(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire70da"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire70da"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bRvn3", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $8a2cfa87cf2f491f$export$6503ec6e8aabbaf; }, function (v) { return $8a2cfa87cf2f491f$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $8a2cfa87cf2f491f$export$f7ad0328861e2f03; }, function (v) { return $8a2cfa87cf2f491f$export$f7ad0328861e2f03 = v; });
var $8a2cfa87cf2f491f$export$6503ec6e8aabbaf;
var $8a2cfa87cf2f491f$export$f7ad0328861e2f03;
"use strict";
var $8a2cfa87cf2f491f$var$mapping = new Map();
function $8a2cfa87cf2f491f$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$8a2cfa87cf2f491f$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $8a2cfa87cf2f491f$var$resolve(id) {
    var resolved = $8a2cfa87cf2f491f$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$8a2cfa87cf2f491f$export$6503ec6e8aabbaf = $8a2cfa87cf2f491f$var$register;
$8a2cfa87cf2f491f$export$f7ad0328861e2f03 = $8a2cfa87cf2f491f$var$resolve;

});

parcelRegister("6Aq0R", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $4cba487fb552c90c$export$bdfd709ae4826697; }, function (v) { return $4cba487fb552c90c$export$bdfd709ae4826697 = v; });
var $4cba487fb552c90c$export$bdfd709ae4826697;
var $4cba487fb552c90c$export$c9e73fbda7da57b6;
var $4cba487fb552c90c$export$5a759dc7a1cfb72a;
"use strict";
var $4cba487fb552c90c$var$bundleURL = {};
function $4cba487fb552c90c$var$getBundleURLCached(id) {
    var value = $4cba487fb552c90c$var$bundleURL[id];
    if (!value) {
        value = $4cba487fb552c90c$var$getBundleURL();
        $4cba487fb552c90c$var$bundleURL[id] = value;
    }
    return value;
}
function $4cba487fb552c90c$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $4cba487fb552c90c$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $4cba487fb552c90c$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $4cba487fb552c90c$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$4cba487fb552c90c$export$bdfd709ae4826697 = $4cba487fb552c90c$var$getBundleURLCached;
$4cba487fb552c90c$export$c9e73fbda7da57b6 = $4cba487fb552c90c$var$getBaseURL;
$4cba487fb552c90c$export$5a759dc7a1cfb72a = $4cba487fb552c90c$var$getOrigin;

});

parcelRegister("hxSYn", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $cc60292f8145080b$export$ffb0004e005737fa; }, function (v) { return $cc60292f8145080b$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $cc60292f8145080b$export$34b9dba7ce09269b; }, function (v) { return $cc60292f8145080b$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $cc60292f8145080b$export$25062201e9e25d76; }, function (v) { return $cc60292f8145080b$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cc60292f8145080b$export$ffb0004e005737fa;
var $cc60292f8145080b$export$34b9dba7ce09269b;
var $cc60292f8145080b$export$25062201e9e25d76;
"use strict";

var $1Mpn7 = parcelRequire("1Mpn7");
var $cc60292f8145080b$var$k = Symbol.for("react.element"), $cc60292f8145080b$var$l = Symbol.for("react.fragment"), $cc60292f8145080b$var$m = Object.prototype.hasOwnProperty, $cc60292f8145080b$var$n = $1Mpn7.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $cc60292f8145080b$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $cc60292f8145080b$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$cc60292f8145080b$var$m.call(a, b) && !$cc60292f8145080b$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $cc60292f8145080b$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $cc60292f8145080b$var$n.current
    };
}
$cc60292f8145080b$export$ffb0004e005737fa = $cc60292f8145080b$var$l;
$cc60292f8145080b$export$34b9dba7ce09269b = $cc60292f8145080b$var$q;
$cc60292f8145080b$export$25062201e9e25d76 = $cc60292f8145080b$var$q;

});
parcelRegister("1Mpn7", function(module, exports) {
"use strict";

module.exports = (parcelRequire("hq3pV"));

});
parcelRegister("hq3pV", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $cae783ed169ac813$export$dca3b0875bd9a954; }, function (v) { return $cae783ed169ac813$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $cae783ed169ac813$export$16fa2f45be04daa8; }, function (v) { return $cae783ed169ac813$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $cae783ed169ac813$export$ffb0004e005737fa; }, function (v) { return $cae783ed169ac813$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $cae783ed169ac813$export$e2c29f18771995cb; }, function (v) { return $cae783ed169ac813$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $cae783ed169ac813$export$221d75b3f55bb0bd; }, function (v) { return $cae783ed169ac813$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $cae783ed169ac813$export$5f8d39834fd61797; }, function (v) { return $cae783ed169ac813$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $cae783ed169ac813$export$74bf444e3cd11ea5; }, function (v) { return $cae783ed169ac813$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $cae783ed169ac813$export$ae55be85d98224ed; }, function (v) { return $cae783ed169ac813$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $cae783ed169ac813$export$3ba232387fd5d6dd; }, function (v) { return $cae783ed169ac813$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $cae783ed169ac813$export$e530037191fcd5d7; }, function (v) { return $cae783ed169ac813$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $cae783ed169ac813$export$fd42f52fd3ae1109; }, function (v) { return $cae783ed169ac813$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $cae783ed169ac813$export$c8a8987d4410bf2d; }, function (v) { return $cae783ed169ac813$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $cae783ed169ac813$export$d38cd72104c1f0e9; }, function (v) { return $cae783ed169ac813$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $cae783ed169ac813$export$7d1e3a5e95ceca43; }, function (v) { return $cae783ed169ac813$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $cae783ed169ac813$export$257a8862b851cb5b; }, function (v) { return $cae783ed169ac813$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $cae783ed169ac813$export$a8257692ac88316c; }, function (v) { return $cae783ed169ac813$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $cae783ed169ac813$export$488013bae63b21da; }, function (v) { return $cae783ed169ac813$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $cae783ed169ac813$export$7c73462e0d25e514; }, function (v) { return $cae783ed169ac813$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $cae783ed169ac813$export$7568632d0d33d16d; }, function (v) { return $cae783ed169ac813$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $cae783ed169ac813$export$88948ce120ea2619; }, function (v) { return $cae783ed169ac813$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $cae783ed169ac813$export$35808ee640e87ca7; }, function (v) { return $cae783ed169ac813$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $cae783ed169ac813$export$fae74005e78b1a27; }, function (v) { return $cae783ed169ac813$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $cae783ed169ac813$export$dc8fbce3eb94dc1e; }, function (v) { return $cae783ed169ac813$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $cae783ed169ac813$export$6a7bc4e911dc01cf; }, function (v) { return $cae783ed169ac813$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $cae783ed169ac813$export$6d9c69b0de29b591; }, function (v) { return $cae783ed169ac813$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $cae783ed169ac813$export$f680877a34711e37; }, function (v) { return $cae783ed169ac813$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $cae783ed169ac813$export$d5a552a76deda3c2; }, function (v) { return $cae783ed169ac813$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $cae783ed169ac813$export$aaabe4eda9ed9969; }, function (v) { return $cae783ed169ac813$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $cae783ed169ac813$export$e5c5a5f917a5871c; }, function (v) { return $cae783ed169ac813$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $cae783ed169ac813$export$1538c33de8887b59; }, function (v) { return $cae783ed169ac813$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $cae783ed169ac813$export$13e3392192263954; }, function (v) { return $cae783ed169ac813$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $cae783ed169ac813$export$b8f5890fc79d6aca; }, function (v) { return $cae783ed169ac813$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $cae783ed169ac813$export$60241385465d0a34; }, function (v) { return $cae783ed169ac813$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $cae783ed169ac813$export$306c0aa65ff9ec16; }, function (v) { return $cae783ed169ac813$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $cae783ed169ac813$export$7b286972b8d8ccbf; }, function (v) { return $cae783ed169ac813$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $cae783ed169ac813$export$83d89fbfd8236492; }, function (v) { return $cae783ed169ac813$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $l0HdX = parcelRequire("l0HdX");
var $cae783ed169ac813$export$dca3b0875bd9a954;
var $cae783ed169ac813$export$16fa2f45be04daa8;
var $cae783ed169ac813$export$ffb0004e005737fa;
var $cae783ed169ac813$export$e2c29f18771995cb;
var $cae783ed169ac813$export$221d75b3f55bb0bd;
var $cae783ed169ac813$export$5f8d39834fd61797;
var $cae783ed169ac813$export$74bf444e3cd11ea5;
var $cae783ed169ac813$export$ae55be85d98224ed;
var $cae783ed169ac813$export$3ba232387fd5d6dd;
var $cae783ed169ac813$export$e530037191fcd5d7;
var $cae783ed169ac813$export$fd42f52fd3ae1109;
var $cae783ed169ac813$export$c8a8987d4410bf2d;
var $cae783ed169ac813$export$d38cd72104c1f0e9;
var $cae783ed169ac813$export$7d1e3a5e95ceca43;
var $cae783ed169ac813$export$257a8862b851cb5b;
var $cae783ed169ac813$export$a8257692ac88316c;
var $cae783ed169ac813$export$488013bae63b21da;
var $cae783ed169ac813$export$7c73462e0d25e514;
var $cae783ed169ac813$export$7568632d0d33d16d;
var $cae783ed169ac813$export$88948ce120ea2619;
var $cae783ed169ac813$export$35808ee640e87ca7;
var $cae783ed169ac813$export$fae74005e78b1a27;
var $cae783ed169ac813$export$dc8fbce3eb94dc1e;
var $cae783ed169ac813$export$6a7bc4e911dc01cf;
var $cae783ed169ac813$export$6d9c69b0de29b591;
var $cae783ed169ac813$export$f680877a34711e37;
var $cae783ed169ac813$export$d5a552a76deda3c2;
var $cae783ed169ac813$export$aaabe4eda9ed9969;
var $cae783ed169ac813$export$e5c5a5f917a5871c;
var $cae783ed169ac813$export$1538c33de8887b59;
var $cae783ed169ac813$export$13e3392192263954;
var $cae783ed169ac813$export$b8f5890fc79d6aca;
var $cae783ed169ac813$export$60241385465d0a34;
var $cae783ed169ac813$export$306c0aa65ff9ec16;
var $cae783ed169ac813$export$7b286972b8d8ccbf;
var $cae783ed169ac813$export$83d89fbfd8236492;
"use strict";
var $cae783ed169ac813$var$l = Symbol.for("react.element"), $cae783ed169ac813$var$n = Symbol.for("react.portal"), $cae783ed169ac813$var$p = Symbol.for("react.fragment"), $cae783ed169ac813$var$q = Symbol.for("react.strict_mode"), $cae783ed169ac813$var$r = Symbol.for("react.profiler"), $cae783ed169ac813$var$t = Symbol.for("react.provider"), $cae783ed169ac813$var$u = Symbol.for("react.context"), $cae783ed169ac813$var$v = Symbol.for("react.forward_ref"), $cae783ed169ac813$var$w = Symbol.for("react.suspense"), $cae783ed169ac813$var$x = Symbol.for("react.memo"), $cae783ed169ac813$var$y = Symbol.for("react.lazy"), $cae783ed169ac813$var$z = Symbol.iterator;
function $cae783ed169ac813$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $cae783ed169ac813$var$z && a[$cae783ed169ac813$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $cae783ed169ac813$var$B = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $cae783ed169ac813$var$C = Object.assign, $cae783ed169ac813$var$D = {};
function $cae783ed169ac813$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $cae783ed169ac813$var$D;
    this.updater = e || $cae783ed169ac813$var$B;
}
$cae783ed169ac813$var$E.prototype.isReactComponent = {};
$cae783ed169ac813$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$cae783ed169ac813$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $cae783ed169ac813$var$F() {}
$cae783ed169ac813$var$F.prototype = $cae783ed169ac813$var$E.prototype;
function $cae783ed169ac813$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $cae783ed169ac813$var$D;
    this.updater = e || $cae783ed169ac813$var$B;
}
var $cae783ed169ac813$var$H = $cae783ed169ac813$var$G.prototype = new $cae783ed169ac813$var$F;
$cae783ed169ac813$var$H.constructor = $cae783ed169ac813$var$G;
$cae783ed169ac813$var$C($cae783ed169ac813$var$H, $cae783ed169ac813$var$E.prototype);
$cae783ed169ac813$var$H.isPureReactComponent = !0;
var $cae783ed169ac813$var$I = Array.isArray, $cae783ed169ac813$var$J = Object.prototype.hasOwnProperty, $cae783ed169ac813$var$K = {
    current: null
}, $cae783ed169ac813$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $cae783ed169ac813$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$cae783ed169ac813$var$J.call(b, d) && !$cae783ed169ac813$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $cae783ed169ac813$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $cae783ed169ac813$var$K.current
    };
}
function $cae783ed169ac813$var$N(a, b) {
    return {
        $$typeof: $cae783ed169ac813$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $cae783ed169ac813$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $cae783ed169ac813$var$l;
}
function $cae783ed169ac813$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $cae783ed169ac813$var$P = /\/+/g;
function $cae783ed169ac813$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $cae783ed169ac813$var$escape("" + a.key) : b.toString(36);
}
function $cae783ed169ac813$var$R(a, b, e, d, c) {
    var k = typeof a === "undefined" ? "undefined" : (0, $l0HdX._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $cae783ed169ac813$var$l:
                case $cae783ed169ac813$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $cae783ed169ac813$var$Q(h, 0) : d, $cae783ed169ac813$var$I(c) ? (e = "", null != a && (e = a.replace($cae783ed169ac813$var$P, "$&/") + "/"), $cae783ed169ac813$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($cae783ed169ac813$var$O(c) && (c = $cae783ed169ac813$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($cae783ed169ac813$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($cae783ed169ac813$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $cae783ed169ac813$var$Q(k, g);
        h += $cae783ed169ac813$var$R(k, b, e, f, c);
    }
    else if (f = $cae783ed169ac813$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $cae783ed169ac813$var$Q(k, g++), h += $cae783ed169ac813$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $cae783ed169ac813$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $cae783ed169ac813$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $cae783ed169ac813$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $cae783ed169ac813$var$U = {
    current: null
}, $cae783ed169ac813$var$V = {
    transition: null
}, $cae783ed169ac813$var$W = {
    ReactCurrentDispatcher: $cae783ed169ac813$var$U,
    ReactCurrentBatchConfig: $cae783ed169ac813$var$V,
    ReactCurrentOwner: $cae783ed169ac813$var$K
};
function $cae783ed169ac813$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$cae783ed169ac813$export$dca3b0875bd9a954 = {
    map: $cae783ed169ac813$var$S,
    forEach: function forEach(a, b, e) {
        $cae783ed169ac813$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function count(a) {
        var b = 0;
        $cae783ed169ac813$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return $cae783ed169ac813$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!$cae783ed169ac813$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$cae783ed169ac813$export$16fa2f45be04daa8 = $cae783ed169ac813$var$E;
$cae783ed169ac813$export$ffb0004e005737fa = $cae783ed169ac813$var$p;
$cae783ed169ac813$export$e2c29f18771995cb = $cae783ed169ac813$var$r;
$cae783ed169ac813$export$221d75b3f55bb0bd = $cae783ed169ac813$var$G;
$cae783ed169ac813$export$5f8d39834fd61797 = $cae783ed169ac813$var$q;
$cae783ed169ac813$export$74bf444e3cd11ea5 = $cae783ed169ac813$var$w;
$cae783ed169ac813$export$ae55be85d98224ed = $cae783ed169ac813$var$W;
$cae783ed169ac813$export$3ba232387fd5d6dd = $cae783ed169ac813$var$X;
$cae783ed169ac813$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $cae783ed169ac813$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $cae783ed169ac813$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$cae783ed169ac813$var$J.call(b, f) && !$cae783ed169ac813$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $cae783ed169ac813$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$cae783ed169ac813$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $cae783ed169ac813$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $cae783ed169ac813$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$cae783ed169ac813$export$c8a8987d4410bf2d = $cae783ed169ac813$var$M;
$cae783ed169ac813$export$d38cd72104c1f0e9 = function(a) {
    var b = $cae783ed169ac813$var$M.bind(null, a);
    b.type = a;
    return b;
};
$cae783ed169ac813$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$cae783ed169ac813$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $cae783ed169ac813$var$v,
        render: a
    };
};
$cae783ed169ac813$export$a8257692ac88316c = $cae783ed169ac813$var$O;
$cae783ed169ac813$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $cae783ed169ac813$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $cae783ed169ac813$var$T
    };
};
$cae783ed169ac813$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $cae783ed169ac813$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$cae783ed169ac813$export$7568632d0d33d16d = function(a) {
    var b = $cae783ed169ac813$var$V.transition;
    $cae783ed169ac813$var$V.transition = {};
    try {
        a();
    } finally{
        $cae783ed169ac813$var$V.transition = b;
    }
};
$cae783ed169ac813$export$88948ce120ea2619 = $cae783ed169ac813$var$X;
$cae783ed169ac813$export$35808ee640e87ca7 = function(a, b) {
    return $cae783ed169ac813$var$U.current.useCallback(a, b);
};
$cae783ed169ac813$export$fae74005e78b1a27 = function(a) {
    return $cae783ed169ac813$var$U.current.useContext(a);
};
$cae783ed169ac813$export$dc8fbce3eb94dc1e = function() {};
$cae783ed169ac813$export$6a7bc4e911dc01cf = function(a) {
    return $cae783ed169ac813$var$U.current.useDeferredValue(a);
};
$cae783ed169ac813$export$6d9c69b0de29b591 = function(a, b) {
    return $cae783ed169ac813$var$U.current.useEffect(a, b);
};
$cae783ed169ac813$export$f680877a34711e37 = function() {
    return $cae783ed169ac813$var$U.current.useId();
};
$cae783ed169ac813$export$d5a552a76deda3c2 = function(a, b, e) {
    return $cae783ed169ac813$var$U.current.useImperativeHandle(a, b, e);
};
$cae783ed169ac813$export$aaabe4eda9ed9969 = function(a, b) {
    return $cae783ed169ac813$var$U.current.useInsertionEffect(a, b);
};
$cae783ed169ac813$export$e5c5a5f917a5871c = function(a, b) {
    return $cae783ed169ac813$var$U.current.useLayoutEffect(a, b);
};
$cae783ed169ac813$export$1538c33de8887b59 = function(a, b) {
    return $cae783ed169ac813$var$U.current.useMemo(a, b);
};
$cae783ed169ac813$export$13e3392192263954 = function(a, b, e) {
    return $cae783ed169ac813$var$U.current.useReducer(a, b, e);
};
$cae783ed169ac813$export$b8f5890fc79d6aca = function(a) {
    return $cae783ed169ac813$var$U.current.useRef(a);
};
$cae783ed169ac813$export$60241385465d0a34 = function(a) {
    return $cae783ed169ac813$var$U.current.useState(a);
};
$cae783ed169ac813$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $cae783ed169ac813$var$U.current.useSyncExternalStore(a, b, e);
};
$cae783ed169ac813$export$7b286972b8d8ccbf = function() {
    return $cae783ed169ac813$var$U.current.useTransition();
};
$cae783ed169ac813$export$83d89fbfd8236492 = "18.3.1";

});
parcelRegister("l0HdX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f4bb2077aa61b74c$export$71511d61b312f219; });
function $f4bb2077aa61b74c$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});




parcelRegister("6A8xk", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $013c97a5603ef3be$export$ae55be85d98224ed; }, function (v) { return $013c97a5603ef3be$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $013c97a5603ef3be$export$d39a5bbd09211389; }, function (v) { return $013c97a5603ef3be$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $013c97a5603ef3be$export$882461b6382ed46c; }, function (v) { return $013c97a5603ef3be$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $013c97a5603ef3be$export$466bfc07425424d5; }, function (v) { return $013c97a5603ef3be$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $013c97a5603ef3be$export$cd75ccfd720a3cd4; }, function (v) { return $013c97a5603ef3be$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $013c97a5603ef3be$export$fa8d919ba61d84db; }, function (v) { return $013c97a5603ef3be$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $013c97a5603ef3be$export$757ceba2d55c277e; }, function (v) { return $013c97a5603ef3be$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $013c97a5603ef3be$export$b3890eb0ae9dca99; }, function (v) { return $013c97a5603ef3be$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $013c97a5603ef3be$export$502457920280e6be; }, function (v) { return $013c97a5603ef3be$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $013c97a5603ef3be$export$c78a37762a8d58e1; }, function (v) { return $013c97a5603ef3be$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $013c97a5603ef3be$export$dc54d992c10e8a18; }, function (v) { return $013c97a5603ef3be$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $013c97a5603ef3be$export$83d89fbfd8236492; }, function (v) { return $013c97a5603ef3be$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $l0HdX = parcelRequire("l0HdX");
var $013c97a5603ef3be$export$ae55be85d98224ed;
var $013c97a5603ef3be$export$d39a5bbd09211389;
var $013c97a5603ef3be$export$882461b6382ed46c;
var $013c97a5603ef3be$export$466bfc07425424d5;
var $013c97a5603ef3be$export$cd75ccfd720a3cd4;
var $013c97a5603ef3be$export$fa8d919ba61d84db;
var $013c97a5603ef3be$export$757ceba2d55c277e;
var $013c97a5603ef3be$export$b3890eb0ae9dca99;
var $013c97a5603ef3be$export$502457920280e6be;
var $013c97a5603ef3be$export$c78a37762a8d58e1;
var $013c97a5603ef3be$export$dc54d992c10e8a18;
var $013c97a5603ef3be$export$83d89fbfd8236492;
"use strict";

var $1Mpn7 = parcelRequire("1Mpn7");

var $3rCRi = parcelRequire("3rCRi");
function $013c97a5603ef3be$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $013c97a5603ef3be$var$da = new Set, $013c97a5603ef3be$var$ea = {};
function $013c97a5603ef3be$var$fa(a, b) {
    $013c97a5603ef3be$var$ha(a, b);
    $013c97a5603ef3be$var$ha(a + "Capture", b);
}
function $013c97a5603ef3be$var$ha(a, b) {
    $013c97a5603ef3be$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$013c97a5603ef3be$var$da.add(b[a]);
}
var $013c97a5603ef3be$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $013c97a5603ef3be$var$ja = Object.prototype.hasOwnProperty, $013c97a5603ef3be$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $013c97a5603ef3be$var$la = {}, $013c97a5603ef3be$var$ma = {};
function $013c97a5603ef3be$var$oa(a) {
    if ($013c97a5603ef3be$var$ja.call($013c97a5603ef3be$var$ma, a)) return !0;
    if ($013c97a5603ef3be$var$ja.call($013c97a5603ef3be$var$la, a)) return !1;
    if ($013c97a5603ef3be$var$ka.test(a)) return $013c97a5603ef3be$var$ma[a] = !0;
    $013c97a5603ef3be$var$la[a] = !0;
    return !1;
}
function $013c97a5603ef3be$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $l0HdX._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $013c97a5603ef3be$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $013c97a5603ef3be$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $013c97a5603ef3be$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $013c97a5603ef3be$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $013c97a5603ef3be$var$z[a] = new $013c97a5603ef3be$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $013c97a5603ef3be$var$z[b] = new $013c97a5603ef3be$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $013c97a5603ef3be$var$z[a] = new $013c97a5603ef3be$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $013c97a5603ef3be$var$z[a] = new $013c97a5603ef3be$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $013c97a5603ef3be$var$z[a] = new $013c97a5603ef3be$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $013c97a5603ef3be$var$z[a] = new $013c97a5603ef3be$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $013c97a5603ef3be$var$z[a] = new $013c97a5603ef3be$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $013c97a5603ef3be$var$z[a] = new $013c97a5603ef3be$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $013c97a5603ef3be$var$z[a] = new $013c97a5603ef3be$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $013c97a5603ef3be$var$ra = /[\-:]([a-z])/g;
function $013c97a5603ef3be$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($013c97a5603ef3be$var$ra, $013c97a5603ef3be$var$sa);
    $013c97a5603ef3be$var$z[b] = new $013c97a5603ef3be$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($013c97a5603ef3be$var$ra, $013c97a5603ef3be$var$sa);
    $013c97a5603ef3be$var$z[b] = new $013c97a5603ef3be$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($013c97a5603ef3be$var$ra, $013c97a5603ef3be$var$sa);
    $013c97a5603ef3be$var$z[b] = new $013c97a5603ef3be$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $013c97a5603ef3be$var$z[a] = new $013c97a5603ef3be$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$013c97a5603ef3be$var$z.xlinkHref = new $013c97a5603ef3be$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $013c97a5603ef3be$var$z[a] = new $013c97a5603ef3be$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $013c97a5603ef3be$var$ta(a, b, c, d) {
    var e = $013c97a5603ef3be$var$z.hasOwnProperty(b) ? $013c97a5603ef3be$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $013c97a5603ef3be$var$qa(b, c, e, d) && (c = null), d || null === e ? $013c97a5603ef3be$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $013c97a5603ef3be$var$ua = $1Mpn7.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $013c97a5603ef3be$var$va = Symbol.for("react.element"), $013c97a5603ef3be$var$wa = Symbol.for("react.portal"), $013c97a5603ef3be$var$ya = Symbol.for("react.fragment"), $013c97a5603ef3be$var$za = Symbol.for("react.strict_mode"), $013c97a5603ef3be$var$Aa = Symbol.for("react.profiler"), $013c97a5603ef3be$var$Ba = Symbol.for("react.provider"), $013c97a5603ef3be$var$Ca = Symbol.for("react.context"), $013c97a5603ef3be$var$Da = Symbol.for("react.forward_ref"), $013c97a5603ef3be$var$Ea = Symbol.for("react.suspense"), $013c97a5603ef3be$var$Fa = Symbol.for("react.suspense_list"), $013c97a5603ef3be$var$Ga = Symbol.for("react.memo"), $013c97a5603ef3be$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $013c97a5603ef3be$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $013c97a5603ef3be$var$Ja = Symbol.iterator;
function $013c97a5603ef3be$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $013c97a5603ef3be$var$Ja && a[$013c97a5603ef3be$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $013c97a5603ef3be$var$A = Object.assign, $013c97a5603ef3be$var$La;
function $013c97a5603ef3be$var$Ma(a) {
    if (void 0 === $013c97a5603ef3be$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $013c97a5603ef3be$var$La = b && b[1] || "";
    }
    return "\n" + $013c97a5603ef3be$var$La + a;
}
var $013c97a5603ef3be$var$Na = !1;
function $013c97a5603ef3be$var$Oa(a, b) {
    if (!a || $013c97a5603ef3be$var$Na) return "";
    $013c97a5603ef3be$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $013c97a5603ef3be$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $013c97a5603ef3be$var$Ma(a) : "";
}
function $013c97a5603ef3be$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $013c97a5603ef3be$var$Ma(a.type);
        case 16:
            return $013c97a5603ef3be$var$Ma("Lazy");
        case 13:
            return $013c97a5603ef3be$var$Ma("Suspense");
        case 19:
            return $013c97a5603ef3be$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $013c97a5603ef3be$var$Oa(a.type, !1), a;
        case 11:
            return a = $013c97a5603ef3be$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $013c97a5603ef3be$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $013c97a5603ef3be$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $013c97a5603ef3be$var$ya:
            return "Fragment";
        case $013c97a5603ef3be$var$wa:
            return "Portal";
        case $013c97a5603ef3be$var$Aa:
            return "Profiler";
        case $013c97a5603ef3be$var$za:
            return "StrictMode";
        case $013c97a5603ef3be$var$Ea:
            return "Suspense";
        case $013c97a5603ef3be$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $013c97a5603ef3be$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $013c97a5603ef3be$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $013c97a5603ef3be$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $013c97a5603ef3be$var$Ga:
            return b = a.displayName || null, null !== b ? b : $013c97a5603ef3be$var$Qa(a.type) || "Memo";
        case $013c97a5603ef3be$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $013c97a5603ef3be$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $013c97a5603ef3be$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $013c97a5603ef3be$var$Qa(b);
        case 8:
            return b === $013c97a5603ef3be$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $013c97a5603ef3be$var$Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, $l0HdX._)(a)){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $013c97a5603ef3be$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $013c97a5603ef3be$var$Ua(a) {
    var b = $013c97a5603ef3be$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $013c97a5603ef3be$var$Va(a) {
    a._valueTracker || (a._valueTracker = $013c97a5603ef3be$var$Ua(a));
}
function $013c97a5603ef3be$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $013c97a5603ef3be$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $013c97a5603ef3be$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $013c97a5603ef3be$var$Ya(a, b) {
    var c = b.checked;
    return $013c97a5603ef3be$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $013c97a5603ef3be$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $013c97a5603ef3be$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $013c97a5603ef3be$var$ab(a, b) {
    b = b.checked;
    null != b && $013c97a5603ef3be$var$ta(a, "checked", b, !1);
}
function $013c97a5603ef3be$var$bb(a, b) {
    $013c97a5603ef3be$var$ab(a, b);
    var c = $013c97a5603ef3be$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $013c97a5603ef3be$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $013c97a5603ef3be$var$cb(a, b.type, $013c97a5603ef3be$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $013c97a5603ef3be$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $013c97a5603ef3be$var$cb(a, b, c) {
    if ("number" !== b || $013c97a5603ef3be$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $013c97a5603ef3be$var$eb = Array.isArray;
function $013c97a5603ef3be$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $013c97a5603ef3be$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $013c97a5603ef3be$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($013c97a5603ef3be$var$p(91));
    return $013c97a5603ef3be$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $013c97a5603ef3be$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($013c97a5603ef3be$var$p(92));
            if ($013c97a5603ef3be$var$eb(c)) {
                if (1 < c.length) throw Error($013c97a5603ef3be$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $013c97a5603ef3be$var$Sa(c)
    };
}
function $013c97a5603ef3be$var$ib(a, b) {
    var c = $013c97a5603ef3be$var$Sa(b.value), d = $013c97a5603ef3be$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $013c97a5603ef3be$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $013c97a5603ef3be$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $013c97a5603ef3be$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $013c97a5603ef3be$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $013c97a5603ef3be$var$mb, $013c97a5603ef3be$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $013c97a5603ef3be$var$mb = $013c97a5603ef3be$var$mb || document.createElement("div");
        $013c97a5603ef3be$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $013c97a5603ef3be$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $013c97a5603ef3be$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $013c97a5603ef3be$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $013c97a5603ef3be$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($013c97a5603ef3be$var$pb).forEach(function(a) {
    $013c97a5603ef3be$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $013c97a5603ef3be$var$pb[b] = $013c97a5603ef3be$var$pb[a];
    });
});
function $013c97a5603ef3be$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $013c97a5603ef3be$var$pb.hasOwnProperty(a) && $013c97a5603ef3be$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $013c97a5603ef3be$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $013c97a5603ef3be$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $013c97a5603ef3be$var$tb = $013c97a5603ef3be$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $013c97a5603ef3be$var$ub(a, b) {
    if (b) {
        if ($013c97a5603ef3be$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($013c97a5603ef3be$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($013c97a5603ef3be$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($013c97a5603ef3be$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($013c97a5603ef3be$var$p(62));
    }
}
function $013c97a5603ef3be$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $013c97a5603ef3be$var$wb = null;
function $013c97a5603ef3be$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $013c97a5603ef3be$var$yb = null, $013c97a5603ef3be$var$zb = null, $013c97a5603ef3be$var$Ab = null;
function $013c97a5603ef3be$var$Bb(a) {
    if (a = $013c97a5603ef3be$var$Cb(a)) {
        if ("function" !== typeof $013c97a5603ef3be$var$yb) throw Error($013c97a5603ef3be$var$p(280));
        var b = a.stateNode;
        b && (b = $013c97a5603ef3be$var$Db(b), $013c97a5603ef3be$var$yb(a.stateNode, a.type, b));
    }
}
function $013c97a5603ef3be$var$Eb(a) {
    $013c97a5603ef3be$var$zb ? $013c97a5603ef3be$var$Ab ? $013c97a5603ef3be$var$Ab.push(a) : $013c97a5603ef3be$var$Ab = [
        a
    ] : $013c97a5603ef3be$var$zb = a;
}
function $013c97a5603ef3be$var$Fb() {
    if ($013c97a5603ef3be$var$zb) {
        var a = $013c97a5603ef3be$var$zb, b = $013c97a5603ef3be$var$Ab;
        $013c97a5603ef3be$var$Ab = $013c97a5603ef3be$var$zb = null;
        $013c97a5603ef3be$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$013c97a5603ef3be$var$Bb(b[a]);
    }
}
function $013c97a5603ef3be$var$Gb(a, b) {
    return a(b);
}
function $013c97a5603ef3be$var$Hb() {}
var $013c97a5603ef3be$var$Ib = !1;
function $013c97a5603ef3be$var$Jb(a, b, c) {
    if ($013c97a5603ef3be$var$Ib) return a(b, c);
    $013c97a5603ef3be$var$Ib = !0;
    try {
        return $013c97a5603ef3be$var$Gb(a, b, c);
    } finally{
        if ($013c97a5603ef3be$var$Ib = !1, null !== $013c97a5603ef3be$var$zb || null !== $013c97a5603ef3be$var$Ab) $013c97a5603ef3be$var$Hb(), $013c97a5603ef3be$var$Fb();
    }
}
function $013c97a5603ef3be$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $013c97a5603ef3be$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($013c97a5603ef3be$var$p(231, b, typeof c === "undefined" ? "undefined" : (0, $l0HdX._)(c)));
    return c;
}
var $013c97a5603ef3be$var$Lb = !1;
if ($013c97a5603ef3be$var$ia) try {
    var $013c97a5603ef3be$var$Mb = {};
    Object.defineProperty($013c97a5603ef3be$var$Mb, "passive", {
        get: function get() {
            $013c97a5603ef3be$var$Lb = !0;
        }
    });
    window.addEventListener("test", $013c97a5603ef3be$var$Mb, $013c97a5603ef3be$var$Mb);
    window.removeEventListener("test", $013c97a5603ef3be$var$Mb, $013c97a5603ef3be$var$Mb);
} catch (a) {
    $013c97a5603ef3be$var$Lb = !1;
}
function $013c97a5603ef3be$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $013c97a5603ef3be$var$Ob = !1, $013c97a5603ef3be$var$Pb = null, $013c97a5603ef3be$var$Qb = !1, $013c97a5603ef3be$var$Rb = null, $013c97a5603ef3be$var$Sb = {
    onError: function onError(a) {
        $013c97a5603ef3be$var$Ob = !0;
        $013c97a5603ef3be$var$Pb = a;
    }
};
function $013c97a5603ef3be$var$Tb(a, b, c, d, e, f, g, h, k) {
    $013c97a5603ef3be$var$Ob = !1;
    $013c97a5603ef3be$var$Pb = null;
    $013c97a5603ef3be$var$Nb.apply($013c97a5603ef3be$var$Sb, arguments);
}
function $013c97a5603ef3be$var$Ub(a, b, c, d, e, f, g, h, k) {
    $013c97a5603ef3be$var$Tb.apply(this, arguments);
    if ($013c97a5603ef3be$var$Ob) {
        if ($013c97a5603ef3be$var$Ob) {
            var l = $013c97a5603ef3be$var$Pb;
            $013c97a5603ef3be$var$Ob = !1;
            $013c97a5603ef3be$var$Pb = null;
        } else throw Error($013c97a5603ef3be$var$p(198));
        $013c97a5603ef3be$var$Qb || ($013c97a5603ef3be$var$Qb = !0, $013c97a5603ef3be$var$Rb = l);
    }
}
function $013c97a5603ef3be$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $013c97a5603ef3be$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $013c97a5603ef3be$var$Xb(a) {
    if ($013c97a5603ef3be$var$Vb(a) !== a) throw Error($013c97a5603ef3be$var$p(188));
}
function $013c97a5603ef3be$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $013c97a5603ef3be$var$Vb(a);
        if (null === b) throw Error($013c97a5603ef3be$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $013c97a5603ef3be$var$Xb(e), a;
                if (f === d) return $013c97a5603ef3be$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($013c97a5603ef3be$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($013c97a5603ef3be$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($013c97a5603ef3be$var$p(190));
    }
    if (3 !== c.tag) throw Error($013c97a5603ef3be$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $013c97a5603ef3be$var$Zb(a) {
    a = $013c97a5603ef3be$var$Yb(a);
    return null !== a ? $013c97a5603ef3be$var$$b(a) : null;
}
function $013c97a5603ef3be$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $013c97a5603ef3be$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $013c97a5603ef3be$var$ac = $3rCRi.unstable_scheduleCallback, $013c97a5603ef3be$var$bc = $3rCRi.unstable_cancelCallback, $013c97a5603ef3be$var$cc = $3rCRi.unstable_shouldYield, $013c97a5603ef3be$var$dc = $3rCRi.unstable_requestPaint, $013c97a5603ef3be$var$B = $3rCRi.unstable_now, $013c97a5603ef3be$var$ec = $3rCRi.unstable_getCurrentPriorityLevel, $013c97a5603ef3be$var$fc = $3rCRi.unstable_ImmediatePriority, $013c97a5603ef3be$var$gc = $3rCRi.unstable_UserBlockingPriority, $013c97a5603ef3be$var$hc = $3rCRi.unstable_NormalPriority, $013c97a5603ef3be$var$ic = $3rCRi.unstable_LowPriority, $013c97a5603ef3be$var$jc = $3rCRi.unstable_IdlePriority, $013c97a5603ef3be$var$kc = null, $013c97a5603ef3be$var$lc = null;
function $013c97a5603ef3be$var$mc(a) {
    if ($013c97a5603ef3be$var$lc && "function" === typeof $013c97a5603ef3be$var$lc.onCommitFiberRoot) try {
        $013c97a5603ef3be$var$lc.onCommitFiberRoot($013c97a5603ef3be$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $013c97a5603ef3be$var$oc = Math.clz32 ? Math.clz32 : $013c97a5603ef3be$var$nc, $013c97a5603ef3be$var$pc = Math.log, $013c97a5603ef3be$var$qc = Math.LN2;
function $013c97a5603ef3be$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($013c97a5603ef3be$var$pc(a) / $013c97a5603ef3be$var$qc | 0) | 0;
}
var $013c97a5603ef3be$var$rc = 64, $013c97a5603ef3be$var$sc = 4194304;
function $013c97a5603ef3be$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $013c97a5603ef3be$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $013c97a5603ef3be$var$tc(h) : (f &= g, 0 !== f && (d = $013c97a5603ef3be$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $013c97a5603ef3be$var$tc(g) : 0 !== f && (d = $013c97a5603ef3be$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $013c97a5603ef3be$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $013c97a5603ef3be$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $013c97a5603ef3be$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $013c97a5603ef3be$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $013c97a5603ef3be$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $013c97a5603ef3be$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $013c97a5603ef3be$var$yc() {
    var a = $013c97a5603ef3be$var$rc;
    $013c97a5603ef3be$var$rc <<= 1;
    0 === ($013c97a5603ef3be$var$rc & 4194240) && ($013c97a5603ef3be$var$rc = 64);
    return a;
}
function $013c97a5603ef3be$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $013c97a5603ef3be$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $013c97a5603ef3be$var$oc(b);
    a[b] = c;
}
function $013c97a5603ef3be$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $013c97a5603ef3be$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $013c97a5603ef3be$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $013c97a5603ef3be$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $013c97a5603ef3be$var$C = 0;
function $013c97a5603ef3be$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $013c97a5603ef3be$var$Ec, $013c97a5603ef3be$var$Fc, $013c97a5603ef3be$var$Gc, $013c97a5603ef3be$var$Hc, $013c97a5603ef3be$var$Ic, $013c97a5603ef3be$var$Jc = !1, $013c97a5603ef3be$var$Kc = [], $013c97a5603ef3be$var$Lc = null, $013c97a5603ef3be$var$Mc = null, $013c97a5603ef3be$var$Nc = null, $013c97a5603ef3be$var$Oc = new Map, $013c97a5603ef3be$var$Pc = new Map, $013c97a5603ef3be$var$Qc = [], $013c97a5603ef3be$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $013c97a5603ef3be$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $013c97a5603ef3be$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $013c97a5603ef3be$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $013c97a5603ef3be$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $013c97a5603ef3be$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $013c97a5603ef3be$var$Pc.delete(b.pointerId);
    }
}
function $013c97a5603ef3be$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $013c97a5603ef3be$var$Cb(b), null !== b && $013c97a5603ef3be$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $013c97a5603ef3be$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $013c97a5603ef3be$var$Lc = $013c97a5603ef3be$var$Tc($013c97a5603ef3be$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $013c97a5603ef3be$var$Mc = $013c97a5603ef3be$var$Tc($013c97a5603ef3be$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $013c97a5603ef3be$var$Nc = $013c97a5603ef3be$var$Tc($013c97a5603ef3be$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $013c97a5603ef3be$var$Oc.set(f, $013c97a5603ef3be$var$Tc($013c97a5603ef3be$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $013c97a5603ef3be$var$Pc.set(f, $013c97a5603ef3be$var$Tc($013c97a5603ef3be$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $013c97a5603ef3be$var$Vc(a) {
    var b = $013c97a5603ef3be$var$Wc(a.target);
    if (null !== b) {
        var c = $013c97a5603ef3be$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $013c97a5603ef3be$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $013c97a5603ef3be$var$Ic(a.priority, function() {
                        $013c97a5603ef3be$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $013c97a5603ef3be$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $013c97a5603ef3be$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $013c97a5603ef3be$var$wb = d;
            c.target.dispatchEvent(d);
            $013c97a5603ef3be$var$wb = null;
        } else return b = $013c97a5603ef3be$var$Cb(c), null !== b && $013c97a5603ef3be$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $013c97a5603ef3be$var$Zc(a, b, c) {
    $013c97a5603ef3be$var$Xc(a) && c.delete(b);
}
function $013c97a5603ef3be$var$$c() {
    $013c97a5603ef3be$var$Jc = !1;
    null !== $013c97a5603ef3be$var$Lc && $013c97a5603ef3be$var$Xc($013c97a5603ef3be$var$Lc) && ($013c97a5603ef3be$var$Lc = null);
    null !== $013c97a5603ef3be$var$Mc && $013c97a5603ef3be$var$Xc($013c97a5603ef3be$var$Mc) && ($013c97a5603ef3be$var$Mc = null);
    null !== $013c97a5603ef3be$var$Nc && $013c97a5603ef3be$var$Xc($013c97a5603ef3be$var$Nc) && ($013c97a5603ef3be$var$Nc = null);
    $013c97a5603ef3be$var$Oc.forEach($013c97a5603ef3be$var$Zc);
    $013c97a5603ef3be$var$Pc.forEach($013c97a5603ef3be$var$Zc);
}
function $013c97a5603ef3be$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $013c97a5603ef3be$var$Jc || ($013c97a5603ef3be$var$Jc = !0, $3rCRi.unstable_scheduleCallback($3rCRi.unstable_NormalPriority, $013c97a5603ef3be$var$$c)));
}
function $013c97a5603ef3be$var$bd(a) {
    function b(b) {
        return $013c97a5603ef3be$var$ad(b, a);
    }
    if (0 < $013c97a5603ef3be$var$Kc.length) {
        $013c97a5603ef3be$var$ad($013c97a5603ef3be$var$Kc[0], a);
        for(var c = 1; c < $013c97a5603ef3be$var$Kc.length; c++){
            var d = $013c97a5603ef3be$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $013c97a5603ef3be$var$Lc && $013c97a5603ef3be$var$ad($013c97a5603ef3be$var$Lc, a);
    null !== $013c97a5603ef3be$var$Mc && $013c97a5603ef3be$var$ad($013c97a5603ef3be$var$Mc, a);
    null !== $013c97a5603ef3be$var$Nc && $013c97a5603ef3be$var$ad($013c97a5603ef3be$var$Nc, a);
    $013c97a5603ef3be$var$Oc.forEach(b);
    $013c97a5603ef3be$var$Pc.forEach(b);
    for(c = 0; c < $013c97a5603ef3be$var$Qc.length; c++)d = $013c97a5603ef3be$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $013c97a5603ef3be$var$Qc.length && (c = $013c97a5603ef3be$var$Qc[0], null === c.blockedOn);)$013c97a5603ef3be$var$Vc(c), null === c.blockedOn && $013c97a5603ef3be$var$Qc.shift();
}
var $013c97a5603ef3be$var$cd = $013c97a5603ef3be$var$ua.ReactCurrentBatchConfig, $013c97a5603ef3be$var$dd = !0;
function $013c97a5603ef3be$var$ed(a, b, c, d) {
    var e = $013c97a5603ef3be$var$C, f = $013c97a5603ef3be$var$cd.transition;
    $013c97a5603ef3be$var$cd.transition = null;
    try {
        $013c97a5603ef3be$var$C = 1, $013c97a5603ef3be$var$fd(a, b, c, d);
    } finally{
        $013c97a5603ef3be$var$C = e, $013c97a5603ef3be$var$cd.transition = f;
    }
}
function $013c97a5603ef3be$var$gd(a, b, c, d) {
    var e = $013c97a5603ef3be$var$C, f = $013c97a5603ef3be$var$cd.transition;
    $013c97a5603ef3be$var$cd.transition = null;
    try {
        $013c97a5603ef3be$var$C = 4, $013c97a5603ef3be$var$fd(a, b, c, d);
    } finally{
        $013c97a5603ef3be$var$C = e, $013c97a5603ef3be$var$cd.transition = f;
    }
}
function $013c97a5603ef3be$var$fd(a, b, c, d) {
    if ($013c97a5603ef3be$var$dd) {
        var e = $013c97a5603ef3be$var$Yc(a, b, c, d);
        if (null === e) $013c97a5603ef3be$var$hd(a, b, d, $013c97a5603ef3be$var$id, c), $013c97a5603ef3be$var$Sc(a, d);
        else if ($013c97a5603ef3be$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($013c97a5603ef3be$var$Sc(a, d), b & 4 && -1 < $013c97a5603ef3be$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $013c97a5603ef3be$var$Cb(e);
                null !== f && $013c97a5603ef3be$var$Ec(f);
                f = $013c97a5603ef3be$var$Yc(a, b, c, d);
                null === f && $013c97a5603ef3be$var$hd(a, b, d, $013c97a5603ef3be$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $013c97a5603ef3be$var$hd(a, b, d, null, c);
    }
}
var $013c97a5603ef3be$var$id = null;
function $013c97a5603ef3be$var$Yc(a, b, c, d) {
    $013c97a5603ef3be$var$id = null;
    a = $013c97a5603ef3be$var$xb(d);
    a = $013c97a5603ef3be$var$Wc(a);
    if (null !== a) {
        if (b = $013c97a5603ef3be$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $013c97a5603ef3be$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $013c97a5603ef3be$var$id = a;
    return null;
}
function $013c97a5603ef3be$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($013c97a5603ef3be$var$ec()){
                case $013c97a5603ef3be$var$fc:
                    return 1;
                case $013c97a5603ef3be$var$gc:
                    return 4;
                case $013c97a5603ef3be$var$hc:
                case $013c97a5603ef3be$var$ic:
                    return 16;
                case $013c97a5603ef3be$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $013c97a5603ef3be$var$kd = null, $013c97a5603ef3be$var$ld = null, $013c97a5603ef3be$var$md = null;
function $013c97a5603ef3be$var$nd() {
    if ($013c97a5603ef3be$var$md) return $013c97a5603ef3be$var$md;
    var a, b = $013c97a5603ef3be$var$ld, c = b.length, d, e = "value" in $013c97a5603ef3be$var$kd ? $013c97a5603ef3be$var$kd.value : $013c97a5603ef3be$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $013c97a5603ef3be$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $013c97a5603ef3be$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $013c97a5603ef3be$var$pd() {
    return !0;
}
function $013c97a5603ef3be$var$qd() {
    return !1;
}
function $013c97a5603ef3be$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $013c97a5603ef3be$var$pd : $013c97a5603ef3be$var$qd;
        this.isPropagationStopped = $013c97a5603ef3be$var$qd;
        return this;
    }
    $013c97a5603ef3be$var$A(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $l0HdX._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = $013c97a5603ef3be$var$pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $l0HdX._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = $013c97a5603ef3be$var$pd);
        },
        persist: function persist() {},
        isPersistent: $013c97a5603ef3be$var$pd
    });
    return b;
}
var $013c97a5603ef3be$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $013c97a5603ef3be$var$td = $013c97a5603ef3be$var$rd($013c97a5603ef3be$var$sd), $013c97a5603ef3be$var$ud = $013c97a5603ef3be$var$A({}, $013c97a5603ef3be$var$sd, {
    view: 0,
    detail: 0
}), $013c97a5603ef3be$var$vd = $013c97a5603ef3be$var$rd($013c97a5603ef3be$var$ud), $013c97a5603ef3be$var$wd, $013c97a5603ef3be$var$xd, $013c97a5603ef3be$var$yd, $013c97a5603ef3be$var$Ad = $013c97a5603ef3be$var$A({}, $013c97a5603ef3be$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $013c97a5603ef3be$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== $013c97a5603ef3be$var$yd && ($013c97a5603ef3be$var$yd && "mousemove" === a.type ? ($013c97a5603ef3be$var$wd = a.screenX - $013c97a5603ef3be$var$yd.screenX, $013c97a5603ef3be$var$xd = a.screenY - $013c97a5603ef3be$var$yd.screenY) : $013c97a5603ef3be$var$xd = $013c97a5603ef3be$var$wd = 0, $013c97a5603ef3be$var$yd = a);
        return $013c97a5603ef3be$var$wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : $013c97a5603ef3be$var$xd;
    }
}), $013c97a5603ef3be$var$Bd = $013c97a5603ef3be$var$rd($013c97a5603ef3be$var$Ad), $013c97a5603ef3be$var$Cd = $013c97a5603ef3be$var$A({}, $013c97a5603ef3be$var$Ad, {
    dataTransfer: 0
}), $013c97a5603ef3be$var$Dd = $013c97a5603ef3be$var$rd($013c97a5603ef3be$var$Cd), $013c97a5603ef3be$var$Ed = $013c97a5603ef3be$var$A({}, $013c97a5603ef3be$var$ud, {
    relatedTarget: 0
}), $013c97a5603ef3be$var$Fd = $013c97a5603ef3be$var$rd($013c97a5603ef3be$var$Ed), $013c97a5603ef3be$var$Gd = $013c97a5603ef3be$var$A({}, $013c97a5603ef3be$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $013c97a5603ef3be$var$Hd = $013c97a5603ef3be$var$rd($013c97a5603ef3be$var$Gd), $013c97a5603ef3be$var$Id = $013c97a5603ef3be$var$A({}, $013c97a5603ef3be$var$sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $013c97a5603ef3be$var$Jd = $013c97a5603ef3be$var$rd($013c97a5603ef3be$var$Id), $013c97a5603ef3be$var$Kd = $013c97a5603ef3be$var$A({}, $013c97a5603ef3be$var$sd, {
    data: 0
}), $013c97a5603ef3be$var$Ld = $013c97a5603ef3be$var$rd($013c97a5603ef3be$var$Kd), $013c97a5603ef3be$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $013c97a5603ef3be$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $013c97a5603ef3be$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $013c97a5603ef3be$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $013c97a5603ef3be$var$Od[a]) ? !!b[a] : !1;
}
function $013c97a5603ef3be$var$zd() {
    return $013c97a5603ef3be$var$Pd;
}
var $013c97a5603ef3be$var$Qd = $013c97a5603ef3be$var$A({}, $013c97a5603ef3be$var$ud, {
    key: function key(a) {
        if (a.key) {
            var b = $013c97a5603ef3be$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $013c97a5603ef3be$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $013c97a5603ef3be$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $013c97a5603ef3be$var$zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? $013c97a5603ef3be$var$od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? $013c97a5603ef3be$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $013c97a5603ef3be$var$Rd = $013c97a5603ef3be$var$rd($013c97a5603ef3be$var$Qd), $013c97a5603ef3be$var$Sd = $013c97a5603ef3be$var$A({}, $013c97a5603ef3be$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $013c97a5603ef3be$var$Td = $013c97a5603ef3be$var$rd($013c97a5603ef3be$var$Sd), $013c97a5603ef3be$var$Ud = $013c97a5603ef3be$var$A({}, $013c97a5603ef3be$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $013c97a5603ef3be$var$zd
}), $013c97a5603ef3be$var$Vd = $013c97a5603ef3be$var$rd($013c97a5603ef3be$var$Ud), $013c97a5603ef3be$var$Wd = $013c97a5603ef3be$var$A({}, $013c97a5603ef3be$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $013c97a5603ef3be$var$Xd = $013c97a5603ef3be$var$rd($013c97a5603ef3be$var$Wd), $013c97a5603ef3be$var$Yd = $013c97a5603ef3be$var$A({}, $013c97a5603ef3be$var$Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $013c97a5603ef3be$var$Zd = $013c97a5603ef3be$var$rd($013c97a5603ef3be$var$Yd), $013c97a5603ef3be$var$$d = [
    9,
    13,
    27,
    32
], $013c97a5603ef3be$var$ae = $013c97a5603ef3be$var$ia && "CompositionEvent" in window, $013c97a5603ef3be$var$be = null;
$013c97a5603ef3be$var$ia && "documentMode" in document && ($013c97a5603ef3be$var$be = document.documentMode);
var $013c97a5603ef3be$var$ce = $013c97a5603ef3be$var$ia && "TextEvent" in window && !$013c97a5603ef3be$var$be, $013c97a5603ef3be$var$de = $013c97a5603ef3be$var$ia && (!$013c97a5603ef3be$var$ae || $013c97a5603ef3be$var$be && 8 < $013c97a5603ef3be$var$be && 11 >= $013c97a5603ef3be$var$be), $013c97a5603ef3be$var$ee = String.fromCharCode(32), $013c97a5603ef3be$var$fe = !1;
function $013c97a5603ef3be$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $013c97a5603ef3be$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $013c97a5603ef3be$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $013c97a5603ef3be$var$ie = !1;
function $013c97a5603ef3be$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $013c97a5603ef3be$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $013c97a5603ef3be$var$fe = !0;
            return $013c97a5603ef3be$var$ee;
        case "textInput":
            return a = b.data, a === $013c97a5603ef3be$var$ee && $013c97a5603ef3be$var$fe ? null : a;
        default:
            return null;
    }
}
function $013c97a5603ef3be$var$ke(a, b) {
    if ($013c97a5603ef3be$var$ie) return "compositionend" === a || !$013c97a5603ef3be$var$ae && $013c97a5603ef3be$var$ge(a, b) ? (a = $013c97a5603ef3be$var$nd(), $013c97a5603ef3be$var$md = $013c97a5603ef3be$var$ld = $013c97a5603ef3be$var$kd = null, $013c97a5603ef3be$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $013c97a5603ef3be$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $013c97a5603ef3be$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $013c97a5603ef3be$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$013c97a5603ef3be$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $013c97a5603ef3be$var$ne(a, b, c, d) {
    $013c97a5603ef3be$var$Eb(d);
    b = $013c97a5603ef3be$var$oe(b, "onChange");
    0 < b.length && (c = new $013c97a5603ef3be$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $013c97a5603ef3be$var$pe = null, $013c97a5603ef3be$var$qe = null;
function $013c97a5603ef3be$var$re(a) {
    $013c97a5603ef3be$var$se(a, 0);
}
function $013c97a5603ef3be$var$te(a) {
    var b = $013c97a5603ef3be$var$ue(a);
    if ($013c97a5603ef3be$var$Wa(b)) return a;
}
function $013c97a5603ef3be$var$ve(a, b) {
    if ("change" === a) return b;
}
var $013c97a5603ef3be$var$we = !1;
if ($013c97a5603ef3be$var$ia) {
    var $013c97a5603ef3be$var$xe;
    if ($013c97a5603ef3be$var$ia) {
        var $013c97a5603ef3be$var$ye = "oninput" in document;
        if (!$013c97a5603ef3be$var$ye) {
            var $013c97a5603ef3be$var$ze = document.createElement("div");
            $013c97a5603ef3be$var$ze.setAttribute("oninput", "return;");
            $013c97a5603ef3be$var$ye = "function" === typeof $013c97a5603ef3be$var$ze.oninput;
        }
        $013c97a5603ef3be$var$xe = $013c97a5603ef3be$var$ye;
    } else $013c97a5603ef3be$var$xe = !1;
    $013c97a5603ef3be$var$we = $013c97a5603ef3be$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $013c97a5603ef3be$var$Ae() {
    $013c97a5603ef3be$var$pe && ($013c97a5603ef3be$var$pe.detachEvent("onpropertychange", $013c97a5603ef3be$var$Be), $013c97a5603ef3be$var$qe = $013c97a5603ef3be$var$pe = null);
}
function $013c97a5603ef3be$var$Be(a) {
    if ("value" === a.propertyName && $013c97a5603ef3be$var$te($013c97a5603ef3be$var$qe)) {
        var b = [];
        $013c97a5603ef3be$var$ne(b, $013c97a5603ef3be$var$qe, a, $013c97a5603ef3be$var$xb(a));
        $013c97a5603ef3be$var$Jb($013c97a5603ef3be$var$re, b);
    }
}
function $013c97a5603ef3be$var$Ce(a, b, c) {
    "focusin" === a ? ($013c97a5603ef3be$var$Ae(), $013c97a5603ef3be$var$pe = b, $013c97a5603ef3be$var$qe = c, $013c97a5603ef3be$var$pe.attachEvent("onpropertychange", $013c97a5603ef3be$var$Be)) : "focusout" === a && $013c97a5603ef3be$var$Ae();
}
function $013c97a5603ef3be$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $013c97a5603ef3be$var$te($013c97a5603ef3be$var$qe);
}
function $013c97a5603ef3be$var$Ee(a, b) {
    if ("click" === a) return $013c97a5603ef3be$var$te(b);
}
function $013c97a5603ef3be$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $013c97a5603ef3be$var$te(b);
}
function $013c97a5603ef3be$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $013c97a5603ef3be$var$He = "function" === typeof Object.is ? Object.is : $013c97a5603ef3be$var$Ge;
function $013c97a5603ef3be$var$Ie(a, b) {
    if ($013c97a5603ef3be$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$013c97a5603ef3be$var$ja.call(b, e) || !$013c97a5603ef3be$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $013c97a5603ef3be$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $013c97a5603ef3be$var$Ke(a, b) {
    var c = $013c97a5603ef3be$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $013c97a5603ef3be$var$Je(c);
    }
}
function $013c97a5603ef3be$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $013c97a5603ef3be$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $013c97a5603ef3be$var$Me() {
    for(var a = window, b = $013c97a5603ef3be$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $013c97a5603ef3be$var$Xa(a.document);
    }
    return b;
}
function $013c97a5603ef3be$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $013c97a5603ef3be$var$Oe(a) {
    var b = $013c97a5603ef3be$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $013c97a5603ef3be$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $013c97a5603ef3be$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $013c97a5603ef3be$var$Ke(c, f);
                var g = $013c97a5603ef3be$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $013c97a5603ef3be$var$Pe = $013c97a5603ef3be$var$ia && "documentMode" in document && 11 >= document.documentMode, $013c97a5603ef3be$var$Qe = null, $013c97a5603ef3be$var$Re = null, $013c97a5603ef3be$var$Se = null, $013c97a5603ef3be$var$Te = !1;
function $013c97a5603ef3be$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $013c97a5603ef3be$var$Te || null == $013c97a5603ef3be$var$Qe || $013c97a5603ef3be$var$Qe !== $013c97a5603ef3be$var$Xa(d) || (d = $013c97a5603ef3be$var$Qe, "selectionStart" in d && $013c97a5603ef3be$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $013c97a5603ef3be$var$Se && $013c97a5603ef3be$var$Ie($013c97a5603ef3be$var$Se, d) || ($013c97a5603ef3be$var$Se = d, d = $013c97a5603ef3be$var$oe($013c97a5603ef3be$var$Re, "onSelect"), 0 < d.length && (b = new $013c97a5603ef3be$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $013c97a5603ef3be$var$Qe)));
}
function $013c97a5603ef3be$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $013c97a5603ef3be$var$We = {
    animationend: $013c97a5603ef3be$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $013c97a5603ef3be$var$Ve("Animation", "AnimationIteration"),
    animationstart: $013c97a5603ef3be$var$Ve("Animation", "AnimationStart"),
    transitionend: $013c97a5603ef3be$var$Ve("Transition", "TransitionEnd")
}, $013c97a5603ef3be$var$Xe = {}, $013c97a5603ef3be$var$Ye = {};
$013c97a5603ef3be$var$ia && ($013c97a5603ef3be$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $013c97a5603ef3be$var$We.animationend.animation, delete $013c97a5603ef3be$var$We.animationiteration.animation, delete $013c97a5603ef3be$var$We.animationstart.animation), "TransitionEvent" in window || delete $013c97a5603ef3be$var$We.transitionend.transition);
function $013c97a5603ef3be$var$Ze(a) {
    if ($013c97a5603ef3be$var$Xe[a]) return $013c97a5603ef3be$var$Xe[a];
    if (!$013c97a5603ef3be$var$We[a]) return a;
    var b = $013c97a5603ef3be$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $013c97a5603ef3be$var$Ye) return $013c97a5603ef3be$var$Xe[a] = b[c];
    return a;
}
var $013c97a5603ef3be$var$$e = $013c97a5603ef3be$var$Ze("animationend"), $013c97a5603ef3be$var$af = $013c97a5603ef3be$var$Ze("animationiteration"), $013c97a5603ef3be$var$bf = $013c97a5603ef3be$var$Ze("animationstart"), $013c97a5603ef3be$var$cf = $013c97a5603ef3be$var$Ze("transitionend"), $013c97a5603ef3be$var$df = new Map, $013c97a5603ef3be$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $013c97a5603ef3be$var$ff(a, b) {
    $013c97a5603ef3be$var$df.set(a, b);
    $013c97a5603ef3be$var$fa(b, [
        a
    ]);
}
for(var $013c97a5603ef3be$var$gf = 0; $013c97a5603ef3be$var$gf < $013c97a5603ef3be$var$ef.length; $013c97a5603ef3be$var$gf++){
    var $013c97a5603ef3be$var$hf = $013c97a5603ef3be$var$ef[$013c97a5603ef3be$var$gf], $013c97a5603ef3be$var$jf = $013c97a5603ef3be$var$hf.toLowerCase(), $013c97a5603ef3be$var$kf = $013c97a5603ef3be$var$hf[0].toUpperCase() + $013c97a5603ef3be$var$hf.slice(1);
    $013c97a5603ef3be$var$ff($013c97a5603ef3be$var$jf, "on" + $013c97a5603ef3be$var$kf);
}
$013c97a5603ef3be$var$ff($013c97a5603ef3be$var$$e, "onAnimationEnd");
$013c97a5603ef3be$var$ff($013c97a5603ef3be$var$af, "onAnimationIteration");
$013c97a5603ef3be$var$ff($013c97a5603ef3be$var$bf, "onAnimationStart");
$013c97a5603ef3be$var$ff("dblclick", "onDoubleClick");
$013c97a5603ef3be$var$ff("focusin", "onFocus");
$013c97a5603ef3be$var$ff("focusout", "onBlur");
$013c97a5603ef3be$var$ff($013c97a5603ef3be$var$cf, "onTransitionEnd");
$013c97a5603ef3be$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$013c97a5603ef3be$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$013c97a5603ef3be$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$013c97a5603ef3be$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$013c97a5603ef3be$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$013c97a5603ef3be$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$013c97a5603ef3be$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$013c97a5603ef3be$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$013c97a5603ef3be$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$013c97a5603ef3be$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $013c97a5603ef3be$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $013c97a5603ef3be$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($013c97a5603ef3be$var$lf));
function $013c97a5603ef3be$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $013c97a5603ef3be$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $013c97a5603ef3be$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $013c97a5603ef3be$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $013c97a5603ef3be$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($013c97a5603ef3be$var$Qb) throw a = $013c97a5603ef3be$var$Rb, $013c97a5603ef3be$var$Qb = !1, $013c97a5603ef3be$var$Rb = null, a;
}
function $013c97a5603ef3be$var$D(a, b) {
    var c = b[$013c97a5603ef3be$var$of];
    void 0 === c && (c = b[$013c97a5603ef3be$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($013c97a5603ef3be$var$pf(b, a, 2, !1), c.add(d));
}
function $013c97a5603ef3be$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $013c97a5603ef3be$var$pf(c, a, d, b);
}
var $013c97a5603ef3be$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $013c97a5603ef3be$var$sf(a) {
    if (!a[$013c97a5603ef3be$var$rf]) {
        a[$013c97a5603ef3be$var$rf] = !0;
        $013c97a5603ef3be$var$da.forEach(function(b) {
            "selectionchange" !== b && ($013c97a5603ef3be$var$mf.has(b) || $013c97a5603ef3be$var$qf(b, !1, a), $013c97a5603ef3be$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$013c97a5603ef3be$var$rf] || (b[$013c97a5603ef3be$var$rf] = !0, $013c97a5603ef3be$var$qf("selectionchange", !1, b));
    }
}
function $013c97a5603ef3be$var$pf(a, b, c, d) {
    switch($013c97a5603ef3be$var$jd(b)){
        case 1:
            var e = $013c97a5603ef3be$var$ed;
            break;
        case 4:
            e = $013c97a5603ef3be$var$gd;
            break;
        default:
            e = $013c97a5603ef3be$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$013c97a5603ef3be$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $013c97a5603ef3be$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $013c97a5603ef3be$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $013c97a5603ef3be$var$Jb(function() {
        var _$d = f, _$e = $013c97a5603ef3be$var$xb(c), g = [];
        a: {
            var h = $013c97a5603ef3be$var$df.get(a);
            if (void 0 !== h) {
                var k = $013c97a5603ef3be$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $013c97a5603ef3be$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $013c97a5603ef3be$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $013c97a5603ef3be$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $013c97a5603ef3be$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $013c97a5603ef3be$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $013c97a5603ef3be$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $013c97a5603ef3be$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $013c97a5603ef3be$var$Vd;
                        break;
                    case $013c97a5603ef3be$var$$e:
                    case $013c97a5603ef3be$var$af:
                    case $013c97a5603ef3be$var$bf:
                        k = $013c97a5603ef3be$var$Hd;
                        break;
                    case $013c97a5603ef3be$var$cf:
                        k = $013c97a5603ef3be$var$Xd;
                        break;
                    case "scroll":
                        k = $013c97a5603ef3be$var$vd;
                        break;
                    case "wheel":
                        k = $013c97a5603ef3be$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $013c97a5603ef3be$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $013c97a5603ef3be$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = _$d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $013c97a5603ef3be$var$Kb(w, x), null != F && t.push($013c97a5603ef3be$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, _$e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $013c97a5603ef3be$var$wb && (n = c.relatedTarget || c.fromElement) && ($013c97a5603ef3be$var$Wc(n) || n[$013c97a5603ef3be$var$uf])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = _$d, n = n ? $013c97a5603ef3be$var$Wc(n) : null, null !== n && (J = $013c97a5603ef3be$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = _$d;
                    if (k !== n) {
                        t = $013c97a5603ef3be$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $013c97a5603ef3be$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $013c97a5603ef3be$var$ue(k);
                        u = null == n ? h : $013c97a5603ef3be$var$ue(n);
                        h = new t(F, w + "leave", k, c, _$e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $013c97a5603ef3be$var$Wc(_$e) === _$d && (t = new t(x, w + "enter", n, c, _$e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $013c97a5603ef3be$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $013c97a5603ef3be$var$vf(F))u++;
                            for(; 0 < w - u;)t = $013c97a5603ef3be$var$vf(t), w--;
                            for(; 0 < u - w;)x = $013c97a5603ef3be$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $013c97a5603ef3be$var$vf(t);
                                x = $013c97a5603ef3be$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $013c97a5603ef3be$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $013c97a5603ef3be$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = _$d ? $013c97a5603ef3be$var$ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $013c97a5603ef3be$var$ve;
                else if ($013c97a5603ef3be$var$me(h)) {
                    if ($013c97a5603ef3be$var$we) na = $013c97a5603ef3be$var$Fe;
                    else {
                        na = $013c97a5603ef3be$var$De;
                        var xa = $013c97a5603ef3be$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $013c97a5603ef3be$var$Ee);
                if (na && (na = na(a, _$d))) {
                    $013c97a5603ef3be$var$ne(g, na, c, _$e);
                    break a;
                }
                xa && xa(a, h, _$d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $013c97a5603ef3be$var$cb(h, "number", h.value);
            }
            xa = _$d ? $013c97a5603ef3be$var$ue(_$d) : window;
            switch(a){
                case "focusin":
                    if ($013c97a5603ef3be$var$me(xa) || "true" === xa.contentEditable) $013c97a5603ef3be$var$Qe = xa, $013c97a5603ef3be$var$Re = _$d, $013c97a5603ef3be$var$Se = null;
                    break;
                case "focusout":
                    $013c97a5603ef3be$var$Se = $013c97a5603ef3be$var$Re = $013c97a5603ef3be$var$Qe = null;
                    break;
                case "mousedown":
                    $013c97a5603ef3be$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $013c97a5603ef3be$var$Te = !1;
                    $013c97a5603ef3be$var$Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if ($013c97a5603ef3be$var$Pe) break;
                case "keydown":
                case "keyup":
                    $013c97a5603ef3be$var$Ue(g, c, _$e);
            }
            var $a;
            if ($013c97a5603ef3be$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $013c97a5603ef3be$var$ie ? $013c97a5603ef3be$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($013c97a5603ef3be$var$de && "ko" !== c.locale && ($013c97a5603ef3be$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $013c97a5603ef3be$var$ie && ($a = $013c97a5603ef3be$var$nd()) : ($013c97a5603ef3be$var$kd = _$e, $013c97a5603ef3be$var$ld = "value" in $013c97a5603ef3be$var$kd ? $013c97a5603ef3be$var$kd.value : $013c97a5603ef3be$var$kd.textContent, $013c97a5603ef3be$var$ie = !0)), xa = $013c97a5603ef3be$var$oe(_$d, ba), 0 < xa.length && (ba = new $013c97a5603ef3be$var$Ld(ba, a, null, c, _$e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $013c97a5603ef3be$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $013c97a5603ef3be$var$ce ? $013c97a5603ef3be$var$je(a, c) : $013c97a5603ef3be$var$ke(a, c)) _$d = $013c97a5603ef3be$var$oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new $013c97a5603ef3be$var$Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = $a);
        }
        $013c97a5603ef3be$var$se(g, b);
    });
}
function $013c97a5603ef3be$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $013c97a5603ef3be$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $013c97a5603ef3be$var$Kb(a, c), null != f && d.unshift($013c97a5603ef3be$var$tf(a, f, e)), f = $013c97a5603ef3be$var$Kb(a, b), null != f && d.push($013c97a5603ef3be$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $013c97a5603ef3be$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $013c97a5603ef3be$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $013c97a5603ef3be$var$Kb(c, f), null != k && g.unshift($013c97a5603ef3be$var$tf(c, k, h))) : e || (k = $013c97a5603ef3be$var$Kb(c, f), null != k && g.push($013c97a5603ef3be$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $013c97a5603ef3be$var$xf = /\r\n?/g, $013c97a5603ef3be$var$yf = /\u0000|\uFFFD/g;
function $013c97a5603ef3be$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($013c97a5603ef3be$var$xf, "\n").replace($013c97a5603ef3be$var$yf, "");
}
function $013c97a5603ef3be$var$Af(a, b, c) {
    b = $013c97a5603ef3be$var$zf(b);
    if ($013c97a5603ef3be$var$zf(a) !== b && c) throw Error($013c97a5603ef3be$var$p(425));
}
function $013c97a5603ef3be$var$Bf() {}
var $013c97a5603ef3be$var$Cf = null, $013c97a5603ef3be$var$Df = null;
function $013c97a5603ef3be$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $013c97a5603ef3be$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $013c97a5603ef3be$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $013c97a5603ef3be$var$Hf = "function" === typeof Promise ? Promise : void 0, $013c97a5603ef3be$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $013c97a5603ef3be$var$Hf ? function Jf(a) {
    return $013c97a5603ef3be$var$Hf.resolve(null).then(a).catch($013c97a5603ef3be$var$If);
} : $013c97a5603ef3be$var$Ff;
function $013c97a5603ef3be$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $013c97a5603ef3be$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $013c97a5603ef3be$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $013c97a5603ef3be$var$bd(b);
}
function $013c97a5603ef3be$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $013c97a5603ef3be$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $013c97a5603ef3be$var$Nf = Math.random().toString(36).slice(2), $013c97a5603ef3be$var$Of = "__reactFiber$" + $013c97a5603ef3be$var$Nf, $013c97a5603ef3be$var$Pf = "__reactProps$" + $013c97a5603ef3be$var$Nf, $013c97a5603ef3be$var$uf = "__reactContainer$" + $013c97a5603ef3be$var$Nf, $013c97a5603ef3be$var$of = "__reactEvents$" + $013c97a5603ef3be$var$Nf, $013c97a5603ef3be$var$Qf = "__reactListeners$" + $013c97a5603ef3be$var$Nf, $013c97a5603ef3be$var$Rf = "__reactHandles$" + $013c97a5603ef3be$var$Nf;
function $013c97a5603ef3be$var$Wc(a) {
    var b = a[$013c97a5603ef3be$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$013c97a5603ef3be$var$uf] || c[$013c97a5603ef3be$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $013c97a5603ef3be$var$Mf(a); null !== a;){
                if (c = a[$013c97a5603ef3be$var$Of]) return c;
                a = $013c97a5603ef3be$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $013c97a5603ef3be$var$Cb(a) {
    a = a[$013c97a5603ef3be$var$Of] || a[$013c97a5603ef3be$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $013c97a5603ef3be$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($013c97a5603ef3be$var$p(33));
}
function $013c97a5603ef3be$var$Db(a) {
    return a[$013c97a5603ef3be$var$Pf] || null;
}
var $013c97a5603ef3be$var$Sf = [], $013c97a5603ef3be$var$Tf = -1;
function $013c97a5603ef3be$var$Uf(a) {
    return {
        current: a
    };
}
function $013c97a5603ef3be$var$E(a) {
    0 > $013c97a5603ef3be$var$Tf || (a.current = $013c97a5603ef3be$var$Sf[$013c97a5603ef3be$var$Tf], $013c97a5603ef3be$var$Sf[$013c97a5603ef3be$var$Tf] = null, $013c97a5603ef3be$var$Tf--);
}
function $013c97a5603ef3be$var$G(a, b) {
    $013c97a5603ef3be$var$Tf++;
    $013c97a5603ef3be$var$Sf[$013c97a5603ef3be$var$Tf] = a.current;
    a.current = b;
}
var $013c97a5603ef3be$var$Vf = {}, $013c97a5603ef3be$var$H = $013c97a5603ef3be$var$Uf($013c97a5603ef3be$var$Vf), $013c97a5603ef3be$var$Wf = $013c97a5603ef3be$var$Uf(!1), $013c97a5603ef3be$var$Xf = $013c97a5603ef3be$var$Vf;
function $013c97a5603ef3be$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $013c97a5603ef3be$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $013c97a5603ef3be$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $013c97a5603ef3be$var$$f() {
    $013c97a5603ef3be$var$E($013c97a5603ef3be$var$Wf);
    $013c97a5603ef3be$var$E($013c97a5603ef3be$var$H);
}
function $013c97a5603ef3be$var$ag(a, b, c) {
    if ($013c97a5603ef3be$var$H.current !== $013c97a5603ef3be$var$Vf) throw Error($013c97a5603ef3be$var$p(168));
    $013c97a5603ef3be$var$G($013c97a5603ef3be$var$H, b);
    $013c97a5603ef3be$var$G($013c97a5603ef3be$var$Wf, c);
}
function $013c97a5603ef3be$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($013c97a5603ef3be$var$p(108, $013c97a5603ef3be$var$Ra(a) || "Unknown", e));
    return $013c97a5603ef3be$var$A({}, c, d);
}
function $013c97a5603ef3be$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $013c97a5603ef3be$var$Vf;
    $013c97a5603ef3be$var$Xf = $013c97a5603ef3be$var$H.current;
    $013c97a5603ef3be$var$G($013c97a5603ef3be$var$H, a);
    $013c97a5603ef3be$var$G($013c97a5603ef3be$var$Wf, $013c97a5603ef3be$var$Wf.current);
    return !0;
}
function $013c97a5603ef3be$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($013c97a5603ef3be$var$p(169));
    c ? (a = $013c97a5603ef3be$var$bg(a, b, $013c97a5603ef3be$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $013c97a5603ef3be$var$E($013c97a5603ef3be$var$Wf), $013c97a5603ef3be$var$E($013c97a5603ef3be$var$H), $013c97a5603ef3be$var$G($013c97a5603ef3be$var$H, a)) : $013c97a5603ef3be$var$E($013c97a5603ef3be$var$Wf);
    $013c97a5603ef3be$var$G($013c97a5603ef3be$var$Wf, c);
}
var $013c97a5603ef3be$var$eg = null, $013c97a5603ef3be$var$fg = !1, $013c97a5603ef3be$var$gg = !1;
function $013c97a5603ef3be$var$hg(a) {
    null === $013c97a5603ef3be$var$eg ? $013c97a5603ef3be$var$eg = [
        a
    ] : $013c97a5603ef3be$var$eg.push(a);
}
function $013c97a5603ef3be$var$ig(a) {
    $013c97a5603ef3be$var$fg = !0;
    $013c97a5603ef3be$var$hg(a);
}
function $013c97a5603ef3be$var$jg() {
    if (!$013c97a5603ef3be$var$gg && null !== $013c97a5603ef3be$var$eg) {
        $013c97a5603ef3be$var$gg = !0;
        var a = 0, b = $013c97a5603ef3be$var$C;
        try {
            var c = $013c97a5603ef3be$var$eg;
            for($013c97a5603ef3be$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $013c97a5603ef3be$var$eg = null;
            $013c97a5603ef3be$var$fg = !1;
        } catch (e) {
            throw null !== $013c97a5603ef3be$var$eg && ($013c97a5603ef3be$var$eg = $013c97a5603ef3be$var$eg.slice(a + 1)), $013c97a5603ef3be$var$ac($013c97a5603ef3be$var$fc, $013c97a5603ef3be$var$jg), e;
        } finally{
            $013c97a5603ef3be$var$C = b, $013c97a5603ef3be$var$gg = !1;
        }
    }
    return null;
}
var $013c97a5603ef3be$var$kg = [], $013c97a5603ef3be$var$lg = 0, $013c97a5603ef3be$var$mg = null, $013c97a5603ef3be$var$ng = 0, $013c97a5603ef3be$var$og = [], $013c97a5603ef3be$var$pg = 0, $013c97a5603ef3be$var$qg = null, $013c97a5603ef3be$var$rg = 1, $013c97a5603ef3be$var$sg = "";
function $013c97a5603ef3be$var$tg(a, b) {
    $013c97a5603ef3be$var$kg[$013c97a5603ef3be$var$lg++] = $013c97a5603ef3be$var$ng;
    $013c97a5603ef3be$var$kg[$013c97a5603ef3be$var$lg++] = $013c97a5603ef3be$var$mg;
    $013c97a5603ef3be$var$mg = a;
    $013c97a5603ef3be$var$ng = b;
}
function $013c97a5603ef3be$var$ug(a, b, c) {
    $013c97a5603ef3be$var$og[$013c97a5603ef3be$var$pg++] = $013c97a5603ef3be$var$rg;
    $013c97a5603ef3be$var$og[$013c97a5603ef3be$var$pg++] = $013c97a5603ef3be$var$sg;
    $013c97a5603ef3be$var$og[$013c97a5603ef3be$var$pg++] = $013c97a5603ef3be$var$qg;
    $013c97a5603ef3be$var$qg = a;
    var d = $013c97a5603ef3be$var$rg;
    a = $013c97a5603ef3be$var$sg;
    var e = 32 - $013c97a5603ef3be$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $013c97a5603ef3be$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $013c97a5603ef3be$var$rg = 1 << 32 - $013c97a5603ef3be$var$oc(b) + e | c << e | d;
        $013c97a5603ef3be$var$sg = f + a;
    } else $013c97a5603ef3be$var$rg = 1 << f | c << e | d, $013c97a5603ef3be$var$sg = a;
}
function $013c97a5603ef3be$var$vg(a) {
    null !== a.return && ($013c97a5603ef3be$var$tg(a, 1), $013c97a5603ef3be$var$ug(a, 1, 0));
}
function $013c97a5603ef3be$var$wg(a) {
    for(; a === $013c97a5603ef3be$var$mg;)$013c97a5603ef3be$var$mg = $013c97a5603ef3be$var$kg[--$013c97a5603ef3be$var$lg], $013c97a5603ef3be$var$kg[$013c97a5603ef3be$var$lg] = null, $013c97a5603ef3be$var$ng = $013c97a5603ef3be$var$kg[--$013c97a5603ef3be$var$lg], $013c97a5603ef3be$var$kg[$013c97a5603ef3be$var$lg] = null;
    for(; a === $013c97a5603ef3be$var$qg;)$013c97a5603ef3be$var$qg = $013c97a5603ef3be$var$og[--$013c97a5603ef3be$var$pg], $013c97a5603ef3be$var$og[$013c97a5603ef3be$var$pg] = null, $013c97a5603ef3be$var$sg = $013c97a5603ef3be$var$og[--$013c97a5603ef3be$var$pg], $013c97a5603ef3be$var$og[$013c97a5603ef3be$var$pg] = null, $013c97a5603ef3be$var$rg = $013c97a5603ef3be$var$og[--$013c97a5603ef3be$var$pg], $013c97a5603ef3be$var$og[$013c97a5603ef3be$var$pg] = null;
}
var $013c97a5603ef3be$var$xg = null, $013c97a5603ef3be$var$yg = null, $013c97a5603ef3be$var$I = !1, $013c97a5603ef3be$var$zg = null;
function $013c97a5603ef3be$var$Ag(a, b) {
    var c = $013c97a5603ef3be$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $013c97a5603ef3be$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $013c97a5603ef3be$var$xg = a, $013c97a5603ef3be$var$yg = $013c97a5603ef3be$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $013c97a5603ef3be$var$xg = a, $013c97a5603ef3be$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $013c97a5603ef3be$var$qg ? {
                id: $013c97a5603ef3be$var$rg,
                overflow: $013c97a5603ef3be$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $013c97a5603ef3be$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $013c97a5603ef3be$var$xg = a, $013c97a5603ef3be$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $013c97a5603ef3be$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $013c97a5603ef3be$var$Eg(a) {
    if ($013c97a5603ef3be$var$I) {
        var b = $013c97a5603ef3be$var$yg;
        if (b) {
            var c = b;
            if (!$013c97a5603ef3be$var$Cg(a, b)) {
                if ($013c97a5603ef3be$var$Dg(a)) throw Error($013c97a5603ef3be$var$p(418));
                b = $013c97a5603ef3be$var$Lf(c.nextSibling);
                var d = $013c97a5603ef3be$var$xg;
                b && $013c97a5603ef3be$var$Cg(a, b) ? $013c97a5603ef3be$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $013c97a5603ef3be$var$I = !1, $013c97a5603ef3be$var$xg = a);
            }
        } else {
            if ($013c97a5603ef3be$var$Dg(a)) throw Error($013c97a5603ef3be$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $013c97a5603ef3be$var$I = !1;
            $013c97a5603ef3be$var$xg = a;
        }
    }
}
function $013c97a5603ef3be$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $013c97a5603ef3be$var$xg = a;
}
function $013c97a5603ef3be$var$Gg(a) {
    if (a !== $013c97a5603ef3be$var$xg) return !1;
    if (!$013c97a5603ef3be$var$I) return $013c97a5603ef3be$var$Fg(a), $013c97a5603ef3be$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$013c97a5603ef3be$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $013c97a5603ef3be$var$yg)) {
        if ($013c97a5603ef3be$var$Dg(a)) throw $013c97a5603ef3be$var$Hg(), Error($013c97a5603ef3be$var$p(418));
        for(; b;)$013c97a5603ef3be$var$Ag(a, b), b = $013c97a5603ef3be$var$Lf(b.nextSibling);
    }
    $013c97a5603ef3be$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($013c97a5603ef3be$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $013c97a5603ef3be$var$yg = $013c97a5603ef3be$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $013c97a5603ef3be$var$yg = null;
        }
    } else $013c97a5603ef3be$var$yg = $013c97a5603ef3be$var$xg ? $013c97a5603ef3be$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $013c97a5603ef3be$var$Hg() {
    for(var a = $013c97a5603ef3be$var$yg; a;)a = $013c97a5603ef3be$var$Lf(a.nextSibling);
}
function $013c97a5603ef3be$var$Ig() {
    $013c97a5603ef3be$var$yg = $013c97a5603ef3be$var$xg = null;
    $013c97a5603ef3be$var$I = !1;
}
function $013c97a5603ef3be$var$Jg(a) {
    null === $013c97a5603ef3be$var$zg ? $013c97a5603ef3be$var$zg = [
        a
    ] : $013c97a5603ef3be$var$zg.push(a);
}
var $013c97a5603ef3be$var$Kg = $013c97a5603ef3be$var$ua.ReactCurrentBatchConfig;
function $013c97a5603ef3be$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($013c97a5603ef3be$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($013c97a5603ef3be$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function b(a) {
                var _$b = e.refs;
                null === a ? delete _$b[f] : _$b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($013c97a5603ef3be$var$p(284));
        if (!c._owner) throw Error($013c97a5603ef3be$var$p(290, a));
    }
    return a;
}
function $013c97a5603ef3be$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($013c97a5603ef3be$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $013c97a5603ef3be$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $013c97a5603ef3be$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $013c97a5603ef3be$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $013c97a5603ef3be$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $013c97a5603ef3be$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $013c97a5603ef3be$var$Ha && $013c97a5603ef3be$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $013c97a5603ef3be$var$Lg(a, b, c), d.return = a, d;
        d = $013c97a5603ef3be$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $013c97a5603ef3be$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $013c97a5603ef3be$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $013c97a5603ef3be$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $013c97a5603ef3be$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $013c97a5603ef3be$var$va:
                    return c = $013c97a5603ef3be$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $013c97a5603ef3be$var$Lg(a, null, b), c.return = a, c;
                case $013c97a5603ef3be$var$wa:
                    return b = $013c97a5603ef3be$var$Sg(b, a.mode, c), b.return = a, b;
                case $013c97a5603ef3be$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($013c97a5603ef3be$var$eb(b) || $013c97a5603ef3be$var$Ka(b)) return b = $013c97a5603ef3be$var$Tg(b, a.mode, c, null), b.return = a, b;
            $013c97a5603ef3be$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $013c97a5603ef3be$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $013c97a5603ef3be$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $013c97a5603ef3be$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($013c97a5603ef3be$var$eb(c) || $013c97a5603ef3be$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $013c97a5603ef3be$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $013c97a5603ef3be$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $013c97a5603ef3be$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $013c97a5603ef3be$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($013c97a5603ef3be$var$eb(d) || $013c97a5603ef3be$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $013c97a5603ef3be$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $013c97a5603ef3be$var$I && $013c97a5603ef3be$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $013c97a5603ef3be$var$I && $013c97a5603ef3be$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $013c97a5603ef3be$var$I && $013c97a5603ef3be$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $013c97a5603ef3be$var$Ka(h);
        if ("function" !== typeof l) throw Error($013c97a5603ef3be$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($013c97a5603ef3be$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $013c97a5603ef3be$var$I && $013c97a5603ef3be$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $013c97a5603ef3be$var$I && $013c97a5603ef3be$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $013c97a5603ef3be$var$I && $013c97a5603ef3be$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $013c97a5603ef3be$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $013c97a5603ef3be$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $013c97a5603ef3be$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $013c97a5603ef3be$var$Ha && $013c97a5603ef3be$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $013c97a5603ef3be$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $013c97a5603ef3be$var$ya ? (d = $013c97a5603ef3be$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $013c97a5603ef3be$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $013c97a5603ef3be$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $013c97a5603ef3be$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $013c97a5603ef3be$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $013c97a5603ef3be$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($013c97a5603ef3be$var$eb(f)) return n(a, d, f, h);
            if ($013c97a5603ef3be$var$Ka(f)) return t(a, d, f, h);
            $013c97a5603ef3be$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $013c97a5603ef3be$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $013c97a5603ef3be$var$Ug = $013c97a5603ef3be$var$Og(!0), $013c97a5603ef3be$var$Vg = $013c97a5603ef3be$var$Og(!1), $013c97a5603ef3be$var$Wg = $013c97a5603ef3be$var$Uf(null), $013c97a5603ef3be$var$Xg = null, $013c97a5603ef3be$var$Yg = null, $013c97a5603ef3be$var$Zg = null;
function $013c97a5603ef3be$var$$g() {
    $013c97a5603ef3be$var$Zg = $013c97a5603ef3be$var$Yg = $013c97a5603ef3be$var$Xg = null;
}
function $013c97a5603ef3be$var$ah(a) {
    var b = $013c97a5603ef3be$var$Wg.current;
    $013c97a5603ef3be$var$E($013c97a5603ef3be$var$Wg);
    a._currentValue = b;
}
function $013c97a5603ef3be$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $013c97a5603ef3be$var$ch(a, b) {
    $013c97a5603ef3be$var$Xg = a;
    $013c97a5603ef3be$var$Zg = $013c97a5603ef3be$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($013c97a5603ef3be$var$dh = !0), a.firstContext = null);
}
function $013c97a5603ef3be$var$eh(a) {
    var b = a._currentValue;
    if ($013c97a5603ef3be$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $013c97a5603ef3be$var$Yg) {
            if (null === $013c97a5603ef3be$var$Xg) throw Error($013c97a5603ef3be$var$p(308));
            $013c97a5603ef3be$var$Yg = a;
            $013c97a5603ef3be$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $013c97a5603ef3be$var$Yg = $013c97a5603ef3be$var$Yg.next = a;
    }
    return b;
}
var $013c97a5603ef3be$var$fh = null;
function $013c97a5603ef3be$var$gh(a) {
    null === $013c97a5603ef3be$var$fh ? $013c97a5603ef3be$var$fh = [
        a
    ] : $013c97a5603ef3be$var$fh.push(a);
}
function $013c97a5603ef3be$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $013c97a5603ef3be$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $013c97a5603ef3be$var$ih(a, d);
}
function $013c97a5603ef3be$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $013c97a5603ef3be$var$jh = !1;
function $013c97a5603ef3be$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $013c97a5603ef3be$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $013c97a5603ef3be$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $013c97a5603ef3be$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($013c97a5603ef3be$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $013c97a5603ef3be$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $013c97a5603ef3be$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $013c97a5603ef3be$var$ih(a, c);
}
function $013c97a5603ef3be$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $013c97a5603ef3be$var$Cc(a, c);
    }
}
function $013c97a5603ef3be$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $013c97a5603ef3be$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $013c97a5603ef3be$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $013c97a5603ef3be$var$A({}, q, r);
                            break a;
                        case 2:
                            $013c97a5603ef3be$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $013c97a5603ef3be$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $013c97a5603ef3be$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($013c97a5603ef3be$var$p(191, e));
            e.call(d);
        }
    }
}
var $013c97a5603ef3be$var$th = {}, $013c97a5603ef3be$var$uh = $013c97a5603ef3be$var$Uf($013c97a5603ef3be$var$th), $013c97a5603ef3be$var$vh = $013c97a5603ef3be$var$Uf($013c97a5603ef3be$var$th), $013c97a5603ef3be$var$wh = $013c97a5603ef3be$var$Uf($013c97a5603ef3be$var$th);
function $013c97a5603ef3be$var$xh(a) {
    if (a === $013c97a5603ef3be$var$th) throw Error($013c97a5603ef3be$var$p(174));
    return a;
}
function $013c97a5603ef3be$var$yh(a, b) {
    $013c97a5603ef3be$var$G($013c97a5603ef3be$var$wh, b);
    $013c97a5603ef3be$var$G($013c97a5603ef3be$var$vh, a);
    $013c97a5603ef3be$var$G($013c97a5603ef3be$var$uh, $013c97a5603ef3be$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $013c97a5603ef3be$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $013c97a5603ef3be$var$lb(b, a);
    }
    $013c97a5603ef3be$var$E($013c97a5603ef3be$var$uh);
    $013c97a5603ef3be$var$G($013c97a5603ef3be$var$uh, b);
}
function $013c97a5603ef3be$var$zh() {
    $013c97a5603ef3be$var$E($013c97a5603ef3be$var$uh);
    $013c97a5603ef3be$var$E($013c97a5603ef3be$var$vh);
    $013c97a5603ef3be$var$E($013c97a5603ef3be$var$wh);
}
function $013c97a5603ef3be$var$Ah(a) {
    $013c97a5603ef3be$var$xh($013c97a5603ef3be$var$wh.current);
    var b = $013c97a5603ef3be$var$xh($013c97a5603ef3be$var$uh.current);
    var c = $013c97a5603ef3be$var$lb(b, a.type);
    b !== c && ($013c97a5603ef3be$var$G($013c97a5603ef3be$var$vh, a), $013c97a5603ef3be$var$G($013c97a5603ef3be$var$uh, c));
}
function $013c97a5603ef3be$var$Bh(a) {
    $013c97a5603ef3be$var$vh.current === a && ($013c97a5603ef3be$var$E($013c97a5603ef3be$var$uh), $013c97a5603ef3be$var$E($013c97a5603ef3be$var$vh));
}
var $013c97a5603ef3be$var$L = $013c97a5603ef3be$var$Uf(0);
function $013c97a5603ef3be$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $013c97a5603ef3be$var$Dh = [];
function $013c97a5603ef3be$var$Eh() {
    for(var a = 0; a < $013c97a5603ef3be$var$Dh.length; a++)$013c97a5603ef3be$var$Dh[a]._workInProgressVersionPrimary = null;
    $013c97a5603ef3be$var$Dh.length = 0;
}
var $013c97a5603ef3be$var$Fh = $013c97a5603ef3be$var$ua.ReactCurrentDispatcher, $013c97a5603ef3be$var$Gh = $013c97a5603ef3be$var$ua.ReactCurrentBatchConfig, $013c97a5603ef3be$var$Hh = 0, $013c97a5603ef3be$var$M = null, $013c97a5603ef3be$var$N = null, $013c97a5603ef3be$var$O = null, $013c97a5603ef3be$var$Ih = !1, $013c97a5603ef3be$var$Jh = !1, $013c97a5603ef3be$var$Kh = 0, $013c97a5603ef3be$var$Lh = 0;
function $013c97a5603ef3be$var$P() {
    throw Error($013c97a5603ef3be$var$p(321));
}
function $013c97a5603ef3be$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$013c97a5603ef3be$var$He(a[c], b[c])) return !1;
    return !0;
}
function $013c97a5603ef3be$var$Nh(a, b, c, d, e, f) {
    $013c97a5603ef3be$var$Hh = f;
    $013c97a5603ef3be$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $013c97a5603ef3be$var$Fh.current = null === a || null === a.memoizedState ? $013c97a5603ef3be$var$Oh : $013c97a5603ef3be$var$Ph;
    a = c(d, e);
    if ($013c97a5603ef3be$var$Jh) {
        f = 0;
        do {
            $013c97a5603ef3be$var$Jh = !1;
            $013c97a5603ef3be$var$Kh = 0;
            if (25 <= f) throw Error($013c97a5603ef3be$var$p(301));
            f += 1;
            $013c97a5603ef3be$var$O = $013c97a5603ef3be$var$N = null;
            b.updateQueue = null;
            $013c97a5603ef3be$var$Fh.current = $013c97a5603ef3be$var$Qh;
            a = c(d, e);
        }while ($013c97a5603ef3be$var$Jh);
    }
    $013c97a5603ef3be$var$Fh.current = $013c97a5603ef3be$var$Rh;
    b = null !== $013c97a5603ef3be$var$N && null !== $013c97a5603ef3be$var$N.next;
    $013c97a5603ef3be$var$Hh = 0;
    $013c97a5603ef3be$var$O = $013c97a5603ef3be$var$N = $013c97a5603ef3be$var$M = null;
    $013c97a5603ef3be$var$Ih = !1;
    if (b) throw Error($013c97a5603ef3be$var$p(300));
    return a;
}
function $013c97a5603ef3be$var$Sh() {
    var a = 0 !== $013c97a5603ef3be$var$Kh;
    $013c97a5603ef3be$var$Kh = 0;
    return a;
}
function $013c97a5603ef3be$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $013c97a5603ef3be$var$O ? $013c97a5603ef3be$var$M.memoizedState = $013c97a5603ef3be$var$O = a : $013c97a5603ef3be$var$O = $013c97a5603ef3be$var$O.next = a;
    return $013c97a5603ef3be$var$O;
}
function $013c97a5603ef3be$var$Uh() {
    if (null === $013c97a5603ef3be$var$N) {
        var a = $013c97a5603ef3be$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $013c97a5603ef3be$var$N.next;
    var b = null === $013c97a5603ef3be$var$O ? $013c97a5603ef3be$var$M.memoizedState : $013c97a5603ef3be$var$O.next;
    if (null !== b) $013c97a5603ef3be$var$O = b, $013c97a5603ef3be$var$N = a;
    else {
        if (null === a) throw Error($013c97a5603ef3be$var$p(310));
        $013c97a5603ef3be$var$N = a;
        a = {
            memoizedState: $013c97a5603ef3be$var$N.memoizedState,
            baseState: $013c97a5603ef3be$var$N.baseState,
            baseQueue: $013c97a5603ef3be$var$N.baseQueue,
            queue: $013c97a5603ef3be$var$N.queue,
            next: null
        };
        null === $013c97a5603ef3be$var$O ? $013c97a5603ef3be$var$M.memoizedState = $013c97a5603ef3be$var$O = a : $013c97a5603ef3be$var$O = $013c97a5603ef3be$var$O.next = a;
    }
    return $013c97a5603ef3be$var$O;
}
function $013c97a5603ef3be$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $013c97a5603ef3be$var$Wh(a) {
    var b = $013c97a5603ef3be$var$Uh(), c = b.queue;
    if (null === c) throw Error($013c97a5603ef3be$var$p(311));
    c.lastRenderedReducer = a;
    var d = $013c97a5603ef3be$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($013c97a5603ef3be$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $013c97a5603ef3be$var$M.lanes |= m;
                $013c97a5603ef3be$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $013c97a5603ef3be$var$He(d, b.memoizedState) || ($013c97a5603ef3be$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $013c97a5603ef3be$var$M.lanes |= f, $013c97a5603ef3be$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $013c97a5603ef3be$var$Xh(a) {
    var b = $013c97a5603ef3be$var$Uh(), c = b.queue;
    if (null === c) throw Error($013c97a5603ef3be$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $013c97a5603ef3be$var$He(f, b.memoizedState) || ($013c97a5603ef3be$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $013c97a5603ef3be$var$Yh() {}
function $013c97a5603ef3be$var$Zh(a, b) {
    var c = $013c97a5603ef3be$var$M, d = $013c97a5603ef3be$var$Uh(), e = b(), f = !$013c97a5603ef3be$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $013c97a5603ef3be$var$dh = !0);
    d = d.queue;
    $013c97a5603ef3be$var$$h($013c97a5603ef3be$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $013c97a5603ef3be$var$O && $013c97a5603ef3be$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $013c97a5603ef3be$var$bi(9, $013c97a5603ef3be$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $013c97a5603ef3be$var$Q) throw Error($013c97a5603ef3be$var$p(349));
        0 !== ($013c97a5603ef3be$var$Hh & 30) || $013c97a5603ef3be$var$di(c, b, e);
    }
    return e;
}
function $013c97a5603ef3be$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $013c97a5603ef3be$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $013c97a5603ef3be$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $013c97a5603ef3be$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $013c97a5603ef3be$var$ei(b) && $013c97a5603ef3be$var$fi(a);
}
function $013c97a5603ef3be$var$ai(a, b, c) {
    return c(function() {
        $013c97a5603ef3be$var$ei(b) && $013c97a5603ef3be$var$fi(a);
    });
}
function $013c97a5603ef3be$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$013c97a5603ef3be$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $013c97a5603ef3be$var$fi(a) {
    var b = $013c97a5603ef3be$var$ih(a, 1);
    null !== b && $013c97a5603ef3be$var$gi(b, a, 1, -1);
}
function $013c97a5603ef3be$var$hi(a) {
    var b = $013c97a5603ef3be$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $013c97a5603ef3be$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $013c97a5603ef3be$var$ii.bind(null, $013c97a5603ef3be$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $013c97a5603ef3be$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $013c97a5603ef3be$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $013c97a5603ef3be$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $013c97a5603ef3be$var$ji() {
    return $013c97a5603ef3be$var$Uh().memoizedState;
}
function $013c97a5603ef3be$var$ki(a, b, c, d) {
    var e = $013c97a5603ef3be$var$Th();
    $013c97a5603ef3be$var$M.flags |= a;
    e.memoizedState = $013c97a5603ef3be$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $013c97a5603ef3be$var$li(a, b, c, d) {
    var e = $013c97a5603ef3be$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $013c97a5603ef3be$var$N) {
        var g = $013c97a5603ef3be$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $013c97a5603ef3be$var$Mh(d, g.deps)) {
            e.memoizedState = $013c97a5603ef3be$var$bi(b, c, f, d);
            return;
        }
    }
    $013c97a5603ef3be$var$M.flags |= a;
    e.memoizedState = $013c97a5603ef3be$var$bi(1 | b, c, f, d);
}
function $013c97a5603ef3be$var$mi(a, b) {
    return $013c97a5603ef3be$var$ki(8390656, 8, a, b);
}
function $013c97a5603ef3be$var$$h(a, b) {
    return $013c97a5603ef3be$var$li(2048, 8, a, b);
}
function $013c97a5603ef3be$var$ni(a, b) {
    return $013c97a5603ef3be$var$li(4, 2, a, b);
}
function $013c97a5603ef3be$var$oi(a, b) {
    return $013c97a5603ef3be$var$li(4, 4, a, b);
}
function $013c97a5603ef3be$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $013c97a5603ef3be$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $013c97a5603ef3be$var$li(4, 4, $013c97a5603ef3be$var$pi.bind(null, b, a), c);
}
function $013c97a5603ef3be$var$ri() {}
function $013c97a5603ef3be$var$si(a, b) {
    var c = $013c97a5603ef3be$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $013c97a5603ef3be$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $013c97a5603ef3be$var$ti(a, b) {
    var c = $013c97a5603ef3be$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $013c97a5603ef3be$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $013c97a5603ef3be$var$ui(a, b, c) {
    if (0 === ($013c97a5603ef3be$var$Hh & 21)) return a.baseState && (a.baseState = !1, $013c97a5603ef3be$var$dh = !0), a.memoizedState = c;
    $013c97a5603ef3be$var$He(c, b) || (c = $013c97a5603ef3be$var$yc(), $013c97a5603ef3be$var$M.lanes |= c, $013c97a5603ef3be$var$rh |= c, a.baseState = !0);
    return b;
}
function $013c97a5603ef3be$var$vi(a, b) {
    var c = $013c97a5603ef3be$var$C;
    $013c97a5603ef3be$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $013c97a5603ef3be$var$Gh.transition;
    $013c97a5603ef3be$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $013c97a5603ef3be$var$C = c, $013c97a5603ef3be$var$Gh.transition = d;
    }
}
function $013c97a5603ef3be$var$wi() {
    return $013c97a5603ef3be$var$Uh().memoizedState;
}
function $013c97a5603ef3be$var$xi(a, b, c) {
    var d = $013c97a5603ef3be$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($013c97a5603ef3be$var$zi(a)) $013c97a5603ef3be$var$Ai(b, c);
    else if (c = $013c97a5603ef3be$var$hh(a, b, c, d), null !== c) {
        var e = $013c97a5603ef3be$var$R();
        $013c97a5603ef3be$var$gi(c, a, d, e);
        $013c97a5603ef3be$var$Bi(c, b, d);
    }
}
function $013c97a5603ef3be$var$ii(a, b, c) {
    var d = $013c97a5603ef3be$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($013c97a5603ef3be$var$zi(a)) $013c97a5603ef3be$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($013c97a5603ef3be$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $013c97a5603ef3be$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $013c97a5603ef3be$var$hh(a, b, e, d);
        null !== c && (e = $013c97a5603ef3be$var$R(), $013c97a5603ef3be$var$gi(c, a, d, e), $013c97a5603ef3be$var$Bi(c, b, d));
    }
}
function $013c97a5603ef3be$var$zi(a) {
    var b = a.alternate;
    return a === $013c97a5603ef3be$var$M || null !== b && b === $013c97a5603ef3be$var$M;
}
function $013c97a5603ef3be$var$Ai(a, b) {
    $013c97a5603ef3be$var$Jh = $013c97a5603ef3be$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $013c97a5603ef3be$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $013c97a5603ef3be$var$Cc(a, c);
    }
}
var $013c97a5603ef3be$var$Rh = {
    readContext: $013c97a5603ef3be$var$eh,
    useCallback: $013c97a5603ef3be$var$P,
    useContext: $013c97a5603ef3be$var$P,
    useEffect: $013c97a5603ef3be$var$P,
    useImperativeHandle: $013c97a5603ef3be$var$P,
    useInsertionEffect: $013c97a5603ef3be$var$P,
    useLayoutEffect: $013c97a5603ef3be$var$P,
    useMemo: $013c97a5603ef3be$var$P,
    useReducer: $013c97a5603ef3be$var$P,
    useRef: $013c97a5603ef3be$var$P,
    useState: $013c97a5603ef3be$var$P,
    useDebugValue: $013c97a5603ef3be$var$P,
    useDeferredValue: $013c97a5603ef3be$var$P,
    useTransition: $013c97a5603ef3be$var$P,
    useMutableSource: $013c97a5603ef3be$var$P,
    useSyncExternalStore: $013c97a5603ef3be$var$P,
    useId: $013c97a5603ef3be$var$P,
    unstable_isNewReconciler: !1
}, $013c97a5603ef3be$var$Oh = {
    readContext: $013c97a5603ef3be$var$eh,
    useCallback: function useCallback(a, b) {
        $013c97a5603ef3be$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $013c97a5603ef3be$var$eh,
    useEffect: $013c97a5603ef3be$var$mi,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $013c97a5603ef3be$var$ki(4194308, 4, $013c97a5603ef3be$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return $013c97a5603ef3be$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function useInsertionEffect(a, b) {
        return $013c97a5603ef3be$var$ki(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = $013c97a5603ef3be$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = $013c97a5603ef3be$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $013c97a5603ef3be$var$xi.bind(null, $013c97a5603ef3be$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = $013c97a5603ef3be$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $013c97a5603ef3be$var$hi,
    useDebugValue: $013c97a5603ef3be$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        return $013c97a5603ef3be$var$Th().memoizedState = a;
    },
    useTransition: function useTransition() {
        var a = $013c97a5603ef3be$var$hi(!1), b = a[0];
        a = $013c97a5603ef3be$var$vi.bind(null, a[1]);
        $013c97a5603ef3be$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function useMutableSource() {},
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        var d = $013c97a5603ef3be$var$M, e = $013c97a5603ef3be$var$Th();
        if ($013c97a5603ef3be$var$I) {
            if (void 0 === c) throw Error($013c97a5603ef3be$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $013c97a5603ef3be$var$Q) throw Error($013c97a5603ef3be$var$p(349));
            0 !== ($013c97a5603ef3be$var$Hh & 30) || $013c97a5603ef3be$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $013c97a5603ef3be$var$mi($013c97a5603ef3be$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $013c97a5603ef3be$var$bi(9, $013c97a5603ef3be$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function useId() {
        var a = $013c97a5603ef3be$var$Th(), b = $013c97a5603ef3be$var$Q.identifierPrefix;
        if ($013c97a5603ef3be$var$I) {
            var c = $013c97a5603ef3be$var$sg;
            var d = $013c97a5603ef3be$var$rg;
            c = (d & ~(1 << 32 - $013c97a5603ef3be$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $013c97a5603ef3be$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $013c97a5603ef3be$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $013c97a5603ef3be$var$Ph = {
    readContext: $013c97a5603ef3be$var$eh,
    useCallback: $013c97a5603ef3be$var$si,
    useContext: $013c97a5603ef3be$var$eh,
    useEffect: $013c97a5603ef3be$var$$h,
    useImperativeHandle: $013c97a5603ef3be$var$qi,
    useInsertionEffect: $013c97a5603ef3be$var$ni,
    useLayoutEffect: $013c97a5603ef3be$var$oi,
    useMemo: $013c97a5603ef3be$var$ti,
    useReducer: $013c97a5603ef3be$var$Wh,
    useRef: $013c97a5603ef3be$var$ji,
    useState: function useState() {
        return $013c97a5603ef3be$var$Wh($013c97a5603ef3be$var$Vh);
    },
    useDebugValue: $013c97a5603ef3be$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = $013c97a5603ef3be$var$Uh();
        return $013c97a5603ef3be$var$ui(b, $013c97a5603ef3be$var$N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $013c97a5603ef3be$var$Wh($013c97a5603ef3be$var$Vh)[0], b = $013c97a5603ef3be$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $013c97a5603ef3be$var$Yh,
    useSyncExternalStore: $013c97a5603ef3be$var$Zh,
    useId: $013c97a5603ef3be$var$wi,
    unstable_isNewReconciler: !1
}, $013c97a5603ef3be$var$Qh = {
    readContext: $013c97a5603ef3be$var$eh,
    useCallback: $013c97a5603ef3be$var$si,
    useContext: $013c97a5603ef3be$var$eh,
    useEffect: $013c97a5603ef3be$var$$h,
    useImperativeHandle: $013c97a5603ef3be$var$qi,
    useInsertionEffect: $013c97a5603ef3be$var$ni,
    useLayoutEffect: $013c97a5603ef3be$var$oi,
    useMemo: $013c97a5603ef3be$var$ti,
    useReducer: $013c97a5603ef3be$var$Xh,
    useRef: $013c97a5603ef3be$var$ji,
    useState: function useState() {
        return $013c97a5603ef3be$var$Xh($013c97a5603ef3be$var$Vh);
    },
    useDebugValue: $013c97a5603ef3be$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = $013c97a5603ef3be$var$Uh();
        return null === $013c97a5603ef3be$var$N ? b.memoizedState = a : $013c97a5603ef3be$var$ui(b, $013c97a5603ef3be$var$N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $013c97a5603ef3be$var$Xh($013c97a5603ef3be$var$Vh)[0], b = $013c97a5603ef3be$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $013c97a5603ef3be$var$Yh,
    useSyncExternalStore: $013c97a5603ef3be$var$Zh,
    useId: $013c97a5603ef3be$var$wi,
    unstable_isNewReconciler: !1
};
function $013c97a5603ef3be$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $013c97a5603ef3be$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $013c97a5603ef3be$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $013c97a5603ef3be$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $013c97a5603ef3be$var$Ei = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? $013c97a5603ef3be$var$Vb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = $013c97a5603ef3be$var$R(), e = $013c97a5603ef3be$var$yi(a), f = $013c97a5603ef3be$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $013c97a5603ef3be$var$nh(a, f, e);
        null !== b && ($013c97a5603ef3be$var$gi(b, a, e, d), $013c97a5603ef3be$var$oh(b, a, e));
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = $013c97a5603ef3be$var$R(), e = $013c97a5603ef3be$var$yi(a), f = $013c97a5603ef3be$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $013c97a5603ef3be$var$nh(a, f, e);
        null !== b && ($013c97a5603ef3be$var$gi(b, a, e, d), $013c97a5603ef3be$var$oh(b, a, e));
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = $013c97a5603ef3be$var$R(), d = $013c97a5603ef3be$var$yi(a), e = $013c97a5603ef3be$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $013c97a5603ef3be$var$nh(a, e, d);
        null !== b && ($013c97a5603ef3be$var$gi(b, a, d, c), $013c97a5603ef3be$var$oh(b, a, d));
    }
};
function $013c97a5603ef3be$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$013c97a5603ef3be$var$Ie(c, d) || !$013c97a5603ef3be$var$Ie(e, f) : !0;
}
function $013c97a5603ef3be$var$Gi(a, b, c) {
    var d = !1, e = $013c97a5603ef3be$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $013c97a5603ef3be$var$eh(f) : (e = $013c97a5603ef3be$var$Zf(b) ? $013c97a5603ef3be$var$Xf : $013c97a5603ef3be$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $013c97a5603ef3be$var$Yf(a, e) : $013c97a5603ef3be$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $013c97a5603ef3be$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $013c97a5603ef3be$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $013c97a5603ef3be$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $013c97a5603ef3be$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $013c97a5603ef3be$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $013c97a5603ef3be$var$eh(f) : (f = $013c97a5603ef3be$var$Zf(b) ? $013c97a5603ef3be$var$Xf : $013c97a5603ef3be$var$H.current, e.context = $013c97a5603ef3be$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($013c97a5603ef3be$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $013c97a5603ef3be$var$Ei.enqueueReplaceState(e, e.state, null), $013c97a5603ef3be$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $013c97a5603ef3be$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $013c97a5603ef3be$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $013c97a5603ef3be$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $013c97a5603ef3be$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $013c97a5603ef3be$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $013c97a5603ef3be$var$Ni(a, b, c) {
    c = $013c97a5603ef3be$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $013c97a5603ef3be$var$Oi || ($013c97a5603ef3be$var$Oi = !0, $013c97a5603ef3be$var$Pi = d);
        $013c97a5603ef3be$var$Li(a, b);
    };
    return c;
}
function $013c97a5603ef3be$var$Qi(a, b, c) {
    c = $013c97a5603ef3be$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $013c97a5603ef3be$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $013c97a5603ef3be$var$Li(a, b);
        "function" !== typeof d && (null === $013c97a5603ef3be$var$Ri ? $013c97a5603ef3be$var$Ri = new Set([
            this
        ]) : $013c97a5603ef3be$var$Ri.add(this));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
function $013c97a5603ef3be$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $013c97a5603ef3be$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $013c97a5603ef3be$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $013c97a5603ef3be$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $013c97a5603ef3be$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $013c97a5603ef3be$var$mh(-1, 1), b.tag = 2, $013c97a5603ef3be$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $013c97a5603ef3be$var$Wi = $013c97a5603ef3be$var$ua.ReactCurrentOwner, $013c97a5603ef3be$var$dh = !1;
function $013c97a5603ef3be$var$Xi(a, b, c, d) {
    b.child = null === a ? $013c97a5603ef3be$var$Vg(b, null, c, d) : $013c97a5603ef3be$var$Ug(b, a.child, c, d);
}
function $013c97a5603ef3be$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $013c97a5603ef3be$var$ch(b, e);
    d = $013c97a5603ef3be$var$Nh(a, b, c, d, f, e);
    c = $013c97a5603ef3be$var$Sh();
    if (null !== a && !$013c97a5603ef3be$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $013c97a5603ef3be$var$Zi(a, b, e);
    $013c97a5603ef3be$var$I && c && $013c97a5603ef3be$var$vg(b);
    b.flags |= 1;
    $013c97a5603ef3be$var$Xi(a, b, d, e);
    return b.child;
}
function $013c97a5603ef3be$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$013c97a5603ef3be$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $013c97a5603ef3be$var$bj(a, b, f, d, e);
        a = $013c97a5603ef3be$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $013c97a5603ef3be$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $013c97a5603ef3be$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $013c97a5603ef3be$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $013c97a5603ef3be$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($013c97a5603ef3be$var$Ie(f, d) && a.ref === b.ref) {
            if ($013c97a5603ef3be$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($013c97a5603ef3be$var$dh = !0);
            else return b.lanes = a.lanes, $013c97a5603ef3be$var$Zi(a, b, e);
        }
    }
    return $013c97a5603ef3be$var$cj(a, b, c, d, e);
}
function $013c97a5603ef3be$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $013c97a5603ef3be$var$G($013c97a5603ef3be$var$ej, $013c97a5603ef3be$var$fj), $013c97a5603ef3be$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $013c97a5603ef3be$var$G($013c97a5603ef3be$var$ej, $013c97a5603ef3be$var$fj), $013c97a5603ef3be$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $013c97a5603ef3be$var$G($013c97a5603ef3be$var$ej, $013c97a5603ef3be$var$fj);
            $013c97a5603ef3be$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $013c97a5603ef3be$var$G($013c97a5603ef3be$var$ej, $013c97a5603ef3be$var$fj), $013c97a5603ef3be$var$fj |= d;
    $013c97a5603ef3be$var$Xi(a, b, e, c);
    return b.child;
}
function $013c97a5603ef3be$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $013c97a5603ef3be$var$cj(a, b, c, d, e) {
    var f = $013c97a5603ef3be$var$Zf(c) ? $013c97a5603ef3be$var$Xf : $013c97a5603ef3be$var$H.current;
    f = $013c97a5603ef3be$var$Yf(b, f);
    $013c97a5603ef3be$var$ch(b, e);
    c = $013c97a5603ef3be$var$Nh(a, b, c, d, f, e);
    d = $013c97a5603ef3be$var$Sh();
    if (null !== a && !$013c97a5603ef3be$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $013c97a5603ef3be$var$Zi(a, b, e);
    $013c97a5603ef3be$var$I && d && $013c97a5603ef3be$var$vg(b);
    b.flags |= 1;
    $013c97a5603ef3be$var$Xi(a, b, c, e);
    return b.child;
}
function $013c97a5603ef3be$var$hj(a, b, c, d, e) {
    if ($013c97a5603ef3be$var$Zf(c)) {
        var f = !0;
        $013c97a5603ef3be$var$cg(b);
    } else f = !1;
    $013c97a5603ef3be$var$ch(b, e);
    if (null === b.stateNode) $013c97a5603ef3be$var$ij(a, b), $013c97a5603ef3be$var$Gi(b, c, d), $013c97a5603ef3be$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $013c97a5603ef3be$var$eh(l) : (l = $013c97a5603ef3be$var$Zf(c) ? $013c97a5603ef3be$var$Xf : $013c97a5603ef3be$var$H.current, l = $013c97a5603ef3be$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $013c97a5603ef3be$var$Hi(b, g, d, l);
        $013c97a5603ef3be$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $013c97a5603ef3be$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $013c97a5603ef3be$var$Wf.current || $013c97a5603ef3be$var$jh ? ("function" === typeof m && ($013c97a5603ef3be$var$Di(b, c, m, d), k = b.memoizedState), (h = $013c97a5603ef3be$var$jh || $013c97a5603ef3be$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $013c97a5603ef3be$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $013c97a5603ef3be$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $013c97a5603ef3be$var$eh(k) : (k = $013c97a5603ef3be$var$Zf(c) ? $013c97a5603ef3be$var$Xf : $013c97a5603ef3be$var$H.current, k = $013c97a5603ef3be$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $013c97a5603ef3be$var$Hi(b, g, d, k);
        $013c97a5603ef3be$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $013c97a5603ef3be$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $013c97a5603ef3be$var$Wf.current || $013c97a5603ef3be$var$jh ? ("function" === typeof y && ($013c97a5603ef3be$var$Di(b, c, y, d), n = b.memoizedState), (l = $013c97a5603ef3be$var$jh || $013c97a5603ef3be$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $013c97a5603ef3be$var$jj(a, b, c, d, f, e);
}
function $013c97a5603ef3be$var$jj(a, b, c, d, e, f) {
    $013c97a5603ef3be$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $013c97a5603ef3be$var$dg(b, c, !1), $013c97a5603ef3be$var$Zi(a, b, f);
    d = b.stateNode;
    $013c97a5603ef3be$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $013c97a5603ef3be$var$Ug(b, a.child, null, f), b.child = $013c97a5603ef3be$var$Ug(b, null, h, f)) : $013c97a5603ef3be$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $013c97a5603ef3be$var$dg(b, c, !0);
    return b.child;
}
function $013c97a5603ef3be$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $013c97a5603ef3be$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $013c97a5603ef3be$var$ag(a, b.context, !1);
    $013c97a5603ef3be$var$yh(a, b.containerInfo);
}
function $013c97a5603ef3be$var$lj(a, b, c, d, e) {
    $013c97a5603ef3be$var$Ig();
    $013c97a5603ef3be$var$Jg(e);
    b.flags |= 256;
    $013c97a5603ef3be$var$Xi(a, b, c, d);
    return b.child;
}
var $013c97a5603ef3be$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $013c97a5603ef3be$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $013c97a5603ef3be$var$oj(a, b, c) {
    var d = b.pendingProps, e = $013c97a5603ef3be$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $013c97a5603ef3be$var$G($013c97a5603ef3be$var$L, e & 1);
    if (null === a) {
        $013c97a5603ef3be$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $013c97a5603ef3be$var$pj(g, d, 0, null), a = $013c97a5603ef3be$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $013c97a5603ef3be$var$nj(c), b.memoizedState = $013c97a5603ef3be$var$mj, a) : $013c97a5603ef3be$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $013c97a5603ef3be$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $013c97a5603ef3be$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $013c97a5603ef3be$var$Pg(h, f) : (f = $013c97a5603ef3be$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $013c97a5603ef3be$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $013c97a5603ef3be$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $013c97a5603ef3be$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $013c97a5603ef3be$var$qj(a, b) {
    b = $013c97a5603ef3be$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $013c97a5603ef3be$var$sj(a, b, c, d) {
    null !== d && $013c97a5603ef3be$var$Jg(d);
    $013c97a5603ef3be$var$Ug(b, a.child, null, c);
    a = $013c97a5603ef3be$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $013c97a5603ef3be$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $013c97a5603ef3be$var$Ki(Error($013c97a5603ef3be$var$p(422))), $013c97a5603ef3be$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $013c97a5603ef3be$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $013c97a5603ef3be$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $013c97a5603ef3be$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $013c97a5603ef3be$var$nj(g);
        b.memoizedState = $013c97a5603ef3be$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $013c97a5603ef3be$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($013c97a5603ef3be$var$p(419));
        d = $013c97a5603ef3be$var$Ki(f, d, void 0);
        return $013c97a5603ef3be$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($013c97a5603ef3be$var$dh || h) {
        d = $013c97a5603ef3be$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $013c97a5603ef3be$var$ih(a, e), $013c97a5603ef3be$var$gi(d, a, e, -1));
        }
        $013c97a5603ef3be$var$tj();
        d = $013c97a5603ef3be$var$Ki(Error($013c97a5603ef3be$var$p(421)));
        return $013c97a5603ef3be$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $013c97a5603ef3be$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $013c97a5603ef3be$var$yg = $013c97a5603ef3be$var$Lf(e.nextSibling);
    $013c97a5603ef3be$var$xg = b;
    $013c97a5603ef3be$var$I = !0;
    $013c97a5603ef3be$var$zg = null;
    null !== a && ($013c97a5603ef3be$var$og[$013c97a5603ef3be$var$pg++] = $013c97a5603ef3be$var$rg, $013c97a5603ef3be$var$og[$013c97a5603ef3be$var$pg++] = $013c97a5603ef3be$var$sg, $013c97a5603ef3be$var$og[$013c97a5603ef3be$var$pg++] = $013c97a5603ef3be$var$qg, $013c97a5603ef3be$var$rg = a.id, $013c97a5603ef3be$var$sg = a.overflow, $013c97a5603ef3be$var$qg = b);
    b = $013c97a5603ef3be$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $013c97a5603ef3be$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $013c97a5603ef3be$var$bh(a.return, b, c);
}
function $013c97a5603ef3be$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $013c97a5603ef3be$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $013c97a5603ef3be$var$Xi(a, b, d.children, c);
    d = $013c97a5603ef3be$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $013c97a5603ef3be$var$vj(a, c, b);
            else if (19 === a.tag) $013c97a5603ef3be$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $013c97a5603ef3be$var$G($013c97a5603ef3be$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $013c97a5603ef3be$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $013c97a5603ef3be$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $013c97a5603ef3be$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $013c97a5603ef3be$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $013c97a5603ef3be$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $013c97a5603ef3be$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $013c97a5603ef3be$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $013c97a5603ef3be$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($013c97a5603ef3be$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $013c97a5603ef3be$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $013c97a5603ef3be$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $013c97a5603ef3be$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $013c97a5603ef3be$var$kj(b);
            $013c97a5603ef3be$var$Ig();
            break;
        case 5:
            $013c97a5603ef3be$var$Ah(b);
            break;
        case 1:
            $013c97a5603ef3be$var$Zf(b.type) && $013c97a5603ef3be$var$cg(b);
            break;
        case 4:
            $013c97a5603ef3be$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $013c97a5603ef3be$var$G($013c97a5603ef3be$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $013c97a5603ef3be$var$G($013c97a5603ef3be$var$L, $013c97a5603ef3be$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $013c97a5603ef3be$var$oj(a, b, c);
                $013c97a5603ef3be$var$G($013c97a5603ef3be$var$L, $013c97a5603ef3be$var$L.current & 1);
                a = $013c97a5603ef3be$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $013c97a5603ef3be$var$G($013c97a5603ef3be$var$L, $013c97a5603ef3be$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $013c97a5603ef3be$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $013c97a5603ef3be$var$G($013c97a5603ef3be$var$L, $013c97a5603ef3be$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $013c97a5603ef3be$var$dj(a, b, c);
    }
    return $013c97a5603ef3be$var$Zi(a, b, c);
}
var $013c97a5603ef3be$var$zj, $013c97a5603ef3be$var$Aj, $013c97a5603ef3be$var$Bj, $013c97a5603ef3be$var$Cj;
$013c97a5603ef3be$var$zj = function zj(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$013c97a5603ef3be$var$Aj = function Aj() {};
$013c97a5603ef3be$var$Bj = function Bj(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $013c97a5603ef3be$var$xh($013c97a5603ef3be$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $013c97a5603ef3be$var$Ya(a, e);
                d = $013c97a5603ef3be$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $013c97a5603ef3be$var$A({}, e, {
                    value: void 0
                });
                d = $013c97a5603ef3be$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $013c97a5603ef3be$var$gb(a, e);
                d = $013c97a5603ef3be$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $013c97a5603ef3be$var$Bf);
        }
        $013c97a5603ef3be$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($013c97a5603ef3be$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($013c97a5603ef3be$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $013c97a5603ef3be$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$013c97a5603ef3be$var$Cj = function Cj(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $013c97a5603ef3be$var$Dj(a, b) {
    if (!$013c97a5603ef3be$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $013c97a5603ef3be$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $013c97a5603ef3be$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $013c97a5603ef3be$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $013c97a5603ef3be$var$S(b), null;
        case 1:
            return $013c97a5603ef3be$var$Zf(b.type) && $013c97a5603ef3be$var$$f(), $013c97a5603ef3be$var$S(b), null;
        case 3:
            d = b.stateNode;
            $013c97a5603ef3be$var$zh();
            $013c97a5603ef3be$var$E($013c97a5603ef3be$var$Wf);
            $013c97a5603ef3be$var$E($013c97a5603ef3be$var$H);
            $013c97a5603ef3be$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $013c97a5603ef3be$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $013c97a5603ef3be$var$zg && ($013c97a5603ef3be$var$Fj($013c97a5603ef3be$var$zg), $013c97a5603ef3be$var$zg = null));
            $013c97a5603ef3be$var$Aj(a, b);
            $013c97a5603ef3be$var$S(b);
            return null;
        case 5:
            $013c97a5603ef3be$var$Bh(b);
            var e = $013c97a5603ef3be$var$xh($013c97a5603ef3be$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $013c97a5603ef3be$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($013c97a5603ef3be$var$p(166));
                    $013c97a5603ef3be$var$S(b);
                    return null;
                }
                a = $013c97a5603ef3be$var$xh($013c97a5603ef3be$var$uh.current);
                if ($013c97a5603ef3be$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$013c97a5603ef3be$var$Of] = b;
                    d[$013c97a5603ef3be$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $013c97a5603ef3be$var$D("cancel", d);
                            $013c97a5603ef3be$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $013c97a5603ef3be$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $013c97a5603ef3be$var$lf.length; e++)$013c97a5603ef3be$var$D($013c97a5603ef3be$var$lf[e], d);
                            break;
                        case "source":
                            $013c97a5603ef3be$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $013c97a5603ef3be$var$D("error", d);
                            $013c97a5603ef3be$var$D("load", d);
                            break;
                        case "details":
                            $013c97a5603ef3be$var$D("toggle", d);
                            break;
                        case "input":
                            $013c97a5603ef3be$var$Za(d, f);
                            $013c97a5603ef3be$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $013c97a5603ef3be$var$D("invalid", d);
                            break;
                        case "textarea":
                            $013c97a5603ef3be$var$hb(d, f), $013c97a5603ef3be$var$D("invalid", d);
                    }
                    $013c97a5603ef3be$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $013c97a5603ef3be$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $013c97a5603ef3be$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $013c97a5603ef3be$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $013c97a5603ef3be$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $013c97a5603ef3be$var$Va(d);
                            $013c97a5603ef3be$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $013c97a5603ef3be$var$Va(d);
                            $013c97a5603ef3be$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $013c97a5603ef3be$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $013c97a5603ef3be$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$013c97a5603ef3be$var$Of] = b;
                    a[$013c97a5603ef3be$var$Pf] = d;
                    $013c97a5603ef3be$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $013c97a5603ef3be$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $013c97a5603ef3be$var$D("cancel", a);
                                $013c97a5603ef3be$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $013c97a5603ef3be$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $013c97a5603ef3be$var$lf.length; e++)$013c97a5603ef3be$var$D($013c97a5603ef3be$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $013c97a5603ef3be$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $013c97a5603ef3be$var$D("error", a);
                                $013c97a5603ef3be$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $013c97a5603ef3be$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $013c97a5603ef3be$var$Za(a, d);
                                e = $013c97a5603ef3be$var$Ya(a, d);
                                $013c97a5603ef3be$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $013c97a5603ef3be$var$A({}, d, {
                                    value: void 0
                                });
                                $013c97a5603ef3be$var$D("invalid", a);
                                break;
                            case "textarea":
                                $013c97a5603ef3be$var$hb(a, d);
                                e = $013c97a5603ef3be$var$gb(a, d);
                                $013c97a5603ef3be$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $013c97a5603ef3be$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $013c97a5603ef3be$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $013c97a5603ef3be$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $013c97a5603ef3be$var$ob(a, k) : "number" === typeof k && $013c97a5603ef3be$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($013c97a5603ef3be$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $013c97a5603ef3be$var$D("scroll", a) : null != k && $013c97a5603ef3be$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $013c97a5603ef3be$var$Va(a);
                                $013c97a5603ef3be$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $013c97a5603ef3be$var$Va(a);
                                $013c97a5603ef3be$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $013c97a5603ef3be$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $013c97a5603ef3be$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $013c97a5603ef3be$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $013c97a5603ef3be$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $013c97a5603ef3be$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $013c97a5603ef3be$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($013c97a5603ef3be$var$p(166));
                c = $013c97a5603ef3be$var$xh($013c97a5603ef3be$var$wh.current);
                $013c97a5603ef3be$var$xh($013c97a5603ef3be$var$uh.current);
                if ($013c97a5603ef3be$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$013c97a5603ef3be$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $013c97a5603ef3be$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $013c97a5603ef3be$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $013c97a5603ef3be$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$013c97a5603ef3be$var$Of] = b, b.stateNode = d;
            }
            $013c97a5603ef3be$var$S(b);
            return null;
        case 13:
            $013c97a5603ef3be$var$E($013c97a5603ef3be$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($013c97a5603ef3be$var$I && null !== $013c97a5603ef3be$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $013c97a5603ef3be$var$Hg(), $013c97a5603ef3be$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $013c97a5603ef3be$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($013c97a5603ef3be$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($013c97a5603ef3be$var$p(317));
                        f[$013c97a5603ef3be$var$Of] = b;
                    } else $013c97a5603ef3be$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $013c97a5603ef3be$var$S(b);
                    f = !1;
                } else null !== $013c97a5603ef3be$var$zg && ($013c97a5603ef3be$var$Fj($013c97a5603ef3be$var$zg), $013c97a5603ef3be$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($013c97a5603ef3be$var$L.current & 1) ? 0 === $013c97a5603ef3be$var$T && ($013c97a5603ef3be$var$T = 3) : $013c97a5603ef3be$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $013c97a5603ef3be$var$S(b);
            return null;
        case 4:
            return $013c97a5603ef3be$var$zh(), $013c97a5603ef3be$var$Aj(a, b), null === a && $013c97a5603ef3be$var$sf(b.stateNode.containerInfo), $013c97a5603ef3be$var$S(b), null;
        case 10:
            return $013c97a5603ef3be$var$ah(b.type._context), $013c97a5603ef3be$var$S(b), null;
        case 17:
            return $013c97a5603ef3be$var$Zf(b.type) && $013c97a5603ef3be$var$$f(), $013c97a5603ef3be$var$S(b), null;
        case 19:
            $013c97a5603ef3be$var$E($013c97a5603ef3be$var$L);
            f = b.memoizedState;
            if (null === f) return $013c97a5603ef3be$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $013c97a5603ef3be$var$Dj(f, !1);
                else {
                    if (0 !== $013c97a5603ef3be$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $013c97a5603ef3be$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $013c97a5603ef3be$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $013c97a5603ef3be$var$G($013c97a5603ef3be$var$L, $013c97a5603ef3be$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $013c97a5603ef3be$var$B() > $013c97a5603ef3be$var$Gj && (b.flags |= 128, d = !0, $013c97a5603ef3be$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $013c97a5603ef3be$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $013c97a5603ef3be$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$013c97a5603ef3be$var$I) return $013c97a5603ef3be$var$S(b), null;
                    } else 2 * $013c97a5603ef3be$var$B() - f.renderingStartTime > $013c97a5603ef3be$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $013c97a5603ef3be$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $013c97a5603ef3be$var$B(), b.sibling = null, c = $013c97a5603ef3be$var$L.current, $013c97a5603ef3be$var$G($013c97a5603ef3be$var$L, d ? c & 1 | 2 : c & 1), b;
            $013c97a5603ef3be$var$S(b);
            return null;
        case 22:
        case 23:
            return $013c97a5603ef3be$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($013c97a5603ef3be$var$fj & 1073741824) && ($013c97a5603ef3be$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $013c97a5603ef3be$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($013c97a5603ef3be$var$p(156, b.tag));
}
function $013c97a5603ef3be$var$Ij(a, b) {
    $013c97a5603ef3be$var$wg(b);
    switch(b.tag){
        case 1:
            return $013c97a5603ef3be$var$Zf(b.type) && $013c97a5603ef3be$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $013c97a5603ef3be$var$zh(), $013c97a5603ef3be$var$E($013c97a5603ef3be$var$Wf), $013c97a5603ef3be$var$E($013c97a5603ef3be$var$H), $013c97a5603ef3be$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $013c97a5603ef3be$var$Bh(b), null;
        case 13:
            $013c97a5603ef3be$var$E($013c97a5603ef3be$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($013c97a5603ef3be$var$p(340));
                $013c97a5603ef3be$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $013c97a5603ef3be$var$E($013c97a5603ef3be$var$L), null;
        case 4:
            return $013c97a5603ef3be$var$zh(), null;
        case 10:
            return $013c97a5603ef3be$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $013c97a5603ef3be$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $013c97a5603ef3be$var$Jj = !1, $013c97a5603ef3be$var$U = !1, $013c97a5603ef3be$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $013c97a5603ef3be$var$V = null;
function $013c97a5603ef3be$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $013c97a5603ef3be$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $013c97a5603ef3be$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $013c97a5603ef3be$var$W(a, b, d);
    }
}
var $013c97a5603ef3be$var$Nj = !1;
function $013c97a5603ef3be$var$Oj(a, b) {
    $013c97a5603ef3be$var$Cf = $013c97a5603ef3be$var$dd;
    a = $013c97a5603ef3be$var$Me();
    if ($013c97a5603ef3be$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $013c97a5603ef3be$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $013c97a5603ef3be$var$dd = !1;
    for($013c97a5603ef3be$var$V = b; null !== $013c97a5603ef3be$var$V;)if (b = $013c97a5603ef3be$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $013c97a5603ef3be$var$V = a;
    else for(; null !== $013c97a5603ef3be$var$V;){
        b = $013c97a5603ef3be$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $013c97a5603ef3be$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($013c97a5603ef3be$var$p(163));
            }
        } catch (F) {
            $013c97a5603ef3be$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $013c97a5603ef3be$var$V = a;
            break;
        }
        $013c97a5603ef3be$var$V = b.return;
    }
    n = $013c97a5603ef3be$var$Nj;
    $013c97a5603ef3be$var$Nj = !1;
    return n;
}
function $013c97a5603ef3be$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $013c97a5603ef3be$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $013c97a5603ef3be$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $013c97a5603ef3be$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $013c97a5603ef3be$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $013c97a5603ef3be$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$013c97a5603ef3be$var$Of], delete b[$013c97a5603ef3be$var$Pf], delete b[$013c97a5603ef3be$var$of], delete b[$013c97a5603ef3be$var$Qf], delete b[$013c97a5603ef3be$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $013c97a5603ef3be$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $013c97a5603ef3be$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $013c97a5603ef3be$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $013c97a5603ef3be$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $013c97a5603ef3be$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($013c97a5603ef3be$var$Vj(a, b, c), a = a.sibling; null !== a;)$013c97a5603ef3be$var$Vj(a, b, c), a = a.sibling;
}
function $013c97a5603ef3be$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($013c97a5603ef3be$var$Wj(a, b, c), a = a.sibling; null !== a;)$013c97a5603ef3be$var$Wj(a, b, c), a = a.sibling;
}
var $013c97a5603ef3be$var$X = null, $013c97a5603ef3be$var$Xj = !1;
function $013c97a5603ef3be$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$013c97a5603ef3be$var$Zj(a, b, c), c = c.sibling;
}
function $013c97a5603ef3be$var$Zj(a, b, c) {
    if ($013c97a5603ef3be$var$lc && "function" === typeof $013c97a5603ef3be$var$lc.onCommitFiberUnmount) try {
        $013c97a5603ef3be$var$lc.onCommitFiberUnmount($013c97a5603ef3be$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $013c97a5603ef3be$var$U || $013c97a5603ef3be$var$Lj(c, b);
        case 6:
            var d = $013c97a5603ef3be$var$X, e = $013c97a5603ef3be$var$Xj;
            $013c97a5603ef3be$var$X = null;
            $013c97a5603ef3be$var$Yj(a, b, c);
            $013c97a5603ef3be$var$X = d;
            $013c97a5603ef3be$var$Xj = e;
            null !== $013c97a5603ef3be$var$X && ($013c97a5603ef3be$var$Xj ? (a = $013c97a5603ef3be$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $013c97a5603ef3be$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $013c97a5603ef3be$var$X && ($013c97a5603ef3be$var$Xj ? (a = $013c97a5603ef3be$var$X, c = c.stateNode, 8 === a.nodeType ? $013c97a5603ef3be$var$Kf(a.parentNode, c) : 1 === a.nodeType && $013c97a5603ef3be$var$Kf(a, c), $013c97a5603ef3be$var$bd(a)) : $013c97a5603ef3be$var$Kf($013c97a5603ef3be$var$X, c.stateNode));
            break;
        case 4:
            d = $013c97a5603ef3be$var$X;
            e = $013c97a5603ef3be$var$Xj;
            $013c97a5603ef3be$var$X = c.stateNode.containerInfo;
            $013c97a5603ef3be$var$Xj = !0;
            $013c97a5603ef3be$var$Yj(a, b, c);
            $013c97a5603ef3be$var$X = d;
            $013c97a5603ef3be$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$013c97a5603ef3be$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $013c97a5603ef3be$var$Mj(c, b, g) : 0 !== (f & 4) && $013c97a5603ef3be$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $013c97a5603ef3be$var$Yj(a, b, c);
            break;
        case 1:
            if (!$013c97a5603ef3be$var$U && ($013c97a5603ef3be$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $013c97a5603ef3be$var$W(c, b, h);
            }
            $013c97a5603ef3be$var$Yj(a, b, c);
            break;
        case 21:
            $013c97a5603ef3be$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($013c97a5603ef3be$var$U = (d = $013c97a5603ef3be$var$U) || null !== c.memoizedState, $013c97a5603ef3be$var$Yj(a, b, c), $013c97a5603ef3be$var$U = d) : $013c97a5603ef3be$var$Yj(a, b, c);
            break;
        default:
            $013c97a5603ef3be$var$Yj(a, b, c);
    }
}
function $013c97a5603ef3be$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $013c97a5603ef3be$var$Kj);
        b.forEach(function(b) {
            var d = $013c97a5603ef3be$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $013c97a5603ef3be$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $013c97a5603ef3be$var$X = h.stateNode;
                        $013c97a5603ef3be$var$Xj = !1;
                        break a;
                    case 3:
                        $013c97a5603ef3be$var$X = h.stateNode.containerInfo;
                        $013c97a5603ef3be$var$Xj = !0;
                        break a;
                    case 4:
                        $013c97a5603ef3be$var$X = h.stateNode.containerInfo;
                        $013c97a5603ef3be$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $013c97a5603ef3be$var$X) throw Error($013c97a5603ef3be$var$p(160));
            $013c97a5603ef3be$var$Zj(f, g, e);
            $013c97a5603ef3be$var$X = null;
            $013c97a5603ef3be$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $013c97a5603ef3be$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$013c97a5603ef3be$var$dk(b, a), b = b.sibling;
}
function $013c97a5603ef3be$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $013c97a5603ef3be$var$ck(b, a);
            $013c97a5603ef3be$var$ek(a);
            if (d & 4) {
                try {
                    $013c97a5603ef3be$var$Pj(3, a, a.return), $013c97a5603ef3be$var$Qj(3, a);
                } catch (t) {
                    $013c97a5603ef3be$var$W(a, a.return, t);
                }
                try {
                    $013c97a5603ef3be$var$Pj(5, a, a.return);
                } catch (t) {
                    $013c97a5603ef3be$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $013c97a5603ef3be$var$ck(b, a);
            $013c97a5603ef3be$var$ek(a);
            d & 512 && null !== c && $013c97a5603ef3be$var$Lj(c, c.return);
            break;
        case 5:
            $013c97a5603ef3be$var$ck(b, a);
            $013c97a5603ef3be$var$ek(a);
            d & 512 && null !== c && $013c97a5603ef3be$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $013c97a5603ef3be$var$ob(e, "");
                } catch (t) {
                    $013c97a5603ef3be$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $013c97a5603ef3be$var$ab(e, f);
                    $013c97a5603ef3be$var$vb(h, g);
                    var l = $013c97a5603ef3be$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $013c97a5603ef3be$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $013c97a5603ef3be$var$nb(e, q) : "children" === m ? $013c97a5603ef3be$var$ob(e, q) : $013c97a5603ef3be$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $013c97a5603ef3be$var$bb(e, f);
                            break;
                        case "textarea":
                            $013c97a5603ef3be$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $013c97a5603ef3be$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $013c97a5603ef3be$var$fb(e, !!f.multiple, f.defaultValue, !0) : $013c97a5603ef3be$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$013c97a5603ef3be$var$Pf] = f;
                } catch (t) {
                    $013c97a5603ef3be$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $013c97a5603ef3be$var$ck(b, a);
            $013c97a5603ef3be$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($013c97a5603ef3be$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $013c97a5603ef3be$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $013c97a5603ef3be$var$ck(b, a);
            $013c97a5603ef3be$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $013c97a5603ef3be$var$bd(b.containerInfo);
            } catch (t) {
                $013c97a5603ef3be$var$W(a, a.return, t);
            }
            break;
        case 4:
            $013c97a5603ef3be$var$ck(b, a);
            $013c97a5603ef3be$var$ek(a);
            break;
        case 13:
            $013c97a5603ef3be$var$ck(b, a);
            $013c97a5603ef3be$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($013c97a5603ef3be$var$fk = $013c97a5603ef3be$var$B()));
            d & 4 && $013c97a5603ef3be$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($013c97a5603ef3be$var$U = (l = $013c97a5603ef3be$var$U) || m, $013c97a5603ef3be$var$ck(b, a), $013c97a5603ef3be$var$U = l) : $013c97a5603ef3be$var$ck(b, a);
            $013c97a5603ef3be$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($013c97a5603ef3be$var$V = a, m = a.child; null !== m;){
                    for(q = $013c97a5603ef3be$var$V = m; null !== $013c97a5603ef3be$var$V;){
                        r = $013c97a5603ef3be$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $013c97a5603ef3be$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $013c97a5603ef3be$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $013c97a5603ef3be$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $013c97a5603ef3be$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $013c97a5603ef3be$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $013c97a5603ef3be$var$V = y) : $013c97a5603ef3be$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $013c97a5603ef3be$var$rb("display", g));
                            } catch (t) {
                                $013c97a5603ef3be$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $013c97a5603ef3be$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $013c97a5603ef3be$var$ck(b, a);
            $013c97a5603ef3be$var$ek(a);
            d & 4 && $013c97a5603ef3be$var$ak(a);
            break;
        case 21:
            break;
        default:
            $013c97a5603ef3be$var$ck(b, a), $013c97a5603ef3be$var$ek(a);
    }
}
function $013c97a5603ef3be$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($013c97a5603ef3be$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($013c97a5603ef3be$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($013c97a5603ef3be$var$ob(e, ""), d.flags &= -33);
                    var f = $013c97a5603ef3be$var$Uj(a);
                    $013c97a5603ef3be$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $013c97a5603ef3be$var$Uj(a);
                    $013c97a5603ef3be$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($013c97a5603ef3be$var$p(161));
            }
        } catch (k) {
            $013c97a5603ef3be$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $013c97a5603ef3be$var$hk(a, b, c) {
    $013c97a5603ef3be$var$V = a;
    $013c97a5603ef3be$var$ik(a, b, c);
}
function $013c97a5603ef3be$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $013c97a5603ef3be$var$V;){
        var e = $013c97a5603ef3be$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $013c97a5603ef3be$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $013c97a5603ef3be$var$U;
                h = $013c97a5603ef3be$var$Jj;
                var l = $013c97a5603ef3be$var$U;
                $013c97a5603ef3be$var$Jj = g;
                if (($013c97a5603ef3be$var$U = k) && !l) for($013c97a5603ef3be$var$V = e; null !== $013c97a5603ef3be$var$V;)g = $013c97a5603ef3be$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $013c97a5603ef3be$var$jk(e) : null !== k ? (k.return = g, $013c97a5603ef3be$var$V = k) : $013c97a5603ef3be$var$jk(e);
                for(; null !== f;)$013c97a5603ef3be$var$V = f, $013c97a5603ef3be$var$ik(f, b, c), f = f.sibling;
                $013c97a5603ef3be$var$V = e;
                $013c97a5603ef3be$var$Jj = h;
                $013c97a5603ef3be$var$U = l;
            }
            $013c97a5603ef3be$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $013c97a5603ef3be$var$V = f) : $013c97a5603ef3be$var$kk(a, b, c);
    }
}
function $013c97a5603ef3be$var$kk(a) {
    for(; null !== $013c97a5603ef3be$var$V;){
        var b = $013c97a5603ef3be$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $013c97a5603ef3be$var$U || $013c97a5603ef3be$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$013c97a5603ef3be$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $013c97a5603ef3be$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $013c97a5603ef3be$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $013c97a5603ef3be$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $013c97a5603ef3be$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($013c97a5603ef3be$var$p(163));
                }
                $013c97a5603ef3be$var$U || b.flags & 512 && $013c97a5603ef3be$var$Rj(b);
            } catch (r) {
                $013c97a5603ef3be$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $013c97a5603ef3be$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $013c97a5603ef3be$var$V = c;
            break;
        }
        $013c97a5603ef3be$var$V = b.return;
    }
}
function $013c97a5603ef3be$var$gk(a) {
    for(; null !== $013c97a5603ef3be$var$V;){
        var b = $013c97a5603ef3be$var$V;
        if (b === a) {
            $013c97a5603ef3be$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $013c97a5603ef3be$var$V = c;
            break;
        }
        $013c97a5603ef3be$var$V = b.return;
    }
}
function $013c97a5603ef3be$var$jk(a) {
    for(; null !== $013c97a5603ef3be$var$V;){
        var b = $013c97a5603ef3be$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $013c97a5603ef3be$var$Qj(4, b);
                    } catch (k) {
                        $013c97a5603ef3be$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $013c97a5603ef3be$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $013c97a5603ef3be$var$Rj(b);
                    } catch (k) {
                        $013c97a5603ef3be$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $013c97a5603ef3be$var$Rj(b);
                    } catch (k) {
                        $013c97a5603ef3be$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $013c97a5603ef3be$var$W(b, b.return, k);
        }
        if (b === a) {
            $013c97a5603ef3be$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $013c97a5603ef3be$var$V = h;
            break;
        }
        $013c97a5603ef3be$var$V = b.return;
    }
}
var $013c97a5603ef3be$var$lk = Math.ceil, $013c97a5603ef3be$var$mk = $013c97a5603ef3be$var$ua.ReactCurrentDispatcher, $013c97a5603ef3be$var$nk = $013c97a5603ef3be$var$ua.ReactCurrentOwner, $013c97a5603ef3be$var$ok = $013c97a5603ef3be$var$ua.ReactCurrentBatchConfig, $013c97a5603ef3be$var$K = 0, $013c97a5603ef3be$var$Q = null, $013c97a5603ef3be$var$Y = null, $013c97a5603ef3be$var$Z = 0, $013c97a5603ef3be$var$fj = 0, $013c97a5603ef3be$var$ej = $013c97a5603ef3be$var$Uf(0), $013c97a5603ef3be$var$T = 0, $013c97a5603ef3be$var$pk = null, $013c97a5603ef3be$var$rh = 0, $013c97a5603ef3be$var$qk = 0, $013c97a5603ef3be$var$rk = 0, $013c97a5603ef3be$var$sk = null, $013c97a5603ef3be$var$tk = null, $013c97a5603ef3be$var$fk = 0, $013c97a5603ef3be$var$Gj = Infinity, $013c97a5603ef3be$var$uk = null, $013c97a5603ef3be$var$Oi = !1, $013c97a5603ef3be$var$Pi = null, $013c97a5603ef3be$var$Ri = null, $013c97a5603ef3be$var$vk = !1, $013c97a5603ef3be$var$wk = null, $013c97a5603ef3be$var$xk = 0, $013c97a5603ef3be$var$yk = 0, $013c97a5603ef3be$var$zk = null, $013c97a5603ef3be$var$Ak = -1, $013c97a5603ef3be$var$Bk = 0;
function $013c97a5603ef3be$var$R() {
    return 0 !== ($013c97a5603ef3be$var$K & 6) ? $013c97a5603ef3be$var$B() : -1 !== $013c97a5603ef3be$var$Ak ? $013c97a5603ef3be$var$Ak : $013c97a5603ef3be$var$Ak = $013c97a5603ef3be$var$B();
}
function $013c97a5603ef3be$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($013c97a5603ef3be$var$K & 2) && 0 !== $013c97a5603ef3be$var$Z) return $013c97a5603ef3be$var$Z & -$013c97a5603ef3be$var$Z;
    if (null !== $013c97a5603ef3be$var$Kg.transition) return 0 === $013c97a5603ef3be$var$Bk && ($013c97a5603ef3be$var$Bk = $013c97a5603ef3be$var$yc()), $013c97a5603ef3be$var$Bk;
    a = $013c97a5603ef3be$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $013c97a5603ef3be$var$jd(a.type);
    return a;
}
function $013c97a5603ef3be$var$gi(a, b, c, d) {
    if (50 < $013c97a5603ef3be$var$yk) throw $013c97a5603ef3be$var$yk = 0, $013c97a5603ef3be$var$zk = null, Error($013c97a5603ef3be$var$p(185));
    $013c97a5603ef3be$var$Ac(a, c, d);
    if (0 === ($013c97a5603ef3be$var$K & 2) || a !== $013c97a5603ef3be$var$Q) a === $013c97a5603ef3be$var$Q && (0 === ($013c97a5603ef3be$var$K & 2) && ($013c97a5603ef3be$var$qk |= c), 4 === $013c97a5603ef3be$var$T && $013c97a5603ef3be$var$Ck(a, $013c97a5603ef3be$var$Z)), $013c97a5603ef3be$var$Dk(a, d), 1 === c && 0 === $013c97a5603ef3be$var$K && 0 === (b.mode & 1) && ($013c97a5603ef3be$var$Gj = $013c97a5603ef3be$var$B() + 500, $013c97a5603ef3be$var$fg && $013c97a5603ef3be$var$jg());
}
function $013c97a5603ef3be$var$Dk(a, b) {
    var c = a.callbackNode;
    $013c97a5603ef3be$var$wc(a, b);
    var d = $013c97a5603ef3be$var$uc(a, a === $013c97a5603ef3be$var$Q ? $013c97a5603ef3be$var$Z : 0);
    if (0 === d) null !== c && $013c97a5603ef3be$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $013c97a5603ef3be$var$bc(c);
        if (1 === b) 0 === a.tag ? $013c97a5603ef3be$var$ig($013c97a5603ef3be$var$Ek.bind(null, a)) : $013c97a5603ef3be$var$hg($013c97a5603ef3be$var$Ek.bind(null, a)), $013c97a5603ef3be$var$Jf(function() {
            0 === ($013c97a5603ef3be$var$K & 6) && $013c97a5603ef3be$var$jg();
        }), c = null;
        else {
            switch($013c97a5603ef3be$var$Dc(d)){
                case 1:
                    c = $013c97a5603ef3be$var$fc;
                    break;
                case 4:
                    c = $013c97a5603ef3be$var$gc;
                    break;
                case 16:
                    c = $013c97a5603ef3be$var$hc;
                    break;
                case 536870912:
                    c = $013c97a5603ef3be$var$jc;
                    break;
                default:
                    c = $013c97a5603ef3be$var$hc;
            }
            c = $013c97a5603ef3be$var$Fk(c, $013c97a5603ef3be$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $013c97a5603ef3be$var$Gk(a, b) {
    $013c97a5603ef3be$var$Ak = -1;
    $013c97a5603ef3be$var$Bk = 0;
    if (0 !== ($013c97a5603ef3be$var$K & 6)) throw Error($013c97a5603ef3be$var$p(327));
    var c = a.callbackNode;
    if ($013c97a5603ef3be$var$Hk() && a.callbackNode !== c) return null;
    var d = $013c97a5603ef3be$var$uc(a, a === $013c97a5603ef3be$var$Q ? $013c97a5603ef3be$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $013c97a5603ef3be$var$Ik(a, d);
    else {
        b = d;
        var e = $013c97a5603ef3be$var$K;
        $013c97a5603ef3be$var$K |= 2;
        var f = $013c97a5603ef3be$var$Jk();
        if ($013c97a5603ef3be$var$Q !== a || $013c97a5603ef3be$var$Z !== b) $013c97a5603ef3be$var$uk = null, $013c97a5603ef3be$var$Gj = $013c97a5603ef3be$var$B() + 500, $013c97a5603ef3be$var$Kk(a, b);
        for(;;)try {
            $013c97a5603ef3be$var$Lk();
            break;
        } catch (h) {
            $013c97a5603ef3be$var$Mk(a, h);
        }
        $013c97a5603ef3be$var$$g();
        $013c97a5603ef3be$var$mk.current = f;
        $013c97a5603ef3be$var$K = e;
        null !== $013c97a5603ef3be$var$Y ? b = 0 : ($013c97a5603ef3be$var$Q = null, $013c97a5603ef3be$var$Z = 0, b = $013c97a5603ef3be$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $013c97a5603ef3be$var$xc(a), 0 !== e && (d = e, b = $013c97a5603ef3be$var$Nk(a, e)));
        if (1 === b) throw c = $013c97a5603ef3be$var$pk, $013c97a5603ef3be$var$Kk(a, 0), $013c97a5603ef3be$var$Ck(a, d), $013c97a5603ef3be$var$Dk(a, $013c97a5603ef3be$var$B()), c;
        if (6 === b) $013c97a5603ef3be$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$013c97a5603ef3be$var$Ok(e) && (b = $013c97a5603ef3be$var$Ik(a, d), 2 === b && (f = $013c97a5603ef3be$var$xc(a), 0 !== f && (d = f, b = $013c97a5603ef3be$var$Nk(a, f))), 1 === b)) throw c = $013c97a5603ef3be$var$pk, $013c97a5603ef3be$var$Kk(a, 0), $013c97a5603ef3be$var$Ck(a, d), $013c97a5603ef3be$var$Dk(a, $013c97a5603ef3be$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($013c97a5603ef3be$var$p(345));
                case 2:
                    $013c97a5603ef3be$var$Pk(a, $013c97a5603ef3be$var$tk, $013c97a5603ef3be$var$uk);
                    break;
                case 3:
                    $013c97a5603ef3be$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $013c97a5603ef3be$var$fk + 500 - $013c97a5603ef3be$var$B(), 10 < b)) {
                        if (0 !== $013c97a5603ef3be$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $013c97a5603ef3be$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $013c97a5603ef3be$var$Ff($013c97a5603ef3be$var$Pk.bind(null, a, $013c97a5603ef3be$var$tk, $013c97a5603ef3be$var$uk), b);
                        break;
                    }
                    $013c97a5603ef3be$var$Pk(a, $013c97a5603ef3be$var$tk, $013c97a5603ef3be$var$uk);
                    break;
                case 4:
                    $013c97a5603ef3be$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $013c97a5603ef3be$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $013c97a5603ef3be$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $013c97a5603ef3be$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $013c97a5603ef3be$var$Ff($013c97a5603ef3be$var$Pk.bind(null, a, $013c97a5603ef3be$var$tk, $013c97a5603ef3be$var$uk), d);
                        break;
                    }
                    $013c97a5603ef3be$var$Pk(a, $013c97a5603ef3be$var$tk, $013c97a5603ef3be$var$uk);
                    break;
                case 5:
                    $013c97a5603ef3be$var$Pk(a, $013c97a5603ef3be$var$tk, $013c97a5603ef3be$var$uk);
                    break;
                default:
                    throw Error($013c97a5603ef3be$var$p(329));
            }
        }
    }
    $013c97a5603ef3be$var$Dk(a, $013c97a5603ef3be$var$B());
    return a.callbackNode === c ? $013c97a5603ef3be$var$Gk.bind(null, a) : null;
}
function $013c97a5603ef3be$var$Nk(a, b) {
    var c = $013c97a5603ef3be$var$sk;
    a.current.memoizedState.isDehydrated && ($013c97a5603ef3be$var$Kk(a, b).flags |= 256);
    a = $013c97a5603ef3be$var$Ik(a, b);
    2 !== a && (b = $013c97a5603ef3be$var$tk, $013c97a5603ef3be$var$tk = c, null !== b && $013c97a5603ef3be$var$Fj(b));
    return a;
}
function $013c97a5603ef3be$var$Fj(a) {
    null === $013c97a5603ef3be$var$tk ? $013c97a5603ef3be$var$tk = a : $013c97a5603ef3be$var$tk.push.apply($013c97a5603ef3be$var$tk, a);
}
function $013c97a5603ef3be$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$013c97a5603ef3be$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $013c97a5603ef3be$var$Ck(a, b) {
    b &= ~$013c97a5603ef3be$var$rk;
    b &= ~$013c97a5603ef3be$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $013c97a5603ef3be$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $013c97a5603ef3be$var$Ek(a) {
    if (0 !== ($013c97a5603ef3be$var$K & 6)) throw Error($013c97a5603ef3be$var$p(327));
    $013c97a5603ef3be$var$Hk();
    var b = $013c97a5603ef3be$var$uc(a, 0);
    if (0 === (b & 1)) return $013c97a5603ef3be$var$Dk(a, $013c97a5603ef3be$var$B()), null;
    var c = $013c97a5603ef3be$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $013c97a5603ef3be$var$xc(a);
        0 !== d && (b = d, c = $013c97a5603ef3be$var$Nk(a, d));
    }
    if (1 === c) throw c = $013c97a5603ef3be$var$pk, $013c97a5603ef3be$var$Kk(a, 0), $013c97a5603ef3be$var$Ck(a, b), $013c97a5603ef3be$var$Dk(a, $013c97a5603ef3be$var$B()), c;
    if (6 === c) throw Error($013c97a5603ef3be$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $013c97a5603ef3be$var$Pk(a, $013c97a5603ef3be$var$tk, $013c97a5603ef3be$var$uk);
    $013c97a5603ef3be$var$Dk(a, $013c97a5603ef3be$var$B());
    return null;
}
function $013c97a5603ef3be$var$Qk(a, b) {
    var c = $013c97a5603ef3be$var$K;
    $013c97a5603ef3be$var$K |= 1;
    try {
        return a(b);
    } finally{
        $013c97a5603ef3be$var$K = c, 0 === $013c97a5603ef3be$var$K && ($013c97a5603ef3be$var$Gj = $013c97a5603ef3be$var$B() + 500, $013c97a5603ef3be$var$fg && $013c97a5603ef3be$var$jg());
    }
}
function $013c97a5603ef3be$var$Rk(a) {
    null !== $013c97a5603ef3be$var$wk && 0 === $013c97a5603ef3be$var$wk.tag && 0 === ($013c97a5603ef3be$var$K & 6) && $013c97a5603ef3be$var$Hk();
    var b = $013c97a5603ef3be$var$K;
    $013c97a5603ef3be$var$K |= 1;
    var c = $013c97a5603ef3be$var$ok.transition, d = $013c97a5603ef3be$var$C;
    try {
        if ($013c97a5603ef3be$var$ok.transition = null, $013c97a5603ef3be$var$C = 1, a) return a();
    } finally{
        $013c97a5603ef3be$var$C = d, $013c97a5603ef3be$var$ok.transition = c, $013c97a5603ef3be$var$K = b, 0 === ($013c97a5603ef3be$var$K & 6) && $013c97a5603ef3be$var$jg();
    }
}
function $013c97a5603ef3be$var$Hj() {
    $013c97a5603ef3be$var$fj = $013c97a5603ef3be$var$ej.current;
    $013c97a5603ef3be$var$E($013c97a5603ef3be$var$ej);
}
function $013c97a5603ef3be$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $013c97a5603ef3be$var$Gf(c));
    if (null !== $013c97a5603ef3be$var$Y) for(c = $013c97a5603ef3be$var$Y.return; null !== c;){
        var d = c;
        $013c97a5603ef3be$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $013c97a5603ef3be$var$$f();
                break;
            case 3:
                $013c97a5603ef3be$var$zh();
                $013c97a5603ef3be$var$E($013c97a5603ef3be$var$Wf);
                $013c97a5603ef3be$var$E($013c97a5603ef3be$var$H);
                $013c97a5603ef3be$var$Eh();
                break;
            case 5:
                $013c97a5603ef3be$var$Bh(d);
                break;
            case 4:
                $013c97a5603ef3be$var$zh();
                break;
            case 13:
                $013c97a5603ef3be$var$E($013c97a5603ef3be$var$L);
                break;
            case 19:
                $013c97a5603ef3be$var$E($013c97a5603ef3be$var$L);
                break;
            case 10:
                $013c97a5603ef3be$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $013c97a5603ef3be$var$Hj();
        }
        c = c.return;
    }
    $013c97a5603ef3be$var$Q = a;
    $013c97a5603ef3be$var$Y = a = $013c97a5603ef3be$var$Pg(a.current, null);
    $013c97a5603ef3be$var$Z = $013c97a5603ef3be$var$fj = b;
    $013c97a5603ef3be$var$T = 0;
    $013c97a5603ef3be$var$pk = null;
    $013c97a5603ef3be$var$rk = $013c97a5603ef3be$var$qk = $013c97a5603ef3be$var$rh = 0;
    $013c97a5603ef3be$var$tk = $013c97a5603ef3be$var$sk = null;
    if (null !== $013c97a5603ef3be$var$fh) {
        for(b = 0; b < $013c97a5603ef3be$var$fh.length; b++)if (c = $013c97a5603ef3be$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $013c97a5603ef3be$var$fh = null;
    }
    return a;
}
function $013c97a5603ef3be$var$Mk(a, b) {
    do {
        var c = $013c97a5603ef3be$var$Y;
        try {
            $013c97a5603ef3be$var$$g();
            $013c97a5603ef3be$var$Fh.current = $013c97a5603ef3be$var$Rh;
            if ($013c97a5603ef3be$var$Ih) {
                for(var d = $013c97a5603ef3be$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $013c97a5603ef3be$var$Ih = !1;
            }
            $013c97a5603ef3be$var$Hh = 0;
            $013c97a5603ef3be$var$O = $013c97a5603ef3be$var$N = $013c97a5603ef3be$var$M = null;
            $013c97a5603ef3be$var$Jh = !1;
            $013c97a5603ef3be$var$Kh = 0;
            $013c97a5603ef3be$var$nk.current = null;
            if (null === c || null === c.return) {
                $013c97a5603ef3be$var$T = 1;
                $013c97a5603ef3be$var$pk = b;
                $013c97a5603ef3be$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $013c97a5603ef3be$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $013c97a5603ef3be$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $013c97a5603ef3be$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $013c97a5603ef3be$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $013c97a5603ef3be$var$Si(f, l, b);
                            $013c97a5603ef3be$var$tj();
                            break a;
                        }
                        k = Error($013c97a5603ef3be$var$p(426));
                    }
                } else if ($013c97a5603ef3be$var$I && h.mode & 1) {
                    var J = $013c97a5603ef3be$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $013c97a5603ef3be$var$Vi(J, g, h, f, b);
                        $013c97a5603ef3be$var$Jg($013c97a5603ef3be$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $013c97a5603ef3be$var$Ji(k, h);
                4 !== $013c97a5603ef3be$var$T && ($013c97a5603ef3be$var$T = 2);
                null === $013c97a5603ef3be$var$sk ? $013c97a5603ef3be$var$sk = [
                    f
                ] : $013c97a5603ef3be$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $013c97a5603ef3be$var$Ni(f, k, b);
                            $013c97a5603ef3be$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $013c97a5603ef3be$var$Ri || !$013c97a5603ef3be$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $013c97a5603ef3be$var$Qi(f, h, b);
                                $013c97a5603ef3be$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $013c97a5603ef3be$var$Sk(c);
        } catch (na) {
            b = na;
            $013c97a5603ef3be$var$Y === c && null !== c && ($013c97a5603ef3be$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $013c97a5603ef3be$var$Jk() {
    var a = $013c97a5603ef3be$var$mk.current;
    $013c97a5603ef3be$var$mk.current = $013c97a5603ef3be$var$Rh;
    return null === a ? $013c97a5603ef3be$var$Rh : a;
}
function $013c97a5603ef3be$var$tj() {
    if (0 === $013c97a5603ef3be$var$T || 3 === $013c97a5603ef3be$var$T || 2 === $013c97a5603ef3be$var$T) $013c97a5603ef3be$var$T = 4;
    null === $013c97a5603ef3be$var$Q || 0 === ($013c97a5603ef3be$var$rh & 268435455) && 0 === ($013c97a5603ef3be$var$qk & 268435455) || $013c97a5603ef3be$var$Ck($013c97a5603ef3be$var$Q, $013c97a5603ef3be$var$Z);
}
function $013c97a5603ef3be$var$Ik(a, b) {
    var c = $013c97a5603ef3be$var$K;
    $013c97a5603ef3be$var$K |= 2;
    var d = $013c97a5603ef3be$var$Jk();
    if ($013c97a5603ef3be$var$Q !== a || $013c97a5603ef3be$var$Z !== b) $013c97a5603ef3be$var$uk = null, $013c97a5603ef3be$var$Kk(a, b);
    for(;;)try {
        $013c97a5603ef3be$var$Tk();
        break;
    } catch (e) {
        $013c97a5603ef3be$var$Mk(a, e);
    }
    $013c97a5603ef3be$var$$g();
    $013c97a5603ef3be$var$K = c;
    $013c97a5603ef3be$var$mk.current = d;
    if (null !== $013c97a5603ef3be$var$Y) throw Error($013c97a5603ef3be$var$p(261));
    $013c97a5603ef3be$var$Q = null;
    $013c97a5603ef3be$var$Z = 0;
    return $013c97a5603ef3be$var$T;
}
function $013c97a5603ef3be$var$Tk() {
    for(; null !== $013c97a5603ef3be$var$Y;)$013c97a5603ef3be$var$Uk($013c97a5603ef3be$var$Y);
}
function $013c97a5603ef3be$var$Lk() {
    for(; null !== $013c97a5603ef3be$var$Y && !$013c97a5603ef3be$var$cc();)$013c97a5603ef3be$var$Uk($013c97a5603ef3be$var$Y);
}
function $013c97a5603ef3be$var$Uk(a) {
    var b = $013c97a5603ef3be$var$Vk(a.alternate, a, $013c97a5603ef3be$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $013c97a5603ef3be$var$Sk(a) : $013c97a5603ef3be$var$Y = b;
    $013c97a5603ef3be$var$nk.current = null;
}
function $013c97a5603ef3be$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $013c97a5603ef3be$var$Ej(c, b, $013c97a5603ef3be$var$fj), null !== c) {
                $013c97a5603ef3be$var$Y = c;
                return;
            }
        } else {
            c = $013c97a5603ef3be$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $013c97a5603ef3be$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $013c97a5603ef3be$var$T = 6;
                $013c97a5603ef3be$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $013c97a5603ef3be$var$Y = b;
            return;
        }
        $013c97a5603ef3be$var$Y = b = a;
    }while (null !== b);
    0 === $013c97a5603ef3be$var$T && ($013c97a5603ef3be$var$T = 5);
}
function $013c97a5603ef3be$var$Pk(a, b, c) {
    var d = $013c97a5603ef3be$var$C, e = $013c97a5603ef3be$var$ok.transition;
    try {
        $013c97a5603ef3be$var$ok.transition = null, $013c97a5603ef3be$var$C = 1, $013c97a5603ef3be$var$Wk(a, b, c, d);
    } finally{
        $013c97a5603ef3be$var$ok.transition = e, $013c97a5603ef3be$var$C = d;
    }
    return null;
}
function $013c97a5603ef3be$var$Wk(a, b, c, d) {
    do $013c97a5603ef3be$var$Hk();
    while (null !== $013c97a5603ef3be$var$wk);
    if (0 !== ($013c97a5603ef3be$var$K & 6)) throw Error($013c97a5603ef3be$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($013c97a5603ef3be$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $013c97a5603ef3be$var$Bc(a, f);
    a === $013c97a5603ef3be$var$Q && ($013c97a5603ef3be$var$Y = $013c97a5603ef3be$var$Q = null, $013c97a5603ef3be$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $013c97a5603ef3be$var$vk || ($013c97a5603ef3be$var$vk = !0, $013c97a5603ef3be$var$Fk($013c97a5603ef3be$var$hc, function() {
        $013c97a5603ef3be$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $013c97a5603ef3be$var$ok.transition;
        $013c97a5603ef3be$var$ok.transition = null;
        var g = $013c97a5603ef3be$var$C;
        $013c97a5603ef3be$var$C = 1;
        var h = $013c97a5603ef3be$var$K;
        $013c97a5603ef3be$var$K |= 4;
        $013c97a5603ef3be$var$nk.current = null;
        $013c97a5603ef3be$var$Oj(a, c);
        $013c97a5603ef3be$var$dk(c, a);
        $013c97a5603ef3be$var$Oe($013c97a5603ef3be$var$Df);
        $013c97a5603ef3be$var$dd = !!$013c97a5603ef3be$var$Cf;
        $013c97a5603ef3be$var$Df = $013c97a5603ef3be$var$Cf = null;
        a.current = c;
        $013c97a5603ef3be$var$hk(c, a, e);
        $013c97a5603ef3be$var$dc();
        $013c97a5603ef3be$var$K = h;
        $013c97a5603ef3be$var$C = g;
        $013c97a5603ef3be$var$ok.transition = f;
    } else a.current = c;
    $013c97a5603ef3be$var$vk && ($013c97a5603ef3be$var$vk = !1, $013c97a5603ef3be$var$wk = a, $013c97a5603ef3be$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($013c97a5603ef3be$var$Ri = null);
    $013c97a5603ef3be$var$mc(c.stateNode, d);
    $013c97a5603ef3be$var$Dk(a, $013c97a5603ef3be$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($013c97a5603ef3be$var$Oi) throw $013c97a5603ef3be$var$Oi = !1, a = $013c97a5603ef3be$var$Pi, $013c97a5603ef3be$var$Pi = null, a;
    0 !== ($013c97a5603ef3be$var$xk & 1) && 0 !== a.tag && $013c97a5603ef3be$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $013c97a5603ef3be$var$zk ? $013c97a5603ef3be$var$yk++ : ($013c97a5603ef3be$var$yk = 0, $013c97a5603ef3be$var$zk = a) : $013c97a5603ef3be$var$yk = 0;
    $013c97a5603ef3be$var$jg();
    return null;
}
function $013c97a5603ef3be$var$Hk() {
    if (null !== $013c97a5603ef3be$var$wk) {
        var a = $013c97a5603ef3be$var$Dc($013c97a5603ef3be$var$xk), b = $013c97a5603ef3be$var$ok.transition, c = $013c97a5603ef3be$var$C;
        try {
            $013c97a5603ef3be$var$ok.transition = null;
            $013c97a5603ef3be$var$C = 16 > a ? 16 : a;
            if (null === $013c97a5603ef3be$var$wk) var d = !1;
            else {
                a = $013c97a5603ef3be$var$wk;
                $013c97a5603ef3be$var$wk = null;
                $013c97a5603ef3be$var$xk = 0;
                if (0 !== ($013c97a5603ef3be$var$K & 6)) throw Error($013c97a5603ef3be$var$p(331));
                var e = $013c97a5603ef3be$var$K;
                $013c97a5603ef3be$var$K |= 4;
                for($013c97a5603ef3be$var$V = a.current; null !== $013c97a5603ef3be$var$V;){
                    var f = $013c97a5603ef3be$var$V, g = f.child;
                    if (0 !== ($013c97a5603ef3be$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($013c97a5603ef3be$var$V = l; null !== $013c97a5603ef3be$var$V;){
                                    var m = $013c97a5603ef3be$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $013c97a5603ef3be$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $013c97a5603ef3be$var$V = q;
                                    else for(; null !== $013c97a5603ef3be$var$V;){
                                        m = $013c97a5603ef3be$var$V;
                                        var r = m.sibling, y = m.return;
                                        $013c97a5603ef3be$var$Sj(m);
                                        if (m === l) {
                                            $013c97a5603ef3be$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $013c97a5603ef3be$var$V = r;
                                            break;
                                        }
                                        $013c97a5603ef3be$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $013c97a5603ef3be$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $013c97a5603ef3be$var$V = g;
                    else b: for(; null !== $013c97a5603ef3be$var$V;){
                        f = $013c97a5603ef3be$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $013c97a5603ef3be$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $013c97a5603ef3be$var$V = x;
                            break b;
                        }
                        $013c97a5603ef3be$var$V = f.return;
                    }
                }
                var w = a.current;
                for($013c97a5603ef3be$var$V = w; null !== $013c97a5603ef3be$var$V;){
                    g = $013c97a5603ef3be$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $013c97a5603ef3be$var$V = u;
                    else b: for(g = w; null !== $013c97a5603ef3be$var$V;){
                        h = $013c97a5603ef3be$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $013c97a5603ef3be$var$Qj(9, h);
                            }
                        } catch (na) {
                            $013c97a5603ef3be$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $013c97a5603ef3be$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $013c97a5603ef3be$var$V = F;
                            break b;
                        }
                        $013c97a5603ef3be$var$V = h.return;
                    }
                }
                $013c97a5603ef3be$var$K = e;
                $013c97a5603ef3be$var$jg();
                if ($013c97a5603ef3be$var$lc && "function" === typeof $013c97a5603ef3be$var$lc.onPostCommitFiberRoot) try {
                    $013c97a5603ef3be$var$lc.onPostCommitFiberRoot($013c97a5603ef3be$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $013c97a5603ef3be$var$C = c, $013c97a5603ef3be$var$ok.transition = b;
        }
    }
    return !1;
}
function $013c97a5603ef3be$var$Xk(a, b, c) {
    b = $013c97a5603ef3be$var$Ji(c, b);
    b = $013c97a5603ef3be$var$Ni(a, b, 1);
    a = $013c97a5603ef3be$var$nh(a, b, 1);
    b = $013c97a5603ef3be$var$R();
    null !== a && ($013c97a5603ef3be$var$Ac(a, 1, b), $013c97a5603ef3be$var$Dk(a, b));
}
function $013c97a5603ef3be$var$W(a, b, c) {
    if (3 === a.tag) $013c97a5603ef3be$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $013c97a5603ef3be$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $013c97a5603ef3be$var$Ri || !$013c97a5603ef3be$var$Ri.has(d))) {
                a = $013c97a5603ef3be$var$Ji(c, a);
                a = $013c97a5603ef3be$var$Qi(b, a, 1);
                b = $013c97a5603ef3be$var$nh(b, a, 1);
                a = $013c97a5603ef3be$var$R();
                null !== b && ($013c97a5603ef3be$var$Ac(b, 1, a), $013c97a5603ef3be$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $013c97a5603ef3be$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $013c97a5603ef3be$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $013c97a5603ef3be$var$Q === a && ($013c97a5603ef3be$var$Z & c) === c && (4 === $013c97a5603ef3be$var$T || 3 === $013c97a5603ef3be$var$T && ($013c97a5603ef3be$var$Z & 130023424) === $013c97a5603ef3be$var$Z && 500 > $013c97a5603ef3be$var$B() - $013c97a5603ef3be$var$fk ? $013c97a5603ef3be$var$Kk(a, 0) : $013c97a5603ef3be$var$rk |= c);
    $013c97a5603ef3be$var$Dk(a, b);
}
function $013c97a5603ef3be$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $013c97a5603ef3be$var$sc, $013c97a5603ef3be$var$sc <<= 1, 0 === ($013c97a5603ef3be$var$sc & 130023424) && ($013c97a5603ef3be$var$sc = 4194304)));
    var c = $013c97a5603ef3be$var$R();
    a = $013c97a5603ef3be$var$ih(a, b);
    null !== a && ($013c97a5603ef3be$var$Ac(a, b, c), $013c97a5603ef3be$var$Dk(a, c));
}
function $013c97a5603ef3be$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $013c97a5603ef3be$var$Yk(a, c);
}
function $013c97a5603ef3be$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($013c97a5603ef3be$var$p(314));
    }
    null !== d && d.delete(b);
    $013c97a5603ef3be$var$Yk(a, c);
}
var $013c97a5603ef3be$var$Vk;
$013c97a5603ef3be$var$Vk = function Vk(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $013c97a5603ef3be$var$Wf.current) $013c97a5603ef3be$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $013c97a5603ef3be$var$dh = !1, $013c97a5603ef3be$var$yj(a, b, c);
            $013c97a5603ef3be$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $013c97a5603ef3be$var$dh = !1, $013c97a5603ef3be$var$I && 0 !== (b.flags & 1048576) && $013c97a5603ef3be$var$ug(b, $013c97a5603ef3be$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $013c97a5603ef3be$var$ij(a, b);
            a = b.pendingProps;
            var e = $013c97a5603ef3be$var$Yf(b, $013c97a5603ef3be$var$H.current);
            $013c97a5603ef3be$var$ch(b, c);
            e = $013c97a5603ef3be$var$Nh(null, b, d, a, e, c);
            var f = $013c97a5603ef3be$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $013c97a5603ef3be$var$Zf(d) ? (f = !0, $013c97a5603ef3be$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $013c97a5603ef3be$var$kh(b), e.updater = $013c97a5603ef3be$var$Ei, b.stateNode = e, e._reactInternals = b, $013c97a5603ef3be$var$Ii(b, d, a, c), b = $013c97a5603ef3be$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $013c97a5603ef3be$var$I && f && $013c97a5603ef3be$var$vg(b), $013c97a5603ef3be$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $013c97a5603ef3be$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $013c97a5603ef3be$var$Zk(d);
                a = $013c97a5603ef3be$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $013c97a5603ef3be$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $013c97a5603ef3be$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $013c97a5603ef3be$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $013c97a5603ef3be$var$$i(null, b, d, $013c97a5603ef3be$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($013c97a5603ef3be$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $013c97a5603ef3be$var$Ci(d, e), $013c97a5603ef3be$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $013c97a5603ef3be$var$Ci(d, e), $013c97a5603ef3be$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $013c97a5603ef3be$var$kj(b);
                if (null === a) throw Error($013c97a5603ef3be$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $013c97a5603ef3be$var$lh(a, b);
                $013c97a5603ef3be$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $013c97a5603ef3be$var$Ji(Error($013c97a5603ef3be$var$p(423)), b);
                        b = $013c97a5603ef3be$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $013c97a5603ef3be$var$Ji(Error($013c97a5603ef3be$var$p(424)), b);
                        b = $013c97a5603ef3be$var$lj(a, b, d, c, e);
                        break a;
                    } else for($013c97a5603ef3be$var$yg = $013c97a5603ef3be$var$Lf(b.stateNode.containerInfo.firstChild), $013c97a5603ef3be$var$xg = b, $013c97a5603ef3be$var$I = !0, $013c97a5603ef3be$var$zg = null, c = $013c97a5603ef3be$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $013c97a5603ef3be$var$Ig();
                    if (d === e) {
                        b = $013c97a5603ef3be$var$Zi(a, b, c);
                        break a;
                    }
                    $013c97a5603ef3be$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $013c97a5603ef3be$var$Ah(b), null === a && $013c97a5603ef3be$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $013c97a5603ef3be$var$Ef(d, e) ? g = null : null !== f && $013c97a5603ef3be$var$Ef(d, f) && (b.flags |= 32), $013c97a5603ef3be$var$gj(a, b), $013c97a5603ef3be$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $013c97a5603ef3be$var$Eg(b), null;
        case 13:
            return $013c97a5603ef3be$var$oj(a, b, c);
        case 4:
            return $013c97a5603ef3be$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $013c97a5603ef3be$var$Ug(b, null, d, c) : $013c97a5603ef3be$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $013c97a5603ef3be$var$Ci(d, e), $013c97a5603ef3be$var$Yi(a, b, d, e, c);
        case 7:
            return $013c97a5603ef3be$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $013c97a5603ef3be$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $013c97a5603ef3be$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $013c97a5603ef3be$var$G($013c97a5603ef3be$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($013c97a5603ef3be$var$He(f.value, g)) {
                        if (f.children === e.children && !$013c97a5603ef3be$var$Wf.current) {
                            b = $013c97a5603ef3be$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $013c97a5603ef3be$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $013c97a5603ef3be$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($013c97a5603ef3be$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $013c97a5603ef3be$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $013c97a5603ef3be$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $013c97a5603ef3be$var$ch(b, c), e = $013c97a5603ef3be$var$eh(e), d = d(e), b.flags |= 1, $013c97a5603ef3be$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $013c97a5603ef3be$var$Ci(d, b.pendingProps), e = $013c97a5603ef3be$var$Ci(d.type, e), $013c97a5603ef3be$var$$i(a, b, d, e, c);
        case 15:
            return $013c97a5603ef3be$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $013c97a5603ef3be$var$Ci(d, e), $013c97a5603ef3be$var$ij(a, b), b.tag = 1, $013c97a5603ef3be$var$Zf(d) ? (a = !0, $013c97a5603ef3be$var$cg(b)) : a = !1, $013c97a5603ef3be$var$ch(b, c), $013c97a5603ef3be$var$Gi(b, d, e), $013c97a5603ef3be$var$Ii(b, d, e, c), $013c97a5603ef3be$var$jj(null, b, d, !0, a, c);
        case 19:
            return $013c97a5603ef3be$var$xj(a, b, c);
        case 22:
            return $013c97a5603ef3be$var$dj(a, b, c);
    }
    throw Error($013c97a5603ef3be$var$p(156, b.tag));
};
function $013c97a5603ef3be$var$Fk(a, b) {
    return $013c97a5603ef3be$var$ac(a, b);
}
function $013c97a5603ef3be$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $013c97a5603ef3be$var$Bg(a, b, c, d) {
    return new $013c97a5603ef3be$var$$k(a, b, c, d);
}
function $013c97a5603ef3be$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $013c97a5603ef3be$var$Zk(a) {
    if ("function" === typeof a) return $013c97a5603ef3be$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $013c97a5603ef3be$var$Da) return 11;
        if (a === $013c97a5603ef3be$var$Ga) return 14;
    }
    return 2;
}
function $013c97a5603ef3be$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $013c97a5603ef3be$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $013c97a5603ef3be$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $013c97a5603ef3be$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $013c97a5603ef3be$var$ya:
            return $013c97a5603ef3be$var$Tg(c.children, e, f, b);
        case $013c97a5603ef3be$var$za:
            g = 8;
            e |= 8;
            break;
        case $013c97a5603ef3be$var$Aa:
            return a = $013c97a5603ef3be$var$Bg(12, c, b, e | 2), a.elementType = $013c97a5603ef3be$var$Aa, a.lanes = f, a;
        case $013c97a5603ef3be$var$Ea:
            return a = $013c97a5603ef3be$var$Bg(13, c, b, e), a.elementType = $013c97a5603ef3be$var$Ea, a.lanes = f, a;
        case $013c97a5603ef3be$var$Fa:
            return a = $013c97a5603ef3be$var$Bg(19, c, b, e), a.elementType = $013c97a5603ef3be$var$Fa, a.lanes = f, a;
        case $013c97a5603ef3be$var$Ia:
            return $013c97a5603ef3be$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $013c97a5603ef3be$var$Ba:
                    g = 10;
                    break a;
                case $013c97a5603ef3be$var$Ca:
                    g = 9;
                    break a;
                case $013c97a5603ef3be$var$Da:
                    g = 11;
                    break a;
                case $013c97a5603ef3be$var$Ga:
                    g = 14;
                    break a;
                case $013c97a5603ef3be$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($013c97a5603ef3be$var$p(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, $l0HdX._)(a), ""));
    }
    b = $013c97a5603ef3be$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $013c97a5603ef3be$var$Tg(a, b, c, d) {
    a = $013c97a5603ef3be$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $013c97a5603ef3be$var$pj(a, b, c, d) {
    a = $013c97a5603ef3be$var$Bg(22, a, d, b);
    a.elementType = $013c97a5603ef3be$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $013c97a5603ef3be$var$Qg(a, b, c) {
    a = $013c97a5603ef3be$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $013c97a5603ef3be$var$Sg(a, b, c) {
    b = $013c97a5603ef3be$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $013c97a5603ef3be$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $013c97a5603ef3be$var$zc(0);
    this.expirationTimes = $013c97a5603ef3be$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $013c97a5603ef3be$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $013c97a5603ef3be$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $013c97a5603ef3be$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $013c97a5603ef3be$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $013c97a5603ef3be$var$kh(f);
    return a;
}
function $013c97a5603ef3be$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $013c97a5603ef3be$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $013c97a5603ef3be$var$dl(a) {
    if (!a) return $013c97a5603ef3be$var$Vf;
    a = a._reactInternals;
    a: {
        if ($013c97a5603ef3be$var$Vb(a) !== a || 1 !== a.tag) throw Error($013c97a5603ef3be$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($013c97a5603ef3be$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($013c97a5603ef3be$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($013c97a5603ef3be$var$Zf(c)) return $013c97a5603ef3be$var$bg(a, c, b);
    }
    return b;
}
function $013c97a5603ef3be$var$el(a, b, c, d, e, f, g, h, k) {
    a = $013c97a5603ef3be$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $013c97a5603ef3be$var$dl(null);
    c = a.current;
    d = $013c97a5603ef3be$var$R();
    e = $013c97a5603ef3be$var$yi(c);
    f = $013c97a5603ef3be$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $013c97a5603ef3be$var$nh(c, f, e);
    a.current.lanes = e;
    $013c97a5603ef3be$var$Ac(a, e, d);
    $013c97a5603ef3be$var$Dk(a, d);
    return a;
}
function $013c97a5603ef3be$var$fl(a, b, c, d) {
    var e = b.current, f = $013c97a5603ef3be$var$R(), g = $013c97a5603ef3be$var$yi(e);
    c = $013c97a5603ef3be$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $013c97a5603ef3be$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $013c97a5603ef3be$var$nh(e, b, g);
    null !== a && ($013c97a5603ef3be$var$gi(a, e, g, f), $013c97a5603ef3be$var$oh(a, e, g));
    return g;
}
function $013c97a5603ef3be$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $013c97a5603ef3be$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $013c97a5603ef3be$var$il(a, b) {
    $013c97a5603ef3be$var$hl(a, b);
    (a = a.alternate) && $013c97a5603ef3be$var$hl(a, b);
}
function $013c97a5603ef3be$var$jl() {
    return null;
}
var $013c97a5603ef3be$var$kl = "function" === typeof reportError ? reportError : function kl(a) {
    console.error(a);
};
function $013c97a5603ef3be$var$ll(a) {
    this._internalRoot = a;
}
$013c97a5603ef3be$var$ml.prototype.render = $013c97a5603ef3be$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($013c97a5603ef3be$var$p(409));
    $013c97a5603ef3be$var$fl(a, b, null, null);
};
$013c97a5603ef3be$var$ml.prototype.unmount = $013c97a5603ef3be$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $013c97a5603ef3be$var$Rk(function() {
            $013c97a5603ef3be$var$fl(null, a, null, null);
        });
        b[$013c97a5603ef3be$var$uf] = null;
    }
};
function $013c97a5603ef3be$var$ml(a) {
    this._internalRoot = a;
}
$013c97a5603ef3be$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $013c97a5603ef3be$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $013c97a5603ef3be$var$Qc.length && 0 !== b && b < $013c97a5603ef3be$var$Qc[c].priority; c++);
        $013c97a5603ef3be$var$Qc.splice(c, 0, a);
        0 === c && $013c97a5603ef3be$var$Vc(a);
    }
};
function $013c97a5603ef3be$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $013c97a5603ef3be$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $013c97a5603ef3be$var$pl() {}
function $013c97a5603ef3be$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function d() {
                var _$a = $013c97a5603ef3be$var$gl(g);
                f.call(_$a);
            };
        }
        var g = $013c97a5603ef3be$var$el(b, d, a, 0, null, !1, !1, "", $013c97a5603ef3be$var$pl);
        a._reactRootContainer = g;
        a[$013c97a5603ef3be$var$uf] = g.current;
        $013c97a5603ef3be$var$sf(8 === a.nodeType ? a.parentNode : a);
        $013c97a5603ef3be$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function d() {
            var _$a = $013c97a5603ef3be$var$gl(k);
            h.call(_$a);
        };
    }
    var k = $013c97a5603ef3be$var$bl(a, 0, !1, null, null, !1, !1, "", $013c97a5603ef3be$var$pl);
    a._reactRootContainer = k;
    a[$013c97a5603ef3be$var$uf] = k.current;
    $013c97a5603ef3be$var$sf(8 === a.nodeType ? a.parentNode : a);
    $013c97a5603ef3be$var$Rk(function() {
        $013c97a5603ef3be$var$fl(b, k, c, d);
    });
    return k;
}
function $013c97a5603ef3be$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = $013c97a5603ef3be$var$gl(g);
                h.call(_$a);
            };
        }
        $013c97a5603ef3be$var$fl(b, g, a, e);
    } else g = $013c97a5603ef3be$var$ql(c, b, a, e, d);
    return $013c97a5603ef3be$var$gl(g);
}
$013c97a5603ef3be$var$Ec = function Ec(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $013c97a5603ef3be$var$tc(b.pendingLanes);
                0 !== c && ($013c97a5603ef3be$var$Cc(b, c | 1), $013c97a5603ef3be$var$Dk(b, $013c97a5603ef3be$var$B()), 0 === ($013c97a5603ef3be$var$K & 6) && ($013c97a5603ef3be$var$Gj = $013c97a5603ef3be$var$B() + 500, $013c97a5603ef3be$var$jg()));
            }
            break;
        case 13:
            $013c97a5603ef3be$var$Rk(function() {
                var b = $013c97a5603ef3be$var$ih(a, 1);
                if (null !== b) {
                    var c = $013c97a5603ef3be$var$R();
                    $013c97a5603ef3be$var$gi(b, a, 1, c);
                }
            }), $013c97a5603ef3be$var$il(a, 1);
    }
};
$013c97a5603ef3be$var$Fc = function Fc(a) {
    if (13 === a.tag) {
        var b = $013c97a5603ef3be$var$ih(a, 134217728);
        if (null !== b) {
            var c = $013c97a5603ef3be$var$R();
            $013c97a5603ef3be$var$gi(b, a, 134217728, c);
        }
        $013c97a5603ef3be$var$il(a, 134217728);
    }
};
$013c97a5603ef3be$var$Gc = function Gc(a) {
    if (13 === a.tag) {
        var b = $013c97a5603ef3be$var$yi(a), c = $013c97a5603ef3be$var$ih(a, b);
        if (null !== c) {
            var d = $013c97a5603ef3be$var$R();
            $013c97a5603ef3be$var$gi(c, a, b, d);
        }
        $013c97a5603ef3be$var$il(a, b);
    }
};
$013c97a5603ef3be$var$Hc = function Hc() {
    return $013c97a5603ef3be$var$C;
};
$013c97a5603ef3be$var$Ic = function Ic(a, b) {
    var c = $013c97a5603ef3be$var$C;
    try {
        return $013c97a5603ef3be$var$C = a, b();
    } finally{
        $013c97a5603ef3be$var$C = c;
    }
};
$013c97a5603ef3be$var$yb = function yb(a, b, c) {
    switch(b){
        case "input":
            $013c97a5603ef3be$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $013c97a5603ef3be$var$Db(d);
                        if (!e) throw Error($013c97a5603ef3be$var$p(90));
                        $013c97a5603ef3be$var$Wa(d);
                        $013c97a5603ef3be$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $013c97a5603ef3be$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $013c97a5603ef3be$var$fb(a, !!c.multiple, b, !1);
    }
};
$013c97a5603ef3be$var$Gb = $013c97a5603ef3be$var$Qk;
$013c97a5603ef3be$var$Hb = $013c97a5603ef3be$var$Rk;
var $013c97a5603ef3be$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $013c97a5603ef3be$var$Cb,
        $013c97a5603ef3be$var$ue,
        $013c97a5603ef3be$var$Db,
        $013c97a5603ef3be$var$Eb,
        $013c97a5603ef3be$var$Fb,
        $013c97a5603ef3be$var$Qk
    ]
}, $013c97a5603ef3be$var$tl = {
    findFiberByHostInstance: $013c97a5603ef3be$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $013c97a5603ef3be$var$ul = {
    bundleType: $013c97a5603ef3be$var$tl.bundleType,
    version: $013c97a5603ef3be$var$tl.version,
    rendererPackageName: $013c97a5603ef3be$var$tl.rendererPackageName,
    rendererConfig: $013c97a5603ef3be$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $013c97a5603ef3be$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = $013c97a5603ef3be$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $013c97a5603ef3be$var$tl.findFiberByHostInstance || $013c97a5603ef3be$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $013c97a5603ef3be$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$013c97a5603ef3be$var$vl.isDisabled && $013c97a5603ef3be$var$vl.supportsFiber) try {
        $013c97a5603ef3be$var$kc = $013c97a5603ef3be$var$vl.inject($013c97a5603ef3be$var$ul), $013c97a5603ef3be$var$lc = $013c97a5603ef3be$var$vl;
    } catch (a) {}
}
$013c97a5603ef3be$export$ae55be85d98224ed = $013c97a5603ef3be$var$sl;
$013c97a5603ef3be$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$013c97a5603ef3be$var$nl(b)) throw Error($013c97a5603ef3be$var$p(200));
    return $013c97a5603ef3be$var$cl(a, b, null, c);
};
$013c97a5603ef3be$export$882461b6382ed46c = function(a, b) {
    if (!$013c97a5603ef3be$var$nl(a)) throw Error($013c97a5603ef3be$var$p(299));
    var c = !1, d = "", e = $013c97a5603ef3be$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $013c97a5603ef3be$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$013c97a5603ef3be$var$uf] = b.current;
    $013c97a5603ef3be$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $013c97a5603ef3be$var$ll(b);
};
$013c97a5603ef3be$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($013c97a5603ef3be$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($013c97a5603ef3be$var$p(268, a));
    }
    a = $013c97a5603ef3be$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$013c97a5603ef3be$export$cd75ccfd720a3cd4 = function(a) {
    return $013c97a5603ef3be$var$Rk(a);
};
$013c97a5603ef3be$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$013c97a5603ef3be$var$ol(b)) throw Error($013c97a5603ef3be$var$p(200));
    return $013c97a5603ef3be$var$rl(null, a, b, !0, c);
};
$013c97a5603ef3be$export$757ceba2d55c277e = function(a, b, c) {
    if (!$013c97a5603ef3be$var$nl(a)) throw Error($013c97a5603ef3be$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $013c97a5603ef3be$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $013c97a5603ef3be$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$013c97a5603ef3be$var$uf] = b.current;
    $013c97a5603ef3be$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $013c97a5603ef3be$var$ml(b);
};
$013c97a5603ef3be$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$013c97a5603ef3be$var$ol(b)) throw Error($013c97a5603ef3be$var$p(200));
    return $013c97a5603ef3be$var$rl(null, a, b, !1, c);
};
$013c97a5603ef3be$export$502457920280e6be = function(a) {
    if (!$013c97a5603ef3be$var$ol(a)) throw Error($013c97a5603ef3be$var$p(40));
    return a._reactRootContainer ? ($013c97a5603ef3be$var$Rk(function() {
        $013c97a5603ef3be$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$013c97a5603ef3be$var$uf] = null;
        });
    }), !0) : !1;
};
$013c97a5603ef3be$export$c78a37762a8d58e1 = $013c97a5603ef3be$var$Qk;
$013c97a5603ef3be$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$013c97a5603ef3be$var$ol(c)) throw Error($013c97a5603ef3be$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($013c97a5603ef3be$var$p(38));
    return $013c97a5603ef3be$var$rl(a, b, c, !1, d);
};
$013c97a5603ef3be$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("3rCRi", function(module, exports) {
"use strict";

module.exports = (parcelRequire("fcIYe"));

});
parcelRegister("fcIYe", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $b11adc311ce2c52a$export$c4744153514ff05d; }, function (v) { return $b11adc311ce2c52a$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $b11adc311ce2c52a$export$3e506c1ccc9cc1a7; }, function (v) { return $b11adc311ce2c52a$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $b11adc311ce2c52a$export$e26fe2ed2fa76875; }, function (v) { return $b11adc311ce2c52a$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $b11adc311ce2c52a$export$502329bbf4b505b1; }, function (v) { return $b11adc311ce2c52a$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $b11adc311ce2c52a$export$6e3807111c4874c4; }, function (v) { return $b11adc311ce2c52a$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $b11adc311ce2c52a$export$c27134553091fb3a; }, function (v) { return $b11adc311ce2c52a$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $b11adc311ce2c52a$export$33ee1acdc04fd2a2; }, function (v) { return $b11adc311ce2c52a$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $b11adc311ce2c52a$export$b00a404bbd5edef2; }, function (v) { return $b11adc311ce2c52a$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $b11adc311ce2c52a$export$8352ce38b91d0c62; }, function (v) { return $b11adc311ce2c52a$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $b11adc311ce2c52a$export$d66a1c1c77bd778b; }, function (v) { return $b11adc311ce2c52a$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $b11adc311ce2c52a$export$d3dfb8e4810cb555; }, function (v) { return $b11adc311ce2c52a$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $b11adc311ce2c52a$export$839f9183b0465a69; }, function (v) { return $b11adc311ce2c52a$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $b11adc311ce2c52a$export$72fdf0e06517287b; }, function (v) { return $b11adc311ce2c52a$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $b11adc311ce2c52a$export$4b844e58a3e414b4; }, function (v) { return $b11adc311ce2c52a$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $b11adc311ce2c52a$export$816d2913ae6b83b1; }, function (v) { return $b11adc311ce2c52a$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $b11adc311ce2c52a$export$61bcfe829111a1d0; }, function (v) { return $b11adc311ce2c52a$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $b11adc311ce2c52a$export$7ee8c9beb337bc3f; }, function (v) { return $b11adc311ce2c52a$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $b11adc311ce2c52a$export$b5836b71941fa3ed; }, function (v) { return $b11adc311ce2c52a$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $b11adc311ce2c52a$export$cf845f2c119da08a; }, function (v) { return $b11adc311ce2c52a$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b11adc311ce2c52a$export$c4744153514ff05d;
var $b11adc311ce2c52a$export$3e506c1ccc9cc1a7;
var $b11adc311ce2c52a$export$e26fe2ed2fa76875;
var $b11adc311ce2c52a$export$502329bbf4b505b1;
var $b11adc311ce2c52a$export$6e3807111c4874c4;
var $b11adc311ce2c52a$export$c27134553091fb3a;
var $b11adc311ce2c52a$export$33ee1acdc04fd2a2;
var $b11adc311ce2c52a$export$b00a404bbd5edef2;
var $b11adc311ce2c52a$export$8352ce38b91d0c62;
var $b11adc311ce2c52a$export$d66a1c1c77bd778b;
var $b11adc311ce2c52a$export$d3dfb8e4810cb555;
var $b11adc311ce2c52a$export$839f9183b0465a69;
var $b11adc311ce2c52a$export$72fdf0e06517287b;
var $b11adc311ce2c52a$export$4b844e58a3e414b4;
var $b11adc311ce2c52a$export$816d2913ae6b83b1;
var $b11adc311ce2c52a$export$61bcfe829111a1d0;
var $b11adc311ce2c52a$export$7ee8c9beb337bc3f;
var $b11adc311ce2c52a$export$b5836b71941fa3ed;
var $b11adc311ce2c52a$export$cf845f2c119da08a;
"use strict";
function $b11adc311ce2c52a$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $b11adc311ce2c52a$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $b11adc311ce2c52a$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $b11adc311ce2c52a$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $b11adc311ce2c52a$var$g(C, c)) n < e && 0 > $b11adc311ce2c52a$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $b11adc311ce2c52a$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $b11adc311ce2c52a$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $b11adc311ce2c52a$var$l = performance;
    $b11adc311ce2c52a$export$c4744153514ff05d = function() {
        return $b11adc311ce2c52a$var$l.now();
    };
} else {
    var $b11adc311ce2c52a$var$p = Date, $b11adc311ce2c52a$var$q = $b11adc311ce2c52a$var$p.now();
    $b11adc311ce2c52a$export$c4744153514ff05d = function() {
        return $b11adc311ce2c52a$var$p.now() - $b11adc311ce2c52a$var$q;
    };
}
var $b11adc311ce2c52a$var$r = [], $b11adc311ce2c52a$var$t = [], $b11adc311ce2c52a$var$u = 1, $b11adc311ce2c52a$var$v = null, $b11adc311ce2c52a$var$y = 3, $b11adc311ce2c52a$var$z = !1, $b11adc311ce2c52a$var$A = !1, $b11adc311ce2c52a$var$B = !1, $b11adc311ce2c52a$var$D = "function" === typeof setTimeout ? setTimeout : null, $b11adc311ce2c52a$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $b11adc311ce2c52a$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $b11adc311ce2c52a$var$G(a) {
    for(var b = $b11adc311ce2c52a$var$h($b11adc311ce2c52a$var$t); null !== b;){
        if (null === b.callback) $b11adc311ce2c52a$var$k($b11adc311ce2c52a$var$t);
        else if (b.startTime <= a) $b11adc311ce2c52a$var$k($b11adc311ce2c52a$var$t), b.sortIndex = b.expirationTime, $b11adc311ce2c52a$var$f($b11adc311ce2c52a$var$r, b);
        else break;
        b = $b11adc311ce2c52a$var$h($b11adc311ce2c52a$var$t);
    }
}
function $b11adc311ce2c52a$var$H(a) {
    $b11adc311ce2c52a$var$B = !1;
    $b11adc311ce2c52a$var$G(a);
    if (!$b11adc311ce2c52a$var$A) {
        if (null !== $b11adc311ce2c52a$var$h($b11adc311ce2c52a$var$r)) $b11adc311ce2c52a$var$A = !0, $b11adc311ce2c52a$var$I($b11adc311ce2c52a$var$J);
        else {
            var b = $b11adc311ce2c52a$var$h($b11adc311ce2c52a$var$t);
            null !== b && $b11adc311ce2c52a$var$K($b11adc311ce2c52a$var$H, b.startTime - a);
        }
    }
}
function $b11adc311ce2c52a$var$J(a, b) {
    $b11adc311ce2c52a$var$A = !1;
    $b11adc311ce2c52a$var$B && ($b11adc311ce2c52a$var$B = !1, $b11adc311ce2c52a$var$E($b11adc311ce2c52a$var$L), $b11adc311ce2c52a$var$L = -1);
    $b11adc311ce2c52a$var$z = !0;
    var c = $b11adc311ce2c52a$var$y;
    try {
        $b11adc311ce2c52a$var$G(b);
        for($b11adc311ce2c52a$var$v = $b11adc311ce2c52a$var$h($b11adc311ce2c52a$var$r); null !== $b11adc311ce2c52a$var$v && (!($b11adc311ce2c52a$var$v.expirationTime > b) || a && !$b11adc311ce2c52a$var$M());){
            var d = $b11adc311ce2c52a$var$v.callback;
            if ("function" === typeof d) {
                $b11adc311ce2c52a$var$v.callback = null;
                $b11adc311ce2c52a$var$y = $b11adc311ce2c52a$var$v.priorityLevel;
                var e = d($b11adc311ce2c52a$var$v.expirationTime <= b);
                b = $b11adc311ce2c52a$export$c4744153514ff05d();
                "function" === typeof e ? $b11adc311ce2c52a$var$v.callback = e : $b11adc311ce2c52a$var$v === $b11adc311ce2c52a$var$h($b11adc311ce2c52a$var$r) && $b11adc311ce2c52a$var$k($b11adc311ce2c52a$var$r);
                $b11adc311ce2c52a$var$G(b);
            } else $b11adc311ce2c52a$var$k($b11adc311ce2c52a$var$r);
            $b11adc311ce2c52a$var$v = $b11adc311ce2c52a$var$h($b11adc311ce2c52a$var$r);
        }
        if (null !== $b11adc311ce2c52a$var$v) var w = !0;
        else {
            var m = $b11adc311ce2c52a$var$h($b11adc311ce2c52a$var$t);
            null !== m && $b11adc311ce2c52a$var$K($b11adc311ce2c52a$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $b11adc311ce2c52a$var$v = null, $b11adc311ce2c52a$var$y = c, $b11adc311ce2c52a$var$z = !1;
    }
}
var $b11adc311ce2c52a$var$N = !1, $b11adc311ce2c52a$var$O = null, $b11adc311ce2c52a$var$L = -1, $b11adc311ce2c52a$var$P = 5, $b11adc311ce2c52a$var$Q = -1;
function $b11adc311ce2c52a$var$M() {
    return $b11adc311ce2c52a$export$c4744153514ff05d() - $b11adc311ce2c52a$var$Q < $b11adc311ce2c52a$var$P ? !1 : !0;
}
function $b11adc311ce2c52a$var$R() {
    if (null !== $b11adc311ce2c52a$var$O) {
        var a = $b11adc311ce2c52a$export$c4744153514ff05d();
        $b11adc311ce2c52a$var$Q = a;
        var b = !0;
        try {
            b = $b11adc311ce2c52a$var$O(!0, a);
        } finally{
            b ? $b11adc311ce2c52a$var$S() : ($b11adc311ce2c52a$var$N = !1, $b11adc311ce2c52a$var$O = null);
        }
    } else $b11adc311ce2c52a$var$N = !1;
}
var $b11adc311ce2c52a$var$S;
if ("function" === typeof $b11adc311ce2c52a$var$F) $b11adc311ce2c52a$var$S = function S() {
    $b11adc311ce2c52a$var$F($b11adc311ce2c52a$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $b11adc311ce2c52a$var$T = new MessageChannel, $b11adc311ce2c52a$var$U = $b11adc311ce2c52a$var$T.port2;
    $b11adc311ce2c52a$var$T.port1.onmessage = $b11adc311ce2c52a$var$R;
    $b11adc311ce2c52a$var$S = function S() {
        $b11adc311ce2c52a$var$U.postMessage(null);
    };
} else $b11adc311ce2c52a$var$S = function S() {
    $b11adc311ce2c52a$var$D($b11adc311ce2c52a$var$R, 0);
};
function $b11adc311ce2c52a$var$I(a) {
    $b11adc311ce2c52a$var$O = a;
    $b11adc311ce2c52a$var$N || ($b11adc311ce2c52a$var$N = !0, $b11adc311ce2c52a$var$S());
}
function $b11adc311ce2c52a$var$K(a, b) {
    $b11adc311ce2c52a$var$L = $b11adc311ce2c52a$var$D(function() {
        a($b11adc311ce2c52a$export$c4744153514ff05d());
    }, b);
}
$b11adc311ce2c52a$export$3e506c1ccc9cc1a7 = 5;
$b11adc311ce2c52a$export$e26fe2ed2fa76875 = 1;
$b11adc311ce2c52a$export$502329bbf4b505b1 = 4;
$b11adc311ce2c52a$export$6e3807111c4874c4 = 3;
$b11adc311ce2c52a$export$c27134553091fb3a = null;
$b11adc311ce2c52a$export$33ee1acdc04fd2a2 = 2;
$b11adc311ce2c52a$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$b11adc311ce2c52a$export$8352ce38b91d0c62 = function() {
    $b11adc311ce2c52a$var$A || $b11adc311ce2c52a$var$z || ($b11adc311ce2c52a$var$A = !0, $b11adc311ce2c52a$var$I($b11adc311ce2c52a$var$J));
};
$b11adc311ce2c52a$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $b11adc311ce2c52a$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$b11adc311ce2c52a$export$d3dfb8e4810cb555 = function() {
    return $b11adc311ce2c52a$var$y;
};
$b11adc311ce2c52a$export$839f9183b0465a69 = function() {
    return $b11adc311ce2c52a$var$h($b11adc311ce2c52a$var$r);
};
$b11adc311ce2c52a$export$72fdf0e06517287b = function(a) {
    switch($b11adc311ce2c52a$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $b11adc311ce2c52a$var$y;
    }
    var c = $b11adc311ce2c52a$var$y;
    $b11adc311ce2c52a$var$y = b;
    try {
        return a();
    } finally{
        $b11adc311ce2c52a$var$y = c;
    }
};
$b11adc311ce2c52a$export$4b844e58a3e414b4 = function() {};
$b11adc311ce2c52a$export$816d2913ae6b83b1 = function() {};
$b11adc311ce2c52a$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $b11adc311ce2c52a$var$y;
    $b11adc311ce2c52a$var$y = a;
    try {
        return b();
    } finally{
        $b11adc311ce2c52a$var$y = c;
    }
};
$b11adc311ce2c52a$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $b11adc311ce2c52a$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $b11adc311ce2c52a$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $b11adc311ce2c52a$var$f($b11adc311ce2c52a$var$t, a), null === $b11adc311ce2c52a$var$h($b11adc311ce2c52a$var$r) && a === $b11adc311ce2c52a$var$h($b11adc311ce2c52a$var$t) && ($b11adc311ce2c52a$var$B ? ($b11adc311ce2c52a$var$E($b11adc311ce2c52a$var$L), $b11adc311ce2c52a$var$L = -1) : $b11adc311ce2c52a$var$B = !0, $b11adc311ce2c52a$var$K($b11adc311ce2c52a$var$H, c - d))) : (a.sortIndex = e, $b11adc311ce2c52a$var$f($b11adc311ce2c52a$var$r, a), $b11adc311ce2c52a$var$A || $b11adc311ce2c52a$var$z || ($b11adc311ce2c52a$var$A = !0, $b11adc311ce2c52a$var$I($b11adc311ce2c52a$var$J)));
    return a;
};
$b11adc311ce2c52a$export$b5836b71941fa3ed = $b11adc311ce2c52a$var$M;
$b11adc311ce2c52a$export$cf845f2c119da08a = function(a) {
    var b = $b11adc311ce2c52a$var$y;
    return function() {
        var c = $b11adc311ce2c52a$var$y;
        $b11adc311ce2c52a$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $b11adc311ce2c52a$var$y = c;
        }
    };
};

});



parcelRegister("kSuI9", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f330ac5f61e1368d$export$71511d61b312f219; });
function $f330ac5f61e1368d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $f330ac5f61e1368d$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $f330ac5f61e1368d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $f330ac5f61e1368d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("do9pw", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9bf4d105a019f48b$export$71511d61b312f219; });

var $3sHb8 = parcelRequire("3sHb8");
function $9bf4d105a019f48b$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $3sHb8._)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("3sHb8", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $28557b013f37bb6b$export$71511d61b312f219; });
function $28557b013f37bb6b$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("cxjpp", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $92079f442e5d1061$export$71511d61b312f219; });
function $92079f442e5d1061$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $92079f442e5d1061$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $92079f442e5d1061$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("c6Xmf", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8d1416c8f734345e$export$71511d61b312f219; });

var $2BACi = parcelRequire("2BACi");

var $djrl5 = parcelRequire("djrl5");

var $jix3C = parcelRequire("jix3C");

var $1hjNY = parcelRequire("1hjNY");
function $8d1416c8f734345e$export$71511d61b312f219(arr) {
    return (0, $2BACi._)(arr) || (0, $djrl5._)(arr) || (0, $1hjNY._)(arr) || (0, $jix3C._)();
}

});
parcelRegister("2BACi", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1e5b70c2c2307a84$export$71511d61b312f219; });

var $QCMVH = parcelRequire("QCMVH");
function $1e5b70c2c2307a84$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $QCMVH._)(arr);
}

});
parcelRegister("QCMVH", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $09e2f1f84ceddf09$export$71511d61b312f219; });
function $09e2f1f84ceddf09$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("djrl5", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9b1241b318447a2a$export$71511d61b312f219; });
function $9b1241b318447a2a$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("jix3C", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e0c9573dc9b3384a$export$71511d61b312f219; });
function $e0c9573dc9b3384a$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("1hjNY", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0ee6bdd820e270f4$export$71511d61b312f219; });

var $QCMVH = parcelRequire("QCMVH");
function $0ee6bdd820e270f4$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $QCMVH._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $QCMVH._)(o, minLen);
}

});


parcelRegister("eha6O", function(module, exports) {

$parcel$export(module.exports, "__awaiter", function () { return $bfff507257219634$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $bfff507257219634$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__values", function () { return $bfff507257219634$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $l0HdX = parcelRequire("l0HdX");
var $bfff507257219634$var$extendStatics = function extendStatics1(d, b) {
    $bfff507257219634$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $bfff507257219634$var$extendStatics(d, b);
};
function $bfff507257219634$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $bfff507257219634$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $bfff507257219634$export$18ce0697a983be9b = function __assign1() {
    $bfff507257219634$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bfff507257219634$export$18ce0697a983be9b.apply(this, arguments);
};
function $bfff507257219634$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $bfff507257219634$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $bfff507257219634$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $bfff507257219634$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $bfff507257219634$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $bfff507257219634$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $l0HdX._)(x)) === "symbol" ? x : "".concat(x);
}
function $bfff507257219634$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $l0HdX._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $bfff507257219634$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $bfff507257219634$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $bfff507257219634$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $bfff507257219634$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $bfff507257219634$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $bfff507257219634$export$45d3717a4c69092e(o, m, p);
}
function $bfff507257219634$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $bfff507257219634$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $bfff507257219634$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($bfff507257219634$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $bfff507257219634$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $bfff507257219634$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $bfff507257219634$export$10c90e4f7922046c(v) {
    return this instanceof $bfff507257219634$export$10c90e4f7922046c ? (this.v = v, this) : new $bfff507257219634$export$10c90e4f7922046c(v);
}
function $bfff507257219634$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $bfff507257219634$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $bfff507257219634$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $bfff507257219634$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $bfff507257219634$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $bfff507257219634$export$19a8beecd37a4c45 === "function" ? $bfff507257219634$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $bfff507257219634$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $bfff507257219634$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $bfff507257219634$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $bfff507257219634$export$45d3717a4c69092e(result, mod, k);
    }
    $bfff507257219634$var$__setModuleDefault(result, mod);
    return result;
}
function $bfff507257219634$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $bfff507257219634$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $bfff507257219634$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $bfff507257219634$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $bfff507257219634$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $bfff507257219634$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $bfff507257219634$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $bfff507257219634$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
var $bfff507257219634$export$2e2bcd8739ae039 = {
    __extends: $bfff507257219634$export$a8ba968b8961cb8a,
    __assign: $bfff507257219634$export$18ce0697a983be9b,
    __rest: $bfff507257219634$export$3c9a16f847548506,
    __decorate: $bfff507257219634$export$29e00dfd3077644b,
    __param: $bfff507257219634$export$d5ad3fd78186038f,
    __metadata: $bfff507257219634$export$f1db080c865becb9,
    __awaiter: $bfff507257219634$export$1050f835b63b671e,
    __generator: $bfff507257219634$export$67ebef60e6f28a6,
    __createBinding: $bfff507257219634$export$45d3717a4c69092e,
    __exportStar: $bfff507257219634$export$f33643c0debef087,
    __values: $bfff507257219634$export$19a8beecd37a4c45,
    __read: $bfff507257219634$export$8d051b38c9118094,
    __spread: $bfff507257219634$export$afc72e2116322959,
    __spreadArrays: $bfff507257219634$export$6388937ca91ccae8,
    __spreadArray: $bfff507257219634$export$1216008129fb82ed,
    __await: $bfff507257219634$export$10c90e4f7922046c,
    __asyncGenerator: $bfff507257219634$export$e427f37a30a4de9b,
    __asyncDelegator: $bfff507257219634$export$bbd80228419bb833,
    __asyncValues: $bfff507257219634$export$e3b29a3d6162315f,
    __makeTemplateObject: $bfff507257219634$export$4fb47efe1390b86f,
    __importStar: $bfff507257219634$export$c21735bcef00d192,
    __importDefault: $bfff507257219634$export$da59b14a69baef04,
    __classPrivateFieldGet: $bfff507257219634$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $bfff507257219634$export$d40a35129aaff81f,
    __classPrivateFieldIn: $bfff507257219634$export$81fdc39f203e4e04,
    __addDisposableResource: $bfff507257219634$export$88ac25d8e944e405,
    __disposeResources: $bfff507257219634$export$8f076105dc360e92
};

});

parcelRegister("cv9Rk", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $91a007218046315e$export$71511d61b312f219; });

var $hrk7H = parcelRequire("hrk7H");

var $fBJYg = parcelRequire("fBJYg");

var $e8oCh = parcelRequire("e8oCh");

var $1hjNY = parcelRequire("1hjNY");
function $91a007218046315e$export$71511d61b312f219(arr, i) {
    return (0, $hrk7H._)(arr) || (0, $fBJYg._)(arr, i) || (0, $1hjNY._)(arr, i) || (0, $e8oCh._)();
}

});
parcelRegister("hrk7H", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cb24915816a1cfc9$export$71511d61b312f219; });
function $cb24915816a1cfc9$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("fBJYg", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b5cdf895c6f08ea2$export$71511d61b312f219; });
function $b5cdf895c6f08ea2$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("e8oCh", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a4a4e8541bb818da$export$71511d61b312f219; });
function $a4a4e8541bb818da$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("4GJKx", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $369e92947825c2b5$export$71511d61b312f219; });
function $369e92947825c2b5$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("1wc17", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $11b219ef186b1c94$export$71511d61b312f219; });
function $11b219ef186b1c94$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $11b219ef186b1c94$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $11b219ef186b1c94$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $11b219ef186b1c94$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("d3H5E", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $981cfaf5c821609e$export$71511d61b312f219; });
function $981cfaf5c821609e$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("dcsZi", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $99c2e1b2c4a01e52$export$71511d61b312f219; });

var $koVwh = parcelRequire("koVwh");
function $99c2e1b2c4a01e52$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $koVwh._)(subClass, superClass);
}

});
parcelRegister("koVwh", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $eda2aabf2c4b7bd6$export$71511d61b312f219; });
function $eda2aabf2c4b7bd6$export$71511d61b312f219(o, p) {
    $eda2aabf2c4b7bd6$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $eda2aabf2c4b7bd6$export$71511d61b312f219(o, p);
}

});


parcelRegister("ohfOJ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $048fa05071cfee44$export$71511d61b312f219; });

var $b8Rim = parcelRequire("b8Rim");

var $9yjJS = parcelRequire("9yjJS");

var $3U0IP = parcelRequire("3U0IP");
function $048fa05071cfee44$export$71511d61b312f219(Derived) {
    var hasNativeReflectConstruct = (0, $9yjJS._)();
    return function _createSuperInternal() {
        var Super = (0, $b8Rim._)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $b8Rim._)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $3U0IP._)(this, result);
    };
}

});
parcelRegister("b8Rim", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $81c9c858187986cb$export$71511d61b312f219; });
function $81c9c858187986cb$export$71511d61b312f219(o) {
    $81c9c858187986cb$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $81c9c858187986cb$export$71511d61b312f219(o);
}

});

parcelRegister("9yjJS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6f4699ca644cfb51$export$71511d61b312f219; });
function $6f4699ca644cfb51$export$71511d61b312f219() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("3U0IP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2d772972bd4fe337$export$71511d61b312f219; });

var $d3H5E = parcelRequire("d3H5E");

var $l0HdX = parcelRequire("l0HdX");
function $2d772972bd4fe337$export$71511d61b312f219(self, call) {
    if (call && ((0, $l0HdX._)(call) === "object" || typeof call === "function")) return call;
    return (0, $d3H5E._)(self);
}

});


parcelRegister("04RAu", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $00e9f136d8b86c33$export$71511d61b312f219; });

var $9Fj1i = parcelRequire("9Fj1i");
function $00e9f136d8b86c33$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $00e9f136d8b86c33$export$71511d61b312f219 = Reflect.get;
    else $00e9f136d8b86c33$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $9Fj1i._)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $00e9f136d8b86c33$export$71511d61b312f219(target, property, receiver || target);
}

});
parcelRegister("9Fj1i", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7096b25b59c4b2c1$export$71511d61b312f219; });

var $b8Rim = parcelRequire("b8Rim");
function $7096b25b59c4b2c1$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $b8Rim._)(object);
        if (object === null) break;
    }
    return object;
}

});


parcelRegister("FuVm8", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $07cbd154cab12773$export$71511d61b312f219; });

var $5Gbgo = parcelRequire("5Gbgo");

var $b8Rim = parcelRequire("b8Rim");

var $19aQU = parcelRequire("19aQU");

var $koVwh = parcelRequire("koVwh");
function $07cbd154cab12773$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $07cbd154cab12773$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $19aQU._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $5Gbgo._)(Class, arguments, (0, $b8Rim._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $koVwh._)(Wrapper, Class);
    };
    return $07cbd154cab12773$export$71511d61b312f219(Class);
}

});
parcelRegister("5Gbgo", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $42299caecbd14337$export$71511d61b312f219; });

var $9yjJS = parcelRequire("9yjJS");

var $koVwh = parcelRequire("koVwh");
function $42299caecbd14337$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $9yjJS._)()) $42299caecbd14337$export$71511d61b312f219 = Reflect.construct;
    else $42299caecbd14337$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $koVwh._)(instance, Class.prototype);
        return instance;
    };
    return $42299caecbd14337$export$71511d61b312f219.apply(null, arguments);
}

});

parcelRegister("19aQU", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0d5f0cc57e65a7f7$export$71511d61b312f219; });
function $0d5f0cc57e65a7f7$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("7ihh7", function(module, exports) {

$parcel$export(module.exports, "BaseError", function () { return $54f79d4e971ffcf8$export$a490eb03cb7a0a5e; });

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $c6Xmf = parcelRequire("c6Xmf");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");

var $dz5qt = parcelRequire("dz5qt");
var $54f79d4e971ffcf8$var$errorConfig = {
    getDocsUrl: function(param) {
        var docsBaseUrl = param.docsBaseUrl, _param_docsPath = param.docsPath, docsPath = _param_docsPath === void 0 ? "" : _param_docsPath, docsSlug = param.docsSlug;
        return docsPath ? "".concat(docsBaseUrl !== null && docsBaseUrl !== void 0 ? docsBaseUrl : "https://viem.sh").concat(docsPath).concat(docsSlug ? "#".concat(docsSlug) : "") : undefined;
    },
    version: (0, $dz5qt.version)
};
function $54f79d4e971ffcf8$export$4ac109df0c5244e9(config) {
    $54f79d4e971ffcf8$var$errorConfig = config;
}
var $54f79d4e971ffcf8$export$a490eb03cb7a0a5e = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $dcsZi._)(BaseError, Error1);
    var _super = (0, $ohfOJ._)(BaseError);
    function BaseError(shortMessage) {
        var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $4GJKx._)(this, BaseError);
        var _this;
        var _errorConfig_getDocsUrl;
        var details = function() {
            var _args_cause;
            if (args.cause instanceof BaseError) return args.cause.details;
            if ((_args_cause = args.cause) === null || _args_cause === void 0 ? void 0 : _args_cause.message) return args.cause.message;
            return args.details;
        }();
        var docsPath = function() {
            if (args.cause instanceof BaseError) return args.cause.docsPath || args.docsPath;
            return args.docsPath;
        }();
        var docsUrl = (_errorConfig_getDocsUrl = $54f79d4e971ffcf8$var$errorConfig.getDocsUrl) === null || _errorConfig_getDocsUrl === void 0 ? void 0 : _errorConfig_getDocsUrl.call($54f79d4e971ffcf8$var$errorConfig, (0, $cxjpp._)((0, $do9pw._)({}, args), {
            docsPath: docsPath
        }));
        var message = [
            shortMessage || "An error occurred.",
            ""
        ].concat((0, $c6Xmf._)(args.metaMessages ? (0, $c6Xmf._)(args.metaMessages).concat([
            ""
        ]) : []), (0, $c6Xmf._)(docsUrl ? [
            "Docs: ".concat(docsUrl)
        ] : []), (0, $c6Xmf._)(details ? [
            "Details: ".concat(details)
        ] : []), (0, $c6Xmf._)($54f79d4e971ffcf8$var$errorConfig.version ? [
            "Version: ".concat($54f79d4e971ffcf8$var$errorConfig.version)
        ] : [])).join("\n");
        _this = _super.call(this, message, args.cause ? {
            cause: args.cause
        } : undefined);
        Object.defineProperty((0, $d3H5E._)(_this), "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty((0, $d3H5E._)(_this), "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty((0, $d3H5E._)(_this), "metaMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty((0, $d3H5E._)(_this), "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty((0, $d3H5E._)(_this), "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty((0, $d3H5E._)(_this), "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "BaseError"
        });
        _this.details = details;
        _this.docsPath = docsPath;
        _this.metaMessages = args.metaMessages;
        var _args_name;
        _this.name = (_args_name = args.name) !== null && _args_name !== void 0 ? _args_name : _this.name;
        _this.shortMessage = shortMessage;
        _this.version = (0, $dz5qt.version);
        return _this;
    }
    (0, $1wc17._)(BaseError, [
        {
            key: "walk",
            value: function walk1(fn) {
                return $54f79d4e971ffcf8$var$walk(this, fn);
            }
        }
    ]);
    return BaseError;
}((0, $FuVm8._)(Error));
function $54f79d4e971ffcf8$var$walk(err, fn) {
    if (fn === null || fn === void 0 ? void 0 : fn(err)) return err;
    if (err && typeof err === "object" && "cause" in err) return $54f79d4e971ffcf8$var$walk(err.cause, fn);
    return fn ? null : err;
}

});
parcelRegister("dz5qt", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $028c6e76ad01363b$export$83d89fbfd8236492; });
var $028c6e76ad01363b$export$83d89fbfd8236492 = "2.21.0";

});


parcelRegister("aP7UT", function(module, exports) {

$parcel$export(module.exports, "isHex", function () { return $7e14cedd0503844f$export$8a9b6341a7c96bc; });
function $7e14cedd0503844f$export$8a9b6341a7c96bc(value) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_strict = _ref.strict, strict = _ref_strict === void 0 ? true : _ref_strict;
    if (!value) return false;
    if (typeof value !== "string") return false;
    return strict ? /^0x[0-9a-fA-F]*$/.test(value) : value.startsWith("0x");
}

});

parcelRegister("ewLmX", function(module, exports) {

$parcel$export(module.exports, "concat", function () { return $a938cc6a053cc366$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "concatHex", function () { return $a938cc6a053cc366$export$f6cc0b64b5a999af; });
function $a938cc6a053cc366$export$ee1b3e54f0441b22(values) {
    if (typeof values[0] === "string") return $a938cc6a053cc366$export$f6cc0b64b5a999af(values);
    return $a938cc6a053cc366$export$287dd7971339c972(values);
}
function $a938cc6a053cc366$export$287dd7971339c972(values) {
    var length = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var arr = _step.value;
            length += arr.length;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var result = new Uint8Array(length);
    var offset = 0;
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = values[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var arr1 = _step1.value;
            result.set(arr1, offset);
            offset += arr1.length;
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return result;
}
function $a938cc6a053cc366$export$f6cc0b64b5a999af(values) {
    return "0x".concat(values.reduce(function(acc, x) {
        return acc + x.replace("0x", "");
    }, ""));
}

});

parcelRegister("dRLPW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a18554f914d0c57d$export$71511d61b312f219; });

var $8vV5y = parcelRequire("8vV5y");
function $a18554f914d0c57d$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = (0, $8vV5y._)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("8vV5y", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $632d808f00de0e4b$export$71511d61b312f219; });
function $632d808f00de0e4b$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("cwWZ7", function(module, exports) {

$parcel$export(module.exports, "ModalController", function () { return (parcelRequire("5Lhe6")).ModalController; });
$parcel$export(module.exports, "RouterController", function () { return (parcelRequire("iptjJ")).RouterController; });
$parcel$export(module.exports, "AccountController", function () { return (parcelRequire("dMLJP")).AccountController; });
$parcel$export(module.exports, "ChainController", function () { return (parcelRequire("9zDWP")).ChainController; });
$parcel$export(module.exports, "NetworkController", function () { return (parcelRequire("fPqxb")).NetworkController; });
$parcel$export(module.exports, "OnRampController", function () { return (parcelRequire("69mn1")).OnRampController; });
$parcel$export(module.exports, "ConnectionController", function () { return (parcelRequire("3cYIS")).ConnectionController; });
$parcel$export(module.exports, "ConnectorController", function () { return (parcelRequire("2qlRb")).ConnectorController; });
$parcel$export(module.exports, "SnackController", function () { return (parcelRequire("8FcCV")).SnackController; });
$parcel$export(module.exports, "ApiController", function () { return (parcelRequire("hMdcG")).ApiController; });
$parcel$export(module.exports, "AssetController", function () { return (parcelRequire("datXT")).AssetController; });
$parcel$export(module.exports, "ThemeController", function () { return (parcelRequire("dJ6Ea")).ThemeController; });
$parcel$export(module.exports, "OptionsController", function () { return (parcelRequire("faNff")).OptionsController; });
$parcel$export(module.exports, "BlockchainApiController", function () { return (parcelRequire("jrvVk")).BlockchainApiController; });
$parcel$export(module.exports, "PublicStateController", function () { return (parcelRequire("4HJlA")).PublicStateController; });
$parcel$export(module.exports, "EventsController", function () { return (parcelRequire("1QDT9")).EventsController; });
$parcel$export(module.exports, "TransactionsController", function () { return (parcelRequire("ktZEF")).TransactionsController; });
$parcel$export(module.exports, "SwapController", function () { return (parcelRequire("8DzeN")).SwapController; });
$parcel$export(module.exports, "SendController", function () { return (parcelRequire("iSNyw")).SendController; });
$parcel$export(module.exports, "TooltipController", function () { return (parcelRequire("5R7lI")).TooltipController; });
$parcel$export(module.exports, "EnsController", function () { return (parcelRequire("kOW8v")).EnsController; });
$parcel$export(module.exports, "AssetUtil", function () { return (parcelRequire("khm6W")).AssetUtil; });
$parcel$export(module.exports, "ConstantsUtil", function () { return (parcelRequire("2sXdV")).ConstantsUtil; });
$parcel$export(module.exports, "CoreHelperUtil", function () { return (parcelRequire("hZBJb")).CoreHelperUtil; });
$parcel$export(module.exports, "StorageUtil", function () { return (parcelRequire("i7zcD")).StorageUtil; });
$parcel$export(module.exports, "RouterUtil", function () { return (parcelRequire("6a2RN")).RouterUtil; });
// -- Controllers -------------------------------------------------------------

var $5Lhe6 = parcelRequire("5Lhe6");

var $iptjJ = parcelRequire("iptjJ");

var $dMLJP = parcelRequire("dMLJP");

var $9zDWP = parcelRequire("9zDWP");

var $fPqxb = parcelRequire("fPqxb");

var $69mn1 = parcelRequire("69mn1");

var $3cYIS = parcelRequire("3cYIS");

var $2qlRb = parcelRequire("2qlRb");

var $8FcCV = parcelRequire("8FcCV");

var $hMdcG = parcelRequire("hMdcG");

var $datXT = parcelRequire("datXT");

var $dJ6Ea = parcelRequire("dJ6Ea");

var $faNff = parcelRequire("faNff");

var $jrvVk = parcelRequire("jrvVk");

var $4HJlA = parcelRequire("4HJlA");

var $1QDT9 = parcelRequire("1QDT9");

var $ktZEF = parcelRequire("ktZEF");

var $8DzeN = parcelRequire("8DzeN");

var $iSNyw = parcelRequire("iSNyw");

var $5R7lI = parcelRequire("5R7lI");

var $kOW8v = parcelRequire("kOW8v");

var $khm6W = parcelRequire("khm6W");

var $2sXdV = parcelRequire("2sXdV");

var $hZBJb = parcelRequire("hZBJb");

var $i7zcD = parcelRequire("i7zcD");

var $6a2RN = parcelRequire("6a2RN");

});
parcelRegister("5Lhe6", function(module, exports) {

$parcel$export(module.exports, "ModalController", function () { return $431eb4569d9c7247$export$d507f25e63650365; });

var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $6vAtg = parcelRequire("6vAtg");

var $hyDkn = parcelRequire("hyDkn");

var $dMLJP = parcelRequire("dMLJP");

var $hMdcG = parcelRequire("hMdcG");

var $1QDT9 = parcelRequire("1QDT9");

var $4HJlA = parcelRequire("4HJlA");

var $iptjJ = parcelRequire("iptjJ");
// -- State --------------------------------------------- //
var $431eb4569d9c7247$var$state = (0, $hyDkn.proxy)({
    loading: false,
    open: false,
    shake: false
});
var $431eb4569d9c7247$export$d507f25e63650365 = {
    state: $431eb4569d9c7247$var$state,
    subscribe: function(callback) {
        return (0, $hyDkn.subscribe)($431eb4569d9c7247$var$state, function() {
            return callback($431eb4569d9c7247$var$state);
        });
    },
    subscribeKey: function(key, callback) {
        return (0, $6vAtg.subscribeKey)($431eb4569d9c7247$var$state, key, callback);
    },
    open: function(options) {
        return (0, $kSuI9._)(function() {
            var connected;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, $hMdcG.ApiController).state.prefetchPromise
                        ];
                    case 1:
                        _state.sent();
                        connected = (0, $dMLJP.AccountController).state.isConnected;
                        if (options === null || options === void 0 ? void 0 : options.view) (0, $iptjJ.RouterController).reset(options.view);
                        else if (connected) (0, $iptjJ.RouterController).reset("Account");
                        else (0, $iptjJ.RouterController).reset("Connect");
                        $431eb4569d9c7247$var$state.open = true;
                        (0, $4HJlA.PublicStateController).set({
                            open: true
                        });
                        (0, $1QDT9.EventsController).sendEvent({
                            type: "track",
                            event: "MODAL_OPEN",
                            properties: {
                                connected: connected
                            }
                        });
                        return [
                            2
                        ];
                }
            });
        })();
    },
    close: function() {
        var connected = (0, $dMLJP.AccountController).state.isConnected || false;
        $431eb4569d9c7247$var$state.open = false;
        (0, $4HJlA.PublicStateController).set({
            open: false
        });
        (0, $1QDT9.EventsController).sendEvent({
            type: "track",
            event: "MODAL_CLOSE",
            properties: {
                connected: connected
            }
        });
    },
    setLoading: function(loading) {
        $431eb4569d9c7247$var$state.loading = loading;
        (0, $4HJlA.PublicStateController).set({
            loading: loading
        });
    },
    shake: function() {
        if ($431eb4569d9c7247$var$state.shake) return;
        $431eb4569d9c7247$var$state.shake = true;
        setTimeout(function() {
            $431eb4569d9c7247$var$state.shake = false;
        }, 500);
    }
};

});
parcelRegister("6vAtg", function(module, exports) {

$parcel$export(module.exports, "subscribeKey", function () { return $a9ff159ce095d9c7$export$7faad7f6b3708314; });
$parcel$export(module.exports, "proxyMap", function () { return $a9ff159ce095d9c7$export$17aaac2670e0d2b9; });

var $9jBhZ = parcelRequire("9jBhZ");

var $3sHb8 = parcelRequire("3sHb8");

var $do9pw = parcelRequire("do9pw");

var $dRLPW = parcelRequire("dRLPW");

var $cv9Rk = parcelRequire("cv9Rk");

var $hyDkn = parcelRequire("hyDkn");
var $a9ff159ce095d9c7$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/valtio/esm/vanilla/utils.mjs"
});
function $a9ff159ce095d9c7$export$7faad7f6b3708314(proxyObject, key, callback, notifyInSync) {
    var prevValue = proxyObject[key];
    return (0, $hyDkn.subscribe)(proxyObject, function() {
        var nextValue = proxyObject[key];
        if (!Object.is(prevValue, nextValue)) callback(prevValue = nextValue);
    }, notifyInSync);
}
var $a9ff159ce095d9c7$var$currentCleanups;
function $a9ff159ce095d9c7$export$3db5d71bdb2d5499(callback, options) {
    var alive = true;
    var cleanups = /* @__PURE__ */ new Set();
    var subscriptions = /* @__PURE__ */ new Map();
    var cleanup = function() {
        if (alive) {
            alive = false;
            cleanups.forEach(function(clean) {
                return clean();
            });
            cleanups.clear();
            subscriptions.forEach(function(unsubscribe) {
                return unsubscribe();
            });
            subscriptions.clear();
        }
    };
    var revalidate = function() {
        if (!alive) return;
        cleanups.forEach(function(clean) {
            return clean();
        });
        cleanups.clear();
        var proxiesToSubscribe = /* @__PURE__ */ new Set();
        var parent = $a9ff159ce095d9c7$var$currentCleanups;
        $a9ff159ce095d9c7$var$currentCleanups = cleanups;
        try {
            var cleanupReturn = callback(function(proxyObject) {
                proxiesToSubscribe.add(proxyObject);
                return proxyObject;
            });
            if (cleanupReturn) cleanups.add(cleanupReturn);
        } finally{
            $a9ff159ce095d9c7$var$currentCleanups = parent;
        }
        subscriptions.forEach(function(unsubscribe, proxyObject) {
            if (proxiesToSubscribe.has(proxyObject)) proxiesToSubscribe.delete(proxyObject);
            else {
                subscriptions.delete(proxyObject);
                unsubscribe();
            }
        });
        proxiesToSubscribe.forEach(function(proxyObject) {
            var unsubscribe = (0, $hyDkn.subscribe)(proxyObject, revalidate, options == null ? void 0 : options.sync);
            subscriptions.set(proxyObject, unsubscribe);
        });
    };
    if ($a9ff159ce095d9c7$var$currentCleanups) $a9ff159ce095d9c7$var$currentCleanups.add(cleanup);
    revalidate();
    return cleanup;
}
var $a9ff159ce095d9c7$var$DEVTOOLS = Symbol();
function $a9ff159ce095d9c7$export$6922d3b3a607469e(proxyObject, options) {
    if (typeof options === "string") {
        console.warn("string name option is deprecated, use { name }. https://github.com/pmndrs/valtio/pull/400");
        options = {
            name: options
        };
    }
    var _ref = options || {}, enabled = _ref.enabled, _ref_name = _ref.name, name = _ref_name === void 0 ? "" : _ref_name, rest = (0, $dRLPW._)(_ref, [
        "enabled",
        "name"
    ]);
    var extension;
    try {
        extension = (enabled != null ? enabled : ($a9ff159ce095d9c7$import_meta.env ? $a9ff159ce095d9c7$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
    } catch (e) {}
    if (!extension) {
        if (($a9ff159ce095d9c7$import_meta.env ? $a9ff159ce095d9c7$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[Warning] Please install/enable Redux devtools extension");
        return;
    }
    var isTimeTraveling = false;
    var devtools2 = extension.connect((0, $do9pw._)({
        name: name
    }, rest));
    var unsub1 = (0, $hyDkn.subscribe)(proxyObject, function(ops) {
        var action = ops.filter(function(param) {
            var _param = (0, $cv9Rk._)(param, 2), _ = _param[0], path = _param[1];
            return path[0] !== $a9ff159ce095d9c7$var$DEVTOOLS;
        }).map(function(param) {
            var _param = (0, $cv9Rk._)(param, 2), op = _param[0], path = _param[1];
            return "".concat(op, ":").concat(path.map(String).join("."));
        }).join(", ");
        if (!action) return;
        if (isTimeTraveling) isTimeTraveling = false;
        else {
            var snapWithoutDevtools = Object.assign({}, (0, $hyDkn.snapshot)(proxyObject));
            delete snapWithoutDevtools[$a9ff159ce095d9c7$var$DEVTOOLS];
            devtools2.send({
                type: action,
                updatedAt: /* @__PURE__ */ new Date().toLocaleString()
            }, snapWithoutDevtools);
        }
    });
    var unsub2 = devtools2.subscribe(function(message) {
        var _a, _b, _c, _d, _e, _f;
        if (message.type === "ACTION" && message.payload) try {
            Object.assign(proxyObject, JSON.parse(message.payload));
        } catch (e) {
            console.error("please dispatch a serializable value that JSON.parse() and proxy() support\n", e);
        }
        if (message.type === "DISPATCH" && message.state) {
            if (((_a = message.payload) == null ? void 0 : _a.type) === "JUMP_TO_ACTION" || ((_b = message.payload) == null ? void 0 : _b.type) === "JUMP_TO_STATE") {
                isTimeTraveling = true;
                var state = JSON.parse(message.state);
                Object.assign(proxyObject, state);
            }
            proxyObject[$a9ff159ce095d9c7$var$DEVTOOLS] = message;
        } else if (message.type === "DISPATCH" && ((_c = message.payload) == null ? void 0 : _c.type) === "COMMIT") devtools2.init((0, $hyDkn.snapshot)(proxyObject));
        else if (message.type === "DISPATCH" && ((_d = message.payload) == null ? void 0 : _d.type) === "IMPORT_STATE") {
            var actions = (_e = message.payload.nextLiftedState) == null ? void 0 : _e.actionsById;
            var computedStates = ((_f = message.payload.nextLiftedState) == null ? void 0 : _f.computedStates) || [];
            isTimeTraveling = true;
            computedStates.forEach(function(param, index) {
                var state = param.state;
                var action = actions[index] || "No action found";
                Object.assign(proxyObject, state);
                if (index === 0) devtools2.init((0, $hyDkn.snapshot)(proxyObject));
                else devtools2.send(action, (0, $hyDkn.snapshot)(proxyObject));
            });
        }
    });
    devtools2.init((0, $hyDkn.snapshot)(proxyObject));
    return function() {
        unsub1();
        unsub2 == null || unsub2();
    };
}
var $a9ff159ce095d9c7$var$sourceObjectMap = /* @__PURE__ */ new WeakMap();
var $a9ff159ce095d9c7$var$derivedObjectMap = /* @__PURE__ */ new WeakMap();
var $a9ff159ce095d9c7$var$markPending = function(sourceObject, callback) {
    var sourceObjectEntry = $a9ff159ce095d9c7$var$sourceObjectMap.get(sourceObject);
    if (sourceObjectEntry) {
        sourceObjectEntry[0].forEach(function(subscription) {
            var derivedObject = subscription.d;
            if (sourceObject !== derivedObject) $a9ff159ce095d9c7$var$markPending(derivedObject);
        });
        ++sourceObjectEntry[2];
        if (callback) sourceObjectEntry[3].add(callback);
    }
};
var $a9ff159ce095d9c7$var$checkPending = function(sourceObject, callback) {
    var sourceObjectEntry = $a9ff159ce095d9c7$var$sourceObjectMap.get(sourceObject);
    if (sourceObjectEntry == null ? void 0 : sourceObjectEntry[2]) {
        sourceObjectEntry[3].add(callback);
        return true;
    }
    return false;
};
var $a9ff159ce095d9c7$var$unmarkPending = function(sourceObject) {
    var sourceObjectEntry = $a9ff159ce095d9c7$var$sourceObjectMap.get(sourceObject);
    if (sourceObjectEntry) {
        --sourceObjectEntry[2];
        if (!sourceObjectEntry[2]) {
            sourceObjectEntry[3].forEach(function(callback) {
                return callback();
            });
            sourceObjectEntry[3].clear();
        }
        sourceObjectEntry[0].forEach(function(subscription) {
            var derivedObject = subscription.d;
            if (sourceObject !== derivedObject) $a9ff159ce095d9c7$var$unmarkPending(derivedObject);
        });
    }
};
var $a9ff159ce095d9c7$var$addSubscription = function(subscription) {
    var sourceObject = subscription.s, derivedObject = subscription.d;
    var derivedObjectEntry = $a9ff159ce095d9c7$var$derivedObjectMap.get(derivedObject);
    if (!derivedObjectEntry) {
        derivedObjectEntry = [
            /* @__PURE__ */ new Set()
        ];
        $a9ff159ce095d9c7$var$derivedObjectMap.set(subscription.d, derivedObjectEntry);
    }
    derivedObjectEntry[0].add(subscription);
    var sourceObjectEntry = $a9ff159ce095d9c7$var$sourceObjectMap.get(sourceObject);
    if (!sourceObjectEntry) {
        var subscriptions = /* @__PURE__ */ new Set();
        var unsubscribe = (0, $hyDkn.subscribe)(sourceObject, function(ops) {
            subscriptions.forEach(function(subscription2) {
                var derivedObject2 = subscription2.d, callback = subscription2.c, notifyInSync = subscription2.n, ignoreKeys = subscription2.i;
                if (sourceObject === derivedObject2 && ops.every(function(op) {
                    return op[1].length === 1 && ignoreKeys.includes(op[1][0]);
                })) return;
                if (subscription2.p) return;
                $a9ff159ce095d9c7$var$markPending(sourceObject, callback);
                if (notifyInSync) $a9ff159ce095d9c7$var$unmarkPending(sourceObject);
                else subscription2.p = Promise.resolve().then(function() {
                    delete subscription2.p;
                    $a9ff159ce095d9c7$var$unmarkPending(sourceObject);
                });
            });
        }, true);
        sourceObjectEntry = [
            subscriptions,
            unsubscribe,
            0,
            /* @__PURE__ */ new Set()
        ];
        $a9ff159ce095d9c7$var$sourceObjectMap.set(sourceObject, sourceObjectEntry);
    }
    sourceObjectEntry[0].add(subscription);
};
var $a9ff159ce095d9c7$var$removeSubscription = function(subscription) {
    var sourceObject = subscription.s, derivedObject = subscription.d;
    var derivedObjectEntry = $a9ff159ce095d9c7$var$derivedObjectMap.get(derivedObject);
    derivedObjectEntry == null || derivedObjectEntry[0].delete(subscription);
    if ((derivedObjectEntry == null ? void 0 : derivedObjectEntry[0].size) === 0) $a9ff159ce095d9c7$var$derivedObjectMap.delete(derivedObject);
    var sourceObjectEntry = $a9ff159ce095d9c7$var$sourceObjectMap.get(sourceObject);
    if (sourceObjectEntry) {
        var _sourceObjectEntry = (0, $cv9Rk._)(sourceObjectEntry, 2), subscriptions = _sourceObjectEntry[0], unsubscribe = _sourceObjectEntry[1];
        subscriptions.delete(subscription);
        if (!subscriptions.size) {
            unsubscribe();
            $a9ff159ce095d9c7$var$sourceObjectMap.delete(sourceObject);
        }
    }
};
var $a9ff159ce095d9c7$var$listSubscriptions = function(derivedObject) {
    var derivedObjectEntry = $a9ff159ce095d9c7$var$derivedObjectMap.get(derivedObject);
    if (derivedObjectEntry) return Array.from(derivedObjectEntry[0]);
    return [];
};
var $a9ff159ce095d9c7$export$5bb85a5dcd872eb9 = {
    add: $a9ff159ce095d9c7$var$addSubscription,
    remove: $a9ff159ce095d9c7$var$removeSubscription,
    list: $a9ff159ce095d9c7$var$listSubscriptions
};
function $a9ff159ce095d9c7$export$78ed5b3305815fc7(derivedFns, options) {
    var proxyObject = (options == null ? void 0 : options.proxy) || (0, $hyDkn.proxy)({});
    var notifyInSync = !!(options == null ? void 0 : options.sync);
    var derivedKeys = Object.keys(derivedFns);
    derivedKeys.forEach(function(key) {
        if (Object.getOwnPropertyDescriptor(proxyObject, key)) throw new Error("object property already defined");
        var fn = derivedFns[key];
        var lastDependencies = null;
        var evaluate = function() {
            if (lastDependencies) {
                if (Array.from(lastDependencies).map(function(param) {
                    var _param = (0, $cv9Rk._)(param, 1), p = _param[0];
                    return $a9ff159ce095d9c7$var$checkPending(p, evaluate);
                }).some(function(isPending) {
                    return isPending;
                })) return;
                if (Array.from(lastDependencies).every(function(param) {
                    var _param = (0, $cv9Rk._)(param, 2), p = _param[0], entry = _param[1];
                    return (0, $hyDkn.getVersion)(p) === entry.v;
                })) return;
            }
            var dependencies = /* @__PURE__ */ new Map();
            var get = function(p) {
                dependencies.set(p, {
                    v: (0, $hyDkn.getVersion)(p)
                });
                return p;
            };
            var value = fn(get);
            var subscribeToDependencies = function() {
                dependencies.forEach(function(entry, p) {
                    var _a;
                    var lastSubscription = (_a = lastDependencies == null ? void 0 : lastDependencies.get(p)) == null ? void 0 : _a.s;
                    if (lastSubscription) entry.s = lastSubscription;
                    else {
                        var subscription = {
                            s: p,
                            // sourceObject
                            d: proxyObject,
                            // derivedObject
                            k: key,
                            // derived key
                            c: evaluate,
                            // callback
                            n: notifyInSync,
                            i: derivedKeys
                        };
                        $a9ff159ce095d9c7$var$addSubscription(subscription);
                        entry.s = subscription;
                    }
                });
                lastDependencies == null || lastDependencies.forEach(function(entry, p) {
                    if (!dependencies.has(p) && entry.s) $a9ff159ce095d9c7$var$removeSubscription(entry.s);
                });
                lastDependencies = dependencies;
            };
            if (value instanceof Promise) value.finally(subscribeToDependencies);
            else subscribeToDependencies();
            proxyObject[key] = value;
        };
        evaluate();
    });
    return proxyObject;
}
function $a9ff159ce095d9c7$export$992ed2abb18cb90(proxyObject, options) {
    var keysToDelete = (options == null ? void 0 : options.delete) ? /* @__PURE__ */ new Set() : null;
    $a9ff159ce095d9c7$var$listSubscriptions(proxyObject).forEach(function(subscription) {
        var key = subscription.k;
        if (!(options == null ? void 0 : options.keys) || options.keys.includes(key)) {
            $a9ff159ce095d9c7$var$removeSubscription(subscription);
            if (keysToDelete) keysToDelete.add(key);
        }
    });
    if (keysToDelete) keysToDelete.forEach(function(key) {
        delete proxyObject[key];
    });
}
function $a9ff159ce095d9c7$export$b84fff6f79a56fa3(proxyObject, computedFns_FAKE) {
    var targetObject = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : proxyObject;
    if (($a9ff159ce095d9c7$import_meta.env ? $a9ff159ce095d9c7$import_meta.env.MODE : void 0) !== "production") console.warn("addComputed is deprecated. Please consider using `derive`. Falling back to emulation with derive. https://github.com/pmndrs/valtio/pull/201");
    var derivedFns = {};
    Object.keys(computedFns_FAKE).forEach(function(key) {
        derivedFns[key] = function(get) {
            return computedFns_FAKE[key](get(proxyObject));
        };
    });
    return $a9ff159ce095d9c7$export$78ed5b3305815fc7(derivedFns, {
        proxy: targetObject
    });
}
function $a9ff159ce095d9c7$export$64a33e9109220e08(initialObject, computedFns) {
    if (($a9ff159ce095d9c7$import_meta.env ? $a9ff159ce095d9c7$import_meta.env.MODE : void 0) !== "production") console.warn('proxyWithComputed is deprecated. Please follow "Computed Properties" guide in docs.');
    Object.keys(computedFns).forEach(function(key) {
        if (Object.getOwnPropertyDescriptor(initialObject, key)) throw new Error("object property already defined");
        var computedFn = computedFns[key];
        var _ref = typeof computedFn === "function" ? {
            get: computedFn
        } : computedFn, get = _ref.get, set = _ref.set;
        var desc = {};
        desc.get = function() {
            return get((0, $hyDkn.snapshot)(proxyObject));
        };
        if (set) desc.set = function(newValue) {
            return set(proxyObject, newValue);
        };
        Object.defineProperty(initialObject, key, desc);
    });
    var proxyObject = (0, $hyDkn.proxy)(initialObject);
    return proxyObject;
}
var $a9ff159ce095d9c7$var$isObject = function(x) {
    return typeof x === "object" && x !== null;
};
var $a9ff159ce095d9c7$var$refSet;
var $a9ff159ce095d9c7$var$deepClone = function(obj) {
    if (!$a9ff159ce095d9c7$var$refSet) $a9ff159ce095d9c7$var$refSet = (0, $hyDkn.unstable_buildProxyFunction)()[2];
    if (!$a9ff159ce095d9c7$var$isObject(obj) || $a9ff159ce095d9c7$var$refSet.has(obj)) return obj;
    var baseObject = Array.isArray(obj) ? [] : Object.create(Object.getPrototypeOf(obj));
    Reflect.ownKeys(obj).forEach(function(key) {
        baseObject[key] = $a9ff159ce095d9c7$var$deepClone(obj[key]);
    });
    return baseObject;
};
function $a9ff159ce095d9c7$export$32f3091caa3ecf1e(initialValue) {
    var skipSubscribe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var proxyObject = (0, $hyDkn.proxy)({
        value: initialValue,
        history: (0, $hyDkn.ref)({
            wip: void 0,
            // to avoid infinite loop
            snapshots: [],
            index: -1
        }),
        clone: $a9ff159ce095d9c7$var$deepClone,
        canUndo: function() {
            return proxyObject.history.index > 0;
        },
        undo: function() {
            if (proxyObject.canUndo()) proxyObject.value = proxyObject.history.wip = proxyObject.clone(proxyObject.history.snapshots[--proxyObject.history.index]);
        },
        canRedo: function() {
            return proxyObject.history.index < proxyObject.history.snapshots.length - 1;
        },
        redo: function() {
            if (proxyObject.canRedo()) proxyObject.value = proxyObject.history.wip = proxyObject.clone(proxyObject.history.snapshots[++proxyObject.history.index]);
        },
        saveHistory: function() {
            proxyObject.history.snapshots.splice(proxyObject.history.index + 1);
            proxyObject.history.snapshots.push((0, $hyDkn.snapshot)(proxyObject).value);
            ++proxyObject.history.index;
        },
        subscribe: function() {
            return (0, $hyDkn.subscribe)(proxyObject, function(ops) {
                if (ops.every(function(op) {
                    return op[1][0] === "value" && (op[0] !== "set" || op[2] !== proxyObject.history.wip);
                })) proxyObject.saveHistory();
            });
        }
    });
    proxyObject.saveHistory();
    if (!skipSubscribe) proxyObject.subscribe();
    return proxyObject;
}
function $a9ff159ce095d9c7$export$339ebc24fb22ad80(initialValues) {
    var _obj, _mutatorMap = {};
    var set = (0, $hyDkn.proxy)((_obj = {
        data: Array.from(new Set(initialValues)),
        has: function(value) {
            return this.data.indexOf(value) !== -1;
        },
        add: function(value) {
            var hasProxy = false;
            if (typeof value === "object" && value !== null) hasProxy = this.data.indexOf((0, $hyDkn.proxy)(value)) !== -1;
            if (this.data.indexOf(value) === -1 && !hasProxy) this.data.push(value);
            return this;
        },
        delete: function(value) {
            var index = this.data.indexOf(value);
            if (index === -1) return false;
            this.data.splice(index, 1);
            return true;
        },
        clear: function() {
            this.data.splice(0);
        },
        get size () {
            return this.data.length;
        },
        forEach: function(cb) {
            var _this = this;
            this.data.forEach(function(value) {
                cb(value, value, _this);
            });
        }
    }, _mutatorMap[Symbol.toStringTag] = _mutatorMap[Symbol.toStringTag] || {}, _mutatorMap[Symbol.toStringTag].get = function() {
        return "Set";
    }, (0, $3sHb8._)(_obj, "toJSON", function() {
        return new Set(this.data);
    }), (0, $3sHb8._)(_obj, Symbol.iterator, function() {
        return this.data[Symbol.iterator]();
    }), (0, $3sHb8._)(_obj, "values", function() {
        return this.data.values();
    }), (0, $3sHb8._)(_obj, "keys", function() {
        return this.data.values();
    }), (0, $3sHb8._)(_obj, "entries", function() {
        return new Set(this.data).entries();
    }), (0, $9jBhZ._)(_obj, _mutatorMap), _obj));
    Object.defineProperties(set, {
        data: {
            enumerable: false
        },
        size: {
            enumerable: false
        },
        toJSON: {
            enumerable: false
        }
    });
    Object.seal(set);
    return set;
}
function $a9ff159ce095d9c7$export$17aaac2670e0d2b9(entries) {
    var _obj, _mutatorMap = {};
    var map = (0, $hyDkn.proxy)((_obj = {
        data: Array.from(entries || []),
        has: function(key) {
            return this.data.some(function(p) {
                return p[0] === key;
            });
        },
        set: function(key, value) {
            var record = this.data.find(function(p) {
                return p[0] === key;
            });
            if (record) record[1] = value;
            else this.data.push([
                key,
                value
            ]);
            return this;
        },
        get: function(key) {
            var _a;
            return (_a = this.data.find(function(p) {
                return p[0] === key;
            })) == null ? void 0 : _a[1];
        },
        delete: function(key) {
            var index = this.data.findIndex(function(p) {
                return p[0] === key;
            });
            if (index === -1) return false;
            this.data.splice(index, 1);
            return true;
        },
        clear: function() {
            this.data.splice(0);
        },
        get size () {
            return this.data.length;
        },
        toJSON: function() {
            return new Map(this.data);
        },
        forEach: function(cb) {
            var _this = this;
            this.data.forEach(function(p) {
                cb(p[1], p[0], _this);
            });
        },
        keys: function() {
            return this.data.map(function(p) {
                return p[0];
            }).values();
        },
        values: function() {
            return this.data.map(function(p) {
                return p[1];
            }).values();
        },
        entries: function() {
            return new Map(this.data).entries();
        }
    }, _mutatorMap[Symbol.toStringTag] = _mutatorMap[Symbol.toStringTag] || {}, _mutatorMap[Symbol.toStringTag].get = function() {
        return "Map";
    }, (0, $3sHb8._)(_obj, Symbol.iterator, function() {
        return this.entries();
    }), (0, $9jBhZ._)(_obj, _mutatorMap), _obj));
    Object.defineProperties(map, {
        data: {
            enumerable: false
        },
        size: {
            enumerable: false
        },
        toJSON: {
            enumerable: false
        }
    });
    Object.seal(map);
    return map;
}

});
parcelRegister("9jBhZ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6c82d04369441379$export$71511d61b312f219; });
function $6c82d04369441379$export$71511d61b312f219(obj, descs) {
    for(var key in descs){
        var desc = descs[key];
        desc.configurable = desc.enumerable = true;
        if ("value" in desc) desc.writable = true;
        Object.defineProperty(obj, key, desc);
    }
    if (Object.getOwnPropertySymbols) {
        var objectSymbols = Object.getOwnPropertySymbols(descs);
        for(var i = 0; i < objectSymbols.length; i++){
            var sym = objectSymbols[i];
            var desc = descs[sym];
            desc.configurable = desc.enumerable = true;
            if ("value" in desc) desc.writable = true;
            Object.defineProperty(obj, sym, desc);
        }
    }
    return obj;
}

});

parcelRegister("hyDkn", function(module, exports) {

$parcel$export(module.exports, "proxy", function () { return $65769ecb51dccd8b$export$923f96dd5afa9ce6; });
$parcel$export(module.exports, "getVersion", function () { return $65769ecb51dccd8b$export$c506eb22e615ba4a; });
$parcel$export(module.exports, "subscribe", function () { return $65769ecb51dccd8b$export$ec068583843480e7; });
$parcel$export(module.exports, "snapshot", function () { return $65769ecb51dccd8b$export$b8801ea43165ed7d; });
$parcel$export(module.exports, "ref", function () { return $65769ecb51dccd8b$export$eff4d24c3ff7876e; });
$parcel$export(module.exports, "unstable_buildProxyFunction", function () { return $65769ecb51dccd8b$export$e7b04d37d9502758; });

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $2WS8n = parcelRequire("2WS8n");
var $65769ecb51dccd8b$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/valtio/esm/vanilla.mjs"
});
var $65769ecb51dccd8b$var$isObject = function(x) {
    return typeof x === "object" && x !== null;
};
var $65769ecb51dccd8b$var$proxyStateMap = /* @__PURE__ */ new WeakMap();
var $65769ecb51dccd8b$var$refSet = /* @__PURE__ */ new WeakSet();
var $65769ecb51dccd8b$var$buildProxyFunction = function() {
    var objectIs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Object.is, newProxy = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function(target, handler) {
        return new Proxy(target, handler);
    }, canProxy = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function(x) {
        return $65769ecb51dccd8b$var$isObject(x) && !$65769ecb51dccd8b$var$refSet.has(x) && (Array.isArray(x) || !(Symbol.iterator in x)) && !(x instanceof WeakMap) && !(x instanceof WeakSet) && !(x instanceof Error) && !(x instanceof Number) && !(x instanceof Date) && !(x instanceof String) && !(x instanceof RegExp) && !(x instanceof ArrayBuffer);
    }, defaultHandlePromise = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : function(promise) {
        switch(promise.status){
            case "fulfilled":
                return promise.value;
            case "rejected":
                throw promise.reason;
            default:
                throw promise;
        }
    }, snapCache = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : /* @__PURE__ */ new WeakMap(), createSnapshot = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : function(target, version) {
        var handlePromise = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultHandlePromise;
        var cache = snapCache.get(target);
        if ((cache == null ? void 0 : cache[0]) === version) return cache[1];
        var snap = Array.isArray(target) ? [] : Object.create(Object.getPrototypeOf(target));
        (0, $2WS8n.markToTrack)(snap, true);
        snapCache.set(target, [
            version,
            snap
        ]);
        Reflect.ownKeys(target).forEach(function(key) {
            if (Object.getOwnPropertyDescriptor(snap, key)) return;
            var value = Reflect.get(target, key);
            var desc = {
                value: value,
                enumerable: true,
                // This is intentional to avoid copying with proxy-compare.
                // It's still non-writable, so it avoids assigning a value.
                configurable: true
            };
            if ($65769ecb51dccd8b$var$refSet.has(value)) (0, $2WS8n.markToTrack)(value, false);
            else if (value instanceof Promise) {
                delete desc.value;
                desc.get = function() {
                    return handlePromise(value);
                };
            } else if ($65769ecb51dccd8b$var$proxyStateMap.has(value)) {
                var _proxyStateMap_get = (0, $cv9Rk._)($65769ecb51dccd8b$var$proxyStateMap.get(value), 2), target2 = _proxyStateMap_get[0], ensureVersion = _proxyStateMap_get[1];
                desc.value = createSnapshot(target2, ensureVersion(), handlePromise);
            }
            Object.defineProperty(snap, key, desc);
        });
        return Object.preventExtensions(snap);
    }, proxyCache = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : /* @__PURE__ */ new WeakMap(), versionHolder = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : [
        1,
        1
    ], proxyFunction = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : function(initialObject) {
        if (!$65769ecb51dccd8b$var$isObject(initialObject)) throw new Error("object required");
        var found = proxyCache.get(initialObject);
        if (found) return found;
        var version = versionHolder[0];
        var listeners = /* @__PURE__ */ new Set();
        var notifyUpdate = function(op) {
            var nextVersion = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ++versionHolder[0];
            if (version !== nextVersion) {
                version = nextVersion;
                listeners.forEach(function(listener) {
                    return listener(op, nextVersion);
                });
            }
        };
        var checkVersion = versionHolder[1];
        var ensureVersion = function() {
            var nextCheckVersion = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ++versionHolder[1];
            if (checkVersion !== nextCheckVersion && !listeners.size) {
                checkVersion = nextCheckVersion;
                propProxyStates.forEach(function(param) {
                    var _param = (0, $cv9Rk._)(param, 1), propProxyState = _param[0];
                    var propVersion = propProxyState[1](nextCheckVersion);
                    if (propVersion > version) version = propVersion;
                });
            }
            return version;
        };
        var createPropListener = function(prop) {
            return function(op, nextVersion) {
                var newOp = (0, $c6Xmf._)(op);
                newOp[1] = [
                    prop
                ].concat((0, $c6Xmf._)(newOp[1]));
                notifyUpdate(newOp, nextVersion);
            };
        };
        var propProxyStates = /* @__PURE__ */ new Map();
        var addPropListener = function(prop, propProxyState) {
            if (($65769ecb51dccd8b$import_meta.env ? $65769ecb51dccd8b$import_meta.env.MODE : void 0) !== "production" && propProxyStates.has(prop)) throw new Error("prop listener already exists");
            if (listeners.size) {
                var remove = propProxyState[3](createPropListener(prop));
                propProxyStates.set(prop, [
                    propProxyState,
                    remove
                ]);
            } else propProxyStates.set(prop, [
                propProxyState
            ]);
        };
        var removePropListener = function(prop) {
            var _a;
            var entry = propProxyStates.get(prop);
            if (entry) {
                propProxyStates.delete(prop);
                (_a = entry[1]) == null || _a.call(entry);
            }
        };
        var addListener = function(listener) {
            listeners.add(listener);
            if (listeners.size === 1) propProxyStates.forEach(function(param, prop) {
                var _param = (0, $cv9Rk._)(param, 2), propProxyState = _param[0], prevRemove = _param[1];
                if (($65769ecb51dccd8b$import_meta.env ? $65769ecb51dccd8b$import_meta.env.MODE : void 0) !== "production" && prevRemove) throw new Error("remove already exists");
                var remove = propProxyState[3](createPropListener(prop));
                propProxyStates.set(prop, [
                    propProxyState,
                    remove
                ]);
            });
            var removeListener = function() {
                listeners.delete(listener);
                if (listeners.size === 0) propProxyStates.forEach(function(param, prop) {
                    var _param = (0, $cv9Rk._)(param, 2), propProxyState = _param[0], remove = _param[1];
                    if (remove) {
                        remove();
                        propProxyStates.set(prop, [
                            propProxyState
                        ]);
                    }
                });
            };
            return removeListener;
        };
        var baseObject = Array.isArray(initialObject) ? [] : Object.create(Object.getPrototypeOf(initialObject));
        var handler = {
            deleteProperty: function(target, prop) {
                var prevValue = Reflect.get(target, prop);
                removePropListener(prop);
                var deleted = Reflect.deleteProperty(target, prop);
                if (deleted) notifyUpdate([
                    "delete",
                    [
                        prop
                    ],
                    prevValue
                ]);
                return deleted;
            },
            set: function(target, prop, value, receiver) {
                var hasPrevValue = Reflect.has(target, prop);
                var prevValue = Reflect.get(target, prop, receiver);
                if (hasPrevValue && (objectIs(prevValue, value) || proxyCache.has(value) && objectIs(prevValue, proxyCache.get(value)))) return true;
                removePropListener(prop);
                if ($65769ecb51dccd8b$var$isObject(value)) value = (0, $2WS8n.getUntracked)(value) || value;
                var nextValue = value;
                if (value instanceof Promise) value.then(function(v) {
                    value.status = "fulfilled";
                    value.value = v;
                    notifyUpdate([
                        "resolve",
                        [
                            prop
                        ],
                        v
                    ]);
                }).catch(function(e) {
                    value.status = "rejected";
                    value.reason = e;
                    notifyUpdate([
                        "reject",
                        [
                            prop
                        ],
                        e
                    ]);
                });
                else {
                    if (!$65769ecb51dccd8b$var$proxyStateMap.has(value) && canProxy(value)) nextValue = proxyFunction(value);
                    var childProxyState = !$65769ecb51dccd8b$var$refSet.has(nextValue) && $65769ecb51dccd8b$var$proxyStateMap.get(nextValue);
                    if (childProxyState) addPropListener(prop, childProxyState);
                }
                Reflect.set(target, prop, nextValue, receiver);
                notifyUpdate([
                    "set",
                    [
                        prop
                    ],
                    value,
                    prevValue
                ]);
                return true;
            }
        };
        var proxyObject = newProxy(baseObject, handler);
        proxyCache.set(initialObject, proxyObject);
        var proxyState = [
            baseObject,
            ensureVersion,
            createSnapshot,
            addListener
        ];
        $65769ecb51dccd8b$var$proxyStateMap.set(proxyObject, proxyState);
        Reflect.ownKeys(initialObject).forEach(function(key) {
            var desc = Object.getOwnPropertyDescriptor(initialObject, key);
            if ("value" in desc) {
                proxyObject[key] = initialObject[key];
                delete desc.value;
                delete desc.writable;
            }
            Object.defineProperty(baseObject, key, desc);
        });
        return proxyObject;
    };
    return [
        // public functions
        proxyFunction,
        // shared state
        $65769ecb51dccd8b$var$proxyStateMap,
        $65769ecb51dccd8b$var$refSet,
        // internal things
        objectIs,
        newProxy,
        canProxy,
        defaultHandlePromise,
        snapCache,
        createSnapshot,
        proxyCache,
        versionHolder
    ];
};
var $65769ecb51dccd8b$var$_buildProxyFunction = (0, $cv9Rk._)($65769ecb51dccd8b$var$buildProxyFunction(), 1), $65769ecb51dccd8b$var$defaultProxyFunction = $65769ecb51dccd8b$var$_buildProxyFunction[0];
function $65769ecb51dccd8b$export$923f96dd5afa9ce6() {
    var initialObject = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return $65769ecb51dccd8b$var$defaultProxyFunction(initialObject);
}
function $65769ecb51dccd8b$export$c506eb22e615ba4a(proxyObject) {
    var proxyState = $65769ecb51dccd8b$var$proxyStateMap.get(proxyObject);
    return proxyState == null ? void 0 : proxyState[1]();
}
function $65769ecb51dccd8b$export$ec068583843480e7(proxyObject, callback, notifyInSync) {
    var proxyState = $65769ecb51dccd8b$var$proxyStateMap.get(proxyObject);
    if (($65769ecb51dccd8b$import_meta.env ? $65769ecb51dccd8b$import_meta.env.MODE : void 0) !== "production" && !proxyState) console.warn("Please use proxy object");
    var promise;
    var ops = [];
    var addListener = proxyState[3];
    var isListenerActive = false;
    var listener = function(op) {
        ops.push(op);
        if (notifyInSync) {
            callback(ops.splice(0));
            return;
        }
        if (!promise) promise = Promise.resolve().then(function() {
            promise = void 0;
            if (isListenerActive) callback(ops.splice(0));
        });
    };
    var removeListener = addListener(listener);
    isListenerActive = true;
    return function() {
        isListenerActive = false;
        removeListener();
    };
}
function $65769ecb51dccd8b$export$b8801ea43165ed7d(proxyObject, handlePromise) {
    var proxyState = $65769ecb51dccd8b$var$proxyStateMap.get(proxyObject);
    if (($65769ecb51dccd8b$import_meta.env ? $65769ecb51dccd8b$import_meta.env.MODE : void 0) !== "production" && !proxyState) console.warn("Please use proxy object");
    var _proxyState = (0, $cv9Rk._)(proxyState, 3), target = _proxyState[0], ensureVersion = _proxyState[1], createSnapshot = _proxyState[2];
    return createSnapshot(target, ensureVersion(), handlePromise);
}
function $65769ecb51dccd8b$export$eff4d24c3ff7876e(obj) {
    $65769ecb51dccd8b$var$refSet.add(obj);
    return obj;
}
var $65769ecb51dccd8b$export$e7b04d37d9502758 = $65769ecb51dccd8b$var$buildProxyFunction;

});
parcelRegister("2WS8n", function(module, exports) {

$parcel$export(module.exports, "getUntracked", function () { return $225afd79517e27ad$export$80d2cee7ee556e99; });
$parcel$export(module.exports, "markToTrack", function () { return $225afd79517e27ad$export$2c8383c890e26a1c; });

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");
var $225afd79517e27ad$var$e = Symbol(), $225afd79517e27ad$var$t = Symbol(), $225afd79517e27ad$var$r = "a", $225afd79517e27ad$var$n = "w";
var $225afd79517e27ad$var$o = function(e, t) {
    return new Proxy(e, t);
};
var $225afd79517e27ad$var$s = Object.getPrototypeOf, $225afd79517e27ad$var$c = new WeakMap, $225afd79517e27ad$var$l = function(e) {
    return e && ($225afd79517e27ad$var$c.has(e) ? $225afd79517e27ad$var$c.get(e) : $225afd79517e27ad$var$s(e) === Object.prototype || $225afd79517e27ad$var$s(e) === Array.prototype);
}, $225afd79517e27ad$var$f = function(e) {
    return "object" == typeof e && null !== e;
}, $225afd79517e27ad$var$i = function(e) {
    if (Array.isArray(e)) return Array.from(e);
    var t = Object.getOwnPropertyDescriptors(e);
    return Object.values(t).forEach(function(e) {
        e.configurable = !0;
    }), Object.create($225afd79517e27ad$var$s(e), t);
}, $225afd79517e27ad$var$u = function(e) {
    return e[$225afd79517e27ad$var$t] || e;
}, $225afd79517e27ad$export$7865d0c7f908de6b = function(s, c, f, p) {
    if (!$225afd79517e27ad$var$l(s)) return s;
    var g = p && p.get(s);
    if (!g) {
        var e1 = $225afd79517e27ad$var$u(s);
        g = function(e) {
            return Object.values(Object.getOwnPropertyDescriptors(e)).some(function(e) {
                return !e.configurable && !e.writable;
            });
        }(e1) ? [
            e1,
            $225afd79517e27ad$var$i(e1)
        ] : [
            e1
        ], null == p || p.set(s, g);
    }
    var _g = (0, $cv9Rk._)(g, 2), y = _g[0], h = _g[1];
    var w = f && f.get(y);
    return w && w[1].f === !!h || (w = function(o, s) {
        var _$c = {
            f: s
        };
        var l = !1;
        var _$f = function(e, t) {
            if (!l) {
                var _$s = _$c[$225afd79517e27ad$var$r].get(o);
                if (_$s || (_$s = {}, _$c[$225afd79517e27ad$var$r].set(o, _$s)), e === $225afd79517e27ad$var$n) _$s[$225afd79517e27ad$var$n] = !0;
                else {
                    var r1 = _$s[e];
                    r1 || (r1 = new Set, _$s[e] = r1), r1.add(t);
                }
            }
        }, i = {
            get: function(e, n) {
                return n === $225afd79517e27ad$var$t ? o : (_$f("k", n), $225afd79517e27ad$export$7865d0c7f908de6b(Reflect.get(e, n), _$c[$225afd79517e27ad$var$r], _$c.c, _$c.t));
            },
            has: function(t, n) {
                return n === $225afd79517e27ad$var$e ? (l = !0, _$c[$225afd79517e27ad$var$r].delete(o), !0) : (_$f("h", n), Reflect.has(t, n));
            },
            getOwnPropertyDescriptor: function(e, t) {
                return _$f("o", t), Reflect.getOwnPropertyDescriptor(e, t);
            },
            ownKeys: function(e) {
                return _$f($225afd79517e27ad$var$n), Reflect.ownKeys(e);
            }
        };
        return s && (i.set = i.deleteProperty = function() {
            return !1;
        }), [
            i,
            _$c
        ];
    }(y, !!h), w[1].p = $225afd79517e27ad$var$o(h || y, w[0]), f && f.set(y, w)), w[1][$225afd79517e27ad$var$r] = c, w[1].c = f, w[1].t = p, w[1].p;
}, $225afd79517e27ad$export$3a85b3f4caf02b6f = function(e, t, r, o) {
    if (Object.is(e, t)) return !1;
    if (!$225afd79517e27ad$var$f(e) || !$225afd79517e27ad$var$f(t)) return !0;
    var s = r.get($225afd79517e27ad$var$u(e));
    if (!s) return !0;
    if (o) {
        var _$r = o.get(e);
        if (_$r && _$r.n === t) return _$r.g;
        o.set(e, {
            n: t,
            g: !1
        });
    }
    var c = null;
    try {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = (s.h || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _$r1 = _step.value;
                if (c = Reflect.has(e, _$r1) !== Reflect.has(t, _$r1), c) return c;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        if (!0 === s[$225afd79517e27ad$var$n]) {
            if (c = function(e, t) {
                var _$r = Reflect.ownKeys(e), n = Reflect.ownKeys(t);
                return _$r.length !== n.length || _$r.some(function(e, t) {
                    return e !== n[t];
                });
            }(e, t), c) return c;
        } else try {
            for(var _iterator1 = (s.o || [])[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var _$r2 = _step1.value;
                if (c = !!Reflect.getOwnPropertyDescriptor(e, _$r2) != !!Reflect.getOwnPropertyDescriptor(t, _$r2), c) return c;
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
        try {
            for(var _iterator2 = (s.k || [])[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                var n1 = _step2.value;
                if (c = $225afd79517e27ad$export$3a85b3f4caf02b6f(e[n1], t[n1], r, o), c) return c;
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                    _iterator2.return();
                }
            } finally{
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
        return null === c && (c = !0), c;
    } finally{
        o && o.set(e, {
            n: t,
            g: c
        });
    }
}, $225afd79517e27ad$export$badc26589cf7bb38 = function(t) {
    return !!$225afd79517e27ad$var$l(t) && $225afd79517e27ad$var$e in t;
}, $225afd79517e27ad$export$80d2cee7ee556e99 = function(e) {
    return $225afd79517e27ad$var$l(e) && e[$225afd79517e27ad$var$t] || null;
}, $225afd79517e27ad$export$2c8383c890e26a1c = function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    $225afd79517e27ad$var$c.set(e, t);
}, $225afd79517e27ad$export$10e85fc10e680a16 = function(e, t, r) {
    var o = [], s = new WeakSet, c = function(e, l) {
        if (s.has(e)) return;
        $225afd79517e27ad$var$f(e) && s.add(e);
        var i = $225afd79517e27ad$var$f(e) && t.get($225afd79517e27ad$var$u(e));
        if (i) {
            var a, p;
            if (null == (a = i.h) || a.forEach(function(e) {
                var _$t = ":has(".concat(String(e), ")");
                o.push(l ? (0, $c6Xmf._)(l).concat([
                    _$t
                ]) : [
                    _$t
                ]);
            }), !0 === i[$225afd79517e27ad$var$n]) {
                var _$e = ":ownKeys";
                o.push(l ? (0, $c6Xmf._)(l).concat([
                    _$e
                ]) : [
                    _$e
                ]);
            } else {
                var g;
                null == (g = i.o) || g.forEach(function(e) {
                    var _$t = ":hasOwn(".concat(String(e), ")");
                    o.push(l ? (0, $c6Xmf._)(l).concat([
                        _$t
                    ]) : [
                        _$t
                    ]);
                });
            }
            null == (p = i.k) || p.forEach(function(t) {
                r && !("value" in (Object.getOwnPropertyDescriptor(e, t) || {})) || c(e[t], l ? (0, $c6Xmf._)(l).concat([
                    t
                ]) : [
                    t
                ]);
            });
        } else l && o.push(l);
    };
    return c(e), o;
}, $225afd79517e27ad$export$9b4d5450dbd8e67e = function(e) {
    $225afd79517e27ad$var$o = e;
};

});



parcelRegister("dMLJP", function(module, exports) {

$parcel$export(module.exports, "AccountController", function () { return $a094c9dde8f3f16e$export$3a40b83c1282ee40; });

var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $hZBJb = parcelRequire("hZBJb");

var $jrvVk = parcelRequire("jrvVk");

var $8FcCV = parcelRequire("8FcCV");

var $8DzeN = parcelRequire("8DzeN");

var $4Tiue = parcelRequire("4Tiue");

var $9zDWP = parcelRequire("9zDWP");

var $fPqxb = parcelRequire("fPqxb");

var $hyDkn = parcelRequire("hyDkn");
// -- State --------------------------------------------- //
var $a094c9dde8f3f16e$var$state = (0, $hyDkn.proxy)({
    isConnected: false,
    currentTab: 0,
    tokenBalance: [],
    smartAccountDeployed: false,
    addressLabels: new Map(),
    allAccounts: []
});
var $a094c9dde8f3f16e$export$3a40b83c1282ee40 = {
    state: $a094c9dde8f3f16e$var$state,
    replaceState: function(newState) {
        if (!newState) return;
        Object.assign($a094c9dde8f3f16e$var$state, (0, $hyDkn.ref)(newState));
    },
    subscribe: function(callback) {
        return (0, $9zDWP.ChainController).subscribeChainProp("accountState", function(accountState) {
            if (accountState) return callback(accountState);
            return undefined;
        });
    },
    subscribeKey: function(property, callback) {
        var prev = undefined;
        return (0, $9zDWP.ChainController).subscribeChainProp("accountState", function(accountState) {
            if (accountState) {
                var nextValue = accountState[property];
                if (prev !== nextValue) {
                    prev = nextValue;
                    callback(nextValue);
                }
            }
        });
    },
    setIsConnected: function(isConnected, chain) {
        (0, $9zDWP.ChainController).setAccountProp("isConnected", isConnected, chain);
    },
    getChainIsConnected: function(chain) {
        return (0, $9zDWP.ChainController).getAccountProp("isConnected", chain);
    },
    setCaipAddress: function(caipAddress, chain) {
        var newCaipAddress = caipAddress ? (0, $hZBJb.CoreHelperUtil).getPlainAddress(caipAddress) : undefined;
        (0, $9zDWP.ChainController).setAccountProp("caipAddress", caipAddress, chain);
        (0, $9zDWP.ChainController).setAccountProp("address", newCaipAddress, chain);
    },
    setBalance: function(balance, balanceSymbol, chain) {
        (0, $9zDWP.ChainController).setAccountProp("balance", balance, chain);
        (0, $9zDWP.ChainController).setAccountProp("balanceSymbol", balanceSymbol, chain);
    },
    setProfileName: function(profileName, chain) {
        (0, $9zDWP.ChainController).setAccountProp("profileName", profileName, chain);
    },
    setProfileImage: function(profileImage, chain) {
        (0, $9zDWP.ChainController).setAccountProp("profileImage", profileImage, chain);
    },
    setAddressExplorerUrl: function(explorerUrl, chain) {
        (0, $9zDWP.ChainController).setAccountProp("addressExplorerUrl", explorerUrl, chain);
    },
    setSmartAccountDeployed: function(isDeployed, chain) {
        (0, $9zDWP.ChainController).setAccountProp("smartAccountDeployed", isDeployed, chain);
    },
    setCurrentTab: function(currentTab) {
        (0, $9zDWP.ChainController).setAccountProp("currentTab", currentTab, (0, $9zDWP.ChainController).state.activeChain);
    },
    setTokenBalance: function(tokenBalance, chain) {
        if (tokenBalance) (0, $9zDWP.ChainController).setAccountProp("tokenBalance", tokenBalance, chain);
    },
    setShouldUpdateToAddress: function(address, chain) {
        (0, $9zDWP.ChainController).setAccountProp("shouldUpdateToAddress", address, chain);
    },
    setAllAccounts: function(accounts, chain) {
        (0, $9zDWP.ChainController).setAccountProp("allAccounts", accounts, chain);
    },
    addAddressLabel: function(address, label, chain) {
        var map = (0, $9zDWP.ChainController).getAccountProp("addressLabels", chain) || new Map();
        map.set(address, label);
        (0, $9zDWP.ChainController).setAccountProp("addressLabels", map, (0, $9zDWP.ChainController).state.activeChain);
    },
    removeAddressLabel: function(address, chain) {
        var map = (0, $9zDWP.ChainController).getAccountProp("addressLabels", chain) || new Map();
        map.delete(address);
        (0, $9zDWP.ChainController).setAccountProp("addressLabels", map, (0, $9zDWP.ChainController).state.activeChain);
    },
    setConnectedWalletInfo: function(connectedWalletInfo, chain) {
        (0, $9zDWP.ChainController).setAccountProp("connectedWalletInfo", connectedWalletInfo, chain);
    },
    setPreferredAccountType: function(preferredAccountType, chain) {
        (0, $9zDWP.ChainController).setAccountProp("preferredAccountType", preferredAccountType, chain);
    },
    setSocialProvider: function(socialProvider, chain) {
        if (socialProvider) (0, $9zDWP.ChainController).setAccountProp("socialProvider", socialProvider, chain);
    },
    setSocialWindow: function(socialWindow, chain) {
        if (socialWindow) (0, $9zDWP.ChainController).setAccountProp("socialWindow", (0, $hyDkn.ref)(socialWindow), chain);
    },
    setFarcasterUrl: function(farcasterUrl, chain) {
        if (farcasterUrl) (0, $9zDWP.ChainController).setAccountProp("farcasterUrl", farcasterUrl, chain);
    },
    fetchTokenBalance: function() {
        return (0, $kSuI9._)(function() {
            var _NetworkController_state_caipNetwork, _NetworkController_state_caipNetwork1, chainId, chain, address, response, filteredBalances, error;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        chainId = (_NetworkController_state_caipNetwork = (0, $fPqxb.NetworkController).state.caipNetwork) === null || _NetworkController_state_caipNetwork === void 0 ? void 0 : _NetworkController_state_caipNetwork.id;
                        chain = (_NetworkController_state_caipNetwork1 = (0, $fPqxb.NetworkController).state.caipNetwork) === null || _NetworkController_state_caipNetwork1 === void 0 ? void 0 : _NetworkController_state_caipNetwork1.chain;
                        address = $a094c9dde8f3f16e$export$3a40b83c1282ee40.state.address;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        if (!(address && chainId && chain)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            (0, $jrvVk.BlockchainApiController).getBalance(address, chainId)
                        ];
                    case 2:
                        response = _state.sent();
                        filteredBalances = response.balances.filter(function(balance) {
                            return balance.quantity.decimals !== "0";
                        });
                        this.setTokenBalance(filteredBalances, chain);
                        (0, $8DzeN.SwapController).setBalances((0, $4Tiue.SwapApiUtil).mapBalancesToSwapTokens(response.balances));
                        _state.label = 3;
                    case 3:
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        (0, $8FcCV.SnackController).showError("Failed to fetch token balance");
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    resetAccount: function(chain) {
        (0, $9zDWP.ChainController).resetAccount(chain);
    }
};

});
parcelRegister("hZBJb", function(module, exports) {

$parcel$export(module.exports, "CoreHelperUtil", function () { return $d19566227886d350$export$d8fe68a4208d58ff; });

var $kSuI9 = parcelRequire("kSuI9");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $eha6O = parcelRequire("eha6O");
parcelRequire("dSKxG");
var $3QZC1 = parcelRequire("3QZC1");

var $2sXdV = parcelRequire("2sXdV");
var $d19566227886d350$export$d8fe68a4208d58ff = {
    isMobile: function() {
        if (typeof window !== "undefined") return Boolean(window.matchMedia("(pointer:coarse)").matches || RegExp("Android|webOS|iPhone|iPad|iPod|BlackBerry|Opera Mini", "u").test(navigator.userAgent));
        return false;
    },
    checkCaipNetwork: function(network) {
        var networkName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        return network === null || network === void 0 ? void 0 : network.id.toLocaleLowerCase().includes(networkName.toLowerCase());
    },
    isAndroid: function() {
        var ua = window.navigator.userAgent.toLowerCase();
        return $d19566227886d350$export$d8fe68a4208d58ff.isMobile() && ua.includes("android");
    },
    isIos: function() {
        var ua = window.navigator.userAgent.toLowerCase();
        return $d19566227886d350$export$d8fe68a4208d58ff.isMobile() && (ua.includes("iphone") || ua.includes("ipad"));
    },
    isClient: function() {
        return typeof window !== "undefined";
    },
    isPairingExpired: function(expiry) {
        return expiry ? expiry - Date.now() <= (0, $2sXdV.ConstantsUtil).TEN_SEC_MS : true;
    },
    isAllowedRetry: function(lastRetry) {
        return Date.now() - lastRetry >= (0, $2sXdV.ConstantsUtil).ONE_SEC_MS;
    },
    copyToClopboard: function(text) {
        navigator.clipboard.writeText(text);
    },
    getPairingExpiry: function() {
        return Date.now() + (0, $2sXdV.ConstantsUtil).FOUR_MINUTES_MS;
    },
    getNetworkId: function(caipAddress) {
        return caipAddress === null || caipAddress === void 0 ? void 0 : caipAddress.split(":")[1];
    },
    getPlainAddress: function(caipAddress) {
        return caipAddress === null || caipAddress === void 0 ? void 0 : caipAddress.split(":")[2];
    },
    wait: function(milliseconds) {
        return (0, $kSuI9._)(function() {
            return (0, $eha6O.__generator)(this, function(_state) {
                return [
                    2,
                    new Promise(function(resolve) {
                        setTimeout(resolve, milliseconds);
                    })
                ];
            });
        })();
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    debounce: function(func) {
        var timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500;
        var timer = undefined;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            function next() {
                func.apply(void 0, (0, $c6Xmf._)(args));
            }
            if (timer) clearTimeout(timer);
            timer = setTimeout(next, timeout);
        };
    },
    isHttpUrl: function(url) {
        return url.startsWith("http://") || url.startsWith("https://");
    },
    formatNativeUrl: function(appUrl, wcUri) {
        if ($d19566227886d350$export$d8fe68a4208d58ff.isHttpUrl(appUrl)) return this.formatUniversalUrl(appUrl, wcUri);
        var safeAppUrl = appUrl;
        if (!safeAppUrl.includes("://")) {
            safeAppUrl = appUrl.replaceAll("/", "").replaceAll(":", "");
            safeAppUrl = "".concat(safeAppUrl, "://");
        }
        if (!safeAppUrl.endsWith("/")) safeAppUrl = "".concat(safeAppUrl, "/");
        var encodedWcUrl = encodeURIComponent(wcUri);
        return {
            redirect: "".concat(safeAppUrl, "wc?uri=").concat(encodedWcUrl),
            href: safeAppUrl
        };
    },
    formatUniversalUrl: function(appUrl, wcUri) {
        if (!$d19566227886d350$export$d8fe68a4208d58ff.isHttpUrl(appUrl)) return this.formatNativeUrl(appUrl, wcUri);
        var safeAppUrl = appUrl;
        if (!safeAppUrl.endsWith("/")) safeAppUrl = "".concat(safeAppUrl, "/");
        var encodedWcUrl = encodeURIComponent(wcUri);
        return {
            redirect: "".concat(safeAppUrl, "wc?uri=").concat(encodedWcUrl),
            href: safeAppUrl
        };
    },
    openHref: function(href, target, features) {
        window.open(href, target, features || "noreferrer noopener");
    },
    returnOpenHref: function(href, target, features) {
        return window.open(href, target, features || "noreferrer noopener");
    },
    preloadImage: function(src) {
        return (0, $kSuI9._)(function() {
            var imagePromise;
            return (0, $eha6O.__generator)(this, function(_state) {
                imagePromise = new Promise(function(resolve, reject) {
                    var image = new Image();
                    image.onload = resolve;
                    image.onerror = reject;
                    image.crossOrigin = "anonymous";
                    image.src = src;
                });
                return [
                    2,
                    Promise.race([
                        imagePromise,
                        $d19566227886d350$export$d8fe68a4208d58ff.wait(2000)
                    ])
                ];
            });
        })();
    },
    formatBalance: function(balance, symbol) {
        var formattedBalance = "0.000";
        if (typeof balance === "string") {
            var number = Number(balance);
            if (number) {
                var formattedValue = Math.floor(number * 1000) / 1000;
                if (formattedValue) formattedBalance = formattedValue.toString();
            }
        }
        return "".concat(formattedBalance).concat(symbol ? " ".concat(symbol) : "");
    },
    formatBalance2: function(balance, symbol) {
        var formattedBalance = undefined;
        if (balance === "0") formattedBalance = "0";
        else if (typeof balance === "string") {
            var _number_toString_match;
            var number = Number(balance);
            if (number) formattedBalance = (_number_toString_match = number.toString().match(RegExp("^-?\\d+(?:\\.\\d{0,3})?", "u"))) === null || _number_toString_match === void 0 ? void 0 : _number_toString_match[0];
        }
        return {
            value: formattedBalance !== null && formattedBalance !== void 0 ? formattedBalance : "0",
            rest: formattedBalance === "0" ? "000" : "",
            symbol: symbol
        };
    },
    getApiUrl: function() {
        return (0, $3QZC1.ConstantsUtil).W3M_API_URL;
    },
    getBlockchainApiUrl: function() {
        return (0, $3QZC1.ConstantsUtil).BLOCKCHAIN_API_RPC_URL;
    },
    getAnalyticsUrl: function() {
        return (0, $3QZC1.ConstantsUtil).PULSE_API_URL;
    },
    getUUID: function() {
        var _crypto;
        if ((_crypto = crypto) === null || _crypto === void 0 ? void 0 : _crypto.randomUUID) return crypto.randomUUID();
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(RegExp("[xy]", "gu"), function(c) {
            var r = Math.random() * 16 | 0;
            var v = c === "x" ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseError: function(error) {
        var _error_issues_, _error_issues;
        if (typeof error === "string") return error;
        else if (typeof (error === null || error === void 0 ? void 0 : (_error_issues = error.issues) === null || _error_issues === void 0 ? void 0 : (_error_issues_ = _error_issues[0]) === null || _error_issues_ === void 0 ? void 0 : _error_issues_.message) === "string") return error.issues[0].message;
        else if (error instanceof Error) return error.message;
        return "Unknown error";
    },
    sortRequestedNetworks: function(approvedIds) {
        var requestedNetworks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
        var approvedIndexMap = {};
        if (requestedNetworks && approvedIds) {
            approvedIds.forEach(function(id, index) {
                approvedIndexMap[id] = index;
            });
            requestedNetworks.sort(function(a, b) {
                var indexA = approvedIndexMap[a.id];
                var indexB = approvedIndexMap[b.id];
                if (indexA !== undefined && indexB !== undefined) return indexA - indexB;
                else if (indexA !== undefined) return -1;
                else if (indexB !== undefined) return 1;
                return 0;
            });
        }
        return requestedNetworks;
    },
    calculateBalance: function(array) {
        var sum = 0;
        var _item_value;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = array[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                sum += (_item_value = item.value) !== null && _item_value !== void 0 ? _item_value : 0;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return sum;
    },
    formatTokenBalance: function(number) {
        var roundedNumber = number.toFixed(2);
        var _roundedNumber_split = (0, $cv9Rk._)(roundedNumber.split("."), 2), dollars = _roundedNumber_split[0], pennies = _roundedNumber_split[1];
        return {
            dollars: dollars,
            pennies: pennies
        };
    },
    isAddress: function(address) {
        if (!RegExp("^(?:0x)?[0-9a-f]{40}$", "iu").test(address)) return false;
        else if (RegExp("^(?:0x)?[0-9a-f]{40}$", "iu").test(address) || RegExp("^(?:0x)?[0-9A-F]{40}$", "iu").test(address)) return true;
        return false;
    },
    uniqueBy: function(arr, key) {
        var set = new Set();
        return arr.filter(function(item) {
            var keyValue = item[key];
            if (set.has(keyValue)) return false;
            set.add(keyValue);
            return true;
        });
    }
};

});
parcelRegister("dSKxG", function(module, exports) {
$parcel$export(module.exports, "getW3mThemeVariables", function () { return (parcelRequire("cnADL")).getW3mThemeVariables; });

$parcel$export(module.exports, "DateUtil", function () { return (parcelRequire("6qlO7")).DateUtil; });
$parcel$export(module.exports, "NetworkUtil", function () { return (parcelRequire("fcokf")).NetworkUtil; });
$parcel$export(module.exports, "NumberUtil", function () { return (parcelRequire("eMPGH")).NumberUtil; });
$parcel$export(module.exports, "InputUtil", function () { return (parcelRequire("c3zzE")).InputUtil; });
$parcel$export(module.exports, "erc20ABI", function () { return (parcelRequire("55oQe")).erc20ABI; });
$parcel$export(module.exports, "NavigationUtil", function () { return (parcelRequire("ejaSv")).NavigationUtil; });
$parcel$export(module.exports, "ConstantsUtil", function () { return (parcelRequire("3QZC1")).ConstantsUtil; });

var $6qlO7 = parcelRequire("6qlO7");

var $fcokf = parcelRequire("fcokf");

var $eMPGH = parcelRequire("eMPGH");

var $c3zzE = parcelRequire("c3zzE");

var $55oQe = parcelRequire("55oQe");

var $ejaSv = parcelRequire("ejaSv");

var $3QZC1 = parcelRequire("3QZC1");
parcelRequire("cnADL");

});
parcelRegister("6qlO7", function(module, exports) {

$parcel$export(module.exports, "DateUtil", function () { return $4ad6164484edf66d$export$9b575f14aa5e09a1; });

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $3ONiv = parcelRequire("3ONiv");

var $jaxKu = parcelRequire("jaxKu");

var $gFISE = parcelRequire("gFISE");

var $4G43e = parcelRequire("4G43e");
(0, (/*@__PURE__*/$parcel$interopDefault($3ONiv))).extend((0, (/*@__PURE__*/$parcel$interopDefault($gFISE))));
(0, (/*@__PURE__*/$parcel$interopDefault($3ONiv))).extend((0, (/*@__PURE__*/$parcel$interopDefault($4G43e))));
var $4ad6164484edf66d$var$localeObject = (0, $cxjpp._)((0, $do9pw._)({}, (0, (/*@__PURE__*/$parcel$interopDefault($jaxKu)))), {
    name: "en-web3-modal",
    relativeTime: {
        future: "in %s",
        past: "%s ago",
        s: "%d sec",
        m: "1 min",
        mm: "%d min",
        h: "1 hr",
        hh: "%d hrs",
        d: "1 d",
        dd: "%d d",
        M: "1 mo",
        MM: "%d mo",
        y: "1 yr",
        yy: "%d yr"
    }
});
(0, (/*@__PURE__*/$parcel$interopDefault($3ONiv))).locale("en-web3-modal", $4ad6164484edf66d$var$localeObject);
var $4ad6164484edf66d$export$9b575f14aa5e09a1 = {
    getYear: function() {
        var date = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Date().toISOString();
        return (0, (/*@__PURE__*/$parcel$interopDefault($3ONiv)))(date).year();
    },
    getRelativeDateFromNow: function(date) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($3ONiv)))(date).locale("en-web3-modal").fromNow(true);
    },
    formatDate: function(date) {
        var format = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "DD MMM";
        return (0, (/*@__PURE__*/$parcel$interopDefault($3ONiv)))(date).format(format);
    }
};

});
parcelRegister("3ONiv", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function ordinal(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function m(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function z(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function a(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function p(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function u(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function S(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function O(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function l(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function $(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, _$M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, _$M) : l(0, _$M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), _$M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function y(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var _$M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * _$M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function h(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function d(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, _$M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function D() {
                return b.m(y, m);
            };
            switch(_$M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});

parcelRegister("jaxKu", function(module, exports) {
!function(e, n) {
    module.exports = n();
}(module.exports, function() {
    "use strict";
    return {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function ordinal(e) {
            var n = [
                "th",
                "st",
                "nd",
                "rd"
            ], t = e % 100;
            return "[" + e + (n[(t - 20) % 10] || n[t] || n[0]) + "]";
        }
    };
});

});

parcelRegister("gFISE", function(module, exports) {
!function(r, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    return function(r, e, t) {
        r = r || {};
        var n = e.prototype, o = {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        };
        function i(r, e, t, o) {
            return n.fromToBase(r, e, t, o);
        }
        t.en.relativeTime = o, n.fromToBase = function(e, n, i, d, u) {
            for(var f, a, s, l = i.$locale().relativeTime || o, h = r.thresholds || [
                {
                    l: "s",
                    r: 44,
                    d: "second"
                },
                {
                    l: "m",
                    r: 89
                },
                {
                    l: "mm",
                    r: 44,
                    d: "minute"
                },
                {
                    l: "h",
                    r: 89
                },
                {
                    l: "hh",
                    r: 21,
                    d: "hour"
                },
                {
                    l: "d",
                    r: 35
                },
                {
                    l: "dd",
                    r: 25,
                    d: "day"
                },
                {
                    l: "M",
                    r: 45
                },
                {
                    l: "MM",
                    r: 10,
                    d: "month"
                },
                {
                    l: "y",
                    r: 17
                },
                {
                    l: "yy",
                    d: "year"
                }
            ], m = h.length, c = 0; c < m; c += 1){
                var y = h[c];
                y.d && (f = d ? t(e).diff(i, y.d, !0) : i.diff(e, y.d, !0));
                var p = (r.rounding || Math.round)(Math.abs(f));
                if (s = f > 0, p <= y.r || !y.r) {
                    p <= 1 && c > 0 && (y = h[c - 1]);
                    var v = l[y.l];
                    u && (p = u("" + p)), a = "string" == typeof v ? v.replace("%d", p) : v(p, n, y.l, s);
                    break;
                }
            }
            if (n) return a;
            var M = s ? l.future : l.past;
            return "function" == typeof M ? M(a) : M.replace("%s", a);
        }, n.to = function(r, e) {
            return i(r, e, this, !0);
        }, n.from = function(r, e) {
            return i(r, e, this);
        };
        var d = function d(r) {
            return r.$u ? t.utc() : t();
        };
        n.toNow = function(r) {
            return this.to(d(this), r);
        }, n.fromNow = function(r) {
            return this.from(d(this), r);
        };
    };
});

});

parcelRegister("4G43e", function(module, exports) {
!function(e, n) {
    module.exports = n();
}(module.exports, function() {
    "use strict";
    return function(e, n, t) {
        t.updateLocale = function(e, n) {
            var o = t.Ls[e];
            if (o) return (n ? Object.keys(n) : []).forEach(function(e) {
                o[e] = n[e];
            }), o;
        };
    };
});

});


parcelRegister("fcokf", function(module, exports) {

$parcel$export(module.exports, "NetworkUtil", function () { return $b10ad88a15546881$export$79d00c05833eff69; });
var $b10ad88a15546881$export$79d00c05833eff69 = {
    caipNetworkIdToNumber: function(caipnetworkId) {
        return caipnetworkId ? Number(caipnetworkId.split(":")[1]) : undefined;
    },
    parseEvmChainId: function(chainId) {
        return typeof chainId === "string" ? this.caipNetworkIdToNumber(chainId) : chainId;
    }
};

});

parcelRegister("eMPGH", function(module, exports) {

$parcel$export(module.exports, "NumberUtil", function () { return $ac3da47cfce550a7$export$be098d443162b0ca; });

var $5ZD4w = parcelRequire("5ZD4w");
var $ac3da47cfce550a7$export$be098d443162b0ca = {
    bigNumber: function(value) {
        return new $5ZD4w.BigNumber(value);
    },
    multiply: function(a, b) {
        if (a === undefined || b === undefined) return $5ZD4w.BigNumber(0);
        var aBigNumber = new $5ZD4w.BigNumber(a);
        var bBigNumber = new $5ZD4w.BigNumber(b);
        return aBigNumber.multipliedBy(bBigNumber);
    },
    formatNumberToLocalString: function(value) {
        var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
        if (value === undefined) return "0.00";
        if (typeof value === "number") return value.toLocaleString("en-US", {
            maximumFractionDigits: decimals,
            minimumFractionDigits: decimals
        });
        return parseFloat(value).toLocaleString("en-US", {
            maximumFractionDigits: decimals,
            minimumFractionDigits: decimals
        });
    }
};

});
parcelRegister("5ZD4w", function(module, exports) {

$parcel$export(module.exports, "BigNumber", function () { return $6a233875b22d2bbb$export$d97aa349ed20696; });
$parcel$export(module.exports, "default", function () { return $6a233875b22d2bbb$export$2e2bcd8739ae039; });
/*
 *      bignumber.js v9.1.2
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var $6a233875b22d2bbb$var$isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, $6a233875b22d2bbb$var$mathceil = Math.ceil, $6a233875b22d2bbb$var$mathfloor = Math.floor, $6a233875b22d2bbb$var$bignumberError = "[BigNumber Error] ", $6a233875b22d2bbb$var$tooManyDigits = $6a233875b22d2bbb$var$bignumberError + "Number primitive has more than 15 significant digits: ", $6a233875b22d2bbb$var$BASE = 1e14, $6a233875b22d2bbb$var$LOG_BASE = 14, $6a233875b22d2bbb$var$MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
$6a233875b22d2bbb$var$POWS_TEN = [
    1,
    10,
    100,
    1e3,
    1e4,
    1e5,
    1e6,
    1e7,
    1e8,
    1e9,
    1e10,
    1e11,
    1e12,
    1e13
], $6a233875b22d2bbb$var$SQRT_BASE = 1e7, // EDITABLE
// The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
// the arguments to toExponential, toFixed, toFormat, and toPrecision.
$6a233875b22d2bbb$var$MAX = 1E9; // 0 to MAX_INT32
/*
 * Create and return a BigNumber constructor.
 */ function $6a233875b22d2bbb$var$clone(configObject) {
    var div, convertBase, parseNumeric, P = BigNumber.prototype = {
        constructor: BigNumber,
        toString: null,
        valueOf: null
    }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
    // The default values below must be integers within the inclusive ranges stated.
    // The values can also be changed at run-time using BigNumber.set.
    // The maximum number of decimal places for operations involving division.
    DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
    // toExponential, toFixed, toFormat and toPrecision, and round (default value).
    // UP         0 Away from zero.
    // DOWN       1 Towards zero.
    // CEIL       2 Towards +Infinity.
    // FLOOR      3 Towards -Infinity.
    // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
    // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
    // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
    // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
    // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
    ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
    // The exponent value at and beneath which toString returns exponential notation.
    // Number type: -7
    TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
    // Number type: 21
    TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
    // The minimum exponent value, beneath which underflow to zero occurs.
    // Number type: -324  (5e-324)
    MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
    // Number type:  308  (1.7976931348623157e+308)
    // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
    MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
    CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
    // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
    // The remainder (r) is calculated as: r = a - n * q.
    //
    // UP        0 The remainder is positive if the dividend is negative, else is negative.
    // DOWN      1 The remainder has the same sign as the dividend.
    //             This modulo mode is commonly known as 'truncated division' and is
    //             equivalent to (a % n) in JavaScript.
    // FLOOR     3 The remainder has the same sign as the divisor (Python %).
    // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
    // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
    //             The remainder is always positive.
    //
    // The truncated division, floored division, Euclidian division and IEEE 754 remainder
    // modes are commonly used for the modulus operation.
    // Although the other rounding modes can also be used, they may not give useful results.
    MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
    // If POW_PRECISION is 0, there will be unlimited significant digits.
    POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
    FORMAT = {
        prefix: "",
        groupSize: 3,
        secondaryGroupSize: 0,
        groupSeparator: ",",
        decimalSeparator: ".",
        fractionGroupSize: 0,
        fractionGroupSeparator: "\xa0",
        suffix: ""
    }, // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
    // '-', '.', whitespace, or repeated character.
    // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
    ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz", alphabetHasNormalDecimalDigits = true;
    //------------------------------------------------------------------------------------------
    // CONSTRUCTOR
    /*
   * The BigNumber constructor and exported function.
   * Create and return a new instance of a BigNumber object.
   *
   * v {number|string|BigNumber} A numeric value.
   * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
   */ function BigNumber(v, b) {
        var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
        // Enable constructor call without `new`.
        if (!(x instanceof BigNumber)) return new BigNumber(v, b);
        if (b == null) {
            if (v && v._isBigNumber === true) {
                x.s = v.s;
                if (!v.c || v.e > MAX_EXP) x.c = x.e = null;
                else if (v.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
                else {
                    x.e = v.e;
                    x.c = v.c.slice();
                }
                return;
            }
            if ((isNum = typeof v == "number") && v * 0 == 0) {
                // Use `1 / n` to handle minus zero also.
                x.s = 1 / v < 0 ? (v = -v, -1) : 1;
                // Fast path for integers, where n < 2147483648 (2**31).
                if (v === ~~v) {
                    for(e = 0, i = v; i >= 10; i /= 10, e++);
                    if (e > MAX_EXP) x.c = x.e = null;
                    else {
                        x.e = e;
                        x.c = [
                            v
                        ];
                    }
                    return;
                }
                str = String(v);
            } else {
                if (!$6a233875b22d2bbb$var$isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);
                x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
            }
            // Decimal point?
            if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
            // Exponential form?
            if ((i = str.search(/e/i)) > 0) {
                // Determine exponent.
                if (e < 0) e = i;
                e += +str.slice(i + 1);
                str = str.substring(0, i);
            } else if (e < 0) // Integer.
            e = str.length;
        } else {
            // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
            $6a233875b22d2bbb$var$intCheck(b, 2, ALPHABET.length, "Base");
            // Allow exponential notation to be used with base 10 argument, while
            // also rounding to DECIMAL_PLACES as with other bases.
            if (b == 10 && alphabetHasNormalDecimalDigits) {
                x = new BigNumber(v);
                return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
            }
            str = String(v);
            if (isNum = typeof v == "number") {
                // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                if (v * 0 != 0) return parseNumeric(x, str, isNum, b);
                x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;
                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, "").length > 15) throw Error($6a233875b22d2bbb$var$tooManyDigits + v);
            } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
            alphabet = ALPHABET.slice(0, b);
            e = i = 0;
            // Check that str is a valid base b number.
            // Don't use RegExp, so alphabet can contain special characters.
            for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                if (c == ".") // If '.' is not the first character and it has not be found before.
                {
                    if (i > e) {
                        e = len;
                        continue;
                    }
                } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                {
                    if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                        caseChanged = true;
                        i = -1;
                        e = 0;
                        continue;
                    }
                }
                return parseNumeric(x, String(v), isNum, b);
            }
            // Prevent later check for length on converted number.
            isNum = false;
            str = convertBase(str, b, 10, x.s);
            // Decimal point?
            if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
            else e = str.length;
        }
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48; i++);
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(--len) === 48;);
        if (str = str.slice(i, ++len)) {
            len -= i;
            // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
            if (isNum && BigNumber.DEBUG && len > 15 && (v > $6a233875b22d2bbb$var$MAX_SAFE_INTEGER || v !== $6a233875b22d2bbb$var$mathfloor(v))) throw Error($6a233875b22d2bbb$var$tooManyDigits + x.s * v);
            // Overflow?
            if ((e = e - i - 1) > MAX_EXP) // Infinity.
            x.c = x.e = null;
            else if (e < MIN_EXP) // Zero.
            x.c = [
                x.e = 0
            ];
            else {
                x.e = e;
                x.c = [];
                // Transform base
                // e is the base 10 exponent.
                // i is where to slice str to get the first element of the coefficient array.
                i = (e + 1) % $6a233875b22d2bbb$var$LOG_BASE;
                if (e < 0) i += $6a233875b22d2bbb$var$LOG_BASE; // i < 1
                if (i < len) {
                    if (i) x.c.push(+str.slice(0, i));
                    for(len -= $6a233875b22d2bbb$var$LOG_BASE; i < len;)x.c.push(+str.slice(i, i += $6a233875b22d2bbb$var$LOG_BASE));
                    i = $6a233875b22d2bbb$var$LOG_BASE - (str = str.slice(i)).length;
                } else i -= len;
                for(; i--; str += "0");
                x.c.push(+str);
            }
        } else // Zero.
        x.c = [
            x.e = 0
        ];
    }
    // CONSTRUCTOR PROPERTIES
    BigNumber.clone = $6a233875b22d2bbb$var$clone;
    BigNumber.ROUND_UP = 0;
    BigNumber.ROUND_DOWN = 1;
    BigNumber.ROUND_CEIL = 2;
    BigNumber.ROUND_FLOOR = 3;
    BigNumber.ROUND_HALF_UP = 4;
    BigNumber.ROUND_HALF_DOWN = 5;
    BigNumber.ROUND_HALF_EVEN = 6;
    BigNumber.ROUND_HALF_CEIL = 7;
    BigNumber.ROUND_HALF_FLOOR = 8;
    BigNumber.EUCLID = 9;
    /*
   * Configure infrequently-changing library-wide settings.
   *
   * Accept an object with the following optional properties (if the value of a property is
   * a number, it must be an integer within the inclusive range stated):
   *
   *   DECIMAL_PLACES   {number}           0 to MAX
   *   ROUNDING_MODE    {number}           0 to 8
   *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
   *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
   *   CRYPTO           {boolean}          true or false
   *   MODULO_MODE      {number}           0 to 9
   *   POW_PRECISION       {number}           0 to MAX
   *   ALPHABET         {string}           A string of two or more unique characters which does
   *                                       not contain '.'.
   *   FORMAT           {object}           An object with some of the following properties:
   *     prefix                 {string}
   *     groupSize              {number}
   *     secondaryGroupSize     {number}
   *     groupSeparator         {string}
   *     decimalSeparator       {string}
   *     fractionGroupSize      {number}
   *     fractionGroupSeparator {string}
   *     suffix                 {string}
   *
   * (The values assigned to the above FORMAT object properties are not checked for validity.)
   *
   * E.g.
   * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
   *
   * Ignore properties/parameters set to null or undefined, except for ALPHABET.
   *
   * Return an object with the properties current values.
   */ BigNumber.config = BigNumber.set = function(obj) {
        var p, v;
        if (obj != null) {
            if (typeof obj == "object") {
                // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = "DECIMAL_PLACES")) {
                    v = obj[p];
                    $6a233875b22d2bbb$var$intCheck(v, 0, $6a233875b22d2bbb$var$MAX, p);
                    DECIMAL_PLACES = v;
                }
                // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = "ROUNDING_MODE")) {
                    v = obj[p];
                    $6a233875b22d2bbb$var$intCheck(v, 0, 8, p);
                    ROUNDING_MODE = v;
                }
                // EXPONENTIAL_AT {number|number[]}
                // Integer, -MAX to MAX inclusive or
                // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = "EXPONENTIAL_AT")) {
                    v = obj[p];
                    if (v && v.pop) {
                        $6a233875b22d2bbb$var$intCheck(v[0], -$6a233875b22d2bbb$var$MAX, 0, p);
                        $6a233875b22d2bbb$var$intCheck(v[1], 0, $6a233875b22d2bbb$var$MAX, p);
                        TO_EXP_NEG = v[0];
                        TO_EXP_POS = v[1];
                    } else {
                        $6a233875b22d2bbb$var$intCheck(v, -$6a233875b22d2bbb$var$MAX, $6a233875b22d2bbb$var$MAX, p);
                        TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                    }
                }
                // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                if (obj.hasOwnProperty(p = "RANGE")) {
                    v = obj[p];
                    if (v && v.pop) {
                        $6a233875b22d2bbb$var$intCheck(v[0], -$6a233875b22d2bbb$var$MAX, -1, p);
                        $6a233875b22d2bbb$var$intCheck(v[1], 1, $6a233875b22d2bbb$var$MAX, p);
                        MIN_EXP = v[0];
                        MAX_EXP = v[1];
                    } else {
                        $6a233875b22d2bbb$var$intCheck(v, -$6a233875b22d2bbb$var$MAX, $6a233875b22d2bbb$var$MAX, p);
                        if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                        else throw Error($6a233875b22d2bbb$var$bignumberError + p + " cannot be zero: " + v);
                    }
                }
                // CRYPTO {boolean} true or false.
                // '[BigNumber Error] CRYPTO not true or false: {v}'
                // '[BigNumber Error] crypto unavailable'
                if (obj.hasOwnProperty(p = "CRYPTO")) {
                    v = obj[p];
                    if (v === !!v) {
                        if (v) {
                            if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                            else {
                                CRYPTO = !v;
                                throw Error($6a233875b22d2bbb$var$bignumberError + "crypto unavailable");
                            }
                        } else CRYPTO = v;
                    } else throw Error($6a233875b22d2bbb$var$bignumberError + p + " not true or false: " + v);
                }
                // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = "MODULO_MODE")) {
                    v = obj[p];
                    $6a233875b22d2bbb$var$intCheck(v, 0, 9, p);
                    MODULO_MODE = v;
                }
                // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = "POW_PRECISION")) {
                    v = obj[p];
                    $6a233875b22d2bbb$var$intCheck(v, 0, $6a233875b22d2bbb$var$MAX, p);
                    POW_PRECISION = v;
                }
                // FORMAT {object}
                // '[BigNumber Error] FORMAT not an object: {v}'
                if (obj.hasOwnProperty(p = "FORMAT")) {
                    v = obj[p];
                    if (typeof v == "object") FORMAT = v;
                    else throw Error($6a233875b22d2bbb$var$bignumberError + p + " not an object: " + v);
                }
                // ALPHABET {string}
                // '[BigNumber Error] ALPHABET invalid: {v}'
                if (obj.hasOwnProperty(p = "ALPHABET")) {
                    v = obj[p];
                    // Disallow if less than two characters,
                    // or if it contains '+', '-', '.', whitespace, or a repeated character.
                    if (typeof v == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
                        alphabetHasNormalDecimalDigits = v.slice(0, 10) == "0123456789";
                        ALPHABET = v;
                    } else throw Error($6a233875b22d2bbb$var$bignumberError + p + " invalid: " + v);
                }
            } else // '[BigNumber Error] Object expected: {v}'
            throw Error($6a233875b22d2bbb$var$bignumberError + "Object expected: " + obj);
        }
        return {
            DECIMAL_PLACES: DECIMAL_PLACES,
            ROUNDING_MODE: ROUNDING_MODE,
            EXPONENTIAL_AT: [
                TO_EXP_NEG,
                TO_EXP_POS
            ],
            RANGE: [
                MIN_EXP,
                MAX_EXP
            ],
            CRYPTO: CRYPTO,
            MODULO_MODE: MODULO_MODE,
            POW_PRECISION: POW_PRECISION,
            FORMAT: FORMAT,
            ALPHABET: ALPHABET
        };
    };
    /*
   * Return true if v is a BigNumber instance, otherwise return false.
   *
   * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
   *
   * v {any}
   *
   * '[BigNumber Error] Invalid BigNumber: {v}'
   */ BigNumber.isBigNumber = function(v) {
        if (!v || v._isBigNumber !== true) return false;
        if (!BigNumber.DEBUG) return true;
        var i, n, c = v.c, e = v.e, s = v.s;
        out: if (({}).toString.call(c) == "[object Array]") {
            if ((s === 1 || s === -1) && e >= -$6a233875b22d2bbb$var$MAX && e <= $6a233875b22d2bbb$var$MAX && e === $6a233875b22d2bbb$var$mathfloor(e)) {
                // If the first element is zero, the BigNumber value must be zero.
                if (c[0] === 0) {
                    if (e === 0 && c.length === 1) return true;
                    break out;
                }
                // Calculate number of digits that c[0] should have, based on the exponent.
                i = (e + 1) % $6a233875b22d2bbb$var$LOG_BASE;
                if (i < 1) i += $6a233875b22d2bbb$var$LOG_BASE;
                // Calculate number of digits of c[0].
                //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
                if (String(c[0]).length == i) {
                    for(i = 0; i < c.length; i++){
                        n = c[i];
                        if (n < 0 || n >= $6a233875b22d2bbb$var$BASE || n !== $6a233875b22d2bbb$var$mathfloor(n)) break out;
                    }
                    // Last element cannot be zero, unless it is the only element.
                    if (n !== 0) return true;
                }
            }
        } else if (c === null && e === null && (s === null || s === 1 || s === -1)) return true;
        throw Error($6a233875b22d2bbb$var$bignumberError + "Invalid BigNumber: " + v);
    };
    /*
   * Return a new BigNumber whose value is the maximum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */ BigNumber.maximum = BigNumber.max = function() {
        return maxOrMin(arguments, -1);
    };
    /*
   * Return a new BigNumber whose value is the minimum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */ BigNumber.minimum = BigNumber.min = function() {
        return maxOrMin(arguments, 1);
    };
    /*
   * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
   * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
   * zeros are produced).
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
   * '[BigNumber Error] crypto unavailable'
   */ BigNumber.random = function() {
        var pow2_53 = 0x20000000000000;
        // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
        // Check if Math.random() produces more than 32 bits of randomness.
        // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
        // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
        var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function random53bitInt() {
            return $6a233875b22d2bbb$var$mathfloor(Math.random() * pow2_53);
        } : function() {
            return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
        };
        return function(dp) {
            var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
            if (dp == null) dp = DECIMAL_PLACES;
            else $6a233875b22d2bbb$var$intCheck(dp, 0, $6a233875b22d2bbb$var$MAX);
            k = $6a233875b22d2bbb$var$mathceil(dp / $6a233875b22d2bbb$var$LOG_BASE);
            if (CRYPTO) {
                // Browsers supporting crypto.getRandomValues.
                if (crypto.getRandomValues) {
                    a = crypto.getRandomValues(new Uint32Array(k *= 2));
                    for(; i < k;){
                        // 53 bits:
                        // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                        // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                        // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                        //                                     11111 11111111 11111111
                        // 0x20000 is 2^21.
                        v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                        // Rejection sampling:
                        // 0 <= v < 9007199254740992
                        // Probability that v >= 9e15, is
                        // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                        if (v >= 9e15) {
                            b = crypto.getRandomValues(new Uint32Array(2));
                            a[i] = b[0];
                            a[i + 1] = b[1];
                        } else {
                            // 0 <= v <= 8999999999999999
                            // 0 <= (v % 1e14) <= 99999999999999
                            c.push(v % 1e14);
                            i += 2;
                        }
                    }
                    i = k / 2;
                // Node.js supporting crypto.randomBytes.
                } else if (crypto.randomBytes) {
                    // buffer
                    a = crypto.randomBytes(k *= 7);
                    for(; i < k;){
                        // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                        // 0x100000000 is 2^32, 0x1000000 is 2^24
                        // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                        // 0 <= v < 9007199254740992
                        v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                        if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                        else {
                            // 0 <= (v % 1e14) <= 99999999999999
                            c.push(v % 1e14);
                            i += 7;
                        }
                    }
                    i = k / 7;
                } else {
                    CRYPTO = false;
                    throw Error($6a233875b22d2bbb$var$bignumberError + "crypto unavailable");
                }
            }
            // Use Math.random.
            if (!CRYPTO) for(; i < k;){
                v = random53bitInt();
                if (v < 9e15) c[i++] = v % 1e14;
            }
            k = c[--i];
            dp %= $6a233875b22d2bbb$var$LOG_BASE;
            // Convert trailing digits to zeros according to dp.
            if (k && dp) {
                v = $6a233875b22d2bbb$var$POWS_TEN[$6a233875b22d2bbb$var$LOG_BASE - dp];
                c[i] = $6a233875b22d2bbb$var$mathfloor(k / v) * v;
            }
            // Remove trailing elements which are zero.
            for(; c[i] === 0; c.pop(), i--);
            // Zero?
            if (i < 0) c = [
                e = 0
            ];
            else {
                // Remove leading elements which are zero and adjust exponent accordingly.
                for(e = -1; c[0] === 0; c.splice(0, 1), e -= $6a233875b22d2bbb$var$LOG_BASE);
                // Count the digits of the first element of c to determine leading zeros, and...
                for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                // adjust the exponent accordingly.
                if (i < $6a233875b22d2bbb$var$LOG_BASE) e -= $6a233875b22d2bbb$var$LOG_BASE - i;
            }
            rand.e = e;
            rand.c = c;
            return rand;
        };
    }();
    /*
   * Return a BigNumber whose value is the sum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */ BigNumber.sum = function() {
        var i = 1, args = arguments, sum = new BigNumber(args[0]);
        for(; i < args.length;)sum = sum.plus(args[i++]);
        return sum;
    };
    // PRIVATE FUNCTIONS
    // Called by BigNumber and BigNumber.prototype.toString.
    convertBase = function() {
        var decimal = "0123456789";
        /*
     * Convert string of baseIn to an array of numbers of baseOut.
     * Eg. toBaseOut('255', 10, 16) returns [15, 15].
     * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
     */ function toBaseOut(str, baseIn, baseOut, alphabet) {
            var j, arr = [
                0
            ], arrL, i = 0, len = str.length;
            for(; i < len;){
                for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                arr[0] += alphabet.indexOf(str.charAt(i++));
                for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                    if (arr[j + 1] == null) arr[j + 1] = 0;
                    arr[j + 1] += arr[j] / baseOut | 0;
                    arr[j] %= baseOut;
                }
            }
            return arr.reverse();
        }
        // Convert a numeric string of baseIn to a numeric string of baseOut.
        // If the caller is toString, we are converting from base 10 to baseOut.
        // If the caller is BigNumber, we are converting from baseIn to base 10.
        return function(str, baseIn, baseOut, sign, callerIsToString) {
            var alphabet, d, e, k, r, x, xc, y, i = str.indexOf("."), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
            // Non-integer.
            if (i >= 0) {
                k = POW_PRECISION;
                // Unlimited precision.
                POW_PRECISION = 0;
                str = str.replace(".", "");
                y = new BigNumber(baseIn);
                x = y.pow(str.length - i);
                POW_PRECISION = k;
                // Convert str as if an integer, then restore the fraction part by dividing the
                // result by its base raised to a power.
                y.c = toBaseOut($6a233875b22d2bbb$var$toFixedPoint($6a233875b22d2bbb$var$coeffToString(x.c), x.e, "0"), 10, baseOut, decimal);
                y.e = y.c.length;
            }
            // Convert the number as integer.
            xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
            // xc now represents str as an integer and converted to baseOut. e is the exponent.
            e = k = xc.length;
            // Remove trailing zeros.
            for(; xc[--k] == 0; xc.pop());
            // Zero?
            if (!xc[0]) return alphabet.charAt(0);
            // Does str represent an integer? If so, no need for the division.
            if (i < 0) --e;
            else {
                x.c = xc;
                x.e = e;
                // The sign is needed for correct rounding.
                x.s = sign;
                x = div(x, y, dp, rm, baseOut);
                xc = x.c;
                r = x.r;
                e = x.e;
            }
            // xc now represents str converted to baseOut.
            // THe index of the rounding digit.
            d = e + dp + 1;
            // The rounding digit: the digit to the right of the digit that may be rounded up.
            i = xc[d];
            // Look at the rounding digits and mode to determine whether to round up.
            k = baseOut / 2;
            r = r || d < 0 || xc[d + 1] != null;
            r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
            // If the index of the rounding digit is not greater than zero, or xc represents
            // zero, then the result of the base conversion is zero or, if rounding up, a value
            // such as 0.00001.
            if (d < 1 || !xc[0]) // 1^-dp or 0
            str = r ? $6a233875b22d2bbb$var$toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
            else {
                // Truncate xc to the required number of decimal places.
                xc.length = d;
                // Round up?
                if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                for(--baseOut; ++xc[--d] > baseOut;){
                    xc[d] = 0;
                    if (!d) {
                        ++e;
                        xc = [
                            1
                        ].concat(xc);
                    }
                }
                // Determine trailing zeros.
                for(k = xc.length; !xc[--k];);
                // E.g. [4, 11, 15] becomes 4bf.
                for(i = 0, str = ""; i <= k; str += alphabet.charAt(xc[i++]));
                // Add leading zeros, decimal point and trailing zeros as required.
                str = $6a233875b22d2bbb$var$toFixedPoint(str, e, alphabet.charAt(0));
            }
            // The caller will add the sign.
            return str;
        };
    }();
    // Perform division in the specified base. Called by div and convertBase.
    div = function() {
        // Assume non-zero x and k.
        function multiply(x, k, base) {
            var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % $6a233875b22d2bbb$var$SQRT_BASE, khi = k / $6a233875b22d2bbb$var$SQRT_BASE | 0;
            for(x = x.slice(); i--;){
                xlo = x[i] % $6a233875b22d2bbb$var$SQRT_BASE;
                xhi = x[i] / $6a233875b22d2bbb$var$SQRT_BASE | 0;
                m = khi * xlo + xhi * klo;
                temp = klo * xlo + m % $6a233875b22d2bbb$var$SQRT_BASE * $6a233875b22d2bbb$var$SQRT_BASE + carry;
                carry = (temp / base | 0) + (m / $6a233875b22d2bbb$var$SQRT_BASE | 0) + khi * xhi;
                x[i] = temp % base;
            }
            if (carry) x = [
                carry
            ].concat(x);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, cmp;
            if (aL != bL) cmp = aL > bL ? 1 : -1;
            else {
                for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                    cmp = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return cmp;
        }
        function subtract(a, b, aL, base) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * base + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1; a.splice(0, 1));
        }
        // x: dividend, y: divisor.
        return function(x, y, dp, rm, base) {
            var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
            // Either NaN, Infinity or 0?
            if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
            !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
            xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
            q = new BigNumber(s);
            qc = q.c = [];
            e = x.e - y.e;
            s = dp + e + 1;
            if (!base) {
                base = $6a233875b22d2bbb$var$BASE;
                e = $6a233875b22d2bbb$var$bitFloor(x.e / $6a233875b22d2bbb$var$LOG_BASE) - $6a233875b22d2bbb$var$bitFloor(y.e / $6a233875b22d2bbb$var$LOG_BASE);
                s = s / $6a233875b22d2bbb$var$LOG_BASE | 0;
            }
            // Result exponent may be one less then the current value of e.
            // The coefficients of the BigNumbers from convertBase may have trailing zeros.
            for(i = 0; yc[i] == (xc[i] || 0); i++);
            if (yc[i] > (xc[i] || 0)) e--;
            if (s < 0) {
                qc.push(1);
                more = true;
            } else {
                xL = xc.length;
                yL = yc.length;
                i = 0;
                s += 2;
                // Normalise xc and yc so highest order digit of yc is >= base / 2.
                n = $6a233875b22d2bbb$var$mathfloor(base / (yc[0] + 1));
                // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                if (n > 1) {
                    yc = multiply(yc, n, base);
                    xc = multiply(xc, n, base);
                    yL = yc.length;
                    xL = xc.length;
                }
                xi = yL;
                rem = xc.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL; rem[remL++] = 0);
                yz = yc.slice();
                yz = [
                    0
                ].concat(yz);
                yc0 = yc[0];
                if (yc[1] >= base / 2) yc0++;
                // Not necessary, but to prevent trial digit n > base, when using base 3.
                // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                do {
                    n = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yc, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, n.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                        // n is how many times the divisor goes into the current remainder.
                        n = $6a233875b22d2bbb$var$mathfloor(rem0 / yc0);
                        //  Algorithm:
                        //  product = divisor multiplied by trial digit (n).
                        //  Compare product and remainder.
                        //  If product is greater than remainder:
                        //    Subtract divisor from product, decrement trial digit.
                        //  Subtract product from remainder.
                        //  If product was less than remainder at the last compare:
                        //    Compare new remainder and divisor.
                        //    If remainder is greater than divisor:
                        //      Subtract divisor from remainder, increment trial digit.
                        if (n > 1) {
                            // n may be > base only when base is 3.
                            if (n >= base) n = base - 1;
                            // product = divisor * trial digit.
                            prod = multiply(yc, n, base);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            // If product > remainder then trial digit n too high.
                            // n is 1 too high about 5% of the time, and is not known to have
                            // ever been more than 1 too high.
                            while(compare(prod, rem, prodL, remL) == 1){
                                n--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                prodL = prod.length;
                                cmp = 1;
                            }
                        } else {
                            // n is 0 or 1, cmp is -1.
                            // If n is 0, there is no need to compare yc and rem again below,
                            // so change cmp to 1 to avoid it.
                            // If n is 1, leave cmp as -1, so yc and rem are compared again.
                            if (n == 0) // divisor < remainder, so n must be at least 1.
                            cmp = n = 1;
                            // product = divisor
                            prod = yc.slice();
                            prodL = prod.length;
                        }
                        if (prodL < remL) prod = [
                            0
                        ].concat(prod);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL, base);
                        remL = rem.length;
                        // If product was < remainder.
                        if (cmp == -1) // Compare divisor and new remainder.
                        // If divisor < new remainder, subtract divisor from remainder.
                        // Trial digit n too low.
                        // n is 1 too low about 5% of the time, and very rarely 2 too low.
                        while(compare(yc, rem, yL, remL) < 1){
                            n++;
                            // Subtract divisor from remainder.
                            subtract(rem, yL < remL ? yz : yc, remL, base);
                            remL = rem.length;
                        }
                    } else if (cmp === 0) {
                        n++;
                        rem = [
                            0
                        ];
                    } // else cmp === 1 and n will be 0
                    // Add the next digit, n, to the result array.
                    qc[i++] = n;
                    // Update the remainder.
                    if (rem[0]) rem[remL++] = xc[xi] || 0;
                    else {
                        rem = [
                            xc[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] != null) && s--);
                more = rem[0] != null;
                // Leading zero?
                if (!qc[0]) qc.splice(0, 1);
            }
            if (base == $6a233875b22d2bbb$var$BASE) {
                // To calculate q.e, first get the number of digits of qc[0].
                for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                round(q, dp + (q.e = i + e * $6a233875b22d2bbb$var$LOG_BASE - 1) + 1, rm, more);
            // Caller is convertBase.
            } else {
                q.e = e;
                q.r = +more;
            }
            return q;
        };
    }();
    /*
   * Return a string representing the value of BigNumber n in fixed-point or exponential
   * notation rounded to the specified decimal places or significant digits.
   *
   * n: a BigNumber.
   * i: the index of the last digit required (i.e. the digit that may be rounded up).
   * rm: the rounding mode.
   * id: 1 (toExponential) or 2 (toPrecision).
   */ function format(n, i, rm, id) {
        var c0, e, ne, len, str;
        if (rm == null) rm = ROUNDING_MODE;
        else $6a233875b22d2bbb$var$intCheck(rm, 0, 8);
        if (!n.c) return n.toString();
        c0 = n.c[0];
        ne = n.e;
        if (i == null) {
            str = $6a233875b22d2bbb$var$coeffToString(n.c);
            str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS) ? $6a233875b22d2bbb$var$toExponential(str, ne) : $6a233875b22d2bbb$var$toFixedPoint(str, ne, "0");
        } else {
            n = round(new BigNumber(n), i, rm);
            // n.e may have changed if the value was rounded up.
            e = n.e;
            str = $6a233875b22d2bbb$var$coeffToString(n.c);
            len = str.length;
            // toPrecision returns exponential notation if the number of significant digits
            // specified is less than the number of digits necessary to represent the integer
            // part of the value in fixed-point notation.
            // Exponential notation.
            if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                // Append zeros?
                for(; len < i; str += "0", len++);
                str = $6a233875b22d2bbb$var$toExponential(str, e);
            // Fixed-point notation.
            } else {
                i -= ne;
                str = $6a233875b22d2bbb$var$toFixedPoint(str, e, "0");
                // Append zeros?
                if (e + 1 > len) {
                    if (--i > 0) for(str += "."; i--; str += "0");
                } else {
                    i += e - len;
                    if (i > 0) {
                        if (e + 1 == len) str += ".";
                        for(; i--; str += "0");
                    }
                }
            }
        }
        return n.s < 0 && c0 ? "-" + str : str;
    }
    // Handle BigNumber.max and BigNumber.min.
    // If any number is NaN, return NaN.
    function maxOrMin(args, n) {
        var k, y, i = 1, x = new BigNumber(args[0]);
        for(; i < args.length; i++){
            y = new BigNumber(args[i]);
            if (!y.s || (k = $6a233875b22d2bbb$var$compare(x, y)) === n || k === 0 && x.s === n) x = y;
        }
        return x;
    }
    /*
   * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
   * Called by minus, plus and times.
   */ function normalise(n, c, e) {
        var i = 1, j = c.length;
        // Remove trailing zeros.
        for(; !c[--j]; c.pop());
        // Calculate the base 10 exponent. First get the number of digits of c[0].
        for(j = c[0]; j >= 10; j /= 10, i++);
        // Overflow?
        if ((e = i + e * $6a233875b22d2bbb$var$LOG_BASE - 1) > MAX_EXP) // Infinity.
        n.c = n.e = null;
        else if (e < MIN_EXP) // Zero.
        n.c = [
            n.e = 0
        ];
        else {
            n.e = e;
            n.c = c;
        }
        return n;
    }
    // Handle values that fail the validity test in BigNumber.
    parseNumeric = function() {
        var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
        return function(x, str, isNum, b) {
            var base, s = isNum ? str : str.replace(whitespaceOrPlus, "");
            // No exception on ±Infinity or NaN.
            if (isInfinityOrNaN.test(s)) x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
            else {
                if (!isNum) {
                    // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                    s = s.replace(basePrefix, function(m, p1, p2) {
                        base = (p2 = p2.toLowerCase()) == "x" ? 16 : p2 == "b" ? 2 : 8;
                        return !b || b == base ? p1 : m;
                    });
                    if (b) {
                        base = b;
                        // E.g. '1.' to '1', '.1' to '0.1'
                        s = s.replace(dotAfter, "$1").replace(dotBefore, "0.$1");
                    }
                    if (str != s) return new BigNumber(s, base);
                }
                // '[BigNumber Error] Not a number: {n}'
                // '[BigNumber Error] Not a base {b} number: {n}'
                if (BigNumber.DEBUG) throw Error($6a233875b22d2bbb$var$bignumberError + "Not a" + (b ? " base " + b : "") + " number: " + str);
                // NaN
                x.s = null;
            }
            x.c = x.e = null;
        };
    }();
    /*
   * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
   * If r is truthy, it is known that there are more digits after the rounding digit.
   */ function round(x, sd, rm, r) {
        var d, i, j, k, n, ni, rd, xc = x.c, pows10 = $6a233875b22d2bbb$var$POWS_TEN;
        // if x is not Infinity or NaN...
        if (xc) {
            // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
            // n is a base 1e14 number, the value of the element of array x.c containing rd.
            // ni is the index of n within x.c.
            // d is the number of digits of n.
            // i is the index of rd within n including leading zeros.
            // j is the actual index of rd within n (if < 0, rd is a leading zero).
            out: {
                // Get the number of digits of the first element of xc.
                for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                i = sd - d;
                // If the rounding digit is in the first element of xc...
                if (i < 0) {
                    i += $6a233875b22d2bbb$var$LOG_BASE;
                    j = sd;
                    n = xc[ni = 0];
                    // Get the rounding digit at index j of n.
                    rd = $6a233875b22d2bbb$var$mathfloor(n / pows10[d - j - 1] % 10);
                } else {
                    ni = $6a233875b22d2bbb$var$mathceil((i + 1) / $6a233875b22d2bbb$var$LOG_BASE);
                    if (ni >= xc.length) {
                        if (r) {
                            // Needed by sqrt.
                            for(; xc.length <= ni; xc.push(0));
                            n = rd = 0;
                            d = 1;
                            i %= $6a233875b22d2bbb$var$LOG_BASE;
                            j = i - $6a233875b22d2bbb$var$LOG_BASE + 1;
                        } else break out;
                    } else {
                        n = k = xc[ni];
                        // Get the number of digits of n.
                        for(d = 1; k >= 10; k /= 10, d++);
                        // Get the index of rd within n.
                        i %= $6a233875b22d2bbb$var$LOG_BASE;
                        // Get the index of rd within n, adjusted for leading zeros.
                        // The number of leading zeros of n is given by LOG_BASE - d.
                        j = i - $6a233875b22d2bbb$var$LOG_BASE + d;
                        // Get the rounding digit at index j of n.
                        rd = j < 0 ? 0 : $6a233875b22d2bbb$var$mathfloor(n / pows10[d - j - 1] % 10);
                    }
                }
                r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                if (sd < 1 || !xc[0]) {
                    xc.length = 0;
                    if (r) {
                        // Convert sd to decimal places.
                        sd -= x.e + 1;
                        // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                        xc[0] = pows10[($6a233875b22d2bbb$var$LOG_BASE - sd % $6a233875b22d2bbb$var$LOG_BASE) % $6a233875b22d2bbb$var$LOG_BASE];
                        x.e = -sd || 0;
                    } else // Zero.
                    xc[0] = x.e = 0;
                    return x;
                }
                // Remove excess digits.
                if (i == 0) {
                    xc.length = ni;
                    k = 1;
                    ni--;
                } else {
                    xc.length = ni + 1;
                    k = pows10[$6a233875b22d2bbb$var$LOG_BASE - i];
                    // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                    // j > 0 means i > number of leading zeros of n.
                    xc[ni] = j > 0 ? $6a233875b22d2bbb$var$mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                }
                // Round up?
                if (r) {
                    for(;;)// If the digit to be rounded up is in the first element of xc...
                    if (ni == 0) {
                        // i will be the length of xc[0] before k is added.
                        for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                        j = xc[0] += k;
                        for(k = 1; j >= 10; j /= 10, k++);
                        // if i != k the length has increased.
                        if (i != k) {
                            x.e++;
                            if (xc[0] == $6a233875b22d2bbb$var$BASE) xc[0] = 1;
                        }
                        break;
                    } else {
                        xc[ni] += k;
                        if (xc[ni] != $6a233875b22d2bbb$var$BASE) break;
                        xc[ni--] = 0;
                        k = 1;
                    }
                }
                // Remove trailing zeros.
                for(i = xc.length; xc[--i] === 0; xc.pop());
            }
            // Overflow? Infinity.
            if (x.e > MAX_EXP) x.c = x.e = null;
            else if (x.e < MIN_EXP) x.c = [
                x.e = 0
            ];
        }
        return x;
    }
    function valueOf(n) {
        var str, e = n.e;
        if (e === null) return n.toString();
        str = $6a233875b22d2bbb$var$coeffToString(n.c);
        str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? $6a233875b22d2bbb$var$toExponential(str, e) : $6a233875b22d2bbb$var$toFixedPoint(str, e, "0");
        return n.s < 0 ? "-" + str : str;
    }
    // PROTOTYPE/INSTANCE METHODS
    /*
   * Return a new BigNumber whose value is the absolute value of this BigNumber.
   */ P.absoluteValue = P.abs = function() {
        var x = new BigNumber(this);
        if (x.s < 0) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
   *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
   *   0 if they have the same value,
   *   or null if the value of either is NaN.
   */ P.comparedTo = function(y, b) {
        return $6a233875b22d2bbb$var$compare(this, new BigNumber(y, b));
    };
    /*
   * If dp is undefined or null or true or false, return the number of decimal places of the
   * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
   *
   * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
   * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
   * ROUNDING_MODE if rm is omitted.
   *
   * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */ P.decimalPlaces = P.dp = function(dp, rm) {
        var c, n, v, x = this;
        if (dp != null) {
            $6a233875b22d2bbb$var$intCheck(dp, 0, $6a233875b22d2bbb$var$MAX);
            if (rm == null) rm = ROUNDING_MODE;
            else $6a233875b22d2bbb$var$intCheck(rm, 0, 8);
            return round(new BigNumber(x), dp + x.e + 1, rm);
        }
        if (!(c = x.c)) return null;
        n = ((v = c.length - 1) - $6a233875b22d2bbb$var$bitFloor(this.e / $6a233875b22d2bbb$var$LOG_BASE)) * $6a233875b22d2bbb$var$LOG_BASE;
        // Subtract the number of trailing zeros of the last number.
        if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
        if (n < 0) n = 0;
        return n;
    };
    /*
   *  n / 0 = I
   *  n / N = N
   *  n / I = 0
   *  0 / n = 0
   *  0 / 0 = N
   *  0 / N = N
   *  0 / I = 0
   *  N / n = N
   *  N / 0 = N
   *  N / N = N
   *  N / I = N
   *  I / n = I
   *  I / 0 = I
   *  I / N = N
   *  I / I = N
   *
   * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
   * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
   */ P.dividedBy = P.div = function(y, b) {
        return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
    };
    /*
   * Return a new BigNumber whose value is the integer part of dividing the value of this
   * BigNumber by the value of BigNumber(y, b).
   */ P.dividedToIntegerBy = P.idiv = function(y, b) {
        return div(this, new BigNumber(y, b), 0, 1);
    };
    /*
   * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
   *
   * If m is present, return the result modulo m.
   * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
   * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
   *
   * The modular power operation works efficiently when x, n, and m are integers, otherwise it
   * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
   *
   * n {number|string|BigNumber} The exponent. An integer.
   * [m] {number|string|BigNumber} The modulus.
   *
   * '[BigNumber Error] Exponent not an integer: {n}'
   */ P.exponentiatedBy = P.pow = function(n, m) {
        var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
        n = new BigNumber(n);
        // Allow NaN and ±Infinity, but not other non-integers.
        if (n.c && !n.isInteger()) throw Error($6a233875b22d2bbb$var$bignumberError + "Exponent not an integer: " + valueOf(n));
        if (m != null) m = new BigNumber(m);
        // Exponent of MAX_SAFE_INTEGER is 15.
        nIsBig = n.e > 14;
        // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
        if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
            // The sign of the result of pow when x is negative depends on the evenness of n.
            // If +n overflows to ±Infinity, the evenness of n would be not be known.
            y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - $6a233875b22d2bbb$var$isOdd(n)) : +valueOf(n)));
            return m ? y.mod(m) : y;
        }
        nIsNeg = n.s < 0;
        if (m) {
            // x % m returns NaN if abs(m) is zero, or m is NaN.
            if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
            isModExp = !nIsNeg && x.isInteger() && m.isInteger();
            if (isModExp) x = x.mod(m);
        // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
        // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
        } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
            // If x is negative and n is odd, k = -0, else k = 0.
            k = x.s < 0 && $6a233875b22d2bbb$var$isOdd(n) ? -0 : 0;
            // If x >= 1, k = ±Infinity.
            if (x.e > -1) k = 1 / k;
            // If n is negative return ±0, else return ±Infinity.
            return new BigNumber(nIsNeg ? 1 / k : k);
        } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
        // equates to truncating significant digits to POW_PRECISION + [28, 41],
        // i.e. there will be a minimum of 28 guard digits retained.
        k = $6a233875b22d2bbb$var$mathceil(POW_PRECISION / $6a233875b22d2bbb$var$LOG_BASE + 2);
        if (nIsBig) {
            half = new BigNumber(0.5);
            if (nIsNeg) n.s = 1;
            nIsOdd = $6a233875b22d2bbb$var$isOdd(n);
        } else {
            i = Math.abs(+valueOf(n));
            nIsOdd = i % 2;
        }
        y = new BigNumber(ONE);
        // Performs 54 loop iterations for n of 9007199254740991.
        for(;;){
            if (nIsOdd) {
                y = y.times(x);
                if (!y.c) break;
                if (k) {
                    if (y.c.length > k) y.c.length = k;
                } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
            }
            if (i) {
                i = $6a233875b22d2bbb$var$mathfloor(i / 2);
                if (i === 0) break;
                nIsOdd = i % 2;
            } else {
                n = n.times(half);
                round(n, n.e + 1, 1);
                if (n.e > 14) nIsOdd = $6a233875b22d2bbb$var$isOdd(n);
                else {
                    i = +valueOf(n);
                    if (i === 0) break;
                    nIsOdd = i % 2;
                }
            }
            x = x.times(x);
            if (k) {
                if (x.c && x.c.length > k) x.c.length = k;
            } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
        }
        if (isModExp) return y;
        if (nIsNeg) y = ONE.div(y);
        return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
    };
    /*
   * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
   * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
   *
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
   */ P.integerValue = function(rm) {
        var n = new BigNumber(this);
        if (rm == null) rm = ROUNDING_MODE;
        else $6a233875b22d2bbb$var$intCheck(rm, 0, 8);
        return round(n, n.e + 1, rm);
    };
    /*
   * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
   * otherwise return false.
   */ P.isEqualTo = P.eq = function(y, b) {
        return $6a233875b22d2bbb$var$compare(this, new BigNumber(y, b)) === 0;
    };
    /*
   * Return true if the value of this BigNumber is a finite number, otherwise return false.
   */ P.isFinite = function() {
        return !!this.c;
    };
    /*
   * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
   * otherwise return false.
   */ P.isGreaterThan = P.gt = function(y, b) {
        return $6a233875b22d2bbb$var$compare(this, new BigNumber(y, b)) > 0;
    };
    /*
   * Return true if the value of this BigNumber is greater than or equal to the value of
   * BigNumber(y, b), otherwise return false.
   */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
        return (b = $6a233875b22d2bbb$var$compare(this, new BigNumber(y, b))) === 1 || b === 0;
    };
    /*
   * Return true if the value of this BigNumber is an integer, otherwise return false.
   */ P.isInteger = function() {
        return !!this.c && $6a233875b22d2bbb$var$bitFloor(this.e / $6a233875b22d2bbb$var$LOG_BASE) > this.c.length - 2;
    };
    /*
   * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
   * otherwise return false.
   */ P.isLessThan = P.lt = function(y, b) {
        return $6a233875b22d2bbb$var$compare(this, new BigNumber(y, b)) < 0;
    };
    /*
   * Return true if the value of this BigNumber is less than or equal to the value of
   * BigNumber(y, b), otherwise return false.
   */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
        return (b = $6a233875b22d2bbb$var$compare(this, new BigNumber(y, b))) === -1 || b === 0;
    };
    /*
   * Return true if the value of this BigNumber is NaN, otherwise return false.
   */ P.isNaN = function() {
        return !this.s;
    };
    /*
   * Return true if the value of this BigNumber is negative, otherwise return false.
   */ P.isNegative = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this BigNumber is positive, otherwise return false.
   */ P.isPositive = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
   */ P.isZero = function() {
        return !!this.c && this.c[0] == 0;
    };
    /*
   *  n - 0 = n
   *  n - N = N
   *  n - I = -I
   *  0 - n = -n
   *  0 - 0 = 0
   *  0 - N = N
   *  0 - I = -I
   *  N - n = N
   *  N - 0 = N
   *  N - N = N
   *  N - I = N
   *  I - n = I
   *  I - 0 = I
   *  I - N = N
   *  I - I = N
   *
   * Return a new BigNumber whose value is the value of this BigNumber minus the value of
   * BigNumber(y, b).
   */ P.minus = function(y, b) {
        var i, j, t, xLTy, x = this, a = x.s;
        y = new BigNumber(y, b);
        b = y.s;
        // Either NaN?
        if (!a || !b) return new BigNumber(NaN);
        // Signs differ?
        if (a != b) {
            y.s = -b;
            return x.plus(y);
        }
        var xe = x.e / $6a233875b22d2bbb$var$LOG_BASE, ye = y.e / $6a233875b22d2bbb$var$LOG_BASE, xc = x.c, yc = y.c;
        if (!xe || !ye) {
            // Either Infinity?
            if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
            // Either zero?
            if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
            return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
            ROUNDING_MODE == 3 ? -0 : 0);
        }
        xe = $6a233875b22d2bbb$var$bitFloor(xe);
        ye = $6a233875b22d2bbb$var$bitFloor(ye);
        xc = xc.slice();
        // Determine which is the bigger number.
        if (a = xe - ye) {
            if (xLTy = a < 0) {
                a = -a;
                t = xc;
            } else {
                ye = xe;
                t = yc;
            }
            t.reverse();
            // Prepend zeros to equalise exponents.
            for(b = a; b--; t.push(0));
            t.reverse();
        } else {
            // Exponents equal. Check digit by digit.
            j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
            for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                xLTy = xc[b] < yc[b];
                break;
            }
        }
        // x < y? Point xc to the array of the bigger number.
        if (xLTy) {
            t = xc;
            xc = yc;
            yc = t;
            y.s = -y.s;
        }
        b = (j = yc.length) - (i = xc.length);
        // Append zeros to xc if shorter.
        // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
        if (b > 0) for(; b--; xc[i++] = 0);
        b = $6a233875b22d2bbb$var$BASE - 1;
        // Subtract yc from xc.
        for(; j > a;){
            if (xc[--j] < yc[j]) {
                for(i = j; i && !xc[--i]; xc[i] = b);
                --xc[i];
                xc[j] += $6a233875b22d2bbb$var$BASE;
            }
            xc[j] -= yc[j];
        }
        // Remove leading zeros and adjust exponent accordingly.
        for(; xc[0] == 0; xc.splice(0, 1), --ye);
        // Zero?
        if (!xc[0]) {
            // Following IEEE 754 (2008) 6.3,
            // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
            y.s = ROUNDING_MODE == 3 ? -1 : 1;
            y.c = [
                y.e = 0
            ];
            return y;
        }
        // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
        // for finite x and y.
        return normalise(y, xc, ye);
    };
    /*
   *   n % 0 =  N
   *   n % N =  N
   *   n % I =  n
   *   0 % n =  0
   *  -0 % n = -0
   *   0 % 0 =  N
   *   0 % N =  N
   *   0 % I =  0
   *   N % n =  N
   *   N % 0 =  N
   *   N % N =  N
   *   N % I =  N
   *   I % n =  N
   *   I % 0 =  N
   *   I % N =  N
   *   I % I =  N
   *
   * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
   * BigNumber(y, b). The result depends on the value of MODULO_MODE.
   */ P.modulo = P.mod = function(y, b) {
        var q, s, x = this;
        y = new BigNumber(y, b);
        // Return NaN if x is Infinity or NaN, or y is NaN or zero.
        if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
        else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
        if (MODULO_MODE == 9) {
            // Euclidian division: q = sign(y) * floor(x / abs(y))
            // r = x - qy    where  0 <= r < abs(y)
            s = y.s;
            y.s = 1;
            q = div(x, y, 0, 3);
            y.s = s;
            q.s *= s;
        } else q = div(x, y, 0, MODULO_MODE);
        y = x.minus(q.times(y));
        // To match JavaScript %, ensure sign of zero is sign of dividend.
        if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
        return y;
    };
    /*
   *  n * 0 = 0
   *  n * N = N
   *  n * I = I
   *  0 * n = 0
   *  0 * 0 = 0
   *  0 * N = N
   *  0 * I = N
   *  N * n = N
   *  N * 0 = N
   *  N * N = N
   *  N * I = N
   *  I * n = I
   *  I * 0 = N
   *  I * N = N
   *  I * I = I
   *
   * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
   * of BigNumber(y, b).
   */ P.multipliedBy = P.times = function(y, b) {
        var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
        // Either NaN, ±Infinity or ±0?
        if (!xc || !yc || !xc[0] || !yc[0]) {
            // Return NaN if either is NaN, or one is 0 and the other is Infinity.
            if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
            else {
                y.s *= x.s;
                // Return ±Infinity if either is ±Infinity.
                if (!xc || !yc) y.c = y.e = null;
                else {
                    y.c = [
                        0
                    ];
                    y.e = 0;
                }
            }
            return y;
        }
        e = $6a233875b22d2bbb$var$bitFloor(x.e / $6a233875b22d2bbb$var$LOG_BASE) + $6a233875b22d2bbb$var$bitFloor(y.e / $6a233875b22d2bbb$var$LOG_BASE);
        y.s *= x.s;
        xcL = xc.length;
        ycL = yc.length;
        // Ensure xc points to longer array and xcL to its length.
        if (xcL < ycL) {
            zc = xc;
            xc = yc;
            yc = zc;
            i = xcL;
            xcL = ycL;
            ycL = i;
        }
        // Initialise the result array with zeros.
        for(i = xcL + ycL, zc = []; i--; zc.push(0));
        base = $6a233875b22d2bbb$var$BASE;
        sqrtBase = $6a233875b22d2bbb$var$SQRT_BASE;
        for(i = ycL; --i >= 0;){
            c = 0;
            ylo = yc[i] % sqrtBase;
            yhi = yc[i] / sqrtBase | 0;
            for(k = xcL, j = i + k; j > i;){
                xlo = xc[--k] % sqrtBase;
                xhi = xc[k] / sqrtBase | 0;
                m = yhi * xlo + xhi * ylo;
                xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                zc[j--] = xlo % base;
            }
            zc[j] = c;
        }
        if (c) ++e;
        else zc.splice(0, 1);
        return normalise(y, zc, e);
    };
    /*
   * Return a new BigNumber whose value is the value of this BigNumber negated,
   * i.e. multiplied by -1.
   */ P.negated = function() {
        var x = new BigNumber(this);
        x.s = -x.s || null;
        return x;
    };
    /*
   *  n + 0 = n
   *  n + N = N
   *  n + I = I
   *  0 + n = n
   *  0 + 0 = 0
   *  0 + N = N
   *  0 + I = I
   *  N + n = N
   *  N + 0 = N
   *  N + N = N
   *  N + I = N
   *  I + n = I
   *  I + 0 = I
   *  I + N = N
   *  I + I = I
   *
   * Return a new BigNumber whose value is the value of this BigNumber plus the value of
   * BigNumber(y, b).
   */ P.plus = function(y, b) {
        var t, x = this, a = x.s;
        y = new BigNumber(y, b);
        b = y.s;
        // Either NaN?
        if (!a || !b) return new BigNumber(NaN);
        // Signs differ?
        if (a != b) {
            y.s = -b;
            return x.minus(y);
        }
        var xe = x.e / $6a233875b22d2bbb$var$LOG_BASE, ye = y.e / $6a233875b22d2bbb$var$LOG_BASE, xc = x.c, yc = y.c;
        if (!xe || !ye) {
            // Return ±Infinity if either ±Infinity.
            if (!xc || !yc) return new BigNumber(a / 0);
            // Either zero?
            // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
            if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
        }
        xe = $6a233875b22d2bbb$var$bitFloor(xe);
        ye = $6a233875b22d2bbb$var$bitFloor(ye);
        xc = xc.slice();
        // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
        if (a = xe - ye) {
            if (a > 0) {
                ye = xe;
                t = yc;
            } else {
                a = -a;
                t = xc;
            }
            t.reverse();
            for(; a--; t.push(0));
            t.reverse();
        }
        a = xc.length;
        b = yc.length;
        // Point xc to the longer array, and b to the shorter length.
        if (a - b < 0) {
            t = yc;
            yc = xc;
            xc = t;
            b = a;
        }
        // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
        for(a = 0; b;){
            a = (xc[--b] = xc[b] + yc[b] + a) / $6a233875b22d2bbb$var$BASE | 0;
            xc[b] = $6a233875b22d2bbb$var$BASE === xc[b] ? 0 : xc[b] % $6a233875b22d2bbb$var$BASE;
        }
        if (a) {
            xc = [
                a
            ].concat(xc);
            ++ye;
        }
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        // ye = MAX_EXP + 1 possible
        return normalise(y, xc, ye);
    };
    /*
   * If sd is undefined or null or true or false, return the number of significant digits of
   * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
   * If sd is true include integer-part trailing zeros in the count.
   *
   * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
   * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
   * ROUNDING_MODE if rm is omitted.
   *
   * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
   *                     boolean: whether to count integer-part trailing zeros: true or false.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
   */ P.precision = P.sd = function(sd, rm) {
        var c, n, v, x = this;
        if (sd != null && sd !== !!sd) {
            $6a233875b22d2bbb$var$intCheck(sd, 1, $6a233875b22d2bbb$var$MAX);
            if (rm == null) rm = ROUNDING_MODE;
            else $6a233875b22d2bbb$var$intCheck(rm, 0, 8);
            return round(new BigNumber(x), sd, rm);
        }
        if (!(c = x.c)) return null;
        v = c.length - 1;
        n = v * $6a233875b22d2bbb$var$LOG_BASE + 1;
        if (v = c[v]) {
            // Subtract the number of trailing zeros of the last element.
            for(; v % 10 == 0; v /= 10, n--);
            // Add the number of digits of the first element.
            for(v = c[0]; v >= 10; v /= 10, n++);
        }
        if (sd && x.e + 1 > n) n = x.e + 1;
        return n;
    };
    /*
   * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
   * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
   *
   * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
   */ P.shiftedBy = function(k) {
        $6a233875b22d2bbb$var$intCheck(k, -$6a233875b22d2bbb$var$MAX_SAFE_INTEGER, $6a233875b22d2bbb$var$MAX_SAFE_INTEGER);
        return this.times("1e" + k);
    };
    /*
   *  sqrt(-n) =  N
   *  sqrt(N) =  N
   *  sqrt(-I) =  N
   *  sqrt(I) =  I
   *  sqrt(0) =  0
   *  sqrt(-0) = -0
   *
   * Return a new BigNumber whose value is the square root of the value of this BigNumber,
   * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
   */ P.squareRoot = P.sqrt = function() {
        var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber("0.5");
        // Negative/NaN/Infinity/zero?
        if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
        // Initial estimate.
        s = Math.sqrt(+valueOf(x));
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = $6a233875b22d2bbb$var$coeffToString(c);
            if ((n.length + e) % 2 == 0) n += "0";
            s = Math.sqrt(+n);
            e = $6a233875b22d2bbb$var$bitFloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = "5e" + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf("e") + 1) + e;
            }
            r = new BigNumber(n);
        } else r = new BigNumber(s + "");
        // Check for zero.
        // r could be zero if MIN_EXP is changed after the this value was created.
        // This would cause a division by zero (x/t) and hence Infinity below, which would cause
        // coeffToString to throw.
        if (r.c[0]) {
            e = r.e;
            s = e + dp;
            if (s < 3) s = 0;
            // Newton-Raphson iteration.
            for(;;){
                t = r;
                r = half.times(t.plus(div(x, t, dp, 1)));
                if ($6a233875b22d2bbb$var$coeffToString(t.c).slice(0, s) === (n = $6a233875b22d2bbb$var$coeffToString(r.c)).slice(0, s)) {
                    // The exponent of r may here be one less than the final result exponent,
                    // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                    // are indexed correctly.
                    if (r.e < e) --s;
                    n = n.slice(s - 3, s + 1);
                    // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                    // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                    // iteration.
                    if (n == "9999" || !rep && n == "4999") {
                        // On the first iteration only, check to see if rounding up gives the
                        // exact result as the nines may infinitely repeat.
                        if (!rep) {
                            round(t, t.e + DECIMAL_PLACES + 2, 0);
                            if (t.times(t).eq(x)) {
                                r = t;
                                break;
                            }
                        }
                        dp += 4;
                        s += 4;
                        rep = 1;
                    } else {
                        // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                        // result. If not, then there are further digits and m will be truthy.
                        if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                            // Truncate to the first rounding digit.
                            round(r, r.e + DECIMAL_PLACES + 2, 1);
                            m = !r.times(r).eq(x);
                        }
                        break;
                    }
                }
            }
        }
        return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
    };
    /*
   * Return a string representing the value of this BigNumber in exponential notation and
   * rounded using ROUNDING_MODE to dp fixed decimal places.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */ P.toExponential = function(dp, rm) {
        if (dp != null) {
            $6a233875b22d2bbb$var$intCheck(dp, 0, $6a233875b22d2bbb$var$MAX);
            dp++;
        }
        return format(this, dp, rm, 1);
    };
    /*
   * Return a string representing the value of this BigNumber in fixed-point notation rounding
   * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
   *
   * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
   * but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */ P.toFixed = function(dp, rm) {
        if (dp != null) {
            $6a233875b22d2bbb$var$intCheck(dp, 0, $6a233875b22d2bbb$var$MAX);
            dp = dp + this.e + 1;
        }
        return format(this, dp, rm);
    };
    /*
   * Return a string representing the value of this BigNumber in fixed-point notation rounded
   * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
   * of the format or FORMAT object (see BigNumber.set).
   *
   * The formatting object may contain some or all of the properties shown below.
   *
   * FORMAT = {
   *   prefix: '',
   *   groupSize: 3,
   *   secondaryGroupSize: 0,
   *   groupSeparator: ',',
   *   decimalSeparator: '.',
   *   fractionGroupSize: 0,
   *   fractionGroupSeparator: '\xA0',      // non-breaking space
   *   suffix: ''
   * };
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   * [format] {object} Formatting options. See FORMAT pbject above.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   * '[BigNumber Error] Argument not an object: {format}'
   */ P.toFormat = function(dp, rm, format) {
        var str, x = this;
        if (format == null) {
            if (dp != null && rm && typeof rm == "object") {
                format = rm;
                rm = null;
            } else if (dp && typeof dp == "object") {
                format = dp;
                dp = rm = null;
            } else format = FORMAT;
        } else if (typeof format != "object") throw Error($6a233875b22d2bbb$var$bignumberError + "Argument not an object: " + format);
        str = x.toFixed(dp, rm);
        if (x.c) {
            var i, arr = str.split("."), g1 = +format.groupSize, g2 = +format.secondaryGroupSize, groupSeparator = format.groupSeparator || "", intPart = arr[0], fractionPart = arr[1], isNeg = x.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
            if (g2) {
                i = g1;
                g1 = g2;
                g2 = i;
                len -= i;
            }
            if (g1 > 0 && len > 0) {
                i = len % g1 || g1;
                intPart = intDigits.substr(0, i);
                for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                if (isNeg) intPart = "-" + intPart;
            }
            str = fractionPart ? intPart + (format.decimalSeparator || "") + ((g2 = +format.fractionGroupSize) ? fractionPart.replace(new RegExp("\\d{" + g2 + "}\\B", "g"), "$&" + (format.fractionGroupSeparator || "")) : fractionPart) : intPart;
        }
        return (format.prefix || "") + str + (format.suffix || "");
    };
    /*
   * Return an array of two BigNumbers representing the value of this BigNumber as a simple
   * fraction with an integer numerator and an integer denominator.
   * The denominator will be a positive non-zero value less than or equal to the specified
   * maximum denominator. If a maximum denominator is not specified, the denominator will be
   * the lowest value necessary to represent the number exactly.
   *
   * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
   *
   * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
   */ P.toFraction = function(md) {
        var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s, x = this, xc = x.c;
        if (md != null) {
            n = new BigNumber(md);
            // Throw if md is less than one or is not an integer, unless it is Infinity.
            if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error($6a233875b22d2bbb$var$bignumberError + "Argument " + (n.isInteger() ? "out of range: " : "not an integer: ") + valueOf(n));
        }
        if (!xc) return new BigNumber(x);
        d = new BigNumber(ONE);
        n1 = d0 = new BigNumber(ONE);
        d1 = n0 = new BigNumber(ONE);
        s = $6a233875b22d2bbb$var$coeffToString(xc);
        // Determine initial denominator.
        // d is a power of 10 and the minimum max denominator that specifies the value exactly.
        e = d.e = s.length - x.e - 1;
        d.c[0] = $6a233875b22d2bbb$var$POWS_TEN[(exp = e % $6a233875b22d2bbb$var$LOG_BASE) < 0 ? $6a233875b22d2bbb$var$LOG_BASE + exp : exp];
        md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
        exp = MAX_EXP;
        MAX_EXP = 1 / 0;
        n = new BigNumber(s);
        // n0 = d1 = 0
        n0.c[0] = 0;
        for(;;){
            q = div(n, d, 0, 1);
            d2 = d0.plus(q.times(d1));
            if (d2.comparedTo(md) == 1) break;
            d0 = d1;
            d1 = d2;
            n1 = n0.plus(q.times(d2 = n1));
            n0 = d2;
            d = n.minus(q.times(d2 = d));
            n = d2;
        }
        d2 = div(md.minus(d0), d1, 0, 1);
        n0 = n0.plus(d2.times(n1));
        d0 = d0.plus(d2.times(d1));
        n0.s = n1.s = x.s;
        e = e * 2;
        // Determine which fraction is closer to x, n0/d0 or n1/d1
        r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
            n1,
            d1
        ] : [
            n0,
            d0
        ];
        MAX_EXP = exp;
        return r;
    };
    /*
   * Return the value of this BigNumber converted to a number primitive.
   */ P.toNumber = function() {
        return +valueOf(this);
    };
    /*
   * Return a string representing the value of this BigNumber rounded to sd significant digits
   * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
   * necessary to represent the integer part of the value in fixed-point notation, then use
   * exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
   */ P.toPrecision = function(sd, rm) {
        if (sd != null) $6a233875b22d2bbb$var$intCheck(sd, 1, $6a233875b22d2bbb$var$MAX);
        return format(this, sd, rm, 2);
    };
    /*
   * Return a string representing the value of this BigNumber in base b, or base 10 if b is
   * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
   * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
   * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
   * TO_EXP_NEG, return exponential notation.
   *
   * [b] {number} Integer, 2 to ALPHABET.length inclusive.
   *
   * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
   */ P.toString = function(b) {
        var str, n = this, s = n.s, e = n.e;
        // Infinity or NaN?
        if (e === null) {
            if (s) {
                str = "Infinity";
                if (s < 0) str = "-" + str;
            } else str = "NaN";
        } else {
            if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? $6a233875b22d2bbb$var$toExponential($6a233875b22d2bbb$var$coeffToString(n.c), e) : $6a233875b22d2bbb$var$toFixedPoint($6a233875b22d2bbb$var$coeffToString(n.c), e, "0");
            else if (b === 10 && alphabetHasNormalDecimalDigits) {
                n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
                str = $6a233875b22d2bbb$var$toFixedPoint($6a233875b22d2bbb$var$coeffToString(n.c), n.e, "0");
            } else {
                $6a233875b22d2bbb$var$intCheck(b, 2, ALPHABET.length, "Base");
                str = convertBase($6a233875b22d2bbb$var$toFixedPoint($6a233875b22d2bbb$var$coeffToString(n.c), e, "0"), 10, b, s, true);
            }
            if (s < 0 && n.c[0]) str = "-" + str;
        }
        return str;
    };
    /*
   * Return as toString, but do not accept a base argument, and include the minus sign for
   * negative zero.
   */ P.valueOf = P.toJSON = function() {
        return valueOf(this);
    };
    P._isBigNumber = true;
    P[Symbol.toStringTag] = "BigNumber";
    // Node.js v10.12.0+
    P[Symbol.for("nodejs.util.inspect.custom")] = P.valueOf;
    if (configObject != null) BigNumber.set(configObject);
    return BigNumber;
}
// PRIVATE HELPER FUNCTIONS
// These functions don't need access to variables,
// e.g. DECIMAL_PLACES, in the scope of the `clone` function above.
function $6a233875b22d2bbb$var$bitFloor(n) {
    var i = n | 0;
    return n > 0 || n === i ? i : i - 1;
}
// Return a coefficient array as a string of base 10 digits.
function $6a233875b22d2bbb$var$coeffToString(a) {
    var s, z, i = 1, j = a.length, r = a[0] + "";
    for(; i < j;){
        s = a[i++] + "";
        z = $6a233875b22d2bbb$var$LOG_BASE - s.length;
        for(; z--; s = "0" + s);
        r += s;
    }
    // Determine trailing zeros.
    for(j = r.length; r.charCodeAt(--j) === 48;);
    return r.slice(0, j + 1 || 1);
}
// Compare the value of BigNumbers x and y.
function $6a233875b22d2bbb$var$compare(x, y) {
    var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
    // Either NaN?
    if (!i || !j) return null;
    a = xc && !xc[0];
    b = yc && !yc[0];
    // Either zero?
    if (a || b) return a ? b ? 0 : -j : i;
    // Signs differ?
    if (i != j) return i;
    a = i < 0;
    b = k == l;
    // Either Infinity?
    if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
    // Compare exponents.
    if (!b) return k > l ^ a ? 1 : -1;
    j = (k = xc.length) < (l = yc.length) ? k : l;
    // Compare digit by digit.
    for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
    // Compare lengths.
    return k == l ? 0 : k > l ^ a ? 1 : -1;
}
/*
 * Check that n is a primitive number, an integer, and in range, otherwise throw.
 */ function $6a233875b22d2bbb$var$intCheck(n, min, max, name) {
    if (n < min || n > max || n !== $6a233875b22d2bbb$var$mathfloor(n)) throw Error($6a233875b22d2bbb$var$bignumberError + (name || "Argument") + (typeof n == "number" ? n < min || n > max ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(n));
}
// Assumes finite n.
function $6a233875b22d2bbb$var$isOdd(n) {
    var k = n.c.length - 1;
    return $6a233875b22d2bbb$var$bitFloor(n.e / $6a233875b22d2bbb$var$LOG_BASE) == k && n.c[k] % 2 != 0;
}
function $6a233875b22d2bbb$var$toExponential(str, e) {
    return (str.length > 1 ? str.charAt(0) + "." + str.slice(1) : str) + (e < 0 ? "e" : "e+") + e;
}
function $6a233875b22d2bbb$var$toFixedPoint(str, e, z) {
    var len, zs;
    // Negative exponent?
    if (e < 0) {
        // Prepend zeros.
        for(zs = z + "."; ++e; zs += z);
        str = zs + str;
    // Positive exponent
    } else {
        len = str.length;
        // Append zeros.
        if (++e > len) {
            for(zs = z, e -= len; --e; zs += z);
            str += zs;
        } else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
    }
    return str;
}
var $6a233875b22d2bbb$export$d97aa349ed20696 = $6a233875b22d2bbb$var$clone();
var $6a233875b22d2bbb$export$2e2bcd8739ae039 = $6a233875b22d2bbb$export$d97aa349ed20696;

});


parcelRegister("c3zzE", function(module, exports) {

$parcel$export(module.exports, "InputUtil", function () { return $8c715c1d007e4843$export$14dd5e87e3c1b0c9; });
var $8c715c1d007e4843$export$14dd5e87e3c1b0c9 = {
    numericInputKeyDown: function(event, currentValue, onChange) {
        var allowedKeys = [
            "Backspace",
            "Meta",
            "Ctrl",
            "a",
            "A",
            "c",
            "C",
            "x",
            "X",
            "v",
            "V",
            "ArrowLeft",
            "ArrowRight",
            "Tab"
        ];
        var controlPressed = event.metaKey || event.ctrlKey;
        var eventKey = event.key;
        var lowercaseEventKey = eventKey.toLocaleLowerCase();
        var selectAll = lowercaseEventKey === "a";
        var copyKey = lowercaseEventKey === "c";
        var pasteKey = lowercaseEventKey === "v";
        var cutKey = lowercaseEventKey === "x";
        var isComma = eventKey === ",";
        var isDot = eventKey === ".";
        var isNumericKey = eventKey >= "0" && eventKey <= "9";
        if (!controlPressed && (selectAll || copyKey || pasteKey || cutKey)) event.preventDefault();
        if (currentValue === "0" && !isComma && !isDot && eventKey === "0") event.preventDefault();
        if (currentValue === "0" && isNumericKey) {
            onChange(eventKey);
            event.preventDefault();
        }
        if (isComma || isDot) {
            if (!currentValue) {
                onChange("0.");
                event.preventDefault();
            }
            if ((currentValue === null || currentValue === void 0 ? void 0 : currentValue.includes(".")) || (currentValue === null || currentValue === void 0 ? void 0 : currentValue.includes(","))) event.preventDefault();
        }
        if (!isNumericKey && !allowedKeys.includes(eventKey) && !isDot && !isComma) event.preventDefault();
    }
};

});

parcelRegister("55oQe", function(module, exports) {

$parcel$export(module.exports, "erc20ABI", function () { return $3b40b0595dc04c1b$export$e125cdc2a458cf13; });
var $3b40b0595dc04c1b$export$e125cdc2a458cf13 = [
    {
        constant: true,
        inputs: [],
        name: "name",
        outputs: [
            {
                name: "",
                type: "string"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: false,
        inputs: [
            {
                name: "_spender",
                type: "address"
            },
            {
                name: "_value",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        constant: true,
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: false,
        inputs: [
            {
                name: "_from",
                type: "address"
            },
            {
                name: "_to",
                type: "address"
            },
            {
                name: "_value",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        constant: true,
        inputs: [],
        name: "decimals",
        outputs: [
            {
                name: "",
                type: "uint8"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: true,
        inputs: [
            {
                name: "_owner",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                name: "balance",
                type: "uint256"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: true,
        inputs: [],
        name: "symbol",
        outputs: [
            {
                name: "",
                type: "string"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: false,
        inputs: [
            {
                name: "_to",
                type: "address"
            },
            {
                name: "_value",
                type: "uint256"
            }
        ],
        name: "transfer",
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        constant: true,
        inputs: [
            {
                name: "_owner",
                type: "address"
            },
            {
                name: "_spender",
                type: "address"
            }
        ],
        name: "allowance",
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        payable: true,
        stateMutability: "payable",
        type: "fallback"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    }
];

});

parcelRegister("ejaSv", function(module, exports) {

$parcel$export(module.exports, "NavigationUtil", function () { return $a6ab47300da85b13$export$9dec99ba6a2a5c00; });
var $a6ab47300da85b13$export$9dec99ba6a2a5c00 = {
    URLS: {
        FAQ: "https://walletconnect.com/faq"
    }
};

});

parcelRegister("3QZC1", function(module, exports) {

$parcel$export(module.exports, "ConstantsUtil", function () { return $2ce60558971fb271$export$aafe1f751f1bc52a; });
var $2ce60558971fb271$export$aafe1f751f1bc52a = {
    WC_NAME_SUFFIX: ".wcn.id",
    BLOCKCHAIN_API_RPC_URL: "https://rpc.walletconnect.org",
    PULSE_API_URL: "https://pulse.walletconnect.org",
    W3M_API_URL: "https://api.web3modal.org",
    CHAIN: {
        EVM: "evm",
        SOLANA: "solana"
    },
    CHAIN_NAME_MAP: {
        evm: "Ethereum",
        solana: "Solana"
    }
};

});

parcelRegister("cnADL", function(module, exports) {

$parcel$export(module.exports, "getW3mThemeVariables", function () { return $90340e0acf9a57bb$export$5ab0d52f4d8873e4; });
function $90340e0acf9a57bb$export$5ab0d52f4d8873e4(themeVariables, themeType) {
    if (themeType === "light") return {
        "--w3m-accent": (themeVariables === null || themeVariables === void 0 ? void 0 : themeVariables["--w3m-accent"]) || "hsla(231, 100%, 70%, 1)",
        "--w3m-background": "#fff"
    };
    return {
        "--w3m-accent": (themeVariables === null || themeVariables === void 0 ? void 0 : themeVariables["--w3m-accent"]) || "hsla(230, 100%, 67%, 1)",
        "--w3m-background": "#121313"
    };
}

});


parcelRegister("2sXdV", function(module, exports) {

$parcel$export(module.exports, "ONRAMP_PROVIDERS", function () { return $1cbc22e31bd62b9b$export$e021b4b4649620f6; });
$parcel$export(module.exports, "ConstantsUtil", function () { return $1cbc22e31bd62b9b$export$aafe1f751f1bc52a; });
var $1cbc22e31bd62b9b$var$SECURE_SITE = "https://secure.walletconnect.org";
var $1cbc22e31bd62b9b$export$e021b4b4649620f6 = [
    {
        label: "Coinbase",
        name: "coinbase",
        feeRange: "1-2%",
        url: ""
    }
];
var $1cbc22e31bd62b9b$export$aafe1f751f1bc52a = {
    FOUR_MINUTES_MS: 240000,
    TEN_SEC_MS: 10000,
    ONE_SEC_MS: 1000,
    SECURE_SITE: $1cbc22e31bd62b9b$var$SECURE_SITE,
    SECURE_SITE_DASHBOARD: "".concat($1cbc22e31bd62b9b$var$SECURE_SITE, "/dashboard"),
    SECURE_SITE_FAVICON: "".concat($1cbc22e31bd62b9b$var$SECURE_SITE, "/images/favicon.png"),
    RESTRICTED_TIMEZONES: [
        "ASIA/SHANGHAI",
        "ASIA/URUMQI",
        "ASIA/CHONGQING",
        "ASIA/HARBIN",
        "ASIA/KASHGAR",
        "ASIA/MACAU",
        "ASIA/HONG_KONG",
        "ASIA/MACAO",
        "ASIA/BEIJING",
        "ASIA/HARBIN"
    ],
    /**
     * Network name to Coinbase Pay SDK chain name map object
     * @see supported chain names on Coinbase for Pay SDK: https://github.com/coinbase/cbpay-js/blob/d4bda2c05c4d5917c8db6a05476b603546046394/src/types/onramp.ts
     */ WC_COINBASE_PAY_SDK_CHAINS: [
        "ethereum",
        "arbitrum",
        "polygon",
        "avalanche-c-chain",
        "optimism",
        "celo",
        "base"
    ],
    WC_COINBASE_PAY_SDK_FALLBACK_CHAIN: "ethereum",
    WC_COINBASE_PAY_SDK_CHAIN_NAME_MAP: {
        Ethereum: "ethereum",
        "Arbitrum One": "arbitrum",
        Polygon: "polygon",
        Avalanche: "avalanche-c-chain",
        "OP Mainnet": "optimism",
        Celo: "celo",
        Base: "base"
    },
    WC_COINBASE_ONRAMP_APP_ID: "bf18c88d-495a-463b-b249-0b9d3656cf5e",
    SWAP_SUGGESTED_TOKENS: [
        "ETH",
        "UNI",
        "1INCH",
        "AAVE",
        "SOL",
        "ADA",
        "AVAX",
        "DOT",
        "LINK",
        "NITRO",
        "GAIA",
        "MILK",
        "TRX",
        "NEAR",
        "GNO",
        "WBTC",
        "DAI",
        "WETH",
        "USDC",
        "USDT",
        "ARB",
        "BAL",
        "BICO",
        "CRV",
        "ENS",
        "MATIC",
        "OP"
    ],
    SWAP_POPULAR_TOKENS: [
        "ETH",
        "UNI",
        "1INCH",
        "AAVE",
        "SOL",
        "ADA",
        "AVAX",
        "DOT",
        "LINK",
        "NITRO",
        "GAIA",
        "MILK",
        "TRX",
        "NEAR",
        "GNO",
        "WBTC",
        "DAI",
        "WETH",
        "USDC",
        "USDT",
        "ARB",
        "BAL",
        "BICO",
        "CRV",
        "ENS",
        "MATIC",
        "OP",
        "METAL",
        "DAI",
        "CHAMP",
        "WOLF",
        "SALE",
        "BAL",
        "BUSD",
        "MUST",
        "BTCpx",
        "ROUTE",
        "HEX",
        "WELT",
        "amDAI",
        "VSQ",
        "VISION",
        "AURUM",
        "pSP",
        "SNX",
        "VC",
        "LINK",
        "CHP",
        "amUSDT",
        "SPHERE",
        "FOX",
        "GIDDY",
        "GFC",
        "OMEN",
        "OX_OLD",
        "DE",
        "WNT"
    ],
    SWAP_SUPPORTED_NETWORKS: [
        // Ethereum'
        "eip155:1",
        // Arbitrum One'
        "eip155:42161",
        // Optimism'
        "eip155:10",
        // ZKSync Era'
        "eip155:324",
        // Base'
        "eip155:8453",
        // BNB Smart Chain'
        "eip155:56",
        // Polygon'
        "eip155:137",
        // Gnosis'
        "eip155:100",
        // Avalanche'
        "eip155:43114",
        // Fantom'
        "eip155:250",
        // Klaytn'
        "eip155:8217",
        // Aurora
        "eip155:1313161554"
    ],
    NATIVE_TOKEN_ADDRESS: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
    CONVERT_SLIPPAGE_TOLERANCE: 1
};

});


parcelRegister("jrvVk", function(module, exports) {

$parcel$export(module.exports, "BlockchainApiController", function () { return $e2794d516b97a52d$export$9c45fcf03cadbfaa; });

var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $2sXdV = parcelRequire("2sXdV");

var $hZBJb = parcelRequire("hZBJb");

var $7CVRB = parcelRequire("7CVRB");
parcelRequire("dSKxG");
var $3QZC1 = parcelRequire("3QZC1");

var $faNff = parcelRequire("faNff");

var $hyDkn = parcelRequire("hyDkn");

var $dMLJP = parcelRequire("dMLJP");
var $e2794d516b97a52d$var$DEFAULT_OPTIONS = {
    purchaseCurrencies: [
        {
            id: "2b92315d-eab7-5bef-84fa-089a131333f5",
            name: "USD Coin",
            symbol: "USDC",
            networks: [
                {
                    name: "ethereum-mainnet",
                    display_name: "Ethereum",
                    chain_id: "1",
                    contract_address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"
                },
                {
                    name: "polygon-mainnet",
                    display_name: "Polygon",
                    chain_id: "137",
                    contract_address: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174"
                }
            ]
        },
        {
            id: "2b92315d-eab7-5bef-84fa-089a131333f5",
            name: "Ether",
            symbol: "ETH",
            networks: [
                {
                    name: "ethereum-mainnet",
                    display_name: "Ethereum",
                    chain_id: "1",
                    contract_address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"
                },
                {
                    name: "polygon-mainnet",
                    display_name: "Polygon",
                    chain_id: "137",
                    contract_address: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174"
                }
            ]
        }
    ],
    paymentCurrencies: [
        {
            id: "USD",
            payment_method_limits: [
                {
                    id: "card",
                    min: "10.00",
                    max: "7500.00"
                },
                {
                    id: "ach_bank_account",
                    min: "10.00",
                    max: "25000.00"
                }
            ]
        },
        {
            id: "EUR",
            payment_method_limits: [
                {
                    id: "card",
                    min: "10.00",
                    max: "7500.00"
                },
                {
                    id: "ach_bank_account",
                    min: "10.00",
                    max: "25000.00"
                }
            ]
        }
    ]
};
// -- Helpers ------------------------------------------- //
var $e2794d516b97a52d$var$baseUrl = (0, $hZBJb.CoreHelperUtil).getBlockchainApiUrl();
// -- State --------------------------------------------- //
var $e2794d516b97a52d$var$state = (0, $hyDkn.proxy)({
    clientId: null,
    api: new (0, $7CVRB.FetchUtil)({
        baseUrl: $e2794d516b97a52d$var$baseUrl,
        clientId: null
    })
});
var $e2794d516b97a52d$export$9c45fcf03cadbfaa = {
    state: $e2794d516b97a52d$var$state,
    fetchIdentity: function(param) {
        var address = param.address;
        return $e2794d516b97a52d$var$state.api.get({
            path: "/v1/identity/".concat(address),
            params: {
                projectId: (0, $faNff.OptionsController).state.projectId,
                sender: (0, $dMLJP.AccountController).state.address
            }
        });
    },
    fetchTransactions: function(param) {
        var account = param.account, projectId = param.projectId, cursor = param.cursor, onramp = param.onramp, signal = param.signal, cache = param.cache;
        return $e2794d516b97a52d$var$state.api.get({
            path: "/v1/account/".concat(account, "/history"),
            params: {
                projectId: projectId,
                cursor: cursor,
                onramp: onramp
            },
            signal: signal,
            cache: cache
        });
    },
    fetchSwapQuote: function(param) {
        var projectId = param.projectId, amount = param.amount, userAddress = param.userAddress, from = param.from, to = param.to, gasPrice = param.gasPrice;
        return $e2794d516b97a52d$var$state.api.get({
            path: "/v1/convert/quotes",
            headers: {
                "Content-Type": "application/json"
            },
            params: {
                projectId: projectId,
                amount: amount,
                userAddress: userAddress,
                from: from,
                to: to,
                gasPrice: gasPrice
            }
        });
    },
    fetchSwapTokens: function(param) {
        var projectId = param.projectId, chainId = param.chainId;
        return $e2794d516b97a52d$var$state.api.get({
            path: "/v1/convert/tokens",
            params: {
                projectId: projectId,
                chainId: chainId
            }
        });
    },
    fetchTokenPrice: function(param) {
        var projectId = param.projectId, addresses = param.addresses;
        return $e2794d516b97a52d$var$state.api.post({
            path: "/v1/fungible/price",
            body: {
                projectId: projectId,
                currency: "usd",
                addresses: addresses
            },
            headers: {
                "Content-Type": "application/json"
            }
        });
    },
    fetchSwapAllowance: function(param) {
        var projectId = param.projectId, tokenAddress = param.tokenAddress, userAddress = param.userAddress;
        var _OptionsController_state = (0, $faNff.OptionsController).state, sdkType = _OptionsController_state.sdkType, sdkVersion = _OptionsController_state.sdkVersion;
        return $e2794d516b97a52d$var$state.api.get({
            path: "/v1/convert/allowance",
            params: {
                projectId: projectId,
                tokenAddress: tokenAddress,
                userAddress: userAddress
            },
            headers: {
                "Content-Type": "application/json",
                "x-sdk-type": sdkType,
                "x-sdk-version": sdkVersion
            }
        });
    },
    fetchGasPrice: function(param) {
        var projectId = param.projectId, chainId = param.chainId;
        var _OptionsController_state = (0, $faNff.OptionsController).state, sdkType = _OptionsController_state.sdkType, sdkVersion = _OptionsController_state.sdkVersion;
        return $e2794d516b97a52d$var$state.api.get({
            path: "/v1/convert/gas-price",
            headers: {
                "Content-Type": "application/json",
                "x-sdk-type": sdkType,
                "x-sdk-version": sdkVersion
            },
            params: {
                projectId: projectId,
                chainId: chainId
            }
        });
    },
    generateSwapCalldata: function(param) {
        var amount = param.amount, from = param.from, projectId = param.projectId, to = param.to, userAddress = param.userAddress;
        return $e2794d516b97a52d$var$state.api.post({
            path: "/v1/convert/build-transaction",
            headers: {
                "Content-Type": "application/json"
            },
            body: {
                amount: amount,
                eip155: {
                    slippage: (0, $2sXdV.ConstantsUtil).CONVERT_SLIPPAGE_TOLERANCE
                },
                from: from,
                projectId: projectId,
                to: to,
                userAddress: userAddress
            }
        });
    },
    generateApproveCalldata: function(param) {
        var from = param.from, projectId = param.projectId, to = param.to, userAddress = param.userAddress;
        var _OptionsController_state = (0, $faNff.OptionsController).state, sdkType = _OptionsController_state.sdkType, sdkVersion = _OptionsController_state.sdkVersion;
        return $e2794d516b97a52d$var$state.api.get({
            path: "/v1/convert/build-approve",
            headers: {
                "Content-Type": "application/json",
                "x-sdk-type": sdkType,
                "x-sdk-version": sdkVersion
            },
            params: {
                projectId: projectId,
                userAddress: userAddress,
                from: from,
                to: to
            }
        });
    },
    getBalance: function(address, chainId, forceUpdate) {
        return (0, $kSuI9._)(function() {
            var _OptionsController_state, sdkType, sdkVersion;
            return (0, $eha6O.__generator)(this, function(_state) {
                _OptionsController_state = (0, $faNff.OptionsController).state, sdkType = _OptionsController_state.sdkType, sdkVersion = _OptionsController_state.sdkVersion;
                return [
                    2,
                    $e2794d516b97a52d$var$state.api.get({
                        path: "/v1/account/".concat(address, "/balance"),
                        headers: {
                            "x-sdk-type": sdkType,
                            "x-sdk-version": sdkVersion
                        },
                        params: {
                            currency: "usd",
                            projectId: (0, $faNff.OptionsController).state.projectId,
                            chainId: chainId,
                            forceUpdate: forceUpdate
                        }
                    })
                ];
            });
        })();
    },
    lookupEnsName: function(name) {
        return (0, $kSuI9._)(function() {
            return (0, $eha6O.__generator)(this, function(_state) {
                return [
                    2,
                    $e2794d516b97a52d$var$state.api.get({
                        path: "/v1/profile/account/".concat(name).concat((0, $3QZC1.ConstantsUtil).WC_NAME_SUFFIX),
                        params: {
                            projectId: (0, $faNff.OptionsController).state.projectId
                        }
                    })
                ];
            });
        })();
    },
    reverseLookupEnsName: function(param) {
        var address = param.address;
        return (0, $kSuI9._)(function() {
            return (0, $eha6O.__generator)(this, function(_state) {
                return [
                    2,
                    $e2794d516b97a52d$var$state.api.get({
                        path: "/v1/profile/reverse/".concat(address),
                        params: {
                            sender: (0, $dMLJP.AccountController).state.address,
                            projectId: (0, $faNff.OptionsController).state.projectId
                        }
                    })
                ];
            });
        })();
    },
    getEnsNameSuggestions: function(name) {
        return (0, $kSuI9._)(function() {
            return (0, $eha6O.__generator)(this, function(_state) {
                return [
                    2,
                    $e2794d516b97a52d$var$state.api.get({
                        path: "/v1/profile/suggestions/".concat(name),
                        params: {
                            projectId: (0, $faNff.OptionsController).state.projectId
                        }
                    })
                ];
            });
        })();
    },
    registerEnsName: function(param) {
        var coinType = param.coinType, address = param.address, message = param.message, signature = param.signature;
        return (0, $kSuI9._)(function() {
            return (0, $eha6O.__generator)(this, function(_state) {
                return [
                    2,
                    $e2794d516b97a52d$var$state.api.post({
                        path: "/v1/profile/account",
                        body: {
                            coin_type: coinType,
                            address: address,
                            message: message,
                            signature: signature
                        },
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                ];
            });
        })();
    },
    generateOnRampURL: function(param) {
        var destinationWallets = param.destinationWallets, partnerUserId = param.partnerUserId, defaultNetwork = param.defaultNetwork, purchaseAmount = param.purchaseAmount, paymentAmount = param.paymentAmount;
        return (0, $kSuI9._)(function() {
            var response;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            $e2794d516b97a52d$var$state.api.post({
                                path: "/v1/generators/onrampurl",
                                params: {
                                    projectId: (0, $faNff.OptionsController).state.projectId
                                },
                                body: {
                                    destinationWallets: destinationWallets,
                                    defaultNetwork: defaultNetwork,
                                    partnerUserId: partnerUserId,
                                    defaultExperience: "buy",
                                    presetCryptoAmount: purchaseAmount,
                                    presetFiatAmount: paymentAmount
                                }
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            2,
                            response.url
                        ];
                }
            });
        })();
    },
    getOnrampOptions: function() {
        return (0, $kSuI9._)(function() {
            var response, e;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            $e2794d516b97a52d$var$state.api.get({
                                path: "/v1/onramp/options",
                                params: {
                                    projectId: (0, $faNff.OptionsController).state.projectId
                                }
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            2,
                            response
                        ];
                    case 2:
                        e = _state.sent();
                        return [
                            2,
                            $e2794d516b97a52d$var$DEFAULT_OPTIONS
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    },
    getOnrampQuote: function(param) {
        var purchaseCurrency = param.purchaseCurrency, paymentCurrency = param.paymentCurrency, amount = param.amount, network = param.network;
        return (0, $kSuI9._)(function() {
            var response, e;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            $e2794d516b97a52d$var$state.api.post({
                                path: "/v1/onramp/quote",
                                params: {
                                    projectId: (0, $faNff.OptionsController).state.projectId
                                },
                                body: {
                                    purchaseCurrency: purchaseCurrency,
                                    paymentCurrency: paymentCurrency,
                                    amount: amount,
                                    network: network
                                }
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            2,
                            response
                        ];
                    case 2:
                        e = _state.sent();
                        // Mocking response as 1:1 until endpoint is ready
                        return [
                            2,
                            {
                                coinbaseFee: {
                                    amount: amount,
                                    currency: paymentCurrency.id
                                },
                                networkFee: {
                                    amount: amount,
                                    currency: paymentCurrency.id
                                },
                                paymentSubtotal: {
                                    amount: amount,
                                    currency: paymentCurrency.id
                                },
                                paymentTotal: {
                                    amount: amount,
                                    currency: paymentCurrency.id
                                },
                                purchaseAmount: {
                                    amount: amount,
                                    currency: paymentCurrency.id
                                },
                                quoteId: "mocked-quote-id"
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    },
    setClientId: function(clientId) {
        $e2794d516b97a52d$var$state.clientId = clientId;
        $e2794d516b97a52d$var$state.api = new (0, $7CVRB.FetchUtil)({
            baseUrl: $e2794d516b97a52d$var$baseUrl,
            clientId: clientId
        });
    }
};

});
parcelRegister("7CVRB", function(module, exports) {

$parcel$export(module.exports, "FetchUtil", function () { return $58d8f77f3fb7272f$export$ed6eff17d860976a; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dRLPW = parcelRequire("dRLPW");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $eha6O = parcelRequire("eha6O");
function $58d8f77f3fb7272f$var$fetchData() {
    return $58d8f77f3fb7272f$var$_fetchData.apply(this, arguments);
}
function $58d8f77f3fb7272f$var$_fetchData() {
    $58d8f77f3fb7272f$var$_fetchData = (0, $kSuI9._)(function() {
        var _len, args, _key, response, err;
        var _arguments = arguments;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = _arguments[_key];
                    }
                    return [
                        4,
                        fetch.apply(void 0, (0, $c6Xmf._)(args))
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) {
                        // Create error object and reject if not a 2xx response code
                        err = new Error("HTTP status code: ".concat(response.status), {
                            cause: response
                        });
                        throw err;
                    }
                    return [
                        2,
                        response
                    ];
            }
        });
    });
    return $58d8f77f3fb7272f$var$_fetchData.apply(this, arguments);
}
var $58d8f77f3fb7272f$export$ed6eff17d860976a = /*#__PURE__*/ function() {
    "use strict";
    function FetchUtil(param) {
        var baseUrl = param.baseUrl, clientId = param.clientId;
        (0, $4GJKx._)(this, FetchUtil);
        this.baseUrl = baseUrl;
        this.clientId = clientId;
    }
    (0, $1wc17._)(FetchUtil, [
        {
            key: "get",
            value: function get(_param) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var headers, signal, cache, args, url, response;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                headers = _param.headers, signal = _param.signal, cache = _param.cache, args = (0, $dRLPW._)(_param, [
                                    "headers",
                                    "signal",
                                    "cache"
                                ]);
                                url = _this.createUrl(args);
                                return [
                                    4,
                                    $58d8f77f3fb7272f$var$fetchData(url, {
                                        method: "GET",
                                        headers: headers,
                                        signal: signal,
                                        cache: cache
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response.json()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getBlob",
            value: function getBlob(_param) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var headers, signal, args, url, response;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                headers = _param.headers, signal = _param.signal, args = (0, $dRLPW._)(_param, [
                                    "headers",
                                    "signal"
                                ]);
                                url = _this.createUrl(args);
                                return [
                                    4,
                                    $58d8f77f3fb7272f$var$fetchData(url, {
                                        method: "GET",
                                        headers: headers,
                                        signal: signal
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response.blob()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "post",
            value: function post(_param) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var body, headers, signal, args, url, response;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                body = _param.body, headers = _param.headers, signal = _param.signal, args = (0, $dRLPW._)(_param, [
                                    "body",
                                    "headers",
                                    "signal"
                                ]);
                                url = _this.createUrl(args);
                                return [
                                    4,
                                    $58d8f77f3fb7272f$var$fetchData(url, {
                                        method: "POST",
                                        headers: headers,
                                        body: body ? JSON.stringify(body) : undefined,
                                        signal: signal
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response.json()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "put",
            value: function put(_param) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var body, headers, signal, args, url, response;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                body = _param.body, headers = _param.headers, signal = _param.signal, args = (0, $dRLPW._)(_param, [
                                    "body",
                                    "headers",
                                    "signal"
                                ]);
                                url = _this.createUrl(args);
                                return [
                                    4,
                                    $58d8f77f3fb7272f$var$fetchData(url, {
                                        method: "PUT",
                                        headers: headers,
                                        body: body ? JSON.stringify(body) : undefined,
                                        signal: signal
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response.json()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "delete",
            value: function _delete(_param) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var body, headers, signal, args, url, response;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                body = _param.body, headers = _param.headers, signal = _param.signal, args = (0, $dRLPW._)(_param, [
                                    "body",
                                    "headers",
                                    "signal"
                                ]);
                                url = _this.createUrl(args);
                                return [
                                    4,
                                    $58d8f77f3fb7272f$var$fetchData(url, {
                                        method: "DELETE",
                                        headers: headers,
                                        body: body ? JSON.stringify(body) : undefined,
                                        signal: signal
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response.json()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createUrl",
            value: function createUrl(param) {
                var path = param.path, params = param.params;
                var url = new URL(path, this.baseUrl);
                if (params) Object.entries(params).forEach(function(param) {
                    var _param = (0, $cv9Rk._)(param, 2), key = _param[0], value = _param[1];
                    if (value) url.searchParams.append(key, value);
                });
                if (this.clientId) url.searchParams.append("clientId", this.clientId);
                return url;
            }
        }
    ]);
    return FetchUtil;
}();

});

parcelRegister("faNff", function(module, exports) {

$parcel$export(module.exports, "OptionsController", function () { return $b0bdfd30a390e1fa$export$1f4c428077fc6173; });

var $6vAtg = parcelRequire("6vAtg");

var $hyDkn = parcelRequire("hyDkn");

var $hMdcG = parcelRequire("hMdcG");
// -- State --------------------------------------------- //
var $b0bdfd30a390e1fa$var$state = (0, $hyDkn.proxy)({
    projectId: "",
    sdkType: "w3m",
    sdkVersion: "html-wagmi-undefined"
});
var $b0bdfd30a390e1fa$export$1f4c428077fc6173 = {
    state: $b0bdfd30a390e1fa$var$state,
    subscribeKey: function(key, callback) {
        return (0, $6vAtg.subscribeKey)($b0bdfd30a390e1fa$var$state, key, callback);
    },
    setOptions: function(options) {
        Object.assign($b0bdfd30a390e1fa$var$state, options);
    },
    setProjectId: function(projectId) {
        $b0bdfd30a390e1fa$var$state.projectId = projectId;
    },
    setAllWallets: function(allWallets) {
        $b0bdfd30a390e1fa$var$state.allWallets = allWallets;
    },
    setIncludeWalletIds: function(includeWalletIds) {
        $b0bdfd30a390e1fa$var$state.includeWalletIds = includeWalletIds;
    },
    setExcludeWalletIds: function(excludeWalletIds) {
        $b0bdfd30a390e1fa$var$state.excludeWalletIds = excludeWalletIds;
        if (excludeWalletIds) (0, $hMdcG.ApiController).searchWalletByIds({
            ids: excludeWalletIds
        });
    },
    setFeaturedWalletIds: function(featuredWalletIds) {
        $b0bdfd30a390e1fa$var$state.featuredWalletIds = featuredWalletIds;
    },
    setTokens: function(tokens) {
        $b0bdfd30a390e1fa$var$state.tokens = tokens;
    },
    setTermsConditionsUrl: function(termsConditionsUrl) {
        $b0bdfd30a390e1fa$var$state.termsConditionsUrl = termsConditionsUrl;
    },
    setPrivacyPolicyUrl: function(privacyPolicyUrl) {
        $b0bdfd30a390e1fa$var$state.privacyPolicyUrl = privacyPolicyUrl;
    },
    setCustomWallets: function(customWallets) {
        $b0bdfd30a390e1fa$var$state.customWallets = customWallets;
    },
    setIsSiweEnabled: function(isSiweEnabled) {
        $b0bdfd30a390e1fa$var$state.isSiweEnabled = isSiweEnabled;
    },
    setIsUniversalProvider: function(isUniversalProvider) {
        $b0bdfd30a390e1fa$var$state.isUniversalProvider = isUniversalProvider;
    },
    setEnableAnalytics: function(enableAnalytics) {
        $b0bdfd30a390e1fa$var$state.enableAnalytics = enableAnalytics;
    },
    setSdkVersion: function(sdkVersion) {
        $b0bdfd30a390e1fa$var$state.sdkVersion = sdkVersion;
    },
    setMetadata: function(metadata) {
        $b0bdfd30a390e1fa$var$state.metadata = metadata;
    },
    setOnrampEnabled: function(enableOnramp) {
        $b0bdfd30a390e1fa$var$state.enableOnramp = enableOnramp;
    },
    setDisableAppend: function(disableAppend) {
        $b0bdfd30a390e1fa$var$state.disableAppend = disableAppend;
    },
    setEIP6963Enabled: function(enableEIP6963) {
        $b0bdfd30a390e1fa$var$state.enableEIP6963 = enableEIP6963;
    },
    setHasMultipleAddresses: function(hasMultipleAddresses) {
        $b0bdfd30a390e1fa$var$state.hasMultipleAddresses = hasMultipleAddresses;
    },
    setEnableSwaps: function(enableSwaps) {
        $b0bdfd30a390e1fa$var$state.enableSwaps = enableSwaps;
    }
};

});
parcelRegister("hMdcG", function(module, exports) {

$parcel$export(module.exports, "ApiController", function () { return $cf1129503ddabafa$export$99411f73957952af; });

var $kSuI9 = parcelRequire("kSuI9");

var $c6Xmf = parcelRequire("c6Xmf");

var $eha6O = parcelRequire("eha6O");

var $6vAtg = parcelRequire("6vAtg");

var $hyDkn = parcelRequire("hyDkn");

var $hZBJb = parcelRequire("hZBJb");

var $7CVRB = parcelRequire("7CVRB");

var $i7zcD = parcelRequire("i7zcD");

var $datXT = parcelRequire("datXT");

var $2qlRb = parcelRequire("2qlRb");

var $fPqxb = parcelRequire("fPqxb");

var $faNff = parcelRequire("faNff");
// -- Helpers ------------------------------------------- //
var $cf1129503ddabafa$var$baseUrl = (0, $hZBJb.CoreHelperUtil).getApiUrl();
var $cf1129503ddabafa$export$644d8ea042df96a6 = new (0, $7CVRB.FetchUtil)({
    baseUrl: $cf1129503ddabafa$var$baseUrl,
    clientId: null
});
var $cf1129503ddabafa$var$entries = "40";
var $cf1129503ddabafa$var$recommendedEntries = "4";
var $cf1129503ddabafa$var$imageCountToFetch = 20;
// -- State --------------------------------------------- //
var $cf1129503ddabafa$var$state = (0, $hyDkn.proxy)({
    page: 1,
    count: 0,
    featured: [],
    recommended: [],
    wallets: [],
    search: [],
    isAnalyticsEnabled: false,
    excludedRDNS: []
});
var $cf1129503ddabafa$export$99411f73957952af = {
    state: $cf1129503ddabafa$var$state,
    subscribeKey: function(key, callback) {
        return (0, $6vAtg.subscribeKey)($cf1129503ddabafa$var$state, key, callback);
    },
    _getApiHeaders: function() {
        var _OptionsController_state = (0, $faNff.OptionsController).state, projectId = _OptionsController_state.projectId, sdkType = _OptionsController_state.sdkType, sdkVersion = _OptionsController_state.sdkVersion;
        return {
            "x-project-id": projectId,
            "x-sdk-type": sdkType,
            "x-sdk-version": sdkVersion
        };
    },
    _filterOutExtensions: function(wallets) {
        if ((0, $faNff.OptionsController).state.isUniversalProvider) return wallets.filter(function(w) {
            return Boolean(w.mobile_link || w.desktop_link || w.webapp_link);
        });
        return wallets;
    },
    _fetchWalletImage: function(imageId) {
        return (0, $kSuI9._)(function() {
            var imageUrl, blob;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        imageUrl = "".concat($cf1129503ddabafa$export$644d8ea042df96a6.baseUrl, "/getWalletImage/").concat(imageId);
                        return [
                            4,
                            $cf1129503ddabafa$export$644d8ea042df96a6.getBlob({
                                path: imageUrl,
                                headers: $cf1129503ddabafa$export$99411f73957952af._getApiHeaders()
                            })
                        ];
                    case 1:
                        blob = _state.sent();
                        (0, $datXT.AssetController).setWalletImage(imageId, URL.createObjectURL(blob));
                        return [
                            2
                        ];
                }
            });
        })();
    },
    _fetchNetworkImage: function(imageId) {
        return (0, $kSuI9._)(function() {
            var imageUrl, blob;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        imageUrl = "".concat($cf1129503ddabafa$export$644d8ea042df96a6.baseUrl, "/public/getAssetImage/").concat(imageId);
                        return [
                            4,
                            $cf1129503ddabafa$export$644d8ea042df96a6.getBlob({
                                path: imageUrl,
                                headers: $cf1129503ddabafa$export$99411f73957952af._getApiHeaders()
                            })
                        ];
                    case 1:
                        blob = _state.sent();
                        (0, $datXT.AssetController).setNetworkImage(imageId, URL.createObjectURL(blob));
                        return [
                            2
                        ];
                }
            });
        })();
    },
    _fetchConnectorImage: function(imageId) {
        return (0, $kSuI9._)(function() {
            var imageUrl, blob;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        imageUrl = "".concat($cf1129503ddabafa$export$644d8ea042df96a6.baseUrl, "/public/getAssetImage/").concat(imageId);
                        return [
                            4,
                            $cf1129503ddabafa$export$644d8ea042df96a6.getBlob({
                                path: imageUrl,
                                headers: $cf1129503ddabafa$export$99411f73957952af._getApiHeaders()
                            })
                        ];
                    case 1:
                        blob = _state.sent();
                        (0, $datXT.AssetController).setConnectorImage(imageId, URL.createObjectURL(blob));
                        return [
                            2
                        ];
                }
            });
        })();
    },
    _fetchCurrencyImage: function(countryCode) {
        return (0, $kSuI9._)(function() {
            var imageUrl, blob;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        imageUrl = "".concat($cf1129503ddabafa$export$644d8ea042df96a6.baseUrl, "/public/getCurrencyImage/").concat(countryCode);
                        return [
                            4,
                            $cf1129503ddabafa$export$644d8ea042df96a6.getBlob({
                                path: imageUrl,
                                headers: $cf1129503ddabafa$export$99411f73957952af._getApiHeaders()
                            })
                        ];
                    case 1:
                        blob = _state.sent();
                        (0, $datXT.AssetController).setCurrencyImage(countryCode, URL.createObjectURL(blob));
                        return [
                            2
                        ];
                }
            });
        })();
    },
    _fetchTokenImage: function(symbol) {
        return (0, $kSuI9._)(function() {
            var imageUrl, blob;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        imageUrl = "".concat($cf1129503ddabafa$export$644d8ea042df96a6.baseUrl, "/public/getTokenImage/").concat(symbol);
                        return [
                            4,
                            $cf1129503ddabafa$export$644d8ea042df96a6.getBlob({
                                path: imageUrl,
                                headers: $cf1129503ddabafa$export$99411f73957952af._getApiHeaders()
                            })
                        ];
                    case 1:
                        blob = _state.sent();
                        (0, $datXT.AssetController).setTokenImage(symbol, URL.createObjectURL(blob));
                        return [
                            2
                        ];
                }
            });
        })();
    },
    fetchNetworkImages: function() {
        return (0, $kSuI9._)(function() {
            var requestedCaipNetworks, ids;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        requestedCaipNetworks = (0, $fPqxb.NetworkController).getRequestedCaipNetworks();
                        ids = requestedCaipNetworks === null || requestedCaipNetworks === void 0 ? void 0 : requestedCaipNetworks.map(function(param) {
                            var imageId = param.imageId;
                            return imageId;
                        }).filter(Boolean);
                        if (!ids) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            Promise.allSettled(ids.map(function(id) {
                                return $cf1129503ddabafa$export$99411f73957952af._fetchNetworkImage(id);
                            }))
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        })();
    },
    fetchConnectorImages: function() {
        return (0, $kSuI9._)(function() {
            var connectors, ids;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        connectors = (0, $2qlRb.ConnectorController).state.connectors;
                        ids = connectors.map(function(param) {
                            var imageId = param.imageId;
                            return imageId;
                        }).filter(Boolean);
                        return [
                            4,
                            Promise.allSettled(ids.map(function(id) {
                                return $cf1129503ddabafa$export$99411f73957952af._fetchConnectorImage(id);
                            }))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    },
    fetchCurrencyImages: function() {
        var currencies = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        return (0, $kSuI9._)(function() {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Promise.allSettled(currencies.map(function(currency) {
                                return $cf1129503ddabafa$export$99411f73957952af._fetchCurrencyImage(currency);
                            }))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    },
    fetchTokenImages: function() {
        var tokens = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        return (0, $kSuI9._)(function() {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Promise.allSettled(tokens.map(function(token) {
                                return $cf1129503ddabafa$export$99411f73957952af._fetchTokenImage(token);
                            }))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    },
    fetchFeaturedWallets: function() {
        return (0, $kSuI9._)(function() {
            var featuredWalletIds, data, images;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        featuredWalletIds = (0, $faNff.OptionsController).state.featuredWalletIds;
                        if (!(featuredWalletIds === null || featuredWalletIds === void 0 ? void 0 : featuredWalletIds.length)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            $cf1129503ddabafa$export$644d8ea042df96a6.get({
                                path: "/getWallets",
                                headers: $cf1129503ddabafa$export$99411f73957952af._getApiHeaders(),
                                params: {
                                    page: "1",
                                    entries: (featuredWalletIds === null || featuredWalletIds === void 0 ? void 0 : featuredWalletIds.length) ? String(featuredWalletIds.length) : $cf1129503ddabafa$var$recommendedEntries,
                                    include: featuredWalletIds === null || featuredWalletIds === void 0 ? void 0 : featuredWalletIds.join(",")
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        data.sort(function(a, b) {
                            return featuredWalletIds.indexOf(a.id) - featuredWalletIds.indexOf(b.id);
                        });
                        images = data.map(function(d) {
                            return d.image_id;
                        }).filter(Boolean);
                        return [
                            4,
                            Promise.allSettled(images.map(function(id) {
                                return $cf1129503ddabafa$export$99411f73957952af._fetchWalletImage(id);
                            }))
                        ];
                    case 2:
                        _state.sent();
                        $cf1129503ddabafa$var$state.featured = data;
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    },
    fetchRecommendedWallets: function() {
        return (0, $kSuI9._)(function() {
            var _NetworkController_state_caipNetwork, _OptionsController_state, includeWalletIds, excludeWalletIds, featuredWalletIds, exclude, _ref, data, count, recent, recommendedImages, recentImages;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _OptionsController_state = (0, $faNff.OptionsController).state, includeWalletIds = _OptionsController_state.includeWalletIds, excludeWalletIds = _OptionsController_state.excludeWalletIds, featuredWalletIds = _OptionsController_state.featuredWalletIds;
                        exclude = (0, $c6Xmf._)(excludeWalletIds !== null && excludeWalletIds !== void 0 ? excludeWalletIds : []).concat((0, $c6Xmf._)(featuredWalletIds !== null && featuredWalletIds !== void 0 ? featuredWalletIds : [])).filter(Boolean);
                        return [
                            4,
                            $cf1129503ddabafa$export$644d8ea042df96a6.get({
                                path: "/getWallets",
                                headers: $cf1129503ddabafa$export$99411f73957952af._getApiHeaders(),
                                params: {
                                    page: "1",
                                    chains: (_NetworkController_state_caipNetwork = (0, $fPqxb.NetworkController).state.caipNetwork) === null || _NetworkController_state_caipNetwork === void 0 ? void 0 : _NetworkController_state_caipNetwork.id,
                                    entries: $cf1129503ddabafa$var$recommendedEntries,
                                    include: includeWalletIds === null || includeWalletIds === void 0 ? void 0 : includeWalletIds.join(","),
                                    exclude: exclude === null || exclude === void 0 ? void 0 : exclude.join(",")
                                }
                            })
                        ];
                    case 1:
                        _ref = _state.sent(), data = _ref.data, count = _ref.count;
                        recent = (0, $i7zcD.StorageUtil).getRecentWallets();
                        recommendedImages = data.map(function(d) {
                            return d.image_id;
                        }).filter(Boolean);
                        recentImages = recent.map(function(r) {
                            return r.image_id;
                        }).filter(Boolean);
                        return [
                            4,
                            Promise.allSettled((0, $c6Xmf._)(recommendedImages).concat((0, $c6Xmf._)(recentImages)).map(function(id) {
                                return $cf1129503ddabafa$export$99411f73957952af._fetchWalletImage(id);
                            }))
                        ];
                    case 2:
                        _state.sent();
                        $cf1129503ddabafa$var$state.recommended = data;
                        $cf1129503ddabafa$var$state.count = count !== null && count !== void 0 ? count : 0;
                        return [
                            2
                        ];
                }
            });
        })();
    },
    fetchWallets: function(param) {
        var page = param.page;
        return (0, $kSuI9._)(function() {
            var _NetworkController_state_caipNetwork, _OptionsController_state, includeWalletIds, excludeWalletIds, featuredWalletIds, exclude, _ref, data, count, images;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _OptionsController_state = (0, $faNff.OptionsController).state, includeWalletIds = _OptionsController_state.includeWalletIds, excludeWalletIds = _OptionsController_state.excludeWalletIds, featuredWalletIds = _OptionsController_state.featuredWalletIds;
                        exclude = (0, $c6Xmf._)($cf1129503ddabafa$var$state.recommended.map(function(param) {
                            var id = param.id;
                            return id;
                        })).concat((0, $c6Xmf._)(excludeWalletIds !== null && excludeWalletIds !== void 0 ? excludeWalletIds : []), (0, $c6Xmf._)(featuredWalletIds !== null && featuredWalletIds !== void 0 ? featuredWalletIds : [])).filter(Boolean);
                        return [
                            4,
                            $cf1129503ddabafa$export$644d8ea042df96a6.get({
                                path: "/getWallets",
                                headers: $cf1129503ddabafa$export$99411f73957952af._getApiHeaders(),
                                params: {
                                    page: String(page),
                                    entries: $cf1129503ddabafa$var$entries,
                                    chains: (_NetworkController_state_caipNetwork = (0, $fPqxb.NetworkController).state.caipNetwork) === null || _NetworkController_state_caipNetwork === void 0 ? void 0 : _NetworkController_state_caipNetwork.id,
                                    include: includeWalletIds === null || includeWalletIds === void 0 ? void 0 : includeWalletIds.join(","),
                                    exclude: exclude.join(",")
                                }
                            })
                        ];
                    case 1:
                        _ref = _state.sent(), data = _ref.data, count = _ref.count;
                        images = data.slice(0, $cf1129503ddabafa$var$imageCountToFetch).map(function(w) {
                            return w.image_id;
                        }).filter(Boolean);
                        return [
                            4,
                            Promise.allSettled(images.map(function(id) {
                                return $cf1129503ddabafa$export$99411f73957952af._fetchWalletImage(id);
                            }))
                        ];
                    case 2:
                        _state.sent();
                        $cf1129503ddabafa$var$state.wallets = (0, $hZBJb.CoreHelperUtil).uniqueBy((0, $c6Xmf._)($cf1129503ddabafa$var$state.wallets).concat((0, $c6Xmf._)($cf1129503ddabafa$export$99411f73957952af._filterOutExtensions(data))), "id");
                        $cf1129503ddabafa$var$state.count = count > $cf1129503ddabafa$var$state.count ? count : $cf1129503ddabafa$var$state.count;
                        $cf1129503ddabafa$var$state.page = page;
                        return [
                            2
                        ];
                }
            });
        })();
    },
    searchWalletByIds: function(param) {
        var ids = param.ids;
        return (0, $kSuI9._)(function() {
            var _NetworkController_state_caipNetwork, data;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            $cf1129503ddabafa$export$644d8ea042df96a6.get({
                                path: "/getWallets",
                                headers: $cf1129503ddabafa$export$99411f73957952af._getApiHeaders(),
                                params: {
                                    page: "1",
                                    entries: String(ids.length),
                                    chains: (_NetworkController_state_caipNetwork = (0, $fPqxb.NetworkController).state.caipNetwork) === null || _NetworkController_state_caipNetwork === void 0 ? void 0 : _NetworkController_state_caipNetwork.id,
                                    include: ids === null || ids === void 0 ? void 0 : ids.join(",")
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (data) data.forEach(function(wallet) {
                            if (wallet === null || wallet === void 0 ? void 0 : wallet.rdns) $cf1129503ddabafa$var$state.excludedRDNS.push(wallet.rdns);
                        });
                        return [
                            2
                        ];
                }
            });
        })();
    },
    searchWallet: function(param) {
        var search = param.search;
        return (0, $kSuI9._)(function() {
            var _NetworkController_state_caipNetwork, _OptionsController_state, includeWalletIds, excludeWalletIds, data, images;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _OptionsController_state = (0, $faNff.OptionsController).state, includeWalletIds = _OptionsController_state.includeWalletIds, excludeWalletIds = _OptionsController_state.excludeWalletIds;
                        $cf1129503ddabafa$var$state.search = [];
                        return [
                            4,
                            $cf1129503ddabafa$export$644d8ea042df96a6.get({
                                path: "/getWallets",
                                headers: $cf1129503ddabafa$export$99411f73957952af._getApiHeaders(),
                                params: {
                                    page: "1",
                                    entries: "100",
                                    search: search === null || search === void 0 ? void 0 : search.trim(),
                                    chains: (_NetworkController_state_caipNetwork = (0, $fPqxb.NetworkController).state.caipNetwork) === null || _NetworkController_state_caipNetwork === void 0 ? void 0 : _NetworkController_state_caipNetwork.id,
                                    include: includeWalletIds === null || includeWalletIds === void 0 ? void 0 : includeWalletIds.join(","),
                                    exclude: excludeWalletIds === null || excludeWalletIds === void 0 ? void 0 : excludeWalletIds.join(",")
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        images = data.map(function(w) {
                            return w.image_id;
                        }).filter(Boolean);
                        return [
                            4,
                            Promise.allSettled((0, $c6Xmf._)(images.map(function(id) {
                                return $cf1129503ddabafa$export$99411f73957952af._fetchWalletImage(id);
                            })).concat([
                                (0, $hZBJb.CoreHelperUtil).wait(300)
                            ]))
                        ];
                    case 2:
                        _state.sent();
                        $cf1129503ddabafa$var$state.search = $cf1129503ddabafa$export$99411f73957952af._filterOutExtensions(data);
                        return [
                            2
                        ];
                }
            });
        })();
    },
    reFetchWallets: function() {
        return (0, $kSuI9._)(function() {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $cf1129503ddabafa$var$state.page = 1;
                        $cf1129503ddabafa$var$state.wallets = [];
                        return [
                            4,
                            $cf1129503ddabafa$export$99411f73957952af.fetchFeaturedWallets()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            $cf1129503ddabafa$export$99411f73957952af.fetchRecommendedWallets()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    },
    prefetch: function() {
        var promises = [
            $cf1129503ddabafa$export$99411f73957952af.fetchFeaturedWallets(),
            $cf1129503ddabafa$export$99411f73957952af.fetchRecommendedWallets(),
            $cf1129503ddabafa$export$99411f73957952af.fetchNetworkImages(),
            $cf1129503ddabafa$export$99411f73957952af.fetchConnectorImages()
        ];
        if ((0, $faNff.OptionsController).state.enableAnalytics === undefined) promises.push($cf1129503ddabafa$export$99411f73957952af.fetchAnalyticsConfig());
        $cf1129503ddabafa$var$state.prefetchPromise = Promise.race([
            Promise.allSettled(promises)
        ]);
    },
    fetchAnalyticsConfig: function() {
        return (0, $kSuI9._)(function() {
            var isAnalyticsEnabled;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            $cf1129503ddabafa$export$644d8ea042df96a6.get({
                                path: "/getAnalyticsConfig",
                                headers: $cf1129503ddabafa$export$99411f73957952af._getApiHeaders()
                            })
                        ];
                    case 1:
                        isAnalyticsEnabled = _state.sent().isAnalyticsEnabled;
                        (0, $faNff.OptionsController).setEnableAnalytics(isAnalyticsEnabled);
                        return [
                            2
                        ];
                }
            });
        })();
    }
};

});
parcelRegister("i7zcD", function(module, exports) {

$parcel$export(module.exports, "StorageUtil", function () { return $d3142ffea234af62$export$d4382c6359971b24; });
// -- Helpers -----------------------------------------------------------------
var $d3142ffea234af62$var$WC_DEEPLINK = "WALLETCONNECT_DEEPLINK_CHOICE";
var $d3142ffea234af62$var$W3M_RECENT = "@w3m/recent";
var $d3142ffea234af62$var$W3M_CONNECTED_CONNECTOR = "@w3m/connected_connector";
var $d3142ffea234af62$var$W3M_CONNECTED_SOCIAL = "@w3m/connected_social";
var $d3142ffea234af62$var$W3M_CONNECTED_SOCIAL_USERNAME = "@w3m-storage/SOCIAL_USERNAME";
var $d3142ffea234af62$export$d4382c6359971b24 = {
    setWalletConnectDeepLink: function(param) {
        var href = param.href, name = param.name;
        try {
            localStorage.setItem($d3142ffea234af62$var$WC_DEEPLINK, JSON.stringify({
                href: href,
                name: name
            }));
        } catch (e) {
            console.info("Unable to set WalletConnect deep link");
        }
    },
    getWalletConnectDeepLink: function() {
        try {
            var deepLink = localStorage.getItem($d3142ffea234af62$var$WC_DEEPLINK);
            if (deepLink) return JSON.parse(deepLink);
        } catch (e) {
            console.info("Unable to get WalletConnect deep link");
        }
        return undefined;
    },
    deleteWalletConnectDeepLink: function() {
        try {
            localStorage.removeItem($d3142ffea234af62$var$WC_DEEPLINK);
        } catch (e) {
            console.info("Unable to delete WalletConnect deep link");
        }
    },
    setWeb3ModalRecent: function(wallet) {
        try {
            var recentWallets = $d3142ffea234af62$export$d4382c6359971b24.getRecentWallets();
            var exists = recentWallets.find(function(w) {
                return w.id === wallet.id;
            });
            if (!exists) {
                recentWallets.unshift(wallet);
                if (recentWallets.length > 2) recentWallets.pop();
                localStorage.setItem($d3142ffea234af62$var$W3M_RECENT, JSON.stringify(recentWallets));
            }
        } catch (e) {
            console.info("Unable to set Web3Modal recent");
        }
    },
    getRecentWallets: function() {
        try {
            var recent = localStorage.getItem($d3142ffea234af62$var$W3M_RECENT);
            return recent ? JSON.parse(recent) : [];
        } catch (e) {
            console.info("Unable to get Web3Modal recent");
        }
        return [];
    },
    setConnectedConnector: function(connectorType) {
        try {
            localStorage.setItem($d3142ffea234af62$var$W3M_CONNECTED_CONNECTOR, connectorType);
        } catch (e) {
            console.info("Unable to set Connected Connector");
        }
    },
    getConnectedConnector: function() {
        try {
            return localStorage.getItem($d3142ffea234af62$var$W3M_CONNECTED_CONNECTOR);
        } catch (e) {
            console.info("Unable to get Connected Connector");
        }
        return undefined;
    },
    setConnectedSocialProvider: function(socialProvider) {
        try {
            localStorage.setItem($d3142ffea234af62$var$W3M_CONNECTED_SOCIAL, socialProvider);
        } catch (e) {
            console.info("Unable to set Connected Social Provider");
        }
    },
    getConnectedSocialProvider: function() {
        try {
            return localStorage.getItem($d3142ffea234af62$var$W3M_CONNECTED_SOCIAL);
        } catch (e) {
            console.info("Unable to get Connected Social Provider");
        }
        return undefined;
    },
    getConnectedSocialUsername: function() {
        try {
            return localStorage.getItem($d3142ffea234af62$var$W3M_CONNECTED_SOCIAL_USERNAME);
        } catch (e) {
            console.info("Unable to get Connected Social Username");
        }
        return undefined;
    }
};

});

parcelRegister("datXT", function(module, exports) {

$parcel$export(module.exports, "AssetController", function () { return $996373f77bdb1766$export$4f2a98fee99335; });

var $6vAtg = parcelRequire("6vAtg");

var $hyDkn = parcelRequire("hyDkn");
// -- State --------------------------------------------- //
var $996373f77bdb1766$var$state = (0, $hyDkn.proxy)({
    walletImages: {},
    networkImages: {},
    chainImages: {},
    connectorImages: {},
    tokenImages: {},
    currencyImages: {}
});
var $996373f77bdb1766$export$4f2a98fee99335 = {
    state: $996373f77bdb1766$var$state,
    subscribeNetworkImages: function(callback) {
        return (0, $hyDkn.subscribe)($996373f77bdb1766$var$state.networkImages, function() {
            return callback($996373f77bdb1766$var$state.networkImages);
        });
    },
    subscribeKey: function(key, callback) {
        return (0, $6vAtg.subscribeKey)($996373f77bdb1766$var$state, key, callback);
    },
    subscribe: function(callback) {
        return (0, $hyDkn.subscribe)($996373f77bdb1766$var$state, function() {
            return callback($996373f77bdb1766$var$state);
        });
    },
    setWalletImage: function(key, value) {
        $996373f77bdb1766$var$state.walletImages[key] = value;
    },
    setNetworkImage: function(key, value) {
        $996373f77bdb1766$var$state.networkImages[key] = value;
    },
    setChainImage: function(key, value) {
        $996373f77bdb1766$var$state.chainImages[key] = value;
    },
    setConnectorImage: function(key, value) {
        $996373f77bdb1766$var$state.connectorImages[key] = value;
    },
    setTokenImage: function(key, value) {
        $996373f77bdb1766$var$state.tokenImages[key] = value;
    },
    setCurrencyImage: function(key, value) {
        $996373f77bdb1766$var$state.currencyImages[key] = value;
    }
};

});

parcelRegister("2qlRb", function(module, exports) {

$parcel$export(module.exports, "ConnectorController", function () { return $1c3ef6c35424633c$export$c83edcb4eee2f517; });

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $c6Xmf = parcelRequire("c6Xmf");

var $6vAtg = parcelRequire("6vAtg");

var $hyDkn = parcelRequire("hyDkn");
parcelRequire("dSKxG");
var $3QZC1 = parcelRequire("3QZC1");
var $cnADL = parcelRequire("cnADL");

var $faNff = parcelRequire("faNff");

var $dJ6Ea = parcelRequire("dJ6Ea");
// -- State --------------------------------------------- //
var $1c3ef6c35424633c$var$state = (0, $hyDkn.proxy)({
    unMergedConnectors: [],
    connectors: []
});
var $1c3ef6c35424633c$export$c83edcb4eee2f517 = {
    state: $1c3ef6c35424633c$var$state,
    subscribeKey: function(key, callback) {
        return (0, $6vAtg.subscribeKey)($1c3ef6c35424633c$var$state, key, callback);
    },
    setConnectors: function(connectors) {
        connectors.forEach(this.syncIfAuthConnector);
        $1c3ef6c35424633c$var$state.unMergedConnectors = (0, $c6Xmf._)($1c3ef6c35424633c$var$state.unMergedConnectors).concat((0, $c6Xmf._)(connectors));
        $1c3ef6c35424633c$var$state.connectors = this.mergeMultiChainConnectors($1c3ef6c35424633c$var$state.unMergedConnectors);
    },
    mergeMultiChainConnectors: function(connectors) {
        var _this = this;
        var connectorsByNameMap = this.generateConnectorMapByName(connectors);
        var refactoredConnectors = Array.from(connectorsByNameMap.values()).map(function(_connectors) {
            var _connectors_, _connectors_1, _connectors_2;
            if (_connectors.length > 1) return {
                name: (_connectors_ = _connectors[0]) === null || _connectors_ === void 0 ? void 0 : _connectors_.name,
                imageUrl: (_connectors_1 = _connectors[0]) === null || _connectors_1 === void 0 ? void 0 : _connectors_1.imageUrl,
                imageId: (_connectors_2 = _connectors[0]) === null || _connectors_2 === void 0 ? void 0 : _connectors_2.imageId,
                providers: _this.getUniqueConnectorsByName(_connectors),
                type: "MULTI_CHAIN"
            };
            return _connectors[0];
        });
        return refactoredConnectors;
    },
    generateConnectorMapByName: function(connectors) {
        var connectorsByNameMap = new Map();
        connectors.forEach(function(connector) {
            var name = connector.name;
            if (!name) return;
            var connectorsByName = connectorsByNameMap.get(name) || [];
            var haveSameConnector = connectorsByName.find(function(c) {
                return c.chain === connector.chain;
            });
            if (!haveSameConnector) connectorsByName.push(connector);
            connectorsByNameMap.set(name, connectorsByName);
        });
        return connectorsByNameMap;
    },
    getUniqueConnectorsByName: function(connectors) {
        var uniqueConnectors = [];
        connectors.forEach(function(c) {
            if (!uniqueConnectors.find(function(uc) {
                return uc.chain === c.chain;
            })) uniqueConnectors.push((0, $cxjpp._)((0, $do9pw._)({}, c), {
                name: (0, $3QZC1.ConstantsUtil).CHAIN_NAME_MAP[c.chain]
            }));
        });
        return uniqueConnectors;
    },
    addConnector: function(connector) {
        this.setConnectors([
            connector
        ]);
    },
    getAuthConnector: function() {
        return $1c3ef6c35424633c$var$state.connectors.find(function(c) {
            return c.type === "AUTH";
        });
    },
    getAnnouncedConnectorRdns: function() {
        return $1c3ef6c35424633c$var$state.connectors.filter(function(c) {
            return c.type === "ANNOUNCED";
        }).map(function(c) {
            var _c_info;
            return (_c_info = c.info) === null || _c_info === void 0 ? void 0 : _c_info.rdns;
        });
    },
    getConnectors: function() {
        return $1c3ef6c35424633c$var$state.connectors;
    },
    getConnector: function(id, rdns) {
        return $1c3ef6c35424633c$var$state.connectors.find(function(c) {
            var _c_info;
            return c.explorerId === id || ((_c_info = c.info) === null || _c_info === void 0 ? void 0 : _c_info.rdns) === rdns;
        });
    },
    syncIfAuthConnector: function(connector) {
        var _authConnector_provider_syncDappData, _authConnector_provider;
        if (connector.id !== "w3mAuth") return;
        var authConnector = connector;
        var optionsState = (0, $hyDkn.snapshot)((0, $faNff.OptionsController).state);
        var themeMode = (0, $dJ6Ea.ThemeController).getSnapshot().themeMode;
        var themeVariables = (0, $dJ6Ea.ThemeController).getSnapshot().themeVariables;
        authConnector === null || authConnector === void 0 ? void 0 : (_authConnector_provider = authConnector.provider) === null || _authConnector_provider === void 0 ? void 0 : (_authConnector_provider_syncDappData = _authConnector_provider.syncDappData) === null || _authConnector_provider_syncDappData === void 0 ? void 0 : _authConnector_provider_syncDappData.call(_authConnector_provider, {
            metadata: optionsState.metadata,
            sdkVersion: optionsState.sdkVersion,
            projectId: optionsState.projectId
        });
        authConnector.provider.syncTheme({
            themeMode: themeMode,
            themeVariables: themeVariables,
            w3mThemeVariables: (0, $cnADL.getW3mThemeVariables)(themeVariables, themeMode)
        });
    }
};

});
parcelRegister("dJ6Ea", function(module, exports) {

$parcel$export(module.exports, "ThemeController", function () { return $9fe4a23cbbe43d4b$export$e18d4112326e72bf; });

var $do9pw = parcelRequire("do9pw");

var $hyDkn = parcelRequire("hyDkn");

var $2qlRb = parcelRequire("2qlRb");
parcelRequire("dSKxG");
var $cnADL = parcelRequire("cnADL");
// -- State --------------------------------------------- //
var $9fe4a23cbbe43d4b$var$state = (0, $hyDkn.proxy)({
    themeMode: "dark",
    themeVariables: {},
    w3mThemeVariables: undefined
});
var $9fe4a23cbbe43d4b$export$e18d4112326e72bf = {
    state: $9fe4a23cbbe43d4b$var$state,
    subscribe: function(callback) {
        return (0, $hyDkn.subscribe)($9fe4a23cbbe43d4b$var$state, function() {
            return callback($9fe4a23cbbe43d4b$var$state);
        });
    },
    setThemeMode: function(themeMode) {
        $9fe4a23cbbe43d4b$var$state.themeMode = themeMode;
        try {
            var authConnector = (0, $2qlRb.ConnectorController).getAuthConnector();
            if (authConnector) {
                var themeVariables = $9fe4a23cbbe43d4b$export$e18d4112326e72bf.getSnapshot().themeVariables;
                authConnector.provider.syncTheme({
                    themeMode: themeMode,
                    themeVariables: themeVariables,
                    w3mThemeVariables: (0, $cnADL.getW3mThemeVariables)(themeVariables, themeMode)
                });
            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.info("Unable to sync theme to auth connector");
        }
    },
    setThemeVariables: function(themeVariables) {
        $9fe4a23cbbe43d4b$var$state.themeVariables = (0, $do9pw._)({}, $9fe4a23cbbe43d4b$var$state.themeVariables, themeVariables);
        try {
            var authConnector = (0, $2qlRb.ConnectorController).getAuthConnector();
            if (authConnector) {
                var themeVariablesSnapshot = $9fe4a23cbbe43d4b$export$e18d4112326e72bf.getSnapshot().themeVariables;
                authConnector.provider.syncTheme({
                    themeVariables: themeVariablesSnapshot,
                    w3mThemeVariables: (0, $cnADL.getW3mThemeVariables)($9fe4a23cbbe43d4b$var$state.themeVariables, $9fe4a23cbbe43d4b$var$state.themeMode)
                });
            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.info("Unable to sync theme to auth connector");
        }
    },
    getSnapshot: function() {
        return (0, $hyDkn.snapshot)($9fe4a23cbbe43d4b$var$state);
    }
};

});


parcelRegister("fPqxb", function(module, exports) {

$parcel$export(module.exports, "NetworkController", function () { return $b860339453f7402e$export$c63f10f788d47d86; });

var $kSuI9 = parcelRequire("kSuI9");

var $c6Xmf = parcelRequire("c6Xmf");

var $eha6O = parcelRequire("eha6O");

var $hyDkn = parcelRequire("hyDkn");

var $1QDT9 = parcelRequire("1QDT9");

var $5Lhe6 = parcelRequire("5Lhe6");

var $hZBJb = parcelRequire("hZBJb");
parcelRequire("dSKxG");
var $fcokf = parcelRequire("fcokf");

var $9zDWP = parcelRequire("9zDWP");

var $4HJlA = parcelRequire("4HJlA");
// -- State --------------------------------------------- //
var $b860339453f7402e$var$state = (0, $hyDkn.proxy)({
    supportsAllNetworks: true,
    isDefaultCaipNetwork: false,
    smartAccountEnabledNetworks: []
});
var $b860339453f7402e$export$c63f10f788d47d86 = {
    state: $b860339453f7402e$var$state,
    replaceState: function(newState) {
        if (!newState) return;
        Object.assign($b860339453f7402e$var$state, (0, $hyDkn.ref)(newState));
    },
    subscribeKey: function(property, callback) {
        var prev = undefined;
        return (0, $9zDWP.ChainController).subscribeChainProp("networkState", function(networkState) {
            if (networkState) {
                var nextValue = networkState[property];
                if (prev !== nextValue) {
                    prev = nextValue;
                    callback(nextValue);
                }
            }
        });
    },
    _getClient: function() {
        return (0, $9zDWP.ChainController).getNetworkControllerClient();
    },
    initializeDefaultNetwork: function() {
        var networks = this.getRequestedCaipNetworks();
        if (networks.length > 0) this.setCaipNetwork(networks[0]);
    },
    setDefaultCaipNetwork: function(caipNetwork) {
        if (caipNetwork) {
            (0, $9zDWP.ChainController).setCaipNetwork(caipNetwork.chain, caipNetwork, true);
            (0, $9zDWP.ChainController).setChainNetworkData(caipNetwork.chain, {
                isDefaultCaipNetwork: true
            });
            (0, $4HJlA.PublicStateController).set({
                selectedNetworkId: caipNetwork.id
            });
        }
    },
    setActiveCaipNetwork: function(caipNetwork) {
        var _ChainController_state_chains_get_networkState, _ChainController_state_chains_get;
        if (!caipNetwork) return;
        (0, $9zDWP.ChainController).setActiveCaipNetwork(caipNetwork);
        (0, $9zDWP.ChainController).setChainNetworkData(caipNetwork.chain, {
            caipNetwork: caipNetwork
        });
        (0, $4HJlA.PublicStateController).set({
            activeChain: caipNetwork.chain,
            selectedNetworkId: caipNetwork === null || caipNetwork === void 0 ? void 0 : caipNetwork.id
        });
        if (!((_ChainController_state_chains_get = (0, $9zDWP.ChainController).state.chains.get(caipNetwork.chain)) === null || _ChainController_state_chains_get === void 0 ? void 0 : (_ChainController_state_chains_get_networkState = _ChainController_state_chains_get.networkState) === null || _ChainController_state_chains_get_networkState === void 0 ? void 0 : _ChainController_state_chains_get_networkState.allowUnsupportedChain)) {
            var isSupported = this.checkIfSupportedNetwork();
            if (!isSupported) this.showUnsupportedChainUI();
        }
    },
    setCaipNetwork: function(caipNetwork) {
        var _ChainController_state_chains_get_networkState, _ChainController_state_chains_get;
        if (!caipNetwork) return;
        if (!(caipNetwork === null || caipNetwork === void 0 ? void 0 : caipNetwork.chain)) throw new Error("chain is required to set active network");
        (0, $9zDWP.ChainController).setCaipNetwork(caipNetwork === null || caipNetwork === void 0 ? void 0 : caipNetwork.chain, caipNetwork);
        if (!((_ChainController_state_chains_get = (0, $9zDWP.ChainController).state.chains.get(caipNetwork.chain)) === null || _ChainController_state_chains_get === void 0 ? void 0 : (_ChainController_state_chains_get_networkState = _ChainController_state_chains_get.networkState) === null || _ChainController_state_chains_get_networkState === void 0 ? void 0 : _ChainController_state_chains_get_networkState.allowUnsupportedChain)) {
            var isSupported = this.checkIfSupportedNetwork();
            if (!isSupported) this.showUnsupportedChainUI();
        }
    },
    setRequestedCaipNetworks: function(requestedNetworks, chain) {
        (0, $9zDWP.ChainController).setChainNetworkData(chain, {
            requestedCaipNetworks: requestedNetworks
        });
    },
    setAllowUnsupportedChain: function(allowUnsupportedChain, chain) {
        (0, $9zDWP.ChainController).setChainNetworkData(chain || (0, $9zDWP.ChainController).state.activeChain, {
            allowUnsupportedChain: allowUnsupportedChain
        });
    },
    setSmartAccountEnabledNetworks: function(smartAccountEnabledNetworks, chain) {
        (0, $9zDWP.ChainController).setChainNetworkData(chain, {
            smartAccountEnabledNetworks: smartAccountEnabledNetworks
        });
    },
    getRequestedCaipNetworks: function(chainToFilter) {
        var chainAdapters = undefined;
        if (!(0, $9zDWP.ChainController).state.activeChain) throw new Error("activeChain is required to get requested networks");
        if (chainToFilter) {
            var chain = chainToFilter;
            if (!chain) throw new Error("chain is required to get requested networks");
            chainAdapters = [
                chain
            ];
        } else {
            var chains = (0, $c6Xmf._)((0, $9zDWP.ChainController).state.chains.keys());
            chainAdapters = chains;
        }
        var approvedIds = [];
        var requestedNetworks = [];
        chainAdapters.forEach(function(chn) {
            var _approvedIds, _requestedNetworks;
            var _ChainController_state_chains_get_networkState, _ChainController_state_chains_get, _ChainController_state_chains_get_networkState1, _ChainController_state_chains_get1, _ChainController_state_chains_get_networkState2, _ChainController_state_chains_get2, _ChainController_state_chains_get_networkState3, _ChainController_state_chains_get3;
            if ((_ChainController_state_chains_get = (0, $9zDWP.ChainController).state.chains.get(chn)) === null || _ChainController_state_chains_get === void 0 ? void 0 : (_ChainController_state_chains_get_networkState = _ChainController_state_chains_get.networkState) === null || _ChainController_state_chains_get_networkState === void 0 ? void 0 : _ChainController_state_chains_get_networkState.approvedCaipNetworkIds) (_approvedIds = approvedIds).push.apply(_approvedIds, (0, $c6Xmf._)(((_ChainController_state_chains_get1 = (0, $9zDWP.ChainController).state.chains.get(chn)) === null || _ChainController_state_chains_get1 === void 0 ? void 0 : (_ChainController_state_chains_get_networkState1 = _ChainController_state_chains_get1.networkState) === null || _ChainController_state_chains_get_networkState1 === void 0 ? void 0 : _ChainController_state_chains_get_networkState1.approvedCaipNetworkIds) || []));
            if ((_ChainController_state_chains_get2 = (0, $9zDWP.ChainController).state.chains.get(chn)) === null || _ChainController_state_chains_get2 === void 0 ? void 0 : (_ChainController_state_chains_get_networkState2 = _ChainController_state_chains_get2.networkState) === null || _ChainController_state_chains_get_networkState2 === void 0 ? void 0 : _ChainController_state_chains_get_networkState2.requestedCaipNetworks) (_requestedNetworks = requestedNetworks).push.apply(_requestedNetworks, (0, $c6Xmf._)(((_ChainController_state_chains_get3 = (0, $9zDWP.ChainController).state.chains.get(chn)) === null || _ChainController_state_chains_get3 === void 0 ? void 0 : (_ChainController_state_chains_get_networkState3 = _ChainController_state_chains_get3.networkState) === null || _ChainController_state_chains_get_networkState3 === void 0 ? void 0 : _ChainController_state_chains_get_networkState3.requestedCaipNetworks) || []));
        });
        var sortedNetworks = (0, $hZBJb.CoreHelperUtil).sortRequestedNetworks(approvedIds, requestedNetworks);
        return sortedNetworks;
    },
    switchActiveNetwork: function(network) {
        return (0, $kSuI9._)(function() {
            var _ChainController_state_chains_get, networkControllerClient;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        networkControllerClient = network ? (_ChainController_state_chains_get = (0, $9zDWP.ChainController).state.chains.get(network.chain)) === null || _ChainController_state_chains_get === void 0 ? void 0 : _ChainController_state_chains_get.networkControllerClient : undefined;
                        if (!networkControllerClient) throw new Error("networkControllerClient not found for given network object");
                        (0, $9zDWP.ChainController).setActiveCaipNetwork(network);
                        return [
                            4,
                            networkControllerClient === null || networkControllerClient === void 0 ? void 0 : networkControllerClient.switchCaipNetwork(network)
                        ];
                    case 1:
                        _state.sent();
                        if (network) (0, $1QDT9.EventsController).sendEvent({
                            type: "track",
                            event: "SWITCH_NETWORK",
                            properties: {
                                network: network.id
                            }
                        });
                        return [
                            2
                        ];
                }
            });
        })();
    },
    getApprovedCaipNetworkIds: function(chainToFilter) {
        if (chainToFilter) {
            var _ChainController_state_chains_get_networkState, _ChainController_state_chains_get;
            var chain = chainToFilter;
            if (!chain) throw new Error("chain is required to get approved network IDs");
            return (_ChainController_state_chains_get = (0, $9zDWP.ChainController).state.chains.get(chain)) === null || _ChainController_state_chains_get === void 0 ? void 0 : (_ChainController_state_chains_get_networkState = _ChainController_state_chains_get.networkState) === null || _ChainController_state_chains_get_networkState === void 0 ? void 0 : _ChainController_state_chains_get_networkState.approvedCaipNetworkIds;
        }
        var allCaipNetworkIds = [];
        Object.values((0, $9zDWP.ChainController).state.chains).forEach(function(adapter) {
            var _allCaipNetworkIds;
            var _adapter_networkState;
            if (adapter.networkState.approvedCaipNetworkIds) (_allCaipNetworkIds = allCaipNetworkIds).push.apply(_allCaipNetworkIds, (0, $c6Xmf._)(((_adapter_networkState = adapter.networkState) === null || _adapter_networkState === void 0 ? void 0 : _adapter_networkState.approvedCaipNetworkIds) || []));
        });
        return allCaipNetworkIds;
    },
    setApprovedCaipNetworksData: function(chain) {
        return (0, $kSuI9._)(function() {
            var networkControllerClient, data;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        networkControllerClient = (0, $9zDWP.ChainController).getNetworkControllerClient();
                        return [
                            4,
                            networkControllerClient.getApprovedCaipNetworksData()
                        ];
                    case 1:
                        data = _state.sent();
                        if (!chain) throw new Error("chain is required to set approved network data");
                        (0, $9zDWP.ChainController).setChainNetworkData(chain, {
                            approvedCaipNetworkIds: data === null || data === void 0 ? void 0 : data.approvedCaipNetworkIds,
                            supportsAllNetworks: (data === null || data === void 0 ? void 0 : data.supportsAllNetworks) || false
                        });
                        return [
                            2
                        ];
                }
            });
        })();
    },
    checkIfSupportedNetwork: function() {
        var _ChainController_state_chains_get_networkState, _ChainController_state_chains_get;
        var chain = (0, $9zDWP.ChainController).state.activeChain;
        if (!chain) return false;
        var activeCaipNetwork = (_ChainController_state_chains_get = (0, $9zDWP.ChainController).state.chains.get(chain)) === null || _ChainController_state_chains_get === void 0 ? void 0 : (_ChainController_state_chains_get_networkState = _ChainController_state_chains_get.networkState) === null || _ChainController_state_chains_get_networkState === void 0 ? void 0 : _ChainController_state_chains_get_networkState.caipNetwork;
        var requestedCaipNetworks = this.getRequestedCaipNetworks();
        return requestedCaipNetworks === null || requestedCaipNetworks === void 0 ? void 0 : requestedCaipNetworks.some(function(network) {
            return network.id === (activeCaipNetwork === null || activeCaipNetwork === void 0 ? void 0 : activeCaipNetwork.id);
        });
    },
    checkIfSmartAccountEnabled: function() {
        var _state_caipNetwork;
        var networkId = (0, $fcokf.NetworkUtil).caipNetworkIdToNumber((_state_caipNetwork = $b860339453f7402e$var$state.caipNetwork) === null || _state_caipNetwork === void 0 ? void 0 : _state_caipNetwork.id);
        var activeChain = (0, $9zDWP.ChainController).state.activeChain;
        if (!activeChain) throw new Error("activeChain is required to check if smart account is enabled");
        if (!networkId) return false;
        var smartAccountEnabledNetworks = (0, $9zDWP.ChainController).getNetworkProp("smartAccountEnabledNetworks");
        return Boolean(smartAccountEnabledNetworks === null || smartAccountEnabledNetworks === void 0 ? void 0 : smartAccountEnabledNetworks.includes(networkId));
    },
    resetNetwork: function() {
        var chain = (0, $9zDWP.ChainController).state.activeChain;
        if (!chain) throw new Error("chain is required to reset network");
        (0, $9zDWP.ChainController).setChainNetworkData(chain, {
            approvedCaipNetworkIds: undefined,
            supportsAllNetworks: true,
            smartAccountEnabledNetworks: []
        });
    },
    getSupportsAllNetworks: function() {
        var _ChainController_state_chains_get_networkState, _ChainController_state_chains_get;
        var chain = (0, $9zDWP.ChainController).state.activeChain;
        if (!chain) throw new Error("chain is required to check if network supports all networks");
        return (_ChainController_state_chains_get = (0, $9zDWP.ChainController).state.chains.get(chain)) === null || _ChainController_state_chains_get === void 0 ? void 0 : (_ChainController_state_chains_get_networkState = _ChainController_state_chains_get.networkState) === null || _ChainController_state_chains_get_networkState === void 0 ? void 0 : _ChainController_state_chains_get_networkState.supportsAllNetworks;
    },
    showUnsupportedChainUI: function() {
        setTimeout(function() {
            (0, $5Lhe6.ModalController).open({
                view: "UnsupportedChain"
            });
        }, 300);
    }
};

});
parcelRegister("1QDT9", function(module, exports) {

$parcel$export(module.exports, "EventsController", function () { return $158996cf422453f8$export$23ca5cb260756952; });

var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $hyDkn = parcelRequire("hyDkn");

var $hZBJb = parcelRequire("hZBJb");

var $7CVRB = parcelRequire("7CVRB");

var $faNff = parcelRequire("faNff");
// -- Helpers ------------------------------------------- //
var $158996cf422453f8$var$baseUrl = (0, $hZBJb.CoreHelperUtil).getAnalyticsUrl();
var $158996cf422453f8$var$api = new (0, $7CVRB.FetchUtil)({
    baseUrl: $158996cf422453f8$var$baseUrl,
    clientId: null
});
var $158996cf422453f8$var$excluded = [
    "MODAL_CREATED"
];
// -- State --------------------------------------------- //
var $158996cf422453f8$var$state = (0, $hyDkn.proxy)({
    timestamp: Date.now(),
    data: {
        type: "track",
        event: "MODAL_CREATED"
    }
});
var $158996cf422453f8$export$23ca5cb260756952 = {
    state: $158996cf422453f8$var$state,
    subscribe: function(callback) {
        return (0, $hyDkn.subscribe)($158996cf422453f8$var$state, function() {
            return callback($158996cf422453f8$var$state);
        });
    },
    _getApiHeaders: function() {
        var _OptionsController_state = (0, $faNff.OptionsController).state, projectId = _OptionsController_state.projectId, sdkType = _OptionsController_state.sdkType, sdkVersion = _OptionsController_state.sdkVersion;
        return {
            "x-project-id": projectId,
            "x-sdk-type": sdkType,
            "x-sdk-version": sdkVersion
        };
    },
    _sendAnalyticsEvent: function(payload) {
        return (0, $kSuI9._)(function() {
            var e;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        if ($158996cf422453f8$var$excluded.includes(payload.data.event) || typeof window === "undefined") return [
                            2
                        ];
                        return [
                            4,
                            $158996cf422453f8$var$api.post({
                                path: "/e",
                                headers: $158996cf422453f8$export$23ca5cb260756952._getApiHeaders(),
                                body: {
                                    eventId: (0, $hZBJb.CoreHelperUtil).getUUID(),
                                    url: window.location.href,
                                    domain: window.location.hostname,
                                    timestamp: payload.timestamp,
                                    props: payload.data
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    },
    sendEvent: function(data) {
        $158996cf422453f8$var$state.timestamp = Date.now();
        $158996cf422453f8$var$state.data = data;
        if ((0, $faNff.OptionsController).state.enableAnalytics) $158996cf422453f8$export$23ca5cb260756952._sendAnalyticsEvent($158996cf422453f8$var$state);
    }
};

});

parcelRegister("9zDWP", function(module, exports) {

$parcel$export(module.exports, "ChainController", function () { return $6f865ec3c909eae0$export$fbf61adcac1da229; });

var $3sHb8 = parcelRequire("3sHb8");

var $do9pw = parcelRequire("do9pw");

var $6vAtg = parcelRequire("6vAtg");

var $hyDkn = parcelRequire("hyDkn");

var $fPqxb = parcelRequire("fPqxb");

var $dMLJP = parcelRequire("dMLJP");

var $4HJlA = parcelRequire("4HJlA");
parcelRequire("dSKxG");
// -- Constants ----------------------------------------- //
var $6f865ec3c909eae0$var$accountState = {
    isConnected: false,
    currentTab: 0,
    tokenBalance: [],
    smartAccountDeployed: false,
    addressLabels: new Map(),
    allAccounts: []
};
var $6f865ec3c909eae0$var$networkState = {
    supportsAllNetworks: true,
    isDefaultCaipNetwork: false,
    smartAccountEnabledNetworks: []
};
// -- State --------------------------------------------- //
var $6f865ec3c909eae0$var$state = (0, $hyDkn.proxy)({
    chains: (0, $6vAtg.proxyMap)(),
    activeChain: undefined,
    activeCaipNetwork: undefined
});
var $6f865ec3c909eae0$export$fbf61adcac1da229 = {
    state: $6f865ec3c909eae0$var$state,
    subscribeKey: function(key, callback) {
        return (0, $6vAtg.subscribeKey)($6f865ec3c909eae0$var$state, key, callback);
    },
    subscribeChain: function(callback) {
        var prev = undefined;
        return (0, $hyDkn.subscribe)($6f865ec3c909eae0$var$state.chains, function() {
            var activeChain = $6f865ec3c909eae0$var$state.activeChain;
            if (activeChain) {
                var nextValue = $6f865ec3c909eae0$var$state.chains.get(activeChain);
                if (!prev || prev !== nextValue) {
                    prev = nextValue;
                    callback(nextValue);
                }
            }
        });
    },
    subscribeChainProp: function(property, callback) {
        var prev = undefined;
        return (0, $hyDkn.subscribe)($6f865ec3c909eae0$var$state.chains, function() {
            var activeChain = $6f865ec3c909eae0$var$state.activeChain;
            if (activeChain) {
                var _state_chains_get;
                var nextValue = (_state_chains_get = $6f865ec3c909eae0$var$state.chains.get(activeChain)) === null || _state_chains_get === void 0 ? void 0 : _state_chains_get[property];
                if (prev !== nextValue) {
                    prev = nextValue;
                    callback(nextValue);
                }
            }
        });
    },
    initialize: function(adapters) {
        var adapterToActivate = adapters === null || adapters === void 0 ? void 0 : adapters[0];
        if (!adapterToActivate) throw new Error("Adapter is required to initialize ChainController");
        $6f865ec3c909eae0$var$state.activeChain = adapterToActivate.chain;
        (0, $4HJlA.PublicStateController).set({
            activeChain: adapterToActivate.chain
        });
        this.setActiveCaipNetwork(adapterToActivate.defaultChain);
        adapters.forEach(function(adapter) {
            $6f865ec3c909eae0$var$state.chains.set(adapter.chain, {
                chain: adapter.chain,
                connectionControllerClient: adapter.connectionControllerClient,
                networkControllerClient: adapter.networkControllerClient,
                accountState: $6f865ec3c909eae0$var$accountState,
                networkState: $6f865ec3c909eae0$var$networkState
            });
        });
    },
    setChainNetworkData: function(chain, props) {
        var replaceState = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        if (!chain) throw new Error("Chain is required to update chain network data");
        var chainAdapter = $6f865ec3c909eae0$var$state.chains.get(chain);
        if (chainAdapter) {
            chainAdapter.networkState = (0, $hyDkn.ref)((0, $do9pw._)({}, chainAdapter.networkState, props));
            $6f865ec3c909eae0$var$state.chains.set(chain, (0, $hyDkn.ref)(chainAdapter));
            if (replaceState || $6f865ec3c909eae0$var$state.chains.size === 1 || $6f865ec3c909eae0$var$state.activeChain === chain) (0, $fPqxb.NetworkController).replaceState(chainAdapter.networkState);
        }
    },
    setChainAccountData: function(chain, accountProps) {
        var replaceState = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        if (!chain) throw new Error("Chain is required to update chain account data");
        var chainAdapter = $6f865ec3c909eae0$var$state.chains.get(chain);
        if (chainAdapter) {
            chainAdapter.accountState = (0, $hyDkn.ref)((0, $do9pw._)({}, chainAdapter.accountState, accountProps));
            $6f865ec3c909eae0$var$state.chains.set(chain, chainAdapter);
            if (replaceState || $6f865ec3c909eae0$var$state.chains.size === 1 || $6f865ec3c909eae0$var$state.activeChain === chain) (0, $dMLJP.AccountController).replaceState(chainAdapter.accountState);
        }
    },
    setAccountProp: function(prop, value, chain) {
        this.setChainAccountData(chain, (0, $3sHb8._)({}, prop, value));
    },
    setActiveChain: function(chain) {
        var newAdapter = chain ? $6f865ec3c909eae0$var$state.chains.get(chain) : undefined;
        if (newAdapter && newAdapter.chain !== $6f865ec3c909eae0$var$state.activeChain) {
            var _newAdapter_networkState, _newAdapter_networkState1, _newAdapter_networkState2, _newAdapter_networkState_caipNetwork, _newAdapter_networkState3;
            $6f865ec3c909eae0$var$state.activeChain = newAdapter.chain;
            $6f865ec3c909eae0$var$state.activeCaipNetwork = ((_newAdapter_networkState = newAdapter.networkState) === null || _newAdapter_networkState === void 0 ? void 0 : _newAdapter_networkState.caipNetwork) ? (0, $hyDkn.ref)((_newAdapter_networkState1 = newAdapter.networkState) === null || _newAdapter_networkState1 === void 0 ? void 0 : _newAdapter_networkState1.caipNetwork) : undefined;
            (0, $dMLJP.AccountController).replaceState(newAdapter.accountState);
            (0, $fPqxb.NetworkController).replaceState(newAdapter.networkState);
            this.setCaipNetwork(newAdapter.chain, (_newAdapter_networkState2 = newAdapter.networkState) === null || _newAdapter_networkState2 === void 0 ? void 0 : _newAdapter_networkState2.caipNetwork);
            (0, $4HJlA.PublicStateController).set({
                activeChain: chain,
                selectedNetworkId: (_newAdapter_networkState3 = newAdapter.networkState) === null || _newAdapter_networkState3 === void 0 ? void 0 : (_newAdapter_networkState_caipNetwork = _newAdapter_networkState3.caipNetwork) === null || _newAdapter_networkState_caipNetwork === void 0 ? void 0 : _newAdapter_networkState_caipNetwork.id
            });
        }
    },
    setActiveCaipNetwork: function(caipNetwork) {
        if (!caipNetwork) return;
        if (caipNetwork.chain !== $6f865ec3c909eae0$var$state.activeChain) this.setActiveChain(caipNetwork.chain);
        $6f865ec3c909eae0$var$state.activeCaipNetwork = (0, $hyDkn.ref)(caipNetwork);
        $6f865ec3c909eae0$var$state.activeChain = caipNetwork.chain;
        this.setCaipNetwork(caipNetwork.chain, caipNetwork, true);
        (0, $4HJlA.PublicStateController).set({
            activeChain: caipNetwork.chain,
            selectedNetworkId: caipNetwork === null || caipNetwork === void 0 ? void 0 : caipNetwork.id
        });
    },
    /**
     * The setCaipNetwork function is being called for different purposes and it needs to be controlled if it should replace the NetworkController state or not.
     * While we initializing the adapters, we need to set the caipNetwork without replacing the state.
     * But when we switch the network, we need to replace the state.
     * @param chain
     * @param caipNetwork
     * @param shouldReplace - if true, it will replace the NetworkController state
     */ setCaipNetwork: function(chain, caipNetwork) {
        var shouldReplace = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        this.setChainNetworkData(chain, {
            caipNetwork: caipNetwork
        }, shouldReplace);
    },
    setActiveConnector: function(connector) {
        if (connector) $6f865ec3c909eae0$var$state.activeConnector = (0, $hyDkn.ref)(connector);
    },
    getNetworkControllerClient: function() {
        var chain = $6f865ec3c909eae0$var$state.activeChain;
        if (!chain) throw new Error("Chain is required to get network controller client");
        var chainAdapter = $6f865ec3c909eae0$var$state.chains.get(chain);
        if (!chainAdapter) throw new Error("Chain adapter not found");
        if (!chainAdapter.networkControllerClient) throw new Error("NetworkController client not set");
        return chainAdapter.networkControllerClient;
    },
    getConnectionControllerClient: function(_chain) {
        var chain = _chain || $6f865ec3c909eae0$var$state.activeChain;
        if (!chain) throw new Error("Chain is required to get connection controller client");
        var chainAdapter = $6f865ec3c909eae0$var$state.chains.get(chain);
        if (!chainAdapter) throw new Error("Chain adapter not found");
        if (!chainAdapter.connectionControllerClient) throw new Error("ConnectionController client not set");
        return chainAdapter.connectionControllerClient;
    },
    getAccountProp: function(key, _chain) {
        var _state_chains_get;
        var chain = $6f865ec3c909eae0$var$state.activeChain;
        if (_chain) chain = _chain;
        if (!chain) return undefined;
        var chainAccountState = (_state_chains_get = $6f865ec3c909eae0$var$state.chains.get(chain)) === null || _state_chains_get === void 0 ? void 0 : _state_chains_get.accountState;
        if (!chainAccountState) return undefined;
        return chainAccountState[key];
    },
    getNetworkProp: function(key) {
        var _state_chains_get;
        var chainToWrite = $6f865ec3c909eae0$var$state.activeChain;
        if (!chainToWrite) return undefined;
        var chainNetworkState = (_state_chains_get = $6f865ec3c909eae0$var$state.chains.get(chainToWrite)) === null || _state_chains_get === void 0 ? void 0 : _state_chains_get.networkState;
        if (!chainNetworkState) return undefined;
        return chainNetworkState[key];
    },
    resetAccount: function(chain) {
        var chainToWrite = chain;
        if (!chainToWrite) throw new Error("Chain is required to set account prop");
        this.setChainAccountData(chainToWrite, (0, $hyDkn.ref)({
            isConnected: false,
            smartAccountDeployed: false,
            currentTab: 0,
            caipAddress: undefined,
            address: undefined,
            balance: undefined,
            balanceSymbol: undefined,
            profileName: undefined,
            profileImage: undefined,
            addressExplorerUrl: undefined,
            tokenBalance: [],
            connectedWalletInfo: undefined,
            preferredAccountType: undefined,
            socialProvider: undefined,
            socialWindow: undefined,
            farcasterUrl: undefined
        }));
    }
};

});
parcelRegister("4HJlA", function(module, exports) {

$parcel$export(module.exports, "PublicStateController", function () { return $36ce5a9aae143171$export$24bc8c77cb7c530; });

var $do9pw = parcelRequire("do9pw");

var $hyDkn = parcelRequire("hyDkn");
// -- State --------------------------------------------- //
var $36ce5a9aae143171$var$state = (0, $hyDkn.proxy)({
    loading: false,
    open: false,
    selectedNetworkId: undefined,
    activeChain: undefined
});
var $36ce5a9aae143171$export$24bc8c77cb7c530 = {
    state: $36ce5a9aae143171$var$state,
    subscribe: function(callback) {
        return (0, $hyDkn.subscribe)($36ce5a9aae143171$var$state, function() {
            return callback($36ce5a9aae143171$var$state);
        });
    },
    set: function(newState) {
        Object.assign($36ce5a9aae143171$var$state, (0, $do9pw._)({}, $36ce5a9aae143171$var$state, newState));
    }
};

});






parcelRegister("8FcCV", function(module, exports) {

$parcel$export(module.exports, "SnackController", function () { return $64ebf283d3978faf$export$506cae4b4f746de7; });

var $6vAtg = parcelRequire("6vAtg");

var $hyDkn = parcelRequire("hyDkn");

var $hZBJb = parcelRequire("hZBJb");
// -- State --------------------------------------------- //
var $64ebf283d3978faf$var$state = (0, $hyDkn.proxy)({
    message: "",
    variant: "success",
    open: false
});
var $64ebf283d3978faf$export$506cae4b4f746de7 = {
    state: $64ebf283d3978faf$var$state,
    subscribeKey: function(key, callback) {
        return (0, $6vAtg.subscribeKey)($64ebf283d3978faf$var$state, key, callback);
    },
    showLoading: function(message) {
        $64ebf283d3978faf$var$state.message = message;
        $64ebf283d3978faf$var$state.variant = "loading";
        $64ebf283d3978faf$var$state.open = true;
    },
    showSuccess: function(message) {
        $64ebf283d3978faf$var$state.message = message;
        $64ebf283d3978faf$var$state.variant = "success";
        $64ebf283d3978faf$var$state.open = true;
    },
    showError: function(message) {
        var errorMessage = (0, $hZBJb.CoreHelperUtil).parseError(message);
        $64ebf283d3978faf$var$state.message = errorMessage;
        $64ebf283d3978faf$var$state.variant = "error";
        $64ebf283d3978faf$var$state.open = true;
    },
    hide: function() {
        $64ebf283d3978faf$var$state.open = false;
    }
};

});

parcelRegister("8DzeN", function(module, exports) {

$parcel$export(module.exports, "SwapController", function () { return $649d4cbaa93fc5f0$export$cb69c6a27866a8a5; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $do9pw = parcelRequire("do9pw");

var $c6Xmf = parcelRequire("c6Xmf");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");

var $6vAtg = parcelRequire("6vAtg");

var $hyDkn = parcelRequire("hyDkn");

var $dMLJP = parcelRequire("dMLJP");

var $2sXdV = parcelRequire("2sXdV");

var $3cYIS = parcelRequire("3cYIS");

var $4Tiue = parcelRequire("4Tiue");

var $8FcCV = parcelRequire("8FcCV");

var $iptjJ = parcelRequire("iptjJ");
parcelRequire("dSKxG");
var $eMPGH = parcelRequire("eMPGH");

var $fPqxb = parcelRequire("fPqxb");

var $hZBJb = parcelRequire("hZBJb");

var $jrvVk = parcelRequire("jrvVk");

var $faNff = parcelRequire("faNff");

var $Lhkxt = parcelRequire("Lhkxt");

var $1QDT9 = parcelRequire("1QDT9");
parcelRequire("hsyMZ");
var $cSJ4o = parcelRequire("cSJ4o");

var $i7zcD = parcelRequire("i7zcD");

var $2qlRb = parcelRequire("2qlRb");
var $649d4cbaa93fc5f0$export$3540a8643ebda500 = 150000;
var $649d4cbaa93fc5f0$export$7d4f9f74f76f88bb = 6;
var $649d4cbaa93fc5f0$var$TransactionError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $dcsZi._)(TransactionError, Error1);
    var _super = (0, $ohfOJ._)(TransactionError);
    function TransactionError(message, shortMessage) {
        (0, $4GJKx._)(this, TransactionError);
        var _this;
        _this = _super.call(this, message);
        _this.name = "TransactionError";
        _this.shortMessage = shortMessage;
        return _this;
    }
    return TransactionError;
}((0, $FuVm8._)(Error));
// -- State --------------------------------------------- //
var $649d4cbaa93fc5f0$var$initialState = {
    // Loading states
    initializing: false,
    initialized: false,
    loadingPrices: false,
    loadingQuote: false,
    loadingApprovalTransaction: false,
    loadingBuildTransaction: false,
    loadingTransaction: false,
    // Error states
    fetchError: false,
    // Approval & Swap transaction states
    approvalTransaction: undefined,
    swapTransaction: undefined,
    transactionError: undefined,
    // Input values
    sourceToken: undefined,
    sourceTokenAmount: "",
    sourceTokenPriceInUSD: 0,
    toToken: undefined,
    toTokenAmount: "",
    toTokenPriceInUSD: 0,
    networkPrice: "0",
    networkBalanceInUSD: "0",
    networkTokenSymbol: "",
    inputError: undefined,
    // Request values
    slippage: (0, $2sXdV.ConstantsUtil).CONVERT_SLIPPAGE_TOLERANCE,
    // Tokens
    tokens: undefined,
    popularTokens: undefined,
    suggestedTokens: undefined,
    foundTokens: undefined,
    myTokensWithBalance: undefined,
    tokensPriceMap: {},
    // Calculations
    gasFee: "0",
    gasPriceInUSD: 0,
    priceImpact: undefined,
    maxSlippage: undefined,
    providerFee: undefined
};
var $649d4cbaa93fc5f0$var$state = (0, $hyDkn.proxy)($649d4cbaa93fc5f0$var$initialState);
var $649d4cbaa93fc5f0$export$cb69c6a27866a8a5 = {
    state: $649d4cbaa93fc5f0$var$state,
    subscribe: function(callback) {
        return (0, $hyDkn.subscribe)($649d4cbaa93fc5f0$var$state, function() {
            return callback($649d4cbaa93fc5f0$var$state);
        });
    },
    subscribeKey: function(key, callback) {
        return (0, $6vAtg.subscribeKey)($649d4cbaa93fc5f0$var$state, key, callback);
    },
    getParams: function() {
        var _state_toToken, _state_toToken1, _state_sourceToken, _state_sourceToken1, _state_sourceToken2, _state_toToken2, _state_toToken3, _state_sourceToken3;
        var caipNetwork = (0, $fPqxb.NetworkController).state.caipNetwork;
        var address = (0, $dMLJP.AccountController).state.address;
        var networkAddress = "".concat(caipNetwork === null || caipNetwork === void 0 ? void 0 : caipNetwork.id, ":").concat((0, $2sXdV.ConstantsUtil).NATIVE_TOKEN_ADDRESS);
        var type = (0, $i7zcD.StorageUtil).getConnectedConnector();
        var authConnector = (0, $2qlRb.ConnectorController).getAuthConnector();
        if (!address) throw new Error("No address found to swap the tokens from.");
        var caipAddress = (0, $dMLJP.AccountController).state.caipAddress;
        var invalidToToken = !((_state_toToken = $649d4cbaa93fc5f0$var$state.toToken) === null || _state_toToken === void 0 ? void 0 : _state_toToken.address) || !((_state_toToken1 = $649d4cbaa93fc5f0$var$state.toToken) === null || _state_toToken1 === void 0 ? void 0 : _state_toToken1.decimals);
        var invalidSourceToken = !((_state_sourceToken = $649d4cbaa93fc5f0$var$state.sourceToken) === null || _state_sourceToken === void 0 ? void 0 : _state_sourceToken.address) || !((_state_sourceToken1 = $649d4cbaa93fc5f0$var$state.sourceToken) === null || _state_sourceToken1 === void 0 ? void 0 : _state_sourceToken1.decimals) || !(0, $eMPGH.NumberUtil).bigNumber($649d4cbaa93fc5f0$var$state.sourceTokenAmount).isGreaterThan(0);
        var invalidSourceTokenAmount = !$649d4cbaa93fc5f0$var$state.sourceTokenAmount;
        return {
            networkAddress: networkAddress,
            fromAddress: address,
            fromCaipAddress: (0, $dMLJP.AccountController).state.caipAddress,
            sourceTokenAddress: (_state_sourceToken2 = $649d4cbaa93fc5f0$var$state.sourceToken) === null || _state_sourceToken2 === void 0 ? void 0 : _state_sourceToken2.address,
            toTokenAddress: (_state_toToken2 = $649d4cbaa93fc5f0$var$state.toToken) === null || _state_toToken2 === void 0 ? void 0 : _state_toToken2.address,
            toTokenAmount: $649d4cbaa93fc5f0$var$state.toTokenAmount,
            toTokenDecimals: (_state_toToken3 = $649d4cbaa93fc5f0$var$state.toToken) === null || _state_toToken3 === void 0 ? void 0 : _state_toToken3.decimals,
            sourceTokenAmount: $649d4cbaa93fc5f0$var$state.sourceTokenAmount,
            sourceTokenDecimals: (_state_sourceToken3 = $649d4cbaa93fc5f0$var$state.sourceToken) === null || _state_sourceToken3 === void 0 ? void 0 : _state_sourceToken3.decimals,
            invalidToToken: invalidToToken,
            invalidSourceToken: invalidSourceToken,
            invalidSourceTokenAmount: invalidSourceTokenAmount,
            availableToSwap: caipAddress && !invalidToToken && !invalidSourceToken && !invalidSourceTokenAmount,
            isAuthConnector: (authConnector === null || authConnector === void 0 ? void 0 : authConnector.walletFeatures) && type === "AUTH"
        };
    },
    setSourceToken: function(sourceToken) {
        if (!sourceToken) {
            $649d4cbaa93fc5f0$var$state.sourceToken = sourceToken;
            $649d4cbaa93fc5f0$var$state.sourceTokenAmount = "";
            $649d4cbaa93fc5f0$var$state.sourceTokenPriceInUSD = 0;
            return;
        }
        $649d4cbaa93fc5f0$var$state.sourceToken = sourceToken;
        this.setTokenPrice(sourceToken.address, "sourceToken");
    },
    setSourceTokenAmount: function(amount) {
        $649d4cbaa93fc5f0$var$state.sourceTokenAmount = amount;
    },
    setToToken: function(toToken) {
        if (!toToken) {
            $649d4cbaa93fc5f0$var$state.toToken = toToken;
            $649d4cbaa93fc5f0$var$state.toTokenAmount = "";
            $649d4cbaa93fc5f0$var$state.toTokenPriceInUSD = 0;
            return;
        }
        $649d4cbaa93fc5f0$var$state.toToken = toToken;
        this.setTokenPrice(toToken.address, "toToken");
    },
    setToTokenAmount: function(amount) {
        $649d4cbaa93fc5f0$var$state.toTokenAmount = amount ? (0, $eMPGH.NumberUtil).formatNumberToLocalString(amount, $649d4cbaa93fc5f0$export$7d4f9f74f76f88bb) : "";
    },
    setTokenPrice: function(address, target) {
        return (0, $kSuI9._)(function() {
            var availableToSwap, price;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        availableToSwap = this.getParams().availableToSwap;
                        price = $649d4cbaa93fc5f0$var$state.tokensPriceMap[address] || 0;
                        if (!!price) return [
                            3,
                            2
                        ];
                        $649d4cbaa93fc5f0$var$state.loadingPrices = true;
                        return [
                            4,
                            this.getAddressPrice(address)
                        ];
                    case 1:
                        price = _state.sent();
                        _state.label = 2;
                    case 2:
                        if (target === "sourceToken") $649d4cbaa93fc5f0$var$state.sourceTokenPriceInUSD = price;
                        else if (target === "toToken") $649d4cbaa93fc5f0$var$state.toTokenPriceInUSD = price;
                        if ($649d4cbaa93fc5f0$var$state.loadingPrices) {
                            $649d4cbaa93fc5f0$var$state.loadingPrices = false;
                            if (availableToSwap) this.swapTokens();
                        }
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    switchTokens: function() {
        if ($649d4cbaa93fc5f0$var$state.initializing || !$649d4cbaa93fc5f0$var$state.initialized) return;
        var newSourceToken = $649d4cbaa93fc5f0$var$state.toToken ? (0, $do9pw._)({}, $649d4cbaa93fc5f0$var$state.toToken) : undefined;
        var newToToken = $649d4cbaa93fc5f0$var$state.sourceToken ? (0, $do9pw._)({}, $649d4cbaa93fc5f0$var$state.sourceToken) : undefined;
        var newSourceTokenAmount = newSourceToken && $649d4cbaa93fc5f0$var$state.toTokenAmount === "" ? "1" : $649d4cbaa93fc5f0$var$state.toTokenAmount;
        this.setSourceToken(newSourceToken);
        this.setToToken(newToToken);
        this.setSourceTokenAmount(newSourceTokenAmount);
        this.setToTokenAmount("");
        this.swapTokens();
    },
    resetState: function() {
        $649d4cbaa93fc5f0$var$state.myTokensWithBalance = $649d4cbaa93fc5f0$var$initialState.myTokensWithBalance;
        $649d4cbaa93fc5f0$var$state.tokensPriceMap = $649d4cbaa93fc5f0$var$initialState.tokensPriceMap;
        $649d4cbaa93fc5f0$var$state.initialized = $649d4cbaa93fc5f0$var$initialState.initialized;
        $649d4cbaa93fc5f0$var$state.sourceToken = $649d4cbaa93fc5f0$var$initialState.sourceToken;
        $649d4cbaa93fc5f0$var$state.sourceTokenAmount = $649d4cbaa93fc5f0$var$initialState.sourceTokenAmount;
        $649d4cbaa93fc5f0$var$state.sourceTokenPriceInUSD = $649d4cbaa93fc5f0$var$initialState.sourceTokenPriceInUSD;
        $649d4cbaa93fc5f0$var$state.toToken = $649d4cbaa93fc5f0$var$initialState.toToken;
        $649d4cbaa93fc5f0$var$state.toTokenAmount = $649d4cbaa93fc5f0$var$initialState.toTokenAmount;
        $649d4cbaa93fc5f0$var$state.toTokenPriceInUSD = $649d4cbaa93fc5f0$var$initialState.toTokenPriceInUSD;
        $649d4cbaa93fc5f0$var$state.networkPrice = $649d4cbaa93fc5f0$var$initialState.networkPrice;
        $649d4cbaa93fc5f0$var$state.networkTokenSymbol = $649d4cbaa93fc5f0$var$initialState.networkTokenSymbol;
        $649d4cbaa93fc5f0$var$state.networkBalanceInUSD = $649d4cbaa93fc5f0$var$initialState.networkBalanceInUSD;
        $649d4cbaa93fc5f0$var$state.inputError = $649d4cbaa93fc5f0$var$initialState.inputError;
    },
    resetValues: function() {
        var _state_tokens;
        var networkAddress = this.getParams().networkAddress;
        var networkToken = (_state_tokens = $649d4cbaa93fc5f0$var$state.tokens) === null || _state_tokens === void 0 ? void 0 : _state_tokens.find(function(token) {
            return token.address === networkAddress;
        });
        this.setSourceToken(networkToken);
        this.setToToken(undefined);
    },
    getApprovalLoadingState: function() {
        return $649d4cbaa93fc5f0$var$state.loadingApprovalTransaction;
    },
    clearError: function() {
        $649d4cbaa93fc5f0$var$state.transactionError = undefined;
    },
    initializeState: function() {
        return (0, $kSuI9._)(function() {
            var error;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if ($649d4cbaa93fc5f0$var$state.initializing) return [
                            2
                        ];
                        $649d4cbaa93fc5f0$var$state.initializing = true;
                        if (!!$649d4cbaa93fc5f0$var$state.initialized) return [
                            3,
                            4
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            this.fetchTokens()
                        ];
                    case 2:
                        _state.sent();
                        $649d4cbaa93fc5f0$var$state.initialized = true;
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        $649d4cbaa93fc5f0$var$state.initialized = false;
                        (0, $8FcCV.SnackController).showError("Failed to initialize swap");
                        (0, $iptjJ.RouterController).goBack();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        $649d4cbaa93fc5f0$var$state.initializing = false;
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    fetchTokens: function() {
        return (0, $kSuI9._)(function() {
            var _state_tokens, networkAddress, networkToken;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        networkAddress = this.getParams().networkAddress;
                        return [
                            4,
                            this.getTokenList()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            this.getNetworkTokenPrice()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            this.getMyTokensWithBalance()
                        ];
                    case 3:
                        _state.sent();
                        networkToken = (_state_tokens = $649d4cbaa93fc5f0$var$state.tokens) === null || _state_tokens === void 0 ? void 0 : _state_tokens.find(function(token) {
                            return token.address === networkAddress;
                        });
                        if (networkToken) {
                            $649d4cbaa93fc5f0$var$state.networkTokenSymbol = networkToken.symbol;
                            this.setSourceToken(networkToken);
                            this.setSourceTokenAmount("1");
                        }
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    getTokenList: function() {
        return (0, $kSuI9._)(function() {
            var tokens;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, $4Tiue.SwapApiUtil).getTokenList()
                        ];
                    case 1:
                        tokens = _state.sent();
                        $649d4cbaa93fc5f0$var$state.tokens = tokens;
                        $649d4cbaa93fc5f0$var$state.popularTokens = tokens.sort(function(aTokenInfo, bTokenInfo) {
                            if (aTokenInfo.symbol < bTokenInfo.symbol) return -1;
                            if (aTokenInfo.symbol > bTokenInfo.symbol) return 1;
                            return 0;
                        });
                        $649d4cbaa93fc5f0$var$state.suggestedTokens = tokens.filter(function(token) {
                            if ((0, $2sXdV.ConstantsUtil).SWAP_SUGGESTED_TOKENS.includes(token.symbol)) return true;
                            return false;
                        }, {});
                        return [
                            2
                        ];
                }
            });
        })();
    },
    getAddressPrice: function(address) {
        return (0, $kSuI9._)(function() {
            var _allTokens_find, _fungibles_find, existPrice, response, fungibles, allTokens, symbol, price, priceAsFloat;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existPrice = $649d4cbaa93fc5f0$var$state.tokensPriceMap[address];
                        if (existPrice) return [
                            2,
                            existPrice
                        ];
                        return [
                            4,
                            (0, $jrvVk.BlockchainApiController).fetchTokenPrice({
                                projectId: (0, $faNff.OptionsController).state.projectId,
                                addresses: [
                                    address
                                ]
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        fungibles = response.fungibles || [];
                        allTokens = (0, $c6Xmf._)($649d4cbaa93fc5f0$var$state.tokens || []).concat((0, $c6Xmf._)($649d4cbaa93fc5f0$var$state.myTokensWithBalance || []));
                        symbol = allTokens === null || allTokens === void 0 ? void 0 : (_allTokens_find = allTokens.find(function(token) {
                            return token.address === address;
                        })) === null || _allTokens_find === void 0 ? void 0 : _allTokens_find.symbol;
                        price = ((_fungibles_find = fungibles.find(function(p) {
                            return p.symbol.toLowerCase() === (symbol === null || symbol === void 0 ? void 0 : symbol.toLowerCase());
                        })) === null || _fungibles_find === void 0 ? void 0 : _fungibles_find.price) || 0;
                        priceAsFloat = parseFloat(price.toString());
                        $649d4cbaa93fc5f0$var$state.tokensPriceMap[address] = priceAsFloat;
                        return [
                            2,
                            priceAsFloat
                        ];
                }
            });
        })();
    },
    getNetworkTokenPrice: function() {
        return (0, $kSuI9._)(function() {
            var _response_fungibles, networkAddress, response, token, price;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        networkAddress = this.getParams().networkAddress;
                        return [
                            4,
                            (0, $jrvVk.BlockchainApiController).fetchTokenPrice({
                                projectId: (0, $faNff.OptionsController).state.projectId,
                                addresses: [
                                    networkAddress
                                ]
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        token = (_response_fungibles = response.fungibles) === null || _response_fungibles === void 0 ? void 0 : _response_fungibles[0];
                        price = (token === null || token === void 0 ? void 0 : token.price.toString()) || "0";
                        $649d4cbaa93fc5f0$var$state.tokensPriceMap[networkAddress] = parseFloat(price);
                        $649d4cbaa93fc5f0$var$state.networkTokenSymbol = (token === null || token === void 0 ? void 0 : token.symbol) || "";
                        $649d4cbaa93fc5f0$var$state.networkPrice = price;
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    getMyTokensWithBalance: function(forceUpdate) {
        return (0, $kSuI9._)(function() {
            var balances;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, $4Tiue.SwapApiUtil).getMyTokensWithBalance(forceUpdate)
                        ];
                    case 1:
                        balances = _state.sent();
                        if (!balances) return [
                            2
                        ];
                        return [
                            4,
                            this.getInitialGasPrice()
                        ];
                    case 2:
                        _state.sent();
                        this.setBalances(balances);
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    setBalances: function(balances) {
        var networkAddress = this.getParams().networkAddress;
        var caipNetwork = (0, $fPqxb.NetworkController).state.caipNetwork;
        if (!caipNetwork) return;
        var networkToken = balances.find(function(token) {
            return token.address === networkAddress;
        });
        balances.forEach(function(token) {
            $649d4cbaa93fc5f0$var$state.tokensPriceMap[token.address] = token.price || 0;
        });
        $649d4cbaa93fc5f0$var$state.myTokensWithBalance = balances.filter(function(token) {
            return token.address.startsWith(caipNetwork.id);
        });
        $649d4cbaa93fc5f0$var$state.networkBalanceInUSD = networkToken ? (0, $eMPGH.NumberUtil).multiply(networkToken.quantity.numeric, networkToken.price).toString() : "0";
    },
    getInitialGasPrice: function() {
        return (0, $kSuI9._)(function() {
            var res, value, gasFee, gasLimit, gasPrice;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, $4Tiue.SwapApiUtil).fetchGasPrice()
                        ];
                    case 1:
                        res = _state.sent();
                        if (!res) return [
                            2,
                            {
                                gasPrice: null,
                                gasPriceInUsd: null
                            }
                        ];
                        value = res.standard;
                        gasFee = BigInt(value);
                        gasLimit = BigInt($649d4cbaa93fc5f0$export$3540a8643ebda500);
                        gasPrice = (0, $Lhkxt.SwapCalculationUtil).getGasPriceInUSD($649d4cbaa93fc5f0$var$state.networkPrice, gasLimit, gasFee);
                        $649d4cbaa93fc5f0$var$state.gasFee = value;
                        $649d4cbaa93fc5f0$var$state.gasPriceInUSD = gasPrice;
                        return [
                            2,
                            {
                                gasPrice: gasFee,
                                gasPriceInUSD: $649d4cbaa93fc5f0$var$state.gasPriceInUSD
                            }
                        ];
                }
            });
        })();
    },
    swapTokens: // -- Swap -------------------------------------- //
    function() {
        return (0, $kSuI9._)(function() {
            var _quoteResponse_quotes_, _quoteResponse_quotes, address, sourceToken, toToken, haveSourceTokenAmount, amountDecimal, quoteResponse, quoteToAmount, toTokenAmount, isInsufficientToken;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        address = (0, $dMLJP.AccountController).state.address;
                        sourceToken = $649d4cbaa93fc5f0$var$state.sourceToken;
                        toToken = $649d4cbaa93fc5f0$var$state.toToken;
                        haveSourceTokenAmount = (0, $eMPGH.NumberUtil).bigNumber($649d4cbaa93fc5f0$var$state.sourceTokenAmount).isGreaterThan(0);
                        if (!toToken || !sourceToken || $649d4cbaa93fc5f0$var$state.loadingPrices || !haveSourceTokenAmount) return [
                            2
                        ];
                        $649d4cbaa93fc5f0$var$state.loadingQuote = true;
                        amountDecimal = (0, $eMPGH.NumberUtil).bigNumber($649d4cbaa93fc5f0$var$state.sourceTokenAmount).multipliedBy(Math.pow(10, sourceToken.decimals));
                        return [
                            4,
                            (0, $jrvVk.BlockchainApiController).fetchSwapQuote({
                                userAddress: address,
                                projectId: (0, $faNff.OptionsController).state.projectId,
                                from: sourceToken.address,
                                to: toToken.address,
                                gasPrice: $649d4cbaa93fc5f0$var$state.gasFee,
                                amount: amountDecimal.toString()
                            })
                        ];
                    case 1:
                        quoteResponse = _state.sent();
                        $649d4cbaa93fc5f0$var$state.loadingQuote = false;
                        quoteToAmount = quoteResponse === null || quoteResponse === void 0 ? void 0 : (_quoteResponse_quotes = quoteResponse.quotes) === null || _quoteResponse_quotes === void 0 ? void 0 : (_quoteResponse_quotes_ = _quoteResponse_quotes[0]) === null || _quoteResponse_quotes_ === void 0 ? void 0 : _quoteResponse_quotes_.toAmount;
                        if (!quoteToAmount) return [
                            2
                        ];
                        toTokenAmount = (0, $eMPGH.NumberUtil).bigNumber(quoteToAmount).dividedBy(Math.pow(10, toToken.decimals)).toString();
                        this.setToTokenAmount(toTokenAmount);
                        isInsufficientToken = this.hasInsufficientToken($649d4cbaa93fc5f0$var$state.sourceTokenAmount, sourceToken.address);
                        if (isInsufficientToken) $649d4cbaa93fc5f0$var$state.inputError = "Insufficient balance";
                        else {
                            $649d4cbaa93fc5f0$var$state.inputError = undefined;
                            this.setTransactionDetails();
                        }
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    getTransaction: // -- Create Transactions -------------------------------------- //
    function() {
        return (0, $kSuI9._)(function() {
            var _this_getParams, fromCaipAddress, availableToSwap, sourceToken, toToken, hasAllowance, transaction, error;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this_getParams = this.getParams(), fromCaipAddress = _this_getParams.fromCaipAddress, availableToSwap = _this_getParams.availableToSwap;
                        sourceToken = $649d4cbaa93fc5f0$var$state.sourceToken;
                        toToken = $649d4cbaa93fc5f0$var$state.toToken;
                        if (!fromCaipAddress || !availableToSwap || !sourceToken || !toToken || $649d4cbaa93fc5f0$var$state.loadingQuote) return [
                            2,
                            undefined
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            ,
                            8
                        ]);
                        $649d4cbaa93fc5f0$var$state.loadingBuildTransaction = true;
                        return [
                            4,
                            (0, $4Tiue.SwapApiUtil).fetchSwapAllowance({
                                userAddress: fromCaipAddress,
                                tokenAddress: sourceToken.address,
                                sourceTokenAmount: $649d4cbaa93fc5f0$var$state.sourceTokenAmount,
                                sourceTokenDecimals: sourceToken.decimals
                            })
                        ];
                    case 2:
                        hasAllowance = _state.sent();
                        transaction = undefined;
                        if (!hasAllowance) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            this.createSwapTransaction()
                        ];
                    case 3:
                        transaction = _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 4:
                        return [
                            4,
                            this.createAllowanceTransaction()
                        ];
                    case 5:
                        transaction = _state.sent();
                        _state.label = 6;
                    case 6:
                        $649d4cbaa93fc5f0$var$state.loadingBuildTransaction = false;
                        $649d4cbaa93fc5f0$var$state.fetchError = false;
                        return [
                            2,
                            transaction
                        ];
                    case 7:
                        error = _state.sent();
                        (0, $iptjJ.RouterController).goBack();
                        (0, $8FcCV.SnackController).showError("Failed to check allowance");
                        $649d4cbaa93fc5f0$var$state.loadingBuildTransaction = false;
                        $649d4cbaa93fc5f0$var$state.approvalTransaction = undefined;
                        $649d4cbaa93fc5f0$var$state.swapTransaction = undefined;
                        $649d4cbaa93fc5f0$var$state.fetchError = true;
                        return [
                            2,
                            undefined
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    createAllowanceTransaction: function() {
        return (0, $kSuI9._)(function() {
            var _this_getParams, fromCaipAddress, fromAddress, sourceTokenAddress, toTokenAddress, response, gasLimit, transaction, error;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this_getParams = this.getParams(), fromCaipAddress = _this_getParams.fromCaipAddress, fromAddress = _this_getParams.fromAddress, sourceTokenAddress = _this_getParams.sourceTokenAddress, toTokenAddress = _this_getParams.toTokenAddress;
                        if (!fromCaipAddress || !toTokenAddress) return [
                            2,
                            undefined
                        ];
                        if (!sourceTokenAddress) throw new Error("createAllowanceTransaction - No source token address found.");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            (0, $jrvVk.BlockchainApiController).generateApproveCalldata({
                                projectId: (0, $faNff.OptionsController).state.projectId,
                                from: sourceTokenAddress,
                                to: toTokenAddress,
                                userAddress: fromCaipAddress
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        return [
                            4,
                            (0, $3cYIS.ConnectionController).estimateGas({
                                address: fromAddress,
                                to: (0, $hZBJb.CoreHelperUtil).getPlainAddress(response.tx.to),
                                data: response.tx.data
                            })
                        ];
                    case 3:
                        gasLimit = _state.sent();
                        transaction = {
                            data: response.tx.data,
                            to: (0, $hZBJb.CoreHelperUtil).getPlainAddress(response.tx.from),
                            gas: gasLimit,
                            gasPrice: BigInt(response.tx.eip155.gasPrice),
                            value: BigInt(response.tx.value),
                            toAmount: $649d4cbaa93fc5f0$var$state.toTokenAmount
                        };
                        $649d4cbaa93fc5f0$var$state.swapTransaction = undefined;
                        $649d4cbaa93fc5f0$var$state.approvalTransaction = transaction;
                        return [
                            2,
                            transaction
                        ];
                    case 4:
                        error = _state.sent();
                        (0, $iptjJ.RouterController).goBack();
                        (0, $8FcCV.SnackController).showError("Failed to create approval transaction");
                        $649d4cbaa93fc5f0$var$state.approvalTransaction = undefined;
                        $649d4cbaa93fc5f0$var$state.swapTransaction = undefined;
                        $649d4cbaa93fc5f0$var$state.fetchError = true;
                        return [
                            2,
                            undefined
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    createSwapTransaction: function() {
        return (0, $kSuI9._)(function() {
            var _this_getParams, networkAddress, fromCaipAddress, sourceTokenAmount, sourceToken, toToken, amount, response, isSourceTokenIsNetworkToken, gas, gasPrice, transaction, error;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this_getParams = this.getParams(), networkAddress = _this_getParams.networkAddress, fromCaipAddress = _this_getParams.fromCaipAddress, sourceTokenAmount = _this_getParams.sourceTokenAmount;
                        sourceToken = $649d4cbaa93fc5f0$var$state.sourceToken;
                        toToken = $649d4cbaa93fc5f0$var$state.toToken;
                        if (!fromCaipAddress || !sourceTokenAmount || !sourceToken || !toToken) return [
                            2,
                            undefined
                        ];
                        amount = (0, $3cYIS.ConnectionController).parseUnits(sourceTokenAmount, sourceToken.decimals).toString();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0, $jrvVk.BlockchainApiController).generateSwapCalldata({
                                projectId: (0, $faNff.OptionsController).state.projectId,
                                userAddress: fromCaipAddress,
                                from: sourceToken.address,
                                to: toToken.address,
                                amount: amount
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        isSourceTokenIsNetworkToken = sourceToken.address === networkAddress;
                        gas = BigInt(response.tx.eip155.gas);
                        gasPrice = BigInt(response.tx.eip155.gasPrice);
                        transaction = {
                            data: response.tx.data,
                            to: (0, $hZBJb.CoreHelperUtil).getPlainAddress(response.tx.to),
                            gas: gas,
                            gasPrice: gasPrice,
                            value: isSourceTokenIsNetworkToken ? BigInt(amount) : BigInt("0"),
                            toAmount: $649d4cbaa93fc5f0$var$state.toTokenAmount
                        };
                        $649d4cbaa93fc5f0$var$state.gasPriceInUSD = (0, $Lhkxt.SwapCalculationUtil).getGasPriceInUSD($649d4cbaa93fc5f0$var$state.networkPrice, gas, gasPrice);
                        $649d4cbaa93fc5f0$var$state.approvalTransaction = undefined;
                        $649d4cbaa93fc5f0$var$state.swapTransaction = transaction;
                        return [
                            2,
                            transaction
                        ];
                    case 3:
                        error = _state.sent();
                        (0, $iptjJ.RouterController).goBack();
                        (0, $8FcCV.SnackController).showError("Failed to create transaction");
                        $649d4cbaa93fc5f0$var$state.approvalTransaction = undefined;
                        $649d4cbaa93fc5f0$var$state.swapTransaction = undefined;
                        $649d4cbaa93fc5f0$var$state.fetchError = true;
                        return [
                            2,
                            undefined
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    sendTransactionForApproval: // -- Send Transactions --------------------------------- //
    function(data) {
        return (0, $kSuI9._)(function() {
            var _this_getParams, fromAddress, isAuthConnector, approveLimitMessage, err, error;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this_getParams = this.getParams(), fromAddress = _this_getParams.fromAddress, isAuthConnector = _this_getParams.isAuthConnector;
                        $649d4cbaa93fc5f0$var$state.loadingApprovalTransaction = true;
                        approveLimitMessage = "Approve limit increase in your wallet";
                        if (isAuthConnector) (0, $iptjJ.RouterController).pushTransactionStack({
                            view: null,
                            goBack: true,
                            onSuccess: function() {
                                (0, $8FcCV.SnackController).showLoading(approveLimitMessage);
                            }
                        });
                        else (0, $8FcCV.SnackController).showLoading(approveLimitMessage);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4,
                            (0, $3cYIS.ConnectionController).sendTransaction({
                                address: fromAddress,
                                to: data.to,
                                data: data.data,
                                value: BigInt(data.value),
                                gasPrice: BigInt(data.gasPrice)
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            this.swapTokens()
                        ];
                    case 3:
                        _state.sent();
                        return [
                            4,
                            this.getTransaction()
                        ];
                    case 4:
                        _state.sent();
                        $649d4cbaa93fc5f0$var$state.approvalTransaction = undefined;
                        $649d4cbaa93fc5f0$var$state.loadingApprovalTransaction = false;
                        return [
                            3,
                            6
                        ];
                    case 5:
                        err = _state.sent();
                        error = err;
                        $649d4cbaa93fc5f0$var$state.transactionError = error === null || error === void 0 ? void 0 : error.shortMessage;
                        $649d4cbaa93fc5f0$var$state.loadingApprovalTransaction = false;
                        (0, $8FcCV.SnackController).showError((error === null || error === void 0 ? void 0 : error.shortMessage) || "Transaction error");
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    sendTransactionForSwap: function(data) {
        return (0, $kSuI9._)(function() {
            var _state_sourceToken, _state_toToken, _state_sourceToken1, _state_toToken1, _this_getParams, fromAddress, toTokenAmount, isAuthConnector, snackbarPendingMessage, snackbarSuccessMessage, _state_sourceToken2, _state_toToken2, _NetworkController_state_caipNetwork, _this_state_sourceToken, _this_state_toToken, forceUpdateAddresses, transactionHash, err, _NetworkController_state_caipNetwork1, _this_state_sourceToken1, _this_state_toToken1, error;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!data) return [
                            2,
                            undefined
                        ];
                        _this_getParams = this.getParams(), fromAddress = _this_getParams.fromAddress, toTokenAmount = _this_getParams.toTokenAmount, isAuthConnector = _this_getParams.isAuthConnector;
                        $649d4cbaa93fc5f0$var$state.loadingTransaction = true;
                        snackbarPendingMessage = "Swapping ".concat((_state_sourceToken = $649d4cbaa93fc5f0$var$state.sourceToken) === null || _state_sourceToken === void 0 ? void 0 : _state_sourceToken.symbol, " to ").concat((0, $eMPGH.NumberUtil).formatNumberToLocalString(toTokenAmount, 3), " ").concat((_state_toToken = $649d4cbaa93fc5f0$var$state.toToken) === null || _state_toToken === void 0 ? void 0 : _state_toToken.symbol);
                        snackbarSuccessMessage = "Swapped ".concat((_state_sourceToken1 = $649d4cbaa93fc5f0$var$state.sourceToken) === null || _state_sourceToken1 === void 0 ? void 0 : _state_sourceToken1.symbol, " to ").concat((0, $eMPGH.NumberUtil).formatNumberToLocalString(toTokenAmount, 3), " ").concat((_state_toToken1 = $649d4cbaa93fc5f0$var$state.toToken) === null || _state_toToken1 === void 0 ? void 0 : _state_toToken1.symbol);
                        if (isAuthConnector) (0, $iptjJ.RouterController).pushTransactionStack({
                            view: "Account",
                            goBack: false,
                            onSuccess: function() {
                                (0, $8FcCV.SnackController).showLoading(snackbarPendingMessage);
                                $649d4cbaa93fc5f0$export$cb69c6a27866a8a5.resetState();
                            }
                        });
                        else (0, $8FcCV.SnackController).showLoading("Confirm transaction in your wallet");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        forceUpdateAddresses = [
                            (_state_sourceToken2 = $649d4cbaa93fc5f0$var$state.sourceToken) === null || _state_sourceToken2 === void 0 ? void 0 : _state_sourceToken2.address,
                            (_state_toToken2 = $649d4cbaa93fc5f0$var$state.toToken) === null || _state_toToken2 === void 0 ? void 0 : _state_toToken2.address
                        ].join(",");
                        return [
                            4,
                            (0, $3cYIS.ConnectionController).sendTransaction({
                                address: fromAddress,
                                to: data.to,
                                data: data.data,
                                gas: data.gas,
                                gasPrice: BigInt(data.gasPrice),
                                value: data.value
                            })
                        ];
                    case 2:
                        transactionHash = _state.sent();
                        $649d4cbaa93fc5f0$var$state.loadingTransaction = false;
                        (0, $8FcCV.SnackController).showSuccess(snackbarSuccessMessage);
                        (0, $1QDT9.EventsController).sendEvent({
                            type: "track",
                            event: "SWAP_SUCCESS",
                            properties: {
                                network: ((_NetworkController_state_caipNetwork = (0, $fPqxb.NetworkController).state.caipNetwork) === null || _NetworkController_state_caipNetwork === void 0 ? void 0 : _NetworkController_state_caipNetwork.id) || "",
                                swapFromToken: ((_this_state_sourceToken = this.state.sourceToken) === null || _this_state_sourceToken === void 0 ? void 0 : _this_state_sourceToken.symbol) || "",
                                swapToToken: ((_this_state_toToken = this.state.toToken) === null || _this_state_toToken === void 0 ? void 0 : _this_state_toToken.symbol) || "",
                                swapFromAmount: this.state.sourceTokenAmount || "",
                                swapToAmount: this.state.toTokenAmount || "",
                                isSmartAccount: (0, $dMLJP.AccountController).state.preferredAccountType === (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT
                            }
                        });
                        $649d4cbaa93fc5f0$export$cb69c6a27866a8a5.resetState();
                        if (!isAuthConnector) (0, $iptjJ.RouterController).replace("Account");
                        $649d4cbaa93fc5f0$export$cb69c6a27866a8a5.getMyTokensWithBalance(forceUpdateAddresses);
                        return [
                            2,
                            transactionHash
                        ];
                    case 3:
                        err = _state.sent();
                        error = err;
                        $649d4cbaa93fc5f0$var$state.transactionError = error === null || error === void 0 ? void 0 : error.shortMessage;
                        $649d4cbaa93fc5f0$var$state.loadingTransaction = false;
                        (0, $8FcCV.SnackController).showError((error === null || error === void 0 ? void 0 : error.shortMessage) || "Transaction error");
                        (0, $1QDT9.EventsController).sendEvent({
                            type: "track",
                            event: "SWAP_ERROR",
                            properties: {
                                network: ((_NetworkController_state_caipNetwork1 = (0, $fPqxb.NetworkController).state.caipNetwork) === null || _NetworkController_state_caipNetwork1 === void 0 ? void 0 : _NetworkController_state_caipNetwork1.id) || "",
                                swapFromToken: ((_this_state_sourceToken1 = this.state.sourceToken) === null || _this_state_sourceToken1 === void 0 ? void 0 : _this_state_sourceToken1.symbol) || "",
                                swapToToken: ((_this_state_toToken1 = this.state.toToken) === null || _this_state_toToken1 === void 0 ? void 0 : _this_state_toToken1.symbol) || "",
                                swapFromAmount: this.state.sourceTokenAmount || "",
                                swapToAmount: this.state.toTokenAmount || "",
                                isSmartAccount: (0, $dMLJP.AccountController).state.preferredAccountType === (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT
                            }
                        });
                        return [
                            2,
                            undefined
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    // -- Checks -------------------------------------------- //
    hasInsufficientToken: function(sourceTokenAmount, sourceTokenAddress) {
        var isInsufficientSourceTokenForSwap = (0, $Lhkxt.SwapCalculationUtil).isInsufficientSourceTokenForSwap(sourceTokenAmount, sourceTokenAddress, $649d4cbaa93fc5f0$var$state.myTokensWithBalance);
        var insufficientNetworkTokenForGas = (0, $Lhkxt.SwapCalculationUtil).isInsufficientNetworkTokenForGas($649d4cbaa93fc5f0$var$state.networkBalanceInUSD, $649d4cbaa93fc5f0$var$state.gasPriceInUSD);
        return insufficientNetworkTokenForGas || isInsufficientSourceTokenForSwap;
    },
    // -- Calculations -------------------------------------- //
    setTransactionDetails: function() {
        var _this_getParams = this.getParams(), toTokenAddress = _this_getParams.toTokenAddress, toTokenDecimals = _this_getParams.toTokenDecimals;
        if (!toTokenAddress || !toTokenDecimals) return;
        $649d4cbaa93fc5f0$var$state.gasPriceInUSD = (0, $Lhkxt.SwapCalculationUtil).getGasPriceInUSD($649d4cbaa93fc5f0$var$state.networkPrice, BigInt($649d4cbaa93fc5f0$var$state.gasFee), BigInt($649d4cbaa93fc5f0$export$3540a8643ebda500));
        $649d4cbaa93fc5f0$var$state.priceImpact = (0, $Lhkxt.SwapCalculationUtil).getPriceImpact({
            sourceTokenAmount: $649d4cbaa93fc5f0$var$state.sourceTokenAmount,
            sourceTokenPriceInUSD: $649d4cbaa93fc5f0$var$state.sourceTokenPriceInUSD,
            toTokenPriceInUSD: $649d4cbaa93fc5f0$var$state.toTokenPriceInUSD,
            toTokenAmount: $649d4cbaa93fc5f0$var$state.toTokenAmount
        });
        $649d4cbaa93fc5f0$var$state.maxSlippage = (0, $Lhkxt.SwapCalculationUtil).getMaxSlippage($649d4cbaa93fc5f0$var$state.slippage, $649d4cbaa93fc5f0$var$state.toTokenAmount);
        $649d4cbaa93fc5f0$var$state.providerFee = (0, $Lhkxt.SwapCalculationUtil).getProviderFee($649d4cbaa93fc5f0$var$state.sourceTokenAmount);
    }
};

});
parcelRegister("3cYIS", function(module, exports) {

$parcel$export(module.exports, "ConnectionController", function () { return $2561985e37f6e6b5$export$303deccbe6e8c782; });

var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $6vAtg = parcelRequire("6vAtg");

var $hyDkn = parcelRequire("hyDkn");

var $hZBJb = parcelRequire("hZBJb");

var $i7zcD = parcelRequire("i7zcD");

var $ktZEF = parcelRequire("ktZEF");

var $9zDWP = parcelRequire("9zDWP");
parcelRequire("hsyMZ");

var $5Lhe6 = parcelRequire("5Lhe6");

var $2qlRb = parcelRequire("2qlRb");

var $1QDT9 = parcelRequire("1QDT9");

var $fPqxb = parcelRequire("fPqxb");
// -- State --------------------------------------------- //
var $2561985e37f6e6b5$var$state = (0, $hyDkn.proxy)({
    wcError: false,
    buffering: false
});
var $2561985e37f6e6b5$export$303deccbe6e8c782 = {
    state: $2561985e37f6e6b5$var$state,
    subscribeKey: function(key, callback) {
        return (0, $6vAtg.subscribeKey)($2561985e37f6e6b5$var$state, key, callback);
    },
    _getClient: function(chain) {
        return (0, $9zDWP.ChainController).getConnectionControllerClient(chain);
    },
    setClient: function(client) {
        $2561985e37f6e6b5$var$state._client = (0, $hyDkn.ref)(client);
    },
    connectWalletConnect: function() {
        return (0, $kSuI9._)(function() {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        (0, $i7zcD.StorageUtil).setConnectedConnector("WALLET_CONNECT");
                        return [
                            4,
                            this._getClient().connectWalletConnect(function(uri) {
                                $2561985e37f6e6b5$var$state.wcUri = uri;
                                $2561985e37f6e6b5$var$state.wcPairingExpiry = (0, $hZBJb.CoreHelperUtil).getPairingExpiry();
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    connectExternal: function(options, chain) {
        return (0, $kSuI9._)(function() {
            var _this__getClient_connectExternal, _this__getClient;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (_this__getClient_connectExternal = (_this__getClient = this._getClient(chain)).connectExternal) === null || _this__getClient_connectExternal === void 0 ? void 0 : _this__getClient_connectExternal.call(_this__getClient, options)
                        ];
                    case 1:
                        _state.sent();
                        (0, $9zDWP.ChainController).setActiveChain(chain);
                        (0, $i7zcD.StorageUtil).setConnectedConnector(options.type);
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    reconnectExternal: function(options) {
        return (0, $kSuI9._)(function() {
            var _this__getClient_reconnectExternal, _this__getClient;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (_this__getClient_reconnectExternal = (_this__getClient = this._getClient()).reconnectExternal) === null || _this__getClient_reconnectExternal === void 0 ? void 0 : _this__getClient_reconnectExternal.call(_this__getClient, options)
                        ];
                    case 1:
                        _state.sent();
                        (0, $i7zcD.StorageUtil).setConnectedConnector(options.type);
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    setPreferredAccountType: function(accountType) {
        return (0, $kSuI9._)(function() {
            var _NetworkController_state_caipNetwork, authConnector;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        (0, $5Lhe6.ModalController).setLoading(true);
                        authConnector = (0, $2qlRb.ConnectorController).getAuthConnector();
                        if (!authConnector) return [
                            2
                        ];
                        return [
                            4,
                            authConnector === null || authConnector === void 0 ? void 0 : authConnector.provider.setPreferredAccount(accountType)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            this.reconnectExternal(authConnector)
                        ];
                    case 2:
                        _state.sent();
                        (0, $5Lhe6.ModalController).setLoading(false);
                        (0, $1QDT9.EventsController).sendEvent({
                            type: "track",
                            event: "SET_PREFERRED_ACCOUNT_TYPE",
                            properties: {
                                accountType: accountType,
                                network: ((_NetworkController_state_caipNetwork = (0, $fPqxb.NetworkController).state.caipNetwork) === null || _NetworkController_state_caipNetwork === void 0 ? void 0 : _NetworkController_state_caipNetwork.id) || ""
                            }
                        });
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    signMessage: function(message) {
        return (0, $kSuI9._)(function() {
            return (0, $eha6O.__generator)(this, function(_state) {
                return [
                    2,
                    this._getClient().signMessage(message)
                ];
            });
        }).apply(this);
    },
    parseUnits: function(value, decimals) {
        return this._getClient().parseUnits(value, decimals);
    },
    formatUnits: function(value, decimals) {
        return this._getClient().formatUnits(value, decimals);
    },
    sendTransaction: function(args) {
        return (0, $kSuI9._)(function() {
            return (0, $eha6O.__generator)(this, function(_state) {
                return [
                    2,
                    this._getClient().sendTransaction(args)
                ];
            });
        }).apply(this);
    },
    estimateGas: function(args) {
        return (0, $kSuI9._)(function() {
            return (0, $eha6O.__generator)(this, function(_state) {
                return [
                    2,
                    this._getClient().estimateGas(args)
                ];
            });
        }).apply(this);
    },
    writeContract: function(args) {
        return (0, $kSuI9._)(function() {
            return (0, $eha6O.__generator)(this, function(_state) {
                return [
                    2,
                    this._getClient().writeContract(args)
                ];
            });
        }).apply(this);
    },
    getEnsAddress: function(value) {
        return (0, $kSuI9._)(function() {
            return (0, $eha6O.__generator)(this, function(_state) {
                return [
                    2,
                    this._getClient().getEnsAddress(value)
                ];
            });
        }).apply(this);
    },
    getEnsAvatar: function(value) {
        return (0, $kSuI9._)(function() {
            return (0, $eha6O.__generator)(this, function(_state) {
                return [
                    2,
                    this._getClient().getEnsAvatar(value)
                ];
            });
        }).apply(this);
    },
    checkInstalled: function(ids, chain) {
        var _this__getClient_checkInstalled, _this__getClient;
        return ((_this__getClient_checkInstalled = (_this__getClient = this._getClient(chain)).checkInstalled) === null || _this__getClient_checkInstalled === void 0 ? void 0 : _this__getClient_checkInstalled.call(_this__getClient, ids)) || false;
    },
    resetWcConnection: function() {
        $2561985e37f6e6b5$var$state.wcUri = undefined;
        $2561985e37f6e6b5$var$state.wcPairingExpiry = undefined;
        $2561985e37f6e6b5$var$state.wcLinking = undefined;
        $2561985e37f6e6b5$var$state.recentWallet = undefined;
        (0, $ktZEF.TransactionsController).resetTransactions();
        (0, $i7zcD.StorageUtil).deleteWalletConnectDeepLink();
    },
    setWcLinking: function(wcLinking) {
        $2561985e37f6e6b5$var$state.wcLinking = wcLinking;
    },
    setWcError: function(wcError) {
        $2561985e37f6e6b5$var$state.wcError = wcError;
        $2561985e37f6e6b5$var$state.buffering = false;
    },
    setRecentWallet: function(wallet) {
        $2561985e37f6e6b5$var$state.recentWallet = wallet;
    },
    setBuffering: function(buffering) {
        $2561985e37f6e6b5$var$state.buffering = buffering;
    },
    disconnect: function() {
        return (0, $kSuI9._)(function() {
            var client, error;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        client = this._getClient();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            client.disconnect()
                        ];
                    case 2:
                        _state.sent();
                        this.resetWcConnection();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        throw new Error("Failed to disconnect");
                    case 4:
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    }
};

});
parcelRegister("ktZEF", function(module, exports) {

$parcel$export(module.exports, "TransactionsController", function () { return $ee96577cd055dd8f$export$da1e018e28e23fb0; });

var $kSuI9 = parcelRequire("kSuI9");

var $3sHb8 = parcelRequire("3sHb8");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $c6Xmf = parcelRequire("c6Xmf");

var $eha6O = parcelRequire("eha6O");

var $hyDkn = parcelRequire("hyDkn");

var $faNff = parcelRequire("faNff");

var $1QDT9 = parcelRequire("1QDT9");

var $8FcCV = parcelRequire("8FcCV");

var $fPqxb = parcelRequire("fPqxb");

var $jrvVk = parcelRequire("jrvVk");

var $dMLJP = parcelRequire("dMLJP");
parcelRequire("hsyMZ");
var $cSJ4o = parcelRequire("cSJ4o");
// -- State --------------------------------------------- //
var $ee96577cd055dd8f$var$state = (0, $hyDkn.proxy)({
    transactions: [],
    coinbaseTransactions: {},
    transactionsByYear: {},
    lastNetworkInView: undefined,
    loading: false,
    empty: false,
    next: undefined
});
var $ee96577cd055dd8f$export$da1e018e28e23fb0 = {
    state: $ee96577cd055dd8f$var$state,
    subscribe: function(callback) {
        return (0, $hyDkn.subscribe)($ee96577cd055dd8f$var$state, function() {
            return callback($ee96577cd055dd8f$var$state);
        });
    },
    setLastNetworkInView: function(lastNetworkInView) {
        $ee96577cd055dd8f$var$state.lastNetworkInView = lastNetworkInView;
    },
    fetchTransactions: function(accountAddress, onramp) {
        return (0, $kSuI9._)(function() {
            var projectId, response, nonSpamTransactions, sameChainTransactions, filteredTransactions, error;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        projectId = (0, $faNff.OptionsController).state.projectId;
                        if (!projectId || !accountAddress) throw new Error("Transactions can't be fetched without a projectId and an accountAddress");
                        $ee96577cd055dd8f$var$state.loading = true;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0, $jrvVk.BlockchainApiController).fetchTransactions({
                                account: accountAddress,
                                projectId: projectId,
                                cursor: $ee96577cd055dd8f$var$state.next,
                                onramp: onramp,
                                // Coinbase transaction history state updates require the latest data
                                cache: onramp === "coinbase" ? "no-cache" : undefined
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        nonSpamTransactions = this.filterSpamTransactions(response.data);
                        sameChainTransactions = this.filterByConnectedChain(nonSpamTransactions);
                        filteredTransactions = (0, $c6Xmf._)($ee96577cd055dd8f$var$state.transactions).concat((0, $c6Xmf._)(sameChainTransactions));
                        $ee96577cd055dd8f$var$state.loading = false;
                        if (onramp === "coinbase") $ee96577cd055dd8f$var$state.coinbaseTransactions = this.groupTransactionsByYearAndMonth($ee96577cd055dd8f$var$state.coinbaseTransactions, response.data);
                        else {
                            $ee96577cd055dd8f$var$state.transactions = filteredTransactions;
                            $ee96577cd055dd8f$var$state.transactionsByYear = this.groupTransactionsByYearAndMonth($ee96577cd055dd8f$var$state.transactionsByYear, sameChainTransactions);
                        }
                        $ee96577cd055dd8f$var$state.empty = filteredTransactions.length === 0;
                        $ee96577cd055dd8f$var$state.next = response.next ? response.next : undefined;
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        (0, $1QDT9.EventsController).sendEvent({
                            type: "track",
                            event: "ERROR_FETCH_TRANSACTIONS",
                            properties: {
                                address: accountAddress,
                                projectId: projectId,
                                cursor: $ee96577cd055dd8f$var$state.next,
                                isSmartAccount: (0, $dMLJP.AccountController).state.preferredAccountType === (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT
                            }
                        });
                        (0, $8FcCV.SnackController).showError("Failed to fetch transactions");
                        $ee96577cd055dd8f$var$state.loading = false;
                        $ee96577cd055dd8f$var$state.empty = true;
                        $ee96577cd055dd8f$var$state.next = undefined;
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    groupTransactionsByYearAndMonth: function() {
        var transactionsMap = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, transactions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
        var grouped = transactionsMap;
        transactions.forEach(function(transaction) {
            var year = new Date(transaction.metadata.minedAt).getFullYear();
            var month = new Date(transaction.metadata.minedAt).getMonth();
            var _grouped_year;
            var yearTransactions = (_grouped_year = grouped[year]) !== null && _grouped_year !== void 0 ? _grouped_year : {};
            var _yearTransactions_month;
            var monthTransactions = (_yearTransactions_month = yearTransactions[month]) !== null && _yearTransactions_month !== void 0 ? _yearTransactions_month : [];
            // If there's a transaction with the same id, remove the old one
            var newMonthTransactions = monthTransactions.filter(function(tx) {
                return tx.id !== transaction.id;
            });
            grouped[year] = (0, $cxjpp._)((0, $do9pw._)({}, yearTransactions), (0, $3sHb8._)({}, month, (0, $c6Xmf._)(newMonthTransactions).concat([
                transaction
            ]).sort(function(a, b) {
                return new Date(b.metadata.minedAt).getTime() - new Date(a.metadata.minedAt).getTime();
            })));
        });
        return grouped;
    },
    filterSpamTransactions: function(transactions) {
        return transactions.filter(function(transaction) {
            var isAllSpam = transaction.transfers.every(function(transfer) {
                var _transfer_nft_info;
                return ((_transfer_nft_info = transfer.nft_info) === null || _transfer_nft_info === void 0 ? void 0 : _transfer_nft_info.flags.is_spam) === true;
            });
            return !isAllSpam;
        });
    },
    filterByConnectedChain: function(transactions) {
        var _NetworkController_state_caipNetwork;
        var chainId = (_NetworkController_state_caipNetwork = (0, $fPqxb.NetworkController).state.caipNetwork) === null || _NetworkController_state_caipNetwork === void 0 ? void 0 : _NetworkController_state_caipNetwork.id;
        var filteredTransactions = transactions.filter(function(transaction) {
            return transaction.metadata.chain === chainId;
        });
        return filteredTransactions;
    },
    clearCursor: function() {
        $ee96577cd055dd8f$var$state.next = undefined;
    },
    resetTransactions: function() {
        $ee96577cd055dd8f$var$state.transactions = [];
        $ee96577cd055dd8f$var$state.transactionsByYear = {};
        $ee96577cd055dd8f$var$state.lastNetworkInView = undefined;
        $ee96577cd055dd8f$var$state.loading = false;
        $ee96577cd055dd8f$var$state.empty = false;
        $ee96577cd055dd8f$var$state.next = undefined;
    }
};

});
parcelRegister("hsyMZ", function(module, exports) {

$parcel$export(module.exports, "W3mFrameHelpers", function () { return (parcelRequire("2ZXsZ")).W3mFrameHelpers; });
$parcel$export(module.exports, "W3mFrameProvider", function () { return (parcelRequire("31229")).W3mFrameProvider; });
$parcel$export(module.exports, "W3mFrameRpcConstants", function () { return (parcelRequire("cSJ4o")).W3mFrameRpcConstants; });
parcelRequire("8if8T");

var $74Iww = parcelRequire("74Iww");

var $2ZXsZ = parcelRequire("2ZXsZ");

var $31229 = parcelRequire("31229");

var $ai23K = parcelRequire("ai23K");

var $cSJ4o = parcelRequire("cSJ4o");

var $giFXM = parcelRequire("giFXM");

});
parcelRegister("8if8T", function(module, exports) {

var $8dlmd = parcelRequire("8dlmd");
if (typeof window !== "undefined") {
    var $609bc028fe592a80$var$_window_process;
    if (!window.Buffer) window.Buffer = (0, $8dlmd.Buffer);
    if (!window.global) window.global = window;
    if (!window.process) window.process = {};
    if (!(($609bc028fe592a80$var$_window_process = window.process) === null || $609bc028fe592a80$var$_window_process === void 0 ? void 0 : $609bc028fe592a80$var$_window_process.env)) window.process = {
        env: {}
    };
}

});
parcelRegister("8dlmd", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $5fb01ac0df210ca2$export$a143d493d941bafc; }, function (v) { return $5fb01ac0df210ca2$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $5fb01ac0df210ca2$export$e4cf37d7f6fb9e0a; }, function (v) { return $5fb01ac0df210ca2$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $5fb01ac0df210ca2$export$f99ded8fe4b79145; }, function (v) { return $5fb01ac0df210ca2$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $5fb01ac0df210ca2$export$599f31c3813fae4d; }, function (v) { return $5fb01ac0df210ca2$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $l0HdX = parcelRequire("l0HdX");

var $ohfOJ = parcelRequire("ohfOJ");
var $5fb01ac0df210ca2$export$a143d493d941bafc;
var $5fb01ac0df210ca2$export$e4cf37d7f6fb9e0a;
var $5fb01ac0df210ca2$export$f99ded8fe4b79145;
var $5fb01ac0df210ca2$export$599f31c3813fae4d;
"use strict";

var $iB1U9 = parcelRequire("iB1U9");

var $7ls3U = parcelRequire("7ls3U");
var $5fb01ac0df210ca2$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$5fb01ac0df210ca2$export$a143d493d941bafc = $5fb01ac0df210ca2$var$Buffer;
$5fb01ac0df210ca2$export$e4cf37d7f6fb9e0a = $5fb01ac0df210ca2$var$SlowBuffer;
$5fb01ac0df210ca2$export$f99ded8fe4b79145 = 50;
var $5fb01ac0df210ca2$var$K_MAX_LENGTH = 0x7fffffff;
$5fb01ac0df210ca2$export$599f31c3813fae4d = $5fb01ac0df210ca2$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $5fb01ac0df210ca2$var$Buffer.TYPED_ARRAY_SUPPORT = $5fb01ac0df210ca2$var$typedArraySupport();
if (!$5fb01ac0df210ca2$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $5fb01ac0df210ca2$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($5fb01ac0df210ca2$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function get() {
        if (!$5fb01ac0df210ca2$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($5fb01ac0df210ca2$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function get() {
        if (!$5fb01ac0df210ca2$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $5fb01ac0df210ca2$var$createBuffer(length) {
    if (length > $5fb01ac0df210ca2$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $5fb01ac0df210ca2$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $5fb01ac0df210ca2$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $5fb01ac0df210ca2$var$allocUnsafe(arg);
    }
    return $5fb01ac0df210ca2$var$from(arg, encodingOrOffset, length);
}
$5fb01ac0df210ca2$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $5fb01ac0df210ca2$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $5fb01ac0df210ca2$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $5fb01ac0df210ca2$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value)));
    if ($5fb01ac0df210ca2$var$isInstance(value, ArrayBuffer) || value && $5fb01ac0df210ca2$var$isInstance(value.buffer, ArrayBuffer)) return $5fb01ac0df210ca2$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($5fb01ac0df210ca2$var$isInstance(value, SharedArrayBuffer) || value && $5fb01ac0df210ca2$var$isInstance(value.buffer, SharedArrayBuffer))) return $5fb01ac0df210ca2$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $5fb01ac0df210ca2$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $5fb01ac0df210ca2$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $5fb01ac0df210ca2$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $5fb01ac0df210ca2$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $5fb01ac0df210ca2$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($5fb01ac0df210ca2$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($5fb01ac0df210ca2$var$Buffer, Uint8Array);
function $5fb01ac0df210ca2$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $5fb01ac0df210ca2$var$alloc(size, fill, encoding) {
    $5fb01ac0df210ca2$var$assertSize(size);
    if (size <= 0) return $5fb01ac0df210ca2$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $5fb01ac0df210ca2$var$createBuffer(size).fill(fill, encoding) : $5fb01ac0df210ca2$var$createBuffer(size).fill(fill);
    return $5fb01ac0df210ca2$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $5fb01ac0df210ca2$var$Buffer.alloc = function(size, fill, encoding) {
    return $5fb01ac0df210ca2$var$alloc(size, fill, encoding);
};
function $5fb01ac0df210ca2$var$allocUnsafe(size) {
    $5fb01ac0df210ca2$var$assertSize(size);
    return $5fb01ac0df210ca2$var$createBuffer(size < 0 ? 0 : $5fb01ac0df210ca2$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $5fb01ac0df210ca2$var$Buffer.allocUnsafe = function(size) {
    return $5fb01ac0df210ca2$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $5fb01ac0df210ca2$var$Buffer.allocUnsafeSlow = function(size) {
    return $5fb01ac0df210ca2$var$allocUnsafe(size);
};
function $5fb01ac0df210ca2$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$5fb01ac0df210ca2$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $5fb01ac0df210ca2$var$byteLength(string, encoding) | 0;
    var buf = $5fb01ac0df210ca2$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $5fb01ac0df210ca2$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $5fb01ac0df210ca2$var$checked(array.length) | 0;
    var buf = $5fb01ac0df210ca2$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $5fb01ac0df210ca2$var$fromArrayView(arrayView) {
    if ($5fb01ac0df210ca2$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $5fb01ac0df210ca2$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $5fb01ac0df210ca2$var$fromArrayLike(arrayView);
}
function $5fb01ac0df210ca2$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $5fb01ac0df210ca2$var$Buffer.prototype);
    return buf;
}
function $5fb01ac0df210ca2$var$fromObject(obj) {
    if ($5fb01ac0df210ca2$var$Buffer.isBuffer(obj)) {
        var len = $5fb01ac0df210ca2$var$checked(obj.length) | 0;
        var buf = $5fb01ac0df210ca2$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $5fb01ac0df210ca2$var$numberIsNaN(obj.length)) return $5fb01ac0df210ca2$var$createBuffer(0);
        return $5fb01ac0df210ca2$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $5fb01ac0df210ca2$var$fromArrayLike(obj.data);
}
function $5fb01ac0df210ca2$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $5fb01ac0df210ca2$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $5fb01ac0df210ca2$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $5fb01ac0df210ca2$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $5fb01ac0df210ca2$var$Buffer.alloc(+length);
}
$5fb01ac0df210ca2$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $5fb01ac0df210ca2$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$5fb01ac0df210ca2$var$Buffer.compare = function compare(a, b) {
    if ($5fb01ac0df210ca2$var$isInstance(a, Uint8Array)) a = $5fb01ac0df210ca2$var$Buffer.from(a, a.offset, a.byteLength);
    if ($5fb01ac0df210ca2$var$isInstance(b, Uint8Array)) b = $5fb01ac0df210ca2$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$5fb01ac0df210ca2$var$Buffer.isBuffer(a) || !$5fb01ac0df210ca2$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$5fb01ac0df210ca2$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$5fb01ac0df210ca2$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $5fb01ac0df210ca2$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $5fb01ac0df210ca2$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($5fb01ac0df210ca2$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$5fb01ac0df210ca2$var$Buffer.isBuffer(buf)) buf = $5fb01ac0df210ca2$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$5fb01ac0df210ca2$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $5fb01ac0df210ca2$var$byteLength(string, encoding) {
    if ($5fb01ac0df210ca2$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $5fb01ac0df210ca2$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $l0HdX._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $5fb01ac0df210ca2$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $5fb01ac0df210ca2$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $5fb01ac0df210ca2$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$5fb01ac0df210ca2$var$Buffer.byteLength = $5fb01ac0df210ca2$var$byteLength;
function $5fb01ac0df210ca2$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $5fb01ac0df210ca2$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $5fb01ac0df210ca2$var$utf8Slice(this, start, end);
        case "ascii":
            return $5fb01ac0df210ca2$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $5fb01ac0df210ca2$var$latin1Slice(this, start, end);
        case "base64":
            return $5fb01ac0df210ca2$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $5fb01ac0df210ca2$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$5fb01ac0df210ca2$var$Buffer.prototype._isBuffer = true;
function $5fb01ac0df210ca2$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$5fb01ac0df210ca2$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$5fb01ac0df210ca2$var$swap(this, i, i + 1);
    return this;
};
$5fb01ac0df210ca2$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $5fb01ac0df210ca2$var$swap(this, i, i + 3);
        $5fb01ac0df210ca2$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$5fb01ac0df210ca2$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $5fb01ac0df210ca2$var$swap(this, i, i + 7);
        $5fb01ac0df210ca2$var$swap(this, i + 1, i + 6);
        $5fb01ac0df210ca2$var$swap(this, i + 2, i + 5);
        $5fb01ac0df210ca2$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$5fb01ac0df210ca2$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $5fb01ac0df210ca2$var$utf8Slice(this, 0, length);
    return $5fb01ac0df210ca2$var$slowToString.apply(this, arguments);
};
$5fb01ac0df210ca2$var$Buffer.prototype.toLocaleString = $5fb01ac0df210ca2$var$Buffer.prototype.toString;
$5fb01ac0df210ca2$var$Buffer.prototype.equals = function equals(b) {
    if (!$5fb01ac0df210ca2$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $5fb01ac0df210ca2$var$Buffer.compare(this, b) === 0;
};
$5fb01ac0df210ca2$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $5fb01ac0df210ca2$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($5fb01ac0df210ca2$var$customInspectSymbol) $5fb01ac0df210ca2$var$Buffer.prototype[$5fb01ac0df210ca2$var$customInspectSymbol] = $5fb01ac0df210ca2$var$Buffer.prototype.inspect;
$5fb01ac0df210ca2$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($5fb01ac0df210ca2$var$isInstance(target, Uint8Array)) target = $5fb01ac0df210ca2$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$5fb01ac0df210ca2$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $l0HdX._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $5fb01ac0df210ca2$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($5fb01ac0df210ca2$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $5fb01ac0df210ca2$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($5fb01ac0df210ca2$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $5fb01ac0df210ca2$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $5fb01ac0df210ca2$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $5fb01ac0df210ca2$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$5fb01ac0df210ca2$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$5fb01ac0df210ca2$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $5fb01ac0df210ca2$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$5fb01ac0df210ca2$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $5fb01ac0df210ca2$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $5fb01ac0df210ca2$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($5fb01ac0df210ca2$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $5fb01ac0df210ca2$var$utf8Write(buf, string, offset, length) {
    return $5fb01ac0df210ca2$var$blitBuffer($5fb01ac0df210ca2$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $5fb01ac0df210ca2$var$asciiWrite(buf, string, offset, length) {
    return $5fb01ac0df210ca2$var$blitBuffer($5fb01ac0df210ca2$var$asciiToBytes(string), buf, offset, length);
}
function $5fb01ac0df210ca2$var$base64Write(buf, string, offset, length) {
    return $5fb01ac0df210ca2$var$blitBuffer($5fb01ac0df210ca2$var$base64ToBytes(string), buf, offset, length);
}
function $5fb01ac0df210ca2$var$ucs2Write(buf, string, offset, length) {
    return $5fb01ac0df210ca2$var$blitBuffer($5fb01ac0df210ca2$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$5fb01ac0df210ca2$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $5fb01ac0df210ca2$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $5fb01ac0df210ca2$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $5fb01ac0df210ca2$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $5fb01ac0df210ca2$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $5fb01ac0df210ca2$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$5fb01ac0df210ca2$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $5fb01ac0df210ca2$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $iB1U9.fromByteArray(buf);
    else return $iB1U9.fromByteArray(buf.slice(start, end));
}
function $5fb01ac0df210ca2$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $5fb01ac0df210ca2$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $5fb01ac0df210ca2$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $5fb01ac0df210ca2$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $5fb01ac0df210ca2$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $5fb01ac0df210ca2$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $5fb01ac0df210ca2$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $5fb01ac0df210ca2$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $5fb01ac0df210ca2$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $5fb01ac0df210ca2$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $5fb01ac0df210ca2$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$5fb01ac0df210ca2$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $5fb01ac0df210ca2$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $5fb01ac0df210ca2$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$5fb01ac0df210ca2$var$Buffer.prototype.readUintLE = $5fb01ac0df210ca2$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$5fb01ac0df210ca2$var$Buffer.prototype.readUintBE = $5fb01ac0df210ca2$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$5fb01ac0df210ca2$var$Buffer.prototype.readUint8 = $5fb01ac0df210ca2$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$5fb01ac0df210ca2$var$Buffer.prototype.readUint16LE = $5fb01ac0df210ca2$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$5fb01ac0df210ca2$var$Buffer.prototype.readUint16BE = $5fb01ac0df210ca2$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$5fb01ac0df210ca2$var$Buffer.prototype.readUint32LE = $5fb01ac0df210ca2$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$5fb01ac0df210ca2$var$Buffer.prototype.readUint32BE = $5fb01ac0df210ca2$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$5fb01ac0df210ca2$var$Buffer.prototype.readBigUInt64LE = $5fb01ac0df210ca2$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $5fb01ac0df210ca2$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $5fb01ac0df210ca2$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$5fb01ac0df210ca2$var$Buffer.prototype.readBigUInt64BE = $5fb01ac0df210ca2$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $5fb01ac0df210ca2$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $5fb01ac0df210ca2$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$5fb01ac0df210ca2$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$5fb01ac0df210ca2$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$5fb01ac0df210ca2$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$5fb01ac0df210ca2$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$5fb01ac0df210ca2$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$5fb01ac0df210ca2$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$5fb01ac0df210ca2$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$5fb01ac0df210ca2$var$Buffer.prototype.readBigInt64LE = $5fb01ac0df210ca2$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $5fb01ac0df210ca2$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $5fb01ac0df210ca2$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$5fb01ac0df210ca2$var$Buffer.prototype.readBigInt64BE = $5fb01ac0df210ca2$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $5fb01ac0df210ca2$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $5fb01ac0df210ca2$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$5fb01ac0df210ca2$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, 4, this.length);
    return $7ls3U.read(this, offset, true, 23, 4);
};
$5fb01ac0df210ca2$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, 4, this.length);
    return $7ls3U.read(this, offset, false, 23, 4);
};
$5fb01ac0df210ca2$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, 8, this.length);
    return $7ls3U.read(this, offset, true, 52, 8);
};
$5fb01ac0df210ca2$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkOffset(offset, 8, this.length);
    return $7ls3U.read(this, offset, false, 52, 8);
};
function $5fb01ac0df210ca2$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$5fb01ac0df210ca2$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$5fb01ac0df210ca2$var$Buffer.prototype.writeUintLE = $5fb01ac0df210ca2$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $5fb01ac0df210ca2$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$5fb01ac0df210ca2$var$Buffer.prototype.writeUintBE = $5fb01ac0df210ca2$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $5fb01ac0df210ca2$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$5fb01ac0df210ca2$var$Buffer.prototype.writeUint8 = $5fb01ac0df210ca2$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$5fb01ac0df210ca2$var$Buffer.prototype.writeUint16LE = $5fb01ac0df210ca2$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$5fb01ac0df210ca2$var$Buffer.prototype.writeUint16BE = $5fb01ac0df210ca2$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$5fb01ac0df210ca2$var$Buffer.prototype.writeUint32LE = $5fb01ac0df210ca2$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$5fb01ac0df210ca2$var$Buffer.prototype.writeUint32BE = $5fb01ac0df210ca2$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $5fb01ac0df210ca2$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $5fb01ac0df210ca2$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $5fb01ac0df210ca2$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $5fb01ac0df210ca2$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$5fb01ac0df210ca2$var$Buffer.prototype.writeBigUInt64LE = $5fb01ac0df210ca2$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $5fb01ac0df210ca2$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$5fb01ac0df210ca2$var$Buffer.prototype.writeBigUInt64BE = $5fb01ac0df210ca2$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $5fb01ac0df210ca2$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$5fb01ac0df210ca2$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $5fb01ac0df210ca2$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$5fb01ac0df210ca2$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $5fb01ac0df210ca2$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$5fb01ac0df210ca2$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$5fb01ac0df210ca2$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$5fb01ac0df210ca2$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$5fb01ac0df210ca2$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$5fb01ac0df210ca2$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$5fb01ac0df210ca2$var$Buffer.prototype.writeBigInt64LE = $5fb01ac0df210ca2$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $5fb01ac0df210ca2$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$5fb01ac0df210ca2$var$Buffer.prototype.writeBigInt64BE = $5fb01ac0df210ca2$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $5fb01ac0df210ca2$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $5fb01ac0df210ca2$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $5fb01ac0df210ca2$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7ls3U.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$5fb01ac0df210ca2$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $5fb01ac0df210ca2$var$writeFloat(this, value, offset, true, noAssert);
};
$5fb01ac0df210ca2$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $5fb01ac0df210ca2$var$writeFloat(this, value, offset, false, noAssert);
};
function $5fb01ac0df210ca2$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5fb01ac0df210ca2$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7ls3U.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$5fb01ac0df210ca2$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $5fb01ac0df210ca2$var$writeDouble(this, value, offset, true, noAssert);
};
$5fb01ac0df210ca2$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $5fb01ac0df210ca2$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$5fb01ac0df210ca2$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$5fb01ac0df210ca2$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$5fb01ac0df210ca2$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$5fb01ac0df210ca2$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $5fb01ac0df210ca2$var$Buffer.isBuffer(val) ? val : $5fb01ac0df210ca2$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $5fb01ac0df210ca2$var$errors = {};
function $5fb01ac0df210ca2$var$E(sym, getMessage, Base) {
    $5fb01ac0df210ca2$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $dcsZi._)(NodeError, Base);
        var _super = (0, $ohfOJ._)(NodeError);
        function NodeError() {
            (0, $4GJKx._)(this, NodeError);
            var _this;
            _this = _super.call(this);
            Object.defineProperty((0, $d3H5E._)(_this), "message", {
                value: getMessage.apply((0, $d3H5E._)(_this), arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $1wc17._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, "code", {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$5fb01ac0df210ca2$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$5fb01ac0df210ca2$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $l0HdX._)(actual));
}, TypeError);
$5fb01ac0df210ca2$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $5fb01ac0df210ca2$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $l0HdX._)(input)) === "bigint") {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $5fb01ac0df210ca2$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $5fb01ac0df210ca2$var$addNumericalSeparator(val) {
    var res = "";
    var i = val.length;
    var start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $5fb01ac0df210ca2$var$checkBounds(buf, offset, byteLength) {
    $5fb01ac0df210ca2$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $5fb01ac0df210ca2$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $5fb01ac0df210ca2$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $l0HdX._)(min)) === "bigint" ? "n" : "";
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $5fb01ac0df210ca2$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $5fb01ac0df210ca2$var$checkBounds(buf, offset, byteLength);
}
function $5fb01ac0df210ca2$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $5fb01ac0df210ca2$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $5fb01ac0df210ca2$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $5fb01ac0df210ca2$var$validateNumber(value, type);
        throw new $5fb01ac0df210ca2$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $5fb01ac0df210ca2$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $5fb01ac0df210ca2$var$errors.ERR_OUT_OF_RANGE(type || "offset", ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $5fb01ac0df210ca2$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $5fb01ac0df210ca2$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($5fb01ac0df210ca2$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $5fb01ac0df210ca2$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $5fb01ac0df210ca2$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $5fb01ac0df210ca2$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $5fb01ac0df210ca2$var$base64ToBytes(str) {
    return $iB1U9.toByteArray($5fb01ac0df210ca2$var$base64clean(str));
}
function $5fb01ac0df210ca2$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $5fb01ac0df210ca2$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $5fb01ac0df210ca2$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $5fb01ac0df210ca2$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $5fb01ac0df210ca2$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $5fb01ac0df210ca2$var$BufferBigIntNotDefined : fn;
}
function $5fb01ac0df210ca2$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("iB1U9", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $d89d28ee65638e83$export$d622b2ad8d90c771; }, function (v) { return $d89d28ee65638e83$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $d89d28ee65638e83$export$6100ba28696e12de; }, function (v) { return $d89d28ee65638e83$export$6100ba28696e12de = v; });
var $d89d28ee65638e83$export$a48f0734ac7c2329;
var $d89d28ee65638e83$export$d622b2ad8d90c771;
var $d89d28ee65638e83$export$6100ba28696e12de;
"use strict";
$d89d28ee65638e83$export$a48f0734ac7c2329 = $d89d28ee65638e83$var$byteLength;
$d89d28ee65638e83$export$d622b2ad8d90c771 = $d89d28ee65638e83$var$toByteArray;
$d89d28ee65638e83$export$6100ba28696e12de = $d89d28ee65638e83$var$fromByteArray;
var $d89d28ee65638e83$var$lookup = [];
var $d89d28ee65638e83$var$revLookup = [];
var $d89d28ee65638e83$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $d89d28ee65638e83$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $d89d28ee65638e83$var$i = 0, $d89d28ee65638e83$var$len = $d89d28ee65638e83$var$code.length; $d89d28ee65638e83$var$i < $d89d28ee65638e83$var$len; ++$d89d28ee65638e83$var$i){
    $d89d28ee65638e83$var$lookup[$d89d28ee65638e83$var$i] = $d89d28ee65638e83$var$code[$d89d28ee65638e83$var$i];
    $d89d28ee65638e83$var$revLookup[$d89d28ee65638e83$var$code.charCodeAt($d89d28ee65638e83$var$i)] = $d89d28ee65638e83$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$d89d28ee65638e83$var$revLookup["-".charCodeAt(0)] = 62;
$d89d28ee65638e83$var$revLookup["_".charCodeAt(0)] = 63;
function $d89d28ee65638e83$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $d89d28ee65638e83$var$byteLength(b64) {
    var lens = $d89d28ee65638e83$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $d89d28ee65638e83$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $d89d28ee65638e83$var$toByteArray(b64) {
    var tmp;
    var lens = $d89d28ee65638e83$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $d89d28ee65638e83$var$Arr($d89d28ee65638e83$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $d89d28ee65638e83$var$revLookup[b64.charCodeAt(i)] << 18 | $d89d28ee65638e83$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $d89d28ee65638e83$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $d89d28ee65638e83$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $d89d28ee65638e83$var$revLookup[b64.charCodeAt(i)] << 2 | $d89d28ee65638e83$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $d89d28ee65638e83$var$revLookup[b64.charCodeAt(i)] << 10 | $d89d28ee65638e83$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $d89d28ee65638e83$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $d89d28ee65638e83$var$tripletToBase64(num) {
    return $d89d28ee65638e83$var$lookup[num >> 18 & 0x3F] + $d89d28ee65638e83$var$lookup[num >> 12 & 0x3F] + $d89d28ee65638e83$var$lookup[num >> 6 & 0x3F] + $d89d28ee65638e83$var$lookup[num & 0x3F];
}
function $d89d28ee65638e83$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($d89d28ee65638e83$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $d89d28ee65638e83$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($d89d28ee65638e83$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($d89d28ee65638e83$var$lookup[tmp >> 2] + $d89d28ee65638e83$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($d89d28ee65638e83$var$lookup[tmp >> 10] + $d89d28ee65638e83$var$lookup[tmp >> 4 & 0x3F] + $d89d28ee65638e83$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("7ls3U", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $5590431cd58e8b92$export$aafa59e2e03f2942; }, function (v) { return $5590431cd58e8b92$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $5590431cd58e8b92$export$68d8715fc104d294; }, function (v) { return $5590431cd58e8b92$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $5590431cd58e8b92$export$aafa59e2e03f2942;
var $5590431cd58e8b92$export$68d8715fc104d294;
$5590431cd58e8b92$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$5590431cd58e8b92$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("74Iww", function(module, exports) {

$parcel$export(module.exports, "W3mFrame", function () { return $526b7197f0f290db$export$668e35d4f1b0aa08; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $3sHb8 = parcelRequire("3sHb8");

var $c6Xmf = parcelRequire("c6Xmf");

var $cSJ4o = parcelRequire("cSJ4o");

var $ai23K = parcelRequire("ai23K");

var $2ZXsZ = parcelRequire("2ZXsZ");
parcelRequire("dSKxG");
var $3QZC1 = parcelRequire("3QZC1");
var $526b7197f0f290db$export$668e35d4f1b0aa08 = /*#__PURE__*/ function() {
    "use strict";
    function W3mFrame(projectId) {
        var _this = this;
        var isAppClient = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, chainId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "eip155:1";
        (0, $4GJKx._)(this, W3mFrame);
        this.iframe = null;
        this.rpcUrl = (0, $3QZC1.ConstantsUtil).BLOCKCHAIN_API_RPC_URL;
        this.events = {
            registerFrameEventHandler: function(id, callback, signal) {
                function eventHandler(param) {
                    var data = param.data;
                    var _data_type;
                    if (!((_data_type = data.type) === null || _data_type === void 0 ? void 0 : _data_type.includes((0, $cSJ4o.W3mFrameConstants).FRAME_EVENT_KEY))) return;
                    var frameEvent = (0, $ai23K.W3mFrameSchema).frameEvent.parse(data);
                    if (frameEvent.id === id) {
                        callback(frameEvent);
                        window.removeEventListener("message", eventHandler);
                    }
                }
                if ((0, $2ZXsZ.W3mFrameHelpers).isClient) {
                    window.addEventListener("message", eventHandler);
                    signal.addEventListener("abort", function() {
                        window.removeEventListener("message", eventHandler);
                    });
                }
            },
            onFrameEvent: function(callback) {
                if ((0, $2ZXsZ.W3mFrameHelpers).isClient) window.addEventListener("message", function(param) {
                    var data = param.data;
                    var _data_type;
                    if (!((_data_type = data.type) === null || _data_type === void 0 ? void 0 : _data_type.includes((0, $cSJ4o.W3mFrameConstants).FRAME_EVENT_KEY))) return;
                    var frameEvent = (0, $ai23K.W3mFrameSchema).frameEvent.parse(data);
                    callback(frameEvent);
                });
            },
            onAppEvent: function(callback) {
                if ((0, $2ZXsZ.W3mFrameHelpers).isClient) window.addEventListener("message", function(param) {
                    var data = param.data;
                    var _data_type;
                    if (!((_data_type = data.type) === null || _data_type === void 0 ? void 0 : _data_type.includes((0, $cSJ4o.W3mFrameConstants).APP_EVENT_KEY))) return;
                    var appEvent = (0, $ai23K.W3mFrameSchema).appEvent.parse(data);
                    callback(appEvent);
                });
            },
            postAppEvent: function(event) {
                if ((0, $2ZXsZ.W3mFrameHelpers).isClient) {
                    var _this_iframe;
                    if (!((_this_iframe = _this.iframe) === null || _this_iframe === void 0 ? void 0 : _this_iframe.contentWindow)) throw new Error("W3mFrame: iframe is not set");
                    (0, $ai23K.W3mFrameSchema).appEvent.parse(event);
                    _this.iframe.contentWindow.postMessage(event, "*");
                }
            },
            postFrameEvent: function(event) {
                if ((0, $2ZXsZ.W3mFrameHelpers).isClient) {
                    if (!parent) throw new Error("W3mFrame: parent is not set");
                    (0, $ai23K.W3mFrameSchema).frameEvent.parse(event);
                    parent.postMessage(event, "*");
                }
            }
        };
        this.projectId = projectId;
        this.frameLoadPromise = new Promise(function(resolve, reject) {
            _this.frameLoadPromiseResolver = {
                resolve: resolve,
                reject: reject
            };
        });
        if (isAppClient) {
            this.frameLoadPromise = new Promise(function(resolve, reject) {
                _this.frameLoadPromiseResolver = {
                    resolve: resolve,
                    reject: reject
                };
            });
            if ((0, $2ZXsZ.W3mFrameHelpers).isClient) {
                var iframe = document.createElement("iframe");
                iframe.id = "w3m-iframe";
                iframe.src = "".concat((0, $cSJ4o.SECURE_SITE_SDK), "?projectId=").concat(projectId, "&chainId=").concat(chainId);
                iframe.name = "w3m-secure-iframe";
                iframe.style.position = "fixed";
                iframe.style.zIndex = "999999";
                iframe.style.display = "none";
                iframe.style.animationDelay = "0s, 50ms";
                iframe.style.borderBottomLeftRadius = "clamp(0px, var(--wui-border-radius-l), 44px)";
                iframe.style.borderBottomRightRadius = "clamp(0px, var(--wui-border-radius-l), 44px)";
                document.body.appendChild(iframe);
                this.iframe = iframe;
                this.iframe.onload = function() {
                    var _this_frameLoadPromiseResolver;
                    (_this_frameLoadPromiseResolver = _this.frameLoadPromiseResolver) === null || _this_frameLoadPromiseResolver === void 0 ? void 0 : _this_frameLoadPromiseResolver.resolve(undefined);
                };
                this.iframe.onerror = function() {
                    var _this_frameLoadPromiseResolver;
                    (_this_frameLoadPromiseResolver = _this.frameLoadPromiseResolver) === null || _this_frameLoadPromiseResolver === void 0 ? void 0 : _this_frameLoadPromiseResolver.reject("Unable to load email login dependency");
                };
            }
        }
    }
    (0, $1wc17._)(W3mFrame, [
        {
            key: "networks",
            get: function get() {
                var _this = this;
                var _Object;
                var data = [
                    "eip155:1",
                    "eip155:5",
                    "eip155:11155111",
                    "eip155:10",
                    "eip155:420",
                    "eip155:42161",
                    "eip155:421613",
                    "eip155:137",
                    "eip155:80001",
                    "eip155:42220",
                    "eip155:1313161554",
                    "eip155:1313161555",
                    "eip155:56",
                    "eip155:97",
                    "eip155:43114",
                    "eip155:43113",
                    "eip155:324",
                    "eip155:280",
                    "eip155:100",
                    "eip155:8453",
                    "eip155:84531",
                    "eip155:7777777",
                    "eip155:999",
                    "solana:5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp",
                    "solana:4uhcVJyU9pJkvQyS88uRDiswHXSCkY3z",
                    "solana:EtWTRABZaYq6iMfeYKouRu166VU2xqa1"
                ].map(function(id) {
                    return (0, $3sHb8._)({}, id, {
                        rpcUrl: "".concat(_this.rpcUrl, "/v1/?chainId=").concat(id, "&projectId=").concat(_this.projectId),
                        chainId: id
                    });
                });
                return (_Object = Object).assign.apply(_Object, [
                    {}
                ].concat((0, $c6Xmf._)(data)));
            }
        }
    ]);
    return W3mFrame;
}();

});
parcelRegister("cSJ4o", function(module, exports) {

$parcel$export(module.exports, "SECURE_SITE_SDK", function () { return $960d7d19f6ad7091$export$b36058160289df06; });
$parcel$export(module.exports, "DEFAULT_LOG_LEVEL", function () { return $960d7d19f6ad7091$export$97d4c6871900dcac; });
$parcel$export(module.exports, "W3mFrameConstants", function () { return $960d7d19f6ad7091$export$3ff97a7390ed49be; });
$parcel$export(module.exports, "W3mFrameRpcConstants", function () { return $960d7d19f6ad7091$export$9975694bfb286db; });
var $960d7d19f6ad7091$export$b36058160289df06 = "https://secure.walletconnect.org/sdk";
var $960d7d19f6ad7091$export$97d4c6871900dcac = "error";
var $960d7d19f6ad7091$export$3ff97a7390ed49be = {
    APP_EVENT_KEY: "@w3m-app/",
    FRAME_EVENT_KEY: "@w3m-frame/",
    RPC_METHOD_KEY: "RPC_",
    STORAGE_KEY: "@w3m-storage/",
    SESSION_TOKEN_KEY: "SESSION_TOKEN_KEY",
    EMAIL_LOGIN_USED_KEY: "EMAIL_LOGIN_USED_KEY",
    LAST_USED_CHAIN_KEY: "LAST_USED_CHAIN_KEY",
    LAST_EMAIL_LOGIN_TIME: "LAST_EMAIL_LOGIN_TIME",
    EMAIL: "EMAIL",
    PREFERRED_ACCOUNT_TYPE: "PREFERRED_ACCOUNT_TYPE",
    SMART_ACCOUNT_ENABLED: "SMART_ACCOUNT_ENABLED",
    SMART_ACCOUNT_ENABLED_NETWORKS: "SMART_ACCOUNT_ENABLED_NETWORKS",
    SOCIAL_USERNAME: "SOCIAL_USERNAME",
    SOCIAL: "@w3m/connected_social",
    APP_SWITCH_NETWORK: "@w3m-app/SWITCH_NETWORK",
    APP_CONNECT_EMAIL: "@w3m-app/CONNECT_EMAIL",
    APP_CONNECT_DEVICE: "@w3m-app/CONNECT_DEVICE",
    APP_CONNECT_OTP: "@w3m-app/CONNECT_OTP",
    APP_CONNECT_SOCIAL: "@w3m-app/CONNECT_SOCIAL",
    APP_GET_SOCIAL_REDIRECT_URI: "@w3m-app/GET_SOCIAL_REDIRECT_URI",
    APP_GET_USER: "@w3m-app/GET_USER",
    APP_SIGN_OUT: "@w3m-app/SIGN_OUT",
    APP_IS_CONNECTED: "@w3m-app/IS_CONNECTED",
    APP_GET_CHAIN_ID: "@w3m-app/GET_CHAIN_ID",
    APP_RPC_REQUEST: "@w3m-app/RPC_REQUEST",
    APP_UPDATE_EMAIL: "@w3m-app/UPDATE_EMAIL",
    APP_UPDATE_EMAIL_PRIMARY_OTP: "@w3m-app/UPDATE_EMAIL_PRIMARY_OTP",
    APP_UPDATE_EMAIL_SECONDARY_OTP: "@w3m-app/UPDATE_EMAIL_SECONDARY_OTP",
    APP_AWAIT_UPDATE_EMAIL: "@w3m-app/AWAIT_UPDATE_EMAIL",
    APP_SYNC_THEME: "@w3m-app/SYNC_THEME",
    APP_SYNC_DAPP_DATA: "@w3m-app/SYNC_DAPP_DATA",
    APP_GET_SMART_ACCOUNT_ENABLED_NETWORKS: "@w3m-app/GET_SMART_ACCOUNT_ENABLED_NETWORKS",
    APP_INIT_SMART_ACCOUNT: "@w3m-app/INIT_SMART_ACCOUNT",
    APP_SET_PREFERRED_ACCOUNT: "@w3m-app/SET_PREFERRED_ACCOUNT",
    APP_CONNECT_FARCASTER: "@w3m-app/CONNECT_FARCASTER",
    APP_GET_FARCASTER_URI: "@w3m-app/GET_FARCASTER_URI",
    FRAME_SWITCH_NETWORK_ERROR: "@w3m-frame/SWITCH_NETWORK_ERROR",
    FRAME_SWITCH_NETWORK_SUCCESS: "@w3m-frame/SWITCH_NETWORK_SUCCESS",
    FRAME_CONNECT_EMAIL_ERROR: "@w3m-frame/CONNECT_EMAIL_ERROR",
    FRAME_CONNECT_EMAIL_SUCCESS: "@w3m-frame/CONNECT_EMAIL_SUCCESS",
    FRAME_CONNECT_DEVICE_ERROR: "@w3m-frame/CONNECT_DEVICE_ERROR",
    FRAME_CONNECT_DEVICE_SUCCESS: "@w3m-frame/CONNECT_DEVICE_SUCCESS",
    FRAME_CONNECT_OTP_SUCCESS: "@w3m-frame/CONNECT_OTP_SUCCESS",
    FRAME_CONNECT_OTP_ERROR: "@w3m-frame/CONNECT_OTP_ERROR",
    FRAME_CONNECT_SOCIAL_SUCCESS: "@w3m-frame/CONNECT_SOCIAL_SUCCESS",
    FRAME_CONNECT_SOCIAL_ERROR: "@w3m-frame/CONNECT_SOCIAL_ERROR",
    FRAME_CONNECT_FARCASTER_SUCCESS: "@w3m-frame/CONNECT_FARCASTER_SUCCESS",
    FRAME_CONNECT_FARCASTER_ERROR: "@w3m-frame/CONNECT_FARCASTER_ERROR",
    FRAME_GET_FARCASTER_URI_SUCCESS: "@w3m-frame/GET_FARCASTER_URI_SUCCESS",
    FRAME_GET_FARCASTER_URI_ERROR: "@w3m-frame/GET_FARCASTER_URI_ERROR",
    FRAME_GET_SOCIAL_REDIRECT_URI_SUCCESS: "@w3m-frame/GET_SOCIAL_REDIRECT_URI_SUCCESS",
    FRAME_GET_SOCIAL_REDIRECT_URI_ERROR: "@w3m-frame/GET_SOCIAL_REDIRECT_URI_ERROR",
    FRAME_GET_USER_SUCCESS: "@w3m-frame/GET_USER_SUCCESS",
    FRAME_GET_USER_ERROR: "@w3m-frame/GET_USER_ERROR",
    FRAME_SIGN_OUT_SUCCESS: "@w3m-frame/SIGN_OUT_SUCCESS",
    FRAME_SIGN_OUT_ERROR: "@w3m-frame/SIGN_OUT_ERROR",
    FRAME_IS_CONNECTED_SUCCESS: "@w3m-frame/IS_CONNECTED_SUCCESS",
    FRAME_IS_CONNECTED_ERROR: "@w3m-frame/IS_CONNECTED_ERROR",
    FRAME_GET_CHAIN_ID_SUCCESS: "@w3m-frame/GET_CHAIN_ID_SUCCESS",
    FRAME_GET_CHAIN_ID_ERROR: "@w3m-frame/GET_CHAIN_ID_ERROR",
    FRAME_RPC_REQUEST_SUCCESS: "@w3m-frame/RPC_REQUEST_SUCCESS",
    FRAME_RPC_REQUEST_ERROR: "@w3m-frame/RPC_REQUEST_ERROR",
    FRAME_SESSION_UPDATE: "@w3m-frame/SESSION_UPDATE",
    FRAME_UPDATE_EMAIL_SUCCESS: "@w3m-frame/UPDATE_EMAIL_SUCCESS",
    FRAME_UPDATE_EMAIL_ERROR: "@w3m-frame/UPDATE_EMAIL_ERROR",
    FRAME_UPDATE_EMAIL_PRIMARY_OTP_SUCCESS: "@w3m-frame/UPDATE_EMAIL_PRIMARY_OTP_SUCCESS",
    FRAME_UPDATE_EMAIL_PRIMARY_OTP_ERROR: "@w3m-frame/UPDATE_EMAIL_PRIMARY_OTP_ERROR",
    FRAME_UPDATE_EMAIL_SECONDARY_OTP_SUCCESS: "@w3m-frame/UPDATE_EMAIL_SECONDARY_OTP_SUCCESS",
    FRAME_UPDATE_EMAIL_SECONDARY_OTP_ERROR: "@w3m-frame/UPDATE_EMAIL_SECONDARY_OTP_ERROR",
    FRAME_SYNC_THEME_SUCCESS: "@w3m-frame/SYNC_THEME_SUCCESS",
    FRAME_SYNC_THEME_ERROR: "@w3m-frame/SYNC_THEME_ERROR",
    FRAME_SYNC_DAPP_DATA_SUCCESS: "@w3m-frame/SYNC_DAPP_DATA_SUCCESS",
    FRAME_SYNC_DAPP_DATA_ERROR: "@w3m-frame/SYNC_DAPP_DATA_ERROR",
    FRAME_GET_SMART_ACCOUNT_ENABLED_NETWORKS_SUCCESS: "@w3m-frame/GET_SMART_ACCOUNT_ENABLED_NETWORKS_SUCCESS",
    FRAME_GET_SMART_ACCOUNT_ENABLED_NETWORKS_ERROR: "@w3m-frame/GET_SMART_ACCOUNT_ENABLED_NETWORKS_ERROR",
    FRAME_INIT_SMART_ACCOUNT_SUCCESS: "@w3m-frame/INIT_SMART_ACCOUNT_SUCCESS",
    FRAME_INIT_SMART_ACCOUNT_ERROR: "@w3m-frame/INIT_SMART_ACCOUNT_ERROR",
    FRAME_SET_PREFERRED_ACCOUNT_SUCCESS: "@w3m-frame/SET_PREFERRED_ACCOUNT_SUCCESS",
    FRAME_SET_PREFERRED_ACCOUNT_ERROR: "@w3m-frame/SET_PREFERRED_ACCOUNT_ERROR",
    RPC_RESPONSE_TYPE_ERROR: "RPC_RESPONSE_ERROR",
    RPC_RESPONSE_TYPE_TX: "RPC_RESPONSE_TRANSACTION_HASH",
    RPC_RESPONSE_TYPE_OBJECT: "RPC_RESPONSE_OBJECT"
};
var $960d7d19f6ad7091$export$9975694bfb286db = {
    SAFE_RPC_METHODS: [
        "eth_accounts",
        "eth_blockNumber",
        "eth_call",
        "eth_chainId",
        "eth_estimateGas",
        "eth_feeHistory",
        "eth_gasPrice",
        "eth_getAccount",
        "eth_getBalance",
        "eth_getBlockByHash",
        "eth_getBlockByNumber",
        "eth_getBlockReceipts",
        "eth_getBlockTransactionCountByHash",
        "eth_getBlockTransactionCountByNumber",
        "eth_getCode",
        "eth_getFilterChanges",
        "eth_getFilterLogs",
        "eth_getLogs",
        "eth_getProof",
        "eth_getStorageAt",
        "eth_getTransactionByBlockHashAndIndex",
        "eth_getTransactionByBlockNumberAndIndex",
        "eth_getTransactionByHash",
        "eth_getTransactionCount",
        "eth_getTransactionReceipt",
        "eth_getUncleCountByBlockHash",
        "eth_getUncleCountByBlockNumber",
        "eth_maxPriorityFeePerGas",
        "eth_newBlockFilter",
        "eth_newFilter",
        "eth_newPendingTransactionFilter",
        "eth_sendRawTransaction",
        "eth_syncing",
        "eth_uninstallFilter",
        "wallet_getCapabilities",
        "wallet_getCallsStatus"
    ],
    NOT_SAFE_RPC_METHODS: [
        "personal_sign",
        "eth_signTypedData_v4",
        "eth_sendTransaction",
        "solana_signMessage",
        "solana_signTransaction",
        "solana_signAndSendTransaction",
        "wallet_sendCalls",
        "wallet_grantPermissions"
    ],
    GET_CHAIN_ID: "eth_chainId",
    RPC_METHOD_NOT_ALLOWED_MESSAGE: "Requested RPC call is not allowed",
    RPC_METHOD_NOT_ALLOWED_UI_MESSAGE: "Action not allowed",
    ACCOUNT_TYPES: {
        EOA: "eoa",
        SMART_ACCOUNT: "smartAccount"
    }
};

});

parcelRegister("ai23K", function(module, exports) {

$parcel$export(module.exports, "W3mFrameSchema", function () { return $77dd2ecc68fb6bb1$export$238f9986c2bb1b9a; });

var $jZoZ7 = parcelRequire("jZoZ7");

var $cSJ4o = parcelRequire("cSJ4o");
var $77dd2ecc68fb6bb1$var$zError = (0, $jZoZ7.z).object({
    message: (0, $jZoZ7.z).string()
});
function $77dd2ecc68fb6bb1$var$zType(key) {
    return (0, $jZoZ7.z).literal((0, $cSJ4o.W3mFrameConstants)[key]);
}
var $77dd2ecc68fb6bb1$export$89415e8e09b5a4e0 = (0, $jZoZ7.z).object({
    accessList: (0, $jZoZ7.z).array((0, $jZoZ7.z).string()),
    blockHash: (0, $jZoZ7.z).string().nullable(),
    blockNumber: (0, $jZoZ7.z).string().nullable(),
    chainId: (0, $jZoZ7.z).string().or((0, $jZoZ7.z).number()),
    from: (0, $jZoZ7.z).string(),
    gas: (0, $jZoZ7.z).string(),
    hash: (0, $jZoZ7.z).string(),
    input: (0, $jZoZ7.z).string().nullable(),
    maxFeePerGas: (0, $jZoZ7.z).string(),
    maxPriorityFeePerGas: (0, $jZoZ7.z).string(),
    nonce: (0, $jZoZ7.z).string(),
    r: (0, $jZoZ7.z).string(),
    s: (0, $jZoZ7.z).string(),
    to: (0, $jZoZ7.z).string(),
    transactionIndex: (0, $jZoZ7.z).string().nullable(),
    type: (0, $jZoZ7.z).string(),
    v: (0, $jZoZ7.z).string(),
    value: (0, $jZoZ7.z).string()
});
var $77dd2ecc68fb6bb1$export$6f296c19518f2ab2 = (0, $jZoZ7.z).object({
    chainId: (0, $jZoZ7.z).string().or((0, $jZoZ7.z).number())
});
var $77dd2ecc68fb6bb1$export$976f191ce42ce5be = (0, $jZoZ7.z).object({
    email: (0, $jZoZ7.z).string().email()
});
var $77dd2ecc68fb6bb1$export$3c60c26d0e7c7485 = (0, $jZoZ7.z).object({
    otp: (0, $jZoZ7.z).string()
});
var $77dd2ecc68fb6bb1$export$b4cf8f9e803c0857 = (0, $jZoZ7.z).object({
    uri: (0, $jZoZ7.z).string()
});
var $77dd2ecc68fb6bb1$export$2b55edadc32e688a = (0, $jZoZ7.z).object({
    chainId: (0, $jZoZ7.z).optional((0, $jZoZ7.z).string().or((0, $jZoZ7.z).number())),
    preferredAccountType: (0, $jZoZ7.z).optional((0, $jZoZ7.z).string())
});
var $77dd2ecc68fb6bb1$export$9d16112af534cfa2 = (0, $jZoZ7.z).object({
    provider: (0, $jZoZ7.z).enum([
        "google",
        "github",
        "apple",
        "facebook",
        "x",
        "discord"
    ])
});
var $77dd2ecc68fb6bb1$export$65e6e56482b6df27 = (0, $jZoZ7.z).object({
    email: (0, $jZoZ7.z).string().email()
});
var $77dd2ecc68fb6bb1$export$63ec130352b88085 = (0, $jZoZ7.z).object({
    otp: (0, $jZoZ7.z).string()
});
var $77dd2ecc68fb6bb1$export$cbb50d2392bf53e2 = (0, $jZoZ7.z).object({
    otp: (0, $jZoZ7.z).string()
});
var $77dd2ecc68fb6bb1$export$c523bb85fd166f04 = (0, $jZoZ7.z).object({
    themeMode: (0, $jZoZ7.z).optional((0, $jZoZ7.z).enum([
        "light",
        "dark"
    ])),
    themeVariables: (0, $jZoZ7.z).optional((0, $jZoZ7.z).record((0, $jZoZ7.z).string(), (0, $jZoZ7.z).string().or((0, $jZoZ7.z).number()))),
    w3mThemeVariables: (0, $jZoZ7.z).optional((0, $jZoZ7.z).record((0, $jZoZ7.z).string(), (0, $jZoZ7.z).string()))
});
var $77dd2ecc68fb6bb1$export$4ca9ea890e921270 = (0, $jZoZ7.z).object({
    metadata: (0, $jZoZ7.z).object({
        name: (0, $jZoZ7.z).string(),
        description: (0, $jZoZ7.z).string(),
        url: (0, $jZoZ7.z).string(),
        icons: (0, $jZoZ7.z).array((0, $jZoZ7.z).string())
    }).optional(),
    sdkVersion: (0, $jZoZ7.z).string(),
    projectId: (0, $jZoZ7.z).string()
});
var $77dd2ecc68fb6bb1$export$9cebfb60f9fcc35b = (0, $jZoZ7.z).object({
    type: (0, $jZoZ7.z).string()
});
var $77dd2ecc68fb6bb1$export$333a7bf9d10b914 = (0, $jZoZ7.z).object({
    action: (0, $jZoZ7.z).enum([
        "VERIFY_DEVICE",
        "VERIFY_OTP"
    ])
});
var $77dd2ecc68fb6bb1$export$da46d112c20de897 = (0, $jZoZ7.z).object({
    url: (0, $jZoZ7.z).string()
});
var $77dd2ecc68fb6bb1$export$e3d16386f65b39d3 = (0, $jZoZ7.z).object({
    userName: (0, $jZoZ7.z).string()
});
var $77dd2ecc68fb6bb1$export$9f099747f910622d = (0, $jZoZ7.z).object({
    email: (0, $jZoZ7.z).string(),
    address: (0, $jZoZ7.z).string(),
    chainId: (0, $jZoZ7.z).string().or((0, $jZoZ7.z).number()),
    accounts: (0, $jZoZ7.z).array((0, $jZoZ7.z).object({
        address: (0, $jZoZ7.z).string(),
        type: (0, $jZoZ7.z).enum([
            (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.EOA,
            (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT
        ])
    })).optional(),
    userName: (0, $jZoZ7.z).string().optional()
});
var $77dd2ecc68fb6bb1$export$14285ffeae37d072 = (0, $jZoZ7.z).object({
    action: (0, $jZoZ7.z).enum([
        "VERIFY_PRIMARY_OTP",
        "VERIFY_SECONDARY_OTP"
    ])
});
var $77dd2ecc68fb6bb1$export$2d6662dda0084b61 = (0, $jZoZ7.z).object({
    email: (0, $jZoZ7.z).string().email().optional().nullable(),
    address: (0, $jZoZ7.z).string(),
    chainId: (0, $jZoZ7.z).string().or((0, $jZoZ7.z).number()),
    smartAccountDeployed: (0, $jZoZ7.z).optional((0, $jZoZ7.z).boolean()),
    accounts: (0, $jZoZ7.z).array((0, $jZoZ7.z).object({
        address: (0, $jZoZ7.z).string(),
        type: (0, $jZoZ7.z).enum([
            (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.EOA,
            (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT
        ])
    })).optional(),
    preferredAccountType: (0, $jZoZ7.z).optional((0, $jZoZ7.z).string())
});
var $77dd2ecc68fb6bb1$export$37bc618e26a3f46 = (0, $jZoZ7.z).object({
    uri: (0, $jZoZ7.z).string()
});
var $77dd2ecc68fb6bb1$export$775a450ce21f8fdf = (0, $jZoZ7.z).object({
    isConnected: (0, $jZoZ7.z).boolean()
});
var $77dd2ecc68fb6bb1$export$245abc04f43df573 = (0, $jZoZ7.z).object({
    chainId: (0, $jZoZ7.z).string().or((0, $jZoZ7.z).number())
});
var $77dd2ecc68fb6bb1$export$178941fe9bfa6200 = (0, $jZoZ7.z).object({
    chainId: (0, $jZoZ7.z).string().or((0, $jZoZ7.z).number())
});
var $77dd2ecc68fb6bb1$export$d31a2d4d5f5aa2cd = (0, $jZoZ7.z).object({
    newEmail: (0, $jZoZ7.z).string().email()
});
var $77dd2ecc68fb6bb1$export$31b27be58286b84c = (0, $jZoZ7.z).object({
    smartAccountEnabledNetworks: (0, $jZoZ7.z).array((0, $jZoZ7.z).number())
});
var $77dd2ecc68fb6bb1$export$b8e958c03766c98e = (0, $jZoZ7.z).object({
    address: (0, $jZoZ7.z).string(),
    isDeployed: (0, $jZoZ7.z).boolean()
});
var $77dd2ecc68fb6bb1$export$258085d3b41c15d5 = (0, $jZoZ7.z).object({
    type: (0, $jZoZ7.z).string(),
    address: (0, $jZoZ7.z).string()
});
var $77dd2ecc68fb6bb1$export$d4ce1c0118069cf6 = (0, $jZoZ7.z).any();
var $77dd2ecc68fb6bb1$export$333c606c26a06359 = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_accounts")
});
var $77dd2ecc68fb6bb1$export$ed481a6ef87fb1a4 = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_blockNumber")
});
var $77dd2ecc68fb6bb1$export$3746f30d5256aebc = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_call"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).any())
});
var $77dd2ecc68fb6bb1$export$ced6b8fef5e3a1ae = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_chainId")
});
var $77dd2ecc68fb6bb1$export$272161a7d614a7de = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_estimateGas"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).any())
});
var $77dd2ecc68fb6bb1$export$601d25f8f10fb73e = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_feeHistory"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).any())
});
var $77dd2ecc68fb6bb1$export$375f72aea2abe32f = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_gasPrice")
});
var $77dd2ecc68fb6bb1$export$5781e194c9800107 = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_getAccount"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).any())
});
var $77dd2ecc68fb6bb1$export$e8c54d0244516318 = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_getBalance"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).any())
});
var $77dd2ecc68fb6bb1$export$ed296586d8ca73e5 = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_getBlockByHash"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).any())
});
var $77dd2ecc68fb6bb1$export$5930d1a65f85cd1c = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_getBlockByNumber"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).any())
});
var $77dd2ecc68fb6bb1$export$728754e9b5ce598 = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_getBlockReceipts"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).any())
});
var $77dd2ecc68fb6bb1$export$4ddab575d344fe47 = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_getBlockTransactionCountByHash"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).any())
});
var $77dd2ecc68fb6bb1$export$3a9707a1a95b758c = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_getBlockTransactionCountByNumber"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).any())
});
var $77dd2ecc68fb6bb1$export$32d3decd99b4e77c = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_getCode"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).any())
});
var $77dd2ecc68fb6bb1$export$70385be35bb1c094 = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_getFilterChanges"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).any())
});
var $77dd2ecc68fb6bb1$export$67adfcd98750c2a4 = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_getFilterLogs"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).any())
});
var $77dd2ecc68fb6bb1$export$ec85b0f99f3b0860 = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_getLogs"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).any())
});
var $77dd2ecc68fb6bb1$export$aad1bb370c749036 = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_getProof"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).any())
});
var $77dd2ecc68fb6bb1$export$de118eb57c7e99ee = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_getStorageAt"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).any())
});
var $77dd2ecc68fb6bb1$export$925a4185b30091ca = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_getTransactionByBlockHashAndIndex"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).any())
});
var $77dd2ecc68fb6bb1$export$132e327b9ac8100f = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_getTransactionByBlockNumberAndIndex"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).any())
});
var $77dd2ecc68fb6bb1$export$b498be03499c3270 = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_getTransactionByHash"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).any())
});
var $77dd2ecc68fb6bb1$export$8e3ae636de98a13f = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_getTransactionCount"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).any())
});
var $77dd2ecc68fb6bb1$export$ebf4091cc6dfa2ef = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_getTransactionReceipt"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).any())
});
var $77dd2ecc68fb6bb1$export$a9e565a5951dbda1 = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_getUncleCountByBlockHash"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).any())
});
var $77dd2ecc68fb6bb1$export$3e72b948c8cdb33b = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_getUncleCountByBlockNumber"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).any())
});
var $77dd2ecc68fb6bb1$export$35da6e194885ea4f = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_maxPriorityFeePerGas")
});
var $77dd2ecc68fb6bb1$export$f2d7c90f3596d13e = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_newBlockFilter")
});
var $77dd2ecc68fb6bb1$export$f6ccc436669a288e = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_newFilter"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).any())
});
var $77dd2ecc68fb6bb1$export$299d889501e7632c = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_newPendingTransactionFilter")
});
var $77dd2ecc68fb6bb1$export$2f01b91caa317491 = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_sendRawTransaction"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).any())
});
var $77dd2ecc68fb6bb1$export$688f7a1e4924e71b = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_syncing"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).any())
});
var $77dd2ecc68fb6bb1$export$1cc394e8ef03e09a = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_uninstallFilter"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).any())
});
var $77dd2ecc68fb6bb1$export$57dc995d18380851 = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("personal_sign"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).any())
});
var $77dd2ecc68fb6bb1$export$98d6e3ae5e5869d0 = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_signTypedData_v4"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).any())
});
var $77dd2ecc68fb6bb1$export$fc4f4bb7f991c8e0 = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("eth_sendTransaction"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).any())
});
var $77dd2ecc68fb6bb1$export$d91e2474cd16d70d = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("solana_signMessage"),
    params: (0, $jZoZ7.z).object({
        message: (0, $jZoZ7.z).string(),
        pubkey: (0, $jZoZ7.z).string()
    })
});
var $77dd2ecc68fb6bb1$export$11543edd53c7f4cb = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("solana_signTransaction"),
    params: (0, $jZoZ7.z).object({
        transaction: (0, $jZoZ7.z).string()
    })
});
var $77dd2ecc68fb6bb1$export$655852added10635 = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("solana_signAndSendTransaction"),
    params: (0, $jZoZ7.z).object({
        transaction: (0, $jZoZ7.z).string(),
        options: (0, $jZoZ7.z).object({
            skipPreflight: (0, $jZoZ7.z).boolean().optional(),
            preflightCommitment: (0, $jZoZ7.z).enum([
                "processed",
                "confirmed",
                "finalized",
                "recent",
                "single",
                "singleGossip",
                "root",
                "max"
            ]).optional(),
            maxRetries: (0, $jZoZ7.z).number().optional(),
            minContextSlot: (0, $jZoZ7.z).number().optional()
        }).optional()
    })
});
var $77dd2ecc68fb6bb1$export$22abffcfa04dcf81 = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("wallet_sendCalls"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).object({
        chainId: (0, $jZoZ7.z).string().or((0, $jZoZ7.z).number()).optional(),
        from: (0, $jZoZ7.z).string().optional(),
        version: (0, $jZoZ7.z).string().optional(),
        capabilities: (0, $jZoZ7.z).any().optional(),
        calls: (0, $jZoZ7.z).array((0, $jZoZ7.z).object({
            to: (0, $jZoZ7.z).string().startsWith("0x"),
            data: (0, $jZoZ7.z).string().startsWith("0x").optional(),
            value: (0, $jZoZ7.z).string().optional()
        }))
    }))
});
var $77dd2ecc68fb6bb1$export$81a313f8ca8f6f80 = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("wallet_getCallsStatus"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).string())
});
var $77dd2ecc68fb6bb1$export$193ba0334adb9ab5 = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("wallet_getCapabilities")
});
var $77dd2ecc68fb6bb1$export$b5e7f5679b9a54bb = (0, $jZoZ7.z).object({
    method: (0, $jZoZ7.z).literal("wallet_grantPermissions"),
    params: (0, $jZoZ7.z).array((0, $jZoZ7.z).any())
});
var $77dd2ecc68fb6bb1$export$583fad842749c757 = (0, $jZoZ7.z).object({
    token: (0, $jZoZ7.z).string()
});
var $77dd2ecc68fb6bb1$export$769a4ec051ed522c = (0, $jZoZ7.z).object({
    id: (0, $jZoZ7.z).string().optional()
});
var $77dd2ecc68fb6bb1$export$238f9986c2bb1b9a = {
    appEvent: $77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("APP_SWITCH_NETWORK"),
        payload: $77dd2ecc68fb6bb1$export$6f296c19518f2ab2
    }).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("APP_CONNECT_EMAIL"),
        payload: $77dd2ecc68fb6bb1$export$976f191ce42ce5be
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("APP_CONNECT_DEVICE")
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("APP_CONNECT_OTP"),
        payload: $77dd2ecc68fb6bb1$export$3c60c26d0e7c7485
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("APP_CONNECT_SOCIAL"),
        payload: $77dd2ecc68fb6bb1$export$b4cf8f9e803c0857
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("APP_GET_FARCASTER_URI")
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("APP_CONNECT_FARCASTER")
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("APP_GET_USER"),
        payload: (0, $jZoZ7.z).optional($77dd2ecc68fb6bb1$export$2b55edadc32e688a)
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("APP_GET_SOCIAL_REDIRECT_URI"),
        payload: $77dd2ecc68fb6bb1$export$9d16112af534cfa2
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("APP_SIGN_OUT")
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("APP_IS_CONNECTED"),
        payload: (0, $jZoZ7.z).optional($77dd2ecc68fb6bb1$export$583fad842749c757)
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("APP_GET_CHAIN_ID")
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("APP_GET_SMART_ACCOUNT_ENABLED_NETWORKS")
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("APP_INIT_SMART_ACCOUNT")
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("APP_SET_PREFERRED_ACCOUNT"),
        payload: $77dd2ecc68fb6bb1$export$9cebfb60f9fcc35b
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("APP_RPC_REQUEST"),
        payload: $77dd2ecc68fb6bb1$export$57dc995d18380851.or($77dd2ecc68fb6bb1$export$fc4f4bb7f991c8e0).or($77dd2ecc68fb6bb1$export$333c606c26a06359).or($77dd2ecc68fb6bb1$export$ed481a6ef87fb1a4).or($77dd2ecc68fb6bb1$export$3746f30d5256aebc).or($77dd2ecc68fb6bb1$export$ced6b8fef5e3a1ae).or($77dd2ecc68fb6bb1$export$272161a7d614a7de).or($77dd2ecc68fb6bb1$export$601d25f8f10fb73e).or($77dd2ecc68fb6bb1$export$375f72aea2abe32f).or($77dd2ecc68fb6bb1$export$5781e194c9800107).or($77dd2ecc68fb6bb1$export$e8c54d0244516318).or($77dd2ecc68fb6bb1$export$ed296586d8ca73e5).or($77dd2ecc68fb6bb1$export$5930d1a65f85cd1c).or($77dd2ecc68fb6bb1$export$728754e9b5ce598).or($77dd2ecc68fb6bb1$export$4ddab575d344fe47).or($77dd2ecc68fb6bb1$export$3a9707a1a95b758c).or($77dd2ecc68fb6bb1$export$32d3decd99b4e77c).or($77dd2ecc68fb6bb1$export$70385be35bb1c094).or($77dd2ecc68fb6bb1$export$67adfcd98750c2a4).or($77dd2ecc68fb6bb1$export$ec85b0f99f3b0860).or($77dd2ecc68fb6bb1$export$aad1bb370c749036).or($77dd2ecc68fb6bb1$export$de118eb57c7e99ee).or($77dd2ecc68fb6bb1$export$925a4185b30091ca).or($77dd2ecc68fb6bb1$export$132e327b9ac8100f).or($77dd2ecc68fb6bb1$export$b498be03499c3270).or($77dd2ecc68fb6bb1$export$8e3ae636de98a13f).or($77dd2ecc68fb6bb1$export$ebf4091cc6dfa2ef).or($77dd2ecc68fb6bb1$export$a9e565a5951dbda1).or($77dd2ecc68fb6bb1$export$3e72b948c8cdb33b).or($77dd2ecc68fb6bb1$export$35da6e194885ea4f).or($77dd2ecc68fb6bb1$export$f2d7c90f3596d13e).or($77dd2ecc68fb6bb1$export$f6ccc436669a288e).or($77dd2ecc68fb6bb1$export$299d889501e7632c).or($77dd2ecc68fb6bb1$export$2f01b91caa317491).or($77dd2ecc68fb6bb1$export$688f7a1e4924e71b).or($77dd2ecc68fb6bb1$export$1cc394e8ef03e09a).or($77dd2ecc68fb6bb1$export$57dc995d18380851).or($77dd2ecc68fb6bb1$export$98d6e3ae5e5869d0).or($77dd2ecc68fb6bb1$export$fc4f4bb7f991c8e0).or($77dd2ecc68fb6bb1$export$d91e2474cd16d70d).or($77dd2ecc68fb6bb1$export$11543edd53c7f4cb).or($77dd2ecc68fb6bb1$export$655852added10635).or($77dd2ecc68fb6bb1$export$81a313f8ca8f6f80).or($77dd2ecc68fb6bb1$export$22abffcfa04dcf81).or($77dd2ecc68fb6bb1$export$193ba0334adb9ab5).or($77dd2ecc68fb6bb1$export$b5e7f5679b9a54bb)
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("APP_UPDATE_EMAIL"),
        payload: $77dd2ecc68fb6bb1$export$65e6e56482b6df27
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("APP_UPDATE_EMAIL_PRIMARY_OTP"),
        payload: $77dd2ecc68fb6bb1$export$63ec130352b88085
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("APP_UPDATE_EMAIL_SECONDARY_OTP"),
        payload: $77dd2ecc68fb6bb1$export$cbb50d2392bf53e2
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("APP_SYNC_THEME"),
        payload: $77dd2ecc68fb6bb1$export$c523bb85fd166f04
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("APP_SYNC_DAPP_DATA"),
        payload: $77dd2ecc68fb6bb1$export$4ca9ea890e921270
    })),
    frameEvent: $77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_SWITCH_NETWORK_ERROR"),
        payload: $77dd2ecc68fb6bb1$var$zError
    }).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_SWITCH_NETWORK_SUCCESS"),
        payload: $77dd2ecc68fb6bb1$export$178941fe9bfa6200
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_CONNECT_EMAIL_SUCCESS"),
        payload: $77dd2ecc68fb6bb1$export$333a7bf9d10b914
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_CONNECT_EMAIL_ERROR"),
        payload: $77dd2ecc68fb6bb1$var$zError
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_GET_FARCASTER_URI_SUCCESS"),
        payload: $77dd2ecc68fb6bb1$export$da46d112c20de897
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_GET_FARCASTER_URI_ERROR"),
        payload: $77dd2ecc68fb6bb1$var$zError
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_CONNECT_FARCASTER_SUCCESS"),
        payload: $77dd2ecc68fb6bb1$export$e3d16386f65b39d3
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_CONNECT_FARCASTER_ERROR"),
        payload: $77dd2ecc68fb6bb1$var$zError
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_CONNECT_OTP_ERROR"),
        payload: $77dd2ecc68fb6bb1$var$zError
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_CONNECT_OTP_SUCCESS")
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_CONNECT_DEVICE_ERROR"),
        payload: $77dd2ecc68fb6bb1$var$zError
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_CONNECT_DEVICE_SUCCESS")
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_CONNECT_SOCIAL_SUCCESS"),
        payload: $77dd2ecc68fb6bb1$export$9f099747f910622d
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_CONNECT_SOCIAL_ERROR"),
        payload: $77dd2ecc68fb6bb1$var$zError
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_GET_USER_ERROR"),
        payload: $77dd2ecc68fb6bb1$var$zError
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_GET_USER_SUCCESS"),
        payload: $77dd2ecc68fb6bb1$export$2d6662dda0084b61
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_GET_SOCIAL_REDIRECT_URI_ERROR"),
        payload: $77dd2ecc68fb6bb1$var$zError
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_GET_SOCIAL_REDIRECT_URI_SUCCESS"),
        payload: $77dd2ecc68fb6bb1$export$37bc618e26a3f46
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_SIGN_OUT_ERROR"),
        payload: $77dd2ecc68fb6bb1$var$zError
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_SIGN_OUT_SUCCESS")
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_IS_CONNECTED_ERROR"),
        payload: $77dd2ecc68fb6bb1$var$zError
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_IS_CONNECTED_SUCCESS"),
        payload: $77dd2ecc68fb6bb1$export$775a450ce21f8fdf
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_GET_CHAIN_ID_ERROR"),
        payload: $77dd2ecc68fb6bb1$var$zError
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_GET_CHAIN_ID_SUCCESS"),
        payload: $77dd2ecc68fb6bb1$export$245abc04f43df573
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_RPC_REQUEST_ERROR"),
        payload: $77dd2ecc68fb6bb1$var$zError
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_RPC_REQUEST_SUCCESS"),
        payload: $77dd2ecc68fb6bb1$export$d4ce1c0118069cf6
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_SESSION_UPDATE"),
        payload: $77dd2ecc68fb6bb1$export$583fad842749c757
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_UPDATE_EMAIL_ERROR"),
        payload: $77dd2ecc68fb6bb1$var$zError
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_UPDATE_EMAIL_SUCCESS"),
        payload: $77dd2ecc68fb6bb1$export$14285ffeae37d072
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_UPDATE_EMAIL_PRIMARY_OTP_ERROR"),
        payload: $77dd2ecc68fb6bb1$var$zError
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_UPDATE_EMAIL_PRIMARY_OTP_SUCCESS")
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_UPDATE_EMAIL_SECONDARY_OTP_ERROR"),
        payload: $77dd2ecc68fb6bb1$var$zError
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_UPDATE_EMAIL_SECONDARY_OTP_SUCCESS"),
        payload: $77dd2ecc68fb6bb1$export$d31a2d4d5f5aa2cd
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_SYNC_THEME_ERROR"),
        payload: $77dd2ecc68fb6bb1$var$zError
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_SYNC_THEME_SUCCESS")
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_SYNC_DAPP_DATA_ERROR"),
        payload: $77dd2ecc68fb6bb1$var$zError
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_SYNC_DAPP_DATA_SUCCESS")
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_GET_SMART_ACCOUNT_ENABLED_NETWORKS_SUCCESS"),
        payload: $77dd2ecc68fb6bb1$export$31b27be58286b84c
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_GET_SMART_ACCOUNT_ENABLED_NETWORKS_ERROR"),
        payload: $77dd2ecc68fb6bb1$var$zError
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_INIT_SMART_ACCOUNT_ERROR"),
        payload: $77dd2ecc68fb6bb1$var$zError
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_SET_PREFERRED_ACCOUNT_SUCCESS"),
        payload: $77dd2ecc68fb6bb1$export$258085d3b41c15d5
    })).or($77dd2ecc68fb6bb1$export$769a4ec051ed522c.extend({
        type: $77dd2ecc68fb6bb1$var$zType("FRAME_SET_PREFERRED_ACCOUNT_ERROR"),
        payload: $77dd2ecc68fb6bb1$var$zError
    }))
};

});
parcelRegister("jZoZ7", function(module, exports) {

$parcel$export(module.exports, "z", function () { return z; });

var $d3H5E = parcelRequire("d3H5E");

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $3sHb8 = parcelRequire("3sHb8");

var $dcsZi = parcelRequire("dcsZi");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $l0HdX = parcelRequire("l0HdX");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
var util;
(function(util) {
    util.assertEqual = function(val) {
        return val;
    };
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = function(items) {
        var obj = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                obj[item] = item;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return obj;
    };
    util.getValidEnumValues = function(obj) {
        var validKeys = util.objectKeys(obj).filter(function(k) {
            return typeof obj[obj[k]] !== "number";
        });
        var filtered = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = validKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var k = _step.value;
                filtered[k] = obj[k];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return util.objectValues(filtered);
    };
    util.objectValues = function(obj) {
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? function(obj) {
        return Object.keys(obj) // eslint-disable-line ban/ban
        ;
    } : function(object) {
        var keys = [];
        for(var key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = function(arr, checker) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = arr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                if (checker(item)) return item;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? function(val) {
        return Number.isInteger(val) // eslint-disable-line ban/ban
        ;
    } : function(val) {
        return typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    };
    function joinValues(array) {
        var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : " | ";
        return array.map(function(val) {
            return typeof val === "string" ? "'".concat(val, "'") : val;
        }).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = function(_, value) {
        if ((typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value)) === "bigint") return value.toString();
        return value;
    };
})(util || (util = {}));
var objectUtil;
(function(objectUtil) {
    objectUtil.mergeShapes = function(first, second) {
        return (0, $do9pw._)({}, first, second);
    };
})(objectUtil || (objectUtil = {}));
var ZodParsedType = util.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
var getParsedType = function(data) {
    var t = typeof data === "undefined" ? "undefined" : (0, $l0HdX._)(data);
    switch(t){
        case "undefined":
            return ZodParsedType.undefined;
        case "string":
            return ZodParsedType.string;
        case "number":
            return isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
        case "boolean":
            return ZodParsedType.boolean;
        case "function":
            return ZodParsedType.function;
        case "bigint":
            return ZodParsedType.bigint;
        case "symbol":
            return ZodParsedType.symbol;
        case "object":
            if (Array.isArray(data)) return ZodParsedType.array;
            if (data === null) return ZodParsedType.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return ZodParsedType.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return ZodParsedType.map;
            if (typeof Set !== "undefined" && data instanceof Set) return ZodParsedType.set;
            if (typeof Date !== "undefined" && data instanceof Date) return ZodParsedType.date;
            return ZodParsedType.object;
        default:
            return ZodParsedType.unknown;
    }
};
var ZodIssueCode = util.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
var quotelessJson = function(obj) {
    var json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
var ZodError = /*#__PURE__*/ function _target(Error1) {
    "use strict";
    (0, $dcsZi._)(ZodError, Error1);
    var _super = (0, $ohfOJ._)(ZodError);
    function ZodError(issues) {
        (0, $4GJKx._)(this, ZodError);
        var _this;
        _this = _super.call(this);
        _this.issues = [];
        _this.addIssue = function(sub) {
            _this.issues = (0, $c6Xmf._)(_this.issues).concat([
                sub
            ]);
        };
        _this.addIssues = function() {
            var subs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
            _this.issues = (0, $c6Xmf._)(_this.issues).concat((0, $c6Xmf._)(subs));
        };
        var actualProto = (this instanceof ZodError ? this.constructor : void 0).prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf((0, $d3H5E._)(_this), actualProto);
        else _this.__proto__ = actualProto;
        _this.name = "ZodError";
        _this.issues = issues;
        return _this;
    }
    (0, $1wc17._)(ZodError, [
        {
            key: "errors",
            get: function get() {
                return this.issues;
            }
        },
        {
            key: "format",
            value: function format(_mapper) {
                var mapper = _mapper || function(issue) {
                    return issue.message;
                };
                var fieldErrors = {
                    _errors: []
                };
                var processError = function(error) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = error.issues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var issue = _step.value;
                            if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                            else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                            else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                            else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                            else {
                                var curr = fieldErrors;
                                var i = 0;
                                while(i < issue.path.length){
                                    var el = issue.path[i];
                                    var terminal = i === issue.path.length - 1;
                                    if (!terminal) curr[el] = curr[el] || {
                                        _errors: []
                                    };
                                    else {
                                        curr[el] = curr[el] || {
                                            _errors: []
                                        };
                                        curr[el]._errors.push(mapper(issue));
                                    }
                                    curr = curr[el];
                                    i++;
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                };
                processError(this);
                return fieldErrors;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.message;
            }
        },
        {
            key: "message",
            get: function get() {
                return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
            }
        },
        {
            key: "isEmpty",
            get: function get() {
                return this.issues.length === 0;
            }
        },
        {
            key: "flatten",
            value: function flatten() {
                var mapper = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function(issue) {
                    return issue.message;
                };
                var fieldErrors = {};
                var formErrors = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.issues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sub = _step.value;
                        if (sub.path.length > 0) {
                            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
                            fieldErrors[sub.path[0]].push(mapper(sub));
                        } else formErrors.push(mapper(sub));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    formErrors: formErrors,
                    fieldErrors: fieldErrors
                };
            }
        },
        {
            key: "formErrors",
            get: function get() {
                return this.flatten();
            }
        }
    ]);
    return ZodError;
}((0, $FuVm8._)(Error));
ZodError.create = function(issues) {
    var error = new ZodError(issues);
    return error;
};
var errorMap = function(issue, _ctx) {
    var message;
    switch(issue.code){
        case ZodIssueCode.invalid_type:
            if (issue.received === ZodParsedType.undefined) message = "Required";
            else message = "Expected ".concat(issue.expected, ", received ").concat(issue.received);
            break;
        case ZodIssueCode.invalid_literal:
            message = "Invalid literal value, expected ".concat(JSON.stringify(issue.expected, util.jsonStringifyReplacer));
            break;
        case ZodIssueCode.unrecognized_keys:
            message = "Unrecognized key(s) in object: ".concat(util.joinValues(issue.keys, ", "));
            break;
        case ZodIssueCode.invalid_union:
            message = "Invalid input";
            break;
        case ZodIssueCode.invalid_union_discriminator:
            message = "Invalid discriminator value. Expected ".concat(util.joinValues(issue.options));
            break;
        case ZodIssueCode.invalid_enum_value:
            message = "Invalid enum value. Expected ".concat(util.joinValues(issue.options), ", received '").concat(issue.received, "'");
            break;
        case ZodIssueCode.invalid_arguments:
            message = "Invalid function arguments";
            break;
        case ZodIssueCode.invalid_return_type:
            message = "Invalid function return type";
            break;
        case ZodIssueCode.invalid_date:
            message = "Invalid date";
            break;
        case ZodIssueCode.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = 'Invalid input: must include "'.concat(issue.validation.includes, '"');
                    if (typeof issue.validation.position === "number") message = "".concat(message, " at one or more positions greater than or equal to ").concat(issue.validation.position);
                } else if ("startsWith" in issue.validation) message = 'Invalid input: must start with "'.concat(issue.validation.startsWith, '"');
                else if ("endsWith" in issue.validation) message = 'Invalid input: must end with "'.concat(issue.validation.endsWith, '"');
                else util.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = "Invalid ".concat(issue.validation);
            else message = "Invalid";
            break;
        case ZodIssueCode.too_small:
            if (issue.type === "array") message = "Array must contain ".concat(issue.exact ? "exactly" : issue.inclusive ? "at least" : "more than", " ").concat(issue.minimum, " element(s)");
            else if (issue.type === "string") message = "String must contain ".concat(issue.exact ? "exactly" : issue.inclusive ? "at least" : "over", " ").concat(issue.minimum, " character(s)");
            else if (issue.type === "number") message = "Number must be ".concat(issue.exact ? "exactly equal to " : issue.inclusive ? "greater than or equal to " : "greater than ").concat(issue.minimum);
            else if (issue.type === "date") message = "Date must be ".concat(issue.exact ? "exactly equal to " : issue.inclusive ? "greater than or equal to " : "greater than ").concat(new Date(Number(issue.minimum)));
            else message = "Invalid input";
            break;
        case ZodIssueCode.too_big:
            if (issue.type === "array") message = "Array must contain ".concat(issue.exact ? "exactly" : issue.inclusive ? "at most" : "less than", " ").concat(issue.maximum, " element(s)");
            else if (issue.type === "string") message = "String must contain ".concat(issue.exact ? "exactly" : issue.inclusive ? "at most" : "under", " ").concat(issue.maximum, " character(s)");
            else if (issue.type === "number") message = "Number must be ".concat(issue.exact ? "exactly" : issue.inclusive ? "less than or equal to" : "less than", " ").concat(issue.maximum);
            else if (issue.type === "bigint") message = "BigInt must be ".concat(issue.exact ? "exactly" : issue.inclusive ? "less than or equal to" : "less than", " ").concat(issue.maximum);
            else if (issue.type === "date") message = "Date must be ".concat(issue.exact ? "exactly" : issue.inclusive ? "smaller than or equal to" : "smaller than", " ").concat(new Date(Number(issue.maximum)));
            else message = "Invalid input";
            break;
        case ZodIssueCode.custom:
            message = "Invalid input";
            break;
        case ZodIssueCode.invalid_intersection_types:
            message = "Intersection results could not be merged";
            break;
        case ZodIssueCode.not_multiple_of:
            message = "Number must be a multiple of ".concat(issue.multipleOf);
            break;
        case ZodIssueCode.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            util.assertNever(issue);
    }
    return {
        message: message
    };
};
var overrideErrorMap = errorMap;
function setErrorMap(map) {
    overrideErrorMap = map;
}
function getErrorMap() {
    return overrideErrorMap;
}
var makeIssue = function(params) {
    var data = params.data, path = params.path, errorMaps = params.errorMaps, issueData = params.issueData;
    var fullPath = (0, $c6Xmf._)(path).concat((0, $c6Xmf._)(issueData.path || []));
    var fullIssue = (0, $cxjpp._)((0, $do9pw._)({}, issueData), {
        path: fullPath
    });
    var errorMessage = "";
    var maps = errorMaps.filter(function(m) {
        return !!m;
    }).slice().reverse();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = maps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var map = _step.value;
            errorMessage = map(fullIssue, {
                data: data,
                defaultError: errorMessage
            }).message;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return (0, $cxjpp._)((0, $do9pw._)({}, issueData), {
        path: fullPath,
        message: issueData.message || errorMessage
    });
};
var EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
    var issue = makeIssue({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            getErrorMap(),
            errorMap
        ].filter(function(x) {
            return !!x;
        })
    });
    ctx.common.issues.push(issue);
}
var ParseStatus = /*#__PURE__*/ function() {
    "use strict";
    function ParseStatus() {
        (0, $4GJKx._)(this, ParseStatus);
        this.value = "valid";
    }
    (0, $1wc17._)(ParseStatus, [
        {
            key: "dirty",
            value: function dirty() {
                if (this.value === "valid") this.value = "dirty";
            }
        },
        {
            key: "abort",
            value: function abort() {
                if (this.value !== "aborted") this.value = "aborted";
            }
        }
    ], [
        {
            key: "mergeArray",
            value: function mergeArray(status, results) {
                var arrayValue = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = results[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var s = _step.value;
                        if (s.status === "aborted") return INVALID;
                        if (s.status === "dirty") status.dirty();
                        arrayValue.push(s.value);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: arrayValue
                };
            }
        },
        {
            key: "mergeObjectAsync",
            value: function mergeObjectAsync(status, pairs) {
                return (0, $kSuI9._)(function() {
                    var syncPairs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, pair, _, _tmp, err;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                syncPairs = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    9
                                ]);
                                _iterator = pairs[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    6
                                ];
                                pair = _step.value;
                                _ = syncPairs.push;
                                _tmp = {};
                                return [
                                    4,
                                    pair.key
                                ];
                            case 3:
                                _tmp.key = _state.sent();
                                return [
                                    4,
                                    pair.value
                                ];
                            case 4:
                                _.apply(syncPairs, [
                                    (_tmp.value = _state.sent(), _tmp)
                                ]);
                                _state.label = 5;
                            case 5:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    9
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 9:
                                return [
                                    2,
                                    ParseStatus.mergeObjectSync(status, syncPairs)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "mergeObjectSync",
            value: function mergeObjectSync(status, pairs) {
                var finalObject = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = pairs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var pair = _step.value;
                        var key = pair.key, value = pair.value;
                        if (key.status === "aborted") return INVALID;
                        if (value.status === "aborted") return INVALID;
                        if (key.status === "dirty") status.dirty();
                        if (value.status === "dirty") status.dirty();
                        if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: finalObject
                };
            }
        }
    ]);
    return ParseStatus;
}();
var INVALID = Object.freeze({
    status: "aborted"
});
var DIRTY = function(value) {
    return {
        status: "dirty",
        value: value
    };
};
var OK = function(value) {
    return {
        status: "valid",
        value: value
    };
};
var isAborted = function(x) {
    return x.status === "aborted";
};
var isDirty = function(x) {
    return x.status === "dirty";
};
var isValid = function(x) {
    return x.status === "valid";
};
var isAsync = function(x) {
    return typeof Promise !== "undefined" && x instanceof Promise;
};
var errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = function(message) {
        return typeof message === "string" ? {
            message: message
        } : message || {};
    };
    errorUtil.toString = function(message) {
        return typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
    };
})(errorUtil || (errorUtil = {}));
var ParseInputLazyPath = /*#__PURE__*/ function() {
    "use strict";
    function ParseInputLazyPath(parent, value, path, key) {
        (0, $4GJKx._)(this, ParseInputLazyPath);
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    (0, $1wc17._)(ParseInputLazyPath, [
        {
            key: "path",
            get: function get() {
                if (!this._cachedPath.length) {
                    var _this__cachedPath, _this__cachedPath1;
                    if (this._key instanceof Array) (_this__cachedPath = this._cachedPath).push.apply(_this__cachedPath, (0, $c6Xmf._)(this._path).concat((0, $c6Xmf._)(this._key)));
                    else (_this__cachedPath1 = this._cachedPath).push.apply(_this__cachedPath1, (0, $c6Xmf._)(this._path).concat([
                        this._key
                    ]));
                }
                return this._cachedPath;
            }
        }
    ]);
    return ParseInputLazyPath;
}();
var handleResult = function(ctx, result) {
    if (isValid(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                var error = new ZodError(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function processCreateParams(params) {
    if (!params) return {};
    var errorMap = params.errorMap, invalid_type_error = params.invalid_type_error, required_error = params.required_error, description = params.description;
    if (errorMap && (invalid_type_error || required_error)) throw new Error('Can\'t use "invalid_type_error" or "required_error" in conjunction with custom error map.');
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    var customMap = function(iss, ctx) {
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError
        };
        return {
            message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
var ZodType = /*#__PURE__*/ function() {
    "use strict";
    function ZodType(def) {
        (0, $4GJKx._)(this, ZodType);
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    (0, $1wc17._)(ZodType, [
        {
            key: "description",
            get: function get() {
                return this._def.description;
            }
        },
        {
            key: "_getType",
            value: function _getType(input) {
                return getParsedType(input.data);
            }
        },
        {
            key: "_getOrReturnCtx",
            value: function _getOrReturnCtx(input, ctx) {
                return ctx || {
                    common: input.parent.common,
                    data: input.data,
                    parsedType: getParsedType(input.data),
                    schemaErrorMap: this._def.errorMap,
                    path: input.path,
                    parent: input.parent
                };
            }
        },
        {
            key: "_processInputParams",
            value: function _processInputParams(input) {
                return {
                    status: new ParseStatus(),
                    ctx: {
                        common: input.parent.common,
                        data: input.data,
                        parsedType: getParsedType(input.data),
                        schemaErrorMap: this._def.errorMap,
                        path: input.path,
                        parent: input.parent
                    }
                };
            }
        },
        {
            key: "_parseSync",
            value: function _parseSync(input) {
                var result = this._parse(input);
                if (isAsync(result)) throw new Error("Synchronous parse encountered promise.");
                return result;
            }
        },
        {
            key: "_parseAsync",
            value: function _parseAsync(input) {
                var result = this._parse(input);
                return Promise.resolve(result);
            }
        },
        {
            key: "parse",
            value: function parse(data, params) {
                var result = this.safeParse(data, params);
                if (result.success) return result.data;
                throw result.error;
            }
        },
        {
            key: "safeParse",
            value: function safeParse(data, params) {
                var _a;
                var ctx = {
                    common: {
                        issues: [],
                        async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                        contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
                    },
                    path: (params === null || params === void 0 ? void 0 : params.path) || [],
                    schemaErrorMap: this._def.errorMap,
                    parent: null,
                    data: data,
                    parsedType: getParsedType(data)
                };
                var result = this._parseSync({
                    data: data,
                    path: ctx.path,
                    parent: ctx
                });
                return handleResult(ctx, result);
            }
        },
        {
            key: "parseAsync",
            value: function parseAsync(data, params) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var result;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.safeParseAsync(data, params)
                                ];
                            case 1:
                                result = _state.sent();
                                if (result.success) return [
                                    2,
                                    result.data
                                ];
                                throw result.error;
                        }
                    });
                })();
            }
        },
        {
            key: "safeParseAsync",
            value: function safeParseAsync(data, params) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var ctx, maybeAsyncResult, result;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                ctx = {
                                    common: {
                                        issues: [],
                                        contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                                        async: true
                                    },
                                    path: (params === null || params === void 0 ? void 0 : params.path) || [],
                                    schemaErrorMap: _this._def.errorMap,
                                    parent: null,
                                    data: data,
                                    parsedType: getParsedType(data)
                                };
                                maybeAsyncResult = _this._parse({
                                    data: data,
                                    path: ctx.path,
                                    parent: ctx
                                });
                                return [
                                    4,
                                    isAsync(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult)
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    handleResult(ctx, result)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "refine",
            value: function refine(check, message) {
                var getIssueProperties = function(val) {
                    if (typeof message === "string" || typeof message === "undefined") return {
                        message: message
                    };
                    else if (typeof message === "function") return message(val);
                    else return message;
                };
                return this._refinement(function(val, ctx) {
                    var result = check(val);
                    var setError = function() {
                        return ctx.addIssue((0, $do9pw._)({
                            code: ZodIssueCode.custom
                        }, getIssueProperties(val)));
                    };
                    if (typeof Promise !== "undefined" && result instanceof Promise) return result.then(function(data) {
                        if (!data) {
                            setError();
                            return false;
                        } else return true;
                    });
                    if (!result) {
                        setError();
                        return false;
                    } else return true;
                });
            }
        },
        {
            key: "refinement",
            value: function refinement(check, refinementData) {
                return this._refinement(function(val, ctx) {
                    if (!check(val)) {
                        ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                        return false;
                    } else return true;
                });
            }
        },
        {
            key: "_refinement",
            value: function _refinement(refinement) {
                return new ZodEffects({
                    schema: this,
                    typeName: ZodFirstPartyTypeKind.ZodEffects,
                    effect: {
                        type: "refinement",
                        refinement: refinement
                    }
                });
            }
        },
        {
            key: "superRefine",
            value: function superRefine(refinement) {
                return this._refinement(refinement);
            }
        },
        {
            key: "optional",
            value: function optional() {
                return ZodOptional.create(this, this._def);
            }
        },
        {
            key: "nullable",
            value: function nullable() {
                return ZodNullable.create(this, this._def);
            }
        },
        {
            key: "nullish",
            value: function nullish() {
                return this.nullable().optional();
            }
        },
        {
            key: "array",
            value: function array() {
                return ZodArray.create(this, this._def);
            }
        },
        {
            key: "promise",
            value: function promise() {
                return ZodPromise.create(this, this._def);
            }
        },
        {
            key: "or",
            value: function or(option) {
                return ZodUnion.create([
                    this,
                    option
                ], this._def);
            }
        },
        {
            key: "and",
            value: function and(incoming) {
                return ZodIntersection.create(this, incoming, this._def);
            }
        },
        {
            key: "transform",
            value: function transform(transform) {
                return new ZodEffects((0, $cxjpp._)((0, $do9pw._)({}, processCreateParams(this._def)), {
                    schema: this,
                    typeName: ZodFirstPartyTypeKind.ZodEffects,
                    effect: {
                        type: "transform",
                        transform: transform
                    }
                }));
            }
        },
        {
            key: "default",
            value: function _default(def) {
                var defaultValueFunc = typeof def === "function" ? def : function() {
                    return def;
                };
                return new ZodDefault((0, $cxjpp._)((0, $do9pw._)({}, processCreateParams(this._def)), {
                    innerType: this,
                    defaultValue: defaultValueFunc,
                    typeName: ZodFirstPartyTypeKind.ZodDefault
                }));
            }
        },
        {
            key: "brand",
            value: function brand() {
                return new ZodBranded((0, $do9pw._)({
                    typeName: ZodFirstPartyTypeKind.ZodBranded,
                    type: this
                }, processCreateParams(this._def)));
            }
        },
        {
            key: "catch",
            value: function _catch(def) {
                var catchValueFunc = typeof def === "function" ? def : function() {
                    return def;
                };
                return new ZodCatch((0, $cxjpp._)((0, $do9pw._)({}, processCreateParams(this._def)), {
                    innerType: this,
                    catchValue: catchValueFunc,
                    typeName: ZodFirstPartyTypeKind.ZodCatch
                }));
            }
        },
        {
            key: "describe",
            value: function describe(description) {
                var This = this.constructor;
                return new This((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    description: description
                }));
            }
        },
        {
            key: "pipe",
            value: function pipe(target) {
                return ZodPipeline.create(this, target);
            }
        },
        {
            key: "readonly",
            value: function readonly() {
                return ZodReadonly.create(this);
            }
        },
        {
            key: "isOptional",
            value: function isOptional() {
                return this.safeParse(undefined).success;
            }
        },
        {
            key: "isNullable",
            value: function isNullable() {
                return this.safeParse(null).success;
            }
        }
    ]);
    return ZodType;
}();
var cuidRegex = /^c[^\s-]{8,}$/i;
var cuid2Regex = /^[a-z][a-z0-9]*$/;
var ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
var uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
var emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
var _emojiRegex = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
var emojiRegex;
var ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
var ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// Adapted from https://stackoverflow.com/a/3143231
var datetimeRegex = function(args) {
    if (args.precision) {
        if (args.offset) return new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{".concat(args.precision, "}(([+-]\\d{2}(:?\\d{2})?)|Z)$"));
        else return new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{".concat(args.precision, "}Z$"));
    } else if (args.precision === 0) {
        if (args.offset) return new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$");
        else return new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$");
    } else {
        if (args.offset) return new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$");
        else return new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$");
    }
};
function isValidIP(ip, version) {
    if ((version === "v4" || !version) && ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && ipv6Regex.test(ip)) return true;
    return false;
}
var ZodString = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodString, ZodType);
    var _super = (0, $ohfOJ._)(ZodString);
    function ZodString() {
        (0, $4GJKx._)(this, ZodString);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodString, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (this._def.coerce) input.data = String(input.data);
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.string) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.string,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                var status = new ParseStatus();
                var ctx1 = undefined;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var check = _step.value;
                        if (check.kind === "min") {
                            if (input.data.length < check.value) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.too_small,
                                    minimum: check.value,
                                    type: "string",
                                    inclusive: true,
                                    exact: false,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "max") {
                            if (input.data.length > check.value) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.too_big,
                                    maximum: check.value,
                                    type: "string",
                                    inclusive: true,
                                    exact: false,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "length") {
                            var tooBig = input.data.length > check.value;
                            var tooSmall = input.data.length < check.value;
                            if (tooBig || tooSmall) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                if (tooBig) addIssueToContext(ctx1, {
                                    code: ZodIssueCode.too_big,
                                    maximum: check.value,
                                    type: "string",
                                    inclusive: true,
                                    exact: true,
                                    message: check.message
                                });
                                else if (tooSmall) addIssueToContext(ctx1, {
                                    code: ZodIssueCode.too_small,
                                    minimum: check.value,
                                    type: "string",
                                    inclusive: true,
                                    exact: true,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "email") {
                            if (!emailRegex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    validation: "email",
                                    code: ZodIssueCode.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "emoji") {
                            if (!emojiRegex) emojiRegex = new RegExp(_emojiRegex, "u");
                            if (!emojiRegex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    validation: "emoji",
                                    code: ZodIssueCode.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "uuid") {
                            if (!uuidRegex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    validation: "uuid",
                                    code: ZodIssueCode.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "cuid") {
                            if (!cuidRegex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    validation: "cuid",
                                    code: ZodIssueCode.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "cuid2") {
                            if (!cuid2Regex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    validation: "cuid2",
                                    code: ZodIssueCode.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "ulid") {
                            if (!ulidRegex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    validation: "ulid",
                                    code: ZodIssueCode.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "url") try {
                            new URL(input.data);
                        } catch (_a) {
                            ctx1 = this._getOrReturnCtx(input, ctx1);
                            addIssueToContext(ctx1, {
                                validation: "url",
                                code: ZodIssueCode.invalid_string,
                                message: check.message
                            });
                            status.dirty();
                        }
                        else if (check.kind === "regex") {
                            check.regex.lastIndex = 0;
                            var testResult = check.regex.test(input.data);
                            if (!testResult) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    validation: "regex",
                                    code: ZodIssueCode.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "trim") input.data = input.data.trim();
                        else if (check.kind === "includes") {
                            if (!input.data.includes(check.value, check.position)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.invalid_string,
                                    validation: {
                                        includes: check.value,
                                        position: check.position
                                    },
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
                        else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
                        else if (check.kind === "startsWith") {
                            if (!input.data.startsWith(check.value)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.invalid_string,
                                    validation: {
                                        startsWith: check.value
                                    },
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "endsWith") {
                            if (!input.data.endsWith(check.value)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.invalid_string,
                                    validation: {
                                        endsWith: check.value
                                    },
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "datetime") {
                            var regex = datetimeRegex(check);
                            if (!regex.test(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.invalid_string,
                                    validation: "datetime",
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "ip") {
                            if (!isValidIP(input.data, check.version)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    validation: "ip",
                                    code: ZodIssueCode.invalid_string,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else util.assertNever(check);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: input.data
                };
            }
        },
        {
            key: "_regex",
            value: function _regex(regex, validation, message) {
                return this.refinement(function(data) {
                    return regex.test(data);
                }, (0, $do9pw._)({
                    validation: validation,
                    code: ZodIssueCode.invalid_string
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "_addCheck",
            value: function _addCheck(check) {
                return new ZodString((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    checks: (0, $c6Xmf._)(this._def.checks).concat([
                        check
                    ])
                }));
            }
        },
        {
            key: "email",
            value: function email(message) {
                return this._addCheck((0, $do9pw._)({
                    kind: "email"
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "url",
            value: function url(message) {
                return this._addCheck((0, $do9pw._)({
                    kind: "url"
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "emoji",
            value: function emoji(message) {
                return this._addCheck((0, $do9pw._)({
                    kind: "emoji"
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "uuid",
            value: function uuid(message) {
                return this._addCheck((0, $do9pw._)({
                    kind: "uuid"
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "cuid",
            value: function cuid(message) {
                return this._addCheck((0, $do9pw._)({
                    kind: "cuid"
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "cuid2",
            value: function cuid2(message) {
                return this._addCheck((0, $do9pw._)({
                    kind: "cuid2"
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "ulid",
            value: function ulid(message) {
                return this._addCheck((0, $do9pw._)({
                    kind: "ulid"
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "ip",
            value: function ip(options) {
                return this._addCheck((0, $do9pw._)({
                    kind: "ip"
                }, errorUtil.errToObj(options)));
            }
        },
        {
            key: "datetime",
            value: function datetime(options) {
                var _a;
                if (typeof options === "string") return this._addCheck({
                    kind: "datetime",
                    precision: null,
                    offset: false,
                    message: options
                });
                return this._addCheck((0, $do9pw._)({
                    kind: "datetime",
                    precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
                    offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false
                }, errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
            }
        },
        {
            key: "regex",
            value: function regex(regex, message) {
                return this._addCheck((0, $do9pw._)({
                    kind: "regex",
                    regex: regex
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "includes",
            value: function includes(value, options) {
                return this._addCheck((0, $do9pw._)({
                    kind: "includes",
                    value: value,
                    position: options === null || options === void 0 ? void 0 : options.position
                }, errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
            }
        },
        {
            key: "startsWith",
            value: function startsWith(value, message) {
                return this._addCheck((0, $do9pw._)({
                    kind: "startsWith",
                    value: value
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "endsWith",
            value: function endsWith(value, message) {
                return this._addCheck((0, $do9pw._)({
                    kind: "endsWith",
                    value: value
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "min",
            value: function min(minLength, message) {
                return this._addCheck((0, $do9pw._)({
                    kind: "min",
                    value: minLength
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "max",
            value: function max(maxLength, message) {
                return this._addCheck((0, $do9pw._)({
                    kind: "max",
                    value: maxLength
                }, errorUtil.errToObj(message)));
            }
        },
        {
            key: "length",
            value: function length(len, message) {
                return this._addCheck((0, $do9pw._)({
                    kind: "length",
                    value: len
                }, errorUtil.errToObj(message)));
            }
        },
        {
            /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */ key: "nonempty",
            value: function nonempty(message) {
                return this.min(1, errorUtil.errToObj(message));
            }
        },
        {
            key: "trim",
            value: function trim() {
                return new ZodString((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    checks: (0, $c6Xmf._)(this._def.checks).concat([
                        {
                            kind: "trim"
                        }
                    ])
                }));
            }
        },
        {
            key: "toLowerCase",
            value: function toLowerCase() {
                return new ZodString((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    checks: (0, $c6Xmf._)(this._def.checks).concat([
                        {
                            kind: "toLowerCase"
                        }
                    ])
                }));
            }
        },
        {
            key: "toUpperCase",
            value: function toUpperCase() {
                return new ZodString((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    checks: (0, $c6Xmf._)(this._def.checks).concat([
                        {
                            kind: "toUpperCase"
                        }
                    ])
                }));
            }
        },
        {
            key: "isDatetime",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "datetime";
                });
            }
        },
        {
            key: "isEmail",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "email";
                });
            }
        },
        {
            key: "isURL",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "url";
                });
            }
        },
        {
            key: "isEmoji",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "emoji";
                });
            }
        },
        {
            key: "isUUID",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "uuid";
                });
            }
        },
        {
            key: "isCUID",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "cuid";
                });
            }
        },
        {
            key: "isCUID2",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "cuid2";
                });
            }
        },
        {
            key: "isULID",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "ulid";
                });
            }
        },
        {
            key: "isIP",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "ip";
                });
            }
        },
        {
            key: "minLength",
            get: function get() {
                var min = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "min") {
                            if (min === null || ch.value > min) min = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return min;
            }
        },
        {
            key: "maxLength",
            get: function get() {
                var max = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "max") {
                            if (max === null || ch.value < max) max = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return max;
            }
        }
    ]);
    return ZodString;
}(ZodType);
ZodString.create = function(params) {
    var _a;
    return new ZodString((0, $do9pw._)({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false
    }, processCreateParams(params)));
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function floatSafeRemainder(val, step) {
    var valDecCount = (val.toString().split(".")[1] || "").length;
    var stepDecCount = (step.toString().split(".")[1] || "").length;
    var decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    var valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    var stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
var ZodNumber = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodNumber, ZodType);
    var _super = (0, $ohfOJ._)(ZodNumber);
    function ZodNumber() {
        (0, $4GJKx._)(this, ZodNumber);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.min = _this.gte;
        _this.max = _this.lte;
        _this.step = _this.multipleOf;
        return _this;
    }
    (0, $1wc17._)(ZodNumber, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (this._def.coerce) input.data = Number(input.data);
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.number) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.number,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                var ctx1 = undefined;
                var status = new ParseStatus();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var check = _step.value;
                        if (check.kind === "int") {
                            if (!util.isInteger(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.invalid_type,
                                    expected: "integer",
                                    received: "float",
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "min") {
                            var tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                            if (tooSmall) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.too_small,
                                    minimum: check.value,
                                    type: "number",
                                    inclusive: check.inclusive,
                                    exact: false,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "max") {
                            var tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                            if (tooBig) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.too_big,
                                    maximum: check.value,
                                    type: "number",
                                    inclusive: check.inclusive,
                                    exact: false,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "multipleOf") {
                            if (floatSafeRemainder(input.data, check.value) !== 0) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.not_multiple_of,
                                    multipleOf: check.value,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "finite") {
                            if (!Number.isFinite(input.data)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.not_finite,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else util.assertNever(check);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: input.data
                };
            }
        },
        {
            key: "gte",
            value: function gte(value, message) {
                return this.setLimit("min", value, true, errorUtil.toString(message));
            }
        },
        {
            key: "gt",
            value: function gt(value, message) {
                return this.setLimit("min", value, false, errorUtil.toString(message));
            }
        },
        {
            key: "lte",
            value: function lte(value, message) {
                return this.setLimit("max", value, true, errorUtil.toString(message));
            }
        },
        {
            key: "lt",
            value: function lt(value, message) {
                return this.setLimit("max", value, false, errorUtil.toString(message));
            }
        },
        {
            key: "setLimit",
            value: function setLimit(kind, value, inclusive, message) {
                return new ZodNumber((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    checks: (0, $c6Xmf._)(this._def.checks).concat([
                        {
                            kind: kind,
                            value: value,
                            inclusive: inclusive,
                            message: errorUtil.toString(message)
                        }
                    ])
                }));
            }
        },
        {
            key: "_addCheck",
            value: function _addCheck(check) {
                return new ZodNumber((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    checks: (0, $c6Xmf._)(this._def.checks).concat([
                        check
                    ])
                }));
            }
        },
        {
            key: "int",
            value: function int(message) {
                return this._addCheck({
                    kind: "int",
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "positive",
            value: function positive(message) {
                return this._addCheck({
                    kind: "min",
                    value: 0,
                    inclusive: false,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "negative",
            value: function negative(message) {
                return this._addCheck({
                    kind: "max",
                    value: 0,
                    inclusive: false,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "nonpositive",
            value: function nonpositive(message) {
                return this._addCheck({
                    kind: "max",
                    value: 0,
                    inclusive: true,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "nonnegative",
            value: function nonnegative(message) {
                return this._addCheck({
                    kind: "min",
                    value: 0,
                    inclusive: true,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "multipleOf",
            value: function multipleOf(value, message) {
                return this._addCheck({
                    kind: "multipleOf",
                    value: value,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "finite",
            value: function finite(message) {
                return this._addCheck({
                    kind: "finite",
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "safe",
            value: function safe(message) {
                return this._addCheck({
                    kind: "min",
                    inclusive: true,
                    value: Number.MIN_SAFE_INTEGER,
                    message: errorUtil.toString(message)
                })._addCheck({
                    kind: "max",
                    inclusive: true,
                    value: Number.MAX_SAFE_INTEGER,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "minValue",
            get: function get() {
                var min = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "min") {
                            if (min === null || ch.value > min) min = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return min;
            }
        },
        {
            key: "maxValue",
            get: function get() {
                var max = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "max") {
                            if (max === null || ch.value < max) max = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return max;
            }
        },
        {
            key: "isInt",
            get: function get() {
                return !!this._def.checks.find(function(ch) {
                    return ch.kind === "int" || ch.kind === "multipleOf" && util.isInteger(ch.value);
                });
            }
        },
        {
            key: "isFinite",
            get: function get() {
                var max = null, min = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
                        else if (ch.kind === "min") {
                            if (min === null || ch.value > min) min = ch.value;
                        } else if (ch.kind === "max") {
                            if (max === null || ch.value < max) max = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return Number.isFinite(min) && Number.isFinite(max);
            }
        }
    ]);
    return ZodNumber;
}(ZodType);
ZodNumber.create = function(params) {
    return new ZodNumber((0, $do9pw._)({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
    }, processCreateParams(params)));
};
var ZodBigInt = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodBigInt, ZodType);
    var _super = (0, $ohfOJ._)(ZodBigInt);
    function ZodBigInt() {
        (0, $4GJKx._)(this, ZodBigInt);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.min = _this.gte;
        _this.max = _this.lte;
        return _this;
    }
    (0, $1wc17._)(ZodBigInt, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (this._def.coerce) input.data = BigInt(input.data);
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.bigint) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.bigint,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                var ctx1 = undefined;
                var status = new ParseStatus();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var check = _step.value;
                        if (check.kind === "min") {
                            var tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                            if (tooSmall) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.too_small,
                                    type: "bigint",
                                    minimum: check.value,
                                    inclusive: check.inclusive,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "max") {
                            var tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                            if (tooBig) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.too_big,
                                    type: "bigint",
                                    maximum: check.value,
                                    inclusive: check.inclusive,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "multipleOf") {
                            if (input.data % check.value !== BigInt(0)) {
                                ctx1 = this._getOrReturnCtx(input, ctx1);
                                addIssueToContext(ctx1, {
                                    code: ZodIssueCode.not_multiple_of,
                                    multipleOf: check.value,
                                    message: check.message
                                });
                                status.dirty();
                            }
                        } else util.assertNever(check);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: input.data
                };
            }
        },
        {
            key: "gte",
            value: function gte(value, message) {
                return this.setLimit("min", value, true, errorUtil.toString(message));
            }
        },
        {
            key: "gt",
            value: function gt(value, message) {
                return this.setLimit("min", value, false, errorUtil.toString(message));
            }
        },
        {
            key: "lte",
            value: function lte(value, message) {
                return this.setLimit("max", value, true, errorUtil.toString(message));
            }
        },
        {
            key: "lt",
            value: function lt(value, message) {
                return this.setLimit("max", value, false, errorUtil.toString(message));
            }
        },
        {
            key: "setLimit",
            value: function setLimit(kind, value, inclusive, message) {
                return new ZodBigInt((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    checks: (0, $c6Xmf._)(this._def.checks).concat([
                        {
                            kind: kind,
                            value: value,
                            inclusive: inclusive,
                            message: errorUtil.toString(message)
                        }
                    ])
                }));
            }
        },
        {
            key: "_addCheck",
            value: function _addCheck(check) {
                return new ZodBigInt((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    checks: (0, $c6Xmf._)(this._def.checks).concat([
                        check
                    ])
                }));
            }
        },
        {
            key: "positive",
            value: function positive(message) {
                return this._addCheck({
                    kind: "min",
                    value: BigInt(0),
                    inclusive: false,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "negative",
            value: function negative(message) {
                return this._addCheck({
                    kind: "max",
                    value: BigInt(0),
                    inclusive: false,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "nonpositive",
            value: function nonpositive(message) {
                return this._addCheck({
                    kind: "max",
                    value: BigInt(0),
                    inclusive: true,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "nonnegative",
            value: function nonnegative(message) {
                return this._addCheck({
                    kind: "min",
                    value: BigInt(0),
                    inclusive: true,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "multipleOf",
            value: function multipleOf(value, message) {
                return this._addCheck({
                    kind: "multipleOf",
                    value: value,
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "minValue",
            get: function get() {
                var min = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "min") {
                            if (min === null || ch.value > min) min = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return min;
            }
        },
        {
            key: "maxValue",
            get: function get() {
                var max = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "max") {
                            if (max === null || ch.value < max) max = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return max;
            }
        }
    ]);
    return ZodBigInt;
}(ZodType);
ZodBigInt.create = function(params) {
    var _a;
    return new ZodBigInt((0, $do9pw._)({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false
    }, processCreateParams(params)));
};
var ZodBoolean = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodBoolean, ZodType);
    var _super = (0, $ohfOJ._)(ZodBoolean);
    function ZodBoolean() {
        (0, $4GJKx._)(this, ZodBoolean);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodBoolean, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (this._def.coerce) input.data = Boolean(input.data);
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.boolean) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.boolean,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                return OK(input.data);
            }
        }
    ]);
    return ZodBoolean;
}(ZodType);
ZodBoolean.create = function(params) {
    return new ZodBoolean((0, $do9pw._)({
        typeName: ZodFirstPartyTypeKind.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
    }, processCreateParams(params)));
};
var ZodDate = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodDate, ZodType);
    var _super = (0, $ohfOJ._)(ZodDate);
    function ZodDate() {
        (0, $4GJKx._)(this, ZodDate);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodDate, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (this._def.coerce) input.data = new Date(input.data);
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.date) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.date,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                if (isNaN(input.data.getTime())) {
                    var ctx1 = this._getOrReturnCtx(input);
                    addIssueToContext(ctx1, {
                        code: ZodIssueCode.invalid_date
                    });
                    return INVALID;
                }
                var status = new ParseStatus();
                var ctx2 = undefined;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var check = _step.value;
                        if (check.kind === "min") {
                            if (input.data.getTime() < check.value) {
                                ctx2 = this._getOrReturnCtx(input, ctx2);
                                addIssueToContext(ctx2, {
                                    code: ZodIssueCode.too_small,
                                    message: check.message,
                                    inclusive: true,
                                    exact: false,
                                    minimum: check.value,
                                    type: "date"
                                });
                                status.dirty();
                            }
                        } else if (check.kind === "max") {
                            if (input.data.getTime() > check.value) {
                                ctx2 = this._getOrReturnCtx(input, ctx2);
                                addIssueToContext(ctx2, {
                                    code: ZodIssueCode.too_big,
                                    message: check.message,
                                    inclusive: true,
                                    exact: false,
                                    maximum: check.value,
                                    type: "date"
                                });
                                status.dirty();
                            }
                        } else util.assertNever(check);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    status: status.value,
                    value: new Date(input.data.getTime())
                };
            }
        },
        {
            key: "_addCheck",
            value: function _addCheck(check) {
                return new ZodDate((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    checks: (0, $c6Xmf._)(this._def.checks).concat([
                        check
                    ])
                }));
            }
        },
        {
            key: "min",
            value: function min(minDate, message) {
                return this._addCheck({
                    kind: "min",
                    value: minDate.getTime(),
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "max",
            value: function max(maxDate, message) {
                return this._addCheck({
                    kind: "max",
                    value: maxDate.getTime(),
                    message: errorUtil.toString(message)
                });
            }
        },
        {
            key: "minDate",
            get: function get() {
                var min = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "min") {
                            if (min === null || ch.value > min) min = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return min != null ? new Date(min) : null;
            }
        },
        {
            key: "maxDate",
            get: function get() {
                var max = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.checks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ch = _step.value;
                        if (ch.kind === "max") {
                            if (max === null || ch.value < max) max = ch.value;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return max != null ? new Date(max) : null;
            }
        }
    ]);
    return ZodDate;
}(ZodType);
ZodDate.create = function(params) {
    return new ZodDate((0, $do9pw._)({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: ZodFirstPartyTypeKind.ZodDate
    }, processCreateParams(params)));
};
var ZodSymbol = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodSymbol, ZodType);
    var _super = (0, $ohfOJ._)(ZodSymbol);
    function ZodSymbol() {
        (0, $4GJKx._)(this, ZodSymbol);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodSymbol, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.symbol) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.symbol,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                return OK(input.data);
            }
        }
    ]);
    return ZodSymbol;
}(ZodType);
ZodSymbol.create = function(params) {
    return new ZodSymbol((0, $do9pw._)({
        typeName: ZodFirstPartyTypeKind.ZodSymbol
    }, processCreateParams(params)));
};
var ZodUndefined = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodUndefined, ZodType);
    var _super = (0, $ohfOJ._)(ZodUndefined);
    function ZodUndefined() {
        (0, $4GJKx._)(this, ZodUndefined);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodUndefined, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.undefined) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.undefined,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                return OK(input.data);
            }
        }
    ]);
    return ZodUndefined;
}(ZodType);
ZodUndefined.create = function(params) {
    return new ZodUndefined((0, $do9pw._)({
        typeName: ZodFirstPartyTypeKind.ZodUndefined
    }, processCreateParams(params)));
};
var ZodNull = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodNull, ZodType);
    var _super = (0, $ohfOJ._)(ZodNull);
    function ZodNull() {
        (0, $4GJKx._)(this, ZodNull);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodNull, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.null) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.null,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                return OK(input.data);
            }
        }
    ]);
    return ZodNull;
}(ZodType);
ZodNull.create = function(params) {
    return new ZodNull((0, $do9pw._)({
        typeName: ZodFirstPartyTypeKind.ZodNull
    }, processCreateParams(params)));
};
var ZodAny = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodAny, ZodType);
    var _super = (0, $ohfOJ._)(ZodAny);
    function ZodAny() {
        (0, $4GJKx._)(this, ZodAny);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        _this._any = true;
        return _this;
    }
    (0, $1wc17._)(ZodAny, [
        {
            key: "_parse",
            value: function _parse(input) {
                return OK(input.data);
            }
        }
    ]);
    return ZodAny;
}(ZodType);
ZodAny.create = function(params) {
    return new ZodAny((0, $do9pw._)({
        typeName: ZodFirstPartyTypeKind.ZodAny
    }, processCreateParams(params)));
};
var ZodUnknown = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodUnknown, ZodType);
    var _super = (0, $ohfOJ._)(ZodUnknown);
    function ZodUnknown() {
        (0, $4GJKx._)(this, ZodUnknown);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        // required
        _this._unknown = true;
        return _this;
    }
    (0, $1wc17._)(ZodUnknown, [
        {
            key: "_parse",
            value: function _parse(input) {
                return OK(input.data);
            }
        }
    ]);
    return ZodUnknown;
}(ZodType);
ZodUnknown.create = function(params) {
    return new ZodUnknown((0, $do9pw._)({
        typeName: ZodFirstPartyTypeKind.ZodUnknown
    }, processCreateParams(params)));
};
var ZodNever = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodNever, ZodType);
    var _super = (0, $ohfOJ._)(ZodNever);
    function ZodNever() {
        (0, $4GJKx._)(this, ZodNever);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodNever, [
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._getOrReturnCtx(input);
                addIssueToContext(ctx, {
                    code: ZodIssueCode.invalid_type,
                    expected: ZodParsedType.never,
                    received: ctx.parsedType
                });
                return INVALID;
            }
        }
    ]);
    return ZodNever;
}(ZodType);
ZodNever.create = function(params) {
    return new ZodNever((0, $do9pw._)({
        typeName: ZodFirstPartyTypeKind.ZodNever
    }, processCreateParams(params)));
};
var ZodVoid = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodVoid, ZodType);
    var _super = (0, $ohfOJ._)(ZodVoid);
    function ZodVoid() {
        (0, $4GJKx._)(this, ZodVoid);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodVoid, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.undefined) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.void,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                return OK(input.data);
            }
        }
    ]);
    return ZodVoid;
}(ZodType);
ZodVoid.create = function(params) {
    return new ZodVoid((0, $do9pw._)({
        typeName: ZodFirstPartyTypeKind.ZodVoid
    }, processCreateParams(params)));
};
var ZodArray = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodArray, ZodType);
    var _super = (0, $ohfOJ._)(ZodArray);
    function ZodArray() {
        (0, $4GJKx._)(this, ZodArray);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodArray, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), ctx = _this__processInputParams.ctx, status = _this__processInputParams.status;
                var def = this._def;
                if (ctx.parsedType !== ZodParsedType.array) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.array,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                if (def.exactLength !== null) {
                    var tooBig = ctx.data.length > def.exactLength.value;
                    var tooSmall = ctx.data.length < def.exactLength.value;
                    if (tooBig || tooSmall) {
                        addIssueToContext(ctx, {
                            code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
                            minimum: tooSmall ? def.exactLength.value : undefined,
                            maximum: tooBig ? def.exactLength.value : undefined,
                            type: "array",
                            inclusive: true,
                            exact: true,
                            message: def.exactLength.message
                        });
                        status.dirty();
                    }
                }
                if (def.minLength !== null) {
                    if (ctx.data.length < def.minLength.value) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.too_small,
                            minimum: def.minLength.value,
                            type: "array",
                            inclusive: true,
                            exact: false,
                            message: def.minLength.message
                        });
                        status.dirty();
                    }
                }
                if (def.maxLength !== null) {
                    if (ctx.data.length > def.maxLength.value) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.too_big,
                            maximum: def.maxLength.value,
                            type: "array",
                            inclusive: true,
                            exact: false,
                            message: def.maxLength.message
                        });
                        status.dirty();
                    }
                }
                if (ctx.common.async) return Promise.all((0, $c6Xmf._)(ctx.data).map(function(item, i) {
                    return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
                })).then(function(result) {
                    return ParseStatus.mergeArray(status, result);
                });
                var result = (0, $c6Xmf._)(ctx.data).map(function(item, i) {
                    return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
                });
                return ParseStatus.mergeArray(status, result);
            }
        },
        {
            key: "element",
            get: function get() {
                return this._def.type;
            }
        },
        {
            key: "min",
            value: function min(minLength, message) {
                return new ZodArray((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    minLength: {
                        value: minLength,
                        message: errorUtil.toString(message)
                    }
                }));
            }
        },
        {
            key: "max",
            value: function max(maxLength, message) {
                return new ZodArray((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    maxLength: {
                        value: maxLength,
                        message: errorUtil.toString(message)
                    }
                }));
            }
        },
        {
            key: "length",
            value: function length(len, message) {
                return new ZodArray((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    exactLength: {
                        value: len,
                        message: errorUtil.toString(message)
                    }
                }));
            }
        },
        {
            key: "nonempty",
            value: function nonempty(message) {
                return this.min(1, message);
            }
        }
    ]);
    return ZodArray;
}(ZodType);
ZodArray.create = function(schema, params) {
    return new ZodArray((0, $do9pw._)({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: ZodFirstPartyTypeKind.ZodArray
    }, processCreateParams(params)));
};
function deepPartialify(schema) {
    if (schema instanceof ZodObject) {
        var newShape = {};
        for(var key in schema.shape){
            var fieldSchema = schema.shape[key];
            newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
        }
        return new ZodObject((0, $cxjpp._)((0, $do9pw._)({}, schema._def), {
            shape: function() {
                return newShape;
            }
        }));
    } else if (schema instanceof ZodArray) return new ZodArray((0, $cxjpp._)((0, $do9pw._)({}, schema._def), {
        type: deepPartialify(schema.element)
    }));
    else if (schema instanceof ZodOptional) return ZodOptional.create(deepPartialify(schema.unwrap()));
    else if (schema instanceof ZodNullable) return ZodNullable.create(deepPartialify(schema.unwrap()));
    else if (schema instanceof ZodTuple) return ZodTuple.create(schema.items.map(function(item) {
        return deepPartialify(item);
    }));
    else return schema;
}
var ZodObject = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodObject, ZodType);
    var _super = (0, $ohfOJ._)(ZodObject);
    function ZodObject() {
        (0, $4GJKx._)(this, ZodObject);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ _this.nonstrict = _this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ _this.augment = _this.extend;
        return _this;
    }
    (0, $1wc17._)(ZodObject, [
        {
            key: "_getCached",
            value: function _getCached() {
                if (this._cached !== null) return this._cached;
                var shape = this._def.shape();
                var keys = util.objectKeys(shape);
                return this._cached = {
                    shape: shape,
                    keys: keys
                };
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.object) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.object,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx1 = _this__processInputParams.ctx;
                var _this__getCached = this._getCached(), shape = _this__getCached.shape, shapeKeys = _this__getCached.keys;
                var extraKeys = [];
                if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip")) {
                    for(var key in ctx1.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
                }
                var pairs = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = shapeKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key1 = _step.value;
                        var keyValidator = shape[key1];
                        var value = ctx1.data[key1];
                        pairs.push({
                            key: {
                                status: "valid",
                                value: key1
                            },
                            value: keyValidator._parse(new ParseInputLazyPath(ctx1, value, ctx1.path, key1)),
                            alwaysSet: key1 in ctx1.data
                        });
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (this._def.catchall instanceof ZodNever) {
                    var unknownKeys = this._def.unknownKeys;
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    if (unknownKeys === "passthrough") try {
                        for(var _iterator1 = extraKeys[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var key2 = _step1.value;
                            pairs.push({
                                key: {
                                    status: "valid",
                                    value: key2
                                },
                                value: {
                                    status: "valid",
                                    value: ctx1.data[key2]
                                }
                            });
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    else if (unknownKeys === "strict") {
                        if (extraKeys.length > 0) {
                            addIssueToContext(ctx1, {
                                code: ZodIssueCode.unrecognized_keys,
                                keys: extraKeys
                            });
                            status.dirty();
                        }
                    } else if (unknownKeys === "strip") ;
                    else throw new Error("Internal ZodObject error: invalid unknownKeys value.");
                } else {
                    // run catchall validation
                    var catchall = this._def.catchall;
                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(var _iterator2 = extraKeys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var key3 = _step2.value;
                            var value1 = ctx1.data[key3];
                            pairs.push({
                                key: {
                                    status: "valid",
                                    value: key3
                                },
                                value: catchall._parse(new ParseInputLazyPath(ctx1, value1, ctx1.path, key3) //, ctx.child(key), value, getParsedType(value)
                                ),
                                alwaysSet: key3 in ctx1.data
                            });
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
                if (ctx1.common.async) return Promise.resolve().then(/*#__PURE__*/ (0, $kSuI9._)(function() {
                    var syncPairs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, pair, key, _, _tmp, err;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                syncPairs = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    9
                                ]);
                                _iterator = pairs[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    6
                                ];
                                pair = _step.value;
                                return [
                                    4,
                                    pair.key
                                ];
                            case 3:
                                key = _state.sent();
                                _ = syncPairs.push;
                                _tmp = {
                                    key: key
                                };
                                return [
                                    4,
                                    pair.value
                                ];
                            case 4:
                                _.apply(syncPairs, [
                                    (_tmp.value = _state.sent(), _tmp.alwaysSet = pair.alwaysSet, _tmp)
                                ]);
                                _state.label = 5;
                            case 5:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                return [
                                    3,
                                    9
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 9:
                                return [
                                    2,
                                    syncPairs
                                ];
                        }
                    });
                })).then(function(syncPairs) {
                    return ParseStatus.mergeObjectSync(status, syncPairs);
                });
                else return ParseStatus.mergeObjectSync(status, pairs);
            }
        },
        {
            key: "shape",
            get: function get() {
                return this._def.shape();
            }
        },
        {
            key: "strict",
            value: function strict(message) {
                var _this = this;
                errorUtil.errToObj;
                return new ZodObject((0, $do9pw._)((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    unknownKeys: "strict"
                }), message !== undefined ? {
                    errorMap: function(issue, ctx) {
                        var _a, _b, _c, _d;
                        var defaultError = (_c = (_b = (_a = _this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                        if (issue.code === "unrecognized_keys") return {
                            message: (_d = errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                        };
                        return {
                            message: defaultError
                        };
                    }
                } : {}));
            }
        },
        {
            key: "strip",
            value: function strip() {
                return new ZodObject((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    unknownKeys: "strip"
                }));
            }
        },
        {
            key: "passthrough",
            value: function passthrough() {
                return new ZodObject((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    unknownKeys: "passthrough"
                }));
            }
        },
        {
            // const AugmentFactory =
            //   <Def extends ZodObjectDef>(def: Def) =>
            //   <Augmentation extends ZodRawShape>(
            //     augmentation: Augmentation
            //   ): ZodObject<
            //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
            //     Def["unknownKeys"],
            //     Def["catchall"]
            //   > => {
            //     return new ZodObject({
            //       ...def,
            //       shape: () => ({
            //         ...def.shape(),
            //         ...augmentation,
            //       }),
            //     }) as any;
            //   };
            key: "extend",
            value: function extend(augmentation) {
                var _this = this;
                return new ZodObject((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    shape: function() {
                        return (0, $do9pw._)({}, _this._def.shape(), augmentation);
                    }
                }));
            }
        },
        {
            /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ key: "merge",
            value: function merge(merging) {
                var _this = this;
                var merged = new ZodObject({
                    unknownKeys: merging._def.unknownKeys,
                    catchall: merging._def.catchall,
                    shape: function() {
                        return (0, $do9pw._)({}, _this._def.shape(), merging._def.shape());
                    },
                    typeName: ZodFirstPartyTypeKind.ZodObject
                });
                return merged;
            }
        },
        {
            // merge<
            //   Incoming extends AnyZodObject,
            //   Augmentation extends Incoming["shape"],
            //   NewOutput extends {
            //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
            //       ? Augmentation[k]["_output"]
            //       : k extends keyof Output
            //       ? Output[k]
            //       : never;
            //   },
            //   NewInput extends {
            //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
            //       ? Augmentation[k]["_input"]
            //       : k extends keyof Input
            //       ? Input[k]
            //       : never;
            //   }
            // >(
            //   merging: Incoming
            // ): ZodObject<
            //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
            //   Incoming["_def"]["unknownKeys"],
            //   Incoming["_def"]["catchall"],
            //   NewOutput,
            //   NewInput
            // > {
            //   const merged: any = new ZodObject({
            //     unknownKeys: merging._def.unknownKeys,
            //     catchall: merging._def.catchall,
            //     shape: () =>
            //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
            //     typeName: ZodFirstPartyTypeKind.ZodObject,
            //   }) as any;
            //   return merged;
            // }
            key: "setKey",
            value: function setKey(key, schema) {
                return this.augment((0, $3sHb8._)({}, key, schema));
            }
        },
        {
            // merge<Incoming extends AnyZodObject>(
            //   merging: Incoming
            // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
            // ZodObject<
            //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
            //   Incoming["_def"]["unknownKeys"],
            //   Incoming["_def"]["catchall"]
            // > {
            //   // const mergedShape = objectUtil.mergeShapes(
            //   //   this._def.shape(),
            //   //   merging._def.shape()
            //   // );
            //   const merged: any = new ZodObject({
            //     unknownKeys: merging._def.unknownKeys,
            //     catchall: merging._def.catchall,
            //     shape: () =>
            //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
            //     typeName: ZodFirstPartyTypeKind.ZodObject,
            //   }) as any;
            //   return merged;
            // }
            key: "catchall",
            value: function catchall(index) {
                return new ZodObject((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    catchall: index
                }));
            }
        },
        {
            key: "pick",
            value: function pick(mask) {
                var _this = this;
                var shape = {};
                util.objectKeys(mask).forEach(function(key) {
                    if (mask[key] && _this.shape[key]) shape[key] = _this.shape[key];
                });
                return new ZodObject((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    shape: function() {
                        return shape;
                    }
                }));
            }
        },
        {
            key: "omit",
            value: function omit(mask) {
                var _this = this;
                var shape = {};
                util.objectKeys(this.shape).forEach(function(key) {
                    if (!mask[key]) shape[key] = _this.shape[key];
                });
                return new ZodObject((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    shape: function() {
                        return shape;
                    }
                }));
            }
        },
        {
            /**
     * @deprecated
     */ key: "deepPartial",
            value: function deepPartial() {
                return deepPartialify(this);
            }
        },
        {
            key: "partial",
            value: function partial(mask) {
                var _this = this;
                var newShape = {};
                util.objectKeys(this.shape).forEach(function(key) {
                    var fieldSchema = _this.shape[key];
                    if (mask && !mask[key]) newShape[key] = fieldSchema;
                    else newShape[key] = fieldSchema.optional();
                });
                return new ZodObject((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    shape: function() {
                        return newShape;
                    }
                }));
            }
        },
        {
            key: "required",
            value: function required(mask) {
                var _this = this;
                var newShape = {};
                util.objectKeys(this.shape).forEach(function(key) {
                    if (mask && !mask[key]) newShape[key] = _this.shape[key];
                    else {
                        var fieldSchema = _this.shape[key];
                        var newField = fieldSchema;
                        while(newField instanceof ZodOptional)newField = newField._def.innerType;
                        newShape[key] = newField;
                    }
                });
                return new ZodObject((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    shape: function() {
                        return newShape;
                    }
                }));
            }
        },
        {
            key: "keyof",
            value: function keyof() {
                return createZodEnum(util.objectKeys(this.shape));
            }
        }
    ]);
    return ZodObject;
}(ZodType);
ZodObject.create = function(shape, params) {
    return new ZodObject((0, $do9pw._)({
        shape: function() {
            return shape;
        },
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject
    }, processCreateParams(params)));
};
ZodObject.strictCreate = function(shape, params) {
    return new ZodObject((0, $do9pw._)({
        shape: function() {
            return shape;
        },
        unknownKeys: "strict",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject
    }, processCreateParams(params)));
};
ZodObject.lazycreate = function(shape, params) {
    return new ZodObject((0, $do9pw._)({
        shape: shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject
    }, processCreateParams(params)));
};
var ZodUnion = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodUnion, ZodType);
    var _super = (0, $ohfOJ._)(ZodUnion);
    function ZodUnion() {
        (0, $4GJKx._)(this, ZodUnion);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodUnion, [
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._processInputParams(input).ctx;
                var options = this._def.options;
                function handleResults(results) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        // return first issue-free validation if it exists
                        for(var _iterator = results[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var result = _step.value;
                            if (result.result.status === "valid") return result.result;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = results[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var result1 = _step1.value;
                            if (result1.result.status === "dirty") {
                                var // add issues from dirty option
                                _ctx_common_issues;
                                (_ctx_common_issues = ctx.common.issues).push.apply(_ctx_common_issues, (0, $c6Xmf._)(result1.ctx.common.issues));
                                return result1.result;
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    // return invalid
                    var unionErrors = results.map(function(result) {
                        return new ZodError(result.ctx.common.issues);
                    });
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_union,
                        unionErrors: unionErrors
                    });
                    return INVALID;
                }
                if (ctx.common.async) return Promise.all(options.map(function() {
                    var _ref = (0, $kSuI9._)(function(option) {
                        var childCtx, _tmp;
                        return (0, $eha6O.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    childCtx = (0, $cxjpp._)((0, $do9pw._)({}, ctx), {
                                        common: (0, $cxjpp._)((0, $do9pw._)({}, ctx.common), {
                                            issues: []
                                        }),
                                        parent: null
                                    });
                                    _tmp = {};
                                    return [
                                        4,
                                        option._parseAsync({
                                            data: ctx.data,
                                            path: ctx.path,
                                            parent: childCtx
                                        })
                                    ];
                                case 1:
                                    return [
                                        2,
                                        (_tmp.result = _state.sent(), _tmp.ctx = childCtx, _tmp)
                                    ];
                            }
                        });
                    });
                    return function(option) {
                        return _ref.apply(this, arguments);
                    };
                }())).then(handleResults);
                else {
                    var dirty = undefined;
                    var issues = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var option = _step.value;
                            var childCtx = (0, $cxjpp._)((0, $do9pw._)({}, ctx), {
                                common: (0, $cxjpp._)((0, $do9pw._)({}, ctx.common), {
                                    issues: []
                                }),
                                parent: null
                            });
                            var result = option._parseSync({
                                data: ctx.data,
                                path: ctx.path,
                                parent: childCtx
                            });
                            if (result.status === "valid") return result;
                            else if (result.status === "dirty" && !dirty) dirty = {
                                result: result,
                                ctx: childCtx
                            };
                            if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (dirty) {
                        var _ctx_common_issues;
                        (_ctx_common_issues = ctx.common.issues).push.apply(_ctx_common_issues, (0, $c6Xmf._)(dirty.ctx.common.issues));
                        return dirty.result;
                    }
                    var unionErrors = issues.map(function(issues) {
                        return new ZodError(issues);
                    });
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_union,
                        unionErrors: unionErrors
                    });
                    return INVALID;
                }
            }
        },
        {
            key: "options",
            get: function get() {
                return this._def.options;
            }
        }
    ]);
    return ZodUnion;
}(ZodType);
ZodUnion.create = function(types, params) {
    return new ZodUnion((0, $do9pw._)({
        options: types,
        typeName: ZodFirstPartyTypeKind.ZodUnion
    }, processCreateParams(params)));
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
var getDiscriminator = function(type) {
    if (type instanceof ZodLazy) return getDiscriminator(type.schema);
    else if (type instanceof ZodEffects) return getDiscriminator(type.innerType());
    else if (type instanceof ZodLiteral) return [
        type.value
    ];
    else if (type instanceof ZodEnum) return type.options;
    else if (type instanceof ZodNativeEnum) // eslint-disable-next-line ban/ban
    return Object.keys(type.enum);
    else if (type instanceof ZodDefault) return getDiscriminator(type._def.innerType);
    else if (type instanceof ZodUndefined) return [
        undefined
    ];
    else if (type instanceof ZodNull) return [
        null
    ];
    else return null;
};
var ZodDiscriminatedUnion = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodDiscriminatedUnion, ZodType);
    var _super = (0, $ohfOJ._)(ZodDiscriminatedUnion);
    function ZodDiscriminatedUnion() {
        (0, $4GJKx._)(this, ZodDiscriminatedUnion);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodDiscriminatedUnion, [
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._processInputParams(input).ctx;
                if (ctx.parsedType !== ZodParsedType.object) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.object,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                var discriminator = this.discriminator;
                var discriminatorValue = ctx.data[discriminator];
                var option = this.optionsMap.get(discriminatorValue);
                if (!option) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_union_discriminator,
                        options: Array.from(this.optionsMap.keys()),
                        path: [
                            discriminator
                        ]
                    });
                    return INVALID;
                }
                if (ctx.common.async) return option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                else return option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
            }
        },
        {
            key: "discriminator",
            get: function get() {
                return this._def.discriminator;
            }
        },
        {
            key: "options",
            get: function get() {
                return this._def.options;
            }
        },
        {
            key: "optionsMap",
            get: function get() {
                return this._def.optionsMap;
            }
        }
    ], [
        {
            key: "create",
            value: /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ function create(discriminator, options, params) {
                // Get all the valid discriminator values
                var optionsMap = new Map();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // try {
                    for(var _iterator = options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var type = _step.value;
                        var discriminatorValues = getDiscriminator(type.shape[discriminator]);
                        if (!discriminatorValues) throw new Error("A discriminator value for key `".concat(discriminator, "` could not be extracted from all schema options"));
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = discriminatorValues[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var value = _step1.value;
                                if (optionsMap.has(value)) throw new Error("Discriminator property ".concat(String(discriminator), " has duplicate value ").concat(String(value)));
                                optionsMap.set(value, type);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return new ZodDiscriminatedUnion((0, $do9pw._)({
                    typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
                    discriminator: discriminator,
                    options: options,
                    optionsMap: optionsMap
                }, processCreateParams(params)));
            }
        }
    ]);
    return ZodDiscriminatedUnion;
}(ZodType);
function mergeValues(a, b) {
    var aType = getParsedType(a);
    var bType = getParsedType(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
        var bKeys = util.objectKeys(b);
        var sharedKeys = util.objectKeys(a).filter(function(key) {
            return bKeys.indexOf(key) !== -1;
        });
        var newObj = (0, $do9pw._)({}, a, b);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = sharedKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var sharedValue = mergeValues(a[key], b[key]);
                if (!sharedValue.valid) return {
                    valid: false
                };
                newObj[key] = sharedValue.data;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        var newArray = [];
        for(var index = 0; index < a.length; index++){
            var itemA = a[index];
            var itemB = b[index];
            var sharedValue1 = mergeValues(itemA, itemB);
            if (!sharedValue1.valid) return {
                valid: false
            };
            newArray.push(sharedValue1.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === ZodParsedType.date && bType === ZodParsedType.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
var ZodIntersection = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodIntersection, ZodType);
    var _super = (0, $ohfOJ._)(ZodIntersection);
    function ZodIntersection() {
        (0, $4GJKx._)(this, ZodIntersection);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodIntersection, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                var handleParsed = function(parsedLeft, parsedRight) {
                    if (isAborted(parsedLeft) || isAborted(parsedRight)) return INVALID;
                    var merged = mergeValues(parsedLeft.value, parsedRight.value);
                    if (!merged.valid) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.invalid_intersection_types
                        });
                        return INVALID;
                    }
                    if (isDirty(parsedLeft) || isDirty(parsedRight)) status.dirty();
                    return {
                        status: status.value,
                        value: merged.data
                    };
                };
                if (ctx.common.async) return Promise.all([
                    this._def.left._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: ctx
                    }),
                    this._def.right._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: ctx
                    })
                ]).then(function(param) {
                    var _param = (0, $cv9Rk._)(param, 2), left = _param[0], right = _param[1];
                    return handleParsed(left, right);
                });
                else return handleParsed(this._def.left._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                }), this._def.right._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                }));
            }
        }
    ]);
    return ZodIntersection;
}(ZodType);
ZodIntersection.create = function(left, right, params) {
    return new ZodIntersection((0, $do9pw._)({
        left: left,
        right: right,
        typeName: ZodFirstPartyTypeKind.ZodIntersection
    }, processCreateParams(params)));
};
var ZodTuple = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodTuple, ZodType);
    var _super = (0, $ohfOJ._)(ZodTuple);
    function ZodTuple() {
        (0, $4GJKx._)(this, ZodTuple);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodTuple, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this = this;
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                if (ctx.parsedType !== ZodParsedType.array) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.array,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                if (ctx.data.length < this._def.items.length) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        minimum: this._def.items.length,
                        inclusive: true,
                        exact: false,
                        type: "array"
                    });
                    return INVALID;
                }
                var rest = this._def.rest;
                if (!rest && ctx.data.length > this._def.items.length) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        maximum: this._def.items.length,
                        inclusive: true,
                        exact: false,
                        type: "array"
                    });
                    status.dirty();
                }
                var items = (0, $c6Xmf._)(ctx.data).map(function(item, itemIndex) {
                    var schema = _this._def.items[itemIndex] || _this._def.rest;
                    if (!schema) return null;
                    return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
                }).filter(function(x) {
                    return !!x;
                }); // filter nulls
                if (ctx.common.async) return Promise.all(items).then(function(results) {
                    return ParseStatus.mergeArray(status, results);
                });
                else return ParseStatus.mergeArray(status, items);
            }
        },
        {
            key: "items",
            get: function get() {
                return this._def.items;
            }
        },
        {
            key: "rest",
            value: function rest(rest) {
                return new ZodTuple((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    rest: rest
                }));
            }
        }
    ]);
    return ZodTuple;
}(ZodType);
ZodTuple.create = function(schemas, params) {
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new ZodTuple((0, $do9pw._)({
        items: schemas,
        typeName: ZodFirstPartyTypeKind.ZodTuple,
        rest: null
    }, processCreateParams(params)));
};
var ZodRecord = /*#__PURE__*/ function(ZodType1) {
    "use strict";
    (0, $dcsZi._)(ZodRecord, ZodType1);
    var _super = (0, $ohfOJ._)(ZodRecord);
    function ZodRecord() {
        (0, $4GJKx._)(this, ZodRecord);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodRecord, [
        {
            key: "keySchema",
            get: function get() {
                return this._def.keyType;
            }
        },
        {
            key: "valueSchema",
            get: function get() {
                return this._def.valueType;
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                if (ctx.parsedType !== ZodParsedType.object) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.object,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                var pairs = [];
                var keyType = this._def.keyType;
                var valueType = this._def.valueType;
                for(var key in ctx.data)pairs.push({
                    key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
                    value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key))
                });
                if (ctx.common.async) return ParseStatus.mergeObjectAsync(status, pairs);
                else return ParseStatus.mergeObjectSync(status, pairs);
            }
        },
        {
            key: "element",
            get: function get() {
                return this._def.valueType;
            }
        }
    ], [
        {
            key: "create",
            value: function create(first, second, third) {
                if (second instanceof ZodType) return new ZodRecord((0, $do9pw._)({
                    keyType: first,
                    valueType: second,
                    typeName: ZodFirstPartyTypeKind.ZodRecord
                }, processCreateParams(third)));
                return new ZodRecord((0, $do9pw._)({
                    keyType: ZodString.create(),
                    valueType: first,
                    typeName: ZodFirstPartyTypeKind.ZodRecord
                }, processCreateParams(second)));
            }
        }
    ]);
    return ZodRecord;
}(ZodType);
var ZodMap = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodMap, ZodType);
    var _super = (0, $ohfOJ._)(ZodMap);
    function ZodMap() {
        (0, $4GJKx._)(this, ZodMap);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodMap, [
        {
            key: "keySchema",
            get: function get() {
                return this._def.keyType;
            }
        },
        {
            key: "valueSchema",
            get: function get() {
                return this._def.valueType;
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                if (ctx.parsedType !== ZodParsedType.map) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.map,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                var keyType = this._def.keyType;
                var valueType = this._def.valueType;
                var pairs = (0, $c6Xmf._)(ctx.data.entries()).map(function(param, index) {
                    var _param = (0, $cv9Rk._)(param, 2), key = _param[0], value = _param[1];
                    return {
                        key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [
                            index,
                            "key"
                        ])),
                        value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [
                            index,
                            "value"
                        ]))
                    };
                });
                if (ctx.common.async) {
                    var finalMap = new Map();
                    return Promise.resolve().then(/*#__PURE__*/ (0, $kSuI9._)(function() {
                        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, pair, key, value, err;
                        return (0, $eha6O.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        7,
                                        8,
                                        9
                                    ]);
                                    _iterator = pairs[Symbol.iterator]();
                                    _state.label = 2;
                                case 2:
                                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                        3,
                                        6
                                    ];
                                    pair = _step.value;
                                    return [
                                        4,
                                        pair.key
                                    ];
                                case 3:
                                    key = _state.sent();
                                    return [
                                        4,
                                        pair.value
                                    ];
                                case 4:
                                    value = _state.sent();
                                    if (key.status === "aborted" || value.status === "aborted") return [
                                        2,
                                        INVALID
                                    ];
                                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                                    finalMap.set(key.value, value.value);
                                    _state.label = 5;
                                case 5:
                                    _iteratorNormalCompletion = true;
                                    return [
                                        3,
                                        2
                                    ];
                                case 6:
                                    return [
                                        3,
                                        9
                                    ];
                                case 7:
                                    err = _state.sent();
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                    return [
                                        3,
                                        9
                                    ];
                                case 8:
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                    return [
                                        7
                                    ];
                                case 9:
                                    return [
                                        2,
                                        {
                                            status: status.value,
                                            value: finalMap
                                        }
                                    ];
                            }
                        });
                    }));
                } else {
                    var finalMap1 = new Map();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = pairs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var pair = _step.value;
                            var key = pair.key;
                            var value = pair.value;
                            if (key.status === "aborted" || value.status === "aborted") return INVALID;
                            if (key.status === "dirty" || value.status === "dirty") status.dirty();
                            finalMap1.set(key.value, value.value);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return {
                        status: status.value,
                        value: finalMap1
                    };
                }
            }
        }
    ]);
    return ZodMap;
}(ZodType);
ZodMap.create = function(keyType, valueType, params) {
    return new ZodMap((0, $do9pw._)({
        valueType: valueType,
        keyType: keyType,
        typeName: ZodFirstPartyTypeKind.ZodMap
    }, processCreateParams(params)));
};
var ZodSet = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodSet, ZodType);
    var _super = (0, $ohfOJ._)(ZodSet);
    function ZodSet() {
        (0, $4GJKx._)(this, ZodSet);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodSet, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                if (ctx.parsedType !== ZodParsedType.set) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.set,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                var def = this._def;
                if (def.minSize !== null) {
                    if (ctx.data.size < def.minSize.value) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.too_small,
                            minimum: def.minSize.value,
                            type: "set",
                            inclusive: true,
                            exact: false,
                            message: def.minSize.message
                        });
                        status.dirty();
                    }
                }
                if (def.maxSize !== null) {
                    if (ctx.data.size > def.maxSize.value) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.too_big,
                            maximum: def.maxSize.value,
                            type: "set",
                            inclusive: true,
                            exact: false,
                            message: def.maxSize.message
                        });
                        status.dirty();
                    }
                }
                var valueType = this._def.valueType;
                function finalizeSet(elements) {
                    var parsedSet = new Set();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var element = _step.value;
                            if (element.status === "aborted") return INVALID;
                            if (element.status === "dirty") status.dirty();
                            parsedSet.add(element.value);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return {
                        status: status.value,
                        value: parsedSet
                    };
                }
                var elements = (0, $c6Xmf._)(ctx.data.values()).map(function(item, i) {
                    return valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i));
                });
                if (ctx.common.async) return Promise.all(elements).then(function(elements) {
                    return finalizeSet(elements);
                });
                else return finalizeSet(elements);
            }
        },
        {
            key: "min",
            value: function min(minSize, message) {
                return new ZodSet((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    minSize: {
                        value: minSize,
                        message: errorUtil.toString(message)
                    }
                }));
            }
        },
        {
            key: "max",
            value: function max(maxSize, message) {
                return new ZodSet((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    maxSize: {
                        value: maxSize,
                        message: errorUtil.toString(message)
                    }
                }));
            }
        },
        {
            key: "size",
            value: function size(size, message) {
                return this.min(size, message).max(size, message);
            }
        },
        {
            key: "nonempty",
            value: function nonempty(message) {
                return this.min(1, message);
            }
        }
    ]);
    return ZodSet;
}(ZodType);
ZodSet.create = function(valueType, params) {
    return new ZodSet((0, $do9pw._)({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: ZodFirstPartyTypeKind.ZodSet
    }, processCreateParams(params)));
};
var ZodFunction = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodFunction, ZodType);
    var _super = (0, $ohfOJ._)(ZodFunction);
    function ZodFunction() {
        (0, $4GJKx._)(this, ZodFunction);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.validate = _this.implement;
        return _this;
    }
    (0, $1wc17._)(ZodFunction, [
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._processInputParams(input).ctx;
                if (ctx.parsedType !== ZodParsedType.function) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.function,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                function makeArgsIssue(args, error) {
                    return makeIssue({
                        data: args,
                        path: ctx.path,
                        errorMaps: [
                            ctx.common.contextualErrorMap,
                            ctx.schemaErrorMap,
                            getErrorMap(),
                            errorMap
                        ].filter(function(x) {
                            return !!x;
                        }),
                        issueData: {
                            code: ZodIssueCode.invalid_arguments,
                            argumentsError: error
                        }
                    });
                }
                function makeReturnsIssue(returns, error) {
                    return makeIssue({
                        data: returns,
                        path: ctx.path,
                        errorMaps: [
                            ctx.common.contextualErrorMap,
                            ctx.schemaErrorMap,
                            getErrorMap(),
                            errorMap
                        ].filter(function(x) {
                            return !!x;
                        }),
                        issueData: {
                            code: ZodIssueCode.invalid_return_type,
                            returnTypeError: error
                        }
                    });
                }
                var params = {
                    errorMap: ctx.common.contextualErrorMap
                };
                var fn = ctx.data;
                if (this._def.returns instanceof ZodPromise) {
                    // Would love a way to avoid disabling this rule, but we need
                    // an alias (using an arrow function was what caused 2651).
                    // eslint-disable-next-line @typescript-eslint/no-this-alias
                    var me = this;
                    return OK(/*#__PURE__*/ (0, $kSuI9._)(function() {
                        var _len, args, _key, error, parsedArgs, result, parsedReturns;
                        var _arguments = arguments;
                        return (0, $eha6O.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                        args[_key] = _arguments[_key];
                                    }
                                    error = new ZodError([]);
                                    return [
                                        4,
                                        me._def.args.parseAsync(args, params).catch(function(e) {
                                            error.addIssue(makeArgsIssue(args, e));
                                            throw error;
                                        })
                                    ];
                                case 1:
                                    parsedArgs = _state.sent();
                                    return [
                                        4,
                                        Reflect.apply(fn, this, parsedArgs)
                                    ];
                                case 2:
                                    result = _state.sent();
                                    return [
                                        4,
                                        me._def.returns._def.type.parseAsync(result, params).catch(function(e) {
                                            error.addIssue(makeReturnsIssue(result, e));
                                            throw error;
                                        })
                                    ];
                                case 3:
                                    parsedReturns = _state.sent();
                                    return [
                                        2,
                                        parsedReturns
                                    ];
                            }
                        });
                    }));
                } else {
                    // Would love a way to avoid disabling this rule, but we need
                    // an alias (using an arrow function was what caused 2651).
                    // eslint-disable-next-line @typescript-eslint/no-this-alias
                    var me1 = this;
                    return OK(function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        var parsedArgs = me1._def.args.safeParse(args, params);
                        if (!parsedArgs.success) throw new ZodError([
                            makeArgsIssue(args, parsedArgs.error)
                        ]);
                        var result = Reflect.apply(fn, this, parsedArgs.data);
                        var parsedReturns = me1._def.returns.safeParse(result, params);
                        if (!parsedReturns.success) throw new ZodError([
                            makeReturnsIssue(result, parsedReturns.error)
                        ]);
                        return parsedReturns.data;
                    });
                }
            }
        },
        {
            key: "parameters",
            value: function parameters() {
                return this._def.args;
            }
        },
        {
            key: "returnType",
            value: function returnType() {
                return this._def.returns;
            }
        },
        {
            key: "args",
            value: function args() {
                for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
                    items[_key] = arguments[_key];
                }
                return new ZodFunction((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    args: ZodTuple.create(items).rest(ZodUnknown.create())
                }));
            }
        },
        {
            key: "returns",
            value: function returns(returnType) {
                return new ZodFunction((0, $cxjpp._)((0, $do9pw._)({}, this._def), {
                    returns: returnType
                }));
            }
        },
        {
            key: "implement",
            value: function implement(func) {
                var validatedFunc = this.parse(func);
                return validatedFunc;
            }
        },
        {
            key: "strictImplement",
            value: function strictImplement(func) {
                var validatedFunc = this.parse(func);
                return validatedFunc;
            }
        }
    ], [
        {
            key: "create",
            value: function create(args, returns, params) {
                return new ZodFunction((0, $do9pw._)({
                    args: args ? args : ZodTuple.create([]).rest(ZodUnknown.create()),
                    returns: returns || ZodUnknown.create(),
                    typeName: ZodFirstPartyTypeKind.ZodFunction
                }, processCreateParams(params)));
            }
        }
    ]);
    return ZodFunction;
}(ZodType);
var ZodLazy = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodLazy, ZodType);
    var _super = (0, $ohfOJ._)(ZodLazy);
    function ZodLazy() {
        (0, $4GJKx._)(this, ZodLazy);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodLazy, [
        {
            key: "schema",
            get: function get() {
                return this._def.getter();
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._processInputParams(input).ctx;
                var lazySchema = this._def.getter();
                return lazySchema._parse({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
            }
        }
    ]);
    return ZodLazy;
}(ZodType);
ZodLazy.create = function(getter, params) {
    return new ZodLazy((0, $do9pw._)({
        getter: getter,
        typeName: ZodFirstPartyTypeKind.ZodLazy
    }, processCreateParams(params)));
};
var ZodLiteral = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodLiteral, ZodType);
    var _super = (0, $ohfOJ._)(ZodLiteral);
    function ZodLiteral() {
        (0, $4GJKx._)(this, ZodLiteral);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodLiteral, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (input.data !== this._def.value) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        received: ctx.data,
                        code: ZodIssueCode.invalid_literal,
                        expected: this._def.value
                    });
                    return INVALID;
                }
                return {
                    status: "valid",
                    value: input.data
                };
            }
        },
        {
            key: "value",
            get: function get() {
                return this._def.value;
            }
        }
    ]);
    return ZodLiteral;
}(ZodType);
ZodLiteral.create = function(value, params) {
    return new ZodLiteral((0, $do9pw._)({
        value: value,
        typeName: ZodFirstPartyTypeKind.ZodLiteral
    }, processCreateParams(params)));
};
function createZodEnum(values, params) {
    return new ZodEnum((0, $do9pw._)({
        values: values,
        typeName: ZodFirstPartyTypeKind.ZodEnum
    }, processCreateParams(params)));
}
var ZodEnum = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodEnum, ZodType);
    var _super = (0, $ohfOJ._)(ZodEnum);
    function ZodEnum() {
        (0, $4GJKx._)(this, ZodEnum);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodEnum, [
        {
            key: "_parse",
            value: function _parse(input) {
                if (typeof input.data !== "string") {
                    var ctx = this._getOrReturnCtx(input);
                    var expectedValues = this._def.values;
                    addIssueToContext(ctx, {
                        expected: util.joinValues(expectedValues),
                        received: ctx.parsedType,
                        code: ZodIssueCode.invalid_type
                    });
                    return INVALID;
                }
                if (this._def.values.indexOf(input.data) === -1) {
                    var ctx1 = this._getOrReturnCtx(input);
                    var expectedValues1 = this._def.values;
                    addIssueToContext(ctx1, {
                        received: ctx1.data,
                        code: ZodIssueCode.invalid_enum_value,
                        options: expectedValues1
                    });
                    return INVALID;
                }
                return OK(input.data);
            }
        },
        {
            key: "options",
            get: function get() {
                return this._def.values;
            }
        },
        {
            key: "enum",
            get: function get() {
                var enumValues = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var val = _step.value;
                        enumValues[val] = val;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return enumValues;
            }
        },
        {
            key: "Values",
            get: function get() {
                var enumValues = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var val = _step.value;
                        enumValues[val] = val;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return enumValues;
            }
        },
        {
            key: "Enum",
            get: function get() {
                var enumValues = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._def.values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var val = _step.value;
                        enumValues[val] = val;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return enumValues;
            }
        },
        {
            key: "extract",
            value: function extract(values) {
                return ZodEnum.create(values);
            }
        },
        {
            key: "exclude",
            value: function exclude(values) {
                return ZodEnum.create(this.options.filter(function(opt) {
                    return !values.includes(opt);
                }));
            }
        }
    ]);
    return ZodEnum;
}(ZodType);
ZodEnum.create = createZodEnum;
var ZodNativeEnum = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodNativeEnum, ZodType);
    var _super = (0, $ohfOJ._)(ZodNativeEnum);
    function ZodNativeEnum() {
        (0, $4GJKx._)(this, ZodNativeEnum);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodNativeEnum, [
        {
            key: "_parse",
            value: function _parse(input) {
                var nativeEnumValues = util.getValidEnumValues(this._def.values);
                var ctx = this._getOrReturnCtx(input);
                if (ctx.parsedType !== ZodParsedType.string && ctx.parsedType !== ZodParsedType.number) {
                    var expectedValues = util.objectValues(nativeEnumValues);
                    addIssueToContext(ctx, {
                        expected: util.joinValues(expectedValues),
                        received: ctx.parsedType,
                        code: ZodIssueCode.invalid_type
                    });
                    return INVALID;
                }
                if (nativeEnumValues.indexOf(input.data) === -1) {
                    var expectedValues1 = util.objectValues(nativeEnumValues);
                    addIssueToContext(ctx, {
                        received: ctx.data,
                        code: ZodIssueCode.invalid_enum_value,
                        options: expectedValues1
                    });
                    return INVALID;
                }
                return OK(input.data);
            }
        },
        {
            key: "enum",
            get: function get() {
                return this._def.values;
            }
        }
    ]);
    return ZodNativeEnum;
}(ZodType);
ZodNativeEnum.create = function(values, params) {
    return new ZodNativeEnum((0, $do9pw._)({
        values: values,
        typeName: ZodFirstPartyTypeKind.ZodNativeEnum
    }, processCreateParams(params)));
};
var ZodPromise = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodPromise, ZodType);
    var _super = (0, $ohfOJ._)(ZodPromise);
    function ZodPromise() {
        (0, $4GJKx._)(this, ZodPromise);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodPromise, [
        {
            key: "unwrap",
            value: function unwrap() {
                return this._def.type;
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var _this = this;
                var ctx = this._processInputParams(input).ctx;
                if (ctx.parsedType !== ZodParsedType.promise && ctx.common.async === false) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.promise,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                var promisified = ctx.parsedType === ZodParsedType.promise ? ctx.data : Promise.resolve(ctx.data);
                return OK(promisified.then(function(data) {
                    return _this._def.type.parseAsync(data, {
                        path: ctx.path,
                        errorMap: ctx.common.contextualErrorMap
                    });
                }));
            }
        }
    ]);
    return ZodPromise;
}(ZodType);
ZodPromise.create = function(schema, params) {
    return new ZodPromise((0, $do9pw._)({
        type: schema,
        typeName: ZodFirstPartyTypeKind.ZodPromise
    }, processCreateParams(params)));
};
var ZodEffects = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodEffects, ZodType);
    var _super = (0, $ohfOJ._)(ZodEffects);
    function ZodEffects() {
        (0, $4GJKx._)(this, ZodEffects);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodEffects, [
        {
            key: "innerType",
            value: function innerType() {
                return this._def.schema;
            }
        },
        {
            key: "sourceType",
            value: function sourceType() {
                return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
            }
        },
        {
            key: "_parse",
            value: function _parse(input) {
                var _this = this;
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                var effect = this._def.effect || null;
                var checkCtx = {
                    addIssue: function(arg) {
                        addIssueToContext(ctx, arg);
                        if (arg.fatal) status.abort();
                        else status.dirty();
                    },
                    get path () {
                        return ctx.path;
                    }
                };
                checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
                if (effect.type === "preprocess") {
                    var processed = effect.transform(ctx.data, checkCtx);
                    if (ctx.common.issues.length) return {
                        status: "dirty",
                        value: ctx.data
                    };
                    if (ctx.common.async) return Promise.resolve(processed).then(function(processed) {
                        return _this._def.schema._parseAsync({
                            data: processed,
                            path: ctx.path,
                            parent: ctx
                        });
                    });
                    else return this._def.schema._parseSync({
                        data: processed,
                        path: ctx.path,
                        parent: ctx
                    });
                }
                if (effect.type === "refinement") {
                    var executeRefinement = function(acc) {
                        var result = effect.refinement(acc, checkCtx);
                        if (ctx.common.async) return Promise.resolve(result);
                        if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                        return acc;
                    };
                    if (ctx.common.async === false) {
                        var inner = this._def.schema._parseSync({
                            data: ctx.data,
                            path: ctx.path,
                            parent: ctx
                        });
                        if (inner.status === "aborted") return INVALID;
                        if (inner.status === "dirty") status.dirty();
                        // return value is ignored
                        executeRefinement(inner.value);
                        return {
                            status: status.value,
                            value: inner.value
                        };
                    } else return this._def.schema._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: ctx
                    }).then(function(inner) {
                        if (inner.status === "aborted") return INVALID;
                        if (inner.status === "dirty") status.dirty();
                        return executeRefinement(inner.value).then(function() {
                            return {
                                status: status.value,
                                value: inner.value
                            };
                        });
                    });
                }
                if (effect.type === "transform") {
                    if (ctx.common.async === false) {
                        var base = this._def.schema._parseSync({
                            data: ctx.data,
                            path: ctx.path,
                            parent: ctx
                        });
                        if (!isValid(base)) return base;
                        var result = effect.transform(base.value, checkCtx);
                        if (result instanceof Promise) throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
                        return {
                            status: status.value,
                            value: result
                        };
                    } else return this._def.schema._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: ctx
                    }).then(function(base) {
                        if (!isValid(base)) return base;
                        return Promise.resolve(effect.transform(base.value, checkCtx)).then(function(result) {
                            return {
                                status: status.value,
                                value: result
                            };
                        });
                    });
                }
                util.assertNever(effect);
            }
        }
    ]);
    return ZodEffects;
}(ZodType);
ZodEffects.create = function(schema, effect, params) {
    return new ZodEffects((0, $do9pw._)({
        schema: schema,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect: effect
    }, processCreateParams(params)));
};
ZodEffects.createWithPreprocess = function(preprocess, schema, params) {
    return new ZodEffects((0, $do9pw._)({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: ZodFirstPartyTypeKind.ZodEffects
    }, processCreateParams(params)));
};
var ZodOptional = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodOptional, ZodType);
    var _super = (0, $ohfOJ._)(ZodOptional);
    function ZodOptional() {
        (0, $4GJKx._)(this, ZodOptional);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodOptional, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType === ZodParsedType.undefined) return OK(undefined);
                return this._def.innerType._parse(input);
            }
        },
        {
            key: "unwrap",
            value: function unwrap() {
                return this._def.innerType;
            }
        }
    ]);
    return ZodOptional;
}(ZodType);
ZodOptional.create = function(type, params) {
    return new ZodOptional((0, $do9pw._)({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodOptional
    }, processCreateParams(params)));
};
var ZodNullable = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodNullable, ZodType);
    var _super = (0, $ohfOJ._)(ZodNullable);
    function ZodNullable() {
        (0, $4GJKx._)(this, ZodNullable);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodNullable, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType === ZodParsedType.null) return OK(null);
                return this._def.innerType._parse(input);
            }
        },
        {
            key: "unwrap",
            value: function unwrap() {
                return this._def.innerType;
            }
        }
    ]);
    return ZodNullable;
}(ZodType);
ZodNullable.create = function(type, params) {
    return new ZodNullable((0, $do9pw._)({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodNullable
    }, processCreateParams(params)));
};
var ZodDefault = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodDefault, ZodType);
    var _super = (0, $ohfOJ._)(ZodDefault);
    function ZodDefault() {
        (0, $4GJKx._)(this, ZodDefault);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodDefault, [
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._processInputParams(input).ctx;
                var data = ctx.data;
                if (ctx.parsedType === ZodParsedType.undefined) data = this._def.defaultValue();
                return this._def.innerType._parse({
                    data: data,
                    path: ctx.path,
                    parent: ctx
                });
            }
        },
        {
            key: "removeDefault",
            value: function removeDefault() {
                return this._def.innerType;
            }
        }
    ]);
    return ZodDefault;
}(ZodType);
ZodDefault.create = function(type, params) {
    return new ZodDefault((0, $do9pw._)({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : function() {
            return params.default;
        }
    }, processCreateParams(params)));
};
var ZodCatch = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodCatch, ZodType);
    var _super = (0, $ohfOJ._)(ZodCatch);
    function ZodCatch() {
        (0, $4GJKx._)(this, ZodCatch);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodCatch, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this = this;
                var ctx = this._processInputParams(input).ctx;
                // newCtx is used to not collect issues from inner types in ctx
                var newCtx = (0, $cxjpp._)((0, $do9pw._)({}, ctx), {
                    common: (0, $cxjpp._)((0, $do9pw._)({}, ctx.common), {
                        issues: []
                    })
                });
                var result = this._def.innerType._parse({
                    data: newCtx.data,
                    path: newCtx.path,
                    parent: (0, $do9pw._)({}, newCtx)
                });
                if (isAsync(result)) return result.then(function(result) {
                    return {
                        status: "valid",
                        value: result.status === "valid" ? result.value : _this._def.catchValue({
                            get error () {
                                return new ZodError(newCtx.common.issues);
                            },
                            input: newCtx.data
                        })
                    };
                });
                else return {
                    status: "valid",
                    value: result.status === "valid" ? result.value : this._def.catchValue({
                        get error () {
                            return new ZodError(newCtx.common.issues);
                        },
                        input: newCtx.data
                    })
                };
            }
        },
        {
            key: "removeCatch",
            value: function removeCatch() {
                return this._def.innerType;
            }
        }
    ]);
    return ZodCatch;
}(ZodType);
ZodCatch.create = function(type, params) {
    return new ZodCatch((0, $do9pw._)({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : function() {
            return params.catch;
        }
    }, processCreateParams(params)));
};
var ZodNaN = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodNaN, ZodType);
    var _super = (0, $ohfOJ._)(ZodNaN);
    function ZodNaN() {
        (0, $4GJKx._)(this, ZodNaN);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodNaN, [
        {
            key: "_parse",
            value: function _parse(input) {
                var parsedType = this._getType(input);
                if (parsedType !== ZodParsedType.nan) {
                    var ctx = this._getOrReturnCtx(input);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: ZodParsedType.nan,
                        received: ctx.parsedType
                    });
                    return INVALID;
                }
                return {
                    status: "valid",
                    value: input.data
                };
            }
        }
    ]);
    return ZodNaN;
}(ZodType);
ZodNaN.create = function(params) {
    return new ZodNaN((0, $do9pw._)({
        typeName: ZodFirstPartyTypeKind.ZodNaN
    }, processCreateParams(params)));
};
var BRAND = Symbol("zod_brand");
var ZodBranded = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodBranded, ZodType);
    var _super = (0, $ohfOJ._)(ZodBranded);
    function ZodBranded() {
        (0, $4GJKx._)(this, ZodBranded);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodBranded, [
        {
            key: "_parse",
            value: function _parse(input) {
                var ctx = this._processInputParams(input).ctx;
                var data = ctx.data;
                return this._def.type._parse({
                    data: data,
                    path: ctx.path,
                    parent: ctx
                });
            }
        },
        {
            key: "unwrap",
            value: function unwrap() {
                return this._def.type;
            }
        }
    ]);
    return ZodBranded;
}(ZodType);
var ZodPipeline = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodPipeline, ZodType);
    var _super = (0, $ohfOJ._)(ZodPipeline);
    function ZodPipeline() {
        (0, $4GJKx._)(this, ZodPipeline);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodPipeline, [
        {
            key: "_parse",
            value: function _parse(input) {
                var _this__processInputParams = this._processInputParams(input), status = _this__processInputParams.status, ctx = _this__processInputParams.ctx;
                if (ctx.common.async) {
                    var _this = this;
                    var handleAsync = function() {
                        var _ref = (0, $kSuI9._)(function() {
                            var inResult;
                            return (0, $eha6O.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            _this._def.in._parseAsync({
                                                data: ctx.data,
                                                path: ctx.path,
                                                parent: ctx
                                            })
                                        ];
                                    case 1:
                                        inResult = _state.sent();
                                        if (inResult.status === "aborted") return [
                                            2,
                                            INVALID
                                        ];
                                        if (inResult.status === "dirty") {
                                            status.dirty();
                                            return [
                                                2,
                                                DIRTY(inResult.value)
                                            ];
                                        } else return [
                                            2,
                                            _this._def.out._parseAsync({
                                                data: inResult.value,
                                                path: ctx.path,
                                                parent: ctx
                                            })
                                        ];
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function handleAsync() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    return handleAsync();
                } else {
                    var inResult = this._def.in._parseSync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: ctx
                    });
                    if (inResult.status === "aborted") return INVALID;
                    if (inResult.status === "dirty") {
                        status.dirty();
                        return {
                            status: "dirty",
                            value: inResult.value
                        };
                    } else return this._def.out._parseSync({
                        data: inResult.value,
                        path: ctx.path,
                        parent: ctx
                    });
                }
            }
        }
    ], [
        {
            key: "create",
            value: function create(a, b) {
                return new ZodPipeline({
                    in: a,
                    out: b,
                    typeName: ZodFirstPartyTypeKind.ZodPipeline
                });
            }
        }
    ]);
    return ZodPipeline;
}(ZodType);
var ZodReadonly = /*#__PURE__*/ function(ZodType) {
    "use strict";
    (0, $dcsZi._)(ZodReadonly, ZodType);
    var _super = (0, $ohfOJ._)(ZodReadonly);
    function ZodReadonly() {
        (0, $4GJKx._)(this, ZodReadonly);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ZodReadonly, [
        {
            key: "_parse",
            value: function _parse(input) {
                var result = this._def.innerType._parse(input);
                if (isValid(result)) result.value = Object.freeze(result.value);
                return result;
            }
        }
    ]);
    return ZodReadonly;
}(ZodType);
ZodReadonly.create = function(type, params) {
    return new ZodReadonly((0, $do9pw._)({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodReadonly
    }, processCreateParams(params)));
};
var custom = function(check) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal = arguments.length > 2 ? arguments[2] : void 0;
    if (check) return ZodAny.create().superRefine(function(data, ctx) {
        var _a, _b;
        if (!check(data)) {
            var p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            var _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            var p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue((0, $cxjpp._)((0, $do9pw._)({
                code: "custom"
            }, p2), {
                fatal: _fatal
            }));
        }
    });
    return ZodAny.create();
};
var late = {
    object: ZodObject.lazycreate
};
var ZodFirstPartyTypeKind;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
var instanceOfType = function(// const instanceOfType = <T extends new (...args: any[]) => any>(
cls) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        message: "Input not instance of ".concat(cls.name)
    };
    return custom(function(data) {
        return data instanceof cls;
    }, params);
};
var stringType = ZodString.create;
var numberType = ZodNumber.create;
var nanType = ZodNaN.create;
var bigIntType = ZodBigInt.create;
var booleanType = ZodBoolean.create;
var dateType = ZodDate.create;
var symbolType = ZodSymbol.create;
var undefinedType = ZodUndefined.create;
var nullType = ZodNull.create;
var anyType = ZodAny.create;
var unknownType = ZodUnknown.create;
var neverType = ZodNever.create;
var voidType = ZodVoid.create;
var arrayType = ZodArray.create;
var objectType = ZodObject.create;
var strictObjectType = ZodObject.strictCreate;
var unionType = ZodUnion.create;
var discriminatedUnionType = ZodDiscriminatedUnion.create;
var intersectionType = ZodIntersection.create;
var tupleType = ZodTuple.create;
var recordType = ZodRecord.create;
var mapType = ZodMap.create;
var setType = ZodSet.create;
var functionType = ZodFunction.create;
var lazyType = ZodLazy.create;
var literalType = ZodLiteral.create;
var enumType = ZodEnum.create;
var nativeEnumType = ZodNativeEnum.create;
var promiseType = ZodPromise.create;
var effectsType = ZodEffects.create;
var optionalType = ZodOptional.create;
var nullableType = ZodNullable.create;
var preprocessType = ZodEffects.createWithPreprocess;
var pipelineType = ZodPipeline.create;
var ostring = function() {
    return stringType().optional();
};
var onumber = function() {
    return numberType().optional();
};
var oboolean = function() {
    return booleanType().optional();
};
var coerce = {
    string: function(arg) {
        return ZodString.create((0, $cxjpp._)((0, $do9pw._)({}, arg), {
            coerce: true
        }));
    },
    number: function(arg) {
        return ZodNumber.create((0, $cxjpp._)((0, $do9pw._)({}, arg), {
            coerce: true
        }));
    },
    boolean: function(arg) {
        return ZodBoolean.create((0, $cxjpp._)((0, $do9pw._)({}, arg), {
            coerce: true
        }));
    },
    bigint: function(arg) {
        return ZodBigInt.create((0, $cxjpp._)((0, $do9pw._)({}, arg), {
            coerce: true
        }));
    },
    date: function(arg) {
        return ZodDate.create((0, $cxjpp._)((0, $do9pw._)({}, arg), {
            coerce: true
        }));
    }
};
var NEVER = INVALID;
var z = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: errorMap,
    setErrorMap: setErrorMap,
    getErrorMap: getErrorMap,
    makeIssue: makeIssue,
    EMPTY_PATH: EMPTY_PATH,
    addIssueToContext: addIssueToContext,
    ParseStatus: ParseStatus,
    INVALID: INVALID,
    DIRTY: DIRTY,
    OK: OK,
    isAborted: isAborted,
    isDirty: isDirty,
    isValid: isValid,
    isAsync: isAsync,
    get util () {
        return util;
    },
    get objectUtil () {
        return objectUtil;
    },
    ZodParsedType: ZodParsedType,
    getParsedType: getParsedType,
    ZodType: ZodType,
    ZodString: ZodString,
    ZodNumber: ZodNumber,
    ZodBigInt: ZodBigInt,
    ZodBoolean: ZodBoolean,
    ZodDate: ZodDate,
    ZodSymbol: ZodSymbol,
    ZodUndefined: ZodUndefined,
    ZodNull: ZodNull,
    ZodAny: ZodAny,
    ZodUnknown: ZodUnknown,
    ZodNever: ZodNever,
    ZodVoid: ZodVoid,
    ZodArray: ZodArray,
    ZodObject: ZodObject,
    ZodUnion: ZodUnion,
    ZodDiscriminatedUnion: ZodDiscriminatedUnion,
    ZodIntersection: ZodIntersection,
    ZodTuple: ZodTuple,
    ZodRecord: ZodRecord,
    ZodMap: ZodMap,
    ZodSet: ZodSet,
    ZodFunction: ZodFunction,
    ZodLazy: ZodLazy,
    ZodLiteral: ZodLiteral,
    ZodEnum: ZodEnum,
    ZodNativeEnum: ZodNativeEnum,
    ZodPromise: ZodPromise,
    ZodEffects: ZodEffects,
    ZodTransformer: ZodEffects,
    ZodOptional: ZodOptional,
    ZodNullable: ZodNullable,
    ZodDefault: ZodDefault,
    ZodCatch: ZodCatch,
    ZodNaN: ZodNaN,
    BRAND: BRAND,
    ZodBranded: ZodBranded,
    ZodPipeline: ZodPipeline,
    ZodReadonly: ZodReadonly,
    custom: custom,
    Schema: ZodType,
    ZodSchema: ZodType,
    late: late,
    get ZodFirstPartyTypeKind () {
        return ZodFirstPartyTypeKind;
    },
    coerce: coerce,
    any: anyType,
    array: arrayType,
    bigint: bigIntType,
    boolean: booleanType,
    date: dateType,
    discriminatedUnion: discriminatedUnionType,
    effect: effectsType,
    "enum": enumType,
    "function": functionType,
    "instanceof": instanceOfType,
    intersection: intersectionType,
    lazy: lazyType,
    literal: literalType,
    map: mapType,
    nan: nanType,
    nativeEnum: nativeEnumType,
    never: neverType,
    "null": nullType,
    nullable: nullableType,
    number: numberType,
    object: objectType,
    oboolean: oboolean,
    onumber: onumber,
    optional: optionalType,
    ostring: ostring,
    pipeline: pipelineType,
    preprocess: preprocessType,
    promise: promiseType,
    record: recordType,
    set: setType,
    strictObject: strictObjectType,
    string: stringType,
    symbol: symbolType,
    transformer: effectsType,
    tuple: tupleType,
    "undefined": undefinedType,
    union: unionType,
    unknown: unknownType,
    "void": voidType,
    NEVER: NEVER,
    ZodIssueCode: ZodIssueCode,
    quotelessJson: quotelessJson,
    ZodError: ZodError
});

});


parcelRegister("2ZXsZ", function(module, exports) {

$parcel$export(module.exports, "W3mFrameHelpers", function () { return $22ef681b8ff5be3b$export$794efc40d8765bc4; });

var $giFXM = parcelRequire("giFXM");

var $cSJ4o = parcelRequire("cSJ4o");

var $clcqH = parcelRequire("clcqH");
var $22ef681b8ff5be3b$var$EMAIL_MINIMUM_TIMEOUT = 30000;
var $22ef681b8ff5be3b$export$794efc40d8765bc4 = {
    checkIfAllowedToTriggerEmail: function() {
        var lastEmailLoginTime = (0, $giFXM.W3mFrameStorage).get((0, $cSJ4o.W3mFrameConstants).LAST_EMAIL_LOGIN_TIME);
        if (lastEmailLoginTime) {
            var difference = Date.now() - Number(lastEmailLoginTime);
            if (difference < $22ef681b8ff5be3b$var$EMAIL_MINIMUM_TIMEOUT) {
                var cooldownSec = Math.ceil(($22ef681b8ff5be3b$var$EMAIL_MINIMUM_TIMEOUT - difference) / 1000);
                throw new Error("Please try again after ".concat(cooldownSec, " seconds"));
            }
        }
    },
    getTimeToNextEmailLogin: function() {
        var lastEmailLoginTime = (0, $giFXM.W3mFrameStorage).get((0, $cSJ4o.W3mFrameConstants).LAST_EMAIL_LOGIN_TIME);
        if (lastEmailLoginTime) {
            var difference = Date.now() - Number(lastEmailLoginTime);
            if (difference < $22ef681b8ff5be3b$var$EMAIL_MINIMUM_TIMEOUT) return Math.ceil(($22ef681b8ff5be3b$var$EMAIL_MINIMUM_TIMEOUT - difference) / 1000);
        }
        return 0;
    },
    checkIfRequestExists: function(request) {
        return (0, $cSJ4o.W3mFrameRpcConstants).NOT_SAFE_RPC_METHODS.includes(request.method) || (0, $cSJ4o.W3mFrameRpcConstants).SAFE_RPC_METHODS.includes(request.method);
    },
    getResponseType: function(response) {
        var isPayloadString = typeof response === "string";
        var isTransactionHash = isPayloadString && ((response === null || response === void 0 ? void 0 : response.match((0, $clcqH.RegexUtil).transactionHash)) || (response === null || response === void 0 ? void 0 : response.match((0, $clcqH.RegexUtil).signedMessage)));
        if (isTransactionHash) return (0, $cSJ4o.W3mFrameConstants).RPC_RESPONSE_TYPE_TX;
        return (0, $cSJ4o.W3mFrameConstants).RPC_RESPONSE_TYPE_OBJECT;
    },
    checkIfRequestIsAllowed: function(request) {
        return (0, $cSJ4o.W3mFrameRpcConstants).SAFE_RPC_METHODS.includes(request.method);
    },
    isClient: typeof window !== "undefined"
};

});
parcelRegister("giFXM", function(module, exports) {

$parcel$export(module.exports, "W3mFrameStorage", function () { return $bddee0cf6a62d143$export$500c415dce2853c3; });

var $cSJ4o = parcelRequire("cSJ4o");

var $2ZXsZ = parcelRequire("2ZXsZ");
var $bddee0cf6a62d143$export$500c415dce2853c3 = {
    set: function(key, value) {
        if ((0, $2ZXsZ.W3mFrameHelpers).isClient) localStorage.setItem("".concat((0, $cSJ4o.W3mFrameConstants).STORAGE_KEY).concat(key), value);
    },
    get: function(key) {
        if ((0, $2ZXsZ.W3mFrameHelpers).isClient) return localStorage.getItem("".concat((0, $cSJ4o.W3mFrameConstants).STORAGE_KEY).concat(key));
        return null;
    },
    delete: function(key, social) {
        if ((0, $2ZXsZ.W3mFrameHelpers).isClient) {
            if (social) localStorage.removeItem(key);
            else localStorage.removeItem("".concat((0, $cSJ4o.W3mFrameConstants).STORAGE_KEY).concat(key));
        }
    }
};

});

parcelRegister("clcqH", function(module, exports) {

$parcel$export(module.exports, "RegexUtil", function () { return $8fc1167cc6005082$export$e5d4f8e67553e137; });
var $8fc1167cc6005082$export$e5d4f8e67553e137 = {
    address: RegExp("^0x(?:[A-Fa-f0-9]{40})$", "u"),
    transactionHash: RegExp("^0x(?:[A-Fa-f0-9]{64})$", "u"),
    signedMessage: RegExp("^0x(?:[a-fA-F0-9]{62,})$", "u")
};

});



parcelRegister("31229", function(module, exports) {

$parcel$export(module.exports, "W3mFrameProvider", function () { return $23230af2b933a54b$export$112ca4a9acf9f612; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $c6Xmf = parcelRequire("c6Xmf");

var $eha6O = parcelRequire("eha6O");

var $74Iww = parcelRequire("74Iww");

var $cSJ4o = parcelRequire("cSJ4o");

var $giFXM = parcelRequire("giFXM");

var $2ZXsZ = parcelRequire("2ZXsZ");

var $ii78Y = parcelRequire("ii78Y");
var $23230af2b933a54b$export$112ca4a9acf9f612 = /*#__PURE__*/ function() {
    "use strict";
    function W3mFrameProvider(projectId, chainId) {
        (0, $4GJKx._)(this, W3mFrameProvider);
        this.openRpcRequests = [];
        this.w3mLogger = new (0, $ii78Y.W3mFrameLogger)(projectId);
        this.w3mFrame = new (0, $74Iww.W3mFrame)(projectId, true, chainId);
    }
    (0, $1wc17._)(W3mFrameProvider, [
        {
            key: "getLoginEmailUsed",
            value: function getLoginEmailUsed() {
                return Boolean((0, $giFXM.W3mFrameStorage).get((0, $cSJ4o.W3mFrameConstants).EMAIL_LOGIN_USED_KEY));
            }
        },
        {
            key: "getEmail",
            value: function getEmail() {
                return (0, $giFXM.W3mFrameStorage).get((0, $cSJ4o.W3mFrameConstants).EMAIL);
            }
        },
        {
            key: "connectEmail",
            value: function connectEmail(payload) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var response, error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                (0, $2ZXsZ.W3mFrameHelpers).checkIfAllowedToTriggerEmail();
                                return [
                                    4,
                                    _this.appEvent({
                                        type: (0, $cSJ4o.W3mFrameConstants).APP_CONNECT_EMAIL,
                                        payload: payload
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                _this.setNewLastEmailLoginTime();
                                return [
                                    2,
                                    response
                                ];
                            case 2:
                                error = _state.sent();
                                _this.w3mLogger.logger.error({
                                    error: error
                                }, "Error connecting email");
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "connectDevice",
            value: function connectDevice() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        try {
                            return [
                                2,
                                _this.appEvent({
                                    type: (0, $cSJ4o.W3mFrameConstants).APP_CONNECT_DEVICE
                                })
                            ];
                        } catch (error) {
                            _this.w3mLogger.logger.error({
                                error: error
                            }, "Error connecting device");
                            throw error;
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "connectOtp",
            value: function connectOtp(payload) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        try {
                            return [
                                2,
                                _this.appEvent({
                                    type: (0, $cSJ4o.W3mFrameConstants).APP_CONNECT_OTP,
                                    payload: payload
                                })
                            ];
                        } catch (error) {
                            _this.w3mLogger.logger.error({
                                error: error
                            }, "Error connecting otp");
                            throw error;
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "isConnected",
            value: function isConnected() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var response, error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.appEvent({
                                        type: (0, $cSJ4o.W3mFrameConstants).APP_IS_CONNECTED
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.isConnected) _this.deleteAuthLoginCache();
                                return [
                                    2,
                                    response
                                ];
                            case 2:
                                error = _state.sent();
                                _this.deleteAuthLoginCache();
                                _this.w3mLogger.logger.error({
                                    error: error
                                }, "Error checking connection");
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getChainId",
            value: function getChainId() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var response, error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.appEvent({
                                        type: (0, $cSJ4o.W3mFrameConstants).APP_GET_CHAIN_ID
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                _this.setLastUsedChainId(response.chainId);
                                return [
                                    2,
                                    response
                                ];
                            case 2:
                                error = _state.sent();
                                _this.w3mLogger.logger.error({
                                    error: error
                                }, "Error getting chain id");
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSocialRedirectUri",
            value: function getSocialRedirectUri(payload) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        try {
                            return [
                                2,
                                _this.appEvent({
                                    type: (0, $cSJ4o.W3mFrameConstants).APP_GET_SOCIAL_REDIRECT_URI,
                                    payload: payload
                                })
                            ];
                        } catch (error) {
                            _this.w3mLogger.logger.error({
                                error: error
                            }, "Error getting social redirect uri");
                            throw error;
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "updateEmail",
            value: function updateEmail(payload) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var response, error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.appEvent({
                                        type: (0, $cSJ4o.W3mFrameConstants).APP_UPDATE_EMAIL,
                                        payload: payload
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                _this.setNewLastEmailLoginTime();
                                return [
                                    2,
                                    response
                                ];
                            case 2:
                                error = _state.sent();
                                _this.w3mLogger.logger.error({
                                    error: error
                                }, "Error updating email");
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateEmailPrimaryOtp",
            value: function updateEmailPrimaryOtp(payload) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        try {
                            return [
                                2,
                                _this.appEvent({
                                    type: (0, $cSJ4o.W3mFrameConstants).APP_UPDATE_EMAIL_PRIMARY_OTP,
                                    payload: payload
                                })
                            ];
                        } catch (error) {
                            _this.w3mLogger.logger.error({
                                error: error
                            }, "Error updating email primary otp");
                            throw error;
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "updateEmailSecondaryOtp",
            value: function updateEmailSecondaryOtp(payload) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var response, error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.appEvent({
                                        type: (0, $cSJ4o.W3mFrameConstants).APP_UPDATE_EMAIL_SECONDARY_OTP,
                                        payload: payload
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                _this.setLoginSuccess(response.newEmail);
                                return [
                                    2,
                                    response
                                ];
                            case 2:
                                error = _state.sent();
                                _this.w3mLogger.logger.error({
                                    error: error
                                }, "Error updating email secondary otp");
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "syncTheme",
            value: function syncTheme(payload) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        try {
                            return [
                                2,
                                _this.appEvent({
                                    type: (0, $cSJ4o.W3mFrameConstants).APP_SYNC_THEME,
                                    payload: payload
                                })
                            ];
                        } catch (error) {
                            _this.w3mLogger.logger.error({
                                error: error
                            }, "Error syncing theme");
                            throw error;
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "syncDappData",
            value: function syncDappData(payload) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        try {
                            return [
                                2,
                                _this.appEvent({
                                    type: (0, $cSJ4o.W3mFrameConstants).APP_SYNC_DAPP_DATA,
                                    payload: payload
                                })
                            ];
                        } catch (error) {
                            _this.w3mLogger.logger.error({
                                error: error
                            }, "Error syncing dapp data");
                            throw error;
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "getSmartAccountEnabledNetworks",
            value: function getSmartAccountEnabledNetworks() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var response, error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.appEvent({
                                        type: (0, $cSJ4o.W3mFrameConstants).APP_GET_SMART_ACCOUNT_ENABLED_NETWORKS
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                _this.persistSmartAccountEnabledNetworks(response.smartAccountEnabledNetworks);
                                return [
                                    2,
                                    response
                                ];
                            case 2:
                                error = _state.sent();
                                _this.persistSmartAccountEnabledNetworks([]);
                                _this.w3mLogger.logger.error({
                                    error: error
                                }, "Error getting smart account enabled networks");
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setPreferredAccount",
            value: function setPreferredAccount(type) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        try {
                            return [
                                2,
                                _this.appEvent({
                                    type: (0, $cSJ4o.W3mFrameConstants).APP_SET_PREFERRED_ACCOUNT,
                                    payload: {
                                        type: type
                                    }
                                })
                            ];
                        } catch (error) {
                            _this.w3mLogger.logger.error({
                                error: error
                            }, "Error setting preferred account");
                            throw error;
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "connect",
            value: function connect(payload) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _payload_chainId, _ref, chainId, response, error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                chainId = (_ref = (_payload_chainId = payload === null || payload === void 0 ? void 0 : payload.chainId) !== null && _payload_chainId !== void 0 ? _payload_chainId : _this.getLastUsedChainId()) !== null && _ref !== void 0 ? _ref : 1;
                                return [
                                    4,
                                    _this.appEvent({
                                        type: (0, $cSJ4o.W3mFrameConstants).APP_GET_USER,
                                        payload: (0, $cxjpp._)((0, $do9pw._)({}, payload), {
                                            chainId: chainId
                                        })
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                _this.setLoginSuccess(response.email);
                                _this.setLastUsedChainId(response.chainId);
                                return [
                                    2,
                                    response
                                ];
                            case 2:
                                error = _state.sent();
                                _this.w3mLogger.logger.error({
                                    error: error
                                }, "Error connecting");
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "connectSocial",
            value: function connectSocial(uri) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var response, error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.appEvent({
                                        type: (0, $cSJ4o.W3mFrameConstants).APP_CONNECT_SOCIAL,
                                        payload: {
                                            uri: uri
                                        }
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (response.userName) _this.setSocialLoginSuccess(response.userName);
                                return [
                                    2,
                                    response
                                ];
                            case 2:
                                error = _state.sent();
                                _this.w3mLogger.logger.error({
                                    error: error
                                }, "Error connecting social");
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getFarcasterUri",
            value: function getFarcasterUri() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var response, error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.appEvent({
                                        type: (0, $cSJ4o.W3mFrameConstants).APP_GET_FARCASTER_URI
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                            case 2:
                                error = _state.sent();
                                _this.w3mLogger.logger.error({
                                    error: error
                                }, "Error getting farcaster uri");
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "connectFarcaster",
            value: function connectFarcaster() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var response, error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.appEvent({
                                        type: (0, $cSJ4o.W3mFrameConstants).APP_CONNECT_FARCASTER
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (response.userName) _this.setSocialLoginSuccess(response.userName);
                                return [
                                    2,
                                    response
                                ];
                            case 2:
                                error = _state.sent();
                                _this.w3mLogger.logger.error({
                                    error: error
                                }, "Error connecting farcaster");
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "switchNetwork",
            value: function switchNetwork(chainId) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var response, error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.appEvent({
                                        type: (0, $cSJ4o.W3mFrameConstants).APP_SWITCH_NETWORK,
                                        payload: {
                                            chainId: chainId
                                        }
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                _this.setLastUsedChainId(response.chainId);
                                return [
                                    2,
                                    response
                                ];
                            case 2:
                                error = _state.sent();
                                _this.w3mLogger.logger.error({
                                    error: error
                                }, "Error switching network");
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var response, error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.appEvent({
                                        type: (0, $cSJ4o.W3mFrameConstants).APP_SIGN_OUT
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                _this.deleteAuthLoginCache();
                                return [
                                    2,
                                    response
                                ];
                            case 2:
                                error = _state.sent();
                                _this.w3mLogger.logger.error({
                                    error: error
                                }, "Error disconnecting");
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "request",
            value: function request(req) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _this_rpcRequestHandler, _this1, _this_rpcSuccessHandler, _this2, response, error, _this_rpcErrorHandler, _this3;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                if ((0, $cSJ4o.W3mFrameRpcConstants).GET_CHAIN_ID === req.method) return [
                                    2,
                                    _this.getLastUsedChainId()
                                ];
                                (_this_rpcRequestHandler = (_this1 = _this).rpcRequestHandler) === null || _this_rpcRequestHandler === void 0 ? void 0 : _this_rpcRequestHandler.call(_this1, req);
                                return [
                                    4,
                                    _this.appEvent({
                                        type: (0, $cSJ4o.W3mFrameConstants).APP_RPC_REQUEST,
                                        payload: req
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                (_this_rpcSuccessHandler = (_this2 = _this).rpcSuccessHandler) === null || _this_rpcSuccessHandler === void 0 ? void 0 : _this_rpcSuccessHandler.call(_this2, response);
                                return [
                                    2,
                                    response
                                ];
                            case 2:
                                error = _state.sent();
                                (_this_rpcErrorHandler = (_this3 = _this).rpcErrorHandler) === null || _this_rpcErrorHandler === void 0 ? void 0 : _this_rpcErrorHandler.call(_this3, error);
                                _this.w3mLogger.logger.error({
                                    error: error
                                }, "Error requesting");
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onRpcRequest",
            value: function onRpcRequest(callback) {
                this.rpcRequestHandler = callback;
            }
        },
        {
            key: "onRpcSuccess",
            value: function onRpcSuccess(callback) {
                this.rpcSuccessHandler = callback;
            }
        },
        {
            key: "onRpcError",
            value: function onRpcError(callback) {
                this.rpcErrorHandler = callback;
            }
        },
        {
            key: "onIsConnected",
            value: function onIsConnected(callback) {
                this.w3mFrame.events.onFrameEvent(function(event) {
                    if (event.type === (0, $cSJ4o.W3mFrameConstants).FRAME_GET_USER_SUCCESS) callback(event.payload);
                });
            }
        },
        {
            key: "onNotConnected",
            value: function onNotConnected(callback) {
                this.w3mFrame.events.onFrameEvent(function(event) {
                    if (event.type === (0, $cSJ4o.W3mFrameConstants).FRAME_IS_CONNECTED_ERROR) callback();
                    if (event.type === (0, $cSJ4o.W3mFrameConstants).FRAME_IS_CONNECTED_SUCCESS && !event.payload.isConnected) callback();
                });
            }
        },
        {
            key: "getCapabilities",
            value: function getCapabilities() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var capabilities, e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.request({
                                        method: "wallet_getCapabilities"
                                    })
                                ];
                            case 1:
                                capabilities = _state.sent();
                                return [
                                    2,
                                    capabilities || {}
                                ];
                            case 2:
                                e = _state.sent();
                                return [
                                    2,
                                    {}
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onSetPreferredAccount",
            value: function onSetPreferredAccount(callback) {
                this.w3mFrame.events.onFrameEvent(function(event) {
                    if (event.type === (0, $cSJ4o.W3mFrameConstants).FRAME_SET_PREFERRED_ACCOUNT_SUCCESS) callback(event.payload);
                    else if (event.type === (0, $cSJ4o.W3mFrameConstants).FRAME_SET_PREFERRED_ACCOUNT_ERROR) callback({
                        type: (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.EOA
                    });
                });
            }
        },
        {
            key: "onGetSmartAccountEnabledNetworks",
            value: function onGetSmartAccountEnabledNetworks(callback) {
                this.w3mFrame.events.onFrameEvent(function(event) {
                    if (event.type === (0, $cSJ4o.W3mFrameConstants).FRAME_GET_SMART_ACCOUNT_ENABLED_NETWORKS_SUCCESS) callback(event.payload.smartAccountEnabledNetworks);
                    else if (event.type === (0, $cSJ4o.W3mFrameConstants).FRAME_GET_SMART_ACCOUNT_ENABLED_NETWORKS_ERROR) callback([]);
                });
            }
        },
        {
            key: "getAvailableChainIds",
            value: function getAvailableChainIds() {
                return Object.keys(this.w3mFrame.networks);
            }
        },
        {
            key: "rejectRpcRequests",
            value: function rejectRpcRequests() {
                try {
                    this.openRpcRequests.forEach(function(param) {
                        var abortController = param.abortController, method = param.method;
                        if (!(0, $cSJ4o.W3mFrameRpcConstants).SAFE_RPC_METHODS.includes(method)) abortController.abort();
                    });
                    this.openRpcRequests = [];
                } catch (e) {
                    this.w3mLogger.logger.error({
                        error: e
                    }, "Error aborting RPC request");
                }
            }
        },
        {
            key: "appEvent",
            value: function appEvent(event) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var type;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.w3mFrame.frameLoadPromise
                                ];
                            case 1:
                                _state.sent();
                                type = event.type.replace("@w3m-app/", "");
                                return [
                                    2,
                                    new Promise(function(resolve, reject) {
                                        var _this_w3mLogger_logger_info, _this_w3mLogger_logger;
                                        var id = Math.random().toString(36).substring(7);
                                        (_this_w3mLogger_logger_info = (_this_w3mLogger_logger = _this.w3mLogger.logger).info) === null || _this_w3mLogger_logger_info === void 0 ? void 0 : _this_w3mLogger_logger_info.call(_this_w3mLogger_logger, {
                                            event: event,
                                            id: id
                                        }, "Sending app event");
                                        _this.w3mFrame.events.postAppEvent((0, $cxjpp._)((0, $do9pw._)({}, event), {
                                            id: id
                                        }));
                                        var abortController = new AbortController();
                                        if (type === "RPC_REQUEST") {
                                            var rpcEvent = event;
                                            _this.openRpcRequests = (0, $c6Xmf._)(_this.openRpcRequests).concat([
                                                (0, $cxjpp._)((0, $do9pw._)({}, rpcEvent.payload), {
                                                    abortController: abortController
                                                })
                                            ]);
                                        }
                                        abortController.signal.addEventListener("abort", function() {
                                            if (type === "RPC_REQUEST") reject(new Error("Request was aborted"));
                                        });
                                        function handler(framEvent) {
                                            if (framEvent.type === "@w3m-frame/".concat(type, "_SUCCESS")) {
                                                if ("payload" in framEvent) resolve(framEvent.payload);
                                                resolve(undefined);
                                            } else if (framEvent.type === "@w3m-frame/".concat(type, "_ERROR")) {
                                                var _framEvent_payload;
                                                if ("payload" in framEvent) reject(new Error(((_framEvent_payload = framEvent.payload) === null || _framEvent_payload === void 0 ? void 0 : _framEvent_payload.message) || "An error occurred"));
                                                reject(new Error("An error occurred"));
                                            }
                                        }
                                        _this.w3mFrame.events.registerFrameEventHandler(id, handler, abortController.signal);
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setNewLastEmailLoginTime",
            value: function setNewLastEmailLoginTime() {
                (0, $giFXM.W3mFrameStorage).set((0, $cSJ4o.W3mFrameConstants).LAST_EMAIL_LOGIN_TIME, Date.now().toString());
            }
        },
        {
            key: "setSocialLoginSuccess",
            value: function setSocialLoginSuccess(username) {
                (0, $giFXM.W3mFrameStorage).set((0, $cSJ4o.W3mFrameConstants).SOCIAL_USERNAME, username);
            }
        },
        {
            key: "setLoginSuccess",
            value: function setLoginSuccess(email) {
                if (email) (0, $giFXM.W3mFrameStorage).set((0, $cSJ4o.W3mFrameConstants).EMAIL, email);
                (0, $giFXM.W3mFrameStorage).set((0, $cSJ4o.W3mFrameConstants).EMAIL_LOGIN_USED_KEY, "true");
                (0, $giFXM.W3mFrameStorage).delete((0, $cSJ4o.W3mFrameConstants).LAST_EMAIL_LOGIN_TIME);
            }
        },
        {
            key: "deleteAuthLoginCache",
            value: function deleteAuthLoginCache() {
                (0, $giFXM.W3mFrameStorage).delete((0, $cSJ4o.W3mFrameConstants).EMAIL_LOGIN_USED_KEY);
                (0, $giFXM.W3mFrameStorage).delete((0, $cSJ4o.W3mFrameConstants).EMAIL);
                (0, $giFXM.W3mFrameStorage).delete((0, $cSJ4o.W3mFrameConstants).LAST_USED_CHAIN_KEY);
                (0, $giFXM.W3mFrameStorage).delete((0, $cSJ4o.W3mFrameConstants).SOCIAL_USERNAME);
                (0, $giFXM.W3mFrameStorage).delete((0, $cSJ4o.W3mFrameConstants).SOCIAL, true);
            }
        },
        {
            key: "setLastUsedChainId",
            value: function setLastUsedChainId(chainId) {
                (0, $giFXM.W3mFrameStorage).set((0, $cSJ4o.W3mFrameConstants).LAST_USED_CHAIN_KEY, String(chainId));
            }
        },
        {
            key: "getLastUsedChainId",
            value: function getLastUsedChainId() {
                return Number((0, $giFXM.W3mFrameStorage).get((0, $cSJ4o.W3mFrameConstants).LAST_USED_CHAIN_KEY));
            }
        },
        {
            key: "persistSmartAccountEnabledNetworks",
            value: function persistSmartAccountEnabledNetworks(networks) {
                (0, $giFXM.W3mFrameStorage).set((0, $cSJ4o.W3mFrameConstants).SMART_ACCOUNT_ENABLED_NETWORKS, networks.join(","));
            }
        }
    ]);
    return W3mFrameProvider;
}();

});
parcelRegister("ii78Y", function(module, exports) {

$parcel$export(module.exports, "W3mFrameLogger", function () { return $d50f730e3bfd5a9a$export$d95526ab53dea907; });

var $4GJKx = parcelRequire("4GJKx");

var $7Gasr = parcelRequire("7Gasr");

var $cSJ4o = parcelRequire("cSJ4o");
var $d50f730e3bfd5a9a$export$d95526ab53dea907 = function W3mFrameLogger(projectId) {
    "use strict";
    var _this = this;
    (0, $4GJKx._)(this, W3mFrameLogger);
    var _this_chunkLoggerController;
    var loggerOptions = (0, $7Gasr.getDefaultLoggerOptions)({
        level: (0, $cSJ4o.DEFAULT_LOG_LEVEL)
    });
    var _generatePlatformLogger = (0, $7Gasr.generatePlatformLogger)({
        opts: loggerOptions
    }), logger = _generatePlatformLogger.logger, chunkLoggerController = _generatePlatformLogger.chunkLoggerController;
    this.logger = (0, $7Gasr.generateChildLogger)(logger, this.constructor.name);
    this.chunkLoggerController = chunkLoggerController;
    if (typeof window !== "undefined" && ((_this_chunkLoggerController = this.chunkLoggerController) === null || _this_chunkLoggerController === void 0 ? void 0 : _this_chunkLoggerController.downloadLogsBlobInBrowser)) {
        if (!window.downloadAppKitLogsBlob) window.downloadAppKitLogsBlob = {};
        window.downloadAppKitLogsBlob["sdk"] = function() {
            var _this_chunkLoggerController;
            if ((_this_chunkLoggerController = _this.chunkLoggerController) === null || _this_chunkLoggerController === void 0 ? void 0 : _this_chunkLoggerController.downloadLogsBlobInBrowser) _this.chunkLoggerController.downloadLogsBlobInBrowser({
                projectId: projectId
            });
        };
    }
};

});
parcelRegister("7Gasr", function(module, exports) {

$parcel$export(module.exports, "getDefaultLoggerOptions", function () { return $59749158056749f1$export$bad2475df51c8ecc; });
$parcel$export(module.exports, "getLoggerContext", function () { return $59749158056749f1$export$a283a9a0054a3c25; });
$parcel$export(module.exports, "generateChildLogger", function () { return $59749158056749f1$export$4929e0372308a636; });
$parcel$export(module.exports, "generatePlatformLogger", function () { return $59749158056749f1$export$15eba7fb5aaf9303; });
$parcel$export(module.exports, "pino", function () { return (/*@__PURE__*/$parcel$interopDefault((parcelRequire("6DLsq")))); });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $l0HdX = parcelRequire("l0HdX");

var $6DLsq = parcelRequire("6DLsq");

var $2fy4s = parcelRequire("2fy4s");
var $59749158056749f1$export$341ee22b43fe3f8e = {
    level: "info"
}, $59749158056749f1$export$fdd446d41f74bf3a = "custom_context", $59749158056749f1$export$64bef9d49cc9288f = 1024000;
var $59749158056749f1$var$O = /*#__PURE__*/ function() {
    "use strict";
    function O(e) {
        (0, $4GJKx._)(this, O);
        this.nodeValue = e, this.sizeInBytes = new TextEncoder().encode(this.nodeValue).length, this.next = null;
    }
    (0, $1wc17._)(O, [
        {
            key: "value",
            get: function get() {
                return this.nodeValue;
            }
        },
        {
            key: "size",
            get: function get() {
                return this.sizeInBytes;
            }
        }
    ]);
    return O;
}();
var $59749158056749f1$var$d = /*#__PURE__*/ function() {
    "use strict";
    function d(e) {
        (0, $4GJKx._)(this, d);
        this.head = null, this.tail = null, this.lengthInNodes = 0, this.maxSizeInBytes = e, this.sizeInBytes = 0;
    }
    (0, $1wc17._)(d, [
        {
            key: "append",
            value: function append(e) {
                var t = new $59749158056749f1$var$O(e);
                if (t.size > this.maxSizeInBytes) throw new Error("[LinkedList] Value too big to insert into list: ".concat(e, " with size ").concat(t.size));
                for(; this.size + t.size > this.maxSizeInBytes;)this.shift();
                this.head ? (this.tail && (this.tail.next = t), this.tail = t) : (this.head = t, this.tail = t), this.lengthInNodes++, this.sizeInBytes += t.size;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (!this.head) return;
                var e = this.head;
                this.head = this.head.next, this.head || (this.tail = null), this.lengthInNodes--, this.sizeInBytes -= e.size;
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                var e = [];
                var t = this.head;
                for(; t !== null;)e.push(t.value), t = t.next;
                return e;
            }
        },
        {
            key: "length",
            get: function get() {
                return this.lengthInNodes;
            }
        },
        {
            key: "size",
            get: function get() {
                return this.sizeInBytes;
            }
        },
        {
            key: "toOrderedArray",
            value: function toOrderedArray() {
                return Array.from(this);
            }
        },
        {
            key: Symbol.iterator,
            value: function value() {
                var e = this.head;
                return {
                    next: function() {
                        if (!e) return {
                            done: !0,
                            value: null
                        };
                        var t = e.value;
                        return e = e.next, {
                            done: !1,
                            value: t
                        };
                    }
                };
            }
        }
    ]);
    return d;
}();
var $59749158056749f1$var$L = /*#__PURE__*/ function() {
    "use strict";
    function L(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $59749158056749f1$export$64bef9d49cc9288f;
        (0, $4GJKx._)(this, L);
        this.level = e !== null && e !== void 0 ? e : "error", this.levelValue = (0, $6DLsq.levels).values[this.level], this.MAX_LOG_SIZE_IN_BYTES = t, this.logs = new $59749158056749f1$var$d(this.MAX_LOG_SIZE_IN_BYTES);
    }
    (0, $1wc17._)(L, [
        {
            key: "forwardToConsole",
            value: function forwardToConsole(e, t) {
                t === (0, $6DLsq.levels).values.error ? console.error(e) : t === (0, $6DLsq.levels).values.warn ? console.warn(e) : t === (0, $6DLsq.levels).values.debug ? console.debug(e) : t === (0, $6DLsq.levels).values.trace ? console.trace(e) : console.log(e);
            }
        },
        {
            key: "appendToLogs",
            value: function appendToLogs(e) {
                this.logs.append((0, $2fy4s.safeJsonStringify)({
                    timestamp: new Date().toISOString(),
                    log: e
                }));
                var t = typeof e == "string" ? JSON.parse(e).level : e.level;
                t >= this.levelValue && this.forwardToConsole(e, t);
            }
        },
        {
            key: "getLogs",
            value: function getLogs() {
                return this.logs;
            }
        },
        {
            key: "clearLogs",
            value: function clearLogs() {
                this.logs = new $59749158056749f1$var$d(this.MAX_LOG_SIZE_IN_BYTES);
            }
        },
        {
            key: "getLogArray",
            value: function getLogArray() {
                return Array.from(this.logs);
            }
        },
        {
            key: "logsToBlob",
            value: function logsToBlob(e) {
                var t = this.getLogArray();
                return t.push((0, $2fy4s.safeJsonStringify)({
                    extraMetadata: e
                })), new Blob(t, {
                    type: "application/json"
                });
            }
        }
    ]);
    return L;
}();
var $59749158056749f1$var$m = /*#__PURE__*/ function() {
    "use strict";
    function m(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $59749158056749f1$export$64bef9d49cc9288f;
        (0, $4GJKx._)(this, m);
        this.baseChunkLogger = new $59749158056749f1$var$L(e, t);
    }
    (0, $1wc17._)(m, [
        {
            key: "write",
            value: function write(e) {
                this.baseChunkLogger.appendToLogs(e);
            }
        },
        {
            key: "getLogs",
            value: function getLogs() {
                return this.baseChunkLogger.getLogs();
            }
        },
        {
            key: "clearLogs",
            value: function clearLogs() {
                this.baseChunkLogger.clearLogs();
            }
        },
        {
            key: "getLogArray",
            value: function getLogArray() {
                return this.baseChunkLogger.getLogArray();
            }
        },
        {
            key: "logsToBlob",
            value: function logsToBlob(e) {
                return this.baseChunkLogger.logsToBlob(e);
            }
        },
        {
            key: "downloadLogsBlobInBrowser",
            value: function downloadLogsBlobInBrowser(e) {
                var t = URL.createObjectURL(this.logsToBlob(e)), o = document.createElement("a");
                o.href = t, o.download = "walletconnect-logs-".concat(new Date().toISOString(), ".txt"), document.body.appendChild(o), o.click(), document.body.removeChild(o), URL.revokeObjectURL(t);
            }
        }
    ]);
    return m;
}();
var $59749158056749f1$var$B = /*#__PURE__*/ function() {
    "use strict";
    function B(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $59749158056749f1$export$64bef9d49cc9288f;
        (0, $4GJKx._)(this, B);
        this.baseChunkLogger = new $59749158056749f1$var$L(e, t);
    }
    (0, $1wc17._)(B, [
        {
            key: "write",
            value: function write(e) {
                this.baseChunkLogger.appendToLogs(e);
            }
        },
        {
            key: "getLogs",
            value: function getLogs() {
                return this.baseChunkLogger.getLogs();
            }
        },
        {
            key: "clearLogs",
            value: function clearLogs() {
                this.baseChunkLogger.clearLogs();
            }
        },
        {
            key: "getLogArray",
            value: function getLogArray() {
                return this.baseChunkLogger.getLogArray();
            }
        },
        {
            key: "logsToBlob",
            value: function logsToBlob(e) {
                return this.baseChunkLogger.logsToBlob(e);
            }
        }
    ]);
    return B;
}();
var $59749158056749f1$var$x = Object.defineProperty, $59749158056749f1$var$S = Object.defineProperties, $59749158056749f1$var$_ = Object.getOwnPropertyDescriptors, $59749158056749f1$var$p = Object.getOwnPropertySymbols, $59749158056749f1$var$T = Object.prototype.hasOwnProperty, $59749158056749f1$var$z = Object.prototype.propertyIsEnumerable, $59749158056749f1$var$f = function(r, e, t) {
    return e in r ? $59749158056749f1$var$x(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t;
}, $59749158056749f1$var$i = function(r, e) {
    for(var t in e || (e = {}))$59749158056749f1$var$T.call(e, t) && $59749158056749f1$var$f(r, t, e[t]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($59749158056749f1$var$p) try {
        for(var _iterator = $59749158056749f1$var$p(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var t = _step.value;
            $59749158056749f1$var$z.call(e, t) && $59749158056749f1$var$f(r, t, e[t]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return r;
}, $59749158056749f1$var$g = function(r, e) {
    return $59749158056749f1$var$S(r, $59749158056749f1$var$_(e));
};
function $59749158056749f1$export$bad2475df51c8ecc(r) {
    return $59749158056749f1$var$g($59749158056749f1$var$i({}, r), {
        level: (r === null || r === void 0 ? void 0 : r.level) || $59749158056749f1$export$341ee22b43fe3f8e.level
    });
}
function $59749158056749f1$export$e8faae0482d84e9e(r) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $59749158056749f1$export$fdd446d41f74bf3a;
    return r[e] || "";
}
function $59749158056749f1$export$758f352b7265b00e(r, e) {
    var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $59749158056749f1$export$fdd446d41f74bf3a;
    return r[t] = e, r;
}
function $59749158056749f1$export$a283a9a0054a3c25(r) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $59749158056749f1$export$fdd446d41f74bf3a;
    var t = "";
    return (0, $l0HdX._)(r.bindings) > "u" ? t = $59749158056749f1$export$e8faae0482d84e9e(r, e) : t = r.bindings().context || "", t;
}
function $59749158056749f1$export$307261146df20465(r, e) {
    var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $59749158056749f1$export$fdd446d41f74bf3a;
    var o = $59749158056749f1$export$a283a9a0054a3c25(r, t);
    return o.trim() ? "".concat(o, "/").concat(e) : e;
}
function $59749158056749f1$export$4929e0372308a636(r, e) {
    var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $59749158056749f1$export$fdd446d41f74bf3a;
    var o = $59749158056749f1$export$307261146df20465(r, e, t), a = r.child({
        context: o
    });
    return $59749158056749f1$export$758f352b7265b00e(a, o, t);
}
function $59749158056749f1$export$2ca1453636a43a7(r) {
    var e, t;
    var o = new $59749158056749f1$var$m((e = r.opts) == null ? void 0 : e.level, r.maxSizeInBytes);
    return {
        logger: (0, (/*@__PURE__*/$parcel$interopDefault($6DLsq)))($59749158056749f1$var$g($59749158056749f1$var$i({}, r.opts), {
            level: "trace",
            browser: $59749158056749f1$var$g($59749158056749f1$var$i({}, (t = r.opts) == null ? void 0 : t.browser), {
                write: function(a) {
                    return o.write(a);
                }
            })
        })),
        chunkLoggerController: o
    };
}
function $59749158056749f1$export$495ac2973e46cb97(r) {
    var e;
    var t = new $59749158056749f1$var$B((e = r.opts) == null ? void 0 : e.level, r.maxSizeInBytes);
    return {
        logger: (0, (/*@__PURE__*/$parcel$interopDefault($6DLsq)))($59749158056749f1$var$g($59749158056749f1$var$i({}, r.opts), {
            level: "trace"
        }), t),
        chunkLoggerController: t
    };
}
function $59749158056749f1$export$15eba7fb5aaf9303(r) {
    return (0, $l0HdX._)(r.loggerOverride) < "u" && typeof r.loggerOverride != "string" ? {
        logger: r.loggerOverride,
        chunkLoggerController: null
    } : (typeof window === "undefined" ? "undefined" : (0, $l0HdX._)(window)) < "u" ? $59749158056749f1$export$2ca1453636a43a7(r) : $59749158056749f1$export$495ac2973e46cb97(r);
}

});
parcelRegister("6DLsq", function(module, exports) {
"use strict";

var $kbaNN = parcelRequire("kbaNN");
module.exports = $013f680af02bad82$var$pino;
var $013f680af02bad82$var$_console = $013f680af02bad82$var$pfGlobalThisOrFallback().console || {};
var $013f680af02bad82$var$stdSerializers = {
    mapHttpRequest: $013f680af02bad82$var$mock,
    mapHttpResponse: $013f680af02bad82$var$mock,
    wrapRequestSerializer: $013f680af02bad82$var$passthrough,
    wrapResponseSerializer: $013f680af02bad82$var$passthrough,
    wrapErrorSerializer: $013f680af02bad82$var$passthrough,
    req: $013f680af02bad82$var$mock,
    res: $013f680af02bad82$var$mock,
    err: $013f680af02bad82$var$asErrValue
};
function $013f680af02bad82$var$shouldSerialize(serialize, serializers) {
    if (Array.isArray(serialize)) {
        var hasToFilter = serialize.filter(function(k) {
            return k !== "!stdSerializers.err";
        });
        return hasToFilter;
    } else if (serialize === true) return Object.keys(serializers);
    return false;
}
function $013f680af02bad82$var$pino(opts) {
    opts = opts || {};
    opts.browser = opts.browser || {};
    var transmit = opts.browser.transmit;
    if (transmit && typeof transmit.send !== "function") throw Error("pino: transmit option must have a send function");
    var proto = opts.browser.write || $013f680af02bad82$var$_console;
    if (opts.browser.write) opts.browser.asObject = true;
    var serializers = opts.serializers || {};
    var serialize = $013f680af02bad82$var$shouldSerialize(opts.browser.serialize, serializers);
    var stdErrSerialize = opts.browser.serialize;
    if (Array.isArray(opts.browser.serialize) && opts.browser.serialize.indexOf("!stdSerializers.err") > -1) stdErrSerialize = false;
    var levels = [
        "error",
        "fatal",
        "warn",
        "info",
        "debug",
        "trace"
    ];
    if (typeof proto === "function") proto.error = proto.fatal = proto.warn = proto.info = proto.debug = proto.trace = proto;
    if (opts.enabled === false) opts.level = "silent";
    var level = opts.level || "info";
    var logger = Object.create(proto);
    if (!logger.log) logger.log = $013f680af02bad82$var$noop;
    Object.defineProperty(logger, "levelVal", {
        get: getLevelVal
    });
    Object.defineProperty(logger, "level", {
        get: getLevel,
        set: setLevel
    });
    var setOpts = {
        transmit: transmit,
        serialize: serialize,
        asObject: opts.browser.asObject,
        levels: levels,
        timestamp: $013f680af02bad82$var$getTimeFunction(opts)
    };
    logger.levels = $013f680af02bad82$var$pino.levels;
    logger.level = level;
    logger.setMaxListeners = logger.getMaxListeners = logger.emit = logger.addListener = logger.on = logger.prependListener = logger.once = logger.prependOnceListener = logger.removeListener = logger.removeAllListeners = logger.listeners = logger.listenerCount = logger.eventNames = logger.write = logger.flush = $013f680af02bad82$var$noop;
    logger.serializers = serializers;
    logger._serialize = serialize;
    logger._stdErrSerialize = stdErrSerialize;
    logger.child = child;
    if (transmit) logger._logEvent = $013f680af02bad82$var$createLogEventShape();
    function getLevelVal() {
        return this.level === "silent" ? Infinity : this.levels.values[this.level];
    }
    function getLevel() {
        return this._level;
    }
    function setLevel(level) {
        if (level !== "silent" && !this.levels.values[level]) throw Error("unknown level " + level);
        this._level = level;
        $013f680af02bad82$var$set(setOpts, logger, "error", "log") // <-- must stay first
        ;
        $013f680af02bad82$var$set(setOpts, logger, "fatal", "error");
        $013f680af02bad82$var$set(setOpts, logger, "warn", "error");
        $013f680af02bad82$var$set(setOpts, logger, "info", "log");
        $013f680af02bad82$var$set(setOpts, logger, "debug", "log");
        $013f680af02bad82$var$set(setOpts, logger, "trace", "log");
    }
    function child(bindings, childOptions) {
        if (!bindings) throw new Error("missing bindings for child Pino");
        childOptions = childOptions || {};
        if (serialize && bindings.serializers) childOptions.serializers = bindings.serializers;
        var childOptionsSerializers = childOptions.serializers;
        if (serialize && childOptionsSerializers) {
            var childSerializers = Object.assign({}, serializers, childOptionsSerializers);
            var childSerialize = opts.browser.serialize === true ? Object.keys(childSerializers) : serialize;
            delete bindings.serializers;
            $013f680af02bad82$var$applySerializers([
                bindings
            ], childSerialize, childSerializers, this._stdErrSerialize);
        }
        function Child(parent) {
            this._childLevel = (parent._childLevel | 0) + 1;
            this.error = $013f680af02bad82$var$bind(parent, bindings, "error");
            this.fatal = $013f680af02bad82$var$bind(parent, bindings, "fatal");
            this.warn = $013f680af02bad82$var$bind(parent, bindings, "warn");
            this.info = $013f680af02bad82$var$bind(parent, bindings, "info");
            this.debug = $013f680af02bad82$var$bind(parent, bindings, "debug");
            this.trace = $013f680af02bad82$var$bind(parent, bindings, "trace");
            if (childSerializers) {
                this.serializers = childSerializers;
                this._serialize = childSerialize;
            }
            if (transmit) this._logEvent = $013f680af02bad82$var$createLogEventShape([].concat(parent._logEvent.bindings, bindings));
        }
        Child.prototype = this;
        return new Child(this);
    }
    return logger;
}
$013f680af02bad82$var$pino.levels = {
    values: {
        fatal: 60,
        error: 50,
        warn: 40,
        info: 30,
        debug: 20,
        trace: 10
    },
    labels: {
        10: "trace",
        20: "debug",
        30: "info",
        40: "warn",
        50: "error",
        60: "fatal"
    }
};
$013f680af02bad82$var$pino.stdSerializers = $013f680af02bad82$var$stdSerializers;
$013f680af02bad82$var$pino.stdTimeFunctions = Object.assign({}, {
    nullTime: $013f680af02bad82$var$nullTime,
    epochTime: $013f680af02bad82$var$epochTime,
    unixTime: $013f680af02bad82$var$unixTime,
    isoTime: $013f680af02bad82$var$isoTime
});
function $013f680af02bad82$var$set(opts, logger, level, fallback) {
    var proto = Object.getPrototypeOf(logger);
    logger[level] = logger.levelVal > logger.levels.values[level] ? $013f680af02bad82$var$noop : proto[level] ? proto[level] : $013f680af02bad82$var$_console[level] || $013f680af02bad82$var$_console[fallback] || $013f680af02bad82$var$noop;
    $013f680af02bad82$var$wrap(opts, logger, level);
}
function $013f680af02bad82$var$wrap(opts, logger, level) {
    if (!opts.transmit && logger[level] === $013f680af02bad82$var$noop) return;
    logger[level] = function(write) {
        return function LOG() {
            var ts = opts.timestamp();
            var args = new Array(arguments.length);
            var proto = Object.getPrototypeOf && Object.getPrototypeOf(this) === $013f680af02bad82$var$_console ? $013f680af02bad82$var$_console : this;
            for(var i = 0; i < args.length; i++)args[i] = arguments[i];
            if (opts.serialize && !opts.asObject) $013f680af02bad82$var$applySerializers(args, this._serialize, this.serializers, this._stdErrSerialize);
            if (opts.asObject) write.call(proto, $013f680af02bad82$var$asObject(this, level, args, ts));
            else write.apply(proto, args);
            if (opts.transmit) {
                var transmitLevel = opts.transmit.level || logger.level;
                var transmitValue = $013f680af02bad82$var$pino.levels.values[transmitLevel];
                var methodValue = $013f680af02bad82$var$pino.levels.values[level];
                if (methodValue < transmitValue) return;
                $013f680af02bad82$var$transmit(this, {
                    ts: ts,
                    methodLevel: level,
                    methodValue: methodValue,
                    transmitLevel: transmitLevel,
                    transmitValue: $013f680af02bad82$var$pino.levels.values[opts.transmit.level || logger.level],
                    send: opts.transmit.send,
                    val: logger.levelVal
                }, args);
            }
        };
    }(logger[level]);
}
function $013f680af02bad82$var$asObject(logger, level, args, ts) {
    if (logger._serialize) $013f680af02bad82$var$applySerializers(args, logger._serialize, logger.serializers, logger._stdErrSerialize);
    var argsCloned = args.slice();
    var msg = argsCloned[0];
    var o = {};
    if (ts) o.time = ts;
    o.level = $013f680af02bad82$var$pino.levels.values[level];
    var lvl = (logger._childLevel | 0) + 1;
    if (lvl < 1) lvl = 1;
    // deliberate, catching objects, arrays
    if (msg !== null && typeof msg === "object") {
        while(lvl-- && typeof argsCloned[0] === "object")Object.assign(o, argsCloned.shift());
        msg = argsCloned.length ? $kbaNN(argsCloned.shift(), argsCloned) : undefined;
    } else if (typeof msg === "string") msg = $kbaNN(argsCloned.shift(), argsCloned);
    if (msg !== undefined) o.msg = msg;
    return o;
}
function $013f680af02bad82$var$applySerializers(args, serialize, serializers, stdErrSerialize) {
    for(var i in args){
        if (stdErrSerialize && args[i] instanceof Error) args[i] = $013f680af02bad82$var$pino.stdSerializers.err(args[i]);
        else if (typeof args[i] === "object" && !Array.isArray(args[i])) {
            for(var k in args[i])if (serialize && serialize.indexOf(k) > -1 && k in serializers) args[i][k] = serializers[k](args[i][k]);
        }
    }
}
function $013f680af02bad82$var$bind(parent, bindings, level) {
    return function() {
        var args = new Array(1 + arguments.length);
        args[0] = bindings;
        for(var i = 1; i < args.length; i++)args[i] = arguments[i - 1];
        return parent[level].apply(this, args);
    };
}
function $013f680af02bad82$var$transmit(logger, opts, args) {
    var send = opts.send;
    var ts = opts.ts;
    var methodLevel = opts.methodLevel;
    var methodValue = opts.methodValue;
    var val = opts.val;
    var bindings = logger._logEvent.bindings;
    $013f680af02bad82$var$applySerializers(args, logger._serialize || Object.keys(logger.serializers), logger.serializers, logger._stdErrSerialize === undefined ? true : logger._stdErrSerialize);
    logger._logEvent.ts = ts;
    logger._logEvent.messages = args.filter(function(arg) {
        // bindings can only be objects, so reference equality check via indexOf is fine
        return bindings.indexOf(arg) === -1;
    });
    logger._logEvent.level.label = methodLevel;
    logger._logEvent.level.value = methodValue;
    send(methodLevel, logger._logEvent, val);
    logger._logEvent = $013f680af02bad82$var$createLogEventShape(bindings);
}
function $013f680af02bad82$var$createLogEventShape(bindings) {
    return {
        ts: 0,
        messages: [],
        bindings: bindings || [],
        level: {
            label: "",
            value: 0
        }
    };
}
function $013f680af02bad82$var$asErrValue(err) {
    var obj = {
        type: err.constructor.name,
        msg: err.message,
        stack: err.stack
    };
    for(var key in err)if (obj[key] === undefined) obj[key] = err[key];
    return obj;
}
function $013f680af02bad82$var$getTimeFunction(opts) {
    if (typeof opts.timestamp === "function") return opts.timestamp;
    if (opts.timestamp === false) return $013f680af02bad82$var$nullTime;
    return $013f680af02bad82$var$epochTime;
}
function $013f680af02bad82$var$mock() {
    return {};
}
function $013f680af02bad82$var$passthrough(a) {
    return a;
}
function $013f680af02bad82$var$noop() {}
function $013f680af02bad82$var$nullTime() {
    return false;
}
function $013f680af02bad82$var$epochTime() {
    return Date.now();
}
function $013f680af02bad82$var$unixTime() {
    return Math.round(Date.now() / 1000.0);
}
function $013f680af02bad82$var$isoTime() {
    return new Date(Date.now()).toISOString();
} // using Date.now() for testability
/* eslint-disable */ /* istanbul ignore next */ function $013f680af02bad82$var$pfGlobalThisOrFallback() {
    function defd(o) {
        return typeof o !== "undefined" && o;
    }
    try {
        if (typeof globalThis !== "undefined") return globalThis;
        Object.defineProperty(Object.prototype, "globalThis", {
            get: function get() {
                delete Object.prototype.globalThis;
                return this.globalThis = this;
            },
            configurable: true
        });
        return globalThis;
    } catch (e) {
        return defd(self) || defd(window) || defd(this) || {};
    }
} /* eslint-enable */ 

});
parcelRegister("kbaNN", function(module, exports) {

var $l0HdX = parcelRequire("l0HdX");
"use strict";
function $eb0d36cbcc3dad35$var$tryStringify(o) {
    try {
        return JSON.stringify(o);
    } catch (e) {
        return '"[Circular]"';
    }
}
module.exports = $eb0d36cbcc3dad35$var$format;
function $eb0d36cbcc3dad35$var$format(f, args, opts) {
    var ss = opts && opts.stringify || $eb0d36cbcc3dad35$var$tryStringify;
    var offset = 1;
    if (typeof f === "object" && f !== null) {
        var len = args.length + offset;
        if (len === 1) return f;
        var objects = new Array(len);
        objects[0] = ss(f);
        for(var index = 1; index < len; index++)objects[index] = ss(args[index]);
        return objects.join(" ");
    }
    if (typeof f !== "string") return f;
    var argLen = args.length;
    if (argLen === 0) return f;
    var str = "";
    var a = 1 - offset;
    var lastPos = -1;
    var flen = f && f.length || 0;
    for(var i = 0; i < flen;){
        if (f.charCodeAt(i) === 37 && i + 1 < flen) {
            lastPos = lastPos > -1 ? lastPos : 0;
            switch(f.charCodeAt(i + 1)){
                case 100:
                case 102:
                    if (a >= argLen) break;
                    if (args[a] == null) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += Number(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 105:
                    if (a >= argLen) break;
                    if (args[a] == null) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += Math.floor(Number(args[a]));
                    lastPos = i + 2;
                    i++;
                    break;
                case 79:
                case 111:
                case 106:
                    if (a >= argLen) break;
                    if (args[a] === undefined) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    var type = (0, $l0HdX._)(args[a]);
                    if (type === "string") {
                        str += "'" + args[a] + "'";
                        lastPos = i + 2;
                        i++;
                        break;
                    }
                    if (type === "function") {
                        str += args[a].name || "<anonymous>";
                        lastPos = i + 2;
                        i++;
                        break;
                    }
                    str += ss(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 115:
                    if (a >= argLen) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += String(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 37:
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += "%";
                    lastPos = i + 2;
                    i++;
                    a--;
                    break;
            }
            ++a;
        }
        ++i;
    }
    if (lastPos === -1) return f;
    else if (lastPos < flen) str += f.slice(lastPos);
    return str;
}

});


parcelRegister("2fy4s", function(module, exports) {

$parcel$export(module.exports, "safeJsonParse", function () { return $1a376944b3e66524$export$84137bb44359aed5; });
$parcel$export(module.exports, "safeJsonStringify", function () { return $1a376944b3e66524$export$abc3f407e87918a4; });

var $l0HdX = parcelRequire("l0HdX");
var $1a376944b3e66524$var$JSONStringify = function(data) {
    return JSON.stringify(data, function(_, value) {
        return (typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value)) === "bigint" ? value.toString() + "n" : value;
    });
};
var $1a376944b3e66524$var$JSONParse = function(json) {
    var numbersBiggerThanMaxInt = /([\[:])?(\d{17,}|(?:[9](?:[1-9]07199254740991|0[1-9]7199254740991|00[8-9]199254740991|007[2-9]99254740991|007199[3-9]54740991|0071992[6-9]4740991|00719925[5-9]740991|007199254[8-9]40991|0071992547[5-9]0991|00719925474[1-9]991|00719925474099[2-9])))([,\}\]])/g;
    var serializedData = json.replace(numbersBiggerThanMaxInt, '$1"$2n"$3');
    return JSON.parse(serializedData, function(_, value) {
        var isCustomFormatBigInt = typeof value === "string" && value.match(/^\d+n$/);
        if (isCustomFormatBigInt) return BigInt(value.substring(0, value.length - 1));
        return value;
    });
};
function $1a376944b3e66524$export$84137bb44359aed5(value) {
    if (typeof value !== "string") throw new Error("Cannot safe json parse value of type ".concat(typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value)));
    try {
        return $1a376944b3e66524$var$JSONParse(value);
    } catch (_a) {
        return value;
    }
}
function $1a376944b3e66524$export$abc3f407e87918a4(value) {
    return typeof value === "string" ? value : $1a376944b3e66524$var$JSONStringify(value) || "";
}

});







parcelRegister("4Tiue", function(module, exports) {

$parcel$export(module.exports, "SwapApiUtil", function () { return $38faa387583e8c7c$export$1f5dcd8c91bd5bea; });

var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $eha6O = parcelRequire("eha6O");

var $3cYIS = parcelRequire("3cYIS");

var $2sXdV = parcelRequire("2sXdV");

var $jrvVk = parcelRequire("jrvVk");

var $faNff = parcelRequire("faNff");

var $fPqxb = parcelRequire("fPqxb");

var $dMLJP = parcelRequire("dMLJP");

var $9zDWP = parcelRequire("9zDWP");
var $38faa387583e8c7c$export$1f5dcd8c91bd5bea = {
    getTokenList: function() {
        return (0, $kSuI9._)(function() {
            var _response_tokens, caipNetwork, response, tokens;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        caipNetwork = (0, $fPqxb.NetworkController).state.caipNetwork;
                        return [
                            4,
                            (0, $jrvVk.BlockchainApiController).fetchSwapTokens({
                                chainId: caipNetwork === null || caipNetwork === void 0 ? void 0 : caipNetwork.id,
                                projectId: (0, $faNff.OptionsController).state.projectId
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        tokens = (response === null || response === void 0 ? void 0 : (_response_tokens = response.tokens) === null || _response_tokens === void 0 ? void 0 : _response_tokens.map(function(token) {
                            return (0, $cxjpp._)((0, $do9pw._)({}, token), {
                                eip2612: false,
                                quantity: {
                                    decimals: "0",
                                    numeric: "0"
                                },
                                price: 0,
                                value: 0
                            });
                        })) || [];
                        return [
                            2,
                            tokens
                        ];
                }
            });
        })();
    },
    fetchGasPrice: function() {
        return (0, $kSuI9._)(function() {
            var projectId, caipNetwork;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        projectId = (0, $faNff.OptionsController).state.projectId;
                        caipNetwork = (0, $fPqxb.NetworkController).state.caipNetwork;
                        if (!caipNetwork) return [
                            2,
                            null
                        ];
                        return [
                            4,
                            (0, $jrvVk.BlockchainApiController).fetchGasPrice({
                                projectId: projectId,
                                chainId: caipNetwork.id
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        })();
    },
    fetchSwapAllowance: function(param) {
        var tokenAddress = param.tokenAddress, userAddress = param.userAddress, sourceTokenAmount = param.sourceTokenAmount, sourceTokenDecimals = param.sourceTokenDecimals;
        return (0, $kSuI9._)(function() {
            var projectId, response, parsedValue, hasAllowance;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        projectId = (0, $faNff.OptionsController).state.projectId;
                        return [
                            4,
                            (0, $jrvVk.BlockchainApiController).fetchSwapAllowance({
                                projectId: projectId,
                                tokenAddress: tokenAddress,
                                userAddress: userAddress
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if ((response === null || response === void 0 ? void 0 : response.allowance) && sourceTokenAmount && sourceTokenDecimals) {
                            parsedValue = (0, $3cYIS.ConnectionController).parseUnits(sourceTokenAmount, sourceTokenDecimals) || 0;
                            hasAllowance = BigInt(response.allowance) >= parsedValue;
                            return [
                                2,
                                hasAllowance
                            ];
                        }
                        return [
                            2,
                            false
                        ];
                }
            });
        })();
    },
    getMyTokensWithBalance: function(forceUpdate) {
        return (0, $kSuI9._)(function() {
            var address, caipNetwork, response, balances;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        address = (0, $dMLJP.AccountController).state.address;
                        caipNetwork = (0, $fPqxb.NetworkController).state.caipNetwork;
                        if (!address || !caipNetwork) return [
                            2,
                            []
                        ];
                        return [
                            4,
                            (0, $jrvVk.BlockchainApiController).getBalance(address, caipNetwork.id, forceUpdate)
                        ];
                    case 1:
                        response = _state.sent();
                        balances = response.balances.filter(function(balance) {
                            return balance.quantity.decimals !== "0";
                        });
                        (0, $dMLJP.AccountController).setTokenBalance(balances, (0, $9zDWP.ChainController).state.activeChain);
                        return [
                            2,
                            this.mapBalancesToSwapTokens(balances)
                        ];
                }
            });
        }).apply(this);
    },
    mapBalancesToSwapTokens: function(balances) {
        return (balances === null || balances === void 0 ? void 0 : balances.map(function(token) {
            return (0, $cxjpp._)((0, $do9pw._)({}, token), {
                address: (token === null || token === void 0 ? void 0 : token.address) ? token.address : "".concat(token.chainId, ":").concat((0, $2sXdV.ConstantsUtil).NATIVE_TOKEN_ADDRESS),
                decimals: parseInt(token.quantity.decimals, 10),
                logoUri: token.iconUrl,
                eip2612: false
            });
        })) || [];
    }
};

});

parcelRegister("iptjJ", function(module, exports) {

$parcel$export(module.exports, "RouterController", function () { return $d6714d923592f5d3$export$5ceead2526330ba8; });

var $cv9Rk = parcelRequire("cv9Rk");

var $6vAtg = parcelRequire("6vAtg");

var $hyDkn = parcelRequire("hyDkn");
// -- State --------------------------------------------- //
var $d6714d923592f5d3$var$state = (0, $hyDkn.proxy)({
    view: "Connect",
    history: [
        "Connect"
    ],
    transactionStack: []
});
var $d6714d923592f5d3$export$5ceead2526330ba8 = {
    state: $d6714d923592f5d3$var$state,
    subscribeKey: function(key, callback) {
        return (0, $6vAtg.subscribeKey)($d6714d923592f5d3$var$state, key, callback);
    },
    pushTransactionStack: function(action) {
        $d6714d923592f5d3$var$state.transactionStack.push(action);
    },
    popTransactionStack: function(cancel) {
        var action = $d6714d923592f5d3$var$state.transactionStack.pop();
        if (!action) return;
        if (cancel) {
            var _action_onCancel;
            this.goBack();
            action === null || action === void 0 ? void 0 : (_action_onCancel = action.onCancel) === null || _action_onCancel === void 0 ? void 0 : _action_onCancel.call(action);
        } else {
            var _action_onSuccess;
            if (action.goBack) this.goBack();
            else if (action.view) this.reset(action.view);
            action === null || action === void 0 ? void 0 : (_action_onSuccess = action.onSuccess) === null || _action_onSuccess === void 0 ? void 0 : _action_onSuccess.call(action);
        }
    },
    push: function(view, data) {
        if (view !== $d6714d923592f5d3$var$state.view) {
            $d6714d923592f5d3$var$state.view = view;
            $d6714d923592f5d3$var$state.history.push(view);
            $d6714d923592f5d3$var$state.data = data;
        }
    },
    reset: function(view) {
        $d6714d923592f5d3$var$state.view = view;
        $d6714d923592f5d3$var$state.history = [
            view
        ];
    },
    replace: function(view, data) {
        if ($d6714d923592f5d3$var$state.history.length >= 1 && $d6714d923592f5d3$var$state.history.at(-1) !== view) {
            $d6714d923592f5d3$var$state.view = view;
            $d6714d923592f5d3$var$state.history[$d6714d923592f5d3$var$state.history.length - 1] = view;
            $d6714d923592f5d3$var$state.data = data;
        }
    },
    goBack: function() {
        if ($d6714d923592f5d3$var$state.history.length > 1) {
            $d6714d923592f5d3$var$state.history.pop();
            var _state_history_slice = (0, $cv9Rk._)($d6714d923592f5d3$var$state.history.slice(-1), 1), last = _state_history_slice[0];
            if (last) $d6714d923592f5d3$var$state.view = last;
        }
    },
    goBackToIndex: function(historyIndex) {
        if ($d6714d923592f5d3$var$state.history.length > 1) {
            $d6714d923592f5d3$var$state.history = $d6714d923592f5d3$var$state.history.slice(0, historyIndex + 1);
            var _state_history_slice = (0, $cv9Rk._)($d6714d923592f5d3$var$state.history.slice(-1), 1), last = _state_history_slice[0];
            if (last) $d6714d923592f5d3$var$state.view = last;
        }
    }
};

});

parcelRegister("Lhkxt", function(module, exports) {

$parcel$export(module.exports, "SwapCalculationUtil", function () { return $08e1d555050736c4$export$c185d942b7ce88b4; });
// -- Types --------------------------------------------- //
parcelRequire("dSKxG");
var $eMPGH = parcelRequire("eMPGH");
var $08e1d555050736c4$export$c185d942b7ce88b4 = {
    getGasPriceInEther: function(gas, gasPrice) {
        var totalGasCostInWei = gasPrice * gas;
        var totalGasCostInEther = Number(totalGasCostInWei) / 1e18;
        return totalGasCostInEther;
    },
    getGasPriceInUSD: function(networkPrice, gas, gasPrice) {
        var totalGasCostInEther = $08e1d555050736c4$export$c185d942b7ce88b4.getGasPriceInEther(gas, gasPrice);
        var networkPriceInUSD = (0, $eMPGH.NumberUtil).bigNumber(networkPrice);
        var gasCostInUSD = networkPriceInUSD.multipliedBy(totalGasCostInEther);
        return gasCostInUSD.toNumber();
    },
    getPriceImpact: function(param) {
        var sourceTokenAmount = param.sourceTokenAmount, sourceTokenPriceInUSD = param.sourceTokenPriceInUSD, toTokenPriceInUSD = param.toTokenPriceInUSD, toTokenAmount = param.toTokenAmount;
        var inputValue = (0, $eMPGH.NumberUtil).bigNumber(sourceTokenAmount).multipliedBy(sourceTokenPriceInUSD);
        var outputValue = (0, $eMPGH.NumberUtil).bigNumber(toTokenAmount).multipliedBy(toTokenPriceInUSD);
        var priceImpact = inputValue.minus(outputValue).dividedBy(inputValue).multipliedBy(100);
        return priceImpact.toNumber();
    },
    getMaxSlippage: function(slippage, toTokenAmount) {
        var slippageToleranceDecimal = (0, $eMPGH.NumberUtil).bigNumber(slippage).dividedBy(100);
        var maxSlippageAmount = (0, $eMPGH.NumberUtil).multiply(toTokenAmount, slippageToleranceDecimal);
        return maxSlippageAmount.toNumber();
    },
    getProviderFee: function(sourceTokenAmount) {
        var feePercentage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0.0085;
        var providerFee = (0, $eMPGH.NumberUtil).bigNumber(sourceTokenAmount).multipliedBy(feePercentage);
        return providerFee.toString();
    },
    isInsufficientNetworkTokenForGas: function(networkBalanceInUSD, gasPriceInUSD) {
        var gasPrice = gasPriceInUSD || "0";
        if ((0, $eMPGH.NumberUtil).bigNumber(networkBalanceInUSD).isZero()) return true;
        return (0, $eMPGH.NumberUtil).bigNumber((0, $eMPGH.NumberUtil).bigNumber(gasPrice)).isGreaterThan(networkBalanceInUSD);
    },
    isInsufficientSourceTokenForSwap: function(sourceTokenAmount, sourceTokenAddress, balance) {
        var _balance_find_quantity, _balance_find;
        var sourceTokenBalance = balance === null || balance === void 0 ? void 0 : (_balance_find = balance.find(function(token) {
            return token.address === sourceTokenAddress;
        })) === null || _balance_find === void 0 ? void 0 : (_balance_find_quantity = _balance_find.quantity) === null || _balance_find_quantity === void 0 ? void 0 : _balance_find_quantity.numeric;
        var isInSufficientBalance = (0, $eMPGH.NumberUtil).bigNumber(sourceTokenBalance || "0").isLessThan(sourceTokenAmount);
        return isInSufficientBalance;
    },
    getToTokenAmount: function(param) {
        var sourceToken = param.sourceToken, toToken = param.toToken, sourceTokenPrice = param.sourceTokenPrice, toTokenPrice = param.toTokenPrice, sourceTokenAmount = param.sourceTokenAmount;
        if (sourceTokenAmount === "0") return "0";
        if (!sourceToken || !toToken) return "0";
        var sourceTokenDecimals = sourceToken.decimals;
        var sourceTokenPriceInUSD = sourceTokenPrice;
        var toTokenDecimals = toToken.decimals;
        var toTokenPriceInUSD = toTokenPrice;
        if (toTokenPriceInUSD <= 0) return "0";
        // Calculate the provider fee (0.85% of the source token amount)
        var providerFee = (0, $eMPGH.NumberUtil).bigNumber(sourceTokenAmount).multipliedBy(0.0085);
        // Adjust the source token amount by subtracting the provider fee
        var adjustedSourceTokenAmount = (0, $eMPGH.NumberUtil).bigNumber(sourceTokenAmount).minus(providerFee);
        // Proceed with conversion using the adjusted source token amount
        var sourceAmountInSmallestUnit = adjustedSourceTokenAmount.multipliedBy((0, $eMPGH.NumberUtil).bigNumber(10).pow(sourceTokenDecimals));
        var priceRatio = (0, $eMPGH.NumberUtil).bigNumber(sourceTokenPriceInUSD).dividedBy(toTokenPriceInUSD);
        var decimalDifference = sourceTokenDecimals - toTokenDecimals;
        var toTokenAmountInSmallestUnit = sourceAmountInSmallestUnit.multipliedBy(priceRatio).dividedBy((0, $eMPGH.NumberUtil).bigNumber(10).pow(decimalDifference));
        var toTokenAmount = toTokenAmountInSmallestUnit.dividedBy((0, $eMPGH.NumberUtil).bigNumber(10).pow(toTokenDecimals));
        var amount = toTokenAmount.toFixed(toTokenDecimals).toString();
        return amount;
    }
};

});




parcelRegister("69mn1", function(module, exports) {

$parcel$export(module.exports, "OnRampController", function () { return $47a4ef98eb77daa8$export$8cdcd0d64858bea7; });

var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $6vAtg = parcelRequire("6vAtg");

var $hyDkn = parcelRequire("hyDkn");

var $2sXdV = parcelRequire("2sXdV");

var $jrvVk = parcelRequire("jrvVk");

var $hMdcG = parcelRequire("hMdcG");
var $47a4ef98eb77daa8$export$fed6f7f3caffd3f0 = {
    id: "2b92315d-eab7-5bef-84fa-089a131333f5",
    name: "USD Coin",
    symbol: "USDC",
    networks: [
        {
            name: "ethereum-mainnet",
            display_name: "Ethereum",
            chain_id: "1",
            contract_address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"
        },
        {
            name: "polygon-mainnet",
            display_name: "Polygon",
            chain_id: "137",
            contract_address: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174"
        }
    ]
};
var $47a4ef98eb77daa8$export$213201b848d8007c = {
    id: "USD",
    payment_method_limits: [
        {
            id: "card",
            min: "10.00",
            max: "7500.00"
        },
        {
            id: "ach_bank_account",
            min: "10.00",
            max: "25000.00"
        }
    ]
};
var $47a4ef98eb77daa8$var$defaultState = {
    providers: (0, $2sXdV.ONRAMP_PROVIDERS),
    selectedProvider: null,
    error: null,
    purchaseCurrency: $47a4ef98eb77daa8$export$fed6f7f3caffd3f0,
    paymentCurrency: $47a4ef98eb77daa8$export$213201b848d8007c,
    purchaseCurrencies: [
        $47a4ef98eb77daa8$export$fed6f7f3caffd3f0
    ],
    paymentCurrencies: [],
    quotesLoading: false
};
// -- State --------------------------------------------- //
var $47a4ef98eb77daa8$var$state = (0, $hyDkn.proxy)($47a4ef98eb77daa8$var$defaultState);
var $47a4ef98eb77daa8$export$8cdcd0d64858bea7 = {
    state: $47a4ef98eb77daa8$var$state,
    subscribe: function(callback) {
        return (0, $hyDkn.subscribe)($47a4ef98eb77daa8$var$state, function() {
            return callback($47a4ef98eb77daa8$var$state);
        });
    },
    subscribeKey: function(key, callback) {
        return (0, $6vAtg.subscribeKey)($47a4ef98eb77daa8$var$state, key, callback);
    },
    setSelectedProvider: function(provider) {
        $47a4ef98eb77daa8$var$state.selectedProvider = provider;
    },
    setPurchaseCurrency: function(currency) {
        $47a4ef98eb77daa8$var$state.purchaseCurrency = currency;
    },
    setPaymentCurrency: function(currency) {
        $47a4ef98eb77daa8$var$state.paymentCurrency = currency;
    },
    setPurchaseAmount: function(amount) {
        this.state.purchaseAmount = amount;
    },
    setPaymentAmount: function(amount) {
        this.state.paymentAmount = amount;
    },
    getAvailableCurrencies: function() {
        return (0, $kSuI9._)(function() {
            var options;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, $jrvVk.BlockchainApiController).getOnrampOptions()
                        ];
                    case 1:
                        options = _state.sent();
                        $47a4ef98eb77daa8$var$state.purchaseCurrencies = options.purchaseCurrencies;
                        $47a4ef98eb77daa8$var$state.paymentCurrencies = options.paymentCurrencies;
                        $47a4ef98eb77daa8$var$state.paymentCurrency = options.paymentCurrencies[0] || $47a4ef98eb77daa8$export$213201b848d8007c;
                        $47a4ef98eb77daa8$var$state.purchaseCurrency = options.purchaseCurrencies[0] || $47a4ef98eb77daa8$export$fed6f7f3caffd3f0;
                        return [
                            4,
                            (0, $hMdcG.ApiController).fetchCurrencyImages(options.paymentCurrencies.map(function(currency) {
                                return currency.id;
                            }))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            (0, $hMdcG.ApiController).fetchTokenImages(options.purchaseCurrencies.map(function(currency) {
                                return currency.symbol;
                            }))
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    },
    getQuote: function() {
        return (0, $kSuI9._)(function() {
            var _state_paymentAmount, _state_purchaseCurrency, quote, error;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $47a4ef98eb77daa8$var$state.quotesLoading = true;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            (0, $jrvVk.BlockchainApiController).getOnrampQuote({
                                purchaseCurrency: $47a4ef98eb77daa8$var$state.purchaseCurrency,
                                paymentCurrency: $47a4ef98eb77daa8$var$state.paymentCurrency,
                                amount: ((_state_paymentAmount = $47a4ef98eb77daa8$var$state.paymentAmount) === null || _state_paymentAmount === void 0 ? void 0 : _state_paymentAmount.toString()) || "0",
                                network: (_state_purchaseCurrency = $47a4ef98eb77daa8$var$state.purchaseCurrency) === null || _state_purchaseCurrency === void 0 ? void 0 : _state_purchaseCurrency.symbol
                            })
                        ];
                    case 2:
                        quote = _state.sent();
                        $47a4ef98eb77daa8$var$state.quotesLoading = false;
                        $47a4ef98eb77daa8$var$state.purchaseAmount = Number(quote.purchaseAmount.amount);
                        return [
                            2,
                            quote
                        ];
                    case 3:
                        error = _state.sent();
                        $47a4ef98eb77daa8$var$state.error = error.message;
                        $47a4ef98eb77daa8$var$state.quotesLoading = false;
                        return [
                            2,
                            null
                        ];
                    case 4:
                        $47a4ef98eb77daa8$var$state.quotesLoading = false;
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })();
    },
    resetState: function() {
        $47a4ef98eb77daa8$var$state.providers = (0, $2sXdV.ONRAMP_PROVIDERS);
        $47a4ef98eb77daa8$var$state.selectedProvider = null;
        $47a4ef98eb77daa8$var$state.error = null;
        $47a4ef98eb77daa8$var$state.purchaseCurrency = $47a4ef98eb77daa8$export$fed6f7f3caffd3f0;
        $47a4ef98eb77daa8$var$state.paymentCurrency = $47a4ef98eb77daa8$export$213201b848d8007c;
        $47a4ef98eb77daa8$var$state.purchaseCurrencies = [
            $47a4ef98eb77daa8$export$fed6f7f3caffd3f0
        ];
        $47a4ef98eb77daa8$var$state.paymentCurrencies = [];
        $47a4ef98eb77daa8$var$state.paymentAmount = undefined;
        $47a4ef98eb77daa8$var$state.purchaseAmount = undefined;
        $47a4ef98eb77daa8$var$state.quotesLoading = false;
    }
};

});

parcelRegister("iSNyw", function(module, exports) {

$parcel$export(module.exports, "SendController", function () { return $dbf3b5ddee2b8b8e$export$e3bfd79582777e03; });

var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $6vAtg = parcelRequire("6vAtg");

var $hyDkn = parcelRequire("hyDkn");
parcelRequire("dSKxG");
var $55oQe = parcelRequire("55oQe");

var $iptjJ = parcelRequire("iptjJ");

var $dMLJP = parcelRequire("dMLJP");

var $3cYIS = parcelRequire("3cYIS");

var $8FcCV = parcelRequire("8FcCV");

var $hZBJb = parcelRequire("hZBJb");

var $1QDT9 = parcelRequire("1QDT9");

var $fPqxb = parcelRequire("fPqxb");
parcelRequire("hsyMZ");
var $cSJ4o = parcelRequire("cSJ4o");
// -- State --------------------------------------------- //
var $dbf3b5ddee2b8b8e$var$state = (0, $hyDkn.proxy)({
    loading: false
});
var $dbf3b5ddee2b8b8e$export$e3bfd79582777e03 = {
    state: $dbf3b5ddee2b8b8e$var$state,
    subscribe: function(callback) {
        return (0, $hyDkn.subscribe)($dbf3b5ddee2b8b8e$var$state, function() {
            return callback($dbf3b5ddee2b8b8e$var$state);
        });
    },
    subscribeKey: function(key, callback) {
        return (0, $6vAtg.subscribeKey)($dbf3b5ddee2b8b8e$var$state, key, callback);
    },
    setToken: function(token) {
        if (token) $dbf3b5ddee2b8b8e$var$state.token = (0, $hyDkn.ref)(token);
    },
    setTokenAmount: function(sendTokenAmount) {
        $dbf3b5ddee2b8b8e$var$state.sendTokenAmount = sendTokenAmount;
    },
    setReceiverAddress: function(receiverAddress) {
        $dbf3b5ddee2b8b8e$var$state.receiverAddress = receiverAddress;
    },
    setReceiverProfileImageUrl: function(receiverProfileImageUrl) {
        $dbf3b5ddee2b8b8e$var$state.receiverProfileImageUrl = receiverProfileImageUrl;
    },
    setReceiverProfileName: function(receiverProfileName) {
        $dbf3b5ddee2b8b8e$var$state.receiverProfileName = receiverProfileName;
    },
    setGasPrice: function(gasPrice) {
        $dbf3b5ddee2b8b8e$var$state.gasPrice = gasPrice;
    },
    setGasPriceInUsd: function(gasPriceInUSD) {
        $dbf3b5ddee2b8b8e$var$state.gasPriceInUSD = gasPriceInUSD;
    },
    setLoading: function(loading) {
        $dbf3b5ddee2b8b8e$var$state.loading = loading;
    },
    sendToken: function() {
        var _this_state_token, _this_state_token1;
        if (((_this_state_token = this.state.token) === null || _this_state_token === void 0 ? void 0 : _this_state_token.address) && this.state.sendTokenAmount && this.state.receiverAddress) {
            var _NetworkController_state_caipNetwork;
            (0, $1QDT9.EventsController).sendEvent({
                type: "track",
                event: "SEND_INITIATED",
                properties: {
                    isSmartAccount: (0, $dMLJP.AccountController).state.preferredAccountType === (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT,
                    token: this.state.token.address,
                    amount: this.state.sendTokenAmount,
                    network: ((_NetworkController_state_caipNetwork = (0, $fPqxb.NetworkController).state.caipNetwork) === null || _NetworkController_state_caipNetwork === void 0 ? void 0 : _NetworkController_state_caipNetwork.id) || ""
                }
            });
            this.sendERC20Token({
                receiverAddress: this.state.receiverAddress,
                tokenAddress: this.state.token.address,
                sendTokenAmount: this.state.sendTokenAmount,
                decimals: this.state.token.quantity.decimals
            });
        } else if (this.state.receiverAddress && this.state.sendTokenAmount && this.state.gasPrice && ((_this_state_token1 = this.state.token) === null || _this_state_token1 === void 0 ? void 0 : _this_state_token1.quantity.decimals)) {
            var _this_state_token2, _NetworkController_state_caipNetwork1;
            (0, $1QDT9.EventsController).sendEvent({
                type: "track",
                event: "SEND_INITIATED",
                properties: {
                    isSmartAccount: (0, $dMLJP.AccountController).state.preferredAccountType === (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT,
                    token: (_this_state_token2 = this.state.token) === null || _this_state_token2 === void 0 ? void 0 : _this_state_token2.symbol,
                    amount: this.state.sendTokenAmount,
                    network: ((_NetworkController_state_caipNetwork1 = (0, $fPqxb.NetworkController).state.caipNetwork) === null || _NetworkController_state_caipNetwork1 === void 0 ? void 0 : _NetworkController_state_caipNetwork1.id) || ""
                }
            });
            this.sendNativeToken({
                receiverAddress: this.state.receiverAddress,
                sendTokenAmount: this.state.sendTokenAmount,
                gasPrice: this.state.gasPrice,
                decimals: this.state.token.quantity.decimals
            });
        }
    },
    sendNativeToken: function(params) {
        return (0, $kSuI9._)(function() {
            var to, address, value, data, _this_state_token, _NetworkController_state_caipNetwork, error, _this_state_token1, _NetworkController_state_caipNetwork1;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        (0, $iptjJ.RouterController).pushTransactionStack({
                            view: "Account",
                            goBack: false
                        });
                        to = params.receiverAddress;
                        address = (0, $dMLJP.AccountController).state.address;
                        value = (0, $3cYIS.ConnectionController).parseUnits(params.sendTokenAmount.toString(), Number(params.decimals));
                        data = "0x";
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0, $3cYIS.ConnectionController).sendTransaction({
                                to: to,
                                address: address,
                                data: data,
                                value: value,
                                gasPrice: params.gasPrice
                            })
                        ];
                    case 2:
                        _state.sent();
                        (0, $8FcCV.SnackController).showSuccess("Transaction started");
                        (0, $1QDT9.EventsController).sendEvent({
                            type: "track",
                            event: "SEND_SUCCESS",
                            properties: {
                                isSmartAccount: (0, $dMLJP.AccountController).state.preferredAccountType === (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT,
                                token: ((_this_state_token = this.state.token) === null || _this_state_token === void 0 ? void 0 : _this_state_token.symbol) || "",
                                amount: params.sendTokenAmount,
                                network: ((_NetworkController_state_caipNetwork = (0, $fPqxb.NetworkController).state.caipNetwork) === null || _NetworkController_state_caipNetwork === void 0 ? void 0 : _NetworkController_state_caipNetwork.id) || ""
                            }
                        });
                        this.resetSend();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        (0, $1QDT9.EventsController).sendEvent({
                            type: "track",
                            event: "SEND_ERROR",
                            properties: {
                                isSmartAccount: (0, $dMLJP.AccountController).state.preferredAccountType === (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT,
                                token: ((_this_state_token1 = this.state.token) === null || _this_state_token1 === void 0 ? void 0 : _this_state_token1.symbol) || "",
                                amount: params.sendTokenAmount,
                                network: ((_NetworkController_state_caipNetwork1 = (0, $fPqxb.NetworkController).state.caipNetwork) === null || _NetworkController_state_caipNetwork1 === void 0 ? void 0 : _NetworkController_state_caipNetwork1.id) || ""
                            }
                        });
                        (0, $8FcCV.SnackController).showError("Something went wrong");
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    sendERC20Token: function(params) {
        return (0, $kSuI9._)(function() {
            var amount, error;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        (0, $iptjJ.RouterController).pushTransactionStack({
                            view: "Account",
                            goBack: false
                        });
                        amount = (0, $3cYIS.ConnectionController).parseUnits(params.sendTokenAmount.toString(), Number(params.decimals));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        if (!((0, $dMLJP.AccountController).state.address && params.sendTokenAmount && params.receiverAddress && params.tokenAddress)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            (0, $3cYIS.ConnectionController).writeContract({
                                fromAddress: (0, $dMLJP.AccountController).state.address,
                                tokenAddress: (0, $hZBJb.CoreHelperUtil).getPlainAddress(params.tokenAddress),
                                receiverAddress: params.receiverAddress,
                                tokenAmount: amount,
                                method: "transfer",
                                abi: (0, $55oQe.erc20ABI)
                            })
                        ];
                    case 2:
                        _state.sent();
                        (0, $8FcCV.SnackController).showSuccess("Transaction started");
                        this.resetSend();
                        _state.label = 3;
                    case 3:
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        (0, $8FcCV.SnackController).showError("Something went wrong");
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    resetSend: function() {
        $dbf3b5ddee2b8b8e$var$state.token = undefined;
        $dbf3b5ddee2b8b8e$var$state.sendTokenAmount = undefined;
        $dbf3b5ddee2b8b8e$var$state.receiverAddress = undefined;
        $dbf3b5ddee2b8b8e$var$state.receiverProfileImageUrl = undefined;
        $dbf3b5ddee2b8b8e$var$state.receiverProfileName = undefined;
        $dbf3b5ddee2b8b8e$var$state.loading = false;
    }
};

});

parcelRegister("5R7lI", function(module, exports) {

$parcel$export(module.exports, "TooltipController", function () { return $44379a69b9a976b7$export$ad76ea7b944b0d8; });

var $6vAtg = parcelRequire("6vAtg");

var $hyDkn = parcelRequire("hyDkn");
// -- State --------------------------------------------- //
var $44379a69b9a976b7$var$state = (0, $hyDkn.proxy)({
    message: "",
    open: false,
    triggerRect: {
        width: 0,
        height: 0,
        top: 0,
        left: 0
    },
    variant: "shade"
});
var $44379a69b9a976b7$export$ad76ea7b944b0d8 = {
    state: $44379a69b9a976b7$var$state,
    subscribe: function(callback) {
        return (0, $hyDkn.subscribe)($44379a69b9a976b7$var$state, function() {
            return callback($44379a69b9a976b7$var$state);
        });
    },
    subscribeKey: function(key, callback) {
        return (0, $6vAtg.subscribeKey)($44379a69b9a976b7$var$state, key, callback);
    },
    showTooltip: function(param) {
        var message = param.message, triggerRect = param.triggerRect, variant = param.variant;
        $44379a69b9a976b7$var$state.open = true;
        $44379a69b9a976b7$var$state.message = message;
        $44379a69b9a976b7$var$state.triggerRect = triggerRect;
        $44379a69b9a976b7$var$state.variant = variant;
    },
    hide: function() {
        $44379a69b9a976b7$var$state.open = false;
        $44379a69b9a976b7$var$state.message = "";
        $44379a69b9a976b7$var$state.triggerRect = {
            width: 0,
            height: 0,
            top: 0,
            left: 0
        };
    }
};

});

parcelRegister("kOW8v", function(module, exports) {

$parcel$export(module.exports, "EnsController", function () { return $f28592cc1615ae72$export$d0d981286ee4cb7; });

var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $eha6O = parcelRequire("eha6O");

var $6vAtg = parcelRequire("6vAtg");

var $hyDkn = parcelRequire("hyDkn");

var $jrvVk = parcelRequire("jrvVk");

var $dMLJP = parcelRequire("dMLJP");

var $2qlRb = parcelRequire("2qlRb");

var $iptjJ = parcelRequire("iptjJ");

var $3cYIS = parcelRequire("3cYIS");

var $fPqxb = parcelRequire("fPqxb");
parcelRequire("dSKxG");
var $3QZC1 = parcelRequire("3QZC1");
var $fcokf = parcelRequire("fcokf");

var $lpbG5 = parcelRequire("lpbG5");

var $9zDWP = parcelRequire("9zDWP");
// -- State --------------------------------------------- //
var $f28592cc1615ae72$var$state = (0, $hyDkn.proxy)({
    suggestions: [],
    loading: false
});
var $f28592cc1615ae72$export$d0d981286ee4cb7 = {
    state: $f28592cc1615ae72$var$state,
    subscribe: function(callback) {
        return (0, $hyDkn.subscribe)($f28592cc1615ae72$var$state, function() {
            return callback($f28592cc1615ae72$var$state);
        });
    },
    subscribeKey: function(key, callback) {
        return (0, $6vAtg.subscribeKey)($f28592cc1615ae72$var$state, key, callback);
    },
    resolveName: function(name) {
        return (0, $kSuI9._)(function() {
            var e, _error_reasons_, _error_reasons, error;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0, $jrvVk.BlockchainApiController).lookupEnsName(name)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 2:
                        e = _state.sent();
                        error = e;
                        throw new Error((error === null || error === void 0 ? void 0 : (_error_reasons = error.reasons) === null || _error_reasons === void 0 ? void 0 : (_error_reasons_ = _error_reasons[0]) === null || _error_reasons_ === void 0 ? void 0 : _error_reasons_.description) || "Error resolving name");
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    },
    isNameRegistered: function(name) {
        return (0, $kSuI9._)(function() {
            var e;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0, $jrvVk.BlockchainApiController).lookupEnsName(name)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2,
                            true
                        ];
                    case 2:
                        e = _state.sent();
                        return [
                            2,
                            false
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    },
    getSuggestions: function(name) {
        return (0, $kSuI9._)(function() {
            var response, e, errorMessage;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        $f28592cc1615ae72$var$state.loading = true;
                        $f28592cc1615ae72$var$state.suggestions = [];
                        return [
                            4,
                            (0, $jrvVk.BlockchainApiController).getEnsNameSuggestions(name)
                        ];
                    case 1:
                        response = _state.sent();
                        $f28592cc1615ae72$var$state.suggestions = response.suggestions.map(function(suggestion) {
                            return (0, $cxjpp._)((0, $do9pw._)({}, suggestion), {
                                name: suggestion.name.replace((0, $3QZC1.ConstantsUtil).WC_NAME_SUFFIX, "")
                            });
                        }) || [];
                        return [
                            2,
                            $f28592cc1615ae72$var$state.suggestions
                        ];
                    case 2:
                        e = _state.sent();
                        errorMessage = this.parseEnsApiError(e, "Error fetching name suggestions");
                        throw new Error(errorMessage);
                    case 3:
                        $f28592cc1615ae72$var$state.loading = false;
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    getNamesForAddress: function(address) {
        return (0, $kSuI9._)(function() {
            var network, response, e, errorMessage;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        network = (0, $fPqxb.NetworkController).state.caipNetwork;
                        if (!network) return [
                            2,
                            []
                        ];
                        return [
                            4,
                            (0, $jrvVk.BlockchainApiController).reverseLookupEnsName({
                                address: address
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            2,
                            response
                        ];
                    case 2:
                        e = _state.sent();
                        errorMessage = this.parseEnsApiError(e, "Error fetching names for address");
                        throw new Error(errorMessage);
                    case 3:
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    registerName: function(name) {
        return (0, $kSuI9._)(function() {
            var network, address, emailConnector, message, signature, networkId, coinType, e, errorMessage;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        network = (0, $fPqxb.NetworkController).state.caipNetwork;
                        if (!network) throw new Error("Network not found");
                        address = (0, $dMLJP.AccountController).state.address;
                        emailConnector = (0, $2qlRb.ConnectorController).getAuthConnector();
                        if (!address || !emailConnector) throw new Error("Address or auth connector not found");
                        $f28592cc1615ae72$var$state.loading = true;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            5,
                            6
                        ]);
                        message = JSON.stringify({
                            name: "".concat(name).concat((0, $3QZC1.ConstantsUtil).WC_NAME_SUFFIX),
                            attributes: {},
                            timestamp: Math.floor(Date.now() / 1000)
                        });
                        (0, $iptjJ.RouterController).pushTransactionStack({
                            view: "RegisterAccountNameSuccess",
                            goBack: false,
                            replace: true,
                            onCancel: function() {
                                $f28592cc1615ae72$var$state.loading = false;
                            }
                        });
                        return [
                            4,
                            (0, $3cYIS.ConnectionController).signMessage(message)
                        ];
                    case 2:
                        signature = _state.sent();
                        networkId = (0, $fcokf.NetworkUtil).caipNetworkIdToNumber(network.id);
                        if (!networkId) throw new Error("Network not found");
                        coinType = (0, $lpbG5.EnsUtil).convertEVMChainIdToCoinType(networkId);
                        return [
                            4,
                            (0, $jrvVk.BlockchainApiController).registerEnsName({
                                coinType: coinType,
                                address: address,
                                signature: signature,
                                message: message
                            })
                        ];
                    case 3:
                        _state.sent();
                        (0, $dMLJP.AccountController).setProfileName("".concat(name).concat((0, $3QZC1.ConstantsUtil).WC_NAME_SUFFIX), (0, $9zDWP.ChainController).state.activeChain);
                        (0, $iptjJ.RouterController).replace("RegisterAccountNameSuccess");
                        return [
                            3,
                            6
                        ];
                    case 4:
                        e = _state.sent();
                        errorMessage = this.parseEnsApiError(e, "Error registering name ".concat(name));
                        (0, $iptjJ.RouterController).replace("RegisterAccountName");
                        throw new Error(errorMessage);
                    case 5:
                        $f28592cc1615ae72$var$state.loading = false;
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        }).apply(this);
    },
    validateName: function(name) {
        return RegExp("^[a-zA-Z0-9-]{4,}$", "u").test(name);
    },
    parseEnsApiError: function(error, defaultError) {
        var _ensError_reasons_, _ensError_reasons;
        var ensError = error;
        return (ensError === null || ensError === void 0 ? void 0 : (_ensError_reasons = ensError.reasons) === null || _ensError_reasons === void 0 ? void 0 : (_ensError_reasons_ = _ensError_reasons[0]) === null || _ensError_reasons_ === void 0 ? void 0 : _ensError_reasons_.description) || defaultError;
    }
};

});
parcelRegister("lpbG5", function(module, exports) {

$parcel$export(module.exports, "EnsUtil", function () { return $f954fdc42df0481d$export$88d8d1feba0d56ec; });
var $f954fdc42df0481d$var$SLIP44_MSB = 0x80000000;
var $f954fdc42df0481d$export$88d8d1feba0d56ec = {
    convertEVMChainIdToCoinType: function(chainId) {
        if (chainId >= $f954fdc42df0481d$var$SLIP44_MSB) throw new Error("Invalid chainId");
        return ($f954fdc42df0481d$var$SLIP44_MSB | chainId) >>> 0;
    }
};

});


parcelRegister("khm6W", function(module, exports) {

$parcel$export(module.exports, "AssetUtil", function () { return $ec368bee8c5ddbf6$export$2a2d471f51b1e9cb; });

var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $hMdcG = parcelRequire("hMdcG");

var $datXT = parcelRequire("datXT");
var $ec368bee8c5ddbf6$var$namespaceImageIds = {
    // Ethereum
    evm: "ba0ba0cd-17c6-4806-ad93-f9d174f17900",
    // Solana
    solana: "a1b58899-f671-4276-6a5e-56ca5bd59700"
};
var $ec368bee8c5ddbf6$export$2a2d471f51b1e9cb = {
    fetchWalletImage: function(imageId) {
        return (0, $kSuI9._)(function() {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!imageId) return [
                            2,
                            undefined
                        ];
                        return [
                            4,
                            (0, $hMdcG.ApiController)._fetchWalletImage(imageId)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2,
                            this.getWalletImageById(imageId)
                        ];
                }
            });
        }).apply(this);
    },
    getWalletImageById: function(imageId) {
        if (!imageId) return undefined;
        return (0, $datXT.AssetController).state.walletImages[imageId];
    },
    getWalletImage: function(wallet) {
        if (wallet === null || wallet === void 0 ? void 0 : wallet.image_url) return wallet === null || wallet === void 0 ? void 0 : wallet.image_url;
        if (wallet === null || wallet === void 0 ? void 0 : wallet.image_id) return (0, $datXT.AssetController).state.walletImages[wallet.image_id];
        return undefined;
    },
    getNetworkImage: function(network) {
        if (network === null || network === void 0 ? void 0 : network.imageUrl) return network === null || network === void 0 ? void 0 : network.imageUrl;
        if (network === null || network === void 0 ? void 0 : network.imageId) return (0, $datXT.AssetController).state.networkImages[network.imageId];
        return undefined;
    },
    getNetworkImageById: function(imageId) {
        if (!imageId) return undefined;
        return (0, $datXT.AssetController).state.networkImages[imageId];
    },
    getConnectorImage: function(connector) {
        if (connector === null || connector === void 0 ? void 0 : connector.imageUrl) return connector.imageUrl;
        if (connector === null || connector === void 0 ? void 0 : connector.imageId) return (0, $datXT.AssetController).state.connectorImages[connector.imageId];
        return undefined;
    },
    getChainImage: function(chain) {
        return (0, $datXT.AssetController).state.networkImages[$ec368bee8c5ddbf6$var$namespaceImageIds[chain]];
    }
};

});

parcelRegister("6a2RN", function(module, exports) {

$parcel$export(module.exports, "RouterUtil", function () { return $47c5e67e03122f66$export$12c6341a287a74e0; });

var $iptjJ = parcelRequire("iptjJ");

var $5Lhe6 = parcelRequire("5Lhe6");

var $faNff = parcelRequire("faNff");

var $9zDWP = parcelRequire("9zDWP");
parcelRequire("dSKxG");
var $3QZC1 = parcelRequire("3QZC1");
var $47c5e67e03122f66$export$12c6341a287a74e0 = {
    goBackOrCloseModal: function() {
        if ((0, $iptjJ.RouterController).state.history.length > 1) (0, $iptjJ.RouterController).goBack();
        else (0, $5Lhe6.ModalController).close();
    },
    navigateAfterNetworkSwitch: function() {
        var history = (0, $iptjJ.RouterController).state.history;
        var networkSelectIndex = history.findIndex(function(name) {
            return name === "Networks";
        });
        if (networkSelectIndex >= 1) (0, $iptjJ.RouterController).goBackToIndex(networkSelectIndex - 1);
        else (0, $5Lhe6.ModalController).close();
    },
    navigateAfterPreferredAccountTypeSelect: function() {
        var isSiweEnabled = (0, $faNff.OptionsController).state.isSiweEnabled;
        if (isSiweEnabled && (0, $9zDWP.ChainController).state.activeChain === (0, $3QZC1.ConstantsUtil).CHAIN.EVM) (0, $iptjJ.RouterController).push("ConnectingSiwe");
        else (0, $iptjJ.RouterController).push("Account");
    }
};

});


parcelRegister("grHtr", function(module, exports) {

$parcel$export(module.exports, "MathUtil", function () { return (parcelRequire("giGFz")).MathUtil; });
$parcel$export(module.exports, "initializeTheming", function () { return (parcelRequire("kYNxm")).initializeTheming; });
$parcel$export(module.exports, "setColorTheme", function () { return (parcelRequire("kYNxm")).setColorTheme; });
$parcel$export(module.exports, "setThemeVariables", function () { return (parcelRequire("kYNxm")).setThemeVariables; });
$parcel$export(module.exports, "UiHelperUtil", function () { return (parcelRequire("dI7zX")).UiHelperUtil; });
$parcel$export(module.exports, "TransactionUtil", function () { return (parcelRequire("3kwZm")).TransactionUtil; });
$parcel$export(module.exports, "customElement", function () { return (parcelRequire("hdxb6")).customElement; });

var $3my74 = parcelRequire("3my74");

var $gulvp = parcelRequire("gulvp");

var $jfGtx = parcelRequire("jfGtx");

var $dcd5U = parcelRequire("dcd5U");

var $9ZbyK = parcelRequire("9ZbyK");

var $gjpML = parcelRequire("gjpML");

var $ePIOw = parcelRequire("ePIOw");

var $97S8Q = parcelRequire("97S8Q");

var $7stzQ = parcelRequire("7stzQ");

var $1OYaf = parcelRequire("1OYaf");

var $iDAy5 = parcelRequire("iDAy5");

var $6Y9or = parcelRequire("6Y9or");

var $4VTk3 = parcelRequire("4VTk3");

var $eDRu8 = parcelRequire("eDRu8");

var $1iTHu = parcelRequire("1iTHu");

var $2tkBE = parcelRequire("2tkBE");

var $9B3Gw = parcelRequire("9B3Gw");

var $612c2 = parcelRequire("612c2");

var $5Y1eV = parcelRequire("5Y1eV");

var $lvqV3 = parcelRequire("lvqV3");

var $51qnz = parcelRequire("51qnz");

var $xt0OB = parcelRequire("xt0OB");

var $kYRlu = parcelRequire("kYRlu");

var $7yH9d = parcelRequire("7yH9d");

var $7RVCl = parcelRequire("7RVCl");

var $8jknp = parcelRequire("8jknp");

var $aoIfk = parcelRequire("aoIfk");

var $cJnc6 = parcelRequire("cJnc6");

var $cMI92 = parcelRequire("cMI92");

var $aYc6n = parcelRequire("aYc6n");

var $fPwJM = parcelRequire("fPwJM");

var $YocOI = parcelRequire("YocOI");

var $akKYQ = parcelRequire("akKYQ");

var $3t2a7 = parcelRequire("3t2a7");

var $6vhgh = parcelRequire("6vhgh");

var $kyiWo = parcelRequire("kyiWo");

var $iQo3l = parcelRequire("iQo3l");

var $5fLRC = parcelRequire("5fLRC");

var $9zFRT = parcelRequire("9zFRT");

var $cE4SE = parcelRequire("cE4SE");

var $7Clql = parcelRequire("7Clql");

var $iWNXX = parcelRequire("iWNXX");

var $doSia = parcelRequire("doSia");

var $j84rm = parcelRequire("j84rm");

var $85eM7 = parcelRequire("85eM7");

var $2n1QF = parcelRequire("2n1QF");

var $7PfNN = parcelRequire("7PfNN");

var $j0Ugk = parcelRequire("j0Ugk");

var $bMh6r = parcelRequire("bMh6r");

var $3FSJc = parcelRequire("3FSJc");

var $U3J5G = parcelRequire("U3J5G");

var $7yWl4 = parcelRequire("7yWl4");

var $iRTTL = parcelRequire("iRTTL");

var $2wYvx = parcelRequire("2wYvx");

var $lf3eR = parcelRequire("lf3eR");

var $jDyRd = parcelRequire("jDyRd");

var $l8uRs = parcelRequire("l8uRs");

var $7C6VO = parcelRequire("7C6VO");

var $cwlkt = parcelRequire("cwlkt");

var $auSD5 = parcelRequire("auSD5");

var $4fdE7 = parcelRequire("4fdE7");

var $2Gkav = parcelRequire("2Gkav");

var $aKoox = parcelRequire("aKoox");

var $1vo0p = parcelRequire("1vo0p");

var $80cGG = parcelRequire("80cGG");

var $6rgjY = parcelRequire("6rgjY");

var $7pa2i = parcelRequire("7pa2i");

var $6I54U = parcelRequire("6I54U");

var $a1um1 = parcelRequire("a1um1");

var $3hu8X = parcelRequire("3hu8X");

var $6DVx9 = parcelRequire("6DVx9");

var $10Tky = parcelRequire("10Tky");

var $goez5 = parcelRequire("goez5");

var $8tnK2 = parcelRequire("8tnK2");

var $aWndJ = parcelRequire("aWndJ");

var $4EPbW = parcelRequire("4EPbW");

var $giGFz = parcelRequire("giGFz");

var $kYNxm = parcelRequire("kYNxm");

var $dI7zX = parcelRequire("dI7zX");

var $3kwZm = parcelRequire("3kwZm");

var $hdxb6 = parcelRequire("hdxb6");
$parcel$exportWildcard(module.exports, $3my74);
$parcel$exportWildcard(module.exports, $gulvp);
$parcel$exportWildcard(module.exports, $jfGtx);
$parcel$exportWildcard(module.exports, $dcd5U);
$parcel$exportWildcard(module.exports, $9ZbyK);
$parcel$exportWildcard(module.exports, $gjpML);
$parcel$exportWildcard(module.exports, $ePIOw);
$parcel$exportWildcard(module.exports, $97S8Q);
$parcel$exportWildcard(module.exports, $7stzQ);
$parcel$exportWildcard(module.exports, $1OYaf);
$parcel$exportWildcard(module.exports, $iDAy5);
$parcel$exportWildcard(module.exports, $6Y9or);
$parcel$exportWildcard(module.exports, $4VTk3);
$parcel$exportWildcard(module.exports, $eDRu8);
$parcel$exportWildcard(module.exports, $1iTHu);
$parcel$exportWildcard(module.exports, $2tkBE);
$parcel$exportWildcard(module.exports, $9B3Gw);
$parcel$exportWildcard(module.exports, $612c2);
$parcel$exportWildcard(module.exports, $5Y1eV);
$parcel$exportWildcard(module.exports, $lvqV3);
$parcel$exportWildcard(module.exports, $51qnz);
$parcel$exportWildcard(module.exports, $xt0OB);
$parcel$exportWildcard(module.exports, $kYRlu);
$parcel$exportWildcard(module.exports, $7yH9d);
$parcel$exportWildcard(module.exports, $7RVCl);
$parcel$exportWildcard(module.exports, $8jknp);
$parcel$exportWildcard(module.exports, $aoIfk);
$parcel$exportWildcard(module.exports, $cJnc6);
$parcel$exportWildcard(module.exports, $cMI92);
$parcel$exportWildcard(module.exports, $aYc6n);
$parcel$exportWildcard(module.exports, $fPwJM);
$parcel$exportWildcard(module.exports, $YocOI);
$parcel$exportWildcard(module.exports, $akKYQ);
$parcel$exportWildcard(module.exports, $3t2a7);
$parcel$exportWildcard(module.exports, $6vhgh);
$parcel$exportWildcard(module.exports, $kyiWo);
$parcel$exportWildcard(module.exports, $iQo3l);
$parcel$exportWildcard(module.exports, $5fLRC);
$parcel$exportWildcard(module.exports, $9zFRT);
$parcel$exportWildcard(module.exports, $cE4SE);
$parcel$exportWildcard(module.exports, $7Clql);
$parcel$exportWildcard(module.exports, $iWNXX);
$parcel$exportWildcard(module.exports, $doSia);
$parcel$exportWildcard(module.exports, $j84rm);
$parcel$exportWildcard(module.exports, $85eM7);
$parcel$exportWildcard(module.exports, $2n1QF);
$parcel$exportWildcard(module.exports, $7PfNN);
$parcel$exportWildcard(module.exports, $j0Ugk);
$parcel$exportWildcard(module.exports, $bMh6r);
$parcel$exportWildcard(module.exports, $3FSJc);
$parcel$exportWildcard(module.exports, $U3J5G);
$parcel$exportWildcard(module.exports, $7yWl4);
$parcel$exportWildcard(module.exports, $iRTTL);
$parcel$exportWildcard(module.exports, $2wYvx);
$parcel$exportWildcard(module.exports, $lf3eR);
$parcel$exportWildcard(module.exports, $jDyRd);
$parcel$exportWildcard(module.exports, $l8uRs);
$parcel$exportWildcard(module.exports, $7C6VO);
$parcel$exportWildcard(module.exports, $cwlkt);
$parcel$exportWildcard(module.exports, $auSD5);
$parcel$exportWildcard(module.exports, $4fdE7);
$parcel$exportWildcard(module.exports, $2Gkav);
$parcel$exportWildcard(module.exports, $aKoox);
$parcel$exportWildcard(module.exports, $1vo0p);
$parcel$exportWildcard(module.exports, $80cGG);
$parcel$exportWildcard(module.exports, $6rgjY);
$parcel$exportWildcard(module.exports, $7pa2i);
$parcel$exportWildcard(module.exports, $6I54U);
$parcel$exportWildcard(module.exports, $a1um1);
$parcel$exportWildcard(module.exports, $3hu8X);
$parcel$exportWildcard(module.exports, $6DVx9);
$parcel$exportWildcard(module.exports, $10Tky);
$parcel$exportWildcard(module.exports, $goez5);
$parcel$exportWildcard(module.exports, $8tnK2);
$parcel$exportWildcard(module.exports, $aWndJ);
$parcel$exportWildcard(module.exports, $4EPbW);

});
parcelRegister("3my74", function(module, exports) {

$parcel$export(module.exports, "swapInputMaskBottomSvg", function () { return $272de35451818123$export$a65dfac536924807; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $272de35451818123$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg class="input_mask" width="328" height="100" viewBox="0 0 328 100" fill="none">\n  <mask id="path-1-inside-1_18299_4189">\n    <path\n      class="input_mask__border"\n      fill-rule="evenodd"\n      clip-rule="evenodd"\n      d="M138.008 0H40C21.1438 0 11.7157 0 5.85786 5.85786C0 11.7157 0 21.1438 0 40V60C0 78.8562 0 88.2843 5.85786 94.1421C11.7157 100 21.1438 100 40 100H288C306.856 100 316.284 100 322.142 94.1421C328 88.2843 328 78.8562 328 60V40C328 21.1438 328 11.7157 322.142 5.85786C316.284 0 306.856 0 288 0H189.992C189.958 4.89122 189.786 7.76279 188.914 10.1564C187.095 15.1562 183.156 19.0947 178.156 20.9145C175.174 22 171.449 22 164 22C156.551 22 152.826 22 149.844 20.9145C144.844 19.0947 140.905 15.1562 139.086 10.1564C138.214 7.76279 138.042 4.89122 138.008 0Z"\n    />\n  </mask>\n  <path\n    class="input_mask__background"\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M138.008 0H40C21.1438 0 11.7157 0 5.85786 5.85786C0 11.7157 0 21.1438 0 40V60C0 78.8562 0 88.2843 5.85786 94.1421C11.7157 100 21.1438 100 40 100H288C306.856 100 316.284 100 322.142 94.1421C328 88.2843 328 78.8562 328 60V40C328 21.1438 328 11.7157 322.142 5.85786C316.284 0 306.856 0 288 0H189.992C189.958 4.89122 189.786 7.76279 188.914 10.1564C187.095 15.1562 183.156 19.0947 178.156 20.9145C175.174 22 171.449 22 164 22C156.551 22 152.826 22 149.844 20.9145C144.844 19.0947 140.905 15.1562 139.086 10.1564C138.214 7.76279 138.042 4.89122 138.008 0Z"\n  />\n  <path\n    class="input_mask__border"\n    d="M138.008 0L139.008 -0.00694413L139.001 -1H138.008V0ZM322.142 94.1421L322.849 94.8492H322.849L322.142 94.1421ZM322.142 5.85786L322.849 5.15076L322.849 5.15076L322.142 5.85786ZM189.992 0V-1H188.999L188.992 -0.00694413L189.992 0ZM188.914 10.1564L189.854 10.4984V10.4984L188.914 10.1564ZM178.156 20.9145L177.814 19.9748V19.9748L178.156 20.9145ZM149.844 20.9145L150.186 19.9748V19.9748L149.844 20.9145ZM139.086 10.1564L138.146 10.4984V10.4984L139.086 10.1564ZM40 1H138.008V-1H40V1ZM6.56497 6.56497C9.27713 3.85281 12.8524 2.44064 18.1878 1.72332C23.552 1.00212 30.5436 1 40 1V-1C30.6002 -1 23.4497 -1.00212 17.9213 -0.25885C12.3641 0.488292 8.29646 2.00506 5.15076 5.15076L6.56497 6.56497ZM1 40C1 30.5436 1.00212 23.552 1.72332 18.1878C2.44064 12.8524 3.85281 9.27713 6.56497 6.56497L5.15076 5.15076C2.00506 8.29646 0.488292 12.3641 -0.25885 17.9213C-1.00212 23.4497 -1 30.6002 -1 40H1ZM1 60V40H-1V60H1ZM6.56497 93.435C3.85281 90.7229 2.44064 87.1476 1.72332 81.8122C1.00212 76.448 1 69.4564 1 60H-1C-1 69.3998 -1.00212 76.5503 -0.25885 82.0787C0.488292 87.6358 2.00506 91.7035 5.15076 94.8492L6.56497 93.435ZM40 99C30.5436 99 23.552 98.9979 18.1878 98.2767C12.8524 97.5594 9.27713 96.1472 6.56497 93.435L5.15076 94.8492C8.29646 97.9949 12.3641 99.5117 17.9213 100.259C23.4497 101.002 30.6002 101 40 101V99ZM288 99H40V101H288V99ZM321.435 93.435C318.723 96.1472 315.148 97.5594 309.812 98.2767C304.448 98.9979 297.456 99 288 99V101C297.4 101 304.55 101.002 310.079 100.259C315.636 99.5117 319.704 97.9949 322.849 94.8492L321.435 93.435ZM327 60C327 69.4564 326.998 76.448 326.277 81.8122C325.559 87.1476 324.147 90.7229 321.435 93.435L322.849 94.8492C325.995 91.7035 327.512 87.6358 328.259 82.0787C329.002 76.5503 329 69.3998 329 60H327ZM327 40V60H329V40H327ZM321.435 6.56497C324.147 9.27713 325.559 12.8524 326.277 18.1878C326.998 23.552 327 30.5436 327 40H329C329 30.6002 329.002 23.4497 328.259 17.9213C327.512 12.3642 325.995 8.29646 322.849 5.15076L321.435 6.56497ZM288 1C297.456 1 304.448 1.00212 309.812 1.72332C315.148 2.44064 318.723 3.85281 321.435 6.56497L322.849 5.15076C319.704 2.00506 315.636 0.488292 310.079 -0.25885C304.55 -1.00212 297.4 -1 288 -1V1ZM189.992 1H288V-1H189.992V1ZM188.992 -0.00694413C188.958 4.90792 188.778 7.60788 187.975 9.81434L189.854 10.4984C190.793 7.9177 190.958 4.87452 190.992 0.00694413L188.992 -0.00694413ZM187.975 9.81434C186.256 14.5364 182.536 18.2561 177.814 19.9748L178.498 21.8542C183.776 19.9333 187.933 15.7759 189.854 10.4984L187.975 9.81434ZM177.814 19.9748C175.039 20.9848 171.536 21 164 21V23C171.362 23 175.308 23.0152 178.498 21.8542L177.814 19.9748ZM164 21C156.464 21 152.961 20.9848 150.186 19.9748L149.502 21.8542C152.692 23.0152 156.638 23 164 23V21ZM150.186 19.9748C145.464 18.2561 141.744 14.5364 140.025 9.81434L138.146 10.4984C140.067 15.7759 144.224 19.9333 149.502 21.8542L150.186 19.9748ZM140.025 9.81434C139.222 7.60788 139.042 4.90792 139.008 -0.00694413L137.008 0.00694413C137.042 4.87452 137.207 7.9177 138.146 10.4984L140.025 9.81434Z"\n    mask="url(#path-1-inside-1_18299_4189)"\n  />\n</svg>'
    ]);
    $272de35451818123$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $272de35451818123$export$a65dfac536924807 = (0, $1lUIm.svg)($272de35451818123$var$_templateObject());

});
parcelRegister("j06k0", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $dd52ebc95e8f0a15$export$71511d61b312f219; });
function $dd52ebc95e8f0a15$export$71511d61b312f219(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

});

parcelRegister("4Ztkm", function(module, exports) {
$parcel$export(module.exports, "html", function () { return (parcelRequire("1lUIm")).html; });
$parcel$export(module.exports, "LitElement", function () { return (parcelRequire("eAsDt")).LitElement; });
$parcel$export(module.exports, "svg", function () { return (parcelRequire("1lUIm")).svg; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("bBWVO")).css; });
$parcel$export(module.exports, "unsafeCSS", function () { return (parcelRequire("bBWVO")).unsafeCSS; });
parcelRequire("ce9xl");
parcelRequire("1lUIm");
parcelRequire("eAsDt");
parcelRequire("6vTJR");

});
parcelRegister("ce9xl", function(module, exports) {

$parcel$export(module.exports, "defaultConverter", function () { return $8e6e30ab8665e239$export$7312b35fbf521afb; });
$parcel$export(module.exports, "notEqual", function () { return $8e6e30ab8665e239$export$53a6892c50694894; });
$parcel$export(module.exports, "ReactiveElement", function () { return $8e6e30ab8665e239$export$c7c07a37856565d; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("bBWVO")).css; });
$parcel$export(module.exports, "unsafeCSS", function () { return (parcelRequire("bBWVO")).unsafeCSS; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $3U0IP = parcelRequire("3U0IP");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");

var $bBWVO = parcelRequire("bBWVO");
var $8e6e30ab8665e239$var$_Symbol, $8e6e30ab8665e239$var$_a, $8e6e30ab8665e239$var$_a1;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $8e6e30ab8665e239$var$i = Object.is, $8e6e30ab8665e239$var$e = Object.defineProperty, $8e6e30ab8665e239$var$r = Object.getOwnPropertyDescriptor, $8e6e30ab8665e239$var$h = Object.getOwnPropertyNames, $8e6e30ab8665e239$var$o = Object.getOwnPropertySymbols, $8e6e30ab8665e239$var$n = Object.getPrototypeOf, $8e6e30ab8665e239$var$a = globalThis, $8e6e30ab8665e239$var$c = $8e6e30ab8665e239$var$a.trustedTypes, $8e6e30ab8665e239$var$l = $8e6e30ab8665e239$var$c ? $8e6e30ab8665e239$var$c.emptyScript : "", $8e6e30ab8665e239$var$p = $8e6e30ab8665e239$var$a.reactiveElementPolyfillSupport, $8e6e30ab8665e239$var$d = function(t, s) {
    return t;
}, $8e6e30ab8665e239$export$7312b35fbf521afb = {
    toAttribute: function(t, s) {
        switch(s){
            case Boolean:
                t = t ? $8e6e30ab8665e239$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute: function(t, s) {
        var i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $8e6e30ab8665e239$export$53a6892c50694894 = function(t, s) {
    return !$8e6e30ab8665e239$var$i(t, s);
}, $8e6e30ab8665e239$var$y = {
    attribute: !0,
    type: String,
    converter: $8e6e30ab8665e239$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $8e6e30ab8665e239$export$53a6892c50694894
};
var $8e6e30ab8665e239$var$_metadata, $8e6e30ab8665e239$var$_litPropertyMetadata;
($8e6e30ab8665e239$var$_metadata = ($8e6e30ab8665e239$var$_Symbol = Symbol).metadata) !== null && $8e6e30ab8665e239$var$_metadata !== void 0 ? $8e6e30ab8665e239$var$_metadata : $8e6e30ab8665e239$var$_Symbol.metadata = Symbol("metadata"), ($8e6e30ab8665e239$var$_litPropertyMetadata = ($8e6e30ab8665e239$var$_a = $8e6e30ab8665e239$var$a).litPropertyMetadata) !== null && $8e6e30ab8665e239$var$_litPropertyMetadata !== void 0 ? $8e6e30ab8665e239$var$_litPropertyMetadata : $8e6e30ab8665e239$var$_a.litPropertyMetadata = new WeakMap;
var $8e6e30ab8665e239$export$c7c07a37856565d = /*#__PURE__*/ function(HTMLElement1) {
    "use strict";
    (0, $dcsZi._)(b, HTMLElement1);
    var _super = (0, $ohfOJ._)(b);
    function b() {
        (0, $4GJKx._)(this, b);
        var _this;
        _this = _super.call(this), _this._$Ep = void 0, _this.isUpdatePending = !1, _this.hasUpdated = !1, _this._$Em = null, _this._$Ev();
        return (0, $3U0IP._)(_this);
    }
    (0, $1wc17._)(b, [
        {
            key: "_$Ev",
            value: function _$Ev() {
                var _this = this;
                var _this_constructor_l;
                this._$ES = new Promise(function(t) {
                    return _this.enableUpdating = t;
                }), this._$AL = new Map, this._$E_(), this.requestUpdate(), (_this_constructor_l = this.constructor.l) === null || _this_constructor_l === void 0 ? void 0 : _this_constructor_l.forEach(function(t) {
                    return t(_this);
                });
            }
        },
        {
            key: "addController",
            value: function addController(t) {
                var _t_hostConnected;
                var _this__$EO;
                ((_this__$EO = this._$EO) !== null && _this__$EO !== void 0 ? _this__$EO : this._$EO = new Set).add(t), void 0 !== this.renderRoot && this.isConnected && ((_t_hostConnected = t.hostConnected) === null || _t_hostConnected === void 0 ? void 0 : _t_hostConnected.call(t));
            }
        },
        {
            key: "removeController",
            value: function removeController(t) {
                var _this__$EO;
                (_this__$EO = this._$EO) === null || _this__$EO === void 0 ? void 0 : _this__$EO.delete(t);
            }
        },
        {
            key: "_$E_",
            value: function _$E_() {
                var t = new Map, s = this.constructor.elementProperties;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = s.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                t.size > 0 && (this._$Ep = t);
            }
        },
        {
            key: "createRenderRoot",
            value: function createRenderRoot() {
                var _this_shadowRoot;
                var t = (_this_shadowRoot = this.shadowRoot) !== null && _this_shadowRoot !== void 0 ? _this_shadowRoot : this.attachShadow(this.constructor.shadowRootOptions);
                return (0, $bBWVO.adoptStyles)(t, this.constructor.elementStyles), t;
            }
        },
        {
            key: "connectedCallback",
            value: function connectedCallback() {
                var _this__$EO;
                var _this_renderRoot;
                (_this_renderRoot = this.renderRoot) !== null && _this_renderRoot !== void 0 ? _this_renderRoot : this.renderRoot = this.createRenderRoot(), this.enableUpdating(!0), (_this__$EO = this._$EO) === null || _this__$EO === void 0 ? void 0 : _this__$EO.forEach(function(t) {
                    var _t_hostConnected;
                    return (_t_hostConnected = t.hostConnected) === null || _t_hostConnected === void 0 ? void 0 : _t_hostConnected.call(t);
                });
            }
        },
        {
            key: "enableUpdating",
            value: function enableUpdating(t) {}
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                var _this__$EO;
                (_this__$EO = this._$EO) === null || _this__$EO === void 0 ? void 0 : _this__$EO.forEach(function(t) {
                    var _t_hostDisconnected;
                    return (_t_hostDisconnected = t.hostDisconnected) === null || _t_hostDisconnected === void 0 ? void 0 : _t_hostDisconnected.call(t);
                });
            }
        },
        {
            key: "attributeChangedCallback",
            value: function attributeChangedCallback(t, s, i) {
                this._$AK(t, i);
            }
        },
        {
            key: "_$EC",
            value: function _$EC(t, s) {
                var i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
                if (void 0 !== e && !0 === i.reflect) {
                    var _i_converter;
                    var r = (void 0 !== ((_i_converter = i.converter) === null || _i_converter === void 0 ? void 0 : _i_converter.toAttribute) ? i.converter : $8e6e30ab8665e239$export$7312b35fbf521afb).toAttribute(s, i.type);
                    this._$Em = t, null == r ? this.removeAttribute(e) : this.setAttribute(e, r), this._$Em = null;
                }
            }
        },
        {
            key: "_$AK",
            value: function _$AK(t, s) {
                var i = this.constructor, e = i._$Eh.get(t);
                if (void 0 !== e && this._$Em !== e) {
                    var _t_converter;
                    var _$t = i.getPropertyOptions(e), r = "function" == typeof _$t.converter ? {
                        fromAttribute: _$t.converter
                    } : void 0 !== ((_t_converter = _$t.converter) === null || _t_converter === void 0 ? void 0 : _t_converter.fromAttribute) ? _$t.converter : $8e6e30ab8665e239$export$7312b35fbf521afb;
                    this._$Em = e, this[e] = r.fromAttribute(s, _$t.type), this._$Em = null;
                }
            }
        },
        {
            key: "requestUpdate",
            value: function requestUpdate(t, s, i) {
                if (void 0 !== t) {
                    var _i_hasChanged;
                    if (i !== null && i !== void 0 ? i : i = this.constructor.getPropertyOptions(t), !((_i_hasChanged = i.hasChanged) !== null && _i_hasChanged !== void 0 ? _i_hasChanged : $8e6e30ab8665e239$export$53a6892c50694894)(this[t], s)) return;
                    this.P(t, s, i);
                }
                !1 === this.isUpdatePending && (this._$ES = this._$ET());
            }
        },
        {
            key: "P",
            value: function P(t, s, i) {
                var _this__$Ej;
                this._$AL.has(t) || this._$AL.set(t, s), !0 === i.reflect && this._$Em !== t && ((_this__$Ej = this._$Ej) !== null && _this__$Ej !== void 0 ? _this__$Ej : this._$Ej = new Set).add(t);
            }
        },
        {
            key: "_$ET",
            value: function _$ET() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var t, _$t, _tmp;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.isUpdatePending = !0;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this._$ES
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                t = _state.sent();
                                Promise.reject(t);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                _$t = _this.scheduleUpdate();
                                _tmp = null != _$t;
                                if (!_tmp) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    _$t
                                ];
                            case 5:
                                _tmp = _state.sent();
                                _state.label = 6;
                            case 6:
                                return [
                                    2,
                                    (_tmp, !_this.isUpdatePending)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "scheduleUpdate",
            value: function scheduleUpdate() {
                return this.performUpdate();
            }
        },
        {
            key: "performUpdate",
            value: function performUpdate() {
                if (!this.isUpdatePending) return;
                if (!this.hasUpdated) {
                    var _this_renderRoot;
                    if ((_this_renderRoot = this.renderRoot) !== null && _this_renderRoot !== void 0 ? _this_renderRoot : this.renderRoot = this.createRenderRoot(), this._$Ep) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this._$Ep[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _step_value = (0, $cv9Rk._)(_step.value, 2), t = _step_value[0], _$s = _step_value[1];
                                this[t] = _$s;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        this._$Ep = void 0;
                    }
                    var t1 = this.constructor.elementProperties;
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    if (t1.size > 0) try {
                        for(var _iterator1 = t1[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var _step_value1 = (0, $cv9Rk._)(_step1.value, 2), _$s1 = _step_value1[0], i = _step_value1[1];
                            !0 !== i.wrapped || this._$AL.has(_$s1) || void 0 === this[_$s1] || this.P(_$s1, this[_$s1], i);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
                var t2 = !1;
                var _$s2 = this._$AL;
                try {
                    var _this__$EO;
                    t2 = this.shouldUpdate(_$s2), t2 ? (this.willUpdate(_$s2), (_this__$EO = this._$EO) === null || _this__$EO === void 0 ? void 0 : _this__$EO.forEach(function(t) {
                        var _t_hostUpdate;
                        return (_t_hostUpdate = t.hostUpdate) === null || _t_hostUpdate === void 0 ? void 0 : _t_hostUpdate.call(t);
                    }), this.update(_$s2)) : this._$EU();
                } catch (s) {
                    throw t2 = !1, this._$EU(), s;
                }
                t2 && this._$AE(_$s2);
            }
        },
        {
            key: "willUpdate",
            value: function willUpdate(t) {}
        },
        {
            key: "_$AE",
            value: function _$AE(t) {
                var _this__$EO;
                (_this__$EO = this._$EO) === null || _this__$EO === void 0 ? void 0 : _this__$EO.forEach(function(t) {
                    var _t_hostUpdated;
                    return (_t_hostUpdated = t.hostUpdated) === null || _t_hostUpdated === void 0 ? void 0 : _t_hostUpdated.call(t);
                }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
            }
        },
        {
            key: "_$EU",
            value: function _$EU() {
                this._$AL = new Map, this.isUpdatePending = !1;
            }
        },
        {
            key: "updateComplete",
            get: function get() {
                return this.getUpdateComplete();
            }
        },
        {
            key: "getUpdateComplete",
            value: function getUpdateComplete() {
                return this._$ES;
            }
        },
        {
            key: "shouldUpdate",
            value: function shouldUpdate(t) {
                return !0;
            }
        },
        {
            key: "update",
            value: function update(t) {
                var _this = this;
                this._$Ej && (this._$Ej = this._$Ej.forEach(function(t) {
                    return _this._$EC(t, _this[t]);
                })), this._$EU();
            }
        },
        {
            key: "updated",
            value: function updated(t) {}
        },
        {
            key: "firstUpdated",
            value: function firstUpdated(t) {}
        }
    ], [
        {
            key: "addInitializer",
            value: function addInitializer(t) {
                var _this_l;
                this._$Ei(), ((_this_l = this.l) !== null && _this_l !== void 0 ? _this_l : this.l = []).push(t);
            }
        },
        {
            key: "observedAttributes",
            get: function get() {
                return this.finalize(), this._$Eh && (0, $c6Xmf._)(this._$Eh.keys());
            }
        },
        {
            key: "createProperty",
            value: function createProperty(t) {
                var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $8e6e30ab8665e239$var$y;
                if (s.state && (s.attribute = !1), this._$Ei(), this.elementProperties.set(t, s), !s.noAccessor) {
                    var i = Symbol(), r = this.getPropertyDescriptor(t, i, s);
                    void 0 !== r && $8e6e30ab8665e239$var$e(this.prototype, t, r);
                }
            }
        },
        {
            key: "getPropertyDescriptor",
            value: function getPropertyDescriptor(t, s, i) {
                var _r;
                var _ref = (_r = $8e6e30ab8665e239$var$r(this.prototype, t)) !== null && _r !== void 0 ? _r : {
                    get: function() {
                        return this[s];
                    },
                    set: function(t) {
                        this[s] = t;
                    }
                }, e = _ref.get, h = _ref.set;
                return {
                    get: function() {
                        return e === null || e === void 0 ? void 0 : e.call(this);
                    },
                    set: function(s) {
                        var r = e === null || e === void 0 ? void 0 : e.call(this);
                        h.call(this, s), this.requestUpdate(t, r, i);
                    },
                    configurable: !0,
                    enumerable: !0
                };
            }
        },
        {
            key: "getPropertyOptions",
            value: function getPropertyOptions(t) {
                var _this_elementProperties_get;
                return (_this_elementProperties_get = this.elementProperties.get(t)) !== null && _this_elementProperties_get !== void 0 ? _this_elementProperties_get : $8e6e30ab8665e239$var$y;
            }
        },
        {
            key: "_$Ei",
            value: function _$Ei() {
                if (this.hasOwnProperty($8e6e30ab8665e239$var$d("elementProperties"))) return;
                var t = $8e6e30ab8665e239$var$n(this);
                t.finalize(), void 0 !== t.l && (this.l = (0, $c6Xmf._)(t.l)), this.elementProperties = new Map(t.elementProperties);
            }
        },
        {
            key: "finalize",
            value: function finalize() {
                if (this.hasOwnProperty($8e6e30ab8665e239$var$d("finalized"))) return;
                if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($8e6e30ab8665e239$var$d("properties"))) {
                    var t = this.properties, s = (0, $c6Xmf._)($8e6e30ab8665e239$var$h(t)).concat((0, $c6Xmf._)($8e6e30ab8665e239$var$o(t)));
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = s[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var i = _step.value;
                            this.createProperty(i, t[i]);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                var t1 = this[Symbol.metadata];
                if (null !== t1) {
                    var s1 = litPropertyMetadata.get(t1);
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    if (void 0 !== s1) try {
                        for(var _iterator1 = s1[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var _step_value = (0, $cv9Rk._)(_step1.value, 2), t2 = _step_value[0], i1 = _step_value[1];
                            this.elementProperties.set(t2, i1);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
                this._$Eh = new Map;
                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                try {
                    for(var _iterator2 = this.elementProperties[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                        var _step_value1 = (0, $cv9Rk._)(_step2.value, 2), t3 = _step_value1[0], s2 = _step_value1[1];
                        var i2 = this._$Eu(t3, s2);
                        void 0 !== i2 && this._$Eh.set(i2, t3);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                            _iterator2.return();
                        }
                    } finally{
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
                this.elementStyles = this.finalizeStyles(this.styles);
            }
        },
        {
            key: "finalizeStyles",
            value: function finalizeStyles(s) {
                var i = [];
                if (Array.isArray(s)) {
                    var e = new Set(s.flat(1 / 0).reverse());
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$s = _step.value;
                            i.unshift((0, $bBWVO.getCompatibleStyle)(_$s));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                } else void 0 !== s && i.push((0, $bBWVO.getCompatibleStyle)(s));
                return i;
            }
        },
        {
            key: "_$Eu",
            value: function _$Eu(t, s) {
                var i = s.attribute;
                return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
            }
        }
    ]);
    return b;
}((0, $FuVm8._)(HTMLElement));
var $8e6e30ab8665e239$var$_reactiveElementVersions;
$8e6e30ab8665e239$export$c7c07a37856565d.elementStyles = [], $8e6e30ab8665e239$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $8e6e30ab8665e239$export$c7c07a37856565d[$8e6e30ab8665e239$var$d("elementProperties")] = new Map, $8e6e30ab8665e239$export$c7c07a37856565d[$8e6e30ab8665e239$var$d("finalized")] = new Map, $8e6e30ab8665e239$var$p === null || $8e6e30ab8665e239$var$p === void 0 ? void 0 : $8e6e30ab8665e239$var$p({
    ReactiveElement: $8e6e30ab8665e239$export$c7c07a37856565d
}), (($8e6e30ab8665e239$var$_reactiveElementVersions = ($8e6e30ab8665e239$var$_a1 = $8e6e30ab8665e239$var$a).reactiveElementVersions) !== null && $8e6e30ab8665e239$var$_reactiveElementVersions !== void 0 ? $8e6e30ab8665e239$var$_reactiveElementVersions : $8e6e30ab8665e239$var$_a1.reactiveElementVersions = []).push("2.0.4");

});
parcelRegister("bBWVO", function(module, exports) {

$parcel$export(module.exports, "unsafeCSS", function () { return $8740dcfea8740297$export$8d80f9cac07cdb3; });
$parcel$export(module.exports, "css", function () { return $8740dcfea8740297$export$dbf350e5966cf602; });
$parcel$export(module.exports, "adoptStyles", function () { return $8740dcfea8740297$export$2ca4a66ec4cecb90; });
$parcel$export(module.exports, "getCompatibleStyle", function () { return $8740dcfea8740297$export$ee69dfd951e24778; });
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ 
var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");
var $8740dcfea8740297$var$t = globalThis, $8740dcfea8740297$export$b4d10f6001c083c2 = $8740dcfea8740297$var$t.ShadowRoot && (void 0 === $8740dcfea8740297$var$t.ShadyCSS || $8740dcfea8740297$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $8740dcfea8740297$var$s = Symbol(), $8740dcfea8740297$var$o = new WeakMap;
var $8740dcfea8740297$export$505d1e8739bad805 = /*#__PURE__*/ function() {
    "use strict";
    function n(t, e, o) {
        (0, $4GJKx._)(this, n);
        if (this._$cssResult$ = !0, o !== $8740dcfea8740297$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    (0, $1wc17._)(n, [
        {
            key: "styleSheet",
            get: function get() {
                var t = this.o;
                var s = this.t;
                if ($8740dcfea8740297$export$b4d10f6001c083c2 && void 0 === t) {
                    var e1 = void 0 !== s && 1 === s.length;
                    e1 && (t = $8740dcfea8740297$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e1 && $8740dcfea8740297$var$o.set(s, t));
                }
                return t;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.cssText;
            }
        }
    ]);
    return n;
}();
var $8740dcfea8740297$export$8d80f9cac07cdb3 = function(t) {
    return new $8740dcfea8740297$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $8740dcfea8740297$var$s);
}, $8740dcfea8740297$export$dbf350e5966cf602 = function(t) {
    for(var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        e[_key - 1] = arguments[_key];
    }
    var o = 1 === t.length ? t[0] : e.reduce(function(e, s, o) {
        return e + function(t) {
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        }(s) + t[o + 1];
    }, t[0]);
    return new $8740dcfea8740297$export$505d1e8739bad805(o, t, $8740dcfea8740297$var$s);
}, $8740dcfea8740297$export$2ca4a66ec4cecb90 = function(s, o) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($8740dcfea8740297$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map(function(t) {
        return t instanceof CSSStyleSheet ? t : t.styleSheet;
    });
    else try {
        for(var _iterator = o[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var e1 = _step.value;
            var _$o = document.createElement("style"), n = $8740dcfea8740297$var$t.litNonce;
            void 0 !== n && _$o.setAttribute("nonce", n), _$o.textContent = e1.cssText, s.appendChild(_$o);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}, $8740dcfea8740297$export$ee69dfd951e24778 = $8740dcfea8740297$export$b4d10f6001c083c2 ? function(t) {
    return t;
} : function(t) {
    return t instanceof CSSStyleSheet ? function(t) {
        var e = "";
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = t.cssRules[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var s = _step.value;
                e += s.cssText;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return $8740dcfea8740297$export$8d80f9cac07cdb3(e);
    }(t) : t;
};

});


parcelRegister("1lUIm", function(module, exports) {

$parcel$export(module.exports, "html", function () { return $0fc3bef14f424428$export$c0bb0b647f701bb5; });
$parcel$export(module.exports, "svg", function () { return $0fc3bef14f424428$export$7ed1367e7fa1ad68; });
$parcel$export(module.exports, "noChange", function () { return $0fc3bef14f424428$export$9c068ae9cc5db4e8; });
$parcel$export(module.exports, "nothing", function () { return $0fc3bef14f424428$export$45b790e32b2810ee; });
$parcel$export(module.exports, "_$LH", function () { return $0fc3bef14f424428$export$8613d1ca9052b22e; });
$parcel$export(module.exports, "render", function () { return $0fc3bef14f424428$export$b3890eb0ae9dca99; });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ 
var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $3U0IP = parcelRequire("3U0IP");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $ohfOJ = parcelRequire("ohfOJ");
var $0fc3bef14f424428$var$_n;
var $0fc3bef14f424428$var$n = globalThis, $0fc3bef14f424428$var$c = $0fc3bef14f424428$var$n.trustedTypes, $0fc3bef14f424428$var$h = $0fc3bef14f424428$var$c ? $0fc3bef14f424428$var$c.createPolicy("lit-html", {
    createHTML: function(t) {
        return t;
    }
}) : void 0, $0fc3bef14f424428$var$f = "$lit$", $0fc3bef14f424428$var$v = "lit$".concat(Math.random().toFixed(9).slice(2), "$"), $0fc3bef14f424428$var$m = "?" + $0fc3bef14f424428$var$v, $0fc3bef14f424428$var$_ = "<".concat($0fc3bef14f424428$var$m, ">"), $0fc3bef14f424428$var$w = document, $0fc3bef14f424428$var$lt = function() {
    return $0fc3bef14f424428$var$w.createComment("");
}, $0fc3bef14f424428$var$st = function(t) {
    return null === t || "object" != typeof t && "function" != typeof t;
}, $0fc3bef14f424428$var$g = Array.isArray, $0fc3bef14f424428$var$$ = function(t) {
    return $0fc3bef14f424428$var$g(t) || "function" == typeof (t === null || t === void 0 ? void 0 : t[Symbol.iterator]);
}, $0fc3bef14f424428$var$x = "[ 	\n\f\r]", $0fc3bef14f424428$var$T = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $0fc3bef14f424428$var$E = /-->/g, $0fc3bef14f424428$var$k = />/g, $0fc3bef14f424428$var$O = RegExp(">|".concat($0fc3bef14f424428$var$x, "(?:([^\\s\"'>=/]+)(").concat($0fc3bef14f424428$var$x, "*=").concat($0fc3bef14f424428$var$x, "*(?:[^ 	\n\f\r\"'`<>=]|(\"|')|))|$)"), "g"), $0fc3bef14f424428$var$S = /'/g, $0fc3bef14f424428$var$j = /"/g, $0fc3bef14f424428$var$M = /^(?:script|style|textarea|title)$/i, $0fc3bef14f424428$var$P = function(t) {
    return function(i) {
        for(var _len = arguments.length, s = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            s[_key - 1] = arguments[_key];
        }
        return {
            _$litType$: t,
            strings: i,
            values: s
        };
    };
}, $0fc3bef14f424428$export$c0bb0b647f701bb5 = $0fc3bef14f424428$var$P(1), $0fc3bef14f424428$export$7ed1367e7fa1ad68 = $0fc3bef14f424428$var$P(2), $0fc3bef14f424428$export$47d5b44d225be5b4 = $0fc3bef14f424428$var$P(3), $0fc3bef14f424428$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $0fc3bef14f424428$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $0fc3bef14f424428$var$V = new WeakMap, $0fc3bef14f424428$var$I = $0fc3bef14f424428$var$w.createTreeWalker($0fc3bef14f424428$var$w, 129);
function $0fc3bef14f424428$var$N(t, i) {
    if (!$0fc3bef14f424428$var$g(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $0fc3bef14f424428$var$h ? $0fc3bef14f424428$var$h.createHTML(i) : i;
}
var $0fc3bef14f424428$var$U = function(t, i) {
    var s = t.length - 1, e = [];
    var h, o = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", n = $0fc3bef14f424428$var$T;
    for(var _$i = 0; _$i < s; _$i++){
        var s1 = t[_$i];
        var r = void 0, l = void 0, c = -1, a = 0;
        for(; a < s1.length && (n.lastIndex = a, l = n.exec(s1), null !== l);)a = n.lastIndex, n === $0fc3bef14f424428$var$T ? "!--" === l[1] ? n = $0fc3bef14f424428$var$E : void 0 !== l[1] ? n = $0fc3bef14f424428$var$k : void 0 !== l[2] ? ($0fc3bef14f424428$var$M.test(l[2]) && (h = RegExp("</" + l[2], "g")), n = $0fc3bef14f424428$var$O) : void 0 !== l[3] && (n = $0fc3bef14f424428$var$O) : n === $0fc3bef14f424428$var$O ? ">" === l[0] ? (n = h !== null && h !== void 0 ? h : $0fc3bef14f424428$var$T, c = -1) : void 0 === l[1] ? c = -2 : (c = n.lastIndex - l[2].length, r = l[1], n = void 0 === l[3] ? $0fc3bef14f424428$var$O : '"' === l[3] ? $0fc3bef14f424428$var$j : $0fc3bef14f424428$var$S) : n === $0fc3bef14f424428$var$j || n === $0fc3bef14f424428$var$S ? n = $0fc3bef14f424428$var$O : n === $0fc3bef14f424428$var$E || n === $0fc3bef14f424428$var$k ? n = $0fc3bef14f424428$var$T : (n = $0fc3bef14f424428$var$O, h = void 0);
        var u = n === $0fc3bef14f424428$var$O && t[_$i + 1].startsWith("/>") ? " " : "";
        o += n === $0fc3bef14f424428$var$T ? s1 + $0fc3bef14f424428$var$_ : c >= 0 ? (e.push(r), s1.slice(0, c) + $0fc3bef14f424428$var$f + s1.slice(c) + $0fc3bef14f424428$var$v + u) : s1 + $0fc3bef14f424428$var$v + (-2 === c ? _$i : u);
    }
    return [
        $0fc3bef14f424428$var$N(t, o + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        e
    ];
};
var $0fc3bef14f424428$var$B = /*#__PURE__*/ function() {
    "use strict";
    function B(param, s) {
        var t = param.strings, i = param._$litType$;
        (0, $4GJKx._)(this, B);
        var e;
        this.parts = [];
        var h = 0, o = 0;
        var n = t.length - 1, r = this.parts, _U = (0, $cv9Rk._)($0fc3bef14f424428$var$U(t, i), 2), l = _U[0], a = _U[1];
        if (this.el = B.createElement(l, s), $0fc3bef14f424428$var$I.currentNode = this.el.content, 2 === i || 3 === i) {
            var _t;
            var t1 = this.el.content.firstChild;
            (_t = t1).replaceWith.apply(_t, (0, $c6Xmf._)(t1.childNodes));
        }
        for(; null !== (e = $0fc3bef14f424428$var$I.nextNode()) && r.length < n;){
            if (1 === e.nodeType) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (e.hasAttributes()) try {
                    for(var _iterator = e.getAttributeNames()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var t2 = _step.value;
                        if (t2.endsWith($0fc3bef14f424428$var$f)) {
                            var i1 = a[o++], _$s = e.getAttribute(t2).split($0fc3bef14f424428$var$v), n1 = /([.?@])?(.*)/.exec(i1);
                            r.push({
                                type: 1,
                                index: h,
                                name: n1[2],
                                strings: _$s,
                                ctor: "." === n1[1] ? $0fc3bef14f424428$var$Y : "?" === n1[1] ? $0fc3bef14f424428$var$Z : "@" === n1[1] ? $0fc3bef14f424428$var$q : $0fc3bef14f424428$var$G
                            }), e.removeAttribute(t2);
                        } else t2.startsWith($0fc3bef14f424428$var$v) && (r.push({
                            type: 6,
                            index: h
                        }), e.removeAttribute(t2));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if ($0fc3bef14f424428$var$M.test(e.tagName)) {
                    var t3 = e.textContent.split($0fc3bef14f424428$var$v), i2 = t3.length - 1;
                    if (i2 > 0) {
                        e.textContent = $0fc3bef14f424428$var$c ? $0fc3bef14f424428$var$c.emptyScript : "";
                        for(var _$s1 = 0; _$s1 < i2; _$s1++)e.append(t3[_$s1], $0fc3bef14f424428$var$lt()), $0fc3bef14f424428$var$I.nextNode(), r.push({
                            type: 2,
                            index: ++h
                        });
                        e.append(t3[i2], $0fc3bef14f424428$var$lt());
                    }
                }
            } else if (8 === e.nodeType) {
                if (e.data === $0fc3bef14f424428$var$m) r.push({
                    type: 2,
                    index: h
                });
                else {
                    var t4 = -1;
                    for(; -1 !== (t4 = e.data.indexOf($0fc3bef14f424428$var$v, t4 + 1));)r.push({
                        type: 7,
                        index: h
                    }), t4 += $0fc3bef14f424428$var$v.length - 1;
                }
            }
            h++;
        }
    }
    (0, $1wc17._)(B, null, [
        {
            key: "createElement",
            value: function createElement(t, i) {
                var s = $0fc3bef14f424428$var$w.createElement("template");
                return s.innerHTML = t, s;
            }
        }
    ]);
    return B;
}();
function $0fc3bef14f424428$var$z(t, i) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : t, e = arguments.length > 3 ? arguments[3] : void 0;
    var _s_o, _h__$AO;
    var _s;
    if (i === $0fc3bef14f424428$export$9c068ae9cc5db4e8) return i;
    var h = void 0 !== e ? (_s_o = s.o) === null || _s_o === void 0 ? void 0 : _s_o[e] : s.l;
    var o = $0fc3bef14f424428$var$st(i) ? void 0 : i._$litDirective$;
    var _o;
    return (h === null || h === void 0 ? void 0 : h.constructor) !== o && (h === null || h === void 0 ? void 0 : (_h__$AO = h._$AO) === null || _h__$AO === void 0 ? void 0 : _h__$AO.call(h, !1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? ((_o = (_s = s).o) !== null && _o !== void 0 ? _o : _s.o = [])[e] = h : s.l = h), void 0 !== h && (i = $0fc3bef14f424428$var$z(t, h._$AS(t, i.values), h, e)), i;
}
var $0fc3bef14f424428$var$F = /*#__PURE__*/ function() {
    "use strict";
    function F(t, i) {
        (0, $4GJKx._)(this, F);
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    (0, $1wc17._)(F, [
        {
            key: "parentNode",
            get: function get() {
                return this._$AM.parentNode;
            }
        },
        {
            key: "_$AU",
            get: function get() {
                return this._$AM._$AU;
            }
        },
        {
            key: "u",
            value: function u(t) {
                var _t_creationScope;
                var _this__$AD = this._$AD, _this__$AD_el = _this__$AD.el, i = _this__$AD_el.content, s = _this__$AD.parts, e = ((_t_creationScope = t === null || t === void 0 ? void 0 : t.creationScope) !== null && _t_creationScope !== void 0 ? _t_creationScope : $0fc3bef14f424428$var$w).importNode(i, !0);
                $0fc3bef14f424428$var$I.currentNode = e;
                var h = $0fc3bef14f424428$var$I.nextNode(), o = 0, n = 0, r = s[0];
                for(; void 0 !== r;){
                    if (o === r.index) {
                        var i1 = void 0;
                        2 === r.type ? i1 = new $0fc3bef14f424428$var$et(h, h.nextSibling, this, t) : 1 === r.type ? i1 = new r.ctor(h, r.name, r.strings, this, t) : 6 === r.type && (i1 = new $0fc3bef14f424428$var$K(h, this, t)), this._$AV.push(i1), r = s[++n];
                    }
                    o !== (r === null || r === void 0 ? void 0 : r.index) && (h = $0fc3bef14f424428$var$I.nextNode(), o++);
                }
                return $0fc3bef14f424428$var$I.currentNode = $0fc3bef14f424428$var$w, e;
            }
        },
        {
            key: "p",
            value: function p(t) {
                var i = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._$AV[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var s = _step.value;
                        void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ]);
    return F;
}();
var $0fc3bef14f424428$var$et = /*#__PURE__*/ function() {
    "use strict";
    function et(t, i, s, e) {
        (0, $4GJKx._)(this, et);
        var _e_isConnected;
        this.type = 2, this._$AH = $0fc3bef14f424428$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this.v = (_e_isConnected = e === null || e === void 0 ? void 0 : e.isConnected) !== null && _e_isConnected !== void 0 ? _e_isConnected : !0;
    }
    (0, $1wc17._)(et, [
        {
            key: "_$AU",
            get: function get() {
                var _this__$AM;
                var _this__$AM__$AU;
                return (_this__$AM__$AU = (_this__$AM = this._$AM) === null || _this__$AM === void 0 ? void 0 : _this__$AM._$AU) !== null && _this__$AM__$AU !== void 0 ? _this__$AM__$AU : this.v;
            }
        },
        {
            key: "parentNode",
            get: function get() {
                var t = this._$AA.parentNode;
                var i = this._$AM;
                return void 0 !== i && 11 === (t === null || t === void 0 ? void 0 : t.nodeType) && (t = i.parentNode), t;
            }
        },
        {
            key: "startNode",
            get: function get() {
                return this._$AA;
            }
        },
        {
            key: "endNode",
            get: function get() {
                return this._$AB;
            }
        },
        {
            key: "_$AI",
            value: function _$AI(t) {
                var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this;
                t = $0fc3bef14f424428$var$z(this, t, i), $0fc3bef14f424428$var$st(t) ? t === $0fc3bef14f424428$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $0fc3bef14f424428$export$45b790e32b2810ee && this._$AR(), this._$AH = $0fc3bef14f424428$export$45b790e32b2810ee) : t !== this._$AH && t !== $0fc3bef14f424428$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $0fc3bef14f424428$var$$(t) ? this.k(t) : this._(t);
            }
        },
        {
            key: "O",
            value: function O(t) {
                return this._$AA.parentNode.insertBefore(t, this._$AB);
            }
        },
        {
            key: "T",
            value: function T(t) {
                this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
            }
        },
        {
            key: "_",
            value: function _(t) {
                this._$AH !== $0fc3bef14f424428$export$45b790e32b2810ee && $0fc3bef14f424428$var$st(this._$AH) ? this._$AA.nextSibling.data = t : this.T($0fc3bef14f424428$var$w.createTextNode(t)), this._$AH = t;
            }
        },
        {
            key: "$",
            value: function $(t) {
                var _this__$AH;
                var i = t.values, s = t._$litType$, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $0fc3bef14f424428$var$B.createElement($0fc3bef14f424428$var$N(s.h, s.h[0]), this.options)), s);
                if (((_this__$AH = this._$AH) === null || _this__$AH === void 0 ? void 0 : _this__$AH._$AD) === e) this._$AH.p(i);
                else {
                    var _$t = new $0fc3bef14f424428$var$F(e, this), s1 = _$t.u(this.options);
                    _$t.p(i), this.T(s1), this._$AH = _$t;
                }
            }
        },
        {
            key: "_$AC",
            value: function _$AC(t) {
                var i = $0fc3bef14f424428$var$V.get(t.strings);
                return void 0 === i && $0fc3bef14f424428$var$V.set(t.strings, i = new $0fc3bef14f424428$var$B(t)), i;
            }
        },
        {
            key: "k",
            value: function k(t) {
                $0fc3bef14f424428$var$g(this._$AH) || (this._$AH = [], this._$AR());
                var i = this._$AH;
                var s, e = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var h = _step.value;
                        e === i.length ? i.push(s = new et(this.O($0fc3bef14f424428$var$lt()), this.O($0fc3bef14f424428$var$lt()), this, this.options)) : s = i[e], s._$AI(h), e++;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
            }
        },
        {
            key: "_$AR",
            value: function _$AR() {
                var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._$AA.nextSibling, i = arguments.length > 1 ? arguments[1] : void 0;
                var _this__$AP, _this;
                for((_this__$AP = (_this = this)._$AP) === null || _this__$AP === void 0 ? void 0 : _this__$AP.call(_this, !1, !0, i); t && t !== this._$AB;){
                    var i1 = t.nextSibling;
                    t.remove(), t = i1;
                }
            }
        },
        {
            key: "setConnected",
            value: function setConnected(t) {
                var _this__$AP, _this;
                void 0 === this._$AM && (this.v = t, (_this__$AP = (_this = this)._$AP) === null || _this__$AP === void 0 ? void 0 : _this__$AP.call(_this, t));
            }
        }
    ]);
    return et;
}();
var $0fc3bef14f424428$var$G = /*#__PURE__*/ function() {
    "use strict";
    function G(t, i, s, e, h) {
        (0, $4GJKx._)(this, G);
        this.type = 1, this._$AH = $0fc3bef14f424428$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $0fc3bef14f424428$export$45b790e32b2810ee;
    }
    (0, $1wc17._)(G, [
        {
            key: "tagName",
            get: function get() {
                return this.element.tagName;
            }
        },
        {
            key: "_$AU",
            get: function get() {
                return this._$AM._$AU;
            }
        },
        {
            key: "_$AI",
            value: function _$AI(t) {
                var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this, s = arguments.length > 2 ? arguments[2] : void 0, e = arguments.length > 3 ? arguments[3] : void 0;
                var h = this.strings;
                var o = !1;
                if (void 0 === h) t = $0fc3bef14f424428$var$z(this, t, i, 0), o = !$0fc3bef14f424428$var$st(t) || t !== this._$AH && t !== $0fc3bef14f424428$export$9c068ae9cc5db4e8, o && (this._$AH = t);
                else {
                    var e1 = t;
                    var n, r;
                    for(t = h[0], n = 0; n < h.length - 1; n++)r = $0fc3bef14f424428$var$z(this, e1[s + n], i, n), r === $0fc3bef14f424428$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o || (o = !$0fc3bef14f424428$var$st(r) || r !== this._$AH[n]), r === $0fc3bef14f424428$export$45b790e32b2810ee ? t = $0fc3bef14f424428$export$45b790e32b2810ee : t !== $0fc3bef14f424428$export$45b790e32b2810ee && (t += (r !== null && r !== void 0 ? r : "") + h[n + 1]), this._$AH[n] = r;
                }
                o && !e && this.j(t);
            }
        },
        {
            key: "j",
            value: function j(t) {
                t === $0fc3bef14f424428$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t !== null && t !== void 0 ? t : "");
            }
        }
    ]);
    return G;
}();
var $0fc3bef14f424428$var$Y = /*#__PURE__*/ function(G) {
    "use strict";
    (0, $dcsZi._)(Y, G);
    var _super = (0, $ohfOJ._)(Y);
    function Y() {
        (0, $4GJKx._)(this, Y);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments))), _this.type = 3;
        return (0, $3U0IP._)(_this);
    }
    (0, $1wc17._)(Y, [
        {
            key: "j",
            value: function j(t) {
                this.element[this.name] = t === $0fc3bef14f424428$export$45b790e32b2810ee ? void 0 : t;
            }
        }
    ]);
    return Y;
}($0fc3bef14f424428$var$G);
var $0fc3bef14f424428$var$Z = /*#__PURE__*/ function(G) {
    "use strict";
    (0, $dcsZi._)(Z, G);
    var _super = (0, $ohfOJ._)(Z);
    function Z() {
        (0, $4GJKx._)(this, Z);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments))), _this.type = 4;
        return (0, $3U0IP._)(_this);
    }
    (0, $1wc17._)(Z, [
        {
            key: "j",
            value: function j(t) {
                this.element.toggleAttribute(this.name, !!t && t !== $0fc3bef14f424428$export$45b790e32b2810ee);
            }
        }
    ]);
    return Z;
}($0fc3bef14f424428$var$G);
var $0fc3bef14f424428$var$q = /*#__PURE__*/ function(G) {
    "use strict";
    (0, $dcsZi._)(q, G);
    var _super = (0, $ohfOJ._)(q);
    function q(t, i, s, e, h) {
        (0, $4GJKx._)(this, q);
        var _this;
        _this = _super.call(this, t, i, s, e, h), _this.type = 5;
        return (0, $3U0IP._)(_this);
    }
    (0, $1wc17._)(q, [
        {
            key: "_$AI",
            value: function _$AI(t) {
                var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this;
                var _z;
                if ((t = (_z = $0fc3bef14f424428$var$z(this, t, i, 0)) !== null && _z !== void 0 ? _z : $0fc3bef14f424428$export$45b790e32b2810ee) === $0fc3bef14f424428$export$9c068ae9cc5db4e8) return;
                var s = this._$AH, e = t === $0fc3bef14f424428$export$45b790e32b2810ee && s !== $0fc3bef14f424428$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $0fc3bef14f424428$export$45b790e32b2810ee && (s === $0fc3bef14f424428$export$45b790e32b2810ee || e);
                e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
            }
        },
        {
            key: "handleEvent",
            value: function handleEvent(t) {
                var _this_options;
                var _this_options_host;
                "function" == typeof this._$AH ? this._$AH.call((_this_options_host = (_this_options = this.options) === null || _this_options === void 0 ? void 0 : _this_options.host) !== null && _this_options_host !== void 0 ? _this_options_host : this.element, t) : this._$AH.handleEvent(t);
            }
        }
    ]);
    return q;
}($0fc3bef14f424428$var$G);
var $0fc3bef14f424428$var$K = /*#__PURE__*/ function() {
    "use strict";
    function K(t, i, s) {
        (0, $4GJKx._)(this, K);
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    (0, $1wc17._)(K, [
        {
            key: "_$AU",
            get: function get() {
                return this._$AM._$AU;
            }
        },
        {
            key: "_$AI",
            value: function _$AI(t) {
                $0fc3bef14f424428$var$z(this, t);
            }
        }
    ]);
    return K;
}();
var $0fc3bef14f424428$export$8613d1ca9052b22e = {
    M: $0fc3bef14f424428$var$f,
    P: $0fc3bef14f424428$var$v,
    A: $0fc3bef14f424428$var$m,
    C: 1,
    L: $0fc3bef14f424428$var$U,
    R: $0fc3bef14f424428$var$F,
    D: $0fc3bef14f424428$var$$,
    V: $0fc3bef14f424428$var$z,
    I: $0fc3bef14f424428$var$et,
    H: $0fc3bef14f424428$var$G,
    N: $0fc3bef14f424428$var$Z,
    U: $0fc3bef14f424428$var$q,
    B: $0fc3bef14f424428$var$Y,
    F: $0fc3bef14f424428$var$K
}, $0fc3bef14f424428$var$Re = $0fc3bef14f424428$var$n.litHtmlPolyfillSupport;
var $0fc3bef14f424428$var$_litHtmlVersions;
$0fc3bef14f424428$var$Re === null || $0fc3bef14f424428$var$Re === void 0 ? void 0 : $0fc3bef14f424428$var$Re($0fc3bef14f424428$var$B, $0fc3bef14f424428$var$et), (($0fc3bef14f424428$var$_litHtmlVersions = ($0fc3bef14f424428$var$_n = $0fc3bef14f424428$var$n).litHtmlVersions) !== null && $0fc3bef14f424428$var$_litHtmlVersions !== void 0 ? $0fc3bef14f424428$var$_litHtmlVersions : $0fc3bef14f424428$var$_n.litHtmlVersions = []).push("3.2.0");
var $0fc3bef14f424428$export$b3890eb0ae9dca99 = function(t, i, s) {
    var _s_renderBefore;
    var e = (_s_renderBefore = s === null || s === void 0 ? void 0 : s.renderBefore) !== null && _s_renderBefore !== void 0 ? _s_renderBefore : i;
    var h = e._$litPart$;
    if (void 0 === h) {
        var _s_renderBefore1;
        var _$t = (_s_renderBefore1 = s === null || s === void 0 ? void 0 : s.renderBefore) !== null && _s_renderBefore1 !== void 0 ? _s_renderBefore1 : null;
        e._$litPart$ = h = new $0fc3bef14f424428$var$et(i.insertBefore($0fc3bef14f424428$var$lt(), _$t), _$t, void 0, s !== null && s !== void 0 ? s : {});
    }
    return h._$AI(t), h;
};

});

parcelRegister("eAsDt", function(module, exports) {
$parcel$export(module.exports, "css", function () { return (parcelRequire("bBWVO")).css; });
$parcel$export(module.exports, "unsafeCSS", function () { return (parcelRequire("bBWVO")).unsafeCSS; });
$parcel$export(module.exports, "ReactiveElement", function () { return (parcelRequire("ce9xl")).ReactiveElement; });
$parcel$export(module.exports, "html", function () { return (parcelRequire("1lUIm")).html; });
$parcel$export(module.exports, "svg", function () { return (parcelRequire("1lUIm")).svg; });
$parcel$export(module.exports, "render", function () { return (parcelRequire("1lUIm")).render; });
$parcel$export(module.exports, "noChange", function () { return (parcelRequire("1lUIm")).noChange; });

$parcel$export(module.exports, "LitElement", function () { return $a9eaa3e98ebed6c2$export$3f2f9f5909897157; });

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $04RAu = parcelRequire("04RAu");

var $b8Rim = parcelRequire("b8Rim");

var $dcsZi = parcelRequire("dcsZi");

var $3U0IP = parcelRequire("3U0IP");

var $ohfOJ = parcelRequire("ohfOJ");

var $ce9xl = parcelRequire("ce9xl");

var $1lUIm = parcelRequire("1lUIm");
var $a9eaa3e98ebed6c2$var$_globalThis_litElementHydrateSupport, $a9eaa3e98ebed6c2$var$_globalThis;
var $a9eaa3e98ebed6c2$var$_globalThis1;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $a9eaa3e98ebed6c2$export$3f2f9f5909897157 = /*#__PURE__*/ function(e) {
    "use strict";
    (0, $dcsZi._)(h, e);
    var _super = (0, $ohfOJ._)(h);
    function h() {
        (0, $4GJKx._)(this, h);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments))), _this.renderOptions = {
            host: (0, $d3H5E._)(_this)
        }, _this.o = void 0;
        return (0, $3U0IP._)(_this);
    }
    (0, $1wc17._)(h, [
        {
            key: "createRenderRoot",
            value: function createRenderRoot() {
                var _this_renderOptions;
                var t = (0, $04RAu._)((0, $b8Rim._)(h.prototype), "createRenderRoot", this).call(this);
                var _renderBefore;
                return (_renderBefore = (_this_renderOptions = this.renderOptions).renderBefore) !== null && _renderBefore !== void 0 ? _renderBefore : _this_renderOptions.renderBefore = t.firstChild, t;
            }
        },
        {
            key: "update",
            value: function update(t) {
                var _$e = this.render();
                this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), (0, $04RAu._)((0, $b8Rim._)(h.prototype), "update", this).call(this, t), this.o = (0, $1lUIm.render)(_$e, this.renderRoot, this.renderOptions);
            }
        },
        {
            key: "connectedCallback",
            value: function connectedCallback() {
                var _this_o;
                (0, $04RAu._)((0, $b8Rim._)(h.prototype), "connectedCallback", this).call(this), (_this_o = this.o) === null || _this_o === void 0 ? void 0 : _this_o.setConnected(!0);
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                var _this_o;
                (0, $04RAu._)((0, $b8Rim._)(h.prototype), "disconnectedCallback", this).call(this), (_this_o = this.o) === null || _this_o === void 0 ? void 0 : _this_o.setConnected(!1);
            }
        },
        {
            key: "render",
            value: function render() {
                return 0, $1lUIm.noChange;
            }
        }
    ]);
    return h;
}((0, $ce9xl.ReactiveElement));
$a9eaa3e98ebed6c2$export$3f2f9f5909897157._$litElement$ = !0, $a9eaa3e98ebed6c2$export$3f2f9f5909897157["finalized"] = !0, ($a9eaa3e98ebed6c2$var$_globalThis_litElementHydrateSupport = ($a9eaa3e98ebed6c2$var$_globalThis = globalThis).litElementHydrateSupport) === null || $a9eaa3e98ebed6c2$var$_globalThis_litElementHydrateSupport === void 0 ? void 0 : $a9eaa3e98ebed6c2$var$_globalThis_litElementHydrateSupport.call($a9eaa3e98ebed6c2$var$_globalThis, {
    LitElement: $a9eaa3e98ebed6c2$export$3f2f9f5909897157
});
var $a9eaa3e98ebed6c2$var$f = globalThis.litElementPolyfillSupport;
$a9eaa3e98ebed6c2$var$f === null || $a9eaa3e98ebed6c2$var$f === void 0 ? void 0 : $a9eaa3e98ebed6c2$var$f({
    LitElement: $a9eaa3e98ebed6c2$export$3f2f9f5909897157
});
var $a9eaa3e98ebed6c2$export$f5c524615a7708d6 = {
    _$AK: function(t, e, s) {
        t._$AK(e, s);
    },
    _$AL: function(t) {
        return t._$AL;
    }
};
var $a9eaa3e98ebed6c2$var$_litElementVersions;
(($a9eaa3e98ebed6c2$var$_litElementVersions = ($a9eaa3e98ebed6c2$var$_globalThis1 = globalThis).litElementVersions) !== null && $a9eaa3e98ebed6c2$var$_litElementVersions !== void 0 ? $a9eaa3e98ebed6c2$var$_litElementVersions : $a9eaa3e98ebed6c2$var$_globalThis1.litElementVersions = []).push("4.1.0");

});

parcelRegister("6vTJR", function(module, exports) {
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $4be0dfd9c7fce7a6$export$6acf61af03e62db = !1;

});



parcelRegister("gulvp", function(module, exports) {

$parcel$export(module.exports, "swapInputMaskTopSvg", function () { return $c01021394bd1f3d3$export$5ff8049c8368d155; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $c01021394bd1f3d3$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg class="input_mask" width="328" height="100" viewBox="0 0 328 100" fill="none">\n  <mask id="path-1-inside-1_18299_4168">\n    <path\n      class="input_mask__border"\n      fill-rule="evenodd"\n      clip-rule="evenodd"\n      d="M5.85786 5.85786C0 11.7157 0 21.1438 0 40V60C0 78.8562 0 88.2843 5.85786 94.1421C11.7157 100 21.1438 100 40 100H138.008C138.042 95.1088 138.214 92.2372 139.086 89.8436C140.905 84.8438 144.844 80.9053 149.844 79.0855C152.826 78 156.551 78 164 78C171.449 78 175.174 78 178.156 79.0855C183.156 80.9053 187.095 84.8438 188.914 89.8436C189.786 92.2372 189.958 95.1088 189.992 100H288C306.856 100 316.284 100 322.142 94.1421C328 88.2843 328 78.8562 328 60V40C328 21.1438 328 11.7157 322.142 5.85786C316.284 0 306.856 0 288 0H40C21.1438 0 11.7157 0 5.85786 5.85786Z"\n    />\n  </mask>\n  <path\n    class="input_mask__background"\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M5.85786 5.85786C0 11.7157 0 21.1438 0 40V60C0 78.8562 0 88.2843 5.85786 94.1421C11.7157 100 21.1438 100 40 100H138.008C138.042 95.1088 138.214 92.2372 139.086 89.8436C140.905 84.8438 144.844 80.9053 149.844 79.0855C152.826 78 156.551 78 164 78C171.449 78 175.174 78 178.156 79.0855C183.156 80.9053 187.095 84.8438 188.914 89.8436C189.786 92.2372 189.958 95.1088 189.992 100H288C306.856 100 316.284 100 322.142 94.1421C328 88.2843 328 78.8562 328 60V40C328 21.1438 328 11.7157 322.142 5.85786C316.284 0 306.856 0 288 0H40C21.1438 0 11.7157 0 5.85786 5.85786Z"\n  />\n  <path\n    class="input_mask__border"\n    d="M138.008 100V101H139.001L139.008 100.007L138.008 100ZM139.086 89.8436L138.146 89.5016L139.086 89.8436ZM149.844 79.0855L150.186 80.0252L149.844 79.0855ZM178.156 79.0855L177.814 80.0252L178.156 79.0855ZM188.914 89.8436L189.854 89.5016L188.914 89.8436ZM189.992 100L188.992 100.007L188.999 101H189.992V100ZM322.142 94.1421L322.849 94.8492H322.849L322.142 94.1421ZM322.142 5.85786L322.849 5.15076L322.849 5.15076L322.142 5.85786ZM1 40C1 30.5436 1.00212 23.552 1.72332 18.1878C2.44064 12.8524 3.85281 9.27713 6.56497 6.56497L5.15076 5.15076C2.00506 8.29646 0.488292 12.3641 -0.25885 17.9213C-1.00212 23.4497 -1 30.6002 -1 40H1ZM1 60V40H-1V60H1ZM6.56497 93.435C3.85281 90.7229 2.44064 87.1476 1.72332 81.8122C1.00212 76.448 1 69.4564 1 60H-1C-1 69.3998 -1.00212 76.5503 -0.25885 82.0787C0.488292 87.6358 2.00506 91.7035 5.15076 94.8492L6.56497 93.435ZM40 99C30.5436 99 23.552 98.9979 18.1878 98.2767C12.8524 97.5594 9.27713 96.1472 6.56497 93.435L5.15076 94.8492C8.29646 97.9949 12.3641 99.5117 17.9213 100.259C23.4497 101.002 30.6002 101 40 101V99ZM138.008 99H40V101H138.008V99ZM139.008 100.007C139.042 95.0921 139.222 92.3921 140.025 90.1857L138.146 89.5016C137.207 92.0823 137.042 95.1255 137.008 99.9931L139.008 100.007ZM140.025 90.1857C141.744 85.4636 145.464 81.7439 150.186 80.0252L149.502 78.1458C144.224 80.0667 140.067 84.2241 138.146 89.5016L140.025 90.1857ZM150.186 80.0252C152.961 79.0152 156.464 79 164 79V77C156.638 77 152.692 76.9848 149.502 78.1458L150.186 80.0252ZM164 79C171.536 79 175.039 79.0152 177.814 80.0252L178.498 78.1458C175.308 76.9848 171.362 77 164 77V79ZM177.814 80.0252C182.536 81.7439 186.256 85.4636 187.975 90.1857L189.854 89.5016C187.933 84.2241 183.776 80.0667 178.498 78.1458L177.814 80.0252ZM187.975 90.1857C188.778 92.3921 188.958 95.0921 188.992 100.007L190.992 99.9931C190.958 95.1255 190.793 92.0823 189.854 89.5016L187.975 90.1857ZM288 99H189.992V101H288V99ZM321.435 93.435C318.723 96.1472 315.148 97.5594 309.812 98.2767C304.448 98.9979 297.456 99 288 99V101C297.4 101 304.55 101.002 310.079 100.259C315.636 99.5117 319.704 97.9949 322.849 94.8492L321.435 93.435ZM327 60C327 69.4564 326.998 76.448 326.277 81.8122C325.559 87.1476 324.147 90.7229 321.435 93.435L322.849 94.8492C325.995 91.7035 327.512 87.6358 328.259 82.0787C329.002 76.5503 329 69.3998 329 60H327ZM327 40V60H329V40H327ZM321.435 6.56497C324.147 9.27713 325.559 12.8524 326.277 18.1878C326.998 23.552 327 30.5436 327 40H329C329 30.6002 329.002 23.4497 328.259 17.9213C327.512 12.3642 325.995 8.29646 322.849 5.15076L321.435 6.56497ZM288 1C297.456 1 304.448 1.00212 309.812 1.72332C315.148 2.44064 318.723 3.85281 321.435 6.56497L322.849 5.15076C319.704 2.00506 315.636 0.488292 310.079 -0.25885C304.55 -1.00212 297.4 -1 288 -1V1ZM40 1H288V-1H40V1ZM6.56497 6.56497C9.27713 3.85281 12.8524 2.44064 18.1878 1.72332C23.552 1.00212 30.5436 1 40 1V-1C30.6002 -1 23.4497 -1.00212 17.9213 -0.25885C12.3641 0.488292 8.29646 2.00506 5.15076 5.15076L6.56497 6.56497Z"\n    mask="url(#path-1-inside-1_18299_4168)"\n  />\n</svg>'
    ]);
    $c01021394bd1f3d3$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $c01021394bd1f3d3$export$5ff8049c8368d155 = (0, $1lUIm.svg)($c01021394bd1f3d3$var$_templateObject());

});

parcelRegister("jfGtx", function(module, exports) {

$parcel$export(module.exports, "WuiCard", function () { return $e0405dc7fc36c4f7$export$9de547c596d443f7; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $amxoh = parcelRequire("amxoh");
function $e0405dc7fc36c4f7$var$_templateObject() {
    var data = (0, $j06k0._)([
        "<slot></slot>"
    ]);
    $e0405dc7fc36c4f7$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $e0405dc7fc36c4f7$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $e0405dc7fc36c4f7$export$9de547c596d443f7 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiCard, LitElement);
    var _super = (0, $ohfOJ._)(WuiCard);
    function WuiCard() {
        (0, $4GJKx._)(this, WuiCard);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(WuiCard, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($e0405dc7fc36c4f7$var$_templateObject());
            }
        }
    ]);
    return WuiCard;
}((0, $eAsDt.LitElement));
$e0405dc7fc36c4f7$export$9de547c596d443f7.styles = [
    (0, $kYNxm.resetStyles),
    (0, $amxoh.default)
];
$e0405dc7fc36c4f7$export$9de547c596d443f7 = $e0405dc7fc36c4f7$var$__decorate([
    (0, $hdxb6.customElement)("wui-card")
], $e0405dc7fc36c4f7$export$9de547c596d443f7);

});
parcelRegister("kYNxm", function(module, exports) {

$parcel$export(module.exports, "initializeTheming", function () { return $f45fd6481fd2b016$export$8ee9916a43f985de; });
$parcel$export(module.exports, "setColorTheme", function () { return $f45fd6481fd2b016$export$718db041b82c5d23; });
$parcel$export(module.exports, "setThemeVariables", function () { return $f45fd6481fd2b016$export$b6ed091aa8078e9b; });
$parcel$export(module.exports, "resetStyles", function () { return $f45fd6481fd2b016$export$6b6f359a824920a4; });
$parcel$export(module.exports, "elementStyles", function () { return $f45fd6481fd2b016$export$e7ba49a1dbca65c7; });
$parcel$export(module.exports, "colorStyles", function () { return $f45fd6481fd2b016$export$ab44001f5690ee9c; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
parcelRequire("dSKxG");
var $cnADL = parcelRequire("cnADL");
function $f45fd6481fd2b016$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');\n      @keyframes w3m-shake {\n        0% {\n          transform: scale(1) rotate(0deg);\n        }\n        20% {\n          transform: scale(1) rotate(-1deg);\n        }\n        40% {\n          transform: scale(1) rotate(1.5deg);\n        }\n        60% {\n          transform: scale(1) rotate(-1.5deg);\n        }\n        80% {\n          transform: scale(1) rotate(1deg);\n        }\n        100% {\n          transform: scale(1) rotate(0deg);\n        }\n      }\n      @keyframes w3m-iframe-fade-out {\n        0% {\n          opacity: 1;\n        }\n        100% {\n          opacity: 0;\n        }\n      }\n      @keyframes w3m-iframe-zoom-in {\n        0% {\n          transform: translateY(50px);\n          opacity: 0;\n        }\n        100% {\n          transform: translateY(0px);\n          opacity: 1;\n        }\n      }\n      @keyframes w3m-iframe-zoom-in-mobile {\n        0% {\n          transform: scale(0.95);\n          opacity: 0;\n        }\n        100% {\n          transform: scale(1);\n          opacity: 1;\n        }\n      }\n      :root {\n        --w3m-modal-width: 360px;\n        --w3m-color-mix-strength: ",
        ";\n        --w3m-font-family: ",
        ";\n        --w3m-font-size-master: ",
        ";\n        --w3m-border-radius-master: ",
        ";\n        --w3m-z-index: ",
        ";\n\n        --wui-font-family: var(--w3m-font-family);\n\n        --wui-font-size-mini: calc(var(--w3m-font-size-master) * 0.8);\n        --wui-font-size-micro: var(--w3m-font-size-master);\n        --wui-font-size-tiny: calc(var(--w3m-font-size-master) * 1.2);\n        --wui-font-size-small: calc(var(--w3m-font-size-master) * 1.4);\n        --wui-font-size-paragraph: calc(var(--w3m-font-size-master) * 1.6);\n        --wui-font-size-medium: calc(var(--w3m-font-size-master) * 1.8);\n        --wui-font-size-large: calc(var(--w3m-font-size-master) * 2);\n        --wui-font-size-title-6: calc(var(--w3m-font-size-master) * 2.2);\n        --wui-font-size-medium-title: calc(var(--w3m-font-size-master) * 2.4);\n        --wui-font-size-2xl: calc(var(--w3m-font-size-master) * 4);\n\n        --wui-border-radius-5xs: var(--w3m-border-radius-master);\n        --wui-border-radius-4xs: calc(var(--w3m-border-radius-master) * 1.5);\n        --wui-border-radius-3xs: calc(var(--w3m-border-radius-master) * 2);\n        --wui-border-radius-xxs: calc(var(--w3m-border-radius-master) * 3);\n        --wui-border-radius-xs: calc(var(--w3m-border-radius-master) * 4);\n        --wui-border-radius-s: calc(var(--w3m-border-radius-master) * 5);\n        --wui-border-radius-m: calc(var(--w3m-border-radius-master) * 7);\n        --wui-border-radius-l: calc(var(--w3m-border-radius-master) * 9);\n        --wui-border-radius-3xl: calc(var(--w3m-border-radius-master) * 20);\n\n        --wui-font-weight-light: 400;\n        --wui-font-weight-regular: 500;\n        --wui-font-weight-medium: 600;\n        --wui-font-weight-bold: 700;\n\n        --wui-letter-spacing-2xl: -1.6px;\n        --wui-letter-spacing-medium-title: -0.96px;\n        --wui-letter-spacing-title-6: -0.88px;\n        --wui-letter-spacing-large: -0.8px;\n        --wui-letter-spacing-medium: -0.72px;\n        --wui-letter-spacing-paragraph: -0.64px;\n        --wui-letter-spacing-small: -0.56px;\n        --wui-letter-spacing-tiny: -0.48px;\n        --wui-letter-spacing-micro: -0.2px;\n        --wui-letter-spacing-mini: -0.16px;\n\n        --wui-spacing-0: 0px;\n        --wui-spacing-4xs: 2px;\n        --wui-spacing-3xs: 4px;\n        --wui-spacing-xxs: 6px;\n        --wui-spacing-2xs: 7px;\n        --wui-spacing-xs: 8px;\n        --wui-spacing-1xs: 10px;\n        --wui-spacing-s: 12px;\n        --wui-spacing-m: 14px;\n        --wui-spacing-l: 16px;\n        --wui-spacing-2l: 18px;\n        --wui-spacing-xl: 20px;\n        --wui-spacing-xxl: 24px;\n        --wui-spacing-2xl: 32px;\n        --wui-spacing-3xl: 40px;\n        --wui-spacing-4xl: 90px;\n        --wui-spacing-5xl: 95px;\n\n        --wui-icon-box-size-xxs: 14px;\n        --wui-icon-box-size-xs: 20px;\n        --wui-icon-box-size-sm: 24px;\n        --wui-icon-box-size-md: 32px;\n        --wui-icon-box-size-lg: 40px;\n        --wui-icon-box-size-2lg: 48px;\n        --wui-icon-box-size-xl: 64px;\n\n        --wui-icon-size-inherit: inherit;\n        --wui-icon-size-xxs: 10px;\n        --wui-icon-size-xs: 12px;\n        --wui-icon-size-sm: 14px;\n        --wui-icon-size-md: 16px;\n        --wui-icon-size-mdl: 18px;\n        --wui-icon-size-lg: 20px;\n        --wui-icon-size-xl: 24px;\n        --wui-icon-size-xxl: 28px;\n\n        --wui-wallet-image-size-inherit: inherit;\n        --wui-wallet-image-size-sm: 40px;\n        --wui-wallet-image-size-md: 56px;\n        --wui-wallet-image-size-lg: 80px;\n\n        --wui-visual-size-size-inherit: inherit;\n        --wui-visual-size-sm: 40px;\n        --wui-visual-size-md: 55px;\n        --wui-visual-size-lg: 80px;\n\n        --wui-box-size-md: 100px;\n        --wui-box-size-lg: 120px;\n\n        --wui-ease-out-power-2: cubic-bezier(0, 0, 0.22, 1);\n        --wui-ease-out-power-1: cubic-bezier(0, 0, 0.55, 1);\n\n        --wui-ease-in-power-3: cubic-bezier(0.66, 0, 1, 1);\n        --wui-ease-in-power-2: cubic-bezier(0.45, 0, 1, 1);\n        --wui-ease-in-power-1: cubic-bezier(0.3, 0, 1, 1);\n\n        --wui-ease-inout-power-1: cubic-bezier(0.45, 0, 0.55, 1);\n\n        --wui-duration-lg: 200ms;\n        --wui-duration-md: 125ms;\n        --wui-duration-sm: 75ms;\n\n        --wui-path-network-sm: path(\n          'M15.4 2.1a5.21 5.21 0 0 1 5.2 0l11.61 6.7a5.21 5.21 0 0 1 2.61 4.52v13.4c0 1.87-1 3.59-2.6 4.52l-11.61 6.7c-1.62.93-3.6.93-5.22 0l-11.6-6.7a5.21 5.21 0 0 1-2.61-4.51v-13.4c0-1.87 1-3.6 2.6-4.52L15.4 2.1Z'\n        );\n\n        --wui-path-network-md: path(\n          'M43.4605 10.7248L28.0485 1.61089C25.5438 0.129705 22.4562 0.129705 19.9515 1.61088L4.53951 10.7248C2.03626 12.2051 0.5 14.9365 0.5 17.886V36.1139C0.5 39.0635 2.03626 41.7949 4.53951 43.2752L19.9515 52.3891C22.4562 53.8703 25.5438 53.8703 28.0485 52.3891L43.4605 43.2752C45.9637 41.7949 47.5 39.0635 47.5 36.114V17.8861C47.5 14.9365 45.9637 12.2051 43.4605 10.7248Z'\n        );\n\n        --wui-path-network-lg: path(\n          'M78.3244 18.926L50.1808 2.45078C45.7376 -0.150261 40.2624 -0.150262 35.8192 2.45078L7.6756 18.926C3.23322 21.5266 0.5 26.3301 0.5 31.5248V64.4752C0.5 69.6699 3.23322 74.4734 7.6756 77.074L35.8192 93.5492C40.2624 96.1503 45.7376 96.1503 50.1808 93.5492L78.3244 77.074C82.7668 74.4734 85.5 69.6699 85.5 64.4752V31.5248C85.5 26.3301 82.7668 21.5266 78.3244 18.926Z'\n        );\n\n        --wui-width-network-sm: 36px;\n        --wui-width-network-md: 48px;\n        --wui-width-network-lg: 86px;\n\n        --wui-height-network-sm: 40px;\n        --wui-height-network-md: 54px;\n        --wui-height-network-lg: 96px;\n\n        --wui-icon-size-network-xs: 12px;\n        --wui-icon-size-network-sm: 16px;\n        --wui-icon-size-network-md: 24px;\n        --wui-icon-size-network-lg: 42px;\n\n        --wui-color-inherit: inherit;\n\n        --wui-color-inverse-100: #fff;\n        --wui-color-inverse-000: #000;\n\n        --wui-cover: rgba(20, 20, 20, 0.8);\n\n        --wui-color-modal-bg: var(--wui-color-modal-bg-base);\n\n        --wui-color-accent-100: var(--wui-color-accent-base-100);\n        --wui-color-accent-090: var(--wui-color-accent-base-090);\n        --wui-color-accent-080: var(--wui-color-accent-base-080);\n\n        --wui-color-success-100: var(--wui-color-success-base-100);\n\n        --wui-color-error-100: var(--wui-color-error-base-100);\n\n        --wui-icon-box-bg-error-100: var(--wui-icon-box-bg-error-base-100);\n        --wui-icon-box-bg-blue-100: var(--wui-icon-box-bg-blue-base-100);\n        --wui-icon-box-bg-success-100: var(--wui-icon-box-bg-success-base-100);\n        --wui-icon-box-bg-inverse-100: var(--wui-icon-box-bg-inverse-base-100);\n\n        --wui-all-wallets-bg-100: var(--wui-all-wallets-bg-100);\n\n        --wui-avatar-border: var(--wui-avatar-border-base);\n\n        --wui-thumbnail-border: var(--wui-thumbnail-border-base);\n\n        --wui-box-shadow-blue: var(--wui-color-accent-glass-020);\n      }\n\n      @supports (background: color-mix(in srgb, white 50%, black)) {\n        :root {\n          --wui-color-modal-bg: color-mix(\n            in srgb,\n            var(--w3m-color-mix) var(--w3m-color-mix-strength),\n            var(--wui-color-modal-bg-base)\n          );\n\n          --wui-box-shadow-blue: color-mix(in srgb, var(--wui-color-accent-100) 20%, transparent);\n\n          --wui-color-accent-100: color-mix(\n            in srgb,\n            var(--wui-color-accent-base-100) 100%,\n            transparent\n          );\n          --wui-color-accent-090: color-mix(\n            in srgb,\n            var(--wui-color-accent-base-100) 90%,\n            transparent\n          );\n          --wui-color-accent-080: color-mix(\n            in srgb,\n            var(--wui-color-accent-base-100) 80%,\n            transparent\n          );\n          --wui-color-accent-glass-090: color-mix(\n            in srgb,\n            var(--wui-color-accent-base-100) 90%,\n            transparent\n          );\n          --wui-color-accent-glass-080: color-mix(\n            in srgb,\n            var(--wui-color-accent-base-100) 80%,\n            transparent\n          );\n          --wui-color-accent-glass-020: color-mix(\n            in srgb,\n            var(--wui-color-accent-base-100) 20%,\n            transparent\n          );\n          --wui-color-accent-glass-015: color-mix(\n            in srgb,\n            var(--wui-color-accent-base-100) 15%,\n            transparent\n          );\n          --wui-color-accent-glass-010: color-mix(\n            in srgb,\n            var(--wui-color-accent-base-100) 10%,\n            transparent\n          );\n          --wui-color-accent-glass-005: color-mix(\n            in srgb,\n            var(--wui-color-accent-base-100) 5%,\n            transparent\n          );\n          --wui-color-accent-002: color-mix(\n            in srgb,\n            var(--wui-color-accent-base-100) 2%,\n            transparent\n          );\n\n          --wui-color-fg-100: color-mix(\n            in srgb,\n            var(--w3m-color-mix) var(--w3m-color-mix-strength),\n            var(--wui-color-fg-100)\n          );\n          --wui-color-fg-125: color-mix(\n            in srgb,\n            var(--w3m-color-mix) var(--w3m-color-mix-strength),\n            var(--wui-color-fg-125)\n          );\n          --wui-color-fg-150: color-mix(\n            in srgb,\n            var(--w3m-color-mix) var(--w3m-color-mix-strength),\n            var(--wui-color-fg-150)\n          );\n          --wui-color-fg-175: color-mix(\n            in srgb,\n            var(--w3m-color-mix) var(--w3m-color-mix-strength),\n            var(--wui-color-fg-175)\n          );\n          --wui-color-fg-200: color-mix(\n            in srgb,\n            var(--w3m-color-mix) var(--w3m-color-mix-strength),\n            var(--wui-color-fg-200)\n          );\n          --wui-color-fg-225: color-mix(\n            in srgb,\n            var(--w3m-color-mix) var(--w3m-color-mix-strength),\n            var(--wui-color-fg-225)\n          );\n          --wui-color-fg-250: color-mix(\n            in srgb,\n            var(--w3m-color-mix) var(--w3m-color-mix-strength),\n            var(--wui-color-fg-250)\n          );\n          --wui-color-fg-275: color-mix(\n            in srgb,\n            var(--w3m-color-mix) var(--w3m-color-mix-strength),\n            var(--wui-color-fg-275)\n          );\n          --wui-color-fg-300: color-mix(\n            in srgb,\n            var(--w3m-color-mix) var(--w3m-color-mix-strength),\n            var(--wui-color-fg-300)\n          );\n\n          --wui-color-bg-100: color-mix(\n            in srgb,\n            var(--w3m-color-mix) var(--w3m-color-mix-strength),\n            var(--wui-color-bg-100)\n          );\n          --wui-color-bg-125: color-mix(\n            in srgb,\n            var(--w3m-color-mix) var(--w3m-color-mix-strength),\n            var(--wui-color-bg-125)\n          );\n          --wui-color-bg-150: color-mix(\n            in srgb,\n            var(--w3m-color-mix) var(--w3m-color-mix-strength),\n            var(--wui-color-bg-150)\n          );\n          --wui-color-bg-175: color-mix(\n            in srgb,\n            var(--w3m-color-mix) var(--w3m-color-mix-strength),\n            var(--wui-color-bg-175)\n          );\n          --wui-color-bg-200: color-mix(\n            in srgb,\n            var(--w3m-color-mix) var(--w3m-color-mix-strength),\n            var(--wui-color-bg-200)\n          );\n          --wui-color-bg-225: color-mix(\n            in srgb,\n            var(--w3m-color-mix) var(--w3m-color-mix-strength),\n            var(--wui-color-bg-225)\n          );\n          --wui-color-bg-250: color-mix(\n            in srgb,\n            var(--w3m-color-mix) var(--w3m-color-mix-strength),\n            var(--wui-color-bg-250)\n          );\n          --wui-color-bg-275: color-mix(\n            in srgb,\n            var(--w3m-color-mix) var(--w3m-color-mix-strength),\n            var(--wui-color-bg-275)\n          );\n          --wui-color-bg-300: color-mix(\n            in srgb,\n            var(--w3m-color-mix) var(--w3m-color-mix-strength),\n            var(--wui-color-bg-300)\n          );\n\n          --wui-color-success-100: color-mix(\n            in srgb,\n            var(--w3m-color-mix) var(--w3m-color-mix-strength),\n            var(--wui-color-success-base-100)\n          );\n          --wui-color-error-100: color-mix(\n            in srgb,\n            var(--w3m-color-mix) var(--w3m-color-mix-strength),\n            var(--wui-color-error-base-100)\n          );\n\n          --wui-icon-box-bg-error-100: color-mix(\n            in srgb,\n            var(--w3m-color-mix) var(--w3m-color-mix-strength),\n            var(--wui-icon-box-bg-error-base-100)\n          );\n          --wui-icon-box-bg-accent-100: color-mix(\n            in srgb,\n            var(--w3m-color-mix) var(--w3m-color-mix-strength),\n            var(--wui-icon-box-bg-blue-base-100)\n          );\n          --wui-icon-box-bg-success-100: color-mix(\n            in srgb,\n            var(--w3m-color-mix) var(--w3m-color-mix-strength),\n            var(--wui-icon-box-bg-success-base-100)\n          );\n          --wui-icon-box-bg-inverse-100: color-mix(\n            in srgb,\n            var(--w3m-color-mix) var(--w3m-color-mix-strength),\n            var(--wui-icon-box-bg-inverse-base-100)\n          );\n\n          --wui-all-wallets-bg-100: color-mix(\n            in srgb,\n            var(--w3m-color-mix) var(--w3m-color-mix-strength),\n            var(--wui-all-wallets-bg-100)\n          );\n\n          --wui-avatar-border: color-mix(\n            in srgb,\n            var(--w3m-color-mix) var(--w3m-color-mix-strength),\n            var(--wui-avatar-border-base)\n          );\n\n          --wui-thumbnail-border: color-mix(\n            in srgb,\n            var(--w3m-color-mix) var(--w3m-color-mix-strength),\n            var(--wui-thumbnail-border-base)\n          );\n        }\n      }\n    "
    ]);
    $f45fd6481fd2b016$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $f45fd6481fd2b016$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "\n      :root {\n        --w3m-color-mix: ",
        ";\n        --w3m-accent: ",
        ";\n        --w3m-default: #fff;\n\n        --wui-color-modal-bg-base: ",
        ";\n        --wui-color-accent-base-100: var(--w3m-accent);\n\n        --wui-color-blueberry-100: hsla(230, 100%, 67%, 1);\n        --wui-color-blueberry-090: hsla(231, 76%, 61%, 1);\n        --wui-color-blueberry-080: hsla(230, 59%, 55%, 1);\n        --wui-color-blueberry-050: hsla(231, 100%, 70%, 0.1);\n\n        --wui-color-fg-100: #e4e7e7;\n        --wui-color-fg-125: #d0d5d5;\n        --wui-color-fg-150: #a8b1b1;\n        --wui-color-fg-175: #a8b0b0;\n        --wui-color-fg-200: #949e9e;\n        --wui-color-fg-225: #868f8f;\n        --wui-color-fg-250: #788080;\n        --wui-color-fg-275: #788181;\n        --wui-color-fg-300: #6e7777;\n\n        --wui-color-bg-100: #141414;\n        --wui-color-bg-125: #191a1a;\n        --wui-color-bg-150: #1e1f1f;\n        --wui-color-bg-175: #222525;\n        --wui-color-bg-200: #272a2a;\n        --wui-color-bg-225: #2c3030;\n        --wui-color-bg-250: #313535;\n        --wui-color-bg-275: #363b3b;\n        --wui-color-bg-300: #3b4040;\n\n        --wui-color-success-base-100: #26d962;\n        --wui-color-error-base-100: #f25a67;\n\n        --wui-color-success-glass-001: rgba(38, 217, 98, 0.01);\n        --wui-color-success-glass-002: rgba(38, 217, 98, 0.02);\n        --wui-color-success-glass-005: rgba(38, 217, 98, 0.05);\n        --wui-color-success-glass-010: rgba(38, 217, 98, 0.1);\n        --wui-color-success-glass-015: rgba(38, 217, 98, 0.15);\n        --wui-color-success-glass-020: rgba(38, 217, 98, 0.2);\n        --wui-color-success-glass-025: rgba(38, 217, 98, 0.25);\n        --wui-color-success-glass-030: rgba(38, 217, 98, 0.3);\n        --wui-color-success-glass-060: rgba(38, 217, 98, 0.6);\n        --wui-color-success-glass-080: rgba(38, 217, 98, 0.8);\n\n        --wui-color-error-glass-001: rgba(242, 90, 103, 0.01);\n        --wui-color-error-glass-002: rgba(242, 90, 103, 0.02);\n        --wui-color-error-glass-005: rgba(242, 90, 103, 0.05);\n        --wui-color-error-glass-010: rgba(242, 90, 103, 0.1);\n        --wui-color-error-glass-015: rgba(242, 90, 103, 0.15);\n        --wui-color-error-glass-020: rgba(242, 90, 103, 0.2);\n        --wui-color-error-glass-025: rgba(242, 90, 103, 0.25);\n        --wui-color-error-glass-030: rgba(242, 90, 103, 0.3);\n        --wui-color-error-glass-060: rgba(242, 90, 103, 0.6);\n        --wui-color-error-glass-080: rgba(242, 90, 103, 0.8);\n\n        --wui-color-gray-glass-001: rgba(255, 255, 255, 0.01);\n        --wui-color-gray-glass-002: rgba(255, 255, 255, 0.02);\n        --wui-color-gray-glass-005: rgba(255, 255, 255, 0.05);\n        --wui-color-gray-glass-010: rgba(255, 255, 255, 0.1);\n        --wui-color-gray-glass-015: rgba(255, 255, 255, 0.15);\n        --wui-color-gray-glass-020: rgba(255, 255, 255, 0.2);\n        --wui-color-gray-glass-025: rgba(255, 255, 255, 0.25);\n        --wui-color-gray-glass-030: rgba(255, 255, 255, 0.3);\n        --wui-color-gray-glass-060: rgba(255, 255, 255, 0.6);\n        --wui-color-gray-glass-080: rgba(255, 255, 255, 0.8);\n        --wui-color-gray-glass-090: rgba(255, 255, 255, 0.9);\n\n        --wui-icon-box-bg-error-base-100: #3c2426;\n        --wui-icon-box-bg-blue-base-100: #20303f;\n        --wui-icon-box-bg-success-base-100: #1f3a28;\n        --wui-icon-box-bg-inverse-base-100: #243240;\n\n        --wui-all-wallets-bg-100: #222b35;\n\n        --wui-avatar-border-base: #252525;\n\n        --wui-thumbnail-border-base: #252525;\n      }\n    "
    ]);
    $f45fd6481fd2b016$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $f45fd6481fd2b016$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "\n      :root {\n        --w3m-color-mix: ",
        ";\n        --w3m-accent: ",
        ";\n        --w3m-default: #000;\n\n        --wui-color-modal-bg-base: ",
        ";\n        --wui-color-accent-base-100: var(--w3m-accent);\n\n        --wui-color-blueberry-100: hsla(231, 100%, 70%, 1);\n        --wui-color-blueberry-090: hsla(231, 97%, 72%, 1);\n        --wui-color-blueberry-080: hsla(231, 92%, 74%, 1);\n\n        --wui-color-fg-100: #141414;\n        --wui-color-fg-125: #2d3131;\n        --wui-color-fg-150: #474d4d;\n        --wui-color-fg-175: #636d6d;\n        --wui-color-fg-200: #798686;\n        --wui-color-fg-225: #828f8f;\n        --wui-color-fg-250: #8b9797;\n        --wui-color-fg-275: #95a0a0;\n        --wui-color-fg-300: #9ea9a9;\n\n        --wui-color-bg-100: #ffffff;\n        --wui-color-bg-125: #f5fafa;\n        --wui-color-bg-150: #f3f8f8;\n        --wui-color-bg-175: #eef4f4;\n        --wui-color-bg-200: #eaf1f1;\n        --wui-color-bg-225: #e5eded;\n        --wui-color-bg-250: #e1e9e9;\n        --wui-color-bg-275: #dce7e7;\n        --wui-color-bg-300: #d8e3e3;\n\n        --wui-color-success-base-100: #26b562;\n        --wui-color-error-base-100: #f05142;\n\n        --wui-color-success-glass-001: rgba(38, 181, 98, 0.01);\n        --wui-color-success-glass-002: rgba(38, 181, 98, 0.02);\n        --wui-color-success-glass-005: rgba(38, 181, 98, 0.05);\n        --wui-color-success-glass-010: rgba(38, 181, 98, 0.1);\n        --wui-color-success-glass-015: rgba(38, 181, 98, 0.15);\n        --wui-color-success-glass-020: rgba(38, 181, 98, 0.2);\n        --wui-color-success-glass-025: rgba(38, 181, 98, 0.25);\n        --wui-color-success-glass-030: rgba(38, 181, 98, 0.3);\n        --wui-color-success-glass-060: rgba(38, 181, 98, 0.6);\n        --wui-color-success-glass-080: rgba(38, 181, 98, 0.8);\n\n        --wui-color-error-glass-001: rgba(240, 81, 66, 0.01);\n        --wui-color-error-glass-002: rgba(240, 81, 66, 0.02);\n        --wui-color-error-glass-005: rgba(240, 81, 66, 0.05);\n        --wui-color-error-glass-010: rgba(240, 81, 66, 0.1);\n        --wui-color-error-glass-015: rgba(240, 81, 66, 0.15);\n        --wui-color-error-glass-020: rgba(240, 81, 66, 0.2);\n        --wui-color-error-glass-025: rgba(240, 81, 66, 0.25);\n        --wui-color-error-glass-030: rgba(240, 81, 66, 0.3);\n        --wui-color-error-glass-060: rgba(240, 81, 66, 0.6);\n        --wui-color-error-glass-080: rgba(240, 81, 66, 0.8);\n\n        --wui-icon-box-bg-error-base-100: #f4dfdd;\n        --wui-icon-box-bg-blue-base-100: #d9ecfb;\n        --wui-icon-box-bg-success-base-100: #daf0e4;\n        --wui-icon-box-bg-inverse-base-100: #dcecfc;\n\n        --wui-all-wallets-bg-100: #e8f1fa;\n\n        --wui-avatar-border-base: #f3f4f4;\n\n        --wui-thumbnail-border-base: #eaefef;\n\n        --wui-color-gray-glass-001: rgba(0, 0, 0, 0.01);\n        --wui-color-gray-glass-002: rgba(0, 0, 0, 0.02);\n        --wui-color-gray-glass-005: rgba(0, 0, 0, 0.05);\n        --wui-color-gray-glass-010: rgba(0, 0, 0, 0.1);\n        --wui-color-gray-glass-015: rgba(0, 0, 0, 0.15);\n        --wui-color-gray-glass-020: rgba(0, 0, 0, 0.2);\n        --wui-color-gray-glass-025: rgba(0, 0, 0, 0.25);\n        --wui-color-gray-glass-030: rgba(0, 0, 0, 0.3);\n        --wui-color-gray-glass-060: rgba(0, 0, 0, 0.6);\n        --wui-color-gray-glass-080: rgba(0, 0, 0, 0.8);\n        --wui-color-gray-glass-090: rgba(0, 0, 0, 0.9);\n      }\n    "
    ]);
    $f45fd6481fd2b016$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $f45fd6481fd2b016$var$_templateObject3() {
    var data = (0, $j06k0._)([
        "\n  *,\n  *::after,\n  *::before,\n  :host {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    font-style: normal;\n    text-rendering: optimizeSpeed;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-tap-highlight-color: transparent;\n    font-family: var(--wui-font-family);\n    backface-visibility: hidden;\n  }\n"
    ]);
    $f45fd6481fd2b016$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $f45fd6481fd2b016$var$_templateObject4() {
    var data = (0, $j06k0._)([
        "\n  button,\n  a {\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    transition:\n      color var(--wui-duration-lg) var(--wui-ease-out-power-1),\n      background-color var(--wui-duration-lg) var(--wui-ease-out-power-1),\n      border var(--wui-duration-lg) var(--wui-ease-out-power-1),\n      box-shadow var(--wui-duration-lg) var(--wui-ease-out-power-1);\n    will-change: background-color, color, border, box-shadow;\n    outline: none;\n    border: none;\n    column-gap: var(--wui-spacing-3xs);\n    background-color: transparent;\n    text-decoration: none;\n  }\n\n  button:disabled > wui-wallet-image,\n  button:disabled > wui-all-wallets-image,\n  button:disabled > wui-network-image,\n  button:disabled > wui-image,\n  button:disabled > wui-transaction-visual,\n  button:disabled > wui-logo {\n    filter: grayscale(1);\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    button:hover:enabled {\n      background-color: var(--wui-color-gray-glass-005);\n    }\n\n    button:active:enabled {\n      background-color: var(--wui-color-gray-glass-010);\n    }\n  }\n\n  button:disabled > wui-icon-box {\n    opacity: 0.5;\n  }\n\n  input {\n    border: none;\n    outline: none;\n    appearance: none;\n  }\n"
    ]);
    $f45fd6481fd2b016$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $f45fd6481fd2b016$var$_templateObject5() {
    var data = (0, $j06k0._)([
        "\n  .wui-color-inherit {\n    color: var(--wui-color-inherit);\n  }\n\n  .wui-color-accent-100 {\n    color: var(--wui-color-accent-100);\n  }\n\n  .wui-color-error-100 {\n    color: var(--wui-color-error-100);\n  }\n\n  .wui-color-success-100 {\n    color: var(--wui-color-success-100);\n  }\n\n  .wui-color-inverse-100 {\n    color: var(--wui-color-inverse-100);\n  }\n\n  .wui-color-inverse-000 {\n    color: var(--wui-color-inverse-000);\n  }\n\n  .wui-color-fg-100 {\n    color: var(--wui-color-fg-100);\n  }\n\n  .wui-color-fg-200 {\n    color: var(--wui-color-fg-200);\n  }\n\n  .wui-color-fg-300 {\n    color: var(--wui-color-fg-300);\n  }\n\n  .wui-bg-color-inherit {\n    background-color: var(--wui-color-inherit);\n  }\n\n  .wui-bg-color-blue-100 {\n    background-color: var(--wui-color-accent-100);\n  }\n\n  .wui-bg-color-error-100 {\n    background-color: var(--wui-color-error-100);\n  }\n\n  .wui-bg-color-success-100 {\n    background-color: var(--wui-color-success-100);\n  }\n\n  .wui-bg-color-inverse-100 {\n    background-color: var(--wui-color-inverse-100);\n  }\n\n  .wui-bg-color-inverse-000 {\n    background-color: var(--wui-color-inverse-000);\n  }\n\n  .wui-bg-color-fg-100 {\n    background-color: var(--wui-color-fg-100);\n  }\n\n  .wui-bg-color-fg-200 {\n    background-color: var(--wui-color-fg-200);\n  }\n\n  .wui-bg-color-fg-300 {\n    background-color: var(--wui-color-fg-300);\n  }\n"
    ]);
    $f45fd6481fd2b016$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
var $f45fd6481fd2b016$var$themeTag = undefined;
var $f45fd6481fd2b016$var$darkModeTag = undefined;
var $f45fd6481fd2b016$var$lightModeTag = undefined;
function $f45fd6481fd2b016$export$8ee9916a43f985de(themeVariables, themeMode) {
    $f45fd6481fd2b016$var$themeTag = document.createElement("style");
    $f45fd6481fd2b016$var$darkModeTag = document.createElement("style");
    $f45fd6481fd2b016$var$lightModeTag = document.createElement("style");
    $f45fd6481fd2b016$var$themeTag.textContent = $f45fd6481fd2b016$var$createRootStyles(themeVariables).core.cssText;
    $f45fd6481fd2b016$var$darkModeTag.textContent = $f45fd6481fd2b016$var$createRootStyles(themeVariables).dark.cssText;
    $f45fd6481fd2b016$var$lightModeTag.textContent = $f45fd6481fd2b016$var$createRootStyles(themeVariables).light.cssText;
    document.head.appendChild($f45fd6481fd2b016$var$themeTag);
    document.head.appendChild($f45fd6481fd2b016$var$darkModeTag);
    document.head.appendChild($f45fd6481fd2b016$var$lightModeTag);
    $f45fd6481fd2b016$export$718db041b82c5d23(themeMode);
}
function $f45fd6481fd2b016$export$718db041b82c5d23(themeMode) {
    if ($f45fd6481fd2b016$var$darkModeTag && $f45fd6481fd2b016$var$lightModeTag) {
        if (themeMode === "light") {
            $f45fd6481fd2b016$var$darkModeTag.removeAttribute("media");
            $f45fd6481fd2b016$var$lightModeTag.media = "enabled";
        } else {
            $f45fd6481fd2b016$var$lightModeTag.removeAttribute("media");
            $f45fd6481fd2b016$var$darkModeTag.media = "enabled";
        }
    }
}
function $f45fd6481fd2b016$export$b6ed091aa8078e9b(themeVariables) {
    if ($f45fd6481fd2b016$var$themeTag && $f45fd6481fd2b016$var$darkModeTag && $f45fd6481fd2b016$var$lightModeTag) {
        $f45fd6481fd2b016$var$themeTag.textContent = $f45fd6481fd2b016$var$createRootStyles(themeVariables).core.cssText;
        $f45fd6481fd2b016$var$darkModeTag.textContent = $f45fd6481fd2b016$var$createRootStyles(themeVariables).dark.cssText;
        $f45fd6481fd2b016$var$lightModeTag.textContent = $f45fd6481fd2b016$var$createRootStyles(themeVariables).light.cssText;
    }
}
function $f45fd6481fd2b016$var$createRootStyles(themeVariables) {
    return {
        core: (0, $bBWVO.css)($f45fd6481fd2b016$var$_templateObject(), (0, $bBWVO.unsafeCSS)((themeVariables === null || themeVariables === void 0 ? void 0 : themeVariables["--w3m-color-mix-strength"]) ? "".concat(themeVariables["--w3m-color-mix-strength"], "%") : "0%"), (0, $bBWVO.unsafeCSS)((themeVariables === null || themeVariables === void 0 ? void 0 : themeVariables["--w3m-font-family"]) || "Inter, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;"), (0, $bBWVO.unsafeCSS)((themeVariables === null || themeVariables === void 0 ? void 0 : themeVariables["--w3m-font-size-master"]) || "10px"), (0, $bBWVO.unsafeCSS)((themeVariables === null || themeVariables === void 0 ? void 0 : themeVariables["--w3m-border-radius-master"]) || "4px"), (0, $bBWVO.unsafeCSS)((themeVariables === null || themeVariables === void 0 ? void 0 : themeVariables["--w3m-z-index"]) || 999)),
        light: (0, $bBWVO.css)($f45fd6481fd2b016$var$_templateObject1(), (0, $bBWVO.unsafeCSS)((themeVariables === null || themeVariables === void 0 ? void 0 : themeVariables["--w3m-color-mix"]) || "#fff"), (0, $bBWVO.unsafeCSS)((0, $cnADL.getW3mThemeVariables)(themeVariables, "dark")["--w3m-accent"]), (0, $bBWVO.unsafeCSS)((0, $cnADL.getW3mThemeVariables)(themeVariables, "dark")["--w3m-background"])),
        dark: (0, $bBWVO.css)($f45fd6481fd2b016$var$_templateObject2(), (0, $bBWVO.unsafeCSS)((themeVariables === null || themeVariables === void 0 ? void 0 : themeVariables["--w3m-color-mix"]) || "#000"), (0, $bBWVO.unsafeCSS)((0, $cnADL.getW3mThemeVariables)(themeVariables, "light")["--w3m-accent"]), (0, $bBWVO.unsafeCSS)((0, $cnADL.getW3mThemeVariables)(themeVariables, "light")["--w3m-background"]))
    };
}
var $f45fd6481fd2b016$export$6b6f359a824920a4 = (0, $bBWVO.css)($f45fd6481fd2b016$var$_templateObject3());
var $f45fd6481fd2b016$export$e7ba49a1dbca65c7 = (0, $bBWVO.css)($f45fd6481fd2b016$var$_templateObject4());
var $f45fd6481fd2b016$export$ab44001f5690ee9c = (0, $bBWVO.css)($f45fd6481fd2b016$var$_templateObject5());

});

parcelRegister("hdxb6", function(module, exports) {

$parcel$export(module.exports, "customElement", function () { return $c88d630de2180233$export$da64fc29f17f9d0e; });
function $c88d630de2180233$var$standardCustomElement(tagName, descriptor) {
    var kind = descriptor.kind, elements = descriptor.elements;
    return {
        kind: kind,
        elements: elements,
        finisher: function(clazz) {
            if (!customElements.get(tagName)) customElements.define(tagName, clazz);
        }
    };
}
function $c88d630de2180233$var$legacyCustomElement(tagName, clazz) {
    if (!customElements.get(tagName)) customElements.define(tagName, clazz);
    return clazz;
}
function $c88d630de2180233$export$da64fc29f17f9d0e(tagName) {
    return function create(classOrDescriptor) {
        return typeof classOrDescriptor === "function" ? $c88d630de2180233$var$legacyCustomElement(tagName, classOrDescriptor) : $c88d630de2180233$var$standardCustomElement(tagName, classOrDescriptor);
    };
}

});

parcelRegister("amxoh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78b5dc1d3f816845$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $78b5dc1d3f816845$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: block;\n    border-radius: clamp(0px, var(--wui-border-radius-l), 44px);\n    box-shadow: 0 0 0 1px var(--wui-color-gray-glass-005);\n    background-color: var(--wui-color-modal-bg);\n    overflow: hidden;\n  }\n"
    ]);
    $78b5dc1d3f816845$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $78b5dc1d3f816845$export$2e2bcd8739ae039 = (0, $bBWVO.css)($78b5dc1d3f816845$var$_templateObject());

});


parcelRegister("dcd5U", function(module, exports) {

$parcel$export(module.exports, "WuiIcon", function () { return $99b68d970d292f71$export$10b8e15b42b9fa26; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $dLhDB = parcelRequire("dLhDB");

var $gKPni = parcelRequire("gKPni");

var $3WbDy = parcelRequire("3WbDy");

var $9UBkl = parcelRequire("9UBkl");

var $7DnYQ = parcelRequire("7DnYQ");

var $doLsL = parcelRequire("doLsL");

var $87dpD = parcelRequire("87dpD");

var $2FK32 = parcelRequire("2FK32");

var $bOots = parcelRequire("bOots");

var $gEVRw = parcelRequire("gEVRw");

var $7M87H = parcelRequire("7M87H");

var $bESuL = parcelRequire("bESuL");

var $luRPT = parcelRequire("luRPT");

var $cOmWE = parcelRequire("cOmWE");

var $Hxmg5 = parcelRequire("Hxmg5");

var $4lvSo = parcelRequire("4lvSo");

var $aa7CQ = parcelRequire("aa7CQ");

var $laf3a = parcelRequire("laf3a");

var $6HT7J = parcelRequire("6HT7J");

var $gdBWS = parcelRequire("gdBWS");

var $iQsBQ = parcelRequire("iQsBQ");

var $lA5vd = parcelRequire("lA5vd");

var $jhW9a = parcelRequire("jhW9a");

var $fALG7 = parcelRequire("fALG7");

var $8NLTJ = parcelRequire("8NLTJ");

var $egeuF = parcelRequire("egeuF");

var $7rAkP = parcelRequire("7rAkP");

var $hHX0G = parcelRequire("hHX0G");

var $1Rvr6 = parcelRequire("1Rvr6");

var $204fY = parcelRequire("204fY");

var $4coNU = parcelRequire("4coNU");

var $3LZrt = parcelRequire("3LZrt");

var $6VYuj = parcelRequire("6VYuj");

var $gIx8W = parcelRequire("gIx8W");

var $ek7Pr = parcelRequire("ek7Pr");

var $gWT3N = parcelRequire("gWT3N");

var $kapCt = parcelRequire("kapCt");

var $hqHym = parcelRequire("hqHym");

var $6zr1F = parcelRequire("6zr1F");

var $asO9s = parcelRequire("asO9s");

var $2YD4y = parcelRequire("2YD4y");

var $yj3WF = parcelRequire("yj3WF");

var $efZ4g = parcelRequire("efZ4g");

var $7TZuR = parcelRequire("7TZuR");

var $5QOuv = parcelRequire("5QOuv");

var $adaOo = parcelRequire("adaOo");

var $6I6WF = parcelRequire("6I6WF");

var $8Y3HG = parcelRequire("8Y3HG");

var $ebZ5M = parcelRequire("ebZ5M");

var $3V2Xf = parcelRequire("3V2Xf");

var $7aDLM = parcelRequire("7aDLM");

var $cGKw0 = parcelRequire("cGKw0");

var $lNGeX = parcelRequire("lNGeX");

var $5issi = parcelRequire("5issi");

var $9Ilrn = parcelRequire("9Ilrn");

var $bSkD7 = parcelRequire("bSkD7");

var $jhVRd = parcelRequire("jhVRd");

var $8z4p1 = parcelRequire("8z4p1");

var $70FMn = parcelRequire("70FMn");

var $jTGoD = parcelRequire("jTGoD");

var $boCoS = parcelRequire("boCoS");

var $9TWlD = parcelRequire("9TWlD");

var $f8viN = parcelRequire("f8viN");

var $isReu = parcelRequire("isReu");

var $3jwXN = parcelRequire("3jwXN");

var $39yXv = parcelRequire("39yXv");

var $igpBp = parcelRequire("igpBp");

var $h1Dic = parcelRequire("h1Dic");

var $gHJcF = parcelRequire("gHJcF");

var $iZBOB = parcelRequire("iZBOB");

var $i8pSG = parcelRequire("i8pSG");

var $lOLVO = parcelRequire("lOLVO");
function $99b68d970d292f71$var$_templateObject() {
    var data = (0, $j06k0._)([
        "",
        ""
    ]);
    $99b68d970d292f71$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $99b68d970d292f71$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $99b68d970d292f71$var$svgOptions = {
    add: (0, $gKPni.addSvg),
    allWallets: (0, $3WbDy.allWalletsSvg),
    arrowBottomCircle: (0, $9UBkl.arrowBottomCircleSvg),
    appStore: (0, $7DnYQ.appStoreSvg),
    apple: (0, $doLsL.appleSvg),
    arrowBottom: (0, $87dpD.arrowBottomSvg),
    arrowLeft: (0, $2FK32.arrowLeftSvg),
    arrowRight: (0, $bOots.arrowRightSvg),
    arrowTop: (0, $gEVRw.arrowTopSvg),
    bank: (0, $7M87H.bankSvg),
    browser: (0, $bESuL.browserSvg),
    card: (0, $luRPT.cardSvg),
    checkmark: (0, $Hxmg5.checkmarkSvg),
    checkmarkBold: (0, $cOmWE.checkmarkBoldSvg),
    chevronBottom: (0, $4lvSo.chevronBottomSvg),
    chevronLeft: (0, $aa7CQ.chevronLeftSvg),
    chevronRight: (0, $laf3a.chevronRightSvg),
    chevronTop: (0, $6HT7J.chevronTopSvg),
    chromeStore: (0, $gdBWS.chromeStoreSvg),
    clock: (0, $iQsBQ.clockSvg),
    close: (0, $lA5vd.closeSvg),
    compass: (0, $fALG7.compassSvg),
    coinPlaceholder: (0, $jhW9a.coinPlaceholderSvg),
    copy: (0, $8NLTJ.copySvg),
    cursor: (0, $egeuF.cursorSvg),
    cursorTransparent: (0, $7rAkP.cursorTransparentSvg),
    desktop: (0, $hHX0G.desktopSvg),
    disconnect: (0, $1Rvr6.disconnectSvg),
    discord: (0, $204fY.discordSvg),
    etherscan: (0, $4coNU.etherscanSvg),
    extension: (0, $3LZrt.extensionSvg),
    externalLink: (0, $6VYuj.externalLinkSvg),
    facebook: (0, $gIx8W.facebookSvg),
    farcaster: (0, $ek7Pr.farcasterSvg),
    filters: (0, $gWT3N.filtersSvg),
    github: (0, $kapCt.githubSvg),
    google: (0, $hqHym.googleSvg),
    helpCircle: (0, $6zr1F.helpCircleSvg),
    image: (0, $asO9s.imageSvg),
    id: (0, $i8pSG.idSvg),
    infoCircle: (0, $2YD4y.infoCircleSvg),
    lightbulb: (0, $iZBOB.lightbulbSvg),
    mail: (0, $yj3WF.mailSvg),
    mobile: (0, $efZ4g.mobileSvg),
    more: (0, $7TZuR.moreSvg),
    networkPlaceholder: (0, $5QOuv.networkPlaceholderSvg),
    nftPlaceholder: (0, $adaOo.nftPlaceholderSvg),
    off: (0, $6I6WF.offSvg),
    playStore: (0, $8Y3HG.playStoreSvg),
    plus: (0, $ebZ5M.plusSvg),
    qrCode: (0, $3V2Xf.qrCodeIcon),
    recycleHorizontal: (0, $7aDLM.recycleHorizontalSvg),
    refresh: (0, $cGKw0.refreshSvg),
    search: (0, $lNGeX.searchSvg),
    send: (0, $5issi.sendSvg),
    swapHorizontal: (0, $9Ilrn.swapHorizontalSvg),
    swapHorizontalMedium: (0, $jhVRd.swapHorizontalMediumSvg),
    swapHorizontalBold: (0, $bSkD7.swapHorizontalBoldSvg),
    swapHorizontalRoundedBold: (0, $8z4p1.swapHorizontalRoundedBoldSvg),
    swapVertical: (0, $70FMn.swapVerticalSvg),
    telegram: (0, $jTGoD.telegramSvg),
    threeDots: (0, $boCoS.threeDotsSvg),
    twitch: (0, $9TWlD.twitchSvg),
    twitter: (0, $lOLVO.xSvg),
    twitterIcon: (0, $f8viN.twitterIconSvg),
    verify: (0, $isReu.verifySvg),
    verifyFilled: (0, $3jwXN.verifyFilledSvg),
    wallet: (0, $igpBp.walletSvg),
    walletConnect: (0, $h1Dic.walletConnectSvg),
    walletPlaceholder: (0, $39yXv.walletPlaceholderSvg),
    warningCircle: (0, $gHJcF.warningCircleSvg),
    x: (0, $lOLVO.xSvg)
};
var $99b68d970d292f71$export$10b8e15b42b9fa26 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiIcon, LitElement);
    var _super = (0, $ohfOJ._)(WuiIcon);
    function WuiIcon() {
        (0, $4GJKx._)(this, WuiIcon);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.size = "md";
        _this.name = "copy";
        _this.color = "fg-300";
        return _this;
    }
    (0, $1wc17._)(WuiIcon, [
        {
            key: "render",
            value: function render() {
                this.style.cssText = "\n      --local-color: ".concat("var(--wui-color-".concat(this.color, ");"), "\n      --local-width: ").concat("var(--wui-icon-size-".concat(this.size, ");"), "\n    ");
                return (0, $1lUIm.html)($99b68d970d292f71$var$_templateObject(), $99b68d970d292f71$var$svgOptions[this.name]);
            }
        }
    ]);
    return WuiIcon;
}((0, $eAsDt.LitElement));
$99b68d970d292f71$export$10b8e15b42b9fa26.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.colorStyles),
    (0, $dLhDB.default)
];
$99b68d970d292f71$var$__decorate([
    (0, $siQym.property)()
], $99b68d970d292f71$export$10b8e15b42b9fa26.prototype, "size", void 0);
$99b68d970d292f71$var$__decorate([
    (0, $siQym.property)()
], $99b68d970d292f71$export$10b8e15b42b9fa26.prototype, "name", void 0);
$99b68d970d292f71$var$__decorate([
    (0, $siQym.property)()
], $99b68d970d292f71$export$10b8e15b42b9fa26.prototype, "color", void 0);
$99b68d970d292f71$export$10b8e15b42b9fa26 = $99b68d970d292f71$var$__decorate([
    (0, $hdxb6.customElement)("wui-icon")
], $99b68d970d292f71$export$10b8e15b42b9fa26);

});
parcelRegister("i1j9A", function(module, exports) {
$parcel$export(module.exports, "property", function () { return (parcelRequire("siQym")).property; });
$parcel$export(module.exports, "state", function () { return (parcelRequire("6DAI1")).state; });
parcelRequire("RzdCB");
parcelRequire("siQym");
parcelRequire("6DAI1");
parcelRequire("iawiI");
parcelRequire("9k87X");
parcelRequire("8WIZJ");
parcelRequire("j2fwX");
parcelRequire("2mYxl");
parcelRequire("iFOZE");

});
parcelRegister("RzdCB", function(module, exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $0a10450d8bba0e52$export$da64fc29f17f9d0e = function(t) {
    return function(e, o) {
        void 0 !== o ? o.addInitializer(function() {
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };
};

});

parcelRegister("siQym", function(module, exports) {

$parcel$export(module.exports, "property", function () { return $05513c304861e18a$export$d541bacb2bda4494; });

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $ce9xl = parcelRequire("ce9xl");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $05513c304861e18a$var$o = {
    attribute: !0,
    type: String,
    converter: (0, $ce9xl.defaultConverter),
    reflect: !1,
    hasChanged: (0, $ce9xl.notEqual)
}, $05513c304861e18a$export$8d623b1670eb40f4 = function() {
    var _$t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $05513c304861e18a$var$o, _$e = arguments.length > 1 ? arguments[1] : void 0, r = arguments.length > 2 ? arguments[2] : void 0;
    var n = r.kind, i = r.metadata;
    var s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), s.set(r.name, _$t), "accessor" === n) {
        var o1 = r.name;
        return {
            set: function(r) {
                var n = _$e.get.call(this);
                _$e.set.call(this, r), this.requestUpdate(o1, n, _$t);
            },
            init: function(e) {
                return void 0 !== e && this.P(o1, void 0, _$t), e;
            }
        };
    }
    if ("setter" === n) {
        var o2 = r.name;
        return function r(r) {
            var n = this[o2];
            _$e.call(this, r), this.requestUpdate(o2, n, _$t);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function $05513c304861e18a$export$d541bacb2bda4494(t) {
    return function(e, o) {
        return "object" == typeof o ? $05513c304861e18a$export$8d623b1670eb40f4(t, e, o) : function(t, e, o) {
            var r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, r ? (0, $cxjpp._)((0, $do9pw._)({}, t), {
                wrapped: !0
            }) : t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        }(t, e, o);
    };
}

});

parcelRegister("6DAI1", function(module, exports) {

$parcel$export(module.exports, "state", function () { return $4d52dc42ae475529$export$ca000e230c0caa3e; });

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $siQym = parcelRequire("siQym");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $4d52dc42ae475529$export$ca000e230c0caa3e(r) {
    return (0, $siQym.property)((0, $cxjpp._)((0, $do9pw._)({}, r), {
        state: !0,
        attribute: !1
    }));
}

});

parcelRegister("iawiI", function(module, exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $d3a237746ae741b0$export$b2b799818fbabcf3(t) {
    return function(n, o) {
        var c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}

});

parcelRegister("9k87X", function(module, exports) {

var $9bEXq = parcelRequire("9bEXq");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $6c9c4937a0c0e486$export$2fa187e846a241c4(e, r) {
    return function(n, s, i) {
        var o = function(t) {
            var _t_renderRoot;
            var _t_renderRoot_querySelector;
            return (_t_renderRoot_querySelector = (_t_renderRoot = t.renderRoot) === null || _t_renderRoot === void 0 ? void 0 : _t_renderRoot.querySelector(e)) !== null && _t_renderRoot_querySelector !== void 0 ? _t_renderRoot_querySelector : null;
        };
        if (r) {
            var _ref = "object" == typeof s ? n : i !== null && i !== void 0 ? i : function() {
                var _$t = Symbol();
                return {
                    get: function() {
                        return this[_$t];
                    },
                    set: function(e) {
                        this[_$t] = e;
                    }
                };
            }(), e1 = _ref.get, _$r = _ref.set;
            return (0, $9bEXq.desc)(n, s, {
                get: function() {
                    var _$t = e1.call(this);
                    return void 0 === _$t && (_$t = o(this), (null !== _$t || this.hasUpdated) && _$r.call(this, _$t)), _$t;
                }
            });
        }
        return (0, $9bEXq.desc)(n, s, {
            get: function() {
                return o(this);
            }
        });
    };
}

});
parcelRegister("9bEXq", function(module, exports) {

$parcel$export(module.exports, "desc", function () { return $6b04e97590565bf3$export$51987bb50e1f6752; });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $6b04e97590565bf3$export$51987bb50e1f6752 = function(e, t, c) {
    return c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c;
};

});


parcelRegister("8WIZJ", function(module, exports) {

var $9bEXq = parcelRequire("9bEXq");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $6836a47f7b4c9044$var$e;
function $6836a47f7b4c9044$export$dcd0d083aa86c355(r) {
    return function(n, o) {
        return (0, $9bEXq.desc)(n, o, {
            get: function() {
                var _this_renderRoot;
                return ((_this_renderRoot = this.renderRoot) !== null && _this_renderRoot !== void 0 ? _this_renderRoot : $6836a47f7b4c9044$var$e !== null && $6836a47f7b4c9044$var$e !== void 0 ? $6836a47f7b4c9044$var$e : $6836a47f7b4c9044$var$e = document.createDocumentFragment()).querySelectorAll(r);
            }
        });
    };
}

});

parcelRegister("j2fwX", function(module, exports) {

var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $9bEXq = parcelRequire("9bEXq");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $ddba4043463b07a4$export$163dfc35cc43f240(r) {
    return function(n, e) {
        return (0, $9bEXq.desc)(n, e, {
            get: function() {
                return (0, $kSuI9._)(function() {
                    var _this_renderRoot, _this_renderRoot_querySelector;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.updateComplete
                                ];
                            case 1:
                                return [
                                    2,
                                    (_state.sent(), (_this_renderRoot_querySelector = (_this_renderRoot = this.renderRoot) === null || _this_renderRoot === void 0 ? void 0 : _this_renderRoot.querySelector(r)) !== null && _this_renderRoot_querySelector !== void 0 ? _this_renderRoot_querySelector : null)
                                ];
                        }
                    });
                }).apply(this);
            }
        });
    };
}

});

parcelRegister("2mYxl", function(module, exports) {

var $9bEXq = parcelRequire("9bEXq");
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $1b9c9833f4607f5b$export$4682af2d9ee91415(o) {
    return function(e, n) {
        var _ref = o !== null && o !== void 0 ? o : {}, r = _ref.slot, s = _ref.selector, c = "slot" + (r ? "[name=".concat(r, "]") : ":not([name])");
        return (0, $9bEXq.desc)(e, n, {
            get: function() {
                var _this_renderRoot;
                var _t_assignedElements;
                var _$t = (_this_renderRoot = this.renderRoot) === null || _this_renderRoot === void 0 ? void 0 : _this_renderRoot.querySelector(c), _$e = (_t_assignedElements = _$t === null || _$t === void 0 ? void 0 : _$t.assignedElements(o)) !== null && _t_assignedElements !== void 0 ? _t_assignedElements : [];
                return void 0 === s ? _$e : _$e.filter(function(t) {
                    return t.matches(s);
                });
            }
        });
    };
}

});

parcelRegister("iFOZE", function(module, exports) {

var $9bEXq = parcelRequire("9bEXq");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $d9839c8f532432c9$export$1bdbe53f9df1b8(n) {
    return function(o, r) {
        var _ref = n !== null && n !== void 0 ? n : {}, e = _ref.slot, s = "slot" + (e ? "[name=".concat(e, "]") : ":not([name])");
        return (0, $9bEXq.desc)(o, r, {
            get: function() {
                var _this_renderRoot;
                var _$t = (_this_renderRoot = this.renderRoot) === null || _this_renderRoot === void 0 ? void 0 : _this_renderRoot.querySelector(s);
                var _t_assignedNodes;
                return (_t_assignedNodes = _$t === null || _$t === void 0 ? void 0 : _$t.assignedNodes(n)) !== null && _t_assignedNodes !== void 0 ? _t_assignedNodes : [];
            }
        });
    };
}

});


parcelRegister("dLhDB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a04d58a2a3e34b81$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $a04d58a2a3e34b81$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: flex;\n    aspect-ratio: 1 / 1;\n    color: var(--local-color);\n    width: var(--local-width);\n  }\n\n  svg {\n    width: inherit;\n    height: inherit;\n    object-fit: contain;\n    object-position: center;\n  }\n"
    ]);
    $a04d58a2a3e34b81$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $a04d58a2a3e34b81$export$2e2bcd8739ae039 = (0, $bBWVO.css)($a04d58a2a3e34b81$var$_templateObject());

});

parcelRegister("gKPni", function(module, exports) {

$parcel$export(module.exports, "addSvg", function () { return $c328cb2bd2a6816b$export$ca7db417ce6a3550; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $c328cb2bd2a6816b$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg\n  width="14"\n  height="14"\n  viewBox="0 0 14 14"\n  fill="none"\n  xmlns="http://www.w3.org/2000/svg"\n>\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M7.0023 0.875C7.48571 0.875 7.8776 1.26675 7.8776 1.75V6.125H12.2541C12.7375 6.125 13.1294 6.51675 13.1294 7C13.1294 7.48325 12.7375 7.875 12.2541 7.875H7.8776V12.25C7.8776 12.7332 7.48571 13.125 7.0023 13.125C6.51889 13.125 6.12701 12.7332 6.12701 12.25V7.875H1.75054C1.26713 7.875 0.875244 7.48325 0.875244 7C0.875244 6.51675 1.26713 6.125 1.75054 6.125H6.12701V1.75C6.12701 1.26675 6.51889 0.875 7.0023 0.875Z"\n    fill="#667dff"\n  /></svg\n>'
    ]);
    $c328cb2bd2a6816b$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $c328cb2bd2a6816b$export$ca7db417ce6a3550 = (0, $1lUIm.svg)($c328cb2bd2a6816b$var$_templateObject());

});

parcelRegister("3WbDy", function(module, exports) {

$parcel$export(module.exports, "allWalletsSvg", function () { return $2ddfd0bfab7e8804$export$7d5fd172cc1c231a; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $2ddfd0bfab7e8804$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 24 24">\n  <path\n    style="fill: var(--wui-color-accent-100);"\n    d="M10.2 6.6a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0ZM21 6.6a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0ZM10.2 17.4a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0ZM21 17.4a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0Z"\n  />\n</svg>'
    ]);
    $2ddfd0bfab7e8804$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $2ddfd0bfab7e8804$export$7d5fd172cc1c231a = (0, $1lUIm.svg)($2ddfd0bfab7e8804$var$_templateObject());

});

parcelRegister("9UBkl", function(module, exports) {

$parcel$export(module.exports, "arrowBottomCircleSvg", function () { return $73764c66ded6e859$export$33eab3b897a3adc1; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $73764c66ded6e859$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg\n  fill="none"\n  viewBox="0 0 21 20"\n>\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M10.5 2.42908C6.31875 2.42908 2.92859 5.81989 2.92859 10.0034C2.92859 14.1869 6.31875 17.5777 10.5 17.5777C14.6813 17.5777 18.0714 14.1869 18.0714 10.0034C18.0714 5.81989 14.6813 2.42908 10.5 2.42908ZM0.928589 10.0034C0.928589 4.71596 5.21355 0.429077 10.5 0.429077C15.7865 0.429077 20.0714 4.71596 20.0714 10.0034C20.0714 15.2908 15.7865 19.5777 10.5 19.5777C5.21355 19.5777 0.928589 15.2908 0.928589 10.0034ZM10.5 5.75003C11.0523 5.75003 11.5 6.19774 11.5 6.75003L11.5 10.8343L12.7929 9.54137C13.1834 9.15085 13.8166 9.15085 14.2071 9.54137C14.5976 9.9319 14.5976 10.5651 14.2071 10.9556L11.2071 13.9556C10.8166 14.3461 10.1834 14.3461 9.79291 13.9556L6.79291 10.9556C6.40239 10.5651 6.40239 9.9319 6.79291 9.54137C7.18343 9.15085 7.8166 9.15085 8.20712 9.54137L9.50002 10.8343L9.50002 6.75003C9.50002 6.19774 9.94773 5.75003 10.5 5.75003Z"\n    clip-rule="evenodd"\n  /></svg\n>'
    ]);
    $73764c66ded6e859$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $73764c66ded6e859$export$33eab3b897a3adc1 = (0, $1lUIm.svg)($73764c66ded6e859$var$_templateObject());

});

parcelRegister("7DnYQ", function(module, exports) {

$parcel$export(module.exports, "appStoreSvg", function () { return $58eec6ea24f47890$export$bda99385bd09fbb7; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $58eec6ea24f47890$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n<svg width="36" height="36">\n  <path\n    d="M28.724 0H7.271A7.269 7.269 0 0 0 0 7.272v21.46A7.268 7.268 0 0 0 7.271 36H28.73A7.272 7.272 0 0 0 36 28.728V7.272A7.275 7.275 0 0 0 28.724 0Z"\n    fill="url(#a)"\n  />\n  <path\n    d="m17.845 8.271.729-1.26a1.64 1.64 0 1 1 2.843 1.638l-7.023 12.159h5.08c1.646 0 2.569 1.935 1.853 3.276H6.434a1.632 1.632 0 0 1-1.638-1.638c0-.909.73-1.638 1.638-1.638h4.176l5.345-9.265-1.67-2.898a1.642 1.642 0 0 1 2.844-1.638l.716 1.264Zm-6.317 17.5-1.575 2.732a1.64 1.64 0 1 1-2.844-1.638l1.17-2.025c1.323-.41 2.398-.095 3.249.931Zm13.56-4.954h4.262c.909 0 1.638.729 1.638 1.638 0 .909-.73 1.638-1.638 1.638h-2.367l1.597 2.772c.45.788.185 1.782-.602 2.241a1.642 1.642 0 0 1-2.241-.603c-2.69-4.666-4.711-8.159-6.052-10.485-1.372-2.367-.391-4.743.576-5.549 1.075 1.846 2.682 4.631 4.828 8.348Z"\n    fill="#fff"\n  />\n  <defs>\n    <linearGradient id="a" x1="18" y1="0" x2="18" y2="36" gradientUnits="userSpaceOnUse">\n      <stop stop-color="#18BFFB" />\n      <stop offset="1" stop-color="#2072F3" />\n    </linearGradient>\n  </defs>\n</svg>'
    ]);
    $58eec6ea24f47890$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $58eec6ea24f47890$export$bda99385bd09fbb7 = (0, $1lUIm.svg)($58eec6ea24f47890$var$_templateObject());

});

parcelRegister("doLsL", function(module, exports) {

$parcel$export(module.exports, "appleSvg", function () { return $9c12556749ff441d$export$3f5c85d1c093200; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $9c12556749ff441d$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 40 40">\n  <g clip-path="url(#a)">\n    <g clip-path="url(#b)">\n      <circle cx="20" cy="19.89" r="20" fill="#000" />\n      <g clip-path="url(#c)">\n        <path\n          fill="#fff"\n          d="M28.77 23.3c-.69 1.99-2.75 5.52-4.87 5.56-1.4.03-1.86-.84-3.46-.84-1.61 0-2.12.81-3.45.86-2.25.1-5.72-5.1-5.72-9.62 0-4.15 2.9-6.2 5.42-6.25 1.36-.02 2.64.92 3.47.92.83 0 2.38-1.13 4.02-.97.68.03 2.6.28 3.84 2.08-3.27 2.14-2.76 6.61.75 8.25ZM24.2 7.88c-2.47.1-4.49 2.69-4.2 4.84 2.28.17 4.47-2.39 4.2-4.84Z"\n        />\n      </g>\n    </g>\n  </g>\n  <defs>\n    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>\n    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>\n    <clipPath id="c"><path fill="#fff" d="M8 7.89h24v24H8z" /></clipPath>\n  </defs>\n</svg>'
    ]);
    $9c12556749ff441d$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $9c12556749ff441d$export$3f5c85d1c093200 = (0, $1lUIm.svg)($9c12556749ff441d$var$_templateObject());

});

parcelRegister("87dpD", function(module, exports) {

$parcel$export(module.exports, "arrowBottomSvg", function () { return $5e89619a0e16726d$export$6f382756ddebc10; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $5e89619a0e16726d$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 14 15">\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M7 1.99a1 1 0 0 1 1 1v7.58l2.46-2.46a1 1 0 0 1 1.41 1.42L7.7 13.69a1 1 0 0 1-1.41 0L2.12 9.53A1 1 0 0 1 3.54 8.1L6 10.57V3a1 1 0 0 1 1-1Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $5e89619a0e16726d$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $5e89619a0e16726d$export$6f382756ddebc10 = (0, $1lUIm.svg)($5e89619a0e16726d$var$_templateObject());

});

parcelRegister("2FK32", function(module, exports) {

$parcel$export(module.exports, "arrowLeftSvg", function () { return $1f2321416c7108d5$export$539cc194b4601565; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $1f2321416c7108d5$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 14 15">\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M13 7.99a1 1 0 0 1-1 1H4.4l2.46 2.46a1 1 0 1 1-1.41 1.41L1.29 8.7a1 1 0 0 1 0-1.41L5.46 3.1a1 1 0 0 1 1.41 1.42L4.41 6.99H12a1 1 0 0 1 1 1Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $1f2321416c7108d5$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $1f2321416c7108d5$export$539cc194b4601565 = (0, $1lUIm.svg)($1f2321416c7108d5$var$_templateObject());

});

parcelRegister("bOots", function(module, exports) {

$parcel$export(module.exports, "arrowRightSvg", function () { return $89975945ec4d4220$export$8c76deeccbfa0068; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $89975945ec4d4220$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 14 15">\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M1 7.99a1 1 0 0 1 1-1h7.58L7.12 4.53A1 1 0 1 1 8.54 3.1l4.16 4.17a1 1 0 0 1 0 1.41l-4.16 4.17a1 1 0 1 1-1.42-1.41l2.46-2.46H2a1 1 0 0 1-1-1Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $89975945ec4d4220$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $89975945ec4d4220$export$8c76deeccbfa0068 = (0, $1lUIm.svg)($89975945ec4d4220$var$_templateObject());

});

parcelRegister("gEVRw", function(module, exports) {

$parcel$export(module.exports, "arrowTopSvg", function () { return $c20d44041c224d87$export$2903aa7e1dab2e70; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $c20d44041c224d87$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 14 15">\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M7 13.99a1 1 0 0 1-1-1V5.4L3.54 7.86a1 1 0 0 1-1.42-1.41L6.3 2.28a1 1 0 0 1 1.41 0l4.17 4.17a1 1 0 1 1-1.41 1.41L8 5.4v7.59a1 1 0 0 1-1 1Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $c20d44041c224d87$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $c20d44041c224d87$export$2903aa7e1dab2e70 = (0, $1lUIm.svg)($c20d44041c224d87$var$_templateObject());

});

parcelRegister("7M87H", function(module, exports) {

$parcel$export(module.exports, "bankSvg", function () { return $5a93512f2755d37f$export$b7cc4752b6244394; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $5a93512f2755d37f$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  width="12"\n  height="13"\n  viewBox="0 0 12 13"\n  fill="none"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M5.61391 1.57124C5.85142 1.42873 6.14813 1.42873 6.38564 1.57124L11.0793 4.38749C11.9179 4.89067 11.5612 6.17864 10.5832 6.17864H9.96398V10.0358H10.2854C10.6996 10.0358 11.0354 10.3716 11.0354 10.7858C11.0354 11.2 10.6996 11.5358 10.2854 11.5358H1.71416C1.29995 11.5358 0.964172 11.2 0.964172 10.7858C0.964172 10.3716 1.29995 10.0358 1.71416 10.0358H2.03558L2.03558 6.17864H1.41637C0.438389 6.17864 0.0816547 4.89066 0.920263 4.38749L5.61391 1.57124ZM3.53554 6.17864V10.0358H5.24979V6.17864H3.53554ZM6.74976 6.17864V10.0358H8.46401V6.17864H6.74976ZM8.64913 4.67864H3.35043L5.99978 3.089L8.64913 4.67864Z"\n    fill="currentColor"\n  /></svg\n>'
    ]);
    $5a93512f2755d37f$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $5a93512f2755d37f$export$b7cc4752b6244394 = (0, $1lUIm.svg)($5a93512f2755d37f$var$_templateObject());

});

parcelRegister("bESuL", function(module, exports) {

$parcel$export(module.exports, "browserSvg", function () { return $87cdb3b97bde9596$export$9a659d11e13bcec5; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $87cdb3b97bde9596$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 20 20">\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M4 6.4a1 1 0 0 1-.46.89 6.98 6.98 0 0 0 .38 6.18A7 7 0 0 0 16.46 7.3a1 1 0 0 1-.47-.92 7 7 0 0 0-12 .03Zm-2.02-.5a9 9 0 1 1 16.03 8.2A9 9 0 0 1 1.98 5.9Z"\n    clip-rule="evenodd"\n  />\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M6.03 8.63c-1.46-.3-2.72-.75-3.6-1.35l-.02-.01-.14-.11a1 1 0 0 1 1.2-1.6l.1.08c.6.4 1.52.74 2.69 1 .16-.99.39-1.88.67-2.65.3-.79.68-1.5 1.15-2.02A2.58 2.58 0 0 1 9.99 1c.8 0 1.45.44 1.92.97.47.52.84 1.23 1.14 2.02.29.77.52 1.66.68 2.64a8 8 0 0 0 2.7-1l.26-.18h.48a1 1 0 0 1 .12 2c-.86.51-2.01.91-3.34 1.18a22.24 22.24 0 0 1-.03 3.19c1.45.29 2.7.73 3.58 1.31a1 1 0 0 1-1.1 1.68c-.6-.4-1.56-.76-2.75-1-.15.8-.36 1.55-.6 2.2-.3.79-.67 1.5-1.14 2.02-.47.53-1.12.97-1.92.97-.8 0-1.45-.44-1.91-.97a6.51 6.51 0 0 1-1.15-2.02c-.24-.65-.44-1.4-.6-2.2-1.18.24-2.13.6-2.73.99a1 1 0 1 1-1.1-1.67c.88-.58 2.12-1.03 3.57-1.31a22.03 22.03 0 0 1-.04-3.2Zm2.2-1.7c.15-.86.34-1.61.58-2.24.24-.65.51-1.12.76-1.4.25-.28.4-.29.42-.29.03 0 .17.01.42.3.25.27.52.74.77 1.4.23.62.43 1.37.57 2.22a19.96 19.96 0 0 1-3.52 0Zm-.18 4.6a20.1 20.1 0 0 1-.03-2.62 21.95 21.95 0 0 0 3.94 0 20.4 20.4 0 0 1-.03 2.63 21.97 21.97 0 0 0-3.88 0Zm.27 2c.13.66.3 1.26.49 1.78.24.65.51 1.12.76 1.4.25.28.4.29.42.29.03 0 .17-.01.42-.3.25-.27.52-.74.77-1.4.19-.5.36-1.1.49-1.78a20.03 20.03 0 0 0-3.35 0Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $87cdb3b97bde9596$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $87cdb3b97bde9596$export$9a659d11e13bcec5 = (0, $1lUIm.svg)($87cdb3b97bde9596$var$_templateObject());

});

parcelRegister("luRPT", function(module, exports) {

$parcel$export(module.exports, "cardSvg", function () { return $fa6629086903ac81$export$996b002521801861; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $fa6629086903ac81$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  width="12"\n  height="13"\n  viewBox="0 0 12 13"\n  fill="none"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M4.16072 2C4.17367 2 4.18665 2 4.19968 2L7.83857 2C8.36772 1.99998 8.82398 1.99996 9.19518 2.04018C9.5895 2.0829 9.97577 2.17811 10.3221 2.42971C10.5131 2.56849 10.6811 2.73647 10.8198 2.92749C11.0714 3.27379 11.1666 3.66007 11.2094 4.0544C11.2496 4.42561 11.2496 4.88188 11.2495 5.41105V7.58896C11.2496 8.11812 11.2496 8.57439 11.2094 8.94561C11.1666 9.33994 11.0714 9.72621 10.8198 10.0725C10.6811 10.2635 10.5131 10.4315 10.3221 10.5703C9.97577 10.8219 9.5895 10.9171 9.19518 10.9598C8.82398 11 8.36772 11 7.83856 11H4.16073C3.63157 11 3.17531 11 2.80411 10.9598C2.40979 10.9171 2.02352 10.8219 1.67722 10.5703C1.48621 10.4315 1.31824 10.2635 1.17946 10.0725C0.927858 9.72621 0.832652 9.33994 0.78993 8.94561C0.749713 8.5744 0.749733 8.11813 0.749757 7.58896L0.749758 5.45C0.749758 5.43697 0.749758 5.42399 0.749757 5.41104C0.749733 4.88188 0.749713 4.42561 0.78993 4.0544C0.832652 3.66007 0.927858 3.27379 1.17946 2.92749C1.31824 2.73647 1.48621 2.56849 1.67722 2.42971C2.02352 2.17811 2.40979 2.0829 2.80411 2.04018C3.17531 1.99996 3.63157 1.99998 4.16072 2ZM2.96567 3.53145C2.69897 3.56034 2.60687 3.60837 2.55888 3.64324C2.49521 3.6895 2.43922 3.74549 2.39296 3.80916C2.35809 3.85715 2.31007 3.94926 2.28117 4.21597C2.26629 4.35335 2.25844 4.51311 2.25431 4.70832H9.74498C9.74085 4.51311 9.733 4.35335 9.71812 4.21597C9.68922 3.94926 9.6412 3.85715 9.60633 3.80916C9.56007 3.74549 9.50408 3.6895 9.44041 3.64324C9.39242 3.60837 9.30031 3.56034 9.03362 3.53145C8.75288 3.50103 8.37876 3.5 7.79961 3.5H4.19968C3.62053 3.5 3.24641 3.50103 2.96567 3.53145ZM9.74956 6.20832H2.24973V7.55C2.24973 8.12917 2.25076 8.5033 2.28117 8.78404C2.31007 9.05074 2.35809 9.14285 2.39296 9.19084C2.43922 9.25451 2.49521 9.31051 2.55888 9.35677C2.60687 9.39163 2.69897 9.43966 2.96567 9.46856C3.24641 9.49897 3.62053 9.5 4.19968 9.5H7.79961C8.37876 9.5 8.75288 9.49897 9.03362 9.46856C9.30032 9.43966 9.39242 9.39163 9.44041 9.35677C9.50408 9.31051 9.56007 9.25451 9.60633 9.19084C9.6412 9.14285 9.68922 9.05075 9.71812 8.78404C9.74854 8.5033 9.74956 8.12917 9.74956 7.55V6.20832ZM6.74963 8C6.74963 7.58579 7.08541 7.25 7.49961 7.25H8.2496C8.6638 7.25 8.99958 7.58579 8.99958 8C8.99958 8.41422 8.6638 8.75 8.2496 8.75H7.49961C7.08541 8.75 6.74963 8.41422 6.74963 8Z"\n    fill="currentColor"\n  /></svg\n>'
    ]);
    $fa6629086903ac81$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $fa6629086903ac81$export$996b002521801861 = (0, $1lUIm.svg)($fa6629086903ac81$var$_templateObject());

});

parcelRegister("cOmWE", function(module, exports) {

$parcel$export(module.exports, "checkmarkBoldSvg", function () { return $953bf3f2387fa8dd$export$8110e67fa3d88854; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $953bf3f2387fa8dd$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 14 14">\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M12.9576 2.23383C13.3807 2.58873 13.4361 3.21947 13.0812 3.64263L6.37159 11.6426C6.19161 11.8572 5.92989 11.9865 5.65009 11.999C5.3703 12.0115 5.09808 11.9062 4.89965 11.7085L0.979321 7.80331C0.588042 7.41354 0.586817 6.78038 0.976585 6.3891C1.36635 5.99782 1.99952 5.99659 2.3908 6.38636L5.53928 9.52268L11.5488 2.35742C11.9037 1.93426 12.5344 1.87893 12.9576 2.23383Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $953bf3f2387fa8dd$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $953bf3f2387fa8dd$export$8110e67fa3d88854 = (0, $1lUIm.svg)($953bf3f2387fa8dd$var$_templateObject());

});

parcelRegister("Hxmg5", function(module, exports) {

$parcel$export(module.exports, "checkmarkSvg", function () { return $082de478d8beb117$export$1e994e99baa45d19; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $082de478d8beb117$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg\n  width="28"\n  height="28"\n  viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M25.5297 4.92733C26.1221 5.4242 26.1996 6.30724 25.7027 6.89966L12.2836 22.8997C12.0316 23.2001 11.6652 23.3811 11.2735 23.3986C10.8817 23.4161 10.5006 23.2686 10.2228 22.9919L2.38218 15.1815C1.83439 14.6358 1.83268 13.7494 2.37835 13.2016C2.92403 12.6538 3.81046 12.6521 4.35825 13.1978L11.1183 19.9317L23.5573 5.10036C24.0542 4.50794 24.9372 4.43047 25.5297 4.92733Z"\n    fill="#26D962"/>\n</svg>\n'
    ]);
    $082de478d8beb117$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $082de478d8beb117$export$1e994e99baa45d19 = (0, $1lUIm.svg)($082de478d8beb117$var$_templateObject());

});

parcelRegister("4lvSo", function(module, exports) {

$parcel$export(module.exports, "chevronBottomSvg", function () { return $32a1d9930a51adbe$export$515090d56df26148; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $32a1d9930a51adbe$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 16 16">\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M1.46 4.96a1 1 0 0 1 1.41 0L8 10.09l5.13-5.13a1 1 0 1 1 1.41 1.41l-5.83 5.84a1 1 0 0 1-1.42 0L1.46 6.37a1 1 0 0 1 0-1.41Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $32a1d9930a51adbe$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $32a1d9930a51adbe$export$515090d56df26148 = (0, $1lUIm.svg)($32a1d9930a51adbe$var$_templateObject());

});

parcelRegister("aa7CQ", function(module, exports) {

$parcel$export(module.exports, "chevronLeftSvg", function () { return $7660c0d89c19c3b2$export$dd4e32e981ac6b2; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $7660c0d89c19c3b2$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 16 16">\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M11.04 1.46a1 1 0 0 1 0 1.41L5.91 8l5.13 5.13a1 1 0 1 1-1.41 1.41L3.79 8.71a1 1 0 0 1 0-1.42l5.84-5.83a1 1 0 0 1 1.41 0Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $7660c0d89c19c3b2$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $7660c0d89c19c3b2$export$dd4e32e981ac6b2 = (0, $1lUIm.svg)($7660c0d89c19c3b2$var$_templateObject());

});

parcelRegister("laf3a", function(module, exports) {

$parcel$export(module.exports, "chevronRightSvg", function () { return $f68634ccd341ef43$export$79c9cf11f1aff07c; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $f68634ccd341ef43$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 16 16">\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M4.96 14.54a1 1 0 0 1 0-1.41L10.09 8 4.96 2.87a1 1 0 0 1 1.41-1.41l5.84 5.83a1 1 0 0 1 0 1.42l-5.84 5.83a1 1 0 0 1-1.41 0Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $f68634ccd341ef43$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $f68634ccd341ef43$export$79c9cf11f1aff07c = (0, $1lUIm.svg)($f68634ccd341ef43$var$_templateObject());

});

parcelRegister("6HT7J", function(module, exports) {

$parcel$export(module.exports, "chevronTopSvg", function () { return $4e2184a65636d5ff$export$95ea2c128f24f835; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $4e2184a65636d5ff$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 16 16">\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M14.54 11.04a1 1 0 0 1-1.41 0L8 5.92l-5.13 5.12a1 1 0 1 1-1.41-1.41l5.83-5.84a1 1 0 0 1 1.42 0l5.83 5.84a1 1 0 0 1 0 1.41Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $4e2184a65636d5ff$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $4e2184a65636d5ff$export$95ea2c128f24f835 = (0, $1lUIm.svg)($4e2184a65636d5ff$var$_templateObject());

});

parcelRegister("gdBWS", function(module, exports) {

$parcel$export(module.exports, "chromeStoreSvg", function () { return $bceb4c058ea57e56$export$a97c1f844e68ea51; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $bceb4c058ea57e56$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg width="36" height="36" fill="none">\n  <path\n    fill="#fff"\n    fill-opacity=".05"\n    d="M0 14.94c0-5.55 0-8.326 1.182-10.4a9 9 0 0 1 3.359-3.358C6.614 0 9.389 0 14.94 0h6.12c5.55 0 8.326 0 10.4 1.182a9 9 0 0 1 3.358 3.359C36 6.614 36 9.389 36 14.94v6.12c0 5.55 0 8.326-1.182 10.4a9 9 0 0 1-3.359 3.358C29.386 36 26.611 36 21.06 36h-6.12c-5.55 0-8.326 0-10.4-1.182a9 9 0 0 1-3.358-3.359C0 29.386 0 26.611 0 21.06v-6.12Z"\n  />\n  <path\n    stroke="#fff"\n    stroke-opacity=".05"\n    d="M14.94.5h6.12c2.785 0 4.84 0 6.46.146 1.612.144 2.743.43 3.691.97a8.5 8.5 0 0 1 3.172 3.173c.541.948.826 2.08.971 3.692.145 1.62.146 3.675.146 6.459v6.12c0 2.785 0 4.84-.146 6.46-.145 1.612-.43 2.743-.97 3.691a8.5 8.5 0 0 1-3.173 3.172c-.948.541-2.08.826-3.692.971-1.62.145-3.674.146-6.459.146h-6.12c-2.784 0-4.84 0-6.46-.146-1.612-.145-2.743-.43-3.691-.97a8.5 8.5 0 0 1-3.172-3.173c-.541-.948-.827-2.08-.971-3.692C.5 25.9.5 23.845.5 21.06v-6.12c0-2.784 0-4.84.146-6.46.144-1.612.43-2.743.97-3.691A8.5 8.5 0 0 1 4.79 1.617C5.737 1.076 6.869.79 8.48.646 10.1.5 12.156.5 14.94.5Z"\n  />\n  <path\n    fill="url(#a)"\n    d="M17.998 10.8h12.469a14.397 14.397 0 0 0-24.938.001l6.234 10.798.006-.001a7.19 7.19 0 0 1 6.23-10.799Z"\n  />\n  <path\n    fill="url(#b)"\n    d="m24.237 21.598-6.234 10.798A14.397 14.397 0 0 0 30.47 10.798H18.002l-.002.006a7.191 7.191 0 0 1 6.237 10.794Z"\n  />\n  <path\n    fill="url(#c)"\n    d="M11.765 21.601 5.531 10.803A14.396 14.396 0 0 0 18.001 32.4l6.235-10.798-.004-.004a7.19 7.19 0 0 1-12.466.004Z"\n  />\n  <path fill="#fff" d="M18 25.2a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4Z" />\n  <path fill="#1A73E8" d="M18 23.7a5.7 5.7 0 1 0 0-11.4 5.7 5.7 0 0 0 0 11.4Z" />\n  <defs>\n    <linearGradient\n      id="a"\n      x1="6.294"\n      x2="41.1"\n      y1="5.995"\n      y2="5.995"\n      gradientUnits="userSpaceOnUse"\n    >\n      <stop stop-color="#D93025" />\n      <stop offset="1" stop-color="#EA4335" />\n    </linearGradient>\n    <linearGradient\n      id="b"\n      x1="20.953"\n      x2="37.194"\n      y1="32.143"\n      y2="2.701"\n      gradientUnits="userSpaceOnUse"\n    >\n      <stop stop-color="#FCC934" />\n      <stop offset="1" stop-color="#FBBC04" />\n    </linearGradient>\n    <linearGradient\n      id="c"\n      x1="25.873"\n      x2="9.632"\n      y1="31.2"\n      y2="1.759"\n      gradientUnits="userSpaceOnUse"\n    >\n      <stop stop-color="#1E8E3E" />\n      <stop offset="1" stop-color="#34A853" />\n    </linearGradient>\n  </defs>\n</svg>'
    ]);
    $bceb4c058ea57e56$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $bceb4c058ea57e56$export$a97c1f844e68ea51 = (0, $1lUIm.svg)($bceb4c058ea57e56$var$_templateObject());

});

parcelRegister("iQsBQ", function(module, exports) {

$parcel$export(module.exports, "clockSvg", function () { return $db834687db39ff5d$export$36e96663783b415c; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $db834687db39ff5d$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg width="14" height="14" viewBox="0 0 14 14" fill="none">\n  <path \n    fill-rule="evenodd" \n    clip-rule="evenodd" \n    d="M7.00235 2C4.24 2 2.00067 4.23858 2.00067 7C2.00067 9.76142 4.24 12 7.00235 12C9.7647 12 12.004 9.76142 12.004 7C12.004 4.23858 9.7647 2 7.00235 2ZM0 7C0 3.13401 3.13506 0 7.00235 0C10.8696 0 14.0047 3.13401 14.0047 7C14.0047 10.866 10.8696 14 7.00235 14C3.13506 14 0 10.866 0 7ZM7.00235 3C7.55482 3 8.00269 3.44771 8.00269 4V6.58579L9.85327 8.43575C10.2439 8.82627 10.2439 9.45944 9.85327 9.84996C9.46262 10.2405 8.82924 10.2405 8.43858 9.84996L6.29501 7.70711C6.10741 7.51957 6.00201 7.26522 6.00201 7V4C6.00201 3.44771 6.44988 3 7.00235 3Z" \n    fill="currentColor"\n  />\n</svg>'
    ]);
    $db834687db39ff5d$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $db834687db39ff5d$export$36e96663783b415c = (0, $1lUIm.svg)($db834687db39ff5d$var$_templateObject());

});

parcelRegister("lA5vd", function(module, exports) {

$parcel$export(module.exports, "closeSvg", function () { return $fb613a6ddc406e81$export$e973b7b7b0b44400; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $fb613a6ddc406e81$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 16 16">\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M2.54 2.54a1 1 0 0 1 1.42 0L8 6.6l4.04-4.05a1 1 0 1 1 1.42 1.42L9.4 8l4.05 4.04a1 1 0 0 1-1.42 1.42L8 9.4l-4.04 4.05a1 1 0 0 1-1.42-1.42L6.6 8 2.54 3.96a1 1 0 0 1 0-1.42Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $fb613a6ddc406e81$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $fb613a6ddc406e81$export$e973b7b7b0b44400 = (0, $1lUIm.svg)($fb613a6ddc406e81$var$_templateObject());

});

parcelRegister("jhW9a", function(module, exports) {

$parcel$export(module.exports, "coinPlaceholderSvg", function () { return $e0acb5a200a718ee$export$c48cbfcb1f749517; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $e0acb5a200a718ee$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 20 20">\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M10 3a7 7 0 0 0-6.85 8.44l8.29-8.3C10.97 3.06 10.49 3 10 3Zm3.49.93-9.56 9.56c.32.55.71 1.06 1.16 1.5L15 5.1a7.03 7.03 0 0 0-1.5-1.16Zm2.7 2.8-9.46 9.46a7 7 0 0 0 9.46-9.46ZM1.99 5.9A9 9 0 1 1 18 14.09 9 9 0 0 1 1.98 5.91Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $e0acb5a200a718ee$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $e0acb5a200a718ee$export$c48cbfcb1f749517 = (0, $1lUIm.svg)($e0acb5a200a718ee$var$_templateObject());

});

parcelRegister("fALG7", function(module, exports) {

$parcel$export(module.exports, "compassSvg", function () { return $02edec307b99e6ed$export$9fe5dd11ac55c8d4; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $02edec307b99e6ed$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 16 16">\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2ZM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm10.66-2.65a1 1 0 0 1 .23 1.06L9.83 9.24a1 1 0 0 1-.59.58l-2.83 1.06A1 1 0 0 1 5.13 9.6l1.06-2.82a1 1 0 0 1 .58-.59L9.6 5.12a1 1 0 0 1 1.06.23ZM7.9 7.89l-.13.35.35-.13.12-.35-.34.13Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $02edec307b99e6ed$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $02edec307b99e6ed$export$9fe5dd11ac55c8d4 = (0, $1lUIm.svg)($02edec307b99e6ed$var$_templateObject());

});

parcelRegister("8NLTJ", function(module, exports) {

$parcel$export(module.exports, "copySvg", function () { return $66880dde818b6978$export$ec40c5c35ef5dd82; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $66880dde818b6978$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  width="16"\n  height="16"\n  viewBox="0 0 16 16"\n  fill="none"\n>\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M9.21498 1.28565H10.5944C11.1458 1.28562 11.6246 1.2856 12.0182 1.32093C12.4353 1.35836 12.853 1.44155 13.2486 1.66724C13.7005 1.92498 14.0749 2.29935 14.3326 2.75122C14.5583 3.14689 14.6415 3.56456 14.6789 3.9817C14.7143 4.37531 14.7142 4.85403 14.7142 5.40545V6.78489C14.7142 7.33631 14.7143 7.81503 14.6789 8.20865C14.6415 8.62578 14.5583 9.04345 14.3326 9.43912C14.0749 9.89099 13.7005 10.2654 13.2486 10.5231C12.853 10.7488 12.4353 10.832 12.0182 10.8694C11.7003 10.8979 11.3269 10.9034 10.9045 10.9045C10.9034 11.3269 10.8979 11.7003 10.8694 12.0182C10.832 12.4353 10.7488 12.853 10.5231 13.2486C10.2654 13.7005 9.89099 14.0749 9.43912 14.3326C9.04345 14.5583 8.62578 14.6415 8.20865 14.6789C7.81503 14.7143 7.33631 14.7142 6.78489 14.7142H5.40545C4.85403 14.7142 4.37531 14.7143 3.9817 14.6789C3.56456 14.6415 3.14689 14.5583 2.75122 14.3326C2.29935 14.0749 1.92498 13.7005 1.66724 13.2486C1.44155 12.853 1.35836 12.4353 1.32093 12.0182C1.2856 11.6246 1.28562 11.1458 1.28565 10.5944V9.21498C1.28562 8.66356 1.2856 8.18484 1.32093 7.79122C1.35836 7.37409 1.44155 6.95642 1.66724 6.56074C1.92498 6.10887 2.29935 5.73451 2.75122 5.47677C3.14689 5.25108 3.56456 5.16789 3.9817 5.13045C4.2996 5.10192 4.67301 5.09645 5.09541 5.09541C5.09645 4.67302 5.10192 4.2996 5.13045 3.9817C5.16789 3.56456 5.25108 3.14689 5.47676 2.75122C5.73451 2.29935 6.10887 1.92498 6.56074 1.66724C6.95642 1.44155 7.37409 1.35836 7.79122 1.32093C8.18484 1.2856 8.66356 1.28562 9.21498 1.28565ZM5.09541 7.09552C4.68397 7.09667 4.39263 7.10161 4.16046 7.12245C3.88053 7.14757 3.78516 7.18949 3.74214 7.21403C3.60139 7.29431 3.48478 7.41091 3.4045 7.55166C3.37997 7.59468 3.33804 7.69005 3.31292 7.96999C3.28659 8.26345 3.28565 8.65147 3.28565 9.25708V10.5523C3.28565 11.1579 3.28659 11.5459 3.31292 11.8394C3.33804 12.1193 3.37997 12.2147 3.4045 12.2577C3.48478 12.3985 3.60139 12.5151 3.74214 12.5954C3.78516 12.6199 3.88053 12.6618 4.16046 12.6869C4.45393 12.7133 4.84195 12.7142 5.44755 12.7142H6.74279C7.3484 12.7142 7.73641 12.7133 8.02988 12.6869C8.30981 12.6618 8.40518 12.6199 8.44821 12.5954C8.58895 12.5151 8.70556 12.3985 8.78584 12.2577C8.81038 12.2147 8.8523 12.1193 8.87742 11.8394C8.89825 11.6072 8.90319 11.3159 8.90435 10.9045C8.48219 10.9034 8.10898 10.8979 7.79122 10.8694C7.37409 10.832 6.95641 10.7488 6.56074 10.5231C6.10887 10.2654 5.73451 9.89099 5.47676 9.43912C5.25108 9.04345 5.16789 8.62578 5.13045 8.20865C5.10194 7.89089 5.09645 7.51767 5.09541 7.09552ZM7.96999 3.31292C7.69005 3.33804 7.59468 3.37997 7.55166 3.4045C7.41091 3.48478 7.29431 3.60139 7.21403 3.74214C7.18949 3.78516 7.14757 3.88053 7.12245 4.16046C7.09611 4.45393 7.09517 4.84195 7.09517 5.44755V6.74279C7.09517 7.3484 7.09611 7.73641 7.12245 8.02988C7.14757 8.30981 7.18949 8.40518 7.21403 8.4482C7.29431 8.58895 7.41091 8.70556 7.55166 8.78584C7.59468 8.81038 7.69005 8.8523 7.96999 8.87742C8.26345 8.90376 8.65147 8.9047 9.25708 8.9047H10.5523C11.1579 8.9047 11.5459 8.90376 11.8394 8.87742C12.1193 8.8523 12.2147 8.81038 12.2577 8.78584C12.3985 8.70556 12.5151 8.58895 12.5954 8.4482C12.6199 8.40518 12.6618 8.30981 12.6869 8.02988C12.7133 7.73641 12.7142 7.3484 12.7142 6.74279V5.44755C12.7142 4.84195 12.7133 4.45393 12.6869 4.16046C12.6618 3.88053 12.6199 3.78516 12.5954 3.74214C12.5151 3.60139 12.3985 3.48478 12.2577 3.4045C12.2147 3.37997 12.1193 3.33804 11.8394 3.31292C11.5459 3.28659 11.1579 3.28565 10.5523 3.28565H9.25708C8.65147 3.28565 8.26345 3.28659 7.96999 3.31292Z"\n    fill="#788181"\n  /></svg\n>'
    ]);
    $66880dde818b6978$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $66880dde818b6978$export$ec40c5c35ef5dd82 = (0, $1lUIm.svg)($66880dde818b6978$var$_templateObject());

});

parcelRegister("egeuF", function(module, exports) {

$parcel$export(module.exports, "cursorSvg", function () { return $a61dcd75a5ea195c$export$615c57907ad3661f; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $a61dcd75a5ea195c$var$_templateObject() {
    var data = (0, $j06k0._)([
        ' <svg fill="none" viewBox="0 0 13 4">\n  <path fill="currentColor" d="M.5 0h12L8.9 3.13a3.76 3.76 0 0 1-4.8 0L.5 0Z" />\n</svg>'
    ]);
    $a61dcd75a5ea195c$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $a61dcd75a5ea195c$export$615c57907ad3661f = (0, $1lUIm.svg)($a61dcd75a5ea195c$var$_templateObject());

});

parcelRegister("7rAkP", function(module, exports) {

$parcel$export(module.exports, "cursorTransparentSvg", function () { return $56b73d5ccfd0b71d$export$e4fd65630ad5bf5b; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $56b73d5ccfd0b71d$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 14 6">\n  <path style="fill: var(--wui-color-bg-150);" d="M0 1h14L9.21 5.12a3.31 3.31 0 0 1-4.49 0L0 1Z" />\n  <path\n    style="stroke: var(--wui-color-inverse-100);"\n    stroke-opacity=".05"\n    d="M1.33 1.5h11.32L8.88 4.75l-.01.01a2.81 2.81 0 0 1-3.8 0l-.02-.01L1.33 1.5Z"\n  />\n  <path\n    style="fill: var(--wui-color-bg-150);"\n    d="M1.25.71h11.5L9.21 3.88a3.31 3.31 0 0 1-4.49 0L1.25.71Z"\n  />\n</svg> '
    ]);
    $56b73d5ccfd0b71d$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $56b73d5ccfd0b71d$export$e4fd65630ad5bf5b = (0, $1lUIm.svg)($56b73d5ccfd0b71d$var$_templateObject());

});

parcelRegister("hHX0G", function(module, exports) {

$parcel$export(module.exports, "desktopSvg", function () { return $ce4439fa6d7ef165$export$7a2123fcf97e10d1; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $ce4439fa6d7ef165$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 20 20">\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M13.66 2H6.34c-1.07 0-1.96 0-2.68.08-.74.08-1.42.25-2.01.68a4 4 0 0 0-.89.89c-.43.6-.6 1.27-.68 2.01C0 6.38 0 7.26 0 8.34v.89c0 1.07 0 1.96.08 2.68.08.74.25 1.42.68 2.01a4 4 0 0 0 .89.89c.6.43 1.27.6 2.01.68a27 27 0 0 0 2.68.08h7.32a27 27 0 0 0 2.68-.08 4.03 4.03 0 0 0 2.01-.68 4 4 0 0 0 .89-.89c.43-.6.6-1.27.68-2.01.08-.72.08-1.6.08-2.68v-.89c0-1.07 0-1.96-.08-2.68a4.04 4.04 0 0 0-.68-2.01 4 4 0 0 0-.89-.89c-.6-.43-1.27-.6-2.01-.68C15.62 2 14.74 2 13.66 2ZM2.82 4.38c.2-.14.48-.25 1.06-.31C4.48 4 5.25 4 6.4 4h7.2c1.15 0 1.93 0 2.52.07.58.06.86.17 1.06.31a2 2 0 0 1 .44.44c.14.2.25.48.31 1.06.07.6.07 1.37.07 2.52v.77c0 1.15 0 1.93-.07 2.52-.06.58-.17.86-.31 1.06a2 2 0 0 1-.44.44c-.2.14-.48.25-1.06.32-.6.06-1.37.06-2.52.06H6.4c-1.15 0-1.93 0-2.52-.06-.58-.07-.86-.18-1.06-.32a2 2 0 0 1-.44-.44c-.14-.2-.25-.48-.31-1.06C2 11.1 2 10.32 2 9.17V8.4c0-1.15 0-1.93.07-2.52.06-.58.17-.86.31-1.06a2 2 0 0 1 .44-.44Z"\n    clip-rule="evenodd"\n  />\n  <path fill="currentColor" d="M6.14 17.57a1 1 0 1 0 0 2h7.72a1 1 0 1 0 0-2H6.14Z" />\n</svg>'
    ]);
    $ce4439fa6d7ef165$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $ce4439fa6d7ef165$export$7a2123fcf97e10d1 = (0, $1lUIm.svg)($ce4439fa6d7ef165$var$_templateObject());

});

parcelRegister("1Rvr6", function(module, exports) {

$parcel$export(module.exports, "disconnectSvg", function () { return $15b320409a8fb067$export$50fbdab79b8f082d; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $15b320409a8fb067$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 16 16">\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M6.07 1h.57a1 1 0 0 1 0 2h-.52c-.98 0-1.64 0-2.14.06-.48.05-.7.14-.84.24-.13.1-.25.22-.34.35-.1.14-.2.35-.25.83-.05.5-.05 1.16-.05 2.15v2.74c0 .99 0 1.65.05 2.15.05.48.14.7.25.83.1.14.2.25.34.35.14.1.36.2.84.25.5.05 1.16.05 2.14.05h.52a1 1 0 0 1 0 2h-.57c-.92 0-1.69 0-2.3-.07a3.6 3.6 0 0 1-1.8-.61c-.3-.22-.57-.49-.8-.8a3.6 3.6 0 0 1-.6-1.79C.5 11.11.5 10.35.5 9.43V6.58c0-.92 0-1.7.06-2.31a3.6 3.6 0 0 1 .62-1.8c.22-.3.48-.57.79-.79a3.6 3.6 0 0 1 1.8-.61C4.37 1 5.14 1 6.06 1ZM9.5 3a1 1 0 0 1 1.42 0l4.28 4.3a1 1 0 0 1 0 1.4L10.93 13a1 1 0 0 1-1.42-1.42L12.1 9H6.8a1 1 0 1 1 0-2h5.3L9.51 4.42a1 1 0 0 1 0-1.41Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $15b320409a8fb067$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $15b320409a8fb067$export$50fbdab79b8f082d = (0, $1lUIm.svg)($15b320409a8fb067$var$_templateObject());

});

parcelRegister("204fY", function(module, exports) {

$parcel$export(module.exports, "discordSvg", function () { return $174ee21f81b09dfa$export$29470bd7472aef51; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $174ee21f81b09dfa$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 40 40">\n  <g clip-path="url(#a)">\n    <g clip-path="url(#b)">\n      <circle cx="20" cy="19.89" r="20" fill="#5865F2" />\n      <path\n        fill="#fff"\n        fill-rule="evenodd"\n        d="M25.71 28.15C30.25 28 32 25.02 32 25.02c0-6.61-2.96-11.98-2.96-11.98-2.96-2.22-5.77-2.15-5.77-2.15l-.29.32c3.5 1.07 5.12 2.61 5.12 2.61a16.75 16.75 0 0 0-10.34-1.93l-.35.04a15.43 15.43 0 0 0-5.88 1.9s1.71-1.63 5.4-2.7l-.2-.24s-2.81-.07-5.77 2.15c0 0-2.96 5.37-2.96 11.98 0 0 1.73 2.98 6.27 3.13l1.37-1.7c-2.6-.79-3.6-2.43-3.6-2.43l.58.35.09.06.08.04.02.01.08.05a17.25 17.25 0 0 0 4.52 1.58 14.4 14.4 0 0 0 8.3-.86c.72-.27 1.52-.66 2.37-1.21 0 0-1.03 1.68-3.72 2.44.61.78 1.35 1.67 1.35 1.67Zm-9.55-9.6c-1.17 0-2.1 1.03-2.1 2.28 0 1.25.95 2.28 2.1 2.28 1.17 0 2.1-1.03 2.1-2.28.01-1.25-.93-2.28-2.1-2.28Zm7.5 0c-1.17 0-2.1 1.03-2.1 2.28 0 1.25.95 2.28 2.1 2.28 1.17 0 2.1-1.03 2.1-2.28 0-1.25-.93-2.28-2.1-2.28Z"\n        clip-rule="evenodd"\n      />\n    </g>\n  </g>\n  <defs>\n    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>\n    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>\n  </defs>\n</svg>'
    ]);
    $174ee21f81b09dfa$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $174ee21f81b09dfa$export$29470bd7472aef51 = (0, $1lUIm.svg)($174ee21f81b09dfa$var$_templateObject());

});

parcelRegister("4coNU", function(module, exports) {

$parcel$export(module.exports, "etherscanSvg", function () { return $30eb85fbf4ea7f8f$export$fad2d5a54496223b; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $30eb85fbf4ea7f8f$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 16 16">\n  <path\n    fill="currentColor"\n    d="M4.25 7a.63.63 0 0 0-.63.63v3.97c0 .28-.2.51-.47.54l-.75.07a.93.93 0 0 1-.9-.47A7.51 7.51 0 0 1 5.54.92a7.5 7.5 0 0 1 9.54 4.62c.12.35.06.72-.16 1-.74.97-1.68 1.78-2.6 2.44V4.44a.64.64 0 0 0-.63-.64h-1.06c-.35 0-.63.3-.63.64v5.5c0 .23-.12.42-.32.5l-.52.23V6.05c0-.36-.3-.64-.64-.64H7.45c-.35 0-.64.3-.64.64v4.97c0 .25-.17.46-.4.52a5.8 5.8 0 0 0-.45.11v-4c0-.36-.3-.65-.64-.65H4.25ZM14.07 12.4A7.49 7.49 0 0 1 3.6 14.08c4.09-.58 9.14-2.5 11.87-6.6v.03a7.56 7.56 0 0 1-1.41 4.91Z"\n  />\n</svg>'
    ]);
    $30eb85fbf4ea7f8f$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $30eb85fbf4ea7f8f$export$fad2d5a54496223b = (0, $1lUIm.svg)($30eb85fbf4ea7f8f$var$_templateObject());

});

parcelRegister("3LZrt", function(module, exports) {

$parcel$export(module.exports, "extensionSvg", function () { return $2bf56bfc09865c34$export$df81a22cbcc6237a; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $2bf56bfc09865c34$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 14 15">\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M6.71 2.99a.57.57 0 0 0-.57.57 1 1 0 0 1-1 1c-.58 0-.96 0-1.24.03-.27.03-.37.07-.42.1a.97.97 0 0 0-.36.35c-.04.08-.09.21-.11.67a2.57 2.57 0 0 1 0 5.13c.02.45.07.6.11.66.09.15.21.28.36.36.07.04.21.1.67.12a2.57 2.57 0 0 1 5.12 0c.46-.03.6-.08.67-.12a.97.97 0 0 0 .36-.36c.03-.04.07-.14.1-.41.02-.29.03-.66.03-1.24a1 1 0 0 1 1-1 .57.57 0 0 0 0-1.15 1 1 0 0 1-1-1c0-.58 0-.95-.03-1.24a1.04 1.04 0 0 0-.1-.42.97.97 0 0 0-.36-.36 1.04 1.04 0 0 0-.42-.1c-.28-.02-.65-.02-1.24-.02a1 1 0 0 1-1-1 .57.57 0 0 0-.57-.57ZM5.15 13.98a1 1 0 0 0 .99-1v-.78a.57.57 0 0 1 1.14 0v.78a1 1 0 0 0 .99 1H8.36a66.26 66.26 0 0 0 .73 0 3.78 3.78 0 0 0 1.84-.38c.46-.26.85-.64 1.1-1.1.23-.4.32-.8.36-1.22.02-.2.03-.4.03-.63a2.57 2.57 0 0 0 0-4.75c0-.23-.01-.44-.03-.63a2.96 2.96 0 0 0-.35-1.22 2.97 2.97 0 0 0-1.1-1.1c-.4-.22-.8-.31-1.22-.35a8.7 8.7 0 0 0-.64-.04 2.57 2.57 0 0 0-4.74 0c-.23 0-.44.02-.63.04-.42.04-.83.13-1.22.35-.46.26-.84.64-1.1 1.1-.33.57-.37 1.2-.39 1.84a21.39 21.39 0 0 0 0 .72v.1a1 1 0 0 0 1 .99h.78a.57.57 0 0 1 0 1.15h-.77a1 1 0 0 0-1 .98v.1a63.87 63.87 0 0 0 0 .73c0 .64.05 1.27.38 1.83.26.47.64.85 1.1 1.11.56.32 1.2.37 1.84.38a20.93 20.93 0 0 0 .72 0h.1Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $2bf56bfc09865c34$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $2bf56bfc09865c34$export$df81a22cbcc6237a = (0, $1lUIm.svg)($2bf56bfc09865c34$var$_templateObject());

});

parcelRegister("6VYuj", function(module, exports) {

$parcel$export(module.exports, "externalLinkSvg", function () { return $50c6fc9c3e9b3f25$export$34a422f948687038; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $50c6fc9c3e9b3f25$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 14 15">\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M3.74 3.99a1 1 0 0 1 1-1H11a1 1 0 0 1 1 1v6.26a1 1 0 0 1-2 0V6.4l-6.3 6.3a1 1 0 0 1-1.4-1.42l6.29-6.3H4.74a1 1 0 0 1-1-1Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $50c6fc9c3e9b3f25$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $50c6fc9c3e9b3f25$export$34a422f948687038 = (0, $1lUIm.svg)($50c6fc9c3e9b3f25$var$_templateObject());

});

parcelRegister("gIx8W", function(module, exports) {

$parcel$export(module.exports, "facebookSvg", function () { return $c2ba76f0237a911d$export$1ff5018c782ba6f; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $c2ba76f0237a911d$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 40 40">\n  <g clip-path="url(#a)">\n    <g clip-path="url(#b)">\n      <circle cx="20" cy="19.89" r="20" fill="#1877F2" />\n      <g clip-path="url(#c)">\n        <path\n          fill="#fff"\n          d="M26 12.38h-2.89c-.92 0-1.61.38-1.61 1.34v1.66H26l-.36 4.5H21.5v12H17v-12h-3v-4.5h3V12.5c0-3.03 1.6-4.62 5.2-4.62H26v4.5Z"\n        />\n      </g>\n    </g>\n    <path\n      fill="#1877F2"\n      d="M40 20a20 20 0 1 0-23.13 19.76V25.78H11.8V20h5.07v-4.4c0-5.02 3-7.79 7.56-7.79 2.19 0 4.48.4 4.48.4v4.91h-2.53c-2.48 0-3.25 1.55-3.25 3.13V20h5.54l-.88 5.78h-4.66v13.98A20 20 0 0 0 40 20Z"\n    />\n    <path\n      fill="#fff"\n      d="m27.79 25.78.88-5.78h-5.55v-3.75c0-1.58.78-3.13 3.26-3.13h2.53V8.2s-2.3-.39-4.48-.39c-4.57 0-7.55 2.77-7.55 7.78V20H11.8v5.78h5.07v13.98a20.15 20.15 0 0 0 6.25 0V25.78h4.67Z"\n    />\n  </g>\n  <defs>\n    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>\n    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>\n    <clipPath id="c"><path fill="#fff" d="M8 7.89h24v24H8z" /></clipPath>\n  </defs>\n</svg>'
    ]);
    $c2ba76f0237a911d$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $c2ba76f0237a911d$export$1ff5018c782ba6f = (0, $1lUIm.svg)($c2ba76f0237a911d$var$_templateObject());

});

parcelRegister("ek7Pr", function(module, exports) {

$parcel$export(module.exports, "farcasterSvg", function () { return $a6d901937501ff34$export$7b0045cfe57afd2f; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $a6d901937501ff34$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg style="border-radius: 9999px; overflow: hidden;"  fill="none" viewBox="0 0 1000 1000">\n  <rect width="1000" height="1000" rx="9999" ry="9999" fill="#855DCD"/>\n  <path fill="#855DCD" d="M0 0h1000v1000H0V0Z" />\n  <path\n    fill="#fff"\n    d="M320 248h354v504h-51.96V521.13h-.5c-5.76-63.8-59.31-113.81-124.54-113.81s-118.78 50-124.53 113.81h-.5V752H320V248Z"\n  />\n  <path\n    fill="#fff"\n    d="m225 320 21.16 71.46h17.9v289.09a16.29 16.29 0 0 0-16.28 16.24v19.49h-3.25a16.3 16.3 0 0 0-16.28 16.24V752h182.26v-19.48a16.22 16.22 0 0 0-16.28-16.24h-3.25v-19.5a16.22 16.22 0 0 0-16.28-16.23h-19.52V320H225Zm400.3 360.55a16.3 16.3 0 0 0-15.04 10.02 16.2 16.2 0 0 0-1.24 6.22v19.49h-3.25a16.29 16.29 0 0 0-16.27 16.24V752h182.24v-19.48a16.23 16.23 0 0 0-16.27-16.24h-3.25v-19.5a16.2 16.2 0 0 0-10.04-15 16.3 16.3 0 0 0-6.23-1.23v-289.1h17.9L775 320H644.82v360.55H625.3Z"\n  />\n</svg>'
    ]);
    $a6d901937501ff34$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $a6d901937501ff34$export$7b0045cfe57afd2f = (0, $1lUIm.svg)($a6d901937501ff34$var$_templateObject());

});

parcelRegister("gWT3N", function(module, exports) {

$parcel$export(module.exports, "filtersSvg", function () { return $c56cc5ed95e6d845$export$9261929cf6dcbff0; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $c56cc5ed95e6d845$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 16 16">\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M0 3a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1Zm2.63 5.25a1 1 0 0 1 1-1h8.75a1 1 0 1 1 0 2H3.63a1 1 0 0 1-1-1Zm2.62 5.25a1 1 0 0 1 1-1h3.5a1 1 0 0 1 0 2h-3.5a1 1 0 0 1-1-1Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $c56cc5ed95e6d845$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $c56cc5ed95e6d845$export$9261929cf6dcbff0 = (0, $1lUIm.svg)($c56cc5ed95e6d845$var$_templateObject());

});

parcelRegister("kapCt", function(module, exports) {

$parcel$export(module.exports, "githubSvg", function () { return $eae89d57e935dd34$export$f094865edb198013; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $eae89d57e935dd34$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 40 40">\n  <g clip-path="url(#a)">\n    <g clip-path="url(#b)">\n      <circle cx="20" cy="19.89" r="20" fill="#1B1F23" />\n      <g clip-path="url(#c)">\n        <path\n          fill="#fff"\n          d="M8 19.89a12 12 0 1 1 15.8 11.38c-.6.12-.8-.26-.8-.57v-3.3c0-1.12-.4-1.85-.82-2.22 2.67-.3 5.48-1.31 5.48-5.92 0-1.31-.47-2.38-1.24-3.22.13-.3.54-1.52-.12-3.18 0 0-1-.32-3.3 1.23a11.54 11.54 0 0 0-6 0c-2.3-1.55-3.3-1.23-3.3-1.23a4.32 4.32 0 0 0-.12 3.18 4.64 4.64 0 0 0-1.24 3.22c0 4.6 2.8 5.63 5.47 5.93-.34.3-.65.83-.76 1.6-.69.31-2.42.84-3.5-1 0 0-.63-1.15-1.83-1.23 0 0-1.18-.02-.09.73 0 0 .8.37 1.34 1.76 0 0 .7 2.14 4.03 1.41v2.24c0 .31-.2.68-.8.57A12 12 0 0 1 8 19.9Z"\n        />\n      </g>\n    </g>\n  </g>\n  <defs>\n    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>\n    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>\n    <clipPath id="c"><path fill="#fff" d="M8 7.89h24v24H8z" /></clipPath>\n  </defs>\n</svg>'
    ]);
    $eae89d57e935dd34$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $eae89d57e935dd34$export$f094865edb198013 = (0, $1lUIm.svg)($eae89d57e935dd34$var$_templateObject());

});

parcelRegister("hqHym", function(module, exports) {

$parcel$export(module.exports, "googleSvg", function () { return $cb06a6222f6b2b3b$export$62a66155552ed9b0; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $cb06a6222f6b2b3b$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 40 40">\n  <path\n    fill="#4285F4"\n    d="M32.74 20.3c0-.93-.08-1.81-.24-2.66H20.26v5.03h7a6 6 0 0 1-2.62 3.91v3.28h4.22c2.46-2.27 3.88-5.6 3.88-9.56Z"\n  />\n  <path\n    fill="#34A853"\n    d="M20.26 33a12.4 12.4 0 0 0 8.6-3.14l-4.22-3.28a7.74 7.74 0 0 1-4.38 1.26 7.76 7.76 0 0 1-7.28-5.36H8.65v3.36A12.99 12.99 0 0 0 20.26 33Z"\n  />\n  <path\n    fill="#FBBC05"\n    d="M12.98 22.47a7.79 7.79 0 0 1 0-4.94v-3.36H8.65a12.84 12.84 0 0 0 0 11.66l3.37-2.63.96-.73Z"\n  />\n  <path\n    fill="#EA4335"\n    d="M20.26 12.18a7.1 7.1 0 0 1 4.98 1.93l3.72-3.72A12.47 12.47 0 0 0 20.26 7c-5.08 0-9.47 2.92-11.6 7.17l4.32 3.36a7.76 7.76 0 0 1 7.28-5.35Z"\n  />\n</svg>'
    ]);
    $cb06a6222f6b2b3b$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $cb06a6222f6b2b3b$export$62a66155552ed9b0 = (0, $1lUIm.svg)($cb06a6222f6b2b3b$var$_templateObject());

});

parcelRegister("6zr1F", function(module, exports) {

$parcel$export(module.exports, "helpCircleSvg", function () { return $4c8af9b776e69d45$export$cbf7b9dd25929c90; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $4c8af9b776e69d45$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 16 16">\n  <path\n    fill="currentColor"\n    d="M8.51 5.66a.83.83 0 0 0-.57-.2.83.83 0 0 0-.52.28.8.8 0 0 0-.25.52 1 1 0 0 1-2 0c0-.75.34-1.43.81-1.91a2.75 2.75 0 0 1 4.78 1.92c0 1.24-.8 1.86-1.25 2.2l-.04.03c-.47.36-.5.43-.5.65a1 1 0 1 1-2 0c0-1.25.8-1.86 1.24-2.2l.04-.04c.47-.36.5-.43.5-.65 0-.3-.1-.49-.24-.6ZM9.12 11.87a1.13 1.13 0 1 1-2.25 0 1.13 1.13 0 0 1 2.25 0Z"\n  />\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-6a6 6 0 1 0 0 12A6 6 0 0 0 8 2Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $4c8af9b776e69d45$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $4c8af9b776e69d45$export$cbf7b9dd25929c90 = (0, $1lUIm.svg)($4c8af9b776e69d45$var$_templateObject());

});

parcelRegister("asO9s", function(module, exports) {

$parcel$export(module.exports, "imageSvg", function () { return $79e36bfba40700fe$export$cb3fb71461a06425; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $79e36bfba40700fe$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg width="14" height="14" viewBox="0 0 14 14" fill="none">\n  <path d="M4.98926 3.73932C4.2989 3.73932 3.73926 4.29896 3.73926 4.98932C3.73926 5.67968 4.2989 6.23932 4.98926 6.23932C5.67962 6.23932 6.23926 5.67968 6.23926 4.98932C6.23926 4.29896 5.67962 3.73932 4.98926 3.73932Z" fill="currentColor"/>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.60497 0.500001H6.39504C5.41068 0.499977 4.59185 0.499958 3.93178 0.571471C3.24075 0.64634 2.60613 0.809093 2.04581 1.21619C1.72745 1.44749 1.44749 1.72745 1.21619 2.04581C0.809093 2.60613 0.64634 3.24075 0.571471 3.93178C0.499958 4.59185 0.499977 5.41065 0.500001 6.39501V7.57815C0.499998 8.37476 0.499995 9.05726 0.534869 9.62725C0.570123 10.2034 0.644114 10.7419 0.828442 11.2302C0.925651 11.4877 1.05235 11.7287 1.21619 11.9542C1.44749 12.2726 1.72745 12.5525 2.04581 12.7838C2.60613 13.1909 3.24075 13.3537 3.93178 13.4285C4.59185 13.5001 5.41066 13.5 6.39503 13.5H7.60496C8.58933 13.5 9.40815 13.5001 10.0682 13.4285C10.7593 13.3537 11.3939 13.1909 11.9542 12.7838C12.2726 12.5525 12.5525 12.2726 12.7838 11.9542C13.1909 11.3939 13.3537 10.7593 13.4285 10.0682C13.5 9.40816 13.5 8.58935 13.5 7.60497V6.39505C13.5 5.41068 13.5 4.59185 13.4285 3.93178C13.3537 3.24075 13.1909 2.60613 12.7838 2.04581C12.5525 1.72745 12.2726 1.44749 11.9542 1.21619C11.3939 0.809093 10.7593 0.64634 10.0682 0.571471C9.40816 0.499958 8.58933 0.499977 7.60497 0.500001ZM3.22138 2.83422C3.38394 2.71612 3.62634 2.61627 4.14721 2.55984C4.68679 2.50138 5.39655 2.5 6.45 2.5H7.55C8.60345 2.5 9.31322 2.50138 9.8528 2.55984C10.3737 2.61627 10.6161 2.71612 10.7786 2.83422C10.9272 2.94216 11.0578 3.07281 11.1658 3.22138C11.2839 3.38394 11.3837 3.62634 11.4402 4.14721C11.4986 4.68679 11.5 5.39655 11.5 6.45V6.49703C10.9674 6.11617 10.386 5.84936 9.74213 5.81948C8.40536 5.75745 7.3556 6.73051 6.40509 7.84229C6.33236 7.92737 6.27406 7.98735 6.22971 8.02911L6.1919 8.00514L6.17483 7.99427C6.09523 7.94353 5.98115 7.87083 5.85596 7.80302C5.56887 7.64752 5.18012 7.4921 4.68105 7.4921C4.66697 7.4921 4.6529 7.49239 4.63884 7.49299C3.79163 7.52878 3.09922 8.1106 2.62901 8.55472C2.58751 8.59392 2.54594 8.6339 2.50435 8.6745C2.50011 8.34653 2.5 7.97569 2.5 7.55V6.45C2.5 5.39655 2.50138 4.68679 2.55984 4.14721C2.61627 3.62634 2.71612 3.38394 2.83422 3.22138C2.94216 3.07281 3.07281 2.94216 3.22138 2.83422ZM10.3703 8.14825C10.6798 8.37526 11.043 8.71839 11.4832 9.20889C11.4744 9.44992 11.4608 9.662 11.4402 9.8528C11.3837 10.3737 11.2839 10.6161 11.1658 10.7786C11.0578 10.9272 10.9272 11.0578 10.7786 11.1658C10.6161 11.2839 10.3737 11.3837 9.8528 11.4402C9.31322 11.4986 8.60345 11.5 7.55 11.5H6.45C5.39655 11.5 4.68679 11.4986 4.14721 11.4402C3.62634 11.3837 3.38394 11.2839 3.22138 11.1658C3.15484 11.1174 3.0919 11.0645 3.03298 11.0075C3.10126 10.9356 3.16806 10.8649 3.23317 10.7959L3.29772 10.7276C3.55763 10.4525 3.78639 10.2126 4.00232 10.0087C4.22016 9.80294 4.39412 9.66364 4.53524 9.57742C4.63352 9.51738 4.69022 9.49897 4.71275 9.49345C4.76387 9.49804 4.81803 9.51537 4.90343 9.56162C4.96409 9.59447 5.02355 9.63225 5.11802 9.69238L5.12363 9.69595C5.20522 9.74789 5.32771 9.82587 5.46078 9.89278C5.76529 10.0459 6.21427 10.186 6.74977 10.0158C7.21485 9.86796 7.59367 9.52979 7.92525 9.14195C8.91377 7.98571 9.38267 7.80495 9.64941 7.81733C9.7858 7.82366 10.0101 7.884 10.3703 8.14825Z" fill="currentColor"/>\n</svg>'
    ]);
    $79e36bfba40700fe$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $79e36bfba40700fe$export$cb3fb71461a06425 = (0, $1lUIm.svg)($79e36bfba40700fe$var$_templateObject());

});

parcelRegister("2YD4y", function(module, exports) {

$parcel$export(module.exports, "infoCircleSvg", function () { return $22af7e5718834907$export$313082e449e2d152; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $22af7e5718834907$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 14 15">\n  <path\n    fill="currentColor"\n    d="M6 10.49a1 1 0 1 0 2 0v-2a1 1 0 0 0-2 0v2ZM7 4.49a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"\n  />\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M7 14.99a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm5-7a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $22af7e5718834907$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $22af7e5718834907$export$313082e449e2d152 = (0, $1lUIm.svg)($22af7e5718834907$var$_templateObject());

});

parcelRegister("yj3WF", function(module, exports) {

$parcel$export(module.exports, "mailSvg", function () { return $0671f6883abec62d$export$a9b1939cca165cd6; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $0671f6883abec62d$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 16 16">\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M4.83 1.34h6.34c.68 0 1.26 0 1.73.04.5.05.97.15 1.42.4.52.3.95.72 1.24 1.24.26.45.35.92.4 1.42.04.47.04 1.05.04 1.73v3.71c0 .69 0 1.26-.04 1.74-.05.5-.14.97-.4 1.41-.3.52-.72.95-1.24 1.25-.45.25-.92.35-1.42.4-.47.03-1.05.03-1.73.03H4.83c-.68 0-1.26 0-1.73-.04-.5-.04-.97-.14-1.42-.4-.52-.29-.95-.72-1.24-1.24a3.39 3.39 0 0 1-.4-1.41A20.9 20.9 0 0 1 0 9.88v-3.7c0-.7 0-1.27.04-1.74.05-.5.14-.97.4-1.42.3-.52.72-.95 1.24-1.24.45-.25.92-.35 1.42-.4.47-.04 1.05-.04 1.73-.04ZM3.28 3.38c-.36.03-.51.08-.6.14-.21.11-.39.29-.5.5a.8.8 0 0 0-.08.19l5.16 3.44c.45.3 1.03.3 1.48 0L13.9 4.2a.79.79 0 0 0-.08-.2c-.11-.2-.29-.38-.5-.5-.09-.05-.24-.1-.6-.13-.37-.04-.86-.04-1.6-.04H4.88c-.73 0-1.22 0-1.6.04ZM14 6.54 9.85 9.31a3.33 3.33 0 0 1-3.7 0L2 6.54v3.3c0 .74 0 1.22.03 1.6.04.36.1.5.15.6.11.2.29.38.5.5.09.05.24.1.6.14.37.03.86.03 1.6.03h6.25c.73 0 1.22 0 1.6-.03.35-.03.5-.09.6-.14.2-.12.38-.3.5-.5.05-.1.1-.24.14-.6.03-.38.03-.86.03-1.6v-3.3Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $0671f6883abec62d$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $0671f6883abec62d$export$a9b1939cca165cd6 = (0, $1lUIm.svg)($0671f6883abec62d$var$_templateObject());

});

parcelRegister("efZ4g", function(module, exports) {

$parcel$export(module.exports, "mobileSvg", function () { return $a611d62b7aedba2c$export$b6a7821857ebc7d7; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $a611d62b7aedba2c$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 20 20">\n  <path fill="currentColor" d="M10.81 5.81a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" />\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M3 4.75A4.75 4.75 0 0 1 7.75 0h4.5A4.75 4.75 0 0 1 17 4.75v10.5A4.75 4.75 0 0 1 12.25 20h-4.5A4.75 4.75 0 0 1 3 15.25V4.75ZM7.75 2A2.75 2.75 0 0 0 5 4.75v10.5A2.75 2.75 0 0 0 7.75 18h4.5A2.75 2.75 0 0 0 15 15.25V4.75A2.75 2.75 0 0 0 12.25 2h-4.5Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $a611d62b7aedba2c$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $a611d62b7aedba2c$export$b6a7821857ebc7d7 = (0, $1lUIm.svg)($a611d62b7aedba2c$var$_templateObject());

});

parcelRegister("7TZuR", function(module, exports) {

$parcel$export(module.exports, "moreSvg", function () { return $5c0d5f6b136544c5$export$976edb54c21a0ac1; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $5c0d5f6b136544c5$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 41 40">\n  <path\n    style="fill: var(--wui-color-fg-100);"\n    fill-opacity=".05"\n    d="M.6 20a20 20 0 1 1 40 0 20 20 0 0 1-40 0Z"\n  />\n  <path\n    fill="#949E9E"\n    d="M15.6 20.31a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM23.1 20.31a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM28.1 22.81a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"\n  />\n</svg>'
    ]);
    $5c0d5f6b136544c5$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $5c0d5f6b136544c5$export$976edb54c21a0ac1 = (0, $1lUIm.svg)($5c0d5f6b136544c5$var$_templateObject());

});

parcelRegister("5QOuv", function(module, exports) {

$parcel$export(module.exports, "networkPlaceholderSvg", function () { return $4428f9890942de93$export$8eef6146d36b9527; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $4428f9890942de93$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 22 20">\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M16.32 13.62a3.14 3.14 0 1 1-.99 1.72l-1.6-.93a3.83 3.83 0 0 1-3.71 1 3.66 3.66 0 0 1-1.74-1l-1.6.94a3.14 3.14 0 1 1-1-1.73l1.6-.94a3.7 3.7 0 0 1 0-2 3.81 3.81 0 0 1 1.8-2.33c.29-.17.6-.3.92-.38V6.1a3.14 3.14 0 1 1 2 0l-.01.02v1.85H12a3.82 3.82 0 0 1 2.33 1.8 3.7 3.7 0 0 1 .39 2.91l1.6.93ZM2.6 16.54a1.14 1.14 0 0 0 1.98-1.14 1.14 1.14 0 0 0-1.98 1.14ZM11 2.01a1.14 1.14 0 1 0 0 2.28 1.14 1.14 0 0 0 0-2.28Zm1.68 10.45c.08-.19.14-.38.16-.58v-.05l.02-.13v-.13a1.92 1.92 0 0 0-.24-.8l-.11-.15a1.89 1.89 0 0 0-.74-.6 1.86 1.86 0 0 0-.77-.17h-.19a1.97 1.97 0 0 0-.89.34 1.98 1.98 0 0 0-.61.74 1.99 1.99 0 0 0-.16.9v.05a1.87 1.87 0 0 0 .24.74l.1.15c.12.16.26.3.42.42l.16.1.13.07.04.02a1.84 1.84 0 0 0 .76.17h.17a2 2 0 0 0 .91-.35 1.78 1.78 0 0 0 .52-.58l.03-.05a.84.84 0 0 0 .05-.11Zm5.15 4.5a1.14 1.14 0 0 0 1.14-1.97 1.13 1.13 0 0 0-1.55.41c-.32.55-.13 1.25.41 1.56Z"\n    clip-rule="evenodd"\n  />\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M4.63 9.43a1.5 1.5 0 1 0 1.5-2.6 1.5 1.5 0 0 0-1.5 2.6Zm.32-1.55a.5.5 0 0 1 .68-.19.5.5 0 0 1 .18.68.5.5 0 0 1-.68.19.5.5 0 0 1-.18-.68ZM17.94 8.88a1.5 1.5 0 1 1-2.6-1.5 1.5 1.5 0 1 1 2.6 1.5ZM16.9 7.69a.5.5 0 0 0-.68.19.5.5 0 0 0 .18.68.5.5 0 0 0 .68-.19.5.5 0 0 0-.18-.68ZM9.75 17.75a1.5 1.5 0 1 1 2.6 1.5 1.5 1.5 0 1 1-2.6-1.5Zm1.05 1.18a.5.5 0 0 0 .68-.18.5.5 0 0 0-.18-.68.5.5 0 0 0-.68.18.5.5 0 0 0 .18.68Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $4428f9890942de93$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $4428f9890942de93$export$8eef6146d36b9527 = (0, $1lUIm.svg)($4428f9890942de93$var$_templateObject());

});

parcelRegister("adaOo", function(module, exports) {

$parcel$export(module.exports, "nftPlaceholderSvg", function () { return $76f38142dd9de5a5$export$cacef02b4679549a; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $76f38142dd9de5a5$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 20 20">\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M9.13 1h1.71c1.46 0 2.63 0 3.56.1.97.1 1.8.33 2.53.85a5 5 0 0 1 1.1 1.11c.53.73.75 1.56.86 2.53.1.93.1 2.1.1 3.55v1.72c0 1.45 0 2.62-.1 3.55-.1.97-.33 1.8-.86 2.53a5 5 0 0 1-1.1 1.1c-.73.53-1.56.75-2.53.86-.93.1-2.1.1-3.55.1H9.13c-1.45 0-2.62 0-3.56-.1-.96-.1-1.8-.33-2.52-.85a5 5 0 0 1-1.1-1.11 5.05 5.05 0 0 1-.86-2.53c-.1-.93-.1-2.1-.1-3.55V9.14c0-1.45 0-2.62.1-3.55.1-.97.33-1.8.85-2.53a5 5 0 0 1 1.1-1.1 5.05 5.05 0 0 1 2.53-.86C6.51 1 7.67 1 9.13 1ZM5.79 3.09a3.1 3.1 0 0 0-1.57.48 3 3 0 0 0-.66.67c-.24.32-.4.77-.48 1.56-.1.82-.1 1.88-.1 3.4v1.6c0 1.15 0 2.04.05 2.76l.41-.42c.5-.5.93-.92 1.32-1.24.41-.33.86-.6 1.43-.7a3 3 0 0 1 .94 0c.35.06.66.2.95.37a17.11 17.11 0 0 0 .8.45c.1-.08.2-.2.41-.4l.04-.03a27 27 0 0 1 1.95-1.84 4.03 4.03 0 0 1 1.91-.94 4 4 0 0 1 1.25 0c.73.11 1.33.46 1.91.94l.64.55V9.2c0-1.52 0-2.58-.1-3.4a3.1 3.1 0 0 0-.48-1.56 3 3 0 0 0-.66-.67 3.1 3.1 0 0 0-1.56-.48C13.37 3 12.3 3 10.79 3h-1.6c-1.52 0-2.59 0-3.4.09Zm11.18 10-.04-.05a26.24 26.24 0 0 0-1.83-1.74c-.45-.36-.73-.48-.97-.52a2 2 0 0 0-.63 0c-.24.04-.51.16-.97.52-.46.38-1.01.93-1.83 1.74l-.02.02c-.17.18-.34.34-.49.47a2.04 2.04 0 0 1-1.08.5 1.97 1.97 0 0 1-1.25-.27l-.79-.46-.02-.02a.65.65 0 0 0-.24-.1 1 1 0 0 0-.31 0c-.08.02-.21.06-.49.28-.3.24-.65.59-1.2 1.14l-.56.56-.65.66a3 3 0 0 0 .62.6c.33.24.77.4 1.57.49.81.09 1.88.09 3.4.09h1.6c1.52 0 2.58 0 3.4-.09a3.1 3.1 0 0 0 1.56-.48 3 3 0 0 0 .66-.67c.24-.32.4-.77.49-1.56l.07-1.12Zm-8.02-1.03ZM4.99 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $76f38142dd9de5a5$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $76f38142dd9de5a5$export$cacef02b4679549a = (0, $1lUIm.svg)($76f38142dd9de5a5$var$_templateObject());

});

parcelRegister("6I6WF", function(module, exports) {

$parcel$export(module.exports, "offSvg", function () { return $4e2c3d52fab71e82$export$7ec09ee48c3bf315; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $4e2c3d52fab71e82$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 16 16">\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M8 0a1 1 0 0 1 1 1v5.38a1 1 0 0 1-2 0V1a1 1 0 0 1 1-1ZM5.26 2.6a1 1 0 0 1-.28 1.39 5.46 5.46 0 1 0 6.04 0 1 1 0 1 1 1.1-1.67 7.46 7.46 0 1 1-8.25 0 1 1 0 0 1 1.4.28Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $4e2c3d52fab71e82$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $4e2c3d52fab71e82$export$7ec09ee48c3bf315 = (0, $1lUIm.svg)($4e2c3d52fab71e82$var$_templateObject());

});

parcelRegister("8Y3HG", function(module, exports) {

$parcel$export(module.exports, "playStoreSvg", function () { return $6876ccc225fc77d6$export$65007b9f28ed0950; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $6876ccc225fc77d6$var$_templateObject() {
    var data = (0, $j06k0._)([
        ' <svg\n  width="36"\n  height="36"\n  fill="none"\n>\n  <path\n    d="M0 8a8 8 0 0 1 8-8h20a8 8 0 0 1 8 8v20a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8Z"\n    fill="#fff"\n    fill-opacity=".05"\n  />\n  <path\n    d="m18.262 17.513-8.944 9.49v.01a2.417 2.417 0 0 0 3.56 1.452l.026-.017 10.061-5.803-4.703-5.132Z"\n    fill="#EA4335"\n  />\n  <path\n    d="m27.307 15.9-.008-.008-4.342-2.52-4.896 4.36 4.913 4.912 4.325-2.494a2.42 2.42 0 0 0 .008-4.25Z"\n    fill="#FBBC04"\n  />\n  <path\n    d="M9.318 8.997c-.05.202-.084.403-.084.622V26.39c0 .218.025.42.084.621l9.246-9.247-9.246-8.768Z"\n    fill="#4285F4"\n  />\n  <path\n    d="m18.33 18 4.627-4.628-10.053-5.828a2.427 2.427 0 0 0-3.586 1.444L18.329 18Z"\n    fill="#34A853"\n  />\n  <path\n    d="M8 .5h20A7.5 7.5 0 0 1 35.5 8v20a7.5 7.5 0 0 1-7.5 7.5H8A7.5 7.5 0 0 1 .5 28V8A7.5 7.5 0 0 1 8 .5Z"\n    stroke="#fff"\n    stroke-opacity=".05"\n  />\n</svg>'
    ]);
    $6876ccc225fc77d6$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $6876ccc225fc77d6$export$65007b9f28ed0950 = (0, $1lUIm.svg)($6876ccc225fc77d6$var$_templateObject());

});

parcelRegister("ebZ5M", function(module, exports) {

$parcel$export(module.exports, "plusSvg", function () { return $a5517b682aea0e4b$export$f392b38d2d3751; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $a5517b682aea0e4b$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg\n  width="13"\n  height="12"\n  viewBox="0 0 13 12"\n  fill="none"\n>\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M0.794373 5.99982C0.794373 5.52643 1.17812 5.14268 1.6515 5.14268H5.643V1.15109C5.643 0.677701 6.02675 0.293946 6.50012 0.293945C6.9735 0.293946 7.35725 0.677701 7.35725 1.15109V5.14268H11.3488C11.8221 5.14268 12.2059 5.52643 12.2059 5.99982C12.2059 6.47321 11.8221 6.85696 11.3488 6.85696H7.35725V10.8486C7.35725 11.3219 6.9735 11.7057 6.50012 11.7057C6.02675 11.7057 5.643 11.3219 5.643 10.8486V6.85696H1.6515C1.17812 6.85696 0.794373 6.47321 0.794373 5.99982Z"\n  /></svg\n>'
    ]);
    $a5517b682aea0e4b$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $a5517b682aea0e4b$export$f392b38d2d3751 = (0, $1lUIm.svg)($a5517b682aea0e4b$var$_templateObject());

});

parcelRegister("3V2Xf", function(module, exports) {

$parcel$export(module.exports, "qrCodeIcon", function () { return $2da8fcb1961078f7$export$b033e2eb4807deba; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $2da8fcb1961078f7$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 20 20">\n  <path\n    fill="currentColor"\n    d="M3 6a3 3 0 0 1 3-3h1a1 1 0 1 0 0-2H6a5 5 0 0 0-5 5v1a1 1 0 0 0 2 0V6ZM13 1a1 1 0 1 0 0 2h1a3 3 0 0 1 3 3v1a1 1 0 1 0 2 0V6a5 5 0 0 0-5-5h-1ZM3 13a1 1 0 1 0-2 0v1a5 5 0 0 0 5 5h1a1 1 0 1 0 0-2H6a3 3 0 0 1-3-3v-1ZM19 13a1 1 0 1 0-2 0v1a3 3 0 0 1-3 3h-1a1 1 0 1 0 0 2h1.01a5 5 0 0 0 5-5v-1ZM5.3 6.36c-.04.2-.04.43-.04.89s0 .7.05.89c.14.52.54.92 1.06 1.06.19.05.42.05.89.05.46 0 .7 0 .88-.05A1.5 1.5 0 0 0 9.2 8.14c.06-.2.06-.43.06-.89s0-.7-.06-.89A1.5 1.5 0 0 0 8.14 5.3c-.19-.05-.42-.05-.88-.05-.47 0-.7 0-.9.05a1.5 1.5 0 0 0-1.05 1.06ZM10.8 6.36c-.04.2-.04.43-.04.89s0 .7.05.89c.14.52.54.92 1.06 1.06.19.05.42.05.89.05.46 0 .7 0 .88-.05a1.5 1.5 0 0 0 1.06-1.06c.06-.2.06-.43.06-.89s0-.7-.06-.89a1.5 1.5 0 0 0-1.06-1.06c-.19-.05-.42-.05-.88-.05-.47 0-.7 0-.9.05a1.5 1.5 0 0 0-1.05 1.06ZM5.26 12.75c0-.46 0-.7.05-.89a1.5 1.5 0 0 1 1.06-1.06c.19-.05.42-.05.89-.05.46 0 .7 0 .88.05.52.14.93.54 1.06 1.06.06.2.06.43.06.89s0 .7-.06.89a1.5 1.5 0 0 1-1.06 1.06c-.19.05-.42.05-.88.05-.47 0-.7 0-.9-.05a1.5 1.5 0 0 1-1.05-1.06c-.05-.2-.05-.43-.05-.89ZM10.8 11.86c-.04.2-.04.43-.04.89s0 .7.05.89c.14.52.54.92 1.06 1.06.19.05.42.05.89.05.46 0 .7 0 .88-.05a1.5 1.5 0 0 0 1.06-1.06c.06-.2.06-.43.06-.89s0-.7-.06-.89a1.5 1.5 0 0 0-1.06-1.06c-.19-.05-.42-.05-.88-.05-.47 0-.7 0-.9.05a1.5 1.5 0 0 0-1.05 1.06Z"\n  />\n</svg>'
    ]);
    $2da8fcb1961078f7$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $2da8fcb1961078f7$export$b033e2eb4807deba = (0, $1lUIm.svg)($2da8fcb1961078f7$var$_templateObject());

});

parcelRegister("7aDLM", function(module, exports) {

$parcel$export(module.exports, "recycleHorizontalSvg", function () { return $538850fc7445209a$export$abad67e618866d01; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $538850fc7445209a$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg\n  fill="none"\n  viewBox="0 0 21 20"\n>\n  <path\n    fill="currentColor"\n    d="M8.8071 0.292893C9.19763 0.683417 9.19763 1.31658 8.8071 1.70711L6.91421 3.6H11.8404C14.3368 3.6 16.5533 5.1975 17.3427 7.56588L17.4487 7.88377C17.6233 8.40772 17.3402 8.97404 16.8162 9.14868C16.2923 9.32333 15.726 9.04017 15.5513 8.51623L15.4453 8.19834C14.9281 6.64664 13.476 5.6 11.8404 5.6H6.91421L8.8071 7.49289C9.19763 7.88342 9.19763 8.51658 8.8071 8.90711C8.41658 9.29763 7.78341 9.29763 7.39289 8.90711L3.79289 5.30711C3.40236 4.91658 3.40236 4.28342 3.79289 3.89289L7.39289 0.292893C7.78341 -0.0976311 8.41658 -0.0976311 8.8071 0.292893ZM4.18377 10.8513C4.70771 10.6767 5.27403 10.9598 5.44868 11.4838L5.55464 11.8017C6.07188 13.3534 7.52401 14.4 9.15964 14.4L14.0858 14.4L12.1929 12.5071C11.8024 12.1166 11.8024 11.4834 12.1929 11.0929C12.5834 10.7024 13.2166 10.7024 13.6071 11.0929L17.2071 14.6929C17.5976 15.0834 17.5976 15.7166 17.2071 16.1071L13.6071 19.7071C13.2166 20.0976 12.5834 20.0976 12.1929 19.7071C11.8024 19.3166 11.8024 18.6834 12.1929 18.2929L14.0858 16.4L9.15964 16.4C6.66314 16.4 4.44674 14.8025 3.65728 12.4341L3.55131 12.1162C3.37667 11.5923 3.65983 11.026 4.18377 10.8513Z"\n  /></svg\n>'
    ]);
    $538850fc7445209a$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $538850fc7445209a$export$abad67e618866d01 = (0, $1lUIm.svg)($538850fc7445209a$var$_templateObject());

});

parcelRegister("cGKw0", function(module, exports) {

$parcel$export(module.exports, "refreshSvg", function () { return $93cd7d40860d84f0$export$bbe3b42eaaf82fae; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $93cd7d40860d84f0$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 14 16">\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M3.94 1.04a1 1 0 0 1 .7 1.23l-.48 1.68a5.85 5.85 0 0 1 8.53 4.32 5.86 5.86 0 0 1-11.4 2.56 1 1 0 0 1 1.9-.57 3.86 3.86 0 1 0 1.83-4.5l1.87.53a1 1 0 0 1-.55 1.92l-4.1-1.15a1 1 0 0 1-.69-1.23l1.16-4.1a1 1 0 0 1 1.23-.7Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $93cd7d40860d84f0$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $93cd7d40860d84f0$export$bbe3b42eaaf82fae = (0, $1lUIm.svg)($93cd7d40860d84f0$var$_templateObject());

});

parcelRegister("lNGeX", function(module, exports) {

$parcel$export(module.exports, "searchSvg", function () { return $fdeef0a11850ef51$export$28881e95f40c5f68; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $fdeef0a11850ef51$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 20 20">\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M9.36 4.21a5.14 5.14 0 1 0 0 10.29 5.14 5.14 0 0 0 0-10.29ZM1.64 9.36a7.71 7.71 0 1 1 14 4.47l2.52 2.5a1.29 1.29 0 1 1-1.82 1.83l-2.51-2.51A7.71 7.71 0 0 1 1.65 9.36Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $fdeef0a11850ef51$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $fdeef0a11850ef51$export$28881e95f40c5f68 = (0, $1lUIm.svg)($fdeef0a11850ef51$var$_templateObject());

});

parcelRegister("5issi", function(module, exports) {

$parcel$export(module.exports, "sendSvg", function () { return $3db4b4dbf10db0c4$export$cc4f2fc255fe3f38; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $3db4b4dbf10db0c4$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 21 20">\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M14.3808 4.34812C13.72 4.47798 12.8501 4.7587 11.5748 5.17296L9.00869 6.00646C6.90631 6.68935 5.40679 7.17779 4.38121 7.63178C3.87166 7.85734 3.5351 8.05091 3.32022 8.22035C3.11183 8.38466 3.07011 8.48486 3.05969 8.51817C2.98058 8.77103 2.98009 9.04195 3.05831 9.29509C3.06861 9.32844 3.10998 9.42878 3.31777 9.59384C3.53205 9.76404 3.86792 9.95881 4.37667 10.1862C5.29287 10.5957 6.58844 11.0341 8.35529 11.6164L10.8876 8.59854C11.2426 8.17547 11.8733 8.12028 12.2964 8.47528C12.7195 8.83029 12.7746 9.46104 12.4196 9.88412L9.88738 12.9019C10.7676 14.5408 11.4244 15.7406 11.9867 16.5718C12.299 17.0333 12.5491 17.3303 12.7539 17.5117C12.9526 17.6877 13.0586 17.711 13.0932 17.7154C13.3561 17.7484 13.6228 17.7009 13.8581 17.5791C13.8891 17.563 13.9805 17.5046 14.1061 17.2708C14.2357 17.0298 14.3679 16.6647 14.5015 16.1237C14.7705 15.0349 14.9912 13.4733 15.2986 11.2843L15.6738 8.61249C15.8603 7.28456 15.9857 6.37917 15.9989 5.7059C16.012 5.03702 15.9047 4.8056 15.8145 4.69183C15.7044 4.55297 15.5673 4.43792 15.4114 4.35365C15.2837 4.28459 15.0372 4.2191 14.3808 4.34812ZM7.99373 13.603C6.11919 12.9864 4.6304 12.4902 3.5606 12.0121C2.98683 11.7557 2.4778 11.4808 2.07383 11.1599C1.66337 10.8339 1.31312 10.4217 1.14744 9.88551C0.949667 9.24541 0.950886 8.56035 1.15094 7.92096C1.31852 7.38534 1.67024 6.97442 2.08185 6.64985C2.48697 6.33041 2.99697 6.05734 3.57166 5.80295C4.70309 5.3021 6.30179 4.78283 8.32903 4.12437L11.0196 3.25042C12.2166 2.86159 13.2017 2.54158 13.9951 2.38566C14.8065 2.22618 15.6202 2.19289 16.3627 2.59437C16.7568 2.80747 17.1035 3.09839 17.3818 3.4495C17.9062 4.111 18.0147 4.91815 17.9985 5.74496C17.9827 6.55332 17.8386 7.57903 17.6636 8.82534L17.2701 11.6268C16.9737 13.7376 16.7399 15.4022 16.4432 16.6034C16.2924 17.2135 16.1121 17.7632 15.8678 18.2176C15.6197 18.6794 15.2761 19.0971 14.7777 19.3551C14.1827 19.6632 13.5083 19.7833 12.8436 19.6997C12.2867 19.6297 11.82 19.3563 11.4277 19.0087C11.0415 18.6666 10.6824 18.213 10.3302 17.6925C9.67361 16.722 8.92648 15.342 7.99373 13.603Z"\n    clip-rule="evenodd"\n  />\n  <svg\n    xmlns="http://www.w3.org/2000/svg"\n    width="21"\n    height="20"\n    viewBox="0 0 21 20"\n    fill="none"\n  ></svg></svg\n>'
    ]);
    $3db4b4dbf10db0c4$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $3db4b4dbf10db0c4$export$cc4f2fc255fe3f38 = (0, $1lUIm.svg)($3db4b4dbf10db0c4$var$_templateObject());

});

parcelRegister("9Ilrn", function(module, exports) {

$parcel$export(module.exports, "swapHorizontalSvg", function () { return $7128dac8b9f31f16$export$43cc65051e9f7716; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $7128dac8b9f31f16$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 20 20">\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M6.76.3a1 1 0 0 1 0 1.4L4.07 4.4h9a1 1 0 1 1 0 2h-9l2.69 2.68a1 1 0 1 1-1.42 1.42L.95 6.09a1 1 0 0 1 0-1.4l4.4-4.4a1 1 0 0 1 1.4 0Zm6.49 9.21a1 1 0 0 1 1.41 0l4.39 4.4a1 1 0 0 1 0 1.4l-4.39 4.4a1 1 0 0 1-1.41-1.42l2.68-2.68h-9a1 1 0 0 1 0-2h9l-2.68-2.68a1 1 0 0 1 0-1.42Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $7128dac8b9f31f16$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $7128dac8b9f31f16$export$43cc65051e9f7716 = (0, $1lUIm.svg)($7128dac8b9f31f16$var$_templateObject());

});

parcelRegister("bSkD7", function(module, exports) {

$parcel$export(module.exports, "swapHorizontalBoldSvg", function () { return $8a54bd880e40e7a7$export$6929881544dda4e0; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $8a54bd880e40e7a7$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg width="10" height="10" viewBox="0 0 10 10">\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M3.77986 0.566631C4.0589 0.845577 4.0589 1.29784 3.77986 1.57678L3.08261 2.2738H6.34184C6.73647 2.2738 7.05637 2.5936 7.05637 2.98808C7.05637 3.38257 6.73647 3.70237 6.34184 3.70237H3.08261L3.77986 4.39938C4.0589 4.67833 4.0589 5.13059 3.77986 5.40954C3.50082 5.68848 3.04841 5.68848 2.76937 5.40954L0.852346 3.49316C0.573306 3.21421 0.573306 2.76195 0.852346 2.48301L2.76937 0.566631C3.04841 0.287685 3.50082 0.287685 3.77986 0.566631ZM6.22 4.59102C6.49904 4.31208 6.95145 4.31208 7.23049 4.59102L9.14751 6.5074C9.42655 6.78634 9.42655 7.23861 9.14751 7.51755L7.23049 9.43393C6.95145 9.71287 6.49904 9.71287 6.22 9.43393C5.94096 9.15498 5.94096 8.70272 6.22 8.42377L6.91725 7.72676L3.65802 7.72676C3.26339 7.72676 2.94349 7.40696 2.94349 7.01247C2.94349 6.61798 3.26339 6.29819 3.65802 6.29819L6.91725 6.29819L6.22 5.60117C5.94096 5.32223 5.94096 4.86997 6.22 4.59102Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $8a54bd880e40e7a7$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $8a54bd880e40e7a7$export$6929881544dda4e0 = (0, $1lUIm.svg)($8a54bd880e40e7a7$var$_templateObject());

});

parcelRegister("jhVRd", function(module, exports) {

$parcel$export(module.exports, "swapHorizontalMediumSvg", function () { return $e0ac7c1ef0a37909$export$f0d7b23b1c8e0312; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $e0ac7c1ef0a37909$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg\n  width="14"\n  height="14"\n  viewBox="0 0 14 14"\n  fill="none"\n  xmlns="http://www.w3.org/2000/svg"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M13.7306 3.24213C14.0725 3.58384 14.0725 4.13786 13.7306 4.47957L10.7418 7.46737C10.4 7.80908 9.84581 7.80908 9.50399 7.46737C9.16216 7.12567 9.16216 6.57165 9.50399 6.22994L10.9986 4.73585H5.34082C4.85741 4.73585 4.46553 4.3441 4.46553 3.86085C4.46553 3.3776 4.85741 2.98585 5.34082 2.98585L10.9986 2.98585L9.50399 1.49177C9.16216 1.15006 9.16216 0.596037 9.50399 0.254328C9.84581 -0.0873803 10.4 -0.0873803 10.7418 0.254328L13.7306 3.24213ZM9.52515 10.1352C9.52515 10.6185 9.13327 11.0102 8.64986 11.0102L2.9921 11.0102L4.48669 12.5043C4.82852 12.846 4.82852 13.4001 4.48669 13.7418C4.14487 14.0835 3.59066 14.0835 3.24884 13.7418L0.26003 10.754C0.0958806 10.5899 0.0036621 10.3673 0.00366211 10.1352C0.00366212 9.90318 0.0958806 9.68062 0.26003 9.51652L3.24884 6.52872C3.59066 6.18701 4.14487 6.18701 4.48669 6.52872C4.82851 6.87043 4.82851 7.42445 4.48669 7.76616L2.9921 9.26024L8.64986 9.26024C9.13327 9.26024 9.52515 9.65199 9.52515 10.1352Z"\n    fill="currentColor"\n  />\n</svg>\n\n'
    ]);
    $e0ac7c1ef0a37909$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $e0ac7c1ef0a37909$export$f0d7b23b1c8e0312 = (0, $1lUIm.svg)($e0ac7c1ef0a37909$var$_templateObject());

});

parcelRegister("8z4p1", function(module, exports) {

$parcel$export(module.exports, "swapHorizontalRoundedBoldSvg", function () { return $63c501da9ab3897f$export$30367478a181008c; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $63c501da9ab3897f$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">\n  <path \n    fill="currentColor"\n    fill-rule="evenodd" \n    clip-rule="evenodd" \n    d="M8.3071 0.292893C8.69763 0.683417 8.69763 1.31658 8.3071 1.70711L6.41421 3.6H11.3404C13.8368 3.6 16.0533 5.1975 16.8427 7.56588L16.9487 7.88377C17.1233 8.40772 16.8402 8.97404 16.3162 9.14868C15.7923 9.32333 15.226 9.04017 15.0513 8.51623L14.9453 8.19834C14.4281 6.64664 12.976 5.6 11.3404 5.6H6.41421L8.3071 7.49289C8.69763 7.88342 8.69763 8.51658 8.3071 8.90711C7.91658 9.29763 7.28341 9.29763 6.89289 8.90711L3.29289 5.30711C2.90236 4.91658 2.90236 4.28342 3.29289 3.89289L6.89289 0.292893C7.28341 -0.0976311 7.91658 -0.0976311 8.3071 0.292893ZM3.68377 10.8513C4.20771 10.6767 4.77403 10.9598 4.94868 11.4838L5.05464 11.8017C5.57188 13.3534 7.024 14.4 8.65964 14.4L13.5858 14.4L11.6929 12.5071C11.3024 12.1166 11.3024 11.4834 11.6929 11.0929C12.0834 10.7024 12.7166 10.7024 13.1071 11.0929L16.7071 14.6929C17.0976 15.0834 17.0976 15.7166 16.7071 16.1071L13.1071 19.7071C12.7166 20.0976 12.0834 20.0976 11.6929 19.7071C11.3024 19.3166 11.3024 18.6834 11.6929 18.2929L13.5858 16.4L8.65964 16.4C6.16314 16.4 3.94674 14.8025 3.15728 12.4341L3.05131 12.1162C2.87667 11.5923 3.15983 11.026 3.68377 10.8513Z" \n  />\n</svg>'
    ]);
    $63c501da9ab3897f$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $63c501da9ab3897f$export$30367478a181008c = (0, $1lUIm.svg)($63c501da9ab3897f$var$_templateObject());

});

parcelRegister("70FMn", function(module, exports) {

$parcel$export(module.exports, "swapVerticalSvg", function () { return $51a8f0fc74b9efdd$export$8fbc1b2c09145763; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $51a8f0fc74b9efdd$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 14 14">\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M3.48 2.18a1 1 0 0 1 1.41 0l2.68 2.68a1 1 0 1 1-1.41 1.42l-.98-.98v4.56a1 1 0 0 1-2 0V5.3l-.97.98A1 1 0 0 1 .79 4.86l2.69-2.68Zm6.34 2.93a1 1 0 0 1 1 1v4.56l.97-.98a1 1 0 1 1 1.42 1.42l-2.69 2.68a1 1 0 0 1-1.41 0l-2.68-2.68a1 1 0 0 1 1.41-1.42l.98.98V6.1a1 1 0 0 1 1-1Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $51a8f0fc74b9efdd$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $51a8f0fc74b9efdd$export$8fbc1b2c09145763 = (0, $1lUIm.svg)($51a8f0fc74b9efdd$var$_templateObject());

});

parcelRegister("jTGoD", function(module, exports) {

$parcel$export(module.exports, "telegramSvg", function () { return $e7c40a62d361fb44$export$367999698d7de87a; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $e7c40a62d361fb44$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">\n  <g clip-path="url(#a)">\n    <path fill="url(#b)" d="M0 0h32v32H0z"/>\n    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.034 15.252c4.975-2.167 8.293-3.596 9.953-4.287 4.74-1.971 5.725-2.314 6.366-2.325.142-.002.457.033.662.198.172.14.22.33.243.463.022.132.05.435.028.671-.257 2.7-1.368 9.248-1.933 12.27-.24 1.28-.71 1.708-1.167 1.75-.99.091-1.743-.655-2.703-1.284-1.502-.985-2.351-1.598-3.81-2.558-1.684-1.11-.592-1.721.368-2.718.252-.261 4.619-4.233 4.703-4.594.01-.045.02-.213-.08-.301-.1-.09-.246-.059-.353-.035-.15.034-2.55 1.62-7.198 4.758-.682.468-1.298.696-1.851.684-.61-.013-1.782-.344-2.653-.628-1.069-.347-1.918-.53-1.845-1.12.039-.308.462-.623 1.27-.944Z" fill="#fff"/>\n  </g>\n  <path d="M.5 16C.5 7.44 7.44.5 16 .5 24.56.5 31.5 7.44 31.5 16c0 8.56-6.94 15.5-15.5 15.5C7.44 31.5.5 24.56.5 16Z" stroke="#141414" stroke-opacity=".05"/>\n  <defs>\n    <linearGradient id="b" x1="1600" y1="0" x2="1600" y2="3176.27" gradientUnits="userSpaceOnUse">\n      <stop stop-color="#2AABEE"/>\n      <stop offset="1" stop-color="#229ED9"/>\n    </linearGradient>\n    <clipPath id="a">\n      <path d="M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16Z" fill="#fff"/>\n    </clipPath>\n  </defs>\n</svg>'
    ]);
    $e7c40a62d361fb44$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $e7c40a62d361fb44$export$367999698d7de87a = (0, $1lUIm.svg)($e7c40a62d361fb44$var$_templateObject());

});

parcelRegister("boCoS", function(module, exports) {

$parcel$export(module.exports, "threeDotsSvg", function () { return $84bfb911a745747c$export$51d10a72e5cebc7a; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $84bfb911a745747c$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M7 3.71875C6.0335 3.71875 5.25 2.93525 5.25 1.96875C5.25 1.00225 6.0335 0.21875 7 0.21875C7.9665 0.21875 8.75 1.00225 8.75 1.96875C8.75 2.93525 7.9665 3.71875 7 3.71875Z" fill="#949E9E"/>\n  <path d="M7 8.96875C6.0335 8.96875 5.25 8.18525 5.25 7.21875C5.25 6.25225 6.0335 5.46875 7 5.46875C7.9665 5.46875 8.75 6.25225 8.75 7.21875C8.75 8.18525 7.9665 8.96875 7 8.96875Z" fill="#949E9E"/>\n  <path d="M5.25 12.4688C5.25 13.4352 6.0335 14.2187 7 14.2187C7.9665 14.2187 8.75 13.4352 8.75 12.4688C8.75 11.5023 7.9665 10.7188 7 10.7188C6.0335 10.7188 5.25 11.5023 5.25 12.4688Z" fill="#949E9E"/>\n</svg>'
    ]);
    $84bfb911a745747c$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $84bfb911a745747c$export$51d10a72e5cebc7a = (0, $1lUIm.svg)($84bfb911a745747c$var$_templateObject());

});

parcelRegister("9TWlD", function(module, exports) {

$parcel$export(module.exports, "twitchSvg", function () { return $01dc3bea6ece6ac5$export$759b73a5195b6264; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $01dc3bea6ece6ac5$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 40 40">\n  <g clip-path="url(#a)">\n    <g clip-path="url(#b)">\n      <circle cx="20" cy="19.89" r="20" fill="#5A3E85" />\n      <g clip-path="url(#c)">\n        <path\n          fill="#fff"\n          d="M18.22 25.7 20 23.91h3.34l2.1-2.1v-6.68H15.4v8.78h2.82v1.77Zm3.87-8.16h1.25v3.66H22.1v-3.66Zm-3.34 0H20v3.66h-1.25v-3.66ZM20 7.9a12 12 0 1 0 0 24 12 12 0 0 0 0-24Zm6.69 14.56-3.66 3.66h-2.72l-1.77 1.78h-1.88V26.1H13.3v-9.82l.94-2.4H26.7v8.56Z"\n        />\n      </g>\n    </g>\n  </g>\n  <defs>\n    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>\n    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>\n    <clipPath id="c"><path fill="#fff" d="M8 7.89h24v24H8z" /></clipPath>\n  </defs>\n</svg>'
    ]);
    $01dc3bea6ece6ac5$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $01dc3bea6ece6ac5$export$759b73a5195b6264 = (0, $1lUIm.svg)($01dc3bea6ece6ac5$var$_templateObject());

});

parcelRegister("f8viN", function(module, exports) {

$parcel$export(module.exports, "twitterIconSvg", function () { return $b04fe2527fdd8426$export$d6bfd63304732c58; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $b04fe2527fdd8426$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 16 16">\n  <path\n    fill="currentColor"\n    d="m14.36 4.74.01.42c0 4.34-3.3 9.34-9.34 9.34A9.3 9.3 0 0 1 0 13.03a6.6 6.6 0 0 0 4.86-1.36 3.29 3.29 0 0 1-3.07-2.28c.5.1 1 .07 1.48-.06A3.28 3.28 0 0 1 .64 6.11v-.04c.46.26.97.4 1.49.41A3.29 3.29 0 0 1 1.11 2.1a9.32 9.32 0 0 0 6.77 3.43 3.28 3.28 0 0 1 5.6-3 6.59 6.59 0 0 0 2.08-.8 3.3 3.3 0 0 1-1.45 1.82A6.53 6.53 0 0 0 16 3.04c-.44.66-1 1.23-1.64 1.7Z"\n  />\n</svg>'
    ]);
    $b04fe2527fdd8426$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $b04fe2527fdd8426$export$d6bfd63304732c58 = (0, $1lUIm.svg)($b04fe2527fdd8426$var$_templateObject());

});

parcelRegister("isReu", function(module, exports) {

$parcel$export(module.exports, "verifySvg", function () { return $d714226caf9704e6$export$dddaa7bddf7e22f; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $d714226caf9704e6$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 28 28">\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M18.1 4.76c-.42-.73-1.33-1.01-2.09-.66l-1.42.66c-.37.18-.8.18-1.18 0l-1.4-.65a1.63 1.63 0 0 0-2.1.66l-.84 1.45c-.2.34-.53.59-.92.67l-1.7.35c-.83.17-1.39.94-1.3 1.78l.19 1.56c.04.39-.08.78-.33 1.07l-1.12 1.3c-.52.6-.52 1.5 0 2.11L5 16.38c.25.3.37.68.33 1.06l-.18 1.57c-.1.83.46 1.6 1.28 1.78l1.7.35c.4.08.73.32.93.66l.84 1.43a1.63 1.63 0 0 0 2.09.66l1.41-.66c.37-.17.8-.17 1.18 0l1.43.67c.76.35 1.66.07 2.08-.65l.86-1.45c.2-.34.54-.58.92-.66l1.68-.35A1.63 1.63 0 0 0 22.84 19l-.18-1.57a1.4 1.4 0 0 1 .33-1.06l1.12-1.32c.52-.6.52-1.5 0-2.11l-1.12-1.3a1.4 1.4 0 0 1-.33-1.07l.18-1.57c.1-.83-.46-1.6-1.28-1.77l-1.68-.35a1.4 1.4 0 0 1-.92-.66l-.86-1.47Zm-3.27-3.2a4.43 4.43 0 0 1 5.69 1.78l.54.93 1.07.22a4.43 4.43 0 0 1 3.5 4.84l-.11.96.7.83a4.43 4.43 0 0 1 .02 5.76l-.72.85.1.96a4.43 4.43 0 0 1-3.5 4.84l-1.06.22-.54.92a4.43 4.43 0 0 1-5.68 1.77l-.84-.4-.82.39a4.43 4.43 0 0 1-5.7-1.79l-.51-.89-1.09-.22a4.43 4.43 0 0 1-3.5-4.84l.1-.96-.72-.85a4.43 4.43 0 0 1 .01-5.76l.71-.83-.1-.95a4.43 4.43 0 0 1 3.5-4.84l1.08-.23.53-.9a4.43 4.43 0 0 1 5.7-1.8l.81.38.83-.39ZM18.2 9.4c.65.42.84 1.28.42 1.93l-4.4 6.87a1.4 1.4 0 0 1-2.26.14L9.5 15.39a1.4 1.4 0 0 1 2.15-1.8l1.23 1.48 3.38-5.26a1.4 1.4 0 0 1 1.93-.42Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $d714226caf9704e6$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $d714226caf9704e6$export$dddaa7bddf7e22f = (0, $1lUIm.svg)($d714226caf9704e6$var$_templateObject());

});

parcelRegister("3jwXN", function(module, exports) {

$parcel$export(module.exports, "verifyFilledSvg", function () { return $269cb75397147e12$export$1f9737848f580d88; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $269cb75397147e12$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 14 14">\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="m4.1 12.43-.45-.78-.93-.2a1.65 1.65 0 0 1-1.31-1.8l.1-.86-.61-.71a1.65 1.65 0 0 1 0-2.16l.6-.7-.09-.85c-.1-.86.47-1.64 1.3-1.81l.94-.2.45-.78A1.65 1.65 0 0 1 6.23.9l.77.36.78-.36c.77-.36 1.69-.07 2.12.66l.47.8.91.2c.84.17 1.4.95 1.31 1.8l-.1.86.6.7c.54.62.54 1.54.01 2.16l-.6.71.09.86c.1.85-.47 1.63-1.3 1.8l-.92.2-.47.79a1.65 1.65 0 0 1-2.12.66L7 12.74l-.77.36c-.78.35-1.7.07-2.13-.67Zm5.74-6.9a1 1 0 1 0-1.68-1.07L6.32 7.3l-.55-.66a1 1 0 0 0-1.54 1.28l1.43 1.71a1 1 0 0 0 1.61-.1l2.57-4Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $269cb75397147e12$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $269cb75397147e12$export$1f9737848f580d88 = (0, $1lUIm.svg)($269cb75397147e12$var$_templateObject());

});

parcelRegister("39yXv", function(module, exports) {

$parcel$export(module.exports, "walletPlaceholderSvg", function () { return $24bd5474bbba2918$export$e1456ec7b14fe70e; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $24bd5474bbba2918$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n  <svg fill="none" viewBox="0 0 48 44">\n    <path\n      style="fill: var(--wui-color-bg-300);"\n      d="M4.56 8.64c-1.23 1.68-1.23 4.08-1.23 8.88v8.96c0 4.8 0 7.2 1.23 8.88.39.55.87 1.02 1.41 1.42C7.65 38 10.05 38 14.85 38h14.3c4.8 0 7.2 0 8.88-1.22a6.4 6.4 0 0 0 1.41-1.42c.83-1.14 1.1-2.6 1.19-4.92a6.4 6.4 0 0 0 5.16-4.65c.21-.81.21-1.8.21-3.79 0-1.98 0-2.98-.22-3.79a6.4 6.4 0 0 0-5.15-4.65c-.1-2.32-.36-3.78-1.19-4.92a6.4 6.4 0 0 0-1.41-1.42C36.35 6 33.95 6 29.15 6h-14.3c-4.8 0-7.2 0-8.88 1.22a6.4 6.4 0 0 0-1.41 1.42Z"\n    />\n    <path\n      style="fill: var(--wui-color-fg-200);"\n      fill-rule="evenodd"\n      d="M2.27 11.33a6.4 6.4 0 0 1 6.4-6.4h26.66a6.4 6.4 0 0 1 6.4 6.4v1.7a6.4 6.4 0 0 1 5.34 6.3v5.34a6.4 6.4 0 0 1-5.34 6.3v1.7a6.4 6.4 0 0 1-6.4 6.4H8.67a6.4 6.4 0 0 1-6.4-6.4V11.33ZM39.6 31.07h-6.93a9.07 9.07 0 1 1 0-18.14h6.93v-1.6a4.27 4.27 0 0 0-4.27-4.26H8.67a4.27 4.27 0 0 0-4.27 4.26v21.34a4.27 4.27 0 0 0 4.27 4.26h26.66a4.27 4.27 0 0 0 4.27-4.26v-1.6Zm-6.93-16a6.93 6.93 0 0 0 0 13.86h8a4.27 4.27 0 0 0 4.26-4.26v-5.34a4.27 4.27 0 0 0-4.26-4.26h-8Z"\n      clip-rule="evenodd"\n    />\n  </svg>\n'
    ]);
    $24bd5474bbba2918$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $24bd5474bbba2918$export$e1456ec7b14fe70e = (0, $1lUIm.svg)($24bd5474bbba2918$var$_templateObject());

});

parcelRegister("igpBp", function(module, exports) {

$parcel$export(module.exports, "walletSvg", function () { return $d4bd94bdc5d31a2b$export$9025df5921500944; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $d4bd94bdc5d31a2b$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 20 20">\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M0 5.5c0-1.8 1.46-3.25 3.25-3.25H14.5c1.8 0 3.25 1.46 3.25 3.25v.28A3.25 3.25 0 0 1 20 8.88v2.24c0 1.45-.94 2.68-2.25 3.1v.28c0 1.8-1.46 3.25-3.25 3.25H3.25A3.25 3.25 0 0 1 0 14.5v-9Zm15.75 8.88h-2.38a4.38 4.38 0 0 1 0-8.76h2.38V5.5c0-.69-.56-1.25-1.25-1.25H3.25C2.56 4.25 2 4.81 2 5.5v9c0 .69.56 1.25 1.25 1.25H14.5c.69 0 1.25-.56 1.25-1.25v-.13Zm-2.38-6.76a2.37 2.37 0 1 0 0 4.75h3.38c.69 0 1.25-.55 1.25-1.24V8.87c0-.69-.56-1.24-1.25-1.24h-3.38Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $d4bd94bdc5d31a2b$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $d4bd94bdc5d31a2b$export$9025df5921500944 = (0, $1lUIm.svg)($d4bd94bdc5d31a2b$var$_templateObject());

});

parcelRegister("h1Dic", function(module, exports) {

$parcel$export(module.exports, "walletConnectSvg", function () { return $c651025c0e8e13a5$export$84e288e571149f90; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $c651025c0e8e13a5$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 96 67">\n  <path\n    fill="currentColor"\n    d="M25.32 18.8a32.56 32.56 0 0 1 45.36 0l1.5 1.47c.63.62.63 1.61 0 2.22l-5.15 5.05c-.31.3-.82.3-1.14 0l-2.07-2.03a22.71 22.71 0 0 0-31.64 0l-2.22 2.18c-.31.3-.82.3-1.14 0l-5.15-5.05a1.55 1.55 0 0 1 0-2.22l1.65-1.62Zm56.02 10.44 4.59 4.5c.63.6.63 1.6 0 2.21l-20.7 20.26c-.62.61-1.63.61-2.26 0L48.28 41.83a.4.4 0 0 0-.56 0L33.03 56.21c-.63.61-1.64.61-2.27 0L10.07 35.95a1.55 1.55 0 0 1 0-2.22l4.59-4.5a1.63 1.63 0 0 1 2.27 0L31.6 43.63a.4.4 0 0 0 .57 0l14.69-14.38a1.63 1.63 0 0 1 2.26 0l14.69 14.38a.4.4 0 0 0 .57 0l14.68-14.38a1.63 1.63 0 0 1 2.27 0Z"\n  />\n  <path\n    stroke="#000"\n    stroke-opacity=".1"\n    d="M25.67 19.15a32.06 32.06 0 0 1 44.66 0l1.5 1.48c.43.42.43 1.09 0 1.5l-5.15 5.05a.31.31 0 0 1-.44 0l-2.07-2.03a23.21 23.21 0 0 0-32.34 0l-2.22 2.18a.31.31 0 0 1-.44 0l-5.15-5.05a1.05 1.05 0 0 1 0-1.5l1.65-1.63ZM81 29.6l4.6 4.5c.42.41.42 1.09 0 1.5l-20.7 20.26c-.43.43-1.14.43-1.57 0L48.63 41.47a.9.9 0 0 0-1.26 0L32.68 55.85c-.43.43-1.14.43-1.57 0L10.42 35.6a1.05 1.05 0 0 1 0-1.5l4.59-4.5a1.13 1.13 0 0 1 1.57 0l14.68 14.38a.9.9 0 0 0 1.27 0l-.35-.35.35.35L47.22 29.6a1.13 1.13 0 0 1 1.56 0l14.7 14.38a.9.9 0 0 0 1.26 0L79.42 29.6a1.13 1.13 0 0 1 1.57 0Z"\n  />\n</svg>'
    ]);
    $c651025c0e8e13a5$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $c651025c0e8e13a5$export$84e288e571149f90 = (0, $1lUIm.svg)($c651025c0e8e13a5$var$_templateObject());

});

parcelRegister("gHJcF", function(module, exports) {

$parcel$export(module.exports, "warningCircleSvg", function () { return $c293b9f46da571b7$export$6e55d6021a3f4197; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $c293b9f46da571b7$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 20 20">\n  <path\n    fill="currentColor"\n    d="M11 6.67a1 1 0 1 0-2 0v2.66a1 1 0 0 0 2 0V6.67ZM10 14.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"\n  />\n  <path\n    fill="currentColor"\n    fill-rule="evenodd"\n    d="M10 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm-7 9a7 7 0 1 1 14 0 7 7 0 0 1-14 0Z"\n    clip-rule="evenodd"\n  />\n</svg>'
    ]);
    $c293b9f46da571b7$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $c293b9f46da571b7$export$6e55d6021a3f4197 = (0, $1lUIm.svg)($c293b9f46da571b7$var$_templateObject());

});

parcelRegister("iZBOB", function(module, exports) {

$parcel$export(module.exports, "lightbulbSvg", function () { return $dd3b41d1124e2674$export$e3455d95c95b44fb; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $dd3b41d1124e2674$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M5.00177 1.78569C3.8179 1.78569 2.85819 2.74508 2.85819 3.92855C2.85819 4.52287 3.09928 5.05956 3.49077 5.4485L3.5005 5.45817C3.64381 5.60054 3.76515 5.72108 3.85631 5.81845C3.93747 5.90512 4.05255 6.03218 4.12889 6.1805C4.16999 6.26034 4.19 6.30843 4.21768 6.39385C4.22145 6.40546 4.22499 6.41703 4.22833 6.42855H5.77521C5.77854 6.41703 5.78208 6.40547 5.78585 6.39385C5.81353 6.30843 5.83354 6.26034 5.87464 6.1805C5.95098 6.03218 6.06606 5.90512 6.14722 5.81845C6.23839 5.72108 6.35973 5.60053 6.50304 5.45816L6.51276 5.4485C6.90425 5.05956 7.14534 4.52287 7.14534 3.92855C7.14534 2.74508 6.18563 1.78569 5.00177 1.78569ZM5.71629 7.85712H4.28724C4.28724 8.21403 4.28876 8.40985 4.30703 8.54571C4.30727 8.54748 4.30751 8.54921 4.30774 8.55091C4.30944 8.55115 4.31118 8.55138 4.31295 8.55162C4.44884 8.56989 4.64474 8.5714 5.00177 8.5714C5.3588 8.5714 5.55469 8.56989 5.69059 8.55162C5.69236 8.55138 5.69409 8.55115 5.69579 8.55091C5.69603 8.54921 5.69627 8.54748 5.6965 8.54571C5.71477 8.40985 5.71629 8.21403 5.71629 7.85712ZM2.85819 7.14283C2.85819 6.9948 2.85796 6.91114 2.8548 6.85032C2.85461 6.84656 2.85441 6.84309 2.85421 6.83988C2.84393 6.8282 2.83047 6.81334 2.81301 6.79469C2.74172 6.71856 2.63908 6.61643 2.48342 6.46178C1.83307 5.81566 1.42914 4.91859 1.42914 3.92855C1.42914 1.9561 3.02866 0.357117 5.00177 0.357117C6.97487 0.357117 8.57439 1.9561 8.57439 3.92855C8.57439 4.91859 8.17047 5.81566 7.52012 6.46178C7.36445 6.61643 7.26182 6.71856 7.19053 6.79469C7.17306 6.81334 7.1596 6.8282 7.14932 6.83988C7.14912 6.84309 7.14892 6.84656 7.14873 6.85032C7.14557 6.91114 7.14534 6.9948 7.14534 7.14283V7.85712C7.14534 7.87009 7.14535 7.88304 7.14535 7.89598C7.14541 8.19889 7.14547 8.49326 7.11281 8.73606C7.076 9.00978 6.98631 9.32212 6.72678 9.58156C6.46726 9.841 6.15481 9.93065 5.881 9.96745C5.63813 10.0001 5.34365 10 5.04064 9.99998C5.0277 9.99998 5.01474 9.99998 5.00177 9.99998C4.98879 9.99998 4.97583 9.99998 4.96289 9.99998C4.65988 10 4.36541 10.0001 4.12253 9.96745C3.84872 9.93065 3.53628 9.841 3.27675 9.58156C3.01722 9.32212 2.92753 9.00978 2.89072 8.73606C2.85807 8.49326 2.85812 8.19889 2.85818 7.89598C2.85819 7.88304 2.85819 7.87008 2.85819 7.85712V7.14283ZM7.1243 6.86977C7.12366 6.87069 7.1233 6.87116 7.12327 6.87119C7.12323 6.87123 7.12356 6.87076 7.1243 6.86977ZM2.88027 6.8712C2.88025 6.87119 2.87988 6.8707 2.87921 6.86975C2.87995 6.87072 2.88028 6.8712 2.88027 6.8712Z" fill="#949E9E"/>\n</svg>'
    ]);
    $dd3b41d1124e2674$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $dd3b41d1124e2674$export$e3455d95c95b44fb = (0, $1lUIm.svg)($dd3b41d1124e2674$var$_templateObject());

});

parcelRegister("i8pSG", function(module, exports) {

$parcel$export(module.exports, "idSvg", function () { return $d33d0ccbeb05dc97$export$617f4a80e2acdd4f; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $d33d0ccbeb05dc97$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg\n xmlns="http://www.w3.org/2000/svg"\n width="28"\n height="28"\n viewBox="0 0 28 28"\n fill="none">\n  <path\n    fill="#949E9E"\n    fill-rule="evenodd"\n    d="M7.974 2.975h12.052c1.248 0 2.296 0 3.143.092.89.096 1.723.307 2.461.844a4.9 4.9 0 0 1 1.084 1.084c.537.738.748 1.57.844 2.461.092.847.092 1.895.092 3.143v6.802c0 1.248 0 2.296-.092 3.143-.096.89-.307 1.723-.844 2.461a4.9 4.9 0 0 1-1.084 1.084c-.738.537-1.57.748-2.461.844-.847.092-1.895.092-3.143.092H7.974c-1.247 0-2.296 0-3.143-.092-.89-.096-1.723-.307-2.461-.844a4.901 4.901 0 0 1-1.084-1.084c-.537-.738-.748-1.571-.844-2.461C.35 19.697.35 18.649.35 17.4v-6.802c0-1.248 0-2.296.092-3.143.096-.89.307-1.723.844-2.461A4.9 4.9 0 0 1 2.37 3.91c.738-.537 1.571-.748 2.461-.844.847-.092 1.895-.092 3.143-.092ZM5.133 5.85c-.652.071-.936.194-1.117.326a2.1 2.1 0 0 0-.465.465c-.132.181-.255.465-.325 1.117-.074.678-.076 1.573-.076 2.917v6.65c0 1.344.002 2.239.076 2.917.07.652.193.936.325 1.117a2.1 2.1 0 0 0 .465.465c.181.132.465.255 1.117.326.678.073 1.574.075 2.917.075h11.9c1.344 0 2.239-.002 2.917-.075.652-.071.936-.194 1.117-.326.179-.13.335-.286.465-.465.132-.181.255-.465.326-1.117.073-.678.075-1.573.075-2.917v-6.65c0-1.344-.002-2.239-.075-2.917-.071-.652-.194-.936-.326-1.117a2.1 2.1 0 0 0-.465-.465c-.181-.132-.465-.255-1.117-.326-.678-.073-1.573-.075-2.917-.075H8.05c-1.343 0-2.239.002-2.917.075Zm.467 7.275a3.15 3.15 0 1 1 6.3 0 3.15 3.15 0 0 1-6.3 0Zm8.75-1.75a1.4 1.4 0 0 1 1.4-1.4h3.5a1.4 1.4 0 0 1 0 2.8h-3.5a1.4 1.4 0 0 1-1.4-1.4Zm0 5.25a1.4 1.4 0 0 1 1.4-1.4H21a1.4 1.4 0 1 1 0 2.8h-5.25a1.4 1.4 0 0 1-1.4-1.4Z"\n    clip-rule="evenodd"/>\n</svg>'
    ]);
    $d33d0ccbeb05dc97$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $d33d0ccbeb05dc97$export$617f4a80e2acdd4f = (0, $1lUIm.svg)($d33d0ccbeb05dc97$var$_templateObject());

});

parcelRegister("lOLVO", function(module, exports) {

$parcel$export(module.exports, "xSvg", function () { return $fe2372a94941bc07$export$de73a2de604c6323; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $fe2372a94941bc07$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 41 40">\n  <g clip-path="url(#a)">\n    <path fill="#000" d="M.8 0h40v40H.8z" />\n    <path\n      fill="#fff"\n      d="m22.63 18.46 7.14-8.3h-1.69l-6.2 7.2-4.96-7.2H11.2l7.5 10.9-7.5 8.71h1.7l6.55-7.61 5.23 7.61h5.72l-7.77-11.31Zm-9.13-7.03h2.6l11.98 17.13h-2.6L13.5 11.43Z"\n    />\n  </g>\n  <defs>\n    <clipPath id="a"><path fill="#fff" d="M.8 20a20 20 0 1 1 40 0 20 20 0 0 1-40 0Z" /></clipPath>\n  </defs>\n</svg>'
    ]);
    $fe2372a94941bc07$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $fe2372a94941bc07$export$de73a2de604c6323 = (0, $1lUIm.svg)($fe2372a94941bc07$var$_templateObject());

});


parcelRegister("9ZbyK", function(module, exports) {

$parcel$export(module.exports, "WuiImage", function () { return $7452c702cc3f4c72$export$6985d0bcc76e605c; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $5VmRj = parcelRequire("5VmRj");
function $7452c702cc3f4c72$var$_templateObject() {
    var data = (0, $j06k0._)([
        "<img src=",
        " alt=",
        " @error=",
        " />"
    ]);
    $7452c702cc3f4c72$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $7452c702cc3f4c72$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $7452c702cc3f4c72$export$6985d0bcc76e605c = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiImage, LitElement);
    var _super = (0, $ohfOJ._)(WuiImage);
    function WuiImage() {
        (0, $4GJKx._)(this, WuiImage);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.src = "./path/to/image.jpg";
        _this.alt = "Image";
        _this.size = undefined;
        return _this;
    }
    (0, $1wc17._)(WuiImage, [
        {
            key: "render",
            value: function render() {
                this.style.cssText = "\n      --local-width: ".concat(this.size ? "var(--wui-icon-size-".concat(this.size, ");") : "100%", ";\n      --local-height: ").concat(this.size ? "var(--wui-icon-size-".concat(this.size, ");") : "100%", ";\n      ");
                return (0, $1lUIm.html)($7452c702cc3f4c72$var$_templateObject(), this.src, this.alt, this.handleImageError);
            }
        },
        {
            key: "handleImageError",
            value: function handleImageError() {
                this.dispatchEvent(new CustomEvent("onLoadError", {
                    bubbles: true,
                    composed: true
                }));
            }
        }
    ]);
    return WuiImage;
}((0, $eAsDt.LitElement));
$7452c702cc3f4c72$export$6985d0bcc76e605c.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.colorStyles),
    (0, $5VmRj.default)
];
$7452c702cc3f4c72$var$__decorate([
    (0, $siQym.property)()
], $7452c702cc3f4c72$export$6985d0bcc76e605c.prototype, "src", void 0);
$7452c702cc3f4c72$var$__decorate([
    (0, $siQym.property)()
], $7452c702cc3f4c72$export$6985d0bcc76e605c.prototype, "alt", void 0);
$7452c702cc3f4c72$var$__decorate([
    (0, $siQym.property)()
], $7452c702cc3f4c72$export$6985d0bcc76e605c.prototype, "size", void 0);
$7452c702cc3f4c72$export$6985d0bcc76e605c = $7452c702cc3f4c72$var$__decorate([
    (0, $hdxb6.customElement)("wui-image")
], $7452c702cc3f4c72$export$6985d0bcc76e605c);

});
parcelRegister("5VmRj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $450401f106f675f3$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $450401f106f675f3$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: block;\n    width: var(--local-width);\n    height: var(--local-height);\n  }\n\n  img {\n    display: block;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center center;\n    border-radius: inherit;\n  }\n"
    ]);
    $450401f106f675f3$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $450401f106f675f3$export$2e2bcd8739ae039 = (0, $bBWVO.css)($450401f106f675f3$var$_templateObject());

});


parcelRegister("gjpML", function(module, exports) {

$parcel$export(module.exports, "WuiLoadingHexagon", function () { return $be026c25d5f17da9$export$8429fc8b8d557b81; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $ek2QH = parcelRequire("ek2QH");
function $be026c25d5f17da9$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <svg viewBox="0 0 54 59">\n        <path\n          id="wui-loader-path"\n          d="M17.22 5.295c3.877-2.277 5.737-3.363 7.72-3.726a11.44 11.44 0 0 1 4.12 0c1.983.363 3.844 1.45 7.72 3.726l6.065 3.562c3.876 2.276 5.731 3.372 7.032 4.938a11.896 11.896 0 0 1 2.06 3.63c.683 1.928.688 4.11.688 8.663v7.124c0 4.553-.005 6.735-.688 8.664a11.896 11.896 0 0 1-2.06 3.63c-1.3 1.565-3.156 2.66-7.032 4.937l-6.065 3.563c-3.877 2.276-5.737 3.362-7.72 3.725a11.46 11.46 0 0 1-4.12 0c-1.983-.363-3.844-1.449-7.72-3.726l-6.065-3.562c-3.876-2.276-5.731-3.372-7.032-4.938a11.885 11.885 0 0 1-2.06-3.63c-.682-1.928-.688-4.11-.688-8.663v-7.124c0-4.553.006-6.735.688-8.664a11.885 11.885 0 0 1 2.06-3.63c1.3-1.565 3.156-2.66 7.032-4.937l6.065-3.562Z"\n        />\n        <use xlink:href="#wui-loader-path"></use>\n      </svg>\n    '
    ]);
    $be026c25d5f17da9$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $be026c25d5f17da9$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $be026c25d5f17da9$export$8429fc8b8d557b81 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiLoadingHexagon, LitElement);
    var _super = (0, $ohfOJ._)(WuiLoadingHexagon);
    function WuiLoadingHexagon() {
        (0, $4GJKx._)(this, WuiLoadingHexagon);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(WuiLoadingHexagon, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($be026c25d5f17da9$var$_templateObject());
            }
        }
    ]);
    return WuiLoadingHexagon;
}((0, $eAsDt.LitElement));
$be026c25d5f17da9$export$8429fc8b8d557b81.styles = [
    (0, $kYNxm.resetStyles),
    (0, $ek2QH.default)
];
$be026c25d5f17da9$export$8429fc8b8d557b81 = $be026c25d5f17da9$var$__decorate([
    (0, $hdxb6.customElement)("wui-loading-hexagon")
], $be026c25d5f17da9$export$8429fc8b8d557b81);

});
parcelRegister("ek2QH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6d524b856f5a068$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $a6d524b856f5a068$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: block;\n    width: var(--wui-box-size-lg);\n    height: var(--wui-box-size-lg);\n  }\n\n  svg {\n    width: var(--wui-box-size-lg);\n    height: var(--wui-box-size-lg);\n    fill: none;\n    stroke: transparent;\n    stroke-linecap: round;\n  }\n\n  use {\n    stroke: var(--wui-color-accent-100);\n    stroke-width: 2px;\n    stroke-dasharray: 54, 118;\n    stroke-dashoffset: 172;\n    animation: dash 1s linear infinite;\n  }\n\n  @keyframes dash {\n    to {\n      stroke-dashoffset: 0px;\n    }\n  }\n"
    ]);
    $a6d524b856f5a068$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $a6d524b856f5a068$export$2e2bcd8739ae039 = (0, $bBWVO.css)($a6d524b856f5a068$var$_templateObject());

});


parcelRegister("ePIOw", function(module, exports) {

$parcel$export(module.exports, "WuiLoadingSpinner", function () { return $acc8973c2caf072b$export$3a84ab9b4ee14f8a; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $90S0i = parcelRequire("90S0i");
function $acc8973c2caf072b$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg viewBox="25 25 50 50">\n      <circle r="20" cy="50" cx="50"></circle>\n    </svg>'
    ]);
    $acc8973c2caf072b$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $acc8973c2caf072b$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $acc8973c2caf072b$export$3a84ab9b4ee14f8a = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiLoadingSpinner, LitElement);
    var _super = (0, $ohfOJ._)(WuiLoadingSpinner);
    function WuiLoadingSpinner() {
        (0, $4GJKx._)(this, WuiLoadingSpinner);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.color = "accent-100";
        _this.size = "lg";
        return _this;
    }
    (0, $1wc17._)(WuiLoadingSpinner, [
        {
            key: "render",
            value: function render() {
                this.style.cssText = "--local-color: ".concat(this.color === "inherit" ? "inherit" : "var(--wui-color-".concat(this.color, ")"));
                this.dataset["size"] = this.size;
                return (0, $1lUIm.html)($acc8973c2caf072b$var$_templateObject());
            }
        }
    ]);
    return WuiLoadingSpinner;
}((0, $eAsDt.LitElement));
$acc8973c2caf072b$export$3a84ab9b4ee14f8a.styles = [
    (0, $kYNxm.resetStyles),
    (0, $90S0i.default)
];
$acc8973c2caf072b$var$__decorate([
    (0, $siQym.property)()
], $acc8973c2caf072b$export$3a84ab9b4ee14f8a.prototype, "color", void 0);
$acc8973c2caf072b$var$__decorate([
    (0, $siQym.property)()
], $acc8973c2caf072b$export$3a84ab9b4ee14f8a.prototype, "size", void 0);
$acc8973c2caf072b$export$3a84ab9b4ee14f8a = $acc8973c2caf072b$var$__decorate([
    (0, $hdxb6.customElement)("wui-loading-spinner")
], $acc8973c2caf072b$export$3a84ab9b4ee14f8a);

});
parcelRegister("90S0i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68fe012e5a753d45$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $68fe012e5a753d45$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: flex;\n  }\n\n  :host([data-size='sm']) > svg {\n    width: 12px;\n    height: 12px;\n  }\n\n  :host([data-size='md']) > svg {\n    width: 16px;\n    height: 16px;\n  }\n\n  :host([data-size='lg']) > svg {\n    width: 24px;\n    height: 24px;\n  }\n\n  :host([data-size='xl']) > svg {\n    width: 32px;\n    height: 32px;\n  }\n\n  svg {\n    animation: rotate 2s linear infinite;\n  }\n\n  circle {\n    fill: none;\n    stroke: var(--local-color);\n    stroke-width: 4px;\n    stroke-dasharray: 1, 124;\n    stroke-dashoffset: 0;\n    stroke-linecap: round;\n    animation: dash 1.5s ease-in-out infinite;\n  }\n\n  :host([data-size='md']) > svg > circle {\n    stroke-width: 6px;\n  }\n\n  :host([data-size='sm']) > svg > circle {\n    stroke-width: 8px;\n  }\n\n  @keyframes rotate {\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  @keyframes dash {\n    0% {\n      stroke-dasharray: 1, 124;\n      stroke-dashoffset: 0;\n    }\n\n    50% {\n      stroke-dasharray: 90, 124;\n      stroke-dashoffset: -35;\n    }\n\n    100% {\n      stroke-dashoffset: -125;\n    }\n  }\n"
    ]);
    $68fe012e5a753d45$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $68fe012e5a753d45$export$2e2bcd8739ae039 = (0, $bBWVO.css)($68fe012e5a753d45$var$_templateObject());

});


parcelRegister("97S8Q", function(module, exports) {

$parcel$export(module.exports, "WuiLoadingThumbnail", function () { return $6a4ec3e7a2431a1c$export$a8f5e0b29edd5ad2; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $d7WVA = parcelRequire("d7WVA");
function $6a4ec3e7a2431a1c$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <svg viewBox="0 0 110 110" width="110" height="110">\n        <rect\n          x="2"\n          y="2"\n          width="106"\n          height="106"\n          rx=',
        '\n          stroke-dasharray="',
        " ",
        '"\n          stroke-dashoffset=',
        "\n        />\n      </svg>\n    "
    ]);
    $6a4ec3e7a2431a1c$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $6a4ec3e7a2431a1c$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $6a4ec3e7a2431a1c$export$a8f5e0b29edd5ad2 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiLoadingThumbnail, LitElement);
    var _super = (0, $ohfOJ._)(WuiLoadingThumbnail);
    function WuiLoadingThumbnail() {
        (0, $4GJKx._)(this, WuiLoadingThumbnail);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.radius = 36;
        return _this;
    }
    (0, $1wc17._)(WuiLoadingThumbnail, [
        {
            key: "render",
            value: function render() {
                return this.svgLoaderTemplate();
            }
        },
        {
            key: "svgLoaderTemplate",
            value: function svgLoaderTemplate() {
                var radius = this.radius > 50 ? 50 : this.radius;
                var standardValue = 36;
                var radiusFactor = standardValue - radius;
                var dashArrayStart = 116 + radiusFactor;
                var dashArrayEnd = 245 + radiusFactor;
                var dashOffset = 360 + radiusFactor * 1.75;
                return (0, $1lUIm.html)($6a4ec3e7a2431a1c$var$_templateObject(), radius, dashArrayStart, dashArrayEnd, dashOffset);
            }
        }
    ]);
    return WuiLoadingThumbnail;
}((0, $eAsDt.LitElement));
$6a4ec3e7a2431a1c$export$a8f5e0b29edd5ad2.styles = [
    (0, $kYNxm.resetStyles),
    (0, $d7WVA.default)
];
$6a4ec3e7a2431a1c$var$__decorate([
    (0, $siQym.property)({
        type: Number
    })
], $6a4ec3e7a2431a1c$export$a8f5e0b29edd5ad2.prototype, "radius", void 0);
$6a4ec3e7a2431a1c$export$a8f5e0b29edd5ad2 = $6a4ec3e7a2431a1c$var$__decorate([
    (0, $hdxb6.customElement)("wui-loading-thumbnail")
], $6a4ec3e7a2431a1c$export$a8f5e0b29edd5ad2);

});
parcelRegister("d7WVA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98e9a3ab0bee47e6$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $98e9a3ab0bee47e6$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: block;\n    width: var(--wui-box-size-md);\n    height: var(--wui-box-size-md);\n  }\n\n  svg {\n    width: var(--wui-box-size-md);\n    height: var(--wui-box-size-md);\n  }\n\n  rect {\n    fill: none;\n    stroke: var(--wui-color-accent-100);\n    stroke-width: 4px;\n    stroke-linecap: round;\n    animation: dash 1s linear infinite;\n  }\n\n  @keyframes dash {\n    to {\n      stroke-dashoffset: 0px;\n    }\n  }\n"
    ]);
    $98e9a3ab0bee47e6$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $98e9a3ab0bee47e6$export$2e2bcd8739ae039 = (0, $bBWVO.css)($98e9a3ab0bee47e6$var$_templateObject());

});


parcelRegister("7stzQ", function(module, exports) {

$parcel$export(module.exports, "WuiShimmer", function () { return $56e21758c5402e80$export$22033065aa649938; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");

var $hdxb6 = parcelRequire("hdxb6");

var $3KA0u = parcelRequire("3KA0u");
function $56e21758c5402e80$var$_templateObject() {
    var data = (0, $j06k0._)([
        "<slot></slot>"
    ]);
    $56e21758c5402e80$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $56e21758c5402e80$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $56e21758c5402e80$export$22033065aa649938 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiShimmer, LitElement);
    var _super = (0, $ohfOJ._)(WuiShimmer);
    function WuiShimmer() {
        (0, $4GJKx._)(this, WuiShimmer);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.width = "";
        _this.height = "";
        _this.borderRadius = "m";
        _this.variant = "default";
        return _this;
    }
    (0, $1wc17._)(WuiShimmer, [
        {
            key: "render",
            value: function render() {
                this.style.cssText = "\n      width: ".concat(this.width, ";\n      height: ").concat(this.height, ";\n      border-radius: ").concat("clamp(0px,var(--wui-border-radius-".concat(this.borderRadius, "), 40px)"), ";\n    ");
                return (0, $1lUIm.html)($56e21758c5402e80$var$_templateObject());
            }
        }
    ]);
    return WuiShimmer;
}((0, $eAsDt.LitElement));
$56e21758c5402e80$export$22033065aa649938.styles = [
    (0, $3KA0u.default)
];
$56e21758c5402e80$var$__decorate([
    (0, $siQym.property)()
], $56e21758c5402e80$export$22033065aa649938.prototype, "width", void 0);
$56e21758c5402e80$var$__decorate([
    (0, $siQym.property)()
], $56e21758c5402e80$export$22033065aa649938.prototype, "height", void 0);
$56e21758c5402e80$var$__decorate([
    (0, $siQym.property)()
], $56e21758c5402e80$export$22033065aa649938.prototype, "borderRadius", void 0);
$56e21758c5402e80$var$__decorate([
    (0, $siQym.property)()
], $56e21758c5402e80$export$22033065aa649938.prototype, "variant", void 0);
$56e21758c5402e80$export$22033065aa649938 = $56e21758c5402e80$var$__decorate([
    (0, $hdxb6.customElement)("wui-shimmer")
], $56e21758c5402e80$export$22033065aa649938);

});
parcelRegister("3KA0u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2bb1992f8bb719db$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $2bb1992f8bb719db$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: block;\n    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-005);\n    background: linear-gradient(\n      120deg,\n      var(--wui-color-bg-200) 5%,\n      var(--wui-color-bg-200) 48%,\n      var(--wui-color-bg-300) 55%,\n      var(--wui-color-bg-300) 60%,\n      var(--wui-color-bg-300) calc(60% + 10px),\n      var(--wui-color-bg-200) calc(60% + 12px),\n      var(--wui-color-bg-200) 100%\n    );\n    background-size: 250%;\n    animation: shimmer 3s linear infinite reverse;\n  }\n\n  :host([variant='light']) {\n    background: linear-gradient(\n      120deg,\n      var(--wui-color-bg-150) 5%,\n      var(--wui-color-bg-150) 48%,\n      var(--wui-color-bg-200) 55%,\n      var(--wui-color-bg-200) 60%,\n      var(--wui-color-bg-200) calc(60% + 10px),\n      var(--wui-color-bg-150) calc(60% + 12px),\n      var(--wui-color-bg-150) 100%\n    );\n    background-size: 250%;\n  }\n\n  @keyframes shimmer {\n    from {\n      background-position: -250% 0;\n    }\n    to {\n      background-position: 250% 0;\n    }\n  }\n"
    ]);
    $2bb1992f8bb719db$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $2bb1992f8bb719db$export$2e2bcd8739ae039 = (0, $bBWVO.css)($2bb1992f8bb719db$var$_templateObject());

});


parcelRegister("1OYaf", function(module, exports) {

$parcel$export(module.exports, "WuiText", function () { return $153921555e8edbfd$export$406e1aa02d8022e4; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $3sHb8 = parcelRequire("3sHb8");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("248Kv");
var $a1EIv = parcelRequire("a1EIv");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $jCAAM = parcelRequire("jCAAM");
function $153921555e8edbfd$var$_templateObject() {
    var data = (0, $j06k0._)([
        "<slot class=",
        "></slot>"
    ]);
    $153921555e8edbfd$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $153921555e8edbfd$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $153921555e8edbfd$export$406e1aa02d8022e4 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiText, LitElement);
    var _super = (0, $ohfOJ._)(WuiText);
    function WuiText() {
        (0, $4GJKx._)(this, WuiText);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.variant = "paragraph-500";
        _this.color = "fg-300";
        _this.align = "left";
        _this.lineClamp = undefined;
        return _this;
    }
    (0, $1wc17._)(WuiText, [
        {
            key: "render",
            value: function render() {
                var _obj;
                var classes = (_obj = {}, (0, $3sHb8._)(_obj, "wui-font-".concat(this.variant), true), (0, $3sHb8._)(_obj, "wui-color-".concat(this.color), true), (0, $3sHb8._)(_obj, "wui-line-clamp-".concat(this.lineClamp), this.lineClamp ? true : false), _obj);
                this.style.cssText = "\n      --local-align: ".concat(this.align, ";\n      --local-color: var(--wui-color-").concat(this.color, ");\n    ");
                return (0, $1lUIm.html)($153921555e8edbfd$var$_templateObject(), (0, $a1EIv.classMap)(classes));
            }
        }
    ]);
    return WuiText;
}((0, $eAsDt.LitElement));
$153921555e8edbfd$export$406e1aa02d8022e4.styles = [
    (0, $kYNxm.resetStyles),
    (0, $jCAAM.default)
];
$153921555e8edbfd$var$__decorate([
    (0, $siQym.property)()
], $153921555e8edbfd$export$406e1aa02d8022e4.prototype, "variant", void 0);
$153921555e8edbfd$var$__decorate([
    (0, $siQym.property)()
], $153921555e8edbfd$export$406e1aa02d8022e4.prototype, "color", void 0);
$153921555e8edbfd$var$__decorate([
    (0, $siQym.property)()
], $153921555e8edbfd$export$406e1aa02d8022e4.prototype, "align", void 0);
$153921555e8edbfd$var$__decorate([
    (0, $siQym.property)()
], $153921555e8edbfd$export$406e1aa02d8022e4.prototype, "lineClamp", void 0);
$153921555e8edbfd$export$406e1aa02d8022e4 = $153921555e8edbfd$var$__decorate([
    (0, $hdxb6.customElement)("wui-text")
], $153921555e8edbfd$export$406e1aa02d8022e4);

});
parcelRegister("248Kv", function(module, exports) {
$parcel$export(module.exports, "classMap", function () { return (parcelRequire("a1EIv")).classMap; });
parcelRequire("a1EIv");

});
parcelRegister("a1EIv", function(module, exports) {

$parcel$export(module.exports, "classMap", function () { return $74c994e7f55fc263$export$56cc687933817664; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $3U0IP = parcelRequire("3U0IP");

var $cv9Rk = parcelRequire("cv9Rk");

var $ohfOJ = parcelRequire("ohfOJ");

var $1lUIm = parcelRequire("1lUIm");

var $1iYSS = parcelRequire("1iYSS");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $74c994e7f55fc263$export$56cc687933817664 = (0, $1iYSS.directive)(/*#__PURE__*/ function(i) {
    "use strict";
    (0, $dcsZi._)(_class, i);
    var _super = (0, $ohfOJ._)(_class);
    function _class(s) {
        (0, $4GJKx._)(this, _class);
        var _this;
        var _s_strings;
        if (_this = _super.call(this, s), s.type !== (0, $1iYSS.PartType).ATTRIBUTE || "class" !== s.name || ((_s_strings = s.strings) === null || _s_strings === void 0 ? void 0 : _s_strings.length) > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
        return (0, $3U0IP._)(_this);
    }
    (0, $1wc17._)(_class, [
        {
            key: "render",
            value: function render(t) {
                return " " + Object.keys(t).filter(function(s) {
                    return t[s];
                }).join(" ") + " ";
            }
        },
        {
            key: "update",
            value: function update(t, param) {
                var _param = (0, $cv9Rk._)(param, 1), s = _param[0];
                if (void 0 === this.st) {
                    var _this_nt;
                    this.st = new Set, void 0 !== t.strings && (this.nt = new Set(t.strings.join(" ").split(/\s/).filter(function(t) {
                        return "" !== t;
                    })));
                    for(var _$t in s)s[_$t] && !((_this_nt = this.nt) === null || _this_nt === void 0 ? void 0 : _this_nt.has(_$t)) && this.st.add(_$t);
                    return this.render(s);
                }
                var _$i = t.element.classList;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.st[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$t1 = _step.value;
                        _$t1 in s || (_$i.remove(_$t1), this.st.delete(_$t1));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                for(var _$t2 in s){
                    var _this_nt1;
                    var r = !!s[_$t2];
                    r === this.st.has(_$t2) || ((_this_nt1 = this.nt) === null || _this_nt1 === void 0 ? void 0 : _this_nt1.has(_$t2)) || (r ? (_$i.add(_$t2), this.st.add(_$t2)) : (_$i.remove(_$t2), this.st.delete(_$t2)));
                }
                return 0, $1lUIm.noChange;
            }
        }
    ]);
    return _class;
}((0, $1iYSS.Directive)));

});
parcelRegister("1iYSS", function(module, exports) {

$parcel$export(module.exports, "PartType", function () { return $0f36b3316f68e9f0$export$9ba3b3f20a85bfa; });
$parcel$export(module.exports, "directive", function () { return $0f36b3316f68e9f0$export$99b43ad1ed32e735; });
$parcel$export(module.exports, "Directive", function () { return $0f36b3316f68e9f0$export$befdefbdce210f91; });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ 
var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $c6Xmf = parcelRequire("c6Xmf");
var $0f36b3316f68e9f0$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $0f36b3316f68e9f0$export$99b43ad1ed32e735 = function(t) {
    return function() {
        for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
            e[_key] = arguments[_key];
        }
        return {
            _$litDirective$: t,
            values: e
        };
    };
};
var $0f36b3316f68e9f0$export$befdefbdce210f91 = /*#__PURE__*/ function() {
    "use strict";
    function i(t) {
        (0, $4GJKx._)(this, i);
    }
    (0, $1wc17._)(i, [
        {
            key: "_$AU",
            get: function get() {
                return this._$AM._$AU;
            }
        },
        {
            key: "_$AT",
            value: function _$AT(t, e, i) {
                this.t = t, this._$AM = e, this.i = i;
            }
        },
        {
            key: "_$AS",
            value: function _$AS(t, e) {
                return this.update(t, e);
            }
        },
        {
            key: "update",
            value: function update(t, e) {
                return this.render.apply(this, (0, $c6Xmf._)(e));
            }
        }
    ]);
    return i;
}();

});



parcelRegister("jCAAM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e48df367c3b0c8d2$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $e48df367c3b0c8d2$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: inline-flex !important;\n  }\n\n  slot {\n    width: 100%;\n    display: inline-block;\n    font-style: normal;\n    font-family: var(--wui-font-family);\n    font-feature-settings:\n      'tnum' on,\n      'lnum' on,\n      'case' on;\n    line-height: 130%;\n    font-weight: var(--wui-font-weight-regular);\n    overflow: inherit;\n    text-overflow: inherit;\n    text-align: var(--local-align);\n    color: var(--local-color);\n  }\n\n  .wui-line-clamp-1 {\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 1;\n  }\n\n  .wui-line-clamp-2 {\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n  }\n\n  .wui-font-medium-400 {\n    font-size: var(--wui-font-size-medium);\n    font-weight: var(--wui-font-weight-light);\n    letter-spacing: var(--wui-letter-spacing-medium);\n  }\n\n  .wui-font-medium-600 {\n    font-size: var(--wui-font-size-medium);\n    letter-spacing: var(--wui-letter-spacing-medium);\n  }\n\n  .wui-font-title-600 {\n    font-size: var(--wui-font-size-title);\n    letter-spacing: var(--wui-letter-spacing-title);\n  }\n\n  .wui-font-title-6-600 {\n    font-size: var(--wui-font-size-title-6);\n    letter-spacing: var(--wui-letter-spacing-title-6);\n  }\n\n  .wui-font-mini-700 {\n    font-size: var(--wui-font-size-mini);\n    letter-spacing: var(--wui-letter-spacing-mini);\n    text-transform: uppercase;\n  }\n\n  .wui-font-large-500,\n  .wui-font-large-600,\n  .wui-font-large-700 {\n    font-size: var(--wui-font-size-large);\n    letter-spacing: var(--wui-letter-spacing-large);\n  }\n\n  .wui-font-2xl-500,\n  .wui-font-2xl-600,\n  .wui-font-2xl-700 {\n    font-size: var(--wui-font-size-2xl);\n    letter-spacing: var(--wui-letter-spacing-2xl);\n  }\n\n  .wui-font-paragraph-400,\n  .wui-font-paragraph-500,\n  .wui-font-paragraph-600,\n  .wui-font-paragraph-700 {\n    font-size: var(--wui-font-size-paragraph);\n    letter-spacing: var(--wui-letter-spacing-paragraph);\n  }\n\n  .wui-font-small-400,\n  .wui-font-small-500,\n  .wui-font-small-600 {\n    font-size: var(--wui-font-size-small);\n    letter-spacing: var(--wui-letter-spacing-small);\n  }\n\n  .wui-font-tiny-400,\n  .wui-font-tiny-500,\n  .wui-font-tiny-600 {\n    font-size: var(--wui-font-size-tiny);\n    letter-spacing: var(--wui-letter-spacing-tiny);\n  }\n\n  .wui-font-micro-700,\n  .wui-font-micro-600 {\n    font-size: var(--wui-font-size-micro);\n    letter-spacing: var(--wui-letter-spacing-micro);\n    text-transform: uppercase;\n  }\n\n  .wui-font-tiny-400,\n  .wui-font-small-400,\n  .wui-font-medium-400,\n  .wui-font-paragraph-400 {\n    font-weight: var(--wui-font-weight-light);\n  }\n\n  .wui-font-large-700,\n  .wui-font-paragraph-700,\n  .wui-font-micro-700,\n  .wui-font-mini-700 {\n    font-weight: var(--wui-font-weight-bold);\n  }\n\n  .wui-font-medium-600,\n  .wui-font-medium-title-600,\n  .wui-font-title-6-600,\n  .wui-font-large-600,\n  .wui-font-paragraph-600,\n  .wui-font-small-600,\n  .wui-font-tiny-600,\n  .wui-font-micro-600 {\n    font-weight: var(--wui-font-weight-medium);\n  }\n\n  :host([disabled]) {\n    opacity: 0.4;\n  }\n"
    ]);
    $e48df367c3b0c8d2$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $e48df367c3b0c8d2$export$2e2bcd8739ae039 = (0, $bBWVO.css)($e48df367c3b0c8d2$var$_templateObject());

});


parcelRegister("iDAy5", function(module, exports) {

$parcel$export(module.exports, "WuiVisual", function () { return $d918385b02be3fd4$export$e6365a334c1a5845; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");

var $4TTs0 = parcelRequire("4TTs0");

var $7ODqj = parcelRequire("7ODqj");

var $2VEal = parcelRequire("2VEal");

var $hKUP2 = parcelRequire("hKUP2");

var $02XbN = parcelRequire("02XbN");

var $1D0j1 = parcelRequire("1D0j1");

var $9YSZN = parcelRequire("9YSZN");

var $lixjS = parcelRequire("lixjS");

var $iKufE = parcelRequire("iKufE");

var $kNPgP = parcelRequire("kNPgP");

var $fw30v = parcelRequire("fw30v");

var $drxIw = parcelRequire("drxIw");

var $jbeF9 = parcelRequire("jbeF9");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $lUw6S = parcelRequire("lUw6S");

var $1V7Ge = parcelRequire("1V7Ge");

var $lNk8w = parcelRequire("lNk8w");

var $kGplp = parcelRequire("kGplp");

var $fi8Xf = parcelRequire("fi8Xf");

var $c5hsg = parcelRequire("c5hsg");

var $jj5bD = parcelRequire("jj5bD");

var $1mVYB = parcelRequire("1mVYB");

var $diCke = parcelRequire("diCke");
function $d918385b02be3fd4$var$_templateObject() {
    var data = (0, $j06k0._)([
        "",
        ""
    ]);
    $d918385b02be3fd4$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $d918385b02be3fd4$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d918385b02be3fd4$var$svgOptions = {
    browser: (0, $4TTs0.browserSvg),
    dao: (0, $7ODqj.daoSvg),
    defi: (0, $2VEal.defiSvg),
    defiAlt: (0, $hKUP2.defiAltSvg),
    eth: (0, $02XbN.ethSvg),
    layers: (0, $1D0j1.layersSvg),
    lock: (0, $9YSZN.lockSvg),
    login: (0, $lixjS.loginSvg),
    network: (0, $iKufE.networkSvg),
    nft: (0, $kNPgP.nftSvg),
    noun: (0, $fw30v.nounSvg),
    profile: (0, $drxIw.profileSvg),
    system: (0, $jbeF9.systemSvg),
    coinbase: (0, $lUw6S.coinbaseSvg),
    onrampCard: (0, $fi8Xf.onrampCardSvg),
    moonpay: (0, $1V7Ge.moonpaySvg),
    stripe: (0, $lNk8w.stripeSvg),
    paypal: (0, $kGplp.paypalSvg),
    google: (0, $c5hsg.googleSvg),
    pencil: (0, $jj5bD.pencilSvg),
    lightbulb: (0, $1mVYB.lightbulbSvg)
};
var $d918385b02be3fd4$export$e6365a334c1a5845 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiVisual, LitElement);
    var _super = (0, $ohfOJ._)(WuiVisual);
    function WuiVisual() {
        (0, $4GJKx._)(this, WuiVisual);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "browser";
        _this.size = "md";
        return _this;
    }
    (0, $1wc17._)(WuiVisual, [
        {
            key: "render",
            value: function render() {
                this.style.cssText = "\n       --local-size: var(--wui-visual-size-".concat(this.size, ");\n   ");
                return (0, $1lUIm.html)($d918385b02be3fd4$var$_templateObject(), $d918385b02be3fd4$var$svgOptions[this.name]);
            }
        }
    ]);
    return WuiVisual;
}((0, $eAsDt.LitElement));
$d918385b02be3fd4$export$e6365a334c1a5845.styles = [
    (0, $kYNxm.resetStyles),
    (0, $diCke.default)
];
$d918385b02be3fd4$var$__decorate([
    (0, $siQym.property)()
], $d918385b02be3fd4$export$e6365a334c1a5845.prototype, "name", void 0);
$d918385b02be3fd4$var$__decorate([
    (0, $siQym.property)()
], $d918385b02be3fd4$export$e6365a334c1a5845.prototype, "size", void 0);
$d918385b02be3fd4$export$e6365a334c1a5845 = $d918385b02be3fd4$var$__decorate([
    (0, $hdxb6.customElement)("wui-visual")
], $d918385b02be3fd4$export$e6365a334c1a5845);

});
parcelRegister("4TTs0", function(module, exports) {

$parcel$export(module.exports, "browserSvg", function () { return $39174fd4b1089406$export$9a659d11e13bcec5; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $39174fd4b1089406$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 60 60">\n  <rect width="60" height="60" fill="#1DC956" rx="30" />\n  <circle cx="30" cy="30" r="3" fill="#fff" />\n  <path\n    fill="#2BEE6C"\n    stroke="#fff"\n    stroke-width="2"\n    d="m45.32 17.9-.88-.42.88.42.02-.05c.1-.2.21-.44.26-.7l-.82-.15.82.16a2 2 0 0 0-.24-1.4c-.13-.23-.32-.42-.47-.57a8.42 8.42 0 0 1-.04-.04l-.04-.04a2.9 2.9 0 0 0-.56-.47l-.51.86.5-.86a2 2 0 0 0-1.4-.24c-.26.05-.5.16-.69.26l-.05.02-15.05 7.25-.1.05c-1.14.55-1.85.89-2.46 1.37a7 7 0 0 0-1.13 1.14c-.5.6-.83 1.32-1.38 2.45l-.05.11-7.25 15.05-.02.05c-.1.2-.21.43-.26.69a2 2 0 0 0 .24 1.4l.85-.5-.85.5c.13.23.32.42.47.57l.04.04.04.04c.15.15.34.34.56.47a2 2 0 0 0 1.41.24l-.2-.98.2.98c.25-.05.5-.17.69-.26l.05-.02-.42-.87.42.87 15.05-7.25.1-.05c1.14-.55 1.85-.89 2.46-1.38a7 7 0 0 0 1.13-1.13 12.87 12.87 0 0 0 1.43-2.56l7.25-15.05Z"\n  />\n  <path\n    fill="#1DC956"\n    d="M33.38 32.72 30.7 29.3 15.86 44.14l.2.2a1 1 0 0 0 1.14.2l15.1-7.27a3 3 0 0 0 1.08-4.55Z"\n  />\n  <path\n    fill="#86F999"\n    d="m26.62 27.28 2.67 3.43 14.85-14.85-.2-.2a1 1 0 0 0-1.14-.2l-15.1 7.27a3 3 0 0 0-1.08 4.55Z"\n  />\n  <circle cx="30" cy="30" r="3" fill="#fff" transform="rotate(45 30 30)" />\n  <rect width="59" height="59" x=".5" y=".5" stroke="#062B2B" stroke-opacity=".1" rx="29.5" />\n</svg> '
    ]);
    $39174fd4b1089406$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $39174fd4b1089406$export$9a659d11e13bcec5 = (0, $1lUIm.svg)($39174fd4b1089406$var$_templateObject());

});

parcelRegister("7ODqj", function(module, exports) {

$parcel$export(module.exports, "daoSvg", function () { return $5b0bc89aaf98f651$export$4c380a6200fee43; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $5b0bc89aaf98f651$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg viewBox="0 0 60 60" fill="none">\n  <g clip-path="url(#clip0_7734_50402)">\n    <path\n      d="M0 24.9C0 15.6485 0 11.0228 1.97053 7.56812C3.3015 5.23468 5.23468 3.3015 7.56812 1.97053C11.0228 0 15.6485 0 24.9 0H35.1C44.3514 0 48.9772 0 52.4319 1.97053C54.7653 3.3015 56.6985 5.23468 58.0295 7.56812C60 11.0228 60 15.6485 60 24.9V35.1C60 44.3514 60 48.9772 58.0295 52.4319C56.6985 54.7653 54.7653 56.6985 52.4319 58.0295C48.9772 60 44.3514 60 35.1 60H24.9C15.6485 60 11.0228 60 7.56812 58.0295C5.23468 56.6985 3.3015 54.7653 1.97053 52.4319C0 48.9772 0 44.3514 0 35.1V24.9Z"\n      fill="#EB8B47"\n    />\n    <path\n      d="M0.5 24.9C0.5 20.2652 0.50047 16.8221 0.744315 14.105C0.987552 11.3946 1.46987 9.45504 2.40484 7.81585C3.69145 5.56019 5.56019 3.69145 7.81585 2.40484C9.45504 1.46987 11.3946 0.987552 14.105 0.744315C16.8221 0.50047 20.2652 0.5 24.9 0.5H35.1C39.7348 0.5 43.1779 0.50047 45.895 0.744315C48.6054 0.987552 50.545 1.46987 52.1841 2.40484C54.4398 3.69145 56.3086 5.56019 57.5952 7.81585C58.5301 9.45504 59.0124 11.3946 59.2557 14.105C59.4995 16.8221 59.5 20.2652 59.5 24.9V35.1C59.5 39.7348 59.4995 43.1779 59.2557 45.895C59.0124 48.6054 58.5301 50.545 57.5952 52.1841C56.3086 54.4398 54.4398 56.3086 52.1841 57.5952C50.545 58.5301 48.6054 59.0124 45.895 59.2557C43.1779 59.4995 39.7348 59.5 35.1 59.5H24.9C20.2652 59.5 16.8221 59.4995 14.105 59.2557C11.3946 59.0124 9.45504 58.5301 7.81585 57.5952C5.56019 56.3086 3.69145 54.4398 2.40484 52.1841C1.46987 50.545 0.987552 48.6054 0.744315 45.895C0.50047 43.1779 0.5 39.7348 0.5 35.1V24.9Z"\n      stroke="#062B2B"\n      stroke-opacity="0.1"\n    />\n    <path\n      d="M19 52C24.5228 52 29 47.5228 29 42C29 36.4772 24.5228 32 19 32C13.4772 32 9 36.4772 9 42C9 47.5228 13.4772 52 19 52Z"\n      fill="#FF974C"\n      stroke="white"\n      stroke-width="2"\n    />\n    <path\n      fill-rule="evenodd"\n      clip-rule="evenodd"\n      d="M42.8437 8.3264C42.4507 7.70891 41.5493 7.70891 41.1564 8.32641L28.978 27.4638C28.5544 28.1295 29.0326 29.0007 29.8217 29.0007H54.1783C54.9674 29.0007 55.4456 28.1295 55.022 27.4638L42.8437 8.3264Z"\n      fill="white"\n    />\n    <path\n      fill-rule="evenodd"\n      clip-rule="evenodd"\n      d="M42.3348 11.6456C42.659 11.7608 42.9061 12.1492 43.4005 12.926L50.7332 24.4488C51.2952 25.332 51.5763 25.7737 51.5254 26.1382C51.4915 26.3808 51.3698 26.6026 51.1833 26.7614C50.9031 27 50.3796 27 49.3327 27H34.6673C33.6204 27 33.0969 27 32.8167 26.7614C32.6302 26.6026 32.5085 26.3808 32.4746 26.1382C32.4237 25.7737 32.7048 25.332 33.2669 24.4488L40.5995 12.926C41.0939 12.1492 41.341 11.7608 41.6652 11.6456C41.8818 11.5687 42.1182 11.5687 42.3348 11.6456ZM35.0001 26.999C38.8661 26.999 42.0001 23.865 42.0001 19.999C42.0001 23.865 45.1341 26.999 49.0001 26.999H35.0001Z"\n      fill="#FF974C"\n    />\n    <path\n      d="M10.1061 9.35712C9.9973 9.67775 9.99867 10.0388 9.99978 10.3323C9.99989 10.3611 10 10.3893 10 10.4167V25.5833C10 25.6107 9.99989 25.6389 9.99978 25.6677C9.99867 25.9612 9.9973 26.3222 10.1061 26.6429C10.306 27.2317 10.7683 27.694 11.3571 27.8939C11.6777 28.0027 12.0388 28.0013 12.3323 28.0002C12.3611 28.0001 12.3893 28 12.4167 28H19C24.5228 28 29 23.5228 29 18C29 12.4772 24.5228 8 19 8H12.4167C12.3893 8 12.3611 7.99989 12.3323 7.99978C12.0388 7.99867 11.6778 7.9973 11.3571 8.10614C10.7683 8.306 10.306 8.76834 10.1061 9.35712Z"\n      fill="#FF974C"\n      stroke="white"\n      stroke-width="2"\n    />\n    <circle cx="19" cy="18" r="4" fill="#EB8B47" stroke="white" stroke-width="2" />\n    <circle cx="19" cy="42" r="4" fill="#EB8B47" stroke="white" stroke-width="2" />\n  </g>\n  <defs>\n    <clipPath id="clip0_7734_50402">\n      <rect width="60" height="60" fill="white" />\n    </clipPath>\n  </defs>\n</svg> '
    ]);
    $5b0bc89aaf98f651$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $5b0bc89aaf98f651$export$4c380a6200fee43 = (0, $1lUIm.svg)($5b0bc89aaf98f651$var$_templateObject());

});

parcelRegister("2VEal", function(module, exports) {

$parcel$export(module.exports, "defiSvg", function () { return $22200fbaf30ba733$export$400ef2a1f7fc3217; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $22200fbaf30ba733$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 60 60">\n  <g clip-path="url(#a)">\n    <path\n      fill="#1DC956"\n      d="M0 25.01c0-9.25 0-13.88 1.97-17.33a15 15 0 0 1 5.6-5.6C11.02.11 15.65.11 24.9.11h10.2c9.25 0 13.88 0 17.33 1.97a15 15 0 0 1 5.6 5.6C60 11.13 60 15.76 60 25v10.2c0 9.25 0 13.88-1.97 17.33a15 15 0 0 1-5.6 5.6c-3.45 1.97-8.08 1.97-17.33 1.97H24.9c-9.25 0-13.88 0-17.33-1.97a15 15 0 0 1-5.6-5.6C0 49.1 0 44.46 0 35.21v-10.2Z"\n    />\n    <path\n      fill="#2BEE6C"\n      d="M16.1 60c-3.82-.18-6.4-.64-8.53-1.86a15 15 0 0 1-5.6-5.6C.55 50.06.16 46.97.04 41.98L4.2 40.6a4 4 0 0 0 2.48-2.39l4.65-12.4a2 2 0 0 1 2.5-1.2l2.53.84a2 2 0 0 0 2.43-1l2.96-5.94a2 2 0 0 1 3.7.32l3.78 12.58a2 2 0 0 0 3.03 1.09l3.34-2.23a2 2 0 0 0 .65-.7l5.3-9.72a2 2 0 0 1 1.42-1.01l4.14-.69a2 2 0 0 1 1.6.44l3.9 3.24a2 2 0 0 0 2.7-.12l4.62-4.63c.08 2.2.08 4.8.08 7.93v10.2c0 9.25 0 13.88-1.97 17.33a15 15 0 0 1-5.6 5.6c-2.13 1.22-4.7 1.68-8.54 1.86H16.11Z"\n    />\n    <path\n      fill="#fff"\n      d="m.07 43.03-.05-2.1 3.85-1.28a3 3 0 0 0 1.86-1.79l4.66-12.4a3 3 0 0 1 3.75-1.8l2.53.84a1 1 0 0 0 1.21-.5l2.97-5.94a3 3 0 0 1 5.56.48l3.77 12.58a1 1 0 0 0 1.51.55l3.34-2.23a1 1 0 0 0 .33-.35l5.3-9.71a3 3 0 0 1 2.14-1.53l4.13-.69a3 3 0 0 1 2.41.66l3.9 3.24a1 1 0 0 0 1.34-.06l5.28-5.28c.05.85.08 1.75.1 2.73L56 22.41a3 3 0 0 1-4.04.19l-3.9-3.25a1 1 0 0 0-.8-.21l-4.13.69a1 1 0 0 0-.72.5l-5.3 9.72a3 3 0 0 1-.97 1.05l-3.34 2.23a3 3 0 0 1-4.53-1.63l-3.78-12.58a1 1 0 0 0-1.85-.16l-2.97 5.94a3 3 0 0 1-3.63 1.5l-2.53-.84a1 1 0 0 0-1.25.6l-4.65 12.4a5 5 0 0 1-3.1 3L.07 43.02Z"\n    />\n    <path\n      fill="#fff"\n      fill-rule="evenodd"\n      d="M49.5 19a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z"\n      clip-rule="evenodd"\n    />\n    <path fill="#fff" d="M45 .28v59.66l-2 .1V.19c.7.02 1.37.05 2 .1Z" />\n    <path fill="#2BEE6C" d="M47.5 19a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" />\n    <path\n      stroke="#fff"\n      stroke-opacity=".1"\n      d="M.5 25.01c0-4.63 0-8.08.24-10.8.25-2.7.73-4.64 1.66-6.28a14.5 14.5 0 0 1 5.42-5.41C9.46 1.58 11.39 1.1 14.1.85A133 133 0 0 1 24.9.61h10.2c4.63 0 8.08 0 10.8.24 2.7.25 4.65.73 6.28 1.67a14.5 14.5 0 0 1 5.42 5.4c.93 1.65 1.41 3.58 1.66 6.3.24 2.71.24 6.16.24 10.79v10.2c0 4.64 0 8.08-.24 10.8-.25 2.7-.73 4.65-1.66 6.28a14.5 14.5 0 0 1-5.42 5.42c-1.63.93-3.57 1.41-6.28 1.66-2.72.24-6.17.24-10.8.24H24.9c-4.63 0-8.08 0-10.8-.24-2.7-.25-4.64-.73-6.28-1.66a14.5 14.5 0 0 1-5.42-5.42C1.47 50.66 1 48.72.74 46.01A133 133 0 0 1 .5 35.2v-10.2Z"\n    />\n  </g>\n  <defs>\n    <clipPath id="a"><path fill="#fff" d="M0 0h60v60H0z" /></clipPath>\n  </defs>\n</svg>'
    ]);
    $22200fbaf30ba733$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $22200fbaf30ba733$export$400ef2a1f7fc3217 = (0, $1lUIm.svg)($22200fbaf30ba733$var$_templateObject());

});

parcelRegister("hKUP2", function(module, exports) {

$parcel$export(module.exports, "defiAltSvg", function () { return $ced2cf3c0f729b30$export$f1568dd015c8f3b9; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $ced2cf3c0f729b30$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 60 60">\n  <g clip-path="url(#a)">\n    <rect width="60" height="60" fill="#C653C6" rx="30" />\n    <path\n      fill="#E87DE8"\n      d="M57.98.01v19.5a4.09 4.09 0 0 0-2.63 2.29L50.7 34.2a2 2 0 0 1-2.5 1.2l-2.53-.84a2 2 0 0 0-2.42 1l-2.97 5.94a2 2 0 0 1-3.7-.32L32.8 28.6a2 2 0 0 0-3.02-1.09l-3.35 2.23a2 2 0 0 0-.64.7l-5.3 9.72a2 2 0 0 1-1.43 1.01l-4.13.69a2 2 0 0 1-1.61-.44l-3.9-3.24a2 2 0 0 0-2.69.12L2.1 42.93.02 43V.01h57.96Z"\n    />\n    <path\n      fill="#fff"\n      d="m61.95 16.94.05 2.1-3.85 1.28a3 3 0 0 0-1.86 1.79l-4.65 12.4a3 3 0 0 1-3.76 1.8l-2.53-.84a1 1 0 0 0-1.2.5l-2.98 5.94a3 3 0 0 1-5.55-.48l-3.78-12.58a1 1 0 0 0-1.5-.55l-3.35 2.23a1 1 0 0 0-.32.35l-5.3 9.72a3 3 0 0 1-2.14 1.52l-4.14.69a3 3 0 0 1-2.41-.66l-3.9-3.24a1 1 0 0 0-1.34.06l-5.28 5.28c-.05-.84-.08-1.75-.1-2.73l3.97-3.96a3 3 0 0 1 4.04-.19l3.89 3.25a1 1 0 0 0 .8.21l4.14-.68a1 1 0 0 0 .71-.51l5.3-9.71a3 3 0 0 1 .97-1.06l3.34-2.23a3 3 0 0 1 4.54 1.63l3.77 12.58a1 1 0 0 0 1.86.16l2.96-5.93a3 3 0 0 1 3.64-1.5l2.52.83a1 1 0 0 0 1.25-.6l4.66-12.4a5 5 0 0 1 3.1-2.99l4.43-1.48Z"\n    />\n    <path\n      fill="#fff"\n      fill-rule="evenodd"\n      d="M35.5 27a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z"\n      clip-rule="evenodd"\n    />\n    <path fill="#fff" d="M31 0v60h-2V0h2Z" />\n    <path fill="#E87DE8" d="M33.5 27a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" />\n  </g>\n  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="29.5" />\n  <defs>\n    <clipPath id="a"><rect width="60" height="60" fill="#fff" rx="30" /></clipPath>\n  </defs>\n</svg> '
    ]);
    $ced2cf3c0f729b30$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $ced2cf3c0f729b30$export$f1568dd015c8f3b9 = (0, $1lUIm.svg)($ced2cf3c0f729b30$var$_templateObject());

});

parcelRegister("02XbN", function(module, exports) {

$parcel$export(module.exports, "ethSvg", function () { return $008e19c28cacc017$export$9c7a8a6662d6e69b; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $008e19c28cacc017$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 60 60">\n  <g clip-path="url(#a)">\n    <rect width="60" height="60" fill="#987DE8" rx="30" />\n    <path\n      fill="#fff"\n      fill-rule="evenodd"\n      d="m15.48 28.37 11.97-19.3a3 3 0 0 1 5.1 0l11.97 19.3a6 6 0 0 1 .9 3.14v.03a6 6 0 0 1-1.16 3.56L33.23 50.2a4 4 0 0 1-6.46 0L15.73 35.1a6 6 0 0 1-1.15-3.54v-.03a6 6 0 0 1 .9-3.16Z"\n      clip-rule="evenodd"\n    />\n    <path\n      fill="#643CDD"\n      d="M30.84 10.11a1 1 0 0 0-.84-.46V24.5l12.6 5.53a2 2 0 0 0-.28-1.4L30.84 10.11Z"\n    />\n    <path\n      fill="#BDADEB"\n      d="M30 9.65a1 1 0 0 0-.85.46L17.66 28.64a2 2 0 0 0-.26 1.39L30 24.5V9.65Z"\n    />\n    <path\n      fill="#643CDD"\n      d="M30 50.54a1 1 0 0 0 .8-.4l11.24-15.38c.3-.44-.2-1-.66-.73l-9.89 5.68a3 3 0 0 1-1.5.4v10.43Z"\n    />\n    <path\n      fill="#BDADEB"\n      d="m17.97 34.76 11.22 15.37c.2.28.5.41.8.41V40.11a3 3 0 0 1-1.49-.4l-9.88-5.68c-.47-.27-.97.3-.65.73Z"\n    />\n    <path\n      fill="#401AB3"\n      d="M42.6 30.03 30 24.5v13.14a3 3 0 0 0 1.5-.4l10.14-5.83a2 2 0 0 0 .95-1.38Z"\n    />\n    <path\n      fill="#7C5AE2"\n      d="M30 37.64V24.46l-12.6 5.57a2 2 0 0 0 .97 1.39l10.13 5.82a3 3 0 0 0 1.5.4Z"\n    />\n  </g>\n  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="29.5" />\n  <defs>\n    <clipPath id="a"><rect width="60" height="60" fill="#fff" rx="30" /></clipPath>\n  </defs>\n</svg> '
    ]);
    $008e19c28cacc017$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $008e19c28cacc017$export$9c7a8a6662d6e69b = (0, $1lUIm.svg)($008e19c28cacc017$var$_templateObject());

});

parcelRegister("1D0j1", function(module, exports) {

$parcel$export(module.exports, "layersSvg", function () { return $12f9abadc724c7bc$export$92af4cd19d37b5ea; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $12f9abadc724c7bc$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 60 60">\n  <rect width="60" height="60" fill="#1DC956" rx="3" />\n  <path\n    fill="#1FAD7E"\n    stroke="#fff"\n    stroke-width="2"\n    d="m30.49 29.13-.49-.27-.49.27-12.77 7.1-.05.02c-.86.48-1.58.88-2.1 1.24-.54.37-1.04.81-1.28 1.45a3 3 0 0 0 0 2.12c.24.63.74 1.08 1.27 1.45.53.36 1.25.76 2.11 1.24l.05.03 6.33 3.51.17.1c2.33 1.3 3.72 2.06 5.22 2.32a9 9 0 0 0 3.08 0c1.5-.26 2.9-1.03 5.22-2.32l.18-.1 6.32-3.51.05-.03a26.9 26.9 0 0 0 2.1-1.24 3.21 3.21 0 0 0 1.28-1.45l-.94-.35.94.35a3 3 0 0 0 0-2.12l-.94.35.94-.35a3.21 3.21 0 0 0-1.27-1.45c-.53-.36-1.25-.76-2.11-1.24l-.05-.03-12.77-7.1Z"\n  />\n  <path\n    fill="#2BEE6C"\n    stroke="#fff"\n    stroke-width="2"\n    d="m30.49 19.13-.49-.27-.49.27-12.77 7.1-.05.02c-.86.48-1.58.88-2.1 1.24-.54.37-1.04.81-1.28 1.45a3 3 0 0 0 0 2.12c.24.63.74 1.08 1.27 1.45.53.36 1.25.76 2.11 1.24l.05.03 6.33 3.51.17.1c2.33 1.3 3.72 2.06 5.22 2.32a9 9 0 0 0 3.08 0c1.5-.26 2.9-1.03 5.22-2.32l.18-.1 6.32-3.51.05-.03a26.9 26.9 0 0 0 2.1-1.24 3.21 3.21 0 0 0 1.28-1.45l-.94-.35.94.35a3 3 0 0 0 0-2.12l-.94.35.94-.35a3.21 3.21 0 0 0-1.27-1.45c-.53-.36-1.25-.76-2.11-1.24l-.05-.03-12.77-7.1Z"\n  />\n  <path\n    fill="#86F999"\n    stroke="#fff"\n    stroke-width="2"\n    d="m46.69 21.06-.94-.35.94.35a3 3 0 0 0 0-2.12l-.94.35.94-.35a3.21 3.21 0 0 0-1.27-1.45c-.53-.36-1.25-.76-2.11-1.24l-.05-.03-6.32-3.51-.18-.1c-2.33-1.3-3.72-2.06-5.22-2.33a9 9 0 0 0-3.08 0c-1.5.27-2.9 1.04-5.22 2.33l-.17.1-6.33 3.51-.05.03c-.86.48-1.58.88-2.1 1.24-.54.37-1.04.81-1.28 1.45a3 3 0 0 0 0 2.12c.24.63.74 1.08 1.27 1.45.53.36 1.25.76 2.11 1.24l.05.03 6.33 3.51.17.1c2.33 1.3 3.72 2.06 5.22 2.32a9 9 0 0 0 3.08 0c1.5-.26 2.9-1.03 5.22-2.32l.18-.1 6.32-3.51.05-.03a26.9 26.9 0 0 0 2.1-1.24 3.21 3.21 0 0 0 1.28-1.45Z"\n  />\n  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="2.5" />\n</svg>'
    ]);
    $12f9abadc724c7bc$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $12f9abadc724c7bc$export$92af4cd19d37b5ea = (0, $1lUIm.svg)($12f9abadc724c7bc$var$_templateObject());

});

parcelRegister("9YSZN", function(module, exports) {

$parcel$export(module.exports, "lockSvg", function () { return $744460a1db37c035$export$70be6a782cc364be; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $744460a1db37c035$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 60 60">\n  <rect width="60" height="60" fill="#C653C6" rx="3" />\n  <path\n    fill="#fff"\n    d="M20.03 15.22C20 15.6 20 16.07 20 17v2.8c0 1.14 0 1.7-.2 2.12-.15.31-.3.5-.58.71-.37.28-1.06.42-2.43.7-.59.12-1.11.29-1.6.51a9 9 0 0 0-4.35 4.36C10 30 10 32.34 10 37c0 4.66 0 7 .84 8.8a9 9 0 0 0 4.36 4.36C17 51 19.34 51 24 51h12c4.66 0 7 0 8.8-.84a9 9 0 0 0 4.36-4.36C50 44 50 41.66 50 37c0-4.66 0-7-.84-8.8a9 9 0 0 0-4.36-4.36c-.48-.22-1-.39-1.6-.5-1.36-.29-2.05-.43-2.42-.7-.27-.22-.43-.4-.58-.72-.2-.42-.2-.98-.2-2.11V17c0-.93 0-1.4-.03-1.78a9 9 0 0 0-8.19-8.19C31.4 7 30.93 7 30 7s-1.4 0-1.78.03a9 9 0 0 0-8.19 8.19Z"\n  />\n  <path\n    fill="#E87DE8"\n    d="M22 17c0-.93 0-1.4.04-1.78a7 7 0 0 1 6.18-6.18C28.6 9 29.07 9 30 9s1.4 0 1.78.04a7 7 0 0 1 6.18 6.18c.04.39.04.85.04 1.78v4.5a1.5 1.5 0 0 1-3 0V17c0-.93 0-1.4-.08-1.78a4 4 0 0 0-3.14-3.14C31.39 12 30.93 12 30 12s-1.4 0-1.78.08a4 4 0 0 0-3.14 3.14c-.08.39-.08.85-.08 1.78v4.5a1.5 1.5 0 0 1-3 0V17Z"\n  />\n  <path\n    fill="#E87DE8"\n    fill-rule="evenodd"\n    d="M12 36.62c0-4.32 0-6.48.92-8.09a7 7 0 0 1 2.61-2.61C17.14 25 19.3 25 23.62 25h6.86c.46 0 .7 0 .9.02 2.73.22 4.37 2.43 4.62 4.98.27-2.7 2.11-5 5.02-5A6.98 6.98 0 0 1 48 31.98v5.4c0 4.32 0 6.48-.92 8.09a7 7 0 0 1-2.61 2.61c-1.61.92-3.77.92-8.09.92h-5.86c-.46 0-.7 0-.9-.02-2.73-.22-4.37-2.43-4.62-4.98-.26 2.58-1.94 4.82-4.71 4.99l-.7.01c-.55 0-.82 0-1.05-.02a7 7 0 0 1-6.52-6.52c-.02-.23-.02-.5-.02-1.05v-4.79Zm21.24-.27a4 4 0 1 0-6.48 0 31.28 31.28 0 0 1 1.57 2.23c.17.4.17.81.17 1.24V42.5a1.5 1.5 0 0 0 3 0V39.82c0-.43 0-.85.17-1.24.09-.2.58-.87 1.57-2.23Z"\n    clip-rule="evenodd"\n  />\n  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="2.5" />\n</svg>'
    ]);
    $744460a1db37c035$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $744460a1db37c035$export$70be6a782cc364be = (0, $1lUIm.svg)($744460a1db37c035$var$_templateObject());

});

parcelRegister("lixjS", function(module, exports) {

$parcel$export(module.exports, "loginSvg", function () { return $f8151ffdb53fb520$export$c9aa74efff8430c; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $f8151ffdb53fb520$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 60 60">\n  <g clip-path="url(#a)">\n    <path\n      fill="#EB8B47"\n      d="M0 24.9c0-9.25 0-13.88 1.97-17.33a15 15 0 0 1 5.6-5.6C11.02 0 15.65 0 24.9 0h10.2c9.25 0 13.88 0 17.33 1.97a15 15 0 0 1 5.6 5.6C60 11.02 60 15.65 60 24.9v10.2c0 9.25 0 13.88-1.97 17.33a15 15 0 0 1-5.6 5.6C48.98 60 44.35 60 35.1 60H24.9c-9.25 0-13.88 0-17.33-1.97a15 15 0 0 1-5.6-5.6C0 48.98 0 44.35 0 35.1V24.9Z"\n    />\n    <path\n      stroke="#062B2B"\n      stroke-opacity=".1"\n      d="M.5 24.9c0-4.64 0-8.08.24-10.8.25-2.7.73-4.65 1.66-6.28A14.5 14.5 0 0 1 7.82 2.4C9.46 1.47 11.39 1 14.1.74A133 133 0 0 1 24.9.5h10.2c4.63 0 8.08 0 10.8.24 2.7.25 4.65.73 6.28 1.66a14.5 14.5 0 0 1 5.42 5.42c.93 1.63 1.41 3.57 1.66 6.28.24 2.72.24 6.16.24 10.8v10.2c0 4.63 0 8.08-.24 10.8-.25 2.7-.73 4.64-1.66 6.28a14.5 14.5 0 0 1-5.42 5.41c-1.63.94-3.57 1.42-6.28 1.67-2.72.24-6.17.24-10.8.24H24.9c-4.63 0-8.08 0-10.8-.24-2.7-.25-4.64-.73-6.28-1.67a14.5 14.5 0 0 1-5.42-5.4C1.47 50.53 1 48.6.74 45.88A133 133 0 0 1 .5 35.1V24.9Z"\n    />\n    <path\n      fill="#FF974C"\n      stroke="#fff"\n      stroke-width="2"\n      d="M39.2 29.2a13 13 0 1 0-18.4 0l1.3 1.28a12.82 12.82 0 0 1 2.1 2.39 6 6 0 0 1 .6 1.47c.2.76.2 1.56.2 3.17v11.24c0 1.08 0 1.61.13 2.12a4 4 0 0 0 .41.98c.26.45.64.83 1.4 1.6l.3.29c.65.65.98.98 1.36 1.09.26.07.54.07.8 0 .38-.11.7-.44 1.36-1.1l3.48-3.47c.65-.65.98-.98 1.09-1.36a1.5 1.5 0 0 0 0-.8c-.1-.38-.44-.7-1.1-1.36l-.47-.48c-.65-.65-.98-.98-1.09-1.36a1.5 1.5 0 0 1 0-.8c.1-.38.44-.7 1.1-1.36l.47-.48c.65-.65.98-.98 1.09-1.36a1.5 1.5 0 0 0 0-.8c-.1-.38-.44-.7-1.1-1.36l-.48-.5c-.65-.64-.98-.97-1.08-1.35a1.5 1.5 0 0 1 0-.79c.1-.38.42-.7 1.06-1.36l5.46-5.55Z"\n    />\n    <circle cx="30" cy="17" r="4" fill="#EB8B47" stroke="#fff" stroke-width="2" />\n  </g>\n  <defs>\n    <clipPath id="a"><path fill="#fff" d="M0 0h60v60H0z" /></clipPath>\n  </defs>\n</svg> '
    ]);
    $f8151ffdb53fb520$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $f8151ffdb53fb520$export$c9aa74efff8430c = (0, $1lUIm.svg)($f8151ffdb53fb520$var$_templateObject());

});

parcelRegister("iKufE", function(module, exports) {

$parcel$export(module.exports, "networkSvg", function () { return $da63fd2c9ea6f584$export$1a3efa751581ed0a; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $da63fd2c9ea6f584$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 60 60">\n  <g clip-path="url(#a)">\n    <rect width="60" height="60" fill="#00ACE6" rx="30" />\n    <circle cx="64" cy="39" r="50" fill="#1AC6FF" stroke="#fff" stroke-width="2" />\n    <circle cx="78" cy="30" r="50" fill="#4DD2FF" stroke="#fff" stroke-width="2" />\n    <circle cx="72" cy="15" r="35" fill="#80DFFF" stroke="#fff" stroke-width="2" />\n    <circle cx="34" cy="-17" r="45" stroke="#fff" stroke-width="2" />\n    <circle cx="34" cy="-5" r="50" stroke="#fff" stroke-width="2" />\n    <circle cx="30" cy="45" r="4" fill="#4DD2FF" stroke="#fff" stroke-width="2" />\n    <circle cx="39.5" cy="27.5" r="4" fill="#80DFFF" stroke="#fff" stroke-width="2" />\n    <circle cx="16" cy="24" r="4" fill="#19C6FF" stroke="#fff" stroke-width="2" />\n  </g>\n  <rect width="59" height="59" x=".5" y=".5" stroke="#062B2B" stroke-opacity=".1" rx="29.5" />\n  <defs>\n    <clipPath id="a"><rect width="60" height="60" fill="#fff" rx="30" /></clipPath>\n  </defs>\n</svg>'
    ]);
    $da63fd2c9ea6f584$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $da63fd2c9ea6f584$export$1a3efa751581ed0a = (0, $1lUIm.svg)($da63fd2c9ea6f584$var$_templateObject());

});

parcelRegister("kNPgP", function(module, exports) {

$parcel$export(module.exports, "nftSvg", function () { return $f250277ad19bc5d8$export$1c5022265b1a9f1f; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $f250277ad19bc5d8$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 60 60">\n  <g clip-path="url(#a)">\n    <rect width="60" height="60" fill="#C653C6" rx="3" />\n    <path\n      fill="#E87DE8"\n      stroke="#fff"\n      stroke-width="2"\n      d="M52.1 47.34c0-4.24-1.44-9.55-5.9-12.4a2.86 2.86 0 0 0-1.6-3.89v-.82c0-1.19-.52-2.26-1.35-3a4.74 4.74 0 0 0-2.4-6.26v-5.5a11.31 11.31 0 1 0-22.63 0v2.15a3.34 3.34 0 0 0-1.18 5.05 4.74 4.74 0 0 0-.68 6.44A5.22 5.22 0 0 0 14 35.92c-3.06 4.13-6.1 8.3-6.1 15.64 0 2.67.37 4.86.74 6.39a20.3 20.3 0 0 0 .73 2.39l.02.04v.01l.92-.39-.92.4.26.6h38.26l.3-.49-.87-.51.86.5.02-.01.03-.07a16.32 16.32 0 0 0 .57-1.05c.36-.72.85-1.74 1.33-2.96a25.51 25.51 0 0 0 1.94-9.07Z"\n    />\n    <path\n      fill="#fff"\n      fill-rule="evenodd"\n      d="M26.5 29.5c-3-.5-5.5-3-5.5-7v-7c0-.47 0-.7.03-.9a3 3 0 0 1 2.58-2.57c.2-.03.42-.03.89-.03 2 0 2.5-2.5 2.5-2.5s0 2.5 2.5 2.5c1.4 0 2.1 0 2.65.23a3 3 0 0 1 1.62 1.62c.23.55.23 1.25.23 2.65v6c0 4-3 7-6.5 7 1.35.23 4 0 6.5-2v9.53C34 38.5 31.5 40 28 40s-6-1.5-6-2.97L24 34l2.5 1.5v-6ZM26 47h4.5c2.5 0 3 4 3 5.5h-3l-1-1.5H26v-4Zm-6.25 5.5H24V57h-8c0-1 1-4.5 3.75-4.5Z"\n      clip-rule="evenodd"\n    />\n  </g>\n  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="2.5" />\n  <defs>\n    <clipPath id="a"><rect width="60" height="60" fill="#fff" rx="3" /></clipPath>\n  </defs>\n</svg> '
    ]);
    $f250277ad19bc5d8$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $f250277ad19bc5d8$export$1c5022265b1a9f1f = (0, $1lUIm.svg)($f250277ad19bc5d8$var$_templateObject());

});

parcelRegister("fw30v", function(module, exports) {

$parcel$export(module.exports, "nounSvg", function () { return $b4bc2d5944aec26f$export$3bfdd1a0cad16fad; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $b4bc2d5944aec26f$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg fill="none" viewBox="0 0 60 60">\n  <rect width="60" height="60" fill="#794CFF" rx="3" />\n  <path\n    fill="#987DE8"\n    stroke="#fff"\n    stroke-width="2"\n    d="M33 22.5v-1H16v5H8.5V36H13v-5h3v7.5h17V31h1v7.5h17v-17H34v5h-1v-4Z"\n  />\n  <path fill="#fff" d="M37.5 25h10v10h-10z" />\n  <path fill="#4019B2" d="M42.5 25h5v10h-5z" />\n  <path fill="#fff" d="M19.5 25h10v10h-10z" />\n  <path fill="#4019B2" d="M24.5 25h5v10h-5z" />\n  <path fill="#fff" d="M12 30.5h4V37h-4v-6.5Z" />\n  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="2.5" />\n</svg>'
    ]);
    $b4bc2d5944aec26f$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $b4bc2d5944aec26f$export$3bfdd1a0cad16fad = (0, $1lUIm.svg)($b4bc2d5944aec26f$var$_templateObject());

});

parcelRegister("drxIw", function(module, exports) {

$parcel$export(module.exports, "profileSvg", function () { return $9c97f378ce630b34$export$f1a0ec1d6376e59; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $9c97f378ce630b34$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg\n  viewBox="0 0 60 60"\n  fill="none"\n>\n  <g clip-path="url(#1)">\n    <rect width="60" height="60" rx="30" fill="#00ACE6" />\n    <path\n      d="M59 73C59 89.0163 46.0163 102 30 102C13.9837 102 1 89.0163 1 73C1 56.9837 12 44 30 44C48 44 59 56.9837 59 73Z"\n      fill="#1AC6FF"\n      stroke="white"\n      stroke-width="2"\n    />\n    <path\n      d="M18.6904 19.9015C19.6264 15.3286 23.3466 11.8445 27.9708 11.2096C29.3231 11.024 30.6751 11.0238 32.0289 11.2096C36.6532 11.8445 40.3733 15.3286 41.3094 19.9015C41.4868 20.7681 41.6309 21.6509 41.7492 22.5271C41.8811 23.5041 41.8811 24.4944 41.7492 25.4715C41.6309 26.3476 41.4868 27.2304 41.3094 28.097C40.3733 32.6699 36.6532 36.154 32.0289 36.7889C30.6772 36.9744 29.3216 36.9743 27.9708 36.7889C23.3466 36.154 19.6264 32.6699 18.6904 28.097C18.513 27.2304 18.3689 26.3476 18.2506 25.4715C18.1186 24.4944 18.1186 23.5041 18.2506 22.5271C18.3689 21.6509 18.513 20.7681 18.6904 19.9015Z"\n      fill="#1AC6FF"\n      stroke="white"\n      stroke-width="2"\n    />\n    <circle cx="24.5" cy="23.5" r="1.5" fill="white" />\n    <circle cx="35.5" cy="23.5" r="1.5" fill="white" />\n    <path\n      d="M31 20L28 28H32"\n      stroke="white"\n      stroke-width="2"\n      stroke-linecap="round"\n      stroke-linejoin="round"\n    />\n  </g>\n  <rect x="0.5" y="0.5" width="59" height="59" rx="29.5" stroke="white" stroke-opacity="0.1" />\n  <defs>\n    <clipPath id="1">\n      <rect width="60" height="60" rx="30" fill="white" />\n    </clipPath>\n  </defs>\n</svg> '
    ]);
    $9c97f378ce630b34$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $9c97f378ce630b34$export$f1a0ec1d6376e59 = (0, $1lUIm.svg)($9c97f378ce630b34$var$_templateObject());

});

parcelRegister("jbeF9", function(module, exports) {

$parcel$export(module.exports, "systemSvg", function () { return $df6a6b1ad98d2cb1$export$5752b741a746ef10; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $df6a6b1ad98d2cb1$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg viewBox="0 0 60 60" fill="none">\n  <g clip-path="url(#1)">\n    <path\n      d="M0 24.9C0 15.6485 0 11.0228 1.97053 7.56812C3.3015 5.23468 5.23468 3.3015 7.56812 1.97053C11.0228 0 15.6485 0 24.9 0H35.1C44.3514 0 48.9772 0 52.4319 1.97053C54.7653 3.3015 56.6985 5.23468 58.0295 7.56812C60 11.0228 60 15.6485 60 24.9V35.1C60 44.3514 60 48.9772 58.0295 52.4319C56.6985 54.7653 54.7653 56.6985 52.4319 58.0295C48.9772 60 44.3514 60 35.1 60H24.9C15.6485 60 11.0228 60 7.56812 58.0295C5.23468 56.6985 3.3015 54.7653 1.97053 52.4319C0 48.9772 0 44.3514 0 35.1V24.9Z"\n      fill="#794CFF"\n    />\n    <path\n      d="M0.5 24.9C0.5 20.2652 0.50047 16.8221 0.744315 14.105C0.987552 11.3946 1.46987 9.45504 2.40484 7.81585C3.69145 5.56019 5.56019 3.69145 7.81585 2.40484C9.45504 1.46987 11.3946 0.987552 14.105 0.744315C16.8221 0.50047 20.2652 0.5 24.9 0.5H35.1C39.7348 0.5 43.1779 0.50047 45.895 0.744315C48.6054 0.987552 50.545 1.46987 52.1841 2.40484C54.4398 3.69145 56.3086 5.56019 57.5952 7.81585C58.5301 9.45504 59.0124 11.3946 59.2557 14.105C59.4995 16.8221 59.5 20.2652 59.5 24.9V35.1C59.5 39.7348 59.4995 43.1779 59.2557 45.895C59.0124 48.6054 58.5301 50.545 57.5952 52.1841C56.3086 54.4398 54.4398 56.3086 52.1841 57.5952C50.545 58.5301 48.6054 59.0124 45.895 59.2557C43.1779 59.4995 39.7348 59.5 35.1 59.5H24.9C20.2652 59.5 16.8221 59.4995 14.105 59.2557C11.3946 59.0124 9.45504 58.5301 7.81585 57.5952C5.56019 56.3086 3.69145 54.4398 2.40484 52.1841C1.46987 50.545 0.987552 48.6054 0.744315 45.895C0.50047 43.1779 0.5 39.7348 0.5 35.1V24.9Z"\n      stroke="#062B2B"\n      stroke-opacity="0.1"\n    />\n    <path\n      d="M35.1403 31.5016C35.1193 30.9637 35.388 30.4558 35.8446 30.1707C36.1207 29.9982 36.4761 29.8473 36.7921 29.7685C37.3143 29.6382 37.8664 29.7977 38.2386 30.1864C38.8507 30.8257 39.3004 31.6836 39.8033 32.408C40.2796 33.0942 41.4695 33.2512 41.9687 32.5047C42.4839 31.7341 42.9405 30.8229 43.572 30.1399C43.9375 29.7447 44.4866 29.5756 45.0111 29.6967C45.3283 29.7701 45.6863 29.9147 45.9655 30.0823C46.4269 30.3595 46.7045 30.8626 46.6928 31.4008C46.6731 32.3083 46.3764 33.2571 46.2158 34.1473C46.061 35.0048 46.9045 35.8337 47.7592 35.664C48.6464 35.4878 49.5899 35.1747 50.497 35.1391C51.0348 35.1181 51.5427 35.3868 51.8279 35.8433C52.0004 36.1195 52.1513 36.4749 52.2301 36.7908C52.3604 37.3131 52.2009 37.8651 51.8121 38.2374C51.1729 38.8495 50.3151 39.2991 49.5908 39.8019C48.9046 40.2782 48.7473 41.4683 49.4939 41.9675C50.2644 42.4827 51.1757 42.9393 51.8587 43.5708C52.2539 43.9362 52.423 44.4854 52.3018 45.0099C52.2285 45.3271 52.0839 45.6851 51.9162 45.9642C51.6391 46.4257 51.1359 46.7032 50.5978 46.6916C49.6903 46.6719 48.7417 46.3753 47.8516 46.2146C46.9939 46.0598 46.1648 46.9035 46.3346 47.7583C46.5108 48.6454 46.8239 49.5888 46.8594 50.4958C46.8805 51.0336 46.6117 51.5415 46.1552 51.8267C45.879 51.9992 45.5236 52.15 45.2077 52.2289C44.6854 52.3592 44.1334 52.1997 43.7611 51.8109C43.1491 51.1718 42.6996 50.314 42.1968 49.5897C41.7203 48.9034 40.5301 48.7463 40.0309 49.493C39.5157 50.2634 39.0592 51.1746 38.4278 51.8574C38.0623 52.2527 37.5132 52.4218 36.9887 52.3006C36.6715 52.2273 36.3135 52.0826 36.0343 51.915C35.5729 51.6379 35.2953 51.1347 35.307 50.5966C35.3267 49.6891 35.6233 48.7405 35.7839 47.8505C35.9388 46.9928 35.0951 46.1636 34.2402 46.3334C33.3531 46.5096 32.4098 46.8227 31.5028 46.8582C30.9649 46.8793 30.457 46.6105 30.1719 46.154C29.9994 45.8778 29.8485 45.5224 29.7697 45.2065C29.6394 44.6842 29.7989 44.1322 30.1877 43.7599C30.8269 43.1479 31.6847 42.6982 32.4091 42.1954C33.0954 41.7189 33.2522 40.5289 32.5056 40.0297C31.7351 39.5145 30.824 39.058 30.1411 38.4265C29.7459 38.0611 29.5768 37.5119 29.698 36.9875C29.7713 36.6702 29.9159 36.3122 30.0836 36.0331C30.3607 35.5717 30.8638 35.2941 31.402 35.3058C32.3095 35.3255 33.2583 35.6221 34.1485 35.7828C35.006 35.9376 35.8349 35.094 35.6652 34.2393C35.489 33.3521 35.1759 32.4087 35.1403 31.5016Z"\n      fill="#906EF7"\n      stroke="white"\n      stroke-width="2"\n    />\n    <path\n      d="M20.7706 8.22357C20.9036 7.51411 21.5231 7 22.2449 7H23.7551C24.4769 7 25.0964 7.51411 25.2294 8.22357C25.5051 9.69403 25.4829 11.6321 27.1202 12.2606C27.3092 12.3331 27.4958 12.4105 27.6798 12.4926C29.2818 13.2072 30.6374 11.8199 31.8721 10.9752C32.4678 10.5676 33.2694 10.6421 33.7798 11.1525L34.8477 12.2204C35.3581 12.7308 35.4326 13.5323 35.025 14.128C34.1802 15.3627 32.7931 16.7183 33.5077 18.3202C33.5898 18.5043 33.6672 18.6909 33.7398 18.88C34.3683 20.5171 36.3061 20.4949 37.7764 20.7706C38.4859 20.9036 39 21.5231 39 22.2449V23.7551C39 24.4769 38.4859 25.0964 37.7764 25.2294C36.3061 25.5051 34.3685 25.483 33.7401 27.1201C33.6675 27.3093 33.59 27.4961 33.5079 27.6803C32.7934 29.282 34.1803 30.6374 35.025 31.8719C35.4326 32.4677 35.3581 33.2692 34.8477 33.7796L33.7798 34.8475C33.2694 35.3579 32.4678 35.4324 31.8721 35.0248C30.6376 34.1801 29.2823 32.7934 27.6806 33.508C27.4962 33.5903 27.3093 33.6678 27.12 33.7405C25.483 34.3688 25.5051 36.3062 25.2294 37.7764C25.0964 38.4859 24.4769 39 23.7551 39H22.2449C21.5231 39 20.9036 38.4859 20.7706 37.7764C20.4949 36.3062 20.517 34.3688 18.88 33.7405C18.6908 33.6678 18.5039 33.5903 18.3196 33.5081C16.7179 32.7936 15.3625 34.1804 14.1279 35.0251C13.5322 35.4327 12.7307 35.3582 12.2203 34.8478L11.1524 33.7799C10.642 33.2695 10.5675 32.4679 10.9751 31.8722C11.8198 30.6376 13.2067 29.2822 12.4922 27.6804C12.41 27.4962 12.3325 27.3093 12.2599 27.1201C11.6315 25.483 9.69392 25.5051 8.22357 25.2294C7.51411 25.0964 7 24.4769 7 23.7551V22.2449C7 21.5231 7.51411 20.9036 8.22357 20.7706C9.69394 20.4949 11.6317 20.5171 12.2602 18.88C12.3328 18.6909 12.4103 18.5042 12.4924 18.3201C13.207 16.7181 11.8198 15.3625 10.975 14.1278C10.5674 13.5321 10.6419 12.7305 11.1523 12.2201L12.2202 11.1522C12.7306 10.6418 13.5322 10.5673 14.1279 10.9749C15.3626 11.8197 16.7184 13.2071 18.3204 12.4925C18.5044 12.4105 18.6909 12.3331 18.8799 12.2606C20.5171 11.6321 20.4949 9.69403 20.7706 8.22357Z"\n      fill="#906EF7"\n      stroke="white"\n      stroke-width="2"\n    />\n    <circle cx="23" cy="23" r="6" fill="#794CFF" stroke="white" stroke-width="2" />\n    <circle cx="41" cy="41" r="4" fill="#794CFF" stroke="white" stroke-width="2" />\n  </g>\n  <defs>\n    <clipPath id="1">\n      <rect width="60" height="60" fill="white" />\n    </clipPath>\n  </defs>\n</svg> '
    ]);
    $df6a6b1ad98d2cb1$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $df6a6b1ad98d2cb1$export$5752b741a746ef10 = (0, $1lUIm.svg)($df6a6b1ad98d2cb1$var$_templateObject());

});

parcelRegister("lUw6S", function(module, exports) {

$parcel$export(module.exports, "coinbaseSvg", function () { return $ff37bc4b51d932af$export$8661898196b83c8c; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $ff37bc4b51d932af$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">\n  <g clip-path="url(#clip0_187_29)">\n    <path d="M1.18187e-05 15.8055C1.18187e-05 9.8015 -5.19442e-07 6.91338 1.69991e-08 0C4.5 3.72236e-05 9.62249 0 16.5 0L23.5 4.31399e-05C29.9349 4.31399e-05 35.5 0.000206332 40 3.73468e-05C40 2.77754 40 9.36708 40 15.8055V22.8364C40 29.2647 40 33.7962 40 40C31.5 40 29.8337 40 23.4 40H16.6C10.5092 40 6.50004 40 4.04289e-05 40C3.05176e-05 32.2453 1.18187e-05 29.6382 1.18187e-05 22.8364V15.8055Z" fill="#0052FF"/>\n    <path d="M20.0236 26.5C16.4342 26.5 13.5236 23.5931 13.5236 20C13.5236 16.4069 16.4342 13.5 20.0236 13.5C23.2411 13.5 25.9134 15.8472 26.4261 18.9167H32.9731C32.4206 12.2433 26.8342 7 20.02 7C12.8411 7 7.02002 12.8211 7.02002 20C7.02002 27.1789 12.8411 33 20.02 33C26.8342 33 32.4206 27.7567 32.9731 21.0833H26.4225C25.9061 24.1528 23.2411 26.5 20.0236 26.5Z" fill="white"/>\n  </g>\n  <defs>\n    <clipPath id="clip0_187_29">\n      <rect width="40" height="40" fill="white"/>\n    </clipPath>\n  </defs>\n</svg>'
    ]);
    $ff37bc4b51d932af$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $ff37bc4b51d932af$export$8661898196b83c8c = (0, $1lUIm.svg)($ff37bc4b51d932af$var$_templateObject());

});

parcelRegister("1V7Ge", function(module, exports) {

$parcel$export(module.exports, "moonpaySvg", function () { return $16611274d1ccf59d$export$a9ed45040996931e; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $16611274d1ccf59d$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n  <svg width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg">\n    <g clip-path="url(#a)">\n      <path\n        d="M0 16.6c0-6.168 0-9.251 1.314-11.555a10 10 0 0 1 3.731-3.731C7.35 0 10.432 0 16.6 0h6.8c6.168 0 9.252 0 11.555 1.314a10 10 0 0 1 3.731 3.731C40 7.35 40 10.432 40 16.6v6.8c0 6.168 0 9.252-1.314 11.555a10 10 0 0 1-3.731 3.731C32.652 40 29.568 40 23.4 40h-6.8c-6.168 0-9.251 0-11.555-1.314a10 10 0 0 1-3.731-3.731C0 32.652 0 29.568 0 23.4v-6.8Z"\n        fill="#7D00FF"\n      />\n      <path\n        d="M.5 16.6c0-3.093 0-5.38.162-7.182.161-1.795.48-3.061 1.086-4.125a9.5 9.5 0 0 1 3.545-3.545C6.357 1.141 7.623.823 9.418.662 11.221.5 13.508.5 16.6.5h6.8c3.093 0 5.38 0 7.182.162 1.795.161 3.062.48 4.125 1.086a9.5 9.5 0 0 1 3.545 3.545c.607 1.064.925 2.33 1.086 4.125.161 1.803.162 4.09.162 7.182v6.8c0 3.093 0 5.38-.162 7.182-.161 1.795-.48 3.062-1.086 4.125a9.5 9.5 0 0 1-3.545 3.545c-1.063.607-2.33.925-4.125 1.086-1.803.161-4.09.162-7.182.162h-6.8c-3.093 0-5.38 0-7.182-.162-1.795-.161-3.061-.48-4.125-1.086a9.5 9.5 0 0 1-3.545-3.545c-.607-1.063-.925-2.33-1.086-4.125C.5 28.779.5 26.492.5 23.4v-6.8Z"\n        stroke="#fff"\n        stroke-opacity=".05"\n      />\n      <path\n        d="M28.306 15.381a3.69 3.69 0 1 0 0-7.381 3.69 3.69 0 0 0 0 7.381ZM16.987 32a8.991 8.991 0 1 1 .016-17.983A8.991 8.991 0 0 1 16.988 32Z"\n        fill="#fff"\n      />\n    </g>\n    <defs>\n      <clipPath id="a"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>\n    </defs>\n  </svg>\n'
    ]);
    $16611274d1ccf59d$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $16611274d1ccf59d$export$a9ed45040996931e = (0, $1lUIm.svg)($16611274d1ccf59d$var$_templateObject());

});

parcelRegister("lNk8w", function(module, exports) {

$parcel$export(module.exports, "stripeSvg", function () { return $fdddcb3f4b4ed722$export$e3fac6a9cb8f9c7b; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $fdddcb3f4b4ed722$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n  <svg width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg">\n    <g clip-path="url(#a)">\n      <path\n        d="M0 16.6c0-6.168 0-9.251 1.314-11.555a10 10 0 0 1 3.731-3.731C7.35 0 10.432 0 16.6 0h6.8c6.168 0 9.252 0 11.555 1.314a10 10 0 0 1 3.731 3.731C40 7.35 40 10.432 40 16.6v6.8c0 6.168 0 9.252-1.314 11.555a10 10 0 0 1-3.731 3.731C32.652 40 29.568 40 23.4 40h-6.8c-6.168 0-9.251 0-11.555-1.314a10 10 0 0 1-3.731-3.731C0 32.652 0 29.568 0 23.4v-6.8Z"\n        fill="#635BFF"\n      />\n      <path\n        d="M.5 16.6c0-3.093 0-5.38.162-7.182.161-1.795.48-3.061 1.086-4.125a9.5 9.5 0 0 1 3.545-3.545C6.357 1.141 7.623.823 9.418.662 11.221.5 13.508.5 16.6.5h6.8c3.093 0 5.38 0 7.182.162 1.795.161 3.062.48 4.125 1.086a9.5 9.5 0 0 1 3.545 3.545c.607 1.064.925 2.33 1.086 4.125.161 1.803.162 4.09.162 7.182v6.8c0 3.093 0 5.38-.162 7.182-.161 1.795-.48 3.062-1.086 4.125a9.5 9.5 0 0 1-3.545 3.545c-1.063.607-2.33.925-4.125 1.086-1.803.161-4.09.162-7.182.162h-6.8c-3.093 0-5.38 0-7.182-.162-1.795-.161-3.061-.48-4.125-1.086a9.5 9.5 0 0 1-3.545-3.545c-.607-1.063-.925-2.33-1.086-4.125C.5 28.779.5 26.492.5 23.4v-6.8Z"\n        stroke="#fff"\n        stroke-opacity=".05"\n      />\n      <path\n        fill-rule="evenodd"\n        clip-rule="evenodd"\n        d="M18.299 15.147c0-1.028.844-1.424 2.242-1.424 2.004 0 4.536.607 6.54 1.688V9.213C24.892 8.343 22.73 8 20.541 8c-5.354 0-8.915 2.796-8.915 7.464 0 7.279 10.022 6.118 10.022 9.257 0 1.213-1.055 1.609-2.531 1.609-2.19 0-4.985-.897-7.2-2.11v6.277a18.283 18.283 0 0 0 7.2 1.503c5.485 0 9.257-2.716 9.257-7.437-.027-7.86-10.075-6.462-10.075-9.416Z"\n        fill="#fff"\n      />\n    </g>\n    <defs>\n      <clipPath id="a"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>\n    </defs>\n  </svg>\n'
    ]);
    $fdddcb3f4b4ed722$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $fdddcb3f4b4ed722$export$e3fac6a9cb8f9c7b = (0, $1lUIm.svg)($fdddcb3f4b4ed722$var$_templateObject());

});

parcelRegister("kGplp", function(module, exports) {

$parcel$export(module.exports, "paypalSvg", function () { return $f0eb63b7e35ef48e$export$aa910b71a02cb299; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $f0eb63b7e35ef48e$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n  <svg width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg">\n    <g clip-path="url(#a)">\n      <path\n        d="M0 16.6c0-6.168 0-9.251 1.314-11.555a10 10 0 0 1 3.731-3.731C7.35 0 10.432 0 16.6 0h6.8c6.168 0 9.252 0 11.555 1.314a10 10 0 0 1 3.731 3.731C40 7.35 40 10.432 40 16.6v6.8c0 6.168 0 9.252-1.314 11.555a10 10 0 0 1-3.731 3.731C32.652 40 29.568 40 23.4 40h-6.8c-6.168 0-9.251 0-11.555-1.314a10 10 0 0 1-3.731-3.731C0 32.652 0 29.568 0 23.4v-6.8Z"\n        fill="#fff"\n      />\n      <path\n        d="M.5 16.6c0-3.093 0-5.38.162-7.182.161-1.795.48-3.061 1.086-4.125a9.5 9.5 0 0 1 3.545-3.545C6.357 1.141 7.623.823 9.418.662 11.221.5 13.508.5 16.6.5h6.8c3.093 0 5.38 0 7.182.162 1.795.161 3.062.48 4.125 1.086a9.5 9.5 0 0 1 3.545 3.545c.607 1.064.925 2.33 1.086 4.125.161 1.803.162 4.09.162 7.182v6.8c0 3.093 0 5.38-.162 7.182-.161 1.795-.48 3.062-1.086 4.125a9.5 9.5 0 0 1-3.545 3.545c-1.063.607-2.33.925-4.125 1.086-1.803.161-4.09.162-7.182.162h-6.8c-3.093 0-5.38 0-7.182-.162-1.795-.161-3.061-.48-4.125-1.086a9.5 9.5 0 0 1-3.545-3.545c-.607-1.063-.925-2.33-1.086-4.125C.5 28.779.5 26.492.5 23.4v-6.8Z"\n        stroke="#fff"\n        stroke-opacity=".05"\n      />\n      <path\n        d="M18.606 12.642a.781.781 0 0 0-.771.66l-1.281 8.125a.78.78 0 0 1 .77-.66h3.755a7.668 7.668 0 0 0 7.57-6.49 6.26 6.26 0 0 0 .075-.843c-.96-.504-2.089-.792-3.325-.792h-6.793Z"\n        fill="#001C64"\n      />\n      <path\n        d="M28.724 13.434c-.006.282-.03.564-.075.843a7.668 7.668 0 0 1-7.57 6.491h-3.754a.78.78 0 0 0-.771.66l-1.916 12.15a.634.634 0 0 0 .626.734h4.075a.781.781 0 0 0 .77-.66l1.074-6.807a.781.781 0 0 1 .772-.66h2.4a7.668 7.668 0 0 0 7.57-6.491c.415-2.651-.92-5.064-3.201-6.26Z"\n        fill="#0070E0"\n      />\n      <path\n        d="M13.977 7.226a.78.78 0 0 0-.771.658l-3.198 20.277a.634.634 0 0 0 .626.733h4.742l1.178-7.467 1.281-8.125a.782.782 0 0 1 .771-.66H25.4c1.237 0 2.364.289 3.325.792.065-3.4-2.74-6.208-6.599-6.208h-8.148Z"\n        fill="#003087"\n      />\n    </g>\n    <defs>\n      <clipPath id="a"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>\n    </defs>\n  </svg>\n'
    ]);
    $f0eb63b7e35ef48e$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $f0eb63b7e35ef48e$export$aa910b71a02cb299 = (0, $1lUIm.svg)($f0eb63b7e35ef48e$var$_templateObject());

});

parcelRegister("fi8Xf", function(module, exports) {

$parcel$export(module.exports, "onrampCardSvg", function () { return $b21f7ba5884770b2$export$bfa60d0bcc3bcad2; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $b21f7ba5884770b2$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg width="60" height="60" viewBox="0 0 60 60" fill="none">\n<g clip-path="url(#clip0_13859_31161)">\n  <path d="M0 24.8995C0 15.6481 0 11.0223 1.97053 7.56763C3.3015 5.2342 5.23468 3.30101 7.56812 1.97004C11.0228 -0.000488281 15.6485 -0.000488281 24.9 -0.000488281H35.1C44.3514 -0.000488281 48.9772 -0.000488281 52.4319 1.97004C54.7653 3.30101 56.6985 5.2342 58.0295 7.56763C60 11.0223 60 15.6481 60 24.8995V35.0995C60 44.351 60 48.9767 58.0295 52.4314C56.6985 54.7648 54.7653 56.698 52.4319 58.029C48.9772 59.9995 44.3514 59.9995 35.1 59.9995H24.9C15.6485 59.9995 11.0228 59.9995 7.56812 58.029C5.23468 56.698 3.3015 54.7648 1.97053 52.4314C0 48.9767 0 44.351 0 35.0995V24.8995Z" fill="#EB8B47"/>\n  <path d="M0.5 24.8995C0.5 20.2647 0.50047 16.8216 0.744315 14.1045C0.987552 11.3941 1.46987 9.45455 2.40484 7.81536C3.69145 5.55971 5.56019 3.69096 7.81585 2.40435C9.45504 1.46938 11.3946 0.987064 14.105 0.743826C16.8221 0.499981 20.2652 0.499512 24.9 0.499512H35.1C39.7348 0.499512 43.1779 0.499981 45.895 0.743826C48.6054 0.987064 50.545 1.46938 52.1841 2.40435C54.4398 3.69096 56.3086 5.55971 57.5952 7.81536C58.5301 9.45455 59.0124 11.3941 59.2557 14.1045C59.4995 16.8216 59.5 20.2647 59.5 24.8995V35.0995C59.5 39.7343 59.4995 43.1774 59.2557 45.8945C59.0124 48.6049 58.5301 50.5445 57.5952 52.1837C56.3086 54.4393 54.4398 56.3081 52.1841 57.5947C50.545 58.5296 48.6054 59.012 45.895 59.2552C43.1779 59.499 39.7348 59.4995 35.1 59.4995H24.9C20.2652 59.4995 16.8221 59.499 14.105 59.2552C11.3946 59.012 9.45504 58.5296 7.81585 57.5947C5.56019 56.3081 3.69145 54.4393 2.40484 52.1837C1.46987 50.5445 0.987552 48.6049 0.744315 45.8945C0.50047 43.1774 0.5 39.7343 0.5 35.0995V24.8995Z" stroke="#141414" stroke-opacity="0.1"/>\n  <path d="M13 26.0335C13 21.7838 13 19.659 14.0822 18.1694C14.4318 17.6883 14.8548 17.2653 15.3359 16.9157C16.8255 15.8335 18.9503 15.8335 23.2 15.8335H36.8C41.0497 15.8335 43.1745 15.8335 44.6641 16.9157C45.1452 17.2653 45.5682 17.6883 45.9178 18.1694C47 19.659 47 21.7838 47 26.0335V33.9668C47 38.2165 47 40.3414 45.9178 41.831C45.5682 42.312 45.1452 42.7351 44.6641 43.0846C43.1745 44.1668 41.0497 44.1668 36.8 44.1668H23.2C18.9503 44.1668 16.8255 44.1668 15.3359 43.0846C14.8548 42.7351 14.4318 42.312 14.0822 41.831C13 40.3414 13 38.2165 13 33.9668V26.0335Z" fill="#FF974C" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n  <path d="M39.5 36.667H36.6666" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>\n  <path d="M45.2 23.0645H14.8C14.0501 23.0645 13.6751 23.0645 13.4122 23.2554C13.3273 23.3171 13.2527 23.3918 13.191 23.4767C13 23.7395 13 24.1145 13 24.8645V27.2645C13 28.0144 13 28.3894 13.191 28.6522C13.2527 28.7371 13.3273 28.8118 13.4122 28.8735C13.6751 29.0645 14.0501 29.0645 14.8 29.0645H45.2C45.9499 29.0645 46.3249 29.0645 46.5878 28.8735C46.6727 28.8118 46.7473 28.7371 46.809 28.6522C47 28.3894 47 28.0144 47 27.2645V24.8645C47 24.1145 47 23.7395 46.809 23.4767C46.7473 23.3918 46.6727 23.3171 46.5878 23.2554C46.3249 23.0645 45.9499 23.0645 45.2 23.0645Z" fill="white" fill-opacity="0.4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n</g>\n<defs>\n  <clipPath id="clip0_13859_31161">\n    <rect width="60" height="60" fill="white"/>\n  </clipPath>\n</defs>\n</svg>'
    ]);
    $b21f7ba5884770b2$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $b21f7ba5884770b2$export$bfa60d0bcc3bcad2 = (0, $1lUIm.svg)($b21f7ba5884770b2$var$_templateObject());

});

parcelRegister("c5hsg", function(module, exports) {

$parcel$export(module.exports, "googleSvg", function () { return $8cc37dd2c7c10323$export$62a66155552ed9b0; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $8cc37dd2c7c10323$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <rect width="64" height="64" rx="30" fill="#1DC956"/>\n  <rect x="0.5" y="0.5" width="63" height="63" rx="29.5" stroke="#141414" stroke-opacity="0.1"/>\n  <path d="M32.4053 19.8031C35.3901 19.8031 38.0431 20.8349 40.1619 22.8247L45.9656 17.0211C42.4465 13.7416 37.8773 11.7333 32.4053 11.7333C24.4829 11.7333 17.6475 16.2841 14.3127 22.9168L21.056 28.1493C22.6589 23.359 27.136 19.8031 32.4053 19.8031Z" fill="#1DC956" stroke="white" stroke-width="2" stroke-linejoin="round"/>\n  <path d="M32.4053 52.2667C37.8773 52.2667 42.465 50.4611 45.8182 47.3658L39.2407 42.2623C37.4351 43.4783 35.1321 44.2153 32.4053 44.2153C27.136 44.2153 22.6589 40.6594 21.056 35.8691L14.3127 41.1016C17.6475 47.7159 24.4829 52.2667 32.4053 52.2667Z" fill="#2BEE6C"/>\n  <path d="M21.056 35.8507L19.5636 36.993L14.3127 41.0832M39.2407 42.2623L45.8182 47.3658C42.465 50.4611 37.8773 52.2667 32.4053 52.2667C24.4829 52.2667 17.6475 47.7159 14.3127 41.1016L21.056 35.8691C22.6589 40.6594 27.136 44.2153 32.4053 44.2153C35.1321 44.2153 37.4351 43.4783 39.2407 42.2623Z" stroke="white" stroke-width="2" stroke-linejoin="round"/>\n  <path d="M51.8613 32.4606C51.8613 31.0235 51.7323 29.6417 51.4928 28.3151H32.4053V36.1638H43.3124C42.8334 38.688 41.3963 40.8252 39.2407 42.2623L45.8181 47.3658C49.6503 43.8283 51.8613 38.6327 51.8613 32.4606Z" fill="#1FAD7E" stroke="white" stroke-width="2" stroke-linejoin="round"/>\n  <path d="M21.056 35.8507C20.6507 34.6347 20.4111 33.345 20.4111 32C20.4111 30.655 20.6507 29.3653 21.056 28.1493L14.3127 22.9169C12.9309 25.6437 12.1387 28.7205 12.1387 32C12.1387 35.2795 12.9309 38.3564 14.3127 41.0831L19.5636 36.993L21.056 35.8507Z" fill="#86F999"/>\n  <path d="M21.056 35.8691L14.3127 41.1016M21.056 35.8507C20.6507 34.6347 20.4111 33.345 20.4111 32C20.4111 30.655 20.6507 29.3653 21.056 28.1493L14.3127 22.9169C12.9309 25.6437 12.1387 28.7205 12.1387 32C12.1387 35.2795 12.9309 38.3564 14.3127 41.0831L19.5636 36.993L21.056 35.8507Z" stroke="white" stroke-width="2" stroke-linejoin="round"/>\n</svg>\n'
    ]);
    $8cc37dd2c7c10323$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $8cc37dd2c7c10323$export$62a66155552ed9b0 = (0, $1lUIm.svg)($8cc37dd2c7c10323$var$_templateObject());

});

parcelRegister("jj5bD", function(module, exports) {

$parcel$export(module.exports, "pencilSvg", function () { return $e0e3d09cf934eedc$export$e79a0508cc0c8f91; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $e0e3d09cf934eedc$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <g clip-path="url(#clip0_241_31635)">\n    <path d="M0 26.5595C0 16.6913 0 11.7572 2.1019 8.07217C3.5216 5.58317 5.58366 3.52111 8.07266 2.10141C11.7577 -0.000488281 16.6918 -0.000488281 26.56 -0.000488281H37.44C47.3082 -0.000488281 52.2423 -0.000488281 55.9273 2.10141C58.4163 3.52111 60.4784 5.58317 61.8981 8.07217C64 11.7572 64 16.6913 64 26.5595V37.4395C64 47.3077 64 52.2418 61.8981 55.9268C60.4784 58.4158 58.4163 60.4779 55.9273 61.8976C52.2423 63.9995 47.3082 63.9995 37.44 63.9995H26.56C16.6918 63.9995 11.7577 63.9995 8.07266 61.8976C5.58366 60.4779 3.5216 58.4158 2.1019 55.9268C0 52.2418 0 47.3077 0 37.4395V26.5595Z" fill="#EB8B47"/>\n    <path d="M0.5 26.5595C0.5 21.6163 0.50047 17.942 0.760736 15.0418C1.02039 12.1485 1.53555 10.0742 2.53621 8.3199C3.91155 5.90869 5.90917 3.91106 8.32039 2.53572C10.0747 1.53506 12.1489 1.01991 15.0423 0.760247C17.9425 0.499981 21.6168 0.499512 26.56 0.499512H37.44C42.3832 0.499512 46.0575 0.499981 48.9577 0.760247C51.8511 1.01991 53.9253 1.53506 55.6796 2.53572C58.0908 3.91106 60.0885 5.90869 61.4638 8.3199C62.4645 10.0742 62.9796 12.1485 63.2393 15.0418C63.4995 17.942 63.5 21.6163 63.5 26.5595V37.4395C63.5 42.3827 63.4995 46.057 63.2393 48.9572C62.9796 51.8506 62.4645 53.9248 61.4638 55.6791C60.0885 58.0903 58.0908 60.088 55.6796 61.4633C53.9253 62.464 51.8511 62.9791 48.9577 63.2388C46.0575 63.499 42.3832 63.4995 37.44 63.4995H26.56C21.6168 63.4995 17.9425 63.499 15.0423 63.2388C12.1489 62.9791 10.0747 62.464 8.32039 61.4633C5.90917 60.088 3.91155 58.0903 2.53621 55.6791C1.53555 53.9248 1.02039 51.8506 0.760736 48.9572C0.50047 46.057 0.5 42.3827 0.5 37.4395V26.5595Z" stroke="#141414" stroke-opacity="0.1"/>\n    <path d="M28.1042 49.2329L13.1024 51.2077L15.0772 36.2059L37.1015 14.1815C39.2441 12.039 40.3154 10.9677 41.5718 10.624C42.4205 10.3918 43.3159 10.3918 44.1645 10.624C45.421 10.9677 46.4922 12.039 48.6348 14.1815L50.1286 15.6753C52.2711 17.8179 53.3424 18.8891 53.6861 20.1456C53.9183 20.9942 53.9183 21.8896 53.6861 22.7383C53.3424 23.9947 52.2711 25.066 50.1286 27.2086L28.1042 49.2329Z" fill="#FF974C" stroke="#E4E7E7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n    <path d="M38.5962 20.5376L22.4199 36.7139" stroke="#E4E7E7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n    <path d="M43.7727 25.714L27.5964 41.8903" stroke="#E4E7E7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n    <path d="M22.3703 36.7635C19.3258 39.808 16.0198 36.6395 16.2616 35.0324" stroke="#E4E7E7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n    <path d="M27.5466 41.9399C24.5034 44.9831 28.155 48.7098 29.2738 48.0475" stroke="#E4E7E7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n    <path d="M27.5468 41.9398C23.428 46.0586 18.2516 40.8822 22.3704 36.7634" stroke="#E4E7E7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n    <path d="M15.8191 50.5214C15.4711 49.5823 14.728 48.8392 13.7889 48.4912" stroke="#E4E7E7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n    <path d="M49.2862 29.5805L34.7275 15.0219" stroke="#E4E7E7" stroke-width="2" stroke-linejoin="round"/>\n  </g>\n  <defs>\n    <clipPath id="clip0_241_31635">\n      <rect width="64" height="64" fill="white"/>\n    </clipPath>\n  </defs>\n</svg>\n'
    ]);
    $e0e3d09cf934eedc$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $e0e3d09cf934eedc$export$e79a0508cc0c8f91 = (0, $1lUIm.svg)($e0e3d09cf934eedc$var$_templateObject());

});

parcelRegister("1mVYB", function(module, exports) {

$parcel$export(module.exports, "lightbulbSvg", function () { return $0ff4d1713e111d60$export$e3455d95c95b44fb; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $0ff4d1713e111d60$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <g clip-path="url(#clip0_241_31636)">\n    <path d="M0 26.5595C0 16.6913 0 11.7572 2.1019 8.07217C3.5216 5.58318 5.58366 3.52111 8.07266 2.10141C11.7577 -0.000488281 16.6918 -0.000488281 26.56 -0.000488281H37.44C47.3082 -0.000488281 52.2423 -0.000488281 55.9273 2.10141C58.4163 3.52111 60.4784 5.58318 61.8981 8.07217C64 11.7572 64 16.6913 64 26.5595V37.4395C64 47.3077 64 52.2418 61.8981 55.9269C60.4784 58.4159 58.4163 60.4779 55.9273 61.8976C52.2423 63.9995 47.3082 63.9995 37.44 63.9995H26.56C16.6918 63.9995 11.7577 63.9995 8.07266 61.8976C5.58366 60.4779 3.5216 58.4159 2.1019 55.9269C0 52.2418 0 47.3077 0 37.4395V26.5595Z" fill="#794CFF"/>\n    <path d="M0.5 26.5595C0.5 21.6163 0.50047 17.942 0.760736 15.0418C1.02039 12.1485 1.53555 10.0742 2.53621 8.3199C3.91155 5.90869 5.90917 3.91106 8.32039 2.53572C10.0747 1.53506 12.1489 1.01991 15.0423 0.760247C17.9425 0.499981 21.6168 0.499512 26.56 0.499512H37.44C42.3832 0.499512 46.0575 0.499981 48.9577 0.760247C51.8511 1.01991 53.9253 1.53506 55.6796 2.53572C58.0908 3.91106 60.0885 5.90869 61.4638 8.3199C62.4645 10.0742 62.9796 12.1485 63.2393 15.0418C63.4995 17.942 63.5 21.6163 63.5 26.5595V37.4395C63.5 42.3827 63.4995 46.057 63.2393 48.9572C62.9796 51.8506 62.4645 53.9248 61.4638 55.6791C60.0885 58.0903 58.0908 60.088 55.6796 61.4633C53.9253 62.464 51.8511 62.9791 48.9577 63.2388C46.0575 63.499 42.3832 63.4995 37.44 63.4995H26.56C21.6168 63.4995 17.9425 63.499 15.0423 63.2388C12.1489 62.9791 10.0747 62.464 8.32039 61.4633C5.90917 60.088 3.91155 58.0903 2.53621 55.6791C1.53555 53.9248 1.02039 51.8506 0.760736 48.9572C0.50047 46.057 0.5 42.3827 0.5 37.4395V26.5595Z" stroke="#141414" stroke-opacity="0.1"/>\n    <path d="M40 39.4595C44.7824 36.693 48 31.5222 48 25.6C48 16.7634 40.8366 9.59998 32 9.59998C23.1634 9.59998 16 16.7634 16 25.6C16 31.5222 19.2176 36.693 24 39.4595V45.8144H40V39.4595Z" fill="#906EF7"/>\n    <path d="M24 49.9689C24 51.8192 24 52.7444 24.3941 53.4353C24.6603 53.902 25.0469 54.2886 25.5136 54.5548C26.2046 54.9489 27.1297 54.9489 28.98 54.9489H35.02C36.8703 54.9489 37.7954 54.9489 38.4864 54.5548C38.9531 54.2886 39.3397 53.902 39.6059 53.4353C40 52.7444 40 51.8192 40 49.9689V45.8144H24V49.9689Z" fill="#906EF7"/>\n    <path d="M24 45.8144V39.4595C19.2176 36.693 16 31.5222 16 25.6C16 16.7634 23.1634 9.59998 32 9.59998C40.8366 9.59998 48 16.7634 48 25.6C48 31.5222 44.7824 36.693 40 39.4595V45.8144M24 45.8144H40M24 45.8144V49.9689C24 51.8192 24 52.7444 24.3941 53.4353C24.6603 53.902 25.0469 54.2886 25.5136 54.5548C26.2046 54.9489 27.1297 54.9489 28.98 54.9489H35.02C36.8703 54.9489 37.7954 54.9489 38.4864 54.5548C38.9531 54.2886 39.3397 53.902 39.6059 53.4353C40 52.7444 40 51.8192 40 49.9689V45.8144" stroke="white" stroke-width="2" stroke-linejoin="round"/>\n    <path d="M24 49.9689C24 51.8192 24 52.7444 24.3941 53.4353C24.6603 53.902 25.0469 54.2886 25.5136 54.5548C26.2046 54.9489 27.1297 54.9489 28.98 54.9489H35.02C36.8703 54.9489 37.7954 54.9489 38.4864 54.5548C38.9531 54.2886 39.3397 53.902 39.6059 53.4353C40 52.7444 40 51.8192 40 49.9689V45.8144H24V49.9689Z" fill="#643CDD" stroke="white" stroke-width="2" stroke-linejoin="round"/>\n    <path d="M29.6735 26.9101V29.1109H34.0753V26.9101C34.0753 25.6945 35.0607 24.7092 36.2762 24.7092C37.4917 24.7092 38.4771 25.6945 38.4771 26.9101C38.4771 28.1256 37.4917 29.1109 36.2762 29.1109H34.0753H29.6735H27.4726C26.2571 29.1109 25.2717 28.1256 25.2717 26.9101C25.2717 25.6945 26.2571 24.7092 27.4726 24.7092C28.6881 24.7092 29.6735 25.6945 29.6735 26.9101Z" fill="#906EF7"/>\n    <path d="M29.6735 45.3183V26.9101C29.6735 25.6945 28.6881 24.7092 27.4726 24.7092V24.7092C26.2571 24.7092 25.2717 25.6945 25.2717 26.9101V26.9101C25.2717 28.1256 26.2571 29.1109 27.4726 29.1109H36.2762C37.4917 29.1109 38.4771 28.1256 38.4771 26.9101V26.9101C38.4771 25.6945 37.4917 24.7092 36.2762 24.7092V24.7092C35.0607 24.7092 34.0753 25.6945 34.0753 26.9101V45.3183" stroke="white" stroke-width="2" stroke-linejoin="round"/>\n  </g>\n  <defs>\n    <clipPath id="clip0_241_31636">\n      <rect width="64" height="64" fill="white"/>\n    </clipPath>\n  </defs>\n</svg>\n'
    ]);
    $0ff4d1713e111d60$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $0ff4d1713e111d60$export$e3455d95c95b44fb = (0, $1lUIm.svg)($0ff4d1713e111d60$var$_templateObject());

});

parcelRegister("diCke", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9aeaaf64b3228d5e$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $9aeaaf64b3228d5e$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: block;\n    width: var(--local-size);\n    height: var(--local-size);\n  }\n\n  :host svg {\n    width: 100%;\n    height: 100%;\n  }\n"
    ]);
    $9aeaaf64b3228d5e$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $9aeaaf64b3228d5e$export$2e2bcd8739ae039 = (0, $bBWVO.css)($9aeaaf64b3228d5e$var$_templateObject());

});


parcelRegister("6Y9or", function(module, exports) {

$parcel$export(module.exports, "WuiAccountButton", function () { return $512fa1f864521ef5$export$bfec9622ebde4e9e; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("3mWyR");
var $2vNUF = parcelRequire("2vNUF");
parcelRequire("9ZbyK");
parcelRequire("1OYaf");
parcelRequire("8tnK2");

var $kYNxm = parcelRequire("kYNxm");

var $dI7zX = parcelRequire("dI7zX");

var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("eDRu8");
parcelRequire("8jknp");

var $lAgO1 = parcelRequire("lAgO1");
function $512fa1f864521ef5$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      <button\n        ?disabled=",
        "\n        class=",
        "\n      >\n        ",
        '\n        <wui-flex gap="xxs" alignItems="center">\n          <wui-avatar\n            .imageSrc=',
        "\n            alt=",
        "\n            address=",
        '\n          ></wui-avatar>\n          <wui-text variant="paragraph-600" color="inherit">\n            ',
        "\n          </wui-text>\n        </wui-flex>\n      </button>\n    "
    ]);
    $512fa1f864521ef5$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $512fa1f864521ef5$var$_templateObject1() {
    var data = (0, $j06k0._)([
        ' <wui-icon-box\n          size="sm"\n          iconColor="error-100"\n          backgroundColor="error-100"\n          icon="warningCircle"\n        ></wui-icon-box>\n        <wui-text variant="paragraph-600" color="inherit"> Switch Network</wui-text>'
    ]);
    $512fa1f864521ef5$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $512fa1f864521ef5$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "<wui-image src=",
        "></wui-image>"
    ]);
    $512fa1f864521ef5$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $512fa1f864521ef5$var$_templateObject3() {
    var data = (0, $j06k0._)([
        '\n            <wui-icon-box\n              size="sm"\n              iconColor="fg-200"\n              backgroundColor="fg-300"\n              icon="networkPlaceholder"\n            ></wui-icon-box>\n          '
    ]);
    $512fa1f864521ef5$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $512fa1f864521ef5$var$_templateObject4() {
    var data = (0, $j06k0._)([
        "\n        ",
        '\n        <wui-text variant="paragraph-600" color="inherit"> ',
        "</wui-text>\n      "
    ]);
    $512fa1f864521ef5$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
var $512fa1f864521ef5$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $512fa1f864521ef5$export$bfec9622ebde4e9e = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiAccountButton, LitElement);
    var _super = (0, $ohfOJ._)(WuiAccountButton);
    function WuiAccountButton() {
        (0, $4GJKx._)(this, WuiAccountButton);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.networkSrc = undefined;
        _this.avatarSrc = undefined;
        _this.balance = undefined;
        _this.isUnsupportedChain = undefined;
        _this.disabled = false;
        _this.address = "";
        _this.profileName = "";
        _this.charsStart = 4;
        _this.charsEnd = 6;
        return _this;
    }
    (0, $1wc17._)(WuiAccountButton, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($512fa1f864521ef5$var$_templateObject(), this.disabled, (0, $2vNUF.ifDefined)(this.balance ? undefined : "local-no-balance"), this.balanceTemplate(), this.avatarSrc, this.address, this.address, this.address ? (0, $dI7zX.UiHelperUtil).getTruncateString({
                    string: this.profileName || this.address,
                    charsStart: this.profileName ? 18 : this.charsStart,
                    charsEnd: this.profileName ? 0 : this.charsEnd,
                    truncate: this.profileName ? "end" : "middle"
                }) : null);
            }
        },
        {
            key: "balanceTemplate",
            value: function balanceTemplate() {
                if (this.isUnsupportedChain) return (0, $1lUIm.html)($512fa1f864521ef5$var$_templateObject1());
                if (this.balance) {
                    var networkElement = this.networkSrc ? (0, $1lUIm.html)($512fa1f864521ef5$var$_templateObject2(), this.networkSrc) : (0, $1lUIm.html)($512fa1f864521ef5$var$_templateObject3());
                    return (0, $1lUIm.html)($512fa1f864521ef5$var$_templateObject4(), networkElement, this.balance);
                }
                return null;
            }
        }
    ]);
    return WuiAccountButton;
}((0, $eAsDt.LitElement));
$512fa1f864521ef5$export$bfec9622ebde4e9e.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $lAgO1.default)
];
$512fa1f864521ef5$var$__decorate([
    (0, $siQym.property)()
], $512fa1f864521ef5$export$bfec9622ebde4e9e.prototype, "networkSrc", void 0);
$512fa1f864521ef5$var$__decorate([
    (0, $siQym.property)()
], $512fa1f864521ef5$export$bfec9622ebde4e9e.prototype, "avatarSrc", void 0);
$512fa1f864521ef5$var$__decorate([
    (0, $siQym.property)()
], $512fa1f864521ef5$export$bfec9622ebde4e9e.prototype, "balance", void 0);
$512fa1f864521ef5$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $512fa1f864521ef5$export$bfec9622ebde4e9e.prototype, "isUnsupportedChain", void 0);
$512fa1f864521ef5$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $512fa1f864521ef5$export$bfec9622ebde4e9e.prototype, "disabled", void 0);
$512fa1f864521ef5$var$__decorate([
    (0, $siQym.property)()
], $512fa1f864521ef5$export$bfec9622ebde4e9e.prototype, "address", void 0);
$512fa1f864521ef5$var$__decorate([
    (0, $siQym.property)()
], $512fa1f864521ef5$export$bfec9622ebde4e9e.prototype, "profileName", void 0);
$512fa1f864521ef5$var$__decorate([
    (0, $siQym.property)()
], $512fa1f864521ef5$export$bfec9622ebde4e9e.prototype, "charsStart", void 0);
$512fa1f864521ef5$var$__decorate([
    (0, $siQym.property)()
], $512fa1f864521ef5$export$bfec9622ebde4e9e.prototype, "charsEnd", void 0);
$512fa1f864521ef5$export$bfec9622ebde4e9e = $512fa1f864521ef5$var$__decorate([
    (0, $hdxb6.customElement)("wui-account-button")
], $512fa1f864521ef5$export$bfec9622ebde4e9e);

});
parcelRegister("3mWyR", function(module, exports) {
$parcel$export(module.exports, "ifDefined", function () { return (parcelRequire("2vNUF")).ifDefined; });
parcelRequire("2vNUF");

});
parcelRegister("2vNUF", function(module, exports) {

$parcel$export(module.exports, "ifDefined", function () { return $1d4531b9f761f5c8$export$f68dd208b5df064d; });

var $1lUIm = parcelRequire("1lUIm");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $1d4531b9f761f5c8$export$f68dd208b5df064d = function(t) {
    return t !== null && t !== void 0 ? t : (0, $1lUIm.nothing);
};

});


parcelRegister("8tnK2", function(module, exports) {

$parcel$export(module.exports, "WuiFlex", function () { return $62b372b991f804be$export$cb455767ea18ce95; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");

var $kYNxm = parcelRequire("kYNxm");

var $dI7zX = parcelRequire("dI7zX");

var $hdxb6 = parcelRequire("hdxb6");

var $cFJpj = parcelRequire("cFJpj");
function $62b372b991f804be$var$_templateObject() {
    var data = (0, $j06k0._)([
        "<slot></slot>"
    ]);
    $62b372b991f804be$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $62b372b991f804be$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $62b372b991f804be$export$cb455767ea18ce95 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiFlex, LitElement);
    var _super = (0, $ohfOJ._)(WuiFlex);
    function WuiFlex() {
        (0, $4GJKx._)(this, WuiFlex);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(WuiFlex, [
        {
            key: "render",
            value: function render() {
                this.style.cssText = "\n      flex-direction: ".concat(this.flexDirection, ";\n      flex-wrap: ").concat(this.flexWrap, ";\n      flex-basis: ").concat(this.flexBasis, ";\n      flex-grow: ").concat(this.flexGrow, ";\n      flex-shrink: ").concat(this.flexShrink, ";\n      align-items: ").concat(this.alignItems, ";\n      justify-content: ").concat(this.justifyContent, ";\n      column-gap: ").concat(this.columnGap && "var(--wui-spacing-".concat(this.columnGap, ")"), ";\n      row-gap: ").concat(this.rowGap && "var(--wui-spacing-".concat(this.rowGap, ")"), ";\n      gap: ").concat(this.gap && "var(--wui-spacing-".concat(this.gap, ")"), ";\n      padding-top: ").concat(this.padding && (0, $dI7zX.UiHelperUtil).getSpacingStyles(this.padding, 0), ";\n      padding-right: ").concat(this.padding && (0, $dI7zX.UiHelperUtil).getSpacingStyles(this.padding, 1), ";\n      padding-bottom: ").concat(this.padding && (0, $dI7zX.UiHelperUtil).getSpacingStyles(this.padding, 2), ";\n      padding-left: ").concat(this.padding && (0, $dI7zX.UiHelperUtil).getSpacingStyles(this.padding, 3), ";\n      margin-top: ").concat(this.margin && (0, $dI7zX.UiHelperUtil).getSpacingStyles(this.margin, 0), ";\n      margin-right: ").concat(this.margin && (0, $dI7zX.UiHelperUtil).getSpacingStyles(this.margin, 1), ";\n      margin-bottom: ").concat(this.margin && (0, $dI7zX.UiHelperUtil).getSpacingStyles(this.margin, 2), ";\n      margin-left: ").concat(this.margin && (0, $dI7zX.UiHelperUtil).getSpacingStyles(this.margin, 3), ";\n    ");
                return (0, $1lUIm.html)($62b372b991f804be$var$_templateObject());
            }
        }
    ]);
    return WuiFlex;
}((0, $eAsDt.LitElement));
$62b372b991f804be$export$cb455767ea18ce95.styles = [
    (0, $kYNxm.resetStyles),
    (0, $cFJpj.default)
];
$62b372b991f804be$var$__decorate([
    (0, $siQym.property)()
], $62b372b991f804be$export$cb455767ea18ce95.prototype, "flexDirection", void 0);
$62b372b991f804be$var$__decorate([
    (0, $siQym.property)()
], $62b372b991f804be$export$cb455767ea18ce95.prototype, "flexWrap", void 0);
$62b372b991f804be$var$__decorate([
    (0, $siQym.property)()
], $62b372b991f804be$export$cb455767ea18ce95.prototype, "flexBasis", void 0);
$62b372b991f804be$var$__decorate([
    (0, $siQym.property)()
], $62b372b991f804be$export$cb455767ea18ce95.prototype, "flexGrow", void 0);
$62b372b991f804be$var$__decorate([
    (0, $siQym.property)()
], $62b372b991f804be$export$cb455767ea18ce95.prototype, "flexShrink", void 0);
$62b372b991f804be$var$__decorate([
    (0, $siQym.property)()
], $62b372b991f804be$export$cb455767ea18ce95.prototype, "alignItems", void 0);
$62b372b991f804be$var$__decorate([
    (0, $siQym.property)()
], $62b372b991f804be$export$cb455767ea18ce95.prototype, "justifyContent", void 0);
$62b372b991f804be$var$__decorate([
    (0, $siQym.property)()
], $62b372b991f804be$export$cb455767ea18ce95.prototype, "columnGap", void 0);
$62b372b991f804be$var$__decorate([
    (0, $siQym.property)()
], $62b372b991f804be$export$cb455767ea18ce95.prototype, "rowGap", void 0);
$62b372b991f804be$var$__decorate([
    (0, $siQym.property)()
], $62b372b991f804be$export$cb455767ea18ce95.prototype, "gap", void 0);
$62b372b991f804be$var$__decorate([
    (0, $siQym.property)()
], $62b372b991f804be$export$cb455767ea18ce95.prototype, "padding", void 0);
$62b372b991f804be$var$__decorate([
    (0, $siQym.property)()
], $62b372b991f804be$export$cb455767ea18ce95.prototype, "margin", void 0);
$62b372b991f804be$export$cb455767ea18ce95 = $62b372b991f804be$var$__decorate([
    (0, $hdxb6.customElement)("wui-flex")
], $62b372b991f804be$export$cb455767ea18ce95);

});
parcelRegister("dI7zX", function(module, exports) {

$parcel$export(module.exports, "UiHelperUtil", function () { return $9fb54372971dcc59$export$be769b74c01bc1bc; });

var $cv9Rk = parcelRequire("cv9Rk");
var $9fb54372971dcc59$export$be769b74c01bc1bc = {
    getSpacingStyles: function(spacing, index) {
        if (Array.isArray(spacing)) return spacing[index] ? "var(--wui-spacing-".concat(spacing[index], ")") : undefined;
        else if (typeof spacing === "string") return "var(--wui-spacing-".concat(spacing, ")");
        return undefined;
    },
    getFormattedDate: function(date) {
        return new Intl.DateTimeFormat("en-US", {
            month: "short",
            day: "numeric"
        }).format(date);
    },
    getHostName: function(url) {
        try {
            var newUrl = new URL(url);
            return newUrl.hostname;
        } catch (error) {
            return "";
        }
    },
    getTruncateString: function(param) {
        var string = param.string, charsStart = param.charsStart, charsEnd = param.charsEnd, truncate = param.truncate;
        if (string.length <= charsStart + charsEnd) return string;
        if (truncate === "end") return "".concat(string.substring(0, charsStart), "...");
        else if (truncate === "start") return "...".concat(string.substring(string.length - charsEnd));
        return "".concat(string.substring(0, Math.floor(charsStart)), "...").concat(string.substring(string.length - Math.floor(charsEnd)));
    },
    generateAvatarColors: function(address) {
        var hash = address.toLowerCase().replace(RegExp("^0x", "iu"), "");
        var baseColor = hash.substring(0, 6);
        var rgbColor = this.hexToRgb(baseColor);
        var masterBorderRadius = getComputedStyle(document.documentElement).getPropertyValue("--w3m-border-radius-master");
        var radius = Number(masterBorderRadius === null || masterBorderRadius === void 0 ? void 0 : masterBorderRadius.replace("px", ""));
        var edge = 100 - 3 * radius;
        var gradientCircle = "".concat(edge, "% ").concat(edge, "% at 65% 40%");
        var colors = [];
        for(var i = 0; i < 5; i += 1){
            var tintedColor = this.tintColor(rgbColor, 0.15 * i);
            colors.push("rgb(".concat(tintedColor[0], ", ").concat(tintedColor[1], ", ").concat(tintedColor[2], ")"));
        }
        return "\n    --local-color-1: ".concat(colors[0], ";\n    --local-color-2: ").concat(colors[1], ";\n    --local-color-3: ").concat(colors[2], ";\n    --local-color-4: ").concat(colors[3], ";\n    --local-color-5: ").concat(colors[4], ";\n    --local-radial-circle: ").concat(gradientCircle, "\n   ");
    },
    hexToRgb: function(hex) {
        var bigint = parseInt(hex, 16);
        var r = bigint >> 16 & 255;
        var g = bigint >> 8 & 255;
        var b = bigint & 255;
        return [
            r,
            g,
            b
        ];
    },
    tintColor: function(rgb, tint) {
        var _rgb = (0, $cv9Rk._)(rgb, 3), r = _rgb[0], g = _rgb[1], b = _rgb[2];
        var tintedR = Math.round(r + (255 - r) * tint);
        var tintedG = Math.round(g + (255 - g) * tint);
        var tintedB = Math.round(b + (255 - b) * tint);
        return [
            tintedR,
            tintedG,
            tintedB
        ];
    },
    isNumber: function(character) {
        var regex = {
            number: RegExp("^[0-9]+$", "u")
        };
        return regex.number.test(character);
    },
    getColorTheme: function(theme) {
        if (theme) return theme;
        else if (typeof window !== "undefined" && window.matchMedia) {
            if (window.matchMedia("(prefers-color-scheme: dark)").matches) return "dark";
            return "light";
        }
        return "dark";
    },
    splitBalance: function(input) {
        var parts = input.split(".");
        if (parts.length === 2) return [
            parts[0],
            parts[1]
        ];
        return [
            "0",
            "00"
        ];
    },
    roundNumber: function(number, threshold, fixed) {
        var roundedNumber = number.toString().length >= threshold ? Number(number).toFixed(fixed) : number;
        return roundedNumber;
    },
    formatNumberToLocalString: function(value) {
        var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
        if (value === undefined) return "0.00";
        if (typeof value === "number") return value.toLocaleString("en-US", {
            maximumFractionDigits: decimals,
            minimumFractionDigits: decimals
        });
        return parseFloat(value).toLocaleString("en-US", {
            maximumFractionDigits: decimals,
            minimumFractionDigits: decimals
        });
    }
};

});

parcelRegister("cFJpj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $939c89546c9198b4$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $939c89546c9198b4$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: flex;\n    width: inherit;\n    height: inherit;\n  }\n"
    ]);
    $939c89546c9198b4$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $939c89546c9198b4$export$2e2bcd8739ae039 = (0, $bBWVO.css)($939c89546c9198b4$var$_templateObject());

});


parcelRegister("eDRu8", function(module, exports) {

$parcel$export(module.exports, "WuiAvatar", function () { return $aa8e323a00d265af$export$21cc36693be5eb11; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("9ZbyK");

var $kYNxm = parcelRequire("kYNxm");

var $dI7zX = parcelRequire("dI7zX");

var $hdxb6 = parcelRequire("hdxb6");

var $j3KuW = parcelRequire("j3KuW");
function $aa8e323a00d265af$var$_templateObject() {
    var data = (0, $j06k0._)([
        "",
        ""
    ]);
    $aa8e323a00d265af$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $aa8e323a00d265af$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "<wui-image src=",
        " alt=",
        "></wui-image>"
    ]);
    $aa8e323a00d265af$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $aa8e323a00d265af$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $aa8e323a00d265af$export$21cc36693be5eb11 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiAvatar, LitElement);
    var _super = (0, $ohfOJ._)(WuiAvatar);
    function WuiAvatar() {
        (0, $4GJKx._)(this, WuiAvatar);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.imageSrc = undefined;
        _this.alt = undefined;
        _this.address = undefined;
        _this.size = "xl";
        return _this;
    }
    (0, $1wc17._)(WuiAvatar, [
        {
            key: "render",
            value: function render() {
                this.style.cssText = "\n    --local-width: var(--wui-icon-box-size-".concat(this.size, ");\n    --local-height: var(--wui-icon-box-size-").concat(this.size, ");\n    ");
                return (0, $1lUIm.html)($aa8e323a00d265af$var$_templateObject(), this.visualTemplate());
            }
        },
        {
            key: "visualTemplate",
            value: function visualTemplate() {
                if (this.imageSrc) {
                    this.dataset["variant"] = "image";
                    var _this_alt;
                    return (0, $1lUIm.html)($aa8e323a00d265af$var$_templateObject1(), this.imageSrc, (_this_alt = this.alt) !== null && _this_alt !== void 0 ? _this_alt : "avatar");
                } else if (this.address) {
                    this.dataset["variant"] = "generated";
                    var cssColors = (0, $dI7zX.UiHelperUtil).generateAvatarColors(this.address);
                    this.style.cssText += "\n ".concat(cssColors);
                    return null;
                }
                this.dataset["variant"] = "default";
                return null;
            }
        }
    ]);
    return WuiAvatar;
}((0, $eAsDt.LitElement));
$aa8e323a00d265af$export$21cc36693be5eb11.styles = [
    (0, $kYNxm.resetStyles),
    (0, $j3KuW.default)
];
$aa8e323a00d265af$var$__decorate([
    (0, $siQym.property)()
], $aa8e323a00d265af$export$21cc36693be5eb11.prototype, "imageSrc", void 0);
$aa8e323a00d265af$var$__decorate([
    (0, $siQym.property)()
], $aa8e323a00d265af$export$21cc36693be5eb11.prototype, "alt", void 0);
$aa8e323a00d265af$var$__decorate([
    (0, $siQym.property)()
], $aa8e323a00d265af$export$21cc36693be5eb11.prototype, "address", void 0);
$aa8e323a00d265af$var$__decorate([
    (0, $siQym.property)()
], $aa8e323a00d265af$export$21cc36693be5eb11.prototype, "size", void 0);
$aa8e323a00d265af$export$21cc36693be5eb11 = $aa8e323a00d265af$var$__decorate([
    (0, $hdxb6.customElement)("wui-avatar")
], $aa8e323a00d265af$export$21cc36693be5eb11);

});
parcelRegister("j3KuW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de025dab6bf90b7e$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $de025dab6bf90b7e$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: block;\n    width: var(--local-width);\n    height: var(--local-height);\n    border-radius: var(--wui-border-radius-3xl);\n    box-shadow: 0 0 0 8px var(--wui-color-gray-glass-005);\n    overflow: hidden;\n    position: relative;\n  }\n\n  :host([data-variant='generated']) {\n    --mixed-local-color-1: var(--local-color-1);\n    --mixed-local-color-2: var(--local-color-2);\n    --mixed-local-color-3: var(--local-color-3);\n    --mixed-local-color-4: var(--local-color-4);\n    --mixed-local-color-5: var(--local-color-5);\n  }\n\n  @supports (background: color-mix(in srgb, white 50%, black)) {\n    :host([data-variant='generated']) {\n      --mixed-local-color-1: color-mix(\n        in srgb,\n        var(--w3m-color-mix) var(--w3m-color-mix-strength),\n        var(--local-color-1)\n      );\n      --mixed-local-color-2: color-mix(\n        in srgb,\n        var(--w3m-color-mix) var(--w3m-color-mix-strength),\n        var(--local-color-2)\n      );\n      --mixed-local-color-3: color-mix(\n        in srgb,\n        var(--w3m-color-mix) var(--w3m-color-mix-strength),\n        var(--local-color-3)\n      );\n      --mixed-local-color-4: color-mix(\n        in srgb,\n        var(--w3m-color-mix) var(--w3m-color-mix-strength),\n        var(--local-color-4)\n      );\n      --mixed-local-color-5: color-mix(\n        in srgb,\n        var(--w3m-color-mix) var(--w3m-color-mix-strength),\n        var(--local-color-5)\n      );\n    }\n  }\n\n  :host([data-variant='generated']) {\n    box-shadow: 0 0 0 8px var(--wui-color-gray-glass-005);\n    background: radial-gradient(\n      var(--local-radial-circle),\n      #fff 0.52%,\n      var(--mixed-local-color-5) 31.25%,\n      var(--mixed-local-color-3) 51.56%,\n      var(--mixed-local-color-2) 65.63%,\n      var(--mixed-local-color-1) 82.29%,\n      var(--mixed-local-color-4) 100%\n    );\n  }\n\n  :host([data-variant='default']) {\n    box-shadow: 0 0 0 8px var(--wui-color-gray-glass-005);\n    background: radial-gradient(\n      75.29% 75.29% at 64.96% 24.36%,\n      #fff 0.52%,\n      #f5ccfc 31.25%,\n      #dba4f5 51.56%,\n      #9a8ee8 65.63%,\n      #6493da 82.29%,\n      #6ebdea 100%\n    );\n  }\n"
    ]);
    $de025dab6bf90b7e$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $de025dab6bf90b7e$export$2e2bcd8739ae039 = (0, $bBWVO.css)($de025dab6bf90b7e$var$_templateObject());

});


parcelRegister("8jknp", function(module, exports) {

$parcel$export(module.exports, "WuiIconBox", function () { return $60cfe76d42cd0fef$export$df20651935c1141; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("dcd5U");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $cKQpq = parcelRequire("cKQpq");
function $60cfe76d42cd0fef$var$_templateObject() {
    var data = (0, $j06k0._)([
        " <wui-icon color=",
        " size=",
        " name=",
        "></wui-icon> "
    ]);
    $60cfe76d42cd0fef$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $60cfe76d42cd0fef$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $60cfe76d42cd0fef$export$df20651935c1141 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiIconBox, LitElement);
    var _super = (0, $ohfOJ._)(WuiIconBox);
    function WuiIconBox() {
        (0, $4GJKx._)(this, WuiIconBox);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.size = "md";
        _this.backgroundColor = "accent-100";
        _this.iconColor = "accent-100";
        _this.background = "transparent";
        _this.border = false;
        _this.borderColor = "wui-color-bg-125";
        _this.icon = "copy";
        return _this;
    }
    (0, $1wc17._)(WuiIconBox, [
        {
            key: "render",
            value: function render() {
                var iconSize = this.iconSize || this.size;
                var isLg = this.size === "lg";
                var isXl = this.size === "xl";
                var bgMix = isLg ? "12%" : "16%";
                var borderRadius = isLg ? "xxs" : isXl ? "s" : "3xl";
                var isGray = this.background === "gray";
                var isOpaque = this.background === "opaque";
                var isColorChange = this.backgroundColor === "accent-100" && isOpaque || this.backgroundColor === "success-100" && isOpaque || this.backgroundColor === "error-100" && isOpaque || this.backgroundColor === "inverse-100" && isOpaque;
                var bgValueVariable = "var(--wui-color-".concat(this.backgroundColor, ")");
                if (isColorChange) bgValueVariable = "var(--wui-icon-box-bg-".concat(this.backgroundColor, ")");
                else if (isGray) bgValueVariable = "var(--wui-color-gray-".concat(this.backgroundColor, ")");
                this.style.cssText = "\n       --local-bg-value: ".concat(bgValueVariable, ";\n       --local-bg-mix: ").concat(isColorChange || isGray ? "100%" : bgMix, ";\n       --local-border-radius: var(--wui-border-radius-").concat(borderRadius, ");\n       --local-size: var(--wui-icon-box-size-").concat(this.size, ");\n       --local-border: ").concat(this.borderColor === "wui-color-bg-125" ? "2px" : "1px", " solid ").concat(this.border ? "var(--".concat(this.borderColor, ")") : "transparent", "\n   ");
                return (0, $1lUIm.html)($60cfe76d42cd0fef$var$_templateObject(), this.iconColor, iconSize, this.icon);
            }
        }
    ]);
    return WuiIconBox;
}((0, $eAsDt.LitElement));
$60cfe76d42cd0fef$export$df20651935c1141.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $cKQpq.default)
];
$60cfe76d42cd0fef$var$__decorate([
    (0, $siQym.property)()
], $60cfe76d42cd0fef$export$df20651935c1141.prototype, "size", void 0);
$60cfe76d42cd0fef$var$__decorate([
    (0, $siQym.property)()
], $60cfe76d42cd0fef$export$df20651935c1141.prototype, "backgroundColor", void 0);
$60cfe76d42cd0fef$var$__decorate([
    (0, $siQym.property)()
], $60cfe76d42cd0fef$export$df20651935c1141.prototype, "iconColor", void 0);
$60cfe76d42cd0fef$var$__decorate([
    (0, $siQym.property)()
], $60cfe76d42cd0fef$export$df20651935c1141.prototype, "iconSize", void 0);
$60cfe76d42cd0fef$var$__decorate([
    (0, $siQym.property)()
], $60cfe76d42cd0fef$export$df20651935c1141.prototype, "background", void 0);
$60cfe76d42cd0fef$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $60cfe76d42cd0fef$export$df20651935c1141.prototype, "border", void 0);
$60cfe76d42cd0fef$var$__decorate([
    (0, $siQym.property)()
], $60cfe76d42cd0fef$export$df20651935c1141.prototype, "borderColor", void 0);
$60cfe76d42cd0fef$var$__decorate([
    (0, $siQym.property)()
], $60cfe76d42cd0fef$export$df20651935c1141.prototype, "icon", void 0);
$60cfe76d42cd0fef$export$df20651935c1141 = $60cfe76d42cd0fef$var$__decorate([
    (0, $hdxb6.customElement)("wui-icon-box")
], $60cfe76d42cd0fef$export$df20651935c1141);

});
parcelRegister("cKQpq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94926f3e4799ee99$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $94926f3e4799ee99$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    overflow: hidden;\n    background-color: var(--wui-color-gray-glass-020);\n    border-radius: var(--local-border-radius);\n    border: var(--local-border);\n    box-sizing: content-box;\n    width: var(--local-size);\n    height: var(--local-size);\n    min-height: var(--local-size);\n    min-width: var(--local-size);\n  }\n\n  @supports (background: color-mix(in srgb, white 50%, black)) {\n    :host {\n      background-color: color-mix(in srgb, var(--local-bg-value) var(--local-bg-mix), transparent);\n    }\n  }\n"
    ]);
    $94926f3e4799ee99$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $94926f3e4799ee99$export$2e2bcd8739ae039 = (0, $bBWVO.css)($94926f3e4799ee99$var$_templateObject());

});


parcelRegister("lAgO1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb69ff101dba8193$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $fb69ff101dba8193$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: block;\n  }\n\n  button {\n    border-radius: var(--wui-border-radius-3xl);\n    background: var(--wui-color-gray-glass-002);\n    display: flex;\n    gap: var(--wui-spacing-xs);\n    padding: var(--wui-spacing-3xs) var(--wui-spacing-xs) var(--wui-spacing-3xs)\n      var(--wui-spacing-xs);\n    border: 1px solid var(--wui-color-gray-glass-005);\n  }\n\n  button:disabled {\n    background: var(--wui-color-gray-glass-015);\n  }\n\n  button:disabled > wui-text {\n    color: var(--wui-color-gray-glass-015);\n  }\n\n  button:disabled > wui-flex > wui-text {\n    color: var(--wui-color-gray-glass-015);\n  }\n\n  button:disabled > wui-image,\n  button:disabled > wui-flex > wui-avatar {\n    filter: grayscale(1);\n  }\n\n  button:has(wui-image) {\n    padding: var(--wui-spacing-3xs) var(--wui-spacing-3xs) var(--wui-spacing-3xs)\n      var(--wui-spacing-xs);\n  }\n\n  wui-text {\n    color: var(--wui-color-fg-100);\n  }\n\n  wui-flex > wui-text {\n    color: var(--wui-color-fg-200);\n  }\n\n  wui-image,\n  wui-icon-box {\n    border-radius: var(--wui-border-radius-3xl);\n    width: 24px;\n    height: 24px;\n    box-shadow: 0 0 0 2px var(--wui-color-gray-glass-005);\n  }\n\n  wui-flex {\n    border-radius: var(--wui-border-radius-3xl);\n    border: 1px solid var(--wui-color-gray-glass-005);\n    background: var(--wui-color-gray-glass-005);\n    padding: 4px var(--wui-spacing-m) 4px var(--wui-spacing-xxs);\n  }\n\n  button.local-no-balance {\n    border-radius: 0px;\n    border: none;\n    background: transparent;\n  }\n\n  wui-avatar {\n    width: 20px;\n    height: 20px;\n    box-shadow: 0 0 0 2px var(--wui-color-accent-glass-010);\n  }\n\n  @media (max-width: 500px) {\n    button {\n      gap: 0px;\n      padding: var(--wui-spacing-3xs) var(--wui-spacing-xs) !important;\n      height: 32px;\n    }\n    wui-image,\n    wui-icon-box,\n    button > wui-text {\n      visibility: hidden;\n      width: 0px;\n      height: 0px;\n    }\n    button {\n      border-radius: 0px;\n      border: none;\n      background: transparent;\n      padding: 0px;\n    }\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    button:hover:enabled > wui-flex > wui-text {\n      color: var(--wui-color-fg-175);\n    }\n\n    button:active:enabled > wui-flex > wui-text {\n      color: var(--wui-color-fg-175);\n    }\n  }\n"
    ]);
    $fb69ff101dba8193$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $fb69ff101dba8193$export$2e2bcd8739ae039 = (0, $bBWVO.css)($fb69ff101dba8193$var$_templateObject());

});


parcelRegister("4VTk3", function(module, exports) {

$parcel$export(module.exports, "WuiAllWalletsImage", function () { return $39776632dc528e79$export$92558ad1dd06e644; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $c6Xmf = parcelRequire("c6Xmf");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("3mWyR");
var $2vNUF = parcelRequire("2vNUF");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("U3J5G");
parcelRequire("8jknp");

var $lKxNn = parcelRequire("lKxNn");
function $39776632dc528e79$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n            <wui-wallet-image\n              size="inherit"\n              imageSrc=',
        "\n              name=",
        "\n            ></wui-wallet-image>\n          "
    ]);
    $39776632dc528e79$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $39776632dc528e79$var$_templateObject1() {
    var data = (0, $j06k0._)([
        ' <wui-wallet-image size="inherit" name=""></wui-wallet-image>'
    ]);
    $39776632dc528e79$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $39776632dc528e79$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "",
        "\n      ",
        '\n      <wui-flex>\n        <wui-icon-box\n          size="xxs"\n          iconSize="xxs"\n          iconcolor="success-100"\n          backgroundcolor="success-100"\n          icon="checkmark"\n          background="opaque"\n        ></wui-icon-box>\n      </wui-flex>'
    ]);
    $39776632dc528e79$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $39776632dc528e79$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $39776632dc528e79$var$TOTAL_IMAGES = 4;
var $39776632dc528e79$export$92558ad1dd06e644 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiAllWalletsImage, LitElement);
    var _super = (0, $ohfOJ._)(WuiAllWalletsImage);
    function WuiAllWalletsImage() {
        (0, $4GJKx._)(this, WuiAllWalletsImage);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.walletImages = [];
        return _this;
    }
    (0, $1wc17._)(WuiAllWalletsImage, [
        {
            key: "render",
            value: function render() {
                var isPlaceholders = this.walletImages.length < $39776632dc528e79$var$TOTAL_IMAGES;
                return (0, $1lUIm.html)($39776632dc528e79$var$_templateObject2(), this.walletImages.slice(0, $39776632dc528e79$var$TOTAL_IMAGES).map(function(param) {
                    var src = param.src, walletName = param.walletName;
                    return (0, $1lUIm.html)($39776632dc528e79$var$_templateObject(), src, (0, $2vNUF.ifDefined)(walletName));
                }), isPlaceholders ? (0, $c6Xmf._)(Array($39776632dc528e79$var$TOTAL_IMAGES - this.walletImages.length)).map(function() {
                    return (0, $1lUIm.html)($39776632dc528e79$var$_templateObject1());
                }) : null);
            }
        }
    ]);
    return WuiAllWalletsImage;
}((0, $eAsDt.LitElement));
$39776632dc528e79$export$92558ad1dd06e644.styles = [
    (0, $kYNxm.resetStyles),
    (0, $lKxNn.default)
];
$39776632dc528e79$var$__decorate([
    (0, $siQym.property)({
        type: Array
    })
], $39776632dc528e79$export$92558ad1dd06e644.prototype, "walletImages", void 0);
$39776632dc528e79$export$92558ad1dd06e644 = $39776632dc528e79$var$__decorate([
    (0, $hdxb6.customElement)("wui-all-wallets-image")
], $39776632dc528e79$export$92558ad1dd06e644);

});
parcelRegister("U3J5G", function(module, exports) {

$parcel$export(module.exports, "WuiWalletImage", function () { return $0a881f095b674939$export$2df48f4f4e74a226; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("dcd5U");
parcelRequire("9ZbyK");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("8jknp");

var $ljShF = parcelRequire("ljShF");
function $0a881f095b674939$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex justifyContent="center" alignItems="center"> ',
        " </wui-flex>\n    "
    ]);
    $0a881f095b674939$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $0a881f095b674939$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "<wui-image src=",
        " alt=",
        "></wui-image>"
    ]);
    $0a881f095b674939$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $0a881f095b674939$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '<wui-icon\n        data-parent-size="md"\n        size="md"\n        color="inherit"\n        name=',
        "\n      ></wui-icon>"
    ]);
    $0a881f095b674939$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $0a881f095b674939$var$_templateObject3() {
    var data = (0, $j06k0._)([
        "<wui-icon\n      data-parent-size=",
        '\n      size="inherit"\n      color="inherit"\n      name="walletPlaceholder"\n    ></wui-icon>'
    ]);
    $0a881f095b674939$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var $0a881f095b674939$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $0a881f095b674939$export$2df48f4f4e74a226 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiWalletImage, LitElement);
    var _super = (0, $ohfOJ._)(WuiWalletImage);
    function WuiWalletImage() {
        (0, $4GJKx._)(this, WuiWalletImage);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.size = "md";
        _this.name = "";
        _this.installed = false;
        _this.badgeSize = "xs";
        return _this;
    }
    (0, $1wc17._)(WuiWalletImage, [
        {
            key: "render",
            value: function render() {
                var borderRadius = "xxs";
                if (this.size === "lg") borderRadius = "m";
                else if (this.size === "md") borderRadius = "xs";
                else borderRadius = "xxs";
                this.style.cssText = "\n       --local-border-radius: var(--wui-border-radius-".concat(borderRadius, ");\n       --local-size: var(--wui-wallet-image-size-").concat(this.size, ");\n   ");
                if (this.walletIcon) this.dataset["walletIcon"] = this.walletIcon;
                return (0, $1lUIm.html)($0a881f095b674939$var$_templateObject(), this.templateVisual());
            }
        },
        {
            key: "templateVisual",
            value: function templateVisual() {
                if (this.imageSrc) return (0, $1lUIm.html)($0a881f095b674939$var$_templateObject1(), this.imageSrc, this.name);
                else if (this.walletIcon) return (0, $1lUIm.html)($0a881f095b674939$var$_templateObject2(), this.walletIcon);
                return (0, $1lUIm.html)($0a881f095b674939$var$_templateObject3(), this.size);
            }
        }
    ]);
    return WuiWalletImage;
}((0, $eAsDt.LitElement));
$0a881f095b674939$export$2df48f4f4e74a226.styles = [
    (0, $kYNxm.resetStyles),
    (0, $ljShF.default)
];
$0a881f095b674939$var$__decorate([
    (0, $siQym.property)()
], $0a881f095b674939$export$2df48f4f4e74a226.prototype, "size", void 0);
$0a881f095b674939$var$__decorate([
    (0, $siQym.property)()
], $0a881f095b674939$export$2df48f4f4e74a226.prototype, "name", void 0);
$0a881f095b674939$var$__decorate([
    (0, $siQym.property)()
], $0a881f095b674939$export$2df48f4f4e74a226.prototype, "imageSrc", void 0);
$0a881f095b674939$var$__decorate([
    (0, $siQym.property)()
], $0a881f095b674939$export$2df48f4f4e74a226.prototype, "walletIcon", void 0);
$0a881f095b674939$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $0a881f095b674939$export$2df48f4f4e74a226.prototype, "installed", void 0);
$0a881f095b674939$var$__decorate([
    (0, $siQym.property)()
], $0a881f095b674939$export$2df48f4f4e74a226.prototype, "badgeSize", void 0);
$0a881f095b674939$export$2df48f4f4e74a226 = $0a881f095b674939$var$__decorate([
    (0, $hdxb6.customElement)("wui-wallet-image")
], $0a881f095b674939$export$2df48f4f4e74a226);

});
parcelRegister("ljShF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8557af904e11b99$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $f8557af904e11b99$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    position: relative;\n    background-color: var(--wui-color-gray-glass-002);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: var(--local-size);\n    height: var(--local-size);\n    border-radius: inherit;\n    border-radius: var(--local-border-radius);\n  }\n\n  :host > wui-flex {\n    overflow: hidden;\n    border-radius: inherit;\n    border-radius: var(--local-border-radius);\n  }\n\n  :host::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    border-radius: inherit;\n    border: 1px solid var(--wui-color-gray-glass-010);\n    pointer-events: none;\n  }\n\n  :host([name='Extension'])::after {\n    border: 1px solid var(--wui-color-accent-glass-010);\n  }\n\n  :host([data-wallet-icon='allWallets']) {\n    background-color: var(--wui-all-wallets-bg-100);\n  }\n\n  :host([data-wallet-icon='allWallets'])::after {\n    border: 1px solid var(--wui-color-accent-glass-010);\n  }\n\n  wui-icon[data-parent-size='inherit'] {\n    width: 75%;\n    height: 75%;\n    align-items: center;\n  }\n\n  wui-icon[data-parent-size='sm'] {\n    width: 18px;\n    height: 18px;\n  }\n\n  wui-icon[data-parent-size='md'] {\n    width: 24px;\n    height: 24px;\n  }\n\n  wui-icon[data-parent-size='lg'] {\n    width: 42px;\n    height: 42px;\n  }\n\n  wui-icon[data-parent-size='full'] {\n    width: 100%;\n    height: 100%;\n  }\n\n  :host > wui-icon-box {\n    position: absolute;\n    overflow: hidden;\n    right: -1px;\n    bottom: -2px;\n    z-index: 1;\n    border: 2px solid var(--wui-color-bg-150, #1e1f1f);\n    padding: 1px;\n  }\n"
    ]);
    $f8557af904e11b99$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $f8557af904e11b99$export$2e2bcd8739ae039 = (0, $bBWVO.css)($f8557af904e11b99$var$_templateObject());

});


parcelRegister("lKxNn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd581be55bcb2eb1$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $fd581be55bcb2eb1$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    position: relative;\n    border-radius: var(--wui-border-radius-xxs);\n    width: 40px;\n    height: 40px;\n    overflow: hidden;\n    background: var(--wui-color-gray-glass-002);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: var(--wui-spacing-4xs);\n    padding: 3.75px !important;\n  }\n\n  :host::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    border-radius: inherit;\n    border: 1px solid var(--wui-color-gray-glass-010);\n    pointer-events: none;\n  }\n\n  :host > wui-wallet-image {\n    width: 14px;\n    height: 14px;\n    border-radius: var(--wui-border-radius-5xs);\n  }\n\n  :host > wui-flex {\n    padding: 2px;\n    position: fixed;\n    overflow: hidden;\n    left: 34px;\n    bottom: 8px;\n    background: var(--dark-background-150, #1e1f1f);\n    border-radius: 50%;\n    z-index: 2;\n    display: flex;\n  }\n"
    ]);
    $fd581be55bcb2eb1$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $fd581be55bcb2eb1$export$2e2bcd8739ae039 = (0, $bBWVO.css)($fd581be55bcb2eb1$var$_templateObject());

});


parcelRegister("1iTHu", function(module, exports) {

$parcel$export(module.exports, "WuiButton", function () { return $0f32add9e996ec7a$export$5496564a8aaab1b8; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("dcd5U");
parcelRequire("ePIOw");
parcelRequire("1OYaf");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $6XCmj = parcelRequire("6XCmj");
function $0f32add9e996ec7a$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      <button\n        data-variant=",
        "\n        data-icon-left=",
        "\n        data-icon-right=",
        "\n        data-size=",
        "\n        ?disabled=",
        "\n        ontouchstart\n      >\n        ",
        '\n        <slot name="iconLeft" @slotchange=',
        "></slot>\n        <wui-text variant=",
        ' color="inherit">\n          <slot></slot>\n        </wui-text>\n        <slot name="iconRight" @slotchange=',
        "></slot>\n      </button>\n    "
    ]);
    $0f32add9e996ec7a$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $0f32add9e996ec7a$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "<wui-loading-spinner color=",
        " size=",
        "></wui-loading-spinner>"
    ]);
    $0f32add9e996ec7a$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $0f32add9e996ec7a$var$_templateObject2() {
    var data = (0, $j06k0._)([
        ""
    ]);
    $0f32add9e996ec7a$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $0f32add9e996ec7a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $0f32add9e996ec7a$var$SPINNER_COLOR_BY_VARIANT = {
    main: "inverse-100",
    inverse: "inverse-000",
    accent: "accent-100",
    "accent-error": "error-100",
    "accent-success": "success-100",
    neutral: "fg-100",
    disabled: "gray-glass-020"
};
var $0f32add9e996ec7a$var$TEXT_VARIANT_BY_SIZE = {
    lg: "paragraph-600",
    md: "small-600"
};
var $0f32add9e996ec7a$var$SPINNER_SIZE_BY_SIZE = {
    lg: "md",
    md: "md"
};
var $0f32add9e996ec7a$export$5496564a8aaab1b8 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiButton, LitElement);
    var _super = (0, $ohfOJ._)(WuiButton);
    function WuiButton() {
        (0, $4GJKx._)(this, WuiButton);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.size = "lg";
        _this.disabled = false;
        _this.fullWidth = false;
        _this.loading = false;
        _this.variant = "main";
        _this.hasIconLeft = false;
        _this.hasIconRight = false;
        _this.borderRadius = "m";
        return _this;
    }
    (0, $1wc17._)(WuiButton, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                this.style.cssText = "\n    --local-width: ".concat(this.fullWidth ? "100%" : "auto", ";\n    --local-opacity-100: ").concat(this.loading ? 0 : 1, ";\n    --local-opacity-000: ").concat(this.loading ? 1 : 0, ";\n    --local-border-radius: var(--wui-border-radius-").concat(this.borderRadius, ");\n    ");
                var _this_textVariant;
                var textVariant = (_this_textVariant = this.textVariant) !== null && _this_textVariant !== void 0 ? _this_textVariant : $0f32add9e996ec7a$var$TEXT_VARIANT_BY_SIZE[this.size];
                return (0, $1lUIm.html)($0f32add9e996ec7a$var$_templateObject(), this.variant, this.hasIconLeft, this.hasIconRight, this.size, this.disabled, this.loadingTemplate(), function() {
                    return _this.handleSlotLeftChange();
                }, textVariant, function() {
                    return _this.handleSlotRightChange();
                });
            }
        },
        {
            key: "handleSlotLeftChange",
            value: function handleSlotLeftChange() {
                this.hasIconLeft = true;
            }
        },
        {
            key: "handleSlotRightChange",
            value: function handleSlotRightChange() {
                this.hasIconRight = true;
            }
        },
        {
            key: "loadingTemplate",
            value: function loadingTemplate() {
                if (this.loading) {
                    var size = $0f32add9e996ec7a$var$SPINNER_SIZE_BY_SIZE[this.size];
                    var color = this.disabled ? $0f32add9e996ec7a$var$SPINNER_COLOR_BY_VARIANT["disabled"] : $0f32add9e996ec7a$var$SPINNER_COLOR_BY_VARIANT[this.variant];
                    return (0, $1lUIm.html)($0f32add9e996ec7a$var$_templateObject1(), color, size);
                }
                return (0, $1lUIm.html)($0f32add9e996ec7a$var$_templateObject2());
            }
        }
    ]);
    return WuiButton;
}((0, $eAsDt.LitElement));
$0f32add9e996ec7a$export$5496564a8aaab1b8.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $6XCmj.default)
];
$0f32add9e996ec7a$var$__decorate([
    (0, $siQym.property)()
], $0f32add9e996ec7a$export$5496564a8aaab1b8.prototype, "size", void 0);
$0f32add9e996ec7a$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $0f32add9e996ec7a$export$5496564a8aaab1b8.prototype, "disabled", void 0);
$0f32add9e996ec7a$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $0f32add9e996ec7a$export$5496564a8aaab1b8.prototype, "fullWidth", void 0);
$0f32add9e996ec7a$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $0f32add9e996ec7a$export$5496564a8aaab1b8.prototype, "loading", void 0);
$0f32add9e996ec7a$var$__decorate([
    (0, $siQym.property)()
], $0f32add9e996ec7a$export$5496564a8aaab1b8.prototype, "variant", void 0);
$0f32add9e996ec7a$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $0f32add9e996ec7a$export$5496564a8aaab1b8.prototype, "hasIconLeft", void 0);
$0f32add9e996ec7a$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $0f32add9e996ec7a$export$5496564a8aaab1b8.prototype, "hasIconRight", void 0);
$0f32add9e996ec7a$var$__decorate([
    (0, $siQym.property)()
], $0f32add9e996ec7a$export$5496564a8aaab1b8.prototype, "borderRadius", void 0);
$0f32add9e996ec7a$var$__decorate([
    (0, $siQym.property)()
], $0f32add9e996ec7a$export$5496564a8aaab1b8.prototype, "textVariant", void 0);
$0f32add9e996ec7a$export$5496564a8aaab1b8 = $0f32add9e996ec7a$var$__decorate([
    (0, $hdxb6.customElement)("wui-button")
], $0f32add9e996ec7a$export$5496564a8aaab1b8);

});
parcelRegister("6XCmj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51160209cd566032$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $51160209cd566032$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    width: var(--local-width);\n    position: relative;\n  }\n\n  button {\n    border: none;\n    border-radius: var(--local-border-radius);\n    width: var(--local-width);\n    white-space: nowrap;\n  }\n\n  /* -- Sizes --------------------------------------------------- */\n  button[data-size='md'] {\n    padding: 8.2px var(--wui-spacing-l) 9px var(--wui-spacing-l);\n    height: 36px;\n  }\n\n  button[data-size='md'][data-icon-left='true'][data-icon-right='false'] {\n    padding: 8.2px var(--wui-spacing-l) 9px var(--wui-spacing-s);\n  }\n\n  button[data-size='md'][data-icon-right='true'][data-icon-left='false'] {\n    padding: 8.2px var(--wui-spacing-s) 9px var(--wui-spacing-l);\n  }\n\n  button[data-size='lg'] {\n    padding: var(--wui-spacing-m) var(--wui-spacing-2l);\n    height: 48px;\n  }\n\n  /* -- Variants --------------------------------------------------------- */\n  button[data-variant='main'] {\n    background-color: var(--wui-color-accent-100);\n    color: var(--wui-color-inverse-100);\n    border: none;\n    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-010);\n  }\n\n  button[data-variant='inverse'] {\n    background-color: var(--wui-color-inverse-100);\n    color: var(--wui-color-inverse-000);\n    border: none;\n    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-010);\n  }\n\n  button[data-variant='accent'] {\n    background-color: var(--wui-color-accent-glass-010);\n    color: var(--wui-color-accent-100);\n    border: none;\n    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-005);\n  }\n\n  button[data-variant='accent-error'] {\n    background: var(--wui-color-error-glass-015);\n    color: var(--wui-color-error-100);\n    border: none;\n    box-shadow: inset 0 0 0 1px var(--wui-color-error-glass-010);\n  }\n\n  button[data-variant='accent-success'] {\n    background: var(--wui-color-success-glass-015);\n    color: var(--wui-color-success-100);\n    border: none;\n    box-shadow: inset 0 0 0 1px var(--wui-color-success-glass-010);\n  }\n\n  button[data-variant='neutral'] {\n    background: transparent;\n    color: var(--wui-color-fg-100);\n    border: none;\n    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-005);\n  }\n\n  /* -- Focus states --------------------------------------------------- */\n  button[data-variant='main']:focus-visible:enabled {\n    background-color: var(--wui-color-accent-090);\n    box-shadow:\n      inset 0 0 0 1px var(--wui-color-accent-100),\n      0 0 0 4px var(--wui-color-accent-glass-020);\n  }\n  button[data-variant='inverse']:focus-visible:enabled {\n    background-color: var(--wui-color-inverse-100);\n    box-shadow:\n      inset 0 0 0 1px var(--wui-color-gray-glass-010),\n      0 0 0 4px var(--wui-color-accent-glass-020);\n  }\n  button[data-variant='accent']:focus-visible:enabled {\n    background-color: var(--wui-color-accent-glass-010);\n    box-shadow:\n      inset 0 0 0 1px var(--wui-color-accent-100),\n      0 0 0 4px var(--wui-color-accent-glass-020);\n  }\n  button[data-variant='accent-error']:focus-visible:enabled {\n    background: var(--wui-color-error-glass-015);\n    box-shadow:\n      inset 0 0 0 1px var(--wui-color-error-100),\n      0 0 0 4px var(--wui-color-error-glass-020);\n  }\n  button[data-variant='accent-success']:focus-visible:enabled {\n    background: var(--wui-color-success-glass-015);\n    box-shadow:\n      inset 0 0 0 1px var(--wui-color-success-100),\n      0 0 0 4px var(--wui-color-success-glass-020);\n  }\n  button[data-variant='neutral']:focus-visible:enabled {\n    background: var(--wui-color-gray-glass-005);\n    box-shadow:\n      inset 0 0 0 1px var(--wui-color-gray-glass-010),\n      0 0 0 4px var(--wui-color-gray-glass-002);\n  }\n\n  /* -- Hover & Active states ----------------------------------------------------------- */\n  @media (hover: hover) and (pointer: fine) {\n    button[data-variant='main']:hover:enabled {\n      background-color: var(--wui-color-accent-090);\n    }\n\n    button[data-variant='main']:active:enabled {\n      background-color: var(--wui-color-accent-080);\n    }\n\n    button[data-variant='accent']:hover:enabled {\n      background-color: var(--wui-color-accent-glass-015);\n    }\n\n    button[data-variant='accent']:active:enabled {\n      background-color: var(--wui-color-accent-glass-020);\n    }\n\n    button[data-variant='accent-error']:hover:enabled {\n      background: var(--wui-color-error-glass-020);\n      color: var(--wui-color-error-100);\n    }\n\n    button[data-variant='accent-error']:active:enabled {\n      background: var(--wui-color-error-glass-030);\n      color: var(--wui-color-error-100);\n    }\n\n    button[data-variant='accent-success']:hover:enabled {\n      background: var(--wui-color-success-glass-020);\n      color: var(--wui-color-success-100);\n    }\n\n    button[data-variant='accent-success']:active:enabled {\n      background: var(--wui-color-success-glass-030);\n      color: var(--wui-color-success-100);\n    }\n\n    button[data-variant='neutral']:hover:enabled {\n      background: var(--wui-color-gray-glass-002);\n    }\n\n    button[data-variant='neutral']:active:enabled {\n      background: var(--wui-color-gray-glass-005);\n    }\n\n    button[data-size='lg'][data-icon-left='true'][data-icon-right='false'] {\n      padding-left: var(--wui-spacing-m);\n    }\n\n    button[data-size='lg'][data-icon-right='true'][data-icon-left='false'] {\n      padding-right: var(--wui-spacing-m);\n    }\n  }\n\n  /* -- Disabled state --------------------------------------------------- */\n  button:disabled {\n    background-color: var(--wui-color-gray-glass-002);\n    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-002);\n    color: var(--wui-color-gray-glass-020);\n    cursor: not-allowed;\n  }\n\n  button > wui-text {\n    transition: opacity var(--wui-ease-out-power-1) var(--wui-duration-md);\n    will-change: opacity;\n    opacity: var(--local-opacity-100);\n  }\n\n  ::slotted(*) {\n    transition: opacity var(--wui-ease-out-power-1) var(--wui-duration-md);\n    will-change: opacity;\n    opacity: var(--local-opacity-100);\n  }\n\n  wui-loading-spinner {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    opacity: var(--local-opacity-000);\n  }\n"
    ]);
    $51160209cd566032$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $51160209cd566032$export$2e2bcd8739ae039 = (0, $bBWVO.css)($51160209cd566032$var$_templateObject());

});


parcelRegister("2tkBE", function(module, exports) {

$parcel$export(module.exports, "WuiCardSelectLoader", function () { return $1cce462bc4fc151b$export$fc388e944144bd3a; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");

var $ju2is = parcelRequire("ju2is");
parcelRequire("7stzQ");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $c0EQr = parcelRequire("c0EQr");
function $1cce462bc4fc151b$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      ",
        '\n      <wui-shimmer width="56px" height="20px" borderRadius="xs"></wui-shimmer>\n    '
    ]);
    $1cce462bc4fc151b$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $1cce462bc4fc151b$var$_templateObject1() {
    var data = (0, $j06k0._)([
        " <wui-shimmer\n          data-type=",
        '\n          width="48px"\n          height="54px"\n          borderRadius="xs"\n        ></wui-shimmer>\n        ',
        ""
    ]);
    $1cce462bc4fc151b$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $1cce462bc4fc151b$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '<wui-shimmer width="56px" height="56px" borderRadius="xs"></wui-shimmer>'
    ]);
    $1cce462bc4fc151b$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $1cce462bc4fc151b$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $1cce462bc4fc151b$export$fc388e944144bd3a = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiCardSelectLoader, LitElement);
    var _super = (0, $ohfOJ._)(WuiCardSelectLoader);
    function WuiCardSelectLoader() {
        (0, $4GJKx._)(this, WuiCardSelectLoader);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.type = "wallet";
        return _this;
    }
    (0, $1wc17._)(WuiCardSelectLoader, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($1cce462bc4fc151b$var$_templateObject(), this.shimmerTemplate());
            }
        },
        {
            key: "shimmerTemplate",
            value: function shimmerTemplate() {
                if (this.type === "network") return (0, $1lUIm.html)($1cce462bc4fc151b$var$_templateObject1(), this.type, (0, $ju2is.networkSvgMd));
                return (0, $1lUIm.html)($1cce462bc4fc151b$var$_templateObject2());
            }
        }
    ]);
    return WuiCardSelectLoader;
}((0, $eAsDt.LitElement));
$1cce462bc4fc151b$export$fc388e944144bd3a.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $c0EQr.default)
];
$1cce462bc4fc151b$var$__decorate([
    (0, $siQym.property)()
], $1cce462bc4fc151b$export$fc388e944144bd3a.prototype, "type", void 0);
$1cce462bc4fc151b$export$fc388e944144bd3a = $1cce462bc4fc151b$var$__decorate([
    (0, $hdxb6.customElement)("wui-card-select-loader")
], $1cce462bc4fc151b$export$fc388e944144bd3a);

});
parcelRegister("ju2is", function(module, exports) {

$parcel$export(module.exports, "networkSvgMd", function () { return $e2f299bd974d715d$export$711c5994129523c4; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $e2f299bd974d715d$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg  viewBox="0 0 48 54" fill="none">\n  <path\n    d="M43.4605 10.7248L28.0485 1.61089C25.5438 0.129705 22.4562 0.129705 19.9515 1.61088L4.53951 10.7248C2.03626 12.2051 0.5 14.9365 0.5 17.886V36.1139C0.5 39.0635 2.03626 41.7949 4.53951 43.2752L19.9515 52.3891C22.4562 53.8703 25.5438 53.8703 28.0485 52.3891L43.4605 43.2752C45.9637 41.7949 47.5 39.0635 47.5 36.114V17.8861C47.5 14.9365 45.9637 12.2051 43.4605 10.7248Z"\n  />\n</svg>'
    ]);
    $e2f299bd974d715d$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $e2f299bd974d715d$export$711c5994129523c4 = (0, $1lUIm.svg)($e2f299bd974d715d$var$_templateObject());

});

parcelRegister("c0EQr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8be52b132ae15f02$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $8be52b132ae15f02$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 76px;\n    row-gap: var(--wui-spacing-xs);\n    padding: var(--wui-spacing-xs) 10px;\n    background-color: var(--wui-color-gray-glass-002);\n    border-radius: clamp(0px, var(--wui-border-radius-xs), 20px);\n    position: relative;\n  }\n\n  wui-shimmer[data-type='network'] {\n    border: none;\n    -webkit-clip-path: var(--wui-path-network);\n    clip-path: var(--wui-path-network);\n  }\n\n  svg {\n    position: absolute;\n    width: 48px;\n    height: 54px;\n    z-index: 1;\n  }\n\n  svg > path {\n    stroke: var(--wui-color-gray-glass-010);\n    stroke-width: 1px;\n  }\n"
    ]);
    $8be52b132ae15f02$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $8be52b132ae15f02$export$2e2bcd8739ae039 = (0, $bBWVO.css)($8be52b132ae15f02$var$_templateObject());

});


parcelRegister("9B3Gw", function(module, exports) {

$parcel$export(module.exports, "WuiCardSelect", function () { return $6fca6d83942c5dfe$export$815c16e0af51756a; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("3mWyR");
var $2vNUF = parcelRequire("2vNUF");
parcelRequire("1OYaf");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("9zFRT");
parcelRequire("U3J5G");

var $3bdmn = parcelRequire("3bdmn");
function $6fca6d83942c5dfe$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      <button data-selected=",
        " ?disabled=",
        " ontouchstart>\n        ",
        '\n        <wui-text variant="tiny-500" color=',
        ">\n          ",
        "\n        </wui-text>\n      </button>\n    "
    ]);
    $6fca6d83942c5dfe$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $6fca6d83942c5dfe$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "\n        <wui-network-image\n          .selected=",
        "\n          imageSrc=",
        "\n          name=",
        "\n        >\n        </wui-network-image>\n      "
    ]);
    $6fca6d83942c5dfe$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fca6d83942c5dfe$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '\n      <wui-wallet-image\n        size="md"\n        imageSrc=',
        "\n        name=",
        "\n        .installed=",
        '\n        badgeSize="sm"\n      >\n      </wui-wallet-image>\n    '
    ]);
    $6fca6d83942c5dfe$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $6fca6d83942c5dfe$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $6fca6d83942c5dfe$export$815c16e0af51756a = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiCardSelect, LitElement);
    var _super = (0, $ohfOJ._)(WuiCardSelect);
    function WuiCardSelect() {
        (0, $4GJKx._)(this, WuiCardSelect);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "Unknown";
        _this.type = "wallet";
        _this.imageSrc = undefined;
        _this.disabled = false;
        _this.selected = false;
        _this.installed = false;
        return _this;
    }
    (0, $1wc17._)(WuiCardSelect, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($6fca6d83942c5dfe$var$_templateObject(), (0, $2vNUF.ifDefined)(this.selected), this.disabled, this.imageTemplate(), this.selected ? "accent-100" : "inherit", this.name);
            }
        },
        {
            key: "imageTemplate",
            value: function imageTemplate() {
                if (this.type === "network") return (0, $1lUIm.html)($6fca6d83942c5dfe$var$_templateObject1(), this.selected, (0, $2vNUF.ifDefined)(this.imageSrc), this.name);
                return (0, $1lUIm.html)($6fca6d83942c5dfe$var$_templateObject2(), (0, $2vNUF.ifDefined)(this.imageSrc), this.name, this.installed);
            }
        }
    ]);
    return WuiCardSelect;
}((0, $eAsDt.LitElement));
$6fca6d83942c5dfe$export$815c16e0af51756a.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $3bdmn.default)
];
$6fca6d83942c5dfe$var$__decorate([
    (0, $siQym.property)()
], $6fca6d83942c5dfe$export$815c16e0af51756a.prototype, "name", void 0);
$6fca6d83942c5dfe$var$__decorate([
    (0, $siQym.property)()
], $6fca6d83942c5dfe$export$815c16e0af51756a.prototype, "type", void 0);
$6fca6d83942c5dfe$var$__decorate([
    (0, $siQym.property)()
], $6fca6d83942c5dfe$export$815c16e0af51756a.prototype, "imageSrc", void 0);
$6fca6d83942c5dfe$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $6fca6d83942c5dfe$export$815c16e0af51756a.prototype, "disabled", void 0);
$6fca6d83942c5dfe$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $6fca6d83942c5dfe$export$815c16e0af51756a.prototype, "selected", void 0);
$6fca6d83942c5dfe$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $6fca6d83942c5dfe$export$815c16e0af51756a.prototype, "installed", void 0);
$6fca6d83942c5dfe$export$815c16e0af51756a = $6fca6d83942c5dfe$var$__decorate([
    (0, $hdxb6.customElement)("wui-card-select")
], $6fca6d83942c5dfe$export$815c16e0af51756a);

});
parcelRegister("9zFRT", function(module, exports) {

$parcel$export(module.exports, "WuiNetworkImage", function () { return $6f87dc1be7b35a1b$export$4dc5510728d31c71; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");

var $gi2tT = parcelRequire("gi2tT");

var $ju2is = parcelRequire("ju2is");

var $iqkII = parcelRequire("iqkII");
parcelRequire("dcd5U");
parcelRequire("9ZbyK");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $9jLxO = parcelRequire("9jLxO");
function $6f87dc1be7b35a1b$var$_templateObject() {
    var data = (0, $j06k0._)([
        "",
        " ",
        " "
    ]);
    $6f87dc1be7b35a1b$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $6f87dc1be7b35a1b$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "<wui-image src=",
        " alt=",
        "></wui-image>"
    ]);
    $6f87dc1be7b35a1b$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $6f87dc1be7b35a1b$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '<wui-icon size="inherit" color="fg-200" name="networkPlaceholder"></wui-icon>'
    ]);
    $6f87dc1be7b35a1b$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $6f87dc1be7b35a1b$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $6f87dc1be7b35a1b$export$4dc5510728d31c71 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiNetworkImage, LitElement);
    var _super = (0, $ohfOJ._)(WuiNetworkImage);
    function WuiNetworkImage() {
        (0, $4GJKx._)(this, WuiNetworkImage);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.size = "md";
        _this.name = "uknown";
        _this.networkImagesBySize = {
            sm: (0, $gi2tT.networkSvgSm),
            md: (0, $ju2is.networkSvgMd),
            lg: (0, $iqkII.networkSvgLg)
        };
        _this.selected = false;
        _this.round = false;
        return _this;
    }
    (0, $1wc17._)(WuiNetworkImage, [
        {
            key: "render",
            value: function render() {
                if (this.round) {
                    this.dataset["round"] = "true";
                    this.style.cssText = "\n      --local-width: var(--wui-spacing-3xl);\n      --local-height: var(--wui-spacing-3xl);\n      --local-icon-size: var(--wui-spacing-l);\n    ";
                } else this.style.cssText = "\n\n      --local-path: var(--wui-path-network-".concat(this.size, ");\n      --local-width:  var(--wui-width-network-").concat(this.size, ");\n      --local-height:  var(--wui-height-network-").concat(this.size, ");\n      --local-icon-size:  var(--wui-icon-size-network-").concat(this.size, ");\n    ");
                return (0, $1lUIm.html)($6f87dc1be7b35a1b$var$_templateObject(), this.templateVisual(), this.svgTemplate());
            }
        },
        {
            key: "svgTemplate",
            value: function svgTemplate() {
                if (this.round) return null;
                return this.networkImagesBySize[this.size];
            }
        },
        {
            key: "templateVisual",
            value: function templateVisual() {
                if (this.imageSrc) return (0, $1lUIm.html)($6f87dc1be7b35a1b$var$_templateObject1(), this.imageSrc, this.name);
                return (0, $1lUIm.html)($6f87dc1be7b35a1b$var$_templateObject2());
            }
        }
    ]);
    return WuiNetworkImage;
}((0, $eAsDt.LitElement));
$6f87dc1be7b35a1b$export$4dc5510728d31c71.styles = [
    (0, $kYNxm.resetStyles),
    (0, $9jLxO.default)
];
$6f87dc1be7b35a1b$var$__decorate([
    (0, $siQym.property)()
], $6f87dc1be7b35a1b$export$4dc5510728d31c71.prototype, "size", void 0);
$6f87dc1be7b35a1b$var$__decorate([
    (0, $siQym.property)()
], $6f87dc1be7b35a1b$export$4dc5510728d31c71.prototype, "name", void 0);
$6f87dc1be7b35a1b$var$__decorate([
    (0, $siQym.property)({
        type: Object
    })
], $6f87dc1be7b35a1b$export$4dc5510728d31c71.prototype, "networkImagesBySize", void 0);
$6f87dc1be7b35a1b$var$__decorate([
    (0, $siQym.property)()
], $6f87dc1be7b35a1b$export$4dc5510728d31c71.prototype, "imageSrc", void 0);
$6f87dc1be7b35a1b$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $6f87dc1be7b35a1b$export$4dc5510728d31c71.prototype, "selected", void 0);
$6f87dc1be7b35a1b$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $6f87dc1be7b35a1b$export$4dc5510728d31c71.prototype, "round", void 0);
$6f87dc1be7b35a1b$export$4dc5510728d31c71 = $6f87dc1be7b35a1b$var$__decorate([
    (0, $hdxb6.customElement)("wui-network-image")
], $6f87dc1be7b35a1b$export$4dc5510728d31c71);

});
parcelRegister("gi2tT", function(module, exports) {

$parcel$export(module.exports, "networkSvgSm", function () { return $bdc040821b29f29f$export$a36e707df42c73a2; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $bdc040821b29f29f$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n  <svg fill="none" viewBox="0 0 36 40">\n    <path\n      d="M15.4 2.1a5.21 5.21 0 0 1 5.2 0l11.61 6.7a5.21 5.21 0 0 1 2.61 4.52v13.4c0 1.87-1 3.59-2.6 4.52l-11.61 6.7c-1.62.93-3.6.93-5.22 0l-11.6-6.7a5.21 5.21 0 0 1-2.61-4.51v-13.4c0-1.87 1-3.6 2.6-4.52L15.4 2.1Z"\n    />\n  </svg>\n'
    ]);
    $bdc040821b29f29f$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $bdc040821b29f29f$export$a36e707df42c73a2 = (0, $1lUIm.svg)($bdc040821b29f29f$var$_templateObject());

});

parcelRegister("iqkII", function(module, exports) {

$parcel$export(module.exports, "networkSvgLg", function () { return $d69aba4b037bcbd2$export$d2869a6a8000adfa; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
function $d69aba4b037bcbd2$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<svg width="86" height="96" fill="none">\n  <path\n    d="M78.3244 18.926L50.1808 2.45078C45.7376 -0.150261 40.2624 -0.150262 35.8192 2.45078L7.6756 18.926C3.23322 21.5266 0.5 26.3301 0.5 31.5248V64.4752C0.5 69.6699 3.23322 74.4734 7.6756 77.074L35.8192 93.5492C40.2624 96.1503 45.7376 96.1503 50.1808 93.5492L78.3244 77.074C82.7668 74.4734 85.5 69.6699 85.5 64.4752V31.5248C85.5 26.3301 82.7668 21.5266 78.3244 18.926Z"\n  />\n</svg>'
    ]);
    $d69aba4b037bcbd2$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $d69aba4b037bcbd2$export$d2869a6a8000adfa = (0, $1lUIm.svg)($d69aba4b037bcbd2$var$_templateObject());

});

parcelRegister("9jLxO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c8ac4baf8bcdf54$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $6c8ac4baf8bcdf54$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    position: relative;\n    border-radius: inherit;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: var(--local-width);\n    height: var(--local-height);\n  }\n\n  :host([data-round='true']) {\n    background: var(--wui-color-gray-glass-002);\n    border-radius: 100%;\n    outline: 1px solid var(--wui-color-gray-glass-005);\n  }\n\n  svg {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    fill: var(--wui-color-gray-glass-002);\n  }\n\n  svg > path {\n    stroke: var(--local-stroke);\n  }\n\n  wui-image {\n    width: 100%;\n    height: 100%;\n    -webkit-clip-path: var(--local-path);\n    clip-path: var(--local-path);\n    background: var(--wui-color-gray-glass-002);\n  }\n\n  wui-icon {\n    transform: translateY(-5%);\n    width: var(--local-icon-size);\n    height: var(--local-icon-size);\n  }\n"
    ]);
    $6c8ac4baf8bcdf54$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $6c8ac4baf8bcdf54$export$2e2bcd8739ae039 = (0, $bBWVO.css)($6c8ac4baf8bcdf54$var$_templateObject());

});


parcelRegister("3bdmn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $250cc32c3aaed91c$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $250cc32c3aaed91c$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  button {\n    flex-direction: column;\n    width: 76px;\n    row-gap: var(--wui-spacing-xs);\n    padding: var(--wui-spacing-xs) var(--wui-spacing-0);\n    background-color: var(--wui-color-gray-glass-002);\n    border-radius: clamp(0px, var(--wui-border-radius-xs), 20px);\n  }\n\n  button > wui-text {\n    color: var(--wui-color-fg-100);\n    max-width: var(--wui-icon-box-size-xl);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    justify-content: center;\n  }\n\n  button:disabled > wui-text {\n    color: var(--wui-color-gray-glass-015);\n  }\n\n  [data-selected='true'] {\n    background-color: var(--wui-color-accent-glass-020);\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    [data-selected='true']:hover:enabled {\n      background-color: var(--wui-color-accent-glass-015);\n    }\n  }\n\n  [data-selected='true']:active:enabled {\n    background-color: var(--wui-color-accent-glass-010);\n  }\n"
    ]);
    $250cc32c3aaed91c$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $250cc32c3aaed91c$export$2e2bcd8739ae039 = (0, $bBWVO.css)($250cc32c3aaed91c$var$_templateObject());

});


parcelRegister("612c2", function(module, exports) {

$parcel$export(module.exports, "WuiChip", function () { return $461489986226e26c$export$418286c4c7ff87c6; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("dcd5U");
parcelRequire("9ZbyK");
parcelRequire("1OYaf");

var $kYNxm = parcelRequire("kYNxm");

var $dI7zX = parcelRequire("dI7zX");

var $hdxb6 = parcelRequire("hdxb6");

var $f3lNO = parcelRequire("f3lNO");
function $461489986226e26c$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <a\n        rel="noreferrer"\n        target="_blank"\n        href=',
        "\n        class=",
        "\n        data-variant=",
        "\n      >\n        ",
        "\n        <wui-text variant=",
        ' color="inherit">\n          ',
        "\n        </wui-text>\n        <wui-icon name=",
        ' color="inherit" size="inherit"></wui-icon>\n      </a>\n    '
    ]);
    $461489986226e26c$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $461489986226e26c$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "<wui-image src=",
        "></wui-image>"
    ]);
    $461489986226e26c$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $461489986226e26c$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $461489986226e26c$export$418286c4c7ff87c6 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiChip, LitElement);
    var _super = (0, $ohfOJ._)(WuiChip);
    function WuiChip() {
        (0, $4GJKx._)(this, WuiChip);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.variant = "fill";
        _this.imageSrc = undefined;
        _this.disabled = false;
        _this.icon = "externalLink";
        _this.href = "";
        _this.text = undefined;
        return _this;
    }
    (0, $1wc17._)(WuiChip, [
        {
            key: "render",
            value: function render() {
                var isSmall = this.variant === "success" || this.variant === "transparent" || this.variant === "shadeSmall";
                var textVariant = isSmall ? "small-600" : "paragraph-600";
                return (0, $1lUIm.html)($461489986226e26c$var$_templateObject(), this.href, this.disabled ? "disabled" : "", this.variant, this.imageTemplate(), textVariant, this.title ? this.title : (0, $dI7zX.UiHelperUtil).getHostName(this.href), this.icon);
            }
        },
        {
            key: "imageTemplate",
            value: function imageTemplate() {
                if (this.imageSrc) return (0, $1lUIm.html)($461489986226e26c$var$_templateObject1(), this.imageSrc);
                return null;
            }
        }
    ]);
    return WuiChip;
}((0, $eAsDt.LitElement));
$461489986226e26c$export$418286c4c7ff87c6.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $f3lNO.default)
];
$461489986226e26c$var$__decorate([
    (0, $siQym.property)()
], $461489986226e26c$export$418286c4c7ff87c6.prototype, "variant", void 0);
$461489986226e26c$var$__decorate([
    (0, $siQym.property)()
], $461489986226e26c$export$418286c4c7ff87c6.prototype, "imageSrc", void 0);
$461489986226e26c$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $461489986226e26c$export$418286c4c7ff87c6.prototype, "disabled", void 0);
$461489986226e26c$var$__decorate([
    (0, $siQym.property)()
], $461489986226e26c$export$418286c4c7ff87c6.prototype, "icon", void 0);
$461489986226e26c$var$__decorate([
    (0, $siQym.property)()
], $461489986226e26c$export$418286c4c7ff87c6.prototype, "href", void 0);
$461489986226e26c$var$__decorate([
    (0, $siQym.property)()
], $461489986226e26c$export$418286c4c7ff87c6.prototype, "text", void 0);
$461489986226e26c$export$418286c4c7ff87c6 = $461489986226e26c$var$__decorate([
    (0, $hdxb6.customElement)("wui-chip")
], $461489986226e26c$export$418286c4c7ff87c6);

});
parcelRegister("f3lNO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af580c5a363a73f7$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $af580c5a363a73f7$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  a {\n    border: 1px solid var(--wui-color-gray-glass-010);\n    border-radius: var(--wui-border-radius-3xl);\n  }\n\n  wui-image {\n    border-radius: var(--wui-border-radius-3xl);\n    overflow: hidden;\n  }\n\n  a.disabled > wui-icon,\n  a.disabled > wui-image {\n    filter: grayscale(1);\n  }\n\n  a[data-variant='fill'] {\n    color: var(--wui-color-inverse-100);\n    background-color: var(--wui-color-accent-100);\n  }\n\n  a[data-variant='shade'],\n  a[data-variant='shadeSmall'] {\n    background-color: transparent;\n    background-color: var(--wui-color-gray-glass-010);\n    color: var(--wui-color-fg-200);\n  }\n\n  a[data-variant='success'] {\n    column-gap: var(--wui-spacing-xxs);\n    border: 1px solid var(--wui-color-success-glass-010);\n    background-color: var(--wui-color-success-glass-010);\n    color: var(--wui-color-success-100);\n  }\n\n  a[data-variant='error'] {\n    column-gap: var(--wui-spacing-xxs);\n    border: 1px solid var(--wui-color-error-glass-010);\n    background-color: var(--wui-color-error-glass-010);\n    color: var(--wui-color-error-100);\n  }\n\n  a[data-variant='transparent'] {\n    column-gap: var(--wui-spacing-xxs);\n    background-color: transparent;\n    color: var(--wui-color-fg-150);\n  }\n\n  a[data-variant='transparent'],\n  a[data-variant='success'],\n  a[data-variant='shadeSmall'],\n  a[data-variant='error'] {\n    padding: 7px var(--wui-spacing-s) 7px 10px;\n  }\n\n  a[data-variant='transparent']:has(wui-text:first-child),\n  a[data-variant='success']:has(wui-text:first-child),\n  a[data-variant='shadeSmall']:has(wui-text:first-child),\n  a[data-variant='error']:has(wui-text:first-child) {\n    padding: 7px var(--wui-spacing-s);\n  }\n\n  a[data-variant='fill'],\n  a[data-variant='shade'] {\n    column-gap: var(--wui-spacing-xs);\n    padding: var(--wui-spacing-xxs) var(--wui-spacing-m) var(--wui-spacing-xxs)\n      var(--wui-spacing-xs);\n  }\n\n  a[data-variant='fill']:has(wui-text:first-child),\n  a[data-variant='shade']:has(wui-text:first-child) {\n    padding: 9px var(--wui-spacing-m) 9px var(--wui-spacing-m);\n  }\n\n  a[data-variant='fill'] > wui-image,\n  a[data-variant='shade'] > wui-image {\n    width: 24px;\n    height: 24px;\n  }\n\n  a[data-variant='fill'] > wui-image {\n    box-shadow: inset 0 0 0 1px var(--wui-color-accent-090);\n  }\n\n  a[data-variant='shade'] > wui-image,\n  a[data-variant='shadeSmall'] > wui-image {\n    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-010);\n  }\n\n  a[data-variant='fill'] > wui-icon,\n  a[data-variant='shade'] > wui-icon {\n    width: 14px;\n    height: 14px;\n  }\n\n  a[data-variant='transparent'] > wui-image,\n  a[data-variant='success'] > wui-image,\n  a[data-variant='shadeSmall'] > wui-image,\n  a[data-variant='error'] > wui-image {\n    width: 14px;\n    height: 14px;\n  }\n\n  a[data-variant='transparent'] > wui-icon,\n  a[data-variant='success'] > wui-icon,\n  a[data-variant='shadeSmall'] > wui-icon,\n  a[data-variant='error'] > wui-icon {\n    width: 12px;\n    height: 12px;\n  }\n\n  a[data-variant='fill']:focus-visible {\n    background-color: var(--wui-color-accent-090);\n  }\n\n  a[data-variant='shade']:focus-visible,\n  a[data-variant='shadeSmall']:focus-visible {\n    background-color: var(--wui-color-gray-glass-015);\n  }\n\n  a[data-variant='transparent']:focus-visible {\n    background-color: var(--wui-color-gray-glass-005);\n  }\n\n  a[data-variant='success']:focus-visible {\n    background-color: var(--wui-color-success-glass-015);\n  }\n\n  a[data-variant='error']:focus-visible {\n    background-color: var(--wui-color-error-glass-015);\n  }\n\n  a.disabled {\n    color: var(--wui-color-gray-glass-015);\n    background-color: var(--wui-color-gray-glass-015);\n    pointer-events: none;\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    a[data-variant='fill']:hover {\n      background-color: var(--wui-color-accent-090);\n    }\n\n    a[data-variant='shade']:hover,\n    a[data-variant='shadeSmall']:hover {\n      background-color: var(--wui-color-gray-glass-015);\n    }\n\n    a[data-variant='transparent']:hover {\n      background-color: var(--wui-color-gray-glass-005);\n    }\n\n    a[data-variant='success']:hover {\n      background-color: var(--wui-color-success-glass-015);\n    }\n\n    a[data-variant='error']:hover {\n      background-color: var(--wui-color-error-glass-015);\n    }\n  }\n\n  a[data-variant='fill']:active {\n    background-color: var(--wui-color-accent-080);\n  }\n\n  a[data-variant='shade']:active,\n  a[data-variant='shadeSmall']:active {\n    background-color: var(--wui-color-gray-glass-020);\n  }\n\n  a[data-variant='transparent']:active {\n    background-color: var(--wui-color-gray-glass-010);\n  }\n\n  a[data-variant='success']:active {\n    background-color: var(--wui-color-success-glass-020);\n  }\n\n  a[data-variant='error']:active {\n    background-color: var(--wui-color-error-glass-020);\n  }\n"
    ]);
    $af580c5a363a73f7$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $af580c5a363a73f7$export$2e2bcd8739ae039 = (0, $bBWVO.css)($af580c5a363a73f7$var$_templateObject());

});


parcelRegister("5Y1eV", function(module, exports) {

$parcel$export(module.exports, "WuiConnectButton", function () { return $4583848b484a9238$export$7e12422df5cbb04c; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("dcd5U");
parcelRequire("ePIOw");
parcelRequire("1OYaf");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $70Yfl = parcelRequire("70Yfl");
function $4583848b484a9238$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      <button data-size=",
        " ?disabled=",
        " ontouchstart>\n        ",
        "\n        <wui-text variant=",
        " color=",
        ">\n          <slot></slot>\n        </wui-text>\n      </button>\n    "
    ]);
    $4583848b484a9238$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $4583848b484a9238$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "<wui-loading-spinner size=",
        ' color="accent-100"></wui-loading-spinner>'
    ]);
    $4583848b484a9238$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $4583848b484a9238$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $4583848b484a9238$export$7e12422df5cbb04c = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiConnectButton, LitElement);
    var _super = (0, $ohfOJ._)(WuiConnectButton);
    function WuiConnectButton() {
        (0, $4GJKx._)(this, WuiConnectButton);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.size = "md";
        _this.loading = false;
        return _this;
    }
    (0, $1wc17._)(WuiConnectButton, [
        {
            key: "render",
            value: function render() {
                var textVariant = this.size === "md" ? "paragraph-600" : "small-600";
                return (0, $1lUIm.html)($4583848b484a9238$var$_templateObject(), this.size, this.loading, this.loadingTemplate(), textVariant, this.loading ? "accent-100" : "inherit");
            }
        },
        {
            key: "loadingTemplate",
            value: function loadingTemplate() {
                if (!this.loading) return null;
                return (0, $1lUIm.html)($4583848b484a9238$var$_templateObject1(), this.size);
            }
        }
    ]);
    return WuiConnectButton;
}((0, $eAsDt.LitElement));
$4583848b484a9238$export$7e12422df5cbb04c.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $70Yfl.default)
];
$4583848b484a9238$var$__decorate([
    (0, $siQym.property)()
], $4583848b484a9238$export$7e12422df5cbb04c.prototype, "size", void 0);
$4583848b484a9238$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $4583848b484a9238$export$7e12422df5cbb04c.prototype, "loading", void 0);
$4583848b484a9238$export$7e12422df5cbb04c = $4583848b484a9238$var$__decorate([
    (0, $hdxb6.customElement)("wui-connect-button")
], $4583848b484a9238$export$7e12422df5cbb04c);

});
parcelRegister("70Yfl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51b7442f05e27af9$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $51b7442f05e27af9$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    position: relative;\n    display: block;\n  }\n\n  button {\n    background: var(--wui-color-accent-100);\n    border: 1px solid var(--wui-color-gray-glass-010);\n    border-radius: var(--wui-border-radius-m);\n    gap: var(--wui-spacing-xs);\n  }\n\n  button.loading {\n    background: var(--wui-color-gray-glass-010);\n    border: 1px solid var(--wui-color-gray-glass-010);\n    pointer-events: none;\n  }\n\n  button:disabled {\n    background-color: var(--wui-color-gray-glass-015);\n    border: 1px solid var(--wui-color-gray-glass-010);\n  }\n\n  button:disabled > wui-text {\n    color: var(--wui-color-gray-glass-015);\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    button:hover:enabled {\n      background-color: var(--wui-color-accent-090);\n    }\n\n    button:active:enabled {\n      background-color: var(--wui-color-accent-080);\n    }\n  }\n\n  button:focus-visible {\n    border: 1px solid var(--wui-color-gray-glass-010);\n    background-color: var(--wui-color-accent-090);\n    -webkit-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);\n    -moz-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);\n    box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);\n  }\n\n  button[data-size='sm'] {\n    padding: 6.75px 10px 7.25px;\n  }\n\n  ::slotted(*) {\n    transition: opacity var(--wui-ease-out-power-1) var(--wui-duration-md);\n    will-change: opacity;\n    opacity: var(--local-opacity-100);\n  }\n\n  button > wui-text {\n    transition: opacity var(--wui-ease-out-power-1) var(--wui-duration-md);\n    will-change: opacity;\n    opacity: var(--local-opacity-100);\n    color: var(--wui-color-inverse-100);\n  }\n\n  button[data-size='md'] {\n    padding: 9px var(--wui-spacing-l) 9px var(--wui-spacing-l);\n  }\n\n  button[data-size='md'] + wui-text {\n    padding-left: var(--wui-spacing-3xs);\n  }\n\n  @media (max-width: 500px) {\n    button[data-size='md'] {\n      height: 32px;\n      padding: 5px 12px;\n    }\n\n    button[data-size='md'] > wui-text > slot {\n      font-size: 14px !important;\n    }\n  }\n\n  wui-loading-spinner {\n    width: 14px;\n    height: 14px;\n  }\n\n  wui-loading-spinner::slotted(svg) {\n    width: 10px !important;\n    height: 10px !important;\n  }\n\n  button[data-size='sm'] > wui-loading-spinner {\n    width: 12px;\n    height: 12px;\n  }\n"
    ]);
    $51b7442f05e27af9$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $51b7442f05e27af9$export$2e2bcd8739ae039 = (0, $bBWVO.css)($51b7442f05e27af9$var$_templateObject());

});


parcelRegister("lvqV3", function(module, exports) {

$parcel$export(module.exports, "WuiCtaButton", function () { return $fa815fd9170250c5$export$4cb12aabb6d5d23c; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("dcd5U");
parcelRequire("1OYaf");
parcelRequire("1iTHu");
parcelRequire("8tnK2");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $dJM0k = parcelRequire("dJM0k");
function $fa815fd9170250c5$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex\n        justifyContent="space-between"\n        alignItems="center"\n        .padding=',
        '\n      >\n        <wui-text variant="paragraph-500" color="fg-200">',
        '</wui-text>\n        <wui-chip-button size="sm" variant="shade" text=',
        ' icon="chevronRight">\n        </wui-chip-button>\n      </wui-flex>\n    '
    ]);
    $fa815fd9170250c5$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $fa815fd9170250c5$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $fa815fd9170250c5$export$4cb12aabb6d5d23c = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiCtaButton, LitElement);
    var _super = (0, $ohfOJ._)(WuiCtaButton);
    function WuiCtaButton() {
        (0, $4GJKx._)(this, WuiCtaButton);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.disabled = false;
        _this.label = "";
        _this.buttonLabel = "";
        return _this;
    }
    (0, $1wc17._)(WuiCtaButton, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($fa815fd9170250c5$var$_templateObject(), [
                    "1xs",
                    "2l",
                    "1xs",
                    "2l"
                ], this.label, this.buttonLabel);
            }
        }
    ]);
    return WuiCtaButton;
}((0, $eAsDt.LitElement));
$fa815fd9170250c5$export$4cb12aabb6d5d23c.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $dJM0k.default)
];
$fa815fd9170250c5$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $fa815fd9170250c5$export$4cb12aabb6d5d23c.prototype, "disabled", void 0);
$fa815fd9170250c5$var$__decorate([
    (0, $siQym.property)()
], $fa815fd9170250c5$export$4cb12aabb6d5d23c.prototype, "label", void 0);
$fa815fd9170250c5$var$__decorate([
    (0, $siQym.property)()
], $fa815fd9170250c5$export$4cb12aabb6d5d23c.prototype, "buttonLabel", void 0);
$fa815fd9170250c5$export$4cb12aabb6d5d23c = $fa815fd9170250c5$var$__decorate([
    (0, $hdxb6.customElement)("wui-cta-button")
], $fa815fd9170250c5$export$4cb12aabb6d5d23c);

});
parcelRegister("dJM0k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a004b7021d889bac$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $a004b7021d889bac$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  wui-flex {\n    width: 100%;\n    background-color: var(--wui-color-gray-glass-002);\n    border-radius: var(--wui-border-radius-xs);\n  }\n"
    ]);
    $a004b7021d889bac$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $a004b7021d889bac$export$2e2bcd8739ae039 = (0, $bBWVO.css)($a004b7021d889bac$var$_templateObject());

});


parcelRegister("51qnz", function(module, exports) {

$parcel$export(module.exports, "WuiDetailsGroup", function () { return $3a81821f0db629ec$export$37645d4570816cfe; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("8tnK2");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $1uzWk = parcelRequire("1uzWk");
function $3a81821f0db629ec$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex gap="xl" flexDirection="column" justifyContent="space-between" alignItems="center">\n        <slot></slot>\n      </wui-flex>\n    '
    ]);
    $3a81821f0db629ec$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $3a81821f0db629ec$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $3a81821f0db629ec$export$37645d4570816cfe = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiDetailsGroup, LitElement);
    var _super = (0, $ohfOJ._)(WuiDetailsGroup);
    function WuiDetailsGroup() {
        (0, $4GJKx._)(this, WuiDetailsGroup);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(WuiDetailsGroup, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($3a81821f0db629ec$var$_templateObject());
            }
        }
    ]);
    return WuiDetailsGroup;
}((0, $eAsDt.LitElement));
$3a81821f0db629ec$export$37645d4570816cfe.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $1uzWk.default)
];
$3a81821f0db629ec$export$37645d4570816cfe = $3a81821f0db629ec$var$__decorate([
    (0, $hdxb6.customElement)("wui-details-group")
], $3a81821f0db629ec$export$37645d4570816cfe);

});
parcelRegister("1uzWk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $116478a87c0a85d6$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $116478a87c0a85d6$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: block;\n    padding: var(--wui-spacing-l) var(--wui-spacing-m);\n    background-color: var(--wui-color-gray-glass-002);\n    border-radius: var(--wui-border-radius-xs);\n    width: 100%;\n  }\n"
    ]);
    $116478a87c0a85d6$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $116478a87c0a85d6$export$2e2bcd8739ae039 = (0, $bBWVO.css)($116478a87c0a85d6$var$_templateObject());

});


parcelRegister("xt0OB", function(module, exports) {

$parcel$export(module.exports, "WuiDetailsGroupItem", function () { return $06499663f457d94d$export$d005980beb1c2a86; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("8tnK2");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $73a7c = parcelRequire("73a7c");
function $06499663f457d94d$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex justifyContent="space-between" alignItems="center">\n        <wui-text variant="paragraph-500" color="fg-200">',
        '</wui-text>\n        <wui-flex gap="xs" alignItems="center">\n          <slot></slot>\n        </wui-flex>\n      </wui-flex>\n    '
    ]);
    $06499663f457d94d$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $06499663f457d94d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $06499663f457d94d$export$d005980beb1c2a86 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiDetailsGroupItem, LitElement);
    var _super = (0, $ohfOJ._)(WuiDetailsGroupItem);
    function WuiDetailsGroupItem() {
        (0, $4GJKx._)(this, WuiDetailsGroupItem);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "";
        return _this;
    }
    (0, $1wc17._)(WuiDetailsGroupItem, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($06499663f457d94d$var$_templateObject(), this.name);
            }
        }
    ]);
    return WuiDetailsGroupItem;
}((0, $eAsDt.LitElement));
$06499663f457d94d$export$d005980beb1c2a86.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $73a7c.default)
];
$06499663f457d94d$var$__decorate([
    (0, $siQym.property)()
], $06499663f457d94d$export$d005980beb1c2a86.prototype, "name", void 0);
$06499663f457d94d$export$d005980beb1c2a86 = $06499663f457d94d$var$__decorate([
    (0, $hdxb6.customElement)("wui-details-group-item")
], $06499663f457d94d$export$d005980beb1c2a86);

});
parcelRegister("73a7c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5220a8d97018609d$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $5220a8d97018609d$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: flex;\n    flex-direction: row;\n    gap: var(--wui-spacing-l);\n    width: 100%;\n    border-radius: var(--wui-border-radius-xs);\n  }\n"
    ]);
    $5220a8d97018609d$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $5220a8d97018609d$export$2e2bcd8739ae039 = (0, $bBWVO.css)($5220a8d97018609d$var$_templateObject());

});


parcelRegister("kYRlu", function(module, exports) {

$parcel$export(module.exports, "WuiDropdownMenu", function () { return $f462ca96c64db8ac$export$868b19dbe6f5fb81; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("dcd5U");
parcelRequire("9ZbyK");
parcelRequire("ePIOw");
parcelRequire("1OYaf");
parcelRequire("8tnK2");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("8jknp");

var $7hSID = parcelRequire("7hSID");
function $f462ca96c64db8ac$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n            <wui-list-item\n              icon=",
        '\n              iconSize="sm"\n              variant="icon"\n              @click=',
        '\n            >\n              <wui-text variant="small-400" color="fg-100">',
        "</wui-text>\n            </wui-list-item>\n          "
    ]);
    $f462ca96c64db8ac$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $f462ca96c64db8ac$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column" gap="4xs">\n        ',
        "\n      </wui-flex>\n    "
    ]);
    $f462ca96c64db8ac$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $f462ca96c64db8ac$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f462ca96c64db8ac$export$868b19dbe6f5fb81 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiDropdownMenu, LitElement);
    var _super = (0, $ohfOJ._)(WuiDropdownMenu);
    function WuiDropdownMenu() {
        (0, $4GJKx._)(this, WuiDropdownMenu);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.actions = [];
        _this.isOpen = false;
        return _this;
    }
    (0, $1wc17._)(WuiDropdownMenu, [
        {
            key: "render",
            value: function render() {
                if (!this.isOpen) return null;
                return (0, $1lUIm.html)($f462ca96c64db8ac$var$_templateObject1(), this.actions.map(function(action) {
                    return (0, $1lUIm.html)($f462ca96c64db8ac$var$_templateObject(), action.icon, action.onClick, action.label);
                }));
            }
        }
    ]);
    return WuiDropdownMenu;
}((0, $eAsDt.LitElement));
$f462ca96c64db8ac$export$868b19dbe6f5fb81.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $7hSID.default)
];
$f462ca96c64db8ac$var$__decorate([
    (0, $siQym.property)({
        type: Array
    })
], $f462ca96c64db8ac$export$868b19dbe6f5fb81.prototype, "actions", void 0);
$f462ca96c64db8ac$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $f462ca96c64db8ac$export$868b19dbe6f5fb81.prototype, "isOpen", void 0);
$f462ca96c64db8ac$export$868b19dbe6f5fb81 = $f462ca96c64db8ac$var$__decorate([
    (0, $hdxb6.customElement)("wui-dropdown-menu")
], $f462ca96c64db8ac$export$868b19dbe6f5fb81);

});
parcelRegister("7hSID", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54e490fa5a67cc65$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $54e490fa5a67cc65$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    z-index: calc(var(--w3m-z-index) + 1);\n    width: 200px;\n    padding: var(--wui-spacing-3xs);\n    align-items: center;\n    display: inherit;\n    border-radius: var(--wui-border-radius-xs);\n    border: 1px solid var(--wui-color-gray-glass-002);\n    background: var(--wui-color-fg-base-125);\n    /* Dark/Elevation/L */\n    box-shadow:\n      0px 8px 22px -6px rgba(0, 0, 0, 0.12),\n      0px 14px 64px -4px rgba(0, 0, 0, 0.12);\n  }\n"
    ]);
    $54e490fa5a67cc65$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $54e490fa5a67cc65$export$2e2bcd8739ae039 = (0, $bBWVO.css)($54e490fa5a67cc65$var$_templateObject());

});


parcelRegister("7yH9d", function(module, exports) {

$parcel$export(module.exports, "WuiEmailInput", function () { return $580d2d9f42a9c5b8$export$99face4607bb46ea; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("dcd5U");
parcelRequire("1OYaf");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("aYc6n");

var $1Naat = parcelRequire("1Naat");
function $580d2d9f42a9c5b8$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-input-text\n        placeholder="Email"\n        icon="mail"\n        size="mdl"\n        .disabled=',
        "\n        .value=",
        '\n        data-testid="wui-email-input"\n      ></wui-input-text>\n      ',
        "\n    "
    ]);
    $580d2d9f42a9c5b8$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $580d2d9f42a9c5b8$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '<wui-text variant="tiny-500" color="error-100">',
        "</wui-text>"
    ]);
    $580d2d9f42a9c5b8$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $580d2d9f42a9c5b8$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $580d2d9f42a9c5b8$export$99face4607bb46ea = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiEmailInput, LitElement);
    var _super = (0, $ohfOJ._)(WuiEmailInput);
    function WuiEmailInput() {
        (0, $4GJKx._)(this, WuiEmailInput);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.disabled = false;
        return _this;
    }
    (0, $1wc17._)(WuiEmailInput, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($580d2d9f42a9c5b8$var$_templateObject(), this.disabled, this.value, this.templateError());
            }
        },
        {
            key: "templateError",
            value: function templateError() {
                if (this.errorMessage) return (0, $1lUIm.html)($580d2d9f42a9c5b8$var$_templateObject1(), this.errorMessage);
                return null;
            }
        }
    ]);
    return WuiEmailInput;
}((0, $eAsDt.LitElement));
$580d2d9f42a9c5b8$export$99face4607bb46ea.styles = [
    (0, $kYNxm.resetStyles),
    (0, $1Naat.default)
];
$580d2d9f42a9c5b8$var$__decorate([
    (0, $siQym.property)()
], $580d2d9f42a9c5b8$export$99face4607bb46ea.prototype, "errorMessage", void 0);
$580d2d9f42a9c5b8$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $580d2d9f42a9c5b8$export$99face4607bb46ea.prototype, "disabled", void 0);
$580d2d9f42a9c5b8$var$__decorate([
    (0, $siQym.property)()
], $580d2d9f42a9c5b8$export$99face4607bb46ea.prototype, "value", void 0);
$580d2d9f42a9c5b8$export$99face4607bb46ea = $580d2d9f42a9c5b8$var$__decorate([
    (0, $hdxb6.customElement)("wui-email-input")
], $580d2d9f42a9c5b8$export$99face4607bb46ea);

});
parcelRegister("aYc6n", function(module, exports) {

$parcel$export(module.exports, "WuiInputText", function () { return $7fc8e529b55e2197$export$487c694bc02cf7da; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $3sHb8 = parcelRequire("3sHb8");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("3mWyR");
var $2vNUF = parcelRequire("2vNUF");
parcelRequire("8jzG0");
var $fR1Rt = parcelRequire("fR1Rt");
parcelRequire("248Kv");
var $a1EIv = parcelRequire("a1EIv");
parcelRequire("dcd5U");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $joAwB = parcelRequire("joAwB");
function $7fc8e529b55e2197$var$_templateObject() {
    var data = (0, $j06k0._)([
        "",
        '\n      <input\n        data-testid="wui-input-text"\n        ',
        "\n        class=",
        "\n        type=",
        "\n        enterkeyhint=",
        "\n        ?disabled=",
        "\n        placeholder=",
        "\n        @input=",
        "\n        .value=",
        "\n      />\n      <slot></slot>"
    ]);
    $7fc8e529b55e2197$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $7fc8e529b55e2197$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "<wui-icon\n        data-input=",
        "\n        size=",
        '\n        color="inherit"\n        name=',
        "\n      ></wui-icon>"
    ]);
    $7fc8e529b55e2197$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $7fc8e529b55e2197$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $7fc8e529b55e2197$export$487c694bc02cf7da = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiInputText, LitElement);
    var _super = (0, $ohfOJ._)(WuiInputText);
    function WuiInputText() {
        (0, $4GJKx._)(this, WuiInputText);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.inputElementRef = (0, $fR1Rt.createRef)();
        _this.size = "md";
        _this.disabled = false;
        _this.placeholder = "";
        _this.type = "text";
        _this.value = "";
        return _this;
    }
    (0, $1wc17._)(WuiInputText, [
        {
            key: "render",
            value: function render() {
                var inputClass = "wui-padding-right-".concat(this.inputRightPadding);
                var sizeClass = "wui-size-".concat(this.size);
                var _obj;
                var classes = (_obj = {}, (0, $3sHb8._)(_obj, sizeClass, true), (0, $3sHb8._)(_obj, inputClass, Boolean(this.inputRightPadding)), _obj);
                return (0, $1lUIm.html)($7fc8e529b55e2197$var$_templateObject(), this.templateIcon(), (0, $fR1Rt.ref)(this.inputElementRef), (0, $a1EIv.classMap)(classes), this.type, (0, $2vNUF.ifDefined)(this.enterKeyHint), this.disabled, this.placeholder, this.dispatchInputChangeEvent.bind(this), this.value || "");
            }
        },
        {
            key: "templateIcon",
            value: function templateIcon() {
                if (this.icon) return (0, $1lUIm.html)($7fc8e529b55e2197$var$_templateObject1(), this.size, this.size, this.icon);
                return null;
            }
        },
        {
            key: "dispatchInputChangeEvent",
            value: function dispatchInputChangeEvent() {
                var _this_inputElementRef_value;
                this.dispatchEvent(new CustomEvent("inputChange", {
                    detail: (_this_inputElementRef_value = this.inputElementRef.value) === null || _this_inputElementRef_value === void 0 ? void 0 : _this_inputElementRef_value.value,
                    bubbles: true,
                    composed: true
                }));
            }
        }
    ]);
    return WuiInputText;
}((0, $eAsDt.LitElement));
$7fc8e529b55e2197$export$487c694bc02cf7da.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $joAwB.default)
];
$7fc8e529b55e2197$var$__decorate([
    (0, $siQym.property)()
], $7fc8e529b55e2197$export$487c694bc02cf7da.prototype, "size", void 0);
$7fc8e529b55e2197$var$__decorate([
    (0, $siQym.property)()
], $7fc8e529b55e2197$export$487c694bc02cf7da.prototype, "icon", void 0);
$7fc8e529b55e2197$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $7fc8e529b55e2197$export$487c694bc02cf7da.prototype, "disabled", void 0);
$7fc8e529b55e2197$var$__decorate([
    (0, $siQym.property)()
], $7fc8e529b55e2197$export$487c694bc02cf7da.prototype, "placeholder", void 0);
$7fc8e529b55e2197$var$__decorate([
    (0, $siQym.property)()
], $7fc8e529b55e2197$export$487c694bc02cf7da.prototype, "type", void 0);
$7fc8e529b55e2197$var$__decorate([
    (0, $siQym.property)()
], $7fc8e529b55e2197$export$487c694bc02cf7da.prototype, "keyHint", void 0);
$7fc8e529b55e2197$var$__decorate([
    (0, $siQym.property)()
], $7fc8e529b55e2197$export$487c694bc02cf7da.prototype, "value", void 0);
$7fc8e529b55e2197$var$__decorate([
    (0, $siQym.property)()
], $7fc8e529b55e2197$export$487c694bc02cf7da.prototype, "inputRightPadding", void 0);
$7fc8e529b55e2197$export$487c694bc02cf7da = $7fc8e529b55e2197$var$__decorate([
    (0, $hdxb6.customElement)("wui-input-text")
], $7fc8e529b55e2197$export$487c694bc02cf7da);

});
parcelRegister("8jzG0", function(module, exports) {
$parcel$export(module.exports, "createRef", function () { return (parcelRequire("fR1Rt")).createRef; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("fR1Rt")).ref; });
parcelRequire("fR1Rt");

});
parcelRegister("fR1Rt", function(module, exports) {

$parcel$export(module.exports, "createRef", function () { return $b8ad3feb113edf63$export$7d1e3a5e95ceca43; });
$parcel$export(module.exports, "ref", function () { return $b8ad3feb113edf63$export$eff4d24c3ff7876e; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $cv9Rk = parcelRequire("cv9Rk");

var $ohfOJ = parcelRequire("ohfOJ");

var $1lUIm = parcelRequire("1lUIm");

var $7cObZ = parcelRequire("7cObZ");

var $1iYSS = parcelRequire("1iYSS");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $b8ad3feb113edf63$export$7d1e3a5e95ceca43 = function() {
    return new $b8ad3feb113edf63$var$Zt;
};
var $b8ad3feb113edf63$var$Zt = function Zt() {
    "use strict";
    (0, $4GJKx._)(this, Zt);
};
var $b8ad3feb113edf63$var$qt = new WeakMap, $b8ad3feb113edf63$export$eff4d24c3ff7876e = (0, $1iYSS.directive)(/*#__PURE__*/ function($t) {
    "use strict";
    (0, $dcsZi._)(_class, $t);
    var _super = (0, $ohfOJ._)(_class);
    function _class() {
        (0, $4GJKx._)(this, _class);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(_class, [
        {
            key: "render",
            value: function render(t) {
                return 0, $1lUIm.nothing;
            }
        },
        {
            key: "update",
            value: function update(t, param) {
                var _param = (0, $cv9Rk._)(param, 1), i = _param[0];
                var _t_options;
                var s = i !== this.Y;
                return s && void 0 !== this.Y && this.rt(void 0), (s || this.lt !== this.ct) && (this.Y = i, this.ht = (_t_options = t.options) === null || _t_options === void 0 ? void 0 : _t_options.host, this.rt(this.ct = t.element)), $1lUIm.nothing;
            }
        },
        {
            key: "rt",
            value: function rt(t) {
                if (this.isConnected || (t = void 0), "function" == typeof this.Y) {
                    var _this_ht;
                    var i = (_this_ht = this.ht) !== null && _this_ht !== void 0 ? _this_ht : globalThis;
                    var s = $b8ad3feb113edf63$var$qt.get(i);
                    void 0 === s && (s = new WeakMap, $b8ad3feb113edf63$var$qt.set(i, s)), void 0 !== s.get(this.Y) && this.Y.call(this.ht, void 0), s.set(this.Y, t), void 0 !== t && this.Y.call(this.ht, t);
                } else this.Y.value = t;
            }
        },
        {
            key: "lt",
            get: function get() {
                var _qt_get, _this_Y;
                var _this_ht;
                return "function" == typeof this.Y ? (_qt_get = $b8ad3feb113edf63$var$qt.get((_this_ht = this.ht) !== null && _this_ht !== void 0 ? _this_ht : globalThis)) === null || _qt_get === void 0 ? void 0 : _qt_get.get(this.Y) : (_this_Y = this.Y) === null || _this_Y === void 0 ? void 0 : _this_Y.value;
            }
        },
        {
            key: "disconnected",
            value: function disconnected() {
                this.lt === this.ct && this.rt(void 0);
            }
        },
        {
            key: "reconnected",
            value: function reconnected() {
                this.rt(this.ct);
            }
        }
    ]);
    return _class;
}((0, $7cObZ.AsyncDirective)));

});
parcelRegister("7cObZ", function(module, exports) {

$parcel$export(module.exports, "AsyncDirective", function () { return $53f09693005867af$export$7d025501802325e; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $04RAu = parcelRequire("04RAu");

var $b8Rim = parcelRequire("b8Rim");

var $dcsZi = parcelRequire("dcsZi");

var $3U0IP = parcelRequire("3U0IP");

var $c6Xmf = parcelRequire("c6Xmf");

var $ohfOJ = parcelRequire("ohfOJ");

var $bgdZC = parcelRequire("bgdZC");

var $1iYSS = parcelRequire("1iYSS");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $53f09693005867af$var$mt = function(i, t) {
    var _i__$AO;
    var e = i._$AN;
    if (void 0 === e) return !1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _$i = _step.value;
            (_i__$AO = _$i._$AO) === null || _i__$AO === void 0 ? void 0 : _i__$AO.call(_$i, t, !1), $53f09693005867af$var$mt(_$i, t);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return !0;
}, $53f09693005867af$var$_t = function(i) {
    var t, e;
    do {
        if (void 0 === (t = i._$AM)) break;
        e = t._$AN, e.delete(i), i = t;
    }while (0 === (e === null || e === void 0 ? void 0 : e.size));
}, $53f09693005867af$var$wt = function(i) {
    for(var t; t = i._$AM; i = t){
        var e = t._$AN;
        if (void 0 === e) t._$AN = e = new Set;
        else if (e.has(i)) break;
        e.add(i), $53f09693005867af$var$gt(t);
    }
};
function $53f09693005867af$var$bt(i) {
    void 0 !== this._$AN ? ($53f09693005867af$var$_t(this), this._$AM = i, $53f09693005867af$var$wt(this)) : this._$AM = i;
}
function $53f09693005867af$var$yt(i) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var s = this._$AH, o = this._$AN;
    if (void 0 !== o && 0 !== o.size) {
        if (t) {
            if (Array.isArray(s)) for(var _$i = e; _$i < s.length; _$i++)$53f09693005867af$var$mt(s[_$i], !1), $53f09693005867af$var$_t(s[_$i]);
            else null != s && ($53f09693005867af$var$mt(s, !1), $53f09693005867af$var$_t(s));
        } else $53f09693005867af$var$mt(this, i);
    }
}
var $53f09693005867af$var$gt = function(i) {
    var _i, _i1;
    var __$AP, __$AQ;
    i.type == (0, $1iYSS.PartType).CHILD && ((__$AP = (_i = i)._$AP) !== null && __$AP !== void 0 ? __$AP : _i._$AP = $53f09693005867af$var$yt, (__$AQ = (_i1 = i)._$AQ) !== null && __$AQ !== void 0 ? __$AQ : _i1._$AQ = $53f09693005867af$var$bt);
};
var $53f09693005867af$export$7d025501802325e = /*#__PURE__*/ function(i) {
    "use strict";
    (0, $dcsZi._)($t, i);
    var _super = (0, $ohfOJ._)($t);
    function $t() {
        (0, $4GJKx._)(this, $t);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments))), _this._$AN = void 0;
        return (0, $3U0IP._)(_this);
    }
    (0, $1wc17._)($t, [
        {
            key: "_$AT",
            value: function _$AT(i, t, e) {
                (0, $04RAu._)((0, $b8Rim._)($t.prototype), "_$AT", this).call(this, i, t, e), $53f09693005867af$var$wt(this), this.isConnected = i._$AU;
            }
        },
        {
            key: "_$AO",
            value: function _$AO(i) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
                var _this_reconnected, _this, _this_disconnected, _this1;
                i !== this.isConnected && (this.isConnected = i, i ? (_this_reconnected = (_this = this).reconnected) === null || _this_reconnected === void 0 ? void 0 : _this_reconnected.call(_this) : (_this_disconnected = (_this1 = this).disconnected) === null || _this_disconnected === void 0 ? void 0 : _this_disconnected.call(_this1)), t && ($53f09693005867af$var$mt(this, i), $53f09693005867af$var$_t(this));
            }
        },
        {
            key: "setValue",
            value: function setValue(i) {
                if ((0, $bgdZC.isSingleExpression)(this.t)) this.t._$AI(i, this);
                else {
                    var t = (0, $c6Xmf._)(this.t._$AH);
                    t[this.i] = i, this.t._$AI(t, this, 0);
                }
            }
        },
        {
            key: "disconnected",
            value: function disconnected() {}
        },
        {
            key: "reconnected",
            value: function reconnected() {}
        }
    ]);
    return $t;
}((0, $1iYSS.Directive));

});
parcelRegister("bgdZC", function(module, exports) {

$parcel$export(module.exports, "isSingleExpression", function () { return $832c0b00ccf20efc$export$7f431ad0fff82fd9; });

var $1lUIm = parcelRequire("1lUIm");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $832c0b00ccf20efc$var$et = (0, $1lUIm._$LH).I, $832c0b00ccf20efc$export$c3825b437cbdea5c = function(o) {
    return null === o || "object" != typeof o && "function" != typeof o;
}, $832c0b00ccf20efc$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2,
    MATHML: 3
}, $832c0b00ccf20efc$export$6b6d145ec2a44ca9 = function(o, t) {
    return void 0 === t ? void 0 !== (o === null || o === void 0 ? void 0 : o._$litType$) : (o === null || o === void 0 ? void 0 : o._$litType$) === t;
}, $832c0b00ccf20efc$export$6a0e8de894d2fcca = function(o) {
    var _o__$litType$;
    return null != (o === null || o === void 0 ? void 0 : (_o__$litType$ = o._$litType$) === null || _o__$litType$ === void 0 ? void 0 : _o__$litType$.h);
}, $832c0b00ccf20efc$export$2f448fec17d50a3e = function(o) {
    return void 0 !== (o === null || o === void 0 ? void 0 : o._$litDirective$);
}, $832c0b00ccf20efc$export$f28e31de6a6eaf32 = function(o) {
    return o === null || o === void 0 ? void 0 : o._$litDirective$;
}, $832c0b00ccf20efc$export$7f431ad0fff82fd9 = function(o) {
    return void 0 === o.strings;
}, $832c0b00ccf20efc$var$lt = function() {
    return document.createComment("");
}, $832c0b00ccf20efc$export$291b2338ad9b0b30 = function(o, t, i) {
    var n = o._$AA.parentNode, e = void 0 === t ? o._$AB : t._$AA;
    if (void 0 === i) {
        var _$t = n.insertBefore($832c0b00ccf20efc$var$lt(), e), l = n.insertBefore($832c0b00ccf20efc$var$lt(), e);
        i = new $832c0b00ccf20efc$var$et(_$t, l, o, o.options);
    } else {
        var _$t1 = i._$AB.nextSibling, l1 = i._$AM, c = l1 !== o;
        if (c) {
            var _i__$AQ;
            var _$t2;
            (_i__$AQ = i._$AQ) === null || _i__$AQ === void 0 ? void 0 : _i__$AQ.call(i, o), i._$AM = o, void 0 !== i._$AP && (_$t2 = o._$AU) !== l1._$AU && i._$AP(_$t2);
        }
        if (_$t1 !== e || c) {
            var _$o = i._$AA;
            for(; _$o !== _$t1;){
                var _$t3 = _$o.nextSibling;
                n.insertBefore(_$o, e), _$o = _$t3;
            }
        }
    }
    return i;
}, $832c0b00ccf20efc$export$cb8bf9562088e9f4 = function(o, t) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : o;
    return o._$AI(t, i), o;
}, $832c0b00ccf20efc$var$ht = {}, $832c0b00ccf20efc$export$ea70d9dd5965b1c8 = function(o) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $832c0b00ccf20efc$var$ht;
    return o._$AH = t;
}, $832c0b00ccf20efc$export$59e9bce518cde500 = function(o) {
    return o._$AH;
}, $832c0b00ccf20efc$export$3133b3144bbba267 = function(o) {
    var _o__$AP;
    (_o__$AP = o._$AP) === null || _o__$AP === void 0 ? void 0 : _o__$AP.call(o, !1, !0);
    var t = o._$AA;
    var i = o._$AB.nextSibling;
    for(; t !== i;){
        var _$o = t.nextSibling;
        t.remove(), t = _$o;
    }
}, $832c0b00ccf20efc$export$7f600b8138c094dc = function(o) {
    o._$AR();
};

});




parcelRegister("joAwB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1ec974ef1755b4d$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $e1ec974ef1755b4d$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    position: relative;\n    width: 100%;\n    display: inline-block;\n    color: var(--wui-color-fg-275);\n  }\n\n  input {\n    width: 100%;\n    border-radius: var(--wui-border-radius-xs);\n    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-002);\n    background: var(--wui-color-gray-glass-002);\n    font-size: var(--wui-font-size-paragraph);\n    letter-spacing: var(--wui-letter-spacing-paragraph);\n    color: var(--wui-color-fg-100);\n    transition:\n      background-color var(--wui-ease-inout-power-1) var(--wui-duration-md),\n      border-color var(--wui-ease-inout-power-1) var(--wui-duration-md),\n      box-shadow var(--wui-ease-inout-power-1) var(--wui-duration-md);\n    will-change: background-color, border-color, box-shadow;\n    caret-color: var(--wui-color-accent-100);\n  }\n\n  input:disabled {\n    cursor: not-allowed;\n    border: 1px solid var(--wui-color-gray-glass-010);\n  }\n\n  input:disabled::placeholder,\n  input:disabled + wui-icon {\n    color: var(--wui-color-fg-300);\n  }\n\n  input::placeholder {\n    color: var(--wui-color-fg-275);\n  }\n\n  input:focus:enabled {\n    background-color: var(--wui-color-gray-glass-005);\n    -webkit-box-shadow:\n      inset 0 0 0 1px var(--wui-color-accent-100),\n      0px 0px 0px 4px var(--wui-box-shadow-blue);\n    -moz-box-shadow:\n      inset 0 0 0 1px var(--wui-color-accent-100),\n      0px 0px 0px 4px var(--wui-box-shadow-blue);\n    box-shadow:\n      inset 0 0 0 1px var(--wui-color-accent-100),\n      0px 0px 0px 4px var(--wui-box-shadow-blue);\n  }\n\n  input:hover:enabled {\n    background-color: var(--wui-color-gray-glass-005);\n  }\n\n  wui-icon {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    pointer-events: none;\n  }\n\n  .wui-size-sm {\n    padding: 9px var(--wui-spacing-m) 10px var(--wui-spacing-s);\n  }\n\n  wui-icon + .wui-size-sm {\n    padding: 9px var(--wui-spacing-m) 10px 36px;\n  }\n\n  wui-icon[data-input='sm'] {\n    left: var(--wui-spacing-s);\n  }\n\n  .wui-size-md {\n    padding: 15px var(--wui-spacing-m) var(--wui-spacing-l) var(--wui-spacing-m);\n  }\n\n  wui-icon + .wui-size-md,\n  wui-loading-spinner + .wui-size-md {\n    padding: 10.5px var(--wui-spacing-3xl) 10.5px var(--wui-spacing-3xl);\n  }\n\n  wui-icon[data-input='md'] {\n    left: var(--wui-spacing-l);\n  }\n\n  .wui-size-lg {\n    padding: var(--wui-spacing-s) var(--wui-spacing-s) var(--wui-spacing-s) var(--wui-spacing-l);\n    letter-spacing: var(--wui-letter-spacing-medium-title);\n    font-size: var(--wui-font-size-medium-title);\n    font-weight: var(--wui-font-weight-light);\n    line-height: 130%;\n    color: var(--wui-color-fg-100);\n    height: 64px;\n  }\n\n  .wui-padding-right-xs {\n    padding-right: var(--wui-spacing-xs);\n  }\n\n  .wui-padding-right-s {\n    padding-right: var(--wui-spacing-s);\n  }\n\n  .wui-padding-right-m {\n    padding-right: var(--wui-spacing-m);\n  }\n\n  .wui-padding-right-l {\n    padding-right: var(--wui-spacing-l);\n  }\n\n  .wui-padding-right-xl {\n    padding-right: var(--wui-spacing-xl);\n  }\n\n  .wui-padding-right-2xl {\n    padding-right: var(--wui-spacing-2xl);\n  }\n\n  .wui-padding-right-3xl {\n    padding-right: var(--wui-spacing-3xl);\n  }\n\n  .wui-padding-right-4xl {\n    padding-right: var(--wui-spacing-4xl);\n  }\n\n  .wui-padding-right-5xl {\n    padding-right: var(--wui-spacing-5xl);\n  }\n\n  wui-icon + .wui-size-lg,\n  wui-loading-spinner + .wui-size-lg {\n    padding-left: 50px;\n  }\n\n  wui-icon[data-input='lg'] {\n    left: var(--wui-spacing-l);\n  }\n\n  .wui-size-mdl {\n    padding: 17.25px var(--wui-spacing-m) 17.25px var(--wui-spacing-m);\n  }\n  wui-icon + .wui-size-mdl,\n  wui-loading-spinner + .wui-size-mdl {\n    padding: 17.25px var(--wui-spacing-3xl) 17.25px 40px;\n  }\n  wui-icon[data-input='mdl'] {\n    left: var(--wui-spacing-m);\n  }\n\n  input:placeholder-shown ~ ::slotted(wui-input-element),\n  input:placeholder-shown ~ ::slotted(wui-icon) {\n    opacity: 0;\n    pointer-events: none;\n  }\n\n  input::-webkit-outer-spin-button,\n  input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  input[type='number'] {\n    -moz-appearance: textfield;\n  }\n\n  ::slotted(wui-input-element),\n  ::slotted(wui-icon) {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  ::slotted(wui-input-element) {\n    right: var(--wui-spacing-m);\n  }\n\n  ::slotted(wui-icon) {\n    right: 0px;\n  }\n"
    ]);
    $e1ec974ef1755b4d$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $e1ec974ef1755b4d$export$2e2bcd8739ae039 = (0, $bBWVO.css)($e1ec974ef1755b4d$var$_templateObject());

});


parcelRegister("1Naat", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14e2412f7e9dfcd1$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $14e2412f7e9dfcd1$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    position: relative;\n    display: inline-block;\n  }\n\n  wui-text {\n    margin: var(--wui-spacing-xxs) var(--wui-spacing-m) var(--wui-spacing-0) var(--wui-spacing-m);\n  }\n"
    ]);
    $14e2412f7e9dfcd1$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $14e2412f7e9dfcd1$export$2e2bcd8739ae039 = (0, $bBWVO.css)($14e2412f7e9dfcd1$var$_templateObject());

});


parcelRegister("7RVCl", function(module, exports) {

$parcel$export(module.exports, "WuiEnsInput", function () { return $5baa2d42fd690322$export$2dc775ce7bfee34f; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("dcd5U");
parcelRequire("1OYaf");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("aYc6n");

var $d0tkO = parcelRequire("d0tkO");
parcelRequire("3mWyR");
var $2vNUF = parcelRequire("2vNUF");
parcelRequire("dSKxG");
var $3QZC1 = parcelRequire("3QZC1");
function $5baa2d42fd690322$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      <wui-input-text\n        value=",
        "\n        ?disabled=",
        "\n        .value=",
        '\n        data-testid="wui-ens-input"\n        inputRightPadding="5xl"\n      >\n        ',
        " ",
        "",
        "\n      </wui-input-text>\n    "
    ]);
    $5baa2d42fd690322$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $5baa2d42fd690322$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '<wui-text variant="paragraph-400" color="fg-200" class="base-name">\n      ',
        "\n    </wui-text>"
    ]);
    $5baa2d42fd690322$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $5baa2d42fd690322$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '<wui-loading-spinner size="md" color="accent-100"></wui-loading-spinner>'
    ]);
    $5baa2d42fd690322$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $5baa2d42fd690322$var$_templateObject3() {
    var data = (0, $j06k0._)([
        '<wui-text variant="tiny-500" color="error-100" class="error"\n        >',
        "</wui-text\n      >"
    ]);
    $5baa2d42fd690322$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var $5baa2d42fd690322$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $5baa2d42fd690322$export$2dc775ce7bfee34f = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiEnsInput, LitElement);
    var _super = (0, $ohfOJ._)(WuiEnsInput);
    function WuiEnsInput() {
        (0, $4GJKx._)(this, WuiEnsInput);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.disabled = false;
        _this.loading = false;
        return _this;
    }
    (0, $1wc17._)(WuiEnsInput, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($5baa2d42fd690322$var$_templateObject(), (0, $2vNUF.ifDefined)(this.value), this.disabled, this.value || "", this.baseNameTemplate(), this.errorTemplate(), this.loadingTemplate());
            }
        },
        {
            key: "baseNameTemplate",
            value: function baseNameTemplate() {
                return (0, $1lUIm.html)($5baa2d42fd690322$var$_templateObject1(), (0, $3QZC1.ConstantsUtil).WC_NAME_SUFFIX);
            }
        },
        {
            key: "loadingTemplate",
            value: function loadingTemplate() {
                return this.loading ? (0, $1lUIm.html)($5baa2d42fd690322$var$_templateObject2()) : null;
            }
        },
        {
            key: "errorTemplate",
            value: function errorTemplate() {
                if (this.errorMessage) return (0, $1lUIm.html)($5baa2d42fd690322$var$_templateObject3(), this.errorMessage);
                return null;
            }
        }
    ]);
    return WuiEnsInput;
}((0, $eAsDt.LitElement));
$5baa2d42fd690322$export$2dc775ce7bfee34f.styles = [
    (0, $kYNxm.resetStyles),
    (0, $d0tkO.default)
];
$5baa2d42fd690322$var$__decorate([
    (0, $siQym.property)()
], $5baa2d42fd690322$export$2dc775ce7bfee34f.prototype, "errorMessage", void 0);
$5baa2d42fd690322$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $5baa2d42fd690322$export$2dc775ce7bfee34f.prototype, "disabled", void 0);
$5baa2d42fd690322$var$__decorate([
    (0, $siQym.property)()
], $5baa2d42fd690322$export$2dc775ce7bfee34f.prototype, "value", void 0);
$5baa2d42fd690322$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $5baa2d42fd690322$export$2dc775ce7bfee34f.prototype, "loading", void 0);
$5baa2d42fd690322$export$2dc775ce7bfee34f = $5baa2d42fd690322$var$__decorate([
    (0, $hdxb6.customElement)("wui-ens-input")
], $5baa2d42fd690322$export$2dc775ce7bfee34f);

});
parcelRegister("d0tkO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $978207b350476d38$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $978207b350476d38$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    position: relative;\n    width: 100%;\n    display: inline-block;\n    color: var(--wui-color-fg-275);\n  }\n\n  .error {\n    margin: var(--wui-spacing-xxs) var(--wui-spacing-m) var(--wui-spacing-0) var(--wui-spacing-m);\n  }\n\n  .base-name {\n    position: absolute;\n    right: 45px;\n    top: 15px;\n    text-align: right;\n  }\n"
    ]);
    $978207b350476d38$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $978207b350476d38$export$2e2bcd8739ae039 = (0, $bBWVO.css)($978207b350476d38$var$_templateObject());

});


parcelRegister("aoIfk", function(module, exports) {

$parcel$export(module.exports, "WuiIconLink", function () { return $791e77a4b5d85b5f$export$5a944ba239383166; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("dcd5U");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $kYaJ1 = parcelRequire("kYaJ1");
function $791e77a4b5d85b5f$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      <button ?disabled=",
        " ontouchstart>\n        <wui-icon color=",
        " size=",
        " name=",
        "></wui-icon>\n      </button>\n    "
    ]);
    $791e77a4b5d85b5f$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $791e77a4b5d85b5f$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $791e77a4b5d85b5f$export$5a944ba239383166 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiIconLink, LitElement);
    var _super = (0, $ohfOJ._)(WuiIconLink);
    function WuiIconLink() {
        (0, $4GJKx._)(this, WuiIconLink);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.size = "md";
        _this.disabled = false;
        _this.icon = "copy";
        _this.iconColor = "inherit";
        return _this;
    }
    (0, $1wc17._)(WuiIconLink, [
        {
            key: "render",
            value: function render() {
                var borderRadius = this.size === "lg" ? "--wui-border-radius-xs" : "--wui-border-radius-xxs";
                var padding = this.size === "lg" ? "--wui-spacing-1xs" : "--wui-spacing-2xs";
                this.style.cssText = "\n    --local-border-radius: var(".concat(borderRadius, ");\n    --local-padding: var(").concat(padding, ");\n");
                return (0, $1lUIm.html)($791e77a4b5d85b5f$var$_templateObject(), this.disabled, this.iconColor, this.size, this.icon);
            }
        }
    ]);
    return WuiIconLink;
}((0, $eAsDt.LitElement));
$791e77a4b5d85b5f$export$5a944ba239383166.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $kYNxm.colorStyles),
    (0, $kYaJ1.default)
];
$791e77a4b5d85b5f$var$__decorate([
    (0, $siQym.property)()
], $791e77a4b5d85b5f$export$5a944ba239383166.prototype, "size", void 0);
$791e77a4b5d85b5f$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $791e77a4b5d85b5f$export$5a944ba239383166.prototype, "disabled", void 0);
$791e77a4b5d85b5f$var$__decorate([
    (0, $siQym.property)()
], $791e77a4b5d85b5f$export$5a944ba239383166.prototype, "icon", void 0);
$791e77a4b5d85b5f$var$__decorate([
    (0, $siQym.property)()
], $791e77a4b5d85b5f$export$5a944ba239383166.prototype, "iconColor", void 0);
$791e77a4b5d85b5f$export$5a944ba239383166 = $791e77a4b5d85b5f$var$__decorate([
    (0, $hdxb6.customElement)("wui-icon-link")
], $791e77a4b5d85b5f$export$5a944ba239383166);

});
parcelRegister("kYaJ1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f441bb09e01e0fb9$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $f441bb09e01e0fb9$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  button {\n    border-radius: var(--local-border-radius);\n    color: var(--wui-color-fg-100);\n    padding: var(--local-padding);\n  }\n\n  @media (max-width: 700px) {\n    button {\n      padding: var(--wui-spacing-s);\n    }\n  }\n\n  button > wui-icon {\n    pointer-events: none;\n  }\n\n  button:disabled > wui-icon {\n    color: var(--wui-color-bg-300) !important;\n  }\n\n  button:disabled {\n    background-color: transparent;\n  }\n"
    ]);
    $f441bb09e01e0fb9$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $f441bb09e01e0fb9$export$2e2bcd8739ae039 = (0, $bBWVO.css)($f441bb09e01e0fb9$var$_templateObject());

});


parcelRegister("cJnc6", function(module, exports) {

$parcel$export(module.exports, "WuiInputElement", function () { return $944bade893d3f96c$export$673191bf93fc142c; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("dcd5U");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $6UVx3 = parcelRequire("6UVx3");
function $944bade893d3f96c$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <button>\n        <wui-icon color="inherit" size="xxs" name=',
        "></wui-icon>\n      </button>\n    "
    ]);
    $944bade893d3f96c$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $944bade893d3f96c$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $944bade893d3f96c$export$673191bf93fc142c = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiInputElement, LitElement);
    var _super = (0, $ohfOJ._)(WuiInputElement);
    function WuiInputElement() {
        (0, $4GJKx._)(this, WuiInputElement);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.icon = "copy";
        return _this;
    }
    (0, $1wc17._)(WuiInputElement, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($944bade893d3f96c$var$_templateObject(), this.icon);
            }
        }
    ]);
    return WuiInputElement;
}((0, $eAsDt.LitElement));
$944bade893d3f96c$export$673191bf93fc142c.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $6UVx3.default)
];
$944bade893d3f96c$var$__decorate([
    (0, $siQym.property)()
], $944bade893d3f96c$export$673191bf93fc142c.prototype, "icon", void 0);
$944bade893d3f96c$export$673191bf93fc142c = $944bade893d3f96c$var$__decorate([
    (0, $hdxb6.customElement)("wui-input-element")
], $944bade893d3f96c$export$673191bf93fc142c);

});
parcelRegister("6UVx3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $509499bdf46291ba$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $509499bdf46291ba$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  button {\n    background-color: var(--wui-color-fg-300);\n    border-radius: var(--wui-border-radius-4xs);\n    width: 16px;\n    height: 16px;\n  }\n\n  button:disabled {\n    background-color: var(--wui-color-bg-300);\n  }\n\n  wui-icon {\n    color: var(--wui-color-bg-200) !important;\n  }\n\n  button:focus-visible {\n    background-color: var(--wui-color-fg-250);\n    border: 1px solid var(--wui-color-accent-100);\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    button:hover:enabled {\n      background-color: var(--wui-color-fg-250);\n    }\n\n    button:active:enabled {\n      background-color: var(--wui-color-fg-225);\n    }\n  }\n"
    ]);
    $509499bdf46291ba$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $509499bdf46291ba$export$2e2bcd8739ae039 = (0, $bBWVO.css)($509499bdf46291ba$var$_templateObject());

});


parcelRegister("cMI92", function(module, exports) {

$parcel$export(module.exports, "WuiInputNumeric", function () { return $94ec35f9f365f182$export$230332bec9d0029b; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $72xOG = parcelRequire("72xOG");
function $94ec35f9f365f182$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<input\n      type="number"\n      maxlength="1"\n      inputmode="numeric"\n      autofocus\n      ?disabled=',
        "\n      value=",
        "\n    /> "
    ]);
    $94ec35f9f365f182$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $94ec35f9f365f182$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $94ec35f9f365f182$export$230332bec9d0029b = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiInputNumeric, LitElement);
    var _super = (0, $ohfOJ._)(WuiInputNumeric);
    function WuiInputNumeric() {
        (0, $4GJKx._)(this, WuiInputNumeric);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.disabled = false;
        _this.value = "";
        return _this;
    }
    (0, $1wc17._)(WuiInputNumeric, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($94ec35f9f365f182$var$_templateObject(), this.disabled, this.value);
            }
        }
    ]);
    return WuiInputNumeric;
}((0, $eAsDt.LitElement));
$94ec35f9f365f182$export$230332bec9d0029b.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $72xOG.default)
];
$94ec35f9f365f182$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $94ec35f9f365f182$export$230332bec9d0029b.prototype, "disabled", void 0);
$94ec35f9f365f182$var$__decorate([
    (0, $siQym.property)({
        type: String
    })
], $94ec35f9f365f182$export$230332bec9d0029b.prototype, "value", void 0);
$94ec35f9f365f182$export$230332bec9d0029b = $94ec35f9f365f182$var$__decorate([
    (0, $hdxb6.customElement)("wui-input-numeric")
], $94ec35f9f365f182$export$230332bec9d0029b);

});
parcelRegister("72xOG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5202f3942146aed7$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $5202f3942146aed7$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    position: relative;\n    display: inline-block;\n  }\n\n  input {\n    width: 50px;\n    height: 50px;\n    background: var(--wui-color-gray-glass-010);\n    border-radius: var(--wui-border-radius-xs);\n    border: 1px solid var(--wui-color-gray-glass-005);\n    font-family: var(--wui-font-family);\n    font-size: var(--wui-font-size-large);\n    font-weight: var(--wui-font-weight-regular);\n    letter-spacing: var(--wui-letter-spacing-large);\n    text-align: center;\n    color: var(--wui-color-fg-100);\n    caret-color: var(--wui-color-accent-100);\n    transition:\n      background-color var(--wui-ease-inout-power-1) var(--wui-duration-md),\n      border-color var(--wui-ease-inout-power-1) var(--wui-duration-md),\n      box-shadow var(--wui-ease-inout-power-1) var(--wui-duration-md);\n    will-change: background-color, border-color, box-shadow;\n    box-sizing: border-box;\n    -webkit-appearance: none;\n    -moz-appearance: textfield;\n    padding: 0px;\n  }\n\n  input::-webkit-outer-spin-button,\n  input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  input[type='number'] {\n    -moz-appearance: textfield;\n  }\n\n  input:disabled {\n    cursor: not-allowed;\n    border: 1px solid var(--wui-color-gray-glass-010);\n    background: var(--wui-color-gray-glass-005);\n  }\n\n  input:focus:enabled {\n    background-color: var(--wui-color-gray-glass-015);\n    border: 1px solid var(--wui-color-accent-100);\n    -webkit-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);\n    -moz-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);\n    box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    input:hover:enabled {\n      background-color: var(--wui-color-gray-glass-015);\n    }\n  }\n"
    ]);
    $5202f3942146aed7$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $5202f3942146aed7$export$2e2bcd8739ae039 = (0, $bBWVO.css)($5202f3942146aed7$var$_templateObject());

});


parcelRegister("fPwJM", function(module, exports) {

$parcel$export(module.exports, "WuiLink", function () { return $b86503645d1801b7$export$f279fe723271abb; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("dcd5U");
parcelRequire("1OYaf");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $gPoVi = parcelRequire("gPoVi");
function $b86503645d1801b7$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      <button ?disabled=",
        ' ontouchstart>\n        <slot name="iconLeft"></slot>\n        <wui-text variant="small-600" color=',
        '>\n          <slot></slot>\n        </wui-text>\n        <slot name="iconRight"></slot>\n      </button>\n    '
    ]);
    $b86503645d1801b7$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $b86503645d1801b7$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $b86503645d1801b7$export$f279fe723271abb = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiLink, LitElement);
    var _super = (0, $ohfOJ._)(WuiLink);
    function WuiLink() {
        (0, $4GJKx._)(this, WuiLink);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.disabled = false;
        _this.color = "inherit";
        return _this;
    }
    (0, $1wc17._)(WuiLink, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($b86503645d1801b7$var$_templateObject(), this.disabled, this.color);
            }
        }
    ]);
    return WuiLink;
}((0, $eAsDt.LitElement));
$b86503645d1801b7$export$f279fe723271abb.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $gPoVi.default)
];
$b86503645d1801b7$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $b86503645d1801b7$export$f279fe723271abb.prototype, "disabled", void 0);
$b86503645d1801b7$var$__decorate([
    (0, $siQym.property)()
], $b86503645d1801b7$export$f279fe723271abb.prototype, "color", void 0);
$b86503645d1801b7$export$f279fe723271abb = $b86503645d1801b7$var$__decorate([
    (0, $hdxb6.customElement)("wui-link")
], $b86503645d1801b7$export$f279fe723271abb);

});
parcelRegister("gPoVi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c404bdf673301d89$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $c404bdf673301d89$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  button {\n    padding: var(--wui-spacing-4xs) var(--wui-spacing-xxs);\n    border-radius: var(--wui-border-radius-3xs);\n    background-color: transparent;\n    color: var(--wui-color-accent-100);\n  }\n\n  button:disabled {\n    background-color: transparent;\n    color: var(--wui-color-gray-glass-015);\n  }\n\n  button:hover {\n    background-color: var(--wui-color-gray-glass-005);\n  }\n"
    ]);
    $c404bdf673301d89$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $c404bdf673301d89$export$2e2bcd8739ae039 = (0, $bBWVO.css)($c404bdf673301d89$var$_templateObject());

});


parcelRegister("YocOI", function(module, exports) {

$parcel$export(module.exports, "WuiListItem", function () { return $0b586176c8aa297a$export$cd9b2e41f828fc8a; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("3mWyR");
var $2vNUF = parcelRequire("2vNUF");
parcelRequire("dcd5U");
parcelRequire("9ZbyK");
parcelRequire("ePIOw");
parcelRequire("1OYaf");
parcelRequire("8tnK2");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("8jknp");

var $a3JmQ = parcelRequire("a3JmQ");
function $0b586176c8aa297a$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      <button\n        ?disabled=",
        "\n        data-loading=",
        "\n        data-iconvariant=",
        "\n        ontouchstart\n      >\n        ",
        " ",
        '\n        <wui-flex gap="3xs">\n          <slot></slot>\n        </wui-flex>\n        ',
        "\n      </button>\n    "
    ]);
    $0b586176c8aa297a$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $0b586176c8aa297a$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "<wui-image src=",
        " alt=",
        "></wui-image>"
    ]);
    $0b586176c8aa297a$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $0b586176c8aa297a$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "<wui-icon name=",
        "></wui-icon>"
    ]);
    $0b586176c8aa297a$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $0b586176c8aa297a$var$_templateObject3() {
    var data = (0, $j06k0._)([
        "\n        <wui-icon-box\n          data-variant=",
        "\n          icon=",
        "\n          iconSize=",
        '\n          background="transparent"\n          iconColor=',
        "\n          backgroundColor=",
        "\n          size=",
        "\n        ></wui-icon-box>\n      "
    ]);
    $0b586176c8aa297a$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $0b586176c8aa297a$var$_templateObject4() {
    var data = (0, $j06k0._)([
        '<wui-loading-spinner color="fg-300"></wui-loading-spinner>'
    ]);
    $0b586176c8aa297a$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $0b586176c8aa297a$var$_templateObject5() {
    var data = (0, $j06k0._)([
        ""
    ]);
    $0b586176c8aa297a$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $0b586176c8aa297a$var$_templateObject6() {
    var data = (0, $j06k0._)([
        '<wui-icon size="inherit" color="fg-200" name="chevronRight"></wui-icon>'
    ]);
    $0b586176c8aa297a$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
var $0b586176c8aa297a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $0b586176c8aa297a$export$cd9b2e41f828fc8a = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiListItem, LitElement);
    var _super = (0, $ohfOJ._)(WuiListItem);
    function WuiListItem() {
        (0, $4GJKx._)(this, WuiListItem);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.variant = "icon";
        _this.disabled = false;
        _this.imageSrc = undefined;
        _this.alt = undefined;
        _this.chevron = false;
        _this.loading = false;
        return _this;
    }
    (0, $1wc17._)(WuiListItem, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($0b586176c8aa297a$var$_templateObject(), this.loading ? true : Boolean(this.disabled), this.loading, (0, $2vNUF.ifDefined)(this.iconVariant), this.loadingTemplate(), this.visualTemplate(), this.chevronTemplate());
            }
        },
        {
            key: "visualTemplate",
            value: function visualTemplate() {
                var _this_alt;
                if (this.variant === "image" && this.imageSrc) return (0, $1lUIm.html)($0b586176c8aa297a$var$_templateObject1(), this.imageSrc, (_this_alt = this.alt) !== null && _this_alt !== void 0 ? _this_alt : "list item");
                if (this.iconVariant === "square" && this.icon && this.variant === "icon") return (0, $1lUIm.html)($0b586176c8aa297a$var$_templateObject2(), this.icon);
                if (this.variant === "icon" && this.icon && this.iconVariant) {
                    var color = [
                        "blue",
                        "square-blue"
                    ].includes(this.iconVariant) ? "accent-100" : "fg-200";
                    var size = this.iconVariant === "square-blue" ? "mdl" : "md";
                    var iconSize = this.iconSize ? this.iconSize : size;
                    return (0, $1lUIm.html)($0b586176c8aa297a$var$_templateObject3(), this.iconVariant, this.icon, iconSize, color, color, size);
                }
                return null;
            }
        },
        {
            key: "loadingTemplate",
            value: function loadingTemplate() {
                if (this.loading) return (0, $1lUIm.html)($0b586176c8aa297a$var$_templateObject4());
                return (0, $1lUIm.html)($0b586176c8aa297a$var$_templateObject5());
            }
        },
        {
            key: "chevronTemplate",
            value: function chevronTemplate() {
                if (this.chevron) return (0, $1lUIm.html)($0b586176c8aa297a$var$_templateObject6());
                return null;
            }
        }
    ]);
    return WuiListItem;
}((0, $eAsDt.LitElement));
$0b586176c8aa297a$export$cd9b2e41f828fc8a.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $a3JmQ.default)
];
$0b586176c8aa297a$var$__decorate([
    (0, $siQym.property)()
], $0b586176c8aa297a$export$cd9b2e41f828fc8a.prototype, "icon", void 0);
$0b586176c8aa297a$var$__decorate([
    (0, $siQym.property)()
], $0b586176c8aa297a$export$cd9b2e41f828fc8a.prototype, "iconSize", void 0);
$0b586176c8aa297a$var$__decorate([
    (0, $siQym.property)()
], $0b586176c8aa297a$export$cd9b2e41f828fc8a.prototype, "variant", void 0);
$0b586176c8aa297a$var$__decorate([
    (0, $siQym.property)()
], $0b586176c8aa297a$export$cd9b2e41f828fc8a.prototype, "iconVariant", void 0);
$0b586176c8aa297a$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $0b586176c8aa297a$export$cd9b2e41f828fc8a.prototype, "disabled", void 0);
$0b586176c8aa297a$var$__decorate([
    (0, $siQym.property)()
], $0b586176c8aa297a$export$cd9b2e41f828fc8a.prototype, "imageSrc", void 0);
$0b586176c8aa297a$var$__decorate([
    (0, $siQym.property)()
], $0b586176c8aa297a$export$cd9b2e41f828fc8a.prototype, "alt", void 0);
$0b586176c8aa297a$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $0b586176c8aa297a$export$cd9b2e41f828fc8a.prototype, "chevron", void 0);
$0b586176c8aa297a$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $0b586176c8aa297a$export$cd9b2e41f828fc8a.prototype, "loading", void 0);
$0b586176c8aa297a$export$cd9b2e41f828fc8a = $0b586176c8aa297a$var$__decorate([
    (0, $hdxb6.customElement)("wui-list-item")
], $0b586176c8aa297a$export$cd9b2e41f828fc8a);

});
parcelRegister("a3JmQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $752d603d3a372ded$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $752d603d3a372ded$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  button {\n    column-gap: var(--wui-spacing-s);\n    padding: 11px 18px 11px var(--wui-spacing-s);\n    width: 100%;\n    background-color: var(--wui-color-gray-glass-002);\n    border-radius: var(--wui-border-radius-xs);\n    color: var(--wui-color-fg-250);\n    transition:\n      color var(--wui-ease-out-power-1) var(--wui-duration-md),\n      background-color var(--wui-ease-out-power-1) var(--wui-duration-md);\n    will-change: color, background-color;\n  }\n\n  button[data-iconvariant='square'],\n  button[data-iconvariant='square-blue'] {\n    padding: 6px 18px 6px 9px;\n  }\n\n  button > wui-flex {\n    flex: 1;\n  }\n\n  button > wui-image {\n    width: 32px;\n    height: 32px;\n    box-shadow: 0 0 0 2px var(--wui-color-gray-glass-005);\n    border-radius: var(--wui-border-radius-3xl);\n  }\n\n  button > wui-icon {\n    width: 36px;\n    height: 36px;\n    transition: opacity var(--wui-ease-out-power-1) var(--wui-duration-md);\n    will-change: opacity;\n  }\n\n  button > wui-icon-box[data-variant='blue'] {\n    box-shadow: 0 0 0 2px var(--wui-color-accent-glass-005);\n  }\n\n  button > wui-icon-box[data-variant='overlay'] {\n    box-shadow: 0 0 0 2px var(--wui-color-gray-glass-005);\n  }\n\n  button > wui-icon-box[data-variant='square-blue'] {\n    border-radius: var(--wui-border-radius-3xs);\n    position: relative;\n    border: none;\n    width: 36px;\n    height: 36px;\n  }\n\n  button > wui-icon-box[data-variant='square-blue']::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    border-radius: inherit;\n    border: 1px solid var(--wui-color-accent-glass-010);\n    pointer-events: none;\n  }\n\n  button > wui-icon:last-child {\n    width: 14px;\n    height: 14px;\n  }\n\n  button:disabled {\n    color: var(--wui-color-gray-glass-020);\n  }\n\n  button[data-loading='true'] > wui-icon {\n    opacity: 0;\n  }\n\n  wui-loading-spinner {\n    position: absolute;\n    right: 18px;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n"
    ]);
    $752d603d3a372ded$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $752d603d3a372ded$export$2e2bcd8739ae039 = (0, $bBWVO.css)($752d603d3a372ded$var$_templateObject());

});


parcelRegister("akKYQ", function(module, exports) {

$parcel$export(module.exports, "WuiTransactionListItem", function () { return $786036fbeeff14fd$export$ee516ccb0af19908; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");

var $hdxb6 = parcelRequire("hdxb6");

var $fS6pi = parcelRequire("fS6pi");

var $kYNxm = parcelRequire("kYNxm");
parcelRequire("1OYaf");
parcelRequire("bMh6r");
parcelRequire("3mWyR");
var $2vNUF = parcelRequire("2vNUF");

var $hKpaP = parcelRequire("hKpaP");
function $786036fbeeff14fd$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      <wui-flex>\n        <wui-transaction-visual\n          .status=",
        "\n          direction=",
        "\n          type=",
        "\n          onlyDirectionIcon=",
        "\n          .images=",
        '\n        ></wui-transaction-visual>\n        <wui-flex flexDirection="column" gap="3xs">\n          <wui-text variant="paragraph-600" color="fg-100">\n            ',
        '\n          </wui-text>\n          <wui-flex class="description-container">\n            ',
        " ",
        '\n          </wui-flex>\n        </wui-flex>\n        <wui-text variant="micro-700" color="fg-300"><span>',
        "</span></wui-text>\n      </wui-flex>\n    "
    ]);
    $786036fbeeff14fd$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $786036fbeeff14fd$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '\n          <wui-text variant="small-500" color="fg-200">\n            <span>',
        "</span>\n          </wui-text>\n        "
    ]);
    $786036fbeeff14fd$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $786036fbeeff14fd$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '\n          <wui-icon class="description-separator-icon" size="xxs" name="arrowRight"></wui-icon>\n          <wui-text variant="small-400" color="fg-200">\n            <span>',
        "</span>\n          </wui-text>\n        "
    ]);
    $786036fbeeff14fd$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $786036fbeeff14fd$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $786036fbeeff14fd$export$ee516ccb0af19908 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiTransactionListItem, LitElement);
    var _super = (0, $ohfOJ._)(WuiTransactionListItem);
    function WuiTransactionListItem() {
        (0, $4GJKx._)(this, WuiTransactionListItem);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.type = "approve";
        _this.onlyDirectionIcon = false;
        _this.images = [];
        _this.price = [];
        _this.amount = [];
        _this.symbol = [];
        return _this;
    }
    (0, $1wc17._)(WuiTransactionListItem, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($786036fbeeff14fd$var$_templateObject(), this.status, (0, $2vNUF.ifDefined)(this.direction), this.type, (0, $2vNUF.ifDefined)(this.onlyDirectionIcon), this.images, (0, $fS6pi.TransactionTypePastTense)[this.type] || this.type, this.templateDescription(), this.templateSecondDescription(), this.date);
            }
        },
        {
            key: "templateDescription",
            value: function templateDescription() {
                var _this_descriptions;
                var description = (_this_descriptions = this.descriptions) === null || _this_descriptions === void 0 ? void 0 : _this_descriptions[0];
                return description ? (0, $1lUIm.html)($786036fbeeff14fd$var$_templateObject1(), description) : null;
            }
        },
        {
            key: "templateSecondDescription",
            value: function templateSecondDescription() {
                var _this_descriptions;
                var description = (_this_descriptions = this.descriptions) === null || _this_descriptions === void 0 ? void 0 : _this_descriptions[1];
                return description ? (0, $1lUIm.html)($786036fbeeff14fd$var$_templateObject2(), description) : null;
            }
        }
    ]);
    return WuiTransactionListItem;
}((0, $eAsDt.LitElement));
$786036fbeeff14fd$export$ee516ccb0af19908.styles = [
    (0, $kYNxm.resetStyles),
    (0, $hKpaP.default)
];
$786036fbeeff14fd$var$__decorate([
    (0, $siQym.property)()
], $786036fbeeff14fd$export$ee516ccb0af19908.prototype, "type", void 0);
$786036fbeeff14fd$var$__decorate([
    (0, $siQym.property)({
        type: Array
    })
], $786036fbeeff14fd$export$ee516ccb0af19908.prototype, "descriptions", void 0);
$786036fbeeff14fd$var$__decorate([
    (0, $siQym.property)()
], $786036fbeeff14fd$export$ee516ccb0af19908.prototype, "date", void 0);
$786036fbeeff14fd$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $786036fbeeff14fd$export$ee516ccb0af19908.prototype, "onlyDirectionIcon", void 0);
$786036fbeeff14fd$var$__decorate([
    (0, $siQym.property)()
], $786036fbeeff14fd$export$ee516ccb0af19908.prototype, "status", void 0);
$786036fbeeff14fd$var$__decorate([
    (0, $siQym.property)()
], $786036fbeeff14fd$export$ee516ccb0af19908.prototype, "direction", void 0);
$786036fbeeff14fd$var$__decorate([
    (0, $siQym.property)({
        type: Array
    })
], $786036fbeeff14fd$export$ee516ccb0af19908.prototype, "images", void 0);
$786036fbeeff14fd$var$__decorate([
    (0, $siQym.property)({
        type: Array
    })
], $786036fbeeff14fd$export$ee516ccb0af19908.prototype, "price", void 0);
$786036fbeeff14fd$var$__decorate([
    (0, $siQym.property)({
        type: Array
    })
], $786036fbeeff14fd$export$ee516ccb0af19908.prototype, "amount", void 0);
$786036fbeeff14fd$var$__decorate([
    (0, $siQym.property)({
        type: Array
    })
], $786036fbeeff14fd$export$ee516ccb0af19908.prototype, "symbol", void 0);
$786036fbeeff14fd$export$ee516ccb0af19908 = $786036fbeeff14fd$var$__decorate([
    (0, $hdxb6.customElement)("wui-transaction-list-item")
], $786036fbeeff14fd$export$ee516ccb0af19908);

});
parcelRegister("fS6pi", function(module, exports) {

$parcel$export(module.exports, "TransactionTypePastTense", function () { return $b8e0de7318de8de6$export$1c6b44bd2bf7f8fa; });
var $b8e0de7318de8de6$export$1c6b44bd2bf7f8fa;
(function(TransactionTypePastTense) {
    TransactionTypePastTense["approve"] = "approved";
    TransactionTypePastTense["bought"] = "bought";
    TransactionTypePastTense["borrow"] = "borrowed";
    TransactionTypePastTense["burn"] = "burnt";
    TransactionTypePastTense["cancel"] = "canceled";
    TransactionTypePastTense["claim"] = "claimed";
    TransactionTypePastTense["deploy"] = "deployed";
    TransactionTypePastTense["deposit"] = "deposited";
    TransactionTypePastTense["execute"] = "executed";
    TransactionTypePastTense["mint"] = "minted";
    TransactionTypePastTense["receive"] = "received";
    TransactionTypePastTense["repay"] = "repaid";
    TransactionTypePastTense["send"] = "sent";
    TransactionTypePastTense["sell"] = "sold";
    TransactionTypePastTense["stake"] = "staked";
    TransactionTypePastTense["trade"] = "swapped";
    TransactionTypePastTense["unstake"] = "unstaked";
    TransactionTypePastTense["withdraw"] = "withdrawn";
})($b8e0de7318de8de6$export$1c6b44bd2bf7f8fa || ($b8e0de7318de8de6$export$1c6b44bd2bf7f8fa = {}));

});

parcelRegister("bMh6r", function(module, exports) {

$parcel$export(module.exports, "WuiTransactionVisual", function () { return $893171b2138b9e2b$export$98664c16c41f47e3; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $cv9Rk = parcelRequire("cv9Rk");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");

var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("9ZbyK");
parcelRequire("8jknp");

var $3gd3h = parcelRequire("3gd3h");
function $893171b2138b9e2b$var$_templateObject() {
    var data = (0, $j06k0._)([
        "<wui-flex> ",
        " ",
        " </wui-flex>"
    ]);
    $893171b2138b9e2b$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $893171b2138b9e2b$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "<wui-image src=",
        ' alt="Transaction image"></wui-image>'
    ]);
    $893171b2138b9e2b$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $893171b2138b9e2b$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "<wui-image src=",
        ' alt="Transaction image"></wui-image>'
    ]);
    $893171b2138b9e2b$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $893171b2138b9e2b$var$_templateObject3() {
    var data = (0, $j06k0._)([
        '<div class="swap-images-container">\n        ',
        "\n        ",
        "\n      </div>"
    ]);
    $893171b2138b9e2b$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $893171b2138b9e2b$var$_templateObject4() {
    var data = (0, $j06k0._)([
        "<wui-image src=",
        ' alt="Transaction image"></wui-image>'
    ]);
    $893171b2138b9e2b$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $893171b2138b9e2b$var$_templateObject5() {
    var data = (0, $j06k0._)([
        '<wui-icon size="inherit" color="fg-200" name="nftPlaceholder"></wui-icon>'
    ]);
    $893171b2138b9e2b$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $893171b2138b9e2b$var$_templateObject6() {
    var data = (0, $j06k0._)([
        '<wui-icon size="inherit" color="fg-200" name="coinPlaceholder"></wui-icon>'
    ]);
    $893171b2138b9e2b$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $893171b2138b9e2b$var$_templateObject7() {
    var data = (0, $j06k0._)([
        '\n      <wui-icon-box\n        size="xxs"\n        iconColor=',
        "\n        backgroundColor=",
        '\n        background="opaque"\n        icon=',
        "\n        ?border=",
        '\n        borderColor="wui-color-bg-125"\n      ></wui-icon-box>\n    '
    ]);
    $893171b2138b9e2b$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
var $893171b2138b9e2b$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $893171b2138b9e2b$export$98664c16c41f47e3 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiTransactionVisual, LitElement);
    var _super = (0, $ohfOJ._)(WuiTransactionVisual);
    function WuiTransactionVisual() {
        (0, $4GJKx._)(this, WuiTransactionVisual);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.images = [];
        _this.secondImage = {
            type: undefined,
            url: ""
        };
        return _this;
    }
    (0, $1wc17._)(WuiTransactionVisual, [
        {
            key: "render",
            value: function render() {
                var _this_images = (0, $cv9Rk._)(this.images, 2), firstImage = _this_images[0], secondImage = _this_images[1];
                var isLeftNFT = (firstImage === null || firstImage === void 0 ? void 0 : firstImage.type) === "NFT";
                var isRightNFT = (secondImage === null || secondImage === void 0 ? void 0 : secondImage.url) ? secondImage.type === "NFT" : isLeftNFT;
                var leftRadius = isLeftNFT ? "var(--wui-border-radius-xxs)" : "var(--wui-border-radius-s)";
                var rightRadius = isRightNFT ? "var(--wui-border-radius-xxs)" : "var(--wui-border-radius-s)";
                this.style.cssText = "\n    --local-left-border-radius: ".concat(leftRadius, ";\n    --local-right-border-radius: ").concat(rightRadius, ";\n    ");
                return (0, $1lUIm.html)($893171b2138b9e2b$var$_templateObject(), this.templateVisual(), this.templateIcon());
            }
        },
        {
            key: "templateVisual",
            value: function templateVisual() {
                var _this_images = (0, $cv9Rk._)(this.images, 2), firstImage = _this_images[0], secondImage = _this_images[1];
                var firstImageType = firstImage === null || firstImage === void 0 ? void 0 : firstImage.type;
                var haveTwoImages = this.images.length === 2;
                if (haveTwoImages && ((firstImage === null || firstImage === void 0 ? void 0 : firstImage.url) || (secondImage === null || secondImage === void 0 ? void 0 : secondImage.url))) return (0, $1lUIm.html)($893171b2138b9e2b$var$_templateObject3(), (firstImage === null || firstImage === void 0 ? void 0 : firstImage.url) ? (0, $1lUIm.html)($893171b2138b9e2b$var$_templateObject1(), firstImage.url) : null, (secondImage === null || secondImage === void 0 ? void 0 : secondImage.url) ? (0, $1lUIm.html)($893171b2138b9e2b$var$_templateObject2(), secondImage.url) : null);
                else if (firstImage === null || firstImage === void 0 ? void 0 : firstImage.url) return (0, $1lUIm.html)($893171b2138b9e2b$var$_templateObject4(), firstImage.url);
                else if (firstImageType === "NFT") return (0, $1lUIm.html)($893171b2138b9e2b$var$_templateObject5());
                return (0, $1lUIm.html)($893171b2138b9e2b$var$_templateObject6());
            }
        },
        {
            key: "templateIcon",
            value: function templateIcon() {
                var color = "accent-100";
                var icon = undefined;
                icon = this.getIcon();
                if (this.status) color = this.getStatusColor();
                if (!icon) return null;
                return (0, $1lUIm.html)($893171b2138b9e2b$var$_templateObject7(), color, color, icon, true);
            }
        },
        {
            key: "getDirectionIcon",
            value: function getDirectionIcon() {
                switch(this.direction){
                    case "in":
                        return "arrowBottom";
                    case "out":
                        return "arrowTop";
                    default:
                        return undefined;
                }
            }
        },
        {
            key: "getIcon",
            value: function getIcon() {
                if (this.onlyDirectionIcon) return this.getDirectionIcon();
                if (this.type === "trade") return "swapHorizontalBold";
                else if (this.type === "approve") return "checkmark";
                else if (this.type === "cancel") return "close";
                return this.getDirectionIcon();
            }
        },
        {
            key: "getStatusColor",
            value: function getStatusColor() {
                switch(this.status){
                    case "confirmed":
                        return "success-100";
                    case "failed":
                        return "error-100";
                    case "pending":
                        return "inverse-100";
                    default:
                        return "accent-100";
                }
            }
        }
    ]);
    return WuiTransactionVisual;
}((0, $eAsDt.LitElement));
$893171b2138b9e2b$export$98664c16c41f47e3.styles = [
    (0, $3gd3h.default)
];
$893171b2138b9e2b$var$__decorate([
    (0, $siQym.property)()
], $893171b2138b9e2b$export$98664c16c41f47e3.prototype, "type", void 0);
$893171b2138b9e2b$var$__decorate([
    (0, $siQym.property)()
], $893171b2138b9e2b$export$98664c16c41f47e3.prototype, "status", void 0);
$893171b2138b9e2b$var$__decorate([
    (0, $siQym.property)()
], $893171b2138b9e2b$export$98664c16c41f47e3.prototype, "direction", void 0);
$893171b2138b9e2b$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $893171b2138b9e2b$export$98664c16c41f47e3.prototype, "onlyDirectionIcon", void 0);
$893171b2138b9e2b$var$__decorate([
    (0, $siQym.property)({
        type: Array
    })
], $893171b2138b9e2b$export$98664c16c41f47e3.prototype, "images", void 0);
$893171b2138b9e2b$var$__decorate([
    (0, $siQym.property)({
        type: Object
    })
], $893171b2138b9e2b$export$98664c16c41f47e3.prototype, "secondImage", void 0);
$893171b2138b9e2b$export$98664c16c41f47e3 = $893171b2138b9e2b$var$__decorate([
    (0, $hdxb6.customElement)("wui-transaction-visual")
], $893171b2138b9e2b$export$98664c16c41f47e3);

});
parcelRegister("3gd3h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25fcfd8ab2ec8251$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $25fcfd8ab2ec8251$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host > wui-flex {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    width: 40px;\n    height: 40px;\n    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-005);\n    background-color: var(--wui-color-gray-glass-005);\n  }\n\n  :host > wui-flex wui-image {\n    display: block;\n  }\n\n  :host > wui-flex,\n  :host > wui-flex wui-image,\n  .swap-images-container,\n  .swap-images-container.nft,\n  wui-image.nft {\n    border-top-left-radius: var(--local-left-border-radius);\n    border-top-right-radius: var(--local-right-border-radius);\n    border-bottom-left-radius: var(--local-left-border-radius);\n    border-bottom-right-radius: var(--local-right-border-radius);\n  }\n\n  wui-icon {\n    width: 20px;\n    height: 20px;\n  }\n\n  wui-icon-box {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    transform: translate(20%, 20%);\n  }\n\n  .swap-images-container {\n    position: relative;\n    width: 40px;\n    height: 40px;\n    overflow: hidden;\n  }\n\n  .swap-images-container wui-image:first-child {\n    position: absolute;\n    width: 40px;\n    height: 40px;\n    top: 0;\n    left: 0%;\n    clip-path: inset(0px calc(50% + 2px) 0px 0%);\n  }\n\n  .swap-images-container wui-image:last-child {\n    clip-path: inset(0px 0px 0px calc(50% + 2px));\n  }\n"
    ]);
    $25fcfd8ab2ec8251$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $25fcfd8ab2ec8251$export$2e2bcd8739ae039 = (0, $bBWVO.css)($25fcfd8ab2ec8251$var$_templateObject());

});


parcelRegister("hKpaP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ceba427cbdae430e$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $ceba427cbdae430e$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host > wui-flex:first-child {\n    align-items: center;\n    column-gap: var(--wui-spacing-s);\n    padding: 6.5px var(--wui-spacing-xs) 6.5px var(--wui-spacing-xs);\n    width: 100%;\n  }\n\n  :host > wui-flex:first-child wui-text:nth-child(1) {\n    text-transform: capitalize;\n  }\n\n  wui-transaction-visual {\n    width: 40px;\n    height: 40px;\n  }\n\n  wui-flex {\n    flex: 1;\n  }\n\n  :host wui-flex wui-flex {\n    overflow: hidden;\n  }\n\n  :host .description-container wui-text span {\n    word-break: break-all;\n  }\n\n  :host .description-container wui-text {\n    overflow: hidden;\n  }\n\n  :host .description-separator-icon {\n    margin: 0px 6px;\n  }\n\n  :host wui-text > span {\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 1;\n  }\n"
    ]);
    $ceba427cbdae430e$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $ceba427cbdae430e$export$2e2bcd8739ae039 = (0, $bBWVO.css)($ceba427cbdae430e$var$_templateObject());

});


parcelRegister("3t2a7", function(module, exports) {

$parcel$export(module.exports, "WuiTransactionListItemLoader", function () { return $2865c1e3838c2f74$export$994c2d15662c37cc; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");

var $hdxb6 = parcelRequire("hdxb6");

var $kYNxm = parcelRequire("kYNxm");
parcelRequire("1OYaf");
parcelRequire("bMh6r");

var $3h91C = parcelRequire("3h91C");
function $2865c1e3838c2f74$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex alignItems="center">\n        <wui-shimmer width="40px" height="40px"></wui-shimmer>\n        <wui-flex flexDirection="column" gap="2xs">\n          <wui-shimmer width="72px" height="16px" borderRadius="4xs"></wui-shimmer>\n          <wui-shimmer width="148px" height="14px" borderRadius="4xs"></wui-shimmer>\n        </wui-flex>\n        <wui-shimmer width="24px" height="12px" borderRadius="5xs"></wui-shimmer>\n      </wui-flex>\n    '
    ]);
    $2865c1e3838c2f74$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $2865c1e3838c2f74$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $2865c1e3838c2f74$export$994c2d15662c37cc = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiTransactionListItemLoader, LitElement);
    var _super = (0, $ohfOJ._)(WuiTransactionListItemLoader);
    function WuiTransactionListItemLoader() {
        (0, $4GJKx._)(this, WuiTransactionListItemLoader);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(WuiTransactionListItemLoader, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($2865c1e3838c2f74$var$_templateObject());
            }
        }
    ]);
    return WuiTransactionListItemLoader;
}((0, $eAsDt.LitElement));
$2865c1e3838c2f74$export$994c2d15662c37cc.styles = [
    (0, $kYNxm.resetStyles),
    (0, $3h91C.default)
];
$2865c1e3838c2f74$export$994c2d15662c37cc = $2865c1e3838c2f74$var$__decorate([
    (0, $hdxb6.customElement)("wui-transaction-list-item-loader")
], $2865c1e3838c2f74$export$994c2d15662c37cc);

});
parcelRegister("3h91C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2629f5d109f36aec$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $2629f5d109f36aec$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host > wui-flex:first-child {\n    column-gap: var(--wui-spacing-s);\n    padding: 7px var(--wui-spacing-l) 7px var(--wui-spacing-xs);\n    width: 100%;\n  }\n\n  wui-flex {\n    display: flex;\n    flex: 1;\n  }\n"
    ]);
    $2629f5d109f36aec$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $2629f5d109f36aec$export$2e2bcd8739ae039 = (0, $bBWVO.css)($2629f5d109f36aec$var$_templateObject());

});


parcelRegister("6vhgh", function(module, exports) {

$parcel$export(module.exports, "WuiListWallet", function () { return $4bc3071da4795f7d$export$fe01be9b7ff81a09; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("dcd5U");
parcelRequire("8jknp");
parcelRequire("1OYaf");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4VTk3");
parcelRequire("2n1QF");
parcelRequire("U3J5G");

var $aYOyV = parcelRequire("aYOyV");
function $4bc3071da4795f7d$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      <button ?disabled=",
        " ontouchstart>\n        ",
        " ",
        '\n        <wui-text variant="paragraph-500" color="inherit">',
        "</wui-text>\n        ",
        "\n      </button>\n    "
    ]);
    $4bc3071da4795f7d$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $4bc3071da4795f7d$var$_templateObject1() {
    var data = (0, $j06k0._)([
        " <wui-all-wallets-image .imageeSrc=",
        "> </wui-all-wallets-image> "
    ]);
    $4bc3071da4795f7d$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $4bc3071da4795f7d$var$_templateObject2() {
    var data = (0, $j06k0._)([
        " <wui-wallet-image .walletIcon=",
        ' size="sm"> </wui-wallet-image> '
    ]);
    $4bc3071da4795f7d$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $4bc3071da4795f7d$var$_templateObject3() {
    var data = (0, $j06k0._)([
        '<wui-wallet-image\n        size="sm"\n        imageSrc=',
        "\n        name=",
        "\n        .installed=",
        "\n      ></wui-wallet-image>"
    ]);
    $4bc3071da4795f7d$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $4bc3071da4795f7d$var$_templateObject4() {
    var data = (0, $j06k0._)([
        '<wui-wallet-image size="sm" name=',
        "></wui-wallet-image>"
    ]);
    $4bc3071da4795f7d$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $4bc3071da4795f7d$var$_templateObject5() {
    var data = (0, $j06k0._)([
        "<wui-tag variant=",
        ">",
        "</wui-tag>"
    ]);
    $4bc3071da4795f7d$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $4bc3071da4795f7d$var$_templateObject6() {
    var data = (0, $j06k0._)([
        '<wui-icon color="inherit" size="sm" name=',
        "></wui-icon>"
    ]);
    $4bc3071da4795f7d$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
var $4bc3071da4795f7d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $4bc3071da4795f7d$export$fe01be9b7ff81a09 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiListWallet, LitElement);
    var _super = (0, $ohfOJ._)(WuiListWallet);
    function WuiListWallet() {
        (0, $4GJKx._)(this, WuiListWallet);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.walletImages = [];
        _this.imageSrc = "";
        _this.name = "";
        _this.installed = false;
        _this.disabled = false;
        _this.showAllWallets = false;
        return _this;
    }
    (0, $1wc17._)(WuiListWallet, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($4bc3071da4795f7d$var$_templateObject(), this.disabled, this.templateAllWallets(), this.templateWalletImage(), this.name, this.templateStatus());
            }
        },
        {
            key: "templateAllWallets",
            value: function templateAllWallets() {
                if (this.showAllWallets && this.imageSrc) return (0, $1lUIm.html)($4bc3071da4795f7d$var$_templateObject1(), this.imageSrc);
                else if (this.showAllWallets && this.walletIcon) return (0, $1lUIm.html)($4bc3071da4795f7d$var$_templateObject2(), this.walletIcon);
                return null;
            }
        },
        {
            key: "templateWalletImage",
            value: function templateWalletImage() {
                if (!this.showAllWallets && this.imageSrc) return (0, $1lUIm.html)($4bc3071da4795f7d$var$_templateObject3(), this.imageSrc, this.name, this.installed);
                else if (!this.showAllWallets && !this.imageSrc) return (0, $1lUIm.html)($4bc3071da4795f7d$var$_templateObject4(), this.name);
                return null;
            }
        },
        {
            key: "templateStatus",
            value: function templateStatus() {
                if (this.tagLabel && this.tagVariant) return (0, $1lUIm.html)($4bc3071da4795f7d$var$_templateObject5(), this.tagVariant, this.tagLabel);
                else if (this.icon) return (0, $1lUIm.html)($4bc3071da4795f7d$var$_templateObject6(), this.icon);
                return null;
            }
        }
    ]);
    return WuiListWallet;
}((0, $eAsDt.LitElement));
$4bc3071da4795f7d$export$fe01be9b7ff81a09.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $aYOyV.default)
];
$4bc3071da4795f7d$var$__decorate([
    (0, $siQym.property)({
        type: Array
    })
], $4bc3071da4795f7d$export$fe01be9b7ff81a09.prototype, "walletImages", void 0);
$4bc3071da4795f7d$var$__decorate([
    (0, $siQym.property)()
], $4bc3071da4795f7d$export$fe01be9b7ff81a09.prototype, "imageSrc", void 0);
$4bc3071da4795f7d$var$__decorate([
    (0, $siQym.property)()
], $4bc3071da4795f7d$export$fe01be9b7ff81a09.prototype, "name", void 0);
$4bc3071da4795f7d$var$__decorate([
    (0, $siQym.property)()
], $4bc3071da4795f7d$export$fe01be9b7ff81a09.prototype, "tagLabel", void 0);
$4bc3071da4795f7d$var$__decorate([
    (0, $siQym.property)()
], $4bc3071da4795f7d$export$fe01be9b7ff81a09.prototype, "tagVariant", void 0);
$4bc3071da4795f7d$var$__decorate([
    (0, $siQym.property)()
], $4bc3071da4795f7d$export$fe01be9b7ff81a09.prototype, "icon", void 0);
$4bc3071da4795f7d$var$__decorate([
    (0, $siQym.property)()
], $4bc3071da4795f7d$export$fe01be9b7ff81a09.prototype, "walletIcon", void 0);
$4bc3071da4795f7d$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $4bc3071da4795f7d$export$fe01be9b7ff81a09.prototype, "installed", void 0);
$4bc3071da4795f7d$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $4bc3071da4795f7d$export$fe01be9b7ff81a09.prototype, "disabled", void 0);
$4bc3071da4795f7d$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $4bc3071da4795f7d$export$fe01be9b7ff81a09.prototype, "showAllWallets", void 0);
$4bc3071da4795f7d$export$fe01be9b7ff81a09 = $4bc3071da4795f7d$var$__decorate([
    (0, $hdxb6.customElement)("wui-list-wallet")
], $4bc3071da4795f7d$export$fe01be9b7ff81a09);

});
parcelRegister("2n1QF", function(module, exports) {

$parcel$export(module.exports, "WuiTag", function () { return $1b9f29d52ae48bd0$export$989e5aad4666150; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("1OYaf");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $gtQss = parcelRequire("gtQss");
function $1b9f29d52ae48bd0$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      <wui-text data-variant=",
        " variant=",
        ' color="inherit">\n        <slot></slot>\n      </wui-text>\n    '
    ]);
    $1b9f29d52ae48bd0$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $1b9f29d52ae48bd0$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $1b9f29d52ae48bd0$export$989e5aad4666150 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiTag, LitElement);
    var _super = (0, $ohfOJ._)(WuiTag);
    function WuiTag() {
        (0, $4GJKx._)(this, WuiTag);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.variant = "main";
        _this.size = "lg";
        return _this;
    }
    (0, $1wc17._)(WuiTag, [
        {
            key: "render",
            value: function render() {
                this.dataset["variant"] = this.variant;
                this.dataset["size"] = this.size;
                var textVariant = this.size === "md" ? "mini-700" : "micro-700";
                return (0, $1lUIm.html)($1b9f29d52ae48bd0$var$_templateObject(), this.variant, textVariant);
            }
        }
    ]);
    return WuiTag;
}((0, $eAsDt.LitElement));
$1b9f29d52ae48bd0$export$989e5aad4666150.styles = [
    (0, $kYNxm.resetStyles),
    (0, $gtQss.default)
];
$1b9f29d52ae48bd0$var$__decorate([
    (0, $siQym.property)()
], $1b9f29d52ae48bd0$export$989e5aad4666150.prototype, "variant", void 0);
$1b9f29d52ae48bd0$var$__decorate([
    (0, $siQym.property)()
], $1b9f29d52ae48bd0$export$989e5aad4666150.prototype, "size", void 0);
$1b9f29d52ae48bd0$export$989e5aad4666150 = $1b9f29d52ae48bd0$var$__decorate([
    (0, $hdxb6.customElement)("wui-tag")
], $1b9f29d52ae48bd0$export$989e5aad4666150);

});
parcelRegister("gtQss", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bff80bd10555cfd5$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $bff80bd10555cfd5$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: var(--wui-spacing-m);\n    padding: 0 var(--wui-spacing-3xs) !important;\n    border-radius: var(--wui-border-radius-5xs);\n  }\n\n  :host > wui-text {\n    transform: translateY(5%);\n  }\n\n  :host([data-variant='main']) {\n    background-color: var(--wui-color-accent-glass-015);\n    color: var(--wui-color-accent-100);\n  }\n\n  :host([data-variant='shade']) {\n    background-color: var(--wui-color-gray-glass-010);\n    color: var(--wui-color-fg-200);\n  }\n\n  :host([data-variant='success']) {\n    background-color: var(--wui-icon-box-bg-success-100);\n    color: var(--wui-color-success-100);\n  }\n\n  :host([data-variant='error']) {\n    background-color: var(--wui-icon-box-bg-error-100);\n    color: var(--wui-color-error-100);\n  }\n\n  :host([data-size='lg']) {\n    padding: 11px 5px !important;\n  }\n\n  :host([data-size='lg']) > wui-text {\n    transform: translateY(2%);\n  }\n"
    ]);
    $bff80bd10555cfd5$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $bff80bd10555cfd5$export$2e2bcd8739ae039 = (0, $bBWVO.css)($bff80bd10555cfd5$var$_templateObject());

});


parcelRegister("aYOyV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7fe6ba9fe9732b72$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $7fe6ba9fe9732b72$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  button {\n    column-gap: var(--wui-spacing-s);\n    padding: 7px var(--wui-spacing-l) 7px var(--wui-spacing-xs);\n    width: 100%;\n    background-color: var(--wui-color-gray-glass-002);\n    border-radius: var(--wui-border-radius-xs);\n    color: var(--wui-color-fg-100);\n  }\n\n  button > wui-text:nth-child(2) {\n    display: flex;\n    flex: 1;\n  }\n\n  button:disabled {\n    background-color: var(--wui-color-gray-glass-015);\n    color: var(--wui-color-gray-glass-015);\n  }\n\n  button:disabled > wui-tag {\n    background-color: var(--wui-color-gray-glass-010);\n    color: var(--wui-color-fg-300);\n  }\n\n  wui-icon {\n    color: var(--wui-color-fg-200) !important;\n  }\n"
    ]);
    $7fe6ba9fe9732b72$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $7fe6ba9fe9732b72$export$2e2bcd8739ae039 = (0, $bBWVO.css)($7fe6ba9fe9732b72$var$_templateObject());

});


parcelRegister("kyiWo", function(module, exports) {

$parcel$export(module.exports, "WuiLogoSelect", function () { return $ef65acdf4d49230f$export$aadc276ee48f1572; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("iQo3l");

var $k0Q8r = parcelRequire("k0Q8r");
function $ef65acdf4d49230f$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      <button ?disabled=",
        " ontouchstart>\n        <wui-logo logo=",
        "></wui-logo>\n      </button>\n    "
    ]);
    $ef65acdf4d49230f$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $ef65acdf4d49230f$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $ef65acdf4d49230f$export$aadc276ee48f1572 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiLogoSelect, LitElement);
    var _super = (0, $ohfOJ._)(WuiLogoSelect);
    function WuiLogoSelect() {
        (0, $4GJKx._)(this, WuiLogoSelect);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.logo = "google";
        _this.disabled = false;
        return _this;
    }
    (0, $1wc17._)(WuiLogoSelect, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($ef65acdf4d49230f$var$_templateObject(), this.disabled, this.logo);
            }
        }
    ]);
    return WuiLogoSelect;
}((0, $eAsDt.LitElement));
$ef65acdf4d49230f$export$aadc276ee48f1572.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $k0Q8r.default)
];
$ef65acdf4d49230f$var$__decorate([
    (0, $siQym.property)()
], $ef65acdf4d49230f$export$aadc276ee48f1572.prototype, "logo", void 0);
$ef65acdf4d49230f$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $ef65acdf4d49230f$export$aadc276ee48f1572.prototype, "disabled", void 0);
$ef65acdf4d49230f$export$aadc276ee48f1572 = $ef65acdf4d49230f$var$__decorate([
    (0, $hdxb6.customElement)("wui-logo-select")
], $ef65acdf4d49230f$export$aadc276ee48f1572);

});
parcelRegister("iQo3l", function(module, exports) {

$parcel$export(module.exports, "WuiLogo", function () { return $db7fbdbee4102f58$export$e515c2183ed1fdbc; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("dcd5U");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $lI35B = parcelRequire("lI35B");
function $db7fbdbee4102f58$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<wui-icon color="inherit" size="inherit" name=',
        "></wui-icon> "
    ]);
    $db7fbdbee4102f58$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $db7fbdbee4102f58$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $db7fbdbee4102f58$export$e515c2183ed1fdbc = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiLogo, LitElement);
    var _super = (0, $ohfOJ._)(WuiLogo);
    function WuiLogo() {
        (0, $4GJKx._)(this, WuiLogo);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.logo = "google";
        return _this;
    }
    (0, $1wc17._)(WuiLogo, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($db7fbdbee4102f58$var$_templateObject(), this.logo);
            }
        }
    ]);
    return WuiLogo;
}((0, $eAsDt.LitElement));
$db7fbdbee4102f58$export$e515c2183ed1fdbc.styles = [
    (0, $kYNxm.resetStyles),
    (0, $lI35B.default)
];
$db7fbdbee4102f58$var$__decorate([
    (0, $siQym.property)()
], $db7fbdbee4102f58$export$e515c2183ed1fdbc.prototype, "logo", void 0);
$db7fbdbee4102f58$export$e515c2183ed1fdbc = $db7fbdbee4102f58$var$__decorate([
    (0, $hdxb6.customElement)("wui-logo")
], $db7fbdbee4102f58$export$e515c2183ed1fdbc);

});
parcelRegister("lI35B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fce01a7eb83d1ffc$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $fce01a7eb83d1ffc$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 40px;\n    height: 40px;\n    border-radius: var(--wui-border-radius-3xl);\n    border: 1px solid var(--wui-color-gray-glass-005);\n    overflow: hidden;\n  }\n\n  wui-icon {\n    width: 100%;\n    height: 100%;\n  }\n"
    ]);
    $fce01a7eb83d1ffc$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $fce01a7eb83d1ffc$export$2e2bcd8739ae039 = (0, $bBWVO.css)($fce01a7eb83d1ffc$var$_templateObject());

});


parcelRegister("k0Q8r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e91c3fb21d64de35$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $e91c3fb21d64de35$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: block;\n    width: 100%;\n  }\n\n  button {\n    width: 100%;\n    height: 56px;\n    background: var(--wui-color-gray-glass-002);\n    border-radius: var(--wui-border-radius-xs);\n  }\n"
    ]);
    $e91c3fb21d64de35$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $e91c3fb21d64de35$export$2e2bcd8739ae039 = (0, $bBWVO.css)($e91c3fb21d64de35$var$_templateObject());

});


parcelRegister("5fLRC", function(module, exports) {

$parcel$export(module.exports, "WuiNetworkButton", function () { return $3d337b3f56a5cc85$export$bb00a3a9463dc4a7; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("9ZbyK");
parcelRequire("1OYaf");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("8jknp");

var $bA1OB = parcelRequire("bA1OB");
function $3d337b3f56a5cc85$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <button data-testid="w3m-network-button" ?disabled=',
        ">\n        ",
        '\n        <wui-text variant="paragraph-600" color="inherit">\n          <slot></slot>\n        </wui-text>\n      </button>\n    '
    ]);
    $3d337b3f56a5cc85$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $3d337b3f56a5cc85$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '\n        <wui-icon-box\n          size="sm"\n          iconColor="error-100"\n          backgroundColor="error-100"\n          icon="warningCircle"\n        ></wui-icon-box>\n      '
    ]);
    $3d337b3f56a5cc85$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $3d337b3f56a5cc85$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "<wui-image src=",
        "></wui-image>"
    ]);
    $3d337b3f56a5cc85$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $3d337b3f56a5cc85$var$_templateObject3() {
    var data = (0, $j06k0._)([
        '\n      <wui-icon-box\n        size="sm"\n        iconColor="inverse-100"\n        backgroundColor="fg-100"\n        icon="networkPlaceholder"\n      ></wui-icon-box>\n    '
    ]);
    $3d337b3f56a5cc85$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var $3d337b3f56a5cc85$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $3d337b3f56a5cc85$export$bb00a3a9463dc4a7 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiNetworkButton, LitElement);
    var _super = (0, $ohfOJ._)(WuiNetworkButton);
    function WuiNetworkButton() {
        (0, $4GJKx._)(this, WuiNetworkButton);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.imageSrc = undefined;
        _this.isUnsupportedChain = undefined;
        _this.disabled = false;
        return _this;
    }
    (0, $1wc17._)(WuiNetworkButton, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($3d337b3f56a5cc85$var$_templateObject(), this.disabled, this.visualTemplate());
            }
        },
        {
            key: "visualTemplate",
            value: function visualTemplate() {
                if (this.isUnsupportedChain) return (0, $1lUIm.html)($3d337b3f56a5cc85$var$_templateObject1());
                if (this.imageSrc) return (0, $1lUIm.html)($3d337b3f56a5cc85$var$_templateObject2(), this.imageSrc);
                return (0, $1lUIm.html)($3d337b3f56a5cc85$var$_templateObject3());
            }
        }
    ]);
    return WuiNetworkButton;
}((0, $eAsDt.LitElement));
$3d337b3f56a5cc85$export$bb00a3a9463dc4a7.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $bA1OB.default)
];
$3d337b3f56a5cc85$var$__decorate([
    (0, $siQym.property)()
], $3d337b3f56a5cc85$export$bb00a3a9463dc4a7.prototype, "imageSrc", void 0);
$3d337b3f56a5cc85$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $3d337b3f56a5cc85$export$bb00a3a9463dc4a7.prototype, "isUnsupportedChain", void 0);
$3d337b3f56a5cc85$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $3d337b3f56a5cc85$export$bb00a3a9463dc4a7.prototype, "disabled", void 0);
$3d337b3f56a5cc85$export$bb00a3a9463dc4a7 = $3d337b3f56a5cc85$var$__decorate([
    (0, $hdxb6.customElement)("wui-network-button")
], $3d337b3f56a5cc85$export$bb00a3a9463dc4a7);

});
parcelRegister("bA1OB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86e476f917c0e7c7$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $86e476f917c0e7c7$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: block;\n  }\n\n  button {\n    border-radius: var(--wui-border-radius-3xl);\n    display: flex;\n    gap: var(--wui-spacing-xs);\n    padding: var(--wui-spacing-2xs) var(--wui-spacing-s) var(--wui-spacing-2xs)\n      var(--wui-spacing-xs);\n    border: 1px solid var(--wui-color-gray-glass-010);\n    background-color: var(--wui-color-gray-glass-005);\n    color: var(--wui-color-fg-100);\n  }\n\n  button:disabled {\n    border: 1px solid var(--wui-color-gray-glass-005);\n    background-color: var(--wui-color-gray-glass-015);\n    color: var(--wui-color-gray-glass-015);\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    button:hover:enabled {\n      background-color: var(--wui-color-gray-glass-010);\n    }\n\n    button:active:enabled {\n      background-color: var(--wui-color-gray-glass-015);\n    }\n  }\n\n  wui-image,\n  wui-icon-box {\n    border-radius: var(--wui-border-radius-3xl);\n    width: 24px;\n    height: 24px;\n    box-shadow: 0 0 0 2px var(--wui-color-gray-glass-005);\n  }\n"
    ]);
    $86e476f917c0e7c7$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $86e476f917c0e7c7$export$2e2bcd8739ae039 = (0, $bBWVO.css)($86e476f917c0e7c7$var$_templateObject());

});


parcelRegister("cE4SE", function(module, exports) {

$parcel$export(module.exports, "WuiOtp", function () { return $934d01a3606ee553$export$443bf27d3bf7bc18; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
var $6DAI1 = parcelRequire("6DAI1");
parcelRequire("8tnK2");

var $kYNxm = parcelRequire("kYNxm");

var $dI7zX = parcelRequire("dI7zX");

var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("cMI92");

var $fZj2O = parcelRequire("fZj2O");
function $934d01a3606ee553$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n            <wui-input-numeric\n              @input=",
        "\n              @click=",
        "\n              @keydown=",
        "\n              .disabled=",
        "\n              .value=",
        "\n            >\n            </wui-input-numeric>\n          "
    ]);
    $934d01a3606ee553$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $934d01a3606ee553$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex gap="xxs" data-testid="wui-otp-input">\n        ',
        "\n      </wui-flex>\n    "
    ]);
    $934d01a3606ee553$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $934d01a3606ee553$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $934d01a3606ee553$export$443bf27d3bf7bc18 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiOtp, LitElement);
    var _super = (0, $ohfOJ._)(WuiOtp);
    function WuiOtp() {
        (0, $4GJKx._)(this, WuiOtp);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.length = 6;
        _this.otp = "";
        _this.values = Array.from({
            length: _this.length
        }).map(function() {
            return "";
        });
        _this.numerics = [];
        _this.shouldInputBeEnabled = function(index) {
            var previousInputs = _this.values.slice(0, index);
            return previousInputs.every(function(input) {
                return input !== "";
            });
        };
        _this.handleKeyDown = function(e, index) {
            var inputElement = e.target;
            var input = _this.getInputElement(inputElement);
            var keyArr = [
                "ArrowLeft",
                "ArrowRight",
                "Shift",
                "Delete"
            ];
            if (!input) return;
            if (keyArr.includes(e.key)) e.preventDefault();
            var currentCaretPos = input.selectionStart;
            switch(e.key){
                case "ArrowLeft":
                    if (currentCaretPos) input.setSelectionRange(currentCaretPos + 1, currentCaretPos + 1);
                    _this.focusInputField("prev", index);
                    break;
                case "ArrowRight":
                    _this.focusInputField("next", index);
                    break;
                case "Shift":
                    _this.focusInputField("next", index);
                    break;
                case "Delete":
                    if (input.value === "") _this.focusInputField("prev", index);
                    else _this.updateInput(input, index, "");
                    break;
                case "Backspace":
                    if (input.value === "") _this.focusInputField("prev", index);
                    else _this.updateInput(input, index, "");
                    break;
                default:
            }
        };
        _this.focusInputField = function(dir, index) {
            if (dir === "next") {
                var nextIndex = index + 1;
                if (!_this.shouldInputBeEnabled(nextIndex)) return;
                var numeric = _this.numerics[nextIndex < _this.length ? nextIndex : index];
                var input = numeric ? _this.getInputElement(numeric) : undefined;
                if (input) {
                    input.disabled = false;
                    input.focus();
                }
            }
            if (dir === "prev") {
                var nextIndex1 = index - 1;
                var numeric1 = _this.numerics[nextIndex1 > -1 ? nextIndex1 : index];
                var input1 = numeric1 ? _this.getInputElement(numeric1) : undefined;
                if (input1) input1.focus();
            }
        };
        return _this;
    }
    (0, $1wc17._)(WuiOtp, [
        {
            key: "firstUpdated",
            value: function firstUpdated() {
                var _this_shadowRoot, _this_numerics_;
                if (this.otp) this.values = this.otp.split("");
                var numericElements = (_this_shadowRoot = this.shadowRoot) === null || _this_shadowRoot === void 0 ? void 0 : _this_shadowRoot.querySelectorAll("wui-input-numeric");
                if (numericElements) this.numerics = Array.from(numericElements);
                (_this_numerics_ = this.numerics[0]) === null || _this_numerics_ === void 0 ? void 0 : _this_numerics_.focus();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                return (0, $1lUIm.html)($934d01a3606ee553$var$_templateObject1(), Array.from({
                    length: this.length
                }).map(function(_, index) {
                    return (0, $1lUIm.html)($934d01a3606ee553$var$_templateObject(), function(e) {
                        return _this.handleInput(e, index);
                    }, function(e) {
                        return _this.selectInput(e);
                    }, function(e) {
                        return _this.handleKeyDown(e, index);
                    }, !_this.shouldInputBeEnabled(index), _this.values[index] || "");
                }));
            }
        },
        {
            key: "updateInput",
            value: function updateInput(element, index, value) {
                var numeric = this.numerics[index];
                var input = element || (numeric ? this.getInputElement(numeric) : undefined);
                if (input) {
                    input.value = value;
                    this.values = this.values.map(function(val, i) {
                        return i === index ? value : val;
                    });
                }
            }
        },
        {
            key: "selectInput",
            value: function selectInput(e) {
                var targetElement = e.target;
                if (targetElement) {
                    var inputElement = this.getInputElement(targetElement);
                    inputElement === null || inputElement === void 0 ? void 0 : inputElement.select();
                }
            }
        },
        {
            key: "handleInput",
            value: function handleInput(e, index) {
                var inputElement = e.target;
                var input = this.getInputElement(inputElement);
                if (input) {
                    var inputValue = input.value;
                    if (e.inputType === "insertFromPaste") this.handlePaste(input, inputValue, index);
                    else {
                        var isValid = (0, $dI7zX.UiHelperUtil).isNumber(inputValue);
                        if (isValid && e.data) {
                            this.updateInput(input, index, e.data);
                            this.focusInputField("next", index);
                        } else this.updateInput(input, index, "");
                    }
                }
                this.dispatchInputChangeEvent();
            }
        },
        {
            key: "handlePaste",
            value: function handlePaste(input, inputValue, index) {
                var value = inputValue[0];
                var isValid = value && (0, $dI7zX.UiHelperUtil).isNumber(value);
                if (isValid) {
                    this.updateInput(input, index, value);
                    var inputString = inputValue.substring(1);
                    if (index + 1 < this.length && inputString.length) {
                        var nextNumeric = this.numerics[index + 1];
                        var nextInput = nextNumeric ? this.getInputElement(nextNumeric) : undefined;
                        if (nextInput) this.handlePaste(nextInput, inputString, index + 1);
                    } else this.focusInputField("next", index);
                } else this.updateInput(input, index, "");
            }
        },
        {
            key: "getInputElement",
            value: function getInputElement(el) {
                var _el_shadowRoot;
                if ((_el_shadowRoot = el.shadowRoot) === null || _el_shadowRoot === void 0 ? void 0 : _el_shadowRoot.querySelector("input")) return el.shadowRoot.querySelector("input");
                return null;
            }
        },
        {
            key: "dispatchInputChangeEvent",
            value: function dispatchInputChangeEvent() {
                var value = this.values.join("");
                this.dispatchEvent(new CustomEvent("inputChange", {
                    detail: value,
                    bubbles: true,
                    composed: true
                }));
            }
        }
    ]);
    return WuiOtp;
}((0, $eAsDt.LitElement));
$934d01a3606ee553$export$443bf27d3bf7bc18.styles = [
    (0, $kYNxm.resetStyles),
    (0, $fZj2O.default)
];
$934d01a3606ee553$var$__decorate([
    (0, $siQym.property)({
        type: Number
    })
], $934d01a3606ee553$export$443bf27d3bf7bc18.prototype, "length", void 0);
$934d01a3606ee553$var$__decorate([
    (0, $siQym.property)({
        type: String
    })
], $934d01a3606ee553$export$443bf27d3bf7bc18.prototype, "otp", void 0);
$934d01a3606ee553$var$__decorate([
    (0, $6DAI1.state)()
], $934d01a3606ee553$export$443bf27d3bf7bc18.prototype, "values", void 0);
$934d01a3606ee553$export$443bf27d3bf7bc18 = $934d01a3606ee553$var$__decorate([
    (0, $hdxb6.customElement)("wui-otp")
], $934d01a3606ee553$export$443bf27d3bf7bc18);

});
parcelRegister("fZj2O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba3b5351676f0f3b$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $ba3b5351676f0f3b$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    position: relative;\n    display: block;\n  }\n"
    ]);
    $ba3b5351676f0f3b$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $ba3b5351676f0f3b$export$2e2bcd8739ae039 = (0, $bBWVO.css)($ba3b5351676f0f3b$var$_templateObject());

});


parcelRegister("7Clql", function(module, exports) {

$parcel$export(module.exports, "WuiQrCode", function () { return $58bcb35fe789c45c$export$29f6e16532a663bf; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("dcd5U");
parcelRequire("9ZbyK");

var $gXmMD = parcelRequire("gXmMD");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $gCOCT = parcelRequire("gCOCT");
function $58bcb35fe789c45c$var$_templateObject() {
    var data = (0, $j06k0._)([
        "",
        " ",
        ""
    ]);
    $58bcb35fe789c45c$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $58bcb35fe789c45c$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "\n      <svg height=",
        " width=",
        ">\n        ",
        "\n      </svg>\n    "
    ]);
    $58bcb35fe789c45c$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $58bcb35fe789c45c$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "<wui-image src=",
        " alt=",
        "></wui-image>"
    ]);
    $58bcb35fe789c45c$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $58bcb35fe789c45c$var$_templateObject3() {
    var data = (0, $j06k0._)([
        '<wui-icon\n        class="farcaster"\n        size="inherit"\n        color="inherit"\n        name="farcaster"\n      ></wui-icon>'
    ]);
    $58bcb35fe789c45c$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $58bcb35fe789c45c$var$_templateObject4() {
    var data = (0, $j06k0._)([
        '<wui-icon size="inherit" color="inherit" name="walletConnect"></wui-icon>'
    ]);
    $58bcb35fe789c45c$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
var $58bcb35fe789c45c$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $58bcb35fe789c45c$export$29f6e16532a663bf = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiQrCode, LitElement);
    var _super = (0, $ohfOJ._)(WuiQrCode);
    function WuiQrCode() {
        (0, $4GJKx._)(this, WuiQrCode);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.uri = "";
        _this.size = 0;
        _this.theme = "dark";
        _this.imageSrc = undefined;
        _this.alt = undefined;
        _this.arenaClear = undefined;
        _this.farcaster = undefined;
        return _this;
    }
    (0, $1wc17._)(WuiQrCode, [
        {
            key: "render",
            value: function render() {
                this.dataset["theme"] = this.theme;
                this.dataset["clear"] = String(this.arenaClear);
                this.style.cssText = "--local-size: ".concat(this.size, "px");
                return (0, $1lUIm.html)($58bcb35fe789c45c$var$_templateObject(), this.templateVisual(), this.templateSvg());
            }
        },
        {
            key: "templateSvg",
            value: function templateSvg() {
                var size = this.theme === "light" ? this.size : this.size - 32;
                return (0, $1lUIm.svg)($58bcb35fe789c45c$var$_templateObject1(), size, size, (0, $gXmMD.QrCodeUtil).generate(this.uri, size, this.arenaClear ? 0 : size / 4));
            }
        },
        {
            key: "templateVisual",
            value: function templateVisual() {
                var _this_alt;
                if (this.imageSrc) return (0, $1lUIm.html)($58bcb35fe789c45c$var$_templateObject2(), this.imageSrc, (_this_alt = this.alt) !== null && _this_alt !== void 0 ? _this_alt : "logo");
                if (this.farcaster) return (0, $1lUIm.html)($58bcb35fe789c45c$var$_templateObject3());
                return (0, $1lUIm.html)($58bcb35fe789c45c$var$_templateObject4());
            }
        }
    ]);
    return WuiQrCode;
}((0, $eAsDt.LitElement));
$58bcb35fe789c45c$export$29f6e16532a663bf.styles = [
    (0, $kYNxm.resetStyles),
    (0, $gCOCT.default)
];
$58bcb35fe789c45c$var$__decorate([
    (0, $siQym.property)()
], $58bcb35fe789c45c$export$29f6e16532a663bf.prototype, "uri", void 0);
$58bcb35fe789c45c$var$__decorate([
    (0, $siQym.property)({
        type: Number
    })
], $58bcb35fe789c45c$export$29f6e16532a663bf.prototype, "size", void 0);
$58bcb35fe789c45c$var$__decorate([
    (0, $siQym.property)()
], $58bcb35fe789c45c$export$29f6e16532a663bf.prototype, "theme", void 0);
$58bcb35fe789c45c$var$__decorate([
    (0, $siQym.property)()
], $58bcb35fe789c45c$export$29f6e16532a663bf.prototype, "imageSrc", void 0);
$58bcb35fe789c45c$var$__decorate([
    (0, $siQym.property)()
], $58bcb35fe789c45c$export$29f6e16532a663bf.prototype, "alt", void 0);
$58bcb35fe789c45c$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $58bcb35fe789c45c$export$29f6e16532a663bf.prototype, "arenaClear", void 0);
$58bcb35fe789c45c$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $58bcb35fe789c45c$export$29f6e16532a663bf.prototype, "farcaster", void 0);
$58bcb35fe789c45c$export$29f6e16532a663bf = $58bcb35fe789c45c$var$__decorate([
    (0, $hdxb6.customElement)("wui-qr-code")
], $58bcb35fe789c45c$export$29f6e16532a663bf);

});
parcelRegister("gXmMD", function(module, exports) {

$parcel$export(module.exports, "QrCodeUtil", function () { return $c583d452ebdbd9c8$export$2faef7998946735; });

var $cv9Rk = parcelRequire("cv9Rk");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");

var $bk8Qn = parcelRequire("bk8Qn");
function $c583d452ebdbd9c8$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n            <rect\n              fill=",
        "\n              width=",
        "\n              rx= ",
        "\n              ry= ",
        "\n              stroke=",
        "\n              stroke-width=",
        "\n              height=",
        "\n              x= ",
        "\n              y= ",
        "\n            />\n          "
    ]);
    $c583d452ebdbd9c8$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $c583d452ebdbd9c8$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "<circle cx=",
        " cy=",
        " fill=",
        " r=",
        " />"
    ]);
    $c583d452ebdbd9c8$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $c583d452ebdbd9c8$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "\n              <line\n                x1=",
        "\n                x2=",
        "\n                y1=",
        "\n                y2=",
        "\n                stroke=",
        "\n                stroke-width=",
        '\n                stroke-linecap="round"\n              />\n            '
    ]);
    $c583d452ebdbd9c8$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $c583d452ebdbd9c8$var$CONNECTING_ERROR_MARGIN = 0.1;
var $c583d452ebdbd9c8$var$CIRCLE_SIZE_MODIFIER = 2.5;
var $c583d452ebdbd9c8$var$QRCODE_MATRIX_MARGIN = 7;
function $c583d452ebdbd9c8$var$isAdjecentDots(cy, otherCy, cellSize) {
    if (cy === otherCy) return false;
    var diff = cy - otherCy < 0 ? otherCy - cy : cy - otherCy;
    return diff <= cellSize + $c583d452ebdbd9c8$var$CONNECTING_ERROR_MARGIN;
}
function $c583d452ebdbd9c8$var$getMatrix(value, errorCorrectionLevel) {
    var arr = Array.prototype.slice.call((0, (/*@__PURE__*/$parcel$interopDefault($bk8Qn))).create(value, {
        errorCorrectionLevel: errorCorrectionLevel
    }).modules.data, 0);
    var sqrt = Math.sqrt(arr.length);
    return arr.reduce(function(rows, key, index) {
        return (index % sqrt === 0 ? rows.push([
            key
        ]) : rows[rows.length - 1].push(key)) && rows;
    }, []);
}
var $c583d452ebdbd9c8$export$2faef7998946735 = {
    generate: function(uri, size, logoSize) {
        var dotColor = "#141414";
        var edgeColor = "transparent";
        var strokeWidth = 5;
        var dots = [];
        var matrix = $c583d452ebdbd9c8$var$getMatrix(uri, "Q");
        var cellSize = size / matrix.length;
        var qrList = [
            {
                x: 0,
                y: 0
            },
            {
                x: 1,
                y: 0
            },
            {
                x: 0,
                y: 1
            }
        ];
        qrList.forEach(function(param) {
            var x = param.x, y = param.y;
            var x1 = (matrix.length - $c583d452ebdbd9c8$var$QRCODE_MATRIX_MARGIN) * cellSize * x;
            var y1 = (matrix.length - $c583d452ebdbd9c8$var$QRCODE_MATRIX_MARGIN) * cellSize * y;
            var borderRadius = 0.45;
            for(var i = 0; i < qrList.length; i += 1){
                var dotSize = cellSize * ($c583d452ebdbd9c8$var$QRCODE_MATRIX_MARGIN - i * 2);
                dots.push((0, $1lUIm.svg)($c583d452ebdbd9c8$var$_templateObject(), i === 2 ? dotColor : edgeColor, i === 0 ? dotSize - strokeWidth : dotSize, i === 0 ? (dotSize - strokeWidth) * borderRadius : dotSize * borderRadius, i === 0 ? (dotSize - strokeWidth) * borderRadius : dotSize * borderRadius, dotColor, i === 0 ? strokeWidth : 0, i === 0 ? dotSize - strokeWidth : dotSize, i === 0 ? y1 + cellSize * i + strokeWidth / 2 : y1 + cellSize * i, i === 0 ? x1 + cellSize * i + strokeWidth / 2 : x1 + cellSize * i));
            }
        });
        var clearArenaSize = Math.floor((logoSize + 25) / cellSize);
        var matrixMiddleStart = matrix.length / 2 - clearArenaSize / 2;
        var matrixMiddleEnd = matrix.length / 2 + clearArenaSize / 2 - 1;
        var circles = [];
        matrix.forEach(function(row, i) {
            row.forEach(function(_, j) {
                if (matrix[i][j]) {
                    if (!(i < $c583d452ebdbd9c8$var$QRCODE_MATRIX_MARGIN && j < $c583d452ebdbd9c8$var$QRCODE_MATRIX_MARGIN || i > matrix.length - ($c583d452ebdbd9c8$var$QRCODE_MATRIX_MARGIN + 1) && j < $c583d452ebdbd9c8$var$QRCODE_MATRIX_MARGIN || i < $c583d452ebdbd9c8$var$QRCODE_MATRIX_MARGIN && j > matrix.length - ($c583d452ebdbd9c8$var$QRCODE_MATRIX_MARGIN + 1))) {
                        if (!(i > matrixMiddleStart && i < matrixMiddleEnd && j > matrixMiddleStart && j < matrixMiddleEnd)) {
                            var cx = i * cellSize + cellSize / 2;
                            var cy = j * cellSize + cellSize / 2;
                            circles.push([
                                cx,
                                cy
                            ]);
                        }
                    }
                }
            });
        });
        var circlesToConnect = {};
        circles.forEach(function(param) {
            var _param = (0, $cv9Rk._)(param, 2), cx = _param[0], cy = _param[1];
            var _circlesToConnect_cx;
            if (circlesToConnect[cx]) (_circlesToConnect_cx = circlesToConnect[cx]) === null || _circlesToConnect_cx === void 0 ? void 0 : _circlesToConnect_cx.push(cy);
            else circlesToConnect[cx] = [
                cy
            ];
        });
        Object.entries(circlesToConnect).map(function(param) {
            var _param = (0, $cv9Rk._)(param, 2), cx = _param[0], cys = _param[1];
            var newCys = cys.filter(function(cy) {
                return cys.every(function(otherCy) {
                    return !$c583d452ebdbd9c8$var$isAdjecentDots(cy, otherCy, cellSize);
                });
            });
            return [
                Number(cx),
                newCys
            ];
        }).forEach(function(param) {
            var _param = (0, $cv9Rk._)(param, 2), cx = _param[0], cys = _param[1];
            cys.forEach(function(cy) {
                dots.push((0, $1lUIm.svg)($c583d452ebdbd9c8$var$_templateObject1(), cx, cy, dotColor, cellSize / $c583d452ebdbd9c8$var$CIRCLE_SIZE_MODIFIER));
            });
        });
        Object.entries(circlesToConnect).filter(function(param) {
            var _param = (0, $cv9Rk._)(param, 2), _ = _param[0], cys = _param[1];
            return cys.length > 1;
        }).map(function(param) {
            var _param = (0, $cv9Rk._)(param, 2), cx = _param[0], cys = _param[1];
            var newCys = cys.filter(function(cy) {
                return cys.some(function(otherCy) {
                    return $c583d452ebdbd9c8$var$isAdjecentDots(cy, otherCy, cellSize);
                });
            });
            return [
                Number(cx),
                newCys
            ];
        }).map(function(param) {
            var _param = (0, $cv9Rk._)(param, 2), cx = _param[0], cys = _param[1];
            cys.sort(function(a, b) {
                return a < b ? -1 : 1;
            });
            var groups = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                var _loop = function() {
                    var cy = _step.value;
                    var group = groups.find(function(item) {
                        return item.some(function(otherCy) {
                            return $c583d452ebdbd9c8$var$isAdjecentDots(cy, otherCy, cellSize);
                        });
                    });
                    if (group) group.push(cy);
                    else groups.push([
                        cy
                    ]);
                };
                for(var _iterator = cys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return [
                cx,
                groups.map(function(item) {
                    return [
                        item[0],
                        item[item.length - 1]
                    ];
                })
            ];
        }).forEach(function(param) {
            var _param = (0, $cv9Rk._)(param, 2), cx = _param[0], groups = _param[1];
            groups.forEach(function(param) {
                var _param = (0, $cv9Rk._)(param, 2), y1 = _param[0], y2 = _param[1];
                dots.push((0, $1lUIm.svg)($c583d452ebdbd9c8$var$_templateObject2(), cx, cx, y1, y2, dotColor, cellSize / ($c583d452ebdbd9c8$var$CIRCLE_SIZE_MODIFIER / 2)));
            });
        });
        return dots;
    }
};

});
parcelRegister("bk8Qn", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $83e86c29f2ef04e8$export$185802fd694ee1f5; }, function (v) { return $83e86c29f2ef04e8$export$185802fd694ee1f5 = v; });
$parcel$export(module.exports, "toCanvas", function () { return $83e86c29f2ef04e8$export$f87f6982d1fd4f81; }, function (v) { return $83e86c29f2ef04e8$export$f87f6982d1fd4f81 = v; });
$parcel$export(module.exports, "toDataURL", function () { return $83e86c29f2ef04e8$export$723e4939e5a27c8; }, function (v) { return $83e86c29f2ef04e8$export$723e4939e5a27c8 = v; });
$parcel$export(module.exports, "toString", function () { return $83e86c29f2ef04e8$export$f84e8e69fd4488a5; }, function (v) { return $83e86c29f2ef04e8$export$f84e8e69fd4488a5 = v; });
var $83e86c29f2ef04e8$export$185802fd694ee1f5;
var $83e86c29f2ef04e8$export$f87f6982d1fd4f81;
var $83e86c29f2ef04e8$export$723e4939e5a27c8;
// only svg for now.
var $83e86c29f2ef04e8$export$f84e8e69fd4488a5;

var $WlTNf = parcelRequire("WlTNf");

var $eLn0y = parcelRequire("eLn0y");

var $1ZVJr = parcelRequire("1ZVJr");

var $cRaam = parcelRequire("cRaam");
function $83e86c29f2ef04e8$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    var args = [].slice.call(arguments, 1);
    var argsNum = args.length;
    var isLastArgCb = typeof args[argsNum - 1] === "function";
    if (!isLastArgCb && !$WlTNf()) throw new Error("Callback required as last argument");
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error("Too few arguments provided");
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === "undefined") {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error("Too few arguments provided");
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                var data = $eLn0y.create(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        var data = $eLn0y.create(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$83e86c29f2ef04e8$export$185802fd694ee1f5 = $eLn0y.create;
$83e86c29f2ef04e8$export$f87f6982d1fd4f81 = $83e86c29f2ef04e8$var$renderCanvas.bind(null, $1ZVJr.render);
$83e86c29f2ef04e8$export$723e4939e5a27c8 = $83e86c29f2ef04e8$var$renderCanvas.bind(null, $1ZVJr.renderToDataURL);
$83e86c29f2ef04e8$export$f84e8e69fd4488a5 = $83e86c29f2ef04e8$var$renderCanvas.bind(null, function(data, _, opts) {
    return $cRaam.render(data, opts);
});

});
parcelRegister("WlTNf", function(module, exports) {
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
module.exports = function() {
    return typeof Promise === "function" && Promise.prototype && Promise.prototype.then;
};

});

parcelRegister("eLn0y", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $abf74d5eeeab7c35$export$185802fd694ee1f5; }, function (v) { return $abf74d5eeeab7c35$export$185802fd694ee1f5 = v; });
/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $abf74d5eeeab7c35$export$185802fd694ee1f5;

var $am8JH = parcelRequire("am8JH");

var $9BZm5 = parcelRequire("9BZm5");

var $hDXw1 = parcelRequire("hDXw1");

var $eTNNj = parcelRequire("eTNNj");

var $6uZft = parcelRequire("6uZft");

var $h24W0 = parcelRequire("h24W0");

var $bujmJ = parcelRequire("bujmJ");

var $43LoF = parcelRequire("43LoF");

var $lhiw3 = parcelRequire("lhiw3");

var $4sGnJ = parcelRequire("4sGnJ");

var $jZAiS = parcelRequire("jZAiS");

var $4RD3g = parcelRequire("4RD3g");

var $dVCGS = parcelRequire("dVCGS");
/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $abf74d5eeeab7c35$var$setupFinderPattern(matrix, version) {
    var size = matrix.size;
    var pos = $h24W0.getPositions(version);
    for(var i = 0; i < pos.length; i++){
        var row = pos[i][0];
        var col = pos[i][1];
        for(var r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(var c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $abf74d5eeeab7c35$var$setupTimingPattern(matrix) {
    var size = matrix.size;
    for(var r = 8; r < size - 8; r++){
        var value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $abf74d5eeeab7c35$var$setupAlignmentPattern(matrix, version) {
    var pos = $6uZft.getPositions(version);
    for(var i = 0; i < pos.length; i++){
        var row = pos[i][0];
        var col = pos[i][1];
        for(var r = -2; r <= 2; r++){
            for(var c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $abf74d5eeeab7c35$var$setupVersionInfo(matrix, version) {
    var size = matrix.size;
    var bits = $4sGnJ.getEncodedBits(version);
    var row, col, mod;
    for(var i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $abf74d5eeeab7c35$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    var size = matrix.size;
    var bits = $jZAiS.getEncodedBits(errorCorrectionLevel, maskPattern);
    var i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $abf74d5eeeab7c35$var$setupData(matrix, data) {
    var size = matrix.size;
    var inc = -1;
    var row = size - 1;
    var bitIndex = 7;
    var byteIndex = 0;
    for(var col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(var c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                var dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $abf74d5eeeab7c35$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    var buffer = new $hDXw1();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $4RD3g.getCharCountIndicator(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    var totalCodewords = $am8JH.getSymbolTotalCodewords(version);
    var ecTotalCodewords = $43LoF.getTotalCodewordsCount(version, errorCorrectionLevel);
    var dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    var remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(var i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $abf74d5eeeab7c35$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $abf74d5eeeab7c35$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    var totalCodewords = $am8JH.getSymbolTotalCodewords(version);
    // Total number of error correction codewords
    var ecTotalCodewords = $43LoF.getTotalCodewordsCount(version, errorCorrectionLevel);
    // Total number of data codewords
    var dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    var ecTotalBlocks = $43LoF.getBlocksCount(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    var blocksInGroup2 = totalCodewords % ecTotalBlocks;
    var blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    var totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    var dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    var dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    var ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    var rs = new $lhiw3(ecCount);
    var offset = 0;
    var dcData = new Array(ecTotalBlocks);
    var ecData = new Array(ecTotalBlocks);
    var maxDataSize = 0;
    var buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(var b = 0; b < ecTotalBlocks; b++){
        var dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    var data = new Uint8Array(totalCodewords);
    var index = 0;
    var i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $abf74d5eeeab7c35$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    var segments;
    if (Array.isArray(data)) segments = $dVCGS.fromArray(data);
    else if (typeof data === "string") {
        var estimatedVersion = version;
        if (!estimatedVersion) {
            var rawSegments = $dVCGS.rawSplit(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $4sGnJ.getBestVersionForData(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $dVCGS.fromString(data, estimatedVersion || 40);
    } else throw new Error("Invalid data");
    // Get the min version that can contain data
    var bestVersion = $4sGnJ.getBestVersionForData(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error("The amount of data is too big to be stored in a QR Code");
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + ".\n");
    var dataBits = $abf74d5eeeab7c35$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    var moduleCount = $am8JH.getSymbolSize(version);
    var modules = new $eTNNj(moduleCount);
    // Add function modules
    $abf74d5eeeab7c35$var$setupFinderPattern(modules, version);
    $abf74d5eeeab7c35$var$setupTimingPattern(modules);
    $abf74d5eeeab7c35$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $abf74d5eeeab7c35$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $abf74d5eeeab7c35$var$setupVersionInfo(modules, version);
    // Add data codewords
    $abf74d5eeeab7c35$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $bujmJ.getBestMask(modules, $abf74d5eeeab7c35$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $bujmJ.applyMask(maskPattern, modules);
    // Replace format info bits with correct values
    $abf74d5eeeab7c35$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$abf74d5eeeab7c35$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === "undefined" || data === "") throw new Error("No input text");
    var errorCorrectionLevel = $9BZm5.M;
    var version;
    var mask;
    if (typeof options !== "undefined") {
        // Use higher error correction level as default
        errorCorrectionLevel = $9BZm5.from(options.errorCorrectionLevel, $9BZm5.M);
        version = $4sGnJ.from(options.version);
        mask = $bujmJ.from(options.maskPattern);
        if (options.toSJISFunc) $am8JH.setToSJISFunction(options.toSJISFunc);
    }
    return $abf74d5eeeab7c35$var$createSymbol(data, version, errorCorrectionLevel, mask);
};

});
parcelRegister("am8JH", function(module, exports) {

$parcel$export(module.exports, "getSymbolSize", function () { return $78a2bc3f2bbe85f1$export$8d4a06d3facd414b; }, function (v) { return $78a2bc3f2bbe85f1$export$8d4a06d3facd414b = v; });
$parcel$export(module.exports, "getSymbolTotalCodewords", function () { return $78a2bc3f2bbe85f1$export$b05dac13c7a35c32; }, function (v) { return $78a2bc3f2bbe85f1$export$b05dac13c7a35c32 = v; });
$parcel$export(module.exports, "getBCHDigit", function () { return $78a2bc3f2bbe85f1$export$ed1d66da50968976; }, function (v) { return $78a2bc3f2bbe85f1$export$ed1d66da50968976 = v; });
$parcel$export(module.exports, "setToSJISFunction", function () { return $78a2bc3f2bbe85f1$export$6733b14783f975c2; }, function (v) { return $78a2bc3f2bbe85f1$export$6733b14783f975c2 = v; });
$parcel$export(module.exports, "isKanjiModeEnabled", function () { return $78a2bc3f2bbe85f1$export$ce5b1274f8597fa0; }, function (v) { return $78a2bc3f2bbe85f1$export$ce5b1274f8597fa0 = v; });
$parcel$export(module.exports, "toSJIS", function () { return $78a2bc3f2bbe85f1$export$43dd553ecded716d; }, function (v) { return $78a2bc3f2bbe85f1$export$43dd553ecded716d = v; });
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $78a2bc3f2bbe85f1$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $78a2bc3f2bbe85f1$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $78a2bc3f2bbe85f1$export$ed1d66da50968976;
var $78a2bc3f2bbe85f1$export$6733b14783f975c2;
var $78a2bc3f2bbe85f1$export$ce5b1274f8597fa0;
var $78a2bc3f2bbe85f1$export$43dd553ecded716d;
var $78a2bc3f2bbe85f1$var$toSJISFunction;
var $78a2bc3f2bbe85f1$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$78a2bc3f2bbe85f1$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$78a2bc3f2bbe85f1$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $78a2bc3f2bbe85f1$var$CODEWORDS_COUNT[version];
};
$78a2bc3f2bbe85f1$export$ed1d66da50968976 = function(data) {
    var digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$78a2bc3f2bbe85f1$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== "function") throw new Error('"toSJISFunc" is not a valid function.');
    $78a2bc3f2bbe85f1$var$toSJISFunction = f;
};
$78a2bc3f2bbe85f1$export$ce5b1274f8597fa0 = function() {
    return typeof $78a2bc3f2bbe85f1$var$toSJISFunction !== "undefined";
};
$78a2bc3f2bbe85f1$export$43dd553ecded716d = function toSJIS(kanji) {
    return $78a2bc3f2bbe85f1$var$toSJISFunction(kanji);
};

});

parcelRegister("9BZm5", function(module, exports) {

$parcel$export(module.exports, "L", function () { return $6ff729a0ccaf6baf$export$61196ced6d74a310; }, function (v) { return $6ff729a0ccaf6baf$export$61196ced6d74a310 = v; });
$parcel$export(module.exports, "M", function () { return $6ff729a0ccaf6baf$export$3a1a48c8f6ef640e; }, function (v) { return $6ff729a0ccaf6baf$export$3a1a48c8f6ef640e = v; });
$parcel$export(module.exports, "Q", function () { return $6ff729a0ccaf6baf$export$3722cfe417b6ed86; }, function (v) { return $6ff729a0ccaf6baf$export$3722cfe417b6ed86 = v; });
$parcel$export(module.exports, "H", function () { return $6ff729a0ccaf6baf$export$7f8ddf7c7c20b3cd; }, function (v) { return $6ff729a0ccaf6baf$export$7f8ddf7c7c20b3cd = v; });
$parcel$export(module.exports, "isValid", function () { return $6ff729a0ccaf6baf$export$1ea939691cdc45b8; }, function (v) { return $6ff729a0ccaf6baf$export$1ea939691cdc45b8 = v; });
$parcel$export(module.exports, "from", function () { return $6ff729a0ccaf6baf$export$6788812c4e6611e6; }, function (v) { return $6ff729a0ccaf6baf$export$6788812c4e6611e6 = v; });
var $6ff729a0ccaf6baf$export$61196ced6d74a310;
var $6ff729a0ccaf6baf$export$3a1a48c8f6ef640e;
var $6ff729a0ccaf6baf$export$3722cfe417b6ed86;
var $6ff729a0ccaf6baf$export$7f8ddf7c7c20b3cd;
var $6ff729a0ccaf6baf$export$1ea939691cdc45b8;
var $6ff729a0ccaf6baf$export$6788812c4e6611e6;
$6ff729a0ccaf6baf$export$61196ced6d74a310 = {
    bit: 1
};
$6ff729a0ccaf6baf$export$3a1a48c8f6ef640e = {
    bit: 0
};
$6ff729a0ccaf6baf$export$3722cfe417b6ed86 = {
    bit: 3
};
$6ff729a0ccaf6baf$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $6ff729a0ccaf6baf$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    var lcStr = string.toLowerCase();
    switch(lcStr){
        case "l":
        case "low":
            return $6ff729a0ccaf6baf$export$61196ced6d74a310;
        case "m":
        case "medium":
            return $6ff729a0ccaf6baf$export$3a1a48c8f6ef640e;
        case "q":
        case "quartile":
            return $6ff729a0ccaf6baf$export$3722cfe417b6ed86;
        case "h":
        case "high":
            return $6ff729a0ccaf6baf$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error("Unknown EC Level: " + string);
    }
}
$6ff729a0ccaf6baf$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== "undefined" && level.bit >= 0 && level.bit < 4;
};
$6ff729a0ccaf6baf$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($6ff729a0ccaf6baf$export$1ea939691cdc45b8(value)) return value;
    try {
        return $6ff729a0ccaf6baf$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};

});

parcelRegister("hDXw1", function(module, exports) {
function $cd843eb981099c8a$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$cd843eb981099c8a$var$BitBuffer.prototype = {
    get: function get(index) {
        var bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function put(num, length) {
        for(var i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function getLengthInBits() {
        return this.length;
    },
    putBit: function putBit(bit) {
        var bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
module.exports = $cd843eb981099c8a$var$BitBuffer;

});

parcelRegister("eTNNj", function(module, exports) {
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $ad8cd3d7ee65783a$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $ad8cd3d7ee65783a$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    var index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $ad8cd3d7ee65783a$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $ad8cd3d7ee65783a$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $ad8cd3d7ee65783a$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
module.exports = $ad8cd3d7ee65783a$var$BitMatrix;

});

parcelRegister("6uZft", function(module, exports) {

$parcel$export(module.exports, "getRowColCoords", function () { return $4bb50e21ba2a611c$export$cb05537eb8e57a83; }, function (v) { return $4bb50e21ba2a611c$export$cb05537eb8e57a83 = v; });
$parcel$export(module.exports, "getPositions", function () { return $4bb50e21ba2a611c$export$c39457c570f2b189; }, function (v) { return $4bb50e21ba2a611c$export$c39457c570f2b189 = v; });
/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $4bb50e21ba2a611c$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $4bb50e21ba2a611c$export$c39457c570f2b189;

var $am8JH = parcelRequire("am8JH");
var $4bb50e21ba2a611c$require$getSymbolSize = $am8JH.getSymbolSize;
$4bb50e21ba2a611c$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    var posCount = Math.floor(version / 7) + 2;
    var size = $4bb50e21ba2a611c$require$getSymbolSize(version);
    var intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    var positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(var i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$4bb50e21ba2a611c$export$c39457c570f2b189 = function getPositions(version) {
    var coords = [];
    var pos = $4bb50e21ba2a611c$export$cb05537eb8e57a83(version);
    var posLength = pos.length;
    for(var i = 0; i < posLength; i++)for(var j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};

});

parcelRegister("h24W0", function(module, exports) {

$parcel$export(module.exports, "getPositions", function () { return $c66673768e73a3b1$export$c39457c570f2b189; }, function (v) { return $c66673768e73a3b1$export$c39457c570f2b189 = v; });
/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $c66673768e73a3b1$export$c39457c570f2b189;

var $am8JH = parcelRequire("am8JH");
var $c66673768e73a3b1$require$getSymbolSize = $am8JH.getSymbolSize;
var $c66673768e73a3b1$var$FINDER_PATTERN_SIZE = 7;
$c66673768e73a3b1$export$c39457c570f2b189 = function getPositions(version) {
    var size = $c66673768e73a3b1$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $c66673768e73a3b1$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $c66673768e73a3b1$var$FINDER_PATTERN_SIZE
        ]
    ];
};

});

parcelRegister("bujmJ", function(module, exports) {

$parcel$export(module.exports, "Patterns", function () { return $85d184aa378132a1$export$7ed115685df827af; }, function (v) { return $85d184aa378132a1$export$7ed115685df827af = v; });
$parcel$export(module.exports, "isValid", function () { return $85d184aa378132a1$export$1ea939691cdc45b8; }, function (v) { return $85d184aa378132a1$export$1ea939691cdc45b8 = v; });
$parcel$export(module.exports, "from", function () { return $85d184aa378132a1$export$6788812c4e6611e6; }, function (v) { return $85d184aa378132a1$export$6788812c4e6611e6 = v; });
$parcel$export(module.exports, "getPenaltyN1", function () { return $85d184aa378132a1$export$a5fd3a02c14d0b3e; }, function (v) { return $85d184aa378132a1$export$a5fd3a02c14d0b3e = v; });
$parcel$export(module.exports, "getPenaltyN2", function () { return $85d184aa378132a1$export$9a9385107a518e46; }, function (v) { return $85d184aa378132a1$export$9a9385107a518e46 = v; });
$parcel$export(module.exports, "getPenaltyN3", function () { return $85d184aa378132a1$export$ade754353f0dc75e; }, function (v) { return $85d184aa378132a1$export$ade754353f0dc75e = v; });
$parcel$export(module.exports, "getPenaltyN4", function () { return $85d184aa378132a1$export$3ff6f04d40d9962b; }, function (v) { return $85d184aa378132a1$export$3ff6f04d40d9962b = v; });
$parcel$export(module.exports, "applyMask", function () { return $85d184aa378132a1$export$a1c9aa9c0e8ba394; }, function (v) { return $85d184aa378132a1$export$a1c9aa9c0e8ba394 = v; });
$parcel$export(module.exports, "getBestMask", function () { return $85d184aa378132a1$export$fe9625aaceb0e563; }, function (v) { return $85d184aa378132a1$export$fe9625aaceb0e563 = v; });
/**
 * Data mask pattern reference
 * @type {Object}
 */ var $85d184aa378132a1$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $85d184aa378132a1$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $85d184aa378132a1$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $85d184aa378132a1$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $85d184aa378132a1$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $85d184aa378132a1$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $85d184aa378132a1$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $85d184aa378132a1$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $85d184aa378132a1$export$fe9625aaceb0e563;
$85d184aa378132a1$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ var $85d184aa378132a1$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$85d184aa378132a1$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== "" && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$85d184aa378132a1$export$6788812c4e6611e6 = function from(value) {
    return $85d184aa378132a1$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$85d184aa378132a1$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    var size = data.size;
    var points = 0;
    var sameCountCol = 0;
    var sameCountRow = 0;
    var lastCol = null;
    var lastRow = null;
    for(var row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(var col = 0; col < size; col++){
            var module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $85d184aa378132a1$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $85d184aa378132a1$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $85d184aa378132a1$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $85d184aa378132a1$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$85d184aa378132a1$export$9a9385107a518e46 = function getPenaltyN2(data) {
    var size = data.size;
    var points = 0;
    for(var row = 0; row < size - 1; row++)for(var col = 0; col < size - 1; col++){
        var last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $85d184aa378132a1$var$PenaltyScores.N2;
};
$85d184aa378132a1$export$ade754353f0dc75e = function getPenaltyN3(data) {
    var size = data.size;
    var points = 0;
    var bitsCol = 0;
    var bitsRow = 0;
    for(var row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(var col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $85d184aa378132a1$var$PenaltyScores.N3;
};
$85d184aa378132a1$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    var darkCount = 0;
    var modulesCount = data.data.length;
    for(var i = 0; i < modulesCount; i++)darkCount += data.data[i];
    var k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $85d184aa378132a1$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $85d184aa378132a1$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $85d184aa378132a1$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $85d184aa378132a1$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $85d184aa378132a1$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $85d184aa378132a1$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $85d184aa378132a1$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $85d184aa378132a1$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $85d184aa378132a1$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $85d184aa378132a1$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error("bad maskPattern:" + maskPattern);
    }
}
$85d184aa378132a1$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    var size = data.size;
    for(var col = 0; col < size; col++)for(var row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $85d184aa378132a1$var$getMaskAt(pattern, row, col));
    }
};
$85d184aa378132a1$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    var numPatterns = Object.keys($85d184aa378132a1$export$7ed115685df827af).length;
    var bestPattern = 0;
    var lowerPenalty = Infinity;
    for(var p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $85d184aa378132a1$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        var penalty = $85d184aa378132a1$export$a5fd3a02c14d0b3e(data) + $85d184aa378132a1$export$9a9385107a518e46(data) + $85d184aa378132a1$export$ade754353f0dc75e(data) + $85d184aa378132a1$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $85d184aa378132a1$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};

});

parcelRegister("43LoF", function(module, exports) {

$parcel$export(module.exports, "getBlocksCount", function () { return $2f4c354a1ca89ee4$export$41a1fc627aca72b9; }, function (v) { return $2f4c354a1ca89ee4$export$41a1fc627aca72b9 = v; });
$parcel$export(module.exports, "getTotalCodewordsCount", function () { return $2f4c354a1ca89ee4$export$683d1b3e8a1a8438; }, function (v) { return $2f4c354a1ca89ee4$export$683d1b3e8a1a8438 = v; });
/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $2f4c354a1ca89ee4$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $2f4c354a1ca89ee4$export$683d1b3e8a1a8438;

var $9BZm5 = parcelRequire("9BZm5");
var $2f4c354a1ca89ee4$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
var $2f4c354a1ca89ee4$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$2f4c354a1ca89ee4$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $9BZm5.L:
            return $2f4c354a1ca89ee4$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $9BZm5.M:
            return $2f4c354a1ca89ee4$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $9BZm5.Q:
            return $2f4c354a1ca89ee4$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $9BZm5.H:
            return $2f4c354a1ca89ee4$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$2f4c354a1ca89ee4$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $9BZm5.L:
            return $2f4c354a1ca89ee4$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $9BZm5.M:
            return $2f4c354a1ca89ee4$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $9BZm5.Q:
            return $2f4c354a1ca89ee4$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $9BZm5.H:
            return $2f4c354a1ca89ee4$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};

});

parcelRegister("lhiw3", function(module, exports) {

var $fffqn = parcelRequire("fffqn");
function $f7d98c6671f1c452$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $f7d98c6671f1c452$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $fffqn.generateECPolynomial(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $f7d98c6671f1c452$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error("Encoder not initialized");
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    var paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    var remainder = $fffqn.mod(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    var start = this.degree - remainder.length;
    if (start > 0) {
        var buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
module.exports = $f7d98c6671f1c452$var$ReedSolomonEncoder;

});
parcelRegister("fffqn", function(module, exports) {

$parcel$export(module.exports, "mul", function () { return $b19438b06d7ad1dc$export$6e3a27864ab166fe; }, function (v) { return $b19438b06d7ad1dc$export$6e3a27864ab166fe = v; });
$parcel$export(module.exports, "mod", function () { return $b19438b06d7ad1dc$export$842a2cf37af977e1; }, function (v) { return $b19438b06d7ad1dc$export$842a2cf37af977e1 = v; });
$parcel$export(module.exports, "generateECPolynomial", function () { return $b19438b06d7ad1dc$export$7b8be06a973a9d05; }, function (v) { return $b19438b06d7ad1dc$export$7b8be06a973a9d05 = v; });
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $b19438b06d7ad1dc$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $b19438b06d7ad1dc$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $b19438b06d7ad1dc$export$7b8be06a973a9d05;

var $7fHKJ = parcelRequire("7fHKJ");
$b19438b06d7ad1dc$export$6e3a27864ab166fe = function mul(p1, p2) {
    var coeff = new Uint8Array(p1.length + p2.length - 1);
    for(var i = 0; i < p1.length; i++)for(var j = 0; j < p2.length; j++)coeff[i + j] ^= $7fHKJ.mul(p1[i], p2[j]);
    return coeff;
};
$b19438b06d7ad1dc$export$842a2cf37af977e1 = function mod(divident, divisor) {
    var result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        var coeff = result[0];
        for(var i = 0; i < divisor.length; i++)result[i] ^= $7fHKJ.mul(divisor[i], coeff);
        // remove all zeros from buffer head
        var offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$b19438b06d7ad1dc$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    var poly = new Uint8Array([
        1
    ]);
    for(var i = 0; i < degree; i++)poly = $b19438b06d7ad1dc$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $7fHKJ.exp(i)
    ]));
    return poly;
};

});
parcelRegister("7fHKJ", function(module, exports) {

$parcel$export(module.exports, "exp", function () { return $547bdf7b1277e393$export$b310ec824aaee37f; }, function (v) { return $547bdf7b1277e393$export$b310ec824aaee37f = v; });
$parcel$export(module.exports, "mul", function () { return $547bdf7b1277e393$export$6e3a27864ab166fe; }, function (v) { return $547bdf7b1277e393$export$6e3a27864ab166fe = v; });
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $547bdf7b1277e393$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $547bdf7b1277e393$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $547bdf7b1277e393$export$6e3a27864ab166fe;
var $547bdf7b1277e393$var$EXP_TABLE = new Uint8Array(512);
var $547bdf7b1277e393$var$LOG_TABLE = new Uint8Array(256) /**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */ ;
(function initTables() {
    var x = 1;
    for(var i = 0; i < 255; i++){
        $547bdf7b1277e393$var$EXP_TABLE[i] = x;
        $547bdf7b1277e393$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(var i1 = 255; i1 < 512; i1++)$547bdf7b1277e393$var$EXP_TABLE[i1] = $547bdf7b1277e393$var$EXP_TABLE[i1 - 255];
})();
$547bdf7b1277e393$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error("log(" + n + ")");
    return $547bdf7b1277e393$var$LOG_TABLE[n];
};
$547bdf7b1277e393$export$b310ec824aaee37f = function exp(n) {
    return $547bdf7b1277e393$var$EXP_TABLE[n];
};
$547bdf7b1277e393$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $547bdf7b1277e393$var$EXP_TABLE[$547bdf7b1277e393$var$LOG_TABLE[x] + $547bdf7b1277e393$var$LOG_TABLE[y]];
};

});



parcelRegister("4sGnJ", function(module, exports) {

$parcel$export(module.exports, "getCapacity", function () { return $33faa71afa7e13a4$export$55b283886ec2d3fb; }, function (v) { return $33faa71afa7e13a4$export$55b283886ec2d3fb = v; });
$parcel$export(module.exports, "from", function () { return $33faa71afa7e13a4$export$6788812c4e6611e6; }, function (v) { return $33faa71afa7e13a4$export$6788812c4e6611e6 = v; });
$parcel$export(module.exports, "getBestVersionForData", function () { return $33faa71afa7e13a4$export$264e969aa7a8ff7e; }, function (v) { return $33faa71afa7e13a4$export$264e969aa7a8ff7e = v; });
$parcel$export(module.exports, "getEncodedBits", function () { return $33faa71afa7e13a4$export$eee5438974ef6f0e; }, function (v) { return $33faa71afa7e13a4$export$eee5438974ef6f0e = v; });
/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $33faa71afa7e13a4$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $33faa71afa7e13a4$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $33faa71afa7e13a4$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $33faa71afa7e13a4$export$eee5438974ef6f0e;

var $am8JH = parcelRequire("am8JH");

var $43LoF = parcelRequire("43LoF");

var $9BZm5 = parcelRequire("9BZm5");

var $4RD3g = parcelRequire("4RD3g");

var $c1JCZ = parcelRequire("c1JCZ");
// Generator polynomial used to encode version information
var $33faa71afa7e13a4$var$G18 = 7973;
var $33faa71afa7e13a4$var$G18_BCH = $am8JH.getBCHDigit($33faa71afa7e13a4$var$G18);
function $33faa71afa7e13a4$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(var currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $33faa71afa7e13a4$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $33faa71afa7e13a4$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $4RD3g.getCharCountIndicator(mode, version) + 4;
}
function $33faa71afa7e13a4$var$getTotalBitsFromDataArray(segments, version) {
    var totalBits = 0;
    segments.forEach(function(data) {
        var reservedBits = $33faa71afa7e13a4$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $33faa71afa7e13a4$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(var currentVersion = 1; currentVersion <= 40; currentVersion++){
        var length = $33faa71afa7e13a4$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $33faa71afa7e13a4$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $4RD3g.MIXED)) return currentVersion;
    }
    return undefined;
}
$33faa71afa7e13a4$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($c1JCZ.isValid(value)) return parseInt(value, 10);
    return defaultValue;
};
$33faa71afa7e13a4$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$c1JCZ.isValid(version)) throw new Error("Invalid QR Code version");
    // Use Byte mode as default
    if (typeof mode === "undefined") mode = $4RD3g.BYTE;
    // Total codewords for this QR code version (Data + Error correction)
    var totalCodewords = $am8JH.getSymbolTotalCodewords(version);
    // Total number of error correction codewords
    var ecTotalCodewords = $43LoF.getTotalCodewordsCount(version, errorCorrectionLevel);
    // Total number of data codewords
    var dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $4RD3g.MIXED) return dataTotalCodewordsBits;
    var usableBits = dataTotalCodewordsBits - $33faa71afa7e13a4$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $4RD3g.NUMERIC:
            return Math.floor(usableBits / 10 * 3);
        case $4RD3g.ALPHANUMERIC:
            return Math.floor(usableBits / 11 * 2);
        case $4RD3g.KANJI:
            return Math.floor(usableBits / 13);
        case $4RD3g.BYTE:
        default:
            return Math.floor(usableBits / 8);
    }
};
$33faa71afa7e13a4$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    var seg;
    var ecl = $9BZm5.from(errorCorrectionLevel, $9BZm5.M);
    if (Array.isArray(data)) {
        if (data.length > 1) return $33faa71afa7e13a4$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $33faa71afa7e13a4$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$33faa71afa7e13a4$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$c1JCZ.isValid(version) || version < 7) throw new Error("Invalid QR Code version");
    var d = version << 12;
    while($am8JH.getBCHDigit(d) - $33faa71afa7e13a4$var$G18_BCH >= 0)d ^= $33faa71afa7e13a4$var$G18 << $am8JH.getBCHDigit(d) - $33faa71afa7e13a4$var$G18_BCH;
    return version << 12 | d;
};

});
parcelRegister("4RD3g", function(module, exports) {

$parcel$export(module.exports, "NUMERIC", function () { return $38aa677c4eab36f2$export$4d318981b5a83836; }, function (v) { return $38aa677c4eab36f2$export$4d318981b5a83836 = v; });
$parcel$export(module.exports, "ALPHANUMERIC", function () { return $38aa677c4eab36f2$export$376a9ed239d6c1c8; }, function (v) { return $38aa677c4eab36f2$export$376a9ed239d6c1c8 = v; });
$parcel$export(module.exports, "BYTE", function () { return $38aa677c4eab36f2$export$8f4bf8f7eb581284; }, function (v) { return $38aa677c4eab36f2$export$8f4bf8f7eb581284 = v; });
$parcel$export(module.exports, "KANJI", function () { return $38aa677c4eab36f2$export$a4d452c2363c8e12; }, function (v) { return $38aa677c4eab36f2$export$a4d452c2363c8e12 = v; });
$parcel$export(module.exports, "MIXED", function () { return $38aa677c4eab36f2$export$bb410559a65d3418; }, function (v) { return $38aa677c4eab36f2$export$bb410559a65d3418 = v; });
$parcel$export(module.exports, "getCharCountIndicator", function () { return $38aa677c4eab36f2$export$e79764af6ffaeb8d; }, function (v) { return $38aa677c4eab36f2$export$e79764af6ffaeb8d = v; });
$parcel$export(module.exports, "getBestModeForData", function () { return $38aa677c4eab36f2$export$1bd4c93ffb42e55e; }, function (v) { return $38aa677c4eab36f2$export$1bd4c93ffb42e55e = v; });
$parcel$export(module.exports, "toString", function () { return $38aa677c4eab36f2$export$f84e8e69fd4488a5; }, function (v) { return $38aa677c4eab36f2$export$f84e8e69fd4488a5 = v; });
$parcel$export(module.exports, "isValid", function () { return $38aa677c4eab36f2$export$1ea939691cdc45b8; }, function (v) { return $38aa677c4eab36f2$export$1ea939691cdc45b8 = v; });
$parcel$export(module.exports, "from", function () { return $38aa677c4eab36f2$export$6788812c4e6611e6; }, function (v) { return $38aa677c4eab36f2$export$6788812c4e6611e6 = v; });
/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $38aa677c4eab36f2$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $38aa677c4eab36f2$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $38aa677c4eab36f2$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $38aa677c4eab36f2$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $38aa677c4eab36f2$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $38aa677c4eab36f2$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $38aa677c4eab36f2$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $38aa677c4eab36f2$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $38aa677c4eab36f2$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $38aa677c4eab36f2$export$6788812c4e6611e6;

var $c1JCZ = parcelRequire("c1JCZ");

var $dk0HL = parcelRequire("dk0HL");
$38aa677c4eab36f2$export$4d318981b5a83836 = {
    id: "Numeric",
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$38aa677c4eab36f2$export$376a9ed239d6c1c8 = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$38aa677c4eab36f2$export$8f4bf8f7eb581284 = {
    id: "Byte",
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$38aa677c4eab36f2$export$a4d452c2363c8e12 = {
    id: "Kanji",
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$38aa677c4eab36f2$export$bb410559a65d3418 = {
    bit: -1
};
$38aa677c4eab36f2$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error("Invalid mode: " + mode);
    if (!$c1JCZ.isValid(version)) throw new Error("Invalid version: " + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$38aa677c4eab36f2$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($dk0HL.testNumeric(dataStr)) return $38aa677c4eab36f2$export$4d318981b5a83836;
    else if ($dk0HL.testAlphanumeric(dataStr)) return $38aa677c4eab36f2$export$376a9ed239d6c1c8;
    else if ($dk0HL.testKanji(dataStr)) return $38aa677c4eab36f2$export$a4d452c2363c8e12;
    else return $38aa677c4eab36f2$export$8f4bf8f7eb581284;
};
$38aa677c4eab36f2$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error("Invalid mode");
};
$38aa677c4eab36f2$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $38aa677c4eab36f2$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    var lcStr = string.toLowerCase();
    switch(lcStr){
        case "numeric":
            return $38aa677c4eab36f2$export$4d318981b5a83836;
        case "alphanumeric":
            return $38aa677c4eab36f2$export$376a9ed239d6c1c8;
        case "kanji":
            return $38aa677c4eab36f2$export$a4d452c2363c8e12;
        case "byte":
            return $38aa677c4eab36f2$export$8f4bf8f7eb581284;
        default:
            throw new Error("Unknown mode: " + string);
    }
}
$38aa677c4eab36f2$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($38aa677c4eab36f2$export$1ea939691cdc45b8(value)) return value;
    try {
        return $38aa677c4eab36f2$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};

});
parcelRegister("c1JCZ", function(module, exports) {

$parcel$export(module.exports, "isValid", function () { return $8c18f8c192442cc2$export$1ea939691cdc45b8; }, function (v) { return $8c18f8c192442cc2$export$1ea939691cdc45b8 = v; });
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $8c18f8c192442cc2$export$1ea939691cdc45b8;
$8c18f8c192442cc2$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};

});

parcelRegister("dk0HL", function(module, exports) {

$parcel$export(module.exports, "KANJI", function () { return $9b2db096d9d92723$export$a4d452c2363c8e12; }, function (v) { return $9b2db096d9d92723$export$a4d452c2363c8e12 = v; });
$parcel$export(module.exports, "BYTE_KANJI", function () { return $9b2db096d9d92723$export$9df7c29d562bab83; }, function (v) { return $9b2db096d9d92723$export$9df7c29d562bab83 = v; });
$parcel$export(module.exports, "BYTE", function () { return $9b2db096d9d92723$export$8f4bf8f7eb581284; }, function (v) { return $9b2db096d9d92723$export$8f4bf8f7eb581284 = v; });
$parcel$export(module.exports, "NUMERIC", function () { return $9b2db096d9d92723$export$4d318981b5a83836; }, function (v) { return $9b2db096d9d92723$export$4d318981b5a83836 = v; });
$parcel$export(module.exports, "ALPHANUMERIC", function () { return $9b2db096d9d92723$export$376a9ed239d6c1c8; }, function (v) { return $9b2db096d9d92723$export$376a9ed239d6c1c8 = v; });
$parcel$export(module.exports, "testKanji", function () { return $9b2db096d9d92723$export$175f16aef75a4569; }, function (v) { return $9b2db096d9d92723$export$175f16aef75a4569 = v; });
$parcel$export(module.exports, "testNumeric", function () { return $9b2db096d9d92723$export$50b7f9bf92c74274; }, function (v) { return $9b2db096d9d92723$export$50b7f9bf92c74274 = v; });
$parcel$export(module.exports, "testAlphanumeric", function () { return $9b2db096d9d92723$export$4ba5f52893b4ac97; }, function (v) { return $9b2db096d9d92723$export$4ba5f52893b4ac97 = v; });
var $9b2db096d9d92723$export$a4d452c2363c8e12;
var $9b2db096d9d92723$export$9df7c29d562bab83;
var $9b2db096d9d92723$export$8f4bf8f7eb581284;
var $9b2db096d9d92723$export$4d318981b5a83836;
var $9b2db096d9d92723$export$376a9ed239d6c1c8;
var $9b2db096d9d92723$export$175f16aef75a4569;
var $9b2db096d9d92723$export$50b7f9bf92c74274;
var $9b2db096d9d92723$export$4ba5f52893b4ac97;
var $9b2db096d9d92723$var$numeric = "[0-9]+";
var $9b2db096d9d92723$var$alphanumeric = "[A-Z $%*+\\-./:]+";
var $9b2db096d9d92723$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$9b2db096d9d92723$var$kanji = $9b2db096d9d92723$var$kanji.replace(/u/g, "\\u");
var $9b2db096d9d92723$var$byte = "(?:(?![A-Z0-9 $%*+\\-./:]|" + $9b2db096d9d92723$var$kanji + ")(?:.|[\r\n]))+";
$9b2db096d9d92723$export$a4d452c2363c8e12 = new RegExp($9b2db096d9d92723$var$kanji, "g");
$9b2db096d9d92723$export$9df7c29d562bab83 = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
$9b2db096d9d92723$export$8f4bf8f7eb581284 = new RegExp($9b2db096d9d92723$var$byte, "g");
$9b2db096d9d92723$export$4d318981b5a83836 = new RegExp($9b2db096d9d92723$var$numeric, "g");
$9b2db096d9d92723$export$376a9ed239d6c1c8 = new RegExp($9b2db096d9d92723$var$alphanumeric, "g");
var $9b2db096d9d92723$var$TEST_KANJI = new RegExp("^" + $9b2db096d9d92723$var$kanji + "$");
var $9b2db096d9d92723$var$TEST_NUMERIC = new RegExp("^" + $9b2db096d9d92723$var$numeric + "$");
var $9b2db096d9d92723$var$TEST_ALPHANUMERIC = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
$9b2db096d9d92723$export$175f16aef75a4569 = function testKanji(str) {
    return $9b2db096d9d92723$var$TEST_KANJI.test(str);
};
$9b2db096d9d92723$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $9b2db096d9d92723$var$TEST_NUMERIC.test(str);
};
$9b2db096d9d92723$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $9b2db096d9d92723$var$TEST_ALPHANUMERIC.test(str);
};

});



parcelRegister("jZAiS", function(module, exports) {

$parcel$export(module.exports, "getEncodedBits", function () { return $e8dfdff6055afdd7$export$eee5438974ef6f0e; }, function (v) { return $e8dfdff6055afdd7$export$eee5438974ef6f0e = v; });
/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $e8dfdff6055afdd7$export$eee5438974ef6f0e;

var $am8JH = parcelRequire("am8JH");
var $e8dfdff6055afdd7$var$G15 = 1335;
var $e8dfdff6055afdd7$var$G15_MASK = 21522;
var $e8dfdff6055afdd7$var$G15_BCH = $am8JH.getBCHDigit($e8dfdff6055afdd7$var$G15);
$e8dfdff6055afdd7$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    var data = errorCorrectionLevel.bit << 3 | mask;
    var d = data << 10;
    while($am8JH.getBCHDigit(d) - $e8dfdff6055afdd7$var$G15_BCH >= 0)d ^= $e8dfdff6055afdd7$var$G15 << $am8JH.getBCHDigit(d) - $e8dfdff6055afdd7$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $e8dfdff6055afdd7$var$G15_MASK;
};

});

parcelRegister("dVCGS", function(module, exports) {

$parcel$export(module.exports, "fromArray", function () { return $a23e9c5d05b0345e$export$571d59b505e6bb4e; }, function (v) { return $a23e9c5d05b0345e$export$571d59b505e6bb4e = v; });
$parcel$export(module.exports, "fromString", function () { return $a23e9c5d05b0345e$export$3004f64547af360e; }, function (v) { return $a23e9c5d05b0345e$export$3004f64547af360e = v; });
$parcel$export(module.exports, "rawSplit", function () { return $a23e9c5d05b0345e$export$89ab1afb9839589b; }, function (v) { return $a23e9c5d05b0345e$export$89ab1afb9839589b = v; });
/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $a23e9c5d05b0345e$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $a23e9c5d05b0345e$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $a23e9c5d05b0345e$export$89ab1afb9839589b;

var $4RD3g = parcelRequire("4RD3g");

var $3wCy6 = parcelRequire("3wCy6");

var $gSCMy = parcelRequire("gSCMy");

var $9dgQr = parcelRequire("9dgQr");

var $3pLk8 = parcelRequire("3pLk8");

var $dk0HL = parcelRequire("dk0HL");

var $am8JH = parcelRequire("am8JH");

var $67vLd = parcelRequire("67vLd");
/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $a23e9c5d05b0345e$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $a23e9c5d05b0345e$var$getSegments(regex, mode, str) {
    var segments = [];
    var result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $a23e9c5d05b0345e$var$getSegmentsFromString(dataStr) {
    var numSegs = $a23e9c5d05b0345e$var$getSegments($dk0HL.NUMERIC, $4RD3g.NUMERIC, dataStr);
    var alphaNumSegs = $a23e9c5d05b0345e$var$getSegments($dk0HL.ALPHANUMERIC, $4RD3g.ALPHANUMERIC, dataStr);
    var byteSegs;
    var kanjiSegs;
    if ($am8JH.isKanjiModeEnabled()) {
        byteSegs = $a23e9c5d05b0345e$var$getSegments($dk0HL.BYTE, $4RD3g.BYTE, dataStr);
        kanjiSegs = $a23e9c5d05b0345e$var$getSegments($dk0HL.KANJI, $4RD3g.KANJI, dataStr);
    } else {
        byteSegs = $a23e9c5d05b0345e$var$getSegments($dk0HL.BYTE_KANJI, $4RD3g.BYTE, dataStr);
        kanjiSegs = [];
    }
    var segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $a23e9c5d05b0345e$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $4RD3g.NUMERIC:
            return $3wCy6.getBitsLength(length);
        case $4RD3g.ALPHANUMERIC:
            return $gSCMy.getBitsLength(length);
        case $4RD3g.KANJI:
            return $3pLk8.getBitsLength(length);
        case $4RD3g.BYTE:
            return $9dgQr.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $a23e9c5d05b0345e$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        var prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $a23e9c5d05b0345e$var$buildNodes(segs) {
    var nodes = [];
    for(var i = 0; i < segs.length; i++){
        var seg = segs[i];
        switch(seg.mode){
            case $4RD3g.NUMERIC:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $4RD3g.ALPHANUMERIC,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $4RD3g.BYTE,
                        length: seg.length
                    }
                ]);
                break;
            case $4RD3g.ALPHANUMERIC:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $4RD3g.BYTE,
                        length: seg.length
                    }
                ]);
                break;
            case $4RD3g.KANJI:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $4RD3g.BYTE,
                        length: $a23e9c5d05b0345e$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $4RD3g.BYTE:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $4RD3g.BYTE,
                        length: $a23e9c5d05b0345e$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $a23e9c5d05b0345e$var$buildGraph(nodes, version) {
    var table = {};
    var graph = {
        start: {}
    };
    var prevNodeIds = [
        "start"
    ];
    for(var i = 0; i < nodes.length; i++){
        var nodeGroup = nodes[i];
        var currentNodeIds = [];
        for(var j = 0; j < nodeGroup.length; j++){
            var node = nodeGroup[j];
            var key = "" + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(var n = 0; n < prevNodeIds.length; n++){
                var prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $a23e9c5d05b0345e$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $a23e9c5d05b0345e$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $a23e9c5d05b0345e$var$getSegmentBitsLength(node.length, node.mode) + 4 + $4RD3g.getCharCountIndicator(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(var n1 = 0; n1 < prevNodeIds.length; n1++)graph[prevNodeIds[n1]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $a23e9c5d05b0345e$var$buildSingleSegment(data, modesHint) {
    var mode;
    var bestMode = $4RD3g.getBestModeForData(data);
    mode = $4RD3g.from(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $4RD3g.BYTE && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + " cannot be encoded with mode " + $4RD3g.toString(mode) + ".\n Suggested mode is: " + $4RD3g.toString(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $4RD3g.KANJI && !$am8JH.isKanjiModeEnabled()) mode = $4RD3g.BYTE;
    switch(mode){
        case $4RD3g.NUMERIC:
            return new $3wCy6(data);
        case $4RD3g.ALPHANUMERIC:
            return new $gSCMy(data);
        case $4RD3g.KANJI:
            return new $3pLk8(data);
        case $4RD3g.BYTE:
            return new $9dgQr(data);
    }
}
$a23e9c5d05b0345e$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === "string") acc.push($a23e9c5d05b0345e$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($a23e9c5d05b0345e$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$a23e9c5d05b0345e$export$3004f64547af360e = function fromString(data, version) {
    var segs = $a23e9c5d05b0345e$var$getSegmentsFromString(data, $am8JH.isKanjiModeEnabled());
    var nodes = $a23e9c5d05b0345e$var$buildNodes(segs);
    var graph = $a23e9c5d05b0345e$var$buildGraph(nodes, version);
    var path = $67vLd.find_path(graph.map, "start", "end");
    var optimizedSegs = [];
    for(var i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $a23e9c5d05b0345e$export$571d59b505e6bb4e($a23e9c5d05b0345e$var$mergeSegments(optimizedSegs));
};
$a23e9c5d05b0345e$export$89ab1afb9839589b = function rawSplit(data) {
    return $a23e9c5d05b0345e$export$571d59b505e6bb4e($a23e9c5d05b0345e$var$getSegmentsFromString(data, $am8JH.isKanjiModeEnabled()));
};

});
parcelRegister("3wCy6", function(module, exports) {

var $4RD3g = parcelRequire("4RD3g");
function $29124347acfcdfac$var$NumericData(data) {
    this.mode = $4RD3g.NUMERIC;
    this.data = data.toString();
}
$29124347acfcdfac$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$29124347acfcdfac$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$29124347acfcdfac$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $29124347acfcdfac$var$NumericData.getBitsLength(this.data.length);
};
$29124347acfcdfac$var$NumericData.prototype.write = function write(bitBuffer) {
    var i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    var remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
module.exports = $29124347acfcdfac$var$NumericData;

});

parcelRegister("gSCMy", function(module, exports) {

var $4RD3g = parcelRequire("4RD3g");
/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ var $c49fc5d4c4bb3890$var$ALPHA_NUM_CHARS = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
];
function $c49fc5d4c4bb3890$var$AlphanumericData(data) {
    this.mode = $4RD3g.ALPHANUMERIC;
    this.data = data;
}
$c49fc5d4c4bb3890$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$c49fc5d4c4bb3890$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$c49fc5d4c4bb3890$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $c49fc5d4c4bb3890$var$AlphanumericData.getBitsLength(this.data.length);
};
$c49fc5d4c4bb3890$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    var i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        var value = $c49fc5d4c4bb3890$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $c49fc5d4c4bb3890$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($c49fc5d4c4bb3890$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
module.exports = $c49fc5d4c4bb3890$var$AlphanumericData;

});

parcelRegister("9dgQr", function(module, exports) {

var $8Nb7t = parcelRequire("8Nb7t");

var $4RD3g = parcelRequire("4RD3g");
function $6b5264fa81e982b5$var$ByteData(data) {
    this.mode = $4RD3g.BYTE;
    if (typeof data === "string") data = $8Nb7t(data);
    this.data = new Uint8Array(data);
}
$6b5264fa81e982b5$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$6b5264fa81e982b5$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$6b5264fa81e982b5$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $6b5264fa81e982b5$var$ByteData.getBitsLength(this.data.length);
};
$6b5264fa81e982b5$var$ByteData.prototype.write = function(bitBuffer) {
    for(var i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
module.exports = $6b5264fa81e982b5$var$ByteData;

});
parcelRegister("8Nb7t", function(module, exports) {
"use strict";
module.exports = function encodeUtf8(input) {
    var result = [];
    var size = input.length;
    for(var index = 0; index < size; index++){
        var point = input.charCodeAt(index);
        if (point >= 0xD800 && point <= 0xDBFF && size > index + 1) {
            var second = input.charCodeAt(index + 1);
            if (second >= 0xDC00 && second <= 0xDFFF) {
                // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                point = (point - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
                index += 1;
            }
        }
        // US-ASCII
        if (point < 0x80) {
            result.push(point);
            continue;
        }
        // 2-byte UTF-8
        if (point < 0x800) {
            result.push(point >> 6 | 192);
            result.push(point & 63 | 128);
            continue;
        }
        // 3-byte UTF-8
        if (point < 0xD800 || point >= 0xE000 && point < 0x10000) {
            result.push(point >> 12 | 224);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // 4-byte UTF-8
        if (point >= 0x10000 && point <= 0x10FFFF) {
            result.push(point >> 18 | 240);
            result.push(point >> 12 & 63 | 128);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // Invalid character
        result.push(0xEF, 0xBF, 0xBD);
    }
    return new Uint8Array(result).buffer;
};

});


parcelRegister("3pLk8", function(module, exports) {

var $4RD3g = parcelRequire("4RD3g");

var $am8JH = parcelRequire("am8JH");
function $27c86a683daa810d$var$KanjiData(data) {
    this.mode = $4RD3g.KANJI;
    this.data = data;
}
$27c86a683daa810d$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$27c86a683daa810d$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$27c86a683daa810d$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $27c86a683daa810d$var$KanjiData.getBitsLength(this.data.length);
};
$27c86a683daa810d$var$KanjiData.prototype.write = function(bitBuffer) {
    var i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        var value = $am8JH.toSJIS(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error("Invalid SJIS character: " + this.data[i] + "\n" + "Make sure your charset is UTF-8");
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
module.exports = $27c86a683daa810d$var$KanjiData;

});

parcelRegister("67vLd", function(module, exports) {
"use strict";
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var $474c087d31926996$var$dijkstra = {
    single_source_shortest_paths: function single_source_shortest_paths(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = $474c087d31926996$var$dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === "undefined";
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== "undefined" && typeof costs[d] === "undefined") {
            var msg = [
                "Could not find a path from ",
                s,
                " to ",
                d,
                "."
            ].join("");
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function extract_shortest_path_from_predecessor_list(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function find_path(graph, s, d) {
        var predecessors = $474c087d31926996$var$dijkstra.single_source_shortest_paths(graph, s, d);
        return $474c087d31926996$var$dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function make(opts) {
            var T = $474c087d31926996$var$dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function default_sorter(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function push(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function pop() {
            return this.queue.shift();
        },
        empty: function empty() {
            return this.queue.length === 0;
        }
    }
};
module.exports = $474c087d31926996$var$dijkstra;

});



parcelRegister("1ZVJr", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $1748454ecd35b7de$export$b3890eb0ae9dca99; }, function (v) { return $1748454ecd35b7de$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "renderToDataURL", function () { return $1748454ecd35b7de$export$c3e5526bbaf70a25; }, function (v) { return $1748454ecd35b7de$export$c3e5526bbaf70a25 = v; });
var $1748454ecd35b7de$export$b3890eb0ae9dca99;
var $1748454ecd35b7de$export$c3e5526bbaf70a25;

var $k00yG = parcelRequire("k00yG");
function $1748454ecd35b7de$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + "px";
    canvas.style.width = size + "px";
}
function $1748454ecd35b7de$var$getCanvasElement() {
    try {
        return document.createElement("canvas");
    } catch (e) {
        throw new Error("You need to specify a canvas element");
    }
}
$1748454ecd35b7de$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    var opts = options;
    var canvasEl = canvas;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $1748454ecd35b7de$var$getCanvasElement();
    opts = $k00yG.getOptions(opts);
    var size = $k00yG.getImageWidth(qrData.modules.size, opts);
    var ctx = canvasEl.getContext("2d");
    var image = ctx.createImageData(size, size);
    $k00yG.qrToImageData(image.data, qrData, opts);
    $1748454ecd35b7de$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$1748454ecd35b7de$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    var opts = options;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    var canvasEl = $1748454ecd35b7de$export$b3890eb0ae9dca99(qrData, canvas, opts);
    var type = opts.type || "image/png";
    var rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};

});
parcelRegister("k00yG", function(module, exports) {

$parcel$export(module.exports, "getOptions", function () { return $e8f43d9c8a218b42$export$d2312e68e1f5ad00; }, function (v) { return $e8f43d9c8a218b42$export$d2312e68e1f5ad00 = v; });
$parcel$export(module.exports, "getScale", function () { return $e8f43d9c8a218b42$export$5cdac61cf538712e; }, function (v) { return $e8f43d9c8a218b42$export$5cdac61cf538712e = v; });
$parcel$export(module.exports, "getImageWidth", function () { return $e8f43d9c8a218b42$export$c3a1a1f268a8142b; }, function (v) { return $e8f43d9c8a218b42$export$c3a1a1f268a8142b = v; });
$parcel$export(module.exports, "qrToImageData", function () { return $e8f43d9c8a218b42$export$83136f57c739c5f3; }, function (v) { return $e8f43d9c8a218b42$export$83136f57c739c5f3 = v; });
var $e8f43d9c8a218b42$export$d2312e68e1f5ad00;
var $e8f43d9c8a218b42$export$5cdac61cf538712e;
var $e8f43d9c8a218b42$export$c3a1a1f268a8142b;
var $e8f43d9c8a218b42$export$83136f57c739c5f3;
function $e8f43d9c8a218b42$var$hex2rgba(hex) {
    if (typeof hex === "number") hex = hex.toString();
    if (typeof hex !== "string") throw new Error("Color should be defined as hex string");
    var hexCode = hex.slice().replace("#", "").split("");
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error("Invalid hex color: " + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push("F", "F");
    var hexValue = parseInt(hexCode.join(""), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: "#" + hexCode.slice(0, 6).join("")
    };
}
$e8f43d9c8a218b42$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    var margin = typeof options.margin === "undefined" || options.margin === null || options.margin < 0 ? 4 : options.margin;
    var width = options.width && options.width >= 21 ? options.width : undefined;
    var scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $e8f43d9c8a218b42$var$hex2rgba(options.color.dark || "#000000ff"),
            light: $e8f43d9c8a218b42$var$hex2rgba(options.color.light || "#ffffffff")
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$e8f43d9c8a218b42$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$e8f43d9c8a218b42$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    var scale = $e8f43d9c8a218b42$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$e8f43d9c8a218b42$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    var size = qr.modules.size;
    var data = qr.modules.data;
    var scale = $e8f43d9c8a218b42$export$5cdac61cf538712e(size, opts);
    var symbolSize = Math.floor((size + opts.margin * 2) * scale);
    var scaledMargin = opts.margin * scale;
    var palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(var i = 0; i < symbolSize; i++)for(var j = 0; j < symbolSize; j++){
        var posDst = (i * symbolSize + j) * 4;
        var pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            var iSrc = Math.floor((i - scaledMargin) / scale);
            var jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};

});


parcelRegister("cRaam", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $95c252123bd6445d$export$b3890eb0ae9dca99; }, function (v) { return $95c252123bd6445d$export$b3890eb0ae9dca99 = v; });
var $95c252123bd6445d$export$b3890eb0ae9dca99;

var $k00yG = parcelRequire("k00yG");
function $95c252123bd6445d$var$getColorAttrib(color, attrib) {
    var alpha = color.a / 255;
    var str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + " " + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $95c252123bd6445d$var$svgCmd(cmd, x, y) {
    var str = cmd + x;
    if (typeof y !== "undefined") str += " " + y;
    return str;
}
function $95c252123bd6445d$var$qrToPath(data, size, margin) {
    var path = "";
    var moveBy = 0;
    var newRow = false;
    var lineLength = 0;
    for(var i = 0; i < data.length; i++){
        var col = Math.floor(i % size);
        var row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $95c252123bd6445d$var$svgCmd("M", col + margin, 0.5 + row + margin) : $95c252123bd6445d$var$svgCmd("m", moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $95c252123bd6445d$var$svgCmd("h", lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$95c252123bd6445d$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    var opts = $k00yG.getOptions(options);
    var size = qrData.modules.size;
    var data = qrData.modules.data;
    var qrcodesize = size + opts.margin * 2;
    var bg = !opts.color.light.a ? "" : "<path " + $95c252123bd6445d$var$getColorAttrib(opts.color.light, "fill") + ' d="M0 0h' + qrcodesize + "v" + qrcodesize + 'H0z"/>';
    var path = "<path " + $95c252123bd6445d$var$getColorAttrib(opts.color.dark, "stroke") + ' d="' + $95c252123bd6445d$var$qrToPath(data, size, opts.margin) + '"/>';
    var viewBox = 'viewBox="0 0 ' + qrcodesize + " " + qrcodesize + '"';
    var width = !opts.width ? "" : 'width="' + opts.width + '" height="' + opts.width + '" ';
    var svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + "</svg>\n";
    if (typeof cb === "function") cb(null, svgTag);
    return svgTag;
};

});



parcelRegister("gCOCT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1a777416fe8eb17$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $c1a777416fe8eb17$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    position: relative;\n    user-select: none;\n    display: block;\n    overflow: hidden;\n    aspect-ratio: 1 / 1;\n    width: var(--local-size);\n  }\n\n  :host([data-theme='dark']) {\n    border-radius: clamp(0px, var(--wui-border-radius-l), 40px);\n    background-color: var(--wui-color-inverse-100);\n    padding: var(--wui-spacing-l);\n  }\n\n  :host([data-theme='light']) {\n    box-shadow: 0 0 0 1px var(--wui-color-bg-125);\n    background-color: var(--wui-color-bg-125);\n  }\n\n  :host([data-clear='true']) > wui-icon {\n    display: none;\n  }\n\n  svg:first-child,\n  wui-image,\n  wui-icon {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translateY(-50%) translateX(-50%);\n  }\n\n  wui-image {\n    width: 25%;\n    height: 25%;\n    border-radius: var(--wui-border-radius-xs);\n  }\n\n  wui-icon {\n    width: 100%;\n    height: 100%;\n    color: #3396ff !important;\n    transform: translateY(-50%) translateX(-50%) scale(0.25);\n  }\n"
    ]);
    $c1a777416fe8eb17$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $c1a777416fe8eb17$export$2e2bcd8739ae039 = (0, $bBWVO.css)($c1a777416fe8eb17$var$_templateObject());

});


parcelRegister("iWNXX", function(module, exports) {

$parcel$export(module.exports, "WuiSearchBar", function () { return $dcb466fcb14bef5e$export$208b8ce22c764062; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("8jzG0");
var $fR1Rt = parcelRequire("fR1Rt");
parcelRequire("cJnc6");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("aYc6n");

var $dZDUh = parcelRequire("dZDUh");
function $dcb466fcb14bef5e$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      <wui-input-text\n        ",
        '\n        placeholder="Search wallet"\n        icon="search"\n        type="search"\n        enterKeyHint="search"\n        size="sm"\n      >\n        <wui-input-element @click=',
        ' icon="close"></wui-input-element>\n      </wui-input-text>\n    '
    ]);
    $dcb466fcb14bef5e$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $dcb466fcb14bef5e$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $dcb466fcb14bef5e$export$208b8ce22c764062 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiSearchBar, LitElement);
    var _super = (0, $ohfOJ._)(WuiSearchBar);
    function WuiSearchBar() {
        (0, $4GJKx._)(this, WuiSearchBar);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.inputComponentRef = (0, $fR1Rt.createRef)();
        return _this;
    }
    (0, $1wc17._)(WuiSearchBar, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($dcb466fcb14bef5e$var$_templateObject(), (0, $fR1Rt.ref)(this.inputComponentRef), this.clearValue);
            }
        },
        {
            key: "clearValue",
            value: function clearValue() {
                var inputComponent = this.inputComponentRef.value;
                var inputElement = inputComponent === null || inputComponent === void 0 ? void 0 : inputComponent.inputElementRef.value;
                if (inputElement) {
                    inputElement.value = "";
                    inputElement.focus();
                    inputElement.dispatchEvent(new Event("input"));
                }
            }
        }
    ]);
    return WuiSearchBar;
}((0, $eAsDt.LitElement));
$dcb466fcb14bef5e$export$208b8ce22c764062.styles = [
    (0, $kYNxm.resetStyles),
    (0, $dZDUh.default)
];
$dcb466fcb14bef5e$export$208b8ce22c764062 = $dcb466fcb14bef5e$var$__decorate([
    (0, $hdxb6.customElement)("wui-search-bar")
], $dcb466fcb14bef5e$export$208b8ce22c764062);

});
parcelRegister("dZDUh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2ffed82e9683185$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $a2ffed82e9683185$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    position: relative;\n    display: inline-block;\n    width: 100%;\n  }\n"
    ]);
    $a2ffed82e9683185$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $a2ffed82e9683185$export$2e2bcd8739ae039 = (0, $bBWVO.css)($a2ffed82e9683185$var$_templateObject());

});


parcelRegister("doSia", function(module, exports) {

$parcel$export(module.exports, "WuiSnackbar", function () { return $9c17a18015d0ef33$export$864d710a9db8f7a3; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("1OYaf");
parcelRequire("ePIOw");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("8jknp");

var $hrnsB = parcelRequire("hrnsB");
function $9c17a18015d0ef33$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<wui-loading-spinner size="md" color="accent-100"></wui-loading-spinner>'
    ]);
    $9c17a18015d0ef33$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $9c17a18015d0ef33$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '<wui-icon-box\n            size="sm"\n            iconSize="xs"\n            iconColor=',
        "\n            backgroundColor=",
        "\n            icon=",
        '\n            background="opaque"\n          ></wui-icon-box>'
    ]);
    $9c17a18015d0ef33$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $9c17a18015d0ef33$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "\n      ",
        '\n      <wui-text variant="paragraph-500" color="fg-100">',
        "</wui-text>\n    "
    ]);
    $9c17a18015d0ef33$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $9c17a18015d0ef33$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9c17a18015d0ef33$export$864d710a9db8f7a3 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiSnackbar, LitElement);
    var _super = (0, $ohfOJ._)(WuiSnackbar);
    function WuiSnackbar() {
        (0, $4GJKx._)(this, WuiSnackbar);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.backgroundColor = "accent-100";
        _this.iconColor = "accent-100";
        _this.icon = "checkmark";
        _this.message = "";
        _this.loading = false;
        return _this;
    }
    (0, $1wc17._)(WuiSnackbar, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($9c17a18015d0ef33$var$_templateObject2(), this.loading ? (0, $1lUIm.html)($9c17a18015d0ef33$var$_templateObject()) : (0, $1lUIm.html)($9c17a18015d0ef33$var$_templateObject1(), this.iconColor, this.backgroundColor, this.icon), this.message);
            }
        }
    ]);
    return WuiSnackbar;
}((0, $eAsDt.LitElement));
$9c17a18015d0ef33$export$864d710a9db8f7a3.styles = [
    (0, $kYNxm.resetStyles),
    (0, $hrnsB.default)
];
$9c17a18015d0ef33$var$__decorate([
    (0, $siQym.property)()
], $9c17a18015d0ef33$export$864d710a9db8f7a3.prototype, "backgroundColor", void 0);
$9c17a18015d0ef33$var$__decorate([
    (0, $siQym.property)()
], $9c17a18015d0ef33$export$864d710a9db8f7a3.prototype, "iconColor", void 0);
$9c17a18015d0ef33$var$__decorate([
    (0, $siQym.property)()
], $9c17a18015d0ef33$export$864d710a9db8f7a3.prototype, "icon", void 0);
$9c17a18015d0ef33$var$__decorate([
    (0, $siQym.property)()
], $9c17a18015d0ef33$export$864d710a9db8f7a3.prototype, "message", void 0);
$9c17a18015d0ef33$var$__decorate([
    (0, $siQym.property)()
], $9c17a18015d0ef33$export$864d710a9db8f7a3.prototype, "loading", void 0);
$9c17a18015d0ef33$export$864d710a9db8f7a3 = $9c17a18015d0ef33$var$__decorate([
    (0, $hdxb6.customElement)("wui-snackbar")
], $9c17a18015d0ef33$export$864d710a9db8f7a3);

});
parcelRegister("hrnsB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb2728048e1dcecb$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $cb2728048e1dcecb$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: flex;\n    column-gap: var(--wui-spacing-xs);\n    align-items: center;\n    padding: var(--wui-spacing-xs) var(--wui-spacing-m) var(--wui-spacing-xs) var(--wui-spacing-xs);\n    border-radius: var(--wui-border-radius-3xl);\n    border: 1px solid var(--wui-color-gray-glass-005);\n    box-sizing: border-box;\n    max-height: 40px;\n    background-color: var(--wui-color-bg-175);\n    box-shadow:\n      0px 14px 64px -4px rgba(0, 0, 0, 0.15),\n      0px 8px 22px -6px rgba(0, 0, 0, 0.15);\n  }\n\n  :host wui-loading-spinner {\n    margin-left: var(--wui-spacing-3xs);\n  }\n"
    ]);
    $cb2728048e1dcecb$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $cb2728048e1dcecb$export$2e2bcd8739ae039 = (0, $bBWVO.css)($cb2728048e1dcecb$var$_templateObject());

});


parcelRegister("j84rm", function(module, exports) {

$parcel$export(module.exports, "WuiTabs", function () { return $ded23570ac7d938d$export$78c669163db53348; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $c6Xmf = parcelRequire("c6Xmf");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
var $6DAI1 = parcelRequire("6DAI1");

var $kYNxm = parcelRequire("kYNxm");
parcelRequire("dcd5U");

var $hdxb6 = parcelRequire("hdxb6");

var $7Zjnp = parcelRequire("7Zjnp");
function $ded23570ac7d938d$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n        <button\n          ?disabled=",
        "\n          @click=",
        "\n          data-active=",
        '\n          data-testid="tab-',
        '"\n        >\n          ',
        '\n          <wui-text variant="small-600" color="inherit"> ',
        " </wui-text>\n        </button>\n      "
    ]);
    $ded23570ac7d938d$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $ded23570ac7d938d$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '<wui-icon size="xs" color="inherit" name=',
        "></wui-icon>"
    ]);
    $ded23570ac7d938d$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $ded23570ac7d938d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $ded23570ac7d938d$export$78c669163db53348 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiTabs, LitElement);
    var _super = (0, $ohfOJ._)(WuiTabs);
    function WuiTabs() {
        (0, $4GJKx._)(this, WuiTabs);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.tabs = [];
        _this.onTabChange = function() {
            return null;
        };
        _this.buttons = [];
        _this.disabled = false;
        _this.localTabWidth = "100px";
        _this.activeTab = 0;
        _this.isDense = false;
        return _this;
    }
    (0, $1wc17._)(WuiTabs, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                this.isDense = this.tabs.length > 3;
                this.style.cssText = "\n      --local-tab: ".concat(this.activeTab, ";\n      --local-tab-width: ").concat(this.localTabWidth, ";\n    ");
                this.dataset["type"] = this.isDense ? "flex" : "block";
                return this.tabs.map(function(tab, index) {
                    var _tab_label;
                    var isActive = index === _this.activeTab;
                    return (0, $1lUIm.html)($ded23570ac7d938d$var$_templateObject(), _this.disabled, function() {
                        return _this.onTabClick(index);
                    }, isActive, (_tab_label = tab.label) === null || _tab_label === void 0 ? void 0 : _tab_label.toLowerCase(), _this.iconTemplate(tab), tab.label);
                });
            }
        },
        {
            key: "firstUpdated",
            value: function firstUpdated() {
                var _this = this;
                if (this.shadowRoot && this.isDense) {
                    this.buttons = (0, $c6Xmf._)(this.shadowRoot.querySelectorAll("button"));
                    setTimeout(function() {
                        _this.animateTabs(0, true);
                    }, 0);
                }
            }
        },
        {
            key: "iconTemplate",
            value: function iconTemplate(tab) {
                if (tab.icon) return (0, $1lUIm.html)($ded23570ac7d938d$var$_templateObject1(), tab.icon);
                return null;
            }
        },
        {
            key: "onTabClick",
            value: function onTabClick(index) {
                if (this.buttons) this.animateTabs(index, false);
                this.activeTab = index;
                this.onTabChange(index);
            }
        },
        {
            key: "animateTabs",
            value: function animateTabs(index, initialAnimation) {
                var passiveBtn = this.buttons[this.activeTab];
                var activeBtn = this.buttons[index];
                var passiveBtnText = passiveBtn === null || passiveBtn === void 0 ? void 0 : passiveBtn.querySelector("wui-text");
                var activeBtnText = activeBtn === null || activeBtn === void 0 ? void 0 : activeBtn.querySelector("wui-text");
                var activeBtnBounds = activeBtn === null || activeBtn === void 0 ? void 0 : activeBtn.getBoundingClientRect();
                var activeBtnTextBounds = activeBtnText === null || activeBtnText === void 0 ? void 0 : activeBtnText.getBoundingClientRect();
                if (passiveBtn && passiveBtnText && !initialAnimation && index !== this.activeTab) {
                    passiveBtnText.animate([
                        {
                            opacity: 0
                        }
                    ], {
                        duration: 50,
                        easing: "ease",
                        fill: "forwards"
                    });
                    passiveBtn.animate([
                        {
                            width: "34px"
                        }
                    ], {
                        duration: 500,
                        easing: "ease",
                        fill: "forwards"
                    });
                }
                if (activeBtn && activeBtnBounds && activeBtnTextBounds && activeBtnText) {
                    if (index !== this.activeTab || initialAnimation) {
                        this.localTabWidth = "".concat(Math.round(activeBtnBounds.width + activeBtnTextBounds.width) + 6, "px");
                        activeBtn.animate([
                            {
                                width: "".concat(activeBtnBounds.width + activeBtnTextBounds.width, "px")
                            }
                        ], {
                            duration: initialAnimation ? 0 : 500,
                            fill: "forwards",
                            easing: "ease"
                        });
                        activeBtnText.animate([
                            {
                                opacity: 1
                            }
                        ], {
                            duration: initialAnimation ? 0 : 125,
                            delay: initialAnimation ? 0 : 200,
                            fill: "forwards",
                            easing: "ease"
                        });
                    }
                }
            }
        }
    ]);
    return WuiTabs;
}((0, $eAsDt.LitElement));
$ded23570ac7d938d$export$78c669163db53348.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $7Zjnp.default)
];
$ded23570ac7d938d$var$__decorate([
    (0, $siQym.property)({
        type: Array
    })
], $ded23570ac7d938d$export$78c669163db53348.prototype, "tabs", void 0);
$ded23570ac7d938d$var$__decorate([
    (0, $siQym.property)()
], $ded23570ac7d938d$export$78c669163db53348.prototype, "onTabChange", void 0);
$ded23570ac7d938d$var$__decorate([
    (0, $siQym.property)({
        type: Array
    })
], $ded23570ac7d938d$export$78c669163db53348.prototype, "buttons", void 0);
$ded23570ac7d938d$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $ded23570ac7d938d$export$78c669163db53348.prototype, "disabled", void 0);
$ded23570ac7d938d$var$__decorate([
    (0, $siQym.property)()
], $ded23570ac7d938d$export$78c669163db53348.prototype, "localTabWidth", void 0);
$ded23570ac7d938d$var$__decorate([
    (0, $6DAI1.state)()
], $ded23570ac7d938d$export$78c669163db53348.prototype, "activeTab", void 0);
$ded23570ac7d938d$var$__decorate([
    (0, $6DAI1.state)()
], $ded23570ac7d938d$export$78c669163db53348.prototype, "isDense", void 0);
$ded23570ac7d938d$export$78c669163db53348 = $ded23570ac7d938d$var$__decorate([
    (0, $hdxb6.customElement)("wui-tabs")
], $ded23570ac7d938d$export$78c669163db53348);

});
parcelRegister("7Zjnp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d0d42b1abd3e2ff$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $5d0d42b1abd3e2ff$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: inline-flex;\n    background-color: var(--wui-color-gray-glass-002);\n    border-radius: var(--wui-border-radius-3xl);\n    padding: var(--wui-spacing-3xs);\n    position: relative;\n    height: 36px;\n    min-height: 36px;\n    overflow: hidden;\n  }\n\n  :host::before {\n    content: '';\n    position: absolute;\n    pointer-events: none;\n    top: 4px;\n    left: 4px;\n    display: block;\n    width: var(--local-tab-width);\n    height: 28px;\n    border-radius: var(--wui-border-radius-3xl);\n    background-color: var(--wui-color-gray-glass-002);\n    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-002);\n    transform: translateX(calc(var(--local-tab) * var(--local-tab-width)));\n    transition: transform var(--wui-ease-out-power-1) var(--wui-duration-md);\n    will-change: background-color, opacity;\n  }\n\n  :host([data-type='flex'])::before {\n    left: 3px;\n    transform: translateX(calc((var(--local-tab) * 34px) + (var(--local-tab) * 4px)));\n  }\n\n  :host([data-type='flex']) {\n    display: flex;\n    padding: 0px 0px 0px 12px;\n    gap: 4px;\n  }\n\n  :host([data-type='flex']) > button > wui-text {\n    position: absolute;\n    left: 18px;\n    opacity: 0;\n  }\n\n  button[data-active='true'] > wui-icon,\n  button[data-active='true'] > wui-text {\n    color: var(--wui-color-fg-100);\n  }\n\n  button[data-active='false'] > wui-icon,\n  button[data-active='false'] > wui-text {\n    color: var(--wui-color-fg-200);\n  }\n\n  button[data-active='true']:disabled,\n  button[data-active='false']:disabled {\n    background-color: transparent;\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  button[data-active='true']:disabled > wui-text {\n    color: var(--wui-color-fg-200);\n  }\n\n  button[data-active='false']:disabled > wui-text {\n    color: var(--wui-color-fg-300);\n  }\n\n  button > wui-icon,\n  button > wui-text {\n    pointer-events: none;\n    transition: color var(--wui-e ase-out-power-1) var(--wui-duration-md);\n    will-change: color;\n  }\n\n  button {\n    width: var(--local-tab-width);\n    transition: background-color var(--wui-ease-out-power-1) var(--wui-duration-md);\n    will-change: background-color;\n  }\n\n  :host([data-type='flex']) > button {\n    width: 34px;\n    position: relative;\n    display: flex;\n    justify-content: flex-start;\n  }\n\n  button:hover:enabled,\n  button:active:enabled {\n    background-color: transparent !important;\n  }\n\n  button:hover:enabled > wui-icon,\n  button:active:enabled > wui-icon {\n    transition: all var(--wui-ease-out-power-1) var(--wui-duration-lg);\n    color: var(--wui-color-fg-125);\n  }\n\n  button:hover:enabled > wui-text,\n  button:active:enabled > wui-text {\n    transition: all var(--wui-ease-out-power-1) var(--wui-duration-lg);\n    color: var(--wui-color-fg-125);\n  }\n\n  button {\n    border-radius: var(--wui-border-radius-3xl);\n  }\n"
    ]);
    $5d0d42b1abd3e2ff$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $5d0d42b1abd3e2ff$export$2e2bcd8739ae039 = (0, $bBWVO.css)($5d0d42b1abd3e2ff$var$_templateObject());

});


parcelRegister("85eM7", function(module, exports) {

$parcel$export(module.exports, "WuiTokenButton", function () { return $5e2a40622405e92b$export$8a423828f5c8fb29; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");

var $hdxb6 = parcelRequire("hdxb6");

var $kYNxm = parcelRequire("kYNxm");
parcelRequire("1OYaf");
parcelRequire("9ZbyK");
parcelRequire("8jknp");

var $80CdG = parcelRequire("80CdG");
function $5e2a40622405e92b$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      <button ontouchstart>\n        ",
        '\n        <wui-text variant="paragraph-600" color="fg-100">',
        "</wui-text>\n      </button>\n    "
    ]);
    $5e2a40622405e92b$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $5e2a40622405e92b$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "<wui-image src=",
        "></wui-image>"
    ]);
    $5e2a40622405e92b$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $5e2a40622405e92b$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '\n      <wui-icon-box\n        size="sm"\n        iconColor="fg-200"\n        backgroundColor="fg-300"\n        icon="networkPlaceholder"\n      ></wui-icon-box>\n    '
    ]);
    $5e2a40622405e92b$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $5e2a40622405e92b$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $5e2a40622405e92b$export$8a423828f5c8fb29 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiTokenButton, LitElement);
    var _super = (0, $ohfOJ._)(WuiTokenButton);
    function WuiTokenButton() {
        (0, $4GJKx._)(this, WuiTokenButton);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.text = "";
        return _this;
    }
    (0, $1wc17._)(WuiTokenButton, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($5e2a40622405e92b$var$_templateObject(), this.tokenTemplate(), this.text);
            }
        },
        {
            key: "tokenTemplate",
            value: function tokenTemplate() {
                if (this.imageSrc) return (0, $1lUIm.html)($5e2a40622405e92b$var$_templateObject1(), this.imageSrc);
                return (0, $1lUIm.html)($5e2a40622405e92b$var$_templateObject2());
            }
        }
    ]);
    return WuiTokenButton;
}((0, $eAsDt.LitElement));
$5e2a40622405e92b$export$8a423828f5c8fb29.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $80CdG.default)
];
$5e2a40622405e92b$var$__decorate([
    (0, $siQym.property)()
], $5e2a40622405e92b$export$8a423828f5c8fb29.prototype, "imageSrc", void 0);
$5e2a40622405e92b$var$__decorate([
    (0, $siQym.property)()
], $5e2a40622405e92b$export$8a423828f5c8fb29.prototype, "text", void 0);
$5e2a40622405e92b$export$8a423828f5c8fb29 = $5e2a40622405e92b$var$__decorate([
    (0, $hdxb6.customElement)("wui-token-button")
], $5e2a40622405e92b$export$8a423828f5c8fb29);

});
parcelRegister("80CdG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d4bf87277c75f13$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $5d4bf87277c75f13$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: block;\n  }\n\n  :host > button {\n    gap: var(--wui-spacing-xxs);\n    padding: var(--wui-spacing-xs);\n    padding-right: var(--wui-spacing-1xs);\n    height: 40px;\n    border-radius: var(--wui-border-radius-l);\n    background: var(--wui-color-gray-glass-002);\n    border-width: 0px;\n    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-002);\n  }\n\n  :host > button wui-image {\n    width: 24px;\n    height: 24px;\n    border-radius: var(--wui-border-radius-s);\n    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-010);\n  }\n"
    ]);
    $5d4bf87277c75f13$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $5d4bf87277c75f13$export$2e2bcd8739ae039 = (0, $bBWVO.css)($5d4bf87277c75f13$var$_templateObject());

});


parcelRegister("7PfNN", function(module, exports) {

$parcel$export(module.exports, "WuiTooltip", function () { return $5b298dd462d66768$export$eee74dbee7f7f64b; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("dcd5U");
parcelRequire("1OYaf");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $jvrBl = parcelRequire("jvrBl");
function $5b298dd462d66768$var$_templateObject() {
    var data = (0, $j06k0._)([
        "<wui-icon\n        data-placement=",
        '\n        color="fg-100"\n        size="inherit"\n        name=',
        '\n      ></wui-icon>\n      <wui-text color="inherit" variant="small-500">',
        "</wui-text>"
    ]);
    $5b298dd462d66768$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $5b298dd462d66768$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $5b298dd462d66768$export$eee74dbee7f7f64b = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiTooltip, LitElement);
    var _super = (0, $ohfOJ._)(WuiTooltip);
    function WuiTooltip() {
        (0, $4GJKx._)(this, WuiTooltip);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.placement = "top";
        _this.variant = "fill";
        _this.message = "";
        return _this;
    }
    (0, $1wc17._)(WuiTooltip, [
        {
            key: "render",
            value: function render() {
                this.dataset["variant"] = this.variant;
                return (0, $1lUIm.html)($5b298dd462d66768$var$_templateObject(), this.placement, this.variant === "fill" ? "cursor" : "cursorTransparent", this.message);
            }
        }
    ]);
    return WuiTooltip;
}((0, $eAsDt.LitElement));
$5b298dd462d66768$export$eee74dbee7f7f64b.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $jvrBl.default)
];
$5b298dd462d66768$var$__decorate([
    (0, $siQym.property)()
], $5b298dd462d66768$export$eee74dbee7f7f64b.prototype, "placement", void 0);
$5b298dd462d66768$var$__decorate([
    (0, $siQym.property)()
], $5b298dd462d66768$export$eee74dbee7f7f64b.prototype, "variant", void 0);
$5b298dd462d66768$var$__decorate([
    (0, $siQym.property)()
], $5b298dd462d66768$export$eee74dbee7f7f64b.prototype, "message", void 0);
$5b298dd462d66768$export$eee74dbee7f7f64b = $5b298dd462d66768$var$__decorate([
    (0, $hdxb6.customElement)("wui-tooltip")
], $5b298dd462d66768$export$eee74dbee7f7f64b);

});
parcelRegister("jvrBl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e336529908efd230$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $e336529908efd230$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: block;\n    padding: 9px var(--wui-spacing-s) 10px var(--wui-spacing-s);\n    border-radius: var(--wui-border-radius-xxs);\n\n    color: var(--wui-color-bg-100);\n    position: relative;\n  }\n\n  :host([data-variant='shade']) {\n    background-color: var(--wui-color-bg-150);\n    border: 1px solid var(--wui-color-gray-glass-005);\n  }\n\n  :host([data-variant='shade']) > wui-text {\n    color: var(--wui-color-fg-150);\n  }\n\n  :host([data-variant='fill']) {\n    background-color: var(--wui-color-fg-100);\n    border: none;\n  }\n\n  wui-icon {\n    position: absolute;\n    width: 12px !important;\n    height: 4px !important;\n  }\n\n  wui-icon[data-placement='top'] {\n    bottom: 0px;\n    left: 50%;\n    transform: translate(-50%, 95%);\n  }\n\n  wui-icon[data-placement='bottom'] {\n    top: 0;\n    left: 50%;\n    transform: translate(-50%, -95%) rotate(180deg);\n  }\n\n  wui-icon[data-placement='right'] {\n    top: 50%;\n    left: 0;\n    transform: translate(-65%, -50%) rotate(90deg);\n  }\n\n  wui-icon[data-placement='left'] {\n    top: 50%;\n    right: 0%;\n    transform: translate(65%, -50%) rotate(270deg);\n  }\n"
    ]);
    $e336529908efd230$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $e336529908efd230$export$2e2bcd8739ae039 = (0, $bBWVO.css)($e336529908efd230$var$_templateObject());

});


parcelRegister("j0Ugk", function(module, exports) {

$parcel$export(module.exports, "WuiTokenListItem", function () { return $dd79a8f3a53c05e7$export$85f8def8a6b9b172; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
var $6DAI1 = parcelRequire("6DAI1");
parcelRequire("9ZbyK");
parcelRequire("1OYaf");
parcelRequire("8tnK2");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $hNK91 = parcelRequire("hNK91");

var $dI7zX = parcelRequire("dI7zX");
parcelRequire("dSKxG");
var $eMPGH = parcelRequire("eMPGH");
function $dd79a8f3a53c05e7$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n                  <wui-text variant="paragraph-500" color="fg-100">\n                    $',
        "\n                  </wui-text>\n                "
    ]);
    $dd79a8f3a53c05e7$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $dd79a8f3a53c05e7$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '<wui-text variant="small-400" color="fg-200">\n                  ',
        "\n                </wui-text>"
    ]);
    $dd79a8f3a53c05e7$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $dd79a8f3a53c05e7$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex alignItems="center">\n        ',
        '\n        <wui-flex flexDirection="column" gap="3xs">\n          <wui-flex justifyContent="space-between">\n            <wui-text variant="paragraph-500" color="fg-100" lineClamp="1">',
        "</wui-text>\n            ",
        '\n          </wui-flex>\n          <wui-flex justifyContent="space-between">\n            <wui-text variant="small-400" color="fg-200" lineClamp="1">',
        "</wui-text>\n            ",
        "\n          </wui-flex>\n        </wui-flex>\n      </wui-flex>\n    "
    ]);
    $dd79a8f3a53c05e7$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $dd79a8f3a53c05e7$var$_templateObject3() {
    var data = (0, $j06k0._)([
        '<wui-flex class="token-item-image-placeholder">\n        <wui-icon name="image" color="inherit"></wui-icon>\n      </wui-flex>'
    ]);
    $dd79a8f3a53c05e7$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $dd79a8f3a53c05e7$var$_templateObject4() {
    var data = (0, $j06k0._)([
        '<wui-image\n        width="40"\n        height="40"\n        src=',
        "\n        @onLoadError=",
        "\n      ></wui-image>"
    ]);
    $dd79a8f3a53c05e7$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
var $dd79a8f3a53c05e7$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $dd79a8f3a53c05e7$export$85f8def8a6b9b172 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiTokenListItem, LitElement);
    var _super = (0, $ohfOJ._)(WuiTokenListItem);
    function WuiTokenListItem() {
        (0, $4GJKx._)(this, WuiTokenListItem);
        var _this;
        _this = _super.call(this);
        _this.observer = new IntersectionObserver(function() {
            return undefined;
        });
        _this.imageSrc = undefined;
        _this.name = undefined;
        _this.symbol = undefined;
        _this.price = undefined;
        _this.amount = undefined;
        _this.visible = false;
        _this.imageError = false;
        _this.observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) _this.visible = true;
                else _this.visible = false;
            });
        }, {
            threshold: 0.1
        });
        return _this;
    }
    (0, $1wc17._)(WuiTokenListItem, [
        {
            key: "firstUpdated",
            value: function firstUpdated() {
                this.observer.observe(this);
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.observer.disconnect();
            }
        },
        {
            key: "render",
            value: function render() {
                var _NumberUtil_multiply;
                if (!this.visible) return null;
                var value = this.amount && this.price ? (_NumberUtil_multiply = (0, $eMPGH.NumberUtil).multiply(this.price, this.amount)) === null || _NumberUtil_multiply === void 0 ? void 0 : _NumberUtil_multiply.toFixed(3) : null;
                return (0, $1lUIm.html)($dd79a8f3a53c05e7$var$_templateObject2(), this.visualTemplate(), this.name, value ? (0, $1lUIm.html)($dd79a8f3a53c05e7$var$_templateObject(), (0, $dI7zX.UiHelperUtil).formatNumberToLocalString(value, 3)) : null, this.symbol, this.amount ? (0, $1lUIm.html)($dd79a8f3a53c05e7$var$_templateObject1(), (0, $dI7zX.UiHelperUtil).formatNumberToLocalString(this.amount, 4)) : null);
            }
        },
        {
            key: "visualTemplate",
            value: function visualTemplate() {
                if (this.imageError) return (0, $1lUIm.html)($dd79a8f3a53c05e7$var$_templateObject3());
                if (this.imageSrc) return (0, $1lUIm.html)($dd79a8f3a53c05e7$var$_templateObject4(), this.imageSrc, this.imageLoadError);
                return null;
            }
        },
        {
            key: "imageLoadError",
            value: function imageLoadError() {
                this.imageError = true;
            }
        }
    ]);
    return WuiTokenListItem;
}((0, $eAsDt.LitElement));
$dd79a8f3a53c05e7$export$85f8def8a6b9b172.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $hNK91.default)
];
$dd79a8f3a53c05e7$var$__decorate([
    (0, $siQym.property)()
], $dd79a8f3a53c05e7$export$85f8def8a6b9b172.prototype, "imageSrc", void 0);
$dd79a8f3a53c05e7$var$__decorate([
    (0, $siQym.property)()
], $dd79a8f3a53c05e7$export$85f8def8a6b9b172.prototype, "name", void 0);
$dd79a8f3a53c05e7$var$__decorate([
    (0, $siQym.property)()
], $dd79a8f3a53c05e7$export$85f8def8a6b9b172.prototype, "symbol", void 0);
$dd79a8f3a53c05e7$var$__decorate([
    (0, $siQym.property)()
], $dd79a8f3a53c05e7$export$85f8def8a6b9b172.prototype, "price", void 0);
$dd79a8f3a53c05e7$var$__decorate([
    (0, $siQym.property)()
], $dd79a8f3a53c05e7$export$85f8def8a6b9b172.prototype, "amount", void 0);
$dd79a8f3a53c05e7$var$__decorate([
    (0, $6DAI1.state)()
], $dd79a8f3a53c05e7$export$85f8def8a6b9b172.prototype, "visible", void 0);
$dd79a8f3a53c05e7$var$__decorate([
    (0, $6DAI1.state)()
], $dd79a8f3a53c05e7$export$85f8def8a6b9b172.prototype, "imageError", void 0);
$dd79a8f3a53c05e7$export$85f8def8a6b9b172 = $dd79a8f3a53c05e7$var$__decorate([
    (0, $hdxb6.customElement)("wui-token-list-item")
], $dd79a8f3a53c05e7$export$85f8def8a6b9b172);

});
parcelRegister("hNK91", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf5acea2c4a98197$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $cf5acea2c4a98197$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    height: 60px;\n    min-height: 60px;\n  }\n\n  :host > wui-flex {\n    cursor: pointer;\n    height: 100%;\n    display: flex;\n    column-gap: var(--wui-spacing-s);\n    padding: var(--wui-spacing-xs);\n    padding-right: var(--wui-spacing-l);\n    width: 100%;\n    background-color: transparent;\n    border-radius: var(--wui-border-radius-xs);\n    color: var(--wui-color-fg-250);\n    transition:\n      background-color var(--wui-ease-out-power-1) var(--wui-duration-lg),\n      opacity var(--wui-ease-out-power-1) var(--wui-duration-lg);\n    will-change: background-color, opacity;\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    :host > wui-flex:hover {\n      background-color: var(--wui-color-gray-glass-002);\n    }\n\n    :host > wui-flex:active {\n      background-color: var(--wui-color-gray-glass-005);\n    }\n  }\n\n  :host([disabled]) > wui-flex {\n    opacity: 0.6;\n  }\n\n  :host([disabled]) > wui-flex:hover {\n    background-color: transparent;\n  }\n\n  :host > wui-flex > wui-flex {\n    flex: 1;\n  }\n\n  :host > wui-flex > wui-image,\n  :host > wui-flex > .token-item-image-placeholder {\n    width: 40px;\n    max-width: 40px;\n    height: 40px;\n    border-radius: var(--wui-border-radius-3xl);\n    position: relative;\n  }\n\n  :host > wui-flex > .token-item-image-placeholder {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  :host > wui-flex > wui-image::after,\n  :host > wui-flex > .token-item-image-placeholder::after {\n    position: absolute;\n    content: '';\n    inset: 0;\n    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-010);\n    border-radius: var(--wui-border-radius-l);\n  }\n\n  button > wui-icon-box[data-variant='square-blue'] {\n    border-radius: var(--wui-border-radius-3xs);\n    position: relative;\n    border: none;\n    width: 36px;\n    height: 36px;\n  }\n"
    ]);
    $cf5acea2c4a98197$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $cf5acea2c4a98197$export$2e2bcd8739ae039 = (0, $bBWVO.css)($cf5acea2c4a98197$var$_templateObject());

});


parcelRegister("3FSJc", function(module, exports) {

$parcel$export(module.exports, "WuiVisualThumbnail", function () { return $2acfa742de3792fe$export$fb0fe7c7cc2031fe; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("9ZbyK");
parcelRequire("dcd5U");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $lj7jN = parcelRequire("lj7jN");
function $2acfa742de3792fe$var$_templateObject() {
    var data = (0, $j06k0._)([
        "",
        ""
    ]);
    $2acfa742de3792fe$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $2acfa742de3792fe$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "<wui-image src=",
        " alt=",
        "></wui-image>"
    ]);
    $2acfa742de3792fe$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $2acfa742de3792fe$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '<wui-icon\n      data-parent-size="md"\n      size="inherit"\n      color="inherit"\n      name="walletPlaceholder"\n    ></wui-icon>'
    ]);
    $2acfa742de3792fe$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $2acfa742de3792fe$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $2acfa742de3792fe$export$fb0fe7c7cc2031fe = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiVisualThumbnail, LitElement);
    var _super = (0, $ohfOJ._)(WuiVisualThumbnail);
    function WuiVisualThumbnail() {
        (0, $4GJKx._)(this, WuiVisualThumbnail);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(WuiVisualThumbnail, [
        {
            key: "render",
            value: function render() {
                this.style.cssText = "--local-border-radius: ".concat(this.borderRadiusFull ? "1000px" : "20px", "; background-color: var(--wui-color-modal-bg);");
                return (0, $1lUIm.html)($2acfa742de3792fe$var$_templateObject(), this.templateVisual());
            }
        },
        {
            key: "templateVisual",
            value: function templateVisual() {
                var _this_alt;
                if (this.imageSrc) return (0, $1lUIm.html)($2acfa742de3792fe$var$_templateObject1(), this.imageSrc, (_this_alt = this.alt) !== null && _this_alt !== void 0 ? _this_alt : "");
                return (0, $1lUIm.html)($2acfa742de3792fe$var$_templateObject2());
            }
        }
    ]);
    return WuiVisualThumbnail;
}((0, $eAsDt.LitElement));
$2acfa742de3792fe$export$fb0fe7c7cc2031fe.styles = [
    (0, $kYNxm.resetStyles),
    (0, $lj7jN.default)
];
$2acfa742de3792fe$var$__decorate([
    (0, $siQym.property)()
], $2acfa742de3792fe$export$fb0fe7c7cc2031fe.prototype, "imageSrc", void 0);
$2acfa742de3792fe$var$__decorate([
    (0, $siQym.property)()
], $2acfa742de3792fe$export$fb0fe7c7cc2031fe.prototype, "alt", void 0);
$2acfa742de3792fe$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $2acfa742de3792fe$export$fb0fe7c7cc2031fe.prototype, "borderRadiusFull", void 0);
$2acfa742de3792fe$export$fb0fe7c7cc2031fe = $2acfa742de3792fe$var$__decorate([
    (0, $hdxb6.customElement)("wui-visual-thumbnail")
], $2acfa742de3792fe$export$fb0fe7c7cc2031fe);

});
parcelRegister("lj7jN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8310c8f2490feaf$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $f8310c8f2490feaf$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: var(--wui-icon-box-size-xl);\n    height: var(--wui-icon-box-size-xl);\n    box-shadow: 0 0 0 8px var(--wui-thumbnail-border);\n    border-radius: var(--local-border-radius);\n    overflow: hidden;\n  }\n\n  wui-icon {\n    width: 32px;\n    height: 32px;\n  }\n"
    ]);
    $f8310c8f2490feaf$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $f8310c8f2490feaf$export$2e2bcd8739ae039 = (0, $bBWVO.css)($f8310c8f2490feaf$var$_templateObject());

});


parcelRegister("7yWl4", function(module, exports) {

$parcel$export(module.exports, "WuiNoticeCard", function () { return $5818f646aad2c1a0$export$bdf6de60cd1210c8; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("8tnK2");
parcelRequire("1OYaf");
parcelRequire("1iTHu");
parcelRequire("8jknp");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $1wijC = parcelRequire("1wijC");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
function $5818f646aad2c1a0$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <button>\n        <wui-flex gap="m" alignItems="center" justifyContent="space-between">\n          <wui-icon-box\n            size="lg"\n            iconcolor="accent-100"\n            backgroundcolor="accent-100"\n            icon=',
        '\n            background="transparent"\n          ></wui-icon-box>\n\n          <wui-flex flexDirection="column" gap="3xs">\n            <wui-text variant="paragraph-500" color="fg-100">',
        '</wui-text>\n            <wui-text variant="small-400" color="fg-200">',
        '</wui-text>\n          </wui-flex>\n\n          <wui-icon size="md" color="fg-200" name="chevronRight"></wui-icon>\n        </wui-flex>\n      </button>\n    '
    ]);
    $5818f646aad2c1a0$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $5818f646aad2c1a0$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $5818f646aad2c1a0$export$bdf6de60cd1210c8 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiNoticeCard, LitElement);
    var _super = (0, $ohfOJ._)(WuiNoticeCard);
    function WuiNoticeCard() {
        (0, $4GJKx._)(this, WuiNoticeCard);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.label = "";
        _this.description = "";
        _this.icon = "wallet";
        return _this;
    }
    (0, $1wc17._)(WuiNoticeCard, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($5818f646aad2c1a0$var$_templateObject(), this.icon, this.label, this.description);
            }
        }
    ]);
    return WuiNoticeCard;
}((0, $eAsDt.LitElement));
$5818f646aad2c1a0$export$bdf6de60cd1210c8.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $1wijC.default)
];
$5818f646aad2c1a0$var$__decorate([
    (0, $siQym.property)()
], $5818f646aad2c1a0$export$bdf6de60cd1210c8.prototype, "label", void 0);
$5818f646aad2c1a0$var$__decorate([
    (0, $siQym.property)()
], $5818f646aad2c1a0$export$bdf6de60cd1210c8.prototype, "description", void 0);
$5818f646aad2c1a0$var$__decorate([
    (0, $siQym.property)()
], $5818f646aad2c1a0$export$bdf6de60cd1210c8.prototype, "icon", void 0);
$5818f646aad2c1a0$export$bdf6de60cd1210c8 = $5818f646aad2c1a0$var$__decorate([
    (0, $hdxb6.customElement)("wui-notice-card")
], $5818f646aad2c1a0$export$bdf6de60cd1210c8);

});
parcelRegister("1wijC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11b6fca91d827260$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $11b6fca91d827260$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: block;\n  }\n\n  button {\n    width: 100%;\n    display: block;\n    padding-top: var(--wui-spacing-l);\n    padding-bottom: var(--wui-spacing-l);\n    padding-left: var(--wui-spacing-s);\n    padding-right: var(--wui-spacing-2l);\n    border-radius: var(--wui-border-radius-s);\n    background-color: var(--wui-color-accent-glass-010);\n  }\n\n  button:hover {\n    background-color: var(--wui-color-accent-glass-015) !important;\n  }\n\n  button:active {\n    background-color: var(--wui-color-accent-glass-020) !important;\n  }\n"
    ]);
    $11b6fca91d827260$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $11b6fca91d827260$export$2e2bcd8739ae039 = (0, $bBWVO.css)($11b6fca91d827260$var$_templateObject());

});


parcelRegister("iRTTL", function(module, exports) {

$parcel$export(module.exports, "WuiListAccordion", function () { return $dbc8897fe12f920e$export$f885ba019a6ba4db; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $04RAu = parcelRequire("04RAu");

var $b8Rim = parcelRequire("b8Rim");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("dcd5U");
parcelRequire("1OYaf");
parcelRequire("8tnK2");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $1FVnL = parcelRequire("1FVnL");
function $dbc8897fe12f920e$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      <button ontouchstart @click=",
        '>\n        <wui-flex justifyContent="space-between" alignItems="center">\n          <wui-text variant="paragraph-500" color="fg-100">',
        "</wui-text>\n          ",
        "\n        </wui-flex>\n        <div\n          data-active=",
        '\n          class="overflowedContent"\n        >\n          <div class="heightContent">\n            <wui-text class="textContent" variant="paragraph-400" color="fg-200">\n              <pre>',
        "</pre>\n            </wui-text>\n          </div>\n        </div>\n      </button>\n    "
    ]);
    $dbc8897fe12f920e$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $dbc8897fe12f920e$var$_templateObject1() {
    var data = (0, $j06k0._)([
        ' <wui-icon color="fg-100" size="sm" name="chevronBottom"></wui-icon>'
    ]);
    $dbc8897fe12f920e$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $dbc8897fe12f920e$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $dbc8897fe12f920e$var$MAX_HEIGHT = 100;
var $dbc8897fe12f920e$export$f885ba019a6ba4db = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiListAccordion, LitElement);
    var _super = (0, $ohfOJ._)(WuiListAccordion);
    function WuiListAccordion() {
        (0, $4GJKx._)(this, WuiListAccordion);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.textTitle = "";
        _this.overflowedContent = "";
        _this.toggled = false;
        _this.enableAccordion = false;
        _this.scrollElement = undefined;
        _this.scrollHeightElement = 0;
        return _this;
    }
    (0, $1wc17._)(WuiListAccordion, [
        {
            key: "updated",
            value: function updated(changedProperties) {
                var _this = this;
                (0, $04RAu._)((0, $b8Rim._)(WuiListAccordion.prototype), "updated", this).call(this, changedProperties);
                if (changedProperties.has("textTitle") || changedProperties.has("overflowedContent")) setTimeout(function() {
                    _this.checkHeight();
                }, 1);
            }
        },
        {
            key: "checkHeight",
            value: function checkHeight() {
                var _this = this;
                this.updateComplete.then(function() {
                    var _this_shadowRoot, _this_shadowRoot1;
                    var heightElement = (_this_shadowRoot = _this.shadowRoot) === null || _this_shadowRoot === void 0 ? void 0 : _this_shadowRoot.querySelector(".heightContent");
                    var textElement = (_this_shadowRoot1 = _this.shadowRoot) === null || _this_shadowRoot1 === void 0 ? void 0 : _this_shadowRoot1.querySelector(".textContent");
                    if (heightElement && textElement) {
                        _this.scrollElement = heightElement;
                        var scrollHeight = textElement === null || textElement === void 0 ? void 0 : textElement.scrollHeight;
                        if (scrollHeight && scrollHeight > $dbc8897fe12f920e$var$MAX_HEIGHT) {
                            _this.enableAccordion = true;
                            _this.scrollHeightElement = scrollHeight;
                            _this.requestUpdate();
                        }
                    }
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                return (0, $1lUIm.html)($dbc8897fe12f920e$var$_templateObject(), function() {
                    return _this.onClick();
                }, this.textTitle, this.chevronTemplate(), this.enableAccordion ? Boolean(this.toggled) : true, this.overflowedContent);
            }
        },
        {
            key: "onClick",
            value: function onClick() {
                var _this_shadowRoot;
                var icon = (_this_shadowRoot = this.shadowRoot) === null || _this_shadowRoot === void 0 ? void 0 : _this_shadowRoot.querySelector("wui-icon");
                if (this.enableAccordion) {
                    this.toggled = !this.toggled;
                    this.requestUpdate();
                    if (this.scrollElement) this.scrollElement.animate([
                        {
                            maxHeight: this.toggled ? "".concat($dbc8897fe12f920e$var$MAX_HEIGHT, "px") : "".concat(this.scrollHeightElement, "px")
                        },
                        {
                            maxHeight: this.toggled ? "".concat(this.scrollHeightElement, "px") : "".concat($dbc8897fe12f920e$var$MAX_HEIGHT, "px")
                        }
                    ], {
                        duration: 300,
                        fill: "forwards",
                        easing: "ease"
                    });
                    if (icon) icon.animate([
                        {
                            transform: this.toggled ? "rotate(0deg)" : "rotate(180deg)"
                        },
                        {
                            transform: this.toggled ? "rotate(180deg)" : "rotate(0deg)"
                        }
                    ], {
                        duration: 300,
                        fill: "forwards",
                        easing: "ease"
                    });
                }
            }
        },
        {
            key: "chevronTemplate",
            value: function chevronTemplate() {
                if (this.enableAccordion) return (0, $1lUIm.html)($dbc8897fe12f920e$var$_templateObject1());
                return null;
            }
        }
    ]);
    return WuiListAccordion;
}((0, $eAsDt.LitElement));
$dbc8897fe12f920e$export$f885ba019a6ba4db.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $1FVnL.default)
];
$dbc8897fe12f920e$var$__decorate([
    (0, $siQym.property)()
], $dbc8897fe12f920e$export$f885ba019a6ba4db.prototype, "textTitle", void 0);
$dbc8897fe12f920e$var$__decorate([
    (0, $siQym.property)()
], $dbc8897fe12f920e$export$f885ba019a6ba4db.prototype, "overflowedContent", void 0);
$dbc8897fe12f920e$export$f885ba019a6ba4db = $dbc8897fe12f920e$var$__decorate([
    (0, $hdxb6.customElement)("wui-list-accordion")
], $dbc8897fe12f920e$export$f885ba019a6ba4db);

});
parcelRegister("1FVnL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $138621b3de9e14b1$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $138621b3de9e14b1$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  button {\n    height: auto;\n    position: relative;\n    flex-direction: column;\n    gap: var(--wui-spacing-s);\n    padding: 17px 18px 17px var(--wui-spacing-m);\n    width: 100%;\n    background-color: var(--wui-color-gray-glass-002);\n    border-radius: var(--wui-border-radius-xs);\n    color: var(--wui-color-fg-250);\n  }\n\n  .overflowedContent {\n    width: 100%;\n    overflow: hidden;\n  }\n\n  .overflowedContent[data-active='false']:after {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: linear-gradient(to top, var(--wui-color-bg-150), transparent);\n    border-bottom-left-radius: var(--wui-border-radius-xs);\n    border-bottom-right-radius: var(--wui-border-radius-xs);\n  }\n\n  .heightContent {\n    max-height: 100px;\n  }\n\n  pre {\n    text-align: left;\n    white-space: pre-wrap;\n    height: auto;\n    overflow-x: auto;\n    overflow-wrap: anywhere;\n  }\n"
    ]);
    $138621b3de9e14b1$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $138621b3de9e14b1$export$2e2bcd8739ae039 = (0, $bBWVO.css)($138621b3de9e14b1$var$_templateObject());

});


parcelRegister("2wYvx", function(module, exports) {

$parcel$export(module.exports, "WuiListContent", function () { return $1d7d817dfbe4e04d$export$621c7f09b7560b89; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("dcd5U");
parcelRequire("9ZbyK");
parcelRequire("1OYaf");
parcelRequire("8tnK2");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $2rGNd = parcelRequire("2rGNd");
function $1d7d817dfbe4e04d$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex justifyContent="space-between" alignItems="center">\n        <wui-text variant="paragraph-500" color=',
        ">\n          ",
        "\n        </wui-text>\n        ",
        "\n      </wui-flex>\n    "
    ]);
    $1d7d817dfbe4e04d$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $1d7d817dfbe4e04d$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "<wui-image src=",
        " alt=",
        "></wui-image>"
    ]);
    $1d7d817dfbe4e04d$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $1d7d817dfbe4e04d$var$_templateObject2() {
    var data = (0, $j06k0._)([
        ' <wui-text variant="paragraph-400" color="fg-100"> ',
        " </wui-text>"
    ]);
    $1d7d817dfbe4e04d$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $1d7d817dfbe4e04d$var$_templateObject3() {
    var data = (0, $j06k0._)([
        '<wui-icon size="inherit" color="fg-200" name="networkPlaceholder"></wui-icon>'
    ]);
    $1d7d817dfbe4e04d$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var $1d7d817dfbe4e04d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $1d7d817dfbe4e04d$export$621c7f09b7560b89 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiListContent, LitElement);
    var _super = (0, $ohfOJ._)(WuiListContent);
    function WuiListContent() {
        (0, $4GJKx._)(this, WuiListContent);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.imageSrc = undefined;
        _this.textTitle = "";
        _this.textValue = undefined;
        return _this;
    }
    (0, $1wc17._)(WuiListContent, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($1d7d817dfbe4e04d$var$_templateObject(), this.textValue ? "fg-200" : "fg-100", this.textTitle, this.templateContent());
            }
        },
        {
            key: "templateContent",
            value: function templateContent() {
                if (this.imageSrc) return (0, $1lUIm.html)($1d7d817dfbe4e04d$var$_templateObject1(), this.imageSrc, this.textTitle);
                else if (this.textValue) return (0, $1lUIm.html)($1d7d817dfbe4e04d$var$_templateObject2(), this.textValue);
                return (0, $1lUIm.html)($1d7d817dfbe4e04d$var$_templateObject3());
            }
        }
    ]);
    return WuiListContent;
}((0, $eAsDt.LitElement));
$1d7d817dfbe4e04d$export$621c7f09b7560b89.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $2rGNd.default)
];
$1d7d817dfbe4e04d$var$__decorate([
    (0, $siQym.property)()
], $1d7d817dfbe4e04d$export$621c7f09b7560b89.prototype, "imageSrc", void 0);
$1d7d817dfbe4e04d$var$__decorate([
    (0, $siQym.property)()
], $1d7d817dfbe4e04d$export$621c7f09b7560b89.prototype, "textTitle", void 0);
$1d7d817dfbe4e04d$var$__decorate([
    (0, $siQym.property)()
], $1d7d817dfbe4e04d$export$621c7f09b7560b89.prototype, "textValue", void 0);
$1d7d817dfbe4e04d$export$621c7f09b7560b89 = $1d7d817dfbe4e04d$var$__decorate([
    (0, $hdxb6.customElement)("wui-list-content")
], $1d7d817dfbe4e04d$export$621c7f09b7560b89);

});
parcelRegister("2rGNd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c7f4c25df347a26$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $1c7f4c25df347a26$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: flex;\n    column-gap: var(--wui-spacing-s);\n    padding: 17px 18px 17px var(--wui-spacing-m);\n    width: 100%;\n    background-color: var(--wui-color-gray-glass-002);\n    border-radius: var(--wui-border-radius-xs);\n    color: var(--wui-color-fg-250);\n  }\n\n  wui-image {\n    width: var(--wui-icon-size-lg);\n    height: var(--wui-icon-size-lg);\n    border-radius: var(--wui-border-radius-3xl);\n  }\n\n  wui-icon {\n    width: var(--wui-icon-size-lg);\n    height: var(--wui-icon-size-lg);\n  }\n"
    ]);
    $1c7f4c25df347a26$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $1c7f4c25df347a26$export$2e2bcd8739ae039 = (0, $bBWVO.css)($1c7f4c25df347a26$var$_templateObject());

});


parcelRegister("lf3eR", function(module, exports) {

$parcel$export(module.exports, "WuiListNetwork", function () { return $f76d82d3dc76acc5$export$f7ecfb3cf2878ec8; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("1OYaf");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("9zFRT");

var $2Laf1 = parcelRequire("2Laf1");
function $f76d82d3dc76acc5$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      <button data-transparent=",
        " ?disabled=",
        ' ontouchstart>\n        <wui-flex gap="s" alignItems="center">\n          ',
        '\n          <wui-text variant="paragraph-500" color="inherit">',
        "</wui-text></wui-flex\n        >\n        ",
        "\n      </button>\n    "
    ]);
    $f76d82d3dc76acc5$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $f76d82d3dc76acc5$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '<wui-icon size="sm" color="accent-100" name="checkmarkBold"></wui-icon>'
    ]);
    $f76d82d3dc76acc5$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $f76d82d3dc76acc5$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '<wui-image size="sm" src=',
        " name=",
        "></wui-image>"
    ]);
    $f76d82d3dc76acc5$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $f76d82d3dc76acc5$var$_templateObject3() {
    var data = (0, $j06k0._)([
        "<wui-network-image\n        ?round=",
        '\n        size="md"\n        name=',
        "\n      ></wui-network-image>"
    ]);
    $f76d82d3dc76acc5$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var $f76d82d3dc76acc5$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f76d82d3dc76acc5$export$f7ecfb3cf2878ec8 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiListNetwork, LitElement);
    var _super = (0, $ohfOJ._)(WuiListNetwork);
    function WuiListNetwork() {
        (0, $4GJKx._)(this, WuiListNetwork);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.imageSrc = "";
        _this.name = "";
        _this.disabled = false;
        _this.selected = false;
        _this.transparent = false;
        return _this;
    }
    (0, $1wc17._)(WuiListNetwork, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($f76d82d3dc76acc5$var$_templateObject(), this.transparent, this.disabled, this.templateNetworkImage(), this.name, this.checkmarkTemplate());
            }
        },
        {
            key: "checkmarkTemplate",
            value: function checkmarkTemplate() {
                if (this.selected) return (0, $1lUIm.html)($f76d82d3dc76acc5$var$_templateObject1());
                return null;
            }
        },
        {
            key: "templateNetworkImage",
            value: function templateNetworkImage() {
                if (this.imageSrc) return (0, $1lUIm.html)($f76d82d3dc76acc5$var$_templateObject2(), this.imageSrc, this.name);
                if (!this.imageSrc) return (0, $1lUIm.html)($f76d82d3dc76acc5$var$_templateObject3(), true, this.name);
                return null;
            }
        }
    ]);
    return WuiListNetwork;
}((0, $eAsDt.LitElement));
$f76d82d3dc76acc5$export$f7ecfb3cf2878ec8.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $2Laf1.default)
];
$f76d82d3dc76acc5$var$__decorate([
    (0, $siQym.property)()
], $f76d82d3dc76acc5$export$f7ecfb3cf2878ec8.prototype, "imageSrc", void 0);
$f76d82d3dc76acc5$var$__decorate([
    (0, $siQym.property)()
], $f76d82d3dc76acc5$export$f7ecfb3cf2878ec8.prototype, "name", void 0);
$f76d82d3dc76acc5$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $f76d82d3dc76acc5$export$f7ecfb3cf2878ec8.prototype, "disabled", void 0);
$f76d82d3dc76acc5$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $f76d82d3dc76acc5$export$f7ecfb3cf2878ec8.prototype, "selected", void 0);
$f76d82d3dc76acc5$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $f76d82d3dc76acc5$export$f7ecfb3cf2878ec8.prototype, "transparent", void 0);
$f76d82d3dc76acc5$export$f7ecfb3cf2878ec8 = $f76d82d3dc76acc5$var$__decorate([
    (0, $hdxb6.customElement)("wui-list-network")
], $f76d82d3dc76acc5$export$f7ecfb3cf2878ec8);

});
parcelRegister("2Laf1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2027ea440257fb67$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $2027ea440257fb67$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  button {\n    column-gap: var(--wui-spacing-s);\n    padding: 7px var(--wui-spacing-l) 7px var(--wui-spacing-xs);\n    width: 100%;\n    transition: all var(--wui-ease-out-power-1) var(--wui-duration-md);\n    border-radius: var(--wui-border-radius-xs);\n    color: var(--wui-color-fg-100);\n  }\n\n  button > wui-text:nth-child(2) {\n    display: flex;\n    flex: 1;\n  }\n\n  button[data-transparent='true'] {\n    pointer-events: none;\n    background-color: transparent;\n  }\n\n  button:hover {\n    background-color: var(--wui-color-gray-glass-002);\n  }\n\n  button:active {\n    background-color: var(--wui-color-gray-glass-005);\n  }\n\n  wui-image {\n    width: var(--wui-spacing-3xl);\n    height: var(--wui-spacing-3xl);\n    border-radius: 100%;\n  }\n\n  button:disabled {\n    background-color: var(--wui-color-gray-glass-002);\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  button:disabled > wui-tag {\n    background-color: var(--wui-color-gray-glass-010);\n    color: var(--wui-color-fg-300);\n  }\n"
    ]);
    $2027ea440257fb67$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $2027ea440257fb67$export$2e2bcd8739ae039 = (0, $bBWVO.css)($2027ea440257fb67$var$_templateObject());

});


parcelRegister("jDyRd", function(module, exports) {

$parcel$export(module.exports, "WuiListWalletTransaction", function () { return $e4bcb2c29c1455b6$export$fc79cdc2df8cc885; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("dcd5U");
parcelRequire("9ZbyK");
parcelRequire("1OYaf");
parcelRequire("612c2");
parcelRequire("8tnK2");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $d3OYq = parcelRequire("d3OYq");
function $e4bcb2c29c1455b6$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex justifyContent="space-between" alignItems="center">\n        <wui-text variant="paragraph-500" color="fg-200">Sending</wui-text>\n        <wui-flex gap="xs" alignItems="center">\n          <wui-text variant="paragraph-400" color="fg-100">\n            ',
        " ",
        "\n          </wui-text>\n          ",
        '\n        </wui-flex>\n      </wui-flex>\n      <wui-flex justifyContent="space-between" alignItems="center">\n        <wui-text variant="paragraph-500" color="fg-200">To</wui-text>\n        <wui-chip\n          icon="externalLink"\n          variant="shadeSmall"\n          href=',
        "\n          title=",
        "\n        ></wui-chip>\n      </wui-flex>\n    "
    ]);
    $e4bcb2c29c1455b6$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $e4bcb2c29c1455b6$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "<wui-image src=",
        ' alt="Network Image"></wui-image>'
    ]);
    $e4bcb2c29c1455b6$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $e4bcb2c29c1455b6$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '<wui-icon size="inherit" color="fg-200" name="networkPlaceholder"></wui-icon>'
    ]);
    $e4bcb2c29c1455b6$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $e4bcb2c29c1455b6$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $e4bcb2c29c1455b6$export$fc79cdc2df8cc885 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiListWalletTransaction, LitElement);
    var _super = (0, $ohfOJ._)(WuiListWalletTransaction);
    function WuiListWalletTransaction() {
        (0, $4GJKx._)(this, WuiListWalletTransaction);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.amount = "";
        _this.networkCurreny = "";
        _this.networkImageUrl = "";
        _this.receiverAddress = "";
        _this.addressExplorerUrl = "";
        return _this;
    }
    (0, $1wc17._)(WuiListWalletTransaction, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($e4bcb2c29c1455b6$var$_templateObject(), this.amount, this.networkCurreny, this.templateNetworkVisual(), this.addressExplorerUrl, this.receiverAddress);
            }
        },
        {
            key: "templateNetworkVisual",
            value: function templateNetworkVisual() {
                if (this.networkImageUrl) return (0, $1lUIm.html)($e4bcb2c29c1455b6$var$_templateObject1(), this.networkImageUrl);
                return (0, $1lUIm.html)($e4bcb2c29c1455b6$var$_templateObject2());
            }
        }
    ]);
    return WuiListWalletTransaction;
}((0, $eAsDt.LitElement));
$e4bcb2c29c1455b6$export$fc79cdc2df8cc885.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $d3OYq.default)
];
$e4bcb2c29c1455b6$var$__decorate([
    (0, $siQym.property)()
], $e4bcb2c29c1455b6$export$fc79cdc2df8cc885.prototype, "amount", void 0);
$e4bcb2c29c1455b6$var$__decorate([
    (0, $siQym.property)()
], $e4bcb2c29c1455b6$export$fc79cdc2df8cc885.prototype, "networkCurreny", void 0);
$e4bcb2c29c1455b6$var$__decorate([
    (0, $siQym.property)()
], $e4bcb2c29c1455b6$export$fc79cdc2df8cc885.prototype, "networkImageUrl", void 0);
$e4bcb2c29c1455b6$var$__decorate([
    (0, $siQym.property)()
], $e4bcb2c29c1455b6$export$fc79cdc2df8cc885.prototype, "receiverAddress", void 0);
$e4bcb2c29c1455b6$var$__decorate([
    (0, $siQym.property)()
], $e4bcb2c29c1455b6$export$fc79cdc2df8cc885.prototype, "addressExplorerUrl", void 0);
$e4bcb2c29c1455b6$export$fc79cdc2df8cc885 = $e4bcb2c29c1455b6$var$__decorate([
    (0, $hdxb6.customElement)("wui-list-wallet-transaction")
], $e4bcb2c29c1455b6$export$fc79cdc2df8cc885);

});
parcelRegister("d3OYq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9823187b2f8d3eea$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $9823187b2f8d3eea$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: flex;\n    flex-direction: column;\n    gap: var(--wui-spacing-l);\n    padding: 17px 18px 17px var(--wui-spacing-m);\n    width: 100%;\n    background-color: var(--wui-color-gray-glass-002);\n    border-radius: var(--wui-border-radius-xs);\n    color: var(--wui-color-fg-250);\n  }\n\n  wui-image {\n    width: var(--wui-icon-size-lg);\n    height: var(--wui-icon-size-lg);\n    border-radius: var(--wui-border-radius-3xl);\n  }\n\n  wui-icon {\n    width: var(--wui-icon-size-lg);\n    height: var(--wui-icon-size-lg);\n  }\n"
    ]);
    $9823187b2f8d3eea$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $9823187b2f8d3eea$export$2e2bcd8739ae039 = (0, $bBWVO.css)($9823187b2f8d3eea$var$_templateObject());

});


parcelRegister("l8uRs", function(module, exports) {

$parcel$export(module.exports, "WuiPromo", function () { return $f63248b494f83430$export$73a995aef5d1b186; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");

var $hdxb6 = parcelRequire("hdxb6");

var $i9ubo = parcelRequire("i9ubo");
parcelRequire("1OYaf");
parcelRequire("dcd5U");

var $kYNxm = parcelRequire("kYNxm");
function $f63248b494f83430$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<button ontouchstart>\n      <wui-text variant="small-600" color="bg-100">',
        '</wui-text>\n      <wui-icon color="bg-100" size="xs" name="arrowRight"></wui-icon>\n    </button>'
    ]);
    $f63248b494f83430$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $f63248b494f83430$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f63248b494f83430$export$73a995aef5d1b186 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiPromo, LitElement);
    var _super = (0, $ohfOJ._)(WuiPromo);
    function WuiPromo() {
        (0, $4GJKx._)(this, WuiPromo);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.text = "";
        return _this;
    }
    (0, $1wc17._)(WuiPromo, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($f63248b494f83430$var$_templateObject(), this.text);
            }
        }
    ]);
    return WuiPromo;
}((0, $eAsDt.LitElement));
$f63248b494f83430$export$73a995aef5d1b186.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $i9ubo.default)
];
$f63248b494f83430$var$__decorate([
    (0, $siQym.property)()
], $f63248b494f83430$export$73a995aef5d1b186.prototype, "text", void 0);
$f63248b494f83430$export$73a995aef5d1b186 = $f63248b494f83430$var$__decorate([
    (0, $hdxb6.customElement)("wui-promo")
], $f63248b494f83430$export$73a995aef5d1b186);

});
parcelRegister("i9ubo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3707ae92e1cddb0$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $d3707ae92e1cddb0$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  button {\n    display: flex;\n    gap: var(--wui-spacing-3xs);\n    align-items: center;\n    padding: 6.25px var(--wui-spacing-xs) 7.25px var(--wui-spacing-s);\n    background-color: var(--wui-color-gray-glass-090);\n    border-radius: var(--wui-border-radius-3xl);\n    border: 1px solid var(--wui-color-gray-glass-060);\n    transition: background-color var(--wui-duration-md) var(--wui-ease-inout-power-1);\n    will-change: background-color;\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    button:hover:enabled {\n      background-color: var(--wui-color-gray-glass-080);\n    }\n\n    button:active:enabled {\n      background-color: var(--wui-color-gray-glass-060);\n    }\n  }\n"
    ]);
    $d3707ae92e1cddb0$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $d3707ae92e1cddb0$export$2e2bcd8739ae039 = (0, $bBWVO.css)($d3707ae92e1cddb0$var$_templateObject());

});


parcelRegister("7C6VO", function(module, exports) {

$parcel$export(module.exports, "WuiBalance", function () { return $58b175745559ffd1$export$cc964192ca050c2f; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");

var $hdxb6 = parcelRequire("hdxb6");

var $611Lq = parcelRequire("611Lq");

var $kYNxm = parcelRequire("kYNxm");
function $58b175745559ffd1$var$_templateObject() {
    var data = (0, $j06k0._)([
        "<span>$",
        '<span class="pennies">.',
        "</span></span>"
    ]);
    $58b175745559ffd1$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $58b175745559ffd1$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $58b175745559ffd1$export$cc964192ca050c2f = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiBalance, LitElement);
    var _super = (0, $ohfOJ._)(WuiBalance);
    function WuiBalance() {
        (0, $4GJKx._)(this, WuiBalance);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.dollars = "0";
        _this.pennies = "00";
        return _this;
    }
    (0, $1wc17._)(WuiBalance, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($58b175745559ffd1$var$_templateObject(), this.dollars, this.pennies);
            }
        }
    ]);
    return WuiBalance;
}((0, $eAsDt.LitElement));
$58b175745559ffd1$export$cc964192ca050c2f.styles = [
    (0, $kYNxm.resetStyles),
    (0, $611Lq.default)
];
$58b175745559ffd1$var$__decorate([
    (0, $siQym.property)()
], $58b175745559ffd1$export$cc964192ca050c2f.prototype, "dollars", void 0);
$58b175745559ffd1$var$__decorate([
    (0, $siQym.property)()
], $58b175745559ffd1$export$cc964192ca050c2f.prototype, "pennies", void 0);
$58b175745559ffd1$export$cc964192ca050c2f = $58b175745559ffd1$var$__decorate([
    (0, $hdxb6.customElement)("wui-balance")
], $58b175745559ffd1$export$cc964192ca050c2f);

});
parcelRegister("611Lq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $461434572449c647$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $461434572449c647$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  span {\n    font-weight: 500;\n    font-size: 40px;\n    color: var(--wui-color-fg-100);\n    line-height: 130%; /* 52px */\n    letter-spacing: -1.6px;\n    text-align: center;\n  }\n\n  .pennies {\n    color: var(--wui-color-fg-200);\n  }\n"
    ]);
    $461434572449c647$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $461434572449c647$export$2e2bcd8739ae039 = (0, $bBWVO.css)($461434572449c647$var$_templateObject());

});


parcelRegister("cwlkt", function(module, exports) {

$parcel$export(module.exports, "WuiProfileButton", function () { return $91d904b72f7560ad$export$7833c7acf4c9684a; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("dcd5U");
parcelRequire("1OYaf");
parcelRequire("9ZbyK");
parcelRequire("8tnK2");
parcelRequire("eDRu8");
parcelRequire("8jknp");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $foLp5 = parcelRequire("foLp5");

var $dI7zX = parcelRequire("dI7zX");
function $91d904b72f7560ad$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<button ontouchstart data-testid="wui-profile-button">\n      <wui-flex gap="xs" alignItems="center">\n        <wui-avatar\n          .imageSrc=',
        "\n          alt=",
        "\n          address=",
        "\n        ></wui-avatar>\n        ",
        '\n        <wui-flex gap="xs" alignItems="center">\n          <wui-text variant="large-600" color="fg-100">\n            ',
        '\n          </wui-text>\n          <wui-icon size="sm" color="fg-200" name=',
        "></wui-icon>\n        </wui-flex>\n      </wui-flex>\n    </button>"
    ]);
    $91d904b72f7560ad$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $91d904b72f7560ad$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "<wui-image src=",
        "></wui-image>"
    ]);
    $91d904b72f7560ad$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $91d904b72f7560ad$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '\n      <wui-icon-box\n        size="xxs"\n        iconColor="fg-200"\n        backgroundColor="bg-100"\n        icon="networkPlaceholder"\n      ></wui-icon-box>\n    '
    ]);
    $91d904b72f7560ad$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $91d904b72f7560ad$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $91d904b72f7560ad$export$7833c7acf4c9684a = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiProfileButton, LitElement);
    var _super = (0, $ohfOJ._)(WuiProfileButton);
    function WuiProfileButton() {
        (0, $4GJKx._)(this, WuiProfileButton);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.networkSrc = undefined;
        _this.avatarSrc = undefined;
        _this.profileName = "";
        _this.address = "";
        _this.icon = "chevronBottom";
        return _this;
    }
    (0, $1wc17._)(WuiProfileButton, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($91d904b72f7560ad$var$_templateObject(), this.avatarSrc, this.address, this.address, this.networkImageTemplate(), (0, $dI7zX.UiHelperUtil).getTruncateString({
                    string: this.profileName || this.address,
                    charsStart: this.profileName ? 18 : 4,
                    charsEnd: this.profileName ? 0 : 4,
                    truncate: this.profileName ? "end" : "middle"
                }), this.icon);
            }
        },
        {
            key: "networkImageTemplate",
            value: function networkImageTemplate() {
                if (this.networkSrc) return (0, $1lUIm.html)($91d904b72f7560ad$var$_templateObject1(), this.networkSrc);
                return (0, $1lUIm.html)($91d904b72f7560ad$var$_templateObject2());
            }
        }
    ]);
    return WuiProfileButton;
}((0, $eAsDt.LitElement));
$91d904b72f7560ad$export$7833c7acf4c9684a.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $foLp5.default)
];
$91d904b72f7560ad$var$__decorate([
    (0, $siQym.property)()
], $91d904b72f7560ad$export$7833c7acf4c9684a.prototype, "networkSrc", void 0);
$91d904b72f7560ad$var$__decorate([
    (0, $siQym.property)()
], $91d904b72f7560ad$export$7833c7acf4c9684a.prototype, "avatarSrc", void 0);
$91d904b72f7560ad$var$__decorate([
    (0, $siQym.property)()
], $91d904b72f7560ad$export$7833c7acf4c9684a.prototype, "profileName", void 0);
$91d904b72f7560ad$var$__decorate([
    (0, $siQym.property)()
], $91d904b72f7560ad$export$7833c7acf4c9684a.prototype, "address", void 0);
$91d904b72f7560ad$var$__decorate([
    (0, $siQym.property)()
], $91d904b72f7560ad$export$7833c7acf4c9684a.prototype, "icon", void 0);
$91d904b72f7560ad$export$7833c7acf4c9684a = $91d904b72f7560ad$var$__decorate([
    (0, $hdxb6.customElement)("wui-profile-button")
], $91d904b72f7560ad$export$7833c7acf4c9684a);

});
parcelRegister("foLp5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b35dde4b75db1c7f$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $b35dde4b75db1c7f$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  button {\n    background-color: var(--wui-color-gray-glass-002);\n    border-radius: var(--wui-border-radius-3xl);\n    border: 1px solid var(--wui-color-gray-glass-002);\n    padding: var(--wui-spacing-xs) var(--wui-spacing-s) var(--wui-spacing-xs) var(--wui-spacing-xs);\n    position: relative;\n  }\n\n  wui-avatar {\n    width: 32px;\n    height: 32px;\n    box-shadow: 0 0 0 0;\n    outline: 3px solid var(--wui-color-gray-glass-005);\n  }\n\n  wui-icon-box,\n  wui-image {\n    width: 16px;\n    height: 16px;\n    border-radius: var(--wui-border-radius-3xl);\n    position: absolute;\n    left: 26px;\n    top: 24px;\n  }\n\n  wui-image {\n    outline: 2px solid var(--wui-color-bg-125);\n  }\n\n  wui-icon-box {\n    outline: 2px solid var(--wui-color-bg-200);\n    background-color: var(--wui-color-bg-250);\n  }\n"
    ]);
    $b35dde4b75db1c7f$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $b35dde4b75db1c7f$export$2e2bcd8739ae039 = (0, $bBWVO.css)($b35dde4b75db1c7f$var$_templateObject());

});


parcelRegister("auSD5", function(module, exports) {

$parcel$export(module.exports, "WuiProfileButtonV2", function () { return $7a471501173c115a$export$ceb46aef168f6a4d; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("dcd5U");
parcelRequire("1OYaf");
parcelRequire("9ZbyK");
parcelRequire("8tnK2");
parcelRequire("eDRu8");
parcelRequire("8jknp");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $19WNR = parcelRequire("19WNR");

var $dI7zX = parcelRequire("dI7zX");
parcelRequire("cwWZ7");
var $i7zcD = parcelRequire("i7zcD");
function $7a471501173c115a$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<button ontouchstart data-testid="wui-profile-button" @click=',
        '>\n      <wui-flex gap="xs" alignItems="center">\n        <wui-avatar\n          .imageSrc=',
        "\n          alt=",
        "\n          address=",
        "\n        ></wui-avatar>\n        ",
        '\n        <wui-flex gap="xs" alignItems="center">\n          <wui-text variant="large-600" color="fg-100">\n            ',
        '\n          </wui-text>\n          <wui-icon size="sm" color="fg-200" name="copy" id="copy-address"></wui-icon>\n        </wui-flex>\n      </wui-flex>\n    </button>'
    ]);
    $7a471501173c115a$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $7a471501173c115a$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '\n      <wui-icon-box\n        size="xxs"\n        iconColor="fg-200"\n        backgroundColor="bg-100"\n        icon="',
        '"\n      ></wui-icon-box>\n    '
    ]);
    $7a471501173c115a$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $7a471501173c115a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $7a471501173c115a$export$ceb46aef168f6a4d = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiProfileButtonV2, LitElement);
    var _super = (0, $ohfOJ._)(WuiProfileButtonV2);
    function WuiProfileButtonV2() {
        (0, $4GJKx._)(this, WuiProfileButtonV2);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.avatarSrc = undefined;
        _this.profileName = "";
        _this.address = "";
        _this.icon = "mail";
        _this.connectedConnector = (0, $i7zcD.StorageUtil).getConnectedConnector();
        _this.shouldShowIcon = _this.connectedConnector === "AUTH";
        return _this;
    }
    (0, $1wc17._)(WuiProfileButtonV2, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($7a471501173c115a$var$_templateObject(), this.handleClick, this.avatarSrc, this.address, this.address, this.shouldShowIcon ? this.getIconTemplate(this.icon) : "", (0, $dI7zX.UiHelperUtil).getTruncateString({
                    string: this.profileName || this.address,
                    charsStart: this.profileName ? 18 : 4,
                    charsEnd: this.profileName ? 0 : 4,
                    truncate: this.profileName ? "end" : "middle"
                }));
            }
        },
        {
            key: "handleClick",
            value: function handleClick(event) {
                var _this_onProfileClick, _this;
                if (event.target instanceof HTMLElement && event.target.id === "copy-address") {
                    var _this_onCopyClick, _this1;
                    (_this_onCopyClick = (_this1 = this).onCopyClick) === null || _this_onCopyClick === void 0 ? void 0 : _this_onCopyClick.call(_this1, event);
                    return;
                }
                (_this_onProfileClick = (_this = this).onProfileClick) === null || _this_onProfileClick === void 0 ? void 0 : _this_onProfileClick.call(_this, event);
            }
        },
        {
            key: "getIconTemplate",
            value: function getIconTemplate(icon) {
                return (0, $1lUIm.html)($7a471501173c115a$var$_templateObject1(), icon || "networkPlaceholder");
            }
        }
    ]);
    return WuiProfileButtonV2;
}((0, $eAsDt.LitElement));
$7a471501173c115a$export$ceb46aef168f6a4d.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $19WNR.default)
];
$7a471501173c115a$var$__decorate([
    (0, $siQym.property)()
], $7a471501173c115a$export$ceb46aef168f6a4d.prototype, "avatarSrc", void 0);
$7a471501173c115a$var$__decorate([
    (0, $siQym.property)()
], $7a471501173c115a$export$ceb46aef168f6a4d.prototype, "profileName", void 0);
$7a471501173c115a$var$__decorate([
    (0, $siQym.property)()
], $7a471501173c115a$export$ceb46aef168f6a4d.prototype, "address", void 0);
$7a471501173c115a$var$__decorate([
    (0, $siQym.property)()
], $7a471501173c115a$export$ceb46aef168f6a4d.prototype, "icon", void 0);
$7a471501173c115a$var$__decorate([
    (0, $siQym.property)()
], $7a471501173c115a$export$ceb46aef168f6a4d.prototype, "onProfileClick", void 0);
$7a471501173c115a$var$__decorate([
    (0, $siQym.property)()
], $7a471501173c115a$export$ceb46aef168f6a4d.prototype, "onCopyClick", void 0);
$7a471501173c115a$export$ceb46aef168f6a4d = $7a471501173c115a$var$__decorate([
    (0, $hdxb6.customElement)("wui-profile-button-v2")
], $7a471501173c115a$export$ceb46aef168f6a4d);

});
parcelRegister("19WNR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d843ec7e1eac4cf$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $0d843ec7e1eac4cf$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  button {\n    background-color: var(--wui-color-gray-glass-002);\n    border-radius: var(--wui-border-radius-3xl);\n    border: 1px solid var(--wui-color-gray-glass-002);\n    padding: var(--wui-spacing-xs) var(--wui-spacing-s) var(--wui-spacing-xs) var(--wui-spacing-xs);\n    position: relative;\n  }\n\n  wui-avatar {\n    width: 32px;\n    height: 32px;\n    box-shadow: 0 0 0 0;\n    outline: 3px solid var(--wui-color-gray-glass-005);\n  }\n\n  wui-icon-box,\n  wui-image {\n    width: 16px;\n    height: 16px;\n    border-radius: var(--wui-border-radius-3xl);\n    position: absolute;\n    left: 26px;\n    top: 24px;\n  }\n\n  wui-image {\n    outline: 2px solid var(--wui-color-bg-125);\n  }\n\n  wui-icon-box {\n    outline: 2px solid var(--wui-color-bg-200);\n    background-color: var(--wui-color-bg-250);\n  }\n"
    ]);
    $0d843ec7e1eac4cf$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $0d843ec7e1eac4cf$export$2e2bcd8739ae039 = (0, $bBWVO.css)($0d843ec7e1eac4cf$var$_templateObject());

});


parcelRegister("4fdE7", function(module, exports) {

$parcel$export(module.exports, "WuiChipButton", function () { return $317325fafea3c341$export$f49ca3c577c0b16f; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("dcd5U");
parcelRequire("9ZbyK");
parcelRequire("1OYaf");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $d5Gs2 = parcelRequire("d5Gs2");
function $317325fafea3c341$var$_templateObject() {
    var data = (0, $j06k0._)([
        "<wui-image src=",
        "></wui-image>"
    ]);
    $317325fafea3c341$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $317325fafea3c341$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "\n      <button\n        class=",
        "\n        data-variant=",
        "\n        data-size=",
        "\n      >\n        ",
        "\n        <wui-text variant=",
        ' color="inherit"> ',
        " </wui-text>\n        <wui-icon name=",
        ' color="inherit" size="inherit"></wui-icon>\n      </button>\n    '
    ]);
    $317325fafea3c341$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $317325fafea3c341$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $317325fafea3c341$export$f49ca3c577c0b16f = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiChipButton, LitElement);
    var _super = (0, $ohfOJ._)(WuiChipButton);
    function WuiChipButton() {
        (0, $4GJKx._)(this, WuiChipButton);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.variant = "accent";
        _this.imageSrc = "";
        _this.disabled = false;
        _this.icon = "externalLink";
        _this.size = "md";
        _this.text = "";
        return _this;
    }
    (0, $1wc17._)(WuiChipButton, [
        {
            key: "render",
            value: function render() {
                var textVariant = this.size === "sm" ? "small-600" : "paragraph-600";
                return (0, $1lUIm.html)($317325fafea3c341$var$_templateObject1(), this.disabled ? "disabled" : "", this.variant, this.size, this.imageSrc ? (0, $1lUIm.html)($317325fafea3c341$var$_templateObject(), this.imageSrc) : null, textVariant, this.text, this.icon);
            }
        }
    ]);
    return WuiChipButton;
}((0, $eAsDt.LitElement));
$317325fafea3c341$export$f49ca3c577c0b16f.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $d5Gs2.default)
];
$317325fafea3c341$var$__decorate([
    (0, $siQym.property)()
], $317325fafea3c341$export$f49ca3c577c0b16f.prototype, "variant", void 0);
$317325fafea3c341$var$__decorate([
    (0, $siQym.property)()
], $317325fafea3c341$export$f49ca3c577c0b16f.prototype, "imageSrc", void 0);
$317325fafea3c341$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $317325fafea3c341$export$f49ca3c577c0b16f.prototype, "disabled", void 0);
$317325fafea3c341$var$__decorate([
    (0, $siQym.property)()
], $317325fafea3c341$export$f49ca3c577c0b16f.prototype, "icon", void 0);
$317325fafea3c341$var$__decorate([
    (0, $siQym.property)()
], $317325fafea3c341$export$f49ca3c577c0b16f.prototype, "size", void 0);
$317325fafea3c341$var$__decorate([
    (0, $siQym.property)()
], $317325fafea3c341$export$f49ca3c577c0b16f.prototype, "text", void 0);
$317325fafea3c341$export$f49ca3c577c0b16f = $317325fafea3c341$var$__decorate([
    (0, $hdxb6.customElement)("wui-chip-button")
], $317325fafea3c341$export$f49ca3c577c0b16f);

});
parcelRegister("d5Gs2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $987cabf149c91190$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $987cabf149c91190$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  button {\n    border: none;\n    border-radius: var(--wui-border-radius-3xl);\n  }\n\n  button[data-variant='main'] {\n    background-color: var(--wui-color-accent-100);\n    color: var(--wui-color-inverse-100);\n    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-010);\n  }\n\n  button[data-variant='accent'] {\n    background-color: var(--wui-color-accent-glass-010);\n    color: var(--wui-color-accent-100);\n    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-005);\n  }\n\n  button[data-variant='gray'] {\n    background-color: transparent;\n    color: var(--wui-color-fg-200);\n    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-010);\n  }\n\n  button[data-variant='shade'] {\n    background-color: transparent;\n    color: var(--wui-color-accent-100);\n    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-010);\n  }\n\n  button[data-size='sm'] {\n    height: 32px;\n    padding: 0 var(--wui-spacing-s);\n  }\n\n  button[data-size='md'] {\n    height: 40px;\n    padding: 0 var(--wui-spacing-l);\n  }\n\n  button[data-size='sm'] > wui-image {\n    width: 16px;\n    height: 16px;\n  }\n\n  button[data-size='md'] > wui-image {\n    width: 24px;\n    height: 24px;\n  }\n\n  button[data-size='sm'] > wui-icon {\n    width: 12px;\n    height: 12px;\n  }\n\n  button[data-size='md'] > wui-icon {\n    width: 14px;\n    height: 14px;\n  }\n\n  wui-image {\n    border-radius: var(--wui-border-radius-3xl);\n    overflow: hidden;\n  }\n\n  button.disabled > wui-icon,\n  button.disabled > wui-image {\n    filter: grayscale(1);\n  }\n\n  button[data-variant='main'] > wui-image {\n    box-shadow: inset 0 0 0 1px var(--wui-color-accent-090);\n  }\n\n  button[data-variant='shade'] > wui-image,\n  button[data-variant='gray'] > wui-image {\n    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-010);\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    button[data-variant='main']:focus-visible {\n      background-color: var(--wui-color-accent-090);\n    }\n\n    button[data-variant='main']:hover:enabled {\n      background-color: var(--wui-color-accent-090);\n    }\n\n    button[data-variant='main']:active:enabled {\n      background-color: var(--wui-color-accent-080);\n    }\n\n    button[data-variant='accent']:hover:enabled {\n      background-color: var(--wui-color-accent-glass-015);\n    }\n\n    button[data-variant='accent']:active:enabled {\n      background-color: var(--wui-color-accent-glass-020);\n    }\n\n    button[data-variant='shade']:focus-visible,\n    button[data-variant='gray']:focus-visible,\n    button[data-variant='shade']:hover,\n    button[data-variant='gray']:hover {\n      background-color: var(--wui-color-gray-glass-002);\n    }\n\n    button[data-variant='gray']:active,\n    button[data-variant='shade']:active {\n      background-color: var(--wui-color-gray-glass-005);\n    }\n  }\n\n  button.disabled {\n    color: var(--wui-color-gray-glass-020);\n    background-color: var(--wui-color-gray-glass-002);\n    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-002);\n    pointer-events: none;\n  }\n"
    ]);
    $987cabf149c91190$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $987cabf149c91190$export$2e2bcd8739ae039 = (0, $bBWVO.css)($987cabf149c91190$var$_templateObject());

});


parcelRegister("2Gkav", function(module, exports) {

$parcel$export(module.exports, "WuiCompatibleNetwork", function () { return $1f3f26100200335d$export$baf057fb6d6ac7c2; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("dcd5U");
parcelRequire("1OYaf");
parcelRequire("9ZbyK");
parcelRequire("8tnK2");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $eduhi = parcelRequire("eduhi");
function $1f3f26100200335d$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <button ontouchstart>\n        <wui-text variant="small-400" color="fg-200">',
        '</wui-text>\n        <wui-flex gap="3xs" alignItems="center">\n          ',
        '\n          <wui-icon name="chevronRight" size="sm" color="fg-200"></wui-icon>\n        </wui-flex>\n      </button>\n    '
    ]);
    $1f3f26100200335d$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $1f3f26100200335d$var$_templateObject1() {
    var data = (0, $j06k0._)([
        ' <wui-flex class="network-icon"> <wui-image src=',
        "></wui-image> </wui-flex>"
    ]);
    $1f3f26100200335d$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $1f3f26100200335d$var$_templateObject2() {
    var data = (0, $j06k0._)([
        ' <wui-flex class="networks">\n      ',
        "\n    </wui-flex>"
    ]);
    $1f3f26100200335d$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $1f3f26100200335d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $1f3f26100200335d$export$baf057fb6d6ac7c2 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiCompatibleNetwork, LitElement);
    var _super = (0, $ohfOJ._)(WuiCompatibleNetwork);
    function WuiCompatibleNetwork() {
        (0, $4GJKx._)(this, WuiCompatibleNetwork);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.networkImages = [
            ""
        ];
        _this.text = "";
        return _this;
    }
    (0, $1wc17._)(WuiCompatibleNetwork, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($1f3f26100200335d$var$_templateObject(), this.text, this.networksTemplate());
            }
        },
        {
            key: "networksTemplate",
            value: function networksTemplate() {
                var slicedNetworks = this.networkImages.slice(0, 5);
                return (0, $1lUIm.html)($1f3f26100200335d$var$_templateObject2(), slicedNetworks === null || slicedNetworks === void 0 ? void 0 : slicedNetworks.map(function(network) {
                    return (0, $1lUIm.html)($1f3f26100200335d$var$_templateObject1(), network);
                }));
            }
        }
    ]);
    return WuiCompatibleNetwork;
}((0, $eAsDt.LitElement));
$1f3f26100200335d$export$baf057fb6d6ac7c2.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $eduhi.default)
];
$1f3f26100200335d$var$__decorate([
    (0, $siQym.property)({
        type: Array
    })
], $1f3f26100200335d$export$baf057fb6d6ac7c2.prototype, "networkImages", void 0);
$1f3f26100200335d$var$__decorate([
    (0, $siQym.property)()
], $1f3f26100200335d$export$baf057fb6d6ac7c2.prototype, "text", void 0);
$1f3f26100200335d$export$baf057fb6d6ac7c2 = $1f3f26100200335d$var$__decorate([
    (0, $hdxb6.customElement)("wui-compatible-network")
], $1f3f26100200335d$export$baf057fb6d6ac7c2);

});
parcelRegister("eduhi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a599c429f9ee760a$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $a599c429f9ee760a$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  button {\n    display: flex;\n    gap: var(--wui-spacing-xl);\n    width: 100%;\n    background-color: var(--wui-color-gray-glass-002);\n    border-radius: var(--wui-border-radius-xxs);\n    padding: var(--wui-spacing-m) var(--wui-spacing-s);\n  }\n\n  wui-text {\n    width: 100%;\n  }\n\n  wui-flex {\n    width: auto;\n  }\n\n  .network-icon {\n    width: var(--wui-spacing-2l);\n    height: var(--wui-spacing-2l);\n    border-radius: calc(var(--wui-spacing-2l) / 2);\n    overflow: hidden;\n    box-shadow:\n      0 0 0 3px var(--wui-color-gray-glass-002),\n      0 0 0 3px var(--wui-color-modal-bg);\n  }\n"
    ]);
    $a599c429f9ee760a$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $a599c429f9ee760a$export$2e2bcd8739ae039 = (0, $bBWVO.css)($a599c429f9ee760a$var$_templateObject());

});


parcelRegister("aKoox", function(module, exports) {

$parcel$export(module.exports, "WuiBanner", function () { return $7d311f878f2f561a$export$51cf21fa3212b001; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("1OYaf");
parcelRequire("8jknp");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $9XTPl = parcelRequire("9XTPl");
function $7d311f878f2f561a$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex gap="1xs" alignItems="center">\n        <wui-icon-box\n          size="sm"\n          iconcolor="fg-200"\n          backgroundcolor="fg-200"\n          icon=',
        '\n          background="transparent"\n        ></wui-icon-box>\n        <wui-text variant="small-400" color="fg-200">',
        "</wui-text>\n      </wui-flex>\n    "
    ]);
    $7d311f878f2f561a$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $7d311f878f2f561a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $7d311f878f2f561a$export$51cf21fa3212b001 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiBanner, LitElement);
    var _super = (0, $ohfOJ._)(WuiBanner);
    function WuiBanner() {
        (0, $4GJKx._)(this, WuiBanner);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.icon = "externalLink";
        _this.text = "";
        return _this;
    }
    (0, $1wc17._)(WuiBanner, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($7d311f878f2f561a$var$_templateObject(), this.icon, this.text);
            }
        }
    ]);
    return WuiBanner;
}((0, $eAsDt.LitElement));
$7d311f878f2f561a$export$51cf21fa3212b001.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $9XTPl.default)
];
$7d311f878f2f561a$var$__decorate([
    (0, $siQym.property)()
], $7d311f878f2f561a$export$51cf21fa3212b001.prototype, "icon", void 0);
$7d311f878f2f561a$var$__decorate([
    (0, $siQym.property)()
], $7d311f878f2f561a$export$51cf21fa3212b001.prototype, "text", void 0);
$7d311f878f2f561a$export$51cf21fa3212b001 = $7d311f878f2f561a$var$__decorate([
    (0, $hdxb6.customElement)("wui-banner")
], $7d311f878f2f561a$export$51cf21fa3212b001);

});
parcelRegister("9XTPl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7414edde8871ba31$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $7414edde8871ba31$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  wui-flex {\n    width: 100%;\n    background-color: var(--wui-color-gray-glass-005);\n    border-radius: var(--wui-border-radius-s);\n    padding: var(--wui-spacing-1xs) var(--wui-spacing-s) var(--wui-spacing-1xs)\n      var(--wui-spacing-1xs);\n  }\n"
    ]);
    $7414edde8871ba31$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $7414edde8871ba31$export$2e2bcd8739ae039 = (0, $bBWVO.css)($7414edde8871ba31$var$_templateObject());

});


parcelRegister("1vo0p", function(module, exports) {

$parcel$export(module.exports, "WuiBannerImg", function () { return $118b4eb60d75a90e$export$e5edb823776f5f6f; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("1OYaf");
parcelRequire("8jknp");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $6M4Ip = parcelRequire("6M4Ip");
function $118b4eb60d75a90e$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex gap="1xs" alignItems="center">\n        <wui-avatar size=',
        " imageSrc=",
        '></wui-avatar>\n        <wui-text variant="small-400" color="fg-200">',
        "</wui-text>\n      </wui-flex>\n    "
    ]);
    $118b4eb60d75a90e$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $118b4eb60d75a90e$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $118b4eb60d75a90e$export$e5edb823776f5f6f = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiBannerImg, LitElement);
    var _super = (0, $ohfOJ._)(WuiBannerImg);
    function WuiBannerImg() {
        (0, $4GJKx._)(this, WuiBannerImg);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.imageSrc = "";
        _this.text = "";
        _this.size = "";
        return _this;
    }
    (0, $1wc17._)(WuiBannerImg, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($118b4eb60d75a90e$var$_templateObject(), this.size, this.imageSrc, this.text);
            }
        }
    ]);
    return WuiBannerImg;
}((0, $eAsDt.LitElement));
$118b4eb60d75a90e$export$e5edb823776f5f6f.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $6M4Ip.default)
];
$118b4eb60d75a90e$var$__decorate([
    (0, $siQym.property)()
], $118b4eb60d75a90e$export$e5edb823776f5f6f.prototype, "imageSrc", void 0);
$118b4eb60d75a90e$var$__decorate([
    (0, $siQym.property)()
], $118b4eb60d75a90e$export$e5edb823776f5f6f.prototype, "text", void 0);
$118b4eb60d75a90e$var$__decorate([
    (0, $siQym.property)()
], $118b4eb60d75a90e$export$e5edb823776f5f6f.prototype, "size", void 0);
$118b4eb60d75a90e$export$e5edb823776f5f6f = $118b4eb60d75a90e$var$__decorate([
    (0, $hdxb6.customElement)("wui-banner-img")
], $118b4eb60d75a90e$export$e5edb823776f5f6f);

});
parcelRegister("6M4Ip", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4eeae21c1f7fa7cc$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $4eeae21c1f7fa7cc$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  wui-flex {\n    width: 100%;\n    background-color: var(--wui-color-gray-glass-005);\n    border-radius: var(--wui-border-radius-m);\n    padding: var(--wui-spacing-1xs) var(--wui-spacing-s) var(--wui-spacing-1xs)\n      var(--wui-spacing-1xs);\n  }\n"
    ]);
    $4eeae21c1f7fa7cc$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $4eeae21c1f7fa7cc$export$2e2bcd8739ae039 = (0, $bBWVO.css)($4eeae21c1f7fa7cc$var$_templateObject());

});


parcelRegister("80cGG", function(module, exports) {

$parcel$export(module.exports, "WuiListToken", function () { return $5d382a4d97343f92$export$13e50b688b8e5b1; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("1OYaf");
parcelRequire("9ZbyK");
parcelRequire("8tnK2");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $geZz0 = parcelRequire("geZz0");

var $dI7zX = parcelRequire("dI7zX");
function $5d382a4d97343f92$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      <button data-clickable=",
        ' ontouchstart>\n        <wui-flex gap="s" alignItems="center">\n          ',
        '\n          <wui-flex flexDirection="column" justifyContent="spaceBetween">\n            <wui-text variant="paragraph-500" color="fg-100">',
        '</wui-text>\n            <wui-text variant="small-400" color="fg-200">\n              ',
        " ",
        '\n            </wui-text>\n          </wui-flex>\n        </wui-flex>\n        <wui-text variant="paragraph-500" color="fg-100">$',
        "</wui-text>\n      </button>\n    "
    ]);
    $5d382a4d97343f92$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $5d382a4d97343f92$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "<wui-image alt=",
        " src=",
        "></wui-image>"
    ]);
    $5d382a4d97343f92$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $5d382a4d97343f92$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '<wui-icon name="coinPlaceholder" color="fg-100"></wui-icon>'
    ]);
    $5d382a4d97343f92$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $5d382a4d97343f92$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $5d382a4d97343f92$export$13e50b688b8e5b1 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiListToken, LitElement);
    var _super = (0, $ohfOJ._)(WuiListToken);
    function WuiListToken() {
        (0, $4GJKx._)(this, WuiListToken);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.tokenName = "";
        _this.tokenImageUrl = "";
        _this.tokenValue = 0.0;
        _this.tokenAmount = "0.0";
        _this.tokenCurrency = "";
        _this.clickable = false;
        return _this;
    }
    (0, $1wc17._)(WuiListToken, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($5d382a4d97343f92$var$_templateObject(), String(this.clickable), this.visualTemplate(), this.tokenName, (0, $dI7zX.UiHelperUtil).formatNumberToLocalString(this.tokenAmount, 4), this.tokenCurrency, this.tokenValue.toFixed(2));
            }
        },
        {
            key: "visualTemplate",
            value: function visualTemplate() {
                if (this.tokenName && this.tokenImageUrl) return (0, $1lUIm.html)($5d382a4d97343f92$var$_templateObject1(), this.tokenName, this.tokenImageUrl);
                return (0, $1lUIm.html)($5d382a4d97343f92$var$_templateObject2());
            }
        }
    ]);
    return WuiListToken;
}((0, $eAsDt.LitElement));
$5d382a4d97343f92$export$13e50b688b8e5b1.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $geZz0.default)
];
$5d382a4d97343f92$var$__decorate([
    (0, $siQym.property)()
], $5d382a4d97343f92$export$13e50b688b8e5b1.prototype, "tokenName", void 0);
$5d382a4d97343f92$var$__decorate([
    (0, $siQym.property)()
], $5d382a4d97343f92$export$13e50b688b8e5b1.prototype, "tokenImageUrl", void 0);
$5d382a4d97343f92$var$__decorate([
    (0, $siQym.property)({
        type: Number
    })
], $5d382a4d97343f92$export$13e50b688b8e5b1.prototype, "tokenValue", void 0);
$5d382a4d97343f92$var$__decorate([
    (0, $siQym.property)()
], $5d382a4d97343f92$export$13e50b688b8e5b1.prototype, "tokenAmount", void 0);
$5d382a4d97343f92$var$__decorate([
    (0, $siQym.property)()
], $5d382a4d97343f92$export$13e50b688b8e5b1.prototype, "tokenCurrency", void 0);
$5d382a4d97343f92$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $5d382a4d97343f92$export$13e50b688b8e5b1.prototype, "clickable", void 0);
$5d382a4d97343f92$export$13e50b688b8e5b1 = $5d382a4d97343f92$var$__decorate([
    (0, $hdxb6.customElement)("wui-list-token")
], $5d382a4d97343f92$export$13e50b688b8e5b1);

});
parcelRegister("geZz0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd2db569161a29da$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $bd2db569161a29da$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  button {\n    padding: 6.5px var(--wui-spacing-l) 6.5px var(--wui-spacing-xs);\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    border-radius: var(--wui-border-radius-xs);\n    background-color: var(--wui-color-gray-glass-002);\n  }\n\n  button[data-clickable='false'] {\n    pointer-events: none;\n    background-color: transparent;\n  }\n\n  wui-image,\n  wui-icon {\n    width: var(--wui-spacing-3xl);\n    height: var(--wui-spacing-3xl);\n  }\n\n  wui-image {\n    border-radius: var(--wui-border-radius-3xl);\n  }\n"
    ]);
    $bd2db569161a29da$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $bd2db569161a29da$export$2e2bcd8739ae039 = (0, $bBWVO.css)($bd2db569161a29da$var$_templateObject());

});


parcelRegister("6rgjY", function(module, exports) {

$parcel$export(module.exports, "WuiListDescription", function () { return $4b01ecbdb44760c7$export$f327e80cbe72e7a9; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("1OYaf");
parcelRequire("9ZbyK");
parcelRequire("8tnK2");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $BWKBi = parcelRequire("BWKBi");
function $4b01ecbdb44760c7$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      <button ontouchstart ?disabled=",
        ">\n        <wui-icon-box\n          iconColor=",
        "\n          backgroundColor=",
        '\n          size="inherit"\n          icon=',
        '\n          iconSize="md"\n        ></wui-icon-box>\n        <wui-flex flexDirection="column" justifyContent="spaceBetween">\n          ',
        '\n          <wui-text variant="small-400" color="fg-200"> ',
        "</wui-text></wui-flex\n        >\n      </button>\n    "
    ]);
    $4b01ecbdb44760c7$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $4b01ecbdb44760c7$var$_templateObject1() {
    var data = (0, $j06k0._)([
        ' <wui-flex alignItems="center" gap="xxs"\n        ><wui-text variant="paragraph-500" color="fg-100">',
        '</wui-text\n        ><wui-tag tagType="main" size="md">',
        "</wui-tag>\n      </wui-flex>"
    ]);
    $4b01ecbdb44760c7$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $4b01ecbdb44760c7$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '<wui-text variant="paragraph-500" color="fg-100">',
        "</wui-text>"
    ]);
    $4b01ecbdb44760c7$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $4b01ecbdb44760c7$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $4b01ecbdb44760c7$export$f327e80cbe72e7a9 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiListDescription, LitElement);
    var _super = (0, $ohfOJ._)(WuiListDescription);
    function WuiListDescription() {
        (0, $4GJKx._)(this, WuiListDescription);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.icon = "card";
        _this.text = "";
        _this.description = "";
        _this.tag = undefined;
        _this.iconBackgroundColor = "accent-100";
        _this.iconColor = "accent-100";
        _this.disabled = false;
        return _this;
    }
    (0, $1wc17._)(WuiListDescription, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($4b01ecbdb44760c7$var$_templateObject(), this.disabled, this.iconColor, this.iconBackgroundColor, this.icon, this.titleTemplate(), this.description);
            }
        },
        {
            key: "titleTemplate",
            value: function titleTemplate() {
                if (this.tag) return (0, $1lUIm.html)($4b01ecbdb44760c7$var$_templateObject1(), this.text, this.tag);
                return (0, $1lUIm.html)($4b01ecbdb44760c7$var$_templateObject2(), this.text);
            }
        }
    ]);
    return WuiListDescription;
}((0, $eAsDt.LitElement));
$4b01ecbdb44760c7$export$f327e80cbe72e7a9.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $BWKBi.default)
];
$4b01ecbdb44760c7$var$__decorate([
    (0, $siQym.property)()
], $4b01ecbdb44760c7$export$f327e80cbe72e7a9.prototype, "icon", void 0);
$4b01ecbdb44760c7$var$__decorate([
    (0, $siQym.property)()
], $4b01ecbdb44760c7$export$f327e80cbe72e7a9.prototype, "text", void 0);
$4b01ecbdb44760c7$var$__decorate([
    (0, $siQym.property)()
], $4b01ecbdb44760c7$export$f327e80cbe72e7a9.prototype, "description", void 0);
$4b01ecbdb44760c7$var$__decorate([
    (0, $siQym.property)()
], $4b01ecbdb44760c7$export$f327e80cbe72e7a9.prototype, "tag", void 0);
$4b01ecbdb44760c7$var$__decorate([
    (0, $siQym.property)()
], $4b01ecbdb44760c7$export$f327e80cbe72e7a9.prototype, "iconBackgroundColor", void 0);
$4b01ecbdb44760c7$var$__decorate([
    (0, $siQym.property)()
], $4b01ecbdb44760c7$export$f327e80cbe72e7a9.prototype, "iconColor", void 0);
$4b01ecbdb44760c7$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $4b01ecbdb44760c7$export$f327e80cbe72e7a9.prototype, "disabled", void 0);
$4b01ecbdb44760c7$export$f327e80cbe72e7a9 = $4b01ecbdb44760c7$var$__decorate([
    (0, $hdxb6.customElement)("wui-list-description")
], $4b01ecbdb44760c7$export$f327e80cbe72e7a9);

});
parcelRegister("BWKBi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0721077724dab1aa$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $0721077724dab1aa$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  button {\n    width: 100%;\n    display: flex;\n    gap: var(--wui-spacing-s);\n    align-items: center;\n    justify-content: flex-start;\n    padding: var(--wui-spacing-s) var(--wui-spacing-m) var(--wui-spacing-s) var(--wui-spacing-s);\n    background-color: var(--wui-color-gray-glass-002);\n    border-radius: var(--wui-border-radius-xs);\n  }\n\n  wui-icon-box {\n    width: var(--wui-spacing-2xl);\n    height: var(--wui-spacing-2xl);\n  }\n\n  wui-flex {\n    width: auto;\n  }\n"
    ]);
    $0721077724dab1aa$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $0721077724dab1aa$export$2e2bcd8739ae039 = (0, $bBWVO.css)($0721077724dab1aa$var$_templateObject());

});


parcelRegister("7pa2i", function(module, exports) {

$parcel$export(module.exports, "WuiInputAmount", function () { return $5642a724ce96ff73$export$b2838f44ec9f0443; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $1odoJ = parcelRequire("1odoJ");
parcelRequire("8jzG0");
var $fR1Rt = parcelRequire("fR1Rt");

var $fzIJ7 = parcelRequire("fzIJ7");
function $5642a724ce96ff73$var$_templateObject() {
    var data = (0, $j06k0._)([
        "<input\n      ",
        '\n      type="text"\n      inputmode="decimal"\n      pattern="[0-9,.]*"\n      placeholder=',
        "\n      ?disabled=",
        "\n      autofocus\n      value=",
        "\n      @input=",
        "\n    /> "
    ]);
    $5642a724ce96ff73$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $5642a724ce96ff73$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $5642a724ce96ff73$export$b2838f44ec9f0443 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiInputAmount, LitElement);
    var _super = (0, $ohfOJ._)(WuiInputAmount);
    function WuiInputAmount() {
        (0, $4GJKx._)(this, WuiInputAmount);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.inputElementRef = (0, $fR1Rt.createRef)();
        _this.disabled = false;
        _this.value = "";
        _this.placeholder = "0";
        return _this;
    }
    (0, $1wc17._)(WuiInputAmount, [
        {
            key: "render",
            value: function render() {
                var _this_inputElementRef;
                if (((_this_inputElementRef = this.inputElementRef) === null || _this_inputElementRef === void 0 ? void 0 : _this_inputElementRef.value) && this.value) this.inputElementRef.value.value = this.value;
                var _this_value;
                return (0, $1lUIm.html)($5642a724ce96ff73$var$_templateObject(), (0, $fR1Rt.ref)(this.inputElementRef), this.placeholder, this.disabled, (_this_value = this.value) !== null && _this_value !== void 0 ? _this_value : "", this.dispatchInputChangeEvent.bind(this));
            }
        },
        {
            key: "dispatchInputChangeEvent",
            value: function dispatchInputChangeEvent(e) {
                var _this_inputElementRef, _this_inputElementRef_value;
                var inputChar = e.data;
                if (inputChar && ((_this_inputElementRef = this.inputElementRef) === null || _this_inputElementRef === void 0 ? void 0 : _this_inputElementRef.value)) {
                    if (inputChar === ",") {
                        var inputValue = this.inputElementRef.value.value.replace(",", ".");
                        this.inputElementRef.value.value = inputValue;
                        this.value = "".concat(this.value).concat(inputValue);
                    } else if (!(0, $fzIJ7.numbersRegex).test(inputChar)) this.inputElementRef.value.value = this.value.replace(new RegExp(inputChar.replace((0, $fzIJ7.specialCharactersRegex), "\\$&"), "gu"), "");
                }
                this.dispatchEvent(new CustomEvent("inputChange", {
                    detail: (_this_inputElementRef_value = this.inputElementRef.value) === null || _this_inputElementRef_value === void 0 ? void 0 : _this_inputElementRef_value.value,
                    bubbles: true,
                    composed: true
                }));
            }
        }
    ]);
    return WuiInputAmount;
}((0, $eAsDt.LitElement));
$5642a724ce96ff73$export$b2838f44ec9f0443.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $1odoJ.default)
];
$5642a724ce96ff73$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $5642a724ce96ff73$export$b2838f44ec9f0443.prototype, "disabled", void 0);
$5642a724ce96ff73$var$__decorate([
    (0, $siQym.property)({
        type: String
    })
], $5642a724ce96ff73$export$b2838f44ec9f0443.prototype, "value", void 0);
$5642a724ce96ff73$var$__decorate([
    (0, $siQym.property)({
        type: String
    })
], $5642a724ce96ff73$export$b2838f44ec9f0443.prototype, "placeholder", void 0);
$5642a724ce96ff73$export$b2838f44ec9f0443 = $5642a724ce96ff73$var$__decorate([
    (0, $hdxb6.customElement)("wui-input-amount")
], $5642a724ce96ff73$export$b2838f44ec9f0443);

});
parcelRegister("1odoJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10326ce331ad9cc3$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $10326ce331ad9cc3$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    position: relative;\n    display: inline-block;\n  }\n\n  input {\n    background: transparent;\n    width: 100%;\n    height: auto;\n    font-family: var(--wui-font-family);\n    color: var(--wui-color-fg-100);\n\n    font-feature-settings: 'case' on;\n    font-size: 32px;\n    font-weight: var(--wui-font-weight-light);\n    caret-color: var(--wui-color-accent-100);\n    line-height: 130%;\n    letter-spacing: -1.28px;\n    box-sizing: border-box;\n    -webkit-appearance: none;\n    -moz-appearance: textfield;\n    padding: 0px;\n  }\n\n  input::-webkit-outer-spin-button,\n  input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  input::placeholder {\n    color: var(--wui-color-fg-275);\n  }\n"
    ]);
    $10326ce331ad9cc3$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $10326ce331ad9cc3$export$2e2bcd8739ae039 = (0, $bBWVO.css)($10326ce331ad9cc3$var$_templateObject());

});

parcelRegister("fzIJ7", function(module, exports) {

$parcel$export(module.exports, "specialCharactersRegex", function () { return $b56cd1abe8030413$export$c39fd9747ee8dc1a; });
$parcel$export(module.exports, "numbersRegex", function () { return $b56cd1abe8030413$export$e4e17532376f38ea; });
var $b56cd1abe8030413$export$c39fd9747ee8dc1a = RegExp("[.*+?^${}()|[\\]\\\\]", "gu");
var $b56cd1abe8030413$export$e4e17532376f38ea = RegExp("[0-9,.]", "u");

});


parcelRegister("6I54U", function(module, exports) {

$parcel$export(module.exports, "WuiPreviewItem", function () { return $4e2aca8f8a5c6b9f$export$60b39244fc096362; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("1OYaf");
parcelRequire("9ZbyK");
parcelRequire("dcd5U");
parcelRequire("eDRu8");
parcelRequire("8tnK2");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $fiVAt = parcelRequire("fiVAt");
function $4e2aca8f8a5c6b9f$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<wui-text variant="large-500" color="fg-100">',
        "</wui-text>\n      ",
        ""
    ]);
    $4e2aca8f8a5c6b9f$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $4e2aca8f8a5c6b9f$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "<wui-avatar address=",
        " .imageSrc=",
        "></wui-avatar>"
    ]);
    $4e2aca8f8a5c6b9f$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $4e2aca8f8a5c6b9f$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "<wui-image src=",
        "></wui-image>"
    ]);
    $4e2aca8f8a5c6b9f$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $4e2aca8f8a5c6b9f$var$_templateObject3() {
    var data = (0, $j06k0._)([
        '<wui-icon size="inherit" color="fg-200" name="networkPlaceholder"></wui-icon>'
    ]);
    $4e2aca8f8a5c6b9f$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var $4e2aca8f8a5c6b9f$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $4e2aca8f8a5c6b9f$export$60b39244fc096362 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiPreviewItem, LitElement);
    var _super = (0, $ohfOJ._)(WuiPreviewItem);
    function WuiPreviewItem() {
        (0, $4GJKx._)(this, WuiPreviewItem);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.text = "";
        _this.address = "";
        _this.isAddress = false;
        return _this;
    }
    (0, $1wc17._)(WuiPreviewItem, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($4e2aca8f8a5c6b9f$var$_templateObject(), this.text, this.imageTemplate());
            }
        },
        {
            key: "imageTemplate",
            value: function imageTemplate() {
                if (this.isAddress) return (0, $1lUIm.html)($4e2aca8f8a5c6b9f$var$_templateObject1(), this.address, this.imageSrc);
                else if (this.imageSrc) return (0, $1lUIm.html)($4e2aca8f8a5c6b9f$var$_templateObject2(), this.imageSrc);
                return (0, $1lUIm.html)($4e2aca8f8a5c6b9f$var$_templateObject3());
            }
        }
    ]);
    return WuiPreviewItem;
}((0, $eAsDt.LitElement));
$4e2aca8f8a5c6b9f$export$60b39244fc096362.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $fiVAt.default)
];
$4e2aca8f8a5c6b9f$var$__decorate([
    (0, $siQym.property)()
], $4e2aca8f8a5c6b9f$export$60b39244fc096362.prototype, "text", void 0);
$4e2aca8f8a5c6b9f$var$__decorate([
    (0, $siQym.property)()
], $4e2aca8f8a5c6b9f$export$60b39244fc096362.prototype, "address", void 0);
$4e2aca8f8a5c6b9f$var$__decorate([
    (0, $siQym.property)()
], $4e2aca8f8a5c6b9f$export$60b39244fc096362.prototype, "imageSrc", void 0);
$4e2aca8f8a5c6b9f$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $4e2aca8f8a5c6b9f$export$60b39244fc096362.prototype, "isAddress", void 0);
$4e2aca8f8a5c6b9f$export$60b39244fc096362 = $4e2aca8f8a5c6b9f$var$__decorate([
    (0, $hdxb6.customElement)("wui-preview-item")
], $4e2aca8f8a5c6b9f$export$60b39244fc096362);

});
parcelRegister("fiVAt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2453515fda685fc$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $b2453515fda685fc$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: flex;\n    gap: var(--wui-spacing-xs);\n    border-radius: var(--wui-border-radius-3xl);\n    border: 1px solid var(--wui-color-gray-glass-002);\n    background: var(--wui-color-gray-glass-002);\n    padding: var(--wui-spacing-2xs) var(--wui-spacing-xs) var(--wui-spacing-2xs)\n      var(--wui-spacing-s);\n    align-items: center;\n  }\n\n  wui-avatar,\n  wui-icon,\n  wui-image {\n    width: 32px;\n    height: 32px;\n    border: 1px solid var(--wui-color-gray-glass-002);\n    border-radius: var(--wui-border-radius-3xl);\n    box-shadow: 0 0 0 2px var(--wui-color-gray-glass-002);\n  }\n"
    ]);
    $b2453515fda685fc$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $b2453515fda685fc$export$2e2bcd8739ae039 = (0, $bBWVO.css)($b2453515fda685fc$var$_templateObject());

});


parcelRegister("a1um1", function(module, exports) {

$parcel$export(module.exports, "WuiListAccount", function () { return $74c18b1ab4e94af6$export$5ac51030fb805c58; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $04RAu = parcelRequire("04RAu");

var $b8Rim = parcelRequire("b8Rim");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("1OYaf");
parcelRequire("9ZbyK");
parcelRequire("8tnK2");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $fvwgL = parcelRequire("fvwgL");

var $dI7zX = parcelRequire("dI7zX");
parcelRequire("hsyMZ");
var $cSJ4o = parcelRequire("cSJ4o");
parcelRequire("cwWZ7");
var $i7zcD = parcelRequire("i7zcD");
var $dMLJP = parcelRequire("dMLJP");
var $fPqxb = parcelRequire("fPqxb");
var $jrvVk = parcelRequire("jrvVk");
function $74c18b1ab4e94af6$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<wui-icon-box\n                size="sm"\n                iconcolor="fg-200"\n                backgroundcolor="fg-300"\n                icon=',
        '\n                background="fg-300"\n              ></wui-icon-box>'
    ]);
    $74c18b1ab4e94af6$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $74c18b1ab4e94af6$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '<wui-flex .padding="',
        '"></wui-flex>'
    ]);
    $74c18b1ab4e94af6$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $74c18b1ab4e94af6$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '<wui-loading-spinner size="sm" color="accent-100"></wui-loading-spinner>'
    ]);
    $74c18b1ab4e94af6$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $74c18b1ab4e94af6$var$_templateObject3() {
    var data = (0, $j06k0._)([
        ' <wui-text variant="small-400">$',
        "</wui-text>"
    ]);
    $74c18b1ab4e94af6$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $74c18b1ab4e94af6$var$_templateObject4() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex\n        flexDirection="row"\n        justifyContent="space-between"\n        .padding=',
        '\n      >\n        <wui-flex gap="md" alignItems="center">\n          <wui-avatar address=',
        "></wui-avatar>\n          ",
        '\n          <wui-flex flexDirection="column">\n            <wui-text class="address" variant="paragraph-500" color="fg-100"\n              >',
        '</wui-text\n            >\n            <wui-text class="address-description" variant="small-400">',
        '</wui-text></wui-flex\n          >\n        </wui-flex>\n        <wui-flex gap="s" alignItems="center">\n          ',
        '\n          <slot name="action"></slot>\n        </wui-flex>\n      </wui-flex>\n    '
    ]);
    $74c18b1ab4e94af6$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
var $74c18b1ab4e94af6$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $74c18b1ab4e94af6$export$5ac51030fb805c58 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiListAccount, LitElement);
    var _super = (0, $ohfOJ._)(WuiListAccount);
    function WuiListAccount() {
        (0, $4GJKx._)(this, WuiListAccount);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.accountAddress = "";
        _this.accountType = "";
        _this.connectedConnector = (0, $i7zcD.StorageUtil).getConnectedConnector();
        _this.labels = (0, $dMLJP.AccountController).state.addressLabels;
        _this.caipNetwork = (0, $fPqxb.NetworkController).state.caipNetwork;
        _this.socialProvider = (0, $i7zcD.StorageUtil).getConnectedSocialProvider();
        _this.balance = 0;
        _this.fetchingBalance = true;
        _this.shouldShowIcon = false;
        _this.selected = false;
        return _this;
    }
    (0, $1wc17._)(WuiListAccount, [
        {
            key: "connectedCallback",
            value: function connectedCallback() {
                var _this = this;
                var _this_caipNetwork;
                (0, $04RAu._)((0, $b8Rim._)(WuiListAccount.prototype), "connectedCallback", this).call(this);
                (0, $jrvVk.BlockchainApiController).getBalance(this.accountAddress, (_this_caipNetwork = this.caipNetwork) === null || _this_caipNetwork === void 0 ? void 0 : _this_caipNetwork.id).then(function(response) {
                    var total = _this.balance;
                    if (response.balances.length > 0) total = response.balances.reduce(function(acc, balance) {
                        return acc + ((balance === null || balance === void 0 ? void 0 : balance.value) || 0);
                    }, 0);
                    _this.balance = total;
                    _this.fetchingBalance = false;
                    _this.requestUpdate();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var label = this.getLabel();
                this.shouldShowIcon = this.connectedConnector === "AUTH";
                var _this_socialProvider;
                return (0, $1lUIm.html)($74c18b1ab4e94af6$var$_templateObject4(), [
                    "0",
                    "0",
                    "s",
                    "1xs"
                ], this.accountAddress, this.shouldShowIcon ? (0, $1lUIm.html)($74c18b1ab4e94af6$var$_templateObject(), this.accountType === (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.EOA ? (_this_socialProvider = this.socialProvider) !== null && _this_socialProvider !== void 0 ? _this_socialProvider : "mail" : "lightbulb") : (0, $1lUIm.html)($74c18b1ab4e94af6$var$_templateObject1(), [
                    "0",
                    "0",
                    "0",
                    "s"
                ]), (0, $dI7zX.UiHelperUtil).getTruncateString({
                    string: this.accountAddress,
                    charsStart: 4,
                    charsEnd: 6,
                    truncate: "middle"
                }), label, this.fetchingBalance ? (0, $1lUIm.html)($74c18b1ab4e94af6$var$_templateObject2()) : (0, $1lUIm.html)($74c18b1ab4e94af6$var$_templateObject3(), this.balance.toFixed(2)));
            }
        },
        {
            key: "getLabel",
            value: function getLabel() {
                var _this_labels;
                var label = (_this_labels = this.labels) === null || _this_labels === void 0 ? void 0 : _this_labels.get(this.accountAddress);
                var _this_socialProvider;
                if (!label && this.connectedConnector === "AUTH") label = "".concat(this.accountType === "eoa" ? (_this_socialProvider = this.socialProvider) !== null && _this_socialProvider !== void 0 ? _this_socialProvider : "Email" : "Smart", " Account");
                else if (!label && this.connectedConnector === "INJECTED" || this.connectedConnector === "ANNOUNCED") label = "Injected Account";
                else if (!label) label = "EOA";
                return label;
            }
        }
    ]);
    return WuiListAccount;
}((0, $eAsDt.LitElement));
$74c18b1ab4e94af6$export$5ac51030fb805c58.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $fvwgL.default)
];
$74c18b1ab4e94af6$var$__decorate([
    (0, $siQym.property)()
], $74c18b1ab4e94af6$export$5ac51030fb805c58.prototype, "accountAddress", void 0);
$74c18b1ab4e94af6$var$__decorate([
    (0, $siQym.property)()
], $74c18b1ab4e94af6$export$5ac51030fb805c58.prototype, "accountType", void 0);
$74c18b1ab4e94af6$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $74c18b1ab4e94af6$export$5ac51030fb805c58.prototype, "selected", void 0);
$74c18b1ab4e94af6$var$__decorate([
    (0, $siQym.property)({
        type: Function
    })
], $74c18b1ab4e94af6$export$5ac51030fb805c58.prototype, "onSelect", void 0);
$74c18b1ab4e94af6$export$5ac51030fb805c58 = $74c18b1ab4e94af6$var$__decorate([
    (0, $hdxb6.customElement)("wui-list-account")
], $74c18b1ab4e94af6$export$5ac51030fb805c58);

});
parcelRegister("fvwgL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4a2c8454f7f09bc$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $b4a2c8454f7f09bc$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  button {\n    padding: 6.5px var(--wui-spacing-l) 6.5px var(--wui-spacing-xs);\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    border-radius: var(--wui-border-radius-xs);\n    background-color: var(--wui-color-gray-glass-002);\n  }\n\n  button[data-clickable='false'] {\n    pointer-events: none;\n    background-color: transparent;\n  }\n\n  wui-image {\n    width: var(--wui-spacing-3xl);\n    height: var(--wui-spacing-3xl);\n    border-radius: var(--wui-border-radius-3xl);\n  }\n\n  wui-avatar {\n    width: var(--wui-spacing-3xl);\n    height: var(--wui-spacing-3xl);\n    box-shadow: 0 0 0 0;\n  }\n  .address {\n    color: var(--wui-color-fg-base-100);\n  }\n  .address-description {\n    text-transform: capitalize;\n    color: var(--wui-color-fg-base-200);\n  }\n\n  wui-icon-box {\n    position: relative;\n    right: 15px;\n    top: 15px;\n    border: 2px solid var(--wui-color-bg-150);\n    background-color: var(--wui-color-bg-125);\n  }\n"
    ]);
    $b4a2c8454f7f09bc$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $b4a2c8454f7f09bc$export$2e2bcd8739ae039 = (0, $bBWVO.css)($b4a2c8454f7f09bc$var$_templateObject());

});


parcelRegister("3hu8X", function(module, exports) {

$parcel$export(module.exports, "WuiIconButton", function () { return $263a5782726d9fad$export$91b5dd827cb523b7; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");

var $hdxb6 = parcelRequire("hdxb6");

var $63LC2 = parcelRequire("63LC2");
parcelRequire("7PfNN");
parcelRequire("dcd5U");

var $kYNxm = parcelRequire("kYNxm");
function $263a5782726d9fad$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<button>\n      <wui-icon color="accent-100" name=',
        ' size="lg"></wui-icon>\n    </button>'
    ]);
    $263a5782726d9fad$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $263a5782726d9fad$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $263a5782726d9fad$export$91b5dd827cb523b7 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiIconButton, LitElement);
    var _super = (0, $ohfOJ._)(WuiIconButton);
    function WuiIconButton() {
        (0, $4GJKx._)(this, WuiIconButton);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.text = "";
        _this.icon = "card";
        return _this;
    }
    (0, $1wc17._)(WuiIconButton, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($263a5782726d9fad$var$_templateObject(), this.icon);
            }
        }
    ]);
    return WuiIconButton;
}((0, $eAsDt.LitElement));
$263a5782726d9fad$export$91b5dd827cb523b7.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $63LC2.default)
];
$263a5782726d9fad$var$__decorate([
    (0, $siQym.property)()
], $263a5782726d9fad$export$91b5dd827cb523b7.prototype, "text", void 0);
$263a5782726d9fad$var$__decorate([
    (0, $siQym.property)()
], $263a5782726d9fad$export$91b5dd827cb523b7.prototype, "icon", void 0);
$263a5782726d9fad$export$91b5dd827cb523b7 = $263a5782726d9fad$var$__decorate([
    (0, $hdxb6.customElement)("wui-icon-button")
], $263a5782726d9fad$export$91b5dd827cb523b7);

});
parcelRegister("63LC2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4697f4b9220389e7$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $4697f4b9220389e7$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    position: relative;\n  }\n\n  button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 48px;\n    width: 100%;\n    background-color: var(--wui-color-accent-glass-010);\n    border-radius: var(--wui-border-radius-xs);\n    border: 1px solid var(--wui-color-accent-glass-010);\n    transition: background-color var(--wui-ease-out-power-1) var(--wui-duration-md);\n    will-change: background-color;\n  }\n\n  wui-tooltip {\n    padding: 7px var(--wui-spacing-s) 8px var(--wui-spacing-s);\n    position: absolute;\n    top: -8px;\n    left: 50%;\n    transform: translate(-50%, -100%);\n    opacity: 0;\n    display: none;\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    button:hover:enabled {\n      background-color: var(--wui-color-accent-glass-015);\n    }\n\n    button:active:enabled {\n      background-color: var(--wui-color-accent-glass-020);\n    }\n  }\n"
    ]);
    $4697f4b9220389e7$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $4697f4b9220389e7$export$2e2bcd8739ae039 = (0, $bBWVO.css)($4697f4b9220389e7$var$_templateObject());

});


parcelRegister("6DVx9", function(module, exports) {

$parcel$export(module.exports, "WuiListButton", function () { return $4d6303907547fe5a$export$ce16820f038eaf8e; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("1OYaf");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $6ts4G = parcelRequire("6ts4G");
function $4d6303907547fe5a$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      <button ?disabled=",
        ' ontouchstart>\n        <wui-text align="center" variant="paragraph-500" color="inherit">',
        "</wui-text>\n      </button>\n    "
    ]);
    $4d6303907547fe5a$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $4d6303907547fe5a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $4d6303907547fe5a$export$ce16820f038eaf8e = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiListButton, LitElement);
    var _super = (0, $ohfOJ._)(WuiListButton);
    function WuiListButton() {
        (0, $4GJKx._)(this, WuiListButton);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.text = "";
        _this.disabled = false;
        return _this;
    }
    (0, $1wc17._)(WuiListButton, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($4d6303907547fe5a$var$_templateObject(), this.disabled, this.text);
            }
        }
    ]);
    return WuiListButton;
}((0, $eAsDt.LitElement));
$4d6303907547fe5a$export$ce16820f038eaf8e.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $6ts4G.default)
];
$4d6303907547fe5a$var$__decorate([
    (0, $siQym.property)()
], $4d6303907547fe5a$export$ce16820f038eaf8e.prototype, "text", void 0);
$4d6303907547fe5a$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $4d6303907547fe5a$export$ce16820f038eaf8e.prototype, "disabled", void 0);
$4d6303907547fe5a$export$ce16820f038eaf8e = $4d6303907547fe5a$var$__decorate([
    (0, $hdxb6.customElement)("wui-list-button")
], $4d6303907547fe5a$export$ce16820f038eaf8e);

});
parcelRegister("6ts4G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b6b3a86dfc7d7cc$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $4b6b3a86dfc7d7cc$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  button {\n    column-gap: var(--wui-spacing-s);\n    padding: 16.5px var(--wui-spacing-l) 16.5px var(--wui-spacing-xs);\n    width: 100%;\n    background-color: var(--wui-color-gray-glass-002);\n    border-radius: var(--wui-border-radius-xs);\n    color: var(--wui-color-fg-100);\n    justify-content: center;\n    align-items: center;\n  }\n\n  button:disabled {\n    background-color: var(--wui-color-gray-glass-015);\n    color: var(--wui-color-gray-glass-015);\n  }\n"
    ]);
    $4b6b3a86dfc7d7cc$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $4b6b3a86dfc7d7cc$export$2e2bcd8739ae039 = (0, $bBWVO.css)($4b6b3a86dfc7d7cc$var$_templateObject());

});


parcelRegister("10Tky", function(module, exports) {

$parcel$export(module.exports, "WuiListSocial", function () { return $0bd0b609e0f05481$export$6d44576f6b47c46b; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("1OYaf");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("iQo3l");

var $gDKDG = parcelRequire("gDKDG");
function $0bd0b609e0f05481$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      <button ?disabled=",
        " ontouchstart>\n        <wui-logo logo=",
        "></wui-logo>\n        <wui-text\n          data-align=",
        '\n          variant="paragraph-500"\n          color="inherit"\n          align=',
        "\n          >",
        "</wui-text\n        >\n        ",
        "\n      </button>\n    "
    ]);
    $0bd0b609e0f05481$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $0bd0b609e0f05481$var$_templateObject1() {
    var data = (0, $j06k0._)([
        ' <wui-logo class="invisible" logo=',
        "></wui-logo>"
    ]);
    $0bd0b609e0f05481$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $0bd0b609e0f05481$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $0bd0b609e0f05481$export$6d44576f6b47c46b = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiListSocial, LitElement);
    var _super = (0, $ohfOJ._)(WuiListSocial);
    function WuiListSocial() {
        (0, $4GJKx._)(this, WuiListSocial);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.logo = "google";
        _this.name = "Continue with google";
        _this.align = "left";
        _this.disabled = false;
        return _this;
    }
    (0, $1wc17._)(WuiListSocial, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($0bd0b609e0f05481$var$_templateObject(), this.disabled, this.logo, this.align, this.align, this.name, this.templatePlacement());
            }
        },
        {
            key: "templatePlacement",
            value: function templatePlacement() {
                if (this.align === "center") return (0, $1lUIm.html)($0bd0b609e0f05481$var$_templateObject1(), this.logo);
                return null;
            }
        }
    ]);
    return WuiListSocial;
}((0, $eAsDt.LitElement));
$0bd0b609e0f05481$export$6d44576f6b47c46b.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $gDKDG.default)
];
$0bd0b609e0f05481$var$__decorate([
    (0, $siQym.property)()
], $0bd0b609e0f05481$export$6d44576f6b47c46b.prototype, "logo", void 0);
$0bd0b609e0f05481$var$__decorate([
    (0, $siQym.property)()
], $0bd0b609e0f05481$export$6d44576f6b47c46b.prototype, "name", void 0);
$0bd0b609e0f05481$var$__decorate([
    (0, $siQym.property)()
], $0bd0b609e0f05481$export$6d44576f6b47c46b.prototype, "align", void 0);
$0bd0b609e0f05481$var$__decorate([
    (0, $siQym.property)({
        type: Boolean
    })
], $0bd0b609e0f05481$export$6d44576f6b47c46b.prototype, "disabled", void 0);
$0bd0b609e0f05481$export$6d44576f6b47c46b = $0bd0b609e0f05481$var$__decorate([
    (0, $hdxb6.customElement)("wui-list-social")
], $0bd0b609e0f05481$export$6d44576f6b47c46b);

});
parcelRegister("gDKDG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1d4776a436047fa$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $c1d4776a436047fa$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  button {\n    column-gap: var(--wui-spacing-s);\n    padding: 7px var(--wui-spacing-l) 7px var(--wui-spacing-xs);\n    width: 100%;\n    justify-content: flex-start;\n    background-color: var(--wui-color-gray-glass-002);\n    border-radius: var(--wui-border-radius-xs);\n    color: var(--wui-color-fg-100);\n  }\n\n  wui-text {\n    text-transform: capitalize;\n  }\n\n  wui-text[data-align='left'] {\n    display: flex;\n    flex: 1;\n  }\n\n  wui-text[data-align='center'] {\n    display: flex;\n    flex: 1;\n    justify-content: center;\n  }\n\n  .invisible {\n    opacity: 0;\n    pointer-events: none;\n  }\n\n  button:disabled {\n    background-color: var(--wui-color-gray-glass-015);\n    color: var(--wui-color-gray-glass-015);\n  }\n"
    ]);
    $c1d4776a436047fa$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $c1d4776a436047fa$export$2e2bcd8739ae039 = (0, $bBWVO.css)($c1d4776a436047fa$var$_templateObject());

});


parcelRegister("goez5", function(module, exports) {

$parcel$export(module.exports, "WuiSelect", function () { return $beea2f84b4da8502$export$1ff92e25bd10418b; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $9Wxtx = parcelRequire("9Wxtx");
parcelRequire("dcd5U");
parcelRequire("9ZbyK");
parcelRequire("8jknp");
function $beea2f84b4da8502$var$_templateObject() {
    var data = (0, $j06k0._)([
        "<button>\n      ",
        '\n      <wui-icon size="xs" color="fg-200" name="chevronBottom"></wui-icon>\n    </button>'
    ]);
    $beea2f84b4da8502$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $beea2f84b4da8502$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "<wui-image src=",
        ' alt="select visual"></wui-image>'
    ]);
    $beea2f84b4da8502$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $beea2f84b4da8502$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '<wui-icon-box\n      size="xxs"\n      iconColor="fg-200"\n      backgroundColor="fg-100"\n      background="opaque"\n      icon="networkPlaceholder"\n    ></wui-icon-box>'
    ]);
    $beea2f84b4da8502$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $beea2f84b4da8502$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $beea2f84b4da8502$export$1ff92e25bd10418b = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiSelect, LitElement);
    var _super = (0, $ohfOJ._)(WuiSelect);
    function WuiSelect() {
        (0, $4GJKx._)(this, WuiSelect);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.imageSrc = "";
        return _this;
    }
    (0, $1wc17._)(WuiSelect, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($beea2f84b4da8502$var$_templateObject(), this.imageTemplate());
            }
        },
        {
            key: "imageTemplate",
            value: function imageTemplate() {
                if (this.imageSrc) return (0, $1lUIm.html)($beea2f84b4da8502$var$_templateObject1(), this.imageSrc);
                return (0, $1lUIm.html)($beea2f84b4da8502$var$_templateObject2());
            }
        }
    ]);
    return WuiSelect;
}((0, $eAsDt.LitElement));
$beea2f84b4da8502$export$1ff92e25bd10418b.styles = [
    (0, $kYNxm.resetStyles),
    (0, $kYNxm.elementStyles),
    (0, $kYNxm.colorStyles),
    (0, $9Wxtx.default)
];
$beea2f84b4da8502$var$__decorate([
    (0, $siQym.property)()
], $beea2f84b4da8502$export$1ff92e25bd10418b.prototype, "imageSrc", void 0);
$beea2f84b4da8502$export$1ff92e25bd10418b = $beea2f84b4da8502$var$__decorate([
    (0, $hdxb6.customElement)("wui-select")
], $beea2f84b4da8502$export$1ff92e25bd10418b);

});
parcelRegister("9Wxtx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73d37f6005822c65$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $73d37f6005822c65$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  button {\n    display: block;\n    display: flex;\n    align-items: center;\n    padding: var(--wui-spacing-xxs);\n    gap: var(--wui-spacing-xxs);\n    transition: all var(--wui-ease-out-power-1) var(--wui-duration-md);\n    border-radius: var(--wui-border-radius-xxs);\n  }\n\n  wui-image {\n    border-radius: 100%;\n    width: var(--wui-spacing-xl);\n    height: var(--wui-spacing-xl);\n  }\n\n  wui-icon-box {\n    width: var(--wui-spacing-xl);\n    height: var(--wui-spacing-xl);\n  }\n\n  button:hover {\n    background-color: var(--wui-color-gray-glass-002);\n  }\n\n  button:active {\n    background-color: var(--wui-color-gray-glass-005);\n  }\n"
    ]);
    $73d37f6005822c65$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $73d37f6005822c65$export$2e2bcd8739ae039 = (0, $bBWVO.css)($73d37f6005822c65$var$_templateObject());

});


parcelRegister("aWndJ", function(module, exports) {

$parcel$export(module.exports, "WuiGrid", function () { return $7f71554530133cae$export$834debd63a0ca469; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");

var $kYNxm = parcelRequire("kYNxm");

var $dI7zX = parcelRequire("dI7zX");

var $hdxb6 = parcelRequire("hdxb6");

var $6Bmrt = parcelRequire("6Bmrt");
function $7f71554530133cae$var$_templateObject() {
    var data = (0, $j06k0._)([
        "<slot></slot>"
    ]);
    $7f71554530133cae$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $7f71554530133cae$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $7f71554530133cae$export$834debd63a0ca469 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiGrid, LitElement);
    var _super = (0, $ohfOJ._)(WuiGrid);
    function WuiGrid() {
        (0, $4GJKx._)(this, WuiGrid);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(WuiGrid, [
        {
            key: "render",
            value: function render() {
                this.style.cssText = "\n      grid-template-rows: ".concat(this.gridTemplateRows, ";\n      grid-template-columns: ").concat(this.gridTemplateColumns, ";\n      justify-items: ").concat(this.justifyItems, ";\n      align-items: ").concat(this.alignItems, ";\n      justify-content: ").concat(this.justifyContent, ";\n      align-content: ").concat(this.alignContent, ";\n      column-gap: ").concat(this.columnGap && "var(--wui-spacing-".concat(this.columnGap, ")"), ";\n      row-gap: ").concat(this.rowGap && "var(--wui-spacing-".concat(this.rowGap, ")"), ";\n      gap: ").concat(this.gap && "var(--wui-spacing-".concat(this.gap, ")"), ";\n      padding-top: ").concat(this.padding && (0, $dI7zX.UiHelperUtil).getSpacingStyles(this.padding, 0), ";\n      padding-right: ").concat(this.padding && (0, $dI7zX.UiHelperUtil).getSpacingStyles(this.padding, 1), ";\n      padding-bottom: ").concat(this.padding && (0, $dI7zX.UiHelperUtil).getSpacingStyles(this.padding, 2), ";\n      padding-left: ").concat(this.padding && (0, $dI7zX.UiHelperUtil).getSpacingStyles(this.padding, 3), ";\n      margin-top: ").concat(this.margin && (0, $dI7zX.UiHelperUtil).getSpacingStyles(this.margin, 0), ";\n      margin-right: ").concat(this.margin && (0, $dI7zX.UiHelperUtil).getSpacingStyles(this.margin, 1), ";\n      margin-bottom: ").concat(this.margin && (0, $dI7zX.UiHelperUtil).getSpacingStyles(this.margin, 2), ";\n      margin-left: ").concat(this.margin && (0, $dI7zX.UiHelperUtil).getSpacingStyles(this.margin, 3), ";\n    ");
                return (0, $1lUIm.html)($7f71554530133cae$var$_templateObject());
            }
        }
    ]);
    return WuiGrid;
}((0, $eAsDt.LitElement));
$7f71554530133cae$export$834debd63a0ca469.styles = [
    (0, $kYNxm.resetStyles),
    (0, $6Bmrt.default)
];
$7f71554530133cae$var$__decorate([
    (0, $siQym.property)()
], $7f71554530133cae$export$834debd63a0ca469.prototype, "gridTemplateRows", void 0);
$7f71554530133cae$var$__decorate([
    (0, $siQym.property)()
], $7f71554530133cae$export$834debd63a0ca469.prototype, "gridTemplateColumns", void 0);
$7f71554530133cae$var$__decorate([
    (0, $siQym.property)()
], $7f71554530133cae$export$834debd63a0ca469.prototype, "justifyItems", void 0);
$7f71554530133cae$var$__decorate([
    (0, $siQym.property)()
], $7f71554530133cae$export$834debd63a0ca469.prototype, "alignItems", void 0);
$7f71554530133cae$var$__decorate([
    (0, $siQym.property)()
], $7f71554530133cae$export$834debd63a0ca469.prototype, "justifyContent", void 0);
$7f71554530133cae$var$__decorate([
    (0, $siQym.property)()
], $7f71554530133cae$export$834debd63a0ca469.prototype, "alignContent", void 0);
$7f71554530133cae$var$__decorate([
    (0, $siQym.property)()
], $7f71554530133cae$export$834debd63a0ca469.prototype, "columnGap", void 0);
$7f71554530133cae$var$__decorate([
    (0, $siQym.property)()
], $7f71554530133cae$export$834debd63a0ca469.prototype, "rowGap", void 0);
$7f71554530133cae$var$__decorate([
    (0, $siQym.property)()
], $7f71554530133cae$export$834debd63a0ca469.prototype, "gap", void 0);
$7f71554530133cae$var$__decorate([
    (0, $siQym.property)()
], $7f71554530133cae$export$834debd63a0ca469.prototype, "padding", void 0);
$7f71554530133cae$var$__decorate([
    (0, $siQym.property)()
], $7f71554530133cae$export$834debd63a0ca469.prototype, "margin", void 0);
$7f71554530133cae$export$834debd63a0ca469 = $7f71554530133cae$var$__decorate([
    (0, $hdxb6.customElement)("wui-grid")
], $7f71554530133cae$export$834debd63a0ca469);

});
parcelRegister("6Bmrt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ce79b51e9701f42$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $4ce79b51e9701f42$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: grid;\n    width: inherit;\n    height: inherit;\n  }\n"
    ]);
    $4ce79b51e9701f42$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $4ce79b51e9701f42$export$2e2bcd8739ae039 = (0, $bBWVO.css)($4ce79b51e9701f42$var$_templateObject());

});


parcelRegister("4EPbW", function(module, exports) {

$parcel$export(module.exports, "WuiSeparator", function () { return $36429b6ece41f516$export$987a8443516753c9; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4Ztkm");
var $1lUIm = parcelRequire("1lUIm");
var $eAsDt = parcelRequire("eAsDt");
parcelRequire("i1j9A");
var $siQym = parcelRequire("siQym");
parcelRequire("1OYaf");

var $kYNxm = parcelRequire("kYNxm");

var $hdxb6 = parcelRequire("hdxb6");

var $h3VHf = parcelRequire("h3VHf");
function $36429b6ece41f516$var$_templateObject() {
    var data = (0, $j06k0._)([
        "",
        ""
    ]);
    $36429b6ece41f516$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $36429b6ece41f516$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '<wui-text variant="small-500" color="fg-200">',
        "</wui-text>"
    ]);
    $36429b6ece41f516$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $36429b6ece41f516$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $36429b6ece41f516$export$987a8443516753c9 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiSeparator, LitElement);
    var _super = (0, $ohfOJ._)(WuiSeparator);
    function WuiSeparator() {
        (0, $4GJKx._)(this, WuiSeparator);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.text = "";
        return _this;
    }
    (0, $1wc17._)(WuiSeparator, [
        {
            key: "render",
            value: function render() {
                return (0, $1lUIm.html)($36429b6ece41f516$var$_templateObject(), this.template());
            }
        },
        {
            key: "template",
            value: function template() {
                if (this.text) return (0, $1lUIm.html)($36429b6ece41f516$var$_templateObject1(), this.text);
                return null;
            }
        }
    ]);
    return WuiSeparator;
}((0, $eAsDt.LitElement));
$36429b6ece41f516$export$987a8443516753c9.styles = [
    (0, $kYNxm.resetStyles),
    (0, $h3VHf.default)
];
$36429b6ece41f516$var$__decorate([
    (0, $siQym.property)()
], $36429b6ece41f516$export$987a8443516753c9.prototype, "text", void 0);
$36429b6ece41f516$export$987a8443516753c9 = $36429b6ece41f516$var$__decorate([
    (0, $hdxb6.customElement)("wui-separator")
], $36429b6ece41f516$export$987a8443516753c9);

});
parcelRegister("h3VHf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6bf78cc14bbf2db$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4Ztkm");
var $bBWVO = parcelRequire("bBWVO");
function $c6bf78cc14bbf2db$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    position: relative;\n    display: flex;\n    width: 100%;\n    height: 1px;\n    background-color: var(--wui-color-gray-glass-005);\n    justify-content: center;\n    align-items: center;\n  }\n\n  :host > wui-text {\n    position: absolute;\n    padding: 0px 10px;\n    background-color: var(--wui-color-modal-bg);\n  }\n"
    ]);
    $c6bf78cc14bbf2db$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $c6bf78cc14bbf2db$export$2e2bcd8739ae039 = (0, $bBWVO.css)($c6bf78cc14bbf2db$var$_templateObject());

});


parcelRegister("giGFz", function(module, exports) {

$parcel$export(module.exports, "MathUtil", function () { return $bddf6d1260561717$export$cdbe365d8c7d477d; });
var $bddf6d1260561717$export$cdbe365d8c7d477d = {
    interpolate: function(inputRange, outputRange, value) {
        if (inputRange.length !== 2 || outputRange.length !== 2) throw new Error("inputRange and outputRange must be an array of length 2");
        var originalRangeMin = inputRange[0] || 0;
        var originalRangeMax = inputRange[1] || 0;
        var newRangeMin = outputRange[0] || 0;
        var newRangeMax = outputRange[1] || 0;
        if (value < originalRangeMin) return newRangeMin;
        if (value > originalRangeMax) return newRangeMax;
        return (newRangeMax - newRangeMin) / (originalRangeMax - originalRangeMin) * (value - originalRangeMin) + newRangeMin;
    }
};

});

parcelRegister("3kwZm", function(module, exports) {

$parcel$export(module.exports, "TransactionUtil", function () { return $26ccd43cc1d96482$export$445ed8d5992cc5e0; });

var $cv9Rk = parcelRequire("cv9Rk");
parcelRequire("dSKxG");
var $6qlO7 = parcelRequire("6qlO7");

var $dI7zX = parcelRequire("dI7zX");
var $26ccd43cc1d96482$var$FLOAT_FIXED_VALUE = 3;
var $26ccd43cc1d96482$var$plusTypes = [
    "receive",
    "deposit",
    "borrow",
    "claim"
];
var $26ccd43cc1d96482$var$minusTypes = [
    "withdraw",
    "repay",
    "burn"
];
var $26ccd43cc1d96482$export$445ed8d5992cc5e0 = {
    getMonthName: function(monthNumber) {
        var date = new Date();
        date.setMonth(monthNumber);
        return date.toLocaleString("en-US", {
            month: "long"
        });
    },
    getTransactionGroupTitle: function(year, month) {
        var currentYear = (0, $6qlO7.DateUtil).getYear();
        var monthName = this.getMonthName(month);
        var isCurrentYear = year === currentYear;
        var groupTitle = isCurrentYear ? monthName : "".concat(monthName, " ").concat(year);
        return groupTitle;
    },
    getTransactionImages: function(transfers) {
        var _this = this;
        var _transfers = (0, $cv9Rk._)(transfers, 2), transfer = _transfers[0], secondTransfer = _transfers[1];
        var isAllNFT = Boolean(transfer) && (transfers === null || transfers === void 0 ? void 0 : transfers.every(function(item) {
            return Boolean(item.nft_info);
        }));
        var haveMultipleTransfers = (transfers === null || transfers === void 0 ? void 0 : transfers.length) > 1;
        var haveTwoTransfers = (transfers === null || transfers === void 0 ? void 0 : transfers.length) === 2;
        if (haveTwoTransfers && !isAllNFT) return [
            this.getTransactionImage(transfer),
            this.getTransactionImage(secondTransfer)
        ];
        if (haveMultipleTransfers) return transfers.map(function(item) {
            return _this.getTransactionImage(item);
        });
        return [
            this.getTransactionImage(transfer)
        ];
    },
    getTransactionImage: function(transfer) {
        return {
            type: $26ccd43cc1d96482$export$445ed8d5992cc5e0.getTransactionTransferTokenType(transfer),
            url: $26ccd43cc1d96482$export$445ed8d5992cc5e0.getTransactionImageURL(transfer)
        };
    },
    getTransactionImageURL: function(transfer) {
        var _transfer_nft_info_content_preview, _transfer_nft_info_content, _transfer_nft_info, _transfer_fungible_info_icon, _transfer_fungible_info;
        var imageURL = undefined;
        var isNFT = Boolean(transfer === null || transfer === void 0 ? void 0 : transfer.nft_info);
        var isFungible = Boolean(transfer === null || transfer === void 0 ? void 0 : transfer.fungible_info);
        if (transfer && isNFT) imageURL = transfer === null || transfer === void 0 ? void 0 : (_transfer_nft_info = transfer.nft_info) === null || _transfer_nft_info === void 0 ? void 0 : (_transfer_nft_info_content = _transfer_nft_info.content) === null || _transfer_nft_info_content === void 0 ? void 0 : (_transfer_nft_info_content_preview = _transfer_nft_info_content.preview) === null || _transfer_nft_info_content_preview === void 0 ? void 0 : _transfer_nft_info_content_preview.url;
        else if (transfer && isFungible) imageURL = transfer === null || transfer === void 0 ? void 0 : (_transfer_fungible_info = transfer.fungible_info) === null || _transfer_fungible_info === void 0 ? void 0 : (_transfer_fungible_info_icon = _transfer_fungible_info.icon) === null || _transfer_fungible_info_icon === void 0 ? void 0 : _transfer_fungible_info_icon.url;
        return imageURL;
    },
    getTransactionTransferTokenType: function(transfer) {
        if (transfer === null || transfer === void 0 ? void 0 : transfer.fungible_info) return "FUNGIBLE";
        else if (transfer === null || transfer === void 0 ? void 0 : transfer.nft_info) return "NFT";
        return undefined;
    },
    getTransactionDescriptions: function(transaction) {
        var _this = this;
        var _transaction_metadata, _transaction_transfers, _transaction_transfers1;
        var type = transaction === null || transaction === void 0 ? void 0 : (_transaction_metadata = transaction.metadata) === null || _transaction_metadata === void 0 ? void 0 : _transaction_metadata.operationType;
        var transfers = transaction === null || transaction === void 0 ? void 0 : transaction.transfers;
        var haveTransfer = (transaction === null || transaction === void 0 ? void 0 : (_transaction_transfers = transaction.transfers) === null || _transaction_transfers === void 0 ? void 0 : _transaction_transfers.length) > 0;
        var haveMultipleTransfers = (transaction === null || transaction === void 0 ? void 0 : (_transaction_transfers1 = transaction.transfers) === null || _transaction_transfers1 === void 0 ? void 0 : _transaction_transfers1.length) > 1;
        var isFungible = haveTransfer && (transfers === null || transfers === void 0 ? void 0 : transfers.every(function(transfer) {
            return Boolean(transfer === null || transfer === void 0 ? void 0 : transfer.fungible_info);
        }));
        var _transfers = (0, $cv9Rk._)(transfers, 2), firstTransfer = _transfers[0], secondTransfer = _transfers[1];
        var firstDescription = this.getTransferDescription(firstTransfer);
        var secondDescription = this.getTransferDescription(secondTransfer);
        if (!haveTransfer) {
            var isSendOrReceive = type === "send" || type === "receive";
            if (isSendOrReceive && isFungible) {
                firstDescription = (0, $dI7zX.UiHelperUtil).getTruncateString({
                    string: transaction === null || transaction === void 0 ? void 0 : transaction.metadata.sentFrom,
                    charsStart: 4,
                    charsEnd: 6,
                    truncate: "middle"
                });
                secondDescription = (0, $dI7zX.UiHelperUtil).getTruncateString({
                    string: transaction === null || transaction === void 0 ? void 0 : transaction.metadata.sentTo,
                    charsStart: 4,
                    charsEnd: 6,
                    truncate: "middle"
                });
                return [
                    firstDescription,
                    secondDescription
                ];
            }
            return [
                transaction.metadata.status
            ];
        }
        if (haveMultipleTransfers) return transfers.map(function(item) {
            return _this.getTransferDescription(item);
        });
        var prefix = "";
        if ($26ccd43cc1d96482$var$plusTypes.includes(type)) prefix = "+";
        else if ($26ccd43cc1d96482$var$minusTypes.includes(type)) prefix = "-";
        firstDescription = prefix.concat(firstDescription);
        return [
            firstDescription
        ];
    },
    getTransferDescription: function(transfer) {
        var _transfer_nft_info;
        var description = "";
        if (!transfer) return description;
        if (transfer === null || transfer === void 0 ? void 0 : transfer.nft_info) description = (transfer === null || transfer === void 0 ? void 0 : (_transfer_nft_info = transfer.nft_info) === null || _transfer_nft_info === void 0 ? void 0 : _transfer_nft_info.name) || "-";
        else if (transfer === null || transfer === void 0 ? void 0 : transfer.fungible_info) description = this.getFungibleTransferDescription(transfer) || "-";
        return description;
    },
    getFungibleTransferDescription: function(transfer) {
        var _transfer_fungible_info;
        if (!transfer) return null;
        var quantity = this.getQuantityFixedValue(transfer === null || transfer === void 0 ? void 0 : transfer.quantity.numeric);
        var description = [
            quantity,
            transfer === null || transfer === void 0 ? void 0 : (_transfer_fungible_info = transfer.fungible_info) === null || _transfer_fungible_info === void 0 ? void 0 : _transfer_fungible_info.symbol
        ].join(" ").trim();
        return description;
    },
    getQuantityFixedValue: function(value) {
        if (!value) return null;
        var parsedValue = parseFloat(value);
        return parsedValue.toFixed($26ccd43cc1d96482$var$FLOAT_FIXED_VALUE);
    }
};

});


parcelRegister("jCIHD", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("d2Ske")).then(function() {
    return parcelRequire("8ecTx");
});

});
parcelRegister("eg86f", function(module, exports) {
"use strict";

var $31a2I = parcelRequire("31a2I");
module.exports = $31a2I(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("31a2I", function(module, exports) {
"use strict";
var $23294162c634ba05$var$cachedBundles = {};
var $23294162c634ba05$var$cachedPreloads = {};
var $23294162c634ba05$var$cachedPrefetches = {};
function $23294162c634ba05$var$getCache(type) {
    switch(type){
        case "preload":
            return $23294162c634ba05$var$cachedPreloads;
        case "prefetch":
            return $23294162c634ba05$var$cachedPrefetches;
        default:
            return $23294162c634ba05$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $23294162c634ba05$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("gtcRQ", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("eDVZM")).then(function() {
    return parcelRequire("5ONDf");
});

});

parcelRegister("4A6TP", function(module, exports) {
$parcel$export(module.exports, "html", function () { return (parcelRequire("hxyOZ")).html; });
$parcel$export(module.exports, "LitElement", function () { return (parcelRequire("2yD3e")).LitElement; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("2D5eP")).css; });
parcelRequire("ipLAV");
parcelRequire("hxyOZ");
parcelRequire("2yD3e");
parcelRequire("iqhuo");

});
parcelRegister("ipLAV", function(module, exports) {

$parcel$export(module.exports, "defaultConverter", function () { return $d67f7b15e67ffa96$export$7312b35fbf521afb; });
$parcel$export(module.exports, "notEqual", function () { return $d67f7b15e67ffa96$export$53a6892c50694894; });
$parcel$export(module.exports, "ReactiveElement", function () { return $d67f7b15e67ffa96$export$c7c07a37856565d; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("2D5eP")).css; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $3U0IP = parcelRequire("3U0IP");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");

var $2D5eP = parcelRequire("2D5eP");
var $d67f7b15e67ffa96$var$_Symbol, $d67f7b15e67ffa96$var$_a, $d67f7b15e67ffa96$var$_a1;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $d67f7b15e67ffa96$var$i = Object.is, $d67f7b15e67ffa96$var$e = Object.defineProperty, $d67f7b15e67ffa96$var$r = Object.getOwnPropertyDescriptor, $d67f7b15e67ffa96$var$h = Object.getOwnPropertyNames, $d67f7b15e67ffa96$var$o = Object.getOwnPropertySymbols, $d67f7b15e67ffa96$var$n = Object.getPrototypeOf, $d67f7b15e67ffa96$var$a = globalThis, $d67f7b15e67ffa96$var$c = $d67f7b15e67ffa96$var$a.trustedTypes, $d67f7b15e67ffa96$var$l = $d67f7b15e67ffa96$var$c ? $d67f7b15e67ffa96$var$c.emptyScript : "", $d67f7b15e67ffa96$var$p = $d67f7b15e67ffa96$var$a.reactiveElementPolyfillSupport, $d67f7b15e67ffa96$var$d = function(t, s) {
    return t;
}, $d67f7b15e67ffa96$export$7312b35fbf521afb = {
    toAttribute: function(t, s) {
        switch(s){
            case Boolean:
                t = t ? $d67f7b15e67ffa96$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute: function(t, s) {
        var i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $d67f7b15e67ffa96$export$53a6892c50694894 = function(t, s) {
    return !$d67f7b15e67ffa96$var$i(t, s);
}, $d67f7b15e67ffa96$var$y = {
    attribute: !0,
    type: String,
    converter: $d67f7b15e67ffa96$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $d67f7b15e67ffa96$export$53a6892c50694894
};
var $d67f7b15e67ffa96$var$_metadata, $d67f7b15e67ffa96$var$_litPropertyMetadata;
($d67f7b15e67ffa96$var$_metadata = ($d67f7b15e67ffa96$var$_Symbol = Symbol).metadata) !== null && $d67f7b15e67ffa96$var$_metadata !== void 0 ? $d67f7b15e67ffa96$var$_metadata : $d67f7b15e67ffa96$var$_Symbol.metadata = Symbol("metadata"), ($d67f7b15e67ffa96$var$_litPropertyMetadata = ($d67f7b15e67ffa96$var$_a = $d67f7b15e67ffa96$var$a).litPropertyMetadata) !== null && $d67f7b15e67ffa96$var$_litPropertyMetadata !== void 0 ? $d67f7b15e67ffa96$var$_litPropertyMetadata : $d67f7b15e67ffa96$var$_a.litPropertyMetadata = new WeakMap;
var $d67f7b15e67ffa96$export$c7c07a37856565d = /*#__PURE__*/ function(HTMLElement1) {
    "use strict";
    (0, $dcsZi._)(b, HTMLElement1);
    var _super = (0, $ohfOJ._)(b);
    function b() {
        (0, $4GJKx._)(this, b);
        var _this;
        _this = _super.call(this), _this._$Ep = void 0, _this.isUpdatePending = !1, _this.hasUpdated = !1, _this._$Em = null, _this._$Ev();
        return (0, $3U0IP._)(_this);
    }
    (0, $1wc17._)(b, [
        {
            key: "_$Ev",
            value: function _$Ev() {
                var _this = this;
                var _this_constructor_l;
                this._$ES = new Promise(function(t) {
                    return _this.enableUpdating = t;
                }), this._$AL = new Map, this._$E_(), this.requestUpdate(), (_this_constructor_l = this.constructor.l) === null || _this_constructor_l === void 0 ? void 0 : _this_constructor_l.forEach(function(t) {
                    return t(_this);
                });
            }
        },
        {
            key: "addController",
            value: function addController(t) {
                var _t_hostConnected;
                var _this__$EO;
                ((_this__$EO = this._$EO) !== null && _this__$EO !== void 0 ? _this__$EO : this._$EO = new Set).add(t), void 0 !== this.renderRoot && this.isConnected && ((_t_hostConnected = t.hostConnected) === null || _t_hostConnected === void 0 ? void 0 : _t_hostConnected.call(t));
            }
        },
        {
            key: "removeController",
            value: function removeController(t) {
                var _this__$EO;
                (_this__$EO = this._$EO) === null || _this__$EO === void 0 ? void 0 : _this__$EO.delete(t);
            }
        },
        {
            key: "_$E_",
            value: function _$E_() {
                var t = new Map, s = this.constructor.elementProperties;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = s.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                t.size > 0 && (this._$Ep = t);
            }
        },
        {
            key: "createRenderRoot",
            value: function createRenderRoot() {
                var _this_shadowRoot;
                var t = (_this_shadowRoot = this.shadowRoot) !== null && _this_shadowRoot !== void 0 ? _this_shadowRoot : this.attachShadow(this.constructor.shadowRootOptions);
                return (0, $2D5eP.adoptStyles)(t, this.constructor.elementStyles), t;
            }
        },
        {
            key: "connectedCallback",
            value: function connectedCallback() {
                var _this__$EO;
                var _this_renderRoot;
                (_this_renderRoot = this.renderRoot) !== null && _this_renderRoot !== void 0 ? _this_renderRoot : this.renderRoot = this.createRenderRoot(), this.enableUpdating(!0), (_this__$EO = this._$EO) === null || _this__$EO === void 0 ? void 0 : _this__$EO.forEach(function(t) {
                    var _t_hostConnected;
                    return (_t_hostConnected = t.hostConnected) === null || _t_hostConnected === void 0 ? void 0 : _t_hostConnected.call(t);
                });
            }
        },
        {
            key: "enableUpdating",
            value: function enableUpdating(t) {}
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                var _this__$EO;
                (_this__$EO = this._$EO) === null || _this__$EO === void 0 ? void 0 : _this__$EO.forEach(function(t) {
                    var _t_hostDisconnected;
                    return (_t_hostDisconnected = t.hostDisconnected) === null || _t_hostDisconnected === void 0 ? void 0 : _t_hostDisconnected.call(t);
                });
            }
        },
        {
            key: "attributeChangedCallback",
            value: function attributeChangedCallback(t, s, i) {
                this._$AK(t, i);
            }
        },
        {
            key: "_$EC",
            value: function _$EC(t, s) {
                var i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
                if (void 0 !== e && !0 === i.reflect) {
                    var _i_converter;
                    var r = (void 0 !== ((_i_converter = i.converter) === null || _i_converter === void 0 ? void 0 : _i_converter.toAttribute) ? i.converter : $d67f7b15e67ffa96$export$7312b35fbf521afb).toAttribute(s, i.type);
                    this._$Em = t, null == r ? this.removeAttribute(e) : this.setAttribute(e, r), this._$Em = null;
                }
            }
        },
        {
            key: "_$AK",
            value: function _$AK(t, s) {
                var i = this.constructor, e = i._$Eh.get(t);
                if (void 0 !== e && this._$Em !== e) {
                    var _t_converter;
                    var _$t = i.getPropertyOptions(e), r = "function" == typeof _$t.converter ? {
                        fromAttribute: _$t.converter
                    } : void 0 !== ((_t_converter = _$t.converter) === null || _t_converter === void 0 ? void 0 : _t_converter.fromAttribute) ? _$t.converter : $d67f7b15e67ffa96$export$7312b35fbf521afb;
                    this._$Em = e, this[e] = r.fromAttribute(s, _$t.type), this._$Em = null;
                }
            }
        },
        {
            key: "requestUpdate",
            value: function requestUpdate(t, s, i) {
                if (void 0 !== t) {
                    var _i_hasChanged;
                    if (i !== null && i !== void 0 ? i : i = this.constructor.getPropertyOptions(t), !((_i_hasChanged = i.hasChanged) !== null && _i_hasChanged !== void 0 ? _i_hasChanged : $d67f7b15e67ffa96$export$53a6892c50694894)(this[t], s)) return;
                    this.P(t, s, i);
                }
                !1 === this.isUpdatePending && (this._$ES = this._$ET());
            }
        },
        {
            key: "P",
            value: function P(t, s, i) {
                var _this__$Ej;
                this._$AL.has(t) || this._$AL.set(t, s), !0 === i.reflect && this._$Em !== t && ((_this__$Ej = this._$Ej) !== null && _this__$Ej !== void 0 ? _this__$Ej : this._$Ej = new Set).add(t);
            }
        },
        {
            key: "_$ET",
            value: function _$ET() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var t, _$t, _tmp;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.isUpdatePending = !0;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this._$ES
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                t = _state.sent();
                                Promise.reject(t);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                _$t = _this.scheduleUpdate();
                                _tmp = null != _$t;
                                if (!_tmp) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    _$t
                                ];
                            case 5:
                                _tmp = _state.sent();
                                _state.label = 6;
                            case 6:
                                return [
                                    2,
                                    (_tmp, !_this.isUpdatePending)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "scheduleUpdate",
            value: function scheduleUpdate() {
                return this.performUpdate();
            }
        },
        {
            key: "performUpdate",
            value: function performUpdate() {
                if (!this.isUpdatePending) return;
                if (!this.hasUpdated) {
                    var _this_renderRoot;
                    if ((_this_renderRoot = this.renderRoot) !== null && _this_renderRoot !== void 0 ? _this_renderRoot : this.renderRoot = this.createRenderRoot(), this._$Ep) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this._$Ep[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _step_value = (0, $cv9Rk._)(_step.value, 2), t = _step_value[0], _$s = _step_value[1];
                                this[t] = _$s;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        this._$Ep = void 0;
                    }
                    var t1 = this.constructor.elementProperties;
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    if (t1.size > 0) try {
                        for(var _iterator1 = t1[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var _step_value1 = (0, $cv9Rk._)(_step1.value, 2), _$s1 = _step_value1[0], i = _step_value1[1];
                            !0 !== i.wrapped || this._$AL.has(_$s1) || void 0 === this[_$s1] || this.P(_$s1, this[_$s1], i);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
                var t2 = !1;
                var _$s2 = this._$AL;
                try {
                    var _this__$EO;
                    t2 = this.shouldUpdate(_$s2), t2 ? (this.willUpdate(_$s2), (_this__$EO = this._$EO) === null || _this__$EO === void 0 ? void 0 : _this__$EO.forEach(function(t) {
                        var _t_hostUpdate;
                        return (_t_hostUpdate = t.hostUpdate) === null || _t_hostUpdate === void 0 ? void 0 : _t_hostUpdate.call(t);
                    }), this.update(_$s2)) : this._$EU();
                } catch (s) {
                    throw t2 = !1, this._$EU(), s;
                }
                t2 && this._$AE(_$s2);
            }
        },
        {
            key: "willUpdate",
            value: function willUpdate(t) {}
        },
        {
            key: "_$AE",
            value: function _$AE(t) {
                var _this__$EO;
                (_this__$EO = this._$EO) === null || _this__$EO === void 0 ? void 0 : _this__$EO.forEach(function(t) {
                    var _t_hostUpdated;
                    return (_t_hostUpdated = t.hostUpdated) === null || _t_hostUpdated === void 0 ? void 0 : _t_hostUpdated.call(t);
                }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
            }
        },
        {
            key: "_$EU",
            value: function _$EU() {
                this._$AL = new Map, this.isUpdatePending = !1;
            }
        },
        {
            key: "updateComplete",
            get: function get() {
                return this.getUpdateComplete();
            }
        },
        {
            key: "getUpdateComplete",
            value: function getUpdateComplete() {
                return this._$ES;
            }
        },
        {
            key: "shouldUpdate",
            value: function shouldUpdate(t) {
                return !0;
            }
        },
        {
            key: "update",
            value: function update(t) {
                var _this = this;
                this._$Ej && (this._$Ej = this._$Ej.forEach(function(t) {
                    return _this._$EC(t, _this[t]);
                })), this._$EU();
            }
        },
        {
            key: "updated",
            value: function updated(t) {}
        },
        {
            key: "firstUpdated",
            value: function firstUpdated(t) {}
        }
    ], [
        {
            key: "addInitializer",
            value: function addInitializer(t) {
                var _this_l;
                this._$Ei(), ((_this_l = this.l) !== null && _this_l !== void 0 ? _this_l : this.l = []).push(t);
            }
        },
        {
            key: "observedAttributes",
            get: function get() {
                return this.finalize(), this._$Eh && (0, $c6Xmf._)(this._$Eh.keys());
            }
        },
        {
            key: "createProperty",
            value: function createProperty(t) {
                var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $d67f7b15e67ffa96$var$y;
                if (s.state && (s.attribute = !1), this._$Ei(), this.elementProperties.set(t, s), !s.noAccessor) {
                    var i = Symbol(), r = this.getPropertyDescriptor(t, i, s);
                    void 0 !== r && $d67f7b15e67ffa96$var$e(this.prototype, t, r);
                }
            }
        },
        {
            key: "getPropertyDescriptor",
            value: function getPropertyDescriptor(t, s, i) {
                var _r;
                var _ref = (_r = $d67f7b15e67ffa96$var$r(this.prototype, t)) !== null && _r !== void 0 ? _r : {
                    get: function() {
                        return this[s];
                    },
                    set: function(t) {
                        this[s] = t;
                    }
                }, e = _ref.get, h = _ref.set;
                return {
                    get: function() {
                        return e === null || e === void 0 ? void 0 : e.call(this);
                    },
                    set: function(s) {
                        var r = e === null || e === void 0 ? void 0 : e.call(this);
                        h.call(this, s), this.requestUpdate(t, r, i);
                    },
                    configurable: !0,
                    enumerable: !0
                };
            }
        },
        {
            key: "getPropertyOptions",
            value: function getPropertyOptions(t) {
                var _this_elementProperties_get;
                return (_this_elementProperties_get = this.elementProperties.get(t)) !== null && _this_elementProperties_get !== void 0 ? _this_elementProperties_get : $d67f7b15e67ffa96$var$y;
            }
        },
        {
            key: "_$Ei",
            value: function _$Ei() {
                if (this.hasOwnProperty($d67f7b15e67ffa96$var$d("elementProperties"))) return;
                var t = $d67f7b15e67ffa96$var$n(this);
                t.finalize(), void 0 !== t.l && (this.l = (0, $c6Xmf._)(t.l)), this.elementProperties = new Map(t.elementProperties);
            }
        },
        {
            key: "finalize",
            value: function finalize() {
                if (this.hasOwnProperty($d67f7b15e67ffa96$var$d("finalized"))) return;
                if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($d67f7b15e67ffa96$var$d("properties"))) {
                    var t = this.properties, s = (0, $c6Xmf._)($d67f7b15e67ffa96$var$h(t)).concat((0, $c6Xmf._)($d67f7b15e67ffa96$var$o(t)));
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = s[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var i = _step.value;
                            this.createProperty(i, t[i]);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                var t1 = this[Symbol.metadata];
                if (null !== t1) {
                    var s1 = litPropertyMetadata.get(t1);
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    if (void 0 !== s1) try {
                        for(var _iterator1 = s1[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var _step_value = (0, $cv9Rk._)(_step1.value, 2), t2 = _step_value[0], i1 = _step_value[1];
                            this.elementProperties.set(t2, i1);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
                this._$Eh = new Map;
                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                try {
                    for(var _iterator2 = this.elementProperties[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                        var _step_value1 = (0, $cv9Rk._)(_step2.value, 2), t3 = _step_value1[0], s2 = _step_value1[1];
                        var i2 = this._$Eu(t3, s2);
                        void 0 !== i2 && this._$Eh.set(i2, t3);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                            _iterator2.return();
                        }
                    } finally{
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
                this.elementStyles = this.finalizeStyles(this.styles);
            }
        },
        {
            key: "finalizeStyles",
            value: function finalizeStyles(s) {
                var i = [];
                if (Array.isArray(s)) {
                    var e = new Set(s.flat(1 / 0).reverse());
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$s = _step.value;
                            i.unshift((0, $2D5eP.getCompatibleStyle)(_$s));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                } else void 0 !== s && i.push((0, $2D5eP.getCompatibleStyle)(s));
                return i;
            }
        },
        {
            key: "_$Eu",
            value: function _$Eu(t, s) {
                var i = s.attribute;
                return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
            }
        }
    ]);
    return b;
}((0, $FuVm8._)(HTMLElement));
var $d67f7b15e67ffa96$var$_reactiveElementVersions;
$d67f7b15e67ffa96$export$c7c07a37856565d.elementStyles = [], $d67f7b15e67ffa96$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $d67f7b15e67ffa96$export$c7c07a37856565d[$d67f7b15e67ffa96$var$d("elementProperties")] = new Map, $d67f7b15e67ffa96$export$c7c07a37856565d[$d67f7b15e67ffa96$var$d("finalized")] = new Map, $d67f7b15e67ffa96$var$p === null || $d67f7b15e67ffa96$var$p === void 0 ? void 0 : $d67f7b15e67ffa96$var$p({
    ReactiveElement: $d67f7b15e67ffa96$export$c7c07a37856565d
}), (($d67f7b15e67ffa96$var$_reactiveElementVersions = ($d67f7b15e67ffa96$var$_a1 = $d67f7b15e67ffa96$var$a).reactiveElementVersions) !== null && $d67f7b15e67ffa96$var$_reactiveElementVersions !== void 0 ? $d67f7b15e67ffa96$var$_reactiveElementVersions : $d67f7b15e67ffa96$var$_a1.reactiveElementVersions = []).push("2.0.4");

});
parcelRegister("2D5eP", function(module, exports) {

$parcel$export(module.exports, "css", function () { return $1ea3497ab94487f1$export$dbf350e5966cf602; });
$parcel$export(module.exports, "adoptStyles", function () { return $1ea3497ab94487f1$export$2ca4a66ec4cecb90; });
$parcel$export(module.exports, "getCompatibleStyle", function () { return $1ea3497ab94487f1$export$ee69dfd951e24778; });
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ 
var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");
var $1ea3497ab94487f1$var$t = globalThis, $1ea3497ab94487f1$export$b4d10f6001c083c2 = $1ea3497ab94487f1$var$t.ShadowRoot && (void 0 === $1ea3497ab94487f1$var$t.ShadyCSS || $1ea3497ab94487f1$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $1ea3497ab94487f1$var$s = Symbol(), $1ea3497ab94487f1$var$o = new WeakMap;
var $1ea3497ab94487f1$export$505d1e8739bad805 = /*#__PURE__*/ function() {
    "use strict";
    function n(t, e, o) {
        (0, $4GJKx._)(this, n);
        if (this._$cssResult$ = !0, o !== $1ea3497ab94487f1$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    (0, $1wc17._)(n, [
        {
            key: "styleSheet",
            get: function get() {
                var t = this.o;
                var s = this.t;
                if ($1ea3497ab94487f1$export$b4d10f6001c083c2 && void 0 === t) {
                    var e1 = void 0 !== s && 1 === s.length;
                    e1 && (t = $1ea3497ab94487f1$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e1 && $1ea3497ab94487f1$var$o.set(s, t));
                }
                return t;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.cssText;
            }
        }
    ]);
    return n;
}();
var $1ea3497ab94487f1$export$8d80f9cac07cdb3 = function(t) {
    return new $1ea3497ab94487f1$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $1ea3497ab94487f1$var$s);
}, $1ea3497ab94487f1$export$dbf350e5966cf602 = function(t) {
    for(var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        e[_key - 1] = arguments[_key];
    }
    var o = 1 === t.length ? t[0] : e.reduce(function(e, s, o) {
        return e + function(t) {
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        }(s) + t[o + 1];
    }, t[0]);
    return new $1ea3497ab94487f1$export$505d1e8739bad805(o, t, $1ea3497ab94487f1$var$s);
}, $1ea3497ab94487f1$export$2ca4a66ec4cecb90 = function(s, o) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($1ea3497ab94487f1$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map(function(t) {
        return t instanceof CSSStyleSheet ? t : t.styleSheet;
    });
    else try {
        for(var _iterator = o[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var e1 = _step.value;
            var _$o = document.createElement("style"), n = $1ea3497ab94487f1$var$t.litNonce;
            void 0 !== n && _$o.setAttribute("nonce", n), _$o.textContent = e1.cssText, s.appendChild(_$o);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}, $1ea3497ab94487f1$export$ee69dfd951e24778 = $1ea3497ab94487f1$export$b4d10f6001c083c2 ? function(t) {
    return t;
} : function(t) {
    return t instanceof CSSStyleSheet ? function(t) {
        var e = "";
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = t.cssRules[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var s = _step.value;
                e += s.cssText;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return $1ea3497ab94487f1$export$8d80f9cac07cdb3(e);
    }(t) : t;
};

});


parcelRegister("hxyOZ", function(module, exports) {

$parcel$export(module.exports, "html", function () { return $cc508789fb87c5a2$export$c0bb0b647f701bb5; });
$parcel$export(module.exports, "noChange", function () { return $cc508789fb87c5a2$export$9c068ae9cc5db4e8; });
$parcel$export(module.exports, "nothing", function () { return $cc508789fb87c5a2$export$45b790e32b2810ee; });
$parcel$export(module.exports, "_$LH", function () { return $cc508789fb87c5a2$export$8613d1ca9052b22e; });
$parcel$export(module.exports, "render", function () { return $cc508789fb87c5a2$export$b3890eb0ae9dca99; });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ 
var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $3U0IP = parcelRequire("3U0IP");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $ohfOJ = parcelRequire("ohfOJ");
var $cc508789fb87c5a2$var$_n;
var $cc508789fb87c5a2$var$n = globalThis, $cc508789fb87c5a2$var$c = $cc508789fb87c5a2$var$n.trustedTypes, $cc508789fb87c5a2$var$h = $cc508789fb87c5a2$var$c ? $cc508789fb87c5a2$var$c.createPolicy("lit-html", {
    createHTML: function(t) {
        return t;
    }
}) : void 0, $cc508789fb87c5a2$var$f = "$lit$", $cc508789fb87c5a2$var$v = "lit$".concat(Math.random().toFixed(9).slice(2), "$"), $cc508789fb87c5a2$var$m = "?" + $cc508789fb87c5a2$var$v, $cc508789fb87c5a2$var$_ = "<".concat($cc508789fb87c5a2$var$m, ">"), $cc508789fb87c5a2$var$w = document, $cc508789fb87c5a2$var$lt = function() {
    return $cc508789fb87c5a2$var$w.createComment("");
}, $cc508789fb87c5a2$var$st = function(t) {
    return null === t || "object" != typeof t && "function" != typeof t;
}, $cc508789fb87c5a2$var$g = Array.isArray, $cc508789fb87c5a2$var$$ = function(t) {
    return $cc508789fb87c5a2$var$g(t) || "function" == typeof (t === null || t === void 0 ? void 0 : t[Symbol.iterator]);
}, $cc508789fb87c5a2$var$x = "[ 	\n\f\r]", $cc508789fb87c5a2$var$T = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $cc508789fb87c5a2$var$E = /-->/g, $cc508789fb87c5a2$var$k = />/g, $cc508789fb87c5a2$var$O = RegExp(">|".concat($cc508789fb87c5a2$var$x, "(?:([^\\s\"'>=/]+)(").concat($cc508789fb87c5a2$var$x, "*=").concat($cc508789fb87c5a2$var$x, "*(?:[^ 	\n\f\r\"'`<>=]|(\"|')|))|$)"), "g"), $cc508789fb87c5a2$var$S = /'/g, $cc508789fb87c5a2$var$j = /"/g, $cc508789fb87c5a2$var$M = /^(?:script|style|textarea|title)$/i, $cc508789fb87c5a2$var$P = function(t) {
    return function(i) {
        for(var _len = arguments.length, s = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            s[_key - 1] = arguments[_key];
        }
        return {
            _$litType$: t,
            strings: i,
            values: s
        };
    };
}, $cc508789fb87c5a2$export$c0bb0b647f701bb5 = $cc508789fb87c5a2$var$P(1), $cc508789fb87c5a2$export$7ed1367e7fa1ad68 = $cc508789fb87c5a2$var$P(2), $cc508789fb87c5a2$export$47d5b44d225be5b4 = $cc508789fb87c5a2$var$P(3), $cc508789fb87c5a2$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $cc508789fb87c5a2$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $cc508789fb87c5a2$var$V = new WeakMap, $cc508789fb87c5a2$var$I = $cc508789fb87c5a2$var$w.createTreeWalker($cc508789fb87c5a2$var$w, 129);
function $cc508789fb87c5a2$var$N(t, i) {
    if (!$cc508789fb87c5a2$var$g(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $cc508789fb87c5a2$var$h ? $cc508789fb87c5a2$var$h.createHTML(i) : i;
}
var $cc508789fb87c5a2$var$U = function(t, i) {
    var s = t.length - 1, e = [];
    var h, o = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", n = $cc508789fb87c5a2$var$T;
    for(var _$i = 0; _$i < s; _$i++){
        var s1 = t[_$i];
        var r = void 0, l = void 0, c = -1, a = 0;
        for(; a < s1.length && (n.lastIndex = a, l = n.exec(s1), null !== l);)a = n.lastIndex, n === $cc508789fb87c5a2$var$T ? "!--" === l[1] ? n = $cc508789fb87c5a2$var$E : void 0 !== l[1] ? n = $cc508789fb87c5a2$var$k : void 0 !== l[2] ? ($cc508789fb87c5a2$var$M.test(l[2]) && (h = RegExp("</" + l[2], "g")), n = $cc508789fb87c5a2$var$O) : void 0 !== l[3] && (n = $cc508789fb87c5a2$var$O) : n === $cc508789fb87c5a2$var$O ? ">" === l[0] ? (n = h !== null && h !== void 0 ? h : $cc508789fb87c5a2$var$T, c = -1) : void 0 === l[1] ? c = -2 : (c = n.lastIndex - l[2].length, r = l[1], n = void 0 === l[3] ? $cc508789fb87c5a2$var$O : '"' === l[3] ? $cc508789fb87c5a2$var$j : $cc508789fb87c5a2$var$S) : n === $cc508789fb87c5a2$var$j || n === $cc508789fb87c5a2$var$S ? n = $cc508789fb87c5a2$var$O : n === $cc508789fb87c5a2$var$E || n === $cc508789fb87c5a2$var$k ? n = $cc508789fb87c5a2$var$T : (n = $cc508789fb87c5a2$var$O, h = void 0);
        var u = n === $cc508789fb87c5a2$var$O && t[_$i + 1].startsWith("/>") ? " " : "";
        o += n === $cc508789fb87c5a2$var$T ? s1 + $cc508789fb87c5a2$var$_ : c >= 0 ? (e.push(r), s1.slice(0, c) + $cc508789fb87c5a2$var$f + s1.slice(c) + $cc508789fb87c5a2$var$v + u) : s1 + $cc508789fb87c5a2$var$v + (-2 === c ? _$i : u);
    }
    return [
        $cc508789fb87c5a2$var$N(t, o + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        e
    ];
};
var $cc508789fb87c5a2$var$B = /*#__PURE__*/ function() {
    "use strict";
    function B(param, s) {
        var t = param.strings, i = param._$litType$;
        (0, $4GJKx._)(this, B);
        var e;
        this.parts = [];
        var h = 0, o = 0;
        var n = t.length - 1, r = this.parts, _U = (0, $cv9Rk._)($cc508789fb87c5a2$var$U(t, i), 2), l = _U[0], a = _U[1];
        if (this.el = B.createElement(l, s), $cc508789fb87c5a2$var$I.currentNode = this.el.content, 2 === i || 3 === i) {
            var _t;
            var t1 = this.el.content.firstChild;
            (_t = t1).replaceWith.apply(_t, (0, $c6Xmf._)(t1.childNodes));
        }
        for(; null !== (e = $cc508789fb87c5a2$var$I.nextNode()) && r.length < n;){
            if (1 === e.nodeType) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (e.hasAttributes()) try {
                    for(var _iterator = e.getAttributeNames()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var t2 = _step.value;
                        if (t2.endsWith($cc508789fb87c5a2$var$f)) {
                            var i1 = a[o++], _$s = e.getAttribute(t2).split($cc508789fb87c5a2$var$v), n1 = /([.?@])?(.*)/.exec(i1);
                            r.push({
                                type: 1,
                                index: h,
                                name: n1[2],
                                strings: _$s,
                                ctor: "." === n1[1] ? $cc508789fb87c5a2$var$Y : "?" === n1[1] ? $cc508789fb87c5a2$var$Z : "@" === n1[1] ? $cc508789fb87c5a2$var$q : $cc508789fb87c5a2$var$G
                            }), e.removeAttribute(t2);
                        } else t2.startsWith($cc508789fb87c5a2$var$v) && (r.push({
                            type: 6,
                            index: h
                        }), e.removeAttribute(t2));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if ($cc508789fb87c5a2$var$M.test(e.tagName)) {
                    var t3 = e.textContent.split($cc508789fb87c5a2$var$v), i2 = t3.length - 1;
                    if (i2 > 0) {
                        e.textContent = $cc508789fb87c5a2$var$c ? $cc508789fb87c5a2$var$c.emptyScript : "";
                        for(var _$s1 = 0; _$s1 < i2; _$s1++)e.append(t3[_$s1], $cc508789fb87c5a2$var$lt()), $cc508789fb87c5a2$var$I.nextNode(), r.push({
                            type: 2,
                            index: ++h
                        });
                        e.append(t3[i2], $cc508789fb87c5a2$var$lt());
                    }
                }
            } else if (8 === e.nodeType) {
                if (e.data === $cc508789fb87c5a2$var$m) r.push({
                    type: 2,
                    index: h
                });
                else {
                    var t4 = -1;
                    for(; -1 !== (t4 = e.data.indexOf($cc508789fb87c5a2$var$v, t4 + 1));)r.push({
                        type: 7,
                        index: h
                    }), t4 += $cc508789fb87c5a2$var$v.length - 1;
                }
            }
            h++;
        }
    }
    (0, $1wc17._)(B, null, [
        {
            key: "createElement",
            value: function createElement(t, i) {
                var s = $cc508789fb87c5a2$var$w.createElement("template");
                return s.innerHTML = t, s;
            }
        }
    ]);
    return B;
}();
function $cc508789fb87c5a2$var$z(t, i) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : t, e = arguments.length > 3 ? arguments[3] : void 0;
    var _s_o, _h__$AO;
    var _s;
    if (i === $cc508789fb87c5a2$export$9c068ae9cc5db4e8) return i;
    var h = void 0 !== e ? (_s_o = s.o) === null || _s_o === void 0 ? void 0 : _s_o[e] : s.l;
    var o = $cc508789fb87c5a2$var$st(i) ? void 0 : i._$litDirective$;
    var _o;
    return (h === null || h === void 0 ? void 0 : h.constructor) !== o && (h === null || h === void 0 ? void 0 : (_h__$AO = h._$AO) === null || _h__$AO === void 0 ? void 0 : _h__$AO.call(h, !1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? ((_o = (_s = s).o) !== null && _o !== void 0 ? _o : _s.o = [])[e] = h : s.l = h), void 0 !== h && (i = $cc508789fb87c5a2$var$z(t, h._$AS(t, i.values), h, e)), i;
}
var $cc508789fb87c5a2$var$F = /*#__PURE__*/ function() {
    "use strict";
    function F(t, i) {
        (0, $4GJKx._)(this, F);
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    (0, $1wc17._)(F, [
        {
            key: "parentNode",
            get: function get() {
                return this._$AM.parentNode;
            }
        },
        {
            key: "_$AU",
            get: function get() {
                return this._$AM._$AU;
            }
        },
        {
            key: "u",
            value: function u(t) {
                var _t_creationScope;
                var _this__$AD = this._$AD, _this__$AD_el = _this__$AD.el, i = _this__$AD_el.content, s = _this__$AD.parts, e = ((_t_creationScope = t === null || t === void 0 ? void 0 : t.creationScope) !== null && _t_creationScope !== void 0 ? _t_creationScope : $cc508789fb87c5a2$var$w).importNode(i, !0);
                $cc508789fb87c5a2$var$I.currentNode = e;
                var h = $cc508789fb87c5a2$var$I.nextNode(), o = 0, n = 0, r = s[0];
                for(; void 0 !== r;){
                    if (o === r.index) {
                        var i1 = void 0;
                        2 === r.type ? i1 = new $cc508789fb87c5a2$var$et(h, h.nextSibling, this, t) : 1 === r.type ? i1 = new r.ctor(h, r.name, r.strings, this, t) : 6 === r.type && (i1 = new $cc508789fb87c5a2$var$K(h, this, t)), this._$AV.push(i1), r = s[++n];
                    }
                    o !== (r === null || r === void 0 ? void 0 : r.index) && (h = $cc508789fb87c5a2$var$I.nextNode(), o++);
                }
                return $cc508789fb87c5a2$var$I.currentNode = $cc508789fb87c5a2$var$w, e;
            }
        },
        {
            key: "p",
            value: function p(t) {
                var i = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._$AV[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var s = _step.value;
                        void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ]);
    return F;
}();
var $cc508789fb87c5a2$var$et = /*#__PURE__*/ function() {
    "use strict";
    function et(t, i, s, e) {
        (0, $4GJKx._)(this, et);
        var _e_isConnected;
        this.type = 2, this._$AH = $cc508789fb87c5a2$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this.v = (_e_isConnected = e === null || e === void 0 ? void 0 : e.isConnected) !== null && _e_isConnected !== void 0 ? _e_isConnected : !0;
    }
    (0, $1wc17._)(et, [
        {
            key: "_$AU",
            get: function get() {
                var _this__$AM;
                var _this__$AM__$AU;
                return (_this__$AM__$AU = (_this__$AM = this._$AM) === null || _this__$AM === void 0 ? void 0 : _this__$AM._$AU) !== null && _this__$AM__$AU !== void 0 ? _this__$AM__$AU : this.v;
            }
        },
        {
            key: "parentNode",
            get: function get() {
                var t = this._$AA.parentNode;
                var i = this._$AM;
                return void 0 !== i && 11 === (t === null || t === void 0 ? void 0 : t.nodeType) && (t = i.parentNode), t;
            }
        },
        {
            key: "startNode",
            get: function get() {
                return this._$AA;
            }
        },
        {
            key: "endNode",
            get: function get() {
                return this._$AB;
            }
        },
        {
            key: "_$AI",
            value: function _$AI(t) {
                var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this;
                t = $cc508789fb87c5a2$var$z(this, t, i), $cc508789fb87c5a2$var$st(t) ? t === $cc508789fb87c5a2$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $cc508789fb87c5a2$export$45b790e32b2810ee && this._$AR(), this._$AH = $cc508789fb87c5a2$export$45b790e32b2810ee) : t !== this._$AH && t !== $cc508789fb87c5a2$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $cc508789fb87c5a2$var$$(t) ? this.k(t) : this._(t);
            }
        },
        {
            key: "O",
            value: function O(t) {
                return this._$AA.parentNode.insertBefore(t, this._$AB);
            }
        },
        {
            key: "T",
            value: function T(t) {
                this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
            }
        },
        {
            key: "_",
            value: function _(t) {
                this._$AH !== $cc508789fb87c5a2$export$45b790e32b2810ee && $cc508789fb87c5a2$var$st(this._$AH) ? this._$AA.nextSibling.data = t : this.T($cc508789fb87c5a2$var$w.createTextNode(t)), this._$AH = t;
            }
        },
        {
            key: "$",
            value: function $(t) {
                var _this__$AH;
                var i = t.values, s = t._$litType$, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $cc508789fb87c5a2$var$B.createElement($cc508789fb87c5a2$var$N(s.h, s.h[0]), this.options)), s);
                if (((_this__$AH = this._$AH) === null || _this__$AH === void 0 ? void 0 : _this__$AH._$AD) === e) this._$AH.p(i);
                else {
                    var _$t = new $cc508789fb87c5a2$var$F(e, this), s1 = _$t.u(this.options);
                    _$t.p(i), this.T(s1), this._$AH = _$t;
                }
            }
        },
        {
            key: "_$AC",
            value: function _$AC(t) {
                var i = $cc508789fb87c5a2$var$V.get(t.strings);
                return void 0 === i && $cc508789fb87c5a2$var$V.set(t.strings, i = new $cc508789fb87c5a2$var$B(t)), i;
            }
        },
        {
            key: "k",
            value: function k(t) {
                $cc508789fb87c5a2$var$g(this._$AH) || (this._$AH = [], this._$AR());
                var i = this._$AH;
                var s, e = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var h = _step.value;
                        e === i.length ? i.push(s = new et(this.O($cc508789fb87c5a2$var$lt()), this.O($cc508789fb87c5a2$var$lt()), this, this.options)) : s = i[e], s._$AI(h), e++;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
            }
        },
        {
            key: "_$AR",
            value: function _$AR() {
                var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._$AA.nextSibling, i = arguments.length > 1 ? arguments[1] : void 0;
                var _this__$AP, _this;
                for((_this__$AP = (_this = this)._$AP) === null || _this__$AP === void 0 ? void 0 : _this__$AP.call(_this, !1, !0, i); t && t !== this._$AB;){
                    var i1 = t.nextSibling;
                    t.remove(), t = i1;
                }
            }
        },
        {
            key: "setConnected",
            value: function setConnected(t) {
                var _this__$AP, _this;
                void 0 === this._$AM && (this.v = t, (_this__$AP = (_this = this)._$AP) === null || _this__$AP === void 0 ? void 0 : _this__$AP.call(_this, t));
            }
        }
    ]);
    return et;
}();
var $cc508789fb87c5a2$var$G = /*#__PURE__*/ function() {
    "use strict";
    function G(t, i, s, e, h) {
        (0, $4GJKx._)(this, G);
        this.type = 1, this._$AH = $cc508789fb87c5a2$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $cc508789fb87c5a2$export$45b790e32b2810ee;
    }
    (0, $1wc17._)(G, [
        {
            key: "tagName",
            get: function get() {
                return this.element.tagName;
            }
        },
        {
            key: "_$AU",
            get: function get() {
                return this._$AM._$AU;
            }
        },
        {
            key: "_$AI",
            value: function _$AI(t) {
                var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this, s = arguments.length > 2 ? arguments[2] : void 0, e = arguments.length > 3 ? arguments[3] : void 0;
                var h = this.strings;
                var o = !1;
                if (void 0 === h) t = $cc508789fb87c5a2$var$z(this, t, i, 0), o = !$cc508789fb87c5a2$var$st(t) || t !== this._$AH && t !== $cc508789fb87c5a2$export$9c068ae9cc5db4e8, o && (this._$AH = t);
                else {
                    var e1 = t;
                    var n, r;
                    for(t = h[0], n = 0; n < h.length - 1; n++)r = $cc508789fb87c5a2$var$z(this, e1[s + n], i, n), r === $cc508789fb87c5a2$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o || (o = !$cc508789fb87c5a2$var$st(r) || r !== this._$AH[n]), r === $cc508789fb87c5a2$export$45b790e32b2810ee ? t = $cc508789fb87c5a2$export$45b790e32b2810ee : t !== $cc508789fb87c5a2$export$45b790e32b2810ee && (t += (r !== null && r !== void 0 ? r : "") + h[n + 1]), this._$AH[n] = r;
                }
                o && !e && this.j(t);
            }
        },
        {
            key: "j",
            value: function j(t) {
                t === $cc508789fb87c5a2$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t !== null && t !== void 0 ? t : "");
            }
        }
    ]);
    return G;
}();
var $cc508789fb87c5a2$var$Y = /*#__PURE__*/ function(G) {
    "use strict";
    (0, $dcsZi._)(Y, G);
    var _super = (0, $ohfOJ._)(Y);
    function Y() {
        (0, $4GJKx._)(this, Y);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments))), _this.type = 3;
        return (0, $3U0IP._)(_this);
    }
    (0, $1wc17._)(Y, [
        {
            key: "j",
            value: function j(t) {
                this.element[this.name] = t === $cc508789fb87c5a2$export$45b790e32b2810ee ? void 0 : t;
            }
        }
    ]);
    return Y;
}($cc508789fb87c5a2$var$G);
var $cc508789fb87c5a2$var$Z = /*#__PURE__*/ function(G) {
    "use strict";
    (0, $dcsZi._)(Z, G);
    var _super = (0, $ohfOJ._)(Z);
    function Z() {
        (0, $4GJKx._)(this, Z);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments))), _this.type = 4;
        return (0, $3U0IP._)(_this);
    }
    (0, $1wc17._)(Z, [
        {
            key: "j",
            value: function j(t) {
                this.element.toggleAttribute(this.name, !!t && t !== $cc508789fb87c5a2$export$45b790e32b2810ee);
            }
        }
    ]);
    return Z;
}($cc508789fb87c5a2$var$G);
var $cc508789fb87c5a2$var$q = /*#__PURE__*/ function(G) {
    "use strict";
    (0, $dcsZi._)(q, G);
    var _super = (0, $ohfOJ._)(q);
    function q(t, i, s, e, h) {
        (0, $4GJKx._)(this, q);
        var _this;
        _this = _super.call(this, t, i, s, e, h), _this.type = 5;
        return (0, $3U0IP._)(_this);
    }
    (0, $1wc17._)(q, [
        {
            key: "_$AI",
            value: function _$AI(t) {
                var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this;
                var _z;
                if ((t = (_z = $cc508789fb87c5a2$var$z(this, t, i, 0)) !== null && _z !== void 0 ? _z : $cc508789fb87c5a2$export$45b790e32b2810ee) === $cc508789fb87c5a2$export$9c068ae9cc5db4e8) return;
                var s = this._$AH, e = t === $cc508789fb87c5a2$export$45b790e32b2810ee && s !== $cc508789fb87c5a2$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $cc508789fb87c5a2$export$45b790e32b2810ee && (s === $cc508789fb87c5a2$export$45b790e32b2810ee || e);
                e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
            }
        },
        {
            key: "handleEvent",
            value: function handleEvent(t) {
                var _this_options;
                var _this_options_host;
                "function" == typeof this._$AH ? this._$AH.call((_this_options_host = (_this_options = this.options) === null || _this_options === void 0 ? void 0 : _this_options.host) !== null && _this_options_host !== void 0 ? _this_options_host : this.element, t) : this._$AH.handleEvent(t);
            }
        }
    ]);
    return q;
}($cc508789fb87c5a2$var$G);
var $cc508789fb87c5a2$var$K = /*#__PURE__*/ function() {
    "use strict";
    function K(t, i, s) {
        (0, $4GJKx._)(this, K);
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    (0, $1wc17._)(K, [
        {
            key: "_$AU",
            get: function get() {
                return this._$AM._$AU;
            }
        },
        {
            key: "_$AI",
            value: function _$AI(t) {
                $cc508789fb87c5a2$var$z(this, t);
            }
        }
    ]);
    return K;
}();
var $cc508789fb87c5a2$export$8613d1ca9052b22e = {
    M: $cc508789fb87c5a2$var$f,
    P: $cc508789fb87c5a2$var$v,
    A: $cc508789fb87c5a2$var$m,
    C: 1,
    L: $cc508789fb87c5a2$var$U,
    R: $cc508789fb87c5a2$var$F,
    D: $cc508789fb87c5a2$var$$,
    V: $cc508789fb87c5a2$var$z,
    I: $cc508789fb87c5a2$var$et,
    H: $cc508789fb87c5a2$var$G,
    N: $cc508789fb87c5a2$var$Z,
    U: $cc508789fb87c5a2$var$q,
    B: $cc508789fb87c5a2$var$Y,
    F: $cc508789fb87c5a2$var$K
}, $cc508789fb87c5a2$var$Re = $cc508789fb87c5a2$var$n.litHtmlPolyfillSupport;
var $cc508789fb87c5a2$var$_litHtmlVersions;
$cc508789fb87c5a2$var$Re === null || $cc508789fb87c5a2$var$Re === void 0 ? void 0 : $cc508789fb87c5a2$var$Re($cc508789fb87c5a2$var$B, $cc508789fb87c5a2$var$et), (($cc508789fb87c5a2$var$_litHtmlVersions = ($cc508789fb87c5a2$var$_n = $cc508789fb87c5a2$var$n).litHtmlVersions) !== null && $cc508789fb87c5a2$var$_litHtmlVersions !== void 0 ? $cc508789fb87c5a2$var$_litHtmlVersions : $cc508789fb87c5a2$var$_n.litHtmlVersions = []).push("3.2.0");
var $cc508789fb87c5a2$export$b3890eb0ae9dca99 = function(t, i, s) {
    var _s_renderBefore;
    var e = (_s_renderBefore = s === null || s === void 0 ? void 0 : s.renderBefore) !== null && _s_renderBefore !== void 0 ? _s_renderBefore : i;
    var h = e._$litPart$;
    if (void 0 === h) {
        var _s_renderBefore1;
        var _$t = (_s_renderBefore1 = s === null || s === void 0 ? void 0 : s.renderBefore) !== null && _s_renderBefore1 !== void 0 ? _s_renderBefore1 : null;
        e._$litPart$ = h = new $cc508789fb87c5a2$var$et(i.insertBefore($cc508789fb87c5a2$var$lt(), _$t), _$t, void 0, s !== null && s !== void 0 ? s : {});
    }
    return h._$AI(t), h;
};

});

parcelRegister("2yD3e", function(module, exports) {
$parcel$export(module.exports, "css", function () { return (parcelRequire("2D5eP")).css; });
$parcel$export(module.exports, "ReactiveElement", function () { return (parcelRequire("ipLAV")).ReactiveElement; });
$parcel$export(module.exports, "html", function () { return (parcelRequire("hxyOZ")).html; });
$parcel$export(module.exports, "render", function () { return (parcelRequire("hxyOZ")).render; });
$parcel$export(module.exports, "noChange", function () { return (parcelRequire("hxyOZ")).noChange; });

$parcel$export(module.exports, "LitElement", function () { return $1dcd0c80777963a7$export$3f2f9f5909897157; });

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $04RAu = parcelRequire("04RAu");

var $b8Rim = parcelRequire("b8Rim");

var $dcsZi = parcelRequire("dcsZi");

var $3U0IP = parcelRequire("3U0IP");

var $ohfOJ = parcelRequire("ohfOJ");

var $ipLAV = parcelRequire("ipLAV");

var $hxyOZ = parcelRequire("hxyOZ");
var $1dcd0c80777963a7$var$_globalThis_litElementHydrateSupport, $1dcd0c80777963a7$var$_globalThis;
var $1dcd0c80777963a7$var$_globalThis1;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $1dcd0c80777963a7$export$3f2f9f5909897157 = /*#__PURE__*/ function(e) {
    "use strict";
    (0, $dcsZi._)(h, e);
    var _super = (0, $ohfOJ._)(h);
    function h() {
        (0, $4GJKx._)(this, h);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments))), _this.renderOptions = {
            host: (0, $d3H5E._)(_this)
        }, _this.o = void 0;
        return (0, $3U0IP._)(_this);
    }
    (0, $1wc17._)(h, [
        {
            key: "createRenderRoot",
            value: function createRenderRoot() {
                var _this_renderOptions;
                var t = (0, $04RAu._)((0, $b8Rim._)(h.prototype), "createRenderRoot", this).call(this);
                var _renderBefore;
                return (_renderBefore = (_this_renderOptions = this.renderOptions).renderBefore) !== null && _renderBefore !== void 0 ? _renderBefore : _this_renderOptions.renderBefore = t.firstChild, t;
            }
        },
        {
            key: "update",
            value: function update(t) {
                var _$e = this.render();
                this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), (0, $04RAu._)((0, $b8Rim._)(h.prototype), "update", this).call(this, t), this.o = (0, $hxyOZ.render)(_$e, this.renderRoot, this.renderOptions);
            }
        },
        {
            key: "connectedCallback",
            value: function connectedCallback() {
                var _this_o;
                (0, $04RAu._)((0, $b8Rim._)(h.prototype), "connectedCallback", this).call(this), (_this_o = this.o) === null || _this_o === void 0 ? void 0 : _this_o.setConnected(!0);
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                var _this_o;
                (0, $04RAu._)((0, $b8Rim._)(h.prototype), "disconnectedCallback", this).call(this), (_this_o = this.o) === null || _this_o === void 0 ? void 0 : _this_o.setConnected(!1);
            }
        },
        {
            key: "render",
            value: function render() {
                return 0, $hxyOZ.noChange;
            }
        }
    ]);
    return h;
}((0, $ipLAV.ReactiveElement));
$1dcd0c80777963a7$export$3f2f9f5909897157._$litElement$ = !0, $1dcd0c80777963a7$export$3f2f9f5909897157["finalized"] = !0, ($1dcd0c80777963a7$var$_globalThis_litElementHydrateSupport = ($1dcd0c80777963a7$var$_globalThis = globalThis).litElementHydrateSupport) === null || $1dcd0c80777963a7$var$_globalThis_litElementHydrateSupport === void 0 ? void 0 : $1dcd0c80777963a7$var$_globalThis_litElementHydrateSupport.call($1dcd0c80777963a7$var$_globalThis, {
    LitElement: $1dcd0c80777963a7$export$3f2f9f5909897157
});
var $1dcd0c80777963a7$var$f = globalThis.litElementPolyfillSupport;
$1dcd0c80777963a7$var$f === null || $1dcd0c80777963a7$var$f === void 0 ? void 0 : $1dcd0c80777963a7$var$f({
    LitElement: $1dcd0c80777963a7$export$3f2f9f5909897157
});
var $1dcd0c80777963a7$export$f5c524615a7708d6 = {
    _$AK: function(t, e, s) {
        t._$AK(e, s);
    },
    _$AL: function(t) {
        return t._$AL;
    }
};
var $1dcd0c80777963a7$var$_litElementVersions;
(($1dcd0c80777963a7$var$_litElementVersions = ($1dcd0c80777963a7$var$_globalThis1 = globalThis).litElementVersions) !== null && $1dcd0c80777963a7$var$_litElementVersions !== void 0 ? $1dcd0c80777963a7$var$_litElementVersions : $1dcd0c80777963a7$var$_globalThis1.litElementVersions = []).push("4.1.0");

});

parcelRegister("iqhuo", function(module, exports) {
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $0376116e3a9b33db$export$6acf61af03e62db = !1;

});


parcelRegister("kAqXG", function(module, exports) {
$parcel$export(module.exports, "property", function () { return (parcelRequire("04kNM")).property; });
$parcel$export(module.exports, "state", function () { return (parcelRequire("334Pv")).state; });
parcelRequire("9u8eC");
parcelRequire("04kNM");
parcelRequire("334Pv");
parcelRequire("3vl7N");
parcelRequire("dzZFK");
parcelRequire("9Nb9m");
parcelRequire("77d8a");
parcelRequire("3ZoUk");
parcelRequire("4uUkN");

});
parcelRegister("9u8eC", function(module, exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $6e7d4da32bceb0b5$export$da64fc29f17f9d0e = function(t) {
    return function(e, o) {
        void 0 !== o ? o.addInitializer(function() {
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };
};

});

parcelRegister("04kNM", function(module, exports) {

$parcel$export(module.exports, "property", function () { return $00d082ac7538553e$export$d541bacb2bda4494; });

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $ipLAV = parcelRequire("ipLAV");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $00d082ac7538553e$var$o = {
    attribute: !0,
    type: String,
    converter: (0, $ipLAV.defaultConverter),
    reflect: !1,
    hasChanged: (0, $ipLAV.notEqual)
}, $00d082ac7538553e$export$8d623b1670eb40f4 = function() {
    var _$t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $00d082ac7538553e$var$o, _$e = arguments.length > 1 ? arguments[1] : void 0, r = arguments.length > 2 ? arguments[2] : void 0;
    var n = r.kind, i = r.metadata;
    var s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), s.set(r.name, _$t), "accessor" === n) {
        var o1 = r.name;
        return {
            set: function(r) {
                var n = _$e.get.call(this);
                _$e.set.call(this, r), this.requestUpdate(o1, n, _$t);
            },
            init: function(e) {
                return void 0 !== e && this.P(o1, void 0, _$t), e;
            }
        };
    }
    if ("setter" === n) {
        var o2 = r.name;
        return function r(r) {
            var n = this[o2];
            _$e.call(this, r), this.requestUpdate(o2, n, _$t);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function $00d082ac7538553e$export$d541bacb2bda4494(t) {
    return function(e, o) {
        return "object" == typeof o ? $00d082ac7538553e$export$8d623b1670eb40f4(t, e, o) : function(t, e, o) {
            var r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, r ? (0, $cxjpp._)((0, $do9pw._)({}, t), {
                wrapped: !0
            }) : t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        }(t, e, o);
    };
}

});

parcelRegister("334Pv", function(module, exports) {

$parcel$export(module.exports, "state", function () { return $238565fc4b1b7bf6$export$ca000e230c0caa3e; });

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $04kNM = parcelRequire("04kNM");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $238565fc4b1b7bf6$export$ca000e230c0caa3e(r) {
    return (0, $04kNM.property)((0, $cxjpp._)((0, $do9pw._)({}, r), {
        state: !0,
        attribute: !1
    }));
}

});

parcelRegister("3vl7N", function(module, exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $28d4a748835d6709$export$b2b799818fbabcf3(t) {
    return function(n, o) {
        var c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}

});

parcelRegister("dzZFK", function(module, exports) {

var $iSBWz = parcelRequire("iSBWz");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $9e2e621cb1e0dfa6$export$2fa187e846a241c4(e, r) {
    return function(n, s, i) {
        var o = function(t) {
            var _t_renderRoot;
            var _t_renderRoot_querySelector;
            return (_t_renderRoot_querySelector = (_t_renderRoot = t.renderRoot) === null || _t_renderRoot === void 0 ? void 0 : _t_renderRoot.querySelector(e)) !== null && _t_renderRoot_querySelector !== void 0 ? _t_renderRoot_querySelector : null;
        };
        if (r) {
            var _ref = "object" == typeof s ? n : i !== null && i !== void 0 ? i : function() {
                var _$t = Symbol();
                return {
                    get: function() {
                        return this[_$t];
                    },
                    set: function(e) {
                        this[_$t] = e;
                    }
                };
            }(), e1 = _ref.get, _$r = _ref.set;
            return (0, $iSBWz.desc)(n, s, {
                get: function() {
                    var _$t = e1.call(this);
                    return void 0 === _$t && (_$t = o(this), (null !== _$t || this.hasUpdated) && _$r.call(this, _$t)), _$t;
                }
            });
        }
        return (0, $iSBWz.desc)(n, s, {
            get: function() {
                return o(this);
            }
        });
    };
}

});
parcelRegister("iSBWz", function(module, exports) {

$parcel$export(module.exports, "desc", function () { return $dbeab3f49eceeed9$export$51987bb50e1f6752; });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $dbeab3f49eceeed9$export$51987bb50e1f6752 = function(e, t, c) {
    return c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c;
};

});


parcelRegister("9Nb9m", function(module, exports) {

var $iSBWz = parcelRequire("iSBWz");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $721156d58bbbd1ef$var$e;
function $721156d58bbbd1ef$export$dcd0d083aa86c355(r) {
    return function(n, o) {
        return (0, $iSBWz.desc)(n, o, {
            get: function() {
                var _this_renderRoot;
                return ((_this_renderRoot = this.renderRoot) !== null && _this_renderRoot !== void 0 ? _this_renderRoot : $721156d58bbbd1ef$var$e !== null && $721156d58bbbd1ef$var$e !== void 0 ? $721156d58bbbd1ef$var$e : $721156d58bbbd1ef$var$e = document.createDocumentFragment()).querySelectorAll(r);
            }
        });
    };
}

});

parcelRegister("77d8a", function(module, exports) {

var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $iSBWz = parcelRequire("iSBWz");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $52e35f54522aa6ca$export$163dfc35cc43f240(r) {
    return function(n, e) {
        return (0, $iSBWz.desc)(n, e, {
            get: function() {
                return (0, $kSuI9._)(function() {
                    var _this_renderRoot, _this_renderRoot_querySelector;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.updateComplete
                                ];
                            case 1:
                                return [
                                    2,
                                    (_state.sent(), (_this_renderRoot_querySelector = (_this_renderRoot = this.renderRoot) === null || _this_renderRoot === void 0 ? void 0 : _this_renderRoot.querySelector(r)) !== null && _this_renderRoot_querySelector !== void 0 ? _this_renderRoot_querySelector : null)
                                ];
                        }
                    });
                }).apply(this);
            }
        });
    };
}

});

parcelRegister("3ZoUk", function(module, exports) {

var $iSBWz = parcelRequire("iSBWz");
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $2e7a63be32945b73$export$4682af2d9ee91415(o) {
    return function(e, n) {
        var _ref = o !== null && o !== void 0 ? o : {}, r = _ref.slot, s = _ref.selector, c = "slot" + (r ? "[name=".concat(r, "]") : ":not([name])");
        return (0, $iSBWz.desc)(e, n, {
            get: function() {
                var _this_renderRoot;
                var _t_assignedElements;
                var _$t = (_this_renderRoot = this.renderRoot) === null || _this_renderRoot === void 0 ? void 0 : _this_renderRoot.querySelector(c), _$e = (_t_assignedElements = _$t === null || _$t === void 0 ? void 0 : _$t.assignedElements(o)) !== null && _t_assignedElements !== void 0 ? _t_assignedElements : [];
                return void 0 === s ? _$e : _$e.filter(function(t) {
                    return t.matches(s);
                });
            }
        });
    };
}

});

parcelRegister("4uUkN", function(module, exports) {

var $iSBWz = parcelRequire("iSBWz");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $3465a99591408ddc$export$1bdbe53f9df1b8(n) {
    return function(o, r) {
        var _ref = n !== null && n !== void 0 ? n : {}, e = _ref.slot, s = "slot" + (e ? "[name=".concat(e, "]") : ":not([name])");
        return (0, $iSBWz.desc)(o, r, {
            get: function() {
                var _this_renderRoot;
                var _$t = (_this_renderRoot = this.renderRoot) === null || _this_renderRoot === void 0 ? void 0 : _this_renderRoot.querySelector(s);
                var _t_assignedNodes;
                return (_t_assignedNodes = _$t === null || _$t === void 0 ? void 0 : _$t.assignedNodes(n)) !== null && _t_assignedNodes !== void 0 ? _t_assignedNodes : [];
            }
        });
    };
}

});


parcelRegister("cTdql", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "REQUIRED_METHODS", function () { return $962508d1698929b7$export$cfec112b6d27bf; });
$parcel$export(module.exports, "OPTIONAL_METHODS", function () { return $962508d1698929b7$export$bc85197675500780; });
$parcel$export(module.exports, "REQUIRED_EVENTS", function () { return $962508d1698929b7$export$2c607e5ce12221af; });
$parcel$export(module.exports, "OPTIONAL_EVENTS", function () { return $962508d1698929b7$export$1d352f96d67d51e6; });
$parcel$export(module.exports, "default", function () { return $962508d1698929b7$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "EthereumProvider", function () { return $962508d1698929b7$export$cdfbbad9b2980226; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $3sHb8 = parcelRequire("3sHb8");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $eha6O = parcelRequire("eha6O");

var $cyxGb = parcelRequire("cyxGb");

var $8wnFv = parcelRequire("8wnFv");

var $lpHpe = parcelRequire("lpHpe");
var $962508d1698929b7$var$R = "wc", $962508d1698929b7$var$T = "ethereum_provider", $962508d1698929b7$var$$ = "".concat($962508d1698929b7$var$R, "@2:").concat($962508d1698929b7$var$T, ":"), $962508d1698929b7$var$j = "https://rpc.walletconnect.com/v1/", $962508d1698929b7$export$cfec112b6d27bf = [
    "eth_sendTransaction",
    "personal_sign"
], $962508d1698929b7$export$bc85197675500780 = [
    "eth_accounts",
    "eth_requestAccounts",
    "eth_sendRawTransaction",
    "eth_sign",
    "eth_signTransaction",
    "eth_signTypedData",
    "eth_signTypedData_v3",
    "eth_signTypedData_v4",
    "eth_sendTransaction",
    "personal_sign",
    "wallet_switchEthereumChain",
    "wallet_addEthereumChain",
    "wallet_getPermissions",
    "wallet_requestPermissions",
    "wallet_registerOnboarding",
    "wallet_watchAsset",
    "wallet_scanQRCode",
    "wallet_sendCalls",
    "wallet_getCapabilities",
    "wallet_getCallsStatus",
    "wallet_showCallsStatus"
], $962508d1698929b7$export$2c607e5ce12221af = [
    "chainChanged",
    "accountsChanged"
], $962508d1698929b7$export$1d352f96d67d51e6 = [
    "chainChanged",
    "accountsChanged",
    "message",
    "disconnect",
    "connect"
];
var $962508d1698929b7$var$q = Object.defineProperty, $962508d1698929b7$var$N = Object.defineProperties, $962508d1698929b7$var$D = Object.getOwnPropertyDescriptors, $962508d1698929b7$var$M = Object.getOwnPropertySymbols, $962508d1698929b7$var$U = Object.prototype.hasOwnProperty, $962508d1698929b7$var$Q = Object.prototype.propertyIsEnumerable, $962508d1698929b7$var$O = function(a, t, s) {
    return t in a ? $962508d1698929b7$var$q(a, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: s
    }) : a[t] = s;
}, $962508d1698929b7$var$p = function(a, t) {
    for(var s in t || (t = {}))$962508d1698929b7$var$U.call(t, s) && $962508d1698929b7$var$O(a, s, t[s]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($962508d1698929b7$var$M) try {
        for(var _iterator = $962508d1698929b7$var$M(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var s = _step.value;
            $962508d1698929b7$var$Q.call(t, s) && $962508d1698929b7$var$O(a, s, t[s]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
}, $962508d1698929b7$var$E = function(a, t) {
    return $962508d1698929b7$var$N(a, $962508d1698929b7$var$D(t));
};
function $962508d1698929b7$var$m(a) {
    return Number(a[0].split(":")[1]);
}
function $962508d1698929b7$var$v(a) {
    return "0x".concat(a.toString(16));
}
function $962508d1698929b7$var$L(a) {
    var t = a.chains, s = a.optionalChains, i = a.methods, e = a.optionalMethods, n = a.events, o = a.optionalEvents, r = a.rpcMap;
    if (!(0, $8wnFv.isValidArray)(t)) throw new Error("Invalid chains");
    var c = {
        chains: t,
        methods: i || $962508d1698929b7$export$cfec112b6d27bf,
        events: n || $962508d1698929b7$export$2c607e5ce12221af,
        rpcMap: $962508d1698929b7$var$p({}, t.length ? (0, $3sHb8._)({}, $962508d1698929b7$var$m(t), r[$962508d1698929b7$var$m(t)]) : {})
    }, h = n === null || n === void 0 ? void 0 : n.filter(function(l) {
        return !$962508d1698929b7$export$2c607e5ce12221af.includes(l);
    }), d = i === null || i === void 0 ? void 0 : i.filter(function(l) {
        return !$962508d1698929b7$export$cfec112b6d27bf.includes(l);
    });
    if (!s && !o && !e && !(h != null && h.length) && !(d != null && d.length)) return {
        required: t.length ? c : void 0
    };
    var w = (h === null || h === void 0 ? void 0 : h.length) && (d === null || d === void 0 ? void 0 : d.length) || !s, I = {
        chains: (0, $c6Xmf._)(new Set(w ? c.chains.concat(s || []) : s)),
        methods: (0, $c6Xmf._)(new Set(c.methods.concat(e != null && e.length ? e : $962508d1698929b7$export$bc85197675500780))),
        events: (0, $c6Xmf._)(new Set(c.events.concat(o != null && o.length ? o : $962508d1698929b7$export$1d352f96d67d51e6))),
        rpcMap: r
    };
    return {
        required: t.length ? c : void 0,
        optional: s.length ? I : void 0
    };
}

var $962508d1698929b7$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function C() {
        var _this = this;
        (0, $4GJKx._)(this, C);
        this.events = new (0, $cyxGb.EventEmitter), this.namespace = "eip155", this.accounts = [], this.chainId = 1, this.STORAGE_KEY = $962508d1698929b7$var$$, this.on = function(t, s) {
            return _this.events.on(t, s), _this;
        }, this.once = function(t, s) {
            return _this.events.once(t, s), _this;
        }, this.removeListener = function(t, s) {
            return _this.events.removeListener(t, s), _this;
        }, this.off = function(t, s) {
            return _this.events.off(t, s), _this;
        }, this.parseAccount = function(t) {
            return _this.isCompatibleChainId(t) ? _this.parseAccountId(t).address : t;
        }, this.signer = {}, this.rpc = {};
    }
    (0, $1wc17._)(C, [
        {
            key: "request",
            value: function request(t, s) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.signer.request(t, _this.formatChainId(_this.chainId), s)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendAsync",
            value: function sendAsync(t, s, i) {
                this.signer.sendAsync(t, s, this.formatChainId(this.chainId), i);
            }
        },
        {
            key: "connected",
            get: function get() {
                return this.signer.client ? this.signer.client.core.relayer.connected : !1;
            }
        },
        {
            key: "connecting",
            get: function get() {
                return this.signer.client ? this.signer.client.core.relayer.connecting : !1;
            }
        },
        {
            key: "enable",
            value: function enable() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _tmp;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = _this.session;
                                if (_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.connect()
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                _tmp;
                                return [
                                    4,
                                    _this.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "connect",
            value: function connect(t) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _L, s, i, _$e, n, e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.signer.client) throw new Error("Provider not initialized. Call init() first");
                                _this.loadConnectOpts(t);
                                _L = $962508d1698929b7$var$L(_this.rpc), s = _L.required, i = _L.optional;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    4,
                                    5
                                ]);
                                return [
                                    4,
                                    new Promise(function() {
                                        var _ref = (0, $kSuI9._)(function(o, r) {
                                            var c;
                                            return (0, $eha6O.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        _this.rpc.showQrModal && ((c = _this.modal) == null || c.subscribeModal(function(h) {
                                                            !h.open && !_this.signer.session && (_this.signer.abortPairingAttempt(), r(new Error("Connection request reset. Please try again.")));
                                                        }));
                                                        return [
                                                            4,
                                                            _this.signer.connect($962508d1698929b7$var$E($962508d1698929b7$var$p({
                                                                namespaces: $962508d1698929b7$var$p({}, s && (0, $3sHb8._)({}, _this.namespace, s))
                                                            }, i && {
                                                                optionalNamespaces: (0, $3sHb8._)({}, _this.namespace, i)
                                                            }), {
                                                                pairingTopic: t === null || t === void 0 ? void 0 : t.pairingTopic
                                                            })).then(function(h) {
                                                                o(h);
                                                            }).catch(function(h) {
                                                                r(new Error(h.message));
                                                            })
                                                        ];
                                                    case 1:
                                                        _state.sent();
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(o, r) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }())
                                ];
                            case 2:
                                _$e = _state.sent();
                                if (!_$e) return [
                                    2
                                ];
                                n = (0, $8wnFv.getAccountsFromNamespaces)(_$e.namespaces, [
                                    _this.namespace
                                ]);
                                _this.setChainIds(_this.rpc.chains.length ? _this.rpc.chains : n), _this.setAccounts(n), _this.events.emit("connect", {
                                    chainId: $962508d1698929b7$var$v(_this.chainId)
                                });
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                e = _state.sent();
                                throw _this.signer.logger.error(e), e;
                            case 4:
                                _this.modal && _this.modal.closeModal();
                                return [
                                    7
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "authenticate",
            value: function authenticate(t) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _$s, i, e, s;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.signer.client) throw new Error("Provider not initialized. Call init() first");
                                _this.loadConnectOpts({
                                    chains: t === null || t === void 0 ? void 0 : t.chains
                                });
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    4,
                                    5
                                ]);
                                return [
                                    4,
                                    new Promise(function() {
                                        var _ref = (0, $kSuI9._)(function(e, n) {
                                            var o;
                                            return (0, $eha6O.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        _this.rpc.showQrModal && ((o = _this.modal) == null || o.subscribeModal(function(r) {
                                                            !r.open && !_this.signer.session && (_this.signer.abortPairingAttempt(), n(new Error("Connection request reset. Please try again.")));
                                                        }));
                                                        return [
                                                            4,
                                                            _this.signer.authenticate($962508d1698929b7$var$E($962508d1698929b7$var$p({}, t), {
                                                                chains: _this.rpc.chains
                                                            })).then(function(r) {
                                                                e(r);
                                                            }).catch(function(r) {
                                                                n(new Error(r.message));
                                                            })
                                                        ];
                                                    case 1:
                                                        _state.sent();
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(e, n) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }())
                                ];
                            case 2:
                                _$s = _state.sent(), i = _$s.session;
                                if (i) {
                                    e = (0, $8wnFv.getAccountsFromNamespaces)(i.namespaces, [
                                        _this.namespace
                                    ]);
                                    _this.setChainIds(_this.rpc.chains.length ? _this.rpc.chains : e), _this.setAccounts(e), _this.events.emit("connect", {
                                        chainId: $962508d1698929b7$var$v(_this.chainId)
                                    });
                                }
                                return [
                                    2,
                                    _$s
                                ];
                            case 3:
                                s = _state.sent();
                                throw _this.signer.logger.error(s), s;
                            case 4:
                                _this.modal && _this.modal.closeModal();
                                return [
                                    7
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _tmp;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = _this.session;
                                if (!_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.signer.disconnect()
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                _tmp, _this.reset();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "isWalletConnect",
            get: function get() {
                return !0;
            }
        },
        {
            key: "session",
            get: function get() {
                return this.signer.session;
            }
        },
        {
            key: "registerEventListeners",
            value: function registerEventListeners() {
                var _this = this;
                this.signer.on("session_event", function(t) {
                    var s = t.params, i = s.event;
                    i.name === "accountsChanged" ? (_this.accounts = _this.parseAccounts(i.data), _this.events.emit("accountsChanged", _this.accounts)) : i.name === "chainChanged" ? _this.setChainId(_this.formatChainId(i.data)) : _this.events.emit(i.name, i.data), _this.events.emit("session_event", t);
                }), this.signer.on("chainChanged", function(t) {
                    var s = parseInt(t);
                    _this.chainId = s, _this.events.emit("chainChanged", $962508d1698929b7$var$v(_this.chainId)), _this.persist();
                }), this.signer.on("session_update", function(t) {
                    _this.events.emit("session_update", t);
                }), this.signer.on("session_delete", function(t) {
                    _this.reset(), _this.events.emit("session_delete", t), _this.events.emit("disconnect", $962508d1698929b7$var$E($962508d1698929b7$var$p({}, (0, $8wnFv.getSdkError)("USER_DISCONNECTED")), {
                        data: t.topic,
                        name: "USER_DISCONNECTED"
                    }));
                }), this.signer.on("display_uri", function(t) {
                    var s, i;
                    _this.rpc.showQrModal && ((s = _this.modal) == null || s.closeModal(), (i = _this.modal) == null || i.openModal({
                        uri: t
                    })), _this.events.emit("display_uri", t);
                });
            }
        },
        {
            key: "switchEthereumChain",
            value: function switchEthereumChain(t) {
                this.request({
                    method: "wallet_switchEthereumChain",
                    params: [
                        {
                            chainId: t.toString(16)
                        }
                    ]
                });
            }
        },
        {
            key: "isCompatibleChainId",
            value: function isCompatibleChainId(t) {
                return typeof t == "string" ? t.startsWith("".concat(this.namespace, ":")) : !1;
            }
        },
        {
            key: "formatChainId",
            value: function formatChainId(t) {
                return "".concat(this.namespace, ":").concat(t);
            }
        },
        {
            key: "parseChainId",
            value: function parseChainId(t) {
                return Number(t.split(":")[1]);
            }
        },
        {
            key: "setChainIds",
            value: function setChainIds(t) {
                var _this = this;
                var s = t.filter(function(i) {
                    return _this.isCompatibleChainId(i);
                }).map(function(i) {
                    return _this.parseChainId(i);
                });
                s.length && (this.chainId = s[0], this.events.emit("chainChanged", $962508d1698929b7$var$v(this.chainId)), this.persist());
            }
        },
        {
            key: "setChainId",
            value: function setChainId(t) {
                if (this.isCompatibleChainId(t)) {
                    var s = this.parseChainId(t);
                    this.chainId = s, this.switchEthereumChain(s);
                }
            }
        },
        {
            key: "parseAccountId",
            value: function parseAccountId(t) {
                var _t_split = (0, $cv9Rk._)(t.split(":"), 3), s = _t_split[0], i = _t_split[1], e = _t_split[2];
                return {
                    chainId: "".concat(s, ":").concat(i),
                    address: e
                };
            }
        },
        {
            key: "setAccounts",
            value: function setAccounts(t) {
                var _this = this;
                this.accounts = t.filter(function(s) {
                    return _this.parseChainId(_this.parseAccountId(s).chainId) === _this.chainId;
                }).map(function(s) {
                    return _this.parseAccountId(s).address;
                }), this.events.emit("accountsChanged", this.accounts);
            }
        },
        {
            key: "getRpcConfig",
            value: function getRpcConfig(t) {
                var _this = this;
                var s, i;
                var e = (s = t === null || t === void 0 ? void 0 : t.chains) != null ? s : [], n = (i = t === null || t === void 0 ? void 0 : t.optionalChains) != null ? i : [], o = e.concat(n);
                if (!o.length) throw new Error("No chains specified in either `chains` or `optionalChains`");
                var r = e.length ? (t === null || t === void 0 ? void 0 : t.methods) || $962508d1698929b7$export$cfec112b6d27bf : [], c = e.length ? (t === null || t === void 0 ? void 0 : t.events) || $962508d1698929b7$export$2c607e5ce12221af : [], h = (t === null || t === void 0 ? void 0 : t.optionalMethods) || [], d = (t === null || t === void 0 ? void 0 : t.optionalEvents) || [], w = (t === null || t === void 0 ? void 0 : t.rpcMap) || this.buildRpcMap(o, t.projectId), I = (t === null || t === void 0 ? void 0 : t.qrModalOptions) || void 0;
                return {
                    chains: e === null || e === void 0 ? void 0 : e.map(function(l) {
                        return _this.formatChainId(l);
                    }),
                    optionalChains: n.map(function(l) {
                        return _this.formatChainId(l);
                    }),
                    methods: r,
                    events: c,
                    optionalMethods: h,
                    optionalEvents: d,
                    rpcMap: w,
                    showQrModal: !!(t != null && t.showQrModal),
                    qrModalOptions: I,
                    projectId: t.projectId,
                    metadata: t.metadata
                };
            }
        },
        {
            key: "buildRpcMap",
            value: function buildRpcMap(t, s) {
                var _this = this;
                var i = {};
                return t.forEach(function(e) {
                    i[e] = _this.getRpcUrl(e, s);
                }), i;
            }
        },
        {
            key: "initialize",
            value: function initialize(t) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var s, _ref, _$i, e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.rpc = _this.getRpcConfig(t), _this.chainId = _this.rpc.chains.length ? $962508d1698929b7$var$m(_this.rpc.chains) : $962508d1698929b7$var$m(_this.rpc.optionalChains);
                                return [
                                    4,
                                    (0, $lpHpe.UniversalProvider).init({
                                        projectId: _this.rpc.projectId,
                                        metadata: _this.rpc.metadata,
                                        disableProviderPing: t.disableProviderPing,
                                        relayUrl: t.relayUrl,
                                        storageOptions: t.storageOptions,
                                        customStoragePrefix: t.customStoragePrefix,
                                        telemetryEnabled: t.telemetryEnabled
                                    })
                                ];
                            case 1:
                                _this.signer = _state.sent(), _this.registerEventListeners();
                                return [
                                    4,
                                    _this.loadPersistedSession()
                                ];
                            case 2:
                                if (!(_state.sent(), _this.rpc.showQrModal)) return [
                                    3,
                                    7
                                ];
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    (parcelRequire("6fkXj"))
                                ];
                            case 4:
                                _ref = _state.sent(), _$i = _ref.WalletConnectModal;
                                s = _$i;
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                e = _state.sent();
                                throw new Error("To use QR modal, please install @walletconnect/modal package");
                            case 6:
                                if (s) try {
                                    _this.modal = new s($962508d1698929b7$var$p({
                                        projectId: _this.rpc.projectId
                                    }, _this.rpc.qrModalOptions));
                                } catch (i) {
                                    throw _this.signer.logger.error(i), new Error("Could not generate WalletConnectModal Instance");
                                }
                                _state.label = 7;
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "loadConnectOpts",
            value: function loadConnectOpts(t) {
                var _this = this;
                if (!t) return;
                var s = t.chains, i = t.optionalChains, e = t.rpcMap;
                s && (0, $8wnFv.isValidArray)(s) && (this.rpc.chains = s.map(function(n) {
                    return _this.formatChainId(n);
                }), s.forEach(function(n) {
                    _this.rpc.rpcMap[n] = (e === null || e === void 0 ? void 0 : e[n]) || _this.getRpcUrl(n);
                })), i && (0, $8wnFv.isValidArray)(i) && (this.rpc.optionalChains = [], this.rpc.optionalChains = i === null || i === void 0 ? void 0 : i.map(function(n) {
                    return _this.formatChainId(n);
                }), i.forEach(function(n) {
                    _this.rpc.rpcMap[n] = (e === null || e === void 0 ? void 0 : e[n]) || _this.getRpcUrl(n);
                }));
            }
        },
        {
            key: "getRpcUrl",
            value: function getRpcUrl(t, s) {
                var i;
                return ((i = this.rpc.rpcMap) == null ? void 0 : i[t]) || "".concat($962508d1698929b7$var$j, "?chainId=eip155:").concat(t, "&projectId=").concat(s || this.rpc.projectId);
            }
        },
        {
            key: "loadPersistedSession",
            value: function loadPersistedSession() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _$t, s, t;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.session) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    _this.signer.client.core.storage.getItem("".concat(_this.STORAGE_KEY, "/chainId"))
                                ];
                            case 2:
                                _$t = _state.sent(), s = _this.session.namespaces["".concat(_this.namespace, ":").concat(_$t)] ? _this.session.namespaces["".concat(_this.namespace, ":").concat(_$t)] : _this.session.namespaces[_this.namespace];
                                _this.setChainIds(_$t ? [
                                    _this.formatChainId(_$t)
                                ] : s === null || s === void 0 ? void 0 : s.accounts), _this.setAccounts(s === null || s === void 0 ? void 0 : s.accounts);
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                t = _state.sent();
                                _this.signer.logger.error("Failed to load persisted session, clearing state..."), _this.signer.logger.error(t);
                                return [
                                    4,
                                    _this.disconnect().catch(function(s) {
                                        return _this.signer.logger.warn(s);
                                    })
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.chainId = 1, this.accounts = [];
            }
        },
        {
            key: "persist",
            value: function persist() {
                this.session && this.signer.client.core.storage.setItem("".concat(this.STORAGE_KEY, "/chainId"), this.chainId);
            }
        },
        {
            key: "parseAccounts",
            value: function parseAccounts(t) {
                var _this = this;
                return typeof t == "string" || t instanceof String ? [
                    this.parseAccount(t)
                ] : t.map(function(s) {
                    return _this.parseAccount(s);
                });
            }
        }
    ], [
        {
            key: "init",
            value: function init(t) {
                return (0, $kSuI9._)(function() {
                    var s;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                s = new C;
                                return [
                                    4,
                                    s.initialize(t)
                                ];
                            case 1:
                                return [
                                    2,
                                    (_state.sent(), s)
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return C;
}();
var $962508d1698929b7$export$cdfbbad9b2980226 = $962508d1698929b7$export$2e2bcd8739ae039;

});
parcelRegister("cyxGb", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $l0HdX = parcelRequire("l0HdX");
"use strict";
var $9242c90cd2aa67c8$var$R = typeof Reflect === "object" ? Reflect : null;
var $9242c90cd2aa67c8$var$ReflectApply = $9242c90cd2aa67c8$var$R && typeof $9242c90cd2aa67c8$var$R.apply === "function" ? $9242c90cd2aa67c8$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $9242c90cd2aa67c8$var$ReflectOwnKeys;
if ($9242c90cd2aa67c8$var$R && typeof $9242c90cd2aa67c8$var$R.ownKeys === "function") $9242c90cd2aa67c8$var$ReflectOwnKeys = $9242c90cd2aa67c8$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $9242c90cd2aa67c8$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $9242c90cd2aa67c8$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $9242c90cd2aa67c8$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $9242c90cd2aa67c8$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $9242c90cd2aa67c8$var$EventEmitter() {
    $9242c90cd2aa67c8$var$EventEmitter.init.call(this);
}
module.exports = $9242c90cd2aa67c8$var$EventEmitter;
module.exports.once = $9242c90cd2aa67c8$var$once;
// Backwards-compat with node 0.10.x
$9242c90cd2aa67c8$var$EventEmitter.EventEmitter = $9242c90cd2aa67c8$var$EventEmitter;
$9242c90cd2aa67c8$var$EventEmitter.prototype._events = undefined;
$9242c90cd2aa67c8$var$EventEmitter.prototype._eventsCount = 0;
$9242c90cd2aa67c8$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $9242c90cd2aa67c8$var$defaultMaxListeners = 10;
function $9242c90cd2aa67c8$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + (typeof listener === "undefined" ? "undefined" : (0, $l0HdX._)(listener)));
}
Object.defineProperty($9242c90cd2aa67c8$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function get() {
        return $9242c90cd2aa67c8$var$defaultMaxListeners;
    },
    set: function set(arg) {
        if (typeof arg !== "number" || arg < 0 || $9242c90cd2aa67c8$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $9242c90cd2aa67c8$var$defaultMaxListeners = arg;
    }
});
$9242c90cd2aa67c8$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$9242c90cd2aa67c8$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $9242c90cd2aa67c8$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $9242c90cd2aa67c8$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $9242c90cd2aa67c8$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$9242c90cd2aa67c8$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $9242c90cd2aa67c8$var$_getMaxListeners(this);
};
$9242c90cd2aa67c8$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $9242c90cd2aa67c8$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $9242c90cd2aa67c8$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$9242c90cd2aa67c8$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $9242c90cd2aa67c8$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $9242c90cd2aa67c8$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $9242c90cd2aa67c8$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $9242c90cd2aa67c8$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$9242c90cd2aa67c8$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $9242c90cd2aa67c8$var$_addListener(this, type, listener, false);
};
$9242c90cd2aa67c8$var$EventEmitter.prototype.on = $9242c90cd2aa67c8$var$EventEmitter.prototype.addListener;
$9242c90cd2aa67c8$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $9242c90cd2aa67c8$var$_addListener(this, type, listener, true);
};
function $9242c90cd2aa67c8$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $9242c90cd2aa67c8$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $9242c90cd2aa67c8$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$9242c90cd2aa67c8$var$EventEmitter.prototype.once = function once(type, listener) {
    $9242c90cd2aa67c8$var$checkListener(listener);
    this.on(type, $9242c90cd2aa67c8$var$_onceWrap(this, type, listener));
    return this;
};
$9242c90cd2aa67c8$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $9242c90cd2aa67c8$var$checkListener(listener);
    this.prependListener(type, $9242c90cd2aa67c8$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$9242c90cd2aa67c8$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $9242c90cd2aa67c8$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $9242c90cd2aa67c8$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$9242c90cd2aa67c8$var$EventEmitter.prototype.off = $9242c90cd2aa67c8$var$EventEmitter.prototype.removeListener;
$9242c90cd2aa67c8$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $9242c90cd2aa67c8$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $9242c90cd2aa67c8$var$unwrapListeners(evlistener) : $9242c90cd2aa67c8$var$arrayClone(evlistener, evlistener.length);
}
$9242c90cd2aa67c8$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $9242c90cd2aa67c8$var$_listeners(this, type, true);
};
$9242c90cd2aa67c8$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $9242c90cd2aa67c8$var$_listeners(this, type, false);
};
$9242c90cd2aa67c8$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $9242c90cd2aa67c8$var$listenerCount.call(emitter, type);
};
$9242c90cd2aa67c8$var$EventEmitter.prototype.listenerCount = $9242c90cd2aa67c8$var$listenerCount;
function $9242c90cd2aa67c8$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$9242c90cd2aa67c8$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $9242c90cd2aa67c8$var$ReflectOwnKeys(this._events) : [];
};
function $9242c90cd2aa67c8$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $9242c90cd2aa67c8$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $9242c90cd2aa67c8$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $9242c90cd2aa67c8$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $9242c90cd2aa67c8$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $9242c90cd2aa67c8$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $9242c90cd2aa67c8$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $9242c90cd2aa67c8$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $9242c90cd2aa67c8$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + (typeof emitter === "undefined" ? "undefined" : (0, $l0HdX._)(emitter)));
}

});

parcelRegister("8wnFv", function(module, exports) {

$parcel$export(module.exports, "parseChainId", function () { return $6343abee919005ee$export$4764229d78de4437; });
$parcel$export(module.exports, "getAccountsFromNamespaces", function () { return $6343abee919005ee$export$23329703ad972840; });
$parcel$export(module.exports, "isNode", function () { return $6343abee919005ee$export$8ee0fc9ee280b4ee; });
$parcel$export(module.exports, "isBrowser", function () { return $6343abee919005ee$export$4e09c449d6c407f7; });
$parcel$export(module.exports, "getBundleId", function () { return $6343abee919005ee$export$40a40f90174d197c; });
$parcel$export(module.exports, "getAppMetadata", function () { return $6343abee919005ee$export$ba31e015127122bb; });
$parcel$export(module.exports, "formatRelayRpcUrl", function () { return $6343abee919005ee$export$d875b3963ef774f5; });
$parcel$export(module.exports, "mapToObj", function () { return $6343abee919005ee$export$c4b8dfeb6e237eb9; });
$parcel$export(module.exports, "objToMap", function () { return $6343abee919005ee$export$ac31b37c726bc3ba; });
$parcel$export(module.exports, "createDelayedPromise", function () { return $6343abee919005ee$export$cbf9e3cc9ffc85cb; });
$parcel$export(module.exports, "createExpiringPromise", function () { return $6343abee919005ee$export$3da2293b007ed708; });
$parcel$export(module.exports, "formatTopicTarget", function () { return $6343abee919005ee$export$43ab92477f8713b9; });
$parcel$export(module.exports, "formatIdTarget", function () { return $6343abee919005ee$export$bd13103c2e5cc0c3; });
$parcel$export(module.exports, "parseExpirerTarget", function () { return $6343abee919005ee$export$93adeb0f16e8e51d; });
$parcel$export(module.exports, "calcExpiry", function () { return $6343abee919005ee$export$b136d03015bfc12; });
$parcel$export(module.exports, "isExpired", function () { return $6343abee919005ee$export$57947cfd429801a2; });
$parcel$export(module.exports, "engineEvent", function () { return $6343abee919005ee$export$e3eb27ce66c0f6d9; });
$parcel$export(module.exports, "mergeArrays", function () { return $6343abee919005ee$export$9826fe7ad3921016; });
$parcel$export(module.exports, "handleDeeplinkRedirect", function () { return $6343abee919005ee$export$694a208c8abca99a; });
$parcel$export(module.exports, "getDeepLink", function () { return $6343abee919005ee$export$e55bfdac47149a32; });
$parcel$export(module.exports, "uuidv4", function () { return $6343abee919005ee$export$abe4376e1bf796d6; });
$parcel$export(module.exports, "getNamespacedDidChainId", function () { return $6343abee919005ee$export$a8b149927aef7051; });
$parcel$export(module.exports, "getDidAddress", function () { return $6343abee919005ee$export$bf43cfbb4bd95de9; });
$parcel$export(module.exports, "validateSignedCacao", function () { return $6343abee919005ee$export$b7d566fce8e2b970; });
$parcel$export(module.exports, "formatMessage", function () { return $6343abee919005ee$export$25868d1e8e76735f; });
$parcel$export(module.exports, "getRecapFromResources", function () { return $6343abee919005ee$export$3bb18ae0fb9a9fa9; });
$parcel$export(module.exports, "createEncodedRecap", function () { return $6343abee919005ee$export$2bc35d2a08a09ad5; });
$parcel$export(module.exports, "mergeEncodedRecaps", function () { return $6343abee919005ee$export$c7a40c552af428b5; });
$parcel$export(module.exports, "getMethodsFromRecap", function () { return $6343abee919005ee$export$d6c6a43d36418efe; });
$parcel$export(module.exports, "getChainsFromRecap", function () { return $6343abee919005ee$export$372f88051a611988; });
$parcel$export(module.exports, "BASE16", function () { return $6343abee919005ee$export$49eb910ab2518105; });
$parcel$export(module.exports, "TYPE_1", function () { return $6343abee919005ee$export$406e97c329f0f3d4; });
$parcel$export(module.exports, "generateKeyPair", function () { return $6343abee919005ee$export$a949d36eab55b41f; });
$parcel$export(module.exports, "generateRandomBytes32", function () { return $6343abee919005ee$export$d15a28e4f1821243; });
$parcel$export(module.exports, "deriveSymKey", function () { return $6343abee919005ee$export$f8378f68e053f5c6; });
$parcel$export(module.exports, "hashKey", function () { return $6343abee919005ee$export$1e87d19d4aab5805; });
$parcel$export(module.exports, "hashMessage", function () { return $6343abee919005ee$export$d4c241cec96564c1; });
$parcel$export(module.exports, "decodeTypeByte", function () { return $6343abee919005ee$export$7547a514ee29b9d4; });
$parcel$export(module.exports, "encrypt", function () { return $6343abee919005ee$export$5b0f6292f11d1d18; });
$parcel$export(module.exports, "decrypt", function () { return $6343abee919005ee$export$e85a0c9a1067c5d3; });
$parcel$export(module.exports, "deserialize", function () { return $6343abee919005ee$export$efcd34ab6248d3cd; });
$parcel$export(module.exports, "validateDecoding", function () { return $6343abee919005ee$export$177f3e316562333d; });
$parcel$export(module.exports, "validateEncoding", function () { return $6343abee919005ee$export$7949f60f2444aef2; });
$parcel$export(module.exports, "isTypeOneEnvelope", function () { return $6343abee919005ee$export$8c165704db2d5c15; });
$parcel$export(module.exports, "verifyP256Jwt", function () { return $6343abee919005ee$export$f65520390041ee33; });
$parcel$export(module.exports, "getRelayProtocolName", function () { return $6343abee919005ee$export$cf77af25151525db; });
$parcel$export(module.exports, "getRelayProtocolApi", function () { return $6343abee919005ee$export$604e3deb95e1b734; });
$parcel$export(module.exports, "parseUri", function () { return $6343abee919005ee$export$59f58847421cfb28; });
$parcel$export(module.exports, "formatUri", function () { return $6343abee919005ee$export$b2786ede34fb2350; });
$parcel$export(module.exports, "isValidNamespaces", function () { return $6343abee919005ee$export$93f7b81dc815a714; });
$parcel$export(module.exports, "isConformingNamespaces", function () { return $6343abee919005ee$export$ba5b0a4b585cd1b4; });
$parcel$export(module.exports, "isCaipNamespace", function () { return $6343abee919005ee$export$e03e993df4723bde; });
$parcel$export(module.exports, "parseNamespaceKey", function () { return $6343abee919005ee$export$dd404c96fbbb1ff8; });
$parcel$export(module.exports, "isValidObject", function () { return $6343abee919005ee$export$16a0268bc22b47b0; });
$parcel$export(module.exports, "buildNamespacesFromAuth", function () { return $6343abee919005ee$export$b5744b1c39447540; });
$parcel$export(module.exports, "getInternalError", function () { return $6343abee919005ee$export$500d4c4a8fafe35; });
$parcel$export(module.exports, "getSdkError", function () { return $6343abee919005ee$export$8203ef1531c8b5b5; });
$parcel$export(module.exports, "isValidArray", function () { return $6343abee919005ee$export$41dd3d480aac4a71; });
$parcel$export(module.exports, "isUndefined", function () { return $6343abee919005ee$export$fce6876652108ab; });
$parcel$export(module.exports, "isValidString", function () { return $6343abee919005ee$export$ee898ca48ab56c74; });
$parcel$export(module.exports, "isSessionCompatible", function () { return $6343abee919005ee$export$6fc4971bf8f326a; });
$parcel$export(module.exports, "isValidUrl", function () { return $6343abee919005ee$export$bef94a5618bf18bf; });
$parcel$export(module.exports, "isProposalStruct", function () { return $6343abee919005ee$export$f657f7976bb2769d; });
$parcel$export(module.exports, "isSessionStruct", function () { return $6343abee919005ee$export$c96d5113768aaf5e; });
$parcel$export(module.exports, "isValidController", function () { return $6343abee919005ee$export$5e1c5c89613c213f; });
$parcel$export(module.exports, "isValidRequiredNamespaces", function () { return $6343abee919005ee$export$9e2b2cae22c6a8b3; });
$parcel$export(module.exports, "isValidRelay", function () { return $6343abee919005ee$export$1b3fc298be8c9a7b; });
$parcel$export(module.exports, "isValidRelays", function () { return $6343abee919005ee$export$6294c30b976bd21e; });
$parcel$export(module.exports, "isValidId", function () { return $6343abee919005ee$export$53551be28ad5e34d; });
$parcel$export(module.exports, "isValidParams", function () { return $6343abee919005ee$export$b3f5fcca1d210454; });
$parcel$export(module.exports, "isValidErrorReason", function () { return $6343abee919005ee$export$766fe78377d96f2a; });
$parcel$export(module.exports, "isValidRequest", function () { return $6343abee919005ee$export$1a2af3c017fb6d42; });
$parcel$export(module.exports, "isValidResponse", function () { return $6343abee919005ee$export$1ae38cf0a848f651; });
$parcel$export(module.exports, "isValidEvent", function () { return $6343abee919005ee$export$cbe4cdc5960cfa11; });
$parcel$export(module.exports, "isValidNamespacesChainId", function () { return $6343abee919005ee$export$144fc36610eb6522; });
$parcel$export(module.exports, "isValidNamespacesRequest", function () { return $6343abee919005ee$export$8db4804e3a6de711; });
$parcel$export(module.exports, "isValidNamespacesEvent", function () { return $6343abee919005ee$export$df2c67ef8baad16b; });
$parcel$export(module.exports, "isValidRequestExpiry", function () { return $6343abee919005ee$export$59fba2af1ac782b; });
$parcel$export(module.exports, "isOnline", function () { return $6343abee919005ee$export$53c2fd0173ad2b80; });
$parcel$export(module.exports, "subscribeToNetworkChange", function () { return $6343abee919005ee$export$600a1ee4bc680996; });
$parcel$export(module.exports, "MemoryStore", function () { return $6343abee919005ee$export$b72d712fed4d036d; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $3sHb8 = parcelRequire("3sHb8");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $l0HdX = parcelRequire("l0HdX");

var $eha6O = parcelRequire("eha6O");

var $3ngRt = parcelRequire("3ngRt");

var $4BEBs = parcelRequire("4BEBs");

var $4caNq = parcelRequire("4caNq");

var $kfXuF = parcelRequire("kfXuF");

var $hDCWT = parcelRequire("hDCWT");

var $1MbOp = parcelRequire("1MbOp");

var $atJCh = parcelRequire("atJCh");

var $5A0yG = parcelRequire("5A0yG");

var $27vAG = parcelRequire("27vAG");

var $1fnK2 = parcelRequire("1fnK2");
parcelRequire("7Ft2D");
var $ewlTP = parcelRequire("ewlTP");
var $l7Yp4 = parcelRequire("l7Yp4");
var $lQfAa = parcelRequire("lQfAa");

var $4z21a = parcelRequire("4z21a");
parcelRequire("25PiQ");
var $kGjpT = parcelRequire("kGjpT");

var $aXdDy = parcelRequire("aXdDy");

var $3qWgZ = parcelRequire("3qWgZ");

var $8dlmd = parcelRequire("8dlmd");
var $6343abee919005ee$require$Buffer = $8dlmd.Buffer;
var $6343abee919005ee$var$Ir = ":";
function $6343abee919005ee$export$4764229d78de4437(e) {
    var _e_split = (0, $cv9Rk._)(e.split($6343abee919005ee$var$Ir), 2), t = _e_split[0], r = _e_split[1];
    return {
        namespace: t,
        reference: r
    };
}
function $6343abee919005ee$export$a5999672e4930644(e) {
    var t = e.namespace, r = e.reference;
    return [
        t,
        r
    ].join($6343abee919005ee$var$Ir);
}
function $6343abee919005ee$export$276ab0158c66e3d(e) {
    var _e_split = (0, $cv9Rk._)(e.split($6343abee919005ee$var$Ir), 3), t = _e_split[0], r = _e_split[1], i = _e_split[2];
    return {
        namespace: t,
        reference: r,
        address: i
    };
}
function $6343abee919005ee$export$566a25328fb93a18(e) {
    var t = e.namespace, r = e.reference, i = e.address;
    return [
        t,
        r,
        i
    ].join($6343abee919005ee$var$Ir);
}
function $6343abee919005ee$export$d579bc26e95946b5(e, t) {
    var r = [];
    return e.forEach(function(i) {
        var n = t(i);
        r.includes(n) || r.push(n);
    }), r;
}
function $6343abee919005ee$export$2806d446053abd1d(e) {
    var _ci = $6343abee919005ee$export$276ab0158c66e3d(e), t = _ci.address;
    return t;
}
function $6343abee919005ee$export$93512919ec2ab555(e) {
    var _ci = $6343abee919005ee$export$276ab0158c66e3d(e), t = _ci.namespace, r = _ci.reference;
    return $6343abee919005ee$export$a5999672e4930644({
        namespace: t,
        reference: r
    });
}
function $6343abee919005ee$export$40283ddc77f27f6e(e, t) {
    var _pn = $6343abee919005ee$export$4764229d78de4437(t), r = _pn.namespace, i = _pn.reference;
    return $6343abee919005ee$export$566a25328fb93a18({
        namespace: r,
        reference: i,
        address: e
    });
}
function $6343abee919005ee$export$aa4a6b630dfcfa83(e) {
    return $6343abee919005ee$export$d579bc26e95946b5(e, $6343abee919005ee$export$2806d446053abd1d);
}
function $6343abee919005ee$export$d5ee58c6b13696e9(e) {
    return $6343abee919005ee$export$d579bc26e95946b5(e, $6343abee919005ee$export$93512919ec2ab555);
}
function $6343abee919005ee$export$23329703ad972840(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var r = [];
    return Object.keys(e).forEach(function(i) {
        var _r;
        if (t.length && !t.includes(i)) return;
        var n = e[i];
        (_r = r).push.apply(_r, (0, $c6Xmf._)(n.accounts));
    }), r;
}
function $6343abee919005ee$export$6281ff29da5f85fe(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var r = [];
    return Object.keys(e).forEach(function(i) {
        var _r;
        if (t.length && !t.includes(i)) return;
        var n = e[i];
        (_r = r).push.apply(_r, (0, $c6Xmf._)($6343abee919005ee$export$d5ee58c6b13696e9(n.accounts)));
    }), r;
}
function $6343abee919005ee$export$d1109eeb751412cf(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var r = [];
    return Object.keys(e).forEach(function(i) {
        var _$_r;
        if (t.length && !t.includes(i)) return;
        var n = e[i];
        (_$_r = r).push.apply(_$_r, (0, $c6Xmf._)($6343abee919005ee$export$376384387cd15b27(i, n)));
    }), r;
}
function $6343abee919005ee$export$376384387cd15b27(e, t) {
    return e.includes(":") ? [
        e
    ] : t.chains || [];
}
var $6343abee919005ee$var$Wo = Object.defineProperty, $6343abee919005ee$var$yn = Object.getOwnPropertySymbols, $6343abee919005ee$var$Xo = Object.prototype.hasOwnProperty, $6343abee919005ee$var$Zo = Object.prototype.propertyIsEnumerable, $6343abee919005ee$var$wn = function(e, t, r) {
    return t in e ? $6343abee919005ee$var$Wo(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r;
}, $6343abee919005ee$var$xn = function(e, t) {
    for(var r in t || (t = {}))$6343abee919005ee$var$Xo.call(t, r) && $6343abee919005ee$var$wn(e, r, t[r]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($6343abee919005ee$var$yn) try {
        for(var _iterator = $6343abee919005ee$var$yn(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var r = _step.value;
            $6343abee919005ee$var$Zo.call(t, r) && $6343abee919005ee$var$wn(e, r, t[r]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return e;
};
var $6343abee919005ee$export$f12873d77424d47b = "ReactNative", $6343abee919005ee$export$86b1301a63b15dd9 = {
    reactNative: "react-native",
    node: "node",
    browser: "browser",
    unknown: "unknown"
}, $6343abee919005ee$export$657dee6d5648750a = " ", $6343abee919005ee$export$96c3628b3b9d2079 = ":", $6343abee919005ee$export$98238152dfccf046 = "/", $6343abee919005ee$export$7f882bb969de14a3 = 2, $6343abee919005ee$export$77baccb4c6bd5852 = 1e3, $6343abee919005ee$export$e08b61c98317d88c = "js";
function $6343abee919005ee$export$8ee0fc9ee280b4ee() {
    return (typeof $3qWgZ === "undefined" ? "undefined" : (0, $l0HdX._)($3qWgZ)) < "u" && (0, $l0HdX._)($3qWgZ.versions) < "u" && (0, $l0HdX._)($3qWgZ.versions.node) < "u";
}
function $6343abee919005ee$export$f7a1e23e542d38e3() {
    return !(0, $4caNq.getDocument)() && !!(0, $4caNq.getNavigator)() && navigator.product === $6343abee919005ee$export$f12873d77424d47b;
}
function $6343abee919005ee$export$4e09c449d6c407f7() {
    return !$6343abee919005ee$export$8ee0fc9ee280b4ee() && !!(0, $4caNq.getNavigator)() && !!(0, $4caNq.getDocument)();
}
function $6343abee919005ee$export$57570b1603cf6adb() {
    return $6343abee919005ee$export$f7a1e23e542d38e3() ? $6343abee919005ee$export$86b1301a63b15dd9.reactNative : $6343abee919005ee$export$8ee0fc9ee280b4ee() ? $6343abee919005ee$export$86b1301a63b15dd9.node : $6343abee919005ee$export$4e09c449d6c407f7() ? $6343abee919005ee$export$86b1301a63b15dd9.browser : $6343abee919005ee$export$86b1301a63b15dd9.unknown;
}
function $6343abee919005ee$export$40a40f90174d197c() {
    var e;
    try {
        return $6343abee919005ee$export$f7a1e23e542d38e3() && (typeof $parcel$global === "undefined" ? "undefined" : (0, $l0HdX._)($parcel$global)) < "u" && (0, $l0HdX._)($parcel$global == null ? void 0 : $parcel$global.Application) < "u" ? (e = $parcel$global.Application) == null ? void 0 : e.applicationId : void 0;
    } catch (e) {
        return;
    }
}
function $6343abee919005ee$export$c4147c69f6845da(e, t) {
    var r = $hDCWT.parse(e);
    return r = $6343abee919005ee$var$xn($6343abee919005ee$var$xn({}, r), t), e = $hDCWT.stringify(r), e;
}
function $6343abee919005ee$export$ba31e015127122bb() {
    return (0, $kfXuF.getWindowMetadata)() || {
        name: "",
        description: "",
        url: "",
        icons: [
            ""
        ]
    };
}
function $6343abee919005ee$export$6b05aa0115b6fc2d(e, t) {
    var r;
    var i = $6343abee919005ee$export$57570b1603cf6adb(), n = {
        protocol: e,
        version: t,
        env: i
    };
    return i === "browser" && (n.host = ((r = (0, $4caNq.getLocation)()) == null ? void 0 : r.host) || "unknown"), n;
}
function $6343abee919005ee$export$20d4a3cb5829b8b6() {
    if ($6343abee919005ee$export$57570b1603cf6adb() === $6343abee919005ee$export$86b1301a63b15dd9.reactNative && (typeof $parcel$global === "undefined" ? "undefined" : (0, $l0HdX._)($parcel$global)) < "u" && (0, $l0HdX._)($parcel$global == null ? void 0 : $parcel$global.Platform) < "u") {
        var _global_Platform = $parcel$global.Platform, r = _global_Platform.OS, i = _global_Platform.Version;
        return [
            r,
            i
        ].join("-");
    }
    var e = (0, $3ngRt.detect)();
    if (e === null) return "unknown";
    var t = e.os ? e.os.replace(" ", "").toLowerCase() : "unknown";
    return e.type === "browser" ? [
        t,
        e.name,
        e.version
    ].join("-") : [
        t,
        e.version
    ].join("-");
}
function $6343abee919005ee$export$4389b0987726d52d() {
    var e;
    var t = $6343abee919005ee$export$57570b1603cf6adb();
    return t === $6343abee919005ee$export$86b1301a63b15dd9.browser ? [
        t,
        ((e = (0, $4caNq.getLocation)()) == null ? void 0 : e.host) || "unknown"
    ].join(":") : t;
}
function $6343abee919005ee$export$b55a4c6e272b719f(e, t, r) {
    var i = $6343abee919005ee$export$20d4a3cb5829b8b6(), n = $6343abee919005ee$export$4389b0987726d52d();
    return [
        [
            e,
            t
        ].join("-"),
        [
            $6343abee919005ee$export$e08b61c98317d88c,
            r
        ].join("-"),
        i,
        n
    ].join("/");
}
function $6343abee919005ee$export$d875b3963ef774f5(param) {
    var e = param.protocol, t = param.version, r = param.relayUrl, i = param.sdkVersion, n = param.auth, o = param.projectId, h = param.useOnCloseEvent, p = param.bundleId;
    var A = r.split("?"), m = $6343abee919005ee$export$b55a4c6e272b719f(e, t, i), w = {
        auth: n,
        ua: m,
        projectId: o,
        useOnCloseEvent: h || void 0,
        origin: p || void 0
    }, y = $6343abee919005ee$export$c4147c69f6845da(A[1] || "", w);
    return A[0] + "?" + y;
}
function $6343abee919005ee$export$ed08891a8a54eb(e) {
    var t = (e.match(/^[^:]+(?=:\/\/)/gi) || [])[0];
    var r = (typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t)) < "u" ? e.split("://")[1] : e;
    return t = t === "wss" ? "https" : "http", [
        t,
        r
    ].join("://");
}
function $6343abee919005ee$export$804de46662e4ac95(e, t, r) {
    if (!e[t] || (0, $l0HdX._)(e[t]) !== r) throw new Error('Missing or invalid "'.concat(t, '" param'));
}
function $6343abee919005ee$export$1e21530e896c0b0b(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $6343abee919005ee$export$7f882bb969de14a3;
    return $6343abee919005ee$export$7f00885504704576(e.split($6343abee919005ee$export$98238152dfccf046), t);
}
function $6343abee919005ee$export$80bffd46c37a96f6(e) {
    return $6343abee919005ee$export$1e21530e896c0b0b(e).join($6343abee919005ee$export$657dee6d5648750a);
}
function $6343abee919005ee$export$1468a49de573f7f9(e, t) {
    return e.filter(function(r) {
        return t.includes(r);
    }).length === e.length;
}
function $6343abee919005ee$export$7f00885504704576(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $6343abee919005ee$export$7f882bb969de14a3;
    return e.slice(Math.max(e.length - t, 0));
}
function $6343abee919005ee$export$c4b8dfeb6e237eb9(e) {
    return Object.fromEntries(e.entries());
}
function $6343abee919005ee$export$ac31b37c726bc3ba(e) {
    return new Map(Object.entries(e));
}
function $6343abee919005ee$export$592ef47eabb05614(e, t) {
    var r = {};
    return Object.keys(e).forEach(function(i) {
        r[i] = t(e[i]);
    }), r;
}
var $6343abee919005ee$export$85c927578394b28b = function(e) {
    return e;
};
function $6343abee919005ee$export$e9f8fcacef3bca4b(e) {
    return e.trim().replace(/^\w/, function(t) {
        return t.toUpperCase();
    });
}
function $6343abee919005ee$export$9a00dee1beb8f576(e) {
    return e.split($6343abee919005ee$export$657dee6d5648750a).map(function(t) {
        return $6343abee919005ee$export$e9f8fcacef3bca4b(t);
    }).join($6343abee919005ee$export$657dee6d5648750a);
}
function $6343abee919005ee$export$cbf9e3cc9ffc85cb() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $4BEBs.FIVE_MINUTES), t = arguments.length > 1 ? arguments[1] : void 0;
    var r = (0, $4BEBs.toMiliseconds)(e || (0, $4BEBs.FIVE_MINUTES));
    var i, n, o;
    return {
        resolve: function(h) {
            o && i && (clearTimeout(o), i(h));
        },
        reject: function(h) {
            o && n && (clearTimeout(o), n(h));
        },
        done: function() {
            return new Promise(function(h, p) {
                o = setTimeout(function() {
                    p(new Error(t));
                }, r), i = h, n = p;
            });
        }
    };
}
function $6343abee919005ee$export$3da2293b007ed708(e, t, r) {
    return new Promise(function() {
        var _ref = (0, $kSuI9._)(function(i, n) {
            var o, _$h, h;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        o = setTimeout(function() {
                            return n(new Error(r));
                        }, t);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            e
                        ];
                    case 2:
                        _$h = _state.sent();
                        i(_$h);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        h = _state.sent();
                        n(h);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        clearTimeout(o);
                        return [
                            2
                        ];
                }
            });
        });
        return function(i, n) {
            return _ref.apply(this, arguments);
        };
    }());
}
function $6343abee919005ee$export$187ab6574b2ae23f(e, t) {
    if (typeof t == "string" && t.startsWith("".concat(e, ":"))) return t;
    if (e.toLowerCase() === "topic") {
        if (typeof t != "string") throw new Error('Value must be "string" for expirer target type: topic');
        return "topic:".concat(t);
    } else if (e.toLowerCase() === "id") {
        if (typeof t != "number") throw new Error('Value must be "number" for expirer target type: id');
        return "id:".concat(t);
    }
    throw new Error("Unknown expirer target type: ".concat(e));
}
function $6343abee919005ee$export$43ab92477f8713b9(e) {
    return $6343abee919005ee$export$187ab6574b2ae23f("topic", e);
}
function $6343abee919005ee$export$bd13103c2e5cc0c3(e) {
    return $6343abee919005ee$export$187ab6574b2ae23f("id", e);
}
function $6343abee919005ee$export$93adeb0f16e8e51d(e) {
    var _e_split = (0, $cv9Rk._)(e.split(":"), 2), t = _e_split[0], r = _e_split[1], i = {
        id: void 0,
        topic: void 0
    };
    if (t === "topic" && typeof r == "string") i.topic = r;
    else if (t === "id" && Number.isInteger(Number(r))) i.id = Number(r);
    else throw new Error("Invalid target, expected id:number or topic:string, got ".concat(t, ":").concat(r));
    return i;
}
function $6343abee919005ee$export$b136d03015bfc12(e, t) {
    return (0, $4BEBs.fromMiliseconds)((t || Date.now()) + (0, $4BEBs.toMiliseconds)(e));
}
function $6343abee919005ee$export$57947cfd429801a2(e) {
    return Date.now() >= (0, $4BEBs.toMiliseconds)(e);
}
function $6343abee919005ee$export$e3eb27ce66c0f6d9(e, t) {
    return "".concat(e).concat(t ? ":".concat(t) : "");
}
function $6343abee919005ee$export$9826fe7ad3921016() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return (0, $c6Xmf._)(new Set((0, $c6Xmf._)(e).concat((0, $c6Xmf._)(t))));
}
function $6343abee919005ee$export$694a208c8abca99a(_) {
    return $6343abee919005ee$var$_ws.apply(this, arguments);
}
function $6343abee919005ee$var$_ws() {
    $6343abee919005ee$var$_ws = (0, $kSuI9._)(function(param) {
        var e, t, r, _$i, n, o, h, _tmp, _tmp1, i;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    e = param.id, t = param.topic, r = param.wcDeepLink;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        ,
                        7
                    ]);
                    if (!r) return [
                        2
                    ];
                    _$i = typeof r == "string" ? JSON.parse(r) : r;
                    n = _$i === null || _$i === void 0 ? void 0 : _$i.href;
                    if (typeof n != "string") return [
                        2
                    ];
                    n.endsWith("/") && (n = n.slice(0, -1));
                    o = "".concat(n, "/wc?requestId=").concat(e, "&sessionTopic=").concat(t), h = $6343abee919005ee$export$57570b1603cf6adb();
                    if (!(h === $6343abee919005ee$export$86b1301a63b15dd9.browser)) return [
                        3,
                        2
                    ];
                    _tmp = o.startsWith("https://") || o.startsWith("http://") ? window.open(o, "_blank", "noreferrer noopener") : window.open(o, "_self", "noreferrer noopener");
                    return [
                        3,
                        5
                    ];
                case 2:
                    _tmp1 = h === $6343abee919005ee$export$86b1301a63b15dd9.reactNative && (0, $l0HdX._)($parcel$global == null ? void 0 : $parcel$global.Linking) < "u";
                    if (!_tmp1) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        $parcel$global.Linking.openURL(o)
                    ];
                case 3:
                    _tmp1 = _state.sent();
                    _state.label = 4;
                case 4:
                    _tmp = _tmp1;
                    _state.label = 5;
                case 5:
                    _tmp;
                    return [
                        3,
                        7
                    ];
                case 6:
                    i = _state.sent();
                    console.error(i);
                    return [
                        3,
                        7
                    ];
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    return $6343abee919005ee$var$_ws.apply(this, arguments);
}
function $6343abee919005ee$export$e55bfdac47149a32(e, t) {
    return $6343abee919005ee$var$_xs.apply(this, arguments);
}
function $6343abee919005ee$var$_xs() {
    $6343abee919005ee$var$_xs = (0, $kSuI9._)(function(e, t) {
        var r;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        e.getItem(t)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent() || ($6343abee919005ee$export$4e09c449d6c407f7() ? localStorage.getItem(t) : void 0)
                    ];
                case 2:
                    r = _state.sent();
                    console.error(r);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $6343abee919005ee$var$_xs.apply(this, arguments);
}
function $6343abee919005ee$export$f8aaf09178dd8b96(e, t) {
    return e.filter(function(r) {
        return t.includes(r);
    });
}
function $6343abee919005ee$export$abe4376e1bf796d6() {
    return (typeof crypto === "undefined" ? "undefined" : (0, $l0HdX._)(crypto)) < "u" && crypto != null && crypto.randomUUID ? crypto.randomUUID() : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(RegExp("[xy]", "gu"), function(e) {
        var t = Math.random() * 16 | 0;
        return (e === "x" ? t : t & 3 | 8).toString(16);
    });
}
var $6343abee919005ee$var$Pn = (typeof globalThis === "undefined" ? "undefined" : (0, $l0HdX._)(globalThis)) < "u" ? globalThis : (typeof window === "undefined" ? "undefined" : (0, $l0HdX._)(window)) < "u" ? window : (typeof $parcel$global === "undefined" ? "undefined" : (0, $l0HdX._)($parcel$global)) < "u" ? $parcel$global : (typeof self === "undefined" ? "undefined" : (0, $l0HdX._)(self)) < "u" ? self : {};
function $6343abee919005ee$var$Es(e) {
    var t = e.default;
    if (typeof t == "function") {
        var r = function r() {
            return t.apply(this, arguments);
        };
        r.prototype = t.prototype;
    } else r = {};
    return Object.defineProperty(r, "__esModule", {
        value: !0
    }), Object.keys(e).forEach(function(i) {
        var n = Object.getOwnPropertyDescriptor(e, i);
        Object.defineProperty(r, i, n.get ? n : {
            enumerable: !0,
            get: function get() {
                return e[i];
            }
        });
    }), r;
}
var $6343abee919005ee$var$Dn = {
    exports: {}
}; /**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */ 
(function(e) {
    (function() {
        var t = "input is invalid type", r = "finalize already called", i = typeof window == "object", n = i ? window : {};
        n.JS_SHA3_NO_WINDOW && (i = !1);
        var o = !i && typeof self == "object", h = !n.JS_SHA3_NO_NODE_JS && typeof $3qWgZ == "object" && $3qWgZ.versions && $3qWgZ.versions.node;
        h ? n = $6343abee919005ee$var$Pn : o && (n = self);
        var p = !n.JS_SHA3_NO_COMMON_JS && !0 && e.exports, A = !n.JS_SHA3_NO_ARRAY_BUFFER && (typeof ArrayBuffer === "undefined" ? "undefined" : (0, $l0HdX._)(ArrayBuffer)) < "u", m = "0123456789abcdef".split(""), w = [
            31,
            7936,
            2031616,
            520093696
        ], y = [
            4,
            1024,
            262144,
            67108864
        ], S = [
            1,
            256,
            65536,
            16777216
        ], I = [
            6,
            1536,
            393216,
            100663296
        ], N = [
            0,
            8,
            16,
            24
        ], C = [
            1,
            0,
            32898,
            0,
            32906,
            2147483648,
            2147516416,
            2147483648,
            32907,
            0,
            2147483649,
            0,
            2147516545,
            2147483648,
            32777,
            2147483648,
            138,
            0,
            136,
            0,
            2147516425,
            0,
            2147483658,
            0,
            2147516555,
            0,
            139,
            2147483648,
            32905,
            2147483648,
            32771,
            2147483648,
            32770,
            2147483648,
            128,
            2147483648,
            32778,
            0,
            2147483658,
            2147483648,
            2147516545,
            2147483648,
            32896,
            2147483648,
            2147483649,
            0,
            2147516424,
            2147483648
        ], F = [
            224,
            256,
            384,
            512
        ], U = [
            128,
            256
        ], J = [
            "hex",
            "buffer",
            "arrayBuffer",
            "array",
            "digest"
        ], Bt = {
            128: 168,
            256: 136
        };
        (n.JS_SHA3_NO_NODE_JS || !Array.isArray) && (Array.isArray = function(u) {
            return Object.prototype.toString.call(u) === "[object Array]";
        }), A && (n.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView) && (ArrayBuffer.isView = function(u) {
            return typeof u == "object" && u.buffer && u.buffer.constructor === ArrayBuffer;
        });
        for(var G = function G(u, E, _) {
            return function(B) {
                return new s(u, E, u).update(B)[_]();
            };
        }, H = function H(u, E, _) {
            return function(B, R) {
                return new s(u, E, R).update(B)[_]();
            };
        }, z = function z(u, E, _) {
            return function(B, R, T, P) {
                return f["cshake" + u].update(B, R, T, P)[_]();
            };
        }, Pt = function Pt(u, E, _) {
            return function(B, R, T, P) {
                return f["kmac" + u].update(B, R, T, P)[_]();
            };
        }, W = function W(u, E, _, B) {
            for(var R = 0; R < J.length; ++R){
                var T = J[R];
                u[T] = E(_, B, T);
            }
            return u;
        }, Rt = function Rt(u, E) {
            var _ = G(u, E, "hex");
            return _.create = function() {
                return new s(u, E, u);
            }, _.update = function(B) {
                return _.create().update(B);
            }, W(_, G, u, E);
        }, Yt = function Yt(u, E) {
            var _ = H(u, E, "hex");
            return _.create = function(B) {
                return new s(u, E, B);
            }, _.update = function(B, R) {
                return _.create(R).update(B);
            }, W(_, H, u, E);
        }, Y = function Y(u, E) {
            var _ = Bt[u], B = z(u, E, "hex");
            return B.create = function(R, T, P) {
                return !T && !P ? f["shake" + u].create(R) : new s(u, E, R).bytepad([
                    T,
                    P
                ], _);
            }, B.update = function(R, T, P, O) {
                return B.create(T, P, O).update(R);
            }, W(B, z, u, E);
        }, Vt = function Vt(u, E) {
            var _ = Bt[u], B = Pt(u, E, "hex");
            return B.create = function(R, T, P) {
                return new v(u, E, T).bytepad([
                    "KMAC",
                    P
                ], _).bytepad([
                    R
                ], _);
            }, B.update = function(R, T, P, O) {
                return B.create(R, P, O).update(T);
            }, W(B, Pt, u, E);
        }, b = [
            {
                name: "keccak",
                padding: S,
                bits: F,
                createMethod: Rt
            },
            {
                name: "sha3",
                padding: I,
                bits: F,
                createMethod: Rt
            },
            {
                name: "shake",
                padding: w,
                bits: U,
                createMethod: Yt
            },
            {
                name: "cshake",
                padding: y,
                bits: U,
                createMethod: Y
            },
            {
                name: "kmac",
                padding: y,
                bits: U,
                createMethod: Vt
            }
        ], f = {}, a = [], c = 0; c < b.length; ++c)for(var d = b[c], g = d.bits, x = 0; x < g.length; ++x){
            var M = d.name + "_" + g[x];
            if (a.push(M), f[M] = d.createMethod(g[x], d.padding), d.name !== "sha3") {
                var l = d.name + g[x];
                a.push(l), f[l] = f[M];
            }
        }
        function s(u, E, _) {
            this.blocks = [], this.s = [], this.padding = E, this.outputBits = _, this.reset = !0, this.finalized = !1, this.block = 0, this.start = 0, this.blockCount = 1600 - (u << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = _ >> 5, this.extraBytes = (_ & 31) >> 3;
            for(var B = 0; B < 50; ++B)this.s[B] = 0;
        }
        s.prototype.update = function(u) {
            if (this.finalized) throw new Error(r);
            var E, _ = typeof u === "undefined" ? "undefined" : (0, $l0HdX._)(u);
            if (_ !== "string") {
                if (_ === "object") {
                    if (u === null) throw new Error(t);
                    if (A && u.constructor === ArrayBuffer) u = new Uint8Array(u);
                    else if (!Array.isArray(u) && (!A || !ArrayBuffer.isView(u))) throw new Error(t);
                } else throw new Error(t);
                E = !0;
            }
            for(var B = this.blocks, R = this.byteCount, T = u.length, P = this.blockCount, O = 0, Ct = this.s, D, q; O < T;){
                if (this.reset) for(this.reset = !1, B[0] = this.block, D = 1; D < P + 1; ++D)B[D] = 0;
                if (E) for(D = this.start; O < T && D < R; ++O)B[D >> 2] |= u[O] << N[D++ & 3];
                else for(D = this.start; O < T && D < R; ++O)q = u.charCodeAt(O), q < 128 ? B[D >> 2] |= q << N[D++ & 3] : q < 2048 ? (B[D >> 2] |= (192 | q >> 6) << N[D++ & 3], B[D >> 2] |= (128 | q & 63) << N[D++ & 3]) : q < 55296 || q >= 57344 ? (B[D >> 2] |= (224 | q >> 12) << N[D++ & 3], B[D >> 2] |= (128 | q >> 6 & 63) << N[D++ & 3], B[D >> 2] |= (128 | q & 63) << N[D++ & 3]) : (q = 65536 + ((q & 1023) << 10 | u.charCodeAt(++O) & 1023), B[D >> 2] |= (240 | q >> 18) << N[D++ & 3], B[D >> 2] |= (128 | q >> 12 & 63) << N[D++ & 3], B[D >> 2] |= (128 | q >> 6 & 63) << N[D++ & 3], B[D >> 2] |= (128 | q & 63) << N[D++ & 3]);
                if (this.lastByteIndex = D, D >= R) {
                    for(this.start = D - R, this.block = B[P], D = 0; D < P; ++D)Ct[D] ^= B[D];
                    k(Ct), this.reset = !0;
                } else this.start = D;
            }
            return this;
        }, s.prototype.encode = function(u, E) {
            var _ = u & 255, B = 1, R = [
                _
            ];
            for(u = u >> 8, _ = u & 255; _ > 0;)R.unshift(_), u = u >> 8, _ = u & 255, ++B;
            return E ? R.push(B) : R.unshift(B), this.update(R), R.length;
        }, s.prototype.encodeString = function(u) {
            var E, _ = typeof u === "undefined" ? "undefined" : (0, $l0HdX._)(u);
            if (_ !== "string") {
                if (_ === "object") {
                    if (u === null) throw new Error(t);
                    if (A && u.constructor === ArrayBuffer) u = new Uint8Array(u);
                    else if (!Array.isArray(u) && (!A || !ArrayBuffer.isView(u))) throw new Error(t);
                } else throw new Error(t);
                E = !0;
            }
            var B = 0, R = u.length;
            if (E) B = R;
            else for(var T = 0; T < u.length; ++T){
                var P = u.charCodeAt(T);
                P < 128 ? B += 1 : P < 2048 ? B += 2 : P < 55296 || P >= 57344 ? B += 3 : (P = 65536 + ((P & 1023) << 10 | u.charCodeAt(++T) & 1023), B += 4);
            }
            return B += this.encode(B * 8), this.update(u), B;
        }, s.prototype.bytepad = function(u, E) {
            for(var _ = this.encode(E), B = 0; B < u.length; ++B)_ += this.encodeString(u[B]);
            var R = E - _ % E, T = [];
            return T.length = R, this.update(T), this;
        }, s.prototype.finalize = function() {
            if (!this.finalized) {
                this.finalized = !0;
                var u = this.blocks, E = this.lastByteIndex, _ = this.blockCount, B = this.s;
                if (u[E >> 2] |= this.padding[E & 3], this.lastByteIndex === this.byteCount) for(u[0] = u[_], E = 1; E < _ + 1; ++E)u[E] = 0;
                for(u[_ - 1] |= 2147483648, E = 0; E < _; ++E)B[E] ^= u[E];
                k(B);
            }
        }, s.prototype.toString = s.prototype.hex = function() {
            this.finalize();
            for(var u = this.blockCount, E = this.s, _ = this.outputBlocks, B = this.extraBytes, R = 0, T = 0, P = "", O; T < _;){
                for(R = 0; R < u && T < _; ++R, ++T)O = E[R], P += m[O >> 4 & 15] + m[O & 15] + m[O >> 12 & 15] + m[O >> 8 & 15] + m[O >> 20 & 15] + m[O >> 16 & 15] + m[O >> 28 & 15] + m[O >> 24 & 15];
                T % u === 0 && (k(E), R = 0);
            }
            return B && (O = E[R], P += m[O >> 4 & 15] + m[O & 15], B > 1 && (P += m[O >> 12 & 15] + m[O >> 8 & 15]), B > 2 && (P += m[O >> 20 & 15] + m[O >> 16 & 15])), P;
        }, s.prototype.arrayBuffer = function() {
            this.finalize();
            var u = this.blockCount, E = this.s, _ = this.outputBlocks, B = this.extraBytes, R = 0, T = 0, P = this.outputBits >> 3, O;
            B ? O = new ArrayBuffer(_ + 1 << 2) : O = new ArrayBuffer(P);
            for(var Ct = new Uint32Array(O); T < _;){
                for(R = 0; R < u && T < _; ++R, ++T)Ct[T] = E[R];
                T % u === 0 && k(E);
            }
            return B && (Ct[R] = E[R], O = O.slice(0, P)), O;
        }, s.prototype.buffer = s.prototype.arrayBuffer, s.prototype.digest = s.prototype.array = function() {
            this.finalize();
            for(var u = this.blockCount, E = this.s, _ = this.outputBlocks, B = this.extraBytes, R = 0, T = 0, P = [], O, Ct; T < _;){
                for(R = 0; R < u && T < _; ++R, ++T)O = T << 2, Ct = E[R], P[O] = Ct & 255, P[O + 1] = Ct >> 8 & 255, P[O + 2] = Ct >> 16 & 255, P[O + 3] = Ct >> 24 & 255;
                T % u === 0 && k(E);
            }
            return B && (O = T << 2, Ct = E[R], P[O] = Ct & 255, B > 1 && (P[O + 1] = Ct >> 8 & 255), B > 2 && (P[O + 2] = Ct >> 16 & 255)), P;
        };
        function v(u, E, _) {
            s.call(this, u, E, _);
        }
        v.prototype = new s, v.prototype.finalize = function() {
            return this.encode(this.outputBits, !0), s.prototype.finalize.call(this);
        };
        var k = function k(u) {
            var E, _, B, R, T, P, O, Ct, D, q, De, X, Z, Fe, $, tt, Te, et, rt, Ue, it, nt, ke, ft, ot, qe, st, at, Ke, ut, ht, He, ct, lt, ze, dt, pt, Le, vt, mt, je, gt, At, Qe, bt, yt, Je, wt, xt, Ge, Mt, Et, Ye, St, Nt, Ve, It, _t, Me, Ee, Se, Ne, Ie;
            for(B = 0; B < 48; B += 2)R = u[0] ^ u[10] ^ u[20] ^ u[30] ^ u[40], T = u[1] ^ u[11] ^ u[21] ^ u[31] ^ u[41], P = u[2] ^ u[12] ^ u[22] ^ u[32] ^ u[42], O = u[3] ^ u[13] ^ u[23] ^ u[33] ^ u[43], Ct = u[4] ^ u[14] ^ u[24] ^ u[34] ^ u[44], D = u[5] ^ u[15] ^ u[25] ^ u[35] ^ u[45], q = u[6] ^ u[16] ^ u[26] ^ u[36] ^ u[46], De = u[7] ^ u[17] ^ u[27] ^ u[37] ^ u[47], X = u[8] ^ u[18] ^ u[28] ^ u[38] ^ u[48], Z = u[9] ^ u[19] ^ u[29] ^ u[39] ^ u[49], E = X ^ (P << 1 | O >>> 31), _ = Z ^ (O << 1 | P >>> 31), u[0] ^= E, u[1] ^= _, u[10] ^= E, u[11] ^= _, u[20] ^= E, u[21] ^= _, u[30] ^= E, u[31] ^= _, u[40] ^= E, u[41] ^= _, E = R ^ (Ct << 1 | D >>> 31), _ = T ^ (D << 1 | Ct >>> 31), u[2] ^= E, u[3] ^= _, u[12] ^= E, u[13] ^= _, u[22] ^= E, u[23] ^= _, u[32] ^= E, u[33] ^= _, u[42] ^= E, u[43] ^= _, E = P ^ (q << 1 | De >>> 31), _ = O ^ (De << 1 | q >>> 31), u[4] ^= E, u[5] ^= _, u[14] ^= E, u[15] ^= _, u[24] ^= E, u[25] ^= _, u[34] ^= E, u[35] ^= _, u[44] ^= E, u[45] ^= _, E = Ct ^ (X << 1 | Z >>> 31), _ = D ^ (Z << 1 | X >>> 31), u[6] ^= E, u[7] ^= _, u[16] ^= E, u[17] ^= _, u[26] ^= E, u[27] ^= _, u[36] ^= E, u[37] ^= _, u[46] ^= E, u[47] ^= _, E = q ^ (R << 1 | T >>> 31), _ = De ^ (T << 1 | R >>> 31), u[8] ^= E, u[9] ^= _, u[18] ^= E, u[19] ^= _, u[28] ^= E, u[29] ^= _, u[38] ^= E, u[39] ^= _, u[48] ^= E, u[49] ^= _, Fe = u[0], $ = u[1], yt = u[11] << 4 | u[10] >>> 28, Je = u[10] << 4 | u[11] >>> 28, at = u[20] << 3 | u[21] >>> 29, Ke = u[21] << 3 | u[20] >>> 29, Ee = u[31] << 9 | u[30] >>> 23, Se = u[30] << 9 | u[31] >>> 23, gt = u[40] << 18 | u[41] >>> 14, At = u[41] << 18 | u[40] >>> 14, lt = u[2] << 1 | u[3] >>> 31, ze = u[3] << 1 | u[2] >>> 31, tt = u[13] << 12 | u[12] >>> 20, Te = u[12] << 12 | u[13] >>> 20, wt = u[22] << 10 | u[23] >>> 22, xt = u[23] << 10 | u[22] >>> 22, ut = u[33] << 13 | u[32] >>> 19, ht = u[32] << 13 | u[33] >>> 19, Ne = u[42] << 2 | u[43] >>> 30, Ie = u[43] << 2 | u[42] >>> 30, St = u[5] << 30 | u[4] >>> 2, Nt = u[4] << 30 | u[5] >>> 2, dt = u[14] << 6 | u[15] >>> 26, pt = u[15] << 6 | u[14] >>> 26, et = u[25] << 11 | u[24] >>> 21, rt = u[24] << 11 | u[25] >>> 21, Ge = u[34] << 15 | u[35] >>> 17, Mt = u[35] << 15 | u[34] >>> 17, He = u[45] << 29 | u[44] >>> 3, ct = u[44] << 29 | u[45] >>> 3, ft = u[6] << 28 | u[7] >>> 4, ot = u[7] << 28 | u[6] >>> 4, Ve = u[17] << 23 | u[16] >>> 9, It = u[16] << 23 | u[17] >>> 9, Le = u[26] << 25 | u[27] >>> 7, vt = u[27] << 25 | u[26] >>> 7, Ue = u[36] << 21 | u[37] >>> 11, it = u[37] << 21 | u[36] >>> 11, Et = u[47] << 24 | u[46] >>> 8, Ye = u[46] << 24 | u[47] >>> 8, Qe = u[8] << 27 | u[9] >>> 5, bt = u[9] << 27 | u[8] >>> 5, qe = u[18] << 20 | u[19] >>> 12, st = u[19] << 20 | u[18] >>> 12, _t = u[29] << 7 | u[28] >>> 25, Me = u[28] << 7 | u[29] >>> 25, mt = u[38] << 8 | u[39] >>> 24, je = u[39] << 8 | u[38] >>> 24, nt = u[48] << 14 | u[49] >>> 18, ke = u[49] << 14 | u[48] >>> 18, u[0] = Fe ^ ~tt & et, u[1] = $ ^ ~Te & rt, u[10] = ft ^ ~qe & at, u[11] = ot ^ ~st & Ke, u[20] = lt ^ ~dt & Le, u[21] = ze ^ ~pt & vt, u[30] = Qe ^ ~yt & wt, u[31] = bt ^ ~Je & xt, u[40] = St ^ ~Ve & _t, u[41] = Nt ^ ~It & Me, u[2] = tt ^ ~et & Ue, u[3] = Te ^ ~rt & it, u[12] = qe ^ ~at & ut, u[13] = st ^ ~Ke & ht, u[22] = dt ^ ~Le & mt, u[23] = pt ^ ~vt & je, u[32] = yt ^ ~wt & Ge, u[33] = Je ^ ~xt & Mt, u[42] = Ve ^ ~_t & Ee, u[43] = It ^ ~Me & Se, u[4] = et ^ ~Ue & nt, u[5] = rt ^ ~it & ke, u[14] = at ^ ~ut & He, u[15] = Ke ^ ~ht & ct, u[24] = Le ^ ~mt & gt, u[25] = vt ^ ~je & At, u[34] = wt ^ ~Ge & Et, u[35] = xt ^ ~Mt & Ye, u[44] = _t ^ ~Ee & Ne, u[45] = Me ^ ~Se & Ie, u[6] = Ue ^ ~nt & Fe, u[7] = it ^ ~ke & $, u[16] = ut ^ ~He & ft, u[17] = ht ^ ~ct & ot, u[26] = mt ^ ~gt & lt, u[27] = je ^ ~At & ze, u[36] = Ge ^ ~Et & Qe, u[37] = Mt ^ ~Ye & bt, u[46] = Ee ^ ~Ne & St, u[47] = Se ^ ~Ie & Nt, u[8] = nt ^ ~Fe & tt, u[9] = ke ^ ~$ & Te, u[18] = He ^ ~ft & qe, u[19] = ct ^ ~ot & st, u[28] = gt ^ ~lt & dt, u[29] = At ^ ~ze & pt, u[38] = Et ^ ~Qe & yt, u[39] = Ye ^ ~bt & Je, u[48] = Ne ^ ~St & Ve, u[49] = Ie ^ ~Nt & It, u[0] ^= C[B], u[1] ^= C[B + 1];
        };
        if (p) e.exports = f;
        else for(c = 0; c < a.length; ++c)n[a[c]] = f[a[c]];
    })();
})($6343abee919005ee$var$Dn);
var $6343abee919005ee$var$Ss = $6343abee919005ee$var$Dn.exports;
var $6343abee919005ee$var$Ns = "logger/5.7.0";
var $6343abee919005ee$var$Fn = !1, $6343abee919005ee$var$Tn = !1;
var $6343abee919005ee$var$Cr = {
    debug: 1,
    default: 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
var $6343abee919005ee$var$Un = $6343abee919005ee$var$Cr.default, $6343abee919005ee$var$gi = null;
function $6343abee919005ee$var$Is() {
    try {
        var _$e = [];
        if ([
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach(function(t) {
            try {
                if ("test".normalize(t) !== "test") throw new Error("bad normalize");
            } catch (e) {
                _$e.push(t);
            }
        }), _$e.length) throw new Error("missing " + _$e.join(", "));
        if (String.fromCharCode(233).normalize("NFD") !== String.fromCharCode(101, 769)) throw new Error("broken implementation");
    } catch (e) {
        return e.message;
    }
    return null;
}
var $6343abee919005ee$var$kn = $6343abee919005ee$var$Is();
var $6343abee919005ee$var$Ai;
(function(e) {
    e.DEBUG = "DEBUG", e.INFO = "INFO", e.WARNING = "WARNING", e.ERROR = "ERROR", e.OFF = "OFF";
})($6343abee919005ee$var$Ai || ($6343abee919005ee$var$Ai = {}));
var $6343abee919005ee$var$re;
(function(e) {
    e.UNKNOWN_ERROR = "UNKNOWN_ERROR", e.NOT_IMPLEMENTED = "NOT_IMPLEMENTED", e.UNSUPPORTED_OPERATION = "UNSUPPORTED_OPERATION", e.NETWORK_ERROR = "NETWORK_ERROR", e.SERVER_ERROR = "SERVER_ERROR", e.TIMEOUT = "TIMEOUT", e.BUFFER_OVERRUN = "BUFFER_OVERRUN", e.NUMERIC_FAULT = "NUMERIC_FAULT", e.MISSING_NEW = "MISSING_NEW", e.INVALID_ARGUMENT = "INVALID_ARGUMENT", e.MISSING_ARGUMENT = "MISSING_ARGUMENT", e.UNEXPECTED_ARGUMENT = "UNEXPECTED_ARGUMENT", e.CALL_EXCEPTION = "CALL_EXCEPTION", e.INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS", e.NONCE_EXPIRED = "NONCE_EXPIRED", e.REPLACEMENT_UNDERPRICED = "REPLACEMENT_UNDERPRICED", e.UNPREDICTABLE_GAS_LIMIT = "UNPREDICTABLE_GAS_LIMIT", e.TRANSACTION_REPLACED = "TRANSACTION_REPLACED", e.ACTION_REJECTED = "ACTION_REJECTED";
})($6343abee919005ee$var$re || ($6343abee919005ee$var$re = {}));
var $6343abee919005ee$var$qn = "0123456789abcdef";
var $6343abee919005ee$var$L = /*#__PURE__*/ function() {
    "use strict";
    function L(t) {
        (0, $4GJKx._)(this, L);
        Object.defineProperty(this, "version", {
            enumerable: !0,
            value: t,
            writable: !1
        });
    }
    (0, $1wc17._)(L, [
        {
            key: "_log",
            value: function _log(t, r) {
                var i = t.toLowerCase();
                $6343abee919005ee$var$Cr[i] == null && this.throwArgumentError("invalid log level name", "logLevel", t), !($6343abee919005ee$var$Un > $6343abee919005ee$var$Cr[i]) && console.log.apply(console, r);
            }
        },
        {
            key: "debug",
            value: function debug() {
                for(var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++){
                    t[_key] = arguments[_key];
                }
                this._log(L.levels.DEBUG, t);
            }
        },
        {
            key: "info",
            value: function info() {
                for(var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++){
                    t[_key] = arguments[_key];
                }
                this._log(L.levels.INFO, t);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++){
                    t[_key] = arguments[_key];
                }
                this._log(L.levels.WARNING, t);
            }
        },
        {
            key: "makeError",
            value: function makeError(t, r, i) {
                if ($6343abee919005ee$var$Tn) return this.makeError("censored error", r, {});
                r || (r = L.errors.UNKNOWN_ERROR), i || (i = {});
                var n = [];
                Object.keys(i).forEach(function(A) {
                    var m = i[A];
                    try {
                        if (m instanceof Uint8Array) {
                            var w = "";
                            for(var y = 0; y < m.length; y++)w += $6343abee919005ee$var$qn[m[y] >> 4], w += $6343abee919005ee$var$qn[m[y] & 15];
                            n.push(A + "=Uint8Array(0x" + w + ")");
                        } else n.push(A + "=" + JSON.stringify(m));
                    } catch (e) {
                        n.push(A + "=" + JSON.stringify(i[A].toString()));
                    }
                }), n.push("code=".concat(r)), n.push("version=".concat(this.version));
                var o = t;
                var h = "";
                switch(r){
                    case $6343abee919005ee$var$re.NUMERIC_FAULT:
                        {
                            h = "NUMERIC_FAULT";
                            var A = t;
                            switch(A){
                                case "overflow":
                                case "underflow":
                                case "division-by-zero":
                                    h += "-" + A;
                                    break;
                                case "negative-power":
                                case "negative-width":
                                    h += "-unsupported";
                                    break;
                                case "unbound-bitwise-result":
                                    h += "-unbound-result";
                                    break;
                            }
                            break;
                        }
                    case $6343abee919005ee$var$re.CALL_EXCEPTION:
                    case $6343abee919005ee$var$re.INSUFFICIENT_FUNDS:
                    case $6343abee919005ee$var$re.MISSING_NEW:
                    case $6343abee919005ee$var$re.NONCE_EXPIRED:
                    case $6343abee919005ee$var$re.REPLACEMENT_UNDERPRICED:
                    case $6343abee919005ee$var$re.TRANSACTION_REPLACED:
                    case $6343abee919005ee$var$re.UNPREDICTABLE_GAS_LIMIT:
                        h = r;
                        break;
                }
                h && (t += " [ See: https://links.ethers.org/v5-errors-" + h + " ]"), n.length && (t += " (" + n.join(", ") + ")");
                var p = new Error(t);
                return p.reason = o, p.code = r, Object.keys(i).forEach(function(A) {
                    p[A] = i[A];
                }), p;
            }
        },
        {
            key: "throwError",
            value: function throwError(t, r, i) {
                throw this.makeError(t, r, i);
            }
        },
        {
            key: "throwArgumentError",
            value: function throwArgumentError(t, r, i) {
                return this.throwError(t, L.errors.INVALID_ARGUMENT, {
                    argument: r,
                    value: i
                });
            }
        },
        {
            key: "assert",
            value: function assert(t, r, i, n) {
                t || this.throwError(r, i, n);
            }
        },
        {
            key: "assertArgument",
            value: function assertArgument(t, r, i, n) {
                t || this.throwArgumentError(r, i, n);
            }
        },
        {
            key: "checkNormalize",
            value: function checkNormalize(t) {
                $6343abee919005ee$var$kn && this.throwError("platform missing String.prototype.normalize", L.errors.UNSUPPORTED_OPERATION, {
                    operation: "String.prototype.normalize",
                    form: $6343abee919005ee$var$kn
                });
            }
        },
        {
            key: "checkSafeUint53",
            value: function checkSafeUint53(t, r) {
                typeof t == "number" && (r == null && (r = "value not safe"), (t < 0 || t >= 9007199254740991) && this.throwError(r, L.errors.NUMERIC_FAULT, {
                    operation: "checkSafeInteger",
                    fault: "out-of-safe-range",
                    value: t
                }), t % 1 && this.throwError(r, L.errors.NUMERIC_FAULT, {
                    operation: "checkSafeInteger",
                    fault: "non-integer",
                    value: t
                }));
            }
        },
        {
            key: "checkArgumentCount",
            value: function checkArgumentCount(t, r, i) {
                i ? i = ": " + i : i = "", t < r && this.throwError("missing argument" + i, L.errors.MISSING_ARGUMENT, {
                    count: t,
                    expectedCount: r
                }), t > r && this.throwError("too many arguments" + i, L.errors.UNEXPECTED_ARGUMENT, {
                    count: t,
                    expectedCount: r
                });
            }
        },
        {
            key: "checkNew",
            value: function checkNew(t, r) {
                (t === Object || t == null) && this.throwError("missing new", L.errors.MISSING_NEW, {
                    name: r.name
                });
            }
        },
        {
            key: "checkAbstract",
            value: function checkAbstract(t, r) {
                t === r ? this.throwError("cannot instantiate abstract class " + JSON.stringify(r.name) + " directly; use a sub-class", L.errors.UNSUPPORTED_OPERATION, {
                    name: t.name,
                    operation: "new"
                }) : (t === Object || t == null) && this.throwError("missing new", L.errors.MISSING_NEW, {
                    name: r.name
                });
            }
        }
    ], [
        {
            key: "globalLogger",
            value: function globalLogger() {
                return $6343abee919005ee$var$gi || ($6343abee919005ee$var$gi = new L($6343abee919005ee$var$Ns)), $6343abee919005ee$var$gi;
            }
        },
        {
            key: "setCensorship",
            value: function setCensorship(t, r) {
                if (!t && r && this.globalLogger().throwError("cannot permanently disable censorship", L.errors.UNSUPPORTED_OPERATION, {
                    operation: "setCensorship"
                }), $6343abee919005ee$var$Fn) {
                    if (!t) return;
                    this.globalLogger().throwError("error censorship permanent", L.errors.UNSUPPORTED_OPERATION, {
                        operation: "setCensorship"
                    });
                }
                $6343abee919005ee$var$Tn = !!t, $6343abee919005ee$var$Fn = !!r;
            }
        },
        {
            key: "setLogLevel",
            value: function setLogLevel(t) {
                var r = $6343abee919005ee$var$Cr[t.toLowerCase()];
                if (r == null) {
                    L.globalLogger().warn("invalid log level - " + t);
                    return;
                }
                $6343abee919005ee$var$Un = r;
            }
        },
        {
            key: "from",
            value: function from(t) {
                return new L(t);
            }
        }
    ]);
    return L;
}();
$6343abee919005ee$var$L.errors = $6343abee919005ee$var$re, $6343abee919005ee$var$L.levels = $6343abee919005ee$var$Ai;
var $6343abee919005ee$var$_s = "bytes/5.7.0", $6343abee919005ee$var$Dt = new $6343abee919005ee$var$L($6343abee919005ee$var$_s);
function $6343abee919005ee$var$Kn(e) {
    return !!e.toHexString;
}
function $6343abee919005ee$var$rr(e) {
    return e.slice || (e.slice = function() {
        var t = Array.prototype.slice.call(arguments);
        return $6343abee919005ee$var$rr(new Uint8Array(Array.prototype.slice.apply(e, t)));
    }), e;
}
function $6343abee919005ee$var$Bs(e) {
    return $6343abee919005ee$var$Qt(e) && !(e.length % 2) || $6343abee919005ee$var$ir(e);
}
function $6343abee919005ee$var$Hn(e) {
    return typeof e == "number" && e == e && e % 1 === 0;
}
function $6343abee919005ee$var$ir(e) {
    if (e == null) return !1;
    if (e.constructor === Uint8Array) return !0;
    if (typeof e == "string" || !$6343abee919005ee$var$Hn(e.length) || e.length < 0) return !1;
    for(var t = 0; t < e.length; t++){
        var r = e[t];
        if (!$6343abee919005ee$var$Hn(r) || r < 0 || r >= 256) return !1;
    }
    return !0;
}
function $6343abee919005ee$var$Ot(e, t) {
    if (t || (t = {}), typeof e == "number") {
        $6343abee919005ee$var$Dt.checkSafeUint53(e, "invalid arrayify value");
        var r = [];
        for(; e;)r.unshift(e & 255), e = parseInt(String(e / 256));
        return r.length === 0 && r.push(0), $6343abee919005ee$var$rr(new Uint8Array(r));
    }
    if (t.allowMissingPrefix && typeof e == "string" && e.substring(0, 2) !== "0x" && (e = "0x" + e), $6343abee919005ee$var$Kn(e) && (e = e.toHexString()), $6343abee919005ee$var$Qt(e)) {
        var r1 = e.substring(2);
        r1.length % 2 && (t.hexPad === "left" ? r1 = "0" + r1 : t.hexPad === "right" ? r1 += "0" : $6343abee919005ee$var$Dt.throwArgumentError("hex data is odd-length", "value", e));
        var i = [];
        for(var n = 0; n < r1.length; n += 2)i.push(parseInt(r1.substring(n, n + 2), 16));
        return $6343abee919005ee$var$rr(new Uint8Array(i));
    }
    return $6343abee919005ee$var$ir(e) ? $6343abee919005ee$var$rr(new Uint8Array(e)) : $6343abee919005ee$var$Dt.throwArgumentError("invalid arrayify value", "value", e);
}
function $6343abee919005ee$var$Cs(e) {
    var t = e.map(function(n) {
        return $6343abee919005ee$var$Ot(n);
    }), r = t.reduce(function(n, o) {
        return n + o.length;
    }, 0), i = new Uint8Array(r);
    return t.reduce(function(n, o) {
        return i.set(o, n), n + o.length;
    }, 0), $6343abee919005ee$var$rr(i);
}
function $6343abee919005ee$var$Rs(e, t) {
    e = $6343abee919005ee$var$Ot(e), e.length > t && $6343abee919005ee$var$Dt.throwArgumentError("value out of range", "value", arguments[0]);
    var r = new Uint8Array(t);
    return r.set(e, t - e.length), $6343abee919005ee$var$rr(r);
}
function $6343abee919005ee$var$Qt(e, t) {
    return !(typeof e != "string" || !e.match(/^0x[0-9A-Fa-f]*$/) || t && e.length !== 2 + 2 * t);
}
var $6343abee919005ee$var$bi = "0123456789abcdef";
function $6343abee919005ee$var$Kt(e, t) {
    if (t || (t = {}), typeof e == "number") {
        $6343abee919005ee$var$Dt.checkSafeUint53(e, "invalid hexlify value");
        var r = "";
        for(; e;)r = $6343abee919005ee$var$bi[e & 15] + r, e = Math.floor(e / 16);
        return r.length ? (r.length % 2 && (r = "0" + r), "0x" + r) : "0x00";
    }
    if ((typeof e === "undefined" ? "undefined" : (0, $l0HdX._)(e)) == "bigint") return e = e.toString(16), e.length % 2 ? "0x0" + e : "0x" + e;
    if (t.allowMissingPrefix && typeof e == "string" && e.substring(0, 2) !== "0x" && (e = "0x" + e), $6343abee919005ee$var$Kn(e)) return e.toHexString();
    if ($6343abee919005ee$var$Qt(e)) return e.length % 2 && (t.hexPad === "left" ? e = "0x0" + e.substring(2) : t.hexPad === "right" ? e += "0" : $6343abee919005ee$var$Dt.throwArgumentError("hex data is odd-length", "value", e)), e.toLowerCase();
    if ($6343abee919005ee$var$ir(e)) {
        var r1 = "0x";
        for(var i = 0; i < e.length; i++){
            var n = e[i];
            r1 += $6343abee919005ee$var$bi[(n & 240) >> 4] + $6343abee919005ee$var$bi[n & 15];
        }
        return r1;
    }
    return $6343abee919005ee$var$Dt.throwArgumentError("invalid hexlify value", "value", e);
}
function $6343abee919005ee$var$Os(e) {
    if (typeof e != "string") e = $6343abee919005ee$var$Kt(e);
    else if (!$6343abee919005ee$var$Qt(e) || e.length % 2) return null;
    return (e.length - 2) / 2;
}
function $6343abee919005ee$var$zn(e, t, r) {
    return typeof e != "string" ? e = $6343abee919005ee$var$Kt(e) : (!$6343abee919005ee$var$Qt(e) || e.length % 2) && $6343abee919005ee$var$Dt.throwArgumentError("invalid hexData", "value", e), t = 2 + 2 * t, r != null ? "0x" + e.substring(t, 2 + 2 * r) : "0x" + e.substring(t);
}
function $6343abee919005ee$var$oe(e, t) {
    for(typeof e != "string" ? e = $6343abee919005ee$var$Kt(e) : $6343abee919005ee$var$Qt(e) || $6343abee919005ee$var$Dt.throwArgumentError("invalid hex string", "value", e), e.length > 2 * t + 2 && $6343abee919005ee$var$Dt.throwArgumentError("value out of range", "value", arguments[1]); e.length < 2 * t + 2;)e = "0x0" + e.substring(2);
    return e;
}
function $6343abee919005ee$var$Ln(e) {
    var t = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if ($6343abee919005ee$var$Bs(e)) {
        var r = $6343abee919005ee$var$Ot(e);
        r.length === 64 ? (t.v = 27 + (r[32] >> 7), r[32] &= 127, t.r = $6343abee919005ee$var$Kt(r.slice(0, 32)), t.s = $6343abee919005ee$var$Kt(r.slice(32, 64))) : r.length === 65 ? (t.r = $6343abee919005ee$var$Kt(r.slice(0, 32)), t.s = $6343abee919005ee$var$Kt(r.slice(32, 64)), t.v = r[64]) : $6343abee919005ee$var$Dt.throwArgumentError("invalid signature string", "signature", e), t.v < 27 && (t.v === 0 || t.v === 1 ? t.v += 27 : $6343abee919005ee$var$Dt.throwArgumentError("signature invalid v byte", "signature", e)), t.recoveryParam = 1 - t.v % 2, t.recoveryParam && (r[32] |= 128), t._vs = $6343abee919005ee$var$Kt(r.slice(32, 64));
    } else {
        if (t.r = e.r, t.s = e.s, t.v = e.v, t.recoveryParam = e.recoveryParam, t._vs = e._vs, t._vs != null) {
            var n = $6343abee919005ee$var$Rs($6343abee919005ee$var$Ot(t._vs), 32);
            t._vs = $6343abee919005ee$var$Kt(n);
            var o = n[0] >= 128 ? 1 : 0;
            t.recoveryParam == null ? t.recoveryParam = o : t.recoveryParam !== o && $6343abee919005ee$var$Dt.throwArgumentError("signature recoveryParam mismatch _vs", "signature", e), n[0] &= 127;
            var h = $6343abee919005ee$var$Kt(n);
            t.s == null ? t.s = h : t.s !== h && $6343abee919005ee$var$Dt.throwArgumentError("signature v mismatch _vs", "signature", e);
        }
        if (t.recoveryParam == null) t.v == null ? $6343abee919005ee$var$Dt.throwArgumentError("signature missing v and recoveryParam", "signature", e) : t.v === 0 || t.v === 1 ? t.recoveryParam = t.v : t.recoveryParam = 1 - t.v % 2;
        else if (t.v == null) t.v = 27 + t.recoveryParam;
        else {
            var n1 = t.v === 0 || t.v === 1 ? t.v : 1 - t.v % 2;
            t.recoveryParam !== n1 && $6343abee919005ee$var$Dt.throwArgumentError("signature recoveryParam mismatch v", "signature", e);
        }
        t.r == null || !$6343abee919005ee$var$Qt(t.r) ? $6343abee919005ee$var$Dt.throwArgumentError("signature missing or invalid r", "signature", e) : t.r = $6343abee919005ee$var$oe(t.r, 32), t.s == null || !$6343abee919005ee$var$Qt(t.s) ? $6343abee919005ee$var$Dt.throwArgumentError("signature missing or invalid s", "signature", e) : t.s = $6343abee919005ee$var$oe(t.s, 32);
        var r1 = $6343abee919005ee$var$Ot(t.s);
        r1[0] >= 128 && $6343abee919005ee$var$Dt.throwArgumentError("signature s out of range", "signature", e), t.recoveryParam && (r1[0] |= 128);
        var i = $6343abee919005ee$var$Kt(r1);
        t._vs && ($6343abee919005ee$var$Qt(t._vs) || $6343abee919005ee$var$Dt.throwArgumentError("signature invalid _vs", "signature", e), t._vs = $6343abee919005ee$var$oe(t._vs, 32)), t._vs == null ? t._vs = i : t._vs !== i && $6343abee919005ee$var$Dt.throwArgumentError("signature _vs mismatch v and s", "signature", e);
    }
    return t.yParityAndS = t._vs, t.compact = t.r + t.yParityAndS.substring(2), t;
}
function $6343abee919005ee$var$yi(e) {
    return "0x" + $6343abee919005ee$var$Ss.keccak_256($6343abee919005ee$var$Ot(e));
}
var $6343abee919005ee$var$jn = {
    exports: {}
}, $6343abee919005ee$var$Ps = {}, $6343abee919005ee$var$Ds = Object.freeze({
    __proto__: null,
    default: $6343abee919005ee$var$Ps
}), $6343abee919005ee$var$Fs = $6343abee919005ee$var$Es($6343abee919005ee$var$Ds);
(function(e) {
    (function(t, r) {
        function i(b, f) {
            if (!b) throw new Error(f || "Assertion failed");
        }
        function n(b, f) {
            b.super_ = f;
            var a = function a() {};
            a.prototype = f.prototype, b.prototype = new a, b.prototype.constructor = b;
        }
        function o(b, f, a) {
            if (o.isBN(b)) return b;
            this.negative = 0, this.words = null, this.length = 0, this.red = null, b !== null && ((f === "le" || f === "be") && (a = f, f = 10), this._init(b || 0, f || 10, a || "be"));
        }
        typeof t == "object" ? t.exports = o : r.BN = o, o.BN = o, o.wordSize = 26;
        var h;
        try {
            (typeof window === "undefined" ? "undefined" : (0, $l0HdX._)(window)) < "u" && (0, $l0HdX._)(window.Buffer) < "u" ? h = window.Buffer : h = $6343abee919005ee$var$Fs.Buffer;
        } catch (e) {}
        o.isBN = function(f) {
            return f instanceof o ? !0 : f !== null && typeof f == "object" && f.constructor.wordSize === o.wordSize && Array.isArray(f.words);
        }, o.max = function(f, a) {
            return f.cmp(a) > 0 ? f : a;
        }, o.min = function(f, a) {
            return f.cmp(a) < 0 ? f : a;
        }, o.prototype._init = function(f, a, c) {
            if (typeof f == "number") return this._initNumber(f, a, c);
            if (typeof f == "object") return this._initArray(f, a, c);
            a === "hex" && (a = 16), i(a === (a | 0) && a >= 2 && a <= 36), f = f.toString().replace(/\s+/g, "");
            var d = 0;
            f[0] === "-" && (d++, this.negative = 1), d < f.length && (a === 16 ? this._parseHex(f, d, c) : (this._parseBase(f, a, d), c === "le" && this._initArray(this.toArray(), a, c)));
        }, o.prototype._initNumber = function(f, a, c) {
            f < 0 && (this.negative = 1, f = -f), f < 67108864 ? (this.words = [
                f & 67108863
            ], this.length = 1) : f < 4503599627370496 ? (this.words = [
                f & 67108863,
                f / 67108864 & 67108863
            ], this.length = 2) : (i(f < 9007199254740992), this.words = [
                f & 67108863,
                f / 67108864 & 67108863,
                1
            ], this.length = 3), c === "le" && this._initArray(this.toArray(), a, c);
        }, o.prototype._initArray = function(f, a, c) {
            if (i(typeof f.length == "number"), f.length <= 0) return this.words = [
                0
            ], this.length = 1, this;
            this.length = Math.ceil(f.length / 3), this.words = new Array(this.length);
            for(var d = 0; d < this.length; d++)this.words[d] = 0;
            var g, x, M = 0;
            if (c === "be") for(d = f.length - 1, g = 0; d >= 0; d -= 3)x = f[d] | f[d - 1] << 8 | f[d - 2] << 16, this.words[g] |= x << M & 67108863, this.words[g + 1] = x >>> 26 - M & 67108863, M += 24, M >= 26 && (M -= 26, g++);
            else if (c === "le") for(d = 0, g = 0; d < f.length; d += 3)x = f[d] | f[d + 1] << 8 | f[d + 2] << 16, this.words[g] |= x << M & 67108863, this.words[g + 1] = x >>> 26 - M & 67108863, M += 24, M >= 26 && (M -= 26, g++);
            return this._strip();
        };
        function p(b, f) {
            var a = b.charCodeAt(f);
            if (a >= 48 && a <= 57) return a - 48;
            if (a >= 65 && a <= 70) return a - 55;
            if (a >= 97 && a <= 102) return a - 87;
            i(!1, "Invalid character in " + b);
        }
        function A(b, f, a) {
            var c = p(b, a);
            return a - 1 >= f && (c |= p(b, a - 1) << 4), c;
        }
        o.prototype._parseHex = function(f, a, c) {
            this.length = Math.ceil((f.length - a) / 6), this.words = new Array(this.length);
            for(var d = 0; d < this.length; d++)this.words[d] = 0;
            var g = 0, x = 0, M;
            if (c === "be") for(d = f.length - 1; d >= a; d -= 2)M = A(f, a, d) << g, this.words[x] |= M & 67108863, g >= 18 ? (g -= 18, x += 1, this.words[x] |= M >>> 26) : g += 8;
            else {
                var l = f.length - a;
                for(d = l % 2 === 0 ? a + 1 : a; d < f.length; d += 2)M = A(f, a, d) << g, this.words[x] |= M & 67108863, g >= 18 ? (g -= 18, x += 1, this.words[x] |= M >>> 26) : g += 8;
            }
            this._strip();
        };
        function m(b, f, a, c) {
            for(var d = 0, g = 0, x = Math.min(b.length, a), M = f; M < x; M++){
                var l = b.charCodeAt(M) - 48;
                d *= c, l >= 49 ? g = l - 49 + 10 : l >= 17 ? g = l - 17 + 10 : g = l, i(l >= 0 && g < c, "Invalid character"), d += g;
            }
            return d;
        }
        o.prototype._parseBase = function(f, a, c) {
            this.words = [
                0
            ], this.length = 1;
            for(var d = 0, g = 1; g <= 67108863; g *= a)d++;
            d--, g = g / a | 0;
            for(var x = f.length - c, M = x % d, l = Math.min(x, x - M) + c, s = 0, v = c; v < l; v += d)s = m(f, v, v + d, a), this.imuln(g), this.words[0] + s < 67108864 ? this.words[0] += s : this._iaddn(s);
            if (M !== 0) {
                var k = 1;
                for(s = m(f, v, f.length, a), v = 0; v < M; v++)k *= a;
                this.imuln(k), this.words[0] + s < 67108864 ? this.words[0] += s : this._iaddn(s);
            }
            this._strip();
        }, o.prototype.copy = function(f) {
            f.words = new Array(this.length);
            for(var a = 0; a < this.length; a++)f.words[a] = this.words[a];
            f.length = this.length, f.negative = this.negative, f.red = this.red;
        };
        function w(b, f) {
            b.words = f.words, b.length = f.length, b.negative = f.negative, b.red = f.red;
        }
        if (o.prototype._move = function(f) {
            w(f, this);
        }, o.prototype.clone = function() {
            var f = new o(null);
            return this.copy(f), f;
        }, o.prototype._expand = function(f) {
            for(; this.length < f;)this.words[this.length++] = 0;
            return this;
        }, o.prototype._strip = function() {
            for(; this.length > 1 && this.words[this.length - 1] === 0;)this.length--;
            return this._normSign();
        }, o.prototype._normSign = function() {
            return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
        }, (typeof Symbol === "undefined" ? "undefined" : (0, $l0HdX._)(Symbol)) < "u" && typeof Symbol.for == "function") try {
            o.prototype[Symbol.for("nodejs.util.inspect.custom")] = y;
        } catch (e) {
            o.prototype.inspect = y;
        }
        else o.prototype.inspect = y;
        function y() {
            return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
        }
        var S = [
            "",
            "0",
            "00",
            "000",
            "0000",
            "00000",
            "000000",
            "0000000",
            "00000000",
            "000000000",
            "0000000000",
            "00000000000",
            "000000000000",
            "0000000000000",
            "00000000000000",
            "000000000000000",
            "0000000000000000",
            "00000000000000000",
            "000000000000000000",
            "0000000000000000000",
            "00000000000000000000",
            "000000000000000000000",
            "0000000000000000000000",
            "00000000000000000000000",
            "000000000000000000000000",
            "0000000000000000000000000"
        ], I = [
            0,
            0,
            25,
            16,
            12,
            11,
            10,
            9,
            8,
            8,
            7,
            7,
            7,
            7,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5
        ], N = [
            0,
            0,
            33554432,
            43046721,
            16777216,
            48828125,
            60466176,
            40353607,
            16777216,
            43046721,
            1e7,
            19487171,
            35831808,
            62748517,
            7529536,
            11390625,
            16777216,
            24137569,
            34012224,
            47045881,
            64e6,
            4084101,
            5153632,
            6436343,
            7962624,
            9765625,
            11881376,
            14348907,
            17210368,
            20511149,
            243e5,
            28629151,
            33554432,
            39135393,
            45435424,
            52521875,
            60466176
        ];
        o.prototype.toString = function(f, a) {
            f = f || 10, a = a | 0 || 1;
            var c;
            if (f === 16 || f === "hex") {
                c = "";
                for(var d = 0, g = 0, x = 0; x < this.length; x++){
                    var M = this.words[x], l = ((M << d | g) & 16777215).toString(16);
                    g = M >>> 24 - d & 16777215, d += 2, d >= 26 && (d -= 26, x--), g !== 0 || x !== this.length - 1 ? c = S[6 - l.length] + l + c : c = l + c;
                }
                for(g !== 0 && (c = g.toString(16) + c); c.length % a !== 0;)c = "0" + c;
                return this.negative !== 0 && (c = "-" + c), c;
            }
            if (f === (f | 0) && f >= 2 && f <= 36) {
                var s = I[f], v = N[f];
                c = "";
                var k = this.clone();
                for(k.negative = 0; !k.isZero();){
                    var u = k.modrn(v).toString(f);
                    k = k.idivn(v), k.isZero() ? c = u + c : c = S[s - u.length] + u + c;
                }
                for(this.isZero() && (c = "0" + c); c.length % a !== 0;)c = "0" + c;
                return this.negative !== 0 && (c = "-" + c), c;
            }
            i(!1, "Base should be between 2 and 36");
        }, o.prototype.toNumber = function() {
            var f = this.words[0];
            return this.length === 2 ? f += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? f += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -f : f;
        }, o.prototype.toJSON = function() {
            return this.toString(16, 2);
        }, h && (o.prototype.toBuffer = function(f, a) {
            return this.toArrayLike(h, f, a);
        }), o.prototype.toArray = function(f, a) {
            return this.toArrayLike(Array, f, a);
        };
        var C = function C(f, a) {
            return f.allocUnsafe ? f.allocUnsafe(a) : new f(a);
        };
        o.prototype.toArrayLike = function(f, a, c) {
            this._strip();
            var d = this.byteLength(), g = c || Math.max(1, d);
            i(d <= g, "byte array longer than desired length"), i(g > 0, "Requested array length <= 0");
            var x = C(f, g), M = a === "le" ? "LE" : "BE";
            return this["_toArrayLike" + M](x, d), x;
        }, o.prototype._toArrayLikeLE = function(f, a) {
            for(var c = 0, d = 0, g = 0, x = 0; g < this.length; g++){
                var M = this.words[g] << x | d;
                f[c++] = M & 255, c < f.length && (f[c++] = M >> 8 & 255), c < f.length && (f[c++] = M >> 16 & 255), x === 6 ? (c < f.length && (f[c++] = M >> 24 & 255), d = 0, x = 0) : (d = M >>> 24, x += 2);
            }
            if (c < f.length) for(f[c++] = d; c < f.length;)f[c++] = 0;
        }, o.prototype._toArrayLikeBE = function(f, a) {
            for(var c = f.length - 1, d = 0, g = 0, x = 0; g < this.length; g++){
                var M = this.words[g] << x | d;
                f[c--] = M & 255, c >= 0 && (f[c--] = M >> 8 & 255), c >= 0 && (f[c--] = M >> 16 & 255), x === 6 ? (c >= 0 && (f[c--] = M >> 24 & 255), d = 0, x = 0) : (d = M >>> 24, x += 2);
            }
            if (c >= 0) for(f[c--] = d; c >= 0;)f[c--] = 0;
        }, Math.clz32 ? o.prototype._countBits = function(f) {
            return 32 - Math.clz32(f);
        } : o.prototype._countBits = function(f) {
            var a = f, c = 0;
            return a >= 4096 && (c += 13, a >>>= 13), a >= 64 && (c += 7, a >>>= 7), a >= 8 && (c += 4, a >>>= 4), a >= 2 && (c += 2, a >>>= 2), c + a;
        }, o.prototype._zeroBits = function(f) {
            if (f === 0) return 26;
            var a = f, c = 0;
            return a & 8191 || (c += 13, a >>>= 13), a & 127 || (c += 7, a >>>= 7), a & 15 || (c += 4, a >>>= 4), a & 3 || (c += 2, a >>>= 2), a & 1 || c++, c;
        }, o.prototype.bitLength = function() {
            var f = this.words[this.length - 1], a = this._countBits(f);
            return (this.length - 1) * 26 + a;
        };
        function F(b) {
            for(var f = new Array(b.bitLength()), a = 0; a < f.length; a++){
                var c = a / 26 | 0, d = a % 26;
                f[a] = b.words[c] >>> d & 1;
            }
            return f;
        }
        o.prototype.zeroBits = function() {
            if (this.isZero()) return 0;
            for(var f = 0, a = 0; a < this.length; a++){
                var c = this._zeroBits(this.words[a]);
                if (f += c, c !== 26) break;
            }
            return f;
        }, o.prototype.byteLength = function() {
            return Math.ceil(this.bitLength() / 8);
        }, o.prototype.toTwos = function(f) {
            return this.negative !== 0 ? this.abs().inotn(f).iaddn(1) : this.clone();
        }, o.prototype.fromTwos = function(f) {
            return this.testn(f - 1) ? this.notn(f).iaddn(1).ineg() : this.clone();
        }, o.prototype.isNeg = function() {
            return this.negative !== 0;
        }, o.prototype.neg = function() {
            return this.clone().ineg();
        }, o.prototype.ineg = function() {
            return this.isZero() || (this.negative ^= 1), this;
        }, o.prototype.iuor = function(f) {
            for(; this.length < f.length;)this.words[this.length++] = 0;
            for(var a = 0; a < f.length; a++)this.words[a] = this.words[a] | f.words[a];
            return this._strip();
        }, o.prototype.ior = function(f) {
            return i((this.negative | f.negative) === 0), this.iuor(f);
        }, o.prototype.or = function(f) {
            return this.length > f.length ? this.clone().ior(f) : f.clone().ior(this);
        }, o.prototype.uor = function(f) {
            return this.length > f.length ? this.clone().iuor(f) : f.clone().iuor(this);
        }, o.prototype.iuand = function(f) {
            var a;
            this.length > f.length ? a = f : a = this;
            for(var c = 0; c < a.length; c++)this.words[c] = this.words[c] & f.words[c];
            return this.length = a.length, this._strip();
        }, o.prototype.iand = function(f) {
            return i((this.negative | f.negative) === 0), this.iuand(f);
        }, o.prototype.and = function(f) {
            return this.length > f.length ? this.clone().iand(f) : f.clone().iand(this);
        }, o.prototype.uand = function(f) {
            return this.length > f.length ? this.clone().iuand(f) : f.clone().iuand(this);
        }, o.prototype.iuxor = function(f) {
            var a, c;
            this.length > f.length ? (a = this, c = f) : (a = f, c = this);
            for(var d = 0; d < c.length; d++)this.words[d] = a.words[d] ^ c.words[d];
            if (this !== a) for(; d < a.length; d++)this.words[d] = a.words[d];
            return this.length = a.length, this._strip();
        }, o.prototype.ixor = function(f) {
            return i((this.negative | f.negative) === 0), this.iuxor(f);
        }, o.prototype.xor = function(f) {
            return this.length > f.length ? this.clone().ixor(f) : f.clone().ixor(this);
        }, o.prototype.uxor = function(f) {
            return this.length > f.length ? this.clone().iuxor(f) : f.clone().iuxor(this);
        }, o.prototype.inotn = function(f) {
            i(typeof f == "number" && f >= 0);
            var a = Math.ceil(f / 26) | 0, c = f % 26;
            this._expand(a), c > 0 && a--;
            for(var d = 0; d < a; d++)this.words[d] = ~this.words[d] & 67108863;
            return c > 0 && (this.words[d] = ~this.words[d] & 67108863 >> 26 - c), this._strip();
        }, o.prototype.notn = function(f) {
            return this.clone().inotn(f);
        }, o.prototype.setn = function(f, a) {
            i(typeof f == "number" && f >= 0);
            var c = f / 26 | 0, d = f % 26;
            return this._expand(c + 1), a ? this.words[c] = this.words[c] | 1 << d : this.words[c] = this.words[c] & ~(1 << d), this._strip();
        }, o.prototype.iadd = function(f) {
            var a;
            if (this.negative !== 0 && f.negative === 0) return this.negative = 0, a = this.isub(f), this.negative ^= 1, this._normSign();
            if (this.negative === 0 && f.negative !== 0) return f.negative = 0, a = this.isub(f), f.negative = 1, a._normSign();
            var c, d;
            this.length > f.length ? (c = this, d = f) : (c = f, d = this);
            for(var g = 0, x = 0; x < d.length; x++)a = (c.words[x] | 0) + (d.words[x] | 0) + g, this.words[x] = a & 67108863, g = a >>> 26;
            for(; g !== 0 && x < c.length; x++)a = (c.words[x] | 0) + g, this.words[x] = a & 67108863, g = a >>> 26;
            if (this.length = c.length, g !== 0) this.words[this.length] = g, this.length++;
            else if (c !== this) for(; x < c.length; x++)this.words[x] = c.words[x];
            return this;
        }, o.prototype.add = function(f) {
            var a;
            return f.negative !== 0 && this.negative === 0 ? (f.negative = 0, a = this.sub(f), f.negative ^= 1, a) : f.negative === 0 && this.negative !== 0 ? (this.negative = 0, a = f.sub(this), this.negative = 1, a) : this.length > f.length ? this.clone().iadd(f) : f.clone().iadd(this);
        }, o.prototype.isub = function(f) {
            if (f.negative !== 0) {
                f.negative = 0;
                var a = this.iadd(f);
                return f.negative = 1, a._normSign();
            } else if (this.negative !== 0) return this.negative = 0, this.iadd(f), this.negative = 1, this._normSign();
            var c = this.cmp(f);
            if (c === 0) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
            var d, g;
            c > 0 ? (d = this, g = f) : (d = f, g = this);
            for(var x = 0, M = 0; M < g.length; M++)a = (d.words[M] | 0) - (g.words[M] | 0) + x, x = a >> 26, this.words[M] = a & 67108863;
            for(; x !== 0 && M < d.length; M++)a = (d.words[M] | 0) + x, x = a >> 26, this.words[M] = a & 67108863;
            if (x === 0 && M < d.length && d !== this) for(; M < d.length; M++)this.words[M] = d.words[M];
            return this.length = Math.max(this.length, M), d !== this && (this.negative = 1), this._strip();
        }, o.prototype.sub = function(f) {
            return this.clone().isub(f);
        };
        function U(b, f, a) {
            a.negative = f.negative ^ b.negative;
            var c = b.length + f.length | 0;
            a.length = c, c = c - 1 | 0;
            var d = b.words[0] | 0, g = f.words[0] | 0, x = d * g, M = x & 67108863, l = x / 67108864 | 0;
            a.words[0] = M;
            for(var s = 1; s < c; s++){
                for(var v = l >>> 26, k = l & 67108863, u = Math.min(s, f.length - 1), E = Math.max(0, s - b.length + 1); E <= u; E++){
                    var _ = s - E | 0;
                    d = b.words[_] | 0, g = f.words[E] | 0, x = d * g + k, v += x / 67108864 | 0, k = x & 67108863;
                }
                a.words[s] = k | 0, l = v | 0;
            }
            return l !== 0 ? a.words[s] = l | 0 : a.length--, a._strip();
        }
        var J = function J(f, a, c) {
            var d = f.words, g = a.words, x = c.words, M = 0, l, s, v, k = d[0] | 0, u = k & 8191, E = k >>> 13, _ = d[1] | 0, B = _ & 8191, R = _ >>> 13, T = d[2] | 0, P = T & 8191, O = T >>> 13, Ct = d[3] | 0, D = Ct & 8191, q = Ct >>> 13, De = d[4] | 0, X = De & 8191, Z = De >>> 13, Fe = d[5] | 0, $ = Fe & 8191, tt = Fe >>> 13, Te = d[6] | 0, et = Te & 8191, rt = Te >>> 13, Ue = d[7] | 0, it = Ue & 8191, nt = Ue >>> 13, ke = d[8] | 0, ft = ke & 8191, ot = ke >>> 13, qe = d[9] | 0, st = qe & 8191, at = qe >>> 13, Ke = g[0] | 0, ut = Ke & 8191, ht = Ke >>> 13, He = g[1] | 0, ct = He & 8191, lt = He >>> 13, ze = g[2] | 0, dt = ze & 8191, pt = ze >>> 13, Le = g[3] | 0, vt = Le & 8191, mt = Le >>> 13, je = g[4] | 0, gt = je & 8191, At = je >>> 13, Qe = g[5] | 0, bt = Qe & 8191, yt = Qe >>> 13, Je = g[6] | 0, wt = Je & 8191, xt = Je >>> 13, Ge = g[7] | 0, Mt = Ge & 8191, Et = Ge >>> 13, Ye = g[8] | 0, St = Ye & 8191, Nt = Ye >>> 13, Ve = g[9] | 0, It = Ve & 8191, _t = Ve >>> 13;
            c.negative = f.negative ^ a.negative, c.length = 19, l = Math.imul(u, ut), s = Math.imul(u, ht), s = s + Math.imul(E, ut) | 0, v = Math.imul(E, ht);
            var Me = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, l = Math.imul(B, ut), s = Math.imul(B, ht), s = s + Math.imul(R, ut) | 0, v = Math.imul(R, ht), l = l + Math.imul(u, ct) | 0, s = s + Math.imul(u, lt) | 0, s = s + Math.imul(E, ct) | 0, v = v + Math.imul(E, lt) | 0;
            var Ee = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, l = Math.imul(P, ut), s = Math.imul(P, ht), s = s + Math.imul(O, ut) | 0, v = Math.imul(O, ht), l = l + Math.imul(B, ct) | 0, s = s + Math.imul(B, lt) | 0, s = s + Math.imul(R, ct) | 0, v = v + Math.imul(R, lt) | 0, l = l + Math.imul(u, dt) | 0, s = s + Math.imul(u, pt) | 0, s = s + Math.imul(E, dt) | 0, v = v + Math.imul(E, pt) | 0;
            var Se = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, l = Math.imul(D, ut), s = Math.imul(D, ht), s = s + Math.imul(q, ut) | 0, v = Math.imul(q, ht), l = l + Math.imul(P, ct) | 0, s = s + Math.imul(P, lt) | 0, s = s + Math.imul(O, ct) | 0, v = v + Math.imul(O, lt) | 0, l = l + Math.imul(B, dt) | 0, s = s + Math.imul(B, pt) | 0, s = s + Math.imul(R, dt) | 0, v = v + Math.imul(R, pt) | 0, l = l + Math.imul(u, vt) | 0, s = s + Math.imul(u, mt) | 0, s = s + Math.imul(E, vt) | 0, v = v + Math.imul(E, mt) | 0;
            var Ne = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Ne >>> 26) | 0, Ne &= 67108863, l = Math.imul(X, ut), s = Math.imul(X, ht), s = s + Math.imul(Z, ut) | 0, v = Math.imul(Z, ht), l = l + Math.imul(D, ct) | 0, s = s + Math.imul(D, lt) | 0, s = s + Math.imul(q, ct) | 0, v = v + Math.imul(q, lt) | 0, l = l + Math.imul(P, dt) | 0, s = s + Math.imul(P, pt) | 0, s = s + Math.imul(O, dt) | 0, v = v + Math.imul(O, pt) | 0, l = l + Math.imul(B, vt) | 0, s = s + Math.imul(B, mt) | 0, s = s + Math.imul(R, vt) | 0, v = v + Math.imul(R, mt) | 0, l = l + Math.imul(u, gt) | 0, s = s + Math.imul(u, At) | 0, s = s + Math.imul(E, gt) | 0, v = v + Math.imul(E, At) | 0;
            var Ie = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863, l = Math.imul($, ut), s = Math.imul($, ht), s = s + Math.imul(tt, ut) | 0, v = Math.imul(tt, ht), l = l + Math.imul(X, ct) | 0, s = s + Math.imul(X, lt) | 0, s = s + Math.imul(Z, ct) | 0, v = v + Math.imul(Z, lt) | 0, l = l + Math.imul(D, dt) | 0, s = s + Math.imul(D, pt) | 0, s = s + Math.imul(q, dt) | 0, v = v + Math.imul(q, pt) | 0, l = l + Math.imul(P, vt) | 0, s = s + Math.imul(P, mt) | 0, s = s + Math.imul(O, vt) | 0, v = v + Math.imul(O, mt) | 0, l = l + Math.imul(B, gt) | 0, s = s + Math.imul(B, At) | 0, s = s + Math.imul(R, gt) | 0, v = v + Math.imul(R, At) | 0, l = l + Math.imul(u, bt) | 0, s = s + Math.imul(u, yt) | 0, s = s + Math.imul(E, bt) | 0, v = v + Math.imul(E, yt) | 0;
            var Wr = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Wr >>> 26) | 0, Wr &= 67108863, l = Math.imul(et, ut), s = Math.imul(et, ht), s = s + Math.imul(rt, ut) | 0, v = Math.imul(rt, ht), l = l + Math.imul($, ct) | 0, s = s + Math.imul($, lt) | 0, s = s + Math.imul(tt, ct) | 0, v = v + Math.imul(tt, lt) | 0, l = l + Math.imul(X, dt) | 0, s = s + Math.imul(X, pt) | 0, s = s + Math.imul(Z, dt) | 0, v = v + Math.imul(Z, pt) | 0, l = l + Math.imul(D, vt) | 0, s = s + Math.imul(D, mt) | 0, s = s + Math.imul(q, vt) | 0, v = v + Math.imul(q, mt) | 0, l = l + Math.imul(P, gt) | 0, s = s + Math.imul(P, At) | 0, s = s + Math.imul(O, gt) | 0, v = v + Math.imul(O, At) | 0, l = l + Math.imul(B, bt) | 0, s = s + Math.imul(B, yt) | 0, s = s + Math.imul(R, bt) | 0, v = v + Math.imul(R, yt) | 0, l = l + Math.imul(u, wt) | 0, s = s + Math.imul(u, xt) | 0, s = s + Math.imul(E, wt) | 0, v = v + Math.imul(E, xt) | 0;
            var Xr = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Xr >>> 26) | 0, Xr &= 67108863, l = Math.imul(it, ut), s = Math.imul(it, ht), s = s + Math.imul(nt, ut) | 0, v = Math.imul(nt, ht), l = l + Math.imul(et, ct) | 0, s = s + Math.imul(et, lt) | 0, s = s + Math.imul(rt, ct) | 0, v = v + Math.imul(rt, lt) | 0, l = l + Math.imul($, dt) | 0, s = s + Math.imul($, pt) | 0, s = s + Math.imul(tt, dt) | 0, v = v + Math.imul(tt, pt) | 0, l = l + Math.imul(X, vt) | 0, s = s + Math.imul(X, mt) | 0, s = s + Math.imul(Z, vt) | 0, v = v + Math.imul(Z, mt) | 0, l = l + Math.imul(D, gt) | 0, s = s + Math.imul(D, At) | 0, s = s + Math.imul(q, gt) | 0, v = v + Math.imul(q, At) | 0, l = l + Math.imul(P, bt) | 0, s = s + Math.imul(P, yt) | 0, s = s + Math.imul(O, bt) | 0, v = v + Math.imul(O, yt) | 0, l = l + Math.imul(B, wt) | 0, s = s + Math.imul(B, xt) | 0, s = s + Math.imul(R, wt) | 0, v = v + Math.imul(R, xt) | 0, l = l + Math.imul(u, Mt) | 0, s = s + Math.imul(u, Et) | 0, s = s + Math.imul(E, Mt) | 0, v = v + Math.imul(E, Et) | 0;
            var Zr = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Zr >>> 26) | 0, Zr &= 67108863, l = Math.imul(ft, ut), s = Math.imul(ft, ht), s = s + Math.imul(ot, ut) | 0, v = Math.imul(ot, ht), l = l + Math.imul(it, ct) | 0, s = s + Math.imul(it, lt) | 0, s = s + Math.imul(nt, ct) | 0, v = v + Math.imul(nt, lt) | 0, l = l + Math.imul(et, dt) | 0, s = s + Math.imul(et, pt) | 0, s = s + Math.imul(rt, dt) | 0, v = v + Math.imul(rt, pt) | 0, l = l + Math.imul($, vt) | 0, s = s + Math.imul($, mt) | 0, s = s + Math.imul(tt, vt) | 0, v = v + Math.imul(tt, mt) | 0, l = l + Math.imul(X, gt) | 0, s = s + Math.imul(X, At) | 0, s = s + Math.imul(Z, gt) | 0, v = v + Math.imul(Z, At) | 0, l = l + Math.imul(D, bt) | 0, s = s + Math.imul(D, yt) | 0, s = s + Math.imul(q, bt) | 0, v = v + Math.imul(q, yt) | 0, l = l + Math.imul(P, wt) | 0, s = s + Math.imul(P, xt) | 0, s = s + Math.imul(O, wt) | 0, v = v + Math.imul(O, xt) | 0, l = l + Math.imul(B, Mt) | 0, s = s + Math.imul(B, Et) | 0, s = s + Math.imul(R, Mt) | 0, v = v + Math.imul(R, Et) | 0, l = l + Math.imul(u, St) | 0, s = s + Math.imul(u, Nt) | 0, s = s + Math.imul(E, St) | 0, v = v + Math.imul(E, Nt) | 0;
            var $r = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + ($r >>> 26) | 0, $r &= 67108863, l = Math.imul(st, ut), s = Math.imul(st, ht), s = s + Math.imul(at, ut) | 0, v = Math.imul(at, ht), l = l + Math.imul(ft, ct) | 0, s = s + Math.imul(ft, lt) | 0, s = s + Math.imul(ot, ct) | 0, v = v + Math.imul(ot, lt) | 0, l = l + Math.imul(it, dt) | 0, s = s + Math.imul(it, pt) | 0, s = s + Math.imul(nt, dt) | 0, v = v + Math.imul(nt, pt) | 0, l = l + Math.imul(et, vt) | 0, s = s + Math.imul(et, mt) | 0, s = s + Math.imul(rt, vt) | 0, v = v + Math.imul(rt, mt) | 0, l = l + Math.imul($, gt) | 0, s = s + Math.imul($, At) | 0, s = s + Math.imul(tt, gt) | 0, v = v + Math.imul(tt, At) | 0, l = l + Math.imul(X, bt) | 0, s = s + Math.imul(X, yt) | 0, s = s + Math.imul(Z, bt) | 0, v = v + Math.imul(Z, yt) | 0, l = l + Math.imul(D, wt) | 0, s = s + Math.imul(D, xt) | 0, s = s + Math.imul(q, wt) | 0, v = v + Math.imul(q, xt) | 0, l = l + Math.imul(P, Mt) | 0, s = s + Math.imul(P, Et) | 0, s = s + Math.imul(O, Mt) | 0, v = v + Math.imul(O, Et) | 0, l = l + Math.imul(B, St) | 0, s = s + Math.imul(B, Nt) | 0, s = s + Math.imul(R, St) | 0, v = v + Math.imul(R, Nt) | 0, l = l + Math.imul(u, It) | 0, s = s + Math.imul(u, _t) | 0, s = s + Math.imul(E, It) | 0, v = v + Math.imul(E, _t) | 0;
            var ti = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (ti >>> 26) | 0, ti &= 67108863, l = Math.imul(st, ct), s = Math.imul(st, lt), s = s + Math.imul(at, ct) | 0, v = Math.imul(at, lt), l = l + Math.imul(ft, dt) | 0, s = s + Math.imul(ft, pt) | 0, s = s + Math.imul(ot, dt) | 0, v = v + Math.imul(ot, pt) | 0, l = l + Math.imul(it, vt) | 0, s = s + Math.imul(it, mt) | 0, s = s + Math.imul(nt, vt) | 0, v = v + Math.imul(nt, mt) | 0, l = l + Math.imul(et, gt) | 0, s = s + Math.imul(et, At) | 0, s = s + Math.imul(rt, gt) | 0, v = v + Math.imul(rt, At) | 0, l = l + Math.imul($, bt) | 0, s = s + Math.imul($, yt) | 0, s = s + Math.imul(tt, bt) | 0, v = v + Math.imul(tt, yt) | 0, l = l + Math.imul(X, wt) | 0, s = s + Math.imul(X, xt) | 0, s = s + Math.imul(Z, wt) | 0, v = v + Math.imul(Z, xt) | 0, l = l + Math.imul(D, Mt) | 0, s = s + Math.imul(D, Et) | 0, s = s + Math.imul(q, Mt) | 0, v = v + Math.imul(q, Et) | 0, l = l + Math.imul(P, St) | 0, s = s + Math.imul(P, Nt) | 0, s = s + Math.imul(O, St) | 0, v = v + Math.imul(O, Nt) | 0, l = l + Math.imul(B, It) | 0, s = s + Math.imul(B, _t) | 0, s = s + Math.imul(R, It) | 0, v = v + Math.imul(R, _t) | 0;
            var ei = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (ei >>> 26) | 0, ei &= 67108863, l = Math.imul(st, dt), s = Math.imul(st, pt), s = s + Math.imul(at, dt) | 0, v = Math.imul(at, pt), l = l + Math.imul(ft, vt) | 0, s = s + Math.imul(ft, mt) | 0, s = s + Math.imul(ot, vt) | 0, v = v + Math.imul(ot, mt) | 0, l = l + Math.imul(it, gt) | 0, s = s + Math.imul(it, At) | 0, s = s + Math.imul(nt, gt) | 0, v = v + Math.imul(nt, At) | 0, l = l + Math.imul(et, bt) | 0, s = s + Math.imul(et, yt) | 0, s = s + Math.imul(rt, bt) | 0, v = v + Math.imul(rt, yt) | 0, l = l + Math.imul($, wt) | 0, s = s + Math.imul($, xt) | 0, s = s + Math.imul(tt, wt) | 0, v = v + Math.imul(tt, xt) | 0, l = l + Math.imul(X, Mt) | 0, s = s + Math.imul(X, Et) | 0, s = s + Math.imul(Z, Mt) | 0, v = v + Math.imul(Z, Et) | 0, l = l + Math.imul(D, St) | 0, s = s + Math.imul(D, Nt) | 0, s = s + Math.imul(q, St) | 0, v = v + Math.imul(q, Nt) | 0, l = l + Math.imul(P, It) | 0, s = s + Math.imul(P, _t) | 0, s = s + Math.imul(O, It) | 0, v = v + Math.imul(O, _t) | 0;
            var ri = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (ri >>> 26) | 0, ri &= 67108863, l = Math.imul(st, vt), s = Math.imul(st, mt), s = s + Math.imul(at, vt) | 0, v = Math.imul(at, mt), l = l + Math.imul(ft, gt) | 0, s = s + Math.imul(ft, At) | 0, s = s + Math.imul(ot, gt) | 0, v = v + Math.imul(ot, At) | 0, l = l + Math.imul(it, bt) | 0, s = s + Math.imul(it, yt) | 0, s = s + Math.imul(nt, bt) | 0, v = v + Math.imul(nt, yt) | 0, l = l + Math.imul(et, wt) | 0, s = s + Math.imul(et, xt) | 0, s = s + Math.imul(rt, wt) | 0, v = v + Math.imul(rt, xt) | 0, l = l + Math.imul($, Mt) | 0, s = s + Math.imul($, Et) | 0, s = s + Math.imul(tt, Mt) | 0, v = v + Math.imul(tt, Et) | 0, l = l + Math.imul(X, St) | 0, s = s + Math.imul(X, Nt) | 0, s = s + Math.imul(Z, St) | 0, v = v + Math.imul(Z, Nt) | 0, l = l + Math.imul(D, It) | 0, s = s + Math.imul(D, _t) | 0, s = s + Math.imul(q, It) | 0, v = v + Math.imul(q, _t) | 0;
            var ii = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (ii >>> 26) | 0, ii &= 67108863, l = Math.imul(st, gt), s = Math.imul(st, At), s = s + Math.imul(at, gt) | 0, v = Math.imul(at, At), l = l + Math.imul(ft, bt) | 0, s = s + Math.imul(ft, yt) | 0, s = s + Math.imul(ot, bt) | 0, v = v + Math.imul(ot, yt) | 0, l = l + Math.imul(it, wt) | 0, s = s + Math.imul(it, xt) | 0, s = s + Math.imul(nt, wt) | 0, v = v + Math.imul(nt, xt) | 0, l = l + Math.imul(et, Mt) | 0, s = s + Math.imul(et, Et) | 0, s = s + Math.imul(rt, Mt) | 0, v = v + Math.imul(rt, Et) | 0, l = l + Math.imul($, St) | 0, s = s + Math.imul($, Nt) | 0, s = s + Math.imul(tt, St) | 0, v = v + Math.imul(tt, Nt) | 0, l = l + Math.imul(X, It) | 0, s = s + Math.imul(X, _t) | 0, s = s + Math.imul(Z, It) | 0, v = v + Math.imul(Z, _t) | 0;
            var ni = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (ni >>> 26) | 0, ni &= 67108863, l = Math.imul(st, bt), s = Math.imul(st, yt), s = s + Math.imul(at, bt) | 0, v = Math.imul(at, yt), l = l + Math.imul(ft, wt) | 0, s = s + Math.imul(ft, xt) | 0, s = s + Math.imul(ot, wt) | 0, v = v + Math.imul(ot, xt) | 0, l = l + Math.imul(it, Mt) | 0, s = s + Math.imul(it, Et) | 0, s = s + Math.imul(nt, Mt) | 0, v = v + Math.imul(nt, Et) | 0, l = l + Math.imul(et, St) | 0, s = s + Math.imul(et, Nt) | 0, s = s + Math.imul(rt, St) | 0, v = v + Math.imul(rt, Nt) | 0, l = l + Math.imul($, It) | 0, s = s + Math.imul($, _t) | 0, s = s + Math.imul(tt, It) | 0, v = v + Math.imul(tt, _t) | 0;
            var fi = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (fi >>> 26) | 0, fi &= 67108863, l = Math.imul(st, wt), s = Math.imul(st, xt), s = s + Math.imul(at, wt) | 0, v = Math.imul(at, xt), l = l + Math.imul(ft, Mt) | 0, s = s + Math.imul(ft, Et) | 0, s = s + Math.imul(ot, Mt) | 0, v = v + Math.imul(ot, Et) | 0, l = l + Math.imul(it, St) | 0, s = s + Math.imul(it, Nt) | 0, s = s + Math.imul(nt, St) | 0, v = v + Math.imul(nt, Nt) | 0, l = l + Math.imul(et, It) | 0, s = s + Math.imul(et, _t) | 0, s = s + Math.imul(rt, It) | 0, v = v + Math.imul(rt, _t) | 0;
            var oi = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (oi >>> 26) | 0, oi &= 67108863, l = Math.imul(st, Mt), s = Math.imul(st, Et), s = s + Math.imul(at, Mt) | 0, v = Math.imul(at, Et), l = l + Math.imul(ft, St) | 0, s = s + Math.imul(ft, Nt) | 0, s = s + Math.imul(ot, St) | 0, v = v + Math.imul(ot, Nt) | 0, l = l + Math.imul(it, It) | 0, s = s + Math.imul(it, _t) | 0, s = s + Math.imul(nt, It) | 0, v = v + Math.imul(nt, _t) | 0;
            var si = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (si >>> 26) | 0, si &= 67108863, l = Math.imul(st, St), s = Math.imul(st, Nt), s = s + Math.imul(at, St) | 0, v = Math.imul(at, Nt), l = l + Math.imul(ft, It) | 0, s = s + Math.imul(ft, _t) | 0, s = s + Math.imul(ot, It) | 0, v = v + Math.imul(ot, _t) | 0;
            var ai = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (ai >>> 26) | 0, ai &= 67108863, l = Math.imul(st, It), s = Math.imul(st, _t), s = s + Math.imul(at, It) | 0, v = Math.imul(at, _t);
            var ui = (M + l | 0) + ((s & 8191) << 13) | 0;
            return M = (v + (s >>> 13) | 0) + (ui >>> 26) | 0, ui &= 67108863, x[0] = Me, x[1] = Ee, x[2] = Se, x[3] = Ne, x[4] = Ie, x[5] = Wr, x[6] = Xr, x[7] = Zr, x[8] = $r, x[9] = ti, x[10] = ei, x[11] = ri, x[12] = ii, x[13] = ni, x[14] = fi, x[15] = oi, x[16] = si, x[17] = ai, x[18] = ui, M !== 0 && (x[19] = M, c.length++), c;
        };
        Math.imul || (J = U);
        function Bt(b, f, a) {
            a.negative = f.negative ^ b.negative, a.length = b.length + f.length;
            for(var c = 0, d = 0, g = 0; g < a.length - 1; g++){
                var x = d;
                d = 0;
                for(var M = c & 67108863, l = Math.min(g, f.length - 1), s = Math.max(0, g - b.length + 1); s <= l; s++){
                    var v = g - s, k = b.words[v] | 0, u = f.words[s] | 0, E = k * u, _ = E & 67108863;
                    x = x + (E / 67108864 | 0) | 0, _ = _ + M | 0, M = _ & 67108863, x = x + (_ >>> 26) | 0, d += x >>> 26, x &= 67108863;
                }
                a.words[g] = M, c = x, x = d;
            }
            return c !== 0 ? a.words[g] = c : a.length--, a._strip();
        }
        function G(b, f, a) {
            return Bt(b, f, a);
        }
        o.prototype.mulTo = function(f, a) {
            var c, d = this.length + f.length;
            return this.length === 10 && f.length === 10 ? c = J(this, f, a) : d < 63 ? c = U(this, f, a) : d < 1024 ? c = Bt(this, f, a) : c = G(this, f, a), c;
        }, o.prototype.mul = function(f) {
            var a = new o(null);
            return a.words = new Array(this.length + f.length), this.mulTo(f, a);
        }, o.prototype.mulf = function(f) {
            var a = new o(null);
            return a.words = new Array(this.length + f.length), G(this, f, a);
        }, o.prototype.imul = function(f) {
            return this.clone().mulTo(f, this);
        }, o.prototype.imuln = function(f) {
            var a = f < 0;
            a && (f = -f), i(typeof f == "number"), i(f < 67108864);
            for(var c = 0, d = 0; d < this.length; d++){
                var g = (this.words[d] | 0) * f, x = (g & 67108863) + (c & 67108863);
                c >>= 26, c += g / 67108864 | 0, c += x >>> 26, this.words[d] = x & 67108863;
            }
            return c !== 0 && (this.words[d] = c, this.length++), a ? this.ineg() : this;
        }, o.prototype.muln = function(f) {
            return this.clone().imuln(f);
        }, o.prototype.sqr = function() {
            return this.mul(this);
        }, o.prototype.isqr = function() {
            return this.imul(this.clone());
        }, o.prototype.pow = function(f) {
            var a = F(f);
            if (a.length === 0) return new o(1);
            for(var c = this, d = 0; d < a.length && a[d] === 0; d++, c = c.sqr());
            if (++d < a.length) for(var g = c.sqr(); d < a.length; d++, g = g.sqr())a[d] !== 0 && (c = c.mul(g));
            return c;
        }, o.prototype.iushln = function(f) {
            i(typeof f == "number" && f >= 0);
            var a = f % 26, c = (f - a) / 26, d = 67108863 >>> 26 - a << 26 - a, g;
            if (a !== 0) {
                var x = 0;
                for(g = 0; g < this.length; g++){
                    var M = this.words[g] & d, l = (this.words[g] | 0) - M << a;
                    this.words[g] = l | x, x = M >>> 26 - a;
                }
                x && (this.words[g] = x, this.length++);
            }
            if (c !== 0) {
                for(g = this.length - 1; g >= 0; g--)this.words[g + c] = this.words[g];
                for(g = 0; g < c; g++)this.words[g] = 0;
                this.length += c;
            }
            return this._strip();
        }, o.prototype.ishln = function(f) {
            return i(this.negative === 0), this.iushln(f);
        }, o.prototype.iushrn = function(f, a, c) {
            i(typeof f == "number" && f >= 0);
            var d;
            a ? d = (a - a % 26) / 26 : d = 0;
            var g = f % 26, x = Math.min((f - g) / 26, this.length), M = 67108863 ^ 67108863 >>> g << g, l = c;
            if (d -= x, d = Math.max(0, d), l) {
                for(var s = 0; s < x; s++)l.words[s] = this.words[s];
                l.length = x;
            }
            if (x !== 0) {
                if (this.length > x) for(this.length -= x, s = 0; s < this.length; s++)this.words[s] = this.words[s + x];
                else this.words[0] = 0, this.length = 1;
            }
            var v = 0;
            for(s = this.length - 1; s >= 0 && (v !== 0 || s >= d); s--){
                var k = this.words[s] | 0;
                this.words[s] = v << 26 - g | k >>> g, v = k & M;
            }
            return l && v !== 0 && (l.words[l.length++] = v), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
        }, o.prototype.ishrn = function(f, a, c) {
            return i(this.negative === 0), this.iushrn(f, a, c);
        }, o.prototype.shln = function(f) {
            return this.clone().ishln(f);
        }, o.prototype.ushln = function(f) {
            return this.clone().iushln(f);
        }, o.prototype.shrn = function(f) {
            return this.clone().ishrn(f);
        }, o.prototype.ushrn = function(f) {
            return this.clone().iushrn(f);
        }, o.prototype.testn = function(f) {
            i(typeof f == "number" && f >= 0);
            var a = f % 26, c = (f - a) / 26, d = 1 << a;
            if (this.length <= c) return !1;
            var g = this.words[c];
            return !!(g & d);
        }, o.prototype.imaskn = function(f) {
            i(typeof f == "number" && f >= 0);
            var a = f % 26, c = (f - a) / 26;
            if (i(this.negative === 0, "imaskn works only with positive numbers"), this.length <= c) return this;
            if (a !== 0 && c++, this.length = Math.min(c, this.length), a !== 0) {
                var d = 67108863 ^ 67108863 >>> a << a;
                this.words[this.length - 1] &= d;
            }
            return this._strip();
        }, o.prototype.maskn = function(f) {
            return this.clone().imaskn(f);
        }, o.prototype.iaddn = function(f) {
            return i(typeof f == "number"), i(f < 67108864), f < 0 ? this.isubn(-f) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= f ? (this.words[0] = f - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(f), this.negative = 1, this) : this._iaddn(f);
        }, o.prototype._iaddn = function(f) {
            this.words[0] += f;
            for(var a = 0; a < this.length && this.words[a] >= 67108864; a++)this.words[a] -= 67108864, a === this.length - 1 ? this.words[a + 1] = 1 : this.words[a + 1]++;
            return this.length = Math.max(this.length, a + 1), this;
        }, o.prototype.isubn = function(f) {
            if (i(typeof f == "number"), i(f < 67108864), f < 0) return this.iaddn(-f);
            if (this.negative !== 0) return this.negative = 0, this.iaddn(f), this.negative = 1, this;
            if (this.words[0] -= f, this.length === 1 && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;
            else for(var a = 0; a < this.length && this.words[a] < 0; a++)this.words[a] += 67108864, this.words[a + 1] -= 1;
            return this._strip();
        }, o.prototype.addn = function(f) {
            return this.clone().iaddn(f);
        }, o.prototype.subn = function(f) {
            return this.clone().isubn(f);
        }, o.prototype.iabs = function() {
            return this.negative = 0, this;
        }, o.prototype.abs = function() {
            return this.clone().iabs();
        }, o.prototype._ishlnsubmul = function(f, a, c) {
            var d = f.length + c, g;
            this._expand(d);
            var x, M = 0;
            for(g = 0; g < f.length; g++){
                x = (this.words[g + c] | 0) + M;
                var l = (f.words[g] | 0) * a;
                x -= l & 67108863, M = (x >> 26) - (l / 67108864 | 0), this.words[g + c] = x & 67108863;
            }
            for(; g < this.length - c; g++)x = (this.words[g + c] | 0) + M, M = x >> 26, this.words[g + c] = x & 67108863;
            if (M === 0) return this._strip();
            for(i(M === -1), M = 0, g = 0; g < this.length; g++)x = -(this.words[g] | 0) + M, M = x >> 26, this.words[g] = x & 67108863;
            return this.negative = 1, this._strip();
        }, o.prototype._wordDiv = function(f, a) {
            var c = this.length - f.length, d = this.clone(), g = f, x = g.words[g.length - 1] | 0, M = this._countBits(x);
            c = 26 - M, c !== 0 && (g = g.ushln(c), d.iushln(c), x = g.words[g.length - 1] | 0);
            var l = d.length - g.length, s;
            if (a !== "mod") {
                s = new o(null), s.length = l + 1, s.words = new Array(s.length);
                for(var v = 0; v < s.length; v++)s.words[v] = 0;
            }
            var k = d.clone()._ishlnsubmul(g, 1, l);
            k.negative === 0 && (d = k, s && (s.words[l] = 1));
            for(var u = l - 1; u >= 0; u--){
                var E = (d.words[g.length + u] | 0) * 67108864 + (d.words[g.length + u - 1] | 0);
                for(E = Math.min(E / x | 0, 67108863), d._ishlnsubmul(g, E, u); d.negative !== 0;)E--, d.negative = 0, d._ishlnsubmul(g, 1, u), d.isZero() || (d.negative ^= 1);
                s && (s.words[u] = E);
            }
            return s && s._strip(), d._strip(), a !== "div" && c !== 0 && d.iushrn(c), {
                div: s || null,
                mod: d
            };
        }, o.prototype.divmod = function(f, a, c) {
            if (i(!f.isZero()), this.isZero()) return {
                div: new o(0),
                mod: new o(0)
            };
            var d, g, x;
            return this.negative !== 0 && f.negative === 0 ? (x = this.neg().divmod(f, a), a !== "mod" && (d = x.div.neg()), a !== "div" && (g = x.mod.neg(), c && g.negative !== 0 && g.iadd(f)), {
                div: d,
                mod: g
            }) : this.negative === 0 && f.negative !== 0 ? (x = this.divmod(f.neg(), a), a !== "mod" && (d = x.div.neg()), {
                div: d,
                mod: x.mod
            }) : this.negative & f.negative ? (x = this.neg().divmod(f.neg(), a), a !== "div" && (g = x.mod.neg(), c && g.negative !== 0 && g.isub(f)), {
                div: x.div,
                mod: g
            }) : f.length > this.length || this.cmp(f) < 0 ? {
                div: new o(0),
                mod: this
            } : f.length === 1 ? a === "div" ? {
                div: this.divn(f.words[0]),
                mod: null
            } : a === "mod" ? {
                div: null,
                mod: new o(this.modrn(f.words[0]))
            } : {
                div: this.divn(f.words[0]),
                mod: new o(this.modrn(f.words[0]))
            } : this._wordDiv(f, a);
        }, o.prototype.div = function(f) {
            return this.divmod(f, "div", !1).div;
        }, o.prototype.mod = function(f) {
            return this.divmod(f, "mod", !1).mod;
        }, o.prototype.umod = function(f) {
            return this.divmod(f, "mod", !0).mod;
        }, o.prototype.divRound = function(f) {
            var a = this.divmod(f);
            if (a.mod.isZero()) return a.div;
            var c = a.div.negative !== 0 ? a.mod.isub(f) : a.mod, d = f.ushrn(1), g = f.andln(1), x = c.cmp(d);
            return x < 0 || g === 1 && x === 0 ? a.div : a.div.negative !== 0 ? a.div.isubn(1) : a.div.iaddn(1);
        }, o.prototype.modrn = function(f) {
            var a = f < 0;
            a && (f = -f), i(f <= 67108863);
            for(var c = 67108864 % f, d = 0, g = this.length - 1; g >= 0; g--)d = (c * d + (this.words[g] | 0)) % f;
            return a ? -d : d;
        }, o.prototype.modn = function(f) {
            return this.modrn(f);
        }, o.prototype.idivn = function(f) {
            var a = f < 0;
            a && (f = -f), i(f <= 67108863);
            for(var c = 0, d = this.length - 1; d >= 0; d--){
                var g = (this.words[d] | 0) + c * 67108864;
                this.words[d] = g / f | 0, c = g % f;
            }
            return this._strip(), a ? this.ineg() : this;
        }, o.prototype.divn = function(f) {
            return this.clone().idivn(f);
        }, o.prototype.egcd = function(f) {
            i(f.negative === 0), i(!f.isZero());
            var a = this, c = f.clone();
            a.negative !== 0 ? a = a.umod(f) : a = a.clone();
            for(var d = new o(1), g = new o(0), x = new o(0), M = new o(1), l = 0; a.isEven() && c.isEven();)a.iushrn(1), c.iushrn(1), ++l;
            for(var s = c.clone(), v = a.clone(); !a.isZero();){
                for(var k = 0, u = 1; !(a.words[0] & u) && k < 26; ++k, u <<= 1);
                if (k > 0) for(a.iushrn(k); k-- > 0;)(d.isOdd() || g.isOdd()) && (d.iadd(s), g.isub(v)), d.iushrn(1), g.iushrn(1);
                for(var E = 0, _ = 1; !(c.words[0] & _) && E < 26; ++E, _ <<= 1);
                if (E > 0) for(c.iushrn(E); E-- > 0;)(x.isOdd() || M.isOdd()) && (x.iadd(s), M.isub(v)), x.iushrn(1), M.iushrn(1);
                a.cmp(c) >= 0 ? (a.isub(c), d.isub(x), g.isub(M)) : (c.isub(a), x.isub(d), M.isub(g));
            }
            return {
                a: x,
                b: M,
                gcd: c.iushln(l)
            };
        }, o.prototype._invmp = function(f) {
            i(f.negative === 0), i(!f.isZero());
            var a = this, c = f.clone();
            a.negative !== 0 ? a = a.umod(f) : a = a.clone();
            for(var d = new o(1), g = new o(0), x = c.clone(); a.cmpn(1) > 0 && c.cmpn(1) > 0;){
                for(var M = 0, l = 1; !(a.words[0] & l) && M < 26; ++M, l <<= 1);
                if (M > 0) for(a.iushrn(M); M-- > 0;)d.isOdd() && d.iadd(x), d.iushrn(1);
                for(var s = 0, v = 1; !(c.words[0] & v) && s < 26; ++s, v <<= 1);
                if (s > 0) for(c.iushrn(s); s-- > 0;)g.isOdd() && g.iadd(x), g.iushrn(1);
                a.cmp(c) >= 0 ? (a.isub(c), d.isub(g)) : (c.isub(a), g.isub(d));
            }
            var k;
            return a.cmpn(1) === 0 ? k = d : k = g, k.cmpn(0) < 0 && k.iadd(f), k;
        }, o.prototype.gcd = function(f) {
            if (this.isZero()) return f.abs();
            if (f.isZero()) return this.abs();
            var a = this.clone(), c = f.clone();
            a.negative = 0, c.negative = 0;
            for(var d = 0; a.isEven() && c.isEven(); d++)a.iushrn(1), c.iushrn(1);
            do {
                for(; a.isEven();)a.iushrn(1);
                for(; c.isEven();)c.iushrn(1);
                var g = a.cmp(c);
                if (g < 0) {
                    var x = a;
                    a = c, c = x;
                } else if (g === 0 || c.cmpn(1) === 0) break;
                a.isub(c);
            }while (!0);
            return c.iushln(d);
        }, o.prototype.invm = function(f) {
            return this.egcd(f).a.umod(f);
        }, o.prototype.isEven = function() {
            return (this.words[0] & 1) === 0;
        }, o.prototype.isOdd = function() {
            return (this.words[0] & 1) === 1;
        }, o.prototype.andln = function(f) {
            return this.words[0] & f;
        }, o.prototype.bincn = function(f) {
            i(typeof f == "number");
            var a = f % 26, c = (f - a) / 26, d = 1 << a;
            if (this.length <= c) return this._expand(c + 1), this.words[c] |= d, this;
            for(var g = d, x = c; g !== 0 && x < this.length; x++){
                var M = this.words[x] | 0;
                M += g, g = M >>> 26, M &= 67108863, this.words[x] = M;
            }
            return g !== 0 && (this.words[x] = g, this.length++), this;
        }, o.prototype.isZero = function() {
            return this.length === 1 && this.words[0] === 0;
        }, o.prototype.cmpn = function(f) {
            var a = f < 0;
            if (this.negative !== 0 && !a) return -1;
            if (this.negative === 0 && a) return 1;
            this._strip();
            var c;
            if (this.length > 1) c = 1;
            else {
                a && (f = -f), i(f <= 67108863, "Number is too big");
                var d = this.words[0] | 0;
                c = d === f ? 0 : d < f ? -1 : 1;
            }
            return this.negative !== 0 ? -c | 0 : c;
        }, o.prototype.cmp = function(f) {
            if (this.negative !== 0 && f.negative === 0) return -1;
            if (this.negative === 0 && f.negative !== 0) return 1;
            var a = this.ucmp(f);
            return this.negative !== 0 ? -a | 0 : a;
        }, o.prototype.ucmp = function(f) {
            if (this.length > f.length) return 1;
            if (this.length < f.length) return -1;
            for(var a = 0, c = this.length - 1; c >= 0; c--){
                var d = this.words[c] | 0, g = f.words[c] | 0;
                if (d !== g) {
                    d < g ? a = -1 : d > g && (a = 1);
                    break;
                }
            }
            return a;
        }, o.prototype.gtn = function(f) {
            return this.cmpn(f) === 1;
        }, o.prototype.gt = function(f) {
            return this.cmp(f) === 1;
        }, o.prototype.gten = function(f) {
            return this.cmpn(f) >= 0;
        }, o.prototype.gte = function(f) {
            return this.cmp(f) >= 0;
        }, o.prototype.ltn = function(f) {
            return this.cmpn(f) === -1;
        }, o.prototype.lt = function(f) {
            return this.cmp(f) === -1;
        }, o.prototype.lten = function(f) {
            return this.cmpn(f) <= 0;
        }, o.prototype.lte = function(f) {
            return this.cmp(f) <= 0;
        }, o.prototype.eqn = function(f) {
            return this.cmpn(f) === 0;
        }, o.prototype.eq = function(f) {
            return this.cmp(f) === 0;
        }, o.red = function(f) {
            return new Y(f);
        }, o.prototype.toRed = function(f) {
            return i(!this.red, "Already a number in reduction context"), i(this.negative === 0, "red works only with positives"), f.convertTo(this)._forceRed(f);
        }, o.prototype.fromRed = function() {
            return i(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
        }, o.prototype._forceRed = function(f) {
            return this.red = f, this;
        }, o.prototype.forceRed = function(f) {
            return i(!this.red, "Already a number in reduction context"), this._forceRed(f);
        }, o.prototype.redAdd = function(f) {
            return i(this.red, "redAdd works only with red numbers"), this.red.add(this, f);
        }, o.prototype.redIAdd = function(f) {
            return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, f);
        }, o.prototype.redSub = function(f) {
            return i(this.red, "redSub works only with red numbers"), this.red.sub(this, f);
        }, o.prototype.redISub = function(f) {
            return i(this.red, "redISub works only with red numbers"), this.red.isub(this, f);
        }, o.prototype.redShl = function(f) {
            return i(this.red, "redShl works only with red numbers"), this.red.shl(this, f);
        }, o.prototype.redMul = function(f) {
            return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, f), this.red.mul(this, f);
        }, o.prototype.redIMul = function(f) {
            return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, f), this.red.imul(this, f);
        }, o.prototype.redSqr = function() {
            return i(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
        }, o.prototype.redISqr = function() {
            return i(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
        }, o.prototype.redSqrt = function() {
            return i(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
        }, o.prototype.redInvm = function() {
            return i(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
        }, o.prototype.redNeg = function() {
            return i(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
        }, o.prototype.redPow = function(f) {
            return i(this.red && !f.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, f);
        };
        var H = {
            k256: null,
            p224: null,
            p192: null,
            p25519: null
        };
        function z(b, f) {
            this.name = b, this.p = new o(f, 16), this.n = this.p.bitLength(), this.k = new o(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
        }
        z.prototype._tmp = function() {
            var f = new o(null);
            return f.words = new Array(Math.ceil(this.n / 13)), f;
        }, z.prototype.ireduce = function(f) {
            var a = f, c;
            do this.split(a, this.tmp), a = this.imulK(a), a = a.iadd(this.tmp), c = a.bitLength();
            while (c > this.n);
            var d = c < this.n ? -1 : a.ucmp(this.p);
            return d === 0 ? (a.words[0] = 0, a.length = 1) : d > 0 ? a.isub(this.p) : a.strip !== void 0 ? a.strip() : a._strip(), a;
        }, z.prototype.split = function(f, a) {
            f.iushrn(this.n, 0, a);
        }, z.prototype.imulK = function(f) {
            return f.imul(this.k);
        };
        function Pt() {
            z.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
        }
        n(Pt, z), Pt.prototype.split = function(f, a) {
            for(var c = 4194303, d = Math.min(f.length, 9), g = 0; g < d; g++)a.words[g] = f.words[g];
            if (a.length = d, f.length <= 9) {
                f.words[0] = 0, f.length = 1;
                return;
            }
            var x = f.words[9];
            for(a.words[a.length++] = x & c, g = 10; g < f.length; g++){
                var M = f.words[g] | 0;
                f.words[g - 10] = (M & c) << 4 | x >>> 22, x = M;
            }
            x >>>= 22, f.words[g - 10] = x, x === 0 && f.length > 10 ? f.length -= 10 : f.length -= 9;
        }, Pt.prototype.imulK = function(f) {
            f.words[f.length] = 0, f.words[f.length + 1] = 0, f.length += 2;
            for(var a = 0, c = 0; c < f.length; c++){
                var d = f.words[c] | 0;
                a += d * 977, f.words[c] = a & 67108863, a = d * 64 + (a / 67108864 | 0);
            }
            return f.words[f.length - 1] === 0 && (f.length--, f.words[f.length - 1] === 0 && f.length--), f;
        };
        function W() {
            z.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
        }
        n(W, z);
        function Rt() {
            z.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
        }
        n(Rt, z);
        function Yt() {
            z.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
        }
        n(Yt, z), Yt.prototype.imulK = function(f) {
            for(var a = 0, c = 0; c < f.length; c++){
                var d = (f.words[c] | 0) * 19 + a, g = d & 67108863;
                d >>>= 26, f.words[c] = g, a = d;
            }
            return a !== 0 && (f.words[f.length++] = a), f;
        }, o._prime = function(f) {
            if (H[f]) return H[f];
            var a;
            if (f === "k256") a = new Pt;
            else if (f === "p224") a = new W;
            else if (f === "p192") a = new Rt;
            else if (f === "p25519") a = new Yt;
            else throw new Error("Unknown prime " + f);
            return H[f] = a, a;
        };
        function Y(b) {
            if (typeof b == "string") {
                var f = o._prime(b);
                this.m = f.p, this.prime = f;
            } else i(b.gtn(1), "modulus must be greater than 1"), this.m = b, this.prime = null;
        }
        Y.prototype._verify1 = function(f) {
            i(f.negative === 0, "red works only with positives"), i(f.red, "red works only with red numbers");
        }, Y.prototype._verify2 = function(f, a) {
            i((f.negative | a.negative) === 0, "red works only with positives"), i(f.red && f.red === a.red, "red works only with red numbers");
        }, Y.prototype.imod = function(f) {
            return this.prime ? this.prime.ireduce(f)._forceRed(this) : (w(f, f.umod(this.m)._forceRed(this)), f);
        }, Y.prototype.neg = function(f) {
            return f.isZero() ? f.clone() : this.m.sub(f)._forceRed(this);
        }, Y.prototype.add = function(f, a) {
            this._verify2(f, a);
            var c = f.add(a);
            return c.cmp(this.m) >= 0 && c.isub(this.m), c._forceRed(this);
        }, Y.prototype.iadd = function(f, a) {
            this._verify2(f, a);
            var c = f.iadd(a);
            return c.cmp(this.m) >= 0 && c.isub(this.m), c;
        }, Y.prototype.sub = function(f, a) {
            this._verify2(f, a);
            var c = f.sub(a);
            return c.cmpn(0) < 0 && c.iadd(this.m), c._forceRed(this);
        }, Y.prototype.isub = function(f, a) {
            this._verify2(f, a);
            var c = f.isub(a);
            return c.cmpn(0) < 0 && c.iadd(this.m), c;
        }, Y.prototype.shl = function(f, a) {
            return this._verify1(f), this.imod(f.ushln(a));
        }, Y.prototype.imul = function(f, a) {
            return this._verify2(f, a), this.imod(f.imul(a));
        }, Y.prototype.mul = function(f, a) {
            return this._verify2(f, a), this.imod(f.mul(a));
        }, Y.prototype.isqr = function(f) {
            return this.imul(f, f.clone());
        }, Y.prototype.sqr = function(f) {
            return this.mul(f, f);
        }, Y.prototype.sqrt = function(f) {
            if (f.isZero()) return f.clone();
            var a = this.m.andln(3);
            if (i(a % 2 === 1), a === 3) {
                var c = this.m.add(new o(1)).iushrn(2);
                return this.pow(f, c);
            }
            for(var d = this.m.subn(1), g = 0; !d.isZero() && d.andln(1) === 0;)g++, d.iushrn(1);
            i(!d.isZero());
            var x = new o(1).toRed(this), M = x.redNeg(), l = this.m.subn(1).iushrn(1), s = this.m.bitLength();
            for(s = new o(2 * s * s).toRed(this); this.pow(s, l).cmp(M) !== 0;)s.redIAdd(M);
            for(var v = this.pow(s, d), k = this.pow(f, d.addn(1).iushrn(1)), u = this.pow(f, d), E = g; u.cmp(x) !== 0;){
                for(var _ = u, B = 0; _.cmp(x) !== 0; B++)_ = _.redSqr();
                i(B < E);
                var R = this.pow(v, new o(1).iushln(E - B - 1));
                k = k.redMul(R), v = R.redSqr(), u = u.redMul(v), E = B;
            }
            return k;
        }, Y.prototype.invm = function(f) {
            var a = f._invmp(this.m);
            return a.negative !== 0 ? (a.negative = 0, this.imod(a).redNeg()) : this.imod(a);
        }, Y.prototype.pow = function(f, a) {
            if (a.isZero()) return new o(1).toRed(this);
            if (a.cmpn(1) === 0) return f.clone();
            var c = 4, d = new Array(1 << c);
            d[0] = new o(1).toRed(this), d[1] = f;
            for(var g = 2; g < d.length; g++)d[g] = this.mul(d[g - 1], f);
            var x = d[0], M = 0, l = 0, s = a.bitLength() % 26;
            for(s === 0 && (s = 26), g = a.length - 1; g >= 0; g--){
                for(var v = a.words[g], k = s - 1; k >= 0; k--){
                    var u = v >> k & 1;
                    if (x !== d[0] && (x = this.sqr(x)), u === 0 && M === 0) {
                        l = 0;
                        continue;
                    }
                    M <<= 1, M |= u, l++, !(l !== c && (g !== 0 || k !== 0)) && (x = this.mul(x, d[M]), l = 0, M = 0);
                }
                s = 26;
            }
            return x;
        }, Y.prototype.convertTo = function(f) {
            var a = f.umod(this.m);
            return a === f ? a.clone() : a;
        }, Y.prototype.convertFrom = function(f) {
            var a = f.clone();
            return a.red = null, a;
        }, o.mont = function(f) {
            return new Vt(f);
        };
        function Vt(b) {
            Y.call(this, b), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new o(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
        }
        n(Vt, Y), Vt.prototype.convertTo = function(f) {
            return this.imod(f.ushln(this.shift));
        }, Vt.prototype.convertFrom = function(f) {
            var a = this.imod(f.mul(this.rinv));
            return a.red = null, a;
        }, Vt.prototype.imul = function(f, a) {
            if (f.isZero() || a.isZero()) return f.words[0] = 0, f.length = 1, f;
            var c = f.imul(a), d = c.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), g = c.isub(d).iushrn(this.shift), x = g;
            return g.cmp(this.m) >= 0 ? x = g.isub(this.m) : g.cmpn(0) < 0 && (x = g.iadd(this.m)), x._forceRed(this);
        }, Vt.prototype.mul = function(f, a) {
            if (f.isZero() || a.isZero()) return new o(0)._forceRed(this);
            var c = f.mul(a), d = c.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), g = c.isub(d).iushrn(this.shift), x = g;
            return g.cmp(this.m) >= 0 ? x = g.isub(this.m) : g.cmpn(0) < 0 && (x = g.iadd(this.m)), x._forceRed(this);
        }, Vt.prototype.invm = function(f) {
            var a = this.imod(f._invmp(this.m).mul(this.r2));
            return a._forceRed(this);
        };
    })(e, $6343abee919005ee$var$Pn);
})($6343abee919005ee$var$jn);
var $6343abee919005ee$var$K = $6343abee919005ee$var$jn.exports;
var $6343abee919005ee$var$Qn = "bignumber/5.7.0";
var $6343abee919005ee$var$Rr = $6343abee919005ee$var$K.BN;
var $6343abee919005ee$var$Ae = new $6343abee919005ee$var$L($6343abee919005ee$var$Qn), $6343abee919005ee$var$wi = {}, $6343abee919005ee$var$Jn = 9007199254740991;
function $6343abee919005ee$var$Ts(e) {
    return e != null && ($6343abee919005ee$var$V.isBigNumber(e) || typeof e == "number" && e % 1 === 0 || typeof e == "string" && !!e.match(/^-?[0-9]+$/) || $6343abee919005ee$var$Qt(e) || (typeof e === "undefined" ? "undefined" : (0, $l0HdX._)(e)) == "bigint" || $6343abee919005ee$var$ir(e));
}
var $6343abee919005ee$var$Gn = !1;
var $6343abee919005ee$var$V = /*#__PURE__*/ function() {
    "use strict";
    function V(t, r) {
        (0, $4GJKx._)(this, V);
        t !== $6343abee919005ee$var$wi && $6343abee919005ee$var$Ae.throwError("cannot call constructor directly; use BigNumber.from", $6343abee919005ee$var$L.errors.UNSUPPORTED_OPERATION, {
            operation: "new (BigNumber)"
        }), this._hex = r, this._isBigNumber = !0, Object.freeze(this);
    }
    (0, $1wc17._)(V, [
        {
            key: "fromTwos",
            value: function fromTwos(t) {
                return $6343abee919005ee$var$Lt($6343abee919005ee$var$j(this).fromTwos(t));
            }
        },
        {
            key: "toTwos",
            value: function toTwos(t) {
                return $6343abee919005ee$var$Lt($6343abee919005ee$var$j(this).toTwos(t));
            }
        },
        {
            key: "abs",
            value: function abs() {
                return this._hex[0] === "-" ? V.from(this._hex.substring(1)) : this;
            }
        },
        {
            key: "add",
            value: function add(t) {
                return $6343abee919005ee$var$Lt($6343abee919005ee$var$j(this).add($6343abee919005ee$var$j(t)));
            }
        },
        {
            key: "sub",
            value: function sub(t) {
                return $6343abee919005ee$var$Lt($6343abee919005ee$var$j(this).sub($6343abee919005ee$var$j(t)));
            }
        },
        {
            key: "div",
            value: function div(t) {
                return V.from(t).isZero() && $6343abee919005ee$var$Wt("division-by-zero", "div"), $6343abee919005ee$var$Lt($6343abee919005ee$var$j(this).div($6343abee919005ee$var$j(t)));
            }
        },
        {
            key: "mul",
            value: function mul(t) {
                return $6343abee919005ee$var$Lt($6343abee919005ee$var$j(this).mul($6343abee919005ee$var$j(t)));
            }
        },
        {
            key: "mod",
            value: function mod(t) {
                var r = $6343abee919005ee$var$j(t);
                return r.isNeg() && $6343abee919005ee$var$Wt("division-by-zero", "mod"), $6343abee919005ee$var$Lt($6343abee919005ee$var$j(this).umod(r));
            }
        },
        {
            key: "pow",
            value: function pow(t) {
                var r = $6343abee919005ee$var$j(t);
                return r.isNeg() && $6343abee919005ee$var$Wt("negative-power", "pow"), $6343abee919005ee$var$Lt($6343abee919005ee$var$j(this).pow(r));
            }
        },
        {
            key: "and",
            value: function and(t) {
                var r = $6343abee919005ee$var$j(t);
                return (this.isNegative() || r.isNeg()) && $6343abee919005ee$var$Wt("unbound-bitwise-result", "and"), $6343abee919005ee$var$Lt($6343abee919005ee$var$j(this).and(r));
            }
        },
        {
            key: "or",
            value: function or(t) {
                var r = $6343abee919005ee$var$j(t);
                return (this.isNegative() || r.isNeg()) && $6343abee919005ee$var$Wt("unbound-bitwise-result", "or"), $6343abee919005ee$var$Lt($6343abee919005ee$var$j(this).or(r));
            }
        },
        {
            key: "xor",
            value: function xor(t) {
                var r = $6343abee919005ee$var$j(t);
                return (this.isNegative() || r.isNeg()) && $6343abee919005ee$var$Wt("unbound-bitwise-result", "xor"), $6343abee919005ee$var$Lt($6343abee919005ee$var$j(this).xor(r));
            }
        },
        {
            key: "mask",
            value: function mask(t) {
                return (this.isNegative() || t < 0) && $6343abee919005ee$var$Wt("negative-width", "mask"), $6343abee919005ee$var$Lt($6343abee919005ee$var$j(this).maskn(t));
            }
        },
        {
            key: "shl",
            value: function shl(t) {
                return (this.isNegative() || t < 0) && $6343abee919005ee$var$Wt("negative-width", "shl"), $6343abee919005ee$var$Lt($6343abee919005ee$var$j(this).shln(t));
            }
        },
        {
            key: "shr",
            value: function shr(t) {
                return (this.isNegative() || t < 0) && $6343abee919005ee$var$Wt("negative-width", "shr"), $6343abee919005ee$var$Lt($6343abee919005ee$var$j(this).shrn(t));
            }
        },
        {
            key: "eq",
            value: function eq(t) {
                return $6343abee919005ee$var$j(this).eq($6343abee919005ee$var$j(t));
            }
        },
        {
            key: "lt",
            value: function lt(t) {
                return $6343abee919005ee$var$j(this).lt($6343abee919005ee$var$j(t));
            }
        },
        {
            key: "lte",
            value: function lte(t) {
                return $6343abee919005ee$var$j(this).lte($6343abee919005ee$var$j(t));
            }
        },
        {
            key: "gt",
            value: function gt(t) {
                return $6343abee919005ee$var$j(this).gt($6343abee919005ee$var$j(t));
            }
        },
        {
            key: "gte",
            value: function gte(t) {
                return $6343abee919005ee$var$j(this).gte($6343abee919005ee$var$j(t));
            }
        },
        {
            key: "isNegative",
            value: function isNegative() {
                return this._hex[0] === "-";
            }
        },
        {
            key: "isZero",
            value: function isZero() {
                return $6343abee919005ee$var$j(this).isZero();
            }
        },
        {
            key: "toNumber",
            value: function toNumber() {
                try {
                    return $6343abee919005ee$var$j(this).toNumber();
                } catch (e) {
                    $6343abee919005ee$var$Wt("overflow", "toNumber", this.toString());
                }
                return null;
            }
        },
        {
            key: "toBigInt",
            value: function toBigInt() {
                try {
                    return BigInt(this.toString());
                } catch (e) {}
                return $6343abee919005ee$var$Ae.throwError("this platform does not support BigInt", $6343abee919005ee$var$L.errors.UNSUPPORTED_OPERATION, {
                    value: this.toString()
                });
            }
        },
        {
            key: "toString",
            value: function toString() {
                return arguments.length > 0 && (arguments[0] === 10 ? $6343abee919005ee$var$Gn || ($6343abee919005ee$var$Gn = !0, $6343abee919005ee$var$Ae.warn("BigNumber.toString does not accept any parameters; base-10 is assumed")) : arguments[0] === 16 ? $6343abee919005ee$var$Ae.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", $6343abee919005ee$var$L.errors.UNEXPECTED_ARGUMENT, {}) : $6343abee919005ee$var$Ae.throwError("BigNumber.toString does not accept parameters", $6343abee919005ee$var$L.errors.UNEXPECTED_ARGUMENT, {})), $6343abee919005ee$var$j(this).toString(10);
            }
        },
        {
            key: "toHexString",
            value: function toHexString() {
                return this._hex;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(t) {
                return {
                    type: "BigNumber",
                    hex: this.toHexString()
                };
            }
        }
    ], [
        {
            key: "from",
            value: function from(t) {
                if (t instanceof V) return t;
                if (typeof t == "string") return t.match(/^-?0x[0-9a-f]+$/i) ? new V($6343abee919005ee$var$wi, $6343abee919005ee$var$vr(t)) : t.match(/^-?[0-9]+$/) ? new V($6343abee919005ee$var$wi, $6343abee919005ee$var$vr(new $6343abee919005ee$var$Rr(t))) : $6343abee919005ee$var$Ae.throwArgumentError("invalid BigNumber string", "value", t);
                if (typeof t == "number") return t % 1 && $6343abee919005ee$var$Wt("underflow", "BigNumber.from", t), (t >= $6343abee919005ee$var$Jn || t <= -$6343abee919005ee$var$Jn) && $6343abee919005ee$var$Wt("overflow", "BigNumber.from", t), V.from(String(t));
                var r = t;
                if ((typeof r === "undefined" ? "undefined" : (0, $l0HdX._)(r)) == "bigint") return V.from(r.toString());
                if ($6343abee919005ee$var$ir(r)) return V.from($6343abee919005ee$var$Kt(r));
                if (r) {
                    if (r.toHexString) {
                        var i = r.toHexString();
                        if (typeof i == "string") return V.from(i);
                    } else {
                        var i1 = r._hex;
                        if (i1 == null && r.type === "BigNumber" && (i1 = r.hex), typeof i1 == "string" && ($6343abee919005ee$var$Qt(i1) || i1[0] === "-" && $6343abee919005ee$var$Qt(i1.substring(1)))) return V.from(i1);
                    }
                }
                return $6343abee919005ee$var$Ae.throwArgumentError("invalid BigNumber value", "value", t);
            }
        },
        {
            key: "isBigNumber",
            value: function isBigNumber(t) {
                return !!(t && t._isBigNumber);
            }
        }
    ]);
    return V;
}();
function $6343abee919005ee$var$vr(e) {
    if (typeof e != "string") return $6343abee919005ee$var$vr(e.toString(16));
    if (e[0] === "-") return e = e.substring(1), e[0] === "-" && $6343abee919005ee$var$Ae.throwArgumentError("invalid hex", "value", e), e = $6343abee919005ee$var$vr(e), e === "0x00" ? e : "-" + e;
    if (e.substring(0, 2) !== "0x" && (e = "0x" + e), e === "0x") return "0x00";
    for(e.length % 2 && (e = "0x0" + e.substring(2)); e.length > 4 && e.substring(0, 4) === "0x00";)e = "0x" + e.substring(4);
    return e;
}
function $6343abee919005ee$var$Lt(e) {
    return $6343abee919005ee$var$V.from($6343abee919005ee$var$vr(e));
}
function $6343abee919005ee$var$j(e) {
    var t = $6343abee919005ee$var$V.from(e).toHexString();
    return t[0] === "-" ? new $6343abee919005ee$var$Rr("-" + t.substring(3), 16) : new $6343abee919005ee$var$Rr(t.substring(2), 16);
}
function $6343abee919005ee$var$Wt(e, t, r) {
    var i = {
        fault: e,
        operation: t
    };
    return r != null && (i.value = r), $6343abee919005ee$var$Ae.throwError(e, $6343abee919005ee$var$L.errors.NUMERIC_FAULT, i);
}
function $6343abee919005ee$var$Us(e) {
    return new $6343abee919005ee$var$Rr(e, 36).toString(16);
}
var $6343abee919005ee$var$Ht = new $6343abee919005ee$var$L($6343abee919005ee$var$Qn), $6343abee919005ee$var$mr = {}, $6343abee919005ee$var$Yn = $6343abee919005ee$var$V.from(0), $6343abee919005ee$var$Vn = $6343abee919005ee$var$V.from(-1);
function $6343abee919005ee$var$Wn(e, t, r, i) {
    var n = {
        fault: t,
        operation: r
    };
    return i !== void 0 && (n.value = i), $6343abee919005ee$var$Ht.throwError(e, $6343abee919005ee$var$L.errors.NUMERIC_FAULT, n);
}
var $6343abee919005ee$var$gr = "0";
for(; $6343abee919005ee$var$gr.length < 256;)$6343abee919005ee$var$gr += $6343abee919005ee$var$gr;
function $6343abee919005ee$var$xi(e) {
    if (typeof e != "number") try {
        e = $6343abee919005ee$var$V.from(e).toNumber();
    } catch (e) {}
    return typeof e == "number" && e >= 0 && e <= 256 && !(e % 1) ? "1" + $6343abee919005ee$var$gr.substring(0, e) : $6343abee919005ee$var$Ht.throwArgumentError("invalid decimal size", "decimals", e);
}
function $6343abee919005ee$var$Mi(e, t) {
    t == null && (t = 0);
    var r = $6343abee919005ee$var$xi(t);
    e = $6343abee919005ee$var$V.from(e);
    var i = e.lt($6343abee919005ee$var$Yn);
    i && (e = e.mul($6343abee919005ee$var$Vn));
    var n = e.mod(r).toString();
    for(; n.length < r.length - 1;)n = "0" + n;
    n = n.match(/^([0-9]*[1-9]|0)(0*)/)[1];
    var o = e.div(r).toString();
    return r.length === 1 ? e = o : e = o + "." + n, i && (e = "-" + e), e;
}
function $6343abee919005ee$var$be(e, t) {
    t == null && (t = 0);
    var r = $6343abee919005ee$var$xi(t);
    (typeof e != "string" || !e.match(/^-?[0-9.]+$/)) && $6343abee919005ee$var$Ht.throwArgumentError("invalid decimal value", "value", e);
    var i = e.substring(0, 1) === "-";
    i && (e = e.substring(1)), e === "." && $6343abee919005ee$var$Ht.throwArgumentError("missing value", "value", e);
    var n = e.split(".");
    n.length > 2 && $6343abee919005ee$var$Ht.throwArgumentError("too many decimal points", "value", e);
    var o = n[0], h = n[1];
    for(o || (o = "0"), h || (h = "0"); h[h.length - 1] === "0";)h = h.substring(0, h.length - 1);
    for(h.length > r.length - 1 && $6343abee919005ee$var$Wn("fractional component exceeds decimals", "underflow", "parseFixed"), h === "" && (h = "0"); h.length < r.length - 1;)h += "0";
    var p = $6343abee919005ee$var$V.from(o), A = $6343abee919005ee$var$V.from(h);
    var m = p.mul(r).add(A);
    return i && (m = m.mul($6343abee919005ee$var$Vn)), m;
}
var $6343abee919005ee$var$dr = /*#__PURE__*/ function() {
    "use strict";
    function dr(t, r, i, n) {
        (0, $4GJKx._)(this, dr);
        t !== $6343abee919005ee$var$mr && $6343abee919005ee$var$Ht.throwError("cannot use FixedFormat constructor; use FixedFormat.from", $6343abee919005ee$var$L.errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        }), this.signed = r, this.width = i, this.decimals = n, this.name = (r ? "" : "u") + "fixed" + String(i) + "x" + String(n), this._multiplier = $6343abee919005ee$var$xi(n), Object.freeze(this);
    }
    (0, $1wc17._)(dr, null, [
        {
            key: "from",
            value: function from(t) {
                if (t instanceof dr) return t;
                typeof t == "number" && (t = "fixed128x".concat(t));
                var r = !0, i = 128, n = 18;
                if (typeof t == "string") {
                    if (t !== "fixed") {
                        if (t === "ufixed") r = !1;
                        else {
                            var o = t.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
                            o || $6343abee919005ee$var$Ht.throwArgumentError("invalid fixed format", "format", t), r = o[1] !== "u", i = parseInt(o[2]), n = parseInt(o[3]);
                        }
                    }
                } else if (t) {
                    var o1 = function(h, p, A) {
                        return t[h] == null ? A : ((0, $l0HdX._)(t[h]) !== p && $6343abee919005ee$var$Ht.throwArgumentError("invalid fixed format (" + h + " not " + p + ")", "format." + h, t[h]), t[h]);
                    };
                    r = o1("signed", "boolean", r), i = o1("width", "number", i), n = o1("decimals", "number", n);
                }
                return i % 8 && $6343abee919005ee$var$Ht.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", i), n > 80 && $6343abee919005ee$var$Ht.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", n), new dr($6343abee919005ee$var$mr, r, i, n);
            }
        }
    ]);
    return dr;
}();
var $6343abee919005ee$var$Ut = /*#__PURE__*/ function() {
    "use strict";
    function Ut(t, r, i, n) {
        (0, $4GJKx._)(this, Ut);
        t !== $6343abee919005ee$var$mr && $6343abee919005ee$var$Ht.throwError("cannot use FixedNumber constructor; use FixedNumber.from", $6343abee919005ee$var$L.errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        }), this.format = n, this._hex = r, this._value = i, this._isFixedNumber = !0, Object.freeze(this);
    }
    (0, $1wc17._)(Ut, [
        {
            key: "_checkFormat",
            value: function _checkFormat(t) {
                this.format.name !== t.format.name && $6343abee919005ee$var$Ht.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", t);
            }
        },
        {
            key: "addUnsafe",
            value: function addUnsafe(t) {
                this._checkFormat(t);
                var r = $6343abee919005ee$var$be(this._value, this.format.decimals), i = $6343abee919005ee$var$be(t._value, t.format.decimals);
                return Ut.fromValue(r.add(i), this.format.decimals, this.format);
            }
        },
        {
            key: "subUnsafe",
            value: function subUnsafe(t) {
                this._checkFormat(t);
                var r = $6343abee919005ee$var$be(this._value, this.format.decimals), i = $6343abee919005ee$var$be(t._value, t.format.decimals);
                return Ut.fromValue(r.sub(i), this.format.decimals, this.format);
            }
        },
        {
            key: "mulUnsafe",
            value: function mulUnsafe(t) {
                this._checkFormat(t);
                var r = $6343abee919005ee$var$be(this._value, this.format.decimals), i = $6343abee919005ee$var$be(t._value, t.format.decimals);
                return Ut.fromValue(r.mul(i).div(this.format._multiplier), this.format.decimals, this.format);
            }
        },
        {
            key: "divUnsafe",
            value: function divUnsafe(t) {
                this._checkFormat(t);
                var r = $6343abee919005ee$var$be(this._value, this.format.decimals), i = $6343abee919005ee$var$be(t._value, t.format.decimals);
                return Ut.fromValue(r.mul(this.format._multiplier).div(i), this.format.decimals, this.format);
            }
        },
        {
            key: "floor",
            value: function floor() {
                var t = this.toString().split(".");
                t.length === 1 && t.push("0");
                var r = Ut.from(t[0], this.format);
                var i = !t[1].match(/^(0*)$/);
                return this.isNegative() && i && (r = r.subUnsafe($6343abee919005ee$var$Xn.toFormat(r.format))), r;
            }
        },
        {
            key: "ceiling",
            value: function ceiling() {
                var t = this.toString().split(".");
                t.length === 1 && t.push("0");
                var r = Ut.from(t[0], this.format);
                var i = !t[1].match(/^(0*)$/);
                return !this.isNegative() && i && (r = r.addUnsafe($6343abee919005ee$var$Xn.toFormat(r.format))), r;
            }
        },
        {
            key: "round",
            value: function round(t) {
                t == null && (t = 0);
                var r = this.toString().split(".");
                if (r.length === 1 && r.push("0"), (t < 0 || t > 80 || t % 1) && $6343abee919005ee$var$Ht.throwArgumentError("invalid decimal count", "decimals", t), r[1].length <= t) return this;
                var i = Ut.from("1" + $6343abee919005ee$var$gr.substring(0, t), this.format), n = $6343abee919005ee$var$ks.toFormat(this.format);
                return this.mulUnsafe(i).addUnsafe(n).floor().divUnsafe(i);
            }
        },
        {
            key: "isZero",
            value: function isZero() {
                return this._value === "0.0" || this._value === "0";
            }
        },
        {
            key: "isNegative",
            value: function isNegative() {
                return this._value[0] === "-";
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this._value;
            }
        },
        {
            key: "toHexString",
            value: function toHexString(t) {
                if (t == null) return this._hex;
                t % 8 && $6343abee919005ee$var$Ht.throwArgumentError("invalid byte width", "width", t);
                var r = $6343abee919005ee$var$V.from(this._hex).fromTwos(this.format.width).toTwos(t).toHexString();
                return $6343abee919005ee$var$oe(r, t / 8);
            }
        },
        {
            key: "toUnsafeFloat",
            value: function toUnsafeFloat() {
                return parseFloat(this.toString());
            }
        },
        {
            key: "toFormat",
            value: function toFormat(t) {
                return Ut.fromString(this._value, t);
            }
        }
    ], [
        {
            key: "fromValue",
            value: function fromValue(t, r, i) {
                return i == null && r != null && !$6343abee919005ee$var$Ts(r) && (i = r, r = null), r == null && (r = 0), i == null && (i = "fixed"), Ut.fromString($6343abee919005ee$var$Mi(t, r), $6343abee919005ee$var$dr.from(i));
            }
        },
        {
            key: "fromString",
            value: function fromString(t, r) {
                r == null && (r = "fixed");
                var i = $6343abee919005ee$var$dr.from(r), n = $6343abee919005ee$var$be(t, i.decimals);
                !i.signed && n.lt($6343abee919005ee$var$Yn) && $6343abee919005ee$var$Wn("unsigned value cannot be negative", "overflow", "value", t);
                var o = null;
                i.signed ? o = n.toTwos(i.width).toHexString() : (o = n.toHexString(), o = $6343abee919005ee$var$oe(o, i.width / 8));
                var h = $6343abee919005ee$var$Mi(n, i.decimals);
                return new Ut($6343abee919005ee$var$mr, o, h, i);
            }
        },
        {
            key: "fromBytes",
            value: function fromBytes(t, r) {
                r == null && (r = "fixed");
                var i = $6343abee919005ee$var$dr.from(r);
                if ($6343abee919005ee$var$Ot(t).length > i.width / 8) throw new Error("overflow");
                var n = $6343abee919005ee$var$V.from(t);
                i.signed && (n = n.fromTwos(i.width));
                var o = n.toTwos((i.signed ? 0 : 1) + i.width).toHexString(), h = $6343abee919005ee$var$Mi(n, i.decimals);
                return new Ut($6343abee919005ee$var$mr, o, h, i);
            }
        },
        {
            key: "from",
            value: function from(t, r) {
                if (typeof t == "string") return Ut.fromString(t, r);
                if ($6343abee919005ee$var$ir(t)) return Ut.fromBytes(t, r);
                try {
                    return Ut.fromValue(t, 0, r);
                } catch (i) {
                    if (i.code !== $6343abee919005ee$var$L.errors.INVALID_ARGUMENT) throw i;
                }
                return $6343abee919005ee$var$Ht.throwArgumentError("invalid FixedNumber value", "value", t);
            }
        },
        {
            key: "isFixedNumber",
            value: function isFixedNumber(t) {
                return !!(t && t._isFixedNumber);
            }
        }
    ]);
    return Ut;
}();
var $6343abee919005ee$var$Xn = $6343abee919005ee$var$Ut.from(1), $6343abee919005ee$var$ks = $6343abee919005ee$var$Ut.from("0.5"), $6343abee919005ee$var$qs = "strings/5.7.0", $6343abee919005ee$var$Zn = new $6343abee919005ee$var$L($6343abee919005ee$var$qs);
var $6343abee919005ee$var$Or;
(function(e) {
    e.current = "", e.NFC = "NFC", e.NFD = "NFD", e.NFKC = "NFKC", e.NFKD = "NFKD";
})($6343abee919005ee$var$Or || ($6343abee919005ee$var$Or = {}));
var $6343abee919005ee$var$nr;
(function(e) {
    e.UNEXPECTED_CONTINUE = "unexpected continuation byte", e.BAD_PREFIX = "bad codepoint prefix", e.OVERRUN = "string overrun", e.MISSING_CONTINUE = "missing continuation byte", e.OUT_OF_RANGE = "out of UTF-8 range", e.UTF16_SURROGATE = "UTF-16 surrogate", e.OVERLONG = "overlong representation";
})($6343abee919005ee$var$nr || ($6343abee919005ee$var$nr = {}));
function $6343abee919005ee$var$Ks(e, t, r, i, n) {
    return $6343abee919005ee$var$Zn.throwArgumentError("invalid codepoint at offset ".concat(t, "; ").concat(e), "bytes", r);
}
function $6343abee919005ee$var$$n(e, t, r, i, n) {
    if (e === $6343abee919005ee$var$nr.BAD_PREFIX || e === $6343abee919005ee$var$nr.UNEXPECTED_CONTINUE) {
        var o = 0;
        for(var h = t + 1; h < r.length && r[h] >> 6 === 2; h++)o++;
        return o;
    }
    return e === $6343abee919005ee$var$nr.OVERRUN ? r.length - t - 1 : 0;
}
function $6343abee919005ee$var$Hs(e, t, r, i, n) {
    return e === $6343abee919005ee$var$nr.OVERLONG ? (i.push(n), 0) : (i.push(65533), $6343abee919005ee$var$$n(e, t, r));
}
Object.freeze({
    error: $6343abee919005ee$var$Ks,
    ignore: $6343abee919005ee$var$$n,
    replace: $6343abee919005ee$var$Hs
});
function $6343abee919005ee$var$Ei(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $6343abee919005ee$var$Or.current;
    t != $6343abee919005ee$var$Or.current && ($6343abee919005ee$var$Zn.checkNormalize(), e = e.normalize(t));
    var r = [];
    for(var i = 0; i < e.length; i++){
        var n = e.charCodeAt(i);
        if (n < 128) r.push(n);
        else if (n < 2048) r.push(n >> 6 | 192), r.push(n & 63 | 128);
        else if ((n & 64512) == 55296) {
            i++;
            var o = e.charCodeAt(i);
            if (i >= e.length || (o & 64512) !== 56320) throw new Error("invalid utf-8 string");
            var h = 65536 + ((n & 1023) << 10) + (o & 1023);
            r.push(h >> 18 | 240), r.push(h >> 12 & 63 | 128), r.push(h >> 6 & 63 | 128), r.push(h & 63 | 128);
        } else r.push(n >> 12 | 224), r.push(n >> 6 & 63 | 128), r.push(n & 63 | 128);
    }
    return $6343abee919005ee$var$Ot(r);
}
function $6343abee919005ee$var$zs(e) {
    if (e.length % 4 !== 0) throw new Error("bad data");
    var t = [];
    for(var r = 0; r < e.length; r += 4)t.push(parseInt(e.substring(r, r + 4), 16));
    return t;
}
function $6343abee919005ee$var$Si(e, t) {
    t || (t = function t(n) {
        return [
            parseInt(n, 16)
        ];
    });
    var r = 0, i = {};
    return e.split(",").forEach(function(n) {
        var o = n.split(":");
        r += parseInt(o[0], 16), i[r] = t(o[1]);
    }), i;
}
function $6343abee919005ee$var$tf(e) {
    var t = 0;
    return e.split(",").map(function(r) {
        var i = r.split("-");
        i.length === 1 ? i[1] = "0" : i[1] === "" && (i[1] = "1");
        var n = t + parseInt(i[0], 16);
        return t = parseInt(i[1], 16), {
            l: n,
            h: t
        };
    });
}
$6343abee919005ee$var$tf("221,13-1b,5f-,40-10,51-f,11-3,3-3,2-2,2-4,8,2,15,2d,28-8,88,48,27-,3-5,11-20,27-,8,28,3-5,12,18,b-a,1c-4,6-16,2-d,2-2,2,1b-4,17-9,8f-,10,f,1f-2,1c-34,33-14e,4,36-,13-,6-2,1a-f,4,9-,3-,17,8,2-2,5-,2,8-,3-,4-8,2-3,3,6-,16-6,2-,7-3,3-,17,8,3,3,3-,2,6-3,3-,4-a,5,2-6,10-b,4,8,2,4,17,8,3,6-,b,4,4-,2-e,2-4,b-10,4,9-,3-,17,8,3-,5-,9-2,3-,4-7,3-3,3,4-3,c-10,3,7-2,4,5-2,3,2,3-2,3-2,4-2,9,4-3,6-2,4,5-8,2-e,d-d,4,9,4,18,b,6-3,8,4,5-6,3-8,3-3,b-11,3,9,4,18,b,6-3,8,4,5-6,3-6,2,3-3,b-11,3,9,4,18,11-3,7-,4,5-8,2-7,3-3,b-11,3,13-2,19,a,2-,8-2,2-3,7,2,9-11,4-b,3b-3,1e-24,3,2-,3,2-,2-5,5,8,4,2,2-,3,e,4-,6,2,7-,b-,3-21,49,23-5,1c-3,9,25,10-,2-2f,23,6,3,8-2,5-5,1b-45,27-9,2a-,2-3,5b-4,45-4,53-5,8,40,2,5-,8,2,5-,28,2,5-,20,2,5-,8,2,5-,8,8,18,20,2,5-,8,28,14-5,1d-22,56-b,277-8,1e-2,52-e,e,8-a,18-8,15-b,e,4,3-b,5e-2,b-15,10,b-5,59-7,2b-555,9d-3,5b-5,17-,7-,27-,7-,9,2,2,2,20-,36,10,f-,7,14-,4,a,54-3,2-6,6-5,9-,1c-10,13-1d,1c-14,3c-,10-6,32-b,240-30,28-18,c-14,a0,115-,3,66-,b-76,5,5-,1d,24,2,5-2,2,8-,35-2,19,f-10,1d-3,311-37f,1b,5a-b,d7-19,d-3,41,57-,68-4,29-3,5f,29-37,2e-2,25-c,2c-2,4e-3,30,78-3,64-,20,19b7-49,51a7-59,48e-2,38-738,2ba5-5b,222f-,3c-94,8-b,6-4,1b,6,2,3,3,6d-20,16e-f,41-,37-7,2e-2,11-f,5-b,18-,b,14,5-3,6,88-,2,bf-2,7-,7-,7-,4-2,8,8-9,8-2ff,20,5-b,1c-b4,27-,27-cbb1,f7-9,28-2,b5-221,56,48,3-,2-,3-,5,d,2,5,3,42,5-,9,8,1d,5,6,2-2,8,153-3,123-3,33-27fd,a6da-5128,21f-5df,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3,2-1d,61-ff7d"), "ad,34f,1806,180b,180c,180d,200b,200c,200d,2060,feff".split(",").map(function(e) {
    return parseInt(e, 16);
}), $6343abee919005ee$var$Si("b5:3bc,c3:ff,7:73,2:253,5:254,3:256,1:257,5:259,1:25b,3:260,1:263,2:269,1:268,5:26f,1:272,2:275,7:280,3:283,5:288,3:28a,1:28b,5:292,3f:195,1:1bf,29:19e,125:3b9,8b:3b2,1:3b8,1:3c5,3:3c6,1:3c0,1a:3ba,1:3c1,1:3c3,2:3b8,1:3b5,1bc9:3b9,1c:1f76,1:1f77,f:1f7a,1:1f7b,d:1f78,1:1f79,1:1f7c,1:1f7d,107:63,5:25b,4:68,1:68,1:68,3:69,1:69,1:6c,3:6e,4:70,1:71,1:72,1:72,1:72,7:7a,2:3c9,2:7a,2:6b,1:e5,1:62,1:63,3:65,1:66,2:6d,b:3b3,1:3c0,6:64,1b574:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3"), $6343abee919005ee$var$Si("179:1,2:1,2:1,5:1,2:1,a:4f,a:1,8:1,2:1,2:1,3:1,5:1,3:1,4:1,2:1,3:1,4:1,8:2,1:1,2:2,1:1,2:2,27:2,195:26,2:25,1:25,1:25,2:40,2:3f,1:3f,33:1,11:-6,1:-9,1ac7:-3a,6d:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,b:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,c:-8,2:-8,2:-8,2:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,49:-8,1:-8,1:-4a,1:-4a,d:-56,1:-56,1:-56,1:-56,d:-8,1:-8,f:-8,1:-8,3:-7"), $6343abee919005ee$var$Si("df:00730073,51:00690307,19:02BC006E,a7:006A030C,18a:002003B9,16:03B903080301,20:03C503080301,1d7:05650582,190f:00680331,1:00740308,1:0077030A,1:0079030A,1:006102BE,b6:03C50313,2:03C503130300,2:03C503130301,2:03C503130342,2a:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,3:1F7003B9,1:03B103B9,1:03AC03B9,2:03B10342,1:03B1034203B9,5:03B103B9,6:1F7403B9,1:03B703B9,1:03AE03B9,2:03B70342,1:03B7034203B9,5:03B703B9,6:03B903080300,1:03B903080301,3:03B90342,1:03B903080342,b:03C503080300,1:03C503080301,1:03C10313,2:03C50342,1:03C503080342,b:1F7C03B9,1:03C903B9,1:03CE03B9,2:03C90342,1:03C9034203B9,5:03C903B9,ac:00720073,5b:00B00063,6:00B00066,d:006E006F,a:0073006D,1:00740065006C,1:0074006D,124f:006800700061,2:00610075,2:006F0076,b:00700061,1:006E0061,1:03BC0061,1:006D0061,1:006B0061,1:006B0062,1:006D0062,1:00670062,3:00700066,1:006E0066,1:03BC0066,4:0068007A,1:006B0068007A,1:006D0068007A,1:00670068007A,1:00740068007A,15:00700061,1:006B00700061,1:006D00700061,1:006700700061,8:00700076,1:006E0076,1:03BC0076,1:006D0076,1:006B0076,1:006D0076,1:00700077,1:006E0077,1:03BC0077,1:006D0077,1:006B0077,1:006D0077,1:006B03C9,1:006D03C9,2:00620071,3:00632215006B0067,1:0063006F002E,1:00640062,1:00670079,2:00680070,2:006B006B,1:006B006D,9:00700068,2:00700070006D,1:00700072,2:00730076,1:00770062,c723:00660066,1:00660069,1:0066006C,1:006600660069,1:00660066006C,1:00730074,1:00730074,d:05740576,1:05740565,1:0574056B,1:057E0576,1:0574056D", $6343abee919005ee$var$zs), $6343abee919005ee$var$tf("80-20,2a0-,39c,32,f71,18e,7f2-f,19-7,30-4,7-5,f81-b,5,a800-20ff,4d1-1f,110,fa-6,d174-7,2e84-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,2,1f-5f,ff7f-20001");
var $6343abee919005ee$var$ef = "hash/5.7.0";
function $6343abee919005ee$var$Ls(e) {
    e = atob(e);
    var t = [];
    for(var r = 0; r < e.length; r++)t.push(e.charCodeAt(r));
    return $6343abee919005ee$var$Ot(t);
}
function $6343abee919005ee$var$rf(e, t) {
    t == null && (t = 1);
    var r = [], i = r.forEach, n = function n1(o, h) {
        i.call(o, function(p) {
            h > 0 && Array.isArray(p) ? n(p, h - 1) : r.push(p);
        });
    };
    return n(e, t), r;
}
function $6343abee919005ee$var$js(e) {
    var t = {};
    for(var r = 0; r < e.length; r++){
        var i = e[r];
        t[i[0]] = i[1];
    }
    return t;
}
function $6343abee919005ee$var$Qs(e) {
    var t = 0;
    function r() {
        return e[t++] << 8 | e[t++];
    }
    var i = r(), n = 1, o = [
        0,
        1
    ];
    for(var H = 1; H < i; H++)o.push(n += r());
    var h = r(), p = t;
    t += h;
    var A = 0, m = 0;
    function w() {
        return A == 0 && (m = m << 8 | e[t++], A = 8), m >> --A & 1;
    }
    var y = 31, S = Math.pow(2, y), I = S >>> 1, N = I >> 1, C = S - 1;
    var F = 0;
    for(var H1 = 0; H1 < y; H1++)F = F << 1 | w();
    var U = [], J = 0, Bt = S;
    for(;;){
        var H2 = Math.floor(((F - J + 1) * n - 1) / Bt), z = 0, Pt = i;
        for(; Pt - z > 1;){
            var Yt = z + Pt >>> 1;
            H2 < o[Yt] ? Pt = Yt : z = Yt;
        }
        if (z == 0) break;
        U.push(z);
        var W = J + Math.floor(Bt * o[z] / n), Rt = J + Math.floor(Bt * o[z + 1] / n) - 1;
        for(; !((W ^ Rt) & I);)F = F << 1 & C | w(), W = W << 1 & C, Rt = Rt << 1 & C | 1;
        for(; W & ~Rt & N;)F = F & I | F << 1 & C >>> 1 | w(), W = W << 1 ^ I, Rt = (Rt ^ I) << 1 | I | 1;
        J = W, Bt = 1 + Rt - W;
    }
    var G = i - 4;
    return U.map(function(H) {
        switch(H - G){
            case 3:
                return G + 65792 + (e[p++] << 16 | e[p++] << 8 | e[p++]);
            case 2:
                return G + 256 + (e[p++] << 8 | e[p++]);
            case 1:
                return G + e[p++];
            default:
                return H - 1;
        }
    });
}
function $6343abee919005ee$var$Js(e) {
    var t = 0;
    return function() {
        return e[t++];
    };
}
function $6343abee919005ee$var$Gs(e) {
    return $6343abee919005ee$var$Js($6343abee919005ee$var$Qs(e));
}
function $6343abee919005ee$var$Ys(e) {
    return e & 1 ? ~e >> 1 : e >> 1;
}
function $6343abee919005ee$var$Vs(e, t) {
    var r = Array(e);
    for(var i = 0; i < e; i++)r[i] = 1 + t();
    return r;
}
function $6343abee919005ee$var$nf(e, t) {
    var r = Array(e);
    for(var i = 0, n = -1; i < e; i++)r[i] = n += 1 + t();
    return r;
}
function $6343abee919005ee$var$Ws(e, t) {
    var r = Array(e);
    for(var i = 0, n = 0; i < e; i++)r[i] = n += $6343abee919005ee$var$Ys(t());
    return r;
}
function $6343abee919005ee$var$Pr(e, t) {
    var r = $6343abee919005ee$var$nf(e(), e), i = e(), n = $6343abee919005ee$var$nf(i, e), o = $6343abee919005ee$var$Vs(i, e);
    for(var h = 0; h < i; h++)for(var p = 0; p < o[h]; p++)r.push(n[h] + p);
    return t ? r.map(function(h) {
        return t[h];
    }) : r;
}
function $6343abee919005ee$var$Xs(e) {
    var t = [];
    for(;;){
        var r = e();
        if (r == 0) break;
        t.push($6343abee919005ee$var$$s(r, e));
    }
    for(;;){
        var r1 = e() - 1;
        if (r1 < 0) break;
        t.push($6343abee919005ee$var$t0(r1, e));
    }
    return $6343abee919005ee$var$js($6343abee919005ee$var$rf(t));
}
function $6343abee919005ee$var$Zs(e) {
    var t = [];
    for(;;){
        var r = e();
        if (r == 0) break;
        t.push(r);
    }
    return t;
}
function $6343abee919005ee$var$ff(e, t, r) {
    var i = Array(e).fill(void 0).map(function() {
        return [];
    });
    for(var n = 0; n < t; n++)$6343abee919005ee$var$Ws(e, r).forEach(function(o, h) {
        return i[h].push(o);
    });
    return i;
}
function $6343abee919005ee$var$$s(e, t) {
    var r = 1 + t(), i = t(), n = $6343abee919005ee$var$Zs(t), o = $6343abee919005ee$var$ff(n.length, 1 + e, t);
    return $6343abee919005ee$var$rf(o.map(function(h, p) {
        var A = h[0], m = h.slice(1);
        return Array(n[p]).fill(void 0).map(function(w, y) {
            var S = y * i;
            return [
                A + y * r,
                m.map(function(I) {
                    return I + S;
                })
            ];
        });
    }));
}
function $6343abee919005ee$var$t0(e, t) {
    var r = 1 + t();
    return $6343abee919005ee$var$ff(r, 1 + e, t).map(function(n) {
        return [
            n[0],
            n.slice(1)
        ];
    });
}
function $6343abee919005ee$var$e0(e) {
    var t = $6343abee919005ee$var$Pr(e).sort(function(i, n) {
        return i - n;
    });
    return r();
    function r() {
        var i = [];
        for(;;){
            var m = $6343abee919005ee$var$Pr(e, t);
            if (m.length == 0) break;
            i.push({
                set: new Set(m),
                node: r()
            });
        }
        i.sort(function(m, w) {
            return w.set.size - m.set.size;
        });
        var n = e(), o = n % 3;
        n = n / 3 | 0;
        var h = !!(n & 1);
        n >>= 1;
        var p = n == 1, A = n == 2;
        return {
            branches: i,
            valid: o,
            fe0f: h,
            save: p,
            check: A
        };
    }
}
function $6343abee919005ee$var$r0() {
    return $6343abee919005ee$var$Gs($6343abee919005ee$var$Ls("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"));
}
var $6343abee919005ee$var$Dr = $6343abee919005ee$var$r0();
new Set($6343abee919005ee$var$Pr($6343abee919005ee$var$Dr)), new Set($6343abee919005ee$var$Pr($6343abee919005ee$var$Dr)), $6343abee919005ee$var$Xs($6343abee919005ee$var$Dr), $6343abee919005ee$var$e0($6343abee919005ee$var$Dr), new $6343abee919005ee$var$L($6343abee919005ee$var$ef);
var $6343abee919005ee$var$i0 = new Uint8Array(32);
$6343abee919005ee$var$i0.fill(0);
var $6343abee919005ee$var$n0 = "\x19Ethereum Signed Message:\n";
function $6343abee919005ee$var$of(e) {
    return typeof e == "string" && (e = $6343abee919005ee$var$Ei(e)), $6343abee919005ee$var$yi($6343abee919005ee$var$Cs([
        $6343abee919005ee$var$Ei($6343abee919005ee$var$n0),
        $6343abee919005ee$var$Ei(String(e.length)),
        e
    ]));
}
var $6343abee919005ee$var$f0 = "rlp/5.7.0";
new $6343abee919005ee$var$L($6343abee919005ee$var$f0);
var $6343abee919005ee$var$o0 = "address/5.7.0", $6343abee919005ee$var$Ar = new $6343abee919005ee$var$L($6343abee919005ee$var$o0);
function $6343abee919005ee$var$sf(e) {
    $6343abee919005ee$var$Qt(e, 20) || $6343abee919005ee$var$Ar.throwArgumentError("invalid address", "address", e), e = e.toLowerCase();
    var t = e.substring(2).split(""), r = new Uint8Array(40);
    for(var n = 0; n < 40; n++)r[n] = t[n].charCodeAt(0);
    var i = $6343abee919005ee$var$Ot($6343abee919005ee$var$yi(r));
    for(var n1 = 0; n1 < 40; n1 += 2)i[n1 >> 1] >> 4 >= 8 && (t[n1] = t[n1].toUpperCase()), (i[n1 >> 1] & 15) >= 8 && (t[n1 + 1] = t[n1 + 1].toUpperCase());
    return "0x" + t.join("");
}
var $6343abee919005ee$var$s0 = 9007199254740991;
function $6343abee919005ee$var$a0(e) {
    return Math.log10 ? Math.log10(e) : Math.log(e) / Math.LN10;
}
var $6343abee919005ee$var$Ni = {};
for(var $6343abee919005ee$var$e = 0; $6343abee919005ee$var$e < 10; $6343abee919005ee$var$e++)$6343abee919005ee$var$Ni[String($6343abee919005ee$var$e)] = String($6343abee919005ee$var$e);
for(var $6343abee919005ee$var$e1 = 0; $6343abee919005ee$var$e1 < 26; $6343abee919005ee$var$e1++)$6343abee919005ee$var$Ni[String.fromCharCode(65 + $6343abee919005ee$var$e1)] = String(10 + $6343abee919005ee$var$e1);
var $6343abee919005ee$var$af = Math.floor($6343abee919005ee$var$a0($6343abee919005ee$var$s0));
function $6343abee919005ee$var$u0(e) {
    e = e.toUpperCase(), e = e.substring(4) + e.substring(0, 2) + "00";
    var t = e.split("").map(function(i) {
        return $6343abee919005ee$var$Ni[i];
    }).join("");
    for(; t.length >= $6343abee919005ee$var$af;){
        var i = t.substring(0, $6343abee919005ee$var$af);
        t = parseInt(i, 10) % 97 + t.substring(i.length);
    }
    var r = String(98 - parseInt(t, 10) % 97);
    for(; r.length < 2;)r = "0" + r;
    return r;
}
function $6343abee919005ee$var$h0(e) {
    var t = null;
    if (typeof e != "string" && $6343abee919005ee$var$Ar.throwArgumentError("invalid address", "address", e), e.match(/^(0x)?[0-9a-fA-F]{40}$/)) e.substring(0, 2) !== "0x" && (e = "0x" + e), t = $6343abee919005ee$var$sf(e), e.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && t !== e && $6343abee919005ee$var$Ar.throwArgumentError("bad address checksum", "address", e);
    else if (e.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        for(e.substring(2, 4) !== $6343abee919005ee$var$u0(e) && $6343abee919005ee$var$Ar.throwArgumentError("bad icap checksum", "address", e), t = $6343abee919005ee$var$Us(e.substring(4)); t.length < 40;)t = "0" + t;
        t = $6343abee919005ee$var$sf("0x" + t);
    } else $6343abee919005ee$var$Ar.throwArgumentError("invalid address", "address", e);
    return t;
}
var $6343abee919005ee$var$c0 = "properties/5.7.0";
new $6343abee919005ee$var$L($6343abee919005ee$var$c0);
function $6343abee919005ee$var$br(e, t, r) {
    Object.defineProperty(e, t, {
        enumerable: !0,
        value: r,
        writable: !1
    });
}
new $6343abee919005ee$var$L($6343abee919005ee$var$ef);
var $6343abee919005ee$var$l0 = new Uint8Array(32);
$6343abee919005ee$var$l0.fill(0), $6343abee919005ee$var$V.from(-1);
var $6343abee919005ee$var$d0 = $6343abee919005ee$var$V.from(0), $6343abee919005ee$var$p0 = $6343abee919005ee$var$V.from(1);
$6343abee919005ee$var$V.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), $6343abee919005ee$var$oe($6343abee919005ee$var$p0.toHexString(), 32), $6343abee919005ee$var$oe($6343abee919005ee$var$d0.toHexString(), 32);
var $6343abee919005ee$var$se = {}, $6343abee919005ee$var$Q = {}, $6343abee919005ee$var$yr = $6343abee919005ee$var$uf;
function $6343abee919005ee$var$uf(e, t) {
    if (!e) throw new Error(t || "Assertion failed");
}
$6343abee919005ee$var$uf.equal = function(t, r, i) {
    if (t != r) throw new Error(i || "Assertion failed: " + t + " != " + r);
};
var $6343abee919005ee$var$Ii = {
    exports: {}
};
typeof Object.create == "function" ? $6343abee919005ee$var$Ii.exports = function(t, r) {
    r && (t.super_ = r, t.prototype = Object.create(r.prototype, {
        constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0
        }
    }));
} : $6343abee919005ee$var$Ii.exports = function(t, r) {
    if (r) {
        t.super_ = r;
        var i = function i() {};
        i.prototype = r.prototype, t.prototype = new i, t.prototype.constructor = t;
    }
};
var $6343abee919005ee$var$v0 = $6343abee919005ee$var$yr, $6343abee919005ee$var$m0 = $6343abee919005ee$var$Ii.exports;
$6343abee919005ee$var$Q.inherits = $6343abee919005ee$var$m0;
function $6343abee919005ee$var$g0(e, t) {
    return (e.charCodeAt(t) & 64512) !== 55296 || t < 0 || t + 1 >= e.length ? !1 : (e.charCodeAt(t + 1) & 64512) === 56320;
}
function $6343abee919005ee$var$A0(e, t) {
    if (Array.isArray(e)) return e.slice();
    if (!e) return [];
    var r = [];
    if (typeof e == "string") {
        if (t) {
            if (t === "hex") for(e = e.replace(/[^a-z0-9]+/ig, ""), e.length % 2 !== 0 && (e = "0" + e), n = 0; n < e.length; n += 2)r.push(parseInt(e[n] + e[n + 1], 16));
        } else for(var i = 0, n = 0; n < e.length; n++){
            var o = e.charCodeAt(n);
            o < 128 ? r[i++] = o : o < 2048 ? (r[i++] = o >> 6 | 192, r[i++] = o & 63 | 128) : $6343abee919005ee$var$g0(e, n) ? (o = 65536 + ((o & 1023) << 10) + (e.charCodeAt(++n) & 1023), r[i++] = o >> 18 | 240, r[i++] = o >> 12 & 63 | 128, r[i++] = o >> 6 & 63 | 128, r[i++] = o & 63 | 128) : (r[i++] = o >> 12 | 224, r[i++] = o >> 6 & 63 | 128, r[i++] = o & 63 | 128);
        }
    } else for(n = 0; n < e.length; n++)r[n] = e[n] | 0;
    return r;
}
$6343abee919005ee$var$Q.toArray = $6343abee919005ee$var$A0;
function $6343abee919005ee$var$b0(e) {
    for(var t = "", r = 0; r < e.length; r++)t += $6343abee919005ee$var$cf(e[r].toString(16));
    return t;
}
$6343abee919005ee$var$Q.toHex = $6343abee919005ee$var$b0;
function $6343abee919005ee$var$hf(e) {
    var t = e >>> 24 | e >>> 8 & 65280 | e << 8 & 16711680 | (e & 255) << 24;
    return t >>> 0;
}
$6343abee919005ee$var$Q.htonl = $6343abee919005ee$var$hf;
function $6343abee919005ee$var$y0(e, t) {
    for(var r = "", i = 0; i < e.length; i++){
        var n = e[i];
        t === "little" && (n = $6343abee919005ee$var$hf(n)), r += $6343abee919005ee$var$lf(n.toString(16));
    }
    return r;
}
$6343abee919005ee$var$Q.toHex32 = $6343abee919005ee$var$y0;
function $6343abee919005ee$var$cf(e) {
    return e.length === 1 ? "0" + e : e;
}
$6343abee919005ee$var$Q.zero2 = $6343abee919005ee$var$cf;
function $6343abee919005ee$var$lf(e) {
    return e.length === 7 ? "0" + e : e.length === 6 ? "00" + e : e.length === 5 ? "000" + e : e.length === 4 ? "0000" + e : e.length === 3 ? "00000" + e : e.length === 2 ? "000000" + e : e.length === 1 ? "0000000" + e : e;
}
$6343abee919005ee$var$Q.zero8 = $6343abee919005ee$var$lf;
function $6343abee919005ee$var$w0(e, t, r, i) {
    var n = r - t;
    $6343abee919005ee$var$v0(n % 4 === 0);
    for(var o = new Array(n / 4), h = 0, p = t; h < o.length; h++, p += 4){
        var A;
        i === "big" ? A = e[p] << 24 | e[p + 1] << 16 | e[p + 2] << 8 | e[p + 3] : A = e[p + 3] << 24 | e[p + 2] << 16 | e[p + 1] << 8 | e[p], o[h] = A >>> 0;
    }
    return o;
}
$6343abee919005ee$var$Q.join32 = $6343abee919005ee$var$w0;
function $6343abee919005ee$var$x0(e, t) {
    for(var r = new Array(e.length * 4), i = 0, n = 0; i < e.length; i++, n += 4){
        var o = e[i];
        t === "big" ? (r[n] = o >>> 24, r[n + 1] = o >>> 16 & 255, r[n + 2] = o >>> 8 & 255, r[n + 3] = o & 255) : (r[n + 3] = o >>> 24, r[n + 2] = o >>> 16 & 255, r[n + 1] = o >>> 8 & 255, r[n] = o & 255);
    }
    return r;
}
$6343abee919005ee$var$Q.split32 = $6343abee919005ee$var$x0;
function $6343abee919005ee$var$M0(e, t) {
    return e >>> t | e << 32 - t;
}
$6343abee919005ee$var$Q.rotr32 = $6343abee919005ee$var$M0;
function $6343abee919005ee$var$E0(e, t) {
    return e << t | e >>> 32 - t;
}
$6343abee919005ee$var$Q.rotl32 = $6343abee919005ee$var$E0;
function $6343abee919005ee$var$S0(e, t) {
    return e + t >>> 0;
}
$6343abee919005ee$var$Q.sum32 = $6343abee919005ee$var$S0;
function $6343abee919005ee$var$N0(e, t, r) {
    return e + t + r >>> 0;
}
$6343abee919005ee$var$Q.sum32_3 = $6343abee919005ee$var$N0;
function $6343abee919005ee$var$I0(e, t, r, i) {
    return e + t + r + i >>> 0;
}
$6343abee919005ee$var$Q.sum32_4 = $6343abee919005ee$var$I0;
function $6343abee919005ee$var$_0(e, t, r, i, n) {
    return e + t + r + i + n >>> 0;
}
$6343abee919005ee$var$Q.sum32_5 = $6343abee919005ee$var$_0;
function $6343abee919005ee$var$B0(e, t, r, i) {
    var n = e[t], o = e[t + 1], h = i + o >>> 0, p = (h < i ? 1 : 0) + r + n;
    e[t] = p >>> 0, e[t + 1] = h;
}
$6343abee919005ee$var$Q.sum64 = $6343abee919005ee$var$B0;
function $6343abee919005ee$var$C0(e, t, r, i) {
    var n = t + i >>> 0, o = (n < t ? 1 : 0) + e + r;
    return o >>> 0;
}
$6343abee919005ee$var$Q.sum64_hi = $6343abee919005ee$var$C0;
function $6343abee919005ee$var$R0(e, t, r, i) {
    var n = t + i;
    return n >>> 0;
}
$6343abee919005ee$var$Q.sum64_lo = $6343abee919005ee$var$R0;
function $6343abee919005ee$var$O0(e, t, r, i, n, o, h, p) {
    var A = 0, m = t;
    m = m + i >>> 0, A += m < t ? 1 : 0, m = m + o >>> 0, A += m < o ? 1 : 0, m = m + p >>> 0, A += m < p ? 1 : 0;
    var w = e + r + n + h + A;
    return w >>> 0;
}
$6343abee919005ee$var$Q.sum64_4_hi = $6343abee919005ee$var$O0;
function $6343abee919005ee$var$P0(e, t, r, i, n, o, h, p) {
    var A = t + i + o + p;
    return A >>> 0;
}
$6343abee919005ee$var$Q.sum64_4_lo = $6343abee919005ee$var$P0;
function $6343abee919005ee$var$D0(e, t, r, i, n, o, h, p, A, m) {
    var w = 0, y = t;
    y = y + i >>> 0, w += y < t ? 1 : 0, y = y + o >>> 0, w += y < o ? 1 : 0, y = y + p >>> 0, w += y < p ? 1 : 0, y = y + m >>> 0, w += y < m ? 1 : 0;
    var S = e + r + n + h + A + w;
    return S >>> 0;
}
$6343abee919005ee$var$Q.sum64_5_hi = $6343abee919005ee$var$D0;
function $6343abee919005ee$var$F0(e, t, r, i, n, o, h, p, A, m) {
    var w = t + i + o + p + m;
    return w >>> 0;
}
$6343abee919005ee$var$Q.sum64_5_lo = $6343abee919005ee$var$F0;
function $6343abee919005ee$var$T0(e, t, r) {
    var i = t << 32 - r | e >>> r;
    return i >>> 0;
}
$6343abee919005ee$var$Q.rotr64_hi = $6343abee919005ee$var$T0;
function $6343abee919005ee$var$U0(e, t, r) {
    var i = e << 32 - r | t >>> r;
    return i >>> 0;
}
$6343abee919005ee$var$Q.rotr64_lo = $6343abee919005ee$var$U0;
function $6343abee919005ee$var$k0(e, t, r) {
    return e >>> r;
}
$6343abee919005ee$var$Q.shr64_hi = $6343abee919005ee$var$k0;
function $6343abee919005ee$var$q0(e, t, r) {
    var i = e << 32 - r | t >>> r;
    return i >>> 0;
}
$6343abee919005ee$var$Q.shr64_lo = $6343abee919005ee$var$q0;
var $6343abee919005ee$var$fr = {}, $6343abee919005ee$var$df = $6343abee919005ee$var$Q, $6343abee919005ee$var$K0 = $6343abee919005ee$var$yr;
function $6343abee919005ee$var$Fr() {
    this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
}
$6343abee919005ee$var$fr.BlockHash = $6343abee919005ee$var$Fr, $6343abee919005ee$var$Fr.prototype.update = function(t, r) {
    if (t = $6343abee919005ee$var$df.toArray(t, r), this.pending ? this.pending = this.pending.concat(t) : this.pending = t, this.pendingTotal += t.length, this.pending.length >= this._delta8) {
        t = this.pending;
        var i = t.length % this._delta8;
        this.pending = t.slice(t.length - i, t.length), this.pending.length === 0 && (this.pending = null), t = $6343abee919005ee$var$df.join32(t, 0, t.length - i, this.endian);
        for(var n = 0; n < t.length; n += this._delta32)this._update(t, n, n + this._delta32);
    }
    return this;
}, $6343abee919005ee$var$Fr.prototype.digest = function(t) {
    return this.update(this._pad()), $6343abee919005ee$var$K0(this.pending === null), this._digest(t);
}, $6343abee919005ee$var$Fr.prototype._pad = function() {
    var t = this.pendingTotal, r = this._delta8, i = r - (t + this.padLength) % r, n = new Array(i + this.padLength);
    n[0] = 128;
    for(var o = 1; o < i; o++)n[o] = 0;
    if (t <<= 3, this.endian === "big") {
        for(var h = 8; h < this.padLength; h++)n[o++] = 0;
        n[o++] = 0, n[o++] = 0, n[o++] = 0, n[o++] = 0, n[o++] = t >>> 24 & 255, n[o++] = t >>> 16 & 255, n[o++] = t >>> 8 & 255, n[o++] = t & 255;
    } else for(n[o++] = t & 255, n[o++] = t >>> 8 & 255, n[o++] = t >>> 16 & 255, n[o++] = t >>> 24 & 255, n[o++] = 0, n[o++] = 0, n[o++] = 0, n[o++] = 0, h = 8; h < this.padLength; h++)n[o++] = 0;
    return n;
};
var $6343abee919005ee$var$or = {}, $6343abee919005ee$var$ae = {}, $6343abee919005ee$var$H0 = $6343abee919005ee$var$Q, $6343abee919005ee$var$ue = $6343abee919005ee$var$H0.rotr32;
function $6343abee919005ee$var$z0(e, t, r, i) {
    if (e === 0) return $6343abee919005ee$var$pf(t, r, i);
    if (e === 1 || e === 3) return $6343abee919005ee$var$mf(t, r, i);
    if (e === 2) return $6343abee919005ee$var$vf(t, r, i);
}
$6343abee919005ee$var$ae.ft_1 = $6343abee919005ee$var$z0;
function $6343abee919005ee$var$pf(e, t, r) {
    return e & t ^ ~e & r;
}
$6343abee919005ee$var$ae.ch32 = $6343abee919005ee$var$pf;
function $6343abee919005ee$var$vf(e, t, r) {
    return e & t ^ e & r ^ t & r;
}
$6343abee919005ee$var$ae.maj32 = $6343abee919005ee$var$vf;
function $6343abee919005ee$var$mf(e, t, r) {
    return e ^ t ^ r;
}
$6343abee919005ee$var$ae.p32 = $6343abee919005ee$var$mf;
function $6343abee919005ee$var$L0(e) {
    return $6343abee919005ee$var$ue(e, 2) ^ $6343abee919005ee$var$ue(e, 13) ^ $6343abee919005ee$var$ue(e, 22);
}
$6343abee919005ee$var$ae.s0_256 = $6343abee919005ee$var$L0;
function $6343abee919005ee$var$j0(e) {
    return $6343abee919005ee$var$ue(e, 6) ^ $6343abee919005ee$var$ue(e, 11) ^ $6343abee919005ee$var$ue(e, 25);
}
$6343abee919005ee$var$ae.s1_256 = $6343abee919005ee$var$j0;
function $6343abee919005ee$var$Q0(e) {
    return $6343abee919005ee$var$ue(e, 7) ^ $6343abee919005ee$var$ue(e, 18) ^ e >>> 3;
}
$6343abee919005ee$var$ae.g0_256 = $6343abee919005ee$var$Q0;
function $6343abee919005ee$var$J0(e) {
    return $6343abee919005ee$var$ue(e, 17) ^ $6343abee919005ee$var$ue(e, 19) ^ e >>> 10;
}
$6343abee919005ee$var$ae.g1_256 = $6343abee919005ee$var$J0;
var $6343abee919005ee$var$sr = $6343abee919005ee$var$Q, $6343abee919005ee$var$G0 = $6343abee919005ee$var$fr, $6343abee919005ee$var$Y0 = $6343abee919005ee$var$ae, $6343abee919005ee$var$_i = $6343abee919005ee$var$sr.rotl32, $6343abee919005ee$var$wr = $6343abee919005ee$var$sr.sum32, $6343abee919005ee$var$V0 = $6343abee919005ee$var$sr.sum32_5, $6343abee919005ee$var$W0 = $6343abee919005ee$var$Y0.ft_1, $6343abee919005ee$var$gf = $6343abee919005ee$var$G0.BlockHash, $6343abee919005ee$var$X0 = [
    1518500249,
    1859775393,
    2400959708,
    3395469782
];
function $6343abee919005ee$var$he() {
    if (!(this instanceof $6343abee919005ee$var$he)) return new $6343abee919005ee$var$he;
    $6343abee919005ee$var$gf.call(this), this.h = [
        1732584193,
        4023233417,
        2562383102,
        271733878,
        3285377520
    ], this.W = new Array(80);
}
$6343abee919005ee$var$sr.inherits($6343abee919005ee$var$he, $6343abee919005ee$var$gf);
var $6343abee919005ee$var$Z0 = $6343abee919005ee$var$he;
$6343abee919005ee$var$he.blockSize = 512, $6343abee919005ee$var$he.outSize = 160, $6343abee919005ee$var$he.hmacStrength = 80, $6343abee919005ee$var$he.padLength = 64, $6343abee919005ee$var$he.prototype._update = function(t, r) {
    for(var i = this.W, n = 0; n < 16; n++)i[n] = t[r + n];
    for(; n < i.length; n++)i[n] = $6343abee919005ee$var$_i(i[n - 3] ^ i[n - 8] ^ i[n - 14] ^ i[n - 16], 1);
    var o = this.h[0], h = this.h[1], p = this.h[2], A = this.h[3], m = this.h[4];
    for(n = 0; n < i.length; n++){
        var w = ~~(n / 20), y = $6343abee919005ee$var$V0($6343abee919005ee$var$_i(o, 5), $6343abee919005ee$var$W0(w, h, p, A), m, i[n], $6343abee919005ee$var$X0[w]);
        m = A, A = p, p = $6343abee919005ee$var$_i(h, 30), h = o, o = y;
    }
    this.h[0] = $6343abee919005ee$var$wr(this.h[0], o), this.h[1] = $6343abee919005ee$var$wr(this.h[1], h), this.h[2] = $6343abee919005ee$var$wr(this.h[2], p), this.h[3] = $6343abee919005ee$var$wr(this.h[3], A), this.h[4] = $6343abee919005ee$var$wr(this.h[4], m);
}, $6343abee919005ee$var$he.prototype._digest = function(t) {
    return t === "hex" ? $6343abee919005ee$var$sr.toHex32(this.h, "big") : $6343abee919005ee$var$sr.split32(this.h, "big");
};
var $6343abee919005ee$var$ar = $6343abee919005ee$var$Q, $6343abee919005ee$var$$0 = $6343abee919005ee$var$fr, $6343abee919005ee$var$ur = $6343abee919005ee$var$ae, $6343abee919005ee$var$ta = $6343abee919005ee$var$yr, $6343abee919005ee$var$ie = $6343abee919005ee$var$ar.sum32, $6343abee919005ee$var$ea = $6343abee919005ee$var$ar.sum32_4, $6343abee919005ee$var$ra = $6343abee919005ee$var$ar.sum32_5, $6343abee919005ee$var$ia = $6343abee919005ee$var$ur.ch32, $6343abee919005ee$var$na = $6343abee919005ee$var$ur.maj32, $6343abee919005ee$var$fa = $6343abee919005ee$var$ur.s0_256, $6343abee919005ee$var$oa = $6343abee919005ee$var$ur.s1_256, $6343abee919005ee$var$sa = $6343abee919005ee$var$ur.g0_256, $6343abee919005ee$var$aa = $6343abee919005ee$var$ur.g1_256, $6343abee919005ee$var$Af = $6343abee919005ee$var$$0.BlockHash, $6343abee919005ee$var$ua = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
];
function $6343abee919005ee$var$ce() {
    if (!(this instanceof $6343abee919005ee$var$ce)) return new $6343abee919005ee$var$ce;
    $6343abee919005ee$var$Af.call(this), this.h = [
        1779033703,
        3144134277,
        1013904242,
        2773480762,
        1359893119,
        2600822924,
        528734635,
        1541459225
    ], this.k = $6343abee919005ee$var$ua, this.W = new Array(64);
}
$6343abee919005ee$var$ar.inherits($6343abee919005ee$var$ce, $6343abee919005ee$var$Af);
var $6343abee919005ee$var$bf = $6343abee919005ee$var$ce;
$6343abee919005ee$var$ce.blockSize = 512, $6343abee919005ee$var$ce.outSize = 256, $6343abee919005ee$var$ce.hmacStrength = 192, $6343abee919005ee$var$ce.padLength = 64, $6343abee919005ee$var$ce.prototype._update = function(t, r) {
    for(var i = this.W, n = 0; n < 16; n++)i[n] = t[r + n];
    for(; n < i.length; n++)i[n] = $6343abee919005ee$var$ea($6343abee919005ee$var$aa(i[n - 2]), i[n - 7], $6343abee919005ee$var$sa(i[n - 15]), i[n - 16]);
    var o = this.h[0], h = this.h[1], p = this.h[2], A = this.h[3], m = this.h[4], w = this.h[5], y = this.h[6], S = this.h[7];
    for($6343abee919005ee$var$ta(this.k.length === i.length), n = 0; n < i.length; n++){
        var I = $6343abee919005ee$var$ra(S, $6343abee919005ee$var$oa(m), $6343abee919005ee$var$ia(m, w, y), this.k[n], i[n]), N = $6343abee919005ee$var$ie($6343abee919005ee$var$fa(o), $6343abee919005ee$var$na(o, h, p));
        S = y, y = w, w = m, m = $6343abee919005ee$var$ie(A, I), A = p, p = h, h = o, o = $6343abee919005ee$var$ie(I, N);
    }
    this.h[0] = $6343abee919005ee$var$ie(this.h[0], o), this.h[1] = $6343abee919005ee$var$ie(this.h[1], h), this.h[2] = $6343abee919005ee$var$ie(this.h[2], p), this.h[3] = $6343abee919005ee$var$ie(this.h[3], A), this.h[4] = $6343abee919005ee$var$ie(this.h[4], m), this.h[5] = $6343abee919005ee$var$ie(this.h[5], w), this.h[6] = $6343abee919005ee$var$ie(this.h[6], y), this.h[7] = $6343abee919005ee$var$ie(this.h[7], S);
}, $6343abee919005ee$var$ce.prototype._digest = function(t) {
    return t === "hex" ? $6343abee919005ee$var$ar.toHex32(this.h, "big") : $6343abee919005ee$var$ar.split32(this.h, "big");
};
var $6343abee919005ee$var$Bi = $6343abee919005ee$var$Q, $6343abee919005ee$var$yf = $6343abee919005ee$var$bf;
function $6343abee919005ee$var$ye() {
    if (!(this instanceof $6343abee919005ee$var$ye)) return new $6343abee919005ee$var$ye;
    $6343abee919005ee$var$yf.call(this), this.h = [
        3238371032,
        914150663,
        812702999,
        4144912697,
        4290775857,
        1750603025,
        1694076839,
        3204075428
    ];
}
$6343abee919005ee$var$Bi.inherits($6343abee919005ee$var$ye, $6343abee919005ee$var$yf);
var $6343abee919005ee$var$ha = $6343abee919005ee$var$ye;
$6343abee919005ee$var$ye.blockSize = 512, $6343abee919005ee$var$ye.outSize = 224, $6343abee919005ee$var$ye.hmacStrength = 192, $6343abee919005ee$var$ye.padLength = 64, $6343abee919005ee$var$ye.prototype._digest = function(t) {
    return t === "hex" ? $6343abee919005ee$var$Bi.toHex32(this.h.slice(0, 7), "big") : $6343abee919005ee$var$Bi.split32(this.h.slice(0, 7), "big");
};
var $6343abee919005ee$var$jt = $6343abee919005ee$var$Q, $6343abee919005ee$var$ca = $6343abee919005ee$var$fr, $6343abee919005ee$var$la = $6343abee919005ee$var$yr, $6343abee919005ee$var$le = $6343abee919005ee$var$jt.rotr64_hi, $6343abee919005ee$var$de = $6343abee919005ee$var$jt.rotr64_lo, $6343abee919005ee$var$wf = $6343abee919005ee$var$jt.shr64_hi, $6343abee919005ee$var$xf = $6343abee919005ee$var$jt.shr64_lo, $6343abee919005ee$var$Be = $6343abee919005ee$var$jt.sum64, $6343abee919005ee$var$Ci = $6343abee919005ee$var$jt.sum64_hi, $6343abee919005ee$var$Ri = $6343abee919005ee$var$jt.sum64_lo, $6343abee919005ee$var$da = $6343abee919005ee$var$jt.sum64_4_hi, $6343abee919005ee$var$pa = $6343abee919005ee$var$jt.sum64_4_lo, $6343abee919005ee$var$va = $6343abee919005ee$var$jt.sum64_5_hi, $6343abee919005ee$var$ma = $6343abee919005ee$var$jt.sum64_5_lo, $6343abee919005ee$var$Mf = $6343abee919005ee$var$ca.BlockHash, $6343abee919005ee$var$ga = [
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
];
function $6343abee919005ee$var$ne() {
    if (!(this instanceof $6343abee919005ee$var$ne)) return new $6343abee919005ee$var$ne;
    $6343abee919005ee$var$Mf.call(this), this.h = [
        1779033703,
        4089235720,
        3144134277,
        2227873595,
        1013904242,
        4271175723,
        2773480762,
        1595750129,
        1359893119,
        2917565137,
        2600822924,
        725511199,
        528734635,
        4215389547,
        1541459225,
        327033209
    ], this.k = $6343abee919005ee$var$ga, this.W = new Array(160);
}
$6343abee919005ee$var$jt.inherits($6343abee919005ee$var$ne, $6343abee919005ee$var$Mf);
var $6343abee919005ee$var$Ef = $6343abee919005ee$var$ne;
$6343abee919005ee$var$ne.blockSize = 1024, $6343abee919005ee$var$ne.outSize = 512, $6343abee919005ee$var$ne.hmacStrength = 192, $6343abee919005ee$var$ne.padLength = 128, $6343abee919005ee$var$ne.prototype._prepareBlock = function(t, r) {
    for(var i = this.W, n = 0; n < 32; n++)i[n] = t[r + n];
    for(; n < i.length; n += 2){
        var o = $6343abee919005ee$var$_a(i[n - 4], i[n - 3]), h = $6343abee919005ee$var$Ba(i[n - 4], i[n - 3]), p = i[n - 14], A = i[n - 13], m = $6343abee919005ee$var$Na(i[n - 30], i[n - 29]), w = $6343abee919005ee$var$Ia(i[n - 30], i[n - 29]), y = i[n - 32], S = i[n - 31];
        i[n] = $6343abee919005ee$var$da(o, h, p, A, m, w, y, S), i[n + 1] = $6343abee919005ee$var$pa(o, h, p, A, m, w, y, S);
    }
}, $6343abee919005ee$var$ne.prototype._update = function(t, r) {
    this._prepareBlock(t, r);
    var i = this.W, n = this.h[0], o = this.h[1], h = this.h[2], p = this.h[3], A = this.h[4], m = this.h[5], w = this.h[6], y = this.h[7], S = this.h[8], I = this.h[9], N = this.h[10], C = this.h[11], F = this.h[12], U = this.h[13], J = this.h[14], Bt = this.h[15];
    $6343abee919005ee$var$la(this.k.length === i.length);
    for(var G = 0; G < i.length; G += 2){
        var H = J, z = Bt, Pt = $6343abee919005ee$var$Ea(S, I), W = $6343abee919005ee$var$Sa(S, I), Rt = $6343abee919005ee$var$Aa(S, I, N, C, F), Yt = $6343abee919005ee$var$ba(S, I, N, C, F, U), Y = this.k[G], Vt = this.k[G + 1], b = i[G], f = i[G + 1], a = $6343abee919005ee$var$va(H, z, Pt, W, Rt, Yt, Y, Vt, b, f), c = $6343abee919005ee$var$ma(H, z, Pt, W, Rt, Yt, Y, Vt, b, f);
        H = $6343abee919005ee$var$xa(n, o), z = $6343abee919005ee$var$Ma(n, o), Pt = $6343abee919005ee$var$ya(n, o, h, p, A), W = $6343abee919005ee$var$wa(n, o, h, p, A, m);
        var d = $6343abee919005ee$var$Ci(H, z, Pt, W), g = $6343abee919005ee$var$Ri(H, z, Pt, W);
        J = F, Bt = U, F = N, U = C, N = S, C = I, S = $6343abee919005ee$var$Ci(w, y, a, c), I = $6343abee919005ee$var$Ri(y, y, a, c), w = A, y = m, A = h, m = p, h = n, p = o, n = $6343abee919005ee$var$Ci(a, c, d, g), o = $6343abee919005ee$var$Ri(a, c, d, g);
    }
    $6343abee919005ee$var$Be(this.h, 0, n, o), $6343abee919005ee$var$Be(this.h, 2, h, p), $6343abee919005ee$var$Be(this.h, 4, A, m), $6343abee919005ee$var$Be(this.h, 6, w, y), $6343abee919005ee$var$Be(this.h, 8, S, I), $6343abee919005ee$var$Be(this.h, 10, N, C), $6343abee919005ee$var$Be(this.h, 12, F, U), $6343abee919005ee$var$Be(this.h, 14, J, Bt);
}, $6343abee919005ee$var$ne.prototype._digest = function(t) {
    return t === "hex" ? $6343abee919005ee$var$jt.toHex32(this.h, "big") : $6343abee919005ee$var$jt.split32(this.h, "big");
};
function $6343abee919005ee$var$Aa(e, t, r, i, n) {
    var o = e & r ^ ~e & n;
    return o < 0 && (o += 4294967296), o;
}
function $6343abee919005ee$var$ba(e, t, r, i, n, o) {
    var h = t & i ^ ~t & o;
    return h < 0 && (h += 4294967296), h;
}
function $6343abee919005ee$var$ya(e, t, r, i, n) {
    var o = e & r ^ e & n ^ r & n;
    return o < 0 && (o += 4294967296), o;
}
function $6343abee919005ee$var$wa(e, t, r, i, n, o) {
    var h = t & i ^ t & o ^ i & o;
    return h < 0 && (h += 4294967296), h;
}
function $6343abee919005ee$var$xa(e, t) {
    var r = $6343abee919005ee$var$le(e, t, 28), i = $6343abee919005ee$var$le(t, e, 2), n = $6343abee919005ee$var$le(t, e, 7), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $6343abee919005ee$var$Ma(e, t) {
    var r = $6343abee919005ee$var$de(e, t, 28), i = $6343abee919005ee$var$de(t, e, 2), n = $6343abee919005ee$var$de(t, e, 7), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $6343abee919005ee$var$Ea(e, t) {
    var r = $6343abee919005ee$var$le(e, t, 14), i = $6343abee919005ee$var$le(e, t, 18), n = $6343abee919005ee$var$le(t, e, 9), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $6343abee919005ee$var$Sa(e, t) {
    var r = $6343abee919005ee$var$de(e, t, 14), i = $6343abee919005ee$var$de(e, t, 18), n = $6343abee919005ee$var$de(t, e, 9), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $6343abee919005ee$var$Na(e, t) {
    var r = $6343abee919005ee$var$le(e, t, 1), i = $6343abee919005ee$var$le(e, t, 8), n = $6343abee919005ee$var$wf(e, t, 7), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $6343abee919005ee$var$Ia(e, t) {
    var r = $6343abee919005ee$var$de(e, t, 1), i = $6343abee919005ee$var$de(e, t, 8), n = $6343abee919005ee$var$xf(e, t, 7), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $6343abee919005ee$var$_a(e, t) {
    var r = $6343abee919005ee$var$le(e, t, 19), i = $6343abee919005ee$var$le(t, e, 29), n = $6343abee919005ee$var$wf(e, t, 6), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $6343abee919005ee$var$Ba(e, t) {
    var r = $6343abee919005ee$var$de(e, t, 19), i = $6343abee919005ee$var$de(t, e, 29), n = $6343abee919005ee$var$xf(e, t, 6), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
var $6343abee919005ee$var$Oi = $6343abee919005ee$var$Q, $6343abee919005ee$var$Sf = $6343abee919005ee$var$Ef;
function $6343abee919005ee$var$we() {
    if (!(this instanceof $6343abee919005ee$var$we)) return new $6343abee919005ee$var$we;
    $6343abee919005ee$var$Sf.call(this), this.h = [
        3418070365,
        3238371032,
        1654270250,
        914150663,
        2438529370,
        812702999,
        355462360,
        4144912697,
        1731405415,
        4290775857,
        2394180231,
        1750603025,
        3675008525,
        1694076839,
        1203062813,
        3204075428
    ];
}
$6343abee919005ee$var$Oi.inherits($6343abee919005ee$var$we, $6343abee919005ee$var$Sf);
var $6343abee919005ee$var$Ca = $6343abee919005ee$var$we;
$6343abee919005ee$var$we.blockSize = 1024, $6343abee919005ee$var$we.outSize = 384, $6343abee919005ee$var$we.hmacStrength = 192, $6343abee919005ee$var$we.padLength = 128, $6343abee919005ee$var$we.prototype._digest = function(t) {
    return t === "hex" ? $6343abee919005ee$var$Oi.toHex32(this.h.slice(0, 12), "big") : $6343abee919005ee$var$Oi.split32(this.h.slice(0, 12), "big");
}, $6343abee919005ee$var$or.sha1 = $6343abee919005ee$var$Z0, $6343abee919005ee$var$or.sha224 = $6343abee919005ee$var$ha, $6343abee919005ee$var$or.sha256 = $6343abee919005ee$var$bf, $6343abee919005ee$var$or.sha384 = $6343abee919005ee$var$Ca, $6343abee919005ee$var$or.sha512 = $6343abee919005ee$var$Ef;
var $6343abee919005ee$var$Nf = {}, $6343abee919005ee$var$Xe = $6343abee919005ee$var$Q, $6343abee919005ee$var$Ra = $6343abee919005ee$var$fr, $6343abee919005ee$var$Tr = $6343abee919005ee$var$Xe.rotl32, $6343abee919005ee$var$If = $6343abee919005ee$var$Xe.sum32, $6343abee919005ee$var$xr = $6343abee919005ee$var$Xe.sum32_3, $6343abee919005ee$var$_f = $6343abee919005ee$var$Xe.sum32_4, $6343abee919005ee$var$Bf = $6343abee919005ee$var$Ra.BlockHash;
function $6343abee919005ee$var$pe() {
    if (!(this instanceof $6343abee919005ee$var$pe)) return new $6343abee919005ee$var$pe;
    $6343abee919005ee$var$Bf.call(this), this.h = [
        1732584193,
        4023233417,
        2562383102,
        271733878,
        3285377520
    ], this.endian = "little";
}
$6343abee919005ee$var$Xe.inherits($6343abee919005ee$var$pe, $6343abee919005ee$var$Bf), $6343abee919005ee$var$Nf.ripemd160 = $6343abee919005ee$var$pe, $6343abee919005ee$var$pe.blockSize = 512, $6343abee919005ee$var$pe.outSize = 160, $6343abee919005ee$var$pe.hmacStrength = 192, $6343abee919005ee$var$pe.padLength = 64, $6343abee919005ee$var$pe.prototype._update = function(t, r) {
    for(var i = this.h[0], n = this.h[1], o = this.h[2], h = this.h[3], p = this.h[4], A = i, m = n, w = o, y = h, S = p, I = 0; I < 80; I++){
        var N = $6343abee919005ee$var$If($6343abee919005ee$var$Tr($6343abee919005ee$var$_f(i, $6343abee919005ee$var$Cf(I, n, o, h), t[$6343abee919005ee$var$Da[I] + r], $6343abee919005ee$var$Oa(I)), $6343abee919005ee$var$Ta[I]), p);
        i = p, p = h, h = $6343abee919005ee$var$Tr(o, 10), o = n, n = N, N = $6343abee919005ee$var$If($6343abee919005ee$var$Tr($6343abee919005ee$var$_f(A, $6343abee919005ee$var$Cf(79 - I, m, w, y), t[$6343abee919005ee$var$Fa[I] + r], $6343abee919005ee$var$Pa(I)), $6343abee919005ee$var$Ua[I]), S), A = S, S = y, y = $6343abee919005ee$var$Tr(w, 10), w = m, m = N;
    }
    N = $6343abee919005ee$var$xr(this.h[1], o, y), this.h[1] = $6343abee919005ee$var$xr(this.h[2], h, S), this.h[2] = $6343abee919005ee$var$xr(this.h[3], p, A), this.h[3] = $6343abee919005ee$var$xr(this.h[4], i, m), this.h[4] = $6343abee919005ee$var$xr(this.h[0], n, w), this.h[0] = N;
}, $6343abee919005ee$var$pe.prototype._digest = function(t) {
    return t === "hex" ? $6343abee919005ee$var$Xe.toHex32(this.h, "little") : $6343abee919005ee$var$Xe.split32(this.h, "little");
};
function $6343abee919005ee$var$Cf(e, t, r, i) {
    return e <= 15 ? t ^ r ^ i : e <= 31 ? t & r | ~t & i : e <= 47 ? (t | ~r) ^ i : e <= 63 ? t & i | r & ~i : t ^ (r | ~i);
}
function $6343abee919005ee$var$Oa(e) {
    return e <= 15 ? 0 : e <= 31 ? 1518500249 : e <= 47 ? 1859775393 : e <= 63 ? 2400959708 : 2840853838;
}
function $6343abee919005ee$var$Pa(e) {
    return e <= 15 ? 1352829926 : e <= 31 ? 1548603684 : e <= 47 ? 1836072691 : e <= 63 ? 2053994217 : 0;
}
var $6343abee919005ee$var$Da = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
], $6343abee919005ee$var$Fa = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
], $6343abee919005ee$var$Ta = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
], $6343abee919005ee$var$Ua = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
], $6343abee919005ee$var$ka = $6343abee919005ee$var$Q, $6343abee919005ee$var$qa = $6343abee919005ee$var$yr;
function $6343abee919005ee$var$hr(e, t, r) {
    if (!(this instanceof $6343abee919005ee$var$hr)) return new $6343abee919005ee$var$hr(e, t, r);
    this.Hash = e, this.blockSize = e.blockSize / 8, this.outSize = e.outSize / 8, this.inner = null, this.outer = null, this._init($6343abee919005ee$var$ka.toArray(t, r));
}
var $6343abee919005ee$var$Ka = $6343abee919005ee$var$hr;
$6343abee919005ee$var$hr.prototype._init = function(t) {
    t.length > this.blockSize && (t = new this.Hash().update(t).digest()), $6343abee919005ee$var$qa(t.length <= this.blockSize);
    for(var r = t.length; r < this.blockSize; r++)t.push(0);
    for(r = 0; r < t.length; r++)t[r] ^= 54;
    for(this.inner = new this.Hash().update(t), r = 0; r < t.length; r++)t[r] ^= 106;
    this.outer = new this.Hash().update(t);
}, $6343abee919005ee$var$hr.prototype.update = function(t, r) {
    return this.inner.update(t, r), this;
}, $6343abee919005ee$var$hr.prototype.digest = function(t) {
    return this.outer.update(this.inner.digest()), this.outer.digest(t);
}, function(e) {
    var t = e;
    t.utils = $6343abee919005ee$var$Q, t.common = $6343abee919005ee$var$fr, t.sha = $6343abee919005ee$var$or, t.ripemd = $6343abee919005ee$var$Nf, t.hmac = $6343abee919005ee$var$Ka, t.sha1 = t.sha.sha1, t.sha256 = t.sha.sha256, t.sha224 = t.sha.sha224, t.sha384 = t.sha.sha384, t.sha512 = t.sha.sha512, t.ripemd160 = t.ripemd.ripemd160;
}($6343abee919005ee$var$se);
function $6343abee919005ee$var$cr(e, t, r) {
    return r = {
        path: t,
        exports: {},
        require: function require1(i, n) {
            return $6343abee919005ee$var$Ha(i, n !== null && n !== void 0 ? n : r.path);
        }
    }, e(r, r.exports), r.exports;
}
function $6343abee919005ee$var$Ha() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var $6343abee919005ee$var$Pi = $6343abee919005ee$var$Rf;
function $6343abee919005ee$var$Rf(e, t) {
    if (!e) throw new Error(t || "Assertion failed");
}
$6343abee919005ee$var$Rf.equal = function(t, r, i) {
    if (t != r) throw new Error(i || "Assertion failed: " + t + " != " + r);
};
var $6343abee919005ee$var$fe = $6343abee919005ee$var$cr(function(e, t) {
    var r = t;
    function i(h, p) {
        if (Array.isArray(h)) return h.slice();
        if (!h) return [];
        var A = [];
        if (typeof h != "string") {
            for(var m = 0; m < h.length; m++)A[m] = h[m] | 0;
            return A;
        }
        if (p === "hex") {
            h = h.replace(/[^a-z0-9]+/ig, ""), h.length % 2 !== 0 && (h = "0" + h);
            for(var m = 0; m < h.length; m += 2)A.push(parseInt(h[m] + h[m + 1], 16));
        } else for(var m = 0; m < h.length; m++){
            var w = h.charCodeAt(m), y = w >> 8, S = w & 255;
            y ? A.push(y, S) : A.push(S);
        }
        return A;
    }
    r.toArray = i;
    function n(h) {
        return h.length === 1 ? "0" + h : h;
    }
    r.zero2 = n;
    function o(h) {
        for(var p = "", A = 0; A < h.length; A++)p += n(h[A].toString(16));
        return p;
    }
    r.toHex = o, r.encode = function(p, A) {
        return A === "hex" ? o(p) : p;
    };
}), $6343abee919005ee$var$Jt = $6343abee919005ee$var$cr(function(e, t) {
    var r = t;
    r.assert = $6343abee919005ee$var$Pi, r.toArray = $6343abee919005ee$var$fe.toArray, r.zero2 = $6343abee919005ee$var$fe.zero2, r.toHex = $6343abee919005ee$var$fe.toHex, r.encode = $6343abee919005ee$var$fe.encode;
    function i(A, m, w) {
        var y = new Array(Math.max(A.bitLength(), w) + 1);
        y.fill(0);
        for(var S = 1 << m + 1, I = A.clone(), N = 0; N < y.length; N++){
            var C, F = I.andln(S - 1);
            I.isOdd() ? (F > (S >> 1) - 1 ? C = (S >> 1) - F : C = F, I.isubn(C)) : C = 0, y[N] = C, I.iushrn(1);
        }
        return y;
    }
    r.getNAF = i;
    function n(A, m) {
        var w = [
            [],
            []
        ];
        A = A.clone(), m = m.clone();
        for(var y = 0, S = 0, I; A.cmpn(-y) > 0 || m.cmpn(-S) > 0;){
            var N = A.andln(3) + y & 3, C = m.andln(3) + S & 3;
            N === 3 && (N = -1), C === 3 && (C = -1);
            var F;
            N & 1 ? (I = A.andln(7) + y & 7, (I === 3 || I === 5) && C === 2 ? F = -N : F = N) : F = 0, w[0].push(F);
            var U;
            C & 1 ? (I = m.andln(7) + S & 7, (I === 3 || I === 5) && N === 2 ? U = -C : U = C) : U = 0, w[1].push(U), 2 * y === F + 1 && (y = 1 - y), 2 * S === U + 1 && (S = 1 - S), A.iushrn(1), m.iushrn(1);
        }
        return w;
    }
    r.getJSF = n;
    function o(A, m, w) {
        var y = "_" + m;
        A.prototype[m] = function() {
            return this[y] !== void 0 ? this[y] : this[y] = w.call(this);
        };
    }
    r.cachedProperty = o;
    function h(A) {
        return typeof A == "string" ? r.toArray(A, "hex") : A;
    }
    r.parseBytes = h;
    function p(A) {
        return new $6343abee919005ee$var$K(A, "hex", "le");
    }
    r.intFromLE = p;
}), $6343abee919005ee$var$Ur = $6343abee919005ee$var$Jt.getNAF, $6343abee919005ee$var$za = $6343abee919005ee$var$Jt.getJSF, $6343abee919005ee$var$kr = $6343abee919005ee$var$Jt.assert;
function $6343abee919005ee$var$Ce(e, t) {
    this.type = e, this.p = new $6343abee919005ee$var$K(t.p, 16), this.red = t.prime ? $6343abee919005ee$var$K.red(t.prime) : $6343abee919005ee$var$K.mont(this.p), this.zero = new $6343abee919005ee$var$K(0).toRed(this.red), this.one = new $6343abee919005ee$var$K(1).toRed(this.red), this.two = new $6343abee919005ee$var$K(2).toRed(this.red), this.n = t.n && new $6343abee919005ee$var$K(t.n, 16), this.g = t.g && this.pointFromJSON(t.g, t.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
    var r = this.n && this.p.div(this.n);
    !r || r.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
}
var $6343abee919005ee$var$Ze = $6343abee919005ee$var$Ce;
$6343abee919005ee$var$Ce.prototype.point = function() {
    throw new Error("Not implemented");
}, $6343abee919005ee$var$Ce.prototype.validate = function() {
    throw new Error("Not implemented");
}, $6343abee919005ee$var$Ce.prototype._fixedNafMul = function(t, r) {
    $6343abee919005ee$var$kr(t.precomputed);
    var i = t._getDoubles(), n = $6343abee919005ee$var$Ur(r, 1, this._bitLength), o = (1 << i.step + 1) - (i.step % 2 === 0 ? 2 : 1);
    o /= 3;
    var h = [], p, A;
    for(p = 0; p < n.length; p += i.step){
        A = 0;
        for(var m = p + i.step - 1; m >= p; m--)A = (A << 1) + n[m];
        h.push(A);
    }
    for(var w = this.jpoint(null, null, null), y = this.jpoint(null, null, null), S = o; S > 0; S--){
        for(p = 0; p < h.length; p++)A = h[p], A === S ? y = y.mixedAdd(i.points[p]) : A === -S && (y = y.mixedAdd(i.points[p].neg()));
        w = w.add(y);
    }
    return w.toP();
}, $6343abee919005ee$var$Ce.prototype._wnafMul = function(t, r) {
    var i = 4, n = t._getNAFPoints(i);
    i = n.wnd;
    for(var o = n.points, h = $6343abee919005ee$var$Ur(r, i, this._bitLength), p = this.jpoint(null, null, null), A = h.length - 1; A >= 0; A--){
        for(var m = 0; A >= 0 && h[A] === 0; A--)m++;
        if (A >= 0 && m++, p = p.dblp(m), A < 0) break;
        var w = h[A];
        $6343abee919005ee$var$kr(w !== 0), t.type === "affine" ? w > 0 ? p = p.mixedAdd(o[w - 1 >> 1]) : p = p.mixedAdd(o[-w - 1 >> 1].neg()) : w > 0 ? p = p.add(o[w - 1 >> 1]) : p = p.add(o[-w - 1 >> 1].neg());
    }
    return t.type === "affine" ? p.toP() : p;
}, $6343abee919005ee$var$Ce.prototype._wnafMulAdd = function(t, r, i, n, o) {
    var h = this._wnafT1, p = this._wnafT2, A = this._wnafT3, m = 0, w, y, S;
    for(w = 0; w < n; w++){
        S = r[w];
        var I = S._getNAFPoints(t);
        h[w] = I.wnd, p[w] = I.points;
    }
    for(w = n - 1; w >= 1; w -= 2){
        var N = w - 1, C = w;
        if (h[N] !== 1 || h[C] !== 1) {
            A[N] = $6343abee919005ee$var$Ur(i[N], h[N], this._bitLength), A[C] = $6343abee919005ee$var$Ur(i[C], h[C], this._bitLength), m = Math.max(A[N].length, m), m = Math.max(A[C].length, m);
            continue;
        }
        var F = [
            r[N],
            null,
            null,
            r[C]
        ];
        r[N].y.cmp(r[C].y) === 0 ? (F[1] = r[N].add(r[C]), F[2] = r[N].toJ().mixedAdd(r[C].neg())) : r[N].y.cmp(r[C].y.redNeg()) === 0 ? (F[1] = r[N].toJ().mixedAdd(r[C]), F[2] = r[N].add(r[C].neg())) : (F[1] = r[N].toJ().mixedAdd(r[C]), F[2] = r[N].toJ().mixedAdd(r[C].neg()));
        var U = [
            -3,
            -1,
            -5,
            -7,
            0,
            7,
            5,
            1,
            3
        ], J = $6343abee919005ee$var$za(i[N], i[C]);
        for(m = Math.max(J[0].length, m), A[N] = new Array(m), A[C] = new Array(m), y = 0; y < m; y++){
            var Bt = J[0][y] | 0, G = J[1][y] | 0;
            A[N][y] = U[(Bt + 1) * 3 + (G + 1)], A[C][y] = 0, p[N] = F;
        }
    }
    var H = this.jpoint(null, null, null), z = this._wnafT4;
    for(w = m; w >= 0; w--){
        for(var Pt = 0; w >= 0;){
            var W = !0;
            for(y = 0; y < n; y++)z[y] = A[y][w] | 0, z[y] !== 0 && (W = !1);
            if (!W) break;
            Pt++, w--;
        }
        if (w >= 0 && Pt++, H = H.dblp(Pt), w < 0) break;
        for(y = 0; y < n; y++){
            var Rt = z[y];
            Rt !== 0 && (Rt > 0 ? S = p[y][Rt - 1 >> 1] : Rt < 0 && (S = p[y][-Rt - 1 >> 1].neg()), S.type === "affine" ? H = H.mixedAdd(S) : H = H.add(S));
        }
    }
    for(w = 0; w < n; w++)p[w] = null;
    return o ? H : H.toP();
};
function $6343abee919005ee$var$Xt(e, t) {
    this.curve = e, this.type = t, this.precomputed = null;
}
$6343abee919005ee$var$Ce.BasePoint = $6343abee919005ee$var$Xt, $6343abee919005ee$var$Xt.prototype.eq = function() {
    throw new Error("Not implemented");
}, $6343abee919005ee$var$Xt.prototype.validate = function() {
    return this.curve.validate(this);
}, $6343abee919005ee$var$Ce.prototype.decodePoint = function(t, r) {
    t = $6343abee919005ee$var$Jt.toArray(t, r);
    var i = this.p.byteLength();
    if ((t[0] === 4 || t[0] === 6 || t[0] === 7) && t.length - 1 === 2 * i) {
        t[0] === 6 ? $6343abee919005ee$var$kr(t[t.length - 1] % 2 === 0) : t[0] === 7 && $6343abee919005ee$var$kr(t[t.length - 1] % 2 === 1);
        var n = this.point(t.slice(1, 1 + i), t.slice(1 + i, 1 + 2 * i));
        return n;
    } else if ((t[0] === 2 || t[0] === 3) && t.length - 1 === i) return this.pointFromX(t.slice(1, 1 + i), t[0] === 3);
    throw new Error("Unknown point format");
}, $6343abee919005ee$var$Xt.prototype.encodeCompressed = function(t) {
    return this.encode(t, !0);
}, $6343abee919005ee$var$Xt.prototype._encode = function(t) {
    var r = this.curve.p.byteLength(), i = this.getX().toArray("be", r);
    return t ? [
        this.getY().isEven() ? 2 : 3
    ].concat(i) : [
        4
    ].concat(i, this.getY().toArray("be", r));
}, $6343abee919005ee$var$Xt.prototype.encode = function(t, r) {
    return $6343abee919005ee$var$Jt.encode(this._encode(r), t);
}, $6343abee919005ee$var$Xt.prototype.precompute = function(t) {
    if (this.precomputed) return this;
    var r = {
        doubles: null,
        naf: null,
        beta: null
    };
    return r.naf = this._getNAFPoints(8), r.doubles = this._getDoubles(4, t), r.beta = this._getBeta(), this.precomputed = r, this;
}, $6343abee919005ee$var$Xt.prototype._hasDoubles = function(t) {
    if (!this.precomputed) return !1;
    var r = this.precomputed.doubles;
    return r ? r.points.length >= Math.ceil((t.bitLength() + 1) / r.step) : !1;
}, $6343abee919005ee$var$Xt.prototype._getDoubles = function(t, r) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    for(var i = [
        this
    ], n = this, o = 0; o < r; o += t){
        for(var h = 0; h < t; h++)n = n.dbl();
        i.push(n);
    }
    return {
        step: t,
        points: i
    };
}, $6343abee919005ee$var$Xt.prototype._getNAFPoints = function(t) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    for(var r = [
        this
    ], i = (1 << t) - 1, n = i === 1 ? null : this.dbl(), o = 1; o < i; o++)r[o] = r[o - 1].add(n);
    return {
        wnd: t,
        points: r
    };
}, $6343abee919005ee$var$Xt.prototype._getBeta = function() {
    return null;
}, $6343abee919005ee$var$Xt.prototype.dblp = function(t) {
    for(var r = this, i = 0; i < t; i++)r = r.dbl();
    return r;
};
var $6343abee919005ee$var$Di = $6343abee919005ee$var$cr(function(e) {
    typeof Object.create == "function" ? e.exports = function(r, i) {
        i && (r.super_ = i, r.prototype = Object.create(i.prototype, {
            constructor: {
                value: r,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }));
    } : e.exports = function(r, i) {
        if (i) {
            r.super_ = i;
            var n = function n() {};
            n.prototype = i.prototype, r.prototype = new n, r.prototype.constructor = r;
        }
    };
}), $6343abee919005ee$var$La = $6343abee919005ee$var$Jt.assert;
function $6343abee919005ee$var$Zt(e) {
    $6343abee919005ee$var$Ze.call(this, "short", e), this.a = new $6343abee919005ee$var$K(e.a, 16).toRed(this.red), this.b = new $6343abee919005ee$var$K(e.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(e), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
}
$6343abee919005ee$var$Di($6343abee919005ee$var$Zt, $6343abee919005ee$var$Ze);
var $6343abee919005ee$var$ja = $6343abee919005ee$var$Zt;
$6343abee919005ee$var$Zt.prototype._getEndomorphism = function(t) {
    if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
        var r, i;
        if (t.beta) r = new $6343abee919005ee$var$K(t.beta, 16).toRed(this.red);
        else {
            var n = this._getEndoRoots(this.p);
            r = n[0].cmp(n[1]) < 0 ? n[0] : n[1], r = r.toRed(this.red);
        }
        if (t.lambda) i = new $6343abee919005ee$var$K(t.lambda, 16);
        else {
            var o = this._getEndoRoots(this.n);
            this.g.mul(o[0]).x.cmp(this.g.x.redMul(r)) === 0 ? i = o[0] : (i = o[1], $6343abee919005ee$var$La(this.g.mul(i).x.cmp(this.g.x.redMul(r)) === 0));
        }
        var h;
        return t.basis ? h = t.basis.map(function(p) {
            return {
                a: new $6343abee919005ee$var$K(p.a, 16),
                b: new $6343abee919005ee$var$K(p.b, 16)
            };
        }) : h = this._getEndoBasis(i), {
            beta: r,
            lambda: i,
            basis: h
        };
    }
}, $6343abee919005ee$var$Zt.prototype._getEndoRoots = function(t) {
    var r = t === this.p ? this.red : $6343abee919005ee$var$K.mont(t), i = new $6343abee919005ee$var$K(2).toRed(r).redInvm(), n = i.redNeg(), o = new $6343abee919005ee$var$K(3).toRed(r).redNeg().redSqrt().redMul(i), h = n.redAdd(o).fromRed(), p = n.redSub(o).fromRed();
    return [
        h,
        p
    ];
}, $6343abee919005ee$var$Zt.prototype._getEndoBasis = function(t) {
    for(var r = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), i = t, n = this.n.clone(), o = new $6343abee919005ee$var$K(1), h = new $6343abee919005ee$var$K(0), p = new $6343abee919005ee$var$K(0), A = new $6343abee919005ee$var$K(1), m, w, y, S, I, N, C, F = 0, U, J; i.cmpn(0) !== 0;){
        var Bt = n.div(i);
        U = n.sub(Bt.mul(i)), J = p.sub(Bt.mul(o));
        var G = A.sub(Bt.mul(h));
        if (!y && U.cmp(r) < 0) m = C.neg(), w = o, y = U.neg(), S = J;
        else if (y && ++F === 2) break;
        C = U, n = i, i = U, p = o, o = J, A = h, h = G;
    }
    I = U.neg(), N = J;
    var H = y.sqr().add(S.sqr()), z = I.sqr().add(N.sqr());
    return z.cmp(H) >= 0 && (I = m, N = w), y.negative && (y = y.neg(), S = S.neg()), I.negative && (I = I.neg(), N = N.neg()), [
        {
            a: y,
            b: S
        },
        {
            a: I,
            b: N
        }
    ];
}, $6343abee919005ee$var$Zt.prototype._endoSplit = function(t) {
    var r = this.endo.basis, i = r[0], n = r[1], o = n.b.mul(t).divRound(this.n), h = i.b.neg().mul(t).divRound(this.n), p = o.mul(i.a), A = h.mul(n.a), m = o.mul(i.b), w = h.mul(n.b), y = t.sub(p).sub(A), S = m.add(w).neg();
    return {
        k1: y,
        k2: S
    };
}, $6343abee919005ee$var$Zt.prototype.pointFromX = function(t, r) {
    t = new $6343abee919005ee$var$K(t, 16), t.red || (t = t.toRed(this.red));
    var i = t.redSqr().redMul(t).redIAdd(t.redMul(this.a)).redIAdd(this.b), n = i.redSqrt();
    if (n.redSqr().redSub(i).cmp(this.zero) !== 0) throw new Error("invalid point");
    var o = n.fromRed().isOdd();
    return (r && !o || !r && o) && (n = n.redNeg()), this.point(t, n);
}, $6343abee919005ee$var$Zt.prototype.validate = function(t) {
    if (t.inf) return !0;
    var r = t.x, i = t.y, n = this.a.redMul(r), o = r.redSqr().redMul(r).redIAdd(n).redIAdd(this.b);
    return i.redSqr().redISub(o).cmpn(0) === 0;
}, $6343abee919005ee$var$Zt.prototype._endoWnafMulAdd = function(t, r, i) {
    for(var n = this._endoWnafT1, o = this._endoWnafT2, h = 0; h < t.length; h++){
        var p = this._endoSplit(r[h]), A = t[h], m = A._getBeta();
        p.k1.negative && (p.k1.ineg(), A = A.neg(!0)), p.k2.negative && (p.k2.ineg(), m = m.neg(!0)), n[h * 2] = A, n[h * 2 + 1] = m, o[h * 2] = p.k1, o[h * 2 + 1] = p.k2;
    }
    for(var w = this._wnafMulAdd(1, n, o, h * 2, i), y = 0; y < h * 2; y++)n[y] = null, o[y] = null;
    return w;
};
function $6343abee919005ee$var$Ft(e, t, r, i) {
    $6343abee919005ee$var$Ze.BasePoint.call(this, e, "affine"), t === null && r === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new $6343abee919005ee$var$K(t, 16), this.y = new $6343abee919005ee$var$K(r, 16), i && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
}
$6343abee919005ee$var$Di($6343abee919005ee$var$Ft, $6343abee919005ee$var$Ze.BasePoint), $6343abee919005ee$var$Zt.prototype.point = function(t, r, i) {
    return new $6343abee919005ee$var$Ft(this, t, r, i);
}, $6343abee919005ee$var$Zt.prototype.pointFromJSON = function(t, r) {
    return $6343abee919005ee$var$Ft.fromJSON(this, t, r);
}, $6343abee919005ee$var$Ft.prototype._getBeta = function() {
    if (this.curve.endo) {
        var t = this.precomputed;
        if (t && t.beta) return t.beta;
        var r = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
        if (t) {
            var i = this.curve, n = function n(o) {
                return i.point(o.x.redMul(i.endo.beta), o.y);
            };
            t.beta = r, r.precomputed = {
                beta: null,
                naf: t.naf && {
                    wnd: t.naf.wnd,
                    points: t.naf.points.map(n)
                },
                doubles: t.doubles && {
                    step: t.doubles.step,
                    points: t.doubles.points.map(n)
                }
            };
        }
        return r;
    }
}, $6343abee919005ee$var$Ft.prototype.toJSON = function() {
    return this.precomputed ? [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ] : [
        this.x,
        this.y
    ];
}, $6343abee919005ee$var$Ft.fromJSON = function(t, r, i) {
    typeof r == "string" && (r = JSON.parse(r));
    var n = t.point(r[0], r[1], i);
    if (!r[2]) return n;
    function o(p) {
        return t.point(p[0], p[1], i);
    }
    var h = r[2];
    return n.precomputed = {
        beta: null,
        doubles: h.doubles && {
            step: h.doubles.step,
            points: [
                n
            ].concat(h.doubles.points.map(o))
        },
        naf: h.naf && {
            wnd: h.naf.wnd,
            points: [
                n
            ].concat(h.naf.points.map(o))
        }
    }, n;
}, $6343abee919005ee$var$Ft.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
}, $6343abee919005ee$var$Ft.prototype.isInfinity = function() {
    return this.inf;
}, $6343abee919005ee$var$Ft.prototype.add = function(t) {
    if (this.inf) return t;
    if (t.inf) return this;
    if (this.eq(t)) return this.dbl();
    if (this.neg().eq(t)) return this.curve.point(null, null);
    if (this.x.cmp(t.x) === 0) return this.curve.point(null, null);
    var r = this.y.redSub(t.y);
    r.cmpn(0) !== 0 && (r = r.redMul(this.x.redSub(t.x).redInvm()));
    var i = r.redSqr().redISub(this.x).redISub(t.x), n = r.redMul(this.x.redSub(i)).redISub(this.y);
    return this.curve.point(i, n);
}, $6343abee919005ee$var$Ft.prototype.dbl = function() {
    if (this.inf) return this;
    var t = this.y.redAdd(this.y);
    if (t.cmpn(0) === 0) return this.curve.point(null, null);
    var r = this.curve.a, i = this.x.redSqr(), n = t.redInvm(), o = i.redAdd(i).redIAdd(i).redIAdd(r).redMul(n), h = o.redSqr().redISub(this.x.redAdd(this.x)), p = o.redMul(this.x.redSub(h)).redISub(this.y);
    return this.curve.point(h, p);
}, $6343abee919005ee$var$Ft.prototype.getX = function() {
    return this.x.fromRed();
}, $6343abee919005ee$var$Ft.prototype.getY = function() {
    return this.y.fromRed();
}, $6343abee919005ee$var$Ft.prototype.mul = function(t) {
    return t = new $6343abee919005ee$var$K(t, 16), this.isInfinity() ? this : this._hasDoubles(t) ? this.curve._fixedNafMul(this, t) : this.curve.endo ? this.curve._endoWnafMulAdd([
        this
    ], [
        t
    ]) : this.curve._wnafMul(this, t);
}, $6343abee919005ee$var$Ft.prototype.mulAdd = function(t, r, i) {
    var n = [
        this,
        r
    ], o = [
        t,
        i
    ];
    return this.curve.endo ? this.curve._endoWnafMulAdd(n, o) : this.curve._wnafMulAdd(1, n, o, 2);
}, $6343abee919005ee$var$Ft.prototype.jmulAdd = function(t, r, i) {
    var n = [
        this,
        r
    ], o = [
        t,
        i
    ];
    return this.curve.endo ? this.curve._endoWnafMulAdd(n, o, !0) : this.curve._wnafMulAdd(1, n, o, 2, !0);
}, $6343abee919005ee$var$Ft.prototype.eq = function(t) {
    return this === t || this.inf === t.inf && (this.inf || this.x.cmp(t.x) === 0 && this.y.cmp(t.y) === 0);
}, $6343abee919005ee$var$Ft.prototype.neg = function(t) {
    if (this.inf) return this;
    var r = this.curve.point(this.x, this.y.redNeg());
    if (t && this.precomputed) {
        var i = this.precomputed, n = function n(o) {
            return o.neg();
        };
        r.precomputed = {
            naf: i.naf && {
                wnd: i.naf.wnd,
                points: i.naf.points.map(n)
            },
            doubles: i.doubles && {
                step: i.doubles.step,
                points: i.doubles.points.map(n)
            }
        };
    }
    return r;
}, $6343abee919005ee$var$Ft.prototype.toJ = function() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var t = this.curve.jpoint(this.x, this.y, this.curve.one);
    return t;
};
function $6343abee919005ee$var$Tt(e, t, r, i) {
    $6343abee919005ee$var$Ze.BasePoint.call(this, e, "jacobian"), t === null && r === null && i === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new $6343abee919005ee$var$K(0)) : (this.x = new $6343abee919005ee$var$K(t, 16), this.y = new $6343abee919005ee$var$K(r, 16), this.z = new $6343abee919005ee$var$K(i, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
}
$6343abee919005ee$var$Di($6343abee919005ee$var$Tt, $6343abee919005ee$var$Ze.BasePoint), $6343abee919005ee$var$Zt.prototype.jpoint = function(t, r, i) {
    return new $6343abee919005ee$var$Tt(this, t, r, i);
}, $6343abee919005ee$var$Tt.prototype.toP = function() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var t = this.z.redInvm(), r = t.redSqr(), i = this.x.redMul(r), n = this.y.redMul(r).redMul(t);
    return this.curve.point(i, n);
}, $6343abee919005ee$var$Tt.prototype.neg = function() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
}, $6343abee919005ee$var$Tt.prototype.add = function(t) {
    if (this.isInfinity()) return t;
    if (t.isInfinity()) return this;
    var r = t.z.redSqr(), i = this.z.redSqr(), n = this.x.redMul(r), o = t.x.redMul(i), h = this.y.redMul(r.redMul(t.z)), p = t.y.redMul(i.redMul(this.z)), A = n.redSub(o), m = h.redSub(p);
    if (A.cmpn(0) === 0) return m.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var w = A.redSqr(), y = w.redMul(A), S = n.redMul(w), I = m.redSqr().redIAdd(y).redISub(S).redISub(S), N = m.redMul(S.redISub(I)).redISub(h.redMul(y)), C = this.z.redMul(t.z).redMul(A);
    return this.curve.jpoint(I, N, C);
}, $6343abee919005ee$var$Tt.prototype.mixedAdd = function(t) {
    if (this.isInfinity()) return t.toJ();
    if (t.isInfinity()) return this;
    var r = this.z.redSqr(), i = this.x, n = t.x.redMul(r), o = this.y, h = t.y.redMul(r).redMul(this.z), p = i.redSub(n), A = o.redSub(h);
    if (p.cmpn(0) === 0) return A.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var m = p.redSqr(), w = m.redMul(p), y = i.redMul(m), S = A.redSqr().redIAdd(w).redISub(y).redISub(y), I = A.redMul(y.redISub(S)).redISub(o.redMul(w)), N = this.z.redMul(p);
    return this.curve.jpoint(S, I, N);
}, $6343abee919005ee$var$Tt.prototype.dblp = function(t) {
    if (t === 0) return this;
    if (this.isInfinity()) return this;
    if (!t) return this.dbl();
    var r;
    if (this.curve.zeroA || this.curve.threeA) {
        var i = this;
        for(r = 0; r < t; r++)i = i.dbl();
        return i;
    }
    var n = this.curve.a, o = this.curve.tinv, h = this.x, p = this.y, A = this.z, m = A.redSqr().redSqr(), w = p.redAdd(p);
    for(r = 0; r < t; r++){
        var y = h.redSqr(), S = w.redSqr(), I = S.redSqr(), N = y.redAdd(y).redIAdd(y).redIAdd(n.redMul(m)), C = h.redMul(S), F = N.redSqr().redISub(C.redAdd(C)), U = C.redISub(F), J = N.redMul(U);
        J = J.redIAdd(J).redISub(I);
        var Bt = w.redMul(A);
        r + 1 < t && (m = m.redMul(I)), h = F, A = Bt, w = J;
    }
    return this.curve.jpoint(h, w.redMul(o), A);
}, $6343abee919005ee$var$Tt.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
}, $6343abee919005ee$var$Tt.prototype._zeroDbl = function() {
    var t, r, i;
    if (this.zOne) {
        var n = this.x.redSqr(), o = this.y.redSqr(), h = o.redSqr(), p = this.x.redAdd(o).redSqr().redISub(n).redISub(h);
        p = p.redIAdd(p);
        var A = n.redAdd(n).redIAdd(n), m = A.redSqr().redISub(p).redISub(p), w = h.redIAdd(h);
        w = w.redIAdd(w), w = w.redIAdd(w), t = m, r = A.redMul(p.redISub(m)).redISub(w), i = this.y.redAdd(this.y);
    } else {
        var y = this.x.redSqr(), S = this.y.redSqr(), I = S.redSqr(), N = this.x.redAdd(S).redSqr().redISub(y).redISub(I);
        N = N.redIAdd(N);
        var C = y.redAdd(y).redIAdd(y), F = C.redSqr(), U = I.redIAdd(I);
        U = U.redIAdd(U), U = U.redIAdd(U), t = F.redISub(N).redISub(N), r = C.redMul(N.redISub(t)).redISub(U), i = this.y.redMul(this.z), i = i.redIAdd(i);
    }
    return this.curve.jpoint(t, r, i);
}, $6343abee919005ee$var$Tt.prototype._threeDbl = function() {
    var t, r, i;
    if (this.zOne) {
        var n = this.x.redSqr(), o = this.y.redSqr(), h = o.redSqr(), p = this.x.redAdd(o).redSqr().redISub(n).redISub(h);
        p = p.redIAdd(p);
        var A = n.redAdd(n).redIAdd(n).redIAdd(this.curve.a), m = A.redSqr().redISub(p).redISub(p);
        t = m;
        var w = h.redIAdd(h);
        w = w.redIAdd(w), w = w.redIAdd(w), r = A.redMul(p.redISub(m)).redISub(w), i = this.y.redAdd(this.y);
    } else {
        var y = this.z.redSqr(), S = this.y.redSqr(), I = this.x.redMul(S), N = this.x.redSub(y).redMul(this.x.redAdd(y));
        N = N.redAdd(N).redIAdd(N);
        var C = I.redIAdd(I);
        C = C.redIAdd(C);
        var F = C.redAdd(C);
        t = N.redSqr().redISub(F), i = this.y.redAdd(this.z).redSqr().redISub(S).redISub(y);
        var U = S.redSqr();
        U = U.redIAdd(U), U = U.redIAdd(U), U = U.redIAdd(U), r = N.redMul(C.redISub(t)).redISub(U);
    }
    return this.curve.jpoint(t, r, i);
}, $6343abee919005ee$var$Tt.prototype._dbl = function() {
    var t = this.curve.a, r = this.x, i = this.y, n = this.z, o = n.redSqr().redSqr(), h = r.redSqr(), p = i.redSqr(), A = h.redAdd(h).redIAdd(h).redIAdd(t.redMul(o)), m = r.redAdd(r);
    m = m.redIAdd(m);
    var w = m.redMul(p), y = A.redSqr().redISub(w.redAdd(w)), S = w.redISub(y), I = p.redSqr();
    I = I.redIAdd(I), I = I.redIAdd(I), I = I.redIAdd(I);
    var N = A.redMul(S).redISub(I), C = i.redAdd(i).redMul(n);
    return this.curve.jpoint(y, N, C);
}, $6343abee919005ee$var$Tt.prototype.trpl = function() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    var t = this.x.redSqr(), r = this.y.redSqr(), i = this.z.redSqr(), n = r.redSqr(), o = t.redAdd(t).redIAdd(t), h = o.redSqr(), p = this.x.redAdd(r).redSqr().redISub(t).redISub(n);
    p = p.redIAdd(p), p = p.redAdd(p).redIAdd(p), p = p.redISub(h);
    var A = p.redSqr(), m = n.redIAdd(n);
    m = m.redIAdd(m), m = m.redIAdd(m), m = m.redIAdd(m);
    var w = o.redIAdd(p).redSqr().redISub(h).redISub(A).redISub(m), y = r.redMul(w);
    y = y.redIAdd(y), y = y.redIAdd(y);
    var S = this.x.redMul(A).redISub(y);
    S = S.redIAdd(S), S = S.redIAdd(S);
    var I = this.y.redMul(w.redMul(m.redISub(w)).redISub(p.redMul(A)));
    I = I.redIAdd(I), I = I.redIAdd(I), I = I.redIAdd(I);
    var N = this.z.redAdd(p).redSqr().redISub(i).redISub(A);
    return this.curve.jpoint(S, I, N);
}, $6343abee919005ee$var$Tt.prototype.mul = function(t, r) {
    return t = new $6343abee919005ee$var$K(t, r), this.curve._wnafMul(this, t);
}, $6343abee919005ee$var$Tt.prototype.eq = function(t) {
    if (t.type === "affine") return this.eq(t.toJ());
    if (this === t) return !0;
    var r = this.z.redSqr(), i = t.z.redSqr();
    if (this.x.redMul(i).redISub(t.x.redMul(r)).cmpn(0) !== 0) return !1;
    var n = r.redMul(this.z), o = i.redMul(t.z);
    return this.y.redMul(o).redISub(t.y.redMul(n)).cmpn(0) === 0;
}, $6343abee919005ee$var$Tt.prototype.eqXToP = function(t) {
    var r = this.z.redSqr(), i = t.toRed(this.curve.red).redMul(r);
    if (this.x.cmp(i) === 0) return !0;
    for(var n = t.clone(), o = this.curve.redN.redMul(r);;){
        if (n.iadd(this.curve.n), n.cmp(this.curve.p) >= 0) return !1;
        if (i.redIAdd(o), this.x.cmp(i) === 0) return !0;
    }
}, $6343abee919005ee$var$Tt.prototype.inspect = function() {
    return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
}, $6343abee919005ee$var$Tt.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
};
var $6343abee919005ee$var$qr = $6343abee919005ee$var$cr(function(e, t) {
    var r = t;
    r.base = $6343abee919005ee$var$Ze, r.short = $6343abee919005ee$var$ja, r.mont = null, r.edwards = null;
}), $6343abee919005ee$var$Kr = $6343abee919005ee$var$cr(function(e, t) {
    var r = t, i = $6343abee919005ee$var$Jt.assert;
    function n(p) {
        p.type === "short" ? this.curve = new $6343abee919005ee$var$qr.short(p) : p.type === "edwards" ? this.curve = new $6343abee919005ee$var$qr.edwards(p) : this.curve = new $6343abee919005ee$var$qr.mont(p), this.g = this.curve.g, this.n = this.curve.n, this.hash = p.hash, i(this.g.validate(), "Invalid curve"), i(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    r.PresetCurve = n;
    function o(p, A) {
        Object.defineProperty(r, p, {
            configurable: !0,
            enumerable: !0,
            get: function get() {
                var m = new n(A);
                return Object.defineProperty(r, p, {
                    configurable: !0,
                    enumerable: !0,
                    value: m
                }), m;
            }
        });
    }
    o("p192", {
        type: "short",
        prime: "p192",
        p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
        b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
        n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
        hash: $6343abee919005ee$var$se.sha256,
        gRed: !1,
        g: [
            "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
            "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
        ]
    }), o("p224", {
        type: "short",
        prime: "p224",
        p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
        b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
        n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
        hash: $6343abee919005ee$var$se.sha256,
        gRed: !1,
        g: [
            "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
            "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
        ]
    }), o("p256", {
        type: "short",
        prime: null,
        p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
        a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
        b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
        n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
        hash: $6343abee919005ee$var$se.sha256,
        gRed: !1,
        g: [
            "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
            "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
        ]
    }), o("p384", {
        type: "short",
        prime: null,
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
        a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
        b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
        n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
        hash: $6343abee919005ee$var$se.sha384,
        gRed: !1,
        g: [
            "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
            "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
        ]
    }), o("p521", {
        type: "short",
        prime: null,
        p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
        a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
        b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
        n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
        hash: $6343abee919005ee$var$se.sha512,
        gRed: !1,
        g: [
            "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
            "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
        ]
    }), o("curve25519", {
        type: "mont",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "76d06",
        b: "1",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: $6343abee919005ee$var$se.sha256,
        gRed: !1,
        g: [
            "9"
        ]
    }), o("ed25519", {
        type: "edwards",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "-1",
        c: "1",
        d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: $6343abee919005ee$var$se.sha256,
        gRed: !1,
        g: [
            "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
            "6666666666666666666666666666666666666666666666666666666666666658"
        ]
    });
    var h;
    try {
        h = null.crash();
    } catch (e) {
        h = void 0;
    }
    o("secp256k1", {
        type: "short",
        prime: "k256",
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
        a: "0",
        b: "7",
        n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
        h: "1",
        hash: $6343abee919005ee$var$se.sha256,
        beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
        lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
        basis: [
            {
                a: "3086d221a7d46bcde86c90e49284eb15",
                b: "-e4437ed6010e88286f547fa90abfe4c3"
            },
            {
                a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                b: "3086d221a7d46bcde86c90e49284eb15"
            }
        ],
        gRed: !1,
        g: [
            "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
            "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
            h
        ]
    });
});
function $6343abee919005ee$var$Re(e) {
    if (!(this instanceof $6343abee919005ee$var$Re)) return new $6343abee919005ee$var$Re(e);
    this.hash = e.hash, this.predResist = !!e.predResist, this.outLen = this.hash.outSize, this.minEntropy = e.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
    var t = $6343abee919005ee$var$fe.toArray(e.entropy, e.entropyEnc || "hex"), r = $6343abee919005ee$var$fe.toArray(e.nonce, e.nonceEnc || "hex"), i = $6343abee919005ee$var$fe.toArray(e.pers, e.persEnc || "hex");
    $6343abee919005ee$var$Pi(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._init(t, r, i);
}
var $6343abee919005ee$var$Of = $6343abee919005ee$var$Re;
$6343abee919005ee$var$Re.prototype._init = function(t, r, i) {
    var n = t.concat(r).concat(i);
    this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
    for(var o = 0; o < this.V.length; o++)this.K[o] = 0, this.V[o] = 1;
    this._update(n), this._reseed = 1, this.reseedInterval = 281474976710656;
}, $6343abee919005ee$var$Re.prototype._hmac = function() {
    return new $6343abee919005ee$var$se.hmac(this.hash, this.K);
}, $6343abee919005ee$var$Re.prototype._update = function(t) {
    var r = this._hmac().update(this.V).update([
        0
    ]);
    t && (r = r.update(t)), this.K = r.digest(), this.V = this._hmac().update(this.V).digest(), t && (this.K = this._hmac().update(this.V).update([
        1
    ]).update(t).digest(), this.V = this._hmac().update(this.V).digest());
}, $6343abee919005ee$var$Re.prototype.reseed = function(t, r, i, n) {
    typeof r != "string" && (n = i, i = r, r = null), t = $6343abee919005ee$var$fe.toArray(t, r), i = $6343abee919005ee$var$fe.toArray(i, n), $6343abee919005ee$var$Pi(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._update(t.concat(i || [])), this._reseed = 1;
}, $6343abee919005ee$var$Re.prototype.generate = function(t, r, i, n) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    typeof r != "string" && (n = i, i = r, r = null), i && (i = $6343abee919005ee$var$fe.toArray(i, n || "hex"), this._update(i));
    for(var o = []; o.length < t;)this.V = this._hmac().update(this.V).digest(), o = o.concat(this.V);
    var h = o.slice(0, t);
    return this._update(i), this._reseed++, $6343abee919005ee$var$fe.encode(h, r);
};
var $6343abee919005ee$var$Fi = $6343abee919005ee$var$Jt.assert;
function $6343abee919005ee$var$kt(e, t) {
    this.ec = e, this.priv = null, this.pub = null, t.priv && this._importPrivate(t.priv, t.privEnc), t.pub && this._importPublic(t.pub, t.pubEnc);
}
var $6343abee919005ee$var$Ti = $6343abee919005ee$var$kt;
$6343abee919005ee$var$kt.fromPublic = function(t, r, i) {
    return r instanceof $6343abee919005ee$var$kt ? r : new $6343abee919005ee$var$kt(t, {
        pub: r,
        pubEnc: i
    });
}, $6343abee919005ee$var$kt.fromPrivate = function(t, r, i) {
    return r instanceof $6343abee919005ee$var$kt ? r : new $6343abee919005ee$var$kt(t, {
        priv: r,
        privEnc: i
    });
}, $6343abee919005ee$var$kt.prototype.validate = function() {
    var t = this.getPublic();
    return t.isInfinity() ? {
        result: !1,
        reason: "Invalid public key"
    } : t.validate() ? t.mul(this.ec.curve.n).isInfinity() ? {
        result: !0,
        reason: null
    } : {
        result: !1,
        reason: "Public key * N != O"
    } : {
        result: !1,
        reason: "Public key is not a point"
    };
}, $6343abee919005ee$var$kt.prototype.getPublic = function(t, r) {
    return typeof t == "string" && (r = t, t = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), r ? this.pub.encode(r, t) : this.pub;
}, $6343abee919005ee$var$kt.prototype.getPrivate = function(t) {
    return t === "hex" ? this.priv.toString(16, 2) : this.priv;
}, $6343abee919005ee$var$kt.prototype._importPrivate = function(t, r) {
    this.priv = new $6343abee919005ee$var$K(t, r || 16), this.priv = this.priv.umod(this.ec.curve.n);
}, $6343abee919005ee$var$kt.prototype._importPublic = function(t, r) {
    if (t.x || t.y) {
        this.ec.curve.type === "mont" ? $6343abee919005ee$var$Fi(t.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && $6343abee919005ee$var$Fi(t.x && t.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(t.x, t.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(t, r);
}, $6343abee919005ee$var$kt.prototype.derive = function(t) {
    return t.validate() || $6343abee919005ee$var$Fi(t.validate(), "public point not validated"), t.mul(this.priv).getX();
}, $6343abee919005ee$var$kt.prototype.sign = function(t, r, i) {
    return this.ec.sign(t, this, r, i);
}, $6343abee919005ee$var$kt.prototype.verify = function(t, r) {
    return this.ec.verify(t, r, this);
}, $6343abee919005ee$var$kt.prototype.inspect = function() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
var $6343abee919005ee$var$Qa = $6343abee919005ee$var$Jt.assert;
function $6343abee919005ee$var$Hr(e, t) {
    if (e instanceof $6343abee919005ee$var$Hr) return e;
    this._importDER(e, t) || ($6343abee919005ee$var$Qa(e.r && e.s, "Signature without r or s"), this.r = new $6343abee919005ee$var$K(e.r, 16), this.s = new $6343abee919005ee$var$K(e.s, 16), e.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = e.recoveryParam);
}
var $6343abee919005ee$var$zr = $6343abee919005ee$var$Hr;
function $6343abee919005ee$var$Ja() {
    this.place = 0;
}
function $6343abee919005ee$var$Ui(e, t) {
    var r = e[t.place++];
    if (!(r & 128)) return r;
    var i = r & 15;
    if (i === 0 || i > 4) return !1;
    for(var n = 0, o = 0, h = t.place; o < i; o++, h++)n <<= 8, n |= e[h], n >>>= 0;
    return n <= 127 ? !1 : (t.place = h, n);
}
function $6343abee919005ee$var$Pf(e) {
    for(var t = 0, r = e.length - 1; !e[t] && !(e[t + 1] & 128) && t < r;)t++;
    return t === 0 ? e : e.slice(t);
}
$6343abee919005ee$var$Hr.prototype._importDER = function(t, r) {
    t = $6343abee919005ee$var$Jt.toArray(t, r);
    var i = new $6343abee919005ee$var$Ja;
    if (t[i.place++] !== 48) return !1;
    var n = $6343abee919005ee$var$Ui(t, i);
    if (n === !1 || n + i.place !== t.length || t[i.place++] !== 2) return !1;
    var o = $6343abee919005ee$var$Ui(t, i);
    if (o === !1) return !1;
    var h = t.slice(i.place, o + i.place);
    if (i.place += o, t[i.place++] !== 2) return !1;
    var p = $6343abee919005ee$var$Ui(t, i);
    if (p === !1 || t.length !== p + i.place) return !1;
    var A = t.slice(i.place, p + i.place);
    if (h[0] === 0) {
        if (h[1] & 128) h = h.slice(1);
        else return !1;
    }
    if (A[0] === 0) {
        if (A[1] & 128) A = A.slice(1);
        else return !1;
    }
    return this.r = new $6343abee919005ee$var$K(h), this.s = new $6343abee919005ee$var$K(A), this.recoveryParam = null, !0;
};
function $6343abee919005ee$var$ki(e, t) {
    if (t < 128) {
        e.push(t);
        return;
    }
    var r = 1 + (Math.log(t) / Math.LN2 >>> 3);
    for(e.push(r | 128); --r;)e.push(t >>> (r << 3) & 255);
    e.push(t);
}
$6343abee919005ee$var$Hr.prototype.toDER = function(t) {
    var r = this.r.toArray(), i = this.s.toArray();
    for(r[0] & 128 && (r = [
        0
    ].concat(r)), i[0] & 128 && (i = [
        0
    ].concat(i)), r = $6343abee919005ee$var$Pf(r), i = $6343abee919005ee$var$Pf(i); !i[0] && !(i[1] & 128);)i = i.slice(1);
    var n = [
        2
    ];
    $6343abee919005ee$var$ki(n, r.length), n = n.concat(r), n.push(2), $6343abee919005ee$var$ki(n, i.length);
    var o = n.concat(i), h = [
        48
    ];
    return $6343abee919005ee$var$ki(h, o.length), h = h.concat(o), $6343abee919005ee$var$Jt.encode(h, t);
};
var $6343abee919005ee$var$Ga = function Ga() {
    throw new Error("unsupported");
}, $6343abee919005ee$var$Df = $6343abee919005ee$var$Jt.assert;
function $6343abee919005ee$var$$t(e) {
    if (!(this instanceof $6343abee919005ee$var$$t)) return new $6343abee919005ee$var$$t(e);
    typeof e == "string" && ($6343abee919005ee$var$Df(Object.prototype.hasOwnProperty.call($6343abee919005ee$var$Kr, e), "Unknown curve " + e), e = $6343abee919005ee$var$Kr[e]), e instanceof $6343abee919005ee$var$Kr.PresetCurve && (e = {
        curve: e
    }), this.curve = e.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = e.curve.g, this.g.precompute(e.curve.n.bitLength() + 1), this.hash = e.hash || e.curve.hash;
}
var $6343abee919005ee$var$Ya = $6343abee919005ee$var$$t;
$6343abee919005ee$var$$t.prototype.keyPair = function(t) {
    return new $6343abee919005ee$var$Ti(this, t);
}, $6343abee919005ee$var$$t.prototype.keyFromPrivate = function(t, r) {
    return $6343abee919005ee$var$Ti.fromPrivate(this, t, r);
}, $6343abee919005ee$var$$t.prototype.keyFromPublic = function(t, r) {
    return $6343abee919005ee$var$Ti.fromPublic(this, t, r);
}, $6343abee919005ee$var$$t.prototype.genKeyPair = function(t) {
    t || (t = {});
    for(var r = new $6343abee919005ee$var$Of({
        hash: this.hash,
        pers: t.pers,
        persEnc: t.persEnc || "utf8",
        entropy: t.entropy || $6343abee919005ee$var$Ga(this.hash.hmacStrength),
        entropyEnc: t.entropy && t.entropyEnc || "utf8",
        nonce: this.n.toArray()
    }), i = this.n.byteLength(), n = this.n.sub(new $6343abee919005ee$var$K(2));;){
        var o = new $6343abee919005ee$var$K(r.generate(i));
        if (!(o.cmp(n) > 0)) return o.iaddn(1), this.keyFromPrivate(o);
    }
}, $6343abee919005ee$var$$t.prototype._truncateToN = function(t, r) {
    var i = t.byteLength() * 8 - this.n.bitLength();
    return i > 0 && (t = t.ushrn(i)), !r && t.cmp(this.n) >= 0 ? t.sub(this.n) : t;
}, $6343abee919005ee$var$$t.prototype.sign = function(t, r, i, n) {
    typeof i == "object" && (n = i, i = null), n || (n = {}), r = this.keyFromPrivate(r, i), t = this._truncateToN(new $6343abee919005ee$var$K(t, 16));
    for(var o = this.n.byteLength(), h = r.getPrivate().toArray("be", o), p = t.toArray("be", o), A = new $6343abee919005ee$var$Of({
        hash: this.hash,
        entropy: h,
        nonce: p,
        pers: n.pers,
        persEnc: n.persEnc || "utf8"
    }), m = this.n.sub(new $6343abee919005ee$var$K(1)), w = 0;; w++){
        var y = n.k ? n.k(w) : new $6343abee919005ee$var$K(A.generate(this.n.byteLength()));
        if (y = this._truncateToN(y, !0), !(y.cmpn(1) <= 0 || y.cmp(m) >= 0)) {
            var S = this.g.mul(y);
            if (!S.isInfinity()) {
                var I = S.getX(), N = I.umod(this.n);
                if (N.cmpn(0) !== 0) {
                    var C = y.invm(this.n).mul(N.mul(r.getPrivate()).iadd(t));
                    if (C = C.umod(this.n), C.cmpn(0) !== 0) {
                        var F = (S.getY().isOdd() ? 1 : 0) | (I.cmp(N) !== 0 ? 2 : 0);
                        return n.canonical && C.cmp(this.nh) > 0 && (C = this.n.sub(C), F ^= 1), new $6343abee919005ee$var$zr({
                            r: N,
                            s: C,
                            recoveryParam: F
                        });
                    }
                }
            }
        }
    }
}, $6343abee919005ee$var$$t.prototype.verify = function(t, r, i, n) {
    t = this._truncateToN(new $6343abee919005ee$var$K(t, 16)), i = this.keyFromPublic(i, n), r = new $6343abee919005ee$var$zr(r, "hex");
    var o = r.r, h = r.s;
    if (o.cmpn(1) < 0 || o.cmp(this.n) >= 0 || h.cmpn(1) < 0 || h.cmp(this.n) >= 0) return !1;
    var p = h.invm(this.n), A = p.mul(t).umod(this.n), m = p.mul(o).umod(this.n), w;
    return this.curve._maxwellTrick ? (w = this.g.jmulAdd(A, i.getPublic(), m), w.isInfinity() ? !1 : w.eqXToP(o)) : (w = this.g.mulAdd(A, i.getPublic(), m), w.isInfinity() ? !1 : w.getX().umod(this.n).cmp(o) === 0);
}, $6343abee919005ee$var$$t.prototype.recoverPubKey = function(e, t, r, i) {
    $6343abee919005ee$var$Df((3 & r) === r, "The recovery param is more than two bits"), t = new $6343abee919005ee$var$zr(t, i);
    var n = this.n, o = new $6343abee919005ee$var$K(e), h = t.r, p = t.s, A = r & 1, m = r >> 1;
    if (h.cmp(this.curve.p.umod(this.curve.n)) >= 0 && m) throw new Error("Unable to find sencond key candinate");
    m ? h = this.curve.pointFromX(h.add(this.curve.n), A) : h = this.curve.pointFromX(h, A);
    var w = t.r.invm(n), y = n.sub(o).mul(w).umod(n), S = p.mul(w).umod(n);
    return this.g.mulAdd(y, h, S);
}, $6343abee919005ee$var$$t.prototype.getKeyRecoveryParam = function(e, t, r, i) {
    if (t = new $6343abee919005ee$var$zr(t, i), t.recoveryParam !== null) return t.recoveryParam;
    for(var n = 0; n < 4; n++){
        var o;
        try {
            o = this.recoverPubKey(e, t, n);
        } catch (e) {
            continue;
        }
        if (o.eq(r)) return n;
    }
    throw new Error("Unable to find valid recovery factor");
};
var $6343abee919005ee$var$Va = $6343abee919005ee$var$cr(function(e, t) {
    var r = t;
    r.version = "6.5.4", r.utils = $6343abee919005ee$var$Jt, r.rand = function() {
        throw new Error("unsupported");
    }, r.curve = $6343abee919005ee$var$qr, r.curves = $6343abee919005ee$var$Kr, r.ec = $6343abee919005ee$var$Ya, r.eddsa = null;
}), $6343abee919005ee$var$Wa = $6343abee919005ee$var$Va.ec;
var $6343abee919005ee$var$Xa = "signing-key/5.7.0", $6343abee919005ee$var$qi = new $6343abee919005ee$var$L($6343abee919005ee$var$Xa);
var $6343abee919005ee$var$Ki = null;
function $6343abee919005ee$var$ve() {
    return $6343abee919005ee$var$Ki || ($6343abee919005ee$var$Ki = new $6343abee919005ee$var$Wa("secp256k1")), $6343abee919005ee$var$Ki;
}
var $6343abee919005ee$var$Za = /*#__PURE__*/ function() {
    "use strict";
    function Za(t) {
        (0, $4GJKx._)(this, Za);
        $6343abee919005ee$var$br(this, "curve", "secp256k1"), $6343abee919005ee$var$br(this, "privateKey", $6343abee919005ee$var$Kt(t)), $6343abee919005ee$var$Os(this.privateKey) !== 32 && $6343abee919005ee$var$qi.throwArgumentError("invalid private key", "privateKey", "[[ REDACTED ]]");
        var r = $6343abee919005ee$var$ve().keyFromPrivate($6343abee919005ee$var$Ot(this.privateKey));
        $6343abee919005ee$var$br(this, "publicKey", "0x" + r.getPublic(!1, "hex")), $6343abee919005ee$var$br(this, "compressedPublicKey", "0x" + r.getPublic(!0, "hex")), $6343abee919005ee$var$br(this, "_isSigningKey", !0);
    }
    (0, $1wc17._)(Za, [
        {
            key: "_addPoint",
            value: function _addPoint(t) {
                var r = $6343abee919005ee$var$ve().keyFromPublic($6343abee919005ee$var$Ot(this.publicKey)), i = $6343abee919005ee$var$ve().keyFromPublic($6343abee919005ee$var$Ot(t));
                return "0x" + r.pub.add(i.pub).encodeCompressed("hex");
            }
        },
        {
            key: "signDigest",
            value: function signDigest(t) {
                var r = $6343abee919005ee$var$ve().keyFromPrivate($6343abee919005ee$var$Ot(this.privateKey)), i = $6343abee919005ee$var$Ot(t);
                i.length !== 32 && $6343abee919005ee$var$qi.throwArgumentError("bad digest length", "digest", t);
                var n = r.sign(i, {
                    canonical: !0
                });
                return $6343abee919005ee$var$Ln({
                    recoveryParam: n.recoveryParam,
                    r: $6343abee919005ee$var$oe("0x" + n.r.toString(16), 32),
                    s: $6343abee919005ee$var$oe("0x" + n.s.toString(16), 32)
                });
            }
        },
        {
            key: "computeSharedSecret",
            value: function computeSharedSecret(t) {
                var r = $6343abee919005ee$var$ve().keyFromPrivate($6343abee919005ee$var$Ot(this.privateKey)), i = $6343abee919005ee$var$ve().keyFromPublic($6343abee919005ee$var$Ot($6343abee919005ee$var$Ff(t)));
                return $6343abee919005ee$var$oe("0x" + r.derive(i.getPublic()).toString(16), 32);
            }
        }
    ], [
        {
            key: "isSigningKey",
            value: function isSigningKey(t) {
                return !!(t && t._isSigningKey);
            }
        }
    ]);
    return Za;
}();
function $6343abee919005ee$var$$a(e, t) {
    var r = $6343abee919005ee$var$Ln(t), i = {
        r: $6343abee919005ee$var$Ot(r.r),
        s: $6343abee919005ee$var$Ot(r.s)
    };
    return "0x" + $6343abee919005ee$var$ve().recoverPubKey($6343abee919005ee$var$Ot(e), i, r.recoveryParam).encode("hex", !1);
}
function $6343abee919005ee$var$Ff(e, t) {
    var r = $6343abee919005ee$var$Ot(e);
    if (r.length === 32) {
        var i = new $6343abee919005ee$var$Za(r);
        return t ? "0x" + $6343abee919005ee$var$ve().keyFromPrivate(r).getPublic(!0, "hex") : i.publicKey;
    } else {
        if (r.length === 33) return t ? $6343abee919005ee$var$Kt(r) : "0x" + $6343abee919005ee$var$ve().keyFromPublic(r).getPublic(!1, "hex");
        if (r.length === 65) return t ? "0x" + $6343abee919005ee$var$ve().keyFromPublic(r).getPublic(!0, "hex") : $6343abee919005ee$var$Kt(r);
    }
    return $6343abee919005ee$var$qi.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}
var $6343abee919005ee$var$tu = "transactions/5.7.0";
new $6343abee919005ee$var$L($6343abee919005ee$var$tu);
var $6343abee919005ee$var$Tf;
(function(e) {
    e[e.legacy = 0] = "legacy", e[e.eip2930 = 1] = "eip2930", e[e.eip1559 = 2] = "eip1559";
})($6343abee919005ee$var$Tf || ($6343abee919005ee$var$Tf = {}));
function $6343abee919005ee$var$eu(e) {
    var t = $6343abee919005ee$var$Ff(e);
    return $6343abee919005ee$var$h0($6343abee919005ee$var$zn($6343abee919005ee$var$yi($6343abee919005ee$var$zn(t, 1)), 12));
}
function $6343abee919005ee$var$ru(e, t) {
    return $6343abee919005ee$var$eu($6343abee919005ee$var$$a($6343abee919005ee$var$Ot(e), t));
}
var $6343abee919005ee$var$iu = "https://rpc.walletconnect.com/v1";
function $6343abee919005ee$export$ab54e47fdf2903bb(e, t, r, i, n, o) {
    return $6343abee919005ee$var$_Uf.apply(this, arguments);
}
function $6343abee919005ee$var$_Uf() {
    $6343abee919005ee$var$_Uf = (0, $kSuI9._)(function(e, t, r, i, n, o) {
        var _;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = r.t;
                    switch(_){
                        case "eip191":
                            return [
                                3,
                                1
                            ];
                        case "eip1271":
                            return [
                                3,
                                2
                            ];
                    }
                    return [
                        3,
                        4
                    ];
                case 1:
                    return [
                        2,
                        $6343abee919005ee$export$b5da105d64914e5a(e, t, r.s)
                    ];
                case 2:
                    return [
                        4,
                        $6343abee919005ee$export$9bffe3330373b76b(e, t, r.s, i, n, o)
                    ];
                case 3:
                    return [
                        2,
                        _state.sent()
                    ];
                case 4:
                    throw new Error("verifySignature failed: Attempted to verify CacaoSignature with unknown type: ".concat(r.t));
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return $6343abee919005ee$var$_Uf.apply(this, arguments);
}
function $6343abee919005ee$export$b5da105d64914e5a(e, t, r) {
    return $6343abee919005ee$var$ru($6343abee919005ee$var$of(t), r).toLowerCase() === e.toLowerCase();
}
function $6343abee919005ee$export$9bffe3330373b76b(e, t, r, i, n, o) {
    return $6343abee919005ee$var$_qf.apply(this, arguments);
}
function $6343abee919005ee$var$_qf() {
    $6343abee919005ee$var$_qf = (0, $kSuI9._)(function(e, t, r, i, n, o) {
        var _$h, p, A, m, w, y, S, _ref, I, h;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    _$h = "0x1626ba7e", p = "0000000000000000000000000000000000000000000000000000000000000040", A = "0000000000000000000000000000000000000000000000000000000000000041", m = r.substring(2), w = $6343abee919005ee$var$of(t).substring(2), y = _$h + w + p + A + m;
                    return [
                        4,
                        fetch("".concat(o || $6343abee919005ee$var$iu, "/?chainId=").concat(i, "&projectId=").concat(n), {
                            method: "POST",
                            body: JSON.stringify({
                                id: $6343abee919005ee$var$nu(),
                                jsonrpc: "2.0",
                                method: "eth_call",
                                params: [
                                    {
                                        to: e,
                                        data: y
                                    },
                                    "latest"
                                ]
                            })
                        })
                    ];
                case 1:
                    S = _state.sent();
                    return [
                        4,
                        S.json()
                    ];
                case 2:
                    _ref = _state.sent(), I = _ref.result;
                    return [
                        2,
                        I ? I.slice(0, _$h.length).toLowerCase() === _$h.toLowerCase() : !1
                    ];
                case 3:
                    h = _state.sent();
                    return [
                        2,
                        (console.error("isValidEip1271Signature: ", h), !1)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $6343abee919005ee$var$_qf.apply(this, arguments);
}
function $6343abee919005ee$var$nu() {
    return Date.now() + Math.floor(Math.random() * 1e3);
}
var $6343abee919005ee$var$fu = Object.defineProperty, $6343abee919005ee$var$ou = Object.defineProperties, $6343abee919005ee$var$su = Object.getOwnPropertyDescriptors, $6343abee919005ee$var$Kf = Object.getOwnPropertySymbols, $6343abee919005ee$var$au = Object.prototype.hasOwnProperty, $6343abee919005ee$var$uu = Object.prototype.propertyIsEnumerable, $6343abee919005ee$var$Hf = function(e, t, r) {
    return t in e ? $6343abee919005ee$var$fu(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r;
}, $6343abee919005ee$var$Hi = function(e, t) {
    for(var r in t || (t = {}))$6343abee919005ee$var$au.call(t, r) && $6343abee919005ee$var$Hf(e, r, t[r]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($6343abee919005ee$var$Kf) try {
        for(var _iterator = $6343abee919005ee$var$Kf(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var r = _step.value;
            $6343abee919005ee$var$uu.call(t, r) && $6343abee919005ee$var$Hf(e, r, t[r]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return e;
}, $6343abee919005ee$var$zf = function(e, t) {
    return $6343abee919005ee$var$ou(e, $6343abee919005ee$var$su(t));
};
var $6343abee919005ee$var$hu = "did:pkh:", $6343abee919005ee$export$a524ae552db7912 = function(e) {
    return e === null || e === void 0 ? void 0 : e.split(":");
}, $6343abee919005ee$export$85f23c05c80b194 = function(e) {
    var t = e && $6343abee919005ee$export$a524ae552db7912(e);
    if (t) return e.includes($6343abee919005ee$var$hu) ? t[3] : t[1];
}, $6343abee919005ee$export$a8b149927aef7051 = function(e) {
    var t = e && $6343abee919005ee$export$a524ae552db7912(e);
    if (t) return t[2] + ":" + t[3];
}, $6343abee919005ee$export$bf43cfbb4bd95de9 = function(e) {
    var t = e && $6343abee919005ee$export$a524ae552db7912(e);
    if (t) return t.pop();
};
function $6343abee919005ee$export$b7d566fce8e2b970(e) {
    return $6343abee919005ee$var$_lu.apply(this, arguments);
}
function $6343abee919005ee$var$_lu() {
    $6343abee919005ee$var$_lu = (0, $kSuI9._)(function(e) {
        var t, r, i, n, o, h;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    t = e.cacao, r = e.projectId, i = t.s, n = t.p, o = $6343abee919005ee$export$25868d1e8e76735f(n, n.iss), h = $6343abee919005ee$export$bf43cfbb4bd95de9(n.iss);
                    return [
                        4,
                        $6343abee919005ee$export$ab54e47fdf2903bb(h, o, i, $6343abee919005ee$export$85f23c05c80b194(n.iss), r)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return $6343abee919005ee$var$_lu.apply(this, arguments);
}
var $6343abee919005ee$export$25868d1e8e76735f = function(e, t) {
    var r = "".concat(e.domain, " wants you to sign in with your Ethereum account:"), i = $6343abee919005ee$export$bf43cfbb4bd95de9(t);
    if (!e.aud && !e.uri) throw new Error("Either `aud` or `uri` is required to construct the message");
    var n = e.statement || void 0;
    var o = "URI: ".concat(e.aud || e.uri), h = "Version: ".concat(e.version), p = "Chain ID: ".concat($6343abee919005ee$export$85f23c05c80b194(t)), A = "Nonce: ".concat(e.nonce), m = "Issued At: ".concat(e.iat), w = e.exp ? "Expiration Time: ".concat(e.exp) : void 0, y = e.nbf ? "Not Before: ".concat(e.nbf) : void 0, S = e.requestId ? "Request ID: ".concat(e.requestId) : void 0, I = e.resources ? "Resources:".concat(e.resources.map(function(C) {
        return "\n- ".concat(C);
    }).join("")) : void 0, N = $6343abee919005ee$export$3bb18ae0fb9a9fa9(e.resources);
    if (N) {
        var C = $6343abee919005ee$export$d34522c9e5a1aed1(N);
        n = $6343abee919005ee$export$51673931d3a8308d(n, C);
    }
    return [
        r,
        i,
        "",
        n,
        "",
        o,
        h,
        p,
        A,
        m,
        w,
        y,
        S,
        I
    ].filter(function(C) {
        return C != null;
    }).join("\n");
};
function $6343abee919005ee$export$905974078a05d5f9(e, t, r) {
    return r.includes("did:pkh:") || (r = "did:pkh:".concat(r)), {
        h: {
            t: "caip122"
        },
        p: {
            iss: r,
            domain: e.domain,
            aud: e.aud,
            version: e.version,
            nonce: e.nonce,
            iat: e.iat,
            statement: e.statement,
            requestId: e.requestId,
            resources: e.resources,
            nbf: e.nbf,
            exp: e.exp
        },
        s: t
    };
}
function $6343abee919005ee$export$2bfa2ac7d9bc193c(e) {
    var t;
    var r = e.authPayload, i = e.chains, n = e.methods, o = r.statement || "";
    if (!(i != null && i.length)) return r;
    var h = r.chains, p = $6343abee919005ee$export$f8aaf09178dd8b96(h, i);
    if (!(p != null && p.length)) throw new Error("No supported chains");
    var A = $6343abee919005ee$export$8db308c294c84efd(r.resources);
    if (!A) return r;
    $6343abee919005ee$export$ae8075c482503f32(A);
    var m = $6343abee919005ee$export$9595a56724061288(A, "eip155");
    var w = (r === null || r === void 0 ? void 0 : r.resources) || [];
    if (m != null && m.length) {
        var y = $6343abee919005ee$export$e1a9af3d61db3b68(m), S = $6343abee919005ee$export$f8aaf09178dd8b96(y, n);
        if (!(S != null && S.length)) throw new Error("Supported methods don't satisfy the requested: ".concat(JSON.stringify(y), ", supported: ").concat(JSON.stringify(n)));
        var I = $6343abee919005ee$export$987cafd76db78dd1("request", S, {
            chains: p
        }), N = $6343abee919005ee$export$317cb0007b0867c1(A, "eip155", I);
        w = ((t = r === null || r === void 0 ? void 0 : r.resources) == null ? void 0 : t.slice(0, -1)) || [], w.push($6343abee919005ee$export$79a538532b4f11f7(N));
    }
    return $6343abee919005ee$var$zf($6343abee919005ee$var$Hi({}, r), {
        statement: $6343abee919005ee$export$fb351782bc6f001e(o, $6343abee919005ee$export$3bb18ae0fb9a9fa9(w)),
        chains: p,
        resources: r != null && r.resources || w.length > 0 ? w : void 0
    });
}
function $6343abee919005ee$export$8db308c294c84efd(e) {
    var t = $6343abee919005ee$export$3bb18ae0fb9a9fa9(e);
    if (t && $6343abee919005ee$export$d9f11bd9fec5a64(t)) return $6343abee919005ee$export$d34522c9e5a1aed1(t);
}
function $6343abee919005ee$export$771534f1eaa353c(e, t) {
    var r;
    return (r = e === null || e === void 0 ? void 0 : e.att) == null ? void 0 : r.hasOwnProperty(t);
}
function $6343abee919005ee$export$9595a56724061288(e, t) {
    var r, i;
    return (r = e === null || e === void 0 ? void 0 : e.att) != null && r[t] ? Object.keys((i = e === null || e === void 0 ? void 0 : e.att) == null ? void 0 : i[t]) : [];
}
function $6343abee919005ee$export$d4548b739f9dafe(e) {
    return (e === null || e === void 0 ? void 0 : e.map(function(t) {
        return Object.keys(t);
    })) || [];
}
function $6343abee919005ee$export$e1a9af3d61db3b68(e) {
    return (e === null || e === void 0 ? void 0 : e.map(function(t) {
        var r;
        return (r = t.split("/")) == null ? void 0 : r[1];
    })) || [];
}
function $6343abee919005ee$export$e510a73ee562749(e) {
    return $6343abee919005ee$require$Buffer.from(JSON.stringify(e)).toString("base64");
}
function $6343abee919005ee$export$c62426fdd000a97e(e) {
    return JSON.parse($6343abee919005ee$require$Buffer.from(e, "base64").toString("utf-8"));
}
function $6343abee919005ee$export$ae8075c482503f32(e) {
    if (!e) throw new Error("No recap provided, value is undefined");
    if (!e.att) throw new Error("No `att` property found");
    var t = Object.keys(e.att);
    if (!(t != null && t.length)) throw new Error("No resources found in `att` property");
    t.forEach(function(r) {
        var i = e.att[r];
        if (Array.isArray(i)) throw new Error("Resource must be an object: ".concat(r));
        if (typeof i != "object") throw new Error("Resource must be an object: ".concat(r));
        if (!Object.keys(i).length) throw new Error("Resource object is empty: ".concat(r));
        Object.keys(i).forEach(function(n) {
            var o = i[n];
            if (!Array.isArray(o)) throw new Error("Ability limits ".concat(n, " must be an array of objects, found: ").concat(o));
            if (!o.length) throw new Error("Value of ".concat(n, " is empty array, must be an array with objects"));
            o.forEach(function(h) {
                if (typeof h != "object") throw new Error("Ability limits (".concat(n, ") must be an array of objects, found: ").concat(h));
            });
        });
    });
}
function $6343abee919005ee$export$eea18a04b33506ed(e, t, r) {
    var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return r === null || r === void 0 ? void 0 : r.sort(function(n, o) {
        return n.localeCompare(o);
    }), {
        att: (0, $3sHb8._)({}, e, $6343abee919005ee$export$987cafd76db78dd1(t, r, i))
    };
}
function $6343abee919005ee$export$317cb0007b0867c1(e, t, r) {
    var i;
    return e.att[t] = $6343abee919005ee$var$Hi({}, r), ((i = Object.keys(e.att)) == null ? void 0 : i.sort(function(n, o) {
        return n.localeCompare(o);
    })).reduce(function(n, o) {
        return n.att[o] = e.att[o], n;
    }, {
        att: {}
    });
}
function $6343abee919005ee$export$987cafd76db78dd1(e, t) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _Object;
    t = t === null || t === void 0 ? void 0 : t.sort(function(n, o) {
        return n.localeCompare(o);
    });
    var i = t.map(function(n) {
        return (0, $3sHb8._)({}, "".concat(e, "/").concat(n), [
            r
        ]);
    });
    return (_Object = Object).assign.apply(_Object, [
        {}
    ].concat((0, $c6Xmf._)(i)));
}
function $6343abee919005ee$export$79a538532b4f11f7(e) {
    return $6343abee919005ee$export$ae8075c482503f32(e), "urn:recap:".concat($6343abee919005ee$export$e510a73ee562749(e).replace(/=/g, ""));
}
function $6343abee919005ee$export$d34522c9e5a1aed1(e) {
    var t = $6343abee919005ee$export$c62426fdd000a97e(e.replace("urn:recap:", ""));
    return $6343abee919005ee$export$ae8075c482503f32(t), t;
}
function $6343abee919005ee$export$2bc35d2a08a09ad5(e, t, r) {
    var i = $6343abee919005ee$export$eea18a04b33506ed(e, t, r);
    return $6343abee919005ee$export$79a538532b4f11f7(i);
}
function $6343abee919005ee$export$d9f11bd9fec5a64(e) {
    return e && e.includes("urn:recap:");
}
function $6343abee919005ee$export$c7a40c552af428b5(e, t) {
    var r = $6343abee919005ee$export$d34522c9e5a1aed1(e), i = $6343abee919005ee$export$d34522c9e5a1aed1(t), n = $6343abee919005ee$export$2445df2492ef2cbd(r, i);
    return $6343abee919005ee$export$79a538532b4f11f7(n);
}
function $6343abee919005ee$export$2445df2492ef2cbd(e, t) {
    $6343abee919005ee$export$ae8075c482503f32(e), $6343abee919005ee$export$ae8075c482503f32(t);
    var r = Object.keys(e.att).concat(Object.keys(t.att)).sort(function(n, o) {
        return n.localeCompare(o);
    }), i = {
        att: {}
    };
    return r.forEach(function(n) {
        var o, h;
        Object.keys(((o = e.att) == null ? void 0 : o[n]) || {}).concat(Object.keys(((h = t.att) == null ? void 0 : h[n]) || {})).sort(function(p, A) {
            return p.localeCompare(A);
        }).forEach(function(p) {
            var A, m;
            i.att[n] = $6343abee919005ee$var$zf($6343abee919005ee$var$Hi({}, i.att[n]), (0, $3sHb8._)({}, p, ((A = e.att[n]) == null ? void 0 : A[p]) || ((m = t.att[n]) == null ? void 0 : m[p])));
        });
    }), i;
}
function $6343abee919005ee$export$51673931d3a8308d() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 ? arguments[1] : void 0;
    $6343abee919005ee$export$ae8075c482503f32(t);
    var r = "I further authorize the stated URI to perform the following actions on my behalf: ";
    if (e.includes(r)) return e;
    var i = [];
    var n = 0;
    Object.keys(t.att).forEach(function(p) {
        var A = Object.keys(t.att[p]).map(function(y) {
            return {
                ability: y.split("/")[0],
                action: y.split("/")[1]
            };
        });
        A.sort(function(y, S) {
            return y.action.localeCompare(S.action);
        });
        var m = {};
        A.forEach(function(y) {
            m[y.ability] || (m[y.ability] = []), m[y.ability].push(y.action);
        });
        var w = Object.keys(m).map(function(y) {
            return n++, "(".concat(n, ") '").concat(y, "': '").concat(m[y].join("', '"), "' for '").concat(p, "'.");
        });
        i.push(w.join(", ").replace(".,", "."));
    });
    var o = i.join(" "), h = "".concat(r).concat(o);
    return "".concat(e ? e + " " : "").concat(h);
}
function $6343abee919005ee$export$d6c6a43d36418efe(e) {
    var t;
    var r = $6343abee919005ee$export$d34522c9e5a1aed1(e);
    $6343abee919005ee$export$ae8075c482503f32(r);
    var i = (t = r.att) == null ? void 0 : t.eip155;
    return i ? Object.keys(i).map(function(n) {
        return n.split("/")[1];
    }) : [];
}
function $6343abee919005ee$export$372f88051a611988(e) {
    var t = $6343abee919005ee$export$d34522c9e5a1aed1(e);
    $6343abee919005ee$export$ae8075c482503f32(t);
    var r = [];
    return Object.values(t.att).forEach(function(i) {
        Object.values(i).forEach(function(n) {
            var o;
            (o = n === null || n === void 0 ? void 0 : n[0]) != null && o.chains && r.push(n[0].chains);
        });
    }), (0, $c6Xmf._)(new Set(r.flat()));
}
function $6343abee919005ee$export$fb351782bc6f001e(e, t) {
    if (!t) return e;
    var r = $6343abee919005ee$export$d34522c9e5a1aed1(t);
    return $6343abee919005ee$export$ae8075c482503f32(r), $6343abee919005ee$export$51673931d3a8308d(e, r);
}
function $6343abee919005ee$export$3bb18ae0fb9a9fa9(e) {
    if (!e) return;
    var t = e === null || e === void 0 ? void 0 : e[e.length - 1];
    return $6343abee919005ee$export$d9f11bd9fec5a64(t) ? t : void 0;
}
var $6343abee919005ee$var$wu = Object.defineProperty, $6343abee919005ee$var$xu = Object.defineProperties, $6343abee919005ee$var$Mu = Object.getOwnPropertyDescriptors, $6343abee919005ee$var$$f = Object.getOwnPropertySymbols, $6343abee919005ee$var$Eu = Object.prototype.hasOwnProperty, $6343abee919005ee$var$Su = Object.prototype.propertyIsEnumerable, $6343abee919005ee$var$to = function(e, t, r) {
    return t in e ? $6343abee919005ee$var$wu(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r;
}, $6343abee919005ee$var$Nu = function(e, t) {
    for(var r in t || (t = {}))$6343abee919005ee$var$Eu.call(t, r) && $6343abee919005ee$var$to(e, r, t[r]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($6343abee919005ee$var$$f) try {
        for(var _iterator = $6343abee919005ee$var$$f(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var r = _step.value;
            $6343abee919005ee$var$Su.call(t, r) && $6343abee919005ee$var$to(e, r, t[r]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return e;
}, $6343abee919005ee$var$Iu = function(e, t) {
    return $6343abee919005ee$var$xu(e, $6343abee919005ee$var$Mu(t));
};
var $6343abee919005ee$export$f7403969428298bd = "base10", $6343abee919005ee$export$49eb910ab2518105 = "base16", $6343abee919005ee$export$9bff723d552e6bcf = "base64pad", $6343abee919005ee$export$9560dad2a83e4f04 = "utf8", $6343abee919005ee$export$3425bd336a9673d8 = 0, $6343abee919005ee$export$406e97c329f0f3d4 = 1, $6343abee919005ee$var$_u = 0, $6343abee919005ee$var$eo = 1, $6343abee919005ee$var$Vi = 12, $6343abee919005ee$var$Wi = 32;
function $6343abee919005ee$export$a949d36eab55b41f() {
    var e = $1fnK2.generateKeyPair();
    return {
        privateKey: (0, $ewlTP.toString)(e.secretKey, $6343abee919005ee$export$49eb910ab2518105),
        publicKey: (0, $ewlTP.toString)(e.publicKey, $6343abee919005ee$export$49eb910ab2518105)
    };
}
function $6343abee919005ee$export$d15a28e4f1821243() {
    var e = (0, $5A0yG.randomBytes)($6343abee919005ee$var$Wi);
    return (0, $ewlTP.toString)(e, $6343abee919005ee$export$49eb910ab2518105);
}
function $6343abee919005ee$export$f8378f68e053f5c6(e, t) {
    var r = $1fnK2.sharedKey((0, $l7Yp4.fromString)(e, $6343abee919005ee$export$49eb910ab2518105), (0, $l7Yp4.fromString)(t, $6343abee919005ee$export$49eb910ab2518105), !0), i = new (0, $atJCh.HKDF)((0, $27vAG.SHA256), r).expand($6343abee919005ee$var$Wi);
    return (0, $ewlTP.toString)(i, $6343abee919005ee$export$49eb910ab2518105);
}
function $6343abee919005ee$export$1e87d19d4aab5805(e) {
    var t = (0, $27vAG.hash)((0, $l7Yp4.fromString)(e, $6343abee919005ee$export$49eb910ab2518105));
    return (0, $ewlTP.toString)(t, $6343abee919005ee$export$49eb910ab2518105);
}
function $6343abee919005ee$export$d4c241cec96564c1(e) {
    var t = (0, $27vAG.hash)((0, $l7Yp4.fromString)(e, $6343abee919005ee$export$9560dad2a83e4f04));
    return (0, $ewlTP.toString)(t, $6343abee919005ee$export$49eb910ab2518105);
}
function $6343abee919005ee$export$e9d2f9ba70428fb6(e) {
    return (0, $l7Yp4.fromString)("".concat(e), $6343abee919005ee$export$f7403969428298bd);
}
function $6343abee919005ee$export$7547a514ee29b9d4(e) {
    return Number((0, $ewlTP.toString)(e, $6343abee919005ee$export$f7403969428298bd));
}
function $6343abee919005ee$export$5b0f6292f11d1d18(e) {
    var t = $6343abee919005ee$export$e9d2f9ba70428fb6((0, $l0HdX._)(e.type) < "u" ? e.type : $6343abee919005ee$export$3425bd336a9673d8);
    if ($6343abee919005ee$export$7547a514ee29b9d4(t) === $6343abee919005ee$export$406e97c329f0f3d4 && (0, $l0HdX._)(e.senderPublicKey) > "u") throw new Error("Missing sender public key for type 1 envelope");
    var r = (0, $l0HdX._)(e.senderPublicKey) < "u" ? (0, $l7Yp4.fromString)(e.senderPublicKey, $6343abee919005ee$export$49eb910ab2518105) : void 0, i = (0, $l0HdX._)(e.iv) < "u" ? (0, $l7Yp4.fromString)(e.iv, $6343abee919005ee$export$49eb910ab2518105) : (0, $5A0yG.randomBytes)($6343abee919005ee$var$Vi), n = new (0, $1MbOp.ChaCha20Poly1305)((0, $l7Yp4.fromString)(e.symKey, $6343abee919005ee$export$49eb910ab2518105)).seal(i, (0, $l7Yp4.fromString)(e.message, $6343abee919005ee$export$9560dad2a83e4f04));
    return $6343abee919005ee$export$dfdc1655ccc5b9cb({
        type: t,
        sealed: n,
        iv: i,
        senderPublicKey: r
    });
}
function $6343abee919005ee$export$e85a0c9a1067c5d3(e) {
    var t = new (0, $1MbOp.ChaCha20Poly1305)((0, $l7Yp4.fromString)(e.symKey, $6343abee919005ee$export$49eb910ab2518105)), _Xi = $6343abee919005ee$export$efcd34ab6248d3cd(e.encoded), r = _Xi.sealed, i = _Xi.iv, n = t.open(i, r);
    if (n === null) throw new Error("Failed to decrypt");
    return (0, $ewlTP.toString)(n, $6343abee919005ee$export$9560dad2a83e4f04);
}
function $6343abee919005ee$export$dfdc1655ccc5b9cb(e) {
    if ($6343abee919005ee$export$7547a514ee29b9d4(e.type) === $6343abee919005ee$export$406e97c329f0f3d4) {
        if ((0, $l0HdX._)(e.senderPublicKey) > "u") throw new Error("Missing sender public key for type 1 envelope");
        return (0, $ewlTP.toString)((0, $lQfAa.concat)([
            e.type,
            e.senderPublicKey,
            e.iv,
            e.sealed
        ]), $6343abee919005ee$export$9bff723d552e6bcf);
    }
    return (0, $ewlTP.toString)((0, $lQfAa.concat)([
        e.type,
        e.iv,
        e.sealed
    ]), $6343abee919005ee$export$9bff723d552e6bcf);
}
function $6343abee919005ee$export$efcd34ab6248d3cd(e) {
    var t = (0, $l7Yp4.fromString)(e, $6343abee919005ee$export$9bff723d552e6bcf), r = t.slice($6343abee919005ee$var$_u, $6343abee919005ee$var$eo), i = $6343abee919005ee$var$eo;
    if ($6343abee919005ee$export$7547a514ee29b9d4(r) === $6343abee919005ee$export$406e97c329f0f3d4) {
        var p = i + $6343abee919005ee$var$Wi, A = p + $6343abee919005ee$var$Vi, m = t.slice(i, p), w = t.slice(p, A), y = t.slice(A);
        return {
            type: r,
            sealed: y,
            iv: w,
            senderPublicKey: m
        };
    }
    var n = i + $6343abee919005ee$var$Vi, o = t.slice(i, n), h = t.slice(n);
    return {
        type: r,
        sealed: h,
        iv: o
    };
}
function $6343abee919005ee$export$177f3e316562333d(e, t) {
    var r = $6343abee919005ee$export$efcd34ab6248d3cd(e);
    return $6343abee919005ee$export$7949f60f2444aef2({
        type: $6343abee919005ee$export$7547a514ee29b9d4(r.type),
        senderPublicKey: (0, $l0HdX._)(r.senderPublicKey) < "u" ? (0, $ewlTP.toString)(r.senderPublicKey, $6343abee919005ee$export$49eb910ab2518105) : void 0,
        receiverPublicKey: t === null || t === void 0 ? void 0 : t.receiverPublicKey
    });
}
function $6343abee919005ee$export$7949f60f2444aef2(e) {
    var t = (e === null || e === void 0 ? void 0 : e.type) || $6343abee919005ee$export$3425bd336a9673d8;
    if (t === $6343abee919005ee$export$406e97c329f0f3d4) {
        if ((0, $l0HdX._)(e === null || e === void 0 ? void 0 : e.senderPublicKey) > "u") throw new Error("missing sender public key");
        if ((0, $l0HdX._)(e === null || e === void 0 ? void 0 : e.receiverPublicKey) > "u") throw new Error("missing receiver public key");
    }
    return {
        type: t,
        senderPublicKey: e === null || e === void 0 ? void 0 : e.senderPublicKey,
        receiverPublicKey: e === null || e === void 0 ? void 0 : e.receiverPublicKey
    };
}
function $6343abee919005ee$export$8c165704db2d5c15(e) {
    return e.type === $6343abee919005ee$export$406e97c329f0f3d4 && typeof e.senderPublicKey == "string" && typeof e.receiverPublicKey == "string";
}
function $6343abee919005ee$export$63aed4db4cd72ee8(e) {
    return new (0, $4z21a.ec)("p256").keyFromPublic({
        x: $6343abee919005ee$require$Buffer.from(e.x, "base64").toString("hex"),
        y: $6343abee919005ee$require$Buffer.from(e.y, "base64").toString("hex")
    }, "hex");
}
function $6343abee919005ee$var$ku(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    var r = t.length % 4;
    return r > 0 && (t += "=".repeat(4 - r)), t;
}
function $6343abee919005ee$var$qu(e) {
    return $6343abee919005ee$require$Buffer.from($6343abee919005ee$var$ku(e), "base64");
}
function $6343abee919005ee$export$f65520390041ee33(e, t) {
    var _e_split = (0, $cv9Rk._)(e.split("."), 3), r = _e_split[0], i = _e_split[1], n = _e_split[2], o = $6343abee919005ee$var$qu(n);
    if (o.length !== 64) throw new Error("Invalid signature length");
    var h = o.slice(0, 32).toString("hex"), p = o.slice(32, 64).toString("hex"), A = "".concat(r, ".").concat(i), m = new (0, $27vAG.SHA256)().update($6343abee919005ee$require$Buffer.from(A)).digest(), w = $6343abee919005ee$export$63aed4db4cd72ee8(t), y = $6343abee919005ee$require$Buffer.from(m).toString("hex"), S = w.verify(y, {
        r: h,
        s: p
    });
    if (!S) throw new Error("Invalid signature");
    var I = (0, $kGjpT.decodeJWT)(e);
    return $6343abee919005ee$var$Iu($6343abee919005ee$var$Nu({}, I.payload), {
        isVerified: S
    });
}
var $6343abee919005ee$export$822d0bd1635d5360 = "irn";
function $6343abee919005ee$export$cf77af25151525db(e) {
    return (e === null || e === void 0 ? void 0 : e.relay) || {
        protocol: $6343abee919005ee$export$822d0bd1635d5360
    };
}
function $6343abee919005ee$export$604e3deb95e1b734(e) {
    var t = (0, $aXdDy.RELAY_JSONRPC)[e];
    if ((typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t)) > "u") throw new Error("Relay Protocol not supported: ".concat(e));
    return t;
}
var $6343abee919005ee$var$Lu = Object.defineProperty, $6343abee919005ee$var$ju = Object.defineProperties, $6343abee919005ee$var$Qu = Object.getOwnPropertyDescriptors, $6343abee919005ee$var$so = Object.getOwnPropertySymbols, $6343abee919005ee$var$Ju = Object.prototype.hasOwnProperty, $6343abee919005ee$var$Gu = Object.prototype.propertyIsEnumerable, $6343abee919005ee$var$ao = function(e, t, r) {
    return t in e ? $6343abee919005ee$var$Lu(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r;
}, $6343abee919005ee$var$uo = function(e, t) {
    for(var r in t || (t = {}))$6343abee919005ee$var$Ju.call(t, r) && $6343abee919005ee$var$ao(e, r, t[r]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($6343abee919005ee$var$so) try {
        for(var _iterator = $6343abee919005ee$var$so(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var r = _step.value;
            $6343abee919005ee$var$Gu.call(t, r) && $6343abee919005ee$var$ao(e, r, t[r]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return e;
}, $6343abee919005ee$var$Yu = function(e, t) {
    return $6343abee919005ee$var$ju(e, $6343abee919005ee$var$Qu(t));
};
function $6343abee919005ee$export$3d24f408c2ac468a(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "-";
    var r = {}, i = "relay" + t;
    return Object.keys(e).forEach(function(n) {
        if (n.startsWith(i)) {
            var o = n.replace(i, ""), h = e[n];
            r[o] = h;
        }
    }), r;
}
function $6343abee919005ee$export$59f58847421cfb28(e) {
    e = e.includes("wc://") ? e.replace("wc://", "") : e, e = e.includes("wc:") ? e.replace("wc:", "") : e;
    var t = e.indexOf(":"), r = e.indexOf("?") !== -1 ? e.indexOf("?") : void 0, i = e.substring(0, t), n = e.substring(t + 1, r).split("@"), o = (typeof r === "undefined" ? "undefined" : (0, $l0HdX._)(r)) < "u" ? e.substring(r) : "", h = $hDCWT.parse(o), p = typeof h.methods == "string" ? h.methods.split(",") : void 0;
    return {
        protocol: i,
        topic: $6343abee919005ee$export$5ddc9ebef1d00f28(n[0]),
        version: parseInt(n[1], 10),
        symKey: h.symKey,
        relay: $6343abee919005ee$export$3d24f408c2ac468a(h),
        methods: p,
        expiryTimestamp: h.expiryTimestamp ? parseInt(h.expiryTimestamp, 10) : void 0
    };
}
function $6343abee919005ee$export$5ddc9ebef1d00f28(e) {
    return e.startsWith("//") ? e.substring(2) : e;
}
function $6343abee919005ee$export$65c55c7ccd19bb8f(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "-";
    var r = "relay", i = {};
    return Object.keys(e).forEach(function(n) {
        var o = r + t + n;
        e[n] && (i[o] = e[n]);
    }), i;
}
function $6343abee919005ee$export$b2786ede34fb2350(e) {
    return "".concat(e.protocol, ":").concat(e.topic, "@").concat(e.version, "?") + $hDCWT.stringify($6343abee919005ee$var$uo($6343abee919005ee$var$Yu($6343abee919005ee$var$uo({
        symKey: e.symKey
    }, $6343abee919005ee$export$65c55c7ccd19bb8f(e.relay)), {
        expiryTimestamp: e.expiryTimestamp
    }), e.methods ? {
        methods: e.methods.join(",")
    } : {}));
}
var $6343abee919005ee$var$Xu = Object.defineProperty, $6343abee919005ee$var$Zu = Object.defineProperties, $6343abee919005ee$var$$u = Object.getOwnPropertyDescriptors, $6343abee919005ee$var$po = Object.getOwnPropertySymbols, $6343abee919005ee$var$th = Object.prototype.hasOwnProperty, $6343abee919005ee$var$eh = Object.prototype.propertyIsEnumerable, $6343abee919005ee$var$vo = function(e, t, r) {
    return t in e ? $6343abee919005ee$var$Xu(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r;
}, $6343abee919005ee$var$rh = function(e, t) {
    for(var r in t || (t = {}))$6343abee919005ee$var$th.call(t, r) && $6343abee919005ee$var$vo(e, r, t[r]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($6343abee919005ee$var$po) try {
        for(var _iterator = $6343abee919005ee$var$po(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var r = _step.value;
            $6343abee919005ee$var$eh.call(t, r) && $6343abee919005ee$var$vo(e, r, t[r]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return e;
}, $6343abee919005ee$var$ih = function(e, t) {
    return $6343abee919005ee$var$Zu(e, $6343abee919005ee$var$$u(t));
};
function $6343abee919005ee$export$d46695d9c3664fe9(e) {
    var t = [];
    return e.forEach(function(r) {
        var _r_split = (0, $cv9Rk._)(r.split(":"), 2), i = _r_split[0], n = _r_split[1];
        t.push("".concat(i, ":").concat(n));
    }), t;
}
function $6343abee919005ee$export$fb6db6038e742b14(e) {
    var t = [];
    return Object.values(e).forEach(function(r) {
        var _t;
        (_t = t).push.apply(_t, (0, $c6Xmf._)($6343abee919005ee$export$d46695d9c3664fe9(r.accounts)));
    }), t;
}
function $6343abee919005ee$export$7dcf4808e17b15ac(e, t) {
    var r = [];
    return Object.values(e).forEach(function(i) {
        var _r;
        $6343abee919005ee$export$d46695d9c3664fe9(i.accounts).includes(t) && (_r = r).push.apply(_r, (0, $c6Xmf._)(i.methods));
    }), r;
}
function $6343abee919005ee$export$94ee6d00e384a22(e, t) {
    var r = [];
    return Object.values(e).forEach(function(i) {
        var _r;
        $6343abee919005ee$export$d46695d9c3664fe9(i.accounts).includes(t) && (_r = r).push.apply(_r, (0, $c6Xmf._)(i.events));
    }), r;
}
function $6343abee919005ee$export$a8daa26a7c60ef90(e, t) {
    var r = $6343abee919005ee$export$93f7b81dc815a714(e, t);
    if (r) throw new Error(r.message);
    var i = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $cv9Rk._)(_step.value, 2), n = _step_value[0], o = _step_value[1];
            i[n] = {
                methods: o.methods,
                events: o.events,
                chains: o.accounts.map(function(h) {
                    return "".concat(h.split(":")[0], ":").concat(h.split(":")[1]);
                })
            };
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return i;
}
function $6343abee919005ee$export$c0b86bc9b7d9f338(e) {
    var _e_proposal = e.proposal, t = _e_proposal.requiredNamespaces, tmp = _e_proposal.optionalNamespaces, r = tmp === void 0 ? {} : tmp, i = e.supportedNamespaces, n = $6343abee919005ee$export$2994550cda701c96(t), o = $6343abee919005ee$export$2994550cda701c96(r), h = {};
    Object.keys(i).forEach(function(m) {
        var w = i[m].chains, y = i[m].methods, S = i[m].events, I = i[m].accounts;
        w.forEach(function(N) {
            if (!I.some(function(C) {
                return C.includes(N);
            })) throw new Error("No accounts provided for chain ".concat(N, " in namespace ").concat(m));
        }), h[m] = {
            chains: w,
            methods: y,
            events: S,
            accounts: I
        };
    });
    var p = $6343abee919005ee$export$ba5b0a4b585cd1b4(t, h, "approve()");
    if (p) throw new Error(p.message);
    var A = {};
    return !Object.keys(t).length && !Object.keys(r).length ? h : (Object.keys(n).forEach(function(m) {
        var w = i[m].chains.filter(function(N) {
            var C, F;
            return (F = (C = n[m]) == null ? void 0 : C.chains) == null ? void 0 : F.includes(N);
        }), y = i[m].methods.filter(function(N) {
            var C, F;
            return (F = (C = n[m]) == null ? void 0 : C.methods) == null ? void 0 : F.includes(N);
        }), S = i[m].events.filter(function(N) {
            var C, F;
            return (F = (C = n[m]) == null ? void 0 : C.events) == null ? void 0 : F.includes(N);
        }), I = w.map(function(N) {
            return i[m].accounts.filter(function(C) {
                return C.includes("".concat(N, ":"));
            });
        }).flat();
        A[m] = {
            chains: w,
            methods: y,
            events: S,
            accounts: I
        };
    }), Object.keys(o).forEach(function(m) {
        var w, y, S, I, N, C;
        if (!i[m]) return;
        var F = (y = (w = o[m]) == null ? void 0 : w.chains) == null ? void 0 : y.filter(function(G) {
            return i[m].chains.includes(G);
        }), U = i[m].methods.filter(function(G) {
            var H, z;
            return (z = (H = o[m]) == null ? void 0 : H.methods) == null ? void 0 : z.includes(G);
        }), J = i[m].events.filter(function(G) {
            var H, z;
            return (z = (H = o[m]) == null ? void 0 : H.events) == null ? void 0 : z.includes(G);
        }), Bt = F === null || F === void 0 ? void 0 : F.map(function(G) {
            return i[m].accounts.filter(function(H) {
                return H.includes("".concat(G, ":"));
            });
        }).flat();
        A[m] = {
            chains: $6343abee919005ee$export$9826fe7ad3921016((S = A[m]) == null ? void 0 : S.chains, F),
            methods: $6343abee919005ee$export$9826fe7ad3921016((I = A[m]) == null ? void 0 : I.methods, U),
            events: $6343abee919005ee$export$9826fe7ad3921016((N = A[m]) == null ? void 0 : N.events, J),
            accounts: $6343abee919005ee$export$9826fe7ad3921016((C = A[m]) == null ? void 0 : C.accounts, Bt)
        };
    }), A);
}
function $6343abee919005ee$export$e03e993df4723bde(e) {
    return e.includes(":");
}
function $6343abee919005ee$export$dd404c96fbbb1ff8(e) {
    return $6343abee919005ee$export$e03e993df4723bde(e) ? e.split(":")[0] : e;
}
function $6343abee919005ee$export$2994550cda701c96(e) {
    var t, r, i;
    var n = {};
    if (!$6343abee919005ee$export$16a0268bc22b47b0(e)) return n;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $cv9Rk._)(_step.value, 2), o = _step_value[0], h = _step_value[1];
            var p = $6343abee919005ee$export$e03e993df4723bde(o) ? [
                o
            ] : h.chains, A = h.methods || [], m = h.events || [], w = $6343abee919005ee$export$dd404c96fbbb1ff8(o);
            n[w] = $6343abee919005ee$var$ih($6343abee919005ee$var$rh({}, n[w]), {
                chains: $6343abee919005ee$export$9826fe7ad3921016(p, (t = n[w]) == null ? void 0 : t.chains),
                methods: $6343abee919005ee$export$9826fe7ad3921016(A, (r = n[w]) == null ? void 0 : r.methods),
                events: $6343abee919005ee$export$9826fe7ad3921016(m, (i = n[w]) == null ? void 0 : i.events)
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return n;
}
function $6343abee919005ee$export$293459f1cc8d700(e) {
    var t = {};
    return e === null || e === void 0 ? void 0 : e.forEach(function(r) {
        var _r_split = (0, $cv9Rk._)(r.split(":"), 2), i = _r_split[0], n = _r_split[1];
        t[i] || (t[i] = {
            accounts: [],
            chains: [],
            events: []
        }), t[i].accounts.push(r), t[i].chains.push("".concat(i, ":").concat(n));
    }), t;
}
function $6343abee919005ee$export$b5744b1c39447540(e, t) {
    t = t.map(function(i) {
        return i.replace("did:pkh:", "");
    });
    var r = $6343abee919005ee$export$293459f1cc8d700(t);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(r)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $cv9Rk._)(_step.value, 2), i = _step_value[0], n = _step_value[1];
            n.methods ? n.methods = $6343abee919005ee$export$9826fe7ad3921016(n.methods, e) : n.methods = e, n.events = [
                "chainChanged",
                "accountsChanged"
            ];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return r;
}
var $6343abee919005ee$export$990de0b632caca05 = {
    INVALID_METHOD: {
        message: "Invalid method.",
        code: 1001
    },
    INVALID_EVENT: {
        message: "Invalid event.",
        code: 1002
    },
    INVALID_UPDATE_REQUEST: {
        message: "Invalid update request.",
        code: 1003
    },
    INVALID_EXTEND_REQUEST: {
        message: "Invalid extend request.",
        code: 1004
    },
    INVALID_SESSION_SETTLE_REQUEST: {
        message: "Invalid session settle request.",
        code: 1005
    },
    UNAUTHORIZED_METHOD: {
        message: "Unauthorized method.",
        code: 3001
    },
    UNAUTHORIZED_EVENT: {
        message: "Unauthorized event.",
        code: 3002
    },
    UNAUTHORIZED_UPDATE_REQUEST: {
        message: "Unauthorized update request.",
        code: 3003
    },
    UNAUTHORIZED_EXTEND_REQUEST: {
        message: "Unauthorized extend request.",
        code: 3004
    },
    USER_REJECTED: {
        message: "User rejected.",
        code: 5e3
    },
    USER_REJECTED_CHAINS: {
        message: "User rejected chains.",
        code: 5001
    },
    USER_REJECTED_METHODS: {
        message: "User rejected methods.",
        code: 5002
    },
    USER_REJECTED_EVENTS: {
        message: "User rejected events.",
        code: 5003
    },
    UNSUPPORTED_CHAINS: {
        message: "Unsupported chains.",
        code: 5100
    },
    UNSUPPORTED_METHODS: {
        message: "Unsupported methods.",
        code: 5101
    },
    UNSUPPORTED_EVENTS: {
        message: "Unsupported events.",
        code: 5102
    },
    UNSUPPORTED_ACCOUNTS: {
        message: "Unsupported accounts.",
        code: 5103
    },
    UNSUPPORTED_NAMESPACE_KEY: {
        message: "Unsupported namespace key.",
        code: 5104
    },
    USER_DISCONNECTED: {
        message: "User disconnected.",
        code: 6e3
    },
    SESSION_SETTLEMENT_FAILED: {
        message: "Session settlement failed.",
        code: 7e3
    },
    WC_METHOD_UNSUPPORTED: {
        message: "Unsupported wc_ method.",
        code: 10001
    }
}, $6343abee919005ee$export$77b3faa414a0ce61 = {
    NOT_INITIALIZED: {
        message: "Not initialized.",
        code: 1
    },
    NO_MATCHING_KEY: {
        message: "No matching key.",
        code: 2
    },
    RESTORE_WILL_OVERRIDE: {
        message: "Restore will override.",
        code: 3
    },
    RESUBSCRIBED: {
        message: "Resubscribed.",
        code: 4
    },
    MISSING_OR_INVALID: {
        message: "Missing or invalid.",
        code: 5
    },
    EXPIRED: {
        message: "Expired.",
        code: 6
    },
    UNKNOWN_TYPE: {
        message: "Unknown type.",
        code: 7
    },
    MISMATCHED_TOPIC: {
        message: "Mismatched topic.",
        code: 8
    },
    NON_CONFORMING_NAMESPACES: {
        message: "Non conforming namespaces.",
        code: 9
    }
};
function $6343abee919005ee$export$500d4c4a8fafe35(e, t) {
    var _xo_e = $6343abee919005ee$export$77b3faa414a0ce61[e], r = _xo_e.message, i = _xo_e.code;
    return {
        message: t ? "".concat(r, " ").concat(t) : r,
        code: i
    };
}
function $6343abee919005ee$export$8203ef1531c8b5b5(e, t) {
    var _wo_e = $6343abee919005ee$export$990de0b632caca05[e], r = _wo_e.message, i = _wo_e.code;
    return {
        message: t ? "".concat(r, " ").concat(t) : r,
        code: i
    };
}
function $6343abee919005ee$export$41dd3d480aac4a71(e, t) {
    return Array.isArray(e) ? (typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t)) < "u" && e.length ? e.every(t) : !0 : !1;
}
function $6343abee919005ee$export$16a0268bc22b47b0(e) {
    return Object.getPrototypeOf(e) === Object.prototype && Object.keys(e).length;
}
function $6343abee919005ee$export$fce6876652108ab(e) {
    return (typeof e === "undefined" ? "undefined" : (0, $l0HdX._)(e)) > "u";
}
function $6343abee919005ee$export$ee898ca48ab56c74(e, t) {
    return t && $6343abee919005ee$export$fce6876652108ab(e) ? !0 : typeof e == "string" && !!e.trim().length;
}
function $6343abee919005ee$export$d6781b696a0576d1(e, t) {
    return t && $6343abee919005ee$export$fce6876652108ab(e) ? !0 : typeof e == "number" && !isNaN(e);
}
function $6343abee919005ee$export$6fc4971bf8f326a(e, t) {
    var r = t.requiredNamespaces, i = Object.keys(e.namespaces), n = Object.keys(r);
    var o = !0;
    return $6343abee919005ee$export$1468a49de573f7f9(n, i) ? (i.forEach(function(h) {
        var _e_namespaces_h = e.namespaces[h], p = _e_namespaces_h.accounts, A = _e_namespaces_h.methods, m = _e_namespaces_h.events, w = $6343abee919005ee$export$d46695d9c3664fe9(p), y = r[h];
        (!$6343abee919005ee$export$1468a49de573f7f9($6343abee919005ee$export$376384387cd15b27(h, y), w) || !$6343abee919005ee$export$1468a49de573f7f9(y.methods, A) || !$6343abee919005ee$export$1468a49de573f7f9(y.events, m)) && (o = !1);
    }), o) : !1;
}
function $6343abee919005ee$export$e544b39f0a22e47a(e) {
    return $6343abee919005ee$export$ee898ca48ab56c74(e, !1) && e.includes(":") ? e.split(":").length === 2 : !1;
}
function $6343abee919005ee$export$49e4a5b6862e3c71(e) {
    if ($6343abee919005ee$export$ee898ca48ab56c74(e, !1) && e.includes(":")) {
        var t = e.split(":");
        if (t.length === 3) {
            var r = t[0] + ":" + t[1];
            return !!t[2] && $6343abee919005ee$export$e544b39f0a22e47a(r);
        }
    }
    return !1;
}
function $6343abee919005ee$export$bef94a5618bf18bf(e) {
    if ($6343abee919005ee$export$ee898ca48ab56c74(e, !1)) try {
        return (0, $l0HdX._)(new URL(e)) < "u";
    } catch (e) {
        return !1;
    }
    return !1;
}
function $6343abee919005ee$export$f657f7976bb2769d(e) {
    var t;
    return (t = e === null || e === void 0 ? void 0 : e.proposer) == null ? void 0 : t.publicKey;
}
function $6343abee919005ee$export$c96d5113768aaf5e(e) {
    return e === null || e === void 0 ? void 0 : e.topic;
}
function $6343abee919005ee$export$5e1c5c89613c213f(e, t) {
    var r = null;
    return $6343abee919005ee$export$ee898ca48ab56c74(e === null || e === void 0 ? void 0 : e.publicKey, !1) || (r = $6343abee919005ee$export$500d4c4a8fafe35("MISSING_OR_INVALID", "".concat(t, " controller public key should be a string"))), r;
}
function $6343abee919005ee$export$c12fced8176774f3(e) {
    var t = !0;
    return $6343abee919005ee$export$41dd3d480aac4a71(e) ? e.length && (t = e.every(function(r) {
        return $6343abee919005ee$export$ee898ca48ab56c74(r, !1);
    })) : t = !1, t;
}
function $6343abee919005ee$export$df46c123d7e298ce(e, t, r) {
    var i = null;
    return $6343abee919005ee$export$41dd3d480aac4a71(t) && t.length ? t.forEach(function(n) {
        i || $6343abee919005ee$export$e544b39f0a22e47a(n) || (i = $6343abee919005ee$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", "".concat(r, ", chain ").concat(n, ' should be a string and conform to "namespace:chainId" format')));
    }) : $6343abee919005ee$export$e544b39f0a22e47a(e) || (i = $6343abee919005ee$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", "".concat(r, ', chains must be defined as "namespace:chainId" e.g. "eip155:1": {...} in the namespace key OR as an array of CAIP-2 chainIds e.g. eip155: { chains: ["eip155:1", "eip155:5"] }'))), i;
}
function $6343abee919005ee$export$94ae96fb66f29e08(e, t, r) {
    var i = null;
    return Object.entries(e).forEach(function(param) {
        var _param = (0, $cv9Rk._)(param, 2), n = _param[0], o = _param[1];
        if (i) return;
        var h = $6343abee919005ee$export$df46c123d7e298ce(n, $6343abee919005ee$export$376384387cd15b27(n, o), "".concat(t, " ").concat(r));
        h && (i = h);
    }), i;
}
function $6343abee919005ee$export$d5644026aaffb9e7(e, t) {
    var r = null;
    return $6343abee919005ee$export$41dd3d480aac4a71(e) ? e.forEach(function(i) {
        r || $6343abee919005ee$export$49e4a5b6862e3c71(i) || (r = $6343abee919005ee$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", "".concat(t, ", account ").concat(i, ' should be a string and conform to "namespace:chainId:address" format')));
    }) : r = $6343abee919005ee$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", "".concat(t, ', accounts should be an array of strings conforming to "namespace:chainId:address" format')), r;
}
function $6343abee919005ee$export$2a2012e7bfa1cfb4(e, t) {
    var r = null;
    return Object.values(e).forEach(function(i) {
        if (r) return;
        var n = $6343abee919005ee$export$d5644026aaffb9e7(i === null || i === void 0 ? void 0 : i.accounts, "".concat(t, " namespace"));
        n && (r = n);
    }), r;
}
function $6343abee919005ee$export$b32541d63753af56(e, t) {
    var r = null;
    return $6343abee919005ee$export$c12fced8176774f3(e === null || e === void 0 ? void 0 : e.methods) ? $6343abee919005ee$export$c12fced8176774f3(e === null || e === void 0 ? void 0 : e.events) || (r = $6343abee919005ee$export$8203ef1531c8b5b5("UNSUPPORTED_EVENTS", "".concat(t, ", events should be an array of strings or empty array for no events"))) : r = $6343abee919005ee$export$8203ef1531c8b5b5("UNSUPPORTED_METHODS", "".concat(t, ", methods should be an array of strings or empty array for no methods")), r;
}
function $6343abee919005ee$export$27682c78deeca9d7(e, t) {
    var r = null;
    return Object.values(e).forEach(function(i) {
        if (r) return;
        var n = $6343abee919005ee$export$b32541d63753af56(i, "".concat(t, ", namespace"));
        n && (r = n);
    }), r;
}
function $6343abee919005ee$export$9e2b2cae22c6a8b3(e, t, r) {
    var i = null;
    if (e && $6343abee919005ee$export$16a0268bc22b47b0(e)) {
        var n = $6343abee919005ee$export$27682c78deeca9d7(e, t);
        n && (i = n);
        var o = $6343abee919005ee$export$94ae96fb66f29e08(e, t, r);
        o && (i = o);
    } else i = $6343abee919005ee$export$500d4c4a8fafe35("MISSING_OR_INVALID", "".concat(t, ", ").concat(r, " should be an object with data"));
    return i;
}
function $6343abee919005ee$export$93f7b81dc815a714(e, t) {
    var r = null;
    if (e && $6343abee919005ee$export$16a0268bc22b47b0(e)) {
        var i = $6343abee919005ee$export$27682c78deeca9d7(e, t);
        i && (r = i);
        var n = $6343abee919005ee$export$2a2012e7bfa1cfb4(e, t);
        n && (r = n);
    } else r = $6343abee919005ee$export$500d4c4a8fafe35("MISSING_OR_INVALID", "".concat(t, ", namespaces should be an object with data"));
    return r;
}
function $6343abee919005ee$export$1b3fc298be8c9a7b(e) {
    return $6343abee919005ee$export$ee898ca48ab56c74(e.protocol, !0);
}
function $6343abee919005ee$export$6294c30b976bd21e(e, t) {
    var r = !1;
    return t && !e ? r = !0 : e && $6343abee919005ee$export$41dd3d480aac4a71(e) && e.length && e.forEach(function(i) {
        r = $6343abee919005ee$export$1b3fc298be8c9a7b(i);
    }), r;
}
function $6343abee919005ee$export$53551be28ad5e34d(e) {
    return typeof e == "number";
}
function $6343abee919005ee$export$b3f5fcca1d210454(e) {
    return (typeof e === "undefined" ? "undefined" : (0, $l0HdX._)(e)) < "u" && true;
}
function $6343abee919005ee$export$766fe78377d96f2a(e) {
    return !(!e || typeof e != "object" || !e.code || !$6343abee919005ee$export$d6781b696a0576d1(e.code, !1) || !e.message || !$6343abee919005ee$export$ee898ca48ab56c74(e.message, !1));
}
function $6343abee919005ee$export$1a2af3c017fb6d42(e) {
    return !($6343abee919005ee$export$fce6876652108ab(e) || !$6343abee919005ee$export$ee898ca48ab56c74(e.method, !1));
}
function $6343abee919005ee$export$1ae38cf0a848f651(e) {
    return !($6343abee919005ee$export$fce6876652108ab(e) || $6343abee919005ee$export$fce6876652108ab(e.result) && $6343abee919005ee$export$fce6876652108ab(e.error) || !$6343abee919005ee$export$d6781b696a0576d1(e.id, !1) || !$6343abee919005ee$export$ee898ca48ab56c74(e.jsonrpc, !1));
}
function $6343abee919005ee$export$cbe4cdc5960cfa11(e) {
    return !($6343abee919005ee$export$fce6876652108ab(e) || !$6343abee919005ee$export$ee898ca48ab56c74(e.name, !1));
}
function $6343abee919005ee$export$144fc36610eb6522(e, t) {
    return !(!$6343abee919005ee$export$e544b39f0a22e47a(t) || !$6343abee919005ee$export$fb6db6038e742b14(e).includes(t));
}
function $6343abee919005ee$export$8db4804e3a6de711(e, t, r) {
    return $6343abee919005ee$export$ee898ca48ab56c74(r, !1) ? $6343abee919005ee$export$7dcf4808e17b15ac(e, t).includes(r) : !1;
}
function $6343abee919005ee$export$df2c67ef8baad16b(e, t, r) {
    return $6343abee919005ee$export$ee898ca48ab56c74(r, !1) ? $6343abee919005ee$export$94ee6d00e384a22(e, t).includes(r) : !1;
}
function $6343abee919005ee$export$ba5b0a4b585cd1b4(e, t, r) {
    var i = null;
    var n = $6343abee919005ee$var$Mh(e), o = $6343abee919005ee$var$Eh(t), h = Object.keys(n), p = Object.keys(o), A = $6343abee919005ee$var$Oo(Object.keys(e)), m = $6343abee919005ee$var$Oo(Object.keys(t)), w = A.filter(function(y) {
        return !m.includes(y);
    });
    return w.length && (i = $6343abee919005ee$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", "".concat(r, " namespaces keys don't satisfy requiredNamespaces.\n      Required: ").concat(w.toString(), "\n      Received: ").concat(Object.keys(t).toString()))), $6343abee919005ee$export$1468a49de573f7f9(h, p) || (i = $6343abee919005ee$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", "".concat(r, " namespaces chains don't satisfy required namespaces.\n      Required: ").concat(h.toString(), "\n      Approved: ").concat(p.toString()))), Object.keys(t).forEach(function(y) {
        if (!y.includes(":") || i) return;
        var S = $6343abee919005ee$export$d46695d9c3664fe9(t[y].accounts);
        S.includes(y) || (i = $6343abee919005ee$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", "".concat(r, " namespaces accounts don't satisfy namespace accounts for ").concat(y, "\n        Required: ").concat(y, "\n        Approved: ").concat(S.toString())));
    }), h.forEach(function(y) {
        i || ($6343abee919005ee$export$1468a49de573f7f9(n[y].methods, o[y].methods) ? $6343abee919005ee$export$1468a49de573f7f9(n[y].events, o[y].events) || (i = $6343abee919005ee$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", "".concat(r, " namespaces events don't satisfy namespace events for ").concat(y))) : i = $6343abee919005ee$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", "".concat(r, " namespaces methods don't satisfy namespace methods for ").concat(y)));
    }), i;
}
function $6343abee919005ee$var$Mh(e) {
    var t = {};
    return Object.keys(e).forEach(function(r) {
        var i;
        r.includes(":") ? t[r] = e[r] : (i = e[r].chains) == null || i.forEach(function(n) {
            t[n] = {
                methods: e[r].methods,
                events: e[r].events
            };
        });
    }), t;
}
function $6343abee919005ee$var$Oo(e) {
    return (0, $c6Xmf._)(new Set(e.map(function(t) {
        return t.includes(":") ? t.split(":")[0] : t;
    })));
}
function $6343abee919005ee$var$Eh(e) {
    var t = {};
    return Object.keys(e).forEach(function(r) {
        if (r.includes(":")) t[r] = e[r];
        else {
            var i = $6343abee919005ee$export$d46695d9c3664fe9(e[r].accounts);
            i === null || i === void 0 ? void 0 : i.forEach(function(n) {
                t[n] = {
                    accounts: e[r].accounts.filter(function(o) {
                        return o.includes("".concat(n, ":"));
                    }),
                    methods: e[r].methods,
                    events: e[r].events
                };
            });
        }
    }), t;
}
function $6343abee919005ee$export$59fba2af1ac782b(e, t) {
    return $6343abee919005ee$export$d6781b696a0576d1(e, !1) && e <= t.max && e >= t.min;
}
function $6343abee919005ee$export$53c2fd0173ad2b80() {
    var e = $6343abee919005ee$export$57570b1603cf6adb();
    return new Promise(function(t) {
        switch(e){
            case $6343abee919005ee$export$86b1301a63b15dd9.browser:
                t($6343abee919005ee$export$2f147c609a999e49());
                break;
            case $6343abee919005ee$export$86b1301a63b15dd9.reactNative:
                t($6343abee919005ee$export$1444c95b1570bd12());
                break;
            case $6343abee919005ee$export$86b1301a63b15dd9.node:
                t($6343abee919005ee$export$aec5b2d627eec500());
                break;
            default:
                t(!0);
        }
    });
}
function $6343abee919005ee$export$2f147c609a999e49() {
    var _navigator;
    return $6343abee919005ee$export$4e09c449d6c407f7() && ((_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.onLine);
}
function $6343abee919005ee$export$1444c95b1570bd12() {
    return $6343abee919005ee$var$_Do.apply(this, arguments);
}
function $6343abee919005ee$var$_Do() {
    $6343abee919005ee$var$_Do = (0, $kSuI9._)(function() {
        var e;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!($6343abee919005ee$export$f7a1e23e542d38e3() && (typeof $parcel$global === "undefined" ? "undefined" : (0, $l0HdX._)($parcel$global)) < "u" && $parcel$global != null && $parcel$global.NetInfo)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        $parcel$global == null ? void 0 : $parcel$global.NetInfo.fetch()
                    ];
                case 1:
                    e = _state.sent();
                    return [
                        2,
                        e === null || e === void 0 ? void 0 : e.isConnected
                    ];
                case 2:
                    return [
                        2,
                        !0
                    ];
            }
        });
    });
    return $6343abee919005ee$var$_Do.apply(this, arguments);
}
function $6343abee919005ee$export$aec5b2d627eec500() {
    return !0;
}
function $6343abee919005ee$export$600a1ee4bc680996(e) {
    switch($6343abee919005ee$export$57570b1603cf6adb()){
        case $6343abee919005ee$export$86b1301a63b15dd9.browser:
            $6343abee919005ee$export$d32b24f18d96c5f2(e);
            break;
        case $6343abee919005ee$export$86b1301a63b15dd9.reactNative:
            $6343abee919005ee$export$904edb1c18ec91c7(e);
            break;
        case $6343abee919005ee$export$86b1301a63b15dd9.node:
            break;
    }
}
function $6343abee919005ee$export$d32b24f18d96c5f2(e) {
    !$6343abee919005ee$export$f7a1e23e542d38e3() && $6343abee919005ee$export$4e09c449d6c407f7() && (window.addEventListener("online", function() {
        return e(!0);
    }), window.addEventListener("offline", function() {
        return e(!1);
    }));
}
function $6343abee919005ee$export$904edb1c18ec91c7(e) {
    var _global;
    $6343abee919005ee$export$f7a1e23e542d38e3() && (typeof $parcel$global === "undefined" ? "undefined" : (0, $l0HdX._)($parcel$global)) < "u" && $parcel$global != null && $parcel$global.NetInfo && ((_global = $parcel$global) === null || _global === void 0 ? void 0 : _global.NetInfo.addEventListener(function(t) {
        return e(t === null || t === void 0 ? void 0 : t.isConnected);
    }));
}
var $6343abee919005ee$var$rn = {};
var $6343abee919005ee$export$b72d712fed4d036d = /*#__PURE__*/ function() {
    "use strict";
    function _h() {
        (0, $4GJKx._)(this, _h);
    }
    (0, $1wc17._)(_h, null, [
        {
            key: "get",
            value: function get(t) {
                return $6343abee919005ee$var$rn[t];
            }
        },
        {
            key: "set",
            value: function set(t, r) {
                $6343abee919005ee$var$rn[t] = r;
            }
        },
        {
            key: "delete",
            value: function _delete(t) {
                delete $6343abee919005ee$var$rn[t];
            }
        }
    ]);
    return _h;
}();

});
parcelRegister("3ngRt", function(module, exports) {

$parcel$export(module.exports, "detect", function () { return $2750996b6a6e9426$export$17b446b869dad473; });

var $3qWgZ = parcelRequire("3qWgZ");
var $2750996b6a6e9426$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $2750996b6a6e9426$export$8fa985da04a86f0 = /** @class */ function() {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.type = "browser";
    }
    return BrowserInfo;
}();
var $2750996b6a6e9426$export$62457c674e0167c0 = /** @class */ function() {
    function NodeInfo(version) {
        this.version = version;
        this.type = "node";
        this.name = "node";
        this.os = $3qWgZ.platform;
    }
    return NodeInfo;
}();
var $2750996b6a6e9426$export$775de176f06fc21 = /** @class */ function() {
    function SearchBotDeviceInfo(name, version, os, bot) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.bot = bot;
        this.type = "bot-device";
    }
    return SearchBotDeviceInfo;
}();
var $2750996b6a6e9426$export$cb435e1e9f86c1ff = /** @class */ function() {
    function BotInfo() {
        this.type = "bot";
        this.bot = true; // NOTE: deprecated test name instead
        this.name = "bot";
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}();
var $2750996b6a6e9426$export$7c78fe95a9d9b03e = /** @class */ function() {
    function ReactNativeInfo() {
        this.type = "react-native";
        this.name = "react-native";
        this.version = null;
        this.os = null;
    }
    return ReactNativeInfo;
}();
// tslint:disable-next-line:max-line-length
var $2750996b6a6e9426$var$SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var $2750996b6a6e9426$var$SEARCHBOT_OS_REGEX = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
var $2750996b6a6e9426$var$REQUIRED_VERSION_PARTS = 3;
var $2750996b6a6e9426$var$userAgentRules = [
    [
        "aol",
        /AOLShield\/([0-9\._]+)/
    ],
    [
        "edge",
        /Edge\/([0-9\._]+)/
    ],
    [
        "edge-ios",
        /EdgiOS\/([0-9\._]+)/
    ],
    [
        "yandexbrowser",
        /YaBrowser\/([0-9\._]+)/
    ],
    [
        "kakaotalk",
        /KAKAOTALK\s([0-9\.]+)/
    ],
    [
        "samsung",
        /SamsungBrowser\/([0-9\.]+)/
    ],
    [
        "silk",
        /\bSilk\/([0-9._-]+)\b/
    ],
    [
        "miui",
        /MiuiBrowser\/([0-9\.]+)$/
    ],
    [
        "beaker",
        /BeakerBrowser\/([0-9\.]+)/
    ],
    [
        "edge-chromium",
        /EdgA?\/([0-9\.]+)/
    ],
    [
        "chromium-webview",
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "chrome",
        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "phantomjs",
        /PhantomJS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "crios",
        /CriOS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "firefox",
        /Firefox\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "fxios",
        /FxiOS\/([0-9\.]+)/
    ],
    [
        "opera-mini",
        /Opera Mini.*Version\/([0-9\.]+)/
    ],
    [
        "opera",
        /Opera\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "opera",
        /OPR\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "pie",
        /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/
    ],
    [
        "pie",
        /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/
    ],
    [
        "netfront",
        /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/
    ],
    [
        "ie",
        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
    ],
    [
        "ie",
        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
    ],
    [
        "ie",
        /MSIE\s(7\.0)/
    ],
    [
        "bb10",
        /BB10;\sTouch.*Version\/([0-9\.]+)/
    ],
    [
        "android",
        /Android\s([0-9\.]+)/
    ],
    [
        "ios",
        /Version\/([0-9\._]+).*Mobile.*Safari.*/
    ],
    [
        "safari",
        /Version\/([0-9\._]+).*Safari/
    ],
    [
        "facebook",
        /FB[AS]V\/([0-9\.]+)/
    ],
    [
        "instagram",
        /Instagram\s([0-9\.]+)/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Mobile/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
    ],
    [
        "curl",
        /^curl\/([0-9\.]+)$/
    ],
    [
        "searchbot",
        $2750996b6a6e9426$var$SEARCHBOX_UA_REGEX
    ]
];
var $2750996b6a6e9426$var$operatingSystemRules = [
    [
        "iOS",
        /iP(hone|od|ad)/
    ],
    [
        "Android OS",
        /Android/
    ],
    [
        "BlackBerry OS",
        /BlackBerry|BB10/
    ],
    [
        "Windows Mobile",
        /IEMobile/
    ],
    [
        "Amazon OS",
        /Kindle/
    ],
    [
        "Windows 3.11",
        /Win16/
    ],
    [
        "Windows 95",
        /(Windows 95)|(Win95)|(Windows_95)/
    ],
    [
        "Windows 98",
        /(Windows 98)|(Win98)/
    ],
    [
        "Windows 2000",
        /(Windows NT 5.0)|(Windows 2000)/
    ],
    [
        "Windows XP",
        /(Windows NT 5.1)|(Windows XP)/
    ],
    [
        "Windows Server 2003",
        /(Windows NT 5.2)/
    ],
    [
        "Windows Vista",
        /(Windows NT 6.0)/
    ],
    [
        "Windows 7",
        /(Windows NT 6.1)/
    ],
    [
        "Windows 8",
        /(Windows NT 6.2)/
    ],
    [
        "Windows 8.1",
        /(Windows NT 6.3)/
    ],
    [
        "Windows 10",
        /(Windows NT 10.0)/
    ],
    [
        "Windows ME",
        /Windows ME/
    ],
    [
        "Windows CE",
        /Windows CE|WinCE|Microsoft Pocket Internet Explorer/
    ],
    [
        "Open BSD",
        /OpenBSD/
    ],
    [
        "Sun OS",
        /SunOS/
    ],
    [
        "Chrome OS",
        /CrOS/
    ],
    [
        "Linux",
        /(Linux)|(X11)/
    ],
    [
        "Mac OS",
        /(Mac_PowerPC)|(Macintosh)/
    ],
    [
        "QNX",
        /QNX/
    ],
    [
        "BeOS",
        /BeOS/
    ],
    [
        "OS/2",
        /OS\/2/
    ]
];
function $2750996b6a6e9426$export$17b446b869dad473(userAgent) {
    if (!!userAgent) return $2750996b6a6e9426$export$1184956100eddc3c(userAgent);
    if (typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative") return new $2750996b6a6e9426$export$7c78fe95a9d9b03e();
    if (typeof navigator !== "undefined") return $2750996b6a6e9426$export$1184956100eddc3c(navigator.userAgent);
    return $2750996b6a6e9426$export$bf2c6630ab904918();
}
function $2750996b6a6e9426$var$matchUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    return ua !== "" && $2750996b6a6e9426$var$userAgentRules.reduce(function(matched, _a) {
        var browser = _a[0], regex = _a[1];
        if (matched) return matched;
        var uaMatch = regex.exec(ua);
        return !!uaMatch && [
            browser,
            uaMatch
        ];
    }, false);
}
function $2750996b6a6e9426$export$89ca9f8ca1a50fd5(ua) {
    var data = $2750996b6a6e9426$var$matchUserAgent(ua);
    return data ? data[0] : null;
}
function $2750996b6a6e9426$export$1184956100eddc3c(ua) {
    var matchedRule = $2750996b6a6e9426$var$matchUserAgent(ua);
    if (!matchedRule) return null;
    var name = matchedRule[0], match = matchedRule[1];
    if (name === "searchbot") return new $2750996b6a6e9426$export$cb435e1e9f86c1ff();
    // Do not use RegExp for split operation as some browser do not support it (See: http://blog.stevenlevithan.com/archives/cross-browser-split)
    var versionParts = match[1] && match[1].split(".").join("_").split("_").slice(0, 3);
    if (versionParts) {
        if (versionParts.length < $2750996b6a6e9426$var$REQUIRED_VERSION_PARTS) versionParts = $2750996b6a6e9426$var$__spreadArray($2750996b6a6e9426$var$__spreadArray([], versionParts, true), $2750996b6a6e9426$var$createVersionParts($2750996b6a6e9426$var$REQUIRED_VERSION_PARTS - versionParts.length), true);
    } else versionParts = [];
    var version = versionParts.join(".");
    var os = $2750996b6a6e9426$export$3070bd282ec37ea8(ua);
    var searchBotMatch = $2750996b6a6e9426$var$SEARCHBOT_OS_REGEX.exec(ua);
    if (searchBotMatch && searchBotMatch[1]) return new $2750996b6a6e9426$export$775de176f06fc21(name, version, os, searchBotMatch[1]);
    return new $2750996b6a6e9426$export$8fa985da04a86f0(name, version, os);
}
function $2750996b6a6e9426$export$3070bd282ec37ea8(ua) {
    for(var ii = 0, count = $2750996b6a6e9426$var$operatingSystemRules.length; ii < count; ii++){
        var _a = $2750996b6a6e9426$var$operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.exec(ua);
        if (match) return os;
    }
    return null;
}
function $2750996b6a6e9426$export$bf2c6630ab904918() {
    var isNode = typeof $3qWgZ !== "undefined" && $3qWgZ.version;
    return isNode ? new $2750996b6a6e9426$export$62457c674e0167c0($3qWgZ.version.slice(1)) : null;
}
function $2750996b6a6e9426$var$createVersionParts(count) {
    var output = [];
    for(var ii = 0; ii < count; ii++)output.push("0");
    return output;
}

});
parcelRegister("3qWgZ", function(module, exports) {
// shim for using process in browser
var $28010097cfd45d35$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $28010097cfd45d35$var$cachedSetTimeout;
var $28010097cfd45d35$var$cachedClearTimeout;
function $28010097cfd45d35$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $28010097cfd45d35$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $28010097cfd45d35$var$cachedSetTimeout = setTimeout;
        else $28010097cfd45d35$var$cachedSetTimeout = $28010097cfd45d35$var$defaultSetTimout;
    } catch (e) {
        $28010097cfd45d35$var$cachedSetTimeout = $28010097cfd45d35$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $28010097cfd45d35$var$cachedClearTimeout = clearTimeout;
        else $28010097cfd45d35$var$cachedClearTimeout = $28010097cfd45d35$var$defaultClearTimeout;
    } catch (e) {
        $28010097cfd45d35$var$cachedClearTimeout = $28010097cfd45d35$var$defaultClearTimeout;
    }
})();
function $28010097cfd45d35$var$runTimeout(fun) {
    if ($28010097cfd45d35$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($28010097cfd45d35$var$cachedSetTimeout === $28010097cfd45d35$var$defaultSetTimout || !$28010097cfd45d35$var$cachedSetTimeout) && setTimeout) {
        $28010097cfd45d35$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $28010097cfd45d35$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $28010097cfd45d35$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $28010097cfd45d35$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $28010097cfd45d35$var$runClearTimeout(marker) {
    if ($28010097cfd45d35$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($28010097cfd45d35$var$cachedClearTimeout === $28010097cfd45d35$var$defaultClearTimeout || !$28010097cfd45d35$var$cachedClearTimeout) && clearTimeout) {
        $28010097cfd45d35$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $28010097cfd45d35$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $28010097cfd45d35$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $28010097cfd45d35$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $28010097cfd45d35$var$queue = [];
var $28010097cfd45d35$var$draining = false;
var $28010097cfd45d35$var$currentQueue;
var $28010097cfd45d35$var$queueIndex = -1;
function $28010097cfd45d35$var$cleanUpNextTick() {
    if (!$28010097cfd45d35$var$draining || !$28010097cfd45d35$var$currentQueue) return;
    $28010097cfd45d35$var$draining = false;
    if ($28010097cfd45d35$var$currentQueue.length) $28010097cfd45d35$var$queue = $28010097cfd45d35$var$currentQueue.concat($28010097cfd45d35$var$queue);
    else $28010097cfd45d35$var$queueIndex = -1;
    if ($28010097cfd45d35$var$queue.length) $28010097cfd45d35$var$drainQueue();
}
function $28010097cfd45d35$var$drainQueue() {
    if ($28010097cfd45d35$var$draining) return;
    var timeout = $28010097cfd45d35$var$runTimeout($28010097cfd45d35$var$cleanUpNextTick);
    $28010097cfd45d35$var$draining = true;
    var len = $28010097cfd45d35$var$queue.length;
    while(len){
        $28010097cfd45d35$var$currentQueue = $28010097cfd45d35$var$queue;
        $28010097cfd45d35$var$queue = [];
        while(++$28010097cfd45d35$var$queueIndex < len)if ($28010097cfd45d35$var$currentQueue) $28010097cfd45d35$var$currentQueue[$28010097cfd45d35$var$queueIndex].run();
        $28010097cfd45d35$var$queueIndex = -1;
        len = $28010097cfd45d35$var$queue.length;
    }
    $28010097cfd45d35$var$currentQueue = null;
    $28010097cfd45d35$var$draining = false;
    $28010097cfd45d35$var$runClearTimeout(timeout);
}
$28010097cfd45d35$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $28010097cfd45d35$var$queue.push(new $28010097cfd45d35$var$Item(fun, args));
    if ($28010097cfd45d35$var$queue.length === 1 && !$28010097cfd45d35$var$draining) $28010097cfd45d35$var$runTimeout($28010097cfd45d35$var$drainQueue);
};
// v8 likes predictible objects
function $28010097cfd45d35$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$28010097cfd45d35$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$28010097cfd45d35$var$process.title = "browser";
$28010097cfd45d35$var$process.browser = true;
$28010097cfd45d35$var$process.env = {};
$28010097cfd45d35$var$process.argv = [];
$28010097cfd45d35$var$process.version = ""; // empty string to avoid regexp issues
$28010097cfd45d35$var$process.versions = {};
function $28010097cfd45d35$var$noop() {}
$28010097cfd45d35$var$process.on = $28010097cfd45d35$var$noop;
$28010097cfd45d35$var$process.addListener = $28010097cfd45d35$var$noop;
$28010097cfd45d35$var$process.once = $28010097cfd45d35$var$noop;
$28010097cfd45d35$var$process.off = $28010097cfd45d35$var$noop;
$28010097cfd45d35$var$process.removeListener = $28010097cfd45d35$var$noop;
$28010097cfd45d35$var$process.removeAllListeners = $28010097cfd45d35$var$noop;
$28010097cfd45d35$var$process.emit = $28010097cfd45d35$var$noop;
$28010097cfd45d35$var$process.prependListener = $28010097cfd45d35$var$noop;
$28010097cfd45d35$var$process.prependOnceListener = $28010097cfd45d35$var$noop;
$28010097cfd45d35$var$process.listeners = function(name) {
    return [];
};
$28010097cfd45d35$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$28010097cfd45d35$var$process.cwd = function() {
    return "/";
};
$28010097cfd45d35$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$28010097cfd45d35$var$process.umask = function() {
    return 0;
};

});


parcelRegister("4BEBs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $g01mJ = parcelRequire("g01mJ");

$g01mJ.__exportStar((parcelRequire("1vFxI")), module.exports);

$g01mJ.__exportStar((parcelRequire("4ytPO")), module.exports);

$g01mJ.__exportStar((parcelRequire("2H9vU")), module.exports);

$g01mJ.__exportStar((parcelRequire("asOZn")), module.exports);

});
parcelRegister("g01mJ", function(module, exports) {

$parcel$export(module.exports, "__exportStar", function () { return $ba5db49a1a48c342$export$f33643c0debef087; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $ba5db49a1a48c342$var$extendStatics = function extendStatics1(d, b) {
    $ba5db49a1a48c342$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $ba5db49a1a48c342$var$extendStatics(d, b);
};
function $ba5db49a1a48c342$export$a8ba968b8961cb8a(d, b) {
    $ba5db49a1a48c342$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $ba5db49a1a48c342$export$18ce0697a983be9b = function __assign1() {
    $ba5db49a1a48c342$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ba5db49a1a48c342$export$18ce0697a983be9b.apply(this, arguments);
};
function $ba5db49a1a48c342$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ba5db49a1a48c342$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $ba5db49a1a48c342$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $ba5db49a1a48c342$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $ba5db49a1a48c342$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $ba5db49a1a48c342$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $ba5db49a1a48c342$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $ba5db49a1a48c342$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $ba5db49a1a48c342$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $ba5db49a1a48c342$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $ba5db49a1a48c342$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($ba5db49a1a48c342$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $ba5db49a1a48c342$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $ba5db49a1a48c342$export$10c90e4f7922046c(v) {
    return this instanceof $ba5db49a1a48c342$export$10c90e4f7922046c ? (this.v = v, this) : new $ba5db49a1a48c342$export$10c90e4f7922046c(v);
}
function $ba5db49a1a48c342$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $ba5db49a1a48c342$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $ba5db49a1a48c342$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $ba5db49a1a48c342$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $ba5db49a1a48c342$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $ba5db49a1a48c342$export$19a8beecd37a4c45 === "function" ? $ba5db49a1a48c342$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $ba5db49a1a48c342$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $ba5db49a1a48c342$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $ba5db49a1a48c342$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $ba5db49a1a48c342$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $ba5db49a1a48c342$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("1vFxI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $g01mJ = parcelRequire("g01mJ");

$g01mJ.__exportStar((parcelRequire("eh7hk")), module.exports);

$g01mJ.__exportStar((parcelRequire("38IOB")), module.exports);

});
parcelRegister("eh7hk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.delay = void 0;
function $a6484c8d8883a92f$var$delay(timeout) {
    return new Promise(function(resolve) {
        setTimeout(function() {
            resolve(true);
        }, timeout);
    });
}
module.exports.delay = $a6484c8d8883a92f$var$delay;

});

parcelRegister("38IOB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromMiliseconds = module.exports.toMiliseconds = void 0;

var $asOZn = parcelRequire("asOZn");
function $2494e1d4fe09de0f$var$toMiliseconds(seconds) {
    return seconds * $asOZn.ONE_THOUSAND;
}
module.exports.toMiliseconds = $2494e1d4fe09de0f$var$toMiliseconds;
function $2494e1d4fe09de0f$var$fromMiliseconds(miliseconds) {
    return Math.floor(miliseconds / $asOZn.ONE_THOUSAND);
}
module.exports.fromMiliseconds = $2494e1d4fe09de0f$var$fromMiliseconds;

});
parcelRegister("asOZn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $g01mJ = parcelRequire("g01mJ");

$g01mJ.__exportStar((parcelRequire("9M6jU")), module.exports);

$g01mJ.__exportStar((parcelRequire("9tyFe")), module.exports);

});
parcelRegister("9M6jU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ONE_THOUSAND = module.exports.ONE_HUNDRED = void 0;
module.exports.ONE_HUNDRED = 100;
module.exports.ONE_THOUSAND = 1000;

});

parcelRegister("9tyFe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ONE_YEAR = module.exports.FOUR_WEEKS = module.exports.THREE_WEEKS = module.exports.TWO_WEEKS = module.exports.ONE_WEEK = module.exports.THIRTY_DAYS = module.exports.SEVEN_DAYS = module.exports.FIVE_DAYS = module.exports.THREE_DAYS = module.exports.ONE_DAY = module.exports.TWENTY_FOUR_HOURS = module.exports.TWELVE_HOURS = module.exports.SIX_HOURS = module.exports.THREE_HOURS = module.exports.ONE_HOUR = module.exports.SIXTY_MINUTES = module.exports.THIRTY_MINUTES = module.exports.TEN_MINUTES = module.exports.FIVE_MINUTES = module.exports.ONE_MINUTE = module.exports.SIXTY_SECONDS = module.exports.THIRTY_SECONDS = module.exports.TEN_SECONDS = module.exports.FIVE_SECONDS = module.exports.ONE_SECOND = void 0;
module.exports.ONE_SECOND = 1;
module.exports.FIVE_SECONDS = 5;
module.exports.TEN_SECONDS = 10;
module.exports.THIRTY_SECONDS = 30;
module.exports.SIXTY_SECONDS = 60;
module.exports.ONE_MINUTE = module.exports.SIXTY_SECONDS;
module.exports.FIVE_MINUTES = module.exports.ONE_MINUTE * 5;
module.exports.TEN_MINUTES = module.exports.ONE_MINUTE * 10;
module.exports.THIRTY_MINUTES = module.exports.ONE_MINUTE * 30;
module.exports.SIXTY_MINUTES = module.exports.ONE_MINUTE * 60;
module.exports.ONE_HOUR = module.exports.SIXTY_MINUTES;
module.exports.THREE_HOURS = module.exports.ONE_HOUR * 3;
module.exports.SIX_HOURS = module.exports.ONE_HOUR * 6;
module.exports.TWELVE_HOURS = module.exports.ONE_HOUR * 12;
module.exports.TWENTY_FOUR_HOURS = module.exports.ONE_HOUR * 24;
module.exports.ONE_DAY = module.exports.TWENTY_FOUR_HOURS;
module.exports.THREE_DAYS = module.exports.ONE_DAY * 3;
module.exports.FIVE_DAYS = module.exports.ONE_DAY * 5;
module.exports.SEVEN_DAYS = module.exports.ONE_DAY * 7;
module.exports.THIRTY_DAYS = module.exports.ONE_DAY * 30;
module.exports.ONE_WEEK = module.exports.SEVEN_DAYS;
module.exports.TWO_WEEKS = module.exports.ONE_WEEK * 2;
module.exports.THREE_WEEKS = module.exports.ONE_WEEK * 3;
module.exports.FOUR_WEEKS = module.exports.ONE_WEEK * 4;
module.exports.ONE_YEAR = module.exports.ONE_DAY * 365;

});




parcelRegister("4ytPO", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Watch = void 0;
var $35117af1c70e8fd9$var$Watch = /*#__PURE__*/ function() {
    function Watch() {
        (0, $4GJKx._)(this, Watch);
        this.timestamps = new Map();
    }
    (0, $1wc17._)(Watch, [
        {
            key: "start",
            value: function start(label) {
                if (this.timestamps.has(label)) throw new Error("Watch already started for label: ".concat(label));
                this.timestamps.set(label, {
                    started: Date.now()
                });
            }
        },
        {
            key: "stop",
            value: function stop(label) {
                var timestamp = this.get(label);
                if (typeof timestamp.elapsed !== "undefined") throw new Error("Watch already stopped for label: ".concat(label));
                var elapsed = Date.now() - timestamp.started;
                this.timestamps.set(label, {
                    started: timestamp.started,
                    elapsed: elapsed
                });
            }
        },
        {
            key: "get",
            value: function get(label) {
                var timestamp = this.timestamps.get(label);
                if (typeof timestamp === "undefined") throw new Error("No timestamp found for label: ".concat(label));
                return timestamp;
            }
        },
        {
            key: "elapsed",
            value: function elapsed(label) {
                var timestamp = this.get(label);
                var elapsed = timestamp.elapsed || Date.now() - timestamp.started;
                return elapsed;
            }
        }
    ]);
    return Watch;
}();
module.exports.Watch = $35117af1c70e8fd9$var$Watch;
module.exports.default = $35117af1c70e8fd9$var$Watch;

});

parcelRegister("2H9vU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $g01mJ = parcelRequire("g01mJ");

$g01mJ.__exportStar((parcelRequire("hhJcd")), module.exports);

});
parcelRegister("hhJcd", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IWatch = void 0;
var $c957152ab0066690$var$IWatch = function IWatch() {
    (0, $4GJKx._)(this, IWatch);
};
module.exports.IWatch = $c957152ab0066690$var$IWatch;

});



parcelRegister("4caNq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getLocalStorage = module.exports.getLocalStorageOrThrow = module.exports.getCrypto = module.exports.getCryptoOrThrow = module.exports.getLocation = module.exports.getLocationOrThrow = module.exports.getNavigator = module.exports.getNavigatorOrThrow = module.exports.getDocument = module.exports.getDocumentOrThrow = module.exports.getFromWindowOrThrow = module.exports.getFromWindow = void 0;
function $30e0a8549404672a$var$getFromWindow(name) {
    var res = undefined;
    if (typeof window !== "undefined" && typeof window[name] !== "undefined") res = window[name];
    return res;
}
module.exports.getFromWindow = $30e0a8549404672a$var$getFromWindow;
function $30e0a8549404672a$var$getFromWindowOrThrow(name) {
    var res = $30e0a8549404672a$var$getFromWindow(name);
    if (!res) throw new Error("".concat(name, " is not defined in Window"));
    return res;
}
module.exports.getFromWindowOrThrow = $30e0a8549404672a$var$getFromWindowOrThrow;
function $30e0a8549404672a$var$getDocumentOrThrow() {
    return $30e0a8549404672a$var$getFromWindowOrThrow("document");
}
module.exports.getDocumentOrThrow = $30e0a8549404672a$var$getDocumentOrThrow;
function $30e0a8549404672a$var$getDocument() {
    return $30e0a8549404672a$var$getFromWindow("document");
}
module.exports.getDocument = $30e0a8549404672a$var$getDocument;
function $30e0a8549404672a$var$getNavigatorOrThrow() {
    return $30e0a8549404672a$var$getFromWindowOrThrow("navigator");
}
module.exports.getNavigatorOrThrow = $30e0a8549404672a$var$getNavigatorOrThrow;
function $30e0a8549404672a$var$getNavigator() {
    return $30e0a8549404672a$var$getFromWindow("navigator");
}
module.exports.getNavigator = $30e0a8549404672a$var$getNavigator;
function $30e0a8549404672a$var$getLocationOrThrow() {
    return $30e0a8549404672a$var$getFromWindowOrThrow("location");
}
module.exports.getLocationOrThrow = $30e0a8549404672a$var$getLocationOrThrow;
function $30e0a8549404672a$var$getLocation() {
    return $30e0a8549404672a$var$getFromWindow("location");
}
module.exports.getLocation = $30e0a8549404672a$var$getLocation;
function $30e0a8549404672a$var$getCryptoOrThrow() {
    return $30e0a8549404672a$var$getFromWindowOrThrow("crypto");
}
module.exports.getCryptoOrThrow = $30e0a8549404672a$var$getCryptoOrThrow;
function $30e0a8549404672a$var$getCrypto() {
    return $30e0a8549404672a$var$getFromWindow("crypto");
}
module.exports.getCrypto = $30e0a8549404672a$var$getCrypto;
function $30e0a8549404672a$var$getLocalStorageOrThrow() {
    return $30e0a8549404672a$var$getFromWindowOrThrow("localStorage");
}
module.exports.getLocalStorageOrThrow = $30e0a8549404672a$var$getLocalStorageOrThrow;
function $30e0a8549404672a$var$getLocalStorage() {
    return $30e0a8549404672a$var$getFromWindow("localStorage");
}
module.exports.getLocalStorage = $30e0a8549404672a$var$getLocalStorage;

});

parcelRegister("kfXuF", function(module, exports) {

var $l0HdX = parcelRequire("l0HdX");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getWindowMetadata = void 0;

var $4caNq = parcelRequire("4caNq");
function $ebf35b8dac0238f1$var$getWindowMetadata() {
    var doc;
    var loc;
    try {
        doc = $4caNq.getDocumentOrThrow();
        loc = $4caNq.getLocationOrThrow();
    } catch (e) {
        return null;
    }
    function getIcons() {
        var links = doc.getElementsByTagName("link");
        var icons = [];
        for(var i = 0; i < links.length; i++){
            var link = links[i];
            var rel = link.getAttribute("rel");
            if (rel) {
                if (rel.toLowerCase().indexOf("icon") > -1) {
                    var href = link.getAttribute("href");
                    if (href) {
                        if (href.toLowerCase().indexOf("https:") === -1 && href.toLowerCase().indexOf("http:") === -1 && href.indexOf("//") !== 0) {
                            var absoluteHref = loc.protocol + "//" + loc.host;
                            if (href.indexOf("/") === 0) absoluteHref += href;
                            else {
                                var path = loc.pathname.split("/");
                                path.pop();
                                var finalPath = path.join("/");
                                absoluteHref += finalPath + "/" + href;
                            }
                            icons.push(absoluteHref);
                        } else if (href.indexOf("//") === 0) {
                            var absoluteUrl = loc.protocol + href;
                            icons.push(absoluteUrl);
                        } else icons.push(href);
                    }
                }
            }
        }
        return icons;
    }
    function getWindowMetadataOfAny() {
        var _loop = function(i) {
            var tag = metaTags[i];
            var attributes = [
                "itemprop",
                "property",
                "name"
            ].map(function(target) {
                return tag.getAttribute(target);
            }).filter(function(attr) {
                if (attr) return args.includes(attr);
                return false;
            });
            if (attributes.length && attributes) {
                var content = tag.getAttribute("content");
                if (content) return {
                    v: content
                };
            }
        };
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var metaTags = doc.getElementsByTagName("meta");
        for(var i = 0; i < metaTags.length; i++){
            var _ret = _loop(i);
            if ((0, $l0HdX._)(_ret) === "object") return _ret.v;
        }
        return "";
    }
    function getName() {
        var name = getWindowMetadataOfAny("name", "og:site_name", "og:title", "twitter:title");
        if (!name) name = doc.title;
        return name;
    }
    function getDescription() {
        var description = getWindowMetadataOfAny("description", "og:description", "twitter:description", "keywords");
        return description;
    }
    var name = getName();
    var description = getDescription();
    var url = loc.origin;
    var icons = getIcons();
    var meta = {
        description: description,
        url: url,
        icons: icons,
        name: name
    };
    return meta;
}
module.exports.getWindowMetadata = $ebf35b8dac0238f1$var$getWindowMetadata;

});

parcelRegister("hDCWT", function(module, exports) {

$parcel$export(module.exports, "extract", function () { return $cd744a9a319cc687$export$f9380c9a627682d3; }, function (v) { return $cd744a9a319cc687$export$f9380c9a627682d3 = v; });
$parcel$export(module.exports, "parse", function () { return $cd744a9a319cc687$export$98e6a39c04603d36; }, function (v) { return $cd744a9a319cc687$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $cd744a9a319cc687$export$fac44ee5b035f737; }, function (v) { return $cd744a9a319cc687$export$fac44ee5b035f737 = v; });
$parcel$export(module.exports, "parseUrl", function () { return $cd744a9a319cc687$export$7a5253c0f62e0150; }, function (v) { return $cd744a9a319cc687$export$7a5253c0f62e0150 = v; });
$parcel$export(module.exports, "stringifyUrl", function () { return $cd744a9a319cc687$export$a8c1621ea79325d3; }, function (v) { return $cd744a9a319cc687$export$a8c1621ea79325d3 = v; });
$parcel$export(module.exports, "pick", function () { return $cd744a9a319cc687$export$357523c63a2253b9; }, function (v) { return $cd744a9a319cc687$export$357523c63a2253b9 = v; });

var $3sHb8 = parcelRequire("3sHb8");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");
var $cd744a9a319cc687$export$f9380c9a627682d3;
var $cd744a9a319cc687$export$98e6a39c04603d36;
var $cd744a9a319cc687$export$fac44ee5b035f737;
var $cd744a9a319cc687$export$7a5253c0f62e0150;
var $cd744a9a319cc687$export$a8c1621ea79325d3;
var $cd744a9a319cc687$export$357523c63a2253b9;
var $cd744a9a319cc687$export$44c361b8ec72ef7f;
"use strict";

var $6pUpV = parcelRequire("6pUpV");

var $zKeTC = parcelRequire("zKeTC");

var $ljZAm = parcelRequire("ljZAm");

var $2Mx4x = parcelRequire("2Mx4x");
var $cd744a9a319cc687$var$isNullOrUndefined = function(value) {
    return value === null || value === undefined;
};
var $cd744a9a319cc687$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $cd744a9a319cc687$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return function(key) {
                return function(result, value) {
                    var index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return (0, $c6Xmf._)(result).concat([
                        [
                            $cd744a9a319cc687$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ]);
                    return (0, $c6Xmf._)(result).concat([
                        [
                            $cd744a9a319cc687$var$encode(key, options),
                            "[",
                            $cd744a9a319cc687$var$encode(index, options),
                            "]=",
                            $cd744a9a319cc687$var$encode(value, options)
                        ].join("")
                    ]);
                };
            };
        case "bracket":
            return function(key) {
                return function(result, value) {
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return (0, $c6Xmf._)(result).concat([
                        [
                            $cd744a9a319cc687$var$encode(key, options),
                            "[]"
                        ].join("")
                    ]);
                    return (0, $c6Xmf._)(result).concat([
                        [
                            $cd744a9a319cc687$var$encode(key, options),
                            "[]=",
                            $cd744a9a319cc687$var$encode(value, options)
                        ].join("")
                    ]);
                };
            };
        case "colon-list-separator":
            return function(key) {
                return function(result, value) {
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return (0, $c6Xmf._)(result).concat([
                        [
                            $cd744a9a319cc687$var$encode(key, options),
                            ":list="
                        ].join("")
                    ]);
                    return (0, $c6Xmf._)(result).concat([
                        [
                            $cd744a9a319cc687$var$encode(key, options),
                            ":list=",
                            $cd744a9a319cc687$var$encode(value, options)
                        ].join("")
                    ]);
                };
            };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                var keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return function(key) {
                    return function(result, value) {
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $cd744a9a319cc687$var$encode(key, options),
                                keyValueSep,
                                $cd744a9a319cc687$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $cd744a9a319cc687$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
                };
            }
        default:
            return function(key) {
                return function(result, value) {
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return (0, $c6Xmf._)(result).concat([
                        $cd744a9a319cc687$var$encode(key, options)
                    ]);
                    return (0, $c6Xmf._)(result).concat([
                        [
                            $cd744a9a319cc687$var$encode(key, options),
                            "=",
                            $cd744a9a319cc687$var$encode(value, options)
                        ].join("")
                    ]);
                };
            };
    }
}
function $cd744a9a319cc687$var$parserForArrayFormat(options) {
    var result;
    switch(options.arrayFormat){
        case "index":
            return function(key, value, accumulator) {
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return function(key, value, accumulator) {
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "colon-list-separator":
            return function(key, value, accumulator) {
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return function(key, value, accumulator) {
                var isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                var isEncodedArray = typeof value === "string" && !isArray && $cd744a9a319cc687$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $cd744a9a319cc687$var$decode(value, options) : value;
                var newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(function(item) {
                    return $cd744a9a319cc687$var$decode(item, options);
                }) : value === null ? value : $cd744a9a319cc687$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return function(key, value, accumulator) {
                var isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $cd744a9a319cc687$var$decode(value, options) : value;
                    return;
                }
                var arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map(function(item) {
                    return $cd744a9a319cc687$var$decode(item, options);
                });
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return function(key, value, accumulator) {
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $cd744a9a319cc687$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $cd744a9a319cc687$var$encode(value, options) {
    if (options.encode) return options.strict ? $6pUpV(value) : encodeURIComponent(value);
    return value;
}
function $cd744a9a319cc687$var$decode(value, options) {
    if (options.decode) return $zKeTC(value);
    return value;
}
function $cd744a9a319cc687$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $cd744a9a319cc687$var$keysSorter(Object.keys(input)).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(key) {
        return input[key];
    });
    return input;
}
function $cd744a9a319cc687$var$removeHash(input) {
    var hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $cd744a9a319cc687$var$getHash(url) {
    var hash = "";
    var hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $cd744a9a319cc687$var$extract(input) {
    input = $cd744a9a319cc687$var$removeHash(input);
    var queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $cd744a9a319cc687$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $cd744a9a319cc687$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $cd744a9a319cc687$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    var formatter = $cd744a9a319cc687$var$parserForArrayFormat(options);
    // Create an object with no prototype
    var ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = query.split("&")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var param = _step.value;
            if (param === "") continue;
            var _splitOnFirst = (0, $cv9Rk._)($ljZAm(options.decode ? param.replace(/\+/g, " ") : param, "="), 2), key = _splitOnFirst[0], value = _splitOnFirst[1];
            // Missing `=` should be `null`:
            // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
            value = value === undefined ? null : [
                "comma",
                "separator",
                "bracket-separator"
            ].includes(options.arrayFormat) ? value : $cd744a9a319cc687$var$decode(value, options);
            formatter($cd744a9a319cc687$var$decode(key, options), value, ret);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = Object.keys(ret)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var key1 = _step1.value;
            var value1 = ret[key1];
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            if (typeof value1 === "object" && value1 !== null) try {
                for(var _iterator2 = Object.keys(value1)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var k = _step2.value;
                    value1[k] = $cd744a9a319cc687$var$parseValue(value1[k], options);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
            else ret[key1] = $cd744a9a319cc687$var$parseValue(value1, options);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce(function(result, key) {
        var value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $cd744a9a319cc687$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$cd744a9a319cc687$export$f9380c9a627682d3 = $cd744a9a319cc687$var$extract;
$cd744a9a319cc687$export$98e6a39c04603d36 = $cd744a9a319cc687$var$parse;
$cd744a9a319cc687$export$fac44ee5b035f737 = function(object, options) {
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    $cd744a9a319cc687$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    var shouldFilter = function(key) {
        return options.skipNull && $cd744a9a319cc687$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    };
    var formatter = $cd744a9a319cc687$var$encoderForArrayFormat(options);
    var objectCopy = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(object)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (!shouldFilter(key)) objectCopy[key] = object[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map(function(key) {
        var value = object[key];
        if (value === undefined) return "";
        if (value === null) return $cd744a9a319cc687$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $cd744a9a319cc687$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $cd744a9a319cc687$var$encode(key, options) + "=" + $cd744a9a319cc687$var$encode(value, options);
    }).filter(function(x) {
        return x.length > 0;
    }).join("&");
};
$cd744a9a319cc687$export$7a5253c0f62e0150 = function(url, options) {
    options = Object.assign({
        decode: true
    }, options);
    var _splitOnFirst = (0, $cv9Rk._)($ljZAm(url, "#"), 2), url_ = _splitOnFirst[0], hash = _splitOnFirst[1];
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: $cd744a9a319cc687$var$parse($cd744a9a319cc687$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $cd744a9a319cc687$var$decode(hash, options)
    } : {});
};
$cd744a9a319cc687$export$a8c1621ea79325d3 = function(object, options) {
    options = Object.assign((0, $3sHb8._)({
        encode: true,
        strict: true
    }, $cd744a9a319cc687$var$encodeFragmentIdentifier, true), options);
    var url = $cd744a9a319cc687$var$removeHash(object.url).split("?")[0] || "";
    var queryFromUrl = $cd744a9a319cc687$export$f9380c9a627682d3(object.url);
    var parsedQueryFromUrl = $cd744a9a319cc687$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    var query = Object.assign(parsedQueryFromUrl, object.query);
    var queryString = $cd744a9a319cc687$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = "?".concat(queryString);
    var hash = $cd744a9a319cc687$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = "#".concat(options[$cd744a9a319cc687$var$encodeFragmentIdentifier] ? $cd744a9a319cc687$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier);
    return "".concat(url).concat(queryString).concat(hash);
};
$cd744a9a319cc687$export$357523c63a2253b9 = function(input, filter, options) {
    options = Object.assign((0, $3sHb8._)({
        parseFragmentIdentifier: true
    }, $cd744a9a319cc687$var$encodeFragmentIdentifier, false), options);
    var _exports_parseUrl = $cd744a9a319cc687$export$7a5253c0f62e0150(input, options), url = _exports_parseUrl.url, query = _exports_parseUrl.query, fragmentIdentifier = _exports_parseUrl.fragmentIdentifier;
    return $cd744a9a319cc687$export$a8c1621ea79325d3({
        url: url,
        query: $2Mx4x(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$cd744a9a319cc687$export$44c361b8ec72ef7f = function(input, filter, options) {
    var exclusionFilter = Array.isArray(filter) ? function(key) {
        return !filter.includes(key);
    } : function(key, value) {
        return !filter(key, value);
    };
    return $cd744a9a319cc687$export$357523c63a2253b9(input, exclusionFilter, options);
};

});
parcelRegister("6pUpV", function(module, exports) {
"use strict";
module.exports = function(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(x) {
        return "%".concat(x.charCodeAt(0).toString(16).toUpperCase());
    });
};

});

parcelRegister("zKeTC", function(module, exports) {

var $l0HdX = parcelRequire("l0HdX");
"use strict";
var $06b723271f58e700$var$token = "%[a-f0-9]{2}";
var $06b723271f58e700$var$singleMatcher = new RegExp("(" + $06b723271f58e700$var$token + ")|([^%]+?)", "gi");
var $06b723271f58e700$var$multiMatcher = new RegExp("(" + $06b723271f58e700$var$token + ")+", "gi");
function $06b723271f58e700$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $06b723271f58e700$var$decodeComponents(left), $06b723271f58e700$var$decodeComponents(right));
}
function $06b723271f58e700$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($06b723271f58e700$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $06b723271f58e700$var$decodeComponents(tokens, i).join("");
            tokens = input.match($06b723271f58e700$var$singleMatcher) || [];
        }
        return input;
    }
}
function $06b723271f58e700$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        "%FE%FF": "\uFFFD\uFFFD",
        "%FF%FE": "\uFFFD\uFFFD"
    };
    var match = $06b723271f58e700$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $06b723271f58e700$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $06b723271f58e700$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "\uFFFD";
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + (typeof encodedURI === "undefined" ? "undefined" : (0, $l0HdX._)(encodedURI)) + "`");
    try {
        encodedURI = encodedURI.replace(/\+/g, " ");
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $06b723271f58e700$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("ljZAm", function(module, exports) {
"use strict";
module.exports = function(string, separator) {
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (separator === "") return [
        string
    ];
    var separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("2Mx4x", function(module, exports) {
"use strict";
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});


parcelRegister("1MbOp", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fTpET = parcelRequire("fTpET");

var $eMcuk = parcelRequire("eMcuk");

var $1iHRq = parcelRequire("1iHRq");

var $9sToB = parcelRequire("9sToB");

var $3z58J = parcelRequire("3z58J");
module.exports.KEY_LENGTH = 32;
module.exports.NONCE_LENGTH = 12;
module.exports.TAG_LENGTH = 16;
var $14b36fc2a9ba95fe$var$ZEROS = new Uint8Array(16);
/**
 * ChaCha20-Poly1305 Authenticated Encryption with Associated Data.
 *
 * Defined in RFC7539.
 */ var $14b36fc2a9ba95fe$var$ChaCha20Poly1305 = /** @class */ function() {
    /**
     * Creates a new instance with the given 32-byte key.
     */ function ChaCha20Poly1305(key) {
        this.nonceLength = module.exports.NONCE_LENGTH;
        this.tagLength = module.exports.TAG_LENGTH;
        if (key.length !== module.exports.KEY_LENGTH) throw new Error("ChaCha20Poly1305 needs 32-byte key");
        // Copy key.
        this._key = new Uint8Array(key);
    }
    /**
     * Encrypts and authenticates plaintext, authenticates associated data,
     * and returns sealed ciphertext, which includes authentication tag.
     *
     * RFC7539 specifies 12 bytes for nonce. It may be this 12-byte nonce
     * ("IV"), or full 16-byte counter (called "32-bit fixed-common part")
     * and nonce.
     *
     * If dst is given (it must be the size of plaintext + the size of tag
     * length) the result will be put into it. Dst and plaintext must not
     * overlap.
     */ ChaCha20Poly1305.prototype.seal = function(nonce, plaintext, associatedData, dst) {
        if (nonce.length > 16) throw new Error("ChaCha20Poly1305: incorrect nonce length");
        // Allocate space for counter, and set nonce as last bytes of it.
        var counter = new Uint8Array(16);
        counter.set(nonce, counter.length - nonce.length);
        // Generate authentication key by taking first 32-bytes of stream.
        // We pass full counter, which has 12-byte nonce and 4-byte block counter,
        // and it will get incremented after generating the block, which is
        // exactly what we need: we only use the first 32 bytes of 64-byte
        // ChaCha block and discard the next 32 bytes.
        var authKey = new Uint8Array(32);
        $fTpET.stream(this._key, counter, authKey, 4);
        // Allocate space for sealed ciphertext.
        var resultLength = plaintext.length + this.tagLength;
        var result;
        if (dst) {
            if (dst.length !== resultLength) throw new Error("ChaCha20Poly1305: incorrect destination length");
            result = dst;
        } else result = new Uint8Array(resultLength);
        // Encrypt plaintext.
        $fTpET.streamXOR(this._key, counter, plaintext, result, 4);
        // Authenticate.
        // XXX: can "simplify" here: pass full result (which is already padded
        // due to zeroes prepared for tag), and ciphertext length instead of
        // subarray of result.
        this._authenticate(result.subarray(result.length - this.tagLength, result.length), authKey, result.subarray(0, result.length - this.tagLength), associatedData);
        // Cleanup.
        $1iHRq.wipe(counter);
        return result;
    };
    /**
     * Authenticates sealed ciphertext (which includes authentication tag) and
     * associated data, decrypts ciphertext and returns decrypted plaintext.
     *
     * RFC7539 specifies 12 bytes for nonce. It may be this 12-byte nonce
     * ("IV"), or full 16-byte counter (called "32-bit fixed-common part")
     * and nonce.
     *
     * If authentication fails, it returns null.
     *
     * If dst is given (it must be of ciphertext length minus tag length),
     * the result will be put into it. Dst and plaintext must not overlap.
     */ ChaCha20Poly1305.prototype.open = function(nonce, sealed, associatedData, dst) {
        if (nonce.length > 16) throw new Error("ChaCha20Poly1305: incorrect nonce length");
        // Sealed ciphertext should at least contain tag.
        if (sealed.length < this.tagLength) // TODO(dchest): should we throw here instead?
        return null;
        // Allocate space for counter, and set nonce as last bytes of it.
        var counter = new Uint8Array(16);
        counter.set(nonce, counter.length - nonce.length);
        // Generate authentication key by taking first 32-bytes of stream.
        var authKey = new Uint8Array(32);
        $fTpET.stream(this._key, counter, authKey, 4);
        // Authenticate.
        // XXX: can simplify and avoid allocation: since authenticate()
        // already allocates tag (from Poly1305.digest(), it can return)
        // it instead of copying to calculatedTag. But then in seal()
        // we'll need to copy it.
        var calculatedTag = new Uint8Array(this.tagLength);
        this._authenticate(calculatedTag, authKey, sealed.subarray(0, sealed.length - this.tagLength), associatedData);
        // Constant-time compare tags and return null if they differ.
        if (!$3z58J.equal(calculatedTag, sealed.subarray(sealed.length - this.tagLength, sealed.length))) return null;
        // Allocate space for decrypted plaintext.
        var resultLength = sealed.length - this.tagLength;
        var result;
        if (dst) {
            if (dst.length !== resultLength) throw new Error("ChaCha20Poly1305: incorrect destination length");
            result = dst;
        } else result = new Uint8Array(resultLength);
        // Decrypt.
        $fTpET.streamXOR(this._key, counter, sealed.subarray(0, sealed.length - this.tagLength), result, 4);
        // Cleanup.
        $1iHRq.wipe(counter);
        return result;
    };
    ChaCha20Poly1305.prototype.clean = function() {
        $1iHRq.wipe(this._key);
        return this;
    };
    ChaCha20Poly1305.prototype._authenticate = function(tagOut, authKey, ciphertext, associatedData) {
        // Initialize Poly1305 with authKey.
        var h = new $eMcuk.Poly1305(authKey);
        // Authenticate padded associated data.
        if (associatedData) {
            h.update(associatedData);
            if (associatedData.length % 16 > 0) h.update($14b36fc2a9ba95fe$var$ZEROS.subarray(associatedData.length % 16));
        }
        // Authenticate padded ciphertext.
        h.update(ciphertext);
        if (ciphertext.length % 16 > 0) h.update($14b36fc2a9ba95fe$var$ZEROS.subarray(ciphertext.length % 16));
        // Authenticate length of associated data.
        // XXX: can avoid allocation here?
        var length = new Uint8Array(8);
        if (associatedData) $9sToB.writeUint64LE(associatedData.length, length);
        h.update(length);
        // Authenticate length of ciphertext.
        $9sToB.writeUint64LE(ciphertext.length, length);
        h.update(length);
        // Get tag and copy it into tagOut.
        var tag = h.digest();
        for(var i = 0; i < tag.length; i++)tagOut[i] = tag[i];
        // Cleanup.
        h.clean();
        $1iHRq.wipe(tag);
        $1iHRq.wipe(length);
    };
    return ChaCha20Poly1305;
}();
module.exports.ChaCha20Poly1305 = $14b36fc2a9ba95fe$var$ChaCha20Poly1305;

});
parcelRegister("fTpET", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9sToB = parcelRequire("9sToB");

var $1iHRq = parcelRequire("1iHRq");
// Number of ChaCha rounds (ChaCha20).
var $b91fe55717a7fcd5$var$ROUNDS = 20;
// Applies the ChaCha core function to 16-byte input,
// 32-byte key key, and puts the result into 64-byte array out.
function $b91fe55717a7fcd5$var$core(out, input, key) {
    var j0 = 0x61707865; // "expa"  -- ChaCha's "sigma" constant
    var j1 = 0x3320646E; // "nd 3"     for 32-byte keys
    var j2 = 0x79622D32; // "2-by"
    var j3 = 0x6B206574; // "te k"
    var j4 = key[3] << 24 | key[2] << 16 | key[1] << 8 | key[0];
    var j5 = key[7] << 24 | key[6] << 16 | key[5] << 8 | key[4];
    var j6 = key[11] << 24 | key[10] << 16 | key[9] << 8 | key[8];
    var j7 = key[15] << 24 | key[14] << 16 | key[13] << 8 | key[12];
    var j8 = key[19] << 24 | key[18] << 16 | key[17] << 8 | key[16];
    var j9 = key[23] << 24 | key[22] << 16 | key[21] << 8 | key[20];
    var j10 = key[27] << 24 | key[26] << 16 | key[25] << 8 | key[24];
    var j11 = key[31] << 24 | key[30] << 16 | key[29] << 8 | key[28];
    var j12 = input[3] << 24 | input[2] << 16 | input[1] << 8 | input[0];
    var j13 = input[7] << 24 | input[6] << 16 | input[5] << 8 | input[4];
    var j14 = input[11] << 24 | input[10] << 16 | input[9] << 8 | input[8];
    var j15 = input[15] << 24 | input[14] << 16 | input[13] << 8 | input[12];
    var x0 = j0;
    var x1 = j1;
    var x2 = j2;
    var x3 = j3;
    var x4 = j4;
    var x5 = j5;
    var x6 = j6;
    var x7 = j7;
    var x8 = j8;
    var x9 = j9;
    var x10 = j10;
    var x11 = j11;
    var x12 = j12;
    var x13 = j13;
    var x14 = j14;
    var x15 = j15;
    for(var i = 0; i < $b91fe55717a7fcd5$var$ROUNDS; i += 2){
        x0 = x0 + x4 | 0;
        x12 ^= x0;
        x12 = x12 >>> 16 | x12 << 16;
        x8 = x8 + x12 | 0;
        x4 ^= x8;
        x4 = x4 >>> 20 | x4 << 12;
        x1 = x1 + x5 | 0;
        x13 ^= x1;
        x13 = x13 >>> 16 | x13 << 16;
        x9 = x9 + x13 | 0;
        x5 ^= x9;
        x5 = x5 >>> 20 | x5 << 12;
        x2 = x2 + x6 | 0;
        x14 ^= x2;
        x14 = x14 >>> 16 | x14 << 16;
        x10 = x10 + x14 | 0;
        x6 ^= x10;
        x6 = x6 >>> 20 | x6 << 12;
        x3 = x3 + x7 | 0;
        x15 ^= x3;
        x15 = x15 >>> 16 | x15 << 16;
        x11 = x11 + x15 | 0;
        x7 ^= x11;
        x7 = x7 >>> 20 | x7 << 12;
        x2 = x2 + x6 | 0;
        x14 ^= x2;
        x14 = x14 >>> 24 | x14 << 8;
        x10 = x10 + x14 | 0;
        x6 ^= x10;
        x6 = x6 >>> 25 | x6 << 7;
        x3 = x3 + x7 | 0;
        x15 ^= x3;
        x15 = x15 >>> 24 | x15 << 8;
        x11 = x11 + x15 | 0;
        x7 ^= x11;
        x7 = x7 >>> 25 | x7 << 7;
        x1 = x1 + x5 | 0;
        x13 ^= x1;
        x13 = x13 >>> 24 | x13 << 8;
        x9 = x9 + x13 | 0;
        x5 ^= x9;
        x5 = x5 >>> 25 | x5 << 7;
        x0 = x0 + x4 | 0;
        x12 ^= x0;
        x12 = x12 >>> 24 | x12 << 8;
        x8 = x8 + x12 | 0;
        x4 ^= x8;
        x4 = x4 >>> 25 | x4 << 7;
        x0 = x0 + x5 | 0;
        x15 ^= x0;
        x15 = x15 >>> 16 | x15 << 16;
        x10 = x10 + x15 | 0;
        x5 ^= x10;
        x5 = x5 >>> 20 | x5 << 12;
        x1 = x1 + x6 | 0;
        x12 ^= x1;
        x12 = x12 >>> 16 | x12 << 16;
        x11 = x11 + x12 | 0;
        x6 ^= x11;
        x6 = x6 >>> 20 | x6 << 12;
        x2 = x2 + x7 | 0;
        x13 ^= x2;
        x13 = x13 >>> 16 | x13 << 16;
        x8 = x8 + x13 | 0;
        x7 ^= x8;
        x7 = x7 >>> 20 | x7 << 12;
        x3 = x3 + x4 | 0;
        x14 ^= x3;
        x14 = x14 >>> 16 | x14 << 16;
        x9 = x9 + x14 | 0;
        x4 ^= x9;
        x4 = x4 >>> 20 | x4 << 12;
        x2 = x2 + x7 | 0;
        x13 ^= x2;
        x13 = x13 >>> 24 | x13 << 8;
        x8 = x8 + x13 | 0;
        x7 ^= x8;
        x7 = x7 >>> 25 | x7 << 7;
        x3 = x3 + x4 | 0;
        x14 ^= x3;
        x14 = x14 >>> 24 | x14 << 8;
        x9 = x9 + x14 | 0;
        x4 ^= x9;
        x4 = x4 >>> 25 | x4 << 7;
        x1 = x1 + x6 | 0;
        x12 ^= x1;
        x12 = x12 >>> 24 | x12 << 8;
        x11 = x11 + x12 | 0;
        x6 ^= x11;
        x6 = x6 >>> 25 | x6 << 7;
        x0 = x0 + x5 | 0;
        x15 ^= x0;
        x15 = x15 >>> 24 | x15 << 8;
        x10 = x10 + x15 | 0;
        x5 ^= x10;
        x5 = x5 >>> 25 | x5 << 7;
    }
    $9sToB.writeUint32LE(x0 + j0 | 0, out, 0);
    $9sToB.writeUint32LE(x1 + j1 | 0, out, 4);
    $9sToB.writeUint32LE(x2 + j2 | 0, out, 8);
    $9sToB.writeUint32LE(x3 + j3 | 0, out, 12);
    $9sToB.writeUint32LE(x4 + j4 | 0, out, 16);
    $9sToB.writeUint32LE(x5 + j5 | 0, out, 20);
    $9sToB.writeUint32LE(x6 + j6 | 0, out, 24);
    $9sToB.writeUint32LE(x7 + j7 | 0, out, 28);
    $9sToB.writeUint32LE(x8 + j8 | 0, out, 32);
    $9sToB.writeUint32LE(x9 + j9 | 0, out, 36);
    $9sToB.writeUint32LE(x10 + j10 | 0, out, 40);
    $9sToB.writeUint32LE(x11 + j11 | 0, out, 44);
    $9sToB.writeUint32LE(x12 + j12 | 0, out, 48);
    $9sToB.writeUint32LE(x13 + j13 | 0, out, 52);
    $9sToB.writeUint32LE(x14 + j14 | 0, out, 56);
    $9sToB.writeUint32LE(x15 + j15 | 0, out, 60);
}
/**
 * Encrypt src with ChaCha20 stream generated for the given 32-byte key and
 * 8-byte (as in original implementation) or 12-byte (as in RFC7539) nonce and
 * write the result into dst and return it.
 *
 * dst and src may be the same, but otherwise must not overlap.
 *
 * If nonce is 12 bytes, users should not encrypt more than 256 GiB with the
 * same key and nonce, otherwise the stream will repeat. The function will
 * throw error if counter overflows to prevent this.
 *
 * If nonce is 8 bytes, the output is practically unlimited (2^70 bytes, which
 * is more than a million petabytes). However, it is not recommended to
 * generate 8-byte nonces randomly, as the chance of collision is high.
 *
 * Never use the same key and nonce to encrypt more than one message.
 *
 * If nonceInplaceCounterLength is not 0, the nonce is assumed to be a 16-byte
 * array with stream counter in first nonceInplaceCounterLength bytes and nonce
 * in the last remaining bytes. The counter will be incremented inplace for
 * each ChaCha block. This is useful if you need to encrypt one stream of data
 * in chunks.
 */ function $b91fe55717a7fcd5$var$streamXOR(key, nonce, src, dst, nonceInplaceCounterLength) {
    if (nonceInplaceCounterLength === void 0) nonceInplaceCounterLength = 0;
    // We only support 256-bit keys.
    if (key.length !== 32) throw new Error("ChaCha: key size must be 32 bytes");
    if (dst.length < src.length) throw new Error("ChaCha: destination is shorter than source");
    var nc;
    var counterLength;
    if (nonceInplaceCounterLength === 0) {
        if (nonce.length !== 8 && nonce.length !== 12) throw new Error("ChaCha nonce must be 8 or 12 bytes");
        nc = new Uint8Array(16);
        // First counterLength bytes of nc are counter, starting with zero.
        counterLength = nc.length - nonce.length;
        // Last bytes of nc after counterLength are nonce, set them.
        nc.set(nonce, counterLength);
    } else {
        if (nonce.length !== 16) throw new Error("ChaCha nonce with counter must be 16 bytes");
        // This will update passed nonce with counter inplace.
        nc = nonce;
        counterLength = nonceInplaceCounterLength;
    }
    // Allocate temporary space for ChaCha block.
    var block = new Uint8Array(64);
    for(var i = 0; i < src.length; i += 64){
        // Generate a block.
        $b91fe55717a7fcd5$var$core(block, nc, key);
        // XOR block bytes with src into dst.
        for(var j = i; j < i + 64 && j < src.length; j++)dst[j] = src[j] ^ block[j - i];
        // Increment counter.
        $b91fe55717a7fcd5$var$incrementCounter(nc, 0, counterLength);
    }
    // Cleanup temporary space.
    $1iHRq.wipe(block);
    if (nonceInplaceCounterLength === 0) // Cleanup counter.
    $1iHRq.wipe(nc);
    return dst;
}
module.exports.streamXOR = $b91fe55717a7fcd5$var$streamXOR;
/**
 * Generate ChaCha20 stream for the given 32-byte key and 8-byte or 12-byte
 * nonce and write it into dst and return it.
 *
 * Never use the same key and nonce to generate more than one stream.
 *
 * If nonceInplaceCounterLength is not 0, it behaves the same with respect to
 * the nonce as described in the streamXOR documentation.
 *
 * stream is like streamXOR with all-zero src.
 */ function $b91fe55717a7fcd5$var$stream(key, nonce, dst, nonceInplaceCounterLength) {
    if (nonceInplaceCounterLength === void 0) nonceInplaceCounterLength = 0;
    $1iHRq.wipe(dst);
    return $b91fe55717a7fcd5$var$streamXOR(key, nonce, dst, dst, nonceInplaceCounterLength);
}
module.exports.stream = $b91fe55717a7fcd5$var$stream;
function $b91fe55717a7fcd5$var$incrementCounter(counter, pos, len) {
    var carry = 1;
    while(len--){
        carry = carry + (counter[pos] & 0xff) | 0;
        counter[pos] = carry & 0xff;
        carry >>>= 8;
        pos++;
    }
    if (carry > 0) throw new Error("ChaCha: counter overflow");
}

});
parcelRegister("9sToB", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2YjaL = parcelRequire("2YjaL");
// TODO(dchest): add asserts for correct value ranges and array offsets.
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * signed 16-bit integer and returns it.
 */ function $6e41b303b7c190b1$var$readInt16BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 0] << 8 | array[offset + 1]) << 16 >> 16;
}
module.exports.readInt16BE = $6e41b303b7c190b1$var$readInt16BE;
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * unsigned 16-bit integer and returns it.
 */ function $6e41b303b7c190b1$var$readUint16BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 0] << 8 | array[offset + 1]) >>> 0;
}
module.exports.readUint16BE = $6e41b303b7c190b1$var$readUint16BE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * signed 16-bit integer and returns it.
 */ function $6e41b303b7c190b1$var$readInt16LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 1] << 8 | array[offset]) << 16 >> 16;
}
module.exports.readInt16LE = $6e41b303b7c190b1$var$readInt16LE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * unsigned 16-bit integer and returns it.
 */ function $6e41b303b7c190b1$var$readUint16LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 1] << 8 | array[offset]) >>> 0;
}
module.exports.readUint16LE = $6e41b303b7c190b1$var$readUint16LE;
/**
 * Writes 2-byte big-endian representation of 16-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */ function $6e41b303b7c190b1$var$writeUint16BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(2);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 8;
    out[offset + 1] = value >>> 0;
    return out;
}
module.exports.writeUint16BE = $6e41b303b7c190b1$var$writeUint16BE;
module.exports.writeInt16BE = $6e41b303b7c190b1$var$writeUint16BE;
/**
 * Writes 2-byte little-endian representation of 16-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */ function $6e41b303b7c190b1$var$writeUint16LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(2);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    return out;
}
module.exports.writeUint16LE = $6e41b303b7c190b1$var$writeUint16LE;
module.exports.writeInt16LE = $6e41b303b7c190b1$var$writeUint16LE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * signed 32-bit integer and returns it.
 */ function $6e41b303b7c190b1$var$readInt32BE(array, offset) {
    if (offset === void 0) offset = 0;
    return array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3];
}
module.exports.readInt32BE = $6e41b303b7c190b1$var$readInt32BE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * unsigned 32-bit integer and returns it.
 */ function $6e41b303b7c190b1$var$readUint32BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3]) >>> 0;
}
module.exports.readUint32BE = $6e41b303b7c190b1$var$readUint32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * signed 32-bit integer and returns it.
 */ function $6e41b303b7c190b1$var$readInt32LE(array, offset) {
    if (offset === void 0) offset = 0;
    return array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset];
}
module.exports.readInt32LE = $6e41b303b7c190b1$var$readInt32LE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * unsigned 32-bit integer and returns it.
 */ function $6e41b303b7c190b1$var$readUint32LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset]) >>> 0;
}
module.exports.readUint32LE = $6e41b303b7c190b1$var$readUint32LE;
/**
 * Writes 4-byte big-endian representation of 32-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $6e41b303b7c190b1$var$writeUint32BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 24;
    out[offset + 1] = value >>> 16;
    out[offset + 2] = value >>> 8;
    out[offset + 3] = value >>> 0;
    return out;
}
module.exports.writeUint32BE = $6e41b303b7c190b1$var$writeUint32BE;
module.exports.writeInt32BE = $6e41b303b7c190b1$var$writeUint32BE;
/**
 * Writes 4-byte little-endian representation of 32-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $6e41b303b7c190b1$var$writeUint32LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    out[offset + 2] = value >>> 16;
    out[offset + 3] = value >>> 24;
    return out;
}
module.exports.writeUint32LE = $6e41b303b7c190b1$var$writeUint32LE;
module.exports.writeInt32LE = $6e41b303b7c190b1$var$writeUint32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */ function $6e41b303b7c190b1$var$readInt64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var hi = $6e41b303b7c190b1$var$readInt32BE(array, offset);
    var lo = $6e41b303b7c190b1$var$readInt32BE(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
module.exports.readInt64BE = $6e41b303b7c190b1$var$readInt64BE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */ function $6e41b303b7c190b1$var$readUint64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var hi = $6e41b303b7c190b1$var$readUint32BE(array, offset);
    var lo = $6e41b303b7c190b1$var$readUint32BE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
module.exports.readUint64BE = $6e41b303b7c190b1$var$readUint64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */ function $6e41b303b7c190b1$var$readInt64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var lo = $6e41b303b7c190b1$var$readInt32LE(array, offset);
    var hi = $6e41b303b7c190b1$var$readInt32LE(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
module.exports.readInt64LE = $6e41b303b7c190b1$var$readInt64LE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */ function $6e41b303b7c190b1$var$readUint64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var lo = $6e41b303b7c190b1$var$readUint32LE(array, offset);
    var hi = $6e41b303b7c190b1$var$readUint32LE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
module.exports.readUint64LE = $6e41b303b7c190b1$var$readUint64LE;
/**
 * Writes 8-byte big-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $6e41b303b7c190b1$var$writeUint64BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    $6e41b303b7c190b1$var$writeUint32BE(value / 0x100000000 >>> 0, out, offset);
    $6e41b303b7c190b1$var$writeUint32BE(value >>> 0, out, offset + 4);
    return out;
}
module.exports.writeUint64BE = $6e41b303b7c190b1$var$writeUint64BE;
module.exports.writeInt64BE = $6e41b303b7c190b1$var$writeUint64BE;
/**
 * Writes 8-byte little-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $6e41b303b7c190b1$var$writeUint64LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    $6e41b303b7c190b1$var$writeUint32LE(value >>> 0, out, offset);
    $6e41b303b7c190b1$var$writeUint32LE(value / 0x100000000 >>> 0, out, offset + 4);
    return out;
}
module.exports.writeUint64LE = $6e41b303b7c190b1$var$writeUint64LE;
module.exports.writeInt64LE = $6e41b303b7c190b1$var$writeUint64LE;
/**
 * Reads bytes from array starting at offset as big-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */ function $6e41b303b7c190b1$var$readUintBE(bitLength, array, offset) {
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintBE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintBE: array is too short for the given bitLength");
    var result = 0;
    var mul = 1;
    for(var i = bitLength / 8 + offset - 1; i >= offset; i--){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
module.exports.readUintBE = $6e41b303b7c190b1$var$readUintBE;
/**
 * Reads bytes from array starting at offset as little-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */ function $6e41b303b7c190b1$var$readUintLE(bitLength, array, offset) {
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintLE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintLE: array is too short for the given bitLength");
    var result = 0;
    var mul = 1;
    for(var i = offset; i < offset + bitLength / 8; i++){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
module.exports.readUintLE = $6e41b303b7c190b1$var$readUintLE;
/**
 * Writes a big-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */ function $6e41b303b7c190b1$var$writeUintBE(bitLength, value, out, offset) {
    if (out === void 0) out = new Uint8Array(bitLength / 8);
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintBE supports only bitLengths divisible by 8");
    if (!$2YjaL.isSafeInteger(value)) throw new Error("writeUintBE value must be an integer");
    var div = 1;
    for(var i = bitLength / 8 + offset - 1; i >= offset; i--){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
module.exports.writeUintBE = $6e41b303b7c190b1$var$writeUintBE;
/**
 * Writes a little-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */ function $6e41b303b7c190b1$var$writeUintLE(bitLength, value, out, offset) {
    if (out === void 0) out = new Uint8Array(bitLength / 8);
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintLE supports only bitLengths divisible by 8");
    if (!$2YjaL.isSafeInteger(value)) throw new Error("writeUintLE value must be an integer");
    var div = 1;
    for(var i = offset; i < offset + bitLength / 8; i++){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
module.exports.writeUintLE = $6e41b303b7c190b1$var$writeUintLE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * 32-bit floating-point number and returns it.
 */ function $6e41b303b7c190b1$var$readFloat32BE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset);
}
module.exports.readFloat32BE = $6e41b303b7c190b1$var$readFloat32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * 32-bit floating-point number and returns it.
 */ function $6e41b303b7c190b1$var$readFloat32LE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset, true);
}
module.exports.readFloat32LE = $6e41b303b7c190b1$var$readFloat32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * 64-bit floating-point number ("double") and returns it.
 */ function $6e41b303b7c190b1$var$readFloat64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset);
}
module.exports.readFloat64BE = $6e41b303b7c190b1$var$readFloat64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * 64-bit floating-point number ("double") and returns it.
 */ function $6e41b303b7c190b1$var$readFloat64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset, true);
}
module.exports.readFloat64LE = $6e41b303b7c190b1$var$readFloat64LE;
/**
 * Writes 4-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $6e41b303b7c190b1$var$writeFloat32BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value);
    return out;
}
module.exports.writeFloat32BE = $6e41b303b7c190b1$var$writeFloat32BE;
/**
 * Writes 4-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $6e41b303b7c190b1$var$writeFloat32LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value, true);
    return out;
}
module.exports.writeFloat32LE = $6e41b303b7c190b1$var$writeFloat32LE;
/**
 * Writes 8-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $6e41b303b7c190b1$var$writeFloat64BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value);
    return out;
}
module.exports.writeFloat64BE = $6e41b303b7c190b1$var$writeFloat64BE;
/**
 * Writes 8-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $6e41b303b7c190b1$var$writeFloat64LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value, true);
    return out;
}
module.exports.writeFloat64LE = $6e41b303b7c190b1$var$writeFloat64LE;

});
parcelRegister("2YjaL", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Package int provides helper functions for integerss.
 */ // Shim using 16-bit pieces.
function $22a00ea76a731e6a$var$imulShim(a, b) {
    var ah = a >>> 16 & 0xffff, al = a & 0xffff;
    var bh = b >>> 16 & 0xffff, bl = b & 0xffff;
    return al * bl + (ah * bl + al * bh << 16 >>> 0) | 0;
}
/** 32-bit integer multiplication.  */ // Use system Math.imul if available, otherwise use our shim.
module.exports.mul = Math.imul || $22a00ea76a731e6a$var$imulShim;
/** 32-bit integer addition.  */ function $22a00ea76a731e6a$var$add(a, b) {
    return a + b | 0;
}
module.exports.add = $22a00ea76a731e6a$var$add;
/**  32-bit integer subtraction.  */ function $22a00ea76a731e6a$var$sub(a, b) {
    return a - b | 0;
}
module.exports.sub = $22a00ea76a731e6a$var$sub;
/** 32-bit integer left rotation */ function $22a00ea76a731e6a$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
module.exports.rotl = $22a00ea76a731e6a$var$rotl;
/** 32-bit integer left rotation */ function $22a00ea76a731e6a$var$rotr(x, n) {
    return x << 32 - n | x >>> n;
}
module.exports.rotr = $22a00ea76a731e6a$var$rotr;
function $22a00ea76a731e6a$var$isIntegerShim(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n;
}
/**
 * Returns true if the argument is an integer number.
 *
 * In ES2015, Number.isInteger.
 */ module.exports.isInteger = Number.isInteger || $22a00ea76a731e6a$var$isIntegerShim;
/**
 *  Math.pow(2, 53) - 1
 *
 *  In ES2015 Number.MAX_SAFE_INTEGER.
 */ module.exports.MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Returns true if the argument is a safe integer number
 * (-MIN_SAFE_INTEGER < number <= MAX_SAFE_INTEGER)
 *
 * In ES2015, Number.isSafeInteger.
 */ module.exports.isSafeInteger = function(n) {
    return module.exports.isInteger(n) && n >= -module.exports.MAX_SAFE_INTEGER && n <= module.exports.MAX_SAFE_INTEGER;
};

});


parcelRegister("1iHRq", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Sets all values in the given array to zero and returns it.
 *
 * The fact that it sets bytes to zero can be relied on.
 *
 * There is no guarantee that this function makes data disappear from memory,
 * as runtime implementation can, for example, have copying garbage collector
 * that will make copies of sensitive data before we wipe it. Or that an
 * operating system will write our data to swap or sleep image. Another thing
 * is that an optimizing compiler can remove calls to this function or make it
 * no-op. There's nothing we can do with it, so we just do our best and hope
 * that everything will be okay and good will triumph over evil.
 */ function $0f297ebb2d178f53$var$wipe(array) {
    // Right now it's similar to array.fill(0). If it turns
    // out that runtimes optimize this call away, maybe
    // we can try something else.
    for(var i = 0; i < array.length; i++)array[i] = 0;
    return array;
}
module.exports.wipe = $0f297ebb2d178f53$var$wipe;

});


parcelRegister("eMcuk", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3z58J = parcelRequire("3z58J");

var $1iHRq = parcelRequire("1iHRq");
module.exports.DIGEST_LENGTH = 16;
// Port of Andrew Moon's Poly1305-donna-16. Public domain.
// https://github.com/floodyberry/poly1305-donna
/**
 * Poly1305 computes 16-byte authenticator of message using
 * a one-time 32-byte key.
 *
 * Important: key should be used for only one message,
 * it should never repeat.
 */ var $ac1f3c41fb71580b$var$Poly1305 = /** @class */ function() {
    function Poly1305(key) {
        this.digestLength = module.exports.DIGEST_LENGTH;
        this._buffer = new Uint8Array(16);
        this._r = new Uint16Array(10);
        this._h = new Uint16Array(10);
        this._pad = new Uint16Array(8);
        this._leftover = 0;
        this._fin = 0;
        this._finished = false;
        var t0 = key[0] | key[1] << 8;
        this._r[0] = t0 & 0x1fff;
        var t1 = key[2] | key[3] << 8;
        this._r[1] = (t0 >>> 13 | t1 << 3) & 0x1fff;
        var t2 = key[4] | key[5] << 8;
        this._r[2] = (t1 >>> 10 | t2 << 6) & 0x1f03;
        var t3 = key[6] | key[7] << 8;
        this._r[3] = (t2 >>> 7 | t3 << 9) & 0x1fff;
        var t4 = key[8] | key[9] << 8;
        this._r[4] = (t3 >>> 4 | t4 << 12) & 0x00ff;
        this._r[5] = t4 >>> 1 & 0x1ffe;
        var t5 = key[10] | key[11] << 8;
        this._r[6] = (t4 >>> 14 | t5 << 2) & 0x1fff;
        var t6 = key[12] | key[13] << 8;
        this._r[7] = (t5 >>> 11 | t6 << 5) & 0x1f81;
        var t7 = key[14] | key[15] << 8;
        this._r[8] = (t6 >>> 8 | t7 << 8) & 0x1fff;
        this._r[9] = t7 >>> 5 & 0x007f;
        this._pad[0] = key[16] | key[17] << 8;
        this._pad[1] = key[18] | key[19] << 8;
        this._pad[2] = key[20] | key[21] << 8;
        this._pad[3] = key[22] | key[23] << 8;
        this._pad[4] = key[24] | key[25] << 8;
        this._pad[5] = key[26] | key[27] << 8;
        this._pad[6] = key[28] | key[29] << 8;
        this._pad[7] = key[30] | key[31] << 8;
    }
    Poly1305.prototype._blocks = function(m, mpos, bytes) {
        var hibit = this._fin ? 0 : 2048;
        var h0 = this._h[0], h1 = this._h[1], h2 = this._h[2], h3 = this._h[3], h4 = this._h[4], h5 = this._h[5], h6 = this._h[6], h7 = this._h[7], h8 = this._h[8], h9 = this._h[9];
        var r0 = this._r[0], r1 = this._r[1], r2 = this._r[2], r3 = this._r[3], r4 = this._r[4], r5 = this._r[5], r6 = this._r[6], r7 = this._r[7], r8 = this._r[8], r9 = this._r[9];
        while(bytes >= 16){
            var t0 = m[mpos + 0] | m[mpos + 1] << 8;
            h0 += t0 & 0x1fff;
            var t1 = m[mpos + 2] | m[mpos + 3] << 8;
            h1 += (t0 >>> 13 | t1 << 3) & 0x1fff;
            var t2 = m[mpos + 4] | m[mpos + 5] << 8;
            h2 += (t1 >>> 10 | t2 << 6) & 0x1fff;
            var t3 = m[mpos + 6] | m[mpos + 7] << 8;
            h3 += (t2 >>> 7 | t3 << 9) & 0x1fff;
            var t4 = m[mpos + 8] | m[mpos + 9] << 8;
            h4 += (t3 >>> 4 | t4 << 12) & 0x1fff;
            h5 += t4 >>> 1 & 0x1fff;
            var t5 = m[mpos + 10] | m[mpos + 11] << 8;
            h6 += (t4 >>> 14 | t5 << 2) & 0x1fff;
            var t6 = m[mpos + 12] | m[mpos + 13] << 8;
            h7 += (t5 >>> 11 | t6 << 5) & 0x1fff;
            var t7 = m[mpos + 14] | m[mpos + 15] << 8;
            h8 += (t6 >>> 8 | t7 << 8) & 0x1fff;
            h9 += t7 >>> 5 | hibit;
            var c = 0;
            var d0 = c;
            d0 += h0 * r0;
            d0 += h1 * (5 * r9);
            d0 += h2 * (5 * r8);
            d0 += h3 * (5 * r7);
            d0 += h4 * (5 * r6);
            c = d0 >>> 13;
            d0 &= 0x1fff;
            d0 += h5 * (5 * r5);
            d0 += h6 * (5 * r4);
            d0 += h7 * (5 * r3);
            d0 += h8 * (5 * r2);
            d0 += h9 * (5 * r1);
            c += d0 >>> 13;
            d0 &= 0x1fff;
            var d1 = c;
            d1 += h0 * r1;
            d1 += h1 * r0;
            d1 += h2 * (5 * r9);
            d1 += h3 * (5 * r8);
            d1 += h4 * (5 * r7);
            c = d1 >>> 13;
            d1 &= 0x1fff;
            d1 += h5 * (5 * r6);
            d1 += h6 * (5 * r5);
            d1 += h7 * (5 * r4);
            d1 += h8 * (5 * r3);
            d1 += h9 * (5 * r2);
            c += d1 >>> 13;
            d1 &= 0x1fff;
            var d2 = c;
            d2 += h0 * r2;
            d2 += h1 * r1;
            d2 += h2 * r0;
            d2 += h3 * (5 * r9);
            d2 += h4 * (5 * r8);
            c = d2 >>> 13;
            d2 &= 0x1fff;
            d2 += h5 * (5 * r7);
            d2 += h6 * (5 * r6);
            d2 += h7 * (5 * r5);
            d2 += h8 * (5 * r4);
            d2 += h9 * (5 * r3);
            c += d2 >>> 13;
            d2 &= 0x1fff;
            var d3 = c;
            d3 += h0 * r3;
            d3 += h1 * r2;
            d3 += h2 * r1;
            d3 += h3 * r0;
            d3 += h4 * (5 * r9);
            c = d3 >>> 13;
            d3 &= 0x1fff;
            d3 += h5 * (5 * r8);
            d3 += h6 * (5 * r7);
            d3 += h7 * (5 * r6);
            d3 += h8 * (5 * r5);
            d3 += h9 * (5 * r4);
            c += d3 >>> 13;
            d3 &= 0x1fff;
            var d4 = c;
            d4 += h0 * r4;
            d4 += h1 * r3;
            d4 += h2 * r2;
            d4 += h3 * r1;
            d4 += h4 * r0;
            c = d4 >>> 13;
            d4 &= 0x1fff;
            d4 += h5 * (5 * r9);
            d4 += h6 * (5 * r8);
            d4 += h7 * (5 * r7);
            d4 += h8 * (5 * r6);
            d4 += h9 * (5 * r5);
            c += d4 >>> 13;
            d4 &= 0x1fff;
            var d5 = c;
            d5 += h0 * r5;
            d5 += h1 * r4;
            d5 += h2 * r3;
            d5 += h3 * r2;
            d5 += h4 * r1;
            c = d5 >>> 13;
            d5 &= 0x1fff;
            d5 += h5 * r0;
            d5 += h6 * (5 * r9);
            d5 += h7 * (5 * r8);
            d5 += h8 * (5 * r7);
            d5 += h9 * (5 * r6);
            c += d5 >>> 13;
            d5 &= 0x1fff;
            var d6 = c;
            d6 += h0 * r6;
            d6 += h1 * r5;
            d6 += h2 * r4;
            d6 += h3 * r3;
            d6 += h4 * r2;
            c = d6 >>> 13;
            d6 &= 0x1fff;
            d6 += h5 * r1;
            d6 += h6 * r0;
            d6 += h7 * (5 * r9);
            d6 += h8 * (5 * r8);
            d6 += h9 * (5 * r7);
            c += d6 >>> 13;
            d6 &= 0x1fff;
            var d7 = c;
            d7 += h0 * r7;
            d7 += h1 * r6;
            d7 += h2 * r5;
            d7 += h3 * r4;
            d7 += h4 * r3;
            c = d7 >>> 13;
            d7 &= 0x1fff;
            d7 += h5 * r2;
            d7 += h6 * r1;
            d7 += h7 * r0;
            d7 += h8 * (5 * r9);
            d7 += h9 * (5 * r8);
            c += d7 >>> 13;
            d7 &= 0x1fff;
            var d8 = c;
            d8 += h0 * r8;
            d8 += h1 * r7;
            d8 += h2 * r6;
            d8 += h3 * r5;
            d8 += h4 * r4;
            c = d8 >>> 13;
            d8 &= 0x1fff;
            d8 += h5 * r3;
            d8 += h6 * r2;
            d8 += h7 * r1;
            d8 += h8 * r0;
            d8 += h9 * (5 * r9);
            c += d8 >>> 13;
            d8 &= 0x1fff;
            var d9 = c;
            d9 += h0 * r9;
            d9 += h1 * r8;
            d9 += h2 * r7;
            d9 += h3 * r6;
            d9 += h4 * r5;
            c = d9 >>> 13;
            d9 &= 0x1fff;
            d9 += h5 * r4;
            d9 += h6 * r3;
            d9 += h7 * r2;
            d9 += h8 * r1;
            d9 += h9 * r0;
            c += d9 >>> 13;
            d9 &= 0x1fff;
            c = (c << 2) + c | 0;
            c = c + d0 | 0;
            d0 = c & 0x1fff;
            c = c >>> 13;
            d1 += c;
            h0 = d0;
            h1 = d1;
            h2 = d2;
            h3 = d3;
            h4 = d4;
            h5 = d5;
            h6 = d6;
            h7 = d7;
            h8 = d8;
            h9 = d9;
            mpos += 16;
            bytes -= 16;
        }
        this._h[0] = h0;
        this._h[1] = h1;
        this._h[2] = h2;
        this._h[3] = h3;
        this._h[4] = h4;
        this._h[5] = h5;
        this._h[6] = h6;
        this._h[7] = h7;
        this._h[8] = h8;
        this._h[9] = h9;
    };
    Poly1305.prototype.finish = function(mac, macpos) {
        if (macpos === void 0) macpos = 0;
        var g = new Uint16Array(10);
        var c;
        var mask;
        var f;
        var i;
        if (this._leftover) {
            i = this._leftover;
            this._buffer[i++] = 1;
            for(; i < 16; i++)this._buffer[i] = 0;
            this._fin = 1;
            this._blocks(this._buffer, 0, 16);
        }
        c = this._h[1] >>> 13;
        this._h[1] &= 0x1fff;
        for(i = 2; i < 10; i++){
            this._h[i] += c;
            c = this._h[i] >>> 13;
            this._h[i] &= 0x1fff;
        }
        this._h[0] += c * 5;
        c = this._h[0] >>> 13;
        this._h[0] &= 0x1fff;
        this._h[1] += c;
        c = this._h[1] >>> 13;
        this._h[1] &= 0x1fff;
        this._h[2] += c;
        g[0] = this._h[0] + 5;
        c = g[0] >>> 13;
        g[0] &= 0x1fff;
        for(i = 1; i < 10; i++){
            g[i] = this._h[i] + c;
            c = g[i] >>> 13;
            g[i] &= 0x1fff;
        }
        g[9] -= 8192;
        mask = (c ^ 1) - 1;
        for(i = 0; i < 10; i++)g[i] &= mask;
        mask = ~mask;
        for(i = 0; i < 10; i++)this._h[i] = this._h[i] & mask | g[i];
        this._h[0] = (this._h[0] | this._h[1] << 13) & 0xffff;
        this._h[1] = (this._h[1] >>> 3 | this._h[2] << 10) & 0xffff;
        this._h[2] = (this._h[2] >>> 6 | this._h[3] << 7) & 0xffff;
        this._h[3] = (this._h[3] >>> 9 | this._h[4] << 4) & 0xffff;
        this._h[4] = (this._h[4] >>> 12 | this._h[5] << 1 | this._h[6] << 14) & 0xffff;
        this._h[5] = (this._h[6] >>> 2 | this._h[7] << 11) & 0xffff;
        this._h[6] = (this._h[7] >>> 5 | this._h[8] << 8) & 0xffff;
        this._h[7] = (this._h[8] >>> 8 | this._h[9] << 5) & 0xffff;
        f = this._h[0] + this._pad[0];
        this._h[0] = f & 0xffff;
        for(i = 1; i < 8; i++){
            f = (this._h[i] + this._pad[i] | 0) + (f >>> 16) | 0;
            this._h[i] = f & 0xffff;
        }
        mac[macpos + 0] = this._h[0] >>> 0;
        mac[macpos + 1] = this._h[0] >>> 8;
        mac[macpos + 2] = this._h[1] >>> 0;
        mac[macpos + 3] = this._h[1] >>> 8;
        mac[macpos + 4] = this._h[2] >>> 0;
        mac[macpos + 5] = this._h[2] >>> 8;
        mac[macpos + 6] = this._h[3] >>> 0;
        mac[macpos + 7] = this._h[3] >>> 8;
        mac[macpos + 8] = this._h[4] >>> 0;
        mac[macpos + 9] = this._h[4] >>> 8;
        mac[macpos + 10] = this._h[5] >>> 0;
        mac[macpos + 11] = this._h[5] >>> 8;
        mac[macpos + 12] = this._h[6] >>> 0;
        mac[macpos + 13] = this._h[6] >>> 8;
        mac[macpos + 14] = this._h[7] >>> 0;
        mac[macpos + 15] = this._h[7] >>> 8;
        this._finished = true;
        return this;
    };
    Poly1305.prototype.update = function(m) {
        var mpos = 0;
        var bytes = m.length;
        var want;
        if (this._leftover) {
            want = 16 - this._leftover;
            if (want > bytes) want = bytes;
            for(var i = 0; i < want; i++)this._buffer[this._leftover + i] = m[mpos + i];
            bytes -= want;
            mpos += want;
            this._leftover += want;
            if (this._leftover < 16) return this;
            this._blocks(this._buffer, 0, 16);
            this._leftover = 0;
        }
        if (bytes >= 16) {
            want = bytes - bytes % 16;
            this._blocks(m, mpos, want);
            mpos += want;
            bytes -= want;
        }
        if (bytes) {
            for(var i = 0; i < bytes; i++)this._buffer[this._leftover + i] = m[mpos + i];
            this._leftover += bytes;
        }
        return this;
    };
    Poly1305.prototype.digest = function() {
        // TODO(dchest): it behaves differently than other hashes/HMAC,
        // because it throws when finished — others just return saved result.
        if (this._finished) throw new Error("Poly1305 was finished");
        var mac = new Uint8Array(16);
        this.finish(mac);
        return mac;
    };
    Poly1305.prototype.clean = function() {
        $1iHRq.wipe(this._buffer);
        $1iHRq.wipe(this._r);
        $1iHRq.wipe(this._h);
        $1iHRq.wipe(this._pad);
        this._leftover = 0;
        this._fin = 0;
        this._finished = true; // mark as finished even if not
        return this;
    };
    return Poly1305;
}();
module.exports.Poly1305 = $ac1f3c41fb71580b$var$Poly1305;
/**
 * Returns 16-byte authenticator of data using a one-time 32-byte key.
 *
 * Important: key should be used for only one message, it should never repeat.
 */ function $ac1f3c41fb71580b$var$oneTimeAuth(key, data) {
    var h = new $ac1f3c41fb71580b$var$Poly1305(key);
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
module.exports.oneTimeAuth = $ac1f3c41fb71580b$var$oneTimeAuth;
/**
 * Returns true if two authenticators are 16-byte long and equal.
 * Uses contant-time comparison to avoid leaking timing information.
 */ function $ac1f3c41fb71580b$var$equal(a, b) {
    if (a.length !== module.exports.DIGEST_LENGTH || b.length !== module.exports.DIGEST_LENGTH) return false;
    return $3z58J.equal(a, b);
}
module.exports.equal = $ac1f3c41fb71580b$var$equal;

});
parcelRegister("3z58J", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Package constant-time provides functions for performing algorithmically constant-time operations.
 */ /**
 * NOTE! Due to the inability to guarantee real constant time evaluation of
 * anything in JavaScript VM, this is module is the best effort.
 */ /**
 * Returns resultIfOne if subject is 1, or resultIfZero if subject is 0.
 *
 * Supports only 32-bit integers, so resultIfOne or resultIfZero are not
 * integers, they'll be converted to them with bitwise operations.
 */ function $2988a0a74a50f919$var$select(subject, resultIfOne, resultIfZero) {
    return ~(subject - 1) & resultIfOne | subject - 1 & resultIfZero;
}
module.exports.select = $2988a0a74a50f919$var$select;
/**
 * Returns 1 if a <= b, or 0 if not.
 * Arguments must be positive 32-bit integers less than or equal to 2^31 - 1.
 */ function $2988a0a74a50f919$var$lessOrEqual(a, b) {
    return (a | 0) - (b | 0) - 1 >>> 31 & 1;
}
module.exports.lessOrEqual = $2988a0a74a50f919$var$lessOrEqual;
/**
 * Returns 1 if a and b are of equal length and their contents
 * are equal, or 0 otherwise.
 *
 * Note that unlike in equal(), zero-length inputs are considered
 * the same, so this function will return 1.
 */ function $2988a0a74a50f919$var$compare(a, b) {
    if (a.length !== b.length) return 0;
    var result = 0;
    for(var i = 0; i < a.length; i++)result |= a[i] ^ b[i];
    return 1 & result - 1 >>> 8;
}
module.exports.compare = $2988a0a74a50f919$var$compare;
/**
 * Returns true if a and b are of equal non-zero length,
 * and their contents are equal, or false otherwise.
 *
 * Note that unlike in compare() zero-length inputs are considered
 * _not_ equal, so this function will return false.
 */ function $2988a0a74a50f919$var$equal(a, b) {
    if (a.length === 0 || b.length === 0) return false;
    return $2988a0a74a50f919$var$compare(a, b) !== 0;
}
module.exports.equal = $2988a0a74a50f919$var$equal;

});



parcelRegister("atJCh", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hfjGl = parcelRequire("hfjGl");

var $1iHRq = parcelRequire("1iHRq");
/**
 * HMAC-based Extract-and-Expand Key Derivation Function.
 *
 * Implements HKDF from RFC5869.
 *
 * Expands the given master key with salt and info into
 * a limited stream of key material.
 */ var $7a0fff4b82f45274$var$HKDF = /** @class */ function() {
    /**
     * Create a new HKDF instance for the given hash function
     * with the master key, optional salt, and info.
     *
     * - Master key is a high-entropy secret key (not a password).
     * - Salt is a non-secret random value.
     * - Info is application- and/or context-specific information.
     */ function HKDF(hash, key, salt, info) {
        if (salt === void 0) salt = new Uint8Array(0);
        this._counter = new Uint8Array(1); // starts with zero
        this._hash = hash;
        this._info = info;
        // HKDF-Extract uses salt as HMAC key, and key as data.
        var okm = $hfjGl.hmac(this._hash, salt, key);
        // Initialize HMAC for expanding with extracted key.
        this._hmac = new $hfjGl.HMAC(hash, okm);
        // Allocate buffer.
        this._buffer = new Uint8Array(this._hmac.digestLength);
        this._bufpos = this._buffer.length;
    }
    // Fill buffer with new block of HKDF-Extract output.
    HKDF.prototype._fillBuffer = function() {
        // Increment counter.
        this._counter[0]++;
        var ctr = this._counter[0];
        // Check if counter overflowed.
        if (ctr === 0) throw new Error("hkdf: cannot expand more");
        // Prepare HMAC instance for new data with old key.
        this._hmac.reset();
        // Hash in previous output if it was generated
        // (i.e. counter is greater than 1).
        if (ctr > 1) this._hmac.update(this._buffer);
        // Hash in info if it exists.
        if (this._info) this._hmac.update(this._info);
        // Hash in the counter.
        this._hmac.update(this._counter);
        // Output result to buffer and clean HMAC instance.
        this._hmac.finish(this._buffer);
        // Reset buffer position.
        this._bufpos = 0;
    };
    /**
     * Expand returns next key material of the given length.
     *
     * It throws if expansion limit is reached (which is
     * 254 digests of the underlying HMAC function).
     */ HKDF.prototype.expand = function(length) {
        var out = new Uint8Array(length);
        for(var i = 0; i < out.length; i++){
            if (this._bufpos === this._buffer.length) this._fillBuffer();
            out[i] = this._buffer[this._bufpos++];
        }
        return out;
    };
    HKDF.prototype.clean = function() {
        this._hmac.clean();
        $1iHRq.wipe(this._buffer);
        $1iHRq.wipe(this._counter);
        this._bufpos = 0;
    };
    return HKDF;
}();
module.exports.HKDF = $7a0fff4b82f45274$var$HKDF; // TODO(dchest): maybe implement deriveKey?

});
parcelRegister("hfjGl", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $606Yj = parcelRequire("606Yj");

var $3z58J = parcelRequire("3z58J");

var $1iHRq = parcelRequire("1iHRq");
/**
 *  HMAC implements hash-based message authentication algorithm.
 */ var $c8e31acac29ac862$var$HMAC = /** @class */ function() {
    /**
     * Constructs a new HMAC with the given Hash and secret key.
     */ function HMAC(hash, key) {
        this._finished = false; // true if HMAC was finalized
        // Initialize inner and outer hashes.
        this._inner = new hash();
        this._outer = new hash();
        // Set block and digest sizes for this HMAC
        // instance to values from the hash.
        this.blockSize = this._outer.blockSize;
        this.digestLength = this._outer.digestLength;
        // Pad temporary stores a key (or its hash) padded with zeroes.
        var pad = new Uint8Array(this.blockSize);
        if (key.length > this.blockSize) // If key is bigger than hash block size, it must be
        // hashed and this hash is used as a key instead.
        this._inner.update(key).finish(pad).clean();
        else // Otherwise, copy the key into pad.
        pad.set(key);
        // Now two different keys are derived from padded key
        // by xoring a different byte value to each.
        // To make inner hash key, xor byte 0x36 into pad.
        for(var i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        // Update inner hash with the result.
        this._inner.update(pad);
        // To make outer hash key, xor byte 0x5c into pad.
        // But since we already xored 0x36 there, we must
        // first undo this by xoring it again.
        for(var i = 0; i < pad.length; i++)pad[i] ^= 106;
        // Update outer hash with the result.
        this._outer.update(pad);
        // Save states of both hashes, so that we can quickly restore
        // them later in reset() without the need to remember the actual
        // key and perform this initialization again.
        if ($606Yj.isSerializableHash(this._inner) && $606Yj.isSerializableHash(this._outer)) {
            this._innerKeyedState = this._inner.saveState();
            this._outerKeyedState = this._outer.saveState();
        }
        // Clean pad.
        $1iHRq.wipe(pad);
    }
    /**
     * Returns HMAC state to the state initialized with key
     * to make it possible to run HMAC over the other data with the same
     * key without creating a new instance.
     */ HMAC.prototype.reset = function() {
        if (!$606Yj.isSerializableHash(this._inner) || !$606Yj.isSerializableHash(this._outer)) throw new Error("hmac: can't reset() because hash doesn't implement restoreState()");
        // Restore keyed states of inner and outer hashes.
        this._inner.restoreState(this._innerKeyedState);
        this._outer.restoreState(this._outerKeyedState);
        this._finished = false;
        return this;
    };
    /**
     * Cleans HMAC state.
     */ HMAC.prototype.clean = function() {
        if ($606Yj.isSerializableHash(this._inner)) this._inner.cleanSavedState(this._innerKeyedState);
        if ($606Yj.isSerializableHash(this._outer)) this._outer.cleanSavedState(this._outerKeyedState);
        this._inner.clean();
        this._outer.clean();
    };
    /**
     * Updates state with provided data.
     */ HMAC.prototype.update = function(data) {
        this._inner.update(data);
        return this;
    };
    /**
     * Finalizes HMAC and puts the result in out.
     */ HMAC.prototype.finish = function(out) {
        if (this._finished) {
            // If HMAC was finalized, outer hash is also finalized,
            // so it produces the same digest it produced when it
            // was finalized.
            this._outer.finish(out);
            return this;
        }
        // Finalize inner hash and store the result temporarily.
        this._inner.finish(out);
        // Update outer hash with digest of inner hash and and finalize it.
        this._outer.update(out.subarray(0, this.digestLength)).finish(out);
        this._finished = true;
        return this;
    };
    /**
     * Returns the computed message authentication code.
     */ HMAC.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Saves HMAC state.
     * This function is needed for PBKDF2 optimization.
     */ HMAC.prototype.saveState = function() {
        if (!$606Yj.isSerializableHash(this._inner)) throw new Error("hmac: can't saveState() because hash doesn't implement it");
        return this._inner.saveState();
    };
    HMAC.prototype.restoreState = function(savedState) {
        if (!$606Yj.isSerializableHash(this._inner) || !$606Yj.isSerializableHash(this._outer)) throw new Error("hmac: can't restoreState() because hash doesn't implement it");
        this._inner.restoreState(savedState);
        this._outer.restoreState(this._outerKeyedState);
        this._finished = false;
        return this;
    };
    HMAC.prototype.cleanSavedState = function(savedState) {
        if (!$606Yj.isSerializableHash(this._inner)) throw new Error("hmac: can't cleanSavedState() because hash doesn't implement it");
        this._inner.cleanSavedState(savedState);
    };
    return HMAC;
}();
module.exports.HMAC = $c8e31acac29ac862$var$HMAC;
/**
 * Returns HMAC using the given hash constructor for the key over data.
 */ function $c8e31acac29ac862$var$hmac(hash, key, data) {
    var h = new $c8e31acac29ac862$var$HMAC(hash, key);
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
module.exports.hmac = $c8e31acac29ac862$var$hmac;
/**
 * Returns true if two HMAC digests are equal.
 * Uses constant-time comparison to avoid leaking timing information.
 *
 * Example:
 *
 *    const receivedDigest = ...
 *    const realDigest = hmac(SHA256, key, data);
 *    if (!equal(receivedDigest, realDigest)) {
 *        throw new Error("Authentication error");
 *    }
 */ module.exports.equal = $3z58J.equal;

});
parcelRegister("606Yj", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $45e8269ea148e1e0$var$isSerializableHash(h) {
    return typeof h.saveState !== "undefined" && typeof h.restoreState !== "undefined" && typeof h.cleanSavedState !== "undefined";
}
module.exports.isSerializableHash = $45e8269ea148e1e0$var$isSerializableHash; // TODO(dchest): figure out the standardized interface for XOF such as
 // SHAKE and BLAKE2X.

});



parcelRegister("5A0yG", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomStringForEntropy = module.exports.randomString = module.exports.randomUint32 = module.exports.randomBytes = module.exports.defaultRandomSource = void 0;

var $ljKS8 = parcelRequire("ljKS8");

var $9sToB = parcelRequire("9sToB");

var $1iHRq = parcelRequire("1iHRq");
module.exports.defaultRandomSource = new $ljKS8.SystemRandomSource();
function $4100bf73a495f3d3$var$randomBytes(length) {
    var prng = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : module.exports.defaultRandomSource;
    return prng.randomBytes(length);
}
module.exports.randomBytes = $4100bf73a495f3d3$var$randomBytes;
/**
 * Returns a uniformly random unsigned 32-bit integer.
 */ function $4100bf73a495f3d3$var$randomUint32() {
    var prng = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : module.exports.defaultRandomSource;
    // Generate 4-byte random buffer.
    var buf = $4100bf73a495f3d3$var$randomBytes(4, prng);
    // Convert bytes from buffer into a 32-bit integer.
    // It's not important which byte order to use, since
    // the result is random.
    var result = (0, $9sToB.readUint32LE)(buf);
    // Clean the buffer.
    (0, $1iHRq.wipe)(buf);
    return result;
}
module.exports.randomUint32 = $4100bf73a495f3d3$var$randomUint32;
/** 62 alphanumeric characters for default charset of randomString() */ var $4100bf73a495f3d3$var$ALPHANUMERIC = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
/**
 * Returns a uniform random string of the given length
 * with characters from the given charset.
 *
 * Charset must not have more than 256 characters.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */ function $4100bf73a495f3d3$var$randomString(length) {
    var charset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $4100bf73a495f3d3$var$ALPHANUMERIC, prng = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : module.exports.defaultRandomSource;
    if (charset.length < 2) throw new Error("randomString charset is too short");
    if (charset.length > 256) throw new Error("randomString charset is too long");
    var out = "";
    var charsLen = charset.length;
    var maxByte = 256 - 256 % charsLen;
    while(length > 0){
        var buf = $4100bf73a495f3d3$var$randomBytes(Math.ceil(length * 256 / maxByte), prng);
        for(var i = 0; i < buf.length && length > 0; i++){
            var randomByte = buf[i];
            if (randomByte < maxByte) {
                out += charset.charAt(randomByte % charsLen);
                length--;
            }
        }
        (0, $1iHRq.wipe)(buf);
    }
    return out;
}
module.exports.randomString = $4100bf73a495f3d3$var$randomString;
/**
 * Returns uniform random string containing at least the given
 * number of bits of entropy.
 *
 * For example, randomStringForEntropy(128) will return a 22-character
 * alphanumeric string, while randomStringForEntropy(128, "0123456789")
 * will return a 39-character numeric string, both will contain at
 * least 128 bits of entropy.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */ function $4100bf73a495f3d3$var$randomStringForEntropy(bits) {
    var charset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $4100bf73a495f3d3$var$ALPHANUMERIC, prng = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : module.exports.defaultRandomSource;
    var length = Math.ceil(bits / (Math.log(charset.length) / Math.LN2));
    return $4100bf73a495f3d3$var$randomString(length, charset, prng);
}
module.exports.randomStringForEntropy = $4100bf73a495f3d3$var$randomStringForEntropy;

});
parcelRegister("ljKS8", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SystemRandomSource = void 0;

var $63cm1 = parcelRequire("63cm1");

var $i2v6k = parcelRequire("i2v6k");
var $f84fbb2ba7ac5218$var$SystemRandomSource = /*#__PURE__*/ function() {
    function SystemRandomSource() {
        (0, $4GJKx._)(this, SystemRandomSource);
        this.isAvailable = false;
        this.name = "";
        // Try browser.
        this._source = new $63cm1.BrowserRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Browser";
            return;
        }
        // If no browser source, try Node.
        this._source = new $i2v6k.NodeRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Node";
            return;
        }
    }
    (0, $1wc17._)(SystemRandomSource, [
        {
            key: "randomBytes",
            value: function randomBytes(length) {
                if (!this.isAvailable) throw new Error("System random byte generator is not available.");
                return this._source.randomBytes(length);
            }
        }
    ]);
    return SystemRandomSource;
}();
module.exports.SystemRandomSource = $f84fbb2ba7ac5218$var$SystemRandomSource;

});
parcelRegister("63cm1", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BrowserRandomSource = void 0;
var $467c9b2829ba6c9b$var$QUOTA = 65536;
var $467c9b2829ba6c9b$var$BrowserRandomSource = /*#__PURE__*/ function() {
    function BrowserRandomSource() {
        (0, $4GJKx._)(this, BrowserRandomSource);
        this.isAvailable = false;
        this.isInstantiated = false;
        var browserCrypto = typeof self !== "undefined" ? self.crypto || self.msCrypto // IE11 has msCrypto
         : null;
        if (browserCrypto && browserCrypto.getRandomValues !== undefined) {
            this._crypto = browserCrypto;
            this.isAvailable = true;
            this.isInstantiated = true;
        }
    }
    (0, $1wc17._)(BrowserRandomSource, [
        {
            key: "randomBytes",
            value: function randomBytes(length) {
                if (!this.isAvailable || !this._crypto) throw new Error("Browser random byte generator is not available.");
                var out = new Uint8Array(length);
                for(var i = 0; i < out.length; i += $467c9b2829ba6c9b$var$QUOTA)this._crypto.getRandomValues(out.subarray(i, i + Math.min(out.length - i, $467c9b2829ba6c9b$var$QUOTA)));
                return out;
            }
        }
    ]);
    return BrowserRandomSource;
}();
module.exports.BrowserRandomSource = $467c9b2829ba6c9b$var$BrowserRandomSource;

});

parcelRegister("i2v6k", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeRandomSource = void 0;

var $1iHRq = parcelRequire("1iHRq");

var $d22089eafe6e753d$var$NodeRandomSource = /*#__PURE__*/ function() {
    function NodeRandomSource() {
        (0, $4GJKx._)(this, NodeRandomSource);
        this.isAvailable = false;
        this.isInstantiated = false;
        {
            var nodeCrypto = (parcelRequire("9dH9K"));
            if (nodeCrypto && nodeCrypto.randomBytes) {
                this._crypto = nodeCrypto;
                this.isAvailable = true;
                this.isInstantiated = true;
            }
        }
    }
    (0, $1wc17._)(NodeRandomSource, [
        {
            key: "randomBytes",
            value: function randomBytes(length) {
                if (!this.isAvailable || !this._crypto) throw new Error("Node.js random byte generator is not available.");
                // Get random bytes (result is Buffer).
                var buffer = this._crypto.randomBytes(length);
                // Make sure we got the length that we requested.
                if (buffer.length !== length) throw new Error("NodeRandomSource: got fewer bytes than requested");
                // Allocate output array.
                var out = new Uint8Array(length);
                // Copy bytes from buffer to output.
                for(var i = 0; i < out.length; i++)out[i] = buffer[i];
                // Cleanup.
                (0, $1iHRq.wipe)(buffer);
                return out;
            }
        }
    ]);
    return NodeRandomSource;
}();
module.exports.NodeRandomSource = $d22089eafe6e753d$var$NodeRandomSource;

});
parcelRegister("9dH9K", function(module, exports) {
"use strict";

});




parcelRegister("27vAG", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9sToB = parcelRequire("9sToB");

var $1iHRq = parcelRequire("1iHRq");
module.exports.DIGEST_LENGTH = 32;
module.exports.BLOCK_SIZE = 64;
/**
 * SHA2-256 cryptographic hash algorithm.
 */ var $18b4bd71d0626395$var$SHA256 = /** @class */ function() {
    function SHA256() {
        /** Length of hash output */ this.digestLength = module.exports.DIGEST_LENGTH;
        /** Block size */ this.blockSize = module.exports.BLOCK_SIZE;
        // Note: Int32Array is used instead of Uint32Array for performance reasons.
        this._state = new Int32Array(8); // hash state
        this._temp = new Int32Array(64); // temporary state
        this._buffer = new Uint8Array(128); // buffer for data to hash
        this._bufferLength = 0; // number of bytes in buffer
        this._bytesHashed = 0; // number of total bytes hashed
        this._finished = false; // indicates whether the hash was finalized
        this.reset();
    }
    SHA256.prototype._initState = function() {
        this._state[0] = 0x6a09e667;
        this._state[1] = 0xbb67ae85;
        this._state[2] = 0x3c6ef372;
        this._state[3] = 0xa54ff53a;
        this._state[4] = 0x510e527f;
        this._state[5] = 0x9b05688c;
        this._state[6] = 0x1f83d9ab;
        this._state[7] = 0x5be0cd19;
    };
    /**
     * Resets hash state making it possible
     * to re-use this instance to hash other data.
     */ SHA256.prototype.reset = function() {
        this._initState();
        this._bufferLength = 0;
        this._bytesHashed = 0;
        this._finished = false;
        return this;
    };
    /**
     * Cleans internal buffers and resets hash state.
     */ SHA256.prototype.clean = function() {
        $1iHRq.wipe(this._buffer);
        $1iHRq.wipe(this._temp);
        this.reset();
    };
    /**
     * Updates hash state with the given data.
     *
     * Throws error when trying to update already finalized hash:
     * instance must be reset to update it again.
     */ SHA256.prototype.update = function(data, dataLength) {
        if (dataLength === void 0) dataLength = data.length;
        if (this._finished) throw new Error("SHA256: can't update because hash was finished.");
        var dataPos = 0;
        this._bytesHashed += dataLength;
        if (this._bufferLength > 0) {
            while(this._bufferLength < this.blockSize && dataLength > 0){
                this._buffer[this._bufferLength++] = data[dataPos++];
                dataLength--;
            }
            if (this._bufferLength === this.blockSize) {
                $18b4bd71d0626395$var$hashBlocks(this._temp, this._state, this._buffer, 0, this.blockSize);
                this._bufferLength = 0;
            }
        }
        if (dataLength >= this.blockSize) {
            dataPos = $18b4bd71d0626395$var$hashBlocks(this._temp, this._state, data, dataPos, dataLength);
            dataLength %= this.blockSize;
        }
        while(dataLength > 0){
            this._buffer[this._bufferLength++] = data[dataPos++];
            dataLength--;
        }
        return this;
    };
    /**
     * Finalizes hash state and puts hash into out.
     * If hash was already finalized, puts the same value.
     */ SHA256.prototype.finish = function(out) {
        if (!this._finished) {
            var bytesHashed = this._bytesHashed;
            var left = this._bufferLength;
            var bitLenHi = bytesHashed / 0x20000000 | 0;
            var bitLenLo = bytesHashed << 3;
            var padLength = bytesHashed % 64 < 56 ? 64 : 128;
            this._buffer[left] = 0x80;
            for(var i = left + 1; i < padLength - 8; i++)this._buffer[i] = 0;
            $9sToB.writeUint32BE(bitLenHi, this._buffer, padLength - 8);
            $9sToB.writeUint32BE(bitLenLo, this._buffer, padLength - 4);
            $18b4bd71d0626395$var$hashBlocks(this._temp, this._state, this._buffer, 0, padLength);
            this._finished = true;
        }
        for(var i = 0; i < this.digestLength / 4; i++)$9sToB.writeUint32BE(this._state[i], out, i * 4);
        return this;
    };
    /**
     * Returns the final hash digest.
     */ SHA256.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization.
     * Returns hash state to be used with restoreState().
     * Only chain value is saved, not buffers or other
     * state variables.
     */ SHA256.prototype.saveState = function() {
        if (this._finished) throw new Error("SHA256: cannot save finished state");
        return {
            state: new Int32Array(this._state),
            buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : undefined,
            bufferLength: this._bufferLength,
            bytesHashed: this._bytesHashed
        };
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization.
     * Restores state saved by saveState() and sets bytesHashed
     * to the given value.
     */ SHA256.prototype.restoreState = function(savedState) {
        this._state.set(savedState.state);
        this._bufferLength = savedState.bufferLength;
        if (savedState.buffer) this._buffer.set(savedState.buffer);
        this._bytesHashed = savedState.bytesHashed;
        this._finished = false;
        return this;
    };
    /**
     * Cleans state returned by saveState().
     */ SHA256.prototype.cleanSavedState = function(savedState) {
        $1iHRq.wipe(savedState.state);
        if (savedState.buffer) $1iHRq.wipe(savedState.buffer);
        savedState.bufferLength = 0;
        savedState.bytesHashed = 0;
    };
    return SHA256;
}();
module.exports.SHA256 = $18b4bd71d0626395$var$SHA256;
// Constants
var $18b4bd71d0626395$var$K = new Int32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
function $18b4bd71d0626395$var$hashBlocks(w, v, p, pos, len) {
    while(len >= 64){
        var a = v[0];
        var b = v[1];
        var c = v[2];
        var d = v[3];
        var e = v[4];
        var f = v[5];
        var g = v[6];
        var h = v[7];
        for(var i = 0; i < 16; i++){
            var j = pos + i * 4;
            w[i] = $9sToB.readUint32BE(p, j);
        }
        for(var i = 16; i < 64; i++){
            var u = w[i - 2];
            var t1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
            u = w[i - 15];
            var t2 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
            w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0);
        }
        for(var i = 0; i < 64; i++){
            var t1 = (((e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7)) + (e & f ^ ~e & g) | 0) + (h + ($18b4bd71d0626395$var$K[i] + w[i] | 0) | 0) | 0;
            var t2 = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10)) + (a & b ^ a & c ^ b & c) | 0;
            h = g;
            g = f;
            f = e;
            e = d + t1 | 0;
            d = c;
            c = b;
            b = a;
            a = t1 + t2 | 0;
        }
        v[0] += a;
        v[1] += b;
        v[2] += c;
        v[3] += d;
        v[4] += e;
        v[5] += f;
        v[6] += g;
        v[7] += h;
        pos += 64;
        len -= 64;
    }
    return pos;
}
function $18b4bd71d0626395$var$hash(data) {
    var h = new $18b4bd71d0626395$var$SHA256();
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
module.exports.hash = $18b4bd71d0626395$var$hash;

});

parcelRegister("1fnK2", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sharedKey = module.exports.generateKeyPair = module.exports.generateKeyPairFromSeed = module.exports.scalarMultBase = module.exports.scalarMult = module.exports.SHARED_KEY_LENGTH = module.exports.SECRET_KEY_LENGTH = module.exports.PUBLIC_KEY_LENGTH = void 0;

var $5A0yG = parcelRequire("5A0yG");

var $1iHRq = parcelRequire("1iHRq");
module.exports.PUBLIC_KEY_LENGTH = 32;
module.exports.SECRET_KEY_LENGTH = 32;
module.exports.SHARED_KEY_LENGTH = 32;
// Returns new zero-filled 16-element GF (Float64Array).
// If passed an array of numbers, prefills the returned
// array with them.
//
// We use Float64Array, because we need 48-bit numbers
// for this implementation.
function $0e899bb86ee17960$var$gf(init) {
    var r = new Float64Array(16);
    if (init) for(var i = 0; i < init.length; i++)r[i] = init[i];
    return r;
}
// Base point.
var $0e899bb86ee17960$var$_9 = new Uint8Array(32);
$0e899bb86ee17960$var$_9[0] = 9;
var $0e899bb86ee17960$var$_121665 = $0e899bb86ee17960$var$gf([
    0xdb41,
    1
]);
function $0e899bb86ee17960$var$car25519(o) {
    var c = 1;
    for(var i = 0; i < 16; i++){
        var v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
    }
    o[0] += c - 1 + 37 * (c - 1);
}
function $0e899bb86ee17960$var$sel25519(p, q, b) {
    var c = ~(b - 1);
    for(var i = 0; i < 16; i++){
        var t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function $0e899bb86ee17960$var$pack25519(o, n) {
    var m = $0e899bb86ee17960$var$gf();
    var t = $0e899bb86ee17960$var$gf();
    for(var i = 0; i < 16; i++)t[i] = n[i];
    $0e899bb86ee17960$var$car25519(t);
    $0e899bb86ee17960$var$car25519(t);
    $0e899bb86ee17960$var$car25519(t);
    for(var j = 0; j < 2; j++){
        m[0] = t[0] - 0xffed;
        for(var i1 = 1; i1 < 15; i1++){
            m[i1] = t[i1] - 0xffff - (m[i1 - 1] >> 16 & 1);
            m[i1 - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
        var b = m[15] >> 16 & 1;
        m[14] &= 0xffff;
        $0e899bb86ee17960$var$sel25519(t, m, 1 - b);
    }
    for(var i2 = 0; i2 < 16; i2++){
        o[2 * i2] = t[i2] & 0xff;
        o[2 * i2 + 1] = t[i2] >> 8;
    }
}
function $0e899bb86ee17960$var$unpack25519(o, n) {
    for(var i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function $0e899bb86ee17960$var$add(o, a, b) {
    for(var i = 0; i < 16; i++)o[i] = a[i] + b[i];
}
function $0e899bb86ee17960$var$sub(o, a, b) {
    for(var i = 0; i < 16; i++)o[i] = a[i] - b[i];
}
function $0e899bb86ee17960$var$mul(o, a, b) {
    var v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    v = a[0];
    t0 += v * b0;
    t1 += v * b1;
    t2 += v * b2;
    t3 += v * b3;
    t4 += v * b4;
    t5 += v * b5;
    t6 += v * b6;
    t7 += v * b7;
    t8 += v * b8;
    t9 += v * b9;
    t10 += v * b10;
    t11 += v * b11;
    t12 += v * b12;
    t13 += v * b13;
    t14 += v * b14;
    t15 += v * b15;
    v = a[1];
    t1 += v * b0;
    t2 += v * b1;
    t3 += v * b2;
    t4 += v * b3;
    t5 += v * b4;
    t6 += v * b5;
    t7 += v * b6;
    t8 += v * b7;
    t9 += v * b8;
    t10 += v * b9;
    t11 += v * b10;
    t12 += v * b11;
    t13 += v * b12;
    t14 += v * b13;
    t15 += v * b14;
    t16 += v * b15;
    v = a[2];
    t2 += v * b0;
    t3 += v * b1;
    t4 += v * b2;
    t5 += v * b3;
    t6 += v * b4;
    t7 += v * b5;
    t8 += v * b6;
    t9 += v * b7;
    t10 += v * b8;
    t11 += v * b9;
    t12 += v * b10;
    t13 += v * b11;
    t14 += v * b12;
    t15 += v * b13;
    t16 += v * b14;
    t17 += v * b15;
    v = a[3];
    t3 += v * b0;
    t4 += v * b1;
    t5 += v * b2;
    t6 += v * b3;
    t7 += v * b4;
    t8 += v * b5;
    t9 += v * b6;
    t10 += v * b7;
    t11 += v * b8;
    t12 += v * b9;
    t13 += v * b10;
    t14 += v * b11;
    t15 += v * b12;
    t16 += v * b13;
    t17 += v * b14;
    t18 += v * b15;
    v = a[4];
    t4 += v * b0;
    t5 += v * b1;
    t6 += v * b2;
    t7 += v * b3;
    t8 += v * b4;
    t9 += v * b5;
    t10 += v * b6;
    t11 += v * b7;
    t12 += v * b8;
    t13 += v * b9;
    t14 += v * b10;
    t15 += v * b11;
    t16 += v * b12;
    t17 += v * b13;
    t18 += v * b14;
    t19 += v * b15;
    v = a[5];
    t5 += v * b0;
    t6 += v * b1;
    t7 += v * b2;
    t8 += v * b3;
    t9 += v * b4;
    t10 += v * b5;
    t11 += v * b6;
    t12 += v * b7;
    t13 += v * b8;
    t14 += v * b9;
    t15 += v * b10;
    t16 += v * b11;
    t17 += v * b12;
    t18 += v * b13;
    t19 += v * b14;
    t20 += v * b15;
    v = a[6];
    t6 += v * b0;
    t7 += v * b1;
    t8 += v * b2;
    t9 += v * b3;
    t10 += v * b4;
    t11 += v * b5;
    t12 += v * b6;
    t13 += v * b7;
    t14 += v * b8;
    t15 += v * b9;
    t16 += v * b10;
    t17 += v * b11;
    t18 += v * b12;
    t19 += v * b13;
    t20 += v * b14;
    t21 += v * b15;
    v = a[7];
    t7 += v * b0;
    t8 += v * b1;
    t9 += v * b2;
    t10 += v * b3;
    t11 += v * b4;
    t12 += v * b5;
    t13 += v * b6;
    t14 += v * b7;
    t15 += v * b8;
    t16 += v * b9;
    t17 += v * b10;
    t18 += v * b11;
    t19 += v * b12;
    t20 += v * b13;
    t21 += v * b14;
    t22 += v * b15;
    v = a[8];
    t8 += v * b0;
    t9 += v * b1;
    t10 += v * b2;
    t11 += v * b3;
    t12 += v * b4;
    t13 += v * b5;
    t14 += v * b6;
    t15 += v * b7;
    t16 += v * b8;
    t17 += v * b9;
    t18 += v * b10;
    t19 += v * b11;
    t20 += v * b12;
    t21 += v * b13;
    t22 += v * b14;
    t23 += v * b15;
    v = a[9];
    t9 += v * b0;
    t10 += v * b1;
    t11 += v * b2;
    t12 += v * b3;
    t13 += v * b4;
    t14 += v * b5;
    t15 += v * b6;
    t16 += v * b7;
    t17 += v * b8;
    t18 += v * b9;
    t19 += v * b10;
    t20 += v * b11;
    t21 += v * b12;
    t22 += v * b13;
    t23 += v * b14;
    t24 += v * b15;
    v = a[10];
    t10 += v * b0;
    t11 += v * b1;
    t12 += v * b2;
    t13 += v * b3;
    t14 += v * b4;
    t15 += v * b5;
    t16 += v * b6;
    t17 += v * b7;
    t18 += v * b8;
    t19 += v * b9;
    t20 += v * b10;
    t21 += v * b11;
    t22 += v * b12;
    t23 += v * b13;
    t24 += v * b14;
    t25 += v * b15;
    v = a[11];
    t11 += v * b0;
    t12 += v * b1;
    t13 += v * b2;
    t14 += v * b3;
    t15 += v * b4;
    t16 += v * b5;
    t17 += v * b6;
    t18 += v * b7;
    t19 += v * b8;
    t20 += v * b9;
    t21 += v * b10;
    t22 += v * b11;
    t23 += v * b12;
    t24 += v * b13;
    t25 += v * b14;
    t26 += v * b15;
    v = a[12];
    t12 += v * b0;
    t13 += v * b1;
    t14 += v * b2;
    t15 += v * b3;
    t16 += v * b4;
    t17 += v * b5;
    t18 += v * b6;
    t19 += v * b7;
    t20 += v * b8;
    t21 += v * b9;
    t22 += v * b10;
    t23 += v * b11;
    t24 += v * b12;
    t25 += v * b13;
    t26 += v * b14;
    t27 += v * b15;
    v = a[13];
    t13 += v * b0;
    t14 += v * b1;
    t15 += v * b2;
    t16 += v * b3;
    t17 += v * b4;
    t18 += v * b5;
    t19 += v * b6;
    t20 += v * b7;
    t21 += v * b8;
    t22 += v * b9;
    t23 += v * b10;
    t24 += v * b11;
    t25 += v * b12;
    t26 += v * b13;
    t27 += v * b14;
    t28 += v * b15;
    v = a[14];
    t14 += v * b0;
    t15 += v * b1;
    t16 += v * b2;
    t17 += v * b3;
    t18 += v * b4;
    t19 += v * b5;
    t20 += v * b6;
    t21 += v * b7;
    t22 += v * b8;
    t23 += v * b9;
    t24 += v * b10;
    t25 += v * b11;
    t26 += v * b12;
    t27 += v * b13;
    t28 += v * b14;
    t29 += v * b15;
    v = a[15];
    t15 += v * b0;
    t16 += v * b1;
    t17 += v * b2;
    t18 += v * b3;
    t19 += v * b4;
    t20 += v * b5;
    t21 += v * b6;
    t22 += v * b7;
    t23 += v * b8;
    t24 += v * b9;
    t25 += v * b10;
    t26 += v * b11;
    t27 += v * b12;
    t28 += v * b13;
    t29 += v * b14;
    t30 += v * b15;
    t0 += 38 * t16;
    t1 += 38 * t17;
    t2 += 38 * t18;
    t3 += 38 * t19;
    t4 += 38 * t20;
    t5 += 38 * t21;
    t6 += 38 * t22;
    t7 += 38 * t23;
    t8 += 38 * t24;
    t9 += 38 * t25;
    t10 += 38 * t26;
    t11 += 38 * t27;
    t12 += 38 * t28;
    t13 += 38 * t29;
    t14 += 38 * t30;
    // t15 left as is
    // first car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    // second car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    o[0] = t0;
    o[1] = t1;
    o[2] = t2;
    o[3] = t3;
    o[4] = t4;
    o[5] = t5;
    o[6] = t6;
    o[7] = t7;
    o[8] = t8;
    o[9] = t9;
    o[10] = t10;
    o[11] = t11;
    o[12] = t12;
    o[13] = t13;
    o[14] = t14;
    o[15] = t15;
}
function $0e899bb86ee17960$var$square(o, a) {
    $0e899bb86ee17960$var$mul(o, a, a);
}
function $0e899bb86ee17960$var$inv25519(o, inp) {
    var c = $0e899bb86ee17960$var$gf();
    for(var i = 0; i < 16; i++)c[i] = inp[i];
    for(var i1 = 253; i1 >= 0; i1--){
        $0e899bb86ee17960$var$square(c, c);
        if (i1 !== 2 && i1 !== 4) $0e899bb86ee17960$var$mul(c, c, inp);
    }
    for(var i2 = 0; i2 < 16; i2++)o[i2] = c[i2];
}
function $0e899bb86ee17960$var$scalarMult(n, p) {
    var z = new Uint8Array(32);
    var x = new Float64Array(80);
    var a = $0e899bb86ee17960$var$gf(), b = $0e899bb86ee17960$var$gf(), c = $0e899bb86ee17960$var$gf(), d = $0e899bb86ee17960$var$gf(), e = $0e899bb86ee17960$var$gf(), f = $0e899bb86ee17960$var$gf();
    for(var i = 0; i < 31; i++)z[i] = n[i];
    z[31] = n[31] & 127 | 64;
    z[0] &= 248;
    $0e899bb86ee17960$var$unpack25519(x, p);
    for(var i1 = 0; i1 < 16; i1++)b[i1] = x[i1];
    a[0] = d[0] = 1;
    for(var i2 = 254; i2 >= 0; --i2){
        var r = z[i2 >>> 3] >>> (i2 & 7) & 1;
        $0e899bb86ee17960$var$sel25519(a, b, r);
        $0e899bb86ee17960$var$sel25519(c, d, r);
        $0e899bb86ee17960$var$add(e, a, c);
        $0e899bb86ee17960$var$sub(a, a, c);
        $0e899bb86ee17960$var$add(c, b, d);
        $0e899bb86ee17960$var$sub(b, b, d);
        $0e899bb86ee17960$var$square(d, e);
        $0e899bb86ee17960$var$square(f, a);
        $0e899bb86ee17960$var$mul(a, c, a);
        $0e899bb86ee17960$var$mul(c, b, e);
        $0e899bb86ee17960$var$add(e, a, c);
        $0e899bb86ee17960$var$sub(a, a, c);
        $0e899bb86ee17960$var$square(b, a);
        $0e899bb86ee17960$var$sub(c, d, f);
        $0e899bb86ee17960$var$mul(a, c, $0e899bb86ee17960$var$_121665);
        $0e899bb86ee17960$var$add(a, a, d);
        $0e899bb86ee17960$var$mul(c, c, a);
        $0e899bb86ee17960$var$mul(a, d, f);
        $0e899bb86ee17960$var$mul(d, b, x);
        $0e899bb86ee17960$var$square(b, e);
        $0e899bb86ee17960$var$sel25519(a, b, r);
        $0e899bb86ee17960$var$sel25519(c, d, r);
    }
    for(var i3 = 0; i3 < 16; i3++){
        x[i3 + 16] = a[i3];
        x[i3 + 32] = c[i3];
        x[i3 + 48] = b[i3];
        x[i3 + 64] = d[i3];
    }
    var x32 = x.subarray(32);
    var x16 = x.subarray(16);
    $0e899bb86ee17960$var$inv25519(x32, x32);
    $0e899bb86ee17960$var$mul(x16, x16, x32);
    var q = new Uint8Array(32);
    $0e899bb86ee17960$var$pack25519(q, x16);
    return q;
}
module.exports.scalarMult = $0e899bb86ee17960$var$scalarMult;
function $0e899bb86ee17960$var$scalarMultBase(n) {
    return $0e899bb86ee17960$var$scalarMult(n, $0e899bb86ee17960$var$_9);
}
module.exports.scalarMultBase = $0e899bb86ee17960$var$scalarMultBase;
function $0e899bb86ee17960$var$generateKeyPairFromSeed(seed) {
    if (seed.length !== module.exports.SECRET_KEY_LENGTH) throw new Error("x25519: seed must be ".concat(module.exports.SECRET_KEY_LENGTH, " bytes"));
    var secretKey = new Uint8Array(seed);
    var publicKey = $0e899bb86ee17960$var$scalarMultBase(secretKey);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
}
module.exports.generateKeyPairFromSeed = $0e899bb86ee17960$var$generateKeyPairFromSeed;
function $0e899bb86ee17960$var$generateKeyPair(prng) {
    var seed = (0, $5A0yG.randomBytes)(32, prng);
    var result = $0e899bb86ee17960$var$generateKeyPairFromSeed(seed);
    (0, $1iHRq.wipe)(seed);
    return result;
}
module.exports.generateKeyPair = $0e899bb86ee17960$var$generateKeyPair;
/**
 * Returns a shared key between our secret key and a peer's public key.
 *
 * Throws an error if the given keys are of wrong length.
 *
 * If rejectZero is true throws if the calculated shared key is all-zero.
 * From RFC 7748:
 *
 * > Protocol designers using Diffie-Hellman over the curves defined in
 * > this document must not assume "contributory behavior".  Specially,
 * > contributory behavior means that both parties' private keys
 * > contribute to the resulting shared key.  Since curve25519 and
 * > curve448 have cofactors of 8 and 4 (respectively), an input point of
 * > small order will eliminate any contribution from the other party's
 * > private key.  This situation can be detected by checking for the all-
 * > zero output, which implementations MAY do, as specified in Section 6.
 * > However, a large number of existing implementations do not do this.
 *
 * IMPORTANT: the returned key is a raw result of scalar multiplication.
 * To use it as a key material, hash it with a cryptographic hash function.
 */ function $0e899bb86ee17960$var$sharedKey(mySecretKey, theirPublicKey) {
    var rejectZero = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (mySecretKey.length !== module.exports.PUBLIC_KEY_LENGTH) throw new Error("X25519: incorrect secret key length");
    if (theirPublicKey.length !== module.exports.PUBLIC_KEY_LENGTH) throw new Error("X25519: incorrect public key length");
    var result = $0e899bb86ee17960$var$scalarMult(mySecretKey, theirPublicKey);
    if (rejectZero) {
        var zeros = 0;
        for(var i = 0; i < result.length; i++)zeros |= result[i];
        if (zeros === 0) throw new Error("X25519: invalid shared key");
    }
    return result;
}
module.exports.sharedKey = $0e899bb86ee17960$var$sharedKey;

});

parcelRegister("7Ft2D", function(module, exports) {

$parcel$export(module.exports, "concat", function () { return (parcelRequire("lQfAa")).concat; });
$parcel$export(module.exports, "fromString", function () { return (parcelRequire("l7Yp4")).fromString; });
$parcel$export(module.exports, "toString", function () { return (parcelRequire("ewlTP")).toString; });

var $1E65n = parcelRequire("1E65n");

var $lQfAa = parcelRequire("lQfAa");

var $3bFds = parcelRequire("3bFds");

var $l7Yp4 = parcelRequire("l7Yp4");

var $ewlTP = parcelRequire("ewlTP");

var $4wMAt = parcelRequire("4wMAt");

});
parcelRegister("1E65n", function(module, exports) {
function $132e3f612db4a7b8$export$398604a469f7de9a(a, b) {
    for(var i = 0; i < a.byteLength; i++){
        if (a[i] < b[i]) return -1;
        if (a[i] > b[i]) return 1;
    }
    if (a.byteLength > b.byteLength) return 1;
    if (a.byteLength < b.byteLength) return -1;
    return 0;
}

});

parcelRegister("lQfAa", function(module, exports) {

$parcel$export(module.exports, "concat", function () { return $fe6a8aa6053f3aaa$export$ee1b3e54f0441b22; });

var $kfnqU = parcelRequire("kfnqU");
function $fe6a8aa6053f3aaa$export$ee1b3e54f0441b22(arrays, length) {
    if (!length) length = arrays.reduce(function(acc, curr) {
        return acc + curr.length;
    }, 0);
    var output = (0, $kfnqU.allocUnsafe)(length);
    var offset = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = arrays[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var arr = _step.value;
            output.set(arr, offset);
            offset += arr.length;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return output;
}

});
parcelRegister("kfnqU", function(module, exports) {

$parcel$export(module.exports, "allocUnsafe", function () { return $ebd762aa16cecfbb$export$19833a56117fe205; });
function $ebd762aa16cecfbb$export$2de70f21292aac9e() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    if (globalThis.Buffer != null && globalThis.Buffer.alloc != null) return globalThis.Buffer.alloc(size);
    return new Uint8Array(size);
}
function $ebd762aa16cecfbb$export$19833a56117fe205() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    if (globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null) return globalThis.Buffer.allocUnsafe(size);
    return new Uint8Array(size);
}

});


parcelRegister("3bFds", function(module, exports) {
function $25225ecf8be4bc51$export$e9bab7fafb253603(a, b) {
    if (a === b) return true;
    if (a.byteLength !== b.byteLength) return false;
    for(var i = 0; i < a.byteLength; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}

});

parcelRegister("l7Yp4", function(module, exports) {

$parcel$export(module.exports, "fromString", function () { return $f6191b42671f1ed4$export$3004f64547af360e; });

var $rWo4q = parcelRequire("rWo4q");
function $f6191b42671f1ed4$export$3004f64547af360e(string) {
    var encoding = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "utf8";
    var base = (0, $rWo4q.default)[encoding];
    if (!base) throw new Error('Unsupported encoding "'.concat(encoding, '"'));
    if ((encoding === "utf8" || encoding === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null) return globalThis.Buffer.from(string, "utf8");
    return base.decoder.decode("".concat(base.prefix).concat(string));
}

});
parcelRegister("rWo4q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $053fd0380cdd6d77$export$2e2bcd8739ae039; });

var $do9pw = parcelRequire("do9pw");

var $d6irY = parcelRequire("d6irY");

var $kfnqU = parcelRequire("kfnqU");
function $053fd0380cdd6d77$var$createCodec(name, prefix, encode, decode) {
    return {
        name: name,
        prefix: prefix,
        encoder: {
            name: name,
            prefix: prefix,
            encode: encode
        },
        decoder: {
            decode: decode
        }
    };
}
var $053fd0380cdd6d77$var$string = $053fd0380cdd6d77$var$createCodec("utf8", "u", function(buf) {
    var decoder = new TextDecoder("utf8");
    return "u" + decoder.decode(buf);
}, function(str) {
    var encoder = new TextEncoder();
    return encoder.encode(str.substring(1));
});
var $053fd0380cdd6d77$var$ascii = $053fd0380cdd6d77$var$createCodec("ascii", "a", function(buf) {
    var string = "a";
    for(var i = 0; i < buf.length; i++)string += String.fromCharCode(buf[i]);
    return string;
}, function(str) {
    str = str.substring(1);
    var buf = (0, $kfnqU.allocUnsafe)(str.length);
    for(var i = 0; i < str.length; i++)buf[i] = str.charCodeAt(i);
    return buf;
});
var $053fd0380cdd6d77$var$BASES = (0, $do9pw._)({
    utf8: $053fd0380cdd6d77$var$string,
    "utf-8": $053fd0380cdd6d77$var$string,
    hex: (0, $d6irY.bases).base16,
    latin1: $053fd0380cdd6d77$var$ascii,
    ascii: $053fd0380cdd6d77$var$ascii,
    binary: $053fd0380cdd6d77$var$ascii
}, (0, $d6irY.bases));
var $053fd0380cdd6d77$export$2e2bcd8739ae039 = $053fd0380cdd6d77$var$BASES;

});
parcelRegister("d6irY", function(module, exports) {

$parcel$export(module.exports, "bases", function () { return $989a25b8e4d6371b$export$196f613671eb7dd9; });

var $do9pw = parcelRequire("do9pw");

var $24s1E = parcelRequire("24s1E");

var $fja35 = parcelRequire("fja35");

var $2FtAy = parcelRequire("2FtAy");

var $8pfam = parcelRequire("8pfam");

var $6VeIY = parcelRequire("6VeIY");

var $1VqxG = parcelRequire("1VqxG");

var $6bojz = parcelRequire("6bojz");

var $gZoYy = parcelRequire("gZoYy");

var $4RCne = parcelRequire("4RCne");

var $fSPEz = parcelRequire("fSPEz");

var $2QiPL = parcelRequire("2QiPL");

var $5IGJc = parcelRequire("5IGJc");

var $crJmR = parcelRequire("crJmR");

var $dNCPi = parcelRequire("dNCPi");
parcelRequire("7WeoA");
var $4JHwI = parcelRequire("4JHwI");
var $lf6yH = parcelRequire("lf6yH");
var $d3QX5 = parcelRequire("d3QX5");
var $e9AAc = parcelRequire("e9AAc");
var $9mQaX = parcelRequire("9mQaX");
var $989a25b8e4d6371b$export$196f613671eb7dd9 = (0, $do9pw._)({}, $24s1E, $fja35, $2FtAy, $8pfam, $6VeIY, $1VqxG, $6bojz, $gZoYy, $4RCne, $fSPEz);
var $989a25b8e4d6371b$export$cff071c6f82b8944 = (0, $do9pw._)({}, $2QiPL, $5IGJc);
var $989a25b8e4d6371b$export$b2c6ab3b27d60531 = {
    raw: $crJmR,
    json: $dNCPi
};

});
parcelRegister("24s1E", function(module, exports) {

$parcel$export(module.exports, "identity", function () { return $1821b1d16dea7126$export$f0954fd7d5368655; });

var $cXFDz = parcelRequire("cXFDz");

var $9mQaX = parcelRequire("9mQaX");
var $1821b1d16dea7126$export$f0954fd7d5368655 = (0, $cXFDz.from)({
    prefix: "\0",
    name: "identity",
    encode: function(buf) {
        return (0, $9mQaX.toString)(buf);
    },
    decode: function(str) {
        return (0, $9mQaX.fromString)(str);
    }
});

});
parcelRegister("cXFDz", function(module, exports) {

$parcel$export(module.exports, "from", function () { return $96fb4afec7ca256f$export$6788812c4e6611e6; });
$parcel$export(module.exports, "baseX", function () { return $96fb4afec7ca256f$export$180c73aedea7f385; });
$parcel$export(module.exports, "rfc4648", function () { return $96fb4afec7ca256f$export$fa9dde04c7d2f31a; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $3sHb8 = parcelRequire("3sHb8");

var $do9pw = parcelRequire("do9pw");

var $90ERS = parcelRequire("90ERS");

var $9mQaX = parcelRequire("9mQaX");
var $96fb4afec7ca256f$var$Encoder = /*#__PURE__*/ function() {
    "use strict";
    function Encoder(name, prefix, baseEncode) {
        (0, $4GJKx._)(this, Encoder);
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
    }
    (0, $1wc17._)(Encoder, [
        {
            key: "encode",
            value: function encode(bytes) {
                if (bytes instanceof Uint8Array) return "".concat(this.prefix).concat(this.baseEncode(bytes));
                else throw Error("Unknown type, must be binary type");
            }
        }
    ]);
    return Encoder;
}();
var $96fb4afec7ca256f$var$Decoder = /*#__PURE__*/ function() {
    "use strict";
    function Decoder(name, prefix, baseDecode) {
        (0, $4GJKx._)(this, Decoder);
        this.name = name;
        this.prefix = prefix;
        if (prefix.codePointAt(0) === undefined) throw new Error("Invalid prefix character");
        this.prefixCodePoint = prefix.codePointAt(0);
        this.baseDecode = baseDecode;
    }
    (0, $1wc17._)(Decoder, [
        {
            key: "decode",
            value: function decode(text) {
                if (typeof text === "string") {
                    if (text.codePointAt(0) !== this.prefixCodePoint) throw Error("Unable to decode multibase string ".concat(JSON.stringify(text), ", ").concat(this.name, " decoder only supports inputs prefixed with ").concat(this.prefix));
                    return this.baseDecode(text.slice(this.prefix.length));
                } else throw Error("Can only multibase decode strings");
            }
        },
        {
            key: "or",
            value: function or1(decoder) {
                return $96fb4afec7ca256f$export$252bb8b3bbdf6749(this, decoder);
            }
        }
    ]);
    return Decoder;
}();
var $96fb4afec7ca256f$var$ComposedDecoder = /*#__PURE__*/ function() {
    "use strict";
    function ComposedDecoder(decoders) {
        (0, $4GJKx._)(this, ComposedDecoder);
        this.decoders = decoders;
    }
    (0, $1wc17._)(ComposedDecoder, [
        {
            key: "or",
            value: function or1(decoder) {
                return $96fb4afec7ca256f$export$252bb8b3bbdf6749(this, decoder);
            }
        },
        {
            key: "decode",
            value: function decode(input) {
                var prefix = input[0];
                var decoder = this.decoders[prefix];
                if (decoder) return decoder.decode(input);
                else throw RangeError("Unable to decode multibase string ".concat(JSON.stringify(input), ", only inputs prefixed with ").concat(Object.keys(this.decoders), " are supported"));
            }
        }
    ]);
    return ComposedDecoder;
}();
var $96fb4afec7ca256f$export$252bb8b3bbdf6749 = function(left, right) {
    return new $96fb4afec7ca256f$var$ComposedDecoder((0, $do9pw._)({}, left.decoders || (0, $3sHb8._)({}, left.prefix, left), right.decoders || (0, $3sHb8._)({}, right.prefix, right)));
};
var $96fb4afec7ca256f$export$a111e9ced3f1d2d0 = /*#__PURE__*/ function() {
    "use strict";
    function Codec(name, prefix, baseEncode, baseDecode) {
        (0, $4GJKx._)(this, Codec);
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
        this.baseDecode = baseDecode;
        this.encoder = new $96fb4afec7ca256f$var$Encoder(name, prefix, baseEncode);
        this.decoder = new $96fb4afec7ca256f$var$Decoder(name, prefix, baseDecode);
    }
    (0, $1wc17._)(Codec, [
        {
            key: "encode",
            value: function encode(input) {
                return this.encoder.encode(input);
            }
        },
        {
            key: "decode",
            value: function decode(input) {
                return this.decoder.decode(input);
            }
        }
    ]);
    return Codec;
}();
var $96fb4afec7ca256f$export$6788812c4e6611e6 = function(param) {
    var name = param.name, prefix = param.prefix, encode = param.encode, decode = param.decode;
    return new $96fb4afec7ca256f$export$a111e9ced3f1d2d0(name, prefix, encode, decode);
};
var $96fb4afec7ca256f$export$180c73aedea7f385 = function(param) {
    var prefix = param.prefix, name = param.name, alphabet = param.alphabet;
    var _basex = (0, $90ERS.default)(alphabet, name), encode = _basex.encode, decode = _basex.decode;
    return $96fb4afec7ca256f$export$6788812c4e6611e6({
        prefix: prefix,
        name: name,
        encode: encode,
        decode: function(text) {
            return (0, $9mQaX.coerce)(decode(text));
        }
    });
};
var $96fb4afec7ca256f$var$decode = function(string, alphabet, bitsPerChar, name) {
    var codes = {};
    for(var i = 0; i < alphabet.length; ++i)codes[alphabet[i]] = i;
    var end = string.length;
    while(string[end - 1] === "=")--end;
    var out = new Uint8Array(end * bitsPerChar / 8 | 0);
    var bits = 0;
    var buffer = 0;
    var written = 0;
    for(var i1 = 0; i1 < end; ++i1){
        var value = codes[string[i1]];
        if (value === undefined) throw new SyntaxError("Non-".concat(name, " character"));
        buffer = buffer << bitsPerChar | value;
        bits += bitsPerChar;
        if (bits >= 8) {
            bits -= 8;
            out[written++] = 255 & buffer >> bits;
        }
    }
    if (bits >= bitsPerChar || 255 & buffer << 8 - bits) throw new SyntaxError("Unexpected end of data");
    return out;
};
var $96fb4afec7ca256f$var$encode = function(data, alphabet, bitsPerChar) {
    var pad = alphabet[alphabet.length - 1] === "=";
    var mask = (1 << bitsPerChar) - 1;
    var out = "";
    var bits = 0;
    var buffer = 0;
    for(var i = 0; i < data.length; ++i){
        buffer = buffer << 8 | data[i];
        bits += 8;
        while(bits > bitsPerChar){
            bits -= bitsPerChar;
            out += alphabet[mask & buffer >> bits];
        }
    }
    if (bits) out += alphabet[mask & buffer << bitsPerChar - bits];
    if (pad) while(out.length * bitsPerChar & 7)out += "=";
    return out;
};
var $96fb4afec7ca256f$export$fa9dde04c7d2f31a = function(param) {
    var name = param.name, prefix = param.prefix, bitsPerChar = param.bitsPerChar, alphabet = param.alphabet;
    return $96fb4afec7ca256f$export$6788812c4e6611e6({
        prefix: prefix,
        name: name,
        encode: function(input) {
            return $96fb4afec7ca256f$var$encode(input, alphabet, bitsPerChar);
        },
        decode: function(input) {
            return $96fb4afec7ca256f$var$decode(input, alphabet, bitsPerChar, name);
        }
    });
};

});
parcelRegister("90ERS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68f3d0aeb00296b4$export$2e2bcd8739ae039; });
function $68f3d0aeb00296b4$var$base(ALPHABET, name) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256);
    var iFACTOR = Math.log(256) / Math.log(BASE);
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        while(pbegin !== pend){
            var carry = source[pbegin];
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        if (source[psz] === " ") return;
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        var size = (source.length - psz) * FACTOR + 1 >>> 0;
        var b256 = new Uint8Array(size);
        while(source[psz]){
            var carry = BASE_MAP[source.charCodeAt(psz)];
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        if (source[psz] === " ") return;
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-".concat(name, " character"));
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
var $68f3d0aeb00296b4$var$src = $68f3d0aeb00296b4$var$base;
var $68f3d0aeb00296b4$var$_brrp__multiformats_scope_baseX = $68f3d0aeb00296b4$var$src;
var $68f3d0aeb00296b4$export$2e2bcd8739ae039 = $68f3d0aeb00296b4$var$_brrp__multiformats_scope_baseX;

});

parcelRegister("9mQaX", function(module, exports) {

$parcel$export(module.exports, "equals", function () { return $6d1ea426ee0d60fc$export$e9bab7fafb253603; });
$parcel$export(module.exports, "coerce", function () { return $6d1ea426ee0d60fc$export$8c14e57e778d3873; });
$parcel$export(module.exports, "fromString", function () { return $6d1ea426ee0d60fc$export$3004f64547af360e; });
$parcel$export(module.exports, "toString", function () { return $6d1ea426ee0d60fc$export$f84e8e69fd4488a5; });
var $6d1ea426ee0d60fc$export$6e22c362a0406a2c = new Uint8Array(0);
var $6d1ea426ee0d60fc$export$7ea66e3774a60b67 = function(d) {
    return d.reduce(function(hex, byte) {
        return hex + byte.toString(16).padStart(2, "0");
    }, "");
};
var $6d1ea426ee0d60fc$export$1a8ceedbd5845648 = function(hex) {
    var hexes = hex.match(/../g);
    return hexes ? new Uint8Array(hexes.map(function(b) {
        return parseInt(b, 16);
    })) : $6d1ea426ee0d60fc$export$6e22c362a0406a2c;
};
var $6d1ea426ee0d60fc$export$e9bab7fafb253603 = function(aa, bb) {
    if (aa === bb) return true;
    if (aa.byteLength !== bb.byteLength) return false;
    for(var ii = 0; ii < aa.byteLength; ii++){
        if (aa[ii] !== bb[ii]) return false;
    }
    return true;
};
var $6d1ea426ee0d60fc$export$8c14e57e778d3873 = function(o) {
    if (o instanceof Uint8Array && o.constructor.name === "Uint8Array") return o;
    if (o instanceof ArrayBuffer) return new Uint8Array(o);
    if (ArrayBuffer.isView(o)) return new Uint8Array(o.buffer, o.byteOffset, o.byteLength);
    throw new Error("Unknown type, must be binary type");
};
var $6d1ea426ee0d60fc$export$37488ff1135b1696 = function(o) {
    return o instanceof ArrayBuffer || ArrayBuffer.isView(o);
};
var $6d1ea426ee0d60fc$export$3004f64547af360e = function(str) {
    return new TextEncoder().encode(str);
};
var $6d1ea426ee0d60fc$export$f84e8e69fd4488a5 = function(b) {
    return new TextDecoder().decode(b);
};

});



parcelRegister("fja35", function(module, exports) {

$parcel$export(module.exports, "base2", function () { return $b2506cd446d0372e$export$ed5f7917e37e31aa; });

var $cXFDz = parcelRequire("cXFDz");
var $b2506cd446d0372e$export$ed5f7917e37e31aa = (0, $cXFDz.rfc4648)({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});

});

parcelRegister("2FtAy", function(module, exports) {

$parcel$export(module.exports, "base8", function () { return $1f165cceb38b537d$export$43b580ac9deb5b96; });

var $cXFDz = parcelRequire("cXFDz");
var $1f165cceb38b537d$export$43b580ac9deb5b96 = (0, $cXFDz.rfc4648)({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});

});

parcelRegister("8pfam", function(module, exports) {

$parcel$export(module.exports, "base10", function () { return $61ec6c369bd461e3$export$63d6a7de0ff813cc; });

var $cXFDz = parcelRequire("cXFDz");
var $61ec6c369bd461e3$export$63d6a7de0ff813cc = (0, $cXFDz.baseX)({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});

});

parcelRegister("6VeIY", function(module, exports) {

$parcel$export(module.exports, "base16", function () { return $50a37cecbd0e2dfc$export$586f61c71cb02fe4; });
$parcel$export(module.exports, "base16upper", function () { return $50a37cecbd0e2dfc$export$2d835b8dd4032b62; });

var $cXFDz = parcelRequire("cXFDz");
var $50a37cecbd0e2dfc$export$586f61c71cb02fe4 = (0, $cXFDz.rfc4648)({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
});
var $50a37cecbd0e2dfc$export$2d835b8dd4032b62 = (0, $cXFDz.rfc4648)({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});

});

parcelRegister("1VqxG", function(module, exports) {

$parcel$export(module.exports, "base32", function () { return $166fb4131107a942$export$4a4d5965e2738b2a; });
$parcel$export(module.exports, "base32upper", function () { return $166fb4131107a942$export$fbaa3bbbd754def4; });
$parcel$export(module.exports, "base32pad", function () { return $166fb4131107a942$export$e194fa100d329365; });
$parcel$export(module.exports, "base32padupper", function () { return $166fb4131107a942$export$3a9fc48d294dce32; });
$parcel$export(module.exports, "base32hex", function () { return $166fb4131107a942$export$c57d6760d519c8ac; });
$parcel$export(module.exports, "base32hexupper", function () { return $166fb4131107a942$export$8cf4640df3165d29; });
$parcel$export(module.exports, "base32hexpad", function () { return $166fb4131107a942$export$8c6a05c08ec7d456; });
$parcel$export(module.exports, "base32hexpadupper", function () { return $166fb4131107a942$export$29f73c6a744e639f; });
$parcel$export(module.exports, "base32z", function () { return $166fb4131107a942$export$fdad9af4bdc05e3; });

var $cXFDz = parcelRequire("cXFDz");
var $166fb4131107a942$export$4a4d5965e2738b2a = (0, $cXFDz.rfc4648)({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
});
var $166fb4131107a942$export$fbaa3bbbd754def4 = (0, $cXFDz.rfc4648)({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
});
var $166fb4131107a942$export$e194fa100d329365 = (0, $cXFDz.rfc4648)({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
});
var $166fb4131107a942$export$3a9fc48d294dce32 = (0, $cXFDz.rfc4648)({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
});
var $166fb4131107a942$export$c57d6760d519c8ac = (0, $cXFDz.rfc4648)({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
});
var $166fb4131107a942$export$8cf4640df3165d29 = (0, $cXFDz.rfc4648)({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
});
var $166fb4131107a942$export$8c6a05c08ec7d456 = (0, $cXFDz.rfc4648)({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
});
var $166fb4131107a942$export$29f73c6a744e639f = (0, $cXFDz.rfc4648)({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
});
var $166fb4131107a942$export$fdad9af4bdc05e3 = (0, $cXFDz.rfc4648)({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});

});

parcelRegister("6bojz", function(module, exports) {

$parcel$export(module.exports, "base36", function () { return $4806a18b06cbf9e8$export$95b61e7c39ae893a; });
$parcel$export(module.exports, "base36upper", function () { return $4806a18b06cbf9e8$export$bab7c9bdb963afd; });

var $cXFDz = parcelRequire("cXFDz");
var $4806a18b06cbf9e8$export$95b61e7c39ae893a = (0, $cXFDz.baseX)({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
});
var $4806a18b06cbf9e8$export$bab7c9bdb963afd = (0, $cXFDz.baseX)({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});

});

parcelRegister("gZoYy", function(module, exports) {

$parcel$export(module.exports, "base58btc", function () { return $c5e5b77ecc6e19a7$export$65c61748a9b98a2c; });
$parcel$export(module.exports, "base58flickr", function () { return $c5e5b77ecc6e19a7$export$c6a7baed2941aad2; });

var $cXFDz = parcelRequire("cXFDz");
var $c5e5b77ecc6e19a7$export$65c61748a9b98a2c = (0, $cXFDz.baseX)({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
});
var $c5e5b77ecc6e19a7$export$c6a7baed2941aad2 = (0, $cXFDz.baseX)({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});

});

parcelRegister("4RCne", function(module, exports) {

$parcel$export(module.exports, "base64", function () { return $38a9e0e77fdf2168$export$b3b2de96497acc47; });
$parcel$export(module.exports, "base64pad", function () { return $38a9e0e77fdf2168$export$a9c086fc40b4563c; });
$parcel$export(module.exports, "base64url", function () { return $38a9e0e77fdf2168$export$7d21597c7bc64465; });
$parcel$export(module.exports, "base64urlpad", function () { return $38a9e0e77fdf2168$export$e87ddc9183aa53c9; });

var $cXFDz = parcelRequire("cXFDz");
var $38a9e0e77fdf2168$export$b3b2de96497acc47 = (0, $cXFDz.rfc4648)({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
});
var $38a9e0e77fdf2168$export$a9c086fc40b4563c = (0, $cXFDz.rfc4648)({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
});
var $38a9e0e77fdf2168$export$7d21597c7bc64465 = (0, $cXFDz.rfc4648)({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
});
var $38a9e0e77fdf2168$export$e87ddc9183aa53c9 = (0, $cXFDz.rfc4648)({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});

});

parcelRegister("fSPEz", function(module, exports) {

$parcel$export(module.exports, "base256emoji", function () { return $b903f77687c1e6bc$export$6a5d4ab6075d2779; });

var $cXFDz = parcelRequire("cXFDz");
var $b903f77687c1e6bc$var$alphabet = Array.from("\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42");
var $b903f77687c1e6bc$var$alphabetBytesToChars = $b903f77687c1e6bc$var$alphabet.reduce(function(p, c, i) {
    p[i] = c;
    return p;
}, []);
var $b903f77687c1e6bc$var$alphabetCharsToBytes = $b903f77687c1e6bc$var$alphabet.reduce(function(p, c, i) {
    p[c.codePointAt(0)] = i;
    return p;
}, []);
function $b903f77687c1e6bc$var$encode(data) {
    return data.reduce(function(p, c) {
        p += $b903f77687c1e6bc$var$alphabetBytesToChars[c];
        return p;
    }, "");
}
function $b903f77687c1e6bc$var$decode(str) {
    var byts = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = str[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var char = _step.value;
            var byt = $b903f77687c1e6bc$var$alphabetCharsToBytes[char.codePointAt(0)];
            if (byt === undefined) throw new Error("Non-base256emoji character: ".concat(char));
            byts.push(byt);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return new Uint8Array(byts);
}
var $b903f77687c1e6bc$export$6a5d4ab6075d2779 = (0, $cXFDz.from)({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: $b903f77687c1e6bc$var$encode,
    decode: $b903f77687c1e6bc$var$decode
});

});

parcelRegister("2QiPL", function(module, exports) {

$parcel$export(module.exports, "sha256", function () { return $211f0c20cc4147d8$export$bced8d2aada2d1c9; });
$parcel$export(module.exports, "sha512", function () { return $211f0c20cc4147d8$export$a888d2532e6dc7bb; });

var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $lf6yH = parcelRequire("lf6yH");
var $211f0c20cc4147d8$var$sha = function(name) {
    return function() {
        var _ref = (0, $kSuI9._)(function(data) {
            var _;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ = Uint8Array.bind;
                        return [
                            4,
                            crypto.subtle.digest(name, data)
                        ];
                    case 1:
                        return [
                            2,
                            new (_.apply(Uint8Array, [
                                void 0,
                                _state.sent()
                            ]))
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }();
};
var $211f0c20cc4147d8$export$bced8d2aada2d1c9 = (0, $lf6yH.from)({
    name: "sha2-256",
    code: 18,
    encode: $211f0c20cc4147d8$var$sha("SHA-256")
});
var $211f0c20cc4147d8$export$a888d2532e6dc7bb = (0, $lf6yH.from)({
    name: "sha2-512",
    code: 19,
    encode: $211f0c20cc4147d8$var$sha("SHA-512")
});

});
parcelRegister("lf6yH", function(module, exports) {

$parcel$export(module.exports, "from", function () { return $f770161b89afdd5e$export$6788812c4e6611e6; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $d3QX5 = parcelRequire("d3QX5");
var $f770161b89afdd5e$export$6788812c4e6611e6 = function(param) {
    var name = param.name, code = param.code, encode = param.encode;
    return new $f770161b89afdd5e$export$df06eed23808f4d0(name, code, encode);
};
var $f770161b89afdd5e$export$df06eed23808f4d0 = /*#__PURE__*/ function() {
    "use strict";
    function Hasher(name, code, encode) {
        (0, $4GJKx._)(this, Hasher);
        this.name = name;
        this.code = code;
        this.encode = encode;
    }
    (0, $1wc17._)(Hasher, [
        {
            key: "digest",
            value: function digest(input) {
                var _this = this;
                if (input instanceof Uint8Array) {
                    var result = this.encode(input);
                    return result instanceof Uint8Array ? $d3QX5.create(this.code, result) : result.then(function(digest) {
                        return $d3QX5.create(_this.code, digest);
                    });
                } else throw Error("Unknown type, must be binary type");
            }
        }
    ]);
    return Hasher;
}();

});
parcelRegister("d3QX5", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $9824a15c50e51053$export$185802fd694ee1f5; });
$parcel$export(module.exports, "Digest", function () { return $9824a15c50e51053$export$d67a82ff561eff43; });
$parcel$export(module.exports, "decode", function () { return $9824a15c50e51053$export$2f872c0f2117be69; });
$parcel$export(module.exports, "equals", function () { return $9824a15c50e51053$export$e9bab7fafb253603; });

var $4GJKx = parcelRequire("4GJKx");

var $cv9Rk = parcelRequire("cv9Rk");

var $9mQaX = parcelRequire("9mQaX");

var $e9AAc = parcelRequire("e9AAc");
var $9824a15c50e51053$export$185802fd694ee1f5 = function(code, digest) {
    var size = digest.byteLength;
    var sizeOffset = $e9AAc.encodingLength(code);
    var digestOffset = sizeOffset + $e9AAc.encodingLength(size);
    var bytes = new Uint8Array(digestOffset + size);
    $e9AAc.encodeTo(code, bytes, 0);
    $e9AAc.encodeTo(size, bytes, sizeOffset);
    bytes.set(digest, digestOffset);
    return new $9824a15c50e51053$export$d67a82ff561eff43(code, size, digest, bytes);
};
var $9824a15c50e51053$export$2f872c0f2117be69 = function(multihash) {
    var bytes = (0, $9mQaX.coerce)(multihash);
    var _varint_decode = (0, $cv9Rk._)($e9AAc.decode(bytes), 2), code = _varint_decode[0], sizeOffset = _varint_decode[1];
    var _varint_decode1 = (0, $cv9Rk._)($e9AAc.decode(bytes.subarray(sizeOffset)), 2), size = _varint_decode1[0], digestOffset = _varint_decode1[1];
    var digest = bytes.subarray(sizeOffset + digestOffset);
    if (digest.byteLength !== size) throw new Error("Incorrect length");
    return new $9824a15c50e51053$export$d67a82ff561eff43(code, size, digest, bytes);
};
var $9824a15c50e51053$export$e9bab7fafb253603 = function(a, b) {
    if (a === b) return true;
    else return a.code === b.code && a.size === b.size && (0, $9mQaX.equals)(a.bytes, b.bytes);
};
var $9824a15c50e51053$export$d67a82ff561eff43 = function Digest(code, size, digest, bytes) {
    "use strict";
    (0, $4GJKx._)(this, Digest);
    this.code = code;
    this.size = size;
    this.digest = digest;
    this.bytes = bytes;
};

});
parcelRegister("e9AAc", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $a4de488d84ce9439$export$2f872c0f2117be69; });
$parcel$export(module.exports, "encodeTo", function () { return $a4de488d84ce9439$export$8512cbe4228de3b3; });
$parcel$export(module.exports, "encodingLength", function () { return $a4de488d84ce9439$export$cbee51f25f0626d7; });

var $6c0yc = parcelRequire("6c0yc");
var $a4de488d84ce9439$export$2f872c0f2117be69 = function(data) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var code = (0, $6c0yc.default).decode(data, offset);
    return [
        code,
        (0, $6c0yc.default).decode.bytes
    ];
};
var $a4de488d84ce9439$export$8512cbe4228de3b3 = function(int, target) {
    var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    (0, $6c0yc.default).encode(int, target, offset);
    return target;
};
var $a4de488d84ce9439$export$cbee51f25f0626d7 = function(int) {
    return (0, $6c0yc.default).encodingLength(int);
};

});
parcelRegister("6c0yc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48244a62c46c8100$export$2e2bcd8739ae039; });
var $48244a62c46c8100$var$encode_1 = $48244a62c46c8100$var$encode;
var $48244a62c46c8100$var$MSB = 128, $48244a62c46c8100$var$REST = 127, $48244a62c46c8100$var$MSBALL = ~$48244a62c46c8100$var$REST, $48244a62c46c8100$var$INT = Math.pow(2, 31);
function $48244a62c46c8100$var$encode(num, out, offset) {
    out = out || [];
    offset = offset || 0;
    var oldOffset = offset;
    while(num >= $48244a62c46c8100$var$INT){
        out[offset++] = num & 255 | $48244a62c46c8100$var$MSB;
        num /= 128;
    }
    while(num & $48244a62c46c8100$var$MSBALL){
        out[offset++] = num & 255 | $48244a62c46c8100$var$MSB;
        num >>>= 7;
    }
    out[offset] = num | 0;
    $48244a62c46c8100$var$encode.bytes = offset - oldOffset + 1;
    return out;
}
var $48244a62c46c8100$var$decode = $48244a62c46c8100$var$read;
var $48244a62c46c8100$var$MSB$1 = 128, $48244a62c46c8100$var$REST$1 = 127;
function $48244a62c46c8100$var$read(buf, offset) {
    var res = 0, offset = offset || 0, shift = 0, counter = offset, b, l = buf.length;
    do {
        if (counter >= l) {
            $48244a62c46c8100$var$read.bytes = 0;
            throw new RangeError("Could not decode varint");
        }
        b = buf[counter++];
        res += shift < 28 ? (b & $48244a62c46c8100$var$REST$1) << shift : (b & $48244a62c46c8100$var$REST$1) * Math.pow(2, shift);
        shift += 7;
    }while (b >= $48244a62c46c8100$var$MSB$1);
    $48244a62c46c8100$var$read.bytes = counter - offset;
    return res;
}
var $48244a62c46c8100$var$N1 = Math.pow(2, 7);
var $48244a62c46c8100$var$N2 = Math.pow(2, 14);
var $48244a62c46c8100$var$N3 = Math.pow(2, 21);
var $48244a62c46c8100$var$N4 = Math.pow(2, 28);
var $48244a62c46c8100$var$N5 = Math.pow(2, 35);
var $48244a62c46c8100$var$N6 = Math.pow(2, 42);
var $48244a62c46c8100$var$N7 = Math.pow(2, 49);
var $48244a62c46c8100$var$N8 = Math.pow(2, 56);
var $48244a62c46c8100$var$N9 = Math.pow(2, 63);
var $48244a62c46c8100$var$length = function length(value) {
    return value < $48244a62c46c8100$var$N1 ? 1 : value < $48244a62c46c8100$var$N2 ? 2 : value < $48244a62c46c8100$var$N3 ? 3 : value < $48244a62c46c8100$var$N4 ? 4 : value < $48244a62c46c8100$var$N5 ? 5 : value < $48244a62c46c8100$var$N6 ? 6 : value < $48244a62c46c8100$var$N7 ? 7 : value < $48244a62c46c8100$var$N8 ? 8 : value < $48244a62c46c8100$var$N9 ? 9 : 10;
};
var $48244a62c46c8100$var$varint = {
    encode: $48244a62c46c8100$var$encode_1,
    decode: $48244a62c46c8100$var$decode,
    encodingLength: $48244a62c46c8100$var$length
};
var $48244a62c46c8100$var$_brrp_varint = $48244a62c46c8100$var$varint;
var $48244a62c46c8100$export$2e2bcd8739ae039 = $48244a62c46c8100$var$_brrp_varint;

});





parcelRegister("5IGJc", function(module, exports) {

$parcel$export(module.exports, "identity", function () { return $42a234b4708d2921$export$f0954fd7d5368655; });

var $9mQaX = parcelRequire("9mQaX");

var $d3QX5 = parcelRequire("d3QX5");
var $42a234b4708d2921$var$code = 0;
var $42a234b4708d2921$var$name = "identity";
var $42a234b4708d2921$var$encode = (0, $9mQaX.coerce);
var $42a234b4708d2921$var$digest = function(input) {
    return $d3QX5.create($42a234b4708d2921$var$code, $42a234b4708d2921$var$encode(input));
};
var $42a234b4708d2921$export$f0954fd7d5368655 = {
    code: $42a234b4708d2921$var$code,
    name: $42a234b4708d2921$var$name,
    encode: $42a234b4708d2921$var$encode,
    digest: $42a234b4708d2921$var$digest
};

});

parcelRegister("crJmR", function(module, exports) {

$parcel$export(module.exports, "name", function () { return $90fb32c0f29b9f14$export$a8ff84c12d48cfa6; });
$parcel$export(module.exports, "code", function () { return $90fb32c0f29b9f14$export$6565f9f03506010b; });
$parcel$export(module.exports, "encode", function () { return $90fb32c0f29b9f14$export$c564cdbbe6da493; });
$parcel$export(module.exports, "decode", function () { return $90fb32c0f29b9f14$export$2f872c0f2117be69; });

var $9mQaX = parcelRequire("9mQaX");
var $90fb32c0f29b9f14$export$a8ff84c12d48cfa6 = "raw";
var $90fb32c0f29b9f14$export$6565f9f03506010b = 85;
var $90fb32c0f29b9f14$export$c564cdbbe6da493 = function(node) {
    return (0, $9mQaX.coerce)(node);
};
var $90fb32c0f29b9f14$export$2f872c0f2117be69 = function(data) {
    return (0, $9mQaX.coerce)(data);
};

});

parcelRegister("dNCPi", function(module, exports) {

$parcel$export(module.exports, "name", function () { return $a0bdf81481c32985$export$a8ff84c12d48cfa6; });
$parcel$export(module.exports, "code", function () { return $a0bdf81481c32985$export$6565f9f03506010b; });
$parcel$export(module.exports, "encode", function () { return $a0bdf81481c32985$export$c564cdbbe6da493; });
$parcel$export(module.exports, "decode", function () { return $a0bdf81481c32985$export$2f872c0f2117be69; });
var $a0bdf81481c32985$var$textEncoder = new TextEncoder();
var $a0bdf81481c32985$var$textDecoder = new TextDecoder();
var $a0bdf81481c32985$export$a8ff84c12d48cfa6 = "json";
var $a0bdf81481c32985$export$6565f9f03506010b = 512;
var $a0bdf81481c32985$export$c564cdbbe6da493 = function(node) {
    return $a0bdf81481c32985$var$textEncoder.encode(JSON.stringify(node));
};
var $a0bdf81481c32985$export$2f872c0f2117be69 = function(data) {
    return JSON.parse($a0bdf81481c32985$var$textDecoder.decode(data));
};

});

parcelRegister("7WeoA", function(module, exports) {

var $4JHwI = parcelRequire("4JHwI");

var $e9AAc = parcelRequire("e9AAc");

var $9mQaX = parcelRequire("9mQaX");

var $lf6yH = parcelRequire("lf6yH");

var $d3QX5 = parcelRequire("d3QX5");

});
parcelRegister("4JHwI", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $cv9Rk = parcelRequire("cv9Rk");

var $e9AAc = parcelRequire("e9AAc");

var $d3QX5 = parcelRequire("d3QX5");

var $gZoYy = parcelRequire("gZoYy");

var $1VqxG = parcelRequire("1VqxG");

var $9mQaX = parcelRequire("9mQaX");
var $372d20e1333a635d$export$12d863fcef3f6aa = /*#__PURE__*/ function() {
    "use strict";
    function CID(version, code, multihash, bytes) {
        (0, $4GJKx._)(this, CID);
        this.code = code;
        this.version = version;
        this.multihash = multihash;
        this.bytes = bytes;
        this.byteOffset = bytes.byteOffset;
        this.byteLength = bytes.byteLength;
        this.asCID = this;
        this._baseCache = new Map();
        Object.defineProperties(this, {
            byteOffset: $372d20e1333a635d$var$hidden,
            byteLength: $372d20e1333a635d$var$hidden,
            code: $372d20e1333a635d$var$readonly,
            version: $372d20e1333a635d$var$readonly,
            multihash: $372d20e1333a635d$var$readonly,
            bytes: $372d20e1333a635d$var$readonly,
            _baseCache: $372d20e1333a635d$var$hidden,
            asCID: $372d20e1333a635d$var$hidden
        });
    }
    (0, $1wc17._)(CID, [
        {
            key: "toV0",
            value: function toV0() {
                switch(this.version){
                    case 0:
                        return this;
                    default:
                        {
                            var _this = this, code = _this.code, multihash = _this.multihash;
                            if (code !== $372d20e1333a635d$var$DAG_PB_CODE) throw new Error("Cannot convert a non dag-pb CID to CIDv0");
                            if (multihash.code !== $372d20e1333a635d$var$SHA_256_CODE) throw new Error("Cannot convert non sha2-256 multihash CID to CIDv0");
                            return CID.createV0(multihash);
                        }
                }
            }
        },
        {
            key: "toV1",
            value: function toV1() {
                switch(this.version){
                    case 0:
                        {
                            var _this_multihash = this.multihash, code = _this_multihash.code, digest = _this_multihash.digest;
                            var multihash = $d3QX5.create(code, digest);
                            return CID.createV1(this.code, multihash);
                        }
                    case 1:
                        return this;
                    default:
                        throw Error("Can not convert CID version ".concat(this.version, " to version 0. This is a bug please report"));
                }
            }
        },
        {
            key: "equals",
            value: function equals(other) {
                return other && this.code === other.code && this.version === other.version && $d3QX5.equals(this.multihash, other.multihash);
            }
        },
        {
            key: "toString",
            value: function toString(base) {
                var _this = this, bytes = _this.bytes, version = _this.version, _baseCache = _this._baseCache;
                switch(version){
                    case 0:
                        return $372d20e1333a635d$var$toStringV0(bytes, _baseCache, base || (0, $gZoYy.base58btc).encoder);
                    default:
                        return $372d20e1333a635d$var$toStringV1(bytes, _baseCache, base || (0, $1VqxG.base32).encoder);
                }
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    code: this.code,
                    version: this.version,
                    hash: this.multihash.bytes
                };
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "CID";
            }
        },
        {
            key: Symbol.for("nodejs.util.inspect.custom"),
            value: function value() {
                return "CID(" + this.toString() + ")";
            }
        },
        {
            key: "toBaseEncodedString",
            get: function get() {
                throw new Error("Deprecated, use .toString()");
            }
        },
        {
            key: "codec",
            get: function get() {
                throw new Error('"codec" property is deprecated, use integer "code" property instead');
            }
        },
        {
            key: "buffer",
            get: function get() {
                throw new Error("Deprecated .buffer property, use .bytes to get Uint8Array instead");
            }
        },
        {
            key: "multibaseName",
            get: function get() {
                throw new Error('"multibaseName" property is deprecated');
            }
        },
        {
            key: "prefix",
            get: function get() {
                throw new Error('"prefix" property is deprecated');
            }
        }
    ], [
        {
            key: "isCID",
            value: function isCID(value) {
                $372d20e1333a635d$var$deprecate(/^0\.0/, $372d20e1333a635d$var$IS_CID_DEPRECATION);
                return !!(value && (value[$372d20e1333a635d$var$cidSymbol] || value.asCID === value));
            }
        },
        {
            key: "asCID",
            value: function asCID(value) {
                if (value instanceof CID) return value;
                else if (value != null && value.asCID === value) {
                    var version = value.version, code = value.code, multihash = value.multihash, bytes = value.bytes;
                    return new CID(version, code, multihash, bytes || $372d20e1333a635d$var$encodeCID(version, code, multihash.bytes));
                } else if (value != null && value[$372d20e1333a635d$var$cidSymbol] === true) {
                    var version1 = value.version, multihash1 = value.multihash, code1 = value.code;
                    var digest = $d3QX5.decode(multihash1);
                    return CID.create(version1, code1, digest);
                } else return null;
            }
        },
        {
            key: "create",
            value: function create(version, code, digest) {
                if (typeof code !== "number") throw new Error("String codecs are no longer supported");
                switch(version){
                    case 0:
                        if (code !== $372d20e1333a635d$var$DAG_PB_CODE) throw new Error("Version 0 CID must use dag-pb (code: ".concat($372d20e1333a635d$var$DAG_PB_CODE, ") block encoding"));
                        else return new CID(version, code, digest, digest.bytes);
                    case 1:
                        {
                            var bytes = $372d20e1333a635d$var$encodeCID(version, code, digest.bytes);
                            return new CID(version, code, digest, bytes);
                        }
                    default:
                        throw new Error("Invalid version");
                }
            }
        },
        {
            key: "createV0",
            value: function createV0(digest) {
                return CID.create(0, $372d20e1333a635d$var$DAG_PB_CODE, digest);
            }
        },
        {
            key: "createV1",
            value: function createV1(code, digest) {
                return CID.create(1, code, digest);
            }
        },
        {
            key: "decode",
            value: function decode(bytes) {
                var _CID_decodeFirst = (0, $cv9Rk._)(CID.decodeFirst(bytes), 2), cid = _CID_decodeFirst[0], remainder = _CID_decodeFirst[1];
                if (remainder.length) throw new Error("Incorrect length");
                return cid;
            }
        },
        {
            key: "decodeFirst",
            value: function decodeFirst(bytes) {
                var specs = CID.inspectBytes(bytes);
                var prefixSize = specs.size - specs.multihashSize;
                var multihashBytes = (0, $9mQaX.coerce)(bytes.subarray(prefixSize, prefixSize + specs.multihashSize));
                if (multihashBytes.byteLength !== specs.multihashSize) throw new Error("Incorrect length");
                var digestBytes = multihashBytes.subarray(specs.multihashSize - specs.digestSize);
                var digest = new $d3QX5.Digest(specs.multihashCode, specs.digestSize, digestBytes, multihashBytes);
                var cid = specs.version === 0 ? CID.createV0(digest) : CID.createV1(specs.codec, digest);
                return [
                    cid,
                    bytes.subarray(specs.size)
                ];
            }
        },
        {
            key: "inspectBytes",
            value: function inspectBytes(initialBytes) {
                var offset = 0;
                var next = function() {
                    var _varint_decode = (0, $cv9Rk._)($e9AAc.decode(initialBytes.subarray(offset)), 2), i = _varint_decode[0], length = _varint_decode[1];
                    offset += length;
                    return i;
                };
                var version = next();
                var codec = $372d20e1333a635d$var$DAG_PB_CODE;
                if (version === 18) {
                    version = 0;
                    offset = 0;
                } else if (version === 1) codec = next();
                if (version !== 0 && version !== 1) throw new RangeError("Invalid CID version ".concat(version));
                var prefixSize = offset;
                var multihashCode = next();
                var digestSize = next();
                var size = offset + digestSize;
                var multihashSize = size - prefixSize;
                return {
                    version: version,
                    codec: codec,
                    multihashCode: multihashCode,
                    digestSize: digestSize,
                    multihashSize: multihashSize,
                    size: size
                };
            }
        },
        {
            key: "parse",
            value: function parse(source, base) {
                var _parseCIDtoBytes = (0, $cv9Rk._)($372d20e1333a635d$var$parseCIDtoBytes(source, base), 2), prefix = _parseCIDtoBytes[0], bytes = _parseCIDtoBytes[1];
                var cid = CID.decode(bytes);
                cid._baseCache.set(prefix, source);
                return cid;
            }
        }
    ]);
    return CID;
}();
var $372d20e1333a635d$var$parseCIDtoBytes = function(source, base) {
    switch(source[0]){
        case "Q":
            {
                var decoder = base || (0, $gZoYy.base58btc);
                return [
                    (0, $gZoYy.base58btc).prefix,
                    decoder.decode("".concat((0, $gZoYy.base58btc).prefix).concat(source))
                ];
            }
        case (0, $gZoYy.base58btc).prefix:
            {
                var decoder1 = base || (0, $gZoYy.base58btc);
                return [
                    (0, $gZoYy.base58btc).prefix,
                    decoder1.decode(source)
                ];
            }
        case (0, $1VqxG.base32).prefix:
            {
                var decoder2 = base || (0, $1VqxG.base32);
                return [
                    (0, $1VqxG.base32).prefix,
                    decoder2.decode(source)
                ];
            }
        default:
            if (base == null) throw Error("To parse non base32 or base58btc encoded CID multibase decoder must be provided");
            return [
                source[0],
                base.decode(source)
            ];
    }
};
var $372d20e1333a635d$var$toStringV0 = function(bytes, cache, base) {
    var prefix = base.prefix;
    if (prefix !== (0, $gZoYy.base58btc).prefix) throw Error("Cannot string encode V0 in ".concat(base.name, " encoding"));
    var cid = cache.get(prefix);
    if (cid == null) {
        var cid1 = base.encode(bytes).slice(1);
        cache.set(prefix, cid1);
        return cid1;
    } else return cid;
};
var $372d20e1333a635d$var$toStringV1 = function(bytes, cache, base) {
    var prefix = base.prefix;
    var cid = cache.get(prefix);
    if (cid == null) {
        var cid1 = base.encode(bytes);
        cache.set(prefix, cid1);
        return cid1;
    } else return cid;
};
var $372d20e1333a635d$var$DAG_PB_CODE = 112;
var $372d20e1333a635d$var$SHA_256_CODE = 18;
var $372d20e1333a635d$var$encodeCID = function(version, code, multihash) {
    var codeOffset = $e9AAc.encodingLength(version);
    var hashOffset = codeOffset + $e9AAc.encodingLength(code);
    var bytes = new Uint8Array(hashOffset + multihash.byteLength);
    $e9AAc.encodeTo(version, bytes, 0);
    $e9AAc.encodeTo(code, bytes, codeOffset);
    bytes.set(multihash, hashOffset);
    return bytes;
};
var $372d20e1333a635d$var$cidSymbol = Symbol.for("@ipld/js-cid/CID");
var $372d20e1333a635d$var$readonly = {
    writable: false,
    configurable: false,
    enumerable: true
};
var $372d20e1333a635d$var$hidden = {
    writable: false,
    enumerable: false,
    configurable: false
};
var $372d20e1333a635d$var$version = "0.0.0-dev";
var $372d20e1333a635d$var$deprecate = function(range, message) {
    if (range.test($372d20e1333a635d$var$version)) console.warn(message);
    else throw new Error(message);
};
var $372d20e1333a635d$var$IS_CID_DEPRECATION = "CID.isCID(v) is deprecated and will be removed in the next major release.\nFollowing code pattern:\n\nif (CID.isCID(value)) {\n  doSomethingWithCID(value)\n}\n\nIs replaced with:\n\nconst cid = CID.asCID(value)\nif (cid) {\n  // Make sure to use cid instead of value\n  doSomethingWithCID(cid)\n}\n";

});





parcelRegister("ewlTP", function(module, exports) {

$parcel$export(module.exports, "toString", function () { return $a9250a9f802af394$export$f84e8e69fd4488a5; });

var $rWo4q = parcelRequire("rWo4q");
function $a9250a9f802af394$export$f84e8e69fd4488a5(array) {
    var encoding = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "utf8";
    var base = (0, $rWo4q.default)[encoding];
    if (!base) throw new Error('Unsupported encoding "'.concat(encoding, '"'));
    if ((encoding === "utf8" || encoding === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null) return globalThis.Buffer.from(array.buffer, array.byteOffset, array.byteLength).toString("utf8");
    return base.encoder.encode(array).substring(1);
}

});

parcelRegister("4wMAt", function(module, exports) {

var $kfnqU = parcelRequire("kfnqU");
function $34bfd704945da983$export$6444ef5cd411280c(a, b) {
    if (a.length !== b.length) throw new Error("Inputs should have the same length");
    var result = (0, $kfnqU.allocUnsafe)(a.length);
    for(var i = 0; i < a.length; i++)result[i] = a[i] ^ b[i];
    return result;
}

});


parcelRegister("4z21a", function(module, exports) {
"use strict";
var $352bff07aa0da42d$var$elliptic = module.exports;

$352bff07aa0da42d$var$elliptic.version = (parcelRequire("auhIW")).version;

$352bff07aa0da42d$var$elliptic.utils = (parcelRequire("4OvZ4"));

$352bff07aa0da42d$var$elliptic.rand = (parcelRequire("iuHvy"));

$352bff07aa0da42d$var$elliptic.curve = (parcelRequire("f1dYm"));

$352bff07aa0da42d$var$elliptic.curves = (parcelRequire("dG5bA"));

// Protocols
$352bff07aa0da42d$var$elliptic.ec = (parcelRequire("fGaGJ"));

$352bff07aa0da42d$var$elliptic.eddsa = (parcelRequire("h9ZEV"));

});
parcelRegister("auhIW", function(module, exports) {
module.exports = JSON.parse('{"name":"elliptic","version":"6.5.7","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}');

});

parcelRegister("4OvZ4", function(module, exports) {
"use strict";
var $3814a44bf186da78$var$utils = module.exports;

var $3wGZr = parcelRequire("3wGZr");

var $7WVV2 = parcelRequire("7WVV2");

var $dAFlY = parcelRequire("dAFlY");
$3814a44bf186da78$var$utils.assert = $7WVV2;
$3814a44bf186da78$var$utils.toArray = $dAFlY.toArray;
$3814a44bf186da78$var$utils.zero2 = $dAFlY.zero2;
$3814a44bf186da78$var$utils.toHex = $dAFlY.toHex;
$3814a44bf186da78$var$utils.encode = $dAFlY.encode;
// Represent num in a w-NAF form
function $3814a44bf186da78$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$3814a44bf186da78$var$utils.getNAF = $3814a44bf186da78$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $3814a44bf186da78$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$3814a44bf186da78$var$utils.getJSF = $3814a44bf186da78$var$getJSF;
function $3814a44bf186da78$var$cachedProperty(obj, name, computer) {
    var key = "_" + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$3814a44bf186da78$var$utils.cachedProperty = $3814a44bf186da78$var$cachedProperty;
function $3814a44bf186da78$var$parseBytes(bytes) {
    return typeof bytes === "string" ? $3814a44bf186da78$var$utils.toArray(bytes, "hex") : bytes;
}
$3814a44bf186da78$var$utils.parseBytes = $3814a44bf186da78$var$parseBytes;
function $3814a44bf186da78$var$intFromLE(bytes) {
    return new $3wGZr(bytes, "hex", "le");
}
$3814a44bf186da78$var$utils.intFromLE = $3814a44bf186da78$var$intFromLE;

});
parcelRegister("3wGZr", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("9dH9K")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("7WVV2", function(module, exports) {
module.exports = $5c9ae0b2a4247da8$var$assert;
function $5c9ae0b2a4247da8$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$5c9ae0b2a4247da8$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

});

parcelRegister("dAFlY", function(module, exports) {
"use strict";
var $9e4eb71150b048f8$var$utils = module.exports;
function $9e4eb71150b048f8$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== "string") {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === "hex") {
        msg = msg.replace(/[^a-z0-9]+/ig, "");
        if (msg.length % 2 !== 0) msg = "0" + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$9e4eb71150b048f8$var$utils.toArray = $9e4eb71150b048f8$var$toArray;
function $9e4eb71150b048f8$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$9e4eb71150b048f8$var$utils.zero2 = $9e4eb71150b048f8$var$zero2;
function $9e4eb71150b048f8$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $9e4eb71150b048f8$var$zero2(msg[i].toString(16));
    return res;
}
$9e4eb71150b048f8$var$utils.toHex = $9e4eb71150b048f8$var$toHex;
$9e4eb71150b048f8$var$utils.encode = function encode(arr, enc) {
    if (enc === "hex") return $9e4eb71150b048f8$var$toHex(arr);
    else return arr;
};

});


parcelRegister("iuHvy", function(module, exports) {
var $d76cc71a17f3c5e7$var$r;
module.exports = function rand(len) {
    if (!$d76cc71a17f3c5e7$var$r) $d76cc71a17f3c5e7$var$r = new $d76cc71a17f3c5e7$var$Rand(null);
    return $d76cc71a17f3c5e7$var$r.generate(len);
};
function $d76cc71a17f3c5e7$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $d76cc71a17f3c5e7$var$Rand;
$d76cc71a17f3c5e7$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$d76cc71a17f3c5e7$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === "object") {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $d76cc71a17f3c5e7$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $d76cc71a17f3c5e7$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === "object") // Old junk
    $d76cc71a17f3c5e7$var$Rand.prototype._rand = function() {
        throw new Error("Not implemented yet");
    };
} else // Node.js or Web worker with no crypto support
try {
    var $d76cc71a17f3c5e7$var$crypto = (parcelRequire("9dH9K"));
    if (typeof $d76cc71a17f3c5e7$var$crypto.randomBytes !== "function") throw new Error("Not supported");
    $d76cc71a17f3c5e7$var$Rand.prototype._rand = function _rand(n) {
        return $d76cc71a17f3c5e7$var$crypto.randomBytes(n);
    };
} catch (e) {}

});

parcelRegister("f1dYm", function(module, exports) {
"use strict";
var $aef1c9ad0dd0a9eb$var$curve = module.exports;

$aef1c9ad0dd0a9eb$var$curve.base = (parcelRequire("25gFn"));

$aef1c9ad0dd0a9eb$var$curve.short = (parcelRequire("hbKRh"));

$aef1c9ad0dd0a9eb$var$curve.mont = (parcelRequire("eyqzN"));

$aef1c9ad0dd0a9eb$var$curve.edwards = (parcelRequire("jDxcC"));

});
parcelRegister("25gFn", function(module, exports) {
"use strict";

var $3wGZr = parcelRequire("3wGZr");

var $4OvZ4 = parcelRequire("4OvZ4");
var $1848f9f836a1b9c7$var$getNAF = $4OvZ4.getNAF;
var $1848f9f836a1b9c7$var$getJSF = $4OvZ4.getJSF;
var $1848f9f836a1b9c7$var$assert = $4OvZ4.assert;
function $1848f9f836a1b9c7$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $3wGZr(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $3wGZr.red(conf.prime) : $3wGZr.mont(this.p);
    // Useful for many curves
    this.zero = new $3wGZr(0).toRed(this.red);
    this.one = new $3wGZr(1).toRed(this.red);
    this.two = new $3wGZr(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $3wGZr(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $1848f9f836a1b9c7$var$BaseCurve;
$1848f9f836a1b9c7$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$1848f9f836a1b9c7$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$1848f9f836a1b9c7$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $1848f9f836a1b9c7$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $1848f9f836a1b9c7$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$1848f9f836a1b9c7$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $1848f9f836a1b9c7$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $1848f9f836a1b9c7$var$assert(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$1848f9f836a1b9c7$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $1848f9f836a1b9c7$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $1848f9f836a1b9c7$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $1848f9f836a1b9c7$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $1848f9f836a1b9c7$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$1848f9f836a1b9c7$var$BaseCurve.BasePoint = $1848f9f836a1b9c7$var$BasePoint;
$1848f9f836a1b9c7$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$1848f9f836a1b9c7$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$1848f9f836a1b9c7$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $4OvZ4.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $1848f9f836a1b9c7$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $1848f9f836a1b9c7$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$1848f9f836a1b9c7$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$1848f9f836a1b9c7$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$1848f9f836a1b9c7$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $4OvZ4.encode(this._encode(compact), enc);
};
$1848f9f836a1b9c7$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$1848f9f836a1b9c7$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$1848f9f836a1b9c7$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$1848f9f836a1b9c7$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$1848f9f836a1b9c7$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$1848f9f836a1b9c7$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("hbKRh", function(module, exports) {
"use strict";

var $4OvZ4 = parcelRequire("4OvZ4");

var $3wGZr = parcelRequire("3wGZr");

var $hwgCU = parcelRequire("hwgCU");

var $25gFn = parcelRequire("25gFn");
var $c837cfdbc6a3038e$var$assert = $4OvZ4.assert;
function $c837cfdbc6a3038e$var$ShortCurve(conf) {
    $25gFn.call(this, "short", conf);
    this.a = new $3wGZr(conf.a, 16).toRed(this.red);
    this.b = new $3wGZr(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$hwgCU($c837cfdbc6a3038e$var$ShortCurve, $25gFn);
module.exports = $c837cfdbc6a3038e$var$ShortCurve;
$c837cfdbc6a3038e$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $3wGZr(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $3wGZr(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $c837cfdbc6a3038e$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $3wGZr(vec.a, 16),
            b: new $3wGZr(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$c837cfdbc6a3038e$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $3wGZr.mont(num);
    var tinv = new $3wGZr(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $3wGZr(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$c837cfdbc6a3038e$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $3wGZr(1);
    var y1 = new $3wGZr(0);
    var x2 = new $3wGZr(0);
    var y2 = new $3wGZr(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$c837cfdbc6a3038e$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$c837cfdbc6a3038e$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $3wGZr(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$c837cfdbc6a3038e$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$c837cfdbc6a3038e$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $c837cfdbc6a3038e$var$Point(curve, x, y, isRed) {
    $25gFn.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $3wGZr(x, 16);
        this.y = new $3wGZr(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$hwgCU($c837cfdbc6a3038e$var$Point, $25gFn.BasePoint);
$c837cfdbc6a3038e$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $c837cfdbc6a3038e$var$Point(this, x, y, isRed);
};
$c837cfdbc6a3038e$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $c837cfdbc6a3038e$var$Point.fromJSON(this, obj, red);
};
$c837cfdbc6a3038e$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function endoMul(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$c837cfdbc6a3038e$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$c837cfdbc6a3038e$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$c837cfdbc6a3038e$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$c837cfdbc6a3038e$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$c837cfdbc6a3038e$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$c837cfdbc6a3038e$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$c837cfdbc6a3038e$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$c837cfdbc6a3038e$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$c837cfdbc6a3038e$var$Point.prototype.mul = function mul(k) {
    k = new $3wGZr(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$c837cfdbc6a3038e$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$c837cfdbc6a3038e$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$c837cfdbc6a3038e$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$c837cfdbc6a3038e$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function negate(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$c837cfdbc6a3038e$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $c837cfdbc6a3038e$var$JPoint(curve, x, y, z) {
    $25gFn.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $3wGZr(0);
    } else {
        this.x = new $3wGZr(x, 16);
        this.y = new $3wGZr(y, 16);
        this.z = new $3wGZr(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$hwgCU($c837cfdbc6a3038e$var$JPoint, $25gFn.BasePoint);
$c837cfdbc6a3038e$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $c837cfdbc6a3038e$var$JPoint(this, x, y, z);
};
$c837cfdbc6a3038e$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$c837cfdbc6a3038e$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$c837cfdbc6a3038e$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$c837cfdbc6a3038e$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$c837cfdbc6a3038e$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$c837cfdbc6a3038e$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$c837cfdbc6a3038e$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$c837cfdbc6a3038e$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$c837cfdbc6a3038e$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$c837cfdbc6a3038e$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$c837cfdbc6a3038e$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $3wGZr(k, kbase);
    return this.curve._wnafMul(this, k);
};
$c837cfdbc6a3038e$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$c837cfdbc6a3038e$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$c837cfdbc6a3038e$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$c837cfdbc6a3038e$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});
parcelRegister("hwgCU", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});


parcelRegister("eyqzN", function(module, exports) {
"use strict";

var $3wGZr = parcelRequire("3wGZr");

var $hwgCU = parcelRequire("hwgCU");

var $25gFn = parcelRequire("25gFn");

var $4OvZ4 = parcelRequire("4OvZ4");
function $a988db3387543c7d$var$MontCurve(conf) {
    $25gFn.call(this, "mont", conf);
    this.a = new $3wGZr(conf.a, 16).toRed(this.red);
    this.b = new $3wGZr(conf.b, 16).toRed(this.red);
    this.i4 = new $3wGZr(4).toRed(this.red).redInvm();
    this.two = new $3wGZr(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$hwgCU($a988db3387543c7d$var$MontCurve, $25gFn);
module.exports = $a988db3387543c7d$var$MontCurve;
$a988db3387543c7d$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $a988db3387543c7d$var$Point(curve, x, z) {
    $25gFn.BasePoint.call(this, curve, "projective");
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $3wGZr(x, 16);
        this.z = new $3wGZr(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$hwgCU($a988db3387543c7d$var$Point, $25gFn.BasePoint);
$a988db3387543c7d$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($4OvZ4.toArray(bytes, enc), 1);
};
$a988db3387543c7d$var$MontCurve.prototype.point = function point(x, z) {
    return new $a988db3387543c7d$var$Point(this, x, z);
};
$a988db3387543c7d$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $a988db3387543c7d$var$Point.fromJSON(this, obj);
};
$a988db3387543c7d$var$Point.prototype.precompute = function precompute() {
// No-op
};
$a988db3387543c7d$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray("be", this.curve.p.byteLength());
};
$a988db3387543c7d$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $a988db3387543c7d$var$Point(curve, obj[0], obj[1] || curve.one);
};
$a988db3387543c7d$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$a988db3387543c7d$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$a988db3387543c7d$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$a988db3387543c7d$var$Point.prototype.add = function add() {
    throw new Error("Not supported on Montgomery curve");
};
$a988db3387543c7d$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$a988db3387543c7d$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$a988db3387543c7d$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$a988db3387543c7d$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$a988db3387543c7d$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$a988db3387543c7d$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$a988db3387543c7d$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("jDxcC", function(module, exports) {
"use strict";

var $4OvZ4 = parcelRequire("4OvZ4");

var $3wGZr = parcelRequire("3wGZr");

var $hwgCU = parcelRequire("hwgCU");

var $25gFn = parcelRequire("25gFn");
var $e4bb6a30ae189fa2$var$assert = $4OvZ4.assert;
function $e4bb6a30ae189fa2$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $25gFn.call(this, "edwards", conf);
    this.a = new $3wGZr(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $3wGZr(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $3wGZr(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $e4bb6a30ae189fa2$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$hwgCU($e4bb6a30ae189fa2$var$EdwardsCurve, $25gFn);
module.exports = $e4bb6a30ae189fa2$var$EdwardsCurve;
$e4bb6a30ae189fa2$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$e4bb6a30ae189fa2$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$e4bb6a30ae189fa2$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$e4bb6a30ae189fa2$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $3wGZr(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$e4bb6a30ae189fa2$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $3wGZr(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error("invalid point");
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error("invalid point");
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$e4bb6a30ae189fa2$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $e4bb6a30ae189fa2$var$Point(curve, x, y, z, t) {
    $25gFn.BasePoint.call(this, curve, "projective");
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $3wGZr(x, 16);
        this.y = new $3wGZr(y, 16);
        this.z = z ? new $3wGZr(z, 16) : this.curve.one;
        this.t = t && new $3wGZr(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$hwgCU($e4bb6a30ae189fa2$var$Point, $25gFn.BasePoint);
$e4bb6a30ae189fa2$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $e4bb6a30ae189fa2$var$Point.fromJSON(this, obj);
};
$e4bb6a30ae189fa2$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $e4bb6a30ae189fa2$var$Point(this, x, y, z, t);
};
$e4bb6a30ae189fa2$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $e4bb6a30ae189fa2$var$Point(curve, obj[0], obj[1], obj[2]);
};
$e4bb6a30ae189fa2$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$e4bb6a30ae189fa2$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$e4bb6a30ae189fa2$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$e4bb6a30ae189fa2$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$e4bb6a30ae189fa2$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$e4bb6a30ae189fa2$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$e4bb6a30ae189fa2$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$e4bb6a30ae189fa2$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$e4bb6a30ae189fa2$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$e4bb6a30ae189fa2$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$e4bb6a30ae189fa2$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$e4bb6a30ae189fa2$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$e4bb6a30ae189fa2$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$e4bb6a30ae189fa2$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$e4bb6a30ae189fa2$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$e4bb6a30ae189fa2$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$e4bb6a30ae189fa2$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$e4bb6a30ae189fa2$var$Point.prototype.toP = $e4bb6a30ae189fa2$var$Point.prototype.normalize;
$e4bb6a30ae189fa2$var$Point.prototype.mixedAdd = $e4bb6a30ae189fa2$var$Point.prototype.add;

});


parcelRegister("dG5bA", function(module, exports) {
"use strict";
var $9f533866ab76b6b4$var$curves = module.exports;

var $2eq8E = parcelRequire("2eq8E");

var $f1dYm = parcelRequire("f1dYm");

var $4OvZ4 = parcelRequire("4OvZ4");
var $9f533866ab76b6b4$var$assert = $4OvZ4.assert;
function $9f533866ab76b6b4$var$PresetCurve(options) {
    if (options.type === "short") this.curve = new $f1dYm.short(options);
    else if (options.type === "edwards") this.curve = new $f1dYm.edwards(options);
    else this.curve = new $f1dYm.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $9f533866ab76b6b4$var$assert(this.g.validate(), "Invalid curve");
    $9f533866ab76b6b4$var$assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
}
$9f533866ab76b6b4$var$curves.PresetCurve = $9f533866ab76b6b4$var$PresetCurve;
function $9f533866ab76b6b4$var$defineCurve(name, options) {
    Object.defineProperty($9f533866ab76b6b4$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function get() {
            var curve = new $9f533866ab76b6b4$var$PresetCurve(options);
            Object.defineProperty($9f533866ab76b6b4$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$9f533866ab76b6b4$var$defineCurve("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: $2eq8E.sha256,
    gRed: false,
    g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
});
$9f533866ab76b6b4$var$defineCurve("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: $2eq8E.sha256,
    gRed: false,
    g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
});
$9f533866ab76b6b4$var$defineCurve("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: $2eq8E.sha256,
    gRed: false,
    g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
});
$9f533866ab76b6b4$var$defineCurve("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $2eq8E.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$9f533866ab76b6b4$var$defineCurve("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $2eq8E.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$9f533866ab76b6b4$var$defineCurve("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $2eq8E.sha256,
    gRed: false,
    g: [
        "9"
    ]
});
$9f533866ab76b6b4$var$defineCurve("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $2eq8E.sha256,
    gRed: false,
    g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
    ]
});
var $9f533866ab76b6b4$var$pre;

try {
    $9f533866ab76b6b4$var$pre = (parcelRequire("9TncA"));
} catch (e) {
    $9f533866ab76b6b4$var$pre = undefined;
}
$9f533866ab76b6b4$var$defineCurve("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: $2eq8E.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
        {
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
        }
    ],
    gRed: false,
    g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        $9f533866ab76b6b4$var$pre
    ]
});

});
parcelRegister("2eq8E", function(module, exports) {
var $1a012a2ae54af2fe$var$hash = module.exports;

$1a012a2ae54af2fe$var$hash.utils = (parcelRequire("bxKYQ"));

$1a012a2ae54af2fe$var$hash.common = (parcelRequire("hImYp"));

$1a012a2ae54af2fe$var$hash.sha = (parcelRequire("03XPf"));

$1a012a2ae54af2fe$var$hash.ripemd = (parcelRequire("6xyjW"));

$1a012a2ae54af2fe$var$hash.hmac = (parcelRequire("cMrGk"));
// Proxy hash functions to the main object
$1a012a2ae54af2fe$var$hash.sha1 = $1a012a2ae54af2fe$var$hash.sha.sha1;
$1a012a2ae54af2fe$var$hash.sha256 = $1a012a2ae54af2fe$var$hash.sha.sha256;
$1a012a2ae54af2fe$var$hash.sha224 = $1a012a2ae54af2fe$var$hash.sha.sha224;
$1a012a2ae54af2fe$var$hash.sha384 = $1a012a2ae54af2fe$var$hash.sha.sha384;
$1a012a2ae54af2fe$var$hash.sha512 = $1a012a2ae54af2fe$var$hash.sha.sha512;
$1a012a2ae54af2fe$var$hash.ripemd160 = $1a012a2ae54af2fe$var$hash.ripemd.ripemd160;

});
parcelRegister("bxKYQ", function(module, exports) {

$parcel$export(module.exports, "inherits", function () { return $8677381611f24b78$export$69f1b2dcda23c5f8; }, function (v) { return $8677381611f24b78$export$69f1b2dcda23c5f8 = v; });
$parcel$export(module.exports, "toArray", function () { return $8677381611f24b78$export$45b10814cc054894; }, function (v) { return $8677381611f24b78$export$45b10814cc054894 = v; });
$parcel$export(module.exports, "toHex", function () { return $8677381611f24b78$export$7ea66e3774a60b67; }, function (v) { return $8677381611f24b78$export$7ea66e3774a60b67 = v; });
$parcel$export(module.exports, "htonl", function () { return $8677381611f24b78$export$34a52f00f601f6f1; }, function (v) { return $8677381611f24b78$export$34a52f00f601f6f1 = v; });
$parcel$export(module.exports, "toHex32", function () { return $8677381611f24b78$export$812b0cbd5e8a72ab; }, function (v) { return $8677381611f24b78$export$812b0cbd5e8a72ab = v; });
$parcel$export(module.exports, "zero2", function () { return $8677381611f24b78$export$f24f9e11d63bb314; }, function (v) { return $8677381611f24b78$export$f24f9e11d63bb314 = v; });
$parcel$export(module.exports, "zero8", function () { return $8677381611f24b78$export$b71357c7e07ca1f1; }, function (v) { return $8677381611f24b78$export$b71357c7e07ca1f1 = v; });
$parcel$export(module.exports, "join32", function () { return $8677381611f24b78$export$2e58a4b541fdcbe8; }, function (v) { return $8677381611f24b78$export$2e58a4b541fdcbe8 = v; });
$parcel$export(module.exports, "split32", function () { return $8677381611f24b78$export$183b950bde9faab8; }, function (v) { return $8677381611f24b78$export$183b950bde9faab8 = v; });
$parcel$export(module.exports, "rotr32", function () { return $8677381611f24b78$export$4785c77169fea59e; }, function (v) { return $8677381611f24b78$export$4785c77169fea59e = v; });
$parcel$export(module.exports, "rotl32", function () { return $8677381611f24b78$export$242a185dfcffac5b; }, function (v) { return $8677381611f24b78$export$242a185dfcffac5b = v; });
$parcel$export(module.exports, "sum32", function () { return $8677381611f24b78$export$58c04ae0ae31877d; }, function (v) { return $8677381611f24b78$export$58c04ae0ae31877d = v; });
$parcel$export(module.exports, "sum32_3", function () { return $8677381611f24b78$export$d058ca695f8c6f11; }, function (v) { return $8677381611f24b78$export$d058ca695f8c6f11 = v; });
$parcel$export(module.exports, "sum32_4", function () { return $8677381611f24b78$export$a1efd7fc3e986367; }, function (v) { return $8677381611f24b78$export$a1efd7fc3e986367 = v; });
$parcel$export(module.exports, "sum32_5", function () { return $8677381611f24b78$export$bbfea4a2b5abaab4; }, function (v) { return $8677381611f24b78$export$bbfea4a2b5abaab4 = v; });
$parcel$export(module.exports, "sum64", function () { return $8677381611f24b78$export$97ad4afc7de86152; }, function (v) { return $8677381611f24b78$export$97ad4afc7de86152 = v; });
$parcel$export(module.exports, "sum64_hi", function () { return $8677381611f24b78$export$ce4673d9a79f6a4b; }, function (v) { return $8677381611f24b78$export$ce4673d9a79f6a4b = v; });
$parcel$export(module.exports, "sum64_lo", function () { return $8677381611f24b78$export$786cc99fc6eedc0b; }, function (v) { return $8677381611f24b78$export$786cc99fc6eedc0b = v; });
$parcel$export(module.exports, "sum64_4_hi", function () { return $8677381611f24b78$export$45c59b9a1848dd0; }, function (v) { return $8677381611f24b78$export$45c59b9a1848dd0 = v; });
$parcel$export(module.exports, "sum64_4_lo", function () { return $8677381611f24b78$export$50d8f613e76d3034; }, function (v) { return $8677381611f24b78$export$50d8f613e76d3034 = v; });
$parcel$export(module.exports, "sum64_5_hi", function () { return $8677381611f24b78$export$b8e83683c60ee162; }, function (v) { return $8677381611f24b78$export$b8e83683c60ee162 = v; });
$parcel$export(module.exports, "sum64_5_lo", function () { return $8677381611f24b78$export$aeeb51790d1bcc4a; }, function (v) { return $8677381611f24b78$export$aeeb51790d1bcc4a = v; });
$parcel$export(module.exports, "rotr64_hi", function () { return $8677381611f24b78$export$bb7c616f719ad9c; }, function (v) { return $8677381611f24b78$export$bb7c616f719ad9c = v; });
$parcel$export(module.exports, "rotr64_lo", function () { return $8677381611f24b78$export$4d63290824f9d7df; }, function (v) { return $8677381611f24b78$export$4d63290824f9d7df = v; });
$parcel$export(module.exports, "shr64_hi", function () { return $8677381611f24b78$export$2f64ceb90ef28ea1; }, function (v) { return $8677381611f24b78$export$2f64ceb90ef28ea1 = v; });
$parcel$export(module.exports, "shr64_lo", function () { return $8677381611f24b78$export$8d2089d465f6d10d; }, function (v) { return $8677381611f24b78$export$8d2089d465f6d10d = v; });
var $8677381611f24b78$export$69f1b2dcda23c5f8;
var $8677381611f24b78$export$45b10814cc054894;
var $8677381611f24b78$export$7ea66e3774a60b67;
var $8677381611f24b78$export$34a52f00f601f6f1;
var $8677381611f24b78$export$812b0cbd5e8a72ab;
var $8677381611f24b78$export$f24f9e11d63bb314;
var $8677381611f24b78$export$b71357c7e07ca1f1;
var $8677381611f24b78$export$2e58a4b541fdcbe8;
var $8677381611f24b78$export$183b950bde9faab8;
var $8677381611f24b78$export$4785c77169fea59e;
var $8677381611f24b78$export$242a185dfcffac5b;
var $8677381611f24b78$export$58c04ae0ae31877d;
var $8677381611f24b78$export$d058ca695f8c6f11;
var $8677381611f24b78$export$a1efd7fc3e986367;
var $8677381611f24b78$export$bbfea4a2b5abaab4;
var $8677381611f24b78$export$97ad4afc7de86152;
var $8677381611f24b78$export$ce4673d9a79f6a4b;
var $8677381611f24b78$export$786cc99fc6eedc0b;
var $8677381611f24b78$export$45c59b9a1848dd0;
var $8677381611f24b78$export$50d8f613e76d3034;
var $8677381611f24b78$export$b8e83683c60ee162;
var $8677381611f24b78$export$aeeb51790d1bcc4a;
var $8677381611f24b78$export$bb7c616f719ad9c;
var $8677381611f24b78$export$4d63290824f9d7df;
var $8677381611f24b78$export$2f64ceb90ef28ea1;
var $8677381611f24b78$export$8d2089d465f6d10d;
"use strict";

var $7WVV2 = parcelRequire("7WVV2");

var $hwgCU = parcelRequire("hwgCU");
$8677381611f24b78$export$69f1b2dcda23c5f8 = $hwgCU;
function $8677381611f24b78$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $8677381611f24b78$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($8677381611f24b78$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$8677381611f24b78$export$45b10814cc054894 = $8677381611f24b78$var$toArray;
function $8677381611f24b78$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $8677381611f24b78$var$zero2(msg[i].toString(16));
    return res;
}
$8677381611f24b78$export$7ea66e3774a60b67 = $8677381611f24b78$var$toHex;
function $8677381611f24b78$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$8677381611f24b78$export$34a52f00f601f6f1 = $8677381611f24b78$var$htonl;
function $8677381611f24b78$var$toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = $8677381611f24b78$var$htonl(w);
        res += $8677381611f24b78$var$zero8(w.toString(16));
    }
    return res;
}
$8677381611f24b78$export$812b0cbd5e8a72ab = $8677381611f24b78$var$toHex32;
function $8677381611f24b78$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$8677381611f24b78$export$f24f9e11d63bb314 = $8677381611f24b78$var$zero2;
function $8677381611f24b78$var$zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
$8677381611f24b78$export$b71357c7e07ca1f1 = $8677381611f24b78$var$zero8;
function $8677381611f24b78$var$join32(msg, start, end, endian) {
    var len = end - start;
    $7WVV2(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$8677381611f24b78$export$2e58a4b541fdcbe8 = $8677381611f24b78$var$join32;
function $8677381611f24b78$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$8677381611f24b78$export$183b950bde9faab8 = $8677381611f24b78$var$split32;
function $8677381611f24b78$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$8677381611f24b78$export$4785c77169fea59e = $8677381611f24b78$var$rotr32;
function $8677381611f24b78$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$8677381611f24b78$export$242a185dfcffac5b = $8677381611f24b78$var$rotl32;
function $8677381611f24b78$var$sum32(a, b) {
    return a + b >>> 0;
}
$8677381611f24b78$export$58c04ae0ae31877d = $8677381611f24b78$var$sum32;
function $8677381611f24b78$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$8677381611f24b78$export$d058ca695f8c6f11 = $8677381611f24b78$var$sum32_3;
function $8677381611f24b78$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$8677381611f24b78$export$a1efd7fc3e986367 = $8677381611f24b78$var$sum32_4;
function $8677381611f24b78$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$8677381611f24b78$export$bbfea4a2b5abaab4 = $8677381611f24b78$var$sum32_5;
function $8677381611f24b78$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$8677381611f24b78$export$97ad4afc7de86152 = $8677381611f24b78$var$sum64;
function $8677381611f24b78$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$8677381611f24b78$export$ce4673d9a79f6a4b = $8677381611f24b78$var$sum64_hi;
function $8677381611f24b78$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$8677381611f24b78$export$786cc99fc6eedc0b = $8677381611f24b78$var$sum64_lo;
function $8677381611f24b78$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$8677381611f24b78$export$45c59b9a1848dd0 = $8677381611f24b78$var$sum64_4_hi;
function $8677381611f24b78$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$8677381611f24b78$export$50d8f613e76d3034 = $8677381611f24b78$var$sum64_4_lo;
function $8677381611f24b78$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$8677381611f24b78$export$b8e83683c60ee162 = $8677381611f24b78$var$sum64_5_hi;
function $8677381611f24b78$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$8677381611f24b78$export$aeeb51790d1bcc4a = $8677381611f24b78$var$sum64_5_lo;
function $8677381611f24b78$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$8677381611f24b78$export$bb7c616f719ad9c = $8677381611f24b78$var$rotr64_hi;
function $8677381611f24b78$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$8677381611f24b78$export$4d63290824f9d7df = $8677381611f24b78$var$rotr64_lo;
function $8677381611f24b78$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$8677381611f24b78$export$2f64ceb90ef28ea1 = $8677381611f24b78$var$shr64_hi;
function $8677381611f24b78$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$8677381611f24b78$export$8d2089d465f6d10d = $8677381611f24b78$var$shr64_lo;

});

parcelRegister("hImYp", function(module, exports) {

$parcel$export(module.exports, "BlockHash", function () { return $ce585dc167d45d11$export$8687658379b577e6; }, function (v) { return $ce585dc167d45d11$export$8687658379b577e6 = v; });
var $ce585dc167d45d11$export$8687658379b577e6;
"use strict";

var $bxKYQ = parcelRequire("bxKYQ");

var $7WVV2 = parcelRequire("7WVV2");
function $ce585dc167d45d11$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$ce585dc167d45d11$export$8687658379b577e6 = $ce585dc167d45d11$var$BlockHash;
$ce585dc167d45d11$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $bxKYQ.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $bxKYQ.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$ce585dc167d45d11$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $7WVV2(this.pending === null);
    return this._digest(enc);
};
$ce585dc167d45d11$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("03XPf", function(module, exports) {

$parcel$export(module.exports, "sha1", function () { return $00beb00d0afa2168$export$5091bdda49ba90f5; }, function (v) { return $00beb00d0afa2168$export$5091bdda49ba90f5 = v; });
$parcel$export(module.exports, "sha224", function () { return $00beb00d0afa2168$export$97b70509d4e397ea; }, function (v) { return $00beb00d0afa2168$export$97b70509d4e397ea = v; });
$parcel$export(module.exports, "sha256", function () { return $00beb00d0afa2168$export$bced8d2aada2d1c9; }, function (v) { return $00beb00d0afa2168$export$bced8d2aada2d1c9 = v; });
$parcel$export(module.exports, "sha384", function () { return $00beb00d0afa2168$export$612d47d55dedde45; }, function (v) { return $00beb00d0afa2168$export$612d47d55dedde45 = v; });
$parcel$export(module.exports, "sha512", function () { return $00beb00d0afa2168$export$a888d2532e6dc7bb; }, function (v) { return $00beb00d0afa2168$export$a888d2532e6dc7bb = v; });
var $00beb00d0afa2168$export$5091bdda49ba90f5;
var $00beb00d0afa2168$export$97b70509d4e397ea;
var $00beb00d0afa2168$export$bced8d2aada2d1c9;
var $00beb00d0afa2168$export$612d47d55dedde45;
var $00beb00d0afa2168$export$a888d2532e6dc7bb;
"use strict";

$00beb00d0afa2168$export$5091bdda49ba90f5 = (parcelRequire("i4U9Z"));

$00beb00d0afa2168$export$97b70509d4e397ea = (parcelRequire("e6IrM"));

$00beb00d0afa2168$export$bced8d2aada2d1c9 = (parcelRequire("6tIqG"));

$00beb00d0afa2168$export$612d47d55dedde45 = (parcelRequire("kmwi1"));

$00beb00d0afa2168$export$a888d2532e6dc7bb = (parcelRequire("bVmxl"));

});
parcelRegister("i4U9Z", function(module, exports) {
"use strict";

var $bxKYQ = parcelRequire("bxKYQ");

var $hImYp = parcelRequire("hImYp");

var $clh35 = parcelRequire("clh35");
var $d29429f1c0a951ac$var$rotl32 = $bxKYQ.rotl32;
var $d29429f1c0a951ac$var$sum32 = $bxKYQ.sum32;
var $d29429f1c0a951ac$var$sum32_5 = $bxKYQ.sum32_5;
var $d29429f1c0a951ac$var$ft_1 = $clh35.ft_1;
var $d29429f1c0a951ac$var$BlockHash = $hImYp.BlockHash;
var $d29429f1c0a951ac$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $d29429f1c0a951ac$var$SHA1() {
    if (!(this instanceof $d29429f1c0a951ac$var$SHA1)) return new $d29429f1c0a951ac$var$SHA1();
    $d29429f1c0a951ac$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$bxKYQ.inherits($d29429f1c0a951ac$var$SHA1, $d29429f1c0a951ac$var$BlockHash);
module.exports = $d29429f1c0a951ac$var$SHA1;
$d29429f1c0a951ac$var$SHA1.blockSize = 512;
$d29429f1c0a951ac$var$SHA1.outSize = 160;
$d29429f1c0a951ac$var$SHA1.hmacStrength = 80;
$d29429f1c0a951ac$var$SHA1.padLength = 64;
$d29429f1c0a951ac$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $d29429f1c0a951ac$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $d29429f1c0a951ac$var$sum32_5($d29429f1c0a951ac$var$rotl32(a, 5), $d29429f1c0a951ac$var$ft_1(s, b, c, d), e, W[i], $d29429f1c0a951ac$var$sha1_K[s]);
        e = d;
        d = c;
        c = $d29429f1c0a951ac$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $d29429f1c0a951ac$var$sum32(this.h[0], a);
    this.h[1] = $d29429f1c0a951ac$var$sum32(this.h[1], b);
    this.h[2] = $d29429f1c0a951ac$var$sum32(this.h[2], c);
    this.h[3] = $d29429f1c0a951ac$var$sum32(this.h[3], d);
    this.h[4] = $d29429f1c0a951ac$var$sum32(this.h[4], e);
};
$d29429f1c0a951ac$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return $bxKYQ.toHex32(this.h, "big");
    else return $bxKYQ.split32(this.h, "big");
};

});
parcelRegister("clh35", function(module, exports) {

$parcel$export(module.exports, "ft_1", function () { return $8fc4abc25197f241$export$5a92649d7ddb9f63; }, function (v) { return $8fc4abc25197f241$export$5a92649d7ddb9f63 = v; });
$parcel$export(module.exports, "ch32", function () { return $8fc4abc25197f241$export$c6d0d020c3a6269; }, function (v) { return $8fc4abc25197f241$export$c6d0d020c3a6269 = v; });
$parcel$export(module.exports, "maj32", function () { return $8fc4abc25197f241$export$eb90c27fca05f956; }, function (v) { return $8fc4abc25197f241$export$eb90c27fca05f956 = v; });
$parcel$export(module.exports, "s0_256", function () { return $8fc4abc25197f241$export$14a4a98e063b1999; }, function (v) { return $8fc4abc25197f241$export$14a4a98e063b1999 = v; });
$parcel$export(module.exports, "s1_256", function () { return $8fc4abc25197f241$export$d20cecfa1564c686; }, function (v) { return $8fc4abc25197f241$export$d20cecfa1564c686 = v; });
$parcel$export(module.exports, "g0_256", function () { return $8fc4abc25197f241$export$44fd472a12fc6db; }, function (v) { return $8fc4abc25197f241$export$44fd472a12fc6db = v; });
$parcel$export(module.exports, "g1_256", function () { return $8fc4abc25197f241$export$1ed238bb6ea1dd47; }, function (v) { return $8fc4abc25197f241$export$1ed238bb6ea1dd47 = v; });
var $8fc4abc25197f241$export$5a92649d7ddb9f63;
var $8fc4abc25197f241$export$c6d0d020c3a6269;
var $8fc4abc25197f241$export$eb90c27fca05f956;
var $8fc4abc25197f241$export$cc992891a14496a1;
var $8fc4abc25197f241$export$14a4a98e063b1999;
var $8fc4abc25197f241$export$d20cecfa1564c686;
var $8fc4abc25197f241$export$44fd472a12fc6db;
var $8fc4abc25197f241$export$1ed238bb6ea1dd47;
"use strict";

var $bxKYQ = parcelRequire("bxKYQ");
var $8fc4abc25197f241$var$rotr32 = $bxKYQ.rotr32;
function $8fc4abc25197f241$var$ft_1(s, x, y, z) {
    if (s === 0) return $8fc4abc25197f241$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $8fc4abc25197f241$var$p32(x, y, z);
    if (s === 2) return $8fc4abc25197f241$var$maj32(x, y, z);
}
$8fc4abc25197f241$export$5a92649d7ddb9f63 = $8fc4abc25197f241$var$ft_1;
function $8fc4abc25197f241$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$8fc4abc25197f241$export$c6d0d020c3a6269 = $8fc4abc25197f241$var$ch32;
function $8fc4abc25197f241$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$8fc4abc25197f241$export$eb90c27fca05f956 = $8fc4abc25197f241$var$maj32;
function $8fc4abc25197f241$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$8fc4abc25197f241$export$cc992891a14496a1 = $8fc4abc25197f241$var$p32;
function $8fc4abc25197f241$var$s0_256(x) {
    return $8fc4abc25197f241$var$rotr32(x, 2) ^ $8fc4abc25197f241$var$rotr32(x, 13) ^ $8fc4abc25197f241$var$rotr32(x, 22);
}
$8fc4abc25197f241$export$14a4a98e063b1999 = $8fc4abc25197f241$var$s0_256;
function $8fc4abc25197f241$var$s1_256(x) {
    return $8fc4abc25197f241$var$rotr32(x, 6) ^ $8fc4abc25197f241$var$rotr32(x, 11) ^ $8fc4abc25197f241$var$rotr32(x, 25);
}
$8fc4abc25197f241$export$d20cecfa1564c686 = $8fc4abc25197f241$var$s1_256;
function $8fc4abc25197f241$var$g0_256(x) {
    return $8fc4abc25197f241$var$rotr32(x, 7) ^ $8fc4abc25197f241$var$rotr32(x, 18) ^ x >>> 3;
}
$8fc4abc25197f241$export$44fd472a12fc6db = $8fc4abc25197f241$var$g0_256;
function $8fc4abc25197f241$var$g1_256(x) {
    return $8fc4abc25197f241$var$rotr32(x, 17) ^ $8fc4abc25197f241$var$rotr32(x, 19) ^ x >>> 10;
}
$8fc4abc25197f241$export$1ed238bb6ea1dd47 = $8fc4abc25197f241$var$g1_256;

});


parcelRegister("e6IrM", function(module, exports) {
"use strict";

var $bxKYQ = parcelRequire("bxKYQ");

var $6tIqG = parcelRequire("6tIqG");
function $a4541a7e4b763d42$var$SHA224() {
    if (!(this instanceof $a4541a7e4b763d42$var$SHA224)) return new $a4541a7e4b763d42$var$SHA224();
    $6tIqG.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$bxKYQ.inherits($a4541a7e4b763d42$var$SHA224, $6tIqG);
module.exports = $a4541a7e4b763d42$var$SHA224;
$a4541a7e4b763d42$var$SHA224.blockSize = 512;
$a4541a7e4b763d42$var$SHA224.outSize = 224;
$a4541a7e4b763d42$var$SHA224.hmacStrength = 192;
$a4541a7e4b763d42$var$SHA224.padLength = 64;
$a4541a7e4b763d42$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return $bxKYQ.toHex32(this.h.slice(0, 7), "big");
    else return $bxKYQ.split32(this.h.slice(0, 7), "big");
};

});
parcelRegister("6tIqG", function(module, exports) {
"use strict";

var $bxKYQ = parcelRequire("bxKYQ");

var $hImYp = parcelRequire("hImYp");

var $clh35 = parcelRequire("clh35");

var $7WVV2 = parcelRequire("7WVV2");
var $4b77ea42209547a5$var$sum32 = $bxKYQ.sum32;
var $4b77ea42209547a5$var$sum32_4 = $bxKYQ.sum32_4;
var $4b77ea42209547a5$var$sum32_5 = $bxKYQ.sum32_5;
var $4b77ea42209547a5$var$ch32 = $clh35.ch32;
var $4b77ea42209547a5$var$maj32 = $clh35.maj32;
var $4b77ea42209547a5$var$s0_256 = $clh35.s0_256;
var $4b77ea42209547a5$var$s1_256 = $clh35.s1_256;
var $4b77ea42209547a5$var$g0_256 = $clh35.g0_256;
var $4b77ea42209547a5$var$g1_256 = $clh35.g1_256;
var $4b77ea42209547a5$var$BlockHash = $hImYp.BlockHash;
var $4b77ea42209547a5$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $4b77ea42209547a5$var$SHA256() {
    if (!(this instanceof $4b77ea42209547a5$var$SHA256)) return new $4b77ea42209547a5$var$SHA256();
    $4b77ea42209547a5$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $4b77ea42209547a5$var$sha256_K;
    this.W = new Array(64);
}
$bxKYQ.inherits($4b77ea42209547a5$var$SHA256, $4b77ea42209547a5$var$BlockHash);
module.exports = $4b77ea42209547a5$var$SHA256;
$4b77ea42209547a5$var$SHA256.blockSize = 512;
$4b77ea42209547a5$var$SHA256.outSize = 256;
$4b77ea42209547a5$var$SHA256.hmacStrength = 192;
$4b77ea42209547a5$var$SHA256.padLength = 64;
$4b77ea42209547a5$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $4b77ea42209547a5$var$sum32_4($4b77ea42209547a5$var$g1_256(W[i - 2]), W[i - 7], $4b77ea42209547a5$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $7WVV2(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $4b77ea42209547a5$var$sum32_5(h, $4b77ea42209547a5$var$s1_256(e), $4b77ea42209547a5$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $4b77ea42209547a5$var$sum32($4b77ea42209547a5$var$s0_256(a), $4b77ea42209547a5$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $4b77ea42209547a5$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $4b77ea42209547a5$var$sum32(T1, T2);
    }
    this.h[0] = $4b77ea42209547a5$var$sum32(this.h[0], a);
    this.h[1] = $4b77ea42209547a5$var$sum32(this.h[1], b);
    this.h[2] = $4b77ea42209547a5$var$sum32(this.h[2], c);
    this.h[3] = $4b77ea42209547a5$var$sum32(this.h[3], d);
    this.h[4] = $4b77ea42209547a5$var$sum32(this.h[4], e);
    this.h[5] = $4b77ea42209547a5$var$sum32(this.h[5], f);
    this.h[6] = $4b77ea42209547a5$var$sum32(this.h[6], g);
    this.h[7] = $4b77ea42209547a5$var$sum32(this.h[7], h);
};
$4b77ea42209547a5$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return $bxKYQ.toHex32(this.h, "big");
    else return $bxKYQ.split32(this.h, "big");
};

});


parcelRegister("kmwi1", function(module, exports) {
"use strict";

var $bxKYQ = parcelRequire("bxKYQ");

var $bVmxl = parcelRequire("bVmxl");
function $ed2ee8cb8518db64$var$SHA384() {
    if (!(this instanceof $ed2ee8cb8518db64$var$SHA384)) return new $ed2ee8cb8518db64$var$SHA384();
    $bVmxl.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$bxKYQ.inherits($ed2ee8cb8518db64$var$SHA384, $bVmxl);
module.exports = $ed2ee8cb8518db64$var$SHA384;
$ed2ee8cb8518db64$var$SHA384.blockSize = 1024;
$ed2ee8cb8518db64$var$SHA384.outSize = 384;
$ed2ee8cb8518db64$var$SHA384.hmacStrength = 192;
$ed2ee8cb8518db64$var$SHA384.padLength = 128;
$ed2ee8cb8518db64$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return $bxKYQ.toHex32(this.h.slice(0, 12), "big");
    else return $bxKYQ.split32(this.h.slice(0, 12), "big");
};

});
parcelRegister("bVmxl", function(module, exports) {
"use strict";

var $bxKYQ = parcelRequire("bxKYQ");

var $hImYp = parcelRequire("hImYp");

var $7WVV2 = parcelRequire("7WVV2");
var $8ae67ff153ff2587$var$rotr64_hi = $bxKYQ.rotr64_hi;
var $8ae67ff153ff2587$var$rotr64_lo = $bxKYQ.rotr64_lo;
var $8ae67ff153ff2587$var$shr64_hi = $bxKYQ.shr64_hi;
var $8ae67ff153ff2587$var$shr64_lo = $bxKYQ.shr64_lo;
var $8ae67ff153ff2587$var$sum64 = $bxKYQ.sum64;
var $8ae67ff153ff2587$var$sum64_hi = $bxKYQ.sum64_hi;
var $8ae67ff153ff2587$var$sum64_lo = $bxKYQ.sum64_lo;
var $8ae67ff153ff2587$var$sum64_4_hi = $bxKYQ.sum64_4_hi;
var $8ae67ff153ff2587$var$sum64_4_lo = $bxKYQ.sum64_4_lo;
var $8ae67ff153ff2587$var$sum64_5_hi = $bxKYQ.sum64_5_hi;
var $8ae67ff153ff2587$var$sum64_5_lo = $bxKYQ.sum64_5_lo;
var $8ae67ff153ff2587$var$BlockHash = $hImYp.BlockHash;
var $8ae67ff153ff2587$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $8ae67ff153ff2587$var$SHA512() {
    if (!(this instanceof $8ae67ff153ff2587$var$SHA512)) return new $8ae67ff153ff2587$var$SHA512();
    $8ae67ff153ff2587$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $8ae67ff153ff2587$var$sha512_K;
    this.W = new Array(160);
}
$bxKYQ.inherits($8ae67ff153ff2587$var$SHA512, $8ae67ff153ff2587$var$BlockHash);
module.exports = $8ae67ff153ff2587$var$SHA512;
$8ae67ff153ff2587$var$SHA512.blockSize = 1024;
$8ae67ff153ff2587$var$SHA512.outSize = 512;
$8ae67ff153ff2587$var$SHA512.hmacStrength = 192;
$8ae67ff153ff2587$var$SHA512.padLength = 128;
$8ae67ff153ff2587$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $8ae67ff153ff2587$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $8ae67ff153ff2587$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $8ae67ff153ff2587$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $8ae67ff153ff2587$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $8ae67ff153ff2587$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $8ae67ff153ff2587$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$8ae67ff153ff2587$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $7WVV2(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $8ae67ff153ff2587$var$s1_512_hi(eh, el);
        var c1_lo = $8ae67ff153ff2587$var$s1_512_lo(eh, el);
        var c2_hi = $8ae67ff153ff2587$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $8ae67ff153ff2587$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $8ae67ff153ff2587$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $8ae67ff153ff2587$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $8ae67ff153ff2587$var$s0_512_hi(ah, al);
        c0_lo = $8ae67ff153ff2587$var$s0_512_lo(ah, al);
        c1_hi = $8ae67ff153ff2587$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $8ae67ff153ff2587$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $8ae67ff153ff2587$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $8ae67ff153ff2587$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $8ae67ff153ff2587$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $8ae67ff153ff2587$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $8ae67ff153ff2587$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $8ae67ff153ff2587$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $8ae67ff153ff2587$var$sum64(this.h, 0, ah, al);
    $8ae67ff153ff2587$var$sum64(this.h, 2, bh, bl);
    $8ae67ff153ff2587$var$sum64(this.h, 4, ch, cl);
    $8ae67ff153ff2587$var$sum64(this.h, 6, dh, dl);
    $8ae67ff153ff2587$var$sum64(this.h, 8, eh, el);
    $8ae67ff153ff2587$var$sum64(this.h, 10, fh, fl);
    $8ae67ff153ff2587$var$sum64(this.h, 12, gh, gl);
    $8ae67ff153ff2587$var$sum64(this.h, 14, hh, hl);
};
$8ae67ff153ff2587$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return $bxKYQ.toHex32(this.h, "big");
    else return $bxKYQ.split32(this.h, "big");
};
function $8ae67ff153ff2587$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $8ae67ff153ff2587$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $8ae67ff153ff2587$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $8ae67ff153ff2587$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $8ae67ff153ff2587$var$s0_512_hi(xh, xl) {
    var c0_hi = $8ae67ff153ff2587$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $8ae67ff153ff2587$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $8ae67ff153ff2587$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $8ae67ff153ff2587$var$s0_512_lo(xh, xl) {
    var c0_lo = $8ae67ff153ff2587$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $8ae67ff153ff2587$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $8ae67ff153ff2587$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $8ae67ff153ff2587$var$s1_512_hi(xh, xl) {
    var c0_hi = $8ae67ff153ff2587$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $8ae67ff153ff2587$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $8ae67ff153ff2587$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $8ae67ff153ff2587$var$s1_512_lo(xh, xl) {
    var c0_lo = $8ae67ff153ff2587$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $8ae67ff153ff2587$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $8ae67ff153ff2587$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $8ae67ff153ff2587$var$g0_512_hi(xh, xl) {
    var c0_hi = $8ae67ff153ff2587$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $8ae67ff153ff2587$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $8ae67ff153ff2587$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $8ae67ff153ff2587$var$g0_512_lo(xh, xl) {
    var c0_lo = $8ae67ff153ff2587$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $8ae67ff153ff2587$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $8ae67ff153ff2587$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $8ae67ff153ff2587$var$g1_512_hi(xh, xl) {
    var c0_hi = $8ae67ff153ff2587$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $8ae67ff153ff2587$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $8ae67ff153ff2587$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $8ae67ff153ff2587$var$g1_512_lo(xh, xl) {
    var c0_lo = $8ae67ff153ff2587$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $8ae67ff153ff2587$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $8ae67ff153ff2587$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("6xyjW", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $4c3072866331e23e$export$d1cea0ee4e3f0d3e; }, function (v) { return $4c3072866331e23e$export$d1cea0ee4e3f0d3e = v; });
var $4c3072866331e23e$export$d1cea0ee4e3f0d3e;
"use strict";

var $bxKYQ = parcelRequire("bxKYQ");

var $hImYp = parcelRequire("hImYp");
var $4c3072866331e23e$var$rotl32 = $bxKYQ.rotl32;
var $4c3072866331e23e$var$sum32 = $bxKYQ.sum32;
var $4c3072866331e23e$var$sum32_3 = $bxKYQ.sum32_3;
var $4c3072866331e23e$var$sum32_4 = $bxKYQ.sum32_4;
var $4c3072866331e23e$var$BlockHash = $hImYp.BlockHash;
function $4c3072866331e23e$var$RIPEMD160() {
    if (!(this instanceof $4c3072866331e23e$var$RIPEMD160)) return new $4c3072866331e23e$var$RIPEMD160();
    $4c3072866331e23e$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
$bxKYQ.inherits($4c3072866331e23e$var$RIPEMD160, $4c3072866331e23e$var$BlockHash);
$4c3072866331e23e$export$d1cea0ee4e3f0d3e = $4c3072866331e23e$var$RIPEMD160;
$4c3072866331e23e$var$RIPEMD160.blockSize = 512;
$4c3072866331e23e$var$RIPEMD160.outSize = 160;
$4c3072866331e23e$var$RIPEMD160.hmacStrength = 192;
$4c3072866331e23e$var$RIPEMD160.padLength = 64;
$4c3072866331e23e$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $4c3072866331e23e$var$sum32($4c3072866331e23e$var$rotl32($4c3072866331e23e$var$sum32_4(A, $4c3072866331e23e$var$f(j, B, C, D), msg[$4c3072866331e23e$var$r[j] + start], $4c3072866331e23e$var$K(j)), $4c3072866331e23e$var$s[j]), E);
        A = E;
        E = D;
        D = $4c3072866331e23e$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $4c3072866331e23e$var$sum32($4c3072866331e23e$var$rotl32($4c3072866331e23e$var$sum32_4(Ah, $4c3072866331e23e$var$f(79 - j, Bh, Ch, Dh), msg[$4c3072866331e23e$var$rh[j] + start], $4c3072866331e23e$var$Kh(j)), $4c3072866331e23e$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $4c3072866331e23e$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $4c3072866331e23e$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $4c3072866331e23e$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $4c3072866331e23e$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $4c3072866331e23e$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $4c3072866331e23e$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$4c3072866331e23e$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return $bxKYQ.toHex32(this.h, "little");
    else return $bxKYQ.split32(this.h, "little");
};
function $4c3072866331e23e$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $4c3072866331e23e$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $4c3072866331e23e$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $4c3072866331e23e$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $4c3072866331e23e$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $4c3072866331e23e$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $4c3072866331e23e$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("cMrGk", function(module, exports) {
"use strict";

var $bxKYQ = parcelRequire("bxKYQ");

var $7WVV2 = parcelRequire("7WVV2");
function $94df70b96f2baa06$var$Hmac(hash, key, enc) {
    if (!(this instanceof $94df70b96f2baa06$var$Hmac)) return new $94df70b96f2baa06$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($bxKYQ.toArray(key, enc));
}
module.exports = $94df70b96f2baa06$var$Hmac;
$94df70b96f2baa06$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $7WVV2(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$94df70b96f2baa06$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$94df70b96f2baa06$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("9TncA", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
            ],
            [
                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
            ],
            [
                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
            ],
            [
                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
            ],
            [
                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
            ],
            [
                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
            ],
            [
                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
            ],
            [
                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
            ],
            [
                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
            ],
            [
                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
            ],
            [
                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
            ],
            [
                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
            ],
            [
                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
            ],
            [
                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
            ],
            [
                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
            ],
            [
                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
            ],
            [
                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
            ],
            [
                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
            ],
            [
                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
            ],
            [
                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
            ],
            [
                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
            ],
            [
                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
            ],
            [
                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
            ],
            [
                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
            ],
            [
                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
            ],
            [
                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
            ],
            [
                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
            ],
            [
                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
            ],
            [
                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
            ],
            [
                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
            ],
            [
                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
            ],
            [
                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
            ],
            [
                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
            ],
            [
                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
            ],
            [
                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
            ],
            [
                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
            ],
            [
                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
            ],
            [
                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
            ],
            [
                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
            ],
            [
                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
            ],
            [
                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
            ],
            [
                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
            ],
            [
                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
            ],
            [
                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
            ],
            [
                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
            ],
            [
                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
            ],
            [
                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
            ],
            [
                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
            ],
            [
                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
            ],
            [
                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
            ],
            [
                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
            ],
            [
                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
            ],
            [
                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
            ],
            [
                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
            ],
            [
                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
            ],
            [
                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
            ],
            [
                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
            ],
            [
                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
            ],
            [
                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
            ],
            [
                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
            ],
            [
                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
            ],
            [
                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
            ],
            [
                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
            ],
            [
                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
            ],
            [
                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
            ],
            [
                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
            ],
            [
                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
            ],
            [
                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
            ],
            [
                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
            ],
            [
                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
            ],
            [
                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
            ],
            [
                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
            ],
            [
                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
            ],
            [
                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
            ],
            [
                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
            ],
            [
                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
            ],
            [
                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
            ],
            [
                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
            ],
            [
                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
            ],
            [
                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
            ],
            [
                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
            ],
            [
                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
            ],
            [
                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
            ],
            [
                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
            ],
            [
                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
            ],
            [
                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
            ],
            [
                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
            ],
            [
                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
            ],
            [
                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
            ],
            [
                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
            ],
            [
                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
            ],
            [
                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
            ],
            [
                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
            ],
            [
                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
            ],
            [
                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
            ],
            [
                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
            ],
            [
                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
            ],
            [
                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
            ],
            [
                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
            ],
            [
                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
            ],
            [
                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
            ],
            [
                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
            ],
            [
                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
            ],
            [
                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
            ],
            [
                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
            ],
            [
                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
            ],
            [
                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
            ],
            [
                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
            ],
            [
                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
            ],
            [
                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
            ],
            [
                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
            ],
            [
                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
            ],
            [
                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
            ],
            [
                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
            ],
            [
                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
            ],
            [
                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
            ],
            [
                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
            ],
            [
                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
            ],
            [
                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
            ],
            [
                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
            ],
            [
                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
            ],
            [
                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
            ],
            [
                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
            ],
            [
                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
            ],
            [
                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
            ],
            [
                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
            ],
            [
                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
            ],
            [
                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
            ],
            [
                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
            ],
            [
                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
            ],
            [
                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
            ],
            [
                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
            ],
            [
                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
            ],
            [
                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
            ],
            [
                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
            ],
            [
                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
            ],
            [
                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
            ],
            [
                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
            ],
            [
                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
            ],
            [
                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
            ],
            [
                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
            ],
            [
                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
            ],
            [
                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
            ],
            [
                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
            ],
            [
                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
            ],
            [
                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
            ],
            [
                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
            ],
            [
                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
            ],
            [
                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
            ],
            [
                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
            ],
            [
                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
            ],
            [
                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
            ],
            [
                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
            ],
            [
                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
            ],
            [
                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
            ],
            [
                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
            ],
            [
                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
            ],
            [
                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
            ],
            [
                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
            ],
            [
                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
            ],
            [
                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
            ],
            [
                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
            ],
            [
                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
            ],
            [
                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
            ],
            [
                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
            ],
            [
                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
            ],
            [
                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
            ],
            [
                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
            ],
            [
                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
            ],
            [
                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
            ],
            [
                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
            ],
            [
                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
            ],
            [
                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
            ],
            [
                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
            ],
            [
                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
            ],
            [
                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
            ],
            [
                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
            ],
            [
                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
            ],
            [
                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
            ],
            [
                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
            ],
            [
                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
            ],
            [
                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
            ],
            [
                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
            ],
            [
                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
            ],
            [
                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
            ],
            [
                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
            ],
            [
                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
            ],
            [
                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
            ],
            [
                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
            ],
            [
                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
            ],
            [
                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
            ]
        ]
    }
};

});


parcelRegister("fGaGJ", function(module, exports) {
"use strict";

var $3wGZr = parcelRequire("3wGZr");

var $4ICjl = parcelRequire("4ICjl");

var $4OvZ4 = parcelRequire("4OvZ4");

var $dG5bA = parcelRequire("dG5bA");

var $iuHvy = parcelRequire("iuHvy");
var $b6a311b8d0e8cc20$var$assert = $4OvZ4.assert;

var $c6vd1 = parcelRequire("c6vd1");

var $kJete = parcelRequire("kJete");
function $b6a311b8d0e8cc20$var$EC(options) {
    if (!(this instanceof $b6a311b8d0e8cc20$var$EC)) return new $b6a311b8d0e8cc20$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $b6a311b8d0e8cc20$var$assert(Object.prototype.hasOwnProperty.call($dG5bA, options), "Unknown curve " + options);
        options = $dG5bA[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $dG5bA.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $b6a311b8d0e8cc20$var$EC;
$b6a311b8d0e8cc20$var$EC.prototype.keyPair = function keyPair(options) {
    return new $c6vd1(this, options);
};
$b6a311b8d0e8cc20$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $c6vd1.fromPrivate(this, priv, enc);
};
$b6a311b8d0e8cc20$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $c6vd1.fromPublic(this, pub, enc);
};
$b6a311b8d0e8cc20$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $4ICjl({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $iuHvy(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $3wGZr(2));
    for(;;){
        var priv = new $3wGZr(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$b6a311b8d0e8cc20$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$b6a311b8d0e8cc20$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new $3wGZr(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $4ICjl({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $3wGZr(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $3wGZr(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $kJete({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$b6a311b8d0e8cc20$var$EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new $3wGZr(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new $kJete(signature, "hex");
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$b6a311b8d0e8cc20$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $b6a311b8d0e8cc20$var$assert((3 & j) === j, "The recovery param is more than two bits");
    signature = new $kJete(signature, enc);
    var n = this.n;
    var e = new $3wGZr(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$b6a311b8d0e8cc20$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $kJete(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};

});
parcelRegister("4ICjl", function(module, exports) {
"use strict";

var $2eq8E = parcelRequire("2eq8E");

var $dAFlY = parcelRequire("dAFlY");

var $7WVV2 = parcelRequire("7WVV2");
function $36f8fd3aefd3d562$var$HmacDRBG(options) {
    if (!(this instanceof $36f8fd3aefd3d562$var$HmacDRBG)) return new $36f8fd3aefd3d562$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $dAFlY.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $dAFlY.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $dAFlY.toArray(options.pers, options.persEnc || "hex");
    $7WVV2(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
module.exports = $36f8fd3aefd3d562$var$HmacDRBG;
$36f8fd3aefd3d562$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$36f8fd3aefd3d562$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $2eq8E.hmac(this.hash, this.K);
};
$36f8fd3aefd3d562$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$36f8fd3aefd3d562$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $dAFlY.toArray(entropy, entropyEnc);
    add = $dAFlY.toArray(add, addEnc);
    $7WVV2(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$36f8fd3aefd3d562$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $dAFlY.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $dAFlY.encode(res, enc);
};

});

parcelRegister("c6vd1", function(module, exports) {
"use strict";

var $3wGZr = parcelRequire("3wGZr");

var $4OvZ4 = parcelRequire("4OvZ4");
var $8cfe410d5ce89c9a$var$assert = $4OvZ4.assert;
function $8cfe410d5ce89c9a$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $8cfe410d5ce89c9a$var$KeyPair;
$8cfe410d5ce89c9a$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $8cfe410d5ce89c9a$var$KeyPair) return pub;
    return new $8cfe410d5ce89c9a$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$8cfe410d5ce89c9a$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $8cfe410d5ce89c9a$var$KeyPair) return priv;
    return new $8cfe410d5ce89c9a$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$8cfe410d5ce89c9a$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$8cfe410d5ce89c9a$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$8cfe410d5ce89c9a$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$8cfe410d5ce89c9a$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $3wGZr(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$8cfe410d5ce89c9a$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $8cfe410d5ce89c9a$var$assert(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $8cfe410d5ce89c9a$var$assert(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$8cfe410d5ce89c9a$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $8cfe410d5ce89c9a$var$assert(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$8cfe410d5ce89c9a$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$8cfe410d5ce89c9a$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$8cfe410d5ce89c9a$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};

});

parcelRegister("kJete", function(module, exports) {
"use strict";

var $3wGZr = parcelRequire("3wGZr");

var $4OvZ4 = parcelRequire("4OvZ4");
var $f1733c287b88a42d$var$assert = $4OvZ4.assert;
function $f1733c287b88a42d$var$Signature(options, enc) {
    if (options instanceof $f1733c287b88a42d$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $f1733c287b88a42d$var$assert(options.r && options.s, "Signature without r or s");
    this.r = new $3wGZr(options.r, 16);
    this.s = new $3wGZr(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $f1733c287b88a42d$var$Signature;
function $f1733c287b88a42d$var$Position() {
    this.place = 0;
}
function $f1733c287b88a42d$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    if (buf[p.place] === 0x00) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $f1733c287b88a42d$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$f1733c287b88a42d$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $4OvZ4.toArray(data, enc);
    var p = new $f1733c287b88a42d$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $f1733c287b88a42d$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $f1733c287b88a42d$var$getLength(data, p);
    if (rlen === false) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $f1733c287b88a42d$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $3wGZr(r);
    this.s = new $3wGZr(s);
    this.recoveryParam = null;
    return true;
};
function $f1733c287b88a42d$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$f1733c287b88a42d$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $f1733c287b88a42d$var$rmPadding(r);
    s = $f1733c287b88a42d$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $f1733c287b88a42d$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $f1733c287b88a42d$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $f1733c287b88a42d$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $4OvZ4.encode(res, enc);
};

});


parcelRegister("h9ZEV", function(module, exports) {
"use strict";

var $2eq8E = parcelRequire("2eq8E");

var $dG5bA = parcelRequire("dG5bA");

var $4OvZ4 = parcelRequire("4OvZ4");
var $c7e31b1f62dd2632$var$assert = $4OvZ4.assert;
var $c7e31b1f62dd2632$var$parseBytes = $4OvZ4.parseBytes;

var $4Y9Yr = parcelRequire("4Y9Yr");

var $9muLt = parcelRequire("9muLt");
function $c7e31b1f62dd2632$var$EDDSA(curve) {
    $c7e31b1f62dd2632$var$assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof $c7e31b1f62dd2632$var$EDDSA)) return new $c7e31b1f62dd2632$var$EDDSA(curve);
    curve = $dG5bA[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $2eq8E.sha512;
}
module.exports = $c7e31b1f62dd2632$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $c7e31b1f62dd2632$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $c7e31b1f62dd2632$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $c7e31b1f62dd2632$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $c7e31b1f62dd2632$var$parseBytes(message);
    sig = this.makeSignature(sig);
    if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) return false;
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$c7e31b1f62dd2632$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $4OvZ4.intFromLE(hash.digest()).umod(this.curve.n);
};
$c7e31b1f62dd2632$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $4Y9Yr.fromPublic(this, pub);
};
$c7e31b1f62dd2632$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $4Y9Yr.fromSecret(this, secret);
};
$c7e31b1f62dd2632$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $9muLt) return sig;
    return new $9muLt(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $c7e31b1f62dd2632$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$c7e31b1f62dd2632$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $4OvZ4.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $4OvZ4.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$c7e31b1f62dd2632$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
$c7e31b1f62dd2632$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $4OvZ4.intFromLE(bytes);
};
$c7e31b1f62dd2632$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("4Y9Yr", function(module, exports) {
"use strict";

var $4OvZ4 = parcelRequire("4OvZ4");
var $39e480a1bf1698dd$var$assert = $4OvZ4.assert;
var $39e480a1bf1698dd$var$parseBytes = $4OvZ4.parseBytes;
var $39e480a1bf1698dd$var$cachedProperty = $4OvZ4.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $39e480a1bf1698dd$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $39e480a1bf1698dd$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $39e480a1bf1698dd$var$parseBytes(params.pub);
}
$39e480a1bf1698dd$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $39e480a1bf1698dd$var$KeyPair) return pub;
    return new $39e480a1bf1698dd$var$KeyPair(eddsa, {
        pub: pub
    });
};
$39e480a1bf1698dd$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $39e480a1bf1698dd$var$KeyPair) return secret;
    return new $39e480a1bf1698dd$var$KeyPair(eddsa, {
        secret: secret
    });
};
$39e480a1bf1698dd$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$39e480a1bf1698dd$var$cachedProperty($39e480a1bf1698dd$var$KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$39e480a1bf1698dd$var$cachedProperty($39e480a1bf1698dd$var$KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$39e480a1bf1698dd$var$cachedProperty($39e480a1bf1698dd$var$KeyPair, "privBytes", function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$39e480a1bf1698dd$var$cachedProperty($39e480a1bf1698dd$var$KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$39e480a1bf1698dd$var$cachedProperty($39e480a1bf1698dd$var$KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$39e480a1bf1698dd$var$cachedProperty($39e480a1bf1698dd$var$KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$39e480a1bf1698dd$var$KeyPair.prototype.sign = function sign(message) {
    $39e480a1bf1698dd$var$assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
$39e480a1bf1698dd$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$39e480a1bf1698dd$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $39e480a1bf1698dd$var$assert(this._secret, "KeyPair is public only");
    return $4OvZ4.encode(this.secret(), enc);
};
$39e480a1bf1698dd$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $4OvZ4.encode(this.pubBytes(), enc);
};
module.exports = $39e480a1bf1698dd$var$KeyPair;

});

parcelRegister("9muLt", function(module, exports) {
"use strict";

var $3wGZr = parcelRequire("3wGZr");

var $4OvZ4 = parcelRequire("4OvZ4");
var $6d0e08567e95a27b$var$assert = $4OvZ4.assert;
var $6d0e08567e95a27b$var$cachedProperty = $4OvZ4.cachedProperty;
var $6d0e08567e95a27b$var$parseBytes = $4OvZ4.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $6d0e08567e95a27b$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== "object") sig = $6d0e08567e95a27b$var$parseBytes(sig);
    if (Array.isArray(sig)) {
        $6d0e08567e95a27b$var$assert(sig.length === eddsa.encodingLength * 2, "Signature has invalid size");
        sig = {
            R: sig.slice(0, eddsa.encodingLength),
            S: sig.slice(eddsa.encodingLength)
        };
    }
    $6d0e08567e95a27b$var$assert(sig.R && sig.S, "Signature without R or S");
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $3wGZr) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$6d0e08567e95a27b$var$cachedProperty($6d0e08567e95a27b$var$Signature, "S", function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$6d0e08567e95a27b$var$cachedProperty($6d0e08567e95a27b$var$Signature, "R", function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$6d0e08567e95a27b$var$cachedProperty($6d0e08567e95a27b$var$Signature, "Rencoded", function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$6d0e08567e95a27b$var$cachedProperty($6d0e08567e95a27b$var$Signature, "Sencoded", function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$6d0e08567e95a27b$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$6d0e08567e95a27b$var$Signature.prototype.toHex = function toHex() {
    return $4OvZ4.encode(this.toBytes(), "hex").toUpperCase();
};
module.exports = $6d0e08567e95a27b$var$Signature;

});



parcelRegister("25PiQ", function(module, exports) {
$parcel$export(module.exports, "generateKeyPair", function () { return (parcelRequire("hpTaI")).generateKeyPair; });
$parcel$export(module.exports, "signJWT", function () { return (parcelRequire("hpTaI")).signJWT; });
$parcel$export(module.exports, "decodeJWT", function () { return (parcelRequire("kGjpT")).decodeJWT; });
$parcel$export(module.exports, "encodeIss", function () { return (parcelRequire("kGjpT")).encodeIss; });
parcelRequire("hpTaI");
parcelRequire("6HkgD");

var $6XG8a = parcelRequire("6XG8a");
parcelRequire("kGjpT");
$parcel$exportWildcard(module.exports, $6XG8a);

});
parcelRegister("hpTaI", function(module, exports) {

$parcel$export(module.exports, "generateKeyPair", function () { return $cadf91703f0340cd$export$a949d36eab55b41f; });
$parcel$export(module.exports, "signJWT", function () { return $cadf91703f0340cd$export$a8dda30659d36d45; });

var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $2CFK4 = parcelRequire("2CFK4");

var $5A0yG = parcelRequire("5A0yG");

var $4BEBs = parcelRequire("4BEBs");

var $6HkgD = parcelRequire("6HkgD");

var $kGjpT = parcelRequire("kGjpT");
function $cadf91703f0340cd$export$a949d36eab55b41f() {
    var seed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $5A0yG.randomBytes)((0, $6HkgD.KEY_PAIR_SEED_LENGTH));
    return $2CFK4.generateKeyPairFromSeed(seed);
}
function $cadf91703f0340cd$export$a8dda30659d36d45(sub, aud, ttl, keyPair) {
    return $cadf91703f0340cd$var$_signJWT.apply(this, arguments);
}
function $cadf91703f0340cd$var$_signJWT() {
    $cadf91703f0340cd$var$_signJWT = (0, $kSuI9._)(function(sub, aud, ttl, keyPair) {
        var iat, header, iss, exp, payload, data, signature;
        var _arguments = arguments;
        return (0, $eha6O.__generator)(this, function(_state) {
            iat = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : (0, $4BEBs.fromMiliseconds)(Date.now());
            header = {
                alg: (0, $6HkgD.JWT_IRIDIUM_ALG),
                typ: (0, $6HkgD.JWT_IRIDIUM_TYP)
            };
            iss = (0, $kGjpT.encodeIss)(keyPair.publicKey);
            exp = iat + ttl;
            payload = {
                iss: iss,
                sub: sub,
                aud: aud,
                iat: iat,
                exp: exp
            };
            data = (0, $kGjpT.encodeData)({
                header: header,
                payload: payload
            });
            signature = $2CFK4.sign(keyPair.secretKey, data);
            return [
                2,
                (0, $kGjpT.encodeJWT)({
                    header: header,
                    payload: payload,
                    signature: signature
                })
            ];
        });
    });
    return $cadf91703f0340cd$var$_signJWT.apply(this, arguments);
}
function $cadf91703f0340cd$export$7b6fc79aa8c5b79c(jwt) {
    return $cadf91703f0340cd$var$_verifyJWT.apply(this, arguments);
}
function $cadf91703f0340cd$var$_verifyJWT() {
    $cadf91703f0340cd$var$_verifyJWT = (0, $kSuI9._)(function(jwt) {
        var _decodeJWT, header, payload, data, signature, publicKey;
        return (0, $eha6O.__generator)(this, function(_state) {
            _decodeJWT = (0, $kGjpT.decodeJWT)(jwt), header = _decodeJWT.header, payload = _decodeJWT.payload, data = _decodeJWT.data, signature = _decodeJWT.signature;
            if (header.alg !== (0, $6HkgD.JWT_IRIDIUM_ALG) || header.typ !== (0, $6HkgD.JWT_IRIDIUM_TYP)) throw new Error("JWT must use EdDSA algorithm");
            publicKey = (0, $kGjpT.decodeIss)(payload.iss);
            return [
                2,
                $2CFK4.verify(publicKey, data, signature)
            ];
        });
    });
    return $cadf91703f0340cd$var$_verifyJWT.apply(this, arguments);
}

});
parcelRegister("2CFK4", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.convertSecretKeyToX25519 = module.exports.convertPublicKeyToX25519 = module.exports.verify = module.exports.sign = module.exports.extractPublicKeyFromSecretKey = module.exports.generateKeyPair = module.exports.generateKeyPairFromSeed = module.exports.SEED_LENGTH = module.exports.SECRET_KEY_LENGTH = module.exports.PUBLIC_KEY_LENGTH = module.exports.SIGNATURE_LENGTH = void 0;

var $5A0yG = parcelRequire("5A0yG");

var $dgPwm = parcelRequire("dgPwm");

var $1iHRq = parcelRequire("1iHRq");
module.exports.SIGNATURE_LENGTH = 64;
module.exports.PUBLIC_KEY_LENGTH = 32;
module.exports.SECRET_KEY_LENGTH = 64;
module.exports.SEED_LENGTH = 32;
// Returns new zero-filled 16-element GF (Float64Array).
// If passed an array of numbers, prefills the returned
// array with them.
//
// We use Float64Array, because we need 48-bit numbers
// for this implementation.
function $1e8f8280e95fd98d$var$gf(init) {
    var r = new Float64Array(16);
    if (init) for(var i = 0; i < init.length; i++)r[i] = init[i];
    return r;
}
// Base point.
var $1e8f8280e95fd98d$var$_9 = new Uint8Array(32);
$1e8f8280e95fd98d$var$_9[0] = 9;
var $1e8f8280e95fd98d$var$gf0 = $1e8f8280e95fd98d$var$gf();
var $1e8f8280e95fd98d$var$gf1 = $1e8f8280e95fd98d$var$gf([
    1
]);
var $1e8f8280e95fd98d$var$D = $1e8f8280e95fd98d$var$gf([
    0x78a3,
    0x1359,
    0x4dca,
    0x75eb,
    0xd8ab,
    0x4141,
    0x0a4d,
    0x0070,
    0xe898,
    0x7779,
    0x4079,
    0x8cc7,
    0xfe73,
    0x2b6f,
    0x6cee,
    0x5203
]);
var $1e8f8280e95fd98d$var$D2 = $1e8f8280e95fd98d$var$gf([
    0xf159,
    0x26b2,
    0x9b94,
    0xebd6,
    0xb156,
    0x8283,
    0x149a,
    0x00e0,
    0xd130,
    0xeef3,
    0x80f2,
    0x198e,
    0xfce7,
    0x56df,
    0xd9dc,
    0x2406
]);
var $1e8f8280e95fd98d$var$X = $1e8f8280e95fd98d$var$gf([
    0xd51a,
    0x8f25,
    0x2d60,
    0xc956,
    0xa7b2,
    0x9525,
    0xc760,
    0x692c,
    0xdc5c,
    0xfdd6,
    0xe231,
    0xc0a4,
    0x53fe,
    0xcd6e,
    0x36d3,
    0x2169
]);
var $1e8f8280e95fd98d$var$Y = $1e8f8280e95fd98d$var$gf([
    0x6658,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666
]);
var $1e8f8280e95fd98d$var$I = $1e8f8280e95fd98d$var$gf([
    0xa0b0,
    0x4a0e,
    0x1b27,
    0xc4ee,
    0xe478,
    0xad2f,
    0x1806,
    0x2f43,
    0xd7a7,
    0x3dfb,
    0x0099,
    0x2b4d,
    0xdf0b,
    0x4fc1,
    0x2480,
    0x2b83
]);
function $1e8f8280e95fd98d$var$set25519(r, a) {
    for(var i = 0; i < 16; i++)r[i] = a[i] | 0;
}
function $1e8f8280e95fd98d$var$car25519(o) {
    var c = 1;
    for(var i = 0; i < 16; i++){
        var v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
    }
    o[0] += c - 1 + 37 * (c - 1);
}
function $1e8f8280e95fd98d$var$sel25519(p, q, b) {
    var c = ~(b - 1);
    for(var i = 0; i < 16; i++){
        var t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function $1e8f8280e95fd98d$var$pack25519(o, n) {
    var m = $1e8f8280e95fd98d$var$gf();
    var t = $1e8f8280e95fd98d$var$gf();
    for(var i = 0; i < 16; i++)t[i] = n[i];
    $1e8f8280e95fd98d$var$car25519(t);
    $1e8f8280e95fd98d$var$car25519(t);
    $1e8f8280e95fd98d$var$car25519(t);
    for(var j = 0; j < 2; j++){
        m[0] = t[0] - 0xffed;
        for(var i1 = 1; i1 < 15; i1++){
            m[i1] = t[i1] - 0xffff - (m[i1 - 1] >> 16 & 1);
            m[i1 - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
        var b = m[15] >> 16 & 1;
        m[14] &= 0xffff;
        $1e8f8280e95fd98d$var$sel25519(t, m, 1 - b);
    }
    for(var i2 = 0; i2 < 16; i2++){
        o[2 * i2] = t[i2] & 0xff;
        o[2 * i2 + 1] = t[i2] >> 8;
    }
}
function $1e8f8280e95fd98d$var$verify32(x, y) {
    var d = 0;
    for(var i = 0; i < 32; i++)d |= x[i] ^ y[i];
    return (1 & d - 1 >>> 8) - 1;
}
function $1e8f8280e95fd98d$var$neq25519(a, b) {
    var c = new Uint8Array(32);
    var d = new Uint8Array(32);
    $1e8f8280e95fd98d$var$pack25519(c, a);
    $1e8f8280e95fd98d$var$pack25519(d, b);
    return $1e8f8280e95fd98d$var$verify32(c, d);
}
function $1e8f8280e95fd98d$var$par25519(a) {
    var d = new Uint8Array(32);
    $1e8f8280e95fd98d$var$pack25519(d, a);
    return d[0] & 1;
}
function $1e8f8280e95fd98d$var$unpack25519(o, n) {
    for(var i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function $1e8f8280e95fd98d$var$add(o, a, b) {
    for(var i = 0; i < 16; i++)o[i] = a[i] + b[i];
}
function $1e8f8280e95fd98d$var$sub(o, a, b) {
    for(var i = 0; i < 16; i++)o[i] = a[i] - b[i];
}
function $1e8f8280e95fd98d$var$mul(o, a, b) {
    var v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    v = a[0];
    t0 += v * b0;
    t1 += v * b1;
    t2 += v * b2;
    t3 += v * b3;
    t4 += v * b4;
    t5 += v * b5;
    t6 += v * b6;
    t7 += v * b7;
    t8 += v * b8;
    t9 += v * b9;
    t10 += v * b10;
    t11 += v * b11;
    t12 += v * b12;
    t13 += v * b13;
    t14 += v * b14;
    t15 += v * b15;
    v = a[1];
    t1 += v * b0;
    t2 += v * b1;
    t3 += v * b2;
    t4 += v * b3;
    t5 += v * b4;
    t6 += v * b5;
    t7 += v * b6;
    t8 += v * b7;
    t9 += v * b8;
    t10 += v * b9;
    t11 += v * b10;
    t12 += v * b11;
    t13 += v * b12;
    t14 += v * b13;
    t15 += v * b14;
    t16 += v * b15;
    v = a[2];
    t2 += v * b0;
    t3 += v * b1;
    t4 += v * b2;
    t5 += v * b3;
    t6 += v * b4;
    t7 += v * b5;
    t8 += v * b6;
    t9 += v * b7;
    t10 += v * b8;
    t11 += v * b9;
    t12 += v * b10;
    t13 += v * b11;
    t14 += v * b12;
    t15 += v * b13;
    t16 += v * b14;
    t17 += v * b15;
    v = a[3];
    t3 += v * b0;
    t4 += v * b1;
    t5 += v * b2;
    t6 += v * b3;
    t7 += v * b4;
    t8 += v * b5;
    t9 += v * b6;
    t10 += v * b7;
    t11 += v * b8;
    t12 += v * b9;
    t13 += v * b10;
    t14 += v * b11;
    t15 += v * b12;
    t16 += v * b13;
    t17 += v * b14;
    t18 += v * b15;
    v = a[4];
    t4 += v * b0;
    t5 += v * b1;
    t6 += v * b2;
    t7 += v * b3;
    t8 += v * b4;
    t9 += v * b5;
    t10 += v * b6;
    t11 += v * b7;
    t12 += v * b8;
    t13 += v * b9;
    t14 += v * b10;
    t15 += v * b11;
    t16 += v * b12;
    t17 += v * b13;
    t18 += v * b14;
    t19 += v * b15;
    v = a[5];
    t5 += v * b0;
    t6 += v * b1;
    t7 += v * b2;
    t8 += v * b3;
    t9 += v * b4;
    t10 += v * b5;
    t11 += v * b6;
    t12 += v * b7;
    t13 += v * b8;
    t14 += v * b9;
    t15 += v * b10;
    t16 += v * b11;
    t17 += v * b12;
    t18 += v * b13;
    t19 += v * b14;
    t20 += v * b15;
    v = a[6];
    t6 += v * b0;
    t7 += v * b1;
    t8 += v * b2;
    t9 += v * b3;
    t10 += v * b4;
    t11 += v * b5;
    t12 += v * b6;
    t13 += v * b7;
    t14 += v * b8;
    t15 += v * b9;
    t16 += v * b10;
    t17 += v * b11;
    t18 += v * b12;
    t19 += v * b13;
    t20 += v * b14;
    t21 += v * b15;
    v = a[7];
    t7 += v * b0;
    t8 += v * b1;
    t9 += v * b2;
    t10 += v * b3;
    t11 += v * b4;
    t12 += v * b5;
    t13 += v * b6;
    t14 += v * b7;
    t15 += v * b8;
    t16 += v * b9;
    t17 += v * b10;
    t18 += v * b11;
    t19 += v * b12;
    t20 += v * b13;
    t21 += v * b14;
    t22 += v * b15;
    v = a[8];
    t8 += v * b0;
    t9 += v * b1;
    t10 += v * b2;
    t11 += v * b3;
    t12 += v * b4;
    t13 += v * b5;
    t14 += v * b6;
    t15 += v * b7;
    t16 += v * b8;
    t17 += v * b9;
    t18 += v * b10;
    t19 += v * b11;
    t20 += v * b12;
    t21 += v * b13;
    t22 += v * b14;
    t23 += v * b15;
    v = a[9];
    t9 += v * b0;
    t10 += v * b1;
    t11 += v * b2;
    t12 += v * b3;
    t13 += v * b4;
    t14 += v * b5;
    t15 += v * b6;
    t16 += v * b7;
    t17 += v * b8;
    t18 += v * b9;
    t19 += v * b10;
    t20 += v * b11;
    t21 += v * b12;
    t22 += v * b13;
    t23 += v * b14;
    t24 += v * b15;
    v = a[10];
    t10 += v * b0;
    t11 += v * b1;
    t12 += v * b2;
    t13 += v * b3;
    t14 += v * b4;
    t15 += v * b5;
    t16 += v * b6;
    t17 += v * b7;
    t18 += v * b8;
    t19 += v * b9;
    t20 += v * b10;
    t21 += v * b11;
    t22 += v * b12;
    t23 += v * b13;
    t24 += v * b14;
    t25 += v * b15;
    v = a[11];
    t11 += v * b0;
    t12 += v * b1;
    t13 += v * b2;
    t14 += v * b3;
    t15 += v * b4;
    t16 += v * b5;
    t17 += v * b6;
    t18 += v * b7;
    t19 += v * b8;
    t20 += v * b9;
    t21 += v * b10;
    t22 += v * b11;
    t23 += v * b12;
    t24 += v * b13;
    t25 += v * b14;
    t26 += v * b15;
    v = a[12];
    t12 += v * b0;
    t13 += v * b1;
    t14 += v * b2;
    t15 += v * b3;
    t16 += v * b4;
    t17 += v * b5;
    t18 += v * b6;
    t19 += v * b7;
    t20 += v * b8;
    t21 += v * b9;
    t22 += v * b10;
    t23 += v * b11;
    t24 += v * b12;
    t25 += v * b13;
    t26 += v * b14;
    t27 += v * b15;
    v = a[13];
    t13 += v * b0;
    t14 += v * b1;
    t15 += v * b2;
    t16 += v * b3;
    t17 += v * b4;
    t18 += v * b5;
    t19 += v * b6;
    t20 += v * b7;
    t21 += v * b8;
    t22 += v * b9;
    t23 += v * b10;
    t24 += v * b11;
    t25 += v * b12;
    t26 += v * b13;
    t27 += v * b14;
    t28 += v * b15;
    v = a[14];
    t14 += v * b0;
    t15 += v * b1;
    t16 += v * b2;
    t17 += v * b3;
    t18 += v * b4;
    t19 += v * b5;
    t20 += v * b6;
    t21 += v * b7;
    t22 += v * b8;
    t23 += v * b9;
    t24 += v * b10;
    t25 += v * b11;
    t26 += v * b12;
    t27 += v * b13;
    t28 += v * b14;
    t29 += v * b15;
    v = a[15];
    t15 += v * b0;
    t16 += v * b1;
    t17 += v * b2;
    t18 += v * b3;
    t19 += v * b4;
    t20 += v * b5;
    t21 += v * b6;
    t22 += v * b7;
    t23 += v * b8;
    t24 += v * b9;
    t25 += v * b10;
    t26 += v * b11;
    t27 += v * b12;
    t28 += v * b13;
    t29 += v * b14;
    t30 += v * b15;
    t0 += 38 * t16;
    t1 += 38 * t17;
    t2 += 38 * t18;
    t3 += 38 * t19;
    t4 += 38 * t20;
    t5 += 38 * t21;
    t6 += 38 * t22;
    t7 += 38 * t23;
    t8 += 38 * t24;
    t9 += 38 * t25;
    t10 += 38 * t26;
    t11 += 38 * t27;
    t12 += 38 * t28;
    t13 += 38 * t29;
    t14 += 38 * t30;
    // t15 left as is
    // first car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    // second car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    o[0] = t0;
    o[1] = t1;
    o[2] = t2;
    o[3] = t3;
    o[4] = t4;
    o[5] = t5;
    o[6] = t6;
    o[7] = t7;
    o[8] = t8;
    o[9] = t9;
    o[10] = t10;
    o[11] = t11;
    o[12] = t12;
    o[13] = t13;
    o[14] = t14;
    o[15] = t15;
}
function $1e8f8280e95fd98d$var$square(o, a) {
    $1e8f8280e95fd98d$var$mul(o, a, a);
}
function $1e8f8280e95fd98d$var$inv25519(o, i) {
    var c = $1e8f8280e95fd98d$var$gf();
    var a;
    for(a = 0; a < 16; a++)c[a] = i[a];
    for(a = 253; a >= 0; a--){
        $1e8f8280e95fd98d$var$square(c, c);
        if (a !== 2 && a !== 4) $1e8f8280e95fd98d$var$mul(c, c, i);
    }
    for(a = 0; a < 16; a++)o[a] = c[a];
}
function $1e8f8280e95fd98d$var$pow2523(o, i) {
    var c = $1e8f8280e95fd98d$var$gf();
    var a;
    for(a = 0; a < 16; a++)c[a] = i[a];
    for(a = 250; a >= 0; a--){
        $1e8f8280e95fd98d$var$square(c, c);
        if (a !== 1) $1e8f8280e95fd98d$var$mul(c, c, i);
    }
    for(a = 0; a < 16; a++)o[a] = c[a];
}
function $1e8f8280e95fd98d$var$edadd(p, q) {
    var a = $1e8f8280e95fd98d$var$gf(), b = $1e8f8280e95fd98d$var$gf(), c = $1e8f8280e95fd98d$var$gf(), d = $1e8f8280e95fd98d$var$gf(), e = $1e8f8280e95fd98d$var$gf(), f = $1e8f8280e95fd98d$var$gf(), g = $1e8f8280e95fd98d$var$gf(), h = $1e8f8280e95fd98d$var$gf(), t = $1e8f8280e95fd98d$var$gf();
    $1e8f8280e95fd98d$var$sub(a, p[1], p[0]);
    $1e8f8280e95fd98d$var$sub(t, q[1], q[0]);
    $1e8f8280e95fd98d$var$mul(a, a, t);
    $1e8f8280e95fd98d$var$add(b, p[0], p[1]);
    $1e8f8280e95fd98d$var$add(t, q[0], q[1]);
    $1e8f8280e95fd98d$var$mul(b, b, t);
    $1e8f8280e95fd98d$var$mul(c, p[3], q[3]);
    $1e8f8280e95fd98d$var$mul(c, c, $1e8f8280e95fd98d$var$D2);
    $1e8f8280e95fd98d$var$mul(d, p[2], q[2]);
    $1e8f8280e95fd98d$var$add(d, d, d);
    $1e8f8280e95fd98d$var$sub(e, b, a);
    $1e8f8280e95fd98d$var$sub(f, d, c);
    $1e8f8280e95fd98d$var$add(g, d, c);
    $1e8f8280e95fd98d$var$add(h, b, a);
    $1e8f8280e95fd98d$var$mul(p[0], e, f);
    $1e8f8280e95fd98d$var$mul(p[1], h, g);
    $1e8f8280e95fd98d$var$mul(p[2], g, f);
    $1e8f8280e95fd98d$var$mul(p[3], e, h);
}
function $1e8f8280e95fd98d$var$cswap(p, q, b) {
    for(var i = 0; i < 4; i++)$1e8f8280e95fd98d$var$sel25519(p[i], q[i], b);
}
function $1e8f8280e95fd98d$var$pack(r, p) {
    var tx = $1e8f8280e95fd98d$var$gf(), ty = $1e8f8280e95fd98d$var$gf(), zi = $1e8f8280e95fd98d$var$gf();
    $1e8f8280e95fd98d$var$inv25519(zi, p[2]);
    $1e8f8280e95fd98d$var$mul(tx, p[0], zi);
    $1e8f8280e95fd98d$var$mul(ty, p[1], zi);
    $1e8f8280e95fd98d$var$pack25519(r, ty);
    r[31] ^= $1e8f8280e95fd98d$var$par25519(tx) << 7;
}
function $1e8f8280e95fd98d$var$scalarmult(p, q, s) {
    $1e8f8280e95fd98d$var$set25519(p[0], $1e8f8280e95fd98d$var$gf0);
    $1e8f8280e95fd98d$var$set25519(p[1], $1e8f8280e95fd98d$var$gf1);
    $1e8f8280e95fd98d$var$set25519(p[2], $1e8f8280e95fd98d$var$gf1);
    $1e8f8280e95fd98d$var$set25519(p[3], $1e8f8280e95fd98d$var$gf0);
    for(var i = 255; i >= 0; --i){
        var b = s[i / 8 | 0] >> (i & 7) & 1;
        $1e8f8280e95fd98d$var$cswap(p, q, b);
        $1e8f8280e95fd98d$var$edadd(q, p);
        $1e8f8280e95fd98d$var$edadd(p, p);
        $1e8f8280e95fd98d$var$cswap(p, q, b);
    }
}
function $1e8f8280e95fd98d$var$scalarbase(p, s) {
    var q = [
        $1e8f8280e95fd98d$var$gf(),
        $1e8f8280e95fd98d$var$gf(),
        $1e8f8280e95fd98d$var$gf(),
        $1e8f8280e95fd98d$var$gf()
    ];
    $1e8f8280e95fd98d$var$set25519(q[0], $1e8f8280e95fd98d$var$X);
    $1e8f8280e95fd98d$var$set25519(q[1], $1e8f8280e95fd98d$var$Y);
    $1e8f8280e95fd98d$var$set25519(q[2], $1e8f8280e95fd98d$var$gf1);
    $1e8f8280e95fd98d$var$mul(q[3], $1e8f8280e95fd98d$var$X, $1e8f8280e95fd98d$var$Y);
    $1e8f8280e95fd98d$var$scalarmult(p, q, s);
}
// Generates key pair from secret 32-byte seed.
function $1e8f8280e95fd98d$var$generateKeyPairFromSeed(seed) {
    if (seed.length !== module.exports.SEED_LENGTH) throw new Error("ed25519: seed must be ".concat(module.exports.SEED_LENGTH, " bytes"));
    var d = (0, $dgPwm.hash)(seed);
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    var publicKey = new Uint8Array(32);
    var p = [
        $1e8f8280e95fd98d$var$gf(),
        $1e8f8280e95fd98d$var$gf(),
        $1e8f8280e95fd98d$var$gf(),
        $1e8f8280e95fd98d$var$gf()
    ];
    $1e8f8280e95fd98d$var$scalarbase(p, d);
    $1e8f8280e95fd98d$var$pack(publicKey, p);
    var secretKey = new Uint8Array(64);
    secretKey.set(seed);
    secretKey.set(publicKey, 32);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
}
module.exports.generateKeyPairFromSeed = $1e8f8280e95fd98d$var$generateKeyPairFromSeed;
function $1e8f8280e95fd98d$var$generateKeyPair(prng) {
    var seed = (0, $5A0yG.randomBytes)(32, prng);
    var result = $1e8f8280e95fd98d$var$generateKeyPairFromSeed(seed);
    (0, $1iHRq.wipe)(seed);
    return result;
}
module.exports.generateKeyPair = $1e8f8280e95fd98d$var$generateKeyPair;
function $1e8f8280e95fd98d$var$extractPublicKeyFromSecretKey(secretKey) {
    if (secretKey.length !== module.exports.SECRET_KEY_LENGTH) throw new Error("ed25519: secret key must be ".concat(module.exports.SECRET_KEY_LENGTH, " bytes"));
    return new Uint8Array(secretKey.subarray(32));
}
module.exports.extractPublicKeyFromSecretKey = $1e8f8280e95fd98d$var$extractPublicKeyFromSecretKey;
var $1e8f8280e95fd98d$var$L = new Float64Array([
    0xed,
    0xd3,
    0xf5,
    0x5c,
    0x1a,
    0x63,
    0x12,
    0x58,
    0xd6,
    0x9c,
    0xf7,
    0xa2,
    0xde,
    0xf9,
    0xde,
    0x14,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0x10
]);
function $1e8f8280e95fd98d$var$modL(r, x) {
    var carry;
    var i;
    var j;
    var k;
    for(i = 63; i >= 32; --i){
        carry = 0;
        for(j = i - 32, k = i - 12; j < k; ++j){
            x[j] += carry - 16 * x[i] * $1e8f8280e95fd98d$var$L[j - (i - 32)];
            carry = Math.floor((x[j] + 128) / 256);
            x[j] -= carry * 256;
        }
        x[j] += carry;
        x[i] = 0;
    }
    carry = 0;
    for(j = 0; j < 32; j++){
        x[j] += carry - (x[31] >> 4) * $1e8f8280e95fd98d$var$L[j];
        carry = x[j] >> 8;
        x[j] &= 255;
    }
    for(j = 0; j < 32; j++)x[j] -= carry * $1e8f8280e95fd98d$var$L[j];
    for(i = 0; i < 32; i++){
        x[i + 1] += x[i] >> 8;
        r[i] = x[i] & 255;
    }
}
function $1e8f8280e95fd98d$var$reduce(r) {
    var x = new Float64Array(64);
    for(var i = 0; i < 64; i++)x[i] = r[i];
    for(var i1 = 0; i1 < 64; i1++)r[i1] = 0;
    $1e8f8280e95fd98d$var$modL(r, x);
}
// Returns 64-byte signature of the message under the 64-byte secret key.
function $1e8f8280e95fd98d$var$sign(secretKey, message) {
    var x = new Float64Array(64);
    var p = [
        $1e8f8280e95fd98d$var$gf(),
        $1e8f8280e95fd98d$var$gf(),
        $1e8f8280e95fd98d$var$gf(),
        $1e8f8280e95fd98d$var$gf()
    ];
    var d = (0, $dgPwm.hash)(secretKey.subarray(0, 32));
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    var signature = new Uint8Array(64);
    signature.set(d.subarray(32), 32);
    var hs = new $dgPwm.SHA512();
    hs.update(signature.subarray(32));
    hs.update(message);
    var r = hs.digest();
    hs.clean();
    $1e8f8280e95fd98d$var$reduce(r);
    $1e8f8280e95fd98d$var$scalarbase(p, r);
    $1e8f8280e95fd98d$var$pack(signature, p);
    hs.reset();
    hs.update(signature.subarray(0, 32));
    hs.update(secretKey.subarray(32));
    hs.update(message);
    var h = hs.digest();
    $1e8f8280e95fd98d$var$reduce(h);
    for(var i = 0; i < 32; i++)x[i] = r[i];
    for(var i1 = 0; i1 < 32; i1++)for(var j = 0; j < 32; j++)x[i1 + j] += h[i1] * d[j];
    $1e8f8280e95fd98d$var$modL(signature.subarray(32), x);
    return signature;
}
module.exports.sign = $1e8f8280e95fd98d$var$sign;
function $1e8f8280e95fd98d$var$unpackneg(r, p) {
    var t = $1e8f8280e95fd98d$var$gf(), chk = $1e8f8280e95fd98d$var$gf(), num = $1e8f8280e95fd98d$var$gf(), den = $1e8f8280e95fd98d$var$gf(), den2 = $1e8f8280e95fd98d$var$gf(), den4 = $1e8f8280e95fd98d$var$gf(), den6 = $1e8f8280e95fd98d$var$gf();
    $1e8f8280e95fd98d$var$set25519(r[2], $1e8f8280e95fd98d$var$gf1);
    $1e8f8280e95fd98d$var$unpack25519(r[1], p);
    $1e8f8280e95fd98d$var$square(num, r[1]);
    $1e8f8280e95fd98d$var$mul(den, num, $1e8f8280e95fd98d$var$D);
    $1e8f8280e95fd98d$var$sub(num, num, r[2]);
    $1e8f8280e95fd98d$var$add(den, r[2], den);
    $1e8f8280e95fd98d$var$square(den2, den);
    $1e8f8280e95fd98d$var$square(den4, den2);
    $1e8f8280e95fd98d$var$mul(den6, den4, den2);
    $1e8f8280e95fd98d$var$mul(t, den6, num);
    $1e8f8280e95fd98d$var$mul(t, t, den);
    $1e8f8280e95fd98d$var$pow2523(t, t);
    $1e8f8280e95fd98d$var$mul(t, t, num);
    $1e8f8280e95fd98d$var$mul(t, t, den);
    $1e8f8280e95fd98d$var$mul(t, t, den);
    $1e8f8280e95fd98d$var$mul(r[0], t, den);
    $1e8f8280e95fd98d$var$square(chk, r[0]);
    $1e8f8280e95fd98d$var$mul(chk, chk, den);
    if ($1e8f8280e95fd98d$var$neq25519(chk, num)) $1e8f8280e95fd98d$var$mul(r[0], r[0], $1e8f8280e95fd98d$var$I);
    $1e8f8280e95fd98d$var$square(chk, r[0]);
    $1e8f8280e95fd98d$var$mul(chk, chk, den);
    if ($1e8f8280e95fd98d$var$neq25519(chk, num)) return -1;
    if ($1e8f8280e95fd98d$var$par25519(r[0]) === p[31] >> 7) $1e8f8280e95fd98d$var$sub(r[0], $1e8f8280e95fd98d$var$gf0, r[0]);
    $1e8f8280e95fd98d$var$mul(r[3], r[0], r[1]);
    return 0;
}
function $1e8f8280e95fd98d$var$verify(publicKey, message, signature) {
    var t = new Uint8Array(32);
    var p = [
        $1e8f8280e95fd98d$var$gf(),
        $1e8f8280e95fd98d$var$gf(),
        $1e8f8280e95fd98d$var$gf(),
        $1e8f8280e95fd98d$var$gf()
    ];
    var q = [
        $1e8f8280e95fd98d$var$gf(),
        $1e8f8280e95fd98d$var$gf(),
        $1e8f8280e95fd98d$var$gf(),
        $1e8f8280e95fd98d$var$gf()
    ];
    if (signature.length !== module.exports.SIGNATURE_LENGTH) throw new Error("ed25519: signature must be ".concat(module.exports.SIGNATURE_LENGTH, " bytes"));
    if ($1e8f8280e95fd98d$var$unpackneg(q, publicKey)) return false;
    var hs = new $dgPwm.SHA512();
    hs.update(signature.subarray(0, 32));
    hs.update(publicKey);
    hs.update(message);
    var h = hs.digest();
    $1e8f8280e95fd98d$var$reduce(h);
    $1e8f8280e95fd98d$var$scalarmult(p, q, h);
    $1e8f8280e95fd98d$var$scalarbase(q, signature.subarray(32));
    $1e8f8280e95fd98d$var$edadd(p, q);
    $1e8f8280e95fd98d$var$pack(t, p);
    if ($1e8f8280e95fd98d$var$verify32(signature, t)) return false;
    return true;
}
module.exports.verify = $1e8f8280e95fd98d$var$verify;
/**
 * Convert Ed25519 public key to X25519 public key.
 *
 * Throws if given an invalid public key.
 */ function $1e8f8280e95fd98d$var$convertPublicKeyToX25519(publicKey) {
    var q = [
        $1e8f8280e95fd98d$var$gf(),
        $1e8f8280e95fd98d$var$gf(),
        $1e8f8280e95fd98d$var$gf(),
        $1e8f8280e95fd98d$var$gf()
    ];
    if ($1e8f8280e95fd98d$var$unpackneg(q, publicKey)) throw new Error("Ed25519: invalid public key");
    // Formula: montgomeryX = (edwardsY + 1)*inverse(1 - edwardsY) mod p
    var a = $1e8f8280e95fd98d$var$gf();
    var b = $1e8f8280e95fd98d$var$gf();
    var y = q[1];
    $1e8f8280e95fd98d$var$add(a, $1e8f8280e95fd98d$var$gf1, y);
    $1e8f8280e95fd98d$var$sub(b, $1e8f8280e95fd98d$var$gf1, y);
    $1e8f8280e95fd98d$var$inv25519(b, b);
    $1e8f8280e95fd98d$var$mul(a, a, b);
    var z = new Uint8Array(32);
    $1e8f8280e95fd98d$var$pack25519(z, a);
    return z;
}
module.exports.convertPublicKeyToX25519 = $1e8f8280e95fd98d$var$convertPublicKeyToX25519;
/**
 *  Convert Ed25519 secret (private) key to X25519 secret key.
 */ function $1e8f8280e95fd98d$var$convertSecretKeyToX25519(secretKey) {
    var d = (0, $dgPwm.hash)(secretKey.subarray(0, 32));
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    var o = new Uint8Array(d.subarray(0, 32));
    (0, $1iHRq.wipe)(d);
    return o;
}
module.exports.convertSecretKeyToX25519 = $1e8f8280e95fd98d$var$convertSecretKeyToX25519;

});
parcelRegister("dgPwm", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9sToB = parcelRequire("9sToB");

var $1iHRq = parcelRequire("1iHRq");
module.exports.DIGEST_LENGTH = 64;
module.exports.BLOCK_SIZE = 128;
/**
 * SHA-2-512 cryptographic hash algorithm.
 */ var $9a94bbf9d8d88658$var$SHA512 = /** @class */ function() {
    function SHA512() {
        /** Length of hash output */ this.digestLength = module.exports.DIGEST_LENGTH;
        /** Block size */ this.blockSize = module.exports.BLOCK_SIZE;
        // Note: Int32Array is used instead of Uint32Array for performance reasons.
        this._stateHi = new Int32Array(8); // hash state, high bytes
        this._stateLo = new Int32Array(8); // hash state, low bytes
        this._tempHi = new Int32Array(16); // temporary state, high bytes
        this._tempLo = new Int32Array(16); // temporary state, low bytes
        this._buffer = new Uint8Array(256); // buffer for data to hash
        this._bufferLength = 0; // number of bytes in buffer
        this._bytesHashed = 0; // number of total bytes hashed
        this._finished = false; // indicates whether the hash was finalized
        this.reset();
    }
    SHA512.prototype._initState = function() {
        this._stateHi[0] = 0x6a09e667;
        this._stateHi[1] = 0xbb67ae85;
        this._stateHi[2] = 0x3c6ef372;
        this._stateHi[3] = 0xa54ff53a;
        this._stateHi[4] = 0x510e527f;
        this._stateHi[5] = 0x9b05688c;
        this._stateHi[6] = 0x1f83d9ab;
        this._stateHi[7] = 0x5be0cd19;
        this._stateLo[0] = 0xf3bcc908;
        this._stateLo[1] = 0x84caa73b;
        this._stateLo[2] = 0xfe94f82b;
        this._stateLo[3] = 0x5f1d36f1;
        this._stateLo[4] = 0xade682d1;
        this._stateLo[5] = 0x2b3e6c1f;
        this._stateLo[6] = 0xfb41bd6b;
        this._stateLo[7] = 0x137e2179;
    };
    /**
     * Resets hash state making it possible
     * to re-use this instance to hash other data.
     */ SHA512.prototype.reset = function() {
        this._initState();
        this._bufferLength = 0;
        this._bytesHashed = 0;
        this._finished = false;
        return this;
    };
    /**
     * Cleans internal buffers and resets hash state.
     */ SHA512.prototype.clean = function() {
        $1iHRq.wipe(this._buffer);
        $1iHRq.wipe(this._tempHi);
        $1iHRq.wipe(this._tempLo);
        this.reset();
    };
    /**
     * Updates hash state with the given data.
     *
     * Throws error when trying to update already finalized hash:
     * instance must be reset to update it again.
     */ SHA512.prototype.update = function(data, dataLength) {
        if (dataLength === void 0) dataLength = data.length;
        if (this._finished) throw new Error("SHA512: can't update because hash was finished.");
        var dataPos = 0;
        this._bytesHashed += dataLength;
        if (this._bufferLength > 0) {
            while(this._bufferLength < module.exports.BLOCK_SIZE && dataLength > 0){
                this._buffer[this._bufferLength++] = data[dataPos++];
                dataLength--;
            }
            if (this._bufferLength === this.blockSize) {
                $9a94bbf9d8d88658$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, this.blockSize);
                this._bufferLength = 0;
            }
        }
        if (dataLength >= this.blockSize) {
            dataPos = $9a94bbf9d8d88658$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, data, dataPos, dataLength);
            dataLength %= this.blockSize;
        }
        while(dataLength > 0){
            this._buffer[this._bufferLength++] = data[dataPos++];
            dataLength--;
        }
        return this;
    };
    /**
     * Finalizes hash state and puts hash into out.
     * If hash was already finalized, puts the same value.
     */ SHA512.prototype.finish = function(out) {
        if (!this._finished) {
            var bytesHashed = this._bytesHashed;
            var left = this._bufferLength;
            var bitLenHi = bytesHashed / 0x20000000 | 0;
            var bitLenLo = bytesHashed << 3;
            var padLength = bytesHashed % 128 < 112 ? 128 : 256;
            this._buffer[left] = 0x80;
            for(var i = left + 1; i < padLength - 8; i++)this._buffer[i] = 0;
            $9sToB.writeUint32BE(bitLenHi, this._buffer, padLength - 8);
            $9sToB.writeUint32BE(bitLenLo, this._buffer, padLength - 4);
            $9a94bbf9d8d88658$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, padLength);
            this._finished = true;
        }
        for(var i = 0; i < this.digestLength / 8; i++){
            $9sToB.writeUint32BE(this._stateHi[i], out, i * 8);
            $9sToB.writeUint32BE(this._stateLo[i], out, i * 8 + 4);
        }
        return this;
    };
    /**
     * Returns the final hash digest.
     */ SHA512.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization. Returns hash state to be
     * used with restoreState(). Only chain value is saved, not buffers or
     * other state variables.
     */ SHA512.prototype.saveState = function() {
        if (this._finished) throw new Error("SHA256: cannot save finished state");
        return {
            stateHi: new Int32Array(this._stateHi),
            stateLo: new Int32Array(this._stateLo),
            buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : undefined,
            bufferLength: this._bufferLength,
            bytesHashed: this._bytesHashed
        };
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization. Restores state saved by
     * saveState() and sets bytesHashed to the given value.
     */ SHA512.prototype.restoreState = function(savedState) {
        this._stateHi.set(savedState.stateHi);
        this._stateLo.set(savedState.stateLo);
        this._bufferLength = savedState.bufferLength;
        if (savedState.buffer) this._buffer.set(savedState.buffer);
        this._bytesHashed = savedState.bytesHashed;
        this._finished = false;
        return this;
    };
    /**
     * Cleans state returned by saveState().
     */ SHA512.prototype.cleanSavedState = function(savedState) {
        $1iHRq.wipe(savedState.stateHi);
        $1iHRq.wipe(savedState.stateLo);
        if (savedState.buffer) $1iHRq.wipe(savedState.buffer);
        savedState.bufferLength = 0;
        savedState.bytesHashed = 0;
    };
    return SHA512;
}();
module.exports.SHA512 = $9a94bbf9d8d88658$var$SHA512;
// Constants
var $9a94bbf9d8d88658$var$K = new Int32Array([
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
]);
function $9a94bbf9d8d88658$var$hashBlocks(wh, wl, hh, hl, m, pos, len) {
    var ah0 = hh[0], ah1 = hh[1], ah2 = hh[2], ah3 = hh[3], ah4 = hh[4], ah5 = hh[5], ah6 = hh[6], ah7 = hh[7], al0 = hl[0], al1 = hl[1], al2 = hl[2], al3 = hl[3], al4 = hl[4], al5 = hl[5], al6 = hl[6], al7 = hl[7];
    var h, l;
    var th, tl;
    var a, b, c, d;
    while(len >= 128){
        for(var i = 0; i < 16; i++){
            var j = 8 * i + pos;
            wh[i] = $9sToB.readUint32BE(m, j);
            wl[i] = $9sToB.readUint32BE(m, j + 4);
        }
        for(var i = 0; i < 80; i++){
            var bh0 = ah0;
            var bh1 = ah1;
            var bh2 = ah2;
            var bh3 = ah3;
            var bh4 = ah4;
            var bh5 = ah5;
            var bh6 = ah6;
            var bh7 = ah7;
            var bl0 = al0;
            var bl1 = al1;
            var bl2 = al2;
            var bl3 = al3;
            var bl4 = al4;
            var bl5 = al5;
            var bl6 = al6;
            var bl7 = al7;
            // add
            h = ah7;
            l = al7;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            // Sigma1
            h = (ah4 >>> 14 | al4 << 18) ^ (ah4 >>> 18 | al4 << 14) ^ (al4 >>> 9 | ah4 << 23);
            l = (al4 >>> 14 | ah4 << 18) ^ (al4 >>> 18 | ah4 << 14) ^ (ah4 >>> 9 | al4 << 23);
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // Ch
            h = ah4 & ah5 ^ ~ah4 & ah6;
            l = al4 & al5 ^ ~al4 & al6;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // K
            h = $9a94bbf9d8d88658$var$K[i * 2];
            l = $9a94bbf9d8d88658$var$K[i * 2 + 1];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // w
            h = wh[i % 16];
            l = wl[i % 16];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            th = c & 0xffff | d << 16;
            tl = a & 0xffff | b << 16;
            // add
            h = th;
            l = tl;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            // Sigma0
            h = (ah0 >>> 28 | al0 << 4) ^ (al0 >>> 2 | ah0 << 30) ^ (al0 >>> 7 | ah0 << 25);
            l = (al0 >>> 28 | ah0 << 4) ^ (ah0 >>> 2 | al0 << 30) ^ (ah0 >>> 7 | al0 << 25);
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // Maj
            h = ah0 & ah1 ^ ah0 & ah2 ^ ah1 & ah2;
            l = al0 & al1 ^ al0 & al2 ^ al1 & al2;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            bh7 = c & 0xffff | d << 16;
            bl7 = a & 0xffff | b << 16;
            // add
            h = bh3;
            l = bl3;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = th;
            l = tl;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            bh3 = c & 0xffff | d << 16;
            bl3 = a & 0xffff | b << 16;
            ah1 = bh0;
            ah2 = bh1;
            ah3 = bh2;
            ah4 = bh3;
            ah5 = bh4;
            ah6 = bh5;
            ah7 = bh6;
            ah0 = bh7;
            al1 = bl0;
            al2 = bl1;
            al3 = bl2;
            al4 = bl3;
            al5 = bl4;
            al6 = bl5;
            al7 = bl6;
            al0 = bl7;
            if (i % 16 === 15) for(var j = 0; j < 16; j++){
                // add
                h = wh[j];
                l = wl[j];
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                h = wh[(j + 9) % 16];
                l = wl[(j + 9) % 16];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // sigma0
                th = wh[(j + 1) % 16];
                tl = wl[(j + 1) % 16];
                h = (th >>> 1 | tl << 31) ^ (th >>> 8 | tl << 24) ^ th >>> 7;
                l = (tl >>> 1 | th << 31) ^ (tl >>> 8 | th << 24) ^ (tl >>> 7 | th << 25);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // sigma1
                th = wh[(j + 14) % 16];
                tl = wl[(j + 14) % 16];
                h = (th >>> 19 | tl << 13) ^ (tl >>> 29 | th << 3) ^ th >>> 6;
                l = (tl >>> 19 | th << 13) ^ (th >>> 29 | tl << 3) ^ (tl >>> 6 | th << 26);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                wh[j] = c & 0xffff | d << 16;
                wl[j] = a & 0xffff | b << 16;
            }
        }
        // add
        h = ah0;
        l = al0;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[0];
        l = hl[0];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[0] = ah0 = c & 0xffff | d << 16;
        hl[0] = al0 = a & 0xffff | b << 16;
        h = ah1;
        l = al1;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[1];
        l = hl[1];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[1] = ah1 = c & 0xffff | d << 16;
        hl[1] = al1 = a & 0xffff | b << 16;
        h = ah2;
        l = al2;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[2];
        l = hl[2];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[2] = ah2 = c & 0xffff | d << 16;
        hl[2] = al2 = a & 0xffff | b << 16;
        h = ah3;
        l = al3;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[3];
        l = hl[3];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[3] = ah3 = c & 0xffff | d << 16;
        hl[3] = al3 = a & 0xffff | b << 16;
        h = ah4;
        l = al4;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[4];
        l = hl[4];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[4] = ah4 = c & 0xffff | d << 16;
        hl[4] = al4 = a & 0xffff | b << 16;
        h = ah5;
        l = al5;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[5];
        l = hl[5];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[5] = ah5 = c & 0xffff | d << 16;
        hl[5] = al5 = a & 0xffff | b << 16;
        h = ah6;
        l = al6;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[6];
        l = hl[6];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[6] = ah6 = c & 0xffff | d << 16;
        hl[6] = al6 = a & 0xffff | b << 16;
        h = ah7;
        l = al7;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[7];
        l = hl[7];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[7] = ah7 = c & 0xffff | d << 16;
        hl[7] = al7 = a & 0xffff | b << 16;
        pos += 128;
        len -= 128;
    }
    return pos;
}
function $9a94bbf9d8d88658$var$hash(data) {
    var h = new $9a94bbf9d8d88658$var$SHA512();
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
module.exports.hash = $9a94bbf9d8d88658$var$hash;

});


parcelRegister("6HkgD", function(module, exports) {

$parcel$export(module.exports, "JWT_IRIDIUM_ALG", function () { return $4e067ae2b462202b$export$51745f7832485c34; });
$parcel$export(module.exports, "JWT_IRIDIUM_TYP", function () { return $4e067ae2b462202b$export$f51b45e220f2ba98; });
$parcel$export(module.exports, "JWT_DELIMITER", function () { return $4e067ae2b462202b$export$a3e35a0f952eb3ef; });
$parcel$export(module.exports, "JWT_ENCODING", function () { return $4e067ae2b462202b$export$d2e6fe38c55f8e23; });
$parcel$export(module.exports, "JSON_ENCODING", function () { return $4e067ae2b462202b$export$c09c2801e10a2b95; });
$parcel$export(module.exports, "DATA_ENCODING", function () { return $4e067ae2b462202b$export$1e9219c0b91a4257; });
$parcel$export(module.exports, "DID_DELIMITER", function () { return $4e067ae2b462202b$export$d4057275de9d060b; });
$parcel$export(module.exports, "DID_PREFIX", function () { return $4e067ae2b462202b$export$acf13c61a1a0ccf3; });
$parcel$export(module.exports, "DID_METHOD", function () { return $4e067ae2b462202b$export$b908fe81ccf30934; });
$parcel$export(module.exports, "MULTICODEC_ED25519_ENCODING", function () { return $4e067ae2b462202b$export$7bd18b7a7a4d0471; });
$parcel$export(module.exports, "MULTICODEC_ED25519_BASE", function () { return $4e067ae2b462202b$export$6d6d3d2e39be8d68; });
$parcel$export(module.exports, "MULTICODEC_ED25519_HEADER", function () { return $4e067ae2b462202b$export$9902a33a5776d1fc; });
$parcel$export(module.exports, "MULTICODEC_ED25519_LENGTH", function () { return $4e067ae2b462202b$export$ca477e91394a742a; });
$parcel$export(module.exports, "KEY_PAIR_SEED_LENGTH", function () { return $4e067ae2b462202b$export$f09ad228919f26fb; });
var $4e067ae2b462202b$export$51745f7832485c34 = "EdDSA";
var $4e067ae2b462202b$export$f51b45e220f2ba98 = "JWT";
var $4e067ae2b462202b$export$a3e35a0f952eb3ef = ".";
var $4e067ae2b462202b$export$d2e6fe38c55f8e23 = "base64url";
var $4e067ae2b462202b$export$c09c2801e10a2b95 = "utf8";
var $4e067ae2b462202b$export$1e9219c0b91a4257 = "utf8";
var $4e067ae2b462202b$export$d4057275de9d060b = ":";
var $4e067ae2b462202b$export$acf13c61a1a0ccf3 = "did";
var $4e067ae2b462202b$export$b908fe81ccf30934 = "key";
var $4e067ae2b462202b$export$7bd18b7a7a4d0471 = "base58btc";
var $4e067ae2b462202b$export$6d6d3d2e39be8d68 = "z";
var $4e067ae2b462202b$export$9902a33a5776d1fc = "K36";
var $4e067ae2b462202b$export$ca477e91394a742a = 32;
var $4e067ae2b462202b$export$f09ad228919f26fb = 32;

});

parcelRegister("kGjpT", function(module, exports) {

$parcel$export(module.exports, "encodeIss", function () { return $f0e6caa4f9e0b13c$export$1b29ef9371459e10; });
$parcel$export(module.exports, "decodeIss", function () { return $f0e6caa4f9e0b13c$export$86ac046d72244356; });
$parcel$export(module.exports, "encodeData", function () { return $f0e6caa4f9e0b13c$export$cfdd1f2478131e3d; });
$parcel$export(module.exports, "encodeJWT", function () { return $f0e6caa4f9e0b13c$export$1b70f4551c751d68; });
$parcel$export(module.exports, "decodeJWT", function () { return $f0e6caa4f9e0b13c$export$9a62e6c0a30e00bc; });

var $cv9Rk = parcelRequire("cv9Rk");

var $lQfAa = parcelRequire("lQfAa");

var $ewlTP = parcelRequire("ewlTP");

var $l7Yp4 = parcelRequire("l7Yp4");

var $2fy4s = parcelRequire("2fy4s");

var $6HkgD = parcelRequire("6HkgD");
function $f0e6caa4f9e0b13c$export$2030d1af6cd0ef93(str) {
    return (0, $2fy4s.safeJsonParse)((0, $ewlTP.toString)((0, $l7Yp4.fromString)(str, (0, $6HkgD.JWT_ENCODING)), (0, $6HkgD.JSON_ENCODING)));
}
function $f0e6caa4f9e0b13c$export$84046f8082657cdf(val) {
    return (0, $ewlTP.toString)((0, $l7Yp4.fromString)((0, $2fy4s.safeJsonStringify)(val), (0, $6HkgD.JSON_ENCODING)), (0, $6HkgD.JWT_ENCODING));
}
function $f0e6caa4f9e0b13c$export$1b29ef9371459e10(publicKey) {
    var header = (0, $l7Yp4.fromString)((0, $6HkgD.MULTICODEC_ED25519_HEADER), (0, $6HkgD.MULTICODEC_ED25519_ENCODING));
    var multicodec = (0, $6HkgD.MULTICODEC_ED25519_BASE) + (0, $ewlTP.toString)((0, $lQfAa.concat)([
        header,
        publicKey
    ]), (0, $6HkgD.MULTICODEC_ED25519_ENCODING));
    return [
        (0, $6HkgD.DID_PREFIX),
        (0, $6HkgD.DID_METHOD),
        multicodec
    ].join((0, $6HkgD.DID_DELIMITER));
}
function $f0e6caa4f9e0b13c$export$86ac046d72244356(issuer) {
    var _issuer_split = (0, $cv9Rk._)(issuer.split((0, $6HkgD.DID_DELIMITER)), 3), prefix = _issuer_split[0], method = _issuer_split[1], multicodec = _issuer_split[2];
    if (prefix !== (0, $6HkgD.DID_PREFIX) || method !== (0, $6HkgD.DID_METHOD)) throw new Error('Issuer must be a DID with method "key"');
    var base = multicodec.slice(0, 1);
    if (base !== (0, $6HkgD.MULTICODEC_ED25519_BASE)) throw new Error("Issuer must be a key in mulicodec format");
    var bytes = (0, $l7Yp4.fromString)(multicodec.slice(1), (0, $6HkgD.MULTICODEC_ED25519_ENCODING));
    var type = (0, $ewlTP.toString)(bytes.slice(0, 2), (0, $6HkgD.MULTICODEC_ED25519_ENCODING));
    if (type !== (0, $6HkgD.MULTICODEC_ED25519_HEADER)) throw new Error('Issuer must be a public key with type "Ed25519"');
    var publicKey = bytes.slice(2);
    if (publicKey.length !== (0, $6HkgD.MULTICODEC_ED25519_LENGTH)) throw new Error("Issuer must be a public key with length 32 bytes");
    return publicKey;
}
function $f0e6caa4f9e0b13c$export$d9746ef301b2089b(bytes) {
    return (0, $ewlTP.toString)(bytes, (0, $6HkgD.JWT_ENCODING));
}
function $f0e6caa4f9e0b13c$export$c37aeb372ac07c0e(encoded) {
    return (0, $l7Yp4.fromString)(encoded, (0, $6HkgD.JWT_ENCODING));
}
function $f0e6caa4f9e0b13c$export$cfdd1f2478131e3d(params) {
    return (0, $l7Yp4.fromString)([
        $f0e6caa4f9e0b13c$export$84046f8082657cdf(params.header),
        $f0e6caa4f9e0b13c$export$84046f8082657cdf(params.payload)
    ].join((0, $6HkgD.JWT_DELIMITER)), (0, $6HkgD.DATA_ENCODING));
}
function $f0e6caa4f9e0b13c$export$13923bea59211b58(data) {
    var params = (0, $ewlTP.toString)(data, (0, $6HkgD.DATA_ENCODING)).split((0, $6HkgD.JWT_DELIMITER));
    var header = $f0e6caa4f9e0b13c$export$2030d1af6cd0ef93(params[0]);
    var payload = $f0e6caa4f9e0b13c$export$2030d1af6cd0ef93(params[1]);
    return {
        header: header,
        payload: payload
    };
}
function $f0e6caa4f9e0b13c$export$1b70f4551c751d68(params) {
    return [
        $f0e6caa4f9e0b13c$export$84046f8082657cdf(params.header),
        $f0e6caa4f9e0b13c$export$84046f8082657cdf(params.payload),
        $f0e6caa4f9e0b13c$export$d9746ef301b2089b(params.signature)
    ].join((0, $6HkgD.JWT_DELIMITER));
}
function $f0e6caa4f9e0b13c$export$9a62e6c0a30e00bc(jwt) {
    var params = jwt.split((0, $6HkgD.JWT_DELIMITER));
    var header = $f0e6caa4f9e0b13c$export$2030d1af6cd0ef93(params[0]);
    var payload = $f0e6caa4f9e0b13c$export$2030d1af6cd0ef93(params[1]);
    var signature = $f0e6caa4f9e0b13c$export$c37aeb372ac07c0e(params[2]);
    var data = (0, $l7Yp4.fromString)(params.slice(0, 2).join((0, $6HkgD.JWT_DELIMITER)), (0, $6HkgD.DATA_ENCODING));
    return {
        header: header,
        payload: payload,
        signature: signature,
        data: data
    };
}

});


parcelRegister("6XG8a", function(module, exports) {

});


parcelRegister("aXdDy", function(module, exports) {

$parcel$export(module.exports, "RELAY_JSONRPC", function () { return $7f99fe15e14a3e29$export$af490b3b9a6de00f; });

var $l0HdX = parcelRequire("l0HdX");
function $7f99fe15e14a3e29$var$e(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "string";
    if (!s[r] || (0, $l0HdX._)(s[r]) !== i) throw new Error('Missing or invalid "'.concat(r, '" param'));
}
function $7f99fe15e14a3e29$var$l(s, r) {
    var i = !0;
    return r.forEach(function(t) {
        t in s || (i = !1);
    }), i;
}
function $7f99fe15e14a3e29$var$f(s, r) {
    return Array.isArray(s) ? s.length === r : Object.keys(s).length === r;
}
function $7f99fe15e14a3e29$var$w(s, r) {
    return Array.isArray(s) ? s.length >= r : Object.keys(s).length >= r;
}
function $7f99fe15e14a3e29$var$u(s, r, i) {
    return (i.length ? $7f99fe15e14a3e29$var$w(s, r.length) : $7f99fe15e14a3e29$var$f(s, r.length)) ? $7f99fe15e14a3e29$var$l(s, r) : !1;
}
function $7f99fe15e14a3e29$var$n(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "_";
    var t = s.split(i);
    return t[t.length - 1].trim().toLowerCase() === r.trim().toLowerCase();
}
function $7f99fe15e14a3e29$export$c75580565fa025bd(s) {
    return $7f99fe15e14a3e29$export$f576347163de0984(s.method) && $7f99fe15e14a3e29$export$dae2311546d43680(s.params);
}
function $7f99fe15e14a3e29$export$f576347163de0984(s) {
    return $7f99fe15e14a3e29$var$n(s, "subscribe");
}
function $7f99fe15e14a3e29$export$dae2311546d43680(s) {
    return $7f99fe15e14a3e29$var$u(s, [
        "topic"
    ], []);
}
function $7f99fe15e14a3e29$export$8fa7cf76b41caee0(s) {
    return $7f99fe15e14a3e29$export$71d4d33ac7f7a269(s.method) && $7f99fe15e14a3e29$export$71e8d1aa48c3e86f(s.params);
}
function $7f99fe15e14a3e29$export$71d4d33ac7f7a269(s) {
    return $7f99fe15e14a3e29$var$n(s, "publish");
}
function $7f99fe15e14a3e29$export$71e8d1aa48c3e86f(s) {
    return $7f99fe15e14a3e29$var$u(s, [
        "message",
        "topic",
        "ttl"
    ], [
        "prompt",
        "tag"
    ]);
}
function $7f99fe15e14a3e29$export$83e292763180b41b(s) {
    return $7f99fe15e14a3e29$export$568d956f39536025(s.method) && $7f99fe15e14a3e29$export$cbc597c53c3b4f80(s.params);
}
function $7f99fe15e14a3e29$export$568d956f39536025(s) {
    return $7f99fe15e14a3e29$var$n(s, "unsubscribe");
}
function $7f99fe15e14a3e29$export$cbc597c53c3b4f80(s) {
    return $7f99fe15e14a3e29$var$u(s, [
        "id",
        "topic"
    ], []);
}
function $7f99fe15e14a3e29$export$43cf4100d6287b8e(s) {
    return $7f99fe15e14a3e29$export$3cb4ad320e3a46a4(s.method) && $7f99fe15e14a3e29$export$6366ff9a39f2da4c(s.params);
}
function $7f99fe15e14a3e29$export$3cb4ad320e3a46a4(s) {
    return $7f99fe15e14a3e29$var$n(s, "subscription");
}
function $7f99fe15e14a3e29$export$6366ff9a39f2da4c(s) {
    return $7f99fe15e14a3e29$var$u(s, [
        "id",
        "data"
    ], []);
}
function $7f99fe15e14a3e29$export$abdf96c288cb375(s) {
    if (!$7f99fe15e14a3e29$export$f576347163de0984(s.method)) throw new Error("JSON-RPC Request has invalid subscribe method");
    if (!$7f99fe15e14a3e29$export$dae2311546d43680(s.params)) throw new Error("JSON-RPC Request has invalid subscribe params");
    var r = s.params;
    return $7f99fe15e14a3e29$var$e(r, "topic"), r;
}
function $7f99fe15e14a3e29$export$eac3e45ac5c5c9fa(s) {
    if (!$7f99fe15e14a3e29$export$71d4d33ac7f7a269(s.method)) throw new Error("JSON-RPC Request has invalid publish method");
    if (!$7f99fe15e14a3e29$export$71e8d1aa48c3e86f(s.params)) throw new Error("JSON-RPC Request has invalid publish params");
    var r = s.params;
    return $7f99fe15e14a3e29$var$e(r, "topic"), $7f99fe15e14a3e29$var$e(r, "message"), $7f99fe15e14a3e29$var$e(r, "ttl", "number"), r;
}
function $7f99fe15e14a3e29$export$78baa72f78156594(s) {
    if (!$7f99fe15e14a3e29$export$568d956f39536025(s.method)) throw new Error("JSON-RPC Request has invalid unsubscribe method");
    if (!$7f99fe15e14a3e29$export$cbc597c53c3b4f80(s.params)) throw new Error("JSON-RPC Request has invalid unsubscribe params");
    var r = s.params;
    return $7f99fe15e14a3e29$var$e(r, "id"), r;
}
function $7f99fe15e14a3e29$export$4d5822edd41f3b48(s) {
    if (!$7f99fe15e14a3e29$export$3cb4ad320e3a46a4(s.method)) throw new Error("JSON-RPC Request has invalid subscription method");
    if (!$7f99fe15e14a3e29$export$6366ff9a39f2da4c(s.params)) throw new Error("JSON-RPC Request has invalid subscription params");
    var r = s.params;
    return $7f99fe15e14a3e29$var$e(r, "id"), $7f99fe15e14a3e29$var$e(r, "data"), r;
}
var $7f99fe15e14a3e29$export$af490b3b9a6de00f = {
    waku: {
        publish: "waku_publish",
        batchPublish: "waku_batchPublish",
        subscribe: "waku_subscribe",
        batchSubscribe: "waku_batchSubscribe",
        subscription: "waku_subscription",
        unsubscribe: "waku_unsubscribe",
        batchUnsubscribe: "waku_batchUnsubscribe",
        batchFetchMessages: "waku_batchFetchMessages"
    },
    irn: {
        publish: "irn_publish",
        batchPublish: "irn_batchPublish",
        subscribe: "irn_subscribe",
        batchSubscribe: "irn_batchSubscribe",
        subscription: "irn_subscription",
        unsubscribe: "irn_unsubscribe",
        batchUnsubscribe: "irn_batchUnsubscribe",
        batchFetchMessages: "irn_batchFetchMessages"
    },
    iridium: {
        publish: "iridium_publish",
        batchPublish: "iridium_batchPublish",
        subscribe: "iridium_subscribe",
        batchSubscribe: "iridium_batchSubscribe",
        subscription: "iridium_subscription",
        unsubscribe: "iridium_unsubscribe",
        batchUnsubscribe: "iridium_batchUnsubscribe",
        batchFetchMessages: "iridium_batchFetchMessages"
    }
};

});


parcelRegister("lpHpe", function(module, exports) {

$parcel$export(module.exports, "UniversalProvider", function () { return $f96d9a495098fea9$export$63bc40680ab52599; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $3sHb8 = parcelRequire("3sHb8");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $l0HdX = parcelRequire("l0HdX");

var $eha6O = parcelRequire("eha6O");

var $bjRQh = parcelRequire("bjRQh");

var $8wnFv = parcelRequire("8wnFv");
parcelRequire("7Gasr");
var $6DLsq = parcelRequire("6DLsq");
var $7Gasr = parcelRequire("7Gasr");

var $7FPw1 = parcelRequire("7FPw1");

var $bMQws = parcelRequire("bMQws");

var $cyxGb = parcelRequire("cyxGb");
parcelRequire("9YSHu");
var $3W2Mc = parcelRequire("3W2Mc");
var $f96d9a495098fea9$var$ya = "error", $f96d9a495098fea9$var$Kg = "wss://relay.walletconnect.com", $f96d9a495098fea9$var$Jg = "wc", $f96d9a495098fea9$var$Yg = "universal_provider", $f96d9a495098fea9$var$Sa = "".concat($f96d9a495098fea9$var$Jg, "@2:").concat($f96d9a495098fea9$var$Yg, ":"), $f96d9a495098fea9$var$Zg = "https://rpc.walletconnect.com/v1/", $f96d9a495098fea9$var$Kn = "generic", $f96d9a495098fea9$var$Tt = {
    DEFAULT_CHAIN_CHANGED: "default_chain_changed"
};
var $f96d9a495098fea9$var$_e = (typeof globalThis === "undefined" ? "undefined" : (0, $l0HdX._)(globalThis)) < "u" ? globalThis : (typeof window === "undefined" ? "undefined" : (0, $l0HdX._)(window)) < "u" ? window : (typeof $parcel$global === "undefined" ? "undefined" : (0, $l0HdX._)($parcel$global)) < "u" ? $parcel$global : (typeof self === "undefined" ? "undefined" : (0, $l0HdX._)(self)) < "u" ? self : {}, $f96d9a495098fea9$var$Ui = {
    exports: {}
}; /**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ 
(function(P, s) {
    (function() {
        var i, p = "4.17.21", w = 200, x = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", O = "Expected a function", k = "Invalid `variable` option passed into `_.template`", tn = "__lodash_hash_undefined__", Jn = 500, xn = "__lodash_placeholder__", Ht = 1, Mt = 2, En = 4, yn = 1, me = 2, vt = 1, ln = 2, Gi = 4, Dt = 8, Sn = 16, Nt = 32, On = 64, Bt = 128, Yn = 256, gr = 512, Wa = 30, Ma = "...", Ba = 800, Ga = 16, zi = 1, za = 2, Ka = 3, pn = 1 / 0, nn = 9007199254740991, Ja = 17976931348623157e292, we = 0 / 0, $t = 4294967295, Ya = $t - 1, Za = $t >>> 1, Xa = [
            [
                "ary",
                Bt
            ],
            [
                "bind",
                vt
            ],
            [
                "bindKey",
                ln
            ],
            [
                "curry",
                Dt
            ],
            [
                "curryRight",
                Sn
            ],
            [
                "flip",
                gr
            ],
            [
                "partial",
                Nt
            ],
            [
                "partialRight",
                On
            ],
            [
                "rearg",
                Yn
            ]
        ], Rn = "[object Arguments]", Pe = "[object Array]", Qa = "[object AsyncFunction]", Zn = "[object Boolean]", Xn = "[object Date]", Va = "[object DOMException]", Ce = "[object Error]", Ae = "[object Function]", Ki = "[object GeneratorFunction]", Et = "[object Map]", Qn = "[object Number]", ka = "[object Null]", Gt = "[object Object]", Ji = "[object Promise]", ja = "[object Proxy]", Vn = "[object RegExp]", yt = "[object Set]", kn = "[object String]", Ie = "[object Symbol]", to = "[object Undefined]", jn = "[object WeakMap]", no = "[object WeakSet]", te = "[object ArrayBuffer]", bn = "[object DataView]", vr = "[object Float32Array]", _r = "[object Float64Array]", mr = "[object Int8Array]", wr = "[object Int16Array]", Pr = "[object Int32Array]", Cr = "[object Uint8Array]", Ar = "[object Uint8ClampedArray]", Ir = "[object Uint16Array]", xr = "[object Uint32Array]", eo = /\b__p \+= '';/g, ro = /\b(__p \+=) '' \+/g, io = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Yi = /&(?:amp|lt|gt|quot|#39);/g, Zi = /[&<>"']/g, so = RegExp(Yi.source), uo = RegExp(Zi.source), ao = /<%-([\s\S]+?)%>/g, oo = /<%([\s\S]+?)%>/g, Xi = /<%=([\s\S]+?)%>/g, fo = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, co = /^\w*$/, ho = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Er = /[\\^$.*+?()[\]{}|]/g, lo = RegExp(Er.source), yr = /^\s+/, po = /\s/, go = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, vo = /\{\n\/\* \[wrapped with (.+)\] \*/, _o = /,? & /, mo = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, wo = /[()=,{}\[\]\/\s]/, Po = /\\(\\)?/g, Co = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Qi = /\w*$/, Ao = /^[-+]0x[0-9a-f]+$/i, Io = /^0b[01]+$/i, xo = /^\[object .+?Constructor\]$/, Eo = /^0o[0-7]+$/i, yo = /^(?:0|[1-9]\d*)$/, So = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, xe = /($^)/, Oo = /['\n\r\u2028\u2029\\]/g, Ee = "\ud800-\udfff", Ro = "\\u0300-\\u036f", bo = "\\ufe20-\\ufe2f", To = "\\u20d0-\\u20ff", Vi = Ro + bo + To, ki = "\\u2700-\\u27bf", ji = "a-z\\xdf-\\xf6\\xf8-\\xff", Lo = "\\xac\\xb1\\xd7\\xf7", Ho = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Do = "\\u2000-\\u206f", No = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", ts = "A-Z\\xc0-\\xd6\\xd8-\\xde", ns = "\\ufe0e\\ufe0f", es = Lo + Ho + Do + No, Sr = "['\u2019]", $o = "[" + Ee + "]", rs = "[" + es + "]", ye = "[" + Vi + "]", is = "\\d+", qo = "[" + ki + "]", ss = "[" + ji + "]", us = "[^" + Ee + es + is + ki + ji + ts + "]", Or = "\ud83c[\udffb-\udfff]", Uo = "(?:" + ye + "|" + Or + ")", as = "[^" + Ee + "]", Rr = "(?:\ud83c[\udde6-\uddff]){2}", br = "[\ud800-\udbff][\udc00-\udfff]", Tn = "[" + ts + "]", os = "\\u200d", fs = "(?:" + ss + "|" + us + ")", Fo = "(?:" + Tn + "|" + us + ")", cs = "(?:" + Sr + "(?:d|ll|m|re|s|t|ve))?", hs = "(?:" + Sr + "(?:D|LL|M|RE|S|T|VE))?", ls = Uo + "?", ps = "[" + ns + "]?", Wo = "(?:" + os + "(?:" + [
            as,
            Rr,
            br
        ].join("|") + ")" + ps + ls + ")*", Mo = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Bo = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", ds = ps + ls + Wo, Go = "(?:" + [
            qo,
            Rr,
            br
        ].join("|") + ")" + ds, zo = "(?:" + [
            as + ye + "?",
            ye,
            Rr,
            br,
            $o
        ].join("|") + ")", Ko = RegExp(Sr, "g"), Jo = RegExp(ye, "g"), Tr = RegExp(Or + "(?=" + Or + ")|" + zo + ds, "g"), Yo = RegExp([
            Tn + "?" + ss + "+" + cs + "(?=" + [
                rs,
                Tn,
                "$"
            ].join("|") + ")",
            Fo + "+" + hs + "(?=" + [
                rs,
                Tn + fs,
                "$"
            ].join("|") + ")",
            Tn + "?" + fs + "+" + cs,
            Tn + "+" + hs,
            Bo,
            Mo,
            is,
            Go
        ].join("|"), "g"), Zo = RegExp("[" + os + Ee + Vi + ns + "]"), Xo = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Qo = [
            "Array",
            "Buffer",
            "DataView",
            "Date",
            "Error",
            "Float32Array",
            "Float64Array",
            "Function",
            "Int8Array",
            "Int16Array",
            "Int32Array",
            "Map",
            "Math",
            "Object",
            "Promise",
            "RegExp",
            "Set",
            "String",
            "Symbol",
            "TypeError",
            "Uint8Array",
            "Uint8ClampedArray",
            "Uint16Array",
            "Uint32Array",
            "WeakMap",
            "_",
            "clearTimeout",
            "isFinite",
            "parseInt",
            "setTimeout"
        ], Vo = -1, G = {};
        G[vr] = G[_r] = G[mr] = G[wr] = G[Pr] = G[Cr] = G[Ar] = G[Ir] = G[xr] = !0, G[Rn] = G[Pe] = G[te] = G[Zn] = G[bn] = G[Xn] = G[Ce] = G[Ae] = G[Et] = G[Qn] = G[Gt] = G[Vn] = G[yt] = G[kn] = G[jn] = !1;
        var B = {};
        B[Rn] = B[Pe] = B[te] = B[bn] = B[Zn] = B[Xn] = B[vr] = B[_r] = B[mr] = B[wr] = B[Pr] = B[Et] = B[Qn] = B[Gt] = B[Vn] = B[yt] = B[kn] = B[Ie] = B[Cr] = B[Ar] = B[Ir] = B[xr] = !0, B[Ce] = B[Ae] = B[jn] = !1;
        var ko = {
            "\xc0": "A",
            "\xc1": "A",
            "\xc2": "A",
            "\xc3": "A",
            "\xc4": "A",
            "\xc5": "A",
            "\xe0": "a",
            "\xe1": "a",
            "\xe2": "a",
            "\xe3": "a",
            "\xe4": "a",
            "\xe5": "a",
            "\xc7": "C",
            "\xe7": "c",
            "\xd0": "D",
            "\xf0": "d",
            "\xc8": "E",
            "\xc9": "E",
            "\xca": "E",
            "\xcb": "E",
            "\xe8": "e",
            "\xe9": "e",
            "\xea": "e",
            "\xeb": "e",
            "\xcc": "I",
            "\xcd": "I",
            "\xce": "I",
            "\xcf": "I",
            "\xec": "i",
            "\xed": "i",
            "\xee": "i",
            "\xef": "i",
            "\xd1": "N",
            "\xf1": "n",
            "\xd2": "O",
            "\xd3": "O",
            "\xd4": "O",
            "\xd5": "O",
            "\xd6": "O",
            "\xd8": "O",
            "\xf2": "o",
            "\xf3": "o",
            "\xf4": "o",
            "\xf5": "o",
            "\xf6": "o",
            "\xf8": "o",
            "\xd9": "U",
            "\xda": "U",
            "\xdb": "U",
            "\xdc": "U",
            "\xf9": "u",
            "\xfa": "u",
            "\xfb": "u",
            "\xfc": "u",
            "\xdd": "Y",
            "\xfd": "y",
            "\xff": "y",
            "\xc6": "Ae",
            "\xe6": "ae",
            "\xde": "Th",
            "\xfe": "th",
            "\xdf": "ss",
            \u0100: "A",
            \u0102: "A",
            \u0104: "A",
            \u0101: "a",
            \u0103: "a",
            \u0105: "a",
            \u0106: "C",
            \u0108: "C",
            \u010A: "C",
            \u010C: "C",
            \u0107: "c",
            \u0109: "c",
            \u010B: "c",
            \u010D: "c",
            \u010E: "D",
            \u0110: "D",
            \u010F: "d",
            \u0111: "d",
            \u0112: "E",
            \u0114: "E",
            \u0116: "E",
            \u0118: "E",
            \u011A: "E",
            \u0113: "e",
            \u0115: "e",
            \u0117: "e",
            \u0119: "e",
            \u011B: "e",
            \u011C: "G",
            \u011E: "G",
            \u0120: "G",
            \u0122: "G",
            \u011D: "g",
            \u011F: "g",
            \u0121: "g",
            \u0123: "g",
            \u0124: "H",
            \u0126: "H",
            \u0125: "h",
            \u0127: "h",
            \u0128: "I",
            \u012A: "I",
            \u012C: "I",
            \u012E: "I",
            \u0130: "I",
            \u0129: "i",
            \u012B: "i",
            \u012D: "i",
            \u012F: "i",
            \u0131: "i",
            \u0134: "J",
            \u0135: "j",
            \u0136: "K",
            \u0137: "k",
            \u0138: "k",
            \u0139: "L",
            \u013B: "L",
            \u013D: "L",
            \u013F: "L",
            \u0141: "L",
            \u013A: "l",
            \u013C: "l",
            \u013E: "l",
            \u0140: "l",
            \u0142: "l",
            \u0143: "N",
            \u0145: "N",
            \u0147: "N",
            \u014A: "N",
            \u0144: "n",
            \u0146: "n",
            \u0148: "n",
            \u014B: "n",
            \u014C: "O",
            \u014E: "O",
            \u0150: "O",
            \u014D: "o",
            \u014F: "o",
            \u0151: "o",
            \u0154: "R",
            \u0156: "R",
            \u0158: "R",
            \u0155: "r",
            \u0157: "r",
            \u0159: "r",
            \u015A: "S",
            \u015C: "S",
            \u015E: "S",
            \u0160: "S",
            \u015B: "s",
            \u015D: "s",
            \u015F: "s",
            \u0161: "s",
            \u0162: "T",
            \u0164: "T",
            \u0166: "T",
            \u0163: "t",
            \u0165: "t",
            \u0167: "t",
            \u0168: "U",
            \u016A: "U",
            \u016C: "U",
            \u016E: "U",
            \u0170: "U",
            \u0172: "U",
            \u0169: "u",
            \u016B: "u",
            \u016D: "u",
            \u016F: "u",
            \u0171: "u",
            \u0173: "u",
            \u0174: "W",
            \u0175: "w",
            \u0176: "Y",
            \u0177: "y",
            \u0178: "Y",
            \u0179: "Z",
            \u017B: "Z",
            \u017D: "Z",
            \u017A: "z",
            \u017C: "z",
            \u017E: "z",
            \u0132: "IJ",
            \u0133: "ij",
            \u0152: "Oe",
            \u0153: "oe",
            \u0149: "'n",
            \u017F: "s"
        }, jo = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;"
        }, tf = {
            "&amp;": "&",
            "&lt;": "<",
            "&gt;": ">",
            "&quot;": '"',
            "&#39;": "'"
        }, nf = {
            "\\": "\\",
            "'": "'",
            "\n": "n",
            "\r": "r",
            "\u2028": "u2028",
            "\u2029": "u2029"
        }, ef = parseFloat, rf = parseInt, gs = typeof $f96d9a495098fea9$var$_e == "object" && $f96d9a495098fea9$var$_e && $f96d9a495098fea9$var$_e.Object === Object && $f96d9a495098fea9$var$_e, sf = typeof self == "object" && self && self.Object === Object && self, j = gs || sf || Function("return this")(), Lr = s && !s.nodeType && s, dn = Lr && !0 && P && !P.nodeType && P, vs = dn && dn.exports === Lr, Hr = vs && gs.process, _t = function() {
            try {
                var h = dn && dn.require && dn.require("util").types;
                return h || Hr && Hr.binding && Hr.binding("util");
            } catch (e) {}
        }(), _s = _t && _t.isArrayBuffer, ms = _t && _t.isDate, ws = _t && _t.isMap, Ps = _t && _t.isRegExp, Cs = _t && _t.isSet, As = _t && _t.isTypedArray;
        function ct(h, g, d) {
            switch(d.length){
                case 0:
                    return h.call(g);
                case 1:
                    return h.call(g, d[0]);
                case 2:
                    return h.call(g, d[0], d[1]);
                case 3:
                    return h.call(g, d[0], d[1], d[2]);
            }
            return h.apply(g, d);
        }
        function uf(h, g, d, A) {
            for(var R = -1, q = h == null ? 0 : h.length; ++R < q;){
                var X = h[R];
                g(A, X, d(X), h);
            }
            return A;
        }
        function mt(h, g) {
            for(var d = -1, A = h == null ? 0 : h.length; ++d < A && g(h[d], d, h) !== !1;);
            return h;
        }
        function af(h, g) {
            for(var d = h == null ? 0 : h.length; d-- && g(h[d], d, h) !== !1;);
            return h;
        }
        function Is(h, g) {
            for(var d = -1, A = h == null ? 0 : h.length; ++d < A;)if (!g(h[d], d, h)) return !1;
            return !0;
        }
        function en(h, g) {
            for(var d = -1, A = h == null ? 0 : h.length, R = 0, q = []; ++d < A;){
                var X = h[d];
                g(X, d, h) && (q[R++] = X);
            }
            return q;
        }
        function Se(h, g) {
            var d = h == null ? 0 : h.length;
            return !!d && Ln(h, g, 0) > -1;
        }
        function Dr(h, g, d) {
            for(var A = -1, R = h == null ? 0 : h.length; ++A < R;)if (d(g, h[A])) return !0;
            return !1;
        }
        function z(h, g) {
            for(var d = -1, A = h == null ? 0 : h.length, R = Array(A); ++d < A;)R[d] = g(h[d], d, h);
            return R;
        }
        function rn(h, g) {
            for(var d = -1, A = g.length, R = h.length; ++d < A;)h[R + d] = g[d];
            return h;
        }
        function Nr(h, g, d, A) {
            var R = -1, q = h == null ? 0 : h.length;
            for(A && q && (d = h[++R]); ++R < q;)d = g(d, h[R], R, h);
            return d;
        }
        function of(h, g, d, A) {
            var R = h == null ? 0 : h.length;
            for(A && R && (d = h[--R]); R--;)d = g(d, h[R], R, h);
            return d;
        }
        function $r(h, g) {
            for(var d = -1, A = h == null ? 0 : h.length; ++d < A;)if (g(h[d], d, h)) return !0;
            return !1;
        }
        var ff = qr("length");
        function cf(h) {
            return h.split("");
        }
        function hf(h) {
            return h.match(mo) || [];
        }
        function xs(h, g, d) {
            var A;
            return d(h, function(R, q, X) {
                if (g(R, q, X)) return A = q, !1;
            }), A;
        }
        function Oe(h, g, d, A) {
            for(var R = h.length, q = d + (A ? 1 : -1); A ? q-- : ++q < R;)if (g(h[q], q, h)) return q;
            return -1;
        }
        function Ln(h, g, d) {
            return g === g ? If(h, g, d) : Oe(h, Es, d);
        }
        function lf(h, g, d, A) {
            for(var R = d - 1, q = h.length; ++R < q;)if (A(h[R], g)) return R;
            return -1;
        }
        function Es(h) {
            return h !== h;
        }
        function ys(h, g) {
            var d = h == null ? 0 : h.length;
            return d ? Fr(h, g) / d : we;
        }
        function qr(h) {
            return function(g) {
                return g == null ? i : g[h];
            };
        }
        function Ur(h) {
            return function(g) {
                return h == null ? i : h[g];
            };
        }
        function Ss(h, g, d, A, R) {
            return R(h, function(q, X, M) {
                d = A ? (A = !1, q) : g(d, q, X, M);
            }), d;
        }
        function pf(h, g) {
            var d = h.length;
            for(h.sort(g); d--;)h[d] = h[d].value;
            return h;
        }
        function Fr(h, g) {
            for(var d, A = -1, R = h.length; ++A < R;){
                var q = g(h[A]);
                q !== i && (d = d === i ? q : d + q);
            }
            return d;
        }
        function Wr(h, g) {
            for(var d = -1, A = Array(h); ++d < h;)A[d] = g(d);
            return A;
        }
        function df(h, g) {
            return z(g, function(d) {
                return [
                    d,
                    h[d]
                ];
            });
        }
        function Os(h) {
            return h && h.slice(0, Ls(h) + 1).replace(yr, "");
        }
        function ht(h) {
            return function(g) {
                return h(g);
            };
        }
        function Mr(h, g) {
            return z(g, function(d) {
                return h[d];
            });
        }
        function ne(h, g) {
            return h.has(g);
        }
        function Rs(h, g) {
            for(var d = -1, A = h.length; ++d < A && Ln(g, h[d], 0) > -1;);
            return d;
        }
        function bs(h, g) {
            for(var d = h.length; d-- && Ln(g, h[d], 0) > -1;);
            return d;
        }
        function gf(h, g) {
            for(var d = h.length, A = 0; d--;)h[d] === g && ++A;
            return A;
        }
        var vf = Ur(ko), _f = Ur(jo);
        function mf(h) {
            return "\\" + nf[h];
        }
        function wf(h, g) {
            return h == null ? i : h[g];
        }
        function Hn(h) {
            return Zo.test(h);
        }
        function Pf(h) {
            return Xo.test(h);
        }
        function Cf(h) {
            for(var g, d = []; !(g = h.next()).done;)d.push(g.value);
            return d;
        }
        function Br(h) {
            var g = -1, d = Array(h.size);
            return h.forEach(function(A, R) {
                d[++g] = [
                    R,
                    A
                ];
            }), d;
        }
        function Ts(h, g) {
            return function(d) {
                return h(g(d));
            };
        }
        function sn(h, g) {
            for(var d = -1, A = h.length, R = 0, q = []; ++d < A;){
                var X = h[d];
                (X === g || X === xn) && (h[d] = xn, q[R++] = d);
            }
            return q;
        }
        function Re(h) {
            var g = -1, d = Array(h.size);
            return h.forEach(function(A) {
                d[++g] = A;
            }), d;
        }
        function Af(h) {
            var g = -1, d = Array(h.size);
            return h.forEach(function(A) {
                d[++g] = [
                    A,
                    A
                ];
            }), d;
        }
        function If(h, g, d) {
            for(var A = d - 1, R = h.length; ++A < R;)if (h[A] === g) return A;
            return -1;
        }
        function xf(h, g, d) {
            for(var A = d + 1; A--;)if (h[A] === g) return A;
            return A;
        }
        function Dn(h) {
            return Hn(h) ? yf(h) : ff(h);
        }
        function St(h) {
            return Hn(h) ? Sf(h) : cf(h);
        }
        function Ls(h) {
            for(var g = h.length; g-- && po.test(h.charAt(g)););
            return g;
        }
        var Ef = Ur(tf);
        function yf(h) {
            for(var g = Tr.lastIndex = 0; Tr.test(h);)++g;
            return g;
        }
        function Sf(h) {
            return h.match(Tr) || [];
        }
        function Of(h) {
            return h.match(Yo) || [];
        }
        var Rf = function h(g) {
            g = g == null ? j : Nn.defaults(j.Object(), g, Nn.pick(j, Qo));
            var d = g.Array, A = g.Date, R = g.Error, q = g.Function, X = g.Math, M = g.Object, Gr = g.RegExp, bf = g.String, wt = g.TypeError, be = d.prototype, Tf = q.prototype, $n = M.prototype, Te = g["__core-js_shared__"], Le = Tf.toString, W = $n.hasOwnProperty, Lf = 0, Hs = function() {
                var t = /[^.]+$/.exec(Te && Te.keys && Te.keys.IE_PROTO || "");
                return t ? "Symbol(src)_1." + t : "";
            }(), He = $n.toString, Hf = Le.call(M), Df = j._, Nf = Gr("^" + Le.call(W).replace(Er, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), De = vs ? g.Buffer : i, un = g.Symbol, Ne = g.Uint8Array, Ds = De ? De.allocUnsafe : i, $e = Ts(M.getPrototypeOf, M), Ns = M.create, $s = $n.propertyIsEnumerable, qe = be.splice, qs = un ? un.isConcatSpreadable : i, ee = un ? un.iterator : i, gn = un ? un.toStringTag : i, Ue = function() {
                try {
                    var t = Pn(M, "defineProperty");
                    return t({}, "", {}), t;
                } catch (e) {}
            }(), $f = g.clearTimeout !== j.clearTimeout && g.clearTimeout, qf = A && A.now !== j.Date.now && A.now, Uf = g.setTimeout !== j.setTimeout && g.setTimeout, Fe = X.ceil, We = X.floor, zr = M.getOwnPropertySymbols, Ff = De ? De.isBuffer : i, Us = g.isFinite, Wf = be.join, Mf = Ts(M.keys, M), Q = X.max, nt = X.min, Bf = A.now, Gf = g.parseInt, Fs = X.random, zf = be.reverse, Kr = Pn(g, "DataView"), re = Pn(g, "Map"), Jr = Pn(g, "Promise"), qn = Pn(g, "Set"), ie = Pn(g, "WeakMap"), se = Pn(M, "create"), Me = ie && new ie, Un = {}, Kf = Cn(Kr), Jf = Cn(re), Yf = Cn(Jr), Zf = Cn(qn), Xf = Cn(ie), Be = un ? un.prototype : i, ue = Be ? Be.valueOf : i, Ws = Be ? Be.toString : i;
            function a(t) {
                if (J(t) && !b(t) && !(t instanceof N)) {
                    if (t instanceof Pt) return t;
                    if (W.call(t, "__wrapped__")) return Mu(t);
                }
                return new Pt(t);
            }
            var Fn = function() {
                function t() {}
                return function(n) {
                    if (!K(n)) return {};
                    if (Ns) return Ns(n);
                    t.prototype = n;
                    var e = new t;
                    return t.prototype = i, e;
                };
            }();
            function Ge() {}
            function Pt(t, n) {
                this.__wrapped__ = t, this.__actions__ = [], this.__chain__ = !!n, this.__index__ = 0, this.__values__ = i;
            }
            a.templateSettings = {
                escape: ao,
                evaluate: oo,
                interpolate: Xi,
                variable: "",
                imports: {
                    _: a
                }
            }, a.prototype = Ge.prototype, a.prototype.constructor = a, Pt.prototype = Fn(Ge.prototype), Pt.prototype.constructor = Pt;
            function N(t) {
                this.__wrapped__ = t, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = $t, this.__views__ = [];
            }
            function Qf() {
                var t = new N(this.__wrapped__);
                return t.__actions__ = ut(this.__actions__), t.__dir__ = this.__dir__, t.__filtered__ = this.__filtered__, t.__iteratees__ = ut(this.__iteratees__), t.__takeCount__ = this.__takeCount__, t.__views__ = ut(this.__views__), t;
            }
            function Vf() {
                if (this.__filtered__) {
                    var t = new N(this);
                    t.__dir__ = -1, t.__filtered__ = !0;
                } else t = this.clone(), t.__dir__ *= -1;
                return t;
            }
            function kf() {
                var t = this.__wrapped__.value(), n = this.__dir__, e = b(t), r = n < 0, u = e ? t.length : 0, o = ch(0, u, this.__views__), f = o.start, c = o.end, l = c - f, v = r ? c : f - 1, _ = this.__iteratees__, m = _.length, C = 0, I = nt(l, this.__takeCount__);
                if (!e || !r && u == l && I == l) return cu(t, this.__actions__);
                var y = [];
                t: for(; l-- && C < I;){
                    v += n;
                    for(var L = -1, S = t[v]; ++L < m;){
                        var D = _[L], $ = D.iteratee, dt = D.type, st = $(S);
                        if (dt == za) S = st;
                        else if (!st) {
                            if (dt == zi) continue t;
                            break t;
                        }
                    }
                    y[C++] = S;
                }
                return y;
            }
            N.prototype = Fn(Ge.prototype), N.prototype.constructor = N;
            function vn(t) {
                var n = -1, e = t == null ? 0 : t.length;
                for(this.clear(); ++n < e;){
                    var r = t[n];
                    this.set(r[0], r[1]);
                }
            }
            function jf() {
                this.__data__ = se ? se(null) : {}, this.size = 0;
            }
            function tc(t) {
                var n = this.has(t) && delete this.__data__[t];
                return this.size -= n ? 1 : 0, n;
            }
            function nc(t) {
                var n = this.__data__;
                if (se) {
                    var e = n[t];
                    return e === tn ? i : e;
                }
                return W.call(n, t) ? n[t] : i;
            }
            function ec(t) {
                var n = this.__data__;
                return se ? n[t] !== i : W.call(n, t);
            }
            function rc(t, n) {
                var e = this.__data__;
                return this.size += this.has(t) ? 0 : 1, e[t] = se && n === i ? tn : n, this;
            }
            vn.prototype.clear = jf, vn.prototype.delete = tc, vn.prototype.get = nc, vn.prototype.has = ec, vn.prototype.set = rc;
            function zt(t) {
                var n = -1, e = t == null ? 0 : t.length;
                for(this.clear(); ++n < e;){
                    var r = t[n];
                    this.set(r[0], r[1]);
                }
            }
            function ic() {
                this.__data__ = [], this.size = 0;
            }
            function sc(t) {
                var n = this.__data__, e = ze(n, t);
                if (e < 0) return !1;
                var r = n.length - 1;
                return e == r ? n.pop() : qe.call(n, e, 1), --this.size, !0;
            }
            function uc(t) {
                var n = this.__data__, e = ze(n, t);
                return e < 0 ? i : n[e][1];
            }
            function ac(t) {
                return ze(this.__data__, t) > -1;
            }
            function oc(t, n) {
                var e = this.__data__, r = ze(e, t);
                return r < 0 ? (++this.size, e.push([
                    t,
                    n
                ])) : e[r][1] = n, this;
            }
            zt.prototype.clear = ic, zt.prototype.delete = sc, zt.prototype.get = uc, zt.prototype.has = ac, zt.prototype.set = oc;
            function Kt(t) {
                var n = -1, e = t == null ? 0 : t.length;
                for(this.clear(); ++n < e;){
                    var r = t[n];
                    this.set(r[0], r[1]);
                }
            }
            function fc() {
                this.size = 0, this.__data__ = {
                    hash: new vn,
                    map: new (re || zt),
                    string: new vn
                };
            }
            function cc(t) {
                var n = er(this, t).delete(t);
                return this.size -= n ? 1 : 0, n;
            }
            function hc(t) {
                return er(this, t).get(t);
            }
            function lc(t) {
                return er(this, t).has(t);
            }
            function pc(t, n) {
                var e = er(this, t), r = e.size;
                return e.set(t, n), this.size += e.size == r ? 0 : 1, this;
            }
            Kt.prototype.clear = fc, Kt.prototype.delete = cc, Kt.prototype.get = hc, Kt.prototype.has = lc, Kt.prototype.set = pc;
            function _n(t) {
                var n = -1, e = t == null ? 0 : t.length;
                for(this.__data__ = new Kt; ++n < e;)this.add(t[n]);
            }
            function dc(t) {
                return this.__data__.set(t, tn), this;
            }
            function gc(t) {
                return this.__data__.has(t);
            }
            _n.prototype.add = _n.prototype.push = dc, _n.prototype.has = gc;
            function Ot(t) {
                var n = this.__data__ = new zt(t);
                this.size = n.size;
            }
            function vc() {
                this.__data__ = new zt, this.size = 0;
            }
            function _c(t) {
                var n = this.__data__, e = n.delete(t);
                return this.size = n.size, e;
            }
            function mc(t) {
                return this.__data__.get(t);
            }
            function wc(t) {
                return this.__data__.has(t);
            }
            function Pc(t, n) {
                var e = this.__data__;
                if (e instanceof zt) {
                    var r = e.__data__;
                    if (!re || r.length < w - 1) return r.push([
                        t,
                        n
                    ]), this.size = ++e.size, this;
                    e = this.__data__ = new Kt(r);
                }
                return e.set(t, n), this.size = e.size, this;
            }
            Ot.prototype.clear = vc, Ot.prototype.delete = _c, Ot.prototype.get = mc, Ot.prototype.has = wc, Ot.prototype.set = Pc;
            function Ms(t, n) {
                var e = b(t), r = !e && An(t), u = !e && !r && hn(t), o = !e && !r && !u && Gn(t), f = e || r || u || o, c = f ? Wr(t.length, bf) : [], l = c.length;
                for(var v in t)(n || W.call(t, v)) && !(f && (v == "length" || u && (v == "offset" || v == "parent") || o && (v == "buffer" || v == "byteLength" || v == "byteOffset") || Xt(v, l))) && c.push(v);
                return c;
            }
            function Bs(t) {
                var n = t.length;
                return n ? t[ri(0, n - 1)] : i;
            }
            function Cc(t, n) {
                return rr(ut(t), mn(n, 0, t.length));
            }
            function Ac(t) {
                return rr(ut(t));
            }
            function Yr(t, n, e) {
                (e !== i && !Rt(t[n], e) || e === i && !(n in t)) && Jt(t, n, e);
            }
            function ae(t, n, e) {
                var r = t[n];
                (!(W.call(t, n) && Rt(r, e)) || e === i && !(n in t)) && Jt(t, n, e);
            }
            function ze(t, n) {
                for(var e = t.length; e--;)if (Rt(t[e][0], n)) return e;
                return -1;
            }
            function Ic(t, n, e, r) {
                return an(t, function(u, o, f) {
                    n(r, u, e(u), f);
                }), r;
            }
            function Gs(t, n) {
                return t && Ut(n, V(n), t);
            }
            function xc(t, n) {
                return t && Ut(n, ot(n), t);
            }
            function Jt(t, n, e) {
                n == "__proto__" && Ue ? Ue(t, n, {
                    configurable: !0,
                    enumerable: !0,
                    value: e,
                    writable: !0
                }) : t[n] = e;
            }
            function Zr(t, n) {
                for(var e = -1, r = n.length, u = d(r), o = t == null; ++e < r;)u[e] = o ? i : Oi(t, n[e]);
                return u;
            }
            function mn(t, n, e) {
                return t === t && (e !== i && (t = t <= e ? t : e), n !== i && (t = t >= n ? t : n)), t;
            }
            function Ct(t, n, e, r, u, o) {
                var f, c = n & Ht, l = n & Mt, v = n & En;
                if (e && (f = u ? e(t, r, u, o) : e(t)), f !== i) return f;
                if (!K(t)) return t;
                var _ = b(t);
                if (_) {
                    if (f = lh(t), !c) return ut(t, f);
                } else {
                    var m = et(t), C = m == Ae || m == Ki;
                    if (hn(t)) return pu(t, c);
                    if (m == Gt || m == Rn || C && !u) {
                        if (f = l || C ? {} : Lu(t), !c) return l ? nh(t, xc(f, t)) : th(t, Gs(f, t));
                    } else {
                        if (!B[m]) return u ? t : {};
                        f = ph(t, m, c);
                    }
                }
                o || (o = new Ot);
                var I = o.get(t);
                if (I) return I;
                o.set(t, f), aa(t) ? t.forEach(function(S) {
                    f.add(Ct(S, n, e, S, t, o));
                }) : sa(t) && t.forEach(function(S, D) {
                    f.set(D, Ct(S, n, e, D, t, o));
                });
                var y = v ? l ? di : pi : l ? ot : V, L = _ ? i : y(t);
                return mt(L || t, function(S, D) {
                    L && (D = S, S = t[D]), ae(f, D, Ct(S, n, e, D, t, o));
                }), f;
            }
            function Ec(t) {
                var n = V(t);
                return function(e) {
                    return zs(e, t, n);
                };
            }
            function zs(t, n, e) {
                var r = e.length;
                if (t == null) return !r;
                for(t = M(t); r--;){
                    var u = e[r], o = n[u], f = t[u];
                    if (f === i && !(u in t) || !o(f)) return !1;
                }
                return !0;
            }
            function Ks(t, n, e) {
                if (typeof t != "function") throw new wt(O);
                return de(function() {
                    t.apply(i, e);
                }, n);
            }
            function oe(t, n, e, r) {
                var u = -1, o = Se, f = !0, c = t.length, l = [], v = n.length;
                if (!c) return l;
                e && (n = z(n, ht(e))), r ? (o = Dr, f = !1) : n.length >= w && (o = ne, f = !1, n = new _n(n));
                t: for(; ++u < c;){
                    var _ = t[u], m = e == null ? _ : e(_);
                    if (_ = r || _ !== 0 ? _ : 0, f && m === m) {
                        for(var C = v; C--;)if (n[C] === m) continue t;
                        l.push(_);
                    } else o(n, m, r) || l.push(_);
                }
                return l;
            }
            var an = mu(qt), Js = mu(Qr, !0);
            function yc(t, n) {
                var e = !0;
                return an(t, function(r, u, o) {
                    return e = !!n(r, u, o), e;
                }), e;
            }
            function Ke(t, n, e) {
                for(var r = -1, u = t.length; ++r < u;){
                    var o = t[r], f = n(o);
                    if (f != null && (c === i ? f === f && !pt(f) : e(f, c))) var c = f, l = o;
                }
                return l;
            }
            function Sc(t, n, e, r) {
                var u = t.length;
                for(e = T(e), e < 0 && (e = -e > u ? 0 : u + e), r = r === i || r > u ? u : T(r), r < 0 && (r += u), r = e > r ? 0 : fa(r); e < r;)t[e++] = n;
                return t;
            }
            function Ys(t, n) {
                var e = [];
                return an(t, function(r, u, o) {
                    n(r, u, o) && e.push(r);
                }), e;
            }
            function tt(t, n, e, r, u) {
                var o = -1, f = t.length;
                for(e || (e = gh), u || (u = []); ++o < f;){
                    var c = t[o];
                    n > 0 && e(c) ? n > 1 ? tt(c, n - 1, e, r, u) : rn(u, c) : r || (u[u.length] = c);
                }
                return u;
            }
            var Xr = wu(), Zs = wu(!0);
            function qt(t, n) {
                return t && Xr(t, n, V);
            }
            function Qr(t, n) {
                return t && Zs(t, n, V);
            }
            function Je(t, n) {
                return en(n, function(e) {
                    return Qt(t[e]);
                });
            }
            function wn(t, n) {
                n = fn(n, t);
                for(var e = 0, r = n.length; t != null && e < r;)t = t[Ft(n[e++])];
                return e && e == r ? t : i;
            }
            function Xs(t, n, e) {
                var r = n(t);
                return b(t) ? r : rn(r, e(t));
            }
            function rt(t) {
                return t == null ? t === i ? to : ka : gn && gn in M(t) ? fh(t) : Ah(t);
            }
            function Vr(t, n) {
                return t > n;
            }
            function Oc(t, n) {
                return t != null && W.call(t, n);
            }
            function Rc(t, n) {
                return t != null && n in M(t);
            }
            function bc(t, n, e) {
                return t >= nt(n, e) && t < Q(n, e);
            }
            function kr(t, n, e) {
                for(var r = e ? Dr : Se, u = t[0].length, o = t.length, f = o, c = d(o), l = 1 / 0, v = []; f--;){
                    var _ = t[f];
                    f && n && (_ = z(_, ht(n))), l = nt(_.length, l), c[f] = !e && (n || u >= 120 && _.length >= 120) ? new _n(f && _) : i;
                }
                _ = t[0];
                var m = -1, C = c[0];
                t: for(; ++m < u && v.length < l;){
                    var I = _[m], y = n ? n(I) : I;
                    if (I = e || I !== 0 ? I : 0, !(C ? ne(C, y) : r(v, y, e))) {
                        for(f = o; --f;){
                            var L = c[f];
                            if (!(L ? ne(L, y) : r(t[f], y, e))) continue t;
                        }
                        C && C.push(y), v.push(I);
                    }
                }
                return v;
            }
            function Tc(t, n, e, r) {
                return qt(t, function(u, o, f) {
                    n(r, e(u), o, f);
                }), r;
            }
            function fe(t, n, e) {
                n = fn(n, t), t = $u(t, n);
                var r = t == null ? t : t[Ft(It(n))];
                return r == null ? i : ct(r, t, e);
            }
            function Qs(t) {
                return J(t) && rt(t) == Rn;
            }
            function Lc(t) {
                return J(t) && rt(t) == te;
            }
            function Hc(t) {
                return J(t) && rt(t) == Xn;
            }
            function ce(t, n, e, r, u) {
                return t === n ? !0 : t == null || n == null || !J(t) && !J(n) ? t !== t && n !== n : Dc(t, n, e, r, ce, u);
            }
            function Dc(t, n, e, r, u, o) {
                var f = b(t), c = b(n), l = f ? Pe : et(t), v = c ? Pe : et(n);
                l = l == Rn ? Gt : l, v = v == Rn ? Gt : v;
                var _ = l == Gt, m = v == Gt, C = l == v;
                if (C && hn(t)) {
                    if (!hn(n)) return !1;
                    f = !0, _ = !1;
                }
                if (C && !_) return o || (o = new Ot), f || Gn(t) ? Ru(t, n, e, r, u, o) : ah(t, n, l, e, r, u, o);
                if (!(e & yn)) {
                    var I = _ && W.call(t, "__wrapped__"), y = m && W.call(n, "__wrapped__");
                    if (I || y) {
                        var L = I ? t.value() : t, S = y ? n.value() : n;
                        return o || (o = new Ot), u(L, S, e, r, o);
                    }
                }
                return C ? (o || (o = new Ot), oh(t, n, e, r, u, o)) : !1;
            }
            function Nc(t) {
                return J(t) && et(t) == Et;
            }
            function jr(t, n, e, r) {
                var u = e.length, o = u, f = !r;
                if (t == null) return !o;
                for(t = M(t); u--;){
                    var c = e[u];
                    if (f && c[2] ? c[1] !== t[c[0]] : !(c[0] in t)) return !1;
                }
                for(; ++u < o;){
                    c = e[u];
                    var l = c[0], v = t[l], _ = c[1];
                    if (f && c[2]) {
                        if (v === i && !(l in t)) return !1;
                    } else {
                        var m = new Ot;
                        if (r) var C = r(v, _, l, t, n, m);
                        if (!(C === i ? ce(_, v, yn | me, r, m) : C)) return !1;
                    }
                }
                return !0;
            }
            function Vs(t) {
                if (!K(t) || _h(t)) return !1;
                var n = Qt(t) ? Nf : xo;
                return n.test(Cn(t));
            }
            function $c(t) {
                return J(t) && rt(t) == Vn;
            }
            function qc(t) {
                return J(t) && et(t) == yt;
            }
            function Uc(t) {
                return J(t) && fr(t.length) && !!G[rt(t)];
            }
            function ks(t) {
                return typeof t == "function" ? t : t == null ? ft : typeof t == "object" ? b(t) ? nu(t[0], t[1]) : tu(t) : Pa(t);
            }
            function ti(t) {
                if (!pe(t)) return Mf(t);
                var n = [];
                for(var e in M(t))W.call(t, e) && e != "constructor" && n.push(e);
                return n;
            }
            function Fc(t) {
                if (!K(t)) return Ch(t);
                var n = pe(t), e = [];
                for(var r in t)r == "constructor" && (n || !W.call(t, r)) || e.push(r);
                return e;
            }
            function ni(t, n) {
                return t < n;
            }
            function js(t, n) {
                var e = -1, r = at(t) ? d(t.length) : [];
                return an(t, function(u, o, f) {
                    r[++e] = n(u, o, f);
                }), r;
            }
            function tu(t) {
                var n = vi(t);
                return n.length == 1 && n[0][2] ? Du(n[0][0], n[0][1]) : function(e) {
                    return e === t || jr(e, t, n);
                };
            }
            function nu(t, n) {
                return mi(t) && Hu(n) ? Du(Ft(t), n) : function(e) {
                    var r = Oi(e, t);
                    return r === i && r === n ? Ri(e, t) : ce(n, r, yn | me);
                };
            }
            function Ye(t, n, e, r, u) {
                t !== n && Xr(n, function(o, f) {
                    if (u || (u = new Ot), K(o)) Wc(t, n, f, e, Ye, r, u);
                    else {
                        var c = r ? r(Pi(t, f), o, f + "", t, n, u) : i;
                        c === i && (c = o), Yr(t, f, c);
                    }
                }, ot);
            }
            function Wc(t, n, e, r, u, o, f) {
                var c = Pi(t, e), l = Pi(n, e), v = f.get(l);
                if (v) {
                    Yr(t, e, v);
                    return;
                }
                var _ = o ? o(c, l, e + "", t, n, f) : i, m = _ === i;
                if (m) {
                    var C = b(l), I = !C && hn(l), y = !C && !I && Gn(l);
                    _ = l, C || I || y ? b(c) ? _ = c : Y(c) ? _ = ut(c) : I ? (m = !1, _ = pu(l, !0)) : y ? (m = !1, _ = du(l, !0)) : _ = [] : ge(l) || An(l) ? (_ = c, An(c) ? _ = ca(c) : (!K(c) || Qt(c)) && (_ = Lu(l))) : m = !1;
                }
                m && (f.set(l, _), u(_, l, r, o, f), f.delete(l)), Yr(t, e, _);
            }
            function eu(t, n) {
                var e = t.length;
                if (e) return n += n < 0 ? e : 0, Xt(n, e) ? t[n] : i;
            }
            function ru(t, n, e) {
                n.length ? n = z(n, function(o) {
                    return b(o) ? function(f) {
                        return wn(f, o.length === 1 ? o[0] : o);
                    } : o;
                }) : n = [
                    ft
                ];
                var r = -1;
                n = z(n, ht(E()));
                var u = js(t, function(o, f, c) {
                    var l = z(n, function(v) {
                        return v(o);
                    });
                    return {
                        criteria: l,
                        index: ++r,
                        value: o
                    };
                });
                return pf(u, function(o, f) {
                    return jc(o, f, e);
                });
            }
            function Mc(t, n) {
                return iu(t, n, function(e, r) {
                    return Ri(t, r);
                });
            }
            function iu(t, n, e) {
                for(var r = -1, u = n.length, o = {}; ++r < u;){
                    var f = n[r], c = wn(t, f);
                    e(c, f) && he(o, fn(f, t), c);
                }
                return o;
            }
            function Bc(t) {
                return function(n) {
                    return wn(n, t);
                };
            }
            function ei(t, n, e, r) {
                var u = r ? lf : Ln, o = -1, f = n.length, c = t;
                for(t === n && (n = ut(n)), e && (c = z(t, ht(e))); ++o < f;)for(var l = 0, v = n[o], _ = e ? e(v) : v; (l = u(c, _, l, r)) > -1;)c !== t && qe.call(c, l, 1), qe.call(t, l, 1);
                return t;
            }
            function su(t, n) {
                for(var e = t ? n.length : 0, r = e - 1; e--;){
                    var u = n[e];
                    if (e == r || u !== o) {
                        var o = u;
                        Xt(u) ? qe.call(t, u, 1) : ui(t, u);
                    }
                }
                return t;
            }
            function ri(t, n) {
                return t + We(Fs() * (n - t + 1));
            }
            function Gc(t, n, e, r) {
                for(var u = -1, o = Q(Fe((n - t) / (e || 1)), 0), f = d(o); o--;)f[r ? o : ++u] = t, t += e;
                return f;
            }
            function ii(t, n) {
                var e = "";
                if (!t || n < 1 || n > nn) return e;
                do n % 2 && (e += t), n = We(n / 2), n && (t += t);
                while (n);
                return e;
            }
            function H(t, n) {
                return Ci(Nu(t, n, ft), t + "");
            }
            function zc(t) {
                return Bs(zn(t));
            }
            function Kc(t, n) {
                var e = zn(t);
                return rr(e, mn(n, 0, e.length));
            }
            function he(t, n, e, r) {
                if (!K(t)) return t;
                n = fn(n, t);
                for(var u = -1, o = n.length, f = o - 1, c = t; c != null && ++u < o;){
                    var l = Ft(n[u]), v = e;
                    if (l === "__proto__" || l === "constructor" || l === "prototype") return t;
                    if (u != f) {
                        var _ = c[l];
                        v = r ? r(_, l, c) : i, v === i && (v = K(_) ? _ : Xt(n[u + 1]) ? [] : {});
                    }
                    ae(c, l, v), c = c[l];
                }
                return t;
            }
            var uu = Me ? function uu(t, n) {
                return Me.set(t, n), t;
            } : ft, Jc = Ue ? function Jc(t, n) {
                return Ue(t, "toString", {
                    configurable: !0,
                    enumerable: !1,
                    value: Ti(n),
                    writable: !0
                });
            } : ft;
            function Yc(t) {
                return rr(zn(t));
            }
            function At(t, n, e) {
                var r = -1, u = t.length;
                n < 0 && (n = -n > u ? 0 : u + n), e = e > u ? u : e, e < 0 && (e += u), u = n > e ? 0 : e - n >>> 0, n >>>= 0;
                for(var o = d(u); ++r < u;)o[r] = t[r + n];
                return o;
            }
            function Zc(t, n) {
                var e;
                return an(t, function(r, u, o) {
                    return e = n(r, u, o), !e;
                }), !!e;
            }
            function Ze(t, n, e) {
                var r = 0, u = t == null ? r : t.length;
                if (typeof n == "number" && n === n && u <= Za) {
                    for(; r < u;){
                        var o = r + u >>> 1, f = t[o];
                        f !== null && !pt(f) && (e ? f <= n : f < n) ? r = o + 1 : u = o;
                    }
                    return u;
                }
                return si(t, n, ft, e);
            }
            function si(t, n, e, r) {
                var u = 0, o = t == null ? 0 : t.length;
                if (o === 0) return 0;
                n = e(n);
                for(var f = n !== n, c = n === null, l = pt(n), v = n === i; u < o;){
                    var _ = We((u + o) / 2), m = e(t[_]), C = m !== i, I = m === null, y = m === m, L = pt(m);
                    if (f) var S = r || y;
                    else v ? S = y && (r || C) : c ? S = y && C && (r || !I) : l ? S = y && C && !I && (r || !L) : I || L ? S = !1 : S = r ? m <= n : m < n;
                    S ? u = _ + 1 : o = _;
                }
                return nt(o, Ya);
            }
            function au(t, n) {
                for(var e = -1, r = t.length, u = 0, o = []; ++e < r;){
                    var f = t[e], c = n ? n(f) : f;
                    if (!e || !Rt(c, l)) {
                        var l = c;
                        o[u++] = f === 0 ? 0 : f;
                    }
                }
                return o;
            }
            function ou(t) {
                return typeof t == "number" ? t : pt(t) ? we : +t;
            }
            function lt(t) {
                if (typeof t == "string") return t;
                if (b(t)) return z(t, lt) + "";
                if (pt(t)) return Ws ? Ws.call(t) : "";
                var n = t + "";
                return n == "0" && 1 / t == -pn ? "-0" : n;
            }
            function on(t, n, e) {
                var r = -1, u = Se, o = t.length, f = !0, c = [], l = c;
                if (e) f = !1, u = Dr;
                else if (o >= w) {
                    var v = n ? null : sh(t);
                    if (v) return Re(v);
                    f = !1, u = ne, l = new _n;
                } else l = n ? [] : c;
                t: for(; ++r < o;){
                    var _ = t[r], m = n ? n(_) : _;
                    if (_ = e || _ !== 0 ? _ : 0, f && m === m) {
                        for(var C = l.length; C--;)if (l[C] === m) continue t;
                        n && l.push(m), c.push(_);
                    } else u(l, m, e) || (l !== c && l.push(m), c.push(_));
                }
                return c;
            }
            function ui(t, n) {
                return n = fn(n, t), t = $u(t, n), t == null || delete t[Ft(It(n))];
            }
            function fu(t, n, e, r) {
                return he(t, n, e(wn(t, n)), r);
            }
            function Xe(t, n, e, r) {
                for(var u = t.length, o = r ? u : -1; (r ? o-- : ++o < u) && n(t[o], o, t););
                return e ? At(t, r ? 0 : o, r ? o + 1 : u) : At(t, r ? o + 1 : 0, r ? u : o);
            }
            function cu(t, n) {
                var e = t;
                return e instanceof N && (e = e.value()), Nr(n, function(r, u) {
                    return u.func.apply(u.thisArg, rn([
                        r
                    ], u.args));
                }, e);
            }
            function ai(t, n, e) {
                var r = t.length;
                if (r < 2) return r ? on(t[0]) : [];
                for(var u = -1, o = d(r); ++u < r;)for(var f = t[u], c = -1; ++c < r;)c != u && (o[u] = oe(o[u] || f, t[c], n, e));
                return on(tt(o, 1), n, e);
            }
            function hu(t, n, e) {
                for(var r = -1, u = t.length, o = n.length, f = {}; ++r < u;){
                    var c = r < o ? n[r] : i;
                    e(f, t[r], c);
                }
                return f;
            }
            function oi(t) {
                return Y(t) ? t : [];
            }
            function fi(t) {
                return typeof t == "function" ? t : ft;
            }
            function fn(t, n) {
                return b(t) ? t : mi(t, n) ? [
                    t
                ] : Wu(U(t));
            }
            var Xc = H;
            function cn(t, n, e) {
                var r = t.length;
                return e = e === i ? r : e, !n && e >= r ? t : At(t, n, e);
            }
            var lu = $f || function(t) {
                return j.clearTimeout(t);
            };
            function pu(t, n) {
                if (n) return t.slice();
                var e = t.length, r = Ds ? Ds(e) : new t.constructor(e);
                return t.copy(r), r;
            }
            function ci(t) {
                var n = new t.constructor(t.byteLength);
                return new Ne(n).set(new Ne(t)), n;
            }
            function Qc(t, n) {
                var e = n ? ci(t.buffer) : t.buffer;
                return new t.constructor(e, t.byteOffset, t.byteLength);
            }
            function Vc(t) {
                var n = new t.constructor(t.source, Qi.exec(t));
                return n.lastIndex = t.lastIndex, n;
            }
            function kc(t) {
                return ue ? M(ue.call(t)) : {};
            }
            function du(t, n) {
                var e = n ? ci(t.buffer) : t.buffer;
                return new t.constructor(e, t.byteOffset, t.length);
            }
            function gu(t, n) {
                if (t !== n) {
                    var e = t !== i, r = t === null, u = t === t, o = pt(t), f = n !== i, c = n === null, l = n === n, v = pt(n);
                    if (!c && !v && !o && t > n || o && f && l && !c && !v || r && f && l || !e && l || !u) return 1;
                    if (!r && !o && !v && t < n || v && e && u && !r && !o || c && e && u || !f && u || !l) return -1;
                }
                return 0;
            }
            function jc(t, n, e) {
                for(var r = -1, u = t.criteria, o = n.criteria, f = u.length, c = e.length; ++r < f;){
                    var l = gu(u[r], o[r]);
                    if (l) {
                        if (r >= c) return l;
                        var v = e[r];
                        return l * (v == "desc" ? -1 : 1);
                    }
                }
                return t.index - n.index;
            }
            function vu(t, n, e, r) {
                for(var u = -1, o = t.length, f = e.length, c = -1, l = n.length, v = Q(o - f, 0), _ = d(l + v), m = !r; ++c < l;)_[c] = n[c];
                for(; ++u < f;)(m || u < o) && (_[e[u]] = t[u]);
                for(; v--;)_[c++] = t[u++];
                return _;
            }
            function _u(t, n, e, r) {
                for(var u = -1, o = t.length, f = -1, c = e.length, l = -1, v = n.length, _ = Q(o - c, 0), m = d(_ + v), C = !r; ++u < _;)m[u] = t[u];
                for(var I = u; ++l < v;)m[I + l] = n[l];
                for(; ++f < c;)(C || u < o) && (m[I + e[f]] = t[u++]);
                return m;
            }
            function ut(t, n) {
                var e = -1, r = t.length;
                for(n || (n = d(r)); ++e < r;)n[e] = t[e];
                return n;
            }
            function Ut(t, n, e, r) {
                var u = !e;
                e || (e = {});
                for(var o = -1, f = n.length; ++o < f;){
                    var c = n[o], l = r ? r(e[c], t[c], c, e, t) : i;
                    l === i && (l = t[c]), u ? Jt(e, c, l) : ae(e, c, l);
                }
                return e;
            }
            function th(t, n) {
                return Ut(t, _i(t), n);
            }
            function nh(t, n) {
                return Ut(t, bu(t), n);
            }
            function Qe(t, n) {
                return function(e, r) {
                    var u = b(e) ? uf : Ic, o = n ? n() : {};
                    return u(e, t, E(r, 2), o);
                };
            }
            function Wn(t) {
                return H(function(n, e) {
                    var r = -1, u = e.length, o = u > 1 ? e[u - 1] : i, f = u > 2 ? e[2] : i;
                    for(o = t.length > 3 && typeof o == "function" ? (u--, o) : i, f && it(e[0], e[1], f) && (o = u < 3 ? i : o, u = 1), n = M(n); ++r < u;){
                        var c = e[r];
                        c && t(n, c, r, o);
                    }
                    return n;
                });
            }
            function mu(t, n) {
                return function(e, r) {
                    if (e == null) return e;
                    if (!at(e)) return t(e, r);
                    for(var u = e.length, o = n ? u : -1, f = M(e); (n ? o-- : ++o < u) && r(f[o], o, f) !== !1;);
                    return e;
                };
            }
            function wu(t) {
                return function(n, e, r) {
                    for(var u = -1, o = M(n), f = r(n), c = f.length; c--;){
                        var l = f[t ? c : ++u];
                        if (e(o[l], l, o) === !1) break;
                    }
                    return n;
                };
            }
            function eh(t, n, e) {
                var r = n & vt, u = le(t);
                function o() {
                    var f = this && this !== j && this instanceof o ? u : t;
                    return f.apply(r ? e : this, arguments);
                }
                return o;
            }
            function Pu(t) {
                return function(n) {
                    n = U(n);
                    var e = Hn(n) ? St(n) : i, r = e ? e[0] : n.charAt(0), u = e ? cn(e, 1).join("") : n.slice(1);
                    return r[t]() + u;
                };
            }
            function Mn(t) {
                return function(n) {
                    return Nr(ma(_a(n).replace(Ko, "")), t, "");
                };
            }
            function le(t) {
                return function() {
                    var n = arguments;
                    switch(n.length){
                        case 0:
                            return new t;
                        case 1:
                            return new t(n[0]);
                        case 2:
                            return new t(n[0], n[1]);
                        case 3:
                            return new t(n[0], n[1], n[2]);
                        case 4:
                            return new t(n[0], n[1], n[2], n[3]);
                        case 5:
                            return new t(n[0], n[1], n[2], n[3], n[4]);
                        case 6:
                            return new t(n[0], n[1], n[2], n[3], n[4], n[5]);
                        case 7:
                            return new t(n[0], n[1], n[2], n[3], n[4], n[5], n[6]);
                    }
                    var e = Fn(t.prototype), r = t.apply(e, n);
                    return K(r) ? r : e;
                };
            }
            function rh(t, n, e) {
                var r = le(t);
                function u() {
                    for(var o = arguments.length, f = d(o), c = o, l = Bn(u); c--;)f[c] = arguments[c];
                    var v = o < 3 && f[0] !== l && f[o - 1] !== l ? [] : sn(f, l);
                    if (o -= v.length, o < e) return Eu(t, n, Ve, u.placeholder, i, f, v, i, i, e - o);
                    var _ = this && this !== j && this instanceof u ? r : t;
                    return ct(_, this, f);
                }
                return u;
            }
            function Cu(t) {
                return function(n, e, r) {
                    var u = M(n);
                    if (!at(n)) {
                        var o = E(e, 3);
                        n = V(n), e = function e(c) {
                            return o(u[c], c, u);
                        };
                    }
                    var f = t(n, e, r);
                    return f > -1 ? u[o ? n[f] : f] : i;
                };
            }
            function Au(t) {
                return Zt(function(n) {
                    var e = n.length, r = e, u = Pt.prototype.thru;
                    for(t && n.reverse(); r--;){
                        var o = n[r];
                        if (typeof o != "function") throw new wt(O);
                        if (u && !f && nr(o) == "wrapper") var f = new Pt([], !0);
                    }
                    for(r = f ? r : e; ++r < e;){
                        o = n[r];
                        var c = nr(o), l = c == "wrapper" ? gi(o) : i;
                        l && wi(l[0]) && l[1] == (Bt | Dt | Nt | Yn) && !l[4].length && l[9] == 1 ? f = f[nr(l[0])].apply(f, l[3]) : f = o.length == 1 && wi(o) ? f[c]() : f.thru(o);
                    }
                    return function() {
                        var v = arguments, _ = v[0];
                        if (f && v.length == 1 && b(_)) return f.plant(_).value();
                        for(var m = 0, C = e ? n[m].apply(this, v) : _; ++m < e;)C = n[m].call(this, C);
                        return C;
                    };
                });
            }
            function Ve(t, n, e, r, u, o, f, c, l, v) {
                var _ = n & Bt, m = n & vt, C = n & ln, I = n & (Dt | Sn), y = n & gr, L = C ? i : le(t);
                function S() {
                    for(var D = arguments.length, $ = d(D), dt = D; dt--;)$[dt] = arguments[dt];
                    if (I) var st = Bn(S), gt = gf($, st);
                    if (r && ($ = vu($, r, u, I)), o && ($ = _u($, o, f, I)), D -= gt, I && D < v) {
                        var Z = sn($, st);
                        return Eu(t, n, Ve, S.placeholder, e, $, Z, c, l, v - D);
                    }
                    var bt = m ? e : this, kt = C ? bt[t] : t;
                    return D = $.length, c ? $ = Ih($, c) : y && D > 1 && $.reverse(), _ && l < D && ($.length = l), this && this !== j && this instanceof S && (kt = L || le(kt)), kt.apply(bt, $);
                }
                return S;
            }
            function Iu(t, n) {
                return function(e, r) {
                    return Tc(e, t, n(r), {});
                };
            }
            function ke(t, n) {
                return function(e, r) {
                    var u;
                    if (e === i && r === i) return n;
                    if (e !== i && (u = e), r !== i) {
                        if (u === i) return r;
                        typeof e == "string" || typeof r == "string" ? (e = lt(e), r = lt(r)) : (e = ou(e), r = ou(r)), u = t(e, r);
                    }
                    return u;
                };
            }
            function hi(t) {
                return Zt(function(n) {
                    return n = z(n, ht(E())), H(function(e) {
                        var r = this;
                        return t(n, function(u) {
                            return ct(u, r, e);
                        });
                    });
                });
            }
            function je(t, n) {
                n = n === i ? " " : lt(n);
                var e = n.length;
                if (e < 2) return e ? ii(n, t) : n;
                var r = ii(n, Fe(t / Dn(n)));
                return Hn(n) ? cn(St(r), 0, t).join("") : r.slice(0, t);
            }
            function ih(t, n, e, r) {
                var u = n & vt, o = le(t);
                function f() {
                    for(var c = -1, l = arguments.length, v = -1, _ = r.length, m = d(_ + l), C = this && this !== j && this instanceof f ? o : t; ++v < _;)m[v] = r[v];
                    for(; l--;)m[v++] = arguments[++c];
                    return ct(C, u ? e : this, m);
                }
                return f;
            }
            function xu(t) {
                return function(n, e, r) {
                    return r && typeof r != "number" && it(n, e, r) && (e = r = i), n = Vt(n), e === i ? (e = n, n = 0) : e = Vt(e), r = r === i ? n < e ? 1 : -1 : Vt(r), Gc(n, e, r, t);
                };
            }
            function tr(t) {
                return function(n, e) {
                    return typeof n == "string" && typeof e == "string" || (n = xt(n), e = xt(e)), t(n, e);
                };
            }
            function Eu(t, n, e, r, u, o, f, c, l, v) {
                var _ = n & Dt, m = _ ? f : i, C = _ ? i : f, I = _ ? o : i, y = _ ? i : o;
                n |= _ ? Nt : On, n &= ~(_ ? On : Nt), n & Gi || (n &= ~(vt | ln));
                var L = [
                    t,
                    n,
                    u,
                    I,
                    m,
                    y,
                    C,
                    c,
                    l,
                    v
                ], S = e.apply(i, L);
                return wi(t) && qu(S, L), S.placeholder = r, Uu(S, t, n);
            }
            function li(t) {
                var n = X[t];
                return function(e, r) {
                    if (e = xt(e), r = r == null ? 0 : nt(T(r), 292), r && Us(e)) {
                        var u = (U(e) + "e").split("e"), o = n(u[0] + "e" + (+u[1] + r));
                        return u = (U(o) + "e").split("e"), +(u[0] + "e" + (+u[1] - r));
                    }
                    return n(e);
                };
            }
            var sh = qn && 1 / Re(new qn([
                ,
                -0
            ]))[1] == pn ? function sh(t) {
                return new qn(t);
            } : Di;
            function yu(t) {
                return function(n) {
                    var e = et(n);
                    return e == Et ? Br(n) : e == yt ? Af(n) : df(n, t(n));
                };
            }
            function Yt(t, n, e, r, u, o, f, c) {
                var l = n & ln;
                if (!l && typeof t != "function") throw new wt(O);
                var v = r ? r.length : 0;
                if (v || (n &= ~(Nt | On), r = u = i), f = f === i ? f : Q(T(f), 0), c = c === i ? c : T(c), v -= u ? u.length : 0, n & On) {
                    var _ = r, m = u;
                    r = u = i;
                }
                var C = l ? i : gi(t), I = [
                    t,
                    n,
                    e,
                    r,
                    u,
                    _,
                    m,
                    o,
                    f,
                    c
                ];
                if (C && Ph(I, C), t = I[0], n = I[1], e = I[2], r = I[3], u = I[4], c = I[9] = I[9] === i ? l ? 0 : t.length : Q(I[9] - v, 0), !c && n & (Dt | Sn) && (n &= ~(Dt | Sn)), !n || n == vt) var y = eh(t, n, e);
                else n == Dt || n == Sn ? y = rh(t, n, c) : (n == Nt || n == (vt | Nt)) && !u.length ? y = ih(t, n, e, r) : y = Ve.apply(i, I);
                var L = C ? uu : qu;
                return Uu(L(y, I), t, n);
            }
            function Su(t, n, e, r) {
                return t === i || Rt(t, $n[e]) && !W.call(r, e) ? n : t;
            }
            function Ou(t, n, e, r, u, o) {
                return K(t) && K(n) && (o.set(n, t), Ye(t, n, i, Ou, o), o.delete(n)), t;
            }
            function uh(t) {
                return ge(t) ? i : t;
            }
            function Ru(t, n, e, r, u, o) {
                var f = e & yn, c = t.length, l = n.length;
                if (c != l && !(f && l > c)) return !1;
                var v = o.get(t), _ = o.get(n);
                if (v && _) return v == n && _ == t;
                var m = -1, C = !0, I = e & me ? new _n : i;
                for(o.set(t, n), o.set(n, t); ++m < c;){
                    var y = t[m], L = n[m];
                    if (r) var S = f ? r(L, y, m, n, t, o) : r(y, L, m, t, n, o);
                    if (S !== i) {
                        if (S) continue;
                        C = !1;
                        break;
                    }
                    if (I) {
                        if (!$r(n, function(D, $) {
                            if (!ne(I, $) && (y === D || u(y, D, e, r, o))) return I.push($);
                        })) {
                            C = !1;
                            break;
                        }
                    } else if (!(y === L || u(y, L, e, r, o))) {
                        C = !1;
                        break;
                    }
                }
                return o.delete(t), o.delete(n), C;
            }
            function ah(t, n, e, r, u, o, f) {
                switch(e){
                    case bn:
                        if (t.byteLength != n.byteLength || t.byteOffset != n.byteOffset) return !1;
                        t = t.buffer, n = n.buffer;
                    case te:
                        return !(t.byteLength != n.byteLength || !o(new Ne(t), new Ne(n)));
                    case Zn:
                    case Xn:
                    case Qn:
                        return Rt(+t, +n);
                    case Ce:
                        return t.name == n.name && t.message == n.message;
                    case Vn:
                    case kn:
                        return t == n + "";
                    case Et:
                        var c = Br;
                    case yt:
                        var l = r & yn;
                        if (c || (c = Re), t.size != n.size && !l) return !1;
                        var v = f.get(t);
                        if (v) return v == n;
                        r |= me, f.set(t, n);
                        var _ = Ru(c(t), c(n), r, u, o, f);
                        return f.delete(t), _;
                    case Ie:
                        if (ue) return ue.call(t) == ue.call(n);
                }
                return !1;
            }
            function oh(t, n, e, r, u, o) {
                var f = e & yn, c = pi(t), l = c.length, v = pi(n), _ = v.length;
                if (l != _ && !f) return !1;
                for(var m = l; m--;){
                    var C = c[m];
                    if (!(f ? C in n : W.call(n, C))) return !1;
                }
                var I = o.get(t), y = o.get(n);
                if (I && y) return I == n && y == t;
                var L = !0;
                o.set(t, n), o.set(n, t);
                for(var S = f; ++m < l;){
                    C = c[m];
                    var D = t[C], $ = n[C];
                    if (r) var dt = f ? r($, D, C, n, t, o) : r(D, $, C, t, n, o);
                    if (!(dt === i ? D === $ || u(D, $, e, r, o) : dt)) {
                        L = !1;
                        break;
                    }
                    S || (S = C == "constructor");
                }
                if (L && !S) {
                    var st = t.constructor, gt = n.constructor;
                    st != gt && "constructor" in t && "constructor" in n && !(typeof st == "function" && st instanceof st && typeof gt == "function" && gt instanceof gt) && (L = !1);
                }
                return o.delete(t), o.delete(n), L;
            }
            function Zt(t) {
                return Ci(Nu(t, i, zu), t + "");
            }
            function pi(t) {
                return Xs(t, V, _i);
            }
            function di(t) {
                return Xs(t, ot, bu);
            }
            var gi = Me ? function gi(t) {
                return Me.get(t);
            } : Di;
            function nr(t) {
                for(var n = t.name + "", e = Un[n], r = W.call(Un, n) ? e.length : 0; r--;){
                    var u = e[r], o = u.func;
                    if (o == null || o == t) return u.name;
                }
                return n;
            }
            function Bn(t) {
                var n = W.call(a, "placeholder") ? a : t;
                return n.placeholder;
            }
            function E() {
                var t = a.iteratee || Li;
                return t = t === Li ? ks : t, arguments.length ? t(arguments[0], arguments[1]) : t;
            }
            function er(t, n) {
                var e = t.__data__;
                return vh(n) ? e[typeof n == "string" ? "string" : "hash"] : e.map;
            }
            function vi(t) {
                for(var n = V(t), e = n.length; e--;){
                    var r = n[e], u = t[r];
                    n[e] = [
                        r,
                        u,
                        Hu(u)
                    ];
                }
                return n;
            }
            function Pn(t, n) {
                var e = wf(t, n);
                return Vs(e) ? e : i;
            }
            function fh(t) {
                var n = W.call(t, gn), e = t[gn];
                try {
                    t[gn] = i;
                    var r = !0;
                } catch (e) {}
                var u = He.call(t);
                return r && (n ? t[gn] = e : delete t[gn]), u;
            }
            var _i = zr ? function _i(t) {
                return t == null ? [] : (t = M(t), en(zr(t), function(n) {
                    return $s.call(t, n);
                }));
            } : Ni, bu = zr ? function bu(t) {
                for(var n = []; t;)rn(n, _i(t)), t = $e(t);
                return n;
            } : Ni, et = rt;
            (Kr && et(new Kr(new ArrayBuffer(1))) != bn || re && et(new re) != Et || Jr && et(Jr.resolve()) != Ji || qn && et(new qn) != yt || ie && et(new ie) != jn) && (et = function et(t) {
                var n = rt(t), e = n == Gt ? t.constructor : i, r = e ? Cn(e) : "";
                if (r) switch(r){
                    case Kf:
                        return bn;
                    case Jf:
                        return Et;
                    case Yf:
                        return Ji;
                    case Zf:
                        return yt;
                    case Xf:
                        return jn;
                }
                return n;
            });
            function ch(t, n, e) {
                for(var r = -1, u = e.length; ++r < u;){
                    var o = e[r], f = o.size;
                    switch(o.type){
                        case "drop":
                            t += f;
                            break;
                        case "dropRight":
                            n -= f;
                            break;
                        case "take":
                            n = nt(n, t + f);
                            break;
                        case "takeRight":
                            t = Q(t, n - f);
                            break;
                    }
                }
                return {
                    start: t,
                    end: n
                };
            }
            function hh(t) {
                var n = t.match(vo);
                return n ? n[1].split(_o) : [];
            }
            function Tu(t, n, e) {
                n = fn(n, t);
                for(var r = -1, u = n.length, o = !1; ++r < u;){
                    var f = Ft(n[r]);
                    if (!(o = t != null && e(t, f))) break;
                    t = t[f];
                }
                return o || ++r != u ? o : (u = t == null ? 0 : t.length, !!u && fr(u) && Xt(f, u) && (b(t) || An(t)));
            }
            function lh(t) {
                var n = t.length, e = new t.constructor(n);
                return n && typeof t[0] == "string" && W.call(t, "index") && (e.index = t.index, e.input = t.input), e;
            }
            function Lu(t) {
                return typeof t.constructor == "function" && !pe(t) ? Fn($e(t)) : {};
            }
            function ph(t, n, e) {
                var r = t.constructor;
                switch(n){
                    case te:
                        return ci(t);
                    case Zn:
                    case Xn:
                        return new r(+t);
                    case bn:
                        return Qc(t, e);
                    case vr:
                    case _r:
                    case mr:
                    case wr:
                    case Pr:
                    case Cr:
                    case Ar:
                    case Ir:
                    case xr:
                        return du(t, e);
                    case Et:
                        return new r;
                    case Qn:
                    case kn:
                        return new r(t);
                    case Vn:
                        return Vc(t);
                    case yt:
                        return new r;
                    case Ie:
                        return kc(t);
                }
            }
            function dh(t, n) {
                var e = n.length;
                if (!e) return t;
                var r = e - 1;
                return n[r] = (e > 1 ? "& " : "") + n[r], n = n.join(e > 2 ? ", " : " "), t.replace(go, "{\n/* [wrapped with " + n + "] */\n");
            }
            function gh(t) {
                return b(t) || An(t) || !!(qs && t && t[qs]);
            }
            function Xt(t, n) {
                var e = typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t);
                return n = n !== null && n !== void 0 ? n : nn, !!n && (e == "number" || e != "symbol" && yo.test(t)) && t > -1 && t % 1 == 0 && t < n;
            }
            function it(t, n, e) {
                if (!K(e)) return !1;
                var r = typeof n === "undefined" ? "undefined" : (0, $l0HdX._)(n);
                return (r == "number" ? at(e) && Xt(n, e.length) : r == "string" && n in e) ? Rt(e[n], t) : !1;
            }
            function mi(t, n) {
                if (b(t)) return !1;
                var e = typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t);
                return e == "number" || e == "symbol" || e == "boolean" || t == null || pt(t) ? !0 : co.test(t) || !fo.test(t) || n != null && t in M(n);
            }
            function vh(t) {
                var n = typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t);
                return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? t !== "__proto__" : t === null;
            }
            function wi(t) {
                var n = nr(t), e = a[n];
                if (typeof e != "function" || !(n in N.prototype)) return !1;
                if (t === e) return !0;
                var r = gi(e);
                return !!r && t === r[0];
            }
            function _h(t) {
                return !!Hs && Hs in t;
            }
            var mh = Te ? Qt : $i;
            function pe(t) {
                var n = t && t.constructor, e = typeof n == "function" && n.prototype || $n;
                return t === e;
            }
            function Hu(t) {
                return t === t && !K(t);
            }
            function Du(t, n) {
                return function(e) {
                    return e == null ? !1 : e[t] === n && (n !== i || t in M(e));
                };
            }
            function wh(t) {
                var n = ar(t, function(r) {
                    return e.size === Jn && e.clear(), r;
                }), e = n.cache;
                return n;
            }
            function Ph(t, n) {
                var e = t[1], r = n[1], u = e | r, o = u < (vt | ln | Bt), f = r == Bt && e == Dt || r == Bt && e == Yn && t[7].length <= n[8] || r == (Bt | Yn) && n[7].length <= n[8] && e == Dt;
                if (!(o || f)) return t;
                r & vt && (t[2] = n[2], u |= e & vt ? 0 : Gi);
                var c = n[3];
                if (c) {
                    var l = t[3];
                    t[3] = l ? vu(l, c, n[4]) : c, t[4] = l ? sn(t[3], xn) : n[4];
                }
                return c = n[5], c && (l = t[5], t[5] = l ? _u(l, c, n[6]) : c, t[6] = l ? sn(t[5], xn) : n[6]), c = n[7], c && (t[7] = c), r & Bt && (t[8] = t[8] == null ? n[8] : nt(t[8], n[8])), t[9] == null && (t[9] = n[9]), t[0] = n[0], t[1] = u, t;
            }
            function Ch(t) {
                var n = [];
                if (t != null) for(var e in M(t))n.push(e);
                return n;
            }
            function Ah(t) {
                return He.call(t);
            }
            function Nu(t, n, e) {
                return n = Q(n === i ? t.length - 1 : n, 0), function() {
                    for(var r = arguments, u = -1, o = Q(r.length - n, 0), f = d(o); ++u < o;)f[u] = r[n + u];
                    u = -1;
                    for(var c = d(n + 1); ++u < n;)c[u] = r[u];
                    return c[n] = e(f), ct(t, this, c);
                };
            }
            function $u(t, n) {
                return n.length < 2 ? t : wn(t, At(n, 0, -1));
            }
            function Ih(t, n) {
                for(var e = t.length, r = nt(n.length, e), u = ut(t); r--;){
                    var o = n[r];
                    t[r] = Xt(o, e) ? u[o] : i;
                }
                return t;
            }
            function Pi(t, n) {
                if (!(n === "constructor" && typeof t[n] == "function") && n != "__proto__") return t[n];
            }
            var qu = Fu(uu), de = Uf || function(t, n) {
                return j.setTimeout(t, n);
            }, Ci = Fu(Jc);
            function Uu(t, n, e) {
                var r = n + "";
                return Ci(t, dh(r, xh(hh(r), e)));
            }
            function Fu(t) {
                var n = 0, e = 0;
                return function() {
                    var r = Bf(), u = Ga - (r - e);
                    if (e = r, u > 0) {
                        if (++n >= Ba) return arguments[0];
                    } else n = 0;
                    return t.apply(i, arguments);
                };
            }
            function rr(t, n) {
                var e = -1, r = t.length, u = r - 1;
                for(n = n === i ? r : n; ++e < n;){
                    var o = ri(e, u), f = t[o];
                    t[o] = t[e], t[e] = f;
                }
                return t.length = n, t;
            }
            var Wu = wh(function(t) {
                var n = [];
                return t.charCodeAt(0) === 46 && n.push(""), t.replace(ho, function(e, r, u, o) {
                    n.push(u ? o.replace(Po, "$1") : r || e);
                }), n;
            });
            function Ft(t) {
                if (typeof t == "string" || pt(t)) return t;
                var n = t + "";
                return n == "0" && 1 / t == -pn ? "-0" : n;
            }
            function Cn(t) {
                if (t != null) {
                    try {
                        return Le.call(t);
                    } catch (e) {}
                    try {
                        return t + "";
                    } catch (e) {}
                }
                return "";
            }
            function xh(t, n) {
                return mt(Xa, function(e) {
                    var r = "_." + e[0];
                    n & e[1] && !Se(t, r) && t.push(r);
                }), t.sort();
            }
            function Mu(t) {
                if (t instanceof N) return t.clone();
                var n = new Pt(t.__wrapped__, t.__chain__);
                return n.__actions__ = ut(t.__actions__), n.__index__ = t.__index__, n.__values__ = t.__values__, n;
            }
            function Eh(t, n, e) {
                (e ? it(t, n, e) : n === i) ? n = 1 : n = Q(T(n), 0);
                var r = t == null ? 0 : t.length;
                if (!r || n < 1) return [];
                for(var u = 0, o = 0, f = d(Fe(r / n)); u < r;)f[o++] = At(t, u, u += n);
                return f;
            }
            function yh(t) {
                for(var n = -1, e = t == null ? 0 : t.length, r = 0, u = []; ++n < e;){
                    var o = t[n];
                    o && (u[r++] = o);
                }
                return u;
            }
            function Sh() {
                var t = arguments.length;
                if (!t) return [];
                for(var n = d(t - 1), e = arguments[0], r = t; r--;)n[r - 1] = arguments[r];
                return rn(b(e) ? ut(e) : [
                    e
                ], tt(n, 1));
            }
            var Oh = H(function(t, n) {
                return Y(t) ? oe(t, tt(n, 1, Y, !0)) : [];
            }), Rh = H(function(t, n) {
                var e = It(n);
                return Y(e) && (e = i), Y(t) ? oe(t, tt(n, 1, Y, !0), E(e, 2)) : [];
            }), bh = H(function(t, n) {
                var e = It(n);
                return Y(e) && (e = i), Y(t) ? oe(t, tt(n, 1, Y, !0), i, e) : [];
            });
            function Th(t, n, e) {
                var r = t == null ? 0 : t.length;
                return r ? (n = e || n === i ? 1 : T(n), At(t, n < 0 ? 0 : n, r)) : [];
            }
            function Lh(t, n, e) {
                var r = t == null ? 0 : t.length;
                return r ? (n = e || n === i ? 1 : T(n), n = r - n, At(t, 0, n < 0 ? 0 : n)) : [];
            }
            function Hh(t, n) {
                return t && t.length ? Xe(t, E(n, 3), !0, !0) : [];
            }
            function Dh(t, n) {
                return t && t.length ? Xe(t, E(n, 3), !0) : [];
            }
            function Nh(t, n, e, r) {
                var u = t == null ? 0 : t.length;
                return u ? (e && typeof e != "number" && it(t, n, e) && (e = 0, r = u), Sc(t, n, e, r)) : [];
            }
            function Bu(t, n, e) {
                var r = t == null ? 0 : t.length;
                if (!r) return -1;
                var u = e == null ? 0 : T(e);
                return u < 0 && (u = Q(r + u, 0)), Oe(t, E(n, 3), u);
            }
            function Gu(t, n, e) {
                var r = t == null ? 0 : t.length;
                if (!r) return -1;
                var u = r - 1;
                return e !== i && (u = T(e), u = e < 0 ? Q(r + u, 0) : nt(u, r - 1)), Oe(t, E(n, 3), u, !0);
            }
            function zu(t) {
                var n = t == null ? 0 : t.length;
                return n ? tt(t, 1) : [];
            }
            function $h(t) {
                var n = t == null ? 0 : t.length;
                return n ? tt(t, pn) : [];
            }
            function qh(t, n) {
                var e = t == null ? 0 : t.length;
                return e ? (n = n === i ? 1 : T(n), tt(t, n)) : [];
            }
            function Uh(t) {
                for(var n = -1, e = t == null ? 0 : t.length, r = {}; ++n < e;){
                    var u = t[n];
                    r[u[0]] = u[1];
                }
                return r;
            }
            function Ku(t) {
                return t && t.length ? t[0] : i;
            }
            function Fh(t, n, e) {
                var r = t == null ? 0 : t.length;
                if (!r) return -1;
                var u = e == null ? 0 : T(e);
                return u < 0 && (u = Q(r + u, 0)), Ln(t, n, u);
            }
            function Wh(t) {
                var n = t == null ? 0 : t.length;
                return n ? At(t, 0, -1) : [];
            }
            var Mh = H(function(t) {
                var n = z(t, oi);
                return n.length && n[0] === t[0] ? kr(n) : [];
            }), Bh = H(function(t) {
                var n = It(t), e = z(t, oi);
                return n === It(e) ? n = i : e.pop(), e.length && e[0] === t[0] ? kr(e, E(n, 2)) : [];
            }), Gh = H(function(t) {
                var n = It(t), e = z(t, oi);
                return n = typeof n == "function" ? n : i, n && e.pop(), e.length && e[0] === t[0] ? kr(e, i, n) : [];
            });
            function zh(t, n) {
                return t == null ? "" : Wf.call(t, n);
            }
            function It(t) {
                var n = t == null ? 0 : t.length;
                return n ? t[n - 1] : i;
            }
            function Kh(t, n, e) {
                var r = t == null ? 0 : t.length;
                if (!r) return -1;
                var u = r;
                return e !== i && (u = T(e), u = u < 0 ? Q(r + u, 0) : nt(u, r - 1)), n === n ? xf(t, n, u) : Oe(t, Es, u, !0);
            }
            function Jh(t, n) {
                return t && t.length ? eu(t, T(n)) : i;
            }
            var Yh = H(Ju);
            function Ju(t, n) {
                return t && t.length && n && n.length ? ei(t, n) : t;
            }
            function Zh(t, n, e) {
                return t && t.length && n && n.length ? ei(t, n, E(e, 2)) : t;
            }
            function Xh(t, n, e) {
                return t && t.length && n && n.length ? ei(t, n, i, e) : t;
            }
            var Qh = Zt(function(t, n) {
                var e = t == null ? 0 : t.length, r = Zr(t, n);
                return su(t, z(n, function(u) {
                    return Xt(u, e) ? +u : u;
                }).sort(gu)), r;
            });
            function Vh(t, n) {
                var e = [];
                if (!(t && t.length)) return e;
                var r = -1, u = [], o = t.length;
                for(n = E(n, 3); ++r < o;){
                    var f = t[r];
                    n(f, r, t) && (e.push(f), u.push(r));
                }
                return su(t, u), e;
            }
            function Ai(t) {
                return t == null ? t : zf.call(t);
            }
            function kh(t, n, e) {
                var r = t == null ? 0 : t.length;
                return r ? (e && typeof e != "number" && it(t, n, e) ? (n = 0, e = r) : (n = n == null ? 0 : T(n), e = e === i ? r : T(e)), At(t, n, e)) : [];
            }
            function jh(t, n) {
                return Ze(t, n);
            }
            function tl(t, n, e) {
                return si(t, n, E(e, 2));
            }
            function nl(t, n) {
                var e = t == null ? 0 : t.length;
                if (e) {
                    var r = Ze(t, n);
                    if (r < e && Rt(t[r], n)) return r;
                }
                return -1;
            }
            function el(t, n) {
                return Ze(t, n, !0);
            }
            function rl(t, n, e) {
                return si(t, n, E(e, 2), !0);
            }
            function il(t, n) {
                var e = t == null ? 0 : t.length;
                if (e) {
                    var r = Ze(t, n, !0) - 1;
                    if (Rt(t[r], n)) return r;
                }
                return -1;
            }
            function sl(t) {
                return t && t.length ? au(t) : [];
            }
            function ul(t, n) {
                return t && t.length ? au(t, E(n, 2)) : [];
            }
            function al(t) {
                var n = t == null ? 0 : t.length;
                return n ? At(t, 1, n) : [];
            }
            function ol(t, n, e) {
                return t && t.length ? (n = e || n === i ? 1 : T(n), At(t, 0, n < 0 ? 0 : n)) : [];
            }
            function fl(t, n, e) {
                var r = t == null ? 0 : t.length;
                return r ? (n = e || n === i ? 1 : T(n), n = r - n, At(t, n < 0 ? 0 : n, r)) : [];
            }
            function cl(t, n) {
                return t && t.length ? Xe(t, E(n, 3), !1, !0) : [];
            }
            function hl(t, n) {
                return t && t.length ? Xe(t, E(n, 3)) : [];
            }
            var ll = H(function(t) {
                return on(tt(t, 1, Y, !0));
            }), pl = H(function(t) {
                var n = It(t);
                return Y(n) && (n = i), on(tt(t, 1, Y, !0), E(n, 2));
            }), dl = H(function(t) {
                var n = It(t);
                return n = typeof n == "function" ? n : i, on(tt(t, 1, Y, !0), i, n);
            });
            function gl(t) {
                return t && t.length ? on(t) : [];
            }
            function vl(t, n) {
                return t && t.length ? on(t, E(n, 2)) : [];
            }
            function _l(t, n) {
                return n = typeof n == "function" ? n : i, t && t.length ? on(t, i, n) : [];
            }
            function Ii(t) {
                if (!(t && t.length)) return [];
                var n = 0;
                return t = en(t, function(e) {
                    if (Y(e)) return n = Q(e.length, n), !0;
                }), Wr(n, function(e) {
                    return z(t, qr(e));
                });
            }
            function Yu(t, n) {
                if (!(t && t.length)) return [];
                var e = Ii(t);
                return n == null ? e : z(e, function(r) {
                    return ct(n, i, r);
                });
            }
            var ml = H(function(t, n) {
                return Y(t) ? oe(t, n) : [];
            }), wl = H(function(t) {
                return ai(en(t, Y));
            }), Pl = H(function(t) {
                var n = It(t);
                return Y(n) && (n = i), ai(en(t, Y), E(n, 2));
            }), Cl = H(function(t) {
                var n = It(t);
                return n = typeof n == "function" ? n : i, ai(en(t, Y), i, n);
            }), Al = H(Ii);
            function Il(t, n) {
                return hu(t || [], n || [], ae);
            }
            function xl(t, n) {
                return hu(t || [], n || [], he);
            }
            var El = H(function(t) {
                var n = t.length, e = n > 1 ? t[n - 1] : i;
                return e = typeof e == "function" ? (t.pop(), e) : i, Yu(t, e);
            });
            function Zu(t) {
                var n = a(t);
                return n.__chain__ = !0, n;
            }
            function yl(t, n) {
                return n(t), t;
            }
            function ir(t, n) {
                return n(t);
            }
            var Sl = Zt(function(t) {
                var n = t.length, e = n ? t[0] : 0, r = this.__wrapped__, u = function u(o) {
                    return Zr(o, t);
                };
                return n > 1 || this.__actions__.length || !(r instanceof N) || !Xt(e) ? this.thru(u) : (r = r.slice(e, +e + (n ? 1 : 0)), r.__actions__.push({
                    func: ir,
                    args: [
                        u
                    ],
                    thisArg: i
                }), new Pt(r, this.__chain__).thru(function(o) {
                    return n && !o.length && o.push(i), o;
                }));
            });
            function Ol() {
                return Zu(this);
            }
            function Rl() {
                return new Pt(this.value(), this.__chain__);
            }
            function bl() {
                this.__values__ === i && (this.__values__ = oa(this.value()));
                var t = this.__index__ >= this.__values__.length, n = t ? i : this.__values__[this.__index__++];
                return {
                    done: t,
                    value: n
                };
            }
            function Tl() {
                return this;
            }
            function Ll(t) {
                for(var n, e = this; e instanceof Ge;){
                    var r = Mu(e);
                    r.__index__ = 0, r.__values__ = i, n ? u.__wrapped__ = r : n = r;
                    var u = r;
                    e = e.__wrapped__;
                }
                return u.__wrapped__ = t, n;
            }
            function Hl() {
                var t = this.__wrapped__;
                if (t instanceof N) {
                    var n = t;
                    return this.__actions__.length && (n = new N(this)), n = n.reverse(), n.__actions__.push({
                        func: ir,
                        args: [
                            Ai
                        ],
                        thisArg: i
                    }), new Pt(n, this.__chain__);
                }
                return this.thru(Ai);
            }
            function Dl() {
                return cu(this.__wrapped__, this.__actions__);
            }
            var Nl = Qe(function(t, n, e) {
                W.call(t, e) ? ++t[e] : Jt(t, e, 1);
            });
            function $l(t, n, e) {
                var r = b(t) ? Is : yc;
                return e && it(t, n, e) && (n = i), r(t, E(n, 3));
            }
            function ql(t, n) {
                var e = b(t) ? en : Ys;
                return e(t, E(n, 3));
            }
            var Ul = Cu(Bu), Fl = Cu(Gu);
            function Wl(t, n) {
                return tt(sr(t, n), 1);
            }
            function Ml(t, n) {
                return tt(sr(t, n), pn);
            }
            function Bl(t, n, e) {
                return e = e === i ? 1 : T(e), tt(sr(t, n), e);
            }
            function Xu(t, n) {
                var e = b(t) ? mt : an;
                return e(t, E(n, 3));
            }
            function Qu(t, n) {
                var e = b(t) ? af : Js;
                return e(t, E(n, 3));
            }
            var Gl = Qe(function(t, n, e) {
                W.call(t, e) ? t[e].push(n) : Jt(t, e, [
                    n
                ]);
            });
            function zl(t, n, e, r) {
                t = at(t) ? t : zn(t), e = e && !r ? T(e) : 0;
                var u = t.length;
                return e < 0 && (e = Q(u + e, 0)), cr(t) ? e <= u && t.indexOf(n, e) > -1 : !!u && Ln(t, n, e) > -1;
            }
            var Kl = H(function(t, n, e) {
                var r = -1, u = typeof n == "function", o = at(t) ? d(t.length) : [];
                return an(t, function(f) {
                    o[++r] = u ? ct(n, f, e) : fe(f, n, e);
                }), o;
            }), Jl = Qe(function(t, n, e) {
                Jt(t, e, n);
            });
            function sr(t, n) {
                var e = b(t) ? z : js;
                return e(t, E(n, 3));
            }
            function Yl(t, n, e, r) {
                return t == null ? [] : (b(n) || (n = n == null ? [] : [
                    n
                ]), e = r ? i : e, b(e) || (e = e == null ? [] : [
                    e
                ]), ru(t, n, e));
            }
            var Zl = Qe(function(t, n, e) {
                t[e ? 0 : 1].push(n);
            }, function() {
                return [
                    [],
                    []
                ];
            });
            function Xl(t, n, e) {
                var r = b(t) ? Nr : Ss, u = arguments.length < 3;
                return r(t, E(n, 4), e, u, an);
            }
            function Ql(t, n, e) {
                var r = b(t) ? of : Ss, u = arguments.length < 3;
                return r(t, E(n, 4), e, u, Js);
            }
            function Vl(t, n) {
                var e = b(t) ? en : Ys;
                return e(t, or(E(n, 3)));
            }
            function kl(t) {
                var n = b(t) ? Bs : zc;
                return n(t);
            }
            function jl(t, n, e) {
                (e ? it(t, n, e) : n === i) ? n = 1 : n = T(n);
                var r = b(t) ? Cc : Kc;
                return r(t, n);
            }
            function tp(t) {
                var n = b(t) ? Ac : Yc;
                return n(t);
            }
            function np(t) {
                if (t == null) return 0;
                if (at(t)) return cr(t) ? Dn(t) : t.length;
                var n = et(t);
                return n == Et || n == yt ? t.size : ti(t).length;
            }
            function ep(t, n, e) {
                var r = b(t) ? $r : Zc;
                return e && it(t, n, e) && (n = i), r(t, E(n, 3));
            }
            var rp = H(function(t, n) {
                if (t == null) return [];
                var e = n.length;
                return e > 1 && it(t, n[0], n[1]) ? n = [] : e > 2 && it(n[0], n[1], n[2]) && (n = [
                    n[0]
                ]), ru(t, tt(n, 1), []);
            }), ur = qf || function() {
                return j.Date.now();
            };
            function ip(t, n) {
                if (typeof n != "function") throw new wt(O);
                return t = T(t), function() {
                    if (--t < 1) return n.apply(this, arguments);
                };
            }
            function Vu(t, n, e) {
                return n = e ? i : n, n = t && n == null ? t.length : n, Yt(t, Bt, i, i, i, i, n);
            }
            function ku(t, n) {
                var e;
                if (typeof n != "function") throw new wt(O);
                return t = T(t), function() {
                    return --t > 0 && (e = n.apply(this, arguments)), t <= 1 && (n = i), e;
                };
            }
            var xi = H(function(t, n, e) {
                var r = vt;
                if (e.length) {
                    var u = sn(e, Bn(xi));
                    r |= Nt;
                }
                return Yt(t, r, n, e, u);
            }), ju = H(function(t, n, e) {
                var r = vt | ln;
                if (e.length) {
                    var u = sn(e, Bn(ju));
                    r |= Nt;
                }
                return Yt(n, r, t, e, u);
            });
            function ta(t, n, e) {
                n = e ? i : n;
                var r = Yt(t, Dt, i, i, i, i, i, n);
                return r.placeholder = ta.placeholder, r;
            }
            function na(t, n, e) {
                n = e ? i : n;
                var r = Yt(t, Sn, i, i, i, i, i, n);
                return r.placeholder = na.placeholder, r;
            }
            function ea(t, n, e) {
                var r, u, o, f, c, l, v = 0, _ = !1, m = !1, C = !0;
                if (typeof t != "function") throw new wt(O);
                n = xt(n) || 0, K(e) && (_ = !!e.leading, m = "maxWait" in e, o = m ? Q(xt(e.maxWait) || 0, n) : o, C = "trailing" in e ? !!e.trailing : C);
                function I(Z) {
                    var bt = r, kt = u;
                    return r = u = i, v = Z, f = t.apply(kt, bt), f;
                }
                function y(Z) {
                    return v = Z, c = de(D, n), _ ? I(Z) : f;
                }
                function L(Z) {
                    var bt = Z - l, kt = Z - v, Ca = n - bt;
                    return m ? nt(Ca, o - kt) : Ca;
                }
                function S(Z) {
                    var bt = Z - l, kt = Z - v;
                    return l === i || bt >= n || bt < 0 || m && kt >= o;
                }
                function D() {
                    var Z = ur();
                    if (S(Z)) return $(Z);
                    c = de(D, L(Z));
                }
                function $(Z) {
                    return c = i, C && r ? I(Z) : (r = u = i, f);
                }
                function dt() {
                    c !== i && lu(c), v = 0, r = l = u = c = i;
                }
                function st() {
                    return c === i ? f : $(ur());
                }
                function gt() {
                    var Z = ur(), bt = S(Z);
                    if (r = arguments, u = this, l = Z, bt) {
                        if (c === i) return y(l);
                        if (m) return lu(c), c = de(D, n), I(l);
                    }
                    return c === i && (c = de(D, n)), f;
                }
                return gt.cancel = dt, gt.flush = st, gt;
            }
            var sp = H(function(t, n) {
                return Ks(t, 1, n);
            }), up = H(function(t, n, e) {
                return Ks(t, xt(n) || 0, e);
            });
            function ap(t) {
                return Yt(t, gr);
            }
            function ar(t, n) {
                if (typeof t != "function" || n != null && typeof n != "function") throw new wt(O);
                var e = function e1() {
                    var r = arguments, u = n ? n.apply(this, r) : r[0], o = e.cache;
                    if (o.has(u)) return o.get(u);
                    var f = t.apply(this, r);
                    return e.cache = o.set(u, f) || o, f;
                };
                return e.cache = new (ar.Cache || Kt), e;
            }
            ar.Cache = Kt;
            function or(t) {
                if (typeof t != "function") throw new wt(O);
                return function() {
                    var n = arguments;
                    switch(n.length){
                        case 0:
                            return !t.call(this);
                        case 1:
                            return !t.call(this, n[0]);
                        case 2:
                            return !t.call(this, n[0], n[1]);
                        case 3:
                            return !t.call(this, n[0], n[1], n[2]);
                    }
                    return !t.apply(this, n);
                };
            }
            function op(t) {
                return ku(2, t);
            }
            var fp = Xc(function(t, n) {
                n = n.length == 1 && b(n[0]) ? z(n[0], ht(E())) : z(tt(n, 1), ht(E()));
                var e = n.length;
                return H(function(r) {
                    for(var u = -1, o = nt(r.length, e); ++u < o;)r[u] = n[u].call(this, r[u]);
                    return ct(t, this, r);
                });
            }), Ei = H(function(t, n) {
                var e = sn(n, Bn(Ei));
                return Yt(t, Nt, i, n, e);
            }), ra = H(function(t, n) {
                var e = sn(n, Bn(ra));
                return Yt(t, On, i, n, e);
            }), cp = Zt(function(t, n) {
                return Yt(t, Yn, i, i, i, n);
            });
            function hp(t, n) {
                if (typeof t != "function") throw new wt(O);
                return n = n === i ? n : T(n), H(t, n);
            }
            function lp(t, n) {
                if (typeof t != "function") throw new wt(O);
                return n = n == null ? 0 : Q(T(n), 0), H(function(e) {
                    var r = e[n], u = cn(e, 0, n);
                    return r && rn(u, r), ct(t, this, u);
                });
            }
            function pp(t, n, e) {
                var r = !0, u = !0;
                if (typeof t != "function") throw new wt(O);
                return K(e) && (r = "leading" in e ? !!e.leading : r, u = "trailing" in e ? !!e.trailing : u), ea(t, n, {
                    leading: r,
                    maxWait: n,
                    trailing: u
                });
            }
            function dp(t) {
                return Vu(t, 1);
            }
            function gp(t, n) {
                return Ei(fi(n), t);
            }
            function vp() {
                if (!arguments.length) return [];
                var t = arguments[0];
                return b(t) ? t : [
                    t
                ];
            }
            function _p(t) {
                return Ct(t, En);
            }
            function mp(t, n) {
                return n = typeof n == "function" ? n : i, Ct(t, En, n);
            }
            function wp(t) {
                return Ct(t, Ht | En);
            }
            function Pp(t, n) {
                return n = typeof n == "function" ? n : i, Ct(t, Ht | En, n);
            }
            function Cp(t, n) {
                return n == null || zs(t, n, V(n));
            }
            function Rt(t, n) {
                return t === n || t !== t && n !== n;
            }
            var Ap = tr(Vr), Ip = tr(function(t, n) {
                return t >= n;
            }), An = Qs(function() {
                return arguments;
            }()) ? Qs : function An(t) {
                return J(t) && W.call(t, "callee") && !$s.call(t, "callee");
            }, b = d.isArray, xp = _s ? ht(_s) : Lc;
            function at(t) {
                return t != null && fr(t.length) && !Qt(t);
            }
            function Y(t) {
                return J(t) && at(t);
            }
            function Ep(t) {
                return t === !0 || t === !1 || J(t) && rt(t) == Zn;
            }
            var hn = Ff || $i, yp = ms ? ht(ms) : Hc;
            function Sp(t) {
                return J(t) && t.nodeType === 1 && !ge(t);
            }
            function Op(t) {
                if (t == null) return !0;
                if (at(t) && (b(t) || typeof t == "string" || typeof t.splice == "function" || hn(t) || Gn(t) || An(t))) return !t.length;
                var n = et(t);
                if (n == Et || n == yt) return !t.size;
                if (pe(t)) return !ti(t).length;
                for(var e in t)if (W.call(t, e)) return !1;
                return !0;
            }
            function Rp(t, n) {
                return ce(t, n);
            }
            function bp(t, n, e) {
                e = typeof e == "function" ? e : i;
                var r = e ? e(t, n) : i;
                return r === i ? ce(t, n, i, e) : !!r;
            }
            function yi(t) {
                if (!J(t)) return !1;
                var n = rt(t);
                return n == Ce || n == Va || typeof t.message == "string" && typeof t.name == "string" && !ge(t);
            }
            function Tp(t) {
                return typeof t == "number" && Us(t);
            }
            function Qt(t) {
                if (!K(t)) return !1;
                var n = rt(t);
                return n == Ae || n == Ki || n == Qa || n == ja;
            }
            function ia(t) {
                return typeof t == "number" && t == T(t);
            }
            function fr(t) {
                return typeof t == "number" && t > -1 && t % 1 == 0 && t <= nn;
            }
            function K(t) {
                var n = typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t);
                return t != null && (n == "object" || n == "function");
            }
            function J(t) {
                return t != null && typeof t == "object";
            }
            var sa = ws ? ht(ws) : Nc;
            function Lp(t, n) {
                return t === n || jr(t, n, vi(n));
            }
            function Hp(t, n, e) {
                return e = typeof e == "function" ? e : i, jr(t, n, vi(n), e);
            }
            function Dp(t) {
                return ua(t) && t != +t;
            }
            function Np(t) {
                if (mh(t)) throw new R(x);
                return Vs(t);
            }
            function $p(t) {
                return t === null;
            }
            function qp(t) {
                return t == null;
            }
            function ua(t) {
                return typeof t == "number" || J(t) && rt(t) == Qn;
            }
            function ge(t) {
                if (!J(t) || rt(t) != Gt) return !1;
                var n = $e(t);
                if (n === null) return !0;
                var e = W.call(n, "constructor") && n.constructor;
                return typeof e == "function" && e instanceof e && Le.call(e) == Hf;
            }
            var Si = Ps ? ht(Ps) : $c;
            function Up(t) {
                return ia(t) && t >= -nn && t <= nn;
            }
            var aa = Cs ? ht(Cs) : qc;
            function cr(t) {
                return typeof t == "string" || !b(t) && J(t) && rt(t) == kn;
            }
            function pt(t) {
                return (typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t)) == "symbol" || J(t) && rt(t) == Ie;
            }
            var Gn = As ? ht(As) : Uc;
            function Fp(t) {
                return t === i;
            }
            function Wp(t) {
                return J(t) && et(t) == jn;
            }
            function Mp(t) {
                return J(t) && rt(t) == no;
            }
            var Bp = tr(ni), Gp = tr(function(t, n) {
                return t <= n;
            });
            function oa(t) {
                if (!t) return [];
                if (at(t)) return cr(t) ? St(t) : ut(t);
                if (ee && t[ee]) return Cf(t[ee]());
                var n = et(t), e = n == Et ? Br : n == yt ? Re : zn;
                return e(t);
            }
            function Vt(t) {
                if (!t) return t === 0 ? t : 0;
                if (t = xt(t), t === pn || t === -pn) {
                    var n = t < 0 ? -1 : 1;
                    return n * Ja;
                }
                return t === t ? t : 0;
            }
            function T(t) {
                var n = Vt(t), e = n % 1;
                return n === n ? e ? n - e : n : 0;
            }
            function fa(t) {
                return t ? mn(T(t), 0, $t) : 0;
            }
            function xt(t) {
                if (typeof t == "number") return t;
                if (pt(t)) return we;
                if (K(t)) {
                    var n = typeof t.valueOf == "function" ? t.valueOf() : t;
                    t = K(n) ? n + "" : n;
                }
                if (typeof t != "string") return t === 0 ? t : +t;
                t = Os(t);
                var e = Io.test(t);
                return e || Eo.test(t) ? rf(t.slice(2), e ? 2 : 8) : Ao.test(t) ? we : +t;
            }
            function ca(t) {
                return Ut(t, ot(t));
            }
            function zp(t) {
                return t ? mn(T(t), -nn, nn) : t === 0 ? t : 0;
            }
            function U(t) {
                return t == null ? "" : lt(t);
            }
            var Kp = Wn(function(t, n) {
                if (pe(n) || at(n)) {
                    Ut(n, V(n), t);
                    return;
                }
                for(var e in n)W.call(n, e) && ae(t, e, n[e]);
            }), ha = Wn(function(t, n) {
                Ut(n, ot(n), t);
            }), hr = Wn(function(t, n, e, r) {
                Ut(n, ot(n), t, r);
            }), Jp = Wn(function(t, n, e, r) {
                Ut(n, V(n), t, r);
            }), Yp = Zt(Zr);
            function Zp(t, n) {
                var e = Fn(t);
                return n == null ? e : Gs(e, n);
            }
            var Xp = H(function(t, n) {
                t = M(t);
                var e = -1, r = n.length, u = r > 2 ? n[2] : i;
                for(u && it(n[0], n[1], u) && (r = 1); ++e < r;)for(var o = n[e], f = ot(o), c = -1, l = f.length; ++c < l;){
                    var v = f[c], _ = t[v];
                    (_ === i || Rt(_, $n[v]) && !W.call(t, v)) && (t[v] = o[v]);
                }
                return t;
            }), Qp = H(function(t) {
                return t.push(i, Ou), ct(la, i, t);
            });
            function Vp(t, n) {
                return xs(t, E(n, 3), qt);
            }
            function kp(t, n) {
                return xs(t, E(n, 3), Qr);
            }
            function jp(t, n) {
                return t == null ? t : Xr(t, E(n, 3), ot);
            }
            function td(t, n) {
                return t == null ? t : Zs(t, E(n, 3), ot);
            }
            function nd(t, n) {
                return t && qt(t, E(n, 3));
            }
            function ed(t, n) {
                return t && Qr(t, E(n, 3));
            }
            function rd(t) {
                return t == null ? [] : Je(t, V(t));
            }
            function id(t) {
                return t == null ? [] : Je(t, ot(t));
            }
            function Oi(t, n, e) {
                var r = t == null ? i : wn(t, n);
                return r === i ? e : r;
            }
            function sd(t, n) {
                return t != null && Tu(t, n, Oc);
            }
            function Ri(t, n) {
                return t != null && Tu(t, n, Rc);
            }
            var ud = Iu(function(t, n, e) {
                n != null && typeof n.toString != "function" && (n = He.call(n)), t[n] = e;
            }, Ti(ft)), ad = Iu(function(t, n, e) {
                n != null && typeof n.toString != "function" && (n = He.call(n)), W.call(t, n) ? t[n].push(e) : t[n] = [
                    e
                ];
            }, E), od = H(fe);
            function V(t) {
                return at(t) ? Ms(t) : ti(t);
            }
            function ot(t) {
                return at(t) ? Ms(t, !0) : Fc(t);
            }
            function fd(t, n) {
                var e = {};
                return n = E(n, 3), qt(t, function(r, u, o) {
                    Jt(e, n(r, u, o), r);
                }), e;
            }
            function cd(t, n) {
                var e = {};
                return n = E(n, 3), qt(t, function(r, u, o) {
                    Jt(e, u, n(r, u, o));
                }), e;
            }
            var hd = Wn(function(t, n, e) {
                Ye(t, n, e);
            }), la = Wn(function(t, n, e, r) {
                Ye(t, n, e, r);
            }), ld = Zt(function(t, n) {
                var e = {};
                if (t == null) return e;
                var r = !1;
                n = z(n, function(o) {
                    return o = fn(o, t), r || (r = o.length > 1), o;
                }), Ut(t, di(t), e), r && (e = Ct(e, Ht | Mt | En, uh));
                for(var u = n.length; u--;)ui(e, n[u]);
                return e;
            });
            function pd(t, n) {
                return pa(t, or(E(n)));
            }
            var dd = Zt(function(t, n) {
                return t == null ? {} : Mc(t, n);
            });
            function pa(t, n) {
                if (t == null) return {};
                var e = z(di(t), function(r) {
                    return [
                        r
                    ];
                });
                return n = E(n), iu(t, e, function(r, u) {
                    return n(r, u[0]);
                });
            }
            function gd(t, n, e) {
                n = fn(n, t);
                var r = -1, u = n.length;
                for(u || (u = 1, t = i); ++r < u;){
                    var o = t == null ? i : t[Ft(n[r])];
                    o === i && (r = u, o = e), t = Qt(o) ? o.call(t) : o;
                }
                return t;
            }
            function vd(t, n, e) {
                return t == null ? t : he(t, n, e);
            }
            function _d(t, n, e, r) {
                return r = typeof r == "function" ? r : i, t == null ? t : he(t, n, e, r);
            }
            var da = yu(V), ga = yu(ot);
            function md(t, n, e) {
                var r = b(t), u = r || hn(t) || Gn(t);
                if (n = E(n, 4), e == null) {
                    var o = t && t.constructor;
                    u ? e = r ? new o : [] : K(t) ? e = Qt(o) ? Fn($e(t)) : {} : e = {};
                }
                return (u ? mt : qt)(t, function(f, c, l) {
                    return n(e, f, c, l);
                }), e;
            }
            function wd(t, n) {
                return t == null ? !0 : ui(t, n);
            }
            function Pd(t, n, e) {
                return t == null ? t : fu(t, n, fi(e));
            }
            function Cd(t, n, e, r) {
                return r = typeof r == "function" ? r : i, t == null ? t : fu(t, n, fi(e), r);
            }
            function zn(t) {
                return t == null ? [] : Mr(t, V(t));
            }
            function Ad(t) {
                return t == null ? [] : Mr(t, ot(t));
            }
            function Id(t, n, e) {
                return e === i && (e = n, n = i), e !== i && (e = xt(e), e = e === e ? e : 0), n !== i && (n = xt(n), n = n === n ? n : 0), mn(xt(t), n, e);
            }
            function xd(t, n, e) {
                return n = Vt(n), e === i ? (e = n, n = 0) : e = Vt(e), t = xt(t), bc(t, n, e);
            }
            function Ed(t, n, e) {
                if (e && typeof e != "boolean" && it(t, n, e) && (n = e = i), e === i && (typeof n == "boolean" ? (e = n, n = i) : typeof t == "boolean" && (e = t, t = i)), t === i && n === i ? (t = 0, n = 1) : (t = Vt(t), n === i ? (n = t, t = 0) : n = Vt(n)), t > n) {
                    var r = t;
                    t = n, n = r;
                }
                if (e || t % 1 || n % 1) {
                    var u = Fs();
                    return nt(t + u * (n - t + ef("1e-" + ((u + "").length - 1))), n);
                }
                return ri(t, n);
            }
            var yd = Mn(function(t, n, e) {
                return n = n.toLowerCase(), t + (e ? va(n) : n);
            });
            function va(t) {
                return bi(U(t).toLowerCase());
            }
            function _a(t) {
                return t = U(t), t && t.replace(So, vf).replace(Jo, "");
            }
            function Sd(t, n, e) {
                t = U(t), n = lt(n);
                var r = t.length;
                e = e === i ? r : mn(T(e), 0, r);
                var u = e;
                return e -= n.length, e >= 0 && t.slice(e, u) == n;
            }
            function Od(t) {
                return t = U(t), t && uo.test(t) ? t.replace(Zi, _f) : t;
            }
            function Rd(t) {
                return t = U(t), t && lo.test(t) ? t.replace(Er, "\\$&") : t;
            }
            var bd = Mn(function(t, n, e) {
                return t + (e ? "-" : "") + n.toLowerCase();
            }), Td = Mn(function(t, n, e) {
                return t + (e ? " " : "") + n.toLowerCase();
            }), Ld = Pu("toLowerCase");
            function Hd(t, n, e) {
                t = U(t), n = T(n);
                var r = n ? Dn(t) : 0;
                if (!n || r >= n) return t;
                var u = (n - r) / 2;
                return je(We(u), e) + t + je(Fe(u), e);
            }
            function Dd(t, n, e) {
                t = U(t), n = T(n);
                var r = n ? Dn(t) : 0;
                return n && r < n ? t + je(n - r, e) : t;
            }
            function Nd(t, n, e) {
                t = U(t), n = T(n);
                var r = n ? Dn(t) : 0;
                return n && r < n ? je(n - r, e) + t : t;
            }
            function $d(t, n, e) {
                return e || n == null ? n = 0 : n && (n = +n), Gf(U(t).replace(yr, ""), n || 0);
            }
            function qd(t, n, e) {
                return (e ? it(t, n, e) : n === i) ? n = 1 : n = T(n), ii(U(t), n);
            }
            function Ud() {
                var t = arguments, n = U(t[0]);
                return t.length < 3 ? n : n.replace(t[1], t[2]);
            }
            var Fd = Mn(function(t, n, e) {
                return t + (e ? "_" : "") + n.toLowerCase();
            });
            function Wd(t, n, e) {
                return e && typeof e != "number" && it(t, n, e) && (n = e = i), e = e === i ? $t : e >>> 0, e ? (t = U(t), t && (typeof n == "string" || n != null && !Si(n)) && (n = lt(n), !n && Hn(t)) ? cn(St(t), 0, e) : t.split(n, e)) : [];
            }
            var Md = Mn(function(t, n, e) {
                return t + (e ? " " : "") + bi(n);
            });
            function Bd(t, n, e) {
                return t = U(t), e = e == null ? 0 : mn(T(e), 0, t.length), n = lt(n), t.slice(e, e + n.length) == n;
            }
            function Gd(t, n, e) {
                var r = a.templateSettings;
                e && it(t, n, e) && (n = i), t = U(t), n = hr({}, n, r, Su);
                var u = hr({}, n.imports, r.imports, Su), o = V(u), f = Mr(u, o), c, l, v = 0, _ = n.interpolate || xe, m = "__p += '", C = Gr((n.escape || xe).source + "|" + _.source + "|" + (_ === Xi ? Co : xe).source + "|" + (n.evaluate || xe).source + "|$", "g"), I = "//# sourceURL=" + (W.call(n, "sourceURL") ? (n.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Vo + "]") + "\n";
                t.replace(C, function(S, D, $, dt, st, gt) {
                    return $ || ($ = dt), m += t.slice(v, gt).replace(Oo, mf), D && (c = !0, m += "' +\n__e(" + D + ") +\n'"), st && (l = !0, m += "';\n" + st + ";\n__p += '"), $ && (m += "' +\n((__t = (" + $ + ")) == null ? '' : __t) +\n'"), v = gt + S.length, S;
                }), m += "';\n";
                var y = W.call(n, "variable") && n.variable;
                if (!y) m = "with (obj) {\n" + m + "\n}\n";
                else if (wo.test(y)) throw new R(k);
                m = (l ? m.replace(eo, "") : m).replace(ro, "$1").replace(io, "$1;"), m = "function(" + (y || "obj") + ") {\n" + (y ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (c ? ", __e = _.escape" : "") + (l ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + m + "return __p\n}";
                var L = wa(function() {
                    return q(o, I + "return " + m).apply(i, f);
                });
                if (L.source = m, yi(L)) throw L;
                return L;
            }
            function zd(t) {
                return U(t).toLowerCase();
            }
            function Kd(t) {
                return U(t).toUpperCase();
            }
            function Jd(t, n, e) {
                if (t = U(t), t && (e || n === i)) return Os(t);
                if (!t || !(n = lt(n))) return t;
                var r = St(t), u = St(n), o = Rs(r, u), f = bs(r, u) + 1;
                return cn(r, o, f).join("");
            }
            function Yd(t, n, e) {
                if (t = U(t), t && (e || n === i)) return t.slice(0, Ls(t) + 1);
                if (!t || !(n = lt(n))) return t;
                var r = St(t), u = bs(r, St(n)) + 1;
                return cn(r, 0, u).join("");
            }
            function Zd(t, n, e) {
                if (t = U(t), t && (e || n === i)) return t.replace(yr, "");
                if (!t || !(n = lt(n))) return t;
                var r = St(t), u = Rs(r, St(n));
                return cn(r, u).join("");
            }
            function Xd(t, n) {
                var e = Wa, r = Ma;
                if (K(n)) {
                    var u = "separator" in n ? n.separator : u;
                    e = "length" in n ? T(n.length) : e, r = "omission" in n ? lt(n.omission) : r;
                }
                t = U(t);
                var o = t.length;
                if (Hn(t)) {
                    var f = St(t);
                    o = f.length;
                }
                if (e >= o) return t;
                var c = e - Dn(r);
                if (c < 1) return r;
                var l = f ? cn(f, 0, c).join("") : t.slice(0, c);
                if (u === i) return l + r;
                if (f && (c += l.length - c), Si(u)) {
                    if (t.slice(c).search(u)) {
                        var v, _ = l;
                        for(u.global || (u = Gr(u.source, U(Qi.exec(u)) + "g")), u.lastIndex = 0; v = u.exec(_);)var m = v.index;
                        l = l.slice(0, m === i ? c : m);
                    }
                } else if (t.indexOf(lt(u), c) != c) {
                    var C = l.lastIndexOf(u);
                    C > -1 && (l = l.slice(0, C));
                }
                return l + r;
            }
            function Qd(t) {
                return t = U(t), t && so.test(t) ? t.replace(Yi, Ef) : t;
            }
            var Vd = Mn(function(t, n, e) {
                return t + (e ? " " : "") + n.toUpperCase();
            }), bi = Pu("toUpperCase");
            function ma(t, n, e) {
                return t = U(t), n = e ? i : n, n === i ? Pf(t) ? Of(t) : hf(t) : t.match(n) || [];
            }
            var wa = H(function(t, n) {
                try {
                    return ct(t, i, n);
                } catch (e) {
                    return yi(e) ? e : new R(e);
                }
            }), kd = Zt(function(t, n) {
                return mt(n, function(e) {
                    e = Ft(e), Jt(t, e, xi(t[e], t));
                }), t;
            });
            function jd(t) {
                var n = t == null ? 0 : t.length, e = E();
                return t = n ? z(t, function(r) {
                    if (typeof r[1] != "function") throw new wt(O);
                    return [
                        e(r[0]),
                        r[1]
                    ];
                }) : [], H(function(r) {
                    for(var u = -1; ++u < n;){
                        var o = t[u];
                        if (ct(o[0], this, r)) return ct(o[1], this, r);
                    }
                });
            }
            function tg(t) {
                return Ec(Ct(t, Ht));
            }
            function Ti(t) {
                return function() {
                    return t;
                };
            }
            function ng(t, n) {
                return t == null || t !== t ? n : t;
            }
            var eg = Au(), rg = Au(!0);
            function ft(t) {
                return t;
            }
            function Li(t) {
                return ks(typeof t == "function" ? t : Ct(t, Ht));
            }
            function ig(t) {
                return tu(Ct(t, Ht));
            }
            function sg(t, n) {
                return nu(t, Ct(n, Ht));
            }
            var ug = H(function(t, n) {
                return function(e) {
                    return fe(e, t, n);
                };
            }), ag = H(function(t, n) {
                return function(e) {
                    return fe(t, e, n);
                };
            });
            function Hi(t, n, e) {
                var r = V(n), u = Je(n, r);
                e == null && !(K(n) && (u.length || !r.length)) && (e = n, n = t, t = this, u = Je(n, V(n)));
                var o = !(K(e) && "chain" in e) || !!e.chain, f = Qt(t);
                return mt(u, function(c) {
                    var l = n[c];
                    t[c] = l, f && (t.prototype[c] = function() {
                        var v = this.__chain__;
                        if (o || v) {
                            var _ = t(this.__wrapped__), m = _.__actions__ = ut(this.__actions__);
                            return m.push({
                                func: l,
                                args: arguments,
                                thisArg: t
                            }), _.__chain__ = v, _;
                        }
                        return l.apply(t, rn([
                            this.value()
                        ], arguments));
                    });
                }), t;
            }
            function og() {
                return j._ === this && (j._ = Df), this;
            }
            function Di() {}
            function fg(t) {
                return t = T(t), H(function(n) {
                    return eu(n, t);
                });
            }
            var cg = hi(z), hg = hi(Is), lg = hi($r);
            function Pa(t) {
                return mi(t) ? qr(Ft(t)) : Bc(t);
            }
            function pg(t) {
                return function(n) {
                    return t == null ? i : wn(t, n);
                };
            }
            var dg = xu(), gg = xu(!0);
            function Ni() {
                return [];
            }
            function $i() {
                return !1;
            }
            function vg() {
                return {};
            }
            function _g() {
                return "";
            }
            function mg() {
                return !0;
            }
            function wg(t, n) {
                if (t = T(t), t < 1 || t > nn) return [];
                var e = $t, r = nt(t, $t);
                n = E(n), t -= $t;
                for(var u = Wr(r, n); ++e < t;)n(e);
                return u;
            }
            function Pg(t) {
                return b(t) ? z(t, Ft) : pt(t) ? [
                    t
                ] : ut(Wu(U(t)));
            }
            function Cg(t) {
                var n = ++Lf;
                return U(t) + n;
            }
            var Ag = ke(function(t, n) {
                return t + n;
            }, 0), Ig = li("ceil"), xg = ke(function(t, n) {
                return t / n;
            }, 1), Eg = li("floor");
            function yg(t) {
                return t && t.length ? Ke(t, ft, Vr) : i;
            }
            function Sg(t, n) {
                return t && t.length ? Ke(t, E(n, 2), Vr) : i;
            }
            function Og(t) {
                return ys(t, ft);
            }
            function Rg(t, n) {
                return ys(t, E(n, 2));
            }
            function bg(t) {
                return t && t.length ? Ke(t, ft, ni) : i;
            }
            function Tg(t, n) {
                return t && t.length ? Ke(t, E(n, 2), ni) : i;
            }
            var Lg = ke(function(t, n) {
                return t * n;
            }, 1), Hg = li("round"), Dg = ke(function(t, n) {
                return t - n;
            }, 0);
            function Ng(t) {
                return t && t.length ? Fr(t, ft) : 0;
            }
            function $g(t, n) {
                return t && t.length ? Fr(t, E(n, 2)) : 0;
            }
            return a.after = ip, a.ary = Vu, a.assign = Kp, a.assignIn = ha, a.assignInWith = hr, a.assignWith = Jp, a.at = Yp, a.before = ku, a.bind = xi, a.bindAll = kd, a.bindKey = ju, a.castArray = vp, a.chain = Zu, a.chunk = Eh, a.compact = yh, a.concat = Sh, a.cond = jd, a.conforms = tg, a.constant = Ti, a.countBy = Nl, a.create = Zp, a.curry = ta, a.curryRight = na, a.debounce = ea, a.defaults = Xp, a.defaultsDeep = Qp, a.defer = sp, a.delay = up, a.difference = Oh, a.differenceBy = Rh, a.differenceWith = bh, a.drop = Th, a.dropRight = Lh, a.dropRightWhile = Hh, a.dropWhile = Dh, a.fill = Nh, a.filter = ql, a.flatMap = Wl, a.flatMapDeep = Ml, a.flatMapDepth = Bl, a.flatten = zu, a.flattenDeep = $h, a.flattenDepth = qh, a.flip = ap, a.flow = eg, a.flowRight = rg, a.fromPairs = Uh, a.functions = rd, a.functionsIn = id, a.groupBy = Gl, a.initial = Wh, a.intersection = Mh, a.intersectionBy = Bh, a.intersectionWith = Gh, a.invert = ud, a.invertBy = ad, a.invokeMap = Kl, a.iteratee = Li, a.keyBy = Jl, a.keys = V, a.keysIn = ot, a.map = sr, a.mapKeys = fd, a.mapValues = cd, a.matches = ig, a.matchesProperty = sg, a.memoize = ar, a.merge = hd, a.mergeWith = la, a.method = ug, a.methodOf = ag, a.mixin = Hi, a.negate = or, a.nthArg = fg, a.omit = ld, a.omitBy = pd, a.once = op, a.orderBy = Yl, a.over = cg, a.overArgs = fp, a.overEvery = hg, a.overSome = lg, a.partial = Ei, a.partialRight = ra, a.partition = Zl, a.pick = dd, a.pickBy = pa, a.property = Pa, a.propertyOf = pg, a.pull = Yh, a.pullAll = Ju, a.pullAllBy = Zh, a.pullAllWith = Xh, a.pullAt = Qh, a.range = dg, a.rangeRight = gg, a.rearg = cp, a.reject = Vl, a.remove = Vh, a.rest = hp, a.reverse = Ai, a.sampleSize = jl, a.set = vd, a.setWith = _d, a.shuffle = tp, a.slice = kh, a.sortBy = rp, a.sortedUniq = sl, a.sortedUniqBy = ul, a.split = Wd, a.spread = lp, a.tail = al, a.take = ol, a.takeRight = fl, a.takeRightWhile = cl, a.takeWhile = hl, a.tap = yl, a.throttle = pp, a.thru = ir, a.toArray = oa, a.toPairs = da, a.toPairsIn = ga, a.toPath = Pg, a.toPlainObject = ca, a.transform = md, a.unary = dp, a.union = ll, a.unionBy = pl, a.unionWith = dl, a.uniq = gl, a.uniqBy = vl, a.uniqWith = _l, a.unset = wd, a.unzip = Ii, a.unzipWith = Yu, a.update = Pd, a.updateWith = Cd, a.values = zn, a.valuesIn = Ad, a.without = ml, a.words = ma, a.wrap = gp, a.xor = wl, a.xorBy = Pl, a.xorWith = Cl, a.zip = Al, a.zipObject = Il, a.zipObjectDeep = xl, a.zipWith = El, a.entries = da, a.entriesIn = ga, a.extend = ha, a.extendWith = hr, Hi(a, a), a.add = Ag, a.attempt = wa, a.camelCase = yd, a.capitalize = va, a.ceil = Ig, a.clamp = Id, a.clone = _p, a.cloneDeep = wp, a.cloneDeepWith = Pp, a.cloneWith = mp, a.conformsTo = Cp, a.deburr = _a, a.defaultTo = ng, a.divide = xg, a.endsWith = Sd, a.eq = Rt, a.escape = Od, a.escapeRegExp = Rd, a.every = $l, a.find = Ul, a.findIndex = Bu, a.findKey = Vp, a.findLast = Fl, a.findLastIndex = Gu, a.findLastKey = kp, a.floor = Eg, a.forEach = Xu, a.forEachRight = Qu, a.forIn = jp, a.forInRight = td, a.forOwn = nd, a.forOwnRight = ed, a.get = Oi, a.gt = Ap, a.gte = Ip, a.has = sd, a.hasIn = Ri, a.head = Ku, a.identity = ft, a.includes = zl, a.indexOf = Fh, a.inRange = xd, a.invoke = od, a.isArguments = An, a.isArray = b, a.isArrayBuffer = xp, a.isArrayLike = at, a.isArrayLikeObject = Y, a.isBoolean = Ep, a.isBuffer = hn, a.isDate = yp, a.isElement = Sp, a.isEmpty = Op, a.isEqual = Rp, a.isEqualWith = bp, a.isError = yi, a.isFinite = Tp, a.isFunction = Qt, a.isInteger = ia, a.isLength = fr, a.isMap = sa, a.isMatch = Lp, a.isMatchWith = Hp, a.isNaN = Dp, a.isNative = Np, a.isNil = qp, a.isNull = $p, a.isNumber = ua, a.isObject = K, a.isObjectLike = J, a.isPlainObject = ge, a.isRegExp = Si, a.isSafeInteger = Up, a.isSet = aa, a.isString = cr, a.isSymbol = pt, a.isTypedArray = Gn, a.isUndefined = Fp, a.isWeakMap = Wp, a.isWeakSet = Mp, a.join = zh, a.kebabCase = bd, a.last = It, a.lastIndexOf = Kh, a.lowerCase = Td, a.lowerFirst = Ld, a.lt = Bp, a.lte = Gp, a.max = yg, a.maxBy = Sg, a.mean = Og, a.meanBy = Rg, a.min = bg, a.minBy = Tg, a.stubArray = Ni, a.stubFalse = $i, a.stubObject = vg, a.stubString = _g, a.stubTrue = mg, a.multiply = Lg, a.nth = Jh, a.noConflict = og, a.noop = Di, a.now = ur, a.pad = Hd, a.padEnd = Dd, a.padStart = Nd, a.parseInt = $d, a.random = Ed, a.reduce = Xl, a.reduceRight = Ql, a.repeat = qd, a.replace = Ud, a.result = gd, a.round = Hg, a.runInContext = h, a.sample = kl, a.size = np, a.snakeCase = Fd, a.some = ep, a.sortedIndex = jh, a.sortedIndexBy = tl, a.sortedIndexOf = nl, a.sortedLastIndex = el, a.sortedLastIndexBy = rl, a.sortedLastIndexOf = il, a.startCase = Md, a.startsWith = Bd, a.subtract = Dg, a.sum = Ng, a.sumBy = $g, a.template = Gd, a.times = wg, a.toFinite = Vt, a.toInteger = T, a.toLength = fa, a.toLower = zd, a.toNumber = xt, a.toSafeInteger = zp, a.toString = U, a.toUpper = Kd, a.trim = Jd, a.trimEnd = Yd, a.trimStart = Zd, a.truncate = Xd, a.unescape = Qd, a.uniqueId = Cg, a.upperCase = Vd, a.upperFirst = bi, a.each = Xu, a.eachRight = Qu, a.first = Ku, Hi(a, function() {
                var t = {};
                return qt(a, function(n, e) {
                    W.call(a.prototype, e) || (t[e] = n);
                }), t;
            }(), {
                chain: !1
            }), a.VERSION = p, mt([
                "bind",
                "bindKey",
                "curry",
                "curryRight",
                "partial",
                "partialRight"
            ], function(t) {
                a[t].placeholder = a;
            }), mt([
                "drop",
                "take"
            ], function(t, n) {
                N.prototype[t] = function(e) {
                    e = e === i ? 1 : Q(T(e), 0);
                    var r = this.__filtered__ && !n ? new N(this) : this.clone();
                    return r.__filtered__ ? r.__takeCount__ = nt(e, r.__takeCount__) : r.__views__.push({
                        size: nt(e, $t),
                        type: t + (r.__dir__ < 0 ? "Right" : "")
                    }), r;
                }, N.prototype[t + "Right"] = function(e) {
                    return this.reverse()[t](e).reverse();
                };
            }), mt([
                "filter",
                "map",
                "takeWhile"
            ], function(t, n) {
                var e = n + 1, r = e == zi || e == Ka;
                N.prototype[t] = function(u) {
                    var o = this.clone();
                    return o.__iteratees__.push({
                        iteratee: E(u, 3),
                        type: e
                    }), o.__filtered__ = o.__filtered__ || r, o;
                };
            }), mt([
                "head",
                "last"
            ], function(t, n) {
                var e = "take" + (n ? "Right" : "");
                N.prototype[t] = function() {
                    return this[e](1).value()[0];
                };
            }), mt([
                "initial",
                "tail"
            ], function(t, n) {
                var e = "drop" + (n ? "" : "Right");
                N.prototype[t] = function() {
                    return this.__filtered__ ? new N(this) : this[e](1);
                };
            }), N.prototype.compact = function() {
                return this.filter(ft);
            }, N.prototype.find = function(t) {
                return this.filter(t).head();
            }, N.prototype.findLast = function(t) {
                return this.reverse().find(t);
            }, N.prototype.invokeMap = H(function(t, n) {
                return typeof t == "function" ? new N(this) : this.map(function(e) {
                    return fe(e, t, n);
                });
            }), N.prototype.reject = function(t) {
                return this.filter(or(E(t)));
            }, N.prototype.slice = function(t, n) {
                t = T(t);
                var e = this;
                return e.__filtered__ && (t > 0 || n < 0) ? new N(e) : (t < 0 ? e = e.takeRight(-t) : t && (e = e.drop(t)), n !== i && (n = T(n), e = n < 0 ? e.dropRight(-n) : e.take(n - t)), e);
            }, N.prototype.takeRightWhile = function(t) {
                return this.reverse().takeWhile(t).reverse();
            }, N.prototype.toArray = function() {
                return this.take($t);
            }, qt(N.prototype, function(t, n) {
                var e = /^(?:filter|find|map|reject)|While$/.test(n), r = /^(?:head|last)$/.test(n), u = a[r ? "take" + (n == "last" ? "Right" : "") : n], o = r || /^find/.test(n);
                u && (a.prototype[n] = function() {
                    var f = this.__wrapped__, c = r ? [
                        1
                    ] : arguments, l = f instanceof N, v = c[0], _ = l || b(f), m = function m(D) {
                        var $ = u.apply(a, rn([
                            D
                        ], c));
                        return r && C ? $[0] : $;
                    };
                    _ && e && typeof v == "function" && v.length != 1 && (l = _ = !1);
                    var C = this.__chain__, I = !!this.__actions__.length, y = o && !C, L = l && !I;
                    if (!o && _) {
                        f = L ? f : new N(this);
                        var S = t.apply(f, c);
                        return S.__actions__.push({
                            func: ir,
                            args: [
                                m
                            ],
                            thisArg: i
                        }), new Pt(S, C);
                    }
                    return y && L ? t.apply(this, c) : (S = this.thru(m), y ? r ? S.value()[0] : S.value() : S);
                });
            }), mt([
                "pop",
                "push",
                "shift",
                "sort",
                "splice",
                "unshift"
            ], function(t) {
                var n = be[t], e = /^(?:push|sort|unshift)$/.test(t) ? "tap" : "thru", r = /^(?:pop|shift)$/.test(t);
                a.prototype[t] = function() {
                    var u = arguments;
                    if (r && !this.__chain__) {
                        var o = this.value();
                        return n.apply(b(o) ? o : [], u);
                    }
                    return this[e](function(f) {
                        return n.apply(b(f) ? f : [], u);
                    });
                };
            }), qt(N.prototype, function(t, n) {
                var e = a[n];
                if (e) {
                    var r = e.name + "";
                    W.call(Un, r) || (Un[r] = []), Un[r].push({
                        name: n,
                        func: e
                    });
                }
            }), Un[Ve(i, ln).name] = [
                {
                    name: "wrapper",
                    func: i
                }
            ], N.prototype.clone = Qf, N.prototype.reverse = Vf, N.prototype.value = kf, a.prototype.at = Sl, a.prototype.chain = Ol, a.prototype.commit = Rl, a.prototype.next = bl, a.prototype.plant = Ll, a.prototype.reverse = Hl, a.prototype.toJSON = a.prototype.valueOf = a.prototype.value = Dl, a.prototype.first = a.prototype.head, ee && (a.prototype[ee] = Tl), a;
        }, Nn = Rf();
        dn ? ((dn.exports = Nn)._ = Nn, Lr._ = Nn) : j._ = Nn;
    }).call($f96d9a495098fea9$var$_e);
})($f96d9a495098fea9$var$Ui, $f96d9a495098fea9$var$Ui.exports);
var $f96d9a495098fea9$var$Xg = Object.defineProperty, $f96d9a495098fea9$var$Qg = Object.defineProperties, $f96d9a495098fea9$var$Vg = Object.getOwnPropertyDescriptors, $f96d9a495098fea9$var$Oa = Object.getOwnPropertySymbols, $f96d9a495098fea9$var$kg = Object.prototype.hasOwnProperty, $f96d9a495098fea9$var$jg = Object.prototype.propertyIsEnumerable, $f96d9a495098fea9$var$Ra = function(P, s, i) {
    return s in P ? $f96d9a495098fea9$var$Xg(P, s, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: i
    }) : P[s] = i;
}, $f96d9a495098fea9$var$lr = function(P, s) {
    for(var i in s || (s = {}))$f96d9a495098fea9$var$kg.call(s, i) && $f96d9a495098fea9$var$Ra(P, i, s[i]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($f96d9a495098fea9$var$Oa) try {
        for(var _iterator = $f96d9a495098fea9$var$Oa(s)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var i = _step.value;
            $f96d9a495098fea9$var$jg.call(s, i) && $f96d9a495098fea9$var$Ra(P, i, s[i]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return P;
}, $f96d9a495098fea9$var$tv = function(P, s) {
    return $f96d9a495098fea9$var$Qg(P, $f96d9a495098fea9$var$Vg(s));
};
function $f96d9a495098fea9$var$Lt(P, s, i) {
    var p;
    var w = (0, $8wnFv.parseChainId)(P);
    return ((p = s.rpcMap) == null ? void 0 : p[w.reference]) || "".concat($f96d9a495098fea9$var$Zg, "?chainId=").concat(w.namespace, ":").concat(w.reference, "&projectId=").concat(i);
}
function $f96d9a495098fea9$var$In(P) {
    return P.includes(":") ? P.split(":")[1] : P;
}
function $f96d9a495098fea9$var$ba(P) {
    return P.map(function(s) {
        return "".concat(s.split(":")[0], ":").concat(s.split(":")[1]);
    });
}
function $f96d9a495098fea9$var$nv(P, s) {
    var i = Object.keys(s.namespaces).filter(function(w) {
        return w.includes(P);
    });
    if (!i.length) return [];
    var p = [];
    return i.forEach(function(w) {
        var _p;
        var x = s.namespaces[w].accounts;
        (_p = p).push.apply(_p, (0, $c6Xmf._)(x));
    }), p;
}
function $f96d9a495098fea9$var$Fi() {
    var P = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var i = $f96d9a495098fea9$var$Ta(P), p = $f96d9a495098fea9$var$Ta(s);
    return $f96d9a495098fea9$var$Ui.exports.merge(i, p);
}
function $f96d9a495098fea9$var$Ta(P) {
    var s, i, p, w;
    var x = {};
    if (!(0, $8wnFv.isValidObject)(P)) return x;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(P)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $cv9Rk._)(_step.value, 2), O = _step_value[0], k = _step_value[1];
            var tn = (0, $8wnFv.isCaipNamespace)(O) ? [
                O
            ] : k.chains, Jn = k.methods || [], xn = k.events || [], Ht = k.rpcMap || {}, Mt = (0, $8wnFv.parseNamespaceKey)(O);
            x[Mt] = $f96d9a495098fea9$var$tv($f96d9a495098fea9$var$lr($f96d9a495098fea9$var$lr({}, x[Mt]), k), {
                chains: (0, $8wnFv.mergeArrays)(tn, (s = x[Mt]) == null ? void 0 : s.chains),
                methods: (0, $8wnFv.mergeArrays)(Jn, (i = x[Mt]) == null ? void 0 : i.methods),
                events: (0, $8wnFv.mergeArrays)(xn, (p = x[Mt]) == null ? void 0 : p.events),
                rpcMap: $f96d9a495098fea9$var$lr($f96d9a495098fea9$var$lr({}, Ht), (w = x[Mt]) == null ? void 0 : w.rpcMap)
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return x;
}
function $f96d9a495098fea9$var$ev(P) {
    return P.includes(":") ? P.split(":")[2] : P;
}
function $f96d9a495098fea9$var$La(P) {
    var s = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(P)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $cv9Rk._)(_step.value, 2), i = _step_value[0], p = _step_value[1];
            var w = p.methods || [], x = p.events || [], O = p.accounts || [], k = (0, $8wnFv.isCaipNamespace)(i) ? [
                i
            ] : p.chains ? p.chains : $f96d9a495098fea9$var$ba(p.accounts);
            s[i] = {
                chains: k,
                methods: w,
                events: x,
                accounts: O
            };
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return s;
}
function $f96d9a495098fea9$var$Wi(P) {
    return typeof P == "number" ? P : P.includes("0x") ? parseInt(P, 16) : (P = P.includes(":") ? P.split(":")[1] : P, isNaN(Number(P)) ? P : Number(P));
}
var $f96d9a495098fea9$var$Ha = {}, $f96d9a495098fea9$var$F = function(P) {
    return $f96d9a495098fea9$var$Ha[P];
}, $f96d9a495098fea9$var$Mi = function(P, s) {
    $f96d9a495098fea9$var$Ha[P] = s;
};
var $f96d9a495098fea9$var$rv = /*#__PURE__*/ function() {
    "use strict";
    function rv(s) {
        (0, $4GJKx._)(this, rv);
        this.name = "polkadot", this.namespace = s.namespace, this.events = $f96d9a495098fea9$var$F("events"), this.client = $f96d9a495098fea9$var$F("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    (0, $1wc17._)(rv, [
        {
            key: "updateNamespace",
            value: function updateNamespace(s) {
                this.namespace = Object.assign(this.namespace, s);
            }
        },
        {
            key: "requestAccounts",
            value: function requestAccounts() {
                return this.getAccounts();
            }
        },
        {
            key: "getDefaultChain",
            value: function getDefaultChain() {
                if (this.chainId) return this.chainId;
                if (this.namespace.defaultChain) return this.namespace.defaultChain;
                var s = this.namespace.chains[0];
                if (!s) throw new Error("ChainId not found");
                return s.split(":")[1];
            }
        },
        {
            key: "request",
            value: function request(s) {
                return this.namespace.methods.includes(s.request.method) ? this.client.request(s) : this.getHttpProvider().request(s.request);
            }
        },
        {
            key: "setDefaultChain",
            value: function setDefaultChain(s, i) {
                this.httpProviders[s] || this.setHttpProvider(s, i), this.chainId = s, this.events.emit($f96d9a495098fea9$var$Tt.DEFAULT_CHAIN_CHANGED, "".concat(this.name, ":").concat(s));
            }
        },
        {
            key: "getAccounts",
            value: function getAccounts() {
                var _this = this;
                var s = this.namespace.accounts;
                return s ? s.filter(function(i) {
                    return i.split(":")[1] === _this.chainId.toString();
                }).map(function(i) {
                    return i.split(":")[2];
                }) || [] : [];
            }
        },
        {
            key: "createHttpProviders",
            value: function createHttpProviders() {
                var _this = this;
                var s = {};
                return this.namespace.chains.forEach(function(i) {
                    var p;
                    var w = $f96d9a495098fea9$var$In(i);
                    s[w] = _this.createHttpProvider(w, (p = _this.namespace.rpcMap) == null ? void 0 : p[i]);
                }), s;
            }
        },
        {
            key: "getHttpProvider",
            value: function getHttpProvider() {
                var s = "".concat(this.name, ":").concat(this.chainId), i = this.httpProviders[s];
                if ((typeof i === "undefined" ? "undefined" : (0, $l0HdX._)(i)) > "u") throw new Error("JSON-RPC provider for ".concat(s, " not found"));
                return i;
            }
        },
        {
            key: "setHttpProvider",
            value: function setHttpProvider(s, i) {
                var p = this.createHttpProvider(s, i);
                p && (this.httpProviders[s] = p);
            }
        },
        {
            key: "createHttpProvider",
            value: function createHttpProvider(s, i) {
                var p = i || $f96d9a495098fea9$var$Lt(s, this.namespace, this.client.core.projectId);
                if (!p) throw new Error("No RPC url provided for chainId: ".concat(s));
                return new (0, $bMQws.JsonRpcProvider)(new (0, $7FPw1.default)(p, $f96d9a495098fea9$var$F("disableProviderPing")));
            }
        }
    ]);
    return rv;
}();
var $f96d9a495098fea9$var$iv = Object.defineProperty, $f96d9a495098fea9$var$sv = Object.defineProperties, $f96d9a495098fea9$var$uv = Object.getOwnPropertyDescriptors, $f96d9a495098fea9$var$Da = Object.getOwnPropertySymbols, $f96d9a495098fea9$var$av = Object.prototype.hasOwnProperty, $f96d9a495098fea9$var$ov = Object.prototype.propertyIsEnumerable, $f96d9a495098fea9$var$Na = function(P, s, i) {
    return s in P ? $f96d9a495098fea9$var$iv(P, s, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: i
    }) : P[s] = i;
}, $f96d9a495098fea9$var$$a = function(P, s) {
    for(var i in s || (s = {}))$f96d9a495098fea9$var$av.call(s, i) && $f96d9a495098fea9$var$Na(P, i, s[i]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($f96d9a495098fea9$var$Da) try {
        for(var _iterator = $f96d9a495098fea9$var$Da(s)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var i = _step.value;
            $f96d9a495098fea9$var$ov.call(s, i) && $f96d9a495098fea9$var$Na(P, i, s[i]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return P;
}, $f96d9a495098fea9$var$qa = function(P, s) {
    return $f96d9a495098fea9$var$sv(P, $f96d9a495098fea9$var$uv(s));
};
var $f96d9a495098fea9$var$fv = /*#__PURE__*/ function() {
    "use strict";
    function fv(s) {
        (0, $4GJKx._)(this, fv);
        this.name = "eip155", this.namespace = s.namespace, this.events = $f96d9a495098fea9$var$F("events"), this.client = $f96d9a495098fea9$var$F("client"), this.httpProviders = this.createHttpProviders(), this.chainId = parseInt(this.getDefaultChain());
    }
    (0, $1wc17._)(fv, [
        {
            key: "request",
            value: function request(s) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _, _tmp;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = s.request.method;
                                switch(_){
                                    case "eth_requestAccounts":
                                        return [
                                            3,
                                            1
                                        ];
                                    case "eth_accounts":
                                        return [
                                            3,
                                            2
                                        ];
                                    case "wallet_switchEthereumChain":
                                        return [
                                            3,
                                            3
                                        ];
                                    case "eth_chainId":
                                        return [
                                            3,
                                            5
                                        ];
                                    case "wallet_getCapabilities":
                                        return [
                                            3,
                                            6
                                        ];
                                }
                                return [
                                    3,
                                    8
                                ];
                            case 1:
                                return [
                                    2,
                                    _this.getAccounts()
                                ];
                            case 2:
                                return [
                                    2,
                                    _this.getAccounts()
                                ];
                            case 3:
                                return [
                                    4,
                                    _this.handleSwitchChain(s)
                                ];
                            case 4:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 5:
                                return [
                                    2,
                                    parseInt(_this.getDefaultChain())
                                ];
                            case 6:
                                return [
                                    4,
                                    _this.getCapabilities(s)
                                ];
                            case 7:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 8:
                                if (!_this.namespace.methods.includes(s.request.method)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _this.client.request(s)
                                ];
                            case 9:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                _tmp = _this.getHttpProvider().request(s.request);
                                _state.label = 11;
                            case 11:
                                return [
                                    2,
                                    _tmp
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateNamespace",
            value: function updateNamespace(s) {
                this.namespace = Object.assign(this.namespace, s);
            }
        },
        {
            key: "setDefaultChain",
            value: function setDefaultChain(s, i) {
                this.httpProviders[s] || this.setHttpProvider(parseInt(s), i), this.chainId = parseInt(s), this.events.emit($f96d9a495098fea9$var$Tt.DEFAULT_CHAIN_CHANGED, "".concat(this.name, ":").concat(s));
            }
        },
        {
            key: "requestAccounts",
            value: function requestAccounts() {
                return this.getAccounts();
            }
        },
        {
            key: "getDefaultChain",
            value: function getDefaultChain() {
                if (this.chainId) return this.chainId.toString();
                if (this.namespace.defaultChain) return this.namespace.defaultChain;
                var s = this.namespace.chains[0];
                if (!s) throw new Error("ChainId not found");
                return s.split(":")[1];
            }
        },
        {
            key: "createHttpProvider",
            value: function createHttpProvider(s, i) {
                var p = i || $f96d9a495098fea9$var$Lt("".concat(this.name, ":").concat(s), this.namespace, this.client.core.projectId);
                if (!p) throw new Error("No RPC url provided for chainId: ".concat(s));
                return new (0, $bMQws.JsonRpcProvider)(new (0, $7FPw1.HttpConnection)(p, $f96d9a495098fea9$var$F("disableProviderPing")));
            }
        },
        {
            key: "setHttpProvider",
            value: function setHttpProvider(s, i) {
                var p = this.createHttpProvider(s, i);
                p && (this.httpProviders[s] = p);
            }
        },
        {
            key: "createHttpProviders",
            value: function createHttpProviders() {
                var _this = this;
                var s = {};
                return this.namespace.chains.forEach(function(i) {
                    var p;
                    var w = parseInt($f96d9a495098fea9$var$In(i));
                    s[w] = _this.createHttpProvider(w, (p = _this.namespace.rpcMap) == null ? void 0 : p[i]);
                }), s;
            }
        },
        {
            key: "getAccounts",
            value: function getAccounts() {
                var _this = this;
                var s = this.namespace.accounts;
                return s ? (0, $c6Xmf._)(new Set(s.filter(function(i) {
                    return i.split(":")[1] === _this.chainId.toString();
                }).map(function(i) {
                    return i.split(":")[2];
                }))) : [];
            }
        },
        {
            key: "getHttpProvider",
            value: function getHttpProvider() {
                var s = this.chainId, i = this.httpProviders[s];
                if ((typeof i === "undefined" ? "undefined" : (0, $l0HdX._)(i)) > "u") throw new Error("JSON-RPC provider for ".concat(s, " not found"));
                return i;
            }
        },
        {
            key: "handleSwitchChain",
            value: function handleSwitchChain(s) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var i, p, w, x;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                w = s.request.params ? (i = s.request.params[0]) == null ? void 0 : i.chainId : "0x0";
                                w = w.startsWith("0x") ? w : "0x".concat(w);
                                x = parseInt(w, 16);
                                if (!_this.isChainApproved(x)) return [
                                    3,
                                    1
                                ];
                                _this.setDefaultChain("".concat(x));
                                return [
                                    3,
                                    4
                                ];
                            case 1:
                                if (!_this.namespace.methods.includes("wallet_switchEthereumChain")) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.client.request({
                                        topic: s.topic,
                                        request: {
                                            method: s.request.method,
                                            params: [
                                                {
                                                    chainId: w
                                                }
                                            ]
                                        },
                                        chainId: (p = _this.namespace.chains) == null ? void 0 : p[0]
                                    })
                                ];
                            case 2:
                                _state.sent(), _this.setDefaultChain("".concat(x));
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                throw new Error("Failed to switch to chain 'eip155:".concat(x, "'. The chain is not approved or the wallet does not support 'wallet_switchEthereumChain' method."));
                            case 4:
                                return [
                                    2,
                                    null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "isChainApproved",
            value: function isChainApproved(s) {
                return this.namespace.chains.includes("".concat(this.name, ":").concat(s));
            }
        },
        {
            key: "getCapabilities",
            value: function getCapabilities(s) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var i, p, w, x, O, k, tn, Jn;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                x = (p = (i = s.request) == null ? void 0 : i.params) == null ? void 0 : p[0];
                                if (!x) throw new Error("Missing address parameter in `wallet_getCapabilities` request");
                                O = _this.client.session.get(s.topic), k = ((w = O === null || O === void 0 ? void 0 : O.sessionProperties) == null ? void 0 : w.capabilities) || {};
                                if (k != null && k[x]) return [
                                    2,
                                    k === null || k === void 0 ? void 0 : k[x]
                                ];
                                return [
                                    4,
                                    _this.client.request(s)
                                ];
                            case 1:
                                tn = _state.sent();
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    _this.client.session.update(s.topic, {
                                        sessionProperties: $f96d9a495098fea9$var$qa($f96d9a495098fea9$var$$a({}, O.sessionProperties || {}), {
                                            capabilities: $f96d9a495098fea9$var$qa($f96d9a495098fea9$var$$a({}, k || {}), (0, $3sHb8._)({}, x, tn))
                                        })
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                Jn = _state.sent();
                                console.warn("Failed to update session with capabilities", Jn);
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2,
                                    tn
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return fv;
}();
var $f96d9a495098fea9$var$cv = /*#__PURE__*/ function() {
    "use strict";
    function cv(s) {
        (0, $4GJKx._)(this, cv);
        this.name = "solana", this.namespace = s.namespace, this.events = $f96d9a495098fea9$var$F("events"), this.client = $f96d9a495098fea9$var$F("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    (0, $1wc17._)(cv, [
        {
            key: "updateNamespace",
            value: function updateNamespace(s) {
                this.namespace = Object.assign(this.namespace, s);
            }
        },
        {
            key: "requestAccounts",
            value: function requestAccounts() {
                return this.getAccounts();
            }
        },
        {
            key: "request",
            value: function request(s) {
                return this.namespace.methods.includes(s.request.method) ? this.client.request(s) : this.getHttpProvider().request(s.request);
            }
        },
        {
            key: "setDefaultChain",
            value: function setDefaultChain(s, i) {
                this.httpProviders[s] || this.setHttpProvider(s, i), this.chainId = s, this.events.emit($f96d9a495098fea9$var$Tt.DEFAULT_CHAIN_CHANGED, "".concat(this.name, ":").concat(s));
            }
        },
        {
            key: "getDefaultChain",
            value: function getDefaultChain() {
                if (this.chainId) return this.chainId;
                if (this.namespace.defaultChain) return this.namespace.defaultChain;
                var s = this.namespace.chains[0];
                if (!s) throw new Error("ChainId not found");
                return s.split(":")[1];
            }
        },
        {
            key: "getAccounts",
            value: function getAccounts() {
                var _this = this;
                var s = this.namespace.accounts;
                return s ? (0, $c6Xmf._)(new Set(s.filter(function(i) {
                    return i.split(":")[1] === _this.chainId.toString();
                }).map(function(i) {
                    return i.split(":")[2];
                }))) : [];
            }
        },
        {
            key: "createHttpProviders",
            value: function createHttpProviders() {
                var _this = this;
                var s = {};
                return this.namespace.chains.forEach(function(i) {
                    var p;
                    var w = $f96d9a495098fea9$var$In(i);
                    s[w] = _this.createHttpProvider(w, (p = _this.namespace.rpcMap) == null ? void 0 : p[i]);
                }), s;
            }
        },
        {
            key: "getHttpProvider",
            value: function getHttpProvider() {
                var s = "".concat(this.name, ":").concat(this.chainId), i = this.httpProviders[s];
                if ((typeof i === "undefined" ? "undefined" : (0, $l0HdX._)(i)) > "u") throw new Error("JSON-RPC provider for ".concat(s, " not found"));
                return i;
            }
        },
        {
            key: "setHttpProvider",
            value: function setHttpProvider(s, i) {
                var p = this.createHttpProvider(s, i);
                p && (this.httpProviders[s] = p);
            }
        },
        {
            key: "createHttpProvider",
            value: function createHttpProvider(s, i) {
                var p = i || $f96d9a495098fea9$var$Lt(s, this.namespace, this.client.core.projectId);
                if (!p) throw new Error("No RPC url provided for chainId: ".concat(s));
                return new (0, $bMQws.JsonRpcProvider)(new (0, $7FPw1.default)(p, $f96d9a495098fea9$var$F("disableProviderPing")));
            }
        }
    ]);
    return cv;
}();
var $f96d9a495098fea9$var$hv = /*#__PURE__*/ function() {
    "use strict";
    function hv(s) {
        (0, $4GJKx._)(this, hv);
        this.name = "cosmos", this.namespace = s.namespace, this.events = $f96d9a495098fea9$var$F("events"), this.client = $f96d9a495098fea9$var$F("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    (0, $1wc17._)(hv, [
        {
            key: "updateNamespace",
            value: function updateNamespace(s) {
                this.namespace = Object.assign(this.namespace, s);
            }
        },
        {
            key: "requestAccounts",
            value: function requestAccounts() {
                return this.getAccounts();
            }
        },
        {
            key: "getDefaultChain",
            value: function getDefaultChain() {
                if (this.chainId) return this.chainId;
                if (this.namespace.defaultChain) return this.namespace.defaultChain;
                var s = this.namespace.chains[0];
                if (!s) throw new Error("ChainId not found");
                return s.split(":")[1];
            }
        },
        {
            key: "request",
            value: function request(s) {
                return this.namespace.methods.includes(s.request.method) ? this.client.request(s) : this.getHttpProvider().request(s.request);
            }
        },
        {
            key: "setDefaultChain",
            value: function setDefaultChain(s, i) {
                this.httpProviders[s] || this.setHttpProvider(s, i), this.chainId = s, this.events.emit($f96d9a495098fea9$var$Tt.DEFAULT_CHAIN_CHANGED, "".concat(this.name, ":").concat(this.chainId));
            }
        },
        {
            key: "getAccounts",
            value: function getAccounts() {
                var _this = this;
                var s = this.namespace.accounts;
                return s ? (0, $c6Xmf._)(new Set(s.filter(function(i) {
                    return i.split(":")[1] === _this.chainId.toString();
                }).map(function(i) {
                    return i.split(":")[2];
                }))) : [];
            }
        },
        {
            key: "createHttpProviders",
            value: function createHttpProviders() {
                var _this = this;
                var s = {};
                return this.namespace.chains.forEach(function(i) {
                    var p;
                    var w = $f96d9a495098fea9$var$In(i);
                    s[w] = _this.createHttpProvider(w, (p = _this.namespace.rpcMap) == null ? void 0 : p[i]);
                }), s;
            }
        },
        {
            key: "getHttpProvider",
            value: function getHttpProvider() {
                var s = "".concat(this.name, ":").concat(this.chainId), i = this.httpProviders[s];
                if ((typeof i === "undefined" ? "undefined" : (0, $l0HdX._)(i)) > "u") throw new Error("JSON-RPC provider for ".concat(s, " not found"));
                return i;
            }
        },
        {
            key: "setHttpProvider",
            value: function setHttpProvider(s, i) {
                var p = this.createHttpProvider(s, i);
                p && (this.httpProviders[s] = p);
            }
        },
        {
            key: "createHttpProvider",
            value: function createHttpProvider(s, i) {
                var p = i || $f96d9a495098fea9$var$Lt(s, this.namespace, this.client.core.projectId);
                if (!p) throw new Error("No RPC url provided for chainId: ".concat(s));
                return new (0, $bMQws.JsonRpcProvider)(new (0, $7FPw1.default)(p, $f96d9a495098fea9$var$F("disableProviderPing")));
            }
        }
    ]);
    return hv;
}();
var $f96d9a495098fea9$var$lv = /*#__PURE__*/ function() {
    "use strict";
    function lv(s) {
        (0, $4GJKx._)(this, lv);
        this.name = "algorand", this.namespace = s.namespace, this.events = $f96d9a495098fea9$var$F("events"), this.client = $f96d9a495098fea9$var$F("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    (0, $1wc17._)(lv, [
        {
            key: "updateNamespace",
            value: function updateNamespace(s) {
                this.namespace = Object.assign(this.namespace, s);
            }
        },
        {
            key: "requestAccounts",
            value: function requestAccounts() {
                return this.getAccounts();
            }
        },
        {
            key: "request",
            value: function request(s) {
                return this.namespace.methods.includes(s.request.method) ? this.client.request(s) : this.getHttpProvider().request(s.request);
            }
        },
        {
            key: "setDefaultChain",
            value: function setDefaultChain(s, i) {
                if (!this.httpProviders[s]) {
                    var p = i || $f96d9a495098fea9$var$Lt("".concat(this.name, ":").concat(s), this.namespace, this.client.core.projectId);
                    if (!p) throw new Error("No RPC url provided for chainId: ".concat(s));
                    this.setHttpProvider(s, p);
                }
                this.chainId = s, this.events.emit($f96d9a495098fea9$var$Tt.DEFAULT_CHAIN_CHANGED, "".concat(this.name, ":").concat(this.chainId));
            }
        },
        {
            key: "getDefaultChain",
            value: function getDefaultChain() {
                if (this.chainId) return this.chainId;
                if (this.namespace.defaultChain) return this.namespace.defaultChain;
                var s = this.namespace.chains[0];
                if (!s) throw new Error("ChainId not found");
                return s.split(":")[1];
            }
        },
        {
            key: "getAccounts",
            value: function getAccounts() {
                var _this = this;
                var s = this.namespace.accounts;
                return s ? (0, $c6Xmf._)(new Set(s.filter(function(i) {
                    return i.split(":")[1] === _this.chainId.toString();
                }).map(function(i) {
                    return i.split(":")[2];
                }))) : [];
            }
        },
        {
            key: "createHttpProviders",
            value: function createHttpProviders() {
                var _this = this;
                var s = {};
                return this.namespace.chains.forEach(function(i) {
                    var p;
                    s[i] = _this.createHttpProvider(i, (p = _this.namespace.rpcMap) == null ? void 0 : p[i]);
                }), s;
            }
        },
        {
            key: "getHttpProvider",
            value: function getHttpProvider() {
                var s = "".concat(this.name, ":").concat(this.chainId), i = this.httpProviders[s];
                if ((typeof i === "undefined" ? "undefined" : (0, $l0HdX._)(i)) > "u") throw new Error("JSON-RPC provider for ".concat(s, " not found"));
                return i;
            }
        },
        {
            key: "setHttpProvider",
            value: function setHttpProvider(s, i) {
                var p = this.createHttpProvider(s, i);
                p && (this.httpProviders[s] = p);
            }
        },
        {
            key: "createHttpProvider",
            value: function createHttpProvider(s, i) {
                var p = i || $f96d9a495098fea9$var$Lt(s, this.namespace, this.client.core.projectId);
                return (typeof p === "undefined" ? "undefined" : (0, $l0HdX._)(p)) > "u" ? void 0 : new (0, $bMQws.JsonRpcProvider)(new (0, $7FPw1.default)(p, $f96d9a495098fea9$var$F("disableProviderPing")));
            }
        }
    ]);
    return lv;
}();
var $f96d9a495098fea9$var$pv = /*#__PURE__*/ function() {
    "use strict";
    function pv(s) {
        (0, $4GJKx._)(this, pv);
        this.name = "cip34", this.namespace = s.namespace, this.events = $f96d9a495098fea9$var$F("events"), this.client = $f96d9a495098fea9$var$F("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    (0, $1wc17._)(pv, [
        {
            key: "updateNamespace",
            value: function updateNamespace(s) {
                this.namespace = Object.assign(this.namespace, s);
            }
        },
        {
            key: "requestAccounts",
            value: function requestAccounts() {
                return this.getAccounts();
            }
        },
        {
            key: "getDefaultChain",
            value: function getDefaultChain() {
                if (this.chainId) return this.chainId;
                if (this.namespace.defaultChain) return this.namespace.defaultChain;
                var s = this.namespace.chains[0];
                if (!s) throw new Error("ChainId not found");
                return s.split(":")[1];
            }
        },
        {
            key: "request",
            value: function request(s) {
                return this.namespace.methods.includes(s.request.method) ? this.client.request(s) : this.getHttpProvider().request(s.request);
            }
        },
        {
            key: "setDefaultChain",
            value: function setDefaultChain(s, i) {
                this.httpProviders[s] || this.setHttpProvider(s, i), this.chainId = s, this.events.emit($f96d9a495098fea9$var$Tt.DEFAULT_CHAIN_CHANGED, "".concat(this.name, ":").concat(this.chainId));
            }
        },
        {
            key: "getAccounts",
            value: function getAccounts() {
                var _this = this;
                var s = this.namespace.accounts;
                return s ? (0, $c6Xmf._)(new Set(s.filter(function(i) {
                    return i.split(":")[1] === _this.chainId.toString();
                }).map(function(i) {
                    return i.split(":")[2];
                }))) : [];
            }
        },
        {
            key: "createHttpProviders",
            value: function createHttpProviders() {
                var _this = this;
                var s = {};
                return this.namespace.chains.forEach(function(i) {
                    var p = _this.getCardanoRPCUrl(i), w = $f96d9a495098fea9$var$In(i);
                    s[w] = _this.createHttpProvider(w, p);
                }), s;
            }
        },
        {
            key: "getHttpProvider",
            value: function getHttpProvider() {
                var s = "".concat(this.name, ":").concat(this.chainId), i = this.httpProviders[s];
                if ((typeof i === "undefined" ? "undefined" : (0, $l0HdX._)(i)) > "u") throw new Error("JSON-RPC provider for ".concat(s, " not found"));
                return i;
            }
        },
        {
            key: "getCardanoRPCUrl",
            value: function getCardanoRPCUrl(s) {
                var i = this.namespace.rpcMap;
                if (i) return i[s];
            }
        },
        {
            key: "setHttpProvider",
            value: function setHttpProvider(s, i) {
                var p = this.createHttpProvider(s, i);
                p && (this.httpProviders[s] = p);
            }
        },
        {
            key: "createHttpProvider",
            value: function createHttpProvider(s, i) {
                var p = i || this.getCardanoRPCUrl(s);
                if (!p) throw new Error("No RPC url provided for chainId: ".concat(s));
                return new (0, $bMQws.JsonRpcProvider)(new (0, $7FPw1.default)(p, $f96d9a495098fea9$var$F("disableProviderPing")));
            }
        }
    ]);
    return pv;
}();
var $f96d9a495098fea9$var$dv = /*#__PURE__*/ function() {
    "use strict";
    function dv(s) {
        (0, $4GJKx._)(this, dv);
        this.name = "elrond", this.namespace = s.namespace, this.events = $f96d9a495098fea9$var$F("events"), this.client = $f96d9a495098fea9$var$F("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    (0, $1wc17._)(dv, [
        {
            key: "updateNamespace",
            value: function updateNamespace(s) {
                this.namespace = Object.assign(this.namespace, s);
            }
        },
        {
            key: "requestAccounts",
            value: function requestAccounts() {
                return this.getAccounts();
            }
        },
        {
            key: "request",
            value: function request(s) {
                return this.namespace.methods.includes(s.request.method) ? this.client.request(s) : this.getHttpProvider().request(s.request);
            }
        },
        {
            key: "setDefaultChain",
            value: function setDefaultChain(s, i) {
                this.httpProviders[s] || this.setHttpProvider(s, i), this.chainId = s, this.events.emit($f96d9a495098fea9$var$Tt.DEFAULT_CHAIN_CHANGED, "".concat(this.name, ":").concat(s));
            }
        },
        {
            key: "getDefaultChain",
            value: function getDefaultChain() {
                if (this.chainId) return this.chainId;
                if (this.namespace.defaultChain) return this.namespace.defaultChain;
                var s = this.namespace.chains[0];
                if (!s) throw new Error("ChainId not found");
                return s.split(":")[1];
            }
        },
        {
            key: "getAccounts",
            value: function getAccounts() {
                var _this = this;
                var s = this.namespace.accounts;
                return s ? (0, $c6Xmf._)(new Set(s.filter(function(i) {
                    return i.split(":")[1] === _this.chainId.toString();
                }).map(function(i) {
                    return i.split(":")[2];
                }))) : [];
            }
        },
        {
            key: "createHttpProviders",
            value: function createHttpProviders() {
                var _this = this;
                var s = {};
                return this.namespace.chains.forEach(function(i) {
                    var p;
                    var w = $f96d9a495098fea9$var$In(i);
                    s[w] = _this.createHttpProvider(w, (p = _this.namespace.rpcMap) == null ? void 0 : p[i]);
                }), s;
            }
        },
        {
            key: "getHttpProvider",
            value: function getHttpProvider() {
                var s = "".concat(this.name, ":").concat(this.chainId), i = this.httpProviders[s];
                if ((typeof i === "undefined" ? "undefined" : (0, $l0HdX._)(i)) > "u") throw new Error("JSON-RPC provider for ".concat(s, " not found"));
                return i;
            }
        },
        {
            key: "setHttpProvider",
            value: function setHttpProvider(s, i) {
                var p = this.createHttpProvider(s, i);
                p && (this.httpProviders[s] = p);
            }
        },
        {
            key: "createHttpProvider",
            value: function createHttpProvider(s, i) {
                var p = i || $f96d9a495098fea9$var$Lt(s, this.namespace, this.client.core.projectId);
                if (!p) throw new Error("No RPC url provided for chainId: ".concat(s));
                return new (0, $bMQws.JsonRpcProvider)(new (0, $7FPw1.default)(p, $f96d9a495098fea9$var$F("disableProviderPing")));
            }
        }
    ]);
    return dv;
}();
var $f96d9a495098fea9$var$gv = /*#__PURE__*/ function() {
    "use strict";
    function gv(s) {
        (0, $4GJKx._)(this, gv);
        this.name = "multiversx", this.namespace = s.namespace, this.events = $f96d9a495098fea9$var$F("events"), this.client = $f96d9a495098fea9$var$F("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    (0, $1wc17._)(gv, [
        {
            key: "updateNamespace",
            value: function updateNamespace(s) {
                this.namespace = Object.assign(this.namespace, s);
            }
        },
        {
            key: "requestAccounts",
            value: function requestAccounts() {
                return this.getAccounts();
            }
        },
        {
            key: "request",
            value: function request(s) {
                return this.namespace.methods.includes(s.request.method) ? this.client.request(s) : this.getHttpProvider().request(s.request);
            }
        },
        {
            key: "setDefaultChain",
            value: function setDefaultChain(s, i) {
                this.httpProviders[s] || this.setHttpProvider(s, i), this.chainId = s, this.events.emit($f96d9a495098fea9$var$Tt.DEFAULT_CHAIN_CHANGED, "".concat(this.name, ":").concat(s));
            }
        },
        {
            key: "getDefaultChain",
            value: function getDefaultChain() {
                if (this.chainId) return this.chainId;
                if (this.namespace.defaultChain) return this.namespace.defaultChain;
                var s = this.namespace.chains[0];
                if (!s) throw new Error("ChainId not found");
                return s.split(":")[1];
            }
        },
        {
            key: "getAccounts",
            value: function getAccounts() {
                var _this = this;
                var s = this.namespace.accounts;
                return s ? (0, $c6Xmf._)(new Set(s.filter(function(i) {
                    return i.split(":")[1] === _this.chainId.toString();
                }).map(function(i) {
                    return i.split(":")[2];
                }))) : [];
            }
        },
        {
            key: "createHttpProviders",
            value: function createHttpProviders() {
                var _this = this;
                var s = {};
                return this.namespace.chains.forEach(function(i) {
                    var p;
                    var w = $f96d9a495098fea9$var$In(i);
                    s[w] = _this.createHttpProvider(w, (p = _this.namespace.rpcMap) == null ? void 0 : p[i]);
                }), s;
            }
        },
        {
            key: "getHttpProvider",
            value: function getHttpProvider() {
                var s = "".concat(this.name, ":").concat(this.chainId), i = this.httpProviders[s];
                if ((typeof i === "undefined" ? "undefined" : (0, $l0HdX._)(i)) > "u") throw new Error("JSON-RPC provider for ".concat(s, " not found"));
                return i;
            }
        },
        {
            key: "setHttpProvider",
            value: function setHttpProvider(s, i) {
                var p = this.createHttpProvider(s, i);
                p && (this.httpProviders[s] = p);
            }
        },
        {
            key: "createHttpProvider",
            value: function createHttpProvider(s, i) {
                var p = i || $f96d9a495098fea9$var$Lt(s, this.namespace, this.client.core.projectId);
                if (!p) throw new Error("No RPC url provided for chainId: ".concat(s));
                return new (0, $bMQws.JsonRpcProvider)(new (0, $7FPw1.default)(p, $f96d9a495098fea9$var$F("disableProviderPing")));
            }
        }
    ]);
    return gv;
}();
var $f96d9a495098fea9$var$vv = /*#__PURE__*/ function() {
    "use strict";
    function vv(s) {
        (0, $4GJKx._)(this, vv);
        this.name = "near", this.namespace = s.namespace, this.events = $f96d9a495098fea9$var$F("events"), this.client = $f96d9a495098fea9$var$F("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    (0, $1wc17._)(vv, [
        {
            key: "updateNamespace",
            value: function updateNamespace(s) {
                this.namespace = Object.assign(this.namespace, s);
            }
        },
        {
            key: "requestAccounts",
            value: function requestAccounts() {
                return this.getAccounts();
            }
        },
        {
            key: "getDefaultChain",
            value: function getDefaultChain() {
                if (this.chainId) return this.chainId;
                if (this.namespace.defaultChain) return this.namespace.defaultChain;
                var s = this.namespace.chains[0];
                if (!s) throw new Error("ChainId not found");
                return s.split(":")[1];
            }
        },
        {
            key: "request",
            value: function request(s) {
                return this.namespace.methods.includes(s.request.method) ? this.client.request(s) : this.getHttpProvider().request(s.request);
            }
        },
        {
            key: "setDefaultChain",
            value: function setDefaultChain(s, i) {
                if (this.chainId = s, !this.httpProviders[s]) {
                    var p = i || $f96d9a495098fea9$var$Lt("".concat(this.name, ":").concat(s), this.namespace);
                    if (!p) throw new Error("No RPC url provided for chainId: ".concat(s));
                    this.setHttpProvider(s, p);
                }
                this.events.emit($f96d9a495098fea9$var$Tt.DEFAULT_CHAIN_CHANGED, "".concat(this.name, ":").concat(this.chainId));
            }
        },
        {
            key: "getAccounts",
            value: function getAccounts() {
                var _this = this;
                var s = this.namespace.accounts;
                return s ? s.filter(function(i) {
                    return i.split(":")[1] === _this.chainId.toString();
                }).map(function(i) {
                    return i.split(":")[2];
                }) || [] : [];
            }
        },
        {
            key: "createHttpProviders",
            value: function createHttpProviders() {
                var _this = this;
                var s = {};
                return this.namespace.chains.forEach(function(i) {
                    var p;
                    s[i] = _this.createHttpProvider(i, (p = _this.namespace.rpcMap) == null ? void 0 : p[i]);
                }), s;
            }
        },
        {
            key: "getHttpProvider",
            value: function getHttpProvider() {
                var s = "".concat(this.name, ":").concat(this.chainId), i = this.httpProviders[s];
                if ((typeof i === "undefined" ? "undefined" : (0, $l0HdX._)(i)) > "u") throw new Error("JSON-RPC provider for ".concat(s, " not found"));
                return i;
            }
        },
        {
            key: "setHttpProvider",
            value: function setHttpProvider(s, i) {
                var p = this.createHttpProvider(s, i);
                p && (this.httpProviders[s] = p);
            }
        },
        {
            key: "createHttpProvider",
            value: function createHttpProvider(s, i) {
                var p = i || $f96d9a495098fea9$var$Lt(s, this.namespace);
                return (typeof p === "undefined" ? "undefined" : (0, $l0HdX._)(p)) > "u" ? void 0 : new (0, $bMQws.JsonRpcProvider)(new (0, $7FPw1.default)(p, $f96d9a495098fea9$var$F("disableProviderPing")));
            }
        }
    ]);
    return vv;
}();
var $f96d9a495098fea9$var$_v = /*#__PURE__*/ function() {
    "use strict";
    function _v(s) {
        (0, $4GJKx._)(this, _v);
        this.name = $f96d9a495098fea9$var$Kn, this.namespace = s.namespace, this.events = $f96d9a495098fea9$var$F("events"), this.client = $f96d9a495098fea9$var$F("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    (0, $1wc17._)(_v, [
        {
            key: "updateNamespace",
            value: function updateNamespace(s) {
                this.namespace.chains = (0, $c6Xmf._)(new Set((this.namespace.chains || []).concat(s.chains || []))), this.namespace.accounts = (0, $c6Xmf._)(new Set((this.namespace.accounts || []).concat(s.accounts || []))), this.namespace.methods = (0, $c6Xmf._)(new Set((this.namespace.methods || []).concat(s.methods || []))), this.namespace.events = (0, $c6Xmf._)(new Set((this.namespace.events || []).concat(s.events || []))), this.httpProviders = this.createHttpProviders();
            }
        },
        {
            key: "requestAccounts",
            value: function requestAccounts() {
                return this.getAccounts();
            }
        },
        {
            key: "request",
            value: function request(s) {
                return this.namespace.methods.includes(s.request.method) ? this.client.request(s) : this.getHttpProvider(s.chainId).request(s.request);
            }
        },
        {
            key: "setDefaultChain",
            value: function setDefaultChain(s, i) {
                this.httpProviders[s] || this.setHttpProvider(s, i), this.chainId = s, this.events.emit($f96d9a495098fea9$var$Tt.DEFAULT_CHAIN_CHANGED, "".concat(this.name, ":").concat(s));
            }
        },
        {
            key: "getDefaultChain",
            value: function getDefaultChain() {
                if (this.chainId) return this.chainId;
                if (this.namespace.defaultChain) return this.namespace.defaultChain;
                var s = this.namespace.chains[0];
                if (!s) throw new Error("ChainId not found");
                return s.split(":")[1];
            }
        },
        {
            key: "getAccounts",
            value: function getAccounts() {
                var _this = this;
                var s = this.namespace.accounts;
                return s ? (0, $c6Xmf._)(new Set(s.filter(function(i) {
                    return i.split(":")[1] === _this.chainId.toString();
                }).map(function(i) {
                    return i.split(":")[2];
                }))) : [];
            }
        },
        {
            key: "createHttpProviders",
            value: function createHttpProviders() {
                var _this = this;
                var s, i;
                var p = {};
                return (i = (s = this.namespace) == null ? void 0 : s.accounts) == null || i.forEach(function(w) {
                    var x = (0, $8wnFv.parseChainId)(w);
                    p["".concat(x.namespace, ":").concat(x.reference)] = _this.createHttpProvider(w);
                }), p;
            }
        },
        {
            key: "getHttpProvider",
            value: function getHttpProvider(s) {
                var i = this.httpProviders[s];
                if ((typeof i === "undefined" ? "undefined" : (0, $l0HdX._)(i)) > "u") throw new Error("JSON-RPC provider for ".concat(s, " not found"));
                return i;
            }
        },
        {
            key: "setHttpProvider",
            value: function setHttpProvider(s, i) {
                var p = this.createHttpProvider(s, i);
                p && (this.httpProviders[s] = p);
            }
        },
        {
            key: "createHttpProvider",
            value: function createHttpProvider(s, i) {
                var p = i || $f96d9a495098fea9$var$Lt(s, this.namespace, this.client.core.projectId);
                if (!p) throw new Error("No RPC url provided for chainId: ".concat(s));
                return new (0, $bMQws.JsonRpcProvider)(new (0, $7FPw1.default)(p, $f96d9a495098fea9$var$F("disableProviderPing")));
            }
        }
    ]);
    return _v;
}();
var $f96d9a495098fea9$var$mv = Object.defineProperty, $f96d9a495098fea9$var$wv = Object.defineProperties, $f96d9a495098fea9$var$Pv = Object.getOwnPropertyDescriptors, $f96d9a495098fea9$var$Ua = Object.getOwnPropertySymbols, $f96d9a495098fea9$var$Cv = Object.prototype.hasOwnProperty, $f96d9a495098fea9$var$Av = Object.prototype.propertyIsEnumerable, $f96d9a495098fea9$var$Fa = function(P, s, i) {
    return s in P ? $f96d9a495098fea9$var$mv(P, s, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: i
    }) : P[s] = i;
}, $f96d9a495098fea9$var$pr = function(P, s) {
    for(var i in s || (s = {}))$f96d9a495098fea9$var$Cv.call(s, i) && $f96d9a495098fea9$var$Fa(P, i, s[i]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($f96d9a495098fea9$var$Ua) try {
        for(var _iterator = $f96d9a495098fea9$var$Ua(s)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var i = _step.value;
            $f96d9a495098fea9$var$Av.call(s, i) && $f96d9a495098fea9$var$Fa(P, i, s[i]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return P;
}, $f96d9a495098fea9$var$Bi = function(P, s) {
    return $f96d9a495098fea9$var$wv(P, $f96d9a495098fea9$var$Pv(s));
};
var $f96d9a495098fea9$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function dr(s) {
        (0, $4GJKx._)(this, dr);
        this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($cyxGb))), this.rpcProviders = {}, this.shouldAbortPairingAttempt = !1, this.maxPairingAttempts = 10, this.disableProviderPing = !1, this.providerOpts = s, this.logger = (0, $l0HdX._)(s === null || s === void 0 ? void 0 : s.logger) < "u" && typeof (s === null || s === void 0 ? void 0 : s.logger) != "string" ? s.logger : (0, (/*@__PURE__*/$parcel$interopDefault($6DLsq)))((0, $7Gasr.getDefaultLoggerOptions)({
            level: (s === null || s === void 0 ? void 0 : s.logger) || $f96d9a495098fea9$var$ya
        })), this.disableProviderPing = (s === null || s === void 0 ? void 0 : s.disableProviderPing) || !1;
    }
    (0, $1wc17._)(dr, [
        {
            key: "request",
            value: function request(s, i, p) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _this_validateChain, w, x;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this_validateChain = (0, $cv9Rk._)(_this.validateChain(i), 2), w = _this_validateChain[0], x = _this_validateChain[1];
                                if (!_this.session) throw new Error("Please call connect() before request()");
                                return [
                                    4,
                                    _this.getProvider(w).request({
                                        request: $f96d9a495098fea9$var$pr({}, s),
                                        chainId: "".concat(w, ":").concat(x),
                                        topic: _this.session.topic,
                                        expiry: p
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendAsync",
            value: function sendAsync(s, i, p, w) {
                var x = new Date().getTime();
                this.request(s, p, w).then(function(O) {
                    return i(null, (0, $3W2Mc.formatJsonRpcResult)(x, O));
                }).catch(function(O) {
                    return i(O, void 0);
                });
            }
        },
        {
            key: "enable",
            value: function enable() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _tmp;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.client) throw new Error("Sign Client not initialized");
                                _tmp = _this.session;
                                if (_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.connect({
                                        namespaces: _this.namespaces,
                                        optionalNamespaces: _this.optionalNamespaces,
                                        sessionProperties: _this.sessionProperties
                                    })
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                _tmp;
                                return [
                                    4,
                                    _this.requestAccounts()
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var s;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.session) throw new Error("Please call connect() before enable()");
                                return [
                                    4,
                                    _this.client.disconnect({
                                        topic: (s = _this.session) == null ? void 0 : s.topic,
                                        reason: (0, $8wnFv.getSdkError)("USER_DISCONNECTED")
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this.cleanup()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "connect",
            value: function connect(s) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.client) throw new Error("Sign Client not initialized");
                                _this.setNamespaces(s);
                                return [
                                    4,
                                    _this.cleanupPendingPairings()
                                ];
                            case 1:
                                if (!(_state.sent(), !s.skipPairing)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.pair(s.pairingTopic)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "authenticate",
            value: function authenticate(s) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _ref, i, p, w, x;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.client) throw new Error("Sign Client not initialized");
                                _this.setNamespaces(s);
                                return [
                                    4,
                                    _this.cleanupPendingPairings()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this.client.authenticate(s)
                                ];
                            case 2:
                                _ref = _state.sent(), i = _ref.uri, p = _ref.response;
                                i && (_this.uri = i, _this.events.emit("display_uri", i));
                                return [
                                    4,
                                    p()
                                ];
                            case 3:
                                w = _state.sent();
                                if (_this.session = w.session, _this.session) {
                                    x = $f96d9a495098fea9$var$La(_this.session.namespaces);
                                    _this.namespaces = $f96d9a495098fea9$var$Fi(_this.namespaces, x), _this.persist("namespaces", _this.namespaces), _this.onConnect();
                                }
                                return [
                                    2,
                                    w
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "on",
            value: function on(s, i) {
                this.events.on(s, i);
            }
        },
        {
            key: "once",
            value: function once(s, i) {
                this.events.once(s, i);
            }
        },
        {
            key: "removeListener",
            value: function removeListener(s, i) {
                this.events.removeListener(s, i);
            }
        },
        {
            key: "off",
            value: function off(s, i) {
                this.events.off(s, i);
            }
        },
        {
            key: "isWalletConnect",
            get: function get() {
                return !0;
            }
        },
        {
            key: "pair",
            value: function pair(s) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var i, _ref, p, w;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.shouldAbortPairingAttempt = !1;
                                i = 0;
                                _state.label = 1;
                            case 1:
                                if (_this.shouldAbortPairingAttempt) throw new Error("Pairing aborted");
                                if (i >= _this.maxPairingAttempts) throw new Error("Max auto pairing attempts reached");
                                return [
                                    4,
                                    _this.client.connect({
                                        pairingTopic: s,
                                        requiredNamespaces: _this.namespaces,
                                        optionalNamespaces: _this.optionalNamespaces,
                                        sessionProperties: _this.sessionProperties
                                    })
                                ];
                            case 2:
                                _ref = _state.sent(), p = _ref.uri, w = _ref.approval;
                                p && (_this.uri = p, _this.events.emit("display_uri", p));
                                return [
                                    4,
                                    w().then(function(x) {
                                        _this.session = x;
                                        var O = $f96d9a495098fea9$var$La(x.namespaces);
                                        _this.namespaces = $f96d9a495098fea9$var$Fi(_this.namespaces, O), _this.persist("namespaces", _this.namespaces);
                                    }).catch(function(x) {
                                        if (x.message !== (0, $bjRQh.PROPOSAL_EXPIRY_MESSAGE)) throw x;
                                        i++;
                                    })
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                if (!_this.session) return [
                                    3,
                                    1
                                ];
                                _state.label = 5;
                            case 5:
                                return [
                                    2,
                                    (_this.onConnect(), _this.session)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setDefaultChain",
            value: function setDefaultChain(s, i) {
                try {
                    if (!this.session) return;
                    var _this_validateChain = (0, $cv9Rk._)(this.validateChain(s), 2), _$p = _this_validateChain[0], w = _this_validateChain[1], x = this.getProvider(_$p);
                    x.name === $f96d9a495098fea9$var$Kn ? x.setDefaultChain("".concat(_$p, ":").concat(w), i) : x.setDefaultChain(w, i);
                } catch (p) {
                    if (!/Please call connect/.test(p.message)) throw p;
                }
            }
        },
        {
            key: "cleanupPendingPairings",
            value: function cleanupPendingPairings() {
                var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var i, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, p, _tmp, err;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.logger.info("Cleaning up inactive pairings...");
                                i = _this.client.pairing.getAll();
                                if (!(0, $8wnFv.isValidArray)(i)) return [
                                    3,
                                    11
                                ];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    8,
                                    9,
                                    10
                                ]);
                                _iterator = i[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    7
                                ];
                                p = _step.value;
                                if (!s.deletePairings) return [
                                    3,
                                    3
                                ];
                                _tmp = _this.client.core.expirer.set(p.topic, 0);
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                return [
                                    4,
                                    _this.client.core.relayer.subscriber.unsubscribe(p.topic)
                                ];
                            case 4:
                                _tmp = _state.sent();
                                _state.label = 5;
                            case 5:
                                _tmp;
                                _state.label = 6;
                            case 6:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 7:
                                return [
                                    3,
                                    10
                                ];
                            case 8:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    10
                                ];
                            case 9:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 10:
                                _this.logger.info("Inactive pairings cleared: ".concat(i.length));
                                _state.label = 11;
                            case 11:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "abortPairingAttempt",
            value: function abortPairingAttempt() {
                this.shouldAbortPairingAttempt = !0;
            }
        },
        {
            key: "checkStorage",
            value: function checkStorage() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var s;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getFromStore("namespaces")
                                ];
                            case 1:
                                _this.namespaces = _state.sent();
                                return [
                                    4,
                                    _this.getFromStore("optionalNamespaces")
                                ];
                            case 2:
                                if (_this.optionalNamespaces = _state.sent() || {}, _this.client.session.length) {
                                    s = _this.client.session.keys.length - 1;
                                    _this.session = _this.client.session.get(_this.client.session.keys[s]), _this.createProviders();
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "initialize",
            value: function initialize() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.logger.trace("Initialized");
                                return [
                                    4,
                                    _this.createClient()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this.checkStorage()
                                ];
                            case 2:
                                _state.sent(), _this.registerEventListeners();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createClient",
            value: function createClient() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _tmp;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = _this.providerOpts.client;
                                if (_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (0, $bjRQh.default).init({
                                        core: _this.providerOpts.core,
                                        logger: _this.providerOpts.logger || $f96d9a495098fea9$var$ya,
                                        relayUrl: _this.providerOpts.relayUrl || $f96d9a495098fea9$var$Kg,
                                        projectId: _this.providerOpts.projectId,
                                        metadata: _this.providerOpts.metadata,
                                        storageOptions: _this.providerOpts.storageOptions,
                                        storage: _this.providerOpts.storage,
                                        name: _this.providerOpts.name,
                                        customStoragePrefix: _this.providerOpts.customStoragePrefix,
                                        telemetryEnabled: _this.providerOpts.telemetryEnabled
                                    })
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                _this.client = _tmp, _this.logger.trace("SignClient Initialized");
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createProviders",
            value: function createProviders() {
                var _this = this;
                if (!this.client) throw new Error("Sign Client not initialized");
                if (!this.session) throw new Error("Session not initialized. Please call connect() before enable()");
                var s = (0, $c6Xmf._)(new Set(Object.keys(this.session.namespaces).map(function(i) {
                    return (0, $8wnFv.parseNamespaceKey)(i);
                })));
                $f96d9a495098fea9$var$Mi("client", this.client), $f96d9a495098fea9$var$Mi("events", this.events), $f96d9a495098fea9$var$Mi("disableProviderPing", this.disableProviderPing), s.forEach(function(i) {
                    if (!_this.session) return;
                    var p = $f96d9a495098fea9$var$nv(i, _this.session), w = $f96d9a495098fea9$var$ba(p), x = $f96d9a495098fea9$var$Fi(_this.namespaces, _this.optionalNamespaces), O = $f96d9a495098fea9$var$Bi($f96d9a495098fea9$var$pr({}, x[i]), {
                        accounts: p,
                        chains: w
                    });
                    switch(i){
                        case "eip155":
                            _this.rpcProviders[i] = new $f96d9a495098fea9$var$fv({
                                namespace: O
                            });
                            break;
                        case "algorand":
                            _this.rpcProviders[i] = new $f96d9a495098fea9$var$lv({
                                namespace: O
                            });
                            break;
                        case "solana":
                            _this.rpcProviders[i] = new $f96d9a495098fea9$var$cv({
                                namespace: O
                            });
                            break;
                        case "cosmos":
                            _this.rpcProviders[i] = new $f96d9a495098fea9$var$hv({
                                namespace: O
                            });
                            break;
                        case "polkadot":
                            _this.rpcProviders[i] = new $f96d9a495098fea9$var$rv({
                                namespace: O
                            });
                            break;
                        case "cip34":
                            _this.rpcProviders[i] = new $f96d9a495098fea9$var$pv({
                                namespace: O
                            });
                            break;
                        case "elrond":
                            _this.rpcProviders[i] = new $f96d9a495098fea9$var$dv({
                                namespace: O
                            });
                            break;
                        case "multiversx":
                            _this.rpcProviders[i] = new $f96d9a495098fea9$var$gv({
                                namespace: O
                            });
                            break;
                        case "near":
                            _this.rpcProviders[i] = new $f96d9a495098fea9$var$vv({
                                namespace: O
                            });
                            break;
                        default:
                            _this.rpcProviders[$f96d9a495098fea9$var$Kn] ? _this.rpcProviders[$f96d9a495098fea9$var$Kn].updateNamespace(O) : _this.rpcProviders[$f96d9a495098fea9$var$Kn] = new $f96d9a495098fea9$var$_v({
                                namespace: O
                            });
                    }
                });
            }
        },
        {
            key: "registerEventListeners",
            value: function registerEventListeners() {
                var _this = this;
                if ((0, $l0HdX._)(this.client) > "u") throw new Error("Sign Client is not initialized");
                var _this1 = this;
                this.client.on("session_ping", function(s) {
                    _this.events.emit("session_ping", s);
                }), this.client.on("session_event", function(s) {
                    var i = s.params, p = i.event;
                    if (p.name === "accountsChanged") {
                        var w = p.data;
                        w && (0, $8wnFv.isValidArray)(w) && _this.events.emit("accountsChanged", w.map($f96d9a495098fea9$var$ev));
                    } else if (p.name === "chainChanged") {
                        var w1 = i.chainId, x = i.event.data, O = (0, $8wnFv.parseNamespaceKey)(w1), k = $f96d9a495098fea9$var$Wi(w1) !== $f96d9a495098fea9$var$Wi(x) ? "".concat(O, ":").concat($f96d9a495098fea9$var$Wi(x)) : w1;
                        _this.onChainChanged(k);
                    } else _this.events.emit(p.name, p.data);
                    _this.events.emit("session_event", s);
                }), this.client.on("session_update", function(param) {
                    var s = param.topic, i = param.params;
                    var p;
                    var w = i.namespaces, x = (p = _this.client) == null ? void 0 : p.session.get(s);
                    _this.session = $f96d9a495098fea9$var$Bi($f96d9a495098fea9$var$pr({}, x), {
                        namespaces: w
                    }), _this.onSessionUpdate(), _this.events.emit("session_update", {
                        topic: s,
                        params: i
                    });
                }), this.client.on("session_delete", function() {
                    var _ref = (0, $kSuI9._)(function(s) {
                        return (0, $eha6O.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        _this1.cleanup()
                                    ];
                                case 1:
                                    _state.sent(), _this1.events.emit("session_delete", s), _this1.events.emit("disconnect", $f96d9a495098fea9$var$Bi($f96d9a495098fea9$var$pr({}, (0, $8wnFv.getSdkError)("USER_DISCONNECTED")), {
                                        data: s.topic
                                    }));
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(s) {
                        return _ref.apply(this, arguments);
                    };
                }()), this.on($f96d9a495098fea9$var$Tt.DEFAULT_CHAIN_CHANGED, function(s) {
                    _this.onChainChanged(s, !0);
                });
            }
        },
        {
            key: "getProvider",
            value: function getProvider(s) {
                return this.rpcProviders[s] || this.rpcProviders[$f96d9a495098fea9$var$Kn];
            }
        },
        {
            key: "onSessionUpdate",
            value: function onSessionUpdate() {
                var _this = this;
                Object.keys(this.rpcProviders).forEach(function(s) {
                    var i;
                    _this.getProvider(s).updateNamespace((i = _this.session) == null ? void 0 : i.namespaces[s]);
                });
            }
        },
        {
            key: "setNamespaces",
            value: function setNamespaces(s) {
                var i = s.namespaces, p = s.optionalNamespaces, w = s.sessionProperties;
                i && Object.keys(i).length && (this.namespaces = i), p && Object.keys(p).length && (this.optionalNamespaces = p), this.sessionProperties = w, this.persist("namespaces", i), this.persist("optionalNamespaces", p);
            }
        },
        {
            key: "validateChain",
            value: function validateChain(s) {
                var _ref = (0, $cv9Rk._)((s === null || s === void 0 ? void 0 : s.split(":")) || [
                    "",
                    ""
                ], 2), i = _ref[0], p = _ref[1];
                if (!this.namespaces || !Object.keys(this.namespaces).length) return [
                    i,
                    p
                ];
                if (i && !Object.keys(this.namespaces || {}).map(function(O) {
                    return (0, $8wnFv.parseNamespaceKey)(O);
                }).includes(i)) throw new Error("Namespace '".concat(i, "' is not configured. Please call connect() first with namespace config."));
                if (i && p) return [
                    i,
                    p
                ];
                var w = (0, $8wnFv.parseNamespaceKey)(Object.keys(this.namespaces)[0]), x = this.rpcProviders[w].getDefaultChain();
                return [
                    w,
                    x
                ];
            }
        },
        {
            key: "requestAccounts",
            value: function requestAccounts() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _this_validateChain, s;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this_validateChain = (0, $cv9Rk._)(_this.validateChain(), 1), s = _this_validateChain[0];
                                return [
                                    4,
                                    _this.getProvider(s).requestAccounts()
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onChainChanged",
            value: function onChainChanged(s) {
                var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                if (!this.namespaces) return;
                var _this_validateChain = (0, $cv9Rk._)(this.validateChain(s), 2), p = _this_validateChain[0], w = _this_validateChain[1];
                w && (i || this.getProvider(p).setDefaultChain(w), this.namespaces[p] ? this.namespaces[p].defaultChain = w : this.namespaces["".concat(p, ":").concat(w)] ? this.namespaces["".concat(p, ":").concat(w)].defaultChain = w : this.namespaces["".concat(p, ":").concat(w)] = {
                    defaultChain: w
                }, this.persist("namespaces", this.namespaces), this.events.emit("chainChanged", w));
            }
        },
        {
            key: "onConnect",
            value: function onConnect() {
                this.createProviders(), this.events.emit("connect", {
                    session: this.session
                });
            }
        },
        {
            key: "cleanup",
            value: function cleanup() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.session = void 0, _this.namespaces = void 0, _this.optionalNamespaces = void 0, _this.sessionProperties = void 0, _this.persist("namespaces", void 0), _this.persist("optionalNamespaces", void 0), _this.persist("sessionProperties", void 0);
                                return [
                                    4,
                                    _this.cleanupPendingPairings({
                                        deletePairings: !0
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "persist",
            value: function persist(s, i) {
                this.client.core.storage.setItem("".concat($f96d9a495098fea9$var$Sa, "/").concat(s), i);
            }
        },
        {
            key: "getFromStore",
            value: function getFromStore(s) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.client.core.storage.getItem("".concat($f96d9a495098fea9$var$Sa, "/").concat(s))
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        }
    ], [
        {
            key: "init",
            value: function init(s) {
                return (0, $kSuI9._)(function() {
                    var i;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                i = new dr(s);
                                return [
                                    4,
                                    i.initialize()
                                ];
                            case 1:
                                return [
                                    2,
                                    (_state.sent(), i)
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return dr;
}();
var $f96d9a495098fea9$export$63bc40680ab52599 = $f96d9a495098fea9$export$2e2bcd8739ae039;

});
parcelRegister("bjRQh", function(module, exports) {

$parcel$export(module.exports, "PROPOSAL_EXPIRY_MESSAGE", function () { return $83db3bfa38a2bed3$export$1e6a4dc5172f4830; });
$parcel$export(module.exports, "default", function () { return $83db3bfa38a2bed3$export$2e2bcd8739ae039; });

var $d3H5E = parcelRequire("d3H5E");

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $3U0IP = parcelRequire("3U0IP");

var $c6Xmf = parcelRequire("c6Xmf");

var $l0HdX = parcelRequire("l0HdX");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");

var $6uXh7 = parcelRequire("6uXh7");
parcelRequire("7Gasr");
var $6DLsq = parcelRequire("6DLsq");
var $7Gasr = parcelRequire("7Gasr");

var $3WrnC = parcelRequire("3WrnC");

var $8wnFv = parcelRequire("8wnFv");

var $cyxGb = parcelRequire("cyxGb");

var $4BEBs = parcelRequire("4BEBs");
parcelRequire("9YSHu");
var $3W2Mc = parcelRequire("3W2Mc");
var $5lf06 = parcelRequire("5lf06");
var $83db3bfa38a2bed3$export$4fa962fc67384e02 = "wc", $83db3bfa38a2bed3$export$61085c48796ff049 = 2, $83db3bfa38a2bed3$export$94715592c220319a = "client", $83db3bfa38a2bed3$export$7fa6f9ee1e2cab96 = "".concat($83db3bfa38a2bed3$export$4fa962fc67384e02, "@").concat($83db3bfa38a2bed3$export$61085c48796ff049, ":").concat($83db3bfa38a2bed3$export$94715592c220319a, ":"), $83db3bfa38a2bed3$export$8dffb3242f2c5f72 = {
    name: $83db3bfa38a2bed3$export$94715592c220319a,
    logger: "error",
    controller: !1,
    relayUrl: "wss://relay.walletconnect.com"
}, $83db3bfa38a2bed3$export$fb2c3ad2a2bc26e9 = {
    session_proposal: "session_proposal",
    session_update: "session_update",
    session_extend: "session_extend",
    session_ping: "session_ping",
    session_delete: "session_delete",
    session_expire: "session_expire",
    session_request: "session_request",
    session_request_sent: "session_request_sent",
    session_event: "session_event",
    proposal_expire: "proposal_expire",
    session_authenticate: "session_authenticate",
    session_request_expire: "session_request_expire"
}, $83db3bfa38a2bed3$export$2e2bb8505f95527b = {
    database: ":memory:"
}, $83db3bfa38a2bed3$export$a26ccd6441b7d638 = "WALLETCONNECT_DEEPLINK_CHOICE", $83db3bfa38a2bed3$export$a682338b5ffca937 = {
    created: "history_created",
    updated: "history_updated",
    deleted: "history_deleted",
    sync: "history_sync"
}, $83db3bfa38a2bed3$export$160142c73cb99dc3 = "history", $83db3bfa38a2bed3$export$8eba9ce85616c607 = "0.3", $83db3bfa38a2bed3$export$ae6c7a4f7ed730a1 = "proposal", $83db3bfa38a2bed3$export$6db28e89b135a53c = (0, $4BEBs.THIRTY_DAYS), $83db3bfa38a2bed3$export$1e6a4dc5172f4830 = "Proposal expired", $83db3bfa38a2bed3$export$a069e98a8dfeec1e = "session", $83db3bfa38a2bed3$export$84b1b9dbcdea0475 = (0, $4BEBs.SEVEN_DAYS), $83db3bfa38a2bed3$export$2db42d5151ad6eb8 = "engine", $83db3bfa38a2bed3$export$4edb1ca37014192d = {
    wc_sessionPropose: {
        req: {
            ttl: (0, $4BEBs.FIVE_MINUTES),
            prompt: !0,
            tag: 1100
        },
        res: {
            ttl: (0, $4BEBs.FIVE_MINUTES),
            prompt: !1,
            tag: 1101
        },
        reject: {
            ttl: (0, $4BEBs.FIVE_MINUTES),
            prompt: !1,
            tag: 1120
        },
        autoReject: {
            ttl: (0, $4BEBs.FIVE_MINUTES),
            prompt: !1,
            tag: 1121
        }
    },
    wc_sessionSettle: {
        req: {
            ttl: (0, $4BEBs.FIVE_MINUTES),
            prompt: !1,
            tag: 1102
        },
        res: {
            ttl: (0, $4BEBs.FIVE_MINUTES),
            prompt: !1,
            tag: 1103
        }
    },
    wc_sessionUpdate: {
        req: {
            ttl: (0, $4BEBs.ONE_DAY),
            prompt: !1,
            tag: 1104
        },
        res: {
            ttl: (0, $4BEBs.ONE_DAY),
            prompt: !1,
            tag: 1105
        }
    },
    wc_sessionExtend: {
        req: {
            ttl: (0, $4BEBs.ONE_DAY),
            prompt: !1,
            tag: 1106
        },
        res: {
            ttl: (0, $4BEBs.ONE_DAY),
            prompt: !1,
            tag: 1107
        }
    },
    wc_sessionRequest: {
        req: {
            ttl: (0, $4BEBs.FIVE_MINUTES),
            prompt: !0,
            tag: 1108
        },
        res: {
            ttl: (0, $4BEBs.FIVE_MINUTES),
            prompt: !1,
            tag: 1109
        }
    },
    wc_sessionEvent: {
        req: {
            ttl: (0, $4BEBs.FIVE_MINUTES),
            prompt: !0,
            tag: 1110
        },
        res: {
            ttl: (0, $4BEBs.FIVE_MINUTES),
            prompt: !1,
            tag: 1111
        }
    },
    wc_sessionDelete: {
        req: {
            ttl: (0, $4BEBs.ONE_DAY),
            prompt: !1,
            tag: 1112
        },
        res: {
            ttl: (0, $4BEBs.ONE_DAY),
            prompt: !1,
            tag: 1113
        }
    },
    wc_sessionPing: {
        req: {
            ttl: (0, $4BEBs.ONE_DAY),
            prompt: !1,
            tag: 1114
        },
        res: {
            ttl: (0, $4BEBs.ONE_DAY),
            prompt: !1,
            tag: 1115
        }
    },
    wc_sessionAuthenticate: {
        req: {
            ttl: (0, $4BEBs.ONE_HOUR),
            prompt: !0,
            tag: 1116
        },
        res: {
            ttl: (0, $4BEBs.ONE_HOUR),
            prompt: !1,
            tag: 1117
        },
        reject: {
            ttl: (0, $4BEBs.FIVE_MINUTES),
            prompt: !1,
            tag: 1118
        },
        autoReject: {
            ttl: (0, $4BEBs.FIVE_MINUTES),
            prompt: !1,
            tag: 1119
        }
    }
}, $83db3bfa38a2bed3$export$409f0c0a13a1b7c6 = {
    min: (0, $4BEBs.FIVE_MINUTES),
    max: (0, $4BEBs.SEVEN_DAYS)
}, $83db3bfa38a2bed3$export$8602b201748df21a = {
    idle: "IDLE",
    active: "ACTIVE"
}, $83db3bfa38a2bed3$export$40b296af21bd38a4 = "request", $83db3bfa38a2bed3$export$63c37d8ae5931ad5 = [
    "wc_sessionPropose",
    "wc_sessionRequest",
    "wc_authRequest",
    "wc_sessionAuthenticate"
], $83db3bfa38a2bed3$export$e24c518fa7fc04c = "wc", $83db3bfa38a2bed3$export$af233b4aa2e30834 = 1.5, $83db3bfa38a2bed3$export$e8b9bbdca3ac0ed = "auth", $83db3bfa38a2bed3$export$ab815cb37981e7e0 = "authKeys", $83db3bfa38a2bed3$export$5d9af9e20f678626 = "pairingTopics", $83db3bfa38a2bed3$export$3643b3579d091159 = "requests", $83db3bfa38a2bed3$export$323ba3ebb8028ed0 = "".concat($83db3bfa38a2bed3$export$e24c518fa7fc04c, "@", 1.5, ":").concat($83db3bfa38a2bed3$export$e8b9bbdca3ac0ed, ":"), $83db3bfa38a2bed3$export$efef74cb455ac30f = "".concat($83db3bfa38a2bed3$export$323ba3ebb8028ed0, ":PUB_KEY");
var $83db3bfa38a2bed3$var$Zt = Object.defineProperty, $83db3bfa38a2bed3$var$es = Object.defineProperties, $83db3bfa38a2bed3$var$ts = Object.getOwnPropertyDescriptors, $83db3bfa38a2bed3$var$tt = Object.getOwnPropertySymbols, $83db3bfa38a2bed3$var$ss = Object.prototype.hasOwnProperty, $83db3bfa38a2bed3$var$is = Object.prototype.propertyIsEnumerable, $83db3bfa38a2bed3$var$st = function(I, n, t) {
    return n in I ? $83db3bfa38a2bed3$var$Zt(I, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : I[n] = t;
}, $83db3bfa38a2bed3$var$E = function(I, n) {
    for(var t in n || (n = {}))$83db3bfa38a2bed3$var$ss.call(n, t) && $83db3bfa38a2bed3$var$st(I, t, n[t]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($83db3bfa38a2bed3$var$tt) try {
        for(var _iterator = $83db3bfa38a2bed3$var$tt(n)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var t = _step.value;
            $83db3bfa38a2bed3$var$is.call(n, t) && $83db3bfa38a2bed3$var$st(I, t, n[t]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return I;
}, $83db3bfa38a2bed3$var$j = function(I, n) {
    return $83db3bfa38a2bed3$var$es(I, $83db3bfa38a2bed3$var$ts(n));
};
var $83db3bfa38a2bed3$var$rs = /*#__PURE__*/ function(yt) {
    "use strict";
    (0, $dcsZi._)(rs, yt);
    var _super = (0, $ohfOJ._)(rs);
    function rs(n) {
        (0, $4GJKx._)(this, rs);
        var _this;
        var _this1 = (0, $d3H5E._)(_this);
        var _this2 = (0, $d3H5E._)(_this);
        var _this3 = (0, $d3H5E._)(_this);
        var _this4 = (0, $d3H5E._)(_this);
        var _this5 = (0, $d3H5E._)(_this);
        var _this6 = (0, $d3H5E._)(_this);
        var _this7 = (0, $d3H5E._)(_this);
        var _this8 = (0, $d3H5E._)(_this);
        var _this9 = (0, $d3H5E._)(_this);
        var _this10 = (0, $d3H5E._)(_this);
        var _this11 = (0, $d3H5E._)(_this);
        var _this12 = (0, $d3H5E._)(_this);
        var _this13 = (0, $d3H5E._)(_this);
        var _this14 = (0, $d3H5E._)(_this);
        var _this15 = (0, $d3H5E._)(_this);
        var _this16 = (0, $d3H5E._)(_this);
        var _this17 = (0, $d3H5E._)(_this);
        var _this18 = (0, $d3H5E._)(_this);
        var _this19 = (0, $d3H5E._)(_this);
        var _this20 = (0, $d3H5E._)(_this);
        var _this21 = (0, $d3H5E._)(_this);
        var _this22 = (0, $d3H5E._)(_this);
        var _this23 = (0, $d3H5E._)(_this);
        var _this24 = (0, $d3H5E._)(_this);
        var _this25 = (0, $d3H5E._)(_this);
        var _this26 = (0, $d3H5E._)(_this);
        var _this27 = (0, $d3H5E._)(_this);
        var _this28 = (0, $d3H5E._)(_this);
        var _this29 = (0, $d3H5E._)(_this);
        var _this30 = (0, $d3H5E._)(_this);
        var _this31 = (0, $d3H5E._)(_this);
        var _this32 = (0, $d3H5E._)(_this);
        var _this33 = (0, $d3H5E._)(_this);
        var _this34 = (0, $d3H5E._)(_this);
        var _this35 = (0, $d3H5E._)(_this);
        var _this36 = (0, $d3H5E._)(_this);
        var _this37 = (0, $d3H5E._)(_this);
        var _this38 = (0, $d3H5E._)(_this);
        var _this39 = (0, $d3H5E._)(_this);
        var _this40 = (0, $d3H5E._)(_this);
        var _this41 = (0, $d3H5E._)(_this);
        var _this42 = (0, $d3H5E._)(_this);
        var _this43 = (0, $d3H5E._)(_this);
        var _this44 = (0, $d3H5E._)(_this);
        var _this45 = (0, $d3H5E._)(_this);
        var _this46 = (0, $d3H5E._)(_this);
        var _this47 = (0, $d3H5E._)(_this);
        var _this48 = (0, $d3H5E._)(_this);
        var _this49 = (0, $d3H5E._)(_this);
        var _this50 = (0, $d3H5E._)(_this);
        var _this51 = (0, $d3H5E._)(_this);
        var _this52 = (0, $d3H5E._)(_this);
        var _this53 = (0, $d3H5E._)(_this);
        var _this54 = (0, $d3H5E._)(_this);
        _this = _super.call(this, n), _this.name = $83db3bfa38a2bed3$export$2db42d5151ad6eb8, _this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($cyxGb))), _this.initialized = !1, _this.requestQueue = {
            state: $83db3bfa38a2bed3$export$8602b201748df21a.idle,
            queue: []
        }, _this.sessionRequestQueue = {
            state: $83db3bfa38a2bed3$export$8602b201748df21a.idle,
            queue: []
        }, _this.requestQueueDelay = (0, $4BEBs.ONE_SECOND), _this.expectedPairingMethodMap = new Map, _this.recentlyDeletedMap = new Map, _this.recentlyDeletedLimit = 200, _this.relayMessageCache = [], _this.init = /*#__PURE__*/ (0, $kSuI9._)(function() {
            var _tmp;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = _this1.initialized;
                        if (_tmp) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            _this1.cleanup()
                        ];
                    case 1:
                        _tmp = (_state.sent(), _this1.registerRelayerEvents(), _this1.registerExpirerEvents(), _this1.registerPairingEvents(), _this1.client.core.pairing.register({
                            methods: Object.keys($83db3bfa38a2bed3$export$4edb1ca37014192d)
                        }), _this1.initialized = !0, setTimeout(function() {
                            _this1.sessionRequestQueue.queue = _this1.getPendingSessionRequests(), _this1.processSessionRequestQueue();
                        }, (0, $4BEBs.toMiliseconds)(_this1.requestQueueDelay)));
                        _state.label = 2;
                    case 2:
                        _tmp;
                        return [
                            2
                        ];
                }
            });
        }), _this.connect = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var e, s, i, r, o, a, c, h, l, _ref, _$y, R, _p, _$y1, g, d, u, _, _z, q, m, O, D;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this2.isInitialized()
                            ];
                        case 1:
                            _state.sent();
                            e = $83db3bfa38a2bed3$var$j($83db3bfa38a2bed3$var$E({}, t), {
                                requiredNamespaces: t.requiredNamespaces || {},
                                optionalNamespaces: t.optionalNamespaces || {}
                            });
                            return [
                                4,
                                _this2.isValidConnect(e)
                            ];
                        case 2:
                            _state.sent();
                            s = e.pairingTopic, i = e.requiredNamespaces, r = e.optionalNamespaces, o = e.sessionProperties, a = e.relays;
                            c = s, l = !1;
                            try {
                                c && (l = _this2.client.core.pairing.pairings.get(c).active);
                            } catch (y) {
                                throw _this2.client.logger.error("connect() -> pairing.get(".concat(c, ") failed")), y;
                            }
                            if (!(!c || !l)) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                _this2.client.core.pairing.create()
                            ];
                        case 3:
                            _ref = _state.sent(), _$y = _ref.topic, R = _ref.uri;
                            c = _$y, h = R;
                            _state.label = 4;
                        case 4:
                            if (!c) {
                                _p = (0, $8wnFv.getInternalError)("NO_MATCHING_KEY", "connect() pairing topic: ".concat(c)), _$y1 = _p.message;
                                throw new Error(_$y1);
                            }
                            return [
                                4,
                                _this2.client.core.crypto.generateKeyPair()
                            ];
                        case 5:
                            g = _state.sent(), d = $83db3bfa38a2bed3$export$4edb1ca37014192d.wc_sessionPropose.req.ttl || (0, $4BEBs.FIVE_MINUTES), u = (0, $8wnFv.calcExpiry)(d), _ = $83db3bfa38a2bed3$var$E({
                                requiredNamespaces: i,
                                optionalNamespaces: r,
                                relays: a !== null && a !== void 0 ? a : [
                                    {
                                        protocol: (0, $6uXh7.RELAYER_DEFAULT_PROTOCOL)
                                    }
                                ],
                                proposer: {
                                    publicKey: g,
                                    metadata: _this2.client.metadata
                                },
                                expiryTimestamp: u,
                                pairingTopic: c
                            }, o && {
                                sessionProperties: o
                            }), _z = (0, $8wnFv.createDelayedPromise)(d, $83db3bfa38a2bed3$export$1e6a4dc5172f4830), q = _z.reject, m = _z.resolve, O = _z.done;
                            _this2.events.once((0, $8wnFv.engineEvent)("session_connect"), function() {
                                var _ref = (0, $kSuI9._)(function(param) {
                                    var _$y, R, K, _tmp;
                                    return (0, $eha6O.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _$y = param.error, R = param.session;
                                                if (!_$y) return [
                                                    3,
                                                    1
                                                ];
                                                q(_$y);
                                                return [
                                                    3,
                                                    6
                                                ];
                                            case 1:
                                                if (!R) return [
                                                    3,
                                                    6
                                                ];
                                                R.self.publicKey = g;
                                                K = $83db3bfa38a2bed3$var$j($83db3bfa38a2bed3$var$E({}, R), {
                                                    pairingTopic: _.pairingTopic,
                                                    requiredNamespaces: _.requiredNamespaces,
                                                    optionalNamespaces: _.optionalNamespaces
                                                });
                                                return [
                                                    4,
                                                    _this2.client.session.set(R.topic, K)
                                                ];
                                            case 2:
                                                _state.sent();
                                                return [
                                                    4,
                                                    _this2.setExpiry(R.topic, R.expiry)
                                                ];
                                            case 3:
                                                _state.sent();
                                                _tmp = c;
                                                if (!_tmp) return [
                                                    3,
                                                    5
                                                ];
                                                return [
                                                    4,
                                                    _this2.client.core.pairing.updateMetadata({
                                                        topic: c,
                                                        metadata: R.peer.metadata
                                                    })
                                                ];
                                            case 4:
                                                _tmp = _state.sent();
                                                _state.label = 5;
                                            case 5:
                                                _tmp, _this2.cleanupDuplicatePairings(K), m(K);
                                                _state.label = 6;
                                            case 6:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(_) {
                                    return _ref.apply(this, arguments);
                                };
                            }());
                            return [
                                4,
                                _this2.sendRequest({
                                    topic: c,
                                    method: "wc_sessionPropose",
                                    params: _,
                                    throwOnFailedPublish: !0
                                })
                            ];
                        case 6:
                            D = _state.sent();
                            return [
                                4,
                                _this2.setProposal(D, $83db3bfa38a2bed3$var$E({
                                    id: D
                                }, _))
                            ];
                        case 7:
                            return [
                                2,
                                (_state.sent(), {
                                    uri: h,
                                    approval: O
                                })
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.pair = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var e;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this3.isInitialized()
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                _this3.client.core.pairing.pair(t)
                            ];
                        case 3:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 4:
                            e = _state.sent();
                            throw _this3.client.logger.error("pair() failed"), e;
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.approve = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var e, s, i, r, f, f1, f2, o, a, c, h, l, g, d, u, _, q, m, O, D, y, R, f3, K, f4;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            r = _this4.client.core.eventClient.createEvent({
                                properties: {
                                    topic: (e = t === null || t === void 0 ? void 0 : t.id) == null ? void 0 : e.toString(),
                                    trace: [
                                        (0, $6uXh7.EVENT_CLIENT_SESSION_TRACES).session_approve_started
                                    ]
                                }
                            });
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                _this4.isInitialized()
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            f = _state.sent();
                            throw r.setError((0, $6uXh7.EVENT_CLIENT_SESSION_ERRORS).no_internet_connection), f;
                        case 4:
                            _state.trys.push([
                                4,
                                6,
                                ,
                                7
                            ]);
                            return [
                                4,
                                _this4.isValidProposalId(t === null || t === void 0 ? void 0 : t.id)
                            ];
                        case 5:
                            _state.sent();
                            return [
                                3,
                                7
                            ];
                        case 6:
                            f1 = _state.sent();
                            throw _this4.client.logger.error("approve() -> proposal.get(".concat(t === null || t === void 0 ? void 0 : t.id, ") failed")), r.setError((0, $6uXh7.EVENT_CLIENT_SESSION_ERRORS).proposal_not_found), f1;
                        case 7:
                            _state.trys.push([
                                7,
                                9,
                                ,
                                10
                            ]);
                            return [
                                4,
                                _this4.isValidApprove(t)
                            ];
                        case 8:
                            _state.sent();
                            return [
                                3,
                                10
                            ];
                        case 9:
                            f2 = _state.sent();
                            throw _this4.client.logger.error("approve() -> isValidApprove() failed"), r.setError((0, $6uXh7.EVENT_CLIENT_SESSION_ERRORS).session_approve_namespace_validation_failure), f2;
                        case 10:
                            o = t.id, a = t.relayProtocol, c = t.namespaces, h = t.sessionProperties, l = t.sessionConfig, g = _this4.client.proposal.get(o);
                            _this4.client.core.eventClient.deleteEvent({
                                eventId: r.eventId
                            });
                            d = g.pairingTopic, u = g.proposer, _ = g.requiredNamespaces, q = g.optionalNamespaces;
                            m = (s = _this4.client.core.eventClient) == null ? void 0 : s.getEvent({
                                topic: d
                            });
                            m || (m = (i = _this4.client.core.eventClient) == null ? void 0 : i.createEvent({
                                type: (0, $6uXh7.EVENT_CLIENT_SESSION_TRACES).session_approve_started,
                                properties: {
                                    topic: d,
                                    trace: [
                                        (0, $6uXh7.EVENT_CLIENT_SESSION_TRACES).session_approve_started,
                                        (0, $6uXh7.EVENT_CLIENT_SESSION_TRACES).session_namespaces_validation_success
                                    ]
                                }
                            }));
                            return [
                                4,
                                _this4.client.core.crypto.generateKeyPair()
                            ];
                        case 11:
                            O = _state.sent(), D = u.publicKey;
                            return [
                                4,
                                _this4.client.core.crypto.generateSharedKey(O, D)
                            ];
                        case 12:
                            y = _state.sent(), R = $83db3bfa38a2bed3$var$E($83db3bfa38a2bed3$var$E({
                                relay: {
                                    protocol: a !== null && a !== void 0 ? a : "irn"
                                },
                                namespaces: c,
                                controller: {
                                    publicKey: O,
                                    metadata: _this4.client.metadata
                                },
                                expiry: (0, $8wnFv.calcExpiry)($83db3bfa38a2bed3$export$84b1b9dbcdea0475)
                            }, h && {
                                sessionProperties: h
                            }), l && {
                                sessionConfig: l
                            });
                            m.addTrace((0, $6uXh7.EVENT_CLIENT_SESSION_TRACES).subscribing_session_topic);
                            _state.label = 13;
                        case 13:
                            _state.trys.push([
                                13,
                                15,
                                ,
                                16
                            ]);
                            return [
                                4,
                                _this4.client.core.relayer.subscribe(y)
                            ];
                        case 14:
                            _state.sent();
                            return [
                                3,
                                16
                            ];
                        case 15:
                            f3 = _state.sent();
                            throw m.setError((0, $6uXh7.EVENT_CLIENT_SESSION_ERRORS).subscribe_session_topic_failure), f3;
                        case 16:
                            m.addTrace((0, $6uXh7.EVENT_CLIENT_SESSION_TRACES).subscribe_session_topic_success);
                            K = $83db3bfa38a2bed3$var$j($83db3bfa38a2bed3$var$E({}, R), {
                                topic: y,
                                requiredNamespaces: _,
                                optionalNamespaces: q,
                                pairingTopic: d,
                                acknowledged: !1,
                                self: R.controller,
                                peer: {
                                    publicKey: u.publicKey,
                                    metadata: u.metadata
                                },
                                controller: O
                            });
                            return [
                                4,
                                _this4.client.session.set(y, K)
                            ];
                        case 17:
                            _state.sent(), m.addTrace((0, $6uXh7.EVENT_CLIENT_SESSION_TRACES).store_session);
                            _state.label = 18;
                        case 18:
                            _state.trys.push([
                                18,
                                21,
                                ,
                                23
                            ]);
                            m.addTrace((0, $6uXh7.EVENT_CLIENT_SESSION_TRACES).publishing_session_settle);
                            return [
                                4,
                                _this4.sendRequest({
                                    topic: y,
                                    method: "wc_sessionSettle",
                                    params: R,
                                    throwOnFailedPublish: !0
                                }).catch(function(f) {
                                    throw m === null || m === void 0 ? void 0 : m.setError((0, $6uXh7.EVENT_CLIENT_SESSION_ERRORS).session_settle_publish_failure), f;
                                })
                            ];
                        case 19:
                            _state.sent(), m.addTrace((0, $6uXh7.EVENT_CLIENT_SESSION_TRACES).session_settle_publish_success), m.addTrace((0, $6uXh7.EVENT_CLIENT_SESSION_TRACES).publishing_session_approve);
                            return [
                                4,
                                _this4.sendResult({
                                    id: o,
                                    topic: d,
                                    result: {
                                        relay: {
                                            protocol: a !== null && a !== void 0 ? a : "irn"
                                        },
                                        responderPublicKey: O
                                    },
                                    throwOnFailedPublish: !0
                                }).catch(function(f) {
                                    throw m === null || m === void 0 ? void 0 : m.setError((0, $6uXh7.EVENT_CLIENT_SESSION_ERRORS).session_approve_publish_failure), f;
                                })
                            ];
                        case 20:
                            _state.sent(), m.addTrace((0, $6uXh7.EVENT_CLIENT_SESSION_TRACES).session_approve_publish_success);
                            return [
                                3,
                                23
                            ];
                        case 21:
                            f4 = _state.sent();
                            _this4.client.logger.error(f4), _this4.client.session.delete(y, (0, $8wnFv.getSdkError)("USER_DISCONNECTED"));
                            return [
                                4,
                                _this4.client.core.relayer.unsubscribe(y)
                            ];
                        case 22:
                            throw _state.sent(), f4;
                        case 23:
                            _this4.client.core.eventClient.deleteEvent({
                                eventId: m.eventId
                            });
                            return [
                                4,
                                _this4.client.core.pairing.updateMetadata({
                                    topic: d,
                                    metadata: u.metadata
                                })
                            ];
                        case 24:
                            _state.sent();
                            return [
                                4,
                                _this4.client.proposal.delete(o, (0, $8wnFv.getSdkError)("USER_DISCONNECTED"))
                            ];
                        case 25:
                            _state.sent();
                            return [
                                4,
                                _this4.client.core.pairing.activate({
                                    topic: d
                                })
                            ];
                        case 26:
                            _state.sent();
                            return [
                                4,
                                _this4.setExpiry(y, (0, $8wnFv.calcExpiry)($83db3bfa38a2bed3$export$84b1b9dbcdea0475))
                            ];
                        case 27:
                            return [
                                2,
                                (_state.sent(), {
                                    topic: y,
                                    acknowledged: function() {
                                        return Promise.resolve(_this4.client.session.get(y));
                                    }
                                })
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.reject = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var r, e, s, i, _tmp;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this5.isInitialized()
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                _this5.isValidReject(t)
                            ];
                        case 3:
                            _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 4:
                            r = _state.sent();
                            throw _this5.client.logger.error("reject() -> isValidReject() failed"), r;
                        case 5:
                            e = t.id, s = t.reason;
                            try {
                                i = _this5.client.proposal.get(e).pairingTopic;
                            } catch (r) {
                                throw _this5.client.logger.error("reject() -> proposal.get(".concat(e, ") failed")), r;
                            }
                            _tmp = i;
                            if (!_tmp) return [
                                3,
                                8
                            ];
                            return [
                                4,
                                _this5.sendError({
                                    id: e,
                                    topic: i,
                                    error: s,
                                    rpcOpts: $83db3bfa38a2bed3$export$4edb1ca37014192d.wc_sessionPropose.reject
                                })
                            ];
                        case 6:
                            _state.sent();
                            return [
                                4,
                                _this5.client.proposal.delete(e, (0, $8wnFv.getSdkError)("USER_DISCONNECTED"))
                            ];
                        case 7:
                            _tmp = _state.sent();
                            _state.label = 8;
                        case 8:
                            _tmp;
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.update = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var l, e, s, _z, i, r, o, a, c, h;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this6.isInitialized()
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                _this6.isValidUpdate(t)
                            ];
                        case 3:
                            _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 4:
                            l = _state.sent();
                            throw _this6.client.logger.error("update() -> isValidUpdate() failed"), l;
                        case 5:
                            e = t.topic, s = t.namespaces, _z = (0, $8wnFv.createDelayedPromise)(), i = _z.done, r = _z.resolve, o = _z.reject, a = (0, $3W2Mc.payloadId)(), c = (0, $3W2Mc.getBigIntRpcId)().toString(), h = _this6.client.session.get(e).namespaces;
                            _this6.events.once((0, $8wnFv.engineEvent)("session_update", a), function(param) {
                                var _$l = param.error;
                                _$l ? o(_$l) : r();
                            });
                            return [
                                4,
                                _this6.client.session.update(e, {
                                    namespaces: s
                                })
                            ];
                        case 6:
                            _state.sent();
                            return [
                                4,
                                _this6.sendRequest({
                                    topic: e,
                                    method: "wc_sessionUpdate",
                                    params: {
                                        namespaces: s
                                    },
                                    throwOnFailedPublish: !0,
                                    clientRpcId: a,
                                    relayRpcId: c
                                }).catch(function(l) {
                                    _this6.client.logger.error(l), _this6.client.session.update(e, {
                                        namespaces: h
                                    }), o(l);
                                })
                            ];
                        case 7:
                            return [
                                2,
                                (_state.sent(), {
                                    acknowledged: i
                                })
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.extend = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var a, e, s, _z, i, r, o;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this7.isInitialized()
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                _this7.isValidExtend(t)
                            ];
                        case 3:
                            _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 4:
                            a = _state.sent();
                            throw _this7.client.logger.error("extend() -> isValidExtend() failed"), a;
                        case 5:
                            e = t.topic, s = (0, $3W2Mc.payloadId)(), _z = (0, $8wnFv.createDelayedPromise)(), i = _z.done, r = _z.resolve, o = _z.reject;
                            _this7.events.once((0, $8wnFv.engineEvent)("session_extend", s), function(param) {
                                var _$a = param.error;
                                _$a ? o(_$a) : r();
                            });
                            return [
                                4,
                                _this7.setExpiry(e, (0, $8wnFv.calcExpiry)($83db3bfa38a2bed3$export$84b1b9dbcdea0475))
                            ];
                        case 6:
                            return [
                                2,
                                (_state.sent(), _this7.sendRequest({
                                    topic: e,
                                    method: "wc_sessionExtend",
                                    params: {},
                                    clientRpcId: s,
                                    throwOnFailedPublish: !0
                                }).catch(function(a) {
                                    o(a);
                                }), {
                                    acknowledged: i
                                })
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.request = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var d, e, s, i, tmp, r, o, a, c, _z, h, l, g;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this8.isInitialized()
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                _this8.isValidRequest(t)
                            ];
                        case 3:
                            _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 4:
                            d = _state.sent();
                            throw _this8.client.logger.error("request() -> isValidRequest() failed"), d;
                        case 5:
                            e = t.chainId, s = t.request, i = t.topic, tmp = t.expiry, r = tmp === void 0 ? $83db3bfa38a2bed3$export$4edb1ca37014192d.wc_sessionRequest.req.ttl : tmp, o = _this8.client.session.get(i), a = (0, $3W2Mc.payloadId)(), c = (0, $3W2Mc.getBigIntRpcId)().toString(), _z = (0, $8wnFv.createDelayedPromise)(r, "Request expired. Please try again."), h = _z.done, l = _z.resolve, g = _z.reject;
                            _this8.events.once((0, $8wnFv.engineEvent)("session_request", a), function(param) {
                                var _$d = param.error, u = param.result;
                                _$d ? g(_$d) : l(u);
                            });
                            return [
                                4,
                                Promise.all([
                                    new Promise(function() {
                                        var _ref = (0, $kSuI9._)(function(d) {
                                            return (0, $eha6O.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            _this8.sendRequest({
                                                                clientRpcId: a,
                                                                relayRpcId: c,
                                                                topic: i,
                                                                method: "wc_sessionRequest",
                                                                params: {
                                                                    request: $83db3bfa38a2bed3$var$j($83db3bfa38a2bed3$var$E({}, s), {
                                                                        expiryTimestamp: (0, $8wnFv.calcExpiry)(r)
                                                                    }),
                                                                    chainId: e
                                                                },
                                                                expiry: r,
                                                                throwOnFailedPublish: !0
                                                            }).catch(function(u) {
                                                                return g(u);
                                                            })
                                                        ];
                                                    case 1:
                                                        _state.sent(), _this8.client.events.emit("session_request_sent", {
                                                            topic: i,
                                                            request: s,
                                                            chainId: e,
                                                            id: a
                                                        }), d();
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(d) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }()),
                                    new Promise(function() {
                                        var _ref = (0, $kSuI9._)(function(d) {
                                            var u, _;
                                            return (0, $eha6O.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        if (!!((u = o.sessionConfig) != null && u.disableDeepLink)) return [
                                                            3,
                                                            2
                                                        ];
                                                        return [
                                                            4,
                                                            (0, $8wnFv.getDeepLink)(_this8.client.core.storage, $83db3bfa38a2bed3$export$a26ccd6441b7d638)
                                                        ];
                                                    case 1:
                                                        _ = _state.sent();
                                                        (0, $8wnFv.handleDeeplinkRedirect)({
                                                            id: a,
                                                            topic: i,
                                                            wcDeepLink: _
                                                        });
                                                        _state.label = 2;
                                                    case 2:
                                                        d();
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(d) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }()),
                                    h()
                                ]).then(function(d) {
                                    return d[2];
                                })
                            ];
                        case 6:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.respond = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var e, s, i, _tmp, _tmp1;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this9.isInitialized()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                _this9.isValidRespond(t)
                            ];
                        case 2:
                            _state.sent();
                            e = t.topic, s = t.response, i = s.id;
                            if (!(0, $5lf06.isJsonRpcResult)(s)) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                _this9.sendResult({
                                    id: i,
                                    topic: e,
                                    result: s.result,
                                    throwOnFailedPublish: !0
                                })
                            ];
                        case 3:
                            _tmp = _state.sent();
                            return [
                                3,
                                7
                            ];
                        case 4:
                            _tmp1 = (0, $5lf06.isJsonRpcError)(s);
                            if (!_tmp1) return [
                                3,
                                6
                            ];
                            return [
                                4,
                                _this9.sendError({
                                    id: i,
                                    topic: e,
                                    error: s.error
                                })
                            ];
                        case 5:
                            _tmp1 = _state.sent();
                            _state.label = 6;
                        case 6:
                            _tmp = _tmp1;
                            _state.label = 7;
                        case 7:
                            _tmp, _this9.cleanupAfterResponse(t);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.ping = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var s, e, _$s, i, _z, r, o, a, _tmp;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this10.isInitialized()
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                _this10.isValidPing(t)
                            ];
                        case 3:
                            _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 4:
                            s = _state.sent();
                            throw _this10.client.logger.error("ping() -> isValidPing() failed"), s;
                        case 5:
                            e = t.topic;
                            if (!_this10.client.session.keys.includes(e)) return [
                                3,
                                7
                            ];
                            _$s = (0, $3W2Mc.payloadId)(), i = (0, $3W2Mc.getBigIntRpcId)().toString(), _z = (0, $8wnFv.createDelayedPromise)(), r = _z.done, o = _z.resolve, a = _z.reject;
                            _this10.events.once((0, $8wnFv.engineEvent)("session_ping", _$s), function(param) {
                                var c = param.error;
                                c ? a(c) : o();
                            });
                            return [
                                4,
                                Promise.all([
                                    _this10.sendRequest({
                                        topic: e,
                                        method: "wc_sessionPing",
                                        params: {},
                                        throwOnFailedPublish: !0,
                                        clientRpcId: _$s,
                                        relayRpcId: i
                                    }),
                                    r()
                                ])
                            ];
                        case 6:
                            _state.sent();
                            return [
                                3,
                                10
                            ];
                        case 7:
                            _tmp = _this10.client.core.pairing.pairings.keys.includes(e);
                            if (!_tmp) return [
                                3,
                                9
                            ];
                            return [
                                4,
                                _this10.client.core.pairing.ping({
                                    topic: e
                                })
                            ];
                        case 8:
                            _tmp = _state.sent();
                            _state.label = 9;
                        case 9:
                            _tmp;
                            _state.label = 10;
                        case 10:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.emit = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var e, s, i, r;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this11.isInitialized()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                _this11.isValidEmit(t)
                            ];
                        case 2:
                            _state.sent();
                            e = t.topic, s = t.event, i = t.chainId, r = (0, $3W2Mc.getBigIntRpcId)().toString();
                            return [
                                4,
                                _this11.sendRequest({
                                    topic: e,
                                    method: "wc_sessionEvent",
                                    params: {
                                        event: s,
                                        chainId: i
                                    },
                                    throwOnFailedPublish: !0,
                                    relayRpcId: r
                                })
                            ];
                        case 3:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.disconnect = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var e, _p, s;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this12.isInitialized()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                _this12.isValidDisconnect(t)
                            ];
                        case 2:
                            _state.sent();
                            e = t.topic;
                            if (!_this12.client.session.keys.includes(e)) return [
                                3,
                                5
                            ];
                            return [
                                4,
                                _this12.sendRequest({
                                    topic: e,
                                    method: "wc_sessionDelete",
                                    params: (0, $8wnFv.getSdkError)("USER_DISCONNECTED"),
                                    throwOnFailedPublish: !0
                                })
                            ];
                        case 3:
                            _state.sent();
                            return [
                                4,
                                _this12.deleteSession({
                                    topic: e,
                                    emitEvent: !1
                                })
                            ];
                        case 4:
                            _state.sent();
                            return [
                                3,
                                8
                            ];
                        case 5:
                            if (!_this12.client.core.pairing.pairings.keys.includes(e)) return [
                                3,
                                7
                            ];
                            return [
                                4,
                                _this12.client.core.pairing.disconnect({
                                    topic: e
                                })
                            ];
                        case 6:
                            _state.sent();
                            return [
                                3,
                                8
                            ];
                        case 7:
                            _p = (0, $8wnFv.getInternalError)("MISMATCHED_TOPIC", "Session or pairing topic not found: ".concat(e)), s = _p.message;
                            throw new Error(s);
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.find = function(t) {
            return _this.isInitialized(), _this.client.session.getAll().filter(function(e) {
                return (0, $8wnFv.isSessionCompatible)(e, t);
            });
        }, _this.getPendingSessionRequests = function() {
            return _this.client.pendingRequest.getAll();
        }, _this.authenticate = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var e, tmp, s, i, r, o, a, c, h, tmp1, l, g, d, _ref, u, _, q, m, _Ee, _$A, v, O, D, y, R, _z, K, f, de, re, ue, F, B, A;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this13.isInitialized(), _this13.isValidAuthenticate(t);
                            e = t.chains, tmp = t.statement, s = tmp === void 0 ? "" : tmp, i = t.uri, r = t.domain, o = t.nonce, a = t.type, c = t.exp, h = t.nbf, tmp1 = t.methods, l = tmp1 === void 0 ? [] : tmp1, g = t.expiry, d = (0, $c6Xmf._)(t.resources || []);
                            return [
                                4,
                                _this13.client.core.pairing.create({
                                    methods: [
                                        "wc_sessionAuthenticate"
                                    ]
                                })
                            ];
                        case 1:
                            _ref = _state.sent(), u = _ref.topic, _ = _ref.uri;
                            _this13.client.logger.info({
                                message: "Generated new pairing",
                                pairing: {
                                    topic: u,
                                    uri: _
                                }
                            });
                            return [
                                4,
                                _this13.client.core.crypto.generateKeyPair()
                            ];
                        case 2:
                            q = _state.sent(), m = (0, $8wnFv.hashKey)(q);
                            return [
                                4,
                                Promise.all([
                                    _this13.client.auth.authKeys.set($83db3bfa38a2bed3$export$efef74cb455ac30f, {
                                        responseTopic: m,
                                        publicKey: q
                                    }),
                                    _this13.client.auth.pairingTopics.set(m, {
                                        topic: m,
                                        pairingTopic: u
                                    })
                                ])
                            ];
                        case 3:
                            _state.sent();
                            return [
                                4,
                                _this13.client.core.relayer.subscribe(m)
                            ];
                        case 4:
                            if (_state.sent(), _this13.client.logger.info("sending request to new pairing topic: ".concat(u)), l.length > 0) {
                                _Ee = (0, $8wnFv.parseChainId)(e[0]), _$A = _Ee.namespace;
                                v = (0, $8wnFv.createEncodedRecap)(_$A, "request", l);
                                (0, $8wnFv.getRecapFromResources)(d) && (v = (0, $8wnFv.mergeEncodedRecaps)(v, d.pop())), d.push(v);
                            }
                            O = g && g > $83db3bfa38a2bed3$export$4edb1ca37014192d.wc_sessionAuthenticate.req.ttl ? g : $83db3bfa38a2bed3$export$4edb1ca37014192d.wc_sessionAuthenticate.req.ttl, D = {
                                authPayload: {
                                    type: a !== null && a !== void 0 ? a : "caip122",
                                    chains: e,
                                    statement: s,
                                    aud: i,
                                    domain: r,
                                    version: "1",
                                    nonce: o,
                                    iat: new Date().toISOString(),
                                    exp: c,
                                    nbf: h,
                                    resources: d
                                },
                                requester: {
                                    publicKey: q,
                                    metadata: _this13.client.metadata
                                },
                                expiryTimestamp: (0, $8wnFv.calcExpiry)(O)
                            }, y = {
                                eip155: {
                                    chains: e,
                                    methods: (0, $c6Xmf._)(new Set([
                                        "personal_sign"
                                    ].concat((0, $c6Xmf._)(l)))),
                                    events: [
                                        "chainChanged",
                                        "accountsChanged"
                                    ]
                                }
                            }, R = {
                                requiredNamespaces: {},
                                optionalNamespaces: y,
                                relays: [
                                    {
                                        protocol: "irn"
                                    }
                                ],
                                pairingTopic: u,
                                proposer: {
                                    publicKey: q,
                                    metadata: _this13.client.metadata
                                },
                                expiryTimestamp: (0, $8wnFv.calcExpiry)($83db3bfa38a2bed3$export$4edb1ca37014192d.wc_sessionPropose.req.ttl)
                            }, _z = (0, $8wnFv.createDelayedPromise)(O, "Request expired"), K = _z.done, f = _z.resolve, de = _z.reject, re = function() {
                                var _ref = (0, $kSuI9._)(function(param) {
                                    var _$A, v, _tmp, Q;
                                    return (0, $eha6O.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _$A = param.error, v = param.session;
                                                if (!(_this13.events.off((0, $8wnFv.engineEvent)("session_request", F), ue), _$A)) return [
                                                    3,
                                                    1
                                                ];
                                                de(_$A);
                                                return [
                                                    3,
                                                    7
                                                ];
                                            case 1:
                                                if (!v) return [
                                                    3,
                                                    7
                                                ];
                                                v.self.publicKey = q;
                                                return [
                                                    4,
                                                    _this13.client.session.set(v.topic, v)
                                                ];
                                            case 2:
                                                _state.sent();
                                                return [
                                                    4,
                                                    _this13.setExpiry(v.topic, v.expiry)
                                                ];
                                            case 3:
                                                _state.sent();
                                                _tmp = u;
                                                if (!_tmp) return [
                                                    3,
                                                    5
                                                ];
                                                return [
                                                    4,
                                                    _this13.client.core.pairing.updateMetadata({
                                                        topic: u,
                                                        metadata: v.peer.metadata
                                                    })
                                                ];
                                            case 4:
                                                _tmp = _state.sent();
                                                _state.label = 5;
                                            case 5:
                                                _tmp;
                                                Q = _this13.client.session.get(v.topic);
                                                return [
                                                    4,
                                                    _this13.deleteProposal(B)
                                                ];
                                            case 6:
                                                _state.sent(), f({
                                                    session: Q
                                                });
                                                _state.label = 7;
                                            case 7:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function re(_) {
                                    return _ref.apply(this, arguments);
                                };
                            }(), ue = function() {
                                var _ref = (0, $kSuI9._)(function(A) {
                                    var W, _A_result, v, Q, ge, Te, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, W1, we, ye, Oe, rt, _ge, _Oe, me, nt, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, me1, err, ne, oe, _tmp, _tmp1;
                                    return (0, $eha6O.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    _this13.deletePendingAuthRequest(F, {
                                                        message: "fulfilled",
                                                        code: 0
                                                    })
                                                ];
                                            case 1:
                                                if (_state.sent(), A.error) {
                                                    W = (0, $8wnFv.getSdkError)("WC_METHOD_UNSUPPORTED", "wc_sessionAuthenticate");
                                                    return [
                                                        2,
                                                        A.error.code === W.code ? void 0 : (_this13.events.off((0, $8wnFv.engineEvent)("session_connect"), re), de(A.error.message))
                                                    ];
                                                }
                                                return [
                                                    4,
                                                    _this13.deleteProposal(B)
                                                ];
                                            case 2:
                                                _state.sent(), _this13.events.off((0, $8wnFv.engineEvent)("session_connect"), re);
                                                _A_result = A.result, v = _A_result.cacaos, Q = _A_result.responder, ge = [], Te = [];
                                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                                _state.label = 3;
                                            case 3:
                                                _state.trys.push([
                                                    3,
                                                    8,
                                                    9,
                                                    10
                                                ]);
                                                _iterator = v[Symbol.iterator]();
                                                _state.label = 4;
                                            case 4:
                                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                                    3,
                                                    7
                                                ];
                                                W1 = _step.value;
                                                return [
                                                    4,
                                                    (0, $8wnFv.validateSignedCacao)({
                                                        cacao: W1,
                                                        projectId: _this13.client.core.projectId
                                                    })
                                                ];
                                            case 5:
                                                _state.sent() || (_this13.client.logger.error(W1, "Signature verification failed"), de((0, $8wnFv.getSdkError)("SESSION_SETTLEMENT_FAILED", "Signature verification failed")));
                                                we = W1.p, ye = (0, $8wnFv.getRecapFromResources)(we.resources), Oe = [
                                                    (0, $8wnFv.getNamespacedDidChainId)(we.iss)
                                                ], rt = (0, $8wnFv.getDidAddress)(we.iss);
                                                if (ye) {
                                                    ;
                                                    me = (0, $8wnFv.getMethodsFromRecap)(ye), nt = (0, $8wnFv.getChainsFromRecap)(ye);
                                                    (_ge = ge).push.apply(_ge, (0, $c6Xmf._)(me)), (_Oe = Oe).push.apply(_Oe, (0, $c6Xmf._)(nt));
                                                }
                                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                                try {
                                                    for(_iterator1 = Oe[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                                        me1 = _step1.value;
                                                        Te.push("".concat(me1, ":").concat(rt));
                                                    }
                                                } catch (err) {
                                                    _didIteratorError1 = true;
                                                    _iteratorError1 = err;
                                                } finally{
                                                    try {
                                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                            _iterator1.return();
                                                        }
                                                    } finally{
                                                        if (_didIteratorError1) {
                                                            throw _iteratorError1;
                                                        }
                                                    }
                                                }
                                                _state.label = 6;
                                            case 6:
                                                _iteratorNormalCompletion = true;
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 7:
                                                return [
                                                    3,
                                                    10
                                                ];
                                            case 8:
                                                err = _state.sent();
                                                _didIteratorError = true;
                                                _iteratorError = err;
                                                return [
                                                    3,
                                                    10
                                                ];
                                            case 9:
                                                try {
                                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                        _iterator.return();
                                                    }
                                                } finally{
                                                    if (_didIteratorError) {
                                                        throw _iteratorError;
                                                    }
                                                }
                                                return [
                                                    7
                                                ];
                                            case 10:
                                                return [
                                                    4,
                                                    _this13.client.core.crypto.generateSharedKey(q, Q.publicKey)
                                                ];
                                            case 11:
                                                ne = _state.sent();
                                                _tmp = ge.length > 0;
                                                if (!_tmp) return [
                                                    3,
                                                    16
                                                ];
                                                oe = {
                                                    topic: ne,
                                                    acknowledged: !0,
                                                    self: {
                                                        publicKey: q,
                                                        metadata: _this13.client.metadata
                                                    },
                                                    peer: Q,
                                                    controller: Q.publicKey,
                                                    expiry: (0, $8wnFv.calcExpiry)($83db3bfa38a2bed3$export$84b1b9dbcdea0475),
                                                    requiredNamespaces: {},
                                                    optionalNamespaces: {},
                                                    relay: {
                                                        protocol: "irn"
                                                    },
                                                    pairingTopic: u,
                                                    namespaces: (0, $8wnFv.buildNamespacesFromAuth)((0, $c6Xmf._)(new Set(ge)), (0, $c6Xmf._)(new Set(Te)))
                                                };
                                                return [
                                                    4,
                                                    _this13.client.core.relayer.subscribe(ne)
                                                ];
                                            case 12:
                                                _state.sent();
                                                return [
                                                    4,
                                                    _this13.client.session.set(ne, oe)
                                                ];
                                            case 13:
                                                _state.sent();
                                                _tmp1 = u;
                                                if (!_tmp1) return [
                                                    3,
                                                    15
                                                ];
                                                return [
                                                    4,
                                                    _this13.client.core.pairing.updateMetadata({
                                                        topic: u,
                                                        metadata: Q.metadata
                                                    })
                                                ];
                                            case 14:
                                                _tmp1 = _state.sent();
                                                _state.label = 15;
                                            case 15:
                                                _tmp = (_tmp1, oe = _this13.client.session.get(ne));
                                                _state.label = 16;
                                            case 16:
                                                _tmp, f({
                                                    auths: v,
                                                    session: oe
                                                });
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function ue(A) {
                                    return _ref.apply(this, arguments);
                                };
                            }(), F = (0, $3W2Mc.payloadId)(), B = (0, $3W2Mc.payloadId)();
                            _this13.events.once((0, $8wnFv.engineEvent)("session_connect"), re), _this13.events.once((0, $8wnFv.engineEvent)("session_request", F), ue);
                            _state.label = 5;
                        case 5:
                            _state.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4,
                                Promise.all([
                                    _this13.sendRequest({
                                        topic: u,
                                        method: "wc_sessionAuthenticate",
                                        params: D,
                                        expiry: t.expiry,
                                        throwOnFailedPublish: !0,
                                        clientRpcId: F
                                    }),
                                    _this13.sendRequest({
                                        topic: u,
                                        method: "wc_sessionPropose",
                                        params: R,
                                        expiry: $83db3bfa38a2bed3$export$4edb1ca37014192d.wc_sessionPropose.req.ttl,
                                        throwOnFailedPublish: !0,
                                        clientRpcId: B
                                    })
                                ])
                            ];
                        case 6:
                            _state.sent();
                            return [
                                3,
                                8
                            ];
                        case 7:
                            A = _state.sent();
                            throw _this13.events.off((0, $8wnFv.engineEvent)("session_connect"), re), _this13.events.off((0, $8wnFv.engineEvent)("session_request", F), ue), A;
                        case 8:
                            return [
                                4,
                                _this13.setProposal(B, $83db3bfa38a2bed3$var$E({
                                    id: B
                                }, R))
                            ];
                        case 9:
                            _state.sent();
                            return [
                                4,
                                _this13.setAuthRequest(F, {
                                    request: $83db3bfa38a2bed3$var$j($83db3bfa38a2bed3$var$E({}, D), {
                                        verifyContext: {}
                                    }),
                                    pairingTopic: u
                                })
                            ];
                        case 10:
                            return [
                                2,
                                (_state.sent(), {
                                    uri: _,
                                    response: K
                                })
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.approveSessionAuthenticate = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var e, s, i, r, o, a, c, h, l, g, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _$_, y, q, m, O, D, _l, _O, y1, R, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, y2, err, d, u, _, _1;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            e = t.id, s = t.auths, i = _this14.client.core.eventClient.createEvent({
                                properties: {
                                    topic: e.toString(),
                                    trace: [
                                        (0, $6uXh7.EVENT_CLIENT_AUTHENTICATE_TRACES).authenticated_session_approve_started
                                    ]
                                }
                            });
                            try {
                                _this14.isInitialized();
                            } catch (_) {
                                throw i.setError((0, $6uXh7.EVENT_CLIENT_AUTHENTICATE_ERRORS).no_internet_connection), _;
                            }
                            r = _this14.getPendingAuthRequest(e);
                            if (!r) throw i.setError((0, $6uXh7.EVENT_CLIENT_AUTHENTICATE_ERRORS).authenticated_session_pending_request_not_found), new Error("Could not find pending auth request with id ".concat(e));
                            o = r.requester.publicKey;
                            return [
                                4,
                                _this14.client.core.crypto.generateKeyPair()
                            ];
                        case 1:
                            a = _state.sent(), c = (0, $8wnFv.hashKey)(o), h = {
                                type: (0, $8wnFv.TYPE_1),
                                receiverPublicKey: o,
                                senderPublicKey: a
                            }, l = [], g = [];
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                9,
                                10,
                                11
                            ]);
                            _iterator = s[Symbol.iterator]();
                            _state.label = 3;
                        case 3:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                8
                            ];
                            _$_ = _step.value;
                            return [
                                4,
                                (0, $8wnFv.validateSignedCacao)({
                                    cacao: _$_,
                                    projectId: _this14.client.core.projectId
                                })
                            ];
                        case 4:
                            if (!!_state.sent()) return [
                                3,
                                6
                            ];
                            i.setError((0, $6uXh7.EVENT_CLIENT_AUTHENTICATE_ERRORS).invalid_cacao);
                            y = (0, $8wnFv.getSdkError)("SESSION_SETTLEMENT_FAILED", "Signature verification failed");
                            return [
                                4,
                                _this14.sendError({
                                    id: e,
                                    topic: c,
                                    error: y,
                                    encodeOpts: h
                                })
                            ];
                        case 5:
                            throw _state.sent(), new Error(y.message);
                        case 6:
                            i.addTrace((0, $6uXh7.EVENT_CLIENT_AUTHENTICATE_TRACES).cacaos_verified);
                            q = _$_.p, m = (0, $8wnFv.getRecapFromResources)(q.resources), O = [
                                (0, $8wnFv.getNamespacedDidChainId)(q.iss)
                            ], D = (0, $8wnFv.getDidAddress)(q.iss);
                            if (m) {
                                ;
                                y1 = (0, $8wnFv.getMethodsFromRecap)(m), R = (0, $8wnFv.getChainsFromRecap)(m);
                                (_l = l).push.apply(_l, (0, $c6Xmf._)(y1)), (_O = O).push.apply(_O, (0, $c6Xmf._)(R));
                            }
                            _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(_iterator1 = O[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    y2 = _step1.value;
                                    g.push("".concat(y2, ":").concat(D));
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                            _state.label = 7;
                        case 7:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                3
                            ];
                        case 8:
                            return [
                                3,
                                11
                            ];
                        case 9:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                11
                            ];
                        case 10:
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 11:
                            return [
                                4,
                                _this14.client.core.crypto.generateSharedKey(a, o)
                            ];
                        case 12:
                            d = _state.sent();
                            i.addTrace((0, $6uXh7.EVENT_CLIENT_AUTHENTICATE_TRACES).create_authenticated_session_topic);
                            if (!((l === null || l === void 0 ? void 0 : l.length) > 0)) return [
                                3,
                                19
                            ];
                            u = {
                                topic: d,
                                acknowledged: !0,
                                self: {
                                    publicKey: a,
                                    metadata: _this14.client.metadata
                                },
                                peer: {
                                    publicKey: o,
                                    metadata: r.requester.metadata
                                },
                                controller: o,
                                expiry: (0, $8wnFv.calcExpiry)($83db3bfa38a2bed3$export$84b1b9dbcdea0475),
                                authentication: s,
                                requiredNamespaces: {},
                                optionalNamespaces: {},
                                relay: {
                                    protocol: "irn"
                                },
                                pairingTopic: r.pairingTopic,
                                namespaces: (0, $8wnFv.buildNamespacesFromAuth)((0, $c6Xmf._)(new Set(l)), (0, $c6Xmf._)(new Set(g)))
                            }, i.addTrace((0, $6uXh7.EVENT_CLIENT_AUTHENTICATE_TRACES).subscribing_authenticated_session_topic);
                            _state.label = 13;
                        case 13:
                            _state.trys.push([
                                13,
                                15,
                                ,
                                16
                            ]);
                            return [
                                4,
                                _this14.client.core.relayer.subscribe(d)
                            ];
                        case 14:
                            _state.sent();
                            return [
                                3,
                                16
                            ];
                        case 15:
                            _ = _state.sent();
                            throw i.setError((0, $6uXh7.EVENT_CLIENT_AUTHENTICATE_ERRORS).subscribe_authenticated_session_topic_failure), _;
                        case 16:
                            i.addTrace((0, $6uXh7.EVENT_CLIENT_AUTHENTICATE_TRACES).subscribe_authenticated_session_topic_success);
                            return [
                                4,
                                _this14.client.session.set(d, u)
                            ];
                        case 17:
                            _state.sent(), i.addTrace((0, $6uXh7.EVENT_CLIENT_AUTHENTICATE_TRACES).store_authenticated_session);
                            return [
                                4,
                                _this14.client.core.pairing.updateMetadata({
                                    topic: r.pairingTopic,
                                    metadata: r.requester.metadata
                                })
                            ];
                        case 18:
                            _state.sent();
                            _state.label = 19;
                        case 19:
                            i.addTrace((0, $6uXh7.EVENT_CLIENT_AUTHENTICATE_TRACES).publishing_authenticated_session_approve);
                            _state.label = 20;
                        case 20:
                            _state.trys.push([
                                20,
                                22,
                                ,
                                23
                            ]);
                            return [
                                4,
                                _this14.sendResult({
                                    topic: c,
                                    id: e,
                                    result: {
                                        cacaos: s,
                                        responder: {
                                            publicKey: a,
                                            metadata: _this14.client.metadata
                                        }
                                    },
                                    encodeOpts: h,
                                    throwOnFailedPublish: !0
                                })
                            ];
                        case 21:
                            _state.sent();
                            return [
                                3,
                                23
                            ];
                        case 22:
                            _1 = _state.sent();
                            throw i.setError((0, $6uXh7.EVENT_CLIENT_AUTHENTICATE_ERRORS).authenticated_session_approve_publish_failure), _1;
                        case 23:
                            return [
                                4,
                                _this14.client.auth.requests.delete(e, {
                                    message: "fulfilled",
                                    code: 0
                                })
                            ];
                        case 24:
                            _state.sent();
                            return [
                                4,
                                _this14.client.core.pairing.activate({
                                    topic: r.pairingTopic
                                })
                            ];
                        case 25:
                            return [
                                2,
                                (_state.sent(), _this14.client.core.eventClient.deleteEvent({
                                    eventId: i.eventId
                                }), {
                                    session: u
                                })
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.rejectSessionAuthenticate = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var e, s, i, r, o, a, c;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this15.isInitialized()
                            ];
                        case 1:
                            _state.sent();
                            e = t.id, s = t.reason, i = _this15.getPendingAuthRequest(e);
                            if (!i) throw new Error("Could not find pending auth request with id ".concat(e));
                            r = i.requester.publicKey;
                            return [
                                4,
                                _this15.client.core.crypto.generateKeyPair()
                            ];
                        case 2:
                            o = _state.sent(), a = (0, $8wnFv.hashKey)(r), c = {
                                type: (0, $8wnFv.TYPE_1),
                                receiverPublicKey: r,
                                senderPublicKey: o
                            };
                            return [
                                4,
                                _this15.sendError({
                                    id: e,
                                    topic: a,
                                    error: s,
                                    encodeOpts: c,
                                    rpcOpts: $83db3bfa38a2bed3$export$4edb1ca37014192d.wc_sessionAuthenticate.reject
                                })
                            ];
                        case 3:
                            _state.sent();
                            return [
                                4,
                                _this15.client.auth.requests.delete(e, {
                                    message: "rejected",
                                    code: 0
                                })
                            ];
                        case 4:
                            _state.sent();
                            return [
                                4,
                                _this15.client.proposal.delete(e, (0, $8wnFv.getSdkError)("USER_DISCONNECTED"))
                            ];
                        case 5:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.formatAuthMessage = function(t) {
            _this.isInitialized();
            var e = t.request, s = t.iss;
            return (0, $8wnFv.formatMessage)(e, s);
        }, _this.processRelayMessageCache = function() {
            var _this1 = (0, $d3H5E._)(_this);
            setTimeout(/*#__PURE__*/ (0, $kSuI9._)(function() {
                var _$t, _tmp, t;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(_this1.relayMessageCache.length !== 0)) return [
                                3,
                                7
                            ];
                            _state.label = 1;
                        case 1:
                            if (!(_this1.relayMessageCache.length > 0)) return [
                                3,
                                7
                            ];
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                5,
                                ,
                                6
                            ]);
                            _$t = _this1.relayMessageCache.shift();
                            _tmp = _$t;
                            if (!_tmp) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                _this1.onRelayMessage(_$t)
                            ];
                        case 3:
                            _tmp = _state.sent();
                            _state.label = 4;
                        case 4:
                            _tmp;
                            return [
                                3,
                                6
                            ];
                        case 5:
                            t = _state.sent();
                            _this1.client.logger.error(t);
                            return [
                                3,
                                6
                            ];
                        case 6:
                            return [
                                3,
                                1
                            ];
                        case 7:
                            return [
                                2
                            ];
                    }
                });
            }), 50);
        }, _this.cleanupDuplicatePairings = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var _$e, s, e;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!t.pairingTopic) return [
                                3,
                                4
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            _$e = _this16.client.core.pairing.pairings.get(t.pairingTopic), s = _this16.client.core.pairing.pairings.getAll().filter(function(i) {
                                var r, o;
                                return ((r = i.peerMetadata) == null ? void 0 : r.url) && ((o = i.peerMetadata) == null ? void 0 : o.url) === t.peer.metadata.url && i.topic && i.topic !== _$e.topic;
                            });
                            if (s.length === 0) return [
                                2
                            ];
                            _this16.client.logger.info("Cleaning up ".concat(s.length, " duplicate pairing(s)"));
                            return [
                                4,
                                Promise.all(s.map(function(i) {
                                    return _this16.client.core.pairing.disconnect({
                                        topic: i.topic
                                    });
                                }))
                            ];
                        case 2:
                            _state.sent(), _this16.client.logger.info("Duplicate pairings clean up finished");
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            _this16.client.logger.error(e);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.deleteSession = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var e, s, tmp, i, tmp1, r, tmp2, o, _this_client_session_get, a, _tmp, _tmp1;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            s = t.topic, tmp = t.expirerHasDeleted, i = tmp === void 0 ? !1 : tmp, tmp1 = t.emitEvent, r = tmp1 === void 0 ? !0 : tmp1, tmp2 = t.id, o = tmp2 === void 0 ? 0 : tmp2, _this_client_session_get = _this17.client.session.get(s), a = _this_client_session_get.self;
                            return [
                                4,
                                _this17.client.core.relayer.unsubscribe(s)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                _this17.client.session.delete(s, (0, $8wnFv.getSdkError)("USER_DISCONNECTED"))
                            ];
                        case 2:
                            _state.sent(), _this17.addToRecentlyDeleted(s, "session");
                            _tmp = _this17.client.core.crypto.keychain.has(a.publicKey);
                            if (!_tmp) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                _this17.client.core.crypto.deleteKeyPair(a.publicKey)
                            ];
                        case 3:
                            _tmp = _state.sent();
                            _state.label = 4;
                        case 4:
                            _tmp;
                            _tmp1 = _this17.client.core.crypto.keychain.has(s);
                            if (!_tmp1) return [
                                3,
                                6
                            ];
                            return [
                                4,
                                _this17.client.core.crypto.deleteSymKey(s)
                            ];
                        case 5:
                            _tmp1 = _state.sent();
                            _state.label = 6;
                        case 6:
                            _tmp1, i || _this17.client.core.expirer.del(s), _this17.client.core.storage.removeItem($83db3bfa38a2bed3$export$a26ccd6441b7d638).catch(function(c) {
                                return _this17.client.logger.warn(c);
                            }), _this17.getPendingSessionRequests().forEach(function(c) {
                                c.topic === s && _this17.deletePendingSessionRequest(c.id, (0, $8wnFv.getSdkError)("USER_DISCONNECTED"));
                            }), s === ((e = _this17.sessionRequestQueue.queue[0]) == null ? void 0 : e.topic) && (_this17.sessionRequestQueue.state = $83db3bfa38a2bed3$export$8602b201748df21a.idle), r && _this17.client.events.emit("session_delete", {
                                id: o,
                                topic: s
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.deleteProposal = function() {
            var _ref = (0, $kSuI9._)(function(t, e) {
                var s, i;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (e) try {
                                s = _this18.client.proposal.get(t), i = _this18.client.core.eventClient.getEvent({
                                    topic: s.pairingTopic
                                });
                                i === null || i === void 0 ? void 0 : i.setError((0, $6uXh7.EVENT_CLIENT_SESSION_ERRORS).proposal_expired);
                            } catch (e) {}
                            return [
                                4,
                                Promise.all([
                                    _this18.client.proposal.delete(t, (0, $8wnFv.getSdkError)("USER_DISCONNECTED")),
                                    e ? Promise.resolve() : _this18.client.core.expirer.del(t)
                                ])
                            ];
                        case 1:
                            _state.sent(), _this18.addToRecentlyDeleted(t, "proposal");
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t, e) {
                return _ref.apply(this, arguments);
            };
        }(), _this.deletePendingSessionRequest = function() {
            var _ref = (0, $kSuI9._)(function(t, e) {
                var s;
                var _arguments = arguments;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            s = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : !1;
                            return [
                                4,
                                Promise.all([
                                    _this19.client.pendingRequest.delete(t, e),
                                    s ? Promise.resolve() : _this19.client.core.expirer.del(t)
                                ])
                            ];
                        case 1:
                            _state.sent(), _this19.addToRecentlyDeleted(t, "request"), _this19.sessionRequestQueue.queue = _this19.sessionRequestQueue.queue.filter(function(i) {
                                return i.id !== t;
                            }), s && (_this19.sessionRequestQueue.state = $83db3bfa38a2bed3$export$8602b201748df21a.idle, _this19.client.events.emit("session_request_expire", {
                                id: t
                            }));
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t, e) {
                return _ref.apply(this, arguments);
            };
        }(), _this.deletePendingAuthRequest = function() {
            var _ref = (0, $kSuI9._)(function(t, e) {
                var s;
                var _arguments = arguments;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            s = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : !1;
                            return [
                                4,
                                Promise.all([
                                    _this20.client.auth.requests.delete(t, e),
                                    s ? Promise.resolve() : _this20.client.core.expirer.del(t)
                                ])
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t, e) {
                return _ref.apply(this, arguments);
            };
        }(), _this.setExpiry = function() {
            var _ref = (0, $kSuI9._)(function(t, e) {
                var _tmp;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _tmp = _this21.client.session.keys.includes(t);
                            if (!_tmp) return [
                                3,
                                2
                            ];
                            _this21.client.core.expirer.set(t, e);
                            return [
                                4,
                                _this21.client.session.update(t, {
                                    expiry: e
                                })
                            ];
                        case 1:
                            _tmp = _state.sent();
                            _state.label = 2;
                        case 2:
                            _tmp;
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t, e) {
                return _ref.apply(this, arguments);
            };
        }(), _this.setProposal = function() {
            var _ref = (0, $kSuI9._)(function(t, e) {
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this22.client.core.expirer.set(t, (0, $8wnFv.calcExpiry)($83db3bfa38a2bed3$export$4edb1ca37014192d.wc_sessionPropose.req.ttl));
                            return [
                                4,
                                _this22.client.proposal.set(t, e)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t, e) {
                return _ref.apply(this, arguments);
            };
        }(), _this.setAuthRequest = function() {
            var _ref = (0, $kSuI9._)(function(t, e) {
                var s, i;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            s = e.request, i = e.pairingTopic;
                            _this23.client.core.expirer.set(t, s.expiryTimestamp);
                            return [
                                4,
                                _this23.client.auth.requests.set(t, {
                                    authPayload: s.authPayload,
                                    requester: s.requester,
                                    expiryTimestamp: s.expiryTimestamp,
                                    id: t,
                                    pairingTopic: i,
                                    verifyContext: s.verifyContext
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t, e) {
                return _ref.apply(this, arguments);
            };
        }(), _this.setPendingSessionRequest = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var e, s, i, r, o;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            e = t.id, s = t.topic, i = t.params, r = t.verifyContext, o = i.request.expiryTimestamp || (0, $8wnFv.calcExpiry)($83db3bfa38a2bed3$export$4edb1ca37014192d.wc_sessionRequest.req.ttl);
                            _this24.client.core.expirer.set(e, o);
                            return [
                                4,
                                _this24.client.pendingRequest.set(e, {
                                    id: e,
                                    topic: s,
                                    params: i,
                                    verifyContext: r
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.sendRequest = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var e, s, i, r, o, a, c, h, l, u, g, _$u, _, d, _tmp;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            e = t.topic, s = t.method, i = t.params, r = t.expiry, o = t.relayRpcId, a = t.clientRpcId, c = t.throwOnFailedPublish, h = (0, $3W2Mc.formatJsonRpcRequest)(s, i, a);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                5
                            ]);
                            return [
                                4,
                                _this25.client.core.crypto.encode(e, h)
                            ];
                        case 2:
                            l = _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 3:
                            u = _state.sent();
                            return [
                                4,
                                _this25.cleanup()
                            ];
                        case 4:
                            throw _state.sent(), _this25.client.logger.error("sendRequest() -> core.crypto.encode() for topic ".concat(e, " failed")), u;
                        case 5:
                            if (!$83db3bfa38a2bed3$export$63c37d8ae5931ad5.includes(s)) return [
                                3,
                                7
                            ];
                            _$u = (0, $8wnFv.hashMessage)(JSON.stringify(h)), _ = (0, $8wnFv.hashMessage)(l);
                            return [
                                4,
                                _this25.client.core.verify.register({
                                    id: _,
                                    decryptedId: _$u
                                })
                            ];
                        case 6:
                            g = _state.sent();
                            _state.label = 7;
                        case 7:
                            d = $83db3bfa38a2bed3$export$4edb1ca37014192d[s].req;
                            d.attestation = g, r && (d.ttl = r), o && (d.id = o), _this25.client.core.history.set(e, h);
                            if (!c) return [
                                3,
                                9
                            ];
                            d.internal = $83db3bfa38a2bed3$var$j($83db3bfa38a2bed3$var$E({}, d.internal), {
                                throwOnFailedPublish: !0
                            });
                            return [
                                4,
                                _this25.client.core.relayer.publish(e, l, d)
                            ];
                        case 8:
                            _tmp = _state.sent();
                            return [
                                3,
                                10
                            ];
                        case 9:
                            _tmp = _this25.client.core.relayer.publish(e, l, d).catch(function(u) {
                                return _this25.client.logger.error(u);
                            });
                            _state.label = 10;
                        case 10:
                            return [
                                2,
                                (_tmp, h.id)
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.sendResult = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var e, s, i, r, o, a, c, g, h, g1, l, _tmp;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            e = t.id, s = t.topic, i = t.result, r = t.throwOnFailedPublish, o = t.encodeOpts, a = (0, $3W2Mc.formatJsonRpcResult)(e, i);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                5
                            ]);
                            return [
                                4,
                                _this26.client.core.crypto.encode(s, a, o)
                            ];
                        case 2:
                            c = _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 3:
                            g = _state.sent();
                            return [
                                4,
                                _this26.cleanup()
                            ];
                        case 4:
                            throw _state.sent(), _this26.client.logger.error("sendResult() -> core.crypto.encode() for topic ".concat(s, " failed")), g;
                        case 5:
                            _state.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4,
                                _this26.client.core.history.get(s, e)
                            ];
                        case 6:
                            h = _state.sent();
                            return [
                                3,
                                8
                            ];
                        case 7:
                            g1 = _state.sent();
                            throw _this26.client.logger.error("sendResult() -> history.get(".concat(s, ", ").concat(e, ") failed")), g1;
                        case 8:
                            l = $83db3bfa38a2bed3$export$4edb1ca37014192d[h.request.method].res;
                            if (!r) return [
                                3,
                                10
                            ];
                            l.internal = $83db3bfa38a2bed3$var$j($83db3bfa38a2bed3$var$E({}, l.internal), {
                                throwOnFailedPublish: !0
                            });
                            return [
                                4,
                                _this26.client.core.relayer.publish(s, c, l)
                            ];
                        case 9:
                            _tmp = _state.sent();
                            return [
                                3,
                                11
                            ];
                        case 10:
                            _tmp = _this26.client.core.relayer.publish(s, c, l).catch(function(g) {
                                return _this26.client.logger.error(g);
                            });
                            _state.label = 11;
                        case 11:
                            _tmp;
                            return [
                                4,
                                _this26.client.core.history.resolve(a)
                            ];
                        case 12:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.sendError = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var e, s, i, r, o, a, c, g, h, g1, l;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            e = t.id, s = t.topic, i = t.error, r = t.encodeOpts, o = t.rpcOpts, a = (0, $3W2Mc.formatJsonRpcError)(e, i);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                5
                            ]);
                            return [
                                4,
                                _this27.client.core.crypto.encode(s, a, r)
                            ];
                        case 2:
                            c = _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 3:
                            g = _state.sent();
                            return [
                                4,
                                _this27.cleanup()
                            ];
                        case 4:
                            throw _state.sent(), _this27.client.logger.error("sendError() -> core.crypto.encode() for topic ".concat(s, " failed")), g;
                        case 5:
                            _state.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4,
                                _this27.client.core.history.get(s, e)
                            ];
                        case 6:
                            h = _state.sent();
                            return [
                                3,
                                8
                            ];
                        case 7:
                            g1 = _state.sent();
                            throw _this27.client.logger.error("sendError() -> history.get(".concat(s, ", ").concat(e, ") failed")), g1;
                        case 8:
                            l = o || $83db3bfa38a2bed3$export$4edb1ca37014192d[h.request.method].res;
                            _this27.client.core.relayer.publish(s, c, l);
                            return [
                                4,
                                _this27.client.core.history.resolve(a)
                            ];
                        case 9:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.cleanup = /*#__PURE__*/ (0, $kSuI9._)(function() {
            var t, e;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        t = [], e = [];
                        _this28.client.session.getAll().forEach(function(s) {
                            var i = !1;
                            (0, $8wnFv.isExpired)(s.expiry) && (i = !0), _this28.client.core.crypto.keychain.has(s.topic) || (i = !0), i && t.push(s.topic);
                        }), _this28.client.proposal.getAll().forEach(function(s) {
                            (0, $8wnFv.isExpired)(s.expiryTimestamp) && e.push(s.id);
                        });
                        return [
                            4,
                            Promise.all((0, $c6Xmf._)(t.map(function(s) {
                                return _this28.deleteSession({
                                    topic: s
                                });
                            })).concat((0, $c6Xmf._)(e.map(function(s) {
                                return _this28.deleteProposal(s);
                            }))))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        }), _this.onRelayEventRequest = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this29.requestQueue.queue.push(t);
                            return [
                                4,
                                _this29.processRequestsQueue()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.processRequestsQueue = /*#__PURE__*/ (0, $kSuI9._)(function() {
            var t, e;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (_this30.requestQueue.state === $83db3bfa38a2bed3$export$8602b201748df21a.active) {
                            _this30.client.logger.info("Request queue already active, skipping...");
                            return [
                                2
                            ];
                        }
                        _this30.client.logger.info("Request queue starting with ".concat(_this30.requestQueue.queue.length, " requests"));
                        _state.label = 1;
                    case 1:
                        if (!(_this30.requestQueue.queue.length > 0)) return [
                            3,
                            6
                        ];
                        _this30.requestQueue.state = $83db3bfa38a2bed3$export$8602b201748df21a.active;
                        t = _this30.requestQueue.queue.shift();
                        if (!t) return [
                            3,
                            5
                        ];
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            _this30.processRequest(t)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        e = _state.sent();
                        _this30.client.logger.warn(e);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            3,
                            1
                        ];
                    case 6:
                        _this30.requestQueue.state = $83db3bfa38a2bed3$export$8602b201748df21a.idle;
                        return [
                            2
                        ];
                }
            });
        }), _this.processRequest = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var e, s, i, r, o;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            e = t.topic, s = t.payload, i = t.attestation, r = t.encryptedId, o = s.method;
                            if (!!_this31.shouldIgnorePairingRequest({
                                topic: e,
                                requestMethod: o
                            })) return [
                                3,
                                20
                            ];
                            switch(o){
                                case "wc_sessionPropose":
                                    return [
                                        3,
                                        1
                                    ];
                                case "wc_sessionSettle":
                                    return [
                                        3,
                                        3
                                    ];
                                case "wc_sessionUpdate":
                                    return [
                                        3,
                                        5
                                    ];
                                case "wc_sessionExtend":
                                    return [
                                        3,
                                        7
                                    ];
                                case "wc_sessionPing":
                                    return [
                                        3,
                                        9
                                    ];
                                case "wc_sessionDelete":
                                    return [
                                        3,
                                        11
                                    ];
                                case "wc_sessionRequest":
                                    return [
                                        3,
                                        13
                                    ];
                                case "wc_sessionEvent":
                                    return [
                                        3,
                                        15
                                    ];
                                case "wc_sessionAuthenticate":
                                    return [
                                        3,
                                        17
                                    ];
                            }
                            return [
                                3,
                                19
                            ];
                        case 1:
                            return [
                                4,
                                _this31.onSessionProposeRequest({
                                    topic: e,
                                    payload: s,
                                    attestation: i,
                                    encryptedId: r
                                })
                            ];
                        case 2:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 3:
                            return [
                                4,
                                _this31.onSessionSettleRequest(e, s)
                            ];
                        case 4:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 5:
                            return [
                                4,
                                _this31.onSessionUpdateRequest(e, s)
                            ];
                        case 6:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 7:
                            return [
                                4,
                                _this31.onSessionExtendRequest(e, s)
                            ];
                        case 8:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 9:
                            return [
                                4,
                                _this31.onSessionPingRequest(e, s)
                            ];
                        case 10:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 11:
                            return [
                                4,
                                _this31.onSessionDeleteRequest(e, s)
                            ];
                        case 12:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 13:
                            return [
                                4,
                                _this31.onSessionRequest({
                                    topic: e,
                                    payload: s,
                                    attestation: i,
                                    encryptedId: r
                                })
                            ];
                        case 14:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 15:
                            return [
                                4,
                                _this31.onSessionEventRequest(e, s)
                            ];
                        case 16:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 17:
                            return [
                                4,
                                _this31.onSessionAuthenticateRequest({
                                    topic: e,
                                    payload: s,
                                    attestation: i,
                                    encryptedId: r
                                })
                            ];
                        case 18:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 19:
                            return [
                                2,
                                _this31.client.logger.info("Unsupported request method ".concat(o))
                            ];
                        case 20:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.onRelayEventResponse = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var e, s, i;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            e = t.topic, s = t.payload;
                            return [
                                4,
                                _this32.client.core.history.get(e, s.id)
                            ];
                        case 1:
                            i = _state.sent().request.method;
                            switch(i){
                                case "wc_sessionPropose":
                                    return [
                                        2,
                                        _this32.onSessionProposeResponse(e, s)
                                    ];
                                case "wc_sessionSettle":
                                    return [
                                        2,
                                        _this32.onSessionSettleResponse(e, s)
                                    ];
                                case "wc_sessionUpdate":
                                    return [
                                        2,
                                        _this32.onSessionUpdateResponse(e, s)
                                    ];
                                case "wc_sessionExtend":
                                    return [
                                        2,
                                        _this32.onSessionExtendResponse(e, s)
                                    ];
                                case "wc_sessionPing":
                                    return [
                                        2,
                                        _this32.onSessionPingResponse(e, s)
                                    ];
                                case "wc_sessionRequest":
                                    return [
                                        2,
                                        _this32.onSessionRequestResponse(e, s)
                                    ];
                                case "wc_sessionAuthenticate":
                                    return [
                                        2,
                                        _this32.onSessionAuthenticateResponse(e, s)
                                    ];
                                default:
                                    return [
                                        2,
                                        _this32.client.logger.info("Unsupported response method ".concat(i))
                                    ];
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.onRelayEventUnknownPayload = function(t) {
            var e = t.topic, _p = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "Decoded payload on topic ".concat(e, " is not identifiable as a JSON-RPC request or a response.")), s = _p.message;
            throw new Error(s);
        }, _this.shouldIgnorePairingRequest = function(t) {
            var e = t.topic, s = t.requestMethod, i = _this.expectedPairingMethodMap.get(e);
            return !i || i.includes(s) ? !1 : !!(i.includes("wc_sessionAuthenticate") && _this.client.events.listenerCount("session_authenticate") > 0);
        }, _this.onSessionProposeRequest = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var e, s, i, r, o, a, _$c, h, l, g, c;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            e = t.topic, s = t.payload, i = t.attestation, r = t.encryptedId, o = s.params, a = s.id;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                4,
                                ,
                                6
                            ]);
                            _$c = _this33.client.core.eventClient.getEvent({
                                topic: e
                            });
                            _this33.isValidConnect($83db3bfa38a2bed3$var$E({}, s.params));
                            h = o.expiryTimestamp || (0, $8wnFv.calcExpiry)($83db3bfa38a2bed3$export$4edb1ca37014192d.wc_sessionPropose.req.ttl), l = $83db3bfa38a2bed3$var$E({
                                id: a,
                                pairingTopic: e,
                                expiryTimestamp: h
                            }, o);
                            return [
                                4,
                                _this33.setProposal(a, l)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                4,
                                _this33.getVerifyContext({
                                    attestationId: i,
                                    hash: (0, $8wnFv.hashMessage)(JSON.stringify(s)),
                                    encryptedId: r,
                                    metadata: l.proposer.metadata
                                })
                            ];
                        case 3:
                            g = _state.sent();
                            _this33.client.events.listenerCount("session_proposal") === 0 && (console.warn("No listener for session_proposal event"), _$c === null || _$c === void 0 ? void 0 : _$c.setError((0, $6uXh7.EVENT_CLIENT_PAIRING_ERRORS).proposal_listener_not_found)), _$c === null || _$c === void 0 ? void 0 : _$c.addTrace((0, $6uXh7.EVENT_CLIENT_PAIRING_TRACES).emit_session_proposal), _this33.client.events.emit("session_proposal", {
                                id: a,
                                params: l,
                                verifyContext: g
                            });
                            return [
                                3,
                                6
                            ];
                        case 4:
                            c = _state.sent();
                            return [
                                4,
                                _this33.sendError({
                                    id: a,
                                    topic: e,
                                    error: c,
                                    rpcOpts: $83db3bfa38a2bed3$export$4edb1ca37014192d.wc_sessionPropose.autoReject
                                })
                            ];
                        case 5:
                            _state.sent(), _this33.client.logger.error(c);
                            return [
                                3,
                                6
                            ];
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.onSessionProposeResponse = function() {
            var _ref = (0, $kSuI9._)(function(t, e) {
                var s, i, r, o, a, c, h, i1;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            s = e.id;
                            if (!(0, $5lf06.isJsonRpcResult)(e)) return [
                                3,
                                4
                            ];
                            i = e.result;
                            _this34.client.logger.trace({
                                type: "method",
                                method: "onSessionProposeResponse",
                                result: i
                            });
                            r = _this34.client.proposal.get(s);
                            _this34.client.logger.trace({
                                type: "method",
                                method: "onSessionProposeResponse",
                                proposal: r
                            });
                            o = r.proposer.publicKey;
                            _this34.client.logger.trace({
                                type: "method",
                                method: "onSessionProposeResponse",
                                selfPublicKey: o
                            });
                            a = i.responderPublicKey;
                            _this34.client.logger.trace({
                                type: "method",
                                method: "onSessionProposeResponse",
                                peerPublicKey: a
                            });
                            return [
                                4,
                                _this34.client.core.crypto.generateSharedKey(o, a)
                            ];
                        case 1:
                            c = _state.sent();
                            _this34.client.logger.trace({
                                type: "method",
                                method: "onSessionProposeResponse",
                                sessionTopic: c
                            });
                            return [
                                4,
                                _this34.client.core.relayer.subscribe(c)
                            ];
                        case 2:
                            h = _state.sent();
                            _this34.client.logger.trace({
                                type: "method",
                                method: "onSessionProposeResponse",
                                subscriptionId: h
                            });
                            return [
                                4,
                                _this34.client.core.pairing.activate({
                                    topic: t
                                })
                            ];
                        case 3:
                            _state.sent();
                            return [
                                3,
                                6
                            ];
                        case 4:
                            if (!(0, $5lf06.isJsonRpcError)(e)) return [
                                3,
                                6
                            ];
                            return [
                                4,
                                _this34.client.proposal.delete(s, (0, $8wnFv.getSdkError)("USER_DISCONNECTED"))
                            ];
                        case 5:
                            _state.sent();
                            i1 = (0, $8wnFv.engineEvent)("session_connect");
                            if (_this34.events.listenerCount(i1) === 0) throw new Error("emitting ".concat(i1, " without any listeners, 954"));
                            _this34.events.emit((0, $8wnFv.engineEvent)("session_connect"), {
                                error: e.error
                            });
                            _state.label = 6;
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t, e) {
                return _ref.apply(this, arguments);
            };
        }(), _this.onSessionSettleRequest = function() {
            var _ref = (0, $kSuI9._)(function(t, e) {
                var s, i, _e_params, _$r, o, a, c, h, l, g, d, r;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            s = e.id, i = e.params;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                5
                            ]);
                            _this35.isValidSessionSettleRequest(i);
                            _e_params = e.params, _$r = _e_params.relay, o = _e_params.controller, a = _e_params.expiry, c = _e_params.namespaces, h = _e_params.sessionProperties, l = _e_params.sessionConfig, g = $83db3bfa38a2bed3$var$E($83db3bfa38a2bed3$var$E({
                                topic: t,
                                relay: _$r,
                                expiry: a,
                                namespaces: c,
                                acknowledged: !0,
                                pairingTopic: "",
                                requiredNamespaces: {},
                                optionalNamespaces: {},
                                controller: o.publicKey,
                                self: {
                                    publicKey: "",
                                    metadata: _this35.client.metadata
                                },
                                peer: {
                                    publicKey: o.publicKey,
                                    metadata: o.metadata
                                }
                            }, h && {
                                sessionProperties: h
                            }), l && {
                                sessionConfig: l
                            }), d = (0, $8wnFv.engineEvent)("session_connect");
                            if (_this35.events.listenerCount(d) === 0) throw new Error("emitting ".concat(d, " without any listeners 997"));
                            _this35.events.emit((0, $8wnFv.engineEvent)("session_connect"), {
                                session: g
                            });
                            return [
                                4,
                                _this35.sendResult({
                                    id: e.id,
                                    topic: t,
                                    result: !0,
                                    throwOnFailedPublish: !0
                                })
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 3:
                            r = _state.sent();
                            return [
                                4,
                                _this35.sendError({
                                    id: s,
                                    topic: t,
                                    error: r
                                })
                            ];
                        case 4:
                            _state.sent(), _this35.client.logger.error(r);
                            return [
                                3,
                                5
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t, e) {
                return _ref.apply(this, arguments);
            };
        }(), _this.onSessionSettleResponse = function() {
            var _ref = (0, $kSuI9._)(function(t, e) {
                var s, _tmp, _tmp1;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            s = e.id;
                            if (!(0, $5lf06.isJsonRpcResult)(e)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _this36.client.session.update(t, {
                                    acknowledged: !0
                                })
                            ];
                        case 1:
                            _tmp = (_state.sent(), _this36.events.emit((0, $8wnFv.engineEvent)("session_approve", s), {}));
                            return [
                                3,
                                5
                            ];
                        case 2:
                            _tmp1 = (0, $5lf06.isJsonRpcError)(e);
                            if (!_tmp1) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                _this36.client.session.delete(t, (0, $8wnFv.getSdkError)("USER_DISCONNECTED"))
                            ];
                        case 3:
                            _tmp1 = (_state.sent(), _this36.events.emit((0, $8wnFv.engineEvent)("session_approve", s), {
                                error: e.error
                            }));
                            _state.label = 4;
                        case 4:
                            _tmp = _tmp1;
                            _state.label = 5;
                        case 5:
                            _tmp;
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t, e) {
                return _ref.apply(this, arguments);
            };
        }(), _this.onSessionUpdateRequest = function() {
            var _ref = (0, $kSuI9._)(function(t, e) {
                var s, i, _$r, o, a, r;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            s = e.params, i = e.id;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                7,
                                ,
                                9
                            ]);
                            _$r = "".concat(t, "_session_update"), o = (0, $8wnFv.MemoryStore).get(_$r);
                            if (o && _this37.isRequestOutOfSync(o, i)) {
                                _this37.client.logger.info("Discarding out of sync request - ".concat(i)), _this37.sendError({
                                    id: i,
                                    topic: t,
                                    error: (0, $8wnFv.getSdkError)("INVALID_UPDATE_REQUEST")
                                });
                                return [
                                    2
                                ];
                            }
                            _this37.isValidUpdate($83db3bfa38a2bed3$var$E({
                                topic: t
                            }, s));
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                5,
                                ,
                                6
                            ]);
                            (0, $8wnFv.MemoryStore).set(_$r, i);
                            return [
                                4,
                                _this37.client.session.update(t, {
                                    namespaces: s.namespaces
                                })
                            ];
                        case 3:
                            _state.sent();
                            return [
                                4,
                                _this37.sendResult({
                                    id: i,
                                    topic: t,
                                    result: !0,
                                    throwOnFailedPublish: !0
                                })
                            ];
                        case 4:
                            _state.sent();
                            return [
                                3,
                                6
                            ];
                        case 5:
                            a = _state.sent();
                            throw (0, $8wnFv.MemoryStore).delete(_$r), a;
                        case 6:
                            _this37.client.events.emit("session_update", {
                                id: i,
                                topic: t,
                                params: s
                            });
                            return [
                                3,
                                9
                            ];
                        case 7:
                            r = _state.sent();
                            return [
                                4,
                                _this37.sendError({
                                    id: i,
                                    topic: t,
                                    error: r
                                })
                            ];
                        case 8:
                            _state.sent(), _this37.client.logger.error(r);
                            return [
                                3,
                                9
                            ];
                        case 9:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t, e) {
                return _ref.apply(this, arguments);
            };
        }(), _this.isRequestOutOfSync = function(t, e) {
            return parseInt(e.toString().slice(0, -3)) <= parseInt(t.toString().slice(0, -3));
        }, _this.onSessionUpdateResponse = function(t, e) {
            var s = e.id, i = (0, $8wnFv.engineEvent)("session_update", s);
            if (_this.events.listenerCount(i) === 0) throw new Error("emitting ".concat(i, " without any listeners"));
            (0, $5lf06.isJsonRpcResult)(e) ? _this.events.emit((0, $8wnFv.engineEvent)("session_update", s), {}) : (0, $5lf06.isJsonRpcError)(e) && _this.events.emit((0, $8wnFv.engineEvent)("session_update", s), {
                error: e.error
            });
        }, _this.onSessionExtendRequest = function() {
            var _ref = (0, $kSuI9._)(function(t, e) {
                var s, i;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            s = e.id;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                4,
                                ,
                                6
                            ]);
                            _this38.isValidExtend({
                                topic: t
                            });
                            return [
                                4,
                                _this38.setExpiry(t, (0, $8wnFv.calcExpiry)($83db3bfa38a2bed3$export$84b1b9dbcdea0475))
                            ];
                        case 2:
                            _state.sent();
                            return [
                                4,
                                _this38.sendResult({
                                    id: s,
                                    topic: t,
                                    result: !0,
                                    throwOnFailedPublish: !0
                                })
                            ];
                        case 3:
                            _state.sent(), _this38.client.events.emit("session_extend", {
                                id: s,
                                topic: t
                            });
                            return [
                                3,
                                6
                            ];
                        case 4:
                            i = _state.sent();
                            return [
                                4,
                                _this38.sendError({
                                    id: s,
                                    topic: t,
                                    error: i
                                })
                            ];
                        case 5:
                            _state.sent(), _this38.client.logger.error(i);
                            return [
                                3,
                                6
                            ];
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t, e) {
                return _ref.apply(this, arguments);
            };
        }(), _this.onSessionExtendResponse = function(t, e) {
            var s = e.id, i = (0, $8wnFv.engineEvent)("session_extend", s);
            if (_this.events.listenerCount(i) === 0) throw new Error("emitting ".concat(i, " without any listeners"));
            (0, $5lf06.isJsonRpcResult)(e) ? _this.events.emit((0, $8wnFv.engineEvent)("session_extend", s), {}) : (0, $5lf06.isJsonRpcError)(e) && _this.events.emit((0, $8wnFv.engineEvent)("session_extend", s), {
                error: e.error
            });
        }, _this.onSessionPingRequest = function() {
            var _ref = (0, $kSuI9._)(function(t, e) {
                var s, i;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            s = e.id;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                5
                            ]);
                            _this39.isValidPing({
                                topic: t
                            });
                            return [
                                4,
                                _this39.sendResult({
                                    id: s,
                                    topic: t,
                                    result: !0,
                                    throwOnFailedPublish: !0
                                })
                            ];
                        case 2:
                            _state.sent(), _this39.client.events.emit("session_ping", {
                                id: s,
                                topic: t
                            });
                            return [
                                3,
                                5
                            ];
                        case 3:
                            i = _state.sent();
                            return [
                                4,
                                _this39.sendError({
                                    id: s,
                                    topic: t,
                                    error: i
                                })
                            ];
                        case 4:
                            _state.sent(), _this39.client.logger.error(i);
                            return [
                                3,
                                5
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t, e) {
                return _ref.apply(this, arguments);
            };
        }(), _this.onSessionPingResponse = function(t, e) {
            var s = e.id, i = (0, $8wnFv.engineEvent)("session_ping", s);
            if (_this.events.listenerCount(i) === 0) throw new Error("emitting ".concat(i, " without any listeners"));
            setTimeout(function() {
                (0, $5lf06.isJsonRpcResult)(e) ? _this.events.emit((0, $8wnFv.engineEvent)("session_ping", s), {}) : (0, $5lf06.isJsonRpcError)(e) && _this.events.emit((0, $8wnFv.engineEvent)("session_ping", s), {
                    error: e.error
                });
            }, 500);
        }, _this.onSessionDeleteRequest = function() {
            var _ref = (0, $kSuI9._)(function(t, e) {
                var s, i;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            s = e.id;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            _this40.isValidDisconnect({
                                topic: t,
                                reason: e.params
                            });
                            return [
                                4,
                                Promise.all([
                                    new Promise(function(i) {
                                        _this40.client.core.relayer.once((0, $6uXh7.RELAYER_EVENTS).publish, /*#__PURE__*/ (0, $kSuI9._)(function() {
                                            return (0, $eha6O.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            _this40.deleteSession({
                                                                topic: t,
                                                                id: s
                                                            })
                                                        ];
                                                    case 1:
                                                        i.apply(void 0, [
                                                            _state.sent()
                                                        ]);
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        }));
                                    }),
                                    _this40.sendResult({
                                        id: s,
                                        topic: t,
                                        result: !0,
                                        throwOnFailedPublish: !0
                                    }),
                                    _this40.cleanupPendingSentRequestsForTopic({
                                        topic: t,
                                        error: (0, $8wnFv.getSdkError)("USER_DISCONNECTED")
                                    })
                                ])
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            i = _state.sent();
                            _this40.client.logger.error(i);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t, e) {
                return _ref.apply(this, arguments);
            };
        }(), _this.onSessionRequest = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var e, s, i, r, o, a, c, _$h, l, g, h;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            s = t.topic, i = t.payload, r = t.attestation, o = t.encryptedId, a = i.id, c = i.params;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                5,
                                ,
                                7
                            ]);
                            return [
                                4,
                                _this41.isValidRequest($83db3bfa38a2bed3$var$E({
                                    topic: s
                                }, c))
                            ];
                        case 2:
                            _state.sent();
                            _$h = _this41.client.session.get(s);
                            return [
                                4,
                                _this41.getVerifyContext({
                                    attestationId: r,
                                    hash: (0, $8wnFv.hashMessage)(JSON.stringify((0, $3W2Mc.formatJsonRpcRequest)("wc_sessionRequest", c, a))),
                                    encryptedId: o,
                                    metadata: _$h.peer.metadata
                                })
                            ];
                        case 3:
                            l = _state.sent(), g = {
                                id: a,
                                topic: s,
                                params: c,
                                verifyContext: l
                            };
                            return [
                                4,
                                _this41.setPendingSessionRequest(g)
                            ];
                        case 4:
                            _state.sent(), (e = _this41.client.signConfig) != null && e.disableRequestQueue ? _this41.emitSessionRequest(g) : (_this41.addSessionRequestToSessionRequestQueue(g), _this41.processSessionRequestQueue());
                            return [
                                3,
                                7
                            ];
                        case 5:
                            h = _state.sent();
                            return [
                                4,
                                _this41.sendError({
                                    id: a,
                                    topic: s,
                                    error: h
                                })
                            ];
                        case 6:
                            _state.sent(), _this41.client.logger.error(h);
                            return [
                                3,
                                7
                            ];
                        case 7:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.onSessionRequestResponse = function(t, e) {
            var s = e.id, i = (0, $8wnFv.engineEvent)("session_request", s);
            if (_this.events.listenerCount(i) === 0) throw new Error("emitting ".concat(i, " without any listeners"));
            (0, $5lf06.isJsonRpcResult)(e) ? _this.events.emit((0, $8wnFv.engineEvent)("session_request", s), {
                result: e.result
            }) : (0, $5lf06.isJsonRpcError)(e) && _this.events.emit((0, $8wnFv.engineEvent)("session_request", s), {
                error: e.error
            });
        }, _this.onSessionEventRequest = function() {
            var _ref = (0, $kSuI9._)(function(t, e) {
                var s, i, _$r, o, r;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            s = e.id, i = e.params;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                2,
                                ,
                                4
                            ]);
                            _$r = "".concat(t, "_session_event_").concat(i.event.name), o = (0, $8wnFv.MemoryStore).get(_$r);
                            if (o && _this42.isRequestOutOfSync(o, s)) {
                                _this42.client.logger.info("Discarding out of sync request - ".concat(s));
                                return [
                                    2
                                ];
                            }
                            _this42.isValidEmit($83db3bfa38a2bed3$var$E({
                                topic: t
                            }, i)), _this42.client.events.emit("session_event", {
                                id: s,
                                topic: t,
                                params: i
                            }), (0, $8wnFv.MemoryStore).set(_$r, s);
                            return [
                                3,
                                4
                            ];
                        case 2:
                            r = _state.sent();
                            return [
                                4,
                                _this42.sendError({
                                    id: s,
                                    topic: t,
                                    error: r
                                })
                            ];
                        case 3:
                            _state.sent(), _this42.client.logger.error(r);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t, e) {
                return _ref.apply(this, arguments);
            };
        }(), _this.onSessionAuthenticateResponse = function(t, e) {
            var s = e.id;
            _this.client.logger.trace({
                type: "method",
                method: "onSessionAuthenticateResponse",
                topic: t,
                payload: e
            }), (0, $5lf06.isJsonRpcResult)(e) ? _this.events.emit((0, $8wnFv.engineEvent)("session_request", s), {
                result: e.result
            }) : (0, $5lf06.isJsonRpcError)(e) && _this.events.emit((0, $8wnFv.engineEvent)("session_request", s), {
                error: e.error
            });
        }, _this.onSessionAuthenticateRequest = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var e, s, i, r, _s_params, _$o, a, c, h, l, o, a1, c1, h1;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            e = t.topic, s = t.payload, i = t.attestation, r = t.encryptedId;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                4,
                                ,
                                7
                            ]);
                            _s_params = s.params, _$o = _s_params.requester, a = _s_params.authPayload, c = _s_params.expiryTimestamp;
                            return [
                                4,
                                _this43.getVerifyContext({
                                    attestationId: i,
                                    hash: (0, $8wnFv.hashMessage)(JSON.stringify(s)),
                                    encryptedId: r,
                                    metadata: _this43.client.metadata
                                })
                            ];
                        case 2:
                            h = _state.sent(), l = {
                                requester: _$o,
                                pairingTopic: e,
                                id: s.id,
                                authPayload: a,
                                verifyContext: h,
                                expiryTimestamp: c
                            };
                            return [
                                4,
                                _this43.setAuthRequest(s.id, {
                                    request: l,
                                    pairingTopic: e
                                })
                            ];
                        case 3:
                            _state.sent(), _this43.client.events.emit("session_authenticate", {
                                topic: e,
                                params: s.params,
                                id: s.id,
                                verifyContext: h
                            });
                            return [
                                3,
                                7
                            ];
                        case 4:
                            o = _state.sent();
                            _this43.client.logger.error(o);
                            a1 = s.params.requester.publicKey;
                            return [
                                4,
                                _this43.client.core.crypto.generateKeyPair()
                            ];
                        case 5:
                            c1 = _state.sent(), h1 = {
                                type: (0, $8wnFv.TYPE_1),
                                receiverPublicKey: a1,
                                senderPublicKey: c1
                            };
                            return [
                                4,
                                _this43.sendError({
                                    id: s.id,
                                    topic: e,
                                    error: o,
                                    encodeOpts: h1,
                                    rpcOpts: $83db3bfa38a2bed3$export$4edb1ca37014192d.wc_sessionAuthenticate.autoReject
                                })
                            ];
                        case 6:
                            _state.sent();
                            return [
                                3,
                                7
                            ];
                        case 7:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.addSessionRequestToSessionRequestQueue = function(t) {
            _this.sessionRequestQueue.queue.push(t);
        }, _this.cleanupAfterResponse = function(t) {
            _this.deletePendingSessionRequest(t.response.id, {
                message: "fulfilled",
                code: 0
            }), setTimeout(function() {
                _this.sessionRequestQueue.state = $83db3bfa38a2bed3$export$8602b201748df21a.idle, _this.processSessionRequestQueue();
            }, (0, $4BEBs.toMiliseconds)(_this.requestQueueDelay));
        }, _this.cleanupPendingSentRequestsForTopic = function(param) {
            var t = param.topic, e = param.error;
            var s = _this.client.core.history.pending;
            s.length > 0 && s.filter(function(i) {
                return i.topic === t && i.request.method === "wc_sessionRequest";
            }).forEach(function(i) {
                var r = i.request.id, o = (0, $8wnFv.engineEvent)("session_request", r);
                if (_this.events.listenerCount(o) === 0) throw new Error("emitting ".concat(o, " without any listeners"));
                _this.events.emit((0, $8wnFv.engineEvent)("session_request", i.request.id), {
                    error: e
                });
            });
        }, _this.processSessionRequestQueue = function() {
            if (_this.sessionRequestQueue.state === $83db3bfa38a2bed3$export$8602b201748df21a.active) {
                _this.client.logger.info("session request queue is already active.");
                return;
            }
            var t = _this.sessionRequestQueue.queue[0];
            if (!t) {
                _this.client.logger.info("session request queue is empty.");
                return;
            }
            try {
                _this.sessionRequestQueue.state = $83db3bfa38a2bed3$export$8602b201748df21a.active, _this.emitSessionRequest(t);
            } catch (e) {
                _this.client.logger.error(e);
            }
        }, _this.emitSessionRequest = function(t) {
            _this.client.events.emit("session_request", t);
        }, _this.onPairingCreated = function(t) {
            if (t.methods && _this.expectedPairingMethodMap.set(t.topic, t.methods), t.active) return;
            var e = _this.client.proposal.getAll().find(function(s) {
                return s.pairingTopic === t.topic;
            });
            e && _this.onSessionProposeRequest({
                topic: t.topic,
                payload: (0, $3W2Mc.formatJsonRpcRequest)("wc_sessionPropose", {
                    requiredNamespaces: e.requiredNamespaces,
                    optionalNamespaces: e.optionalNamespaces,
                    relays: e.relays,
                    proposer: e.proposer,
                    sessionProperties: e.sessionProperties
                }, e.id)
            });
        }, _this.isValidConnect = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var _p, a, e, s, i, r, o, _tmp, _p1, a1;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(0, $8wnFv.isValidParams)(t)) {
                                _p = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "connect() params: ".concat(JSON.stringify(t))), a = _p.message;
                                throw new Error(a);
                            }
                            e = t.pairingTopic, s = t.requiredNamespaces, i = t.optionalNamespaces, r = t.sessionProperties, o = t.relays;
                            _tmp = (0, $8wnFv.isUndefined)(e);
                            if (_tmp) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _this44.isValidPairingTopic(e)
                            ];
                        case 1:
                            _tmp = _state.sent();
                            _state.label = 2;
                        case 2:
                            if (_tmp, !(0, $8wnFv.isValidRelays)(o, !0)) {
                                _p1 = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "connect() relays: ".concat(o)), a1 = _p1.message;
                                throw new Error(a1);
                            }
                            !(0, $8wnFv.isUndefined)(s) && (0, $8wnFv.isValidObject)(s) !== 0 && _this44.validateNamespaces(s, "requiredNamespaces"), !(0, $8wnFv.isUndefined)(i) && (0, $8wnFv.isValidObject)(i) !== 0 && _this44.validateNamespaces(i, "optionalNamespaces"), (0, $8wnFv.isUndefined)(r) || _this44.validateSessionProps(r, "sessionProperties");
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.validateNamespaces = function(t, e) {
            var s = (0, $8wnFv.isValidRequiredNamespaces)(t, "connect()", e);
            if (s) throw new Error(s.message);
        }, _this.isValidApprove = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var e, s, i, r, o, a, c, _p, h;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(0, $8wnFv.isValidParams)(t)) throw new Error((0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "approve() params: ".concat(t)).message);
                            e = t.id, s = t.namespaces, i = t.relayProtocol, r = t.sessionProperties;
                            _this45.checkRecentlyDeleted(e);
                            return [
                                4,
                                _this45.isValidProposalId(e)
                            ];
                        case 1:
                            _state.sent();
                            o = _this45.client.proposal.get(e), a = (0, $8wnFv.isValidNamespaces)(s, "approve()");
                            if (a) throw new Error(a.message);
                            c = (0, $8wnFv.isConformingNamespaces)(o.requiredNamespaces, s, "approve()");
                            if (c) throw new Error(c.message);
                            if (!(0, $8wnFv.isValidString)(i, !0)) {
                                _p = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "approve() relayProtocol: ".concat(i)), h = _p.message;
                                throw new Error(h);
                            }
                            (0, $8wnFv.isUndefined)(r) || _this45.validateSessionProps(r, "sessionProperties");
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.isValidReject = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var _p, i, e, s, _p1, i1;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(0, $8wnFv.isValidParams)(t)) {
                                _p = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "reject() params: ".concat(t)), i = _p.message;
                                throw new Error(i);
                            }
                            e = t.id, s = t.reason;
                            _this46.checkRecentlyDeleted(e);
                            return [
                                4,
                                _this46.isValidProposalId(e)
                            ];
                        case 1:
                            if (_state.sent(), !(0, $8wnFv.isValidErrorReason)(s)) {
                                _p1 = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "reject() reason: ".concat(JSON.stringify(s))), i1 = _p1.message;
                                throw new Error(i1);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.isValidSessionSettleRequest = function(t) {
            if (!(0, $8wnFv.isValidParams)(t)) {
                var _p = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "onSessionSettleRequest() params: ".concat(t)), c = _p.message;
                throw new Error(c);
            }
            var e = t.relay, s = t.controller, i = t.namespaces, r = t.expiry;
            if (!(0, $8wnFv.isValidRelay)(e)) {
                var _p1 = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "onSessionSettleRequest() relay protocol should be a string"), c1 = _p1.message;
                throw new Error(c1);
            }
            var o = (0, $8wnFv.isValidController)(s, "onSessionSettleRequest()");
            if (o) throw new Error(o.message);
            var a = (0, $8wnFv.isValidNamespaces)(i, "onSessionSettleRequest()");
            if (a) throw new Error(a.message);
            if ((0, $8wnFv.isExpired)(r)) {
                var _p2 = (0, $8wnFv.getInternalError)("EXPIRED", "onSessionSettleRequest()"), c2 = _p2.message;
                throw new Error(c2);
            }
        }, _this.isValidUpdate = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var _p, a, e, s, i, r, o;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(0, $8wnFv.isValidParams)(t)) {
                                _p = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "update() params: ".concat(t)), a = _p.message;
                                throw new Error(a);
                            }
                            e = t.topic, s = t.namespaces;
                            _this47.checkRecentlyDeleted(e);
                            return [
                                4,
                                _this47.isValidSessionTopic(e)
                            ];
                        case 1:
                            _state.sent();
                            i = _this47.client.session.get(e), r = (0, $8wnFv.isValidNamespaces)(s, "update()");
                            if (r) throw new Error(r.message);
                            o = (0, $8wnFv.isConformingNamespaces)(i.requiredNamespaces, s, "update()");
                            if (o) throw new Error(o.message);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.isValidExtend = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var _p, s, e;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(0, $8wnFv.isValidParams)(t)) {
                                _p = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "extend() params: ".concat(t)), s = _p.message;
                                throw new Error(s);
                            }
                            e = t.topic;
                            _this48.checkRecentlyDeleted(e);
                            return [
                                4,
                                _this48.isValidSessionTopic(e)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.isValidRequest = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var _p, a, e, s, i, r, _this_client_session_get, o, _p1, a1, _p2, a2, _p3, a3, _p4, a4;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(0, $8wnFv.isValidParams)(t)) {
                                _p = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "request() params: ".concat(t)), a = _p.message;
                                throw new Error(a);
                            }
                            e = t.topic, s = t.request, i = t.chainId, r = t.expiry;
                            _this49.checkRecentlyDeleted(e);
                            return [
                                4,
                                _this49.isValidSessionTopic(e)
                            ];
                        case 1:
                            _state.sent();
                            _this_client_session_get = _this49.client.session.get(e), o = _this_client_session_get.namespaces;
                            if (!(0, $8wnFv.isValidNamespacesChainId)(o, i)) {
                                _p1 = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "request() chainId: ".concat(i)), a1 = _p1.message;
                                throw new Error(a1);
                            }
                            if (!(0, $8wnFv.isValidRequest)(s)) {
                                _p2 = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "request() ".concat(JSON.stringify(s))), a2 = _p2.message;
                                throw new Error(a2);
                            }
                            if (!(0, $8wnFv.isValidNamespacesRequest)(o, i, s.method)) {
                                _p3 = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "request() method: ".concat(s.method)), a3 = _p3.message;
                                throw new Error(a3);
                            }
                            if (r && !(0, $8wnFv.isValidRequestExpiry)(r, $83db3bfa38a2bed3$export$409f0c0a13a1b7c6)) {
                                _p4 = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "request() expiry: ".concat(r, ". Expiry must be a number (in seconds) between ").concat($83db3bfa38a2bed3$export$409f0c0a13a1b7c6.min, " and ").concat($83db3bfa38a2bed3$export$409f0c0a13a1b7c6.max)), a4 = _p4.message;
                                throw new Error(a4);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.isValidRespond = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var e, _p, _$r, s, i, r, _p1, _$r1;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(0, $8wnFv.isValidParams)(t)) {
                                _p = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "respond() params: ".concat(t)), _$r = _p.message;
                                throw new Error(_$r);
                            }
                            s = t.topic, i = t.response;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                _this50.isValidSessionTopic(s)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            r = _state.sent();
                            throw (e = t === null || t === void 0 ? void 0 : t.response) != null && e.id && _this50.cleanupAfterResponse(t), r;
                        case 4:
                            if (!(0, $8wnFv.isValidResponse)(i)) {
                                _p1 = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "respond() response: ".concat(JSON.stringify(i))), _$r1 = _p1.message;
                                throw new Error(_$r1);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.isValidPing = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var _p, s, e;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(0, $8wnFv.isValidParams)(t)) {
                                _p = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "ping() params: ".concat(t)), s = _p.message;
                                throw new Error(s);
                            }
                            e = t.topic;
                            return [
                                4,
                                _this51.isValidSessionOrPairingTopic(e)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.isValidEmit = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var _p, o, e, s, i, _this_client_session_get, r, _p1, o1, _p2, o2, _p3, o3;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(0, $8wnFv.isValidParams)(t)) {
                                _p = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "emit() params: ".concat(t)), o = _p.message;
                                throw new Error(o);
                            }
                            e = t.topic, s = t.event, i = t.chainId;
                            return [
                                4,
                                _this52.isValidSessionTopic(e)
                            ];
                        case 1:
                            _state.sent();
                            _this_client_session_get = _this52.client.session.get(e), r = _this_client_session_get.namespaces;
                            if (!(0, $8wnFv.isValidNamespacesChainId)(r, i)) {
                                _p1 = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "emit() chainId: ".concat(i)), o1 = _p1.message;
                                throw new Error(o1);
                            }
                            if (!(0, $8wnFv.isValidEvent)(s)) {
                                _p2 = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "emit() event: ".concat(JSON.stringify(s))), o2 = _p2.message;
                                throw new Error(o2);
                            }
                            if (!(0, $8wnFv.isValidNamespacesEvent)(r, i, s.name)) {
                                _p3 = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "emit() event: ".concat(JSON.stringify(s))), o3 = _p3.message;
                                throw new Error(o3);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.isValidDisconnect = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var _p, s, e;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(0, $8wnFv.isValidParams)(t)) {
                                _p = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "disconnect() params: ".concat(t)), s = _p.message;
                                throw new Error(s);
                            }
                            e = t.topic;
                            return [
                                4,
                                _this53.isValidSessionOrPairingTopic(e)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.isValidAuthenticate = function(t) {
            var e = t.chains, s = t.uri, i = t.domain, r = t.nonce;
            if (!Array.isArray(e) || e.length === 0) throw new Error("chains is required and must be a non-empty array");
            if (!(0, $8wnFv.isValidString)(s, !1)) throw new Error("uri is required parameter");
            if (!(0, $8wnFv.isValidString)(i, !1)) throw new Error("domain is required parameter");
            if (!(0, $8wnFv.isValidString)(r, !1)) throw new Error("nonce is required parameter");
            if ((0, $c6Xmf._)(new Set(e.map(function(a) {
                return (0, $8wnFv.parseChainId)(a).namespace;
            }))).length > 1) throw new Error("Multi-namespace requests are not supported. Please request single namespace only.");
            var _Ee = (0, $8wnFv.parseChainId)(e[0]), o = _Ee.namespace;
            if (o !== "eip155") throw new Error("Only eip155 namespace is supported for authenticated sessions. Please use .connect() for non-eip155 chains.");
        }, _this.getVerifyContext = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var e, s, i, r, o, _$a, a;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            e = t.attestationId, s = t.hash, i = t.encryptedId, r = t.metadata, o = {
                                verified: {
                                    verifyUrl: r.verifyUrl || (0, $6uXh7.VERIFY_SERVER),
                                    validation: "UNKNOWN",
                                    origin: r.url || ""
                                }
                            };
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                _this54.client.core.verify.resolve({
                                    attestationId: e,
                                    hash: s,
                                    encryptedId: i,
                                    verifyUrl: r.verifyUrl
                                })
                            ];
                        case 2:
                            _$a = _state.sent();
                            _$a && (o.verified.origin = _$a.origin, o.verified.isScam = _$a.isScam, o.verified.validation = _$a.origin === new URL(r.url).origin ? "VALID" : "INVALID");
                            return [
                                3,
                                4
                            ];
                        case 3:
                            a = _state.sent();
                            _this54.client.logger.warn(a);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2,
                                (_this54.client.logger.debug("Verify context: ".concat(JSON.stringify(o))), o)
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.validateSessionProps = function(t, e) {
            Object.values(t).forEach(function(s) {
                if (!(0, $8wnFv.isValidString)(s, !1)) {
                    var _p = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "".concat(e, " must be in Record<string, string> format. Received: ").concat(JSON.stringify(s))), i = _p.message;
                    throw new Error(i);
                }
            });
        }, _this.getPendingAuthRequest = function(t) {
            var e = _this.client.auth.requests.get(t);
            return typeof e == "object" ? e : void 0;
        }, _this.addToRecentlyDeleted = function(t, e) {
            if (_this.recentlyDeletedMap.set(t, e), _this.recentlyDeletedMap.size >= _this.recentlyDeletedLimit) {
                var s = 0;
                var i = _this.recentlyDeletedLimit / 2;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = _this.recentlyDeletedMap.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var r = _step.value;
                        if (s++ >= i) break;
                        _this.recentlyDeletedMap.delete(r);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }, _this.checkRecentlyDeleted = function(t) {
            var e = _this.recentlyDeletedMap.get(t);
            if (e) {
                var _p = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "Record was recently deleted - ".concat(e, ": ").concat(t)), s = _p.message;
                throw new Error(s);
            }
        };
        return (0, $3U0IP._)(_this);
    }
    (0, $1wc17._)(rs, [
        {
            key: "isInitialized",
            value: function isInitialized() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _p, n;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.initialized) {
                                    _p = (0, $8wnFv.getInternalError)("NOT_INITIALIZED", _this.name), n = _p.message;
                                    throw new Error(n);
                                }
                                return [
                                    4,
                                    _this.client.core.relayer.confirmOnlineStateOrThrow()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "registerRelayerEvents",
            value: function registerRelayerEvents() {
                var _this = this;
                this.client.core.relayer.on((0, $6uXh7.RELAYER_EVENTS).message, function(n) {
                    !_this.initialized || _this.relayMessageCache.length > 0 ? _this.relayMessageCache.push(n) : _this.onRelayMessage(n);
                });
            }
        },
        {
            key: "onRelayMessage",
            value: function onRelayMessage(n) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var t, e, s, _ref, i, r, _tmp, _tmp1, o;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t = n.topic, e = n.message, s = n.attestation, _ref = _this.client.auth.authKeys.keys.includes($83db3bfa38a2bed3$export$efef74cb455ac30f) ? _this.client.auth.authKeys.get($83db3bfa38a2bed3$export$efef74cb455ac30f) : {
                                    responseTopic: void 0,
                                    publicKey: void 0
                                }, i = _ref.publicKey;
                                return [
                                    4,
                                    _this.client.core.crypto.decode(t, e, {
                                        receiverPublicKey: i
                                    })
                                ];
                            case 1:
                                r = _state.sent();
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    9,
                                    ,
                                    10
                                ]);
                                if (!(0, $5lf06.isJsonRpcRequest)(r)) return [
                                    3,
                                    3
                                ];
                                _tmp = (_this.client.core.history.set(t, r), _this.onRelayEventRequest({
                                    topic: t,
                                    payload: r,
                                    attestation: s,
                                    encryptedId: (0, $8wnFv.hashMessage)(e)
                                }));
                                return [
                                    3,
                                    8
                                ];
                            case 3:
                                if (!(0, $5lf06.isJsonRpcResponse)(r)) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    _this.client.core.history.resolve(r)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    4,
                                    _this.onRelayEventResponse({
                                        topic: t,
                                        payload: r
                                    })
                                ];
                            case 5:
                                _tmp1 = (_state.sent(), _this.client.core.history.delete(t, r.id));
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                _tmp1 = _this.onRelayEventUnknownPayload({
                                    topic: t,
                                    payload: r
                                });
                                _state.label = 7;
                            case 7:
                                _tmp = _tmp1;
                                _state.label = 8;
                            case 8:
                                _tmp;
                                return [
                                    3,
                                    10
                                ];
                            case 9:
                                o = _state.sent();
                                _this.client.logger.error(o);
                                return [
                                    3,
                                    10
                                ];
                            case 10:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "registerExpirerEvents",
            value: function registerExpirerEvents() {
                var _this = this;
                this.client.core.expirer.on((0, $6uXh7.EXPIRER_EVENTS).expired, function() {
                    var _ref = (0, $kSuI9._)(function(n) {
                        var _Vt, t, e, _tmp, _tmp1, _tmp2;
                        return (0, $eha6O.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _Vt = (0, $8wnFv.parseExpirerTarget)(n.target), t = _Vt.topic, e = _Vt.id;
                                    if (!(e && _this.client.pendingRequest.keys.includes(e))) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        _this.deletePendingSessionRequest(e, (0, $8wnFv.getInternalError)("EXPIRED"), !0)
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _state.sent()
                                    ];
                                case 2:
                                    if (!(e && _this.client.auth.requests.keys.includes(e))) return [
                                        3,
                                        4
                                    ];
                                    return [
                                        4,
                                        _this.deletePendingAuthRequest(e, (0, $8wnFv.getInternalError)("EXPIRED"), !0)
                                    ];
                                case 3:
                                    return [
                                        2,
                                        _state.sent()
                                    ];
                                case 4:
                                    if (!t) return [
                                        3,
                                        7
                                    ];
                                    _tmp1 = _this.client.session.keys.includes(t);
                                    if (!_tmp1) return [
                                        3,
                                        6
                                    ];
                                    return [
                                        4,
                                        _this.deleteSession({
                                            topic: t,
                                            expirerHasDeleted: !0
                                        })
                                    ];
                                case 5:
                                    _tmp1 = (_state.sent(), _this.client.events.emit("session_expire", {
                                        topic: t
                                    }));
                                    _state.label = 6;
                                case 6:
                                    _tmp = _tmp1;
                                    return [
                                        3,
                                        10
                                    ];
                                case 7:
                                    _tmp2 = e;
                                    if (!_tmp2) return [
                                        3,
                                        9
                                    ];
                                    return [
                                        4,
                                        _this.deleteProposal(e, !0)
                                    ];
                                case 8:
                                    _tmp2 = (_state.sent(), _this.client.events.emit("proposal_expire", {
                                        id: e
                                    }));
                                    _state.label = 9;
                                case 9:
                                    _tmp = _tmp2;
                                    _state.label = 10;
                                case 10:
                                    _tmp;
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(n) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        },
        {
            key: "registerPairingEvents",
            value: function registerPairingEvents() {
                var _this = this;
                this.client.core.pairing.events.on((0, $6uXh7.PAIRING_EVENTS).create, function(n) {
                    return _this.onPairingCreated(n);
                }), this.client.core.pairing.events.on((0, $6uXh7.PAIRING_EVENTS).delete, function(n) {
                    _this.addToRecentlyDeleted(n.topic, "pairing");
                });
            }
        },
        {
            key: "isValidPairingTopic",
            value: function isValidPairingTopic(n) {
                if (!(0, $8wnFv.isValidString)(n, !1)) {
                    var _p = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "pairing topic should be a string: ".concat(n)), t = _p.message;
                    throw new Error(t);
                }
                if (!this.client.core.pairing.pairings.keys.includes(n)) {
                    var _p1 = (0, $8wnFv.getInternalError)("NO_MATCHING_KEY", "pairing topic doesn't exist: ".concat(n)), t1 = _p1.message;
                    throw new Error(t1);
                }
                if ((0, $8wnFv.isExpired)(this.client.core.pairing.pairings.get(n).expiry)) {
                    var _p2 = (0, $8wnFv.getInternalError)("EXPIRED", "pairing topic: ".concat(n)), t2 = _p2.message;
                    throw new Error(t2);
                }
            }
        },
        {
            key: "isValidSessionTopic",
            value: function isValidSessionTopic(n) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _p, t, _p1, t1, _p2, t2, _p3, t3;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(0, $8wnFv.isValidString)(n, !1)) {
                                    _p = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "session topic should be a string: ".concat(n)), t = _p.message;
                                    throw new Error(t);
                                }
                                if (_this.checkRecentlyDeleted(n), !_this.client.session.keys.includes(n)) {
                                    _p1 = (0, $8wnFv.getInternalError)("NO_MATCHING_KEY", "session topic doesn't exist: ".concat(n)), t1 = _p1.message;
                                    throw new Error(t1);
                                }
                                if (!(0, $8wnFv.isExpired)(_this.client.session.get(n).expiry)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.deleteSession({
                                        topic: n
                                    })
                                ];
                            case 1:
                                _state.sent();
                                _p2 = (0, $8wnFv.getInternalError)("EXPIRED", "session topic: ".concat(n)), t2 = _p2.message;
                                throw new Error(t2);
                            case 2:
                                if (!!_this.client.core.crypto.keychain.has(n)) return [
                                    3,
                                    4
                                ];
                                _p3 = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "session topic does not exist in keychain: ".concat(n)), t3 = _p3.message;
                                return [
                                    4,
                                    _this.deleteSession({
                                        topic: n
                                    })
                                ];
                            case 3:
                                throw _state.sent(), new Error(t3);
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "isValidSessionOrPairingTopic",
            value: function isValidSessionOrPairingTopic(n) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _p, t, _p1, t1;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(_this.checkRecentlyDeleted(n), _this.client.session.keys.includes(n))) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.isValidSessionTopic(n)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                if (_this.client.core.pairing.pairings.keys.includes(n)) _this.isValidPairingTopic(n);
                                else if ((0, $8wnFv.isValidString)(n, !1)) {
                                    _p = (0, $8wnFv.getInternalError)("NO_MATCHING_KEY", "session or pairing topic doesn't exist: ".concat(n)), t = _p.message;
                                    throw new Error(t);
                                } else {
                                    _p1 = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "session or pairing topic should be a string: ".concat(n)), t1 = _p1.message;
                                    throw new Error(t1);
                                }
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "isValidProposalId",
            value: function isValidProposalId(n) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _p, t, _p1, t1, _p2, t2;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(0, $8wnFv.isValidId)(n)) {
                                    _p = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "proposal id should be a number: ".concat(n)), t = _p.message;
                                    throw new Error(t);
                                }
                                if (!_this.client.proposal.keys.includes(n)) {
                                    _p1 = (0, $8wnFv.getInternalError)("NO_MATCHING_KEY", "proposal id doesn't exist: ".concat(n)), t1 = _p1.message;
                                    throw new Error(t1);
                                }
                                if (!(0, $8wnFv.isExpired)(_this.client.proposal.get(n).expiryTimestamp)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.deleteProposal(n)
                                ];
                            case 1:
                                _state.sent();
                                _p2 = (0, $8wnFv.getInternalError)("EXPIRED", "proposal id: ".concat(n)), t2 = _p2.message;
                                throw new Error(t2);
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return rs;
}((0, $3WrnC.IEngine));
var $83db3bfa38a2bed3$var$ns = /*#__PURE__*/ function(H) {
    "use strict";
    (0, $dcsZi._)(ns, H);
    var _super = (0, $ohfOJ._)(ns);
    function ns(n, t) {
        (0, $4GJKx._)(this, ns);
        var _this;
        _this = _super.call(this, n, t, $83db3bfa38a2bed3$export$ae6c7a4f7ed730a1, $83db3bfa38a2bed3$export$7fa6f9ee1e2cab96), _this.core = n, _this.logger = t;
        return (0, $3U0IP._)(_this);
    }
    return ns;
}((0, $6uXh7.Store));
var $83db3bfa38a2bed3$var$it = /*#__PURE__*/ function(H) {
    "use strict";
    (0, $dcsZi._)(it, H);
    var _super = (0, $ohfOJ._)(it);
    function it(n, t) {
        (0, $4GJKx._)(this, it);
        var _this;
        _this = _super.call(this, n, t, $83db3bfa38a2bed3$export$a069e98a8dfeec1e, $83db3bfa38a2bed3$export$7fa6f9ee1e2cab96), _this.core = n, _this.logger = t;
        return (0, $3U0IP._)(_this);
    }
    return it;
}((0, $6uXh7.Store));
var $83db3bfa38a2bed3$var$os = /*#__PURE__*/ function(H) {
    "use strict";
    (0, $dcsZi._)(os, H);
    var _super = (0, $ohfOJ._)(os);
    function os(n, t) {
        (0, $4GJKx._)(this, os);
        var _this;
        _this = _super.call(this, n, t, $83db3bfa38a2bed3$export$40b296af21bd38a4, $83db3bfa38a2bed3$export$7fa6f9ee1e2cab96, function(e) {
            return e.id;
        }), _this.core = n, _this.logger = t;
        return (0, $3U0IP._)(_this);
    }
    return os;
}((0, $6uXh7.Store));
var $83db3bfa38a2bed3$var$as = /*#__PURE__*/ function(H) {
    "use strict";
    (0, $dcsZi._)(as, H);
    var _super = (0, $ohfOJ._)(as);
    function as(n, t) {
        (0, $4GJKx._)(this, as);
        var _this;
        _this = _super.call(this, n, t, $83db3bfa38a2bed3$export$ab815cb37981e7e0, $83db3bfa38a2bed3$export$323ba3ebb8028ed0, function() {
            return $83db3bfa38a2bed3$export$efef74cb455ac30f;
        }), _this.core = n, _this.logger = t;
        return (0, $3U0IP._)(_this);
    }
    return as;
}((0, $6uXh7.Store));
var $83db3bfa38a2bed3$var$cs = /*#__PURE__*/ function(H) {
    "use strict";
    (0, $dcsZi._)(cs, H);
    var _super = (0, $ohfOJ._)(cs);
    function cs(n, t) {
        (0, $4GJKx._)(this, cs);
        var _this;
        _this = _super.call(this, n, t, $83db3bfa38a2bed3$export$5d9af9e20f678626, $83db3bfa38a2bed3$export$323ba3ebb8028ed0), _this.core = n, _this.logger = t;
        return (0, $3U0IP._)(_this);
    }
    return cs;
}((0, $6uXh7.Store));
var $83db3bfa38a2bed3$var$ls = /*#__PURE__*/ function(H) {
    "use strict";
    (0, $dcsZi._)(ls, H);
    var _super = (0, $ohfOJ._)(ls);
    function ls(n, t) {
        (0, $4GJKx._)(this, ls);
        var _this;
        _this = _super.call(this, n, t, $83db3bfa38a2bed3$export$3643b3579d091159, $83db3bfa38a2bed3$export$323ba3ebb8028ed0, function(e) {
            return e.id;
        }), _this.core = n, _this.logger = t;
        return (0, $3U0IP._)(_this);
    }
    return ls;
}((0, $6uXh7.Store));
var $83db3bfa38a2bed3$var$hs = /*#__PURE__*/ function() {
    "use strict";
    function hs(n, t) {
        (0, $4GJKx._)(this, hs);
        this.core = n, this.logger = t, this.authKeys = new $83db3bfa38a2bed3$var$as(this.core, this.logger), this.pairingTopics = new $83db3bfa38a2bed3$var$cs(this.core, this.logger), this.requests = new $83db3bfa38a2bed3$var$ls(this.core, this.logger);
    }
    (0, $1wc17._)(hs, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.authKeys.init()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this.pairingTopics.init()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    _this.requests.init()
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return hs;
}();
var $83db3bfa38a2bed3$export$2e2bcd8739ae039 = /*#__PURE__*/ function(mt) {
    "use strict";
    (0, $dcsZi._)(pe, mt);
    var _super = (0, $ohfOJ._)(pe);
    function pe(n) {
        (0, $4GJKx._)(this, pe);
        var _this;
        var _this1 = (0, $d3H5E._)(_this);
        var _this2 = (0, $d3H5E._)(_this);
        var _this3 = (0, $d3H5E._)(_this);
        var _this4 = (0, $d3H5E._)(_this);
        var _this5 = (0, $d3H5E._)(_this);
        var _this6 = (0, $d3H5E._)(_this);
        var _this7 = (0, $d3H5E._)(_this);
        var _this8 = (0, $d3H5E._)(_this);
        var _this9 = (0, $d3H5E._)(_this);
        var _this10 = (0, $d3H5E._)(_this);
        var _this11 = (0, $d3H5E._)(_this);
        var _this12 = (0, $d3H5E._)(_this);
        var _this13 = (0, $d3H5E._)(_this);
        var _this14 = (0, $d3H5E._)(_this);
        _this = _super.call(this, n), _this.protocol = $83db3bfa38a2bed3$export$4fa962fc67384e02, _this.version = $83db3bfa38a2bed3$export$61085c48796ff049, _this.name = $83db3bfa38a2bed3$export$8dffb3242f2c5f72.name, _this.events = new (0, $cyxGb.EventEmitter), _this.on = function(e, s) {
            return _this.events.on(e, s);
        }, _this.once = function(e, s) {
            return _this.events.once(e, s);
        }, _this.off = function(e, s) {
            return _this.events.off(e, s);
        }, _this.removeListener = function(e, s) {
            return _this.events.removeListener(e, s);
        }, _this.removeAllListeners = function(e) {
            return _this.events.removeAllListeners(e);
        }, _this.connect = function() {
            var _ref = (0, $kSuI9._)(function(e) {
                var s;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this1.engine.connect(e)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            s = _state.sent();
                            throw _this1.logger.error(s.message), s;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(e) {
                return _ref.apply(this, arguments);
            };
        }(), _this.pair = function() {
            var _ref = (0, $kSuI9._)(function(e) {
                var s;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this2.engine.pair(e)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            s = _state.sent();
                            throw _this2.logger.error(s.message), s;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(e) {
                return _ref.apply(this, arguments);
            };
        }(), _this.approve = function() {
            var _ref = (0, $kSuI9._)(function(e) {
                var s;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this3.engine.approve(e)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            s = _state.sent();
                            throw _this3.logger.error(s.message), s;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(e) {
                return _ref.apply(this, arguments);
            };
        }(), _this.reject = function() {
            var _ref = (0, $kSuI9._)(function(e) {
                var s;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this4.engine.reject(e)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            s = _state.sent();
                            throw _this4.logger.error(s.message), s;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(e) {
                return _ref.apply(this, arguments);
            };
        }(), _this.update = function() {
            var _ref = (0, $kSuI9._)(function(e) {
                var s;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this5.engine.update(e)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            s = _state.sent();
                            throw _this5.logger.error(s.message), s;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(e) {
                return _ref.apply(this, arguments);
            };
        }(), _this.extend = function() {
            var _ref = (0, $kSuI9._)(function(e) {
                var s;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this6.engine.extend(e)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            s = _state.sent();
                            throw _this6.logger.error(s.message), s;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(e) {
                return _ref.apply(this, arguments);
            };
        }(), _this.request = function() {
            var _ref = (0, $kSuI9._)(function(e) {
                var s;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this7.engine.request(e)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            s = _state.sent();
                            throw _this7.logger.error(s.message), s;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(e) {
                return _ref.apply(this, arguments);
            };
        }(), _this.respond = function() {
            var _ref = (0, $kSuI9._)(function(e) {
                var s;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this8.engine.respond(e)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            s = _state.sent();
                            throw _this8.logger.error(s.message), s;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(e) {
                return _ref.apply(this, arguments);
            };
        }(), _this.ping = function() {
            var _ref = (0, $kSuI9._)(function(e) {
                var s;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this9.engine.ping(e)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            s = _state.sent();
                            throw _this9.logger.error(s.message), s;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(e) {
                return _ref.apply(this, arguments);
            };
        }(), _this.emit = function() {
            var _ref = (0, $kSuI9._)(function(e) {
                var s;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this10.engine.emit(e)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            s = _state.sent();
                            throw _this10.logger.error(s.message), s;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(e) {
                return _ref.apply(this, arguments);
            };
        }(), _this.disconnect = function() {
            var _ref = (0, $kSuI9._)(function(e) {
                var s;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this11.engine.disconnect(e)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            s = _state.sent();
                            throw _this11.logger.error(s.message), s;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(e) {
                return _ref.apply(this, arguments);
            };
        }(), _this.find = function(e) {
            try {
                return _this.engine.find(e);
            } catch (s) {
                throw _this.logger.error(s.message), s;
            }
        }, _this.getPendingSessionRequests = function() {
            try {
                return _this.engine.getPendingSessionRequests();
            } catch (e) {
                throw _this.logger.error(e.message), e;
            }
        }, _this.authenticate = function() {
            var _ref = (0, $kSuI9._)(function(e) {
                var s;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this12.engine.authenticate(e)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            s = _state.sent();
                            throw _this12.logger.error(s.message), s;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(e) {
                return _ref.apply(this, arguments);
            };
        }(), _this.formatAuthMessage = function(e) {
            try {
                return _this.engine.formatAuthMessage(e);
            } catch (s) {
                throw _this.logger.error(s.message), s;
            }
        }, _this.approveSessionAuthenticate = function() {
            var _ref = (0, $kSuI9._)(function(e) {
                var s;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this13.engine.approveSessionAuthenticate(e)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            s = _state.sent();
                            throw _this13.logger.error(s.message), s;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(e) {
                return _ref.apply(this, arguments);
            };
        }(), _this.rejectSessionAuthenticate = function() {
            var _ref = (0, $kSuI9._)(function(e) {
                var s;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this14.engine.rejectSessionAuthenticate(e)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            s = _state.sent();
                            throw _this14.logger.error(s.message), s;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(e) {
                return _ref.apply(this, arguments);
            };
        }(), _this.name = (n === null || n === void 0 ? void 0 : n.name) || $83db3bfa38a2bed3$export$8dffb3242f2c5f72.name, _this.metadata = (n === null || n === void 0 ? void 0 : n.metadata) || (0, $8wnFv.getAppMetadata)(), _this.signConfig = n === null || n === void 0 ? void 0 : n.signConfig;
        var t = (0, $l0HdX._)(n === null || n === void 0 ? void 0 : n.logger) < "u" && typeof (n === null || n === void 0 ? void 0 : n.logger) != "string" ? n.logger : (0, (/*@__PURE__*/$parcel$interopDefault($6DLsq)))((0, $7Gasr.getDefaultLoggerOptions)({
            level: (n === null || n === void 0 ? void 0 : n.logger) || $83db3bfa38a2bed3$export$8dffb3242f2c5f72.logger
        }));
        _this.core = (n === null || n === void 0 ? void 0 : n.core) || new (0, $6uXh7.Core)(n), _this.logger = (0, $7Gasr.generateChildLogger)(t, _this.name), _this.session = new $83db3bfa38a2bed3$var$it(_this.core, _this.logger), _this.proposal = new $83db3bfa38a2bed3$var$ns(_this.core, _this.logger), _this.pendingRequest = new $83db3bfa38a2bed3$var$os(_this.core, _this.logger), _this.engine = new $83db3bfa38a2bed3$var$rs((0, $d3H5E._)(_this)), _this.auth = new $83db3bfa38a2bed3$var$hs(_this.core, _this.logger);
        return (0, $3U0IP._)(_this);
    }
    (0, $1wc17._)(pe, [
        {
            key: "context",
            get: function get() {
                return (0, $7Gasr.getLoggerContext)(this.logger);
            }
        },
        {
            key: "pairing",
            get: function get() {
                return this.core.pairing.pairings;
            }
        },
        {
            key: "initialize",
            value: function initialize() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var n;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.logger.trace("Initialized");
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    8,
                                    ,
                                    9
                                ]);
                                return [
                                    4,
                                    _this.core.start()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    _this.session.init()
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    4,
                                    _this.proposal.init()
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    4,
                                    _this.pendingRequest.init()
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    4,
                                    _this.engine.init()
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    4,
                                    _this.auth.init()
                                ];
                            case 7:
                                _state.sent(), _this.logger.info("SignClient Initialization Success"), _this.engine.processRelayMessageCache();
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                n = _state.sent();
                                throw _this.logger.info("SignClient Initialization Failure"), _this.logger.error(n.message), n;
                            case 9:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ], [
        {
            key: "init",
            value: function init(n) {
                return (0, $kSuI9._)(function() {
                    var t;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t = new pe(n);
                                return [
                                    4,
                                    t.initialize()
                                ];
                            case 1:
                                return [
                                    2,
                                    (_state.sent(), t)
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return pe;
}((0, $3WrnC.ISignClient));
var $83db3bfa38a2bed3$export$90b8cff65c105172 = $83db3bfa38a2bed3$var$it, $83db3bfa38a2bed3$export$bdf4ba258ec679dc = $83db3bfa38a2bed3$export$2e2bcd8739ae039;

});
parcelRegister("6uXh7", function(module, exports) {

$parcel$export(module.exports, "RELAYER_DEFAULT_PROTOCOL", function () { return $4bb3863dfa1867a4$export$822d0bd1635d5360; });
$parcel$export(module.exports, "RELAYER_EVENTS", function () { return $4bb3863dfa1867a4$export$d56245796e2837d; });
$parcel$export(module.exports, "PAIRING_EVENTS", function () { return $4bb3863dfa1867a4$export$ca3c0b962acf7b75; });
$parcel$export(module.exports, "EXPIRER_EVENTS", function () { return $4bb3863dfa1867a4$export$9013719d9206b0c1; });
$parcel$export(module.exports, "VERIFY_SERVER", function () { return $4bb3863dfa1867a4$export$7e3b1a28ddecdbaa; });
$parcel$export(module.exports, "EVENT_CLIENT_PAIRING_TRACES", function () { return $4bb3863dfa1867a4$export$6736f9bb609b5d34; });
$parcel$export(module.exports, "EVENT_CLIENT_PAIRING_ERRORS", function () { return $4bb3863dfa1867a4$export$e1dc85b7b7495247; });
$parcel$export(module.exports, "EVENT_CLIENT_SESSION_TRACES", function () { return $4bb3863dfa1867a4$export$16ed3f27a411eba0; });
$parcel$export(module.exports, "EVENT_CLIENT_SESSION_ERRORS", function () { return $4bb3863dfa1867a4$export$bc50109885e83402; });
$parcel$export(module.exports, "EVENT_CLIENT_AUTHENTICATE_TRACES", function () { return $4bb3863dfa1867a4$export$6540f02663742dde; });
$parcel$export(module.exports, "EVENT_CLIENT_AUTHENTICATE_ERRORS", function () { return $4bb3863dfa1867a4$export$aca4f34441e6cd3a; });
$parcel$export(module.exports, "Store", function () { return $4bb3863dfa1867a4$export$390f32400eaf98c9; });
$parcel$export(module.exports, "Core", function () { return $4bb3863dfa1867a4$export$4143ab5b91744744; });

var $d3H5E = parcelRequire("d3H5E");

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $3sHb8 = parcelRequire("3sHb8");

var $dcsZi = parcelRequire("dcsZi");

var $do9pw = parcelRequire("do9pw");

var $3U0IP = parcelRequire("3U0IP");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $l0HdX = parcelRequire("l0HdX");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");

var $cyxGb = parcelRequire("cyxGb");

var $kkqqt = parcelRequire("kkqqt");

var $8nsA4 = parcelRequire("8nsA4");

var $7Gasr = parcelRequire("7Gasr");
var $6DLsq = parcelRequire("6DLsq");

var $3WrnC = parcelRequire("3WrnC");

var $2fy4s = parcelRequire("2fy4s");
parcelRequire("25PiQ");
var $hpTaI = parcelRequire("hpTaI");
var $kGjpT = parcelRequire("kGjpT");

var $8wnFv = parcelRequire("8wnFv");
parcelRequire("7Ft2D");
var $ewlTP = parcelRequire("ewlTP");

var $4BEBs = parcelRequire("4BEBs");

var $bMQws = parcelRequire("bMQws");
parcelRequire("9YSHu");
var $3W2Mc = parcelRequire("3W2Mc");
var $5lf06 = parcelRequire("5lf06");

var $gCTEP = parcelRequire("gCTEP");

var $7NEHj = parcelRequire("7NEHj");
function $4bb3863dfa1867a4$var$us(o, e) {
    if (o.length >= 255) throw new TypeError("Alphabet too long");
    for(var t = new Uint8Array(256), s = 0; s < t.length; s++)t[s] = 255;
    for(var i = 0; i < o.length; i++){
        var r = o.charAt(i), n = r.charCodeAt(0);
        if (t[n] !== 255) throw new TypeError(r + " is ambiguous");
        t[n] = i;
    }
    var a = o.length, h = o.charAt(0), c = Math.log(a) / Math.log(256), d = Math.log(256) / Math.log(a);
    function g(l) {
        if (l instanceof Uint8Array || (ArrayBuffer.isView(l) ? l = new Uint8Array(l.buffer, l.byteOffset, l.byteLength) : Array.isArray(l) && (l = Uint8Array.from(l))), !(l instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (l.length === 0) return "";
        for(var p = 0, _ = 0, D = 0, E = l.length; D !== E && l[D] === 0;)D++, p++;
        for(var N = (E - D) * d + 1 >>> 0, T = new Uint8Array(N); D !== E;){
            for(var z = l[D], U = 0, x = N - 1; (z !== 0 || U < _) && x !== -1; x--, U++)z += 256 * T[x] >>> 0, T[x] = z % a >>> 0, z = z / a >>> 0;
            if (z !== 0) throw new Error("Non-zero carry");
            _ = U, D++;
        }
        for(var $ = N - _; $ !== N && T[$] === 0;)$++;
        for(var Q = h.repeat(p); $ < N; ++$)Q += o.charAt(T[$]);
        return Q;
    }
    function b(l) {
        if (typeof l != "string") throw new TypeError("Expected String");
        if (l.length === 0) return new Uint8Array;
        var p = 0;
        if (l[p] !== " ") {
            for(var _ = 0, D = 0; l[p] === h;)_++, p++;
            for(var E = (l.length - p) * c + 1 >>> 0, N = new Uint8Array(E); l[p];){
                var T = t[l.charCodeAt(p)];
                if (T === 255) return;
                for(var z = 0, U = E - 1; (T !== 0 || z < D) && U !== -1; U--, z++)T += a * N[U] >>> 0, N[U] = T % 256 >>> 0, T = T / 256 >>> 0;
                if (T !== 0) throw new Error("Non-zero carry");
                D = z, p++;
            }
            if (l[p] !== " ") {
                for(var x = E - D; x !== E && N[x] === 0;)x++;
                for(var $ = new Uint8Array(_ + (E - x)), Q = _; x !== E;)$[Q++] = N[x++];
                return $;
            }
        }
    }
    function m(l) {
        var p = b(l);
        if (p) return p;
        throw new Error("Non-".concat(e, " character"));
    }
    return {
        encode: g,
        decodeUnsafe: b,
        decode: m
    };
}
var $4bb3863dfa1867a4$var$ds = $4bb3863dfa1867a4$var$us, $4bb3863dfa1867a4$var$gs = $4bb3863dfa1867a4$var$ds;
var $4bb3863dfa1867a4$var$Ve = function(o) {
    if (o instanceof Uint8Array && o.constructor.name === "Uint8Array") return o;
    if (o instanceof ArrayBuffer) return new Uint8Array(o);
    if (ArrayBuffer.isView(o)) return new Uint8Array(o.buffer, o.byteOffset, o.byteLength);
    throw new Error("Unknown type, must be binary type");
}, $4bb3863dfa1867a4$var$ps = function(o) {
    return new TextEncoder().encode(o);
}, $4bb3863dfa1867a4$var$ys = function(o) {
    return new TextDecoder().decode(o);
};
var $4bb3863dfa1867a4$var$Ds = /*#__PURE__*/ function() {
    "use strict";
    function Ds(e, t, s) {
        (0, $4GJKx._)(this, Ds);
        this.name = e, this.prefix = t, this.baseEncode = s;
    }
    (0, $1wc17._)(Ds, [
        {
            key: "encode",
            value: function encode(e) {
                if (e instanceof Uint8Array) return "".concat(this.prefix).concat(this.baseEncode(e));
                throw Error("Unknown type, must be binary type");
            }
        }
    ]);
    return Ds;
}();
var $4bb3863dfa1867a4$var$bs = /*#__PURE__*/ function() {
    "use strict";
    function bs(e, t, s) {
        (0, $4GJKx._)(this, bs);
        if (this.name = e, this.prefix = t, t.codePointAt(0) === void 0) throw new Error("Invalid prefix character");
        this.prefixCodePoint = t.codePointAt(0), this.baseDecode = s;
    }
    (0, $1wc17._)(bs, [
        {
            key: "decode",
            value: function decode(e) {
                if (typeof e == "string") {
                    if (e.codePointAt(0) !== this.prefixCodePoint) throw Error("Unable to decode multibase string ".concat(JSON.stringify(e), ", ").concat(this.name, " decoder only supports inputs prefixed with ").concat(this.prefix));
                    return this.baseDecode(e.slice(this.prefix.length));
                } else throw Error("Can only multibase decode strings");
            }
        },
        {
            key: "or",
            value: function or(e) {
                return $4bb3863dfa1867a4$var$je(this, e);
            }
        }
    ]);
    return bs;
}();
var $4bb3863dfa1867a4$var$ms = /*#__PURE__*/ function() {
    "use strict";
    function ms(e) {
        (0, $4GJKx._)(this, ms);
        this.decoders = e;
    }
    (0, $1wc17._)(ms, [
        {
            key: "or",
            value: function or(e) {
                return $4bb3863dfa1867a4$var$je(this, e);
            }
        },
        {
            key: "decode",
            value: function decode(e) {
                var t = e[0], s = this.decoders[t];
                if (s) return s.decode(e);
                throw RangeError("Unable to decode multibase string ".concat(JSON.stringify(e), ", only inputs prefixed with ").concat(Object.keys(this.decoders), " are supported"));
            }
        }
    ]);
    return ms;
}();
var $4bb3863dfa1867a4$var$je = function(o, e) {
    return new $4bb3863dfa1867a4$var$ms((0, $do9pw._)({}, o.decoders || (0, $3sHb8._)({}, o.prefix, o), e.decoders || (0, $3sHb8._)({}, e.prefix, e)));
};
var $4bb3863dfa1867a4$var$fs = /*#__PURE__*/ function() {
    "use strict";
    function fs(e, t, s, i) {
        (0, $4GJKx._)(this, fs);
        this.name = e, this.prefix = t, this.baseEncode = s, this.baseDecode = i, this.encoder = new $4bb3863dfa1867a4$var$Ds(e, t, s), this.decoder = new $4bb3863dfa1867a4$var$bs(e, t, i);
    }
    (0, $1wc17._)(fs, [
        {
            key: "encode",
            value: function encode(e) {
                return this.encoder.encode(e);
            }
        },
        {
            key: "decode",
            value: function decode(e) {
                return this.decoder.decode(e);
            }
        }
    ]);
    return fs;
}();
var $4bb3863dfa1867a4$var$re = function(param) {
    var o = param.name, e = param.prefix, t = param.encode, s = param.decode;
    return new $4bb3863dfa1867a4$var$fs(o, e, t, s);
}, $4bb3863dfa1867a4$var$Y = function(param) {
    var o = param.prefix, e = param.name, t = param.alphabet;
    var _gs = $4bb3863dfa1867a4$var$gs(t, e), s = _gs.encode, i = _gs.decode;
    return $4bb3863dfa1867a4$var$re({
        prefix: o,
        name: e,
        encode: s,
        decode: function(r) {
            return $4bb3863dfa1867a4$var$Ve(i(r));
        }
    });
}, $4bb3863dfa1867a4$var$_s = function(o, e, t, s) {
    var i = {};
    for(var d = 0; d < e.length; ++d)i[e[d]] = d;
    var r = o.length;
    for(; o[r - 1] === "=";)--r;
    var n = new Uint8Array(r * t / 8 | 0);
    var a = 0, h = 0, c = 0;
    for(var d1 = 0; d1 < r; ++d1){
        var g = i[o[d1]];
        if (g === void 0) throw new SyntaxError("Non-".concat(s, " character"));
        h = h << t | g, a += t, a >= 8 && (a -= 8, n[c++] = 255 & h >> a);
    }
    if (a >= t || 255 & h << 8 - a) throw new SyntaxError("Unexpected end of data");
    return n;
}, $4bb3863dfa1867a4$var$Es = function(o, e, t) {
    var s = e[e.length - 1] === "=", i = (1 << t) - 1;
    var r = "", n = 0, a = 0;
    for(var h = 0; h < o.length; ++h)for(a = a << 8 | o[h], n += 8; n > t;)n -= t, r += e[i & a >> n];
    if (n && (r += e[i & a << t - n]), s) for(; r.length * t & 7;)r += "=";
    return r;
}, $4bb3863dfa1867a4$var$f = function(param) {
    var o = param.name, e = param.prefix, t = param.bitsPerChar, s = param.alphabet;
    return $4bb3863dfa1867a4$var$re({
        prefix: e,
        name: o,
        encode: function(i) {
            return $4bb3863dfa1867a4$var$Es(i, s, t);
        },
        decode: function(i) {
            return $4bb3863dfa1867a4$var$_s(i, s, t, o);
        }
    });
}, $4bb3863dfa1867a4$var$vs = $4bb3863dfa1867a4$var$re({
    prefix: "\0",
    name: "identity",
    encode: function(o) {
        return $4bb3863dfa1867a4$var$ys(o);
    },
    decode: function(o) {
        return $4bb3863dfa1867a4$var$ps(o);
    }
});
var $4bb3863dfa1867a4$var$ws = Object.freeze({
    __proto__: null,
    identity: $4bb3863dfa1867a4$var$vs
});
var $4bb3863dfa1867a4$var$Is = $4bb3863dfa1867a4$var$f({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});
var $4bb3863dfa1867a4$var$Ts = Object.freeze({
    __proto__: null,
    base2: $4bb3863dfa1867a4$var$Is
});
var $4bb3863dfa1867a4$var$Cs = $4bb3863dfa1867a4$var$f({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});
var $4bb3863dfa1867a4$var$Ss = Object.freeze({
    __proto__: null,
    base8: $4bb3863dfa1867a4$var$Cs
});
var $4bb3863dfa1867a4$var$Ps = $4bb3863dfa1867a4$var$Y({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});
var $4bb3863dfa1867a4$var$Rs = Object.freeze({
    __proto__: null,
    base10: $4bb3863dfa1867a4$var$Ps
});
var $4bb3863dfa1867a4$var$xs = $4bb3863dfa1867a4$var$f({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
}), $4bb3863dfa1867a4$var$Os = $4bb3863dfa1867a4$var$f({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});
var $4bb3863dfa1867a4$var$As = Object.freeze({
    __proto__: null,
    base16: $4bb3863dfa1867a4$var$xs,
    base16upper: $4bb3863dfa1867a4$var$Os
});
var $4bb3863dfa1867a4$var$Ns = $4bb3863dfa1867a4$var$f({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
}), $4bb3863dfa1867a4$var$zs = $4bb3863dfa1867a4$var$f({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
}), $4bb3863dfa1867a4$var$Ls = $4bb3863dfa1867a4$var$f({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
}), $4bb3863dfa1867a4$var$$s = $4bb3863dfa1867a4$var$f({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
}), $4bb3863dfa1867a4$var$Fs = $4bb3863dfa1867a4$var$f({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
}), $4bb3863dfa1867a4$var$Us = $4bb3863dfa1867a4$var$f({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
}), $4bb3863dfa1867a4$var$Ks = $4bb3863dfa1867a4$var$f({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
}), $4bb3863dfa1867a4$var$Ms = $4bb3863dfa1867a4$var$f({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
}), $4bb3863dfa1867a4$var$ks = $4bb3863dfa1867a4$var$f({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});
var $4bb3863dfa1867a4$var$Bs = Object.freeze({
    __proto__: null,
    base32: $4bb3863dfa1867a4$var$Ns,
    base32upper: $4bb3863dfa1867a4$var$zs,
    base32pad: $4bb3863dfa1867a4$var$Ls,
    base32padupper: $4bb3863dfa1867a4$var$$s,
    base32hex: $4bb3863dfa1867a4$var$Fs,
    base32hexupper: $4bb3863dfa1867a4$var$Us,
    base32hexpad: $4bb3863dfa1867a4$var$Ks,
    base32hexpadupper: $4bb3863dfa1867a4$var$Ms,
    base32z: $4bb3863dfa1867a4$var$ks
});
var $4bb3863dfa1867a4$var$Vs = $4bb3863dfa1867a4$var$Y({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
}), $4bb3863dfa1867a4$var$js = $4bb3863dfa1867a4$var$Y({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});
var $4bb3863dfa1867a4$var$qs = Object.freeze({
    __proto__: null,
    base36: $4bb3863dfa1867a4$var$Vs,
    base36upper: $4bb3863dfa1867a4$var$js
});
var $4bb3863dfa1867a4$var$Gs = $4bb3863dfa1867a4$var$Y({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
}), $4bb3863dfa1867a4$var$Hs = $4bb3863dfa1867a4$var$Y({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});
var $4bb3863dfa1867a4$var$Ys = Object.freeze({
    __proto__: null,
    base58btc: $4bb3863dfa1867a4$var$Gs,
    base58flickr: $4bb3863dfa1867a4$var$Hs
});
var $4bb3863dfa1867a4$var$Js = $4bb3863dfa1867a4$var$f({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
}), $4bb3863dfa1867a4$var$Ws = $4bb3863dfa1867a4$var$f({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
}), $4bb3863dfa1867a4$var$Xs = $4bb3863dfa1867a4$var$f({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
}), $4bb3863dfa1867a4$var$Zs = $4bb3863dfa1867a4$var$f({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});
var $4bb3863dfa1867a4$var$Qs = Object.freeze({
    __proto__: null,
    base64: $4bb3863dfa1867a4$var$Js,
    base64pad: $4bb3863dfa1867a4$var$Ws,
    base64url: $4bb3863dfa1867a4$var$Xs,
    base64urlpad: $4bb3863dfa1867a4$var$Zs
});
var $4bb3863dfa1867a4$var$qe = Array.from("\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42"), $4bb3863dfa1867a4$var$er = $4bb3863dfa1867a4$var$qe.reduce(function(o, e, t) {
    return o[t] = e, o;
}, []), $4bb3863dfa1867a4$var$tr = $4bb3863dfa1867a4$var$qe.reduce(function(o, e, t) {
    return o[e.codePointAt(0)] = t, o;
}, []);
function $4bb3863dfa1867a4$var$ir(o) {
    return o.reduce(function(e, t) {
        return e += $4bb3863dfa1867a4$var$er[t], e;
    }, "");
}
function $4bb3863dfa1867a4$var$sr(o) {
    var e = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = o[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var t = _step.value;
            var s = $4bb3863dfa1867a4$var$tr[t.codePointAt(0)];
            if (s === void 0) throw new Error("Non-base256emoji character: ".concat(t));
            e.push(s);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return new Uint8Array(e);
}
var $4bb3863dfa1867a4$var$rr = $4bb3863dfa1867a4$var$re({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: $4bb3863dfa1867a4$var$ir,
    decode: $4bb3863dfa1867a4$var$sr
});
var $4bb3863dfa1867a4$var$nr = Object.freeze({
    __proto__: null,
    base256emoji: $4bb3863dfa1867a4$var$rr
}), $4bb3863dfa1867a4$var$or = $4bb3863dfa1867a4$var$He, $4bb3863dfa1867a4$var$Ge = 128, $4bb3863dfa1867a4$var$ar = 127, $4bb3863dfa1867a4$var$hr = ~$4bb3863dfa1867a4$var$ar, $4bb3863dfa1867a4$var$cr = Math.pow(2, 31);
function $4bb3863dfa1867a4$var$He(o, e, t) {
    e = e || [], t = t || 0;
    for(var s = t; o >= $4bb3863dfa1867a4$var$cr;)e[t++] = o & 255 | $4bb3863dfa1867a4$var$Ge, o /= 128;
    for(; o & $4bb3863dfa1867a4$var$hr;)e[t++] = o & 255 | $4bb3863dfa1867a4$var$Ge, o >>>= 7;
    return e[t] = o | 0, $4bb3863dfa1867a4$var$He.bytes = t - s + 1, e;
}
var $4bb3863dfa1867a4$var$lr = $4bb3863dfa1867a4$var$De, $4bb3863dfa1867a4$var$ur = 128, $4bb3863dfa1867a4$var$Ye = 127;
function $4bb3863dfa1867a4$var$De(o, s) {
    var t = 0, s = s || 0, i = 0, r = s, n, a = o.length;
    do {
        if (r >= a) throw $4bb3863dfa1867a4$var$De.bytes = 0, new RangeError("Could not decode varint");
        n = o[r++], t += i < 28 ? (n & $4bb3863dfa1867a4$var$Ye) << i : (n & $4bb3863dfa1867a4$var$Ye) * Math.pow(2, i), i += 7;
    }while (n >= $4bb3863dfa1867a4$var$ur);
    return $4bb3863dfa1867a4$var$De.bytes = r - s, t;
}
var $4bb3863dfa1867a4$var$dr = Math.pow(2, 7), $4bb3863dfa1867a4$var$gr = Math.pow(2, 14), $4bb3863dfa1867a4$var$pr = Math.pow(2, 21), $4bb3863dfa1867a4$var$yr = Math.pow(2, 28), $4bb3863dfa1867a4$var$Dr = Math.pow(2, 35), $4bb3863dfa1867a4$var$br = Math.pow(2, 42), $4bb3863dfa1867a4$var$mr = Math.pow(2, 49), $4bb3863dfa1867a4$var$fr = Math.pow(2, 56), $4bb3863dfa1867a4$var$_r = Math.pow(2, 63), $4bb3863dfa1867a4$var$Er = function Er(o) {
    return o < $4bb3863dfa1867a4$var$dr ? 1 : o < $4bb3863dfa1867a4$var$gr ? 2 : o < $4bb3863dfa1867a4$var$pr ? 3 : o < $4bb3863dfa1867a4$var$yr ? 4 : o < $4bb3863dfa1867a4$var$Dr ? 5 : o < $4bb3863dfa1867a4$var$br ? 6 : o < $4bb3863dfa1867a4$var$mr ? 7 : o < $4bb3863dfa1867a4$var$fr ? 8 : o < $4bb3863dfa1867a4$var$_r ? 9 : 10;
}, $4bb3863dfa1867a4$var$vr = {
    encode: $4bb3863dfa1867a4$var$or,
    decode: $4bb3863dfa1867a4$var$lr,
    encodingLength: $4bb3863dfa1867a4$var$Er
}, $4bb3863dfa1867a4$var$Je = $4bb3863dfa1867a4$var$vr;
var $4bb3863dfa1867a4$var$We = function(o, e) {
    var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    return $4bb3863dfa1867a4$var$Je.encode(o, e, t), e;
}, $4bb3863dfa1867a4$var$Xe = function(o) {
    return $4bb3863dfa1867a4$var$Je.encodingLength(o);
}, $4bb3863dfa1867a4$var$be = function(o, e) {
    var t = e.byteLength, s = $4bb3863dfa1867a4$var$Xe(o), i = s + $4bb3863dfa1867a4$var$Xe(t), r = new Uint8Array(i + t);
    return $4bb3863dfa1867a4$var$We(o, r, 0), $4bb3863dfa1867a4$var$We(t, r, s), r.set(e, i), new $4bb3863dfa1867a4$var$wr(o, t, e, r);
};
var $4bb3863dfa1867a4$var$wr = function wr(e, t, s, i) {
    "use strict";
    (0, $4GJKx._)(this, wr);
    this.code = e, this.size = t, this.digest = s, this.bytes = i;
};
var $4bb3863dfa1867a4$var$Ze = function(param) {
    var o = param.name, e = param.code, t = param.encode;
    return new $4bb3863dfa1867a4$var$Ir(o, e, t);
};
var $4bb3863dfa1867a4$var$Ir = /*#__PURE__*/ function() {
    "use strict";
    function Ir(e, t, s) {
        (0, $4GJKx._)(this, Ir);
        this.name = e, this.code = t, this.encode = s;
    }
    (0, $1wc17._)(Ir, [
        {
            key: "digest",
            value: function digest(e) {
                var _this = this;
                if (e instanceof Uint8Array) {
                    var t = this.encode(e);
                    return t instanceof Uint8Array ? $4bb3863dfa1867a4$var$be(this.code, t) : t.then(function(s) {
                        return $4bb3863dfa1867a4$var$be(_this.code, s);
                    });
                } else throw Error("Unknown type, must be binary type");
            }
        }
    ]);
    return Ir;
}();
var $4bb3863dfa1867a4$var$Qe = function(o) {
    return function() {
        var _ref = (0, $kSuI9._)(function(e) {
            var _;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ = Uint8Array.bind;
                        return [
                            4,
                            crypto.subtle.digest(o, e)
                        ];
                    case 1:
                        return [
                            2,
                            new (_.apply(Uint8Array, [
                                void 0,
                                _state.sent()
                            ]))
                        ];
                }
            });
        });
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }();
}, $4bb3863dfa1867a4$var$Tr = $4bb3863dfa1867a4$var$Ze({
    name: "sha2-256",
    code: 18,
    encode: $4bb3863dfa1867a4$var$Qe("SHA-256")
}), $4bb3863dfa1867a4$var$Cr = $4bb3863dfa1867a4$var$Ze({
    name: "sha2-512",
    code: 19,
    encode: $4bb3863dfa1867a4$var$Qe("SHA-512")
});
var $4bb3863dfa1867a4$var$Sr = Object.freeze({
    __proto__: null,
    sha256: $4bb3863dfa1867a4$var$Tr,
    sha512: $4bb3863dfa1867a4$var$Cr
});
var $4bb3863dfa1867a4$var$et = 0, $4bb3863dfa1867a4$var$Pr = "identity", $4bb3863dfa1867a4$var$tt = $4bb3863dfa1867a4$var$Ve, $4bb3863dfa1867a4$var$Rr = function(o) {
    return $4bb3863dfa1867a4$var$be($4bb3863dfa1867a4$var$et, $4bb3863dfa1867a4$var$tt(o));
}, $4bb3863dfa1867a4$var$xr = {
    code: $4bb3863dfa1867a4$var$et,
    name: $4bb3863dfa1867a4$var$Pr,
    encode: $4bb3863dfa1867a4$var$tt,
    digest: $4bb3863dfa1867a4$var$Rr
};
var $4bb3863dfa1867a4$var$Or = Object.freeze({
    __proto__: null,
    identity: $4bb3863dfa1867a4$var$xr
});
new TextEncoder, new TextDecoder;
var $4bb3863dfa1867a4$var$it = (0, $do9pw._)({}, $4bb3863dfa1867a4$var$ws, $4bb3863dfa1867a4$var$Ts, $4bb3863dfa1867a4$var$Ss, $4bb3863dfa1867a4$var$Rs, $4bb3863dfa1867a4$var$As, $4bb3863dfa1867a4$var$Bs, $4bb3863dfa1867a4$var$qs, $4bb3863dfa1867a4$var$Ys, $4bb3863dfa1867a4$var$Qs, $4bb3863dfa1867a4$var$nr);
(0, $do9pw._)({}, $4bb3863dfa1867a4$var$Sr, $4bb3863dfa1867a4$var$Or);
function $4bb3863dfa1867a4$var$Ar() {
    var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null ? globalThis.Buffer.allocUnsafe(o) : new Uint8Array(o);
}
function $4bb3863dfa1867a4$var$st(o, e, t, s) {
    return {
        name: o,
        prefix: e,
        encoder: {
            name: o,
            prefix: e,
            encode: t
        },
        decoder: {
            decode: s
        }
    };
}
var $4bb3863dfa1867a4$var$rt = $4bb3863dfa1867a4$var$st("utf8", "u", function(o) {
    return "u" + new TextDecoder("utf8").decode(o);
}, function(o) {
    return new TextEncoder().encode(o.substring(1));
}), $4bb3863dfa1867a4$var$me = $4bb3863dfa1867a4$var$st("ascii", "a", function(o) {
    var e = "a";
    for(var t = 0; t < o.length; t++)e += String.fromCharCode(o[t]);
    return e;
}, function(o) {
    o = o.substring(1);
    var e = $4bb3863dfa1867a4$var$Ar(o.length);
    for(var t = 0; t < o.length; t++)e[t] = o.charCodeAt(t);
    return e;
}), $4bb3863dfa1867a4$var$Nr = (0, $do9pw._)({
    utf8: $4bb3863dfa1867a4$var$rt,
    "utf-8": $4bb3863dfa1867a4$var$rt,
    hex: $4bb3863dfa1867a4$var$it.base16,
    latin1: $4bb3863dfa1867a4$var$me,
    ascii: $4bb3863dfa1867a4$var$me,
    binary: $4bb3863dfa1867a4$var$me
}, $4bb3863dfa1867a4$var$it);
function $4bb3863dfa1867a4$var$zr(o) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "utf8";
    var t = $4bb3863dfa1867a4$var$Nr[e];
    if (!t) throw new Error('Unsupported encoding "'.concat(e, '"'));
    return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? globalThis.Buffer.from(o, "utf8") : t.decoder.decode("".concat(t.prefix).concat(o));
}
var $4bb3863dfa1867a4$export$51b1c900ac262bdf = "wc", $4bb3863dfa1867a4$export$f30bd3c8747cdfbe = 2, $4bb3863dfa1867a4$export$d47601f9de5ee22b = "core", $4bb3863dfa1867a4$export$f258d29ae5e3d545 = "".concat($4bb3863dfa1867a4$export$51b1c900ac262bdf, "@2:").concat($4bb3863dfa1867a4$export$d47601f9de5ee22b, ":"), $4bb3863dfa1867a4$export$db0fdb6d486555c2 = {
    name: $4bb3863dfa1867a4$export$d47601f9de5ee22b,
    logger: "error"
}, $4bb3863dfa1867a4$export$ba920abfe854b85d = {
    database: ":memory:"
}, $4bb3863dfa1867a4$export$92a79f21481c803d = "crypto", $4bb3863dfa1867a4$export$3613aa6e652146e4 = "client_ed25519_seed", $4bb3863dfa1867a4$export$c4bc5e31a4d0ec78 = (0, $4BEBs.ONE_DAY), $4bb3863dfa1867a4$export$9d7218f72e8dc49b = "keychain", $4bb3863dfa1867a4$export$34f82f4ba0c3d769 = "0.3", $4bb3863dfa1867a4$export$9662bbc7d10cf481 = "messages", $4bb3863dfa1867a4$export$19dfd1896412c038 = "0.3", $4bb3863dfa1867a4$export$8ddbe6611b67d926 = (0, $4BEBs.SIX_HOURS), $4bb3863dfa1867a4$export$9d92662178f2abd1 = "publisher", $4bb3863dfa1867a4$export$822d0bd1635d5360 = "irn", $4bb3863dfa1867a4$export$5176ffa6778d6637 = "error", $4bb3863dfa1867a4$export$a68061e6c48f332a = "wss://relay.walletconnect.org", $4bb3863dfa1867a4$export$602d6e27611c3fcb = "relayer", $4bb3863dfa1867a4$export$d56245796e2837d = {
    message: "relayer_message",
    message_ack: "relayer_message_ack",
    connect: "relayer_connect",
    disconnect: "relayer_disconnect",
    error: "relayer_error",
    connection_stalled: "relayer_connection_stalled",
    transport_closed: "relayer_transport_closed",
    publish: "relayer_publish"
}, $4bb3863dfa1867a4$export$119b4645f6b233c8 = "_subscription", $4bb3863dfa1867a4$export$58062acf2f31ddf8 = {
    payload: "payload",
    connect: "connect",
    disconnect: "disconnect",
    error: "error"
}, $4bb3863dfa1867a4$export$11ccd39be2c57d6 = .1, $4bb3863dfa1867a4$export$44b621f74f0f4c93 = {
    database: ":memory:"
}, $4bb3863dfa1867a4$export$5f30917a6f8c9025 = "2.15.2", $4bb3863dfa1867a4$export$fb3eab7adf12329d = 1e4, $4bb3863dfa1867a4$export$629a342182ba24b = "0.3", $4bb3863dfa1867a4$export$9e4ca561755938da = "WALLETCONNECT_CLIENT_ID", $4bb3863dfa1867a4$export$24ff3e54e94ef413 = {
    created: "subscription_created",
    deleted: "subscription_deleted",
    expired: "subscription_expired",
    disabled: "subscription_disabled",
    sync: "subscription_sync",
    resubscribed: "subscription_resubscribed"
}, $4bb3863dfa1867a4$export$9d35d0a6a3599be = (0, $4BEBs.THIRTY_DAYS), $4bb3863dfa1867a4$export$9c3a96bb670cddb8 = "subscription", $4bb3863dfa1867a4$export$fb57e03bef4c4cea = "0.3", $4bb3863dfa1867a4$export$9a2ddbfe54f8af77 = (0, $4BEBs.FIVE_SECONDS) * 1e3, $4bb3863dfa1867a4$export$390360ea476c6145 = "pairing", $4bb3863dfa1867a4$export$5593ec74b27d1b18 = "0.3", $4bb3863dfa1867a4$export$ee4b1978d0aedfad = (0, $4BEBs.THIRTY_DAYS), $4bb3863dfa1867a4$export$d94d6986a8185883 = {
    wc_pairingDelete: {
        req: {
            ttl: (0, $4BEBs.ONE_DAY),
            prompt: !1,
            tag: 1e3
        },
        res: {
            ttl: (0, $4BEBs.ONE_DAY),
            prompt: !1,
            tag: 1001
        }
    },
    wc_pairingPing: {
        req: {
            ttl: (0, $4BEBs.THIRTY_SECONDS),
            prompt: !1,
            tag: 1002
        },
        res: {
            ttl: (0, $4BEBs.THIRTY_SECONDS),
            prompt: !1,
            tag: 1003
        }
    },
    unregistered_method: {
        req: {
            ttl: (0, $4BEBs.ONE_DAY),
            prompt: !1,
            tag: 0
        },
        res: {
            ttl: (0, $4BEBs.ONE_DAY),
            prompt: !1,
            tag: 0
        }
    }
}, $4bb3863dfa1867a4$export$ca3c0b962acf7b75 = {
    create: "pairing_create",
    expire: "pairing_expire",
    delete: "pairing_delete",
    ping: "pairing_ping"
}, $4bb3863dfa1867a4$export$a682338b5ffca937 = {
    created: "history_created",
    updated: "history_updated",
    deleted: "history_deleted",
    sync: "history_sync"
}, $4bb3863dfa1867a4$export$160142c73cb99dc3 = "history", $4bb3863dfa1867a4$export$8eba9ce85616c607 = "0.3", $4bb3863dfa1867a4$export$4ddf883392bbc828 = "expirer", $4bb3863dfa1867a4$export$9013719d9206b0c1 = {
    created: "expirer_created",
    deleted: "expirer_deleted",
    expired: "expirer_expired",
    sync: "expirer_sync"
}, $4bb3863dfa1867a4$export$717295846191925d = "0.3", $4bb3863dfa1867a4$export$3cfe73d6765db74 = (0, $4BEBs.ONE_DAY), $4bb3863dfa1867a4$export$3b58f2450f2297e3 = "verify-api", $4bb3863dfa1867a4$var$Kr = "https://verify.walletconnect.com", $4bb3863dfa1867a4$var$Nt = "https://verify.walletconnect.org", $4bb3863dfa1867a4$export$7e3b1a28ddecdbaa = $4bb3863dfa1867a4$var$Nt, $4bb3863dfa1867a4$export$412739528655ee2f = "".concat($4bb3863dfa1867a4$export$7e3b1a28ddecdbaa, "/v3"), $4bb3863dfa1867a4$export$be24df03c4baa778 = [
    $4bb3863dfa1867a4$var$Kr,
    $4bb3863dfa1867a4$var$Nt
], $4bb3863dfa1867a4$export$40c022d2cffe0adc = "echo", $4bb3863dfa1867a4$export$3c48c4faab79aab1 = "https://echo.walletconnect.com", $4bb3863dfa1867a4$export$2f94b15ed52f7de9 = "event-client", $4bb3863dfa1867a4$export$6736f9bb609b5d34 = {
    pairing_started: "pairing_started",
    pairing_uri_validation_success: "pairing_uri_validation_success",
    pairing_uri_not_expired: "pairing_uri_not_expired",
    store_new_pairing: "store_new_pairing",
    subscribing_pairing_topic: "subscribing_pairing_topic",
    subscribe_pairing_topic_success: "subscribe_pairing_topic_success",
    existing_pairing: "existing_pairing",
    pairing_not_expired: "pairing_not_expired",
    emit_inactive_pairing: "emit_inactive_pairing",
    emit_session_proposal: "emit_session_proposal",
    subscribing_to_pairing_topic: "subscribing_to_pairing_topic"
}, $4bb3863dfa1867a4$export$e1dc85b7b7495247 = {
    no_wss_connection: "no_wss_connection",
    no_internet_connection: "no_internet_connection",
    malformed_pairing_uri: "malformed_pairing_uri",
    active_pairing_already_exists: "active_pairing_already_exists",
    subscribe_pairing_topic_failure: "subscribe_pairing_topic_failure",
    pairing_expired: "pairing_expired",
    proposal_expired: "proposal_expired",
    proposal_listener_not_found: "proposal_listener_not_found"
}, $4bb3863dfa1867a4$export$16ed3f27a411eba0 = {
    session_approve_started: "session_approve_started",
    proposal_not_expired: "proposal_not_expired",
    session_namespaces_validation_success: "session_namespaces_validation_success",
    create_session_topic: "create_session_topic",
    subscribing_session_topic: "subscribing_session_topic",
    subscribe_session_topic_success: "subscribe_session_topic_success",
    publishing_session_approve: "publishing_session_approve",
    session_approve_publish_success: "session_approve_publish_success",
    store_session: "store_session",
    publishing_session_settle: "publishing_session_settle",
    session_settle_publish_success: "session_settle_publish_success"
}, $4bb3863dfa1867a4$export$bc50109885e83402 = {
    no_internet_connection: "no_internet_connection",
    no_wss_connection: "no_wss_connection",
    proposal_expired: "proposal_expired",
    subscribe_session_topic_failure: "subscribe_session_topic_failure",
    session_approve_publish_failure: "session_approve_publish_failure",
    session_settle_publish_failure: "session_settle_publish_failure",
    session_approve_namespace_validation_failure: "session_approve_namespace_validation_failure",
    proposal_not_found: "proposal_not_found"
}, $4bb3863dfa1867a4$export$6540f02663742dde = {
    authenticated_session_approve_started: "authenticated_session_approve_started",
    authenticated_session_not_expired: "authenticated_session_not_expired",
    chains_caip2_compliant: "chains_caip2_compliant",
    chains_evm_compliant: "chains_evm_compliant",
    create_authenticated_session_topic: "create_authenticated_session_topic",
    cacaos_verified: "cacaos_verified",
    store_authenticated_session: "store_authenticated_session",
    subscribing_authenticated_session_topic: "subscribing_authenticated_session_topic",
    subscribe_authenticated_session_topic_success: "subscribe_authenticated_session_topic_success",
    publishing_authenticated_session_approve: "publishing_authenticated_session_approve",
    authenticated_session_approve_publish_success: "authenticated_session_approve_publish_success"
}, $4bb3863dfa1867a4$export$aca4f34441e6cd3a = {
    no_internet_connection: "no_internet_connection",
    no_wss_connection: "no_wss_connection",
    missing_session_authenticate_request: "missing_session_authenticate_request",
    session_authenticate_request_expired: "session_authenticate_request_expired",
    chains_caip2_compliant_failure: "chains_caip2_compliant_failure",
    chains_evm_compliant_failure: "chains_evm_compliant_failure",
    invalid_cacao: "invalid_cacao",
    subscribe_authenticated_session_topic_failure: "subscribe_authenticated_session_topic_failure",
    authenticated_session_approve_publish_failure: "authenticated_session_approve_publish_failure",
    authenticated_session_pending_request_not_found: "authenticated_session_pending_request_not_found"
}, $4bb3863dfa1867a4$export$c73857c3a3d16b1c = .1, $4bb3863dfa1867a4$export$e020229e09910965 = "event-client", $4bb3863dfa1867a4$export$79348045429687e2 = 86400, $4bb3863dfa1867a4$export$bb6a8925f3cb1ca = "https://pulse.walletconnect.com/batch";
var $4bb3863dfa1867a4$export$dd4508d2540f08d3 = /*#__PURE__*/ function() {
    "use strict";
    function Bt(e, t) {
        var _this = this;
        (0, $4GJKx._)(this, Bt);
        var _this1 = this;
        var _this2 = this;
        var _this3 = this;
        this.core = e, this.logger = t, this.keychain = new Map, this.name = $4bb3863dfa1867a4$export$9d7218f72e8dc49b, this.version = $4bb3863dfa1867a4$export$34f82f4ba0c3d769, this.initialized = !1, this.storagePrefix = $4bb3863dfa1867a4$export$f258d29ae5e3d545, this.init = /*#__PURE__*/ (0, $kSuI9._)(function() {
            var s;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!_this1.initialized) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            _this1.getKeyChain()
                        ];
                    case 1:
                        s = _state.sent();
                        (typeof s === "undefined" ? "undefined" : (0, $l0HdX._)(s)) < "u" && (_this1.keychain = s), _this1.initialized = !0;
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        }), this.has = function(s) {
            return _this.isInitialized(), _this.keychain.has(s);
        }, this.set = function() {
            var _ref = (0, $kSuI9._)(function(s, i) {
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this2.isInitialized(), _this2.keychain.set(s, i);
                            return [
                                4,
                                _this2.persist()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(s, i) {
                return _ref.apply(this, arguments);
            };
        }(), this.get = function(s) {
            _this.isInitialized();
            var i = _this.keychain.get(s);
            if ((typeof i === "undefined" ? "undefined" : (0, $l0HdX._)(i)) > "u") {
                var _u = (0, $8wnFv.getInternalError)("NO_MATCHING_KEY", "".concat(_this.name, ": ").concat(s)), r = _u.message;
                throw new Error(r);
            }
            return i;
        }, this.del = function() {
            var _ref = (0, $kSuI9._)(function(s) {
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this3.isInitialized(), _this3.keychain.delete(s);
                            return [
                                4,
                                _this3.persist()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(s) {
                return _ref.apply(this, arguments);
            };
        }(), this.core = e, this.logger = (0, $7Gasr.generateChildLogger)(t, this.name);
    }
    (0, $1wc17._)(Bt, [
        {
            key: "context",
            get: function get() {
                return (0, $7Gasr.getLoggerContext)(this.logger);
            }
        },
        {
            key: "storageKey",
            get: function get() {
                return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
            }
        },
        {
            key: "setKeyChain",
            value: function setKeyChain(e) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.core.storage.setItem(_this.storageKey, (0, $8wnFv.mapToObj)(e))
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getKeyChain",
            value: function getKeyChain() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.core.storage.getItem(_this.storageKey)
                                ];
                            case 1:
                                e = _state.sent();
                                return [
                                    2,
                                    (typeof e === "undefined" ? "undefined" : (0, $l0HdX._)(e)) < "u" ? (0, $8wnFv.objToMap)(e) : void 0
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "persist",
            value: function persist() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.setKeyChain(_this.keychain)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "isInitialized",
            value: function isInitialized() {
                if (!this.initialized) {
                    var _u = (0, $8wnFv.getInternalError)("NOT_INITIALIZED", this.name), e = _u.message;
                    throw new Error(e);
                }
            }
        }
    ]);
    return Bt;
}();
var $4bb3863dfa1867a4$export$8ac8b6291b7ccf24 = /*#__PURE__*/ function() {
    "use strict";
    function Vt(e, t, s) {
        var _this = this;
        (0, $4GJKx._)(this, Vt);
        var _this1 = this;
        var _this2 = this;
        var _this3 = this;
        var _this4 = this;
        var _this5 = this;
        var _this6 = this;
        var _this7 = this;
        var _this8 = this;
        this.core = e, this.logger = t, this.name = $4bb3863dfa1867a4$export$92a79f21481c803d, this.randomSessionIdentifier = (0, $8wnFv.generateRandomBytes32)(), this.initialized = !1, this.init = /*#__PURE__*/ (0, $kSuI9._)(function() {
            var _tmp;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = _this1.initialized;
                        if (_tmp) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            _this1.keychain.init()
                        ];
                    case 1:
                        _tmp = (_state.sent(), _this1.initialized = !0);
                        _state.label = 2;
                    case 2:
                        _tmp;
                        return [
                            2
                        ];
                }
            });
        }), this.hasKeys = function(i) {
            return _this.isInitialized(), _this.keychain.has(i);
        }, this.getClientId = /*#__PURE__*/ (0, $kSuI9._)(function() {
            var i, r;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this2.isInitialized();
                        return [
                            4,
                            _this2.getClientSeed()
                        ];
                    case 1:
                        i = _state.sent(), r = $hpTaI.generateKeyPair(i);
                        return [
                            2,
                            $kGjpT.encodeIss(r.publicKey)
                        ];
                }
            });
        }), this.generateKeyPair = function() {
            _this.isInitialized();
            var i = (0, $8wnFv.generateKeyPair)();
            return _this.setPrivateKey(i.publicKey, i.privateKey);
        }, this.signJWT = function() {
            var _ref = (0, $kSuI9._)(function(i) {
                var r, n, a, h;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this3.isInitialized();
                            return [
                                4,
                                _this3.getClientSeed()
                            ];
                        case 1:
                            r = _state.sent(), n = $hpTaI.generateKeyPair(r), a = _this3.randomSessionIdentifier, h = $4bb3863dfa1867a4$export$c4bc5e31a4d0ec78;
                            return [
                                4,
                                $hpTaI.signJWT(a, i, h, n)
                            ];
                        case 2:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(i) {
                return _ref.apply(this, arguments);
            };
        }(), this.generateSharedKey = function(i, r, n) {
            _this.isInitialized();
            var a = _this.getPrivateKey(i), h = (0, $8wnFv.deriveSymKey)(a, r);
            return _this.setSymKey(h, n);
        }, this.setSymKey = function() {
            var _ref = (0, $kSuI9._)(function(i, r) {
                var n;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this4.isInitialized();
                            n = r || (0, $8wnFv.hashKey)(i);
                            return [
                                4,
                                _this4.keychain.set(n, i)
                            ];
                        case 1:
                            return [
                                2,
                                (_state.sent(), n)
                            ];
                    }
                });
            });
            return function(i, r) {
                return _ref.apply(this, arguments);
            };
        }(), this.deleteKeyPair = function() {
            var _ref = (0, $kSuI9._)(function(i) {
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this5.isInitialized();
                            return [
                                4,
                                _this5.keychain.del(i)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(i) {
                return _ref.apply(this, arguments);
            };
        }(), this.deleteSymKey = function() {
            var _ref = (0, $kSuI9._)(function(i) {
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this6.isInitialized();
                            return [
                                4,
                                _this6.keychain.del(i)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(i) {
                return _ref.apply(this, arguments);
            };
        }(), this.encode = function() {
            var _ref = (0, $kSuI9._)(function(i, r, n) {
                var a, h, b, m, c, d, g;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this7.isInitialized();
                            a = (0, $8wnFv.validateEncoding)(n), h = (0, $2fy4s.safeJsonStringify)(r);
                            if (!(0, $8wnFv.isTypeOneEnvelope)(a)) return [
                                3,
                                2
                            ];
                            b = a.senderPublicKey, m = a.receiverPublicKey;
                            return [
                                4,
                                _this7.generateSharedKey(b, m)
                            ];
                        case 1:
                            i = _state.sent();
                            _state.label = 2;
                        case 2:
                            c = _this7.getSymKey(i), d = a.type, g = a.senderPublicKey;
                            return [
                                2,
                                (0, $8wnFv.encrypt)({
                                    type: d,
                                    symKey: c,
                                    message: h,
                                    senderPublicKey: g
                                })
                            ];
                    }
                });
            });
            return function(i, r, n) {
                return _ref.apply(this, arguments);
            };
        }(), this.decode = function() {
            var _ref = (0, $kSuI9._)(function(i, r, n) {
                var a, _$h, c, _$h1, c1, h, _, _1, _2, _3;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this8.isInitialized();
                            a = (0, $8wnFv.validateDecoding)(r, n);
                            if (!(0, $8wnFv.isTypeOneEnvelope)(a)) return [
                                3,
                                2
                            ];
                            _$h = a.receiverPublicKey, c = a.senderPublicKey;
                            return [
                                4,
                                _this8.generateSharedKey(_$h, c)
                            ];
                        case 1:
                            i = _state.sent();
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                3,
                                ,
                                5
                            ]);
                            _$h1 = _this8.getSymKey(i), c1 = (0, $8wnFv.decrypt)({
                                symKey: _$h1,
                                encoded: r
                            });
                            return [
                                2,
                                (0, $2fy4s.safeJsonParse)(c1)
                            ];
                        case 3:
                            h = _state.sent();
                            _1 = (_ = _this8.logger).error;
                            _3 = (_2 = "Failed to decode message from topic: '".concat(i, "', clientId: '")).concat;
                            return [
                                4,
                                _this8.getClientId()
                            ];
                        case 4:
                            _1.apply(_, [
                                _3.apply(_2, [
                                    _state.sent(),
                                    "'"
                                ])
                            ]), _this8.logger.error(h);
                            return [
                                3,
                                5
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(i, r, n) {
                return _ref.apply(this, arguments);
            };
        }(), this.getPayloadType = function(i) {
            var r = (0, $8wnFv.deserialize)(i);
            return (0, $8wnFv.decodeTypeByte)(r.type);
        }, this.getPayloadSenderPublicKey = function(i) {
            var r = (0, $8wnFv.deserialize)(i);
            return r.senderPublicKey ? (0, $ewlTP.toString)(r.senderPublicKey, (0, $8wnFv.BASE16)) : void 0;
        }, this.core = e, this.logger = (0, $7Gasr.generateChildLogger)(t, this.name), this.keychain = s || new $4bb3863dfa1867a4$export$dd4508d2540f08d3(this.core, this.logger);
    }
    (0, $1wc17._)(Vt, [
        {
            key: "context",
            get: function get() {
                return (0, $7Gasr.getLoggerContext)(this.logger);
            }
        },
        {
            key: "setPrivateKey",
            value: function setPrivateKey(e, t) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.keychain.set(e, t)
                                ];
                            case 1:
                                return [
                                    2,
                                    (_state.sent(), e)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getPrivateKey",
            value: function getPrivateKey(e) {
                return this.keychain.get(e);
            }
        },
        {
            key: "getClientSeed",
            value: function getClientSeed() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var e, e1;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                e = "";
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    2,
                                    ,
                                    4
                                ]);
                                e = _this.keychain.get($4bb3863dfa1867a4$export$3613aa6e652146e4);
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                e1 = _state.sent();
                                e = (0, $8wnFv.generateRandomBytes32)();
                                return [
                                    4,
                                    _this.keychain.set($4bb3863dfa1867a4$export$3613aa6e652146e4, e)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2,
                                    $4bb3863dfa1867a4$var$zr(e, "base16")
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSymKey",
            value: function getSymKey(e) {
                return this.keychain.get(e);
            }
        },
        {
            key: "isInitialized",
            value: function isInitialized() {
                if (!this.initialized) {
                    var _u = (0, $8wnFv.getInternalError)("NOT_INITIALIZED", this.name), e = _u.message;
                    throw new Error(e);
                }
            }
        }
    ]);
    return Vt;
}();
var $4bb3863dfa1867a4$export$4a2542d0790ac2fd = /*#__PURE__*/ function(mi) {
    "use strict";
    (0, $dcsZi._)(jt, mi);
    var _super = (0, $ohfOJ._)(jt);
    function jt(e, t) {
        (0, $4GJKx._)(this, jt);
        var _this;
        var _this1 = (0, $d3H5E._)(_this);
        var _this2 = (0, $d3H5E._)(_this);
        var _this3 = (0, $d3H5E._)(_this);
        _this = _super.call(this, e, t), _this.logger = e, _this.core = t, _this.messages = new Map, _this.name = $4bb3863dfa1867a4$export$9662bbc7d10cf481, _this.version = $4bb3863dfa1867a4$export$19dfd1896412c038, _this.initialized = !1, _this.storagePrefix = $4bb3863dfa1867a4$export$f258d29ae5e3d545, _this.init = /*#__PURE__*/ (0, $kSuI9._)(function() {
            var _$s, s;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!_this1.initialized) return [
                            3,
                            5
                        ];
                        _this1.logger.trace("Initialized");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            _this1.getRelayerMessages()
                        ];
                    case 2:
                        _$s = _state.sent();
                        (typeof _$s === "undefined" ? "undefined" : (0, $l0HdX._)(_$s)) < "u" && (_this1.messages = _$s), _this1.logger.debug("Successfully Restored records for ".concat(_this1.name)), _this1.logger.trace({
                            type: "method",
                            method: "restore",
                            size: _this1.messages.size
                        });
                        return [
                            3,
                            5
                        ];
                    case 3:
                        s = _state.sent();
                        _this1.logger.debug("Failed to Restore records for ".concat(_this1.name)), _this1.logger.error(s);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        _this1.initialized = !0;
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        }), _this.set = function() {
            var _ref = (0, $kSuI9._)(function(s, i) {
                var r, n, _tmp;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this2.isInitialized();
                            r = (0, $8wnFv.hashMessage)(i);
                            n = _this2.messages.get(s);
                            (typeof n === "undefined" ? "undefined" : (0, $l0HdX._)(n)) > "u" && (n = {});
                            _tmp = (0, $l0HdX._)(n[r]) < "u";
                            if (_tmp) return [
                                3,
                                2
                            ];
                            n[r] = i, _this2.messages.set(s, n);
                            return [
                                4,
                                _this2.persist()
                            ];
                        case 1:
                            _tmp = _state.sent();
                            _state.label = 2;
                        case 2:
                            return [
                                2,
                                (_tmp, r)
                            ];
                    }
                });
            });
            return function(s, i) {
                return _ref.apply(this, arguments);
            };
        }(), _this.get = function(s) {
            _this.isInitialized();
            var i = _this.messages.get(s);
            return (typeof i === "undefined" ? "undefined" : (0, $l0HdX._)(i)) > "u" && (i = {}), i;
        }, _this.has = function(s, i) {
            _this.isInitialized();
            var r = _this.get(s), n = (0, $8wnFv.hashMessage)(i);
            return (0, $l0HdX._)(r[n]) < "u";
        }, _this.del = function() {
            var _ref = (0, $kSuI9._)(function(s) {
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this3.isInitialized(), _this3.messages.delete(s);
                            return [
                                4,
                                _this3.persist()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(s) {
                return _ref.apply(this, arguments);
            };
        }(), _this.logger = (0, $7Gasr.generateChildLogger)(e, _this.name), _this.core = t;
        return (0, $3U0IP._)(_this);
    }
    (0, $1wc17._)(jt, [
        {
            key: "context",
            get: function get() {
                return (0, $7Gasr.getLoggerContext)(this.logger);
            }
        },
        {
            key: "storageKey",
            get: function get() {
                return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
            }
        },
        {
            key: "setRelayerMessages",
            value: function setRelayerMessages(e) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.core.storage.setItem(_this.storageKey, (0, $8wnFv.mapToObj)(e))
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getRelayerMessages",
            value: function getRelayerMessages() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.core.storage.getItem(_this.storageKey)
                                ];
                            case 1:
                                e = _state.sent();
                                return [
                                    2,
                                    (typeof e === "undefined" ? "undefined" : (0, $l0HdX._)(e)) < "u" ? (0, $8wnFv.objToMap)(e) : void 0
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "persist",
            value: function persist() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.setRelayerMessages(_this.messages)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "isInitialized",
            value: function isInitialized() {
                if (!this.initialized) {
                    var _u = (0, $8wnFv.getInternalError)("NOT_INITIALIZED", this.name), e = _u.message;
                    throw new Error(e);
                }
            }
        }
    ]);
    return jt;
}((0, $3WrnC.IMessageTracker));
var $4bb3863dfa1867a4$var$qr = /*#__PURE__*/ function(fi) {
    "use strict";
    (0, $dcsZi._)(qr, fi);
    var _super = (0, $ohfOJ._)(qr);
    function qr(e, t) {
        (0, $4GJKx._)(this, qr);
        var _this;
        var _this1 = (0, $d3H5E._)(_this);
        _this = _super.call(this, e, t), _this.relayer = e, _this.logger = t, _this.events = new (0, $cyxGb.EventEmitter), _this.name = $4bb3863dfa1867a4$export$9d92662178f2abd1, _this.queue = new Map, _this.publishTimeout = (0, $4BEBs.toMiliseconds)((0, $4BEBs.ONE_MINUTE)), _this.failedPublishTimeout = (0, $4BEBs.toMiliseconds)((0, $4BEBs.ONE_SECOND)), _this.needsTransportRestart = !1, _this.publish = function() {
            var _ref = (0, $kSuI9._)(function(s, i, r) {
                var n, a, h, c, d, g, b, m, l, p, _, _tmp, D;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this1.logger.debug("Publishing Payload"), _this1.logger.trace({
                                type: "method",
                                method: "publish",
                                params: {
                                    topic: s,
                                    message: i,
                                    opts: r
                                }
                            });
                            a = (r === null || r === void 0 ? void 0 : r.ttl) || $4bb3863dfa1867a4$export$8ddbe6611b67d926, h = (0, $8wnFv.getRelayProtocolName)(r), c = (r === null || r === void 0 ? void 0 : r.prompt) || !1, d = (r === null || r === void 0 ? void 0 : r.tag) || 0, g = (r === null || r === void 0 ? void 0 : r.id) || (0, $3W2Mc.getBigIntRpcId)().toString(), b = {
                                topic: s,
                                message: i,
                                opts: {
                                    ttl: a,
                                    relay: h,
                                    prompt: c,
                                    tag: d,
                                    id: g,
                                    attestation: r === null || r === void 0 ? void 0 : r.attestation
                                }
                            }, m = "Failed to publish payload, please try again. id:".concat(g, " tag:").concat(d), l = Date.now();
                            _ = 1;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                9,
                                ,
                                10
                            ]);
                            _state.label = 2;
                        case 2:
                            if (!(p === void 0)) return [
                                3,
                                8
                            ];
                            if (Date.now() - l > _this1.publishTimeout) throw new Error(m);
                            _this1.logger.trace({
                                id: g,
                                attempts: _
                            }, "publisher.publish - attempt ".concat(_));
                            return [
                                4,
                                (0, $8wnFv.createExpiringPromise)(_this1.rpcPublish(s, i, a, h, c, d, g, r === null || r === void 0 ? void 0 : r.attestation).catch(function(D) {
                                    return _this1.logger.warn(D);
                                }), _this1.publishTimeout, m)
                            ];
                        case 3:
                            return [
                                4,
                                _state.sent()
                            ];
                        case 4:
                            p = _state.sent(), _++;
                            _tmp = p;
                            if (_tmp) return [
                                3,
                                6
                            ];
                            return [
                                4,
                                new Promise(function(D) {
                                    return setTimeout(D, _this1.failedPublishTimeout);
                                })
                            ];
                        case 5:
                            _tmp = _state.sent();
                            _state.label = 6;
                        case 6:
                            _tmp;
                            _state.label = 7;
                        case 7:
                            return [
                                3,
                                2
                            ];
                        case 8:
                            _this1.relayer.events.emit($4bb3863dfa1867a4$export$d56245796e2837d.publish, b), _this1.logger.debug("Successfully Published Payload"), _this1.logger.trace({
                                type: "method",
                                method: "publish",
                                params: {
                                    id: g,
                                    topic: s,
                                    message: i,
                                    opts: r
                                }
                            });
                            return [
                                3,
                                10
                            ];
                        case 9:
                            D = _state.sent();
                            if (_this1.logger.debug("Failed to Publish Payload"), _this1.logger.error(D), (n = r === null || r === void 0 ? void 0 : r.internal) != null && n.throwOnFailedPublish) throw D;
                            _this1.queue.set(g, b);
                            return [
                                3,
                                10
                            ];
                        case 10:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(s, i, r) {
                return _ref.apply(this, arguments);
            };
        }(), _this.on = function(s, i) {
            _this.events.on(s, i);
        }, _this.once = function(s, i) {
            _this.events.once(s, i);
        }, _this.off = function(s, i) {
            _this.events.off(s, i);
        }, _this.removeListener = function(s, i) {
            _this.events.removeListener(s, i);
        }, _this.relayer = e, _this.logger = (0, $7Gasr.generateChildLogger)(t, _this.name), _this.registerEventListeners();
        return (0, $3U0IP._)(_this);
    }
    (0, $1wc17._)(qr, [
        {
            key: "context",
            get: function get() {
                return (0, $7Gasr.getLoggerContext)(this.logger);
            }
        },
        {
            key: "rpcPublish",
            value: function rpcPublish(e, t, s, i, r, n, a, h) {
                var c, d, g, b;
                var m = {
                    method: (0, $8wnFv.getRelayProtocolApi)(i.protocol).publish,
                    params: {
                        topic: e,
                        message: t,
                        ttl: s,
                        prompt: r,
                        tag: n,
                        attestation: h
                    },
                    id: a
                };
                return (0, $8wnFv.isUndefined)((c = m.params) == null ? void 0 : c.prompt) && ((d = m.params) == null || delete d.prompt), (0, $8wnFv.isUndefined)((g = m.params) == null ? void 0 : g.tag) && ((b = m.params) == null || delete b.tag), this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
                    type: "message",
                    direction: "outgoing",
                    request: m
                }), this.relayer.request(m);
            }
        },
        {
            key: "removeRequestFromQueue",
            value: function removeRequestFromQueue(e) {
                this.queue.delete(e);
            }
        },
        {
            key: "checkQueue",
            value: function checkQueue() {
                var _this = this;
                this.queue.forEach(function() {
                    var _ref = (0, $kSuI9._)(function(e) {
                        var t, s, i;
                        return (0, $eha6O.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    t = e.topic, s = e.message, i = e.opts;
                                    return [
                                        4,
                                        _this.publish(t, s, i)
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(e) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        },
        {
            key: "registerEventListeners",
            value: function registerEventListeners() {
                var _this = this;
                this.relayer.core.heartbeat.on((0, $8nsA4.HEARTBEAT_EVENTS).pulse, function() {
                    if (_this.needsTransportRestart) {
                        _this.needsTransportRestart = !1, _this.relayer.events.emit($4bb3863dfa1867a4$export$d56245796e2837d.connection_stalled);
                        return;
                    }
                    _this.checkQueue();
                }), this.relayer.on($4bb3863dfa1867a4$export$d56245796e2837d.message_ack, function(e) {
                    _this.removeRequestFromQueue(e.id.toString());
                });
            }
        }
    ]);
    return qr;
}((0, $3WrnC.IPublisher));
var $4bb3863dfa1867a4$var$Gr = /*#__PURE__*/ function() {
    "use strict";
    function Gr() {
        var _this = this;
        (0, $4GJKx._)(this, Gr);
        this.map = new Map, this.set = function(e, t) {
            var s = _this.get(e);
            _this.exists(e, t) || _this.map.set(e, (0, $c6Xmf._)(s).concat([
                t
            ]));
        }, this.get = function(e) {
            return _this.map.get(e) || [];
        }, this.exists = function(e, t) {
            return _this.get(e).includes(t);
        }, this.delete = function(e, t) {
            if ((typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t)) > "u") {
                _this.map.delete(e);
                return;
            }
            if (!_this.map.has(e)) return;
            var s = _this.get(e);
            if (!_this.exists(e, t)) return;
            var i = s.filter(function(r) {
                return r !== t;
            });
            if (!i.length) {
                _this.map.delete(e);
                return;
            }
            _this.map.set(e, i);
        }, this.clear = function() {
            _this.map.clear();
        };
    }
    (0, $1wc17._)(Gr, [
        {
            key: "topics",
            get: function get() {
                return Array.from(this.map.keys());
            }
        }
    ]);
    return Gr;
}();
var $4bb3863dfa1867a4$var$Hr = Object.defineProperty, $4bb3863dfa1867a4$var$Yr = Object.defineProperties, $4bb3863dfa1867a4$var$Jr = Object.getOwnPropertyDescriptors, $4bb3863dfa1867a4$var$qt = Object.getOwnPropertySymbols, $4bb3863dfa1867a4$var$Wr = Object.prototype.hasOwnProperty, $4bb3863dfa1867a4$var$Xr = Object.prototype.propertyIsEnumerable, $4bb3863dfa1867a4$var$Gt = function(o, e, t) {
    return e in o ? $4bb3863dfa1867a4$var$Hr(o, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : o[e] = t;
}, $4bb3863dfa1867a4$var$X = function(o, e) {
    for(var t in e || (e = {}))$4bb3863dfa1867a4$var$Wr.call(e, t) && $4bb3863dfa1867a4$var$Gt(o, t, e[t]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($4bb3863dfa1867a4$var$qt) try {
        for(var _iterator = $4bb3863dfa1867a4$var$qt(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var t = _step.value;
            $4bb3863dfa1867a4$var$Xr.call(e, t) && $4bb3863dfa1867a4$var$Gt(o, t, e[t]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return o;
}, $4bb3863dfa1867a4$var$Ie = function(o, e) {
    return $4bb3863dfa1867a4$var$Yr(o, $4bb3863dfa1867a4$var$Jr(e));
};
var $4bb3863dfa1867a4$export$60959659b2c22881 = /*#__PURE__*/ function(_i) {
    "use strict";
    (0, $dcsZi._)(Ht, _i);
    var _super = (0, $ohfOJ._)(Ht);
    function Ht(e, t) {
        (0, $4GJKx._)(this, Ht);
        var _this;
        var _this1 = (0, $d3H5E._)(_this);
        var _this2 = (0, $d3H5E._)(_this);
        var _this3 = (0, $d3H5E._)(_this);
        var _this4 = (0, $d3H5E._)(_this);
        var _this5 = (0, $d3H5E._)(_this);
        var _this6 = (0, $d3H5E._)(_this);
        var _this7 = (0, $d3H5E._)(_this);
        _this = _super.call(this, e, t), _this.relayer = e, _this.logger = t, _this.subscriptions = new Map, _this.topicMap = new $4bb3863dfa1867a4$var$Gr, _this.events = new (0, $cyxGb.EventEmitter), _this.name = $4bb3863dfa1867a4$export$9c3a96bb670cddb8, _this.version = $4bb3863dfa1867a4$export$fb57e03bef4c4cea, _this.pending = new Map, _this.cached = [], _this.initialized = !1, _this.pendingSubscriptionWatchLabel = "pending_sub_watch_label", _this.pollingInterval = 20, _this.storagePrefix = $4bb3863dfa1867a4$export$f258d29ae5e3d545, _this.subscribeTimeout = (0, $4BEBs.toMiliseconds)((0, $4BEBs.ONE_MINUTE)), _this.restartInProgress = !1, _this.batchSubscribeTopicsLimit = 500, _this.pendingBatchMessages = [], _this.init = /*#__PURE__*/ (0, $kSuI9._)(function() {
            var _tmp;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = _this1.initialized;
                        if (_tmp) return [
                            3,
                            2
                        ];
                        _this1.logger.trace("Initialized"), _this1.registerEventListeners();
                        return [
                            4,
                            _this1.relayer.core.crypto.getClientId()
                        ];
                    case 1:
                        _tmp = _this1.clientId = _state.sent();
                        _state.label = 2;
                    case 2:
                        _tmp;
                        return [
                            2
                        ];
                }
            });
        }), _this.subscribe = function() {
            var _ref = (0, $kSuI9._)(function(s, i) {
                var _$r, n, a, r;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this2.restartToComplete()
                            ];
                        case 1:
                            _state.sent(), _this2.isInitialized(), _this2.logger.debug("Subscribing Topic"), _this2.logger.trace({
                                type: "method",
                                method: "subscribe",
                                params: {
                                    topic: s,
                                    opts: i
                                }
                            });
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            _$r = (0, $8wnFv.getRelayProtocolName)(i), n = {
                                topic: s,
                                relay: _$r
                            };
                            _this2.pending.set(s, n);
                            return [
                                4,
                                _this2.rpcSubscribe(s, _$r)
                            ];
                        case 3:
                            a = _state.sent();
                            return [
                                2,
                                (typeof a == "string" && (_this2.onSubscribe(a, n), _this2.logger.debug("Successfully Subscribed Topic"), _this2.logger.trace({
                                    type: "method",
                                    method: "subscribe",
                                    params: {
                                        topic: s,
                                        opts: i
                                    }
                                })), a)
                            ];
                        case 4:
                            r = _state.sent();
                            throw _this2.logger.debug("Failed to Subscribe Topic"), _this2.logger.error(r), r;
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(s, i) {
                return _ref.apply(this, arguments);
            };
        }(), _this.unsubscribe = function() {
            var _ref = (0, $kSuI9._)(function(s, i) {
                var _tmp;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this3.restartToComplete()
                            ];
                        case 1:
                            _state.sent(), _this3.isInitialized();
                            if (!((0, $l0HdX._)(i === null || i === void 0 ? void 0 : i.id) < "u")) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                _this3.unsubscribeById(s, i.id, i)
                            ];
                        case 2:
                            _tmp = _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 3:
                            return [
                                4,
                                _this3.unsubscribeByTopic(s, i)
                            ];
                        case 4:
                            _tmp = _state.sent();
                            _state.label = 5;
                        case 5:
                            _tmp;
                            return [
                                2
                            ];
                    }
                });
            });
            return function(s, i) {
                return _ref.apply(this, arguments);
            };
        }(), _this.isSubscribed = function() {
            var _ref = (0, $kSuI9._)(function(s) {
                var i;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (_this4.topics.includes(s)) return [
                                2,
                                !0
                            ];
                            i = "".concat(_this4.pendingSubscriptionWatchLabel, "_").concat(s);
                            return [
                                4,
                                new Promise(function(r, n) {
                                    var a = new (0, $4BEBs.Watch);
                                    a.start(i);
                                    var h = setInterval(function() {
                                        !_this4.pending.has(s) && _this4.topics.includes(s) && (clearInterval(h), a.stop(i), r(!0)), a.elapsed(i) >= $4bb3863dfa1867a4$export$9a2ddbfe54f8af77 && (clearInterval(h), a.stop(i), n(new Error("Subscription resolution timeout")));
                                    }, _this4.pollingInterval);
                                }).catch(function() {
                                    return !1;
                                })
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(s) {
                return _ref.apply(this, arguments);
            };
        }(), _this.on = function(s, i) {
            _this.events.on(s, i);
        }, _this.once = function(s, i) {
            _this.events.once(s, i);
        }, _this.off = function(s, i) {
            _this.events.off(s, i);
        }, _this.removeListener = function(s, i) {
            _this.events.removeListener(s, i);
        }, _this.start = /*#__PURE__*/ (0, $kSuI9._)(function() {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this5.onConnect()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        }), _this.stop = /*#__PURE__*/ (0, $kSuI9._)(function() {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this6.onDisconnect()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        }), _this.restart = /*#__PURE__*/ (0, $kSuI9._)(function() {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this7.restartInProgress = !0;
                        return [
                            4,
                            _this7.restore()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            _this7.reset()
                        ];
                    case 2:
                        _state.sent(), _this7.restartInProgress = !1;
                        return [
                            2
                        ];
                }
            });
        }), _this.relayer = e, _this.logger = (0, $7Gasr.generateChildLogger)(t, _this.name), _this.clientId = "";
        return (0, $3U0IP._)(_this);
    }
    (0, $1wc17._)(Ht, [
        {
            key: "context",
            get: function get() {
                return (0, $7Gasr.getLoggerContext)(this.logger);
            }
        },
        {
            key: "storageKey",
            get: function get() {
                return this.storagePrefix + this.version + this.relayer.core.customStoragePrefix + "//" + this.name;
            }
        },
        {
            key: "length",
            get: function get() {
                return this.subscriptions.size;
            }
        },
        {
            key: "ids",
            get: function get() {
                return Array.from(this.subscriptions.keys());
            }
        },
        {
            key: "values",
            get: function get() {
                return Array.from(this.subscriptions.values());
            }
        },
        {
            key: "topics",
            get: function get() {
                return this.topicMap.topics;
            }
        },
        {
            key: "hasSubscription",
            value: function hasSubscription(e, t) {
                var s = !1;
                try {
                    s = this.getSubscription(e).topic === t;
                } catch (e) {}
                return s;
            }
        },
        {
            key: "onEnable",
            value: function onEnable() {
                this.cached = [], this.initialized = !0;
            }
        },
        {
            key: "onDisable",
            value: function onDisable() {
                this.cached = this.values, this.subscriptions.clear(), this.topicMap.clear();
            }
        },
        {
            key: "unsubscribeByTopic",
            value: function unsubscribeByTopic(e, t) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var s;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                s = _this.topicMap.get(e);
                                return [
                                    4,
                                    Promise.all(s.map(function() {
                                        var _ref = (0, $kSuI9._)(function(i) {
                                            return (0, $eha6O.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            _this.unsubscribeById(e, i, t)
                                                        ];
                                                    case 1:
                                                        return [
                                                            2,
                                                            _state.sent()
                                                        ];
                                                }
                                            });
                                        });
                                        return function(i) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }()))
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "unsubscribeById",
            value: function unsubscribeById(e, t, s) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _$i, r, i;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.logger.debug("Unsubscribing Topic"), _this.logger.trace({
                                    type: "method",
                                    method: "unsubscribe",
                                    params: {
                                        topic: e,
                                        id: t,
                                        opts: s
                                    }
                                });
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                _$i = (0, $8wnFv.getRelayProtocolName)(s);
                                return [
                                    4,
                                    _this.rpcUnsubscribe(e, t, _$i)
                                ];
                            case 2:
                                _state.sent();
                                r = (0, $8wnFv.getSdkError)("USER_DISCONNECTED", "".concat(_this.name, ", ").concat(e));
                                return [
                                    4,
                                    _this.onUnsubscribe(e, t, r)
                                ];
                            case 3:
                                _state.sent(), _this.logger.debug("Successfully Unsubscribed Topic"), _this.logger.trace({
                                    type: "method",
                                    method: "unsubscribe",
                                    params: {
                                        topic: e,
                                        id: t,
                                        opts: s
                                    }
                                });
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                i = _state.sent();
                                throw _this.logger.debug("Failed to Unsubscribe Topic"), _this.logger.error(i), i;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "rpcSubscribe",
            value: function rpcSubscribe(e, t) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var s, e1;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                s = {
                                    method: (0, $8wnFv.getRelayProtocolApi)(t.protocol).subscribe,
                                    params: {
                                        topic: e
                                    }
                                };
                                _this.logger.debug("Outgoing Relay Payload"), _this.logger.trace({
                                    type: "payload",
                                    direction: "outgoing",
                                    request: s
                                });
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    (0, $8wnFv.createExpiringPromise)(_this.relayer.request(s).catch(function(i) {
                                        return _this.logger.warn(i);
                                    }), _this.subscribeTimeout)
                                ];
                            case 2:
                                return [
                                    4,
                                    _state.sent()
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent() ? (0, $8wnFv.hashMessage)(e + _this.clientId) : null
                                ];
                            case 4:
                                e1 = _state.sent();
                                _this.logger.debug("Outgoing Relay Subscribe Payload stalled"), _this.relayer.events.emit($4bb3863dfa1867a4$export$d56245796e2837d.connection_stalled);
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2,
                                    null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "rpcBatchSubscribe",
            value: function rpcBatchSubscribe(e) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var t, s, e1;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!e.length) return [
                                    2
                                ];
                                t = e[0].relay, s = {
                                    method: (0, $8wnFv.getRelayProtocolApi)(t.protocol).batchSubscribe,
                                    params: {
                                        topics: e.map(function(i) {
                                            return i.topic;
                                        })
                                    }
                                };
                                _this.logger.debug("Outgoing Relay Payload"), _this.logger.trace({
                                    type: "payload",
                                    direction: "outgoing",
                                    request: s
                                });
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    (0, $8wnFv.createExpiringPromise)(_this.relayer.request(s).catch(function(i) {
                                        return _this.logger.warn(i);
                                    }), _this.subscribeTimeout)
                                ];
                            case 2:
                                return [
                                    4,
                                    _state.sent()
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 4:
                                e1 = _state.sent();
                                _this.relayer.events.emit($4bb3863dfa1867a4$export$d56245796e2837d.connection_stalled);
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "rpcBatchFetchMessages",
            value: function rpcBatchFetchMessages(e) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var t, s, i, e1;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!e.length) return [
                                    2
                                ];
                                t = e[0].relay, s = {
                                    method: (0, $8wnFv.getRelayProtocolApi)(t.protocol).batchFetchMessages,
                                    params: {
                                        topics: e.map(function(r) {
                                            return r.topic;
                                        })
                                    }
                                };
                                _this.logger.debug("Outgoing Relay Payload"), _this.logger.trace({
                                    type: "payload",
                                    direction: "outgoing",
                                    request: s
                                });
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    (0, $8wnFv.createExpiringPromise)(_this.relayer.request(s).catch(function(r) {
                                        return _this.logger.warn(r);
                                    }), _this.subscribeTimeout)
                                ];
                            case 2:
                                return [
                                    4,
                                    _state.sent()
                                ];
                            case 3:
                                i = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                e1 = _state.sent();
                                _this.relayer.events.emit($4bb3863dfa1867a4$export$d56245796e2837d.connection_stalled);
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2,
                                    i
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "rpcUnsubscribe",
            value: function rpcUnsubscribe(e, t, s) {
                var i = {
                    method: (0, $8wnFv.getRelayProtocolApi)(s.protocol).unsubscribe,
                    params: {
                        topic: e,
                        id: t
                    }
                };
                return this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
                    type: "payload",
                    direction: "outgoing",
                    request: i
                }), this.relayer.request(i);
            }
        },
        {
            key: "onSubscribe",
            value: function onSubscribe(e, t) {
                this.setSubscription(e, $4bb3863dfa1867a4$var$Ie($4bb3863dfa1867a4$var$X({}, t), {
                    id: e
                })), this.pending.delete(t.topic);
            }
        },
        {
            key: "onBatchSubscribe",
            value: function onBatchSubscribe(e) {
                var _this = this;
                e.length && e.forEach(function(t) {
                    _this.setSubscription(t.id, $4bb3863dfa1867a4$var$X({}, t)), _this.pending.delete(t.topic);
                });
            }
        },
        {
            key: "onUnsubscribe",
            value: function onUnsubscribe(e, t, s) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.events.removeAllListeners(t), _this.hasSubscription(t, e) && _this.deleteSubscription(t, s);
                                return [
                                    4,
                                    _this.relayer.messages.del(e)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setRelayerSubscriptions",
            value: function setRelayerSubscriptions(e) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.relayer.core.storage.setItem(_this.storageKey, e)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getRelayerSubscriptions",
            value: function getRelayerSubscriptions() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.relayer.core.storage.getItem(_this.storageKey)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setSubscription",
            value: function setSubscription(e, t) {
                this.logger.debug("Setting subscription"), this.logger.trace({
                    type: "method",
                    method: "setSubscription",
                    id: e,
                    subscription: t
                }), this.addSubscription(e, t);
            }
        },
        {
            key: "addSubscription",
            value: function addSubscription(e, t) {
                this.subscriptions.set(e, $4bb3863dfa1867a4$var$X({}, t)), this.topicMap.set(t.topic, e), this.events.emit($4bb3863dfa1867a4$export$24ff3e54e94ef413.created, t);
            }
        },
        {
            key: "getSubscription",
            value: function getSubscription(e) {
                this.logger.debug("Getting subscription"), this.logger.trace({
                    type: "method",
                    method: "getSubscription",
                    id: e
                });
                var t = this.subscriptions.get(e);
                if (!t) {
                    var _u = (0, $8wnFv.getInternalError)("NO_MATCHING_KEY", "".concat(this.name, ": ").concat(e)), s = _u.message;
                    throw new Error(s);
                }
                return t;
            }
        },
        {
            key: "deleteSubscription",
            value: function deleteSubscription(e, t) {
                this.logger.debug("Deleting subscription"), this.logger.trace({
                    type: "method",
                    method: "deleteSubscription",
                    id: e,
                    reason: t
                });
                var s = this.getSubscription(e);
                this.subscriptions.delete(e), this.topicMap.delete(s.topic, e), this.events.emit($4bb3863dfa1867a4$export$24ff3e54e94ef413.deleted, $4bb3863dfa1867a4$var$Ie($4bb3863dfa1867a4$var$X({}, s), {
                    reason: t
                }));
            }
        },
        {
            key: "persist",
            value: function persist() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.setRelayerSubscriptions(_this.values)
                                ];
                            case 1:
                                _state.sent(), _this.events.emit($4bb3863dfa1867a4$export$24ff3e54e94ef413.sync);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "reset",
            value: function reset() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var e, t, s;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.cached.length) return [
                                    3,
                                    5
                                ];
                                e = Math.ceil(_this.cached.length / _this.batchSubscribeTopicsLimit);
                                t = 0;
                                _state.label = 1;
                            case 1:
                                if (!(t < e)) return [
                                    3,
                                    5
                                ];
                                s = _this.cached.splice(0, _this.batchSubscribeTopicsLimit);
                                return [
                                    4,
                                    _this.batchFetchMessages(s)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    _this.batchSubscribe(s)
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                t++;
                                return [
                                    3,
                                    1
                                ];
                            case 5:
                                _this.events.emit($4bb3863dfa1867a4$export$24ff3e54e94ef413.resubscribed);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "restore",
            value: function restore() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _$e, _u, t, e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.getRelayerSubscriptions()
                                ];
                            case 1:
                                _$e = _state.sent();
                                if ((typeof _$e === "undefined" ? "undefined" : (0, $l0HdX._)(_$e)) > "u" || !_$e.length) return [
                                    2
                                ];
                                if (_this.subscriptions.size) {
                                    _u = (0, $8wnFv.getInternalError)("RESTORE_WILL_OVERRIDE", _this.name), t = _u.message;
                                    throw _this.logger.error(t), _this.logger.error("".concat(_this.name, ": ").concat(JSON.stringify(_this.values))), new Error(t);
                                }
                                _this.cached = _$e, _this.logger.debug("Successfully Restored subscriptions for ".concat(_this.name)), _this.logger.trace({
                                    type: "method",
                                    method: "restore",
                                    subscriptions: _this.values
                                });
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                e = _state.sent();
                                _this.logger.debug("Failed to Restore subscriptions for ".concat(_this.name)), _this.logger.error(e);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "batchSubscribe",
            value: function batchSubscribe(e) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var t;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!e.length) return [
                                    2
                                ];
                                return [
                                    4,
                                    _this.rpcBatchSubscribe(e)
                                ];
                            case 1:
                                t = _state.sent();
                                (0, $8wnFv.isValidArray)(t) && _this.onBatchSubscribe(t.map(function(s, i) {
                                    return $4bb3863dfa1867a4$var$Ie($4bb3863dfa1867a4$var$X({}, e[i]), {
                                        id: s
                                    });
                                }));
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "batchFetchMessages",
            value: function batchFetchMessages(e) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var t;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!e.length) return [
                                    2
                                ];
                                _this.logger.trace("Fetching batch messages for ".concat(e.length, " subscriptions"));
                                return [
                                    4,
                                    _this.rpcBatchFetchMessages(e)
                                ];
                            case 1:
                                t = _state.sent();
                                t && t.messages && (_this.pendingBatchMessages = _this.pendingBatchMessages.concat(t.messages));
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onConnect",
            value: function onConnect() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.restart()
                                ];
                            case 1:
                                _state.sent(), _this.onEnable();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onDisconnect",
            value: function onDisconnect() {
                this.onDisable();
            }
        },
        {
            key: "checkPending",
            value: function checkPending() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var e, _tmp;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.initialized || !_this.relayer.connected) return [
                                    2
                                ];
                                e = [];
                                _this.pending.forEach(function(t) {
                                    e.push(t);
                                });
                                return [
                                    4,
                                    _this.batchSubscribe(e)
                                ];
                            case 1:
                                _state.sent();
                                _tmp = _this.pendingBatchMessages.length;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.relayer.handleBatchMessageEvents(_this.pendingBatchMessages)
                                ];
                            case 2:
                                _tmp = (_state.sent(), _this.pendingBatchMessages = []);
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "registerEventListeners",
            value: function registerEventListeners() {
                var _this = this;
                var _this1 = this;
                var _this2 = this;
                this.relayer.core.heartbeat.on((0, $8nsA4.HEARTBEAT_EVENTS).pulse, /*#__PURE__*/ (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.checkPending()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })), this.events.on($4bb3863dfa1867a4$export$24ff3e54e94ef413.created, function() {
                    var _ref = (0, $kSuI9._)(function(e) {
                        var t;
                        return (0, $eha6O.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    t = $4bb3863dfa1867a4$export$24ff3e54e94ef413.created;
                                    _this1.logger.info("Emitting ".concat(t)), _this1.logger.debug({
                                        type: "event",
                                        event: t,
                                        data: e
                                    });
                                    return [
                                        4,
                                        _this1.persist()
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(e) {
                        return _ref.apply(this, arguments);
                    };
                }()), this.events.on($4bb3863dfa1867a4$export$24ff3e54e94ef413.deleted, function() {
                    var _ref = (0, $kSuI9._)(function(e) {
                        var t;
                        return (0, $eha6O.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    t = $4bb3863dfa1867a4$export$24ff3e54e94ef413.deleted;
                                    _this2.logger.info("Emitting ".concat(t)), _this2.logger.debug({
                                        type: "event",
                                        event: t,
                                        data: e
                                    });
                                    return [
                                        4,
                                        _this2.persist()
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(e) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        },
        {
            key: "isInitialized",
            value: function isInitialized() {
                if (!this.initialized) {
                    var _u = (0, $8wnFv.getInternalError)("NOT_INITIALIZED", this.name), e = _u.message;
                    throw new Error(e);
                }
            }
        },
        {
            key: "restartToComplete",
            value: function restartToComplete() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _tmp;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = _this.restartInProgress;
                                if (!_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    new Promise(function(e) {
                                        var t = setInterval(function() {
                                            _this.restartInProgress || (clearInterval(t), e());
                                        }, _this.pollingInterval);
                                    })
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Ht;
}((0, $3WrnC.ISubscriber));
var $4bb3863dfa1867a4$var$Zr = Object.defineProperty, $4bb3863dfa1867a4$var$Yt = Object.getOwnPropertySymbols, $4bb3863dfa1867a4$var$Qr = Object.prototype.hasOwnProperty, $4bb3863dfa1867a4$var$en = Object.prototype.propertyIsEnumerable, $4bb3863dfa1867a4$var$Jt = function(o, e, t) {
    return e in o ? $4bb3863dfa1867a4$var$Zr(o, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : o[e] = t;
}, $4bb3863dfa1867a4$var$tn = function(o, e) {
    for(var t in e || (e = {}))$4bb3863dfa1867a4$var$Qr.call(e, t) && $4bb3863dfa1867a4$var$Jt(o, t, e[t]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($4bb3863dfa1867a4$var$Yt) try {
        for(var _iterator = $4bb3863dfa1867a4$var$Yt(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var t = _step.value;
            $4bb3863dfa1867a4$var$en.call(e, t) && $4bb3863dfa1867a4$var$Jt(o, t, e[t]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return o;
};
var $4bb3863dfa1867a4$export$70e73aa29a3d4407 = /*#__PURE__*/ function(Ei) {
    "use strict";
    (0, $dcsZi._)(Wt, Ei);
    var _super = (0, $ohfOJ._)(Wt);
    function Wt(e) {
        (0, $4GJKx._)(this, Wt);
        var _this;
        var _this1 = (0, $d3H5E._)(_this);
        _this = _super.call(this, e), _this.protocol = "wc", _this.version = 2, _this.events = new (0, $cyxGb.EventEmitter), _this.name = $4bb3863dfa1867a4$export$602d6e27611c3fcb, _this.transportExplicitlyClosed = !1, _this.initialized = !1, _this.connectionAttemptInProgress = !1, _this.connectionStatusPollingInterval = 20, _this.staleConnectionErrors = [
            "socket hang up",
            "stalled",
            "interrupted"
        ], _this.hasExperiencedNetworkDisruption = !1, _this.requestsInFlight = new Map, _this.heartBeatTimeout = (0, $4BEBs.toMiliseconds)((0, $4BEBs.THIRTY_SECONDS) + (0, $4BEBs.ONE_SECOND)), _this.request = function() {
            var _ref = (0, $kSuI9._)(function(t) {
                var s, i, r, _$n, a, n;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this1.logger.debug("Publishing Request Payload");
                            r = t.id || (0, $3W2Mc.getBigIntRpcId)().toString();
                            return [
                                4,
                                _this1.toEstablishConnection()
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                4,
                                5,
                                6
                            ]);
                            _$n = _this1.provider.request(t);
                            _this1.requestsInFlight.set(r, {
                                promise: _$n,
                                request: t
                            }), _this1.logger.trace({
                                id: r,
                                method: t.method,
                                topic: (s = t.params) == null ? void 0 : s.topic
                            }, "relayer.request - attempt to publish...");
                            return [
                                4,
                                new Promise(function() {
                                    var _ref = (0, $kSuI9._)(function(h, c) {
                                        var d, g;
                                        return (0, $eha6O.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    d = function() {
                                                        c(new Error("relayer.request - publish interrupted, id: ".concat(r)));
                                                    };
                                                    _this1.provider.on($4bb3863dfa1867a4$export$58062acf2f31ddf8.disconnect, d);
                                                    return [
                                                        4,
                                                        _$n
                                                    ];
                                                case 1:
                                                    g = _state.sent();
                                                    _this1.provider.off($4bb3863dfa1867a4$export$58062acf2f31ddf8.disconnect, d), h(g);
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(h, c) {
                                        return _ref.apply(this, arguments);
                                    };
                                }())
                            ];
                        case 3:
                            a = _state.sent();
                            return [
                                2,
                                (_this1.logger.trace({
                                    id: r,
                                    method: t.method,
                                    topic: (i = t.params) == null ? void 0 : i.topic
                                }, "relayer.request - published"), a)
                            ];
                        case 4:
                            n = _state.sent();
                            throw _this1.logger.debug("Failed to Publish Request: ".concat(r)), n;
                        case 5:
                            _this1.requestsInFlight.delete(r);
                            return [
                                7
                            ];
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(t) {
                return _ref.apply(this, arguments);
            };
        }(), _this.resetPingTimeout = function() {
            if ((0, $8wnFv.isNode)()) try {
                clearTimeout(_this.pingTimeout), _this.pingTimeout = setTimeout(function() {
                    var _$t, s, i;
                    (i = (s = (_$t = _this.provider) == null ? void 0 : _$t.connection) == null ? void 0 : s.socket) == null || i.terminate();
                }, _this.heartBeatTimeout);
            } catch (t) {
                _this.logger.warn(t);
            }
        }, _this.onPayloadHandler = function(t) {
            _this.onProviderPayload(t), _this.resetPingTimeout();
        }, _this.onConnectHandler = function() {
            _this.logger.trace("relayer connected"), _this.startPingTimeout(), _this.events.emit($4bb3863dfa1867a4$export$d56245796e2837d.connect);
        }, _this.onDisconnectHandler = function() {
            _this.logger.trace("relayer disconnected"), _this.onProviderDisconnect();
        }, _this.onProviderErrorHandler = function(t) {
            _this.logger.error(t), _this.events.emit($4bb3863dfa1867a4$export$d56245796e2837d.error, t), _this.logger.info("Fatal socket error received, closing transport"), _this.transportClose();
        }, _this.registerProviderListeners = function() {
            _this.provider.on($4bb3863dfa1867a4$export$58062acf2f31ddf8.payload, _this.onPayloadHandler), _this.provider.on($4bb3863dfa1867a4$export$58062acf2f31ddf8.connect, _this.onConnectHandler), _this.provider.on($4bb3863dfa1867a4$export$58062acf2f31ddf8.disconnect, _this.onDisconnectHandler), _this.provider.on($4bb3863dfa1867a4$export$58062acf2f31ddf8.error, _this.onProviderErrorHandler);
        }, _this.core = e.core, _this.logger = (0, $l0HdX._)(e.logger) < "u" && typeof e.logger != "string" ? (0, $7Gasr.generateChildLogger)(e.logger, _this.name) : (0, (/*@__PURE__*/$parcel$interopDefault($6DLsq)))((0, $7Gasr.getDefaultLoggerOptions)({
            level: e.logger || $4bb3863dfa1867a4$export$5176ffa6778d6637
        })), _this.messages = new $4bb3863dfa1867a4$export$4a2542d0790ac2fd(_this.logger, e.core), _this.subscriber = new $4bb3863dfa1867a4$export$60959659b2c22881((0, $d3H5E._)(_this), _this.logger), _this.publisher = new $4bb3863dfa1867a4$var$qr((0, $d3H5E._)(_this), _this.logger), _this.relayUrl = (e === null || e === void 0 ? void 0 : e.relayUrl) || $4bb3863dfa1867a4$export$a68061e6c48f332a, _this.projectId = e.projectId, _this.bundleId = (0, $8wnFv.getBundleId)(), _this.provider = {};
        return (0, $3U0IP._)(_this);
    }
    (0, $1wc17._)(Wt, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.logger.trace("Initialized"), _this.registerEventListeners();
                                return [
                                    4,
                                    Promise.all([
                                        _this.messages.init(),
                                        _this.subscriber.init()
                                    ])
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this.transportOpen()
                                ];
                            case 2:
                                _state.sent(), _this.initialized = !0, setTimeout(/*#__PURE__*/ (0, $kSuI9._)(function() {
                                    var _tmp;
                                    return (0, $eha6O.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _tmp = _this.subscriber.topics.length === 0 && _this.subscriber.pending.size === 0;
                                                if (!_tmp) return [
                                                    3,
                                                    2
                                                ];
                                                _this.logger.info("No topics subscribed to after init, closing transport");
                                                return [
                                                    4,
                                                    _this.transportClose()
                                                ];
                                            case 1:
                                                _tmp = (_state.sent(), _this.transportExplicitlyClosed = !1);
                                                _state.label = 2;
                                            case 2:
                                                _tmp;
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }), $4bb3863dfa1867a4$export$fb3eab7adf12329d);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "context",
            get: function get() {
                return (0, $7Gasr.getLoggerContext)(this.logger);
            }
        },
        {
            key: "connected",
            get: function get() {
                var e, t, s;
                return ((s = (t = (e = this.provider) == null ? void 0 : e.connection) == null ? void 0 : t.socket) == null ? void 0 : s.readyState) === 1;
            }
        },
        {
            key: "connecting",
            get: function get() {
                var e, t, s;
                return ((s = (t = (e = this.provider) == null ? void 0 : e.connection) == null ? void 0 : t.socket) == null ? void 0 : s.readyState) === 0;
            }
        },
        {
            key: "publish",
            value: function publish(e, t, s) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.isInitialized();
                                return [
                                    4,
                                    _this.publisher.publish(e, t, s)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this.recordMessageEvent({
                                        topic: e,
                                        message: t,
                                        publishedAt: Date.now()
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "subscribe",
            value: function subscribe(e, t) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var s, i, r, n;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.isInitialized();
                                i = ((s = _this.subscriber.topicMap.get(e)) == null ? void 0 : s[0]) || "";
                                n = function(a) {
                                    a.topic === e && (_this.subscriber.off($4bb3863dfa1867a4$export$24ff3e54e94ef413.created, n), r());
                                };
                                return [
                                    4,
                                    Promise.all([
                                        new Promise(function(a) {
                                            r = a, _this.subscriber.on($4bb3863dfa1867a4$export$24ff3e54e94ef413.created, n);
                                        }),
                                        new Promise(function() {
                                            var _ref = (0, $kSuI9._)(function(a) {
                                                return (0, $eha6O.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            return [
                                                                4,
                                                                _this.subscriber.subscribe(e, t)
                                                            ];
                                                        case 1:
                                                            i = _state.sent() || i, a();
                                                            return [
                                                                2
                                                            ];
                                                    }
                                                });
                                            });
                                            return function(a) {
                                                return _ref.apply(this, arguments);
                                            };
                                        }())
                                    ])
                                ];
                            case 1:
                                return [
                                    2,
                                    (_state.sent(), i)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(e, t) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.isInitialized();
                                return [
                                    4,
                                    _this.subscriber.unsubscribe(e, t)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "on",
            value: function on(e, t) {
                this.events.on(e, t);
            }
        },
        {
            key: "once",
            value: function once(e, t) {
                this.events.once(e, t);
            }
        },
        {
            key: "off",
            value: function off(e, t) {
                this.events.off(e, t);
            }
        },
        {
            key: "removeListener",
            value: function removeListener(e, t) {
                this.events.removeListener(e, t);
            }
        },
        {
            key: "transportDisconnect",
            value: function transportDisconnect() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var e, _tmp;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(!_this.hasExperiencedNetworkDisruption && _this.connected && _this.requestsInFlight.size > 0)) return [
                                    3,
                                    4
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    Promise.all(Array.from(_this.requestsInFlight.values()).map(function(e) {
                                        return e.promise;
                                    }))
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                _this.logger.warn(e);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                if (!(_this.hasExperiencedNetworkDisruption || _this.connected)) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    (0, $8wnFv.createExpiringPromise)(_this.provider.disconnect(), 2e3, "provider.disconnect()").catch(function() {
                                        return _this.onProviderDisconnect();
                                    })
                                ];
                            case 5:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                _tmp = _this.onProviderDisconnect();
                                _state.label = 7;
                            case 7:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "transportClose",
            value: function transportClose() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.transportExplicitlyClosed = !0;
                                return [
                                    4,
                                    _this.transportDisconnect()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "transportOpen",
            value: function transportOpen(e) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _tmp, t, s;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.confirmOnlineStateOrThrow()
                                ];
                            case 1:
                                _state.sent();
                                _tmp = e && e !== _this.relayUrl;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                _this.relayUrl = e;
                                return [
                                    4,
                                    _this.transportDisconnect()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    4,
                                    _this.createProvider()
                                ];
                            case 4:
                                _state.sent(), _this.connectionAttemptInProgress = !0, _this.transportExplicitlyClosed = !1;
                                _state.label = 5;
                            case 5:
                                _state.trys.push([
                                    5,
                                    7,
                                    8,
                                    9
                                ]);
                                return [
                                    4,
                                    new Promise(function() {
                                        var _ref = (0, $kSuI9._)(function(t, s) {
                                            var i;
                                            return (0, $eha6O.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        i = function() {
                                                            _this.provider.off($4bb3863dfa1867a4$export$58062acf2f31ddf8.disconnect, i), s(new Error("Connection interrupted while trying to subscribe"));
                                                        };
                                                        _this.provider.on($4bb3863dfa1867a4$export$58062acf2f31ddf8.disconnect, i);
                                                        return [
                                                            4,
                                                            (0, $8wnFv.createExpiringPromise)(_this.provider.connect(), (0, $4BEBs.toMiliseconds)((0, $4BEBs.ONE_MINUTE)), "Socket stalled when trying to connect to ".concat(_this.relayUrl)).catch(function(r) {
                                                                s(r);
                                                            }).finally(function() {
                                                                clearTimeout(_this.reconnectTimeout), _this.reconnectTimeout = void 0;
                                                            })
                                                        ];
                                                    case 1:
                                                        _state.sent(), _this.subscriber.start().catch(function(r) {
                                                            _this.logger.error(r), _this.onDisconnectHandler();
                                                        }), _this.hasExperiencedNetworkDisruption = !1, t();
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(t, s) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }())
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    3,
                                    9
                                ];
                            case 7:
                                t = _state.sent();
                                _this.logger.error(t);
                                s = t;
                                if (_this.hasExperiencedNetworkDisruption = !0, !_this.isConnectionStalled(s.message)) throw t;
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                _this.connectionAttemptInProgress = !1;
                                return [
                                    7
                                ];
                            case 9:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "restartTransport",
            value: function restartTransport(e) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _tmp;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = _this.connectionAttemptInProgress;
                                if (_tmp) return [
                                    3,
                                    4
                                ];
                                _this.relayUrl = e || _this.relayUrl;
                                return [
                                    4,
                                    _this.confirmOnlineStateOrThrow()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this.transportClose()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    _this.transportOpen()
                                ];
                            case 3:
                                _tmp = _state.sent();
                                _state.label = 4;
                            case 4:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "confirmOnlineStateOrThrow",
            value: function confirmOnlineStateOrThrow() {
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $8wnFv.isOnline)()
                                ];
                            case 1:
                                if (!_state.sent()) throw new Error("No internet connection detected. Please restart your network and try again.");
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handleBatchMessageEvents",
            value: function handleBatchMessageEvents(e) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var t, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, s, i, err;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if ((e === null || e === void 0 ? void 0 : e.length) === 0) {
                                    _this.logger.trace("Batch message events is empty. Ignoring...");
                                    return [
                                        2
                                    ];
                                }
                                t = e.sort(function(s, i) {
                                    return s.publishedAt - i.publishedAt;
                                });
                                _this.logger.trace("Batch of ".concat(t.length, " message events sorted"));
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    8,
                                    9,
                                    10
                                ]);
                                _iterator = t[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    7
                                ];
                                s = _step.value;
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    _this.onMessageEvent(s)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                i = _state.sent();
                                _this.logger.warn(i);
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 7:
                                return [
                                    3,
                                    10
                                ];
                            case 8:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    10
                                ];
                            case 9:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 10:
                                _this.logger.trace("Batch of ".concat(t.length, " message events processed"));
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "startPingTimeout",
            value: function startPingTimeout() {
                var _this = this;
                var e, t, s, i, r;
                if ((0, $8wnFv.isNode)()) try {
                    (t = (e = this.provider) == null ? void 0 : e.connection) != null && t.socket && ((r = (i = (s = this.provider) == null ? void 0 : s.connection) == null ? void 0 : i.socket) == null || r.once("ping", function() {
                        _this.resetPingTimeout();
                    })), this.resetPingTimeout();
                } catch (n) {
                    this.logger.warn(n);
                }
            }
        },
        {
            key: "isConnectionStalled",
            value: function isConnectionStalled(e) {
                return this.staleConnectionErrors.some(function(t) {
                    return e.includes(t);
                });
            }
        },
        {
            key: "createProvider",
            value: function createProvider() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.provider.connection && _this.unregisterProviderListeners();
                                return [
                                    4,
                                    _this.core.crypto.signJWT(_this.relayUrl)
                                ];
                            case 1:
                                e = _state.sent();
                                _this.provider = new (0, $bMQws.JsonRpcProvider)(new (0, $gCTEP.default)((0, $8wnFv.formatRelayRpcUrl)({
                                    sdkVersion: $4bb3863dfa1867a4$export$5f30917a6f8c9025,
                                    protocol: _this.protocol,
                                    version: _this.version,
                                    relayUrl: _this.relayUrl,
                                    projectId: _this.projectId,
                                    auth: e,
                                    useOnCloseEvent: !0,
                                    bundleId: _this.bundleId
                                }))), _this.registerProviderListeners();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "recordMessageEvent",
            value: function recordMessageEvent(e) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var t, s;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t = e.topic, s = e.message;
                                return [
                                    4,
                                    _this.messages.set(t, s)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "shouldIgnoreMessageEvent",
            value: function shouldIgnoreMessageEvent(e) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var t, s, i;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t = e.topic, s = e.message;
                                if (!s || s.length === 0) return [
                                    2,
                                    (_this.logger.debug("Ignoring invalid/empty message: ".concat(s)), !0)
                                ];
                                return [
                                    4,
                                    _this.subscriber.isSubscribed(t)
                                ];
                            case 1:
                                if (!_state.sent()) return [
                                    2,
                                    (_this.logger.debug("Ignoring message for non-subscribed topic ".concat(t)), !0)
                                ];
                                i = _this.messages.has(t, s);
                                return [
                                    2,
                                    (i && _this.logger.debug("Ignoring duplicate message: ".concat(s)), i)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onProviderPayload",
            value: function onProviderPayload(e) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var t, _t_data, s, i, r, n, a;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(_this.logger.debug("Incoming Relay Payload"), _this.logger.trace({
                                    type: "payload",
                                    direction: "incoming",
                                    payload: e
                                }), (0, $5lf06.isJsonRpcRequest)(e))) return [
                                    3,
                                    3
                                ];
                                if (!e.method.endsWith($4bb3863dfa1867a4$export$119b4645f6b233c8)) return [
                                    2
                                ];
                                t = e.params, _t_data = t.data, s = _t_data.topic, i = _t_data.message, r = _t_data.publishedAt, n = _t_data.attestation, a = {
                                    topic: s,
                                    message: i,
                                    publishedAt: r,
                                    attestation: n
                                };
                                _this.logger.debug("Emitting Relayer Payload"), _this.logger.trace($4bb3863dfa1867a4$var$tn({
                                    type: "event",
                                    event: t.id
                                }, a)), _this.events.emit(t.id, a);
                                return [
                                    4,
                                    _this.acknowledgePayload(e)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this.onMessageEvent(a)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                (0, $5lf06.isJsonRpcResponse)(e) && _this.events.emit($4bb3863dfa1867a4$export$d56245796e2837d.message_ack, e);
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onMessageEvent",
            value: function onMessageEvent(e) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _tmp;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.shouldIgnoreMessageEvent(e)
                                ];
                            case 1:
                                _tmp = _state.sent();
                                if (_tmp) return [
                                    3,
                                    3
                                ];
                                _this.events.emit($4bb3863dfa1867a4$export$d56245796e2837d.message, e);
                                return [
                                    4,
                                    _this.recordMessageEvent(e)
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "acknowledgePayload",
            value: function acknowledgePayload(e) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var t;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t = (0, $3W2Mc.formatJsonRpcResult)(e.id, !0);
                                return [
                                    4,
                                    _this.provider.connection.send(t)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "unregisterProviderListeners",
            value: function unregisterProviderListeners() {
                this.provider.off($4bb3863dfa1867a4$export$58062acf2f31ddf8.payload, this.onPayloadHandler), this.provider.off($4bb3863dfa1867a4$export$58062acf2f31ddf8.connect, this.onConnectHandler), this.provider.off($4bb3863dfa1867a4$export$58062acf2f31ddf8.disconnect, this.onDisconnectHandler), this.provider.off($4bb3863dfa1867a4$export$58062acf2f31ddf8.error, this.onProviderErrorHandler), clearTimeout(this.pingTimeout);
            }
        },
        {
            key: "registerEventListeners",
            value: function registerEventListeners() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $8wnFv.isOnline)()
                                ];
                            case 1:
                                e = _state.sent();
                                (0, $8wnFv.subscribeToNetworkChange)(function() {
                                    var _ref = (0, $kSuI9._)(function(t) {
                                        var _tmp, _tmp1;
                                        return (0, $eha6O.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    _tmp = e !== t;
                                                    if (!_tmp) return [
                                                        3,
                                                        5
                                                    ];
                                                    e = t;
                                                    if (!t) return [
                                                        3,
                                                        2
                                                    ];
                                                    return [
                                                        4,
                                                        _this.restartTransport().catch(function(s) {
                                                            return _this.logger.error(s);
                                                        })
                                                    ];
                                                case 1:
                                                    _tmp1 = _state.sent();
                                                    return [
                                                        3,
                                                        4
                                                    ];
                                                case 2:
                                                    _this.hasExperiencedNetworkDisruption = !0;
                                                    return [
                                                        4,
                                                        _this.transportDisconnect()
                                                    ];
                                                case 3:
                                                    _tmp1 = (_state.sent(), _this.transportExplicitlyClosed = !1);
                                                    _state.label = 4;
                                                case 4:
                                                    _tmp = _tmp1;
                                                    _state.label = 5;
                                                case 5:
                                                    _tmp;
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(t) {
                                        return _ref.apply(this, arguments);
                                    };
                                }());
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onProviderDisconnect",
            value: function onProviderDisconnect() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.subscriber.stop()
                                ];
                            case 1:
                                _state.sent(), _this.requestsInFlight.clear(), clearTimeout(_this.pingTimeout), _this.events.emit($4bb3863dfa1867a4$export$d56245796e2837d.disconnect), _this.connectionAttemptInProgress = !1, !_this.transportExplicitlyClosed && (_this.reconnectTimeout || (_this.reconnectTimeout = setTimeout(/*#__PURE__*/ (0, $kSuI9._)(function() {
                                    return (0, $eha6O.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    _this.transportOpen().catch(function(e) {
                                                        return _this.logger.error(e);
                                                    })
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }), (0, $4BEBs.toMiliseconds)($4bb3863dfa1867a4$export$11ccd39be2c57d6))));
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "isInitialized",
            value: function isInitialized() {
                if (!this.initialized) {
                    var _u = (0, $8wnFv.getInternalError)("NOT_INITIALIZED", this.name), e = _u.message;
                    throw new Error(e);
                }
            }
        },
        {
            key: "toEstablishConnection",
            value: function toEstablishConnection() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _tmp, _tmp1;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.confirmOnlineStateOrThrow()
                                ];
                            case 1:
                                _state.sent();
                                _tmp = !_this.connected;
                                if (!_tmp) return [
                                    3,
                                    5
                                ];
                                _tmp1 = _this.connectionAttemptInProgress;
                                if (!_tmp1) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    new Promise(function(e) {
                                        var t = setInterval(function() {
                                            _this.connected && (clearInterval(t), e());
                                        }, _this.connectionStatusPollingInterval);
                                    })
                                ];
                            case 2:
                                _tmp1 = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp1;
                                return [
                                    4,
                                    _this.transportOpen()
                                ];
                            case 4:
                                _tmp = _state.sent();
                                _state.label = 5;
                            case 5:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Wt;
}((0, $3WrnC.IRelayer));
var $4bb3863dfa1867a4$var$sn = Object.defineProperty, $4bb3863dfa1867a4$var$Xt = Object.getOwnPropertySymbols, $4bb3863dfa1867a4$var$rn = Object.prototype.hasOwnProperty, $4bb3863dfa1867a4$var$nn = Object.prototype.propertyIsEnumerable, $4bb3863dfa1867a4$var$Zt = function(o, e, t) {
    return e in o ? $4bb3863dfa1867a4$var$sn(o, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : o[e] = t;
}, $4bb3863dfa1867a4$var$Qt = function(o, e) {
    for(var t in e || (e = {}))$4bb3863dfa1867a4$var$rn.call(e, t) && $4bb3863dfa1867a4$var$Zt(o, t, e[t]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($4bb3863dfa1867a4$var$Xt) try {
        for(var _iterator = $4bb3863dfa1867a4$var$Xt(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var t = _step.value;
            $4bb3863dfa1867a4$var$nn.call(e, t) && $4bb3863dfa1867a4$var$Zt(o, t, e[t]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return o;
};
var $4bb3863dfa1867a4$export$390f32400eaf98c9 = /*#__PURE__*/ function(vi) {
    "use strict";
    (0, $dcsZi._)(ei, vi);
    var _super = (0, $ohfOJ._)(ei);
    function ei(e, t, s) {
        var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $4bb3863dfa1867a4$export$f258d29ae5e3d545, r = arguments.length > 4 ? arguments[4] : void 0;
        (0, $4GJKx._)(this, ei);
        var _this;
        var _this1 = (0, $d3H5E._)(_this);
        var _this2 = (0, $d3H5E._)(_this);
        var _this3 = (0, $d3H5E._)(_this);
        var _this4 = (0, $d3H5E._)(_this);
        _this = _super.call(this, e, t, s, i), _this.core = e, _this.logger = t, _this.name = s, _this.map = new Map, _this.version = $4bb3863dfa1867a4$export$629a342182ba24b, _this.cached = [], _this.initialized = !1, _this.storagePrefix = $4bb3863dfa1867a4$export$f258d29ae5e3d545, _this.recentlyDeleted = [], _this.recentlyDeletedLimit = 200, _this.init = /*#__PURE__*/ (0, $kSuI9._)(function() {
            var _tmp;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = _this1.initialized;
                        if (_tmp) return [
                            3,
                            2
                        ];
                        _this1.logger.trace("Initialized");
                        return [
                            4,
                            _this1.restore()
                        ];
                    case 1:
                        _tmp = (_state.sent(), _this1.cached.forEach(function(n) {
                            _this1.getKey && n !== null && !(0, $8wnFv.isUndefined)(n) ? _this1.map.set(_this1.getKey(n), n) : (0, $8wnFv.isProposalStruct)(n) ? _this1.map.set(n.id, n) : (0, $8wnFv.isSessionStruct)(n) && _this1.map.set(n.topic, n);
                        }), _this1.cached = [], _this1.initialized = !0);
                        _state.label = 2;
                    case 2:
                        _tmp;
                        return [
                            2
                        ];
                }
            });
        }), _this.set = function() {
            var _ref = (0, $kSuI9._)(function(n, a) {
                var _tmp;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this2.isInitialized();
                            if (!_this2.map.has(n)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _this2.update(n, a)
                            ];
                        case 1:
                            _tmp = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 2:
                            _this2.logger.debug("Setting value"), _this2.logger.trace({
                                type: "method",
                                method: "set",
                                key: n,
                                value: a
                            }), _this2.map.set(n, a);
                            return [
                                4,
                                _this2.persist()
                            ];
                        case 3:
                            _tmp = _state.sent();
                            _state.label = 4;
                        case 4:
                            _tmp;
                            return [
                                2
                            ];
                    }
                });
            });
            return function(n, a) {
                return _ref.apply(this, arguments);
            };
        }(), _this.get = function(n) {
            return _this.isInitialized(), _this.logger.debug("Getting value"), _this.logger.trace({
                type: "method",
                method: "get",
                key: n
            }), _this.getData(n);
        }, _this.getAll = function(n) {
            return _this.isInitialized(), n ? _this.values.filter(function(a) {
                return Object.keys(n).every(function(h) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7NEHj)))(a[h], n[h]);
                });
            }) : _this.values;
        }, _this.update = function() {
            var _ref = (0, $kSuI9._)(function(n, a) {
                var h;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this3.isInitialized(), _this3.logger.debug("Updating value"), _this3.logger.trace({
                                type: "method",
                                method: "update",
                                key: n,
                                update: a
                            });
                            h = $4bb3863dfa1867a4$var$Qt($4bb3863dfa1867a4$var$Qt({}, _this3.getData(n)), a);
                            _this3.map.set(n, h);
                            return [
                                4,
                                _this3.persist()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(n, a) {
                return _ref.apply(this, arguments);
            };
        }(), _this.delete = function() {
            var _ref = (0, $kSuI9._)(function(n, a) {
                var _tmp;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this4.isInitialized();
                            _tmp = _this4.map.has(n);
                            if (!_tmp) return [
                                3,
                                2
                            ];
                            _this4.logger.debug("Deleting value"), _this4.logger.trace({
                                type: "method",
                                method: "delete",
                                key: n,
                                reason: a
                            }), _this4.map.delete(n), _this4.addToRecentlyDeleted(n);
                            return [
                                4,
                                _this4.persist()
                            ];
                        case 1:
                            _tmp = _state.sent();
                            _state.label = 2;
                        case 2:
                            _tmp;
                            return [
                                2
                            ];
                    }
                });
            });
            return function(n, a) {
                return _ref.apply(this, arguments);
            };
        }(), _this.logger = (0, $7Gasr.generateChildLogger)(t, _this.name), _this.storagePrefix = i, _this.getKey = r;
        return (0, $3U0IP._)(_this);
    }
    (0, $1wc17._)(ei, [
        {
            key: "context",
            get: function get() {
                return (0, $7Gasr.getLoggerContext)(this.logger);
            }
        },
        {
            key: "storageKey",
            get: function get() {
                return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
            }
        },
        {
            key: "length",
            get: function get() {
                return this.map.size;
            }
        },
        {
            key: "keys",
            get: function get() {
                return Array.from(this.map.keys());
            }
        },
        {
            key: "values",
            get: function get() {
                return Array.from(this.map.values());
            }
        },
        {
            key: "addToRecentlyDeleted",
            value: function addToRecentlyDeleted(e) {
                this.recentlyDeleted.push(e), this.recentlyDeleted.length >= this.recentlyDeletedLimit && this.recentlyDeleted.splice(0, this.recentlyDeletedLimit / 2);
            }
        },
        {
            key: "setDataStore",
            value: function setDataStore(e) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.core.storage.setItem(_this.storageKey, e)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getDataStore",
            value: function getDataStore() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.core.storage.getItem(_this.storageKey)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getData",
            value: function getData(e) {
                var t = this.map.get(e);
                if (!t) {
                    if (this.recentlyDeleted.includes(e)) {
                        var _u = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "Record was recently deleted - ".concat(this.name, ": ").concat(e)), i = _u.message;
                        throw this.logger.error(i), new Error(i);
                    }
                    var _u1 = (0, $8wnFv.getInternalError)("NO_MATCHING_KEY", "".concat(this.name, ": ").concat(e)), s = _u1.message;
                    throw this.logger.error(s), new Error(s);
                }
                return t;
            }
        },
        {
            key: "persist",
            value: function persist() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.setDataStore(_this.values)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "restore",
            value: function restore() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _$e, _u, t, e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.getDataStore()
                                ];
                            case 1:
                                _$e = _state.sent();
                                if ((typeof _$e === "undefined" ? "undefined" : (0, $l0HdX._)(_$e)) > "u" || !_$e.length) return [
                                    2
                                ];
                                if (_this.map.size) {
                                    _u = (0, $8wnFv.getInternalError)("RESTORE_WILL_OVERRIDE", _this.name), t = _u.message;
                                    throw _this.logger.error(t), new Error(t);
                                }
                                _this.cached = _$e, _this.logger.debug("Successfully Restored value for ".concat(_this.name)), _this.logger.trace({
                                    type: "method",
                                    method: "restore",
                                    value: _this.values
                                });
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                e = _state.sent();
                                _this.logger.debug("Failed to Restore value for ".concat(_this.name)), _this.logger.error(e);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "isInitialized",
            value: function isInitialized() {
                if (!this.initialized) {
                    var _u = (0, $8wnFv.getInternalError)("NOT_INITIALIZED", this.name), e = _u.message;
                    throw new Error(e);
                }
            }
        }
    ]);
    return ei;
}((0, $3WrnC.IStore));
var $4bb3863dfa1867a4$export$3370ee24730992a3 = /*#__PURE__*/ function() {
    "use strict";
    function ti(e, t) {
        var _this = this;
        (0, $4GJKx._)(this, ti);
        var _this1 = this;
        var _this2 = this;
        var _this3 = this;
        var _this4 = this;
        var _this5 = this;
        var _this6 = this;
        var _this7 = this;
        var _this8 = this;
        var _this9 = this;
        var _this10 = this;
        var _this11 = this;
        var _this12 = this;
        var _this13 = this;
        var _this14 = this;
        var _this15 = this;
        var _this16 = this;
        var _this17 = this;
        var _this18 = this;
        var _this19 = this;
        var _this20 = this;
        this.core = e, this.logger = t, this.name = $4bb3863dfa1867a4$export$390360ea476c6145, this.version = $4bb3863dfa1867a4$export$5593ec74b27d1b18, this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($cyxGb))), this.initialized = !1, this.storagePrefix = $4bb3863dfa1867a4$export$f258d29ae5e3d545, this.ignoredPayloadTypes = [
            (0, $8wnFv.TYPE_1)
        ], this.registeredMethods = [], this.init = /*#__PURE__*/ (0, $kSuI9._)(function() {
            var _tmp;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = _this1.initialized;
                        if (_tmp) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            _this1.pairings.init()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            _this1.cleanup()
                        ];
                    case 2:
                        _tmp = (_state.sent(), _this1.registerRelayerEvents(), _this1.registerExpirerEvents(), _this1.initialized = !0, _this1.logger.trace("Initialized"));
                        _state.label = 3;
                    case 3:
                        _tmp;
                        return [
                            2
                        ];
                }
            });
        }), this.register = function(param) {
            var s = param.methods;
            _this.isInitialized(), _this.registeredMethods = (0, $c6Xmf._)(new Set((0, $c6Xmf._)(_this.registeredMethods).concat((0, $c6Xmf._)(s))));
        }, this.create = function() {
            var _ref = (0, $kSuI9._)(function(s) {
                var i, r, n, a, h, c;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this2.isInitialized();
                            i = (0, $8wnFv.generateRandomBytes32)();
                            return [
                                4,
                                _this2.core.crypto.setSymKey(i)
                            ];
                        case 1:
                            r = _state.sent(), n = (0, $8wnFv.calcExpiry)((0, $4BEBs.FIVE_MINUTES)), a = {
                                protocol: $4bb3863dfa1867a4$export$822d0bd1635d5360
                            }, h = {
                                topic: r,
                                expiry: n,
                                relay: a,
                                active: !1
                            }, c = (0, $8wnFv.formatUri)({
                                protocol: _this2.core.protocol,
                                version: _this2.core.version,
                                topic: r,
                                symKey: i,
                                relay: a,
                                expiryTimestamp: n,
                                methods: s === null || s === void 0 ? void 0 : s.methods
                            });
                            _this2.core.expirer.set(r, n);
                            return [
                                4,
                                _this2.pairings.set(r, h)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                4,
                                _this2.core.relayer.subscribe(r)
                            ];
                        case 3:
                            return [
                                2,
                                (_state.sent(), {
                                    topic: r,
                                    uri: c
                                })
                            ];
                    }
                });
            });
            return function(s) {
                return _ref.apply(this, arguments);
            };
        }(), this.pair = function() {
            var _ref = (0, $kSuI9._)(function(s) {
                var i, _Ae, r, n, a, h, c, d, g, b, _tmp, _tmp1, e, m;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this3.isInitialized();
                            i = _this3.core.eventClient.createEvent({
                                properties: {
                                    topic: s === null || s === void 0 ? void 0 : s.uri,
                                    trace: [
                                        $4bb3863dfa1867a4$export$6736f9bb609b5d34.pairing_started
                                    ]
                                }
                            });
                            _this3.isValidPair(s, i);
                            _Ae = (0, $8wnFv.parseUri)(s.uri), r = _Ae.topic, n = _Ae.symKey, a = _Ae.relay, h = _Ae.expiryTimestamp, c = _Ae.methods;
                            i.props.properties.topic = r, i.addTrace($4bb3863dfa1867a4$export$6736f9bb609b5d34.pairing_uri_validation_success), i.addTrace($4bb3863dfa1867a4$export$6736f9bb609b5d34.pairing_uri_not_expired);
                            if (_this3.pairings.keys.includes(r)) {
                                if (d = _this3.pairings.get(r), i.addTrace($4bb3863dfa1867a4$export$6736f9bb609b5d34.existing_pairing), d.active) throw i.setError($4bb3863dfa1867a4$export$e1dc85b7b7495247.active_pairing_already_exists), new Error("Pairing already exists: ".concat(r, ". Please try again with a new connection URI."));
                                i.addTrace($4bb3863dfa1867a4$export$6736f9bb609b5d34.pairing_not_expired);
                            }
                            g = h || (0, $8wnFv.calcExpiry)((0, $4BEBs.FIVE_MINUTES)), b = {
                                topic: r,
                                relay: a,
                                expiry: g,
                                active: !1,
                                methods: c
                            };
                            _this3.core.expirer.set(r, g);
                            return [
                                4,
                                _this3.pairings.set(r, b)
                            ];
                        case 1:
                            _state.sent(), i.addTrace($4bb3863dfa1867a4$export$6736f9bb609b5d34.store_new_pairing);
                            _tmp = s.activatePairing;
                            if (!_tmp) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                _this3.activate({
                                    topic: r
                                })
                            ];
                        case 2:
                            _tmp = _state.sent();
                            _state.label = 3;
                        case 3:
                            _tmp, _this3.events.emit($4bb3863dfa1867a4$export$ca3c0b962acf7b75.create, b), i.addTrace($4bb3863dfa1867a4$export$6736f9bb609b5d34.emit_inactive_pairing);
                            _tmp1 = _this3.core.crypto.keychain.has(r);
                            if (_tmp1) return [
                                3,
                                5
                            ];
                            return [
                                4,
                                _this3.core.crypto.setSymKey(n, r)
                            ];
                        case 4:
                            _tmp1 = _state.sent();
                            _state.label = 5;
                        case 5:
                            _tmp1, i.addTrace($4bb3863dfa1867a4$export$6736f9bb609b5d34.subscribing_pairing_topic);
                            _state.label = 6;
                        case 6:
                            _state.trys.push([
                                6,
                                8,
                                ,
                                9
                            ]);
                            return [
                                4,
                                _this3.core.relayer.confirmOnlineStateOrThrow()
                            ];
                        case 7:
                            _state.sent();
                            return [
                                3,
                                9
                            ];
                        case 8:
                            e = _state.sent();
                            i.setError($4bb3863dfa1867a4$export$e1dc85b7b7495247.no_internet_connection);
                            return [
                                3,
                                9
                            ];
                        case 9:
                            _state.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4,
                                _this3.core.relayer.subscribe(r, {
                                    relay: a
                                })
                            ];
                        case 10:
                            _state.sent();
                            return [
                                3,
                                12
                            ];
                        case 11:
                            m = _state.sent();
                            throw i.setError($4bb3863dfa1867a4$export$e1dc85b7b7495247.subscribe_pairing_topic_failure), m;
                        case 12:
                            return [
                                2,
                                (i.addTrace($4bb3863dfa1867a4$export$6736f9bb609b5d34.subscribe_pairing_topic_success), b)
                            ];
                    }
                });
            });
            return function(s) {
                return _ref.apply(this, arguments);
            };
        }(), this.activate = function() {
            var _ref = (0, $kSuI9._)(function(param) {
                var s, i;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            s = param.topic;
                            _this4.isInitialized();
                            i = (0, $8wnFv.calcExpiry)((0, $4BEBs.THIRTY_DAYS));
                            _this4.core.expirer.set(s, i);
                            return [
                                4,
                                _this4.pairings.update(s, {
                                    active: !0,
                                    expiry: i
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(), this.ping = function() {
            var _ref = (0, $kSuI9._)(function(s) {
                var i, r, _Yi, n, a, h;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this5.isInitialized();
                            return [
                                4,
                                _this5.isValidPing(s)
                            ];
                        case 1:
                            _state.sent();
                            i = s.topic;
                            if (!_this5.pairings.keys.includes(i)) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                _this5.sendRequest(i, "wc_pairingPing", {})
                            ];
                        case 2:
                            r = _state.sent(), _Yi = (0, $8wnFv.createDelayedPromise)(), n = _Yi.done, a = _Yi.resolve, h = _Yi.reject;
                            _this5.events.once((0, $8wnFv.engineEvent)("pairing_ping", r), function(param) {
                                var c = param.error;
                                c ? h(c) : a();
                            });
                            return [
                                4,
                                n()
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(s) {
                return _ref.apply(this, arguments);
            };
        }(), this.updateExpiry = function() {
            var _ref = (0, $kSuI9._)(function(param) {
                var s, i;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            s = param.topic, i = param.expiry;
                            _this6.isInitialized();
                            return [
                                4,
                                _this6.pairings.update(s, {
                                    expiry: i
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(), this.updateMetadata = function() {
            var _ref = (0, $kSuI9._)(function(param) {
                var s, i;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            s = param.topic, i = param.metadata;
                            _this7.isInitialized();
                            return [
                                4,
                                _this7.pairings.update(s, {
                                    peerMetadata: i
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(), this.getPairings = function() {
            return _this.isInitialized(), _this.pairings.values;
        }, this.disconnect = function() {
            var _ref = (0, $kSuI9._)(function(s) {
                var i, _tmp;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this8.isInitialized();
                            return [
                                4,
                                _this8.isValidDisconnect(s)
                            ];
                        case 1:
                            _state.sent();
                            i = s.topic;
                            _tmp = _this8.pairings.keys.includes(i);
                            if (!_tmp) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                _this8.sendRequest(i, "wc_pairingDelete", (0, $8wnFv.getSdkError)("USER_DISCONNECTED"))
                            ];
                        case 2:
                            _state.sent();
                            return [
                                4,
                                _this8.deletePairing(i)
                            ];
                        case 3:
                            _tmp = _state.sent();
                            _state.label = 4;
                        case 4:
                            _tmp;
                            return [
                                2
                            ];
                    }
                });
            });
            return function(s) {
                return _ref.apply(this, arguments);
            };
        }(), this.sendRequest = function() {
            var _ref = (0, $kSuI9._)(function(s, i, r) {
                var n, a, h;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            n = (0, $3W2Mc.formatJsonRpcRequest)(i, r);
                            return [
                                4,
                                _this9.core.crypto.encode(s, n)
                            ];
                        case 1:
                            a = _state.sent(), h = $4bb3863dfa1867a4$export$d94d6986a8185883[i].req;
                            return [
                                2,
                                (_this9.core.history.set(s, n), _this9.core.relayer.publish(s, a, h), n.id)
                            ];
                    }
                });
            });
            return function(s, i, r) {
                return _ref.apply(this, arguments);
            };
        }(), this.sendResult = function() {
            var _ref = (0, $kSuI9._)(function(s, i, r) {
                var n, a, h, c;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            n = (0, $3W2Mc.formatJsonRpcResult)(s, r);
                            return [
                                4,
                                _this10.core.crypto.encode(i, n)
                            ];
                        case 1:
                            a = _state.sent();
                            return [
                                4,
                                _this10.core.history.get(i, s)
                            ];
                        case 2:
                            h = _state.sent(), c = $4bb3863dfa1867a4$export$d94d6986a8185883[h.request.method].res;
                            return [
                                4,
                                _this10.core.relayer.publish(i, a, c)
                            ];
                        case 3:
                            _state.sent();
                            return [
                                4,
                                _this10.core.history.resolve(n)
                            ];
                        case 4:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(s, i, r) {
                return _ref.apply(this, arguments);
            };
        }(), this.sendError = function() {
            var _ref = (0, $kSuI9._)(function(s, i, r) {
                var n, a, h, c;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            n = (0, $3W2Mc.formatJsonRpcError)(s, r);
                            return [
                                4,
                                _this11.core.crypto.encode(i, n)
                            ];
                        case 1:
                            a = _state.sent();
                            return [
                                4,
                                _this11.core.history.get(i, s)
                            ];
                        case 2:
                            h = _state.sent(), c = $4bb3863dfa1867a4$export$d94d6986a8185883[h.request.method] ? $4bb3863dfa1867a4$export$d94d6986a8185883[h.request.method].res : $4bb3863dfa1867a4$export$d94d6986a8185883.unregistered_method.res;
                            return [
                                4,
                                _this11.core.relayer.publish(i, a, c)
                            ];
                        case 3:
                            _state.sent();
                            return [
                                4,
                                _this11.core.history.resolve(n)
                            ];
                        case 4:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(s, i, r) {
                return _ref.apply(this, arguments);
            };
        }(), this.deletePairing = function() {
            var _ref = (0, $kSuI9._)(function(s, i) {
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this12.core.relayer.unsubscribe(s)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                Promise.all([
                                    _this12.pairings.delete(s, (0, $8wnFv.getSdkError)("USER_DISCONNECTED")),
                                    _this12.core.crypto.deleteSymKey(s),
                                    i ? Promise.resolve() : _this12.core.expirer.del(s)
                                ])
                            ];
                        case 2:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(s, i) {
                return _ref.apply(this, arguments);
            };
        }(), this.cleanup = /*#__PURE__*/ (0, $kSuI9._)(function() {
            var s;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        s = _this13.pairings.getAll().filter(function(i) {
                            return (0, $8wnFv.isExpired)(i.expiry);
                        });
                        return [
                            4,
                            Promise.all(s.map(function(i) {
                                return _this13.deletePairing(i.topic);
                            }))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        }), this.onRelayEventRequest = function(s) {
            var i = s.topic, r = s.payload;
            switch(r.method){
                case "wc_pairingPing":
                    return _this.onPairingPingRequest(i, r);
                case "wc_pairingDelete":
                    return _this.onPairingDeleteRequest(i, r);
                default:
                    return _this.onUnknownRpcMethodRequest(i, r);
            }
        }, this.onRelayEventResponse = function() {
            var _ref = (0, $kSuI9._)(function(s) {
                var i, r, n;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            i = s.topic, r = s.payload;
                            return [
                                4,
                                _this14.core.history.get(i, r.id)
                            ];
                        case 1:
                            n = _state.sent().request.method;
                            switch(n){
                                case "wc_pairingPing":
                                    return [
                                        2,
                                        _this14.onPairingPingResponse(i, r)
                                    ];
                                default:
                                    return [
                                        2,
                                        _this14.onUnknownRpcMethodResponse(n)
                                    ];
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function(s) {
                return _ref.apply(this, arguments);
            };
        }(), this.onPairingPingRequest = function() {
            var _ref = (0, $kSuI9._)(function(s, i) {
                var r, n;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            r = i.id;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                5
                            ]);
                            _this15.isValidPing({
                                topic: s
                            });
                            return [
                                4,
                                _this15.sendResult(r, s, !0)
                            ];
                        case 2:
                            _state.sent(), _this15.events.emit($4bb3863dfa1867a4$export$ca3c0b962acf7b75.ping, {
                                id: r,
                                topic: s
                            });
                            return [
                                3,
                                5
                            ];
                        case 3:
                            n = _state.sent();
                            return [
                                4,
                                _this15.sendError(r, s, n)
                            ];
                        case 4:
                            _state.sent(), _this15.logger.error(n);
                            return [
                                3,
                                5
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(s, i) {
                return _ref.apply(this, arguments);
            };
        }(), this.onPairingPingResponse = function(s, i) {
            var r = i.id;
            setTimeout(function() {
                (0, $5lf06.isJsonRpcResult)(i) ? _this.events.emit((0, $8wnFv.engineEvent)("pairing_ping", r), {}) : (0, $5lf06.isJsonRpcError)(i) && _this.events.emit((0, $8wnFv.engineEvent)("pairing_ping", r), {
                    error: i.error
                });
            }, 500);
        }, this.onPairingDeleteRequest = function() {
            var _ref = (0, $kSuI9._)(function(s, i) {
                var r, n;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            r = i.id;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                5
                            ]);
                            _this16.isValidDisconnect({
                                topic: s
                            });
                            return [
                                4,
                                _this16.deletePairing(s)
                            ];
                        case 2:
                            _state.sent(), _this16.events.emit($4bb3863dfa1867a4$export$ca3c0b962acf7b75.delete, {
                                id: r,
                                topic: s
                            });
                            return [
                                3,
                                5
                            ];
                        case 3:
                            n = _state.sent();
                            return [
                                4,
                                _this16.sendError(r, s, n)
                            ];
                        case 4:
                            _state.sent(), _this16.logger.error(n);
                            return [
                                3,
                                5
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(s, i) {
                return _ref.apply(this, arguments);
            };
        }(), this.onUnknownRpcMethodRequest = function() {
            var _ref = (0, $kSuI9._)(function(s, i) {
                var r, n, _$a, a;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            r = i.id, n = i.method;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                5
                            ]);
                            if (_this17.registeredMethods.includes(n)) return [
                                2
                            ];
                            _$a = (0, $8wnFv.getSdkError)("WC_METHOD_UNSUPPORTED", n);
                            return [
                                4,
                                _this17.sendError(r, s, _$a)
                            ];
                        case 2:
                            _state.sent(), _this17.logger.error(_$a);
                            return [
                                3,
                                5
                            ];
                        case 3:
                            a = _state.sent();
                            return [
                                4,
                                _this17.sendError(r, s, a)
                            ];
                        case 4:
                            _state.sent(), _this17.logger.error(a);
                            return [
                                3,
                                5
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(s, i) {
                return _ref.apply(this, arguments);
            };
        }(), this.onUnknownRpcMethodResponse = function(s) {
            _this.registeredMethods.includes(s) || _this.logger.error((0, $8wnFv.getSdkError)("WC_METHOD_UNSUPPORTED", s));
        }, this.isValidPair = function(s, i) {
            var r;
            if (!(0, $8wnFv.isValidParams)(s)) {
                var _u = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "pair() params: ".concat(s)), a = _u.message;
                throw i.setError($4bb3863dfa1867a4$export$e1dc85b7b7495247.malformed_pairing_uri), new Error(a);
            }
            if (!(0, $8wnFv.isValidUrl)(s.uri)) {
                var _u1 = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "pair() uri: ".concat(s.uri)), a1 = _u1.message;
                throw i.setError($4bb3863dfa1867a4$export$e1dc85b7b7495247.malformed_pairing_uri), new Error(a1);
            }
            var n = (0, $8wnFv.parseUri)(s === null || s === void 0 ? void 0 : s.uri);
            if (!((r = n === null || n === void 0 ? void 0 : n.relay) != null && r.protocol)) {
                var _u2 = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "pair() uri#relay-protocol"), a2 = _u2.message;
                throw i.setError($4bb3863dfa1867a4$export$e1dc85b7b7495247.malformed_pairing_uri), new Error(a2);
            }
            if (!(n != null && n.symKey)) {
                var _u3 = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "pair() uri#symKey"), a3 = _u3.message;
                throw i.setError($4bb3863dfa1867a4$export$e1dc85b7b7495247.malformed_pairing_uri), new Error(a3);
            }
            if (n != null && n.expiryTimestamp && (0, $4BEBs.toMiliseconds)(n === null || n === void 0 ? void 0 : n.expiryTimestamp) < Date.now()) {
                i.setError($4bb3863dfa1867a4$export$e1dc85b7b7495247.pairing_expired);
                var _u4 = (0, $8wnFv.getInternalError)("EXPIRED", "pair() URI has expired. Please try again with a new connection URI."), a4 = _u4.message;
                throw new Error(a4);
            }
        }, this.isValidPing = function() {
            var _ref = (0, $kSuI9._)(function(s) {
                var _u, r, i;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(0, $8wnFv.isValidParams)(s)) {
                                _u = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "ping() params: ".concat(s)), r = _u.message;
                                throw new Error(r);
                            }
                            i = s.topic;
                            return [
                                4,
                                _this18.isValidPairingTopic(i)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(s) {
                return _ref.apply(this, arguments);
            };
        }(), this.isValidDisconnect = function() {
            var _ref = (0, $kSuI9._)(function(s) {
                var _u, r, i;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(0, $8wnFv.isValidParams)(s)) {
                                _u = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "disconnect() params: ".concat(s)), r = _u.message;
                                throw new Error(r);
                            }
                            i = s.topic;
                            return [
                                4,
                                _this19.isValidPairingTopic(i)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(s) {
                return _ref.apply(this, arguments);
            };
        }(), this.isValidPairingTopic = function() {
            var _ref = (0, $kSuI9._)(function(s) {
                var _u, i, _u1, i1, _u2, i2;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(0, $8wnFv.isValidString)(s, !1)) {
                                _u = (0, $8wnFv.getInternalError)("MISSING_OR_INVALID", "pairing topic should be a string: ".concat(s)), i = _u.message;
                                throw new Error(i);
                            }
                            if (!_this20.pairings.keys.includes(s)) {
                                _u1 = (0, $8wnFv.getInternalError)("NO_MATCHING_KEY", "pairing topic doesn't exist: ".concat(s)), i1 = _u1.message;
                                throw new Error(i1);
                            }
                            if (!(0, $8wnFv.isExpired)(_this20.pairings.get(s).expiry)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _this20.deletePairing(s)
                            ];
                        case 1:
                            _state.sent();
                            _u2 = (0, $8wnFv.getInternalError)("EXPIRED", "pairing topic: ".concat(s)), i2 = _u2.message;
                            throw new Error(i2);
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(s) {
                return _ref.apply(this, arguments);
            };
        }(), this.core = e, this.logger = (0, $7Gasr.generateChildLogger)(t, this.name), this.pairings = new $4bb3863dfa1867a4$export$390f32400eaf98c9(this.core, this.logger, this.name, this.storagePrefix);
    }
    (0, $1wc17._)(ti, [
        {
            key: "context",
            get: function get() {
                return (0, $7Gasr.getLoggerContext)(this.logger);
            }
        },
        {
            key: "isInitialized",
            value: function isInitialized() {
                if (!this.initialized) {
                    var _u = (0, $8wnFv.getInternalError)("NOT_INITIALIZED", this.name), e = _u.message;
                    throw new Error(e);
                }
            }
        },
        {
            key: "registerRelayerEvents",
            value: function registerRelayerEvents() {
                var _this = this;
                this.core.relayer.on($4bb3863dfa1867a4$export$d56245796e2837d.message, function() {
                    var _ref = (0, $kSuI9._)(function(e) {
                        var t, s, i, _tmp, _tmp1, r;
                        return (0, $eha6O.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    t = e.topic, s = e.message;
                                    if (!_this.pairings.keys.includes(t) || _this.ignoredPayloadTypes.includes(_this.core.crypto.getPayloadType(s))) return [
                                        2
                                    ];
                                    return [
                                        4,
                                        _this.core.crypto.decode(t, s)
                                    ];
                                case 1:
                                    i = _state.sent();
                                    _state.label = 2;
                                case 2:
                                    _state.trys.push([
                                        2,
                                        8,
                                        ,
                                        9
                                    ]);
                                    if (!(0, $5lf06.isJsonRpcRequest)(i)) return [
                                        3,
                                        3
                                    ];
                                    _tmp = (_this.core.history.set(t, i), _this.onRelayEventRequest({
                                        topic: t,
                                        payload: i
                                    }));
                                    return [
                                        3,
                                        7
                                    ];
                                case 3:
                                    _tmp1 = (0, $5lf06.isJsonRpcResponse)(i);
                                    if (!_tmp1) return [
                                        3,
                                        6
                                    ];
                                    return [
                                        4,
                                        _this.core.history.resolve(i)
                                    ];
                                case 4:
                                    _state.sent();
                                    return [
                                        4,
                                        _this.onRelayEventResponse({
                                            topic: t,
                                            payload: i
                                        })
                                    ];
                                case 5:
                                    _tmp1 = (_state.sent(), _this.core.history.delete(t, i.id));
                                    _state.label = 6;
                                case 6:
                                    _tmp = _tmp1;
                                    _state.label = 7;
                                case 7:
                                    _tmp;
                                    return [
                                        3,
                                        9
                                    ];
                                case 8:
                                    r = _state.sent();
                                    _this.logger.error(r);
                                    return [
                                        3,
                                        9
                                    ];
                                case 9:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(e) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        },
        {
            key: "registerExpirerEvents",
            value: function registerExpirerEvents() {
                var _this = this;
                this.core.expirer.on($4bb3863dfa1867a4$export$9013719d9206b0c1.expired, function() {
                    var _ref = (0, $kSuI9._)(function(e) {
                        var _Xi, t, _tmp;
                        return (0, $eha6O.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _Xi = (0, $8wnFv.parseExpirerTarget)(e.target), t = _Xi.topic;
                                    _tmp = t && _this.pairings.keys.includes(t);
                                    if (!_tmp) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        _this.deletePairing(t, !0)
                                    ];
                                case 1:
                                    _tmp = (_state.sent(), _this.events.emit($4bb3863dfa1867a4$export$ca3c0b962acf7b75.expire, {
                                        topic: t
                                    }));
                                    _state.label = 2;
                                case 2:
                                    _tmp;
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(e) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        }
    ]);
    return ti;
}();
var $4bb3863dfa1867a4$export$eeb4f10f25d479cb = /*#__PURE__*/ function(wi) {
    "use strict";
    (0, $dcsZi._)(ii, wi);
    var _super = (0, $ohfOJ._)(ii);
    function ii(e, t) {
        (0, $4GJKx._)(this, ii);
        var _this;
        var _this1 = (0, $d3H5E._)(_this);
        var _this2 = (0, $d3H5E._)(_this);
        var _this3 = (0, $d3H5E._)(_this);
        var _this4 = (0, $d3H5E._)(_this);
        _this = _super.call(this, e, t), _this.core = e, _this.logger = t, _this.records = new Map, _this.events = new (0, $cyxGb.EventEmitter), _this.name = $4bb3863dfa1867a4$export$160142c73cb99dc3, _this.version = $4bb3863dfa1867a4$export$8eba9ce85616c607, _this.cached = [], _this.initialized = !1, _this.storagePrefix = $4bb3863dfa1867a4$export$f258d29ae5e3d545, _this.init = /*#__PURE__*/ (0, $kSuI9._)(function() {
            var _tmp;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = _this1.initialized;
                        if (_tmp) return [
                            3,
                            2
                        ];
                        _this1.logger.trace("Initialized");
                        return [
                            4,
                            _this1.restore()
                        ];
                    case 1:
                        _tmp = (_state.sent(), _this1.cached.forEach(function(s) {
                            return _this1.records.set(s.id, s);
                        }), _this1.cached = [], _this1.registerEventListeners(), _this1.initialized = !0);
                        _state.label = 2;
                    case 2:
                        _tmp;
                        return [
                            2
                        ];
                }
            });
        }), _this.set = function(s, i, r) {
            if (_this.isInitialized(), _this.logger.debug("Setting JSON-RPC request history record"), _this.logger.trace({
                type: "method",
                method: "set",
                topic: s,
                request: i,
                chainId: r
            }), _this.records.has(i.id)) return;
            var n = {
                id: i.id,
                topic: s,
                request: {
                    method: i.method,
                    params: i.params || null
                },
                chainId: r,
                expiry: (0, $8wnFv.calcExpiry)((0, $4BEBs.THIRTY_DAYS))
            };
            _this.records.set(n.id, n), _this.persist(), _this.events.emit($4bb3863dfa1867a4$export$a682338b5ffca937.created, n);
        }, _this.resolve = function() {
            var _ref = (0, $kSuI9._)(function(s) {
                var i;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (_this2.isInitialized(), _this2.logger.debug("Updating JSON-RPC response history record"), _this2.logger.trace({
                                type: "method",
                                method: "update",
                                response: s
                            }), !_this2.records.has(s.id)) return [
                                2
                            ];
                            return [
                                4,
                                _this2.getRecord(s.id)
                            ];
                        case 1:
                            i = _state.sent();
                            (0, $l0HdX._)(i.response) > "u" && (i.response = (0, $5lf06.isJsonRpcError)(s) ? {
                                error: s.error
                            } : {
                                result: s.result
                            }, _this2.records.set(i.id, i), _this2.persist(), _this2.events.emit($4bb3863dfa1867a4$export$a682338b5ffca937.updated, i));
                            return [
                                2
                            ];
                    }
                });
            });
            return function(s) {
                return _ref.apply(this, arguments);
            };
        }(), _this.get = function() {
            var _ref = (0, $kSuI9._)(function(s, i) {
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this3.isInitialized(), _this3.logger.debug("Getting record"), _this3.logger.trace({
                                type: "method",
                                method: "get",
                                topic: s,
                                id: i
                            });
                            return [
                                4,
                                _this3.getRecord(i)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(s, i) {
                return _ref.apply(this, arguments);
            };
        }(), _this.delete = function(s, i) {
            _this.isInitialized(), _this.logger.debug("Deleting record"), _this.logger.trace({
                type: "method",
                method: "delete",
                id: i
            }), _this.values.forEach(function(r) {
                if (r.topic === s) {
                    if ((typeof i === "undefined" ? "undefined" : (0, $l0HdX._)(i)) < "u" && r.id !== i) return;
                    _this.records.delete(r.id), _this.events.emit($4bb3863dfa1867a4$export$a682338b5ffca937.deleted, r);
                }
            }), _this.persist();
        }, _this.exists = function() {
            var _ref = (0, $kSuI9._)(function(s, i) {
                var _tmp;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this4.isInitialized();
                            if (!_this4.records.has(i)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _this4.getRecord(i)
                            ];
                        case 1:
                            _tmp = _state.sent().topic === s;
                            return [
                                3,
                                3
                            ];
                        case 2:
                            _tmp = !1;
                            _state.label = 3;
                        case 3:
                            return [
                                2,
                                _tmp
                            ];
                    }
                });
            });
            return function(s, i) {
                return _ref.apply(this, arguments);
            };
        }(), _this.on = function(s, i) {
            _this.events.on(s, i);
        }, _this.once = function(s, i) {
            _this.events.once(s, i);
        }, _this.off = function(s, i) {
            _this.events.off(s, i);
        }, _this.removeListener = function(s, i) {
            _this.events.removeListener(s, i);
        }, _this.logger = (0, $7Gasr.generateChildLogger)(t, _this.name);
        return (0, $3U0IP._)(_this);
    }
    (0, $1wc17._)(ii, [
        {
            key: "context",
            get: function get() {
                return (0, $7Gasr.getLoggerContext)(this.logger);
            }
        },
        {
            key: "storageKey",
            get: function get() {
                return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
            }
        },
        {
            key: "size",
            get: function get() {
                return this.records.size;
            }
        },
        {
            key: "keys",
            get: function get() {
                return Array.from(this.records.keys());
            }
        },
        {
            key: "values",
            get: function get() {
                return Array.from(this.records.values());
            }
        },
        {
            key: "pending",
            get: function get() {
                var e = [];
                return this.values.forEach(function(t) {
                    if ((0, $l0HdX._)(t.response) < "u") return;
                    var s = {
                        topic: t.topic,
                        request: (0, $3W2Mc.formatJsonRpcRequest)(t.request.method, t.request.params, t.id),
                        chainId: t.chainId
                    };
                    return e.push(s);
                }), e;
            }
        },
        {
            key: "setJsonRpcRecords",
            value: function setJsonRpcRecords(e) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.core.storage.setItem(_this.storageKey, e)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getJsonRpcRecords",
            value: function getJsonRpcRecords() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.core.storage.getItem(_this.storageKey)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getRecord",
            value: function getRecord(e) {
                this.isInitialized();
                var t = this.records.get(e);
                if (!t) {
                    var _u = (0, $8wnFv.getInternalError)("NO_MATCHING_KEY", "".concat(this.name, ": ").concat(e)), s = _u.message;
                    throw new Error(s);
                }
                return t;
            }
        },
        {
            key: "persist",
            value: function persist() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.setJsonRpcRecords(_this.values)
                                ];
                            case 1:
                                _state.sent(), _this.events.emit($4bb3863dfa1867a4$export$a682338b5ffca937.sync);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "restore",
            value: function restore() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _$e, _u, t, e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.getJsonRpcRecords()
                                ];
                            case 1:
                                _$e = _state.sent();
                                if ((typeof _$e === "undefined" ? "undefined" : (0, $l0HdX._)(_$e)) > "u" || !_$e.length) return [
                                    2
                                ];
                                if (_this.records.size) {
                                    _u = (0, $8wnFv.getInternalError)("RESTORE_WILL_OVERRIDE", _this.name), t = _u.message;
                                    throw _this.logger.error(t), new Error(t);
                                }
                                _this.cached = _$e, _this.logger.debug("Successfully Restored records for ".concat(_this.name)), _this.logger.trace({
                                    type: "method",
                                    method: "restore",
                                    records: _this.values
                                });
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                e = _state.sent();
                                _this.logger.debug("Failed to Restore records for ".concat(_this.name)), _this.logger.error(e);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "registerEventListeners",
            value: function registerEventListeners() {
                var _this = this;
                this.events.on($4bb3863dfa1867a4$export$a682338b5ffca937.created, function(e) {
                    var t = $4bb3863dfa1867a4$export$a682338b5ffca937.created;
                    _this.logger.info("Emitting ".concat(t)), _this.logger.debug({
                        type: "event",
                        event: t,
                        record: e
                    });
                }), this.events.on($4bb3863dfa1867a4$export$a682338b5ffca937.updated, function(e) {
                    var t = $4bb3863dfa1867a4$export$a682338b5ffca937.updated;
                    _this.logger.info("Emitting ".concat(t)), _this.logger.debug({
                        type: "event",
                        event: t,
                        record: e
                    });
                }), this.events.on($4bb3863dfa1867a4$export$a682338b5ffca937.deleted, function(e) {
                    var t = $4bb3863dfa1867a4$export$a682338b5ffca937.deleted;
                    _this.logger.info("Emitting ".concat(t)), _this.logger.debug({
                        type: "event",
                        event: t,
                        record: e
                    });
                }), this.core.heartbeat.on((0, $8nsA4.HEARTBEAT_EVENTS).pulse, function() {
                    _this.cleanup();
                });
            }
        },
        {
            key: "cleanup",
            value: function cleanup() {
                var _this = this;
                try {
                    this.isInitialized();
                    var _$e = !1;
                    this.records.forEach(function(t) {
                        (0, $4BEBs.toMiliseconds)(t.expiry || 0) - Date.now() <= 0 && (_this.logger.info("Deleting expired history log: ".concat(t.id)), _this.records.delete(t.id), _this.events.emit($4bb3863dfa1867a4$export$a682338b5ffca937.deleted, t, !1), _$e = !0);
                    }), _$e && this.persist();
                } catch (e) {
                    this.logger.warn(e);
                }
            }
        },
        {
            key: "isInitialized",
            value: function isInitialized() {
                if (!this.initialized) {
                    var _u = (0, $8wnFv.getInternalError)("NOT_INITIALIZED", this.name), e = _u.message;
                    throw new Error(e);
                }
            }
        }
    ]);
    return ii;
}((0, $3WrnC.IJsonRpcHistory));
var $4bb3863dfa1867a4$export$e76805ce609031cb = /*#__PURE__*/ function(Ii) {
    "use strict";
    (0, $dcsZi._)(si, Ii);
    var _super = (0, $ohfOJ._)(si);
    function si(e, t) {
        (0, $4GJKx._)(this, si);
        var _this;
        var _this1 = (0, $d3H5E._)(_this);
        _this = _super.call(this, e, t), _this.core = e, _this.logger = t, _this.expirations = new Map, _this.events = new (0, $cyxGb.EventEmitter), _this.name = $4bb3863dfa1867a4$export$4ddf883392bbc828, _this.version = $4bb3863dfa1867a4$export$717295846191925d, _this.cached = [], _this.initialized = !1, _this.storagePrefix = $4bb3863dfa1867a4$export$f258d29ae5e3d545, _this.init = /*#__PURE__*/ (0, $kSuI9._)(function() {
            var _tmp;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = _this1.initialized;
                        if (_tmp) return [
                            3,
                            2
                        ];
                        _this1.logger.trace("Initialized");
                        return [
                            4,
                            _this1.restore()
                        ];
                    case 1:
                        _tmp = (_state.sent(), _this1.cached.forEach(function(s) {
                            return _this1.expirations.set(s.target, s);
                        }), _this1.cached = [], _this1.registerEventListeners(), _this1.initialized = !0);
                        _state.label = 2;
                    case 2:
                        _tmp;
                        return [
                            2
                        ];
                }
            });
        }), _this.has = function(s) {
            try {
                var i = _this.formatTarget(s);
                return (0, $l0HdX._)(_this.getExpiration(i)) < "u";
            } catch (e) {
                return !1;
            }
        }, _this.set = function(s, i) {
            _this.isInitialized();
            var r = _this.formatTarget(s), n = {
                target: r,
                expiry: i
            };
            _this.expirations.set(r, n), _this.checkExpiry(r, n), _this.events.emit($4bb3863dfa1867a4$export$9013719d9206b0c1.created, {
                target: r,
                expiration: n
            });
        }, _this.get = function(s) {
            _this.isInitialized();
            var i = _this.formatTarget(s);
            return _this.getExpiration(i);
        }, _this.del = function(s) {
            if (_this.isInitialized(), _this.has(s)) {
                var i = _this.formatTarget(s), r = _this.getExpiration(i);
                _this.expirations.delete(i), _this.events.emit($4bb3863dfa1867a4$export$9013719d9206b0c1.deleted, {
                    target: i,
                    expiration: r
                });
            }
        }, _this.on = function(s, i) {
            _this.events.on(s, i);
        }, _this.once = function(s, i) {
            _this.events.once(s, i);
        }, _this.off = function(s, i) {
            _this.events.off(s, i);
        }, _this.removeListener = function(s, i) {
            _this.events.removeListener(s, i);
        }, _this.logger = (0, $7Gasr.generateChildLogger)(t, _this.name);
        return (0, $3U0IP._)(_this);
    }
    (0, $1wc17._)(si, [
        {
            key: "context",
            get: function get() {
                return (0, $7Gasr.getLoggerContext)(this.logger);
            }
        },
        {
            key: "storageKey",
            get: function get() {
                return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
            }
        },
        {
            key: "length",
            get: function get() {
                return this.expirations.size;
            }
        },
        {
            key: "keys",
            get: function get() {
                return Array.from(this.expirations.keys());
            }
        },
        {
            key: "values",
            get: function get() {
                return Array.from(this.expirations.values());
            }
        },
        {
            key: "formatTarget",
            value: function formatTarget(e) {
                if (typeof e == "string") return (0, $8wnFv.formatTopicTarget)(e);
                if (typeof e == "number") return (0, $8wnFv.formatIdTarget)(e);
                var _u = (0, $8wnFv.getInternalError)("UNKNOWN_TYPE", "Target type: ".concat(typeof e === "undefined" ? "undefined" : (0, $l0HdX._)(e))), t = _u.message;
                throw new Error(t);
            }
        },
        {
            key: "setExpirations",
            value: function setExpirations(e) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.core.storage.setItem(_this.storageKey, e)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getExpirations",
            value: function getExpirations() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.core.storage.getItem(_this.storageKey)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "persist",
            value: function persist() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.setExpirations(_this.values)
                                ];
                            case 1:
                                _state.sent(), _this.events.emit($4bb3863dfa1867a4$export$9013719d9206b0c1.sync);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "restore",
            value: function restore() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _$e, _u, t, e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.getExpirations()
                                ];
                            case 1:
                                _$e = _state.sent();
                                if ((typeof _$e === "undefined" ? "undefined" : (0, $l0HdX._)(_$e)) > "u" || !_$e.length) return [
                                    2
                                ];
                                if (_this.expirations.size) {
                                    _u = (0, $8wnFv.getInternalError)("RESTORE_WILL_OVERRIDE", _this.name), t = _u.message;
                                    throw _this.logger.error(t), new Error(t);
                                }
                                _this.cached = _$e, _this.logger.debug("Successfully Restored expirations for ".concat(_this.name)), _this.logger.trace({
                                    type: "method",
                                    method: "restore",
                                    expirations: _this.values
                                });
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                e = _state.sent();
                                _this.logger.debug("Failed to Restore expirations for ".concat(_this.name)), _this.logger.error(e);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getExpiration",
            value: function getExpiration(e) {
                var t = this.expirations.get(e);
                if (!t) {
                    var _u = (0, $8wnFv.getInternalError)("NO_MATCHING_KEY", "".concat(this.name, ": ").concat(e)), s = _u.message;
                    throw this.logger.warn(s), new Error(s);
                }
                return t;
            }
        },
        {
            key: "checkExpiry",
            value: function checkExpiry(e, t) {
                var s = t.expiry;
                (0, $4BEBs.toMiliseconds)(s) - Date.now() <= 0 && this.expire(e, t);
            }
        },
        {
            key: "expire",
            value: function expire(e, t) {
                this.expirations.delete(e), this.events.emit($4bb3863dfa1867a4$export$9013719d9206b0c1.expired, {
                    target: e,
                    expiration: t
                });
            }
        },
        {
            key: "checkExpirations",
            value: function checkExpirations() {
                var _this = this;
                this.core.relayer.connected && this.expirations.forEach(function(e, t) {
                    return _this.checkExpiry(t, e);
                });
            }
        },
        {
            key: "registerEventListeners",
            value: function registerEventListeners() {
                var _this = this;
                this.core.heartbeat.on((0, $8nsA4.HEARTBEAT_EVENTS).pulse, function() {
                    return _this.checkExpirations();
                }), this.events.on($4bb3863dfa1867a4$export$9013719d9206b0c1.created, function(e) {
                    var t = $4bb3863dfa1867a4$export$9013719d9206b0c1.created;
                    _this.logger.info("Emitting ".concat(t)), _this.logger.debug({
                        type: "event",
                        event: t,
                        data: e
                    }), _this.persist();
                }), this.events.on($4bb3863dfa1867a4$export$9013719d9206b0c1.expired, function(e) {
                    var t = $4bb3863dfa1867a4$export$9013719d9206b0c1.expired;
                    _this.logger.info("Emitting ".concat(t)), _this.logger.debug({
                        type: "event",
                        event: t,
                        data: e
                    }), _this.persist();
                }), this.events.on($4bb3863dfa1867a4$export$9013719d9206b0c1.deleted, function(e) {
                    var t = $4bb3863dfa1867a4$export$9013719d9206b0c1.deleted;
                    _this.logger.info("Emitting ".concat(t)), _this.logger.debug({
                        type: "event",
                        event: t,
                        data: e
                    }), _this.persist();
                });
            }
        },
        {
            key: "isInitialized",
            value: function isInitialized() {
                if (!this.initialized) {
                    var _u = (0, $8wnFv.getInternalError)("NOT_INITIALIZED", this.name), e = _u.message;
                    throw new Error(e);
                }
            }
        }
    ]);
    return si;
}((0, $3WrnC.IExpirer));
var $4bb3863dfa1867a4$var$y = {};
Object.defineProperty($4bb3863dfa1867a4$var$y, "__esModule", {
    value: !0
}), $4bb3863dfa1867a4$var$y.getLocalStorage = $4bb3863dfa1867a4$var$y.getLocalStorageOrThrow = $4bb3863dfa1867a4$var$y.getCrypto = $4bb3863dfa1867a4$var$y.getCryptoOrThrow = $4bb3863dfa1867a4$var$y.getLocation = $4bb3863dfa1867a4$var$y.getLocationOrThrow = $4bb3863dfa1867a4$var$y.getNavigator = $4bb3863dfa1867a4$var$y.getNavigatorOrThrow = $4bb3863dfa1867a4$var$ri = $4bb3863dfa1867a4$var$y.getDocument = $4bb3863dfa1867a4$var$y.getDocumentOrThrow = $4bb3863dfa1867a4$var$y.getFromWindowOrThrow = $4bb3863dfa1867a4$var$y.getFromWindow = void 0;
function $4bb3863dfa1867a4$var$K(o) {
    var e;
    return (typeof window === "undefined" ? "undefined" : (0, $l0HdX._)(window)) < "u" && (0, $l0HdX._)(window[o]) < "u" && (e = window[o]), e;
}
$4bb3863dfa1867a4$var$y.getFromWindow = $4bb3863dfa1867a4$var$K;
function $4bb3863dfa1867a4$var$j(o) {
    var e = $4bb3863dfa1867a4$var$K(o);
    if (!e) throw new Error("".concat(o, " is not defined in Window"));
    return e;
}
$4bb3863dfa1867a4$var$y.getFromWindowOrThrow = $4bb3863dfa1867a4$var$j;
function $4bb3863dfa1867a4$var$on() {
    return $4bb3863dfa1867a4$var$j("document");
}
$4bb3863dfa1867a4$var$y.getDocumentOrThrow = $4bb3863dfa1867a4$var$on;
function $4bb3863dfa1867a4$var$an() {
    return $4bb3863dfa1867a4$var$K("document");
}
var $4bb3863dfa1867a4$var$ri = $4bb3863dfa1867a4$var$y.getDocument = $4bb3863dfa1867a4$var$an;
function $4bb3863dfa1867a4$var$hn() {
    return $4bb3863dfa1867a4$var$j("navigator");
}
$4bb3863dfa1867a4$var$y.getNavigatorOrThrow = $4bb3863dfa1867a4$var$hn;
function $4bb3863dfa1867a4$var$cn() {
    return $4bb3863dfa1867a4$var$K("navigator");
}
$4bb3863dfa1867a4$var$y.getNavigator = $4bb3863dfa1867a4$var$cn;
function $4bb3863dfa1867a4$var$ln() {
    return $4bb3863dfa1867a4$var$j("location");
}
$4bb3863dfa1867a4$var$y.getLocationOrThrow = $4bb3863dfa1867a4$var$ln;
function $4bb3863dfa1867a4$var$un() {
    return $4bb3863dfa1867a4$var$K("location");
}
$4bb3863dfa1867a4$var$y.getLocation = $4bb3863dfa1867a4$var$un;
function $4bb3863dfa1867a4$var$dn() {
    return $4bb3863dfa1867a4$var$j("crypto");
}
$4bb3863dfa1867a4$var$y.getCryptoOrThrow = $4bb3863dfa1867a4$var$dn;
function $4bb3863dfa1867a4$var$gn() {
    return $4bb3863dfa1867a4$var$K("crypto");
}
$4bb3863dfa1867a4$var$y.getCrypto = $4bb3863dfa1867a4$var$gn;
function $4bb3863dfa1867a4$var$pn() {
    return $4bb3863dfa1867a4$var$j("localStorage");
}
$4bb3863dfa1867a4$var$y.getLocalStorageOrThrow = $4bb3863dfa1867a4$var$pn;
function $4bb3863dfa1867a4$var$yn() {
    return $4bb3863dfa1867a4$var$K("localStorage");
}
$4bb3863dfa1867a4$var$y.getLocalStorage = $4bb3863dfa1867a4$var$yn;
var $4bb3863dfa1867a4$export$91a8e56769aeb334 = /*#__PURE__*/ function(Ti) {
    "use strict";
    (0, $dcsZi._)(ni, Ti);
    var _super = (0, $ohfOJ._)(ni);
    function ni(e, t, s) {
        (0, $4GJKx._)(this, ni);
        var _this;
        var _this1 = (0, $d3H5E._)(_this);
        var _this2 = (0, $d3H5E._)(_this);
        var _this3 = (0, $d3H5E._)(_this);
        var _this4 = (0, $d3H5E._)(_this);
        var _this5 = (0, $d3H5E._)(_this);
        var _this6 = (0, $d3H5E._)(_this);
        var _this7 = (0, $d3H5E._)(_this);
        var _this8 = (0, $d3H5E._)(_this);
        var _this9 = (0, $d3H5E._)(_this);
        var _this10 = (0, $d3H5E._)(_this);
        _this = _super.call(this, e, t, s), _this.core = e, _this.logger = t, _this.store = s, _this.name = $4bb3863dfa1867a4$export$3b58f2450f2297e3, _this.verifyUrlV3 = $4bb3863dfa1867a4$export$412739528655ee2f, _this.storagePrefix = $4bb3863dfa1867a4$export$f258d29ae5e3d545, _this.version = $4bb3863dfa1867a4$export$f30bd3c8747cdfbe, _this.init = /*#__PURE__*/ (0, $kSuI9._)(function() {
            var i, _tmp, _tmp1, _tmp2;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = _this1.isDevEnv;
                        if (_tmp) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            _this1.store.getItem(_this1.storeKey)
                        ];
                    case 1:
                        _this1.publicKey = _state.sent();
                        _tmp1 = _this1.publicKey && (0, $4BEBs.toMiliseconds)((i = _this1.publicKey) == null ? void 0 : i.expiresAt) < Date.now();
                        if (!_tmp1) return [
                            3,
                            3
                        ];
                        _this1.logger.debug("verify v2 public key expired");
                        return [
                            4,
                            _this1.removePublicKey()
                        ];
                    case 2:
                        _tmp1 = _state.sent();
                        _state.label = 3;
                    case 3:
                        _tmp1;
                        _tmp2 = _this1.publicKey;
                        if (_tmp2) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            _this1.fetchAndPersistPublicKey()
                        ];
                    case 4:
                        _tmp2 = _state.sent();
                        _state.label = 5;
                    case 5:
                        _tmp = _tmp2;
                        _state.label = 6;
                    case 6:
                        _tmp;
                        return [
                            2
                        ];
                }
            });
        }), _this.register = function() {
            var _ref = (0, $kSuI9._)(function(i) {
                var r, n, a, h, _$c, d, g, c;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(0, $8wnFv.isBrowser)() || _this2.isDevEnv) return [
                                2
                            ];
                            r = window.location.origin, n = i.id, a = i.decryptedId, h = "".concat(_this2.verifyUrlV3, "/attestation?projectId=").concat(_this2.core.projectId, "&origin=").concat(r, "&id=").concat(n, "&decryptedId=").concat(a);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            _$c = $4bb3863dfa1867a4$var$ri(), d = _this2.startAbortTimer((0, $4BEBs.ONE_SECOND) * 5);
                            return [
                                4,
                                new Promise(function(b, m) {
                                    var l = function() {
                                        window.removeEventListener("message", _), _$c.body.removeChild(p), m("attestation aborted");
                                    };
                                    _this2.abortController.signal.addEventListener("abort", l);
                                    var p = _$c.createElement("iframe");
                                    p.src = h, p.style.display = "none", p.addEventListener("error", l, {
                                        signal: _this2.abortController.signal
                                    });
                                    var _ = function(D) {
                                        if (!D.data) return;
                                        var E = JSON.parse(D.data);
                                        if (E.type === "verify_attestation") {
                                            if ((0, $kGjpT.decodeJWT)(E.attestation).payload.id !== n) return;
                                            clearInterval(d), _$c.body.removeChild(p), _this2.abortController.signal.removeEventListener("abort", l), window.removeEventListener("message", _), b(E.attestation === null ? "" : E.attestation);
                                        }
                                    };
                                    _$c.body.appendChild(p), window.addEventListener("message", _, {
                                        signal: _this2.abortController.signal
                                    });
                                })
                            ];
                        case 2:
                            g = _state.sent();
                            return [
                                2,
                                (_this2.logger.debug("jwt attestation", g), g)
                            ];
                        case 3:
                            c = _state.sent();
                            _this2.logger.warn(c);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2,
                                ""
                            ];
                    }
                });
            });
            return function(i) {
                return _ref.apply(this, arguments);
            };
        }(), _this.resolve = function() {
            var _ref = (0, $kSuI9._)(function(i) {
                var r, n, a, c, h;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (_this3.isDevEnv) return [
                                2,
                                ""
                            ];
                            r = i.attestationId, n = i.hash, a = i.encryptedId;
                            if (r === "") {
                                _this3.logger.debug("resolve: attestationId is empty, skipping");
                                return [
                                    2
                                ];
                            }
                            if (!r) return [
                                3,
                                2
                            ];
                            if ((0, $kGjpT.decodeJWT)(r).payload.id !== a) return [
                                2
                            ];
                            return [
                                4,
                                _this3.isValidJwtAttestation(r)
                            ];
                        case 1:
                            c = _state.sent();
                            if (c) return [
                                2,
                                c
                            ];
                            _state.label = 2;
                        case 2:
                            if (!n) return [
                                2
                            ];
                            h = _this3.getVerifyUrl(i === null || i === void 0 ? void 0 : i.verifyUrl);
                            return [
                                2,
                                _this3.fetchAttestation(n, h)
                            ];
                    }
                });
            });
            return function(i) {
                return _ref.apply(this, arguments);
            };
        }(), _this.fetchAttestation = function() {
            var _ref = (0, $kSuI9._)(function(i, r) {
                var n, a, _tmp;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this4.logger.debug("resolving attestation: ".concat(i, " from url: ").concat(r));
                            n = _this4.startAbortTimer((0, $4BEBs.ONE_SECOND) * 5);
                            return [
                                4,
                                fetch("".concat(r, "/attestation/").concat(i, "?v2Supported=true"), {
                                    signal: _this4.abortController.signal
                                })
                            ];
                        case 1:
                            a = _state.sent();
                            clearTimeout(n);
                            if (!(a.status === 200)) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                a.json()
                            ];
                        case 2:
                            _tmp = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            _tmp = void 0;
                            _state.label = 4;
                        case 4:
                            return [
                                2,
                                _tmp
                            ];
                    }
                });
            });
            return function(i, r) {
                return _ref.apply(this, arguments);
            };
        }(), _this.getVerifyUrl = function(i) {
            var r = i || $4bb3863dfa1867a4$export$7e3b1a28ddecdbaa;
            return $4bb3863dfa1867a4$export$be24df03c4baa778.includes(r) || (_this.logger.info("verify url: ".concat(r, ", not included in trusted list, assigning default: ").concat($4bb3863dfa1867a4$export$7e3b1a28ddecdbaa)), r = $4bb3863dfa1867a4$export$7e3b1a28ddecdbaa), r;
        }, _this.fetchPublicKey = /*#__PURE__*/ (0, $kSuI9._)(function() {
            var _$i, r, i;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        _this5.logger.debug("fetching public key from: ".concat(_this5.verifyUrlV3));
                        _$i = _this5.startAbortTimer((0, $4BEBs.FIVE_SECONDS));
                        return [
                            4,
                            fetch("".concat(_this5.verifyUrlV3, "/public-key"), {
                                signal: _this5.abortController.signal
                            })
                        ];
                    case 1:
                        r = _state.sent();
                        clearTimeout(_$i);
                        return [
                            4,
                            r.json()
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 3:
                        i = _state.sent();
                        _this5.logger.warn(i);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        }), _this.persistPublicKey = function() {
            var _ref = (0, $kSuI9._)(function(i) {
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this6.logger.debug("persisting public key to local storage", i);
                            return [
                                4,
                                _this6.store.setItem(_this6.storeKey, i)
                            ];
                        case 1:
                            _state.sent(), _this6.publicKey = i;
                            return [
                                2
                            ];
                    }
                });
            });
            return function(i) {
                return _ref.apply(this, arguments);
            };
        }(), _this.removePublicKey = /*#__PURE__*/ (0, $kSuI9._)(function() {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this7.logger.debug("removing verify v2 public key from storage");
                        return [
                            4,
                            _this7.store.removeItem(_this7.storeKey)
                        ];
                    case 1:
                        _state.sent(), _this7.publicKey = void 0;
                        return [
                            2
                        ];
                }
            });
        }), _this.isValidJwtAttestation = function() {
            var _ref = (0, $kSuI9._)(function(i) {
                var r, n;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this8.getPublicKey()
                            ];
                        case 1:
                            r = _state.sent();
                            try {
                                if (r) return [
                                    2,
                                    _this8.validateAttestation(i, r)
                                ];
                            } catch (a) {
                                _this8.logger.error(a), _this8.logger.warn("error validating attestation");
                            }
                            return [
                                4,
                                _this8.fetchAndPersistPublicKey()
                            ];
                        case 2:
                            n = _state.sent();
                            try {
                                if (n) return [
                                    2,
                                    _this8.validateAttestation(i, n)
                                ];
                            } catch (a) {
                                _this8.logger.error(a), _this8.logger.warn("error validating attestation");
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function(i) {
                return _ref.apply(this, arguments);
            };
        }(), _this.getPublicKey = /*#__PURE__*/ (0, $kSuI9._)(function() {
            var _tmp;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!_this9.publicKey) return [
                            3,
                            1
                        ];
                        _tmp = _this9.publicKey;
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            _this9.fetchAndPersistPublicKey()
                        ];
                    case 2:
                        _tmp = _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            2,
                            _tmp
                        ];
                }
            });
        }), _this.fetchAndPersistPublicKey = /*#__PURE__*/ (0, $kSuI9._)(function() {
            var i;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!_this10.fetchPromise) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            _this10.fetchPromise
                        ];
                    case 1:
                        return [
                            2,
                            (_state.sent(), _this10.publicKey)
                        ];
                    case 2:
                        _this10.fetchPromise = new Promise(function() {
                            var _ref = (0, $kSuI9._)(function(r) {
                                var n, _tmp;
                                return (0, $eha6O.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                _this10.fetchPublicKey()
                                            ];
                                        case 1:
                                            n = _state.sent();
                                            _tmp = n;
                                            if (!_tmp) return [
                                                3,
                                                3
                                            ];
                                            return [
                                                4,
                                                _this10.persistPublicKey(n)
                                            ];
                                        case 2:
                                            _tmp = (_state.sent(), r(n));
                                            _state.label = 3;
                                        case 3:
                                            _tmp;
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(r) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        return [
                            4,
                            _this10.fetchPromise
                        ];
                    case 3:
                        i = _state.sent();
                        return [
                            2,
                            (_this10.fetchPromise = void 0, i)
                        ];
                }
            });
        }), _this.validateAttestation = function(i, r) {
            var n = (0, $8wnFv.verifyP256Jwt)(i, r.publicKey), a = {
                hasExpired: (0, $4BEBs.toMiliseconds)(n.exp) < Date.now(),
                payload: n
            };
            if (a.hasExpired) throw _this.logger.warn("resolve: jwt attestation expired"), new Error("JWT attestation expired");
            return {
                origin: a.payload.origin,
                isScam: a.payload.isScam
            };
        }, _this.logger = (0, $7Gasr.generateChildLogger)(t, _this.name), _this.abortController = new AbortController, _this.isDevEnv = (0, $8wnFv.isNode)() && undefined, _this.init();
        return (0, $3U0IP._)(_this);
    }
    (0, $1wc17._)(ni, [
        {
            key: "storeKey",
            get: function get() {
                return this.storagePrefix + this.version + this.core.customStoragePrefix + "//verify:public:key";
            }
        },
        {
            key: "context",
            get: function get() {
                return (0, $7Gasr.getLoggerContext)(this.logger);
            }
        },
        {
            key: "startAbortTimer",
            value: function startAbortTimer(e) {
                var _this = this;
                return this.abortController = new AbortController, setTimeout(function() {
                    return _this.abortController.abort();
                }, (0, $4BEBs.toMiliseconds)(e));
            }
        }
    ]);
    return ni;
}((0, $3WrnC.IVerify));
var $4bb3863dfa1867a4$export$c393c48c5b0cf59a = /*#__PURE__*/ function(Ci) {
    "use strict";
    (0, $dcsZi._)(oi, Ci);
    var _super = (0, $ohfOJ._)(oi);
    function oi(e, t) {
        (0, $4GJKx._)(this, oi);
        var _this;
        var _this1 = (0, $d3H5E._)(_this);
        _this = _super.call(this, e, t), _this.projectId = e, _this.logger = t, _this.context = $4bb3863dfa1867a4$export$40c022d2cffe0adc, _this.registerDeviceToken = function() {
            var _ref = (0, $kSuI9._)(function(s) {
                var i, r, n, tmp, a, h;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            i = s.clientId, r = s.token, n = s.notificationType, tmp = s.enableEncrypted, a = tmp === void 0 ? !1 : tmp, h = "".concat($4bb3863dfa1867a4$export$3c48c4faab79aab1, "/").concat(_this1.projectId, "/clients");
                            return [
                                4,
                                fetch(h, {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json"
                                    },
                                    body: JSON.stringify({
                                        client_id: i,
                                        type: n,
                                        token: r,
                                        always_raw: a
                                    })
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(s) {
                return _ref.apply(this, arguments);
            };
        }(), _this.logger = (0, $7Gasr.generateChildLogger)(t, _this.context);
        return (0, $3U0IP._)(_this);
    }
    return oi;
}((0, $3WrnC.IEchoClient));
var $4bb3863dfa1867a4$var$Dn = Object.defineProperty, $4bb3863dfa1867a4$var$ai = Object.getOwnPropertySymbols, $4bb3863dfa1867a4$var$bn = Object.prototype.hasOwnProperty, $4bb3863dfa1867a4$var$mn = Object.prototype.propertyIsEnumerable, $4bb3863dfa1867a4$var$hi = function(o, e, t) {
    return e in o ? $4bb3863dfa1867a4$var$Dn(o, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : o[e] = t;
}, $4bb3863dfa1867a4$var$Z = function(o, e) {
    for(var t in e || (e = {}))$4bb3863dfa1867a4$var$bn.call(e, t) && $4bb3863dfa1867a4$var$hi(o, t, e[t]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($4bb3863dfa1867a4$var$ai) try {
        for(var _iterator = $4bb3863dfa1867a4$var$ai(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var t = _step.value;
            $4bb3863dfa1867a4$var$mn.call(e, t) && $4bb3863dfa1867a4$var$hi(o, t, e[t]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return o;
};
var $4bb3863dfa1867a4$export$f4a30e909fe70796 = /*#__PURE__*/ function(Si) {
    "use strict";
    (0, $dcsZi._)(ci, Si);
    var _super = (0, $ohfOJ._)(ci);
    function ci(e, t) {
        var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
        (0, $4GJKx._)(this, ci);
        var _this;
        var _this1 = (0, $d3H5E._)(_this);
        var _this2 = (0, $d3H5E._)(_this);
        var _this3 = (0, $d3H5E._)(_this);
        var _this4 = (0, $d3H5E._)(_this);
        _this = _super.call(this, e, t, s), _this.core = e, _this.logger = t, _this.context = $4bb3863dfa1867a4$export$e020229e09910965, _this.storagePrefix = $4bb3863dfa1867a4$export$f258d29ae5e3d545, _this.storageVersion = $4bb3863dfa1867a4$export$c73857c3a3d16b1c, _this.events = new Map, _this.shouldPersist = !1, _this.createEvent = function(i) {
            var tmp = i.event, r = tmp === void 0 ? "ERROR" : tmp, tmp1 = i.type, n = tmp1 === void 0 ? "" : tmp1, _i_properties = i.properties, a = _i_properties.topic, h = _i_properties.trace, c = (0, $8wnFv.uuidv4)(), d = _this.core.projectId || "", g = Date.now(), b = $4bb3863dfa1867a4$var$Z({
                eventId: c,
                bundleId: d,
                timestamp: g,
                props: {
                    event: r,
                    type: n,
                    properties: {
                        topic: a,
                        trace: h
                    }
                }
            }, _this.setMethods(c));
            return _this.telemetryEnabled && (_this.events.set(c, b), _this.shouldPersist = !0), b;
        }, _this.getEvent = function(i) {
            var r = i.eventId, n = i.topic;
            if (r) return _this.events.get(r);
            var a = Array.from(_this.events.values()).find(function(h) {
                return h.props.properties.topic === n;
            });
            if (a) return $4bb3863dfa1867a4$var$Z($4bb3863dfa1867a4$var$Z({}, a), _this.setMethods(a.eventId));
        }, _this.deleteEvent = function(i) {
            var r = i.eventId;
            _this.events.delete(r), _this.shouldPersist = !0;
        }, _this.setEventListeners = function() {
            var _this1 = (0, $d3H5E._)(_this);
            _this.core.heartbeat.on((0, $8nsA4.HEARTBEAT_EVENTS).pulse, /*#__PURE__*/ (0, $kSuI9._)(function() {
                var _tmp;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _tmp = _this1.shouldPersist;
                            if (!_tmp) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _this1.persist()
                            ];
                        case 1:
                            _tmp = _state.sent();
                            _state.label = 2;
                        case 2:
                            _tmp, _this1.events.forEach(function(i) {
                                (0, $4BEBs.fromMiliseconds)(Date.now()) - (0, $4BEBs.fromMiliseconds)(i.timestamp) > $4bb3863dfa1867a4$export$79348045429687e2 && (_this1.events.delete(i.eventId), _this1.shouldPersist = !0);
                            });
                            return [
                                2
                            ];
                    }
                });
            }));
        }, _this.setMethods = function(i) {
            return {
                addTrace: function(r) {
                    return _this.addTrace(i, r);
                },
                setError: function(r) {
                    return _this.setError(i, r);
                }
            };
        }, _this.addTrace = function(i, r) {
            var n = _this.events.get(i);
            n && (n.props.properties.trace.push(r), _this.events.set(i, n), _this.shouldPersist = !0);
        }, _this.setError = function(i, r) {
            var n = _this.events.get(i);
            n && (n.props.type = r, n.timestamp = Date.now(), _this.events.set(i, n), _this.shouldPersist = !0);
        }, _this.persist = /*#__PURE__*/ (0, $kSuI9._)(function() {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this1.core.storage.setItem(_this1.storageKey, Array.from(_this1.events.values()))
                        ];
                    case 1:
                        _state.sent(), _this1.shouldPersist = !1;
                        return [
                            2
                        ];
                }
            });
        }), _this.restore = /*#__PURE__*/ (0, $kSuI9._)(function() {
            var _$i, i;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            _this2.core.storage.getItem(_this2.storageKey)
                        ];
                    case 1:
                        _$i = _state.sent() || [];
                        if (!_$i.length) return [
                            2
                        ];
                        _$i.forEach(function(r) {
                            _this2.events.set(r.eventId, $4bb3863dfa1867a4$var$Z($4bb3863dfa1867a4$var$Z({}, r), _this2.setMethods(r.eventId)));
                        });
                        return [
                            3,
                            3
                        ];
                    case 2:
                        i = _state.sent();
                        _this2.logger.warn(i);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        }), _this.submit = /*#__PURE__*/ (0, $kSuI9._)(function() {
            var i, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, _$r, n, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, _$r1, r;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!_this3.telemetryEnabled || _this3.events.size === 0) return [
                            2
                        ];
                        i = [];
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = _this3.events[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                _step_value = (0, $cv9Rk._)(_step.value, 2), _$r = _step_value[0], n = _step_value[1];
                                n.props.type && i.push(n);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        if (!(i.length !== 0)) return [
                            3,
                            4
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        return [
                            4,
                            fetch("".concat($4bb3863dfa1867a4$export$bb6a8925f3cb1ca, "?projectId=").concat(_this3.core.projectId, "&st=events_sdk&sv=js-").concat($4bb3863dfa1867a4$export$5f30917a6f8c9025), {
                                method: "POST",
                                body: JSON.stringify(i)
                            })
                        ];
                    case 2:
                        if (_state.sent().ok) try {
                            for(_iterator1 = i[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                _$r1 = _step1.value;
                                _this3.events.delete(_$r1.eventId), _this3.shouldPersist = !0;
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        r = _state.sent();
                        _this3.logger.warn(r);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        }), _this.logger = (0, $7Gasr.generateChildLogger)(t, _this.context), s ? _this.restore().then(/*#__PURE__*/ (0, $kSuI9._)(function() {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this4.submit()
                        ];
                    case 1:
                        _state.sent(), _this4.setEventListeners();
                        return [
                            2
                        ];
                }
            });
        })) : _this.persist();
        return (0, $3U0IP._)(_this);
    }
    (0, $1wc17._)(ci, [
        {
            key: "storageKey",
            get: function get() {
                return this.storagePrefix + this.storageVersion + this.core.customStoragePrefix + "//" + this.context;
            }
        }
    ]);
    return ci;
}((0, $3WrnC.IEventClient));
var $4bb3863dfa1867a4$var$fn = Object.defineProperty, $4bb3863dfa1867a4$var$li = Object.getOwnPropertySymbols, $4bb3863dfa1867a4$var$_n = Object.prototype.hasOwnProperty, $4bb3863dfa1867a4$var$En = Object.prototype.propertyIsEnumerable, $4bb3863dfa1867a4$var$ui = function(o, e, t) {
    return e in o ? $4bb3863dfa1867a4$var$fn(o, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : o[e] = t;
}, $4bb3863dfa1867a4$var$di = function(o, e) {
    for(var t in e || (e = {}))$4bb3863dfa1867a4$var$_n.call(e, t) && $4bb3863dfa1867a4$var$ui(o, t, e[t]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($4bb3863dfa1867a4$var$li) try {
        for(var _iterator = $4bb3863dfa1867a4$var$li(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var t = _step.value;
            $4bb3863dfa1867a4$var$En.call(e, t) && $4bb3863dfa1867a4$var$ui(o, t, e[t]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return o;
};
var $4bb3863dfa1867a4$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Pi) {
    "use strict";
    (0, $dcsZi._)(oe, Pi);
    var _super = (0, $ohfOJ._)(oe);
    function oe(e) {
        (0, $4GJKx._)(this, oe);
        var _this;
        var t;
        _this = _super.call(this, e), _this.protocol = $4bb3863dfa1867a4$export$51b1c900ac262bdf, _this.version = $4bb3863dfa1867a4$export$f30bd3c8747cdfbe, _this.name = $4bb3863dfa1867a4$export$d47601f9de5ee22b, _this.events = new (0, $cyxGb.EventEmitter), _this.initialized = !1, _this.on = function(n, a) {
            return _this.events.on(n, a);
        }, _this.once = function(n, a) {
            return _this.events.once(n, a);
        }, _this.off = function(n, a) {
            return _this.events.off(n, a);
        }, _this.removeListener = function(n, a) {
            return _this.events.removeListener(n, a);
        }, _this.projectId = e === null || e === void 0 ? void 0 : e.projectId, _this.relayUrl = (e === null || e === void 0 ? void 0 : e.relayUrl) || $4bb3863dfa1867a4$export$a68061e6c48f332a, _this.customStoragePrefix = e != null && e.customStoragePrefix ? ":".concat(e.customStoragePrefix) : "";
        var s = (0, $7Gasr.getDefaultLoggerOptions)({
            level: typeof (e === null || e === void 0 ? void 0 : e.logger) == "string" && e.logger ? e.logger : $4bb3863dfa1867a4$export$db0fdb6d486555c2.logger
        }), _bi = (0, $7Gasr.generatePlatformLogger)({
            opts: s,
            maxSizeInBytes: e === null || e === void 0 ? void 0 : e.maxLogBlobSizeInBytes,
            loggerOverride: e === null || e === void 0 ? void 0 : e.logger
        }), i = _bi.logger, r = _bi.chunkLoggerController;
        var _this1 = (0, $d3H5E._)(_this);
        _this.logChunkController = r, (t = _this.logChunkController) != null && t.downloadLogsBlobInBrowser && (window.downloadLogsBlobInBrowser = /*#__PURE__*/ (0, $kSuI9._)(function() {
            var n, a, _tmp, _tmp1, _, _tmp2;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = (n = _this1.logChunkController) != null && n.downloadLogsBlobInBrowser;
                        if (!_tmp) return [
                            3,
                            3
                        ];
                        _tmp1 = (a = _this1.logChunkController) == null;
                        if (_tmp1) return [
                            3,
                            2
                        ];
                        _ = a.downloadLogsBlobInBrowser;
                        _tmp2 = {};
                        return [
                            4,
                            _this1.crypto.getClientId()
                        ];
                    case 1:
                        _tmp1 = _.apply(a, [
                            (_tmp2.clientId = _state.sent(), _tmp2)
                        ]);
                        _state.label = 2;
                    case 2:
                        _tmp = _tmp1;
                        _state.label = 3;
                    case 3:
                        _tmp;
                        return [
                            2
                        ];
                }
            });
        })), _this.logger = (0, $7Gasr.generateChildLogger)(i, _this.name), _this.heartbeat = new (0, $8nsA4.HeartBeat), _this.crypto = new $4bb3863dfa1867a4$export$8ac8b6291b7ccf24((0, $d3H5E._)(_this), _this.logger, e === null || e === void 0 ? void 0 : e.keychain), _this.history = new $4bb3863dfa1867a4$export$eeb4f10f25d479cb((0, $d3H5E._)(_this), _this.logger), _this.expirer = new $4bb3863dfa1867a4$export$e76805ce609031cb((0, $d3H5E._)(_this), _this.logger), _this.storage = e != null && e.storage ? e.storage : new (0, $kkqqt.default)($4bb3863dfa1867a4$var$di($4bb3863dfa1867a4$var$di({}, $4bb3863dfa1867a4$export$ba920abfe854b85d), e === null || e === void 0 ? void 0 : e.storageOptions)), _this.relayer = new $4bb3863dfa1867a4$export$70e73aa29a3d4407({
            core: (0, $d3H5E._)(_this),
            logger: _this.logger,
            relayUrl: _this.relayUrl,
            projectId: _this.projectId
        }), _this.pairing = new $4bb3863dfa1867a4$export$3370ee24730992a3((0, $d3H5E._)(_this), _this.logger), _this.verify = new $4bb3863dfa1867a4$export$91a8e56769aeb334((0, $d3H5E._)(_this), _this.logger, _this.storage), _this.echoClient = new $4bb3863dfa1867a4$export$c393c48c5b0cf59a(_this.projectId || "", _this.logger), _this.eventClient = new $4bb3863dfa1867a4$export$f4a30e909fe70796((0, $d3H5E._)(_this), _this.logger, e === null || e === void 0 ? void 0 : e.telemetryEnabled);
        return (0, $3U0IP._)(_this);
    }
    (0, $1wc17._)(oe, [
        {
            key: "context",
            get: function get() {
                return (0, $7Gasr.getLoggerContext)(this.logger);
            }
        },
        {
            key: "start",
            value: function start() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _tmp;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = _this.initialized;
                                if (_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.initialize()
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getLogsBlob",
            value: function getLogsBlob() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var e, _tmp, _, _tmp1;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!((e = _this.logChunkController) == null)) return [
                                    3,
                                    1
                                ];
                                _tmp = void 0;
                                return [
                                    3,
                                    3
                                ];
                            case 1:
                                _ = e.logsToBlob;
                                _tmp1 = {};
                                return [
                                    4,
                                    _this.crypto.getClientId()
                                ];
                            case 2:
                                _tmp = _.apply(e, [
                                    (_tmp1.clientId = _state.sent(), _tmp1)
                                ]);
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    _tmp
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "initialize",
            value: function initialize() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.logger.trace("Initialized");
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    8,
                                    ,
                                    9
                                ]);
                                return [
                                    4,
                                    _this.crypto.init()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    _this.history.init()
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    4,
                                    _this.expirer.init()
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    4,
                                    _this.relayer.init()
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    4,
                                    _this.heartbeat.init()
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    4,
                                    _this.pairing.init()
                                ];
                            case 7:
                                _state.sent(), _this.initialized = !0, _this.logger.info("Core Initialization Success");
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                e = _state.sent();
                                throw _this.logger.warn("Core Initialization Failure at epoch ".concat(Date.now()), e), _this.logger.error(e.message), e;
                            case 9:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ], [
        {
            key: "init",
            value: function init(e) {
                return (0, $kSuI9._)(function() {
                    var t, s;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t = new oe(e);
                                return [
                                    4,
                                    t.initialize()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    t.crypto.getClientId()
                                ];
                            case 2:
                                s = _state.sent();
                                return [
                                    4,
                                    t.storage.setItem($4bb3863dfa1867a4$export$9e4ca561755938da, s)
                                ];
                            case 3:
                                return [
                                    2,
                                    (_state.sent(), t)
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return oe;
}((0, $3WrnC.ICore));
var $4bb3863dfa1867a4$export$4143ab5b91744744 = $4bb3863dfa1867a4$export$2e2bcd8739ae039;

});
parcelRegister("kkqqt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecca2c89386281f0$export$8536778e426ddf92; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $l0HdX = parcelRequire("l0HdX");

var $eha6O = parcelRequire("eha6O");

var $i6wU2 = parcelRequire("i6wU2");

var $a74kp = parcelRequire("a74kp");

var $2fy4s = parcelRequire("2fy4s");
function $ecca2c89386281f0$var$C(i) {
    return i;
}
var $ecca2c89386281f0$var$x = "idb-keyval";
var $ecca2c89386281f0$var$z = function() {
    var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var t = i.base && i.base.length > 0 ? "".concat(i.base, ":") : "", e = function(s) {
        return t + s;
    };
    var n;
    return i.dbName && i.storeName && (n = (0, $a74kp.createStore)(i.dbName, i.storeName)), {
        name: $ecca2c89386281f0$var$x,
        options: i,
        hasItem: function(s) {
            return (0, $kSuI9._)(function() {
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0, $a74kp.get)(e(s), n)
                            ];
                        case 1:
                            return [
                                2,
                                !((0, $l0HdX._).apply(void 0, [
                                    _state.sent()
                                ]) > "u")
                            ];
                    }
                });
            })();
        },
        getItem: function(s) {
            return (0, $kSuI9._)(function() {
                var _ref;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0, $a74kp.get)(e(s), n)
                            ];
                        case 1:
                            return [
                                2,
                                (_ref = _state.sent()) !== null && _ref !== void 0 ? _ref : null
                            ];
                    }
                });
            })();
        },
        setItem: function(s, a) {
            return (0, $a74kp.set)(e(s), a, n);
        },
        removeItem: function(s) {
            return (0, $a74kp.del)(e(s), n);
        },
        getKeys: function() {
            return (0, $a74kp.keys)(n);
        },
        clear: function() {
            return (0, $a74kp.clear)(n);
        }
    };
};
var $ecca2c89386281f0$var$D = "WALLET_CONNECT_V2_INDEXED_DB", $ecca2c89386281f0$var$E = "keyvaluestorage";
var $ecca2c89386281f0$var$_ = /*#__PURE__*/ function() {
    "use strict";
    function _() {
        (0, $4GJKx._)(this, _);
        this.indexedDb = (0, $i6wU2.createStorage)({
            driver: $ecca2c89386281f0$var$z({
                dbName: $ecca2c89386281f0$var$D,
                storeName: $ecca2c89386281f0$var$E
            })
        });
    }
    (0, $1wc17._)(_, [
        {
            key: "getKeys",
            value: function getKeys() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.indexedDb.getKeys()
                        ];
                    });
                })();
            }
        },
        {
            key: "getEntries",
            value: function getEntries() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _, _1;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _1 = (_ = _this.indexedDb).getItems;
                                return [
                                    4,
                                    _this.indexedDb.getKeys()
                                ];
                            case 1:
                                return [
                                    4,
                                    _1.apply(_, [
                                        _state.sent()
                                    ])
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent().map(function(t) {
                                        return [
                                            t.key,
                                            t.value
                                        ];
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getItem",
            value: function getItem(t) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.indexedDb.getItem(t)
                                ];
                            case 1:
                                e = _state.sent();
                                if (e !== null) return [
                                    2,
                                    e
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setItem",
            value: function setItem(t, e) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.indexedDb.setItem(t, (0, $2fy4s.safeJsonStringify)(e))
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "removeItem",
            value: function removeItem(t) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.indexedDb.removeItem(t)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return _;
}();
var $ecca2c89386281f0$var$l = (typeof globalThis === "undefined" ? "undefined" : (0, $l0HdX._)(globalThis)) < "u" ? globalThis : (typeof window === "undefined" ? "undefined" : (0, $l0HdX._)(window)) < "u" ? window : (typeof $parcel$global === "undefined" ? "undefined" : (0, $l0HdX._)($parcel$global)) < "u" ? $parcel$global : (typeof self === "undefined" ? "undefined" : (0, $l0HdX._)(self)) < "u" ? self : {}, $ecca2c89386281f0$var$c = {
    exports: {}
};
(function() {
    var i;
    function t() {}
    i = t, i.prototype.getItem = function(e) {
        return this.hasOwnProperty(e) ? String(this[e]) : null;
    }, i.prototype.setItem = function(e, n) {
        this[e] = String(n);
    }, i.prototype.removeItem = function(e) {
        delete this[e];
    }, i.prototype.clear = function() {
        var e = this;
        Object.keys(e).forEach(function(n) {
            e[n] = void 0, delete e[n];
        });
    }, i.prototype.key = function(e) {
        return e = e || 0, Object.keys(this)[e];
    }, i.prototype.__defineGetter__("length", function() {
        return Object.keys(this).length;
    }), (typeof $ecca2c89386281f0$var$l === "undefined" ? "undefined" : (0, $l0HdX._)($ecca2c89386281f0$var$l)) < "u" && $ecca2c89386281f0$var$l.localStorage ? $ecca2c89386281f0$var$c.exports = $ecca2c89386281f0$var$l.localStorage : (typeof window === "undefined" ? "undefined" : (0, $l0HdX._)(window)) < "u" && window.localStorage ? $ecca2c89386281f0$var$c.exports = window.localStorage : $ecca2c89386281f0$var$c.exports = new t;
})();
function $ecca2c89386281f0$var$k(i) {
    var t;
    return [
        i[0],
        (0, $2fy4s.safeJsonParse)((t = i[1]) != null ? t : "")
    ];
}
var $ecca2c89386281f0$var$K = /*#__PURE__*/ function() {
    "use strict";
    function K() {
        (0, $4GJKx._)(this, K);
        this.localStorage = $ecca2c89386281f0$var$c.exports;
    }
    (0, $1wc17._)(K, [
        {
            key: "getKeys",
            value: function getKeys() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        return [
                            2,
                            Object.keys(_this.localStorage)
                        ];
                    });
                })();
            }
        },
        {
            key: "getEntries",
            value: function getEntries() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        return [
                            2,
                            Object.entries(_this.localStorage).map($ecca2c89386281f0$var$k)
                        ];
                    });
                })();
            }
        },
        {
            key: "getItem",
            value: function getItem(t) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        e = _this.localStorage.getItem(t);
                        if (e !== null) return [
                            2,
                            (0, $2fy4s.safeJsonParse)(e)
                        ];
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "setItem",
            value: function setItem(t, e) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        _this.localStorage.setItem(t, (0, $2fy4s.safeJsonStringify)(e));
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "removeItem",
            value: function removeItem(t) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        _this.localStorage.removeItem(t);
                        return [
                            2
                        ];
                    });
                })();
            }
        }
    ]);
    return K;
}();
var $ecca2c89386281f0$var$N = "wc_storage_version", $ecca2c89386281f0$var$y = 1, $ecca2c89386281f0$var$O = function() {
    var _ref = (0, $kSuI9._)(function(i, t, e) {
        var n, s, a, m, r, o, f;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = $ecca2c89386281f0$var$N;
                    return [
                        4,
                        t.getItem(n)
                    ];
                case 1:
                    s = _state.sent();
                    if (s && s >= $ecca2c89386281f0$var$y) {
                        e(t);
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        i.getKeys()
                    ];
                case 2:
                    a = _state.sent();
                    if (!a.length) {
                        e(t);
                        return [
                            2
                        ];
                    }
                    m = [];
                    _state.label = 3;
                case 3:
                    if (!a.length) return [
                        3,
                        7
                    ];
                    r = a.shift();
                    if (!r) return [
                        3,
                        6
                    ];
                    o = r.toLowerCase();
                    if (!(o.includes("wc@") || o.includes("walletconnect") || o.includes("wc_") || o.includes("wallet_connect"))) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        i.getItem(r)
                    ];
                case 4:
                    f = _state.sent();
                    return [
                        4,
                        t.setItem(r, f)
                    ];
                case 5:
                    _state.sent(), m.push(r);
                    _state.label = 6;
                case 6:
                    return [
                        3,
                        3
                    ];
                case 7:
                    return [
                        4,
                        t.setItem(n, $ecca2c89386281f0$var$y)
                    ];
                case 8:
                    _state.sent(), e(t), $ecca2c89386281f0$var$j(i, m);
                    return [
                        2
                    ];
            }
        });
    });
    return function O(i, t, e) {
        return _ref.apply(this, arguments);
    };
}(), $ecca2c89386281f0$var$j = function() {
    var _ref = (0, $kSuI9._)(function(i, t) {
        return (0, $eha6O.__generator)(this, function(_state) {
            t.length && t.forEach(function() {
                var _ref = (0, $kSuI9._)(function(e) {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    i.removeItem(e)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(e) {
                    return _ref.apply(this, arguments);
                };
            }());
            return [
                2
            ];
        });
    });
    return function j(i, t) {
        return _ref.apply(this, arguments);
    };
}();
var $ecca2c89386281f0$export$8536778e426ddf92 = /*#__PURE__*/ function() {
    "use strict";
    function h() {
        var _this = this;
        (0, $4GJKx._)(this, h);
        this.initialized = !1, this.setInitialized = function(e) {
            _this.storage = e, _this.initialized = !0;
        };
        var t = new $ecca2c89386281f0$var$K;
        this.storage = t;
        try {
            var e = new $ecca2c89386281f0$var$_;
            $ecca2c89386281f0$var$O(t, e, this.setInitialized);
        } catch (e) {
            this.initialized = !0;
        }
    }
    (0, $1wc17._)(h, [
        {
            key: "getKeys",
            value: function getKeys() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.initialize()
                                ];
                            case 1:
                                return [
                                    2,
                                    (_state.sent(), _this.storage.getKeys())
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getEntries",
            value: function getEntries() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.initialize()
                                ];
                            case 1:
                                return [
                                    2,
                                    (_state.sent(), _this.storage.getEntries())
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getItem",
            value: function getItem(t) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.initialize()
                                ];
                            case 1:
                                return [
                                    2,
                                    (_state.sent(), _this.storage.getItem(t))
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setItem",
            value: function setItem(t, e) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.initialize()
                                ];
                            case 1:
                                return [
                                    2,
                                    (_state.sent(), _this.storage.setItem(t, e))
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "removeItem",
            value: function removeItem(t) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.initialize()
                                ];
                            case 1:
                                return [
                                    2,
                                    (_state.sent(), _this.storage.removeItem(t))
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "initialize",
            value: function initialize() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _tmp;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = _this.initialized;
                                if (_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    new Promise(function(t) {
                                        var e = setInterval(function() {
                                            _this.initialized && (clearInterval(e), t());
                                        }, 20);
                                    })
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return h;
}();

});
parcelRegister("i6wU2", function(module, exports) {

$parcel$export(module.exports, "createStorage", function () { return $b72b7210f9a81013$export$d184a47a971dd4b9; });

var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $c6Xmf = parcelRequire("c6Xmf");

var $eha6O = parcelRequire("eha6O");

var $eha6O = parcelRequire("eha6O");

var $dYHyt = parcelRequire("dYHyt");

var $4FQAV = parcelRequire("4FQAV");
function $b72b7210f9a81013$export$b5cf55d52d4cddb(factory) {
    return factory;
}
var $b72b7210f9a81013$var$DRIVER_NAME = "memory";
var $b72b7210f9a81013$var$memory = $b72b7210f9a81013$export$b5cf55d52d4cddb(function() {
    var data = /* @__PURE__ */ new Map();
    return {
        name: $b72b7210f9a81013$var$DRIVER_NAME,
        options: {},
        hasItem: function(key) {
            return data.has(key);
        },
        getItem: function(key) {
            var _data_get;
            return (_data_get = data.get(key)) !== null && _data_get !== void 0 ? _data_get : null;
        },
        getItemRaw: function(key) {
            var _data_get;
            return (_data_get = data.get(key)) !== null && _data_get !== void 0 ? _data_get : null;
        },
        setItem: function(key, value) {
            data.set(key, value);
        },
        setItemRaw: function(key, value) {
            data.set(key, value);
        },
        removeItem: function(key) {
            data.delete(key);
        },
        getKeys: function() {
            return Array.from(data.keys());
        },
        clear: function() {
            data.clear();
        },
        dispose: function() {
            data.clear();
        }
    };
});
function $b72b7210f9a81013$export$d184a47a971dd4b9() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var context = {
        mounts: {
            "": options.driver || $b72b7210f9a81013$var$memory()
        },
        mountpoints: [
            ""
        ],
        watching: false,
        watchListeners: [],
        unwatch: {}
    };
    var getMount = function(key) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = context.mountpoints[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var base = _step.value;
                if (key.startsWith(base)) return {
                    base: base,
                    relativeKey: key.slice(base.length),
                    driver: context.mounts[base]
                };
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return {
            base: "",
            relativeKey: key,
            driver: context.mounts[""]
        };
    };
    var getMounts = function(base, includeParent) {
        return context.mountpoints.filter(function(mountpoint) {
            return mountpoint.startsWith(base) || includeParent && base.startsWith(mountpoint);
        }).map(function(mountpoint) {
            return {
                relativeBase: base.length > mountpoint.length ? base.slice(mountpoint.length) : void 0,
                mountpoint: mountpoint,
                driver: context.mounts[mountpoint]
            };
        });
    };
    var onChange = function(event, key) {
        if (!context.watching) return;
        key = (0, $4FQAV.a)(key);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = context.watchListeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var listener = _step.value;
                listener(event, key);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    var startWatch = function() {
        var _ref = (0, $kSuI9._)(function() {
            var _tmp, _tmp1, _i, mountpoint, _;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (context.watching) return [
                            2
                        ];
                        context.watching = true;
                        _tmp = [];
                        for(_tmp1 in context.mounts)_tmp.push(_tmp1);
                        _i = 0;
                        _state.label = 1;
                    case 1:
                        if (!(_i < _tmp.length)) return [
                            3,
                            4
                        ];
                        mountpoint = _tmp[_i];
                        _ = context.unwatch;
                        return [
                            4,
                            $b72b7210f9a81013$var$watch(context.mounts[mountpoint], onChange, mountpoint)
                        ];
                    case 2:
                        _[mountpoint] = _state.sent();
                        _state.label = 3;
                    case 3:
                        _i++;
                        return [
                            3,
                            1
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function startWatch() {
            return _ref.apply(this, arguments);
        };
    }();
    var stopWatch = function() {
        var _ref = (0, $kSuI9._)(function() {
            var _tmp, _tmp1, _i, mountpoint;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!context.watching) return [
                            2
                        ];
                        _tmp = [];
                        for(_tmp1 in context.unwatch)_tmp.push(_tmp1);
                        _i = 0;
                        _state.label = 1;
                    case 1:
                        if (!(_i < _tmp.length)) return [
                            3,
                            4
                        ];
                        mountpoint = _tmp[_i];
                        return [
                            4,
                            context.unwatch[mountpoint]()
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        _i++;
                        return [
                            3,
                            1
                        ];
                    case 4:
                        context.unwatch = {};
                        context.watching = false;
                        return [
                            2
                        ];
                }
            });
        });
        return function stopWatch() {
            return _ref.apply(this, arguments);
        };
    }();
    var runBatch = function(items, commonOptions, cb) {
        var batches = /* @__PURE__ */ new Map();
        var getBatch = function(mount) {
            var batch = batches.get(mount.base);
            if (!batch) {
                batch = {
                    driver: mount.driver,
                    base: mount.base,
                    items: []
                };
                batches.set(mount.base, batch);
            }
            return batch;
        };
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                var isStringItem = typeof item === "string";
                var key = (0, $4FQAV.a)(isStringItem ? item : item.key);
                var value = isStringItem ? void 0 : item.value;
                var options2 = isStringItem || !item.options ? commonOptions : (0, $do9pw._)({}, commonOptions, item.options);
                var mount = getMount(key);
                getBatch(mount).items.push({
                    key: key,
                    value: value,
                    relativeKey: mount.relativeKey,
                    options: options2
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return Promise.all((0, $c6Xmf._)(batches.values()).map(function(batch) {
            return cb(batch);
        })).then(function(r) {
            return r.flat();
        });
    };
    var storage = {
        // Item
        hasItem: function(key) {
            var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            key = (0, $4FQAV.a)(key);
            var _getMount = getMount(key), relativeKey = _getMount.relativeKey, driver = _getMount.driver;
            return (0, $4FQAV.b)(driver.hasItem, relativeKey, opts);
        },
        getItem: function(key) {
            var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            key = (0, $4FQAV.a)(key);
            var _getMount = getMount(key), relativeKey = _getMount.relativeKey, driver = _getMount.driver;
            return (0, $4FQAV.b)(driver.getItem, relativeKey, opts).then(function(value) {
                return (0, $dYHyt.default)(value);
            });
        },
        getItems: function(items, commonOptions) {
            return runBatch(items, commonOptions, function(batch) {
                if (batch.driver.getItems) return (0, $4FQAV.b)(batch.driver.getItems, batch.items.map(function(item) {
                    return {
                        key: item.relativeKey,
                        options: item.options
                    };
                }), commonOptions).then(function(r) {
                    return r.map(function(item) {
                        return {
                            key: (0, $4FQAV.j)(batch.base, item.key),
                            value: (0, $dYHyt.default)(item.value)
                        };
                    });
                });
                return Promise.all(batch.items.map(function(item) {
                    return (0, $4FQAV.b)(batch.driver.getItem, item.relativeKey, item.options).then(function(value) {
                        return {
                            key: item.key,
                            value: (0, $dYHyt.default)(value)
                        };
                    });
                }));
            });
        },
        getItemRaw: function(key) {
            var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            key = (0, $4FQAV.a)(key);
            var _getMount = getMount(key), relativeKey = _getMount.relativeKey, driver = _getMount.driver;
            if (driver.getItemRaw) return (0, $4FQAV.b)(driver.getItemRaw, relativeKey, opts);
            return (0, $4FQAV.b)(driver.getItem, relativeKey, opts).then(function(value) {
                return (0, $4FQAV.d)(value);
            });
        },
        setItem: function(key, value) {
            var opts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return (0, $kSuI9._)(function() {
                var _getMount, relativeKey, driver;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (value === void 0) return [
                                2,
                                storage.removeItem(key)
                            ];
                            key = (0, $4FQAV.a)(key);
                            _getMount = getMount(key), relativeKey = _getMount.relativeKey, driver = _getMount.driver;
                            if (!driver.setItem) return [
                                2
                            ];
                            return [
                                4,
                                (0, $4FQAV.b)(driver.setItem, relativeKey, (0, $4FQAV.s)(value), opts)
                            ];
                        case 1:
                            _state.sent();
                            if (!driver.watch) onChange("update", key);
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        setItems: function(items, commonOptions) {
            return (0, $kSuI9._)(function() {
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                runBatch(items, commonOptions, function() {
                                    var _ref = (0, $kSuI9._)(function(batch) {
                                        return (0, $eha6O.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (batch.driver.setItems) return [
                                                        2,
                                                        (0, $4FQAV.b)(batch.driver.setItems, batch.items.map(function(item) {
                                                            return {
                                                                key: item.relativeKey,
                                                                value: (0, $4FQAV.s)(item.value),
                                                                options: item.options
                                                            };
                                                        }), commonOptions)
                                                    ];
                                                    if (!batch.driver.setItem) return [
                                                        2
                                                    ];
                                                    return [
                                                        4,
                                                        Promise.all(batch.items.map(function(item) {
                                                            return (0, $4FQAV.b)(batch.driver.setItem, item.relativeKey, (0, $4FQAV.s)(item.value), item.options);
                                                        }))
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(batch) {
                                        return _ref.apply(this, arguments);
                                    };
                                }())
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        setItemRaw: function(key, value) {
            var opts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return (0, $kSuI9._)(function() {
                var _getMount, relativeKey, driver;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (value === void 0) return [
                                2,
                                storage.removeItem(key, opts)
                            ];
                            key = (0, $4FQAV.a)(key);
                            _getMount = getMount(key), relativeKey = _getMount.relativeKey, driver = _getMount.driver;
                            if (!driver.setItemRaw) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                (0, $4FQAV.b)(driver.setItemRaw, relativeKey, value, opts)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 2:
                            if (!driver.setItem) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                (0, $4FQAV.b)(driver.setItem, relativeKey, (0, $4FQAV.c)(value), opts)
                            ];
                        case 3:
                            _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 4:
                            return [
                                2
                            ];
                        case 5:
                            if (!driver.watch) onChange("update", key);
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        removeItem: function(key) {
            var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return (0, $kSuI9._)(function() {
                var _getMount, relativeKey, driver;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (typeof opts === "boolean") opts = {
                                removeMeta: opts
                            };
                            key = (0, $4FQAV.a)(key);
                            _getMount = getMount(key), relativeKey = _getMount.relativeKey, driver = _getMount.driver;
                            if (!driver.removeItem) return [
                                2
                            ];
                            return [
                                4,
                                (0, $4FQAV.b)(driver.removeItem, relativeKey, opts)
                            ];
                        case 1:
                            _state.sent();
                            if (!(opts.removeMeta || opts.removeMata)) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                (0, $4FQAV.b)(driver.removeItem, relativeKey + "$", opts)
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            if (!driver.watch) onChange("remove", key);
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        getMeta: // Meta
        function(key) {
            var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return (0, $kSuI9._)(function() {
                var _getMount, relativeKey, driver, meta, _, _tmp, value;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (typeof opts === "boolean") opts = {
                                nativeOnly: opts
                            };
                            key = (0, $4FQAV.a)(key);
                            _getMount = getMount(key), relativeKey = _getMount.relativeKey, driver = _getMount.driver;
                            meta = /* @__PURE__ */ Object.create(null);
                            if (!driver.getMeta) return [
                                3,
                                2
                            ];
                            _ = Object.assign;
                            _tmp = [
                                meta
                            ];
                            return [
                                4,
                                (0, $4FQAV.b)(driver.getMeta, relativeKey, opts)
                            ];
                        case 1:
                            _.apply(Object, _tmp.concat([
                                _state.sent()
                            ]));
                            _state.label = 2;
                        case 2:
                            if (!!opts.nativeOnly) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                (0, $4FQAV.b)(driver.getItem, relativeKey + "$", opts).then(function(value_) {
                                    return (0, $dYHyt.default)(value_);
                                })
                            ];
                        case 3:
                            value = _state.sent();
                            if (value && typeof value === "object") {
                                if (typeof value.atime === "string") value.atime = new Date(value.atime);
                                if (typeof value.mtime === "string") value.mtime = new Date(value.mtime);
                                Object.assign(meta, value);
                            }
                            _state.label = 4;
                        case 4:
                            return [
                                2,
                                meta
                            ];
                    }
                });
            })();
        },
        setMeta: function(key, value) {
            var opts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return this.setItem(key + "$", value, opts);
        },
        removeMeta: function(key) {
            var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return this.removeItem(key + "$", opts);
        },
        getKeys: // Keys
        function(base) {
            var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return (0, $kSuI9._)(function() {
                var mounts, maskedMounts, allKeys, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, err;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            base = (0, $4FQAV.n)(base);
                            mounts = getMounts(base, true);
                            maskedMounts = [];
                            allKeys = [];
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            _loop = function() {
                                var mount, _allKeys, rawKeys, keys;
                                return (0, $eha6O.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            mount = _step.value;
                                            return [
                                                4,
                                                (0, $4FQAV.b)(mount.driver.getKeys, mount.relativeBase, opts)
                                            ];
                                        case 1:
                                            rawKeys = _state.sent();
                                            keys = rawKeys.map(function(key) {
                                                return mount.mountpoint + (0, $4FQAV.a)(key);
                                            }).filter(function(key) {
                                                return !maskedMounts.some(function(p) {
                                                    return key.startsWith(p);
                                                });
                                            });
                                            (_allKeys = allKeys).push.apply(_allKeys, (0, $c6Xmf._)(keys));
                                            maskedMounts = [
                                                mount.mountpoint
                                            ].concat((0, $c6Xmf._)(maskedMounts.filter(function(p) {
                                                return !p.startsWith(mount.mountpoint);
                                            })));
                                            return [
                                                2
                                            ];
                                    }
                                });
                            };
                            _iterator = mounts[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                5
                            ];
                            return [
                                5,
                                (0, $eha6O.__values)(_loop())
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                8
                            ];
                        case 7:
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2,
                                base ? allKeys.filter(function(key) {
                                    return key.startsWith(base) && !key.endsWith("$");
                                }) : allKeys.filter(function(key) {
                                    return !key.endsWith("$");
                                })
                            ];
                    }
                });
            })();
        },
        clear: // Utils
        function(base) {
            var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return (0, $kSuI9._)(function() {
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            base = (0, $4FQAV.n)(base);
                            return [
                                4,
                                Promise.all(getMounts(base, false).map(function() {
                                    var _ref = (0, $kSuI9._)(function(m) {
                                        var keys;
                                        return (0, $eha6O.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (m.driver.clear) return [
                                                        2,
                                                        (0, $4FQAV.b)(m.driver.clear, m.relativeBase, opts)
                                                    ];
                                                    if (!m.driver.removeItem) return [
                                                        3,
                                                        2
                                                    ];
                                                    return [
                                                        4,
                                                        m.driver.getKeys(m.relativeBase || "", opts)
                                                    ];
                                                case 1:
                                                    keys = _state.sent();
                                                    return [
                                                        2,
                                                        Promise.all(keys.map(function(key) {
                                                            return m.driver.removeItem(key, opts);
                                                        }))
                                                    ];
                                                case 2:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(m) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()))
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        dispose: function() {
            return (0, $kSuI9._)(function() {
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                Promise.all(Object.values(context.mounts).map(function(driver) {
                                    return $b72b7210f9a81013$var$dispose(driver);
                                }))
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        watch: function(callback) {
            return (0, $kSuI9._)(function() {
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                startWatch()
                            ];
                        case 1:
                            _state.sent();
                            context.watchListeners.push(callback);
                            return [
                                2,
                                /*#__PURE__*/ (0, $kSuI9._)(function() {
                                    return (0, $eha6O.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                context.watchListeners = context.watchListeners.filter(function(listener) {
                                                    return listener !== callback;
                                                });
                                                if (!(context.watchListeners.length === 0)) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    stopWatch()
                                                ];
                                            case 1:
                                                _state.sent();
                                                _state.label = 2;
                                            case 2:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })
                            ];
                    }
                });
            })();
        },
        unwatch: function() {
            return (0, $kSuI9._)(function() {
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            context.watchListeners = [];
                            return [
                                4,
                                stopWatch()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        // Mount
        mount: function(base, driver) {
            base = (0, $4FQAV.n)(base);
            if (base && context.mounts[base]) throw new Error("already mounted at ".concat(base));
            if (base) {
                context.mountpoints.push(base);
                context.mountpoints.sort(function(a, b) {
                    return b.length - a.length;
                });
            }
            context.mounts[base] = driver;
            if (context.watching) Promise.resolve($b72b7210f9a81013$var$watch(driver, onChange, base)).then(function(unwatcher) {
                context.unwatch[base] = unwatcher;
            }).catch(console.error);
            return storage;
        },
        unmount: function(base) {
            var _dispose = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
            return (0, $kSuI9._)(function() {
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            base = (0, $4FQAV.n)(base);
                            if (!base || !context.mounts[base]) return [
                                2
                            ];
                            if (context.watching && base in context.unwatch) {
                                context.unwatch[base]();
                                delete context.unwatch[base];
                            }
                            if (!_dispose) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                $b72b7210f9a81013$var$dispose(context.mounts[base])
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            context.mountpoints = context.mountpoints.filter(function(key) {
                                return key !== base;
                            });
                            delete context.mounts[base];
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        getMount: function() {
            var key = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
            key = (0, $4FQAV.a)(key) + ":";
            var m = getMount(key);
            return {
                driver: m.driver,
                base: m.base
            };
        },
        getMounts: function() {
            var base = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            base = (0, $4FQAV.a)(base);
            var mounts = getMounts(base, opts.parents);
            return mounts.map(function(m) {
                return {
                    driver: m.driver,
                    base: m.mountpoint
                };
            });
        }
    };
    return storage;
}
function $b72b7210f9a81013$export$b8801ea43165ed7d(storage, base) {
    return $b72b7210f9a81013$var$_snapshot.apply(this, arguments);
}
function $b72b7210f9a81013$var$_snapshot() {
    $b72b7210f9a81013$var$_snapshot = (0, $kSuI9._)(function(storage, base) {
        var keys, snapshot2;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    base = (0, $4FQAV.n)(base);
                    return [
                        4,
                        storage.getKeys(base)
                    ];
                case 1:
                    keys = _state.sent();
                    snapshot2 = {};
                    return [
                        4,
                        Promise.all(keys.map(function() {
                            var _ref = (0, $kSuI9._)(function(key) {
                                var _;
                                return (0, $eha6O.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _ = key.slice(base.length);
                                            return [
                                                4,
                                                storage.getItem(key)
                                            ];
                                        case 1:
                                            snapshot2[_] = _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(key) {
                                return _ref.apply(this, arguments);
                            };
                        }()))
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        snapshot2
                    ];
            }
        });
    });
    return $b72b7210f9a81013$var$_snapshot.apply(this, arguments);
}
function $b72b7210f9a81013$export$11e5d4541284dd1e(driver, snapshot2) {
    return $b72b7210f9a81013$var$_restoreSnapshot.apply(this, arguments);
}
function $b72b7210f9a81013$var$_restoreSnapshot() {
    $b72b7210f9a81013$var$_restoreSnapshot = (0, $kSuI9._)(function(driver, snapshot2) {
        var base;
        var _arguments = arguments;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    base = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "";
                    base = (0, $4FQAV.n)(base);
                    return [
                        4,
                        Promise.all(Object.entries(snapshot2).map(function(e) {
                            return driver.setItem(base + e[0], e[1]);
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $b72b7210f9a81013$var$_restoreSnapshot.apply(this, arguments);
}
function $b72b7210f9a81013$var$watch(driver, onChange, base) {
    return driver.watch ? driver.watch(function(event, key) {
        return onChange(event, base + key);
    }) : function() {};
}
function $b72b7210f9a81013$var$dispose(driver) {
    return $b72b7210f9a81013$var$_dispose.apply(this, arguments);
}
function $b72b7210f9a81013$var$_dispose() {
    $b72b7210f9a81013$var$_dispose = (0, $kSuI9._)(function(driver) {
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(typeof driver.dispose === "function")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0, $4FQAV.b)(driver.dispose)
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    });
    return $b72b7210f9a81013$var$_dispose.apply(this, arguments);
}
var $b72b7210f9a81013$export$108bed33247a8bd7 = {
    azureAppConfiguration: "unstorage/drivers/azure-app-configuration",
    azureCosmos: "unstorage/drivers/azure-cosmos",
    azureKeyVault: "unstorage/drivers/azure-key-vault",
    azureStorageBlob: "unstorage/drivers/azure-storage-blob",
    azureStorageTable: "unstorage/drivers/azure-storage-table",
    cloudflareKVBinding: "unstorage/drivers/cloudflare-kv-binding",
    cloudflareKVHTTP: "unstorage/drivers/cloudflare-kv-http",
    cloudflareR2Binding: "unstorage/drivers/cloudflare-r2-binding",
    fs: "unstorage/drivers/fs",
    fsLite: "unstorage/drivers/fs-lite",
    github: "unstorage/drivers/github",
    http: "unstorage/drivers/http",
    indexedb: "unstorage/drivers/indexedb",
    localStorage: "unstorage/drivers/localstorage",
    lruCache: "unstorage/drivers/lru-cache",
    memory: "unstorage/drivers/memory",
    mongodb: "unstorage/drivers/mongodb",
    netlifyBlobs: "unstorage/drivers/netlify-blobs",
    overlay: "unstorage/drivers/overlay",
    planetscale: "unstorage/drivers/planetscale",
    redis: "unstorage/drivers/redis",
    sessionStorage: "unstorage/drivers/session-storage",
    vercelKV: "unstorage/drivers/vercel-kv",
    /** @deprecated */ "cloudflare-kv-binding": "unstorage/drivers/cloudflare-kv-binding",
    /** @deprecated */ "cloudflare-kv-http": "unstorage/drivers/cloudflare-kv-http"
};

});
parcelRegister("dYHyt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94300a08e86e16a1$export$2e2bcd8739ae039; });

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");
var $94300a08e86e16a1$var$suspectProtoRx = /"(?:_|\\u0{2}5[Ff]){2}(?:p|\\u0{2}70)(?:r|\\u0{2}72)(?:o|\\u0{2}6[Ff])(?:t|\\u0{2}74)(?:o|\\u0{2}6[Ff])(?:_|\\u0{2}5[Ff]){2}"\s*:/;
var $94300a08e86e16a1$var$suspectConstructorRx = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/;
var $94300a08e86e16a1$var$JsonSigRx = /^\s*["[{]|^\s*-?\d{1,16}(\.\d{1,17})?([Ee][+-]?\d+)?\s*$/;
function $94300a08e86e16a1$var$jsonParseTransform(key, value) {
    if (key === "__proto__" || key === "constructor" && value && typeof value === "object" && "prototype" in value) {
        $94300a08e86e16a1$var$warnKeyDropped(key);
        return;
    }
    return value;
}
function $94300a08e86e16a1$var$warnKeyDropped(key) {
    console.warn('[destr] Dropping "'.concat(key, '" key to prevent prototype pollution.'));
}
function $94300a08e86e16a1$export$2e2bcd8739ae039(value) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (typeof value !== "string") return value;
    var _value = value.trim();
    if (// eslint-disable-next-line unicorn/prefer-at
    value[0] === '"' && value.endsWith('"') && !value.includes("\\")) return _value.slice(1, -1);
    if (_value.length <= 9) {
        var _lval = _value.toLowerCase();
        if (_lval === "true") return true;
        if (_lval === "false") return false;
        if (_lval === "undefined") return void 0;
        if (_lval === "null") return null;
        if (_lval === "nan") return Number.NaN;
        if (_lval === "infinity") return Number.POSITIVE_INFINITY;
        if (_lval === "-infinity") return Number.NEGATIVE_INFINITY;
    }
    if (!$94300a08e86e16a1$var$JsonSigRx.test(value)) {
        if (options.strict) throw new SyntaxError("[destr] Invalid JSON");
        return value;
    }
    try {
        if ($94300a08e86e16a1$var$suspectProtoRx.test(value) || $94300a08e86e16a1$var$suspectConstructorRx.test(value)) {
            if (options.strict) throw new Error("[destr] Possible prototype pollution");
            return JSON.parse(value, $94300a08e86e16a1$var$jsonParseTransform);
        }
        return JSON.parse(value);
    } catch (error) {
        if (options.strict) throw error;
        return value;
    }
}
function $94300a08e86e16a1$export$4b2a7c187ff4b28c(value) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return $94300a08e86e16a1$export$2e2bcd8739ae039(value, (0, $cxjpp._)((0, $do9pw._)({}, options), {
        strict: true
    }));
}

});

parcelRegister("4FQAV", function(module, exports) {

$parcel$export(module.exports, "b", function () { return $32ab173dc8a48d4e$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "s", function () { return $32ab173dc8a48d4e$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "c", function () { return $32ab173dc8a48d4e$export$db3b6bfb95261072; });
$parcel$export(module.exports, "d", function () { return $32ab173dc8a48d4e$export$4368d992c4eafac0; });
$parcel$export(module.exports, "n", function () { return $32ab173dc8a48d4e$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "a", function () { return $32ab173dc8a48d4e$export$407448d2b89b1813; });
$parcel$export(module.exports, "j", function () { return $32ab173dc8a48d4e$export$35e795649ee09318; });

var $do9pw = parcelRequire("do9pw");

var $c6Xmf = parcelRequire("c6Xmf");

var $l0HdX = parcelRequire("l0HdX");

var $8dlmd = parcelRequire("8dlmd");
var $32ab173dc8a48d4e$require$Buffer = $8dlmd.Buffer;
function $32ab173dc8a48d4e$var$wrapToPromise(value) {
    if (!value || typeof value.then !== "function") return Promise.resolve(value);
    return value;
}
function $32ab173dc8a48d4e$export$8b22cf2602fb60ce(function_) {
    for(var _len = arguments.length, arguments_ = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        arguments_[_key - 1] = arguments[_key];
    }
    try {
        return $32ab173dc8a48d4e$var$wrapToPromise(function_.apply(void 0, (0, $c6Xmf._)(arguments_)));
    } catch (error) {
        return Promise.reject(error);
    }
}
function $32ab173dc8a48d4e$var$isPrimitive(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value);
    return value === null || type !== "object" && type !== "function";
}
function $32ab173dc8a48d4e$var$isPureObject(value) {
    var proto = Object.getPrototypeOf(value);
    return !proto || proto.isPrototypeOf(Object);
}
function $32ab173dc8a48d4e$export$2408f22a0fab9ae5(value) {
    if ($32ab173dc8a48d4e$var$isPrimitive(value)) return String(value);
    if ($32ab173dc8a48d4e$var$isPureObject(value) || Array.isArray(value)) return JSON.stringify(value);
    if (typeof value.toJSON === "function") return $32ab173dc8a48d4e$export$2408f22a0fab9ae5(value.toJSON());
    throw new Error("[unstorage] Cannot stringify value!");
}
function $32ab173dc8a48d4e$var$checkBufferSupport() {}
var $32ab173dc8a48d4e$var$BASE64_PREFIX = "base64:";
function $32ab173dc8a48d4e$export$db3b6bfb95261072(value) {
    if (typeof value === "string") return value;
    $32ab173dc8a48d4e$var$checkBufferSupport();
    var base64 = $32ab173dc8a48d4e$require$Buffer.from(value).toString("base64");
    return $32ab173dc8a48d4e$var$BASE64_PREFIX + base64;
}
function $32ab173dc8a48d4e$export$4368d992c4eafac0(value) {
    if (typeof value !== "string") return value;
    if (!value.startsWith($32ab173dc8a48d4e$var$BASE64_PREFIX)) return value;
    $32ab173dc8a48d4e$var$checkBufferSupport();
    return $32ab173dc8a48d4e$require$Buffer.from(value.slice($32ab173dc8a48d4e$var$BASE64_PREFIX.length), "base64");
}
var $32ab173dc8a48d4e$var$storageKeyProperties = [
    "hasItem",
    "getItem",
    "getItemRaw",
    "setItem",
    "setItemRaw",
    "removeItem",
    "getMeta",
    "setMeta",
    "removeMeta",
    "getKeys",
    "clear",
    "mount",
    "unmount"
];
function $32ab173dc8a48d4e$export$ffb5f4729a158638(storage, base) {
    var // @ts-ignore
    _storage, _storage1;
    base = $32ab173dc8a48d4e$export$7ccc53e8f1e7dfc5(base);
    if (!base) return storage;
    var nsStorage = (0, $do9pw._)({}, storage);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var property = _step.value;
            nsStorage[property] = function() {
                var key = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                return (_storage = storage)[property].apply(_storage, [
                    base + key
                ].concat((0, $c6Xmf._)(args)));
            };
        };
        for(var _iterator = $32ab173dc8a48d4e$var$storageKeyProperties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    nsStorage.getKeys = function() {
        var key = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        for(var _len = arguments.length, arguments_ = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            arguments_[_key - 1] = arguments[_key];
        }
        return (_storage1 = storage).getKeys.apply(_storage1, [
            base + key
        ].concat((0, $c6Xmf._)(arguments_))).then(function(keys) {
            return keys.map(function(key2) {
                return key2.slice(base.length);
            });
        });
    };
    return nsStorage;
}
function $32ab173dc8a48d4e$export$407448d2b89b1813(key) {
    if (!key) return "";
    return key.split("?")[0].replace(/[/\\]/g, ":").replace(/:+/g, ":").replace(/^:|:$/g, "");
}
function $32ab173dc8a48d4e$export$35e795649ee09318() {
    for(var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++){
        keys[_key] = arguments[_key];
    }
    return $32ab173dc8a48d4e$export$407448d2b89b1813(keys.join(":"));
}
function $32ab173dc8a48d4e$export$7ccc53e8f1e7dfc5(base) {
    base = $32ab173dc8a48d4e$export$407448d2b89b1813(base);
    return base ? base + ":" : "";
}

});


parcelRegister("a74kp", function(module, exports) {

$parcel$export(module.exports, "createStore", function () { return $75cdea51e2e668e1$export$f51a9068ac82ea43; });
$parcel$export(module.exports, "get", function () { return $75cdea51e2e668e1$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "set", function () { return $75cdea51e2e668e1$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "del", function () { return $75cdea51e2e668e1$export$1d2f21e549771e67; });
$parcel$export(module.exports, "clear", function () { return $75cdea51e2e668e1$export$42ffd38884aecdac; });
$parcel$export(module.exports, "keys", function () { return $75cdea51e2e668e1$export$ed97f33186d4b816; });

var $cv9Rk = parcelRequire("cv9Rk");
function $75cdea51e2e668e1$export$b327150396135fe7(request) {
    return new Promise(function(resolve, reject) {
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = function() {
            return resolve(request.result);
        };
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = function() {
            return reject(request.error);
        };
    });
}
function $75cdea51e2e668e1$export$f51a9068ac82ea43(dbName, storeName) {
    var request = indexedDB.open(dbName);
    request.onupgradeneeded = function() {
        return request.result.createObjectStore(storeName);
    };
    var dbp = $75cdea51e2e668e1$export$b327150396135fe7(request);
    return function(txMode, callback) {
        return dbp.then(function(db) {
            return callback(db.transaction(storeName, txMode).objectStore(storeName));
        });
    };
}
var $75cdea51e2e668e1$var$defaultGetStoreFunc;
function $75cdea51e2e668e1$var$defaultGetStore() {
    if (!$75cdea51e2e668e1$var$defaultGetStoreFunc) $75cdea51e2e668e1$var$defaultGetStoreFunc = $75cdea51e2e668e1$export$f51a9068ac82ea43("keyval-store", "keyval");
    return $75cdea51e2e668e1$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $75cdea51e2e668e1$export$3988ae62b71be9a3(key) {
    var customStore = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $75cdea51e2e668e1$var$defaultGetStore();
    return customStore("readonly", function(store) {
        return $75cdea51e2e668e1$export$b327150396135fe7(store.get(key));
    });
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $75cdea51e2e668e1$export$adaa4cf7ef1b65be(key, value) {
    var customStore = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $75cdea51e2e668e1$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.put(value, key);
        return $75cdea51e2e668e1$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $75cdea51e2e668e1$export$daa0a5170277c7a8(entries) {
    var customStore = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $75cdea51e2e668e1$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        entries.forEach(function(entry) {
            return store.put(entry[1], entry[0]);
        });
        return $75cdea51e2e668e1$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $75cdea51e2e668e1$export$5df405cccea42673(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $75cdea51e2e668e1$var$defaultGetStore();
    return customStore("readonly", function(store) {
        return Promise.all(keys.map(function(key) {
            return $75cdea51e2e668e1$export$b327150396135fe7(store.get(key));
        }));
    });
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $75cdea51e2e668e1$export$722fbec263ad908a(key, updater) {
    var customStore = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $75cdea51e2e668e1$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        return(// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise(function(resolve, reject) {
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($75cdea51e2e668e1$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
    });
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $75cdea51e2e668e1$export$1d2f21e549771e67(key) {
    var customStore = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $75cdea51e2e668e1$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.delete(key);
        return $75cdea51e2e668e1$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $75cdea51e2e668e1$export$c8aa84257229cac8(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $75cdea51e2e668e1$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        keys.forEach(function(key) {
            return store.delete(key);
        });
        return $75cdea51e2e668e1$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $75cdea51e2e668e1$export$42ffd38884aecdac() {
    var customStore = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $75cdea51e2e668e1$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.clear();
        return $75cdea51e2e668e1$export$b327150396135fe7(store.transaction);
    });
}
function $75cdea51e2e668e1$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $75cdea51e2e668e1$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $75cdea51e2e668e1$export$ed97f33186d4b816() {
    var customStore = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $75cdea51e2e668e1$var$defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        if (store.getAllKeys) return $75cdea51e2e668e1$export$b327150396135fe7(store.getAllKeys());
        var items = [];
        return $75cdea51e2e668e1$var$eachCursor(store, function(cursor) {
            return items.push(cursor.key);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $75cdea51e2e668e1$export$68c286be0e7e55b7() {
    var customStore = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $75cdea51e2e668e1$var$defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        if (store.getAll) return $75cdea51e2e668e1$export$b327150396135fe7(store.getAll());
        var items = [];
        return $75cdea51e2e668e1$var$eachCursor(store, function(cursor) {
            return items.push(cursor.value);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $75cdea51e2e668e1$export$3e9f948b41964866() {
    var customStore = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $75cdea51e2e668e1$var$defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $75cdea51e2e668e1$export$b327150396135fe7(store.getAllKeys()),
            $75cdea51e2e668e1$export$b327150396135fe7(store.getAll())
        ]).then(function(param) {
            var _param = (0, $cv9Rk._)(param, 2), keys = _param[0], values = _param[1];
            return keys.map(function(key, i) {
                return [
                    key,
                    values[i]
                ];
            });
        });
        var items = [];
        return customStore("readonly", function(store) {
            return $75cdea51e2e668e1$var$eachCursor(store, function(cursor) {
                return items.push([
                    cursor.key,
                    cursor.value
                ]);
            }).then(function() {
                return items;
            });
        });
    });
}

});


parcelRegister("8nsA4", function(module, exports) {

$parcel$export(module.exports, "HEARTBEAT_EVENTS", function () { return $6196a4439d09b612$export$f3340c1af6bee4b5; });
$parcel$export(module.exports, "HeartBeat", function () { return $6196a4439d09b612$export$996c9b2cd7645b55; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $3U0IP = parcelRequire("3U0IP");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");

var $cyxGb = parcelRequire("cyxGb");

var $4BEBs = parcelRequire("4BEBs");
parcelRequire("isy0W");
var $kmEQY = parcelRequire("kmEQY");
var $6196a4439d09b612$export$d31d5212998928bd = /*#__PURE__*/ function(v) {
    "use strict";
    (0, $dcsZi._)(n, v);
    var _super = (0, $ohfOJ._)(n);
    function n(e) {
        (0, $4GJKx._)(this, n);
        return _super.call(this);
    }
    return n;
}((0, $kmEQY.IEvents));
var $6196a4439d09b612$export$31c453b5fe09788d = (0, $4BEBs.FIVE_SECONDS), $6196a4439d09b612$export$f3340c1af6bee4b5 = {
    pulse: "heartbeat_pulse"
};
var $6196a4439d09b612$export$996c9b2cd7645b55 = /*#__PURE__*/ function(n) {
    "use strict";
    (0, $dcsZi._)(i, n);
    var _super = (0, $ohfOJ._)(i);
    function i(e) {
        (0, $4GJKx._)(this, i);
        var _this;
        _this = _super.call(this, e), _this.events = new (0, $cyxGb.EventEmitter), _this.interval = $6196a4439d09b612$export$31c453b5fe09788d, _this.interval = (e === null || e === void 0 ? void 0 : e.interval) || $6196a4439d09b612$export$31c453b5fe09788d;
        return (0, $3U0IP._)(_this);
    }
    (0, $1wc17._)(i, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.initialize()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "stop",
            value: function stop() {
                clearInterval(this.intervalRef);
            }
        },
        {
            key: "on",
            value: function on(e, t) {
                this.events.on(e, t);
            }
        },
        {
            key: "once",
            value: function once(e, t) {
                this.events.once(e, t);
            }
        },
        {
            key: "off",
            value: function off(e, t) {
                this.events.off(e, t);
            }
        },
        {
            key: "removeListener",
            value: function removeListener(e, t) {
                this.events.removeListener(e, t);
            }
        },
        {
            key: "initialize",
            value: function initialize() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        _this.intervalRef = setInterval(function() {
                            return _this.pulse();
                        }, (0, $4BEBs.toMiliseconds)(_this.interval));
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "pulse",
            value: function pulse() {
                this.events.emit($6196a4439d09b612$export$f3340c1af6bee4b5.pulse);
            }
        }
    ], [
        {
            key: "init",
            value: function init(e) {
                return (0, $kSuI9._)(function() {
                    var t;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t = new i(e);
                                return [
                                    4,
                                    t.init()
                                ];
                            case 1:
                                return [
                                    2,
                                    (_state.sent(), t)
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return i;
}($6196a4439d09b612$export$d31d5212998928bd);

});
parcelRegister("isy0W", function(module, exports) {
$parcel$export(module.exports, "IEvents", function () { return (parcelRequire("kmEQY")).IEvents; });
parcelRequire("kmEQY");

});
parcelRegister("kmEQY", function(module, exports) {

$parcel$export(module.exports, "IEvents", function () { return $ed358d59f30ac598$export$ab429ec7e240e546; });

var $4GJKx = parcelRequire("4GJKx");
var $ed358d59f30ac598$export$ab429ec7e240e546 = function IEvents() {
    "use strict";
    (0, $4GJKx._)(this, IEvents);
};

});



parcelRegister("3WrnC", function(module, exports) {

$parcel$export(module.exports, "ICore", function () { return $2dec06f8242aef2e$export$ed533416df113881; });
$parcel$export(module.exports, "IJsonRpcHistory", function () { return $2dec06f8242aef2e$export$45b2c2643615b67; });
$parcel$export(module.exports, "IMessageTracker", function () { return $2dec06f8242aef2e$export$e67570fe0a885c47; });
$parcel$export(module.exports, "IPublisher", function () { return $2dec06f8242aef2e$export$3b0872bbd7e675a2; });
$parcel$export(module.exports, "IRelayer", function () { return $2dec06f8242aef2e$export$9a0f755fd4f79434; });
$parcel$export(module.exports, "IStore", function () { return $2dec06f8242aef2e$export$a7f17ba6c54777e7; });
$parcel$export(module.exports, "ISubscriber", function () { return $2dec06f8242aef2e$export$300eed987e764b57; });
$parcel$export(module.exports, "IExpirer", function () { return $2dec06f8242aef2e$export$41aaa3c39f6f2861; });
$parcel$export(module.exports, "IVerify", function () { return $2dec06f8242aef2e$export$873b0b865d85ddb6; });
$parcel$export(module.exports, "IEchoClient", function () { return $2dec06f8242aef2e$export$7db533fb638f979d; });
$parcel$export(module.exports, "IEventClient", function () { return $2dec06f8242aef2e$export$4264a8ec567679e5; });
$parcel$export(module.exports, "ISignClient", function () { return $2dec06f8242aef2e$export$2ebcf6eeacedad44; });
$parcel$export(module.exports, "IEngine", function () { return $2dec06f8242aef2e$export$87df43c730effa30; });

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $3U0IP = parcelRequire("3U0IP");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("isy0W");
var $kmEQY = parcelRequire("kmEQY");

var $cyxGb = parcelRequire("cyxGb");
var $2dec06f8242aef2e$export$ed533416df113881 = /*#__PURE__*/ function(o) {
    "use strict";
    (0, $dcsZi._)(n, o);
    var _super = (0, $ohfOJ._)(n);
    function n(s) {
        (0, $4GJKx._)(this, n);
        var _this;
        _this = _super.call(this), _this.opts = s, _this.protocol = "wc", _this.version = 2;
        return (0, $3U0IP._)(_this);
    }
    return n;
}((0, $kmEQY.IEvents));
var $2dec06f8242aef2e$export$a4e7e56f03915894 = function l(s, t, e) {
    "use strict";
    (0, $4GJKx._)(this, l);
    this.core = s, this.logger = t;
};
var $2dec06f8242aef2e$export$45b2c2643615b67 = /*#__PURE__*/ function(o) {
    "use strict";
    (0, $dcsZi._)(h, o);
    var _super = (0, $ohfOJ._)(h);
    function h(s, t) {
        (0, $4GJKx._)(this, h);
        var _this;
        _this = _super.call(this), _this.core = s, _this.logger = t, _this.records = new Map;
        return (0, $3U0IP._)(_this);
    }
    return h;
}((0, $kmEQY.IEvents));
var $2dec06f8242aef2e$export$e67570fe0a885c47 = function a(s, t) {
    "use strict";
    (0, $4GJKx._)(this, a);
    this.logger = s, this.core = t;
};
var $2dec06f8242aef2e$export$3b0872bbd7e675a2 = /*#__PURE__*/ function(o) {
    "use strict";
    (0, $dcsZi._)(g, o);
    var _super = (0, $ohfOJ._)(g);
    function g(s, t) {
        (0, $4GJKx._)(this, g);
        var _this;
        _this = _super.call(this), _this.relayer = s, _this.logger = t;
        return (0, $3U0IP._)(_this);
    }
    return g;
}((0, $kmEQY.IEvents));
var $2dec06f8242aef2e$export$9a0f755fd4f79434 = /*#__PURE__*/ function(o) {
    "use strict";
    (0, $dcsZi._)(u, o);
    var _super = (0, $ohfOJ._)(u);
    function u(s) {
        (0, $4GJKx._)(this, u);
        return _super.call(this);
    }
    return u;
}((0, $kmEQY.IEvents));
var $2dec06f8242aef2e$export$a7f17ba6c54777e7 = function p(s, t, e, f) {
    "use strict";
    (0, $4GJKx._)(this, p);
    this.core = s, this.logger = t, this.name = e;
};
var $2dec06f8242aef2e$export$5746ea6dad01660a = function I() {
    "use strict";
    (0, $4GJKx._)(this, I);
    this.map = new Map;
};
var $2dec06f8242aef2e$export$300eed987e764b57 = /*#__PURE__*/ function(o) {
    "use strict";
    (0, $dcsZi._)(d, o);
    var _super = (0, $ohfOJ._)(d);
    function d(s, t) {
        (0, $4GJKx._)(this, d);
        var _this;
        _this = _super.call(this), _this.relayer = s, _this.logger = t;
        return (0, $3U0IP._)(_this);
    }
    return d;
}((0, $kmEQY.IEvents));
var $2dec06f8242aef2e$export$be56d986c75c3691 = function E(s, t) {
    "use strict";
    (0, $4GJKx._)(this, E);
    this.core = s, this.logger = t;
};
var $2dec06f8242aef2e$export$41aaa3c39f6f2861 = /*#__PURE__*/ function(o) {
    "use strict";
    (0, $dcsZi._)(x, o);
    var _super = (0, $ohfOJ._)(x);
    function x(s, t) {
        (0, $4GJKx._)(this, x);
        var _this;
        _this = _super.call(this), _this.core = s, _this.logger = t;
        return (0, $3U0IP._)(_this);
    }
    return x;
}((0, $kmEQY.IEvents));
var $2dec06f8242aef2e$export$d6c2d698ffb743f1 = function m(s, t) {
    "use strict";
    (0, $4GJKx._)(this, m);
    this.logger = s, this.core = t;
};
var $2dec06f8242aef2e$export$873b0b865d85ddb6 = function y(s, t, e) {
    "use strict";
    (0, $4GJKx._)(this, y);
    this.core = s, this.logger = t, this.store = e;
};
var $2dec06f8242aef2e$export$7db533fb638f979d = function v(s, t) {
    "use strict";
    (0, $4GJKx._)(this, v);
    this.projectId = s, this.logger = t;
};
var $2dec06f8242aef2e$export$4264a8ec567679e5 = function C(s, t, e) {
    "use strict";
    (0, $4GJKx._)(this, C);
    this.core = s, this.logger = t, this.telemetryEnabled = e;
};
var $2dec06f8242aef2e$export$235ef727e8a26483 = /*#__PURE__*/ function(c) {
    "use strict";
    (0, $dcsZi._)(b, c);
    var _super = (0, $ohfOJ._)(b);
    function b() {
        (0, $4GJKx._)(this, b);
        return _super.call(this);
    }
    return b;
}((0, (/*@__PURE__*/$parcel$interopDefault($cyxGb))));
var $2dec06f8242aef2e$export$2ebcf6eeacedad44 = function S(s) {
    "use strict";
    (0, $4GJKx._)(this, S);
    this.opts = s, this.protocol = "wc", this.version = 2;
};
var $2dec06f8242aef2e$export$623dd0f793f15643 = /*#__PURE__*/ function(i) {
    "use strict";
    (0, $dcsZi._)(w, i);
    var _super = (0, $ohfOJ._)(w);
    function w() {
        (0, $4GJKx._)(this, w);
        return _super.call(this);
    }
    return w;
}((0, $cyxGb.EventEmitter));
var $2dec06f8242aef2e$export$87df43c730effa30 = function M(s) {
    "use strict";
    (0, $4GJKx._)(this, M);
    this.client = s;
};

});

parcelRegister("bMQws", function(module, exports) {

$parcel$export(module.exports, "JsonRpcProvider", function () { return $894ceb48475fa958$export$da28308012bf6748; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $3U0IP = parcelRequire("3U0IP");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");

var $cyxGb = parcelRequire("cyxGb");
parcelRequire("9YSHu");
var $3W2Mc = parcelRequire("3W2Mc");
var $5lf06 = parcelRequire("5lf06");
var $8WSKZ = parcelRequire("8WSKZ");
var $894ceb48475fa958$export$da28308012bf6748 = /*#__PURE__*/ function(r) {
    "use strict";
    (0, $dcsZi._)(o, r);
    var _super = (0, $ohfOJ._)(o);
    function o(t) {
        (0, $4GJKx._)(this, o);
        var _this;
        _this = _super.call(this, t), _this.events = new (0, $cyxGb.EventEmitter), _this.hasRegisteredEventListeners = !1, _this.connection = _this.setConnection(t), _this.connection.connected && _this.registerEventListeners();
        return (0, $3U0IP._)(_this);
    }
    (0, $1wc17._)(o, [
        {
            key: "connect",
            value: function connect() {
                var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.connection;
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.open(t)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.close()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "on",
            value: function on(t, e) {
                this.events.on(t, e);
            }
        },
        {
            key: "once",
            value: function once(t, e) {
                this.events.once(t, e);
            }
        },
        {
            key: "off",
            value: function off(t, e) {
                this.events.off(t, e);
            }
        },
        {
            key: "removeListener",
            value: function removeListener(t, e) {
                this.events.removeListener(t, e);
            }
        },
        {
            key: "request",
            value: function request(t, e) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.requestStrict((0, $3W2Mc.formatJsonRpcRequest)(t.method, t.params || [], t.id || (0, $3W2Mc.getBigIntRpcId)().toString()), e)
                        ];
                    });
                })();
            }
        },
        {
            key: "requestStrict",
            value: function requestStrict(t, e) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        return [
                            2,
                            new Promise(function() {
                                var _ref = (0, $kSuI9._)(function(i, s) {
                                    var n, n1;
                                    return (0, $eha6O.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!!_this.connection.connected) return [
                                                    3,
                                                    4
                                                ];
                                                _state.label = 1;
                                            case 1:
                                                _state.trys.push([
                                                    1,
                                                    3,
                                                    ,
                                                    4
                                                ]);
                                                return [
                                                    4,
                                                    _this.open()
                                                ];
                                            case 2:
                                                _state.sent();
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 3:
                                                n = _state.sent();
                                                s(n);
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 4:
                                                _this.events.on("".concat(t.id), function(n) {
                                                    (0, $5lf06.isJsonRpcError)(n) ? s(n.error) : i(n.result);
                                                });
                                                _state.label = 5;
                                            case 5:
                                                _state.trys.push([
                                                    5,
                                                    7,
                                                    ,
                                                    8
                                                ]);
                                                return [
                                                    4,
                                                    _this.connection.send(t, e)
                                                ];
                                            case 6:
                                                _state.sent();
                                                return [
                                                    3,
                                                    8
                                                ];
                                            case 7:
                                                n1 = _state.sent();
                                                s(n1);
                                                return [
                                                    3,
                                                    8
                                                ];
                                            case 8:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(i, s) {
                                    return _ref.apply(this, arguments);
                                };
                            }())
                        ];
                    });
                })();
            }
        },
        {
            key: "setConnection",
            value: function setConnection() {
                var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.connection;
                return t;
            }
        },
        {
            key: "onPayload",
            value: function onPayload(t) {
                this.events.emit("payload", t), (0, $5lf06.isJsonRpcResponse)(t) ? this.events.emit("".concat(t.id), t) : this.events.emit("message", {
                    type: t.method,
                    data: t.params
                });
            }
        },
        {
            key: "onClose",
            value: function onClose(t) {
                t && t.code === 3e3 && this.events.emit("error", new Error("WebSocket connection closed abnormally with code: ".concat(t.code, " ").concat(t.reason ? "(".concat(t.reason, ")") : ""))), this.events.emit("disconnect");
            }
        },
        {
            key: "open",
            value: function open() {
                var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.connection;
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _tmp, _tmp1;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = _this.connection === t && _this.connection.connected;
                                if (_tmp) return [
                                    3,
                                    4
                                ];
                                _this.connection.connected && _this.close();
                                _tmp1 = typeof t == "string";
                                if (!_tmp1) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.connection.open(t)
                                ];
                            case 1:
                                _tmp1 = (_state.sent(), t = _this.connection);
                                _state.label = 2;
                            case 2:
                                _tmp1, _this.connection = _this.setConnection(t);
                                return [
                                    4,
                                    _this.connection.open()
                                ];
                            case 3:
                                _tmp = (_state.sent(), _this.registerEventListeners(), _this.events.emit("connect"));
                                _state.label = 4;
                            case 4:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "close",
            value: function close() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.connection.close()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "registerEventListeners",
            value: function registerEventListeners() {
                var _this = this;
                this.hasRegisteredEventListeners || (this.connection.on("payload", function(t) {
                    return _this.onPayload(t);
                }), this.connection.on("close", function(t) {
                    return _this.onClose(t);
                }), this.connection.on("error", function(t) {
                    return _this.events.emit("error", t);
                }), this.connection.on("register_error", function(t) {
                    return _this.onClose();
                }), this.hasRegisteredEventListeners = !0);
            }
        }
    ]);
    return o;
}((0, $8WSKZ.IJsonRpcProvider));

});
parcelRegister("9YSHu", function(module, exports) {
$parcel$export(module.exports, "parseConnectionError", function () { return (parcelRequire("dhRah")).parseConnectionError; });
$parcel$export(module.exports, "formatJsonRpcResult", function () { return (parcelRequire("5z4l8")).formatJsonRpcResult; });
$parcel$export(module.exports, "formatJsonRpcRequest", function () { return (parcelRequire("5z4l8")).formatJsonRpcRequest; });
$parcel$export(module.exports, "getBigIntRpcId", function () { return (parcelRequire("5z4l8")).getBigIntRpcId; });
$parcel$export(module.exports, "isJsonRpcError", function () { return (parcelRequire("5z4l8")).isJsonRpcError; });
$parcel$export(module.exports, "isJsonRpcResponse", function () { return (parcelRequire("5z4l8")).isJsonRpcResponse; });
$parcel$export(module.exports, "IJsonRpcProvider", function () { return (parcelRequire("5z4l8")).IJsonRpcProvider; });
$parcel$export(module.exports, "isHttpUrl", function () { return (parcelRequire("5z4l8")).isHttpUrl; });
$parcel$export(module.exports, "formatJsonRpcError", function () { return (parcelRequire("5z4l8")).formatJsonRpcError; });
$parcel$export(module.exports, "parseConnectionError", function () { return (parcelRequire("5z4l8")).parseConnectionError; });
$parcel$export(module.exports, "payloadId", function () { return (parcelRequire("5z4l8")).payloadId; });
$parcel$export(module.exports, "isJsonRpcResult", function () { return (parcelRequire("5z4l8")).isJsonRpcResult; });
$parcel$export(module.exports, "isJsonRpcRequest", function () { return (parcelRequire("5z4l8")).isJsonRpcRequest; });
$parcel$export(module.exports, "isWsUrl", function () { return (parcelRequire("5z4l8")).isWsUrl; });
$parcel$export(module.exports, "isReactNative", function () { return (parcelRequire("5z4l8")).isReactNative; });
$parcel$export(module.exports, "isLocalhostUrl", function () { return (parcelRequire("5z4l8")).isLocalhostUrl; });
$parcel$export(module.exports, "formatJsonRpcResult", function () { return (parcelRequire("3W2Mc")).formatJsonRpcResult; });
$parcel$export(module.exports, "formatJsonRpcRequest", function () { return (parcelRequire("3W2Mc")).formatJsonRpcRequest; });
$parcel$export(module.exports, "getBigIntRpcId", function () { return (parcelRequire("3W2Mc")).getBigIntRpcId; });
$parcel$export(module.exports, "formatJsonRpcError", function () { return (parcelRequire("3W2Mc")).formatJsonRpcError; });
$parcel$export(module.exports, "payloadId", function () { return (parcelRequire("3W2Mc")).payloadId; });
$parcel$export(module.exports, "IJsonRpcProvider", function () { return (parcelRequire("8WSKZ")).IJsonRpcProvider; });
$parcel$export(module.exports, "isHttpUrl", function () { return (parcelRequire("52GQV")).isHttpUrl; });
$parcel$export(module.exports, "isWsUrl", function () { return (parcelRequire("52GQV")).isWsUrl; });
$parcel$export(module.exports, "isLocalhostUrl", function () { return (parcelRequire("52GQV")).isLocalhostUrl; });
$parcel$export(module.exports, "isJsonRpcError", function () { return (parcelRequire("5lf06")).isJsonRpcError; });
$parcel$export(module.exports, "isJsonRpcResponse", function () { return (parcelRequire("5lf06")).isJsonRpcResponse; });
$parcel$export(module.exports, "isJsonRpcResult", function () { return (parcelRequire("5lf06")).isJsonRpcResult; });
$parcel$export(module.exports, "isJsonRpcRequest", function () { return (parcelRequire("5lf06")).isJsonRpcRequest; });
parcelRequire("eGPy7");
parcelRequire("dhRah");
parcelRequire("bmE5V");
parcelRequire("3W2Mc");
parcelRequire("55K2e");
parcelRequire("OvkA8");
parcelRequire("52GQV");
parcelRequire("5lf06");

});
parcelRegister("eGPy7", function(module, exports) {

$parcel$export(module.exports, "INTERNAL_ERROR", function () { return $ab1cf988991026a6$export$f6e3abf3038d348f; });
$parcel$export(module.exports, "SERVER_ERROR", function () { return $ab1cf988991026a6$export$125ebd30471ac25c; });
$parcel$export(module.exports, "RESERVED_ERROR_CODES", function () { return $ab1cf988991026a6$export$af84821b5448ca78; });
$parcel$export(module.exports, "SERVER_ERROR_CODE_RANGE", function () { return $ab1cf988991026a6$export$fff5b44b15c75f69; });
$parcel$export(module.exports, "STANDARD_ERROR_MAP", function () { return $ab1cf988991026a6$export$cca5387ab287e1ae; });
$parcel$export(module.exports, "DEFAULT_ERROR", function () { return $ab1cf988991026a6$export$d166979eca925bce; });

var $3sHb8 = parcelRequire("3sHb8");
var $ab1cf988991026a6$export$2ecaad7eb5cc1f25 = "PARSE_ERROR";
var $ab1cf988991026a6$export$c77b2f9ece3946ce = "INVALID_REQUEST";
var $ab1cf988991026a6$export$e8d537b30db778d6 = "METHOD_NOT_FOUND";
var $ab1cf988991026a6$export$13aae195c7978fb1 = "INVALID_PARAMS";
var $ab1cf988991026a6$export$f6e3abf3038d348f = "INTERNAL_ERROR";
var $ab1cf988991026a6$export$125ebd30471ac25c = "SERVER_ERROR";
var $ab1cf988991026a6$export$af84821b5448ca78 = [
    -32700,
    -32600,
    -32601,
    -32602,
    -32603
];
var $ab1cf988991026a6$export$fff5b44b15c75f69 = [
    -32000,
    -32099
];
var $ab1cf988991026a6$var$_obj;
var $ab1cf988991026a6$export$cca5387ab287e1ae = ($ab1cf988991026a6$var$_obj = {}, (0, $3sHb8._)($ab1cf988991026a6$var$_obj, $ab1cf988991026a6$export$2ecaad7eb5cc1f25, {
    code: -32700,
    message: "Parse error"
}), (0, $3sHb8._)($ab1cf988991026a6$var$_obj, $ab1cf988991026a6$export$c77b2f9ece3946ce, {
    code: -32600,
    message: "Invalid Request"
}), (0, $3sHb8._)($ab1cf988991026a6$var$_obj, $ab1cf988991026a6$export$e8d537b30db778d6, {
    code: -32601,
    message: "Method not found"
}), (0, $3sHb8._)($ab1cf988991026a6$var$_obj, $ab1cf988991026a6$export$13aae195c7978fb1, {
    code: -32602,
    message: "Invalid params"
}), (0, $3sHb8._)($ab1cf988991026a6$var$_obj, $ab1cf988991026a6$export$f6e3abf3038d348f, {
    code: -32603,
    message: "Internal error"
}), (0, $3sHb8._)($ab1cf988991026a6$var$_obj, $ab1cf988991026a6$export$125ebd30471ac25c, {
    code: -32000,
    message: "Server error"
}), $ab1cf988991026a6$var$_obj);
var $ab1cf988991026a6$export$d166979eca925bce = $ab1cf988991026a6$export$125ebd30471ac25c;

});

parcelRegister("dhRah", function(module, exports) {

$parcel$export(module.exports, "isReservedErrorCode", function () { return $9ac61a56b824fde5$export$2ae0ec6393ab16c3; });
$parcel$export(module.exports, "getError", function () { return $9ac61a56b824fde5$export$e1599abf47b5b568; });
$parcel$export(module.exports, "getErrorByCode", function () { return $9ac61a56b824fde5$export$60a3bac005957e12; });
$parcel$export(module.exports, "parseConnectionError", function () { return $9ac61a56b824fde5$export$f555d7d8f922e407; });

var $eGPy7 = parcelRequire("eGPy7");
function $9ac61a56b824fde5$export$e463129eb4bc487f(code) {
    return code <= (0, $eGPy7.SERVER_ERROR_CODE_RANGE)[0] && code >= (0, $eGPy7.SERVER_ERROR_CODE_RANGE)[1];
}
function $9ac61a56b824fde5$export$2ae0ec6393ab16c3(code) {
    return (0, $eGPy7.RESERVED_ERROR_CODES).includes(code);
}
function $9ac61a56b824fde5$export$7543109e66e1748d(code) {
    return typeof code === "number";
}
function $9ac61a56b824fde5$export$e1599abf47b5b568(type) {
    if (!Object.keys((0, $eGPy7.STANDARD_ERROR_MAP)).includes(type)) return (0, $eGPy7.STANDARD_ERROR_MAP)[0, $eGPy7.DEFAULT_ERROR];
    return (0, $eGPy7.STANDARD_ERROR_MAP)[type];
}
function $9ac61a56b824fde5$export$60a3bac005957e12(code) {
    var match = Object.values((0, $eGPy7.STANDARD_ERROR_MAP)).find(function(e) {
        return e.code === code;
    });
    if (!match) return (0, $eGPy7.STANDARD_ERROR_MAP)[0, $eGPy7.DEFAULT_ERROR];
    return match;
}
function $9ac61a56b824fde5$export$6be064b82176dd99(response) {
    if (typeof response.error.code === "undefined") return {
        valid: false,
        error: "Missing code for JSON-RPC error"
    };
    if (typeof response.error.message === "undefined") return {
        valid: false,
        error: "Missing message for JSON-RPC error"
    };
    if (!$9ac61a56b824fde5$export$7543109e66e1748d(response.error.code)) return {
        valid: false,
        error: "Invalid error code type for JSON-RPC: ".concat(response.error.code)
    };
    if ($9ac61a56b824fde5$export$2ae0ec6393ab16c3(response.error.code)) {
        var error = $9ac61a56b824fde5$export$60a3bac005957e12(response.error.code);
        if (error.message !== (0, $eGPy7.STANDARD_ERROR_MAP)[0, $eGPy7.DEFAULT_ERROR].message && response.error.message === error.message) return {
            valid: false,
            error: "Invalid error code message for JSON-RPC: ".concat(response.error.code)
        };
    }
    return {
        valid: true
    };
}
function $9ac61a56b824fde5$export$f555d7d8f922e407(e, url, type) {
    return e.message.includes("getaddrinfo ENOTFOUND") || e.message.includes("connect ECONNREFUSED") ? new Error("Unavailable ".concat(type, " RPC url at ").concat(url)) : e;
}

});

parcelRegister("bmE5V", function(module, exports) {

var $5z4l8 = parcelRequire("5z4l8");
var $8460d9be42e9c706$export$d1694901a048d7c8 = (0, $5z4l8.isNode);
$parcel$exportWildcard(module.exports, $5z4l8);

});
parcelRegister("5z4l8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dGR1m = parcelRequire("dGR1m");

$dGR1m.__exportStar((parcelRequire("6bA75")), module.exports);

$dGR1m.__exportStar((parcelRequire("4JBIh")), module.exports);

});
parcelRegister("dGR1m", function(module, exports) {

$parcel$export(module.exports, "__exportStar", function () { return $9f7853751cc30d0d$export$f33643c0debef087; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $9f7853751cc30d0d$var$extendStatics = function extendStatics1(d, b) {
    $9f7853751cc30d0d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $9f7853751cc30d0d$var$extendStatics(d, b);
};
function $9f7853751cc30d0d$export$a8ba968b8961cb8a(d, b) {
    $9f7853751cc30d0d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $9f7853751cc30d0d$export$18ce0697a983be9b = function __assign1() {
    $9f7853751cc30d0d$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9f7853751cc30d0d$export$18ce0697a983be9b.apply(this, arguments);
};
function $9f7853751cc30d0d$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $9f7853751cc30d0d$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $9f7853751cc30d0d$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $9f7853751cc30d0d$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $9f7853751cc30d0d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $9f7853751cc30d0d$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $9f7853751cc30d0d$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $9f7853751cc30d0d$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $9f7853751cc30d0d$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $9f7853751cc30d0d$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $9f7853751cc30d0d$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($9f7853751cc30d0d$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $9f7853751cc30d0d$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $9f7853751cc30d0d$export$10c90e4f7922046c(v) {
    return this instanceof $9f7853751cc30d0d$export$10c90e4f7922046c ? (this.v = v, this) : new $9f7853751cc30d0d$export$10c90e4f7922046c(v);
}
function $9f7853751cc30d0d$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $9f7853751cc30d0d$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $9f7853751cc30d0d$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $9f7853751cc30d0d$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $9f7853751cc30d0d$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $9f7853751cc30d0d$export$19a8beecd37a4c45 === "function" ? $9f7853751cc30d0d$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $9f7853751cc30d0d$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $9f7853751cc30d0d$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $9f7853751cc30d0d$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $9f7853751cc30d0d$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $9f7853751cc30d0d$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("6bA75", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isBrowserCryptoAvailable = module.exports.getSubtleCrypto = module.exports.getBrowerCrypto = void 0;
function $480fc884210c1b79$var$getBrowerCrypto() {
    return ($parcel$global === null || $parcel$global === void 0 ? void 0 : $parcel$global.crypto) || ($parcel$global === null || $parcel$global === void 0 ? void 0 : $parcel$global.msCrypto) || {};
}
module.exports.getBrowerCrypto = $480fc884210c1b79$var$getBrowerCrypto;
function $480fc884210c1b79$var$getSubtleCrypto() {
    var browserCrypto = $480fc884210c1b79$var$getBrowerCrypto();
    return browserCrypto.subtle || browserCrypto.webkitSubtle;
}
module.exports.getSubtleCrypto = $480fc884210c1b79$var$getSubtleCrypto;
function $480fc884210c1b79$var$isBrowserCryptoAvailable() {
    return !!$480fc884210c1b79$var$getBrowerCrypto() && !!$480fc884210c1b79$var$getSubtleCrypto();
}
module.exports.isBrowserCryptoAvailable = $480fc884210c1b79$var$isBrowserCryptoAvailable;

});

parcelRegister("4JBIh", function(module, exports) {

var $3qWgZ = parcelRequire("3qWgZ");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isBrowser = module.exports.isNode = module.exports.isReactNative = void 0;
function $37289e71fb048568$var$isReactNative() {
    return typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative";
}
module.exports.isReactNative = $37289e71fb048568$var$isReactNative;
function $37289e71fb048568$var$isNode() {
    return typeof $3qWgZ !== "undefined" && typeof $3qWgZ.versions !== "undefined" && typeof $3qWgZ.versions.node !== "undefined";
}
module.exports.isNode = $37289e71fb048568$var$isNode;
function $37289e71fb048568$var$isBrowser() {
    return !$37289e71fb048568$var$isReactNative() && !$37289e71fb048568$var$isNode();
}
module.exports.isBrowser = $37289e71fb048568$var$isBrowser;

});



parcelRegister("3W2Mc", function(module, exports) {

$parcel$export(module.exports, "payloadId", function () { return $2dd8f13660300ef1$export$2f5364a5d4b80251; });
$parcel$export(module.exports, "getBigIntRpcId", function () { return $2dd8f13660300ef1$export$799a3db5df197877; });
$parcel$export(module.exports, "formatJsonRpcRequest", function () { return $2dd8f13660300ef1$export$11d081ebb32d4398; });
$parcel$export(module.exports, "formatJsonRpcResult", function () { return $2dd8f13660300ef1$export$478fdea01c2a3198; });
$parcel$export(module.exports, "formatJsonRpcError", function () { return $2dd8f13660300ef1$export$9f7302ae26c3f77; });

var $dhRah = parcelRequire("dhRah");

var $eGPy7 = parcelRequire("eGPy7");
function $2dd8f13660300ef1$export$2f5364a5d4b80251() {
    var entropy = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 3;
    var date = Date.now() * Math.pow(10, entropy);
    var extra = Math.floor(Math.random() * Math.pow(10, entropy));
    return date + extra;
}
function $2dd8f13660300ef1$export$799a3db5df197877() {
    var entropy = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 6;
    return BigInt($2dd8f13660300ef1$export$2f5364a5d4b80251(entropy));
}
function $2dd8f13660300ef1$export$11d081ebb32d4398(method, params, id) {
    return {
        id: id || $2dd8f13660300ef1$export$2f5364a5d4b80251(),
        jsonrpc: "2.0",
        method: method,
        params: params
    };
}
function $2dd8f13660300ef1$export$478fdea01c2a3198(id, result) {
    return {
        id: id,
        jsonrpc: "2.0",
        result: result
    };
}
function $2dd8f13660300ef1$export$9f7302ae26c3f77(id, error, data) {
    return {
        id: id,
        jsonrpc: "2.0",
        error: $2dd8f13660300ef1$export$5201d50a34753d71(error, data)
    };
}
function $2dd8f13660300ef1$export$5201d50a34753d71(error, data) {
    if (typeof error === "undefined") return (0, $dhRah.getError)((0, $eGPy7.INTERNAL_ERROR));
    if (typeof error === "string") error = Object.assign(Object.assign({}, (0, $dhRah.getError)((0, $eGPy7.SERVER_ERROR))), {
        message: error
    });
    if (typeof data !== "undefined") error.data = data;
    if ((0, $dhRah.isReservedErrorCode)(error.code)) error = (0, $dhRah.getErrorByCode)(error.code);
    return error;
}

});

parcelRegister("55K2e", function(module, exports) {
function $3b5120f322da83b0$export$9f3e656a7f6a3adc(route) {
    if (route.includes("*")) return $3b5120f322da83b0$export$8e8b9bea55b56df2(route);
    if (/\W/g.test(route)) return false;
    return true;
}
function $3b5120f322da83b0$export$c7e2040809cad2c4(route) {
    return route === "*";
}
function $3b5120f322da83b0$export$8e8b9bea55b56df2(route) {
    if ($3b5120f322da83b0$export$c7e2040809cad2c4(route)) return true;
    if (!route.includes("*")) return false;
    if (route.split("*").length !== 2) return false;
    if (route.split("*").filter(function(x) {
        return x.trim() === "";
    }).length !== 1) return false;
    return true;
}
function $3b5120f322da83b0$export$2d48faaafcc8fbdc(route) {
    return !$3b5120f322da83b0$export$c7e2040809cad2c4(route) && $3b5120f322da83b0$export$8e8b9bea55b56df2(route) && !route.split("*")[0].trim();
}
function $3b5120f322da83b0$export$be298a4710fab756(route) {
    return !$3b5120f322da83b0$export$c7e2040809cad2c4(route) && $3b5120f322da83b0$export$8e8b9bea55b56df2(route) && !route.split("*")[1].trim();
}

});

parcelRegister("OvkA8", function(module, exports) {
$parcel$export(module.exports, "IJsonRpcProvider", function () { return (parcelRequire("8WSKZ")).IJsonRpcProvider; });
parcelRequire("8WSKZ");

});
parcelRegister("8WSKZ", function(module, exports) {

$parcel$export(module.exports, "IJsonRpcProvider", function () { return $683e3714e6c18a4c$export$46957420a688a16d; });

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");
var $683e3714e6c18a4c$export$ab429ec7e240e546 = function e() {
    "use strict";
    (0, $4GJKx._)(this, e);
};
var $683e3714e6c18a4c$export$77d426dd89724fbe = /*#__PURE__*/ function(e) {
    "use strict";
    (0, $dcsZi._)(o, e);
    var _super = (0, $ohfOJ._)(o);
    function o(c) {
        (0, $4GJKx._)(this, o);
        return _super.call(this);
    }
    return o;
}($683e3714e6c18a4c$export$ab429ec7e240e546);
var $683e3714e6c18a4c$export$cb916a2eed49af33 = /*#__PURE__*/ function(e) {
    "use strict";
    (0, $dcsZi._)(n, e);
    var _super = (0, $ohfOJ._)(n);
    function n() {
        (0, $4GJKx._)(this, n);
        return _super.call(this);
    }
    return n;
}($683e3714e6c18a4c$export$ab429ec7e240e546);
var $683e3714e6c18a4c$export$46957420a688a16d = /*#__PURE__*/ function(n) {
    "use strict";
    (0, $dcsZi._)(r, n);
    var _super = (0, $ohfOJ._)(r);
    function r(c) {
        (0, $4GJKx._)(this, r);
        return _super.call(this);
    }
    return r;
}($683e3714e6c18a4c$export$cb916a2eed49af33);

});


parcelRegister("52GQV", function(module, exports) {

$parcel$export(module.exports, "isHttpUrl", function () { return $3abe614f48a22d0f$export$206c3129b8bb1b4f; });
$parcel$export(module.exports, "isWsUrl", function () { return $3abe614f48a22d0f$export$4e4463e75eccf20c; });
$parcel$export(module.exports, "isLocalhostUrl", function () { return $3abe614f48a22d0f$export$8eb4a0a481601f29; });
var $3abe614f48a22d0f$var$HTTP_REGEX = "^https?:";
var $3abe614f48a22d0f$var$WS_REGEX = "^wss?:";
function $3abe614f48a22d0f$var$getUrlProtocol(url) {
    var matches = url.match(new RegExp(/^\w+:/, "gi"));
    if (!matches || !matches.length) return;
    return matches[0];
}
function $3abe614f48a22d0f$var$matchRegexProtocol(url, regex) {
    var protocol = $3abe614f48a22d0f$var$getUrlProtocol(url);
    if (typeof protocol === "undefined") return false;
    return new RegExp(regex).test(protocol);
}
function $3abe614f48a22d0f$export$206c3129b8bb1b4f(url) {
    return $3abe614f48a22d0f$var$matchRegexProtocol(url, $3abe614f48a22d0f$var$HTTP_REGEX);
}
function $3abe614f48a22d0f$export$4e4463e75eccf20c(url) {
    return $3abe614f48a22d0f$var$matchRegexProtocol(url, $3abe614f48a22d0f$var$WS_REGEX);
}
function $3abe614f48a22d0f$export$8eb4a0a481601f29(url) {
    return new RegExp("wss?://localhost(:d{2,5})?").test(url);
}

});

parcelRegister("5lf06", function(module, exports) {

$parcel$export(module.exports, "isJsonRpcRequest", function () { return $3e3a8cbf8627be04$export$f6e4034abe07d2a5; });
$parcel$export(module.exports, "isJsonRpcResponse", function () { return $3e3a8cbf8627be04$export$308ba927de2bcbe8; });
$parcel$export(module.exports, "isJsonRpcResult", function () { return $3e3a8cbf8627be04$export$cb3d3b20e3223d77; });
$parcel$export(module.exports, "isJsonRpcError", function () { return $3e3a8cbf8627be04$export$5662a1047b4d1d15; });
function $3e3a8cbf8627be04$export$bf3617e9fafa893f(payload) {
    return typeof payload === "object" && "id" in payload && "jsonrpc" in payload && payload.jsonrpc === "2.0";
}
function $3e3a8cbf8627be04$export$f6e4034abe07d2a5(payload) {
    return $3e3a8cbf8627be04$export$bf3617e9fafa893f(payload) && "method" in payload;
}
function $3e3a8cbf8627be04$export$308ba927de2bcbe8(payload) {
    return $3e3a8cbf8627be04$export$bf3617e9fafa893f(payload) && ($3e3a8cbf8627be04$export$cb3d3b20e3223d77(payload) || $3e3a8cbf8627be04$export$5662a1047b4d1d15(payload));
}
function $3e3a8cbf8627be04$export$cb3d3b20e3223d77(payload) {
    return "result" in payload;
}
function $3e3a8cbf8627be04$export$5662a1047b4d1d15(payload) {
    return "error" in payload;
}
function $3e3a8cbf8627be04$export$ae97720cc2d120d4(validation) {
    return "error" in validation && validation.valid === false;
}

});



parcelRegister("gCTEP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1ab5e5b3aaf2cbe$export$ea0df116fa892998; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $l0HdX = parcelRequire("l0HdX");

var $eha6O = parcelRequire("eha6O");

var $cyxGb = parcelRequire("cyxGb");

var $2fy4s = parcelRequire("2fy4s");
parcelRequire("9YSHu");
var $52GQV = parcelRequire("52GQV");
var $5z4l8 = parcelRequire("5z4l8");
var $3W2Mc = parcelRequire("3W2Mc");
var $dhRah = parcelRequire("dhRah");

var $c1ab5e5b3aaf2cbe$var$w = function() {
    return (typeof WebSocket === "undefined" ? "undefined" : (0, $l0HdX._)(WebSocket)) < "u" ? WebSocket : (typeof $parcel$global === "undefined" ? "undefined" : (0, $l0HdX._)($parcel$global)) < "u" && (0, $l0HdX._)($parcel$global.WebSocket) < "u" ? $parcel$global.WebSocket : (typeof window === "undefined" ? "undefined" : (0, $l0HdX._)(window)) < "u" && (0, $l0HdX._)(window.WebSocket) < "u" ? window.WebSocket : (typeof self === "undefined" ? "undefined" : (0, $l0HdX._)(self)) < "u" && (0, $l0HdX._)(self.WebSocket) < "u" ? self.WebSocket : (parcelRequire("imJuh"));
}, $c1ab5e5b3aaf2cbe$var$b = function() {
    return (typeof WebSocket === "undefined" ? "undefined" : (0, $l0HdX._)(WebSocket)) < "u" || (typeof $parcel$global === "undefined" ? "undefined" : (0, $l0HdX._)($parcel$global)) < "u" && (0, $l0HdX._)($parcel$global.WebSocket) < "u" || (typeof window === "undefined" ? "undefined" : (0, $l0HdX._)(window)) < "u" && (0, $l0HdX._)(window.WebSocket) < "u" || (typeof self === "undefined" ? "undefined" : (0, $l0HdX._)(self)) < "u" && (0, $l0HdX._)(self.WebSocket) < "u";
}, $c1ab5e5b3aaf2cbe$var$a = function(c) {
    return c.split("?")[0];
}, $c1ab5e5b3aaf2cbe$var$h = 10, $c1ab5e5b3aaf2cbe$var$S = $c1ab5e5b3aaf2cbe$var$w();
var $c1ab5e5b3aaf2cbe$export$ea0df116fa892998 = /*#__PURE__*/ function() {
    "use strict";
    function f(e) {
        (0, $4GJKx._)(this, f);
        if (this.url = e, this.events = new (0, $cyxGb.EventEmitter), this.registering = !1, !(0, $52GQV.isWsUrl)(e)) throw new Error("Provided URL is not compatible with WebSocket connection: ".concat(e));
        this.url = e;
    }
    (0, $1wc17._)(f, [
        {
            key: "connected",
            get: function get() {
                return (0, $l0HdX._)(this.socket) < "u";
            }
        },
        {
            key: "connecting",
            get: function get() {
                return this.registering;
            }
        },
        {
            key: "on",
            value: function on(e, t) {
                this.events.on(e, t);
            }
        },
        {
            key: "once",
            value: function once(e, t) {
                this.events.once(e, t);
            }
        },
        {
            key: "off",
            value: function off(e, t) {
                this.events.off(e, t);
            }
        },
        {
            key: "removeListener",
            value: function removeListener(e, t) {
                this.events.removeListener(e, t);
            }
        },
        {
            key: "open",
            value: function open() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.url;
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.register(e)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "close",
            value: function close() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        return [
                            2,
                            new Promise(function(e, t) {
                                if ((0, $l0HdX._)(_this.socket) > "u") {
                                    t(new Error("Connection already closed"));
                                    return;
                                }
                                _this.socket.onclose = function(n) {
                                    _this.onClose(n), e();
                                }, _this.socket.close();
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "send",
            value: function send(e) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _tmp;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = (0, $l0HdX._)(_this.socket) > "u";
                                if (!_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.register()
                                ];
                            case 1:
                                _tmp = _this.socket = _state.sent();
                                _state.label = 2;
                            case 2:
                                _tmp;
                                try {
                                    _this.socket.send((0, $2fy4s.safeJsonStringify)(e));
                                } catch (t) {
                                    _this.onError(e.id, t);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "register",
            value: function register() {
                var _this = this;
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.url;
                if (!(0, $52GQV.isWsUrl)(e)) throw new Error("Provided URL is not compatible with WebSocket connection: ".concat(e));
                if (this.registering) {
                    var t = this.events.getMaxListeners();
                    return (this.events.listenerCount("register_error") >= t || this.events.listenerCount("open") >= t) && this.events.setMaxListeners(t + 1), new Promise(function(n, o) {
                        _this.events.once("register_error", function(s) {
                            _this.resetMaxListeners(), o(s);
                        }), _this.events.once("open", function() {
                            if (_this.resetMaxListeners(), (0, $l0HdX._)(_this.socket) > "u") return o(new Error("WebSocket connection is missing or invalid"));
                            n(_this.socket);
                        });
                    });
                }
                return this.url = e, this.registering = !0, new Promise(function(t, n) {
                    var o = new URLSearchParams(e).get("origin"), s = (0, $5z4l8.isReactNative)() ? {
                        headers: {
                            origin: o
                        }
                    } : {
                        rejectUnauthorized: !(0, $52GQV.isLocalhostUrl)(e)
                    }, i = new $c1ab5e5b3aaf2cbe$var$S(e, [], s);
                    $c1ab5e5b3aaf2cbe$var$b() ? i.onerror = function(r) {
                        var l = r;
                        n(_this.emitError(l.error));
                    } : i.on("error", function(r) {
                        n(_this.emitError(r));
                    }), i.onopen = function() {
                        _this.onOpen(i), t(i);
                    };
                });
            }
        },
        {
            key: "onOpen",
            value: function onOpen(e) {
                var _this = this;
                e.onmessage = function(t) {
                    return _this.onPayload(t);
                }, e.onclose = function(t) {
                    return _this.onClose(t);
                }, this.socket = e, this.registering = !1, this.events.emit("open");
            }
        },
        {
            key: "onClose",
            value: function onClose(e) {
                this.socket = void 0, this.registering = !1, this.events.emit("close", e);
            }
        },
        {
            key: "onPayload",
            value: function onPayload(e) {
                if ((0, $l0HdX._)(e.data) > "u") return;
                var t = typeof e.data == "string" ? (0, $2fy4s.safeJsonParse)(e.data) : e.data;
                this.events.emit("payload", t);
            }
        },
        {
            key: "onError",
            value: function onError(e, t) {
                var n = this.parseError(t), o = n.message || n.toString(), s = (0, $3W2Mc.formatJsonRpcError)(e, o);
                this.events.emit("payload", s);
            }
        },
        {
            key: "parseError",
            value: function parseError(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.url;
                return (0, $dhRah.parseConnectionError)(e, $c1ab5e5b3aaf2cbe$var$a(t), "WS");
            }
        },
        {
            key: "resetMaxListeners",
            value: function resetMaxListeners() {
                this.events.getMaxListeners() > $c1ab5e5b3aaf2cbe$var$h && this.events.setMaxListeners($c1ab5e5b3aaf2cbe$var$h);
            }
        },
        {
            key: "emitError",
            value: function emitError(e) {
                var t = this.parseError(new Error((e === null || e === void 0 ? void 0 : e.message) || "WebSocket connection failed for host: ".concat($c1ab5e5b3aaf2cbe$var$a(this.url))));
                return this.events.emit("register_error", t), t;
            }
        }
    ]);
    return f;
}();

});
parcelRegister("imJuh", function(module, exports) {
"use strict";
module.exports = function() {
    throw new Error("ws does not work in the browser. Browser clients must use the native WebSocket object");
};

});


parcelRegister("7NEHj", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ 
var $l0HdX = parcelRequire("l0HdX");
var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function getSymbols(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function getTag(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value);
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function isArguments(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value);
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

});



parcelRegister("7FPw1", function(module, exports) {

$parcel$export(module.exports, "HttpConnection", function () { return $596452a5ca5ce605$export$13c1f9cf8a283575; });
$parcel$export(module.exports, "default", function () { return $596452a5ca5ce605$export$13c1f9cf8a283575; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $l0HdX = parcelRequire("l0HdX");

var $eha6O = parcelRequire("eha6O");

var $cyxGb = parcelRequire("cyxGb");

var $hshPe = parcelRequire("hshPe");

var $2fy4s = parcelRequire("2fy4s");
parcelRequire("9YSHu");
var $52GQV = parcelRequire("52GQV");
var $3W2Mc = parcelRequire("3W2Mc");
var $dhRah = parcelRequire("dhRah");
var $596452a5ca5ce605$var$P = Object.defineProperty, $596452a5ca5ce605$var$w = Object.defineProperties, $596452a5ca5ce605$var$E = Object.getOwnPropertyDescriptors, $596452a5ca5ce605$var$c = Object.getOwnPropertySymbols, $596452a5ca5ce605$var$L = Object.prototype.hasOwnProperty, $596452a5ca5ce605$var$O = Object.prototype.propertyIsEnumerable, $596452a5ca5ce605$var$l = function(r, t, e) {
    return t in r ? $596452a5ca5ce605$var$P(r, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : r[t] = e;
}, $596452a5ca5ce605$var$p = function(r, t) {
    for(var e in t || (t = {}))$596452a5ca5ce605$var$L.call(t, e) && $596452a5ca5ce605$var$l(r, e, t[e]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($596452a5ca5ce605$var$c) try {
        for(var _iterator = $596452a5ca5ce605$var$c(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var e = _step.value;
            $596452a5ca5ce605$var$O.call(t, e) && $596452a5ca5ce605$var$l(r, e, t[e]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return r;
}, $596452a5ca5ce605$var$v = function(r, t) {
    return $596452a5ca5ce605$var$w(r, $596452a5ca5ce605$var$E(t));
};
var $596452a5ca5ce605$var$j = {
    Accept: "application/json",
    "Content-Type": "application/json"
}, $596452a5ca5ce605$var$T = "POST", $596452a5ca5ce605$var$d = {
    headers: $596452a5ca5ce605$var$j,
    method: $596452a5ca5ce605$var$T
}, $596452a5ca5ce605$var$g = 10;
var $596452a5ca5ce605$export$13c1f9cf8a283575 = /*#__PURE__*/ function() {
    "use strict";
    function f(t) {
        var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
        (0, $4GJKx._)(this, f);
        if (this.url = t, this.disableProviderPing = e, this.events = new (0, $cyxGb.EventEmitter), this.isAvailable = !1, this.registering = !1, !(0, $52GQV.isHttpUrl)(t)) throw new Error("Provided URL is not compatible with HTTP connection: ".concat(t));
        this.url = t, this.disableProviderPing = e;
    }
    (0, $1wc17._)(f, [
        {
            key: "connected",
            get: function get() {
                return this.isAvailable;
            }
        },
        {
            key: "connecting",
            get: function get() {
                return this.registering;
            }
        },
        {
            key: "on",
            value: function on(t, e) {
                this.events.on(t, e);
            }
        },
        {
            key: "once",
            value: function once(t, e) {
                this.events.once(t, e);
            }
        },
        {
            key: "off",
            value: function off(t, e) {
                this.events.off(t, e);
            }
        },
        {
            key: "removeListener",
            value: function removeListener(t, e) {
                this.events.removeListener(t, e);
            }
        },
        {
            key: "open",
            value: function open() {
                var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.url;
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.register(t)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "close",
            value: function close() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        if (!_this.isAvailable) throw new Error("Connection already closed");
                        _this.onClose();
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "send",
            value: function send(t) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _tmp, _$e, s, e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = _this.isAvailable;
                                if (_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.register()
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                _tmp;
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    6,
                                    ,
                                    7
                                ]);
                                _$e = (0, $2fy4s.safeJsonStringify)(t);
                                return [
                                    4,
                                    (0, (/*@__PURE__*/$parcel$interopDefault($hshPe)))(_this.url, $596452a5ca5ce605$var$v($596452a5ca5ce605$var$p({}, $596452a5ca5ce605$var$d), {
                                        body: _$e
                                    }))
                                ];
                            case 4:
                                return [
                                    4,
                                    _state.sent().json()
                                ];
                            case 5:
                                s = _state.sent();
                                _this.onPayload({
                                    data: s
                                });
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                e = _state.sent();
                                _this.onError(t.id, e);
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "register",
            value: function register() {
                var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.url;
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _$e, _$e1, e, s;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(0, $52GQV.isHttpUrl)(t)) throw new Error("Provided URL is not compatible with HTTP connection: ".concat(t));
                                if (_this.registering) {
                                    _$e = _this.events.getMaxListeners();
                                    return [
                                        2,
                                        ((_this.events.listenerCount("register_error") >= _$e || _this.events.listenerCount("open") >= _$e) && _this.events.setMaxListeners(_$e + 1), new Promise(function(s, i) {
                                            _this.events.once("register_error", function(n) {
                                                _this.resetMaxListeners(), i(n);
                                            }), _this.events.once("open", function() {
                                                if (_this.resetMaxListeners(), (0, $l0HdX._)(_this.isAvailable) > "u") return i(new Error("HTTP connection is missing or invalid"));
                                                s();
                                            });
                                        }))
                                    ];
                                }
                                _this.url = t, _this.registering = !0;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                if (!!_this.disableProviderPing) return [
                                    3,
                                    3
                                ];
                                _$e1 = (0, $2fy4s.safeJsonStringify)({
                                    id: 1,
                                    jsonrpc: "2.0",
                                    method: "test",
                                    params: []
                                });
                                return [
                                    4,
                                    (0, (/*@__PURE__*/$parcel$interopDefault($hshPe)))(t, $596452a5ca5ce605$var$v($596452a5ca5ce605$var$p({}, $596452a5ca5ce605$var$d), {
                                        body: _$e1
                                    }))
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                _this.onOpen();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                e = _state.sent();
                                s = _this.parseError(e);
                                throw _this.events.emit("register_error", s), _this.onClose(), s;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onOpen",
            value: function onOpen() {
                this.isAvailable = !0, this.registering = !1, this.events.emit("open");
            }
        },
        {
            key: "onClose",
            value: function onClose() {
                this.isAvailable = !1, this.registering = !1, this.events.emit("close");
            }
        },
        {
            key: "onPayload",
            value: function onPayload(t) {
                if ((0, $l0HdX._)(t.data) > "u") return;
                var e = typeof t.data == "string" ? (0, $2fy4s.safeJsonParse)(t.data) : t.data;
                this.events.emit("payload", e);
            }
        },
        {
            key: "onError",
            value: function onError(t, e) {
                var s = this.parseError(e), i = s.message || s.toString(), n = (0, $3W2Mc.formatJsonRpcError)(t, i);
                this.events.emit("payload", n);
            }
        },
        {
            key: "parseError",
            value: function parseError(t) {
                var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.url;
                return (0, $dhRah.parseConnectionError)(t, e, "HTTP");
            }
        },
        {
            key: "resetMaxListeners",
            value: function resetMaxListeners() {
                this.events.getMaxListeners() > $596452a5ca5ce605$var$g && this.events.setMaxListeners($596452a5ca5ce605$var$g);
            }
        }
    ]);
    return f;
}();

});
parcelRegister("hshPe", function(module, exports) {
var global = typeof self !== "undefined" ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: "URLSearchParams" in self1,
            iterable: "Symbol" in self1 && "iterator" in Symbol,
            blob: "FileReader" in self1 && "Blob" in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in self1,
            arrayBuffer: "ArrayBuffer" in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function next() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = "statusText" in options ? options.statusText : "OK";
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException("Aborted", "AbortError"));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});



parcelRegister("6fkXj", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("amd2r")).then(function() {
    return parcelRequire("JaAjO");
});

});


parcelRegister("5yelF", function(module, exports) {

$parcel$export(module.exports, "HttpRequestError", function () { return $40ab4205d56413df$export$715ba3385e9f2cf0; });
$parcel$export(module.exports, "RpcRequestError", function () { return $40ab4205d56413df$export$a823590631c47261; });
$parcel$export(module.exports, "TimeoutError", function () { return $40ab4205d56413df$export$66d311bf29d5c89c; });

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $lUgMT = parcelRequire("lUgMT");

var $7ihh7 = parcelRequire("7ihh7");

var $QhBM2 = parcelRequire("QhBM2");
var $40ab4205d56413df$export$715ba3385e9f2cf0 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(HttpRequestError, BaseError);
    var _super = (0, $ohfOJ._)(HttpRequestError);
    function HttpRequestError(param) {
        var body = param.body, cause = param.cause, details = param.details, headers = param.headers, status = param.status, url = param.url;
        (0, $4GJKx._)(this, HttpRequestError);
        var _this;
        _this = _super.call(this, "HTTP request failed.", {
            cause: cause,
            details: details,
            metaMessages: [
                status && "Status: ".concat(status),
                "URL: ".concat((0, $QhBM2.getUrl)(url)),
                body && "Request body: ".concat((0, $lUgMT.stringify)(body))
            ].filter(Boolean),
            name: "HttpRequestError"
        });
        Object.defineProperty((0, $d3H5E._)(_this), "body", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty((0, $d3H5E._)(_this), "headers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty((0, $d3H5E._)(_this), "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty((0, $d3H5E._)(_this), "url", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this.body = body;
        _this.headers = headers;
        _this.status = status;
        _this.url = url;
        return _this;
    }
    return HttpRequestError;
}((0, $7ihh7.BaseError));
var $40ab4205d56413df$export$e1d72a3a26ed1bc = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(WebSocketRequestError, BaseError);
    var _super = (0, $ohfOJ._)(WebSocketRequestError);
    function WebSocketRequestError(param) {
        var body = param.body, cause = param.cause, details = param.details, url = param.url;
        (0, $4GJKx._)(this, WebSocketRequestError);
        return _super.call(this, "WebSocket request failed.", {
            cause: cause,
            details: details,
            metaMessages: [
                "URL: ".concat((0, $QhBM2.getUrl)(url)),
                body && "Request body: ".concat((0, $lUgMT.stringify)(body))
            ].filter(Boolean),
            name: "WebSocketRequestError"
        });
    }
    return WebSocketRequestError;
}((0, $7ihh7.BaseError));
var $40ab4205d56413df$export$a823590631c47261 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(RpcRequestError, BaseError);
    var _super = (0, $ohfOJ._)(RpcRequestError);
    function RpcRequestError(param) {
        var body = param.body, error = param.error, url = param.url;
        (0, $4GJKx._)(this, RpcRequestError);
        var _this;
        _this = _super.call(this, "RPC Request failed.", {
            cause: error,
            details: error.message,
            metaMessages: [
                "URL: ".concat((0, $QhBM2.getUrl)(url)),
                "Request body: ".concat((0, $lUgMT.stringify)(body))
            ],
            name: "RpcRequestError"
        });
        Object.defineProperty((0, $d3H5E._)(_this), "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this.code = error.code;
        return _this;
    }
    return RpcRequestError;
}((0, $7ihh7.BaseError));
var $40ab4205d56413df$export$a52f6cfb6f69ff4d = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(SocketClosedError, BaseError);
    var _super = (0, $ohfOJ._)(SocketClosedError);
    function SocketClosedError() {
        var url = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).url;
        (0, $4GJKx._)(this, SocketClosedError);
        return _super.call(this, "The socket has been closed.", {
            metaMessages: [
                url && "URL: ".concat((0, $QhBM2.getUrl)(url))
            ].filter(Boolean),
            name: "SocketClosedError"
        });
    }
    return SocketClosedError;
}((0, $7ihh7.BaseError));
var $40ab4205d56413df$export$66d311bf29d5c89c = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(TimeoutError, BaseError);
    var _super = (0, $ohfOJ._)(TimeoutError);
    function TimeoutError(param) {
        var body = param.body, url = param.url;
        (0, $4GJKx._)(this, TimeoutError);
        return _super.call(this, "The request took too long to respond.", {
            details: "The request timed out.",
            metaMessages: [
                "URL: ".concat((0, $QhBM2.getUrl)(url)),
                "Request body: ".concat((0, $lUgMT.stringify)(body))
            ],
            name: "TimeoutError"
        });
    }
    return TimeoutError;
}((0, $7ihh7.BaseError));

});
parcelRegister("lUgMT", function(module, exports) {

$parcel$export(module.exports, "stringify", function () { return $ff2bd9963477248f$export$fac44ee5b035f737; });

var $l0HdX = parcelRequire("l0HdX");
var $ff2bd9963477248f$export$fac44ee5b035f737 = function(value, replacer, space) {
    return JSON.stringify(value, function(key, value_) {
        var _$value = (typeof value_ === "undefined" ? "undefined" : (0, $l0HdX._)(value_)) === "bigint" ? value_.toString() : value_;
        return typeof replacer === "function" ? replacer(key, _$value) : _$value;
    }, space);
};

});

parcelRegister("QhBM2", function(module, exports) {

$parcel$export(module.exports, "getContractAddress", function () { return $09d2841369c113b1$export$b7fbffef12272e40; });
$parcel$export(module.exports, "getUrl", function () { return $09d2841369c113b1$export$94df0e59ebebf4a7; });
var $09d2841369c113b1$export$b7fbffef12272e40 = function(address) {
    return address;
};
var $09d2841369c113b1$export$94df0e59ebebf4a7 = function(url) {
    return url;
};

});


parcelRegister("hy7Ff", function(module, exports) {

$parcel$export(module.exports, "call", function () { return $cc6b8e9d63412258$export$848feb93d8f32b9b; });

var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");

var $cv9Rk = parcelRequire("cv9Rk");

var $eha6O = parcelRequire("eha6O");

var $43Ca3 = parcelRequire("43Ca3");

var $l2YyF = parcelRequire("l2YyF");

var $9ClpR = parcelRequire("9ClpR");

var $a7CXx = parcelRequire("a7CXx");

var $iakMX = parcelRequire("iakMX");

var $7ihh7 = parcelRequire("7ihh7");

var $7yD9U = parcelRequire("7yD9U");

var $fZz5Q = parcelRequire("fZz5Q");

var $itJ66 = parcelRequire("itJ66");

var $af8cf = parcelRequire("af8cf");

var $cdvyV = parcelRequire("cdvyV");

var $hpqb7 = parcelRequire("hpqb7");

var $f3VZN = parcelRequire("f3VZN");

var $c4967 = parcelRequire("c4967");

var $6N8Zo = parcelRequire("6N8Zo");

var $17do3 = parcelRequire("17do3");

var $esvdW = parcelRequire("esvdW");

var $7h9bY = parcelRequire("7h9bY");

var $p2XJW = parcelRequire("p2XJW");
function $cc6b8e9d63412258$export$848feb93d8f32b9b(client, args) {
    return $cc6b8e9d63412258$var$_call.apply(this, arguments);
}

function $cc6b8e9d63412258$var$_call() {
    $cc6b8e9d63412258$var$_call = (0, $kSuI9._)(function(client, args) {
        var _client_batch, tmp, account_, _args_batch, batch, blockNumber, _args_blockTag, blockTag, accessList, blobs, code, data_, factory, factoryData, gas, gasPrice, maxFeePerBlobGas, maxFeePerGas, maxPriorityFeePerGas, nonce, to, value, stateOverride, rest, account, deploylessCallViaBytecode, deploylessCallViaFactory, deploylessCall, data, _client_chain_formatters_transactionRequest, _client_chain_formatters, _client_chain, blockNumberHex, block, rpcStateOverride, chainFormat, format, request, err, response, err1, data1, _ref, offchainLookup, offchainLookupSignature, _tmp;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    tmp = args.account, account_ = tmp === void 0 ? client.account : tmp, _args_batch = args.batch, batch = _args_batch === void 0 ? Boolean((_client_batch = client.batch) === null || _client_batch === void 0 ? void 0 : _client_batch.multicall) : _args_batch, blockNumber = args.blockNumber, _args_blockTag = args.blockTag, blockTag = _args_blockTag === void 0 ? "latest" : _args_blockTag, accessList = args.accessList, blobs = args.blobs, code = args.code, data_ = args.data, factory = args.factory, factoryData = args.factoryData, gas = args.gas, gasPrice = args.gasPrice, maxFeePerBlobGas = args.maxFeePerBlobGas, maxFeePerGas = args.maxFeePerGas, maxPriorityFeePerGas = args.maxPriorityFeePerGas, nonce = args.nonce, to = args.to, value = args.value, stateOverride = args.stateOverride, rest = (0, $dRLPW._)(args, [
                        "account",
                        "batch",
                        "blockNumber",
                        "blockTag",
                        "accessList",
                        "blobs",
                        "code",
                        "data",
                        "factory",
                        "factoryData",
                        "gas",
                        "gasPrice",
                        "maxFeePerBlobGas",
                        "maxFeePerGas",
                        "maxPriorityFeePerGas",
                        "nonce",
                        "to",
                        "value",
                        "stateOverride"
                    ]);
                    account = account_ ? (0, $l2YyF.parseAccount)(account_) : undefined;
                    if (code && (factory || factoryData)) throw new (0, $7ihh7.BaseError)("Cannot provide both `code` & `factory`/`factoryData` as parameters.");
                    if (code && to) throw new (0, $7ihh7.BaseError)("Cannot provide both `code` & `to` as parameters.");
                    // Check if the call is deployless via bytecode.
                    deploylessCallViaBytecode = code && data_;
                    // Check if the call is deployless via a factory.
                    deploylessCallViaFactory = factory && factoryData && to && data_;
                    deploylessCall = deploylessCallViaBytecode || deploylessCallViaFactory;
                    data = function() {
                        if (deploylessCallViaBytecode) return $cc6b8e9d63412258$var$toDeploylessCallViaBytecodeData({
                            code: code,
                            data: data_
                        });
                        if (deploylessCallViaFactory) return $cc6b8e9d63412258$var$toDeploylessCallViaFactoryData({
                            data: data_,
                            factory: factory,
                            factoryData: factoryData,
                            to: to
                        });
                        return data_;
                    }();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        ,
                        11
                    ]);
                    (0, $p2XJW.assertRequest)(args);
                    blockNumberHex = blockNumber ? (0, $f3VZN.numberToHex)(blockNumber) : undefined;
                    block = blockNumberHex || blockTag;
                    rpcStateOverride = (0, $7h9bY.serializeStateOverride)(stateOverride);
                    chainFormat = (_client_chain = client.chain) === null || _client_chain === void 0 ? void 0 : (_client_chain_formatters = _client_chain.formatters) === null || _client_chain_formatters === void 0 ? void 0 : (_client_chain_formatters_transactionRequest = _client_chain_formatters.transactionRequest) === null || _client_chain_formatters_transactionRequest === void 0 ? void 0 : _client_chain_formatters_transactionRequest.format;
                    format = chainFormat || (0, $17do3.formatTransactionRequest);
                    request = format((0, $cxjpp._)((0, $do9pw._)({}, (0, $6N8Zo.extract)(rest, {
                        format: chainFormat
                    })), {
                        from: account === null || account === void 0 ? void 0 : account.address,
                        accessList: accessList,
                        blobs: blobs,
                        data: data,
                        gas: gas,
                        gasPrice: gasPrice,
                        maxFeePerBlobGas: maxFeePerBlobGas,
                        maxFeePerGas: maxFeePerGas,
                        maxPriorityFeePerGas: maxPriorityFeePerGas,
                        nonce: nonce,
                        to: deploylessCall ? undefined : to,
                        value: value
                    }));
                    if (!(batch && $cc6b8e9d63412258$var$shouldPerformMulticall({
                        request: request
                    }) && !rpcStateOverride)) return [
                        3,
                        5
                    ];
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        $cc6b8e9d63412258$var$scheduleMulticall(client, (0, $cxjpp._)((0, $do9pw._)({}, request), {
                            blockNumber: blockNumber,
                            blockTag: blockTag
                        }))
                    ];
                case 3:
                    return [
                        2,
                        _state.sent()
                    ];
                case 4:
                    err = _state.sent();
                    if (!(err instanceof (0, $7yD9U.ClientChainNotConfiguredError)) && !(err instanceof (0, $7yD9U.ChainDoesNotSupportContract))) throw err;
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        4,
                        client.request({
                            method: "eth_call",
                            params: rpcStateOverride ? [
                                request,
                                block,
                                rpcStateOverride
                            ] : [
                                request,
                                block
                            ]
                        })
                    ];
                case 6:
                    response = _state.sent();
                    if (response === "0x") return [
                        2,
                        {
                            data: undefined
                        }
                    ];
                    return [
                        2,
                        {
                            data: response
                        }
                    ];
                case 7:
                    err1 = _state.sent();
                    data1 = $cc6b8e9d63412258$export$6ef1a527f868ca75(err1);
                    return [
                        4,
                        (parcelRequire("apPuK"))
                    ];
                case 8:
                    _ref = _state.sent(), offchainLookup = _ref.offchainLookup, offchainLookupSignature = _ref.offchainLookupSignature;
                    if (!(client.ccipRead !== false && (data1 === null || data1 === void 0 ? void 0 : data1.slice(0, 10)) === offchainLookupSignature && to)) return [
                        3,
                        10
                    ];
                    _tmp = {};
                    return [
                        4,
                        offchainLookup(client, {
                            data: data1,
                            to: to
                        })
                    ];
                case 9:
                    return [
                        2,
                        (_tmp.data = _state.sent(), _tmp)
                    ];
                case 10:
                    // Check for counterfactual deployment error.
                    if (deploylessCall && (data1 === null || data1 === void 0 ? void 0 : data1.slice(0, 10)) === "0x101bb98d") throw new (0, $fZz5Q.CounterfactualDeploymentFailedError)({
                        factory: factory
                    });
                    throw (0, $c4967.getCallError)(err1, (0, $cxjpp._)((0, $do9pw._)({}, args), {
                        account: account,
                        chain: client.chain
                    }));
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
    return $cc6b8e9d63412258$var$_call.apply(this, arguments);
}
// We only want to perform a scheduled multicall if:
// - The request has calldata,
// - The request has a target address,
// - The target address is not already the aggregate3 signature,
// - The request has no other properties (`nonce`, `gas`, etc cannot be sent with a multicall).
function $cc6b8e9d63412258$var$shouldPerformMulticall(param) {
    var request = param.request;
    var data = request.data, to = request.to, request_ = (0, $dRLPW._)(request, [
        "data",
        "to"
    ]);
    if (!data) return false;
    if (data.startsWith((0, $a7CXx.aggregate3Signature))) return false;
    if (!to) return false;
    if (Object.values(request_).filter(function(x) {
        return typeof x !== "undefined";
    }).length > 0) return false;
    return true;
}
function $cc6b8e9d63412258$var$scheduleMulticall(client, args) {
    return $cc6b8e9d63412258$var$_scheduleMulticall.apply(this, arguments);
}
function $cc6b8e9d63412258$var$_scheduleMulticall() {
    $cc6b8e9d63412258$var$_scheduleMulticall = (0, $kSuI9._)(function(client, args) {
        var _client_batch, _ref, _ref_batchSize, batchSize, _ref_wait, wait, blockNumber, _args_blockTag, blockTag, data, multicallAddress_, to, multicallAddress, blockNumberHex, block, schedule, _ref1, _ref_, returnData, success;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ref = typeof ((_client_batch = client.batch) === null || _client_batch === void 0 ? void 0 : _client_batch.multicall) === "object" ? client.batch.multicall : {}, _ref_batchSize = _ref.batchSize, batchSize = _ref_batchSize === void 0 ? 1024 : _ref_batchSize, _ref_wait = _ref.wait, wait = _ref_wait === void 0 ? 0 : _ref_wait;
                    blockNumber = args.blockNumber, _args_blockTag = args.blockTag, blockTag = _args_blockTag === void 0 ? "latest" : _args_blockTag, data = args.data, multicallAddress_ = args.multicallAddress, to = args.to;
                    multicallAddress = multicallAddress_;
                    if (!multicallAddress) {
                        if (!client.chain) throw new (0, $7yD9U.ClientChainNotConfiguredError)();
                        multicallAddress = (0, $hpqb7.getChainContractAddress)({
                            blockNumber: blockNumber,
                            chain: client.chain,
                            contract: "multicall3"
                        });
                    }
                    blockNumberHex = blockNumber ? (0, $f3VZN.numberToHex)(blockNumber) : undefined;
                    block = blockNumberHex || blockTag;
                    schedule = (0, $esvdW.createBatchScheduler)({
                        id: "".concat(client.uid, ".").concat(block),
                        wait: wait,
                        shouldSplitBatch: function(args) {
                            var size = args.reduce(function(size, param) {
                                var data = param.data;
                                return size + (data.length - 2);
                            }, 0);
                            return size > batchSize * 2;
                        },
                        fn: function() {
                            var _ref = (0, $kSuI9._)(function(requests) {
                                var calls, calldata, data;
                                return (0, $eha6O.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            calls = requests.map(function(request) {
                                                return {
                                                    allowFailure: true,
                                                    callData: request.data,
                                                    target: request.to
                                                };
                                            });
                                            calldata = (0, $cdvyV.encodeFunctionData)({
                                                abi: (0, $9ClpR.multicall3Abi),
                                                args: [
                                                    calls
                                                ],
                                                functionName: "aggregate3"
                                            });
                                            return [
                                                4,
                                                client.request({
                                                    method: "eth_call",
                                                    params: [
                                                        {
                                                            data: calldata,
                                                            to: multicallAddress
                                                        },
                                                        block
                                                    ]
                                                })
                                            ];
                                        case 1:
                                            data = _state.sent();
                                            return [
                                                2,
                                                (0, $itJ66.decodeFunctionResult)({
                                                    abi: (0, $9ClpR.multicall3Abi),
                                                    args: [
                                                        calls
                                                    ],
                                                    functionName: "aggregate3",
                                                    data: data || "0x"
                                                })
                                            ];
                                    }
                                });
                            });
                            return function(requests) {
                                return _ref.apply(this, arguments);
                            };
                        }()
                    }).schedule;
                    return [
                        4,
                        schedule({
                            data: data,
                            to: to
                        })
                    ];
                case 1:
                    _ref1 = (0, $cv9Rk._).apply(void 0, [
                        _state.sent(),
                        1
                    ]), _ref_ = _ref1[0], returnData = _ref_.returnData, success = _ref_.success;
                    if (!success) throw new (0, $fZz5Q.RawContractError)({
                        data: returnData
                    });
                    if (returnData === "0x") return [
                        2,
                        {
                            data: undefined
                        }
                    ];
                    return [
                        2,
                        {
                            data: returnData
                        }
                    ];
            }
        });
    });
    return $cc6b8e9d63412258$var$_scheduleMulticall.apply(this, arguments);
}
function $cc6b8e9d63412258$var$toDeploylessCallViaBytecodeData(parameters) {
    var code = parameters.code, data = parameters.data;
    return (0, $af8cf.encodeDeployData)({
        abi: (0, $43Ca3.parseAbi)([
            "constructor(bytes, bytes)"
        ]),
        bytecode: (0, $iakMX.deploylessCallViaBytecodeBytecode),
        args: [
            code,
            data
        ]
    });
}
function $cc6b8e9d63412258$var$toDeploylessCallViaFactoryData(parameters) {
    var data = parameters.data, factory = parameters.factory, factoryData = parameters.factoryData, to = parameters.to;
    return (0, $af8cf.encodeDeployData)({
        abi: (0, $43Ca3.parseAbi)([
            "constructor(address, bytes, address, bytes)"
        ]),
        bytecode: (0, $iakMX.deploylessCallViaFactoryBytecode),
        args: [
            to,
            data,
            factory,
            factoryData
        ]
    });
}
function $cc6b8e9d63412258$export$6ef1a527f868ca75(err) {
    var _error_data;
    if (!(err instanceof (0, $7ihh7.BaseError))) return undefined;
    var error = err.walk();
    return typeof (error === null || error === void 0 ? void 0 : error.data) === "object" ? (_error_data = error.data) === null || _error_data === void 0 ? void 0 : _error_data.data : error.data;
}

});
parcelRegister("43Ca3", function(module, exports) {

$parcel$export(module.exports, "parseAbi", function () { return $2f450b401145782b$export$4ab3f466fb8f069; });

var $br4FB = parcelRequire("br4FB");

var $ibBuC = parcelRequire("ibBuC");

var $4pXBQ = parcelRequire("4pXBQ");
function $2f450b401145782b$export$4ab3f466fb8f069(signatures) {
    var structs = (0, $ibBuC.parseStructs)(signatures);
    var abi = [];
    var length = signatures.length;
    for(var i = 0; i < length; i++){
        var signature = signatures[i];
        if ((0, $br4FB.isStructSignature)(signature)) continue;
        abi.push((0, $4pXBQ.parseSignature)(signature, structs));
    }
    return abi;
}

});
parcelRegister("br4FB", function(module, exports) {

$parcel$export(module.exports, "isErrorSignature", function () { return $8535d6b73cf28f32$export$33be303020ecaff5; });
$parcel$export(module.exports, "execErrorSignature", function () { return $8535d6b73cf28f32$export$a8b67e842e5c116d; });
$parcel$export(module.exports, "isEventSignature", function () { return $8535d6b73cf28f32$export$7912f33b3b4526ca; });
$parcel$export(module.exports, "execEventSignature", function () { return $8535d6b73cf28f32$export$87d5ec49338ff6f; });
$parcel$export(module.exports, "isFunctionSignature", function () { return $8535d6b73cf28f32$export$fa8ae1a8bca33200; });
$parcel$export(module.exports, "execFunctionSignature", function () { return $8535d6b73cf28f32$export$8a14253893829398; });
$parcel$export(module.exports, "isStructSignature", function () { return $8535d6b73cf28f32$export$130f77ea18c25fb8; });
$parcel$export(module.exports, "execStructSignature", function () { return $8535d6b73cf28f32$export$432f3b6c467d7b70; });
$parcel$export(module.exports, "isConstructorSignature", function () { return $8535d6b73cf28f32$export$7ec9623fe58e8638; });
$parcel$export(module.exports, "execConstructorSignature", function () { return $8535d6b73cf28f32$export$4713f9c79c855460; });
$parcel$export(module.exports, "isFallbackSignature", function () { return $8535d6b73cf28f32$export$f99ebae7027f9f2f; });
$parcel$export(module.exports, "isReceiveSignature", function () { return $8535d6b73cf28f32$export$555d9bfe0f07ab3d; });
$parcel$export(module.exports, "eventModifiers", function () { return $8535d6b73cf28f32$export$e4045f69b6b17e16; });
$parcel$export(module.exports, "functionModifiers", function () { return $8535d6b73cf28f32$export$d304f1652f422b6b; });

var $M4QSd = parcelRequire("M4QSd");
// https://regexr.com/7gmok
var $8535d6b73cf28f32$var$errorSignatureRegex = RegExp("^error (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\\((?<parameters>.*?)\\)$");
function $8535d6b73cf28f32$export$33be303020ecaff5(signature) {
    return $8535d6b73cf28f32$var$errorSignatureRegex.test(signature);
}
function $8535d6b73cf28f32$export$a8b67e842e5c116d(signature) {
    return (0, $M4QSd.execTyped)($8535d6b73cf28f32$var$errorSignatureRegex, signature);
}
// https://regexr.com/7gmoq
var $8535d6b73cf28f32$var$eventSignatureRegex = RegExp("^event (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\\((?<parameters>.*?)\\)$");
function $8535d6b73cf28f32$export$7912f33b3b4526ca(signature) {
    return $8535d6b73cf28f32$var$eventSignatureRegex.test(signature);
}
function $8535d6b73cf28f32$export$87d5ec49338ff6f(signature) {
    return (0, $M4QSd.execTyped)($8535d6b73cf28f32$var$eventSignatureRegex, signature);
}
// https://regexr.com/7gmot
var $8535d6b73cf28f32$var$functionSignatureRegex = RegExp("^function (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\\((?<parameters>.*?)\\)(?: (?<scope>external|public{1}))?(?: (?<stateMutability>pure|view|nonpayable|payable{1}))?(?: returns\\s?\\((?<returns>.*?)\\))?$");
function $8535d6b73cf28f32$export$fa8ae1a8bca33200(signature) {
    return $8535d6b73cf28f32$var$functionSignatureRegex.test(signature);
}
function $8535d6b73cf28f32$export$8a14253893829398(signature) {
    return (0, $M4QSd.execTyped)($8535d6b73cf28f32$var$functionSignatureRegex, signature);
}
// https://regexr.com/7gmp3
var $8535d6b73cf28f32$var$structSignatureRegex = RegExp("^struct (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*) \\{(?<properties>.*?)\\}$");
function $8535d6b73cf28f32$export$130f77ea18c25fb8(signature) {
    return $8535d6b73cf28f32$var$structSignatureRegex.test(signature);
}
function $8535d6b73cf28f32$export$432f3b6c467d7b70(signature) {
    return (0, $M4QSd.execTyped)($8535d6b73cf28f32$var$structSignatureRegex, signature);
}
// https://regexr.com/78u01
var $8535d6b73cf28f32$var$constructorSignatureRegex = RegExp("^constructor\\((?<parameters>.*?)\\)(?:\\s(?<stateMutability>payable{1}))?$");
function $8535d6b73cf28f32$export$7ec9623fe58e8638(signature) {
    return $8535d6b73cf28f32$var$constructorSignatureRegex.test(signature);
}
function $8535d6b73cf28f32$export$4713f9c79c855460(signature) {
    return (0, $M4QSd.execTyped)($8535d6b73cf28f32$var$constructorSignatureRegex, signature);
}
// https://regexr.com/7srtn
var $8535d6b73cf28f32$var$fallbackSignatureRegex = RegExp("^fallback\\(\\) external(?:\\s(?<stateMutability>payable{1}))?$");
function $8535d6b73cf28f32$export$f99ebae7027f9f2f(signature) {
    return $8535d6b73cf28f32$var$fallbackSignatureRegex.test(signature);
}
// https://regexr.com/78u1k
var $8535d6b73cf28f32$var$receiveSignatureRegex = /^receive\(\) external payable$/;
function $8535d6b73cf28f32$export$555d9bfe0f07ab3d(signature) {
    return $8535d6b73cf28f32$var$receiveSignatureRegex.test(signature);
}
var $8535d6b73cf28f32$export$c2f15f629432a51d = new Set([
    "memory",
    "indexed",
    "storage",
    "calldata"
]);
var $8535d6b73cf28f32$export$e4045f69b6b17e16 = new Set([
    "indexed"
]);
var $8535d6b73cf28f32$export$d304f1652f422b6b = new Set([
    "calldata",
    "memory",
    "storage"
]);

});
parcelRegister("M4QSd", function(module, exports) {

$parcel$export(module.exports, "execTyped", function () { return $09083f469192ad2b$export$1cca4755fb17f5bd; });
$parcel$export(module.exports, "bytesRegex", function () { return $09083f469192ad2b$export$94d7303c0d9f263a; });
$parcel$export(module.exports, "integerRegex", function () { return $09083f469192ad2b$export$45902cc189596eef; });
$parcel$export(module.exports, "isTupleRegex", function () { return $09083f469192ad2b$export$5c1628af1434aed0; });
// TODO: This looks cool. Need to check the performance of `new RegExp` versus defined inline though.
// https://twitter.com/GabrielVergnaud/status/1622906834343366657
function $09083f469192ad2b$export$1cca4755fb17f5bd(regex, string) {
    var match = regex.exec(string);
    return match === null || match === void 0 ? void 0 : match.groups;
}
var $09083f469192ad2b$export$94d7303c0d9f263a = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/;
var $09083f469192ad2b$export$45902cc189596eef = /^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;
var $09083f469192ad2b$export$5c1628af1434aed0 = /^\(.+?\).*?$/;

});


parcelRegister("ibBuC", function(module, exports) {

$parcel$export(module.exports, "parseStructs", function () { return $d3d65663cc390dd9$export$6e5e6f927c48b857; });

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $M4QSd = parcelRequire("M4QSd");

var $6vOSr = parcelRequire("6vOSr");

var $7GhJq = parcelRequire("7GhJq");

var $jWHW6 = parcelRequire("jWHW6");

var $gqRZ9 = parcelRequire("gqRZ9");

var $br4FB = parcelRequire("br4FB");

var $4pXBQ = parcelRequire("4pXBQ");
function $d3d65663cc390dd9$export$6e5e6f927c48b857(signatures) {
    // Create "shallow" version of each struct (and filter out non-structs or invalid structs)
    var shallowStructs = {};
    var signaturesLength = signatures.length;
    for(var i = 0; i < signaturesLength; i++){
        var signature = signatures[i];
        if (!(0, $br4FB.isStructSignature)(signature)) continue;
        var match = (0, $br4FB.execStructSignature)(signature);
        if (!match) throw new (0, $jWHW6.InvalidSignatureError)({
            signature: signature,
            type: "struct"
        });
        var properties = match.properties.split(";");
        var components = [];
        var propertiesLength = properties.length;
        for(var k = 0; k < propertiesLength; k++){
            var property = properties[k];
            var trimmed = property.trim();
            if (!trimmed) continue;
            var abiParameter = (0, $4pXBQ.parseAbiParameter)(trimmed, {
                type: "struct"
            });
            components.push(abiParameter);
        }
        if (!components.length) throw new (0, $jWHW6.InvalidStructSignatureError)({
            signature: signature
        });
        shallowStructs[match.name] = components;
    }
    // Resolve nested structs inside each parameter
    var resolvedStructs = {};
    var entries = Object.entries(shallowStructs);
    var entriesLength = entries.length;
    for(var i1 = 0; i1 < entriesLength; i1++){
        var _entries_i = (0, $cv9Rk._)(entries[i1], 2), name = _entries_i[0], parameters = _entries_i[1];
        resolvedStructs[name] = $d3d65663cc390dd9$var$resolveStructs(parameters, shallowStructs);
    }
    return resolvedStructs;
}
var $d3d65663cc390dd9$var$typeWithoutTupleRegex = RegExp("^(?<type>[a-zA-Z$_][a-zA-Z0-9$_]*)(?<array>(?:\\[\\d*?\\])+?)?$");
function $d3d65663cc390dd9$var$resolveStructs(abiParameters, structs) {
    var ancestors = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new Set();
    var components = [];
    var length = abiParameters.length;
    for(var i = 0; i < length; i++){
        var abiParameter = abiParameters[i];
        var isTuple = (0, $M4QSd.isTupleRegex).test(abiParameter.type);
        if (isTuple) components.push(abiParameter);
        else {
            var match = (0, $M4QSd.execTyped)($d3d65663cc390dd9$var$typeWithoutTupleRegex, abiParameter.type);
            if (!(match === null || match === void 0 ? void 0 : match.type)) throw new (0, $7GhJq.InvalidAbiTypeParameterError)({
                abiParameter: abiParameter
            });
            var array = match.array, type = match.type;
            if (type in structs) {
                if (ancestors.has(type)) throw new (0, $gqRZ9.CircularReferenceError)({
                    type: type
                });
                var _structs_type;
                components.push((0, $cxjpp._)((0, $do9pw._)({}, abiParameter), {
                    type: "tuple".concat(array !== null && array !== void 0 ? array : ""),
                    components: $d3d65663cc390dd9$var$resolveStructs((_structs_type = structs[type]) !== null && _structs_type !== void 0 ? _structs_type : [], structs, new Set((0, $c6Xmf._)(ancestors).concat([
                        type
                    ])))
                }));
            } else {
                if ((0, $4pXBQ.isSolidityType)(type)) components.push(abiParameter);
                else throw new (0, $6vOSr.UnknownTypeError)({
                    type: type
                });
            }
        }
    }
    return components;
}

});
parcelRegister("6vOSr", function(module, exports) {

$parcel$export(module.exports, "UnknownTypeError", function () { return $4bdd1a7384e87a76$export$9e77a92da3bcd5ca; });
$parcel$export(module.exports, "UnknownSolidityTypeError", function () { return $4bdd1a7384e87a76$export$5a36348a2ac471a3; });

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $lcTc8 = parcelRequire("lcTc8");
var $4bdd1a7384e87a76$export$a4e0854b60f599b6 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(InvalidAbiItemError, BaseError);
    var _super = (0, $ohfOJ._)(InvalidAbiItemError);
    function InvalidAbiItemError(param) {
        var signature = param.signature;
        (0, $4GJKx._)(this, InvalidAbiItemError);
        var _this;
        _this = _super.call(this, "Failed to parse ABI item.", {
            details: "parseAbiItem(".concat(JSON.stringify(signature, null, 2), ")"),
            docsPath: "/api/human#parseabiitem-1"
        });
        Object.defineProperty((0, $d3H5E._)(_this), "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiItemError"
        });
        return _this;
    }
    return InvalidAbiItemError;
}((0, $lcTc8.BaseError));
var $4bdd1a7384e87a76$export$9e77a92da3bcd5ca = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(UnknownTypeError, BaseError);
    var _super = (0, $ohfOJ._)(UnknownTypeError);
    function UnknownTypeError(param) {
        var type = param.type;
        (0, $4GJKx._)(this, UnknownTypeError);
        var _this;
        _this = _super.call(this, "Unknown type.", {
            metaMessages: [
                'Type "'.concat(type, '" is not a valid ABI type. Perhaps you forgot to include a struct signature?')
            ]
        });
        Object.defineProperty((0, $d3H5E._)(_this), "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnknownTypeError"
        });
        return _this;
    }
    return UnknownTypeError;
}((0, $lcTc8.BaseError));
var $4bdd1a7384e87a76$export$5a36348a2ac471a3 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(UnknownSolidityTypeError, BaseError);
    var _super = (0, $ohfOJ._)(UnknownSolidityTypeError);
    function UnknownSolidityTypeError(param) {
        var type = param.type;
        (0, $4GJKx._)(this, UnknownSolidityTypeError);
        var _this;
        _this = _super.call(this, "Unknown type.", {
            metaMessages: [
                'Type "'.concat(type, '" is not a valid ABI type.')
            ]
        });
        Object.defineProperty((0, $d3H5E._)(_this), "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnknownSolidityTypeError"
        });
        return _this;
    }
    return UnknownSolidityTypeError;
}((0, $lcTc8.BaseError));

});
parcelRegister("lcTc8", function(module, exports) {

$parcel$export(module.exports, "BaseError", function () { return $f7058876fc63d272$export$a490eb03cb7a0a5e; });

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $c6Xmf = parcelRequire("c6Xmf");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");

var $9F6p0 = parcelRequire("9F6p0");
var $f7058876fc63d272$export$a490eb03cb7a0a5e = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $dcsZi._)(BaseError, Error1);
    var _super = (0, $ohfOJ._)(BaseError);
    function BaseError(shortMessage) {
        var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $4GJKx._)(this, BaseError);
        var _this;
        var _args_cause;
        var details = args.cause instanceof BaseError ? args.cause.details : ((_args_cause = args.cause) === null || _args_cause === void 0 ? void 0 : _args_cause.message) ? args.cause.message : args.details;
        var docsPath = args.cause instanceof BaseError ? args.cause.docsPath || args.docsPath : args.docsPath;
        var message = [
            shortMessage || "An error occurred.",
            ""
        ].concat((0, $c6Xmf._)(args.metaMessages ? (0, $c6Xmf._)(args.metaMessages).concat([
            ""
        ]) : []), (0, $c6Xmf._)(docsPath ? [
            "Docs: https://abitype.dev".concat(docsPath)
        ] : []), (0, $c6Xmf._)(details ? [
            "Details: ".concat(details)
        ] : []), [
            "Version: abitype@".concat((0, $9F6p0.version))
        ]).join("\n");
        _this = _super.call(this, message);
        Object.defineProperty((0, $d3H5E._)(_this), "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty((0, $d3H5E._)(_this), "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty((0, $d3H5E._)(_this), "metaMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty((0, $d3H5E._)(_this), "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty((0, $d3H5E._)(_this), "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiTypeError"
        });
        if (args.cause) _this.cause = args.cause;
        _this.details = details;
        _this.docsPath = docsPath;
        _this.metaMessages = args.metaMessages;
        _this.shortMessage = shortMessage;
        return _this;
    }
    return BaseError;
}((0, $FuVm8._)(Error));

});
parcelRegister("9F6p0", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $708ce8bd12da7576$export$83d89fbfd8236492; });
var $708ce8bd12da7576$export$83d89fbfd8236492 = "1.0.5";

});



parcelRegister("7GhJq", function(module, exports) {

$parcel$export(module.exports, "InvalidParameterError", function () { return $597a35cc4b9eef1a$export$e569b97a5d46005c; });
$parcel$export(module.exports, "SolidityProtectedKeywordError", function () { return $597a35cc4b9eef1a$export$58697cc8f790f211; });
$parcel$export(module.exports, "InvalidModifierError", function () { return $597a35cc4b9eef1a$export$f837e6b0dee0e468; });
$parcel$export(module.exports, "InvalidFunctionModifierError", function () { return $597a35cc4b9eef1a$export$7afd0f25b8fdbbd8; });
$parcel$export(module.exports, "InvalidAbiTypeParameterError", function () { return $597a35cc4b9eef1a$export$b5451545b6c52dc8; });

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $lcTc8 = parcelRequire("lcTc8");
var $597a35cc4b9eef1a$export$bdcd4054531f5b35 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(InvalidAbiParameterError, BaseError);
    var _super = (0, $ohfOJ._)(InvalidAbiParameterError);
    function InvalidAbiParameterError(param) {
        var _$param = param.param;
        (0, $4GJKx._)(this, InvalidAbiParameterError);
        var _this;
        _this = _super.call(this, "Failed to parse ABI parameter.", {
            details: "parseAbiParameter(".concat(JSON.stringify(_$param, null, 2), ")"),
            docsPath: "/api/human#parseabiparameter-1"
        });
        Object.defineProperty((0, $d3H5E._)(_this), "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiParameterError"
        });
        return _this;
    }
    return InvalidAbiParameterError;
}((0, $lcTc8.BaseError));
var $597a35cc4b9eef1a$export$f35df31806e96ff = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(InvalidAbiParametersError, BaseError);
    var _super = (0, $ohfOJ._)(InvalidAbiParametersError);
    function InvalidAbiParametersError(param) {
        var params = param.params;
        (0, $4GJKx._)(this, InvalidAbiParametersError);
        var _this;
        _this = _super.call(this, "Failed to parse ABI parameters.", {
            details: "parseAbiParameters(".concat(JSON.stringify(params, null, 2), ")"),
            docsPath: "/api/human#parseabiparameters-1"
        });
        Object.defineProperty((0, $d3H5E._)(_this), "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiParametersError"
        });
        return _this;
    }
    return InvalidAbiParametersError;
}((0, $lcTc8.BaseError));
var $597a35cc4b9eef1a$export$e569b97a5d46005c = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(InvalidParameterError, BaseError);
    var _super = (0, $ohfOJ._)(InvalidParameterError);
    function InvalidParameterError(param) {
        var _$param = param.param;
        (0, $4GJKx._)(this, InvalidParameterError);
        var _this;
        _this = _super.call(this, "Invalid ABI parameter.", {
            details: _$param
        });
        Object.defineProperty((0, $d3H5E._)(_this), "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidParameterError"
        });
        return _this;
    }
    return InvalidParameterError;
}((0, $lcTc8.BaseError));
var $597a35cc4b9eef1a$export$58697cc8f790f211 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(SolidityProtectedKeywordError, BaseError);
    var _super = (0, $ohfOJ._)(SolidityProtectedKeywordError);
    function SolidityProtectedKeywordError(param) {
        var _$param = param.param, name = param.name;
        (0, $4GJKx._)(this, SolidityProtectedKeywordError);
        var _this;
        _this = _super.call(this, "Invalid ABI parameter.", {
            details: _$param,
            metaMessages: [
                '"'.concat(name, '" is a protected Solidity keyword. More info: https://docs.soliditylang.org/en/latest/cheatsheet.html')
            ]
        });
        Object.defineProperty((0, $d3H5E._)(_this), "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "SolidityProtectedKeywordError"
        });
        return _this;
    }
    return SolidityProtectedKeywordError;
}((0, $lcTc8.BaseError));
var $597a35cc4b9eef1a$export$f837e6b0dee0e468 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(InvalidModifierError, BaseError);
    var _super = (0, $ohfOJ._)(InvalidModifierError);
    function InvalidModifierError(param) {
        var _$param = param.param, type = param.type, modifier = param.modifier;
        (0, $4GJKx._)(this, InvalidModifierError);
        var _this;
        _this = _super.call(this, "Invalid ABI parameter.", {
            details: _$param,
            metaMessages: [
                'Modifier "'.concat(modifier, '" not allowed').concat(type ? ' in "'.concat(type, '" type') : "", ".")
            ]
        });
        Object.defineProperty((0, $d3H5E._)(_this), "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidModifierError"
        });
        return _this;
    }
    return InvalidModifierError;
}((0, $lcTc8.BaseError));
var $597a35cc4b9eef1a$export$7afd0f25b8fdbbd8 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(InvalidFunctionModifierError, BaseError);
    var _super = (0, $ohfOJ._)(InvalidFunctionModifierError);
    function InvalidFunctionModifierError(param) {
        var _$param = param.param, type = param.type, modifier = param.modifier;
        (0, $4GJKx._)(this, InvalidFunctionModifierError);
        var _this;
        _this = _super.call(this, "Invalid ABI parameter.", {
            details: _$param,
            metaMessages: [
                'Modifier "'.concat(modifier, '" not allowed').concat(type ? ' in "'.concat(type, '" type') : "", "."),
                'Data location can only be specified for array, struct, or mapping types, but "'.concat(modifier, '" was given.')
            ]
        });
        Object.defineProperty((0, $d3H5E._)(_this), "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidFunctionModifierError"
        });
        return _this;
    }
    return InvalidFunctionModifierError;
}((0, $lcTc8.BaseError));
var $597a35cc4b9eef1a$export$b5451545b6c52dc8 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(InvalidAbiTypeParameterError, BaseError);
    var _super = (0, $ohfOJ._)(InvalidAbiTypeParameterError);
    function InvalidAbiTypeParameterError(param) {
        var abiParameter = param.abiParameter;
        (0, $4GJKx._)(this, InvalidAbiTypeParameterError);
        var _this;
        _this = _super.call(this, "Invalid ABI parameter.", {
            details: JSON.stringify(abiParameter, null, 2),
            metaMessages: [
                "ABI parameter type is invalid."
            ]
        });
        Object.defineProperty((0, $d3H5E._)(_this), "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiTypeParameterError"
        });
        return _this;
    }
    return InvalidAbiTypeParameterError;
}((0, $lcTc8.BaseError));

});

parcelRegister("jWHW6", function(module, exports) {

$parcel$export(module.exports, "InvalidSignatureError", function () { return $e85583ec8f5cb232$export$ccc2f68ef106615a; });
$parcel$export(module.exports, "UnknownSignatureError", function () { return $e85583ec8f5cb232$export$3727c00c40963d37; });
$parcel$export(module.exports, "InvalidStructSignatureError", function () { return $e85583ec8f5cb232$export$769955518e5ea753; });

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $lcTc8 = parcelRequire("lcTc8");
var $e85583ec8f5cb232$export$ccc2f68ef106615a = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(InvalidSignatureError, BaseError);
    var _super = (0, $ohfOJ._)(InvalidSignatureError);
    function InvalidSignatureError(param) {
        var signature = param.signature, type = param.type;
        (0, $4GJKx._)(this, InvalidSignatureError);
        var _this;
        _this = _super.call(this, "Invalid ".concat(type, " signature."), {
            details: signature
        });
        Object.defineProperty((0, $d3H5E._)(_this), "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidSignatureError"
        });
        return _this;
    }
    return InvalidSignatureError;
}((0, $lcTc8.BaseError));
var $e85583ec8f5cb232$export$3727c00c40963d37 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(UnknownSignatureError, BaseError);
    var _super = (0, $ohfOJ._)(UnknownSignatureError);
    function UnknownSignatureError(param) {
        var signature = param.signature;
        (0, $4GJKx._)(this, UnknownSignatureError);
        var _this;
        _this = _super.call(this, "Unknown signature.", {
            details: signature
        });
        Object.defineProperty((0, $d3H5E._)(_this), "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnknownSignatureError"
        });
        return _this;
    }
    return UnknownSignatureError;
}((0, $lcTc8.BaseError));
var $e85583ec8f5cb232$export$769955518e5ea753 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(InvalidStructSignatureError, BaseError);
    var _super = (0, $ohfOJ._)(InvalidStructSignatureError);
    function InvalidStructSignatureError(param) {
        var signature = param.signature;
        (0, $4GJKx._)(this, InvalidStructSignatureError);
        var _this;
        _this = _super.call(this, "Invalid struct signature.", {
            details: signature,
            metaMessages: [
                "No properties exist."
            ]
        });
        Object.defineProperty((0, $d3H5E._)(_this), "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidStructSignatureError"
        });
        return _this;
    }
    return InvalidStructSignatureError;
}((0, $lcTc8.BaseError));

});

parcelRegister("gqRZ9", function(module, exports) {

$parcel$export(module.exports, "CircularReferenceError", function () { return $bf68f3663b93cbe7$export$3b7cb2315fb6b103; });

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $lcTc8 = parcelRequire("lcTc8");
var $bf68f3663b93cbe7$export$3b7cb2315fb6b103 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(CircularReferenceError, BaseError);
    var _super = (0, $ohfOJ._)(CircularReferenceError);
    function CircularReferenceError(param) {
        var type = param.type;
        (0, $4GJKx._)(this, CircularReferenceError);
        var _this;
        _this = _super.call(this, "Circular reference detected.", {
            metaMessages: [
                'Struct "'.concat(type, '" is a circular reference.')
            ]
        });
        Object.defineProperty((0, $d3H5E._)(_this), "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "CircularReferenceError"
        });
        return _this;
    }
    return CircularReferenceError;
}((0, $lcTc8.BaseError));

});

parcelRegister("4pXBQ", function(module, exports) {

$parcel$export(module.exports, "parseSignature", function () { return $3377bc64d30bd040$export$dc1dc22ccf24efef; });
$parcel$export(module.exports, "parseAbiParameter", function () { return $3377bc64d30bd040$export$357229f9e2d85552; });
$parcel$export(module.exports, "isSolidityType", function () { return $3377bc64d30bd040$export$640ecc6f40db6417; });

var $do9pw = parcelRequire("do9pw");

var $c6Xmf = parcelRequire("c6Xmf");

var $M4QSd = parcelRequire("M4QSd");

var $6vOSr = parcelRequire("6vOSr");

var $7GhJq = parcelRequire("7GhJq");

var $jWHW6 = parcelRequire("jWHW6");

var $5KSMn = parcelRequire("5KSMn");

var $fexBx = parcelRequire("fexBx");

var $br4FB = parcelRequire("br4FB");
function $3377bc64d30bd040$export$dc1dc22ccf24efef(signature) {
    var structs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if ((0, $br4FB.isFunctionSignature)(signature)) {
        var match = (0, $br4FB.execFunctionSignature)(signature);
        if (!match) throw new (0, $jWHW6.InvalidSignatureError)({
            signature: signature,
            type: "function"
        });
        var inputParams = $3377bc64d30bd040$export$8350908b11ff5aef(match.parameters);
        var inputs = [];
        var inputLength = inputParams.length;
        for(var i = 0; i < inputLength; i++)inputs.push($3377bc64d30bd040$export$357229f9e2d85552(inputParams[i], {
            modifiers: (0, $br4FB.functionModifiers),
            structs: structs,
            type: "function"
        }));
        var outputs = [];
        if (match.returns) {
            var outputParams = $3377bc64d30bd040$export$8350908b11ff5aef(match.returns);
            var outputLength = outputParams.length;
            for(var i1 = 0; i1 < outputLength; i1++)outputs.push($3377bc64d30bd040$export$357229f9e2d85552(outputParams[i1], {
                modifiers: (0, $br4FB.functionModifiers),
                structs: structs,
                type: "function"
            }));
        }
        var _match_stateMutability;
        return {
            name: match.name,
            type: "function",
            stateMutability: (_match_stateMutability = match.stateMutability) !== null && _match_stateMutability !== void 0 ? _match_stateMutability : "nonpayable",
            inputs: inputs,
            outputs: outputs
        };
    }
    if ((0, $br4FB.isEventSignature)(signature)) {
        var match1 = (0, $br4FB.execEventSignature)(signature);
        if (!match1) throw new (0, $jWHW6.InvalidSignatureError)({
            signature: signature,
            type: "event"
        });
        var params = $3377bc64d30bd040$export$8350908b11ff5aef(match1.parameters);
        var abiParameters = [];
        var length = params.length;
        for(var i2 = 0; i2 < length; i2++)abiParameters.push($3377bc64d30bd040$export$357229f9e2d85552(params[i2], {
            modifiers: (0, $br4FB.eventModifiers),
            structs: structs,
            type: "event"
        }));
        return {
            name: match1.name,
            type: "event",
            inputs: abiParameters
        };
    }
    if ((0, $br4FB.isErrorSignature)(signature)) {
        var match2 = (0, $br4FB.execErrorSignature)(signature);
        if (!match2) throw new (0, $jWHW6.InvalidSignatureError)({
            signature: signature,
            type: "error"
        });
        var params1 = $3377bc64d30bd040$export$8350908b11ff5aef(match2.parameters);
        var abiParameters1 = [];
        var length1 = params1.length;
        for(var i3 = 0; i3 < length1; i3++)abiParameters1.push($3377bc64d30bd040$export$357229f9e2d85552(params1[i3], {
            structs: structs,
            type: "error"
        }));
        return {
            name: match2.name,
            type: "error",
            inputs: abiParameters1
        };
    }
    if ((0, $br4FB.isConstructorSignature)(signature)) {
        var match3 = (0, $br4FB.execConstructorSignature)(signature);
        if (!match3) throw new (0, $jWHW6.InvalidSignatureError)({
            signature: signature,
            type: "constructor"
        });
        var params2 = $3377bc64d30bd040$export$8350908b11ff5aef(match3.parameters);
        var abiParameters2 = [];
        var length2 = params2.length;
        for(var i4 = 0; i4 < length2; i4++)abiParameters2.push($3377bc64d30bd040$export$357229f9e2d85552(params2[i4], {
            structs: structs,
            type: "constructor"
        }));
        var _match_stateMutability1;
        return {
            type: "constructor",
            stateMutability: (_match_stateMutability1 = match3.stateMutability) !== null && _match_stateMutability1 !== void 0 ? _match_stateMutability1 : "nonpayable",
            inputs: abiParameters2
        };
    }
    if ((0, $br4FB.isFallbackSignature)(signature)) return {
        type: "fallback"
    };
    if ((0, $br4FB.isReceiveSignature)(signature)) return {
        type: "receive",
        stateMutability: "payable"
    };
    throw new (0, $jWHW6.UnknownSignatureError)({
        signature: signature
    });
}
var $3377bc64d30bd040$var$abiParameterWithoutTupleRegex = RegExp("^(?<type>[a-zA-Z$_][a-zA-Z0-9$_]*)(?<array>(?:\\[\\d*?\\])+?)?(?:\\s(?<modifier>calldata|indexed|memory|storage{1}))?(?:\\s(?<name>[a-zA-Z$_][a-zA-Z0-9$_]*))?$");
var $3377bc64d30bd040$var$abiParameterWithTupleRegex = RegExp("^\\((?<type>.+?)\\)(?<array>(?:\\[\\d*?\\])+?)?(?:\\s(?<modifier>calldata|indexed|memory|storage{1}))?(?:\\s(?<name>[a-zA-Z$_][a-zA-Z0-9$_]*))?$");
var $3377bc64d30bd040$var$dynamicIntegerRegex = /^u?int$/;
function $3377bc64d30bd040$export$357229f9e2d85552(param, options) {
    // optional namespace cache by `type`
    var parameterCacheKey = (0, $fexBx.getParameterCacheKey)(param, options === null || options === void 0 ? void 0 : options.type);
    if ((0, $fexBx.parameterCache).has(parameterCacheKey)) return (0, $fexBx.parameterCache).get(parameterCacheKey);
    var isTuple = (0, $M4QSd.isTupleRegex).test(param);
    var match = (0, $M4QSd.execTyped)(isTuple ? $3377bc64d30bd040$var$abiParameterWithTupleRegex : $3377bc64d30bd040$var$abiParameterWithoutTupleRegex, param);
    if (!match) throw new (0, $7GhJq.InvalidParameterError)({
        param: param
    });
    if (match.name && $3377bc64d30bd040$export$d83e1b8970d84409(match.name)) throw new (0, $7GhJq.SolidityProtectedKeywordError)({
        param: param,
        name: match.name
    });
    var name = match.name ? {
        name: match.name
    } : {};
    var indexed = match.modifier === "indexed" ? {
        indexed: true
    } : {};
    var _options_structs;
    var structs = (_options_structs = options === null || options === void 0 ? void 0 : options.structs) !== null && _options_structs !== void 0 ? _options_structs : {};
    var type;
    var components = {};
    if (isTuple) {
        type = "tuple";
        var params = $3377bc64d30bd040$export$8350908b11ff5aef(match.type);
        var components_ = [];
        var length = params.length;
        for(var i = 0; i < length; i++)// remove `modifiers` from `options` to prevent from being added to tuple components
        components_.push($3377bc64d30bd040$export$357229f9e2d85552(params[i], {
            structs: structs
        }));
        components = {
            components: components_
        };
    } else if (match.type in structs) {
        type = "tuple";
        components = {
            components: structs[match.type]
        };
    } else if ($3377bc64d30bd040$var$dynamicIntegerRegex.test(match.type)) type = "".concat(match.type, "256");
    else {
        type = match.type;
        if (!((options === null || options === void 0 ? void 0 : options.type) === "struct") && !$3377bc64d30bd040$export$640ecc6f40db6417(type)) throw new (0, $6vOSr.UnknownSolidityTypeError)({
            type: type
        });
    }
    if (match.modifier) {
        var _options_modifiers_has, _options_modifiers;
        // Check if modifier exists, but is not allowed (e.g. `indexed` in `functionModifiers`)
        if (!(options === null || options === void 0 ? void 0 : (_options_modifiers = options.modifiers) === null || _options_modifiers === void 0 ? void 0 : (_options_modifiers_has = _options_modifiers.has) === null || _options_modifiers_has === void 0 ? void 0 : _options_modifiers_has.call(_options_modifiers, match.modifier))) throw new (0, $7GhJq.InvalidModifierError)({
            param: param,
            type: options === null || options === void 0 ? void 0 : options.type,
            modifier: match.modifier
        });
        // Check if resolved `type` is valid if there is a function modifier
        if ((0, $br4FB.functionModifiers).has(match.modifier) && !$3377bc64d30bd040$export$7265528696368a9(type, !!match.array)) throw new (0, $7GhJq.InvalidFunctionModifierError)({
            param: param,
            type: options === null || options === void 0 ? void 0 : options.type,
            modifier: match.modifier
        });
    }
    var _match_array;
    var abiParameter = (0, $do9pw._)({
        type: "".concat(type).concat((_match_array = match.array) !== null && _match_array !== void 0 ? _match_array : "")
    }, name, indexed, components);
    (0, $fexBx.parameterCache).set(parameterCacheKey, abiParameter);
    return abiParameter;
}
function $3377bc64d30bd040$export$8350908b11ff5aef(params) {
    var result = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], current = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", depth = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    var length = params.trim().length;
    // biome-ignore lint/correctness/noUnreachable: recursive
    for(var i = 0; i < length; i++){
        var char = params[i];
        var tail = params.slice(i + 1);
        switch(char){
            case ",":
                return depth === 0 ? $3377bc64d30bd040$export$8350908b11ff5aef(tail, (0, $c6Xmf._)(result).concat([
                    current.trim()
                ])) : $3377bc64d30bd040$export$8350908b11ff5aef(tail, result, "".concat(current).concat(char), depth);
            case "(":
                return $3377bc64d30bd040$export$8350908b11ff5aef(tail, result, "".concat(current).concat(char), depth + 1);
            case ")":
                return $3377bc64d30bd040$export$8350908b11ff5aef(tail, result, "".concat(current).concat(char), depth - 1);
            default:
                return $3377bc64d30bd040$export$8350908b11ff5aef(tail, result, "".concat(current).concat(char), depth);
        }
    }
    if (current === "") return result;
    if (depth !== 0) throw new (0, $5KSMn.InvalidParenthesisError)({
        current: current,
        depth: depth
    });
    result.push(current.trim());
    return result;
}
function $3377bc64d30bd040$export$640ecc6f40db6417(type) {
    return type === "address" || type === "bool" || type === "function" || type === "string" || (0, $M4QSd.bytesRegex).test(type) || (0, $M4QSd.integerRegex).test(type);
}
var $3377bc64d30bd040$var$protectedKeywordsRegex = /^(?:after|alias|anonymous|apply|auto|byte|calldata|case|catch|constant|copyof|default|defined|error|event|external|false|final|function|immutable|implements|in|indexed|inline|internal|let|mapping|match|memory|mutable|null|of|override|partial|private|promise|public|pure|reference|relocatable|return|returns|sizeof|static|storage|struct|super|supports|switch|this|true|try|typedef|typeof|var|view|virtual)$/;
function $3377bc64d30bd040$export$d83e1b8970d84409(name) {
    return name === "address" || name === "bool" || name === "function" || name === "string" || name === "tuple" || (0, $M4QSd.bytesRegex).test(name) || (0, $M4QSd.integerRegex).test(name) || $3377bc64d30bd040$var$protectedKeywordsRegex.test(name);
}
function $3377bc64d30bd040$export$7265528696368a9(type, isArray) {
    return isArray || type === "bytes" || type === "string" || type === "tuple";
}

});
parcelRegister("5KSMn", function(module, exports) {

$parcel$export(module.exports, "InvalidParenthesisError", function () { return $430bbda51ca4a2d5$export$a13d6673dbe1ad6e; });

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $lcTc8 = parcelRequire("lcTc8");
var $430bbda51ca4a2d5$export$a13d6673dbe1ad6e = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(InvalidParenthesisError, BaseError);
    var _super = (0, $ohfOJ._)(InvalidParenthesisError);
    function InvalidParenthesisError(param) {
        var current = param.current, depth = param.depth;
        (0, $4GJKx._)(this, InvalidParenthesisError);
        var _this;
        _this = _super.call(this, "Unbalanced parentheses.", {
            metaMessages: [
                '"'.concat(current.trim(), '" has too many ').concat(depth > 0 ? "opening" : "closing", " parentheses.")
            ],
            details: 'Depth "'.concat(depth, '"')
        });
        Object.defineProperty((0, $d3H5E._)(_this), "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidParenthesisError"
        });
        return _this;
    }
    return InvalidParenthesisError;
}((0, $lcTc8.BaseError));

});

parcelRegister("fexBx", function(module, exports) {

$parcel$export(module.exports, "getParameterCacheKey", function () { return $b1723af1d52f4fec$export$516f1eedf0355404; });
$parcel$export(module.exports, "parameterCache", function () { return $b1723af1d52f4fec$export$da1654d628010643; });
/**
 * Gets {@link parameterCache} cache key namespaced by {@link type}. This prevents parameters from being accessible to types that don't allow them (e.g. `string indexed foo` not allowed outside of `type: 'event'`).
 * @param param ABI parameter string
 * @param type ABI parameter type
 * @returns Cache key for {@link parameterCache}
 */ function $b1723af1d52f4fec$export$516f1eedf0355404(param, type) {
    if (type) return "".concat(type, ":").concat(param);
    return param;
}
var $b1723af1d52f4fec$export$da1654d628010643 = new Map([
    // Unnamed
    [
        "address",
        {
            type: "address"
        }
    ],
    [
        "bool",
        {
            type: "bool"
        }
    ],
    [
        "bytes",
        {
            type: "bytes"
        }
    ],
    [
        "bytes32",
        {
            type: "bytes32"
        }
    ],
    [
        "int",
        {
            type: "int256"
        }
    ],
    [
        "int256",
        {
            type: "int256"
        }
    ],
    [
        "string",
        {
            type: "string"
        }
    ],
    [
        "uint",
        {
            type: "uint256"
        }
    ],
    [
        "uint8",
        {
            type: "uint8"
        }
    ],
    [
        "uint16",
        {
            type: "uint16"
        }
    ],
    [
        "uint24",
        {
            type: "uint24"
        }
    ],
    [
        "uint32",
        {
            type: "uint32"
        }
    ],
    [
        "uint64",
        {
            type: "uint64"
        }
    ],
    [
        "uint96",
        {
            type: "uint96"
        }
    ],
    [
        "uint112",
        {
            type: "uint112"
        }
    ],
    [
        "uint160",
        {
            type: "uint160"
        }
    ],
    [
        "uint192",
        {
            type: "uint192"
        }
    ],
    [
        "uint256",
        {
            type: "uint256"
        }
    ],
    // Named
    [
        "address owner",
        {
            type: "address",
            name: "owner"
        }
    ],
    [
        "address to",
        {
            type: "address",
            name: "to"
        }
    ],
    [
        "bool approved",
        {
            type: "bool",
            name: "approved"
        }
    ],
    [
        "bytes _data",
        {
            type: "bytes",
            name: "_data"
        }
    ],
    [
        "bytes data",
        {
            type: "bytes",
            name: "data"
        }
    ],
    [
        "bytes signature",
        {
            type: "bytes",
            name: "signature"
        }
    ],
    [
        "bytes32 hash",
        {
            type: "bytes32",
            name: "hash"
        }
    ],
    [
        "bytes32 r",
        {
            type: "bytes32",
            name: "r"
        }
    ],
    [
        "bytes32 root",
        {
            type: "bytes32",
            name: "root"
        }
    ],
    [
        "bytes32 s",
        {
            type: "bytes32",
            name: "s"
        }
    ],
    [
        "string name",
        {
            type: "string",
            name: "name"
        }
    ],
    [
        "string symbol",
        {
            type: "string",
            name: "symbol"
        }
    ],
    [
        "string tokenURI",
        {
            type: "string",
            name: "tokenURI"
        }
    ],
    [
        "uint tokenId",
        {
            type: "uint256",
            name: "tokenId"
        }
    ],
    [
        "uint8 v",
        {
            type: "uint8",
            name: "v"
        }
    ],
    [
        "uint256 balance",
        {
            type: "uint256",
            name: "balance"
        }
    ],
    [
        "uint256 tokenId",
        {
            type: "uint256",
            name: "tokenId"
        }
    ],
    [
        "uint256 value",
        {
            type: "uint256",
            name: "value"
        }
    ],
    // Indexed
    [
        "event:address indexed from",
        {
            type: "address",
            name: "from",
            indexed: true
        }
    ],
    [
        "event:address indexed to",
        {
            type: "address",
            name: "to",
            indexed: true
        }
    ],
    [
        "event:uint indexed tokenId",
        {
            type: "uint256",
            name: "tokenId",
            indexed: true
        }
    ],
    [
        "event:uint256 indexed tokenId",
        {
            type: "uint256",
            name: "tokenId",
            indexed: true
        }
    ]
]);

});




parcelRegister("l2YyF", function(module, exports) {

$parcel$export(module.exports, "parseAccount", function () { return $f528c274d04d5894$export$11027cbf6cf15da2; });
function $f528c274d04d5894$export$11027cbf6cf15da2(account) {
    if (typeof account === "string") return {
        address: account,
        type: "json-rpc"
    };
    return account;
}

});

parcelRegister("9ClpR", function(module, exports) {

$parcel$export(module.exports, "multicall3Abi", function () { return $7008467af228fec3$export$4e233219477ffb48; });
$parcel$export(module.exports, "universalResolverResolveAbi", function () { return $7008467af228fec3$export$400f1d40cf4f98fe; });
$parcel$export(module.exports, "universalResolverReverseAbi", function () { return $7008467af228fec3$export$fd0db820daeebac9; });
$parcel$export(module.exports, "textResolverAbi", function () { return $7008467af228fec3$export$4e6990b9fd834e88; });
$parcel$export(module.exports, "addressResolverAbi", function () { return $7008467af228fec3$export$4c61cc2994c5d90b; });
$parcel$export(module.exports, "universalSignatureValidatorAbi", function () { return $7008467af228fec3$export$b10682c3fa53fbd1; });
$parcel$export(module.exports, "erc20Abi", function () { return $7008467af228fec3$export$891152826cc2370a; });
/* [Multicall3](https://github.com/mds1/multicall) */ 
var $c6Xmf = parcelRequire("c6Xmf");
var $7008467af228fec3$export$4e233219477ffb48 = [
    {
        inputs: [
            {
                components: [
                    {
                        name: "target",
                        type: "address"
                    },
                    {
                        name: "allowFailure",
                        type: "bool"
                    },
                    {
                        name: "callData",
                        type: "bytes"
                    }
                ],
                name: "calls",
                type: "tuple[]"
            }
        ],
        name: "aggregate3",
        outputs: [
            {
                components: [
                    {
                        name: "success",
                        type: "bool"
                    },
                    {
                        name: "returnData",
                        type: "bytes"
                    }
                ],
                name: "returnData",
                type: "tuple[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
var $7008467af228fec3$var$universalResolverErrors = [
    {
        inputs: [],
        name: "ResolverNotFound",
        type: "error"
    },
    {
        inputs: [],
        name: "ResolverWildcardNotSupported",
        type: "error"
    },
    {
        inputs: [],
        name: "ResolverNotContract",
        type: "error"
    },
    {
        inputs: [
            {
                name: "returnData",
                type: "bytes"
            }
        ],
        name: "ResolverError",
        type: "error"
    },
    {
        inputs: [
            {
                components: [
                    {
                        name: "status",
                        type: "uint16"
                    },
                    {
                        name: "message",
                        type: "string"
                    }
                ],
                name: "errors",
                type: "tuple[]"
            }
        ],
        name: "HttpError",
        type: "error"
    }
];
var $7008467af228fec3$export$400f1d40cf4f98fe = (0, $c6Xmf._)($7008467af228fec3$var$universalResolverErrors).concat([
    {
        name: "resolve",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes"
            },
            {
                name: "data",
                type: "bytes"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bytes"
            },
            {
                name: "address",
                type: "address"
            }
        ]
    },
    {
        name: "resolve",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes"
            },
            {
                name: "data",
                type: "bytes"
            },
            {
                name: "gateways",
                type: "string[]"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bytes"
            },
            {
                name: "address",
                type: "address"
            }
        ]
    }
]);
var $7008467af228fec3$export$fd0db820daeebac9 = (0, $c6Xmf._)($7008467af228fec3$var$universalResolverErrors).concat([
    {
        name: "reverse",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                type: "bytes",
                name: "reverseName"
            }
        ],
        outputs: [
            {
                type: "string",
                name: "resolvedName"
            },
            {
                type: "address",
                name: "resolvedAddress"
            },
            {
                type: "address",
                name: "reverseResolver"
            },
            {
                type: "address",
                name: "resolver"
            }
        ]
    },
    {
        name: "reverse",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                type: "bytes",
                name: "reverseName"
            },
            {
                type: "string[]",
                name: "gateways"
            }
        ],
        outputs: [
            {
                type: "string",
                name: "resolvedName"
            },
            {
                type: "address",
                name: "resolvedAddress"
            },
            {
                type: "address",
                name: "reverseResolver"
            },
            {
                type: "address",
                name: "resolver"
            }
        ]
    }
]);
var $7008467af228fec3$export$4e6990b9fd834e88 = [
    {
        name: "text",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes32"
            },
            {
                name: "key",
                type: "string"
            }
        ],
        outputs: [
            {
                name: "",
                type: "string"
            }
        ]
    }
];
var $7008467af228fec3$export$4c61cc2994c5d90b = [
    {
        name: "addr",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes32"
            }
        ],
        outputs: [
            {
                name: "",
                type: "address"
            }
        ]
    },
    {
        name: "addr",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes32"
            },
            {
                name: "coinType",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bytes"
            }
        ]
    }
];
var $7008467af228fec3$export$429a705aa5b352c0 = [
    {
        name: "isValidSignature",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "hash",
                type: "bytes32"
            },
            {
                name: "signature",
                type: "bytes"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bytes4"
            }
        ]
    }
];
var $7008467af228fec3$export$b10682c3fa53fbd1 = [
    {
        inputs: [
            {
                name: "_signer",
                type: "address"
            },
            {
                name: "_hash",
                type: "bytes32"
            },
            {
                name: "_signature",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    }
];
var $7008467af228fec3$export$891152826cc2370a = [
    {
        type: "event",
        name: "Approval",
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ]
    },
    {
        type: "event",
        name: "Transfer",
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "allowance",
        stateMutability: "view",
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "spender",
                type: "address"
            }
        ],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "approve",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "balanceOf",
        stateMutability: "view",
        inputs: [
            {
                name: "account",
                type: "address"
            }
        ],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "decimals",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "uint8"
            }
        ]
    },
    {
        type: "function",
        name: "name",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "symbol",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "totalSupply",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "transfer",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "transferFrom",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "sender",
                type: "address"
            },
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    }
];
var $7008467af228fec3$export$1c8d119bf9c799eb = [
    {
        type: "event",
        name: "Approval",
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ]
    },
    {
        type: "event",
        name: "Transfer",
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "allowance",
        stateMutability: "view",
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "spender",
                type: "address"
            }
        ],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "approve",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "balanceOf",
        stateMutability: "view",
        inputs: [
            {
                name: "account",
                type: "address"
            }
        ],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "decimals",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "uint8"
            }
        ]
    },
    {
        type: "function",
        name: "name",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "bytes32"
            }
        ]
    },
    {
        type: "function",
        name: "symbol",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "bytes32"
            }
        ]
    },
    {
        type: "function",
        name: "totalSupply",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "transfer",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "transferFrom",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "sender",
                type: "address"
            },
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    }
];
var $7008467af228fec3$export$da6511eb7df6e9f8 = [
    {
        type: "event",
        name: "Approval",
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: true,
                name: "tokenId",
                type: "uint256"
            }
        ]
    },
    {
        type: "event",
        name: "ApprovalForAll",
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                name: "approved",
                type: "bool"
            }
        ]
    },
    {
        type: "event",
        name: "Transfer",
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: true,
                name: "tokenId",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "approve",
        stateMutability: "payable",
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "balanceOf",
        stateMutability: "view",
        inputs: [
            {
                name: "account",
                type: "address"
            }
        ],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "getApproved",
        stateMutability: "view",
        inputs: [
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "address"
            }
        ]
    },
    {
        type: "function",
        name: "isApprovedForAll",
        stateMutability: "view",
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "operator",
                type: "address"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "name",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "ownerOf",
        stateMutability: "view",
        inputs: [
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "owner",
                type: "address"
            }
        ]
    },
    {
        type: "function",
        name: "safeTransferFrom",
        stateMutability: "payable",
        inputs: [
            {
                name: "from",
                type: "address"
            },
            {
                name: "to",
                type: "address"
            },
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "safeTransferFrom",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "from",
                type: "address"
            },
            {
                name: "to",
                type: "address"
            },
            {
                name: "id",
                type: "uint256"
            },
            {
                name: "data",
                type: "bytes"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "setApprovalForAll",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "operator",
                type: "address"
            },
            {
                name: "approved",
                type: "bool"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "symbol",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "tokenByIndex",
        stateMutability: "view",
        inputs: [
            {
                name: "index",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "tokenByIndex",
        stateMutability: "view",
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "index",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "tokenId",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "tokenURI",
        stateMutability: "view",
        inputs: [
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "totalSupply",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "transferFrom",
        stateMutability: "payable",
        inputs: [
            {
                name: "sender",
                type: "address"
            },
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "tokeId",
                type: "uint256"
            }
        ],
        outputs: []
    }
];
var $7008467af228fec3$export$82934a3bb3a99370 = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "sender",
                type: "address"
            },
            {
                indexed: true,
                name: "receiver",
                type: "address"
            },
            {
                indexed: false,
                name: "assets",
                type: "uint256"
            },
            {
                indexed: false,
                name: "shares",
                type: "uint256"
            }
        ],
        name: "Deposit",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "sender",
                type: "address"
            },
            {
                indexed: true,
                name: "receiver",
                type: "address"
            },
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: false,
                name: "assets",
                type: "uint256"
            },
            {
                indexed: false,
                name: "shares",
                type: "uint256"
            }
        ],
        name: "Withdraw",
        type: "event"
    },
    {
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "spender",
                type: "address"
            }
        ],
        name: "allowance",
        outputs: [
            {
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [
            {
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "asset",
        outputs: [
            {
                name: "assetTokenAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "account",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        name: "convertToAssets",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        name: "convertToShares",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            },
            {
                name: "receiver",
                type: "address"
            }
        ],
        name: "deposit",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                name: "caller",
                type: "address"
            }
        ],
        name: "maxDeposit",
        outputs: [
            {
                name: "maxAssets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "caller",
                type: "address"
            }
        ],
        name: "maxMint",
        outputs: [
            {
                name: "maxShares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "owner",
                type: "address"
            }
        ],
        name: "maxRedeem",
        outputs: [
            {
                name: "maxShares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "owner",
                type: "address"
            }
        ],
        name: "maxWithdraw",
        outputs: [
            {
                name: "maxAssets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            },
            {
                name: "receiver",
                type: "address"
            }
        ],
        name: "mint",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        name: "previewDeposit",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        name: "previewMint",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        name: "previewRedeem",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        name: "previewWithdraw",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            },
            {
                name: "receiver",
                type: "address"
            },
            {
                name: "owner",
                type: "address"
            }
        ],
        name: "redeem",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "totalAssets",
        outputs: [
            {
                name: "totalManagedAssets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "to",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transfer",
        outputs: [
            {
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                name: "from",
                type: "address"
            },
            {
                name: "to",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [
            {
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            },
            {
                name: "receiver",
                type: "address"
            },
            {
                name: "owner",
                type: "address"
            }
        ],
        name: "withdraw",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    }
];

});

parcelRegister("a7CXx", function(module, exports) {

$parcel$export(module.exports, "aggregate3Signature", function () { return $01e6d9ecd1305d1f$export$25fd9a7ba13a8409; });
var $01e6d9ecd1305d1f$export$25fd9a7ba13a8409 = "0x82ad56cb";

});

parcelRegister("iakMX", function(module, exports) {

$parcel$export(module.exports, "deploylessCallViaBytecodeBytecode", function () { return $d399495ce971cbde$export$b8650f6504de1536; });
$parcel$export(module.exports, "deploylessCallViaFactoryBytecode", function () { return $d399495ce971cbde$export$b03493bdbcb80605; });
$parcel$export(module.exports, "universalSignatureValidatorByteCode", function () { return $d399495ce971cbde$export$76c7202cd92b9dbb; });
var $d399495ce971cbde$export$b8650f6504de1536 = "0x608060405234801561001057600080fd5b5060405161018e38038061018e83398101604081905261002f91610124565b6000808351602085016000f59050803b61004857600080fd5b6000808351602085016000855af16040513d6000823e81610067573d81fd5b3d81f35b634e487b7160e01b600052604160045260246000fd5b600082601f83011261009257600080fd5b81516001600160401b038111156100ab576100ab61006b565b604051601f8201601f19908116603f011681016001600160401b03811182821017156100d9576100d961006b565b6040528181528382016020018510156100f157600080fd5b60005b82811015610110576020818601810151838301820152016100f4565b506000918101602001919091529392505050565b6000806040838503121561013757600080fd5b82516001600160401b0381111561014d57600080fd5b61015985828601610081565b602085015190935090506001600160401b0381111561017757600080fd5b61018385828601610081565b915050925092905056fe";
var $d399495ce971cbde$export$b03493bdbcb80605 = "0x608060405234801561001057600080fd5b506040516102c03803806102c083398101604081905261002f916101e6565b836001600160a01b03163b6000036100e457600080836001600160a01b03168360405161005c9190610270565b6000604051808303816000865af19150503d8060008114610099576040519150601f19603f3d011682016040523d82523d6000602084013e61009e565b606091505b50915091508115806100b857506001600160a01b0386163b155b156100e1578060405163101bb98d60e01b81526004016100d8919061028c565b60405180910390fd5b50505b6000808451602086016000885af16040513d6000823e81610103573d81fd5b3d81f35b80516001600160a01b038116811461011e57600080fd5b919050565b634e487b7160e01b600052604160045260246000fd5b60005b8381101561015457818101518382015260200161013c565b50506000910152565b600082601f83011261016e57600080fd5b81516001600160401b0381111561018757610187610123565b604051601f8201601f19908116603f011681016001600160401b03811182821017156101b5576101b5610123565b6040528181528382016020018510156101cd57600080fd5b6101de826020830160208701610139565b949350505050565b600080600080608085870312156101fc57600080fd5b61020585610107565b60208601519094506001600160401b0381111561022157600080fd5b61022d8782880161015d565b93505061023c60408601610107565b60608601519092506001600160401b0381111561025857600080fd5b6102648782880161015d565b91505092959194509250565b60008251610282818460208701610139565b9190910192915050565b60208152600082518060208401526102ab816040850160208701610139565b601f01601f1916919091016040019291505056fe";
var $d399495ce971cbde$export$76c7202cd92b9dbb = "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";

});

parcelRegister("7yD9U", function(module, exports) {

$parcel$export(module.exports, "ChainDoesNotSupportContract", function () { return $580a1581d6e06f43$export$f2b2bfa70417796b; });
$parcel$export(module.exports, "ChainMismatchError", function () { return $580a1581d6e06f43$export$535d82255cc17992; });
$parcel$export(module.exports, "ChainNotFoundError", function () { return $580a1581d6e06f43$export$b7f33b26fea1ae0b; });
$parcel$export(module.exports, "ClientChainNotConfiguredError", function () { return $580a1581d6e06f43$export$64807f0e18658482; });
$parcel$export(module.exports, "InvalidChainIdError", function () { return $580a1581d6e06f43$export$4836eb835ffca5b2; });

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $c6Xmf = parcelRequire("c6Xmf");

var $ohfOJ = parcelRequire("ohfOJ");

var $7ihh7 = parcelRequire("7ihh7");
var $580a1581d6e06f43$export$f2b2bfa70417796b = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(ChainDoesNotSupportContract, BaseError);
    var _super = (0, $ohfOJ._)(ChainDoesNotSupportContract);
    function ChainDoesNotSupportContract(param) {
        var blockNumber = param.blockNumber, chain = param.chain, contract = param.contract;
        (0, $4GJKx._)(this, ChainDoesNotSupportContract);
        return _super.call(this, 'Chain "'.concat(chain.name, '" does not support contract "').concat(contract.name, '".'), {
            metaMessages: [
                "This could be due to any of the following:"
            ].concat((0, $c6Xmf._)(blockNumber && contract.blockCreated && contract.blockCreated > blockNumber ? [
                '- The contract "'.concat(contract.name, '" was not deployed until block ').concat(contract.blockCreated, " (current block ").concat(blockNumber, ").")
            ] : [
                '- The chain does not have the contract "'.concat(contract.name, '" configured.')
            ])),
            name: "ChainDoesNotSupportContract"
        });
    }
    return ChainDoesNotSupportContract;
}((0, $7ihh7.BaseError));
var $580a1581d6e06f43$export$535d82255cc17992 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(ChainMismatchError, BaseError);
    var _super = (0, $ohfOJ._)(ChainMismatchError);
    function ChainMismatchError(param) {
        var chain = param.chain, currentChainId = param.currentChainId;
        (0, $4GJKx._)(this, ChainMismatchError);
        return _super.call(this, "The current chain of the wallet (id: ".concat(currentChainId, ") does not match the target chain for the transaction (id: ").concat(chain.id, " \u2013 ").concat(chain.name, ")."), {
            metaMessages: [
                "Current Chain ID:  ".concat(currentChainId),
                "Expected Chain ID: ".concat(chain.id, " \u2013 ").concat(chain.name)
            ],
            name: "ChainMismatchError"
        });
    }
    return ChainMismatchError;
}((0, $7ihh7.BaseError));
var $580a1581d6e06f43$export$b7f33b26fea1ae0b = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(ChainNotFoundError, BaseError);
    var _super = (0, $ohfOJ._)(ChainNotFoundError);
    function ChainNotFoundError() {
        (0, $4GJKx._)(this, ChainNotFoundError);
        return _super.call(this, [
            "No chain was provided to the request.",
            "Please provide a chain with the `chain` argument on the Action, or by supplying a `chain` to WalletClient."
        ].join("\n"), {
            name: "ChainNotFoundError"
        });
    }
    return ChainNotFoundError;
}((0, $7ihh7.BaseError));
var $580a1581d6e06f43$export$64807f0e18658482 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(ClientChainNotConfiguredError, BaseError);
    var _super = (0, $ohfOJ._)(ClientChainNotConfiguredError);
    function ClientChainNotConfiguredError() {
        (0, $4GJKx._)(this, ClientChainNotConfiguredError);
        return _super.call(this, "No chain was provided to the Client.", {
            name: "ClientChainNotConfiguredError"
        });
    }
    return ClientChainNotConfiguredError;
}((0, $7ihh7.BaseError));
var $580a1581d6e06f43$export$4836eb835ffca5b2 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(InvalidChainIdError, BaseError);
    var _super = (0, $ohfOJ._)(InvalidChainIdError);
    function InvalidChainIdError(param) {
        var chainId = param.chainId;
        (0, $4GJKx._)(this, InvalidChainIdError);
        return _super.call(this, typeof chainId === "number" ? 'Chain ID "'.concat(chainId, '" is invalid.') : "Chain ID is invalid.", {
            name: "InvalidChainIdError"
        });
    }
    return InvalidChainIdError;
}((0, $7ihh7.BaseError));

});

parcelRegister("fZz5Q", function(module, exports) {

$parcel$export(module.exports, "CallExecutionError", function () { return $ba47c65108986d2e$export$e67b04e2cd29b7d; });
$parcel$export(module.exports, "ContractFunctionExecutionError", function () { return $ba47c65108986d2e$export$399e62fddbe24423; });
$parcel$export(module.exports, "ContractFunctionRevertedError", function () { return $ba47c65108986d2e$export$b3a6b9663001535f; });
$parcel$export(module.exports, "ContractFunctionZeroDataError", function () { return $ba47c65108986d2e$export$46f5208cdcd5a621; });
$parcel$export(module.exports, "CounterfactualDeploymentFailedError", function () { return $ba47c65108986d2e$export$4fec38f081e68d02; });
$parcel$export(module.exports, "RawContractError", function () { return $ba47c65108986d2e$export$5b877bc4d7d9d460; });

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $ohfOJ = parcelRequire("ohfOJ");

var $l2YyF = parcelRequire("l2YyF");

var $7B10z = parcelRequire("7B10z");

var $3Jmse = parcelRequire("3Jmse");

var $5FHHs = parcelRequire("5FHHs");

var $3bePB = parcelRequire("3bePB");

var $lW5gB = parcelRequire("lW5gB");

var $2LEmF = parcelRequire("2LEmF");

var $PaOKy = parcelRequire("PaOKy");

var $fLalY = parcelRequire("fLalY");

var $7ihh7 = parcelRequire("7ihh7");

var $iyR6o = parcelRequire("iyR6o");

var $hgawa = parcelRequire("hgawa");

var $QhBM2 = parcelRequire("QhBM2");
var $ba47c65108986d2e$export$e67b04e2cd29b7d = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(CallExecutionError, BaseError);
    var _super = (0, $ohfOJ._)(CallExecutionError);
    function CallExecutionError(cause, param) {
        var account_ = param.account, docsPath = param.docsPath, chain = param.chain, data = param.data, gas = param.gas, gasPrice = param.gasPrice, maxFeePerGas = param.maxFeePerGas, maxPriorityFeePerGas = param.maxPriorityFeePerGas, nonce = param.nonce, to = param.to, value = param.value, stateOverride = param.stateOverride;
        (0, $4GJKx._)(this, CallExecutionError);
        var _this;
        var _chain_nativeCurrency;
        var account = account_ ? (0, $l2YyF.parseAccount)(account_) : undefined;
        var prettyArgs = (0, $hgawa.prettyPrint)({
            from: account === null || account === void 0 ? void 0 : account.address,
            to: to,
            value: typeof value !== "undefined" && "".concat((0, $2LEmF.formatEther)(value), " ").concat((chain === null || chain === void 0 ? void 0 : (_chain_nativeCurrency = chain.nativeCurrency) === null || _chain_nativeCurrency === void 0 ? void 0 : _chain_nativeCurrency.symbol) || "ETH"),
            data: data,
            gas: gas,
            gasPrice: typeof gasPrice !== "undefined" && "".concat((0, $PaOKy.formatGwei)(gasPrice), " gwei"),
            maxFeePerGas: typeof maxFeePerGas !== "undefined" && "".concat((0, $PaOKy.formatGwei)(maxFeePerGas), " gwei"),
            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== "undefined" && "".concat((0, $PaOKy.formatGwei)(maxPriorityFeePerGas), " gwei"),
            nonce: nonce
        });
        if (stateOverride) prettyArgs += "\n".concat((0, $iyR6o.prettyStateOverride)(stateOverride));
        _this = _super.call(this, cause.shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: (0, $c6Xmf._)(cause.metaMessages ? (0, $c6Xmf._)(cause.metaMessages).concat([
                " "
            ]) : []).concat([
                "Raw Call Arguments:",
                prettyArgs
            ]).filter(Boolean),
            name: "CallExecutionError"
        });
        Object.defineProperty((0, $d3H5E._)(_this), "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this.cause = cause;
        return _this;
    }
    return CallExecutionError;
}((0, $7ihh7.BaseError));
var $ba47c65108986d2e$export$399e62fddbe24423 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(ContractFunctionExecutionError, BaseError);
    var _super = (0, $ohfOJ._)(ContractFunctionExecutionError);
    function ContractFunctionExecutionError(cause, param) {
        var abi = param.abi, args = param.args, contractAddress = param.contractAddress, docsPath = param.docsPath, functionName = param.functionName, sender = param.sender;
        (0, $4GJKx._)(this, ContractFunctionExecutionError);
        var _this;
        var abiItem = (0, $lW5gB.getAbiItem)({
            abi: abi,
            args: args,
            name: functionName
        });
        var formattedArgs = abiItem ? (0, $3bePB.formatAbiItemWithArgs)({
            abiItem: abiItem,
            args: args,
            includeFunctionName: false,
            includeName: false
        }) : undefined;
        var functionWithParams = abiItem ? (0, $5FHHs.formatAbiItem)(abiItem, {
            includeName: true
        }) : undefined;
        var _functionName_length;
        var prettyArgs = (0, $hgawa.prettyPrint)({
            address: contractAddress && (0, $QhBM2.getContractAddress)(contractAddress),
            function: functionWithParams,
            args: formattedArgs && formattedArgs !== "()" && "".concat((0, $c6Xmf._)(Array((_functionName_length = functionName === null || functionName === void 0 ? void 0 : functionName.length) !== null && _functionName_length !== void 0 ? _functionName_length : 0).keys()).map(function() {
                return " ";
            }).join("")).concat(formattedArgs),
            sender: sender
        });
        _this = _super.call(this, cause.shortMessage || 'An unknown error occurred while executing the contract function "'.concat(functionName, '".'), {
            cause: cause,
            docsPath: docsPath,
            metaMessages: (0, $c6Xmf._)(cause.metaMessages ? (0, $c6Xmf._)(cause.metaMessages).concat([
                " "
            ]) : []).concat([
                prettyArgs && "Contract Call:",
                prettyArgs
            ]).filter(Boolean),
            name: "ContractFunctionExecutionError"
        });
        Object.defineProperty((0, $d3H5E._)(_this), "abi", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty((0, $d3H5E._)(_this), "args", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty((0, $d3H5E._)(_this), "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty((0, $d3H5E._)(_this), "contractAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty((0, $d3H5E._)(_this), "formattedArgs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty((0, $d3H5E._)(_this), "functionName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty((0, $d3H5E._)(_this), "sender", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this.abi = abi;
        _this.args = args;
        _this.cause = cause;
        _this.contractAddress = contractAddress;
        _this.functionName = functionName;
        _this.sender = sender;
        return _this;
    }
    return ContractFunctionExecutionError;
}((0, $7ihh7.BaseError));
var $ba47c65108986d2e$export$b3a6b9663001535f = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(ContractFunctionRevertedError, BaseError);
    var _super = (0, $ohfOJ._)(ContractFunctionRevertedError);
    function ContractFunctionRevertedError(param) {
        var abi = param.abi, data = param.data, functionName = param.functionName, message = param.message;
        (0, $4GJKx._)(this, ContractFunctionRevertedError);
        var _this;
        var cause;
        var decodedData = undefined;
        var metaMessages;
        var reason;
        if (data && data !== "0x") try {
            decodedData = (0, $3Jmse.decodeErrorResult)({
                abi: abi,
                data: data
            });
            var abiItem = decodedData.abiItem, errorName = decodedData.errorName, errorArgs = decodedData.args;
            if (errorName === "Error") reason = errorArgs[0];
            else if (errorName === "Panic") {
                var _errorArgs = (0, $cv9Rk._)(errorArgs, 1), firstArg = _errorArgs[0];
                reason = (0, $7B10z.panicReasons)[firstArg];
            } else {
                var errorWithParams = abiItem ? (0, $5FHHs.formatAbiItem)(abiItem, {
                    includeName: true
                }) : undefined;
                var formattedArgs = abiItem && errorArgs ? (0, $3bePB.formatAbiItemWithArgs)({
                    abiItem: abiItem,
                    args: errorArgs,
                    includeFunctionName: false,
                    includeName: false
                }) : undefined;
                var _errorName_length;
                metaMessages = [
                    errorWithParams ? "Error: ".concat(errorWithParams) : "",
                    formattedArgs && formattedArgs !== "()" ? "       ".concat((0, $c6Xmf._)(Array((_errorName_length = errorName === null || errorName === void 0 ? void 0 : errorName.length) !== null && _errorName_length !== void 0 ? _errorName_length : 0).keys()).map(function() {
                        return " ";
                    }).join("")).concat(formattedArgs) : ""
                ];
            }
        } catch (err) {
            cause = err;
        }
        else if (message) reason = message;
        var signature;
        if (cause instanceof (0, $fLalY.AbiErrorSignatureNotFoundError)) {
            signature = cause.signature;
            metaMessages = [
                'Unable to decode signature "'.concat(signature, '" as it was not found on the provided ABI.'),
                "Make sure you are using the correct ABI and that the error exists on it.",
                "You can look up the decoded signature here: https://openchain.xyz/signatures?query=".concat(signature, ".")
            ];
        }
        _this = _super.call(this, reason && reason !== "execution reverted" || signature ? [
            'The contract function "'.concat(functionName, '" reverted with the following ').concat(signature ? "signature" : "reason", ":"),
            reason || signature
        ].join("\n") : 'The contract function "'.concat(functionName, '" reverted.'), {
            cause: cause,
            metaMessages: metaMessages,
            name: "ContractFunctionRevertedError"
        });
        Object.defineProperty((0, $d3H5E._)(_this), "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty((0, $d3H5E._)(_this), "reason", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty((0, $d3H5E._)(_this), "signature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this.data = decodedData;
        _this.reason = reason;
        _this.signature = signature;
        return _this;
    }
    return ContractFunctionRevertedError;
}((0, $7ihh7.BaseError));
var $ba47c65108986d2e$export$46f5208cdcd5a621 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(ContractFunctionZeroDataError, BaseError);
    var _super = (0, $ohfOJ._)(ContractFunctionZeroDataError);
    function ContractFunctionZeroDataError(param) {
        var functionName = param.functionName;
        (0, $4GJKx._)(this, ContractFunctionZeroDataError);
        return _super.call(this, 'The contract function "'.concat(functionName, '" returned no data ("0x").'), {
            metaMessages: [
                "This could be due to any of the following:",
                '  - The contract does not have the function "'.concat(functionName, '",'),
                "  - The parameters passed to the contract function may be invalid, or",
                "  - The address is not a contract."
            ],
            name: "ContractFunctionZeroDataError"
        });
    }
    return ContractFunctionZeroDataError;
}((0, $7ihh7.BaseError));
var $ba47c65108986d2e$export$4fec38f081e68d02 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(CounterfactualDeploymentFailedError, BaseError);
    var _super = (0, $ohfOJ._)(CounterfactualDeploymentFailedError);
    function CounterfactualDeploymentFailedError(param) {
        var factory = param.factory;
        (0, $4GJKx._)(this, CounterfactualDeploymentFailedError);
        return _super.call(this, "Deployment for counterfactual contract call failed".concat(factory ? ' for factory "'.concat(factory, '".') : ""), {
            metaMessages: [
                "Please ensure:",
                "- The `factory` is a valid contract deployment factory (ie. Create2 Factory, ERC-4337 Factory, etc).",
                "- The `factoryData` is a valid encoded function call for contract deployment function on the factory."
            ],
            name: "CounterfactualDeploymentFailedError"
        });
    }
    return CounterfactualDeploymentFailedError;
}((0, $7ihh7.BaseError));
var $ba47c65108986d2e$export$5b877bc4d7d9d460 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(RawContractError, BaseError);
    var _super = (0, $ohfOJ._)(RawContractError);
    function RawContractError(param) {
        var data = param.data, message = param.message;
        (0, $4GJKx._)(this, RawContractError);
        var _this;
        _this = _super.call(this, message || "", {
            name: "RawContractError"
        });
        Object.defineProperty((0, $d3H5E._)(_this), "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 3
        });
        Object.defineProperty((0, $d3H5E._)(_this), "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this.data = data;
        return _this;
    }
    return RawContractError;
}((0, $7ihh7.BaseError));

});
parcelRegister("7B10z", function(module, exports) {

$parcel$export(module.exports, "panicReasons", function () { return $587cc54e96167f59$export$a618024566d3d221; });
$parcel$export(module.exports, "solidityError", function () { return $587cc54e96167f59$export$730e9cc7aaa8ca20; });
$parcel$export(module.exports, "solidityPanic", function () { return $587cc54e96167f59$export$e45b3aea1c5b33e6; });
// https://docs.soliditylang.org/en/v0.8.16/control-structures.html#panic-via-assert-and-error-via-require
var $587cc54e96167f59$export$a618024566d3d221 = {
    1: "An `assert` condition failed.",
    17: "Arithmetic operation resulted in underflow or overflow.",
    18: "Division or modulo by zero (e.g. `5 / 0` or `23 % 0`).",
    33: "Attempted to convert to an invalid type.",
    34: "Attempted to access a storage byte array that is incorrectly encoded.",
    49: "Performed `.pop()` on an empty array",
    50: "Array index is out of bounds.",
    65: "Allocated too much memory or created an array which is too large.",
    81: "Attempted to call a zero-initialized variable of internal function type."
};
var $587cc54e96167f59$export$730e9cc7aaa8ca20 = {
    inputs: [
        {
            name: "message",
            type: "string"
        }
    ],
    name: "Error",
    type: "error"
};
var $587cc54e96167f59$export$e45b3aea1c5b33e6 = {
    inputs: [
        {
            name: "reason",
            type: "uint256"
        }
    ],
    name: "Panic",
    type: "error"
};

});

parcelRegister("3Jmse", function(module, exports) {

$parcel$export(module.exports, "decodeErrorResult", function () { return $2b76fe05a047d6e6$export$8f7898b7bcae6080; });

var $c6Xmf = parcelRequire("c6Xmf");

var $7B10z = parcelRequire("7B10z");

var $fLalY = parcelRequire("fLalY");

var $8SGIa = parcelRequire("8SGIa");

var $h023G = parcelRequire("h023G");

var $iYiQt = parcelRequire("iYiQt");

var $5FHHs = parcelRequire("5FHHs");
function $2b76fe05a047d6e6$export$8f7898b7bcae6080(parameters) {
    var abi = parameters.abi, data = parameters.data;
    var signature = (0, $8SGIa.slice)(data, 0, 4);
    if (signature === "0x") throw new (0, $fLalY.AbiDecodingZeroDataError)();
    var abi_ = (0, $c6Xmf._)(abi || []).concat([
        (0, $7B10z.solidityError),
        (0, $7B10z.solidityPanic)
    ]);
    var abiItem = abi_.find(function(x) {
        return x.type === "error" && signature === (0, $h023G.toFunctionSelector)((0, $5FHHs.formatAbiItem)(x));
    });
    if (!abiItem) throw new (0, $fLalY.AbiErrorSignatureNotFoundError)(signature, {
        docsPath: "/docs/contract/decodeErrorResult"
    });
    return {
        abiItem: abiItem,
        args: "inputs" in abiItem && abiItem.inputs && abiItem.inputs.length > 0 ? (0, $iYiQt.decodeAbiParameters)(abiItem.inputs, (0, $8SGIa.slice)(data, 4)) : undefined,
        errorName: abiItem.name
    };
}

});
parcelRegister("fLalY", function(module, exports) {

$parcel$export(module.exports, "AbiConstructorNotFoundError", function () { return $b79346c5e61123c4$export$efa723f306cf6168; });
$parcel$export(module.exports, "AbiConstructorParamsNotFoundError", function () { return $b79346c5e61123c4$export$4faec14323ef9c47; });
$parcel$export(module.exports, "AbiDecodingDataSizeTooSmallError", function () { return $b79346c5e61123c4$export$7a409e433c5f3a8c; });
$parcel$export(module.exports, "AbiDecodingZeroDataError", function () { return $b79346c5e61123c4$export$a063cde4013f1935; });
$parcel$export(module.exports, "AbiEncodingArrayLengthMismatchError", function () { return $b79346c5e61123c4$export$a851da9bf50b557; });
$parcel$export(module.exports, "AbiEncodingBytesSizeMismatchError", function () { return $b79346c5e61123c4$export$19c281dc8e23a2ea; });
$parcel$export(module.exports, "AbiEncodingLengthMismatchError", function () { return $b79346c5e61123c4$export$20737d495bb13c2d; });
$parcel$export(module.exports, "AbiErrorSignatureNotFoundError", function () { return $b79346c5e61123c4$export$8959cb729fefe1ea; });
$parcel$export(module.exports, "AbiEventSignatureEmptyTopicsError", function () { return $b79346c5e61123c4$export$f83210ce5f9b901f; });
$parcel$export(module.exports, "AbiEventSignatureNotFoundError", function () { return $b79346c5e61123c4$export$3b44baeac92e4d3a; });
$parcel$export(module.exports, "AbiEventNotFoundError", function () { return $b79346c5e61123c4$export$c7be62baad13b157; });
$parcel$export(module.exports, "AbiFunctionNotFoundError", function () { return $b79346c5e61123c4$export$c4faa308ea7f9b2; });
$parcel$export(module.exports, "AbiFunctionOutputsNotFoundError", function () { return $b79346c5e61123c4$export$26f2edb605108b34; });
$parcel$export(module.exports, "AbiItemAmbiguityError", function () { return $b79346c5e61123c4$export$fdbba54ba15f2c2d; });
$parcel$export(module.exports, "BytesSizeMismatchError", function () { return $b79346c5e61123c4$export$a0eb884ede5c87eb; });
$parcel$export(module.exports, "DecodeLogDataMismatch", function () { return $b79346c5e61123c4$export$3978f86c08fc8c25; });
$parcel$export(module.exports, "DecodeLogTopicsMismatch", function () { return $b79346c5e61123c4$export$6d7c6f419cf52377; });
$parcel$export(module.exports, "InvalidAbiEncodingTypeError", function () { return $b79346c5e61123c4$export$53ed98b886965f49; });
$parcel$export(module.exports, "InvalidAbiDecodingTypeError", function () { return $b79346c5e61123c4$export$cf94ccff0ff97c65; });
$parcel$export(module.exports, "InvalidArrayError", function () { return $b79346c5e61123c4$export$710dd6d4f78cc47e; });
$parcel$export(module.exports, "InvalidDefinitionTypeError", function () { return $b79346c5e61123c4$export$81781a0fcfb9ed95; });

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $5FHHs = parcelRequire("5FHHs");

var $dfJGH = parcelRequire("dfJGH");

var $7ihh7 = parcelRequire("7ihh7");
var $b79346c5e61123c4$export$efa723f306cf6168 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(AbiConstructorNotFoundError, BaseError);
    var _super = (0, $ohfOJ._)(AbiConstructorNotFoundError);
    function AbiConstructorNotFoundError(param) {
        var docsPath = param.docsPath;
        (0, $4GJKx._)(this, AbiConstructorNotFoundError);
        return _super.call(this, [
            "A constructor was not found on the ABI.",
            "Make sure you are using the correct ABI and that the constructor exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiConstructorNotFoundError"
        });
    }
    return AbiConstructorNotFoundError;
}((0, $7ihh7.BaseError));
var $b79346c5e61123c4$export$4faec14323ef9c47 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(AbiConstructorParamsNotFoundError, BaseError);
    var _super = (0, $ohfOJ._)(AbiConstructorParamsNotFoundError);
    function AbiConstructorParamsNotFoundError(param) {
        var docsPath = param.docsPath;
        (0, $4GJKx._)(this, AbiConstructorParamsNotFoundError);
        return _super.call(this, [
            "Constructor arguments were provided (`args`), but a constructor parameters (`inputs`) were not found on the ABI.",
            "Make sure you are using the correct ABI, and that the `inputs` attribute on the constructor exists."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiConstructorParamsNotFoundError"
        });
    }
    return AbiConstructorParamsNotFoundError;
}((0, $7ihh7.BaseError));
var $b79346c5e61123c4$export$68a7b570091cba69 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(AbiDecodingDataSizeInvalidError, BaseError);
    var _super = (0, $ohfOJ._)(AbiDecodingDataSizeInvalidError);
    function AbiDecodingDataSizeInvalidError(param) {
        var data = param.data, size = param.size;
        (0, $4GJKx._)(this, AbiDecodingDataSizeInvalidError);
        return _super.call(this, [
            "Data size of ".concat(size, " bytes is invalid."),
            "Size must be in increments of 32 bytes (size % 32 === 0)."
        ].join("\n"), {
            metaMessages: [
                "Data: ".concat(data, " (").concat(size, " bytes)")
            ],
            name: "AbiDecodingDataSizeInvalidError"
        });
    }
    return AbiDecodingDataSizeInvalidError;
}((0, $7ihh7.BaseError));
var $b79346c5e61123c4$export$7a409e433c5f3a8c = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(AbiDecodingDataSizeTooSmallError, BaseError);
    var _super = (0, $ohfOJ._)(AbiDecodingDataSizeTooSmallError);
    function AbiDecodingDataSizeTooSmallError(param) {
        var data = param.data, params = param.params, size = param.size;
        (0, $4GJKx._)(this, AbiDecodingDataSizeTooSmallError);
        var _this;
        _this = _super.call(this, [
            "Data size of ".concat(size, " bytes is too small for given parameters.")
        ].join("\n"), {
            metaMessages: [
                "Params: (".concat((0, $5FHHs.formatAbiParams)(params, {
                    includeName: true
                }), ")"),
                "Data:   ".concat(data, " (").concat(size, " bytes)")
            ],
            name: "AbiDecodingDataSizeTooSmallError"
        });
        Object.defineProperty((0, $d3H5E._)(_this), "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty((0, $d3H5E._)(_this), "params", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty((0, $d3H5E._)(_this), "size", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this.data = data;
        _this.params = params;
        _this.size = size;
        return _this;
    }
    return AbiDecodingDataSizeTooSmallError;
}((0, $7ihh7.BaseError));
var $b79346c5e61123c4$export$a063cde4013f1935 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(AbiDecodingZeroDataError, BaseError);
    var _super = (0, $ohfOJ._)(AbiDecodingZeroDataError);
    function AbiDecodingZeroDataError() {
        (0, $4GJKx._)(this, AbiDecodingZeroDataError);
        return _super.call(this, 'Cannot decode zero data ("0x") with ABI parameters.', {
            name: "AbiDecodingZeroDataError"
        });
    }
    return AbiDecodingZeroDataError;
}((0, $7ihh7.BaseError));
var $b79346c5e61123c4$export$a851da9bf50b557 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(AbiEncodingArrayLengthMismatchError, BaseError);
    var _super = (0, $ohfOJ._)(AbiEncodingArrayLengthMismatchError);
    function AbiEncodingArrayLengthMismatchError(param) {
        var expectedLength = param.expectedLength, givenLength = param.givenLength, type = param.type;
        (0, $4GJKx._)(this, AbiEncodingArrayLengthMismatchError);
        return _super.call(this, [
            "ABI encoding array length mismatch for type ".concat(type, "."),
            "Expected length: ".concat(expectedLength),
            "Given length: ".concat(givenLength)
        ].join("\n"), {
            name: "AbiEncodingArrayLengthMismatchError"
        });
    }
    return AbiEncodingArrayLengthMismatchError;
}((0, $7ihh7.BaseError));
var $b79346c5e61123c4$export$19c281dc8e23a2ea = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(AbiEncodingBytesSizeMismatchError, BaseError);
    var _super = (0, $ohfOJ._)(AbiEncodingBytesSizeMismatchError);
    function AbiEncodingBytesSizeMismatchError(param) {
        var expectedSize = param.expectedSize, value = param.value;
        (0, $4GJKx._)(this, AbiEncodingBytesSizeMismatchError);
        return _super.call(this, 'Size of bytes "'.concat(value, '" (bytes').concat((0, $dfJGH.size)(value), ") does not match expected size (bytes").concat(expectedSize, ")."), {
            name: "AbiEncodingBytesSizeMismatchError"
        });
    }
    return AbiEncodingBytesSizeMismatchError;
}((0, $7ihh7.BaseError));
var $b79346c5e61123c4$export$20737d495bb13c2d = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(AbiEncodingLengthMismatchError, BaseError);
    var _super = (0, $ohfOJ._)(AbiEncodingLengthMismatchError);
    function AbiEncodingLengthMismatchError(param) {
        var expectedLength = param.expectedLength, givenLength = param.givenLength;
        (0, $4GJKx._)(this, AbiEncodingLengthMismatchError);
        return _super.call(this, [
            "ABI encoding params/values length mismatch.",
            "Expected length (params): ".concat(expectedLength),
            "Given length (values): ".concat(givenLength)
        ].join("\n"), {
            name: "AbiEncodingLengthMismatchError"
        });
    }
    return AbiEncodingLengthMismatchError;
}((0, $7ihh7.BaseError));
var $b79346c5e61123c4$export$d47cf5ef47eda817 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(AbiErrorInputsNotFoundError, BaseError);
    var _super = (0, $ohfOJ._)(AbiErrorInputsNotFoundError);
    function AbiErrorInputsNotFoundError(errorName, param) {
        var docsPath = param.docsPath;
        (0, $4GJKx._)(this, AbiErrorInputsNotFoundError);
        return _super.call(this, [
            'Arguments (`args`) were provided to "'.concat(errorName, '", but "').concat(errorName, '" on the ABI does not contain any parameters (`inputs`).'),
            "Cannot encode error result without knowing what the parameter types are.",
            "Make sure you are using the correct ABI and that the inputs exist on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiErrorInputsNotFoundError"
        });
    }
    return AbiErrorInputsNotFoundError;
}((0, $7ihh7.BaseError));
var $b79346c5e61123c4$export$86b719574b683f04 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(AbiErrorNotFoundError, BaseError);
    var _super = (0, $ohfOJ._)(AbiErrorNotFoundError);
    function AbiErrorNotFoundError(errorName) {
        var docsPath = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).docsPath;
        (0, $4GJKx._)(this, AbiErrorNotFoundError);
        return _super.call(this, [
            "Error ".concat(errorName ? '"'.concat(errorName, '" ') : "", "not found on ABI."),
            "Make sure you are using the correct ABI and that the error exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiErrorNotFoundError"
        });
    }
    return AbiErrorNotFoundError;
}((0, $7ihh7.BaseError));
var $b79346c5e61123c4$export$8959cb729fefe1ea = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(AbiErrorSignatureNotFoundError, BaseError);
    var _super = (0, $ohfOJ._)(AbiErrorSignatureNotFoundError);
    function AbiErrorSignatureNotFoundError(signature, param) {
        var docsPath = param.docsPath;
        (0, $4GJKx._)(this, AbiErrorSignatureNotFoundError);
        var _this;
        _this = _super.call(this, [
            'Encoded error signature "'.concat(signature, '" not found on ABI.'),
            "Make sure you are using the correct ABI and that the error exists on it.",
            "You can look up the decoded signature here: https://openchain.xyz/signatures?query=".concat(signature, ".")
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiErrorSignatureNotFoundError"
        });
        Object.defineProperty((0, $d3H5E._)(_this), "signature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this.signature = signature;
        return _this;
    }
    return AbiErrorSignatureNotFoundError;
}((0, $7ihh7.BaseError));
var $b79346c5e61123c4$export$f83210ce5f9b901f = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(AbiEventSignatureEmptyTopicsError, BaseError);
    var _super = (0, $ohfOJ._)(AbiEventSignatureEmptyTopicsError);
    function AbiEventSignatureEmptyTopicsError(param) {
        var docsPath = param.docsPath;
        (0, $4GJKx._)(this, AbiEventSignatureEmptyTopicsError);
        return _super.call(this, "Cannot extract event signature from empty topics.", {
            docsPath: docsPath,
            name: "AbiEventSignatureEmptyTopicsError"
        });
    }
    return AbiEventSignatureEmptyTopicsError;
}((0, $7ihh7.BaseError));
var $b79346c5e61123c4$export$3b44baeac92e4d3a = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(AbiEventSignatureNotFoundError, BaseError);
    var _super = (0, $ohfOJ._)(AbiEventSignatureNotFoundError);
    function AbiEventSignatureNotFoundError(signature, param) {
        var docsPath = param.docsPath;
        (0, $4GJKx._)(this, AbiEventSignatureNotFoundError);
        return _super.call(this, [
            'Encoded event signature "'.concat(signature, '" not found on ABI.'),
            "Make sure you are using the correct ABI and that the event exists on it.",
            "You can look up the signature here: https://openchain.xyz/signatures?query=".concat(signature, ".")
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiEventSignatureNotFoundError"
        });
    }
    return AbiEventSignatureNotFoundError;
}((0, $7ihh7.BaseError));
var $b79346c5e61123c4$export$c7be62baad13b157 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(AbiEventNotFoundError, BaseError);
    var _super = (0, $ohfOJ._)(AbiEventNotFoundError);
    function AbiEventNotFoundError(eventName) {
        var docsPath = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).docsPath;
        (0, $4GJKx._)(this, AbiEventNotFoundError);
        return _super.call(this, [
            "Event ".concat(eventName ? '"'.concat(eventName, '" ') : "", "not found on ABI."),
            "Make sure you are using the correct ABI and that the event exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiEventNotFoundError"
        });
    }
    return AbiEventNotFoundError;
}((0, $7ihh7.BaseError));
var $b79346c5e61123c4$export$c4faa308ea7f9b2 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(AbiFunctionNotFoundError, BaseError);
    var _super = (0, $ohfOJ._)(AbiFunctionNotFoundError);
    function AbiFunctionNotFoundError(functionName) {
        var docsPath = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).docsPath;
        (0, $4GJKx._)(this, AbiFunctionNotFoundError);
        return _super.call(this, [
            "Function ".concat(functionName ? '"'.concat(functionName, '" ') : "", "not found on ABI."),
            "Make sure you are using the correct ABI and that the function exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiFunctionNotFoundError"
        });
    }
    return AbiFunctionNotFoundError;
}((0, $7ihh7.BaseError));
var $b79346c5e61123c4$export$26f2edb605108b34 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(AbiFunctionOutputsNotFoundError, BaseError);
    var _super = (0, $ohfOJ._)(AbiFunctionOutputsNotFoundError);
    function AbiFunctionOutputsNotFoundError(functionName, param) {
        var docsPath = param.docsPath;
        (0, $4GJKx._)(this, AbiFunctionOutputsNotFoundError);
        return _super.call(this, [
            'Function "'.concat(functionName, '" does not contain any `outputs` on ABI.'),
            "Cannot decode function result without knowing what the parameter types are.",
            "Make sure you are using the correct ABI and that the function exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiFunctionOutputsNotFoundError"
        });
    }
    return AbiFunctionOutputsNotFoundError;
}((0, $7ihh7.BaseError));
var $b79346c5e61123c4$export$14373147a0e60810 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(AbiFunctionSignatureNotFoundError, BaseError);
    var _super = (0, $ohfOJ._)(AbiFunctionSignatureNotFoundError);
    function AbiFunctionSignatureNotFoundError(signature, param) {
        var docsPath = param.docsPath;
        (0, $4GJKx._)(this, AbiFunctionSignatureNotFoundError);
        return _super.call(this, [
            'Encoded function signature "'.concat(signature, '" not found on ABI.'),
            "Make sure you are using the correct ABI and that the function exists on it.",
            "You can look up the signature here: https://openchain.xyz/signatures?query=".concat(signature, ".")
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiFunctionSignatureNotFoundError"
        });
    }
    return AbiFunctionSignatureNotFoundError;
}((0, $7ihh7.BaseError));
var $b79346c5e61123c4$export$fdbba54ba15f2c2d = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(AbiItemAmbiguityError, BaseError);
    var _super = (0, $ohfOJ._)(AbiItemAmbiguityError);
    function AbiItemAmbiguityError(x, y) {
        (0, $4GJKx._)(this, AbiItemAmbiguityError);
        return _super.call(this, "Found ambiguous types in overloaded ABI items.", {
            metaMessages: [
                "`".concat(x.type, "` in `").concat((0, $5FHHs.formatAbiItem)(x.abiItem), "`, and"),
                "`".concat(y.type, "` in `").concat((0, $5FHHs.formatAbiItem)(y.abiItem), "`"),
                "",
                "These types encode differently and cannot be distinguished at runtime.",
                "Remove one of the ambiguous items in the ABI."
            ],
            name: "AbiItemAmbiguityError"
        });
    }
    return AbiItemAmbiguityError;
}((0, $7ihh7.BaseError));
var $b79346c5e61123c4$export$a0eb884ede5c87eb = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(BytesSizeMismatchError, BaseError);
    var _super = (0, $ohfOJ._)(BytesSizeMismatchError);
    function BytesSizeMismatchError(param) {
        var expectedSize = param.expectedSize, givenSize = param.givenSize;
        (0, $4GJKx._)(this, BytesSizeMismatchError);
        return _super.call(this, "Expected bytes".concat(expectedSize, ", got bytes").concat(givenSize, "."), {
            name: "BytesSizeMismatchError"
        });
    }
    return BytesSizeMismatchError;
}((0, $7ihh7.BaseError));
var $b79346c5e61123c4$export$3978f86c08fc8c25 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(DecodeLogDataMismatch, BaseError);
    var _super = (0, $ohfOJ._)(DecodeLogDataMismatch);
    function DecodeLogDataMismatch(param) {
        var abiItem = param.abiItem, data = param.data, params = param.params, size = param.size;
        (0, $4GJKx._)(this, DecodeLogDataMismatch);
        var _this;
        _this = _super.call(this, [
            "Data size of ".concat(size, " bytes is too small for non-indexed event parameters.")
        ].join("\n"), {
            metaMessages: [
                "Params: (".concat((0, $5FHHs.formatAbiParams)(params, {
                    includeName: true
                }), ")"),
                "Data:   ".concat(data, " (").concat(size, " bytes)")
            ],
            name: "DecodeLogDataMismatch"
        });
        Object.defineProperty((0, $d3H5E._)(_this), "abiItem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty((0, $d3H5E._)(_this), "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty((0, $d3H5E._)(_this), "params", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty((0, $d3H5E._)(_this), "size", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this.abiItem = abiItem;
        _this.data = data;
        _this.params = params;
        _this.size = size;
        return _this;
    }
    return DecodeLogDataMismatch;
}((0, $7ihh7.BaseError));
var $b79346c5e61123c4$export$6d7c6f419cf52377 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(DecodeLogTopicsMismatch, BaseError);
    var _super = (0, $ohfOJ._)(DecodeLogTopicsMismatch);
    function DecodeLogTopicsMismatch(param) {
        var abiItem = param.abiItem, _$param = param.param;
        (0, $4GJKx._)(this, DecodeLogTopicsMismatch);
        var _this;
        _this = _super.call(this, [
            "Expected a topic for indexed event parameter".concat(_$param.name ? ' "'.concat(_$param.name, '"') : "", ' on event "').concat((0, $5FHHs.formatAbiItem)(abiItem, {
                includeName: true
            }), '".')
        ].join("\n"), {
            name: "DecodeLogTopicsMismatch"
        });
        Object.defineProperty((0, $d3H5E._)(_this), "abiItem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this.abiItem = abiItem;
        return _this;
    }
    return DecodeLogTopicsMismatch;
}((0, $7ihh7.BaseError));
var $b79346c5e61123c4$export$53ed98b886965f49 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(InvalidAbiEncodingTypeError, BaseError);
    var _super = (0, $ohfOJ._)(InvalidAbiEncodingTypeError);
    function InvalidAbiEncodingTypeError(type, param) {
        var docsPath = param.docsPath;
        (0, $4GJKx._)(this, InvalidAbiEncodingTypeError);
        return _super.call(this, [
            'Type "'.concat(type, '" is not a valid encoding type.'),
            "Please provide a valid ABI type."
        ].join("\n"), {
            docsPath: docsPath,
            name: "InvalidAbiEncodingType"
        });
    }
    return InvalidAbiEncodingTypeError;
}((0, $7ihh7.BaseError));
var $b79346c5e61123c4$export$cf94ccff0ff97c65 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(InvalidAbiDecodingTypeError, BaseError);
    var _super = (0, $ohfOJ._)(InvalidAbiDecodingTypeError);
    function InvalidAbiDecodingTypeError(type, param) {
        var docsPath = param.docsPath;
        (0, $4GJKx._)(this, InvalidAbiDecodingTypeError);
        return _super.call(this, [
            'Type "'.concat(type, '" is not a valid decoding type.'),
            "Please provide a valid ABI type."
        ].join("\n"), {
            docsPath: docsPath,
            name: "InvalidAbiDecodingType"
        });
    }
    return InvalidAbiDecodingTypeError;
}((0, $7ihh7.BaseError));
var $b79346c5e61123c4$export$710dd6d4f78cc47e = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(InvalidArrayError, BaseError);
    var _super = (0, $ohfOJ._)(InvalidArrayError);
    function InvalidArrayError(value) {
        (0, $4GJKx._)(this, InvalidArrayError);
        return _super.call(this, [
            'Value "'.concat(value, '" is not a valid array.')
        ].join("\n"), {
            name: "InvalidArrayError"
        });
    }
    return InvalidArrayError;
}((0, $7ihh7.BaseError));
var $b79346c5e61123c4$export$81781a0fcfb9ed95 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(InvalidDefinitionTypeError, BaseError);
    var _super = (0, $ohfOJ._)(InvalidDefinitionTypeError);
    function InvalidDefinitionTypeError(type) {
        (0, $4GJKx._)(this, InvalidDefinitionTypeError);
        return _super.call(this, [
            '"'.concat(type, '" is not a valid definition type.'),
            'Valid types: "function", "event", "error"'
        ].join("\n"), {
            name: "InvalidDefinitionTypeError"
        });
    }
    return InvalidDefinitionTypeError;
}((0, $7ihh7.BaseError));
var $b79346c5e61123c4$export$a16541e2fe420ef1 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(UnsupportedPackedAbiType, BaseError);
    var _super = (0, $ohfOJ._)(UnsupportedPackedAbiType);
    function UnsupportedPackedAbiType(type) {
        (0, $4GJKx._)(this, UnsupportedPackedAbiType);
        return _super.call(this, 'Type "'.concat(type, '" is not supported for packed encoding.'), {
            name: "UnsupportedPackedAbiType"
        });
    }
    return UnsupportedPackedAbiType;
}((0, $7ihh7.BaseError));

});
parcelRegister("5FHHs", function(module, exports) {

$parcel$export(module.exports, "formatAbiItem", function () { return $4212adf6a1d0ef24$export$dc5d0ff4fc2fdee1; });
$parcel$export(module.exports, "formatAbiParams", function () { return $4212adf6a1d0ef24$export$849e499971de75b3; });

var $fLalY = parcelRequire("fLalY");
function $4212adf6a1d0ef24$export$dc5d0ff4fc2fdee1(abiItem) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_includeName = _ref.includeName, includeName = _ref_includeName === void 0 ? false : _ref_includeName;
    if (abiItem.type !== "function" && abiItem.type !== "event" && abiItem.type !== "error") throw new (0, $fLalY.InvalidDefinitionTypeError)(abiItem.type);
    return "".concat(abiItem.name, "(").concat($4212adf6a1d0ef24$export$849e499971de75b3(abiItem.inputs, {
        includeName: includeName
    }), ")");
}
function $4212adf6a1d0ef24$export$849e499971de75b3(params) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_includeName = _ref.includeName, includeName = _ref_includeName === void 0 ? false : _ref_includeName;
    if (!params) return "";
    return params.map(function(param) {
        return $4212adf6a1d0ef24$var$formatAbiParam(param, {
            includeName: includeName
        });
    }).join(includeName ? ", " : ",");
}
function $4212adf6a1d0ef24$var$formatAbiParam(param, param1) {
    var includeName = param1.includeName;
    if (param.type.startsWith("tuple")) return "(".concat($4212adf6a1d0ef24$export$849e499971de75b3(param.components, {
        includeName: includeName
    }), ")").concat(param.type.slice(5));
    return param.type + (includeName && param.name ? " ".concat(param.name) : "");
}

});

parcelRegister("dfJGH", function(module, exports) {

$parcel$export(module.exports, "size", function () { return $9a601db351e0c250$export$346677f925de839c; });

var $aP7UT = parcelRequire("aP7UT");
function $9a601db351e0c250$export$346677f925de839c(value) {
    if ((0, $aP7UT.isHex)(value, {
        strict: false
    })) return Math.ceil((value.length - 2) / 2);
    return value.length;
}

});


parcelRegister("8SGIa", function(module, exports) {

$parcel$export(module.exports, "slice", function () { return $67747f70c7ce87ca$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "sliceHex", function () { return $67747f70c7ce87ca$export$728fe14c970402fe; });
$parcel$export(module.exports, "sliceBytes", function () { return $67747f70c7ce87ca$export$8bac03c8c1da551; });

var $bD8YT = parcelRequire("bD8YT");

var $aP7UT = parcelRequire("aP7UT");

var $dfJGH = parcelRequire("dfJGH");
function $67747f70c7ce87ca$export$58adb3bec8346d0f(value, start, end) {
    var strict = (arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}).strict;
    if ((0, $aP7UT.isHex)(value, {
        strict: false
    })) return $67747f70c7ce87ca$export$728fe14c970402fe(value, start, end, {
        strict: strict
    });
    return $67747f70c7ce87ca$export$8bac03c8c1da551(value, start, end, {
        strict: strict
    });
}
function $67747f70c7ce87ca$var$assertStartOffset(value, start) {
    if (typeof start === "number" && start > 0 && start > (0, $dfJGH.size)(value) - 1) throw new (0, $bD8YT.SliceOffsetOutOfBoundsError)({
        offset: start,
        position: "start",
        size: (0, $dfJGH.size)(value)
    });
}
function $67747f70c7ce87ca$var$assertEndOffset(value, start, end) {
    if (typeof start === "number" && typeof end === "number" && (0, $dfJGH.size)(value) !== end - start) throw new (0, $bD8YT.SliceOffsetOutOfBoundsError)({
        offset: end,
        position: "end",
        size: (0, $dfJGH.size)(value)
    });
}
function $67747f70c7ce87ca$export$8bac03c8c1da551(value_, start, end) {
    var strict = (arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}).strict;
    $67747f70c7ce87ca$var$assertStartOffset(value_, start);
    var value = value_.slice(start, end);
    if (strict) $67747f70c7ce87ca$var$assertEndOffset(value, start, end);
    return value;
}
function $67747f70c7ce87ca$export$728fe14c970402fe(value_, start, end) {
    var strict = (arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}).strict;
    $67747f70c7ce87ca$var$assertStartOffset(value_, start);
    var value = "0x".concat(value_.replace("0x", "").slice((start !== null && start !== void 0 ? start : 0) * 2, (end !== null && end !== void 0 ? end : value_.length) * 2));
    if (strict) $67747f70c7ce87ca$var$assertEndOffset(value, start, end);
    return value;
}

});
parcelRegister("bD8YT", function(module, exports) {

$parcel$export(module.exports, "SliceOffsetOutOfBoundsError", function () { return $877a4db842f2af3d$export$cfcd41bba8b36dbd; });
$parcel$export(module.exports, "SizeExceedsPaddingSizeError", function () { return $877a4db842f2af3d$export$70445dc308a7f3d5; });
$parcel$export(module.exports, "InvalidBytesLengthError", function () { return $877a4db842f2af3d$export$8a5469becf223114; });

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $7ihh7 = parcelRequire("7ihh7");
var $877a4db842f2af3d$export$cfcd41bba8b36dbd = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(SliceOffsetOutOfBoundsError, BaseError);
    var _super = (0, $ohfOJ._)(SliceOffsetOutOfBoundsError);
    function SliceOffsetOutOfBoundsError(param) {
        var offset = param.offset, position = param.position, size = param.size;
        (0, $4GJKx._)(this, SliceOffsetOutOfBoundsError);
        return _super.call(this, "Slice ".concat(position === "start" ? "starting" : "ending", ' at offset "').concat(offset, '" is out-of-bounds (size: ').concat(size, ")."), {
            name: "SliceOffsetOutOfBoundsError"
        });
    }
    return SliceOffsetOutOfBoundsError;
}((0, $7ihh7.BaseError));
var $877a4db842f2af3d$export$70445dc308a7f3d5 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(SizeExceedsPaddingSizeError, BaseError);
    var _super = (0, $ohfOJ._)(SizeExceedsPaddingSizeError);
    function SizeExceedsPaddingSizeError(param) {
        var size = param.size, targetSize = param.targetSize, type = param.type;
        (0, $4GJKx._)(this, SizeExceedsPaddingSizeError);
        return _super.call(this, "".concat(type.charAt(0).toUpperCase()).concat(type.slice(1).toLowerCase(), " size (").concat(size, ") exceeds padding size (").concat(targetSize, ")."), {
            name: "SizeExceedsPaddingSizeError"
        });
    }
    return SizeExceedsPaddingSizeError;
}((0, $7ihh7.BaseError));
var $877a4db842f2af3d$export$8a5469becf223114 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(InvalidBytesLengthError, BaseError);
    var _super = (0, $ohfOJ._)(InvalidBytesLengthError);
    function InvalidBytesLengthError(param) {
        var size = param.size, targetSize = param.targetSize, type = param.type;
        (0, $4GJKx._)(this, InvalidBytesLengthError);
        return _super.call(this, "".concat(type.charAt(0).toUpperCase()).concat(type.slice(1).toLowerCase(), " is expected to be ").concat(targetSize, " ").concat(type, " long, but is ").concat(size, " ").concat(type, " long."), {
            name: "InvalidBytesLengthError"
        });
    }
    return InvalidBytesLengthError;
}((0, $7ihh7.BaseError));

});


parcelRegister("h023G", function(module, exports) {

$parcel$export(module.exports, "toFunctionSelector", function () { return $c604087cbef44f05$export$e2442488533809cb; });

var $8SGIa = parcelRequire("8SGIa");

var $bg6Lc = parcelRequire("bg6Lc");
var $c604087cbef44f05$export$e2442488533809cb = function(fn) {
    return (0, $8SGIa.slice)((0, $bg6Lc.toSignatureHash)(fn), 0, 4);
};

});
parcelRegister("bg6Lc", function(module, exports) {

$parcel$export(module.exports, "toSignatureHash", function () { return $83266eca53c6b22a$export$d809beebc9c913db; });

var $fu1pO = parcelRequire("fu1pO");

var $jvoK9 = parcelRequire("jvoK9");
function $83266eca53c6b22a$export$d809beebc9c913db(fn) {
    return (0, $fu1pO.hashSignature)((0, $jvoK9.toSignature)(fn));
}

});
parcelRegister("fu1pO", function(module, exports) {

$parcel$export(module.exports, "hashSignature", function () { return $b45ac1675c9bc6b3$export$77bbcd7aaec17976; });

var $g8Qfu = parcelRequire("g8Qfu");

var $h0UKT = parcelRequire("h0UKT");
var $b45ac1675c9bc6b3$var$hash = function(value) {
    return (0, $h0UKT.keccak256)((0, $g8Qfu.toBytes)(value));
};
function $b45ac1675c9bc6b3$export$77bbcd7aaec17976(sig) {
    return $b45ac1675c9bc6b3$var$hash(sig);
}

});
parcelRegister("g8Qfu", function(module, exports) {

$parcel$export(module.exports, "toBytes", function () { return $bc05ec35f889f040$export$30a71edf0753ed6b; });
$parcel$export(module.exports, "hexToBytes", function () { return $bc05ec35f889f040$export$31c96b9df38bc8d4; });
$parcel$export(module.exports, "stringToBytes", function () { return $bc05ec35f889f040$export$c8dd6bc66a63753c; });

var $l0HdX = parcelRequire("l0HdX");

var $7ihh7 = parcelRequire("7ihh7");

var $aP7UT = parcelRequire("aP7UT");

var $b7M07 = parcelRequire("b7M07");

var $itrhm = parcelRequire("itrhm");

var $f3VZN = parcelRequire("f3VZN");
var $bc05ec35f889f040$var$encoder = /*#__PURE__*/ new TextEncoder();
function $bc05ec35f889f040$export$30a71edf0753ed6b(value) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (typeof value === "number" || (typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value)) === "bigint") return $bc05ec35f889f040$export$49ad9be85c347998(value, opts);
    if (typeof value === "boolean") return $bc05ec35f889f040$export$771517697a68241(value, opts);
    if ((0, $aP7UT.isHex)(value)) return $bc05ec35f889f040$export$31c96b9df38bc8d4(value, opts);
    return $bc05ec35f889f040$export$c8dd6bc66a63753c(value, opts);
}
function $bc05ec35f889f040$export$771517697a68241(value) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var bytes = new Uint8Array(1);
    bytes[0] = Number(value);
    if (typeof opts.size === "number") {
        (0, $itrhm.assertSize)(bytes, {
            size: opts.size
        });
        return (0, $b7M07.pad)(bytes, {
            size: opts.size
        });
    }
    return bytes;
}
// We use very optimized technique to convert hex string to byte array
var $bc05ec35f889f040$var$charCodeMap = {
    zero: 48,
    nine: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $bc05ec35f889f040$var$charCodeToBase16(char) {
    if (char >= $bc05ec35f889f040$var$charCodeMap.zero && char <= $bc05ec35f889f040$var$charCodeMap.nine) return char - $bc05ec35f889f040$var$charCodeMap.zero;
    if (char >= $bc05ec35f889f040$var$charCodeMap.A && char <= $bc05ec35f889f040$var$charCodeMap.F) return char - ($bc05ec35f889f040$var$charCodeMap.A - 10);
    if (char >= $bc05ec35f889f040$var$charCodeMap.a && char <= $bc05ec35f889f040$var$charCodeMap.f) return char - ($bc05ec35f889f040$var$charCodeMap.a - 10);
    return undefined;
}
function $bc05ec35f889f040$export$31c96b9df38bc8d4(hex_) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var hex = hex_;
    if (opts.size) {
        (0, $itrhm.assertSize)(hex, {
            size: opts.size
        });
        hex = (0, $b7M07.pad)(hex, {
            dir: "right",
            size: opts.size
        });
    }
    var hexString = hex.slice(2);
    if (hexString.length % 2) hexString = "0".concat(hexString);
    var length = hexString.length / 2;
    var bytes = new Uint8Array(length);
    for(var index = 0, j = 0; index < length; index++){
        var nibbleLeft = $bc05ec35f889f040$var$charCodeToBase16(hexString.charCodeAt(j++));
        var nibbleRight = $bc05ec35f889f040$var$charCodeToBase16(hexString.charCodeAt(j++));
        if (nibbleLeft === undefined || nibbleRight === undefined) throw new (0, $7ihh7.BaseError)('Invalid byte sequence ("'.concat(hexString[j - 2]).concat(hexString[j - 1], '" in "').concat(hexString, '").'));
        bytes[index] = nibbleLeft * 16 + nibbleRight;
    }
    return bytes;
}
function $bc05ec35f889f040$export$49ad9be85c347998(value, opts) {
    var hex = (0, $f3VZN.numberToHex)(value, opts);
    return $bc05ec35f889f040$export$31c96b9df38bc8d4(hex);
}
function $bc05ec35f889f040$export$c8dd6bc66a63753c(value) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var bytes = $bc05ec35f889f040$var$encoder.encode(value);
    if (typeof opts.size === "number") {
        (0, $itrhm.assertSize)(bytes, {
            size: opts.size
        });
        return (0, $b7M07.pad)(bytes, {
            dir: "right",
            size: opts.size
        });
    }
    return bytes;
}

});
parcelRegister("b7M07", function(module, exports) {

$parcel$export(module.exports, "pad", function () { return $819595203e2a2ea5$export$5d04458e2a6c373e; });
$parcel$export(module.exports, "padHex", function () { return $819595203e2a2ea5$export$1bcd51c0fce8ee55; });

var $bD8YT = parcelRequire("bD8YT");
function $819595203e2a2ea5$export$5d04458e2a6c373e(hexOrBytes) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, dir = _ref.dir, _ref_size = _ref.size, size = _ref_size === void 0 ? 32 : _ref_size;
    if (typeof hexOrBytes === "string") return $819595203e2a2ea5$export$1bcd51c0fce8ee55(hexOrBytes, {
        dir: dir,
        size: size
    });
    return $819595203e2a2ea5$export$4c6b868113605df3(hexOrBytes, {
        dir: dir,
        size: size
    });
}
function $819595203e2a2ea5$export$1bcd51c0fce8ee55(hex_) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, dir = _ref.dir, _ref_size = _ref.size, size = _ref_size === void 0 ? 32 : _ref_size;
    if (size === null) return hex_;
    var hex = hex_.replace("0x", "");
    if (hex.length > size * 2) throw new (0, $bD8YT.SizeExceedsPaddingSizeError)({
        size: Math.ceil(hex.length / 2),
        targetSize: size,
        type: "hex"
    });
    return "0x".concat(hex[dir === "right" ? "padEnd" : "padStart"](size * 2, "0"));
}
function $819595203e2a2ea5$export$4c6b868113605df3(bytes) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, dir = _ref.dir, _ref_size = _ref.size, size = _ref_size === void 0 ? 32 : _ref_size;
    if (size === null) return bytes;
    if (bytes.length > size) throw new (0, $bD8YT.SizeExceedsPaddingSizeError)({
        size: bytes.length,
        targetSize: size,
        type: "bytes"
    });
    var paddedBytes = new Uint8Array(size);
    for(var i = 0; i < size; i++){
        var padEnd = dir === "right";
        paddedBytes[padEnd ? i : size - i - 1] = bytes[padEnd ? i : bytes.length - i - 1];
    }
    return paddedBytes;
}

});

parcelRegister("itrhm", function(module, exports) {

$parcel$export(module.exports, "assertSize", function () { return $d730187dbca7ebe4$export$2af489edb7fa35fe; });
$parcel$export(module.exports, "hexToNumber", function () { return $d730187dbca7ebe4$export$d57f2bacc26b4249; });
$parcel$export(module.exports, "hexToBigInt", function () { return $d730187dbca7ebe4$export$92a44656ec81b584; });
$parcel$export(module.exports, "hexToString", function () { return $d730187dbca7ebe4$export$f4bc7e46f3eb3ac3; });

var $8UU42 = parcelRequire("8UU42");

var $dfJGH = parcelRequire("dfJGH");

var $bi3OS = parcelRequire("bi3OS");

var $g8Qfu = parcelRequire("g8Qfu");
function $d730187dbca7ebe4$export$2af489edb7fa35fe(hexOrBytes, param) {
    var size = param.size;
    if ((0, $dfJGH.size)(hexOrBytes) > size) throw new (0, $8UU42.SizeOverflowError)({
        givenSize: (0, $dfJGH.size)(hexOrBytes),
        maxSize: size
    });
}
function $d730187dbca7ebe4$export$1a8ceedbd5845648(hex, toOrOpts) {
    var opts = typeof toOrOpts === "string" ? {
        to: toOrOpts
    } : toOrOpts;
    var to = opts.to;
    if (to === "number") return $d730187dbca7ebe4$export$d57f2bacc26b4249(hex, opts);
    if (to === "bigint") return $d730187dbca7ebe4$export$92a44656ec81b584(hex, opts);
    if (to === "string") return $d730187dbca7ebe4$export$f4bc7e46f3eb3ac3(hex, opts);
    if (to === "boolean") return $d730187dbca7ebe4$export$bde1d77e6fe6c41e(hex, opts);
    return (0, $g8Qfu.hexToBytes)(hex, opts);
}
function $d730187dbca7ebe4$export$92a44656ec81b584(hex) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var signed = opts.signed;
    if (opts.size) $d730187dbca7ebe4$export$2af489edb7fa35fe(hex, {
        size: opts.size
    });
    var value = BigInt(hex);
    if (!signed) return value;
    var size = (hex.length - 2) / 2;
    var max = (1n << BigInt(size) * 8n - 1n) - 1n;
    if (value <= max) return value;
    return value - BigInt("0x".concat("f".padStart(size * 2, "f"))) - 1n;
}
function $d730187dbca7ebe4$export$bde1d77e6fe6c41e(hex_) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var hex = hex_;
    if (opts.size) {
        $d730187dbca7ebe4$export$2af489edb7fa35fe(hex, {
            size: opts.size
        });
        hex = (0, $bi3OS.trim)(hex);
    }
    if ((0, $bi3OS.trim)(hex) === "0x00") return false;
    if ((0, $bi3OS.trim)(hex) === "0x01") return true;
    throw new (0, $8UU42.InvalidHexBooleanError)(hex);
}
function $d730187dbca7ebe4$export$d57f2bacc26b4249(hex) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return Number($d730187dbca7ebe4$export$92a44656ec81b584(hex, opts));
}
function $d730187dbca7ebe4$export$f4bc7e46f3eb3ac3(hex) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var bytes = (0, $g8Qfu.hexToBytes)(hex);
    if (opts.size) {
        $d730187dbca7ebe4$export$2af489edb7fa35fe(bytes, {
            size: opts.size
        });
        bytes = (0, $bi3OS.trim)(bytes, {
            dir: "right"
        });
    }
    return new TextDecoder().decode(bytes);
}

});
parcelRegister("8UU42", function(module, exports) {

$parcel$export(module.exports, "IntegerOutOfRangeError", function () { return $67df0add52f7cf9b$export$47d164a8071229a9; });
$parcel$export(module.exports, "InvalidBytesBooleanError", function () { return $67df0add52f7cf9b$export$52fc62e5266c8838; });
$parcel$export(module.exports, "InvalidHexBooleanError", function () { return $67df0add52f7cf9b$export$f574ac54e35514c; });
$parcel$export(module.exports, "SizeOverflowError", function () { return $67df0add52f7cf9b$export$beb44ed4f8747d0e; });

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $7ihh7 = parcelRequire("7ihh7");
var $67df0add52f7cf9b$export$47d164a8071229a9 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(IntegerOutOfRangeError, BaseError);
    var _super = (0, $ohfOJ._)(IntegerOutOfRangeError);
    function IntegerOutOfRangeError(param) {
        var max = param.max, min = param.min, signed = param.signed, size = param.size, value = param.value;
        (0, $4GJKx._)(this, IntegerOutOfRangeError);
        return _super.call(this, 'Number "'.concat(value, '" is not in safe ').concat(size ? "".concat(size * 8, "-bit ").concat(signed ? "signed" : "unsigned", " ") : "", "integer range ").concat(max ? "(".concat(min, " to ").concat(max, ")") : "(above ".concat(min, ")")), {
            name: "IntegerOutOfRangeError"
        });
    }
    return IntegerOutOfRangeError;
}((0, $7ihh7.BaseError));
var $67df0add52f7cf9b$export$52fc62e5266c8838 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(InvalidBytesBooleanError, BaseError);
    var _super = (0, $ohfOJ._)(InvalidBytesBooleanError);
    function InvalidBytesBooleanError(bytes) {
        (0, $4GJKx._)(this, InvalidBytesBooleanError);
        return _super.call(this, 'Bytes value "'.concat(bytes, '" is not a valid boolean. The bytes array must contain a single byte of either a 0 or 1 value.'), {
            name: "InvalidBytesBooleanError"
        });
    }
    return InvalidBytesBooleanError;
}((0, $7ihh7.BaseError));
var $67df0add52f7cf9b$export$f574ac54e35514c = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(InvalidHexBooleanError, BaseError);
    var _super = (0, $ohfOJ._)(InvalidHexBooleanError);
    function InvalidHexBooleanError(hex) {
        (0, $4GJKx._)(this, InvalidHexBooleanError);
        return _super.call(this, 'Hex value "'.concat(hex, '" is not a valid boolean. The hex value must be "0x0" (false) or "0x1" (true).'), {
            name: "InvalidHexBooleanError"
        });
    }
    return InvalidHexBooleanError;
}((0, $7ihh7.BaseError));
var $67df0add52f7cf9b$export$ef05eafd11dd4a83 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(InvalidHexValueError, BaseError);
    var _super = (0, $ohfOJ._)(InvalidHexValueError);
    function InvalidHexValueError(value) {
        (0, $4GJKx._)(this, InvalidHexValueError);
        return _super.call(this, 'Hex value "'.concat(value, '" is an odd length (').concat(value.length, "). It must be an even length."), {
            name: "InvalidHexValueError"
        });
    }
    return InvalidHexValueError;
}((0, $7ihh7.BaseError));
var $67df0add52f7cf9b$export$beb44ed4f8747d0e = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(SizeOverflowError, BaseError);
    var _super = (0, $ohfOJ._)(SizeOverflowError);
    function SizeOverflowError(param) {
        var givenSize = param.givenSize, maxSize = param.maxSize;
        (0, $4GJKx._)(this, SizeOverflowError);
        return _super.call(this, "Size cannot exceed ".concat(maxSize, " bytes. Given size: ").concat(givenSize, " bytes."), {
            name: "SizeOverflowError"
        });
    }
    return SizeOverflowError;
}((0, $7ihh7.BaseError));

});

parcelRegister("bi3OS", function(module, exports) {

$parcel$export(module.exports, "trim", function () { return $8384569e348b458e$export$87c2784dc9fc4ab; });
function $8384569e348b458e$export$87c2784dc9fc4ab(hexOrBytes) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_dir = _ref.dir, dir = _ref_dir === void 0 ? "left" : _ref_dir;
    var data = typeof hexOrBytes === "string" ? hexOrBytes.replace("0x", "") : hexOrBytes;
    var sliceLength = 0;
    for(var i = 0; i < data.length - 1; i++){
        if (data[dir === "left" ? i : data.length - i - 1].toString() === "0") sliceLength++;
        else break;
    }
    data = dir === "left" ? data.slice(sliceLength) : data.slice(0, data.length - sliceLength);
    if (typeof hexOrBytes === "string") {
        if (data.length === 1 && dir === "right") data = "".concat(data, "0");
        return "0x".concat(data.length % 2 === 1 ? "0".concat(data) : data);
    }
    return data;
}

});


parcelRegister("f3VZN", function(module, exports) {

$parcel$export(module.exports, "toHex", function () { return $af741f97eee270d2$export$7ea66e3774a60b67; });
$parcel$export(module.exports, "numberToHex", function () { return $af741f97eee270d2$export$4e87185b7ecfeec4; });
$parcel$export(module.exports, "stringToHex", function () { return $af741f97eee270d2$export$551c48dea6f88e6d; });
$parcel$export(module.exports, "boolToHex", function () { return $af741f97eee270d2$export$b5c95dec4f62ef7a; });
$parcel$export(module.exports, "bytesToHex", function () { return $af741f97eee270d2$export$58b867e287a802c8; });

var $l0HdX = parcelRequire("l0HdX");

var $8UU42 = parcelRequire("8UU42");

var $b7M07 = parcelRequire("b7M07");

var $itrhm = parcelRequire("itrhm");
var $af741f97eee270d2$var$hexes = /*#__PURE__*/ Array.from({
    length: 256
}, function(_v, i) {
    return i.toString(16).padStart(2, "0");
});
function $af741f97eee270d2$export$7ea66e3774a60b67(value) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (typeof value === "number" || (typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value)) === "bigint") return $af741f97eee270d2$export$4e87185b7ecfeec4(value, opts);
    if (typeof value === "string") return $af741f97eee270d2$export$551c48dea6f88e6d(value, opts);
    if (typeof value === "boolean") return $af741f97eee270d2$export$b5c95dec4f62ef7a(value, opts);
    return $af741f97eee270d2$export$58b867e287a802c8(value, opts);
}
function $af741f97eee270d2$export$b5c95dec4f62ef7a(value) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var hex = "0x".concat(Number(value));
    if (typeof opts.size === "number") {
        (0, $itrhm.assertSize)(hex, {
            size: opts.size
        });
        return (0, $b7M07.pad)(hex, {
            size: opts.size
        });
    }
    return hex;
}
function $af741f97eee270d2$export$58b867e287a802c8(value) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var string = "";
    for(var i = 0; i < value.length; i++)string += $af741f97eee270d2$var$hexes[value[i]];
    var hex = "0x".concat(string);
    if (typeof opts.size === "number") {
        (0, $itrhm.assertSize)(hex, {
            size: opts.size
        });
        return (0, $b7M07.pad)(hex, {
            dir: "right",
            size: opts.size
        });
    }
    return hex;
}
function $af741f97eee270d2$export$4e87185b7ecfeec4(value_) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var signed = opts.signed, size = opts.size;
    var value = BigInt(value_);
    var maxValue;
    if (size) {
        if (signed) maxValue = (1n << BigInt(size) * 8n - 1n) - 1n;
        else maxValue = Math.pow(2n, BigInt(size) * 8n) - 1n;
    } else if (typeof value_ === "number") maxValue = BigInt(Number.MAX_SAFE_INTEGER);
    var minValue = (typeof maxValue === "undefined" ? "undefined" : (0, $l0HdX._)(maxValue)) === "bigint" && signed ? -maxValue - 1n : 0;
    if (maxValue && value > maxValue || value < minValue) {
        var suffix = (typeof value_ === "undefined" ? "undefined" : (0, $l0HdX._)(value_)) === "bigint" ? "n" : "";
        throw new (0, $8UU42.IntegerOutOfRangeError)({
            max: maxValue ? "".concat(maxValue).concat(suffix) : undefined,
            min: "".concat(minValue).concat(suffix),
            signed: signed,
            size: size,
            value: "".concat(value_).concat(suffix)
        });
    }
    var hex = "0x".concat((signed && value < 0 ? (1n << BigInt(size * 8)) + BigInt(value) : value).toString(16));
    if (size) return (0, $b7M07.pad)(hex, {
        size: size
    });
    return hex;
}
var $af741f97eee270d2$var$encoder = /*#__PURE__*/ new TextEncoder();
function $af741f97eee270d2$export$551c48dea6f88e6d(value_) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var value = $af741f97eee270d2$var$encoder.encode(value_);
    return $af741f97eee270d2$export$58b867e287a802c8(value, opts);
}

});


parcelRegister("h0UKT", function(module, exports) {

$parcel$export(module.exports, "keccak256", function () { return $c62e76314f39c9cd$export$f8151fce47ad1c35; });

var $jlkmN = parcelRequire("jlkmN");

var $aP7UT = parcelRequire("aP7UT");

var $g8Qfu = parcelRequire("g8Qfu");

var $f3VZN = parcelRequire("f3VZN");
function $c62e76314f39c9cd$export$f8151fce47ad1c35(value, to_) {
    var to = to_ || "hex";
    var bytes = (0, $jlkmN.keccak_256)((0, $aP7UT.isHex)(value, {
        strict: false
    }) ? (0, $g8Qfu.toBytes)(value) : value);
    if (to === "bytes") return bytes;
    return (0, $f3VZN.toHex)(bytes);
}

});
parcelRegister("jlkmN", function(module, exports) {

$parcel$export(module.exports, "keccak_256", function () { return $e14fc6e1ac5dce23$export$860ddaa9ca84a66d; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $cv9Rk = parcelRequire("cv9Rk");

var $ohfOJ = parcelRequire("ohfOJ");

var $Vu6Hx = parcelRequire("Vu6Hx");

var $Fis3O = parcelRequire("Fis3O");

var $8ybNC = parcelRequire("8ybNC");
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
var $e14fc6e1ac5dce23$var$SHA3_PI = [];
var $e14fc6e1ac5dce23$var$SHA3_ROTL = [];
var $e14fc6e1ac5dce23$var$_SHA3_IOTA = [];
var $e14fc6e1ac5dce23$var$_0n = /* @__PURE__ */ BigInt(0);
var $e14fc6e1ac5dce23$var$_1n = /* @__PURE__ */ BigInt(1);
var $e14fc6e1ac5dce23$var$_2n = /* @__PURE__ */ BigInt(2);
var $e14fc6e1ac5dce23$var$_7n = /* @__PURE__ */ BigInt(7);
var $e14fc6e1ac5dce23$var$_256n = /* @__PURE__ */ BigInt(256);
var $e14fc6e1ac5dce23$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(var $e14fc6e1ac5dce23$var$round = 0, $e14fc6e1ac5dce23$var$R = $e14fc6e1ac5dce23$var$_1n, $e14fc6e1ac5dce23$var$x = 1, $e14fc6e1ac5dce23$var$y = 0; $e14fc6e1ac5dce23$var$round < 24; $e14fc6e1ac5dce23$var$round++){
    var $e14fc6e1ac5dce23$var$ref;
    // Pi
    $e14fc6e1ac5dce23$var$ref = [
        $e14fc6e1ac5dce23$var$y,
        (2 * $e14fc6e1ac5dce23$var$x + 3 * $e14fc6e1ac5dce23$var$y) % 5
    ], $e14fc6e1ac5dce23$var$x = $e14fc6e1ac5dce23$var$ref[0], $e14fc6e1ac5dce23$var$y = $e14fc6e1ac5dce23$var$ref[1], $e14fc6e1ac5dce23$var$ref;
    $e14fc6e1ac5dce23$var$SHA3_PI.push(2 * (5 * $e14fc6e1ac5dce23$var$y + $e14fc6e1ac5dce23$var$x));
    // Rotational
    $e14fc6e1ac5dce23$var$SHA3_ROTL.push(($e14fc6e1ac5dce23$var$round + 1) * ($e14fc6e1ac5dce23$var$round + 2) / 2 % 64);
    // Iota
    var $e14fc6e1ac5dce23$var$t = $e14fc6e1ac5dce23$var$_0n;
    for(var $e14fc6e1ac5dce23$var$j = 0; $e14fc6e1ac5dce23$var$j < 7; $e14fc6e1ac5dce23$var$j++){
        $e14fc6e1ac5dce23$var$R = ($e14fc6e1ac5dce23$var$R << $e14fc6e1ac5dce23$var$_1n ^ ($e14fc6e1ac5dce23$var$R >> $e14fc6e1ac5dce23$var$_7n) * $e14fc6e1ac5dce23$var$_0x71n) % $e14fc6e1ac5dce23$var$_256n;
        if ($e14fc6e1ac5dce23$var$R & $e14fc6e1ac5dce23$var$_2n) $e14fc6e1ac5dce23$var$t ^= $e14fc6e1ac5dce23$var$_1n << ($e14fc6e1ac5dce23$var$_1n << /* @__PURE__ */ BigInt($e14fc6e1ac5dce23$var$j)) - $e14fc6e1ac5dce23$var$_1n;
    }
    $e14fc6e1ac5dce23$var$_SHA3_IOTA.push($e14fc6e1ac5dce23$var$t);
}
var /* @__PURE__ */ $e14fc6e1ac5dce23$var$_split = (0, $cv9Rk._)((0, $Fis3O.split)($e14fc6e1ac5dce23$var$_SHA3_IOTA, true), 2), $e14fc6e1ac5dce23$var$SHA3_IOTA_H = $e14fc6e1ac5dce23$var$_split[0], $e14fc6e1ac5dce23$var$SHA3_IOTA_L = $e14fc6e1ac5dce23$var$_split[1];
// Left rotation (without 0, 32, 64)
var $e14fc6e1ac5dce23$var$rotlH = function(h, l, s) {
    return s > 32 ? (0, $Fis3O.rotlBH)(h, l, s) : (0, $Fis3O.rotlSH)(h, l, s);
};
var $e14fc6e1ac5dce23$var$rotlL = function(h, l, s) {
    return s > 32 ? (0, $Fis3O.rotlBL)(h, l, s) : (0, $Fis3O.rotlSL)(h, l, s);
};
function $e14fc6e1ac5dce23$export$1bcd3d5a58ba6fb0(s) {
    var rounds = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 24;
    var B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(var round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(var x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(var x1 = 0; x1 < 10; x1 += 2){
            var idx1 = (x1 + 8) % 10;
            var idx0 = (x1 + 2) % 10;
            var B0 = B[idx0];
            var B1 = B[idx0 + 1];
            var Th = $e14fc6e1ac5dce23$var$rotlH(B0, B1, 1) ^ B[idx1];
            var Tl = $e14fc6e1ac5dce23$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(var y = 0; y < 50; y += 10){
                s[x1 + y] ^= Th;
                s[x1 + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        var curH = s[2];
        var curL = s[3];
        for(var t = 0; t < 24; t++){
            var shift = $e14fc6e1ac5dce23$var$SHA3_ROTL[t];
            var Th1 = $e14fc6e1ac5dce23$var$rotlH(curH, curL, shift);
            var Tl1 = $e14fc6e1ac5dce23$var$rotlL(curH, curL, shift);
            var PI = $e14fc6e1ac5dce23$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th1;
            s[PI + 1] = Tl1;
        }
        // Chi (χ)
        for(var y1 = 0; y1 < 50; y1 += 10){
            for(var x2 = 0; x2 < 10; x2++)B[x2] = s[y1 + x2];
            for(var x3 = 0; x3 < 10; x3++)s[y1 + x3] ^= ~B[(x3 + 2) % 10] & B[(x3 + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $e14fc6e1ac5dce23$var$SHA3_IOTA_H[round];
        s[1] ^= $e14fc6e1ac5dce23$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
var $e14fc6e1ac5dce23$export$f7374b8b4498bc2e = /*#__PURE__*/ function(Hash) {
    "use strict";
    (0, $dcsZi._)(Keccak, Hash);
    var _super = (0, $ohfOJ._)(Keccak);
    function Keccak(blockLen, suffix, outputLen) {
        var enableXOF = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, rounds = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 24;
        (0, $4GJKx._)(this, Keccak);
        var _this;
        _this = _super.call(this);
        _this.blockLen = blockLen;
        _this.suffix = suffix;
        _this.outputLen = outputLen;
        _this.enableXOF = enableXOF;
        _this.rounds = rounds;
        _this.pos = 0;
        _this.posOut = 0;
        _this.finished = false;
        _this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $Vu6Hx.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= _this.blockLen || _this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        _this.state = new Uint8Array(200);
        _this.state32 = (0, $8ybNC.u32)(_this.state);
        return _this;
    }
    (0, $1wc17._)(Keccak, [
        {
            key: "keccak",
            value: function keccak() {
                if (!(0, $8ybNC.isLE)) (0, $8ybNC.byteSwap32)(this.state32);
                $e14fc6e1ac5dce23$export$1bcd3d5a58ba6fb0(this.state32, this.rounds);
                if (!(0, $8ybNC.isLE)) (0, $8ybNC.byteSwap32)(this.state32);
                this.posOut = 0;
                this.pos = 0;
            }
        },
        {
            key: "update",
            value: function update(data) {
                (0, $Vu6Hx.exists)(this);
                var _this = this, blockLen = _this.blockLen, state = _this.state;
                data = (0, $8ybNC.toBytes)(data);
                var len = data.length;
                for(var pos = 0; pos < len;){
                    var take = Math.min(blockLen - this.pos, len - pos);
                    for(var i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
                    if (this.pos === blockLen) this.keccak();
                }
                return this;
            }
        },
        {
            key: "finish",
            value: function finish() {
                if (this.finished) return;
                this.finished = true;
                var _this = this, state = _this.state, suffix = _this.suffix, pos = _this.pos, blockLen = _this.blockLen;
                // Do the padding
                state[pos] ^= suffix;
                if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
                state[blockLen - 1] ^= 0x80;
                this.keccak();
            }
        },
        {
            key: "writeInto",
            value: function writeInto(out) {
                (0, $Vu6Hx.exists)(this, false);
                (0, $Vu6Hx.bytes)(out);
                this.finish();
                var bufferOut = this.state;
                var blockLen = this.blockLen;
                for(var pos = 0, len = out.length; pos < len;){
                    if (this.posOut >= blockLen) this.keccak();
                    var take = Math.min(blockLen - this.posOut, len - pos);
                    out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
                    this.posOut += take;
                    pos += take;
                }
                return out;
            }
        },
        {
            key: "xofInto",
            value: function xofInto(out) {
                // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
                if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
                return this.writeInto(out);
            }
        },
        {
            key: "xof",
            value: function xof(bytes) {
                (0, $Vu6Hx.number)(bytes);
                return this.xofInto(new Uint8Array(bytes));
            }
        },
        {
            key: "digestInto",
            value: function digestInto(out) {
                (0, $Vu6Hx.output)(out, this);
                if (this.finished) throw new Error("digest() was already called");
                this.writeInto(out);
                this.destroy();
                return out;
            }
        },
        {
            key: "digest",
            value: function digest() {
                return this.digestInto(new Uint8Array(this.outputLen));
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.destroyed = true;
                this.state.fill(0);
            }
        },
        {
            key: "_cloneInto",
            value: function _cloneInto(to) {
                var _this = this, blockLen = _this.blockLen, suffix = _this.suffix, outputLen = _this.outputLen, rounds = _this.rounds, enableXOF = _this.enableXOF;
                to || (to = new Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
                to.state32.set(this.state32);
                to.pos = this.pos;
                to.posOut = this.posOut;
                to.finished = this.finished;
                to.rounds = rounds;
                // Suffix can change in cSHAKE
                to.suffix = suffix;
                to.outputLen = outputLen;
                to.enableXOF = enableXOF;
                to.destroyed = this.destroyed;
                return to;
            }
        }
    ]);
    return Keccak;
}((0, $8ybNC.Hash));
var $e14fc6e1ac5dce23$var$gen = function(suffix, blockLen, outputLen) {
    return (0, $8ybNC.wrapConstructor)(function() {
        return new $e14fc6e1ac5dce23$export$f7374b8b4498bc2e(blockLen, suffix, outputLen);
    });
};
var $e14fc6e1ac5dce23$export$fe6c2b96a79338e9 = /* @__PURE__ */ $e14fc6e1ac5dce23$var$gen(0x06, 144, 28);
var $e14fc6e1ac5dce23$export$76e19b6966813b14 = /* @__PURE__ */ $e14fc6e1ac5dce23$var$gen(0x06, 136, 32);
var $e14fc6e1ac5dce23$export$a58509fa80f30d15 = /* @__PURE__ */ $e14fc6e1ac5dce23$var$gen(0x06, 104, 48);
var $e14fc6e1ac5dce23$export$20ed324dbdf09b7c = /* @__PURE__ */ $e14fc6e1ac5dce23$var$gen(0x06, 72, 64);
var $e14fc6e1ac5dce23$export$2f7fb3c6fac246bc = /* @__PURE__ */ $e14fc6e1ac5dce23$var$gen(0x01, 144, 28);
var $e14fc6e1ac5dce23$export$860ddaa9ca84a66d = /* @__PURE__ */ $e14fc6e1ac5dce23$var$gen(0x01, 136, 32);
var $e14fc6e1ac5dce23$export$46fcdeb4c5686552 = /* @__PURE__ */ $e14fc6e1ac5dce23$var$gen(0x01, 104, 48);
var $e14fc6e1ac5dce23$export$aec1ddaf6c1ba495 = /* @__PURE__ */ $e14fc6e1ac5dce23$var$gen(0x01, 72, 64);
var $e14fc6e1ac5dce23$var$genShake = function(suffix, blockLen, outputLen) {
    return (0, $8ybNC.wrapXOFConstructorWithOpts)(function() {
        var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return new $e14fc6e1ac5dce23$export$f7374b8b4498bc2e(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true);
    });
};
var $e14fc6e1ac5dce23$export$f43dc3bb86efbba2 = /* @__PURE__ */ $e14fc6e1ac5dce23$var$genShake(0x1f, 168, 16);
var $e14fc6e1ac5dce23$export$c240d011f1520440 = /* @__PURE__ */ $e14fc6e1ac5dce23$var$genShake(0x1f, 136, 32);

});
parcelRegister("Vu6Hx", function(module, exports) {

$parcel$export(module.exports, "number", function () { return $0accada028dd2121$export$98e628dec113755e; });
$parcel$export(module.exports, "bytes", function () { return $0accada028dd2121$export$b3317979f9250576; });
$parcel$export(module.exports, "hash", function () { return $0accada028dd2121$export$d6af199866bfb566; });
$parcel$export(module.exports, "exists", function () { return $0accada028dd2121$export$f7e9f41ea797a17; });
$parcel$export(module.exports, "output", function () { return $0accada028dd2121$export$c789db2c85949867; });
function $0accada028dd2121$export$98e628dec113755e(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error("positive integer expected, not ".concat(n));
}
function $0accada028dd2121$export$87b259aa03e3d267(b) {
    if (typeof b !== "boolean") throw new Error("boolean expected, not ".concat(b));
}
function $0accada028dd2121$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
function $0accada028dd2121$export$b3317979f9250576(b) {
    for(var _len = arguments.length, lengths = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        lengths[_key - 1] = arguments[_key];
    }
    if (!$0accada028dd2121$export$c6fabfbfd097fc30(b)) throw new Error("Uint8Array expected");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error("Uint8Array expected of length ".concat(lengths, ", not of length=").concat(b.length));
}
function $0accada028dd2121$export$d6af199866bfb566(h) {
    if (typeof h !== "function" || typeof h.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $0accada028dd2121$export$98e628dec113755e(h.outputLen);
    $0accada028dd2121$export$98e628dec113755e(h.blockLen);
}
function $0accada028dd2121$export$f7e9f41ea797a17(instance) {
    var checkFinished = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
function $0accada028dd2121$export$c789db2c85949867(out, instance) {
    $0accada028dd2121$export$b3317979f9250576(out);
    var min = instance.outputLen;
    if (out.length < min) throw new Error("digestInto() expects output buffer of length at least ".concat(min));
}
var $0accada028dd2121$var$assert = {
    number: $0accada028dd2121$export$98e628dec113755e,
    bool: $0accada028dd2121$export$87b259aa03e3d267,
    bytes: $0accada028dd2121$export$b3317979f9250576,
    hash: $0accada028dd2121$export$d6af199866bfb566,
    exists: $0accada028dd2121$export$f7e9f41ea797a17,
    output: $0accada028dd2121$export$c789db2c85949867
};
var $0accada028dd2121$export$2e2bcd8739ae039 = $0accada028dd2121$var$assert;

});

parcelRegister("Fis3O", function(module, exports) {

$parcel$export(module.exports, "split", function () { return $07c2248d24f950e6$export$65980d18b75784e2; });
$parcel$export(module.exports, "rotlSH", function () { return $07c2248d24f950e6$export$4b80a2917447870e; });
$parcel$export(module.exports, "rotlSL", function () { return $07c2248d24f950e6$export$20652918a7b63b3; });
$parcel$export(module.exports, "rotlBH", function () { return $07c2248d24f950e6$export$a52f14bf902f9977; });
$parcel$export(module.exports, "rotlBL", function () { return $07c2248d24f950e6$export$5d12cc1da441323f; });
$parcel$export(module.exports, "default", function () { return $07c2248d24f950e6$export$2e2bcd8739ae039; });
var $07c2248d24f950e6$var$U32_MASK64 = /* @__PURE__ */ BigInt(Math.pow(2, 32) - 1);
var $07c2248d24f950e6$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $07c2248d24f950e6$export$9625d4333cb56c3f(n) {
    var le = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (le) return {
        h: Number(n & $07c2248d24f950e6$var$U32_MASK64),
        l: Number(n >> $07c2248d24f950e6$var$_32n & $07c2248d24f950e6$var$U32_MASK64)
    };
    return {
        h: Number(n >> $07c2248d24f950e6$var$_32n & $07c2248d24f950e6$var$U32_MASK64) | 0,
        l: Number(n & $07c2248d24f950e6$var$U32_MASK64) | 0
    };
}
function $07c2248d24f950e6$export$65980d18b75784e2(lst) {
    var le = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var Ah = new Uint32Array(lst.length);
    var Al = new Uint32Array(lst.length);
    for(var i = 0; i < lst.length; i++){
        var _fromBig = $07c2248d24f950e6$export$9625d4333cb56c3f(lst[i], le), h = _fromBig.h, l = _fromBig.l;
        var ref;
        ref = [
            h,
            l
        ], Ah[i] = ref[0], Al[i] = ref[1], ref;
    }
    return [
        Ah,
        Al
    ];
}
var $07c2248d24f950e6$export$30f78adcaaa2eb7 = function(h, l) {
    return BigInt(h >>> 0) << $07c2248d24f950e6$var$_32n | BigInt(l >>> 0);
};
// for Shift in [0, 32)
var $07c2248d24f950e6$export$75aa78dc5bd52853 = function(h, _l, s) {
    return h >>> s;
};
var $07c2248d24f950e6$export$a0225ff0aee14e25 = function(h, l, s) {
    return h << 32 - s | l >>> s;
};
// Right rotate for Shift in [1, 32)
var $07c2248d24f950e6$export$97f812dfd830ca87 = function(h, l, s) {
    return h >>> s | l << 32 - s;
};
var $07c2248d24f950e6$export$60987e30e2c9d9d = function(h, l, s) {
    return h << 32 - s | l >>> s;
};
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
var $07c2248d24f950e6$export$af9c7fbac44dcb76 = function(h, l, s) {
    return h << 64 - s | l >>> s - 32;
};
var $07c2248d24f950e6$export$f619171d6d5ac414 = function(h, l, s) {
    return h >>> s - 32 | l << 64 - s;
};
// Right rotate for shift===32 (just swaps l&h)
var $07c2248d24f950e6$export$a088d44bd387d2a3 = function(_h, l) {
    return l;
};
var $07c2248d24f950e6$export$8415aae4d1f69577 = function(h, _l) {
    return h;
};
// Left rotate for Shift in [1, 32)
var $07c2248d24f950e6$export$4b80a2917447870e = function(h, l, s) {
    return h << s | l >>> 32 - s;
};
var $07c2248d24f950e6$export$20652918a7b63b3 = function(h, l, s) {
    return l << s | h >>> 32 - s;
};
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
var $07c2248d24f950e6$export$a52f14bf902f9977 = function(h, l, s) {
    return l << s - 32 | h >>> 64 - s;
};
var $07c2248d24f950e6$export$5d12cc1da441323f = function(h, l, s) {
    return h << s - 32 | l >>> 64 - s;
};
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $07c2248d24f950e6$export$e16d8520af44a096(Ah, Al, Bh, Bl) {
    var l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / Math.pow(2, 32) | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
var $07c2248d24f950e6$export$c0c22b91f08911f = function(Al, Bl, Cl) {
    return (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
};
var $07c2248d24f950e6$export$ef7b26044977a8ec = function(low, Ah, Bh, Ch) {
    return Ah + Bh + Ch + (low / Math.pow(2, 32) | 0) | 0;
};
var $07c2248d24f950e6$export$2f4e199c560f545d = function(Al, Bl, Cl, Dl) {
    return (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
};
var $07c2248d24f950e6$export$e909220d675a7741 = function(low, Ah, Bh, Ch, Dh) {
    return Ah + Bh + Ch + Dh + (low / Math.pow(2, 32) | 0) | 0;
};
var $07c2248d24f950e6$export$d732b061fe9c9ae4 = function(Al, Bl, Cl, Dl, El) {
    return (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
};
var $07c2248d24f950e6$export$b45ee8d78c965098 = function(low, Ah, Bh, Ch, Dh, Eh) {
    return Ah + Bh + Ch + Dh + Eh + (low / Math.pow(2, 32) | 0) | 0;
};
// prettier-ignore
var $07c2248d24f950e6$var$u64 = {
    fromBig: $07c2248d24f950e6$export$9625d4333cb56c3f,
    split: $07c2248d24f950e6$export$65980d18b75784e2,
    toBig: $07c2248d24f950e6$export$30f78adcaaa2eb7,
    shrSH: $07c2248d24f950e6$export$75aa78dc5bd52853,
    shrSL: $07c2248d24f950e6$export$a0225ff0aee14e25,
    rotrSH: $07c2248d24f950e6$export$97f812dfd830ca87,
    rotrSL: $07c2248d24f950e6$export$60987e30e2c9d9d,
    rotrBH: $07c2248d24f950e6$export$af9c7fbac44dcb76,
    rotrBL: $07c2248d24f950e6$export$f619171d6d5ac414,
    rotr32H: $07c2248d24f950e6$export$a088d44bd387d2a3,
    rotr32L: $07c2248d24f950e6$export$8415aae4d1f69577,
    rotlSH: $07c2248d24f950e6$export$4b80a2917447870e,
    rotlSL: $07c2248d24f950e6$export$20652918a7b63b3,
    rotlBH: $07c2248d24f950e6$export$a52f14bf902f9977,
    rotlBL: $07c2248d24f950e6$export$5d12cc1da441323f,
    add: $07c2248d24f950e6$export$e16d8520af44a096,
    add3L: $07c2248d24f950e6$export$c0c22b91f08911f,
    add3H: $07c2248d24f950e6$export$ef7b26044977a8ec,
    add4L: $07c2248d24f950e6$export$2f4e199c560f545d,
    add4H: $07c2248d24f950e6$export$e909220d675a7741,
    add5H: $07c2248d24f950e6$export$b45ee8d78c965098,
    add5L: $07c2248d24f950e6$export$d732b061fe9c9ae4
};
var $07c2248d24f950e6$export$2e2bcd8739ae039 = $07c2248d24f950e6$var$u64;

});

parcelRegister("8ybNC", function(module, exports) {

$parcel$export(module.exports, "u32", function () { return $639aa6ce9c860f35$export$8bacf4ad828c7fe7; });
$parcel$export(module.exports, "createView", function () { return $639aa6ce9c860f35$export$d7febe7b891e79f0; });
$parcel$export(module.exports, "rotr", function () { return $639aa6ce9c860f35$export$466993d7d0d272aa; });
$parcel$export(module.exports, "isLE", function () { return $639aa6ce9c860f35$export$a0f88e38d4cf9577; });
$parcel$export(module.exports, "byteSwap32", function () { return $639aa6ce9c860f35$export$97b40fc37f25d711; });
$parcel$export(module.exports, "utf8ToBytes", function () { return $639aa6ce9c860f35$export$3df70a15530b5e81; });
$parcel$export(module.exports, "toBytes", function () { return $639aa6ce9c860f35$export$30a71edf0753ed6b; });
$parcel$export(module.exports, "concatBytes", function () { return $639aa6ce9c860f35$export$287dd7971339c972; });
$parcel$export(module.exports, "Hash", function () { return $639aa6ce9c860f35$export$ab85ecd77ce6a5cd; });
$parcel$export(module.exports, "wrapConstructor", function () { return $639aa6ce9c860f35$export$f081816339df1972; });
$parcel$export(module.exports, "wrapXOFConstructorWithOpts", function () { return $639aa6ce9c860f35$export$e18964dbd6e083c1; });
$parcel$export(module.exports, "randomBytes", function () { return $639aa6ce9c860f35$export$5f828d93ff035aa8; });
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $l0HdX = parcelRequire("l0HdX");

var $eha6O = parcelRequire("eha6O");

var $eZSu4 = parcelRequire("eZSu4");

var $Vu6Hx = parcelRequire("Vu6Hx");
function $639aa6ce9c860f35$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
var $639aa6ce9c860f35$export$9813fca58c0b9f71 = function(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
};
var $639aa6ce9c860f35$export$8bacf4ad828c7fe7 = function(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
};
var $639aa6ce9c860f35$export$d7febe7b891e79f0 = function(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
};
var $639aa6ce9c860f35$export$466993d7d0d272aa = function(word, shift) {
    return word << 32 - shift | word >>> shift;
};
var $639aa6ce9c860f35$export$ac5e39599698b562 = function(word, shift) {
    return word << shift | word >>> 32 - shift >>> 0;
};
var $639aa6ce9c860f35$export$a0f88e38d4cf9577 = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
var $639aa6ce9c860f35$export$a4170f7f8be47425 = function(word) {
    return word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
};
var $639aa6ce9c860f35$export$4a0a88cc2d284e7f = $639aa6ce9c860f35$export$a0f88e38d4cf9577 ? function(n) {
    return n;
} : function(n) {
    return $639aa6ce9c860f35$export$a4170f7f8be47425(n);
};
function $639aa6ce9c860f35$export$97b40fc37f25d711(arr) {
    for(var i = 0; i < arr.length; i++)arr[i] = $639aa6ce9c860f35$export$a4170f7f8be47425(arr[i]);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
var $639aa6ce9c860f35$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, function(_, i) {
    return i.toString(16).padStart(2, "0");
});
function $639aa6ce9c860f35$export$58b867e287a802c8(bytes) {
    (0, $Vu6Hx.bytes)(bytes);
    // pre-caching improves the speed 6x
    var hex = "";
    for(var i = 0; i < bytes.length; i++)hex += $639aa6ce9c860f35$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
var $639aa6ce9c860f35$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $639aa6ce9c860f35$var$asciiToBase16(char) {
    if (char >= $639aa6ce9c860f35$var$asciis._0 && char <= $639aa6ce9c860f35$var$asciis._9) return char - $639aa6ce9c860f35$var$asciis._0;
    if (char >= $639aa6ce9c860f35$var$asciis._A && char <= $639aa6ce9c860f35$var$asciis._F) return char - ($639aa6ce9c860f35$var$asciis._A - 10);
    if (char >= $639aa6ce9c860f35$var$asciis._a && char <= $639aa6ce9c860f35$var$asciis._f) return char - ($639aa6ce9c860f35$var$asciis._a - 10);
    return;
}
function $639aa6ce9c860f35$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + (typeof hex === "undefined" ? "undefined" : (0, $l0HdX._)(hex)));
    var hl = hex.length;
    var al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    var array = new Uint8Array(al);
    for(var ai = 0, hi = 0; ai < al; ai++, hi += 2){
        var n1 = $639aa6ce9c860f35$var$asciiToBase16(hex.charCodeAt(hi));
        var n2 = $639aa6ce9c860f35$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            var char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
var $639aa6ce9c860f35$export$bdd553fddd433dcb = function() {
    var _ref = (0, $kSuI9._)(function() {
        return (0, $eha6O.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    });
    return function nextTick() {
        return _ref.apply(this, arguments);
    };
}();
function $639aa6ce9c860f35$export$57207d71b8c929c8(iters, tick, cb) {
    return $639aa6ce9c860f35$var$_asyncLoop.apply(this, arguments);
}
function $639aa6ce9c860f35$var$_asyncLoop() {
    $639aa6ce9c860f35$var$_asyncLoop = (0, $kSuI9._)(function(iters, tick, cb) {
        var ts, i, diff;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ts = Date.now();
                    i = 0;
                    _state.label = 1;
                case 1:
                    if (!(i < iters)) return [
                        3,
                        4
                    ];
                    cb(i);
                    // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
                    diff = Date.now() - ts;
                    if (diff >= 0 && diff < tick) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        $639aa6ce9c860f35$export$bdd553fddd433dcb()
                    ];
                case 2:
                    _state.sent();
                    ts += diff;
                    _state.label = 3;
                case 3:
                    i++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $639aa6ce9c860f35$var$_asyncLoop.apply(this, arguments);
}
function $639aa6ce9c860f35$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error("utf8ToBytes expected string, got ".concat(typeof str === "undefined" ? "undefined" : (0, $l0HdX._)(str)));
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $639aa6ce9c860f35$export$30a71edf0753ed6b(data) {
    if (typeof data === "string") data = $639aa6ce9c860f35$export$3df70a15530b5e81(data);
    (0, $Vu6Hx.bytes)(data);
    return data;
}
function $639aa6ce9c860f35$export$287dd7971339c972() {
    for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++){
        arrays[_key] = arguments[_key];
    }
    var sum = 0;
    for(var i = 0; i < arrays.length; i++){
        var a = arrays[i];
        (0, $Vu6Hx.bytes)(a);
        sum += a.length;
    }
    var res = new Uint8Array(sum);
    for(var i1 = 0, pad = 0; i1 < arrays.length; i1++){
        var a1 = arrays[i1];
        res.set(a1, pad);
        pad += a1.length;
    }
    return res;
}
var $639aa6ce9c860f35$export$ab85ecd77ce6a5cd = /*#__PURE__*/ function() {
    "use strict";
    function Hash() {
        (0, $4GJKx._)(this, Hash);
    }
    (0, $1wc17._)(Hash, [
        {
            // Safe version that clones internal state
            key: "clone",
            value: function clone() {
                return this._cloneInto();
            }
        }
    ]);
    return Hash;
}();
var $639aa6ce9c860f35$var$toStr = {}.toString;
function $639aa6ce9c860f35$export$6fcee72895eceb1e(defaults, opts) {
    if (opts !== undefined && $639aa6ce9c860f35$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    var merged = Object.assign(defaults, opts);
    return merged;
}
function $639aa6ce9c860f35$export$f081816339df1972(hashCons) {
    var hashC = function(msg) {
        return hashCons().update($639aa6ce9c860f35$export$30a71edf0753ed6b(msg)).digest();
    };
    var tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = function() {
        return hashCons();
    };
    return hashC;
}
function $639aa6ce9c860f35$export$b465638d1569a3ae(hashCons) {
    var hashC = function(msg, opts) {
        return hashCons(opts).update($639aa6ce9c860f35$export$30a71edf0753ed6b(msg)).digest();
    };
    var tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = function(opts) {
        return hashCons(opts);
    };
    return hashC;
}
function $639aa6ce9c860f35$export$e18964dbd6e083c1(hashCons) {
    var hashC = function(msg, opts) {
        return hashCons(opts).update($639aa6ce9c860f35$export$30a71edf0753ed6b(msg)).digest();
    };
    var tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = function(opts) {
        return hashCons(opts);
    };
    return hashC;
}
function $639aa6ce9c860f35$export$5f828d93ff035aa8() {
    var bytesLength = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 32;
    if ((0, $eZSu4.crypto) && typeof (0, $eZSu4.crypto).getRandomValues === "function") return (0, $eZSu4.crypto).getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}

});
parcelRegister("eZSu4", function(module, exports) {

$parcel$export(module.exports, "crypto", function () { return $aeb10691140d6867$export$7effb53edfc7fa2d; });
var $aeb10691140d6867$export$7effb53edfc7fa2d = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});





parcelRegister("jvoK9", function(module, exports) {

$parcel$export(module.exports, "toSignature", function () { return $e3341b11e1a81cd7$export$d075a2fd83e0ecb; });

var $aHLUh = parcelRequire("aHLUh");

var $4yRgh = parcelRequire("4yRgh");
var $e3341b11e1a81cd7$export$d075a2fd83e0ecb = function(def) {
    var def_ = function() {
        if (typeof def === "string") return def;
        return (0, $aHLUh.formatAbiItem)(def);
    }();
    return (0, $4yRgh.normalizeSignature)(def_);
};

});
parcelRegister("aHLUh", function(module, exports) {

$parcel$export(module.exports, "formatAbiItem", function () { return $7cb314d0289c1b00$export$dc5d0ff4fc2fdee1; });

var $1AJLr = parcelRequire("1AJLr");
function $7cb314d0289c1b00$export$dc5d0ff4fc2fdee1(abiItem) {
    if (abiItem.type === "function") return "function ".concat(abiItem.name, "(").concat((0, $1AJLr.formatAbiParameters)(abiItem.inputs), ")").concat(abiItem.stateMutability && abiItem.stateMutability !== "nonpayable" ? " ".concat(abiItem.stateMutability) : "").concat(abiItem.outputs.length ? " returns (".concat((0, $1AJLr.formatAbiParameters)(abiItem.outputs), ")") : "");
    if (abiItem.type === "event") return "event ".concat(abiItem.name, "(").concat((0, $1AJLr.formatAbiParameters)(abiItem.inputs), ")");
    if (abiItem.type === "error") return "error ".concat(abiItem.name, "(").concat((0, $1AJLr.formatAbiParameters)(abiItem.inputs), ")");
    if (abiItem.type === "constructor") return "constructor(".concat((0, $1AJLr.formatAbiParameters)(abiItem.inputs), ")").concat(abiItem.stateMutability === "payable" ? " payable" : "");
    if (abiItem.type === "fallback") return "fallback()";
    return "receive() external payable";
}

});
parcelRegister("1AJLr", function(module, exports) {

$parcel$export(module.exports, "formatAbiParameters", function () { return $128ca711b24bac65$export$c55dbda1a081631e; });

var $2c3gf = parcelRequire("2c3gf");
function $128ca711b24bac65$export$c55dbda1a081631e(abiParameters) {
    var params = "";
    var length = abiParameters.length;
    for(var i = 0; i < length; i++){
        var abiParameter = abiParameters[i];
        params += (0, $2c3gf.formatAbiParameter)(abiParameter);
        if (i !== length - 1) params += ", ";
    }
    return params;
}

});
parcelRegister("2c3gf", function(module, exports) {

$parcel$export(module.exports, "formatAbiParameter", function () { return $198f3b5d282a7225$export$c75e01ebc733dc6b; });

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $M4QSd = parcelRequire("M4QSd");
// https://regexr.com/7f7rv
var $198f3b5d282a7225$var$tupleRegex = RegExp("^tuple(?<array>(\\[(\\d*)\\])*)$");
function $198f3b5d282a7225$export$c75e01ebc733dc6b(abiParameter) {
    var type = abiParameter.type;
    if ($198f3b5d282a7225$var$tupleRegex.test(abiParameter.type) && "components" in abiParameter) {
        type = "(";
        var length = abiParameter.components.length;
        for(var i = 0; i < length; i++){
            var component = abiParameter.components[i];
            type += $198f3b5d282a7225$export$c75e01ebc733dc6b(component);
            if (i < length - 1) type += ", ";
        }
        var result = (0, $M4QSd.execTyped)($198f3b5d282a7225$var$tupleRegex, abiParameter.type);
        var _result_array;
        type += ")".concat((_result_array = result === null || result === void 0 ? void 0 : result.array) !== null && _result_array !== void 0 ? _result_array : "");
        return $198f3b5d282a7225$export$c75e01ebc733dc6b((0, $cxjpp._)((0, $do9pw._)({}, abiParameter), {
            type: type
        }));
    }
    // Add `indexed` to type if in `abiParameter`
    if ("indexed" in abiParameter && abiParameter.indexed) type = "".concat(type, " indexed");
    // Return human-readable ABI parameter
    if (abiParameter.name) return "".concat(type, " ").concat(abiParameter.name);
    return type;
}

});



parcelRegister("4yRgh", function(module, exports) {

$parcel$export(module.exports, "normalizeSignature", function () { return $3523a707ac545219$export$5cba87ebe4d0307a; });

var $7ihh7 = parcelRequire("7ihh7");
function $3523a707ac545219$export$5cba87ebe4d0307a(signature) {
    var active = true;
    var current = "";
    var level = 0;
    var result = "";
    var valid = false;
    for(var i = 0; i < signature.length; i++){
        var char = signature[i];
        // If the character is a separator, we want to reactivate.
        if ([
            "(",
            ")",
            ","
        ].includes(char)) active = true;
        // If the character is a "level" token, we want to increment/decrement.
        if (char === "(") level++;
        if (char === ")") level--;
        // If we aren't active, we don't want to mutate the result.
        if (!active) continue;
        // If level === 0, we are at the definition level.
        if (level === 0) {
            if (char === " " && [
                "event",
                "function",
                ""
            ].includes(result)) result = "";
            else {
                result += char;
                // If we are at the end of the definition, we must be finished.
                if (char === ")") {
                    valid = true;
                    break;
                }
            }
            continue;
        }
        // Ignore spaces
        if (char === " ") {
            // If the previous character is a separator, and the current section isn't empty, we want to deactivate.
            if (signature[i - 1] !== "," && current !== "," && current !== ",(") {
                current = "";
                active = false;
            }
            continue;
        }
        result += char;
        current += char;
    }
    if (!valid) throw new (0, $7ihh7.BaseError)("Unable to normalize signature.");
    return result;
}

});




parcelRegister("iYiQt", function(module, exports) {

$parcel$export(module.exports, "decodeAbiParameters", function () { return $dcfc72df0ed6ca84$export$84d51ac2fffabd56; });

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $cv9Rk = parcelRequire("cv9Rk");

var $fLalY = parcelRequire("fLalY");

var $8zfHX = parcelRequire("8zfHX");

var $89FXB = parcelRequire("89FXB");

var $dfJGH = parcelRequire("dfJGH");

var $8SGIa = parcelRequire("8SGIa");

var $bi3OS = parcelRequire("bi3OS");

var $8SGYU = parcelRequire("8SGYU");

var $g8Qfu = parcelRequire("g8Qfu");

var $f3VZN = parcelRequire("f3VZN");

var $iL62l = parcelRequire("iL62l");
function $dcfc72df0ed6ca84$export$84d51ac2fffabd56(params, data) {
    var bytes = typeof data === "string" ? (0, $g8Qfu.hexToBytes)(data) : data;
    var cursor = (0, $89FXB.createCursor)(bytes);
    if ((0, $dfJGH.size)(bytes) === 0 && params.length > 0) throw new (0, $fLalY.AbiDecodingZeroDataError)();
    if ((0, $dfJGH.size)(data) && (0, $dfJGH.size)(data) < 32) throw new (0, $fLalY.AbiDecodingDataSizeTooSmallError)({
        data: typeof data === "string" ? data : (0, $f3VZN.bytesToHex)(data),
        params: params,
        size: (0, $dfJGH.size)(data)
    });
    var consumed = 0;
    var values = [];
    for(var i = 0; i < params.length; ++i){
        var param = params[i];
        cursor.setPosition(consumed);
        var _decodeParameter = (0, $cv9Rk._)($dcfc72df0ed6ca84$var$decodeParameter(cursor, param, {
            staticPosition: 0
        }), 2), _$data = _decodeParameter[0], consumed_ = _decodeParameter[1];
        consumed += consumed_;
        values.push(_$data);
    }
    return values;
}
function $dcfc72df0ed6ca84$var$decodeParameter(cursor, param, param1) {
    var staticPosition = param1.staticPosition;
    var arrayComponents = (0, $iL62l.getArrayComponents)(param.type);
    if (arrayComponents) {
        var _arrayComponents = (0, $cv9Rk._)(arrayComponents, 2), length = _arrayComponents[0], type = _arrayComponents[1];
        return $dcfc72df0ed6ca84$var$decodeArray(cursor, (0, $cxjpp._)((0, $do9pw._)({}, param), {
            type: type
        }), {
            length: length,
            staticPosition: staticPosition
        });
    }
    if (param.type === "tuple") return $dcfc72df0ed6ca84$var$decodeTuple(cursor, param, {
        staticPosition: staticPosition
    });
    if (param.type === "address") return $dcfc72df0ed6ca84$var$decodeAddress(cursor);
    if (param.type === "bool") return $dcfc72df0ed6ca84$var$decodeBool(cursor);
    if (param.type.startsWith("bytes")) return $dcfc72df0ed6ca84$var$decodeBytes(cursor, param, {
        staticPosition: staticPosition
    });
    if (param.type.startsWith("uint") || param.type.startsWith("int")) return $dcfc72df0ed6ca84$var$decodeNumber(cursor, param);
    if (param.type === "string") return $dcfc72df0ed6ca84$var$decodeString(cursor, {
        staticPosition: staticPosition
    });
    throw new (0, $fLalY.InvalidAbiDecodingTypeError)(param.type, {
        docsPath: "/docs/contract/decodeAbiParameters"
    });
}
////////////////////////////////////////////////////////////////////
// Type Decoders
var $dcfc72df0ed6ca84$var$sizeOfLength = 32;
var $dcfc72df0ed6ca84$var$sizeOfOffset = 32;
function $dcfc72df0ed6ca84$var$decodeAddress(cursor) {
    var value = cursor.readBytes(32);
    return [
        (0, $8zfHX.checksumAddress)((0, $f3VZN.bytesToHex)((0, $8SGIa.sliceBytes)(value, -20))),
        32
    ];
}
function $dcfc72df0ed6ca84$var$decodeArray(cursor, param, param1) {
    var length = param1.length, staticPosition = param1.staticPosition;
    // If the length of the array is not known in advance (dynamic array),
    // this means we will need to wonder off to the pointer and decode.
    if (!length) {
        // Dealing with a dynamic type, so get the offset of the array data.
        var offset = (0, $8SGYU.bytesToNumber)(cursor.readBytes($dcfc72df0ed6ca84$var$sizeOfOffset));
        // Start is the static position of current slot + offset.
        var start = staticPosition + offset;
        var startOfData = start + $dcfc72df0ed6ca84$var$sizeOfLength;
        // Get the length of the array from the offset.
        cursor.setPosition(start);
        var length1 = (0, $8SGYU.bytesToNumber)(cursor.readBytes($dcfc72df0ed6ca84$var$sizeOfLength));
        // Check if the array has any dynamic children.
        var dynamicChild = $dcfc72df0ed6ca84$var$hasDynamicChild(param);
        var consumed = 0;
        var value = [];
        for(var i = 0; i < length1; ++i){
            // If any of the children is dynamic, then all elements will be offset pointer, thus size of one slot (32 bytes).
            // Otherwise, elements will be the size of their encoding (consumed bytes).
            cursor.setPosition(startOfData + (dynamicChild ? i * 32 : consumed));
            var _decodeParameter = (0, $cv9Rk._)($dcfc72df0ed6ca84$var$decodeParameter(cursor, param, {
                staticPosition: startOfData
            }), 2), data = _decodeParameter[0], consumed_ = _decodeParameter[1];
            consumed += consumed_;
            value.push(data);
        }
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [
            value,
            32
        ];
    }
    // If the length of the array is known in advance,
    // and the length of an element deeply nested in the array is not known,
    // we need to decode the offset of the array data.
    if ($dcfc72df0ed6ca84$var$hasDynamicChild(param)) {
        // Dealing with dynamic types, so get the offset of the array data.
        var offset1 = (0, $8SGYU.bytesToNumber)(cursor.readBytes($dcfc72df0ed6ca84$var$sizeOfOffset));
        // Start is the static position of current slot + offset.
        var start1 = staticPosition + offset1;
        var value1 = [];
        for(var i1 = 0; i1 < length; ++i1){
            // Move cursor along to the next slot (next offset pointer).
            cursor.setPosition(start1 + i1 * 32);
            var _decodeParameter1 = (0, $cv9Rk._)($dcfc72df0ed6ca84$var$decodeParameter(cursor, param, {
                staticPosition: start1
            }), 1), data1 = _decodeParameter1[0];
            value1.push(data1);
        }
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [
            value1,
            32
        ];
    }
    // If the length of the array is known in advance and the array is deeply static,
    // then we can just decode each element in sequence.
    var consumed1 = 0;
    var value2 = [];
    for(var i2 = 0; i2 < length; ++i2){
        var _decodeParameter2 = (0, $cv9Rk._)($dcfc72df0ed6ca84$var$decodeParameter(cursor, param, {
            staticPosition: staticPosition + consumed1
        }), 2), data2 = _decodeParameter2[0], consumed_1 = _decodeParameter2[1];
        consumed1 += consumed_1;
        value2.push(data2);
    }
    return [
        value2,
        consumed1
    ];
}
function $dcfc72df0ed6ca84$var$decodeBool(cursor) {
    return [
        (0, $8SGYU.bytesToBool)(cursor.readBytes(32), {
            size: 32
        }),
        32
    ];
}
function $dcfc72df0ed6ca84$var$decodeBytes(cursor, param, param1) {
    var staticPosition = param1.staticPosition;
    var _param_type_split = (0, $cv9Rk._)(param.type.split("bytes"), 2), _ = _param_type_split[0], size = _param_type_split[1];
    if (!size) {
        // Dealing with dynamic types, so get the offset of the bytes data.
        var offset = (0, $8SGYU.bytesToNumber)(cursor.readBytes(32));
        // Set position of the cursor to start of bytes data.
        cursor.setPosition(staticPosition + offset);
        var length = (0, $8SGYU.bytesToNumber)(cursor.readBytes(32));
        // If there is no length, we have zero data.
        if (length === 0) {
            // As we have gone wondering, restore to the original position + next slot.
            cursor.setPosition(staticPosition + 32);
            return [
                "0x",
                32
            ];
        }
        var data = cursor.readBytes(length);
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [
            (0, $f3VZN.bytesToHex)(data),
            32
        ];
    }
    var value = (0, $f3VZN.bytesToHex)(cursor.readBytes(Number.parseInt(size), 32));
    return [
        value,
        32
    ];
}
function $dcfc72df0ed6ca84$var$decodeNumber(cursor, param) {
    var signed = param.type.startsWith("int");
    var size = Number.parseInt(param.type.split("int")[1] || "256");
    var value = cursor.readBytes(32);
    return [
        size > 48 ? (0, $8SGYU.bytesToBigInt)(value, {
            signed: signed
        }) : (0, $8SGYU.bytesToNumber)(value, {
            signed: signed
        }),
        32
    ];
}
function $dcfc72df0ed6ca84$var$decodeTuple(cursor, param, param1) {
    var staticPosition = param1.staticPosition;
    // Tuples can have unnamed components (i.e. they are arrays), so we must
    // determine whether the tuple is named or unnamed. In the case of a named
    // tuple, the value will be an object where each property is the name of the
    // component. In the case of an unnamed tuple, the value will be an array.
    var hasUnnamedChild = param.components.length === 0 || param.components.some(function(param) {
        var name = param.name;
        return !name;
    });
    // Initialize the value to an object or an array, depending on whether the
    // tuple is named or unnamed.
    var value = hasUnnamedChild ? [] : {};
    var consumed = 0;
    // If the tuple has a dynamic child, we must first decode the offset to the
    // tuple data.
    if ($dcfc72df0ed6ca84$var$hasDynamicChild(param)) {
        // Dealing with dynamic types, so get the offset of the tuple data.
        var offset = (0, $8SGYU.bytesToNumber)(cursor.readBytes($dcfc72df0ed6ca84$var$sizeOfOffset));
        // Start is the static position of referencing slot + offset.
        var start = staticPosition + offset;
        for(var i = 0; i < param.components.length; ++i){
            var component = param.components[i];
            cursor.setPosition(start + consumed);
            var _decodeParameter = (0, $cv9Rk._)($dcfc72df0ed6ca84$var$decodeParameter(cursor, component, {
                staticPosition: start
            }), 2), data = _decodeParameter[0], consumed_ = _decodeParameter[1];
            consumed += consumed_;
            value[hasUnnamedChild ? i : component === null || component === void 0 ? void 0 : component.name] = data;
        }
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [
            value,
            32
        ];
    }
    // If the tuple has static children, we can just decode each component
    // in sequence.
    for(var i1 = 0; i1 < param.components.length; ++i1){
        var component1 = param.components[i1];
        var _decodeParameter1 = (0, $cv9Rk._)($dcfc72df0ed6ca84$var$decodeParameter(cursor, component1, {
            staticPosition: staticPosition
        }), 2), data1 = _decodeParameter1[0], consumed_1 = _decodeParameter1[1];
        value[hasUnnamedChild ? i1 : component1 === null || component1 === void 0 ? void 0 : component1.name] = data1;
        consumed += consumed_1;
    }
    return [
        value,
        consumed
    ];
}
function $dcfc72df0ed6ca84$var$decodeString(cursor, param) {
    var staticPosition = param.staticPosition;
    // Get offset to start of string data.
    var offset = (0, $8SGYU.bytesToNumber)(cursor.readBytes(32));
    // Start is the static position of current slot + offset.
    var start = staticPosition + offset;
    cursor.setPosition(start);
    var length = (0, $8SGYU.bytesToNumber)(cursor.readBytes(32));
    // If there is no length, we have zero data (empty string).
    if (length === 0) {
        cursor.setPosition(staticPosition + 32);
        return [
            "",
            32
        ];
    }
    var data = cursor.readBytes(length, 32);
    var value = (0, $8SGYU.bytesToString)((0, $bi3OS.trim)(data));
    // As we have gone wondering, restore to the original position + next slot.
    cursor.setPosition(staticPosition + 32);
    return [
        value,
        32
    ];
}
function $dcfc72df0ed6ca84$var$hasDynamicChild(param) {
    var _param_components;
    var type = param.type;
    if (type === "string") return true;
    if (type === "bytes") return true;
    if (type.endsWith("[]")) return true;
    if (type === "tuple") return (_param_components = param.components) === null || _param_components === void 0 ? void 0 : _param_components.some($dcfc72df0ed6ca84$var$hasDynamicChild);
    var arrayComponents = (0, $iL62l.getArrayComponents)(param.type);
    if (arrayComponents && $dcfc72df0ed6ca84$var$hasDynamicChild((0, $cxjpp._)((0, $do9pw._)({}, param), {
        type: arrayComponents[1]
    }))) return true;
    return false;
}

});
parcelRegister("8zfHX", function(module, exports) {

$parcel$export(module.exports, "checksumAddress", function () { return $63cdc6e9d47fb19d$export$9ff46e8f6df13548; });
$parcel$export(module.exports, "getAddress", function () { return $63cdc6e9d47fb19d$export$88411125f012957a; });

var $5YJl8 = parcelRequire("5YJl8");

var $g8Qfu = parcelRequire("g8Qfu");

var $h0UKT = parcelRequire("h0UKT");

var $8Ampo = parcelRequire("8Ampo");

var $7deC8 = parcelRequire("7deC8");
var $63cdc6e9d47fb19d$var$checksumAddressCache = /*#__PURE__*/ new (0, $8Ampo.LruMap)(8192);
function $63cdc6e9d47fb19d$export$9ff46e8f6df13548(address_, /**
 * Warning: EIP-1191 checksum addresses are generally not backwards compatible with the
 * wider Ethereum ecosystem, meaning it will break when validated against an application/tool
 * that relies on EIP-55 checksum encoding (checksum without chainId).
 *
 * It is highly recommended to not use this feature unless you
 * know what you are doing.
 *
 * See more: https://github.com/ethereum/EIPs/issues/1121
 */ chainId) {
    if ($63cdc6e9d47fb19d$var$checksumAddressCache.has("".concat(address_, ".").concat(chainId))) return $63cdc6e9d47fb19d$var$checksumAddressCache.get("".concat(address_, ".").concat(chainId));
    var hexAddress = chainId ? "".concat(chainId).concat(address_.toLowerCase()) : address_.substring(2).toLowerCase();
    var hash = (0, $h0UKT.keccak256)((0, $g8Qfu.stringToBytes)(hexAddress), "bytes");
    var address = (chainId ? hexAddress.substring("".concat(chainId, "0x").length) : hexAddress).split("");
    for(var i = 0; i < 40; i += 2){
        if (hash[i >> 1] >> 4 >= 8 && address[i]) address[i] = address[i].toUpperCase();
        if ((hash[i >> 1] & 0x0f) >= 8 && address[i + 1]) address[i + 1] = address[i + 1].toUpperCase();
    }
    var result = "0x".concat(address.join(""));
    $63cdc6e9d47fb19d$var$checksumAddressCache.set("".concat(address_, ".").concat(chainId), result);
    return result;
}
function $63cdc6e9d47fb19d$export$88411125f012957a(address, /**
 * Warning: EIP-1191 checksum addresses are generally not backwards compatible with the
 * wider Ethereum ecosystem, meaning it will break when validated against an application/tool
 * that relies on EIP-55 checksum encoding (checksum without chainId).
 *
 * It is highly recommended to not use this feature unless you
 * know what you are doing.
 *
 * See more: https://github.com/ethereum/EIPs/issues/1121
 */ chainId) {
    if (!(0, $7deC8.isAddress)(address, {
        strict: false
    })) throw new (0, $5YJl8.InvalidAddressError)({
        address: address
    });
    return $63cdc6e9d47fb19d$export$9ff46e8f6df13548(address, chainId);
}

});
parcelRegister("5YJl8", function(module, exports) {

$parcel$export(module.exports, "InvalidAddressError", function () { return $45a5b9e2ea918a7e$export$66c44d927ffead98; });

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $7ihh7 = parcelRequire("7ihh7");
var $45a5b9e2ea918a7e$export$66c44d927ffead98 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(InvalidAddressError, BaseError);
    var _super = (0, $ohfOJ._)(InvalidAddressError);
    function InvalidAddressError(param) {
        var address = param.address;
        (0, $4GJKx._)(this, InvalidAddressError);
        return _super.call(this, 'Address "'.concat(address, '" is invalid.'), {
            metaMessages: [
                "- Address must be a hex value of 20 bytes (40 hex characters).",
                "- Address must match its checksum counterpart."
            ],
            name: "InvalidAddressError"
        });
    }
    return InvalidAddressError;
}((0, $7ihh7.BaseError));

});

parcelRegister("8Ampo", function(module, exports) {

$parcel$export(module.exports, "LruMap", function () { return $640311614e76d422$export$fcb3b6cad79d7e3a; });
/**
 * Map with a LRU (Least recently used) policy.
 *
 * @link https://en.wikipedia.org/wiki/Cache_replacement_policies#LRU
 */ 
var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $04RAu = parcelRequire("04RAu");

var $b8Rim = parcelRequire("b8Rim");

var $dcsZi = parcelRequire("dcsZi");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");
var $640311614e76d422$export$fcb3b6cad79d7e3a = /*#__PURE__*/ function(Map1) {
    "use strict";
    (0, $dcsZi._)(LruMap, Map1);
    var _super = (0, $ohfOJ._)(LruMap);
    function LruMap(size) {
        (0, $4GJKx._)(this, LruMap);
        var _this;
        _this = _super.call(this);
        Object.defineProperty((0, $d3H5E._)(_this), "maxSize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this.maxSize = size;
        return _this;
    }
    (0, $1wc17._)(LruMap, [
        {
            key: "set",
            value: function set(key, value) {
                (0, $04RAu._)((0, $b8Rim._)(LruMap.prototype), "set", this).call(this, key, value);
                if (this.maxSize && this.size > this.maxSize) this.delete(this.keys().next().value);
                return this;
            }
        }
    ]);
    return LruMap;
}((0, $FuVm8._)(Map));

});

parcelRegister("7deC8", function(module, exports) {

$parcel$export(module.exports, "isAddress", function () { return $5405155ba712012b$export$977e255126d763d6; });

var $8Ampo = parcelRequire("8Ampo");

var $8zfHX = parcelRequire("8zfHX");
var $5405155ba712012b$var$addressRegex = /^0x[a-fA-F0-9]{40}$/;
var $5405155ba712012b$export$ef83598cc5072ce = /*#__PURE__*/ new (0, $8Ampo.LruMap)(8192);
function $5405155ba712012b$export$977e255126d763d6(address, options) {
    var _ref = options !== null && options !== void 0 ? options : {}, _ref_strict = _ref.strict, strict = _ref_strict === void 0 ? true : _ref_strict;
    var cacheKey = "".concat(address, ".").concat(strict);
    if ($5405155ba712012b$export$ef83598cc5072ce.has(cacheKey)) return $5405155ba712012b$export$ef83598cc5072ce.get(cacheKey);
    var result = function() {
        if (!$5405155ba712012b$var$addressRegex.test(address)) return false;
        if (address.toLowerCase() === address) return true;
        if (strict) return (0, $8zfHX.checksumAddress)(address) === address;
        return true;
    }();
    $5405155ba712012b$export$ef83598cc5072ce.set(cacheKey, result);
    return result;
}

});


parcelRegister("89FXB", function(module, exports) {

$parcel$export(module.exports, "createCursor", function () { return $5effb671d14019d2$export$fb542681b7c0dc55; });

var $1kC4N = parcelRequire("1kC4N");
var $5effb671d14019d2$var$staticCursor = {
    bytes: new Uint8Array(),
    dataView: new DataView(new ArrayBuffer(0)),
    position: 0,
    positionReadCount: new Map(),
    recursiveReadCount: 0,
    recursiveReadLimit: Number.POSITIVE_INFINITY,
    assertReadLimit: function() {
        if (this.recursiveReadCount >= this.recursiveReadLimit) throw new (0, $1kC4N.RecursiveReadLimitExceededError)({
            count: this.recursiveReadCount + 1,
            limit: this.recursiveReadLimit
        });
    },
    assertPosition: function(position) {
        if (position < 0 || position > this.bytes.length - 1) throw new (0, $1kC4N.PositionOutOfBoundsError)({
            length: this.bytes.length,
            position: position
        });
    },
    decrementPosition: function(offset) {
        if (offset < 0) throw new (0, $1kC4N.NegativeOffsetError)({
            offset: offset
        });
        var position = this.position - offset;
        this.assertPosition(position);
        this.position = position;
    },
    getReadCount: function(position) {
        return this.positionReadCount.get(position || this.position) || 0;
    },
    incrementPosition: function(offset) {
        if (offset < 0) throw new (0, $1kC4N.NegativeOffsetError)({
            offset: offset
        });
        var position = this.position + offset;
        this.assertPosition(position);
        this.position = position;
    },
    inspectByte: function(position_) {
        var position = position_ !== null && position_ !== void 0 ? position_ : this.position;
        this.assertPosition(position);
        return this.bytes[position];
    },
    inspectBytes: function(length, position_) {
        var position = position_ !== null && position_ !== void 0 ? position_ : this.position;
        this.assertPosition(position + length - 1);
        return this.bytes.subarray(position, position + length);
    },
    inspectUint8: function(position_) {
        var position = position_ !== null && position_ !== void 0 ? position_ : this.position;
        this.assertPosition(position);
        return this.bytes[position];
    },
    inspectUint16: function(position_) {
        var position = position_ !== null && position_ !== void 0 ? position_ : this.position;
        this.assertPosition(position + 1);
        return this.dataView.getUint16(position);
    },
    inspectUint24: function(position_) {
        var position = position_ !== null && position_ !== void 0 ? position_ : this.position;
        this.assertPosition(position + 2);
        return (this.dataView.getUint16(position) << 8) + this.dataView.getUint8(position + 2);
    },
    inspectUint32: function(position_) {
        var position = position_ !== null && position_ !== void 0 ? position_ : this.position;
        this.assertPosition(position + 3);
        return this.dataView.getUint32(position);
    },
    pushByte: function(byte) {
        this.assertPosition(this.position);
        this.bytes[this.position] = byte;
        this.position++;
    },
    pushBytes: function(bytes) {
        this.assertPosition(this.position + bytes.length - 1);
        this.bytes.set(bytes, this.position);
        this.position += bytes.length;
    },
    pushUint8: function(value) {
        this.assertPosition(this.position);
        this.bytes[this.position] = value;
        this.position++;
    },
    pushUint16: function(value) {
        this.assertPosition(this.position + 1);
        this.dataView.setUint16(this.position, value);
        this.position += 2;
    },
    pushUint24: function(value) {
        this.assertPosition(this.position + 2);
        this.dataView.setUint16(this.position, value >> 8);
        this.dataView.setUint8(this.position + 2, value & 255);
        this.position += 3;
    },
    pushUint32: function(value) {
        this.assertPosition(this.position + 3);
        this.dataView.setUint32(this.position, value);
        this.position += 4;
    },
    readByte: function() {
        this.assertReadLimit();
        this._touch();
        var value = this.inspectByte();
        this.position++;
        return value;
    },
    readBytes: function(length, size) {
        this.assertReadLimit();
        this._touch();
        var value = this.inspectBytes(length);
        this.position += size !== null && size !== void 0 ? size : length;
        return value;
    },
    readUint8: function() {
        this.assertReadLimit();
        this._touch();
        var value = this.inspectUint8();
        this.position += 1;
        return value;
    },
    readUint16: function() {
        this.assertReadLimit();
        this._touch();
        var value = this.inspectUint16();
        this.position += 2;
        return value;
    },
    readUint24: function() {
        this.assertReadLimit();
        this._touch();
        var value = this.inspectUint24();
        this.position += 3;
        return value;
    },
    readUint32: function() {
        this.assertReadLimit();
        this._touch();
        var value = this.inspectUint32();
        this.position += 4;
        return value;
    },
    get remaining () {
        return this.bytes.length - this.position;
    },
    setPosition: function(position) {
        var _this = this;
        var oldPosition = this.position;
        this.assertPosition(position);
        this.position = position;
        return function() {
            return _this.position = oldPosition;
        };
    },
    _touch: function() {
        if (this.recursiveReadLimit === Number.POSITIVE_INFINITY) return;
        var count = this.getReadCount();
        this.positionReadCount.set(this.position, count + 1);
        if (count > 0) this.recursiveReadCount++;
    }
};
function $5effb671d14019d2$export$fb542681b7c0dc55(bytes) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_recursiveReadLimit = _ref.recursiveReadLimit, recursiveReadLimit = _ref_recursiveReadLimit === void 0 ? 8192 : _ref_recursiveReadLimit;
    var cursor = Object.create($5effb671d14019d2$var$staticCursor);
    cursor.bytes = bytes;
    cursor.dataView = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    cursor.positionReadCount = new Map();
    cursor.recursiveReadLimit = recursiveReadLimit;
    return cursor;
}

});
parcelRegister("1kC4N", function(module, exports) {

$parcel$export(module.exports, "NegativeOffsetError", function () { return $0f8531dc2c8efb4e$export$4741ff085e62ac19; });
$parcel$export(module.exports, "PositionOutOfBoundsError", function () { return $0f8531dc2c8efb4e$export$72dcc4230cbf50ba; });
$parcel$export(module.exports, "RecursiveReadLimitExceededError", function () { return $0f8531dc2c8efb4e$export$4952f5c6336a7cc7; });

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $7ihh7 = parcelRequire("7ihh7");
var $0f8531dc2c8efb4e$export$4741ff085e62ac19 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(NegativeOffsetError, BaseError);
    var _super = (0, $ohfOJ._)(NegativeOffsetError);
    function NegativeOffsetError(param) {
        var offset = param.offset;
        (0, $4GJKx._)(this, NegativeOffsetError);
        return _super.call(this, "Offset `".concat(offset, "` cannot be negative."), {
            name: "NegativeOffsetError"
        });
    }
    return NegativeOffsetError;
}((0, $7ihh7.BaseError));
var $0f8531dc2c8efb4e$export$72dcc4230cbf50ba = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(PositionOutOfBoundsError, BaseError);
    var _super = (0, $ohfOJ._)(PositionOutOfBoundsError);
    function PositionOutOfBoundsError(param) {
        var length = param.length, position = param.position;
        (0, $4GJKx._)(this, PositionOutOfBoundsError);
        return _super.call(this, "Position `".concat(position, "` is out of bounds (`0 < position < ").concat(length, "`)."), {
            name: "PositionOutOfBoundsError"
        });
    }
    return PositionOutOfBoundsError;
}((0, $7ihh7.BaseError));
var $0f8531dc2c8efb4e$export$4952f5c6336a7cc7 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(RecursiveReadLimitExceededError, BaseError);
    var _super = (0, $ohfOJ._)(RecursiveReadLimitExceededError);
    function RecursiveReadLimitExceededError(param) {
        var count = param.count, limit = param.limit;
        (0, $4GJKx._)(this, RecursiveReadLimitExceededError);
        return _super.call(this, "Recursive read limit of `".concat(limit, "` exceeded (recursive read count: `").concat(count, "`)."), {
            name: "RecursiveReadLimitExceededError"
        });
    }
    return RecursiveReadLimitExceededError;
}((0, $7ihh7.BaseError));

});


parcelRegister("8SGYU", function(module, exports) {

$parcel$export(module.exports, "bytesToNumber", function () { return $6774b5164f164555$export$c0cca17bcf674749; });
$parcel$export(module.exports, "bytesToBigInt", function () { return $6774b5164f164555$export$2a52511e4f35930a; });
$parcel$export(module.exports, "bytesToBool", function () { return $6774b5164f164555$export$aa06fda122958d5d; });
$parcel$export(module.exports, "bytesToString", function () { return $6774b5164f164555$export$7c746b75f47c9c7d; });

var $8UU42 = parcelRequire("8UU42");

var $bi3OS = parcelRequire("bi3OS");

var $itrhm = parcelRequire("itrhm");

var $f3VZN = parcelRequire("f3VZN");
function $6774b5164f164555$export$de2da3025c30316c(bytes, toOrOpts) {
    var opts = typeof toOrOpts === "string" ? {
        to: toOrOpts
    } : toOrOpts;
    var to = opts.to;
    if (to === "number") return $6774b5164f164555$export$c0cca17bcf674749(bytes, opts);
    if (to === "bigint") return $6774b5164f164555$export$2a52511e4f35930a(bytes, opts);
    if (to === "boolean") return $6774b5164f164555$export$aa06fda122958d5d(bytes, opts);
    if (to === "string") return $6774b5164f164555$export$7c746b75f47c9c7d(bytes, opts);
    return (0, $f3VZN.bytesToHex)(bytes, opts);
}
function $6774b5164f164555$export$2a52511e4f35930a(bytes) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (typeof opts.size !== "undefined") (0, $itrhm.assertSize)(bytes, {
        size: opts.size
    });
    var hex = (0, $f3VZN.bytesToHex)(bytes, opts);
    return (0, $itrhm.hexToBigInt)(hex, opts);
}
function $6774b5164f164555$export$aa06fda122958d5d(bytes_) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var bytes = bytes_;
    if (typeof opts.size !== "undefined") {
        (0, $itrhm.assertSize)(bytes, {
            size: opts.size
        });
        bytes = (0, $bi3OS.trim)(bytes);
    }
    if (bytes.length > 1 || bytes[0] > 1) throw new (0, $8UU42.InvalidBytesBooleanError)(bytes);
    return Boolean(bytes[0]);
}
function $6774b5164f164555$export$c0cca17bcf674749(bytes) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (typeof opts.size !== "undefined") (0, $itrhm.assertSize)(bytes, {
        size: opts.size
    });
    var hex = (0, $f3VZN.bytesToHex)(bytes, opts);
    return (0, $itrhm.hexToNumber)(hex, opts);
}
function $6774b5164f164555$export$7c746b75f47c9c7d(bytes_) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var bytes = bytes_;
    if (typeof opts.size !== "undefined") {
        (0, $itrhm.assertSize)(bytes, {
            size: opts.size
        });
        bytes = (0, $bi3OS.trim)(bytes, {
            dir: "right"
        });
    }
    return new TextDecoder().decode(bytes);
}

});

parcelRegister("iL62l", function(module, exports) {

$parcel$export(module.exports, "encodeAbiParameters", function () { return $da814c8c18c2e1da$export$448ea0950d6dd7d7; });
$parcel$export(module.exports, "getArrayComponents", function () { return $da814c8c18c2e1da$export$ab502cfdbb1a0d07; });

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $l0HdX = parcelRequire("l0HdX");

var $fLalY = parcelRequire("fLalY");

var $5YJl8 = parcelRequire("5YJl8");

var $7ihh7 = parcelRequire("7ihh7");

var $7deC8 = parcelRequire("7deC8");

var $ewLmX = parcelRequire("ewLmX");

var $b7M07 = parcelRequire("b7M07");

var $dfJGH = parcelRequire("dfJGH");

var $8SGIa = parcelRequire("8SGIa");

var $f3VZN = parcelRequire("f3VZN");
function $da814c8c18c2e1da$export$448ea0950d6dd7d7(params, values) {
    if (params.length !== values.length) throw new (0, $fLalY.AbiEncodingLengthMismatchError)({
        expectedLength: params.length,
        givenLength: values.length
    });
    // Prepare the parameters to determine dynamic types to encode.
    var preparedParams = $da814c8c18c2e1da$var$prepareParams({
        params: params,
        values: values
    });
    var data = $da814c8c18c2e1da$var$encodeParams(preparedParams);
    if (data.length === 0) return "0x";
    return data;
}
function $da814c8c18c2e1da$var$prepareParams(param) {
    var params = param.params, values = param.values;
    var preparedParams = [];
    for(var i = 0; i < params.length; i++)preparedParams.push($da814c8c18c2e1da$var$prepareParam({
        param: params[i],
        value: values[i]
    }));
    return preparedParams;
}
function $da814c8c18c2e1da$var$prepareParam(param) {
    var _$param = param.param, value = param.value;
    var arrayComponents = $da814c8c18c2e1da$export$ab502cfdbb1a0d07(_$param.type);
    if (arrayComponents) {
        var _arrayComponents = (0, $cv9Rk._)(arrayComponents, 2), length = _arrayComponents[0], type = _arrayComponents[1];
        return $da814c8c18c2e1da$var$encodeArray(value, {
            length: length,
            param: (0, $cxjpp._)((0, $do9pw._)({}, _$param), {
                type: type
            })
        });
    }
    if (_$param.type === "tuple") return $da814c8c18c2e1da$var$encodeTuple(value, {
        param: _$param
    });
    if (_$param.type === "address") return $da814c8c18c2e1da$var$encodeAddress(value);
    if (_$param.type === "bool") return $da814c8c18c2e1da$var$encodeBool(value);
    if (_$param.type.startsWith("uint") || _$param.type.startsWith("int")) {
        var signed = _$param.type.startsWith("int");
        return $da814c8c18c2e1da$var$encodeNumber(value, {
            signed: signed
        });
    }
    if (_$param.type.startsWith("bytes")) return $da814c8c18c2e1da$var$encodeBytes(value, {
        param: _$param
    });
    if (_$param.type === "string") return $da814c8c18c2e1da$var$encodeString(value);
    throw new (0, $fLalY.InvalidAbiEncodingTypeError)(_$param.type, {
        docsPath: "/docs/contract/encodeAbiParameters"
    });
}
function $da814c8c18c2e1da$var$encodeParams(preparedParams) {
    // 1. Compute the size of the static part of the parameters.
    var staticSize = 0;
    for(var i = 0; i < preparedParams.length; i++){
        var _preparedParams_i = preparedParams[i], dynamic = _preparedParams_i.dynamic, encoded = _preparedParams_i.encoded;
        if (dynamic) staticSize += 32;
        else staticSize += (0, $dfJGH.size)(encoded);
    }
    // 2. Split the parameters into static and dynamic parts.
    var staticParams = [];
    var dynamicParams = [];
    var dynamicSize = 0;
    for(var i1 = 0; i1 < preparedParams.length; i1++){
        var _preparedParams_i1 = preparedParams[i1], dynamic1 = _preparedParams_i1.dynamic, encoded1 = _preparedParams_i1.encoded;
        if (dynamic1) {
            staticParams.push((0, $f3VZN.numberToHex)(staticSize + dynamicSize, {
                size: 32
            }));
            dynamicParams.push(encoded1);
            dynamicSize += (0, $dfJGH.size)(encoded1);
        } else staticParams.push(encoded1);
    }
    // 3. Concatenate static and dynamic parts.
    return (0, $ewLmX.concat)((0, $c6Xmf._)(staticParams).concat((0, $c6Xmf._)(dynamicParams)));
}
function $da814c8c18c2e1da$var$encodeAddress(value) {
    if (!(0, $7deC8.isAddress)(value)) throw new (0, $5YJl8.InvalidAddressError)({
        address: value
    });
    return {
        dynamic: false,
        encoded: (0, $b7M07.padHex)(value.toLowerCase())
    };
}
function $da814c8c18c2e1da$var$encodeArray(value, param) {
    var length = param.length, _$param = param.param;
    var dynamic = length === null;
    if (!Array.isArray(value)) throw new (0, $fLalY.InvalidArrayError)(value);
    if (!dynamic && value.length !== length) throw new (0, $fLalY.AbiEncodingArrayLengthMismatchError)({
        expectedLength: length,
        givenLength: value.length,
        type: "".concat(_$param.type, "[").concat(length, "]")
    });
    var dynamicChild = false;
    var preparedParams = [];
    for(var i = 0; i < value.length; i++){
        var preparedParam = $da814c8c18c2e1da$var$prepareParam({
            param: _$param,
            value: value[i]
        });
        if (preparedParam.dynamic) dynamicChild = true;
        preparedParams.push(preparedParam);
    }
    if (dynamic || dynamicChild) {
        var data = $da814c8c18c2e1da$var$encodeParams(preparedParams);
        if (dynamic) {
            var length1 = (0, $f3VZN.numberToHex)(preparedParams.length, {
                size: 32
            });
            return {
                dynamic: true,
                encoded: preparedParams.length > 0 ? (0, $ewLmX.concat)([
                    length1,
                    data
                ]) : length1
            };
        }
        if (dynamicChild) return {
            dynamic: true,
            encoded: data
        };
    }
    return {
        dynamic: false,
        encoded: (0, $ewLmX.concat)(preparedParams.map(function(param) {
            var encoded = param.encoded;
            return encoded;
        }))
    };
}
function $da814c8c18c2e1da$var$encodeBytes(value, param) {
    var _$param = param.param;
    var _param_type_split = (0, $cv9Rk._)(_$param.type.split("bytes"), 2), paramSize = _param_type_split[1];
    var bytesSize = (0, $dfJGH.size)(value);
    if (!paramSize) {
        var value_ = value;
        // If the size is not divisible by 32 bytes, pad the end
        // with empty bytes to the ceiling 32 bytes.
        if (bytesSize % 32 !== 0) value_ = (0, $b7M07.padHex)(value_, {
            dir: "right",
            size: Math.ceil((value.length - 2) / 2 / 32) * 32
        });
        return {
            dynamic: true,
            encoded: (0, $ewLmX.concat)([
                (0, $b7M07.padHex)((0, $f3VZN.numberToHex)(bytesSize, {
                    size: 32
                })),
                value_
            ])
        };
    }
    if (bytesSize !== Number.parseInt(paramSize)) throw new (0, $fLalY.AbiEncodingBytesSizeMismatchError)({
        expectedSize: Number.parseInt(paramSize),
        value: value
    });
    return {
        dynamic: false,
        encoded: (0, $b7M07.padHex)(value, {
            dir: "right"
        })
    };
}
function $da814c8c18c2e1da$var$encodeBool(value) {
    if (typeof value !== "boolean") throw new (0, $7ihh7.BaseError)('Invalid boolean value: "'.concat(value, '" (type: ').concat(typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value), "). Expected: `true` or `false`."));
    return {
        dynamic: false,
        encoded: (0, $b7M07.padHex)((0, $f3VZN.boolToHex)(value))
    };
}
function $da814c8c18c2e1da$var$encodeNumber(value, param) {
    var signed = param.signed;
    return {
        dynamic: false,
        encoded: (0, $f3VZN.numberToHex)(value, {
            size: 32,
            signed: signed
        })
    };
}
function $da814c8c18c2e1da$var$encodeString(value) {
    var hexValue = (0, $f3VZN.stringToHex)(value);
    var partsLength = Math.ceil((0, $dfJGH.size)(hexValue) / 32);
    var parts = [];
    for(var i = 0; i < partsLength; i++)parts.push((0, $b7M07.padHex)((0, $8SGIa.slice)(hexValue, i * 32, (i + 1) * 32), {
        dir: "right"
    }));
    return {
        dynamic: true,
        encoded: (0, $ewLmX.concat)([
            (0, $b7M07.padHex)((0, $f3VZN.numberToHex)((0, $dfJGH.size)(hexValue), {
                size: 32
            }))
        ].concat((0, $c6Xmf._)(parts)))
    };
}
function $da814c8c18c2e1da$var$encodeTuple(value, param) {
    var _$param = param.param;
    var dynamic = false;
    var preparedParams = [];
    for(var i = 0; i < _$param.components.length; i++){
        var param_ = _$param.components[i];
        var index = Array.isArray(value) ? i : param_.name;
        var preparedParam = $da814c8c18c2e1da$var$prepareParam({
            param: param_,
            value: value[index]
        });
        preparedParams.push(preparedParam);
        if (preparedParam.dynamic) dynamic = true;
    }
    return {
        dynamic: dynamic,
        encoded: dynamic ? $da814c8c18c2e1da$var$encodeParams(preparedParams) : (0, $ewLmX.concat)(preparedParams.map(function(param) {
            var encoded = param.encoded;
            return encoded;
        }))
    };
}
function $da814c8c18c2e1da$export$ab502cfdbb1a0d07(type) {
    var matches = type.match(/^(.*)\[(\d+)?\]$/);
    return matches ? [
        matches[2] ? Number(matches[2]) : null,
        matches[1]
    ] : undefined;
}

});



parcelRegister("3bePB", function(module, exports) {

$parcel$export(module.exports, "formatAbiItemWithArgs", function () { return $250de75d6b8a6c78$export$5266ec2b0e3e9205; });

var $lUgMT = parcelRequire("lUgMT");
function $250de75d6b8a6c78$export$5266ec2b0e3e9205(param) {
    var abiItem = param.abiItem, args = param.args, _param_includeFunctionName = param.includeFunctionName, includeFunctionName = _param_includeFunctionName === void 0 ? true : _param_includeFunctionName, _param_includeName = param.includeName, includeName = _param_includeName === void 0 ? false : _param_includeName;
    if (!("name" in abiItem)) return;
    if (!("inputs" in abiItem)) return;
    if (!abiItem.inputs) return;
    return "".concat(includeFunctionName ? abiItem.name : "", "(").concat(abiItem.inputs.map(function(input, i) {
        return "".concat(includeName && input.name ? "".concat(input.name, ": ") : "").concat(typeof args[i] === "object" ? (0, $lUgMT.stringify)(args[i]) : args[i]);
    }).join(", "), ")");
}

});

parcelRegister("lW5gB", function(module, exports) {

$parcel$export(module.exports, "getAbiItem", function () { return $ff8319a642e6b76d$export$99b134cd177e9574; });

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $l0HdX = parcelRequire("l0HdX");

var $fLalY = parcelRequire("fLalY");

var $aP7UT = parcelRequire("aP7UT");

var $7deC8 = parcelRequire("7deC8");

var $040Im = parcelRequire("040Im");

var $h023G = parcelRequire("h023G");
function $ff8319a642e6b76d$export$99b134cd177e9574(parameters) {
    var abi = parameters.abi, _parameters_args = parameters.args, args = _parameters_args === void 0 ? [] : _parameters_args, name = parameters.name;
    var isSelector = (0, $aP7UT.isHex)(name, {
        strict: false
    });
    var abiItems = abi.filter(function(abiItem) {
        if (isSelector) {
            if (abiItem.type === "function") return (0, $h023G.toFunctionSelector)(abiItem) === name;
            if (abiItem.type === "event") return (0, $040Im.toEventSelector)(abiItem) === name;
            return false;
        }
        return "name" in abiItem && abiItem.name === name;
    });
    if (abiItems.length === 0) return undefined;
    if (abiItems.length === 1) return abiItems[0];
    var matchedAbiItem = undefined;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var abiItem = _step.value;
            if (!("inputs" in abiItem)) return "continue";
            if (!args || args.length === 0) {
                if (!abiItem.inputs || abiItem.inputs.length === 0) return {
                    v: abiItem
                };
                return "continue";
            }
            if (!abiItem.inputs) return "continue";
            if (abiItem.inputs.length === 0) return "continue";
            if (abiItem.inputs.length !== args.length) return "continue";
            var matched = args.every(function(arg, index) {
                var abiParameter = "inputs" in abiItem && abiItem.inputs[index];
                if (!abiParameter) return false;
                return $ff8319a642e6b76d$export$697eff86d182a8c1(arg, abiParameter);
            });
            if (matched) {
                // Check for ambiguity against already matched parameters (e.g. `address` vs `bytes20`).
                if (matchedAbiItem && "inputs" in matchedAbiItem && matchedAbiItem.inputs) {
                    var ambiguousTypes = $ff8319a642e6b76d$export$79fd08820d2778aa(abiItem.inputs, matchedAbiItem.inputs, args);
                    if (ambiguousTypes) throw new (0, $fLalY.AbiItemAmbiguityError)({
                        abiItem: abiItem,
                        type: ambiguousTypes[0]
                    }, {
                        abiItem: matchedAbiItem,
                        type: ambiguousTypes[1]
                    });
                }
                matchedAbiItem = abiItem;
            }
        };
        for(var _iterator = abiItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop();
            if ((0, $l0HdX._)(_ret) === "object") return _ret.v;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (matchedAbiItem) return matchedAbiItem;
    return abiItems[0];
}
function $ff8319a642e6b76d$export$697eff86d182a8c1(arg, abiParameter) {
    var argType = typeof arg === "undefined" ? "undefined" : (0, $l0HdX._)(arg);
    var abiParameterType = abiParameter.type;
    switch(abiParameterType){
        case "address":
            return (0, $7deC8.isAddress)(arg, {
                strict: false
            });
        case "bool":
            return argType === "boolean";
        case "function":
            return argType === "string";
        case "string":
            return argType === "string";
        default:
            if (abiParameterType === "tuple" && "components" in abiParameter) return Object.values(abiParameter.components).every(function(component, index) {
                return $ff8319a642e6b76d$export$697eff86d182a8c1(Object.values(arg)[index], component);
            });
            // `(u)int<M>`: (un)signed integer type of `M` bits, `0 < M <= 256`, `M % 8 == 0`
            // https://regexr.com/6v8hp
            if (/^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/.test(abiParameterType)) return argType === "number" || argType === "bigint";
            // `bytes<M>`: binary type of `M` bytes, `0 < M <= 32`
            // https://regexr.com/6va55
            if (/^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/.test(abiParameterType)) return argType === "string" || arg instanceof Uint8Array;
            // fixed-length (`<type>[M]`) and dynamic (`<type>[]`) arrays
            // https://regexr.com/6va6i
            if (/[a-z]+[1-9]{0,3}(\[[0-9]{0,}\])+$/.test(abiParameterType)) return Array.isArray(arg) && arg.every(function(x) {
                return $ff8319a642e6b76d$export$697eff86d182a8c1(x, (0, $cxjpp._)((0, $do9pw._)({}, abiParameter), {
                    // Pop off `[]` or `[M]` from end of type
                    type: abiParameterType.replace(/(\[[0-9]{0,}\])$/, "")
                }));
            });
            return false;
    }
}
function $ff8319a642e6b76d$export$79fd08820d2778aa(sourceParameters, targetParameters, args) {
    var _loop = function(parameterIndex) {
        var sourceParameter = sourceParameters[parameterIndex];
        var targetParameter = targetParameters[parameterIndex];
        if (sourceParameter.type === "tuple" && targetParameter.type === "tuple" && "components" in sourceParameter && "components" in targetParameter) return {
            v: $ff8319a642e6b76d$export$79fd08820d2778aa(sourceParameter.components, targetParameter.components, args[parameterIndex])
        };
        var types = [
            sourceParameter.type,
            targetParameter.type
        ];
        var ambiguous = function() {
            if (types.includes("address") && types.includes("bytes20")) return true;
            if (types.includes("address") && types.includes("string")) return (0, $7deC8.isAddress)(args[parameterIndex], {
                strict: false
            });
            if (types.includes("address") && types.includes("bytes")) return (0, $7deC8.isAddress)(args[parameterIndex], {
                strict: false
            });
            return false;
        }();
        if (ambiguous) return {
            v: types
        };
    };
    for(var parameterIndex in sourceParameters){
        var _ret = _loop(parameterIndex);
        if ((0, $l0HdX._)(_ret) === "object") return _ret.v;
    }
    return;
}

});
parcelRegister("040Im", function(module, exports) {

$parcel$export(module.exports, "toEventSelector", function () { return $00c0edb3b8560ae7$export$351f40ec61b2972; });

var $bg6Lc = parcelRequire("bg6Lc");
var $00c0edb3b8560ae7$export$351f40ec61b2972 = (0, $bg6Lc.toSignatureHash);

});


parcelRegister("2LEmF", function(module, exports) {

$parcel$export(module.exports, "formatEther", function () { return $203f481c6fdeff37$export$11bc63b4c03ea518; });

var $bRSDw = parcelRequire("bRSDw");

var $4fKM9 = parcelRequire("4fKM9");
function $203f481c6fdeff37$export$11bc63b4c03ea518(wei) {
    var unit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "wei";
    return (0, $4fKM9.formatUnits)(wei, (0, $bRSDw.etherUnits)[unit]);
}

});
parcelRegister("bRSDw", function(module, exports) {

$parcel$export(module.exports, "etherUnits", function () { return $8a3f0698b023cb12$export$5bbd813111ed9646; });
$parcel$export(module.exports, "gweiUnits", function () { return $8a3f0698b023cb12$export$a26120bf8be88528; });
$parcel$export(module.exports, "weiUnits", function () { return $8a3f0698b023cb12$export$b959b3594ea07183; });
var $8a3f0698b023cb12$export$5bbd813111ed9646 = {
    gwei: 9,
    wei: 18
};
var $8a3f0698b023cb12$export$a26120bf8be88528 = {
    ether: -9,
    wei: 9
};
var $8a3f0698b023cb12$export$b959b3594ea07183 = {
    ether: -18,
    gwei: -9
};

});

parcelRegister("4fKM9", function(module, exports) {

$parcel$export(module.exports, "formatUnits", function () { return $318cd8c872dfe9dc$export$bd39b96f71da1885; });
/**
 *  Divides a number by a given exponent of base 10 (10exponent), and formats it into a string representation of the number..
 *
 * - Docs: https://viem.sh/docs/utilities/formatUnits
 *
 * @example
 * import { formatUnits } from 'viem'
 *
 * formatUnits(420000000000n, 9)
 * // '420'
 */ function $318cd8c872dfe9dc$export$bd39b96f71da1885(value, decimals) {
    var display = value.toString();
    var negative = display.startsWith("-");
    if (negative) display = display.slice(1);
    display = display.padStart(decimals, "0");
    var _ref = [
        display.slice(0, display.length - decimals),
        display.slice(display.length - decimals)
    ], integer = _ref[0], fraction = _ref[1];
    fraction = fraction.replace(/(0+)$/, "");
    return "".concat(negative ? "-" : "").concat(integer || "0").concat(fraction ? ".".concat(fraction) : "");
}

});


parcelRegister("PaOKy", function(module, exports) {

$parcel$export(module.exports, "formatGwei", function () { return $099d27ac8c506e7e$export$a716d64a7f646b61; });

var $bRSDw = parcelRequire("bRSDw");

var $4fKM9 = parcelRequire("4fKM9");
function $099d27ac8c506e7e$export$a716d64a7f646b61(wei) {
    var unit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "wei";
    return (0, $4fKM9.formatUnits)(wei, (0, $bRSDw.gweiUnits)[unit]);
}

});

parcelRegister("iyR6o", function(module, exports) {

$parcel$export(module.exports, "AccountStateConflictError", function () { return $037cb820d4a6cf1a$export$eb92af66de2d34c1; });
$parcel$export(module.exports, "StateAssignmentConflictError", function () { return $037cb820d4a6cf1a$export$3f829f5a43fdcc2e; });
$parcel$export(module.exports, "prettyStateOverride", function () { return $037cb820d4a6cf1a$export$d08c47f9c4a87c67; });

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $dRLPW = parcelRequire("dRLPW");

var $ohfOJ = parcelRequire("ohfOJ");

var $7ihh7 = parcelRequire("7ihh7");
var $037cb820d4a6cf1a$export$eb92af66de2d34c1 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(AccountStateConflictError, BaseError);
    var _super = (0, $ohfOJ._)(AccountStateConflictError);
    function AccountStateConflictError(param) {
        var address = param.address;
        (0, $4GJKx._)(this, AccountStateConflictError);
        return _super.call(this, 'State for account "'.concat(address, '" is set multiple times.'), {
            name: "AccountStateConflictError"
        });
    }
    return AccountStateConflictError;
}((0, $7ihh7.BaseError));
var $037cb820d4a6cf1a$export$3f829f5a43fdcc2e = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(StateAssignmentConflictError, BaseError);
    var _super = (0, $ohfOJ._)(StateAssignmentConflictError);
    function StateAssignmentConflictError() {
        (0, $4GJKx._)(this, StateAssignmentConflictError);
        return _super.call(this, "state and stateDiff are set on the same account.", {
            name: "StateAssignmentConflictError"
        });
    }
    return StateAssignmentConflictError;
}((0, $7ihh7.BaseError));
function $037cb820d4a6cf1a$export$4afb15becff191ad(stateMapping) {
    return stateMapping.reduce(function(pretty, param) {
        var slot = param.slot, value = param.value;
        return "".concat(pretty, "        ").concat(slot, ": ").concat(value, "\n");
    }, "");
}
function $037cb820d4a6cf1a$export$d08c47f9c4a87c67(stateOverride) {
    return stateOverride.reduce(function(pretty, _param) {
        var address = _param.address, state = (0, $dRLPW._)(_param, [
            "address"
        ]);
        var val = "".concat(pretty, "    ").concat(address, ":\n");
        if (state.nonce) val += "      nonce: ".concat(state.nonce, "\n");
        if (state.balance) val += "      balance: ".concat(state.balance, "\n");
        if (state.code) val += "      code: ".concat(state.code, "\n");
        if (state.state) {
            val += "      state:\n";
            val += $037cb820d4a6cf1a$export$4afb15becff191ad(state.state);
        }
        if (state.stateDiff) {
            val += "      stateDiff:\n";
            val += $037cb820d4a6cf1a$export$4afb15becff191ad(state.stateDiff);
        }
        return val;
    }, "  State Override:\n").slice(0, -1);
}

});

parcelRegister("hgawa", function(module, exports) {

$parcel$export(module.exports, "prettyPrint", function () { return $c90c16edb8d50c8f$export$cde3d1388a9feac3; });
$parcel$export(module.exports, "FeeConflictError", function () { return $c90c16edb8d50c8f$export$4e13f9693b10724d; });
$parcel$export(module.exports, "InvalidLegacyVError", function () { return $c90c16edb8d50c8f$export$8ffce3f13fa2ade4; });
$parcel$export(module.exports, "InvalidSerializableTransactionError", function () { return $c90c16edb8d50c8f$export$f2282ba9c8899971; });
$parcel$export(module.exports, "InvalidStorageKeySizeError", function () { return $c90c16edb8d50c8f$export$f5e370fd7cd91580; });
$parcel$export(module.exports, "TransactionExecutionError", function () { return $c90c16edb8d50c8f$export$17fc407b5aeb1e96; });
$parcel$export(module.exports, "TransactionNotFoundError", function () { return $c90c16edb8d50c8f$export$23c42bc218867b7c; });
$parcel$export(module.exports, "TransactionReceiptNotFoundError", function () { return $c90c16edb8d50c8f$export$df65591684d92652; });
$parcel$export(module.exports, "WaitForTransactionReceiptTimeoutError", function () { return $c90c16edb8d50c8f$export$69578a09754f4b33; });

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $ohfOJ = parcelRequire("ohfOJ");

var $2LEmF = parcelRequire("2LEmF");

var $PaOKy = parcelRequire("PaOKy");

var $7ihh7 = parcelRequire("7ihh7");
function $c90c16edb8d50c8f$export$cde3d1388a9feac3(args) {
    var entries = Object.entries(args).map(function(param) {
        var _param = (0, $cv9Rk._)(param, 2), key = _param[0], value = _param[1];
        if (value === undefined || value === false) return null;
        return [
            key,
            value
        ];
    }).filter(Boolean);
    var maxLength = entries.reduce(function(acc, param) {
        var _param = (0, $cv9Rk._)(param, 1), key = _param[0];
        return Math.max(acc, key.length);
    }, 0);
    return entries.map(function(param) {
        var _param = (0, $cv9Rk._)(param, 2), key = _param[0], value = _param[1];
        return "  ".concat("".concat(key, ":").padEnd(maxLength + 1), "  ").concat(value);
    }).join("\n");
}
var $c90c16edb8d50c8f$export$4e13f9693b10724d = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(FeeConflictError, BaseError);
    var _super = (0, $ohfOJ._)(FeeConflictError);
    function FeeConflictError() {
        (0, $4GJKx._)(this, FeeConflictError);
        return _super.call(this, [
            "Cannot specify both a `gasPrice` and a `maxFeePerGas`/`maxPriorityFeePerGas`.",
            "Use `maxFeePerGas`/`maxPriorityFeePerGas` for EIP-1559 compatible networks, and `gasPrice` for others."
        ].join("\n"), {
            name: "FeeConflictError"
        });
    }
    return FeeConflictError;
}((0, $7ihh7.BaseError));
var $c90c16edb8d50c8f$export$8ffce3f13fa2ade4 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(InvalidLegacyVError, BaseError);
    var _super = (0, $ohfOJ._)(InvalidLegacyVError);
    function InvalidLegacyVError(param) {
        var v = param.v;
        (0, $4GJKx._)(this, InvalidLegacyVError);
        return _super.call(this, 'Invalid `v` value "'.concat(v, '". Expected 27 or 28.'), {
            name: "InvalidLegacyVError"
        });
    }
    return InvalidLegacyVError;
}((0, $7ihh7.BaseError));
var $c90c16edb8d50c8f$export$f2282ba9c8899971 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(InvalidSerializableTransactionError, BaseError);
    var _super = (0, $ohfOJ._)(InvalidSerializableTransactionError);
    function InvalidSerializableTransactionError(param) {
        var transaction = param.transaction;
        (0, $4GJKx._)(this, InvalidSerializableTransactionError);
        return _super.call(this, "Cannot infer a transaction type from provided transaction.", {
            metaMessages: [
                "Provided Transaction:",
                "{",
                $c90c16edb8d50c8f$export$cde3d1388a9feac3(transaction),
                "}",
                "",
                "To infer the type, either provide:",
                "- a `type` to the Transaction, or",
                "- an EIP-1559 Transaction with `maxFeePerGas`, or",
                "- an EIP-2930 Transaction with `gasPrice` & `accessList`, or",
                "- an EIP-4844 Transaction with `blobs`, `blobVersionedHashes`, `sidecars`, or",
                "- an EIP-7702 Transaction with `authorizationList`, or",
                "- a Legacy Transaction with `gasPrice`"
            ],
            name: "InvalidSerializableTransactionError"
        });
    }
    return InvalidSerializableTransactionError;
}((0, $7ihh7.BaseError));
var $c90c16edb8d50c8f$export$e410925d6bb07863 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(InvalidSerializedTransactionTypeError, BaseError);
    var _super = (0, $ohfOJ._)(InvalidSerializedTransactionTypeError);
    function InvalidSerializedTransactionTypeError(param) {
        var serializedType = param.serializedType;
        (0, $4GJKx._)(this, InvalidSerializedTransactionTypeError);
        var _this;
        _this = _super.call(this, 'Serialized transaction type "'.concat(serializedType, '" is invalid.'), {
            name: "InvalidSerializedTransactionType"
        });
        Object.defineProperty((0, $d3H5E._)(_this), "serializedType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this.serializedType = serializedType;
        return _this;
    }
    return InvalidSerializedTransactionTypeError;
}((0, $7ihh7.BaseError));
var $c90c16edb8d50c8f$export$75fa267d8b74b3b9 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(InvalidSerializedTransactionError, BaseError);
    var _super = (0, $ohfOJ._)(InvalidSerializedTransactionError);
    function InvalidSerializedTransactionError(param) {
        var attributes = param.attributes, serializedTransaction = param.serializedTransaction, type = param.type;
        (0, $4GJKx._)(this, InvalidSerializedTransactionError);
        var _this;
        var missing = Object.entries(attributes).map(function(param) {
            var _param = (0, $cv9Rk._)(param, 2), key = _param[0], value = _param[1];
            return typeof value === "undefined" ? key : undefined;
        }).filter(Boolean);
        _this = _super.call(this, 'Invalid serialized transaction of type "'.concat(type, '" was provided.'), {
            metaMessages: [
                'Serialized Transaction: "'.concat(serializedTransaction, '"'),
                missing.length > 0 ? "Missing Attributes: ".concat(missing.join(", ")) : ""
            ].filter(Boolean),
            name: "InvalidSerializedTransactionError"
        });
        Object.defineProperty((0, $d3H5E._)(_this), "serializedTransaction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty((0, $d3H5E._)(_this), "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this.serializedTransaction = serializedTransaction;
        _this.type = type;
        return _this;
    }
    return InvalidSerializedTransactionError;
}((0, $7ihh7.BaseError));
var $c90c16edb8d50c8f$export$f5e370fd7cd91580 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(InvalidStorageKeySizeError, BaseError);
    var _super = (0, $ohfOJ._)(InvalidStorageKeySizeError);
    function InvalidStorageKeySizeError(param) {
        var storageKey = param.storageKey;
        (0, $4GJKx._)(this, InvalidStorageKeySizeError);
        return _super.call(this, 'Size for storage key "'.concat(storageKey, '" is invalid. Expected 32 bytes. Got ').concat(Math.floor((storageKey.length - 2) / 2), " bytes."), {
            name: "InvalidStorageKeySizeError"
        });
    }
    return InvalidStorageKeySizeError;
}((0, $7ihh7.BaseError));
var $c90c16edb8d50c8f$export$17fc407b5aeb1e96 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(TransactionExecutionError, BaseError);
    var _super = (0, $ohfOJ._)(TransactionExecutionError);
    function TransactionExecutionError(cause, param) {
        var account = param.account, docsPath = param.docsPath, chain = param.chain, data = param.data, gas = param.gas, gasPrice = param.gasPrice, maxFeePerGas = param.maxFeePerGas, maxPriorityFeePerGas = param.maxPriorityFeePerGas, nonce = param.nonce, to = param.to, value = param.value;
        (0, $4GJKx._)(this, TransactionExecutionError);
        var _this;
        var _chain_nativeCurrency;
        var prettyArgs = $c90c16edb8d50c8f$export$cde3d1388a9feac3({
            chain: chain && "".concat(chain === null || chain === void 0 ? void 0 : chain.name, " (id: ").concat(chain === null || chain === void 0 ? void 0 : chain.id, ")"),
            from: account === null || account === void 0 ? void 0 : account.address,
            to: to,
            value: typeof value !== "undefined" && "".concat((0, $2LEmF.formatEther)(value), " ").concat((chain === null || chain === void 0 ? void 0 : (_chain_nativeCurrency = chain.nativeCurrency) === null || _chain_nativeCurrency === void 0 ? void 0 : _chain_nativeCurrency.symbol) || "ETH"),
            data: data,
            gas: gas,
            gasPrice: typeof gasPrice !== "undefined" && "".concat((0, $PaOKy.formatGwei)(gasPrice), " gwei"),
            maxFeePerGas: typeof maxFeePerGas !== "undefined" && "".concat((0, $PaOKy.formatGwei)(maxFeePerGas), " gwei"),
            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== "undefined" && "".concat((0, $PaOKy.formatGwei)(maxPriorityFeePerGas), " gwei"),
            nonce: nonce
        });
        _this = _super.call(this, cause.shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: (0, $c6Xmf._)(cause.metaMessages ? (0, $c6Xmf._)(cause.metaMessages).concat([
                " "
            ]) : []).concat([
                "Request Arguments:",
                prettyArgs
            ]).filter(Boolean),
            name: "TransactionExecutionError"
        });
        Object.defineProperty((0, $d3H5E._)(_this), "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this.cause = cause;
        return _this;
    }
    return TransactionExecutionError;
}((0, $7ihh7.BaseError));
var $c90c16edb8d50c8f$export$23c42bc218867b7c = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(TransactionNotFoundError, BaseError);
    var _super = (0, $ohfOJ._)(TransactionNotFoundError);
    function TransactionNotFoundError(param) {
        var blockHash = param.blockHash, blockNumber = param.blockNumber, blockTag = param.blockTag, hash = param.hash, index = param.index;
        (0, $4GJKx._)(this, TransactionNotFoundError);
        var identifier = "Transaction";
        if (blockTag && index !== undefined) identifier = 'Transaction at block time "'.concat(blockTag, '" at index "').concat(index, '"');
        if (blockHash && index !== undefined) identifier = 'Transaction at block hash "'.concat(blockHash, '" at index "').concat(index, '"');
        if (blockNumber && index !== undefined) identifier = 'Transaction at block number "'.concat(blockNumber, '" at index "').concat(index, '"');
        if (hash) identifier = 'Transaction with hash "'.concat(hash, '"');
        return _super.call(this, "".concat(identifier, " could not be found."), {
            name: "TransactionNotFoundError"
        });
    }
    return TransactionNotFoundError;
}((0, $7ihh7.BaseError));
var $c90c16edb8d50c8f$export$df65591684d92652 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(TransactionReceiptNotFoundError, BaseError);
    var _super = (0, $ohfOJ._)(TransactionReceiptNotFoundError);
    function TransactionReceiptNotFoundError(param) {
        var hash = param.hash;
        (0, $4GJKx._)(this, TransactionReceiptNotFoundError);
        return _super.call(this, 'Transaction receipt with hash "'.concat(hash, '" could not be found. The Transaction may not be processed on a block yet.'), {
            name: "TransactionReceiptNotFoundError"
        });
    }
    return TransactionReceiptNotFoundError;
}((0, $7ihh7.BaseError));
var $c90c16edb8d50c8f$export$69578a09754f4b33 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(WaitForTransactionReceiptTimeoutError, BaseError);
    var _super = (0, $ohfOJ._)(WaitForTransactionReceiptTimeoutError);
    function WaitForTransactionReceiptTimeoutError(param) {
        var hash = param.hash;
        (0, $4GJKx._)(this, WaitForTransactionReceiptTimeoutError);
        return _super.call(this, 'Timed out while waiting for transaction with hash "'.concat(hash, '" to be confirmed.'), {
            name: "WaitForTransactionReceiptTimeoutError"
        });
    }
    return WaitForTransactionReceiptTimeoutError;
}((0, $7ihh7.BaseError));

});


parcelRegister("itJ66", function(module, exports) {

$parcel$export(module.exports, "decodeFunctionResult", function () { return $d73dead87ae63ca1$export$3a05a90c230f925; });

var $fLalY = parcelRequire("fLalY");

var $iYiQt = parcelRequire("iYiQt");

var $lW5gB = parcelRequire("lW5gB");
var $d73dead87ae63ca1$var$docsPath = "/docs/contract/decodeFunctionResult";
function $d73dead87ae63ca1$export$3a05a90c230f925(parameters) {
    var abi = parameters.abi, args = parameters.args, functionName = parameters.functionName, data = parameters.data;
    var abiItem = abi[0];
    if (functionName) {
        var item = (0, $lW5gB.getAbiItem)({
            abi: abi,
            args: args,
            name: functionName
        });
        if (!item) throw new (0, $fLalY.AbiFunctionNotFoundError)(functionName, {
            docsPath: $d73dead87ae63ca1$var$docsPath
        });
        abiItem = item;
    }
    if (abiItem.type !== "function") throw new (0, $fLalY.AbiFunctionNotFoundError)(undefined, {
        docsPath: $d73dead87ae63ca1$var$docsPath
    });
    if (!abiItem.outputs) throw new (0, $fLalY.AbiFunctionOutputsNotFoundError)(abiItem.name, {
        docsPath: $d73dead87ae63ca1$var$docsPath
    });
    var values = (0, $iYiQt.decodeAbiParameters)(abiItem.outputs, data);
    if (values && values.length > 1) return values;
    if (values && values.length === 1) return values[0];
    return undefined;
}

});

parcelRegister("af8cf", function(module, exports) {

$parcel$export(module.exports, "encodeDeployData", function () { return $7751a9bed8add2c7$export$d7a7276006273fbd; });

var $fLalY = parcelRequire("fLalY");

var $ewLmX = parcelRequire("ewLmX");

var $iL62l = parcelRequire("iL62l");
var $7751a9bed8add2c7$var$docsPath = "/docs/contract/encodeDeployData";
function $7751a9bed8add2c7$export$d7a7276006273fbd(parameters) {
    var abi = parameters.abi, args = parameters.args, bytecode = parameters.bytecode;
    if (!args || args.length === 0) return bytecode;
    var description = abi.find(function(x) {
        return "type" in x && x.type === "constructor";
    });
    if (!description) throw new (0, $fLalY.AbiConstructorNotFoundError)({
        docsPath: $7751a9bed8add2c7$var$docsPath
    });
    if (!("inputs" in description)) throw new (0, $fLalY.AbiConstructorParamsNotFoundError)({
        docsPath: $7751a9bed8add2c7$var$docsPath
    });
    if (!description.inputs || description.inputs.length === 0) throw new (0, $fLalY.AbiConstructorParamsNotFoundError)({
        docsPath: $7751a9bed8add2c7$var$docsPath
    });
    var data = (0, $iL62l.encodeAbiParameters)(description.inputs, args);
    return (0, $ewLmX.concatHex)([
        bytecode,
        data
    ]);
}

});

parcelRegister("cdvyV", function(module, exports) {

$parcel$export(module.exports, "encodeFunctionData", function () { return $8e4f2e86da0d23e4$export$f4ee15df45da9f03; });

var $ewLmX = parcelRequire("ewLmX");

var $iL62l = parcelRequire("iL62l");

var $fhZVy = parcelRequire("fhZVy");
function $8e4f2e86da0d23e4$export$f4ee15df45da9f03(parameters) {
    var args = parameters.args;
    var _ref = function() {
        var _parameters_functionName;
        if (parameters.abi.length === 1 && ((_parameters_functionName = parameters.functionName) === null || _parameters_functionName === void 0 ? void 0 : _parameters_functionName.startsWith("0x"))) return parameters;
        return (0, $fhZVy.prepareEncodeFunctionData)(parameters);
    }(), abi = _ref.abi, functionName = _ref.functionName;
    var abiItem = abi[0];
    var signature = functionName;
    var data = "inputs" in abiItem && abiItem.inputs ? (0, $iL62l.encodeAbiParameters)(abiItem.inputs, args !== null && args !== void 0 ? args : []) : undefined;
    return (0, $ewLmX.concatHex)([
        signature,
        data !== null && data !== void 0 ? data : "0x"
    ]);
}

});
parcelRegister("fhZVy", function(module, exports) {

$parcel$export(module.exports, "prepareEncodeFunctionData", function () { return $b2187b01ea3e580f$export$bb3e0a434581ff8; });

var $fLalY = parcelRequire("fLalY");

var $h023G = parcelRequire("h023G");

var $5FHHs = parcelRequire("5FHHs");

var $lW5gB = parcelRequire("lW5gB");
var $b2187b01ea3e580f$var$docsPath = "/docs/contract/encodeFunctionData";
function $b2187b01ea3e580f$export$bb3e0a434581ff8(parameters) {
    var abi = parameters.abi, args = parameters.args, functionName = parameters.functionName;
    var abiItem = abi[0];
    if (functionName) {
        var item = (0, $lW5gB.getAbiItem)({
            abi: abi,
            args: args,
            name: functionName
        });
        if (!item) throw new (0, $fLalY.AbiFunctionNotFoundError)(functionName, {
            docsPath: $b2187b01ea3e580f$var$docsPath
        });
        abiItem = item;
    }
    if (abiItem.type !== "function") throw new (0, $fLalY.AbiFunctionNotFoundError)(undefined, {
        docsPath: $b2187b01ea3e580f$var$docsPath
    });
    return {
        abi: [
            abiItem
        ],
        functionName: (0, $h023G.toFunctionSelector)((0, $5FHHs.formatAbiItem)(abiItem))
    };
}

});


parcelRegister("hpqb7", function(module, exports) {

$parcel$export(module.exports, "getChainContractAddress", function () { return $cac913f12b7a5b0a$export$cf4414608a078996; });

var $7yD9U = parcelRequire("7yD9U");
function $cac913f12b7a5b0a$export$cf4414608a078996(param) {
    var blockNumber = param.blockNumber, chain = param.chain, name = param.contract;
    var _chain_contracts;
    var contract = chain === null || chain === void 0 ? void 0 : (_chain_contracts = chain.contracts) === null || _chain_contracts === void 0 ? void 0 : _chain_contracts[name];
    if (!contract) throw new (0, $7yD9U.ChainDoesNotSupportContract)({
        chain: chain,
        contract: {
            name: name
        }
    });
    if (blockNumber && contract.blockCreated && contract.blockCreated > blockNumber) throw new (0, $7yD9U.ChainDoesNotSupportContract)({
        blockNumber: blockNumber,
        chain: chain,
        contract: {
            name: name,
            blockCreated: contract.blockCreated
        }
    });
    return contract.address;
}

});

parcelRegister("c4967", function(module, exports) {

$parcel$export(module.exports, "getCallError", function () { return $8c8cea5ff4a72736$export$7a3a4dfb724485e1; });

var $do9pw = parcelRequire("do9pw");

var $dRLPW = parcelRequire("dRLPW");

var $fZz5Q = parcelRequire("fZz5Q");

var $btxjr = parcelRequire("btxjr");

var $lVJzh = parcelRequire("lVJzh");
function $8c8cea5ff4a72736$export$7a3a4dfb724485e1(err, _param) {
    var docsPath = _param.docsPath, args = (0, $dRLPW._)(_param, [
        "docsPath"
    ]);
    var cause = function() {
        var cause = (0, $lVJzh.getNodeError)(err, args);
        if (cause instanceof (0, $btxjr.UnknownNodeError)) return err;
        return cause;
    }();
    return new (0, $fZz5Q.CallExecutionError)(cause, (0, $do9pw._)({
        docsPath: docsPath
    }, args));
}

});
parcelRegister("btxjr", function(module, exports) {

$parcel$export(module.exports, "ExecutionRevertedError", function () { return $85ac3e56e914424d$export$a558573a20f90d54; });
$parcel$export(module.exports, "FeeCapTooHighError", function () { return $85ac3e56e914424d$export$63c545de2a2ec844; });
$parcel$export(module.exports, "FeeCapTooLowError", function () { return $85ac3e56e914424d$export$dbd5936ae1758966; });
$parcel$export(module.exports, "NonceTooHighError", function () { return $85ac3e56e914424d$export$6147426561fdc965; });
$parcel$export(module.exports, "NonceTooLowError", function () { return $85ac3e56e914424d$export$2bb6d6395b589b3b; });
$parcel$export(module.exports, "NonceMaxValueError", function () { return $85ac3e56e914424d$export$71cf1d500f9be262; });
$parcel$export(module.exports, "InsufficientFundsError", function () { return $85ac3e56e914424d$export$b276096bbba16879; });
$parcel$export(module.exports, "IntrinsicGasTooHighError", function () { return $85ac3e56e914424d$export$7ad883b4998b9615; });
$parcel$export(module.exports, "IntrinsicGasTooLowError", function () { return $85ac3e56e914424d$export$813ccdcce0428bcf; });
$parcel$export(module.exports, "TransactionTypeNotSupportedError", function () { return $85ac3e56e914424d$export$a20c52a8beca5c20; });
$parcel$export(module.exports, "TipAboveFeeCapError", function () { return $85ac3e56e914424d$export$6ef9dd5e2f836046; });
$parcel$export(module.exports, "UnknownNodeError", function () { return $85ac3e56e914424d$export$d6085363229de344; });

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $PaOKy = parcelRequire("PaOKy");

var $7ihh7 = parcelRequire("7ihh7");
var $85ac3e56e914424d$export$a558573a20f90d54 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(ExecutionRevertedError, BaseError);
    var _super = (0, $ohfOJ._)(ExecutionRevertedError);
    function ExecutionRevertedError() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, cause = _ref.cause, message = _ref.message;
        (0, $4GJKx._)(this, ExecutionRevertedError);
        var _message_replace;
        var reason = message === null || message === void 0 ? void 0 : (_message_replace = message.replace("execution reverted: ", "")) === null || _message_replace === void 0 ? void 0 : _message_replace.replace("execution reverted", "");
        return _super.call(this, "Execution reverted ".concat(reason ? "with reason: ".concat(reason) : "for an unknown reason", "."), {
            cause: cause,
            name: "ExecutionRevertedError"
        });
    }
    return ExecutionRevertedError;
}((0, $7ihh7.BaseError));
Object.defineProperty($85ac3e56e914424d$export$a558573a20f90d54, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 3
});
Object.defineProperty($85ac3e56e914424d$export$a558573a20f90d54, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /execution reverted/
});
var $85ac3e56e914424d$export$63c545de2a2ec844 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(FeeCapTooHighError, BaseError);
    var _super = (0, $ohfOJ._)(FeeCapTooHighError);
    function FeeCapTooHighError() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, cause = _ref.cause, maxFeePerGas = _ref.maxFeePerGas;
        (0, $4GJKx._)(this, FeeCapTooHighError);
        return _super.call(this, "The fee cap (`maxFeePerGas`".concat(maxFeePerGas ? " = ".concat((0, $PaOKy.formatGwei)(maxFeePerGas), " gwei") : "", ") cannot be higher than the maximum allowed value (2^256-1)."), {
            cause: cause,
            name: "FeeCapTooHighError"
        });
    }
    return FeeCapTooHighError;
}((0, $7ihh7.BaseError));
Object.defineProperty($85ac3e56e914424d$export$63c545de2a2ec844, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /max fee per gas higher than 2\^256-1|fee cap higher than 2\^256-1/
});
var $85ac3e56e914424d$export$dbd5936ae1758966 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(FeeCapTooLowError, BaseError);
    var _super = (0, $ohfOJ._)(FeeCapTooLowError);
    function FeeCapTooLowError() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, cause = _ref.cause, maxFeePerGas = _ref.maxFeePerGas;
        (0, $4GJKx._)(this, FeeCapTooLowError);
        return _super.call(this, "The fee cap (`maxFeePerGas`".concat(maxFeePerGas ? " = ".concat((0, $PaOKy.formatGwei)(maxFeePerGas)) : "", " gwei) cannot be lower than the block base fee."), {
            cause: cause,
            name: "FeeCapTooLowError"
        });
    }
    return FeeCapTooLowError;
}((0, $7ihh7.BaseError));
Object.defineProperty($85ac3e56e914424d$export$dbd5936ae1758966, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /max fee per gas less than block base fee|fee cap less than block base fee|transaction is outdated/
});
var $85ac3e56e914424d$export$6147426561fdc965 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(NonceTooHighError, BaseError);
    var _super = (0, $ohfOJ._)(NonceTooHighError);
    function NonceTooHighError() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, cause = _ref.cause, nonce = _ref.nonce;
        (0, $4GJKx._)(this, NonceTooHighError);
        return _super.call(this, "Nonce provided for the transaction ".concat(nonce ? "(".concat(nonce, ") ") : "", "is higher than the next one expected."), {
            cause: cause,
            name: "NonceTooHighError"
        });
    }
    return NonceTooHighError;
}((0, $7ihh7.BaseError));
Object.defineProperty($85ac3e56e914424d$export$6147426561fdc965, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /nonce too high/
});
var $85ac3e56e914424d$export$2bb6d6395b589b3b = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(NonceTooLowError, BaseError);
    var _super = (0, $ohfOJ._)(NonceTooLowError);
    function NonceTooLowError() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, cause = _ref.cause, nonce = _ref.nonce;
        (0, $4GJKx._)(this, NonceTooLowError);
        return _super.call(this, [
            "Nonce provided for the transaction ".concat(nonce ? "(".concat(nonce, ") ") : "", "is lower than the current nonce of the account."),
            "Try increasing the nonce or find the latest nonce with `getTransactionCount`."
        ].join("\n"), {
            cause: cause,
            name: "NonceTooLowError"
        });
    }
    return NonceTooLowError;
}((0, $7ihh7.BaseError));
Object.defineProperty($85ac3e56e914424d$export$2bb6d6395b589b3b, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /nonce too low|transaction already imported|already known/
});
var $85ac3e56e914424d$export$71cf1d500f9be262 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(NonceMaxValueError, BaseError);
    var _super = (0, $ohfOJ._)(NonceMaxValueError);
    function NonceMaxValueError() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, cause = _ref.cause, nonce = _ref.nonce;
        (0, $4GJKx._)(this, NonceMaxValueError);
        return _super.call(this, "Nonce provided for the transaction ".concat(nonce ? "(".concat(nonce, ") ") : "", "exceeds the maximum allowed nonce."), {
            cause: cause,
            name: "NonceMaxValueError"
        });
    }
    return NonceMaxValueError;
}((0, $7ihh7.BaseError));
Object.defineProperty($85ac3e56e914424d$export$71cf1d500f9be262, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /nonce has max value/
});
var $85ac3e56e914424d$export$b276096bbba16879 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(InsufficientFundsError, BaseError);
    var _super = (0, $ohfOJ._)(InsufficientFundsError);
    function InsufficientFundsError() {
        var cause = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).cause;
        (0, $4GJKx._)(this, InsufficientFundsError);
        return _super.call(this, [
            "The total cost (gas * gas fee + value) of executing this transaction exceeds the balance of the account."
        ].join("\n"), {
            cause: cause,
            metaMessages: [
                "This error could arise when the account does not have enough funds to:",
                " - pay for the total gas fee,",
                " - pay for the value to send.",
                " ",
                "The cost of the transaction is calculated as `gas * gas fee + value`, where:",
                " - `gas` is the amount of gas needed for transaction to execute,",
                " - `gas fee` is the gas fee,",
                " - `value` is the amount of ether to send to the recipient."
            ],
            name: "InsufficientFundsError"
        });
    }
    return InsufficientFundsError;
}((0, $7ihh7.BaseError));
Object.defineProperty($85ac3e56e914424d$export$b276096bbba16879, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /insufficient funds|exceeds transaction sender account balance/
});
var $85ac3e56e914424d$export$7ad883b4998b9615 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(IntrinsicGasTooHighError, BaseError);
    var _super = (0, $ohfOJ._)(IntrinsicGasTooHighError);
    function IntrinsicGasTooHighError() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, cause = _ref.cause, gas = _ref.gas;
        (0, $4GJKx._)(this, IntrinsicGasTooHighError);
        return _super.call(this, "The amount of gas ".concat(gas ? "(".concat(gas, ") ") : "", "provided for the transaction exceeds the limit allowed for the block."), {
            cause: cause,
            name: "IntrinsicGasTooHighError"
        });
    }
    return IntrinsicGasTooHighError;
}((0, $7ihh7.BaseError));
Object.defineProperty($85ac3e56e914424d$export$7ad883b4998b9615, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /intrinsic gas too high|gas limit reached/
});
var $85ac3e56e914424d$export$813ccdcce0428bcf = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(IntrinsicGasTooLowError, BaseError);
    var _super = (0, $ohfOJ._)(IntrinsicGasTooLowError);
    function IntrinsicGasTooLowError() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, cause = _ref.cause, gas = _ref.gas;
        (0, $4GJKx._)(this, IntrinsicGasTooLowError);
        return _super.call(this, "The amount of gas ".concat(gas ? "(".concat(gas, ") ") : "", "provided for the transaction is too low."), {
            cause: cause,
            name: "IntrinsicGasTooLowError"
        });
    }
    return IntrinsicGasTooLowError;
}((0, $7ihh7.BaseError));
Object.defineProperty($85ac3e56e914424d$export$813ccdcce0428bcf, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /intrinsic gas too low/
});
var $85ac3e56e914424d$export$a20c52a8beca5c20 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(TransactionTypeNotSupportedError, BaseError);
    var _super = (0, $ohfOJ._)(TransactionTypeNotSupportedError);
    function TransactionTypeNotSupportedError(param) {
        var cause = param.cause;
        (0, $4GJKx._)(this, TransactionTypeNotSupportedError);
        return _super.call(this, "The transaction type is not supported for this chain.", {
            cause: cause,
            name: "TransactionTypeNotSupportedError"
        });
    }
    return TransactionTypeNotSupportedError;
}((0, $7ihh7.BaseError));
Object.defineProperty($85ac3e56e914424d$export$a20c52a8beca5c20, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /transaction type not valid/
});
var $85ac3e56e914424d$export$6ef9dd5e2f836046 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(TipAboveFeeCapError, BaseError);
    var _super = (0, $ohfOJ._)(TipAboveFeeCapError);
    function TipAboveFeeCapError() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, cause = _ref.cause, maxPriorityFeePerGas = _ref.maxPriorityFeePerGas, maxFeePerGas = _ref.maxFeePerGas;
        (0, $4GJKx._)(this, TipAboveFeeCapError);
        return _super.call(this, [
            "The provided tip (`maxPriorityFeePerGas`".concat(maxPriorityFeePerGas ? " = ".concat((0, $PaOKy.formatGwei)(maxPriorityFeePerGas), " gwei") : "", ") cannot be higher than the fee cap (`maxFeePerGas`").concat(maxFeePerGas ? " = ".concat((0, $PaOKy.formatGwei)(maxFeePerGas), " gwei") : "", ").")
        ].join("\n"), {
            cause: cause,
            name: "TipAboveFeeCapError"
        });
    }
    return TipAboveFeeCapError;
}((0, $7ihh7.BaseError));
Object.defineProperty($85ac3e56e914424d$export$6ef9dd5e2f836046, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /max priority fee per gas higher than max fee per gas|tip higher than fee cap/
});
var $85ac3e56e914424d$export$d6085363229de344 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(UnknownNodeError, BaseError);
    var _super = (0, $ohfOJ._)(UnknownNodeError);
    function UnknownNodeError(param) {
        var cause = param.cause;
        (0, $4GJKx._)(this, UnknownNodeError);
        return _super.call(this, "An error occurred while executing: ".concat(cause === null || cause === void 0 ? void 0 : cause.shortMessage), {
            cause: cause,
            name: "UnknownNodeError"
        });
    }
    return UnknownNodeError;
}((0, $7ihh7.BaseError));

});

parcelRegister("lVJzh", function(module, exports) {

$parcel$export(module.exports, "getNodeError", function () { return $ff7244b0c34a648f$export$218ee3a1c831c34e; });

var $7ihh7 = parcelRequire("7ihh7");

var $btxjr = parcelRequire("btxjr");

var $5yelF = parcelRequire("5yelF");

var $aqVrP = parcelRequire("aqVrP");
function $ff7244b0c34a648f$export$620efda101db5601(err) {
    return err instanceof (0, $aqVrP.TransactionRejectedRpcError) || err instanceof (0, $aqVrP.InvalidInputRpcError) || err instanceof (0, $5yelF.RpcRequestError) && err.code === (0, $btxjr.ExecutionRevertedError).code;
}
function $ff7244b0c34a648f$export$218ee3a1c831c34e(err, args) {
    var message = (err.details || "").toLowerCase();
    var executionRevertedError = err instanceof (0, $7ihh7.BaseError) ? err.walk(function(e) {
        return e.code === (0, $btxjr.ExecutionRevertedError).code;
    }) : err;
    if (executionRevertedError instanceof (0, $7ihh7.BaseError)) return new (0, $btxjr.ExecutionRevertedError)({
        cause: err,
        message: executionRevertedError.details
    });
    if ((0, $btxjr.ExecutionRevertedError).nodeMessage.test(message)) return new (0, $btxjr.ExecutionRevertedError)({
        cause: err,
        message: err.details
    });
    if ((0, $btxjr.FeeCapTooHighError).nodeMessage.test(message)) return new (0, $btxjr.FeeCapTooHighError)({
        cause: err,
        maxFeePerGas: args === null || args === void 0 ? void 0 : args.maxFeePerGas
    });
    if ((0, $btxjr.FeeCapTooLowError).nodeMessage.test(message)) return new (0, $btxjr.FeeCapTooLowError)({
        cause: err,
        maxFeePerGas: args === null || args === void 0 ? void 0 : args.maxFeePerGas
    });
    if ((0, $btxjr.NonceTooHighError).nodeMessage.test(message)) return new (0, $btxjr.NonceTooHighError)({
        cause: err,
        nonce: args === null || args === void 0 ? void 0 : args.nonce
    });
    if ((0, $btxjr.NonceTooLowError).nodeMessage.test(message)) return new (0, $btxjr.NonceTooLowError)({
        cause: err,
        nonce: args === null || args === void 0 ? void 0 : args.nonce
    });
    if ((0, $btxjr.NonceMaxValueError).nodeMessage.test(message)) return new (0, $btxjr.NonceMaxValueError)({
        cause: err,
        nonce: args === null || args === void 0 ? void 0 : args.nonce
    });
    if ((0, $btxjr.InsufficientFundsError).nodeMessage.test(message)) return new (0, $btxjr.InsufficientFundsError)({
        cause: err
    });
    if ((0, $btxjr.IntrinsicGasTooHighError).nodeMessage.test(message)) return new (0, $btxjr.IntrinsicGasTooHighError)({
        cause: err,
        gas: args === null || args === void 0 ? void 0 : args.gas
    });
    if ((0, $btxjr.IntrinsicGasTooLowError).nodeMessage.test(message)) return new (0, $btxjr.IntrinsicGasTooLowError)({
        cause: err,
        gas: args === null || args === void 0 ? void 0 : args.gas
    });
    if ((0, $btxjr.TransactionTypeNotSupportedError).nodeMessage.test(message)) return new (0, $btxjr.TransactionTypeNotSupportedError)({
        cause: err
    });
    if ((0, $btxjr.TipAboveFeeCapError).nodeMessage.test(message)) return new (0, $btxjr.TipAboveFeeCapError)({
        cause: err,
        maxFeePerGas: args === null || args === void 0 ? void 0 : args.maxFeePerGas,
        maxPriorityFeePerGas: args === null || args === void 0 ? void 0 : args.maxPriorityFeePerGas
    });
    return new (0, $btxjr.UnknownNodeError)({
        cause: err
    });
}

});
parcelRegister("aqVrP", function(module, exports) {

$parcel$export(module.exports, "ParseRpcError", function () { return $7988e50f8de303f7$export$aa31e6432f136746; });
$parcel$export(module.exports, "InvalidRequestRpcError", function () { return $7988e50f8de303f7$export$ff7b9f15f3eb8d4d; });
$parcel$export(module.exports, "MethodNotFoundRpcError", function () { return $7988e50f8de303f7$export$4c4044ac99c8d2d3; });
$parcel$export(module.exports, "InvalidParamsRpcError", function () { return $7988e50f8de303f7$export$c600faffd3cbd390; });
$parcel$export(module.exports, "InternalRpcError", function () { return $7988e50f8de303f7$export$4e62fafb20e19fd7; });
$parcel$export(module.exports, "InvalidInputRpcError", function () { return $7988e50f8de303f7$export$3ba2994324ab015e; });
$parcel$export(module.exports, "ResourceNotFoundRpcError", function () { return $7988e50f8de303f7$export$466772c50c6d6751; });
$parcel$export(module.exports, "ResourceUnavailableRpcError", function () { return $7988e50f8de303f7$export$270451347568a637; });
$parcel$export(module.exports, "TransactionRejectedRpcError", function () { return $7988e50f8de303f7$export$f714565c9176e28; });
$parcel$export(module.exports, "MethodNotSupportedRpcError", function () { return $7988e50f8de303f7$export$b106fe05a02d89c5; });
$parcel$export(module.exports, "LimitExceededRpcError", function () { return $7988e50f8de303f7$export$2c6f5ab73129d9d7; });
$parcel$export(module.exports, "JsonRpcVersionUnsupportedError", function () { return $7988e50f8de303f7$export$662f3764fa426a13; });
$parcel$export(module.exports, "UserRejectedRequestError", function () { return $7988e50f8de303f7$export$4af5b080d9e9e1a6; });
$parcel$export(module.exports, "UnauthorizedProviderError", function () { return $7988e50f8de303f7$export$cc1057a5779c7ffa; });
$parcel$export(module.exports, "UnsupportedProviderMethodError", function () { return $7988e50f8de303f7$export$6a557500ae315a49; });
$parcel$export(module.exports, "ProviderDisconnectedError", function () { return $7988e50f8de303f7$export$abb104bf1dd9c38b; });
$parcel$export(module.exports, "ChainDisconnectedError", function () { return $7988e50f8de303f7$export$ef186cf1cda0444; });
$parcel$export(module.exports, "SwitchChainError", function () { return $7988e50f8de303f7$export$d4ddb31968a9d366; });
$parcel$export(module.exports, "UnknownRpcError", function () { return $7988e50f8de303f7$export$bfc830e1ec76e31b; });

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $7ihh7 = parcelRequire("7ihh7");

var $5yelF = parcelRequire("5yelF");
var $7988e50f8de303f7$var$unknownErrorCode = -1;
var $7988e50f8de303f7$export$5460eff990f31920 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(RpcError, BaseError);
    var _super = (0, $ohfOJ._)(RpcError);
    function RpcError(cause, param) {
        var code = param.code, docsPath = param.docsPath, metaMessages = param.metaMessages, name = param.name, shortMessage = param.shortMessage;
        (0, $4GJKx._)(this, RpcError);
        var _this;
        _this = _super.call(this, shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: metaMessages || (cause === null || cause === void 0 ? void 0 : cause.metaMessages),
            name: name || "RpcError"
        });
        Object.defineProperty((0, $d3H5E._)(_this), "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this.name = name || cause.name;
        _this.code = cause instanceof (0, $5yelF.RpcRequestError) ? cause.code : code !== null && code !== void 0 ? code : $7988e50f8de303f7$var$unknownErrorCode;
        return _this;
    }
    return RpcError;
}((0, $7ihh7.BaseError));
var $7988e50f8de303f7$export$417589b978208a8f = /*#__PURE__*/ function(RpcError) {
    "use strict";
    (0, $dcsZi._)(ProviderRpcError, RpcError);
    var _super = (0, $ohfOJ._)(ProviderRpcError);
    function ProviderRpcError(cause, options) {
        (0, $4GJKx._)(this, ProviderRpcError);
        var _this;
        _this = _super.call(this, cause, options);
        Object.defineProperty((0, $d3H5E._)(_this), "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this.data = options.data;
        return _this;
    }
    return ProviderRpcError;
}($7988e50f8de303f7$export$5460eff990f31920);
var $7988e50f8de303f7$export$aa31e6432f136746 = /*#__PURE__*/ function(RpcError) {
    "use strict";
    (0, $dcsZi._)(ParseRpcError, RpcError);
    var _super = (0, $ohfOJ._)(ParseRpcError);
    function ParseRpcError(cause) {
        (0, $4GJKx._)(this, ParseRpcError);
        return _super.call(this, cause, {
            code: ParseRpcError.code,
            name: "ParseRpcError",
            shortMessage: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
        });
    }
    return ParseRpcError;
}($7988e50f8de303f7$export$5460eff990f31920);
Object.defineProperty($7988e50f8de303f7$export$aa31e6432f136746, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32700
});
var $7988e50f8de303f7$export$ff7b9f15f3eb8d4d = /*#__PURE__*/ function(RpcError) {
    "use strict";
    (0, $dcsZi._)(InvalidRequestRpcError, RpcError);
    var _super = (0, $ohfOJ._)(InvalidRequestRpcError);
    function InvalidRequestRpcError(cause) {
        (0, $4GJKx._)(this, InvalidRequestRpcError);
        return _super.call(this, cause, {
            code: InvalidRequestRpcError.code,
            name: "InvalidRequestRpcError",
            shortMessage: "JSON is not a valid request object."
        });
    }
    return InvalidRequestRpcError;
}($7988e50f8de303f7$export$5460eff990f31920);
Object.defineProperty($7988e50f8de303f7$export$ff7b9f15f3eb8d4d, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32600
});
var $7988e50f8de303f7$export$4c4044ac99c8d2d3 = /*#__PURE__*/ function(RpcError) {
    "use strict";
    (0, $dcsZi._)(MethodNotFoundRpcError, RpcError);
    var _super = (0, $ohfOJ._)(MethodNotFoundRpcError);
    function MethodNotFoundRpcError(cause) {
        var method = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).method;
        (0, $4GJKx._)(this, MethodNotFoundRpcError);
        return _super.call(this, cause, {
            code: MethodNotFoundRpcError.code,
            name: "MethodNotFoundRpcError",
            shortMessage: "The method".concat(method ? ' "'.concat(method, '"') : "", " does not exist / is not available.")
        });
    }
    return MethodNotFoundRpcError;
}($7988e50f8de303f7$export$5460eff990f31920);
Object.defineProperty($7988e50f8de303f7$export$4c4044ac99c8d2d3, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32601
});
var $7988e50f8de303f7$export$c600faffd3cbd390 = /*#__PURE__*/ function(RpcError) {
    "use strict";
    (0, $dcsZi._)(InvalidParamsRpcError, RpcError);
    var _super = (0, $ohfOJ._)(InvalidParamsRpcError);
    function InvalidParamsRpcError(cause) {
        (0, $4GJKx._)(this, InvalidParamsRpcError);
        return _super.call(this, cause, {
            code: InvalidParamsRpcError.code,
            name: "InvalidParamsRpcError",
            shortMessage: [
                "Invalid parameters were provided to the RPC method.",
                "Double check you have provided the correct parameters."
            ].join("\n")
        });
    }
    return InvalidParamsRpcError;
}($7988e50f8de303f7$export$5460eff990f31920);
Object.defineProperty($7988e50f8de303f7$export$c600faffd3cbd390, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32602
});
var $7988e50f8de303f7$export$4e62fafb20e19fd7 = /*#__PURE__*/ function(RpcError) {
    "use strict";
    (0, $dcsZi._)(InternalRpcError, RpcError);
    var _super = (0, $ohfOJ._)(InternalRpcError);
    function InternalRpcError(cause) {
        (0, $4GJKx._)(this, InternalRpcError);
        return _super.call(this, cause, {
            code: InternalRpcError.code,
            name: "InternalRpcError",
            shortMessage: "An internal error was received."
        });
    }
    return InternalRpcError;
}($7988e50f8de303f7$export$5460eff990f31920);
Object.defineProperty($7988e50f8de303f7$export$4e62fafb20e19fd7, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32603
});
var $7988e50f8de303f7$export$3ba2994324ab015e = /*#__PURE__*/ function(RpcError) {
    "use strict";
    (0, $dcsZi._)(InvalidInputRpcError, RpcError);
    var _super = (0, $ohfOJ._)(InvalidInputRpcError);
    function InvalidInputRpcError(cause) {
        (0, $4GJKx._)(this, InvalidInputRpcError);
        return _super.call(this, cause, {
            code: InvalidInputRpcError.code,
            name: "InvalidInputRpcError",
            shortMessage: [
                "Missing or invalid parameters.",
                "Double check you have provided the correct parameters."
            ].join("\n")
        });
    }
    return InvalidInputRpcError;
}($7988e50f8de303f7$export$5460eff990f31920);
Object.defineProperty($7988e50f8de303f7$export$3ba2994324ab015e, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32000
});
var $7988e50f8de303f7$export$466772c50c6d6751 = /*#__PURE__*/ function(RpcError) {
    "use strict";
    (0, $dcsZi._)(ResourceNotFoundRpcError, RpcError);
    var _super = (0, $ohfOJ._)(ResourceNotFoundRpcError);
    function ResourceNotFoundRpcError(cause) {
        (0, $4GJKx._)(this, ResourceNotFoundRpcError);
        var _this;
        _this = _super.call(this, cause, {
            code: ResourceNotFoundRpcError.code,
            name: "ResourceNotFoundRpcError",
            shortMessage: "Requested resource not found."
        });
        Object.defineProperty((0, $d3H5E._)(_this), "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ResourceNotFoundRpcError"
        });
        return _this;
    }
    return ResourceNotFoundRpcError;
}($7988e50f8de303f7$export$5460eff990f31920);
Object.defineProperty($7988e50f8de303f7$export$466772c50c6d6751, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32001
});
var $7988e50f8de303f7$export$270451347568a637 = /*#__PURE__*/ function(RpcError) {
    "use strict";
    (0, $dcsZi._)(ResourceUnavailableRpcError, RpcError);
    var _super = (0, $ohfOJ._)(ResourceUnavailableRpcError);
    function ResourceUnavailableRpcError(cause) {
        (0, $4GJKx._)(this, ResourceUnavailableRpcError);
        return _super.call(this, cause, {
            code: ResourceUnavailableRpcError.code,
            name: "ResourceUnavailableRpcError",
            shortMessage: "Requested resource not available."
        });
    }
    return ResourceUnavailableRpcError;
}($7988e50f8de303f7$export$5460eff990f31920);
Object.defineProperty($7988e50f8de303f7$export$270451347568a637, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32002
});
var $7988e50f8de303f7$export$f714565c9176e28 = /*#__PURE__*/ function(RpcError) {
    "use strict";
    (0, $dcsZi._)(TransactionRejectedRpcError, RpcError);
    var _super = (0, $ohfOJ._)(TransactionRejectedRpcError);
    function TransactionRejectedRpcError(cause) {
        (0, $4GJKx._)(this, TransactionRejectedRpcError);
        return _super.call(this, cause, {
            code: TransactionRejectedRpcError.code,
            name: "TransactionRejectedRpcError",
            shortMessage: "Transaction creation failed."
        });
    }
    return TransactionRejectedRpcError;
}($7988e50f8de303f7$export$5460eff990f31920);
Object.defineProperty($7988e50f8de303f7$export$f714565c9176e28, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32003
});
var $7988e50f8de303f7$export$b106fe05a02d89c5 = /*#__PURE__*/ function(RpcError) {
    "use strict";
    (0, $dcsZi._)(MethodNotSupportedRpcError, RpcError);
    var _super = (0, $ohfOJ._)(MethodNotSupportedRpcError);
    function MethodNotSupportedRpcError(cause) {
        var method = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).method;
        (0, $4GJKx._)(this, MethodNotSupportedRpcError);
        return _super.call(this, cause, {
            code: MethodNotSupportedRpcError.code,
            name: "MethodNotSupportedRpcError",
            shortMessage: "Method".concat(method ? ' "'.concat(method, '"') : "", " is not implemented.")
        });
    }
    return MethodNotSupportedRpcError;
}($7988e50f8de303f7$export$5460eff990f31920);
Object.defineProperty($7988e50f8de303f7$export$b106fe05a02d89c5, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32004
});
var $7988e50f8de303f7$export$2c6f5ab73129d9d7 = /*#__PURE__*/ function(RpcError) {
    "use strict";
    (0, $dcsZi._)(LimitExceededRpcError, RpcError);
    var _super = (0, $ohfOJ._)(LimitExceededRpcError);
    function LimitExceededRpcError(cause) {
        (0, $4GJKx._)(this, LimitExceededRpcError);
        return _super.call(this, cause, {
            code: LimitExceededRpcError.code,
            name: "LimitExceededRpcError",
            shortMessage: "Request exceeds defined limit."
        });
    }
    return LimitExceededRpcError;
}($7988e50f8de303f7$export$5460eff990f31920);
Object.defineProperty($7988e50f8de303f7$export$2c6f5ab73129d9d7, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32005
});
var $7988e50f8de303f7$export$662f3764fa426a13 = /*#__PURE__*/ function(RpcError) {
    "use strict";
    (0, $dcsZi._)(JsonRpcVersionUnsupportedError, RpcError);
    var _super = (0, $ohfOJ._)(JsonRpcVersionUnsupportedError);
    function JsonRpcVersionUnsupportedError(cause) {
        (0, $4GJKx._)(this, JsonRpcVersionUnsupportedError);
        return _super.call(this, cause, {
            code: JsonRpcVersionUnsupportedError.code,
            name: "JsonRpcVersionUnsupportedError",
            shortMessage: "Version of JSON-RPC protocol is not supported."
        });
    }
    return JsonRpcVersionUnsupportedError;
}($7988e50f8de303f7$export$5460eff990f31920);
Object.defineProperty($7988e50f8de303f7$export$662f3764fa426a13, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32006
});
var $7988e50f8de303f7$export$4af5b080d9e9e1a6 = /*#__PURE__*/ function(ProviderRpcError) {
    "use strict";
    (0, $dcsZi._)(UserRejectedRequestError, ProviderRpcError);
    var _super = (0, $ohfOJ._)(UserRejectedRequestError);
    function UserRejectedRequestError(cause) {
        (0, $4GJKx._)(this, UserRejectedRequestError);
        return _super.call(this, cause, {
            code: UserRejectedRequestError.code,
            name: "UserRejectedRequestError",
            shortMessage: "User rejected the request."
        });
    }
    return UserRejectedRequestError;
}($7988e50f8de303f7$export$417589b978208a8f);
Object.defineProperty($7988e50f8de303f7$export$4af5b080d9e9e1a6, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4001
});
var $7988e50f8de303f7$export$cc1057a5779c7ffa = /*#__PURE__*/ function(ProviderRpcError) {
    "use strict";
    (0, $dcsZi._)(UnauthorizedProviderError, ProviderRpcError);
    var _super = (0, $ohfOJ._)(UnauthorizedProviderError);
    function UnauthorizedProviderError(cause) {
        (0, $4GJKx._)(this, UnauthorizedProviderError);
        return _super.call(this, cause, {
            code: UnauthorizedProviderError.code,
            name: "UnauthorizedProviderError",
            shortMessage: "The requested method and/or account has not been authorized by the user."
        });
    }
    return UnauthorizedProviderError;
}($7988e50f8de303f7$export$417589b978208a8f);
Object.defineProperty($7988e50f8de303f7$export$cc1057a5779c7ffa, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4100
});
var $7988e50f8de303f7$export$6a557500ae315a49 = /*#__PURE__*/ function(ProviderRpcError) {
    "use strict";
    (0, $dcsZi._)(UnsupportedProviderMethodError, ProviderRpcError);
    var _super = (0, $ohfOJ._)(UnsupportedProviderMethodError);
    function UnsupportedProviderMethodError(cause) {
        var method = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).method;
        (0, $4GJKx._)(this, UnsupportedProviderMethodError);
        return _super.call(this, cause, {
            code: UnsupportedProviderMethodError.code,
            name: "UnsupportedProviderMethodError",
            shortMessage: "The Provider does not support the requested method".concat(method ? ' " '.concat(method, '"') : "", ".")
        });
    }
    return UnsupportedProviderMethodError;
}($7988e50f8de303f7$export$417589b978208a8f);
Object.defineProperty($7988e50f8de303f7$export$6a557500ae315a49, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4200
});
var $7988e50f8de303f7$export$abb104bf1dd9c38b = /*#__PURE__*/ function(ProviderRpcError) {
    "use strict";
    (0, $dcsZi._)(ProviderDisconnectedError, ProviderRpcError);
    var _super = (0, $ohfOJ._)(ProviderDisconnectedError);
    function ProviderDisconnectedError(cause) {
        (0, $4GJKx._)(this, ProviderDisconnectedError);
        return _super.call(this, cause, {
            code: ProviderDisconnectedError.code,
            name: "ProviderDisconnectedError",
            shortMessage: "The Provider is disconnected from all chains."
        });
    }
    return ProviderDisconnectedError;
}($7988e50f8de303f7$export$417589b978208a8f);
Object.defineProperty($7988e50f8de303f7$export$abb104bf1dd9c38b, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4900
});
var $7988e50f8de303f7$export$ef186cf1cda0444 = /*#__PURE__*/ function(ProviderRpcError) {
    "use strict";
    (0, $dcsZi._)(ChainDisconnectedError, ProviderRpcError);
    var _super = (0, $ohfOJ._)(ChainDisconnectedError);
    function ChainDisconnectedError(cause) {
        (0, $4GJKx._)(this, ChainDisconnectedError);
        return _super.call(this, cause, {
            code: ChainDisconnectedError.code,
            name: "ChainDisconnectedError",
            shortMessage: "The Provider is not connected to the requested chain."
        });
    }
    return ChainDisconnectedError;
}($7988e50f8de303f7$export$417589b978208a8f);
Object.defineProperty($7988e50f8de303f7$export$ef186cf1cda0444, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4901
});
var $7988e50f8de303f7$export$d4ddb31968a9d366 = /*#__PURE__*/ function(ProviderRpcError) {
    "use strict";
    (0, $dcsZi._)(SwitchChainError, ProviderRpcError);
    var _super = (0, $ohfOJ._)(SwitchChainError);
    function SwitchChainError(cause) {
        (0, $4GJKx._)(this, SwitchChainError);
        return _super.call(this, cause, {
            code: SwitchChainError.code,
            name: "SwitchChainError",
            shortMessage: "An error occurred when attempting to switch chain."
        });
    }
    return SwitchChainError;
}($7988e50f8de303f7$export$417589b978208a8f);
Object.defineProperty($7988e50f8de303f7$export$d4ddb31968a9d366, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4902
});
var $7988e50f8de303f7$export$bfc830e1ec76e31b = /*#__PURE__*/ function(RpcError) {
    "use strict";
    (0, $dcsZi._)(UnknownRpcError, RpcError);
    var _super = (0, $ohfOJ._)(UnknownRpcError);
    function UnknownRpcError(cause) {
        (0, $4GJKx._)(this, UnknownRpcError);
        return _super.call(this, cause, {
            name: "UnknownRpcError",
            shortMessage: "An unknown RPC error occurred."
        });
    }
    return UnknownRpcError;
}($7988e50f8de303f7$export$5460eff990f31920);

});



parcelRegister("6N8Zo", function(module, exports) {

$parcel$export(module.exports, "extract", function () { return $4f1e4ac19fae12d4$export$f9380c9a627682d3; });
/**
 * @description Picks out the keys from `value` that exist in the formatter..
 */ function $4f1e4ac19fae12d4$export$f9380c9a627682d3(value_, param) {
    var format = param.format;
    if (!format) return {};
    var value = {};
    function extract_(formatted) {
        var keys = Object.keys(formatted);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                if (key in value_) value[key] = value_[key];
                if (formatted[key] && typeof formatted[key] === "object" && !Array.isArray(formatted[key])) extract_(formatted[key]);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    var formatted = format(value_ || {});
    extract_(formatted);
    return value;
}

});

parcelRegister("17do3", function(module, exports) {

$parcel$export(module.exports, "formatTransactionRequest", function () { return $0d00d44589c1646c$export$d23fcba447c86a8e; });

var $do9pw = parcelRequire("do9pw");

var $f3VZN = parcelRequire("f3VZN");

var $2eyrN = parcelRequire("2eyrN");
var $0d00d44589c1646c$export$b2a848539dcbb25f = {
    legacy: "0x0",
    eip2930: "0x1",
    eip1559: "0x2",
    eip4844: "0x3",
    eip7702: "0x4"
};
function $0d00d44589c1646c$export$d23fcba447c86a8e(request) {
    var rpcRequest = {};
    if (typeof request.authorizationList !== "undefined") rpcRequest.authorizationList = $0d00d44589c1646c$var$formatAuthorizationList(request.authorizationList);
    if (typeof request.accessList !== "undefined") rpcRequest.accessList = request.accessList;
    if (typeof request.blobVersionedHashes !== "undefined") rpcRequest.blobVersionedHashes = request.blobVersionedHashes;
    if (typeof request.blobs !== "undefined") {
        if (typeof request.blobs[0] !== "string") rpcRequest.blobs = request.blobs.map(function(x) {
            return (0, $f3VZN.bytesToHex)(x);
        });
        else rpcRequest.blobs = request.blobs;
    }
    if (typeof request.data !== "undefined") rpcRequest.data = request.data;
    if (typeof request.from !== "undefined") rpcRequest.from = request.from;
    if (typeof request.gas !== "undefined") rpcRequest.gas = (0, $f3VZN.numberToHex)(request.gas);
    if (typeof request.gasPrice !== "undefined") rpcRequest.gasPrice = (0, $f3VZN.numberToHex)(request.gasPrice);
    if (typeof request.maxFeePerBlobGas !== "undefined") rpcRequest.maxFeePerBlobGas = (0, $f3VZN.numberToHex)(request.maxFeePerBlobGas);
    if (typeof request.maxFeePerGas !== "undefined") rpcRequest.maxFeePerGas = (0, $f3VZN.numberToHex)(request.maxFeePerGas);
    if (typeof request.maxPriorityFeePerGas !== "undefined") rpcRequest.maxPriorityFeePerGas = (0, $f3VZN.numberToHex)(request.maxPriorityFeePerGas);
    if (typeof request.nonce !== "undefined") rpcRequest.nonce = (0, $f3VZN.numberToHex)(request.nonce);
    if (typeof request.to !== "undefined") rpcRequest.to = request.to;
    if (typeof request.type !== "undefined") rpcRequest.type = $0d00d44589c1646c$export$b2a848539dcbb25f[request.type];
    if (typeof request.value !== "undefined") rpcRequest.value = (0, $f3VZN.numberToHex)(request.value);
    return rpcRequest;
}
var $0d00d44589c1646c$export$aba208618cee26e3 = /*#__PURE__*/ (0, $2eyrN.defineFormatter)("transactionRequest", $0d00d44589c1646c$export$d23fcba447c86a8e);
//////////////////////////////////////////////////////////////////////////////
function $0d00d44589c1646c$var$formatAuthorizationList(authorizationList) {
    return authorizationList.map(function(authorization) {
        return (0, $do9pw._)({
            address: authorization.contractAddress,
            r: authorization.r,
            s: authorization.s,
            chainId: (0, $f3VZN.numberToHex)(authorization.chainId),
            nonce: (0, $f3VZN.numberToHex)(authorization.nonce)
        }, typeof authorization.yParity !== "undefined" ? {
            yParity: (0, $f3VZN.numberToHex)(authorization.yParity)
        } : {}, typeof authorization.v !== "undefined" && typeof authorization.yParity === "undefined" ? {
            v: (0, $f3VZN.numberToHex)(authorization.v)
        } : {});
    });
}

});
parcelRegister("2eyrN", function(module, exports) {

$parcel$export(module.exports, "defineFormatter", function () { return $1a079c1bb4b03789$export$5d08535cc975931a; });

var $do9pw = parcelRequire("do9pw");
function $1a079c1bb4b03789$export$5d08535cc975931a(type, format) {
    return function(param) {
        var exclude = param.exclude, overrides = param.format;
        return {
            exclude: exclude,
            format: function(args) {
                var formatted = format(args);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (exclude) try {
                    for(var _iterator = exclude[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        delete formatted[key];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return (0, $do9pw._)({}, formatted, overrides(args));
            },
            type: type
        };
    };
}

});


parcelRegister("esvdW", function(module, exports) {

$parcel$export(module.exports, "createBatchScheduler", function () { return $a86be69ab4bbf8c4$export$24d3fde68b7c4167; });

var $kSuI9 = parcelRequire("kSuI9");

var $c6Xmf = parcelRequire("c6Xmf");

var $eha6O = parcelRequire("eha6O");
var $a86be69ab4bbf8c4$var$schedulerCache = /*#__PURE__*/ new Map();
function $a86be69ab4bbf8c4$export$24d3fde68b7c4167(param) {
    var fn = param.fn, id = param.id, shouldSplitBatch = param.shouldSplitBatch, _param_wait = param.wait, wait = _param_wait === void 0 ? 0 : _param_wait, sort = param.sort;
    var exec = function() {
        var _ref = (0, $kSuI9._)(function() {
            var scheduler, args;
            return (0, $eha6O.__generator)(this, function(_state) {
                scheduler = getScheduler();
                flush();
                args = scheduler.map(function(param) {
                    var args = param.args;
                    return args;
                });
                if (args.length === 0) return [
                    2
                ];
                fn(args).then(function(data) {
                    if (sort && Array.isArray(data)) data.sort(sort);
                    for(var i = 0; i < scheduler.length; i++){
                        var _pendingPromise_resolve;
                        var pendingPromise = scheduler[i].pendingPromise;
                        (_pendingPromise_resolve = pendingPromise.resolve) === null || _pendingPromise_resolve === void 0 ? void 0 : _pendingPromise_resolve.call(pendingPromise, [
                            data[i],
                            data
                        ]);
                    }
                }).catch(function(err) {
                    for(var i = 0; i < scheduler.length; i++){
                        var _pendingPromise_reject;
                        var pendingPromise = scheduler[i].pendingPromise;
                        (_pendingPromise_reject = pendingPromise.reject) === null || _pendingPromise_reject === void 0 ? void 0 : _pendingPromise_reject.call(pendingPromise, err);
                    }
                });
                return [
                    2
                ];
            });
        });
        return function exec() {
            return _ref.apply(this, arguments);
        };
    }();
    var flush = function() {
        return $a86be69ab4bbf8c4$var$schedulerCache.delete(id);
    };
    var getBatchedArgs = function() {
        return getScheduler().map(function(param) {
            var args = param.args;
            return args;
        });
    };
    var getScheduler = function() {
        return $a86be69ab4bbf8c4$var$schedulerCache.get(id) || [];
    };
    var setScheduler = function(item) {
        return $a86be69ab4bbf8c4$var$schedulerCache.set(id, (0, $c6Xmf._)(getScheduler()).concat([
            item
        ]));
    };
    return {
        flush: flush,
        schedule: function(args) {
            return (0, $kSuI9._)(function() {
                var pendingPromise, promise, split, hasActiveScheduler;
                return (0, $eha6O.__generator)(this, function(_state) {
                    pendingPromise = {};
                    promise = new Promise(function(resolve, reject) {
                        pendingPromise.resolve = resolve;
                        pendingPromise.reject = reject;
                    });
                    split = shouldSplitBatch === null || shouldSplitBatch === void 0 ? void 0 : shouldSplitBatch((0, $c6Xmf._)(getBatchedArgs()).concat([
                        args
                    ]));
                    if (split) exec();
                    hasActiveScheduler = getScheduler().length > 0;
                    if (hasActiveScheduler) {
                        setScheduler({
                            args: args,
                            pendingPromise: pendingPromise
                        });
                        return [
                            2,
                            promise
                        ];
                    }
                    setScheduler({
                        args: args,
                        pendingPromise: pendingPromise
                    });
                    setTimeout(exec, wait);
                    return [
                        2,
                        promise
                    ];
                });
            })();
        }
    };
}

});

parcelRegister("7h9bY", function(module, exports) {

$parcel$export(module.exports, "serializeStateOverride", function () { return $54c14052a360acef$export$f6da3c954eb711d6; });

var $dRLPW = parcelRequire("dRLPW");

var $5YJl8 = parcelRequire("5YJl8");

var $bD8YT = parcelRequire("bD8YT");

var $iyR6o = parcelRequire("iyR6o");

var $7deC8 = parcelRequire("7deC8");

var $f3VZN = parcelRequire("f3VZN");
function $54c14052a360acef$export$29e73cd11b306a76(stateMapping) {
    if (!stateMapping || stateMapping.length === 0) return undefined;
    return stateMapping.reduce(function(acc, param) {
        var slot = param.slot, value = param.value;
        if (slot.length !== 66) throw new (0, $bD8YT.InvalidBytesLengthError)({
            size: slot.length,
            targetSize: 66,
            type: "hex"
        });
        if (value.length !== 66) throw new (0, $bD8YT.InvalidBytesLengthError)({
            size: value.length,
            targetSize: 66,
            type: "hex"
        });
        acc[slot] = value;
        return acc;
    }, {});
}
function $54c14052a360acef$export$ff6c86decd3de345(parameters) {
    var balance = parameters.balance, nonce = parameters.nonce, state = parameters.state, stateDiff = parameters.stateDiff, code = parameters.code;
    var rpcAccountStateOverride = {};
    if (code !== undefined) rpcAccountStateOverride.code = code;
    if (balance !== undefined) rpcAccountStateOverride.balance = (0, $f3VZN.numberToHex)(balance);
    if (nonce !== undefined) rpcAccountStateOverride.nonce = (0, $f3VZN.numberToHex)(nonce);
    if (state !== undefined) rpcAccountStateOverride.state = $54c14052a360acef$export$29e73cd11b306a76(state);
    if (stateDiff !== undefined) {
        if (rpcAccountStateOverride.state) throw new (0, $iyR6o.StateAssignmentConflictError)();
        rpcAccountStateOverride.stateDiff = $54c14052a360acef$export$29e73cd11b306a76(stateDiff);
    }
    return rpcAccountStateOverride;
}
function $54c14052a360acef$export$f6da3c954eb711d6(parameters) {
    if (!parameters) return undefined;
    var rpcStateOverride = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = parameters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ref = _step.value;
            var address = _ref.address, accountState = (0, $dRLPW._)(_ref, [
                "address"
            ]);
            if (!(0, $7deC8.isAddress)(address, {
                strict: false
            })) throw new (0, $5YJl8.InvalidAddressError)({
                address: address
            });
            if (rpcStateOverride[address]) throw new (0, $iyR6o.AccountStateConflictError)({
                address: address
            });
            rpcStateOverride[address] = $54c14052a360acef$export$ff6c86decd3de345(accountState);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return rpcStateOverride;
}

});

parcelRegister("p2XJW", function(module, exports) {

$parcel$export(module.exports, "assertRequest", function () { return $04b4a23706ea18c8$export$5378021d985ceaf8; });

var $l2YyF = parcelRequire("l2YyF");

var $5YJl8 = parcelRequire("5YJl8");

var $btxjr = parcelRequire("btxjr");

var $hgawa = parcelRequire("hgawa");

var $7deC8 = parcelRequire("7deC8");
function $04b4a23706ea18c8$export$5378021d985ceaf8(args) {
    var account_ = args.account, gasPrice = args.gasPrice, maxFeePerGas = args.maxFeePerGas, maxPriorityFeePerGas = args.maxPriorityFeePerGas, to = args.to;
    var account = account_ ? (0, $l2YyF.parseAccount)(account_) : undefined;
    if (account && !(0, $7deC8.isAddress)(account.address)) throw new (0, $5YJl8.InvalidAddressError)({
        address: account.address
    });
    if (to && !(0, $7deC8.isAddress)(to)) throw new (0, $5YJl8.InvalidAddressError)({
        address: to
    });
    if (typeof gasPrice !== "undefined" && (typeof maxFeePerGas !== "undefined" || typeof maxPriorityFeePerGas !== "undefined")) throw new (0, $hgawa.FeeConflictError)();
    if (maxFeePerGas && maxFeePerGas > Math.pow(2n, 256n) - 1n) throw new (0, $btxjr.FeeCapTooHighError)({
        maxFeePerGas: maxFeePerGas
    });
    if (maxPriorityFeePerGas && maxFeePerGas && maxPriorityFeePerGas > maxFeePerGas) throw new (0, $btxjr.TipAboveFeeCapError)({
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas
    });
}

});

parcelRegister("apPuK", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("kxwhk")).then(function() {
    return parcelRequire("iPuXm");
});

});


parcelRegister("gdHfP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bcef69a70d431a1a$export$71511d61b312f219; });

var $hrk7H = parcelRequire("hrk7H");

var $djrl5 = parcelRequire("djrl5");

var $e8oCh = parcelRequire("e8oCh");

var $1hjNY = parcelRequire("1hjNY");
function $bcef69a70d431a1a$export$71511d61b312f219(arr) {
    return (0, $hrk7H._)(arr) || (0, $djrl5._)(arr) || (0, $1hjNY._)(arr) || (0, $e8oCh._)();
}

});

parcelRegister("2ULQQ", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("3FJXC")),
    (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("QlhGd"))
]).then(function() {
    return parcelRequire("eplKH");
});

});

parcelRegister("iMVEh", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("3FJXC")),
    (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("eLVyC"))
]).then(function() {
    return parcelRequire("dqERv");
});

});

parcelRegister("dqToa", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $9c78ab2530e2b49c$export$a7c73072b1a182ae; }, function (v) { return $9c78ab2530e2b49c$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $9c78ab2530e2b49c$export$9f27bc3417b4524d; }, function (v) { return $9c78ab2530e2b49c$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $9c78ab2530e2b49c$export$db77ccec0bb4ccac; }, function (v) { return $9c78ab2530e2b49c$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $9c78ab2530e2b49c$export$8392c0c9d3dcbd35; }, function (v) { return $9c78ab2530e2b49c$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $9c78ab2530e2b49c$export$ffb0004e005737fa; }, function (v) { return $9c78ab2530e2b49c$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $9c78ab2530e2b49c$export$b624eff549462981; }, function (v) { return $9c78ab2530e2b49c$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $9c78ab2530e2b49c$export$7897aa7841a5380c; }, function (v) { return $9c78ab2530e2b49c$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $9c78ab2530e2b49c$export$602eac185826482c; }, function (v) { return $9c78ab2530e2b49c$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $9c78ab2530e2b49c$export$e2c29f18771995cb; }, function (v) { return $9c78ab2530e2b49c$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $9c78ab2530e2b49c$export$5f8d39834fd61797; }, function (v) { return $9c78ab2530e2b49c$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $9c78ab2530e2b49c$export$74bf444e3cd11ea5; }, function (v) { return $9c78ab2530e2b49c$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $9c78ab2530e2b49c$export$998bcd577473dd93; }, function (v) { return $9c78ab2530e2b49c$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $9c78ab2530e2b49c$export$92387174baf9b227; }, function (v) { return $9c78ab2530e2b49c$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $9c78ab2530e2b49c$export$ec112efeb987d9c6; }, function (v) { return $9c78ab2530e2b49c$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $9c78ab2530e2b49c$export$b706b080d889d2c9; }, function (v) { return $9c78ab2530e2b49c$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $9c78ab2530e2b49c$export$5be5a87408f70ddc; }, function (v) { return $9c78ab2530e2b49c$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $9c78ab2530e2b49c$export$45a5e7f76e0caa8d; }, function (v) { return $9c78ab2530e2b49c$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $9c78ab2530e2b49c$export$455c2e768291efa6; }, function (v) { return $9c78ab2530e2b49c$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $9c78ab2530e2b49c$export$9522e17588c12572; }, function (v) { return $9c78ab2530e2b49c$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $9c78ab2530e2b49c$export$2110ac352bb060b9; }, function (v) { return $9c78ab2530e2b49c$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $9c78ab2530e2b49c$export$56885ab8b9c456ab; }, function (v) { return $9c78ab2530e2b49c$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $9c78ab2530e2b49c$export$d927fcb6adf8f9de; }, function (v) { return $9c78ab2530e2b49c$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $9c78ab2530e2b49c$export$b82d16f27459e05a; }, function (v) { return $9c78ab2530e2b49c$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $9c78ab2530e2b49c$export$522c17b4f5e123e8; }, function (v) { return $9c78ab2530e2b49c$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $9c78ab2530e2b49c$export$1aabd8a0274ecfd6; }, function (v) { return $9c78ab2530e2b49c$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $9c78ab2530e2b49c$export$3d6c20d97e46b957; }, function (v) { return $9c78ab2530e2b49c$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $9c78ab2530e2b49c$export$9b621391a187a31a; }, function (v) { return $9c78ab2530e2b49c$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $9c78ab2530e2b49c$export$f5bbd400c2f4426f; }, function (v) { return $9c78ab2530e2b49c$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9c78ab2530e2b49c$export$a7c73072b1a182ae;
var $9c78ab2530e2b49c$export$9f27bc3417b4524d;
var $9c78ab2530e2b49c$export$db77ccec0bb4ccac;
var $9c78ab2530e2b49c$export$8392c0c9d3dcbd35;
var $9c78ab2530e2b49c$export$ffb0004e005737fa;
var $9c78ab2530e2b49c$export$b624eff549462981;
var $9c78ab2530e2b49c$export$7897aa7841a5380c;
var $9c78ab2530e2b49c$export$602eac185826482c;
var $9c78ab2530e2b49c$export$e2c29f18771995cb;
var $9c78ab2530e2b49c$export$5f8d39834fd61797;
var $9c78ab2530e2b49c$export$74bf444e3cd11ea5;
var $9c78ab2530e2b49c$export$998bcd577473dd93;
var $9c78ab2530e2b49c$export$92387174baf9b227;
var $9c78ab2530e2b49c$export$ec112efeb987d9c6;
var $9c78ab2530e2b49c$export$b706b080d889d2c9;
var $9c78ab2530e2b49c$export$5be5a87408f70ddc;
var $9c78ab2530e2b49c$export$45a5e7f76e0caa8d;
var $9c78ab2530e2b49c$export$455c2e768291efa6;
var $9c78ab2530e2b49c$export$9522e17588c12572;
var $9c78ab2530e2b49c$export$2110ac352bb060b9;
var $9c78ab2530e2b49c$export$56885ab8b9c456ab;
var $9c78ab2530e2b49c$export$d927fcb6adf8f9de;
var $9c78ab2530e2b49c$export$b82d16f27459e05a;
var $9c78ab2530e2b49c$export$522c17b4f5e123e8;
var $9c78ab2530e2b49c$export$1aabd8a0274ecfd6;
var $9c78ab2530e2b49c$export$3d6c20d97e46b957;
var $9c78ab2530e2b49c$export$9b621391a187a31a;
var $9c78ab2530e2b49c$export$f5bbd400c2f4426f;
"use strict";
var $9c78ab2530e2b49c$var$b = Symbol.for("react.element"), $9c78ab2530e2b49c$var$c = Symbol.for("react.portal"), $9c78ab2530e2b49c$var$d = Symbol.for("react.fragment"), $9c78ab2530e2b49c$var$e = Symbol.for("react.strict_mode"), $9c78ab2530e2b49c$var$f = Symbol.for("react.profiler"), $9c78ab2530e2b49c$var$g = Symbol.for("react.provider"), $9c78ab2530e2b49c$var$h = Symbol.for("react.context"), $9c78ab2530e2b49c$var$k = Symbol.for("react.server_context"), $9c78ab2530e2b49c$var$l = Symbol.for("react.forward_ref"), $9c78ab2530e2b49c$var$m = Symbol.for("react.suspense"), $9c78ab2530e2b49c$var$n = Symbol.for("react.suspense_list"), $9c78ab2530e2b49c$var$p = Symbol.for("react.memo"), $9c78ab2530e2b49c$var$q = Symbol.for("react.lazy"), $9c78ab2530e2b49c$var$t = Symbol.for("react.offscreen"), $9c78ab2530e2b49c$var$u;
$9c78ab2530e2b49c$var$u = Symbol.for("react.module.reference");
function $9c78ab2530e2b49c$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $9c78ab2530e2b49c$var$b:
                switch(a = a.type, a){
                    case $9c78ab2530e2b49c$var$d:
                    case $9c78ab2530e2b49c$var$f:
                    case $9c78ab2530e2b49c$var$e:
                    case $9c78ab2530e2b49c$var$m:
                    case $9c78ab2530e2b49c$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $9c78ab2530e2b49c$var$k:
                            case $9c78ab2530e2b49c$var$h:
                            case $9c78ab2530e2b49c$var$l:
                            case $9c78ab2530e2b49c$var$q:
                            case $9c78ab2530e2b49c$var$p:
                            case $9c78ab2530e2b49c$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $9c78ab2530e2b49c$var$c:
                return r;
        }
    }
}
$9c78ab2530e2b49c$export$a7c73072b1a182ae = $9c78ab2530e2b49c$var$h;
$9c78ab2530e2b49c$export$9f27bc3417b4524d = $9c78ab2530e2b49c$var$g;
$9c78ab2530e2b49c$export$db77ccec0bb4ccac = $9c78ab2530e2b49c$var$b;
$9c78ab2530e2b49c$export$8392c0c9d3dcbd35 = $9c78ab2530e2b49c$var$l;
$9c78ab2530e2b49c$export$ffb0004e005737fa = $9c78ab2530e2b49c$var$d;
$9c78ab2530e2b49c$export$b624eff549462981 = $9c78ab2530e2b49c$var$q;
$9c78ab2530e2b49c$export$7897aa7841a5380c = $9c78ab2530e2b49c$var$p;
$9c78ab2530e2b49c$export$602eac185826482c = $9c78ab2530e2b49c$var$c;
$9c78ab2530e2b49c$export$e2c29f18771995cb = $9c78ab2530e2b49c$var$f;
$9c78ab2530e2b49c$export$5f8d39834fd61797 = $9c78ab2530e2b49c$var$e;
$9c78ab2530e2b49c$export$74bf444e3cd11ea5 = $9c78ab2530e2b49c$var$m;
$9c78ab2530e2b49c$export$998bcd577473dd93 = $9c78ab2530e2b49c$var$n;
$9c78ab2530e2b49c$export$92387174baf9b227 = function() {
    return !1;
};
$9c78ab2530e2b49c$export$ec112efeb987d9c6 = function() {
    return !1;
};
$9c78ab2530e2b49c$export$b706b080d889d2c9 = function(a) {
    return $9c78ab2530e2b49c$var$v(a) === $9c78ab2530e2b49c$var$h;
};
$9c78ab2530e2b49c$export$5be5a87408f70ddc = function(a) {
    return $9c78ab2530e2b49c$var$v(a) === $9c78ab2530e2b49c$var$g;
};
$9c78ab2530e2b49c$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $9c78ab2530e2b49c$var$b;
};
$9c78ab2530e2b49c$export$455c2e768291efa6 = function(a) {
    return $9c78ab2530e2b49c$var$v(a) === $9c78ab2530e2b49c$var$l;
};
$9c78ab2530e2b49c$export$9522e17588c12572 = function(a) {
    return $9c78ab2530e2b49c$var$v(a) === $9c78ab2530e2b49c$var$d;
};
$9c78ab2530e2b49c$export$2110ac352bb060b9 = function(a) {
    return $9c78ab2530e2b49c$var$v(a) === $9c78ab2530e2b49c$var$q;
};
$9c78ab2530e2b49c$export$56885ab8b9c456ab = function(a) {
    return $9c78ab2530e2b49c$var$v(a) === $9c78ab2530e2b49c$var$p;
};
$9c78ab2530e2b49c$export$d927fcb6adf8f9de = function(a) {
    return $9c78ab2530e2b49c$var$v(a) === $9c78ab2530e2b49c$var$c;
};
$9c78ab2530e2b49c$export$b82d16f27459e05a = function(a) {
    return $9c78ab2530e2b49c$var$v(a) === $9c78ab2530e2b49c$var$f;
};
$9c78ab2530e2b49c$export$522c17b4f5e123e8 = function(a) {
    return $9c78ab2530e2b49c$var$v(a) === $9c78ab2530e2b49c$var$e;
};
$9c78ab2530e2b49c$export$1aabd8a0274ecfd6 = function(a) {
    return $9c78ab2530e2b49c$var$v(a) === $9c78ab2530e2b49c$var$m;
};
$9c78ab2530e2b49c$export$3d6c20d97e46b957 = function(a) {
    return $9c78ab2530e2b49c$var$v(a) === $9c78ab2530e2b49c$var$n;
};
$9c78ab2530e2b49c$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $9c78ab2530e2b49c$var$d || a === $9c78ab2530e2b49c$var$f || a === $9c78ab2530e2b49c$var$e || a === $9c78ab2530e2b49c$var$m || a === $9c78ab2530e2b49c$var$n || a === $9c78ab2530e2b49c$var$t || "object" === typeof a && null !== a && (a.$$typeof === $9c78ab2530e2b49c$var$q || a.$$typeof === $9c78ab2530e2b49c$var$p || a.$$typeof === $9c78ab2530e2b49c$var$g || a.$$typeof === $9c78ab2530e2b49c$var$h || a.$$typeof === $9c78ab2530e2b49c$var$l || a.$$typeof === $9c78ab2530e2b49c$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$9c78ab2530e2b49c$export$f5bbd400c2f4426f = $9c78ab2530e2b49c$var$v;

});

parcelRegister("hwp41", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $cc18de02337931fa$export$2b8d127b894957b9; }, function (v) { return $cc18de02337931fa$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $cc18de02337931fa$export$cea3a54a6425200c; }, function (v) { return $cc18de02337931fa$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $cc18de02337931fa$export$a7c73072b1a182ae; }, function (v) { return $cc18de02337931fa$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $cc18de02337931fa$export$9f27bc3417b4524d; }, function (v) { return $cc18de02337931fa$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $cc18de02337931fa$export$db77ccec0bb4ccac; }, function (v) { return $cc18de02337931fa$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $cc18de02337931fa$export$8392c0c9d3dcbd35; }, function (v) { return $cc18de02337931fa$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $cc18de02337931fa$export$ffb0004e005737fa; }, function (v) { return $cc18de02337931fa$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $cc18de02337931fa$export$b624eff549462981; }, function (v) { return $cc18de02337931fa$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $cc18de02337931fa$export$7897aa7841a5380c; }, function (v) { return $cc18de02337931fa$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $cc18de02337931fa$export$602eac185826482c; }, function (v) { return $cc18de02337931fa$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $cc18de02337931fa$export$e2c29f18771995cb; }, function (v) { return $cc18de02337931fa$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $cc18de02337931fa$export$5f8d39834fd61797; }, function (v) { return $cc18de02337931fa$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $cc18de02337931fa$export$74bf444e3cd11ea5; }, function (v) { return $cc18de02337931fa$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $cc18de02337931fa$export$92387174baf9b227; }, function (v) { return $cc18de02337931fa$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $cc18de02337931fa$export$ec112efeb987d9c6; }, function (v) { return $cc18de02337931fa$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $cc18de02337931fa$export$b706b080d889d2c9; }, function (v) { return $cc18de02337931fa$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $cc18de02337931fa$export$5be5a87408f70ddc; }, function (v) { return $cc18de02337931fa$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $cc18de02337931fa$export$45a5e7f76e0caa8d; }, function (v) { return $cc18de02337931fa$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $cc18de02337931fa$export$455c2e768291efa6; }, function (v) { return $cc18de02337931fa$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $cc18de02337931fa$export$9522e17588c12572; }, function (v) { return $cc18de02337931fa$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $cc18de02337931fa$export$2110ac352bb060b9; }, function (v) { return $cc18de02337931fa$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $cc18de02337931fa$export$56885ab8b9c456ab; }, function (v) { return $cc18de02337931fa$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $cc18de02337931fa$export$d927fcb6adf8f9de; }, function (v) { return $cc18de02337931fa$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $cc18de02337931fa$export$b82d16f27459e05a; }, function (v) { return $cc18de02337931fa$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $cc18de02337931fa$export$522c17b4f5e123e8; }, function (v) { return $cc18de02337931fa$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $cc18de02337931fa$export$1aabd8a0274ecfd6; }, function (v) { return $cc18de02337931fa$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $cc18de02337931fa$export$9b621391a187a31a; }, function (v) { return $cc18de02337931fa$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $cc18de02337931fa$export$f5bbd400c2f4426f; }, function (v) { return $cc18de02337931fa$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cc18de02337931fa$export$2b8d127b894957b9;
var $cc18de02337931fa$export$cea3a54a6425200c;
var $cc18de02337931fa$export$a7c73072b1a182ae;
var $cc18de02337931fa$export$9f27bc3417b4524d;
var $cc18de02337931fa$export$db77ccec0bb4ccac;
var $cc18de02337931fa$export$8392c0c9d3dcbd35;
var $cc18de02337931fa$export$ffb0004e005737fa;
var $cc18de02337931fa$export$b624eff549462981;
var $cc18de02337931fa$export$7897aa7841a5380c;
var $cc18de02337931fa$export$602eac185826482c;
var $cc18de02337931fa$export$e2c29f18771995cb;
var $cc18de02337931fa$export$5f8d39834fd61797;
var $cc18de02337931fa$export$74bf444e3cd11ea5;
var $cc18de02337931fa$export$92387174baf9b227;
var $cc18de02337931fa$export$ec112efeb987d9c6;
var $cc18de02337931fa$export$b706b080d889d2c9;
var $cc18de02337931fa$export$5be5a87408f70ddc;
var $cc18de02337931fa$export$45a5e7f76e0caa8d;
var $cc18de02337931fa$export$455c2e768291efa6;
var $cc18de02337931fa$export$9522e17588c12572;
var $cc18de02337931fa$export$2110ac352bb060b9;
var $cc18de02337931fa$export$56885ab8b9c456ab;
var $cc18de02337931fa$export$d927fcb6adf8f9de;
var $cc18de02337931fa$export$b82d16f27459e05a;
var $cc18de02337931fa$export$522c17b4f5e123e8;
var $cc18de02337931fa$export$1aabd8a0274ecfd6;
var $cc18de02337931fa$export$9b621391a187a31a;
var $cc18de02337931fa$export$f5bbd400c2f4426f;
"use strict";
var $cc18de02337931fa$var$b = "function" === typeof Symbol && Symbol.for, $cc18de02337931fa$var$c = $cc18de02337931fa$var$b ? Symbol.for("react.element") : 60103, $cc18de02337931fa$var$d = $cc18de02337931fa$var$b ? Symbol.for("react.portal") : 60106, $cc18de02337931fa$var$e = $cc18de02337931fa$var$b ? Symbol.for("react.fragment") : 60107, $cc18de02337931fa$var$f = $cc18de02337931fa$var$b ? Symbol.for("react.strict_mode") : 60108, $cc18de02337931fa$var$g = $cc18de02337931fa$var$b ? Symbol.for("react.profiler") : 60114, $cc18de02337931fa$var$h = $cc18de02337931fa$var$b ? Symbol.for("react.provider") : 60109, $cc18de02337931fa$var$k = $cc18de02337931fa$var$b ? Symbol.for("react.context") : 60110, $cc18de02337931fa$var$l = $cc18de02337931fa$var$b ? Symbol.for("react.async_mode") : 60111, $cc18de02337931fa$var$m = $cc18de02337931fa$var$b ? Symbol.for("react.concurrent_mode") : 60111, $cc18de02337931fa$var$n = $cc18de02337931fa$var$b ? Symbol.for("react.forward_ref") : 60112, $cc18de02337931fa$var$p = $cc18de02337931fa$var$b ? Symbol.for("react.suspense") : 60113, $cc18de02337931fa$var$q = $cc18de02337931fa$var$b ? Symbol.for("react.suspense_list") : 60120, $cc18de02337931fa$var$r = $cc18de02337931fa$var$b ? Symbol.for("react.memo") : 60115, $cc18de02337931fa$var$t = $cc18de02337931fa$var$b ? Symbol.for("react.lazy") : 60116, $cc18de02337931fa$var$v = $cc18de02337931fa$var$b ? Symbol.for("react.block") : 60121, $cc18de02337931fa$var$w = $cc18de02337931fa$var$b ? Symbol.for("react.fundamental") : 60117, $cc18de02337931fa$var$x = $cc18de02337931fa$var$b ? Symbol.for("react.responder") : 60118, $cc18de02337931fa$var$y = $cc18de02337931fa$var$b ? Symbol.for("react.scope") : 60119;
function $cc18de02337931fa$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $cc18de02337931fa$var$c:
                switch(a = a.type, a){
                    case $cc18de02337931fa$var$l:
                    case $cc18de02337931fa$var$m:
                    case $cc18de02337931fa$var$e:
                    case $cc18de02337931fa$var$g:
                    case $cc18de02337931fa$var$f:
                    case $cc18de02337931fa$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $cc18de02337931fa$var$k:
                            case $cc18de02337931fa$var$n:
                            case $cc18de02337931fa$var$t:
                            case $cc18de02337931fa$var$r:
                            case $cc18de02337931fa$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $cc18de02337931fa$var$d:
                return u;
        }
    }
}
function $cc18de02337931fa$var$A(a) {
    return $cc18de02337931fa$var$z(a) === $cc18de02337931fa$var$m;
}
$cc18de02337931fa$export$2b8d127b894957b9 = $cc18de02337931fa$var$l;
$cc18de02337931fa$export$cea3a54a6425200c = $cc18de02337931fa$var$m;
$cc18de02337931fa$export$a7c73072b1a182ae = $cc18de02337931fa$var$k;
$cc18de02337931fa$export$9f27bc3417b4524d = $cc18de02337931fa$var$h;
$cc18de02337931fa$export$db77ccec0bb4ccac = $cc18de02337931fa$var$c;
$cc18de02337931fa$export$8392c0c9d3dcbd35 = $cc18de02337931fa$var$n;
$cc18de02337931fa$export$ffb0004e005737fa = $cc18de02337931fa$var$e;
$cc18de02337931fa$export$b624eff549462981 = $cc18de02337931fa$var$t;
$cc18de02337931fa$export$7897aa7841a5380c = $cc18de02337931fa$var$r;
$cc18de02337931fa$export$602eac185826482c = $cc18de02337931fa$var$d;
$cc18de02337931fa$export$e2c29f18771995cb = $cc18de02337931fa$var$g;
$cc18de02337931fa$export$5f8d39834fd61797 = $cc18de02337931fa$var$f;
$cc18de02337931fa$export$74bf444e3cd11ea5 = $cc18de02337931fa$var$p;
$cc18de02337931fa$export$92387174baf9b227 = function(a) {
    return $cc18de02337931fa$var$A(a) || $cc18de02337931fa$var$z(a) === $cc18de02337931fa$var$l;
};
$cc18de02337931fa$export$ec112efeb987d9c6 = $cc18de02337931fa$var$A;
$cc18de02337931fa$export$b706b080d889d2c9 = function(a) {
    return $cc18de02337931fa$var$z(a) === $cc18de02337931fa$var$k;
};
$cc18de02337931fa$export$5be5a87408f70ddc = function(a) {
    return $cc18de02337931fa$var$z(a) === $cc18de02337931fa$var$h;
};
$cc18de02337931fa$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $cc18de02337931fa$var$c;
};
$cc18de02337931fa$export$455c2e768291efa6 = function(a) {
    return $cc18de02337931fa$var$z(a) === $cc18de02337931fa$var$n;
};
$cc18de02337931fa$export$9522e17588c12572 = function(a) {
    return $cc18de02337931fa$var$z(a) === $cc18de02337931fa$var$e;
};
$cc18de02337931fa$export$2110ac352bb060b9 = function(a) {
    return $cc18de02337931fa$var$z(a) === $cc18de02337931fa$var$t;
};
$cc18de02337931fa$export$56885ab8b9c456ab = function(a) {
    return $cc18de02337931fa$var$z(a) === $cc18de02337931fa$var$r;
};
$cc18de02337931fa$export$d927fcb6adf8f9de = function(a) {
    return $cc18de02337931fa$var$z(a) === $cc18de02337931fa$var$d;
};
$cc18de02337931fa$export$b82d16f27459e05a = function(a) {
    return $cc18de02337931fa$var$z(a) === $cc18de02337931fa$var$g;
};
$cc18de02337931fa$export$522c17b4f5e123e8 = function(a) {
    return $cc18de02337931fa$var$z(a) === $cc18de02337931fa$var$f;
};
$cc18de02337931fa$export$1aabd8a0274ecfd6 = function(a) {
    return $cc18de02337931fa$var$z(a) === $cc18de02337931fa$var$p;
};
$cc18de02337931fa$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $cc18de02337931fa$var$e || a === $cc18de02337931fa$var$m || a === $cc18de02337931fa$var$g || a === $cc18de02337931fa$var$f || a === $cc18de02337931fa$var$p || a === $cc18de02337931fa$var$q || "object" === typeof a && null !== a && (a.$$typeof === $cc18de02337931fa$var$t || a.$$typeof === $cc18de02337931fa$var$r || a.$$typeof === $cc18de02337931fa$var$h || a.$$typeof === $cc18de02337931fa$var$k || a.$$typeof === $cc18de02337931fa$var$n || a.$$typeof === $cc18de02337931fa$var$w || a.$$typeof === $cc18de02337931fa$var$x || a.$$typeof === $cc18de02337931fa$var$y || a.$$typeof === $cc18de02337931fa$var$v);
};
$cc18de02337931fa$export$f5bbd400c2f4426f = $cc18de02337931fa$var$z;

});

parcelRegister("7YhYp", function(module, exports) {

$parcel$export(module.exports, "isAddressEqual", function () { return $5cdc1420af27a9b2$export$34ca016df7f376b8; });

var $5YJl8 = parcelRequire("5YJl8");

var $7deC8 = parcelRequire("7deC8");
function $5cdc1420af27a9b2$export$34ca016df7f376b8(a, b) {
    if (!(0, $7deC8.isAddress)(a, {
        strict: false
    })) throw new (0, $5YJl8.InvalidAddressError)({
        address: a
    });
    if (!(0, $7deC8.isAddress)(b, {
        strict: false
    })) throw new (0, $5YJl8.InvalidAddressError)({
        address: b
    });
    return a.toLowerCase() === b.toLowerCase();
}

});

parcelRegister("9i2gq", function(module, exports) {

$parcel$export(module.exports, "secp256k1", function () { return $6c378d1714a5ac0e$export$529e6123e9353a90; });
$parcel$export(module.exports, "schnorr", function () { return $6c378d1714a5ac0e$export$1f2401df071be9f; });
$parcel$export(module.exports, "hashToCurve", function () { return $6c378d1714a5ac0e$export$a95cc2b0cdb9c1e1; });
$parcel$export(module.exports, "encodeToCurve", function () { return $6c378d1714a5ac0e$export$124e820e7679cc3; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $c6Xmf = parcelRequire("c6Xmf");

var $l0HdX = parcelRequire("l0HdX");

var $fjRrf = parcelRequire("fjRrf");

var $8ybNC = parcelRequire("8ybNC");

var $bb46G = parcelRequire("bb46G");

var $93C41 = parcelRequire("93C41");

var $fLMRX = parcelRequire("fLMRX");

var $htkZk = parcelRequire("htkZk");

var $6y2wD = parcelRequire("6y2wD");
var $6c378d1714a5ac0e$var$secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f");
var $6c378d1714a5ac0e$var$secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
var $6c378d1714a5ac0e$var$_1n = BigInt(1);
var $6c378d1714a5ac0e$var$_2n = BigInt(2);
var $6c378d1714a5ac0e$var$divNearest = function(a, b) {
    return (a + b / $6c378d1714a5ac0e$var$_2n) / b;
};
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $6c378d1714a5ac0e$var$sqrtMod(y) {
    var P = $6c378d1714a5ac0e$var$secp256k1P;
    // prettier-ignore
    var _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    var _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    var b2 = y * y * y % P; // x^3, 11
    var b3 = b2 * b2 * y % P; // x^7
    var b6 = (0, $bb46G.pow2)(b3, _3n, P) * b3 % P;
    var b9 = (0, $bb46G.pow2)(b6, _3n, P) * b3 % P;
    var b11 = (0, $bb46G.pow2)(b9, $6c378d1714a5ac0e$var$_2n, P) * b2 % P;
    var b22 = (0, $bb46G.pow2)(b11, _11n, P) * b11 % P;
    var b44 = (0, $bb46G.pow2)(b22, _22n, P) * b22 % P;
    var b88 = (0, $bb46G.pow2)(b44, _44n, P) * b44 % P;
    var b176 = (0, $bb46G.pow2)(b88, _88n, P) * b88 % P;
    var b220 = (0, $bb46G.pow2)(b176, _44n, P) * b44 % P;
    var b223 = (0, $bb46G.pow2)(b220, _3n, P) * b3 % P;
    var t1 = (0, $bb46G.pow2)(b223, _23n, P) * b22 % P;
    var t2 = (0, $bb46G.pow2)(t1, _6n, P) * b2 % P;
    var root = (0, $bb46G.pow2)(t2, $6c378d1714a5ac0e$var$_2n, P);
    if (!$6c378d1714a5ac0e$var$Fp.eql($6c378d1714a5ac0e$var$Fp.sqr(root), y)) throw new Error("Cannot find square root");
    return root;
}
var $6c378d1714a5ac0e$var$Fp = (0, $bb46G.Field)($6c378d1714a5ac0e$var$secp256k1P, undefined, undefined, {
    sqrt: $6c378d1714a5ac0e$var$sqrtMod
});
var $6c378d1714a5ac0e$export$529e6123e9353a90 = (0, $6y2wD.createCurve)({
    a: BigInt(0),
    b: BigInt(7),
    Fp: $6c378d1714a5ac0e$var$Fp,
    n: $6c378d1714a5ac0e$var$secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: true,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */ endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: function(k) {
            var n = $6c378d1714a5ac0e$var$secp256k1N;
            var a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
            var b1 = -$6c378d1714a5ac0e$var$_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
            var a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
            var b2 = a1;
            var POW_2_128 = BigInt("0x100000000000000000000000000000000"); // (2n**128n).toString(16)
            var c1 = $6c378d1714a5ac0e$var$divNearest(b2 * k, n);
            var c2 = $6c378d1714a5ac0e$var$divNearest(-b1 * k, n);
            var k1 = (0, $bb46G.mod)(k - c1 * a1 - c2 * a2, n);
            var k2 = (0, $bb46G.mod)(-c1 * b1 - c2 * b2, n);
            var k1neg = k1 > POW_2_128;
            var k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalar: Endomorphism failed, k=" + k);
            return {
                k1neg: k1neg,
                k1: k1,
                k2neg: k2neg,
                k2: k2
            };
        }
    }
}, (0, $fjRrf.sha256));
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
var $6c378d1714a5ac0e$var$_0n = BigInt(0);
var $6c378d1714a5ac0e$var$fe = function(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $l0HdX._)(x)) === "bigint" && $6c378d1714a5ac0e$var$_0n < x && x < $6c378d1714a5ac0e$var$secp256k1P;
};
var $6c378d1714a5ac0e$var$ge = function(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $l0HdX._)(x)) === "bigint" && $6c378d1714a5ac0e$var$_0n < x && x < $6c378d1714a5ac0e$var$secp256k1N;
};
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ var $6c378d1714a5ac0e$var$TAGGED_HASH_PREFIXES = {};
function $6c378d1714a5ac0e$var$taggedHash(tag) {
    for(var _len = arguments.length, messages = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        messages[_key - 1] = arguments[_key];
    }
    var tagP = $6c378d1714a5ac0e$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        var tagH = (0, $fjRrf.sha256)(Uint8Array.from(tag, function(c) {
            return c.charCodeAt(0);
        }));
        tagP = (0, $fLMRX.concatBytes)(tagH, tagH);
        $6c378d1714a5ac0e$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $fjRrf.sha256)((0, $fLMRX.concatBytes).apply(void 0, [
        tagP
    ].concat((0, $c6Xmf._)(messages))));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
var $6c378d1714a5ac0e$var$pointToBytes = function(point) {
    return point.toRawBytes(true).slice(1);
};
var $6c378d1714a5ac0e$var$numTo32b = function(n) {
    return (0, $fLMRX.numberToBytesBE)(n, 32);
};
var $6c378d1714a5ac0e$var$modP = function(x) {
    return (0, $bb46G.mod)(x, $6c378d1714a5ac0e$var$secp256k1P);
};
var $6c378d1714a5ac0e$var$modN = function(x) {
    return (0, $bb46G.mod)(x, $6c378d1714a5ac0e$var$secp256k1N);
};
var $6c378d1714a5ac0e$var$Point = $6c378d1714a5ac0e$export$529e6123e9353a90.ProjectivePoint;
var $6c378d1714a5ac0e$var$GmulAdd = function(Q, a, b) {
    return $6c378d1714a5ac0e$var$Point.BASE.multiplyAndAddUnsafe(Q, a, b);
};
// Calculate point, scalar and bytes
function $6c378d1714a5ac0e$var$schnorrGetExtPubKey(priv) {
    var d_ = $6c378d1714a5ac0e$export$529e6123e9353a90.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    var p = $6c378d1714a5ac0e$var$Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    var scalar = p.hasEvenY() ? d_ : $6c378d1714a5ac0e$var$modN(-d_);
    return {
        scalar: scalar,
        bytes: $6c378d1714a5ac0e$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $6c378d1714a5ac0e$var$lift_x(x) {
    if (!$6c378d1714a5ac0e$var$fe(x)) throw new Error("bad x: need 0 < x < p"); // Fail if x ≥ p.
    var xx = $6c378d1714a5ac0e$var$modP(x * x);
    var c = $6c378d1714a5ac0e$var$modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    var y = $6c378d1714a5ac0e$var$sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % $6c378d1714a5ac0e$var$_2n !== $6c378d1714a5ac0e$var$_0n) y = $6c378d1714a5ac0e$var$modP(-y); // Return the unique point P such that x(P) = x and
    var p = new $6c378d1714a5ac0e$var$Point(x, y, $6c378d1714a5ac0e$var$_1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $6c378d1714a5ac0e$var$challenge() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return $6c378d1714a5ac0e$var$modN((0, $fLMRX.bytesToNumberBE)($6c378d1714a5ac0e$var$taggedHash.apply(void 0, [
        "BIP0340/challenge"
    ].concat((0, $c6Xmf._)(args)))));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $6c378d1714a5ac0e$var$schnorrGetPublicKey(privateKey) {
    return $6c378d1714a5ac0e$var$schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $6c378d1714a5ac0e$var$schnorrSign(message, privateKey) {
    var auxRand = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $8ybNC.randomBytes)(32);
    var m = (0, $fLMRX.ensureBytes)("message", message);
    var _schnorrGetExtPubKey = $6c378d1714a5ac0e$var$schnorrGetExtPubKey(privateKey), px = _schnorrGetExtPubKey.bytes, d = _schnorrGetExtPubKey.scalar; // checks for isWithinCurveOrder
    var a = (0, $fLMRX.ensureBytes)("auxRand", auxRand, 32); // Auxiliary random data a: a 32-byte array
    var t = $6c378d1714a5ac0e$var$numTo32b(d ^ (0, $fLMRX.bytesToNumberBE)($6c378d1714a5ac0e$var$taggedHash("BIP0340/aux", a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    var rand = $6c378d1714a5ac0e$var$taggedHash("BIP0340/nonce", t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    var k_ = $6c378d1714a5ac0e$var$modN((0, $fLMRX.bytesToNumberBE)(rand)); // Let k' = int(rand) mod n
    if (k_ === $6c378d1714a5ac0e$var$_0n) throw new Error("sign failed: k is zero"); // Fail if k' = 0.
    var _schnorrGetExtPubKey1 = $6c378d1714a5ac0e$var$schnorrGetExtPubKey(k_), rx = _schnorrGetExtPubKey1.bytes, k = _schnorrGetExtPubKey1.scalar; // Let R = k'⋅G.
    var e = $6c378d1714a5ac0e$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    var sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set($6c378d1714a5ac0e$var$numTo32b($6c378d1714a5ac0e$var$modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$6c378d1714a5ac0e$var$schnorrVerify(sig, m, px)) throw new Error("sign: Invalid signature produced");
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $6c378d1714a5ac0e$var$schnorrVerify(signature, message, publicKey) {
    var sig = (0, $fLMRX.ensureBytes)("signature", signature, 64);
    var m = (0, $fLMRX.ensureBytes)("message", message);
    var pub = (0, $fLMRX.ensureBytes)("publicKey", publicKey, 32);
    try {
        var P = $6c378d1714a5ac0e$var$lift_x((0, $fLMRX.bytesToNumberBE)(pub)); // P = lift_x(int(pk)); fail if that fails
        var r = (0, $fLMRX.bytesToNumberBE)(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!$6c378d1714a5ac0e$var$fe(r)) return false;
        var s = (0, $fLMRX.bytesToNumberBE)(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!$6c378d1714a5ac0e$var$ge(s)) return false;
        var e = $6c378d1714a5ac0e$var$challenge($6c378d1714a5ac0e$var$numTo32b(r), $6c378d1714a5ac0e$var$pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        var R = $6c378d1714a5ac0e$var$GmulAdd(P, s, $6c378d1714a5ac0e$var$modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
var $6c378d1714a5ac0e$export$1f2401df071be9f = /* @__PURE__ */ function() {
    return {
        getPublicKey: $6c378d1714a5ac0e$var$schnorrGetPublicKey,
        sign: $6c378d1714a5ac0e$var$schnorrSign,
        verify: $6c378d1714a5ac0e$var$schnorrVerify,
        utils: {
            randomPrivateKey: $6c378d1714a5ac0e$export$529e6123e9353a90.utils.randomPrivateKey,
            lift_x: $6c378d1714a5ac0e$var$lift_x,
            pointToBytes: $6c378d1714a5ac0e$var$pointToBytes,
            numberToBytesBE: (0, $fLMRX.numberToBytesBE),
            bytesToNumberBE: (0, $fLMRX.bytesToNumberBE),
            taggedHash: $6c378d1714a5ac0e$var$taggedHash,
            mod: (0, $bb46G.mod)
        }
    };
}();
var $6c378d1714a5ac0e$var$isoMap = /* @__PURE__ */ function() {
    return (0, $htkZk.isogenyMap)($6c378d1714a5ac0e$var$Fp, [
        // xNum
        [
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
            "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
            "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
        ],
        // xDen
        [
            "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
            "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ],
        // yNum
        [
            "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
            "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
            "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
            "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
        ],
        // yDen
        [
            "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
            "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
            "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ]
    ].map(function(i) {
        return i.map(function(j) {
            return BigInt(j);
        });
    }));
}();
var $6c378d1714a5ac0e$var$mapSWU = /* @__PURE__ */ function() {
    return (0, $93C41.mapToCurveSimpleSWU)($6c378d1714a5ac0e$var$Fp, {
        A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
        B: BigInt("1771"),
        Z: $6c378d1714a5ac0e$var$Fp.create(BigInt("-11"))
    });
}();
var $6c378d1714a5ac0e$var$htf = /* @__PURE__ */ function() {
    return (0, $htkZk.createHasher)($6c378d1714a5ac0e$export$529e6123e9353a90.ProjectivePoint, function(scalars) {
        var _mapSWU = $6c378d1714a5ac0e$var$mapSWU($6c378d1714a5ac0e$var$Fp.create(scalars[0])), x = _mapSWU.x, y = _mapSWU.y;
        return $6c378d1714a5ac0e$var$isoMap(x, y);
    }, {
        DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
        encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
        p: $6c378d1714a5ac0e$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: (0, $fjRrf.sha256)
    });
}();
var $6c378d1714a5ac0e$export$a95cc2b0cdb9c1e1 = /* @__PURE__ */ function() {
    return $6c378d1714a5ac0e$var$htf.hashToCurve;
}();
var $6c378d1714a5ac0e$export$124e820e7679cc3 = /* @__PURE__ */ function() {
    return $6c378d1714a5ac0e$var$htf.encodeToCurve;
}();

});
parcelRegister("fjRrf", function(module, exports) {

$parcel$export(module.exports, "sha256", function () { return $b272152481c7d4a8$export$bced8d2aada2d1c9; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $8ANoe = parcelRequire("8ANoe");

var $8ybNC = parcelRequire("8ybNC");
// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
var $b272152481c7d4a8$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state:
// first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19
// prettier-ignore
var $b272152481c7d4a8$var$SHA256_IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
var $b272152481c7d4a8$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
var $b272152481c7d4a8$var$SHA256 = /*#__PURE__*/ function(HashMD) {
    "use strict";
    (0, $dcsZi._)(SHA256, HashMD);
    var _super = (0, $ohfOJ._)(SHA256);
    function SHA256() {
        (0, $4GJKx._)(this, SHA256);
        var _this;
        _this = _super.call(this, 64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        _this.A = $b272152481c7d4a8$var$SHA256_IV[0] | 0;
        _this.B = $b272152481c7d4a8$var$SHA256_IV[1] | 0;
        _this.C = $b272152481c7d4a8$var$SHA256_IV[2] | 0;
        _this.D = $b272152481c7d4a8$var$SHA256_IV[3] | 0;
        _this.E = $b272152481c7d4a8$var$SHA256_IV[4] | 0;
        _this.F = $b272152481c7d4a8$var$SHA256_IV[5] | 0;
        _this.G = $b272152481c7d4a8$var$SHA256_IV[6] | 0;
        _this.H = $b272152481c7d4a8$var$SHA256_IV[7] | 0;
        return _this;
    }
    (0, $1wc17._)(SHA256, [
        {
            key: "get",
            value: function get() {
                var _this = this, A = _this.A, B = _this.B, C = _this.C, D = _this.D, E = _this.E, F = _this.F, G = _this.G, H = _this.H;
                return [
                    A,
                    B,
                    C,
                    D,
                    E,
                    F,
                    G,
                    H
                ];
            }
        },
        {
            // prettier-ignore
            key: "set",
            value: function set(A, B, C, D, E, F, G, H) {
                this.A = A | 0;
                this.B = B | 0;
                this.C = C | 0;
                this.D = D | 0;
                this.E = E | 0;
                this.F = F | 0;
                this.G = G | 0;
                this.H = H | 0;
            }
        },
        {
            key: "process",
            value: function process(view, offset) {
                // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
                for(var i = 0; i < 16; i++, offset += 4)$b272152481c7d4a8$var$SHA256_W[i] = view.getUint32(offset, false);
                for(var i1 = 16; i1 < 64; i1++){
                    var W15 = $b272152481c7d4a8$var$SHA256_W[i1 - 15];
                    var W2 = $b272152481c7d4a8$var$SHA256_W[i1 - 2];
                    var s0 = (0, $8ybNC.rotr)(W15, 7) ^ (0, $8ybNC.rotr)(W15, 18) ^ W15 >>> 3;
                    var s1 = (0, $8ybNC.rotr)(W2, 17) ^ (0, $8ybNC.rotr)(W2, 19) ^ W2 >>> 10;
                    $b272152481c7d4a8$var$SHA256_W[i1] = s1 + $b272152481c7d4a8$var$SHA256_W[i1 - 7] + s0 + $b272152481c7d4a8$var$SHA256_W[i1 - 16] | 0;
                }
                // Compression function main loop, 64 rounds
                var _this = this, A = _this.A, B = _this.B, C = _this.C, D = _this.D, E = _this.E, F = _this.F, G = _this.G, H = _this.H;
                for(var i2 = 0; i2 < 64; i2++){
                    var sigma1 = (0, $8ybNC.rotr)(E, 6) ^ (0, $8ybNC.rotr)(E, 11) ^ (0, $8ybNC.rotr)(E, 25);
                    var T1 = H + sigma1 + (0, $8ANoe.Chi)(E, F, G) + $b272152481c7d4a8$var$SHA256_K[i2] + $b272152481c7d4a8$var$SHA256_W[i2] | 0;
                    var sigma0 = (0, $8ybNC.rotr)(A, 2) ^ (0, $8ybNC.rotr)(A, 13) ^ (0, $8ybNC.rotr)(A, 22);
                    var T2 = sigma0 + (0, $8ANoe.Maj)(A, B, C) | 0;
                    H = G;
                    G = F;
                    F = E;
                    E = D + T1 | 0;
                    D = C;
                    C = B;
                    B = A;
                    A = T1 + T2 | 0;
                }
                // Add the compressed chunk to the current hash value
                A = A + this.A | 0;
                B = B + this.B | 0;
                C = C + this.C | 0;
                D = D + this.D | 0;
                E = E + this.E | 0;
                F = F + this.F | 0;
                G = G + this.G | 0;
                H = H + this.H | 0;
                this.set(A, B, C, D, E, F, G, H);
            }
        },
        {
            key: "roundClean",
            value: function roundClean() {
                $b272152481c7d4a8$var$SHA256_W.fill(0);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.set(0, 0, 0, 0, 0, 0, 0, 0);
                this.buffer.fill(0);
            }
        }
    ]);
    return SHA256;
}((0, $8ANoe.HashMD));
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
var $b272152481c7d4a8$var$SHA224 = /*#__PURE__*/ function(SHA256) {
    "use strict";
    (0, $dcsZi._)(SHA224, SHA256);
    var _super = (0, $ohfOJ._)(SHA224);
    function SHA224() {
        (0, $4GJKx._)(this, SHA224);
        var _this;
        _this = _super.call(this);
        _this.A = -1056596264;
        _this.B = 914150663;
        _this.C = 812702999;
        _this.D = -150054599;
        _this.E = -4191439;
        _this.F = 1750603025;
        _this.G = 1694076839;
        _this.H = -1090891868;
        _this.outputLen = 28;
        return _this;
    }
    return SHA224;
}($b272152481c7d4a8$var$SHA256);
var $b272152481c7d4a8$export$bced8d2aada2d1c9 = /* @__PURE__ */ (0, $8ybNC.wrapConstructor)(function() {
    return new $b272152481c7d4a8$var$SHA256();
});
var $b272152481c7d4a8$export$97b70509d4e397ea = /* @__PURE__ */ (0, $8ybNC.wrapConstructor)(function() {
    return new $b272152481c7d4a8$var$SHA224();
});

});
parcelRegister("8ANoe", function(module, exports) {

$parcel$export(module.exports, "Chi", function () { return $6417ff4da26a2c08$export$d0d97f016526eaf0; });
$parcel$export(module.exports, "Maj", function () { return $6417ff4da26a2c08$export$8b1d810b1bd30adf; });
$parcel$export(module.exports, "HashMD", function () { return $6417ff4da26a2c08$export$f9f830659f932cb2; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $c6Xmf = parcelRequire("c6Xmf");

var $ohfOJ = parcelRequire("ohfOJ");

var $Vu6Hx = parcelRequire("Vu6Hx");

var $8ybNC = parcelRequire("8ybNC");
// Polyfill for Safari 14
function $6417ff4da26a2c08$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    var _32n = BigInt(32);
    var _u32_max = BigInt(0xffffffff);
    var wh = Number(value >> _32n & _u32_max);
    var wl = Number(value & _u32_max);
    var h = isLE ? 4 : 0;
    var l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
var $6417ff4da26a2c08$export$d0d97f016526eaf0 = function(a, b, c) {
    return a & b ^ ~a & c;
};
var $6417ff4da26a2c08$export$8b1d810b1bd30adf = function(a, b, c) {
    return a & b ^ a & c ^ b & c;
};
var $6417ff4da26a2c08$export$f9f830659f932cb2 = /*#__PURE__*/ function(Hash) {
    "use strict";
    (0, $dcsZi._)(HashMD, Hash);
    var _super = (0, $ohfOJ._)(HashMD);
    function HashMD(blockLen, outputLen, padOffset, isLE) {
        (0, $4GJKx._)(this, HashMD);
        var _this;
        _this = _super.call(this);
        _this.blockLen = blockLen;
        _this.outputLen = outputLen;
        _this.padOffset = padOffset;
        _this.isLE = isLE;
        _this.finished = false;
        _this.length = 0;
        _this.pos = 0;
        _this.destroyed = false;
        _this.buffer = new Uint8Array(blockLen);
        _this.view = (0, $8ybNC.createView)(_this.buffer);
        return _this;
    }
    (0, $1wc17._)(HashMD, [
        {
            key: "update",
            value: function update(data) {
                (0, $Vu6Hx.exists)(this);
                var _this = this, view = _this.view, buffer = _this.buffer, blockLen = _this.blockLen;
                data = (0, $8ybNC.toBytes)(data);
                var len = data.length;
                for(var pos = 0; pos < len;){
                    var take = Math.min(blockLen - this.pos, len - pos);
                    // Fast path: we have at least one block in input, cast it to view and process
                    if (take === blockLen) {
                        var dataView = (0, $8ybNC.createView)(data);
                        for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                        continue;
                    }
                    buffer.set(data.subarray(pos, pos + take), this.pos);
                    this.pos += take;
                    pos += take;
                    if (this.pos === blockLen) {
                        this.process(view, 0);
                        this.pos = 0;
                    }
                }
                this.length += data.length;
                this.roundClean();
                return this;
            }
        },
        {
            key: "digestInto",
            value: function digestInto(out) {
                (0, $Vu6Hx.exists)(this);
                (0, $Vu6Hx.output)(out, this);
                this.finished = true;
                // Padding
                // We can avoid allocation of buffer for padding completely if it
                // was previously not allocated here. But it won't change performance.
                var _this = this, buffer = _this.buffer, view = _this.view, blockLen = _this.blockLen, isLE = _this.isLE;
                var pos = this.pos;
                // append the bit '1' to the message
                buffer[pos++] = 128;
                this.buffer.subarray(pos).fill(0);
                // we have less than padOffset left in buffer, so we cannot put length in
                // current block, need process it and pad again
                if (this.padOffset > blockLen - pos) {
                    this.process(view, 0);
                    pos = 0;
                }
                // Pad until full block byte with zeros
                for(var i = pos; i < blockLen; i++)buffer[i] = 0;
                // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
                // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
                // So we just write lowest 64 bits of that value.
                $6417ff4da26a2c08$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
                this.process(view, 0);
                var oview = (0, $8ybNC.createView)(out);
                var len = this.outputLen;
                // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
                if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
                var outLen = len / 4;
                var state = this.get();
                if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
                for(var i1 = 0; i1 < outLen; i1++)oview.setUint32(4 * i1, state[i1], isLE);
            }
        },
        {
            key: "digest",
            value: function digest() {
                var _this = this, buffer = _this.buffer, outputLen = _this.outputLen;
                this.digestInto(buffer);
                var res = buffer.slice(0, outputLen);
                this.destroy();
                return res;
            }
        },
        {
            key: "_cloneInto",
            value: function _cloneInto(to) {
                var _to;
                to || (to = new this.constructor());
                (_to = to).set.apply(_to, (0, $c6Xmf._)(this.get()));
                var _this = this, blockLen = _this.blockLen, buffer = _this.buffer, length = _this.length, finished = _this.finished, destroyed = _this.destroyed, pos = _this.pos;
                to.length = length;
                to.pos = pos;
                to.finished = finished;
                to.destroyed = destroyed;
                if (length % blockLen) to.buffer.set(buffer);
                return to;
            }
        }
    ]);
    return HashMD;
}((0, $8ybNC.Hash));

});


parcelRegister("bb46G", function(module, exports) {

$parcel$export(module.exports, "mod", function () { return $8233e84ff15cb9f3$export$842a2cf37af977e1; });
$parcel$export(module.exports, "pow2", function () { return $8233e84ff15cb9f3$export$fa569bd808b67eef; });
$parcel$export(module.exports, "invert", function () { return $8233e84ff15cb9f3$export$6897c284b6f9f4dc; });
$parcel$export(module.exports, "validateField", function () { return $8233e84ff15cb9f3$export$bd454f0cef11418d; });
$parcel$export(module.exports, "nLength", function () { return $8233e84ff15cb9f3$export$c79df43ecd7e66c2; });
$parcel$export(module.exports, "Field", function () { return $8233e84ff15cb9f3$export$a455218a85c89869; });
$parcel$export(module.exports, "getMinHashLength", function () { return $8233e84ff15cb9f3$export$d058763b563056af; });
$parcel$export(module.exports, "mapHashToField", function () { return $8233e84ff15cb9f3$export$20cb21dbfa61dac3; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Utilities for modular arithmetics and finite fields

var $l0HdX = parcelRequire("l0HdX");

var $fLMRX = parcelRequire("fLMRX");
// prettier-ignore
var $8233e84ff15cb9f3$var$_0n = BigInt(0), $8233e84ff15cb9f3$var$_1n = BigInt(1), $8233e84ff15cb9f3$var$_2n = BigInt(2), $8233e84ff15cb9f3$var$_3n = BigInt(3);
// prettier-ignore
var $8233e84ff15cb9f3$var$_4n = BigInt(4), $8233e84ff15cb9f3$var$_5n = BigInt(5), $8233e84ff15cb9f3$var$_8n = BigInt(8);
// prettier-ignore
var $8233e84ff15cb9f3$var$_9n = BigInt(9), $8233e84ff15cb9f3$var$_16n = BigInt(16);
function $8233e84ff15cb9f3$export$842a2cf37af977e1(a, b) {
    var result = a % b;
    return result >= $8233e84ff15cb9f3$var$_0n ? result : b + result;
}
function $8233e84ff15cb9f3$export$9c297f60e22e3389(num, power, modulo) {
    if (modulo <= $8233e84ff15cb9f3$var$_0n || power < $8233e84ff15cb9f3$var$_0n) throw new Error("Expected power/modulo > 0");
    if (modulo === $8233e84ff15cb9f3$var$_1n) return $8233e84ff15cb9f3$var$_0n;
    var res = $8233e84ff15cb9f3$var$_1n;
    while(power > $8233e84ff15cb9f3$var$_0n){
        if (power & $8233e84ff15cb9f3$var$_1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= $8233e84ff15cb9f3$var$_1n;
    }
    return res;
}
function $8233e84ff15cb9f3$export$fa569bd808b67eef(x, power, modulo) {
    var res = x;
    while(power-- > $8233e84ff15cb9f3$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
function $8233e84ff15cb9f3$export$6897c284b6f9f4dc(number, modulo) {
    if (number === $8233e84ff15cb9f3$var$_0n || modulo <= $8233e84ff15cb9f3$var$_0n) throw new Error("invert: expected positive integers, got n=".concat(number, " mod=").concat(modulo));
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    var a = $8233e84ff15cb9f3$export$842a2cf37af977e1(number, modulo);
    var b = modulo;
    // prettier-ignore
    var x = $8233e84ff15cb9f3$var$_0n, y = $8233e84ff15cb9f3$var$_1n, u = $8233e84ff15cb9f3$var$_1n, v = $8233e84ff15cb9f3$var$_0n;
    while(a !== $8233e84ff15cb9f3$var$_0n){
        // JIT applies optimization if those two lines follow each other
        var q = b / a;
        var r = b % a;
        var m = x - u * q;
        var n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    var gcd = b;
    if (gcd !== $8233e84ff15cb9f3$var$_1n) throw new Error("invert: does not exist");
    return $8233e84ff15cb9f3$export$842a2cf37af977e1(x, modulo);
}
function $8233e84ff15cb9f3$export$69f29ab1f3e9a234(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    var legendreC = (P - $8233e84ff15cb9f3$var$_1n) / $8233e84ff15cb9f3$var$_2n;
    var Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - $8233e84ff15cb9f3$var$_1n, S = 0; Q % $8233e84ff15cb9f3$var$_2n === $8233e84ff15cb9f3$var$_0n; Q /= $8233e84ff15cb9f3$var$_2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = $8233e84ff15cb9f3$var$_2n; Z < P && $8233e84ff15cb9f3$export$9c297f60e22e3389(Z, legendreC, P) !== P - $8233e84ff15cb9f3$var$_1n; Z++);
    // Fast-path
    if (S === 1) {
        var p1div4 = (P + $8233e84ff15cb9f3$var$_1n) / $8233e84ff15cb9f3$var$_4n;
        return function tonelliFast(Fp, n) {
            var root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Slow-path
    var Q1div2 = (Q + $8233e84ff15cb9f3$var$_1n) / $8233e84ff15cb9f3$var$_2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error("Cannot find square root");
        var r = S;
        // TODO: will fail at Fp2/etc
        var g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        var x = Fp.pow(n, Q1div2); // first guess at the square root
        var b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            var m = 1;
            for(var t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            var ge = Fp.pow(g, $8233e84ff15cb9f3$var$_1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
function $8233e84ff15cb9f3$export$33bda048c6b8ea7d(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % $8233e84ff15cb9f3$var$_4n === $8233e84ff15cb9f3$var$_3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        var p1div4 = (P + $8233e84ff15cb9f3$var$_1n) / $8233e84ff15cb9f3$var$_4n;
        return function sqrt3mod4(Fp, n) {
            var root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % $8233e84ff15cb9f3$var$_8n === $8233e84ff15cb9f3$var$_5n) {
        var c1 = (P - $8233e84ff15cb9f3$var$_5n) / $8233e84ff15cb9f3$var$_8n;
        return function sqrt5mod8(Fp, n) {
            var n2 = Fp.mul(n, $8233e84ff15cb9f3$var$_2n);
            var v = Fp.pow(n2, c1);
            var nv = Fp.mul(n, v);
            var i = Fp.mul(Fp.mul(nv, $8233e84ff15cb9f3$var$_2n), v);
            var root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    $8233e84ff15cb9f3$var$_9n;
    // Other cases: Tonelli-Shanks algorithm
    return $8233e84ff15cb9f3$export$69f29ab1f3e9a234(P);
}
var $8233e84ff15cb9f3$export$7806f13ad5078b2f = function(num, modulo) {
    return ($8233e84ff15cb9f3$export$842a2cf37af977e1(num, modulo) & $8233e84ff15cb9f3$var$_1n) === $8233e84ff15cb9f3$var$_1n;
};
// prettier-ignore
var $8233e84ff15cb9f3$var$FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $8233e84ff15cb9f3$export$bd454f0cef11418d(field) {
    var initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    var opts = $8233e84ff15cb9f3$var$FIELD_FIELDS.reduce(function(map, val) {
        map[val] = "function";
        return map;
    }, initial);
    return (0, $fLMRX.validateObject)(field, opts);
}
function $8233e84ff15cb9f3$export$5d8ce3717733a987(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < $8233e84ff15cb9f3$var$_0n) throw new Error("Expected power > 0");
    if (power === $8233e84ff15cb9f3$var$_0n) return f.ONE;
    if (power === $8233e84ff15cb9f3$var$_1n) return num;
    var p = f.ONE;
    var d = num;
    while(power > $8233e84ff15cb9f3$var$_0n){
        if (power & $8233e84ff15cb9f3$var$_1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= $8233e84ff15cb9f3$var$_1n;
    }
    return p;
}
function $8233e84ff15cb9f3$export$a492e3387142c0e9(f, nums) {
    var tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    var lastMultiplied = nums.reduce(function(acc, num, i) {
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    var inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight(function(acc, num, i) {
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
function $8233e84ff15cb9f3$export$e74c665040343df6(f, lhs, rhs) {
    return f.mul(lhs, (typeof rhs === "undefined" ? "undefined" : (0, $l0HdX._)(rhs)) === "bigint" ? $8233e84ff15cb9f3$export$6897c284b6f9f4dc(rhs, f.ORDER) : f.inv(rhs));
}
function $8233e84ff15cb9f3$export$5e2b6e87f2891ea7(f) {
    var legendreConst = (f.ORDER - $8233e84ff15cb9f3$var$_1n) / $8233e84ff15cb9f3$var$_2n; // Integer arithmetic
    return function(x) {
        var p = f.pow(x, legendreConst);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
function $8233e84ff15cb9f3$export$c79df43ecd7e66c2(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    var _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    var nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
function $8233e84ff15cb9f3$export$a455218a85c89869(ORDER, bitLen) {
    var isLE = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, redef = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    if (ORDER <= $8233e84ff15cb9f3$var$_0n) throw new Error("Expected Field ORDER > 0, got ".concat(ORDER));
    var _nLength = $8233e84ff15cb9f3$export$c79df43ecd7e66c2(ORDER, bitLen), BITS = _nLength.nBitLength, BYTES = _nLength.nByteLength;
    if (BYTES > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
    var sqrtP = $8233e84ff15cb9f3$export$33bda048c6b8ea7d(ORDER);
    var f = Object.freeze({
        ORDER: ORDER,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $fLMRX.bitMask)(BITS),
        ZERO: $8233e84ff15cb9f3$var$_0n,
        ONE: $8233e84ff15cb9f3$var$_1n,
        create: function(num) {
            return $8233e84ff15cb9f3$export$842a2cf37af977e1(num, ORDER);
        },
        isValid: function(num) {
            if ((typeof num === "undefined" ? "undefined" : (0, $l0HdX._)(num)) !== "bigint") throw new Error("Invalid field element: expected bigint, got ".concat(typeof num === "undefined" ? "undefined" : (0, $l0HdX._)(num)));
            return $8233e84ff15cb9f3$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: function(num) {
            return num === $8233e84ff15cb9f3$var$_0n;
        },
        isOdd: function(num) {
            return (num & $8233e84ff15cb9f3$var$_1n) === $8233e84ff15cb9f3$var$_1n;
        },
        neg: function(num) {
            return $8233e84ff15cb9f3$export$842a2cf37af977e1(-num, ORDER);
        },
        eql: function(lhs, rhs) {
            return lhs === rhs;
        },
        sqr: function(num) {
            return $8233e84ff15cb9f3$export$842a2cf37af977e1(num * num, ORDER);
        },
        add: function(lhs, rhs) {
            return $8233e84ff15cb9f3$export$842a2cf37af977e1(lhs + rhs, ORDER);
        },
        sub: function(lhs, rhs) {
            return $8233e84ff15cb9f3$export$842a2cf37af977e1(lhs - rhs, ORDER);
        },
        mul: function(lhs, rhs) {
            return $8233e84ff15cb9f3$export$842a2cf37af977e1(lhs * rhs, ORDER);
        },
        pow: function(num, power) {
            return $8233e84ff15cb9f3$export$5d8ce3717733a987(f, num, power);
        },
        div: function(lhs, rhs) {
            return $8233e84ff15cb9f3$export$842a2cf37af977e1(lhs * $8233e84ff15cb9f3$export$6897c284b6f9f4dc(rhs, ORDER), ORDER);
        },
        // Same as above, but doesn't normalize
        sqrN: function(num) {
            return num * num;
        },
        addN: function(lhs, rhs) {
            return lhs + rhs;
        },
        subN: function(lhs, rhs) {
            return lhs - rhs;
        },
        mulN: function(lhs, rhs) {
            return lhs * rhs;
        },
        inv: function(num) {
            return $8233e84ff15cb9f3$export$6897c284b6f9f4dc(num, ORDER);
        },
        sqrt: redef.sqrt || function(n) {
            return sqrtP(f, n);
        },
        invertBatch: function(lst) {
            return $8233e84ff15cb9f3$export$a492e3387142c0e9(f, lst);
        },
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: function(a, b, c) {
            return c ? b : a;
        },
        toBytes: function(num) {
            return isLE ? (0, $fLMRX.numberToBytesLE)(num, BYTES) : (0, $fLMRX.numberToBytesBE)(num, BYTES);
        },
        fromBytes: function(bytes) {
            if (bytes.length !== BYTES) throw new Error("Fp.fromBytes: expected ".concat(BYTES, ", got ").concat(bytes.length));
            return isLE ? (0, $fLMRX.bytesToNumberLE)(bytes) : (0, $fLMRX.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
function $8233e84ff15cb9f3$export$7acc54692c525d2a(Fp, elm) {
    if (!Fp.isOdd) throw new Error("Field doesn't have isOdd");
    var root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
function $8233e84ff15cb9f3$export$1d7b691df0888e02(Fp, elm) {
    if (!Fp.isOdd) throw new Error("Field doesn't have isOdd");
    var root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
function $8233e84ff15cb9f3$export$d3b0e8260d5dbad4(hash, groupOrder) {
    var isLE = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    hash = (0, $fLMRX.ensureBytes)("privateHash", hash);
    var hashLen = hash.length;
    var minLen = $8233e84ff15cb9f3$export$c79df43ecd7e66c2(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error("hashToPrivateScalar: expected ".concat(minLen, "-1024 bytes of input, got ").concat(hashLen));
    var num = isLE ? (0, $fLMRX.bytesToNumberLE)(hash) : (0, $fLMRX.bytesToNumberBE)(hash);
    return $8233e84ff15cb9f3$export$842a2cf37af977e1(num, groupOrder - $8233e84ff15cb9f3$var$_1n) + $8233e84ff15cb9f3$var$_1n;
}
function $8233e84ff15cb9f3$export$9cf21a9392b0fcfc(fieldOrder) {
    if ((typeof fieldOrder === "undefined" ? "undefined" : (0, $l0HdX._)(fieldOrder)) !== "bigint") throw new Error("field order must be bigint");
    var bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
function $8233e84ff15cb9f3$export$d058763b563056af(fieldOrder) {
    var length = $8233e84ff15cb9f3$export$9cf21a9392b0fcfc(fieldOrder);
    return length + Math.ceil(length / 2);
}
function $8233e84ff15cb9f3$export$20cb21dbfa61dac3(key, fieldOrder) {
    var isLE = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var len = key.length;
    var fieldLen = $8233e84ff15cb9f3$export$9cf21a9392b0fcfc(fieldOrder);
    var minLen = $8233e84ff15cb9f3$export$d058763b563056af(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error("expected ".concat(minLen, "-1024 bytes of input, got ").concat(len));
    var num = isLE ? (0, $fLMRX.bytesToNumberBE)(key) : (0, $fLMRX.bytesToNumberLE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    var reduced = $8233e84ff15cb9f3$export$842a2cf37af977e1(num, fieldOrder - $8233e84ff15cb9f3$var$_1n) + $8233e84ff15cb9f3$var$_1n;
    return isLE ? (0, $fLMRX.numberToBytesLE)(reduced, fieldLen) : (0, $fLMRX.numberToBytesBE)(reduced, fieldLen);
}

});
parcelRegister("fLMRX", function(module, exports) {

$parcel$export(module.exports, "isBytes", function () { return $b7b127350310c791$export$c6fabfbfd097fc30; });
$parcel$export(module.exports, "abytes", function () { return $b7b127350310c791$export$e8a750b9efad93f5; });
$parcel$export(module.exports, "bytesToHex", function () { return $b7b127350310c791$export$58b867e287a802c8; });
$parcel$export(module.exports, "numberToHexUnpadded", function () { return $b7b127350310c791$export$4ed2545b622827c1; });
$parcel$export(module.exports, "hexToNumber", function () { return $b7b127350310c791$export$d57f2bacc26b4249; });
$parcel$export(module.exports, "hexToBytes", function () { return $b7b127350310c791$export$31c96b9df38bc8d4; });
$parcel$export(module.exports, "bytesToNumberBE", function () { return $b7b127350310c791$export$d609354794974f8; });
$parcel$export(module.exports, "bytesToNumberLE", function () { return $b7b127350310c791$export$d67b1d03392107e7; });
$parcel$export(module.exports, "numberToBytesBE", function () { return $b7b127350310c791$export$1459dafd057611cb; });
$parcel$export(module.exports, "numberToBytesLE", function () { return $b7b127350310c791$export$ba2172e58d139f6d; });
$parcel$export(module.exports, "numberToVarBytesBE", function () { return $b7b127350310c791$export$80ee8c1914de6dde; });
$parcel$export(module.exports, "ensureBytes", function () { return $b7b127350310c791$export$3cb5d50a3a30e837; });
$parcel$export(module.exports, "concatBytes", function () { return $b7b127350310c791$export$287dd7971339c972; });
$parcel$export(module.exports, "equalBytes", function () { return $b7b127350310c791$export$2aa59cef064b0333; });
$parcel$export(module.exports, "utf8ToBytes", function () { return $b7b127350310c791$export$3df70a15530b5e81; });
$parcel$export(module.exports, "bitLen", function () { return $b7b127350310c791$export$e93ef600c41761a9; });
$parcel$export(module.exports, "bitGet", function () { return $b7b127350310c791$export$9577d112d1fd46ad; });
$parcel$export(module.exports, "bitSet", function () { return $b7b127350310c791$export$967bb2b9787441cb; });
$parcel$export(module.exports, "bitMask", function () { return $b7b127350310c791$export$803efa2fa1c7279; });
$parcel$export(module.exports, "createHmacDrbg", function () { return $b7b127350310c791$export$d459d139192e4fba; });
$parcel$export(module.exports, "validateObject", function () { return $b7b127350310c791$export$381bae2d0f08004f; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $l0HdX = parcelRequire("l0HdX");
var $b7b127350310c791$var$_0n = BigInt(0);
var $b7b127350310c791$var$_1n = BigInt(1);
var $b7b127350310c791$var$_2n = BigInt(2);
function $b7b127350310c791$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
function $b7b127350310c791$export$e8a750b9efad93f5(item) {
    if (!$b7b127350310c791$export$c6fabfbfd097fc30(item)) throw new Error("Uint8Array expected");
}
// Array where index 0xf0 (240) is mapped to string 'f0'
var $b7b127350310c791$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, function(_, i) {
    return i.toString(16).padStart(2, "0");
});
function $b7b127350310c791$export$58b867e287a802c8(bytes) {
    $b7b127350310c791$export$e8a750b9efad93f5(bytes);
    // pre-caching improves the speed 6x
    var hex = "";
    for(var i = 0; i < bytes.length; i++)hex += $b7b127350310c791$var$hexes[bytes[i]];
    return hex;
}
function $b7b127350310c791$export$4ed2545b622827c1(num) {
    var hex = num.toString(16);
    return hex.length & 1 ? "0".concat(hex) : hex;
}
function $b7b127350310c791$export$d57f2bacc26b4249(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + (typeof hex === "undefined" ? "undefined" : (0, $l0HdX._)(hex)));
    // Big Endian
    return BigInt(hex === "" ? "0" : "0x".concat(hex));
}
// We use optimized technique to convert hex string to byte array
var $b7b127350310c791$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $b7b127350310c791$var$asciiToBase16(char) {
    if (char >= $b7b127350310c791$var$asciis._0 && char <= $b7b127350310c791$var$asciis._9) return char - $b7b127350310c791$var$asciis._0;
    if (char >= $b7b127350310c791$var$asciis._A && char <= $b7b127350310c791$var$asciis._F) return char - ($b7b127350310c791$var$asciis._A - 10);
    if (char >= $b7b127350310c791$var$asciis._a && char <= $b7b127350310c791$var$asciis._f) return char - ($b7b127350310c791$var$asciis._a - 10);
    return;
}
function $b7b127350310c791$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + (typeof hex === "undefined" ? "undefined" : (0, $l0HdX._)(hex)));
    var hl = hex.length;
    var al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    var array = new Uint8Array(al);
    for(var ai = 0, hi = 0; ai < al; ai++, hi += 2){
        var n1 = $b7b127350310c791$var$asciiToBase16(hex.charCodeAt(hi));
        var n2 = $b7b127350310c791$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            var char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
function $b7b127350310c791$export$d609354794974f8(bytes) {
    return $b7b127350310c791$export$d57f2bacc26b4249($b7b127350310c791$export$58b867e287a802c8(bytes));
}
function $b7b127350310c791$export$d67b1d03392107e7(bytes) {
    $b7b127350310c791$export$e8a750b9efad93f5(bytes);
    return $b7b127350310c791$export$d57f2bacc26b4249($b7b127350310c791$export$58b867e287a802c8(Uint8Array.from(bytes).reverse()));
}
function $b7b127350310c791$export$1459dafd057611cb(n, len) {
    return $b7b127350310c791$export$31c96b9df38bc8d4(n.toString(16).padStart(len * 2, "0"));
}
function $b7b127350310c791$export$ba2172e58d139f6d(n, len) {
    return $b7b127350310c791$export$1459dafd057611cb(n, len).reverse();
}
function $b7b127350310c791$export$80ee8c1914de6dde(n) {
    return $b7b127350310c791$export$31c96b9df38bc8d4($b7b127350310c791$export$4ed2545b622827c1(n));
}
function $b7b127350310c791$export$3cb5d50a3a30e837(title, hex, expectedLength) {
    var res;
    if (typeof hex === "string") try {
        res = $b7b127350310c791$export$31c96b9df38bc8d4(hex);
    } catch (e) {
        throw new Error("".concat(title, ' must be valid hex string, got "').concat(hex, '". Cause: ').concat(e));
    }
    else if ($b7b127350310c791$export$c6fabfbfd097fc30(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error("".concat(title, " must be hex string or Uint8Array"));
    var len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error("".concat(title, " expected ").concat(expectedLength, " bytes, got ").concat(len));
    return res;
}
function $b7b127350310c791$export$287dd7971339c972() {
    for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++){
        arrays[_key] = arguments[_key];
    }
    var sum = 0;
    for(var i = 0; i < arrays.length; i++){
        var a = arrays[i];
        $b7b127350310c791$export$e8a750b9efad93f5(a);
        sum += a.length;
    }
    var res = new Uint8Array(sum);
    for(var i1 = 0, pad = 0; i1 < arrays.length; i1++){
        var a1 = arrays[i1];
        res.set(a1, pad);
        pad += a1.length;
    }
    return res;
}
function $b7b127350310c791$export$2aa59cef064b0333(a, b) {
    if (a.length !== b.length) return false;
    var diff = 0;
    for(var i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
function $b7b127350310c791$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error("utf8ToBytes expected string, got ".concat(typeof str === "undefined" ? "undefined" : (0, $l0HdX._)(str)));
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $b7b127350310c791$export$e93ef600c41761a9(n) {
    var len;
    for(len = 0; n > $b7b127350310c791$var$_0n; n >>= $b7b127350310c791$var$_1n, len += 1);
    return len;
}
function $b7b127350310c791$export$9577d112d1fd46ad(n, pos) {
    return n >> BigInt(pos) & $b7b127350310c791$var$_1n;
}
function $b7b127350310c791$export$967bb2b9787441cb(n, pos, value) {
    return n | (value ? $b7b127350310c791$var$_1n : $b7b127350310c791$var$_0n) << BigInt(pos);
}
var $b7b127350310c791$export$803efa2fa1c7279 = function(n) {
    return ($b7b127350310c791$var$_2n << BigInt(n - 1)) - $b7b127350310c791$var$_1n;
};
// DRBG
var $b7b127350310c791$var$u8n = function(data) {
    return new Uint8Array(data);
}; // creates Uint8Array
var $b7b127350310c791$var$u8fr = function(arr) {
    return Uint8Array.from(arr);
}; // another shortcut
function $b7b127350310c791$export$d459d139192e4fba(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    var v = $b7b127350310c791$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    var k = $b7b127350310c791$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    var i = 0; // Iterations counter, will throw when over 1000
    var reset = function() {
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    var h = function() {
        for(var _len = arguments.length, b = new Array(_len), _key = 0; _key < _len; _key++){
            b[_key] = arguments[_key];
        }
        return hmacFn.apply(void 0, [
            k,
            v
        ].concat((0, $c6Xmf._)(b)));
    }; // hmac(k)(v, ...values)
    var reseed = function() {
        var seed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $b7b127350310c791$var$u8n();
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($b7b127350310c791$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($b7b127350310c791$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    var gen = function() {
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        var len = 0;
        var out = [];
        while(len < qByteLen){
            v = h();
            var sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $b7b127350310c791$export$287dd7971339c972.apply(void 0, (0, $c6Xmf._)(out));
    };
    var genUntil = function(seed, pred) {
        reset();
        reseed(seed); // Steps D-G
        var res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
// Validating curves and fields
var $b7b127350310c791$var$validatorFns = {
    bigint: function(val) {
        return (typeof val === "undefined" ? "undefined" : (0, $l0HdX._)(val)) === "bigint";
    },
    function: function(val) {
        return typeof val === "function";
    },
    boolean: function(val) {
        return typeof val === "boolean";
    },
    string: function(val) {
        return typeof val === "string";
    },
    stringOrUint8Array: function(val) {
        return typeof val === "string" || $b7b127350310c791$export$c6fabfbfd097fc30(val);
    },
    isSafeInteger: function(val) {
        return Number.isSafeInteger(val);
    },
    array: function(val) {
        return Array.isArray(val);
    },
    field: function(val, object) {
        return object.Fp.isValid(val);
    },
    hash: function(val) {
        return typeof val === "function" && Number.isSafeInteger(val.outputLen);
    }
};
function $b7b127350310c791$export$381bae2d0f08004f(object, validators) {
    var optValidators = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var checkField = function(fieldName, type, isOptional) {
        var checkVal = $b7b127350310c791$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error('Invalid validator "'.concat(type, '", expected function'));
        var val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error("Invalid param ".concat(String(fieldName), "=").concat(val, " (").concat(typeof val === "undefined" ? "undefined" : (0, $l0HdX._)(val), "), expected ").concat(type));
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(validators)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $cv9Rk._)(_step.value, 2), fieldName = _step_value[0], type = _step_value[1];
            checkField(fieldName, type, false);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = Object.entries(optValidators)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var _step_value1 = (0, $cv9Rk._)(_step1.value, 2), fieldName1 = _step_value1[0], type1 = _step_value1[1];
            checkField(fieldName1, type1, true);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return object;
} // validate type tests
 // const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
 // const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
 // // Should fail type-check
 // const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
 // const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
 // const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
 // const z4 = validateObject(o, { a: 'boolean', z: 'bug' });

});


parcelRegister("93C41", function(module, exports) {

$parcel$export(module.exports, "weierstrass", function () { return $6981eb90e423adb6$export$350b8ea6f1c27fae; });
$parcel$export(module.exports, "mapToCurveSimpleSWU", function () { return $6981eb90e423adb6$export$cc7fea9756a17416; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Short Weierstrass curve. The formula is: y² = x³ + ax + b

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $c6Xmf = parcelRequire("c6Xmf");

var $l0HdX = parcelRequire("l0HdX");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");

var $bb46G = parcelRequire("bb46G");

var $fLMRX = parcelRequire("fLMRX");

var $5tzPU = parcelRequire("5tzPU");
function $6981eb90e423adb6$var$validatePointOpts(curve) {
    var opts = (0, $5tzPU.validateBasic)(curve);
    $fLMRX.validateObject(opts, {
        a: "field",
        b: "field"
    }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
    });
    var endo = opts.endo, Fp = opts.Fp, a = opts.a;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof endo !== "object" || (0, $l0HdX._)(endo.beta) !== "bigint" || typeof endo.splitScalar !== "function") throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
    }
    return Object.freeze((0, $do9pw._)({}, opts));
}
// ASN.1 DER encoding utilities
var $6981eb90e423adb6$var$b2n = $fLMRX.bytesToNumberBE, $6981eb90e423adb6$var$h2b = $fLMRX.hexToBytes;
var $6981eb90e423adb6$export$56ac33195d7076db = {
    // asn.1 DER encoding utils
    Err: /*#__PURE__*/ function(Error1) {
        "use strict";
        (0, $dcsZi._)(DERErr, Error1);
        var _super = (0, $ohfOJ._)(DERErr);
        function DERErr() {
            var m = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
            (0, $4GJKx._)(this, DERErr);
            return _super.call(this, m);
        }
        return DERErr;
    }((0, $FuVm8._)(Error)),
    _parseInt: function(data) {
        var E = $6981eb90e423adb6$export$56ac33195d7076db.Err;
        if (data.length < 2 || data[0] !== 0x02) throw new E("Invalid signature integer tag");
        var len = data[1];
        var res = data.subarray(2, len + 2);
        if (!len || res.length !== len) throw new E("Invalid signature integer: wrong length");
        // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
        // since we always use positive integers here. It must always be empty:
        // - add zero byte if exists
        // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
        if (res[0] & 128) throw new E("Invalid signature integer: negative");
        if (res[0] === 0x00 && !(res[1] & 128)) throw new E("Invalid signature integer: unnecessary leading zero");
        return {
            d: $6981eb90e423adb6$var$b2n(res),
            l: data.subarray(len + 2)
        }; // d is data, l is left
    },
    toSig: function(hex) {
        // parse DER signature
        var E = $6981eb90e423adb6$export$56ac33195d7076db.Err;
        var data = typeof hex === "string" ? $6981eb90e423adb6$var$h2b(hex) : hex;
        $fLMRX.abytes(data);
        var l = data.length;
        if (l < 2 || data[0] != 0x30) throw new E("Invalid signature tag");
        if (data[1] !== l - 2) throw new E("Invalid signature: incorrect length");
        var _DER__parseInt = $6981eb90e423adb6$export$56ac33195d7076db._parseInt(data.subarray(2)), r = _DER__parseInt.d, sBytes = _DER__parseInt.l;
        var _DER__parseInt1 = $6981eb90e423adb6$export$56ac33195d7076db._parseInt(sBytes), s = _DER__parseInt1.d, rBytesLeft = _DER__parseInt1.l;
        if (rBytesLeft.length) throw new E("Invalid signature: left bytes after parsing");
        return {
            r: r,
            s: s
        };
    },
    hexFromSig: function(sig) {
        // Add leading zero if first byte has negative bit enabled. More details in '_parseInt'
        var slice = function(s) {
            return Number.parseInt(s[0], 16) & 8 ? "00" + s : s;
        };
        var h = function(num) {
            var hex = num.toString(16);
            return hex.length & 1 ? "0".concat(hex) : hex;
        };
        var s = slice(h(sig.s));
        var r = slice(h(sig.r));
        var shl = s.length / 2;
        var rhl = r.length / 2;
        var sl = h(shl);
        var rl = h(rhl);
        return "30".concat(h(rhl + shl + 4), "02").concat(rl).concat(r, "02").concat(sl).concat(s);
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
var $6981eb90e423adb6$var$_0n = BigInt(0), $6981eb90e423adb6$var$_1n = BigInt(1), $6981eb90e423adb6$var$_2n = BigInt(2), $6981eb90e423adb6$var$_3n = BigInt(3), $6981eb90e423adb6$var$_4n = BigInt(4);
function $6981eb90e423adb6$export$fa783af82e4fe0fc(opts) {
    var CURVE = $6981eb90e423adb6$var$validatePointOpts(opts);
    var Fp = CURVE.Fp; // All curves has same field / group length as for now, but they can differ
    var toBytes = CURVE.toBytes || function(_c, point, _isCompressed) {
        var a = point.toAffine();
        return $fLMRX.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    };
    var fromBytes = CURVE.fromBytes || function(bytes) {
        // const head = bytes[0];
        var tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        var x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        var y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x: x,
            y: y
        };
    };
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        var a = CURVE.a, b = CURVE.b;
        var x2 = Fp.sqr(x); // x * x
        var x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error("bad generator point: equation left != right");
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return (typeof num === "undefined" ? "undefined" : (0, $l0HdX._)(num)) === "bigint" && $6981eb90e423adb6$var$_0n < num && num < CURVE.n;
    }
    function assertGE(num) {
        if (!isWithinCurveOrder(num)) throw new Error("Expected valid bigint: 0 < bigint < curve.n");
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        var lengths = CURVE.allowedPrivateKeyLengths, nByteLength = CURVE.nByteLength, wrapPrivateKey = CURVE.wrapPrivateKey, n = CURVE.n;
        if (lengths && (typeof key === "undefined" ? "undefined" : (0, $l0HdX._)(key)) !== "bigint") {
            if ($fLMRX.isBytes(key)) key = $fLMRX.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== "string" || !lengths.includes(key.length)) throw new Error("Invalid key");
            key = key.padStart(nByteLength * 2, "0");
        }
        var num;
        try {
            num = (typeof key === "undefined" ? "undefined" : (0, $l0HdX._)(key)) === "bigint" ? key : $fLMRX.bytesToNumberBE((0, $fLMRX.ensureBytes)("private key", key, nByteLength));
        } catch (error) {
            throw new Error("private key must be ".concat(nByteLength, " bytes, hex or bigint, not ").concat(typeof key === "undefined" ? "undefined" : (0, $l0HdX._)(key)));
        }
        if (wrapPrivateKey) num = $bb46G.mod(num, n); // disabled by default, enabled for BLS
        assertGE(num); // num in range [1..N-1]
        return num;
    }
    var pointPrecomputes = new Map();
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error("ProjectivePoint expected");
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ var Point = /*#__PURE__*/ function() {
        "use strict";
        function Point(px, py, pz) {
            (0, $4GJKx._)(this, Point);
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error("x required");
            if (py == null || !Fp.isValid(py)) throw new Error("y required");
            if (pz == null || !Fp.isValid(pz)) throw new Error("z required");
        }
        (0, $1wc17._)(Point, [
            {
                key: "x",
                get: function get() {
                    return this.toAffine().x;
                }
            },
            {
                key: "y",
                get: function get() {
                    return this.toAffine().y;
                }
            },
            {
                // "Private method", don't use it directly
                key: "_setWindowSize",
                value: function _setWindowSize(windowSize) {
                    this._WINDOW_SIZE = windowSize;
                    pointPrecomputes.delete(this);
                }
            },
            {
                // A point on curve is valid if it conforms to equation.
                key: "assertValidity",
                value: function assertValidity() {
                    if (this.is0()) {
                        // (0, 1, 0) aka ZERO is invalid in most contexts.
                        // In BLS, ZERO can be serialized, so we allow it.
                        // (0, 0, 0) is wrong representation of ZERO and is always invalid.
                        if (CURVE.allowInfinityPoint && !Fp.is0(this.py)) return;
                        throw new Error("bad point: ZERO");
                    }
                    // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
                    var _this_toAffine = this.toAffine(), x = _this_toAffine.x, y = _this_toAffine.y;
                    // Check if x, y are valid field elements
                    if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error("bad point: x or y not FE");
                    var left = Fp.sqr(y); // y²
                    var right = weierstrassEquation(x); // x³ + ax + b
                    if (!Fp.eql(left, right)) throw new Error("bad point: equation left != right");
                    if (!this.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
                }
            },
            {
                key: "hasEvenY",
                value: function hasEvenY() {
                    var y = this.toAffine().y;
                    if (Fp.isOdd) return !Fp.isOdd(y);
                    throw new Error("Field doesn't support isOdd");
                }
            },
            {
                /**
         * Compare one point to another.
         */ key: "equals",
                value: function equals(other) {
                    assertPrjPoint(other);
                    var _this = this, X1 = _this.px, Y1 = _this.py, Z1 = _this.pz;
                    var X2 = other.px, Y2 = other.py, Z2 = other.pz;
                    var U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
                    var U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
                    return U1 && U2;
                }
            },
            {
                /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ key: "negate",
                value: function negate() {
                    return new Point(this.px, Fp.neg(this.py), this.pz);
                }
            },
            {
                // Renes-Costello-Batina exception-free doubling formula.
                // There is 30% faster Jacobian formula, but it is not complete.
                // https://eprint.iacr.org/2015/1060, algorithm 3
                // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
                key: "double",
                value: function double() {
                    var a = CURVE.a, b = CURVE.b;
                    var b3 = Fp.mul(b, $6981eb90e423adb6$var$_3n);
                    var _this = this, X1 = _this.px, Y1 = _this.py, Z1 = _this.pz;
                    var X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
                    var t0 = Fp.mul(X1, X1); // step 1
                    var t1 = Fp.mul(Y1, Y1);
                    var t2 = Fp.mul(Z1, Z1);
                    var t3 = Fp.mul(X1, Y1);
                    t3 = Fp.add(t3, t3); // step 5
                    Z3 = Fp.mul(X1, Z1);
                    Z3 = Fp.add(Z3, Z3);
                    X3 = Fp.mul(a, Z3);
                    Y3 = Fp.mul(b3, t2);
                    Y3 = Fp.add(X3, Y3); // step 10
                    X3 = Fp.sub(t1, Y3);
                    Y3 = Fp.add(t1, Y3);
                    Y3 = Fp.mul(X3, Y3);
                    X3 = Fp.mul(t3, X3);
                    Z3 = Fp.mul(b3, Z3); // step 15
                    t2 = Fp.mul(a, t2);
                    t3 = Fp.sub(t0, t2);
                    t3 = Fp.mul(a, t3);
                    t3 = Fp.add(t3, Z3);
                    Z3 = Fp.add(t0, t0); // step 20
                    t0 = Fp.add(Z3, t0);
                    t0 = Fp.add(t0, t2);
                    t0 = Fp.mul(t0, t3);
                    Y3 = Fp.add(Y3, t0);
                    t2 = Fp.mul(Y1, Z1); // step 25
                    t2 = Fp.add(t2, t2);
                    t0 = Fp.mul(t2, t3);
                    X3 = Fp.sub(X3, t0);
                    Z3 = Fp.mul(t2, t1);
                    Z3 = Fp.add(Z3, Z3); // step 30
                    Z3 = Fp.add(Z3, Z3);
                    return new Point(X3, Y3, Z3);
                }
            },
            {
                // Renes-Costello-Batina exception-free addition formula.
                // There is 30% faster Jacobian formula, but it is not complete.
                // https://eprint.iacr.org/2015/1060, algorithm 1
                // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
                key: "add",
                value: function add(other) {
                    assertPrjPoint(other);
                    var _this = this, X1 = _this.px, Y1 = _this.py, Z1 = _this.pz;
                    var X2 = other.px, Y2 = other.py, Z2 = other.pz;
                    var X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
                    var a = CURVE.a;
                    var b3 = Fp.mul(CURVE.b, $6981eb90e423adb6$var$_3n);
                    var t0 = Fp.mul(X1, X2); // step 1
                    var t1 = Fp.mul(Y1, Y2);
                    var t2 = Fp.mul(Z1, Z2);
                    var t3 = Fp.add(X1, Y1);
                    var t4 = Fp.add(X2, Y2); // step 5
                    t3 = Fp.mul(t3, t4);
                    t4 = Fp.add(t0, t1);
                    t3 = Fp.sub(t3, t4);
                    t4 = Fp.add(X1, Z1);
                    var t5 = Fp.add(X2, Z2); // step 10
                    t4 = Fp.mul(t4, t5);
                    t5 = Fp.add(t0, t2);
                    t4 = Fp.sub(t4, t5);
                    t5 = Fp.add(Y1, Z1);
                    X3 = Fp.add(Y2, Z2); // step 15
                    t5 = Fp.mul(t5, X3);
                    X3 = Fp.add(t1, t2);
                    t5 = Fp.sub(t5, X3);
                    Z3 = Fp.mul(a, t4);
                    X3 = Fp.mul(b3, t2); // step 20
                    Z3 = Fp.add(X3, Z3);
                    X3 = Fp.sub(t1, Z3);
                    Z3 = Fp.add(t1, Z3);
                    Y3 = Fp.mul(X3, Z3);
                    t1 = Fp.add(t0, t0); // step 25
                    t1 = Fp.add(t1, t0);
                    t2 = Fp.mul(a, t2);
                    t4 = Fp.mul(b3, t4);
                    t1 = Fp.add(t1, t2);
                    t2 = Fp.sub(t0, t2); // step 30
                    t2 = Fp.mul(a, t2);
                    t4 = Fp.add(t4, t2);
                    t0 = Fp.mul(t1, t4);
                    Y3 = Fp.add(Y3, t0);
                    t0 = Fp.mul(t5, t4); // step 35
                    X3 = Fp.mul(t3, X3);
                    X3 = Fp.sub(X3, t0);
                    t0 = Fp.mul(t3, t1);
                    Z3 = Fp.mul(t5, Z3);
                    Z3 = Fp.add(Z3, t0); // step 40
                    return new Point(X3, Y3, Z3);
                }
            },
            {
                key: "subtract",
                value: function subtract(other) {
                    return this.add(other.negate());
                }
            },
            {
                key: "is0",
                value: function is0() {
                    return this.equals(Point.ZERO);
                }
            },
            {
                key: "wNAF",
                value: function wNAF(n) {
                    return wnaf.wNAFCached(this, pointPrecomputes, n, function(comp) {
                        var toInv = Fp.invertBatch(comp.map(function(p) {
                            return p.pz;
                        }));
                        return comp.map(function(p, i) {
                            return p.toAffine(toInv[i]);
                        }).map(Point.fromAffine);
                    });
                }
            },
            {
                /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ key: "multiplyUnsafe",
                value: function multiplyUnsafe(n) {
                    var I = Point.ZERO;
                    if (n === $6981eb90e423adb6$var$_0n) return I;
                    assertGE(n); // Will throw on 0
                    if (n === $6981eb90e423adb6$var$_1n) return this;
                    var endo = CURVE.endo;
                    if (!endo) return wnaf.unsafeLadder(this, n);
                    // Apply endomorphism
                    var _endo_splitScalar = endo.splitScalar(n), k1neg = _endo_splitScalar.k1neg, k1 = _endo_splitScalar.k1, k2neg = _endo_splitScalar.k2neg, k2 = _endo_splitScalar.k2;
                    var k1p = I;
                    var k2p = I;
                    var d = this;
                    while(k1 > $6981eb90e423adb6$var$_0n || k2 > $6981eb90e423adb6$var$_0n){
                        if (k1 & $6981eb90e423adb6$var$_1n) k1p = k1p.add(d);
                        if (k2 & $6981eb90e423adb6$var$_1n) k2p = k2p.add(d);
                        d = d.double();
                        k1 >>= $6981eb90e423adb6$var$_1n;
                        k2 >>= $6981eb90e423adb6$var$_1n;
                    }
                    if (k1neg) k1p = k1p.negate();
                    if (k2neg) k2p = k2p.negate();
                    k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                    return k1p.add(k2p);
                }
            },
            {
                /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ key: "multiply",
                value: function multiply(scalar) {
                    assertGE(scalar);
                    var n = scalar;
                    var point, fake; // Fake point is used to const-time mult
                    var endo = CURVE.endo;
                    if (endo) {
                        var _endo_splitScalar = endo.splitScalar(n), k1neg = _endo_splitScalar.k1neg, k1 = _endo_splitScalar.k1, k2neg = _endo_splitScalar.k2neg, k2 = _endo_splitScalar.k2;
                        var _this_wNAF = this.wNAF(k1), k1p = _this_wNAF.p, f1p = _this_wNAF.f;
                        var _this_wNAF1 = this.wNAF(k2), k2p = _this_wNAF1.p, f2p = _this_wNAF1.f;
                        k1p = wnaf.constTimeNegate(k1neg, k1p);
                        k2p = wnaf.constTimeNegate(k2neg, k2p);
                        k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                        point = k1p.add(k2p);
                        fake = f1p.add(f2p);
                    } else {
                        var _this_wNAF2 = this.wNAF(n), p = _this_wNAF2.p, f = _this_wNAF2.f;
                        point = p;
                        fake = f;
                    }
                    // Normalize `z` for both points, but return only real one
                    return Point.normalizeZ([
                        point,
                        fake
                    ])[0];
                }
            },
            {
                /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ key: "multiplyAndAddUnsafe",
                value: function multiplyAndAddUnsafe(Q, a, b) {
                    var G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
                    var mul = function(P, a // Select faster multiply() method
                    ) {
                        return a === $6981eb90e423adb6$var$_0n || a === $6981eb90e423adb6$var$_1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
                    };
                    var sum = mul(this, a).add(mul(Q, b));
                    return sum.is0() ? undefined : sum;
                }
            },
            {
                // Converts Projective point to affine (x, y) coordinates.
                // Can accept precomputed Z^-1 - for example, from invertBatch.
                // (x, y, z) ∋ (x=x/z, y=y/z)
                key: "toAffine",
                value: function toAffine(iz) {
                    var _this = this, x = _this.px, y = _this.py, z = _this.pz;
                    var is0 = this.is0();
                    // If invZ was 0, we return zero point. However we still want to execute
                    // all operations, so we replace invZ with a random number, 1.
                    if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
                    var ax = Fp.mul(x, iz);
                    var ay = Fp.mul(y, iz);
                    var zz = Fp.mul(z, iz);
                    if (is0) return {
                        x: Fp.ZERO,
                        y: Fp.ZERO
                    };
                    if (!Fp.eql(zz, Fp.ONE)) throw new Error("invZ was invalid");
                    return {
                        x: ax,
                        y: ay
                    };
                }
            },
            {
                key: "isTorsionFree",
                value: function isTorsionFree() {
                    var cofactor = CURVE.h, isTorsionFree = CURVE.isTorsionFree;
                    if (cofactor === $6981eb90e423adb6$var$_1n) return true; // No subgroups, always torsion-free
                    if (isTorsionFree) return isTorsionFree(Point, this);
                    throw new Error("isTorsionFree() has not been declared for the elliptic curve");
                }
            },
            {
                key: "clearCofactor",
                value: function clearCofactor() {
                    var cofactor = CURVE.h, clearCofactor = CURVE.clearCofactor;
                    if (cofactor === $6981eb90e423adb6$var$_1n) return this; // Fast-path
                    if (clearCofactor) return clearCofactor(Point, this);
                    return this.multiplyUnsafe(CURVE.h);
                }
            },
            {
                key: "toRawBytes",
                value: function toRawBytes() {
                    var isCompressed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                    this.assertValidity();
                    return toBytes(Point, this, isCompressed);
                }
            },
            {
                key: "toHex",
                value: function toHex() {
                    var isCompressed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                    return $fLMRX.bytesToHex(this.toRawBytes(isCompressed));
                }
            }
        ], [
            {
                key: "fromAffine",
                value: // Does not validate if the point is on-curve.
                // Use fromHex instead, or call assertValidity() later.
                function fromAffine(p) {
                    var _ref = p || {}, x = _ref.x, y = _ref.y;
                    if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error("invalid affine point");
                    if (p instanceof Point) throw new Error("projective point not allowed");
                    var is0 = function(i) {
                        return Fp.eql(i, Fp.ZERO);
                    };
                    // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
                    if (is0(x) && is0(y)) return Point.ZERO;
                    return new Point(x, y, Fp.ONE);
                }
            },
            {
                key: "normalizeZ",
                value: /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ function normalizeZ(points) {
                    var toInv = Fp.invertBatch(points.map(function(p) {
                        return p.pz;
                    }));
                    return points.map(function(p, i) {
                        return p.toAffine(toInv[i]);
                    }).map(Point.fromAffine);
                }
            },
            {
                key: "fromHex",
                value: /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ function fromHex(hex) {
                    var P = Point.fromAffine(fromBytes((0, $fLMRX.ensureBytes)("pointHex", hex)));
                    P.assertValidity();
                    return P;
                }
            },
            {
                key: "fromPrivateKey",
                value: // Multiplies generator point by privateKey.
                function fromPrivateKey(privateKey) {
                    return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
                }
            }
        ]);
        return Point;
    }();
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    var _bits = CURVE.nBitLength;
    var wnaf = (0, $5tzPU.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE: CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    };
}
function $6981eb90e423adb6$var$validateOpts(curve) {
    var opts = (0, $5tzPU.validateBasic)(curve);
    $fLMRX.validateObject(opts, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    });
    return Object.freeze((0, $do9pw._)({
        lowS: true
    }, opts));
}
function $6981eb90e423adb6$export$350b8ea6f1c27fae(curveDef) {
    var CURVE = $6981eb90e423adb6$var$validateOpts(curveDef);
    var Fp = CURVE.Fp, CURVE_ORDER = CURVE.n;
    var compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    var uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function isValidFieldElement(num) {
        return $6981eb90e423adb6$var$_0n < num && num < Fp.ORDER; // 0 is banned since it's not invertible FE
    }
    function modN(a) {
        return $bb46G.mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return $bb46G.invert(a, CURVE_ORDER);
    }
    var _weierstrassPoints = $6981eb90e423adb6$export$fa783af82e4fe0fc((0, $cxjpp._)((0, $do9pw._)({}, CURVE), {
        toBytes: function(_c, point, isCompressed) {
            var a = point.toAffine();
            var x = Fp.toBytes(a.x);
            var cat = $fLMRX.concatBytes;
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes: function(bytes) {
            var len = bytes.length;
            var head = bytes[0];
            var tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                var x = $fLMRX.bytesToNumberBE(tail);
                if (!isValidFieldElement(x)) throw new Error("Point is not on curve");
                var y2 = weierstrassEquation(x); // y² = x³ + ax + b
                var y;
                try {
                    y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                } catch (sqrtError) {
                    var suffix = sqrtError instanceof Error ? ": " + sqrtError.message : "";
                    throw new Error("Point is not on curve" + suffix);
                }
                var isYOdd = (y & $6981eb90e423adb6$var$_1n) === $6981eb90e423adb6$var$_1n;
                // ECDSA
                var isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x: x,
                    y: y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                var x1 = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                var y1 = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x: x1,
                    y: y1
                };
            } else throw new Error("Point of length ".concat(len, " was invalid. Expected ").concat(compressedLen, " compressed bytes or ").concat(uncompressedLen, " uncompressed bytes"));
        }
    })), Point = _weierstrassPoints.ProjectivePoint, normPrivateKeyToScalar = _weierstrassPoints.normPrivateKeyToScalar, weierstrassEquation = _weierstrassPoints.weierstrassEquation, isWithinCurveOrder = _weierstrassPoints.isWithinCurveOrder;
    var numToNByteStr = function(num) {
        return $fLMRX.bytesToHex($fLMRX.numberToBytesBE(num, CURVE.nByteLength));
    };
    function isBiggerThanHalfOrder(number) {
        var HALF = CURVE_ORDER >> $6981eb90e423adb6$var$_1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    var slcNum = function(b, from, to) {
        return $fLMRX.bytesToNumberBE(b.slice(from, to));
    };
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ var Signature = /*#__PURE__*/ function() {
        "use strict";
        function Signature(r, s, recovery) {
            (0, $4GJKx._)(this, Signature);
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        (0, $1wc17._)(Signature, [
            {
                key: "assertValidity",
                value: function assertValidity() {
                    // can use assertGE here
                    if (!isWithinCurveOrder(this.r)) throw new Error("r must be 0 < r < CURVE.n");
                    if (!isWithinCurveOrder(this.s)) throw new Error("s must be 0 < s < CURVE.n");
                }
            },
            {
                key: "addRecoveryBit",
                value: function addRecoveryBit(recovery) {
                    return new Signature(this.r, this.s, recovery);
                }
            },
            {
                key: "recoverPublicKey",
                value: function recoverPublicKey(msgHash) {
                    var _this = this, r = _this.r, s = _this.s, rec = _this.recovery;
                    var h = bits2int_modN((0, $fLMRX.ensureBytes)("msgHash", msgHash)); // Truncate hash
                    if (rec == null || ![
                        0,
                        1,
                        2,
                        3
                    ].includes(rec)) throw new Error("recovery id invalid");
                    var radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
                    if (radj >= Fp.ORDER) throw new Error("recovery id 2 or 3 invalid");
                    var prefix = (rec & 1) === 0 ? "02" : "03";
                    var R = Point.fromHex(prefix + numToNByteStr(radj));
                    var ir = invN(radj); // r^-1
                    var u1 = modN(-h * ir); // -hr^-1
                    var u2 = modN(s * ir); // sr^-1
                    var Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
                    if (!Q) throw new Error("point at infinify"); // unsafe is fine: no priv data leaked
                    Q.assertValidity();
                    return Q;
                }
            },
            {
                // Signatures should be low-s, to prevent malleability.
                key: "hasHighS",
                value: function hasHighS() {
                    return isBiggerThanHalfOrder(this.s);
                }
            },
            {
                key: "normalizeS",
                value: function normalizeS() {
                    return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
                }
            },
            {
                // DER-encoded
                key: "toDERRawBytes",
                value: function toDERRawBytes() {
                    return $fLMRX.hexToBytes(this.toDERHex());
                }
            },
            {
                key: "toDERHex",
                value: function toDERHex() {
                    return $6981eb90e423adb6$export$56ac33195d7076db.hexFromSig({
                        r: this.r,
                        s: this.s
                    });
                }
            },
            {
                // padded bytes of r, then padded bytes of s
                key: "toCompactRawBytes",
                value: function toCompactRawBytes() {
                    return $fLMRX.hexToBytes(this.toCompactHex());
                }
            },
            {
                key: "toCompactHex",
                value: function toCompactHex() {
                    return numToNByteStr(this.r) + numToNByteStr(this.s);
                }
            }
        ], [
            {
                key: "fromCompact",
                value: // pair (bytes of r, bytes of s)
                function fromCompact(hex) {
                    var l = CURVE.nByteLength;
                    hex = (0, $fLMRX.ensureBytes)("compactSignature", hex, l * 2);
                    return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
                }
            },
            {
                key: "fromDER",
                value: // DER encoded ECDSA signature
                // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
                function fromDER(hex) {
                    var _DER_toSig = $6981eb90e423adb6$export$56ac33195d7076db.toSig((0, $fLMRX.ensureBytes)("DER", hex)), r = _DER_toSig.r, s = _DER_toSig.s;
                    return new Signature(r, s);
                }
            }
        ]);
        return Signature;
    }();
    var utils = {
        isValidPrivateKey: function(privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: function() {
            var length = $bb46G.getMinHashLength(CURVE.n);
            return $bb46G.mapHashToField(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute: function() {
            var windowSize = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 8, point = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Point.BASE;
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey) {
        var isCompressed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        var arr = $fLMRX.isBytes(item);
        var str = typeof item === "string";
        var len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB) {
        var isCompressed = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        if (isProbPub(privateA)) throw new Error("first arg must be private key");
        if (!isProbPub(publicB)) throw new Error("second arg must be public key");
        var b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    var bits2int = CURVE.bits2int || function(bytes) {
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        var num = $fLMRX.bytesToNumberBE(bytes); // check for == u8 done here
        var delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    var bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    var ORDER_MASK = $fLMRX.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        if ((typeof num === "undefined" ? "undefined" : (0, $l0HdX._)(num)) !== "bigint") throw new Error("bigint expected");
        if (!($6981eb90e423adb6$var$_0n <= num && num < ORDER_MASK)) throw new Error("bigint expected < 2^".concat(CURVE.nBitLength));
        // works with order, can have different size than numToField!
        return $fLMRX.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order, this will be wrong at least for P521.
    // Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey) {
        var opts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultSigOpts;
        var _ut;
        if ([
            "recovered",
            "canonical"
        ].some(function(k) {
            return k in opts;
        })) throw new Error("sign() legacy options not supported");
        var hash = CURVE.hash, randomBytes = CURVE.randomBytes;
        var lowS = opts.lowS, prehash = opts.prehash, ent = opts.extraEntropy; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, $fLMRX.ensureBytes)("msgHash", msgHash);
        if (prehash) msgHash = (0, $fLMRX.ensureBytes)("prehashed msgHash", hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        var h1int = bits2int_modN(msgHash);
        var d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        var seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null && ent !== false) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            var e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, $fLMRX.ensureBytes)("extraEntropy", e)); // check for being bytes
        }
        var seed = (_ut = $fLMRX).concatBytes.apply(_ut, (0, $c6Xmf._)(seedArgs)); // Step D of RFC6979 3.2
        var m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            var k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            var ik = invN(k); // k^-1 mod n
            var q = Point.BASE.multiply(k).toAffine(); // q = Gk
            var r = modN(q.x); // r = q.x mod n
            if (r === $6981eb90e423adb6$var$_0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            var s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === $6981eb90e423adb6$var$_0n) return;
            var recovery = (q.x === r ? 0 : 2) | Number(q.y & $6981eb90e423adb6$var$_1n); // recovery bit (2 or 3, when q.x > n)
            var normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    var defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    var defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey) {
        var opts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultSigOpts;
        var _prepSig = prepSig(msgHash, privKey, opts), seed = _prepSig.seed, k2sig = _prepSig.k2sig; // Steps A, D of RFC6979 3.2.
        var C = CURVE;
        var drbg = $fLMRX.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey) {
        var opts = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : defaultVerOpts;
        var _Point_BASE_multiplyAndAddUnsafe;
        var sg = signature;
        msgHash = (0, $fLMRX.ensureBytes)("msgHash", msgHash);
        publicKey = (0, $fLMRX.ensureBytes)("publicKey", publicKey);
        if ("strict" in opts) throw new Error("options.strict was renamed to lowS");
        var lowS = opts.lowS, prehash = opts.prehash;
        var _sig = undefined;
        var P;
        try {
            if (typeof sg === "string" || $fLMRX.isBytes(sg)) // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
            // Since DER can also be 2*nByteLength bytes, we check for it first.
            try {
                _sig = Signature.fromDER(sg);
            } catch (derError) {
                if (!(derError instanceof $6981eb90e423adb6$export$56ac33195d7076db.Err)) throw derError;
                _sig = Signature.fromCompact(sg);
            }
            else if (typeof sg === "object" && (0, $l0HdX._)(sg.r) === "bigint" && (0, $l0HdX._)(sg.s) === "bigint") {
                var r = sg.r, s = sg.s;
                _sig = new Signature(r, s);
            } else throw new Error("PARSE");
            P = Point.fromHex(publicKey);
        } catch (error) {
            if (error.message === "PARSE") throw new Error("signature must be Signature instance, Uint8Array or hex string");
            return false;
        }
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        var r1 = _sig.r, s1 = _sig.s;
        var h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        var is = invN(s1); // s^-1
        var u1 = modN(h * is); // u1 = hs^-1 mod n
        var u2 = modN(r1 * is); // u2 = rs^-1 mod n
        var R = (_Point_BASE_multiplyAndAddUnsafe = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)) === null || _Point_BASE_multiplyAndAddUnsafe === void 0 ? void 0 : _Point_BASE_multiplyAndAddUnsafe.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        var v = modN(R.x);
        return v === r1;
    }
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        sign: sign,
        verify: verify,
        ProjectivePoint: Point,
        Signature: Signature,
        utils: utils
    };
}
function $6981eb90e423adb6$export$8324ae9483e33241(Fp, Z) {
    // Generic implementation
    var q = Fp.ORDER;
    var l = $6981eb90e423adb6$var$_0n;
    for(var o = q - $6981eb90e423adb6$var$_1n; o % $6981eb90e423adb6$var$_2n === $6981eb90e423adb6$var$_0n; o /= $6981eb90e423adb6$var$_2n)l += $6981eb90e423adb6$var$_1n;
    var c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    var _2n_pow_c1_1 = $6981eb90e423adb6$var$_2n << c1 - $6981eb90e423adb6$var$_1n - $6981eb90e423adb6$var$_1n;
    var _2n_pow_c1 = _2n_pow_c1_1 * $6981eb90e423adb6$var$_2n;
    var c2 = (q - $6981eb90e423adb6$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    var c3 = (c2 - $6981eb90e423adb6$var$_1n) / $6981eb90e423adb6$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    var c4 = _2n_pow_c1 - $6981eb90e423adb6$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    var c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    var c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    var c7 = Fp.pow(Z, (c2 + $6981eb90e423adb6$var$_1n) / $6981eb90e423adb6$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    var sqrtRatio = function(u, v) {
        var tv1 = c6; // 1. tv1 = c6
        var tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        var tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        var tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        var tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        var isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(var i = c1; i > $6981eb90e423adb6$var$_1n; i--){
            var tv51 = i - $6981eb90e423adb6$var$_2n; // 18.    tv5 = i - 2
            tv51 = $6981eb90e423adb6$var$_2n << tv51 - $6981eb90e423adb6$var$_1n; // 19.    tv5 = 2^tv5
            var tvv5 = Fp.pow(tv4, tv51); // 20.    tv5 = tv4^tv5
            var e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $6981eb90e423adb6$var$_4n === $6981eb90e423adb6$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        var c11 = (Fp.ORDER - $6981eb90e423adb6$var$_3n) / $6981eb90e423adb6$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        var c21 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = function(u, v) {
            var tv1 = Fp.sqr(v); // 1. tv1 = v^2
            var tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            var y1 = Fp.pow(tv1, c11); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            var y2 = Fp.mul(y1, c21); // 6. y2 = y1 * c2
            var tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            var isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            var y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
function $6981eb90e423adb6$export$cc7fea9756a17416(Fp, opts) {
    $bb46G.validateField(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
    var sqrtRatio = $6981eb90e423adb6$export$8324ae9483e33241(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error("Fp.isOdd is not implemented!");
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return function(u) {
        // prettier-ignore
        var tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        var _sqrtRatio = sqrtRatio(tv2, tv6), isValid = _sqrtRatio.isValid, value = _sqrtRatio.value; // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        var e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}

});
parcelRegister("5tzPU", function(module, exports) {

$parcel$export(module.exports, "wNAF", function () { return wNAF; });
$parcel$export(module.exports, "validateBasic", function () { return validateBasic; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Abelian group utilities

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $bb46G = parcelRequire("bb46G");

var $fLMRX = parcelRequire("fLMRX");
var _0n = BigInt(0);
var _1n = BigInt(1);
function wNAF(c, bits) {
    var constTimeNegate = function(condition, item) {
        var neg = item.negate();
        return condition ? neg : item;
    };
    var opts = function(W) {
        var windows = Math.ceil(bits / W) + 1; // +1, because
        var windowSize = Math.pow(2, W - 1); // -1 because we skip zero
        return {
            windows: windows,
            windowSize: windowSize
        };
    };
    return {
        constTimeNegate: constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder: function(elm, n) {
            var p = c.ZERO;
            var d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow: function(elm, W) {
            var _opts = opts(W), windows = _opts.windows, windowSize = _opts.windowSize;
            var points = [];
            var p = elm;
            var base = p;
            for(var window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(var i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF: function(W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            var _opts = opts(W), windows = _opts.windows, windowSize = _opts.windowSize;
            var p = c.ZERO;
            var f = c.BASE;
            var mask = BigInt(Math.pow(2, W) - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            var maxNumber = Math.pow(2, W);
            var shiftBy = BigInt(W);
            for(var window = 0; window < windows; window++){
                var offset = window * windowSize;
                // Extract W bits.
                var wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                var offset1 = offset;
                var offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                var cond1 = window % 2 !== 0;
                var cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        wNAFCached: function(P, precomputesMap, n, transform) {
            // @ts-ignore
            var W = P._WINDOW_SIZE || 1;
            // Calculate precomputes on a first run, reuse them after
            var comp = precomputesMap.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) precomputesMap.set(P, transform(comp));
            }
            return this.wNAF(W, comp, n);
        }
    };
}
function validateBasic(curve) {
    (0, $bb46G.validateField)(curve.Fp);
    (0, $fLMRX.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze((0, $cxjpp._)((0, $do9pw._)({}, (0, $bb46G.nLength)(curve.n, curve.nBitLength), curve), {
        p: curve.Fp.ORDER
    }));
}

});


parcelRegister("htkZk", function(module, exports) {

$parcel$export(module.exports, "isogenyMap", function () { return $cb856ceae88db3c2$export$9393380cf1075f28; });
$parcel$export(module.exports, "createHasher", function () { return $cb856ceae88db3c2$export$14b114effbc08b6b; });

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $bb46G = parcelRequire("bb46G");

var $fLMRX = parcelRequire("fLMRX");
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
var $cb856ceae88db3c2$var$os2ip = (0, $fLMRX.bytesToNumberBE);
// Integer to Octet Stream (numberToBytesBE)
function $cb856ceae88db3c2$var$i2osp(value, length) {
    if (value < 0 || value >= 1 << 8 * length) throw new Error("bad I2OSP call: value=".concat(value, " length=").concat(length));
    var res = Array.from({
        length: length
    }).fill(0);
    for(var i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $cb856ceae88db3c2$var$strxor(a, b) {
    var arr = new Uint8Array(a.length);
    for(var i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $cb856ceae88db3c2$var$anum(item) {
    if (!Number.isSafeInteger(item)) throw new Error("number expected");
}
function $cb856ceae88db3c2$export$3df78c69af9fc85d(msg, DST, lenInBytes, H) {
    (0, $fLMRX.abytes)(msg);
    (0, $fLMRX.abytes)(DST);
    $cb856ceae88db3c2$var$anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $fLMRX.concatBytes)((0, $fLMRX.utf8ToBytes)("H2C-OVERSIZE-DST-"), DST));
    var b_in_bytes = H.outputLen, r_in_bytes = H.blockLen;
    var ell = Math.ceil(lenInBytes / b_in_bytes);
    if (ell > 255) throw new Error("Invalid xmd length");
    var DST_prime = (0, $fLMRX.concatBytes)(DST, $cb856ceae88db3c2$var$i2osp(DST.length, 1));
    var Z_pad = $cb856ceae88db3c2$var$i2osp(0, r_in_bytes);
    var l_i_b_str = $cb856ceae88db3c2$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    var b = new Array(ell);
    var b_0 = H((0, $fLMRX.concatBytes)(Z_pad, msg, l_i_b_str, $cb856ceae88db3c2$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $fLMRX.concatBytes)(b_0, $cb856ceae88db3c2$var$i2osp(1, 1), DST_prime));
    for(var i = 1; i <= ell; i++){
        var args = [
            $cb856ceae88db3c2$var$strxor(b_0, b[i - 1]),
            $cb856ceae88db3c2$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $fLMRX.concatBytes).apply(void 0, (0, $c6Xmf._)(args)));
    }
    var pseudo_random_bytes = (0, $fLMRX.concatBytes).apply(void 0, (0, $c6Xmf._)(b));
    return pseudo_random_bytes.slice(0, lenInBytes);
}
function $cb856ceae88db3c2$export$3f56d6fdbf95d07c(msg, DST, lenInBytes, k, H) {
    (0, $fLMRX.abytes)(msg);
    (0, $fLMRX.abytes)(DST);
    $cb856ceae88db3c2$var$anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        var dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $fLMRX.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($cb856ceae88db3c2$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($cb856ceae88db3c2$var$i2osp(DST.length, 1)).digest();
}
function $cb856ceae88db3c2$export$97cdd5ee18de8172(msg, count, options) {
    (0, $fLMRX.validateObject)(options, {
        DST: "stringOrUint8Array",
        p: "bigint",
        m: "isSafeInteger",
        k: "isSafeInteger",
        hash: "hash"
    });
    var p = options.p, k = options.k, m = options.m, hash = options.hash, expand = options.expand, _DST = options.DST;
    (0, $fLMRX.abytes)(msg);
    $cb856ceae88db3c2$var$anum(count);
    var DST = typeof _DST === "string" ? (0, $fLMRX.utf8ToBytes)(_DST) : _DST;
    var log2p = p.toString(2).length;
    var L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    var len_in_bytes = count * m * L;
    var prb; // pseudo_random_bytes
    if (expand === "xmd") prb = $cb856ceae88db3c2$export$3df78c69af9fc85d(msg, DST, len_in_bytes, hash);
    else if (expand === "xof") prb = $cb856ceae88db3c2$export$3f56d6fdbf95d07c(msg, DST, len_in_bytes, k, hash);
    else if (expand === "_internal_pass") // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    var u = new Array(count);
    for(var i = 0; i < count; i++){
        var e = new Array(m);
        for(var j = 0; j < m; j++){
            var elm_offset = L * (j + i * m);
            var tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $bb46G.mod)($cb856ceae88db3c2$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
function $cb856ceae88db3c2$export$9393380cf1075f28(field, map) {
    // Make same order as in spec
    var COEFF = map.map(function(i) {
        return Array.from(i).reverse();
    });
    return function(x, y) {
        var _COEFF_map = (0, $cv9Rk._)(COEFF.map(function(val) {
            return val.reduce(function(acc, i) {
                return field.add(field.mul(acc, x), i);
            });
        }), 4), xNum = _COEFF_map[0], xDen = _COEFF_map[1], yNum = _COEFF_map[2], yDen = _COEFF_map[3];
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
function $cb856ceae88db3c2$export$14b114effbc08b6b(Point, mapToCurve, def) {
    if (typeof mapToCurve !== "function") throw new Error("mapToCurve() must be defined");
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve: function(msg, options) {
            var u = $cb856ceae88db3c2$export$97cdd5ee18de8172(msg, 2, (0, $do9pw._)((0, $cxjpp._)((0, $do9pw._)({}, def), {
                DST: def.DST
            }), options));
            var u0 = Point.fromAffine(mapToCurve(u[0]));
            var u1 = Point.fromAffine(mapToCurve(u[1]));
            var P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve: function(msg, options) {
            var u = $cb856ceae88db3c2$export$97cdd5ee18de8172(msg, 1, (0, $do9pw._)((0, $cxjpp._)((0, $do9pw._)({}, def), {
                DST: def.encodeDST
            }), options));
            var P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}

});

parcelRegister("6y2wD", function(module, exports) {

$parcel$export(module.exports, "createCurve", function () { return $4c47e08a60275f31$export$3f2f6721dd02558a; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $c6Xmf = parcelRequire("c6Xmf");

var $334hE = parcelRequire("334hE");

var $8ybNC = parcelRequire("8ybNC");

var $93C41 = parcelRequire("93C41");
function $4c47e08a60275f31$export$adaba664e531641c(hash) {
    return {
        hash: hash,
        hmac: function(key) {
            for(var _len = arguments.length, msgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                msgs[_key - 1] = arguments[_key];
            }
            return (0, $334hE.hmac)(hash, key, (0, $8ybNC.concatBytes).apply(void 0, (0, $c6Xmf._)(msgs)));
        },
        randomBytes: (0, $8ybNC.randomBytes)
    };
}
function $4c47e08a60275f31$export$3f2f6721dd02558a(curveDef, defHash) {
    var create = function(hash) {
        return (0, $93C41.weierstrass)((0, $do9pw._)({}, curveDef, $4c47e08a60275f31$export$adaba664e531641c(hash)));
    };
    return Object.freeze((0, $cxjpp._)((0, $do9pw._)({}, create(defHash)), {
        create: create
    }));
}

});
parcelRegister("334hE", function(module, exports) {

$parcel$export(module.exports, "hmac", function () { return $2384f98b630c66a2$export$355af40f8ab02f34; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $Vu6Hx = parcelRequire("Vu6Hx");

var $8ybNC = parcelRequire("8ybNC");
var $2384f98b630c66a2$export$7b9cf41ebec74f45 = /*#__PURE__*/ function(Hash) {
    "use strict";
    (0, $dcsZi._)(HMAC, Hash);
    var _super = (0, $ohfOJ._)(HMAC);
    function HMAC(hash, _key) {
        (0, $4GJKx._)(this, HMAC);
        var _this;
        _this = _super.call(this);
        _this.finished = false;
        _this.destroyed = false;
        (0, $Vu6Hx.hash)(hash);
        var key = (0, $8ybNC.toBytes)(_key);
        _this.iHash = hash.create();
        if (typeof _this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        _this.blockLen = _this.iHash.blockLen;
        _this.outputLen = _this.iHash.outputLen;
        var blockLen = _this.blockLen;
        var pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(var i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        _this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        _this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(var i1 = 0; i1 < pad.length; i1++)pad[i1] ^= 106;
        _this.oHash.update(pad);
        pad.fill(0);
        return _this;
    }
    (0, $1wc17._)(HMAC, [
        {
            key: "update",
            value: function update(buf) {
                (0, $Vu6Hx.exists)(this);
                this.iHash.update(buf);
                return this;
            }
        },
        {
            key: "digestInto",
            value: function digestInto(out) {
                (0, $Vu6Hx.exists)(this);
                (0, $Vu6Hx.bytes)(out, this.outputLen);
                this.finished = true;
                this.iHash.digestInto(out);
                this.oHash.update(out);
                this.oHash.digestInto(out);
                this.destroy();
            }
        },
        {
            key: "digest",
            value: function digest() {
                var out = new Uint8Array(this.oHash.outputLen);
                this.digestInto(out);
                return out;
            }
        },
        {
            key: "_cloneInto",
            value: function _cloneInto(to) {
                // Create new instance without calling constructor since key already in state and we don't know it.
                to || (to = Object.create(Object.getPrototypeOf(this), {}));
                var _this = this, oHash = _this.oHash, iHash = _this.iHash, finished = _this.finished, destroyed = _this.destroyed, blockLen = _this.blockLen, outputLen = _this.outputLen;
                to;
                to.finished = finished;
                to.destroyed = destroyed;
                to.blockLen = blockLen;
                to.outputLen = outputLen;
                to.oHash = oHash._cloneInto(to.oHash);
                to.iHash = iHash._cloneInto(to.iHash);
                return to;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.destroyed = true;
                this.oHash.destroy();
                this.iHash.destroy();
            }
        }
    ]);
    return HMAC;
}((0, $8ybNC.Hash));
var $2384f98b630c66a2$export$355af40f8ab02f34 = function(hash, key, message) {
    return new $2384f98b630c66a2$export$7b9cf41ebec74f45(hash, key).update(message).digest();
};
$2384f98b630c66a2$export$355af40f8ab02f34.create = function(hash, key) {
    return new $2384f98b630c66a2$export$7b9cf41ebec74f45(hash, key);
};

});



parcelRegister("bnbqr", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $847ab48debb16f3f$export$bf730a2d8bf68b42; }, function (v) { return $847ab48debb16f3f$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $847ab48debb16f3f$export$bf730a2d8bf68b42;
"use strict";

var $1Mpn7 = parcelRequire("1Mpn7");

var $dZvjC = parcelRequire("dZvjC");
function $847ab48debb16f3f$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $847ab48debb16f3f$var$q = "function" === typeof Object.is ? Object.is : $847ab48debb16f3f$var$p, $847ab48debb16f3f$var$r = $dZvjC.useSyncExternalStore, $847ab48debb16f3f$var$t = $1Mpn7.useRef, $847ab48debb16f3f$var$u = $1Mpn7.useEffect, $847ab48debb16f3f$var$v = $1Mpn7.useMemo, $847ab48debb16f3f$var$w = $1Mpn7.useDebugValue;
$847ab48debb16f3f$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $847ab48debb16f3f$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $847ab48debb16f3f$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var _$b = f.value;
                    if (g(_$b, a)) return k = _$b;
                }
                return k = a;
            }
            _$b = k;
            if ($847ab48debb16f3f$var$q(d, a)) return _$b;
            var _$e = l(a);
            if (void 0 !== g && g(_$b, _$e)) return _$b;
            d = a;
            return k = _$e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $847ab48debb16f3f$var$r(a, c[0], c[1]);
    $847ab48debb16f3f$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $847ab48debb16f3f$var$w(d);
    return d;
};

});
parcelRegister("dZvjC", function(module, exports) {
"use strict";

module.exports = (parcelRequire("469HA"));

});
parcelRegister("469HA", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $2fbf3f992d44bee0$export$306c0aa65ff9ec16; }, function (v) { return $2fbf3f992d44bee0$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2fbf3f992d44bee0$export$306c0aa65ff9ec16;
"use strict";

var $1Mpn7 = parcelRequire("1Mpn7");
function $2fbf3f992d44bee0$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $2fbf3f992d44bee0$var$k = "function" === typeof Object.is ? Object.is : $2fbf3f992d44bee0$var$h, $2fbf3f992d44bee0$var$l = $1Mpn7.useState, $2fbf3f992d44bee0$var$m = $1Mpn7.useEffect, $2fbf3f992d44bee0$var$n = $1Mpn7.useLayoutEffect, $2fbf3f992d44bee0$var$p = $1Mpn7.useDebugValue;
function $2fbf3f992d44bee0$var$q(a, b) {
    var d = b(), f = $2fbf3f992d44bee0$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $2fbf3f992d44bee0$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $2fbf3f992d44bee0$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $2fbf3f992d44bee0$var$m(function() {
        $2fbf3f992d44bee0$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $2fbf3f992d44bee0$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $2fbf3f992d44bee0$var$p(d);
    return d;
}
function $2fbf3f992d44bee0$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$2fbf3f992d44bee0$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $2fbf3f992d44bee0$var$t(a, b) {
    return b();
}
var $2fbf3f992d44bee0$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $2fbf3f992d44bee0$var$t : $2fbf3f992d44bee0$var$q;
$2fbf3f992d44bee0$export$306c0aa65ff9ec16 = void 0 !== $1Mpn7.useSyncExternalStore ? $1Mpn7.useSyncExternalStore : $2fbf3f992d44bee0$var$u;

});



parcelRegister("lFPa6", function(module, exports) {

var $l0HdX = parcelRequire("l0HdX");
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined1;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined1 : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined1 : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined1) result = result === undefined1 ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined1 : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, _$Function = context.Function, Math = context.Math, _$Object = context.Object, _$RegExp = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = _$Function.prototype, objectProto = _$Object.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(_$Object);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = _$RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined1, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined1, getPrototype = overArg(_$Object.getPrototypeOf, _$Object), objectCreate = _$Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined1, symIterator = Symbol ? Symbol.iterator : undefined1, symToStringTag = Symbol ? Symbol.toStringTag : undefined1;
        var defineProperty = function() {
            try {
                var func = getNative(_$Object, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = _$Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined1, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(_$Object.keys, _$Object), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(_$Object, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined1, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined1, symbolToString = symbolProto ? symbolProto.toString : undefined1;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var _$result = new object;
                object.prototype = undefined1;
                return _$result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined1;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var _$result = new LazyWrapper(this.__wrapped__);
            _$result.__actions__ = copyArray(this.__actions__);
            _$result.__dir__ = this.__dir__;
            _$result.__filtered__ = this.__filtered__;
            _$result.__iteratees__ = copyArray(this.__iteratees__);
            _$result.__takeCount__ = this.__takeCount__;
            _$result.__views__ = copyArray(this.__views__);
            return _$result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var _$result = new LazyWrapper(this);
                _$result.__dir__ = -1;
                _$result.__filtered__ = true;
            } else {
                _$result = this.clone();
                _$result.__dir__ *= -1;
            }
            return _$result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var _$result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], _$iteratee = data.iteratee, type = data.type, computed = _$iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                _$result[resIndex++] = value;
            }
            return _$result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var _$result = this.has(key) && delete this.__data__[key];
            this.size -= _$result ? 1 : 0;
            return _$result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var _$result = data[key];
                return _$result === HASH_UNDEFINED ? undefined1 : _$result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined1;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined1 : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined1 ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined1 : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var _$result = getMapData(this, key)["delete"](key);
            this.size -= _$result ? 1 : 0;
            return _$result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), _$size = data.size;
            data.set(key, value);
            this.size += data.size == _$size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, _$result = data["delete"](key);
            this.size = data.size;
            return _$result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, _$result = skipIndexes ? baseTimes(value.length, String) : [], length = _$result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) _$result.push(key);
            return _$result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined1;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined1 && !eq(object[key], value) || value === undefined1 && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined1 && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, _$result = Array1(length), skip = object == null;
            while(++index < length)_$result[index] = skip ? undefined1 : get(object, paths[index]);
            return _$result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined1) number = number <= upper ? number : upper;
                if (lower !== undefined1) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var _$result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) _$result = object ? customizer(value, key, object, stack) : customizer(value);
            if (_$result !== undefined1) return _$result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                _$result = initCloneArray(value);
                if (!isDeep) return copyArray(value, _$result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    _$result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(_$result, value)) : copySymbols(value, baseAssign(_$result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    _$result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, _$result);
            if (isSet(value)) value.forEach(function(subValue) {
                _$result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                _$result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined1 : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(_$result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return _$result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = _$Object(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined1 && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined1, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, _$includes = arrayIncludes, isCommon = true, length = array.length, _$result = [], valuesLength = values.length;
            if (!length) return _$result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                _$includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                _$includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    _$result.push(value);
                } else if (!_$includes(values, computed, comparator)) _$result.push(value);
            }
            return _$result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var _$result = true;
            baseEach(collection, function(value, index, collection) {
                _$result = !!predicate(value, index, collection);
                return _$result;
            });
            return _$result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined1 ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, _$result = value;
            }
            return _$result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined1 || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var _$result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) _$result.push(value);
            });
            return _$result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined1;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var _$result = keysFunc(object);
            return isArray(object) ? _$result : arrayPush(_$result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined1 ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in _$Object(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in _$Object(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var _$includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, _$result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined1;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && _$result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : _$includes(_$result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : _$includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    _$result.push(value);
                }
            }
            return _$result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined1 : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = _$Object(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined1 && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var _$result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(_$result === undefined1 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : _$result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var _$result = [];
            for(var key in _$Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") _$result.push(key);
            return _$result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), _$result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) _$result.push(key);
            return _$result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, _$result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                _$result[++index] = iteratee(value, key, collection);
            });
            return _$result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined1 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined1;
                    if (newValue === undefined1) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined1;
            var isCommon = newValue === undefined1;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined1;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var _$result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(_$result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, _$result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(_$result, castPath(path, object), value);
            }
            return _$result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var _$indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = _$indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), _$result = Array1(length);
            while(length--){
                _$result[fromRight ? length : ++index] = start;
                start += step;
            }
            return _$result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var _$result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return _$result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) _$result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return _$result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined1;
                    if (newValue === undefined1) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function baseSetData(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function baseSetToString(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var _$result = Array1(length);
            while(++index < length)_$result[index] = array[index + start];
            return _$result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var _$result;
            baseEach(collection, function(value, index, collection) {
                _$result = predicate(value, index, collection);
                return !_$result;
            });
            return !!_$result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined1;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined1, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, _$result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    _$result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return _$result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var _$result = value + "";
            return _$result == "0" && 1 / value == -INFINITY ? "-0" : _$result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, _$includes = arrayIncludes, length = array.length, isCommon = true, _$result = [], seen = _$result;
            if (comparator) {
                isCommon = false;
                _$includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var _$set = iteratee ? null : createSet(array);
                if (_$set) return setToArray(_$set);
                isCommon = false;
                _$includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : _$result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    _$result.push(value);
                } else if (!_$includes(seen, computed, comparator)) {
                    if (seen !== _$result) seen.push(computed);
                    _$result.push(value);
                }
            }
            return _$result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var _$result = value;
            if (_$result instanceof LazyWrapper) _$result = _$result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, _$result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, _$result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) _$result[index] = baseDifference(_$result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(_$result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, _$result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined1;
                assignFunc(_$result, props[index], value);
            }
            return _$result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined1 ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, _$result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(_$result);
            return _$result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var _$result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(_$result).set(new Uint8Array(arrayBuffer));
            return _$result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var _$result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            _$result.lastIndex = regexp.lastIndex;
            return _$result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? _$Object(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined1, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined1, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var _$result = compareAscending(objCriteria[index], othCriteria[index]);
                if (_$result) {
                    if (index >= ordersLength) return _$result;
                    var order = orders[index];
                    return _$result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), _$result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)_$result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) _$result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)_$result[leftIndex++] = args[argsIndex++];
            return _$result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), _$result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)_$result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)_$result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) _$result[offset + holders[holdersIndex]] = args[argsIndex++];
            return _$result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined1;
                if (newValue === undefined1) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined1, guard = length > 2 ? sources[2] : undefined1;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined1;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined1 : customizer;
                    length = 1;
                }
                object = _$Object(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = _$Object(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = _$Object(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined1;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), _$result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(_$result) ? _$result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined1, args, holders, undefined1, undefined1, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = _$Object(collection);
                if (!isArrayLike(collection)) {
                    var _$iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function predicate(key) {
                        return _$iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[_$iteratee ? collection[index] : index] : undefined1;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined1;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, _$result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)_$result = funcs[index].call(this, _$result);
                    return _$result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined1 : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var _$result;
                if (value === undefined1 && other === undefined1) return defaultValue;
                if (value !== undefined1) _$result = value;
                if (other !== undefined1) {
                    if (_$result === undefined1) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    _$result = operator(value, other);
                }
                return _$result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined1 ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var _$result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(_$result), 0, length).join("") : _$result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined1;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined1) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined1 ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined1, newHoldersRight = isCurry ? undefined1 : holders, newPartials = isCurry ? partials : undefined1, newPartialsRight = isCurry ? undefined1 : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var _$result = wrapFunc.apply(undefined1, newData);
            if (isLaziable(func)) setData(_$result, newData);
            _$result.placeholder = placeholder;
            return setWrapToString(_$result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function createSet(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined1;
            }
            ary = ary === undefined1 ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined1 ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined1;
            }
            var data = isBindKey ? undefined1 : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined1 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var _$result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) _$result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) _$result = createPartial(func, bitmask, thisArg, partials);
            else _$result = createHybrid.apply(undefined1, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(_$result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined1 || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined1, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined1 : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, _$result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined1;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined1) {
                    if (compared) continue;
                    _$result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        _$result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    _$result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return _$result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var _$result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return _$result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var _$result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    _$result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (_$result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) _$result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return _$result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined1, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function getData(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var _$result = func.name + "", array = realNames[_$result], length = hasOwnProperty.call(realNames, _$result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return _$result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var _$result = lodash.iteratee || iteratee;
            _$result = _$result === iteratee ? baseIteratee : _$result;
            return arguments.length ? _$result(arguments[0], arguments[1]) : _$result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var _$result = keys(object), length = _$result.length;
            while(length--){
                var key = _$result[length], value = object[key];
                _$result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return _$result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined1;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined1;
                var unmasked = true;
            } catch (e) {}
            var _$result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return _$result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function getSymbols(object) {
            if (object == null) return [];
            object = _$Object(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function getSymbolsIn(object) {
            var _$result = [];
            while(object){
                arrayPush(_$result, getSymbols(object));
                object = getPrototype(object);
            }
            return _$result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function getTag(value) {
            var _$result = baseGetTag(value), Ctor = _$result == objectTag ? value.constructor : undefined1, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return _$result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], _$size = data.size;
                switch(data.type){
                    case "drop":
                        start += _$size;
                        break;
                    case "dropRight":
                        end -= _$size;
                        break;
                    case "take":
                        end = nativeMin(end, start + _$size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - _$size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, _$result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(_$result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (_$result || ++index != length) return _$result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, _$result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                _$result.index = array.index;
                _$result.input = array.input;
            }
            return _$result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value);
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index === "undefined" ? "undefined" : (0, $l0HdX._)(index);
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value);
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in _$Object(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value);
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined1 || key in _$Object(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var _$result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = _$result.cache;
            return _$result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var _$result = [];
            if (object != null) for(var key in _$Object(object))_$result.push(key);
            return _$result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined1 ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined1;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined1, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined1 ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var _$result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) _$result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                _$result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return _$result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var _$result = value + "";
            return _$result == "0" && 1 / value == -INFINITY ? "-0" : _$result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var _$result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            _$result.__actions__ = copyArray(wrapper.__actions__);
            _$result.__index__ = wrapper.__index__;
            _$result.__values__ = wrapper.__values__;
            return _$result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined1) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, _$result = Array1(nativeCeil(length / size));
            while(index < length)_$result[resIndex++] = baseSlice(array, index, index += size);
            return _$result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, _$result = [];
            while(++index < length){
                var value = array[index];
                if (value) _$result[resIndex++] = value;
            }
            return _$result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var _$iteratee = last(values);
            if (isArrayLikeObject(_$iteratee)) _$iteratee = undefined1;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(_$iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined1;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined1, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined1) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined1 ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, _$result = {};
            while(++index < length){
                var pair = pairs[index];
                _$result[pair[0]] = pair[1];
            }
            return _$result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined1;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var _$iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (_$iteratee === last(mapped)) _$iteratee = undefined1;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(_$iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined1;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined1, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined1;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined1) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined1;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined1, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, _$result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return _$result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var _$result = [];
            if (!(array && array.length)) return _$result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    _$result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return _$result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined1 ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var _$iteratee = last(arrays);
            if (isArrayLikeObject(_$iteratee)) _$iteratee = undefined1;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(_$iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined1;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined1, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined1;
            return array && array.length ? baseUniq(array, undefined1, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var _$result = unzip(array);
            if (iteratee == null) return _$result;
            return arrayMap(_$result, function(group) {
                return apply(iteratee, undefined1, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var _$iteratee = last(arrays);
            if (isArrayLikeObject(_$iteratee)) _$iteratee = undefined1;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(_$iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined1;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined1, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, _$iteratee = length > 1 ? arrays[length - 1] : undefined1;
            _$iteratee = typeof _$iteratee == "function" ? (arrays.pop(), _$iteratee) : undefined1;
            return unzipWith(arrays, _$iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var _$result = lodash(value);
            _$result.__chain__ = true;
            return _$result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function interceptor(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined1
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined1);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined1) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined1 : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var _$result, parent = this;
            while(parent instanceof baseLodash){
                var _$clone = wrapperClone(parent);
                _$clone.__index__ = 0;
                _$clone.__values__ = undefined1;
                if (_$result) previous.__wrapped__ = _$clone;
                else _$result = _$clone;
                var previous = _$clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return _$result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined1
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined1;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined1 ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", _$result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                _$result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return _$result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined1 : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined1) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined1;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined1 : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined1, undefined1, undefined1, undefined1, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var _$result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) _$result = func.apply(this, arguments);
                if (n <= 1) func = undefined1;
                return _$result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined1 : arity;
            var _$result = createWrap(func, WRAP_CURRY_FLAG, undefined1, undefined1, undefined1, undefined1, undefined1, arity);
            _$result.placeholder = curry.placeholder;
            return _$result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined1 : arity;
            var _$result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined1, undefined1, undefined1, undefined1, undefined1, arity);
            _$result.placeholder = curryRight.placeholder;
            return _$result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, _$result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined1;
                lastInvokeTime = time;
                _$result = func.apply(thisArg, args);
                return _$result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : _$result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined1;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined1;
                return _$result;
            }
            function cancel() {
                if (timerId !== undefined1) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined1;
            }
            function flush() {
                return timerId === undefined1 ? _$result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined1) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined1) timerId = setTimeout(timerExpired, wait);
                return _$result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function memoized1() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var _$result = func.apply(this, args);
                memoized.cache = cache.set(key, _$result) || cache;
                return _$result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined1, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined1, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined1, undefined1, undefined1, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined1 ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function isArguments(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            var _$result = customizer ? customizer(value, other) : undefined1;
            return _$result === undefined1 ? baseIsEqual(value, other, undefined1, customizer) : !!_$result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value);
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return (typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value)) == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined1;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var _$result = toFinite(value), remainder = _$result % 1;
            return _$result === _$result ? remainder ? _$result - remainder : _$result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var _$result = baseCreate(prototype);
            return properties == null ? _$result : baseAssign(_$result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = _$Object(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined1;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined1 || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined1, customDefaultsMerge);
            return apply(mergeWith, undefined1, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var _$result = object == null ? undefined1 : baseGet(object, path);
            return _$result === undefined1 ? defaultValue : _$result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var _$result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(_$result, iteratee(value, key, object), value);
            });
            return _$result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var _$result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(_$result, key, iteratee(value, key, object));
            });
            return _$result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var _$result = {};
            if (object == null) return _$result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), _$result);
            if (isDeep) _$result = baseClone(_$result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(_$result, paths[length]);
            return _$result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined1;
            }
            while(++index < length){
                var value = object == null ? undefined1 : object[toKey(path[index])];
                if (value === undefined1) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined1) {
                upper = lower;
                lower = undefined1;
            }
            if (upper !== undefined1) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined1) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined1) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined1;
            if (floating === undefined1) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined1;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined1;
                }
            }
            if (lower === undefined1 && upper === undefined1) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined1) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined1 ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined1) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined1;
            limit = limit === undefined1 ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined1;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = _$RegExp((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var _$result = attempt(function() {
                return _$Function(importsKeys, sourceURL + "return " + source).apply(undefined1, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            _$result.source = source;
            if (isError(_$result)) throw _$result;
            return _$result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var _$result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined1) return _$result + omission;
            if (strSymbols) end += _$result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = _$result;
                    if (!separator.global) separator = _$RegExp(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    _$result = _$result.slice(0, newEnd === undefined1 ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = _$result.lastIndexOf(separator);
                if (index > -1) _$result = _$result.slice(0, index);
            }
            return _$result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined1 : pattern;
            if (pattern === undefined1) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined1, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var _$chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (_$chain || chainAll) {
                        var _$result = object(this.__wrapped__), actions = _$result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        _$result.__chain__ = chainAll;
                        return _$result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined1 : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var _$result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return _$result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined1;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined1;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined1;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined1;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined1 ? 1 : nativeMax(toInteger(n), 0);
                var _$result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (_$result.__filtered__) _$result.__takeCount__ = nativeMin(n, _$result.__takeCount__);
                else _$result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (_$result.__dir__ < 0 ? "Right" : "")
                });
                return _$result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var _$result = this.clone();
                _$result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                _$result.__filtered__ = _$result.__filtered__ || isFilter;
                return _$result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var _$result = this;
            if (_$result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(_$result);
            if (start < 0) _$result = _$result.takeRight(-start);
            else if (start) _$result = _$result.drop(start);
            if (end !== undefined1) {
                end = toInteger(end);
                _$result = end < 0 ? _$result.dropRight(-end) : _$result.take(end - start);
            }
            return _$result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, _$iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function interceptor(value) {
                    var _$result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? _$result[0] : _$result;
                };
                if (useLazy && checkIteratee && typeof _$iteratee == "function" && _$iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var _$result = func.apply(value, args);
                    _$result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined1
                    });
                    return new LodashWrapper(_$result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                _$result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? _$result.value()[0] : _$result.value() : _$result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined1, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined1
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(undefined);

});

parcelRegister("69N5M", function(module, exports) {

$parcel$export(module.exports, "PublicKey", function () { return $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de; });
$parcel$export(module.exports, "SIGNATURE_LENGTH_IN_BYTES", function () { return $47b9aa0c5fbd17c3$export$14aee086fde78fa6; });
$parcel$export(module.exports, "VersionedMessage", function () { return $47b9aa0c5fbd17c3$export$b0a61927d00ede7f; });
$parcel$export(module.exports, "TransactionInstruction", function () { return $47b9aa0c5fbd17c3$export$a7a3aa8360ac9f59; });
$parcel$export(module.exports, "Transaction", function () { return $47b9aa0c5fbd17c3$export$febc5573c75cefb0; });
$parcel$export(module.exports, "VersionedTransaction", function () { return $47b9aa0c5fbd17c3$export$232cc3f078dcc284; });
$parcel$export(module.exports, "SystemProgram", function () { return $47b9aa0c5fbd17c3$export$d8c4e17726848113; });
$parcel$export(module.exports, "Connection", function () { return $47b9aa0c5fbd17c3$export$98b66c25bb38499d; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $04RAu = parcelRequire("04RAu");

var $b8Rim = parcelRequire("b8Rim");

var $dcsZi = parcelRequire("dcsZi");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $l0HdX = parcelRequire("l0HdX");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");

var $8dlmd = parcelRequire("8dlmd");

var $dVH57 = parcelRequire("dVH57");

var $blRDm = parcelRequire("blRDm");

var $h0PUv = parcelRequire("h0PUv");

var $fjRrf = parcelRequire("fjRrf");

var $1jbTD = parcelRequire("1jbTD");

var $jt90m = parcelRequire("jt90m");

var $hgOwg = parcelRequire("hgOwg");

var $58xNN = parcelRequire("58xNN");

var $cwYMR = parcelRequire("cwYMR");

var $1Rq52 = parcelRequire("1Rq52");

var $jlkmN = parcelRequire("jlkmN");

var $2r5xP = parcelRequire("2r5xP");
/**
 * A 64 byte secret key, the first 32 bytes of which is the
 * private scalar and the last 32 bytes is the public key.
 * Read more: https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
 */ /**
 * Ed25519 Keypair
 */ var $47b9aa0c5fbd17c3$var$generatePrivateKey = (0, $dVH57.ed25519).utils.randomPrivateKey;
var $47b9aa0c5fbd17c3$var$generateKeypair = function() {
    var privateScalar = (0, $dVH57.ed25519).utils.randomPrivateKey();
    var publicKey = $47b9aa0c5fbd17c3$var$getPublicKey(privateScalar);
    var secretKey = new Uint8Array(64);
    secretKey.set(privateScalar);
    secretKey.set(publicKey, 32);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
};
var $47b9aa0c5fbd17c3$var$getPublicKey = (0, $dVH57.ed25519).getPublicKey;
function $47b9aa0c5fbd17c3$var$isOnCurve(publicKey) {
    try {
        (0, $dVH57.ed25519).ExtendedPoint.fromHex(publicKey);
        return true;
    } catch (e) {
        return false;
    }
}
var $47b9aa0c5fbd17c3$var$sign = function(message, secretKey) {
    return (0, $dVH57.ed25519).sign(message, secretKey.slice(0, 32));
};
var $47b9aa0c5fbd17c3$var$verify = (0, $dVH57.ed25519).verify;
var $47b9aa0c5fbd17c3$var$toBuffer = function(arr) {
    if ((0, $8dlmd.Buffer).isBuffer(arr)) return arr;
    else if (arr instanceof Uint8Array) return (0, $8dlmd.Buffer).from(arr.buffer, arr.byteOffset, arr.byteLength);
    else return (0, $8dlmd.Buffer).from(arr);
};
// Class wrapping a plain object
var $47b9aa0c5fbd17c3$export$eabc71f011df675a = /*#__PURE__*/ function() {
    "use strict";
    function Struct(properties) {
        (0, $4GJKx._)(this, Struct);
        Object.assign(this, properties);
    }
    (0, $1wc17._)(Struct, [
        {
            key: "encode",
            value: function encode() {
                return (0, $8dlmd.Buffer).from((0, $1jbTD.serialize)($47b9aa0c5fbd17c3$export$68d13ce9b4cc48f3, this));
            }
        }
    ], [
        {
            key: "decode",
            value: function decode(data) {
                return (0, $1jbTD.deserialize)($47b9aa0c5fbd17c3$export$68d13ce9b4cc48f3, this, data);
            }
        },
        {
            key: "decodeUnchecked",
            value: function decodeUnchecked(data) {
                return (0, $1jbTD.deserializeUnchecked)($47b9aa0c5fbd17c3$export$68d13ce9b4cc48f3, this, data);
            }
        }
    ]);
    return Struct;
}();
// Class representing a Rust-compatible enum, since enums are only strings or
// numbers in pure JS
var $47b9aa0c5fbd17c3$export$deb82508dd66d288 = /*#__PURE__*/ function(Struct) {
    "use strict";
    (0, $dcsZi._)(Enum, Struct);
    var _super = (0, $ohfOJ._)(Enum);
    function Enum(properties) {
        (0, $4GJKx._)(this, Enum);
        var _this;
        _this = _super.call(this, properties);
        _this.enum = "";
        if (Object.keys(properties).length !== 1) throw new Error("Enum can only take single value");
        Object.keys(properties).map(function(key) {
            _this.enum = key;
        });
        return _this;
    }
    return Enum;
}($47b9aa0c5fbd17c3$export$eabc71f011df675a);
var $47b9aa0c5fbd17c3$export$68d13ce9b4cc48f3 = new Map();
var $47b9aa0c5fbd17c3$var$_PublicKey;
/**
 * Maximum length of derived pubkey seed
 */ var $47b9aa0c5fbd17c3$export$8240f9da84ad7873 = 32;
/**
 * Size of public key in bytes
 */ var $47b9aa0c5fbd17c3$export$84fc0a248cc54343 = 32;
/**
 * Value to be converted into public key
 */ /**
 * JSON object representation of PublicKey class
 */ function $47b9aa0c5fbd17c3$var$isPublicKeyData(value) {
    return value._bn !== undefined;
}
// local counter used by PublicKey.unique()
var $47b9aa0c5fbd17c3$var$uniquePublicKeyCounter = 1;
/**
 * A public key
 */ var $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de = /*#__PURE__*/ function(Struct) {
    "use strict";
    (0, $dcsZi._)(PublicKey, Struct);
    var _super = (0, $ohfOJ._)(PublicKey);
    function PublicKey(value) {
        (0, $4GJKx._)(this, PublicKey);
        var _this;
        _this = _super.call(this, {});
        /** @internal */ _this._bn = void 0;
        if ($47b9aa0c5fbd17c3$var$isPublicKeyData(value)) _this._bn = value._bn;
        else {
            if (typeof value === "string") {
                // assume base 58 encoding by default
                var decoded = (0, (/*@__PURE__*/$parcel$interopDefault($h0PUv))).decode(value);
                if (decoded.length != $47b9aa0c5fbd17c3$export$84fc0a248cc54343) throw new Error("Invalid public key input");
                _this._bn = new (0, (/*@__PURE__*/$parcel$interopDefault($blRDm)))(decoded);
            } else _this._bn = new (0, (/*@__PURE__*/$parcel$interopDefault($blRDm)))(value);
            if (_this._bn.byteLength() > $47b9aa0c5fbd17c3$export$84fc0a248cc54343) throw new Error("Invalid public key input");
        }
        return _this;
    }
    (0, $1wc17._)(PublicKey, [
        {
            /**
   * Default public key value. The base58-encoded string representation is all ones (as seen below)
   * The underlying BN number is 32 bytes that are all zeros
   */ /**
   * Checks if two publicKeys are equal
   */ key: "equals",
            value: function equals(publicKey) {
                return this._bn.eq(publicKey._bn);
            }
        },
        {
            /**
   * Return the base-58 representation of the public key
   */ key: "toBase58",
            value: function toBase58() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($h0PUv))).encode(this.toBytes());
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.toBase58();
            }
        },
        {
            /**
   * Return the byte array representation of the public key in big endian
   */ key: "toBytes",
            value: function toBytes() {
                var buf = this.toBuffer();
                return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
            }
        },
        {
            /**
   * Return the Buffer representation of the public key in big endian
   */ key: "toBuffer",
            value: function toBuffer() {
                var b = this._bn.toArrayLike((0, $8dlmd.Buffer));
                if (b.length === $47b9aa0c5fbd17c3$export$84fc0a248cc54343) return b;
                var zeroPad = (0, $8dlmd.Buffer).alloc(32);
                b.copy(zeroPad, 32 - b.length);
                return zeroPad;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "PublicKey(".concat(this.toString(), ")");
            }
        },
        {
            /**
   * Return the base-58 representation of the public key
   */ key: "toString",
            value: function toString() {
                return this.toBase58();
            }
        }
    ], [
        {
            key: "unique",
            value: /**
   * Returns a unique PublicKey for tests and benchmarks using a counter
   */ function unique() {
                var key = new PublicKey($47b9aa0c5fbd17c3$var$uniquePublicKeyCounter);
                $47b9aa0c5fbd17c3$var$uniquePublicKeyCounter += 1;
                return new PublicKey(key.toBuffer());
            }
        },
        {
            key: "createWithSeed",
            value: /**
   * Derive a public key from another key, a seed, and a program ID.
   * The program ID will also serve as the owner of the public key, giving
   * it permission to write data to the account.
   */ /* eslint-disable require-await */ function createWithSeed(fromPublicKey, seed, programId) {
                return (0, $kSuI9._)(function() {
                    var buffer, publicKeyBytes;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        buffer = (0, $8dlmd.Buffer).concat([
                            fromPublicKey.toBuffer(),
                            (0, $8dlmd.Buffer).from(seed),
                            programId.toBuffer()
                        ]);
                        publicKeyBytes = (0, $fjRrf.sha256)(buffer);
                        return [
                            2,
                            new PublicKey(publicKeyBytes)
                        ];
                    });
                })();
            }
        },
        {
            key: "createProgramAddressSync",
            value: /**
   * Derive a program address from seeds and a program ID.
   */ /* eslint-disable require-await */ function createProgramAddressSync(seeds, programId) {
                var buffer = (0, $8dlmd.Buffer).alloc(0);
                seeds.forEach(function(seed) {
                    if (seed.length > $47b9aa0c5fbd17c3$export$8240f9da84ad7873) throw new TypeError("Max seed length exceeded");
                    buffer = (0, $8dlmd.Buffer).concat([
                        buffer,
                        $47b9aa0c5fbd17c3$var$toBuffer(seed)
                    ]);
                });
                buffer = (0, $8dlmd.Buffer).concat([
                    buffer,
                    programId.toBuffer(),
                    (0, $8dlmd.Buffer).from("ProgramDerivedAddress")
                ]);
                var publicKeyBytes = (0, $fjRrf.sha256)(buffer);
                if ($47b9aa0c5fbd17c3$var$isOnCurve(publicKeyBytes)) throw new Error("Invalid seeds, address must fall off the curve");
                return new PublicKey(publicKeyBytes);
            }
        },
        {
            key: "createProgramAddress",
            value: /**
   * Async version of createProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link createProgramAddressSync} instead
   */ /* eslint-disable require-await */ function createProgramAddress(seeds, programId) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.createProgramAddressSync(seeds, programId)
                        ];
                    });
                })();
            }
        },
        {
            key: "findProgramAddressSync",
            value: /**
   * Find a valid program address
   *
   * Valid program addresses must fall off the ed25519 curve.  This function
   * iterates a nonce until it finds one that when combined with the seeds
   * results in a valid program address.
   */ function findProgramAddressSync(seeds, programId) {
                var nonce = 255;
                var address;
                while(nonce != 0){
                    try {
                        var seedsWithNonce = seeds.concat((0, $8dlmd.Buffer).from([
                            nonce
                        ]));
                        address = this.createProgramAddressSync(seedsWithNonce, programId);
                    } catch (err) {
                        if (err instanceof TypeError) throw err;
                        nonce--;
                        continue;
                    }
                    return [
                        address,
                        nonce
                    ];
                }
                throw new Error("Unable to find a viable program address nonce");
            }
        },
        {
            key: "findProgramAddress",
            value: /**
   * Async version of findProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link findProgramAddressSync} instead
   */ function findProgramAddress(seeds, programId) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.findProgramAddressSync(seeds, programId)
                        ];
                    });
                })();
            }
        },
        {
            key: "isOnCurve",
            value: /**
   * Check that a pubkey is on the ed25519 curve.
   */ function isOnCurve1(pubkeyData) {
                var pubkey = new PublicKey(pubkeyData);
                return $47b9aa0c5fbd17c3$var$isOnCurve(pubkey.toBytes());
            }
        }
    ]);
    return PublicKey;
}($47b9aa0c5fbd17c3$export$eabc71f011df675a);
$47b9aa0c5fbd17c3$var$_PublicKey = $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de;
$47b9aa0c5fbd17c3$export$ca8b6604d6ce14de.default = new $47b9aa0c5fbd17c3$var$_PublicKey("11111111111111111111111111111111");
$47b9aa0c5fbd17c3$export$68d13ce9b4cc48f3.set($47b9aa0c5fbd17c3$export$ca8b6604d6ce14de, {
    kind: "struct",
    fields: [
        [
            "_bn",
            "u256"
        ]
    ]
});
/**
 * An account key pair (public and secret keys).
 *
 * @deprecated since v1.10.0, please use {@link Keypair} instead.
 */ var $47b9aa0c5fbd17c3$export$1ed4b10e4aba04a7 = /*#__PURE__*/ function() {
    "use strict";
    function Account(secretKey) {
        (0, $4GJKx._)(this, Account);
        /** @internal */ this._publicKey = void 0;
        /** @internal */ this._secretKey = void 0;
        if (secretKey) {
            var secretKeyBuffer = $47b9aa0c5fbd17c3$var$toBuffer(secretKey);
            if (secretKey.length !== 64) throw new Error("bad secret key size");
            this._publicKey = secretKeyBuffer.slice(32, 64);
            this._secretKey = secretKeyBuffer.slice(0, 32);
        } else {
            this._secretKey = $47b9aa0c5fbd17c3$var$toBuffer($47b9aa0c5fbd17c3$var$generatePrivateKey());
            this._publicKey = $47b9aa0c5fbd17c3$var$toBuffer($47b9aa0c5fbd17c3$var$getPublicKey(this._secretKey));
        }
    }
    (0, $1wc17._)(Account, [
        {
            key: "publicKey",
            get: /**
   * The public key for this account
   */ function get() {
                return new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(this._publicKey);
            }
        },
        {
            key: "secretKey",
            get: /**
   * The **unencrypted** secret key for this account. The first 32 bytes
   * is the private scalar and the last 32 bytes is the public key.
   * Read more: https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
   */ function get() {
                return (0, $8dlmd.Buffer).concat([
                    this._secretKey,
                    this._publicKey
                ], 64);
            }
        }
    ]);
    return Account;
}();
var $47b9aa0c5fbd17c3$export$42bd37c1c64962b6 = new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de("BPFLoader1111111111111111111111111111111111");
/**
 * Maximum over-the-wire size of a Transaction
 *
 * 1280 is IPv6 minimum MTU
 * 40 bytes is the size of the IPv6 header
 * 8 bytes is the size of the fragment header
 */ var $47b9aa0c5fbd17c3$export$4c6d5b89e1596f26 = 1232;
var $47b9aa0c5fbd17c3$export$3c3793d809f8b858 = 0x7f;
var $47b9aa0c5fbd17c3$export$14aee086fde78fa6 = 64;
var $47b9aa0c5fbd17c3$export$718fcd78527f88ed = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $dcsZi._)(TransactionExpiredBlockheightExceededError, Error1);
    var _super = (0, $ohfOJ._)(TransactionExpiredBlockheightExceededError);
    function TransactionExpiredBlockheightExceededError(signature) {
        (0, $4GJKx._)(this, TransactionExpiredBlockheightExceededError);
        var _this;
        _this = _super.call(this, "Signature ".concat(signature, " has expired: block height exceeded."));
        _this.signature = void 0;
        _this.signature = signature;
        return _this;
    }
    return TransactionExpiredBlockheightExceededError;
}((0, $FuVm8._)(Error));
Object.defineProperty($47b9aa0c5fbd17c3$export$718fcd78527f88ed.prototype, "name", {
    value: "TransactionExpiredBlockheightExceededError"
});
var $47b9aa0c5fbd17c3$export$b822204c22e46bdf = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $dcsZi._)(TransactionExpiredTimeoutError, Error1);
    var _super = (0, $ohfOJ._)(TransactionExpiredTimeoutError);
    function TransactionExpiredTimeoutError(signature, timeoutSeconds) {
        (0, $4GJKx._)(this, TransactionExpiredTimeoutError);
        var _this;
        _this = _super.call(this, "Transaction was not confirmed in ".concat(timeoutSeconds.toFixed(2), " seconds. It is ") + "unknown if it succeeded or failed. Check signature " + "".concat(signature, " using the Solana Explorer or CLI tools."));
        _this.signature = void 0;
        _this.signature = signature;
        return _this;
    }
    return TransactionExpiredTimeoutError;
}((0, $FuVm8._)(Error));
Object.defineProperty($47b9aa0c5fbd17c3$export$b822204c22e46bdf.prototype, "name", {
    value: "TransactionExpiredTimeoutError"
});
var $47b9aa0c5fbd17c3$export$a3e7565a95f5a1e5 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $dcsZi._)(TransactionExpiredNonceInvalidError, Error1);
    var _super = (0, $ohfOJ._)(TransactionExpiredNonceInvalidError);
    function TransactionExpiredNonceInvalidError(signature) {
        (0, $4GJKx._)(this, TransactionExpiredNonceInvalidError);
        var _this;
        _this = _super.call(this, "Signature ".concat(signature, " has expired: the nonce is no longer valid."));
        _this.signature = void 0;
        _this.signature = signature;
        return _this;
    }
    return TransactionExpiredNonceInvalidError;
}((0, $FuVm8._)(Error));
Object.defineProperty($47b9aa0c5fbd17c3$export$a3e7565a95f5a1e5.prototype, "name", {
    value: "TransactionExpiredNonceInvalidError"
});
var $47b9aa0c5fbd17c3$export$109914c107623102 = /*#__PURE__*/ function() {
    "use strict";
    function MessageAccountKeys(staticAccountKeys, accountKeysFromLookups) {
        (0, $4GJKx._)(this, MessageAccountKeys);
        this.staticAccountKeys = void 0;
        this.accountKeysFromLookups = void 0;
        this.staticAccountKeys = staticAccountKeys;
        this.accountKeysFromLookups = accountKeysFromLookups;
    }
    (0, $1wc17._)(MessageAccountKeys, [
        {
            key: "keySegments",
            value: function keySegments() {
                var keySegments = [
                    this.staticAccountKeys
                ];
                if (this.accountKeysFromLookups) {
                    keySegments.push(this.accountKeysFromLookups.writable);
                    keySegments.push(this.accountKeysFromLookups.readonly);
                }
                return keySegments;
            }
        },
        {
            key: "get",
            value: function get(index) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.keySegments()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var keySegment = _step.value;
                        if (index < keySegment.length) return keySegment[index];
                        else index -= keySegment.length;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return;
            }
        },
        {
            key: "length",
            get: function get() {
                return this.keySegments().flat().length;
            }
        },
        {
            key: "compileInstructions",
            value: function compileInstructions(instructions) {
                // Bail early if any account indexes would overflow a u8
                var U8_MAX = 255;
                if (this.length > U8_MAX + 1) throw new Error("Account index overflow encountered during compilation");
                var keyIndexMap = new Map();
                this.keySegments().flat().forEach(function(key, index) {
                    keyIndexMap.set(key.toBase58(), index);
                });
                var findKeyIndex = function(key) {
                    var keyIndex = keyIndexMap.get(key.toBase58());
                    if (keyIndex === undefined) throw new Error("Encountered an unknown instruction account key during compilation");
                    return keyIndex;
                };
                return instructions.map(function(instruction) {
                    return {
                        programIdIndex: findKeyIndex(instruction.programId),
                        accountKeyIndexes: instruction.keys.map(function(meta) {
                            return findKeyIndex(meta.pubkey);
                        }),
                        data: instruction.data
                    };
                });
            }
        }
    ]);
    return MessageAccountKeys;
}();
/**
 * Layout for a public key
 */ var $47b9aa0c5fbd17c3$var$publicKey = function() {
    var property = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "publicKey";
    return $jt90m.blob(32, property);
};
/**
 * Layout for a signature
 */ var $47b9aa0c5fbd17c3$var$signature = function() {
    var property = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "signature";
    return $jt90m.blob(64, property);
};
/**
 * Layout for a Rust String type
 */ var $47b9aa0c5fbd17c3$var$rustString = function() {
    var property = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "string";
    var rsl = $jt90m.struct([
        $jt90m.u32("length"),
        $jt90m.u32("lengthPadding"),
        $jt90m.blob($jt90m.offset($jt90m.u32(), -8), "chars")
    ], property);
    var _decode = rsl.decode.bind(rsl);
    var _encode = rsl.encode.bind(rsl);
    var rslShim = rsl;
    rslShim.decode = function(b, offset) {
        var data = _decode(b, offset);
        return data["chars"].toString();
    };
    rslShim.encode = function(str, b, offset) {
        var data = {
            chars: (0, $8dlmd.Buffer).from(str, "utf8")
        };
        return _encode(data, b, offset);
    };
    rslShim.alloc = function(str) {
        return $jt90m.u32().span + $jt90m.u32().span + (0, $8dlmd.Buffer).from(str, "utf8").length;
    };
    return rslShim;
};
/**
 * Layout for an Authorized object
 */ var $47b9aa0c5fbd17c3$var$authorized = function() {
    var property = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "authorized";
    return $jt90m.struct([
        $47b9aa0c5fbd17c3$var$publicKey("staker"),
        $47b9aa0c5fbd17c3$var$publicKey("withdrawer")
    ], property);
};
/**
 * Layout for a Lockup object
 */ var $47b9aa0c5fbd17c3$var$lockup = function() {
    var property = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "lockup";
    return $jt90m.struct([
        $jt90m.ns64("unixTimestamp"),
        $jt90m.ns64("epoch"),
        $47b9aa0c5fbd17c3$var$publicKey("custodian")
    ], property);
};
/**
 *  Layout for a VoteInit object
 */ var $47b9aa0c5fbd17c3$var$voteInit = function() {
    var property = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "voteInit";
    return $jt90m.struct([
        $47b9aa0c5fbd17c3$var$publicKey("nodePubkey"),
        $47b9aa0c5fbd17c3$var$publicKey("authorizedVoter"),
        $47b9aa0c5fbd17c3$var$publicKey("authorizedWithdrawer"),
        $jt90m.u8("commission")
    ], property);
};
/**
 *  Layout for a VoteAuthorizeWithSeedArgs object
 */ var $47b9aa0c5fbd17c3$var$voteAuthorizeWithSeedArgs = function() {
    var property = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "voteAuthorizeWithSeedArgs";
    return $jt90m.struct([
        $jt90m.u32("voteAuthorizationType"),
        $47b9aa0c5fbd17c3$var$publicKey("currentAuthorityDerivedKeyOwnerPubkey"),
        $47b9aa0c5fbd17c3$var$rustString("currentAuthorityDerivedKeySeed"),
        $47b9aa0c5fbd17c3$var$publicKey("newAuthorized")
    ], property);
};
function $47b9aa0c5fbd17c3$var$getAlloc(type, fields) {
    var getItemAlloc = function(item) {
        if (item.span >= 0) return item.span;
        else if (typeof item.alloc === "function") return item.alloc(fields[item.property]);
        else if ("count" in item && "elementLayout" in item) {
            var field = fields[item.property];
            if (Array.isArray(field)) return field.length * getItemAlloc(item.elementLayout);
        } else if ("fields" in item) // This is a `Structure` whose size needs to be recursively measured.
        return $47b9aa0c5fbd17c3$var$getAlloc({
            layout: item
        }, fields[item.property]);
        // Couldn't determine allocated size of layout
        return 0;
    };
    var alloc = 0;
    type.layout.fields.forEach(function(item) {
        alloc += getItemAlloc(item);
    });
    return alloc;
}
function $47b9aa0c5fbd17c3$var$decodeLength(bytes) {
    var len = 0;
    var size = 0;
    for(;;){
        var elem = bytes.shift();
        len |= (elem & 0x7f) << size * 7;
        size += 1;
        if ((elem & 0x80) === 0) break;
    }
    return len;
}
function $47b9aa0c5fbd17c3$var$encodeLength(bytes, len) {
    var rem_len = len;
    for(;;){
        var elem = rem_len & 0x7f;
        rem_len >>= 7;
        if (rem_len == 0) {
            bytes.push(elem);
            break;
        } else {
            elem |= 0x80;
            bytes.push(elem);
        }
    }
}
function $47b9aa0c5fbd17c3$var$assert(condition, message) {
    if (!condition) throw new Error(message || "Assertion failed");
}
var $47b9aa0c5fbd17c3$var$CompiledKeys = /*#__PURE__*/ function() {
    "use strict";
    function CompiledKeys(payer, keyMetaMap) {
        (0, $4GJKx._)(this, CompiledKeys);
        this.payer = void 0;
        this.keyMetaMap = void 0;
        this.payer = payer;
        this.keyMetaMap = keyMetaMap;
    }
    (0, $1wc17._)(CompiledKeys, [
        {
            key: "getMessageComponents",
            value: function getMessageComponents() {
                var mapEntries = (0, $c6Xmf._)(this.keyMetaMap.entries());
                $47b9aa0c5fbd17c3$var$assert(mapEntries.length <= 256, "Max static account keys length exceeded");
                var writableSigners = mapEntries.filter(function(param) {
                    var _param = (0, $cv9Rk._)(param, 2), meta = _param[1];
                    return meta.isSigner && meta.isWritable;
                });
                var readonlySigners = mapEntries.filter(function(param) {
                    var _param = (0, $cv9Rk._)(param, 2), meta = _param[1];
                    return meta.isSigner && !meta.isWritable;
                });
                var writableNonSigners = mapEntries.filter(function(param) {
                    var _param = (0, $cv9Rk._)(param, 2), meta = _param[1];
                    return !meta.isSigner && meta.isWritable;
                });
                var readonlyNonSigners = mapEntries.filter(function(param) {
                    var _param = (0, $cv9Rk._)(param, 2), meta = _param[1];
                    return !meta.isSigner && !meta.isWritable;
                });
                var header = {
                    numRequiredSignatures: writableSigners.length + readonlySigners.length,
                    numReadonlySignedAccounts: readonlySigners.length,
                    numReadonlyUnsignedAccounts: readonlyNonSigners.length
                };
                // sanity checks
                {
                    $47b9aa0c5fbd17c3$var$assert(writableSigners.length > 0, "Expected at least one writable signer key");
                    var _writableSigners_ = (0, $cv9Rk._)(writableSigners[0], 1), payerAddress = _writableSigners_[0];
                    $47b9aa0c5fbd17c3$var$assert(payerAddress === this.payer.toBase58(), "Expected first writable signer key to be the fee payer");
                }
                var staticAccountKeys = (0, $c6Xmf._)(writableSigners.map(function(param) {
                    var _param = (0, $cv9Rk._)(param, 1), address = _param[0];
                    return new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(address);
                })).concat((0, $c6Xmf._)(readonlySigners.map(function(param) {
                    var _param = (0, $cv9Rk._)(param, 1), address = _param[0];
                    return new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(address);
                })), (0, $c6Xmf._)(writableNonSigners.map(function(param) {
                    var _param = (0, $cv9Rk._)(param, 1), address = _param[0];
                    return new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(address);
                })), (0, $c6Xmf._)(readonlyNonSigners.map(function(param) {
                    var _param = (0, $cv9Rk._)(param, 1), address = _param[0];
                    return new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(address);
                })));
                return [
                    header,
                    staticAccountKeys
                ];
            }
        },
        {
            key: "extractTableLookup",
            value: function extractTableLookup(lookupTable) {
                var _this_drainKeysFoundInLookupTable = (0, $cv9Rk._)(this.drainKeysFoundInLookupTable(lookupTable.state.addresses, function(keyMeta) {
                    return !keyMeta.isSigner && !keyMeta.isInvoked && keyMeta.isWritable;
                }), 2), writableIndexes = _this_drainKeysFoundInLookupTable[0], drainedWritableKeys = _this_drainKeysFoundInLookupTable[1];
                var _this_drainKeysFoundInLookupTable1 = (0, $cv9Rk._)(this.drainKeysFoundInLookupTable(lookupTable.state.addresses, function(keyMeta) {
                    return !keyMeta.isSigner && !keyMeta.isInvoked && !keyMeta.isWritable;
                }), 2), readonlyIndexes = _this_drainKeysFoundInLookupTable1[0], drainedReadonlyKeys = _this_drainKeysFoundInLookupTable1[1];
                // Don't extract lookup if no keys were found
                if (writableIndexes.length === 0 && readonlyIndexes.length === 0) return;
                return [
                    {
                        accountKey: lookupTable.key,
                        writableIndexes: writableIndexes,
                        readonlyIndexes: readonlyIndexes
                    },
                    {
                        writable: drainedWritableKeys,
                        readonly: drainedReadonlyKeys
                    }
                ];
            }
        },
        {
            /** @internal */ key: "drainKeysFoundInLookupTable",
            value: function drainKeysFoundInLookupTable(lookupTableEntries, keyMetaFilter) {
                var lookupTableIndexes = new Array();
                var drainedKeys = new Array();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _this = this, _loop = function() {
                        var _step_value = (0, $cv9Rk._)(_step.value, 2), address = _step_value[0], keyMeta = _step_value[1];
                        if (keyMetaFilter(keyMeta)) {
                            var key = new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(address);
                            var lookupTableIndex = lookupTableEntries.findIndex(function(entry) {
                                return entry.equals(key);
                            });
                            if (lookupTableIndex >= 0) {
                                $47b9aa0c5fbd17c3$var$assert(lookupTableIndex < 256, "Max lookup table index exceeded");
                                lookupTableIndexes.push(lookupTableIndex);
                                drainedKeys.push(key);
                                _this.keyMetaMap.delete(address);
                            }
                        }
                    };
                    for(var _iterator = this.keyMetaMap.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return [
                    lookupTableIndexes,
                    drainedKeys
                ];
            }
        }
    ], [
        {
            key: "compile",
            value: function compile(instructions, payer) {
                var keyMetaMap = new Map();
                var getOrInsertDefault = function(pubkey) {
                    var address = pubkey.toBase58();
                    var keyMeta = keyMetaMap.get(address);
                    if (keyMeta === undefined) {
                        keyMeta = {
                            isSigner: false,
                            isWritable: false,
                            isInvoked: false
                        };
                        keyMetaMap.set(address, keyMeta);
                    }
                    return keyMeta;
                };
                var payerKeyMeta = getOrInsertDefault(payer);
                payerKeyMeta.isSigner = true;
                payerKeyMeta.isWritable = true;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = instructions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var ix = _step.value;
                        getOrInsertDefault(ix.programId).isInvoked = true;
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = ix.keys[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var accountMeta = _step1.value;
                                var _keyMeta, _keyMeta1;
                                var keyMeta = getOrInsertDefault(accountMeta.pubkey);
                                (_keyMeta = keyMeta).isSigner || (_keyMeta.isSigner = accountMeta.isSigner);
                                (_keyMeta1 = keyMeta).isWritable || (_keyMeta1.isWritable = accountMeta.isWritable);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return new CompiledKeys(payer, keyMetaMap);
            }
        }
    ]);
    return CompiledKeys;
}();
var $47b9aa0c5fbd17c3$var$END_OF_BUFFER_ERROR_MESSAGE = "Reached end of buffer unexpectedly";
/**
 * Delegates to `Array#shift`, but throws if the array is zero-length.
 */ function $47b9aa0c5fbd17c3$var$guardedShift(byteArray) {
    if (byteArray.length === 0) throw new Error($47b9aa0c5fbd17c3$var$END_OF_BUFFER_ERROR_MESSAGE);
    return byteArray.shift();
}
/**
 * Delegates to `Array#splice`, but throws if the section being spliced out extends past the end of
 * the array.
 */ function $47b9aa0c5fbd17c3$var$guardedSplice(byteArray) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var _byteArray;
    var _args = (0, $cv9Rk._)(args, 1), start = _args[0];
    var _args_;
    if (args.length === 2 // Implies that `deleteCount` was supplied
     ? start + ((_args_ = args[1]) !== null && _args_ !== void 0 ? _args_ : 0) > byteArray.length : start >= byteArray.length) throw new Error($47b9aa0c5fbd17c3$var$END_OF_BUFFER_ERROR_MESSAGE);
    return (_byteArray = byteArray).splice.apply(_byteArray, (0, $c6Xmf._)(args));
}
/**
 * An instruction to execute by a program
 *
 * @property {number} programIdIndex
 * @property {number[]} accounts
 * @property {string} data
 */ /**
 * Message constructor arguments
 */ /**
 * List of instructions to be processed atomically
 */ var $47b9aa0c5fbd17c3$export$f69c19e57285b83a = /*#__PURE__*/ function() {
    "use strict";
    function Message(args) {
        var _this = this;
        (0, $4GJKx._)(this, Message);
        this.header = void 0;
        this.accountKeys = void 0;
        this.recentBlockhash = void 0;
        this.instructions = void 0;
        this.indexToProgramIds = new Map();
        this.header = args.header;
        this.accountKeys = args.accountKeys.map(function(account) {
            return new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(account);
        });
        this.recentBlockhash = args.recentBlockhash;
        this.instructions = args.instructions;
        this.instructions.forEach(function(ix) {
            return _this.indexToProgramIds.set(ix.programIdIndex, _this.accountKeys[ix.programIdIndex]);
        });
    }
    (0, $1wc17._)(Message, [
        {
            key: "version",
            get: function get() {
                return "legacy";
            }
        },
        {
            key: "staticAccountKeys",
            get: function get() {
                return this.accountKeys;
            }
        },
        {
            key: "compiledInstructions",
            get: function get() {
                return this.instructions.map(function(ix) {
                    return {
                        programIdIndex: ix.programIdIndex,
                        accountKeyIndexes: ix.accounts,
                        data: (0, (/*@__PURE__*/$parcel$interopDefault($h0PUv))).decode(ix.data)
                    };
                });
            }
        },
        {
            key: "addressTableLookups",
            get: function get() {
                return [];
            }
        },
        {
            key: "getAccountKeys",
            value: function getAccountKeys() {
                return new $47b9aa0c5fbd17c3$export$109914c107623102(this.staticAccountKeys);
            }
        },
        {
            key: "isAccountSigner",
            value: function isAccountSigner(index) {
                return index < this.header.numRequiredSignatures;
            }
        },
        {
            key: "isAccountWritable",
            value: function isAccountWritable(index) {
                var numSignedAccounts = this.header.numRequiredSignatures;
                if (index >= this.header.numRequiredSignatures) {
                    var unsignedAccountIndex = index - numSignedAccounts;
                    var numUnsignedAccounts = this.accountKeys.length - numSignedAccounts;
                    var numWritableUnsignedAccounts = numUnsignedAccounts - this.header.numReadonlyUnsignedAccounts;
                    return unsignedAccountIndex < numWritableUnsignedAccounts;
                } else {
                    var numWritableSignedAccounts = numSignedAccounts - this.header.numReadonlySignedAccounts;
                    return index < numWritableSignedAccounts;
                }
            }
        },
        {
            key: "isProgramId",
            value: function isProgramId(index) {
                return this.indexToProgramIds.has(index);
            }
        },
        {
            key: "programIds",
            value: function programIds() {
                return (0, $c6Xmf._)(this.indexToProgramIds.values());
            }
        },
        {
            key: "nonProgramIds",
            value: function nonProgramIds() {
                var _this = this;
                return this.accountKeys.filter(function(_, index) {
                    return !_this.isProgramId(index);
                });
            }
        },
        {
            key: "serialize",
            value: function serialize() {
                var numKeys = this.accountKeys.length;
                var keyCount = [];
                $47b9aa0c5fbd17c3$var$encodeLength(keyCount, numKeys);
                var instructions = this.instructions.map(function(instruction) {
                    var accounts = instruction.accounts, programIdIndex = instruction.programIdIndex;
                    var data = Array.from((0, (/*@__PURE__*/$parcel$interopDefault($h0PUv))).decode(instruction.data));
                    var keyIndicesCount = [];
                    $47b9aa0c5fbd17c3$var$encodeLength(keyIndicesCount, accounts.length);
                    var dataCount = [];
                    $47b9aa0c5fbd17c3$var$encodeLength(dataCount, data.length);
                    return {
                        programIdIndex: programIdIndex,
                        keyIndicesCount: (0, $8dlmd.Buffer).from(keyIndicesCount),
                        keyIndices: accounts,
                        dataLength: (0, $8dlmd.Buffer).from(dataCount),
                        data: data
                    };
                });
                var instructionCount = [];
                $47b9aa0c5fbd17c3$var$encodeLength(instructionCount, instructions.length);
                var instructionBuffer = (0, $8dlmd.Buffer).alloc($47b9aa0c5fbd17c3$export$4c6d5b89e1596f26);
                (0, $8dlmd.Buffer).from(instructionCount).copy(instructionBuffer);
                var instructionBufferLength = instructionCount.length;
                instructions.forEach(function(instruction) {
                    var instructionLayout = $jt90m.struct([
                        $jt90m.u8("programIdIndex"),
                        $jt90m.blob(instruction.keyIndicesCount.length, "keyIndicesCount"),
                        $jt90m.seq($jt90m.u8("keyIndex"), instruction.keyIndices.length, "keyIndices"),
                        $jt90m.blob(instruction.dataLength.length, "dataLength"),
                        $jt90m.seq($jt90m.u8("userdatum"), instruction.data.length, "data")
                    ]);
                    var length = instructionLayout.encode(instruction, instructionBuffer, instructionBufferLength);
                    instructionBufferLength += length;
                });
                instructionBuffer = instructionBuffer.slice(0, instructionBufferLength);
                var signDataLayout = $jt90m.struct([
                    $jt90m.blob(1, "numRequiredSignatures"),
                    $jt90m.blob(1, "numReadonlySignedAccounts"),
                    $jt90m.blob(1, "numReadonlyUnsignedAccounts"),
                    $jt90m.blob(keyCount.length, "keyCount"),
                    $jt90m.seq($47b9aa0c5fbd17c3$var$publicKey("key"), numKeys, "keys"),
                    $47b9aa0c5fbd17c3$var$publicKey("recentBlockhash")
                ]);
                var transaction = {
                    numRequiredSignatures: (0, $8dlmd.Buffer).from([
                        this.header.numRequiredSignatures
                    ]),
                    numReadonlySignedAccounts: (0, $8dlmd.Buffer).from([
                        this.header.numReadonlySignedAccounts
                    ]),
                    numReadonlyUnsignedAccounts: (0, $8dlmd.Buffer).from([
                        this.header.numReadonlyUnsignedAccounts
                    ]),
                    keyCount: (0, $8dlmd.Buffer).from(keyCount),
                    keys: this.accountKeys.map(function(key) {
                        return $47b9aa0c5fbd17c3$var$toBuffer(key.toBytes());
                    }),
                    recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($h0PUv))).decode(this.recentBlockhash)
                };
                var signData = (0, $8dlmd.Buffer).alloc(2048);
                var length = signDataLayout.encode(transaction, signData);
                instructionBuffer.copy(signData, length);
                return signData.slice(0, length + instructionBuffer.length);
            }
        }
    ], [
        {
            key: "compile",
            value: function compile(args) {
                var compiledKeys = $47b9aa0c5fbd17c3$var$CompiledKeys.compile(args.instructions, args.payerKey);
                var _compiledKeys_getMessageComponents = (0, $cv9Rk._)(compiledKeys.getMessageComponents(), 2), header = _compiledKeys_getMessageComponents[0], staticAccountKeys = _compiledKeys_getMessageComponents[1];
                var accountKeys = new $47b9aa0c5fbd17c3$export$109914c107623102(staticAccountKeys);
                var instructions = accountKeys.compileInstructions(args.instructions).map(function(ix) {
                    return {
                        programIdIndex: ix.programIdIndex,
                        accounts: ix.accountKeyIndexes,
                        data: (0, (/*@__PURE__*/$parcel$interopDefault($h0PUv))).encode(ix.data)
                    };
                });
                return new Message({
                    header: header,
                    accountKeys: staticAccountKeys,
                    recentBlockhash: args.recentBlockhash,
                    instructions: instructions
                });
            }
        },
        {
            key: "from",
            value: /**
   * Decode a compiled message into a Message object.
   */ function from(buffer) {
                // Slice up wire data
                var byteArray = (0, $c6Xmf._)(buffer);
                var numRequiredSignatures = $47b9aa0c5fbd17c3$var$guardedShift(byteArray);
                if (numRequiredSignatures !== (numRequiredSignatures & $47b9aa0c5fbd17c3$export$3c3793d809f8b858)) throw new Error("Versioned messages must be deserialized with VersionedMessage.deserialize()");
                var numReadonlySignedAccounts = $47b9aa0c5fbd17c3$var$guardedShift(byteArray);
                var numReadonlyUnsignedAccounts = $47b9aa0c5fbd17c3$var$guardedShift(byteArray);
                var accountCount = $47b9aa0c5fbd17c3$var$decodeLength(byteArray);
                var accountKeys = [];
                for(var i = 0; i < accountCount; i++){
                    var account = $47b9aa0c5fbd17c3$var$guardedSplice(byteArray, 0, $47b9aa0c5fbd17c3$export$84fc0a248cc54343);
                    accountKeys.push(new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de((0, $8dlmd.Buffer).from(account)));
                }
                var recentBlockhash = $47b9aa0c5fbd17c3$var$guardedSplice(byteArray, 0, $47b9aa0c5fbd17c3$export$84fc0a248cc54343);
                var instructionCount = $47b9aa0c5fbd17c3$var$decodeLength(byteArray);
                var instructions = [];
                for(var i1 = 0; i1 < instructionCount; i1++){
                    var programIdIndex = $47b9aa0c5fbd17c3$var$guardedShift(byteArray);
                    var accountCount1 = $47b9aa0c5fbd17c3$var$decodeLength(byteArray);
                    var accounts = $47b9aa0c5fbd17c3$var$guardedSplice(byteArray, 0, accountCount1);
                    var dataLength = $47b9aa0c5fbd17c3$var$decodeLength(byteArray);
                    var dataSlice = $47b9aa0c5fbd17c3$var$guardedSplice(byteArray, 0, dataLength);
                    var data = (0, (/*@__PURE__*/$parcel$interopDefault($h0PUv))).encode((0, $8dlmd.Buffer).from(dataSlice));
                    instructions.push({
                        programIdIndex: programIdIndex,
                        accounts: accounts,
                        data: data
                    });
                }
                var messageArgs = {
                    header: {
                        numRequiredSignatures: numRequiredSignatures,
                        numReadonlySignedAccounts: numReadonlySignedAccounts,
                        numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts
                    },
                    recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($h0PUv))).encode((0, $8dlmd.Buffer).from(recentBlockhash)),
                    accountKeys: accountKeys,
                    instructions: instructions
                };
                return new Message(messageArgs);
            }
        }
    ]);
    return Message;
}();
/**
 * Message constructor arguments
 */ var $47b9aa0c5fbd17c3$export$ee274c70e0fae590 = /*#__PURE__*/ function() {
    "use strict";
    function MessageV0(args) {
        (0, $4GJKx._)(this, MessageV0);
        this.header = void 0;
        this.staticAccountKeys = void 0;
        this.recentBlockhash = void 0;
        this.compiledInstructions = void 0;
        this.addressTableLookups = void 0;
        this.header = args.header;
        this.staticAccountKeys = args.staticAccountKeys;
        this.recentBlockhash = args.recentBlockhash;
        this.compiledInstructions = args.compiledInstructions;
        this.addressTableLookups = args.addressTableLookups;
    }
    (0, $1wc17._)(MessageV0, [
        {
            key: "version",
            get: function get() {
                return 0;
            }
        },
        {
            key: "numAccountKeysFromLookups",
            get: function get() {
                var count = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.addressTableLookups[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var lookup = _step.value;
                        count += lookup.readonlyIndexes.length + lookup.writableIndexes.length;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return count;
            }
        },
        {
            key: "getAccountKeys",
            value: function getAccountKeys(args) {
                var accountKeysFromLookups;
                if (args && "accountKeysFromLookups" in args && args.accountKeysFromLookups) {
                    if (this.numAccountKeysFromLookups != args.accountKeysFromLookups.writable.length + args.accountKeysFromLookups.readonly.length) throw new Error("Failed to get account keys because of a mismatch in the number of account keys from lookups");
                    accountKeysFromLookups = args.accountKeysFromLookups;
                } else if (args && "addressLookupTableAccounts" in args && args.addressLookupTableAccounts) accountKeysFromLookups = this.resolveAddressTableLookups(args.addressLookupTableAccounts);
                else if (this.addressTableLookups.length > 0) throw new Error("Failed to get account keys because address table lookups were not resolved");
                return new $47b9aa0c5fbd17c3$export$109914c107623102(this.staticAccountKeys, accountKeysFromLookups);
            }
        },
        {
            key: "isAccountSigner",
            value: function isAccountSigner(index) {
                return index < this.header.numRequiredSignatures;
            }
        },
        {
            key: "isAccountWritable",
            value: function isAccountWritable(index) {
                var numSignedAccounts = this.header.numRequiredSignatures;
                var numStaticAccountKeys = this.staticAccountKeys.length;
                if (index >= numStaticAccountKeys) {
                    var lookupAccountKeysIndex = index - numStaticAccountKeys;
                    var numWritableLookupAccountKeys = this.addressTableLookups.reduce(function(count, lookup) {
                        return count + lookup.writableIndexes.length;
                    }, 0);
                    return lookupAccountKeysIndex < numWritableLookupAccountKeys;
                } else if (index >= this.header.numRequiredSignatures) {
                    var unsignedAccountIndex = index - numSignedAccounts;
                    var numUnsignedAccounts = numStaticAccountKeys - numSignedAccounts;
                    var numWritableUnsignedAccounts = numUnsignedAccounts - this.header.numReadonlyUnsignedAccounts;
                    return unsignedAccountIndex < numWritableUnsignedAccounts;
                } else {
                    var numWritableSignedAccounts = numSignedAccounts - this.header.numReadonlySignedAccounts;
                    return index < numWritableSignedAccounts;
                }
            }
        },
        {
            key: "resolveAddressTableLookups",
            value: function resolveAddressTableLookups(addressLookupTableAccounts) {
                var accountKeysFromLookups = {
                    writable: [],
                    readonly: []
                };
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _loop = function() {
                        var tableLookup = _step.value;
                        var tableAccount = addressLookupTableAccounts.find(function(account) {
                            return account.key.equals(tableLookup.accountKey);
                        });
                        if (!tableAccount) throw new Error("Failed to find address lookup table account for table key ".concat(tableLookup.accountKey.toBase58()));
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = tableLookup.writableIndexes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var index = _step1.value;
                                if (index < tableAccount.state.addresses.length) accountKeysFromLookups.writable.push(tableAccount.state.addresses[index]);
                                else throw new Error("Failed to find address for index ".concat(index, " in address lookup table ").concat(tableLookup.accountKey.toBase58()));
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = tableLookup.readonlyIndexes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion1 = (_step2 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var index1 = _step2.value;
                                if (index1 < tableAccount.state.addresses.length) accountKeysFromLookups.readonly.push(tableAccount.state.addresses[index1]);
                                else throw new Error("Failed to find address for index ".concat(index1, " in address lookup table ").concat(tableLookup.accountKey.toBase58()));
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    };
                    for(var _iterator = this.addressTableLookups[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return accountKeysFromLookups;
            }
        },
        {
            key: "serialize",
            value: function serialize() {
                var encodedStaticAccountKeysLength = Array();
                $47b9aa0c5fbd17c3$var$encodeLength(encodedStaticAccountKeysLength, this.staticAccountKeys.length);
                var serializedInstructions = this.serializeInstructions();
                var encodedInstructionsLength = Array();
                $47b9aa0c5fbd17c3$var$encodeLength(encodedInstructionsLength, this.compiledInstructions.length);
                var serializedAddressTableLookups = this.serializeAddressTableLookups();
                var encodedAddressTableLookupsLength = Array();
                $47b9aa0c5fbd17c3$var$encodeLength(encodedAddressTableLookupsLength, this.addressTableLookups.length);
                var messageLayout = $jt90m.struct([
                    $jt90m.u8("prefix"),
                    $jt90m.struct([
                        $jt90m.u8("numRequiredSignatures"),
                        $jt90m.u8("numReadonlySignedAccounts"),
                        $jt90m.u8("numReadonlyUnsignedAccounts")
                    ], "header"),
                    $jt90m.blob(encodedStaticAccountKeysLength.length, "staticAccountKeysLength"),
                    $jt90m.seq($47b9aa0c5fbd17c3$var$publicKey(), this.staticAccountKeys.length, "staticAccountKeys"),
                    $47b9aa0c5fbd17c3$var$publicKey("recentBlockhash"),
                    $jt90m.blob(encodedInstructionsLength.length, "instructionsLength"),
                    $jt90m.blob(serializedInstructions.length, "serializedInstructions"),
                    $jt90m.blob(encodedAddressTableLookupsLength.length, "addressTableLookupsLength"),
                    $jt90m.blob(serializedAddressTableLookups.length, "serializedAddressTableLookups")
                ]);
                var serializedMessage = new Uint8Array($47b9aa0c5fbd17c3$export$4c6d5b89e1596f26);
                var MESSAGE_VERSION_0_PREFIX = 128;
                var serializedMessageLength = messageLayout.encode({
                    prefix: MESSAGE_VERSION_0_PREFIX,
                    header: this.header,
                    staticAccountKeysLength: new Uint8Array(encodedStaticAccountKeysLength),
                    staticAccountKeys: this.staticAccountKeys.map(function(key) {
                        return key.toBytes();
                    }),
                    recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($h0PUv))).decode(this.recentBlockhash),
                    instructionsLength: new Uint8Array(encodedInstructionsLength),
                    serializedInstructions: serializedInstructions,
                    addressTableLookupsLength: new Uint8Array(encodedAddressTableLookupsLength),
                    serializedAddressTableLookups: serializedAddressTableLookups
                }, serializedMessage);
                return serializedMessage.slice(0, serializedMessageLength);
            }
        },
        {
            key: "serializeInstructions",
            value: function serializeInstructions() {
                var serializedLength = 0;
                var serializedInstructions = new Uint8Array($47b9aa0c5fbd17c3$export$4c6d5b89e1596f26);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.compiledInstructions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var instruction = _step.value;
                        var encodedAccountKeyIndexesLength = Array();
                        $47b9aa0c5fbd17c3$var$encodeLength(encodedAccountKeyIndexesLength, instruction.accountKeyIndexes.length);
                        var encodedDataLength = Array();
                        $47b9aa0c5fbd17c3$var$encodeLength(encodedDataLength, instruction.data.length);
                        var instructionLayout = $jt90m.struct([
                            $jt90m.u8("programIdIndex"),
                            $jt90m.blob(encodedAccountKeyIndexesLength.length, "encodedAccountKeyIndexesLength"),
                            $jt90m.seq($jt90m.u8(), instruction.accountKeyIndexes.length, "accountKeyIndexes"),
                            $jt90m.blob(encodedDataLength.length, "encodedDataLength"),
                            $jt90m.blob(instruction.data.length, "data")
                        ]);
                        serializedLength += instructionLayout.encode({
                            programIdIndex: instruction.programIdIndex,
                            encodedAccountKeyIndexesLength: new Uint8Array(encodedAccountKeyIndexesLength),
                            accountKeyIndexes: instruction.accountKeyIndexes,
                            encodedDataLength: new Uint8Array(encodedDataLength),
                            data: instruction.data
                        }, serializedInstructions, serializedLength);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return serializedInstructions.slice(0, serializedLength);
            }
        },
        {
            key: "serializeAddressTableLookups",
            value: function serializeAddressTableLookups() {
                var serializedLength = 0;
                var serializedAddressTableLookups = new Uint8Array($47b9aa0c5fbd17c3$export$4c6d5b89e1596f26);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.addressTableLookups[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var lookup = _step.value;
                        var encodedWritableIndexesLength = Array();
                        $47b9aa0c5fbd17c3$var$encodeLength(encodedWritableIndexesLength, lookup.writableIndexes.length);
                        var encodedReadonlyIndexesLength = Array();
                        $47b9aa0c5fbd17c3$var$encodeLength(encodedReadonlyIndexesLength, lookup.readonlyIndexes.length);
                        var addressTableLookupLayout = $jt90m.struct([
                            $47b9aa0c5fbd17c3$var$publicKey("accountKey"),
                            $jt90m.blob(encodedWritableIndexesLength.length, "encodedWritableIndexesLength"),
                            $jt90m.seq($jt90m.u8(), lookup.writableIndexes.length, "writableIndexes"),
                            $jt90m.blob(encodedReadonlyIndexesLength.length, "encodedReadonlyIndexesLength"),
                            $jt90m.seq($jt90m.u8(), lookup.readonlyIndexes.length, "readonlyIndexes")
                        ]);
                        serializedLength += addressTableLookupLayout.encode({
                            accountKey: lookup.accountKey.toBytes(),
                            encodedWritableIndexesLength: new Uint8Array(encodedWritableIndexesLength),
                            writableIndexes: lookup.writableIndexes,
                            encodedReadonlyIndexesLength: new Uint8Array(encodedReadonlyIndexesLength),
                            readonlyIndexes: lookup.readonlyIndexes
                        }, serializedAddressTableLookups, serializedLength);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return serializedAddressTableLookups.slice(0, serializedLength);
            }
        }
    ], [
        {
            key: "compile",
            value: function compile(args) {
                var compiledKeys = $47b9aa0c5fbd17c3$var$CompiledKeys.compile(args.instructions, args.payerKey);
                var addressTableLookups = new Array();
                var accountKeysFromLookups = {
                    writable: new Array(),
                    readonly: new Array()
                };
                var lookupTableAccounts = args.addressLookupTableAccounts || [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = lookupTableAccounts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var lookupTable = _step.value;
                        var extractResult = compiledKeys.extractTableLookup(lookupTable);
                        if (extractResult !== undefined) {
                            var _accountKeysFromLookups_writable, _accountKeysFromLookups_readonly;
                            var _extractResult = (0, $cv9Rk._)(extractResult, 2), addressTableLookup = _extractResult[0], _extractResult_ = _extractResult[1], writable = _extractResult_.writable, readonly = _extractResult_.readonly;
                            addressTableLookups.push(addressTableLookup);
                            (_accountKeysFromLookups_writable = accountKeysFromLookups.writable).push.apply(_accountKeysFromLookups_writable, (0, $c6Xmf._)(writable));
                            (_accountKeysFromLookups_readonly = accountKeysFromLookups.readonly).push.apply(_accountKeysFromLookups_readonly, (0, $c6Xmf._)(readonly));
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _compiledKeys_getMessageComponents = (0, $cv9Rk._)(compiledKeys.getMessageComponents(), 2), header = _compiledKeys_getMessageComponents[0], staticAccountKeys = _compiledKeys_getMessageComponents[1];
                var accountKeys = new $47b9aa0c5fbd17c3$export$109914c107623102(staticAccountKeys, accountKeysFromLookups);
                var compiledInstructions = accountKeys.compileInstructions(args.instructions);
                return new MessageV0({
                    header: header,
                    staticAccountKeys: staticAccountKeys,
                    recentBlockhash: args.recentBlockhash,
                    compiledInstructions: compiledInstructions,
                    addressTableLookups: addressTableLookups
                });
            }
        },
        {
            key: "deserialize",
            value: function deserialize(serializedMessage) {
                var byteArray = (0, $c6Xmf._)(serializedMessage);
                var prefix = $47b9aa0c5fbd17c3$var$guardedShift(byteArray);
                var maskedPrefix = prefix & $47b9aa0c5fbd17c3$export$3c3793d809f8b858;
                $47b9aa0c5fbd17c3$var$assert(prefix !== maskedPrefix, "Expected versioned message but received legacy message");
                var version = maskedPrefix;
                $47b9aa0c5fbd17c3$var$assert(version === 0, "Expected versioned message with version 0 but found version ".concat(version));
                var header = {
                    numRequiredSignatures: $47b9aa0c5fbd17c3$var$guardedShift(byteArray),
                    numReadonlySignedAccounts: $47b9aa0c5fbd17c3$var$guardedShift(byteArray),
                    numReadonlyUnsignedAccounts: $47b9aa0c5fbd17c3$var$guardedShift(byteArray)
                };
                var staticAccountKeys = [];
                var staticAccountKeysLength = $47b9aa0c5fbd17c3$var$decodeLength(byteArray);
                for(var i = 0; i < staticAccountKeysLength; i++)staticAccountKeys.push(new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de($47b9aa0c5fbd17c3$var$guardedSplice(byteArray, 0, $47b9aa0c5fbd17c3$export$84fc0a248cc54343)));
                var recentBlockhash = (0, (/*@__PURE__*/$parcel$interopDefault($h0PUv))).encode($47b9aa0c5fbd17c3$var$guardedSplice(byteArray, 0, $47b9aa0c5fbd17c3$export$84fc0a248cc54343));
                var instructionCount = $47b9aa0c5fbd17c3$var$decodeLength(byteArray);
                var compiledInstructions = [];
                for(var i1 = 0; i1 < instructionCount; i1++){
                    var programIdIndex = $47b9aa0c5fbd17c3$var$guardedShift(byteArray);
                    var accountKeyIndexesLength = $47b9aa0c5fbd17c3$var$decodeLength(byteArray);
                    var accountKeyIndexes = $47b9aa0c5fbd17c3$var$guardedSplice(byteArray, 0, accountKeyIndexesLength);
                    var dataLength = $47b9aa0c5fbd17c3$var$decodeLength(byteArray);
                    var data = new Uint8Array($47b9aa0c5fbd17c3$var$guardedSplice(byteArray, 0, dataLength));
                    compiledInstructions.push({
                        programIdIndex: programIdIndex,
                        accountKeyIndexes: accountKeyIndexes,
                        data: data
                    });
                }
                var addressTableLookupsCount = $47b9aa0c5fbd17c3$var$decodeLength(byteArray);
                var addressTableLookups = [];
                for(var i2 = 0; i2 < addressTableLookupsCount; i2++){
                    var accountKey = new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de($47b9aa0c5fbd17c3$var$guardedSplice(byteArray, 0, $47b9aa0c5fbd17c3$export$84fc0a248cc54343));
                    var writableIndexesLength = $47b9aa0c5fbd17c3$var$decodeLength(byteArray);
                    var writableIndexes = $47b9aa0c5fbd17c3$var$guardedSplice(byteArray, 0, writableIndexesLength);
                    var readonlyIndexesLength = $47b9aa0c5fbd17c3$var$decodeLength(byteArray);
                    var readonlyIndexes = $47b9aa0c5fbd17c3$var$guardedSplice(byteArray, 0, readonlyIndexesLength);
                    addressTableLookups.push({
                        accountKey: accountKey,
                        writableIndexes: writableIndexes,
                        readonlyIndexes: readonlyIndexes
                    });
                }
                return new MessageV0({
                    header: header,
                    staticAccountKeys: staticAccountKeys,
                    recentBlockhash: recentBlockhash,
                    compiledInstructions: compiledInstructions,
                    addressTableLookups: addressTableLookups
                });
            }
        }
    ]);
    return MessageV0;
}();
// eslint-disable-next-line no-redeclare
var $47b9aa0c5fbd17c3$export$b0a61927d00ede7f = {
    deserializeMessageVersion: function(serializedMessage) {
        var prefix = serializedMessage[0];
        var maskedPrefix = prefix & $47b9aa0c5fbd17c3$export$3c3793d809f8b858;
        // if the highest bit of the prefix is not set, the message is not versioned
        if (maskedPrefix === prefix) return "legacy";
        // the lower 7 bits of the prefix indicate the message version
        return maskedPrefix;
    },
    deserialize: function(serializedMessage) {
        var version = $47b9aa0c5fbd17c3$export$b0a61927d00ede7f.deserializeMessageVersion(serializedMessage);
        if (version === "legacy") return $47b9aa0c5fbd17c3$export$f69c19e57285b83a.from(serializedMessage);
        if (version === 0) return $47b9aa0c5fbd17c3$export$ee274c70e0fae590.deserialize(serializedMessage);
        else throw new Error("Transaction message version ".concat(version, " deserialization is not supported"));
    }
};
/** @internal */ /**
 * Transaction signature as base-58 encoded string
 */ var $47b9aa0c5fbd17c3$export$7c391bd3b61d2374 = /*#__PURE__*/ function(TransactionStatus) {
    TransactionStatus[TransactionStatus["BLOCKHEIGHT_EXCEEDED"] = 0] = "BLOCKHEIGHT_EXCEEDED";
    TransactionStatus[TransactionStatus["PROCESSED"] = 1] = "PROCESSED";
    TransactionStatus[TransactionStatus["TIMED_OUT"] = 2] = "TIMED_OUT";
    TransactionStatus[TransactionStatus["NONCE_INVALID"] = 3] = "NONCE_INVALID";
    return TransactionStatus;
}({});
/**
 * Default (empty) signature
 */ var $47b9aa0c5fbd17c3$var$DEFAULT_SIGNATURE = (0, $8dlmd.Buffer).alloc($47b9aa0c5fbd17c3$export$14aee086fde78fa6).fill(0);
/**
 * Account metadata used to define instructions
 */ /**
 * List of TransactionInstruction object fields that may be initialized at construction
 */ /**
 * Configuration object for Transaction.serialize()
 */ /**
 * @internal
 */ /**
 * Transaction Instruction class
 */ var $47b9aa0c5fbd17c3$export$a7a3aa8360ac9f59 = /*#__PURE__*/ function() {
    "use strict";
    function TransactionInstruction(opts) {
        (0, $4GJKx._)(this, TransactionInstruction);
        /**
     * Public keys to include in this transaction
     * Boolean represents whether this pubkey needs to sign the transaction
     */ this.keys = void 0;
        /**
     * Program Id to execute
     */ this.programId = void 0;
        /**
     * Program input
     */ this.data = (0, $8dlmd.Buffer).alloc(0);
        this.programId = opts.programId;
        this.keys = opts.keys;
        if (opts.data) this.data = opts.data;
    }
    (0, $1wc17._)(TransactionInstruction, [
        {
            /**
   * @internal
   */ key: "toJSON",
            value: function toJSON() {
                return {
                    keys: this.keys.map(function(param) {
                        var pubkey = param.pubkey, isSigner = param.isSigner, isWritable = param.isWritable;
                        return {
                            pubkey: pubkey.toJSON(),
                            isSigner: isSigner,
                            isWritable: isWritable
                        };
                    }),
                    programId: this.programId.toJSON(),
                    data: (0, $c6Xmf._)(this.data)
                };
            }
        }
    ]);
    return TransactionInstruction;
}();
/**
 * Pair of signature and corresponding public key
 */ /**
 * List of Transaction object fields that may be initialized at construction
 */ // For backward compatibility; an unfortunate consequence of being
// forced to over-export types by the documentation generator.
// See https://github.com/solana-labs/solana/pull/25820
/**
 * Blockhash-based transactions have a lifetime that are defined by
 * the blockhash they include. Any transaction whose blockhash is
 * too old will be rejected.
 */ /**
 * Use these options to construct a durable nonce transaction.
 */ /**
 * Nonce information to be used to build an offline Transaction.
 */ /**
 * @internal
 */ /**
 * Transaction class
 */ var $47b9aa0c5fbd17c3$export$febc5573c75cefb0 = /*#__PURE__*/ function() {
    "use strict";
    function Transaction(opts) {
        (0, $4GJKx._)(this, Transaction);
        /**
     * Signatures for the transaction.  Typically created by invoking the
     * `sign()` method
     */ this.signatures = [];
        this.feePayer = void 0;
        /**
     * The instructions to atomically execute
     */ this.instructions = [];
        /**
     * A recent transaction id. Must be populated by the caller
     */ this.recentBlockhash = void 0;
        /**
     * the last block chain can advance to before tx is declared expired
     * */ this.lastValidBlockHeight = void 0;
        /**
     * Optional Nonce information. If populated, transaction will use a durable
     * Nonce hash instead of a recentBlockhash. Must be populated by the caller
     */ this.nonceInfo = void 0;
        /**
     * If this is a nonce transaction this represents the minimum slot from which
     * to evaluate if the nonce has advanced when attempting to confirm the
     * transaction. This protects against a case where the transaction confirmation
     * logic loads the nonce account from an old slot and assumes the mismatch in
     * nonce value implies that the nonce has been advanced.
     */ this.minNonceContextSlot = void 0;
        /**
     * @internal
     */ this._message = void 0;
        /**
     * @internal
     */ this._json = void 0;
        if (!opts) return;
        if (opts.feePayer) this.feePayer = opts.feePayer;
        if (opts.signatures) this.signatures = opts.signatures;
        if (Object.prototype.hasOwnProperty.call(opts, "nonceInfo")) {
            var minContextSlot = opts.minContextSlot, nonceInfo = opts.nonceInfo;
            this.minNonceContextSlot = minContextSlot;
            this.nonceInfo = nonceInfo;
        } else if (Object.prototype.hasOwnProperty.call(opts, "lastValidBlockHeight")) {
            var blockhash = opts.blockhash, lastValidBlockHeight = opts.lastValidBlockHeight;
            this.recentBlockhash = blockhash;
            this.lastValidBlockHeight = lastValidBlockHeight;
        } else {
            var recentBlockhash = opts.recentBlockhash, nonceInfo1 = opts.nonceInfo;
            if (nonceInfo1) this.nonceInfo = nonceInfo1;
            this.recentBlockhash = recentBlockhash;
        }
    }
    (0, $1wc17._)(Transaction, [
        {
            key: "signature",
            get: /**
   * The first (payer) Transaction signature
   *
   * @returns {Buffer | null} Buffer of payer's signature
   */ function get() {
                if (this.signatures.length > 0) return this.signatures[0].signature;
                return null;
            }
        },
        {
            /**
   * @internal
   */ key: "toJSON",
            value: function toJSON() {
                return {
                    recentBlockhash: this.recentBlockhash || null,
                    feePayer: this.feePayer ? this.feePayer.toJSON() : null,
                    nonceInfo: this.nonceInfo ? {
                        nonce: this.nonceInfo.nonce,
                        nonceInstruction: this.nonceInfo.nonceInstruction.toJSON()
                    } : null,
                    instructions: this.instructions.map(function(instruction) {
                        return instruction.toJSON();
                    }),
                    signers: this.signatures.map(function(param) {
                        var publicKey = param.publicKey;
                        return publicKey.toJSON();
                    })
                };
            }
        },
        {
            /**
   * Add one or more instructions to this Transaction
   *
   * @param {Array< Transaction | TransactionInstruction | TransactionInstructionCtorFields >} items - Instructions to add to the Transaction
   */ key: "add",
            value: function add() {
                var _this = this;
                for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
                    items[_key] = arguments[_key];
                }
                if (items.length === 0) throw new Error("No instructions");
                items.forEach(function(item) {
                    if ("instructions" in item) _this.instructions = _this.instructions.concat(item.instructions);
                    else if ("data" in item && "programId" in item && "keys" in item) _this.instructions.push(item);
                    else _this.instructions.push(new $47b9aa0c5fbd17c3$export$a7a3aa8360ac9f59(item));
                });
                return this;
            }
        },
        {
            /**
   * Compile transaction data
   */ key: "compileMessage",
            value: function compileMessage() {
                if (this._message && JSON.stringify(this.toJSON()) === JSON.stringify(this._json)) return this._message;
                var recentBlockhash;
                var instructions;
                if (this.nonceInfo) {
                    recentBlockhash = this.nonceInfo.nonce;
                    if (this.instructions[0] != this.nonceInfo.nonceInstruction) instructions = [
                        this.nonceInfo.nonceInstruction
                    ].concat((0, $c6Xmf._)(this.instructions));
                    else instructions = this.instructions;
                } else {
                    recentBlockhash = this.recentBlockhash;
                    instructions = this.instructions;
                }
                if (!recentBlockhash) throw new Error("Transaction recentBlockhash required");
                if (instructions.length < 1) console.warn("No instructions provided");
                var feePayer;
                if (this.feePayer) feePayer = this.feePayer;
                else if (this.signatures.length > 0 && this.signatures[0].publicKey) // Use implicit fee payer
                feePayer = this.signatures[0].publicKey;
                else throw new Error("Transaction fee payer required");
                for(var i = 0; i < instructions.length; i++){
                    if (instructions[i].programId === undefined) throw new Error("Transaction instruction index ".concat(i, " has undefined program id"));
                }
                var programIds = [];
                var accountMetas = [];
                instructions.forEach(function(instruction) {
                    instruction.keys.forEach(function(accountMeta) {
                        accountMetas.push((0, $do9pw._)({}, accountMeta));
                    });
                    var programId = instruction.programId.toString();
                    if (!programIds.includes(programId)) programIds.push(programId);
                });
                // Append programID account metas
                programIds.forEach(function(programId) {
                    accountMetas.push({
                        pubkey: new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(programId),
                        isSigner: false,
                        isWritable: false
                    });
                });
                // Cull duplicate account metas
                var uniqueMetas = [];
                accountMetas.forEach(function(accountMeta) {
                    var pubkeyString = accountMeta.pubkey.toString();
                    var uniqueIndex = uniqueMetas.findIndex(function(x) {
                        return x.pubkey.toString() === pubkeyString;
                    });
                    if (uniqueIndex > -1) {
                        uniqueMetas[uniqueIndex].isWritable = uniqueMetas[uniqueIndex].isWritable || accountMeta.isWritable;
                        uniqueMetas[uniqueIndex].isSigner = uniqueMetas[uniqueIndex].isSigner || accountMeta.isSigner;
                    } else uniqueMetas.push(accountMeta);
                });
                // Sort. Prioritizing first by signer, then by writable
                uniqueMetas.sort(function(x, y) {
                    if (x.isSigner !== y.isSigner) // Signers always come before non-signers
                    return x.isSigner ? -1 : 1;
                    if (x.isWritable !== y.isWritable) // Writable accounts always come before read-only accounts
                    return x.isWritable ? -1 : 1;
                    // Otherwise, sort by pubkey, stringwise.
                    var options = {
                        localeMatcher: "best fit",
                        usage: "sort",
                        sensitivity: "variant",
                        ignorePunctuation: false,
                        numeric: false,
                        caseFirst: "lower"
                    };
                    return x.pubkey.toBase58().localeCompare(y.pubkey.toBase58(), "en", options);
                });
                // Move fee payer to the front
                var feePayerIndex = uniqueMetas.findIndex(function(x) {
                    return x.pubkey.equals(feePayer);
                });
                if (feePayerIndex > -1) {
                    var _uniqueMetas_splice = (0, $cv9Rk._)(uniqueMetas.splice(feePayerIndex, 1), 1), payerMeta = _uniqueMetas_splice[0];
                    payerMeta.isSigner = true;
                    payerMeta.isWritable = true;
                    uniqueMetas.unshift(payerMeta);
                } else uniqueMetas.unshift({
                    pubkey: feePayer,
                    isSigner: true,
                    isWritable: true
                });
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _loop = function() {
                        var signature = _step.value;
                        var uniqueIndex = uniqueMetas.findIndex(function(x) {
                            return x.pubkey.equals(signature.publicKey);
                        });
                        if (uniqueIndex > -1) {
                            if (!uniqueMetas[uniqueIndex].isSigner) {
                                uniqueMetas[uniqueIndex].isSigner = true;
                                console.warn("Transaction references a signature that is unnecessary, only the fee payer and instruction signer accounts should sign a transaction. This behavior is deprecated and will throw an error in the next major version release.");
                            }
                        } else throw new Error("unknown signer: ".concat(signature.publicKey.toString()));
                    };
                    // Disallow unknown signers
                    for(var _iterator = this.signatures[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var numRequiredSignatures = 0;
                var numReadonlySignedAccounts = 0;
                var numReadonlyUnsignedAccounts = 0;
                // Split out signing from non-signing keys and count header values
                var signedKeys = [];
                var unsignedKeys = [];
                uniqueMetas.forEach(function(param) {
                    var pubkey = param.pubkey, isSigner = param.isSigner, isWritable = param.isWritable;
                    if (isSigner) {
                        signedKeys.push(pubkey.toString());
                        numRequiredSignatures += 1;
                        if (!isWritable) numReadonlySignedAccounts += 1;
                    } else {
                        unsignedKeys.push(pubkey.toString());
                        if (!isWritable) numReadonlyUnsignedAccounts += 1;
                    }
                });
                var accountKeys = signedKeys.concat(unsignedKeys);
                var compiledInstructions = instructions.map(function(instruction) {
                    var data = instruction.data, programId = instruction.programId;
                    return {
                        programIdIndex: accountKeys.indexOf(programId.toString()),
                        accounts: instruction.keys.map(function(meta) {
                            return accountKeys.indexOf(meta.pubkey.toString());
                        }),
                        data: (0, (/*@__PURE__*/$parcel$interopDefault($h0PUv))).encode(data)
                    };
                });
                compiledInstructions.forEach(function(instruction) {
                    $47b9aa0c5fbd17c3$var$assert(instruction.programIdIndex >= 0);
                    instruction.accounts.forEach(function(keyIndex) {
                        return $47b9aa0c5fbd17c3$var$assert(keyIndex >= 0);
                    });
                });
                return new $47b9aa0c5fbd17c3$export$f69c19e57285b83a({
                    header: {
                        numRequiredSignatures: numRequiredSignatures,
                        numReadonlySignedAccounts: numReadonlySignedAccounts,
                        numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts
                    },
                    accountKeys: accountKeys,
                    recentBlockhash: recentBlockhash,
                    instructions: compiledInstructions
                });
            }
        },
        {
            /**
   * @internal
   */ key: "_compile",
            value: function _compile() {
                var message = this.compileMessage();
                var signedKeys = message.accountKeys.slice(0, message.header.numRequiredSignatures);
                if (this.signatures.length === signedKeys.length) {
                    var valid = this.signatures.every(function(pair, index) {
                        return signedKeys[index].equals(pair.publicKey);
                    });
                    if (valid) return message;
                }
                this.signatures = signedKeys.map(function(publicKey) {
                    return {
                        signature: null,
                        publicKey: publicKey
                    };
                });
                return message;
            }
        },
        {
            /**
   * Get a buffer of the Transaction data that need to be covered by signatures
   */ key: "serializeMessage",
            value: function serializeMessage() {
                return this._compile().serialize();
            }
        },
        {
            key: "getEstimatedFee",
            value: /**
   * Get the estimated fee associated with a transaction
   *
   * @param {Connection} connection Connection to RPC Endpoint.
   *
   * @returns {Promise<number | null>} The estimated fee for the transaction
   */ function getEstimatedFee(connection) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    connection.getFeeForMessage(_this.compileMessage())
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent().value
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
   * Specify the public keys which will be used to sign the Transaction.
   * The first signer will be used as the transaction fee payer account.
   *
   * Signatures can be added with either `partialSign` or `addSignature`
   *
   * @deprecated Deprecated since v0.84.0. Only the fee payer needs to be
   * specified and it can be set in the Transaction constructor or with the
   * `feePayer` property.
   */ key: "setSigners",
            value: function setSigners() {
                for(var _len = arguments.length, signers = new Array(_len), _key = 0; _key < _len; _key++){
                    signers[_key] = arguments[_key];
                }
                if (signers.length === 0) throw new Error("No signers");
                var seen = new Set();
                this.signatures = signers.filter(function(publicKey) {
                    var key = publicKey.toString();
                    if (seen.has(key)) return false;
                    else {
                        seen.add(key);
                        return true;
                    }
                }).map(function(publicKey) {
                    return {
                        signature: null,
                        publicKey: publicKey
                    };
                });
            }
        },
        {
            /**
   * Sign the Transaction with the specified signers. Multiple signatures may
   * be applied to a Transaction. The first signature is considered "primary"
   * and is used identify and confirm transactions.
   *
   * If the Transaction `feePayer` is not set, the first signer will be used
   * as the transaction fee payer account.
   *
   * Transaction fields should not be modified after the first call to `sign`,
   * as doing so may invalidate the signature and cause the Transaction to be
   * rejected.
   *
   * The Transaction must be assigned a valid `recentBlockhash` before invoking this method
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */ key: "sign",
            value: function sign() {
                for(var _len = arguments.length, signers = new Array(_len), _key = 0; _key < _len; _key++){
                    signers[_key] = arguments[_key];
                }
                if (signers.length === 0) throw new Error("No signers");
                // Dedupe signers
                var seen = new Set();
                var uniqueSigners = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = signers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var signer = _step.value;
                        var key = signer.publicKey.toString();
                        if (seen.has(key)) continue;
                        else {
                            seen.add(key);
                            uniqueSigners.push(signer);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.signatures = uniqueSigners.map(function(signer) {
                    return {
                        signature: null,
                        publicKey: signer.publicKey
                    };
                });
                var message = this._compile();
                this._partialSign.apply(this, [
                    message
                ].concat((0, $c6Xmf._)(uniqueSigners)));
            }
        },
        {
            /**
   * Partially sign a transaction with the specified accounts. All accounts must
   * correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * All the caveats from the `sign` method apply to `partialSign`
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */ key: "partialSign",
            value: function partialSign() {
                for(var _len = arguments.length, signers = new Array(_len), _key = 0; _key < _len; _key++){
                    signers[_key] = arguments[_key];
                }
                if (signers.length === 0) throw new Error("No signers");
                // Dedupe signers
                var seen = new Set();
                var uniqueSigners = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = signers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var signer = _step.value;
                        var key = signer.publicKey.toString();
                        if (seen.has(key)) continue;
                        else {
                            seen.add(key);
                            uniqueSigners.push(signer);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var message = this._compile();
                this._partialSign.apply(this, [
                    message
                ].concat((0, $c6Xmf._)(uniqueSigners)));
            }
        },
        {
            /**
   * @internal
   */ key: "_partialSign",
            value: function _partialSign(message) {
                var _this = this;
                for(var _len = arguments.length, signers = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    signers[_key - 1] = arguments[_key];
                }
                var signData = message.serialize();
                signers.forEach(function(signer) {
                    var signature = $47b9aa0c5fbd17c3$var$sign(signData, signer.secretKey);
                    _this._addSignature(signer.publicKey, $47b9aa0c5fbd17c3$var$toBuffer(signature));
                });
            }
        },
        {
            /**
   * Add an externally created signature to a transaction. The public key
   * must correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * @param {PublicKey} pubkey Public key that will be added to the transaction.
   * @param {Buffer} signature An externally created signature to add to the transaction.
   */ key: "addSignature",
            value: function addSignature(pubkey, signature) {
                this._compile(); // Ensure signatures array is populated
                this._addSignature(pubkey, signature);
            }
        },
        {
            /**
   * @internal
   */ key: "_addSignature",
            value: function _addSignature(pubkey, signature) {
                $47b9aa0c5fbd17c3$var$assert(signature.length === 64);
                var index = this.signatures.findIndex(function(sigpair) {
                    return pubkey.equals(sigpair.publicKey);
                });
                if (index < 0) throw new Error("unknown signer: ".concat(pubkey.toString()));
                this.signatures[index].signature = (0, $8dlmd.Buffer).from(signature);
            }
        },
        {
            /**
   * Verify signatures of a Transaction
   * Optional parameter specifies if we're expecting a fully signed Transaction or a partially signed one.
   * If no boolean is provided, we expect a fully signed Transaction by default.
   *
   * @param {boolean} [requireAllSignatures=true] Require a fully signed Transaction
   */ key: "verifySignatures",
            value: function verifySignatures() {
                var requireAllSignatures = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                var signatureErrors = this._getMessageSignednessErrors(this.serializeMessage(), requireAllSignatures);
                return !signatureErrors;
            }
        },
        {
            /**
   * @internal
   */ key: "_getMessageSignednessErrors",
            value: function _getMessageSignednessErrors(message, requireAllSignatures) {
                var errors = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.signatures[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = _step.value, signature = _step_value.signature, publicKey = _step_value.publicKey;
                        var _errors, _errors1;
                        if (signature === null) {
                            if (requireAllSignatures) ((_errors = errors).missing || (_errors.missing = [])).push(publicKey);
                        } else if (!$47b9aa0c5fbd17c3$var$verify(signature, message, publicKey.toBytes())) ((_errors1 = errors).invalid || (_errors1.invalid = [])).push(publicKey);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return errors.invalid || errors.missing ? errors : undefined;
            }
        },
        {
            /**
   * Serialize the Transaction in the wire format.
   *
   * @param {Buffer} [config] Config of transaction.
   *
   * @returns {Buffer} Signature of transaction in wire format.
   */ key: "serialize",
            value: function serialize(config) {
                var _Object_assign = Object.assign({
                    requireAllSignatures: true,
                    verifySignatures: true
                }, config), requireAllSignatures = _Object_assign.requireAllSignatures, verifySignatures = _Object_assign.verifySignatures;
                var signData = this.serializeMessage();
                if (verifySignatures) {
                    var sigErrors = this._getMessageSignednessErrors(signData, requireAllSignatures);
                    if (sigErrors) {
                        var errorMessage = "Signature verification failed.";
                        if (sigErrors.invalid) errorMessage += "\nInvalid signature for public key".concat(sigErrors.invalid.length === 1 ? "" : "(s)", " [`").concat(sigErrors.invalid.map(function(p) {
                            return p.toBase58();
                        }).join("`, `"), "`].");
                        if (sigErrors.missing) errorMessage += "\nMissing signature for public key".concat(sigErrors.missing.length === 1 ? "" : "(s)", " [`").concat(sigErrors.missing.map(function(p) {
                            return p.toBase58();
                        }).join("`, `"), "`].");
                        throw new Error(errorMessage);
                    }
                }
                return this._serialize(signData);
            }
        },
        {
            /**
   * @internal
   */ key: "_serialize",
            value: function _serialize(signData) {
                var signatures = this.signatures;
                var signatureCount = [];
                $47b9aa0c5fbd17c3$var$encodeLength(signatureCount, signatures.length);
                var transactionLength = signatureCount.length + signatures.length * 64 + signData.length;
                var wireTransaction = (0, $8dlmd.Buffer).alloc(transactionLength);
                $47b9aa0c5fbd17c3$var$assert(signatures.length < 256);
                (0, $8dlmd.Buffer).from(signatureCount).copy(wireTransaction, 0);
                signatures.forEach(function(param, index) {
                    var signature = param.signature;
                    if (signature !== null) {
                        $47b9aa0c5fbd17c3$var$assert(signature.length === 64, "signature has invalid length");
                        (0, $8dlmd.Buffer).from(signature).copy(wireTransaction, signatureCount.length + index * 64);
                    }
                });
                signData.copy(wireTransaction, signatureCount.length + signatures.length * 64);
                $47b9aa0c5fbd17c3$var$assert(wireTransaction.length <= $47b9aa0c5fbd17c3$export$4c6d5b89e1596f26, "Transaction too large: ".concat(wireTransaction.length, " > ").concat($47b9aa0c5fbd17c3$export$4c6d5b89e1596f26));
                return wireTransaction;
            }
        },
        {
            key: "keys",
            get: /**
   * Deprecated method
   * @internal
   */ function get() {
                $47b9aa0c5fbd17c3$var$assert(this.instructions.length === 1);
                return this.instructions[0].keys.map(function(keyObj) {
                    return keyObj.pubkey;
                });
            }
        },
        {
            key: "programId",
            get: /**
   * Deprecated method
   * @internal
   */ function get() {
                $47b9aa0c5fbd17c3$var$assert(this.instructions.length === 1);
                return this.instructions[0].programId;
            }
        },
        {
            key: "data",
            get: /**
   * Deprecated method
   * @internal
   */ function get() {
                $47b9aa0c5fbd17c3$var$assert(this.instructions.length === 1);
                return this.instructions[0].data;
            }
        }
    ], [
        {
            key: "from",
            value: /**
   * Parse a wire transaction into a Transaction object.
   *
   * @param {Buffer | Uint8Array | Array<number>} buffer Signature of wire Transaction
   *
   * @returns {Transaction} Transaction associated with the signature
   */ function from(buffer) {
                // Slice up wire data
                var byteArray = (0, $c6Xmf._)(buffer);
                var signatureCount = $47b9aa0c5fbd17c3$var$decodeLength(byteArray);
                var signatures = [];
                for(var i = 0; i < signatureCount; i++){
                    var signature = $47b9aa0c5fbd17c3$var$guardedSplice(byteArray, 0, $47b9aa0c5fbd17c3$export$14aee086fde78fa6);
                    signatures.push((0, (/*@__PURE__*/$parcel$interopDefault($h0PUv))).encode((0, $8dlmd.Buffer).from(signature)));
                }
                return Transaction.populate($47b9aa0c5fbd17c3$export$f69c19e57285b83a.from(byteArray), signatures);
            }
        },
        {
            key: "populate",
            value: /**
   * Populate Transaction object from message and signatures
   *
   * @param {Message} message Message of transaction
   * @param {Array<string>} signatures List of signatures to assign to the transaction
   *
   * @returns {Transaction} The populated Transaction
   */ function populate(message) {
                var signatures = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
                var transaction = new Transaction();
                transaction.recentBlockhash = message.recentBlockhash;
                if (message.header.numRequiredSignatures > 0) transaction.feePayer = message.accountKeys[0];
                signatures.forEach(function(signature, index) {
                    var sigPubkeyPair = {
                        signature: signature == (0, (/*@__PURE__*/$parcel$interopDefault($h0PUv))).encode($47b9aa0c5fbd17c3$var$DEFAULT_SIGNATURE) ? null : (0, (/*@__PURE__*/$parcel$interopDefault($h0PUv))).decode(signature),
                        publicKey: message.accountKeys[index]
                    };
                    transaction.signatures.push(sigPubkeyPair);
                });
                message.instructions.forEach(function(instruction) {
                    var keys = instruction.accounts.map(function(account) {
                        var pubkey = message.accountKeys[account];
                        return {
                            pubkey: pubkey,
                            isSigner: transaction.signatures.some(function(keyObj) {
                                return keyObj.publicKey.toString() === pubkey.toString();
                            }) || message.isAccountSigner(account),
                            isWritable: message.isAccountWritable(account)
                        };
                    });
                    transaction.instructions.push(new $47b9aa0c5fbd17c3$export$a7a3aa8360ac9f59({
                        keys: keys,
                        programId: message.accountKeys[instruction.programIdIndex],
                        data: (0, (/*@__PURE__*/$parcel$interopDefault($h0PUv))).decode(instruction.data)
                    }));
                });
                transaction._message = message;
                transaction._json = transaction.toJSON();
                return transaction;
            }
        }
    ]);
    return Transaction;
}();
var $47b9aa0c5fbd17c3$export$eb15f3e001dd262d = /*#__PURE__*/ function() {
    "use strict";
    function TransactionMessage(args) {
        (0, $4GJKx._)(this, TransactionMessage);
        this.payerKey = void 0;
        this.instructions = void 0;
        this.recentBlockhash = void 0;
        this.payerKey = args.payerKey;
        this.instructions = args.instructions;
        this.recentBlockhash = args.recentBlockhash;
    }
    (0, $1wc17._)(TransactionMessage, [
        {
            key: "compileToLegacyMessage",
            value: function compileToLegacyMessage() {
                return $47b9aa0c5fbd17c3$export$f69c19e57285b83a.compile({
                    payerKey: this.payerKey,
                    recentBlockhash: this.recentBlockhash,
                    instructions: this.instructions
                });
            }
        },
        {
            key: "compileToV0Message",
            value: function compileToV0Message(addressLookupTableAccounts) {
                return $47b9aa0c5fbd17c3$export$ee274c70e0fae590.compile({
                    payerKey: this.payerKey,
                    recentBlockhash: this.recentBlockhash,
                    instructions: this.instructions,
                    addressLookupTableAccounts: addressLookupTableAccounts
                });
            }
        }
    ], [
        {
            key: "decompile",
            value: function decompile(message, args) {
                var header = message.header, compiledInstructions = message.compiledInstructions, recentBlockhash = message.recentBlockhash;
                var numRequiredSignatures = header.numRequiredSignatures, numReadonlySignedAccounts = header.numReadonlySignedAccounts, numReadonlyUnsignedAccounts = header.numReadonlyUnsignedAccounts;
                var numWritableSignedAccounts = numRequiredSignatures - numReadonlySignedAccounts;
                $47b9aa0c5fbd17c3$var$assert(numWritableSignedAccounts > 0, "Message header is invalid");
                var numWritableUnsignedAccounts = message.staticAccountKeys.length - numRequiredSignatures - numReadonlyUnsignedAccounts;
                $47b9aa0c5fbd17c3$var$assert(numWritableUnsignedAccounts >= 0, "Message header is invalid");
                var accountKeys = message.getAccountKeys(args);
                var payerKey = accountKeys.get(0);
                if (payerKey === undefined) throw new Error("Failed to decompile message because no account keys were found");
                var instructions = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = compiledInstructions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var compiledIx = _step.value;
                        var keys = [];
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = compiledIx.accountKeyIndexes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var keyIndex = _step1.value;
                                var pubkey = accountKeys.get(keyIndex);
                                if (pubkey === undefined) throw new Error("Failed to find key for account key index ".concat(keyIndex));
                                var isSigner = keyIndex < numRequiredSignatures;
                                var isWritable = void 0;
                                if (isSigner) isWritable = keyIndex < numWritableSignedAccounts;
                                else if (keyIndex < accountKeys.staticAccountKeys.length) isWritable = keyIndex - numRequiredSignatures < numWritableUnsignedAccounts;
                                else isWritable = keyIndex - accountKeys.staticAccountKeys.length < // accountKeysFromLookups cannot be undefined because we already found a pubkey for this index above
                                accountKeys.accountKeysFromLookups.writable.length;
                                keys.push({
                                    pubkey: pubkey,
                                    isSigner: keyIndex < header.numRequiredSignatures,
                                    isWritable: isWritable
                                });
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        var programId = accountKeys.get(compiledIx.programIdIndex);
                        if (programId === undefined) throw new Error("Failed to find program id for program id index ".concat(compiledIx.programIdIndex));
                        instructions.push(new $47b9aa0c5fbd17c3$export$a7a3aa8360ac9f59({
                            programId: programId,
                            data: $47b9aa0c5fbd17c3$var$toBuffer(compiledIx.data),
                            keys: keys
                        }));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return new TransactionMessage({
                    payerKey: payerKey,
                    instructions: instructions,
                    recentBlockhash: recentBlockhash
                });
            }
        }
    ]);
    return TransactionMessage;
}();
/**
 * Versioned transaction class
 */ var $47b9aa0c5fbd17c3$export$232cc3f078dcc284 = /*#__PURE__*/ function() {
    "use strict";
    function VersionedTransaction(message, signatures) {
        (0, $4GJKx._)(this, VersionedTransaction);
        this.signatures = void 0;
        this.message = void 0;
        if (signatures !== undefined) {
            $47b9aa0c5fbd17c3$var$assert(signatures.length === message.header.numRequiredSignatures, "Expected signatures length to be equal to the number of required signatures");
            this.signatures = signatures;
        } else {
            var defaultSignatures = [];
            for(var i = 0; i < message.header.numRequiredSignatures; i++)defaultSignatures.push(new Uint8Array($47b9aa0c5fbd17c3$export$14aee086fde78fa6));
            this.signatures = defaultSignatures;
        }
        this.message = message;
    }
    (0, $1wc17._)(VersionedTransaction, [
        {
            key: "version",
            get: function get() {
                return this.message.version;
            }
        },
        {
            key: "serialize",
            value: function serialize() {
                var serializedMessage = this.message.serialize();
                var encodedSignaturesLength = Array();
                $47b9aa0c5fbd17c3$var$encodeLength(encodedSignaturesLength, this.signatures.length);
                var transactionLayout = $jt90m.struct([
                    $jt90m.blob(encodedSignaturesLength.length, "encodedSignaturesLength"),
                    $jt90m.seq($47b9aa0c5fbd17c3$var$signature(), this.signatures.length, "signatures"),
                    $jt90m.blob(serializedMessage.length, "serializedMessage")
                ]);
                var serializedTransaction = new Uint8Array(2048);
                var serializedTransactionLength = transactionLayout.encode({
                    encodedSignaturesLength: new Uint8Array(encodedSignaturesLength),
                    signatures: this.signatures,
                    serializedMessage: serializedMessage
                }, serializedTransaction);
                return serializedTransaction.slice(0, serializedTransactionLength);
            }
        },
        {
            key: "sign",
            value: function sign1(signers) {
                var messageData = this.message.serialize();
                var signerPubkeys = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _this = this, _loop = function() {
                        var signer = _step.value;
                        var signerIndex = signerPubkeys.findIndex(function(pubkey) {
                            return pubkey.equals(signer.publicKey);
                        });
                        $47b9aa0c5fbd17c3$var$assert(signerIndex >= 0, "Cannot sign with non signer key ".concat(signer.publicKey.toBase58()));
                        _this.signatures[signerIndex] = $47b9aa0c5fbd17c3$var$sign(messageData, signer.secretKey);
                    };
                    for(var _iterator = signers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "addSignature",
            value: function addSignature(publicKey, signature) {
                $47b9aa0c5fbd17c3$var$assert(signature.byteLength === 64, "Signature must be 64 bytes long");
                var signerPubkeys = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
                var signerIndex = signerPubkeys.findIndex(function(pubkey) {
                    return pubkey.equals(publicKey);
                });
                $47b9aa0c5fbd17c3$var$assert(signerIndex >= 0, "Can not add signature; `".concat(publicKey.toBase58(), "` is not required to sign this transaction"));
                this.signatures[signerIndex] = signature;
            }
        }
    ], [
        {
            key: "deserialize",
            value: function deserialize(serializedTransaction) {
                var byteArray = (0, $c6Xmf._)(serializedTransaction);
                var signatures = [];
                var signaturesLength = $47b9aa0c5fbd17c3$var$decodeLength(byteArray);
                for(var i = 0; i < signaturesLength; i++)signatures.push(new Uint8Array($47b9aa0c5fbd17c3$var$guardedSplice(byteArray, 0, $47b9aa0c5fbd17c3$export$14aee086fde78fa6)));
                var message = $47b9aa0c5fbd17c3$export$b0a61927d00ede7f.deserialize(new Uint8Array(byteArray));
                return new VersionedTransaction(message, signatures);
            }
        }
    ]);
    return VersionedTransaction;
}();
// TODO: These constants should be removed in favor of reading them out of a
// Syscall account
/**
 * @internal
 */ var $47b9aa0c5fbd17c3$var$NUM_TICKS_PER_SECOND = 160;
/**
 * @internal
 */ var $47b9aa0c5fbd17c3$var$DEFAULT_TICKS_PER_SLOT = 64;
/**
 * @internal
 */ var $47b9aa0c5fbd17c3$var$NUM_SLOTS_PER_SECOND = $47b9aa0c5fbd17c3$var$NUM_TICKS_PER_SECOND / $47b9aa0c5fbd17c3$var$DEFAULT_TICKS_PER_SLOT;
/**
 * @internal
 */ var $47b9aa0c5fbd17c3$var$MS_PER_SLOT = 1000 / $47b9aa0c5fbd17c3$var$NUM_SLOTS_PER_SECOND;
var $47b9aa0c5fbd17c3$export$393aa1412d47050e = new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de("SysvarC1ock11111111111111111111111111111111");
var $47b9aa0c5fbd17c3$export$2b71d479444d2f4 = new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de("SysvarEpochSchedu1e111111111111111111111111");
var $47b9aa0c5fbd17c3$export$54419cc1a3ece8d6 = new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de("Sysvar1nstructions1111111111111111111111111");
var $47b9aa0c5fbd17c3$export$e74201139e9833db = new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de("SysvarRecentB1ockHashes11111111111111111111");
var $47b9aa0c5fbd17c3$export$970d0190cdb3a8e9 = new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de("SysvarRent111111111111111111111111111111111");
var $47b9aa0c5fbd17c3$export$da3b38d796bc1af1 = new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de("SysvarRewards111111111111111111111111111111");
var $47b9aa0c5fbd17c3$export$7b3a057916a4a7ae = new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de("SysvarS1otHashes111111111111111111111111111");
var $47b9aa0c5fbd17c3$export$3272815bf0633907 = new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de("SysvarS1otHistory11111111111111111111111111");
var $47b9aa0c5fbd17c3$export$ca994171317280ea = new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de("SysvarStakeHistory1111111111111111111111111");
var $47b9aa0c5fbd17c3$export$121e803f723b3045 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $dcsZi._)(SendTransactionError, Error1);
    var _super = (0, $ohfOJ._)(SendTransactionError);
    function SendTransactionError(param) {
        var action = param.action, signature = param.signature, transactionMessage = param.transactionMessage, logs = param.logs;
        (0, $4GJKx._)(this, SendTransactionError);
        var _this;
        var maybeLogsOutput = logs ? "Logs: \n".concat(JSON.stringify(logs.slice(-10), null, 2), ". ") : "";
        var guideText = "\nCatch the `SendTransactionError` and call `getLogs()` on it for full details.";
        var message;
        switch(action){
            case "send":
                message = "Transaction ".concat(signature, " resulted in an error. \n") + "".concat(transactionMessage, ". ") + maybeLogsOutput + guideText;
                break;
            case "simulate":
                message = "Simulation failed. \nMessage: ".concat(transactionMessage, ". \n") + maybeLogsOutput + guideText;
                break;
            default:
                message = "Unknown action '".concat(function(a) {
                    return a;
                }(action), "'");
        }
        _this = _super.call(this, message);
        _this.signature = void 0;
        _this.transactionMessage = void 0;
        _this.transactionLogs = void 0;
        _this.signature = signature;
        _this.transactionMessage = transactionMessage;
        _this.transactionLogs = logs ? logs : undefined;
        return _this;
    }
    (0, $1wc17._)(SendTransactionError, [
        {
            key: "transactionError",
            get: function get() {
                return {
                    message: this.transactionMessage,
                    logs: Array.isArray(this.transactionLogs) ? this.transactionLogs : undefined
                };
            }
        },
        {
            key: "logs",
            get: /* @deprecated Use `await getLogs()` instead */ function get() {
                var cachedLogs = this.transactionLogs;
                if (cachedLogs != null && typeof cachedLogs === "object" && "then" in cachedLogs) return undefined;
                return cachedLogs;
            }
        },
        {
            key: "getLogs",
            value: function getLogs(connection) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!Array.isArray(_this.transactionLogs)) _this.transactionLogs = new Promise(function(resolve, reject) {
                                    connection.getTransaction(_this.signature).then(function(tx) {
                                        if (tx && tx.meta && tx.meta.logMessages) {
                                            var logs = tx.meta.logMessages;
                                            _this.transactionLogs = logs;
                                            resolve(logs);
                                        } else reject(new Error("Log messages not found"));
                                    }).catch(reject);
                                });
                                return [
                                    4,
                                    _this.transactionLogs
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return SendTransactionError;
}((0, $FuVm8._)(Error));
// Keep in sync with client/src/rpc_custom_errors.rs
// Typescript `enums` thwart tree-shaking. See https://bargsten.org/jsts/enums/
var $47b9aa0c5fbd17c3$export$e5e9869922dd22f8 = {
    JSON_RPC_SERVER_ERROR_BLOCK_CLEANED_UP: -32001,
    JSON_RPC_SERVER_ERROR_SEND_TRANSACTION_PREFLIGHT_FAILURE: -32002,
    JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_VERIFICATION_FAILURE: -32003,
    JSON_RPC_SERVER_ERROR_BLOCK_NOT_AVAILABLE: -32004,
    JSON_RPC_SERVER_ERROR_NODE_UNHEALTHY: -32005,
    JSON_RPC_SERVER_ERROR_TRANSACTION_PRECOMPILE_VERIFICATION_FAILURE: -32006,
    JSON_RPC_SERVER_ERROR_SLOT_SKIPPED: -32007,
    JSON_RPC_SERVER_ERROR_NO_SNAPSHOT: -32008,
    JSON_RPC_SERVER_ERROR_LONG_TERM_STORAGE_SLOT_SKIPPED: -32009,
    JSON_RPC_SERVER_ERROR_KEY_EXCLUDED_FROM_SECONDARY_INDEX: -32010,
    JSON_RPC_SERVER_ERROR_TRANSACTION_HISTORY_NOT_AVAILABLE: -32011,
    JSON_RPC_SCAN_ERROR: -32012,
    JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_LEN_MISMATCH: -32013,
    JSON_RPC_SERVER_ERROR_BLOCK_STATUS_NOT_AVAILABLE_YET: -32014,
    JSON_RPC_SERVER_ERROR_UNSUPPORTED_TRANSACTION_VERSION: -32015,
    JSON_RPC_SERVER_ERROR_MIN_CONTEXT_SLOT_NOT_REACHED: -32016
};
var $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $dcsZi._)(SolanaJSONRPCError, Error1);
    var _super = (0, $ohfOJ._)(SolanaJSONRPCError);
    function SolanaJSONRPCError(param, customMessage) {
        var code = param.code, message = param.message, data = param.data;
        (0, $4GJKx._)(this, SolanaJSONRPCError);
        var _this;
        _this = _super.call(this, customMessage != null ? "".concat(customMessage, ": ").concat(message) : message);
        _this.code = void 0;
        _this.data = void 0;
        _this.code = code;
        _this.data = data;
        _this.name = "SolanaJSONRPCError";
        return _this;
    }
    return SolanaJSONRPCError;
}((0, $FuVm8._)(Error));
function $47b9aa0c5fbd17c3$export$4ad6fe6dae0b6bc3(connection, transaction, signers, options) {
    return $47b9aa0c5fbd17c3$var$_sendAndConfirmTransaction.apply(this, arguments);
}
function $47b9aa0c5fbd17c3$var$_sendAndConfirmTransaction() {
    $47b9aa0c5fbd17c3$var$_sendAndConfirmTransaction = /**
 * Sign, send and confirm a transaction.
 *
 * If `commitment` option is not specified, defaults to 'max' commitment.
 *
 * @param {Connection} connection
 * @param {Transaction} transaction
 * @param {Array<Signer>} signers
 * @param {ConfirmOptions} [options]
 * @returns {Promise<TransactionSignature>}
 */ (0, $kSuI9._)(function(connection, transaction, signers, options) {
        var sendOptions, signature, status, nonceInstruction, nonceAccountPubkey;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    sendOptions = options && {
                        skipPreflight: options.skipPreflight,
                        preflightCommitment: options.preflightCommitment || options.commitment,
                        maxRetries: options.maxRetries,
                        minContextSlot: options.minContextSlot
                    };
                    return [
                        4,
                        connection.sendTransaction(transaction, signers, sendOptions)
                    ];
                case 1:
                    signature = _state.sent();
                    if (!(transaction.recentBlockhash != null && transaction.lastValidBlockHeight != null)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        connection.confirmTransaction({
                            abortSignal: options === null || options === void 0 ? void 0 : options.abortSignal,
                            signature: signature,
                            blockhash: transaction.recentBlockhash,
                            lastValidBlockHeight: transaction.lastValidBlockHeight
                        }, options && options.commitment)
                    ];
                case 2:
                    status = _state.sent().value;
                    return [
                        3,
                        7
                    ];
                case 3:
                    if (!(transaction.minNonceContextSlot != null && transaction.nonceInfo != null)) return [
                        3,
                        5
                    ];
                    nonceInstruction = transaction.nonceInfo.nonceInstruction;
                    nonceAccountPubkey = nonceInstruction.keys[0].pubkey;
                    return [
                        4,
                        connection.confirmTransaction({
                            abortSignal: options === null || options === void 0 ? void 0 : options.abortSignal,
                            minContextSlot: transaction.minNonceContextSlot,
                            nonceAccountPubkey: nonceAccountPubkey,
                            nonceValue: transaction.nonceInfo.nonce,
                            signature: signature
                        }, options && options.commitment)
                    ];
                case 4:
                    status = _state.sent().value;
                    return [
                        3,
                        7
                    ];
                case 5:
                    if ((options === null || options === void 0 ? void 0 : options.abortSignal) != null) console.warn("sendAndConfirmTransaction(): A transaction with a deprecated confirmation strategy was supplied along with an `abortSignal`. Only transactions having `lastValidBlockHeight` or a combination of `nonceInfo` and `minNonceContextSlot` are abortable.");
                    return [
                        4,
                        connection.confirmTransaction(signature, options && options.commitment)
                    ];
                case 6:
                    status = _state.sent().value;
                    _state.label = 7;
                case 7:
                    if (status.err) {
                        if (signature != null) throw new $47b9aa0c5fbd17c3$export$121e803f723b3045({
                            action: "send",
                            signature: signature,
                            transactionMessage: "Status: (".concat(JSON.stringify(status), ")")
                        });
                        throw new Error("Transaction ".concat(signature, " failed (").concat(JSON.stringify(status), ")"));
                    }
                    return [
                        2,
                        signature
                    ];
            }
        });
    });
    return $47b9aa0c5fbd17c3$var$_sendAndConfirmTransaction.apply(this, arguments);
}
// zzz
function $47b9aa0c5fbd17c3$var$sleep(ms) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, ms);
    });
}
/**
 * @internal
 */ /**
 * Populate a buffer of instruction data using an InstructionType
 * @internal
 */ function $47b9aa0c5fbd17c3$var$encodeData(type, fields) {
    var allocLength = type.layout.span >= 0 ? type.layout.span : $47b9aa0c5fbd17c3$var$getAlloc(type, fields);
    var data = (0, $8dlmd.Buffer).alloc(allocLength);
    var layoutFields = Object.assign({
        instruction: type.index
    }, fields);
    type.layout.encode(layoutFields, data);
    return data;
}
/**
 * Decode instruction data buffer using an InstructionType
 * @internal
 */ function $47b9aa0c5fbd17c3$var$decodeData$1(type, buffer) {
    var data;
    try {
        data = type.layout.decode(buffer);
    } catch (err) {
        throw new Error("invalid instruction; " + err);
    }
    if (data.instruction !== type.index) throw new Error("invalid instruction; instruction index mismatch ".concat(data.instruction, " != ").concat(type.index));
    return data;
}
/**
 * https://github.com/solana-labs/solana/blob/90bedd7e067b5b8f3ddbb45da00a4e9cabb22c62/sdk/src/fee_calculator.rs#L7-L11
 *
 * @internal
 */ var $47b9aa0c5fbd17c3$export$d1cc579b1c48f515 = $jt90m.nu64("lamportsPerSignature");
/**
 * Calculator for transaction fees.
 *
 * @deprecated Deprecated since Solana v1.8.0.
 */ /**
 * See https://github.com/solana-labs/solana/blob/0ea2843ec9cdc517572b8e62c959f41b55cf4453/sdk/src/nonce_state.rs#L29-L32
 *
 * @internal
 */ var $47b9aa0c5fbd17c3$var$NonceAccountLayout = $jt90m.struct([
    $jt90m.u32("version"),
    $jt90m.u32("state"),
    $47b9aa0c5fbd17c3$var$publicKey("authorizedPubkey"),
    $47b9aa0c5fbd17c3$var$publicKey("nonce"),
    $jt90m.struct([
        $47b9aa0c5fbd17c3$export$d1cc579b1c48f515
    ], "feeCalculator")
]);
var $47b9aa0c5fbd17c3$export$7126250b6d8bd94a = $47b9aa0c5fbd17c3$var$NonceAccountLayout.span;
/**
 * A durable nonce is a 32 byte value encoded as a base58 string.
 */ /**
 * NonceAccount class
 */ var $47b9aa0c5fbd17c3$export$ed1c2356ce604759 = /*#__PURE__*/ function() {
    "use strict";
    function NonceAccount(args) {
        (0, $4GJKx._)(this, NonceAccount);
        this.authorizedPubkey = void 0;
        this.nonce = void 0;
        this.feeCalculator = void 0;
        this.authorizedPubkey = args.authorizedPubkey;
        this.nonce = args.nonce;
        this.feeCalculator = args.feeCalculator;
    }
    (0, $1wc17._)(NonceAccount, null, [
        {
            key: "fromAccountData",
            value: /**
   * Deserialize NonceAccount from the account data.
   *
   * @param buffer account data
   * @return NonceAccount
   */ function fromAccountData(buffer) {
                var nonceAccount = $47b9aa0c5fbd17c3$var$NonceAccountLayout.decode($47b9aa0c5fbd17c3$var$toBuffer(buffer), 0);
                return new NonceAccount({
                    authorizedPubkey: new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(nonceAccount.authorizedPubkey),
                    nonce: new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(nonceAccount.nonce).toString(),
                    feeCalculator: nonceAccount.feeCalculator
                });
            }
        }
    ]);
    return NonceAccount;
}();
var $47b9aa0c5fbd17c3$var$encodeDecode = function(layout) {
    var decode = layout.decode.bind(layout);
    var encode = layout.encode.bind(layout);
    return {
        decode: decode,
        encode: encode
    };
};
var $47b9aa0c5fbd17c3$var$bigInt = function(length) {
    return function(property) {
        var layout = (0, $jt90m.blob)(length, property);
        var _encodeDecode = $47b9aa0c5fbd17c3$var$encodeDecode(layout), encode = _encodeDecode.encode, decode = _encodeDecode.decode;
        var bigIntLayout = layout;
        bigIntLayout.decode = function(buffer, offset) {
            var src = decode(buffer, offset);
            return (0, $hgOwg.toBigIntLE)((0, $8dlmd.Buffer).from(src));
        };
        bigIntLayout.encode = function(bigInt, buffer, offset) {
            var src = (0, $hgOwg.toBufferLE)(bigInt, length);
            return encode(src, buffer, offset);
        };
        return bigIntLayout;
    };
};
var $47b9aa0c5fbd17c3$var$u64 = $47b9aa0c5fbd17c3$var$bigInt(8);
/**
 * Create account system transaction params
 */ /**
 * Transfer system transaction params
 */ /**
 * Assign system transaction params
 */ /**
 * Create account with seed system transaction params
 */ /**
 * Create nonce account system transaction params
 */ /**
 * Create nonce account with seed system transaction params
 */ /**
 * Initialize nonce account system instruction params
 */ /**
 * Advance nonce account system instruction params
 */ /**
 * Withdraw nonce account system transaction params
 */ /**
 * Authorize nonce account system transaction params
 */ /**
 * Allocate account system transaction params
 */ /**
 * Allocate account with seed system transaction params
 */ /**
 * Assign account with seed system transaction params
 */ /**
 * Transfer with seed system transaction params
 */ /** Decoded transfer system transaction instruction */ /** Decoded transferWithSeed system transaction instruction */ /**
 * System Instruction class
 */ var $47b9aa0c5fbd17c3$export$f009802131fa3d06 = /*#__PURE__*/ function() {
    "use strict";
    function SystemInstruction() {
        (0, $4GJKx._)(this, SystemInstruction);
    }
    (0, $1wc17._)(SystemInstruction, null, [
        {
            key: "decodeInstructionType",
            value: /**
   * Decode a system instruction and retrieve the instruction type.
   */ function decodeInstructionType(instruction) {
                this.checkProgramId(instruction.programId);
                var instructionTypeLayout = $jt90m.u32("instruction");
                var typeIndex = instructionTypeLayout.decode(instruction.data);
                var _$type;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries($47b9aa0c5fbd17c3$export$74bdf41d8d1e7108)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $cv9Rk._)(_step.value, 2), ixType = _step_value[0], layout = _step_value[1];
                        if (layout.index == typeIndex) {
                            _$type = ixType;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (!_$type) throw new Error("Instruction type incorrect; not a SystemInstruction");
                return _$type;
            }
        },
        {
            key: "decodeCreateAccount",
            value: /**
   * Decode a create account system instruction and retrieve the instruction params.
   */ function decodeCreateAccount(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 2);
                var _decodeData$1 = $47b9aa0c5fbd17c3$var$decodeData$1($47b9aa0c5fbd17c3$export$74bdf41d8d1e7108.Create, instruction.data), lamports = _decodeData$1.lamports, space = _decodeData$1.space, programId = _decodeData$1.programId;
                return {
                    fromPubkey: instruction.keys[0].pubkey,
                    newAccountPubkey: instruction.keys[1].pubkey,
                    lamports: lamports,
                    space: space,
                    programId: new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(programId)
                };
            }
        },
        {
            key: "decodeTransfer",
            value: /**
   * Decode a transfer system instruction and retrieve the instruction params.
   */ function decodeTransfer(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 2);
                var lamports = $47b9aa0c5fbd17c3$var$decodeData$1($47b9aa0c5fbd17c3$export$74bdf41d8d1e7108.Transfer, instruction.data).lamports;
                return {
                    fromPubkey: instruction.keys[0].pubkey,
                    toPubkey: instruction.keys[1].pubkey,
                    lamports: lamports
                };
            }
        },
        {
            key: "decodeTransferWithSeed",
            value: /**
   * Decode a transfer with seed system instruction and retrieve the instruction params.
   */ function decodeTransferWithSeed(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 3);
                var _decodeData$1 = $47b9aa0c5fbd17c3$var$decodeData$1($47b9aa0c5fbd17c3$export$74bdf41d8d1e7108.TransferWithSeed, instruction.data), lamports = _decodeData$1.lamports, seed = _decodeData$1.seed, programId = _decodeData$1.programId;
                return {
                    fromPubkey: instruction.keys[0].pubkey,
                    basePubkey: instruction.keys[1].pubkey,
                    toPubkey: instruction.keys[2].pubkey,
                    lamports: lamports,
                    seed: seed,
                    programId: new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(programId)
                };
            }
        },
        {
            key: "decodeAllocate",
            value: /**
   * Decode an allocate system instruction and retrieve the instruction params.
   */ function decodeAllocate(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 1);
                var space = $47b9aa0c5fbd17c3$var$decodeData$1($47b9aa0c5fbd17c3$export$74bdf41d8d1e7108.Allocate, instruction.data).space;
                return {
                    accountPubkey: instruction.keys[0].pubkey,
                    space: space
                };
            }
        },
        {
            key: "decodeAllocateWithSeed",
            value: /**
   * Decode an allocate with seed system instruction and retrieve the instruction params.
   */ function decodeAllocateWithSeed(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 1);
                var _decodeData$1 = $47b9aa0c5fbd17c3$var$decodeData$1($47b9aa0c5fbd17c3$export$74bdf41d8d1e7108.AllocateWithSeed, instruction.data), base = _decodeData$1.base, seed = _decodeData$1.seed, space = _decodeData$1.space, programId = _decodeData$1.programId;
                return {
                    accountPubkey: instruction.keys[0].pubkey,
                    basePubkey: new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(base),
                    seed: seed,
                    space: space,
                    programId: new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(programId)
                };
            }
        },
        {
            key: "decodeAssign",
            value: /**
   * Decode an assign system instruction and retrieve the instruction params.
   */ function decodeAssign(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 1);
                var programId = $47b9aa0c5fbd17c3$var$decodeData$1($47b9aa0c5fbd17c3$export$74bdf41d8d1e7108.Assign, instruction.data).programId;
                return {
                    accountPubkey: instruction.keys[0].pubkey,
                    programId: new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(programId)
                };
            }
        },
        {
            key: "decodeAssignWithSeed",
            value: /**
   * Decode an assign with seed system instruction and retrieve the instruction params.
   */ function decodeAssignWithSeed(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 1);
                var _decodeData$1 = $47b9aa0c5fbd17c3$var$decodeData$1($47b9aa0c5fbd17c3$export$74bdf41d8d1e7108.AssignWithSeed, instruction.data), base = _decodeData$1.base, seed = _decodeData$1.seed, programId = _decodeData$1.programId;
                return {
                    accountPubkey: instruction.keys[0].pubkey,
                    basePubkey: new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(base),
                    seed: seed,
                    programId: new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(programId)
                };
            }
        },
        {
            key: "decodeCreateWithSeed",
            value: /**
   * Decode a create account with seed system instruction and retrieve the instruction params.
   */ function decodeCreateWithSeed(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 2);
                var _decodeData$1 = $47b9aa0c5fbd17c3$var$decodeData$1($47b9aa0c5fbd17c3$export$74bdf41d8d1e7108.CreateWithSeed, instruction.data), base = _decodeData$1.base, seed = _decodeData$1.seed, lamports = _decodeData$1.lamports, space = _decodeData$1.space, programId = _decodeData$1.programId;
                return {
                    fromPubkey: instruction.keys[0].pubkey,
                    newAccountPubkey: instruction.keys[1].pubkey,
                    basePubkey: new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(base),
                    seed: seed,
                    lamports: lamports,
                    space: space,
                    programId: new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(programId)
                };
            }
        },
        {
            key: "decodeNonceInitialize",
            value: /**
   * Decode a nonce initialize system instruction and retrieve the instruction params.
   */ function decodeNonceInitialize(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 3);
                var authorized = $47b9aa0c5fbd17c3$var$decodeData$1($47b9aa0c5fbd17c3$export$74bdf41d8d1e7108.InitializeNonceAccount, instruction.data).authorized;
                return {
                    noncePubkey: instruction.keys[0].pubkey,
                    authorizedPubkey: new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(authorized)
                };
            }
        },
        {
            key: "decodeNonceAdvance",
            value: /**
   * Decode a nonce advance system instruction and retrieve the instruction params.
   */ function decodeNonceAdvance(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 3);
                $47b9aa0c5fbd17c3$var$decodeData$1($47b9aa0c5fbd17c3$export$74bdf41d8d1e7108.AdvanceNonceAccount, instruction.data);
                return {
                    noncePubkey: instruction.keys[0].pubkey,
                    authorizedPubkey: instruction.keys[2].pubkey
                };
            }
        },
        {
            key: "decodeNonceWithdraw",
            value: /**
   * Decode a nonce withdraw system instruction and retrieve the instruction params.
   */ function decodeNonceWithdraw(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 5);
                var lamports = $47b9aa0c5fbd17c3$var$decodeData$1($47b9aa0c5fbd17c3$export$74bdf41d8d1e7108.WithdrawNonceAccount, instruction.data).lamports;
                return {
                    noncePubkey: instruction.keys[0].pubkey,
                    toPubkey: instruction.keys[1].pubkey,
                    authorizedPubkey: instruction.keys[4].pubkey,
                    lamports: lamports
                };
            }
        },
        {
            key: "decodeNonceAuthorize",
            value: /**
   * Decode a nonce authorize system instruction and retrieve the instruction params.
   */ function decodeNonceAuthorize(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 2);
                var authorized = $47b9aa0c5fbd17c3$var$decodeData$1($47b9aa0c5fbd17c3$export$74bdf41d8d1e7108.AuthorizeNonceAccount, instruction.data).authorized;
                return {
                    noncePubkey: instruction.keys[0].pubkey,
                    authorizedPubkey: instruction.keys[1].pubkey,
                    newAuthorizedPubkey: new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(authorized)
                };
            }
        },
        {
            key: "checkProgramId",
            value: /**
   * @internal
   */ function checkProgramId(programId) {
                if (!programId.equals($47b9aa0c5fbd17c3$export$d8c4e17726848113.programId)) throw new Error("invalid instruction; programId is not SystemProgram");
            }
        },
        {
            key: "checkKeyLength",
            value: /**
   * @internal
   */ function checkKeyLength(keys, expectedLength) {
                if (keys.length < expectedLength) throw new Error("invalid instruction; found ".concat(keys.length, " keys, expected at least ").concat(expectedLength));
            }
        }
    ]);
    return SystemInstruction;
}();
/**
 * An enumeration of valid SystemInstructionType's
 */ /**
 * An enumeration of valid system InstructionType's
 * @internal
 */ var $47b9aa0c5fbd17c3$export$74bdf41d8d1e7108 = Object.freeze({
    Create: {
        index: 0,
        layout: $jt90m.struct([
            $jt90m.u32("instruction"),
            $jt90m.ns64("lamports"),
            $jt90m.ns64("space"),
            $47b9aa0c5fbd17c3$var$publicKey("programId")
        ])
    },
    Assign: {
        index: 1,
        layout: $jt90m.struct([
            $jt90m.u32("instruction"),
            $47b9aa0c5fbd17c3$var$publicKey("programId")
        ])
    },
    Transfer: {
        index: 2,
        layout: $jt90m.struct([
            $jt90m.u32("instruction"),
            $47b9aa0c5fbd17c3$var$u64("lamports")
        ])
    },
    CreateWithSeed: {
        index: 3,
        layout: $jt90m.struct([
            $jt90m.u32("instruction"),
            $47b9aa0c5fbd17c3$var$publicKey("base"),
            $47b9aa0c5fbd17c3$var$rustString("seed"),
            $jt90m.ns64("lamports"),
            $jt90m.ns64("space"),
            $47b9aa0c5fbd17c3$var$publicKey("programId")
        ])
    },
    AdvanceNonceAccount: {
        index: 4,
        layout: $jt90m.struct([
            $jt90m.u32("instruction")
        ])
    },
    WithdrawNonceAccount: {
        index: 5,
        layout: $jt90m.struct([
            $jt90m.u32("instruction"),
            $jt90m.ns64("lamports")
        ])
    },
    InitializeNonceAccount: {
        index: 6,
        layout: $jt90m.struct([
            $jt90m.u32("instruction"),
            $47b9aa0c5fbd17c3$var$publicKey("authorized")
        ])
    },
    AuthorizeNonceAccount: {
        index: 7,
        layout: $jt90m.struct([
            $jt90m.u32("instruction"),
            $47b9aa0c5fbd17c3$var$publicKey("authorized")
        ])
    },
    Allocate: {
        index: 8,
        layout: $jt90m.struct([
            $jt90m.u32("instruction"),
            $jt90m.ns64("space")
        ])
    },
    AllocateWithSeed: {
        index: 9,
        layout: $jt90m.struct([
            $jt90m.u32("instruction"),
            $47b9aa0c5fbd17c3$var$publicKey("base"),
            $47b9aa0c5fbd17c3$var$rustString("seed"),
            $jt90m.ns64("space"),
            $47b9aa0c5fbd17c3$var$publicKey("programId")
        ])
    },
    AssignWithSeed: {
        index: 10,
        layout: $jt90m.struct([
            $jt90m.u32("instruction"),
            $47b9aa0c5fbd17c3$var$publicKey("base"),
            $47b9aa0c5fbd17c3$var$rustString("seed"),
            $47b9aa0c5fbd17c3$var$publicKey("programId")
        ])
    },
    TransferWithSeed: {
        index: 11,
        layout: $jt90m.struct([
            $jt90m.u32("instruction"),
            $47b9aa0c5fbd17c3$var$u64("lamports"),
            $47b9aa0c5fbd17c3$var$rustString("seed"),
            $47b9aa0c5fbd17c3$var$publicKey("programId")
        ])
    },
    UpgradeNonceAccount: {
        index: 12,
        layout: $jt90m.struct([
            $jt90m.u32("instruction")
        ])
    }
});
/**
 * Factory class for transactions to interact with the System program
 */ var $47b9aa0c5fbd17c3$export$d8c4e17726848113 = /*#__PURE__*/ function() {
    "use strict";
    function SystemProgram() {
        (0, $4GJKx._)(this, SystemProgram);
    }
    (0, $1wc17._)(SystemProgram, null, [
        {
            key: "createAccount",
            value: /**
   * Public key that identifies the System program
   */ /**
   * Generate a transaction instruction that creates a new account
   */ function createAccount(params) {
                var _$type = $47b9aa0c5fbd17c3$export$74bdf41d8d1e7108.Create;
                var data = $47b9aa0c5fbd17c3$var$encodeData(_$type, {
                    lamports: params.lamports,
                    space: params.space,
                    programId: $47b9aa0c5fbd17c3$var$toBuffer(params.programId.toBuffer())
                });
                return new $47b9aa0c5fbd17c3$export$a7a3aa8360ac9f59({
                    keys: [
                        {
                            pubkey: params.fromPubkey,
                            isSigner: true,
                            isWritable: true
                        },
                        {
                            pubkey: params.newAccountPubkey,
                            isSigner: true,
                            isWritable: true
                        }
                    ],
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "transfer",
            value: /**
   * Generate a transaction instruction that transfers lamports from one account to another
   */ function transfer(params) {
                var data;
                var keys;
                if ("basePubkey" in params) {
                    var _$type = $47b9aa0c5fbd17c3$export$74bdf41d8d1e7108.TransferWithSeed;
                    data = $47b9aa0c5fbd17c3$var$encodeData(_$type, {
                        lamports: BigInt(params.lamports),
                        seed: params.seed,
                        programId: $47b9aa0c5fbd17c3$var$toBuffer(params.programId.toBuffer())
                    });
                    keys = [
                        {
                            pubkey: params.fromPubkey,
                            isSigner: false,
                            isWritable: true
                        },
                        {
                            pubkey: params.basePubkey,
                            isSigner: true,
                            isWritable: false
                        },
                        {
                            pubkey: params.toPubkey,
                            isSigner: false,
                            isWritable: true
                        }
                    ];
                } else {
                    var _$type1 = $47b9aa0c5fbd17c3$export$74bdf41d8d1e7108.Transfer;
                    data = $47b9aa0c5fbd17c3$var$encodeData(_$type1, {
                        lamports: BigInt(params.lamports)
                    });
                    keys = [
                        {
                            pubkey: params.fromPubkey,
                            isSigner: true,
                            isWritable: true
                        },
                        {
                            pubkey: params.toPubkey,
                            isSigner: false,
                            isWritable: true
                        }
                    ];
                }
                return new $47b9aa0c5fbd17c3$export$a7a3aa8360ac9f59({
                    keys: keys,
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "assign",
            value: /**
   * Generate a transaction instruction that assigns an account to a program
   */ function assign(params) {
                var data;
                var keys;
                if ("basePubkey" in params) {
                    var _$type = $47b9aa0c5fbd17c3$export$74bdf41d8d1e7108.AssignWithSeed;
                    data = $47b9aa0c5fbd17c3$var$encodeData(_$type, {
                        base: $47b9aa0c5fbd17c3$var$toBuffer(params.basePubkey.toBuffer()),
                        seed: params.seed,
                        programId: $47b9aa0c5fbd17c3$var$toBuffer(params.programId.toBuffer())
                    });
                    keys = [
                        {
                            pubkey: params.accountPubkey,
                            isSigner: false,
                            isWritable: true
                        },
                        {
                            pubkey: params.basePubkey,
                            isSigner: true,
                            isWritable: false
                        }
                    ];
                } else {
                    var _$type1 = $47b9aa0c5fbd17c3$export$74bdf41d8d1e7108.Assign;
                    data = $47b9aa0c5fbd17c3$var$encodeData(_$type1, {
                        programId: $47b9aa0c5fbd17c3$var$toBuffer(params.programId.toBuffer())
                    });
                    keys = [
                        {
                            pubkey: params.accountPubkey,
                            isSigner: true,
                            isWritable: true
                        }
                    ];
                }
                return new $47b9aa0c5fbd17c3$export$a7a3aa8360ac9f59({
                    keys: keys,
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "createAccountWithSeed",
            value: /**
   * Generate a transaction instruction that creates a new account at
   *   an address generated with `from`, a seed, and programId
   */ function createAccountWithSeed(params) {
                var _$type = $47b9aa0c5fbd17c3$export$74bdf41d8d1e7108.CreateWithSeed;
                var data = $47b9aa0c5fbd17c3$var$encodeData(_$type, {
                    base: $47b9aa0c5fbd17c3$var$toBuffer(params.basePubkey.toBuffer()),
                    seed: params.seed,
                    lamports: params.lamports,
                    space: params.space,
                    programId: $47b9aa0c5fbd17c3$var$toBuffer(params.programId.toBuffer())
                });
                var keys = [
                    {
                        pubkey: params.fromPubkey,
                        isSigner: true,
                        isWritable: true
                    },
                    {
                        pubkey: params.newAccountPubkey,
                        isSigner: false,
                        isWritable: true
                    }
                ];
                if (!params.basePubkey.equals(params.fromPubkey)) keys.push({
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                });
                return new $47b9aa0c5fbd17c3$export$a7a3aa8360ac9f59({
                    keys: keys,
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "createNonceAccount",
            value: /**
   * Generate a transaction that creates a new Nonce account
   */ function createNonceAccount(params) {
                var transaction = new $47b9aa0c5fbd17c3$export$febc5573c75cefb0();
                if ("basePubkey" in params && "seed" in params) transaction.add(SystemProgram.createAccountWithSeed({
                    fromPubkey: params.fromPubkey,
                    newAccountPubkey: params.noncePubkey,
                    basePubkey: params.basePubkey,
                    seed: params.seed,
                    lamports: params.lamports,
                    space: $47b9aa0c5fbd17c3$export$7126250b6d8bd94a,
                    programId: this.programId
                }));
                else transaction.add(SystemProgram.createAccount({
                    fromPubkey: params.fromPubkey,
                    newAccountPubkey: params.noncePubkey,
                    lamports: params.lamports,
                    space: $47b9aa0c5fbd17c3$export$7126250b6d8bd94a,
                    programId: this.programId
                }));
                var initParams = {
                    noncePubkey: params.noncePubkey,
                    authorizedPubkey: params.authorizedPubkey
                };
                transaction.add(this.nonceInitialize(initParams));
                return transaction;
            }
        },
        {
            key: "nonceInitialize",
            value: /**
   * Generate an instruction to initialize a Nonce account
   */ function nonceInitialize(params) {
                var _$type = $47b9aa0c5fbd17c3$export$74bdf41d8d1e7108.InitializeNonceAccount;
                var data = $47b9aa0c5fbd17c3$var$encodeData(_$type, {
                    authorized: $47b9aa0c5fbd17c3$var$toBuffer(params.authorizedPubkey.toBuffer())
                });
                var instructionData = {
                    keys: [
                        {
                            pubkey: params.noncePubkey,
                            isSigner: false,
                            isWritable: true
                        },
                        {
                            pubkey: $47b9aa0c5fbd17c3$export$e74201139e9833db,
                            isSigner: false,
                            isWritable: false
                        },
                        {
                            pubkey: $47b9aa0c5fbd17c3$export$970d0190cdb3a8e9,
                            isSigner: false,
                            isWritable: false
                        }
                    ],
                    programId: this.programId,
                    data: data
                };
                return new $47b9aa0c5fbd17c3$export$a7a3aa8360ac9f59(instructionData);
            }
        },
        {
            key: "nonceAdvance",
            value: /**
   * Generate an instruction to advance the nonce in a Nonce account
   */ function nonceAdvance(params) {
                var _$type = $47b9aa0c5fbd17c3$export$74bdf41d8d1e7108.AdvanceNonceAccount;
                var data = $47b9aa0c5fbd17c3$var$encodeData(_$type);
                var instructionData = {
                    keys: [
                        {
                            pubkey: params.noncePubkey,
                            isSigner: false,
                            isWritable: true
                        },
                        {
                            pubkey: $47b9aa0c5fbd17c3$export$e74201139e9833db,
                            isSigner: false,
                            isWritable: false
                        },
                        {
                            pubkey: params.authorizedPubkey,
                            isSigner: true,
                            isWritable: false
                        }
                    ],
                    programId: this.programId,
                    data: data
                };
                return new $47b9aa0c5fbd17c3$export$a7a3aa8360ac9f59(instructionData);
            }
        },
        {
            key: "nonceWithdraw",
            value: /**
   * Generate a transaction instruction that withdraws lamports from a Nonce account
   */ function nonceWithdraw(params) {
                var _$type = $47b9aa0c5fbd17c3$export$74bdf41d8d1e7108.WithdrawNonceAccount;
                var data = $47b9aa0c5fbd17c3$var$encodeData(_$type, {
                    lamports: params.lamports
                });
                return new $47b9aa0c5fbd17c3$export$a7a3aa8360ac9f59({
                    keys: [
                        {
                            pubkey: params.noncePubkey,
                            isSigner: false,
                            isWritable: true
                        },
                        {
                            pubkey: params.toPubkey,
                            isSigner: false,
                            isWritable: true
                        },
                        {
                            pubkey: $47b9aa0c5fbd17c3$export$e74201139e9833db,
                            isSigner: false,
                            isWritable: false
                        },
                        {
                            pubkey: $47b9aa0c5fbd17c3$export$970d0190cdb3a8e9,
                            isSigner: false,
                            isWritable: false
                        },
                        {
                            pubkey: params.authorizedPubkey,
                            isSigner: true,
                            isWritable: false
                        }
                    ],
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "nonceAuthorize",
            value: /**
   * Generate a transaction instruction that authorizes a new PublicKey as the authority
   * on a Nonce account.
   */ function nonceAuthorize(params) {
                var _$type = $47b9aa0c5fbd17c3$export$74bdf41d8d1e7108.AuthorizeNonceAccount;
                var data = $47b9aa0c5fbd17c3$var$encodeData(_$type, {
                    authorized: $47b9aa0c5fbd17c3$var$toBuffer(params.newAuthorizedPubkey.toBuffer())
                });
                return new $47b9aa0c5fbd17c3$export$a7a3aa8360ac9f59({
                    keys: [
                        {
                            pubkey: params.noncePubkey,
                            isSigner: false,
                            isWritable: true
                        },
                        {
                            pubkey: params.authorizedPubkey,
                            isSigner: true,
                            isWritable: false
                        }
                    ],
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "allocate",
            value: /**
   * Generate a transaction instruction that allocates space in an account without funding
   */ function allocate(params) {
                var data;
                var keys;
                if ("basePubkey" in params) {
                    var _$type = $47b9aa0c5fbd17c3$export$74bdf41d8d1e7108.AllocateWithSeed;
                    data = $47b9aa0c5fbd17c3$var$encodeData(_$type, {
                        base: $47b9aa0c5fbd17c3$var$toBuffer(params.basePubkey.toBuffer()),
                        seed: params.seed,
                        space: params.space,
                        programId: $47b9aa0c5fbd17c3$var$toBuffer(params.programId.toBuffer())
                    });
                    keys = [
                        {
                            pubkey: params.accountPubkey,
                            isSigner: false,
                            isWritable: true
                        },
                        {
                            pubkey: params.basePubkey,
                            isSigner: true,
                            isWritable: false
                        }
                    ];
                } else {
                    var _$type1 = $47b9aa0c5fbd17c3$export$74bdf41d8d1e7108.Allocate;
                    data = $47b9aa0c5fbd17c3$var$encodeData(_$type1, {
                        space: params.space
                    });
                    keys = [
                        {
                            pubkey: params.accountPubkey,
                            isSigner: true,
                            isWritable: true
                        }
                    ];
                }
                return new $47b9aa0c5fbd17c3$export$a7a3aa8360ac9f59({
                    keys: keys,
                    programId: this.programId,
                    data: data
                });
            }
        }
    ]);
    return SystemProgram;
}();
$47b9aa0c5fbd17c3$export$d8c4e17726848113.programId = new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de("11111111111111111111111111111111");
// Keep program chunks under PACKET_DATA_SIZE, leaving enough room for the
// rest of the Transaction fields
//
// TODO: replace 300 with a proper constant for the size of the other
// Transaction fields
var $47b9aa0c5fbd17c3$var$CHUNK_SIZE = $47b9aa0c5fbd17c3$export$4c6d5b89e1596f26 - 300;
/**
 * Program loader interface
 */ var $47b9aa0c5fbd17c3$export$3b0d6d7590275603 = /*#__PURE__*/ function() {
    "use strict";
    function Loader() {
        (0, $4GJKx._)(this, Loader);
    }
    (0, $1wc17._)(Loader, null, [
        {
            key: "getMinNumSignatures",
            value: /**
   * Amount of program data placed in each load Transaction
   */ /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */ function getMinNumSignatures(dataLength) {
                return 2 * // Every transaction requires two signatures (payer + program)
                (Math.ceil(dataLength / Loader.chunkSize) + 1 + // Add one for Create transaction
                1 // Add one for Finalize transaction
                );
            }
        },
        {
            key: "load",
            value: /**
   * Loads a generic program
   *
   * @param connection The connection to use
   * @param payer System account that pays to load the program
   * @param program Account to load the program into
   * @param programId Public key that identifies the loader
   * @param data Program octets
   * @return true if program was loaded successfully, false if program was already loaded
   */ function load(connection, payer, program, programId, data) {
                return (0, $kSuI9._)(function() {
                    var balanceNeeded, programInfo, transaction, dataLayout, chunkSize, offset, _$array, transactions, bytes, _$data, transaction1, REQUESTS_PER_SECOND, dataLayout1, _$data1, transaction2, deployCommitment, finalizeSignature, _ref, context, value, currentSlot, e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    connection.getMinimumBalanceForRentExemption(data.length)
                                ];
                            case 1:
                                balanceNeeded = _state.sent();
                                return [
                                    4,
                                    connection.getAccountInfo(program.publicKey, "confirmed")
                                ];
                            case 2:
                                programInfo = _state.sent();
                                transaction = null;
                                if (programInfo !== null) {
                                    if (programInfo.executable) {
                                        console.error("Program load failed, account is already executable");
                                        return [
                                            2,
                                            false
                                        ];
                                    }
                                    if (programInfo.data.length !== data.length) {
                                        transaction = transaction || new $47b9aa0c5fbd17c3$export$febc5573c75cefb0();
                                        transaction.add($47b9aa0c5fbd17c3$export$d8c4e17726848113.allocate({
                                            accountPubkey: program.publicKey,
                                            space: data.length
                                        }));
                                    }
                                    if (!programInfo.owner.equals(programId)) {
                                        transaction = transaction || new $47b9aa0c5fbd17c3$export$febc5573c75cefb0();
                                        transaction.add($47b9aa0c5fbd17c3$export$d8c4e17726848113.assign({
                                            accountPubkey: program.publicKey,
                                            programId: programId
                                        }));
                                    }
                                    if (programInfo.lamports < balanceNeeded) {
                                        transaction = transaction || new $47b9aa0c5fbd17c3$export$febc5573c75cefb0();
                                        transaction.add($47b9aa0c5fbd17c3$export$d8c4e17726848113.transfer({
                                            fromPubkey: payer.publicKey,
                                            toPubkey: program.publicKey,
                                            lamports: balanceNeeded - programInfo.lamports
                                        }));
                                    }
                                } else transaction = new $47b9aa0c5fbd17c3$export$febc5573c75cefb0().add($47b9aa0c5fbd17c3$export$d8c4e17726848113.createAccount({
                                    fromPubkey: payer.publicKey,
                                    newAccountPubkey: program.publicKey,
                                    lamports: balanceNeeded > 0 ? balanceNeeded : 1,
                                    space: data.length,
                                    programId: programId
                                }));
                                if (!(transaction !== null)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    $47b9aa0c5fbd17c3$export$4ad6fe6dae0b6bc3(connection, transaction, [
                                        payer,
                                        program
                                    ], {
                                        commitment: "confirmed"
                                    })
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                dataLayout = $jt90m.struct([
                                    $jt90m.u32("instruction"),
                                    $jt90m.u32("offset"),
                                    $jt90m.u32("bytesLength"),
                                    $jt90m.u32("bytesLengthPadding"),
                                    $jt90m.seq($jt90m.u8("byte"), $jt90m.offset($jt90m.u32(), -8), "bytes")
                                ]);
                                chunkSize = Loader.chunkSize;
                                offset = 0;
                                _$array = data;
                                transactions = [];
                                _state.label = 5;
                            case 5:
                                if (!(_$array.length > 0)) return [
                                    3,
                                    8
                                ];
                                bytes = _$array.slice(0, chunkSize);
                                _$data = (0, $8dlmd.Buffer).alloc(chunkSize + 16);
                                dataLayout.encode({
                                    instruction: 0,
                                    // Load instruction
                                    offset: offset,
                                    bytes: bytes,
                                    bytesLength: 0,
                                    bytesLengthPadding: 0
                                }, _$data);
                                transaction1 = new $47b9aa0c5fbd17c3$export$febc5573c75cefb0().add({
                                    keys: [
                                        {
                                            pubkey: program.publicKey,
                                            isSigner: true,
                                            isWritable: true
                                        }
                                    ],
                                    programId: programId,
                                    data: _$data
                                });
                                transactions.push($47b9aa0c5fbd17c3$export$4ad6fe6dae0b6bc3(connection, transaction1, [
                                    payer,
                                    program
                                ], {
                                    commitment: "confirmed"
                                }));
                                if (!connection._rpcEndpoint.includes("solana.com")) return [
                                    3,
                                    7
                                ];
                                REQUESTS_PER_SECOND = 4;
                                return [
                                    4,
                                    $47b9aa0c5fbd17c3$var$sleep(1000 / REQUESTS_PER_SECOND)
                                ];
                            case 6:
                                _state.sent();
                                _state.label = 7;
                            case 7:
                                offset += chunkSize;
                                _$array = _$array.slice(chunkSize);
                                return [
                                    3,
                                    5
                                ];
                            case 8:
                                return [
                                    4,
                                    Promise.all(transactions)
                                ];
                            case 9:
                                _state.sent();
                                dataLayout1 = $jt90m.struct([
                                    $jt90m.u32("instruction")
                                ]);
                                _$data1 = (0, $8dlmd.Buffer).alloc(dataLayout1.span);
                                dataLayout1.encode({
                                    instruction: 1 // Finalize instruction
                                }, _$data1);
                                transaction2 = new $47b9aa0c5fbd17c3$export$febc5573c75cefb0().add({
                                    keys: [
                                        {
                                            pubkey: program.publicKey,
                                            isSigner: true,
                                            isWritable: true
                                        },
                                        {
                                            pubkey: $47b9aa0c5fbd17c3$export$970d0190cdb3a8e9,
                                            isSigner: false,
                                            isWritable: false
                                        }
                                    ],
                                    programId: programId,
                                    data: _$data1
                                });
                                deployCommitment = "processed";
                                return [
                                    4,
                                    connection.sendTransaction(transaction2, [
                                        payer,
                                        program
                                    ], {
                                        preflightCommitment: deployCommitment
                                    })
                                ];
                            case 10:
                                finalizeSignature = _state.sent();
                                return [
                                    4,
                                    connection.confirmTransaction({
                                        signature: finalizeSignature,
                                        lastValidBlockHeight: transaction2.lastValidBlockHeight,
                                        blockhash: transaction2.recentBlockhash
                                    }, deployCommitment)
                                ];
                            case 11:
                                _ref = _state.sent(), context = _ref.context, value = _ref.value;
                                if (value.err) throw new Error("Transaction ".concat(finalizeSignature, " failed (").concat(JSON.stringify(value), ")"));
                                _state.label = 12;
                            case 12:
                                if (!true // eslint-disable-line no-constant-condition
                                ) return [
                                    3,
                                    18
                                ];
                                _state.label = 13;
                            case 13:
                                _state.trys.push([
                                    13,
                                    15,
                                    ,
                                    16
                                ]);
                                return [
                                    4,
                                    connection.getSlot({
                                        commitment: deployCommitment
                                    })
                                ];
                            case 14:
                                currentSlot = _state.sent();
                                if (currentSlot > context.slot) return [
                                    3,
                                    18
                                ];
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                e = _state.sent();
                                return [
                                    3,
                                    16
                                ];
                            case 16:
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        return setTimeout(resolve, Math.round($47b9aa0c5fbd17c3$var$MS_PER_SLOT / 2));
                                    })
                                ];
                            case 17:
                                _state.sent();
                                return [
                                    3,
                                    12
                                ];
                            case 18:
                                // success
                                return [
                                    2,
                                    true
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Loader;
}();
$47b9aa0c5fbd17c3$export$3b0d6d7590275603.chunkSize = $47b9aa0c5fbd17c3$var$CHUNK_SIZE;
/**
 * @deprecated Deprecated since Solana v1.17.20.
 */ var $47b9aa0c5fbd17c3$export$59833422f998b937 = new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de("BPFLoader2111111111111111111111111111111111");
/**
 * Factory class for transactions to interact with a program loader
 *
 * @deprecated Deprecated since Solana v1.17.20.
 */ var $47b9aa0c5fbd17c3$export$493be68e6a240d3b = /*#__PURE__*/ function() {
    "use strict";
    function BpfLoader() {
        (0, $4GJKx._)(this, BpfLoader);
    }
    (0, $1wc17._)(BpfLoader, null, [
        {
            key: "getMinNumSignatures",
            value: /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */ function getMinNumSignatures(dataLength) {
                return $47b9aa0c5fbd17c3$export$3b0d6d7590275603.getMinNumSignatures(dataLength);
            }
        },
        {
            key: "load",
            value: /**
   * Load a SBF program
   *
   * @param connection The connection to use
   * @param payer Account that will pay program loading fees
   * @param program Account to load the program into
   * @param elf The entire ELF containing the SBF program
   * @param loaderProgramId The program id of the BPF loader to use
   * @return true if program was loaded successfully, false if program was already loaded
   */ function load(connection, payer, program, elf, loaderProgramId) {
                return $47b9aa0c5fbd17c3$export$3b0d6d7590275603.load(connection, payer, program, loaderProgramId, elf);
            }
        }
    ]);
    return BpfLoader;
}();
function $47b9aa0c5fbd17c3$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var $47b9aa0c5fbd17c3$var$objToString = Object.prototype.toString;
var $47b9aa0c5fbd17c3$var$objKeys = Object.keys || function(obj) {
    var keys = [];
    for(var name in obj)keys.push(name);
    return keys;
};
function $47b9aa0c5fbd17c3$var$stringify(val, isArrayProp) {
    var i, max, str, keys, key, propVal, toStr;
    if (val === true) return "true";
    if (val === false) return "false";
    switch(typeof val === "undefined" ? "undefined" : (0, $l0HdX._)(val)){
        case "object":
            if (val === null) return null;
            else if (val.toJSON && typeof val.toJSON === "function") return $47b9aa0c5fbd17c3$var$stringify(val.toJSON(), isArrayProp);
            else {
                toStr = $47b9aa0c5fbd17c3$var$objToString.call(val);
                if (toStr === "[object Array]") {
                    str = "[";
                    max = val.length - 1;
                    for(i = 0; i < max; i++)str += $47b9aa0c5fbd17c3$var$stringify(val[i], true) + ",";
                    if (max > -1) str += $47b9aa0c5fbd17c3$var$stringify(val[i], true);
                    return str + "]";
                } else if (toStr === "[object Object]") {
                    // only object is left
                    keys = $47b9aa0c5fbd17c3$var$objKeys(val).sort();
                    max = keys.length;
                    str = "";
                    i = 0;
                    while(i < max){
                        key = keys[i];
                        propVal = $47b9aa0c5fbd17c3$var$stringify(val[key], false);
                        if (propVal !== undefined) {
                            if (str) str += ",";
                            str += JSON.stringify(key) + ":" + propVal;
                        }
                        i++;
                    }
                    return "{" + str + "}";
                } else return JSON.stringify(val);
            }
        case "function":
        case "undefined":
            return isArrayProp ? null : undefined;
        case "string":
            return JSON.stringify(val);
        default:
            return isFinite(val) ? val : null;
    }
}
var $47b9aa0c5fbd17c3$var$fastStableStringify = function fastStableStringify(val) {
    var returnVal = $47b9aa0c5fbd17c3$var$stringify(val, false);
    if (returnVal !== undefined) return "" + returnVal;
};
var $47b9aa0c5fbd17c3$var$fastStableStringify$1 = /*@__PURE__*/ $47b9aa0c5fbd17c3$var$getDefaultExportFromCjs($47b9aa0c5fbd17c3$var$fastStableStringify);
var $47b9aa0c5fbd17c3$var$MINIMUM_SLOT_PER_EPOCH = 32;
// Returns the number of trailing zeros in the binary representation of self.
function $47b9aa0c5fbd17c3$var$trailingZeros(n) {
    var trailingZeros = 0;
    while(n > 1){
        n /= 2;
        trailingZeros++;
    }
    return trailingZeros;
}
// Returns the smallest power of two greater than or equal to n
function $47b9aa0c5fbd17c3$var$nextPowerOfTwo(n) {
    if (n === 0) return 1;
    n--;
    n |= n >> 1;
    n |= n >> 2;
    n |= n >> 4;
    n |= n >> 8;
    n |= n >> 16;
    n |= n >> 32;
    return n + 1;
}
/**
 * Epoch schedule
 * (see https://docs.solana.com/terminology#epoch)
 * Can be retrieved with the {@link Connection.getEpochSchedule} method
 */ var $47b9aa0c5fbd17c3$export$df8ed3e830b1d591 = /*#__PURE__*/ function() {
    "use strict";
    function EpochSchedule(slotsPerEpoch, leaderScheduleSlotOffset, warmup, firstNormalEpoch, firstNormalSlot) {
        (0, $4GJKx._)(this, EpochSchedule);
        /** The maximum number of slots in each epoch */ this.slotsPerEpoch = void 0;
        /** The number of slots before beginning of an epoch to calculate a leader schedule for that epoch */ this.leaderScheduleSlotOffset = void 0;
        /** Indicates whether epochs start short and grow */ this.warmup = void 0;
        /** The first epoch with `slotsPerEpoch` slots */ this.firstNormalEpoch = void 0;
        /** The first slot of `firstNormalEpoch` */ this.firstNormalSlot = void 0;
        this.slotsPerEpoch = slotsPerEpoch;
        this.leaderScheduleSlotOffset = leaderScheduleSlotOffset;
        this.warmup = warmup;
        this.firstNormalEpoch = firstNormalEpoch;
        this.firstNormalSlot = firstNormalSlot;
    }
    (0, $1wc17._)(EpochSchedule, [
        {
            key: "getEpoch",
            value: function getEpoch(slot) {
                return this.getEpochAndSlotIndex(slot)[0];
            }
        },
        {
            key: "getEpochAndSlotIndex",
            value: function getEpochAndSlotIndex(slot) {
                if (slot < this.firstNormalSlot) {
                    var epoch = $47b9aa0c5fbd17c3$var$trailingZeros($47b9aa0c5fbd17c3$var$nextPowerOfTwo(slot + $47b9aa0c5fbd17c3$var$MINIMUM_SLOT_PER_EPOCH + 1)) - $47b9aa0c5fbd17c3$var$trailingZeros($47b9aa0c5fbd17c3$var$MINIMUM_SLOT_PER_EPOCH) - 1;
                    var epochLen = this.getSlotsInEpoch(epoch);
                    var slotIndex = slot - (epochLen - $47b9aa0c5fbd17c3$var$MINIMUM_SLOT_PER_EPOCH);
                    return [
                        epoch,
                        slotIndex
                    ];
                } else {
                    var normalSlotIndex = slot - this.firstNormalSlot;
                    var normalEpochIndex = Math.floor(normalSlotIndex / this.slotsPerEpoch);
                    var epoch1 = this.firstNormalEpoch + normalEpochIndex;
                    var slotIndex1 = normalSlotIndex % this.slotsPerEpoch;
                    return [
                        epoch1,
                        slotIndex1
                    ];
                }
            }
        },
        {
            key: "getFirstSlotInEpoch",
            value: function getFirstSlotInEpoch(epoch) {
                if (epoch <= this.firstNormalEpoch) return (Math.pow(2, epoch) - 1) * $47b9aa0c5fbd17c3$var$MINIMUM_SLOT_PER_EPOCH;
                else return (epoch - this.firstNormalEpoch) * this.slotsPerEpoch + this.firstNormalSlot;
            }
        },
        {
            key: "getLastSlotInEpoch",
            value: function getLastSlotInEpoch(epoch) {
                return this.getFirstSlotInEpoch(epoch) + this.getSlotsInEpoch(epoch) - 1;
            }
        },
        {
            key: "getSlotsInEpoch",
            value: function getSlotsInEpoch(epoch) {
                if (epoch < this.firstNormalEpoch) return Math.pow(2, epoch + $47b9aa0c5fbd17c3$var$trailingZeros($47b9aa0c5fbd17c3$var$MINIMUM_SLOT_PER_EPOCH));
                else return this.slotsPerEpoch;
            }
        }
    ]);
    return EpochSchedule;
}();
var $47b9aa0c5fbd17c3$var$fetchImpl = globalThis.fetch;
var $47b9aa0c5fbd17c3$var$RpcWebSocketClient = /*#__PURE__*/ function(CommonClient) {
    "use strict";
    (0, $dcsZi._)(RpcWebSocketClient, CommonClient);
    var _super = (0, $ohfOJ._)(RpcWebSocketClient);
    function RpcWebSocketClient(address, options, generate_request_id) {
        (0, $4GJKx._)(this, RpcWebSocketClient);
        var _this;
        var webSocketFactory = function(url) {
            var rpc = (0, $1Rq52.WebSocket)(url, (0, $do9pw._)({
                autoconnect: true,
                max_reconnects: 5,
                reconnect: true,
                reconnect_interval: 1000
            }, options));
            if ("socket" in rpc) _this.underlyingSocket = rpc.socket;
            else _this.underlyingSocket = rpc;
            return rpc;
        };
        _this = _super.call(this, webSocketFactory, address, options, generate_request_id);
        _this.underlyingSocket = void 0;
        return _this;
    }
    (0, $1wc17._)(RpcWebSocketClient, [
        {
            key: "call",
            value: function call() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _$_get;
                var _this_underlyingSocket;
                var readyState = (_this_underlyingSocket = this.underlyingSocket) === null || _this_underlyingSocket === void 0 ? void 0 : _this_underlyingSocket.readyState;
                if (readyState === 1 /* WebSocket.OPEN */ ) return (_$_get = (0, $04RAu._)((0, $b8Rim._)(RpcWebSocketClient.prototype), "call", this)).call.apply(_$_get, [
                    this
                ].concat((0, $c6Xmf._)(args)));
                return Promise.reject(new Error("Tried to call a JSON-RPC method `" + args[0] + "` but the socket was not `CONNECTING` or `OPEN` (`readyState` was " + readyState + ")"));
            }
        },
        {
            key: "notify",
            value: function notify() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _$_get;
                var _this_underlyingSocket;
                var readyState = (_this_underlyingSocket = this.underlyingSocket) === null || _this_underlyingSocket === void 0 ? void 0 : _this_underlyingSocket.readyState;
                if (readyState === 1 /* WebSocket.OPEN */ ) return (_$_get = (0, $04RAu._)((0, $b8Rim._)(RpcWebSocketClient.prototype), "notify", this)).call.apply(_$_get, [
                    this
                ].concat((0, $c6Xmf._)(args)));
                return Promise.reject(new Error("Tried to send a JSON-RPC notification `" + args[0] + "` but the socket was not `CONNECTING` or `OPEN` (`readyState` was " + readyState + ")"));
            }
        }
    ]);
    return RpcWebSocketClient;
}((0, $1Rq52.CommonClient));
/**
 * @internal
 */ /**
 * Decode account data buffer using an AccountType
 * @internal
 */ function $47b9aa0c5fbd17c3$var$decodeData(type, data) {
    var decoded;
    try {
        decoded = type.layout.decode(data);
    } catch (err) {
        throw new Error("invalid instruction; " + err);
    }
    if (decoded.typeIndex !== type.index) throw new Error("invalid account data; account type mismatch ".concat(decoded.typeIndex, " != ").concat(type.index));
    return decoded;
}
/// The serialized size of lookup table metadata
var $47b9aa0c5fbd17c3$var$LOOKUP_TABLE_META_SIZE = 56;
var $47b9aa0c5fbd17c3$export$5b2310da10e607da = /*#__PURE__*/ function() {
    "use strict";
    function AddressLookupTableAccount(args) {
        (0, $4GJKx._)(this, AddressLookupTableAccount);
        this.key = void 0;
        this.state = void 0;
        this.key = args.key;
        this.state = args.state;
    }
    (0, $1wc17._)(AddressLookupTableAccount, [
        {
            key: "isActive",
            value: function isActive() {
                var U64_MAX = BigInt("0xffffffffffffffff");
                return this.state.deactivationSlot === U64_MAX;
            }
        }
    ], [
        {
            key: "deserialize",
            value: function deserialize(accountData) {
                var meta = $47b9aa0c5fbd17c3$var$decodeData($47b9aa0c5fbd17c3$var$LookupTableMetaLayout, accountData);
                var serializedAddressesLen = accountData.length - $47b9aa0c5fbd17c3$var$LOOKUP_TABLE_META_SIZE;
                $47b9aa0c5fbd17c3$var$assert(serializedAddressesLen >= 0, "lookup table is invalid");
                $47b9aa0c5fbd17c3$var$assert(serializedAddressesLen % 32 === 0, "lookup table is invalid");
                var numSerializedAddresses = serializedAddressesLen / 32;
                var addresses = $jt90m.struct([
                    $jt90m.seq($47b9aa0c5fbd17c3$var$publicKey(), numSerializedAddresses, "addresses")
                ]).decode(accountData.slice($47b9aa0c5fbd17c3$var$LOOKUP_TABLE_META_SIZE)).addresses;
                return {
                    deactivationSlot: meta.deactivationSlot,
                    lastExtendedSlot: meta.lastExtendedSlot,
                    lastExtendedSlotStartIndex: meta.lastExtendedStartIndex,
                    authority: meta.authority.length !== 0 ? new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(meta.authority[0]) : undefined,
                    addresses: addresses.map(function(address) {
                        return new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(address);
                    })
                };
            }
        }
    ]);
    return AddressLookupTableAccount;
}();
var $47b9aa0c5fbd17c3$var$LookupTableMetaLayout = {
    index: 1,
    layout: $jt90m.struct([
        $jt90m.u32("typeIndex"),
        $47b9aa0c5fbd17c3$var$u64("deactivationSlot"),
        $jt90m.nu64("lastExtendedSlot"),
        $jt90m.u8("lastExtendedStartIndex"),
        $jt90m.u8(),
        // option
        $jt90m.seq($47b9aa0c5fbd17c3$var$publicKey(), $jt90m.offset($jt90m.u8(), -1), "authority")
    ])
};
var $47b9aa0c5fbd17c3$var$URL_RE = /^[^:]+:\/\/([^:[]+|\[[^\]]+\])(:\d+)?(.*)/i;
function $47b9aa0c5fbd17c3$var$makeWebsocketUrl(endpoint) {
    var matches = endpoint.match($47b9aa0c5fbd17c3$var$URL_RE);
    if (matches == null) throw TypeError("Failed to validate endpoint URL `".concat(endpoint, "`"));
    var _matches = (0, $cv9Rk._)(matches, 4), _ = _matches[0], // eslint-disable-line @typescript-eslint/no-unused-vars
    hostish = _matches[1], portWithColon = _matches[2], rest = _matches[3];
    var protocol = endpoint.startsWith("https:") ? "wss:" : "ws:";
    var startPort = portWithColon == null ? null : parseInt(portWithColon.slice(1), 10);
    var websocketPort = // Only shift the port by +1 as a convention for ws(s) only if given endpoint
    // is explicitly specifying the endpoint port (HTTP-based RPC), assuming
    // we're directly trying to connect to agave-validator's ws listening port.
    // When the endpoint omits the port, we're connecting to the protocol
    // default ports: http(80) or https(443) and it's assumed we're behind a reverse
    // proxy which manages WebSocket upgrade and backend port redirection.
    startPort == null ? "" : ":".concat(startPort + 1);
    return "".concat(protocol, "//").concat(hostish).concat(websocketPort).concat(rest);
}
var $47b9aa0c5fbd17c3$var$PublicKeyFromString = (0, $58xNN.coerce)((0, $58xNN.instance)($47b9aa0c5fbd17c3$export$ca8b6604d6ce14de), (0, $58xNN.string)(), function(value) {
    return new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(value);
});
var $47b9aa0c5fbd17c3$var$RawAccountDataResult = (0, $58xNN.tuple)([
    (0, $58xNN.string)(),
    (0, $58xNN.literal)("base64")
]);
var $47b9aa0c5fbd17c3$var$BufferFromRawAccountData = (0, $58xNN.coerce)((0, $58xNN.instance)((0, $8dlmd.Buffer)), $47b9aa0c5fbd17c3$var$RawAccountDataResult, function(value) {
    return (0, $8dlmd.Buffer).from(value[0], "base64");
});
/**
 * Attempt to use a recent blockhash for up to 30 seconds
 * @internal
 */ var $47b9aa0c5fbd17c3$export$fcb705732fb5c597 = 30000;
/**
 * HACK.
 * Copied from rpc-websockets/dist/lib/client.
 * Otherwise, `yarn build` fails with:
 * https://gist.github.com/steveluscher/c057eca81d479ef705cdb53162f9971d
 */ /** @internal */ /** @internal */ /** @internal */ /** @internal */ /** @internal */ /**
 * @internal
 * Every subscription contains the args used to open the subscription with
 * the server, and a list of callers interested in notifications.
 */ /**
 * @internal
 * A subscription may be in various states of connectedness. Only when it is
 * fully connected will it have a server subscription id associated with it.
 * This id can be returned to the server to unsubscribe the client entirely.
 */ /**
 * A type that encapsulates a subscription's RPC method
 * names and notification (callback) signature.
 */ /**
 * @internal
 * Utility type that keeps tagged unions intact while omitting properties.
 */ /**
 * @internal
 * This type represents a single subscribable 'topic.' It's made up of:
 *
 * - The args used to open the subscription with the server,
 * - The state of the subscription, in terms of its connectedness, and
 * - The set of callbacks to call when the server publishes notifications
 *
 * This record gets indexed by `SubscriptionConfigHash` and is used to
 * set up subscriptions, fan out notifications, and track subscription state.
 */ /**
 * @internal
 */ /**
 * Extra contextual information for RPC responses
 */ /**
 * Options for sending transactions
 */ /**
 * Options for confirming transactions
 */ /**
 * Options for getConfirmedSignaturesForAddress2
 */ /**
 * Options for getSignaturesForAddress
 */ /**
 * RPC Response with extra contextual information
 */ /**
 * A strategy for confirming transactions that uses the last valid
 * block height for a given blockhash to check for transaction expiration.
 */ /**
 * A strategy for confirming durable nonce transactions.
 */ /**
 * Properties shared by all transaction confirmation strategies
 */ /**
 * This type represents all transaction confirmation strategies
 */ /* @internal */ function $47b9aa0c5fbd17c3$var$assertEndpointUrl(putativeUrl) {
    if (/^https?:/.test(putativeUrl) === false) throw new TypeError("Endpoint URL must start with `http:` or `https:`.");
    return putativeUrl;
}
/** @internal */ function $47b9aa0c5fbd17c3$var$extractCommitmentFromConfig(commitmentOrConfig) {
    var commitment;
    var config;
    if (typeof commitmentOrConfig === "string") commitment = commitmentOrConfig;
    else if (commitmentOrConfig) {
        var specifiedCommitment = commitmentOrConfig.commitment, specifiedConfig = (0, $dRLPW._)(commitmentOrConfig, [
            "commitment"
        ]);
        commitment = specifiedCommitment;
        config = specifiedConfig;
    }
    return {
        commitment: commitment,
        config: config
    };
}
/**
 * @internal
 */ function $47b9aa0c5fbd17c3$var$applyDefaultMemcmpEncodingToFilters(filters) {
    return filters.map(function(filter) {
        var _filter_memcmp_encoding;
        return "memcmp" in filter ? (0, $cxjpp._)((0, $do9pw._)({}, filter), {
            memcmp: (0, $cxjpp._)((0, $do9pw._)({}, filter.memcmp), {
                encoding: (_filter_memcmp_encoding = filter.memcmp.encoding) !== null && _filter_memcmp_encoding !== void 0 ? _filter_memcmp_encoding : "base58"
            })
        }) : filter;
    });
}
/**
 * @internal
 */ function $47b9aa0c5fbd17c3$var$createRpcResult(result) {
    return (0, $58xNN.union)([
        (0, $58xNN.type)({
            jsonrpc: (0, $58xNN.literal)("2.0"),
            id: (0, $58xNN.string)(),
            result: result
        }),
        (0, $58xNN.type)({
            jsonrpc: (0, $58xNN.literal)("2.0"),
            id: (0, $58xNN.string)(),
            error: (0, $58xNN.type)({
                code: (0, $58xNN.unknown)(),
                message: (0, $58xNN.string)(),
                data: (0, $58xNN.optional)((0, $58xNN.any)())
            })
        })
    ]);
}
var $47b9aa0c5fbd17c3$var$UnknownRpcResult = $47b9aa0c5fbd17c3$var$createRpcResult((0, $58xNN.unknown)());
/**
 * @internal
 */ function $47b9aa0c5fbd17c3$var$jsonRpcResult(schema) {
    return (0, $58xNN.coerce)($47b9aa0c5fbd17c3$var$createRpcResult(schema), $47b9aa0c5fbd17c3$var$UnknownRpcResult, function(value) {
        if ("error" in value) return value;
        else return (0, $cxjpp._)((0, $do9pw._)({}, value), {
            result: (0, $58xNN.create)(value.result, schema)
        });
    });
}
/**
 * @internal
 */ function $47b9aa0c5fbd17c3$var$jsonRpcResultAndContext(value) {
    return $47b9aa0c5fbd17c3$var$jsonRpcResult((0, $58xNN.type)({
        context: (0, $58xNN.type)({
            slot: (0, $58xNN.number)()
        }),
        value: value
    }));
}
/**
 * @internal
 */ function $47b9aa0c5fbd17c3$var$notificationResultAndContext(value) {
    return (0, $58xNN.type)({
        context: (0, $58xNN.type)({
            slot: (0, $58xNN.number)()
        }),
        value: value
    });
}
/**
 * @internal
 */ function $47b9aa0c5fbd17c3$var$versionedMessageFromResponse(version, response) {
    if (version === 0) return new $47b9aa0c5fbd17c3$export$ee274c70e0fae590({
        header: response.header,
        staticAccountKeys: response.accountKeys.map(function(accountKey) {
            return new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(accountKey);
        }),
        recentBlockhash: response.recentBlockhash,
        compiledInstructions: response.instructions.map(function(ix) {
            return {
                programIdIndex: ix.programIdIndex,
                accountKeyIndexes: ix.accounts,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($h0PUv))).decode(ix.data)
            };
        }),
        addressTableLookups: response.addressTableLookups
    });
    else return new $47b9aa0c5fbd17c3$export$f69c19e57285b83a(response);
}
/**
 * The level of commitment desired when querying state
 * <pre>
 *   'processed': Query the most recent block which has reached 1 confirmation by the connected node
 *   'confirmed': Query the most recent block which has reached 1 confirmation by the cluster
 *   'finalized': Query the most recent block which has been finalized by the cluster
 * </pre>
 */ // Deprecated as of v1.5.5
/**
 * A subset of Commitment levels, which are at least optimistically confirmed
 * <pre>
 *   'confirmed': Query the most recent block which has reached 1 confirmation by the cluster
 *   'finalized': Query the most recent block which has been finalized by the cluster
 * </pre>
 */ /**
 * Filter for largest accounts query
 * <pre>
 *   'circulating':    Return the largest accounts that are part of the circulating supply
 *   'nonCirculating': Return the largest accounts that are not part of the circulating supply
 * </pre>
 */ /**
 * Configuration object for changing `getAccountInfo` query behavior
 */ /**
 * Configuration object for changing `getBalance` query behavior
 */ /**
 * Configuration object for changing `getBlock` query behavior
 */ /**
 * Configuration object for changing `getBlock` query behavior
 */ /**
 * Configuration object for changing `getStakeMinimumDelegation` query behavior
 */ /**
 * Configuration object for changing `getBlockHeight` query behavior
 */ /**
 * Configuration object for changing `getEpochInfo` query behavior
 */ /**
 * Configuration object for changing `getInflationReward` query behavior
 */ /**
 * Configuration object for changing `getLatestBlockhash` query behavior
 */ /**
 * Configuration object for changing `isBlockhashValid` query behavior
 */ /**
 * Configuration object for changing `getSlot` query behavior
 */ /**
 * Configuration object for changing `getSlotLeader` query behavior
 */ /**
 * Configuration object for changing `getTransaction` query behavior
 */ /**
 * Configuration object for changing `getTransaction` query behavior
 */ /**
 * Configuration object for changing `getLargestAccounts` query behavior
 */ /**
 * Configuration object for changing `getSupply` request behavior
 */ /**
 * Configuration object for changing query behavior
 */ /**
 * Information describing a cluster node
 */ /**
 * Information describing a vote account
 */ /**
 * A collection of cluster vote accounts
 */ /**
 * Network Inflation
 * (see https://docs.solana.com/implemented-proposals/ed_overview)
 */ var $47b9aa0c5fbd17c3$var$GetInflationGovernorResult = (0, $58xNN.type)({
    foundation: (0, $58xNN.number)(),
    foundationTerm: (0, $58xNN.number)(),
    initial: (0, $58xNN.number)(),
    taper: (0, $58xNN.number)(),
    terminal: (0, $58xNN.number)()
});
/**
 * The inflation reward for an epoch
 */ /**
 * Expected JSON RPC response for the "getInflationReward" message
 */ var $47b9aa0c5fbd17c3$var$GetInflationRewardResult = $47b9aa0c5fbd17c3$var$jsonRpcResult((0, $58xNN.array)((0, $58xNN.nullable)((0, $58xNN.type)({
    epoch: (0, $58xNN.number)(),
    effectiveSlot: (0, $58xNN.number)(),
    amount: (0, $58xNN.number)(),
    postBalance: (0, $58xNN.number)(),
    commission: (0, $58xNN.optional)((0, $58xNN.nullable)((0, $58xNN.number)()))
}))));
/**
 * Configuration object for changing `getRecentPrioritizationFees` query behavior
 */ /**
 * Expected JSON RPC response for the "getRecentPrioritizationFees" message
 */ var $47b9aa0c5fbd17c3$var$GetRecentPrioritizationFeesResult = (0, $58xNN.array)((0, $58xNN.type)({
    slot: (0, $58xNN.number)(),
    prioritizationFee: (0, $58xNN.number)()
}));
/**
 * Expected JSON RPC response for the "getInflationRate" message
 */ var $47b9aa0c5fbd17c3$var$GetInflationRateResult = (0, $58xNN.type)({
    total: (0, $58xNN.number)(),
    validator: (0, $58xNN.number)(),
    foundation: (0, $58xNN.number)(),
    epoch: (0, $58xNN.number)()
});
/**
 * Information about the current epoch
 */ var $47b9aa0c5fbd17c3$var$GetEpochInfoResult = (0, $58xNN.type)({
    epoch: (0, $58xNN.number)(),
    slotIndex: (0, $58xNN.number)(),
    slotsInEpoch: (0, $58xNN.number)(),
    absoluteSlot: (0, $58xNN.number)(),
    blockHeight: (0, $58xNN.optional)((0, $58xNN.number)()),
    transactionCount: (0, $58xNN.optional)((0, $58xNN.number)())
});
var $47b9aa0c5fbd17c3$var$GetEpochScheduleResult = (0, $58xNN.type)({
    slotsPerEpoch: (0, $58xNN.number)(),
    leaderScheduleSlotOffset: (0, $58xNN.number)(),
    warmup: (0, $58xNN.boolean)(),
    firstNormalEpoch: (0, $58xNN.number)(),
    firstNormalSlot: (0, $58xNN.number)()
});
/**
 * Leader schedule
 * (see https://docs.solana.com/terminology#leader-schedule)
 */ var $47b9aa0c5fbd17c3$var$GetLeaderScheduleResult = (0, $58xNN.record)((0, $58xNN.string)(), (0, $58xNN.array)((0, $58xNN.number)()));
/**
 * Transaction error or null
 */ var $47b9aa0c5fbd17c3$var$TransactionErrorResult = (0, $58xNN.nullable)((0, $58xNN.union)([
    (0, $58xNN.type)({}),
    (0, $58xNN.string)()
]));
/**
 * Signature status for a transaction
 */ var $47b9aa0c5fbd17c3$var$SignatureStatusResult = (0, $58xNN.type)({
    err: $47b9aa0c5fbd17c3$var$TransactionErrorResult
});
/**
 * Transaction signature received notification
 */ var $47b9aa0c5fbd17c3$var$SignatureReceivedResult = (0, $58xNN.literal)("receivedSignature");
/**
 * Version info for a node
 */ var $47b9aa0c5fbd17c3$var$VersionResult = (0, $58xNN.type)({
    "solana-core": (0, $58xNN.string)(),
    "feature-set": (0, $58xNN.optional)((0, $58xNN.number)())
});
var $47b9aa0c5fbd17c3$var$ParsedInstructionStruct = (0, $58xNN.type)({
    program: (0, $58xNN.string)(),
    programId: $47b9aa0c5fbd17c3$var$PublicKeyFromString,
    parsed: (0, $58xNN.unknown)()
});
var $47b9aa0c5fbd17c3$var$PartiallyDecodedInstructionStruct = (0, $58xNN.type)({
    programId: $47b9aa0c5fbd17c3$var$PublicKeyFromString,
    accounts: (0, $58xNN.array)($47b9aa0c5fbd17c3$var$PublicKeyFromString),
    data: (0, $58xNN.string)()
});
var $47b9aa0c5fbd17c3$var$SimulatedTransactionResponseStruct = $47b9aa0c5fbd17c3$var$jsonRpcResultAndContext((0, $58xNN.type)({
    err: (0, $58xNN.nullable)((0, $58xNN.union)([
        (0, $58xNN.type)({}),
        (0, $58xNN.string)()
    ])),
    logs: (0, $58xNN.nullable)((0, $58xNN.array)((0, $58xNN.string)())),
    accounts: (0, $58xNN.optional)((0, $58xNN.nullable)((0, $58xNN.array)((0, $58xNN.nullable)((0, $58xNN.type)({
        executable: (0, $58xNN.boolean)(),
        owner: (0, $58xNN.string)(),
        lamports: (0, $58xNN.number)(),
        data: (0, $58xNN.array)((0, $58xNN.string)()),
        rentEpoch: (0, $58xNN.optional)((0, $58xNN.number)())
    }))))),
    unitsConsumed: (0, $58xNN.optional)((0, $58xNN.number)()),
    returnData: (0, $58xNN.optional)((0, $58xNN.nullable)((0, $58xNN.type)({
        programId: (0, $58xNN.string)(),
        data: (0, $58xNN.tuple)([
            (0, $58xNN.string)(),
            (0, $58xNN.literal)("base64")
        ])
    }))),
    innerInstructions: (0, $58xNN.optional)((0, $58xNN.nullable)((0, $58xNN.array)((0, $58xNN.type)({
        index: (0, $58xNN.number)(),
        instructions: (0, $58xNN.array)((0, $58xNN.union)([
            $47b9aa0c5fbd17c3$var$ParsedInstructionStruct,
            $47b9aa0c5fbd17c3$var$PartiallyDecodedInstructionStruct
        ]))
    }))))
}));
/**
 * Metadata for a parsed confirmed transaction on the ledger
 *
 * @deprecated Deprecated since RPC v1.8.0. Please use {@link ParsedTransactionMeta} instead.
 */ /**
 * Collection of addresses loaded by a transaction using address table lookups
 */ /**
 * Metadata for a parsed transaction on the ledger
 */ /**
 * Metadata for a confirmed transaction on the ledger
 */ /**
 * A processed transaction from the RPC API
 */ /**
 * A processed transaction from the RPC API
 */ /**
 * A processed transaction message from the RPC API
 */ /**
 * A confirmed transaction on the ledger
 *
 * @deprecated Deprecated since RPC v1.8.0.
 */ /**
 * A partially decoded transaction instruction
 */ /**
 * A parsed transaction message account
 */ /**
 * A parsed transaction instruction
 */ /**
 * A parsed address table lookup
 */ /**
 * A parsed transaction message
 */ /**
 * A parsed transaction
 */ /**
 * A parsed and confirmed transaction on the ledger
 *
 * @deprecated Deprecated since RPC v1.8.0. Please use {@link ParsedTransactionWithMeta} instead.
 */ /**
 * A parsed transaction on the ledger with meta
 */ /**
 * A processed block fetched from the RPC API
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `accounts`
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `none`
 */ /**
 * A block with parsed transactions
 */ /**
 * A block with parsed transactions where the `transactionDetails` mode is `accounts`
 */ /**
 * A block with parsed transactions where the `transactionDetails` mode is `none`
 */ /**
 * A processed block fetched from the RPC API
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `accounts`
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `none`
 */ /**
 * A confirmed block on the ledger
 *
 * @deprecated Deprecated since RPC v1.8.0.
 */ /**
 * A Block on the ledger with signatures only
 */ /**
 * recent block production information
 */ /**
 * Expected JSON RPC response for the "getBlockProduction" message
 */ var $47b9aa0c5fbd17c3$var$BlockProductionResponseStruct = $47b9aa0c5fbd17c3$var$jsonRpcResultAndContext((0, $58xNN.type)({
    byIdentity: (0, $58xNN.record)((0, $58xNN.string)(), (0, $58xNN.array)((0, $58xNN.number)())),
    range: (0, $58xNN.type)({
        firstSlot: (0, $58xNN.number)(),
        lastSlot: (0, $58xNN.number)()
    })
}));
/**
 * A performance sample
 */ function $47b9aa0c5fbd17c3$var$createRpcClient(url, httpHeaders, customFetch, fetchMiddleware, disableRetryOnRateLimit, httpAgent) {
    var fetch = customFetch ? customFetch : $47b9aa0c5fbd17c3$var$fetchImpl;
    var agent;
    if (httpAgent != null) console.warn("You have supplied an `httpAgent` when creating a `Connection` in a browser environment.It has been ignored; `httpAgent` is only used in Node environments.");
    var fetchWithMiddleware;
    if (fetchMiddleware) fetchWithMiddleware = function() {
        var _ref = (0, $kSuI9._)(function(info, init) {
            var modifiedFetchArgs;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            new Promise(function(resolve, reject) {
                                try {
                                    fetchMiddleware(info, init, function(modifiedInfo, modifiedInit) {
                                        return resolve([
                                            modifiedInfo,
                                            modifiedInit
                                        ]);
                                    });
                                } catch (error) {
                                    reject(error);
                                }
                            })
                        ];
                    case 1:
                        modifiedFetchArgs = _state.sent();
                        return [
                            4,
                            fetch.apply(void 0, (0, $c6Xmf._)(modifiedFetchArgs))
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(info, init) {
            return _ref.apply(this, arguments);
        };
    }();
    var clientBrowser = new (0, (/*@__PURE__*/$parcel$interopDefault($cwYMR)))(function() {
        var _ref = (0, $kSuI9._)(function(request, callback) {
            var options, too_many_requests_retries, res, waitTime, text, err;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        options = {
                            method: "POST",
                            body: request,
                            agent: agent,
                            headers: Object.assign({
                                "Content-Type": "application/json"
                            }, httpHeaders || {}, $47b9aa0c5fbd17c3$var$COMMON_HTTP_HEADERS)
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            11,
                            ,
                            12
                        ]);
                        too_many_requests_retries = 5;
                        waitTime = 500;
                        _state.label = 2;
                    case 2:
                        if (!fetchWithMiddleware) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            fetchWithMiddleware(url, options)
                        ];
                    case 3:
                        res = _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 4:
                        return [
                            4,
                            fetch(url, options)
                        ];
                    case 5:
                        res = _state.sent();
                        _state.label = 6;
                    case 6:
                        if (res.status !== 429 /* Too many requests */ ) return [
                            3,
                            9
                        ];
                        if (disableRetryOnRateLimit === true) return [
                            3,
                            9
                        ];
                        too_many_requests_retries -= 1;
                        if (too_many_requests_retries === 0) return [
                            3,
                            9
                        ];
                        console.error("Server responded with ".concat(res.status, " ").concat(res.statusText, ".  Retrying after ").concat(waitTime, "ms delay..."));
                        return [
                            4,
                            $47b9aa0c5fbd17c3$var$sleep(waitTime)
                        ];
                    case 7:
                        _state.sent();
                        waitTime *= 2;
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            2
                        ];
                    case 9:
                        return [
                            4,
                            res.text()
                        ];
                    case 10:
                        text = _state.sent();
                        if (res.ok) callback(null, text);
                        else callback(new Error("".concat(res.status, " ").concat(res.statusText, ": ").concat(text)));
                        return [
                            3,
                            12
                        ];
                    case 11:
                        err = _state.sent();
                        if (err instanceof Error) callback(err);
                        return [
                            3,
                            12
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        });
        return function(request, callback) {
            return _ref.apply(this, arguments);
        };
    }(), {});
    return clientBrowser;
}
function $47b9aa0c5fbd17c3$var$createRpcRequest(client) {
    return function(method, args) {
        return new Promise(function(resolve, reject) {
            client.request(method, args, function(err, response) {
                if (err) {
                    reject(err);
                    return;
                }
                resolve(response);
            });
        });
    };
}
function $47b9aa0c5fbd17c3$var$createRpcBatchRequest(client) {
    return function(requests) {
        return new Promise(function(resolve, reject) {
            // Do nothing if requests is empty
            if (requests.length === 0) resolve([]);
            var batch = requests.map(function(params) {
                return client.request(params.methodName, params.args);
            });
            client.request(batch, function(err, response) {
                if (err) {
                    reject(err);
                    return;
                }
                resolve(response);
            });
        });
    };
}
/**
 * Expected JSON RPC response for the "getInflationGovernor" message
 */ var $47b9aa0c5fbd17c3$var$GetInflationGovernorRpcResult = $47b9aa0c5fbd17c3$var$jsonRpcResult($47b9aa0c5fbd17c3$var$GetInflationGovernorResult);
/**
 * Expected JSON RPC response for the "getInflationRate" message
 */ var $47b9aa0c5fbd17c3$var$GetInflationRateRpcResult = $47b9aa0c5fbd17c3$var$jsonRpcResult($47b9aa0c5fbd17c3$var$GetInflationRateResult);
/**
 * Expected JSON RPC response for the "getRecentPrioritizationFees" message
 */ var $47b9aa0c5fbd17c3$var$GetRecentPrioritizationFeesRpcResult = $47b9aa0c5fbd17c3$var$jsonRpcResult($47b9aa0c5fbd17c3$var$GetRecentPrioritizationFeesResult);
/**
 * Expected JSON RPC response for the "getEpochInfo" message
 */ var $47b9aa0c5fbd17c3$var$GetEpochInfoRpcResult = $47b9aa0c5fbd17c3$var$jsonRpcResult($47b9aa0c5fbd17c3$var$GetEpochInfoResult);
/**
 * Expected JSON RPC response for the "getEpochSchedule" message
 */ var $47b9aa0c5fbd17c3$var$GetEpochScheduleRpcResult = $47b9aa0c5fbd17c3$var$jsonRpcResult($47b9aa0c5fbd17c3$var$GetEpochScheduleResult);
/**
 * Expected JSON RPC response for the "getLeaderSchedule" message
 */ var $47b9aa0c5fbd17c3$var$GetLeaderScheduleRpcResult = $47b9aa0c5fbd17c3$var$jsonRpcResult($47b9aa0c5fbd17c3$var$GetLeaderScheduleResult);
/**
 * Expected JSON RPC response for the "minimumLedgerSlot" and "getFirstAvailableBlock" messages
 */ var $47b9aa0c5fbd17c3$var$SlotRpcResult = $47b9aa0c5fbd17c3$var$jsonRpcResult((0, $58xNN.number)());
/**
 * Supply
 */ /**
 * Expected JSON RPC response for the "getSupply" message
 */ var $47b9aa0c5fbd17c3$var$GetSupplyRpcResult = $47b9aa0c5fbd17c3$var$jsonRpcResultAndContext((0, $58xNN.type)({
    total: (0, $58xNN.number)(),
    circulating: (0, $58xNN.number)(),
    nonCirculating: (0, $58xNN.number)(),
    nonCirculatingAccounts: (0, $58xNN.array)($47b9aa0c5fbd17c3$var$PublicKeyFromString)
}));
/**
 * Token amount object which returns a token amount in different formats
 * for various client use cases.
 */ /**
 * Expected JSON RPC structure for token amounts
 */ var $47b9aa0c5fbd17c3$var$TokenAmountResult = (0, $58xNN.type)({
    amount: (0, $58xNN.string)(),
    uiAmount: (0, $58xNN.nullable)((0, $58xNN.number)()),
    decimals: (0, $58xNN.number)(),
    uiAmountString: (0, $58xNN.optional)((0, $58xNN.string)())
});
/**
 * Token address and balance.
 */ /**
 * Expected JSON RPC response for the "getTokenLargestAccounts" message
 */ var $47b9aa0c5fbd17c3$var$GetTokenLargestAccountsResult = $47b9aa0c5fbd17c3$var$jsonRpcResultAndContext((0, $58xNN.array)((0, $58xNN.type)({
    address: $47b9aa0c5fbd17c3$var$PublicKeyFromString,
    amount: (0, $58xNN.string)(),
    uiAmount: (0, $58xNN.nullable)((0, $58xNN.number)()),
    decimals: (0, $58xNN.number)(),
    uiAmountString: (0, $58xNN.optional)((0, $58xNN.string)())
})));
/**
 * Expected JSON RPC response for the "getTokenAccountsByOwner" message
 */ var $47b9aa0c5fbd17c3$var$GetTokenAccountsByOwner = $47b9aa0c5fbd17c3$var$jsonRpcResultAndContext((0, $58xNN.array)((0, $58xNN.type)({
    pubkey: $47b9aa0c5fbd17c3$var$PublicKeyFromString,
    account: (0, $58xNN.type)({
        executable: (0, $58xNN.boolean)(),
        owner: $47b9aa0c5fbd17c3$var$PublicKeyFromString,
        lamports: (0, $58xNN.number)(),
        data: $47b9aa0c5fbd17c3$var$BufferFromRawAccountData,
        rentEpoch: (0, $58xNN.number)()
    })
})));
var $47b9aa0c5fbd17c3$var$ParsedAccountDataResult = (0, $58xNN.type)({
    program: (0, $58xNN.string)(),
    parsed: (0, $58xNN.unknown)(),
    space: (0, $58xNN.number)()
});
/**
 * Expected JSON RPC response for the "getTokenAccountsByOwner" message with parsed data
 */ var $47b9aa0c5fbd17c3$var$GetParsedTokenAccountsByOwner = $47b9aa0c5fbd17c3$var$jsonRpcResultAndContext((0, $58xNN.array)((0, $58xNN.type)({
    pubkey: $47b9aa0c5fbd17c3$var$PublicKeyFromString,
    account: (0, $58xNN.type)({
        executable: (0, $58xNN.boolean)(),
        owner: $47b9aa0c5fbd17c3$var$PublicKeyFromString,
        lamports: (0, $58xNN.number)(),
        data: $47b9aa0c5fbd17c3$var$ParsedAccountDataResult,
        rentEpoch: (0, $58xNN.number)()
    })
})));
/**
 * Pair of an account address and its balance
 */ /**
 * Expected JSON RPC response for the "getLargestAccounts" message
 */ var $47b9aa0c5fbd17c3$var$GetLargestAccountsRpcResult = $47b9aa0c5fbd17c3$var$jsonRpcResultAndContext((0, $58xNN.array)((0, $58xNN.type)({
    lamports: (0, $58xNN.number)(),
    address: $47b9aa0c5fbd17c3$var$PublicKeyFromString
})));
/**
 * @internal
 */ var $47b9aa0c5fbd17c3$var$AccountInfoResult = (0, $58xNN.type)({
    executable: (0, $58xNN.boolean)(),
    owner: $47b9aa0c5fbd17c3$var$PublicKeyFromString,
    lamports: (0, $58xNN.number)(),
    data: $47b9aa0c5fbd17c3$var$BufferFromRawAccountData,
    rentEpoch: (0, $58xNN.number)()
});
/**
 * @internal
 */ var $47b9aa0c5fbd17c3$var$KeyedAccountInfoResult = (0, $58xNN.type)({
    pubkey: $47b9aa0c5fbd17c3$var$PublicKeyFromString,
    account: $47b9aa0c5fbd17c3$var$AccountInfoResult
});
var $47b9aa0c5fbd17c3$var$ParsedOrRawAccountData = (0, $58xNN.coerce)((0, $58xNN.union)([
    (0, $58xNN.instance)((0, $8dlmd.Buffer)),
    $47b9aa0c5fbd17c3$var$ParsedAccountDataResult
]), (0, $58xNN.union)([
    $47b9aa0c5fbd17c3$var$RawAccountDataResult,
    $47b9aa0c5fbd17c3$var$ParsedAccountDataResult
]), function(value) {
    if (Array.isArray(value)) return (0, $58xNN.create)(value, $47b9aa0c5fbd17c3$var$BufferFromRawAccountData);
    else return value;
});
/**
 * @internal
 */ var $47b9aa0c5fbd17c3$var$ParsedAccountInfoResult = (0, $58xNN.type)({
    executable: (0, $58xNN.boolean)(),
    owner: $47b9aa0c5fbd17c3$var$PublicKeyFromString,
    lamports: (0, $58xNN.number)(),
    data: $47b9aa0c5fbd17c3$var$ParsedOrRawAccountData,
    rentEpoch: (0, $58xNN.number)()
});
var $47b9aa0c5fbd17c3$var$KeyedParsedAccountInfoResult = (0, $58xNN.type)({
    pubkey: $47b9aa0c5fbd17c3$var$PublicKeyFromString,
    account: $47b9aa0c5fbd17c3$var$ParsedAccountInfoResult
});
/**
 * @internal
 */ var $47b9aa0c5fbd17c3$var$StakeActivationResult = (0, $58xNN.type)({
    state: (0, $58xNN.union)([
        (0, $58xNN.literal)("active"),
        (0, $58xNN.literal)("inactive"),
        (0, $58xNN.literal)("activating"),
        (0, $58xNN.literal)("deactivating")
    ]),
    active: (0, $58xNN.number)(),
    inactive: (0, $58xNN.number)()
});
/**
 * Expected JSON RPC response for the "getConfirmedSignaturesForAddress2" message
 */ var $47b9aa0c5fbd17c3$var$GetConfirmedSignaturesForAddress2RpcResult = $47b9aa0c5fbd17c3$var$jsonRpcResult((0, $58xNN.array)((0, $58xNN.type)({
    signature: (0, $58xNN.string)(),
    slot: (0, $58xNN.number)(),
    err: $47b9aa0c5fbd17c3$var$TransactionErrorResult,
    memo: (0, $58xNN.nullable)((0, $58xNN.string)()),
    blockTime: (0, $58xNN.optional)((0, $58xNN.nullable)((0, $58xNN.number)()))
})));
/**
 * Expected JSON RPC response for the "getSignaturesForAddress" message
 */ var $47b9aa0c5fbd17c3$var$GetSignaturesForAddressRpcResult = $47b9aa0c5fbd17c3$var$jsonRpcResult((0, $58xNN.array)((0, $58xNN.type)({
    signature: (0, $58xNN.string)(),
    slot: (0, $58xNN.number)(),
    err: $47b9aa0c5fbd17c3$var$TransactionErrorResult,
    memo: (0, $58xNN.nullable)((0, $58xNN.string)()),
    blockTime: (0, $58xNN.optional)((0, $58xNN.nullable)((0, $58xNN.number)()))
})));
/***
 * Expected JSON RPC response for the "accountNotification" message
 */ var $47b9aa0c5fbd17c3$var$AccountNotificationResult = (0, $58xNN.type)({
    subscription: (0, $58xNN.number)(),
    result: $47b9aa0c5fbd17c3$var$notificationResultAndContext($47b9aa0c5fbd17c3$var$AccountInfoResult)
});
/**
 * @internal
 */ var $47b9aa0c5fbd17c3$var$ProgramAccountInfoResult = (0, $58xNN.type)({
    pubkey: $47b9aa0c5fbd17c3$var$PublicKeyFromString,
    account: $47b9aa0c5fbd17c3$var$AccountInfoResult
});
/***
 * Expected JSON RPC response for the "programNotification" message
 */ var $47b9aa0c5fbd17c3$var$ProgramAccountNotificationResult = (0, $58xNN.type)({
    subscription: (0, $58xNN.number)(),
    result: $47b9aa0c5fbd17c3$var$notificationResultAndContext($47b9aa0c5fbd17c3$var$ProgramAccountInfoResult)
});
/**
 * @internal
 */ var $47b9aa0c5fbd17c3$var$SlotInfoResult = (0, $58xNN.type)({
    parent: (0, $58xNN.number)(),
    slot: (0, $58xNN.number)(),
    root: (0, $58xNN.number)()
});
/**
 * Expected JSON RPC response for the "slotNotification" message
 */ var $47b9aa0c5fbd17c3$var$SlotNotificationResult = (0, $58xNN.type)({
    subscription: (0, $58xNN.number)(),
    result: $47b9aa0c5fbd17c3$var$SlotInfoResult
});
/**
 * Slot updates which can be used for tracking the live progress of a cluster.
 * - `"firstShredReceived"`: connected node received the first shred of a block.
 * Indicates that a new block that is being produced.
 * - `"completed"`: connected node has received all shreds of a block. Indicates
 * a block was recently produced.
 * - `"optimisticConfirmation"`: block was optimistically confirmed by the
 * cluster. It is not guaranteed that an optimistic confirmation notification
 * will be sent for every finalized blocks.
 * - `"root"`: the connected node rooted this block.
 * - `"createdBank"`: the connected node has started validating this block.
 * - `"frozen"`: the connected node has validated this block.
 * - `"dead"`: the connected node failed to validate this block.
 */ /**
 * @internal
 */ var $47b9aa0c5fbd17c3$var$SlotUpdateResult = (0, $58xNN.union)([
    (0, $58xNN.type)({
        type: (0, $58xNN.union)([
            (0, $58xNN.literal)("firstShredReceived"),
            (0, $58xNN.literal)("completed"),
            (0, $58xNN.literal)("optimisticConfirmation"),
            (0, $58xNN.literal)("root")
        ]),
        slot: (0, $58xNN.number)(),
        timestamp: (0, $58xNN.number)()
    }),
    (0, $58xNN.type)({
        type: (0, $58xNN.literal)("createdBank"),
        parent: (0, $58xNN.number)(),
        slot: (0, $58xNN.number)(),
        timestamp: (0, $58xNN.number)()
    }),
    (0, $58xNN.type)({
        type: (0, $58xNN.literal)("frozen"),
        slot: (0, $58xNN.number)(),
        timestamp: (0, $58xNN.number)(),
        stats: (0, $58xNN.type)({
            numTransactionEntries: (0, $58xNN.number)(),
            numSuccessfulTransactions: (0, $58xNN.number)(),
            numFailedTransactions: (0, $58xNN.number)(),
            maxTransactionsPerEntry: (0, $58xNN.number)()
        })
    }),
    (0, $58xNN.type)({
        type: (0, $58xNN.literal)("dead"),
        slot: (0, $58xNN.number)(),
        timestamp: (0, $58xNN.number)(),
        err: (0, $58xNN.string)()
    })
]);
/**
 * Expected JSON RPC response for the "slotsUpdatesNotification" message
 */ var $47b9aa0c5fbd17c3$var$SlotUpdateNotificationResult = (0, $58xNN.type)({
    subscription: (0, $58xNN.number)(),
    result: $47b9aa0c5fbd17c3$var$SlotUpdateResult
});
/**
 * Expected JSON RPC response for the "signatureNotification" message
 */ var $47b9aa0c5fbd17c3$var$SignatureNotificationResult = (0, $58xNN.type)({
    subscription: (0, $58xNN.number)(),
    result: $47b9aa0c5fbd17c3$var$notificationResultAndContext((0, $58xNN.union)([
        $47b9aa0c5fbd17c3$var$SignatureStatusResult,
        $47b9aa0c5fbd17c3$var$SignatureReceivedResult
    ]))
});
/**
 * Expected JSON RPC response for the "rootNotification" message
 */ var $47b9aa0c5fbd17c3$var$RootNotificationResult = (0, $58xNN.type)({
    subscription: (0, $58xNN.number)(),
    result: (0, $58xNN.number)()
});
var $47b9aa0c5fbd17c3$var$ContactInfoResult = (0, $58xNN.type)({
    pubkey: (0, $58xNN.string)(),
    gossip: (0, $58xNN.nullable)((0, $58xNN.string)()),
    tpu: (0, $58xNN.nullable)((0, $58xNN.string)()),
    rpc: (0, $58xNN.nullable)((0, $58xNN.string)()),
    version: (0, $58xNN.nullable)((0, $58xNN.string)())
});
var $47b9aa0c5fbd17c3$var$VoteAccountInfoResult = (0, $58xNN.type)({
    votePubkey: (0, $58xNN.string)(),
    nodePubkey: (0, $58xNN.string)(),
    activatedStake: (0, $58xNN.number)(),
    epochVoteAccount: (0, $58xNN.boolean)(),
    epochCredits: (0, $58xNN.array)((0, $58xNN.tuple)([
        (0, $58xNN.number)(),
        (0, $58xNN.number)(),
        (0, $58xNN.number)()
    ])),
    commission: (0, $58xNN.number)(),
    lastVote: (0, $58xNN.number)(),
    rootSlot: (0, $58xNN.nullable)((0, $58xNN.number)())
});
/**
 * Expected JSON RPC response for the "getVoteAccounts" message
 */ var $47b9aa0c5fbd17c3$var$GetVoteAccounts = $47b9aa0c5fbd17c3$var$jsonRpcResult((0, $58xNN.type)({
    current: (0, $58xNN.array)($47b9aa0c5fbd17c3$var$VoteAccountInfoResult),
    delinquent: (0, $58xNN.array)($47b9aa0c5fbd17c3$var$VoteAccountInfoResult)
}));
var $47b9aa0c5fbd17c3$var$ConfirmationStatus = (0, $58xNN.union)([
    (0, $58xNN.literal)("processed"),
    (0, $58xNN.literal)("confirmed"),
    (0, $58xNN.literal)("finalized")
]);
var $47b9aa0c5fbd17c3$var$SignatureStatusResponse = (0, $58xNN.type)({
    slot: (0, $58xNN.number)(),
    confirmations: (0, $58xNN.nullable)((0, $58xNN.number)()),
    err: $47b9aa0c5fbd17c3$var$TransactionErrorResult,
    confirmationStatus: (0, $58xNN.optional)($47b9aa0c5fbd17c3$var$ConfirmationStatus)
});
/**
 * Expected JSON RPC response for the "getSignatureStatuses" message
 */ var $47b9aa0c5fbd17c3$var$GetSignatureStatusesRpcResult = $47b9aa0c5fbd17c3$var$jsonRpcResultAndContext((0, $58xNN.array)((0, $58xNN.nullable)($47b9aa0c5fbd17c3$var$SignatureStatusResponse)));
/**
 * Expected JSON RPC response for the "getMinimumBalanceForRentExemption" message
 */ var $47b9aa0c5fbd17c3$var$GetMinimumBalanceForRentExemptionRpcResult = $47b9aa0c5fbd17c3$var$jsonRpcResult((0, $58xNN.number)());
var $47b9aa0c5fbd17c3$var$AddressTableLookupStruct = (0, $58xNN.type)({
    accountKey: $47b9aa0c5fbd17c3$var$PublicKeyFromString,
    writableIndexes: (0, $58xNN.array)((0, $58xNN.number)()),
    readonlyIndexes: (0, $58xNN.array)((0, $58xNN.number)())
});
var $47b9aa0c5fbd17c3$var$ConfirmedTransactionResult = (0, $58xNN.type)({
    signatures: (0, $58xNN.array)((0, $58xNN.string)()),
    message: (0, $58xNN.type)({
        accountKeys: (0, $58xNN.array)((0, $58xNN.string)()),
        header: (0, $58xNN.type)({
            numRequiredSignatures: (0, $58xNN.number)(),
            numReadonlySignedAccounts: (0, $58xNN.number)(),
            numReadonlyUnsignedAccounts: (0, $58xNN.number)()
        }),
        instructions: (0, $58xNN.array)((0, $58xNN.type)({
            accounts: (0, $58xNN.array)((0, $58xNN.number)()),
            data: (0, $58xNN.string)(),
            programIdIndex: (0, $58xNN.number)()
        })),
        recentBlockhash: (0, $58xNN.string)(),
        addressTableLookups: (0, $58xNN.optional)((0, $58xNN.array)($47b9aa0c5fbd17c3$var$AddressTableLookupStruct))
    })
});
var $47b9aa0c5fbd17c3$var$AnnotatedAccountKey = (0, $58xNN.type)({
    pubkey: $47b9aa0c5fbd17c3$var$PublicKeyFromString,
    signer: (0, $58xNN.boolean)(),
    writable: (0, $58xNN.boolean)(),
    source: (0, $58xNN.optional)((0, $58xNN.union)([
        (0, $58xNN.literal)("transaction"),
        (0, $58xNN.literal)("lookupTable")
    ]))
});
var $47b9aa0c5fbd17c3$var$ConfirmedTransactionAccountsModeResult = (0, $58xNN.type)({
    accountKeys: (0, $58xNN.array)($47b9aa0c5fbd17c3$var$AnnotatedAccountKey),
    signatures: (0, $58xNN.array)((0, $58xNN.string)())
});
var $47b9aa0c5fbd17c3$var$ParsedInstructionResult = (0, $58xNN.type)({
    parsed: (0, $58xNN.unknown)(),
    program: (0, $58xNN.string)(),
    programId: $47b9aa0c5fbd17c3$var$PublicKeyFromString
});
var $47b9aa0c5fbd17c3$var$RawInstructionResult = (0, $58xNN.type)({
    accounts: (0, $58xNN.array)($47b9aa0c5fbd17c3$var$PublicKeyFromString),
    data: (0, $58xNN.string)(),
    programId: $47b9aa0c5fbd17c3$var$PublicKeyFromString
});
var $47b9aa0c5fbd17c3$var$InstructionResult = (0, $58xNN.union)([
    $47b9aa0c5fbd17c3$var$RawInstructionResult,
    $47b9aa0c5fbd17c3$var$ParsedInstructionResult
]);
var $47b9aa0c5fbd17c3$var$UnknownInstructionResult = (0, $58xNN.union)([
    (0, $58xNN.type)({
        parsed: (0, $58xNN.unknown)(),
        program: (0, $58xNN.string)(),
        programId: (0, $58xNN.string)()
    }),
    (0, $58xNN.type)({
        accounts: (0, $58xNN.array)((0, $58xNN.string)()),
        data: (0, $58xNN.string)(),
        programId: (0, $58xNN.string)()
    })
]);
var $47b9aa0c5fbd17c3$var$ParsedOrRawInstruction = (0, $58xNN.coerce)($47b9aa0c5fbd17c3$var$InstructionResult, $47b9aa0c5fbd17c3$var$UnknownInstructionResult, function(value) {
    if ("accounts" in value) return (0, $58xNN.create)(value, $47b9aa0c5fbd17c3$var$RawInstructionResult);
    else return (0, $58xNN.create)(value, $47b9aa0c5fbd17c3$var$ParsedInstructionResult);
});
/**
 * @internal
 */ var $47b9aa0c5fbd17c3$var$ParsedConfirmedTransactionResult = (0, $58xNN.type)({
    signatures: (0, $58xNN.array)((0, $58xNN.string)()),
    message: (0, $58xNN.type)({
        accountKeys: (0, $58xNN.array)($47b9aa0c5fbd17c3$var$AnnotatedAccountKey),
        instructions: (0, $58xNN.array)($47b9aa0c5fbd17c3$var$ParsedOrRawInstruction),
        recentBlockhash: (0, $58xNN.string)(),
        addressTableLookups: (0, $58xNN.optional)((0, $58xNN.nullable)((0, $58xNN.array)($47b9aa0c5fbd17c3$var$AddressTableLookupStruct)))
    })
});
var $47b9aa0c5fbd17c3$var$TokenBalanceResult = (0, $58xNN.type)({
    accountIndex: (0, $58xNN.number)(),
    mint: (0, $58xNN.string)(),
    owner: (0, $58xNN.optional)((0, $58xNN.string)()),
    uiTokenAmount: $47b9aa0c5fbd17c3$var$TokenAmountResult
});
var $47b9aa0c5fbd17c3$var$LoadedAddressesResult = (0, $58xNN.type)({
    writable: (0, $58xNN.array)($47b9aa0c5fbd17c3$var$PublicKeyFromString),
    readonly: (0, $58xNN.array)($47b9aa0c5fbd17c3$var$PublicKeyFromString)
});
/**
 * @internal
 */ var $47b9aa0c5fbd17c3$var$ConfirmedTransactionMetaResult = (0, $58xNN.type)({
    err: $47b9aa0c5fbd17c3$var$TransactionErrorResult,
    fee: (0, $58xNN.number)(),
    innerInstructions: (0, $58xNN.optional)((0, $58xNN.nullable)((0, $58xNN.array)((0, $58xNN.type)({
        index: (0, $58xNN.number)(),
        instructions: (0, $58xNN.array)((0, $58xNN.type)({
            accounts: (0, $58xNN.array)((0, $58xNN.number)()),
            data: (0, $58xNN.string)(),
            programIdIndex: (0, $58xNN.number)()
        }))
    })))),
    preBalances: (0, $58xNN.array)((0, $58xNN.number)()),
    postBalances: (0, $58xNN.array)((0, $58xNN.number)()),
    logMessages: (0, $58xNN.optional)((0, $58xNN.nullable)((0, $58xNN.array)((0, $58xNN.string)()))),
    preTokenBalances: (0, $58xNN.optional)((0, $58xNN.nullable)((0, $58xNN.array)($47b9aa0c5fbd17c3$var$TokenBalanceResult))),
    postTokenBalances: (0, $58xNN.optional)((0, $58xNN.nullable)((0, $58xNN.array)($47b9aa0c5fbd17c3$var$TokenBalanceResult))),
    loadedAddresses: (0, $58xNN.optional)($47b9aa0c5fbd17c3$var$LoadedAddressesResult),
    computeUnitsConsumed: (0, $58xNN.optional)((0, $58xNN.number)())
});
/**
 * @internal
 */ var $47b9aa0c5fbd17c3$var$ParsedConfirmedTransactionMetaResult = (0, $58xNN.type)({
    err: $47b9aa0c5fbd17c3$var$TransactionErrorResult,
    fee: (0, $58xNN.number)(),
    innerInstructions: (0, $58xNN.optional)((0, $58xNN.nullable)((0, $58xNN.array)((0, $58xNN.type)({
        index: (0, $58xNN.number)(),
        instructions: (0, $58xNN.array)($47b9aa0c5fbd17c3$var$ParsedOrRawInstruction)
    })))),
    preBalances: (0, $58xNN.array)((0, $58xNN.number)()),
    postBalances: (0, $58xNN.array)((0, $58xNN.number)()),
    logMessages: (0, $58xNN.optional)((0, $58xNN.nullable)((0, $58xNN.array)((0, $58xNN.string)()))),
    preTokenBalances: (0, $58xNN.optional)((0, $58xNN.nullable)((0, $58xNN.array)($47b9aa0c5fbd17c3$var$TokenBalanceResult))),
    postTokenBalances: (0, $58xNN.optional)((0, $58xNN.nullable)((0, $58xNN.array)($47b9aa0c5fbd17c3$var$TokenBalanceResult))),
    loadedAddresses: (0, $58xNN.optional)($47b9aa0c5fbd17c3$var$LoadedAddressesResult),
    computeUnitsConsumed: (0, $58xNN.optional)((0, $58xNN.number)())
});
var $47b9aa0c5fbd17c3$var$TransactionVersionStruct = (0, $58xNN.union)([
    (0, $58xNN.literal)(0),
    (0, $58xNN.literal)("legacy")
]);
/** @internal */ var $47b9aa0c5fbd17c3$var$RewardsResult = (0, $58xNN.type)({
    pubkey: (0, $58xNN.string)(),
    lamports: (0, $58xNN.number)(),
    postBalance: (0, $58xNN.nullable)((0, $58xNN.number)()),
    rewardType: (0, $58xNN.nullable)((0, $58xNN.string)()),
    commission: (0, $58xNN.optional)((0, $58xNN.nullable)((0, $58xNN.number)()))
});
/**
 * Expected JSON RPC response for the "getBlock" message
 */ var $47b9aa0c5fbd17c3$var$GetBlockRpcResult = $47b9aa0c5fbd17c3$var$jsonRpcResult((0, $58xNN.nullable)((0, $58xNN.type)({
    blockhash: (0, $58xNN.string)(),
    previousBlockhash: (0, $58xNN.string)(),
    parentSlot: (0, $58xNN.number)(),
    transactions: (0, $58xNN.array)((0, $58xNN.type)({
        transaction: $47b9aa0c5fbd17c3$var$ConfirmedTransactionResult,
        meta: (0, $58xNN.nullable)($47b9aa0c5fbd17c3$var$ConfirmedTransactionMetaResult),
        version: (0, $58xNN.optional)($47b9aa0c5fbd17c3$var$TransactionVersionStruct)
    })),
    rewards: (0, $58xNN.optional)((0, $58xNN.array)($47b9aa0c5fbd17c3$var$RewardsResult)),
    blockTime: (0, $58xNN.nullable)((0, $58xNN.number)()),
    blockHeight: (0, $58xNN.nullable)((0, $58xNN.number)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message when `transactionDetails` is `none`
 */ var $47b9aa0c5fbd17c3$var$GetNoneModeBlockRpcResult = $47b9aa0c5fbd17c3$var$jsonRpcResult((0, $58xNN.nullable)((0, $58xNN.type)({
    blockhash: (0, $58xNN.string)(),
    previousBlockhash: (0, $58xNN.string)(),
    parentSlot: (0, $58xNN.number)(),
    rewards: (0, $58xNN.optional)((0, $58xNN.array)($47b9aa0c5fbd17c3$var$RewardsResult)),
    blockTime: (0, $58xNN.nullable)((0, $58xNN.number)()),
    blockHeight: (0, $58xNN.nullable)((0, $58xNN.number)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message when `transactionDetails` is `accounts`
 */ var $47b9aa0c5fbd17c3$var$GetAccountsModeBlockRpcResult = $47b9aa0c5fbd17c3$var$jsonRpcResult((0, $58xNN.nullable)((0, $58xNN.type)({
    blockhash: (0, $58xNN.string)(),
    previousBlockhash: (0, $58xNN.string)(),
    parentSlot: (0, $58xNN.number)(),
    transactions: (0, $58xNN.array)((0, $58xNN.type)({
        transaction: $47b9aa0c5fbd17c3$var$ConfirmedTransactionAccountsModeResult,
        meta: (0, $58xNN.nullable)($47b9aa0c5fbd17c3$var$ConfirmedTransactionMetaResult),
        version: (0, $58xNN.optional)($47b9aa0c5fbd17c3$var$TransactionVersionStruct)
    })),
    rewards: (0, $58xNN.optional)((0, $58xNN.array)($47b9aa0c5fbd17c3$var$RewardsResult)),
    blockTime: (0, $58xNN.nullable)((0, $58xNN.number)()),
    blockHeight: (0, $58xNN.nullable)((0, $58xNN.number)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message
 */ var $47b9aa0c5fbd17c3$var$GetParsedBlockRpcResult = $47b9aa0c5fbd17c3$var$jsonRpcResult((0, $58xNN.nullable)((0, $58xNN.type)({
    blockhash: (0, $58xNN.string)(),
    previousBlockhash: (0, $58xNN.string)(),
    parentSlot: (0, $58xNN.number)(),
    transactions: (0, $58xNN.array)((0, $58xNN.type)({
        transaction: $47b9aa0c5fbd17c3$var$ParsedConfirmedTransactionResult,
        meta: (0, $58xNN.nullable)($47b9aa0c5fbd17c3$var$ParsedConfirmedTransactionMetaResult),
        version: (0, $58xNN.optional)($47b9aa0c5fbd17c3$var$TransactionVersionStruct)
    })),
    rewards: (0, $58xNN.optional)((0, $58xNN.array)($47b9aa0c5fbd17c3$var$RewardsResult)),
    blockTime: (0, $58xNN.nullable)((0, $58xNN.number)()),
    blockHeight: (0, $58xNN.nullable)((0, $58xNN.number)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message  when `transactionDetails` is `accounts`
 */ var $47b9aa0c5fbd17c3$var$GetParsedAccountsModeBlockRpcResult = $47b9aa0c5fbd17c3$var$jsonRpcResult((0, $58xNN.nullable)((0, $58xNN.type)({
    blockhash: (0, $58xNN.string)(),
    previousBlockhash: (0, $58xNN.string)(),
    parentSlot: (0, $58xNN.number)(),
    transactions: (0, $58xNN.array)((0, $58xNN.type)({
        transaction: $47b9aa0c5fbd17c3$var$ConfirmedTransactionAccountsModeResult,
        meta: (0, $58xNN.nullable)($47b9aa0c5fbd17c3$var$ParsedConfirmedTransactionMetaResult),
        version: (0, $58xNN.optional)($47b9aa0c5fbd17c3$var$TransactionVersionStruct)
    })),
    rewards: (0, $58xNN.optional)((0, $58xNN.array)($47b9aa0c5fbd17c3$var$RewardsResult)),
    blockTime: (0, $58xNN.nullable)((0, $58xNN.number)()),
    blockHeight: (0, $58xNN.nullable)((0, $58xNN.number)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message  when `transactionDetails` is `none`
 */ var $47b9aa0c5fbd17c3$var$GetParsedNoneModeBlockRpcResult = $47b9aa0c5fbd17c3$var$jsonRpcResult((0, $58xNN.nullable)((0, $58xNN.type)({
    blockhash: (0, $58xNN.string)(),
    previousBlockhash: (0, $58xNN.string)(),
    parentSlot: (0, $58xNN.number)(),
    rewards: (0, $58xNN.optional)((0, $58xNN.array)($47b9aa0c5fbd17c3$var$RewardsResult)),
    blockTime: (0, $58xNN.nullable)((0, $58xNN.number)()),
    blockHeight: (0, $58xNN.nullable)((0, $58xNN.number)())
})));
/**
 * Expected JSON RPC response for the "getConfirmedBlock" message
 *
 * @deprecated Deprecated since RPC v1.8.0. Please use {@link GetBlockRpcResult} instead.
 */ var $47b9aa0c5fbd17c3$var$GetConfirmedBlockRpcResult = $47b9aa0c5fbd17c3$var$jsonRpcResult((0, $58xNN.nullable)((0, $58xNN.type)({
    blockhash: (0, $58xNN.string)(),
    previousBlockhash: (0, $58xNN.string)(),
    parentSlot: (0, $58xNN.number)(),
    transactions: (0, $58xNN.array)((0, $58xNN.type)({
        transaction: $47b9aa0c5fbd17c3$var$ConfirmedTransactionResult,
        meta: (0, $58xNN.nullable)($47b9aa0c5fbd17c3$var$ConfirmedTransactionMetaResult)
    })),
    rewards: (0, $58xNN.optional)((0, $58xNN.array)($47b9aa0c5fbd17c3$var$RewardsResult)),
    blockTime: (0, $58xNN.nullable)((0, $58xNN.number)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message
 */ var $47b9aa0c5fbd17c3$var$GetBlockSignaturesRpcResult = $47b9aa0c5fbd17c3$var$jsonRpcResult((0, $58xNN.nullable)((0, $58xNN.type)({
    blockhash: (0, $58xNN.string)(),
    previousBlockhash: (0, $58xNN.string)(),
    parentSlot: (0, $58xNN.number)(),
    signatures: (0, $58xNN.array)((0, $58xNN.string)()),
    blockTime: (0, $58xNN.nullable)((0, $58xNN.number)())
})));
/**
 * Expected JSON RPC response for the "getTransaction" message
 */ var $47b9aa0c5fbd17c3$var$GetTransactionRpcResult = $47b9aa0c5fbd17c3$var$jsonRpcResult((0, $58xNN.nullable)((0, $58xNN.type)({
    slot: (0, $58xNN.number)(),
    meta: (0, $58xNN.nullable)($47b9aa0c5fbd17c3$var$ConfirmedTransactionMetaResult),
    blockTime: (0, $58xNN.optional)((0, $58xNN.nullable)((0, $58xNN.number)())),
    transaction: $47b9aa0c5fbd17c3$var$ConfirmedTransactionResult,
    version: (0, $58xNN.optional)($47b9aa0c5fbd17c3$var$TransactionVersionStruct)
})));
/**
 * Expected parsed JSON RPC response for the "getTransaction" message
 */ var $47b9aa0c5fbd17c3$var$GetParsedTransactionRpcResult = $47b9aa0c5fbd17c3$var$jsonRpcResult((0, $58xNN.nullable)((0, $58xNN.type)({
    slot: (0, $58xNN.number)(),
    transaction: $47b9aa0c5fbd17c3$var$ParsedConfirmedTransactionResult,
    meta: (0, $58xNN.nullable)($47b9aa0c5fbd17c3$var$ParsedConfirmedTransactionMetaResult),
    blockTime: (0, $58xNN.optional)((0, $58xNN.nullable)((0, $58xNN.number)())),
    version: (0, $58xNN.optional)($47b9aa0c5fbd17c3$var$TransactionVersionStruct)
})));
/**
 * Expected JSON RPC response for the "getRecentBlockhash" message
 *
 * @deprecated Deprecated since RPC v1.8.0. Please use {@link GetLatestBlockhashRpcResult} instead.
 */ var $47b9aa0c5fbd17c3$var$GetRecentBlockhashAndContextRpcResult = $47b9aa0c5fbd17c3$var$jsonRpcResultAndContext((0, $58xNN.type)({
    blockhash: (0, $58xNN.string)(),
    feeCalculator: (0, $58xNN.type)({
        lamportsPerSignature: (0, $58xNN.number)()
    })
}));
/**
 * Expected JSON RPC response for the "getLatestBlockhash" message
 */ var $47b9aa0c5fbd17c3$var$GetLatestBlockhashRpcResult = $47b9aa0c5fbd17c3$var$jsonRpcResultAndContext((0, $58xNN.type)({
    blockhash: (0, $58xNN.string)(),
    lastValidBlockHeight: (0, $58xNN.number)()
}));
/**
 * Expected JSON RPC response for the "isBlockhashValid" message
 */ var $47b9aa0c5fbd17c3$var$IsBlockhashValidRpcResult = $47b9aa0c5fbd17c3$var$jsonRpcResultAndContext((0, $58xNN.boolean)());
var $47b9aa0c5fbd17c3$var$PerfSampleResult = (0, $58xNN.type)({
    slot: (0, $58xNN.number)(),
    numTransactions: (0, $58xNN.number)(),
    numSlots: (0, $58xNN.number)(),
    samplePeriodSecs: (0, $58xNN.number)()
});
/*
 * Expected JSON RPC response for "getRecentPerformanceSamples" message
 */ var $47b9aa0c5fbd17c3$var$GetRecentPerformanceSamplesRpcResult = $47b9aa0c5fbd17c3$var$jsonRpcResult((0, $58xNN.array)($47b9aa0c5fbd17c3$var$PerfSampleResult));
/**
 * Expected JSON RPC response for the "getFeeCalculatorForBlockhash" message
 */ var $47b9aa0c5fbd17c3$var$GetFeeCalculatorRpcResult = $47b9aa0c5fbd17c3$var$jsonRpcResultAndContext((0, $58xNN.nullable)((0, $58xNN.type)({
    feeCalculator: (0, $58xNN.type)({
        lamportsPerSignature: (0, $58xNN.number)()
    })
})));
/**
 * Expected JSON RPC response for the "requestAirdrop" message
 */ var $47b9aa0c5fbd17c3$var$RequestAirdropRpcResult = $47b9aa0c5fbd17c3$var$jsonRpcResult((0, $58xNN.string)());
/**
 * Expected JSON RPC response for the "sendTransaction" message
 */ var $47b9aa0c5fbd17c3$var$SendTransactionRpcResult = $47b9aa0c5fbd17c3$var$jsonRpcResult((0, $58xNN.string)());
/**
 * Information about the latest slot being processed by a node
 */ /**
 * Parsed account data
 */ /**
 * Stake Activation data
 */ /**
 * Data slice argument for getProgramAccounts
 */ /**
 * Memory comparison filter for getProgramAccounts
 */ /**
 * Data size comparison filter for getProgramAccounts
 */ /**
 * A filter object for getProgramAccounts
 */ /**
 * Configuration object for getProgramAccounts requests
 */ /**
 * Configuration object for getParsedProgramAccounts
 */ /**
 * Configuration object for getMultipleAccounts
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getNonce`
 */ /**
 * Configuration object for `getNonceAndContext`
 */ /**
 * Information describing an account
 */ /**
 * Account information identified by pubkey
 */ /**
 * Callback function for account change notifications
 */ /**
 * Callback function for program account change notifications
 */ /**
 * Callback function for slot change notifications
 */ /**
 * Callback function for slot update notifications
 */ /**
 * Callback function for signature status notifications
 */ /**
 * Signature status notification with transaction result
 */ /**
 * Signature received notification
 */ /**
 * Callback function for signature notifications
 */ /**
 * Signature subscription options
 */ /**
 * Callback function for root change notifications
 */ /**
 * @internal
 */ var $47b9aa0c5fbd17c3$var$LogsResult = (0, $58xNN.type)({
    err: $47b9aa0c5fbd17c3$var$TransactionErrorResult,
    logs: (0, $58xNN.array)((0, $58xNN.string)()),
    signature: (0, $58xNN.string)()
});
/**
 * Logs result.
 */ /**
 * Expected JSON RPC response for the "logsNotification" message.
 */ var $47b9aa0c5fbd17c3$var$LogsNotificationResult = (0, $58xNN.type)({
    result: $47b9aa0c5fbd17c3$var$notificationResultAndContext($47b9aa0c5fbd17c3$var$LogsResult),
    subscription: (0, $58xNN.number)()
});
/**
 * Filter for log subscriptions.
 */ /**
 * Callback function for log notifications.
 */ /**
 * Signature result
 */ /**
 * Transaction error
 */ /**
 * Transaction confirmation status
 * <pre>
 *   'processed': Transaction landed in a block which has reached 1 confirmation by the connected node
 *   'confirmed': Transaction landed in a block which has reached 1 confirmation by the cluster
 *   'finalized': Transaction landed in a block which has been finalized by the cluster
 * </pre>
 */ /**
 * Signature status
 */ /**
 * A confirmed signature with its status
 */ /**
 * An object defining headers to be passed to the RPC server
 */ /**
 * The type of the JavaScript `fetch()` API
 */ /**
 * A callback used to augment the outgoing HTTP request
 */ /**
 * Configuration for instantiating a Connection
 */ /** @internal */ var $47b9aa0c5fbd17c3$var$COMMON_HTTP_HEADERS = {
    "solana-client": "js/1.0.0-maintenance"
};
/**
 * A connection to a fullnode JSON RPC endpoint
 */ var $47b9aa0c5fbd17c3$export$98b66c25bb38499d = /*#__PURE__*/ function() {
    "use strict";
    function Connection(endpoint, _commitmentOrConfig) {
        var _this = this;
        (0, $4GJKx._)(this, Connection);
        /** @internal */ this._commitment = void 0;
        /** @internal */ this._confirmTransactionInitialTimeout = void 0;
        /** @internal */ this._rpcEndpoint = void 0;
        /** @internal */ this._rpcWsEndpoint = void 0;
        /** @internal */ this._rpcClient = void 0;
        /** @internal */ this._rpcRequest = void 0;
        /** @internal */ this._rpcBatchRequest = void 0;
        /** @internal */ this._rpcWebSocket = void 0;
        /** @internal */ this._rpcWebSocketConnected = false;
        /** @internal */ this._rpcWebSocketHeartbeat = null;
        /** @internal */ this._rpcWebSocketIdleTimeout = null;
        /** @internal
     * A number that we increment every time an active connection closes.
     * Used to determine whether the same socket connection that was open
     * when an async operation started is the same one that's active when
     * its continuation fires.
     *
     */ this._rpcWebSocketGeneration = 0;
        /** @internal */ this._disableBlockhashCaching = false;
        /** @internal */ this._pollingBlockhash = false;
        /** @internal */ this._blockhashInfo = {
            latestBlockhash: null,
            lastFetch: 0,
            transactionSignatures: [],
            simulatedSignatures: []
        };
        /** @internal */ this._nextClientSubscriptionId = 0;
        /** @internal */ this._subscriptionDisposeFunctionsByClientSubscriptionId = {};
        /** @internal */ this._subscriptionHashByClientSubscriptionId = {};
        /** @internal */ this._subscriptionStateChangeCallbacksByHash = {};
        /** @internal */ this._subscriptionCallbacksByServerSubscriptionId = {};
        /** @internal */ this._subscriptionsByHash = {};
        /**
     * Special case.
     * After a signature is processed, RPCs automatically dispose of the
     * subscription on the server side. We need to track which of these
     * subscriptions have been disposed in such a way, so that we know
     * whether the client is dealing with a not-yet-processed signature
     * (in which case we must tear down the server subscription) or an
     * already-processed signature (in which case the client can simply
     * clear out the subscription locally without telling the server).
     *
     * NOTE: There is a proposal to eliminate this special case, here:
     * https://github.com/solana-labs/solana/issues/18892
     */ /** @internal */ this._subscriptionsAutoDisposedByRpc = new Set();
        /*
     * Returns the current block height of the node
     */ this.getBlockHeight = function() {
            var requestPromises = {};
            var _this1 = _this;
            return function() {
                var _ref = (0, $kSuI9._)(function(commitmentOrConfig) {
                    var _extractCommitmentFromConfig, commitment, config, args, requestHash, _requestPromises_requestHash;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $47b9aa0c5fbd17c3$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this1._buildArgs([], commitment, undefined /* encoding */ , config);
                                requestHash = $47b9aa0c5fbd17c3$var$fastStableStringify$1(args);
                                requestPromises[requestHash] = (_requestPromises_requestHash = requestPromises[requestHash]) !== null && _requestPromises_requestHash !== void 0 ? _requestPromises_requestHash : (0, $kSuI9._)(function() {
                                    var unsafeRes, res;
                                    return (0, $eha6O.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _state.trys.push([
                                                    0,
                                                    ,
                                                    2,
                                                    3
                                                ]);
                                                return [
                                                    4,
                                                    _this1._rpcRequest("getBlockHeight", args)
                                                ];
                                            case 1:
                                                unsafeRes = _state.sent();
                                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$jsonRpcResult((0, $58xNN.number)()));
                                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get block height information");
                                                return [
                                                    2,
                                                    res.result
                                                ];
                                            case 2:
                                                delete requestPromises[requestHash];
                                                return [
                                                    7
                                                ];
                                            case 3:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                                return [
                                    4,
                                    requestPromises[requestHash]
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
                return function(commitmentOrConfig) {
                    return _ref.apply(this, arguments);
                };
            }();
        }();
        var wsEndpoint;
        var httpHeaders;
        var fetch;
        var fetchMiddleware;
        var disableRetryOnRateLimit;
        var httpAgent;
        if (_commitmentOrConfig && typeof _commitmentOrConfig === "string") this._commitment = _commitmentOrConfig;
        else if (_commitmentOrConfig) {
            this._commitment = _commitmentOrConfig.commitment;
            this._confirmTransactionInitialTimeout = _commitmentOrConfig.confirmTransactionInitialTimeout;
            wsEndpoint = _commitmentOrConfig.wsEndpoint;
            httpHeaders = _commitmentOrConfig.httpHeaders;
            fetch = _commitmentOrConfig.fetch;
            fetchMiddleware = _commitmentOrConfig.fetchMiddleware;
            disableRetryOnRateLimit = _commitmentOrConfig.disableRetryOnRateLimit;
            httpAgent = _commitmentOrConfig.httpAgent;
        }
        this._rpcEndpoint = $47b9aa0c5fbd17c3$var$assertEndpointUrl(endpoint);
        this._rpcWsEndpoint = wsEndpoint || $47b9aa0c5fbd17c3$var$makeWebsocketUrl(endpoint);
        this._rpcClient = $47b9aa0c5fbd17c3$var$createRpcClient(endpoint, httpHeaders, fetch, fetchMiddleware, disableRetryOnRateLimit, httpAgent);
        this._rpcRequest = $47b9aa0c5fbd17c3$var$createRpcRequest(this._rpcClient);
        this._rpcBatchRequest = $47b9aa0c5fbd17c3$var$createRpcBatchRequest(this._rpcClient);
        this._rpcWebSocket = new $47b9aa0c5fbd17c3$var$RpcWebSocketClient(this._rpcWsEndpoint, {
            autoconnect: false,
            max_reconnects: Infinity
        });
        this._rpcWebSocket.on("open", this._wsOnOpen.bind(this));
        this._rpcWebSocket.on("error", this._wsOnError.bind(this));
        this._rpcWebSocket.on("close", this._wsOnClose.bind(this));
        this._rpcWebSocket.on("accountNotification", this._wsOnAccountNotification.bind(this));
        this._rpcWebSocket.on("programNotification", this._wsOnProgramAccountNotification.bind(this));
        this._rpcWebSocket.on("slotNotification", this._wsOnSlotNotification.bind(this));
        this._rpcWebSocket.on("slotsUpdatesNotification", this._wsOnSlotUpdatesNotification.bind(this));
        this._rpcWebSocket.on("signatureNotification", this._wsOnSignatureNotification.bind(this));
        this._rpcWebSocket.on("rootNotification", this._wsOnRootNotification.bind(this));
        this._rpcWebSocket.on("logsNotification", this._wsOnLogsNotification.bind(this));
    }
    (0, $1wc17._)(Connection, [
        {
            key: "commitment",
            get: /**
   * The default commitment used for requests
   */ function get() {
                return this._commitment;
            }
        },
        {
            key: "rpcEndpoint",
            get: /**
   * The RPC endpoint
   */ function get() {
                return this._rpcEndpoint;
            }
        },
        {
            key: "getBalanceAndContext",
            value: /**
   * Fetch the balance for the specified public key, return with context
   */ function getBalanceAndContext(publicKey, commitmentOrConfig) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                /** @internal */ _extractCommitmentFromConfig = $47b9aa0c5fbd17c3$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this._buildArgs([
                                    publicKey.toBase58()
                                ], commitment, undefined /* encoding */ , config);
                                return [
                                    4,
                                    _this._rpcRequest("getBalance", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$jsonRpcResultAndContext((0, $58xNN.number)()));
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get balance for ".concat(publicKey.toBase58()));
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getBalance",
            value: /**
   * Fetch the balance for the specified public key
   */ function getBalance(publicKey, commitmentOrConfig) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getBalanceAndContext(publicKey, commitmentOrConfig).then(function(x) {
                                        return x.value;
                                    }).catch(function(e) {
                                        throw new Error("failed to get balance of account " + publicKey.toBase58() + ": " + e);
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getBlockTime",
            value: /**
   * Fetch the estimated production time of a block
   */ function getBlockTime(slot) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._rpcRequest("getBlockTime", [
                                        slot
                                    ])
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$jsonRpcResult((0, $58xNN.nullable)((0, $58xNN.number)())));
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get block time for slot ".concat(slot));
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getMinimumLedgerSlot",
            value: /**
   * Fetch the lowest slot that the node has information about in its ledger.
   * This value may increase over time if the node is configured to purge older ledger data
   */ function getMinimumLedgerSlot() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._rpcRequest("minimumLedgerSlot", [])
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$jsonRpcResult((0, $58xNN.number)()));
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get minimum ledger slot");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getFirstAvailableBlock",
            value: /**
   * Fetch the slot of the lowest confirmed block that has not been purged from the ledger
   */ function getFirstAvailableBlock() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._rpcRequest("getFirstAvailableBlock", [])
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$SlotRpcResult);
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get first available block");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSupply",
            value: /**
   * Fetch information about the current supply
   */ function getSupply(config) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var configArg, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                configArg = {};
                                if (typeof config === "string") configArg = {
                                    commitment: config
                                };
                                else if (config) configArg = (0, $cxjpp._)((0, $do9pw._)({}, config), {
                                    commitment: config && config.commitment || _this.commitment
                                });
                                else configArg = {
                                    commitment: _this.commitment
                                };
                                return [
                                    4,
                                    _this._rpcRequest("getSupply", [
                                        configArg
                                    ])
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetSupplyRpcResult);
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get supply");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTokenSupply",
            value: /**
   * Fetch the current supply of a token mint
   */ function getTokenSupply(tokenMintAddress, commitment) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = _this._buildArgs([
                                    tokenMintAddress.toBase58()
                                ], commitment);
                                return [
                                    4,
                                    _this._rpcRequest("getTokenSupply", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$jsonRpcResultAndContext($47b9aa0c5fbd17c3$var$TokenAmountResult));
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get token supply");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTokenAccountBalance",
            value: /**
   * Fetch the current balance of a token account
   */ function getTokenAccountBalance(tokenAddress, commitment) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = _this._buildArgs([
                                    tokenAddress.toBase58()
                                ], commitment);
                                return [
                                    4,
                                    _this._rpcRequest("getTokenAccountBalance", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$jsonRpcResultAndContext($47b9aa0c5fbd17c3$var$TokenAmountResult));
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get token account balance");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTokenAccountsByOwner",
            value: /**
   * Fetch all the token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<GetProgramAccountsResponse>}
   */ function getTokenAccountsByOwner(ownerAddress, filter, commitmentOrConfig) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, _args, args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $47b9aa0c5fbd17c3$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                _args = [
                                    ownerAddress.toBase58()
                                ];
                                if ("mint" in filter) _args.push({
                                    mint: filter.mint.toBase58()
                                });
                                else _args.push({
                                    programId: filter.programId.toBase58()
                                });
                                args = _this._buildArgs(_args, commitment, "base64", config);
                                return [
                                    4,
                                    _this._rpcRequest("getTokenAccountsByOwner", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetTokenAccountsByOwner);
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get token accounts owned by account ".concat(ownerAddress.toBase58()));
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getParsedTokenAccountsByOwner",
            value: /**
   * Fetch parsed token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<Array<{pubkey: PublicKey, account: AccountInfo<ParsedAccountData>}>>>}
   */ function getParsedTokenAccountsByOwner(ownerAddress, filter, commitment) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _args, args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _args = [
                                    ownerAddress.toBase58()
                                ];
                                if ("mint" in filter) _args.push({
                                    mint: filter.mint.toBase58()
                                });
                                else _args.push({
                                    programId: filter.programId.toBase58()
                                });
                                args = _this._buildArgs(_args, commitment, "jsonParsed");
                                return [
                                    4,
                                    _this._rpcRequest("getTokenAccountsByOwner", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetParsedTokenAccountsByOwner);
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get token accounts owned by account ".concat(ownerAddress.toBase58()));
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getLargestAccounts",
            value: /**
   * Fetch the 20 largest accounts with their current balances
   */ function getLargestAccounts(config) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var arg, args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                arg = (0, $cxjpp._)((0, $do9pw._)({}, config), {
                                    commitment: config && config.commitment || _this.commitment
                                });
                                args = arg.filter || arg.commitment ? [
                                    arg
                                ] : [];
                                return [
                                    4,
                                    _this._rpcRequest("getLargestAccounts", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetLargestAccountsRpcResult);
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get largest accounts");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTokenLargestAccounts",
            value: /**
   * Fetch the 20 largest token accounts with their current balances
   * for a given mint.
   */ function getTokenLargestAccounts(mintAddress, commitment) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = _this._buildArgs([
                                    mintAddress.toBase58()
                                ], commitment);
                                return [
                                    4,
                                    _this._rpcRequest("getTokenLargestAccounts", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetTokenLargestAccountsResult);
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get token largest accounts");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAccountInfoAndContext",
            value: /**
   * Fetch all the account info for the specified public key, return with context
   */ function getAccountInfoAndContext(publicKey, commitmentOrConfig) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $47b9aa0c5fbd17c3$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this._buildArgs([
                                    publicKey.toBase58()
                                ], commitment, "base64", config);
                                return [
                                    4,
                                    _this._rpcRequest("getAccountInfo", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$jsonRpcResultAndContext((0, $58xNN.nullable)($47b9aa0c5fbd17c3$var$AccountInfoResult)));
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get info about account ".concat(publicKey.toBase58()));
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getParsedAccountInfo",
            value: /**
   * Fetch parsed account info for the specified public key
   */ function getParsedAccountInfo(publicKey, commitmentOrConfig) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $47b9aa0c5fbd17c3$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this._buildArgs([
                                    publicKey.toBase58()
                                ], commitment, "jsonParsed", config);
                                return [
                                    4,
                                    _this._rpcRequest("getAccountInfo", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$jsonRpcResultAndContext((0, $58xNN.nullable)($47b9aa0c5fbd17c3$var$ParsedAccountInfoResult)));
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get info about account ".concat(publicKey.toBase58()));
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAccountInfo",
            value: /**
   * Fetch all the account info for the specified public key
   */ function getAccountInfo(publicKey, commitmentOrConfig) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var res, e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.getAccountInfoAndContext(publicKey, commitmentOrConfig)
                                ];
                            case 1:
                                res = _state.sent();
                                return [
                                    2,
                                    res.value
                                ];
                            case 2:
                                e = _state.sent();
                                throw new Error("failed to get info about account " + publicKey.toBase58() + ": " + e);
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getMultipleParsedAccounts",
            value: /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */ function getMultipleParsedAccounts(publicKeys, rawConfig) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, keys, args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $47b9aa0c5fbd17c3$var$extractCommitmentFromConfig(rawConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                keys = publicKeys.map(function(key) {
                                    return key.toBase58();
                                });
                                args = _this._buildArgs([
                                    keys
                                ], commitment, "jsonParsed", config);
                                return [
                                    4,
                                    _this._rpcRequest("getMultipleAccounts", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$jsonRpcResultAndContext((0, $58xNN.array)((0, $58xNN.nullable)($47b9aa0c5fbd17c3$var$ParsedAccountInfoResult))));
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get info for accounts ".concat(keys));
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getMultipleAccountsInfoAndContext",
            value: /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */ function getMultipleAccountsInfoAndContext(publicKeys, commitmentOrConfig) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, keys, args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $47b9aa0c5fbd17c3$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                keys = publicKeys.map(function(key) {
                                    return key.toBase58();
                                });
                                args = _this._buildArgs([
                                    keys
                                ], commitment, "base64", config);
                                return [
                                    4,
                                    _this._rpcRequest("getMultipleAccounts", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$jsonRpcResultAndContext((0, $58xNN.array)((0, $58xNN.nullable)($47b9aa0c5fbd17c3$var$AccountInfoResult))));
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get info for accounts ".concat(keys));
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getMultipleAccountsInfo",
            value: /**
   * Fetch all the account info for multiple accounts specified by an array of public keys
   */ function getMultipleAccountsInfo(publicKeys, commitmentOrConfig) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getMultipleAccountsInfoAndContext(publicKeys, commitmentOrConfig)
                                ];
                            case 1:
                                res = _state.sent();
                                return [
                                    2,
                                    res.value
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getStakeActivation",
            value: /**
   * Returns epoch activation information for a stake account that has been delegated
   *
   * @deprecated Deprecated since RPC v1.18; will be removed in a future version.
   */ function getStakeActivation(publicKey, commitmentOrConfig, epoch) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $47b9aa0c5fbd17c3$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this._buildArgs([
                                    publicKey.toBase58()
                                ], commitment, undefined /* encoding */ , (0, $cxjpp._)((0, $do9pw._)({}, config), {
                                    epoch: epoch != null ? epoch : config === null || config === void 0 ? void 0 : config.epoch
                                }));
                                return [
                                    4,
                                    _this._rpcRequest("getStakeActivation", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$jsonRpcResult($47b9aa0c5fbd17c3$var$StakeActivationResult));
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get Stake Activation ".concat(publicKey.toBase58()));
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getProgramAccounts",
            value: /**
   * Fetch all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer>}>>}
   */ // eslint-disable-next-line no-dupe-class-members
            // eslint-disable-next-line no-dupe-class-members
            function getProgramAccounts(programId, configOrCommitment) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, _ref, encoding, configWithoutEncoding, args, unsafeRes, baseSchema, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $47b9aa0c5fbd17c3$var$extractCommitmentFromConfig(configOrCommitment), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                _ref = config || {}, encoding = _ref.encoding, configWithoutEncoding = (0, $dRLPW._)(_ref, [
                                    "encoding"
                                ]);
                                args = _this._buildArgs([
                                    programId.toBase58()
                                ], commitment, encoding || "base64", (0, $do9pw._)({}, configWithoutEncoding, configWithoutEncoding.filters ? {
                                    filters: $47b9aa0c5fbd17c3$var$applyDefaultMemcmpEncodingToFilters(configWithoutEncoding.filters)
                                } : null));
                                return [
                                    4,
                                    _this._rpcRequest("getProgramAccounts", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                baseSchema = (0, $58xNN.array)($47b9aa0c5fbd17c3$var$KeyedAccountInfoResult);
                                res = configWithoutEncoding.withContext === true ? (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$jsonRpcResultAndContext(baseSchema)) : (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$jsonRpcResult(baseSchema));
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get accounts owned by program ".concat(programId.toBase58()));
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getParsedProgramAccounts",
            value: /**
   * Fetch and parse all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer | ParsedAccountData>}>>}
   */ function getParsedProgramAccounts(programId, configOrCommitment) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $47b9aa0c5fbd17c3$var$extractCommitmentFromConfig(configOrCommitment), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this._buildArgs([
                                    programId.toBase58()
                                ], commitment, "jsonParsed", config);
                                return [
                                    4,
                                    _this._rpcRequest("getProgramAccounts", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$jsonRpcResult((0, $58xNN.array)($47b9aa0c5fbd17c3$var$KeyedParsedAccountInfoResult)));
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get accounts owned by program ".concat(programId.toBase58()));
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "confirmTransaction",
            value: /** @deprecated Instead, call `confirmTransaction` and pass in {@link TransactionConfirmationStrategy} */ // eslint-disable-next-line no-dupe-class-members
            // eslint-disable-next-line no-dupe-class-members
            function confirmTransaction(strategy, commitment) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var rawSignature, _config_abortSignal, config, decodedSignature;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (typeof strategy == "string") rawSignature = strategy;
                                else {
                                    ;
                                    config = strategy;
                                    if ((_config_abortSignal = config.abortSignal) === null || _config_abortSignal === void 0 ? void 0 : _config_abortSignal.aborted) return [
                                        2,
                                        Promise.reject(config.abortSignal.reason)
                                    ];
                                    rawSignature = config.signature;
                                }
                                try {
                                    decodedSignature = (0, (/*@__PURE__*/$parcel$interopDefault($h0PUv))).decode(rawSignature);
                                } catch (err) {
                                    throw new Error("signature must be base58 encoded: " + rawSignature);
                                }
                                $47b9aa0c5fbd17c3$var$assert(decodedSignature.length === 64, "signature has invalid length");
                                if (!(typeof strategy === "string")) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.confirmTransactionUsingLegacyTimeoutStrategy({
                                        commitment: commitment || _this.commitment,
                                        signature: rawSignature
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                if (!("lastValidBlockHeight" in strategy)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this.confirmTransactionUsingBlockHeightExceedanceStrategy({
                                        commitment: commitment || _this.commitment,
                                        strategy: strategy
                                    })
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 4:
                                return [
                                    4,
                                    _this.confirmTransactionUsingDurableNonceStrategy({
                                        commitment: commitment || _this.commitment,
                                        strategy: strategy
                                    })
                                ];
                            case 5:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getCancellationPromise",
            value: function getCancellationPromise(signal) {
                return new Promise(function(_, reject) {
                    if (signal == null) return;
                    if (signal.aborted) reject(signal.reason);
                    else signal.addEventListener("abort", function() {
                        reject(signal.reason);
                    });
                });
            }
        },
        {
            key: "getTransactionConfirmationPromise",
            value: function getTransactionConfirmationPromise(param) {
                var _this = this;
                var commitment = param.commitment, signature = param.signature;
                var signatureSubscriptionId;
                var disposeSignatureSubscriptionStateChangeObserver;
                var done = false;
                var confirmationPromise = new Promise(function(resolve, reject) {
                    try {
                        signatureSubscriptionId = _this.onSignature(signature, function(result, context) {
                            signatureSubscriptionId = undefined;
                            var response = {
                                context: context,
                                value: result
                            };
                            resolve({
                                __type: $47b9aa0c5fbd17c3$export$7c391bd3b61d2374.PROCESSED,
                                response: response
                            });
                        }, commitment);
                        var subscriptionSetupPromise = new Promise(function(resolveSubscriptionSetup) {
                            if (signatureSubscriptionId == null) resolveSubscriptionSetup();
                            else disposeSignatureSubscriptionStateChangeObserver = _this._onSubscriptionStateChange(signatureSubscriptionId, function(nextState) {
                                if (nextState === "subscribed") resolveSubscriptionSetup();
                            });
                        });
                        var _this1 = _this;
                        (0, $kSuI9._)(function() {
                            var response, context, value;
                            return (0, $eha6O.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            subscriptionSetupPromise
                                        ];
                                    case 1:
                                        _state.sent();
                                        if (done) return [
                                            2
                                        ];
                                        return [
                                            4,
                                            _this1.getSignatureStatus(signature)
                                        ];
                                    case 2:
                                        response = _state.sent();
                                        if (done) return [
                                            2
                                        ];
                                        if (response == null) return [
                                            2
                                        ];
                                        context = response.context, value = response.value;
                                        if (value == null) return [
                                            2
                                        ];
                                        if (value === null || value === void 0 ? void 0 : value.err) reject(value.err);
                                        else {
                                            switch(commitment){
                                                case "confirmed":
                                                case "single":
                                                case "singleGossip":
                                                    if (value.confirmationStatus === "processed") return [
                                                        2
                                                    ];
                                                    break;
                                                case "finalized":
                                                case "max":
                                                case "root":
                                                    if (value.confirmationStatus === "processed" || value.confirmationStatus === "confirmed") return [
                                                        2
                                                    ];
                                                    break;
                                                // exhaust enums to ensure full coverage
                                                case "processed":
                                                case "recent":
                                            }
                                            done = true;
                                            resolve({
                                                __type: $47b9aa0c5fbd17c3$export$7c391bd3b61d2374.PROCESSED,
                                                response: {
                                                    context: context,
                                                    value: value
                                                }
                                            });
                                        }
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    } catch (err) {
                        reject(err);
                    }
                });
                var abortConfirmation = function() {
                    if (disposeSignatureSubscriptionStateChangeObserver) {
                        disposeSignatureSubscriptionStateChangeObserver();
                        disposeSignatureSubscriptionStateChangeObserver = undefined;
                    }
                    if (signatureSubscriptionId != null) {
                        _this.removeSignatureListener(signatureSubscriptionId);
                        signatureSubscriptionId = undefined;
                    }
                };
                return {
                    abortConfirmation: abortConfirmation,
                    confirmationPromise: confirmationPromise
                };
            }
        },
        {
            key: "confirmTransactionUsingBlockHeightExceedanceStrategy",
            value: function confirmTransactionUsingBlockHeightExceedanceStrategy(param) {
                var commitment = param.commitment, _param_strategy = param.strategy, abortSignal = _param_strategy.abortSignal, lastValidBlockHeight = _param_strategy.lastValidBlockHeight, signature = _param_strategy.signature;
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var done, expiryPromise, _this_getTransactionConfirmationPromise, abortConfirmation, confirmationPromise, cancellationPromise, result, outcome;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                done = false;
                                expiryPromise = new Promise(function(resolve) {
                                    var checkBlockHeight = function() {
                                        var _ref = (0, $kSuI9._)(function() {
                                            var blockHeight, _e;
                                            return (0, $eha6O.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        _state.trys.push([
                                                            0,
                                                            2,
                                                            ,
                                                            3
                                                        ]);
                                                        return [
                                                            4,
                                                            _this.getBlockHeight(commitment)
                                                        ];
                                                    case 1:
                                                        blockHeight = _state.sent();
                                                        return [
                                                            2,
                                                            blockHeight
                                                        ];
                                                    case 2:
                                                        _e = _state.sent();
                                                        return [
                                                            2,
                                                            -1
                                                        ];
                                                    case 3:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function checkBlockHeight() {
                                            return _ref.apply(this, arguments);
                                        };
                                    }();
                                    (0, $kSuI9._)(function() {
                                        var currentBlockHeight;
                                        return (0, $eha6O.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        checkBlockHeight()
                                                    ];
                                                case 1:
                                                    currentBlockHeight = _state.sent();
                                                    if (done) return [
                                                        2
                                                    ];
                                                    _state.label = 2;
                                                case 2:
                                                    if (!(currentBlockHeight <= lastValidBlockHeight)) return [
                                                        3,
                                                        5
                                                    ];
                                                    return [
                                                        4,
                                                        $47b9aa0c5fbd17c3$var$sleep(1000)
                                                    ];
                                                case 3:
                                                    _state.sent();
                                                    if (done) return [
                                                        2
                                                    ];
                                                    return [
                                                        4,
                                                        checkBlockHeight()
                                                    ];
                                                case 4:
                                                    currentBlockHeight = _state.sent();
                                                    if (done) return [
                                                        2
                                                    ];
                                                    return [
                                                        3,
                                                        2
                                                    ];
                                                case 5:
                                                    resolve({
                                                        __type: $47b9aa0c5fbd17c3$export$7c391bd3b61d2374.BLOCKHEIGHT_EXCEEDED
                                                    });
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    })();
                                });
                                _this_getTransactionConfirmationPromise = _this.getTransactionConfirmationPromise({
                                    commitment: commitment,
                                    signature: signature
                                }), abortConfirmation = _this_getTransactionConfirmationPromise.abortConfirmation, confirmationPromise = _this_getTransactionConfirmationPromise.confirmationPromise;
                                cancellationPromise = _this.getCancellationPromise(abortSignal);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    ,
                                    3,
                                    4
                                ]);
                                return [
                                    4,
                                    Promise.race([
                                        cancellationPromise,
                                        confirmationPromise,
                                        expiryPromise
                                    ])
                                ];
                            case 2:
                                outcome = _state.sent();
                                if (outcome.__type === $47b9aa0c5fbd17c3$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
                                else throw new $47b9aa0c5fbd17c3$export$718fcd78527f88ed(signature);
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                done = true;
                                abortConfirmation();
                                return [
                                    7
                                ];
                            case 4:
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "confirmTransactionUsingDurableNonceStrategy",
            value: function confirmTransactionUsingDurableNonceStrategy(param) {
                var commitment = param.commitment, _param_strategy = param.strategy, abortSignal = _param_strategy.abortSignal, minContextSlot = _param_strategy.minContextSlot, nonceAccountPubkey = _param_strategy.nonceAccountPubkey, nonceValue = _param_strategy.nonceValue, signature = _param_strategy.signature;
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var done, expiryPromise, _this_getTransactionConfirmationPromise, abortConfirmation, confirmationPromise, cancellationPromise, result, outcome, signatureStatus, status, _outcome_slotInWhichNonceDidAdvance, commitmentForStatus, confirmationStatus;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                done = false;
                                expiryPromise = new Promise(function(resolve) {
                                    var currentNonceValue = nonceValue;
                                    var lastCheckedSlot = null;
                                    var getCurrentNonceValue = function() {
                                        var _ref = (0, $kSuI9._)(function() {
                                            var _ref, context, nonceAccount, e;
                                            return (0, $eha6O.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        _state.trys.push([
                                                            0,
                                                            2,
                                                            ,
                                                            3
                                                        ]);
                                                        return [
                                                            4,
                                                            _this.getNonceAndContext(nonceAccountPubkey, {
                                                                commitment: commitment,
                                                                minContextSlot: minContextSlot
                                                            })
                                                        ];
                                                    case 1:
                                                        _ref = _state.sent(), context = _ref.context, nonceAccount = _ref.value;
                                                        lastCheckedSlot = context.slot;
                                                        return [
                                                            2,
                                                            nonceAccount === null || nonceAccount === void 0 ? void 0 : nonceAccount.nonce
                                                        ];
                                                    case 2:
                                                        e = _state.sent();
                                                        // If for whatever reason we can't reach/read the nonce
                                                        // account, just keep using the last-known value.
                                                        return [
                                                            2,
                                                            currentNonceValue
                                                        ];
                                                    case 3:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function getCurrentNonceValue() {
                                            return _ref.apply(this, arguments);
                                        };
                                    }();
                                    (0, $kSuI9._)(function() {
                                        return (0, $eha6O.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        getCurrentNonceValue()
                                                    ];
                                                case 1:
                                                    currentNonceValue = _state.sent();
                                                    if (done) return [
                                                        2
                                                    ];
                                                    _state.label = 2;
                                                case 2:
                                                    if (!true // eslint-disable-line no-constant-condition
                                                    ) return [
                                                        3,
                                                        5
                                                    ];
                                                    if (nonceValue !== currentNonceValue) {
                                                        resolve({
                                                            __type: $47b9aa0c5fbd17c3$export$7c391bd3b61d2374.NONCE_INVALID,
                                                            slotInWhichNonceDidAdvance: lastCheckedSlot
                                                        });
                                                        return [
                                                            2
                                                        ];
                                                    }
                                                    return [
                                                        4,
                                                        $47b9aa0c5fbd17c3$var$sleep(2000)
                                                    ];
                                                case 3:
                                                    _state.sent();
                                                    if (done) return [
                                                        2
                                                    ];
                                                    return [
                                                        4,
                                                        getCurrentNonceValue()
                                                    ];
                                                case 4:
                                                    currentNonceValue = _state.sent();
                                                    if (done) return [
                                                        2
                                                    ];
                                                    return [
                                                        3,
                                                        2
                                                    ];
                                                case 5:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    })();
                                });
                                _this_getTransactionConfirmationPromise = _this.getTransactionConfirmationPromise({
                                    commitment: commitment,
                                    signature: signature
                                }), abortConfirmation = _this_getTransactionConfirmationPromise.abortConfirmation, confirmationPromise = _this_getTransactionConfirmationPromise.confirmationPromise;
                                cancellationPromise = _this.getCancellationPromise(abortSignal);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    ,
                                    9,
                                    10
                                ]);
                                return [
                                    4,
                                    Promise.race([
                                        cancellationPromise,
                                        confirmationPromise,
                                        expiryPromise
                                    ])
                                ];
                            case 2:
                                outcome = _state.sent();
                                if (!(outcome.__type === $47b9aa0c5fbd17c3$export$7c391bd3b61d2374.PROCESSED)) return [
                                    3,
                                    3
                                ];
                                result = outcome.response;
                                return [
                                    3,
                                    8
                                ];
                            case 3:
                                if (!true // eslint-disable-line no-constant-condition
                                ) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    _this.getSignatureStatus(signature)
                                ];
                            case 4:
                                status = _state.sent();
                                if (status == null) return [
                                    3,
                                    7
                                ];
                                if (!(status.context.slot < ((_outcome_slotInWhichNonceDidAdvance = outcome.slotInWhichNonceDidAdvance) !== null && _outcome_slotInWhichNonceDidAdvance !== void 0 ? _outcome_slotInWhichNonceDidAdvance : minContextSlot))) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    $47b9aa0c5fbd17c3$var$sleep(400)
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 6:
                                signatureStatus = status;
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                if (signatureStatus === null || signatureStatus === void 0 ? void 0 : signatureStatus.value) {
                                    commitmentForStatus = commitment || "finalized";
                                    confirmationStatus = signatureStatus.value.confirmationStatus;
                                    switch(commitmentForStatus){
                                        case "processed":
                                        case "recent":
                                            if (confirmationStatus !== "processed" && confirmationStatus !== "confirmed" && confirmationStatus !== "finalized") throw new $47b9aa0c5fbd17c3$export$a3e7565a95f5a1e5(signature);
                                            break;
                                        case "confirmed":
                                        case "single":
                                        case "singleGossip":
                                            if (confirmationStatus !== "confirmed" && confirmationStatus !== "finalized") throw new $47b9aa0c5fbd17c3$export$a3e7565a95f5a1e5(signature);
                                            break;
                                        case "finalized":
                                        case "max":
                                        case "root":
                                            if (confirmationStatus !== "finalized") throw new $47b9aa0c5fbd17c3$export$a3e7565a95f5a1e5(signature);
                                            break;
                                        default:
                                            // Exhaustive switch.
                                            // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                            (function(_) {})(commitmentForStatus);
                                    }
                                    result = {
                                        context: signatureStatus.context,
                                        value: {
                                            err: signatureStatus.value.err
                                        }
                                    };
                                } else throw new $47b9aa0c5fbd17c3$export$a3e7565a95f5a1e5(signature);
                                _state.label = 8;
                            case 8:
                                return [
                                    3,
                                    10
                                ];
                            case 9:
                                done = true;
                                abortConfirmation();
                                return [
                                    7
                                ];
                            case 10:
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "confirmTransactionUsingLegacyTimeoutStrategy",
            value: function confirmTransactionUsingLegacyTimeoutStrategy(param) {
                var commitment = param.commitment, signature = param.signature;
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var timeoutId, expiryPromise, _this_getTransactionConfirmationPromise, abortConfirmation, confirmationPromise, result, outcome;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                expiryPromise = new Promise(function(resolve) {
                                    var timeoutMs = _this._confirmTransactionInitialTimeout || 60000;
                                    switch(commitment){
                                        case "processed":
                                        case "recent":
                                        case "single":
                                        case "confirmed":
                                        case "singleGossip":
                                            timeoutMs = _this._confirmTransactionInitialTimeout || 30000;
                                            break;
                                    }
                                    timeoutId = setTimeout(function() {
                                        return resolve({
                                            __type: $47b9aa0c5fbd17c3$export$7c391bd3b61d2374.TIMED_OUT,
                                            timeoutMs: timeoutMs
                                        });
                                    }, timeoutMs);
                                });
                                _this_getTransactionConfirmationPromise = _this.getTransactionConfirmationPromise({
                                    commitment: commitment,
                                    signature: signature
                                }), abortConfirmation = _this_getTransactionConfirmationPromise.abortConfirmation, confirmationPromise = _this_getTransactionConfirmationPromise.confirmationPromise;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    ,
                                    3,
                                    4
                                ]);
                                return [
                                    4,
                                    Promise.race([
                                        confirmationPromise,
                                        expiryPromise
                                    ])
                                ];
                            case 2:
                                outcome = _state.sent();
                                if (outcome.__type === $47b9aa0c5fbd17c3$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
                                else throw new $47b9aa0c5fbd17c3$export$b822204c22e46bdf(signature, outcome.timeoutMs / 1000);
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                clearTimeout(timeoutId);
                                abortConfirmation();
                                return [
                                    7
                                ];
                            case 4:
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getClusterNodes",
            value: /**
   * Return the list of nodes that are currently participating in the cluster
   */ function getClusterNodes() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._rpcRequest("getClusterNodes", [])
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$jsonRpcResult((0, $58xNN.array)($47b9aa0c5fbd17c3$var$ContactInfoResult)));
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get cluster nodes");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getVoteAccounts",
            value: /**
   * Return the list of nodes that are currently participating in the cluster
   */ function getVoteAccounts(commitment) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = _this._buildArgs([], commitment);
                                return [
                                    4,
                                    _this._rpcRequest("getVoteAccounts", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetVoteAccounts);
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get vote accounts");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSlot",
            value: /**
   * Fetch the current slot that the node is processing
   */ function getSlot(commitmentOrConfig) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $47b9aa0c5fbd17c3$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this._buildArgs([], commitment, undefined /* encoding */ , config);
                                return [
                                    4,
                                    _this._rpcRequest("getSlot", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$jsonRpcResult((0, $58xNN.number)()));
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get slot");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSlotLeader",
            value: /**
   * Fetch the current slot leader of the cluster
   */ function getSlotLeader(commitmentOrConfig) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $47b9aa0c5fbd17c3$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this._buildArgs([], commitment, undefined /* encoding */ , config);
                                return [
                                    4,
                                    _this._rpcRequest("getSlotLeader", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$jsonRpcResult((0, $58xNN.string)()));
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get slot leader");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSlotLeaders",
            value: /**
   * Fetch `limit` number of slot leaders starting from `startSlot`
   *
   * @param startSlot fetch slot leaders starting from this slot
   * @param limit number of slot leaders to return
   */ function getSlotLeaders(startSlot, limit) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = [
                                    startSlot,
                                    limit
                                ];
                                return [
                                    4,
                                    _this._rpcRequest("getSlotLeaders", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$jsonRpcResult((0, $58xNN.array)($47b9aa0c5fbd17c3$var$PublicKeyFromString)));
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get slot leaders");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSignatureStatus",
            value: /**
   * Fetch the current status of a signature
   */ function getSignatureStatus(signature, config) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _ref, context, values, value;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getSignatureStatuses([
                                        signature
                                    ], config)
                                ];
                            case 1:
                                _ref = _state.sent(), context = _ref.context, values = _ref.value;
                                $47b9aa0c5fbd17c3$var$assert(values.length === 1);
                                value = values[0];
                                return [
                                    2,
                                    {
                                        context: context,
                                        value: value
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSignatureStatuses",
            value: /**
   * Fetch the current statuses of a batch of signatures
   */ function getSignatureStatuses(signatures, config) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var params, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                params = [
                                    signatures
                                ];
                                if (config) params.push(config);
                                return [
                                    4,
                                    _this._rpcRequest("getSignatureStatuses", params)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetSignatureStatusesRpcResult);
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get signature status");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTransactionCount",
            value: /**
   * Fetch the current transaction count of the cluster
   */ function getTransactionCount(commitmentOrConfig) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $47b9aa0c5fbd17c3$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this._buildArgs([], commitment, undefined /* encoding */ , config);
                                return [
                                    4,
                                    _this._rpcRequest("getTransactionCount", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$jsonRpcResult((0, $58xNN.number)()));
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction count");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTotalSupply",
            value: /**
   * Fetch the current total currency supply of the cluster in lamports
   *
   * @deprecated Deprecated since RPC v1.2.8. Please use {@link getSupply} instead.
   */ function getTotalSupply(commitment) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var result;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getSupply({
                                        commitment: commitment,
                                        excludeNonCirculatingAccountsList: true
                                    })
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result.value.total
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getInflationGovernor",
            value: /**
   * Fetch the cluster InflationGovernor parameters
   */ function getInflationGovernor(commitment) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = _this._buildArgs([], commitment);
                                return [
                                    4,
                                    _this._rpcRequest("getInflationGovernor", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetInflationGovernorRpcResult);
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get inflation");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getInflationReward",
            value: /**
   * Fetch the inflation reward for a list of addresses for an epoch
   */ function getInflationReward(addresses, epoch, commitmentOrConfig) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $47b9aa0c5fbd17c3$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this._buildArgs([
                                    addresses.map(function(pubkey) {
                                        return pubkey.toBase58();
                                    })
                                ], commitment, undefined /* encoding */ , (0, $cxjpp._)((0, $do9pw._)({}, config), {
                                    epoch: epoch != null ? epoch : config === null || config === void 0 ? void 0 : config.epoch
                                }));
                                return [
                                    4,
                                    _this._rpcRequest("getInflationReward", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetInflationRewardResult);
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get inflation reward");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getInflationRate",
            value: /**
   * Fetch the specific inflation values for the current epoch
   */ function getInflationRate() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._rpcRequest("getInflationRate", [])
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetInflationRateRpcResult);
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get inflation rate");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getEpochInfo",
            value: /**
   * Fetch the Epoch Info parameters
   */ function getEpochInfo(commitmentOrConfig) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $47b9aa0c5fbd17c3$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this._buildArgs([], commitment, undefined /* encoding */ , config);
                                return [
                                    4,
                                    _this._rpcRequest("getEpochInfo", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetEpochInfoRpcResult);
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get epoch info");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getEpochSchedule",
            value: /**
   * Fetch the Epoch Schedule parameters
   */ function getEpochSchedule() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var unsafeRes, res, epochSchedule;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._rpcRequest("getEpochSchedule", [])
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetEpochScheduleRpcResult);
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get epoch schedule");
                                epochSchedule = res.result;
                                return [
                                    2,
                                    new $47b9aa0c5fbd17c3$export$df8ed3e830b1d591(epochSchedule.slotsPerEpoch, epochSchedule.leaderScheduleSlotOffset, epochSchedule.warmup, epochSchedule.firstNormalEpoch, epochSchedule.firstNormalSlot)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getLeaderSchedule",
            value: /**
   * Fetch the leader schedule for the current epoch
   * @return {Promise<RpcResponseAndContext<LeaderSchedule>>}
   */ function getLeaderSchedule() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._rpcRequest("getLeaderSchedule", [])
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetLeaderScheduleRpcResult);
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get leader schedule");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getMinimumBalanceForRentExemption",
            value: /**
   * Fetch the minimum balance needed to exempt an account of `dataLength`
   * size from rent
   */ function getMinimumBalanceForRentExemption(dataLength, commitment) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = _this._buildArgs([
                                    dataLength
                                ], commitment);
                                return [
                                    4,
                                    _this._rpcRequest("getMinimumBalanceForRentExemption", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetMinimumBalanceForRentExemptionRpcResult);
                                if ("error" in res) {
                                    console.warn("Unable to fetch minimum balance for rent exemption");
                                    return [
                                        2,
                                        0
                                    ];
                                }
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getRecentBlockhashAndContext",
            value: /**
   * Fetch a recent blockhash from the cluster, return with context
   * @return {Promise<RpcResponseAndContext<{blockhash: Blockhash, feeCalculator: FeeCalculator}>>}
   *
   * @deprecated Deprecated since RPC v1.9.0. Please use {@link getLatestBlockhash} instead.
   */ function getRecentBlockhashAndContext(commitment) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = _this._buildArgs([], commitment);
                                return [
                                    4,
                                    _this._rpcRequest("getRecentBlockhash", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetRecentBlockhashAndContextRpcResult);
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get recent blockhash");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getRecentPerformanceSamples",
            value: /**
   * Fetch recent performance samples
   * @return {Promise<Array<PerfSample>>}
   */ function getRecentPerformanceSamples(limit) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._rpcRequest("getRecentPerformanceSamples", limit ? [
                                        limit
                                    ] : [])
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetRecentPerformanceSamplesRpcResult);
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get recent performance samples");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getFeeCalculatorForBlockhash",
            value: /**
   * Fetch the fee calculator for a recent blockhash from the cluster, return with context
   *
   * @deprecated Deprecated since RPC v1.9.0. Please use {@link getFeeForMessage} instead.
   */ function getFeeCalculatorForBlockhash(blockhash, commitment) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var args, unsafeRes, res, _res_result, context, value;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = _this._buildArgs([
                                    blockhash
                                ], commitment);
                                return [
                                    4,
                                    _this._rpcRequest("getFeeCalculatorForBlockhash", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetFeeCalculatorRpcResult);
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get fee calculator");
                                _res_result = res.result, context = _res_result.context, value = _res_result.value;
                                return [
                                    2,
                                    {
                                        context: context,
                                        value: value !== null ? value.feeCalculator : null
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getFeeForMessage",
            value: /**
   * Fetch the fee for a message from the cluster, return with context
   */ function getFeeForMessage(message, commitment) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var wireMessage, args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                wireMessage = $47b9aa0c5fbd17c3$var$toBuffer(message.serialize()).toString("base64");
                                args = _this._buildArgs([
                                    wireMessage
                                ], commitment);
                                return [
                                    4,
                                    _this._rpcRequest("getFeeForMessage", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$jsonRpcResultAndContext((0, $58xNN.nullable)((0, $58xNN.number)())));
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get fee for message");
                                if (res.result === null) throw new Error("invalid blockhash");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getRecentPrioritizationFees",
            value: /**
   * Fetch a list of prioritization fees from recent blocks.
   */ function getRecentPrioritizationFees(config) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _config_lockedWritableAccounts, accounts, args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                accounts = config === null || config === void 0 ? void 0 : (_config_lockedWritableAccounts = config.lockedWritableAccounts) === null || _config_lockedWritableAccounts === void 0 ? void 0 : _config_lockedWritableAccounts.map(function(key) {
                                    return key.toBase58();
                                });
                                args = (accounts === null || accounts === void 0 ? void 0 : accounts.length) ? [
                                    accounts
                                ] : [];
                                return [
                                    4,
                                    _this._rpcRequest("getRecentPrioritizationFees", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetRecentPrioritizationFeesRpcResult);
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get recent prioritization fees");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getRecentBlockhash",
            value: /**
   * Fetch a recent blockhash from the cluster
   * @return {Promise<{blockhash: Blockhash, feeCalculator: FeeCalculator}>}
   *
   * @deprecated Deprecated since RPC v1.8.0. Please use {@link getLatestBlockhash} instead.
   */ function getRecentBlockhash(commitment) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var res, e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.getRecentBlockhashAndContext(commitment)
                                ];
                            case 1:
                                res = _state.sent();
                                return [
                                    2,
                                    res.value
                                ];
                            case 2:
                                e = _state.sent();
                                throw new Error("failed to get recent blockhash: " + e);
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getLatestBlockhash",
            value: /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */ function getLatestBlockhash(commitmentOrConfig) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var res, e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.getLatestBlockhashAndContext(commitmentOrConfig)
                                ];
                            case 1:
                                res = _state.sent();
                                return [
                                    2,
                                    res.value
                                ];
                            case 2:
                                e = _state.sent();
                                throw new Error("failed to get recent blockhash: " + e);
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getLatestBlockhashAndContext",
            value: /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */ function getLatestBlockhashAndContext(commitmentOrConfig) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $47b9aa0c5fbd17c3$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this._buildArgs([], commitment, undefined /* encoding */ , config);
                                return [
                                    4,
                                    _this._rpcRequest("getLatestBlockhash", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetLatestBlockhashRpcResult);
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get latest blockhash");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "isBlockhashValid",
            value: /**
   * Returns whether a blockhash is still valid or not
   */ function isBlockhashValid(blockhash, rawConfig) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $47b9aa0c5fbd17c3$var$extractCommitmentFromConfig(rawConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this._buildArgs([
                                    blockhash
                                ], commitment, undefined /* encoding */ , config);
                                return [
                                    4,
                                    _this._rpcRequest("isBlockhashValid", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$IsBlockhashValidRpcResult);
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to determine if the blockhash `" + blockhash + "`is valid");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getVersion",
            value: /**
   * Fetch the node version
   */ function getVersion() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._rpcRequest("getVersion", [])
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$jsonRpcResult($47b9aa0c5fbd17c3$var$VersionResult));
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get version");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getGenesisHash",
            value: /**
   * Fetch the genesis hash
   */ function getGenesisHash() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._rpcRequest("getGenesisHash", [])
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$jsonRpcResult((0, $58xNN.string)()));
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get genesis hash");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getBlock",
            value: /**
   * Fetch a processed block from the cluster.
   *
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ // eslint-disable-next-line no-dupe-class-members
            /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ // eslint-disable-next-line no-dupe-class-members
            /**
   * Fetch a processed block from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
            // eslint-disable-next-line no-dupe-class-members
            // eslint-disable-next-line no-dupe-class-members
            /**
   * Fetch a processed block from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
            function getBlock(slot, rawConfig) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, args, unsafeRes, res, res1, res2, result;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $47b9aa0c5fbd17c3$var$extractCommitmentFromConfig(rawConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this._buildArgsAtLeastConfirmed([
                                    slot
                                ], commitment, undefined /* encoding */ , config);
                                return [
                                    4,
                                    _this._rpcRequest("getBlock", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                try {
                                    switch(config === null || config === void 0 ? void 0 : config.transactionDetails){
                                        case "accounts":
                                            {
                                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetAccountsModeBlockRpcResult);
                                                if ("error" in res) throw res.error;
                                                return [
                                                    2,
                                                    res.result
                                                ];
                                            }
                                        case "none":
                                            {
                                                res1 = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetNoneModeBlockRpcResult);
                                                if ("error" in res1) throw res1.error;
                                                return [
                                                    2,
                                                    res1.result
                                                ];
                                            }
                                        default:
                                            {
                                                res2 = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetBlockRpcResult);
                                                if ("error" in res2) throw res2.error;
                                                result = res2.result;
                                                return [
                                                    2,
                                                    result ? (0, $cxjpp._)((0, $do9pw._)({}, result), {
                                                        transactions: result.transactions.map(function(param) {
                                                            var transaction = param.transaction, meta = param.meta, version = param.version;
                                                            return {
                                                                meta: meta,
                                                                transaction: (0, $cxjpp._)((0, $do9pw._)({}, transaction), {
                                                                    message: $47b9aa0c5fbd17c3$var$versionedMessageFromResponse(version, transaction.message)
                                                                }),
                                                                version: version
                                                            };
                                                        })
                                                    }) : null
                                                ];
                                            }
                                    }
                                } catch (e) {
                                    throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(e, "failed to get confirmed block");
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getParsedBlock",
            value: /**
   * Fetch parsed transaction details for a confirmed or finalized block
   */ // eslint-disable-next-line no-dupe-class-members
            // eslint-disable-next-line no-dupe-class-members
            // eslint-disable-next-line no-dupe-class-members
            function getParsedBlock(slot, rawConfig) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, args, unsafeRes, res, res1, res2;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $47b9aa0c5fbd17c3$var$extractCommitmentFromConfig(rawConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this._buildArgsAtLeastConfirmed([
                                    slot
                                ], commitment, "jsonParsed", config);
                                return [
                                    4,
                                    _this._rpcRequest("getBlock", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                try {
                                    switch(config === null || config === void 0 ? void 0 : config.transactionDetails){
                                        case "accounts":
                                            {
                                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetParsedAccountsModeBlockRpcResult);
                                                if ("error" in res) throw res.error;
                                                return [
                                                    2,
                                                    res.result
                                                ];
                                            }
                                        case "none":
                                            {
                                                res1 = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetParsedNoneModeBlockRpcResult);
                                                if ("error" in res1) throw res1.error;
                                                return [
                                                    2,
                                                    res1.result
                                                ];
                                            }
                                        default:
                                            {
                                                res2 = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetParsedBlockRpcResult);
                                                if ("error" in res2) throw res2.error;
                                                return [
                                                    2,
                                                    res2.result
                                                ];
                                            }
                                    }
                                } catch (e) {
                                    throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(e, "failed to get block");
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getBlockProduction",
            value: /*
   * Returns recent block production information from the current or previous epoch
   */ function getBlockProduction(configOrCommitment) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var extra, commitment, c, rest, args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (typeof configOrCommitment === "string") commitment = configOrCommitment;
                                else if (configOrCommitment) {
                                    c = configOrCommitment.commitment, rest = (0, $dRLPW._)(configOrCommitment, [
                                        "commitment"
                                    ]);
                                    commitment = c;
                                    extra = rest;
                                }
                                args = _this._buildArgs([], commitment, "base64", extra);
                                return [
                                    4,
                                    _this._rpcRequest("getBlockProduction", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$BlockProductionResponseStruct);
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get block production information");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTransaction",
            value: /**
   * Fetch a confirmed or finalized transaction from the cluster.
   *
   * @deprecated Instead, call `getTransaction` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */ /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
            /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
            function getTransaction(signature, rawConfig) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, args, unsafeRes, res, result;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $47b9aa0c5fbd17c3$var$extractCommitmentFromConfig(rawConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this._buildArgsAtLeastConfirmed([
                                    signature
                                ], commitment, undefined /* encoding */ , config);
                                return [
                                    4,
                                    _this._rpcRequest("getTransaction", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetTransactionRpcResult);
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction");
                                result = res.result;
                                if (!result) return [
                                    2,
                                    result
                                ];
                                return [
                                    2,
                                    (0, $cxjpp._)((0, $do9pw._)({}, result), {
                                        transaction: (0, $cxjpp._)((0, $do9pw._)({}, result.transaction), {
                                            message: $47b9aa0c5fbd17c3$var$versionedMessageFromResponse(result.version, result.transaction.message)
                                        })
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getParsedTransaction",
            value: /**
   * Fetch parsed transaction details for a confirmed or finalized transaction
   */ function getParsedTransaction(signature, commitmentOrConfig) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $47b9aa0c5fbd17c3$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                args = _this._buildArgsAtLeastConfirmed([
                                    signature
                                ], commitment, "jsonParsed", config);
                                return [
                                    4,
                                    _this._rpcRequest("getTransaction", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetParsedTransactionRpcResult);
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getParsedTransactions",
            value: /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   */ function getParsedTransactions(signatures, commitmentOrConfig) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, batch, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $47b9aa0c5fbd17c3$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                batch = signatures.map(function(signature) {
                                    var args = _this._buildArgsAtLeastConfirmed([
                                        signature
                                    ], commitment, "jsonParsed", config);
                                    return {
                                        methodName: "getTransaction",
                                        args: args
                                    };
                                });
                                return [
                                    4,
                                    _this._rpcBatchRequest(batch)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = unsafeRes.map(function(unsafeRes) {
                                    var res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetParsedTransactionRpcResult);
                                    if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get transactions");
                                    return res.result;
                                });
                                return [
                                    2,
                                    res
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTransactions",
            value: /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link TransactionResponse}.
   *
   * @deprecated Instead, call `getTransactions` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */ /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */ // eslint-disable-next-line no-dupe-class-members
            /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */ // eslint-disable-next-line no-dupe-class-members
            function getTransactions(signatures, commitmentOrConfig) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _extractCommitmentFromConfig, commitment, config, batch, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $47b9aa0c5fbd17c3$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                                batch = signatures.map(function(signature) {
                                    var args = _this._buildArgsAtLeastConfirmed([
                                        signature
                                    ], commitment, undefined /* encoding */ , config);
                                    return {
                                        methodName: "getTransaction",
                                        args: args
                                    };
                                });
                                return [
                                    4,
                                    _this._rpcBatchRequest(batch)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = unsafeRes.map(function(unsafeRes) {
                                    var res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetTransactionRpcResult);
                                    if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get transactions");
                                    var result = res.result;
                                    if (!result) return result;
                                    return (0, $cxjpp._)((0, $do9pw._)({}, result), {
                                        transaction: (0, $cxjpp._)((0, $do9pw._)({}, result.transaction), {
                                            message: $47b9aa0c5fbd17c3$var$versionedMessageFromResponse(result.version, result.transaction.message)
                                        })
                                    });
                                });
                                return [
                                    2,
                                    res
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getConfirmedBlock",
            value: /**
   * Fetch a list of Transactions and transaction statuses from the cluster
   * for a confirmed block.
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getBlock} instead.
   */ function getConfirmedBlock(slot, commitment) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var args, unsafeRes, res, result, block;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = _this._buildArgsAtLeastConfirmed([
                                    slot
                                ], commitment);
                                return [
                                    4,
                                    _this._rpcRequest("getConfirmedBlock", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetConfirmedBlockRpcResult);
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed block");
                                result = res.result;
                                if (!result) throw new Error("Confirmed block " + slot + " not found");
                                block = (0, $cxjpp._)((0, $do9pw._)({}, result), {
                                    transactions: result.transactions.map(function(param) {
                                        var transaction = param.transaction, meta = param.meta;
                                        var message = new $47b9aa0c5fbd17c3$export$f69c19e57285b83a(transaction.message);
                                        return {
                                            meta: meta,
                                            transaction: (0, $cxjpp._)((0, $do9pw._)({}, transaction), {
                                                message: message
                                            })
                                        };
                                    })
                                });
                                return [
                                    2,
                                    (0, $cxjpp._)((0, $do9pw._)({}, block), {
                                        transactions: block.transactions.map(function(param) {
                                            var transaction = param.transaction, meta = param.meta;
                                            return {
                                                meta: meta,
                                                transaction: $47b9aa0c5fbd17c3$export$febc5573c75cefb0.populate(transaction.message, transaction.signatures)
                                            };
                                        })
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getBlocks",
            value: /**
   * Fetch confirmed blocks between two slots
   */ function getBlocks(startSlot, endSlot, commitment) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = _this._buildArgsAtLeastConfirmed(endSlot !== undefined ? [
                                    startSlot,
                                    endSlot
                                ] : [
                                    startSlot
                                ], commitment);
                                return [
                                    4,
                                    _this._rpcRequest("getBlocks", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$jsonRpcResult((0, $58xNN.array)((0, $58xNN.number)())));
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get blocks");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getBlockSignatures",
            value: /**
   * Fetch a list of Signatures from the cluster for a block, excluding rewards
   */ function getBlockSignatures(slot, commitment) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var args, unsafeRes, res, result;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = _this._buildArgsAtLeastConfirmed([
                                    slot
                                ], commitment, undefined, {
                                    transactionDetails: "signatures",
                                    rewards: false
                                });
                                return [
                                    4,
                                    _this._rpcRequest("getBlock", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetBlockSignaturesRpcResult);
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get block");
                                result = res.result;
                                if (!result) throw new Error("Block " + slot + " not found");
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getConfirmedBlockSignatures",
            value: /**
   * Fetch a list of Signatures from the cluster for a confirmed block, excluding rewards
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getBlockSignatures} instead.
   */ function getConfirmedBlockSignatures(slot, commitment) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var args, unsafeRes, res, result;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = _this._buildArgsAtLeastConfirmed([
                                    slot
                                ], commitment, undefined, {
                                    transactionDetails: "signatures",
                                    rewards: false
                                });
                                return [
                                    4,
                                    _this._rpcRequest("getConfirmedBlock", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetBlockSignaturesRpcResult);
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed block");
                                result = res.result;
                                if (!result) throw new Error("Confirmed block " + slot + " not found");
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getConfirmedTransaction",
            value: /**
   * Fetch a transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getTransaction} instead.
   */ function getConfirmedTransaction(signature, commitment) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var args, unsafeRes, res, result, message, signatures;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = _this._buildArgsAtLeastConfirmed([
                                    signature
                                ], commitment);
                                return [
                                    4,
                                    _this._rpcRequest("getConfirmedTransaction", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetTransactionRpcResult);
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction");
                                result = res.result;
                                if (!result) return [
                                    2,
                                    result
                                ];
                                message = new $47b9aa0c5fbd17c3$export$f69c19e57285b83a(result.transaction.message);
                                signatures = result.transaction.signatures;
                                return [
                                    2,
                                    (0, $cxjpp._)((0, $do9pw._)({}, result), {
                                        transaction: $47b9aa0c5fbd17c3$export$febc5573c75cefb0.populate(message, signatures)
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getParsedConfirmedTransaction",
            value: /**
   * Fetch parsed transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getParsedTransaction} instead.
   */ function getParsedConfirmedTransaction(signature, commitment) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = _this._buildArgsAtLeastConfirmed([
                                    signature
                                ], commitment, "jsonParsed");
                                return [
                                    4,
                                    _this._rpcRequest("getConfirmedTransaction", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetParsedTransactionRpcResult);
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed transaction");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getParsedConfirmedTransactions",
            value: /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getParsedTransactions} instead.
   */ function getParsedConfirmedTransactions(signatures, commitment) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var batch, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                batch = signatures.map(function(signature) {
                                    var args = _this._buildArgsAtLeastConfirmed([
                                        signature
                                    ], commitment, "jsonParsed");
                                    return {
                                        methodName: "getConfirmedTransaction",
                                        args: args
                                    };
                                });
                                return [
                                    4,
                                    _this._rpcBatchRequest(batch)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = unsafeRes.map(function(unsafeRes) {
                                    var res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetParsedTransactionRpcResult);
                                    if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed transactions");
                                    return res.result;
                                });
                                return [
                                    2,
                                    res
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getConfirmedSignaturesForAddress",
            value: /**
   * Fetch a list of all the confirmed signatures for transactions involving an address
   * within a specified slot range. Max range allowed is 10,000 slots.
   *
   * @deprecated Deprecated since RPC v1.3. Please use {@link getConfirmedSignaturesForAddress2} instead.
   *
   * @param address queried address
   * @param startSlot start slot, inclusive
   * @param endSlot end slot, inclusive
   */ function getConfirmedSignaturesForAddress(address, startSlot, endSlot) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var options, firstAvailableBlock, block, err, highestConfirmedRoot, block1, err1, confirmedSignatureInfo;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                options = {};
                                return [
                                    4,
                                    _this.getFirstAvailableBlock()
                                ];
                            case 1:
                                firstAvailableBlock = _state.sent();
                                _state.label = 2;
                            case 2:
                                if (!!("until" in options)) return [
                                    3,
                                    7
                                ];
                                startSlot--;
                                if (startSlot <= 0 || startSlot < firstAvailableBlock) return [
                                    3,
                                    7
                                ];
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    _this.getConfirmedBlockSignatures(startSlot, "finalized")
                                ];
                            case 4:
                                block = _state.sent();
                                if (block.signatures.length > 0) options.until = block.signatures[block.signatures.length - 1].toString();
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                err = _state.sent();
                                if (err instanceof Error && err.message.includes("skipped")) return [
                                    3,
                                    2
                                ];
                                else throw err;
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                return [
                                    3,
                                    2
                                ];
                            case 7:
                                return [
                                    4,
                                    _this.getSlot("finalized")
                                ];
                            case 8:
                                highestConfirmedRoot = _state.sent();
                                _state.label = 9;
                            case 9:
                                if (!!("before" in options)) return [
                                    3,
                                    14
                                ];
                                endSlot++;
                                if (endSlot > highestConfirmedRoot) return [
                                    3,
                                    14
                                ];
                                _state.label = 10;
                            case 10:
                                _state.trys.push([
                                    10,
                                    12,
                                    ,
                                    13
                                ]);
                                return [
                                    4,
                                    _this.getConfirmedBlockSignatures(endSlot)
                                ];
                            case 11:
                                block1 = _state.sent();
                                if (block1.signatures.length > 0) options.before = block1.signatures[block1.signatures.length - 1].toString();
                                return [
                                    3,
                                    13
                                ];
                            case 12:
                                err1 = _state.sent();
                                if (err1 instanceof Error && err1.message.includes("skipped")) return [
                                    3,
                                    9
                                ];
                                else throw err1;
                                return [
                                    3,
                                    13
                                ];
                            case 13:
                                return [
                                    3,
                                    9
                                ];
                            case 14:
                                return [
                                    4,
                                    _this.getConfirmedSignaturesForAddress2(address, options)
                                ];
                            case 15:
                                confirmedSignatureInfo = _state.sent();
                                return [
                                    2,
                                    confirmedSignatureInfo.map(function(info) {
                                        return info.signature;
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getConfirmedSignaturesForAddress2",
            value: /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getSignaturesForAddress} instead.
   */ function getConfirmedSignaturesForAddress2(address, options, commitment) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = _this._buildArgsAtLeastConfirmed([
                                    address.toBase58()
                                ], commitment, undefined, options);
                                return [
                                    4,
                                    _this._rpcRequest("getConfirmedSignaturesForAddress2", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetConfirmedSignaturesForAddress2RpcResult);
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed signatures for address");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSignaturesForAddress",
            value: /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */ function getSignaturesForAddress(address, options, commitment) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                args = _this._buildArgsAtLeastConfirmed([
                                    address.toBase58()
                                ], commitment, undefined, options);
                                return [
                                    4,
                                    _this._rpcRequest("getSignaturesForAddress", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$GetSignaturesForAddressRpcResult);
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get signatures for address");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAddressLookupTable",
            value: function getAddressLookupTable(accountKey, config) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _ref, context, accountInfo, value;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getAccountInfoAndContext(accountKey, config)
                                ];
                            case 1:
                                _ref = _state.sent(), context = _ref.context, accountInfo = _ref.value;
                                value = null;
                                if (accountInfo !== null) value = new $47b9aa0c5fbd17c3$export$5b2310da10e607da({
                                    key: accountKey,
                                    state: $47b9aa0c5fbd17c3$export$5b2310da10e607da.deserialize(accountInfo.data)
                                });
                                return [
                                    2,
                                    {
                                        context: context,
                                        value: value
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getNonceAndContext",
            value: /**
   * Fetch the contents of a Nonce account from the cluster, return with context
   */ function getNonceAndContext(nonceAccount, commitmentOrConfig) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _ref, context, accountInfo, value;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getAccountInfoAndContext(nonceAccount, commitmentOrConfig)
                                ];
                            case 1:
                                _ref = _state.sent(), context = _ref.context, accountInfo = _ref.value;
                                value = null;
                                if (accountInfo !== null) value = $47b9aa0c5fbd17c3$export$ed1c2356ce604759.fromAccountData(accountInfo.data);
                                return [
                                    2,
                                    {
                                        context: context,
                                        value: value
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getNonce",
            value: /**
   * Fetch the contents of a Nonce account from the cluster
   */ function getNonce(nonceAccount, commitmentOrConfig) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getNonceAndContext(nonceAccount, commitmentOrConfig).then(function(x) {
                                        return x.value;
                                    }).catch(function(e) {
                                        throw new Error("failed to get nonce for account " + nonceAccount.toBase58() + ": " + e);
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "requestAirdrop",
            value: /**
   * Request an allocation of lamports to the specified address
   *
   * ```typescript
   * import { Connection, PublicKey, LAMPORTS_PER_SOL } from "@solana/web3.js";
   *
   * (async () => {
   *   const connection = new Connection("https://api.testnet.solana.com", "confirmed");
   *   const myAddress = new PublicKey("2nr1bHFT86W9tGnyvmYW4vcHKsQB3sVQfnddasz4kExM");
   *   const signature = await connection.requestAirdrop(myAddress, LAMPORTS_PER_SOL);
   *   await connection.confirmTransaction(signature);
   * })();
   * ```
   */ function requestAirdrop(to, lamports) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._rpcRequest("requestAirdrop", [
                                        to.toBase58(),
                                        lamports
                                    ])
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$RequestAirdropRpcResult);
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "airdrop to ".concat(to.toBase58(), " failed"));
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_blockhashWithExpiryBlockHeight",
            value: /**
   * @internal
   */ function _blockhashWithExpiryBlockHeight(disableCache) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var timeSinceFetch, expired;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!disableCache) return [
                                    3,
                                    4
                                ];
                                _state.label = 1;
                            case 1:
                                if (!_this._pollingBlockhash) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    $47b9aa0c5fbd17c3$var$sleep(100)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    1
                                ];
                            case 3:
                                timeSinceFetch = Date.now() - _this._blockhashInfo.lastFetch;
                                expired = timeSinceFetch >= $47b9aa0c5fbd17c3$export$fcb705732fb5c597;
                                if (_this._blockhashInfo.latestBlockhash !== null && !expired) return [
                                    2,
                                    _this._blockhashInfo.latestBlockhash
                                ];
                                _state.label = 4;
                            case 4:
                                return [
                                    4,
                                    _this._pollNewBlockhash()
                                ];
                            case 5:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_pollNewBlockhash",
            value: /**
   * @internal
   */ function _pollNewBlockhash() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var startTime, cachedLatestBlockhash, cachedBlockhash, i, latestBlockhash;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this._pollingBlockhash = true;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    ,
                                    7,
                                    8
                                ]);
                                startTime = Date.now();
                                cachedLatestBlockhash = _this._blockhashInfo.latestBlockhash;
                                cachedBlockhash = cachedLatestBlockhash ? cachedLatestBlockhash.blockhash : null;
                                i = 0;
                                _state.label = 2;
                            case 2:
                                if (!(i < 50)) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    _this.getLatestBlockhash("finalized")
                                ];
                            case 3:
                                latestBlockhash = _state.sent();
                                if (cachedBlockhash !== latestBlockhash.blockhash) {
                                    _this._blockhashInfo = {
                                        latestBlockhash: latestBlockhash,
                                        lastFetch: Date.now(),
                                        transactionSignatures: [],
                                        simulatedSignatures: []
                                    };
                                    return [
                                        2,
                                        latestBlockhash
                                    ];
                                }
                                // Sleep for approximately half a slot
                                return [
                                    4,
                                    $47b9aa0c5fbd17c3$var$sleep($47b9aa0c5fbd17c3$var$MS_PER_SLOT / 2)
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                i++;
                                return [
                                    3,
                                    2
                                ];
                            case 6:
                                throw new Error("Unable to obtain a new blockhash after ".concat(Date.now() - startTime, "ms"));
                            case 7:
                                _this._pollingBlockhash = false;
                                return [
                                    7
                                ];
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getStakeMinimumDelegation",
            value: /**
   * get the stake minimum delegation
   */ function getStakeMinimumDelegation(config) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _extractCommitmentFromConfig, commitment, configArg, args, unsafeRes, res;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _extractCommitmentFromConfig = $47b9aa0c5fbd17c3$var$extractCommitmentFromConfig(config), commitment = _extractCommitmentFromConfig.commitment, configArg = _extractCommitmentFromConfig.config;
                                args = _this._buildArgs([], commitment, "base64", configArg);
                                return [
                                    4,
                                    _this._rpcRequest("getStakeMinimumDelegation", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$jsonRpcResultAndContext((0, $58xNN.number)()));
                                if ("error" in res) throw new $47b9aa0c5fbd17c3$export$ea1b1a1bba5c14ad(res.error, "failed to get stake minimum delegation");
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "simulateTransaction",
            value: /**
   * Simulate a transaction
   *
   * @deprecated Instead, call {@link simulateTransaction} with {@link
   * VersionedTransaction} and {@link SimulateTransactionConfig} parameters
   */ /**
   * Simulate a transaction
   */ // eslint-disable-next-line no-dupe-class-members
            /**
   * Simulate a transaction
   */ // eslint-disable-next-line no-dupe-class-members
            function simulateTransaction(transactionOrMessage, configOrSigners, includeAccounts) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _transaction, versionedTx, wireTransaction, encodedTransaction, config, args, unsafeRes, res, transaction, originalTx, signers, disableCache, _transaction1, latestBlockhash, signature, message, signData, wireTransaction1, encodedTransaction1, config1, addresses, args1, unsafeRes1, res1, logs, traceIndent, logTrace;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!("message" in transactionOrMessage)) return [
                                    3,
                                    2
                                ];
                                versionedTx = transactionOrMessage;
                                wireTransaction = versionedTx.serialize();
                                encodedTransaction = (0, $8dlmd.Buffer).from(wireTransaction).toString("base64");
                                if (Array.isArray(configOrSigners) || includeAccounts !== undefined) throw new Error("Invalid arguments");
                                config = configOrSigners || {};
                                config.encoding = "base64";
                                if (!("commitment" in config)) config.commitment = _this.commitment;
                                if (configOrSigners && typeof configOrSigners === "object" && "innerInstructions" in configOrSigners) config.innerInstructions = configOrSigners.innerInstructions;
                                args = [
                                    encodedTransaction,
                                    config
                                ];
                                return [
                                    4,
                                    _this._rpcRequest("simulateTransaction", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$SimulatedTransactionResponseStruct);
                                if ("error" in res) throw new Error("failed to simulate transaction: " + res.error.message);
                                return [
                                    2,
                                    res.result
                                ];
                            case 2:
                                if (transactionOrMessage instanceof $47b9aa0c5fbd17c3$export$febc5573c75cefb0) {
                                    originalTx = transactionOrMessage;
                                    transaction = new $47b9aa0c5fbd17c3$export$febc5573c75cefb0();
                                    transaction.feePayer = originalTx.feePayer;
                                    transaction.instructions = transactionOrMessage.instructions;
                                    transaction.nonceInfo = originalTx.nonceInfo;
                                    transaction.signatures = originalTx.signatures;
                                } else {
                                    transaction = $47b9aa0c5fbd17c3$export$febc5573c75cefb0.populate(transactionOrMessage);
                                    // HACK: this function relies on mutating the populated transaction
                                    transaction._message = transaction._json = undefined;
                                }
                                if (configOrSigners !== undefined && !Array.isArray(configOrSigners)) throw new Error("Invalid arguments");
                                signers = configOrSigners;
                                if (!(transaction.nonceInfo && signers)) return [
                                    3,
                                    3
                                ];
                                (_transaction = transaction).sign.apply(_transaction, (0, $c6Xmf._)(signers));
                                return [
                                    3,
                                    7
                                ];
                            case 3:
                                disableCache = _this._disableBlockhashCaching;
                                _state.label = 4;
                            case 4:
                                return [
                                    4,
                                    _this._blockhashWithExpiryBlockHeight(disableCache)
                                ];
                            case 5:
                                latestBlockhash = _state.sent();
                                transaction.lastValidBlockHeight = latestBlockhash.lastValidBlockHeight;
                                transaction.recentBlockhash = latestBlockhash.blockhash;
                                if (!signers) return [
                                    3,
                                    7
                                ];
                                (_transaction1 = transaction).sign.apply(_transaction1, (0, $c6Xmf._)(signers));
                                if (!transaction.signature) throw new Error("!signature"); // should never happen
                                signature = transaction.signature.toString("base64");
                                if (!_this._blockhashInfo.simulatedSignatures.includes(signature) && !_this._blockhashInfo.transactionSignatures.includes(signature)) {
                                    // The signature of this transaction has not been seen before with the
                                    // current recentBlockhash, all done. Let's break
                                    _this._blockhashInfo.simulatedSignatures.push(signature);
                                    return [
                                        3,
                                        7
                                    ];
                                } else // This transaction would be treated as duplicate (its derived signature
                                // matched to one of already recorded signatures).
                                // So, we must fetch a new blockhash for a different signature by disabling
                                // our cache not to wait for the cache expiration (BLOCKHASH_CACHE_TIMEOUT_MS).
                                disableCache = true;
                                _state.label = 6;
                            case 6:
                                return [
                                    3,
                                    4
                                ];
                            case 7:
                                message = transaction._compile();
                                signData = message.serialize();
                                wireTransaction1 = transaction._serialize(signData);
                                encodedTransaction1 = wireTransaction1.toString("base64");
                                config1 = {
                                    encoding: "base64",
                                    commitment: _this.commitment
                                };
                                if (includeAccounts) {
                                    addresses = (Array.isArray(includeAccounts) ? includeAccounts : message.nonProgramIds()).map(function(key) {
                                        return key.toBase58();
                                    });
                                    config1["accounts"] = {
                                        encoding: "base64",
                                        addresses: addresses
                                    };
                                }
                                if (signers) config1.sigVerify = true;
                                if (configOrSigners && typeof configOrSigners === "object" && "innerInstructions" in configOrSigners) config1.innerInstructions = configOrSigners.innerInstructions;
                                args1 = [
                                    encodedTransaction1,
                                    config1
                                ];
                                return [
                                    4,
                                    _this._rpcRequest("simulateTransaction", args1)
                                ];
                            case 8:
                                unsafeRes1 = _state.sent();
                                res1 = (0, $58xNN.create)(unsafeRes1, $47b9aa0c5fbd17c3$var$SimulatedTransactionResponseStruct);
                                if ("error" in res1) {
                                    ;
                                    if ("data" in res1.error) {
                                        logs = res1.error.data.logs;
                                        if (logs && Array.isArray(logs)) {
                                            traceIndent = "\n    ";
                                            logTrace = traceIndent + logs.join(traceIndent);
                                            console.error(res1.error.message, logTrace);
                                        }
                                    }
                                    throw new $47b9aa0c5fbd17c3$export$121e803f723b3045({
                                        action: "simulate",
                                        signature: "",
                                        transactionMessage: res1.error.message,
                                        logs: logs
                                    });
                                }
                                return [
                                    2,
                                    res1.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendTransaction",
            value: /**
   * Sign and send a transaction
   *
   * @deprecated Instead, call {@link sendTransaction} with a {@link
   * VersionedTransaction}
   */ /**
   * Send a signed transaction
   */ // eslint-disable-next-line no-dupe-class-members
            /**
   * Sign and send a transaction
   */ // eslint-disable-next-line no-dupe-class-members
            function sendTransaction(transaction, signersOrOptions, options) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _transaction, wireTransaction, signers, disableCache, _transaction1, latestBlockhash, signature, wireTransaction1;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!("version" in transaction)) return [
                                    3,
                                    2
                                ];
                                if (signersOrOptions && Array.isArray(signersOrOptions)) throw new Error("Invalid arguments");
                                wireTransaction = transaction.serialize();
                                return [
                                    4,
                                    _this.sendRawTransaction(wireTransaction, signersOrOptions)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                if (signersOrOptions === undefined || !Array.isArray(signersOrOptions)) throw new Error("Invalid arguments");
                                signers = signersOrOptions;
                                if (!transaction.nonceInfo) return [
                                    3,
                                    3
                                ];
                                (_transaction = transaction).sign.apply(_transaction, (0, $c6Xmf._)(signers));
                                return [
                                    3,
                                    7
                                ];
                            case 3:
                                disableCache = _this._disableBlockhashCaching;
                                _state.label = 4;
                            case 4:
                                return [
                                    4,
                                    _this._blockhashWithExpiryBlockHeight(disableCache)
                                ];
                            case 5:
                                latestBlockhash = _state.sent();
                                transaction.lastValidBlockHeight = latestBlockhash.lastValidBlockHeight;
                                transaction.recentBlockhash = latestBlockhash.blockhash;
                                (_transaction1 = transaction).sign.apply(_transaction1, (0, $c6Xmf._)(signers));
                                if (!transaction.signature) throw new Error("!signature"); // should never happen
                                signature = transaction.signature.toString("base64");
                                if (!_this._blockhashInfo.transactionSignatures.includes(signature)) {
                                    // The signature of this transaction has not been seen before with the
                                    // current recentBlockhash, all done. Let's break
                                    _this._blockhashInfo.transactionSignatures.push(signature);
                                    return [
                                        3,
                                        7
                                    ];
                                } else // This transaction would be treated as duplicate (its derived signature
                                // matched to one of already recorded signatures).
                                // So, we must fetch a new blockhash for a different signature by disabling
                                // our cache not to wait for the cache expiration (BLOCKHASH_CACHE_TIMEOUT_MS).
                                disableCache = true;
                                _state.label = 6;
                            case 6:
                                return [
                                    3,
                                    4
                                ];
                            case 7:
                                wireTransaction1 = transaction.serialize();
                                return [
                                    4,
                                    _this.sendRawTransaction(wireTransaction1, options)
                                ];
                            case 8:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendRawTransaction",
            value: /**
   * Send a transaction that has already been signed and serialized into the
   * wire format
   */ function sendRawTransaction(rawTransaction, options) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var encodedTransaction, result;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                encodedTransaction = $47b9aa0c5fbd17c3$var$toBuffer(rawTransaction).toString("base64");
                                return [
                                    4,
                                    _this.sendEncodedTransaction(encodedTransaction, options)
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendEncodedTransaction",
            value: /**
   * Send a transaction that has already been signed, serialized into the
   * wire format, and encoded as a base64 string
   */ function sendEncodedTransaction(encodedTransaction, options) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var config, skipPreflight, preflightCommitment, args, unsafeRes, res, logs;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                config = {
                                    encoding: "base64"
                                };
                                skipPreflight = options && options.skipPreflight;
                                preflightCommitment = skipPreflight === true ? "processed" // FIXME Remove when https://github.com/anza-xyz/agave/pull/483 is deployed.
                                 : options && options.preflightCommitment || _this.commitment;
                                if (options && options.maxRetries != null) config.maxRetries = options.maxRetries;
                                if (options && options.minContextSlot != null) config.minContextSlot = options.minContextSlot;
                                if (skipPreflight) config.skipPreflight = skipPreflight;
                                if (preflightCommitment) config.preflightCommitment = preflightCommitment;
                                args = [
                                    encodedTransaction,
                                    config
                                ];
                                return [
                                    4,
                                    _this._rpcRequest("sendTransaction", args)
                                ];
                            case 1:
                                unsafeRes = _state.sent();
                                res = (0, $58xNN.create)(unsafeRes, $47b9aa0c5fbd17c3$var$SendTransactionRpcResult);
                                if ("error" in res) {
                                    logs = undefined;
                                    if ("data" in res.error) logs = res.error.data.logs;
                                    throw new $47b9aa0c5fbd17c3$export$121e803f723b3045({
                                        action: skipPreflight ? "send" : "simulate",
                                        signature: "",
                                        transactionMessage: res.error.message,
                                        logs: logs
                                    });
                                }
                                return [
                                    2,
                                    res.result
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
   * @internal
   */ key: "_wsOnOpen",
            value: function _wsOnOpen() {
                var _this = this;
                this._rpcWebSocketConnected = true;
                this._rpcWebSocketHeartbeat = setInterval(function() {
                    var _this1 = _this;
                    // Ping server every 5s to prevent idle timeouts
                    (0, $kSuI9._)(function() {
                        var e;
                        return (0, $eha6O.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _state.trys.push([
                                        0,
                                        2,
                                        ,
                                        3
                                    ]);
                                    return [
                                        4,
                                        _this1._rpcWebSocket.notify("ping")
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        3,
                                        3
                                    ];
                                case 2:
                                    e = _state.sent();
                                    return [
                                        3,
                                        3
                                    ];
                                case 3:
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                }, 5000);
                this._updateSubscriptions();
            }
        },
        {
            /**
   * @internal
   */ key: "_wsOnError",
            value: function _wsOnError(err) {
                this._rpcWebSocketConnected = false;
                console.error("ws error:", err.message);
            }
        },
        {
            /**
   * @internal
   */ key: "_wsOnClose",
            value: function _wsOnClose(code) {
                var _this = this;
                this._rpcWebSocketConnected = false;
                this._rpcWebSocketGeneration = (this._rpcWebSocketGeneration + 1) % Number.MAX_SAFE_INTEGER;
                if (this._rpcWebSocketIdleTimeout) {
                    clearTimeout(this._rpcWebSocketIdleTimeout);
                    this._rpcWebSocketIdleTimeout = null;
                }
                if (this._rpcWebSocketHeartbeat) {
                    clearInterval(this._rpcWebSocketHeartbeat);
                    this._rpcWebSocketHeartbeat = null;
                }
                if (code === 1000) {
                    // explicit close, check if any subscriptions have been made since close
                    this._updateSubscriptions();
                    return;
                }
                // implicit close, prepare subscriptions for auto-reconnect
                this._subscriptionCallbacksByServerSubscriptionId = {};
                Object.entries(this._subscriptionsByHash).forEach(function(param) {
                    var _param = (0, $cv9Rk._)(param, 2), hash = _param[0], subscription = _param[1];
                    _this._setSubscription(hash, (0, $cxjpp._)((0, $do9pw._)({}, subscription), {
                        state: "pending"
                    }));
                });
            }
        },
        {
            /**
   * @internal
   */ key: "_setSubscription",
            value: function _setSubscription(hash, nextSubscription) {
                var _this__subscriptionsByHash_hash;
                var prevState = (_this__subscriptionsByHash_hash = this._subscriptionsByHash[hash]) === null || _this__subscriptionsByHash_hash === void 0 ? void 0 : _this__subscriptionsByHash_hash.state;
                this._subscriptionsByHash[hash] = nextSubscription;
                if (prevState !== nextSubscription.state) {
                    var stateChangeCallbacks = this._subscriptionStateChangeCallbacksByHash[hash];
                    if (stateChangeCallbacks) stateChangeCallbacks.forEach(function(cb) {
                        try {
                            cb(nextSubscription.state);
                        // eslint-disable-next-line no-empty
                        } catch (e) {}
                    });
                }
            }
        },
        {
            /**
   * @internal
   */ key: "_onSubscriptionStateChange",
            value: function _onSubscriptionStateChange(clientSubscriptionId, callback) {
                var _this = this;
                var _this__subscriptionStateChangeCallbacksByHash, _hash;
                var hash = this._subscriptionHashByClientSubscriptionId[clientSubscriptionId];
                if (hash == null) return function() {};
                var stateChangeCallbacks = (_this__subscriptionStateChangeCallbacksByHash = this._subscriptionStateChangeCallbacksByHash)[_hash = hash] || (_this__subscriptionStateChangeCallbacksByHash[_hash] = new Set());
                stateChangeCallbacks.add(callback);
                return function() {
                    stateChangeCallbacks.delete(callback);
                    if (stateChangeCallbacks.size === 0) delete _this._subscriptionStateChangeCallbacksByHash[hash];
                };
            }
        },
        {
            key: "_updateSubscriptions",
            value: /**
   * @internal
   */ function _updateSubscriptions() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var activeWebSocketGeneration, isCurrentConnectionStillActive;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (Object.keys(_this._subscriptionsByHash).length === 0) {
                                    if (_this._rpcWebSocketConnected) {
                                        _this._rpcWebSocketConnected = false;
                                        _this._rpcWebSocketIdleTimeout = setTimeout(function() {
                                            _this._rpcWebSocketIdleTimeout = null;
                                            try {
                                                _this._rpcWebSocket.close();
                                            } catch (err) {
                                                // swallow error if socket has already been closed.
                                                if (err instanceof Error) console.log("Error when closing socket connection: ".concat(err.message));
                                            }
                                        }, 500);
                                    }
                                    return [
                                        2
                                    ];
                                }
                                if (_this._rpcWebSocketIdleTimeout !== null) {
                                    clearTimeout(_this._rpcWebSocketIdleTimeout);
                                    _this._rpcWebSocketIdleTimeout = null;
                                    _this._rpcWebSocketConnected = true;
                                }
                                if (!_this._rpcWebSocketConnected) {
                                    _this._rpcWebSocket.connect();
                                    return [
                                        2
                                    ];
                                }
                                activeWebSocketGeneration = _this._rpcWebSocketGeneration;
                                isCurrentConnectionStillActive = function() {
                                    return activeWebSocketGeneration === _this._rpcWebSocketGeneration;
                                };
                                return [
                                    4,
                                    Promise.all(// Don't be tempted to change this to `Object.entries`. We call
                                    // `_updateSubscriptions` recursively when processing the state,
                                    // so it's important that we look up the *current* version of
                                    // each subscription, every time we process a hash.
                                    Object.keys(_this._subscriptionsByHash).map(function() {
                                        var _ref = (0, $kSuI9._)(function(hash) {
                                            var subscription, _;
                                            return (0, $eha6O.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        subscription = _this._subscriptionsByHash[hash];
                                                        if (subscription === undefined) // This entry has since been deleted. Skip.
                                                        return [
                                                            2
                                                        ];
                                                        _ = subscription.state;
                                                        switch(_){
                                                            case "pending":
                                                                return [
                                                                    3,
                                                                    1
                                                                ];
                                                            case "unsubscribed":
                                                                return [
                                                                    3,
                                                                    1
                                                                ];
                                                            case "subscribed":
                                                                return [
                                                                    3,
                                                                    5
                                                                ];
                                                        }
                                                        return [
                                                            3,
                                                            8
                                                        ];
                                                    case 1:
                                                        if (!(subscription.callbacks.size === 0)) return [
                                                            3,
                                                            3
                                                        ];
                                                        /**
             * You can end up here when:
             *
             * - a subscription has recently unsubscribed
             *   without having new callbacks added to it
             *   while the unsubscribe was in flight, or
             * - when a pending subscription has its
             *   listeners removed before a request was
             *   sent to the server.
             *
             * Being that nobody is interested in this
             * subscription any longer, delete it.
             */ delete _this._subscriptionsByHash[hash];
                                                        if (subscription.state === "unsubscribed") delete _this._subscriptionCallbacksByServerSubscriptionId[subscription.serverSubscriptionId];
                                                        return [
                                                            4,
                                                            _this._updateSubscriptions()
                                                        ];
                                                    case 2:
                                                        _state.sent();
                                                        return [
                                                            2
                                                        ];
                                                    case 3:
                                                        return [
                                                            4,
                                                            (0, $kSuI9._)(function() {
                                                                var args, method, serverSubscriptionId, e;
                                                                return (0, $eha6O.__generator)(this, function(_state) {
                                                                    switch(_state.label){
                                                                        case 0:
                                                                            args = subscription.args, method = subscription.method;
                                                                            _state.label = 1;
                                                                        case 1:
                                                                            _state.trys.push([
                                                                                1,
                                                                                4,
                                                                                ,
                                                                                6
                                                                            ]);
                                                                            _this._setSubscription(hash, (0, $cxjpp._)((0, $do9pw._)({}, subscription), {
                                                                                state: "subscribing"
                                                                            }));
                                                                            return [
                                                                                4,
                                                                                _this._rpcWebSocket.call(method, args)
                                                                            ];
                                                                        case 2:
                                                                            serverSubscriptionId = _state.sent();
                                                                            _this._setSubscription(hash, (0, $cxjpp._)((0, $do9pw._)({}, subscription), {
                                                                                serverSubscriptionId: serverSubscriptionId,
                                                                                state: "subscribed"
                                                                            }));
                                                                            _this._subscriptionCallbacksByServerSubscriptionId[serverSubscriptionId] = subscription.callbacks;
                                                                            return [
                                                                                4,
                                                                                _this._updateSubscriptions()
                                                                            ];
                                                                        case 3:
                                                                            _state.sent();
                                                                            return [
                                                                                3,
                                                                                6
                                                                            ];
                                                                        case 4:
                                                                            e = _state.sent();
                                                                            if (e instanceof Error) console.error("".concat(method, " error for argument"), args, e.message);
                                                                            if (!isCurrentConnectionStillActive()) return [
                                                                                2
                                                                            ];
                                                                            // TODO: Maybe add an 'errored' state or a retry limit?
                                                                            _this._setSubscription(hash, (0, $cxjpp._)((0, $do9pw._)({}, subscription), {
                                                                                state: "pending"
                                                                            }));
                                                                            return [
                                                                                4,
                                                                                _this._updateSubscriptions()
                                                                            ];
                                                                        case 5:
                                                                            _state.sent();
                                                                            return [
                                                                                3,
                                                                                6
                                                                            ];
                                                                        case 6:
                                                                            return [
                                                                                2
                                                                            ];
                                                                    }
                                                                });
                                                            })()
                                                        ];
                                                    case 4:
                                                        _state.sent();
                                                        return [
                                                            3,
                                                            8
                                                        ];
                                                    case 5:
                                                        if (!(subscription.callbacks.size === 0)) return [
                                                            3,
                                                            7
                                                        ];
                                                        // By the time we successfully set up a subscription
                                                        // with the server, the client stopped caring about it.
                                                        // Tear it down now.
                                                        return [
                                                            4,
                                                            (0, $kSuI9._)(function() {
                                                                var serverSubscriptionId, unsubscribeMethod, e;
                                                                return (0, $eha6O.__generator)(this, function(_state) {
                                                                    switch(_state.label){
                                                                        case 0:
                                                                            serverSubscriptionId = subscription.serverSubscriptionId, unsubscribeMethod = subscription.unsubscribeMethod;
                                                                            if (!_this._subscriptionsAutoDisposedByRpc.has(serverSubscriptionId)) return [
                                                                                3,
                                                                                1
                                                                            ];
                                                                            /**
                 * Special case.
                 * If we're dealing with a subscription that has been auto-
                 * disposed by the RPC, then we can skip the RPC call to
                 * tear down the subscription here.
                 *
                 * NOTE: There is a proposal to eliminate this special case, here:
                 * https://github.com/solana-labs/solana/issues/18892
                 */ _this._subscriptionsAutoDisposedByRpc.delete(serverSubscriptionId);
                                                                            return [
                                                                                3,
                                                                                6
                                                                            ];
                                                                        case 1:
                                                                            _this._setSubscription(hash, (0, $cxjpp._)((0, $do9pw._)({}, subscription), {
                                                                                state: "unsubscribing"
                                                                            }));
                                                                            _this._setSubscription(hash, (0, $cxjpp._)((0, $do9pw._)({}, subscription), {
                                                                                state: "unsubscribing"
                                                                            }));
                                                                            _state.label = 2;
                                                                        case 2:
                                                                            _state.trys.push([
                                                                                2,
                                                                                4,
                                                                                ,
                                                                                6
                                                                            ]);
                                                                            return [
                                                                                4,
                                                                                _this._rpcWebSocket.call(unsubscribeMethod, [
                                                                                    serverSubscriptionId
                                                                                ])
                                                                            ];
                                                                        case 3:
                                                                            _state.sent();
                                                                            return [
                                                                                3,
                                                                                6
                                                                            ];
                                                                        case 4:
                                                                            e = _state.sent();
                                                                            if (e instanceof Error) console.error("".concat(unsubscribeMethod, " error:"), e.message);
                                                                            if (!isCurrentConnectionStillActive()) return [
                                                                                2
                                                                            ];
                                                                            // TODO: Maybe add an 'errored' state or a retry limit?
                                                                            _this._setSubscription(hash, (0, $cxjpp._)((0, $do9pw._)({}, subscription), {
                                                                                state: "subscribed"
                                                                            }));
                                                                            return [
                                                                                4,
                                                                                _this._updateSubscriptions()
                                                                            ];
                                                                        case 5:
                                                                            _state.sent();
                                                                            return [
                                                                                2
                                                                            ];
                                                                        case 6:
                                                                            _this._setSubscription(hash, (0, $cxjpp._)((0, $do9pw._)({}, subscription), {
                                                                                state: "unsubscribed"
                                                                            }));
                                                                            return [
                                                                                4,
                                                                                _this._updateSubscriptions()
                                                                            ];
                                                                        case 7:
                                                                            _state.sent();
                                                                            return [
                                                                                2
                                                                            ];
                                                                    }
                                                                });
                                                            })()
                                                        ];
                                                    case 6:
                                                        _state.sent();
                                                        _state.label = 7;
                                                    case 7:
                                                        return [
                                                            3,
                                                            8
                                                        ];
                                                    case 8:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(hash) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }()))
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
   * @internal
   */ key: "_handleServerNotification",
            value: function _handleServerNotification(serverSubscriptionId, callbackArgs) {
                var callbacks = this._subscriptionCallbacksByServerSubscriptionId[serverSubscriptionId];
                if (callbacks === undefined) return;
                callbacks.forEach(function(cb) {
                    try {
                        cb.apply(void 0, // I failed to find a way to convince TypeScript that `cb` is of type
                        // `TCallback` which is certainly compatible with `Parameters<TCallback>`.
                        // See https://github.com/microsoft/TypeScript/issues/47615
                        // @ts-ignore
                        (0, $c6Xmf._)(callbackArgs));
                    } catch (e) {
                        console.error(e);
                    }
                });
            }
        },
        {
            /**
   * @internal
   */ key: "_wsOnAccountNotification",
            value: function _wsOnAccountNotification(notification) {
                var _create = (0, $58xNN.create)(notification, $47b9aa0c5fbd17c3$var$AccountNotificationResult), result = _create.result, subscription = _create.subscription;
                this._handleServerNotification(subscription, [
                    result.value,
                    result.context
                ]);
            }
        },
        {
            /**
   * @internal
   */ key: "_makeSubscription",
            value: function _makeSubscription(subscriptionConfig, /**
   * When preparing `args` for a call to `_makeSubscription`, be sure
   * to carefully apply a default `commitment` property, if necessary.
   *
   * - If the user supplied a `commitment` use that.
   * - Otherwise, if the `Connection::commitment` is set, use that.
   * - Otherwise, set it to the RPC server default: `finalized`.
   *
   * This is extremely important to ensure that these two fundamentally
   * identical subscriptions produce the same identifying hash:
   *
   * - A subscription made without specifying a commitment.
   * - A subscription made where the commitment specified is the same
   *   as the default applied to the subscription above.
   *
   * Example; these two subscriptions must produce the same hash:
   *
   * - An `accountSubscribe` subscription for `'PUBKEY'`
   * - An `accountSubscribe` subscription for `'PUBKEY'` with commitment
   *   `'finalized'`.
   *
   * See the 'making a subscription with defaulted params omitted' test
   * in `connection-subscriptions.ts` for more.
   */ args) {
                var clientSubscriptionId = this._nextClientSubscriptionId++;
                var hash = $47b9aa0c5fbd17c3$var$fastStableStringify$1([
                    subscriptionConfig.method,
                    args
                ]);
                var existingSubscription = this._subscriptionsByHash[hash];
                if (existingSubscription === undefined) this._subscriptionsByHash[hash] = (0, $cxjpp._)((0, $do9pw._)({}, subscriptionConfig), {
                    args: args,
                    callbacks: new Set([
                        subscriptionConfig.callback
                    ]),
                    state: "pending"
                });
                else existingSubscription.callbacks.add(subscriptionConfig.callback);
                this._subscriptionHashByClientSubscriptionId[clientSubscriptionId] = hash;
                var _this = this;
                this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId] = /*#__PURE__*/ (0, $kSuI9._)(function() {
                    var subscription;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                delete _this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId];
                                delete _this._subscriptionHashByClientSubscriptionId[clientSubscriptionId];
                                subscription = _this._subscriptionsByHash[hash];
                                $47b9aa0c5fbd17c3$var$assert(subscription !== undefined, "Could not find a `Subscription` when tearing down client subscription #".concat(clientSubscriptionId));
                                subscription.callbacks.delete(subscriptionConfig.callback);
                                return [
                                    4,
                                    _this._updateSubscriptions()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                this._updateSubscriptions();
                return clientSubscriptionId;
            }
        },
        {
            /**
   * Register a callback to be invoked whenever the specified account changes
   *
   * @param publicKey Public key of the account to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param config
   * @return subscription id
   */ /** @deprecated Instead, pass in an {@link AccountSubscriptionConfig} */ // eslint-disable-next-line no-dupe-class-members
            // eslint-disable-next-line no-dupe-class-members
            key: "onAccountChange",
            value: function onAccountChange(publicKey, callback, commitmentOrConfig) {
                var _extractCommitmentFromConfig = $47b9aa0c5fbd17c3$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                var args = this._buildArgs([
                    publicKey.toBase58()
                ], commitment || this._commitment || "finalized", // Apply connection/server default.
                "base64", config);
                return this._makeSubscription({
                    callback: callback,
                    method: "accountSubscribe",
                    unsubscribeMethod: "accountUnsubscribe"
                }, args);
            }
        },
        {
            key: "removeAccountChangeListener",
            value: /**
   * Deregister an account notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ function removeAccountChangeListener(clientSubscriptionId) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._unsubscribeClientSubscription(clientSubscriptionId, "account change")
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
   * @internal
   */ key: "_wsOnProgramAccountNotification",
            value: function _wsOnProgramAccountNotification(notification) {
                var _create = (0, $58xNN.create)(notification, $47b9aa0c5fbd17c3$var$ProgramAccountNotificationResult), result = _create.result, subscription = _create.subscription;
                this._handleServerNotification(subscription, [
                    {
                        accountId: result.value.pubkey,
                        accountInfo: result.value.account
                    },
                    result.context
                ]);
            }
        },
        {
            /**
   * Register a callback to be invoked whenever accounts owned by the
   * specified program change
   *
   * @param programId Public key of the program to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param config
   * @return subscription id
   */ /** @deprecated Instead, pass in a {@link ProgramAccountSubscriptionConfig} */ // eslint-disable-next-line no-dupe-class-members
            // eslint-disable-next-line no-dupe-class-members
            key: "onProgramAccountChange",
            value: function onProgramAccountChange(programId, callback, commitmentOrConfig, maybeFilters) {
                var _extractCommitmentFromConfig = $47b9aa0c5fbd17c3$var$extractCommitmentFromConfig(commitmentOrConfig), commitment = _extractCommitmentFromConfig.commitment, config = _extractCommitmentFromConfig.config;
                var args = this._buildArgs([
                    programId.toBase58()
                ], commitment || this._commitment || "finalized", // Apply connection/server default.
                "base64" /* encoding */ , config ? config : maybeFilters ? {
                    filters: $47b9aa0c5fbd17c3$var$applyDefaultMemcmpEncodingToFilters(maybeFilters)
                } : undefined /* extra */ );
                return this._makeSubscription({
                    callback: callback,
                    method: "programSubscribe",
                    unsubscribeMethod: "programUnsubscribe"
                }, args);
            }
        },
        {
            key: "removeProgramAccountChangeListener",
            value: /**
   * Deregister an account notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ function removeProgramAccountChangeListener(clientSubscriptionId) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._unsubscribeClientSubscription(clientSubscriptionId, "program account change")
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
   * Registers a callback to be invoked whenever logs are emitted.
   */ key: "onLogs",
            value: function onLogs(filter, callback, commitment) {
                var args = this._buildArgs([
                    typeof filter === "object" ? {
                        mentions: [
                            filter.toString()
                        ]
                    } : filter
                ], commitment || this._commitment || "finalized" // Apply connection/server default.
                );
                return this._makeSubscription({
                    callback: callback,
                    method: "logsSubscribe",
                    unsubscribeMethod: "logsUnsubscribe"
                }, args);
            }
        },
        {
            key: "removeOnLogsListener",
            value: /**
   * Deregister a logs callback.
   *
   * @param clientSubscriptionId client subscription id to deregister.
   */ function removeOnLogsListener(clientSubscriptionId) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._unsubscribeClientSubscription(clientSubscriptionId, "logs")
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
   * @internal
   */ key: "_wsOnLogsNotification",
            value: function _wsOnLogsNotification(notification) {
                var _create = (0, $58xNN.create)(notification, $47b9aa0c5fbd17c3$var$LogsNotificationResult), result = _create.result, subscription = _create.subscription;
                this._handleServerNotification(subscription, [
                    result.value,
                    result.context
                ]);
            }
        },
        {
            /**
   * @internal
   */ key: "_wsOnSlotNotification",
            value: function _wsOnSlotNotification(notification) {
                var _create = (0, $58xNN.create)(notification, $47b9aa0c5fbd17c3$var$SlotNotificationResult), result = _create.result, subscription = _create.subscription;
                this._handleServerNotification(subscription, [
                    result
                ]);
            }
        },
        {
            /**
   * Register a callback to be invoked upon slot changes
   *
   * @param callback Function to invoke whenever the slot changes
   * @return subscription id
   */ key: "onSlotChange",
            value: function onSlotChange(callback) {
                return this._makeSubscription({
                    callback: callback,
                    method: "slotSubscribe",
                    unsubscribeMethod: "slotUnsubscribe"
                }, []);
            }
        },
        {
            key: "removeSlotChangeListener",
            value: /**
   * Deregister a slot notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ function removeSlotChangeListener(clientSubscriptionId) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._unsubscribeClientSubscription(clientSubscriptionId, "slot change")
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
   * @internal
   */ key: "_wsOnSlotUpdatesNotification",
            value: function _wsOnSlotUpdatesNotification(notification) {
                var _create = (0, $58xNN.create)(notification, $47b9aa0c5fbd17c3$var$SlotUpdateNotificationResult), result = _create.result, subscription = _create.subscription;
                this._handleServerNotification(subscription, [
                    result
                ]);
            }
        },
        {
            /**
   * Register a callback to be invoked upon slot updates. {@link SlotUpdate}'s
   * may be useful to track live progress of a cluster.
   *
   * @param callback Function to invoke whenever the slot updates
   * @return subscription id
   */ key: "onSlotUpdate",
            value: function onSlotUpdate(callback) {
                return this._makeSubscription({
                    callback: callback,
                    method: "slotsUpdatesSubscribe",
                    unsubscribeMethod: "slotsUpdatesUnsubscribe"
                }, []);
            }
        },
        {
            key: "removeSlotUpdateListener",
            value: /**
   * Deregister a slot update notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ function removeSlotUpdateListener(clientSubscriptionId) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._unsubscribeClientSubscription(clientSubscriptionId, "slot update")
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_unsubscribeClientSubscription",
            value: /**
   * @internal
   */ function _unsubscribeClientSubscription(clientSubscriptionId, subscriptionName) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var dispose;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                dispose = _this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId];
                                if (!dispose) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    dispose()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                console.warn("Ignored unsubscribe request because an active subscription with id " + "`".concat(clientSubscriptionId, "` for '").concat(subscriptionName, "' events ") + "could not be found.");
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_buildArgs",
            value: function _buildArgs(args, override, encoding, extra) {
                var commitment = override || this._commitment;
                if (commitment || encoding || extra) {
                    var options = {};
                    if (encoding) options.encoding = encoding;
                    if (commitment) options.commitment = commitment;
                    if (extra) options = Object.assign(options, extra);
                    args.push(options);
                }
                return args;
            }
        },
        {
            /**
   * @internal
   */ key: "_buildArgsAtLeastConfirmed",
            value: function _buildArgsAtLeastConfirmed(args, override, encoding, extra) {
                var commitment = override || this._commitment;
                if (commitment && ![
                    "confirmed",
                    "finalized"
                ].includes(commitment)) throw new Error("Using Connection with default commitment: `" + this._commitment + "`, but method requires at least `confirmed`");
                return this._buildArgs(args, override, encoding, extra);
            }
        },
        {
            /**
   * @internal
   */ key: "_wsOnSignatureNotification",
            value: function _wsOnSignatureNotification(notification) {
                var _create = (0, $58xNN.create)(notification, $47b9aa0c5fbd17c3$var$SignatureNotificationResult), result = _create.result, subscription = _create.subscription;
                if (result.value !== "receivedSignature") /**
       * Special case.
       * After a signature is processed, RPCs automatically dispose of the
       * subscription on the server side. We need to track which of these
       * subscriptions have been disposed in such a way, so that we know
       * whether the client is dealing with a not-yet-processed signature
       * (in which case we must tear down the server subscription) or an
       * already-processed signature (in which case the client can simply
       * clear out the subscription locally without telling the server).
       *
       * NOTE: There is a proposal to eliminate this special case, here:
       * https://github.com/solana-labs/solana/issues/18892
       */ this._subscriptionsAutoDisposedByRpc.add(subscription);
                this._handleServerNotification(subscription, result.value === "receivedSignature" ? [
                    {
                        type: "received"
                    },
                    result.context
                ] : [
                    {
                        type: "status",
                        result: result.value
                    },
                    result.context
                ]);
            }
        },
        {
            /**
   * Register a callback to be invoked upon signature updates
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param commitment Specify the commitment level signature must reach before notification
   * @return subscription id
   */ key: "onSignature",
            value: function onSignature(signature, callback, commitment) {
                var _this = this;
                var args = this._buildArgs([
                    signature
                ], commitment || this._commitment || "finalized" // Apply connection/server default.
                );
                var clientSubscriptionId = this._makeSubscription({
                    callback: function(notification, context) {
                        if (notification.type === "status") {
                            callback(notification.result, context);
                            // Signatures subscriptions are auto-removed by the RPC service
                            // so no need to explicitly send an unsubscribe message.
                            try {
                                _this.removeSignatureListener(clientSubscriptionId);
                            // eslint-disable-next-line no-empty
                            } catch (_err) {
                            // Already removed.
                            }
                        }
                    },
                    method: "signatureSubscribe",
                    unsubscribeMethod: "signatureUnsubscribe"
                }, args);
                return clientSubscriptionId;
            }
        },
        {
            /**
   * Register a callback to be invoked when a transaction is
   * received and/or processed.
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param options Enable received notifications and set the commitment
   *   level that signature must reach before notification
   * @return subscription id
   */ key: "onSignatureWithOptions",
            value: function onSignatureWithOptions(signature, callback, options) {
                var _this = this;
                var _ref = (0, $cxjpp._)((0, $do9pw._)({}, options), {
                    commitment: options && options.commitment || this._commitment || "finalized" // Apply connection/server default.
                }), commitment = _ref.commitment, extra = (0, $dRLPW._)(_ref, [
                    "commitment"
                ]);
                var args = this._buildArgs([
                    signature
                ], commitment, undefined /* encoding */ , extra);
                var clientSubscriptionId = this._makeSubscription({
                    callback: function(notification, context) {
                        callback(notification, context);
                        // Signatures subscriptions are auto-removed by the RPC service
                        // so no need to explicitly send an unsubscribe message.
                        try {
                            _this.removeSignatureListener(clientSubscriptionId);
                        // eslint-disable-next-line no-empty
                        } catch (_err) {
                        // Already removed.
                        }
                    },
                    method: "signatureSubscribe",
                    unsubscribeMethod: "signatureUnsubscribe"
                }, args);
                return clientSubscriptionId;
            }
        },
        {
            key: "removeSignatureListener",
            value: /**
   * Deregister a signature notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ function removeSignatureListener(clientSubscriptionId) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._unsubscribeClientSubscription(clientSubscriptionId, "signature result")
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
   * @internal
   */ key: "_wsOnRootNotification",
            value: function _wsOnRootNotification(notification) {
                var _create = (0, $58xNN.create)(notification, $47b9aa0c5fbd17c3$var$RootNotificationResult), result = _create.result, subscription = _create.subscription;
                this._handleServerNotification(subscription, [
                    result
                ]);
            }
        },
        {
            /**
   * Register a callback to be invoked upon root changes
   *
   * @param callback Function to invoke whenever the root changes
   * @return subscription id
   */ key: "onRootChange",
            value: function onRootChange(callback) {
                return this._makeSubscription({
                    callback: callback,
                    method: "rootSubscribe",
                    unsubscribeMethod: "rootUnsubscribe"
                }, []);
            }
        },
        {
            key: "removeRootChangeListener",
            value: /**
   * Deregister a root notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ function removeRootChangeListener(clientSubscriptionId) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._unsubscribeClientSubscription(clientSubscriptionId, "root change")
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Connection;
}();
/**
 * Keypair signer interface
 */ /**
 * An account keypair used for signing transactions.
 */ var $47b9aa0c5fbd17c3$export$c53bca448cf33676 = /*#__PURE__*/ function() {
    "use strict";
    function Keypair(keypair) {
        (0, $4GJKx._)(this, Keypair);
        this._keypair = void 0;
        this._keypair = keypair !== null && keypair !== void 0 ? keypair : $47b9aa0c5fbd17c3$var$generateKeypair();
    }
    (0, $1wc17._)(Keypair, [
        {
            key: "publicKey",
            get: /**
   * The public key for this keypair
   *
   * @returns {PublicKey} PublicKey
   */ function get() {
                return new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(this._keypair.publicKey);
            }
        },
        {
            key: "secretKey",
            get: /**
   * The raw secret key for this keypair
   * @returns {Uint8Array} Secret key in an array of Uint8 bytes
   */ function get() {
                return new Uint8Array(this._keypair.secretKey);
            }
        }
    ], [
        {
            key: "generate",
            value: /**
   * Generate a new random keypair
   *
   * @returns {Keypair} Keypair
   */ function generate() {
                return new Keypair($47b9aa0c5fbd17c3$var$generateKeypair());
            }
        },
        {
            key: "fromSecretKey",
            value: /**
   * Create a keypair from a raw secret key byte array.
   *
   * This method should only be used to recreate a keypair from a previously
   * generated secret key. Generating keypairs from a random seed should be done
   * with the {@link Keypair.fromSeed} method.
   *
   * @throws error if the provided secret key is invalid and validation is not skipped.
   *
   * @param secretKey secret key byte array
   * @param options skip secret key validation
   *
   * @returns {Keypair} Keypair
   */ function fromSecretKey(secretKey, options) {
                if (secretKey.byteLength !== 64) throw new Error("bad secret key size");
                var publicKey = secretKey.slice(32, 64);
                if (!options || !options.skipValidation) {
                    var privateScalar = secretKey.slice(0, 32);
                    var computedPublicKey = $47b9aa0c5fbd17c3$var$getPublicKey(privateScalar);
                    for(var ii = 0; ii < 32; ii++){
                        if (publicKey[ii] !== computedPublicKey[ii]) throw new Error("provided secretKey is invalid");
                    }
                }
                return new Keypair({
                    publicKey: publicKey,
                    secretKey: secretKey
                });
            }
        },
        {
            key: "fromSeed",
            value: /**
   * Generate a keypair from a 32 byte seed.
   *
   * @param seed seed byte array
   *
   * @returns {Keypair} Keypair
   */ function fromSeed(seed) {
                var publicKey = $47b9aa0c5fbd17c3$var$getPublicKey(seed);
                var secretKey = new Uint8Array(64);
                secretKey.set(seed);
                secretKey.set(publicKey, 32);
                return new Keypair({
                    publicKey: publicKey,
                    secretKey: secretKey
                });
            }
        }
    ]);
    return Keypair;
}();
/**
 * An enumeration of valid LookupTableInstructionType's
 */ /**
 * An enumeration of valid address lookup table InstructionType's
 * @internal
 */ var $47b9aa0c5fbd17c3$export$7d102200c3a357d6 = Object.freeze({
    CreateLookupTable: {
        index: 0,
        layout: $jt90m.struct([
            $jt90m.u32("instruction"),
            $47b9aa0c5fbd17c3$var$u64("recentSlot"),
            $jt90m.u8("bumpSeed")
        ])
    },
    FreezeLookupTable: {
        index: 1,
        layout: $jt90m.struct([
            $jt90m.u32("instruction")
        ])
    },
    ExtendLookupTable: {
        index: 2,
        layout: $jt90m.struct([
            $jt90m.u32("instruction"),
            $47b9aa0c5fbd17c3$var$u64(),
            $jt90m.seq($47b9aa0c5fbd17c3$var$publicKey(), $jt90m.offset($jt90m.u32(), -8), "addresses")
        ])
    },
    DeactivateLookupTable: {
        index: 3,
        layout: $jt90m.struct([
            $jt90m.u32("instruction")
        ])
    },
    CloseLookupTable: {
        index: 4,
        layout: $jt90m.struct([
            $jt90m.u32("instruction")
        ])
    }
});
var $47b9aa0c5fbd17c3$export$3ab2b24d551f0dc2 = /*#__PURE__*/ function() {
    "use strict";
    function AddressLookupTableInstruction() {
        (0, $4GJKx._)(this, AddressLookupTableInstruction);
    }
    (0, $1wc17._)(AddressLookupTableInstruction, null, [
        {
            key: "decodeInstructionType",
            value: function decodeInstructionType(instruction) {
                this.checkProgramId(instruction.programId);
                var instructionTypeLayout = $jt90m.u32("instruction");
                var index = instructionTypeLayout.decode(instruction.data);
                var _$type;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries($47b9aa0c5fbd17c3$export$7d102200c3a357d6)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $cv9Rk._)(_step.value, 2), layoutType = _step_value[0], layout = _step_value[1];
                        if (layout.index == index) {
                            _$type = layoutType;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (!_$type) throw new Error("Invalid Instruction. Should be a LookupTable Instruction");
                return _$type;
            }
        },
        {
            key: "decodeCreateLookupTable",
            value: function decodeCreateLookupTable(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeysLength(instruction.keys, 4);
                var recentSlot = $47b9aa0c5fbd17c3$var$decodeData$1($47b9aa0c5fbd17c3$export$7d102200c3a357d6.CreateLookupTable, instruction.data).recentSlot;
                return {
                    authority: instruction.keys[1].pubkey,
                    payer: instruction.keys[2].pubkey,
                    recentSlot: Number(recentSlot)
                };
            }
        },
        {
            key: "decodeExtendLookupTable",
            value: function decodeExtendLookupTable(instruction) {
                this.checkProgramId(instruction.programId);
                if (instruction.keys.length < 2) throw new Error("invalid instruction; found ".concat(instruction.keys.length, " keys, expected at least 2"));
                var addresses = $47b9aa0c5fbd17c3$var$decodeData$1($47b9aa0c5fbd17c3$export$7d102200c3a357d6.ExtendLookupTable, instruction.data).addresses;
                return {
                    lookupTable: instruction.keys[0].pubkey,
                    authority: instruction.keys[1].pubkey,
                    payer: instruction.keys.length > 2 ? instruction.keys[2].pubkey : undefined,
                    addresses: addresses.map(function(buffer) {
                        return new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(buffer);
                    })
                };
            }
        },
        {
            key: "decodeCloseLookupTable",
            value: function decodeCloseLookupTable(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeysLength(instruction.keys, 3);
                return {
                    lookupTable: instruction.keys[0].pubkey,
                    authority: instruction.keys[1].pubkey,
                    recipient: instruction.keys[2].pubkey
                };
            }
        },
        {
            key: "decodeFreezeLookupTable",
            value: function decodeFreezeLookupTable(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeysLength(instruction.keys, 2);
                return {
                    lookupTable: instruction.keys[0].pubkey,
                    authority: instruction.keys[1].pubkey
                };
            }
        },
        {
            key: "decodeDeactivateLookupTable",
            value: function decodeDeactivateLookupTable(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeysLength(instruction.keys, 2);
                return {
                    lookupTable: instruction.keys[0].pubkey,
                    authority: instruction.keys[1].pubkey
                };
            }
        },
        {
            key: "checkProgramId",
            value: /**
   * @internal
   */ function checkProgramId(programId) {
                if (!programId.equals($47b9aa0c5fbd17c3$export$5147a345798de168.programId)) throw new Error("invalid instruction; programId is not AddressLookupTable Program");
            }
        },
        {
            key: "checkKeysLength",
            value: /**
   * @internal
   */ function checkKeysLength(keys, expectedLength) {
                if (keys.length < expectedLength) throw new Error("invalid instruction; found ".concat(keys.length, " keys, expected at least ").concat(expectedLength));
            }
        }
    ]);
    return AddressLookupTableInstruction;
}();
var $47b9aa0c5fbd17c3$export$5147a345798de168 = /*#__PURE__*/ function() {
    "use strict";
    function AddressLookupTableProgram() {
        (0, $4GJKx._)(this, AddressLookupTableProgram);
    }
    (0, $1wc17._)(AddressLookupTableProgram, null, [
        {
            key: "createLookupTable",
            value: function createLookupTable(params) {
                var _PublicKey_findProgramAddressSync = (0, $cv9Rk._)($47b9aa0c5fbd17c3$export$ca8b6604d6ce14de.findProgramAddressSync([
                    params.authority.toBuffer(),
                    (0, $hgOwg.toBufferLE)(BigInt(params.recentSlot), 8)
                ], this.programId), 2), lookupTableAddress = _PublicKey_findProgramAddressSync[0], bumpSeed = _PublicKey_findProgramAddressSync[1];
                var _$type = $47b9aa0c5fbd17c3$export$7d102200c3a357d6.CreateLookupTable;
                var data = $47b9aa0c5fbd17c3$var$encodeData(_$type, {
                    recentSlot: BigInt(params.recentSlot),
                    bumpSeed: bumpSeed
                });
                var keys = [
                    {
                        pubkey: lookupTableAddress,
                        isSigner: false,
                        isWritable: true
                    },
                    {
                        pubkey: params.authority,
                        isSigner: true,
                        isWritable: false
                    },
                    {
                        pubkey: params.payer,
                        isSigner: true,
                        isWritable: true
                    },
                    {
                        pubkey: $47b9aa0c5fbd17c3$export$d8c4e17726848113.programId,
                        isSigner: false,
                        isWritable: false
                    }
                ];
                return [
                    new $47b9aa0c5fbd17c3$export$a7a3aa8360ac9f59({
                        programId: this.programId,
                        keys: keys,
                        data: data
                    }),
                    lookupTableAddress
                ];
            }
        },
        {
            key: "freezeLookupTable",
            value: function freezeLookupTable(params) {
                var _$type = $47b9aa0c5fbd17c3$export$7d102200c3a357d6.FreezeLookupTable;
                var data = $47b9aa0c5fbd17c3$var$encodeData(_$type);
                var keys = [
                    {
                        pubkey: params.lookupTable,
                        isSigner: false,
                        isWritable: true
                    },
                    {
                        pubkey: params.authority,
                        isSigner: true,
                        isWritable: false
                    }
                ];
                return new $47b9aa0c5fbd17c3$export$a7a3aa8360ac9f59({
                    programId: this.programId,
                    keys: keys,
                    data: data
                });
            }
        },
        {
            key: "extendLookupTable",
            value: function extendLookupTable(params) {
                var _$type = $47b9aa0c5fbd17c3$export$7d102200c3a357d6.ExtendLookupTable;
                var data = $47b9aa0c5fbd17c3$var$encodeData(_$type, {
                    addresses: params.addresses.map(function(addr) {
                        return addr.toBytes();
                    })
                });
                var keys = [
                    {
                        pubkey: params.lookupTable,
                        isSigner: false,
                        isWritable: true
                    },
                    {
                        pubkey: params.authority,
                        isSigner: true,
                        isWritable: false
                    }
                ];
                if (params.payer) keys.push({
                    pubkey: params.payer,
                    isSigner: true,
                    isWritable: true
                }, {
                    pubkey: $47b9aa0c5fbd17c3$export$d8c4e17726848113.programId,
                    isSigner: false,
                    isWritable: false
                });
                return new $47b9aa0c5fbd17c3$export$a7a3aa8360ac9f59({
                    programId: this.programId,
                    keys: keys,
                    data: data
                });
            }
        },
        {
            key: "deactivateLookupTable",
            value: function deactivateLookupTable(params) {
                var _$type = $47b9aa0c5fbd17c3$export$7d102200c3a357d6.DeactivateLookupTable;
                var data = $47b9aa0c5fbd17c3$var$encodeData(_$type);
                var keys = [
                    {
                        pubkey: params.lookupTable,
                        isSigner: false,
                        isWritable: true
                    },
                    {
                        pubkey: params.authority,
                        isSigner: true,
                        isWritable: false
                    }
                ];
                return new $47b9aa0c5fbd17c3$export$a7a3aa8360ac9f59({
                    programId: this.programId,
                    keys: keys,
                    data: data
                });
            }
        },
        {
            key: "closeLookupTable",
            value: function closeLookupTable(params) {
                var _$type = $47b9aa0c5fbd17c3$export$7d102200c3a357d6.CloseLookupTable;
                var data = $47b9aa0c5fbd17c3$var$encodeData(_$type);
                var keys = [
                    {
                        pubkey: params.lookupTable,
                        isSigner: false,
                        isWritable: true
                    },
                    {
                        pubkey: params.authority,
                        isSigner: true,
                        isWritable: false
                    },
                    {
                        pubkey: params.recipient,
                        isSigner: false,
                        isWritable: true
                    }
                ];
                return new $47b9aa0c5fbd17c3$export$a7a3aa8360ac9f59({
                    programId: this.programId,
                    keys: keys,
                    data: data
                });
            }
        }
    ]);
    return AddressLookupTableProgram;
}();
$47b9aa0c5fbd17c3$export$5147a345798de168.programId = new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de("AddressLookupTab1e1111111111111111111111111");
/**
 * Compute Budget Instruction class
 */ var $47b9aa0c5fbd17c3$export$bc4776847c641a67 = /*#__PURE__*/ function() {
    "use strict";
    function ComputeBudgetInstruction() {
        (0, $4GJKx._)(this, ComputeBudgetInstruction);
    }
    (0, $1wc17._)(ComputeBudgetInstruction, null, [
        {
            key: "decodeInstructionType",
            value: /**
   * Decode a compute budget instruction and retrieve the instruction type.
   */ function decodeInstructionType(instruction) {
                this.checkProgramId(instruction.programId);
                var instructionTypeLayout = $jt90m.u8("instruction");
                var typeIndex = instructionTypeLayout.decode(instruction.data);
                var _$type;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries($47b9aa0c5fbd17c3$export$b7c79c50764da3d6)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $cv9Rk._)(_step.value, 2), ixType = _step_value[0], layout = _step_value[1];
                        if (layout.index == typeIndex) {
                            _$type = ixType;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (!_$type) throw new Error("Instruction type incorrect; not a ComputeBudgetInstruction");
                return _$type;
            }
        },
        {
            key: "decodeRequestUnits",
            value: /**
   * Decode request units compute budget instruction and retrieve the instruction params.
   */ function decodeRequestUnits(instruction) {
                this.checkProgramId(instruction.programId);
                var _decodeData$1 = $47b9aa0c5fbd17c3$var$decodeData$1($47b9aa0c5fbd17c3$export$b7c79c50764da3d6.RequestUnits, instruction.data), units = _decodeData$1.units, additionalFee = _decodeData$1.additionalFee;
                return {
                    units: units,
                    additionalFee: additionalFee
                };
            }
        },
        {
            key: "decodeRequestHeapFrame",
            value: /**
   * Decode request heap frame compute budget instruction and retrieve the instruction params.
   */ function decodeRequestHeapFrame(instruction) {
                this.checkProgramId(instruction.programId);
                var bytes = $47b9aa0c5fbd17c3$var$decodeData$1($47b9aa0c5fbd17c3$export$b7c79c50764da3d6.RequestHeapFrame, instruction.data).bytes;
                return {
                    bytes: bytes
                };
            }
        },
        {
            key: "decodeSetComputeUnitLimit",
            value: /**
   * Decode set compute unit limit compute budget instruction and retrieve the instruction params.
   */ function decodeSetComputeUnitLimit(instruction) {
                this.checkProgramId(instruction.programId);
                var units = $47b9aa0c5fbd17c3$var$decodeData$1($47b9aa0c5fbd17c3$export$b7c79c50764da3d6.SetComputeUnitLimit, instruction.data).units;
                return {
                    units: units
                };
            }
        },
        {
            key: "decodeSetComputeUnitPrice",
            value: /**
   * Decode set compute unit price compute budget instruction and retrieve the instruction params.
   */ function decodeSetComputeUnitPrice(instruction) {
                this.checkProgramId(instruction.programId);
                var microLamports = $47b9aa0c5fbd17c3$var$decodeData$1($47b9aa0c5fbd17c3$export$b7c79c50764da3d6.SetComputeUnitPrice, instruction.data).microLamports;
                return {
                    microLamports: microLamports
                };
            }
        },
        {
            key: "checkProgramId",
            value: /**
   * @internal
   */ function checkProgramId(programId) {
                if (!programId.equals($47b9aa0c5fbd17c3$export$11585db5942bcdb7.programId)) throw new Error("invalid instruction; programId is not ComputeBudgetProgram");
            }
        }
    ]);
    return ComputeBudgetInstruction;
}();
/**
 * An enumeration of valid ComputeBudgetInstructionType's
 */ /**
 * Request units instruction params
 */ /**
 * Request heap frame instruction params
 */ /**
 * Set compute unit limit instruction params
 */ /**
 * Set compute unit price instruction params
 */ /**
 * An enumeration of valid ComputeBudget InstructionType's
 * @internal
 */ var $47b9aa0c5fbd17c3$export$b7c79c50764da3d6 = Object.freeze({
    RequestUnits: {
        index: 0,
        layout: $jt90m.struct([
            $jt90m.u8("instruction"),
            $jt90m.u32("units"),
            $jt90m.u32("additionalFee")
        ])
    },
    RequestHeapFrame: {
        index: 1,
        layout: $jt90m.struct([
            $jt90m.u8("instruction"),
            $jt90m.u32("bytes")
        ])
    },
    SetComputeUnitLimit: {
        index: 2,
        layout: $jt90m.struct([
            $jt90m.u8("instruction"),
            $jt90m.u32("units")
        ])
    },
    SetComputeUnitPrice: {
        index: 3,
        layout: $jt90m.struct([
            $jt90m.u8("instruction"),
            $47b9aa0c5fbd17c3$var$u64("microLamports")
        ])
    }
});
/**
 * Factory class for transaction instructions to interact with the Compute Budget program
 */ var $47b9aa0c5fbd17c3$export$11585db5942bcdb7 = /*#__PURE__*/ function() {
    "use strict";
    function ComputeBudgetProgram() {
        (0, $4GJKx._)(this, ComputeBudgetProgram);
    }
    (0, $1wc17._)(ComputeBudgetProgram, null, [
        {
            key: "requestUnits",
            value: /**
   * Public key that identifies the Compute Budget program
   */ /**
   * @deprecated Instead, call {@link setComputeUnitLimit} and/or {@link setComputeUnitPrice}
   */ function requestUnits(params) {
                var _$type = $47b9aa0c5fbd17c3$export$b7c79c50764da3d6.RequestUnits;
                var data = $47b9aa0c5fbd17c3$var$encodeData(_$type, params);
                return new $47b9aa0c5fbd17c3$export$a7a3aa8360ac9f59({
                    keys: [],
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "requestHeapFrame",
            value: function requestHeapFrame(params) {
                var _$type = $47b9aa0c5fbd17c3$export$b7c79c50764da3d6.RequestHeapFrame;
                var data = $47b9aa0c5fbd17c3$var$encodeData(_$type, params);
                return new $47b9aa0c5fbd17c3$export$a7a3aa8360ac9f59({
                    keys: [],
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "setComputeUnitLimit",
            value: function setComputeUnitLimit(params) {
                var _$type = $47b9aa0c5fbd17c3$export$b7c79c50764da3d6.SetComputeUnitLimit;
                var data = $47b9aa0c5fbd17c3$var$encodeData(_$type, params);
                return new $47b9aa0c5fbd17c3$export$a7a3aa8360ac9f59({
                    keys: [],
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "setComputeUnitPrice",
            value: function setComputeUnitPrice(params) {
                var _$type = $47b9aa0c5fbd17c3$export$b7c79c50764da3d6.SetComputeUnitPrice;
                var data = $47b9aa0c5fbd17c3$var$encodeData(_$type, {
                    microLamports: BigInt(params.microLamports)
                });
                return new $47b9aa0c5fbd17c3$export$a7a3aa8360ac9f59({
                    keys: [],
                    programId: this.programId,
                    data: data
                });
            }
        }
    ]);
    return ComputeBudgetProgram;
}();
$47b9aa0c5fbd17c3$export$11585db5942bcdb7.programId = new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de("ComputeBudget111111111111111111111111111111");
var $47b9aa0c5fbd17c3$var$PRIVATE_KEY_BYTES$1 = 64;
var $47b9aa0c5fbd17c3$var$PUBLIC_KEY_BYTES$1 = 32;
var $47b9aa0c5fbd17c3$var$SIGNATURE_BYTES = 64;
/**
 * Params for creating an ed25519 instruction using a public key
 */ /**
 * Params for creating an ed25519 instruction using a private key
 */ var $47b9aa0c5fbd17c3$var$ED25519_INSTRUCTION_LAYOUT = $jt90m.struct([
    $jt90m.u8("numSignatures"),
    $jt90m.u8("padding"),
    $jt90m.u16("signatureOffset"),
    $jt90m.u16("signatureInstructionIndex"),
    $jt90m.u16("publicKeyOffset"),
    $jt90m.u16("publicKeyInstructionIndex"),
    $jt90m.u16("messageDataOffset"),
    $jt90m.u16("messageDataSize"),
    $jt90m.u16("messageInstructionIndex")
]);
var $47b9aa0c5fbd17c3$export$e5087aea02631e = /*#__PURE__*/ function() {
    "use strict";
    function Ed25519Program() {
        (0, $4GJKx._)(this, Ed25519Program);
    }
    (0, $1wc17._)(Ed25519Program, null, [
        {
            key: "createInstructionWithPublicKey",
            value: /**
   * Public key that identifies the ed25519 program
   */ /**
   * Create an ed25519 instruction with a public key and signature. The
   * public key must be a buffer that is 32 bytes long, and the signature
   * must be a buffer of 64 bytes.
   */ function createInstructionWithPublicKey(params) {
                var publicKey = params.publicKey, message = params.message, signature = params.signature, instructionIndex = params.instructionIndex;
                $47b9aa0c5fbd17c3$var$assert(publicKey.length === $47b9aa0c5fbd17c3$var$PUBLIC_KEY_BYTES$1, "Public Key must be ".concat($47b9aa0c5fbd17c3$var$PUBLIC_KEY_BYTES$1, " bytes but received ").concat(publicKey.length, " bytes"));
                $47b9aa0c5fbd17c3$var$assert(signature.length === $47b9aa0c5fbd17c3$var$SIGNATURE_BYTES, "Signature must be ".concat($47b9aa0c5fbd17c3$var$SIGNATURE_BYTES, " bytes but received ").concat(signature.length, " bytes"));
                var publicKeyOffset = $47b9aa0c5fbd17c3$var$ED25519_INSTRUCTION_LAYOUT.span;
                var signatureOffset = publicKeyOffset + publicKey.length;
                var messageDataOffset = signatureOffset + signature.length;
                var numSignatures = 1;
                var instructionData = (0, $8dlmd.Buffer).alloc(messageDataOffset + message.length);
                var index = instructionIndex == null ? 0xffff // An index of `u16::MAX` makes it default to the current instruction.
                 : instructionIndex;
                $47b9aa0c5fbd17c3$var$ED25519_INSTRUCTION_LAYOUT.encode({
                    numSignatures: numSignatures,
                    padding: 0,
                    signatureOffset: signatureOffset,
                    signatureInstructionIndex: index,
                    publicKeyOffset: publicKeyOffset,
                    publicKeyInstructionIndex: index,
                    messageDataOffset: messageDataOffset,
                    messageDataSize: message.length,
                    messageInstructionIndex: index
                }, instructionData);
                instructionData.fill(publicKey, publicKeyOffset);
                instructionData.fill(signature, signatureOffset);
                instructionData.fill(message, messageDataOffset);
                return new $47b9aa0c5fbd17c3$export$a7a3aa8360ac9f59({
                    keys: [],
                    programId: Ed25519Program.programId,
                    data: instructionData
                });
            }
        },
        {
            key: "createInstructionWithPrivateKey",
            value: /**
   * Create an ed25519 instruction with a private key. The private key
   * must be a buffer that is 64 bytes long.
   */ function createInstructionWithPrivateKey(params) {
                var privateKey = params.privateKey, message = params.message, instructionIndex = params.instructionIndex;
                $47b9aa0c5fbd17c3$var$assert(privateKey.length === $47b9aa0c5fbd17c3$var$PRIVATE_KEY_BYTES$1, "Private key must be ".concat($47b9aa0c5fbd17c3$var$PRIVATE_KEY_BYTES$1, " bytes but received ").concat(privateKey.length, " bytes"));
                try {
                    var keypair = $47b9aa0c5fbd17c3$export$c53bca448cf33676.fromSecretKey(privateKey);
                    var publicKey = keypair.publicKey.toBytes();
                    var signature = $47b9aa0c5fbd17c3$var$sign(message, keypair.secretKey);
                    return this.createInstructionWithPublicKey({
                        publicKey: publicKey,
                        message: message,
                        signature: signature,
                        instructionIndex: instructionIndex
                    });
                } catch (error) {
                    throw new Error("Error creating instruction; ".concat(error));
                }
            }
        }
    ]);
    return Ed25519Program;
}();
$47b9aa0c5fbd17c3$export$e5087aea02631e.programId = new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de("Ed25519SigVerify111111111111111111111111111");
var $47b9aa0c5fbd17c3$var$ecdsaSign = function(msgHash, privKey) {
    var signature = (0, $2r5xP.secp256k1).sign(msgHash, privKey);
    return [
        signature.toCompactRawBytes(),
        signature.recovery
    ];
};
(0, $2r5xP.secp256k1).utils.isValidPrivateKey;
var $47b9aa0c5fbd17c3$var$publicKeyCreate = (0, $2r5xP.secp256k1).getPublicKey;
var $47b9aa0c5fbd17c3$var$PRIVATE_KEY_BYTES = 32;
var $47b9aa0c5fbd17c3$var$ETHEREUM_ADDRESS_BYTES = 20;
var $47b9aa0c5fbd17c3$var$PUBLIC_KEY_BYTES = 64;
var $47b9aa0c5fbd17c3$var$SIGNATURE_OFFSETS_SERIALIZED_SIZE = 11;
/**
 * Params for creating an secp256k1 instruction using a public key
 */ /**
 * Params for creating an secp256k1 instruction using an Ethereum address
 */ /**
 * Params for creating an secp256k1 instruction using a private key
 */ var $47b9aa0c5fbd17c3$var$SECP256K1_INSTRUCTION_LAYOUT = $jt90m.struct([
    $jt90m.u8("numSignatures"),
    $jt90m.u16("signatureOffset"),
    $jt90m.u8("signatureInstructionIndex"),
    $jt90m.u16("ethAddressOffset"),
    $jt90m.u8("ethAddressInstructionIndex"),
    $jt90m.u16("messageDataOffset"),
    $jt90m.u16("messageDataSize"),
    $jt90m.u8("messageInstructionIndex"),
    $jt90m.blob(20, "ethAddress"),
    $jt90m.blob(64, "signature"),
    $jt90m.u8("recoveryId")
]);
var $47b9aa0c5fbd17c3$export$d85dd4c1161d13c9 = /*#__PURE__*/ function() {
    "use strict";
    function Secp256k1Program() {
        (0, $4GJKx._)(this, Secp256k1Program);
    }
    (0, $1wc17._)(Secp256k1Program, null, [
        {
            key: "publicKeyToEthAddress",
            value: /**
   * Public key that identifies the secp256k1 program
   */ /**
   * Construct an Ethereum address from a secp256k1 public key buffer.
   * @param {Buffer} publicKey a 64 byte secp256k1 public key buffer
   */ function publicKeyToEthAddress(publicKey) {
                $47b9aa0c5fbd17c3$var$assert(publicKey.length === $47b9aa0c5fbd17c3$var$PUBLIC_KEY_BYTES, "Public key must be ".concat($47b9aa0c5fbd17c3$var$PUBLIC_KEY_BYTES, " bytes but received ").concat(publicKey.length, " bytes"));
                try {
                    return (0, $8dlmd.Buffer).from((0, $jlkmN.keccak_256)($47b9aa0c5fbd17c3$var$toBuffer(publicKey))).slice(-$47b9aa0c5fbd17c3$var$ETHEREUM_ADDRESS_BYTES);
                } catch (error) {
                    throw new Error("Error constructing Ethereum address: ".concat(error));
                }
            }
        },
        {
            key: "createInstructionWithPublicKey",
            value: /**
   * Create an secp256k1 instruction with a public key. The public key
   * must be a buffer that is 64 bytes long.
   */ function createInstructionWithPublicKey(params) {
                var publicKey = params.publicKey, message = params.message, signature = params.signature, recoveryId = params.recoveryId, instructionIndex = params.instructionIndex;
                return Secp256k1Program.createInstructionWithEthAddress({
                    ethAddress: Secp256k1Program.publicKeyToEthAddress(publicKey),
                    message: message,
                    signature: signature,
                    recoveryId: recoveryId,
                    instructionIndex: instructionIndex
                });
            }
        },
        {
            key: "createInstructionWithEthAddress",
            value: /**
   * Create an secp256k1 instruction with an Ethereum address. The address
   * must be a hex string or a buffer that is 20 bytes long.
   */ function createInstructionWithEthAddress(params) {
                var rawAddress = params.ethAddress, message = params.message, signature = params.signature, recoveryId = params.recoveryId, _params_instructionIndex = params.instructionIndex, instructionIndex = _params_instructionIndex === void 0 ? 0 : _params_instructionIndex;
                var ethAddress;
                if (typeof rawAddress === "string") {
                    if (rawAddress.startsWith("0x")) ethAddress = (0, $8dlmd.Buffer).from(rawAddress.substr(2), "hex");
                    else ethAddress = (0, $8dlmd.Buffer).from(rawAddress, "hex");
                } else ethAddress = rawAddress;
                $47b9aa0c5fbd17c3$var$assert(ethAddress.length === $47b9aa0c5fbd17c3$var$ETHEREUM_ADDRESS_BYTES, "Address must be ".concat($47b9aa0c5fbd17c3$var$ETHEREUM_ADDRESS_BYTES, " bytes but received ").concat(ethAddress.length, " bytes"));
                var dataStart = 1 + $47b9aa0c5fbd17c3$var$SIGNATURE_OFFSETS_SERIALIZED_SIZE;
                var ethAddressOffset = dataStart;
                var signatureOffset = dataStart + ethAddress.length;
                var messageDataOffset = signatureOffset + signature.length + 1;
                var numSignatures = 1;
                var instructionData = (0, $8dlmd.Buffer).alloc($47b9aa0c5fbd17c3$var$SECP256K1_INSTRUCTION_LAYOUT.span + message.length);
                $47b9aa0c5fbd17c3$var$SECP256K1_INSTRUCTION_LAYOUT.encode({
                    numSignatures: numSignatures,
                    signatureOffset: signatureOffset,
                    signatureInstructionIndex: instructionIndex,
                    ethAddressOffset: ethAddressOffset,
                    ethAddressInstructionIndex: instructionIndex,
                    messageDataOffset: messageDataOffset,
                    messageDataSize: message.length,
                    messageInstructionIndex: instructionIndex,
                    signature: $47b9aa0c5fbd17c3$var$toBuffer(signature),
                    ethAddress: $47b9aa0c5fbd17c3$var$toBuffer(ethAddress),
                    recoveryId: recoveryId
                }, instructionData);
                instructionData.fill($47b9aa0c5fbd17c3$var$toBuffer(message), $47b9aa0c5fbd17c3$var$SECP256K1_INSTRUCTION_LAYOUT.span);
                return new $47b9aa0c5fbd17c3$export$a7a3aa8360ac9f59({
                    keys: [],
                    programId: Secp256k1Program.programId,
                    data: instructionData
                });
            }
        },
        {
            key: "createInstructionWithPrivateKey",
            value: /**
   * Create an secp256k1 instruction with a private key. The private key
   * must be a buffer that is 32 bytes long.
   */ function createInstructionWithPrivateKey(params) {
                var pkey = params.privateKey, message = params.message, instructionIndex = params.instructionIndex;
                $47b9aa0c5fbd17c3$var$assert(pkey.length === $47b9aa0c5fbd17c3$var$PRIVATE_KEY_BYTES, "Private key must be ".concat($47b9aa0c5fbd17c3$var$PRIVATE_KEY_BYTES, " bytes but received ").concat(pkey.length, " bytes"));
                try {
                    var privateKey = $47b9aa0c5fbd17c3$var$toBuffer(pkey);
                    var publicKey = $47b9aa0c5fbd17c3$var$publicKeyCreate(privateKey, false).slice(1); // throw away leading byte
                    var messageHash = (0, $8dlmd.Buffer).from((0, $jlkmN.keccak_256)($47b9aa0c5fbd17c3$var$toBuffer(message)));
                    var _ecdsaSign = (0, $cv9Rk._)($47b9aa0c5fbd17c3$var$ecdsaSign(messageHash, privateKey), 2), signature = _ecdsaSign[0], recoveryId = _ecdsaSign[1];
                    return this.createInstructionWithPublicKey({
                        publicKey: publicKey,
                        message: message,
                        signature: signature,
                        recoveryId: recoveryId,
                        instructionIndex: instructionIndex
                    });
                } catch (error) {
                    throw new Error("Error creating instruction; ".concat(error));
                }
            }
        }
    ]);
    return Secp256k1Program;
}();
$47b9aa0c5fbd17c3$export$d85dd4c1161d13c9.programId = new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de("KeccakSecp256k11111111111111111111111111111");
var $47b9aa0c5fbd17c3$var$_Lockup;
/**
 * Address of the stake config account which configures the rate
 * of stake warmup and cooldown as well as the slashing penalty.
 */ var $47b9aa0c5fbd17c3$export$18aac71979bdd08f = new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de("StakeConfig11111111111111111111111111111111");
/**
 * Stake account authority info
 */ var $47b9aa0c5fbd17c3$export$9ac74ae66932a145 = function Authorized(staker, withdrawer) {
    "use strict";
    (0, $4GJKx._)(this, Authorized);
    /** stake authority */ this.staker = void 0;
    /** withdraw authority */ this.withdrawer = void 0;
    this.staker = staker;
    this.withdrawer = withdrawer;
};
/**
 * Stake account lockup info
 */ var $47b9aa0c5fbd17c3$export$e7f3941ade35598c = function Lockup(unixTimestamp, epoch, custodian) {
    "use strict";
    (0, $4GJKx._)(this, Lockup);
    /** Unix timestamp of lockup expiration */ this.unixTimestamp = void 0;
    /** Epoch of lockup expiration */ this.epoch = void 0;
    /** Lockup custodian authority */ this.custodian = void 0;
    this.unixTimestamp = unixTimestamp;
    this.epoch = epoch;
    this.custodian = custodian;
};
$47b9aa0c5fbd17c3$var$_Lockup = $47b9aa0c5fbd17c3$export$e7f3941ade35598c;
$47b9aa0c5fbd17c3$export$e7f3941ade35598c.default = new $47b9aa0c5fbd17c3$var$_Lockup(0, 0, $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de.default);
/**
 * Create stake account transaction params
 */ /**
 * Create stake account with seed transaction params
 */ /**
 * Initialize stake instruction params
 */ /**
 * Delegate stake instruction params
 */ /**
 * Authorize stake instruction params
 */ /**
 * Authorize stake instruction params using a derived key
 */ /**
 * Split stake instruction params
 */ /**
 * Split with seed transaction params
 */ /**
 * Withdraw stake instruction params
 */ /**
 * Deactivate stake instruction params
 */ /**
 * Merge stake instruction params
 */ /**
 * Stake Instruction class
 */ var $47b9aa0c5fbd17c3$export$aded313c3a4800f9 = /*#__PURE__*/ function() {
    "use strict";
    function StakeInstruction() {
        (0, $4GJKx._)(this, StakeInstruction);
    }
    (0, $1wc17._)(StakeInstruction, null, [
        {
            key: "decodeInstructionType",
            value: /**
   * Decode a stake instruction and retrieve the instruction type.
   */ function decodeInstructionType(instruction) {
                this.checkProgramId(instruction.programId);
                var instructionTypeLayout = $jt90m.u32("instruction");
                var typeIndex = instructionTypeLayout.decode(instruction.data);
                var _$type;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries($47b9aa0c5fbd17c3$export$c89793bd2bba8b2e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $cv9Rk._)(_step.value, 2), ixType = _step_value[0], layout = _step_value[1];
                        if (layout.index == typeIndex) {
                            _$type = ixType;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (!_$type) throw new Error("Instruction type incorrect; not a StakeInstruction");
                return _$type;
            }
        },
        {
            key: "decodeInitialize",
            value: /**
   * Decode a initialize stake instruction and retrieve the instruction params.
   */ function decodeInitialize(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 2);
                var _decodeData$1 = $47b9aa0c5fbd17c3$var$decodeData$1($47b9aa0c5fbd17c3$export$c89793bd2bba8b2e.Initialize, instruction.data), authorized = _decodeData$1.authorized, lockup = _decodeData$1.lockup;
                return {
                    stakePubkey: instruction.keys[0].pubkey,
                    authorized: new $47b9aa0c5fbd17c3$export$9ac74ae66932a145(new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(authorized.staker), new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(authorized.withdrawer)),
                    lockup: new $47b9aa0c5fbd17c3$export$e7f3941ade35598c(lockup.unixTimestamp, lockup.epoch, new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(lockup.custodian))
                };
            }
        },
        {
            key: "decodeDelegate",
            value: /**
   * Decode a delegate stake instruction and retrieve the instruction params.
   */ function decodeDelegate(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 6);
                $47b9aa0c5fbd17c3$var$decodeData$1($47b9aa0c5fbd17c3$export$c89793bd2bba8b2e.Delegate, instruction.data);
                return {
                    stakePubkey: instruction.keys[0].pubkey,
                    votePubkey: instruction.keys[1].pubkey,
                    authorizedPubkey: instruction.keys[5].pubkey
                };
            }
        },
        {
            key: "decodeAuthorize",
            value: /**
   * Decode an authorize stake instruction and retrieve the instruction params.
   */ function decodeAuthorize(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 3);
                var _decodeData$1 = $47b9aa0c5fbd17c3$var$decodeData$1($47b9aa0c5fbd17c3$export$c89793bd2bba8b2e.Authorize, instruction.data), newAuthorized = _decodeData$1.newAuthorized, stakeAuthorizationType = _decodeData$1.stakeAuthorizationType;
                var o = {
                    stakePubkey: instruction.keys[0].pubkey,
                    authorizedPubkey: instruction.keys[2].pubkey,
                    newAuthorizedPubkey: new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(newAuthorized),
                    stakeAuthorizationType: {
                        index: stakeAuthorizationType
                    }
                };
                if (instruction.keys.length > 3) o.custodianPubkey = instruction.keys[3].pubkey;
                return o;
            }
        },
        {
            key: "decodeAuthorizeWithSeed",
            value: /**
   * Decode an authorize-with-seed stake instruction and retrieve the instruction params.
   */ function decodeAuthorizeWithSeed(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 2);
                var _decodeData$1 = $47b9aa0c5fbd17c3$var$decodeData$1($47b9aa0c5fbd17c3$export$c89793bd2bba8b2e.AuthorizeWithSeed, instruction.data), newAuthorized = _decodeData$1.newAuthorized, stakeAuthorizationType = _decodeData$1.stakeAuthorizationType, authoritySeed = _decodeData$1.authoritySeed, authorityOwner = _decodeData$1.authorityOwner;
                var o = {
                    stakePubkey: instruction.keys[0].pubkey,
                    authorityBase: instruction.keys[1].pubkey,
                    authoritySeed: authoritySeed,
                    authorityOwner: new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(authorityOwner),
                    newAuthorizedPubkey: new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(newAuthorized),
                    stakeAuthorizationType: {
                        index: stakeAuthorizationType
                    }
                };
                if (instruction.keys.length > 3) o.custodianPubkey = instruction.keys[3].pubkey;
                return o;
            }
        },
        {
            key: "decodeSplit",
            value: /**
   * Decode a split stake instruction and retrieve the instruction params.
   */ function decodeSplit(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 3);
                var lamports = $47b9aa0c5fbd17c3$var$decodeData$1($47b9aa0c5fbd17c3$export$c89793bd2bba8b2e.Split, instruction.data).lamports;
                return {
                    stakePubkey: instruction.keys[0].pubkey,
                    splitStakePubkey: instruction.keys[1].pubkey,
                    authorizedPubkey: instruction.keys[2].pubkey,
                    lamports: lamports
                };
            }
        },
        {
            key: "decodeMerge",
            value: /**
   * Decode a merge stake instruction and retrieve the instruction params.
   */ function decodeMerge(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 3);
                $47b9aa0c5fbd17c3$var$decodeData$1($47b9aa0c5fbd17c3$export$c89793bd2bba8b2e.Merge, instruction.data);
                return {
                    stakePubkey: instruction.keys[0].pubkey,
                    sourceStakePubKey: instruction.keys[1].pubkey,
                    authorizedPubkey: instruction.keys[4].pubkey
                };
            }
        },
        {
            key: "decodeWithdraw",
            value: /**
   * Decode a withdraw stake instruction and retrieve the instruction params.
   */ function decodeWithdraw(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 5);
                var lamports = $47b9aa0c5fbd17c3$var$decodeData$1($47b9aa0c5fbd17c3$export$c89793bd2bba8b2e.Withdraw, instruction.data).lamports;
                var o = {
                    stakePubkey: instruction.keys[0].pubkey,
                    toPubkey: instruction.keys[1].pubkey,
                    authorizedPubkey: instruction.keys[4].pubkey,
                    lamports: lamports
                };
                if (instruction.keys.length > 5) o.custodianPubkey = instruction.keys[5].pubkey;
                return o;
            }
        },
        {
            key: "decodeDeactivate",
            value: /**
   * Decode a deactivate stake instruction and retrieve the instruction params.
   */ function decodeDeactivate(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 3);
                $47b9aa0c5fbd17c3$var$decodeData$1($47b9aa0c5fbd17c3$export$c89793bd2bba8b2e.Deactivate, instruction.data);
                return {
                    stakePubkey: instruction.keys[0].pubkey,
                    authorizedPubkey: instruction.keys[2].pubkey
                };
            }
        },
        {
            key: "checkProgramId",
            value: /**
   * @internal
   */ function checkProgramId(programId) {
                if (!programId.equals($47b9aa0c5fbd17c3$export$df86f933e9f8fb15.programId)) throw new Error("invalid instruction; programId is not StakeProgram");
            }
        },
        {
            key: "checkKeyLength",
            value: /**
   * @internal
   */ function checkKeyLength(keys, expectedLength) {
                if (keys.length < expectedLength) throw new Error("invalid instruction; found ".concat(keys.length, " keys, expected at least ").concat(expectedLength));
            }
        }
    ]);
    return StakeInstruction;
}();
/**
 * An enumeration of valid StakeInstructionType's
 */ /**
 * An enumeration of valid stake InstructionType's
 * @internal
 */ var $47b9aa0c5fbd17c3$export$c89793bd2bba8b2e = Object.freeze({
    Initialize: {
        index: 0,
        layout: $jt90m.struct([
            $jt90m.u32("instruction"),
            $47b9aa0c5fbd17c3$var$authorized(),
            $47b9aa0c5fbd17c3$var$lockup()
        ])
    },
    Authorize: {
        index: 1,
        layout: $jt90m.struct([
            $jt90m.u32("instruction"),
            $47b9aa0c5fbd17c3$var$publicKey("newAuthorized"),
            $jt90m.u32("stakeAuthorizationType")
        ])
    },
    Delegate: {
        index: 2,
        layout: $jt90m.struct([
            $jt90m.u32("instruction")
        ])
    },
    Split: {
        index: 3,
        layout: $jt90m.struct([
            $jt90m.u32("instruction"),
            $jt90m.ns64("lamports")
        ])
    },
    Withdraw: {
        index: 4,
        layout: $jt90m.struct([
            $jt90m.u32("instruction"),
            $jt90m.ns64("lamports")
        ])
    },
    Deactivate: {
        index: 5,
        layout: $jt90m.struct([
            $jt90m.u32("instruction")
        ])
    },
    Merge: {
        index: 7,
        layout: $jt90m.struct([
            $jt90m.u32("instruction")
        ])
    },
    AuthorizeWithSeed: {
        index: 8,
        layout: $jt90m.struct([
            $jt90m.u32("instruction"),
            $47b9aa0c5fbd17c3$var$publicKey("newAuthorized"),
            $jt90m.u32("stakeAuthorizationType"),
            $47b9aa0c5fbd17c3$var$rustString("authoritySeed"),
            $47b9aa0c5fbd17c3$var$publicKey("authorityOwner")
        ])
    }
});
/**
 * Stake authorization type
 */ /**
 * An enumeration of valid StakeAuthorizationLayout's
 */ var $47b9aa0c5fbd17c3$export$4783920eadd34361 = Object.freeze({
    Staker: {
        index: 0
    },
    Withdrawer: {
        index: 1
    }
});
/**
 * Factory class for transactions to interact with the Stake program
 */ var $47b9aa0c5fbd17c3$export$df86f933e9f8fb15 = /*#__PURE__*/ function() {
    "use strict";
    function StakeProgram() {
        (0, $4GJKx._)(this, StakeProgram);
    }
    (0, $1wc17._)(StakeProgram, null, [
        {
            key: "initialize",
            value: /**
   * Public key that identifies the Stake program
   */ /**
   * Generate an Initialize instruction to add to a Stake Create transaction
   */ function initialize(params) {
                var stakePubkey = params.stakePubkey, authorized = params.authorized, maybeLockup = params.lockup;
                var lockup = maybeLockup || $47b9aa0c5fbd17c3$export$e7f3941ade35598c.default;
                var _$type = $47b9aa0c5fbd17c3$export$c89793bd2bba8b2e.Initialize;
                var data = $47b9aa0c5fbd17c3$var$encodeData(_$type, {
                    authorized: {
                        staker: $47b9aa0c5fbd17c3$var$toBuffer(authorized.staker.toBuffer()),
                        withdrawer: $47b9aa0c5fbd17c3$var$toBuffer(authorized.withdrawer.toBuffer())
                    },
                    lockup: {
                        unixTimestamp: lockup.unixTimestamp,
                        epoch: lockup.epoch,
                        custodian: $47b9aa0c5fbd17c3$var$toBuffer(lockup.custodian.toBuffer())
                    }
                });
                var instructionData = {
                    keys: [
                        {
                            pubkey: stakePubkey,
                            isSigner: false,
                            isWritable: true
                        },
                        {
                            pubkey: $47b9aa0c5fbd17c3$export$970d0190cdb3a8e9,
                            isSigner: false,
                            isWritable: false
                        }
                    ],
                    programId: this.programId,
                    data: data
                };
                return new $47b9aa0c5fbd17c3$export$a7a3aa8360ac9f59(instructionData);
            }
        },
        {
            key: "createAccountWithSeed",
            value: /**
   * Generate a Transaction that creates a new Stake account at
   *   an address generated with `from`, a seed, and the Stake programId
   */ function createAccountWithSeed(params) {
                var transaction = new $47b9aa0c5fbd17c3$export$febc5573c75cefb0();
                transaction.add($47b9aa0c5fbd17c3$export$d8c4e17726848113.createAccountWithSeed({
                    fromPubkey: params.fromPubkey,
                    newAccountPubkey: params.stakePubkey,
                    basePubkey: params.basePubkey,
                    seed: params.seed,
                    lamports: params.lamports,
                    space: this.space,
                    programId: this.programId
                }));
                var stakePubkey = params.stakePubkey, authorized = params.authorized, lockup = params.lockup;
                return transaction.add(this.initialize({
                    stakePubkey: stakePubkey,
                    authorized: authorized,
                    lockup: lockup
                }));
            }
        },
        {
            key: "createAccount",
            value: /**
   * Generate a Transaction that creates a new Stake account
   */ function createAccount(params) {
                var transaction = new $47b9aa0c5fbd17c3$export$febc5573c75cefb0();
                transaction.add($47b9aa0c5fbd17c3$export$d8c4e17726848113.createAccount({
                    fromPubkey: params.fromPubkey,
                    newAccountPubkey: params.stakePubkey,
                    lamports: params.lamports,
                    space: this.space,
                    programId: this.programId
                }));
                var stakePubkey = params.stakePubkey, authorized = params.authorized, lockup = params.lockup;
                return transaction.add(this.initialize({
                    stakePubkey: stakePubkey,
                    authorized: authorized,
                    lockup: lockup
                }));
            }
        },
        {
            key: "delegate",
            value: /**
   * Generate a Transaction that delegates Stake tokens to a validator
   * Vote PublicKey. This transaction can also be used to redelegate Stake
   * to a new validator Vote PublicKey.
   */ function delegate(params) {
                var stakePubkey = params.stakePubkey, authorizedPubkey = params.authorizedPubkey, votePubkey = params.votePubkey;
                var _$type = $47b9aa0c5fbd17c3$export$c89793bd2bba8b2e.Delegate;
                var data = $47b9aa0c5fbd17c3$var$encodeData(_$type);
                return new $47b9aa0c5fbd17c3$export$febc5573c75cefb0().add({
                    keys: [
                        {
                            pubkey: stakePubkey,
                            isSigner: false,
                            isWritable: true
                        },
                        {
                            pubkey: votePubkey,
                            isSigner: false,
                            isWritable: false
                        },
                        {
                            pubkey: $47b9aa0c5fbd17c3$export$393aa1412d47050e,
                            isSigner: false,
                            isWritable: false
                        },
                        {
                            pubkey: $47b9aa0c5fbd17c3$export$ca994171317280ea,
                            isSigner: false,
                            isWritable: false
                        },
                        {
                            pubkey: $47b9aa0c5fbd17c3$export$18aac71979bdd08f,
                            isSigner: false,
                            isWritable: false
                        },
                        {
                            pubkey: authorizedPubkey,
                            isSigner: true,
                            isWritable: false
                        }
                    ],
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "authorize",
            value: /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */ function authorize(params) {
                var stakePubkey = params.stakePubkey, authorizedPubkey = params.authorizedPubkey, newAuthorizedPubkey = params.newAuthorizedPubkey, stakeAuthorizationType = params.stakeAuthorizationType, custodianPubkey = params.custodianPubkey;
                var _$type = $47b9aa0c5fbd17c3$export$c89793bd2bba8b2e.Authorize;
                var data = $47b9aa0c5fbd17c3$var$encodeData(_$type, {
                    newAuthorized: $47b9aa0c5fbd17c3$var$toBuffer(newAuthorizedPubkey.toBuffer()),
                    stakeAuthorizationType: stakeAuthorizationType.index
                });
                var keys = [
                    {
                        pubkey: stakePubkey,
                        isSigner: false,
                        isWritable: true
                    },
                    {
                        pubkey: $47b9aa0c5fbd17c3$export$393aa1412d47050e,
                        isSigner: false,
                        isWritable: true
                    },
                    {
                        pubkey: authorizedPubkey,
                        isSigner: true,
                        isWritable: false
                    }
                ];
                if (custodianPubkey) keys.push({
                    pubkey: custodianPubkey,
                    isSigner: true,
                    isWritable: false
                });
                return new $47b9aa0c5fbd17c3$export$febc5573c75cefb0().add({
                    keys: keys,
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "authorizeWithSeed",
            value: /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */ function authorizeWithSeed(params) {
                var stakePubkey = params.stakePubkey, authorityBase = params.authorityBase, authoritySeed = params.authoritySeed, authorityOwner = params.authorityOwner, newAuthorizedPubkey = params.newAuthorizedPubkey, stakeAuthorizationType = params.stakeAuthorizationType, custodianPubkey = params.custodianPubkey;
                var _$type = $47b9aa0c5fbd17c3$export$c89793bd2bba8b2e.AuthorizeWithSeed;
                var data = $47b9aa0c5fbd17c3$var$encodeData(_$type, {
                    newAuthorized: $47b9aa0c5fbd17c3$var$toBuffer(newAuthorizedPubkey.toBuffer()),
                    stakeAuthorizationType: stakeAuthorizationType.index,
                    authoritySeed: authoritySeed,
                    authorityOwner: $47b9aa0c5fbd17c3$var$toBuffer(authorityOwner.toBuffer())
                });
                var keys = [
                    {
                        pubkey: stakePubkey,
                        isSigner: false,
                        isWritable: true
                    },
                    {
                        pubkey: authorityBase,
                        isSigner: true,
                        isWritable: false
                    },
                    {
                        pubkey: $47b9aa0c5fbd17c3$export$393aa1412d47050e,
                        isSigner: false,
                        isWritable: false
                    }
                ];
                if (custodianPubkey) keys.push({
                    pubkey: custodianPubkey,
                    isSigner: true,
                    isWritable: false
                });
                return new $47b9aa0c5fbd17c3$export$febc5573c75cefb0().add({
                    keys: keys,
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "splitInstruction",
            value: /**
   * @internal
   */ function splitInstruction(params) {
                var stakePubkey = params.stakePubkey, authorizedPubkey = params.authorizedPubkey, splitStakePubkey = params.splitStakePubkey, lamports = params.lamports;
                var _$type = $47b9aa0c5fbd17c3$export$c89793bd2bba8b2e.Split;
                var data = $47b9aa0c5fbd17c3$var$encodeData(_$type, {
                    lamports: lamports
                });
                return new $47b9aa0c5fbd17c3$export$a7a3aa8360ac9f59({
                    keys: [
                        {
                            pubkey: stakePubkey,
                            isSigner: false,
                            isWritable: true
                        },
                        {
                            pubkey: splitStakePubkey,
                            isSigner: false,
                            isWritable: true
                        },
                        {
                            pubkey: authorizedPubkey,
                            isSigner: true,
                            isWritable: false
                        }
                    ],
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "split",
            value: /**
   * Generate a Transaction that splits Stake tokens into another stake account
   */ function split(params, // Compute the cost of allocating the new stake account in lamports
            rentExemptReserve) {
                var transaction = new $47b9aa0c5fbd17c3$export$febc5573c75cefb0();
                transaction.add($47b9aa0c5fbd17c3$export$d8c4e17726848113.createAccount({
                    fromPubkey: params.authorizedPubkey,
                    newAccountPubkey: params.splitStakePubkey,
                    lamports: rentExemptReserve,
                    space: this.space,
                    programId: this.programId
                }));
                return transaction.add(this.splitInstruction(params));
            }
        },
        {
            key: "splitWithSeed",
            value: /**
   * Generate a Transaction that splits Stake tokens into another account
   * derived from a base public key and seed
   */ function splitWithSeed(params, // If this stake account is new, compute the cost of allocating it in lamports
            rentExemptReserve) {
                var stakePubkey = params.stakePubkey, authorizedPubkey = params.authorizedPubkey, splitStakePubkey = params.splitStakePubkey, basePubkey = params.basePubkey, seed = params.seed, lamports = params.lamports;
                var transaction = new $47b9aa0c5fbd17c3$export$febc5573c75cefb0();
                transaction.add($47b9aa0c5fbd17c3$export$d8c4e17726848113.allocate({
                    accountPubkey: splitStakePubkey,
                    basePubkey: basePubkey,
                    seed: seed,
                    space: this.space,
                    programId: this.programId
                }));
                if (rentExemptReserve && rentExemptReserve > 0) transaction.add($47b9aa0c5fbd17c3$export$d8c4e17726848113.transfer({
                    fromPubkey: params.authorizedPubkey,
                    toPubkey: splitStakePubkey,
                    lamports: rentExemptReserve
                }));
                return transaction.add(this.splitInstruction({
                    stakePubkey: stakePubkey,
                    authorizedPubkey: authorizedPubkey,
                    splitStakePubkey: splitStakePubkey,
                    lamports: lamports
                }));
            }
        },
        {
            key: "merge",
            value: /**
   * Generate a Transaction that merges Stake accounts.
   */ function merge(params) {
                var stakePubkey = params.stakePubkey, sourceStakePubKey = params.sourceStakePubKey, authorizedPubkey = params.authorizedPubkey;
                var _$type = $47b9aa0c5fbd17c3$export$c89793bd2bba8b2e.Merge;
                var data = $47b9aa0c5fbd17c3$var$encodeData(_$type);
                return new $47b9aa0c5fbd17c3$export$febc5573c75cefb0().add({
                    keys: [
                        {
                            pubkey: stakePubkey,
                            isSigner: false,
                            isWritable: true
                        },
                        {
                            pubkey: sourceStakePubKey,
                            isSigner: false,
                            isWritable: true
                        },
                        {
                            pubkey: $47b9aa0c5fbd17c3$export$393aa1412d47050e,
                            isSigner: false,
                            isWritable: false
                        },
                        {
                            pubkey: $47b9aa0c5fbd17c3$export$ca994171317280ea,
                            isSigner: false,
                            isWritable: false
                        },
                        {
                            pubkey: authorizedPubkey,
                            isSigner: true,
                            isWritable: false
                        }
                    ],
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "withdraw",
            value: /**
   * Generate a Transaction that withdraws deactivated Stake tokens.
   */ function withdraw(params) {
                var stakePubkey = params.stakePubkey, authorizedPubkey = params.authorizedPubkey, toPubkey = params.toPubkey, lamports = params.lamports, custodianPubkey = params.custodianPubkey;
                var _$type = $47b9aa0c5fbd17c3$export$c89793bd2bba8b2e.Withdraw;
                var data = $47b9aa0c5fbd17c3$var$encodeData(_$type, {
                    lamports: lamports
                });
                var keys = [
                    {
                        pubkey: stakePubkey,
                        isSigner: false,
                        isWritable: true
                    },
                    {
                        pubkey: toPubkey,
                        isSigner: false,
                        isWritable: true
                    },
                    {
                        pubkey: $47b9aa0c5fbd17c3$export$393aa1412d47050e,
                        isSigner: false,
                        isWritable: false
                    },
                    {
                        pubkey: $47b9aa0c5fbd17c3$export$ca994171317280ea,
                        isSigner: false,
                        isWritable: false
                    },
                    {
                        pubkey: authorizedPubkey,
                        isSigner: true,
                        isWritable: false
                    }
                ];
                if (custodianPubkey) keys.push({
                    pubkey: custodianPubkey,
                    isSigner: true,
                    isWritable: false
                });
                return new $47b9aa0c5fbd17c3$export$febc5573c75cefb0().add({
                    keys: keys,
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "deactivate",
            value: /**
   * Generate a Transaction that deactivates Stake tokens.
   */ function deactivate(params) {
                var stakePubkey = params.stakePubkey, authorizedPubkey = params.authorizedPubkey;
                var _$type = $47b9aa0c5fbd17c3$export$c89793bd2bba8b2e.Deactivate;
                var data = $47b9aa0c5fbd17c3$var$encodeData(_$type);
                return new $47b9aa0c5fbd17c3$export$febc5573c75cefb0().add({
                    keys: [
                        {
                            pubkey: stakePubkey,
                            isSigner: false,
                            isWritable: true
                        },
                        {
                            pubkey: $47b9aa0c5fbd17c3$export$393aa1412d47050e,
                            isSigner: false,
                            isWritable: false
                        },
                        {
                            pubkey: authorizedPubkey,
                            isSigner: true,
                            isWritable: false
                        }
                    ],
                    programId: this.programId,
                    data: data
                });
            }
        }
    ]);
    return StakeProgram;
}();
$47b9aa0c5fbd17c3$export$df86f933e9f8fb15.programId = new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de("Stake11111111111111111111111111111111111111");
/**
 * Max space of a Stake account
 *
 * This is generated from the solana-stake-program StakeState struct as
 * `StakeStateV2::size_of()`:
 * https://docs.rs/solana-stake-program/latest/solana_stake_program/stake_state/enum.StakeStateV2.html
 */ $47b9aa0c5fbd17c3$export$df86f933e9f8fb15.space = 200;
/**
 * Vote account info
 */ var $47b9aa0c5fbd17c3$export$3f9d1b16ff840d7 = function VoteInit(nodePubkey, authorizedVoter, authorizedWithdrawer, commission) {
    "use strict";
    (0, $4GJKx._)(this, VoteInit);
    this.nodePubkey = void 0;
    this.authorizedVoter = void 0;
    this.authorizedWithdrawer = void 0;
    this.commission = void 0;
    this.nodePubkey = nodePubkey;
    this.authorizedVoter = authorizedVoter;
    this.authorizedWithdrawer = authorizedWithdrawer;
    this.commission = commission;
};
/**
 * Create vote account transaction params
 */ /**
 * InitializeAccount instruction params
 */ /**
 * Authorize instruction params
 */ /**
 * AuthorizeWithSeed instruction params
 */ /**
 * Withdraw from vote account transaction params
 */ /**
 * Update validator identity (node pubkey) vote account instruction params.
 */ /**
 * Vote Instruction class
 */ var $47b9aa0c5fbd17c3$export$af8300401fc56047 = /*#__PURE__*/ function() {
    "use strict";
    function VoteInstruction() {
        (0, $4GJKx._)(this, VoteInstruction);
    }
    (0, $1wc17._)(VoteInstruction, null, [
        {
            key: "decodeInstructionType",
            value: /**
   * Decode a vote instruction and retrieve the instruction type.
   */ function decodeInstructionType(instruction) {
                this.checkProgramId(instruction.programId);
                var instructionTypeLayout = $jt90m.u32("instruction");
                var typeIndex = instructionTypeLayout.decode(instruction.data);
                var _$type;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries($47b9aa0c5fbd17c3$var$VOTE_INSTRUCTION_LAYOUTS)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $cv9Rk._)(_step.value, 2), ixType = _step_value[0], layout = _step_value[1];
                        if (layout.index == typeIndex) {
                            _$type = ixType;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (!_$type) throw new Error("Instruction type incorrect; not a VoteInstruction");
                return _$type;
            }
        },
        {
            key: "decodeInitializeAccount",
            value: /**
   * Decode an initialize vote instruction and retrieve the instruction params.
   */ function decodeInitializeAccount(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 4);
                var voteInit = $47b9aa0c5fbd17c3$var$decodeData$1($47b9aa0c5fbd17c3$var$VOTE_INSTRUCTION_LAYOUTS.InitializeAccount, instruction.data).voteInit;
                return {
                    votePubkey: instruction.keys[0].pubkey,
                    nodePubkey: instruction.keys[3].pubkey,
                    voteInit: new $47b9aa0c5fbd17c3$export$3f9d1b16ff840d7(new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(voteInit.nodePubkey), new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(voteInit.authorizedVoter), new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(voteInit.authorizedWithdrawer), voteInit.commission)
                };
            }
        },
        {
            key: "decodeAuthorize",
            value: /**
   * Decode an authorize instruction and retrieve the instruction params.
   */ function decodeAuthorize(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 3);
                var _decodeData$1 = $47b9aa0c5fbd17c3$var$decodeData$1($47b9aa0c5fbd17c3$var$VOTE_INSTRUCTION_LAYOUTS.Authorize, instruction.data), newAuthorized = _decodeData$1.newAuthorized, voteAuthorizationType = _decodeData$1.voteAuthorizationType;
                return {
                    votePubkey: instruction.keys[0].pubkey,
                    authorizedPubkey: instruction.keys[2].pubkey,
                    newAuthorizedPubkey: new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(newAuthorized),
                    voteAuthorizationType: {
                        index: voteAuthorizationType
                    }
                };
            }
        },
        {
            key: "decodeAuthorizeWithSeed",
            value: /**
   * Decode an authorize instruction and retrieve the instruction params.
   */ function decodeAuthorizeWithSeed(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 3);
                var _decodeData$1 = $47b9aa0c5fbd17c3$var$decodeData$1($47b9aa0c5fbd17c3$var$VOTE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed, instruction.data), _decodeData$1_voteAuthorizeWithSeedArgs = _decodeData$1.voteAuthorizeWithSeedArgs, currentAuthorityDerivedKeyOwnerPubkey = _decodeData$1_voteAuthorizeWithSeedArgs.currentAuthorityDerivedKeyOwnerPubkey, currentAuthorityDerivedKeySeed = _decodeData$1_voteAuthorizeWithSeedArgs.currentAuthorityDerivedKeySeed, newAuthorized = _decodeData$1_voteAuthorizeWithSeedArgs.newAuthorized, voteAuthorizationType = _decodeData$1_voteAuthorizeWithSeedArgs.voteAuthorizationType;
                return {
                    currentAuthorityDerivedKeyBasePubkey: instruction.keys[2].pubkey,
                    currentAuthorityDerivedKeyOwnerPubkey: new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(currentAuthorityDerivedKeyOwnerPubkey),
                    currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed,
                    newAuthorizedPubkey: new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(newAuthorized),
                    voteAuthorizationType: {
                        index: voteAuthorizationType
                    },
                    votePubkey: instruction.keys[0].pubkey
                };
            }
        },
        {
            key: "decodeWithdraw",
            value: /**
   * Decode a withdraw instruction and retrieve the instruction params.
   */ function decodeWithdraw(instruction) {
                this.checkProgramId(instruction.programId);
                this.checkKeyLength(instruction.keys, 3);
                var lamports = $47b9aa0c5fbd17c3$var$decodeData$1($47b9aa0c5fbd17c3$var$VOTE_INSTRUCTION_LAYOUTS.Withdraw, instruction.data).lamports;
                return {
                    votePubkey: instruction.keys[0].pubkey,
                    authorizedWithdrawerPubkey: instruction.keys[2].pubkey,
                    lamports: lamports,
                    toPubkey: instruction.keys[1].pubkey
                };
            }
        },
        {
            key: "checkProgramId",
            value: /**
   * @internal
   */ function checkProgramId(programId) {
                if (!programId.equals($47b9aa0c5fbd17c3$export$83db2bc702bee1eb.programId)) throw new Error("invalid instruction; programId is not VoteProgram");
            }
        },
        {
            key: "checkKeyLength",
            value: /**
   * @internal
   */ function checkKeyLength(keys, expectedLength) {
                if (keys.length < expectedLength) throw new Error("invalid instruction; found ".concat(keys.length, " keys, expected at least ").concat(expectedLength));
            }
        }
    ]);
    return VoteInstruction;
}();
/**
 * An enumeration of valid VoteInstructionType's
 */ /** @internal */ var $47b9aa0c5fbd17c3$var$VOTE_INSTRUCTION_LAYOUTS = Object.freeze({
    InitializeAccount: {
        index: 0,
        layout: $jt90m.struct([
            $jt90m.u32("instruction"),
            $47b9aa0c5fbd17c3$var$voteInit()
        ])
    },
    Authorize: {
        index: 1,
        layout: $jt90m.struct([
            $jt90m.u32("instruction"),
            $47b9aa0c5fbd17c3$var$publicKey("newAuthorized"),
            $jt90m.u32("voteAuthorizationType")
        ])
    },
    Withdraw: {
        index: 3,
        layout: $jt90m.struct([
            $jt90m.u32("instruction"),
            $jt90m.ns64("lamports")
        ])
    },
    UpdateValidatorIdentity: {
        index: 4,
        layout: $jt90m.struct([
            $jt90m.u32("instruction")
        ])
    },
    AuthorizeWithSeed: {
        index: 10,
        layout: $jt90m.struct([
            $jt90m.u32("instruction"),
            $47b9aa0c5fbd17c3$var$voteAuthorizeWithSeedArgs()
        ])
    }
});
/**
 * VoteAuthorize type
 */ /**
 * An enumeration of valid VoteAuthorization layouts.
 */ var $47b9aa0c5fbd17c3$export$3f2a92246fa9f71c = Object.freeze({
    Voter: {
        index: 0
    },
    Withdrawer: {
        index: 1
    }
});
/**
 * Factory class for transactions to interact with the Vote program
 */ var $47b9aa0c5fbd17c3$export$83db2bc702bee1eb = /*#__PURE__*/ function() {
    "use strict";
    function VoteProgram() {
        (0, $4GJKx._)(this, VoteProgram);
    }
    (0, $1wc17._)(VoteProgram, null, [
        {
            key: "initializeAccount",
            value: /**
   * Public key that identifies the Vote program
   */ /**
   * Generate an Initialize instruction.
   */ function initializeAccount(params) {
                var votePubkey = params.votePubkey, nodePubkey = params.nodePubkey, voteInit = params.voteInit;
                var _$type = $47b9aa0c5fbd17c3$var$VOTE_INSTRUCTION_LAYOUTS.InitializeAccount;
                var data = $47b9aa0c5fbd17c3$var$encodeData(_$type, {
                    voteInit: {
                        nodePubkey: $47b9aa0c5fbd17c3$var$toBuffer(voteInit.nodePubkey.toBuffer()),
                        authorizedVoter: $47b9aa0c5fbd17c3$var$toBuffer(voteInit.authorizedVoter.toBuffer()),
                        authorizedWithdrawer: $47b9aa0c5fbd17c3$var$toBuffer(voteInit.authorizedWithdrawer.toBuffer()),
                        commission: voteInit.commission
                    }
                });
                var instructionData = {
                    keys: [
                        {
                            pubkey: votePubkey,
                            isSigner: false,
                            isWritable: true
                        },
                        {
                            pubkey: $47b9aa0c5fbd17c3$export$970d0190cdb3a8e9,
                            isSigner: false,
                            isWritable: false
                        },
                        {
                            pubkey: $47b9aa0c5fbd17c3$export$393aa1412d47050e,
                            isSigner: false,
                            isWritable: false
                        },
                        {
                            pubkey: nodePubkey,
                            isSigner: true,
                            isWritable: false
                        }
                    ],
                    programId: this.programId,
                    data: data
                };
                return new $47b9aa0c5fbd17c3$export$a7a3aa8360ac9f59(instructionData);
            }
        },
        {
            key: "createAccount",
            value: /**
   * Generate a transaction that creates a new Vote account.
   */ function createAccount(params) {
                var transaction = new $47b9aa0c5fbd17c3$export$febc5573c75cefb0();
                transaction.add($47b9aa0c5fbd17c3$export$d8c4e17726848113.createAccount({
                    fromPubkey: params.fromPubkey,
                    newAccountPubkey: params.votePubkey,
                    lamports: params.lamports,
                    space: this.space,
                    programId: this.programId
                }));
                return transaction.add(this.initializeAccount({
                    votePubkey: params.votePubkey,
                    nodePubkey: params.voteInit.nodePubkey,
                    voteInit: params.voteInit
                }));
            }
        },
        {
            key: "authorize",
            value: /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account.
   */ function authorize(params) {
                var votePubkey = params.votePubkey, authorizedPubkey = params.authorizedPubkey, newAuthorizedPubkey = params.newAuthorizedPubkey, voteAuthorizationType = params.voteAuthorizationType;
                var _$type = $47b9aa0c5fbd17c3$var$VOTE_INSTRUCTION_LAYOUTS.Authorize;
                var data = $47b9aa0c5fbd17c3$var$encodeData(_$type, {
                    newAuthorized: $47b9aa0c5fbd17c3$var$toBuffer(newAuthorizedPubkey.toBuffer()),
                    voteAuthorizationType: voteAuthorizationType.index
                });
                var keys = [
                    {
                        pubkey: votePubkey,
                        isSigner: false,
                        isWritable: true
                    },
                    {
                        pubkey: $47b9aa0c5fbd17c3$export$393aa1412d47050e,
                        isSigner: false,
                        isWritable: false
                    },
                    {
                        pubkey: authorizedPubkey,
                        isSigner: true,
                        isWritable: false
                    }
                ];
                return new $47b9aa0c5fbd17c3$export$febc5573c75cefb0().add({
                    keys: keys,
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "authorizeWithSeed",
            value: /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account
   * where the current Voter or Withdrawer authority is a derived key.
   */ function authorizeWithSeed(params) {
                var currentAuthorityDerivedKeyBasePubkey = params.currentAuthorityDerivedKeyBasePubkey, currentAuthorityDerivedKeyOwnerPubkey = params.currentAuthorityDerivedKeyOwnerPubkey, currentAuthorityDerivedKeySeed = params.currentAuthorityDerivedKeySeed, newAuthorizedPubkey = params.newAuthorizedPubkey, voteAuthorizationType = params.voteAuthorizationType, votePubkey = params.votePubkey;
                var _$type = $47b9aa0c5fbd17c3$var$VOTE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed;
                var data = $47b9aa0c5fbd17c3$var$encodeData(_$type, {
                    voteAuthorizeWithSeedArgs: {
                        currentAuthorityDerivedKeyOwnerPubkey: $47b9aa0c5fbd17c3$var$toBuffer(currentAuthorityDerivedKeyOwnerPubkey.toBuffer()),
                        currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed,
                        newAuthorized: $47b9aa0c5fbd17c3$var$toBuffer(newAuthorizedPubkey.toBuffer()),
                        voteAuthorizationType: voteAuthorizationType.index
                    }
                });
                var keys = [
                    {
                        pubkey: votePubkey,
                        isSigner: false,
                        isWritable: true
                    },
                    {
                        pubkey: $47b9aa0c5fbd17c3$export$393aa1412d47050e,
                        isSigner: false,
                        isWritable: false
                    },
                    {
                        pubkey: currentAuthorityDerivedKeyBasePubkey,
                        isSigner: true,
                        isWritable: false
                    }
                ];
                return new $47b9aa0c5fbd17c3$export$febc5573c75cefb0().add({
                    keys: keys,
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "withdraw",
            value: /**
   * Generate a transaction to withdraw from a Vote account.
   */ function withdraw(params) {
                var votePubkey = params.votePubkey, authorizedWithdrawerPubkey = params.authorizedWithdrawerPubkey, lamports = params.lamports, toPubkey = params.toPubkey;
                var _$type = $47b9aa0c5fbd17c3$var$VOTE_INSTRUCTION_LAYOUTS.Withdraw;
                var data = $47b9aa0c5fbd17c3$var$encodeData(_$type, {
                    lamports: lamports
                });
                var keys = [
                    {
                        pubkey: votePubkey,
                        isSigner: false,
                        isWritable: true
                    },
                    {
                        pubkey: toPubkey,
                        isSigner: false,
                        isWritable: true
                    },
                    {
                        pubkey: authorizedWithdrawerPubkey,
                        isSigner: true,
                        isWritable: false
                    }
                ];
                return new $47b9aa0c5fbd17c3$export$febc5573c75cefb0().add({
                    keys: keys,
                    programId: this.programId,
                    data: data
                });
            }
        },
        {
            key: "safeWithdraw",
            value: /**
   * Generate a transaction to withdraw safely from a Vote account.
   *
   * This function was created as a safeguard for vote accounts running validators, `safeWithdraw`
   * checks that the withdraw amount will not exceed the specified balance while leaving enough left
   * to cover rent. If you wish to close the vote account by withdrawing the full amount, call the
   * `withdraw` method directly.
   */ function safeWithdraw(params, currentVoteAccountBalance, rentExemptMinimum) {
                if (params.lamports > currentVoteAccountBalance - rentExemptMinimum) throw new Error("Withdraw will leave vote account with insufficient funds.");
                return VoteProgram.withdraw(params);
            }
        },
        {
            key: "updateValidatorIdentity",
            value: /**
   * Generate a transaction to update the validator identity (node pubkey) of a Vote account.
   */ function updateValidatorIdentity(params) {
                var votePubkey = params.votePubkey, authorizedWithdrawerPubkey = params.authorizedWithdrawerPubkey, nodePubkey = params.nodePubkey;
                var _$type = $47b9aa0c5fbd17c3$var$VOTE_INSTRUCTION_LAYOUTS.UpdateValidatorIdentity;
                var data = $47b9aa0c5fbd17c3$var$encodeData(_$type);
                var keys = [
                    {
                        pubkey: votePubkey,
                        isSigner: false,
                        isWritable: true
                    },
                    {
                        pubkey: nodePubkey,
                        isSigner: true,
                        isWritable: false
                    },
                    {
                        pubkey: authorizedWithdrawerPubkey,
                        isSigner: true,
                        isWritable: false
                    }
                ];
                return new $47b9aa0c5fbd17c3$export$febc5573c75cefb0().add({
                    keys: keys,
                    programId: this.programId,
                    data: data
                });
            }
        }
    ]);
    return VoteProgram;
}();
$47b9aa0c5fbd17c3$export$83db2bc702bee1eb.programId = new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de("Vote111111111111111111111111111111111111111");
/**
 * Max space of a Vote account
 *
 * This is generated from the solana-vote-program VoteState struct as
 * `VoteState::size_of()`:
 * https://docs.rs/solana-vote-program/1.9.5/solana_vote_program/vote_state/struct.VoteState.html#method.size_of
 *
 * KEEP IN SYNC WITH `VoteState::size_of()` in https://github.com/solana-labs/solana/blob/a474cb24b9238f5edcc982f65c0b37d4a1046f7e/sdk/program/src/vote/state/mod.rs#L340-L342
 */ $47b9aa0c5fbd17c3$export$83db2bc702bee1eb.space = 3762;
var $47b9aa0c5fbd17c3$export$afdb09d3afdde87c = new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de("Va1idator1nfo111111111111111111111111111111");
/**
 * @internal
 */ /**
 * Info used to identity validators.
 */ var $47b9aa0c5fbd17c3$var$InfoString = (0, $58xNN.type)({
    name: (0, $58xNN.string)(),
    website: (0, $58xNN.optional)((0, $58xNN.string)()),
    details: (0, $58xNN.optional)((0, $58xNN.string)()),
    iconUrl: (0, $58xNN.optional)((0, $58xNN.string)()),
    keybaseUsername: (0, $58xNN.optional)((0, $58xNN.string)())
});
/**
 * ValidatorInfo class
 */ var $47b9aa0c5fbd17c3$export$152d279cf067309b = /*#__PURE__*/ function() {
    "use strict";
    function ValidatorInfo(key, info) {
        (0, $4GJKx._)(this, ValidatorInfo);
        /**
     * validator public key
     */ this.key = void 0;
        /**
     * validator information
     */ this.info = void 0;
        this.key = key;
        this.info = info;
    }
    (0, $1wc17._)(ValidatorInfo, null, [
        {
            key: "fromConfigData",
            value: /**
   * Deserialize ValidatorInfo from the config account data. Exactly two config
   * keys are required in the data.
   *
   * @param buffer config account data
   * @return null if info was not found
   */ function fromConfigData(buffer) {
                var byteArray = (0, $c6Xmf._)(buffer);
                var configKeyCount = $47b9aa0c5fbd17c3$var$decodeLength(byteArray);
                if (configKeyCount !== 2) return null;
                var configKeys = [];
                for(var i = 0; i < 2; i++){
                    var publicKey = new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de($47b9aa0c5fbd17c3$var$guardedSplice(byteArray, 0, $47b9aa0c5fbd17c3$export$84fc0a248cc54343));
                    var isSigner = $47b9aa0c5fbd17c3$var$guardedShift(byteArray) === 1;
                    configKeys.push({
                        publicKey: publicKey,
                        isSigner: isSigner
                    });
                }
                if (configKeys[0].publicKey.equals($47b9aa0c5fbd17c3$export$afdb09d3afdde87c)) {
                    if (configKeys[1].isSigner) {
                        var rawInfo = $47b9aa0c5fbd17c3$var$rustString().decode((0, $8dlmd.Buffer).from(byteArray));
                        var info = JSON.parse(rawInfo);
                        (0, $58xNN.assert)(info, $47b9aa0c5fbd17c3$var$InfoString);
                        return new ValidatorInfo(configKeys[1].publicKey, info);
                    }
                }
                return null;
            }
        }
    ]);
    return ValidatorInfo;
}();
var $47b9aa0c5fbd17c3$export$90bca02a3aea0768 = new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de("Vote111111111111111111111111111111111111111");
/**
 * History of how many credits earned by the end of each epoch
 */ /**
 * See https://github.com/solana-labs/solana/blob/8a12ed029cfa38d4a45400916c2463fb82bbec8c/programs/vote_api/src/vote_state.rs#L68-L88
 *
 * @internal
 */ var $47b9aa0c5fbd17c3$var$VoteAccountLayout = $jt90m.struct([
    $47b9aa0c5fbd17c3$var$publicKey("nodePubkey"),
    $47b9aa0c5fbd17c3$var$publicKey("authorizedWithdrawer"),
    $jt90m.u8("commission"),
    $jt90m.nu64(),
    // votes.length
    $jt90m.seq($jt90m.struct([
        $jt90m.nu64("slot"),
        $jt90m.u32("confirmationCount")
    ]), $jt90m.offset($jt90m.u32(), -8), "votes"),
    $jt90m.u8("rootSlotValid"),
    $jt90m.nu64("rootSlot"),
    $jt90m.nu64(),
    // authorizedVoters.length
    $jt90m.seq($jt90m.struct([
        $jt90m.nu64("epoch"),
        $47b9aa0c5fbd17c3$var$publicKey("authorizedVoter")
    ]), $jt90m.offset($jt90m.u32(), -8), "authorizedVoters"),
    $jt90m.struct([
        $jt90m.seq($jt90m.struct([
            $47b9aa0c5fbd17c3$var$publicKey("authorizedPubkey"),
            $jt90m.nu64("epochOfLastAuthorizedSwitch"),
            $jt90m.nu64("targetEpoch")
        ]), 32, "buf"),
        $jt90m.nu64("idx"),
        $jt90m.u8("isEmpty")
    ], "priorVoters"),
    $jt90m.nu64(),
    // epochCredits.length
    $jt90m.seq($jt90m.struct([
        $jt90m.nu64("epoch"),
        $jt90m.nu64("credits"),
        $jt90m.nu64("prevCredits")
    ]), $jt90m.offset($jt90m.u32(), -8), "epochCredits"),
    $jt90m.struct([
        $jt90m.nu64("slot"),
        $jt90m.nu64("timestamp")
    ], "lastTimestamp")
]);
/**
 * VoteAccount class
 */ var $47b9aa0c5fbd17c3$export$89ef186f708d638b = /*#__PURE__*/ function() {
    "use strict";
    function VoteAccount(args) {
        (0, $4GJKx._)(this, VoteAccount);
        this.nodePubkey = void 0;
        this.authorizedWithdrawer = void 0;
        this.commission = void 0;
        this.rootSlot = void 0;
        this.votes = void 0;
        this.authorizedVoters = void 0;
        this.priorVoters = void 0;
        this.epochCredits = void 0;
        this.lastTimestamp = void 0;
        this.nodePubkey = args.nodePubkey;
        this.authorizedWithdrawer = args.authorizedWithdrawer;
        this.commission = args.commission;
        this.rootSlot = args.rootSlot;
        this.votes = args.votes;
        this.authorizedVoters = args.authorizedVoters;
        this.priorVoters = args.priorVoters;
        this.epochCredits = args.epochCredits;
        this.lastTimestamp = args.lastTimestamp;
    }
    (0, $1wc17._)(VoteAccount, null, [
        {
            key: "fromAccountData",
            value: /**
   * Deserialize VoteAccount from the account data.
   *
   * @param buffer account data
   * @return VoteAccount
   */ function fromAccountData(buffer) {
                var versionOffset = 4;
                var va = $47b9aa0c5fbd17c3$var$VoteAccountLayout.decode($47b9aa0c5fbd17c3$var$toBuffer(buffer), versionOffset);
                var rootSlot = va.rootSlot;
                if (!va.rootSlotValid) rootSlot = null;
                return new VoteAccount({
                    nodePubkey: new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(va.nodePubkey),
                    authorizedWithdrawer: new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(va.authorizedWithdrawer),
                    commission: va.commission,
                    votes: va.votes,
                    rootSlot: rootSlot,
                    authorizedVoters: va.authorizedVoters.map($47b9aa0c5fbd17c3$var$parseAuthorizedVoter),
                    priorVoters: $47b9aa0c5fbd17c3$var$getPriorVoters(va.priorVoters),
                    epochCredits: va.epochCredits,
                    lastTimestamp: va.lastTimestamp
                });
            }
        }
    ]);
    return VoteAccount;
}();
function $47b9aa0c5fbd17c3$var$parseAuthorizedVoter(param) {
    var authorizedVoter = param.authorizedVoter, epoch = param.epoch;
    return {
        epoch: epoch,
        authorizedVoter: new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(authorizedVoter)
    };
}
function $47b9aa0c5fbd17c3$var$parsePriorVoters(param) {
    var authorizedPubkey = param.authorizedPubkey, epochOfLastAuthorizedSwitch = param.epochOfLastAuthorizedSwitch, targetEpoch = param.targetEpoch;
    return {
        authorizedPubkey: new $47b9aa0c5fbd17c3$export$ca8b6604d6ce14de(authorizedPubkey),
        epochOfLastAuthorizedSwitch: epochOfLastAuthorizedSwitch,
        targetEpoch: targetEpoch
    };
}
function $47b9aa0c5fbd17c3$var$getPriorVoters(param) {
    var buf = param.buf, idx = param.idx, isEmpty = param.isEmpty;
    if (isEmpty) return [];
    return (0, $c6Xmf._)(buf.slice(idx + 1).map($47b9aa0c5fbd17c3$var$parsePriorVoters)).concat((0, $c6Xmf._)(buf.slice(0, idx).map($47b9aa0c5fbd17c3$var$parsePriorVoters)));
}
var $47b9aa0c5fbd17c3$var$endpoint = {
    http: {
        devnet: "http://api.devnet.solana.com",
        testnet: "http://api.testnet.solana.com",
        "mainnet-beta": "http://api.mainnet-beta.solana.com/"
    },
    https: {
        devnet: "https://api.devnet.solana.com",
        testnet: "https://api.testnet.solana.com",
        "mainnet-beta": "https://api.mainnet-beta.solana.com/"
    }
};
/**
 * Retrieves the RPC API URL for the specified cluster
 * @param {Cluster} [cluster="devnet"] - The cluster name of the RPC API URL to use. Possible options: 'devnet' | 'testnet' | 'mainnet-beta'
 * @param {boolean} [tls="http"] - Use TLS when connecting to cluster.
 *
 * @returns {string} URL string of the RPC endpoint
 */ function $47b9aa0c5fbd17c3$export$11656287b4eb76ff(cluster, tls) {
    var key = tls === false ? "http" : "https";
    if (!cluster) return $47b9aa0c5fbd17c3$var$endpoint[key]["devnet"];
    var url = $47b9aa0c5fbd17c3$var$endpoint[key][cluster];
    if (!url) throw new Error("Unknown ".concat(key, " cluster: ").concat(cluster));
    return url;
}
function $47b9aa0c5fbd17c3$export$554271b88fdb7843(connection, rawTransaction, confirmationStrategyOrConfirmOptions, maybeConfirmOptions) {
    return $47b9aa0c5fbd17c3$var$_sendAndConfirmRawTransaction.apply(this, arguments);
}
function $47b9aa0c5fbd17c3$var$_sendAndConfirmRawTransaction() {
    $47b9aa0c5fbd17c3$var$_sendAndConfirmRawTransaction = /**
 * Send and confirm a raw transaction
 *
 * If `commitment` option is not specified, defaults to 'max' commitment.
 *
 * @param {Connection} connection
 * @param {Buffer} rawTransaction
 * @param {TransactionConfirmationStrategy} confirmationStrategy
 * @param {ConfirmOptions} [options]
 * @returns {Promise<TransactionSignature>}
 */ /**
 * @deprecated Calling `sendAndConfirmRawTransaction()` without a `confirmationStrategy`
 * is no longer supported and will be removed in a future version.
 */ // eslint-disable-next-line no-redeclare
    // eslint-disable-next-line no-redeclare
    (0, $kSuI9._)(function(connection, rawTransaction, confirmationStrategyOrConfirmOptions, maybeConfirmOptions) {
        var confirmationStrategy, options, sendOptions, signature, commitment, confirmationPromise, status;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (confirmationStrategyOrConfirmOptions && Object.prototype.hasOwnProperty.call(confirmationStrategyOrConfirmOptions, "lastValidBlockHeight")) {
                        confirmationStrategy = confirmationStrategyOrConfirmOptions;
                        options = maybeConfirmOptions;
                    } else if (confirmationStrategyOrConfirmOptions && Object.prototype.hasOwnProperty.call(confirmationStrategyOrConfirmOptions, "nonceValue")) {
                        confirmationStrategy = confirmationStrategyOrConfirmOptions;
                        options = maybeConfirmOptions;
                    } else options = confirmationStrategyOrConfirmOptions;
                    sendOptions = options && {
                        skipPreflight: options.skipPreflight,
                        preflightCommitment: options.preflightCommitment || options.commitment,
                        minContextSlot: options.minContextSlot
                    };
                    return [
                        4,
                        connection.sendRawTransaction(rawTransaction, sendOptions)
                    ];
                case 1:
                    signature = _state.sent();
                    commitment = options && options.commitment;
                    confirmationPromise = confirmationStrategy ? connection.confirmTransaction(confirmationStrategy, commitment) : connection.confirmTransaction(signature, commitment);
                    return [
                        4,
                        confirmationPromise
                    ];
                case 2:
                    status = _state.sent().value;
                    if (status.err) {
                        if (signature != null) throw new $47b9aa0c5fbd17c3$export$121e803f723b3045({
                            action: (sendOptions === null || sendOptions === void 0 ? void 0 : sendOptions.skipPreflight) ? "send" : "simulate",
                            signature: signature,
                            transactionMessage: "Status: (".concat(JSON.stringify(status), ")")
                        });
                        throw new Error("Raw transaction ".concat(signature, " failed (").concat(JSON.stringify(status), ")"));
                    }
                    return [
                        2,
                        signature
                    ];
            }
        });
    });
    return $47b9aa0c5fbd17c3$var$_sendAndConfirmRawTransaction.apply(this, arguments);
}
/**
 * There are 1-billion lamports in one SOL
 */ var $47b9aa0c5fbd17c3$export$5f6a2f2669741bbe = 1000000000;

});
parcelRegister("dVH57", function(module, exports) {

$parcel$export(module.exports, "ed25519", function () { return $a242045505172bb8$export$f63794f4a09a19c1; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $c6Jnd = parcelRequire("c6Jnd");

var $8ybNC = parcelRequire("8ybNC");

var $byA26 = parcelRequire("byA26");

var $llE38 = parcelRequire("llE38");

var $fnxE9 = parcelRequire("fnxE9");

var $299Vm = parcelRequire("299Vm");

var $cOBbr = parcelRequire("cOBbr");
/**
 * ed25519 Twisted Edwards curve with following addons:
 * - X25519 ECDH
 * - Ristretto cofactor elimination
 * - Elligator hash-to-group / point indistinguishability
 */ var $a242045505172bb8$var$ED25519_P = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949");
// √(-1) aka √(a) aka 2^((p-1)/4)
var $a242045505172bb8$var$ED25519_SQRT_M1 = /* @__PURE__ */ BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
// prettier-ignore
var $a242045505172bb8$var$_0n = BigInt(0), $a242045505172bb8$var$_1n = BigInt(1), $a242045505172bb8$var$_2n = BigInt(2), $a242045505172bb8$var$_3n = BigInt(3);
// prettier-ignore
var $a242045505172bb8$var$_5n = BigInt(5), $a242045505172bb8$var$_8n = BigInt(8);
function $a242045505172bb8$var$ed25519_pow_2_252_3(x) {
    // prettier-ignore
    var _10n = BigInt(10), _20n = BigInt(20), _40n = BigInt(40), _80n = BigInt(80);
    var P = $a242045505172bb8$var$ED25519_P;
    var x2 = x * x % P;
    var b2 = x2 * x % P; // x^3, 11
    var b4 = (0, $fnxE9.pow2)(b2, $a242045505172bb8$var$_2n, P) * b2 % P; // x^15, 1111
    var b5 = (0, $fnxE9.pow2)(b4, $a242045505172bb8$var$_1n, P) * x % P; // x^31
    var b10 = (0, $fnxE9.pow2)(b5, $a242045505172bb8$var$_5n, P) * b5 % P;
    var b20 = (0, $fnxE9.pow2)(b10, _10n, P) * b10 % P;
    var b40 = (0, $fnxE9.pow2)(b20, _20n, P) * b20 % P;
    var b80 = (0, $fnxE9.pow2)(b40, _40n, P) * b40 % P;
    var b160 = (0, $fnxE9.pow2)(b80, _80n, P) * b80 % P;
    var b240 = (0, $fnxE9.pow2)(b160, _80n, P) * b80 % P;
    var b250 = (0, $fnxE9.pow2)(b240, _10n, P) * b10 % P;
    var pow_p_5_8 = (0, $fnxE9.pow2)(b250, $a242045505172bb8$var$_2n, P) * x % P;
    // ^ To pow to (p+3)/8, multiply it by x.
    return {
        pow_p_5_8: pow_p_5_8,
        b2: b2
    };
}
function $a242045505172bb8$var$adjustScalarBytes(bytes) {
    // Section 5: For X25519, in order to decode 32 random bytes as an integer scalar,
    // set the three least significant bits of the first byte
    bytes[0] &= 248; // 0b1111_1000
    // and the most significant bit of the last to zero,
    bytes[31] &= 127; // 0b0111_1111
    // set the second most significant bit of the last byte to 1
    bytes[31] |= 64; // 0b0100_0000
    return bytes;
}
// sqrt(u/v)
function $a242045505172bb8$var$uvRatio(u, v) {
    var P = $a242045505172bb8$var$ED25519_P;
    var v3 = (0, $fnxE9.mod)(v * v * v, P); // v³
    var v7 = (0, $fnxE9.mod)(v3 * v3 * v, P); // v⁷
    // (p+3)/8 and (p-5)/8
    var pow = $a242045505172bb8$var$ed25519_pow_2_252_3(u * v7).pow_p_5_8;
    var x = (0, $fnxE9.mod)(u * v3 * pow, P); // (uv³)(uv⁷)^(p-5)/8
    var vx2 = (0, $fnxE9.mod)(v * x * x, P); // vx²
    var root1 = x; // First root candidate
    var root2 = (0, $fnxE9.mod)(x * $a242045505172bb8$var$ED25519_SQRT_M1, P); // Second root candidate
    var useRoot1 = vx2 === u; // If vx² = u (mod p), x is a square root
    var useRoot2 = vx2 === (0, $fnxE9.mod)(-u, P); // If vx² = -u, set x <-- x * 2^((p-1)/4)
    var noRoot = vx2 === (0, $fnxE9.mod)(-u * $a242045505172bb8$var$ED25519_SQRT_M1, P); // There is no valid root, vx² = -u√(-1)
    if (useRoot1) x = root1;
    if (useRoot2 || noRoot) x = root2; // We return root2 anyway, for const-time
    if ((0, $fnxE9.isNegativeLE)(x, P)) x = (0, $fnxE9.mod)(-x, P);
    return {
        isValid: useRoot1 || useRoot2,
        value: x
    };
}
var $a242045505172bb8$export$5ce3305f0d0b8e6f = [
    "0100000000000000000000000000000000000000000000000000000000000000",
    "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac037a",
    "0000000000000000000000000000000000000000000000000000000000000080",
    "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc05",
    "ecffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff7f",
    "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc85",
    "0000000000000000000000000000000000000000000000000000000000000000",
    "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac03fa"
];
var $a242045505172bb8$var$Fp = /* @__PURE__ */ function() {
    return (0, $fnxE9.Field)($a242045505172bb8$var$ED25519_P, undefined, true);
}();
var $a242045505172bb8$var$ed25519Defaults = /* @__PURE__ */ function() {
    return {
        // Param: a
        a: BigInt(-1),
        // d is equal to -121665/121666 over finite field.
        // Negative number is P - number, and division is invert(number, P)
        d: BigInt("37095705934669439343138083508754565189542113879843219016388785533085940283555"),
        // Finite field 𝔽p over which we'll do calculations; 2n**255n - 19n
        Fp: $a242045505172bb8$var$Fp,
        // Subgroup order: how many points curve has
        // 2n**252n + 27742317777372353535851937790883648493n;
        n: BigInt("7237005577332262213973186563042994240857116359379907606001950938285454250989"),
        // Cofactor
        h: $a242045505172bb8$var$_8n,
        // Base point (x, y) aka generator point
        Gx: BigInt("15112221349535400772501151409588531511454012693041857206046113283949847762202"),
        Gy: BigInt("46316835694926478169428394003475163141307993866256225615783033603165251855960"),
        hash: (0, $c6Jnd.sha512),
        randomBytes: (0, $8ybNC.randomBytes),
        adjustScalarBytes: $a242045505172bb8$var$adjustScalarBytes,
        // dom2
        // Ratio of u to v. Allows us to combine inversion and square root. Uses algo from RFC8032 5.1.3.
        // Constant-time, u/√v
        uvRatio: $a242045505172bb8$var$uvRatio
    };
}();
var $a242045505172bb8$export$f63794f4a09a19c1 = /* @__PURE__ */ function() {
    return (0, $byA26.twistedEdwards)($a242045505172bb8$var$ed25519Defaults);
}();
function $a242045505172bb8$var$ed25519_domain(data, ctx, phflag) {
    if (ctx.length > 255) throw new Error("Context is too big");
    return (0, $8ybNC.concatBytes)((0, $8ybNC.utf8ToBytes)("SigEd25519 no Ed25519 collisions"), new Uint8Array([
        phflag ? 1 : 0,
        ctx.length
    ]), ctx, data);
}
var $a242045505172bb8$export$1bc11da7986b0196 = /* @__PURE__ */ function() {
    return (0, $byA26.twistedEdwards)((0, $cxjpp._)((0, $do9pw._)({}, $a242045505172bb8$var$ed25519Defaults), {
        domain: $a242045505172bb8$var$ed25519_domain
    }));
}();
var $a242045505172bb8$export$473acbb6f701cbb6 = /* @__PURE__ */ function() {
    return (0, $byA26.twistedEdwards)(Object.assign({}, $a242045505172bb8$var$ed25519Defaults, {
        domain: $a242045505172bb8$var$ed25519_domain,
        prehash: (0, $c6Jnd.sha512)
    }));
}();
var $a242045505172bb8$export$dab9625394da700 = /* @__PURE__ */ function() {
    return (0, $299Vm.montgomery)({
        P: $a242045505172bb8$var$ED25519_P,
        a: BigInt(486662),
        montgomeryBits: 255,
        nByteLength: 32,
        Gu: BigInt(9),
        powPminus2: function(x) {
            var P = $a242045505172bb8$var$ED25519_P;
            // x^(p-2) aka x^(2^255-21)
            var _ed25519_pow_2_252_3 = $a242045505172bb8$var$ed25519_pow_2_252_3(x), pow_p_5_8 = _ed25519_pow_2_252_3.pow_p_5_8, b2 = _ed25519_pow_2_252_3.b2;
            return (0, $fnxE9.mod)((0, $fnxE9.pow2)(pow_p_5_8, $a242045505172bb8$var$_3n, P) * b2, P);
        },
        adjustScalarBytes: $a242045505172bb8$var$adjustScalarBytes,
        randomBytes: (0, $8ybNC.randomBytes)
    });
}();
function $a242045505172bb8$export$78609ae56f1edf04(edwardsPub) {
    var y = $a242045505172bb8$export$f63794f4a09a19c1.ExtendedPoint.fromHex(edwardsPub).y;
    var _1n = BigInt(1);
    return $a242045505172bb8$var$Fp.toBytes($a242045505172bb8$var$Fp.create((_1n + y) * $a242045505172bb8$var$Fp.inv(_1n - y)));
}
var $a242045505172bb8$export$84bc39a6e4664b07 = $a242045505172bb8$export$78609ae56f1edf04; // deprecated
function $a242045505172bb8$export$c32b0f86cebbdf19(edwardsPriv) {
    var hashed = $a242045505172bb8$var$ed25519Defaults.hash(edwardsPriv.subarray(0, 32));
    return $a242045505172bb8$var$ed25519Defaults.adjustScalarBytes(hashed).subarray(0, 32);
}
// Hash To Curve Elligator2 Map (NOTE: different from ristretto255 elligator)
// NOTE: very important part is usage of FpSqrtEven for ELL2_C1_EDWARDS, since
// SageMath returns different root first and everything falls apart
var $a242045505172bb8$var$ELL2_C1 = /* @__PURE__ */ function() {
    return ($a242045505172bb8$var$Fp.ORDER + $a242045505172bb8$var$_3n) / $a242045505172bb8$var$_8n;
}(); // 1. c1 = (q + 3) / 8       # Integer arithmetic
var $a242045505172bb8$var$ELL2_C2 = /* @__PURE__ */ function() {
    return $a242045505172bb8$var$Fp.pow($a242045505172bb8$var$_2n, $a242045505172bb8$var$ELL2_C1);
}(); // 2. c2 = 2^c1
var $a242045505172bb8$var$ELL2_C3 = /* @__PURE__ */ function() {
    return $a242045505172bb8$var$Fp.sqrt($a242045505172bb8$var$Fp.neg($a242045505172bb8$var$Fp.ONE));
}(); // 3. c3 = sqrt(-1)
// prettier-ignore
function $a242045505172bb8$var$map_to_curve_elligator2_curve25519(u) {
    var ELL2_C4 = ($a242045505172bb8$var$Fp.ORDER - $a242045505172bb8$var$_5n) / $a242045505172bb8$var$_8n; // 4. c4 = (q - 5) / 8       # Integer arithmetic
    var ELL2_J = BigInt(486662);
    var tv1 = $a242045505172bb8$var$Fp.sqr(u); //  1.  tv1 = u^2
    tv1 = $a242045505172bb8$var$Fp.mul(tv1, $a242045505172bb8$var$_2n); //  2.  tv1 = 2 * tv1
    var xd = $a242045505172bb8$var$Fp.add(tv1, $a242045505172bb8$var$Fp.ONE); //  3.   xd = tv1 + 1         # Nonzero: -1 is square (mod p), tv1 is not
    var x1n = $a242045505172bb8$var$Fp.neg(ELL2_J); //  4.  x1n = -J              # x1 = x1n / xd = -J / (1 + 2 * u^2)
    var tv2 = $a242045505172bb8$var$Fp.sqr(xd); //  5.  tv2 = xd^2
    var gxd = $a242045505172bb8$var$Fp.mul(tv2, xd); //  6.  gxd = tv2 * xd        # gxd = xd^3
    var gx1 = $a242045505172bb8$var$Fp.mul(tv1, ELL2_J); //  7.  gx1 = J * tv1         # x1n + J * xd
    gx1 = $a242045505172bb8$var$Fp.mul(gx1, x1n); //  8.  gx1 = gx1 * x1n       # x1n^2 + J * x1n * xd
    gx1 = $a242045505172bb8$var$Fp.add(gx1, tv2); //  9.  gx1 = gx1 + tv2       # x1n^2 + J * x1n * xd + xd^2
    gx1 = $a242045505172bb8$var$Fp.mul(gx1, x1n); //  10. gx1 = gx1 * x1n       # x1n^3 + J * x1n^2 * xd + x1n * xd^2
    var tv3 = $a242045505172bb8$var$Fp.sqr(gxd); //  11. tv3 = gxd^2
    tv2 = $a242045505172bb8$var$Fp.sqr(tv3); //  12. tv2 = tv3^2           # gxd^4
    tv3 = $a242045505172bb8$var$Fp.mul(tv3, gxd); //  13. tv3 = tv3 * gxd       # gxd^3
    tv3 = $a242045505172bb8$var$Fp.mul(tv3, gx1); //  14. tv3 = tv3 * gx1       # gx1 * gxd^3
    tv2 = $a242045505172bb8$var$Fp.mul(tv2, tv3); //  15. tv2 = tv2 * tv3       # gx1 * gxd^7
    var y11 = $a242045505172bb8$var$Fp.pow(tv2, ELL2_C4); //  16. y11 = tv2^c4        # (gx1 * gxd^7)^((p - 5) / 8)
    y11 = $a242045505172bb8$var$Fp.mul(y11, tv3); //  17. y11 = y11 * tv3       # gx1*gxd^3*(gx1*gxd^7)^((p-5)/8)
    var y12 = $a242045505172bb8$var$Fp.mul(y11, $a242045505172bb8$var$ELL2_C3); //  18. y12 = y11 * c3
    tv2 = $a242045505172bb8$var$Fp.sqr(y11); //  19. tv2 = y11^2
    tv2 = $a242045505172bb8$var$Fp.mul(tv2, gxd); //  20. tv2 = tv2 * gxd
    var e1 = $a242045505172bb8$var$Fp.eql(tv2, gx1); //  21.  e1 = tv2 == gx1
    var y1 = $a242045505172bb8$var$Fp.cmov(y12, y11, e1); //  22.  y1 = CMOV(y12, y11, e1)  # If g(x1) is square, this is its sqrt
    var x2n = $a242045505172bb8$var$Fp.mul(x1n, tv1); //  23. x2n = x1n * tv1       # x2 = x2n / xd = 2 * u^2 * x1n / xd
    var y21 = $a242045505172bb8$var$Fp.mul(y11, u); //  24. y21 = y11 * u
    y21 = $a242045505172bb8$var$Fp.mul(y21, $a242045505172bb8$var$ELL2_C2); //  25. y21 = y21 * c2
    var y22 = $a242045505172bb8$var$Fp.mul(y21, $a242045505172bb8$var$ELL2_C3); //  26. y22 = y21 * c3
    var gx2 = $a242045505172bb8$var$Fp.mul(gx1, tv1); //  27. gx2 = gx1 * tv1       # g(x2) = gx2 / gxd = 2 * u^2 * g(x1)
    tv2 = $a242045505172bb8$var$Fp.sqr(y21); //  28. tv2 = y21^2
    tv2 = $a242045505172bb8$var$Fp.mul(tv2, gxd); //  29. tv2 = tv2 * gxd
    var e2 = $a242045505172bb8$var$Fp.eql(tv2, gx2); //  30.  e2 = tv2 == gx2
    var y2 = $a242045505172bb8$var$Fp.cmov(y22, y21, e2); //  31.  y2 = CMOV(y22, y21, e2)  # If g(x2) is square, this is its sqrt
    tv2 = $a242045505172bb8$var$Fp.sqr(y1); //  32. tv2 = y1^2
    tv2 = $a242045505172bb8$var$Fp.mul(tv2, gxd); //  33. tv2 = tv2 * gxd
    var e3 = $a242045505172bb8$var$Fp.eql(tv2, gx1); //  34.  e3 = tv2 == gx1
    var xn = $a242045505172bb8$var$Fp.cmov(x2n, x1n, e3); //  35.  xn = CMOV(x2n, x1n, e3)  # If e3, x = x1, else x = x2
    var y = $a242045505172bb8$var$Fp.cmov(y2, y1, e3); //  36.   y = CMOV(y2, y1, e3)    # If e3, y = y1, else y = y2
    var e4 = $a242045505172bb8$var$Fp.isOdd(y); //  37.  e4 = sgn0(y) == 1        # Fix sign of y
    y = $a242045505172bb8$var$Fp.cmov(y, $a242045505172bb8$var$Fp.neg(y), e3 !== e4); //  38.   y = CMOV(y, -y, e3 XOR e4)
    return {
        xMn: xn,
        xMd: xd,
        yMn: y,
        yMd: $a242045505172bb8$var$_1n
    }; //  39. return (xn, xd, y, 1)
}
var $a242045505172bb8$var$ELL2_C1_EDWARDS = /* @__PURE__ */ function() {
    return (0, $fnxE9.FpSqrtEven)($a242045505172bb8$var$Fp, $a242045505172bb8$var$Fp.neg(BigInt(486664)));
}(); // sgn0(c1) MUST equal 0
function $a242045505172bb8$var$map_to_curve_elligator2_edwards25519(u) {
    var _map_to_curve_elligator2_curve25519 = $a242045505172bb8$var$map_to_curve_elligator2_curve25519(u), xMn = _map_to_curve_elligator2_curve25519.xMn, xMd = _map_to_curve_elligator2_curve25519.xMd, yMn = _map_to_curve_elligator2_curve25519.yMn, yMd = _map_to_curve_elligator2_curve25519.yMd; //  1.  (xMn, xMd, yMn, yMd) =
    // map_to_curve_elligator2_curve25519(u)
    var xn = $a242045505172bb8$var$Fp.mul(xMn, yMd); //  2.  xn = xMn * yMd
    xn = $a242045505172bb8$var$Fp.mul(xn, $a242045505172bb8$var$ELL2_C1_EDWARDS); //  3.  xn = xn * c1
    var xd = $a242045505172bb8$var$Fp.mul(xMd, yMn); //  4.  xd = xMd * yMn    # xn / xd = c1 * xM / yM
    var yn = $a242045505172bb8$var$Fp.sub(xMn, xMd); //  5.  yn = xMn - xMd
    var yd = $a242045505172bb8$var$Fp.add(xMn, xMd); //  6.  yd = xMn + xMd    # (n / d - 1) / (n / d + 1) = (n - d) / (n + d)
    var tv1 = $a242045505172bb8$var$Fp.mul(xd, yd); //  7. tv1 = xd * yd
    var e = $a242045505172bb8$var$Fp.eql(tv1, $a242045505172bb8$var$Fp.ZERO); //  8.   e = tv1 == 0
    xn = $a242045505172bb8$var$Fp.cmov(xn, $a242045505172bb8$var$Fp.ZERO, e); //  9.  xn = CMOV(xn, 0, e)
    xd = $a242045505172bb8$var$Fp.cmov(xd, $a242045505172bb8$var$Fp.ONE, e); //  10. xd = CMOV(xd, 1, e)
    yn = $a242045505172bb8$var$Fp.cmov(yn, $a242045505172bb8$var$Fp.ONE, e); //  11. yn = CMOV(yn, 1, e)
    yd = $a242045505172bb8$var$Fp.cmov(yd, $a242045505172bb8$var$Fp.ONE, e); //  12. yd = CMOV(yd, 1, e)
    var inv = $a242045505172bb8$var$Fp.invertBatch([
        xd,
        yd
    ]); // batch division
    return {
        x: $a242045505172bb8$var$Fp.mul(xn, inv[0]),
        y: $a242045505172bb8$var$Fp.mul(yn, inv[1])
    }; //  13. return (xn, xd, yn, yd)
}
var $a242045505172bb8$var$htf = /* @__PURE__ */ function() {
    return (0, $llE38.createHasher)($a242045505172bb8$export$f63794f4a09a19c1.ExtendedPoint, function(scalars) {
        return $a242045505172bb8$var$map_to_curve_elligator2_edwards25519(scalars[0]);
    }, {
        DST: "edwards25519_XMD:SHA-512_ELL2_RO_",
        encodeDST: "edwards25519_XMD:SHA-512_ELL2_NU_",
        p: $a242045505172bb8$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: (0, $c6Jnd.sha512)
    });
}();
var $a242045505172bb8$export$a95cc2b0cdb9c1e1 = /* @__PURE__ */ function() {
    return $a242045505172bb8$var$htf.hashToCurve;
}();
var $a242045505172bb8$export$124e820e7679cc3 = /* @__PURE__ */ function() {
    return $a242045505172bb8$var$htf.encodeToCurve;
}();
function $a242045505172bb8$var$assertRstPoint(other) {
    if (!(other instanceof $a242045505172bb8$var$RistPoint)) throw new Error("RistrettoPoint expected");
}
// √(-1) aka √(a) aka 2^((p-1)/4)
var $a242045505172bb8$var$SQRT_M1 = $a242045505172bb8$var$ED25519_SQRT_M1;
// √(ad - 1)
var $a242045505172bb8$var$SQRT_AD_MINUS_ONE = /* @__PURE__ */ BigInt("25063068953384623474111414158702152701244531502492656460079210482610430750235");
// 1 / √(a-d)
var $a242045505172bb8$var$INVSQRT_A_MINUS_D = /* @__PURE__ */ BigInt("54469307008909316920995813868745141605393597292927456921205312896311721017578");
// 1-d²
var $a242045505172bb8$var$ONE_MINUS_D_SQ = /* @__PURE__ */ BigInt("1159843021668779879193775521855586647937357759715417654439879720876111806838");
// (d-1)²
var $a242045505172bb8$var$D_MINUS_ONE_SQ = /* @__PURE__ */ BigInt("40440834346308536858101042469323190826248399146238708352240133220865137265952");
// Calculates 1/√(number)
var $a242045505172bb8$var$invertSqrt = function(number) {
    return $a242045505172bb8$var$uvRatio($a242045505172bb8$var$_1n, number);
};
var $a242045505172bb8$var$MAX_255B = /* @__PURE__ */ BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
var $a242045505172bb8$var$bytes255ToNumberLE = function(bytes) {
    return $a242045505172bb8$export$f63794f4a09a19c1.CURVE.Fp.create((0, $cOBbr.bytesToNumberLE)(bytes) & $a242045505172bb8$var$MAX_255B);
};
// Computes Elligator map for Ristretto
// https://ristretto.group/formulas/elligator.html
function $a242045505172bb8$var$calcElligatorRistrettoMap(r0) {
    var d = $a242045505172bb8$export$f63794f4a09a19c1.CURVE.d;
    var P = $a242045505172bb8$export$f63794f4a09a19c1.CURVE.Fp.ORDER;
    var mod = $a242045505172bb8$export$f63794f4a09a19c1.CURVE.Fp.create;
    var r = mod($a242045505172bb8$var$SQRT_M1 * r0 * r0); // 1
    var Ns = mod((r + $a242045505172bb8$var$_1n) * $a242045505172bb8$var$ONE_MINUS_D_SQ); // 2
    var c = BigInt(-1); // 3
    var D = mod((c - d * r) * mod(r + d)); // 4
    var _uvRatio = $a242045505172bb8$var$uvRatio(Ns, D), Ns_D_is_sq = _uvRatio.isValid, s = _uvRatio.value; // 5
    var s_ = mod(s * r0); // 6
    if (!(0, $fnxE9.isNegativeLE)(s_, P)) s_ = mod(-s_);
    if (!Ns_D_is_sq) s = s_; // 7
    if (!Ns_D_is_sq) c = r; // 8
    var Nt = mod(c * (r - $a242045505172bb8$var$_1n) * $a242045505172bb8$var$D_MINUS_ONE_SQ - D); // 9
    var s2 = s * s;
    var W0 = mod((s + s) * D); // 10
    var W1 = mod(Nt * $a242045505172bb8$var$SQRT_AD_MINUS_ONE); // 11
    var W2 = mod($a242045505172bb8$var$_1n - s2); // 12
    var W3 = mod($a242045505172bb8$var$_1n + s2); // 13
    return new $a242045505172bb8$export$f63794f4a09a19c1.ExtendedPoint(mod(W0 * W3), mod(W2 * W1), mod(W1 * W3), mod(W0 * W2));
}
/**
 * Each ed25519/ExtendedPoint has 8 different equivalent points. This can be
 * a source of bugs for protocols like ring signatures. Ristretto was created to solve this.
 * Ristretto point operates in X:Y:Z:T extended coordinates like ExtendedPoint,
 * but it should work in its own namespace: do not combine those two.
 * https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-ristretto255-decaf448
 */ var $a242045505172bb8$var$RistPoint = /*#__PURE__*/ function() {
    "use strict";
    function RistPoint(ep) {
        (0, $4GJKx._)(this, RistPoint);
        this.ep = ep;
    }
    (0, $1wc17._)(RistPoint, [
        {
            /**
     * Encodes ristretto point to Uint8Array.
     * https://ristretto.group/formulas/encoding.html
     */ key: "toRawBytes",
            value: function toRawBytes() {
                var _this_ep = this.ep, x = _this_ep.ex, y = _this_ep.ey, z = _this_ep.ez, t = _this_ep.et;
                var P = $a242045505172bb8$export$f63794f4a09a19c1.CURVE.Fp.ORDER;
                var mod = $a242045505172bb8$export$f63794f4a09a19c1.CURVE.Fp.create;
                var u1 = mod(mod(z + y) * mod(z - y)); // 1
                var u2 = mod(x * y); // 2
                // Square root always exists
                var u2sq = mod(u2 * u2);
                var _invertSqrt = $a242045505172bb8$var$invertSqrt(mod(u1 * u2sq)), invsqrt = _invertSqrt.value; // 3
                var D1 = mod(invsqrt * u1); // 4
                var D2 = mod(invsqrt * u2); // 5
                var zInv = mod(D1 * D2 * t); // 6
                var D; // 7
                if ((0, $fnxE9.isNegativeLE)(t * zInv, P)) {
                    var _x = mod(y * $a242045505172bb8$var$SQRT_M1);
                    var _y = mod(x * $a242045505172bb8$var$SQRT_M1);
                    x = _x;
                    y = _y;
                    D = mod(D1 * $a242045505172bb8$var$INVSQRT_A_MINUS_D);
                } else D = D2; // 8
                if ((0, $fnxE9.isNegativeLE)(x * zInv, P)) y = mod(-y); // 9
                var s = mod((z - y) * D); // 10 (check footer's note, no sqrt(-a))
                if ((0, $fnxE9.isNegativeLE)(s, P)) s = mod(-s);
                return (0, $cOBbr.numberToBytesLE)(s, 32); // 11
            }
        },
        {
            key: "toHex",
            value: function toHex() {
                return (0, $cOBbr.bytesToHex)(this.toRawBytes());
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.toHex();
            }
        },
        {
            // Compare one point to another.
            key: "equals",
            value: function equals(other) {
                $a242045505172bb8$var$assertRstPoint(other);
                var _this_ep = this.ep, X1 = _this_ep.ex, Y1 = _this_ep.ey;
                var _other_ep = other.ep, X2 = _other_ep.ex, Y2 = _other_ep.ey;
                var mod = $a242045505172bb8$export$f63794f4a09a19c1.CURVE.Fp.create;
                // (x1 * y2 == y1 * x2) | (y1 * y2 == x1 * x2)
                var one = mod(X1 * Y2) === mod(Y1 * X2);
                var two = mod(Y1 * Y2) === mod(X1 * X2);
                return one || two;
            }
        },
        {
            key: "add",
            value: function add(other) {
                $a242045505172bb8$var$assertRstPoint(other);
                return new RistPoint(this.ep.add(other.ep));
            }
        },
        {
            key: "subtract",
            value: function subtract(other) {
                $a242045505172bb8$var$assertRstPoint(other);
                return new RistPoint(this.ep.subtract(other.ep));
            }
        },
        {
            key: "multiply",
            value: function multiply(scalar) {
                return new RistPoint(this.ep.multiply(scalar));
            }
        },
        {
            key: "multiplyUnsafe",
            value: function multiplyUnsafe(scalar) {
                return new RistPoint(this.ep.multiplyUnsafe(scalar));
            }
        },
        {
            key: "double",
            value: function double() {
                return new RistPoint(this.ep.double());
            }
        },
        {
            key: "negate",
            value: function negate() {
                return new RistPoint(this.ep.negate());
            }
        }
    ], [
        {
            key: "fromAffine",
            value: function fromAffine(ap) {
                return new RistPoint($a242045505172bb8$export$f63794f4a09a19c1.ExtendedPoint.fromAffine(ap));
            }
        },
        {
            key: "hashToCurve",
            value: /**
     * Takes uniform output of 64-byte hash function like sha512 and converts it to `RistrettoPoint`.
     * The hash-to-group operation applies Elligator twice and adds the results.
     * **Note:** this is one-way map, there is no conversion from point to hash.
     * https://ristretto.group/formulas/elligator.html
     * @param hex 64-byte output of a hash function
     */ function hashToCurve(hex) {
                hex = (0, $cOBbr.ensureBytes)("ristrettoHash", hex, 64);
                var r1 = $a242045505172bb8$var$bytes255ToNumberLE(hex.slice(0, 32));
                var R1 = $a242045505172bb8$var$calcElligatorRistrettoMap(r1);
                var r2 = $a242045505172bb8$var$bytes255ToNumberLE(hex.slice(32, 64));
                var R2 = $a242045505172bb8$var$calcElligatorRistrettoMap(r2);
                return new RistPoint(R1.add(R2));
            }
        },
        {
            key: "fromHex",
            value: /**
     * Converts ristretto-encoded string to ristretto point.
     * https://ristretto.group/formulas/decoding.html
     * @param hex Ristretto-encoded 32 bytes. Not every 32-byte string is valid ristretto encoding
     */ function fromHex(hex) {
                hex = (0, $cOBbr.ensureBytes)("ristrettoHex", hex, 32);
                var _ed25519_CURVE = $a242045505172bb8$export$f63794f4a09a19c1.CURVE, a = _ed25519_CURVE.a, d = _ed25519_CURVE.d;
                var P = $a242045505172bb8$export$f63794f4a09a19c1.CURVE.Fp.ORDER;
                var mod = $a242045505172bb8$export$f63794f4a09a19c1.CURVE.Fp.create;
                var emsg = "RistrettoPoint.fromHex: the hex is not valid encoding of RistrettoPoint";
                var s = $a242045505172bb8$var$bytes255ToNumberLE(hex);
                // 1. Check that s_bytes is the canonical encoding of a field element, or else abort.
                // 3. Check that s is non-negative, or else abort
                if (!(0, $cOBbr.equalBytes)((0, $cOBbr.numberToBytesLE)(s, 32), hex) || (0, $fnxE9.isNegativeLE)(s, P)) throw new Error(emsg);
                var s2 = mod(s * s);
                var u1 = mod($a242045505172bb8$var$_1n + a * s2); // 4 (a is -1)
                var u2 = mod($a242045505172bb8$var$_1n - a * s2); // 5
                var u1_2 = mod(u1 * u1);
                var u2_2 = mod(u2 * u2);
                var v = mod(a * d * u1_2 - u2_2); // 6
                var _invertSqrt = $a242045505172bb8$var$invertSqrt(mod(v * u2_2)), isValid = _invertSqrt.isValid, I = _invertSqrt.value; // 7
                var Dx = mod(I * u2); // 8
                var Dy = mod(I * Dx * v); // 9
                var x = mod((s + s) * Dx); // 10
                if ((0, $fnxE9.isNegativeLE)(x, P)) x = mod(-x); // 10
                var y = mod(u1 * Dy); // 11
                var t = mod(x * y); // 12
                if (!isValid || (0, $fnxE9.isNegativeLE)(t, P) || y === $a242045505172bb8$var$_0n) throw new Error(emsg);
                return new RistPoint(new $a242045505172bb8$export$f63794f4a09a19c1.ExtendedPoint(x, y, $a242045505172bb8$var$_1n, t));
            }
        }
    ]);
    return RistPoint;
}();
var $a242045505172bb8$export$5e87c4f36f27816d = /* @__PURE__ */ function() {
    if (!$a242045505172bb8$var$RistPoint.BASE) $a242045505172bb8$var$RistPoint.BASE = new $a242045505172bb8$var$RistPoint($a242045505172bb8$export$f63794f4a09a19c1.ExtendedPoint.BASE);
    if (!$a242045505172bb8$var$RistPoint.ZERO) $a242045505172bb8$var$RistPoint.ZERO = new $a242045505172bb8$var$RistPoint($a242045505172bb8$export$f63794f4a09a19c1.ExtendedPoint.ZERO);
    return $a242045505172bb8$var$RistPoint;
}();
var $a242045505172bb8$export$c9ad4c0d917ad3 = function(msg, options) {
    var d = options.DST;
    var DST = typeof d === "string" ? (0, $8ybNC.utf8ToBytes)(d) : d;
    var uniform_bytes = (0, $llE38.expand_message_xmd)(msg, DST, 64, (0, $c6Jnd.sha512));
    var P = $a242045505172bb8$var$RistPoint.hashToCurve(uniform_bytes);
    return P;
};
var $a242045505172bb8$export$667ef88de7a83a7f = $a242045505172bb8$export$c9ad4c0d917ad3; // legacy

});
parcelRegister("c6Jnd", function(module, exports) {

$parcel$export(module.exports, "sha512", function () { return $8d093dcbb2198339$export$a888d2532e6dc7bb; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $cv9Rk = parcelRequire("cv9Rk");

var $ohfOJ = parcelRequire("ohfOJ");

var $8ANoe = parcelRequire("8ANoe");

var $Fis3O = parcelRequire("Fis3O");

var $8ybNC = parcelRequire("8ybNC");
// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
var $8d093dcbb2198339$var$_ref = (0, $cv9Rk._)(/* @__PURE__ */ function() {
    return (0, $Fis3O.default).split([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map(function(n) {
        return BigInt(n);
    }));
}(), 2), $8d093dcbb2198339$var$SHA512_Kh = $8d093dcbb2198339$var$_ref[0], $8d093dcbb2198339$var$SHA512_Kl = $8d093dcbb2198339$var$_ref[1];
// Temporary buffer, not used to store anything between runs
var $8d093dcbb2198339$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
var $8d093dcbb2198339$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
var $8d093dcbb2198339$export$d655fdb8a1cad5df = /*#__PURE__*/ function(HashMD) {
    "use strict";
    (0, $dcsZi._)(SHA512, HashMD);
    var _super = (0, $ohfOJ._)(SHA512);
    function SHA512() {
        (0, $4GJKx._)(this, SHA512);
        var _this;
        _this = _super.call(this, 128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        _this.Ah = 1779033703;
        _this.Al = -205731576;
        _this.Bh = -1150833019;
        _this.Bl = -2067093701;
        _this.Ch = 1013904242;
        _this.Cl = -23791573;
        _this.Dh = -1521486534;
        _this.Dl = 1595750129;
        _this.Eh = 1359893119;
        _this.El = -1377402159;
        _this.Fh = -1694144372;
        _this.Fl = 725511199;
        _this.Gh = 528734635;
        _this.Gl = -79577749;
        _this.Hh = 1541459225;
        _this.Hl = 327033209;
        return _this;
    }
    (0, $1wc17._)(SHA512, [
        {
            // prettier-ignore
            key: "get",
            value: function get() {
                var _this = this, Ah = _this.Ah, Al = _this.Al, Bh = _this.Bh, Bl = _this.Bl, Ch = _this.Ch, Cl = _this.Cl, Dh = _this.Dh, Dl = _this.Dl, Eh = _this.Eh, El = _this.El, Fh = _this.Fh, Fl = _this.Fl, Gh = _this.Gh, Gl = _this.Gl, Hh = _this.Hh, Hl = _this.Hl;
                return [
                    Ah,
                    Al,
                    Bh,
                    Bl,
                    Ch,
                    Cl,
                    Dh,
                    Dl,
                    Eh,
                    El,
                    Fh,
                    Fl,
                    Gh,
                    Gl,
                    Hh,
                    Hl
                ];
            }
        },
        {
            // prettier-ignore
            key: "set",
            value: function set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
                this.Ah = Ah | 0;
                this.Al = Al | 0;
                this.Bh = Bh | 0;
                this.Bl = Bl | 0;
                this.Ch = Ch | 0;
                this.Cl = Cl | 0;
                this.Dh = Dh | 0;
                this.Dl = Dl | 0;
                this.Eh = Eh | 0;
                this.El = El | 0;
                this.Fh = Fh | 0;
                this.Fl = Fl | 0;
                this.Gh = Gh | 0;
                this.Gl = Gl | 0;
                this.Hh = Hh | 0;
                this.Hl = Hl | 0;
            }
        },
        {
            key: "process",
            value: function process(view, offset) {
                // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
                for(var i = 0; i < 16; i++, offset += 4){
                    $8d093dcbb2198339$var$SHA512_W_H[i] = view.getUint32(offset);
                    $8d093dcbb2198339$var$SHA512_W_L[i] = view.getUint32(offset += 4);
                }
                for(var i1 = 16; i1 < 80; i1++){
                    // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
                    var W15h = $8d093dcbb2198339$var$SHA512_W_H[i1 - 15] | 0;
                    var W15l = $8d093dcbb2198339$var$SHA512_W_L[i1 - 15] | 0;
                    var s0h = (0, $Fis3O.default).rotrSH(W15h, W15l, 1) ^ (0, $Fis3O.default).rotrSH(W15h, W15l, 8) ^ (0, $Fis3O.default).shrSH(W15h, W15l, 7);
                    var s0l = (0, $Fis3O.default).rotrSL(W15h, W15l, 1) ^ (0, $Fis3O.default).rotrSL(W15h, W15l, 8) ^ (0, $Fis3O.default).shrSL(W15h, W15l, 7);
                    // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
                    var W2h = $8d093dcbb2198339$var$SHA512_W_H[i1 - 2] | 0;
                    var W2l = $8d093dcbb2198339$var$SHA512_W_L[i1 - 2] | 0;
                    var s1h = (0, $Fis3O.default).rotrSH(W2h, W2l, 19) ^ (0, $Fis3O.default).rotrBH(W2h, W2l, 61) ^ (0, $Fis3O.default).shrSH(W2h, W2l, 6);
                    var s1l = (0, $Fis3O.default).rotrSL(W2h, W2l, 19) ^ (0, $Fis3O.default).rotrBL(W2h, W2l, 61) ^ (0, $Fis3O.default).shrSL(W2h, W2l, 6);
                    // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
                    var SUMl = (0, $Fis3O.default).add4L(s0l, s1l, $8d093dcbb2198339$var$SHA512_W_L[i1 - 7], $8d093dcbb2198339$var$SHA512_W_L[i1 - 16]);
                    var SUMh = (0, $Fis3O.default).add4H(SUMl, s0h, s1h, $8d093dcbb2198339$var$SHA512_W_H[i1 - 7], $8d093dcbb2198339$var$SHA512_W_H[i1 - 16]);
                    $8d093dcbb2198339$var$SHA512_W_H[i1] = SUMh | 0;
                    $8d093dcbb2198339$var$SHA512_W_L[i1] = SUMl | 0;
                }
                var _this = this, Ah = _this.Ah, Al = _this.Al, Bh = _this.Bh, Bl = _this.Bl, Ch = _this.Ch, Cl = _this.Cl, Dh = _this.Dh, Dl = _this.Dl, Eh = _this.Eh, El = _this.El, Fh = _this.Fh, Fl = _this.Fl, Gh = _this.Gh, Gl = _this.Gl, Hh = _this.Hh, Hl = _this.Hl;
                // Compression function main loop, 80 rounds
                for(var i2 = 0; i2 < 80; i2++){
                    // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
                    var sigma1h = (0, $Fis3O.default).rotrSH(Eh, El, 14) ^ (0, $Fis3O.default).rotrSH(Eh, El, 18) ^ (0, $Fis3O.default).rotrBH(Eh, El, 41);
                    var sigma1l = (0, $Fis3O.default).rotrSL(Eh, El, 14) ^ (0, $Fis3O.default).rotrSL(Eh, El, 18) ^ (0, $Fis3O.default).rotrBL(Eh, El, 41);
                    //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
                    var CHIh = Eh & Fh ^ ~Eh & Gh;
                    var CHIl = El & Fl ^ ~El & Gl;
                    // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
                    // prettier-ignore
                    var T1ll = (0, $Fis3O.default).add5L(Hl, sigma1l, CHIl, $8d093dcbb2198339$var$SHA512_Kl[i2], $8d093dcbb2198339$var$SHA512_W_L[i2]);
                    var T1h = (0, $Fis3O.default).add5H(T1ll, Hh, sigma1h, CHIh, $8d093dcbb2198339$var$SHA512_Kh[i2], $8d093dcbb2198339$var$SHA512_W_H[i2]);
                    var T1l = T1ll | 0;
                    // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
                    var sigma0h = (0, $Fis3O.default).rotrSH(Ah, Al, 28) ^ (0, $Fis3O.default).rotrBH(Ah, Al, 34) ^ (0, $Fis3O.default).rotrBH(Ah, Al, 39);
                    var sigma0l = (0, $Fis3O.default).rotrSL(Ah, Al, 28) ^ (0, $Fis3O.default).rotrBL(Ah, Al, 34) ^ (0, $Fis3O.default).rotrBL(Ah, Al, 39);
                    var MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
                    var MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
                    Hh = Gh | 0;
                    Hl = Gl | 0;
                    Gh = Fh | 0;
                    Gl = Fl | 0;
                    Fh = Eh | 0;
                    Fl = El | 0;
                    var ref;
                    ref = (0, $Fis3O.default).add(Dh | 0, Dl | 0, T1h | 0, T1l | 0), Eh = ref.h, El = ref.l, ref;
                    Dh = Ch | 0;
                    Dl = Cl | 0;
                    Ch = Bh | 0;
                    Cl = Bl | 0;
                    Bh = Ah | 0;
                    Bl = Al | 0;
                    var All = (0, $Fis3O.default).add3L(T1l, sigma0l, MAJl);
                    Ah = (0, $Fis3O.default).add3H(All, T1h, sigma0h, MAJh);
                    Al = All | 0;
                }
                var ref1;
                // Add the compressed chunk to the current hash value
                ref1 = (0, $Fis3O.default).add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0), Ah = ref1.h, Al = ref1.l, ref1;
                var ref2;
                ref2 = (0, $Fis3O.default).add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0), Bh = ref2.h, Bl = ref2.l, ref2;
                var ref3;
                ref3 = (0, $Fis3O.default).add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0), Ch = ref3.h, Cl = ref3.l, ref3;
                var ref4;
                ref4 = (0, $Fis3O.default).add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0), Dh = ref4.h, Dl = ref4.l, ref4;
                var ref5;
                ref5 = (0, $Fis3O.default).add(this.Eh | 0, this.El | 0, Eh | 0, El | 0), Eh = ref5.h, El = ref5.l, ref5;
                var ref6;
                ref6 = (0, $Fis3O.default).add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0), Fh = ref6.h, Fl = ref6.l, ref6;
                var ref7;
                ref7 = (0, $Fis3O.default).add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0), Gh = ref7.h, Gl = ref7.l, ref7;
                var ref8;
                ref8 = (0, $Fis3O.default).add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0), Hh = ref8.h, Hl = ref8.l, ref8;
                this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
            }
        },
        {
            key: "roundClean",
            value: function roundClean() {
                $8d093dcbb2198339$var$SHA512_W_H.fill(0);
                $8d093dcbb2198339$var$SHA512_W_L.fill(0);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.buffer.fill(0);
                this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
            }
        }
    ]);
    return SHA512;
}((0, $8ANoe.HashMD));
var $8d093dcbb2198339$var$SHA512_224 = /*#__PURE__*/ function(SHA512) {
    "use strict";
    (0, $dcsZi._)(SHA512_224, SHA512);
    var _super = (0, $ohfOJ._)(SHA512_224);
    function SHA512_224() {
        (0, $4GJKx._)(this, SHA512_224);
        var _this;
        _this = _super.call(this);
        // h -- high 32 bits, l -- low 32 bits
        _this.Ah = -1942145080;
        _this.Al = 424955298;
        _this.Bh = 1944164710;
        _this.Bl = -1982016298;
        _this.Ch = 502970286;
        _this.Cl = 855612546;
        _this.Dh = 1738396948;
        _this.Dl = 1479516111;
        _this.Eh = 258812777;
        _this.El = 2077511080;
        _this.Fh = 2011393907;
        _this.Fl = 79989058;
        _this.Gh = 1067287976;
        _this.Gl = 1780299464;
        _this.Hh = 286451373;
        _this.Hl = -1848208735;
        _this.outputLen = 28;
        return _this;
    }
    return SHA512_224;
}($8d093dcbb2198339$export$d655fdb8a1cad5df);
var $8d093dcbb2198339$var$SHA512_256 = /*#__PURE__*/ function(SHA512) {
    "use strict";
    (0, $dcsZi._)(SHA512_256, SHA512);
    var _super = (0, $ohfOJ._)(SHA512_256);
    function SHA512_256() {
        (0, $4GJKx._)(this, SHA512_256);
        var _this;
        _this = _super.call(this);
        // h -- high 32 bits, l -- low 32 bits
        _this.Ah = 573645204;
        _this.Al = -64227540;
        _this.Bh = -1621794909;
        _this.Bl = -934517566;
        _this.Ch = 596883563;
        _this.Cl = 1867755857;
        _this.Dh = -1774684391;
        _this.Dl = 1497426621;
        _this.Eh = -1775747358;
        _this.El = -1467023389;
        _this.Fh = -1101128155;
        _this.Fl = 1401305490;
        _this.Gh = 721525244;
        _this.Gl = 746961066;
        _this.Hh = 246885852;
        _this.Hl = -2117784414;
        _this.outputLen = 32;
        return _this;
    }
    return SHA512_256;
}($8d093dcbb2198339$export$d655fdb8a1cad5df);
var $8d093dcbb2198339$var$SHA384 = /*#__PURE__*/ function(SHA512) {
    "use strict";
    (0, $dcsZi._)(SHA384, SHA512);
    var _super = (0, $ohfOJ._)(SHA384);
    function SHA384() {
        (0, $4GJKx._)(this, SHA384);
        var _this;
        _this = _super.call(this);
        // h -- high 32 bits, l -- low 32 bits
        _this.Ah = -876896931;
        _this.Al = -1056596264;
        _this.Bh = 1654270250;
        _this.Bl = 914150663;
        _this.Ch = -1856437926;
        _this.Cl = 812702999;
        _this.Dh = 355462360;
        _this.Dl = -150054599;
        _this.Eh = 1731405415;
        _this.El = -4191439;
        _this.Fh = -1900787065;
        _this.Fl = 1750603025;
        _this.Gh = -619958771;
        _this.Gl = 1694076839;
        _this.Hh = 1203062813;
        _this.Hl = -1090891868;
        _this.outputLen = 48;
        return _this;
    }
    return SHA384;
}($8d093dcbb2198339$export$d655fdb8a1cad5df);
var $8d093dcbb2198339$export$a888d2532e6dc7bb = /* @__PURE__ */ (0, $8ybNC.wrapConstructor)(function() {
    return new $8d093dcbb2198339$export$d655fdb8a1cad5df();
});
var $8d093dcbb2198339$export$a090a04f72f0a320 = /* @__PURE__ */ (0, $8ybNC.wrapConstructor)(function() {
    return new $8d093dcbb2198339$var$SHA512_224();
});
var $8d093dcbb2198339$export$c78786b6da86db2a = /* @__PURE__ */ (0, $8ybNC.wrapConstructor)(function() {
    return new $8d093dcbb2198339$var$SHA512_256();
});
var $8d093dcbb2198339$export$612d47d55dedde45 = /* @__PURE__ */ (0, $8ybNC.wrapConstructor)(function() {
    return new $8d093dcbb2198339$var$SHA384();
});

});

parcelRegister("byA26", function(module, exports) {

$parcel$export(module.exports, "twistedEdwards", function () { return $869ed2121bc17965$export$f0c1eee63ea541eb; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Twisted Edwards curve. The formula is: ax² + y² = 1 + dx²y²

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $do9pw = parcelRequire("do9pw");

var $c6Xmf = parcelRequire("c6Xmf");

var $1JA7e = parcelRequire("1JA7e");

var $fnxE9 = parcelRequire("fnxE9");

var $cOBbr = parcelRequire("cOBbr");
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
var $869ed2121bc17965$var$_0n = BigInt(0), $869ed2121bc17965$var$_1n = BigInt(1), $869ed2121bc17965$var$_2n = BigInt(2), $869ed2121bc17965$var$_8n = BigInt(8);
// verification rule is either zip215 or rfc8032 / nist186-5. Consult fromHex:
var $869ed2121bc17965$var$VERIFY_DEFAULT = {
    zip215: true
};
function $869ed2121bc17965$var$validateOpts(curve) {
    var opts = (0, $1JA7e.validateBasic)(curve);
    $cOBbr.validateObject(curve, {
        hash: "function",
        a: "bigint",
        d: "bigint",
        randomBytes: "function"
    }, {
        adjustScalarBytes: "function",
        domain: "function",
        uvRatio: "function",
        mapToCurve: "function"
    });
    // Set defaults
    return Object.freeze((0, $do9pw._)({}, opts));
}
function $869ed2121bc17965$export$f0c1eee63ea541eb(curveDef) {
    var CURVE = $869ed2121bc17965$var$validateOpts(curveDef);
    var Fp = CURVE.Fp, CURVE_ORDER = CURVE.n, prehash = CURVE.prehash, cHash = CURVE.hash, randomBytes = CURVE.randomBytes, nByteLength = CURVE.nByteLength, cofactor = CURVE.h;
    var MASK = $869ed2121bc17965$var$_2n << BigInt(nByteLength * 8) - $869ed2121bc17965$var$_1n;
    var modP = Fp.create; // Function overrides
    // sqrt(u/v)
    var uvRatio = CURVE.uvRatio || function(u, v) {
        try {
            return {
                isValid: true,
                value: Fp.sqrt(u * Fp.inv(v))
            };
        } catch (e) {
            return {
                isValid: false,
                value: $869ed2121bc17965$var$_0n
            };
        }
    };
    var adjustScalarBytes = CURVE.adjustScalarBytes || function(bytes) {
        return bytes;
    }; // NOOP
    var domain = CURVE.domain || function(data, ctx, phflag) {
        (0, $cOBbr.abool)("phflag", phflag);
        if (ctx.length || phflag) throw new Error("Contexts/pre-hash are not supported");
        return data;
    }; // NOOP
    // 0 <= n < MASK
    // Coordinates larger than Fp.ORDER are allowed for zip215
    function aCoordinate(title, n) {
        $cOBbr.aInRange("coordinate " + title, n, $869ed2121bc17965$var$_0n, MASK);
    }
    function assertPoint(other) {
        if (!(other instanceof Point)) throw new Error("ExtendedPoint expected");
    }
    // Converts Extended point to default (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    var toAffineMemo = (0, $cOBbr.memoized)(function(p, iz) {
        var x = p.ex, y = p.ey, z = p.ez;
        var is0 = p.is0();
        if (iz == null) iz = is0 ? $869ed2121bc17965$var$_8n : Fp.inv(z); // 8 was chosen arbitrarily
        var ax = modP(x * iz);
        var ay = modP(y * iz);
        var zz = modP(z * iz);
        if (is0) return {
            x: $869ed2121bc17965$var$_0n,
            y: $869ed2121bc17965$var$_1n
        };
        if (zz !== $869ed2121bc17965$var$_1n) throw new Error("invZ was invalid");
        return {
            x: ax,
            y: ay
        };
    });
    var assertValidMemo = (0, $cOBbr.memoized)(function(p) {
        var a = CURVE.a, d = CURVE.d;
        if (p.is0()) throw new Error("bad point: ZERO"); // TODO: optimize, with vars below?
        // Equation in affine coordinates: ax² + y² = 1 + dx²y²
        // Equation in projective coordinates (X/Z, Y/Z, Z):  (aX² + Y²)Z² = Z⁴ + dX²Y²
        var X = p.ex, Y = p.ey, Z = p.ez, T = p.et;
        var X2 = modP(X * X); // X²
        var Y2 = modP(Y * Y); // Y²
        var Z2 = modP(Z * Z); // Z²
        var Z4 = modP(Z2 * Z2); // Z⁴
        var aX2 = modP(X2 * a); // aX²
        var left = modP(Z2 * modP(aX2 + Y2)); // (aX² + Y²)Z²
        var right = modP(Z4 + modP(d * modP(X2 * Y2))); // Z⁴ + dX²Y²
        if (left !== right) throw new Error("bad point: equation left != right (1)");
        // In Extended coordinates we also have T, which is x*y=T/Z: check X*Y == Z*T
        var XY = modP(X * Y);
        var ZT = modP(Z * T);
        if (XY !== ZT) throw new Error("bad point: equation left != right (2)");
        return true;
    });
    // Extended Point works in extended coordinates: (x, y, z, t) ∋ (x=x/z, y=y/z, t=xy).
    // https://en.wikipedia.org/wiki/Twisted_Edwards_curve#Extended_coordinates
    var Point = /*#__PURE__*/ function() {
        "use strict";
        function Point(ex, ey, ez, et) {
            (0, $4GJKx._)(this, Point);
            this.ex = ex;
            this.ey = ey;
            this.ez = ez;
            this.et = et;
            aCoordinate("x", ex);
            aCoordinate("y", ey);
            aCoordinate("z", ez);
            aCoordinate("t", et);
            Object.freeze(this);
        }
        (0, $1wc17._)(Point, [
            {
                key: "x",
                get: function get() {
                    return this.toAffine().x;
                }
            },
            {
                key: "y",
                get: function get() {
                    return this.toAffine().y;
                }
            },
            {
                // "Private method", don't use it directly
                key: "_setWindowSize",
                value: function _setWindowSize(windowSize) {
                    wnaf.setWindowSize(this, windowSize);
                }
            },
            {
                // Not required for fromHex(), which always creates valid points.
                // Could be useful for fromAffine().
                key: "assertValidity",
                value: function assertValidity() {
                    assertValidMemo(this);
                }
            },
            {
                // Compare one point to another.
                key: "equals",
                value: function equals(other) {
                    assertPoint(other);
                    var _this = this, X1 = _this.ex, Y1 = _this.ey, Z1 = _this.ez;
                    var X2 = other.ex, Y2 = other.ey, Z2 = other.ez;
                    var X1Z2 = modP(X1 * Z2);
                    var X2Z1 = modP(X2 * Z1);
                    var Y1Z2 = modP(Y1 * Z2);
                    var Y2Z1 = modP(Y2 * Z1);
                    return X1Z2 === X2Z1 && Y1Z2 === Y2Z1;
                }
            },
            {
                key: "is0",
                value: function is0() {
                    return this.equals(Point.ZERO);
                }
            },
            {
                key: "negate",
                value: function negate() {
                    // Flips point sign to a negative one (-x, y in affine coords)
                    return new Point(modP(-this.ex), this.ey, this.ez, modP(-this.et));
                }
            },
            {
                // Fast algo for doubling Extended Point.
                // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#doubling-dbl-2008-hwcd
                // Cost: 4M + 4S + 1*a + 6add + 1*2.
                key: "double",
                value: function double() {
                    var a = CURVE.a;
                    var _this = this, X1 = _this.ex, Y1 = _this.ey, Z1 = _this.ez;
                    var A = modP(X1 * X1); // A = X12
                    var B = modP(Y1 * Y1); // B = Y12
                    var C = modP($869ed2121bc17965$var$_2n * modP(Z1 * Z1)); // C = 2*Z12
                    var D = modP(a * A); // D = a*A
                    var x1y1 = X1 + Y1;
                    var E = modP(modP(x1y1 * x1y1) - A - B); // E = (X1+Y1)2-A-B
                    var G = D + B; // G = D+B
                    var F = G - C; // F = G-C
                    var H = D - B; // H = D-B
                    var X3 = modP(E * F); // X3 = E*F
                    var Y3 = modP(G * H); // Y3 = G*H
                    var T3 = modP(E * H); // T3 = E*H
                    var Z3 = modP(F * G); // Z3 = F*G
                    return new Point(X3, Y3, Z3, T3);
                }
            },
            {
                // Fast algo for adding 2 Extended Points.
                // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#addition-add-2008-hwcd
                // Cost: 9M + 1*a + 1*d + 7add.
                key: "add",
                value: function add(other) {
                    assertPoint(other);
                    var a = CURVE.a, d = CURVE.d;
                    var _this = this, X1 = _this.ex, Y1 = _this.ey, Z1 = _this.ez, T1 = _this.et;
                    var X2 = other.ex, Y2 = other.ey, Z2 = other.ez, T2 = other.et;
                    // Faster algo for adding 2 Extended Points when curve's a=-1.
                    // http://hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html#addition-add-2008-hwcd-4
                    // Cost: 8M + 8add + 2*2.
                    // Note: It does not check whether the `other` point is valid.
                    if (a === BigInt(-1)) {
                        var A = modP((Y1 - X1) * (Y2 + X2));
                        var B = modP((Y1 + X1) * (Y2 - X2));
                        var F = modP(B - A);
                        if (F === $869ed2121bc17965$var$_0n) return this.double(); // Same point. Tests say it doesn't affect timing
                        var C = modP(Z1 * $869ed2121bc17965$var$_2n * T2);
                        var D = modP(T1 * $869ed2121bc17965$var$_2n * Z2);
                        var E = D + C;
                        var G = B + A;
                        var H = D - C;
                        var X3 = modP(E * F);
                        var Y3 = modP(G * H);
                        var T3 = modP(E * H);
                        var Z3 = modP(F * G);
                        return new Point(X3, Y3, Z3, T3);
                    }
                    var A1 = modP(X1 * X2); // A = X1*X2
                    var B1 = modP(Y1 * Y2); // B = Y1*Y2
                    var C1 = modP(T1 * d * T2); // C = T1*d*T2
                    var D1 = modP(Z1 * Z2); // D = Z1*Z2
                    var E1 = modP((X1 + Y1) * (X2 + Y2) - A1 - B1); // E = (X1+Y1)*(X2+Y2)-A-B
                    var F1 = D1 - C1; // F = D-C
                    var G1 = D1 + C1; // G = D+C
                    var H1 = modP(B1 - a * A1); // H = B-a*A
                    var X31 = modP(E1 * F1); // X3 = E*F
                    var Y31 = modP(G1 * H1); // Y3 = G*H
                    var T31 = modP(E1 * H1); // T3 = E*H
                    var Z31 = modP(F1 * G1); // Z3 = F*G
                    return new Point(X31, Y31, Z31, T31);
                }
            },
            {
                key: "subtract",
                value: function subtract(other) {
                    return this.add(other.negate());
                }
            },
            {
                key: "wNAF",
                value: function wNAF(n) {
                    return wnaf.wNAFCached(this, n, Point.normalizeZ);
                }
            },
            {
                // Constant-time multiplication.
                key: "multiply",
                value: function multiply(scalar) {
                    var n = scalar;
                    $cOBbr.aInRange("scalar", n, $869ed2121bc17965$var$_1n, CURVE_ORDER); // 1 <= scalar < L
                    var _this_wNAF = this.wNAF(n), p = _this_wNAF.p, f = _this_wNAF.f;
                    return Point.normalizeZ([
                        p,
                        f
                    ])[0];
                }
            },
            {
                // Non-constant-time multiplication. Uses double-and-add algorithm.
                // It's faster, but should only be used when you don't care about
                // an exposed private key e.g. sig verification.
                // Does NOT allow scalars higher than CURVE.n.
                key: "multiplyUnsafe",
                value: function multiplyUnsafe(scalar) {
                    var n = scalar;
                    $cOBbr.aInRange("scalar", n, $869ed2121bc17965$var$_0n, CURVE_ORDER); // 0 <= scalar < L
                    if (n === $869ed2121bc17965$var$_0n) return I;
                    if (this.equals(I) || n === $869ed2121bc17965$var$_1n) return this;
                    if (this.equals(G)) return this.wNAF(n).p;
                    return wnaf.unsafeLadder(this, n);
                }
            },
            {
                // Checks if point is of small order.
                // If you add something to small order point, you will have "dirty"
                // point with torsion component.
                // Multiplies point by cofactor and checks if the result is 0.
                key: "isSmallOrder",
                value: function isSmallOrder() {
                    return this.multiplyUnsafe(cofactor).is0();
                }
            },
            {
                // Multiplies point by curve order and checks if the result is 0.
                // Returns `false` is the point is dirty.
                key: "isTorsionFree",
                value: function isTorsionFree() {
                    return wnaf.unsafeLadder(this, CURVE_ORDER).is0();
                }
            },
            {
                // Converts Extended point to default (x, y) coordinates.
                // Can accept precomputed Z^-1 - for example, from invertBatch.
                key: "toAffine",
                value: function toAffine(iz) {
                    return toAffineMemo(this, iz);
                }
            },
            {
                key: "clearCofactor",
                value: function clearCofactor() {
                    var cofactor = CURVE.h;
                    if (cofactor === $869ed2121bc17965$var$_1n) return this;
                    return this.multiplyUnsafe(cofactor);
                }
            },
            {
                key: "toRawBytes",
                value: function toRawBytes() {
                    var _this_toAffine = this.toAffine(), x = _this_toAffine.x, y = _this_toAffine.y;
                    var bytes = $cOBbr.numberToBytesLE(y, Fp.BYTES); // each y has 2 x values (x, -y)
                    bytes[bytes.length - 1] |= x & $869ed2121bc17965$var$_1n ? 0x80 : 0; // when compressing, it's enough to store y
                    return bytes; // and use the last byte to encode sign of x
                }
            },
            {
                key: "toHex",
                value: function toHex() {
                    return $cOBbr.bytesToHex(this.toRawBytes()); // Same as toRawBytes, but returns string.
                }
            }
        ], [
            {
                key: "fromAffine",
                value: function fromAffine(p) {
                    if (p instanceof Point) throw new Error("extended point not allowed");
                    var _ref = p || {}, x = _ref.x, y = _ref.y;
                    aCoordinate("x", x);
                    aCoordinate("y", y);
                    return new Point(x, y, $869ed2121bc17965$var$_1n, modP(x * y));
                }
            },
            {
                key: "normalizeZ",
                value: function normalizeZ(points) {
                    var toInv = Fp.invertBatch(points.map(function(p) {
                        return p.ez;
                    }));
                    return points.map(function(p, i) {
                        return p.toAffine(toInv[i]);
                    }).map(Point.fromAffine);
                }
            },
            {
                key: "fromHex",
                value: // Converts hash string or Uint8Array to Point.
                // Uses algo from RFC8032 5.1.3.
                function fromHex(hex) {
                    var zip215 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                    var d = CURVE.d, a = CURVE.a;
                    var len = Fp.BYTES;
                    hex = (0, $cOBbr.ensureBytes)("pointHex", hex, len); // copy hex to a new array
                    (0, $cOBbr.abool)("zip215", zip215);
                    var normed = hex.slice(); // copy again, we'll manipulate it
                    var lastByte = hex[len - 1]; // select last byte
                    normed[len - 1] = lastByte & -129; // clear last bit
                    var y = $cOBbr.bytesToNumberLE(normed);
                    // RFC8032 prohibits >= p, but ZIP215 doesn't
                    // zip215=true:  0 <= y < MASK (2^256 for ed25519)
                    // zip215=false: 0 <= y < P (2^255-19 for ed25519)
                    var max = zip215 ? MASK : Fp.ORDER;
                    $cOBbr.aInRange("pointHex.y", y, $869ed2121bc17965$var$_0n, max);
                    // Ed25519: x² = (y²-1)/(dy²+1) mod p. Ed448: x² = (y²-1)/(dy²-1) mod p. Generic case:
                    // ax²+y²=1+dx²y² => y²-1=dx²y²-ax² => y²-1=x²(dy²-a) => x²=(y²-1)/(dy²-a)
                    var y2 = modP(y * y); // denominator is always non-0 mod p.
                    var u = modP(y2 - $869ed2121bc17965$var$_1n); // u = y² - 1
                    var v = modP(d * y2 - a); // v = d y² + 1.
                    var _uvRatio = uvRatio(u, v), isValid = _uvRatio.isValid, x = _uvRatio.value; // √(u/v)
                    if (!isValid) throw new Error("Point.fromHex: invalid y coordinate");
                    var isXOdd = (x & $869ed2121bc17965$var$_1n) === $869ed2121bc17965$var$_1n; // There are 2 square roots. Use x_0 bit to select proper
                    var isLastByteOdd = (lastByte & 0x80) !== 0; // x_0, last bit
                    if (!zip215 && x === $869ed2121bc17965$var$_0n && isLastByteOdd) // if x=0 and x_0 = 1, fail
                    throw new Error("Point.fromHex: x=0 and x_0=1");
                    if (isLastByteOdd !== isXOdd) x = modP(-x); // if x_0 != x mod 2, set x = p-x
                    return Point.fromAffine({
                        x: x,
                        y: y
                    });
                }
            },
            {
                key: "fromPrivateKey",
                value: function fromPrivateKey(privKey) {
                    return getExtendedPublicKey(privKey).point;
                }
            }
        ]);
        return Point;
    }();
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, $869ed2121bc17965$var$_1n, modP(CURVE.Gx * CURVE.Gy));
    Point.ZERO = new Point($869ed2121bc17965$var$_0n, $869ed2121bc17965$var$_1n, $869ed2121bc17965$var$_1n, $869ed2121bc17965$var$_0n); // 0, 1, 1, 0
    var G = Point.BASE, I = Point.ZERO;
    var wnaf = (0, $1JA7e.wNAF)(Point, nByteLength * 8);
    function modN(a) {
        return (0, $fnxE9.mod)(a, CURVE_ORDER);
    }
    // Little-endian SHA512 with modulo n
    function modN_LE(hash) {
        return modN($cOBbr.bytesToNumberLE(hash));
    }
    /** Convenience method that creates public key and other stuff. RFC8032 5.1.5 */ function getExtendedPublicKey(key) {
        var len = nByteLength;
        key = (0, $cOBbr.ensureBytes)("private key", key, len);
        // Hash private key with curve's hash function to produce uniformingly random input
        // Check byte lengths: ensure(64, h(ensure(32, key)))
        var hashed = (0, $cOBbr.ensureBytes)("hashed private key", cHash(key), 2 * len);
        var head = adjustScalarBytes(hashed.slice(0, len)); // clear first half bits, produce FE
        var prefix = hashed.slice(len, 2 * len); // second half is called key prefix (5.1.6)
        var scalar = modN_LE(head); // The actual private scalar
        var point = G.multiply(scalar); // Point on Edwards curve aka public key
        var pointBytes = point.toRawBytes(); // Uint8Array representation
        return {
            head: head,
            prefix: prefix,
            scalar: scalar,
            point: point,
            pointBytes: pointBytes
        };
    }
    // Calculates EdDSA pub key. RFC8032 5.1.5. Privkey is hashed. Use first half with 3 bits cleared
    function getPublicKey(privKey) {
        return getExtendedPublicKey(privKey).pointBytes;
    }
    // int('LE', SHA512(dom2(F, C) || msgs)) mod N
    function hashDomainToScalar() {
        var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Uint8Array();
        for(var _len = arguments.length, msgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            msgs[_key - 1] = arguments[_key];
        }
        var _ut;
        var msg = (_ut = $cOBbr).concatBytes.apply(_ut, (0, $c6Xmf._)(msgs));
        return modN_LE(cHash(domain(msg, (0, $cOBbr.ensureBytes)("context", context), !!prehash)));
    }
    /** Signs message with privateKey. RFC8032 5.1.6 */ function sign(msg, privKey) {
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        msg = (0, $cOBbr.ensureBytes)("message", msg);
        if (prehash) msg = prehash(msg); // for ed25519ph etc.
        var _getExtendedPublicKey = getExtendedPublicKey(privKey), prefix = _getExtendedPublicKey.prefix, scalar = _getExtendedPublicKey.scalar, pointBytes = _getExtendedPublicKey.pointBytes;
        var r = hashDomainToScalar(options.context, prefix, msg); // r = dom2(F, C) || prefix || PH(M)
        var R = G.multiply(r).toRawBytes(); // R = rG
        var k = hashDomainToScalar(options.context, R, pointBytes, msg); // R || A || PH(M)
        var s = modN(r + k * scalar); // S = (r + k * s) mod L
        $cOBbr.aInRange("signature.s", s, $869ed2121bc17965$var$_0n, CURVE_ORDER); // 0 <= s < l
        var res = $cOBbr.concatBytes(R, $cOBbr.numberToBytesLE(s, Fp.BYTES));
        return (0, $cOBbr.ensureBytes)("result", res, nByteLength * 2); // 64-byte signature
    }
    var verifyOpts = $869ed2121bc17965$var$VERIFY_DEFAULT;
    function verify(sig, msg, publicKey) {
        var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : verifyOpts;
        var context = options.context, zip215 = options.zip215;
        var len = Fp.BYTES; // Verifies EdDSA signature against message and public key. RFC8032 5.1.7.
        sig = (0, $cOBbr.ensureBytes)("signature", sig, 2 * len); // An extended group equation is checked.
        msg = (0, $cOBbr.ensureBytes)("message", msg);
        if (zip215 !== undefined) (0, $cOBbr.abool)("zip215", zip215);
        if (prehash) msg = prehash(msg); // for ed25519ph, etc
        var s = $cOBbr.bytesToNumberLE(sig.slice(len, 2 * len));
        // zip215: true is good for consensus-critical apps and allows points < 2^256
        // zip215: false follows RFC8032 / NIST186-5 and restricts points to CURVE.p
        var A, R, SB;
        try {
            A = Point.fromHex(publicKey, zip215);
            R = Point.fromHex(sig.slice(0, len), zip215);
            SB = G.multiplyUnsafe(s); // 0 <= s < l is done inside
        } catch (error) {
            return false;
        }
        if (!zip215 && A.isSmallOrder()) return false;
        var k = hashDomainToScalar(context, R.toRawBytes(), A.toRawBytes(), msg);
        var RkA = R.add(A.multiplyUnsafe(k));
        // [8][S]B = [8]R + [8][k]A'
        return RkA.subtract(SB).clearCofactor().equals(Point.ZERO);
    }
    G._setWindowSize(8); // Enable precomputes. Slows down first publicKey computation by 20ms.
    var utils = {
        getExtendedPublicKey: getExtendedPublicKey,
        // ed25519 private keys are uniform 32b. No need to check for modulo bias, like in secp256k1.
        randomPrivateKey: function() {
            return randomBytes(Fp.BYTES);
        },
        /**
         * We're doing scalar multiplication (used in getPublicKey etc) with precomputed BASE_POINT
         * values. This slows down first getPublicKey() by milliseconds (see Speed section),
         * but allows to speed-up subsequent getPublicKey() calls up to 20x.
         * @param windowSize 2, 4, 8, 16
         */ precompute: function() {
            var windowSize = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 8, point = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Point.BASE;
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3));
            return point;
        }
    };
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        sign: sign,
        verify: verify,
        ExtendedPoint: Point,
        utils: utils
    };
}

});
parcelRegister("1JA7e", function(module, exports) {

$parcel$export(module.exports, "wNAF", function () { return wNAF; });
$parcel$export(module.exports, "validateBasic", function () { return validateBasic; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Abelian group utilities

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $fnxE9 = parcelRequire("fnxE9");

var $cOBbr = parcelRequire("cOBbr");
var _0n = BigInt(0);
var _1n = BigInt(1);
// Since points in different groups cannot be equal (different object constructor),
// we can have single place to store precomputes
var pointPrecomputes = new WeakMap();
var pointWindowSizes = new WeakMap(); // This allows use make points immutable (nothing changes inside)
function wNAF(c, bits) {
    var constTimeNegate = function(condition, item) {
        var neg = item.negate();
        return condition ? neg : item;
    };
    var validateW = function(W) {
        if (!Number.isSafeInteger(W) || W <= 0 || W > bits) throw new Error("Wrong window size=".concat(W, ", should be [1..").concat(bits, "]"));
    };
    var opts = function(W) {
        validateW(W);
        var windows = Math.ceil(bits / W) + 1; // +1, because
        var windowSize = Math.pow(2, W - 1); // -1 because we skip zero
        return {
            windows: windows,
            windowSize: windowSize
        };
    };
    return {
        constTimeNegate: constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder: function(elm, n) {
            var p = c.ZERO;
            var d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow: function(elm, W) {
            var _opts = opts(W), windows = _opts.windows, windowSize = _opts.windowSize;
            var points = [];
            var p = elm;
            var base = p;
            for(var window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(var i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF: function(W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            var _opts = opts(W), windows = _opts.windows, windowSize = _opts.windowSize;
            var p = c.ZERO;
            var f = c.BASE;
            var mask = BigInt(Math.pow(2, W) - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            var maxNumber = Math.pow(2, W);
            var shiftBy = BigInt(W);
            for(var window = 0; window < windows; window++){
                var offset = window * windowSize;
                // Extract W bits.
                var wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                var offset1 = offset;
                var offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                var cond1 = window % 2 !== 0;
                var cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        wNAFCached: function(P, n, transform) {
            var W = pointWindowSizes.get(P) || 1;
            // Calculate precomputes on a first run, reuse them after
            var comp = pointPrecomputes.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) pointPrecomputes.set(P, transform(comp));
            }
            return this.wNAF(W, comp, n);
        },
        // We calculate precomputes for elliptic curve point multiplication
        // using windowed method. This specifies window size and
        // stores precomputed values. Usually only base point would be precomputed.
        setWindowSize: function(P, W) {
            validateW(W);
            pointWindowSizes.set(P, W);
            pointPrecomputes.delete(P);
        }
    };
}
function validateBasic(curve) {
    (0, $fnxE9.validateField)(curve.Fp);
    (0, $cOBbr.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze((0, $cxjpp._)((0, $do9pw._)({}, (0, $fnxE9.nLength)(curve.n, curve.nBitLength), curve), {
        p: curve.Fp.ORDER
    }));
}

});
parcelRegister("fnxE9", function(module, exports) {

$parcel$export(module.exports, "mod", function () { return $b3231a81ebc758c6$export$842a2cf37af977e1; });
$parcel$export(module.exports, "pow", function () { return $b3231a81ebc758c6$export$9c297f60e22e3389; });
$parcel$export(module.exports, "pow2", function () { return $b3231a81ebc758c6$export$fa569bd808b67eef; });
$parcel$export(module.exports, "invert", function () { return $b3231a81ebc758c6$export$6897c284b6f9f4dc; });
$parcel$export(module.exports, "isNegativeLE", function () { return $b3231a81ebc758c6$export$7806f13ad5078b2f; });
$parcel$export(module.exports, "validateField", function () { return $b3231a81ebc758c6$export$bd454f0cef11418d; });
$parcel$export(module.exports, "nLength", function () { return $b3231a81ebc758c6$export$c79df43ecd7e66c2; });
$parcel$export(module.exports, "Field", function () { return $b3231a81ebc758c6$export$a455218a85c89869; });
$parcel$export(module.exports, "FpSqrtEven", function () { return $b3231a81ebc758c6$export$1d7b691df0888e02; });
$parcel$export(module.exports, "getMinHashLength", function () { return $b3231a81ebc758c6$export$d058763b563056af; });
$parcel$export(module.exports, "mapHashToField", function () { return $b3231a81ebc758c6$export$20cb21dbfa61dac3; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Utilities for modular arithmetics and finite fields

var $l0HdX = parcelRequire("l0HdX");

var $cOBbr = parcelRequire("cOBbr");
// prettier-ignore
var $b3231a81ebc758c6$var$_0n = BigInt(0), $b3231a81ebc758c6$var$_1n = BigInt(1), $b3231a81ebc758c6$var$_2n = BigInt(2), $b3231a81ebc758c6$var$_3n = BigInt(3);
// prettier-ignore
var $b3231a81ebc758c6$var$_4n = BigInt(4), $b3231a81ebc758c6$var$_5n = BigInt(5), $b3231a81ebc758c6$var$_8n = BigInt(8);
// prettier-ignore
var $b3231a81ebc758c6$var$_9n = BigInt(9), $b3231a81ebc758c6$var$_16n = BigInt(16);
function $b3231a81ebc758c6$export$842a2cf37af977e1(a, b) {
    var result = a % b;
    return result >= $b3231a81ebc758c6$var$_0n ? result : b + result;
}
function $b3231a81ebc758c6$export$9c297f60e22e3389(num, power, modulo) {
    if (modulo <= $b3231a81ebc758c6$var$_0n || power < $b3231a81ebc758c6$var$_0n) throw new Error("Expected power/modulo > 0");
    if (modulo === $b3231a81ebc758c6$var$_1n) return $b3231a81ebc758c6$var$_0n;
    var res = $b3231a81ebc758c6$var$_1n;
    while(power > $b3231a81ebc758c6$var$_0n){
        if (power & $b3231a81ebc758c6$var$_1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= $b3231a81ebc758c6$var$_1n;
    }
    return res;
}
function $b3231a81ebc758c6$export$fa569bd808b67eef(x, power, modulo) {
    var res = x;
    while(power-- > $b3231a81ebc758c6$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
function $b3231a81ebc758c6$export$6897c284b6f9f4dc(number, modulo) {
    if (number === $b3231a81ebc758c6$var$_0n || modulo <= $b3231a81ebc758c6$var$_0n) throw new Error("invert: expected positive integers, got n=".concat(number, " mod=").concat(modulo));
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    var a = $b3231a81ebc758c6$export$842a2cf37af977e1(number, modulo);
    var b = modulo;
    // prettier-ignore
    var x = $b3231a81ebc758c6$var$_0n, y = $b3231a81ebc758c6$var$_1n, u = $b3231a81ebc758c6$var$_1n, v = $b3231a81ebc758c6$var$_0n;
    while(a !== $b3231a81ebc758c6$var$_0n){
        // JIT applies optimization if those two lines follow each other
        var q = b / a;
        var r = b % a;
        var m = x - u * q;
        var n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    var gcd = b;
    if (gcd !== $b3231a81ebc758c6$var$_1n) throw new Error("invert: does not exist");
    return $b3231a81ebc758c6$export$842a2cf37af977e1(x, modulo);
}
function $b3231a81ebc758c6$export$69f29ab1f3e9a234(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    var legendreC = (P - $b3231a81ebc758c6$var$_1n) / $b3231a81ebc758c6$var$_2n;
    var Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - $b3231a81ebc758c6$var$_1n, S = 0; Q % $b3231a81ebc758c6$var$_2n === $b3231a81ebc758c6$var$_0n; Q /= $b3231a81ebc758c6$var$_2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = $b3231a81ebc758c6$var$_2n; Z < P && $b3231a81ebc758c6$export$9c297f60e22e3389(Z, legendreC, P) !== P - $b3231a81ebc758c6$var$_1n; Z++);
    // Fast-path
    if (S === 1) {
        var p1div4 = (P + $b3231a81ebc758c6$var$_1n) / $b3231a81ebc758c6$var$_4n;
        return function tonelliFast(Fp, n) {
            var root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Slow-path
    var Q1div2 = (Q + $b3231a81ebc758c6$var$_1n) / $b3231a81ebc758c6$var$_2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error("Cannot find square root");
        var r = S;
        // TODO: will fail at Fp2/etc
        var g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        var x = Fp.pow(n, Q1div2); // first guess at the square root
        var b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            var m = 1;
            for(var t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            var ge = Fp.pow(g, $b3231a81ebc758c6$var$_1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
function $b3231a81ebc758c6$export$33bda048c6b8ea7d(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % $b3231a81ebc758c6$var$_4n === $b3231a81ebc758c6$var$_3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        var p1div4 = (P + $b3231a81ebc758c6$var$_1n) / $b3231a81ebc758c6$var$_4n;
        return function sqrt3mod4(Fp, n) {
            var root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % $b3231a81ebc758c6$var$_8n === $b3231a81ebc758c6$var$_5n) {
        var c1 = (P - $b3231a81ebc758c6$var$_5n) / $b3231a81ebc758c6$var$_8n;
        return function sqrt5mod8(Fp, n) {
            var n2 = Fp.mul(n, $b3231a81ebc758c6$var$_2n);
            var v = Fp.pow(n2, c1);
            var nv = Fp.mul(n, v);
            var i = Fp.mul(Fp.mul(nv, $b3231a81ebc758c6$var$_2n), v);
            var root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    $b3231a81ebc758c6$var$_9n;
    // Other cases: Tonelli-Shanks algorithm
    return $b3231a81ebc758c6$export$69f29ab1f3e9a234(P);
}
var $b3231a81ebc758c6$export$7806f13ad5078b2f = function(num, modulo) {
    return ($b3231a81ebc758c6$export$842a2cf37af977e1(num, modulo) & $b3231a81ebc758c6$var$_1n) === $b3231a81ebc758c6$var$_1n;
};
// prettier-ignore
var $b3231a81ebc758c6$var$FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $b3231a81ebc758c6$export$bd454f0cef11418d(field) {
    var initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    var opts = $b3231a81ebc758c6$var$FIELD_FIELDS.reduce(function(map, val) {
        map[val] = "function";
        return map;
    }, initial);
    return (0, $cOBbr.validateObject)(field, opts);
}
function $b3231a81ebc758c6$export$5d8ce3717733a987(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < $b3231a81ebc758c6$var$_0n) throw new Error("Expected power > 0");
    if (power === $b3231a81ebc758c6$var$_0n) return f.ONE;
    if (power === $b3231a81ebc758c6$var$_1n) return num;
    var p = f.ONE;
    var d = num;
    while(power > $b3231a81ebc758c6$var$_0n){
        if (power & $b3231a81ebc758c6$var$_1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= $b3231a81ebc758c6$var$_1n;
    }
    return p;
}
function $b3231a81ebc758c6$export$a492e3387142c0e9(f, nums) {
    var tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    var lastMultiplied = nums.reduce(function(acc, num, i) {
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    var inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight(function(acc, num, i) {
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
function $b3231a81ebc758c6$export$e74c665040343df6(f, lhs, rhs) {
    return f.mul(lhs, (typeof rhs === "undefined" ? "undefined" : (0, $l0HdX._)(rhs)) === "bigint" ? $b3231a81ebc758c6$export$6897c284b6f9f4dc(rhs, f.ORDER) : f.inv(rhs));
}
function $b3231a81ebc758c6$export$77ed22730026dd0d(order) {
    // (a | p) ≡ 1    if a is a square (mod p), quadratic residue
    // (a | p) ≡ -1   if a is not a square (mod p), quadratic non residue
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    var legendreConst = (order - $b3231a81ebc758c6$var$_1n) / $b3231a81ebc758c6$var$_2n; // Integer arithmetic
    return function(f, x) {
        return f.pow(x, legendreConst);
    };
}
function $b3231a81ebc758c6$export$5e2b6e87f2891ea7(f) {
    var legendre = $b3231a81ebc758c6$export$77ed22730026dd0d(f.ORDER);
    return function(x) {
        var p = legendre(f, x);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
function $b3231a81ebc758c6$export$c79df43ecd7e66c2(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    var _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    var nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
function $b3231a81ebc758c6$export$a455218a85c89869(ORDER, bitLen) {
    var isLE = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, redef = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    if (ORDER <= $b3231a81ebc758c6$var$_0n) throw new Error("Expected Field ORDER > 0, got ".concat(ORDER));
    var _nLength = $b3231a81ebc758c6$export$c79df43ecd7e66c2(ORDER, bitLen), BITS = _nLength.nBitLength, BYTES = _nLength.nByteLength;
    if (BYTES > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
    var sqrtP = $b3231a81ebc758c6$export$33bda048c6b8ea7d(ORDER);
    var f = Object.freeze({
        ORDER: ORDER,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $cOBbr.bitMask)(BITS),
        ZERO: $b3231a81ebc758c6$var$_0n,
        ONE: $b3231a81ebc758c6$var$_1n,
        create: function(num) {
            return $b3231a81ebc758c6$export$842a2cf37af977e1(num, ORDER);
        },
        isValid: function(num) {
            if ((typeof num === "undefined" ? "undefined" : (0, $l0HdX._)(num)) !== "bigint") throw new Error("Invalid field element: expected bigint, got ".concat(typeof num === "undefined" ? "undefined" : (0, $l0HdX._)(num)));
            return $b3231a81ebc758c6$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: function(num) {
            return num === $b3231a81ebc758c6$var$_0n;
        },
        isOdd: function(num) {
            return (num & $b3231a81ebc758c6$var$_1n) === $b3231a81ebc758c6$var$_1n;
        },
        neg: function(num) {
            return $b3231a81ebc758c6$export$842a2cf37af977e1(-num, ORDER);
        },
        eql: function(lhs, rhs) {
            return lhs === rhs;
        },
        sqr: function(num) {
            return $b3231a81ebc758c6$export$842a2cf37af977e1(num * num, ORDER);
        },
        add: function(lhs, rhs) {
            return $b3231a81ebc758c6$export$842a2cf37af977e1(lhs + rhs, ORDER);
        },
        sub: function(lhs, rhs) {
            return $b3231a81ebc758c6$export$842a2cf37af977e1(lhs - rhs, ORDER);
        },
        mul: function(lhs, rhs) {
            return $b3231a81ebc758c6$export$842a2cf37af977e1(lhs * rhs, ORDER);
        },
        pow: function(num, power) {
            return $b3231a81ebc758c6$export$5d8ce3717733a987(f, num, power);
        },
        div: function(lhs, rhs) {
            return $b3231a81ebc758c6$export$842a2cf37af977e1(lhs * $b3231a81ebc758c6$export$6897c284b6f9f4dc(rhs, ORDER), ORDER);
        },
        // Same as above, but doesn't normalize
        sqrN: function(num) {
            return num * num;
        },
        addN: function(lhs, rhs) {
            return lhs + rhs;
        },
        subN: function(lhs, rhs) {
            return lhs - rhs;
        },
        mulN: function(lhs, rhs) {
            return lhs * rhs;
        },
        inv: function(num) {
            return $b3231a81ebc758c6$export$6897c284b6f9f4dc(num, ORDER);
        },
        sqrt: redef.sqrt || function(n) {
            return sqrtP(f, n);
        },
        invertBatch: function(lst) {
            return $b3231a81ebc758c6$export$a492e3387142c0e9(f, lst);
        },
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: function(a, b, c) {
            return c ? b : a;
        },
        toBytes: function(num) {
            return isLE ? (0, $cOBbr.numberToBytesLE)(num, BYTES) : (0, $cOBbr.numberToBytesBE)(num, BYTES);
        },
        fromBytes: function(bytes) {
            if (bytes.length !== BYTES) throw new Error("Fp.fromBytes: expected ".concat(BYTES, ", got ").concat(bytes.length));
            return isLE ? (0, $cOBbr.bytesToNumberLE)(bytes) : (0, $cOBbr.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
function $b3231a81ebc758c6$export$7acc54692c525d2a(Fp, elm) {
    if (!Fp.isOdd) throw new Error("Field doesn't have isOdd");
    var root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
function $b3231a81ebc758c6$export$1d7b691df0888e02(Fp, elm) {
    if (!Fp.isOdd) throw new Error("Field doesn't have isOdd");
    var root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
function $b3231a81ebc758c6$export$d3b0e8260d5dbad4(hash, groupOrder) {
    var isLE = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    hash = (0, $cOBbr.ensureBytes)("privateHash", hash);
    var hashLen = hash.length;
    var minLen = $b3231a81ebc758c6$export$c79df43ecd7e66c2(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error("hashToPrivateScalar: expected ".concat(minLen, "-1024 bytes of input, got ").concat(hashLen));
    var num = isLE ? (0, $cOBbr.bytesToNumberLE)(hash) : (0, $cOBbr.bytesToNumberBE)(hash);
    return $b3231a81ebc758c6$export$842a2cf37af977e1(num, groupOrder - $b3231a81ebc758c6$var$_1n) + $b3231a81ebc758c6$var$_1n;
}
function $b3231a81ebc758c6$export$9cf21a9392b0fcfc(fieldOrder) {
    if ((typeof fieldOrder === "undefined" ? "undefined" : (0, $l0HdX._)(fieldOrder)) !== "bigint") throw new Error("field order must be bigint");
    var bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
function $b3231a81ebc758c6$export$d058763b563056af(fieldOrder) {
    var length = $b3231a81ebc758c6$export$9cf21a9392b0fcfc(fieldOrder);
    return length + Math.ceil(length / 2);
}
function $b3231a81ebc758c6$export$20cb21dbfa61dac3(key, fieldOrder) {
    var isLE = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var len = key.length;
    var fieldLen = $b3231a81ebc758c6$export$9cf21a9392b0fcfc(fieldOrder);
    var minLen = $b3231a81ebc758c6$export$d058763b563056af(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error("expected ".concat(minLen, "-1024 bytes of input, got ").concat(len));
    var num = isLE ? (0, $cOBbr.bytesToNumberBE)(key) : (0, $cOBbr.bytesToNumberLE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    var reduced = $b3231a81ebc758c6$export$842a2cf37af977e1(num, fieldOrder - $b3231a81ebc758c6$var$_1n) + $b3231a81ebc758c6$var$_1n;
    return isLE ? (0, $cOBbr.numberToBytesLE)(reduced, fieldLen) : (0, $cOBbr.numberToBytesBE)(reduced, fieldLen);
}

});
parcelRegister("cOBbr", function(module, exports) {

$parcel$export(module.exports, "isBytes", function () { return $9546ff71711ed276$export$c6fabfbfd097fc30; });
$parcel$export(module.exports, "abytes", function () { return $9546ff71711ed276$export$e8a750b9efad93f5; });
$parcel$export(module.exports, "abool", function () { return $9546ff71711ed276$export$809304d28d77d92d; });
$parcel$export(module.exports, "bytesToHex", function () { return $9546ff71711ed276$export$58b867e287a802c8; });
$parcel$export(module.exports, "numberToHexUnpadded", function () { return $9546ff71711ed276$export$4ed2545b622827c1; });
$parcel$export(module.exports, "hexToNumber", function () { return $9546ff71711ed276$export$d57f2bacc26b4249; });
$parcel$export(module.exports, "hexToBytes", function () { return $9546ff71711ed276$export$31c96b9df38bc8d4; });
$parcel$export(module.exports, "bytesToNumberBE", function () { return $9546ff71711ed276$export$d609354794974f8; });
$parcel$export(module.exports, "bytesToNumberLE", function () { return $9546ff71711ed276$export$d67b1d03392107e7; });
$parcel$export(module.exports, "numberToBytesBE", function () { return $9546ff71711ed276$export$1459dafd057611cb; });
$parcel$export(module.exports, "numberToBytesLE", function () { return $9546ff71711ed276$export$ba2172e58d139f6d; });
$parcel$export(module.exports, "numberToVarBytesBE", function () { return $9546ff71711ed276$export$80ee8c1914de6dde; });
$parcel$export(module.exports, "ensureBytes", function () { return $9546ff71711ed276$export$3cb5d50a3a30e837; });
$parcel$export(module.exports, "concatBytes", function () { return $9546ff71711ed276$export$287dd7971339c972; });
$parcel$export(module.exports, "equalBytes", function () { return $9546ff71711ed276$export$2aa59cef064b0333; });
$parcel$export(module.exports, "utf8ToBytes", function () { return $9546ff71711ed276$export$3df70a15530b5e81; });
$parcel$export(module.exports, "inRange", function () { return $9546ff71711ed276$export$ddf89a9c5af38f94; });
$parcel$export(module.exports, "aInRange", function () { return $9546ff71711ed276$export$86cc12b5dde3c1e4; });
$parcel$export(module.exports, "bitLen", function () { return $9546ff71711ed276$export$e93ef600c41761a9; });
$parcel$export(module.exports, "bitGet", function () { return $9546ff71711ed276$export$9577d112d1fd46ad; });
$parcel$export(module.exports, "bitSet", function () { return $9546ff71711ed276$export$967bb2b9787441cb; });
$parcel$export(module.exports, "bitMask", function () { return $9546ff71711ed276$export$803efa2fa1c7279; });
$parcel$export(module.exports, "createHmacDrbg", function () { return $9546ff71711ed276$export$d459d139192e4fba; });
$parcel$export(module.exports, "validateObject", function () { return $9546ff71711ed276$export$381bae2d0f08004f; });
$parcel$export(module.exports, "notImplemented", function () { return $9546ff71711ed276$export$94a5f06e658f87e2; });
$parcel$export(module.exports, "memoized", function () { return $9546ff71711ed276$export$9756366f7cb6f62b; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $l0HdX = parcelRequire("l0HdX");
var $9546ff71711ed276$var$_0n = /* @__PURE__ */ BigInt(0);
var $9546ff71711ed276$var$_1n = /* @__PURE__ */ BigInt(1);
var $9546ff71711ed276$var$_2n = /* @__PURE__ */ BigInt(2);
function $9546ff71711ed276$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
function $9546ff71711ed276$export$e8a750b9efad93f5(item) {
    if (!$9546ff71711ed276$export$c6fabfbfd097fc30(item)) throw new Error("Uint8Array expected");
}
function $9546ff71711ed276$export$809304d28d77d92d(title, value) {
    if (typeof value !== "boolean") throw new Error("".concat(title, ' must be valid boolean, got "').concat(value, '".'));
}
// Array where index 0xf0 (240) is mapped to string 'f0'
var $9546ff71711ed276$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, function(_, i) {
    return i.toString(16).padStart(2, "0");
});
function $9546ff71711ed276$export$58b867e287a802c8(bytes) {
    $9546ff71711ed276$export$e8a750b9efad93f5(bytes);
    // pre-caching improves the speed 6x
    var hex = "";
    for(var i = 0; i < bytes.length; i++)hex += $9546ff71711ed276$var$hexes[bytes[i]];
    return hex;
}
function $9546ff71711ed276$export$4ed2545b622827c1(num) {
    var hex = num.toString(16);
    return hex.length & 1 ? "0".concat(hex) : hex;
}
function $9546ff71711ed276$export$d57f2bacc26b4249(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + (typeof hex === "undefined" ? "undefined" : (0, $l0HdX._)(hex)));
    // Big Endian
    return BigInt(hex === "" ? "0" : "0x".concat(hex));
}
// We use optimized technique to convert hex string to byte array
var $9546ff71711ed276$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $9546ff71711ed276$var$asciiToBase16(char) {
    if (char >= $9546ff71711ed276$var$asciis._0 && char <= $9546ff71711ed276$var$asciis._9) return char - $9546ff71711ed276$var$asciis._0;
    if (char >= $9546ff71711ed276$var$asciis._A && char <= $9546ff71711ed276$var$asciis._F) return char - ($9546ff71711ed276$var$asciis._A - 10);
    if (char >= $9546ff71711ed276$var$asciis._a && char <= $9546ff71711ed276$var$asciis._f) return char - ($9546ff71711ed276$var$asciis._a - 10);
    return;
}
function $9546ff71711ed276$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + (typeof hex === "undefined" ? "undefined" : (0, $l0HdX._)(hex)));
    var hl = hex.length;
    var al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    var array = new Uint8Array(al);
    for(var ai = 0, hi = 0; ai < al; ai++, hi += 2){
        var n1 = $9546ff71711ed276$var$asciiToBase16(hex.charCodeAt(hi));
        var n2 = $9546ff71711ed276$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            var char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
function $9546ff71711ed276$export$d609354794974f8(bytes) {
    return $9546ff71711ed276$export$d57f2bacc26b4249($9546ff71711ed276$export$58b867e287a802c8(bytes));
}
function $9546ff71711ed276$export$d67b1d03392107e7(bytes) {
    $9546ff71711ed276$export$e8a750b9efad93f5(bytes);
    return $9546ff71711ed276$export$d57f2bacc26b4249($9546ff71711ed276$export$58b867e287a802c8(Uint8Array.from(bytes).reverse()));
}
function $9546ff71711ed276$export$1459dafd057611cb(n, len) {
    return $9546ff71711ed276$export$31c96b9df38bc8d4(n.toString(16).padStart(len * 2, "0"));
}
function $9546ff71711ed276$export$ba2172e58d139f6d(n, len) {
    return $9546ff71711ed276$export$1459dafd057611cb(n, len).reverse();
}
function $9546ff71711ed276$export$80ee8c1914de6dde(n) {
    return $9546ff71711ed276$export$31c96b9df38bc8d4($9546ff71711ed276$export$4ed2545b622827c1(n));
}
function $9546ff71711ed276$export$3cb5d50a3a30e837(title, hex, expectedLength) {
    var res;
    if (typeof hex === "string") try {
        res = $9546ff71711ed276$export$31c96b9df38bc8d4(hex);
    } catch (e) {
        throw new Error("".concat(title, ' must be valid hex string, got "').concat(hex, '". Cause: ').concat(e));
    }
    else if ($9546ff71711ed276$export$c6fabfbfd097fc30(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error("".concat(title, " must be hex string or Uint8Array"));
    var len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error("".concat(title, " expected ").concat(expectedLength, " bytes, got ").concat(len));
    return res;
}
function $9546ff71711ed276$export$287dd7971339c972() {
    for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++){
        arrays[_key] = arguments[_key];
    }
    var sum = 0;
    for(var i = 0; i < arrays.length; i++){
        var a = arrays[i];
        $9546ff71711ed276$export$e8a750b9efad93f5(a);
        sum += a.length;
    }
    var res = new Uint8Array(sum);
    for(var i1 = 0, pad = 0; i1 < arrays.length; i1++){
        var a1 = arrays[i1];
        res.set(a1, pad);
        pad += a1.length;
    }
    return res;
}
function $9546ff71711ed276$export$2aa59cef064b0333(a, b) {
    if (a.length !== b.length) return false;
    var diff = 0;
    for(var i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
function $9546ff71711ed276$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error("utf8ToBytes expected string, got ".concat(typeof str === "undefined" ? "undefined" : (0, $l0HdX._)(str)));
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
// Is positive bigint
var $9546ff71711ed276$var$isPosBig = function(n) {
    return (typeof n === "undefined" ? "undefined" : (0, $l0HdX._)(n)) === "bigint" && $9546ff71711ed276$var$_0n <= n;
};
function $9546ff71711ed276$export$ddf89a9c5af38f94(n, min, max) {
    return $9546ff71711ed276$var$isPosBig(n) && $9546ff71711ed276$var$isPosBig(min) && $9546ff71711ed276$var$isPosBig(max) && min <= n && n < max;
}
function $9546ff71711ed276$export$86cc12b5dde3c1e4(title, n, min, max) {
    // Why min <= n < max and not a (min < n < max) OR b (min <= n <= max)?
    // consider P=256n, min=0n, max=P
    // - a for min=0 would require -1:          `inRange('x', x, -1n, P)`
    // - b would commonly require subtraction:  `inRange('x', x, 0n, P - 1n)`
    // - our way is the cleanest:               `inRange('x', x, 0n, P)
    if (!$9546ff71711ed276$export$ddf89a9c5af38f94(n, min, max)) throw new Error("expected valid ".concat(title, ": ").concat(min, " <= n < ").concat(max, ", got ").concat(typeof n === "undefined" ? "undefined" : (0, $l0HdX._)(n), " ").concat(n));
}
function $9546ff71711ed276$export$e93ef600c41761a9(n) {
    var len;
    for(len = 0; n > $9546ff71711ed276$var$_0n; n >>= $9546ff71711ed276$var$_1n, len += 1);
    return len;
}
function $9546ff71711ed276$export$9577d112d1fd46ad(n, pos) {
    return n >> BigInt(pos) & $9546ff71711ed276$var$_1n;
}
function $9546ff71711ed276$export$967bb2b9787441cb(n, pos, value) {
    return n | (value ? $9546ff71711ed276$var$_1n : $9546ff71711ed276$var$_0n) << BigInt(pos);
}
var $9546ff71711ed276$export$803efa2fa1c7279 = function(n) {
    return ($9546ff71711ed276$var$_2n << BigInt(n - 1)) - $9546ff71711ed276$var$_1n;
};
// DRBG
var $9546ff71711ed276$var$u8n = function(data) {
    return new Uint8Array(data);
}; // creates Uint8Array
var $9546ff71711ed276$var$u8fr = function(arr) {
    return Uint8Array.from(arr);
}; // another shortcut
function $9546ff71711ed276$export$d459d139192e4fba(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    var v = $9546ff71711ed276$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    var k = $9546ff71711ed276$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    var i = 0; // Iterations counter, will throw when over 1000
    var reset = function() {
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    var h = function() {
        for(var _len = arguments.length, b = new Array(_len), _key = 0; _key < _len; _key++){
            b[_key] = arguments[_key];
        }
        return hmacFn.apply(void 0, [
            k,
            v
        ].concat((0, $c6Xmf._)(b)));
    }; // hmac(k)(v, ...values)
    var reseed = function() {
        var seed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $9546ff71711ed276$var$u8n();
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($9546ff71711ed276$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($9546ff71711ed276$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    var gen = function() {
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        var len = 0;
        var out = [];
        while(len < qByteLen){
            v = h();
            var sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $9546ff71711ed276$export$287dd7971339c972.apply(void 0, (0, $c6Xmf._)(out));
    };
    var genUntil = function(seed, pred) {
        reset();
        reseed(seed); // Steps D-G
        var res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
// Validating curves and fields
var $9546ff71711ed276$var$validatorFns = {
    bigint: function(val) {
        return (typeof val === "undefined" ? "undefined" : (0, $l0HdX._)(val)) === "bigint";
    },
    function: function(val) {
        return typeof val === "function";
    },
    boolean: function(val) {
        return typeof val === "boolean";
    },
    string: function(val) {
        return typeof val === "string";
    },
    stringOrUint8Array: function(val) {
        return typeof val === "string" || $9546ff71711ed276$export$c6fabfbfd097fc30(val);
    },
    isSafeInteger: function(val) {
        return Number.isSafeInteger(val);
    },
    array: function(val) {
        return Array.isArray(val);
    },
    field: function(val, object) {
        return object.Fp.isValid(val);
    },
    hash: function(val) {
        return typeof val === "function" && Number.isSafeInteger(val.outputLen);
    }
};
function $9546ff71711ed276$export$381bae2d0f08004f(object, validators) {
    var optValidators = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var checkField = function(fieldName, type, isOptional) {
        var checkVal = $9546ff71711ed276$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error('Invalid validator "'.concat(type, '", expected function'));
        var val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error("Invalid param ".concat(String(fieldName), "=").concat(val, " (").concat(typeof val === "undefined" ? "undefined" : (0, $l0HdX._)(val), "), expected ").concat(type));
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(validators)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $cv9Rk._)(_step.value, 2), fieldName = _step_value[0], type = _step_value[1];
            checkField(fieldName, type, false);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = Object.entries(optValidators)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var _step_value1 = (0, $cv9Rk._)(_step1.value, 2), fieldName1 = _step_value1[0], type1 = _step_value1[1];
            checkField(fieldName1, type1, true);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return object;
}
var $9546ff71711ed276$export$94a5f06e658f87e2 = function() {
    throw new Error("not implemented");
};
function $9546ff71711ed276$export$9756366f7cb6f62b(fn) {
    var map = new WeakMap();
    return function(arg) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var val = map.get(arg);
        if (val !== undefined) return val;
        var computed = fn.apply(void 0, [
            arg
        ].concat((0, $c6Xmf._)(args)));
        map.set(arg, computed);
        return computed;
    };
}

});




parcelRegister("llE38", function(module, exports) {

$parcel$export(module.exports, "expand_message_xmd", function () { return $f8aaa0270e542eaf$export$3df78c69af9fc85d; });
$parcel$export(module.exports, "isogenyMap", function () { return $f8aaa0270e542eaf$export$9393380cf1075f28; });
$parcel$export(module.exports, "createHasher", function () { return $f8aaa0270e542eaf$export$14b114effbc08b6b; });

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $l0HdX = parcelRequire("l0HdX");

var $fnxE9 = parcelRequire("fnxE9");

var $cOBbr = parcelRequire("cOBbr");
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
var $f8aaa0270e542eaf$var$os2ip = (0, $cOBbr.bytesToNumberBE);
// Integer to Octet Stream (numberToBytesBE)
function $f8aaa0270e542eaf$var$i2osp(value, length) {
    if (value < 0 || value >= 1 << 8 * length) throw new Error("bad I2OSP call: value=".concat(value, " length=").concat(length));
    var res = Array.from({
        length: length
    }).fill(0);
    for(var i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $f8aaa0270e542eaf$var$strxor(a, b) {
    var arr = new Uint8Array(a.length);
    for(var i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $f8aaa0270e542eaf$var$anum(item) {
    if (!Number.isSafeInteger(item)) throw new Error("number expected");
}
function $f8aaa0270e542eaf$export$3df78c69af9fc85d(msg, DST, lenInBytes, H) {
    (0, $cOBbr.abytes)(msg);
    (0, $cOBbr.abytes)(DST);
    $f8aaa0270e542eaf$var$anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $cOBbr.concatBytes)((0, $cOBbr.utf8ToBytes)("H2C-OVERSIZE-DST-"), DST));
    var b_in_bytes = H.outputLen, r_in_bytes = H.blockLen;
    var ell = Math.ceil(lenInBytes / b_in_bytes);
    if (ell > 255) throw new Error("Invalid xmd length");
    var DST_prime = (0, $cOBbr.concatBytes)(DST, $f8aaa0270e542eaf$var$i2osp(DST.length, 1));
    var Z_pad = $f8aaa0270e542eaf$var$i2osp(0, r_in_bytes);
    var l_i_b_str = $f8aaa0270e542eaf$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    var b = new Array(ell);
    var b_0 = H((0, $cOBbr.concatBytes)(Z_pad, msg, l_i_b_str, $f8aaa0270e542eaf$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $cOBbr.concatBytes)(b_0, $f8aaa0270e542eaf$var$i2osp(1, 1), DST_prime));
    for(var i = 1; i <= ell; i++){
        var args = [
            $f8aaa0270e542eaf$var$strxor(b_0, b[i - 1]),
            $f8aaa0270e542eaf$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $cOBbr.concatBytes).apply(void 0, (0, $c6Xmf._)(args)));
    }
    var pseudo_random_bytes = (0, $cOBbr.concatBytes).apply(void 0, (0, $c6Xmf._)(b));
    return pseudo_random_bytes.slice(0, lenInBytes);
}
function $f8aaa0270e542eaf$export$3f56d6fdbf95d07c(msg, DST, lenInBytes, k, H) {
    (0, $cOBbr.abytes)(msg);
    (0, $cOBbr.abytes)(DST);
    $f8aaa0270e542eaf$var$anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        var dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $cOBbr.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($f8aaa0270e542eaf$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($f8aaa0270e542eaf$var$i2osp(DST.length, 1)).digest();
}
function $f8aaa0270e542eaf$export$97cdd5ee18de8172(msg, count, options) {
    (0, $cOBbr.validateObject)(options, {
        DST: "stringOrUint8Array",
        p: "bigint",
        m: "isSafeInteger",
        k: "isSafeInteger",
        hash: "hash"
    });
    var p = options.p, k = options.k, m = options.m, hash = options.hash, expand = options.expand, _DST = options.DST;
    (0, $cOBbr.abytes)(msg);
    $f8aaa0270e542eaf$var$anum(count);
    var DST = typeof _DST === "string" ? (0, $cOBbr.utf8ToBytes)(_DST) : _DST;
    var log2p = p.toString(2).length;
    var L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    var len_in_bytes = count * m * L;
    var prb; // pseudo_random_bytes
    if (expand === "xmd") prb = $f8aaa0270e542eaf$export$3df78c69af9fc85d(msg, DST, len_in_bytes, hash);
    else if (expand === "xof") prb = $f8aaa0270e542eaf$export$3f56d6fdbf95d07c(msg, DST, len_in_bytes, k, hash);
    else if (expand === "_internal_pass") // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    var u = new Array(count);
    for(var i = 0; i < count; i++){
        var e = new Array(m);
        for(var j = 0; j < m; j++){
            var elm_offset = L * (j + i * m);
            var tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $fnxE9.mod)($f8aaa0270e542eaf$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
function $f8aaa0270e542eaf$export$9393380cf1075f28(field, map) {
    // Make same order as in spec
    var COEFF = map.map(function(i) {
        return Array.from(i).reverse();
    });
    return function(x, y) {
        var _COEFF_map = (0, $cv9Rk._)(COEFF.map(function(val) {
            return val.reduce(function(acc, i) {
                return field.add(field.mul(acc, x), i);
            });
        }), 4), xNum = _COEFF_map[0], xDen = _COEFF_map[1], yNum = _COEFF_map[2], yDen = _COEFF_map[3];
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
function $f8aaa0270e542eaf$export$14b114effbc08b6b(Point, mapToCurve, def) {
    if (typeof mapToCurve !== "function") throw new Error("mapToCurve() must be defined");
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve: function(msg, options) {
            var u = $f8aaa0270e542eaf$export$97cdd5ee18de8172(msg, 2, (0, $do9pw._)((0, $cxjpp._)((0, $do9pw._)({}, def), {
                DST: def.DST
            }), options));
            var u0 = Point.fromAffine(mapToCurve(u[0]));
            var u1 = Point.fromAffine(mapToCurve(u[1]));
            var P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve: function(msg, options) {
            var u = $f8aaa0270e542eaf$export$97cdd5ee18de8172(msg, 1, (0, $do9pw._)((0, $cxjpp._)((0, $do9pw._)({}, def), {
                DST: def.encodeDST
            }), options));
            var P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Same as encodeToCurve, but without hash
        mapToCurve: function(scalars) {
            if (!Array.isArray(scalars)) throw new Error("mapToCurve: expected array of bigints");
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = scalars[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var i = _step.value;
                    if ((typeof i === "undefined" ? "undefined" : (0, $l0HdX._)(i)) !== "bigint") throw new Error("mapToCurve: expected array of bigints, got ".concat(i, " in array"));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var P = Point.fromAffine(mapToCurve(scalars)).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}

});

parcelRegister("299Vm", function(module, exports) {

$parcel$export(module.exports, "montgomery", function () { return $19041ec5b8e8a8e2$export$bdbee0d01bf914a7; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $do9pw = parcelRequire("do9pw");

var $fnxE9 = parcelRequire("fnxE9");

var $cOBbr = parcelRequire("cOBbr");
var $19041ec5b8e8a8e2$var$_0n = BigInt(0);
var $19041ec5b8e8a8e2$var$_1n = BigInt(1);
function $19041ec5b8e8a8e2$var$validateOpts(curve) {
    (0, $cOBbr.validateObject)(curve, {
        a: "bigint"
    }, {
        montgomeryBits: "isSafeInteger",
        nByteLength: "isSafeInteger",
        adjustScalarBytes: "function",
        domain: "function",
        powPminus2: "function",
        Gu: "bigint"
    });
    // Set defaults
    return Object.freeze((0, $do9pw._)({}, curve));
}
function $19041ec5b8e8a8e2$export$bdbee0d01bf914a7(curveDef) {
    var CURVE = $19041ec5b8e8a8e2$var$validateOpts(curveDef);
    var P = CURVE.P;
    var modP = function(n) {
        return (0, $fnxE9.mod)(n, P);
    };
    var montgomeryBits = CURVE.montgomeryBits;
    var montgomeryBytes = Math.ceil(montgomeryBits / 8);
    var fieldLen = CURVE.nByteLength;
    var adjustScalarBytes = CURVE.adjustScalarBytes || function(bytes) {
        return bytes;
    };
    var powPminus2 = CURVE.powPminus2 || function(x) {
        return (0, $fnxE9.pow)(x, P - BigInt(2), P);
    };
    // cswap from RFC7748. But it is not from RFC7748!
    /*
      cswap(swap, x_2, x_3):
           dummy = mask(swap) AND (x_2 XOR x_3)
           x_2 = x_2 XOR dummy
           x_3 = x_3 XOR dummy
           Return (x_2, x_3)
    Where mask(swap) is the all-1 or all-0 word of the same length as x_2
     and x_3, computed, e.g., as mask(swap) = 0 - swap.
    */ function cswap(swap, x_2, x_3) {
        var dummy = modP(swap * (x_2 - x_3));
        x_2 = modP(x_2 - dummy);
        x_3 = modP(x_3 + dummy);
        return [
            x_2,
            x_3
        ];
    }
    // x25519 from 4
    // The constant a24 is (486662 - 2) / 4 = 121665 for curve25519/X25519
    var a24 = (CURVE.a - BigInt(2)) / BigInt(4);
    /**
     *
     * @param pointU u coordinate (x) on Montgomery Curve 25519
     * @param scalar by which the point would be multiplied
     * @returns new Point on Montgomery curve
     */ function montgomeryLadder(u, scalar) {
        (0, $cOBbr.aInRange)("u", u, $19041ec5b8e8a8e2$var$_0n, P);
        (0, $cOBbr.aInRange)("scalar", scalar, $19041ec5b8e8a8e2$var$_0n, P);
        // Section 5: Implementations MUST accept non-canonical values and process them as
        // if they had been reduced modulo the field prime.
        var k = scalar;
        var x_1 = u;
        var x_2 = $19041ec5b8e8a8e2$var$_1n;
        var z_2 = $19041ec5b8e8a8e2$var$_0n;
        var x_3 = u;
        var z_3 = $19041ec5b8e8a8e2$var$_1n;
        var swap = $19041ec5b8e8a8e2$var$_0n;
        var sw;
        for(var t = BigInt(montgomeryBits - 1); t >= $19041ec5b8e8a8e2$var$_0n; t--){
            var k_t = k >> t & $19041ec5b8e8a8e2$var$_1n;
            swap ^= k_t;
            sw = cswap(swap, x_2, x_3);
            x_2 = sw[0];
            x_3 = sw[1];
            sw = cswap(swap, z_2, z_3);
            z_2 = sw[0];
            z_3 = sw[1];
            swap = k_t;
            var A = x_2 + z_2;
            var AA = modP(A * A);
            var B = x_2 - z_2;
            var BB = modP(B * B);
            var E = AA - BB;
            var C = x_3 + z_3;
            var D = x_3 - z_3;
            var DA = modP(D * A);
            var CB = modP(C * B);
            var dacb = DA + CB;
            var da_cb = DA - CB;
            x_3 = modP(dacb * dacb);
            z_3 = modP(x_1 * modP(da_cb * da_cb));
            x_2 = modP(AA * BB);
            z_2 = modP(E * (AA + modP(a24 * E)));
        }
        // (x_2, x_3) = cswap(swap, x_2, x_3)
        sw = cswap(swap, x_2, x_3);
        x_2 = sw[0];
        x_3 = sw[1];
        // (z_2, z_3) = cswap(swap, z_2, z_3)
        sw = cswap(swap, z_2, z_3);
        z_2 = sw[0];
        z_3 = sw[1];
        // z_2^(p - 2)
        var z2 = powPminus2(z_2);
        // Return x_2 * (z_2^(p - 2))
        return modP(x_2 * z2);
    }
    function encodeUCoordinate(u) {
        return (0, $cOBbr.numberToBytesLE)(modP(u), montgomeryBytes);
    }
    function decodeUCoordinate(uEnc) {
        // Section 5: When receiving such an array, implementations of X25519
        // MUST mask the most significant bit in the final byte.
        var u = (0, $cOBbr.ensureBytes)("u coordinate", uEnc, montgomeryBytes);
        if (fieldLen === 32) u[31] &= 127; // 0b0111_1111
        return (0, $cOBbr.bytesToNumberLE)(u);
    }
    function decodeScalar(n) {
        var bytes = (0, $cOBbr.ensureBytes)("scalar", n);
        var len = bytes.length;
        if (len !== montgomeryBytes && len !== fieldLen) throw new Error("Expected ".concat(montgomeryBytes, " or ").concat(fieldLen, " bytes, got ").concat(len));
        return (0, $cOBbr.bytesToNumberLE)(adjustScalarBytes(bytes));
    }
    function scalarMult(scalar, u) {
        var pointU = decodeUCoordinate(u);
        var _scalar = decodeScalar(scalar);
        var pu = montgomeryLadder(pointU, _scalar);
        // The result was not contributory
        // https://cr.yp.to/ecdh.html#validate
        if (pu === $19041ec5b8e8a8e2$var$_0n) throw new Error("Invalid private or public key received");
        return encodeUCoordinate(pu);
    }
    // Computes public key from private. By doing scalar multiplication of base point.
    var GuBytes = encodeUCoordinate(CURVE.Gu);
    function scalarMultBase(scalar) {
        return scalarMult(scalar, GuBytes);
    }
    return {
        scalarMult: scalarMult,
        scalarMultBase: scalarMultBase,
        getSharedSecret: function(privateKey, publicKey) {
            return scalarMult(privateKey, publicKey);
        },
        getPublicKey: function(privateKey) {
            return scalarMultBase(privateKey);
        },
        utils: {
            randomPrivateKey: function() {
                return CURVE.randomBytes(CURVE.nByteLength);
            }
        },
        GuBytes: GuBytes
    };
}

});


parcelRegister("blRDm", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("9dH9K")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("h0PUv", function(module, exports) {

var $1ISpw = parcelRequire("1ISpw");
var $c62ab416b9733010$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
module.exports = $1ISpw($c62ab416b9733010$var$ALPHABET);

});
parcelRegister("1ISpw", function(module, exports) {
"use strict";

var $f6JDE = parcelRequire("f6JDE");
var $14141b55f5c3b6b1$require$_Buffer = $f6JDE.Buffer;
function $14141b55f5c3b6b1$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (Array.isArray(source) || source instanceof Uint8Array) source = $14141b55f5c3b6b1$require$_Buffer.from(source);
        if (!$14141b55f5c3b6b1$require$_Buffer.isBuffer(source)) throw new TypeError("Expected Buffer");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return $14141b55f5c3b6b1$require$_Buffer.alloc(0);
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(psz < source.length){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = $14141b55f5c3b6b1$require$_Buffer.allocUnsafe(zeroes + (size - it4));
        vch.fill(0x00, 0, zeroes);
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
module.exports = $14141b55f5c3b6b1$var$base;

});
parcelRegister("f6JDE", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $8dlmd = parcelRequire("8dlmd");
var $affad16faad56d13$var$Buffer = $8dlmd.Buffer;
// alternative to using Object.keys for old browsers
function $affad16faad56d13$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($affad16faad56d13$var$Buffer.from && $affad16faad56d13$var$Buffer.alloc && $affad16faad56d13$var$Buffer.allocUnsafe && $affad16faad56d13$var$Buffer.allocUnsafeSlow) module.exports = $8dlmd;
else {
    // Copy properties from require('buffer')
    $affad16faad56d13$var$copyProps($8dlmd, module.exports);
    module.exports.Buffer = $affad16faad56d13$var$SafeBuffer;
}
function $affad16faad56d13$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $affad16faad56d13$var$Buffer(arg, encodingOrOffset, length);
}
$affad16faad56d13$var$SafeBuffer.prototype = Object.create($affad16faad56d13$var$Buffer.prototype);
// Copy static methods from Buffer
$affad16faad56d13$var$copyProps($affad16faad56d13$var$Buffer, $affad16faad56d13$var$SafeBuffer);
$affad16faad56d13$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $affad16faad56d13$var$Buffer(arg, encodingOrOffset, length);
};
$affad16faad56d13$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $affad16faad56d13$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$affad16faad56d13$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $affad16faad56d13$var$Buffer(size);
};
$affad16faad56d13$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $8dlmd.SlowBuffer(size);
};

});



parcelRegister("1jbTD", function(module, exports) {

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $3sHb8 = parcelRequire("3sHb8");

var $dcsZi = parcelRequire("dcsZi");

var $cv9Rk = parcelRequire("cv9Rk");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");

var $8dlmd = parcelRequire("8dlmd");
var $0f40cb253fadb90e$require$Buffer = $8dlmd.Buffer;
"use strict";
var $0f40cb253fadb90e$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0f40cb253fadb90e$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $0f40cb253fadb90e$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $0f40cb253fadb90e$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $0f40cb253fadb90e$var$__createBinding(result, mod, k);
    }
    $0f40cb253fadb90e$var$__setModuleDefault(result, mod);
    return result;
};
var $0f40cb253fadb90e$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.deserializeUnchecked = module.exports.deserialize = module.exports.serialize = module.exports.BinaryReader = module.exports.BinaryWriter = module.exports.BorshError = module.exports.baseDecode = module.exports.baseEncode = void 0;

var $0f40cb253fadb90e$var$bn_js_1 = $0f40cb253fadb90e$var$__importDefault((parcelRequire("blRDm")));

var $0f40cb253fadb90e$var$bs58_1 = $0f40cb253fadb90e$var$__importDefault((parcelRequire("7muUi")));

// TODO: Make sure this polyfill not included when not required
var $0f40cb253fadb90e$var$encoding = $0f40cb253fadb90e$var$__importStar((parcelRequire("8Ij4F")));
var $0f40cb253fadb90e$var$ResolvedTextDecoder = typeof TextDecoder !== "function" ? $0f40cb253fadb90e$var$encoding.TextDecoder : TextDecoder;
var $0f40cb253fadb90e$var$textDecoder = new $0f40cb253fadb90e$var$ResolvedTextDecoder("utf-8", {
    fatal: true
});
function $0f40cb253fadb90e$var$baseEncode(value) {
    if (typeof value === "string") value = $0f40cb253fadb90e$require$Buffer.from(value, "utf8");
    return $0f40cb253fadb90e$var$bs58_1.default.encode($0f40cb253fadb90e$require$Buffer.from(value));
}
module.exports.baseEncode = $0f40cb253fadb90e$var$baseEncode;
function $0f40cb253fadb90e$var$baseDecode(value) {
    return $0f40cb253fadb90e$require$Buffer.from($0f40cb253fadb90e$var$bs58_1.default.decode(value));
}
module.exports.baseDecode = $0f40cb253fadb90e$var$baseDecode;
var $0f40cb253fadb90e$var$INITIAL_LENGTH = 1024;
var $0f40cb253fadb90e$var$BorshError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $dcsZi._)(BorshError, Error1);
    var _super = (0, $ohfOJ._)(BorshError);
    function BorshError(message) {
        (0, $4GJKx._)(this, BorshError);
        var _this;
        _this = _super.call(this, message);
        _this.fieldPath = [];
        _this.originalMessage = message;
        return _this;
    }
    (0, $1wc17._)(BorshError, [
        {
            key: "addToFieldPath",
            value: function addToFieldPath(fieldName) {
                this.fieldPath.splice(0, 0, fieldName);
                // NOTE: Modifying message directly as jest doesn't use .toString()
                this.message = this.originalMessage + ": " + this.fieldPath.join(".");
            }
        }
    ]);
    return BorshError;
}((0, $FuVm8._)(Error));
module.exports.BorshError = $0f40cb253fadb90e$var$BorshError;
/// Binary encoder.
var $0f40cb253fadb90e$var$BinaryWriter = /*#__PURE__*/ function() {
    "use strict";
    function BinaryWriter() {
        (0, $4GJKx._)(this, BinaryWriter);
        this.buf = $0f40cb253fadb90e$require$Buffer.alloc($0f40cb253fadb90e$var$INITIAL_LENGTH);
        this.length = 0;
    }
    (0, $1wc17._)(BinaryWriter, [
        {
            key: "maybeResize",
            value: function maybeResize() {
                if (this.buf.length < 16 + this.length) this.buf = $0f40cb253fadb90e$require$Buffer.concat([
                    this.buf,
                    $0f40cb253fadb90e$require$Buffer.alloc($0f40cb253fadb90e$var$INITIAL_LENGTH)
                ]);
            }
        },
        {
            key: "writeU8",
            value: function writeU8(value) {
                this.maybeResize();
                this.buf.writeUInt8(value, this.length);
                this.length += 1;
            }
        },
        {
            key: "writeU16",
            value: function writeU16(value) {
                this.maybeResize();
                this.buf.writeUInt16LE(value, this.length);
                this.length += 2;
            }
        },
        {
            key: "writeU32",
            value: function writeU32(value) {
                this.maybeResize();
                this.buf.writeUInt32LE(value, this.length);
                this.length += 4;
            }
        },
        {
            key: "writeU64",
            value: function writeU64(value) {
                this.maybeResize();
                this.writeBuffer($0f40cb253fadb90e$require$Buffer.from(new $0f40cb253fadb90e$var$bn_js_1.default(value).toArray("le", 8)));
            }
        },
        {
            key: "writeU128",
            value: function writeU128(value) {
                this.maybeResize();
                this.writeBuffer($0f40cb253fadb90e$require$Buffer.from(new $0f40cb253fadb90e$var$bn_js_1.default(value).toArray("le", 16)));
            }
        },
        {
            key: "writeU256",
            value: function writeU256(value) {
                this.maybeResize();
                this.writeBuffer($0f40cb253fadb90e$require$Buffer.from(new $0f40cb253fadb90e$var$bn_js_1.default(value).toArray("le", 32)));
            }
        },
        {
            key: "writeU512",
            value: function writeU512(value) {
                this.maybeResize();
                this.writeBuffer($0f40cb253fadb90e$require$Buffer.from(new $0f40cb253fadb90e$var$bn_js_1.default(value).toArray("le", 64)));
            }
        },
        {
            key: "writeBuffer",
            value: function writeBuffer(buffer) {
                // Buffer.from is needed as this.buf.subarray can return plain Uint8Array in browser
                this.buf = $0f40cb253fadb90e$require$Buffer.concat([
                    $0f40cb253fadb90e$require$Buffer.from(this.buf.subarray(0, this.length)),
                    buffer,
                    $0f40cb253fadb90e$require$Buffer.alloc($0f40cb253fadb90e$var$INITIAL_LENGTH)
                ]);
                this.length += buffer.length;
            }
        },
        {
            key: "writeString",
            value: function writeString(str) {
                this.maybeResize();
                var b = $0f40cb253fadb90e$require$Buffer.from(str, "utf8");
                this.writeU32(b.length);
                this.writeBuffer(b);
            }
        },
        {
            key: "writeFixedArray",
            value: function writeFixedArray(array) {
                this.writeBuffer($0f40cb253fadb90e$require$Buffer.from(array));
            }
        },
        {
            key: "writeArray",
            value: function writeArray(array, fn) {
                this.maybeResize();
                this.writeU32(array.length);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = array[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var elem = _step.value;
                        this.maybeResize();
                        fn(elem);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                return this.buf.subarray(0, this.length);
            }
        }
    ]);
    return BinaryWriter;
}();
module.exports.BinaryWriter = $0f40cb253fadb90e$var$BinaryWriter;
function $0f40cb253fadb90e$var$handlingRangeError(target, propertyKey, propertyDescriptor) {
    var originalMethod = propertyDescriptor.value;
    propertyDescriptor.value = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        try {
            return originalMethod.apply(this, args);
        } catch (e) {
            if (e instanceof RangeError) {
                var code = e.code;
                if ([
                    "ERR_BUFFER_OUT_OF_BOUNDS",
                    "ERR_OUT_OF_RANGE"
                ].indexOf(code) >= 0) throw new $0f40cb253fadb90e$var$BorshError("Reached the end of buffer when deserializing");
            }
            throw e;
        }
    };
}
var $0f40cb253fadb90e$var$BinaryReader = /*#__PURE__*/ function() {
    "use strict";
    function BinaryReader(buf) {
        (0, $4GJKx._)(this, BinaryReader);
        this.buf = buf;
        this.offset = 0;
    }
    (0, $1wc17._)(BinaryReader, [
        {
            key: "readU8",
            value: function readU8() {
                var value = this.buf.readUInt8(this.offset);
                this.offset += 1;
                return value;
            }
        },
        {
            key: "readU16",
            value: function readU16() {
                var value = this.buf.readUInt16LE(this.offset);
                this.offset += 2;
                return value;
            }
        },
        {
            key: "readU32",
            value: function readU32() {
                var value = this.buf.readUInt32LE(this.offset);
                this.offset += 4;
                return value;
            }
        },
        {
            key: "readU64",
            value: function readU64() {
                var buf = this.readBuffer(8);
                return new $0f40cb253fadb90e$var$bn_js_1.default(buf, "le");
            }
        },
        {
            key: "readU128",
            value: function readU128() {
                var buf = this.readBuffer(16);
                return new $0f40cb253fadb90e$var$bn_js_1.default(buf, "le");
            }
        },
        {
            key: "readU256",
            value: function readU256() {
                var buf = this.readBuffer(32);
                return new $0f40cb253fadb90e$var$bn_js_1.default(buf, "le");
            }
        },
        {
            key: "readU512",
            value: function readU512() {
                var buf = this.readBuffer(64);
                return new $0f40cb253fadb90e$var$bn_js_1.default(buf, "le");
            }
        },
        {
            key: "readBuffer",
            value: function readBuffer(len) {
                if (this.offset + len > this.buf.length) throw new $0f40cb253fadb90e$var$BorshError("Expected buffer length ".concat(len, " isn't within bounds"));
                var result = this.buf.slice(this.offset, this.offset + len);
                this.offset += len;
                return result;
            }
        },
        {
            key: "readString",
            value: function readString() {
                var len = this.readU32();
                var buf = this.readBuffer(len);
                try {
                    // NOTE: Using TextDecoder to fail on invalid UTF-8
                    return $0f40cb253fadb90e$var$textDecoder.decode(buf);
                } catch (e) {
                    throw new $0f40cb253fadb90e$var$BorshError("Error decoding UTF-8 string: ".concat(e));
                }
            }
        },
        {
            key: "readFixedArray",
            value: function readFixedArray(len) {
                return new Uint8Array(this.readBuffer(len));
            }
        },
        {
            key: "readArray",
            value: function readArray(fn) {
                var len = this.readU32();
                var result = Array();
                for(var i = 0; i < len; ++i)result.push(fn());
                return result;
            }
        }
    ]);
    return BinaryReader;
}();
$0f40cb253fadb90e$var$__decorate([
    $0f40cb253fadb90e$var$handlingRangeError
], $0f40cb253fadb90e$var$BinaryReader.prototype, "readU8", null);
$0f40cb253fadb90e$var$__decorate([
    $0f40cb253fadb90e$var$handlingRangeError
], $0f40cb253fadb90e$var$BinaryReader.prototype, "readU16", null);
$0f40cb253fadb90e$var$__decorate([
    $0f40cb253fadb90e$var$handlingRangeError
], $0f40cb253fadb90e$var$BinaryReader.prototype, "readU32", null);
$0f40cb253fadb90e$var$__decorate([
    $0f40cb253fadb90e$var$handlingRangeError
], $0f40cb253fadb90e$var$BinaryReader.prototype, "readU64", null);
$0f40cb253fadb90e$var$__decorate([
    $0f40cb253fadb90e$var$handlingRangeError
], $0f40cb253fadb90e$var$BinaryReader.prototype, "readU128", null);
$0f40cb253fadb90e$var$__decorate([
    $0f40cb253fadb90e$var$handlingRangeError
], $0f40cb253fadb90e$var$BinaryReader.prototype, "readU256", null);
$0f40cb253fadb90e$var$__decorate([
    $0f40cb253fadb90e$var$handlingRangeError
], $0f40cb253fadb90e$var$BinaryReader.prototype, "readU512", null);
$0f40cb253fadb90e$var$__decorate([
    $0f40cb253fadb90e$var$handlingRangeError
], $0f40cb253fadb90e$var$BinaryReader.prototype, "readString", null);
$0f40cb253fadb90e$var$__decorate([
    $0f40cb253fadb90e$var$handlingRangeError
], $0f40cb253fadb90e$var$BinaryReader.prototype, "readFixedArray", null);
$0f40cb253fadb90e$var$__decorate([
    $0f40cb253fadb90e$var$handlingRangeError
], $0f40cb253fadb90e$var$BinaryReader.prototype, "readArray", null);
module.exports.BinaryReader = $0f40cb253fadb90e$var$BinaryReader;
function $0f40cb253fadb90e$var$capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
function $0f40cb253fadb90e$var$serializeField(schema, fieldName, value, fieldType, writer) {
    try {
        // TODO: Handle missing values properly (make sure they never result in just skipped write)
        if (typeof fieldType === "string") writer["write".concat($0f40cb253fadb90e$var$capitalizeFirstLetter(fieldType))](value);
        else if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") {
                if (value.length !== fieldType[0]) throw new $0f40cb253fadb90e$var$BorshError("Expecting byte array of length ".concat(fieldType[0], ", but got ").concat(value.length, " bytes"));
                writer.writeFixedArray(value);
            } else if (fieldType.length === 2 && typeof fieldType[1] === "number") {
                if (value.length !== fieldType[1]) throw new $0f40cb253fadb90e$var$BorshError("Expecting byte array of length ".concat(fieldType[1], ", but got ").concat(value.length, " bytes"));
                for(var i = 0; i < fieldType[1]; i++)$0f40cb253fadb90e$var$serializeField(schema, null, value[i], fieldType[0], writer);
            } else writer.writeArray(value, function(item) {
                $0f40cb253fadb90e$var$serializeField(schema, fieldName, item, fieldType[0], writer);
            });
        } else if (fieldType.kind !== undefined) switch(fieldType.kind){
            case "option":
                if (value === null || value === undefined) writer.writeU8(0);
                else {
                    writer.writeU8(1);
                    $0f40cb253fadb90e$var$serializeField(schema, fieldName, value, fieldType.type, writer);
                }
                break;
            case "map":
                writer.writeU32(value.size);
                value.forEach(function(val, key) {
                    $0f40cb253fadb90e$var$serializeField(schema, fieldName, key, fieldType.key, writer);
                    $0f40cb253fadb90e$var$serializeField(schema, fieldName, val, fieldType.value, writer);
                });
                break;
            default:
                throw new $0f40cb253fadb90e$var$BorshError("FieldType ".concat(fieldType, " unrecognized"));
        }
        else $0f40cb253fadb90e$var$serializeStruct(schema, value, writer);
    } catch (error) {
        if (error instanceof $0f40cb253fadb90e$var$BorshError) error.addToFieldPath(fieldName);
        throw error;
    }
}
function $0f40cb253fadb90e$var$serializeStruct(schema, obj, writer) {
    if (typeof obj.borshSerialize === "function") {
        obj.borshSerialize(writer);
        return;
    }
    var structSchema = schema.get(obj.constructor);
    if (!structSchema) throw new $0f40cb253fadb90e$var$BorshError("Class ".concat(obj.constructor.name, " is missing in schema"));
    if (structSchema.kind === "struct") structSchema.fields.map(function(param) {
        var _param = (0, $cv9Rk._)(param, 2), fieldName = _param[0], fieldType = _param[1];
        $0f40cb253fadb90e$var$serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
    });
    else if (structSchema.kind === "enum") {
        var name = obj[structSchema.field];
        for(var idx = 0; idx < structSchema.values.length; ++idx){
            var _structSchema_values_idx = (0, $cv9Rk._)(structSchema.values[idx], 2), fieldName = _structSchema_values_idx[0], fieldType = _structSchema_values_idx[1];
            if (fieldName === name) {
                writer.writeU8(idx);
                $0f40cb253fadb90e$var$serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
                break;
            }
        }
    } else throw new $0f40cb253fadb90e$var$BorshError("Unexpected schema kind: ".concat(structSchema.kind, " for ").concat(obj.constructor.name));
}
/// Serialize given object using schema of the form:
/// { class_name -> [ [field_name, field_type], .. ], .. }
function $0f40cb253fadb90e$var$serialize(schema, obj) {
    var Writer = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $0f40cb253fadb90e$var$BinaryWriter;
    var writer = new Writer();
    $0f40cb253fadb90e$var$serializeStruct(schema, obj, writer);
    return writer.toArray();
}
module.exports.serialize = $0f40cb253fadb90e$var$serialize;
function $0f40cb253fadb90e$var$deserializeField(schema, fieldName, fieldType, reader) {
    try {
        if (typeof fieldType === "string") return reader["read".concat($0f40cb253fadb90e$var$capitalizeFirstLetter(fieldType))]();
        if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") return reader.readFixedArray(fieldType[0]);
            else if (typeof fieldType[1] === "number") {
                var arr = [];
                for(var i = 0; i < fieldType[1]; i++)arr.push($0f40cb253fadb90e$var$deserializeField(schema, null, fieldType[0], reader));
                return arr;
            } else return reader.readArray(function() {
                return $0f40cb253fadb90e$var$deserializeField(schema, fieldName, fieldType[0], reader);
            });
        }
        if (fieldType.kind === "option") {
            var option = reader.readU8();
            if (option) return $0f40cb253fadb90e$var$deserializeField(schema, fieldName, fieldType.type, reader);
            return undefined;
        }
        if (fieldType.kind === "map") {
            var map = new Map();
            var length = reader.readU32();
            for(var i1 = 0; i1 < length; i1++){
                var key = $0f40cb253fadb90e$var$deserializeField(schema, fieldName, fieldType.key, reader);
                var val = $0f40cb253fadb90e$var$deserializeField(schema, fieldName, fieldType.value, reader);
                map.set(key, val);
            }
            return map;
        }
        return $0f40cb253fadb90e$var$deserializeStruct(schema, fieldType, reader);
    } catch (error) {
        if (error instanceof $0f40cb253fadb90e$var$BorshError) error.addToFieldPath(fieldName);
        throw error;
    }
}
function $0f40cb253fadb90e$var$deserializeStruct(schema, classType, reader) {
    if (typeof classType.borshDeserialize === "function") return classType.borshDeserialize(reader);
    var structSchema = schema.get(classType);
    if (!structSchema) throw new $0f40cb253fadb90e$var$BorshError("Class ".concat(classType.name, " is missing in schema"));
    if (structSchema.kind === "struct") {
        var result = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = schema.get(classType).fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $cv9Rk._)(_step.value, 2), fieldName = _step_value[0], fieldType = _step_value[1];
                result[fieldName] = $0f40cb253fadb90e$var$deserializeField(schema, fieldName, fieldType, reader);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return new classType(result);
    }
    if (structSchema.kind === "enum") {
        var idx = reader.readU8();
        if (idx >= structSchema.values.length) throw new $0f40cb253fadb90e$var$BorshError("Enum index: ".concat(idx, " is out of range"));
        var _structSchema_values_idx = (0, $cv9Rk._)(structSchema.values[idx], 2), fieldName1 = _structSchema_values_idx[0], fieldType1 = _structSchema_values_idx[1];
        var fieldValue = $0f40cb253fadb90e$var$deserializeField(schema, fieldName1, fieldType1, reader);
        return new classType((0, $3sHb8._)({}, fieldName1, fieldValue));
    }
    throw new $0f40cb253fadb90e$var$BorshError("Unexpected schema kind: ".concat(structSchema.kind, " for ").concat(classType.constructor.name));
}
/// Deserializes object from bytes using schema.
function $0f40cb253fadb90e$var$deserialize(schema, classType, buffer) {
    var Reader = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $0f40cb253fadb90e$var$BinaryReader;
    var reader = new Reader(buffer);
    var result = $0f40cb253fadb90e$var$deserializeStruct(schema, classType, reader);
    if (reader.offset < buffer.length) throw new $0f40cb253fadb90e$var$BorshError("Unexpected ".concat(buffer.length - reader.offset, " bytes after deserialized data"));
    return result;
}
module.exports.deserialize = $0f40cb253fadb90e$var$deserialize;
/// Deserializes object from bytes using schema, without checking the length read
function $0f40cb253fadb90e$var$deserializeUnchecked(schema, classType, buffer) {
    var Reader = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $0f40cb253fadb90e$var$BinaryReader;
    var reader = new Reader(buffer);
    return $0f40cb253fadb90e$var$deserializeStruct(schema, classType, reader);
}
module.exports.deserializeUnchecked = $0f40cb253fadb90e$var$deserializeUnchecked;

});
parcelRegister("7muUi", function(module, exports) {

var $1ISpw = parcelRequire("1ISpw");
var $55c28ff8fb6a1413$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
module.exports = $1ISpw($55c28ff8fb6a1413$var$ALPHABET);

});

parcelRegister("8Ij4F", function(module, exports) {

$parcel$export(module.exports, "TextEncoder", function () { return $65813a8fbb0fe538$export$88fb0cfd153261a7; }, function (v) { return $65813a8fbb0fe538$export$88fb0cfd153261a7 = v; });
$parcel$export(module.exports, "TextDecoder", function () { return $65813a8fbb0fe538$export$9c6b53e35bc51b5c; }, function (v) { return $65813a8fbb0fe538$export$9c6b53e35bc51b5c = v; });
var $65813a8fbb0fe538$export$88fb0cfd153261a7;
var $65813a8fbb0fe538$export$9c6b53e35bc51b5c;
"use strict";
// This is free and unencumbered software released into the public domain.
// See LICENSE.md for more information.
//
// Utilities
//
/**
 * @param {number} a The number to test.
 * @param {number} min The minimum value in the range, inclusive.
 * @param {number} max The maximum value in the range, inclusive.
 * @return {boolean} True if a >= min and a <= max.
 */ function $65813a8fbb0fe538$var$inRange(a, min, max) {
    return min <= a && a <= max;
}
/**
 * @param {*} o
 * @return {Object}
 */ function $65813a8fbb0fe538$var$ToDictionary(o) {
    if (o === undefined) return {};
    if (o === Object(o)) return o;
    throw TypeError("Could not convert argument to dictionary");
}
/**
 * @param {string} string Input string of UTF-16 code units.
 * @return {!Array.<number>} Code points.
 */ function $65813a8fbb0fe538$var$stringToCodePoints(string) {
    // https://heycam.github.io/webidl/#dfn-obtain-unicode
    // 1. Let S be the DOMString value.
    var s = String(string);
    // 2. Let n be the length of S.
    var n = s.length;
    // 3. Initialize i to 0.
    var i = 0;
    // 4. Initialize U to be an empty sequence of Unicode characters.
    var u = [];
    // 5. While i < n:
    while(i < n){
        // 1. Let c be the code unit in S at index i.
        var c = s.charCodeAt(i);
        // 2. Depending on the value of c:
        // c < 0xD800 or c > 0xDFFF
        if (c < 0xD800 || c > 0xDFFF) // Append to U the Unicode character with code point c.
        u.push(c);
        else if (0xDC00 <= c && c <= 0xDFFF) // Append to U a U+FFFD REPLACEMENT CHARACTER.
        u.push(0xFFFD);
        else if (0xD800 <= c && c <= 0xDBFF) {
            // 1. If i = n−1, then append to U a U+FFFD REPLACEMENT
            // CHARACTER.
            if (i === n - 1) u.push(0xFFFD);
            else {
                // 1. Let d be the code unit in S at index i+1.
                var d = string.charCodeAt(i + 1);
                // 2. If 0xDC00 ≤ d ≤ 0xDFFF, then:
                if (0xDC00 <= d && d <= 0xDFFF) {
                    // 1. Let a be c & 0x3FF.
                    var a = c & 0x3FF;
                    // 2. Let b be d & 0x3FF.
                    var b = d & 0x3FF;
                    // 3. Append to U the Unicode character with code point
                    // 2^16+2^10*a+b.
                    u.push(0x10000 + (a << 10) + b);
                    // 4. Set i to i+1.
                    i += 1;
                } else u.push(0xFFFD);
            }
        }
        // 3. Set i to i+1.
        i += 1;
    }
    // 6. Return U.
    return u;
}
/**
 * @param {!Array.<number>} code_points Array of code points.
 * @return {string} string String of UTF-16 code units.
 */ function $65813a8fbb0fe538$var$codePointsToString(code_points) {
    var s = "";
    for(var i = 0; i < code_points.length; ++i){
        var cp = code_points[i];
        if (cp <= 0xFFFF) s += String.fromCharCode(cp);
        else {
            cp -= 0x10000;
            s += String.fromCharCode((cp >> 10) + 0xD800, (cp & 0x3FF) + 0xDC00);
        }
    }
    return s;
}
//
// Implementation of Encoding specification
// https://encoding.spec.whatwg.org/
//
//
// 3. Terminology
//
/**
 * End-of-stream is a special token that signifies no more tokens
 * are in the stream.
 * @const
 */ var $65813a8fbb0fe538$var$end_of_stream = -1;
/**
 * A stream represents an ordered sequence of tokens.
 *
 * @constructor
 * @param {!(Array.<number>|Uint8Array)} tokens Array of tokens that provide the
 * stream.
 */ function $65813a8fbb0fe538$var$Stream(tokens) {
    /** @type {!Array.<number>} */ this.tokens = [].slice.call(tokens);
}
$65813a8fbb0fe538$var$Stream.prototype = {
    /**
   * @return {boolean} True if end-of-stream has been hit.
   */ endOfStream: function endOfStream() {
        return !this.tokens.length;
    },
    /**
   * When a token is read from a stream, the first token in the
   * stream must be returned and subsequently removed, and
   * end-of-stream must be returned otherwise.
   *
   * @return {number} Get the next token from the stream, or
   * end_of_stream.
   */ read: function read() {
        if (!this.tokens.length) return $65813a8fbb0fe538$var$end_of_stream;
        return this.tokens.shift();
    },
    /**
   * When one or more tokens are prepended to a stream, those tokens
   * must be inserted, in given order, before the first token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The token(s) to prepend to the stream.
   */ prepend: function prepend(token) {
        if (Array.isArray(token)) {
            var tokens = /**@type {!Array.<number>}*/ token;
            while(tokens.length)this.tokens.unshift(tokens.pop());
        } else this.tokens.unshift(token);
    },
    /**
   * When one or more tokens are pushed to a stream, those tokens
   * must be inserted, in given order, after the last token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The tokens(s) to prepend to the stream.
   */ push: function push(token) {
        if (Array.isArray(token)) {
            var tokens = /**@type {!Array.<number>}*/ token;
            while(tokens.length)this.tokens.push(tokens.shift());
        } else this.tokens.push(token);
    }
};
//
// 4. Encodings
//
// 4.1 Encoders and decoders
/** @const */ var $65813a8fbb0fe538$var$finished = -1;
/**
 * @param {boolean} fatal If true, decoding errors raise an exception.
 * @param {number=} opt_code_point Override the standard fallback code point.
 * @return {number} The code point to insert on a decoding error.
 */ function $65813a8fbb0fe538$var$decoderError(fatal, opt_code_point) {
    if (fatal) throw TypeError("Decoder error");
    return opt_code_point || 0xFFFD;
}
//
// 7. API
//
/** @const */ var $65813a8fbb0fe538$var$DEFAULT_ENCODING = "utf-8";
// 7.1 Interface TextDecoder
/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */ function $65813a8fbb0fe538$var$TextDecoder(encoding, options) {
    if (!(this instanceof $65813a8fbb0fe538$var$TextDecoder)) return new $65813a8fbb0fe538$var$TextDecoder(encoding, options);
    encoding = encoding !== undefined ? String(encoding).toLowerCase() : $65813a8fbb0fe538$var$DEFAULT_ENCODING;
    if (encoding !== $65813a8fbb0fe538$var$DEFAULT_ENCODING) throw new Error("Encoding not supported. Only utf-8 is supported");
    options = $65813a8fbb0fe538$var$ToDictionary(options);
    /** @private @type {boolean} */ this._streaming = false;
    /** @private @type {boolean} */ this._BOMseen = false;
    /** @private @type {?Decoder} */ this._decoder = null;
    /** @private @type {boolean} */ this._fatal = Boolean(options["fatal"]);
    /** @private @type {boolean} */ this._ignoreBOM = Boolean(options["ignoreBOM"]);
    Object.defineProperty(this, "encoding", {
        value: "utf-8"
    });
    Object.defineProperty(this, "fatal", {
        value: this._fatal
    });
    Object.defineProperty(this, "ignoreBOM", {
        value: this._ignoreBOM
    });
}
$65813a8fbb0fe538$var$TextDecoder.prototype = {
    /**
   * @param {ArrayBufferView=} input The buffer of bytes to decode.
   * @param {Object=} options
   * @return {string} The decoded string.
   */ decode: function decode(input, options) {
        var bytes;
        if (typeof input === "object" && input instanceof ArrayBuffer) bytes = new Uint8Array(input);
        else if (typeof input === "object" && "buffer" in input && input.buffer instanceof ArrayBuffer) bytes = new Uint8Array(input.buffer, input.byteOffset, input.byteLength);
        else bytes = new Uint8Array(0);
        options = $65813a8fbb0fe538$var$ToDictionary(options);
        if (!this._streaming) {
            this._decoder = new $65813a8fbb0fe538$var$UTF8Decoder({
                fatal: this._fatal
            });
            this._BOMseen = false;
        }
        this._streaming = Boolean(options["stream"]);
        var input_stream = new $65813a8fbb0fe538$var$Stream(bytes);
        var code_points = [];
        /** @type {?(number|!Array.<number>)} */ var result;
        while(!input_stream.endOfStream()){
            result = this._decoder.handler(input_stream, input_stream.read());
            if (result === $65813a8fbb0fe538$var$finished) break;
            if (result === null) continue;
            if (Array.isArray(result)) code_points.push.apply(code_points, /**@type {!Array.<number>}*/ result);
            else code_points.push(result);
        }
        if (!this._streaming) {
            do {
                result = this._decoder.handler(input_stream, input_stream.read());
                if (result === $65813a8fbb0fe538$var$finished) break;
                if (result === null) continue;
                if (Array.isArray(result)) code_points.push.apply(code_points, /**@type {!Array.<number>}*/ result);
                else code_points.push(result);
            }while (!input_stream.endOfStream());
            this._decoder = null;
        }
        if (code_points.length) // If encoding is one of utf-8, utf-16be, and utf-16le, and
        // ignore BOM flag and BOM seen flag are unset, run these
        // subsubsteps:
        {
            if ([
                "utf-8"
            ].indexOf(this.encoding) !== -1 && !this._ignoreBOM && !this._BOMseen) {
                // If token is U+FEFF, set BOM seen flag.
                if (code_points[0] === 0xFEFF) {
                    this._BOMseen = true;
                    code_points.shift();
                } else // Otherwise, if token is not end-of-stream, set BOM seen
                // flag and append token to output.
                this._BOMseen = true;
            }
        }
        return $65813a8fbb0fe538$var$codePointsToString(code_points);
    }
};
// 7.2 Interface TextEncoder
/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */ function $65813a8fbb0fe538$var$TextEncoder(encoding, options) {
    if (!(this instanceof $65813a8fbb0fe538$var$TextEncoder)) return new $65813a8fbb0fe538$var$TextEncoder(encoding, options);
    encoding = encoding !== undefined ? String(encoding).toLowerCase() : $65813a8fbb0fe538$var$DEFAULT_ENCODING;
    if (encoding !== $65813a8fbb0fe538$var$DEFAULT_ENCODING) throw new Error("Encoding not supported. Only utf-8 is supported");
    options = $65813a8fbb0fe538$var$ToDictionary(options);
    /** @private @type {boolean} */ this._streaming = false;
    /** @private @type {?Encoder} */ this._encoder = null;
    /** @private @type {{fatal: boolean}} */ this._options = {
        fatal: Boolean(options["fatal"])
    };
    Object.defineProperty(this, "encoding", {
        value: "utf-8"
    });
}
$65813a8fbb0fe538$var$TextEncoder.prototype = {
    /**
   * @param {string=} opt_string The string to encode.
   * @param {Object=} options
   * @return {Uint8Array} Encoded bytes, as a Uint8Array.
   */ encode: function encode(opt_string, options) {
        opt_string = opt_string ? String(opt_string) : "";
        options = $65813a8fbb0fe538$var$ToDictionary(options);
        // NOTE: This option is nonstandard. None of the encodings
        // permitted for encoding (i.e. UTF-8, UTF-16) are stateful,
        // so streaming is not necessary.
        if (!this._streaming) this._encoder = new $65813a8fbb0fe538$var$UTF8Encoder(this._options);
        this._streaming = Boolean(options["stream"]);
        var bytes = [];
        var input_stream = new $65813a8fbb0fe538$var$Stream($65813a8fbb0fe538$var$stringToCodePoints(opt_string));
        /** @type {?(number|!Array.<number>)} */ var result;
        while(!input_stream.endOfStream()){
            result = this._encoder.handler(input_stream, input_stream.read());
            if (result === $65813a8fbb0fe538$var$finished) break;
            if (Array.isArray(result)) bytes.push.apply(bytes, /**@type {!Array.<number>}*/ result);
            else bytes.push(result);
        }
        if (!this._streaming) {
            while(true){
                result = this._encoder.handler(input_stream, input_stream.read());
                if (result === $65813a8fbb0fe538$var$finished) break;
                if (Array.isArray(result)) bytes.push.apply(bytes, /**@type {!Array.<number>}*/ result);
                else bytes.push(result);
            }
            this._encoder = null;
        }
        return new Uint8Array(bytes);
    }
};
//
// 8. The encoding
//
// 8.1 utf-8
/**
 * @constructor
 * @implements {Decoder}
 * @param {{fatal: boolean}} options
 */ function $65813a8fbb0fe538$var$UTF8Decoder(options) {
    var fatal = options.fatal;
    // utf-8's decoder's has an associated utf-8 code point, utf-8
    // bytes seen, and utf-8 bytes needed (all initially 0), a utf-8
    // lower boundary (initially 0x80), and a utf-8 upper boundary
    // (initially 0xBF).
    var /** @type {number} */ utf8_code_point = 0, /** @type {number} */ utf8_bytes_seen = 0, /** @type {number} */ utf8_bytes_needed = 0, /** @type {number} */ utf8_lower_boundary = 0x80, /** @type {number} */ utf8_upper_boundary = 0xBF;
    /**
   * @param {Stream} stream The stream of bytes being decoded.
   * @param {number} bite The next byte read from the stream.
   * @return {?(number|!Array.<number>)} The next code point(s)
   *     decoded, or null if not enough data exists in the input
   *     stream to decode a complete code point.
   */ this.handler = function(stream, bite) {
        // 1. If byte is end-of-stream and utf-8 bytes needed is not 0,
        // set utf-8 bytes needed to 0 and return error.
        if (bite === $65813a8fbb0fe538$var$end_of_stream && utf8_bytes_needed !== 0) {
            utf8_bytes_needed = 0;
            return $65813a8fbb0fe538$var$decoderError(fatal);
        }
        // 2. If byte is end-of-stream, return finished.
        if (bite === $65813a8fbb0fe538$var$end_of_stream) return $65813a8fbb0fe538$var$finished;
        // 3. If utf-8 bytes needed is 0, based on byte:
        if (utf8_bytes_needed === 0) {
            // 0x00 to 0x7F
            if ($65813a8fbb0fe538$var$inRange(bite, 0x00, 0x7F)) // Return a code point whose value is byte.
            return bite;
            // 0xC2 to 0xDF
            if ($65813a8fbb0fe538$var$inRange(bite, 0xC2, 0xDF)) {
                // Set utf-8 bytes needed to 1 and utf-8 code point to byte
                // − 0xC0.
                utf8_bytes_needed = 1;
                utf8_code_point = bite - 0xC0;
            } else if ($65813a8fbb0fe538$var$inRange(bite, 0xE0, 0xEF)) {
                // 1. If byte is 0xE0, set utf-8 lower boundary to 0xA0.
                if (bite === 0xE0) utf8_lower_boundary = 0xA0;
                // 2. If byte is 0xED, set utf-8 upper boundary to 0x9F.
                if (bite === 0xED) utf8_upper_boundary = 0x9F;
                // 3. Set utf-8 bytes needed to 2 and utf-8 code point to
                // byte − 0xE0.
                utf8_bytes_needed = 2;
                utf8_code_point = bite - 0xE0;
            } else if ($65813a8fbb0fe538$var$inRange(bite, 0xF0, 0xF4)) {
                // 1. If byte is 0xF0, set utf-8 lower boundary to 0x90.
                if (bite === 0xF0) utf8_lower_boundary = 0x90;
                // 2. If byte is 0xF4, set utf-8 upper boundary to 0x8F.
                if (bite === 0xF4) utf8_upper_boundary = 0x8F;
                // 3. Set utf-8 bytes needed to 3 and utf-8 code point to
                // byte − 0xF0.
                utf8_bytes_needed = 3;
                utf8_code_point = bite - 0xF0;
            } else // Return error.
            return $65813a8fbb0fe538$var$decoderError(fatal);
            // Then (byte is in the range 0xC2 to 0xF4) set utf-8 code
            // point to utf-8 code point << (6 × utf-8 bytes needed) and
            // return continue.
            utf8_code_point = utf8_code_point << 6 * utf8_bytes_needed;
            return null;
        }
        // 4. If byte is not in the range utf-8 lower boundary to utf-8
        // upper boundary, run these substeps:
        if (!$65813a8fbb0fe538$var$inRange(bite, utf8_lower_boundary, utf8_upper_boundary)) {
            // 1. Set utf-8 code point, utf-8 bytes needed, and utf-8
            // bytes seen to 0, set utf-8 lower boundary to 0x80, and set
            // utf-8 upper boundary to 0xBF.
            utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
            utf8_lower_boundary = 0x80;
            utf8_upper_boundary = 0xBF;
            // 2. Prepend byte to stream.
            stream.prepend(bite);
            // 3. Return error.
            return $65813a8fbb0fe538$var$decoderError(fatal);
        }
        // 5. Set utf-8 lower boundary to 0x80 and utf-8 upper boundary
        // to 0xBF.
        utf8_lower_boundary = 0x80;
        utf8_upper_boundary = 0xBF;
        // 6. Increase utf-8 bytes seen by one and set utf-8 code point
        // to utf-8 code point + (byte − 0x80) << (6 × (utf-8 bytes
        // needed − utf-8 bytes seen)).
        utf8_bytes_seen += 1;
        utf8_code_point += bite - 0x80 << 6 * (utf8_bytes_needed - utf8_bytes_seen);
        // 7. If utf-8 bytes seen is not equal to utf-8 bytes needed,
        // continue.
        if (utf8_bytes_seen !== utf8_bytes_needed) return null;
        // 8. Let code point be utf-8 code point.
        var code_point = utf8_code_point;
        // 9. Set utf-8 code point, utf-8 bytes needed, and utf-8 bytes
        // seen to 0.
        utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
        // 10. Return a code point whose value is code point.
        return code_point;
    };
}
/**
 * @constructor
 * @implements {Encoder}
 * @param {{fatal: boolean}} options
 */ function $65813a8fbb0fe538$var$UTF8Encoder(options) {
    var fatal = options.fatal;
    /**
   * @param {Stream} stream Input stream.
   * @param {number} code_point Next code point read from the stream.
   * @return {(number|!Array.<number>)} Byte(s) to emit.
   */ this.handler = function(stream, code_point) {
        // 1. If code point is end-of-stream, return finished.
        if (code_point === $65813a8fbb0fe538$var$end_of_stream) return $65813a8fbb0fe538$var$finished;
        // 2. If code point is in the range U+0000 to U+007F, return a
        // byte whose value is code point.
        if ($65813a8fbb0fe538$var$inRange(code_point, 0x0000, 0x007f)) return code_point;
        // 3. Set count and offset based on the range code point is in:
        var count, offset;
        // U+0080 to U+07FF:    1 and 0xC0
        if ($65813a8fbb0fe538$var$inRange(code_point, 0x0080, 0x07FF)) {
            count = 1;
            offset = 0xC0;
        } else if ($65813a8fbb0fe538$var$inRange(code_point, 0x0800, 0xFFFF)) {
            count = 2;
            offset = 0xE0;
        } else if ($65813a8fbb0fe538$var$inRange(code_point, 0x10000, 0x10FFFF)) {
            count = 3;
            offset = 0xF0;
        }
        // 4.Let bytes be a byte sequence whose first byte is (code
        // point >> (6 × count)) + offset.
        var bytes = [
            (code_point >> 6 * count) + offset
        ];
        // 5. Run these substeps while count is greater than 0:
        while(count > 0){
            // 1. Set temp to code point >> (6 × (count − 1)).
            var temp = code_point >> 6 * (count - 1);
            // 2. Append to bytes 0x80 | (temp & 0x3F).
            bytes.push(0x80 | temp & 0x3F);
            // 3. Decrease count by one.
            count -= 1;
        }
        // 6. Return bytes bytes, in order.
        return bytes;
    };
}
$65813a8fbb0fe538$export$88fb0cfd153261a7 = $65813a8fbb0fe538$var$TextEncoder;
$65813a8fbb0fe538$export$9c6b53e35bc51b5c = $65813a8fbb0fe538$var$TextDecoder;

});


parcelRegister("jt90m", function(module, exports) {
/* The MIT License (MIT)
 *
 * Copyright 2015-2018 Peter A. Bigot
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * Support for translating between Uint8Array instances and JavaScript
 * native types.
 *
 * {@link module:Layout~Layout|Layout} is the basis of a class
 * hierarchy that associates property names with sequences of encoded
 * bytes.
 *
 * Layouts are supported for these scalar (numeric) types:
 * * {@link module:Layout~UInt|Unsigned integers in little-endian
 *   format} with {@link module:Layout.u8|8-bit}, {@link
 *   module:Layout.u16|16-bit}, {@link module:Layout.u24|24-bit},
 *   {@link module:Layout.u32|32-bit}, {@link
 *   module:Layout.u40|40-bit}, and {@link module:Layout.u48|48-bit}
 *   representation ranges;
 * * {@link module:Layout~UIntBE|Unsigned integers in big-endian
 *   format} with {@link module:Layout.u16be|16-bit}, {@link
 *   module:Layout.u24be|24-bit}, {@link module:Layout.u32be|32-bit},
 *   {@link module:Layout.u40be|40-bit}, and {@link
 *   module:Layout.u48be|48-bit} representation ranges;
 * * {@link module:Layout~Int|Signed integers in little-endian
 *   format} with {@link module:Layout.s8|8-bit}, {@link
 *   module:Layout.s16|16-bit}, {@link module:Layout.s24|24-bit},
 *   {@link module:Layout.s32|32-bit}, {@link
 *   module:Layout.s40|40-bit}, and {@link module:Layout.s48|48-bit}
 *   representation ranges;
 * * {@link module:Layout~IntBE|Signed integers in big-endian format}
 *   with {@link module:Layout.s16be|16-bit}, {@link
 *   module:Layout.s24be|24-bit}, {@link module:Layout.s32be|32-bit},
 *   {@link module:Layout.s40be|40-bit}, and {@link
 *   module:Layout.s48be|48-bit} representation ranges;
 * * 64-bit integral values that decode to an exact (if magnitude is
 *   less than 2^53) or nearby integral Number in {@link
 *   module:Layout.nu64|unsigned little-endian}, {@link
 *   module:Layout.nu64be|unsigned big-endian}, {@link
 *   module:Layout.ns64|signed little-endian}, and {@link
 *   module:Layout.ns64be|unsigned big-endian} encodings;
 * * 32-bit floating point values with {@link
 *   module:Layout.f32|little-endian} and {@link
 *   module:Layout.f32be|big-endian} representations;
 * * 64-bit floating point values with {@link
 *   module:Layout.f64|little-endian} and {@link
 *   module:Layout.f64be|big-endian} representations;
 * * {@link module:Layout.const|Constants} that take no space in the
 *   encoded expression.
 *
 * and for these aggregate types:
 * * {@link module:Layout.seq|Sequence}s of instances of a {@link
 *   module:Layout~Layout|Layout}, with JavaScript representation as
 *   an Array and constant or data-dependent {@link
 *   module:Layout~Sequence#count|length};
 * * {@link module:Layout.struct|Structure}s that aggregate a
 *   heterogeneous sequence of {@link module:Layout~Layout|Layout}
 *   instances, with JavaScript representation as an Object;
 * * {@link module:Layout.union|Union}s that support multiple {@link
 *   module:Layout~VariantLayout|variant layouts} over a fixed
 *   (padded) or variable (not padded) span of bytes, using an
 *   unsigned integer at the start of the data or a separate {@link
 *   module:Layout.unionLayoutDiscriminator|layout element} to
 *   determine which layout to use when interpreting the buffer
 *   contents;
 * * {@link module:Layout.bits|BitStructure}s that contain a sequence
 *   of individual {@link
 *   module:Layout~BitStructure#addField|BitField}s packed into an 8,
 *   16, 24, or 32-bit unsigned integer starting at the least- or
 *   most-significant bit;
 * * {@link module:Layout.cstr|C strings} of varying length;
 * * {@link module:Layout.blob|Blobs} of fixed- or variable-{@link
 *   module:Layout~Blob#length|length} raw data.
 *
 * All {@link module:Layout~Layout|Layout} instances are immutable
 * after construction, to prevent internal state from becoming
 * inconsistent.
 *
 * @local Layout
 * @local ExternalLayout
 * @local GreedyCount
 * @local OffsetLayout
 * @local UInt
 * @local UIntBE
 * @local Int
 * @local IntBE
 * @local NearUInt64
 * @local NearUInt64BE
 * @local NearInt64
 * @local NearInt64BE
 * @local Float
 * @local FloatBE
 * @local Double
 * @local DoubleBE
 * @local Sequence
 * @local Structure
 * @local UnionDiscriminator
 * @local UnionLayoutDiscriminator
 * @local Union
 * @local VariantLayout
 * @local BitStructure
 * @local BitField
 * @local Boolean
 * @local Blob
 * @local CString
 * @local Constant
 * @local bindConstructorLayout
 * @module Layout
 * @license MIT
 * @author Peter A. Bigot
 * @see {@link https://github.com/pabigot/buffer-layout|buffer-layout on GitHub}
 */ 
var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $04RAu = parcelRequire("04RAu");

var $b8Rim = parcelRequire("b8Rim");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.s16 = exports.s8 = exports.nu64be = exports.u48be = exports.u40be = exports.u32be = exports.u24be = exports.u16be = exports.nu64 = exports.u48 = exports.u40 = exports.u32 = exports.u24 = exports.u16 = exports.u8 = exports.offset = exports.greedy = exports.Constant = exports.UTF8 = exports.CString = exports.Blob = exports.Boolean = exports.BitField = exports.BitStructure = exports.VariantLayout = exports.Union = exports.UnionLayoutDiscriminator = exports.UnionDiscriminator = exports.Structure = exports.Sequence = exports.DoubleBE = exports.Double = exports.FloatBE = exports.Float = exports.NearInt64BE = exports.NearInt64 = exports.NearUInt64BE = exports.NearUInt64 = exports.IntBE = exports.Int = exports.UIntBE = exports.UInt = exports.OffsetLayout = exports.GreedyCount = exports.ExternalLayout = exports.bindConstructorLayout = exports.nameWithProperty = exports.Layout = exports.uint8ArrayToBuffer = exports.checkUint8Array = void 0;
exports.constant = exports.utf8 = exports.cstr = exports.blob = exports.unionLayoutDiscriminator = exports.union = exports.seq = exports.bits = exports.struct = exports.f64be = exports.f64 = exports.f32be = exports.f32 = exports.ns64be = exports.s48be = exports.s40be = exports.s32be = exports.s24be = exports.s16be = exports.ns64 = exports.s48 = exports.s40 = exports.s32 = exports.s24 = void 0;

var $8dlmd = parcelRequire("8dlmd");
/* Check if a value is a Uint8Array.
 *
 * @ignore */ function checkUint8Array(b) {
    if (!(b instanceof Uint8Array)) throw new TypeError("b must be a Uint8Array");
}
exports.checkUint8Array = checkUint8Array;
/* Create a Buffer instance from a Uint8Array.
 *
 * @ignore */ function uint8ArrayToBuffer(b) {
    checkUint8Array(b);
    return $8dlmd.Buffer.from(b.buffer, b.byteOffset, b.length);
}
exports.uint8ArrayToBuffer = uint8ArrayToBuffer;
/**
 * Base class for layout objects.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support the {@link
 * Layout#encode|encode} or {@link Layout#decode|decode} functions.
 *
 * @param {Number} span - Initializer for {@link Layout#span|span}.  The
 * parameter must be an integer; a negative value signifies that the
 * span is {@link Layout#getSpan|value-specific}.
 *
 * @param {string} [property] - Initializer for {@link
 * Layout#property|property}.
 *
 * @abstract
 */ var Layout = /*#__PURE__*/ function() {
    function Layout(span, property) {
        (0, $4GJKx._)(this, Layout);
        if (!Number.isInteger(span)) throw new TypeError("span must be an integer");
        /** The span of the layout in bytes.
         *
         * Positive values are generally expected.
         *
         * Zero will only appear in {@link Constant}s and in {@link
         * Sequence}s where the {@link Sequence#count|count} is zero.
         *
         * A negative value indicates that the span is value-specific, and
         * must be obtained using {@link Layout#getSpan|getSpan}. */ this.span = span;
        /** The property name used when this layout is represented in an
         * Object.
         *
         * Used only for layouts that {@link Layout#decode|decode} to Object
         * instances.  If left undefined the span of the unnamed layout will
         * be treated as padding: it will not be mutated by {@link
         * Layout#encode|encode} nor represented as a property in the
         * decoded Object. */ this.property = property;
    }
    (0, $1wc17._)(Layout, [
        {
            /** Function to create an Object into which decoded properties will
     * be written.
     *
     * Used only for layouts that {@link Layout#decode|decode} to Object
     * instances, which means:
     * * {@link Structure}
     * * {@link Union}
     * * {@link VariantLayout}
     * * {@link BitStructure}
     *
     * If left undefined the JavaScript representation of these layouts
     * will be Object instances.
     *
     * See {@link bindConstructorLayout}.
     */ key: "makeDestinationObject",
            value: function makeDestinationObject() {
                return {};
            }
        },
        {
            /**
     * Calculate the span of a specific instance of a layout.
     *
     * @param {Uint8Array} b - the buffer that contains an encoded instance.
     *
     * @param {Number} [offset] - the offset at which the encoded instance
     * starts.  If absent a zero offset is inferred.
     *
     * @return {Number} - the number of bytes covered by the layout
     * instance.  If this method is not overridden in a subclass the
     * definition-time constant {@link Layout#span|span} will be
     * returned.
     *
     * @throws {RangeError} - if the length of the value cannot be
     * determined.
     */ key: "getSpan",
            value: function getSpan(b, offset) {
                if (0 > this.span) throw new RangeError("indeterminate span");
                return this.span;
            }
        },
        {
            /**
     * Replicate the layout using a new property.
     *
     * This function must be used to get a structurally-equivalent layout
     * with a different name since all {@link Layout} instances are
     * immutable.
     *
     * **NOTE** This is a shallow copy.  All fields except {@link
     * Layout#property|property} are strictly equal to the origin layout.
     *
     * @param {String} property - the value for {@link
     * Layout#property|property} in the replica.
     *
     * @returns {Layout} - the copy with {@link Layout#property|property}
     * set to `property`.
     */ key: "replicate",
            value: function replicate(property) {
                var rv = Object.create(this.constructor.prototype);
                Object.assign(rv, this);
                rv.property = property;
                return rv;
            }
        },
        {
            /**
     * Create an object from layout properties and an array of values.
     *
     * **NOTE** This function returns `undefined` if invoked on a layout
     * that does not return its value as an Object.  Objects are
     * returned for things that are a {@link Structure}, which includes
     * {@link VariantLayout|variant layouts} if they are structures, and
     * excludes {@link Union}s.  If you want this feature for a union
     * you must use {@link Union.getVariant|getVariant} to select the
     * desired layout.
     *
     * @param {Array} values - an array of values that correspond to the
     * default order for properties.  As with {@link Layout#decode|decode}
     * layout elements that have no property name are skipped when
     * iterating over the array values.  Only the top-level properties are
     * assigned; arguments are not assigned to properties of contained
     * layouts.  Any unused values are ignored.
     *
     * @return {(Object|undefined)}
     */ key: "fromArray",
            value: function fromArray(values) {
                return undefined;
            }
        }
    ]);
    return Layout;
}();
exports.Layout = Layout;
/* Provide text that carries a name (such as for a function that will
 * be throwing an error) annotated with the property of a given layout
 * (such as one for which the value was unacceptable).
 *
 * @ignore */ function nameWithProperty(name, lo) {
    if (lo.property) return name + "[" + lo.property + "]";
    return name;
}
exports.nameWithProperty = nameWithProperty;
/**
 * Augment a class so that instances can be encoded/decoded using a
 * given layout.
 *
 * Calling this function couples `Class` with `layout` in several ways:
 *
 * * `Class.layout_` becomes a static member property equal to `layout`;
 * * `layout.boundConstructor_` becomes a static member property equal
 *    to `Class`;
 * * The {@link Layout#makeDestinationObject|makeDestinationObject()}
 *   property of `layout` is set to a function that returns a `new
 *   Class()`;
 * * `Class.decode(b, offset)` becomes a static member function that
 *   delegates to {@link Layout#decode|layout.decode}.  The
 *   synthesized function may be captured and extended.
 * * `Class.prototype.encode(b, offset)` provides an instance member
 *   function that delegates to {@link Layout#encode|layout.encode}
 *   with `src` set to `this`.  The synthesized function may be
 *   captured and extended, but when the extension is invoked `this`
 *   must be explicitly bound to the instance.
 *
 * @param {class} Class - a JavaScript class with a nullary
 * constructor.
 *
 * @param {Layout} layout - the {@link Layout} instance used to encode
 * instances of `Class`.
 */ // `Class` must be a constructor Function, but the assignment of a `layout_` property to it makes it difficult to type
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function bindConstructorLayout(Class, layout) {
    if ("function" !== typeof Class) throw new TypeError("Class must be constructor");
    if (Object.prototype.hasOwnProperty.call(Class, "layout_")) throw new Error("Class is already bound to a layout");
    if (!(layout && layout instanceof Layout)) throw new TypeError("layout must be a Layout");
    if (Object.prototype.hasOwnProperty.call(layout, "boundConstructor_")) throw new Error("layout is already bound to a constructor");
    Class.layout_ = layout;
    layout.boundConstructor_ = Class;
    layout.makeDestinationObject = function() {
        return new Class();
    };
    Object.defineProperty(Class.prototype, "encode", {
        value: function(b, offset) {
            return layout.encode(this, b, offset);
        },
        writable: true
    });
    Object.defineProperty(Class, "decode", {
        value: function(b, offset) {
            return layout.decode(b, offset);
        },
        writable: true
    });
}
exports.bindConstructorLayout = bindConstructorLayout;
/**
 * An object that behaves like a layout but does not consume space
 * within its containing layout.
 *
 * This is primarily used to obtain metadata about a member, such as a
 * {@link OffsetLayout} that can provide data about a {@link
 * Layout#getSpan|value-specific span}.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support {@link
 * ExternalLayout#isCount|isCount} or other {@link Layout} functions.
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @abstract
 * @augments {Layout}
 */ var ExternalLayout = /*#__PURE__*/ function(Layout) {
    (0, $dcsZi._)(ExternalLayout, Layout);
    var _super = (0, $ohfOJ._)(ExternalLayout);
    function ExternalLayout() {
        (0, $4GJKx._)(this, ExternalLayout);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(ExternalLayout, [
        {
            /**
     * Return `true` iff the external layout decodes to an unsigned
     * integer layout.
     *
     * In that case it can be used as the source of {@link
     * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
     * or as {@link UnionLayoutDiscriminator#layout|external union
     * discriminators}.
     *
     * @abstract
     */ key: "isCount",
            value: function isCount() {
                throw new Error("ExternalLayout is abstract");
            }
        }
    ]);
    return ExternalLayout;
}(Layout);
exports.ExternalLayout = ExternalLayout;
/**
 * An {@link ExternalLayout} that determines its {@link
 * Layout#decode|value} based on offset into and length of the buffer
 * on which it is invoked.
 *
 * *Factory*: {@link module:Layout.greedy|greedy}
 *
 * @param {Number} [elementSpan] - initializer for {@link
 * GreedyCount#elementSpan|elementSpan}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {ExternalLayout}
 */ var GreedyCount = /*#__PURE__*/ function(ExternalLayout) {
    (0, $dcsZi._)(GreedyCount, ExternalLayout);
    var _super = (0, $ohfOJ._)(GreedyCount);
    function GreedyCount() {
        var elementSpan = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, property = arguments.length > 1 ? arguments[1] : void 0;
        (0, $4GJKx._)(this, GreedyCount);
        var _this;
        if (!Number.isInteger(elementSpan) || 0 >= elementSpan) throw new TypeError("elementSpan must be a (positive) integer");
        _this = _super.call(this, -1, property);
        /** The layout for individual elements of the sequence.  The value
         * must be a positive integer.  If not provided, the value will be
         * 1. */ _this.elementSpan = elementSpan;
        return _this;
    }
    (0, $1wc17._)(GreedyCount, [
        {
            /** @override */ key: "isCount",
            value: function isCount() {
                return true;
            }
        },
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                checkUint8Array(b);
                var rem = b.length - offset;
                return Math.floor(rem / this.elementSpan);
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b, offset) {
                return 0;
            }
        }
    ]);
    return GreedyCount;
}(ExternalLayout);
exports.GreedyCount = GreedyCount;
/**
 * An {@link ExternalLayout} that supports accessing a {@link Layout}
 * at a fixed offset from the start of another Layout.  The offset may
 * be before, within, or after the base layout.
 *
 * *Factory*: {@link module:Layout.offset|offset}
 *
 * @param {Layout} layout - initializer for {@link
 * OffsetLayout#layout|layout}, modulo `property`.
 *
 * @param {Number} [offset] - Initializes {@link
 * OffsetLayout#offset|offset}.  Defaults to zero.
 *
 * @param {string} [property] - Optional new property name for a
 * {@link Layout#replicate| replica} of `layout` to be used as {@link
 * OffsetLayout#layout|layout}.  If not provided the `layout` is used
 * unchanged.
 *
 * @augments {Layout}
 */ var OffsetLayout = /*#__PURE__*/ function(ExternalLayout) {
    (0, $dcsZi._)(OffsetLayout, ExternalLayout);
    var _super = (0, $ohfOJ._)(OffsetLayout);
    function OffsetLayout(layout) {
        var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, property = arguments.length > 2 ? arguments[2] : void 0;
        (0, $4GJKx._)(this, OffsetLayout);
        var _this;
        if (!(layout instanceof Layout)) throw new TypeError("layout must be a Layout");
        if (!Number.isInteger(offset)) throw new TypeError("offset must be integer or undefined");
        _this = _super.call(this, layout.span, property || layout.property);
        /** The subordinated layout. */ _this.layout = layout;
        /** The location of {@link OffsetLayout#layout} relative to the
         * start of another layout.
         *
         * The value may be positive or negative, but an error will thrown
         * if at the point of use it goes outside the span of the Uint8Array
         * being accessed.  */ _this.offset = offset;
        return _this;
    }
    (0, $1wc17._)(OffsetLayout, [
        {
            /** @override */ key: "isCount",
            value: function isCount() {
                return this.layout instanceof UInt || this.layout instanceof UIntBE;
            }
        },
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                return this.layout.decode(b, offset + this.offset);
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                return this.layout.encode(src, b, offset + this.offset);
            }
        }
    ]);
    return OffsetLayout;
}(ExternalLayout);
exports.OffsetLayout = OffsetLayout;
/**
 * Represent an unsigned integer in little-endian format.
 *
 * *Factory*: {@link module:Layout.u8|u8}, {@link
 *  module:Layout.u16|u16}, {@link module:Layout.u24|u24}, {@link
 *  module:Layout.u32|u32}, {@link module:Layout.u40|u40}, {@link
 *  module:Layout.u48|u48}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ var UInt = /*#__PURE__*/ function(Layout) {
    (0, $dcsZi._)(UInt, Layout);
    var _super = (0, $ohfOJ._)(UInt);
    function UInt(span, property) {
        (0, $4GJKx._)(this, UInt);
        var _this;
        _this = _super.call(this, span, property);
        if (6 < _this.span) throw new RangeError("span must not exceed 6 bytes");
        return _this;
    }
    (0, $1wc17._)(UInt, [
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                return uint8ArrayToBuffer(b).readUIntLE(offset, this.span);
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                uint8ArrayToBuffer(b).writeUIntLE(src, offset, this.span);
                return this.span;
            }
        }
    ]);
    return UInt;
}(Layout);
exports.UInt = UInt;
/**
 * Represent an unsigned integer in big-endian format.
 *
 * *Factory*: {@link module:Layout.u8be|u8be}, {@link
 * module:Layout.u16be|u16be}, {@link module:Layout.u24be|u24be},
 * {@link module:Layout.u32be|u32be}, {@link
 * module:Layout.u40be|u40be}, {@link module:Layout.u48be|u48be}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ var UIntBE = /*#__PURE__*/ function(Layout) {
    (0, $dcsZi._)(UIntBE, Layout);
    var _super = (0, $ohfOJ._)(UIntBE);
    function UIntBE(span, property) {
        (0, $4GJKx._)(this, UIntBE);
        var _this;
        _this = _super.call(this, span, property);
        if (6 < _this.span) throw new RangeError("span must not exceed 6 bytes");
        return _this;
    }
    (0, $1wc17._)(UIntBE, [
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                return uint8ArrayToBuffer(b).readUIntBE(offset, this.span);
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                uint8ArrayToBuffer(b).writeUIntBE(src, offset, this.span);
                return this.span;
            }
        }
    ]);
    return UIntBE;
}(Layout);
exports.UIntBE = UIntBE;
/**
 * Represent a signed integer in little-endian format.
 *
 * *Factory*: {@link module:Layout.s8|s8}, {@link
 *  module:Layout.s16|s16}, {@link module:Layout.s24|s24}, {@link
 *  module:Layout.s32|s32}, {@link module:Layout.s40|s40}, {@link
 *  module:Layout.s48|s48}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ var Int = /*#__PURE__*/ function(Layout) {
    (0, $dcsZi._)(Int, Layout);
    var _super = (0, $ohfOJ._)(Int);
    function Int(span, property) {
        (0, $4GJKx._)(this, Int);
        var _this;
        _this = _super.call(this, span, property);
        if (6 < _this.span) throw new RangeError("span must not exceed 6 bytes");
        return _this;
    }
    (0, $1wc17._)(Int, [
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                return uint8ArrayToBuffer(b).readIntLE(offset, this.span);
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                uint8ArrayToBuffer(b).writeIntLE(src, offset, this.span);
                return this.span;
            }
        }
    ]);
    return Int;
}(Layout);
exports.Int = Int;
/**
 * Represent a signed integer in big-endian format.
 *
 * *Factory*: {@link module:Layout.s8be|s8be}, {@link
 * module:Layout.s16be|s16be}, {@link module:Layout.s24be|s24be},
 * {@link module:Layout.s32be|s32be}, {@link
 * module:Layout.s40be|s40be}, {@link module:Layout.s48be|s48be}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ var IntBE = /*#__PURE__*/ function(Layout) {
    (0, $dcsZi._)(IntBE, Layout);
    var _super = (0, $ohfOJ._)(IntBE);
    function IntBE(span, property) {
        (0, $4GJKx._)(this, IntBE);
        var _this;
        _this = _super.call(this, span, property);
        if (6 < _this.span) throw new RangeError("span must not exceed 6 bytes");
        return _this;
    }
    (0, $1wc17._)(IntBE, [
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                return uint8ArrayToBuffer(b).readIntBE(offset, this.span);
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                uint8ArrayToBuffer(b).writeIntBE(src, offset, this.span);
                return this.span;
            }
        }
    ]);
    return IntBE;
}(Layout);
exports.IntBE = IntBE;
var V2E32 = Math.pow(2, 32);
/* True modulus high and low 32-bit words, where low word is always
 * non-negative. */ function divmodInt64(src) {
    var hi32 = Math.floor(src / V2E32);
    var lo32 = src - hi32 * V2E32;
    return {
        hi32: hi32,
        lo32: lo32
    };
}
/* Reconstruct Number from quotient and non-negative remainder */ function roundedInt64(hi32, lo32) {
    return hi32 * V2E32 + lo32;
}
/**
 * Represent an unsigned 64-bit integer in little-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.nu64|nu64}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ var NearUInt64 = /*#__PURE__*/ function(Layout) {
    (0, $dcsZi._)(NearUInt64, Layout);
    var _super = (0, $ohfOJ._)(NearUInt64);
    function NearUInt64(property) {
        (0, $4GJKx._)(this, NearUInt64);
        return _super.call(this, 8, property);
    }
    (0, $1wc17._)(NearUInt64, [
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var buffer = uint8ArrayToBuffer(b);
                var lo32 = buffer.readUInt32LE(offset);
                var hi32 = buffer.readUInt32LE(offset + 4);
                return roundedInt64(hi32, lo32);
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                var split = divmodInt64(src);
                var buffer = uint8ArrayToBuffer(b);
                buffer.writeUInt32LE(split.lo32, offset);
                buffer.writeUInt32LE(split.hi32, offset + 4);
                return 8;
            }
        }
    ]);
    return NearUInt64;
}(Layout);
exports.NearUInt64 = NearUInt64;
/**
 * Represent an unsigned 64-bit integer in big-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.nu64be|nu64be}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ var NearUInt64BE = /*#__PURE__*/ function(Layout) {
    (0, $dcsZi._)(NearUInt64BE, Layout);
    var _super = (0, $ohfOJ._)(NearUInt64BE);
    function NearUInt64BE(property) {
        (0, $4GJKx._)(this, NearUInt64BE);
        return _super.call(this, 8, property);
    }
    (0, $1wc17._)(NearUInt64BE, [
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var buffer = uint8ArrayToBuffer(b);
                var hi32 = buffer.readUInt32BE(offset);
                var lo32 = buffer.readUInt32BE(offset + 4);
                return roundedInt64(hi32, lo32);
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                var split = divmodInt64(src);
                var buffer = uint8ArrayToBuffer(b);
                buffer.writeUInt32BE(split.hi32, offset);
                buffer.writeUInt32BE(split.lo32, offset + 4);
                return 8;
            }
        }
    ]);
    return NearUInt64BE;
}(Layout);
exports.NearUInt64BE = NearUInt64BE;
/**
 * Represent a signed 64-bit integer in little-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.ns64|ns64}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ var NearInt64 = /*#__PURE__*/ function(Layout) {
    (0, $dcsZi._)(NearInt64, Layout);
    var _super = (0, $ohfOJ._)(NearInt64);
    function NearInt64(property) {
        (0, $4GJKx._)(this, NearInt64);
        return _super.call(this, 8, property);
    }
    (0, $1wc17._)(NearInt64, [
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var buffer = uint8ArrayToBuffer(b);
                var lo32 = buffer.readUInt32LE(offset);
                var hi32 = buffer.readInt32LE(offset + 4);
                return roundedInt64(hi32, lo32);
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                var split = divmodInt64(src);
                var buffer = uint8ArrayToBuffer(b);
                buffer.writeUInt32LE(split.lo32, offset);
                buffer.writeInt32LE(split.hi32, offset + 4);
                return 8;
            }
        }
    ]);
    return NearInt64;
}(Layout);
exports.NearInt64 = NearInt64;
/**
 * Represent a signed 64-bit integer in big-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.ns64be|ns64be}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ var NearInt64BE = /*#__PURE__*/ function(Layout) {
    (0, $dcsZi._)(NearInt64BE, Layout);
    var _super = (0, $ohfOJ._)(NearInt64BE);
    function NearInt64BE(property) {
        (0, $4GJKx._)(this, NearInt64BE);
        return _super.call(this, 8, property);
    }
    (0, $1wc17._)(NearInt64BE, [
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var buffer = uint8ArrayToBuffer(b);
                var hi32 = buffer.readInt32BE(offset);
                var lo32 = buffer.readUInt32BE(offset + 4);
                return roundedInt64(hi32, lo32);
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                var split = divmodInt64(src);
                var buffer = uint8ArrayToBuffer(b);
                buffer.writeInt32BE(split.hi32, offset);
                buffer.writeUInt32BE(split.lo32, offset + 4);
                return 8;
            }
        }
    ]);
    return NearInt64BE;
}(Layout);
exports.NearInt64BE = NearInt64BE;
/**
 * Represent a 32-bit floating point number in little-endian format.
 *
 * *Factory*: {@link module:Layout.f32|f32}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ var Float = /*#__PURE__*/ function(Layout) {
    (0, $dcsZi._)(Float, Layout);
    var _super = (0, $ohfOJ._)(Float);
    function Float(property) {
        (0, $4GJKx._)(this, Float);
        return _super.call(this, 4, property);
    }
    (0, $1wc17._)(Float, [
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                return uint8ArrayToBuffer(b).readFloatLE(offset);
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                uint8ArrayToBuffer(b).writeFloatLE(src, offset);
                return 4;
            }
        }
    ]);
    return Float;
}(Layout);
exports.Float = Float;
/**
 * Represent a 32-bit floating point number in big-endian format.
 *
 * *Factory*: {@link module:Layout.f32be|f32be}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ var FloatBE = /*#__PURE__*/ function(Layout) {
    (0, $dcsZi._)(FloatBE, Layout);
    var _super = (0, $ohfOJ._)(FloatBE);
    function FloatBE(property) {
        (0, $4GJKx._)(this, FloatBE);
        return _super.call(this, 4, property);
    }
    (0, $1wc17._)(FloatBE, [
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                return uint8ArrayToBuffer(b).readFloatBE(offset);
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                uint8ArrayToBuffer(b).writeFloatBE(src, offset);
                return 4;
            }
        }
    ]);
    return FloatBE;
}(Layout);
exports.FloatBE = FloatBE;
/**
 * Represent a 64-bit floating point number in little-endian format.
 *
 * *Factory*: {@link module:Layout.f64|f64}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ var Double = /*#__PURE__*/ function(Layout) {
    (0, $dcsZi._)(Double, Layout);
    var _super = (0, $ohfOJ._)(Double);
    function Double(property) {
        (0, $4GJKx._)(this, Double);
        return _super.call(this, 8, property);
    }
    (0, $1wc17._)(Double, [
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                return uint8ArrayToBuffer(b).readDoubleLE(offset);
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                uint8ArrayToBuffer(b).writeDoubleLE(src, offset);
                return 8;
            }
        }
    ]);
    return Double;
}(Layout);
exports.Double = Double;
/**
 * Represent a 64-bit floating point number in big-endian format.
 *
 * *Factory*: {@link module:Layout.f64be|f64be}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ var DoubleBE = /*#__PURE__*/ function(Layout) {
    (0, $dcsZi._)(DoubleBE, Layout);
    var _super = (0, $ohfOJ._)(DoubleBE);
    function DoubleBE(property) {
        (0, $4GJKx._)(this, DoubleBE);
        return _super.call(this, 8, property);
    }
    (0, $1wc17._)(DoubleBE, [
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                return uint8ArrayToBuffer(b).readDoubleBE(offset);
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                uint8ArrayToBuffer(b).writeDoubleBE(src, offset);
                return 8;
            }
        }
    ]);
    return DoubleBE;
}(Layout);
exports.DoubleBE = DoubleBE;
/**
 * Represent a contiguous sequence of a specific layout as an Array.
 *
 * *Factory*: {@link module:Layout.seq|seq}
 *
 * @param {Layout} elementLayout - initializer for {@link
 * Sequence#elementLayout|elementLayout}.
 *
 * @param {(Number|ExternalLayout)} count - initializer for {@link
 * Sequence#count|count}.  The parameter must be either a positive
 * integer or an instance of {@link ExternalLayout}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ var Sequence = /*#__PURE__*/ function(Layout1) {
    (0, $dcsZi._)(Sequence, Layout1);
    var _super = (0, $ohfOJ._)(Sequence);
    function Sequence(elementLayout, count, property) {
        (0, $4GJKx._)(this, Sequence);
        var _this;
        if (!(elementLayout instanceof Layout)) throw new TypeError("elementLayout must be a Layout");
        if (!(count instanceof ExternalLayout && count.isCount() || Number.isInteger(count) && 0 <= count)) throw new TypeError("count must be non-negative integer or an unsigned integer ExternalLayout");
        var span = -1;
        if (!(count instanceof ExternalLayout) && 0 < elementLayout.span) span = count * elementLayout.span;
        _this = _super.call(this, span, property);
        /** The layout for individual elements of the sequence. */ _this.elementLayout = elementLayout;
        /** The number of elements in the sequence.
         *
         * This will be either a non-negative integer or an instance of
         * {@link ExternalLayout} for which {@link
         * ExternalLayout#isCount|isCount()} is `true`. */ _this.count = count;
        return _this;
    }
    (0, $1wc17._)(Sequence, [
        {
            /** @override */ key: "getSpan",
            value: function getSpan(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                if (0 <= this.span) return this.span;
                var span = 0;
                var count = this.count;
                if (count instanceof ExternalLayout) count = count.decode(b, offset);
                if (0 < this.elementLayout.span) span = count * this.elementLayout.span;
                else {
                    var idx = 0;
                    while(idx < count){
                        span += this.elementLayout.getSpan(b, offset + span);
                        ++idx;
                    }
                }
                return span;
            }
        },
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var rv = [];
                var i = 0;
                var count = this.count;
                if (count instanceof ExternalLayout) count = count.decode(b, offset);
                while(i < count){
                    rv.push(this.elementLayout.decode(b, offset));
                    offset += this.elementLayout.getSpan(b, offset);
                    i += 1;
                }
                return rv;
            }
        },
        {
            /** Implement {@link Layout#encode|encode} for {@link Sequence}.
     *
     * **NOTE** If `src` is shorter than {@link Sequence#count|count} then
     * the unused space in the buffer is left unchanged.  If `src` is
     * longer than {@link Sequence#count|count} the unneeded elements are
     * ignored.
     *
     * **NOTE** If {@link Layout#count|count} is an instance of {@link
     * ExternalLayout} then the length of `src` will be encoded as the
     * count after `src` is encoded. */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                var elo = this.elementLayout;
                var span = src.reduce(function(span, v) {
                    return span + elo.encode(v, b, offset + span);
                }, 0);
                if (this.count instanceof ExternalLayout) this.count.encode(src.length, b, offset);
                return span;
            }
        }
    ]);
    return Sequence;
}(Layout);
exports.Sequence = Sequence;
/**
 * Represent a contiguous sequence of arbitrary layout elements as an
 * Object.
 *
 * *Factory*: {@link module:Layout.struct|struct}
 *
 * **NOTE** The {@link Layout#span|span} of the structure is variable
 * if any layout in {@link Structure#fields|fields} has a variable
 * span.  When {@link Layout#encode|encoding} we must have a value for
 * all variable-length fields, or we wouldn't be able to figure out
 * how much space to use for storage.  We can only identify the value
 * for a field when it has a {@link Layout#property|property}.  As
 * such, although a structure may contain both unnamed fields and
 * variable-length fields, it cannot contain an unnamed
 * variable-length field.
 *
 * @param {Layout[]} fields - initializer for {@link
 * Structure#fields|fields}.  An error is raised if this contains a
 * variable-length field for which a {@link Layout#property|property}
 * is not defined.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @param {Boolean} [decodePrefixes] - initializer for {@link
 * Structure#decodePrefixes|property}.
 *
 * @throws {Error} - if `fields` contains an unnamed variable-length
 * layout.
 *
 * @augments {Layout}
 */ var Structure = /*#__PURE__*/ function(Layout1) {
    (0, $dcsZi._)(Structure, Layout1);
    var _super = (0, $ohfOJ._)(Structure);
    function Structure(fields, property, decodePrefixes) {
        (0, $4GJKx._)(this, Structure);
        var _this;
        if (!(Array.isArray(fields) && fields.reduce(function(acc, v) {
            return acc && v instanceof Layout;
        }, true))) throw new TypeError("fields must be array of Layout instances");
        if ("boolean" === typeof property && undefined === decodePrefixes) {
            decodePrefixes = property;
            property = undefined;
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            /* Verify absence of unnamed variable-length fields. */ for(var _iterator = fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var fd = _step.value;
                if (0 > fd.span && undefined === fd.property) throw new Error("fields cannot contain unnamed variable-length layout");
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var span = -1;
        try {
            span = fields.reduce(function(span, fd) {
                return span + fd.getSpan();
            }, 0);
        } catch (e) {
        // ignore error
        }
        _this = _super.call(this, span, property);
        /** The sequence of {@link Layout} values that comprise the
         * structure.
         *
         * The individual elements need not be the same type, and may be
         * either scalar or aggregate layouts.  If a member layout leaves
         * its {@link Layout#property|property} undefined the
         * corresponding region of the buffer associated with the element
         * will not be mutated.
         *
         * @type {Layout[]} */ _this.fields = fields;
        /** Control behavior of {@link Layout#decode|decode()} given short
         * buffers.
         *
         * In some situations a structure many be extended with additional
         * fields over time, with older installations providing only a
         * prefix of the full structure.  If this property is `true`
         * decoding will accept those buffers and leave subsequent fields
         * undefined, as long as the buffer ends at a field boundary.
         * Defaults to `false`. */ _this.decodePrefixes = !!decodePrefixes;
        return _this;
    }
    (0, $1wc17._)(Structure, [
        {
            /** @override */ key: "getSpan",
            value: function getSpan(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                if (0 <= this.span) return this.span;
                var span = 0;
                try {
                    span = this.fields.reduce(function(span, fd) {
                        var fsp = fd.getSpan(b, offset);
                        offset += fsp;
                        return span + fsp;
                    }, 0);
                } catch (e) {
                    throw new RangeError("indeterminate span");
                }
                return span;
            }
        },
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                checkUint8Array(b);
                var dest = this.makeDestinationObject();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var fd = _step.value;
                        if (undefined !== fd.property) dest[fd.property] = fd.decode(b, offset);
                        offset += fd.getSpan(b, offset);
                        if (this.decodePrefixes && b.length === offset) break;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return dest;
            }
        },
        {
            /** Implement {@link Layout#encode|encode} for {@link Structure}.
     *
     * If `src` is missing a property for a member with a defined {@link
     * Layout#property|property} the corresponding region of the buffer is
     * left unmodified. */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                var firstOffset = offset;
                var lastOffset = 0;
                var lastWrote = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var fd = _step.value;
                        var span = fd.span;
                        lastWrote = 0 < span ? span : 0;
                        if (undefined !== fd.property) {
                            var fv = src[fd.property];
                            if (undefined !== fv) {
                                lastWrote = fd.encode(fv, b, offset);
                                if (0 > span) /* Read the as-encoded span, which is not necessarily the
                         * same as what we wrote. */ span = fd.getSpan(b, offset);
                            }
                        }
                        lastOffset = offset;
                        offset += span;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                /* Use (lastOffset + lastWrote) instead of offset because the last
         * item may have had a dynamic length and we don't want to include
         * the padding between it and the end of the space reserved for
         * it. */ return lastOffset + lastWrote - firstOffset;
            }
        },
        {
            /** @override */ key: "fromArray",
            value: function fromArray(values) {
                var dest = this.makeDestinationObject();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var fd = _step.value;
                        if (undefined !== fd.property && 0 < values.length) dest[fd.property] = values.shift();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return dest;
            }
        },
        {
            /**
     * Get access to the layout of a given property.
     *
     * @param {String} property - the structure member of interest.
     *
     * @return {Layout} - the layout associated with `property`, or
     * undefined if there is no such property.
     */ key: "layoutFor",
            value: function layoutFor(property) {
                if ("string" !== typeof property) throw new TypeError("property must be string");
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var fd = _step.value;
                        if (fd.property === property) return fd;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return undefined;
            }
        },
        {
            /**
     * Get the offset of a structure member.
     *
     * @param {String} property - the structure member of interest.
     *
     * @return {Number} - the offset in bytes to the start of `property`
     * within the structure, or undefined if `property` is not a field
     * within the structure.  If the property is a member but follows a
     * variable-length structure member a negative number will be
     * returned.
     */ key: "offsetOf",
            value: function offsetOf(property) {
                if ("string" !== typeof property) throw new TypeError("property must be string");
                var offset = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var fd = _step.value;
                        if (fd.property === property) return offset;
                        if (0 > fd.span) offset = -1;
                        else if (0 <= offset) offset += fd.span;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return undefined;
            }
        }
    ]);
    return Structure;
}(Layout);
exports.Structure = Structure;
/**
 * An object that can provide a {@link
 * Union#discriminator|discriminator} API for {@link Union}.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support the {@link
 * UnionDiscriminator#encode|encode} or {@link
 * UnionDiscriminator#decode|decode} functions.
 *
 * @param {string} [property] - Default for {@link
 * UnionDiscriminator#property|property}.
 *
 * @abstract
 */ var UnionDiscriminator = /*#__PURE__*/ function() {
    function UnionDiscriminator(property) {
        (0, $4GJKx._)(this, UnionDiscriminator);
        /** The {@link Layout#property|property} to be used when the
         * discriminator is referenced in isolation (generally when {@link
         * Union#decode|Union decode} cannot delegate to a specific
         * variant). */ this.property = property;
    }
    (0, $1wc17._)(UnionDiscriminator, [
        {
            /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
     *
     * The implementation of this method need not reference the buffer if
     * variant information is available through other means. */ key: "decode",
            value: function decode(b, offset) {
                throw new Error("UnionDiscriminator is abstract");
            }
        },
        {
            /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
     *
     * The implementation of this method need not store the value if
     * variant information is maintained through other means. */ key: "encode",
            value: function encode(src, b, offset) {
                throw new Error("UnionDiscriminator is abstract");
            }
        }
    ]);
    return UnionDiscriminator;
}();
exports.UnionDiscriminator = UnionDiscriminator;
/**
 * An object that can provide a {@link
 * UnionDiscriminator|discriminator API} for {@link Union} using an
 * unsigned integral {@link Layout} instance located either inside or
 * outside the union.
 *
 * @param {ExternalLayout} layout - initializes {@link
 * UnionLayoutDiscriminator#layout|layout}.  Must satisfy {@link
 * ExternalLayout#isCount|isCount()}.
 *
 * @param {string} [property] - Default for {@link
 * UnionDiscriminator#property|property}, superseding the property
 * from `layout`, but defaulting to `variant` if neither `property`
 * nor layout provide a property name.
 *
 * @augments {UnionDiscriminator}
 */ var UnionLayoutDiscriminator = /*#__PURE__*/ function(UnionDiscriminator) {
    (0, $dcsZi._)(UnionLayoutDiscriminator, UnionDiscriminator);
    var _super = (0, $ohfOJ._)(UnionLayoutDiscriminator);
    function UnionLayoutDiscriminator(layout, property) {
        (0, $4GJKx._)(this, UnionLayoutDiscriminator);
        var _this;
        if (!(layout instanceof ExternalLayout && layout.isCount())) throw new TypeError("layout must be an unsigned integer ExternalLayout");
        _this = _super.call(this, property || layout.property || "variant");
        /** The {@link ExternalLayout} used to access the discriminator
         * value. */ _this.layout = layout;
        return _this;
    }
    (0, $1wc17._)(UnionLayoutDiscriminator, [
        {
            /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */ key: "decode",
            value: function decode(b, offset) {
                return this.layout.decode(b, offset);
            }
        },
        {
            /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */ key: "encode",
            value: function encode(src, b, offset) {
                return this.layout.encode(src, b, offset);
            }
        }
    ]);
    return UnionLayoutDiscriminator;
}(UnionDiscriminator);
exports.UnionLayoutDiscriminator = UnionLayoutDiscriminator;
/**
 * Represent any number of span-compatible layouts.
 *
 * *Factory*: {@link module:Layout.union|union}
 *
 * If the union has a {@link Union#defaultLayout|default layout} that
 * layout must have a non-negative {@link Layout#span|span}.  The span
 * of a fixed-span union includes its {@link
 * Union#discriminator|discriminator} if the variant is a {@link
 * Union#usesPrefixDiscriminator|prefix of the union}, plus the span
 * of its {@link Union#defaultLayout|default layout}.
 *
 * If the union does not have a default layout then the encoded span
 * of the union depends on the encoded span of its variant (which may
 * be fixed or variable).
 *
 * {@link VariantLayout#layout|Variant layout}s are added through
 * {@link Union#addVariant|addVariant}.  If the union has a default
 * layout, the span of the {@link VariantLayout#layout|layout
 * contained by the variant} must not exceed the span of the {@link
 * Union#defaultLayout|default layout} (minus the span of a {@link
 * Union#usesPrefixDiscriminator|prefix disriminator}, if used).  The
 * span of the variant will equal the span of the union itself.
 *
 * The variant for a buffer can only be identified from the {@link
 * Union#discriminator|discriminator} {@link
 * UnionDiscriminator#property|property} (in the case of the {@link
 * Union#defaultLayout|default layout}), or by using {@link
 * Union#getVariant|getVariant} and examining the resulting {@link
 * VariantLayout} instance.
 *
 * A variant compatible with a JavaScript object can be identified
 * using {@link Union#getSourceVariant|getSourceVariant}.
 *
 * @param {(UnionDiscriminator|ExternalLayout|Layout)} discr - How to
 * identify the layout used to interpret the union contents.  The
 * parameter must be an instance of {@link UnionDiscriminator}, an
 * {@link ExternalLayout} that satisfies {@link
 * ExternalLayout#isCount|isCount()}, or {@link UInt} (or {@link
 * UIntBE}).  When a non-external layout element is passed the layout
 * appears at the start of the union.  In all cases the (synthesized)
 * {@link UnionDiscriminator} instance is recorded as {@link
 * Union#discriminator|discriminator}.
 *
 * @param {(Layout|null)} defaultLayout - initializer for {@link
 * Union#defaultLayout|defaultLayout}.  If absent defaults to `null`.
 * If `null` there is no default layout: the union has data-dependent
 * length and attempts to decode or encode unrecognized variants will
 * throw an exception.  A {@link Layout} instance must have a
 * non-negative {@link Layout#span|span}, and if it lacks a {@link
 * Layout#property|property} the {@link
 * Union#defaultLayout|defaultLayout} will be a {@link
 * Layout#replicate|replica} with property `content`.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ var Union = /*#__PURE__*/ function(Layout1) {
    (0, $dcsZi._)(Union, Layout1);
    var _super = (0, $ohfOJ._)(Union);
    function Union(discr, defaultLayout, property) {
        (0, $4GJKx._)(this, Union);
        var _this;
        var discriminator;
        if (discr instanceof UInt || discr instanceof UIntBE) discriminator = new UnionLayoutDiscriminator(new OffsetLayout(discr));
        else if (discr instanceof ExternalLayout && discr.isCount()) discriminator = new UnionLayoutDiscriminator(discr);
        else if (!(discr instanceof UnionDiscriminator)) throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
        else discriminator = discr;
        if (undefined === defaultLayout) defaultLayout = null;
        if (!(null === defaultLayout || defaultLayout instanceof Layout)) throw new TypeError("defaultLayout must be null or a Layout");
        if (null !== defaultLayout) {
            if (0 > defaultLayout.span) throw new Error("defaultLayout must have constant span");
            if (undefined === defaultLayout.property) defaultLayout = defaultLayout.replicate("content");
        }
        /* The union span can be estimated only if there's a default
         * layout.  The union spans its default layout, plus any prefix
         * variant layout.  By construction both layouts, if present, have
         * non-negative span. */ var span = -1;
        if (defaultLayout) {
            span = defaultLayout.span;
            if (0 <= span && (discr instanceof UInt || discr instanceof UIntBE)) span += discriminator.layout.span;
        }
        _this = _super.call(this, span, property);
        /** The interface for the discriminator value in isolation.
         *
         * This a {@link UnionDiscriminator} either passed to the
         * constructor or synthesized from the `discr` constructor
         * argument.  {@link
         * Union#usesPrefixDiscriminator|usesPrefixDiscriminator} will be
         * `true` iff the `discr` parameter was a non-offset {@link
         * Layout} instance. */ _this.discriminator = discriminator;
        /** `true` if the {@link Union#discriminator|discriminator} is the
         * first field in the union.
         *
         * If `false` the discriminator is obtained from somewhere
         * else. */ _this.usesPrefixDiscriminator = discr instanceof UInt || discr instanceof UIntBE;
        /** The layout for non-discriminator content when the value of the
         * discriminator is not recognized.
         *
         * This is the value passed to the constructor.  It is
         * structurally equivalent to the second component of {@link
         * Union#layout|layout} but may have a different property
         * name. */ _this.defaultLayout = defaultLayout;
        /** A registry of allowed variants.
         *
         * The keys are unsigned integers which should be compatible with
         * {@link Union.discriminator|discriminator}.  The property value
         * is the corresponding {@link VariantLayout} instances assigned
         * to this union by {@link Union#addVariant|addVariant}.
         *
         * **NOTE** The registry remains mutable so that variants can be
         * {@link Union#addVariant|added} at any time.  Users should not
         * manipulate the content of this property. */ _this.registry = {};
        /* Private variable used when invoking getSourceVariant */ var boundGetSourceVariant = _this.defaultGetSourceVariant.bind((0, $d3H5E._)(_this));
        /** Function to infer the variant selected by a source object.
         *
         * Defaults to {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant} but may
         * be overridden using {@link
         * Union#configGetSourceVariant|configGetSourceVariant}.
         *
         * @param {Object} src - as with {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant}.
         *
         * @returns {(undefined|VariantLayout)} The default variant
         * (`undefined`) or first registered variant that uses a property
         * available in `src`. */ _this.getSourceVariant = function(src) {
            return boundGetSourceVariant(src);
        };
        /** Function to override the implementation of {@link
         * Union#getSourceVariant|getSourceVariant}.
         *
         * Use this if the desired variant cannot be identified using the
         * algorithm of {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant}.
         *
         * **NOTE** The provided function will be invoked bound to this
         * Union instance, providing local access to {@link
         * Union#registry|registry}.
         *
         * @param {Function} gsv - a function that follows the API of
         * {@link Union#defaultGetSourceVariant|defaultGetSourceVariant}. */ _this.configGetSourceVariant = function(gsv) {
            boundGetSourceVariant = gsv.bind(this);
        };
        return _this;
    }
    (0, $1wc17._)(Union, [
        {
            /** @override */ key: "getSpan",
            value: function getSpan(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                if (0 <= this.span) return this.span;
                /* Default layouts always have non-negative span, so we don't have
         * one and we have to recognize the variant which will in turn
         * determine the span. */ var vlo = this.getVariant(b, offset);
                if (!vlo) throw new Error("unable to determine span for unrecognized variant");
                return vlo.getSpan(b, offset);
            }
        },
        {
            /**
     * Method to infer a registered Union variant compatible with `src`.
     *
     * The first satisfied rule in the following sequence defines the
     * return value:
     * * If `src` has properties matching the Union discriminator and
     *   the default layout, `undefined` is returned regardless of the
     *   value of the discriminator property (this ensures the default
     *   layout will be used);
     * * If `src` has a property matching the Union discriminator, the
     *   value of the discriminator identifies a registered variant, and
     *   either (a) the variant has no layout, or (b) `src` has the
     *   variant's property, then the variant is returned (because the
     *   source satisfies the constraints of the variant it identifies);
     * * If `src` does not have a property matching the Union
     *   discriminator, but does have a property matching a registered
     *   variant, then the variant is returned (because the source
     *   matches a variant without an explicit conflict);
     * * An error is thrown (because we either can't identify a variant,
     *   or we were explicitly told the variant but can't satisfy it).
     *
     * @param {Object} src - an object presumed to be compatible with
     * the content of the Union.
     *
     * @return {(undefined|VariantLayout)} - as described above.
     *
     * @throws {Error} - if `src` cannot be associated with a default or
     * registered variant.
     */ key: "defaultGetSourceVariant",
            value: function defaultGetSourceVariant(src) {
                if (Object.prototype.hasOwnProperty.call(src, this.discriminator.property)) {
                    if (this.defaultLayout && this.defaultLayout.property && Object.prototype.hasOwnProperty.call(src, this.defaultLayout.property)) return undefined;
                    var vlo = this.registry[src[this.discriminator.property]];
                    if (vlo && (!vlo.layout || vlo.property && Object.prototype.hasOwnProperty.call(src, vlo.property))) return vlo;
                } else for(var tag in this.registry){
                    var vlo1 = this.registry[tag];
                    if (vlo1.property && Object.prototype.hasOwnProperty.call(src, vlo1.property)) return vlo1;
                }
                throw new Error("unable to infer src variant");
            }
        },
        {
            /** Implement {@link Layout#decode|decode} for {@link Union}.
     *
     * If the variant is {@link Union#addVariant|registered} the return
     * value is an instance of that variant, with no explicit
     * discriminator.  Otherwise the {@link Union#defaultLayout|default
     * layout} is used to decode the content. */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var dest;
                var dlo = this.discriminator;
                var discr = dlo.decode(b, offset);
                var clo = this.registry[discr];
                if (undefined === clo) {
                    var defaultLayout = this.defaultLayout;
                    var contentOffset = 0;
                    if (this.usesPrefixDiscriminator) contentOffset = dlo.layout.span;
                    dest = this.makeDestinationObject();
                    dest[dlo.property] = discr;
                    // defaultLayout.property can be undefined, but this is allowed by buffer-layout
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dest[defaultLayout.property] = defaultLayout.decode(b, offset + contentOffset);
                } else dest = clo.decode(b, offset);
                return dest;
            }
        },
        {
            /** Implement {@link Layout#encode|encode} for {@link Union}.
     *
     * This API assumes the `src` object is consistent with the union's
     * {@link Union#defaultLayout|default layout}.  To encode variants
     * use the appropriate variant-specific {@link VariantLayout#encode}
     * method. */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                var vlo = this.getSourceVariant(src);
                if (undefined === vlo) {
                    var dlo = this.discriminator;
                    // this.defaultLayout is not undefined when vlo is undefined
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    var clo = this.defaultLayout;
                    var contentOffset = 0;
                    if (this.usesPrefixDiscriminator) contentOffset = dlo.layout.span;
                    dlo.encode(src[dlo.property], b, offset);
                    // clo.property is not undefined when vlo is undefined
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    return contentOffset + clo.encode(src[clo.property], b, offset + contentOffset);
                }
                return vlo.encode(src, b, offset);
            }
        },
        {
            /** Register a new variant structure within a union.  The newly
     * created variant is returned.
     *
     * @param {Number} variant - initializer for {@link
     * VariantLayout#variant|variant}.
     *
     * @param {Layout} layout - initializer for {@link
     * VariantLayout#layout|layout}.
     *
     * @param {String} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {VariantLayout} */ key: "addVariant",
            value: function addVariant(variant, layout, property) {
                var rv = new VariantLayout(this, variant, layout, property);
                this.registry[variant] = rv;
                return rv;
            }
        },
        {
            /**
     * Get the layout associated with a registered variant.
     *
     * If `vb` does not produce a registered variant the function returns
     * `undefined`.
     *
     * @param {(Number|Uint8Array)} vb - either the variant number, or a
     * buffer from which the discriminator is to be read.
     *
     * @param {Number} offset - offset into `vb` for the start of the
     * union.  Used only when `vb` is an instance of {Uint8Array}.
     *
     * @return {({VariantLayout}|undefined)}
     */ key: "getVariant",
            value: function getVariant(vb) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var variant;
                if (vb instanceof Uint8Array) variant = this.discriminator.decode(vb, offset);
                else variant = vb;
                return this.registry[variant];
            }
        }
    ]);
    return Union;
}(Layout);
exports.Union = Union;
/**
 * Represent a specific variant within a containing union.
 *
 * **NOTE** The {@link Layout#span|span} of the variant may include
 * the span of the {@link Union#discriminator|discriminator} used to
 * identify it, but values read and written using the variant strictly
 * conform to the content of {@link VariantLayout#layout|layout}.
 *
 * **NOTE** User code should not invoke this constructor directly.  Use
 * the union {@link Union#addVariant|addVariant} helper method.
 *
 * @param {Union} union - initializer for {@link
 * VariantLayout#union|union}.
 *
 * @param {Number} variant - initializer for {@link
 * VariantLayout#variant|variant}.
 *
 * @param {Layout} [layout] - initializer for {@link
 * VariantLayout#layout|layout}.  If absent the variant carries no
 * data.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.  Unlike many other layouts, variant
 * layouts normally include a property name so they can be identified
 * within their containing {@link Union}.  The property identifier may
 * be absent only if `layout` is is absent.
 *
 * @augments {Layout}
 */ var VariantLayout = /*#__PURE__*/ function(Layout1) {
    (0, $dcsZi._)(VariantLayout, Layout1);
    var _super = (0, $ohfOJ._)(VariantLayout);
    function VariantLayout(union, variant, layout, property) {
        (0, $4GJKx._)(this, VariantLayout);
        var _this;
        if (!(union instanceof Union)) throw new TypeError("union must be a Union");
        if (!Number.isInteger(variant) || 0 > variant) throw new TypeError("variant must be a (non-negative) integer");
        if ("string" === typeof layout && undefined === property) {
            property = layout;
            layout = null;
        }
        if (layout) {
            if (!(layout instanceof Layout)) throw new TypeError("layout must be a Layout");
            if (null !== union.defaultLayout && 0 <= layout.span && layout.span > union.defaultLayout.span) throw new Error("variant span exceeds span of containing union");
            if ("string" !== typeof property) throw new TypeError("variant must have a String property");
        }
        var span = union.span;
        if (0 > union.span) {
            span = layout ? layout.span : 0;
            if (0 <= span && union.usesPrefixDiscriminator) span += union.discriminator.layout.span;
        }
        _this = _super.call(this, span, property);
        /** The {@link Union} to which this variant belongs. */ _this.union = union;
        /** The unsigned integral value identifying this variant within
         * the {@link Union#discriminator|discriminator} of the containing
         * union. */ _this.variant = variant;
        /** The {@link Layout} to be used when reading/writing the
         * non-discriminator part of the {@link
         * VariantLayout#union|union}.  If `null` the variant carries no
         * data. */ _this.layout = layout || null;
        return _this;
    }
    (0, $1wc17._)(VariantLayout, [
        {
            /** @override */ key: "getSpan",
            value: function getSpan(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                if (0 <= this.span) /* Will be equal to the containing union span if that is not
             * variable. */ return this.span;
                var contentOffset = 0;
                if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
                /* Span is defined solely by the variant (and prefix discriminator) */ var span = 0;
                if (this.layout) span = this.layout.getSpan(b, offset + contentOffset);
                return contentOffset + span;
            }
        },
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var dest = this.makeDestinationObject();
                if (this !== this.union.getVariant(b, offset)) throw new Error("variant mismatch");
                var contentOffset = 0;
                if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
                if (this.layout) dest[this.property] = this.layout.decode(b, offset + contentOffset);
                else if (this.property) dest[this.property] = true;
                else if (this.union.usesPrefixDiscriminator) dest[this.union.discriminator.property] = this.variant;
                return dest;
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                var contentOffset = 0;
                if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
                if (this.layout && !Object.prototype.hasOwnProperty.call(src, this.property)) throw new TypeError("variant lacks property " + this.property);
                this.union.discriminator.encode(this.variant, b, offset);
                var span = contentOffset;
                if (this.layout) {
                    this.layout.encode(src[this.property], b, offset + contentOffset);
                    span += this.layout.getSpan(b, offset + contentOffset);
                    if (0 <= this.union.span && span > this.union.span) throw new Error("encoded variant overruns containing union");
                }
                return span;
            }
        },
        {
            /** Delegate {@link Layout#fromArray|fromArray} to {@link
     * VariantLayout#layout|layout}. */ key: "fromArray",
            value: function fromArray(values) {
                if (this.layout) return this.layout.fromArray(values);
                return undefined;
            }
        }
    ]);
    return VariantLayout;
}(Layout);
exports.VariantLayout = VariantLayout;
/** JavaScript chose to define bitwise operations as operating on
 * signed 32-bit values in 2's complement form, meaning any integer
 * with bit 31 set is going to look negative.  For right shifts that's
 * not a problem, because `>>>` is a logical shift, but for every
 * other bitwise operator we have to compensate for possible negative
 * results. */ function fixBitwiseResult(v) {
    if (0 > v) v += 0x100000000;
    return v;
}
/**
 * Contain a sequence of bit fields as an unsigned integer.
 *
 * *Factory*: {@link module:Layout.bits|bits}
 *
 * This is a container element; within it there are {@link BitField}
 * instances that provide the extracted properties.  The container
 * simply defines the aggregate representation and its bit ordering.
 * The representation is an object containing properties with numeric
 * or {@link Boolean} values.
 *
 * {@link BitField}s are added with the {@link
 * BitStructure#addField|addField} and {@link
 * BitStructure#addBoolean|addBoolean} methods.

 * @param {Layout} word - initializer for {@link
 * BitStructure#word|word}.  The parameter must be an instance of
 * {@link UInt} (or {@link UIntBE}) that is no more than 4 bytes wide.
 *
 * @param {bool} [msb] - `true` if the bit numbering starts at the
 * most significant bit of the containing word; `false` (default) if
 * it starts at the least significant bit of the containing word.  If
 * the parameter at this position is a string and `property` is
 * `undefined` the value of this argument will instead be used as the
 * value of `property`.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ var BitStructure = /*#__PURE__*/ function(Layout) {
    (0, $dcsZi._)(BitStructure, Layout);
    var _super = (0, $ohfOJ._)(BitStructure);
    function BitStructure(word, msb, property) {
        (0, $4GJKx._)(this, BitStructure);
        var _this;
        if (!(word instanceof UInt || word instanceof UIntBE)) throw new TypeError("word must be a UInt or UIntBE layout");
        if ("string" === typeof msb && undefined === property) {
            property = msb;
            msb = false;
        }
        if (4 < word.span) throw new RangeError("word cannot exceed 32 bits");
        _this = _super.call(this, word.span, property);
        /** The layout used for the packed value.  {@link BitField}
         * instances are packed sequentially depending on {@link
         * BitStructure#msb|msb}. */ _this.word = word;
        /** Whether the bit sequences are packed starting at the most
         * significant bit growing down (`true`), or the least significant
         * bit growing up (`false`).
         *
         * **NOTE** Regardless of this value, the least significant bit of
         * any {@link BitField} value is the least significant bit of the
         * corresponding section of the packed value. */ _this.msb = !!msb;
        /** The sequence of {@link BitField} layouts that comprise the
         * packed structure.
         *
         * **NOTE** The array remains mutable to allow fields to be {@link
         * BitStructure#addField|added} after construction.  Users should
         * not manipulate the content of this property.*/ _this.fields = [];
        /* Storage for the value.  Capture a variable instead of using an
         * instance property because we don't want anything to change the
         * value without going through the mutator. */ var value = 0;
        _this._packedSetValue = function(v) {
            value = fixBitwiseResult(v);
            return this;
        };
        _this._packedGetValue = function() {
            return value;
        };
        return _this;
    }
    (0, $1wc17._)(BitStructure, [
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var dest = this.makeDestinationObject();
                var value = this.word.decode(b, offset);
                this._packedSetValue(value);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var fd = _step.value;
                        if (undefined !== fd.property) dest[fd.property] = fd.decode(b);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return dest;
            }
        },
        {
            /** Implement {@link Layout#encode|encode} for {@link BitStructure}.
     *
     * If `src` is missing a property for a member with a defined {@link
     * Layout#property|property} the corresponding region of the packed
     * value is left unmodified.  Unused bits are also left unmodified. */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                var value = this.word.decode(b, offset);
                this._packedSetValue(value);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var fd = _step.value;
                        if (undefined !== fd.property) {
                            var fv = src[fd.property];
                            if (undefined !== fv) fd.encode(fv);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return this.word.encode(this._packedGetValue(), b, offset);
            }
        },
        {
            /** Register a new bitfield with a containing bit structure.  The
     * resulting bitfield is returned.
     *
     * @param {Number} bits - initializer for {@link BitField#bits|bits}.
     *
     * @param {string} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {BitField} */ key: "addField",
            value: function addField(bits, property) {
                var bf = new BitField(this, bits, property);
                this.fields.push(bf);
                return bf;
            }
        },
        {
            /** As with {@link BitStructure#addField|addField} for single-bit
     * fields with `boolean` value representation.
     *
     * @param {string} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {Boolean} */ // `Boolean` conflicts with the native primitive type
            // eslint-disable-next-line @typescript-eslint/ban-types
            key: "addBoolean",
            value: function addBoolean(property) {
                // This is my Boolean, not the Javascript one.
                var bf = new Boolean(this, property);
                this.fields.push(bf);
                return bf;
            }
        },
        {
            /**
     * Get access to the bit field for a given property.
     *
     * @param {String} property - the bit field of interest.
     *
     * @return {BitField} - the field associated with `property`, or
     * undefined if there is no such property.
     */ key: "fieldFor",
            value: function fieldFor(property) {
                if ("string" !== typeof property) throw new TypeError("property must be string");
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var fd = _step.value;
                        if (fd.property === property) return fd;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return undefined;
            }
        }
    ]);
    return BitStructure;
}(Layout);
exports.BitStructure = BitStructure;
/**
 * Represent a sequence of bits within a {@link BitStructure}.
 *
 * All bit field values are represented as unsigned integers.
 *
 * **NOTE** User code should not invoke this constructor directly.
 * Use the container {@link BitStructure#addField|addField} helper
 * method.
 *
 * **NOTE** BitField instances are not instances of {@link Layout}
 * since {@link Layout#span|span} measures 8-bit units.
 *
 * @param {BitStructure} container - initializer for {@link
 * BitField#container|container}.
 *
 * @param {Number} bits - initializer for {@link BitField#bits|bits}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 */ var BitField = /*#__PURE__*/ function() {
    function BitField(container, bits, property) {
        (0, $4GJKx._)(this, BitField);
        if (!(container instanceof BitStructure)) throw new TypeError("container must be a BitStructure");
        if (!Number.isInteger(bits) || 0 >= bits) throw new TypeError("bits must be positive integer");
        var totalBits = 8 * container.span;
        var usedBits = container.fields.reduce(function(sum, fd) {
            return sum + fd.bits;
        }, 0);
        if (bits + usedBits > totalBits) throw new Error("bits too long for span remainder (" + (totalBits - usedBits) + " of " + totalBits + " remain)");
        /** The {@link BitStructure} instance to which this bit field
         * belongs. */ this.container = container;
        /** The span of this value in bits. */ this.bits = bits;
        /** A mask of {@link BitField#bits|bits} bits isolating value bits
         * that fit within the field.
         *
         * That is, it masks a value that has not yet been shifted into
         * position within its containing packed integer. */ this.valueMask = (1 << bits) - 1;
        if (32 === bits) this.valueMask = 0xFFFFFFFF;
        /** The offset of the value within the containing packed unsigned
         * integer.  The least significant bit of the packed value is at
         * offset zero, regardless of bit ordering used. */ this.start = usedBits;
        if (this.container.msb) this.start = totalBits - usedBits - bits;
        /** A mask of {@link BitField#bits|bits} isolating the field value
         * within the containing packed unsigned integer. */ this.wordMask = fixBitwiseResult(this.valueMask << this.start);
        /** The property name used when this bitfield is represented in an
         * Object.
         *
         * Intended to be functionally equivalent to {@link
         * Layout#property}.
         *
         * If left undefined the corresponding span of bits will be
         * treated as padding: it will not be mutated by {@link
         * Layout#encode|encode} nor represented as a property in the
         * decoded Object. */ this.property = property;
    }
    (0, $1wc17._)(BitField, [
        {
            /** Store a value into the corresponding subsequence of the containing
     * bit field. */ key: "decode",
            value: function decode(b, offset) {
                var word = this.container._packedGetValue();
                var wordValue = fixBitwiseResult(word & this.wordMask);
                var value = wordValue >>> this.start;
                return value;
            }
        },
        {
            /** Store a value into the corresponding subsequence of the containing
     * bit field.
     *
     * **NOTE** This is not a specialization of {@link
     * Layout#encode|Layout.encode} and there is no return value. */ key: "encode",
            value: function encode(value) {
                if ("number" !== typeof value || !Number.isInteger(value) || value !== fixBitwiseResult(value & this.valueMask)) throw new TypeError(nameWithProperty("BitField.encode", this) + " value must be integer not exceeding " + this.valueMask);
                var word = this.container._packedGetValue();
                var wordValue = fixBitwiseResult(value << this.start);
                this.container._packedSetValue(fixBitwiseResult(word & ~this.wordMask) | wordValue);
            }
        }
    ]);
    return BitField;
}();
exports.BitField = BitField;
/**
 * Represent a single bit within a {@link BitStructure} as a
 * JavaScript boolean.
 *
 * **NOTE** User code should not invoke this constructor directly.
 * Use the container {@link BitStructure#addBoolean|addBoolean} helper
 * method.
 *
 * @param {BitStructure} container - initializer for {@link
 * BitField#container|container}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {BitField}
 */ /* eslint-disable no-extend-native */ var Boolean = /*#__PURE__*/ function(BitField) {
    (0, $dcsZi._)(Boolean, BitField);
    var _super = (0, $ohfOJ._)(Boolean);
    function Boolean(container, property) {
        (0, $4GJKx._)(this, Boolean);
        return _super.call(this, container, 1, property);
    }
    (0, $1wc17._)(Boolean, [
        {
            /** Override {@link BitField#decode|decode} for {@link Boolean|Boolean}.
     *
     * @returns {boolean} */ key: "decode",
            value: function decode(b, offset) {
                return !!(0, $04RAu._)((0, $b8Rim._)(Boolean.prototype), "decode", this).call(this, b, offset);
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(value) {
                if ("boolean" === typeof value) // BitField requires integer values
                value = +value;
                (0, $04RAu._)((0, $b8Rim._)(Boolean.prototype), "encode", this).call(this, value);
            }
        }
    ]);
    return Boolean;
}(BitField);
exports.Boolean = Boolean;
/* eslint-enable no-extend-native */ /**
 * Contain a fixed-length block of arbitrary data, represented as a
 * Uint8Array.
 *
 * *Factory*: {@link module:Layout.blob|blob}
 *
 * @param {(Number|ExternalLayout)} length - initializes {@link
 * Blob#length|length}.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ var Blob = /*#__PURE__*/ function(Layout) {
    (0, $dcsZi._)(Blob, Layout);
    var _super = (0, $ohfOJ._)(Blob);
    function Blob(length, property) {
        (0, $4GJKx._)(this, Blob);
        var _this;
        if (!(length instanceof ExternalLayout && length.isCount() || Number.isInteger(length) && 0 <= length)) throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
        var span = -1;
        if (!(length instanceof ExternalLayout)) span = length;
        _this = _super.call(this, span, property);
        /** The number of bytes in the blob.
         *
         * This may be a non-negative integer, or an instance of {@link
         * ExternalLayout} that satisfies {@link
         * ExternalLayout#isCount|isCount()}. */ _this.length = length;
        return _this;
    }
    (0, $1wc17._)(Blob, [
        {
            /** @override */ key: "getSpan",
            value: function getSpan(b, offset) {
                var span = this.span;
                if (0 > span) span = this.length.decode(b, offset);
                return span;
            }
        },
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var span = this.span;
                if (0 > span) span = this.length.decode(b, offset);
                return uint8ArrayToBuffer(b).slice(offset, offset + span);
            }
        },
        {
            /** Implement {@link Layout#encode|encode} for {@link Blob}.
     *
     * **NOTE** If {@link Layout#count|count} is an instance of {@link
     * ExternalLayout} then the length of `src` will be encoded as the
     * count after `src` is encoded. */ key: "encode",
            value: function encode(src, b, offset) {
                var span = this.length;
                if (this.length instanceof ExternalLayout) span = src.length;
                if (!(src instanceof Uint8Array && span === src.length)) throw new TypeError(nameWithProperty("Blob.encode", this) + " requires (length " + span + ") Uint8Array as src");
                if (offset + span > b.length) throw new RangeError("encoding overruns Uint8Array");
                var srcBuffer = uint8ArrayToBuffer(src);
                uint8ArrayToBuffer(b).write(srcBuffer.toString("hex"), offset, span, "hex");
                if (this.length instanceof ExternalLayout) this.length.encode(span, b, offset);
                return span;
            }
        }
    ]);
    return Blob;
}(Layout);
exports.Blob = Blob;
/**
 * Contain a `NUL`-terminated UTF8 string.
 *
 * *Factory*: {@link module:Layout.cstr|cstr}
 *
 * **NOTE** Any UTF8 string that incorporates a zero-valued byte will
 * not be correctly decoded by this layout.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ var CString = /*#__PURE__*/ function(Layout) {
    (0, $dcsZi._)(CString, Layout);
    var _super = (0, $ohfOJ._)(CString);
    function CString(property) {
        (0, $4GJKx._)(this, CString);
        return _super.call(this, -1, property);
    }
    (0, $1wc17._)(CString, [
        {
            /** @override */ key: "getSpan",
            value: function getSpan(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                checkUint8Array(b);
                var idx = offset;
                while(idx < b.length && 0 !== b[idx])idx += 1;
                return 1 + idx - offset;
            }
        },
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var span = this.getSpan(b, offset);
                return uint8ArrayToBuffer(b).slice(offset, offset + span - 1).toString("utf-8");
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                /* Must force this to a string, lest it be a number and the
         * "utf8-encoding" below actually allocate a buffer of length
         * src */ if ("string" !== typeof src) src = String(src);
                var srcb = $8dlmd.Buffer.from(src, "utf8");
                var span = srcb.length;
                if (offset + span > b.length) throw new RangeError("encoding overruns Buffer");
                var buffer = uint8ArrayToBuffer(b);
                srcb.copy(buffer, offset);
                buffer[offset + span] = 0;
                return span + 1;
            }
        }
    ]);
    return CString;
}(Layout);
exports.CString = CString;
/**
 * Contain a UTF8 string with implicit length.
 *
 * *Factory*: {@link module:Layout.utf8|utf8}
 *
 * **NOTE** Because the length is implicit in the size of the buffer
 * this layout should be used only in isolation, or in a situation
 * where the length can be expressed by operating on a slice of the
 * containing buffer.
 *
 * @param {Number} [maxSpan] - the maximum length allowed for encoded
 * string content.  If not provided there is no bound on the allowed
 * content.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ var UTF8 = /*#__PURE__*/ function(Layout) {
    (0, $dcsZi._)(UTF8, Layout);
    var _super = (0, $ohfOJ._)(UTF8);
    function UTF8(maxSpan, property) {
        (0, $4GJKx._)(this, UTF8);
        var _this;
        if ("string" === typeof maxSpan && undefined === property) {
            property = maxSpan;
            maxSpan = undefined;
        }
        if (undefined === maxSpan) maxSpan = -1;
        else if (!Number.isInteger(maxSpan)) throw new TypeError("maxSpan must be an integer");
        _this = _super.call(this, -1, property);
        /** The maximum span of the layout in bytes.
         *
         * Positive values are generally expected.  Zero is abnormal.
         * Attempts to encode or decode a value that exceeds this length
         * will throw a `RangeError`.
         *
         * A negative value indicates that there is no bound on the length
         * of the content. */ _this.maxSpan = maxSpan;
        return _this;
    }
    (0, $1wc17._)(UTF8, [
        {
            /** @override */ key: "getSpan",
            value: function getSpan(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                checkUint8Array(b);
                return b.length - offset;
            }
        },
        {
            /** @override */ key: "decode",
            value: function decode(b) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var span = this.getSpan(b, offset);
                if (0 <= this.maxSpan && this.maxSpan < span) throw new RangeError("text length exceeds maxSpan");
                return uint8ArrayToBuffer(b).slice(offset, offset + span).toString("utf-8");
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b) {
                var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                /* Must force this to a string, lest it be a number and the
         * "utf8-encoding" below actually allocate a buffer of length
         * src */ if ("string" !== typeof src) src = String(src);
                var srcb = $8dlmd.Buffer.from(src, "utf8");
                var span = srcb.length;
                if (0 <= this.maxSpan && this.maxSpan < span) throw new RangeError("text length exceeds maxSpan");
                if (offset + span > b.length) throw new RangeError("encoding overruns Buffer");
                srcb.copy(uint8ArrayToBuffer(b), offset);
                return span;
            }
        }
    ]);
    return UTF8;
}(Layout);
exports.UTF8 = UTF8;
/**
 * Contain a constant value.
 *
 * This layout may be used in cases where a JavaScript value can be
 * inferred without an expression in the binary encoding.  An example
 * would be a {@link VariantLayout|variant layout} where the content
 * is implied by the union {@link Union#discriminator|discriminator}.
 *
 * @param {Object|Number|String} value - initializer for {@link
 * Constant#value|value}.  If the value is an object (or array) and
 * the application intends the object to remain unchanged regardless
 * of what is done to values decoded by this layout, the value should
 * be frozen prior passing it to this constructor.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ var Constant = /*#__PURE__*/ function(Layout) {
    (0, $dcsZi._)(Constant, Layout);
    var _super = (0, $ohfOJ._)(Constant);
    function Constant(value, property) {
        (0, $4GJKx._)(this, Constant);
        var _this;
        _this = _super.call(this, 0, property);
        /** The value produced by this constant when the layout is {@link
         * Constant#decode|decoded}.
         *
         * Any JavaScript value including `null` and `undefined` is
         * permitted.
         *
         * **WARNING** If `value` passed in the constructor was not
         * frozen, it is possible for users of decoded values to change
         * the content of the value. */ _this.value = value;
        return _this;
    }
    (0, $1wc17._)(Constant, [
        {
            /** @override */ key: "decode",
            value: function decode(b, offset) {
                return this.value;
            }
        },
        {
            /** @override */ key: "encode",
            value: function encode(src, b, offset) {
                /* Constants take no space */ return 0;
            }
        }
    ]);
    return Constant;
}(Layout);
exports.Constant = Constant;
/** Factory for {@link GreedyCount}. */ exports.greedy = function(elementSpan, property) {
    return new GreedyCount(elementSpan, property);
};
/** Factory for {@link OffsetLayout}. */ exports.offset = function(layout, offset, property) {
    return new OffsetLayout(layout, offset, property);
};
/** Factory for {@link UInt|unsigned int layouts} spanning one
 * byte. */ exports.u8 = function(property) {
    return new UInt(1, property);
};
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning two bytes. */ exports.u16 = function(property) {
    return new UInt(2, property);
};
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning three bytes. */ exports.u24 = function(property) {
    return new UInt(3, property);
};
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning four bytes. */ exports.u32 = function(property) {
    return new UInt(4, property);
};
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning five bytes. */ exports.u40 = function(property) {
    return new UInt(5, property);
};
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning six bytes. */ exports.u48 = function(property) {
    return new UInt(6, property);
};
/** Factory for {@link NearUInt64|little-endian unsigned int
 * layouts} interpreted as Numbers. */ exports.nu64 = function(property) {
    return new NearUInt64(property);
};
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning two bytes. */ exports.u16be = function(property) {
    return new UIntBE(2, property);
};
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning three bytes. */ exports.u24be = function(property) {
    return new UIntBE(3, property);
};
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning four bytes. */ exports.u32be = function(property) {
    return new UIntBE(4, property);
};
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning five bytes. */ exports.u40be = function(property) {
    return new UIntBE(5, property);
};
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning six bytes. */ exports.u48be = function(property) {
    return new UIntBE(6, property);
};
/** Factory for {@link NearUInt64BE|big-endian unsigned int
 * layouts} interpreted as Numbers. */ exports.nu64be = function(property) {
    return new NearUInt64BE(property);
};
/** Factory for {@link Int|signed int layouts} spanning one
 * byte. */ exports.s8 = function(property) {
    return new Int(1, property);
};
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning two bytes. */ exports.s16 = function(property) {
    return new Int(2, property);
};
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning three bytes. */ exports.s24 = function(property) {
    return new Int(3, property);
};
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning four bytes. */ exports.s32 = function(property) {
    return new Int(4, property);
};
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning five bytes. */ exports.s40 = function(property) {
    return new Int(5, property);
};
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning six bytes. */ exports.s48 = function(property) {
    return new Int(6, property);
};
/** Factory for {@link NearInt64|little-endian signed int layouts}
 * interpreted as Numbers. */ exports.ns64 = function(property) {
    return new NearInt64(property);
};
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning two bytes. */ exports.s16be = function(property) {
    return new IntBE(2, property);
};
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning three bytes. */ exports.s24be = function(property) {
    return new IntBE(3, property);
};
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning four bytes. */ exports.s32be = function(property) {
    return new IntBE(4, property);
};
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning five bytes. */ exports.s40be = function(property) {
    return new IntBE(5, property);
};
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning six bytes. */ exports.s48be = function(property) {
    return new IntBE(6, property);
};
/** Factory for {@link NearInt64BE|big-endian signed int layouts}
 * interpreted as Numbers. */ exports.ns64be = function(property) {
    return new NearInt64BE(property);
};
/** Factory for {@link Float|little-endian 32-bit floating point} values. */ exports.f32 = function(property) {
    return new Float(property);
};
/** Factory for {@link FloatBE|big-endian 32-bit floating point} values. */ exports.f32be = function(property) {
    return new FloatBE(property);
};
/** Factory for {@link Double|little-endian 64-bit floating point} values. */ exports.f64 = function(property) {
    return new Double(property);
};
/** Factory for {@link DoubleBE|big-endian 64-bit floating point} values. */ exports.f64be = function(property) {
    return new DoubleBE(property);
};
/** Factory for {@link Structure} values. */ exports.struct = function(fields, property, decodePrefixes) {
    return new Structure(fields, property, decodePrefixes);
};
/** Factory for {@link BitStructure} values. */ exports.bits = function(word, msb, property) {
    return new BitStructure(word, msb, property);
};
/** Factory for {@link Sequence} values. */ exports.seq = function(elementLayout, count, property) {
    return new Sequence(elementLayout, count, property);
};
/** Factory for {@link Union} values. */ exports.union = function(discr, defaultLayout, property) {
    return new Union(discr, defaultLayout, property);
};
/** Factory for {@link UnionLayoutDiscriminator} values. */ exports.unionLayoutDiscriminator = function(layout, property) {
    return new UnionLayoutDiscriminator(layout, property);
};
/** Factory for {@link Blob} values. */ exports.blob = function(length, property) {
    return new Blob(length, property);
};
/** Factory for {@link CString} values. */ exports.cstr = function(property) {
    return new CString(property);
};
/** Factory for {@link UTF8} values. */ exports.utf8 = function(maxSpan, property) {
    return new UTF8(maxSpan, property);
};
/** Factory for {@link Constant} values. */ exports.constant = function(value, property) {
    return new Constant(value, property);
};

});

parcelRegister("hgOwg", function(module, exports) {

var $8dlmd = parcelRequire("8dlmd");
var $c92b1e6094c5c064$require$Buffer = $8dlmd.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c92b1e6094c5c064$var$converter;
/**
 * Convert a little-endian buffer into a BigInt.
 * @param buf The little-endian buffer to convert
 * @returns A BigInt with the little-endian representation of buf.
 */ function $c92b1e6094c5c064$var$toBigIntLE(buf) {
    {
        var reversed = $c92b1e6094c5c064$require$Buffer.from(buf);
        reversed.reverse();
        var hex = reversed.toString("hex");
        if (hex.length === 0) return BigInt(0);
        return BigInt("0x".concat(hex));
    }
    return $c92b1e6094c5c064$var$converter.toBigInt(buf, false);
}
module.exports.toBigIntLE = $c92b1e6094c5c064$var$toBigIntLE;
/**
 * Convert a big-endian buffer into a BigInt
 * @param buf The big-endian buffer to convert.
 * @returns A BigInt with the big-endian representation of buf.
 */ function $c92b1e6094c5c064$var$toBigIntBE(buf) {
    {
        var hex = buf.toString("hex");
        if (hex.length === 0) return BigInt(0);
        return BigInt("0x".concat(hex));
    }
    return $c92b1e6094c5c064$var$converter.toBigInt(buf, true);
}
module.exports.toBigIntBE = $c92b1e6094c5c064$var$toBigIntBE;
/**
 * Convert a BigInt to a little-endian buffer.
 * @param num   The BigInt to convert.
 * @param width The number of bytes that the resulting buffer should be.
 * @returns A little-endian buffer representation of num.
 */ function $c92b1e6094c5c064$var$toBufferLE(num, width) {
    {
        var hex = num.toString(16);
        var buffer = $c92b1e6094c5c064$require$Buffer.from(hex.padStart(width * 2, "0").slice(0, width * 2), "hex");
        buffer.reverse();
        return buffer;
    }
    // Allocation is done here, since it is slower using napi in C
    return $c92b1e6094c5c064$var$converter.fromBigInt(num, $c92b1e6094c5c064$require$Buffer.allocUnsafe(width), false);
}
module.exports.toBufferLE = $c92b1e6094c5c064$var$toBufferLE;
/**
 * Convert a BigInt to a big-endian buffer.
 * @param num   The BigInt to convert.
 * @param width The number of bytes that the resulting buffer should be.
 * @returns A big-endian buffer representation of num.
 */ function $c92b1e6094c5c064$var$toBufferBE(num, width) {
    {
        var hex = num.toString(16);
        return $c92b1e6094c5c064$require$Buffer.from(hex.padStart(width * 2, "0").slice(0, width * 2), "hex");
    }
    return $c92b1e6094c5c064$var$converter.fromBigInt(num, $c92b1e6094c5c064$require$Buffer.allocUnsafe(width), true);
}
module.exports.toBufferBE = $c92b1e6094c5c064$var$toBufferBE;

});

parcelRegister("58xNN", function(module, exports) {

$parcel$export(module.exports, "assert", function () { return assert; });
$parcel$export(module.exports, "create", function () { return create; });
$parcel$export(module.exports, "type", function () { return type; });
$parcel$export(module.exports, "optional", function () { return optional; });
$parcel$export(module.exports, "any", function () { return any; });
$parcel$export(module.exports, "array", function () { return array; });
$parcel$export(module.exports, "boolean", function () { return boolean; });
$parcel$export(module.exports, "instance", function () { return instance; });
$parcel$export(module.exports, "literal", function () { return literal; });
$parcel$export(module.exports, "nullable", function () { return nullable; });
$parcel$export(module.exports, "number", function () { return number; });
$parcel$export(module.exports, "record", function () { return record; });
$parcel$export(module.exports, "string", function () { return string; });
$parcel$export(module.exports, "tuple", function () { return tuple; });
$parcel$export(module.exports, "union", function () { return union; });
$parcel$export(module.exports, "unknown", function () { return unknown; });
$parcel$export(module.exports, "coerce", function () { return coerce; });
/**
 * A `StructFailure` represents a single specific failure in validation.
 */ /**
 * `StructError` objects are thrown (or returned) when validation fails.
 *
 * Validation logic is design to exit early for maximum performance. The error
 * represents the first error encountered during validation. For more detail,
 * the `error.failures` property is a generator function that can be run to
 * continue validation and receive all the failures in the data.
 */ 
var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");

var $cv9Rk = parcelRequire("cv9Rk");

var $gdHfP = parcelRequire("gdHfP");

var $c6Xmf = parcelRequire("c6Xmf");

var $l0HdX = parcelRequire("l0HdX");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");

var $eha6O = parcelRequire("eha6O");
var StructError = /*#__PURE__*/ function(TypeError1) {
    "use strict";
    (0, $dcsZi._)(StructError, TypeError1);
    var _super = (0, $ohfOJ._)(StructError);
    function StructError(failure, failures) {
        (0, $4GJKx._)(this, StructError);
        var _this;
        var cached;
        var message = failure.message, explanation = failure.explanation, rest = (0, $dRLPW._)(failure, [
            "message",
            "explanation"
        ]);
        var path = failure.path;
        var msg = path.length === 0 ? message : "At path: ".concat(path.join("."), " -- ").concat(message);
        _this = _super.call(this, explanation !== null && explanation !== void 0 ? explanation : msg);
        if (explanation != null) _this.cause = msg;
        Object.assign((0, $d3H5E._)(_this), rest);
        _this.name = _this.constructor.name;
        _this.failures = function() {
            return cached !== null && cached !== void 0 ? cached : cached = [
                failure
            ].concat((0, $c6Xmf._)(failures()));
        };
        return _this;
    }
    return StructError;
}((0, $FuVm8._)(TypeError));
/**
 * Check if a value is an iterator.
 */ function isIterable(x) {
    return isObject(x) && typeof x[Symbol.iterator] === "function";
}
/**
 * Check if a value is a plain object.
 */ function isObject(x) {
    return typeof x === "object" && x != null;
}
/**
 * Check if a value is a non-array object.
 */ function isNonArrayObject(x) {
    return isObject(x) && !Array.isArray(x);
}
/**
 * Check if a value is a plain object.
 */ function isPlainObject(x) {
    if (Object.prototype.toString.call(x) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(x);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Return a value as a printable string.
 */ function print(value) {
    if ((typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value)) === "symbol") return value.toString();
    return typeof value === "string" ? JSON.stringify(value) : "".concat(value);
}
/**
 * Shifts (removes and returns) the first value from the `input` iterator.
 * Like `Array.prototype.shift()` but for an `Iterator`.
 */ function shiftIterator(input) {
    var _input_next = input.next(), done = _input_next.done, value = _input_next.value;
    return done ? undefined : value;
}
/**
 * Convert a single validation result to a failure.
 */ function toFailure(result, context, struct, value) {
    if (result === true) return;
    else if (result === false) result = {};
    else if (typeof result === "string") result = {
        message: result
    };
    var path = context.path, branch = context.branch;
    var type = struct.type;
    var refinement = result.refinement, _result_message = result.message, message = _result_message === void 0 ? "Expected a value of type `".concat(type, "`").concat(refinement ? " with refinement `".concat(refinement, "`") : "", ", but received: `").concat(print(value), "`") : _result_message;
    return (0, $cxjpp._)((0, $do9pw._)({
        value: value,
        type: type,
        refinement: refinement,
        key: path[path.length - 1],
        path: path,
        branch: branch
    }, result), {
        message: message
    });
}
/**
 * Convert a validation result to an iterable of failures.
 */ function toFailures(result, context, struct, value) {
    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, r, failure, err;
    return (0, $eha6O.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                if (!isIterable(result)) result = [
                    result
                ];
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    6,
                    7,
                    8
                ]);
                _iterator = result[Symbol.iterator]();
                _state.label = 2;
            case 2:
                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                    3,
                    5
                ];
                r = _step.value;
                failure = toFailure(r, context, struct, value);
                if (!failure) return [
                    3,
                    4
                ];
                return [
                    4,
                    failure
                ];
            case 3:
                _state.sent();
                _state.label = 4;
            case 4:
                _iteratorNormalCompletion = true;
                return [
                    3,
                    2
                ];
            case 5:
                return [
                    3,
                    8
                ];
            case 6:
                err = _state.sent();
                _didIteratorError = true;
                _iteratorError = err;
                return [
                    3,
                    8
                ];
            case 7:
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
                return [
                    7
                ];
            case 8:
                return [
                    2
                ];
        }
    });
}
/**
 * Check a value against a struct, traversing deeply into nested values, and
 * returning an iterator of failures or success.
 */ function run(value, struct) {
    var options, _options_path, path, _options_branch, branch, _options_coerce, coerce, _options_mask, mask, ctx, status, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, failure, err, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, _step_value, k, v, s, ts, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, t, err, err, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, failure1, err;
    var _arguments = arguments;
    return (0, $eha6O.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                options = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
                _options_path = options.path, path = _options_path === void 0 ? [] : _options_path, _options_branch = options.branch, branch = _options_branch === void 0 ? [
                    value
                ] : _options_branch, _options_coerce = options.coerce, coerce = _options_coerce === void 0 ? false : _options_coerce, _options_mask = options.mask, mask = _options_mask === void 0 ? false : _options_mask;
                ctx = {
                    path: path,
                    branch: branch,
                    mask: mask
                };
                if (coerce) value = struct.coercer(value, ctx);
                status = "valid";
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    6,
                    7,
                    8
                ]);
                _iterator = struct.validator(value, ctx)[Symbol.iterator]();
                _state.label = 2;
            case 2:
                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                    3,
                    5
                ];
                failure = _step.value;
                failure.explanation = options.message;
                status = "not_valid";
                return [
                    4,
                    [
                        failure,
                        undefined
                    ]
                ];
            case 3:
                _state.sent();
                _state.label = 4;
            case 4:
                _iteratorNormalCompletion = true;
                return [
                    3,
                    2
                ];
            case 5:
                return [
                    3,
                    8
                ];
            case 6:
                err = _state.sent();
                _didIteratorError = true;
                _iteratorError = err;
                return [
                    3,
                    8
                ];
            case 7:
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
                return [
                    7
                ];
            case 8:
                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                _state.label = 9;
            case 9:
                _state.trys.push([
                    9,
                    21,
                    22,
                    23
                ]);
                _iterator1 = struct.entries(value, ctx)[Symbol.iterator]();
                _state.label = 10;
            case 10:
                if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                    3,
                    20
                ];
                _step_value = (0, $cv9Rk._)(_step1.value, 3), k = _step_value[0], v = _step_value[1], s = _step_value[2];
                ts = run(v, s, {
                    path: k === undefined ? path : (0, $c6Xmf._)(path).concat([
                        k
                    ]),
                    branch: k === undefined ? branch : (0, $c6Xmf._)(branch).concat([
                        v
                    ]),
                    coerce: coerce,
                    mask: mask,
                    message: options.message
                });
                _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                _state.label = 11;
            case 11:
                _state.trys.push([
                    11,
                    17,
                    18,
                    19
                ]);
                _iterator2 = ts[Symbol.iterator]();
                _state.label = 12;
            case 12:
                if (!!(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done)) return [
                    3,
                    16
                ];
                t = _step2.value;
                if (!t[0]) return [
                    3,
                    14
                ];
                status = t[0].refinement != null ? "not_refined" : "not_valid";
                return [
                    4,
                    [
                        t[0],
                        undefined
                    ]
                ];
            case 13:
                _state.sent();
                return [
                    3,
                    15
                ];
            case 14:
                if (coerce) {
                    v = t[1];
                    if (k === undefined) value = v;
                    else if (value instanceof Map) value.set(k, v);
                    else if (value instanceof Set) value.add(v);
                    else if (isObject(value)) {
                        if (v !== undefined || k in value) value[k] = v;
                    }
                }
                _state.label = 15;
            case 15:
                _iteratorNormalCompletion2 = true;
                return [
                    3,
                    12
                ];
            case 16:
                return [
                    3,
                    19
                ];
            case 17:
                err = _state.sent();
                _didIteratorError2 = true;
                _iteratorError2 = err;
                return [
                    3,
                    19
                ];
            case 18:
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
                return [
                    7
                ];
            case 19:
                _iteratorNormalCompletion1 = true;
                return [
                    3,
                    10
                ];
            case 20:
                return [
                    3,
                    23
                ];
            case 21:
                err = _state.sent();
                _didIteratorError1 = true;
                _iteratorError1 = err;
                return [
                    3,
                    23
                ];
            case 22:
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
                return [
                    7
                ];
            case 23:
                _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                if (!(status !== "not_valid")) return [
                    3,
                    31
                ];
                _state.label = 24;
            case 24:
                _state.trys.push([
                    24,
                    29,
                    30,
                    31
                ]);
                _iterator3 = struct.refiner(value, ctx)[Symbol.iterator]();
                _state.label = 25;
            case 25:
                if (!!(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done)) return [
                    3,
                    28
                ];
                failure1 = _step3.value;
                failure1.explanation = options.message;
                status = "not_refined";
                return [
                    4,
                    [
                        failure1,
                        undefined
                    ]
                ];
            case 26:
                _state.sent();
                _state.label = 27;
            case 27:
                _iteratorNormalCompletion3 = true;
                return [
                    3,
                    25
                ];
            case 28:
                return [
                    3,
                    31
                ];
            case 29:
                err = _state.sent();
                _didIteratorError3 = true;
                _iteratorError3 = err;
                return [
                    3,
                    31
                ];
            case 30:
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                        _iterator3.return();
                    }
                } finally{
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
                return [
                    7
                ];
            case 31:
                if (!(status === "valid")) return [
                    3,
                    33
                ];
                return [
                    4,
                    [
                        undefined,
                        value
                    ]
                ];
            case 32:
                _state.sent();
                _state.label = 33;
            case 33:
                return [
                    2
                ];
        }
    });
}
/**
 * `Struct` objects encapsulate the validation logic for a specific type of
 * values. Once constructed, you use the `assert`, `is` or `validate` helpers to
 * validate unknown input data against the struct.
 */ var Struct = /*#__PURE__*/ function() {
    "use strict";
    function Struct(props) {
        var _this = this;
        (0, $4GJKx._)(this, Struct);
        var type = props.type, schema = props.schema, validator = props.validator, refiner = props.refiner, _props_coercer = props.coercer, coercer = _props_coercer === void 0 ? function(value) {
            return value;
        } : _props_coercer, _props_entries = props.entries, entries = _props_entries === void 0 ? function() {
            return (0, $eha6O.__generator)(this, function(_state) {
                return [
                    2
                ];
            });
        } : _props_entries;
        this.type = type;
        this.schema = schema;
        this.entries = entries;
        this.coercer = coercer;
        if (validator) this.validator = function(value, context) {
            var result = validator(value, context);
            return toFailures(result, context, _this, value);
        };
        else this.validator = function() {
            return [];
        };
        if (refiner) this.refiner = function(value, context) {
            var result = refiner(value, context);
            return toFailures(result, context, _this, value);
        };
        else this.refiner = function() {
            return [];
        };
    }
    (0, $1wc17._)(Struct, [
        {
            /**
     * Assert that a value passes the struct's validation, throwing if it doesn't.
     */ key: "assert",
            value: function assert1(value, message) {
                return assert(value, this, message);
            }
        },
        {
            /**
     * Create a value with the struct's coercion logic, then validate it.
     */ key: "create",
            value: function create1(value, message) {
                return create(value, this, message);
            }
        },
        {
            /**
     * Check if a value passes the struct's validation.
     */ key: "is",
            value: function is1(value) {
                return is(value, this);
            }
        },
        {
            /**
     * Mask a value, coercing and validating it, but returning only the subset of
     * properties defined by the struct's schema. Masking applies recursively to
     * props of `object` structs only.
     */ key: "mask",
            value: function mask1(value, message) {
                return mask(value, this, message);
            }
        },
        {
            /**
     * Validate a value with the struct's validation logic, returning a tuple
     * representing the result.
     *
     * You may optionally pass `true` for the `coerce` argument to coerce
     * the value before attempting to validate it. If you do, the result will
     * contain the coerced result when successful. Also, `mask` will turn on
     * masking of the unknown `object` props recursively if passed.
     */ key: "validate",
            value: function validate1(value) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return validate(value, this, options);
            }
        }
    ]);
    return Struct;
}();
/**
 * Assert that a value passes a struct, throwing if it doesn't.
 */ function assert(value, struct, message) {
    var result = validate(value, struct, {
        message: message
    });
    if (result[0]) throw result[0];
}
/**
 * Create a value with the coercion logic of struct and validate it.
 */ function create(value, struct, message) {
    var result = validate(value, struct, {
        coerce: true,
        message: message
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Mask a value, returning only the subset of properties defined by a struct.
 */ function mask(value, struct, message) {
    var result = validate(value, struct, {
        coerce: true,
        mask: true,
        message: message
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Check if a value passes a struct.
 */ function is(value, struct) {
    var result = validate(value, struct);
    return !result[0];
}
/**
 * Validate a value against a struct, returning an error if invalid, or the
 * value (with potential coercion) if valid.
 */ function validate(value, struct) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var tuples = run(value, struct, options);
    var tuple = shiftIterator(tuples);
    if (tuple[0]) {
        var error = new StructError(tuple[0], function() {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, t, err;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = tuples[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        t = _step.value;
                        if (!t[0]) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            t[0]
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return [
            error,
            undefined
        ];
    } else {
        var v = tuple[1];
        return [
            undefined,
            v
        ];
    }
}
function assign() {
    for(var _len = arguments.length, Structs = new Array(_len), _key = 0; _key < _len; _key++){
        Structs[_key] = arguments[_key];
    }
    var _Object;
    var isType = Structs[0].type === "type";
    var schemas = Structs.map(function(s) {
        return s.schema;
    });
    var schema = (_Object = Object).assign.apply(_Object, [
        {}
    ].concat((0, $c6Xmf._)(schemas)));
    return isType ? type(schema) : object(schema);
}
/**
 * Define a new struct type with a custom validation function.
 */ function define(name, validator) {
    return new Struct({
        type: name,
        schema: null,
        validator: validator
    });
}
/**
 * Create a new struct based on an existing struct, but the value is allowed to
 * be `undefined`. `log` will be called if the value is not `undefined`.
 */ function deprecated(struct, log) {
    return new Struct((0, $cxjpp._)((0, $do9pw._)({}, struct), {
        refiner: function(value, ctx) {
            return value === undefined || struct.refiner(value, ctx);
        },
        validator: function(value, ctx) {
            if (value === undefined) return true;
            else {
                log(value, ctx);
                return struct.validator(value, ctx);
            }
        }
    }));
}
/**
 * Create a struct with dynamic validation logic.
 *
 * The callback will receive the value currently being validated, and must
 * return a struct object to validate it with. This can be useful to model
 * validation logic that changes based on its input.
 */ function dynamic(fn) {
    return new Struct({
        type: "dynamic",
        schema: null,
        entries: function(value, ctx) {
            var struct;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        struct = fn(value, ctx);
                        return [
                            5,
                            (0, $eha6O.__values)(struct.entries(value, ctx))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        },
        validator: function(value, ctx) {
            var struct = fn(value, ctx);
            return struct.validator(value, ctx);
        },
        coercer: function(value, ctx) {
            var struct = fn(value, ctx);
            return struct.coercer(value, ctx);
        },
        refiner: function(value, ctx) {
            var struct = fn(value, ctx);
            return struct.refiner(value, ctx);
        }
    });
}
/**
 * Create a struct with lazily evaluated validation logic.
 *
 * The first time validation is run with the struct, the callback will be called
 * and must return a struct object to use. This is useful for cases where you
 * want to have self-referential structs for nested data structures to avoid a
 * circular definition problem.
 */ function lazy(fn) {
    var struct;
    return new Struct({
        type: "lazy",
        schema: null,
        entries: function(value, ctx) {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        struct !== null && struct !== void 0 ? struct : struct = fn();
                        return [
                            5,
                            (0, $eha6O.__values)(struct.entries(value, ctx))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        },
        validator: function(value, ctx) {
            struct !== null && struct !== void 0 ? struct : struct = fn();
            return struct.validator(value, ctx);
        },
        coercer: function(value, ctx) {
            struct !== null && struct !== void 0 ? struct : struct = fn();
            return struct.coercer(value, ctx);
        },
        refiner: function(value, ctx) {
            struct !== null && struct !== void 0 ? struct : struct = fn();
            return struct.refiner(value, ctx);
        }
    });
}
/**
 * Create a new struct based on an existing object struct, but excluding
 * specific properties.
 *
 * Like TypeScript's `Omit` utility.
 */ function omit(struct, keys) {
    var schema = struct.schema;
    var subschema = (0, $do9pw._)({}, schema);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            delete subschema[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    switch(struct.type){
        case "type":
            return type(subschema);
        default:
            return object(subschema);
    }
}
/**
 * Create a new struct based on an existing object struct, but with all of its
 * properties allowed to be `undefined`.
 *
 * Like TypeScript's `Partial` utility.
 */ function partial(struct) {
    var isStruct = struct instanceof Struct;
    var schema = isStruct ? (0, $do9pw._)({}, struct.schema) : (0, $do9pw._)({}, struct);
    for(var key in schema)schema[key] = optional(schema[key]);
    if (isStruct && struct.type === "type") return type(schema);
    return object(schema);
}
/**
 * Create a new struct based on an existing object struct, but only including
 * specific properties.
 *
 * Like TypeScript's `Pick` utility.
 */ function pick(struct, keys) {
    var schema = struct.schema;
    var subschema = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            subschema[key] = schema[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    switch(struct.type){
        case "type":
            return type(subschema);
        default:
            return object(subschema);
    }
}
/**
 * Define a new struct type with a custom validation function.
 *
 * @deprecated This function has been renamed to `define`.
 */ function struct(name, validator) {
    console.warn("superstruct@0.11 - The `struct` helper has been renamed to `define`.");
    return define(name, validator);
}
/**
 * Ensure that any value passes validation.
 */ function any() {
    return define("any", function() {
        return true;
    });
}
function array(Element) {
    return new Struct({
        type: "array",
        schema: Element,
        entries: function(value) {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, i, v, err;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if (!(Element && Array.isArray(value))) return [
                            3,
                            8
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = value.entries()[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        _step_value = (0, $cv9Rk._)(_step.value, 2), i = _step_value[0], v = _step_value[1];
                        return [
                            4,
                            [
                                i,
                                v,
                                Element
                            ]
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        },
        coercer: function(value) {
            return Array.isArray(value) ? value.slice() : value;
        },
        validator: function(value) {
            return Array.isArray(value) || "Expected an array value, but received: ".concat(print(value));
        }
    });
}
/**
 * Ensure that a value is a bigint.
 */ function bigint() {
    return define("bigint", function(value) {
        return (typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value)) === "bigint";
    });
}
/**
 * Ensure that a value is a boolean.
 */ function boolean() {
    return define("boolean", function(value) {
        return typeof value === "boolean";
    });
}
/**
 * Ensure that a value is a valid `Date`.
 *
 * Note: this also ensures that the value is *not* an invalid `Date` object,
 * which can occur when parsing a date fails but still returns a `Date`.
 */ function date() {
    return define("date", function(value) {
        return value instanceof Date && !isNaN(value.getTime()) || "Expected a valid `Date` object, but received: ".concat(print(value));
    });
}
function enums(values) {
    var schema = {};
    var description = values.map(function(v) {
        return print(v);
    }).join();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            schema[key] = key;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return new Struct({
        type: "enums",
        schema: schema,
        validator: function(value) {
            return values.includes(value) || "Expected one of `".concat(description, "`, but received: ").concat(print(value));
        }
    });
}
/**
 * Ensure that a value is a function.
 */ function func() {
    return define("func", function(value) {
        return typeof value === "function" || "Expected a function, but received: ".concat(print(value));
    });
}
/**
 * Ensure that a value is an instance of a specific class.
 */ function instance(Class) {
    return define("instance", function(value) {
        return value instanceof Class || "Expected a `".concat(Class.name, "` instance, but received: ").concat(print(value));
    });
}
/**
 * Ensure that a value is an integer.
 */ function integer() {
    return define("integer", function(value) {
        return typeof value === "number" && !isNaN(value) && Number.isInteger(value) || "Expected an integer, but received: ".concat(print(value));
    });
}
/**
 * Ensure that a value matches all of a set of types.
 */ function intersection(Structs) {
    return new Struct({
        type: "intersection",
        schema: null,
        entries: function(value, ctx) {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, S, err;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = Structs[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        S = _step.value;
                        return [
                            5,
                            (0, $eha6O.__values)(S.entries(value, ctx))
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        },
        validator: function(value, ctx) {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, S, err;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = Structs[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        S = _step.value;
                        return [
                            5,
                            (0, $eha6O.__values)(S.validator(value, ctx))
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        },
        refiner: function(value, ctx) {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, S, err;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = Structs[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        S = _step.value;
                        return [
                            5,
                            (0, $eha6O.__values)(S.refiner(value, ctx))
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        }
    });
}
function literal(constant) {
    var description = print(constant);
    var t = typeof constant === "undefined" ? "undefined" : (0, $l0HdX._)(constant);
    return new Struct({
        type: "literal",
        schema: t === "string" || t === "number" || t === "boolean" ? constant : null,
        validator: function(value) {
            return value === constant || "Expected the literal `".concat(description, "`, but received: ").concat(print(value));
        }
    });
}
function map(Key, Value) {
    return new Struct({
        type: "map",
        schema: null,
        entries: function(value) {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, k, v, err;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if (!(Key && Value && value instanceof Map)) return [
                            3,
                            9
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            9
                        ]);
                        _iterator = value.entries()[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            6
                        ];
                        _step_value = (0, $cv9Rk._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                        return [
                            4,
                            [
                                k,
                                k,
                                Key
                            ]
                        ];
                    case 3:
                        _state.sent();
                        return [
                            4,
                            [
                                k,
                                v,
                                Value
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            9
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            9
                        ];
                    case 8:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 9:
                        return [
                            2
                        ];
                }
            });
        },
        coercer: function(value) {
            return value instanceof Map ? new Map(value) : value;
        },
        validator: function(value) {
            return value instanceof Map || "Expected a `Map` object, but received: ".concat(print(value));
        }
    });
}
/**
 * Ensure that no value ever passes validation.
 */ function never() {
    return define("never", function() {
        return false;
    });
}
/**
 * Augment an existing struct to allow `null` values.
 */ function nullable(struct) {
    return new Struct((0, $cxjpp._)((0, $do9pw._)({}, struct), {
        validator: function(value, ctx) {
            return value === null || struct.validator(value, ctx);
        },
        refiner: function(value, ctx) {
            return value === null || struct.refiner(value, ctx);
        }
    }));
}
/**
 * Ensure that a value is a number.
 */ function number() {
    return define("number", function(value) {
        return typeof value === "number" && !isNaN(value) || "Expected a number, but received: ".concat(print(value));
    });
}
function object(schema) {
    var knowns = schema ? Object.keys(schema) : [];
    var Never = never();
    return new Struct({
        type: "object",
        schema: schema ? schema : null,
        entries: function(value) {
            var unknowns, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key, err, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, key1, err;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(schema && isObject(value))) return [
                            3,
                            16
                        ];
                        unknowns = new Set(Object.keys(value));
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = knowns[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        key = _step.value;
                        unknowns.delete(key);
                        return [
                            4,
                            [
                                key,
                                value[key],
                                schema[key]
                            ]
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        _state.label = 9;
                    case 9:
                        _state.trys.push([
                            9,
                            14,
                            15,
                            16
                        ]);
                        _iterator1 = unknowns[Symbol.iterator]();
                        _state.label = 10;
                    case 10:
                        if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                            3,
                            13
                        ];
                        key1 = _step1.value;
                        return [
                            4,
                            [
                                key1,
                                value[key1],
                                Never
                            ]
                        ];
                    case 11:
                        _state.sent();
                        _state.label = 12;
                    case 12:
                        _iteratorNormalCompletion1 = true;
                        return [
                            3,
                            10
                        ];
                    case 13:
                        return [
                            3,
                            16
                        ];
                    case 14:
                        err = _state.sent();
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                        return [
                            3,
                            16
                        ];
                    case 15:
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                        return [
                            7
                        ];
                    case 16:
                        return [
                            2
                        ];
                }
            });
        },
        validator: function(value) {
            return isNonArrayObject(value) || "Expected an object, but received: ".concat(print(value));
        },
        coercer: function(value, ctx) {
            if (!isNonArrayObject(value)) return value;
            var coerced = (0, $do9pw._)({}, value);
            // The `object` struct has special behaviour enabled by the mask flag.
            // When masking, properties that are not in the schema are deleted from
            // the coerced object instead of eventually failing validaiton.
            if (ctx.mask && schema) {
                for(var key in coerced)if (schema[key] === undefined) delete coerced[key];
            }
            return coerced;
        }
    });
}
/**
 * Augment a struct to allow `undefined` values.
 */ function optional(struct) {
    return new Struct((0, $cxjpp._)((0, $do9pw._)({}, struct), {
        validator: function(value, ctx) {
            return value === undefined || struct.validator(value, ctx);
        },
        refiner: function(value, ctx) {
            return value === undefined || struct.refiner(value, ctx);
        }
    }));
}
/**
 * Ensure that a value is an object with keys and values of specific types, but
 * without ensuring any specific shape of properties.
 *
 * Like TypeScript's `Record` utility.
 */ function record(Key, Value) {
    return new Struct({
        type: "record",
        schema: null,
        entries: function(value) {
            var _tmp, _tmp1, _i, k, v;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isObject(value)) return [
                            3,
                            5
                        ];
                        _tmp = [];
                        for(_tmp1 in value)_tmp.push(_tmp1);
                        _i = 0;
                        _state.label = 1;
                    case 1:
                        if (!(_i < _tmp.length)) return [
                            3,
                            5
                        ];
                        k = _tmp[_i];
                        v = value[k];
                        return [
                            4,
                            [
                                k,
                                k,
                                Key
                            ]
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            [
                                k,
                                v,
                                Value
                            ]
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _i++;
                        return [
                            3,
                            1
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        },
        validator: function(value) {
            return isNonArrayObject(value) || "Expected an object, but received: ".concat(print(value));
        },
        coercer: function(value) {
            return isNonArrayObject(value) ? (0, $do9pw._)({}, value) : value;
        }
    });
}
/**
 * Ensure that a value is a `RegExp`.
 *
 * Note: this does not test the value against the regular expression! For that
 * you need to use the `pattern()` refinement.
 */ function regexp() {
    return define("regexp", function(value) {
        return value instanceof RegExp;
    });
}
function set(Element) {
    return new Struct({
        type: "set",
        schema: null,
        entries: function(value) {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, v, err;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if (!(Element && value instanceof Set)) return [
                            3,
                            8
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = value[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        v = _step.value;
                        return [
                            4,
                            [
                                v,
                                v,
                                Element
                            ]
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        },
        coercer: function(value) {
            return value instanceof Set ? new Set(value) : value;
        },
        validator: function(value) {
            return value instanceof Set || "Expected a `Set` object, but received: ".concat(print(value));
        }
    });
}
/**
 * Ensure that a value is a string.
 */ function string() {
    return define("string", function(value) {
        return typeof value === "string" || "Expected a string, but received: ".concat(print(value));
    });
}
/**
 * Ensure that a value is a tuple of a specific length, and that each of its
 * elements is of a specific type.
 */ function tuple(Structs) {
    var Never = never();
    return new Struct({
        type: "tuple",
        schema: null,
        entries: function(value) {
            var length, i;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!Array.isArray(value)) return [
                            3,
                            4
                        ];
                        length = Math.max(Structs.length, value.length);
                        i = 0;
                        _state.label = 1;
                    case 1:
                        if (!(i < length)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            [
                                i,
                                value[i],
                                Structs[i] || Never
                            ]
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        i++;
                        return [
                            3,
                            1
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        },
        validator: function(value) {
            return Array.isArray(value) || "Expected an array, but received: ".concat(print(value));
        },
        coercer: function(value) {
            return Array.isArray(value) ? value.slice() : value;
        }
    });
}
/**
 * Ensure that a value has a set of known properties of specific types.
 *
 * Note: Unrecognized properties are allowed and untouched. This is similar to
 * how TypeScript's structural typing works.
 */ function type(schema) {
    var keys = Object.keys(schema);
    return new Struct({
        type: "type",
        schema: schema,
        entries: function(value) {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, k, err;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if (!isObject(value)) return [
                            3,
                            8
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = keys[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        k = _step.value;
                        return [
                            4,
                            [
                                k,
                                value[k],
                                schema[k]
                            ]
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        },
        validator: function(value) {
            return isNonArrayObject(value) || "Expected an object, but received: ".concat(print(value));
        },
        coercer: function(value) {
            return isNonArrayObject(value) ? (0, $do9pw._)({}, value) : value;
        }
    });
}
/**
 * Ensure that a value matches one of a set of types.
 */ function union(Structs) {
    var description = Structs.map(function(s) {
        return s.type;
    }).join(" | ");
    return new Struct({
        type: "union",
        schema: null,
        coercer: function(value, ctx) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Structs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var S = _step.value;
                    var _S_validate = (0, $cv9Rk._)(S.validate(value, {
                        coerce: true,
                        mask: ctx.mask
                    }), 2), error = _S_validate[0], coerced = _S_validate[1];
                    if (!error) return coerced;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return value;
        },
        validator: function(value, ctx) {
            var failures = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Structs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var S = _step.value;
                    var _run = (0, $gdHfP._)(run(value, S, ctx)), tuples = _run.slice(0);
                    var _tuples = (0, $cv9Rk._)(tuples, 1), first = _tuples[0];
                    if (!first[0]) return [];
                    else {
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = tuples[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var _step_value = (0, $cv9Rk._)(_step1.value, 1), failure = _step_value[0];
                                if (failure) failures.push(failure);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return [
                "Expected the value to satisfy a union of `".concat(description, "`, but received: ").concat(print(value))
            ].concat((0, $c6Xmf._)(failures));
        }
    });
}
/**
 * Ensure that any value passes validation, without widening its type to `any`.
 */ function unknown() {
    return define("unknown", function() {
        return true;
    });
}
/**
 * Augment a `Struct` to add an additional coercion step to its input.
 *
 * This allows you to transform input data before validating it, to increase the
 * likelihood that it passes validation—for example for default values, parsing
 * different formats, etc.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function coerce(struct, condition, coercer) {
    return new Struct((0, $cxjpp._)((0, $do9pw._)({}, struct), {
        coercer: function(value, ctx) {
            return is(value, condition) ? struct.coercer(coercer(value, ctx), ctx) : struct.coercer(value, ctx);
        }
    }));
}
/**
 * Augment a struct to replace `undefined` values with a default.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function defaulted(struct, fallback) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return coerce(struct, unknown(), function(x) {
        var f = typeof fallback === "function" ? fallback() : fallback;
        if (x === undefined) return f;
        if (!options.strict && isPlainObject(x) && isPlainObject(f)) {
            var ret = (0, $do9pw._)({}, x);
            var changed = false;
            for(var key in f)if (ret[key] === undefined) {
                ret[key] = f[key];
                changed = true;
            }
            if (changed) return ret;
        }
        return x;
    });
}
/**
 * Augment a struct to trim string inputs.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function trimmed(struct) {
    return coerce(struct, string(), function(x) {
        return x.trim();
    });
}
/**
 * Ensure that a string, array, map, or set is empty.
 */ function empty(struct) {
    return refine(struct, "empty", function(value) {
        var size = getSize(value);
        return size === 0 || "Expected an empty ".concat(struct.type, " but received one with a size of `").concat(size, "`");
    });
}
function getSize(value) {
    if (value instanceof Map || value instanceof Set) return value.size;
    else return value.length;
}
/**
 * Ensure that a number or date is below a threshold.
 */ function max(struct, threshold) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var exclusive = options.exclusive;
    return refine(struct, "max", function(value) {
        return exclusive ? value < threshold : value <= threshold || "Expected a ".concat(struct.type, " less than ").concat(exclusive ? "" : "or equal to ").concat(threshold, " but received `").concat(value, "`");
    });
}
/**
 * Ensure that a number or date is above a threshold.
 */ function min(struct, threshold) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var exclusive = options.exclusive;
    return refine(struct, "min", function(value) {
        return exclusive ? value > threshold : value >= threshold || "Expected a ".concat(struct.type, " greater than ").concat(exclusive ? "" : "or equal to ").concat(threshold, " but received `").concat(value, "`");
    });
}
/**
 * Ensure that a string, array, map or set is not empty.
 */ function nonempty(struct) {
    return refine(struct, "nonempty", function(value) {
        var size = getSize(value);
        return size > 0 || "Expected a nonempty ".concat(struct.type, " but received an empty one");
    });
}
/**
 * Ensure that a string matches a regular expression.
 */ function pattern(struct, regexp) {
    return refine(struct, "pattern", function(value) {
        return regexp.test(value) || "Expected a ".concat(struct.type, " matching `/").concat(regexp.source, '/` but received "').concat(value, '"');
    });
}
/**
 * Ensure that a string, array, number, date, map, or set has a size (or length, or time) between `min` and `max`.
 */ function size(struct, min) {
    var max = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : min;
    var expected = "Expected a ".concat(struct.type);
    var of = min === max ? "of `".concat(min, "`") : "between `".concat(min, "` and `").concat(max, "`");
    return refine(struct, "size", function(value) {
        if (typeof value === "number" || value instanceof Date) return min <= value && value <= max || "".concat(expected, " ").concat(of, " but received `").concat(value, "`");
        else if (value instanceof Map || value instanceof Set) {
            var size = value.size;
            return min <= size && size <= max || "".concat(expected, " with a size ").concat(of, " but received one with a size of `").concat(size, "`");
        } else {
            var length = value.length;
            return min <= length && length <= max || "".concat(expected, " with a length ").concat(of, " but received one with a length of `").concat(length, "`");
        }
    });
}
/**
 * Augment a `Struct` to add an additional refinement to the validation.
 *
 * The refiner function is guaranteed to receive a value of the struct's type,
 * because the struct's existing validation will already have passed. This
 * allows you to layer additional validation on top of existing structs.
 */ function refine(struct, name, refiner) {
    return new Struct((0, $cxjpp._)((0, $do9pw._)({}, struct), {
        refiner: function(value, ctx) {
            var result, failures, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, failure, err;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            5,
                            (0, $eha6O.__values)(struct.refiner(value, ctx))
                        ];
                    case 1:
                        _state.sent();
                        result = refiner(value, ctx);
                        failures = toFailures(result, ctx, struct, value);
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            7,
                            8,
                            9
                        ]);
                        _iterator = failures[Symbol.iterator]();
                        _state.label = 3;
                    case 3:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            6
                        ];
                        failure = _step.value;
                        return [
                            4,
                            (0, $cxjpp._)((0, $do9pw._)({}, failure), {
                                refinement: name
                            })
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            3
                        ];
                    case 6:
                        return [
                            3,
                            9
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            9
                        ];
                    case 8:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 9:
                        return [
                            2
                        ];
                }
            });
        }
    }));
}

});

parcelRegister("cwYMR", function(module, exports) {
"use strict";

var $cZ38z = parcelRequire("cZ38z");
var $91f7a03a5c590b0a$require$uuid = $cZ38z.default;

var $81mDt = parcelRequire("81mDt");
/**
 * Constructor for a Jayson Browser Client that does not depend any node.js core libraries
 * @class ClientBrowser
 * @param {Function} callServer Method that calls the server, receives the stringified request and a regular node-style callback
 * @param {Object} [options]
 * @param {Function} [options.reviver] Reviver function for JSON
 * @param {Function} [options.replacer] Replacer function for JSON
 * @param {Number} [options.version=2] JSON-RPC version to use (1|2)
 * @param {Function} [options.generator] Function to use for generating request IDs
 *  @param {Boolean} [options.notificationIdNull=false] When true, version 2 requests will set id to null instead of omitting it
 * @return {ClientBrowser}
 */ var $91f7a03a5c590b0a$var$ClientBrowser = function ClientBrowser1(callServer, options) {
    if (!(this instanceof $91f7a03a5c590b0a$var$ClientBrowser)) return new $91f7a03a5c590b0a$var$ClientBrowser(callServer, options);
    if (!options) options = {};
    this.options = {
        reviver: typeof options.reviver !== "undefined" ? options.reviver : null,
        replacer: typeof options.replacer !== "undefined" ? options.replacer : null,
        generator: typeof options.generator !== "undefined" ? options.generator : function() {
            return $91f7a03a5c590b0a$require$uuid();
        },
        version: typeof options.version !== "undefined" ? options.version : 2,
        notificationIdNull: typeof options.notificationIdNull === "boolean" ? options.notificationIdNull : false
    };
    this.callServer = callServer;
};
module.exports = $91f7a03a5c590b0a$var$ClientBrowser;
/**
 *  Creates a request and dispatches it if given a callback.
 *  @param {String|Array} method A batch request if passed an Array, or a method name if passed a String
 *  @param {Array|Object} [params] Parameters for the method
 *  @param {String|Number} [id] Optional id. If undefined an id will be generated. If null it creates a notification request
 *  @param {Function} [callback] Request callback. If specified, executes the request rather than only returning it.
 *  @throws {TypeError} Invalid parameters
 *  @return {Object} JSON-RPC 1.0 or 2.0 compatible request
 */ $91f7a03a5c590b0a$var$ClientBrowser.prototype.request = function(method, params, id, callback) {
    var self = this;
    var request = null;
    // is this a batch request?
    var isBatch = Array.isArray(method) && typeof params === "function";
    if (this.options.version === 1 && isBatch) throw new TypeError("JSON-RPC 1.0 does not support batching");
    // is this a raw request?
    var isRaw = !isBatch && method && typeof method === "object" && typeof params === "function";
    if (isBatch || isRaw) {
        callback = params;
        request = method;
    } else {
        if (typeof id === "function") {
            callback = id;
            // specifically undefined because "null" is a notification request
            id = undefined;
        }
        var hasCallback = typeof callback === "function";
        try {
            request = $81mDt(method, params, id, {
                generator: this.options.generator,
                version: this.options.version,
                notificationIdNull: this.options.notificationIdNull
            });
        } catch (err) {
            if (hasCallback) return callback(err);
            throw err;
        }
        // no callback means we should just return a raw request
        if (!hasCallback) return request;
    }
    var message;
    try {
        message = JSON.stringify(request, this.options.replacer);
    } catch (err) {
        return callback(err);
    }
    this.callServer(message, function(err, response) {
        self._parseResponse(err, response, callback);
    });
    // always return the raw request
    return request;
};
/**
 * Parses a response from a server
 * @param {Object} err Error to pass on that is unrelated to the actual response
 * @param {String} responseText JSON-RPC 1.0 or 2.0 response
 * @param {Function} callback Callback that will receive different arguments depending on the amount of parameters
 * @private
 */ $91f7a03a5c590b0a$var$ClientBrowser.prototype._parseResponse = function(err, responseText, callback) {
    if (err) {
        callback(err);
        return;
    }
    if (!responseText) // empty response text, assume that is correct because it could be a
    // notification which jayson does not give any body for
    return callback();
    var response;
    try {
        response = JSON.parse(responseText, this.options.reviver);
    } catch (err) {
        return callback(err);
    }
    if (callback.length === 3) {
        // if callback length is 3, we split callback arguments on error and response
        // is batch response?
        if (Array.isArray(response)) {
            // neccesary to split strictly on validity according to spec here
            var isError = function isError(res) {
                return typeof res.error !== "undefined";
            };
            var isNotError = function isNotError(res) {
                return !isError(res);
            };
            return callback(null, response.filter(isError), response.filter(isNotError));
        } else // split regardless of validity
        return callback(null, response.error, response.result);
    }
    callback(null, response);
};

});
parcelRegister("cZ38z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $973d9d85a769721b$export$2e2bcd8739ae039; });

var $hFggt = parcelRequire("hFggt");

var $0FR1f = parcelRequire("0FR1f");
function $973d9d85a769721b$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $hFggt.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $0FR1f.default)(rnds);
}
var $973d9d85a769721b$export$2e2bcd8739ae039 = $973d9d85a769721b$var$v4;

});
parcelRegister("hFggt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cdc2e1d0e0d2ec64$export$2e2bcd8739ae039; });
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $cdc2e1d0e0d2ec64$var$getRandomValues;
var $cdc2e1d0e0d2ec64$var$rnds8 = new Uint8Array(16);
function $cdc2e1d0e0d2ec64$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$cdc2e1d0e0d2ec64$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $cdc2e1d0e0d2ec64$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
        if (!$cdc2e1d0e0d2ec64$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $cdc2e1d0e0d2ec64$var$getRandomValues($cdc2e1d0e0d2ec64$var$rnds8);
}

});

parcelRegister("0FR1f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $002077903b45a435$export$2e2bcd8739ae039; });

var $agcbr = parcelRequire("agcbr");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $002077903b45a435$var$byteToHex = [];
for(var $002077903b45a435$var$i = 0; $002077903b45a435$var$i < 256; ++$002077903b45a435$var$i)$002077903b45a435$var$byteToHex.push(($002077903b45a435$var$i + 0x100).toString(16).substr(1));
function $002077903b45a435$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($002077903b45a435$var$byteToHex[arr[offset + 0]] + $002077903b45a435$var$byteToHex[arr[offset + 1]] + $002077903b45a435$var$byteToHex[arr[offset + 2]] + $002077903b45a435$var$byteToHex[arr[offset + 3]] + "-" + $002077903b45a435$var$byteToHex[arr[offset + 4]] + $002077903b45a435$var$byteToHex[arr[offset + 5]] + "-" + $002077903b45a435$var$byteToHex[arr[offset + 6]] + $002077903b45a435$var$byteToHex[arr[offset + 7]] + "-" + $002077903b45a435$var$byteToHex[arr[offset + 8]] + $002077903b45a435$var$byteToHex[arr[offset + 9]] + "-" + $002077903b45a435$var$byteToHex[arr[offset + 10]] + $002077903b45a435$var$byteToHex[arr[offset + 11]] + $002077903b45a435$var$byteToHex[arr[offset + 12]] + $002077903b45a435$var$byteToHex[arr[offset + 13]] + $002077903b45a435$var$byteToHex[arr[offset + 14]] + $002077903b45a435$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $agcbr.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $002077903b45a435$export$2e2bcd8739ae039 = $002077903b45a435$var$stringify;

});
parcelRegister("agcbr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7784d9692e20e659$export$2e2bcd8739ae039; });

var $dPnGR = parcelRequire("dPnGR");
function $7784d9692e20e659$var$validate(uuid) {
    return typeof uuid === "string" && (0, $dPnGR.default).test(uuid);
}
var $7784d9692e20e659$export$2e2bcd8739ae039 = $7784d9692e20e659$var$validate;

});
parcelRegister("dPnGR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1126a2b14a73422$export$2e2bcd8739ae039; });
var $a1126a2b14a73422$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});




parcelRegister("81mDt", function(module, exports) {
"use strict";

var $cZ38z = parcelRequire("cZ38z");
var $5d6ff9ac762dec48$require$uuid = $cZ38z.default;
/**
 *  Generates a JSON-RPC 1.0 or 2.0 request
 *  @param {String} method Name of method to call
 *  @param {Array|Object} params Array of parameters passed to the method as specified, or an object of parameter names and corresponding value
 *  @param {String|Number|null} [id] Request ID can be a string, number, null for explicit notification or left out for automatic generation
 *  @param {Object} [options]
 *  @param {Number} [options.version=2] JSON-RPC version to use (1 or 2)
 *  @param {Boolean} [options.notificationIdNull=false] When true, version 2 requests will set id to null instead of omitting it
 *  @param {Function} [options.generator] Passed the request, and the options object and is expected to return a request ID
 *  @throws {TypeError} If any of the parameters are invalid
 *  @return {Object} A JSON-RPC 1.0 or 2.0 request
 *  @memberOf Utils
 */ var $5d6ff9ac762dec48$var$generateRequest = function generateRequest(method, params, id, options) {
    if (typeof method !== "string") throw new TypeError(method + " must be a string");
    options = options || {};
    // check valid version provided
    var version = typeof options.version === "number" ? options.version : 2;
    if (version !== 1 && version !== 2) throw new TypeError(version + " must be 1 or 2");
    var request = {
        method: method
    };
    if (version === 2) request.jsonrpc = "2.0";
    if (params) {
        // params given, but invalid?
        if (typeof params !== "object" && !Array.isArray(params)) throw new TypeError(params + " must be an object, array or omitted");
        request.params = params;
    }
    // if id was left out, generate one (null means explicit notification)
    if (typeof id === "undefined") {
        var generator = typeof options.generator === "function" ? options.generator : function generator() {
            return $5d6ff9ac762dec48$require$uuid();
        };
        request.id = generator(request, options);
    } else if (version === 2 && id === null) // we have a version 2 notification
    {
        if (options.notificationIdNull) request.id = null; // id will not be set at all unless option provided
    } else request.id = id;
    return request;
};
module.exports = $5d6ff9ac762dec48$var$generateRequest;

});


parcelRegister("1Rq52", function(module, exports) {

$parcel$export(module.exports, "WebSocket", function () { return $cd9c158f6c21688e$export$3909fb301d3dc8c9; });
$parcel$export(module.exports, "CommonClient", function () { return $cd9c158f6c21688e$export$b43a6d9568fa5272; });

var $d3H5E = parcelRequire("d3H5E");

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $3sHb8 = parcelRequire("3sHb8");

var $dcsZi = parcelRequire("dcsZi");

var $do9pw = parcelRequire("do9pw");

var $dRLPW = parcelRequire("dRLPW");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");

var $8dlmd = parcelRequire("8dlmd");
parcelRequire("4cB8w");
var $1Xk3t = parcelRequire("1Xk3t");
// node_modules/esbuild-plugin-polyfill-node/polyfills/buffer.js
var $cd9c158f6c21688e$var$WebSocketBrowserImpl = /*#__PURE__*/ function(EventEmitter) {
    "use strict";
    (0, $dcsZi._)(WebSocketBrowserImpl, EventEmitter);
    var _super = (0, $ohfOJ._)(WebSocketBrowserImpl);
    function WebSocketBrowserImpl(address, options, protocols) {
        (0, $4GJKx._)(this, WebSocketBrowserImpl);
        var _this;
        _this = _super.call(this);
        (0, $3sHb8._)((0, $d3H5E._)(_this), "socket", void 0);
        _this.socket = new window.WebSocket(address, protocols);
        _this.socket.onopen = function() {
            return _this.emit("open");
        };
        _this.socket.onmessage = function(event) {
            return _this.emit("message", event.data);
        };
        _this.socket.onerror = function(error) {
            return _this.emit("error", error);
        };
        _this.socket.onclose = function(event) {
            _this.emit("close", event.code, event.reason);
        };
        return _this;
    }
    (0, $1wc17._)(WebSocketBrowserImpl, [
        {
            /**
  * Sends data through a websocket connection
  * @method
  * @param {(String|Object)} data - data to be sent via websocket
  * @param {Object} optionsOrCallback - ws options
  * @param {Function} callback - a callback called once the data is sent
  * @return {Undefined}
  */ key: "send",
            value: function send(data, optionsOrCallback, callback) {
                var cb = callback || optionsOrCallback;
                try {
                    this.socket.send(data);
                    cb();
                } catch (error) {
                    cb(error);
                }
            }
        },
        {
            /**
  * Closes an underlying socket
  * @method
  * @param {Number} code - status code explaining why the connection is being closed
  * @param {String} reason - a description why the connection is closing
  * @return {Undefined}
  * @throws {Error}
  */ key: "close",
            value: function close(code, reason) {
                this.socket.close(code, reason);
            }
        },
        {
            key: "addEventListener",
            value: function addEventListener(type, listener, options) {
                this.socket.addEventListener(type, listener, options);
            }
        }
    ]);
    return WebSocketBrowserImpl;
}((0, (/*@__PURE__*/$parcel$interopDefault($1Xk3t))));
function $cd9c158f6c21688e$export$3909fb301d3dc8c9(address, options) {
    return new $cd9c158f6c21688e$var$WebSocketBrowserImpl(address, options);
}
// src/lib/utils.ts
var $cd9c158f6c21688e$export$9fd32f4b4353d82d = /*#__PURE__*/ function() {
    "use strict";
    function DefaultDataPack() {
        (0, $4GJKx._)(this, DefaultDataPack);
    }
    (0, $1wc17._)(DefaultDataPack, [
        {
            key: "encode",
            value: function encode(value) {
                return JSON.stringify(value);
            }
        },
        {
            key: "decode",
            value: function decode(value) {
                return JSON.parse(value);
            }
        }
    ]);
    return DefaultDataPack;
}();
// src/lib/client.ts
var $cd9c158f6c21688e$export$b43a6d9568fa5272 = /*#__PURE__*/ function(EventEmitter) {
    "use strict";
    (0, $dcsZi._)(CommonClient, EventEmitter);
    var _super = (0, $ohfOJ._)(CommonClient);
    function CommonClient(webSocketFactory) {
        var address = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "ws://localhost:8080", _param = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, generate_request_id = arguments.length > 3 ? arguments[3] : void 0, dataPack = arguments.length > 4 ? arguments[4] : void 0;
        (0, $4GJKx._)(this, CommonClient);
        var _this;
        var _param_autoconnect = _param.autoconnect, autoconnect = _param_autoconnect === void 0 ? true : _param_autoconnect, _param_reconnect = _param.reconnect, reconnect = _param_reconnect === void 0 ? true : _param_reconnect, _param_reconnect_interval = _param.reconnect_interval, reconnect_interval = _param_reconnect_interval === void 0 ? 1e3 : _param_reconnect_interval, _param_max_reconnects = _param.max_reconnects, max_reconnects = _param_max_reconnects === void 0 ? 5 : _param_max_reconnects, rest_options = (0, $dRLPW._)(_param, [
            "autoconnect",
            "reconnect",
            "reconnect_interval",
            "max_reconnects"
        ]);
        _this = _super.call(this);
        (0, $3sHb8._)((0, $d3H5E._)(_this), "address", void 0);
        (0, $3sHb8._)((0, $d3H5E._)(_this), "rpc_id", void 0);
        (0, $3sHb8._)((0, $d3H5E._)(_this), "queue", void 0);
        (0, $3sHb8._)((0, $d3H5E._)(_this), "options", void 0);
        (0, $3sHb8._)((0, $d3H5E._)(_this), "autoconnect", void 0);
        (0, $3sHb8._)((0, $d3H5E._)(_this), "ready", void 0);
        (0, $3sHb8._)((0, $d3H5E._)(_this), "reconnect", void 0);
        (0, $3sHb8._)((0, $d3H5E._)(_this), "reconnect_timer_id", void 0);
        (0, $3sHb8._)((0, $d3H5E._)(_this), "reconnect_interval", void 0);
        (0, $3sHb8._)((0, $d3H5E._)(_this), "max_reconnects", void 0);
        (0, $3sHb8._)((0, $d3H5E._)(_this), "rest_options", void 0);
        (0, $3sHb8._)((0, $d3H5E._)(_this), "current_reconnects", void 0);
        (0, $3sHb8._)((0, $d3H5E._)(_this), "generate_request_id", void 0);
        (0, $3sHb8._)((0, $d3H5E._)(_this), "socket", void 0);
        (0, $3sHb8._)((0, $d3H5E._)(_this), "webSocketFactory", void 0);
        (0, $3sHb8._)((0, $d3H5E._)(_this), "dataPack", void 0);
        _this.webSocketFactory = webSocketFactory;
        _this.queue = {};
        _this.rpc_id = 0;
        _this.address = address;
        _this.autoconnect = autoconnect;
        _this.ready = false;
        _this.reconnect = reconnect;
        _this.reconnect_timer_id = void 0;
        _this.reconnect_interval = reconnect_interval;
        _this.max_reconnects = max_reconnects;
        _this.rest_options = rest_options;
        _this.current_reconnects = 0;
        _this.generate_request_id = generate_request_id || function() {
            return ++_this.rpc_id;
        };
        if (!dataPack) _this.dataPack = new $cd9c158f6c21688e$export$9fd32f4b4353d82d();
        else _this.dataPack = dataPack;
        if (_this.autoconnect) _this._connect(_this.address, (0, $do9pw._)({
            autoconnect: _this.autoconnect,
            reconnect: _this.reconnect,
            reconnect_interval: _this.reconnect_interval,
            max_reconnects: _this.max_reconnects
        }, _this.rest_options));
        return _this;
    }
    (0, $1wc17._)(CommonClient, [
        {
            /**
  * Connects to a defined server if not connected already.
  * @method
  * @return {Undefined}
  */ key: "connect",
            value: function connect() {
                if (this.socket) return;
                this._connect(this.address, (0, $do9pw._)({
                    autoconnect: this.autoconnect,
                    reconnect: this.reconnect,
                    reconnect_interval: this.reconnect_interval,
                    max_reconnects: this.max_reconnects
                }, this.rest_options));
            }
        },
        {
            /**
  * Calls a registered RPC method on server.
  * @method
  * @param {String} method - RPC method name
  * @param {Object|Array} params - optional method parameters
  * @param {Number} timeout - RPC reply timeout value
  * @param {Object} ws_opts - options passed to ws
  * @return {Promise}
  */ key: "call",
            value: function call(method, params, timeout, ws_opts) {
                var _this = this;
                if (!ws_opts && "object" === typeof timeout) {
                    ws_opts = timeout;
                    timeout = null;
                }
                return new Promise(function(resolve, reject) {
                    if (!_this.ready) return reject(new Error("socket not ready"));
                    var rpc_id = _this.generate_request_id(method, params);
                    var message = {
                        jsonrpc: "2.0",
                        method: method,
                        params: params || void 0,
                        id: rpc_id
                    };
                    _this.socket.send(_this.dataPack.encode(message), ws_opts, function(error) {
                        if (error) return reject(error);
                        _this.queue[rpc_id] = {
                            promise: [
                                resolve,
                                reject
                            ]
                        };
                        if (timeout) _this.queue[rpc_id].timeout = setTimeout(function() {
                            delete _this.queue[rpc_id];
                            reject(new Error("reply timeout"));
                        }, timeout);
                    });
                });
            }
        },
        {
            key: "login",
            value: /**
  * Logins with the other side of the connection.
  * @method
  * @param {Object} params - Login credentials object
  * @return {Promise}
  */ function login(params) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var resp;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.call("rpc.login", params)
                                ];
                            case 1:
                                resp = _state.sent();
                                if (!resp) throw new Error("authentication failed");
                                return [
                                    2,
                                    resp
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "listMethods",
            value: /**
  * Fetches a list of client's methods registered on server.
  * @method
  * @return {Array}
  */ function listMethods() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.call("__listMethods")
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
  * Sends a JSON-RPC 2.0 notification to server.
  * @method
  * @param {String} method - RPC method name
  * @param {Object} params - optional method parameters
  * @return {Promise}
  */ key: "notify",
            value: function notify(method, params) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (!_this.ready) return reject(new Error("socket not ready"));
                    var message = {
                        jsonrpc: "2.0",
                        method: method,
                        params: params
                    };
                    _this.socket.send(_this.dataPack.encode(message), function(error) {
                        if (error) return reject(error);
                        resolve();
                    });
                });
            }
        },
        {
            key: "subscribe",
            value: /**
  * Subscribes for a defined event.
  * @method
  * @param {String|Array} event - event name
  * @return {Undefined}
  * @throws {Error}
  */ function subscribe(event) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var result;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (typeof event === "string") event = [
                                    event
                                ];
                                return [
                                    4,
                                    _this.call("rpc.on", event)
                                ];
                            case 1:
                                result = _state.sent();
                                if (typeof event === "string" && result[event] !== "ok") throw new Error("Failed subscribing to an event '" + event + "' with: " + result[event]);
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "unsubscribe",
            value: /**
  * Unsubscribes from a defined event.
  * @method
  * @param {String|Array} event - event name
  * @return {Undefined}
  * @throws {Error}
  */ function unsubscribe(event) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var result;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (typeof event === "string") event = [
                                    event
                                ];
                                return [
                                    4,
                                    _this.call("rpc.off", event)
                                ];
                            case 1:
                                result = _state.sent();
                                if (typeof event === "string" && result[event] !== "ok") throw new Error("Failed unsubscribing from an event with: " + result);
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
  * Closes a WebSocket connection gracefully.
  * @method
  * @param {Number} code - socket close code
  * @param {String} data - optional data to be sent before closing
  * @return {Undefined}
  */ key: "close",
            value: function close(code, data) {
                this.socket.close(code || 1e3, data);
            }
        },
        {
            /**
  * Enable / disable automatic reconnection.
  * @method
  * @param {Boolean} reconnect - enable / disable reconnection
  * @return {Undefined}
  */ key: "setAutoReconnect",
            value: function setAutoReconnect(reconnect) {
                this.reconnect = reconnect;
            }
        },
        {
            /**
  * Set the interval between reconnection attempts.
  * @method
  * @param {Number} interval - reconnection interval in milliseconds
  * @return {Undefined}
  */ key: "setReconnectInterval",
            value: function setReconnectInterval(interval) {
                this.reconnect_interval = interval;
            }
        },
        {
            /**
  * Set the maximum number of reconnection attempts.
  * @method
  * @param {Number} max_reconnects - maximum reconnection attempts
  * @return {Undefined}
  */ key: "setMaxReconnects",
            value: function setMaxReconnects(max_reconnects) {
                this.max_reconnects = max_reconnects;
            }
        },
        {
            /**
  * Connection/Message handler.
  * @method
  * @private
  * @param {String} address - WebSocket API address
  * @param {Object} options - ws options object
  * @return {Undefined}
  */ key: "_connect",
            value: function _connect(address, options) {
                var _this = this;
                clearTimeout(this.reconnect_timer_id);
                this.socket = this.webSocketFactory(address, options);
                this.socket.addEventListener("open", function() {
                    _this.ready = true;
                    _this.emit("open");
                    _this.current_reconnects = 0;
                });
                this.socket.addEventListener("message", function(param) {
                    var message = param.data;
                    if (message instanceof ArrayBuffer) message = (0, $8dlmd.Buffer).from(message).toString();
                    try {
                        message = _this.dataPack.decode(message);
                    } catch (error) {
                        return;
                    }
                    if (message.notification && _this.listeners(message.notification).length) {
                        if (!Object.keys(message.params).length) return _this.emit(message.notification);
                        var args = [
                            message.notification
                        ];
                        if (message.params.constructor === Object) args.push(message.params);
                        else for(var i = 0; i < message.params.length; i++)args.push(message.params[i]);
                        return Promise.resolve().then(function() {
                            _this.emit.apply(_this, args);
                        });
                    }
                    if (!_this.queue[message.id]) {
                        if (message.method) return Promise.resolve().then(function() {
                            _this.emit(message.method, message === null || message === void 0 ? void 0 : message.params);
                        });
                        return;
                    }
                    if ("error" in message === "result" in message) _this.queue[message.id].promise[1](new Error('Server response malformed. Response must include either "result" or "error", but not both.'));
                    if (_this.queue[message.id].timeout) clearTimeout(_this.queue[message.id].timeout);
                    if (message.error) _this.queue[message.id].promise[1](message.error);
                    else _this.queue[message.id].promise[0](message.result);
                    delete _this.queue[message.id];
                });
                this.socket.addEventListener("error", function(error) {
                    return _this.emit("error", error);
                });
                this.socket.addEventListener("close", function(param) {
                    var code = param.code, reason = param.reason;
                    if (_this.ready) setTimeout(function() {
                        return _this.emit("close", code, reason);
                    }, 0);
                    _this.ready = false;
                    _this.socket = void 0;
                    if (code === 1e3) return;
                    _this.current_reconnects++;
                    if (_this.reconnect && (_this.max_reconnects > _this.current_reconnects || _this.max_reconnects === 0)) _this.reconnect_timer_id = setTimeout(function() {
                        return _this._connect(address, options);
                    }, _this.reconnect_interval);
                });
            }
        }
    ]);
    return CommonClient;
}((0, (/*@__PURE__*/$parcel$interopDefault($1Xk3t))));
// src/index.browser.ts
var $cd9c158f6c21688e$export$1f2bb630327ac4b6 = /*#__PURE__*/ function(CommonClient) {
    "use strict";
    (0, $dcsZi._)(Client, CommonClient);
    var _super = (0, $ohfOJ._)(Client);
    function Client() {
        var address = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "ws://localhost:8080", _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_autoconnect = _ref.autoconnect, autoconnect = _ref_autoconnect === void 0 ? true : _ref_autoconnect, _ref_reconnect = _ref.reconnect, reconnect = _ref_reconnect === void 0 ? true : _ref_reconnect, _ref_reconnect_interval = _ref.reconnect_interval, reconnect_interval = _ref_reconnect_interval === void 0 ? 1e3 : _ref_reconnect_interval, _ref_max_reconnects = _ref.max_reconnects, max_reconnects = _ref_max_reconnects === void 0 ? 5 : _ref_max_reconnects, generate_request_id = arguments.length > 2 ? arguments[2] : void 0;
        (0, $4GJKx._)(this, Client);
        return _super.call(this, $cd9c158f6c21688e$export$3909fb301d3dc8c9, address, {
            autoconnect: autoconnect,
            reconnect: reconnect,
            reconnect_interval: reconnect_interval,
            max_reconnects: max_reconnects
        }, generate_request_id);
    }
    return Client;
}($cd9c158f6c21688e$export$b43a6d9568fa5272);
 //# sourceMappingURL=out.js.map

});
parcelRegister("4cB8w", function(module, exports) {

$parcel$export(module.exports, "EventEmitter", function () { return (/*@__PURE__*/$parcel$interopDefault((parcelRequire("1Xk3t")))); });

var $1Xk3t = parcelRequire("1Xk3t");
var $264c865e2af48a12$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($1Xk3t)));

});
parcelRegister("1Xk3t", function(module, exports) {
"use strict";
var $16cadba65827166b$var$has = Object.prototype.hasOwnProperty, $16cadba65827166b$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $16cadba65827166b$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $16cadba65827166b$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $16cadba65827166b$var$Events().__proto__) $16cadba65827166b$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $16cadba65827166b$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $16cadba65827166b$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $16cadba65827166b$var$EE(fn, context || emitter, once), evt = $16cadba65827166b$var$prefix ? $16cadba65827166b$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $16cadba65827166b$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $16cadba65827166b$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $16cadba65827166b$var$EventEmitter() {
    this._events = new $16cadba65827166b$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $16cadba65827166b$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($16cadba65827166b$var$has.call(events, name)) names.push($16cadba65827166b$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $16cadba65827166b$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $16cadba65827166b$var$prefix ? $16cadba65827166b$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $16cadba65827166b$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $16cadba65827166b$var$prefix ? $16cadba65827166b$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $16cadba65827166b$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $16cadba65827166b$var$prefix ? $16cadba65827166b$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $16cadba65827166b$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $16cadba65827166b$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $16cadba65827166b$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $16cadba65827166b$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $16cadba65827166b$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $16cadba65827166b$var$prefix ? $16cadba65827166b$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $16cadba65827166b$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $16cadba65827166b$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $16cadba65827166b$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $16cadba65827166b$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $16cadba65827166b$var$prefix ? $16cadba65827166b$var$prefix + event : event;
        if (this._events[evt]) $16cadba65827166b$var$clearEvent(this, evt);
    } else {
        this._events = new $16cadba65827166b$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$16cadba65827166b$var$EventEmitter.prototype.off = $16cadba65827166b$var$EventEmitter.prototype.removeListener;
$16cadba65827166b$var$EventEmitter.prototype.addListener = $16cadba65827166b$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$16cadba65827166b$var$EventEmitter.prefixed = $16cadba65827166b$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$16cadba65827166b$var$EventEmitter.EventEmitter = $16cadba65827166b$var$EventEmitter;
module.exports = $16cadba65827166b$var$EventEmitter;

});



parcelRegister("2r5xP", function(module, exports) {

$parcel$export(module.exports, "secp256k1", function () { return $1c62676c35f67aba$export$529e6123e9353a90; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $c6Xmf = parcelRequire("c6Xmf");

var $fjRrf = parcelRequire("fjRrf");

var $8ybNC = parcelRequire("8ybNC");

var $fMLye = parcelRequire("fMLye");

var $llE38 = parcelRequire("llE38");

var $fnxE9 = parcelRequire("fnxE9");

var $cOBbr = parcelRequire("cOBbr");

var $gS0Qe = parcelRequire("gS0Qe");
var $1c62676c35f67aba$var$secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f");
var $1c62676c35f67aba$var$secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
var $1c62676c35f67aba$var$_1n = BigInt(1);
var $1c62676c35f67aba$var$_2n = BigInt(2);
var $1c62676c35f67aba$var$divNearest = function(a, b) {
    return (a + b / $1c62676c35f67aba$var$_2n) / b;
};
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $1c62676c35f67aba$var$sqrtMod(y) {
    var P = $1c62676c35f67aba$var$secp256k1P;
    // prettier-ignore
    var _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    var _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    var b2 = y * y * y % P; // x^3, 11
    var b3 = b2 * b2 * y % P; // x^7
    var b6 = (0, $fnxE9.pow2)(b3, _3n, P) * b3 % P;
    var b9 = (0, $fnxE9.pow2)(b6, _3n, P) * b3 % P;
    var b11 = (0, $fnxE9.pow2)(b9, $1c62676c35f67aba$var$_2n, P) * b2 % P;
    var b22 = (0, $fnxE9.pow2)(b11, _11n, P) * b11 % P;
    var b44 = (0, $fnxE9.pow2)(b22, _22n, P) * b22 % P;
    var b88 = (0, $fnxE9.pow2)(b44, _44n, P) * b44 % P;
    var b176 = (0, $fnxE9.pow2)(b88, _88n, P) * b88 % P;
    var b220 = (0, $fnxE9.pow2)(b176, _44n, P) * b44 % P;
    var b223 = (0, $fnxE9.pow2)(b220, _3n, P) * b3 % P;
    var t1 = (0, $fnxE9.pow2)(b223, _23n, P) * b22 % P;
    var t2 = (0, $fnxE9.pow2)(t1, _6n, P) * b2 % P;
    var root = (0, $fnxE9.pow2)(t2, $1c62676c35f67aba$var$_2n, P);
    if (!$1c62676c35f67aba$var$Fp.eql($1c62676c35f67aba$var$Fp.sqr(root), y)) throw new Error("Cannot find square root");
    return root;
}
var $1c62676c35f67aba$var$Fp = (0, $fnxE9.Field)($1c62676c35f67aba$var$secp256k1P, undefined, undefined, {
    sqrt: $1c62676c35f67aba$var$sqrtMod
});
var $1c62676c35f67aba$export$529e6123e9353a90 = (0, $fMLye.createCurve)({
    a: BigInt(0),
    b: BigInt(7),
    Fp: $1c62676c35f67aba$var$Fp,
    n: $1c62676c35f67aba$var$secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: true,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */ endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: function(k) {
            var n = $1c62676c35f67aba$var$secp256k1N;
            var a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
            var b1 = -$1c62676c35f67aba$var$_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
            var a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
            var b2 = a1;
            var POW_2_128 = BigInt("0x100000000000000000000000000000000"); // (2n**128n).toString(16)
            var c1 = $1c62676c35f67aba$var$divNearest(b2 * k, n);
            var c2 = $1c62676c35f67aba$var$divNearest(-b1 * k, n);
            var k1 = (0, $fnxE9.mod)(k - c1 * a1 - c2 * a2, n);
            var k2 = (0, $fnxE9.mod)(-c1 * b1 - c2 * b2, n);
            var k1neg = k1 > POW_2_128;
            var k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalar: Endomorphism failed, k=" + k);
            return {
                k1neg: k1neg,
                k1: k1,
                k2neg: k2neg,
                k2: k2
            };
        }
    }
}, (0, $fjRrf.sha256));
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
var $1c62676c35f67aba$var$_0n = BigInt(0);
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ var $1c62676c35f67aba$var$TAGGED_HASH_PREFIXES = {};
function $1c62676c35f67aba$var$taggedHash(tag) {
    for(var _len = arguments.length, messages = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        messages[_key - 1] = arguments[_key];
    }
    var tagP = $1c62676c35f67aba$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        var tagH = (0, $fjRrf.sha256)(Uint8Array.from(tag, function(c) {
            return c.charCodeAt(0);
        }));
        tagP = (0, $cOBbr.concatBytes)(tagH, tagH);
        $1c62676c35f67aba$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $fjRrf.sha256)((0, $cOBbr.concatBytes).apply(void 0, [
        tagP
    ].concat((0, $c6Xmf._)(messages))));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
var $1c62676c35f67aba$var$pointToBytes = function(point) {
    return point.toRawBytes(true).slice(1);
};
var $1c62676c35f67aba$var$numTo32b = function(n) {
    return (0, $cOBbr.numberToBytesBE)(n, 32);
};
var $1c62676c35f67aba$var$modP = function(x) {
    return (0, $fnxE9.mod)(x, $1c62676c35f67aba$var$secp256k1P);
};
var $1c62676c35f67aba$var$modN = function(x) {
    return (0, $fnxE9.mod)(x, $1c62676c35f67aba$var$secp256k1N);
};
var $1c62676c35f67aba$var$Point = $1c62676c35f67aba$export$529e6123e9353a90.ProjectivePoint;
var $1c62676c35f67aba$var$GmulAdd = function(Q, a, b) {
    return $1c62676c35f67aba$var$Point.BASE.multiplyAndAddUnsafe(Q, a, b);
};
// Calculate point, scalar and bytes
function $1c62676c35f67aba$var$schnorrGetExtPubKey(priv) {
    var d_ = $1c62676c35f67aba$export$529e6123e9353a90.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    var p = $1c62676c35f67aba$var$Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    var scalar = p.hasEvenY() ? d_ : $1c62676c35f67aba$var$modN(-d_);
    return {
        scalar: scalar,
        bytes: $1c62676c35f67aba$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $1c62676c35f67aba$var$lift_x(x) {
    (0, $cOBbr.aInRange)("x", x, $1c62676c35f67aba$var$_1n, $1c62676c35f67aba$var$secp256k1P); // Fail if x ≥ p.
    var xx = $1c62676c35f67aba$var$modP(x * x);
    var c = $1c62676c35f67aba$var$modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    var y = $1c62676c35f67aba$var$sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % $1c62676c35f67aba$var$_2n !== $1c62676c35f67aba$var$_0n) y = $1c62676c35f67aba$var$modP(-y); // Return the unique point P such that x(P) = x and
    var p = new $1c62676c35f67aba$var$Point(x, y, $1c62676c35f67aba$var$_1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
var $1c62676c35f67aba$var$num = (0, $cOBbr.bytesToNumberBE);
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $1c62676c35f67aba$var$challenge() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return $1c62676c35f67aba$var$modN($1c62676c35f67aba$var$num($1c62676c35f67aba$var$taggedHash.apply(void 0, [
        "BIP0340/challenge"
    ].concat((0, $c6Xmf._)(args)))));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $1c62676c35f67aba$var$schnorrGetPublicKey(privateKey) {
    return $1c62676c35f67aba$var$schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $1c62676c35f67aba$var$schnorrSign(message, privateKey) {
    var auxRand = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $8ybNC.randomBytes)(32);
    var m = (0, $cOBbr.ensureBytes)("message", message);
    var _schnorrGetExtPubKey = $1c62676c35f67aba$var$schnorrGetExtPubKey(privateKey), px = _schnorrGetExtPubKey.bytes, d = _schnorrGetExtPubKey.scalar; // checks for isWithinCurveOrder
    var a = (0, $cOBbr.ensureBytes)("auxRand", auxRand, 32); // Auxiliary random data a: a 32-byte array
    var t = $1c62676c35f67aba$var$numTo32b(d ^ $1c62676c35f67aba$var$num($1c62676c35f67aba$var$taggedHash("BIP0340/aux", a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    var rand = $1c62676c35f67aba$var$taggedHash("BIP0340/nonce", t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    var k_ = $1c62676c35f67aba$var$modN($1c62676c35f67aba$var$num(rand)); // Let k' = int(rand) mod n
    if (k_ === $1c62676c35f67aba$var$_0n) throw new Error("sign failed: k is zero"); // Fail if k' = 0.
    var _schnorrGetExtPubKey1 = $1c62676c35f67aba$var$schnorrGetExtPubKey(k_), rx = _schnorrGetExtPubKey1.bytes, k = _schnorrGetExtPubKey1.scalar; // Let R = k'⋅G.
    var e = $1c62676c35f67aba$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    var sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set($1c62676c35f67aba$var$numTo32b($1c62676c35f67aba$var$modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$1c62676c35f67aba$var$schnorrVerify(sig, m, px)) throw new Error("sign: Invalid signature produced");
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $1c62676c35f67aba$var$schnorrVerify(signature, message, publicKey) {
    var sig = (0, $cOBbr.ensureBytes)("signature", signature, 64);
    var m = (0, $cOBbr.ensureBytes)("message", message);
    var pub = (0, $cOBbr.ensureBytes)("publicKey", publicKey, 32);
    try {
        var P = $1c62676c35f67aba$var$lift_x($1c62676c35f67aba$var$num(pub)); // P = lift_x(int(pk)); fail if that fails
        var r = $1c62676c35f67aba$var$num(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!(0, $cOBbr.inRange)(r, $1c62676c35f67aba$var$_1n, $1c62676c35f67aba$var$secp256k1P)) return false;
        var s = $1c62676c35f67aba$var$num(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!(0, $cOBbr.inRange)(s, $1c62676c35f67aba$var$_1n, $1c62676c35f67aba$var$secp256k1N)) return false;
        var e = $1c62676c35f67aba$var$challenge($1c62676c35f67aba$var$numTo32b(r), $1c62676c35f67aba$var$pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        var R = $1c62676c35f67aba$var$GmulAdd(P, s, $1c62676c35f67aba$var$modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
var $1c62676c35f67aba$export$1f2401df071be9f = /* @__PURE__ */ function() {
    return {
        getPublicKey: $1c62676c35f67aba$var$schnorrGetPublicKey,
        sign: $1c62676c35f67aba$var$schnorrSign,
        verify: $1c62676c35f67aba$var$schnorrVerify,
        utils: {
            randomPrivateKey: $1c62676c35f67aba$export$529e6123e9353a90.utils.randomPrivateKey,
            lift_x: $1c62676c35f67aba$var$lift_x,
            pointToBytes: $1c62676c35f67aba$var$pointToBytes,
            numberToBytesBE: (0, $cOBbr.numberToBytesBE),
            bytesToNumberBE: (0, $cOBbr.bytesToNumberBE),
            taggedHash: $1c62676c35f67aba$var$taggedHash,
            mod: (0, $fnxE9.mod)
        }
    };
}();
var $1c62676c35f67aba$var$isoMap = /* @__PURE__ */ function() {
    return (0, $llE38.isogenyMap)($1c62676c35f67aba$var$Fp, [
        // xNum
        [
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
            "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
            "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
        ],
        // xDen
        [
            "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
            "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ],
        // yNum
        [
            "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
            "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
            "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
            "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
        ],
        // yDen
        [
            "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
            "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
            "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ]
    ].map(function(i) {
        return i.map(function(j) {
            return BigInt(j);
        });
    }));
}();
var $1c62676c35f67aba$var$mapSWU = /* @__PURE__ */ function() {
    return (0, $gS0Qe.mapToCurveSimpleSWU)($1c62676c35f67aba$var$Fp, {
        A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
        B: BigInt("1771"),
        Z: $1c62676c35f67aba$var$Fp.create(BigInt("-11"))
    });
}();
var $1c62676c35f67aba$var$htf = /* @__PURE__ */ function() {
    return (0, $llE38.createHasher)($1c62676c35f67aba$export$529e6123e9353a90.ProjectivePoint, function(scalars) {
        var _mapSWU = $1c62676c35f67aba$var$mapSWU($1c62676c35f67aba$var$Fp.create(scalars[0])), x = _mapSWU.x, y = _mapSWU.y;
        return $1c62676c35f67aba$var$isoMap(x, y);
    }, {
        DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
        encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
        p: $1c62676c35f67aba$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: (0, $fjRrf.sha256)
    });
}();
var $1c62676c35f67aba$export$a95cc2b0cdb9c1e1 = /* @__PURE__ */ function() {
    return $1c62676c35f67aba$var$htf.hashToCurve;
}();
var $1c62676c35f67aba$export$124e820e7679cc3 = /* @__PURE__ */ function() {
    return $1c62676c35f67aba$var$htf.encodeToCurve;
}();

});
parcelRegister("fMLye", function(module, exports) {

$parcel$export(module.exports, "createCurve", function () { return $b7e0395963bff717$export$3f2f6721dd02558a; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $c6Xmf = parcelRequire("c6Xmf");

var $334hE = parcelRequire("334hE");

var $8ybNC = parcelRequire("8ybNC");

var $gS0Qe = parcelRequire("gS0Qe");
function $b7e0395963bff717$export$adaba664e531641c(hash) {
    return {
        hash: hash,
        hmac: function(key) {
            for(var _len = arguments.length, msgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                msgs[_key - 1] = arguments[_key];
            }
            return (0, $334hE.hmac)(hash, key, (0, $8ybNC.concatBytes).apply(void 0, (0, $c6Xmf._)(msgs)));
        },
        randomBytes: (0, $8ybNC.randomBytes)
    };
}
function $b7e0395963bff717$export$3f2f6721dd02558a(curveDef, defHash) {
    var create = function(hash) {
        return (0, $gS0Qe.weierstrass)((0, $do9pw._)({}, curveDef, $b7e0395963bff717$export$adaba664e531641c(hash)));
    };
    return Object.freeze((0, $cxjpp._)((0, $do9pw._)({}, create(defHash)), {
        create: create
    }));
}

});
parcelRegister("gS0Qe", function(module, exports) {

$parcel$export(module.exports, "weierstrass", function () { return $c482579290144a2f$export$350b8ea6f1c27fae; });
$parcel$export(module.exports, "mapToCurveSimpleSWU", function () { return $c482579290144a2f$export$cc7fea9756a17416; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Short Weierstrass curve. The formula is: y² = x³ + ax + b

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $c6Xmf = parcelRequire("c6Xmf");

var $l0HdX = parcelRequire("l0HdX");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");

var $1JA7e = parcelRequire("1JA7e");

var $fnxE9 = parcelRequire("fnxE9");

var $cOBbr = parcelRequire("cOBbr");
function $c482579290144a2f$var$validateSigVerOpts(opts) {
    if (opts.lowS !== undefined) (0, $cOBbr.abool)("lowS", opts.lowS);
    if (opts.prehash !== undefined) (0, $cOBbr.abool)("prehash", opts.prehash);
}
function $c482579290144a2f$var$validatePointOpts(curve) {
    var opts = (0, $1JA7e.validateBasic)(curve);
    $cOBbr.validateObject(opts, {
        a: "field",
        b: "field"
    }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
    });
    var endo = opts.endo, Fp = opts.Fp, a = opts.a;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof endo !== "object" || (0, $l0HdX._)(endo.beta) !== "bigint" || typeof endo.splitScalar !== "function") throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
    }
    return Object.freeze((0, $do9pw._)({}, opts));
}
// ASN.1 DER encoding utilities
var $c482579290144a2f$var$b2n = $cOBbr.bytesToNumberBE, $c482579290144a2f$var$h2b = $cOBbr.hexToBytes;
var $c482579290144a2f$export$56ac33195d7076db = {
    // asn.1 DER encoding utils
    Err: /*#__PURE__*/ function(Error1) {
        "use strict";
        (0, $dcsZi._)(DERErr, Error1);
        var _super = (0, $ohfOJ._)(DERErr);
        function DERErr() {
            var m = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
            (0, $4GJKx._)(this, DERErr);
            return _super.call(this, m);
        }
        return DERErr;
    }((0, $FuVm8._)(Error)),
    _parseInt: function(data) {
        var E = $c482579290144a2f$export$56ac33195d7076db.Err;
        if (data.length < 2 || data[0] !== 0x02) throw new E("Invalid signature integer tag");
        var len = data[1];
        var res = data.subarray(2, len + 2);
        if (!len || res.length !== len) throw new E("Invalid signature integer: wrong length");
        // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
        // since we always use positive integers here. It must always be empty:
        // - add zero byte if exists
        // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
        if (res[0] & 128) throw new E("Invalid signature integer: negative");
        if (res[0] === 0x00 && !(res[1] & 128)) throw new E("Invalid signature integer: unnecessary leading zero");
        return {
            d: $c482579290144a2f$var$b2n(res),
            l: data.subarray(len + 2)
        }; // d is data, l is left
    },
    toSig: function(hex) {
        // parse DER signature
        var E = $c482579290144a2f$export$56ac33195d7076db.Err;
        var data = typeof hex === "string" ? $c482579290144a2f$var$h2b(hex) : hex;
        $cOBbr.abytes(data);
        var l = data.length;
        if (l < 2 || data[0] != 0x30) throw new E("Invalid signature tag");
        if (data[1] !== l - 2) throw new E("Invalid signature: incorrect length");
        var _DER__parseInt = $c482579290144a2f$export$56ac33195d7076db._parseInt(data.subarray(2)), r = _DER__parseInt.d, sBytes = _DER__parseInt.l;
        var _DER__parseInt1 = $c482579290144a2f$export$56ac33195d7076db._parseInt(sBytes), s = _DER__parseInt1.d, rBytesLeft = _DER__parseInt1.l;
        if (rBytesLeft.length) throw new E("Invalid signature: left bytes after parsing");
        return {
            r: r,
            s: s
        };
    },
    hexFromSig: function(sig) {
        // Add leading zero if first byte has negative bit enabled. More details in '_parseInt'
        var slice = function(s) {
            return Number.parseInt(s[0], 16) & 8 ? "00" + s : s;
        };
        var h = function(num) {
            var hex = num.toString(16);
            return hex.length & 1 ? "0".concat(hex) : hex;
        };
        var s = slice(h(sig.s));
        var r = slice(h(sig.r));
        var shl = s.length / 2;
        var rhl = r.length / 2;
        var sl = h(shl);
        var rl = h(rhl);
        return "30".concat(h(rhl + shl + 4), "02").concat(rl).concat(r, "02").concat(sl).concat(s);
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
var $c482579290144a2f$var$_0n = BigInt(0), $c482579290144a2f$var$_1n = BigInt(1), $c482579290144a2f$var$_2n = BigInt(2), $c482579290144a2f$var$_3n = BigInt(3), $c482579290144a2f$var$_4n = BigInt(4);
function $c482579290144a2f$export$fa783af82e4fe0fc(opts) {
    var CURVE = $c482579290144a2f$var$validatePointOpts(opts);
    var Fp = CURVE.Fp; // All curves has same field / group length as for now, but they can differ
    var toBytes = CURVE.toBytes || function(_c, point, _isCompressed) {
        var a = point.toAffine();
        return $cOBbr.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    };
    var fromBytes = CURVE.fromBytes || function(bytes) {
        // const head = bytes[0];
        var tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        var x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        var y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x: x,
            y: y
        };
    };
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        var a = CURVE.a, b = CURVE.b;
        var x2 = Fp.sqr(x); // x * x
        var x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error("bad generator point: equation left != right");
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return $cOBbr.inRange(num, $c482579290144a2f$var$_1n, CURVE.n);
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        var lengths = CURVE.allowedPrivateKeyLengths, nByteLength = CURVE.nByteLength, wrapPrivateKey = CURVE.wrapPrivateKey, N = CURVE.n;
        if (lengths && (typeof key === "undefined" ? "undefined" : (0, $l0HdX._)(key)) !== "bigint") {
            if ($cOBbr.isBytes(key)) key = $cOBbr.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== "string" || !lengths.includes(key.length)) throw new Error("Invalid key");
            key = key.padStart(nByteLength * 2, "0");
        }
        var num;
        try {
            num = (typeof key === "undefined" ? "undefined" : (0, $l0HdX._)(key)) === "bigint" ? key : $cOBbr.bytesToNumberBE((0, $cOBbr.ensureBytes)("private key", key, nByteLength));
        } catch (error) {
            throw new Error("private key must be ".concat(nByteLength, " bytes, hex or bigint, not ").concat(typeof key === "undefined" ? "undefined" : (0, $l0HdX._)(key)));
        }
        if (wrapPrivateKey) num = $fnxE9.mod(num, N); // disabled by default, enabled for BLS
        $cOBbr.aInRange("private key", num, $c482579290144a2f$var$_1n, N); // num in range [1..N-1]
        return num;
    }
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error("ProjectivePoint expected");
    }
    // Memoized toAffine / validity check. They are heavy. Points are immutable.
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    var toAffineMemo = (0, $cOBbr.memoized)(function(p, iz) {
        var x = p.px, y = p.py, z = p.pz;
        // Fast-path for normalized points
        if (Fp.eql(z, Fp.ONE)) return {
            x: x,
            y: y
        };
        var is0 = p.is0();
        // If invZ was 0, we return zero point. However we still want to execute
        // all operations, so we replace invZ with a random number, 1.
        if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
        var ax = Fp.mul(x, iz);
        var ay = Fp.mul(y, iz);
        var zz = Fp.mul(z, iz);
        if (is0) return {
            x: Fp.ZERO,
            y: Fp.ZERO
        };
        if (!Fp.eql(zz, Fp.ONE)) throw new Error("invZ was invalid");
        return {
            x: ax,
            y: ay
        };
    });
    // NOTE: on exception this will crash 'cached' and no value will be set.
    // Otherwise true will be return
    var assertValidMemo = (0, $cOBbr.memoized)(function(p) {
        if (p.is0()) {
            // (0, 1, 0) aka ZERO is invalid in most contexts.
            // In BLS, ZERO can be serialized, so we allow it.
            // (0, 0, 0) is wrong representation of ZERO and is always invalid.
            if (CURVE.allowInfinityPoint && !Fp.is0(p.py)) return;
            throw new Error("bad point: ZERO");
        }
        // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
        var _p_toAffine = p.toAffine(), x = _p_toAffine.x, y = _p_toAffine.y;
        // Check if x, y are valid field elements
        if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error("bad point: x or y not FE");
        var left = Fp.sqr(y); // y²
        var right = weierstrassEquation(x); // x³ + ax + b
        if (!Fp.eql(left, right)) throw new Error("bad point: equation left != right");
        if (!p.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
        return true;
    });
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ var Point = /*#__PURE__*/ function() {
        "use strict";
        function Point(px, py, pz) {
            (0, $4GJKx._)(this, Point);
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error("x required");
            if (py == null || !Fp.isValid(py)) throw new Error("y required");
            if (pz == null || !Fp.isValid(pz)) throw new Error("z required");
            Object.freeze(this);
        }
        (0, $1wc17._)(Point, [
            {
                key: "x",
                get: function get() {
                    return this.toAffine().x;
                }
            },
            {
                key: "y",
                get: function get() {
                    return this.toAffine().y;
                }
            },
            {
                // "Private method", don't use it directly
                key: "_setWindowSize",
                value: function _setWindowSize(windowSize) {
                    wnaf.setWindowSize(this, windowSize);
                }
            },
            {
                // A point on curve is valid if it conforms to equation.
                key: "assertValidity",
                value: function assertValidity() {
                    assertValidMemo(this);
                }
            },
            {
                key: "hasEvenY",
                value: function hasEvenY() {
                    var y = this.toAffine().y;
                    if (Fp.isOdd) return !Fp.isOdd(y);
                    throw new Error("Field doesn't support isOdd");
                }
            },
            {
                /**
         * Compare one point to another.
         */ key: "equals",
                value: function equals(other) {
                    assertPrjPoint(other);
                    var _this = this, X1 = _this.px, Y1 = _this.py, Z1 = _this.pz;
                    var X2 = other.px, Y2 = other.py, Z2 = other.pz;
                    var U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
                    var U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
                    return U1 && U2;
                }
            },
            {
                /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ key: "negate",
                value: function negate() {
                    return new Point(this.px, Fp.neg(this.py), this.pz);
                }
            },
            {
                // Renes-Costello-Batina exception-free doubling formula.
                // There is 30% faster Jacobian formula, but it is not complete.
                // https://eprint.iacr.org/2015/1060, algorithm 3
                // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
                key: "double",
                value: function double() {
                    var a = CURVE.a, b = CURVE.b;
                    var b3 = Fp.mul(b, $c482579290144a2f$var$_3n);
                    var _this = this, X1 = _this.px, Y1 = _this.py, Z1 = _this.pz;
                    var X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
                    var t0 = Fp.mul(X1, X1); // step 1
                    var t1 = Fp.mul(Y1, Y1);
                    var t2 = Fp.mul(Z1, Z1);
                    var t3 = Fp.mul(X1, Y1);
                    t3 = Fp.add(t3, t3); // step 5
                    Z3 = Fp.mul(X1, Z1);
                    Z3 = Fp.add(Z3, Z3);
                    X3 = Fp.mul(a, Z3);
                    Y3 = Fp.mul(b3, t2);
                    Y3 = Fp.add(X3, Y3); // step 10
                    X3 = Fp.sub(t1, Y3);
                    Y3 = Fp.add(t1, Y3);
                    Y3 = Fp.mul(X3, Y3);
                    X3 = Fp.mul(t3, X3);
                    Z3 = Fp.mul(b3, Z3); // step 15
                    t2 = Fp.mul(a, t2);
                    t3 = Fp.sub(t0, t2);
                    t3 = Fp.mul(a, t3);
                    t3 = Fp.add(t3, Z3);
                    Z3 = Fp.add(t0, t0); // step 20
                    t0 = Fp.add(Z3, t0);
                    t0 = Fp.add(t0, t2);
                    t0 = Fp.mul(t0, t3);
                    Y3 = Fp.add(Y3, t0);
                    t2 = Fp.mul(Y1, Z1); // step 25
                    t2 = Fp.add(t2, t2);
                    t0 = Fp.mul(t2, t3);
                    X3 = Fp.sub(X3, t0);
                    Z3 = Fp.mul(t2, t1);
                    Z3 = Fp.add(Z3, Z3); // step 30
                    Z3 = Fp.add(Z3, Z3);
                    return new Point(X3, Y3, Z3);
                }
            },
            {
                // Renes-Costello-Batina exception-free addition formula.
                // There is 30% faster Jacobian formula, but it is not complete.
                // https://eprint.iacr.org/2015/1060, algorithm 1
                // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
                key: "add",
                value: function add(other) {
                    assertPrjPoint(other);
                    var _this = this, X1 = _this.px, Y1 = _this.py, Z1 = _this.pz;
                    var X2 = other.px, Y2 = other.py, Z2 = other.pz;
                    var X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
                    var a = CURVE.a;
                    var b3 = Fp.mul(CURVE.b, $c482579290144a2f$var$_3n);
                    var t0 = Fp.mul(X1, X2); // step 1
                    var t1 = Fp.mul(Y1, Y2);
                    var t2 = Fp.mul(Z1, Z2);
                    var t3 = Fp.add(X1, Y1);
                    var t4 = Fp.add(X2, Y2); // step 5
                    t3 = Fp.mul(t3, t4);
                    t4 = Fp.add(t0, t1);
                    t3 = Fp.sub(t3, t4);
                    t4 = Fp.add(X1, Z1);
                    var t5 = Fp.add(X2, Z2); // step 10
                    t4 = Fp.mul(t4, t5);
                    t5 = Fp.add(t0, t2);
                    t4 = Fp.sub(t4, t5);
                    t5 = Fp.add(Y1, Z1);
                    X3 = Fp.add(Y2, Z2); // step 15
                    t5 = Fp.mul(t5, X3);
                    X3 = Fp.add(t1, t2);
                    t5 = Fp.sub(t5, X3);
                    Z3 = Fp.mul(a, t4);
                    X3 = Fp.mul(b3, t2); // step 20
                    Z3 = Fp.add(X3, Z3);
                    X3 = Fp.sub(t1, Z3);
                    Z3 = Fp.add(t1, Z3);
                    Y3 = Fp.mul(X3, Z3);
                    t1 = Fp.add(t0, t0); // step 25
                    t1 = Fp.add(t1, t0);
                    t2 = Fp.mul(a, t2);
                    t4 = Fp.mul(b3, t4);
                    t1 = Fp.add(t1, t2);
                    t2 = Fp.sub(t0, t2); // step 30
                    t2 = Fp.mul(a, t2);
                    t4 = Fp.add(t4, t2);
                    t0 = Fp.mul(t1, t4);
                    Y3 = Fp.add(Y3, t0);
                    t0 = Fp.mul(t5, t4); // step 35
                    X3 = Fp.mul(t3, X3);
                    X3 = Fp.sub(X3, t0);
                    t0 = Fp.mul(t3, t1);
                    Z3 = Fp.mul(t5, Z3);
                    Z3 = Fp.add(Z3, t0); // step 40
                    return new Point(X3, Y3, Z3);
                }
            },
            {
                key: "subtract",
                value: function subtract(other) {
                    return this.add(other.negate());
                }
            },
            {
                key: "is0",
                value: function is0() {
                    return this.equals(Point.ZERO);
                }
            },
            {
                key: "wNAF",
                value: function wNAF(n) {
                    return wnaf.wNAFCached(this, n, Point.normalizeZ);
                }
            },
            {
                /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ key: "multiplyUnsafe",
                value: function multiplyUnsafe(sc) {
                    $cOBbr.aInRange("scalar", sc, $c482579290144a2f$var$_0n, CURVE.n);
                    var I = Point.ZERO;
                    if (sc === $c482579290144a2f$var$_0n) return I;
                    if (sc === $c482579290144a2f$var$_1n) return this;
                    var endo = CURVE.endo;
                    if (!endo) return wnaf.unsafeLadder(this, sc);
                    // Apply endomorphism
                    var _endo_splitScalar = endo.splitScalar(sc), k1neg = _endo_splitScalar.k1neg, k1 = _endo_splitScalar.k1, k2neg = _endo_splitScalar.k2neg, k2 = _endo_splitScalar.k2;
                    var k1p = I;
                    var k2p = I;
                    var d = this;
                    while(k1 > $c482579290144a2f$var$_0n || k2 > $c482579290144a2f$var$_0n){
                        if (k1 & $c482579290144a2f$var$_1n) k1p = k1p.add(d);
                        if (k2 & $c482579290144a2f$var$_1n) k2p = k2p.add(d);
                        d = d.double();
                        k1 >>= $c482579290144a2f$var$_1n;
                        k2 >>= $c482579290144a2f$var$_1n;
                    }
                    if (k1neg) k1p = k1p.negate();
                    if (k2neg) k2p = k2p.negate();
                    k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                    return k1p.add(k2p);
                }
            },
            {
                /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ key: "multiply",
                value: function multiply(scalar) {
                    var endo = CURVE.endo, N = CURVE.n;
                    $cOBbr.aInRange("scalar", scalar, $c482579290144a2f$var$_1n, N);
                    var point, fake; // Fake point is used to const-time mult
                    if (endo) {
                        var _endo_splitScalar = endo.splitScalar(scalar), k1neg = _endo_splitScalar.k1neg, k1 = _endo_splitScalar.k1, k2neg = _endo_splitScalar.k2neg, k2 = _endo_splitScalar.k2;
                        var _this_wNAF = this.wNAF(k1), k1p = _this_wNAF.p, f1p = _this_wNAF.f;
                        var _this_wNAF1 = this.wNAF(k2), k2p = _this_wNAF1.p, f2p = _this_wNAF1.f;
                        k1p = wnaf.constTimeNegate(k1neg, k1p);
                        k2p = wnaf.constTimeNegate(k2neg, k2p);
                        k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                        point = k1p.add(k2p);
                        fake = f1p.add(f2p);
                    } else {
                        var _this_wNAF2 = this.wNAF(scalar), p = _this_wNAF2.p, f = _this_wNAF2.f;
                        point = p;
                        fake = f;
                    }
                    // Normalize `z` for both points, but return only real one
                    return Point.normalizeZ([
                        point,
                        fake
                    ])[0];
                }
            },
            {
                /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ key: "multiplyAndAddUnsafe",
                value: function multiplyAndAddUnsafe(Q, a, b) {
                    var G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
                    var mul = function(P, a // Select faster multiply() method
                    ) {
                        return a === $c482579290144a2f$var$_0n || a === $c482579290144a2f$var$_1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
                    };
                    var sum = mul(this, a).add(mul(Q, b));
                    return sum.is0() ? undefined : sum;
                }
            },
            {
                // Converts Projective point to affine (x, y) coordinates.
                // Can accept precomputed Z^-1 - for example, from invertBatch.
                // (x, y, z) ∋ (x=x/z, y=y/z)
                key: "toAffine",
                value: function toAffine(iz) {
                    return toAffineMemo(this, iz);
                }
            },
            {
                key: "isTorsionFree",
                value: function isTorsionFree() {
                    var cofactor = CURVE.h, isTorsionFree = CURVE.isTorsionFree;
                    if (cofactor === $c482579290144a2f$var$_1n) return true; // No subgroups, always torsion-free
                    if (isTorsionFree) return isTorsionFree(Point, this);
                    throw new Error("isTorsionFree() has not been declared for the elliptic curve");
                }
            },
            {
                key: "clearCofactor",
                value: function clearCofactor() {
                    var cofactor = CURVE.h, clearCofactor = CURVE.clearCofactor;
                    if (cofactor === $c482579290144a2f$var$_1n) return this; // Fast-path
                    if (clearCofactor) return clearCofactor(Point, this);
                    return this.multiplyUnsafe(CURVE.h);
                }
            },
            {
                key: "toRawBytes",
                value: function toRawBytes() {
                    var isCompressed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                    (0, $cOBbr.abool)("isCompressed", isCompressed);
                    this.assertValidity();
                    return toBytes(Point, this, isCompressed);
                }
            },
            {
                key: "toHex",
                value: function toHex() {
                    var isCompressed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                    (0, $cOBbr.abool)("isCompressed", isCompressed);
                    return $cOBbr.bytesToHex(this.toRawBytes(isCompressed));
                }
            }
        ], [
            {
                key: "fromAffine",
                value: // Does not validate if the point is on-curve.
                // Use fromHex instead, or call assertValidity() later.
                function fromAffine(p) {
                    var _ref = p || {}, x = _ref.x, y = _ref.y;
                    if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error("invalid affine point");
                    if (p instanceof Point) throw new Error("projective point not allowed");
                    var is0 = function(i) {
                        return Fp.eql(i, Fp.ZERO);
                    };
                    // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
                    if (is0(x) && is0(y)) return Point.ZERO;
                    return new Point(x, y, Fp.ONE);
                }
            },
            {
                key: "normalizeZ",
                value: /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ function normalizeZ(points) {
                    var toInv = Fp.invertBatch(points.map(function(p) {
                        return p.pz;
                    }));
                    return points.map(function(p, i) {
                        return p.toAffine(toInv[i]);
                    }).map(Point.fromAffine);
                }
            },
            {
                key: "fromHex",
                value: /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ function fromHex(hex) {
                    var P = Point.fromAffine(fromBytes((0, $cOBbr.ensureBytes)("pointHex", hex)));
                    P.assertValidity();
                    return P;
                }
            },
            {
                key: "fromPrivateKey",
                value: // Multiplies generator point by privateKey.
                function fromPrivateKey(privateKey) {
                    return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
                }
            }
        ]);
        return Point;
    }();
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    var _bits = CURVE.nBitLength;
    var wnaf = (0, $1JA7e.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE: CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    };
}
function $c482579290144a2f$var$validateOpts(curve) {
    var opts = (0, $1JA7e.validateBasic)(curve);
    $cOBbr.validateObject(opts, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    });
    return Object.freeze((0, $do9pw._)({
        lowS: true
    }, opts));
}
function $c482579290144a2f$export$350b8ea6f1c27fae(curveDef) {
    var CURVE = $c482579290144a2f$var$validateOpts(curveDef);
    var Fp = CURVE.Fp, CURVE_ORDER = CURVE.n;
    var compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    var uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function modN(a) {
        return $fnxE9.mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return $fnxE9.invert(a, CURVE_ORDER);
    }
    var _weierstrassPoints = $c482579290144a2f$export$fa783af82e4fe0fc((0, $cxjpp._)((0, $do9pw._)({}, CURVE), {
        toBytes: function(_c, point, isCompressed) {
            var a = point.toAffine();
            var x = Fp.toBytes(a.x);
            var cat = $cOBbr.concatBytes;
            (0, $cOBbr.abool)("isCompressed", isCompressed);
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes: function(bytes) {
            var len = bytes.length;
            var head = bytes[0];
            var tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                var x = $cOBbr.bytesToNumberBE(tail);
                if (!$cOBbr.inRange(x, $c482579290144a2f$var$_1n, Fp.ORDER)) throw new Error("Point is not on curve");
                var y2 = weierstrassEquation(x); // y² = x³ + ax + b
                var y;
                try {
                    y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                } catch (sqrtError) {
                    var suffix = sqrtError instanceof Error ? ": " + sqrtError.message : "";
                    throw new Error("Point is not on curve" + suffix);
                }
                var isYOdd = (y & $c482579290144a2f$var$_1n) === $c482579290144a2f$var$_1n;
                // ECDSA
                var isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x: x,
                    y: y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                var x1 = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                var y1 = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x: x1,
                    y: y1
                };
            } else throw new Error("Point of length ".concat(len, " was invalid. Expected ").concat(compressedLen, " compressed bytes or ").concat(uncompressedLen, " uncompressed bytes"));
        }
    })), Point = _weierstrassPoints.ProjectivePoint, normPrivateKeyToScalar = _weierstrassPoints.normPrivateKeyToScalar, weierstrassEquation = _weierstrassPoints.weierstrassEquation, isWithinCurveOrder = _weierstrassPoints.isWithinCurveOrder;
    var numToNByteStr = function(num) {
        return $cOBbr.bytesToHex($cOBbr.numberToBytesBE(num, CURVE.nByteLength));
    };
    function isBiggerThanHalfOrder(number) {
        var HALF = CURVE_ORDER >> $c482579290144a2f$var$_1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    var slcNum = function(b, from, to) {
        return $cOBbr.bytesToNumberBE(b.slice(from, to));
    };
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ var Signature = /*#__PURE__*/ function() {
        "use strict";
        function Signature(r, s, recovery) {
            (0, $4GJKx._)(this, Signature);
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        (0, $1wc17._)(Signature, [
            {
                key: "assertValidity",
                value: function assertValidity() {
                    $cOBbr.aInRange("r", this.r, $c482579290144a2f$var$_1n, CURVE_ORDER); // r in [1..N]
                    $cOBbr.aInRange("s", this.s, $c482579290144a2f$var$_1n, CURVE_ORDER); // s in [1..N]
                }
            },
            {
                key: "addRecoveryBit",
                value: function addRecoveryBit(recovery) {
                    return new Signature(this.r, this.s, recovery);
                }
            },
            {
                key: "recoverPublicKey",
                value: function recoverPublicKey(msgHash) {
                    var _this = this, r = _this.r, s = _this.s, rec = _this.recovery;
                    var h = bits2int_modN((0, $cOBbr.ensureBytes)("msgHash", msgHash)); // Truncate hash
                    if (rec == null || ![
                        0,
                        1,
                        2,
                        3
                    ].includes(rec)) throw new Error("recovery id invalid");
                    var radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
                    if (radj >= Fp.ORDER) throw new Error("recovery id 2 or 3 invalid");
                    var prefix = (rec & 1) === 0 ? "02" : "03";
                    var R = Point.fromHex(prefix + numToNByteStr(radj));
                    var ir = invN(radj); // r^-1
                    var u1 = modN(-h * ir); // -hr^-1
                    var u2 = modN(s * ir); // sr^-1
                    var Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
                    if (!Q) throw new Error("point at infinify"); // unsafe is fine: no priv data leaked
                    Q.assertValidity();
                    return Q;
                }
            },
            {
                // Signatures should be low-s, to prevent malleability.
                key: "hasHighS",
                value: function hasHighS() {
                    return isBiggerThanHalfOrder(this.s);
                }
            },
            {
                key: "normalizeS",
                value: function normalizeS() {
                    return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
                }
            },
            {
                // DER-encoded
                key: "toDERRawBytes",
                value: function toDERRawBytes() {
                    return $cOBbr.hexToBytes(this.toDERHex());
                }
            },
            {
                key: "toDERHex",
                value: function toDERHex() {
                    return $c482579290144a2f$export$56ac33195d7076db.hexFromSig({
                        r: this.r,
                        s: this.s
                    });
                }
            },
            {
                // padded bytes of r, then padded bytes of s
                key: "toCompactRawBytes",
                value: function toCompactRawBytes() {
                    return $cOBbr.hexToBytes(this.toCompactHex());
                }
            },
            {
                key: "toCompactHex",
                value: function toCompactHex() {
                    return numToNByteStr(this.r) + numToNByteStr(this.s);
                }
            }
        ], [
            {
                key: "fromCompact",
                value: // pair (bytes of r, bytes of s)
                function fromCompact(hex) {
                    var l = CURVE.nByteLength;
                    hex = (0, $cOBbr.ensureBytes)("compactSignature", hex, l * 2);
                    return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
                }
            },
            {
                key: "fromDER",
                value: // DER encoded ECDSA signature
                // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
                function fromDER(hex) {
                    var _DER_toSig = $c482579290144a2f$export$56ac33195d7076db.toSig((0, $cOBbr.ensureBytes)("DER", hex)), r = _DER_toSig.r, s = _DER_toSig.s;
                    return new Signature(r, s);
                }
            }
        ]);
        return Signature;
    }();
    var utils = {
        isValidPrivateKey: function(privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: function() {
            var length = $fnxE9.getMinHashLength(CURVE.n);
            return $fnxE9.mapHashToField(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute: function() {
            var windowSize = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 8, point = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Point.BASE;
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey) {
        var isCompressed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        var arr = $cOBbr.isBytes(item);
        var str = typeof item === "string";
        var len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB) {
        var isCompressed = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        if (isProbPub(privateA)) throw new Error("first arg must be private key");
        if (!isProbPub(publicB)) throw new Error("second arg must be public key");
        var b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    var bits2int = CURVE.bits2int || function(bytes) {
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        var num = $cOBbr.bytesToNumberBE(bytes); // check for == u8 done here
        var delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    var bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    var ORDER_MASK = $cOBbr.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        $cOBbr.aInRange("num < 2^".concat(CURVE.nBitLength), num, $c482579290144a2f$var$_0n, ORDER_MASK);
        // works with order, can have different size than numToField!
        return $cOBbr.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order, this will be wrong at least for P521.
    // Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey) {
        var opts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultSigOpts;
        var _ut;
        if ([
            "recovered",
            "canonical"
        ].some(function(k) {
            return k in opts;
        })) throw new Error("sign() legacy options not supported");
        var hash = CURVE.hash, randomBytes = CURVE.randomBytes;
        var lowS = opts.lowS, prehash = opts.prehash, ent = opts.extraEntropy; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, $cOBbr.ensureBytes)("msgHash", msgHash);
        $c482579290144a2f$var$validateSigVerOpts(opts);
        if (prehash) msgHash = (0, $cOBbr.ensureBytes)("prehashed msgHash", hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        var h1int = bits2int_modN(msgHash);
        var d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        var seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null && ent !== false) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            var e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, $cOBbr.ensureBytes)("extraEntropy", e)); // check for being bytes
        }
        var seed = (_ut = $cOBbr).concatBytes.apply(_ut, (0, $c6Xmf._)(seedArgs)); // Step D of RFC6979 3.2
        var m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            var k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            var ik = invN(k); // k^-1 mod n
            var q = Point.BASE.multiply(k).toAffine(); // q = Gk
            var r = modN(q.x); // r = q.x mod n
            if (r === $c482579290144a2f$var$_0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            var s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === $c482579290144a2f$var$_0n) return;
            var recovery = (q.x === r ? 0 : 2) | Number(q.y & $c482579290144a2f$var$_1n); // recovery bit (2 or 3, when q.x > n)
            var normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    var defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    var defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey) {
        var opts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultSigOpts;
        var _prepSig = prepSig(msgHash, privKey, opts), seed = _prepSig.seed, k2sig = _prepSig.k2sig; // Steps A, D of RFC6979 3.2.
        var C = CURVE;
        var drbg = $cOBbr.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey) {
        var opts = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : defaultVerOpts;
        var _Point_BASE_multiplyAndAddUnsafe;
        var sg = signature;
        msgHash = (0, $cOBbr.ensureBytes)("msgHash", msgHash);
        publicKey = (0, $cOBbr.ensureBytes)("publicKey", publicKey);
        if ("strict" in opts) throw new Error("options.strict was renamed to lowS");
        $c482579290144a2f$var$validateSigVerOpts(opts);
        var lowS = opts.lowS, prehash = opts.prehash;
        var _sig = undefined;
        var P;
        try {
            if (typeof sg === "string" || $cOBbr.isBytes(sg)) // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
            // Since DER can also be 2*nByteLength bytes, we check for it first.
            try {
                _sig = Signature.fromDER(sg);
            } catch (derError) {
                if (!(derError instanceof $c482579290144a2f$export$56ac33195d7076db.Err)) throw derError;
                _sig = Signature.fromCompact(sg);
            }
            else if (typeof sg === "object" && (0, $l0HdX._)(sg.r) === "bigint" && (0, $l0HdX._)(sg.s) === "bigint") {
                var r = sg.r, s = sg.s;
                _sig = new Signature(r, s);
            } else throw new Error("PARSE");
            P = Point.fromHex(publicKey);
        } catch (error) {
            if (error.message === "PARSE") throw new Error("signature must be Signature instance, Uint8Array or hex string");
            return false;
        }
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        var r1 = _sig.r, s1 = _sig.s;
        var h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        var is = invN(s1); // s^-1
        var u1 = modN(h * is); // u1 = hs^-1 mod n
        var u2 = modN(r1 * is); // u2 = rs^-1 mod n
        var R = (_Point_BASE_multiplyAndAddUnsafe = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)) === null || _Point_BASE_multiplyAndAddUnsafe === void 0 ? void 0 : _Point_BASE_multiplyAndAddUnsafe.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        var v = modN(R.x);
        return v === r1;
    }
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        sign: sign,
        verify: verify,
        ProjectivePoint: Point,
        Signature: Signature,
        utils: utils
    };
}
function $c482579290144a2f$export$8324ae9483e33241(Fp, Z) {
    // Generic implementation
    var q = Fp.ORDER;
    var l = $c482579290144a2f$var$_0n;
    for(var o = q - $c482579290144a2f$var$_1n; o % $c482579290144a2f$var$_2n === $c482579290144a2f$var$_0n; o /= $c482579290144a2f$var$_2n)l += $c482579290144a2f$var$_1n;
    var c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    var _2n_pow_c1_1 = $c482579290144a2f$var$_2n << c1 - $c482579290144a2f$var$_1n - $c482579290144a2f$var$_1n;
    var _2n_pow_c1 = _2n_pow_c1_1 * $c482579290144a2f$var$_2n;
    var c2 = (q - $c482579290144a2f$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    var c3 = (c2 - $c482579290144a2f$var$_1n) / $c482579290144a2f$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    var c4 = _2n_pow_c1 - $c482579290144a2f$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    var c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    var c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    var c7 = Fp.pow(Z, (c2 + $c482579290144a2f$var$_1n) / $c482579290144a2f$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    var sqrtRatio = function(u, v) {
        var tv1 = c6; // 1. tv1 = c6
        var tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        var tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        var tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        var tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        var isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(var i = c1; i > $c482579290144a2f$var$_1n; i--){
            var tv51 = i - $c482579290144a2f$var$_2n; // 18.    tv5 = i - 2
            tv51 = $c482579290144a2f$var$_2n << tv51 - $c482579290144a2f$var$_1n; // 19.    tv5 = 2^tv5
            var tvv5 = Fp.pow(tv4, tv51); // 20.    tv5 = tv4^tv5
            var e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $c482579290144a2f$var$_4n === $c482579290144a2f$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        var c11 = (Fp.ORDER - $c482579290144a2f$var$_3n) / $c482579290144a2f$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        var c21 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = function(u, v) {
            var tv1 = Fp.sqr(v); // 1. tv1 = v^2
            var tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            var y1 = Fp.pow(tv1, c11); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            var y2 = Fp.mul(y1, c21); // 6. y2 = y1 * c2
            var tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            var isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            var y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
function $c482579290144a2f$export$cc7fea9756a17416(Fp, opts) {
    $fnxE9.validateField(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
    var sqrtRatio = $c482579290144a2f$export$8324ae9483e33241(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error("Fp.isOdd is not implemented!");
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return function(u) {
        // prettier-ignore
        var tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        var _sqrtRatio = sqrtRatio(tv2, tv6), isValid = _sqrtRatio.isValid, value = _sqrtRatio.value; // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        var e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}

});




parcelRegister("aC4HZ", function(module, exports) {

var $jBETC = parcelRequire("jBETC");
var $7ba11b046e59b4ca$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
module.exports = $jBETC($7ba11b046e59b4ca$var$ALPHABET);

});
parcelRegister("jBETC", function(module, exports) {
"use strict";
// base-x encoding / decoding
// Copyright (c) 2018 base-x contributors
// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
function $e461322701f6bc67$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
module.exports = $e461322701f6bc67$var$base;

});


parcelRegister("l4Sju", function(module, exports) {

$parcel$export(module.exports, "SolanaSignAndSendTransaction", function () { return $f5841a357062ca0c$export$dd64f32469f35f81; });
/** Name of the feature. */ var $f5841a357062ca0c$export$dd64f32469f35f81 = "solana:signAndSendTransaction";

});

parcelRegister("e8TeL", function(module, exports) {

$parcel$export(module.exports, "SolanaSignTransaction", function () { return $a4bca8f6b591c5fd$export$54187c3796d0ecb; });
/** Name of the feature. */ var $a4bca8f6b591c5fd$export$54187c3796d0ecb = "solana:signTransaction";

});

parcelRegister("l0pK9", function(module, exports) {

$parcel$export(module.exports, "SolanaSignMessage", function () { return $f4ad9123e3795404$export$22c7939a38084172; });
/** Name of the feature. */ var $f4ad9123e3795404$export$22c7939a38084172 = "solana:signMessage";

});

parcelRegister("3Jk4b", function(module, exports) {

var $l0HdX = parcelRequire("l0HdX");
/* UAParser.js v1.0.38
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */ (function(window1, undefined1) {
    "use strict";
    var LIBVERSION = "1.0.38", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 500;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS";
    var extend = function extend(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function enumerize(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function has(str1, str2) {
        return (typeof str1 === "undefined" ? "undefined" : (0, $l0HdX._)(str1)) === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function lowerize(str) {
        return str.toLowerCase();
    }, majorize = function majorize(version) {
        return (typeof version === "undefined" ? "undefined" : (0, $l0HdX._)(version)) === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined1;
    }, trim = function trim(str, len) {
        if ((typeof str === "undefined" ? "undefined" : (0, $l0HdX._)(str)) === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return (typeof len === "undefined" ? "undefined" : (0, $l0HdX._)(len)) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    var rgxMapper = function rgxMapper(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1];
            j = k = 0;
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    if ((typeof q === "undefined" ? "undefined" : (0, $l0HdX._)(q)) === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if ((0, $l0HdX._)(q[1]) == FUNC_TYPE) this[q[0]] = q[1].call(this, match);
                            else this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            if ((0, $l0HdX._)(q[1]) === FUNC_TYPE && !(q[1].exec && q[1].test)) this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined1;
                            else this[q[0]] = match ? match.replace(q[1], q[2]) : undefined1;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined1;
                    } else this[q] = match ? match : undefined1;
                }
            }
            i += 2;
        }
    }, strMapper = function strMapper(str, map) {
        for(var i in map){
            if ((0, $l0HdX._)(map[i]) === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined1 : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined1 : i;
        }
        return str;
    };
    var oldSafariMap = {
        "1.0": "/8",
        1.2: "/1",
        1.3: "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2e3: "NT 5.0",
        XP: [
            "NT 5.1",
            "NT 5.2"
        ],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        8.1: "NT 6.3",
        10: [
            "NT 6.4",
            "NT 10.0"
        ],
        RT: "ARM"
    };
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bop(?:rg)?x\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " GX"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Baidu"
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                /(heytap|ovi)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bddg\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "DuckDuckGo"
                ]
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Smart Lenovo " + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI " + BROWSER
                ]
            ],
            [
                /fxios\/([-\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihu|(qi?ho?o?|360)browser/i
            ],
            [
                [
                    NAME,
                    "360 " + BROWSER
                ]
            ],
            [
                /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 " + BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + " Internet"
                ]
            ],
            [
                /(comodo_dragon)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /_/g,
                    " "
                ],
                VERSION
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Sogou Explorer"
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i
            ],
            [
                [
                    NAME,
                    "Sogou Mobile"
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser)/i,
                /\[(linkedin)app\]/i
            ],
            [
                NAME
            ],
            [
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "TikTok"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(navigator|netscape\d?)\/([-\w\.]+)/i
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                /(links) \(([\w\.]+)/i,
                /panasonic;(viera)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(cobalt)\/([\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]([-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei|honor)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(opd2\d{3}a?) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Lenovo"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    "Nokia"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(pixel c)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OnePlus"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(playbook);[-\w\),; ]+(rim)/i
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(nexus 9)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Ulefone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /smart-tv.+(samsung)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /((pebble))app/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(quest( \d| pro)?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                /microsoft (windows) (vista|xp)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    "Windows"
                ]
            ],
            [
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "watchOS"
                ]
            ],
            [
                /crkey\/([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    var UAParser = function UAParser1(ua, extensions) {
        if ((typeof ua === "undefined" ? "undefined" : (0, $l0HdX._)(ua)) === OBJ_TYPE) {
            extensions = ua;
            ua = undefined1;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = (typeof window1 === "undefined" ? "undefined" : (0, $l0HdX._)(window1)) !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined1;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined1;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined1;
            _browser[VERSION] = undefined1;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            if (_isSelfNav && _navigator && _navigator.brave && (0, $l0HdX._)(_navigator.brave.isBrave) == FUNC_TYPE) _browser[NAME] = "Brave";
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined1;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined1;
            _device[MODEL] = undefined1;
            _device[TYPE] = undefined1;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && (0, $l0HdX._)(_navigator.standalone) !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = "iPad";
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined1;
            _engine[VERSION] = undefined1;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined1;
            _os[VERSION] = undefined1;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != "Unknown") _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS);
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = (typeof ua === "undefined" ? "undefined" : (0, $l0HdX._)(ua)) === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    if ("object" !== UNDEF_TYPE) {
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        if ((typeof define === "undefined" ? "undefined" : (0, $l0HdX._)(define)) === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if ((typeof window1 === "undefined" ? "undefined" : (0, $l0HdX._)(window1)) !== UNDEF_TYPE) window1.UAParser = UAParser;
    }
    var $ = (typeof window1 === "undefined" ? "undefined" : (0, $l0HdX._)(window1)) !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser;
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : undefined);

});

parcelRegister("7GSQG", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("gY6yq")).then(function() {
    return parcelRequire("avAvn");
});

});

parcelRegister("2iaeM", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("jcCJq")).then(function() {
    return parcelRequire("6CMwV");
});

});

var $7e941d9b4523819a$exports = {};


(parcelRequire("bRvn3")).register((parcelRequire("6Aq0R")).getBundleURL("jWbtw"), JSON.parse('["jWbtw","index.js","1SXpj","BTCLogo.5558c6c7.svg","3d4dC","EthLogo.13b90052.svg","2xFU5","BNBLogo.3dada3dc.svg","4YQRC","DogeLogo.58faeab6.svg","1dWB0","Solana.f2db1e5a.png","j400Y","LitecoinLogo.f8fad246.svg","4mv4p","DashLogo.ac107e85.svg","5tU2C","CardanoLogo.c8e54c54.svg","6CUfP","XMRLogo.26608d9e.svg","710Jf","TetherLogo.6d30f474.svg","hpIYx","USDCLogo.08b3a902.svg","elZOq","PolygonLogo.dda6f433.svg","6K552","Doge.9d700487.png","jMPu3","ZcashLogo.5ee68c2f.svg","36rPp","BAT.1212afba.svg","bDOcu","BUSDLogo.a70524b3.svg","1nReP","DOT.8f378c19.svg","bfxXE","TronLogo.a023c6a9.svg","CO1ij","VerseLogo.e24b56c2.png","adG9e","ArbitrumLogo.4a7518b6.svg","3Un2u","AvalancheLogo.ad53a0d0.svg","3RuEC","BaseLogo.e87313d9.svg","d2Ske","exports.c0838095.js","eDVZM","w3m-modal.d2ce20b9.js","amd2r","dist.409e7433.js","gS36p","dist.64161a0e.js","kxwhk","ccip.6b617973.js","QlhGd","dist.95037bf1.js","3FJXC","dist.b0665238.js","eLVyC","dist.d8e508b8.js","cXEex","EUROCLogo.e814427f.svg","m65aS","FRAXLogo.493412e4.svg","aiJVz","DaiLogo.5b7d885d.svg","dnwEn","WETH.6226dbd9.svg","drePn","GeminiLogo.5cbba47e.png","gjAVa","TORLogo.bd732ad4.svg","49hTq","TUSDLogo.df934baa.svg","fzOiy","USDPLogo.d2d050af.svg","j59vZ","TetherGoldLogo.5d02ace7.svg","8nu8V","PRQLogo.ef7c079b.svg","iRHZ4","PAXGLogo.814ce36e.svg","9nk4P","MIMLogo.ea9454b3.svg","7PB3Q","FantomLogo.59ea410b.svg","fBsEy","WrappedBitcoin.a9abc558.svg","bSc5f","DAIKLogo.7aa105ad.png","4ykDS","ETHKLogo.b79115fc.png","7OjEc","BTCKLogo.9770427e.png","1S15D","WOKTLogo.2376971f.png","eyliT","OKBLogo.8b0e77b3.png","gY6yq","esm.7c58656d.js","jcCJq","esm.81606749.js","84MRO","Wave.2a680c9e.svg","fN5hy","index.css"]'));

var $78b37e1ff5a5ba28$exports = {};
"use strict";

$78b37e1ff5a5ba28$exports = (parcelRequire("hxSYn"));


parcelRequire("1Mpn7");
var $26fa11aab20bccf7$export$882461b6382ed46c;
var $26fa11aab20bccf7$export$757ceba2d55c277e;
"use strict";
var $aca89270c978b9c1$exports = {};
"use strict";
function $aca89270c978b9c1$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($aca89270c978b9c1$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$aca89270c978b9c1$var$checkDCE();

$aca89270c978b9c1$exports = (parcelRequire("6A8xk"));


var $26fa11aab20bccf7$var$i;
$26fa11aab20bccf7$export$882461b6382ed46c = $aca89270c978b9c1$exports.createRoot;
$26fa11aab20bccf7$export$757ceba2d55c277e = $aca89270c978b9c1$exports.hydrateRoot;



parcelRequire("1Mpn7");

var $1Mpn7 = parcelRequire("1Mpn7");

var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $c6Xmf = parcelRequire("c6Xmf");

var $eha6O = parcelRequire("eha6O");

var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $eha6O = parcelRequire("eha6O");

var $eha6O = parcelRequire("eha6O");
var $f8aa10d203403d99$var$isReconnecting = false;
function $f8aa10d203403d99$export$f0e7018a430fa792(config) {
    return $f8aa10d203403d99$var$_reconnect.apply(this, arguments);
}
function $f8aa10d203403d99$var$_reconnect() {
    $f8aa10d203403d99$var$_reconnect = (0, $kSuI9._)(function(config) {
        var parameters, _connectors, _parameters_connectors, connectors, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, connector_, connector, recentConnectorId, _config_storage, e, scores, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, _step_value, connection, sorted, connected, connections, providers, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _loop, _iterator2, _step2, err;
        var _arguments = arguments;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    parameters = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    // If already reconnecting, do nothing
                    if ($f8aa10d203403d99$var$isReconnecting) return [
                        2,
                        []
                    ];
                    $f8aa10d203403d99$var$isReconnecting = true;
                    config.setState(function(x) {
                        return (0, $cxjpp._)((0, $do9pw._)({}, x), {
                            status: x.current ? "reconnecting" : "connecting"
                        });
                    });
                    connectors = [];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if ((_parameters_connectors = parameters.connectors) === null || _parameters_connectors === void 0 ? void 0 : _parameters_connectors.length) try {
                        for(_iterator = parameters.connectors[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            connector_ = _step.value;
                            connector = void 0;
                            // "Register" connector if not already created
                            if (typeof connector_ === "function") connector = config._internal.connectors.setup(connector_);
                            else connector = connector_;
                            connectors.push(connector);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    else (_connectors = connectors).push.apply(_connectors, (0, $c6Xmf._)(config.connectors));
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (_config_storage = config.storage) === null || _config_storage === void 0 ? void 0 : _config_storage.getItem("recentConnectorId")
                    ];
                case 2:
                    recentConnectorId = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 4:
                    scores = {};
                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(_iterator1 = config.state.connections[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            _step_value = (0, $cv9Rk._)(_step1.value, 2), connection = _step_value[1];
                            scores[connection.connector.id] = 1;
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    if (recentConnectorId) scores[recentConnectorId] = 0;
                    sorted = Object.keys(scores).length > 0 ? (0, $c6Xmf._)(connectors).sort(function(a, b) {
                        var _scores_a_id, _scores_b_id;
                        return ((_scores_a_id = scores[a.id]) !== null && _scores_a_id !== void 0 ? _scores_a_id : 10) - ((_scores_b_id = scores[b.id]) !== null && _scores_b_id !== void 0 ? _scores_b_id : 10);
                    }) : connectors;
                    // Iterate through each connector and try to connect
                    connected = false;
                    connections = [];
                    providers = [];
                    _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    _state.label = 5;
                case 5:
                    _state.trys.push([
                        5,
                        10,
                        11,
                        12
                    ]);
                    _loop = function() {
                        var connector, provider, isAuthorized, data;
                        return (0, $eha6O.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    connector = _step2.value;
                                    return [
                                        4,
                                        connector.getProvider().catch(function() {
                                            return undefined;
                                        })
                                    ];
                                case 1:
                                    provider = _state.sent();
                                    if (!provider) return [
                                        2,
                                        "continue"
                                    ];
                                    // If we already have an instance of this connector's provider,
                                    // then we have already checked it (ie. injected connectors can
                                    // share the same `window.ethereum` instance, so we don't want to
                                    // connect to it again).
                                    if (providers.some(function(x) {
                                        return x === provider;
                                    })) return [
                                        2,
                                        "continue"
                                    ];
                                    return [
                                        4,
                                        connector.isAuthorized()
                                    ];
                                case 2:
                                    isAuthorized = _state.sent();
                                    if (!isAuthorized) return [
                                        2,
                                        "continue"
                                    ];
                                    return [
                                        4,
                                        connector.connect({
                                            isReconnecting: true
                                        }).catch(function() {
                                            return null;
                                        })
                                    ];
                                case 3:
                                    data = _state.sent();
                                    if (!data) return [
                                        2,
                                        "continue"
                                    ];
                                    connector.emitter.off("connect", config._internal.events.connect);
                                    connector.emitter.on("change", config._internal.events.change);
                                    connector.emitter.on("disconnect", config._internal.events.disconnect);
                                    config.setState(function(x) {
                                        var connections = new Map(connected ? x.connections : new Map()).set(connector.uid, {
                                            accounts: data.accounts,
                                            chainId: data.chainId,
                                            connector: connector
                                        });
                                        return (0, $cxjpp._)((0, $do9pw._)({}, x), {
                                            current: connected ? x.current : connector.uid,
                                            connections: connections
                                        });
                                    });
                                    connections.push({
                                        accounts: data.accounts,
                                        chainId: data.chainId,
                                        connector: connector
                                    });
                                    providers.push(provider);
                                    connected = true;
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    _iterator2 = sorted[Symbol.iterator]();
                    _state.label = 6;
                case 6:
                    if (!!(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done)) return [
                        3,
                        9
                    ];
                    return [
                        5,
                        (0, $eha6O.__values)(_loop())
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    _iteratorNormalCompletion2 = true;
                    return [
                        3,
                        6
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                    return [
                        3,
                        12
                    ];
                case 11:
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                            _iterator2.return();
                        }
                    } finally{
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                    return [
                        7
                    ];
                case 12:
                    // Prevent overwriting connected status from race condition
                    if (config.state.status === "reconnecting" || config.state.status === "connecting") {
                        // If connecting didn't succeed, set to disconnected
                        if (!connected) config.setState(function(x) {
                            return (0, $cxjpp._)((0, $do9pw._)({}, x), {
                                connections: new Map(),
                                current: null,
                                status: "disconnected"
                            });
                        });
                        else config.setState(function(x) {
                            return (0, $cxjpp._)((0, $do9pw._)({}, x), {
                                status: "connected"
                            });
                        });
                    }
                    $f8aa10d203403d99$var$isReconnecting = false;
                    return [
                        2,
                        connections
                    ];
            }
        });
    });
    return $f8aa10d203403d99$var$_reconnect.apply(this, arguments);
}


function $d217a0ed0af65bfa$export$fa8d919ba61d84db(config, parameters) {
    var initialState = parameters.initialState, reconnectOnMount = parameters.reconnectOnMount;
    if (initialState && !config._internal.store.persist.hasHydrated()) config.setState((0, $cxjpp._)((0, $do9pw._)({}, initialState), {
        chainId: config.chains.some(function(x) {
            return x.id === initialState.chainId;
        }) ? initialState.chainId : config.chains[0].id,
        connections: reconnectOnMount ? initialState.connections : new Map(),
        status: reconnectOnMount ? "reconnecting" : "disconnected"
    }));
    return {
        onMount: function() {
            return (0, $kSuI9._)(function() {
                var _config__internal_mipd, mipdConnectors;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!config._internal.ssr) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                config._internal.store.persist.rehydrate()
                            ];
                        case 1:
                            _state.sent();
                            mipdConnectors = (_config__internal_mipd = config._internal.mipd) === null || _config__internal_mipd === void 0 ? void 0 : _config__internal_mipd.getProviders().map(config._internal.connectors.providerDetailToConnector).map(config._internal.connectors.setup);
                            config._internal.connectors.setState(function(connectors) {
                                return (0, $c6Xmf._)(connectors).concat((0, $c6Xmf._)(mipdConnectors !== null && mipdConnectors !== void 0 ? mipdConnectors : []));
                            });
                            _state.label = 2;
                        case 2:
                            if (reconnectOnMount) (0, $f8aa10d203403d99$export$f0e7018a430fa792)(config);
                            else if (config.storage) // Reset connections that may have been hydrated from storage.
                            config.setState(function(x) {
                                return (0, $cxjpp._)((0, $do9pw._)({}, x), {
                                    connections: new Map()
                                });
                            });
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    };
}



var $1Mpn7 = parcelRequire("1Mpn7");
"use client";
function $7b11dfe918db1a2a$export$f49feec8afe53ddd(parameters) {
    var children = parameters.children, config = parameters.config, initialState = parameters.initialState, _parameters_reconnectOnMount = parameters.reconnectOnMount, reconnectOnMount = _parameters_reconnectOnMount === void 0 ? true : _parameters_reconnectOnMount;
    var onMount = (0, $d217a0ed0af65bfa$export$fa8d919ba61d84db)(config, {
        initialState: initialState,
        reconnectOnMount: reconnectOnMount
    }).onMount;
    // Hydrate for non-SSR
    if (!config._internal.ssr) onMount();
    // Hydrate for SSR
    var active = (0, $1Mpn7.useRef)(true);
    // biome-ignore lint/correctness/useExhaustiveDependencies: `queryKey` not required
    (0, $1Mpn7.useEffect)(function() {
        if (!active.current) return;
        if (!config._internal.ssr) return;
        onMount();
        return function() {
            active.current = false;
        };
    }, []);
    return children;
}


"use client";
var $6de5ee6f9b442f8a$export$da7c16611087c70c = (0, $1Mpn7.createContext)(undefined);
function $6de5ee6f9b442f8a$export$a28463dc600bc9f8(parameters) {
    var children = parameters.children, config = parameters.config;
    var props = {
        value: config
    };
    return (0, $1Mpn7.createElement)((0, $7b11dfe918db1a2a$export$f49feec8afe53ddd), parameters, (0, $1Mpn7.createElement)($6de5ee6f9b442f8a$export$da7c16611087c70c.Provider, props, children));
}


// src/queryClient.ts

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");
function $3232ea9968b43bd1$export$71511d61b312f219(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}


function $c6741cbfa14e53b2$export$71511d61b312f219(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}


function $8c2a5b50554ee522$export$71511d61b312f219(receiver, privateMap) {
    var descriptor = (0, $c6741cbfa14e53b2$export$71511d61b312f219)(receiver, privateMap, "get");
    return (0, $3232ea9968b43bd1$export$71511d61b312f219)(receiver, descriptor);
}


function $5675f70fde6ccf00$export$71511d61b312f219(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}


function $d4584ce6f6a30a88$export$71511d61b312f219(obj, privateMap, value) {
    (0, $5675f70fde6ccf00$export$71511d61b312f219)(obj, privateMap);
    privateMap.set(obj, value);
}


function $4871340d5bc3802e$export$71511d61b312f219(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}



function $124143cbdcf95d51$export$71511d61b312f219(receiver, privateMap, value) {
    var descriptor = (0, $c6741cbfa14e53b2$export$71511d61b312f219)(receiver, privateMap, "set");
    (0, $4871340d5bc3802e$export$71511d61b312f219)(receiver, descriptor, value);
    return value;
}


function $220196be873b181b$export$71511d61b312f219(receiver, descriptor) {
    if (descriptor.set) {
        if (!descriptor.get) throw new TypeError("attempted to read set only private field");
        if (!("__destrWrapper" in descriptor)) descriptor.__destrWrapper = {
            set value (v){
                descriptor.set.call(receiver, v);
            },
            get value () {
                return descriptor.get.call(receiver);
            }
        };
        return descriptor.__destrWrapper;
    } else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        return descriptor;
    }
}



function $e6af5fa487922a1e$export$71511d61b312f219(receiver, privateMap) {
    var descriptor = (0, $c6741cbfa14e53b2$export$71511d61b312f219)(receiver, privateMap, "update");
    return (0, $220196be873b181b$export$71511d61b312f219)(receiver, descriptor);
}



var $1wc17 = parcelRequire("1wc17");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $c6Xmf = parcelRequire("c6Xmf");

var $eha6O = parcelRequire("eha6O");
// src/utils.ts

var $c6Xmf = parcelRequire("c6Xmf");

var $l0HdX = parcelRequire("l0HdX");
var $af19fbfda254a923$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $af19fbfda254a923$export$8793edee2d425525() {
    return void 0;
}
function $af19fbfda254a923$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $af19fbfda254a923$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $af19fbfda254a923$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $af19fbfda254a923$export$cb3145f011bda3ac(staleTime, query) {
    return typeof staleTime === "function" ? staleTime(query) : staleTime;
}
function $af19fbfda254a923$export$8c88ee6f2357230d(enabled, query) {
    return typeof enabled === "function" ? enabled(query) : enabled;
}
function $af19fbfda254a923$export$c5d1efe363797780(filters, query) {
    var _filters_type = filters.type, type = _filters_type === void 0 ? "all" : _filters_type, exact = filters.exact, fetchStatus = filters.fetchStatus, predicate = filters.predicate, queryKey = filters.queryKey, stale = filters.stale;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $af19fbfda254a923$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$af19fbfda254a923$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        var isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $af19fbfda254a923$export$a1ea5fb559f63ae3(filters, mutation) {
    var exact = filters.exact, status = filters.status, predicate = filters.predicate, mutationKey = filters.mutationKey;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($af19fbfda254a923$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $af19fbfda254a923$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$af19fbfda254a923$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $af19fbfda254a923$export$cc90ca97bc0d73fd(queryKey, options) {
    var hashFn = (options === null || options === void 0 ? void 0 : options.queryKeyHashFn) || $af19fbfda254a923$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $af19fbfda254a923$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, function(_, val) {
        return $af19fbfda254a923$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce(function(result, key) {
            result[key] = val[key];
            return result;
        }, {}) : val;
    });
}
function $af19fbfda254a923$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if ((typeof a === "undefined" ? "undefined" : (0, $l0HdX._)(a)) !== (typeof b === "undefined" ? "undefined" : (0, $l0HdX._)(b))) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some(function(key) {
        return !$af19fbfda254a923$export$2f07189bb9fa26a7(a[key], b[key]);
    });
    return false;
}
function $af19fbfda254a923$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    var array = $af19fbfda254a923$export$7a8558113332b71e(a) && $af19fbfda254a923$export$7a8558113332b71e(b);
    if (array || $af19fbfda254a923$export$53b83ca8eaab0383(a) && $af19fbfda254a923$export$53b83ca8eaab0383(b)) {
        var aItems = array ? a : Object.keys(a);
        var aSize = aItems.length;
        var bItems = array ? b : Object.keys(b);
        var bSize = bItems.length;
        var copy = array ? [] : {};
        var equalItems = 0;
        for(var i = 0; i < bSize; i++){
            var key = array ? i : bItems[i];
            if ((!array && aItems.includes(key) || array) && a[key] === void 0 && b[key] === void 0) {
                copy[key] = void 0;
                equalItems++;
            } else {
                copy[key] = $af19fbfda254a923$export$77a71fc411098696(a[key], b[key]);
                if (copy[key] === a[key] && a[key] !== void 0) equalItems++;
            }
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $af19fbfda254a923$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(var key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $af19fbfda254a923$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $af19fbfda254a923$export$53b83ca8eaab0383(o) {
    if (!$af19fbfda254a923$var$hasObjectPrototype(o)) return false;
    var ctor = o.constructor;
    if (ctor === void 0) return true;
    var prot = ctor.prototype;
    if (!$af19fbfda254a923$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (Object.getPrototypeOf(o) !== Object.prototype) return false;
    return true;
}
function $af19fbfda254a923$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $af19fbfda254a923$export$e772c8ff12451969(timeout) {
    return new Promise(function(resolve) {
        setTimeout(resolve, timeout);
    });
}
function $af19fbfda254a923$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        var error;
        return $af19fbfda254a923$export$77a71fc411098696(prevData, data);
    }
    return data;
}
function $af19fbfda254a923$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $af19fbfda254a923$export$ccce65a22a26f2bc(items, item) {
    var max = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var newItems = (0, $c6Xmf._)(items).concat([
        item
    ]);
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $af19fbfda254a923$export$8c6246b73dd61f4a(items, item) {
    var max = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var newItems = [
        item
    ].concat((0, $c6Xmf._)(items));
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var $af19fbfda254a923$export$1aa5a89531b7670d = Symbol();
function $af19fbfda254a923$export$c71c44209368a3bc(options, fetchOptions) {
    if (!options.queryFn && (fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.initialPromise)) return function() {
        return fetchOptions.initialPromise;
    };
    if (!options.queryFn || options.queryFn === $af19fbfda254a923$export$1aa5a89531b7670d) return function() {
        return Promise.reject(new Error("Missing queryFn: '".concat(options.queryHash, "'")));
    };
    return options.queryFn;
}


// src/queryCache.ts

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");




var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $do9pw = parcelRequire("do9pw");

var $c6Xmf = parcelRequire("c6Xmf");

var $ohfOJ = parcelRequire("ohfOJ");

// src/query.ts

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");



function $a66360d689e7ada3$export$71511d61b312f219(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}



function $4ba5d20095745f8e$export$71511d61b312f219(obj, privateSet) {
    (0, $5675f70fde6ccf00$export$71511d61b312f219)(obj, privateSet);
    privateSet.add(obj);
}



var $1wc17 = parcelRequire("1wc17");

var $04RAu = parcelRequire("04RAu");

var $b8Rim = parcelRequire("b8Rim");

var $dcsZi = parcelRequire("dcsZi");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $ohfOJ = parcelRequire("ohfOJ");

// src/notifyManager.ts

var $c6Xmf = parcelRequire("c6Xmf");
function $13a3a02e43f53625$export$316a8efd03cd1458() {
    var queue = [];
    var transactions = 0;
    var notifyFn = function(callback) {
        callback();
    };
    var batchNotifyFn = function(callback) {
        callback();
    };
    var scheduleFn = function(cb) {
        return setTimeout(cb, 0);
    };
    var setScheduler = function(fn) {
        scheduleFn = fn;
    };
    var batch = function(callback) {
        var result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    var schedule = function(callback) {
        if (transactions) queue.push(callback);
        else scheduleFn(function() {
            notifyFn(callback);
        });
    };
    var batchCalls = function(callback) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            schedule(function() {
                callback.apply(void 0, (0, $c6Xmf._)(args));
            });
        };
    };
    var flush = function() {
        var originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(function() {
            batchNotifyFn(function() {
                originalQueue.forEach(function(callback) {
                    notifyFn(callback);
                });
            });
        });
    };
    var setNotifyFunction = function(fn) {
        notifyFn = fn;
    };
    var setBatchNotifyFunction = function(fn) {
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction,
        setScheduler: setScheduler
    };
}
var $13a3a02e43f53625$export$520687f44db6e1ab = $13a3a02e43f53625$export$316a8efd03cd1458();


// src/retryer.ts

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");
// src/focusManager.ts

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");




var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");
// src/subscribable.ts

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");
var $d7555b70074d2039$export$d26086b469ecdbcc = /*#__PURE__*/ function() {
    "use strict";
    function Subscribable() {
        (0, $4GJKx._)(this, Subscribable);
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    (0, $1wc17._)(Subscribable, [
        {
            key: "subscribe",
            value: function subscribe(listener) {
                var _this = this;
                this.listeners.add(listener);
                this.onSubscribe();
                return function() {
                    _this.listeners.delete(listener);
                    _this.onUnsubscribe();
                };
            }
        },
        {
            key: "hasListeners",
            value: function hasListeners() {
                return this.listeners.size > 0;
            }
        },
        {
            key: "onSubscribe",
            value: function onSubscribe() {}
        },
        {
            key: "onUnsubscribe",
            value: function onUnsubscribe() {}
        }
    ]);
    return Subscribable;
}();



var $29eddb9c4fc3b76a$var$_focused, $29eddb9c4fc3b76a$var$_cleanup, $29eddb9c4fc3b76a$var$_setup;
var $29eddb9c4fc3b76a$export$86f1af424b2ca4de = ($29eddb9c4fc3b76a$var$_focused = /*#__PURE__*/ new WeakMap(), $29eddb9c4fc3b76a$var$_cleanup = /*#__PURE__*/ new WeakMap(), $29eddb9c4fc3b76a$var$_setup = /*#__PURE__*/ new WeakMap(), /*#__PURE__*/ function(Subscribable) {
    "use strict";
    (0, $dcsZi._)(_class, Subscribable);
    var _super = (0, $ohfOJ._)(_class);
    function _class() {
        (0, $4GJKx._)(this, _class);
        var _this;
        _this = _super.call(this);
        (0, $d4584ce6f6a30a88$export$71511d61b312f219)((0, $d3H5E._)(_this), $29eddb9c4fc3b76a$var$_focused, {
            writable: true,
            value: void 0
        });
        (0, $d4584ce6f6a30a88$export$71511d61b312f219)((0, $d3H5E._)(_this), $29eddb9c4fc3b76a$var$_cleanup, {
            writable: true,
            value: void 0
        });
        (0, $d4584ce6f6a30a88$export$71511d61b312f219)((0, $d3H5E._)(_this), $29eddb9c4fc3b76a$var$_setup, {
            writable: true,
            value: void 0
        });
        (0, $124143cbdcf95d51$export$71511d61b312f219)((0, $d3H5E._)(_this), $29eddb9c4fc3b76a$var$_setup, function(onFocus) {
            if (!(0, $af19fbfda254a923$export$6acf61af03e62db) && window.addEventListener) {
                var listener = function() {
                    return onFocus();
                };
                window.addEventListener("visibilitychange", listener, false);
                return function() {
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        });
        return _this;
    }
    (0, $1wc17._)(_class, [
        {
            key: "onSubscribe",
            value: function onSubscribe() {
                if (!(0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $29eddb9c4fc3b76a$var$_cleanup)) this.setEventListener((0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $29eddb9c4fc3b76a$var$_setup));
            }
        },
        {
            key: "onUnsubscribe",
            value: function onUnsubscribe() {
                var _this, _this1, _ref;
                if (!this.hasListeners()) {
                    (_this = (0, $8c2a5b50554ee522$export$71511d61b312f219)(_ref = _this1 = this, $29eddb9c4fc3b76a$var$_cleanup)) === null || _this === void 0 ? void 0 : _this.call(_this1);
                    (0, $124143cbdcf95d51$export$71511d61b312f219)(this, $29eddb9c4fc3b76a$var$_cleanup, void 0);
                }
            }
        },
        {
            key: "setEventListener",
            value: function setEventListener(setup) {
                var _this = this;
                var _this1, _this2, _ref;
                (0, $124143cbdcf95d51$export$71511d61b312f219)(this, $29eddb9c4fc3b76a$var$_setup, setup);
                (_this1 = (0, $8c2a5b50554ee522$export$71511d61b312f219)(_ref = _this2 = this, $29eddb9c4fc3b76a$var$_cleanup)) === null || _this1 === void 0 ? void 0 : _this1.call(_this2);
                (0, $124143cbdcf95d51$export$71511d61b312f219)(this, $29eddb9c4fc3b76a$var$_cleanup, setup(function(focused) {
                    if (typeof focused === "boolean") _this.setFocused(focused);
                    else _this.onFocus();
                }));
            }
        },
        {
            key: "setFocused",
            value: function setFocused(focused) {
                var changed = (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $29eddb9c4fc3b76a$var$_focused) !== focused;
                if (changed) {
                    (0, $124143cbdcf95d51$export$71511d61b312f219)(this, $29eddb9c4fc3b76a$var$_focused, focused);
                    this.onFocus();
                }
            }
        },
        {
            key: "onFocus",
            value: function onFocus() {
                var isFocused = this.isFocused();
                this.listeners.forEach(function(listener) {
                    listener(isFocused);
                });
            }
        },
        {
            key: "isFocused",
            value: function isFocused() {
                var _globalThis_document;
                if (typeof (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $29eddb9c4fc3b76a$var$_focused) === "boolean") return (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $29eddb9c4fc3b76a$var$_focused);
                return ((_globalThis_document = globalThis.document) === null || _globalThis_document === void 0 ? void 0 : _globalThis_document.visibilityState) !== "hidden";
            }
        }
    ]);
    return _class;
}((0, $d7555b70074d2039$export$d26086b469ecdbcc)));
var $29eddb9c4fc3b76a$export$6bf54661be5b02cf = new $29eddb9c4fc3b76a$export$86f1af424b2ca4de();


// src/onlineManager.ts

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");




var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");


var $1b5cdad49385d0dd$var$_online, $1b5cdad49385d0dd$var$_cleanup, $1b5cdad49385d0dd$var$_setup;
var $1b5cdad49385d0dd$export$58774fb55d5ff7fc = ($1b5cdad49385d0dd$var$_online = /*#__PURE__*/ new WeakMap(), $1b5cdad49385d0dd$var$_cleanup = /*#__PURE__*/ new WeakMap(), $1b5cdad49385d0dd$var$_setup = /*#__PURE__*/ new WeakMap(), /*#__PURE__*/ function(Subscribable) {
    "use strict";
    (0, $dcsZi._)(_class, Subscribable);
    var _super = (0, $ohfOJ._)(_class);
    function _class() {
        (0, $4GJKx._)(this, _class);
        var _this;
        _this = _super.call(this);
        (0, $d4584ce6f6a30a88$export$71511d61b312f219)((0, $d3H5E._)(_this), $1b5cdad49385d0dd$var$_online, {
            writable: true,
            value: true
        });
        (0, $d4584ce6f6a30a88$export$71511d61b312f219)((0, $d3H5E._)(_this), $1b5cdad49385d0dd$var$_cleanup, {
            writable: true,
            value: void 0
        });
        (0, $d4584ce6f6a30a88$export$71511d61b312f219)((0, $d3H5E._)(_this), $1b5cdad49385d0dd$var$_setup, {
            writable: true,
            value: void 0
        });
        (0, $124143cbdcf95d51$export$71511d61b312f219)((0, $d3H5E._)(_this), $1b5cdad49385d0dd$var$_setup, function(onOnline) {
            if (!(0, $af19fbfda254a923$export$6acf61af03e62db) && window.addEventListener) {
                var onlineListener = function() {
                    return onOnline(true);
                };
                var offlineListener = function() {
                    return onOnline(false);
                };
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return function() {
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        });
        return _this;
    }
    (0, $1wc17._)(_class, [
        {
            key: "onSubscribe",
            value: function onSubscribe() {
                if (!(0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $1b5cdad49385d0dd$var$_cleanup)) this.setEventListener((0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $1b5cdad49385d0dd$var$_setup));
            }
        },
        {
            key: "onUnsubscribe",
            value: function onUnsubscribe() {
                var _this, _this1, _ref;
                if (!this.hasListeners()) {
                    (_this = (0, $8c2a5b50554ee522$export$71511d61b312f219)(_ref = _this1 = this, $1b5cdad49385d0dd$var$_cleanup)) === null || _this === void 0 ? void 0 : _this.call(_this1);
                    (0, $124143cbdcf95d51$export$71511d61b312f219)(this, $1b5cdad49385d0dd$var$_cleanup, void 0);
                }
            }
        },
        {
            key: "setEventListener",
            value: function setEventListener(setup) {
                var _this, _this1, _ref;
                (0, $124143cbdcf95d51$export$71511d61b312f219)(this, $1b5cdad49385d0dd$var$_setup, setup);
                (_this = (0, $8c2a5b50554ee522$export$71511d61b312f219)(_ref = _this1 = this, $1b5cdad49385d0dd$var$_cleanup)) === null || _this === void 0 ? void 0 : _this.call(_this1);
                (0, $124143cbdcf95d51$export$71511d61b312f219)(this, $1b5cdad49385d0dd$var$_cleanup, setup(this.setOnline.bind(this)));
            }
        },
        {
            key: "setOnline",
            value: function setOnline(online) {
                var changed = (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $1b5cdad49385d0dd$var$_online) !== online;
                if (changed) {
                    (0, $124143cbdcf95d51$export$71511d61b312f219)(this, $1b5cdad49385d0dd$var$_online, online);
                    this.listeners.forEach(function(listener) {
                        listener(online);
                    });
                }
            }
        },
        {
            key: "isOnline",
            value: function isOnline() {
                return (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $1b5cdad49385d0dd$var$_online);
            }
        }
    ]);
    return _class;
}((0, $d7555b70074d2039$export$d26086b469ecdbcc)));
var $1b5cdad49385d0dd$export$b113e788b2dd3fdc = new $1b5cdad49385d0dd$export$58774fb55d5ff7fc();



function $61a27d029c0d15da$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * Math.pow(2, failureCount), 3e4);
}
function $61a27d029c0d15da$export$61b92f63f30245cf(networkMode) {
    return (networkMode !== null && networkMode !== void 0 ? networkMode : "online") === "online" ? (0, $1b5cdad49385d0dd$export$b113e788b2dd3fdc).isOnline() : true;
}
var $61a27d029c0d15da$export$a8430ed4188f35a9 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $dcsZi._)(CancelledError, Error1);
    var _super = (0, $ohfOJ._)(CancelledError);
    function CancelledError(options) {
        (0, $4GJKx._)(this, CancelledError);
        var _this;
        _this = _super.call(this, "CancelledError");
        _this.revert = options === null || options === void 0 ? void 0 : options.revert;
        _this.silent = options === null || options === void 0 ? void 0 : options.silent;
        return _this;
    }
    return CancelledError;
}((0, $FuVm8._)(Error));
function $61a27d029c0d15da$export$986cc6445c1d323(value) {
    return value instanceof $61a27d029c0d15da$export$a8430ed4188f35a9;
}
function $61a27d029c0d15da$export$2cbd00fe8a2c8d85(config) {
    var isRetryCancelled = false;
    var failureCount = 0;
    var isResolved = false;
    var continueFn;
    var promiseResolve;
    var promiseReject;
    var promise = new Promise(function(outerResolve, outerReject) {
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    var cancel = function(cancelOptions) {
        if (!isResolved) {
            var _config_abort;
            reject(new $61a27d029c0d15da$export$a8430ed4188f35a9(cancelOptions));
            (_config_abort = config.abort) === null || _config_abort === void 0 ? void 0 : _config_abort.call(config);
        }
    };
    var cancelRetry = function() {
        isRetryCancelled = true;
    };
    var continueRetry = function() {
        isRetryCancelled = false;
    };
    var canContinue = function() {
        return (0, $29eddb9c4fc3b76a$export$6bf54661be5b02cf).isFocused() && (config.networkMode === "always" || (0, $1b5cdad49385d0dd$export$b113e788b2dd3fdc).isOnline()) && config.canRun();
    };
    var canStart = function() {
        return $61a27d029c0d15da$export$61b92f63f30245cf(config.networkMode) && config.canRun();
    };
    var resolve = function(value) {
        if (!isResolved) {
            var _config_onSuccess;
            isResolved = true;
            (_config_onSuccess = config.onSuccess) === null || _config_onSuccess === void 0 ? void 0 : _config_onSuccess.call(config, value);
            continueFn === null || continueFn === void 0 ? void 0 : continueFn();
            promiseResolve(value);
        }
    };
    var reject = function(value) {
        if (!isResolved) {
            var _config_onError;
            isResolved = true;
            (_config_onError = config.onError) === null || _config_onError === void 0 ? void 0 : _config_onError.call(config, value);
            continueFn === null || continueFn === void 0 ? void 0 : continueFn();
            promiseReject(value);
        }
    };
    var pause = function() {
        return new Promise(function(continueResolve) {
            var _config_onPause;
            continueFn = function(value) {
                if (isResolved || canContinue()) continueResolve(value);
            };
            (_config_onPause = config.onPause) === null || _config_onPause === void 0 ? void 0 : _config_onPause.call(config);
        }).then(function() {
            var _config_onContinue;
            continueFn = void 0;
            if (!isResolved) (_config_onContinue = config.onContinue) === null || _config_onContinue === void 0 ? void 0 : _config_onContinue.call(config);
        });
    };
    var run = function() {
        if (isResolved) return;
        var promiseOrValue;
        var initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise !== null && initialPromise !== void 0 ? initialPromise : config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch(function(error) {
            var _config_onFail;
            if (isResolved) return;
            var _config_retry;
            var retry = (_config_retry = config.retry) !== null && _config_retry !== void 0 ? _config_retry : (0, $af19fbfda254a923$export$6acf61af03e62db) ? 0 : 3;
            var _config_retryDelay;
            var retryDelay = (_config_retryDelay = config.retryDelay) !== null && _config_retryDelay !== void 0 ? _config_retryDelay : $61a27d029c0d15da$var$defaultRetryDelay;
            var delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            var shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            (_config_onFail = config.onFail) === null || _config_onFail === void 0 ? void 0 : _config_onFail.call(config, failureCount, error);
            (0, $af19fbfda254a923$export$e772c8ff12451969)(delay).then(function() {
                return canContinue() ? void 0 : pause();
            }).then(function() {
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: promise,
        cancel: cancel,
        continue: function() {
            continueFn === null || continueFn === void 0 ? void 0 : continueFn();
            return promise;
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry,
        canStart: canStart,
        start: function() {
            if (canStart()) run();
            else pause().then(run);
            return promise;
        }
    };
}


// src/removable.ts

var $4GJKx = parcelRequire("4GJKx");




var $1wc17 = parcelRequire("1wc17");

var $21bf885cfeb31f7a$var$_gcTimeout;
var $21bf885cfeb31f7a$export$e09608847fcc8c59 = ($21bf885cfeb31f7a$var$_gcTimeout = /*#__PURE__*/ new WeakMap(), /*#__PURE__*/ function() {
    "use strict";
    function _class() {
        (0, $4GJKx._)(this, _class);
        (0, $d4584ce6f6a30a88$export$71511d61b312f219)(this, $21bf885cfeb31f7a$var$_gcTimeout, {
            writable: true,
            value: void 0
        });
    }
    (0, $1wc17._)(_class, [
        {
            key: "destroy",
            value: function destroy() {
                this.clearGcTimeout();
            }
        },
        {
            key: "scheduleGc",
            value: function scheduleGc() {
                var _this = this;
                this.clearGcTimeout();
                if ((0, $af19fbfda254a923$export$e539f754e934e270)(this.gcTime)) (0, $124143cbdcf95d51$export$71511d61b312f219)(this, $21bf885cfeb31f7a$var$_gcTimeout, setTimeout(function() {
                    _this.optionalRemove();
                }, this.gcTime));
            }
        },
        {
            key: "updateGcTime",
            value: function updateGcTime(newGcTime) {
                this.gcTime = Math.max(this.gcTime || 0, newGcTime !== null && newGcTime !== void 0 ? newGcTime : (0, $af19fbfda254a923$export$6acf61af03e62db) ? Infinity : 300000);
            }
        },
        {
            key: "clearGcTimeout",
            value: function clearGcTimeout() {
                if ((0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $21bf885cfeb31f7a$var$_gcTimeout)) {
                    clearTimeout((0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $21bf885cfeb31f7a$var$_gcTimeout));
                    (0, $124143cbdcf95d51$export$71511d61b312f219)(this, $21bf885cfeb31f7a$var$_gcTimeout, void 0);
                }
            }
        }
    ]);
    return _class;
}());


var $933dc8dc4f63c001$var$_initialState, $933dc8dc4f63c001$var$_revertState, $933dc8dc4f63c001$var$_cache, $933dc8dc4f63c001$var$_retryer, $933dc8dc4f63c001$var$_defaultOptions, $933dc8dc4f63c001$var$_abortSignalConsumed, $933dc8dc4f63c001$var$_dispatch, $933dc8dc4f63c001$var$_class;
var $933dc8dc4f63c001$export$62297b13309008b2 = ($933dc8dc4f63c001$var$_initialState = /*#__PURE__*/ new WeakMap(), $933dc8dc4f63c001$var$_revertState = /*#__PURE__*/ new WeakMap(), $933dc8dc4f63c001$var$_cache = /*#__PURE__*/ new WeakMap(), $933dc8dc4f63c001$var$_retryer = /*#__PURE__*/ new WeakMap(), $933dc8dc4f63c001$var$_defaultOptions = /*#__PURE__*/ new WeakMap(), $933dc8dc4f63c001$var$_abortSignalConsumed = /*#__PURE__*/ new WeakMap(), $933dc8dc4f63c001$var$_dispatch = /*#__PURE__*/ new WeakSet(), $933dc8dc4f63c001$var$_class = /*#__PURE__*/ function(Removable) {
    "use strict";
    (0, $dcsZi._)(_class, Removable);
    var _super = (0, $ohfOJ._)(_class);
    function _class(config) {
        (0, $4GJKx._)(this, _class);
        var _this;
        _this = _super.call(this);
        (0, $4ba5d20095745f8e$export$71511d61b312f219)((0, $d3H5E._)(_this), $933dc8dc4f63c001$var$_dispatch);
        (0, $d4584ce6f6a30a88$export$71511d61b312f219)((0, $d3H5E._)(_this), $933dc8dc4f63c001$var$_initialState, {
            writable: true,
            value: void 0
        });
        (0, $d4584ce6f6a30a88$export$71511d61b312f219)((0, $d3H5E._)(_this), $933dc8dc4f63c001$var$_revertState, {
            writable: true,
            value: void 0
        });
        (0, $d4584ce6f6a30a88$export$71511d61b312f219)((0, $d3H5E._)(_this), $933dc8dc4f63c001$var$_cache, {
            writable: true,
            value: void 0
        });
        (0, $d4584ce6f6a30a88$export$71511d61b312f219)((0, $d3H5E._)(_this), $933dc8dc4f63c001$var$_retryer, {
            writable: true,
            value: void 0
        });
        (0, $d4584ce6f6a30a88$export$71511d61b312f219)((0, $d3H5E._)(_this), $933dc8dc4f63c001$var$_defaultOptions, {
            writable: true,
            value: void 0
        });
        (0, $d4584ce6f6a30a88$export$71511d61b312f219)((0, $d3H5E._)(_this), $933dc8dc4f63c001$var$_abortSignalConsumed, {
            writable: true,
            value: void 0
        });
        (0, $124143cbdcf95d51$export$71511d61b312f219)((0, $d3H5E._)(_this), $933dc8dc4f63c001$var$_abortSignalConsumed, false);
        (0, $124143cbdcf95d51$export$71511d61b312f219)((0, $d3H5E._)(_this), $933dc8dc4f63c001$var$_defaultOptions, config.defaultOptions);
        _this.setOptions(config.options);
        _this.observers = [];
        (0, $124143cbdcf95d51$export$71511d61b312f219)((0, $d3H5E._)(_this), $933dc8dc4f63c001$var$_cache, config.cache);
        _this.queryKey = config.queryKey;
        _this.queryHash = config.queryHash;
        (0, $124143cbdcf95d51$export$71511d61b312f219)((0, $d3H5E._)(_this), $933dc8dc4f63c001$var$_initialState, $933dc8dc4f63c001$var$getDefaultState(_this.options));
        var _config_state;
        _this.state = (_config_state = config.state) !== null && _config_state !== void 0 ? _config_state : (0, $8c2a5b50554ee522$export$71511d61b312f219)((0, $d3H5E._)(_this), $933dc8dc4f63c001$var$_initialState);
        _this.scheduleGc();
        return _this;
    }
    (0, $1wc17._)(_class, [
        {
            key: "meta",
            get: function get() {
                return this.options.meta;
            }
        },
        {
            key: "promise",
            get: function get() {
                var _$_class_private_field_get;
                return (_$_class_private_field_get = (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $933dc8dc4f63c001$var$_retryer)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.promise;
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                this.options = (0, $do9pw._)({}, (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $933dc8dc4f63c001$var$_defaultOptions), options);
                this.updateGcTime(this.options.gcTime);
            }
        },
        {
            key: "optionalRemove",
            value: function optionalRemove() {
                if (!this.observers.length && this.state.fetchStatus === "idle") (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $933dc8dc4f63c001$var$_cache).remove(this);
            }
        },
        {
            key: "setData",
            value: function setData(newData, options) {
                var data = (0, $af19fbfda254a923$export$17619bac5b909b23)(this.state.data, newData, this.options);
                (0, $a66360d689e7ada3$export$71511d61b312f219)(this, $933dc8dc4f63c001$var$_dispatch, $933dc8dc4f63c001$var$dispatch).call(this, {
                    data: data,
                    type: "success",
                    dataUpdatedAt: options === null || options === void 0 ? void 0 : options.updatedAt,
                    manual: options === null || options === void 0 ? void 0 : options.manual
                });
                return data;
            }
        },
        {
            key: "setState",
            value: function setState(state, setStateOptions) {
                (0, $a66360d689e7ada3$export$71511d61b312f219)(this, $933dc8dc4f63c001$var$_dispatch, $933dc8dc4f63c001$var$dispatch).call(this, {
                    type: "setState",
                    state: state,
                    setStateOptions: setStateOptions
                });
            }
        },
        {
            key: "cancel",
            value: function cancel(options) {
                var _$_class_private_field_get, _$_class_private_field_get1;
                var promise = (_$_class_private_field_get = (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $933dc8dc4f63c001$var$_retryer)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.promise;
                (_$_class_private_field_get1 = (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $933dc8dc4f63c001$var$_retryer)) === null || _$_class_private_field_get1 === void 0 ? void 0 : _$_class_private_field_get1.cancel(options);
                return promise ? promise.then((0, $af19fbfda254a923$export$8793edee2d425525)).catch((0, $af19fbfda254a923$export$8793edee2d425525)) : Promise.resolve();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                (0, $04RAu._)((0, $b8Rim._)(_class.prototype), "destroy", this).call(this);
                this.cancel({
                    silent: true
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.destroy();
                this.setState((0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $933dc8dc4f63c001$var$_initialState));
            }
        },
        {
            key: "isActive",
            value: function isActive() {
                var _this = this;
                return this.observers.some(function(observer) {
                    return (0, $af19fbfda254a923$export$8c88ee6f2357230d)(observer.options.enabled, _this) !== false;
                });
            }
        },
        {
            key: "isDisabled",
            value: function isDisabled() {
                return this.getObserversCount() > 0 && !this.isActive();
            }
        },
        {
            key: "isStale",
            value: function isStale() {
                if (this.state.isInvalidated) return true;
                if (this.getObserversCount() > 0) return this.observers.some(function(observer) {
                    return observer.getCurrentResult().isStale;
                });
                return this.state.data === void 0;
            }
        },
        {
            key: "isStaleByTime",
            value: function isStaleByTime() {
                var staleTime = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                return this.state.isInvalidated || this.state.data === void 0 || !(0, $af19fbfda254a923$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
            }
        },
        {
            key: "onFocus",
            value: function onFocus() {
                var _$_class_private_field_get;
                var observer = this.observers.find(function(x) {
                    return x.shouldFetchOnWindowFocus();
                });
                observer === null || observer === void 0 ? void 0 : observer.refetch({
                    cancelRefetch: false
                });
                (_$_class_private_field_get = (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $933dc8dc4f63c001$var$_retryer)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.continue();
            }
        },
        {
            key: "onOnline",
            value: function onOnline() {
                var _$_class_private_field_get;
                var observer = this.observers.find(function(x) {
                    return x.shouldFetchOnReconnect();
                });
                observer === null || observer === void 0 ? void 0 : observer.refetch({
                    cancelRefetch: false
                });
                (_$_class_private_field_get = (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $933dc8dc4f63c001$var$_retryer)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.continue();
            }
        },
        {
            key: "addObserver",
            value: function addObserver(observer) {
                if (!this.observers.includes(observer)) {
                    this.observers.push(observer);
                    this.clearGcTimeout();
                    (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $933dc8dc4f63c001$var$_cache).notify({
                        type: "observerAdded",
                        query: this,
                        observer: observer
                    });
                }
            }
        },
        {
            key: "removeObserver",
            value: function removeObserver(observer) {
                if (this.observers.includes(observer)) {
                    this.observers = this.observers.filter(function(x) {
                        return x !== observer;
                    });
                    if (!this.observers.length) {
                        if ((0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $933dc8dc4f63c001$var$_retryer)) {
                            if ((0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $933dc8dc4f63c001$var$_abortSignalConsumed)) (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $933dc8dc4f63c001$var$_retryer).cancel({
                                revert: true
                            });
                            else (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $933dc8dc4f63c001$var$_retryer).cancelRetry();
                        }
                        this.scheduleGc();
                    }
                    (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $933dc8dc4f63c001$var$_cache).notify({
                        type: "observerRemoved",
                        query: this,
                        observer: observer
                    });
                }
            }
        },
        {
            key: "getObserversCount",
            value: function getObserversCount() {
                return this.observers.length;
            }
        },
        {
            key: "invalidate",
            value: function invalidate() {
                if (!this.state.isInvalidated) (0, $a66360d689e7ada3$export$71511d61b312f219)(this, $933dc8dc4f63c001$var$_dispatch, $933dc8dc4f63c001$var$dispatch).call(this, {
                    type: "invalidate"
                });
            }
        },
        {
            key: "fetch",
            value: function fetch(options, fetchOptions) {
                var _this = this;
                var _this_options_behavior, _context_fetchOptions, _context_fetchOptions1;
                if (this.state.fetchStatus !== "idle") {
                    if (this.state.data !== void 0 && (fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.cancelRefetch)) this.cancel({
                        silent: true
                    });
                    else if ((0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $933dc8dc4f63c001$var$_retryer)) {
                        (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $933dc8dc4f63c001$var$_retryer).continueRetry();
                        return (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $933dc8dc4f63c001$var$_retryer).promise;
                    }
                }
                if (options) this.setOptions(options);
                if (!this.options.queryFn) {
                    var observer = this.observers.find(function(x) {
                        return x.options.queryFn;
                    });
                    if (observer) this.setOptions(observer.options);
                }
                var abortController = new AbortController();
                var addSignalProperty = function(object) {
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: function() {
                            (0, $124143cbdcf95d51$export$71511d61b312f219)(_this, $933dc8dc4f63c001$var$_abortSignalConsumed, true);
                            return abortController.signal;
                        }
                    });
                };
                var fetchFn = function() {
                    var queryFn = (0, $af19fbfda254a923$export$c71c44209368a3bc)(_this.options, fetchOptions);
                    var queryFnContext = {
                        queryKey: _this.queryKey,
                        meta: _this.meta
                    };
                    addSignalProperty(queryFnContext);
                    (0, $124143cbdcf95d51$export$71511d61b312f219)(_this, $933dc8dc4f63c001$var$_abortSignalConsumed, false);
                    if (_this.options.persister) return _this.options.persister(queryFn, queryFnContext, _this);
                    return queryFn(queryFnContext);
                };
                var context = {
                    fetchOptions: fetchOptions,
                    options: this.options,
                    queryKey: this.queryKey,
                    state: this.state,
                    fetchFn: fetchFn
                };
                addSignalProperty(context);
                (_this_options_behavior = this.options.behavior) === null || _this_options_behavior === void 0 ? void 0 : _this_options_behavior.onFetch(context, this);
                (0, $124143cbdcf95d51$export$71511d61b312f219)(this, $933dc8dc4f63c001$var$_revertState, this.state);
                if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_context_fetchOptions = context.fetchOptions) === null || _context_fetchOptions === void 0 ? void 0 : _context_fetchOptions.meta)) (0, $a66360d689e7ada3$export$71511d61b312f219)(this, $933dc8dc4f63c001$var$_dispatch, $933dc8dc4f63c001$var$dispatch).call(this, {
                    type: "fetch",
                    meta: (_context_fetchOptions1 = context.fetchOptions) === null || _context_fetchOptions1 === void 0 ? void 0 : _context_fetchOptions1.meta
                });
                var onError = function(error) {
                    if (!((0, $61a27d029c0d15da$export$986cc6445c1d323)(error) && error.silent)) (0, $a66360d689e7ada3$export$71511d61b312f219)(_this, $933dc8dc4f63c001$var$_dispatch, $933dc8dc4f63c001$var$dispatch).call(_this, {
                        type: "error",
                        error: error
                    });
                    if (!(0, $61a27d029c0d15da$export$986cc6445c1d323)(error)) {
                        var _class_private_field_get_config_onError, _class_private_field_get_config, _class_private_field_get_config_onSettled, _class_private_field_get_config1;
                        (_class_private_field_get_config_onError = (_class_private_field_get_config = (0, $8c2a5b50554ee522$export$71511d61b312f219)(_this, $933dc8dc4f63c001$var$_cache).config).onError) === null || _class_private_field_get_config_onError === void 0 ? void 0 : _class_private_field_get_config_onError.call(_class_private_field_get_config, error, _this);
                        (_class_private_field_get_config_onSettled = (_class_private_field_get_config1 = (0, $8c2a5b50554ee522$export$71511d61b312f219)(_this, $933dc8dc4f63c001$var$_cache).config).onSettled) === null || _class_private_field_get_config_onSettled === void 0 ? void 0 : _class_private_field_get_config_onSettled.call(_class_private_field_get_config1, _this.state.data, error, _this);
                    }
                    if (!_this.isFetchingOptimistic) _this.scheduleGc();
                    _this.isFetchingOptimistic = false;
                };
                (0, $124143cbdcf95d51$export$71511d61b312f219)(this, $933dc8dc4f63c001$var$_retryer, (0, $61a27d029c0d15da$export$2cbd00fe8a2c8d85)({
                    initialPromise: fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.initialPromise,
                    fn: context.fetchFn,
                    abort: abortController.abort.bind(abortController),
                    onSuccess: function(data) {
                        var _class_private_field_get_config_onSuccess, _class_private_field_get_config, _class_private_field_get_config_onSettled, _class_private_field_get_config1;
                        if (data === void 0) {
                            onError(new Error("".concat(_this.queryHash, " data is undefined")));
                            return;
                        }
                        try {
                            _this.setData(data);
                        } catch (error) {
                            onError(error);
                            return;
                        }
                        (_class_private_field_get_config_onSuccess = (_class_private_field_get_config = (0, $8c2a5b50554ee522$export$71511d61b312f219)(_this, $933dc8dc4f63c001$var$_cache).config).onSuccess) === null || _class_private_field_get_config_onSuccess === void 0 ? void 0 : _class_private_field_get_config_onSuccess.call(_class_private_field_get_config, data, _this);
                        (_class_private_field_get_config_onSettled = (_class_private_field_get_config1 = (0, $8c2a5b50554ee522$export$71511d61b312f219)(_this, $933dc8dc4f63c001$var$_cache).config).onSettled) === null || _class_private_field_get_config_onSettled === void 0 ? void 0 : _class_private_field_get_config_onSettled.call(_class_private_field_get_config1, data, _this.state.error, _this);
                        if (!_this.isFetchingOptimistic) _this.scheduleGc();
                        _this.isFetchingOptimistic = false;
                    },
                    onError: onError,
                    onFail: function(failureCount, error) {
                        (0, $a66360d689e7ada3$export$71511d61b312f219)(_this, $933dc8dc4f63c001$var$_dispatch, $933dc8dc4f63c001$var$dispatch).call(_this, {
                            type: "failed",
                            failureCount: failureCount,
                            error: error
                        });
                    },
                    onPause: function() {
                        (0, $a66360d689e7ada3$export$71511d61b312f219)(_this, $933dc8dc4f63c001$var$_dispatch, $933dc8dc4f63c001$var$dispatch).call(_this, {
                            type: "pause"
                        });
                    },
                    onContinue: function() {
                        (0, $a66360d689e7ada3$export$71511d61b312f219)(_this, $933dc8dc4f63c001$var$_dispatch, $933dc8dc4f63c001$var$dispatch).call(_this, {
                            type: "continue"
                        });
                    },
                    retry: context.options.retry,
                    retryDelay: context.options.retryDelay,
                    networkMode: context.options.networkMode,
                    canRun: function() {
                        return true;
                    }
                }));
                return (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $933dc8dc4f63c001$var$_retryer).start();
            }
        }
    ]);
    return _class;
}((0, $21bf885cfeb31f7a$export$e09608847fcc8c59)), $933dc8dc4f63c001$var$_class);
function $933dc8dc4f63c001$export$f3df9013f2b58bce(data, options) {
    return (0, $do9pw._)({
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $61a27d029c0d15da$export$61b92f63f30245cf)(options.networkMode) ? "fetching" : "paused"
    }, data === void 0 && {
        error: null,
        status: "pending"
    });
}
function $933dc8dc4f63c001$var$getDefaultState(options) {
    var data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    var hasData = data !== void 0;
    var initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt !== null && initialDataUpdatedAt !== void 0 ? initialDataUpdatedAt : Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}
function $933dc8dc4f63c001$var$dispatch(action) {
    var _this = this;
    var reducer = function(state) {
        switch(action.type){
            case "failed":
                return (0, $cxjpp._)((0, $do9pw._)({}, state), {
                    fetchFailureCount: action.failureCount,
                    fetchFailureReason: action.error
                });
            case "pause":
                return (0, $cxjpp._)((0, $do9pw._)({}, state), {
                    fetchStatus: "paused"
                });
            case "continue":
                return (0, $cxjpp._)((0, $do9pw._)({}, state), {
                    fetchStatus: "fetching"
                });
            case "fetch":
                var _action_meta;
                return (0, $cxjpp._)((0, $do9pw._)({}, state, $933dc8dc4f63c001$export$f3df9013f2b58bce(state.data, _this.options)), {
                    fetchMeta: (_action_meta = action.meta) !== null && _action_meta !== void 0 ? _action_meta : null
                });
            case "success":
                var _action_dataUpdatedAt;
                return (0, $do9pw._)((0, $cxjpp._)((0, $do9pw._)({}, state), {
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: (_action_dataUpdatedAt = action.dataUpdatedAt) !== null && _action_dataUpdatedAt !== void 0 ? _action_dataUpdatedAt : Date.now(),
                    error: null,
                    isInvalidated: false,
                    status: "success"
                }), !action.manual && {
                    fetchStatus: "idle",
                    fetchFailureCount: 0,
                    fetchFailureReason: null
                });
            case "error":
                var error = action.error;
                if ((0, $61a27d029c0d15da$export$986cc6445c1d323)(error) && error.revert && (0, $8c2a5b50554ee522$export$71511d61b312f219)(_this, $933dc8dc4f63c001$var$_revertState)) return (0, $cxjpp._)((0, $do9pw._)({}, (0, $8c2a5b50554ee522$export$71511d61b312f219)(_this, $933dc8dc4f63c001$var$_revertState)), {
                    fetchStatus: "idle"
                });
                return (0, $cxjpp._)((0, $do9pw._)({}, state), {
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    fetchFailureReason: error,
                    fetchStatus: "idle",
                    status: "error"
                });
            case "invalidate":
                return (0, $cxjpp._)((0, $do9pw._)({}, state), {
                    isInvalidated: true
                });
            case "setState":
                return (0, $do9pw._)({}, state, action.state);
        }
    };
    this.state = reducer(this.state);
    (0, $13a3a02e43f53625$export$520687f44db6e1ab).batch(function() {
        _this.observers.forEach(function(observer) {
            observer.onQueryUpdate();
        });
        (0, $8c2a5b50554ee522$export$71511d61b312f219)(_this, $933dc8dc4f63c001$var$_cache).notify({
            query: _this,
            type: "updated",
            action: action
        });
    });
}




var $63358a1719517b9f$var$_queries;
var $63358a1719517b9f$export$5dde0cd941da8468 = ($63358a1719517b9f$var$_queries = /*#__PURE__*/ new WeakMap(), /*#__PURE__*/ function(Subscribable) {
    "use strict";
    (0, $dcsZi._)(_class, Subscribable);
    var _super = (0, $ohfOJ._)(_class);
    function _class() {
        var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $4GJKx._)(this, _class);
        var _this;
        _this = _super.call(this);
        (0, $d4584ce6f6a30a88$export$71511d61b312f219)((0, $d3H5E._)(_this), $63358a1719517b9f$var$_queries, {
            writable: true,
            value: void 0
        });
        _this.config = config;
        (0, $124143cbdcf95d51$export$71511d61b312f219)((0, $d3H5E._)(_this), $63358a1719517b9f$var$_queries, /* @__PURE__ */ new Map());
        return _this;
    }
    (0, $1wc17._)(_class, [
        {
            key: "build",
            value: function build(client, options, state) {
                var queryKey = options.queryKey;
                var _options_queryHash;
                var queryHash = (_options_queryHash = options.queryHash) !== null && _options_queryHash !== void 0 ? _options_queryHash : (0, $af19fbfda254a923$export$cc90ca97bc0d73fd)(queryKey, options);
                var query = this.get(queryHash);
                if (!query) {
                    query = new (0, $933dc8dc4f63c001$export$62297b13309008b2)({
                        cache: this,
                        queryKey: queryKey,
                        queryHash: queryHash,
                        options: client.defaultQueryOptions(options),
                        state: state,
                        defaultOptions: client.getQueryDefaults(queryKey)
                    });
                    this.add(query);
                }
                return query;
            }
        },
        {
            key: "add",
            value: function add(query) {
                if (!(0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $63358a1719517b9f$var$_queries).has(query.queryHash)) {
                    (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $63358a1719517b9f$var$_queries).set(query.queryHash, query);
                    this.notify({
                        type: "added",
                        query: query
                    });
                }
            }
        },
        {
            key: "remove",
            value: function remove(query) {
                var queryInMap = (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $63358a1719517b9f$var$_queries).get(query.queryHash);
                if (queryInMap) {
                    query.destroy();
                    if (queryInMap === query) (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $63358a1719517b9f$var$_queries).delete(query.queryHash);
                    this.notify({
                        type: "removed",
                        query: query
                    });
                }
            }
        },
        {
            key: "clear",
            value: function clear() {
                var _this = this;
                (0, $13a3a02e43f53625$export$520687f44db6e1ab).batch(function() {
                    _this.getAll().forEach(function(query) {
                        _this.remove(query);
                    });
                });
            }
        },
        {
            key: "get",
            value: function get(queryHash) {
                return (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $63358a1719517b9f$var$_queries).get(queryHash);
            }
        },
        {
            key: "getAll",
            value: function getAll() {
                return (0, $c6Xmf._)((0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $63358a1719517b9f$var$_queries).values());
            }
        },
        {
            key: "find",
            value: function find(filters) {
                var defaultedFilters = (0, $do9pw._)({
                    exact: true
                }, filters);
                return this.getAll().find(function(query) {
                    return (0, $af19fbfda254a923$export$c5d1efe363797780)(defaultedFilters, query);
                });
            }
        },
        {
            key: "findAll",
            value: function findAll() {
                var filters = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var queries = this.getAll();
                return Object.keys(filters).length > 0 ? queries.filter(function(query) {
                    return (0, $af19fbfda254a923$export$c5d1efe363797780)(filters, query);
                }) : queries;
            }
        },
        {
            key: "notify",
            value: function notify(event) {
                var _this = this;
                (0, $13a3a02e43f53625$export$520687f44db6e1ab).batch(function() {
                    _this.listeners.forEach(function(listener) {
                        listener(event);
                    });
                });
            }
        },
        {
            key: "onFocus",
            value: function onFocus() {
                var _this = this;
                (0, $13a3a02e43f53625$export$520687f44db6e1ab).batch(function() {
                    _this.getAll().forEach(function(query) {
                        query.onFocus();
                    });
                });
            }
        },
        {
            key: "onOnline",
            value: function onOnline() {
                var _this = this;
                (0, $13a3a02e43f53625$export$520687f44db6e1ab).batch(function() {
                    _this.getAll().forEach(function(query) {
                        query.onOnline();
                    });
                });
            }
        }
    ]);
    return _class;
}((0, $d7555b70074d2039$export$d26086b469ecdbcc)));


// src/mutationCache.ts

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");





var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $do9pw = parcelRequire("do9pw");

var $c6Xmf = parcelRequire("c6Xmf");

var $ohfOJ = parcelRequire("ohfOJ");

// src/mutation.ts

var $d3H5E = parcelRequire("d3H5E");

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");






var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");



var $0d96312ae51216f8$var$_observers, $0d96312ae51216f8$var$_mutationCache, $0d96312ae51216f8$var$_retryer, $0d96312ae51216f8$var$_dispatch, $0d96312ae51216f8$var$_class;
var $0d96312ae51216f8$export$17b8b19c814bcf56 = ($0d96312ae51216f8$var$_observers = /*#__PURE__*/ new WeakMap(), $0d96312ae51216f8$var$_mutationCache = /*#__PURE__*/ new WeakMap(), $0d96312ae51216f8$var$_retryer = /*#__PURE__*/ new WeakMap(), $0d96312ae51216f8$var$_dispatch = /*#__PURE__*/ new WeakSet(), $0d96312ae51216f8$var$_class = /*#__PURE__*/ function(Removable) {
    "use strict";
    (0, $dcsZi._)(_class, Removable);
    var _super = (0, $ohfOJ._)(_class);
    function _class(config) {
        (0, $4GJKx._)(this, _class);
        var _this;
        _this = _super.call(this);
        (0, $4ba5d20095745f8e$export$71511d61b312f219)((0, $d3H5E._)(_this), $0d96312ae51216f8$var$_dispatch);
        (0, $d4584ce6f6a30a88$export$71511d61b312f219)((0, $d3H5E._)(_this), $0d96312ae51216f8$var$_observers, {
            writable: true,
            value: void 0
        });
        (0, $d4584ce6f6a30a88$export$71511d61b312f219)((0, $d3H5E._)(_this), $0d96312ae51216f8$var$_mutationCache, {
            writable: true,
            value: void 0
        });
        (0, $d4584ce6f6a30a88$export$71511d61b312f219)((0, $d3H5E._)(_this), $0d96312ae51216f8$var$_retryer, {
            writable: true,
            value: void 0
        });
        _this.mutationId = config.mutationId;
        (0, $124143cbdcf95d51$export$71511d61b312f219)((0, $d3H5E._)(_this), $0d96312ae51216f8$var$_mutationCache, config.mutationCache);
        (0, $124143cbdcf95d51$export$71511d61b312f219)((0, $d3H5E._)(_this), $0d96312ae51216f8$var$_observers, []);
        _this.state = config.state || $0d96312ae51216f8$export$a1659b54bac3252a();
        _this.setOptions(config.options);
        _this.scheduleGc();
        return _this;
    }
    (0, $1wc17._)(_class, [
        {
            key: "setOptions",
            value: function setOptions(options) {
                this.options = options;
                this.updateGcTime(this.options.gcTime);
            }
        },
        {
            key: "meta",
            get: function get() {
                return this.options.meta;
            }
        },
        {
            key: "addObserver",
            value: function addObserver(observer) {
                if (!(0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $0d96312ae51216f8$var$_observers).includes(observer)) {
                    (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $0d96312ae51216f8$var$_observers).push(observer);
                    this.clearGcTimeout();
                    (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $0d96312ae51216f8$var$_mutationCache).notify({
                        type: "observerAdded",
                        mutation: this,
                        observer: observer
                    });
                }
            }
        },
        {
            key: "removeObserver",
            value: function removeObserver(observer) {
                (0, $124143cbdcf95d51$export$71511d61b312f219)(this, $0d96312ae51216f8$var$_observers, (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $0d96312ae51216f8$var$_observers).filter(function(x) {
                    return x !== observer;
                }));
                this.scheduleGc();
                (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $0d96312ae51216f8$var$_mutationCache).notify({
                    type: "observerRemoved",
                    mutation: this,
                    observer: observer
                });
            }
        },
        {
            key: "optionalRemove",
            value: function optionalRemove() {
                if (!(0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $0d96312ae51216f8$var$_observers).length) {
                    if (this.state.status === "pending") this.scheduleGc();
                    else (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $0d96312ae51216f8$var$_mutationCache).remove(this);
                }
            }
        },
        {
            key: "continue",
            value: function _continue() {
                var _$_class_private_field_get;
                var _class_private_field_get_continue;
                return (_class_private_field_get_continue = (_$_class_private_field_get = (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $0d96312ae51216f8$var$_retryer)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.continue()) !== null && _class_private_field_get_continue !== void 0 ? _class_private_field_get_continue : // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
                this.execute(this.state.variables);
            }
        },
        {
            key: "execute",
            value: function execute(variables) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _this_options_retry, restored, isPaused, _class_private_field_get_config_onSuccess, _class_private_field_get_config, _this_options_onSuccess, _this_options, _class_private_field_get_config_onSettled, _class_private_field_get_config1, _this_options_onSettled, _this_options1, _class_private_field_get_config_onMutate, _class_private_field_get_config2, _this_options_onMutate, _this_options2, context, data, error, _class_private_field_get_config_onError, _class_private_field_get_config3, _this_options_onError, _this_options3, _class_private_field_get_config_onSettled1, _class_private_field_get_config4, _this_options_onSettled1, _this_options4;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $124143cbdcf95d51$export$71511d61b312f219)(_this, $0d96312ae51216f8$var$_retryer, (0, $61a27d029c0d15da$export$2cbd00fe8a2c8d85)({
                                    fn: function() {
                                        if (!_this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                                        return _this.options.mutationFn(variables);
                                    },
                                    onFail: function(failureCount, error) {
                                        (0, $a66360d689e7ada3$export$71511d61b312f219)(_this, $0d96312ae51216f8$var$_dispatch, $0d96312ae51216f8$var$dispatch).call(_this, {
                                            type: "failed",
                                            failureCount: failureCount,
                                            error: error
                                        });
                                    },
                                    onPause: function() {
                                        (0, $a66360d689e7ada3$export$71511d61b312f219)(_this, $0d96312ae51216f8$var$_dispatch, $0d96312ae51216f8$var$dispatch).call(_this, {
                                            type: "pause"
                                        });
                                    },
                                    onContinue: function() {
                                        (0, $a66360d689e7ada3$export$71511d61b312f219)(_this, $0d96312ae51216f8$var$_dispatch, $0d96312ae51216f8$var$dispatch).call(_this, {
                                            type: "continue"
                                        });
                                    },
                                    retry: (_this_options_retry = _this.options.retry) !== null && _this_options_retry !== void 0 ? _this_options_retry : 0,
                                    retryDelay: _this.options.retryDelay,
                                    networkMode: _this.options.networkMode,
                                    canRun: function() {
                                        return (0, $8c2a5b50554ee522$export$71511d61b312f219)(_this, $0d96312ae51216f8$var$_mutationCache).canRun(_this);
                                    }
                                }));
                                restored = _this.state.status === "pending";
                                isPaused = !(0, $8c2a5b50554ee522$export$71511d61b312f219)(_this, $0d96312ae51216f8$var$_retryer).canStart();
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    10,
                                    18,
                                    19
                                ]);
                                if (!!restored) return [
                                    3,
                                    4
                                ];
                                (0, $a66360d689e7ada3$export$71511d61b312f219)(_this, $0d96312ae51216f8$var$_dispatch, $0d96312ae51216f8$var$dispatch).call(_this, {
                                    type: "pending",
                                    variables: variables,
                                    isPaused: isPaused
                                });
                                return [
                                    4,
                                    (_class_private_field_get_config_onMutate = (_class_private_field_get_config2 = (0, $8c2a5b50554ee522$export$71511d61b312f219)(_this, $0d96312ae51216f8$var$_mutationCache).config).onMutate) === null || _class_private_field_get_config_onMutate === void 0 ? void 0 : _class_private_field_get_config_onMutate.call(_class_private_field_get_config2, variables, _this)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    (_this_options_onMutate = (_this_options2 = _this.options).onMutate) === null || _this_options_onMutate === void 0 ? void 0 : _this_options_onMutate.call(_this_options2, variables)
                                ];
                            case 3:
                                context = _state.sent();
                                if (context !== _this.state.context) (0, $a66360d689e7ada3$export$71511d61b312f219)(_this, $0d96312ae51216f8$var$_dispatch, $0d96312ae51216f8$var$dispatch).call(_this, {
                                    type: "pending",
                                    context: context,
                                    variables: variables,
                                    isPaused: isPaused
                                });
                                _state.label = 4;
                            case 4:
                                return [
                                    4,
                                    (0, $8c2a5b50554ee522$export$71511d61b312f219)(_this, $0d96312ae51216f8$var$_retryer).start()
                                ];
                            case 5:
                                data = _state.sent();
                                return [
                                    4,
                                    (_class_private_field_get_config_onSuccess = (_class_private_field_get_config = (0, $8c2a5b50554ee522$export$71511d61b312f219)(_this, $0d96312ae51216f8$var$_mutationCache).config).onSuccess) === null || _class_private_field_get_config_onSuccess === void 0 ? void 0 : _class_private_field_get_config_onSuccess.call(_class_private_field_get_config, data, variables, _this.state.context, _this)
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    4,
                                    (_this_options_onSuccess = (_this_options = _this.options).onSuccess) === null || _this_options_onSuccess === void 0 ? void 0 : _this_options_onSuccess.call(_this_options, data, variables, _this.state.context)
                                ];
                            case 7:
                                _state.sent();
                                return [
                                    4,
                                    (_class_private_field_get_config_onSettled = (_class_private_field_get_config1 = (0, $8c2a5b50554ee522$export$71511d61b312f219)(_this, $0d96312ae51216f8$var$_mutationCache).config).onSettled) === null || _class_private_field_get_config_onSettled === void 0 ? void 0 : _class_private_field_get_config_onSettled.call(_class_private_field_get_config1, data, null, _this.state.variables, _this.state.context, _this)
                                ];
                            case 8:
                                _state.sent();
                                return [
                                    4,
                                    (_this_options_onSettled = (_this_options1 = _this.options).onSettled) === null || _this_options_onSettled === void 0 ? void 0 : _this_options_onSettled.call(_this_options1, data, null, variables, _this.state.context)
                                ];
                            case 9:
                                _state.sent();
                                (0, $a66360d689e7ada3$export$71511d61b312f219)(_this, $0d96312ae51216f8$var$_dispatch, $0d96312ae51216f8$var$dispatch).call(_this, {
                                    type: "success",
                                    data: data
                                });
                                return [
                                    2,
                                    data
                                ];
                            case 10:
                                error = _state.sent();
                                _state.label = 11;
                            case 11:
                                _state.trys.push([
                                    11,
                                    ,
                                    16,
                                    17
                                ]);
                                return [
                                    4,
                                    (_class_private_field_get_config_onError = (_class_private_field_get_config3 = (0, $8c2a5b50554ee522$export$71511d61b312f219)(_this, $0d96312ae51216f8$var$_mutationCache).config).onError) === null || _class_private_field_get_config_onError === void 0 ? void 0 : _class_private_field_get_config_onError.call(_class_private_field_get_config3, error, variables, _this.state.context, _this)
                                ];
                            case 12:
                                _state.sent();
                                return [
                                    4,
                                    (_this_options_onError = (_this_options3 = _this.options).onError) === null || _this_options_onError === void 0 ? void 0 : _this_options_onError.call(_this_options3, error, variables, _this.state.context)
                                ];
                            case 13:
                                _state.sent();
                                return [
                                    4,
                                    (_class_private_field_get_config_onSettled1 = (_class_private_field_get_config4 = (0, $8c2a5b50554ee522$export$71511d61b312f219)(_this, $0d96312ae51216f8$var$_mutationCache).config).onSettled) === null || _class_private_field_get_config_onSettled1 === void 0 ? void 0 : _class_private_field_get_config_onSettled1.call(_class_private_field_get_config4, void 0, error, _this.state.variables, _this.state.context, _this)
                                ];
                            case 14:
                                _state.sent();
                                return [
                                    4,
                                    (_this_options_onSettled1 = (_this_options4 = _this.options).onSettled) === null || _this_options_onSettled1 === void 0 ? void 0 : _this_options_onSettled1.call(_this_options4, void 0, error, variables, _this.state.context)
                                ];
                            case 15:
                                _state.sent();
                                throw error;
                            case 16:
                                (0, $a66360d689e7ada3$export$71511d61b312f219)(_this, $0d96312ae51216f8$var$_dispatch, $0d96312ae51216f8$var$dispatch).call(_this, {
                                    type: "error",
                                    error: error
                                });
                                return [
                                    7
                                ];
                            case 17:
                                return [
                                    3,
                                    19
                                ];
                            case 18:
                                (0, $8c2a5b50554ee522$export$71511d61b312f219)(_this, $0d96312ae51216f8$var$_mutationCache).runNext(_this);
                                return [
                                    7
                                ];
                            case 19:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return _class;
}((0, $21bf885cfeb31f7a$export$e09608847fcc8c59)), $0d96312ae51216f8$var$_class);
function $0d96312ae51216f8$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}
function $0d96312ae51216f8$var$dispatch(action) {
    var _this = this;
    var reducer = function(state) {
        switch(action.type){
            case "failed":
                return (0, $cxjpp._)((0, $do9pw._)({}, state), {
                    failureCount: action.failureCount,
                    failureReason: action.error
                });
            case "pause":
                return (0, $cxjpp._)((0, $do9pw._)({}, state), {
                    isPaused: true
                });
            case "continue":
                return (0, $cxjpp._)((0, $do9pw._)({}, state), {
                    isPaused: false
                });
            case "pending":
                return (0, $cxjpp._)((0, $do9pw._)({}, state), {
                    context: action.context,
                    data: void 0,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    isPaused: action.isPaused,
                    status: "pending",
                    variables: action.variables,
                    submittedAt: Date.now()
                });
            case "success":
                return (0, $cxjpp._)((0, $do9pw._)({}, state), {
                    data: action.data,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    status: "success",
                    isPaused: false
                });
            case "error":
                return (0, $cxjpp._)((0, $do9pw._)({}, state), {
                    data: void 0,
                    error: action.error,
                    failureCount: state.failureCount + 1,
                    failureReason: action.error,
                    isPaused: false,
                    status: "error"
                });
        }
    };
    this.state = reducer(this.state);
    (0, $13a3a02e43f53625$export$520687f44db6e1ab).batch(function() {
        (0, $8c2a5b50554ee522$export$71511d61b312f219)(_this, $0d96312ae51216f8$var$_observers).forEach(function(observer) {
            observer.onMutationUpdate(action);
        });
        (0, $8c2a5b50554ee522$export$71511d61b312f219)(_this, $0d96312ae51216f8$var$_mutationCache).notify({
            mutation: _this,
            type: "updated",
            action: action
        });
    });
}




var $800448895f2fb61b$var$_mutations, $800448895f2fb61b$var$_mutationId;
var $800448895f2fb61b$export$1fcfd9a244434844 = ($800448895f2fb61b$var$_mutations = /*#__PURE__*/ new WeakMap(), $800448895f2fb61b$var$_mutationId = /*#__PURE__*/ new WeakMap(), /*#__PURE__*/ function(Subscribable) {
    "use strict";
    (0, $dcsZi._)(_class, Subscribable);
    var _super = (0, $ohfOJ._)(_class);
    function _class() {
        var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $4GJKx._)(this, _class);
        var _this;
        _this = _super.call(this);
        (0, $d4584ce6f6a30a88$export$71511d61b312f219)((0, $d3H5E._)(_this), $800448895f2fb61b$var$_mutations, {
            writable: true,
            value: void 0
        });
        (0, $d4584ce6f6a30a88$export$71511d61b312f219)((0, $d3H5E._)(_this), $800448895f2fb61b$var$_mutationId, {
            writable: true,
            value: void 0
        });
        _this.config = config;
        (0, $124143cbdcf95d51$export$71511d61b312f219)((0, $d3H5E._)(_this), $800448895f2fb61b$var$_mutations, /* @__PURE__ */ new Map());
        (0, $124143cbdcf95d51$export$71511d61b312f219)((0, $d3H5E._)(_this), $800448895f2fb61b$var$_mutationId, Date.now());
        return _this;
    }
    (0, $1wc17._)(_class, [
        {
            key: "build",
            value: function build(client, options, state) {
                var mutation = new (0, $0d96312ae51216f8$export$17b8b19c814bcf56)({
                    mutationCache: this,
                    mutationId: ++(0, $e6af5fa487922a1e$export$71511d61b312f219)(this, $800448895f2fb61b$var$_mutationId).value,
                    options: client.defaultMutationOptions(options),
                    state: state
                });
                this.add(mutation);
                return mutation;
            }
        },
        {
            key: "add",
            value: function add(mutation) {
                var scope = $800448895f2fb61b$var$scopeFor(mutation);
                var _class_private_field_get_get;
                var mutations = (_class_private_field_get_get = (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $800448895f2fb61b$var$_mutations).get(scope)) !== null && _class_private_field_get_get !== void 0 ? _class_private_field_get_get : [];
                mutations.push(mutation);
                (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $800448895f2fb61b$var$_mutations).set(scope, mutations);
                this.notify({
                    type: "added",
                    mutation: mutation
                });
            }
        },
        {
            key: "remove",
            value: function remove(mutation) {
                var scope = $800448895f2fb61b$var$scopeFor(mutation);
                if ((0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $800448895f2fb61b$var$_mutations).has(scope)) {
                    var _class_private_field_get_get;
                    var mutations = (_class_private_field_get_get = (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $800448895f2fb61b$var$_mutations).get(scope)) === null || _class_private_field_get_get === void 0 ? void 0 : _class_private_field_get_get.filter(function(x) {
                        return x !== mutation;
                    });
                    if (mutations) {
                        if (mutations.length === 0) (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $800448895f2fb61b$var$_mutations).delete(scope);
                        else (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $800448895f2fb61b$var$_mutations).set(scope, mutations);
                    }
                }
                this.notify({
                    type: "removed",
                    mutation: mutation
                });
            }
        },
        {
            key: "canRun",
            value: function canRun(mutation) {
                var _class_private_field_get_get;
                var firstPendingMutation = (_class_private_field_get_get = (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $800448895f2fb61b$var$_mutations).get($800448895f2fb61b$var$scopeFor(mutation))) === null || _class_private_field_get_get === void 0 ? void 0 : _class_private_field_get_get.find(function(m) {
                    return m.state.status === "pending";
                });
                return !firstPendingMutation || firstPendingMutation === mutation;
            }
        },
        {
            key: "runNext",
            value: function runNext(mutation) {
                var _class_private_field_get_get;
                var foundMutation = (_class_private_field_get_get = (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $800448895f2fb61b$var$_mutations).get($800448895f2fb61b$var$scopeFor(mutation))) === null || _class_private_field_get_get === void 0 ? void 0 : _class_private_field_get_get.find(function(m) {
                    return m !== mutation && m.state.isPaused;
                });
                var _foundMutation_continue;
                return (_foundMutation_continue = foundMutation === null || foundMutation === void 0 ? void 0 : foundMutation.continue()) !== null && _foundMutation_continue !== void 0 ? _foundMutation_continue : Promise.resolve();
            }
        },
        {
            key: "clear",
            value: function clear() {
                var _this = this;
                (0, $13a3a02e43f53625$export$520687f44db6e1ab).batch(function() {
                    _this.getAll().forEach(function(mutation) {
                        _this.remove(mutation);
                    });
                });
            }
        },
        {
            key: "getAll",
            value: function getAll() {
                return (0, $c6Xmf._)((0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $800448895f2fb61b$var$_mutations).values()).flat();
            }
        },
        {
            key: "find",
            value: function find(filters) {
                var defaultedFilters = (0, $do9pw._)({
                    exact: true
                }, filters);
                return this.getAll().find(function(mutation) {
                    return (0, $af19fbfda254a923$export$a1ea5fb559f63ae3)(defaultedFilters, mutation);
                });
            }
        },
        {
            key: "findAll",
            value: function findAll() {
                var filters = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                return this.getAll().filter(function(mutation) {
                    return (0, $af19fbfda254a923$export$a1ea5fb559f63ae3)(filters, mutation);
                });
            }
        },
        {
            key: "notify",
            value: function notify(event) {
                var _this = this;
                (0, $13a3a02e43f53625$export$520687f44db6e1ab).batch(function() {
                    _this.listeners.forEach(function(listener) {
                        listener(event);
                    });
                });
            }
        },
        {
            key: "resumePausedMutations",
            value: function resumePausedMutations() {
                var pausedMutations = this.getAll().filter(function(x) {
                    return x.state.isPaused;
                });
                return (0, $13a3a02e43f53625$export$520687f44db6e1ab).batch(function() {
                    return Promise.all(pausedMutations.map(function(mutation) {
                        return mutation.continue().catch((0, $af19fbfda254a923$export$8793edee2d425525));
                    }));
                });
            }
        }
    ]);
    return _class;
}((0, $d7555b70074d2039$export$d26086b469ecdbcc)));
function $800448895f2fb61b$var$scopeFor(mutation) {
    var _mutation_options_scope;
    var _mutation_options_scope_id;
    return (_mutation_options_scope_id = (_mutation_options_scope = mutation.options.scope) === null || _mutation_options_scope === void 0 ? void 0 : _mutation_options_scope.id) !== null && _mutation_options_scope_id !== void 0 ? _mutation_options_scope_id : String(mutation.mutationId);
}





// src/infiniteQueryBehavior.ts

var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

function $d3fabe530440115c$export$84470d1367601e8d(pages) {
    return {
        onFetch: function(context, query) {
            var fetchFn = function() {
                var _ref = (0, $kSuI9._)(function() {
                    var _context_fetchOptions_meta_fetchMore, _context_fetchOptions_meta, _context_fetchOptions, _context_state_data, _context_state_data1, options, direction, oldPages, oldPageParams, empty, cancelled, addSignalProperty, queryFn, fetchPage, result, previous, pageParamFn, oldData, param, _oldPageParams_, remainingPages, i, param1;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                options = context.options;
                                direction = (_context_fetchOptions = context.fetchOptions) === null || _context_fetchOptions === void 0 ? void 0 : (_context_fetchOptions_meta = _context_fetchOptions.meta) === null || _context_fetchOptions_meta === void 0 ? void 0 : (_context_fetchOptions_meta_fetchMore = _context_fetchOptions_meta.fetchMore) === null || _context_fetchOptions_meta_fetchMore === void 0 ? void 0 : _context_fetchOptions_meta_fetchMore.direction;
                                oldPages = ((_context_state_data = context.state.data) === null || _context_state_data === void 0 ? void 0 : _context_state_data.pages) || [];
                                oldPageParams = ((_context_state_data1 = context.state.data) === null || _context_state_data1 === void 0 ? void 0 : _context_state_data1.pageParams) || [];
                                empty = {
                                    pages: [],
                                    pageParams: []
                                };
                                cancelled = false;
                                addSignalProperty = function(object) {
                                    Object.defineProperty(object, "signal", {
                                        enumerable: true,
                                        get: function() {
                                            if (context.signal.aborted) cancelled = true;
                                            else context.signal.addEventListener("abort", function() {
                                                cancelled = true;
                                            });
                                            return context.signal;
                                        }
                                    });
                                };
                                queryFn = (0, $af19fbfda254a923$export$c71c44209368a3bc)(context.options, context.fetchOptions);
                                fetchPage = function() {
                                    var _ref = (0, $kSuI9._)(function(data, param, previous) {
                                        var queryFnContext, page, maxPages, addTo;
                                        return (0, $eha6O.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (cancelled) return [
                                                        2,
                                                        Promise.reject()
                                                    ];
                                                    if (param == null && data.pages.length) return [
                                                        2,
                                                        Promise.resolve(data)
                                                    ];
                                                    queryFnContext = {
                                                        queryKey: context.queryKey,
                                                        pageParam: param,
                                                        direction: previous ? "backward" : "forward",
                                                        meta: context.options.meta
                                                    };
                                                    addSignalProperty(queryFnContext);
                                                    return [
                                                        4,
                                                        queryFn(queryFnContext)
                                                    ];
                                                case 1:
                                                    page = _state.sent();
                                                    maxPages = context.options.maxPages;
                                                    addTo = previous ? (0, $af19fbfda254a923$export$8c6246b73dd61f4a) : (0, $af19fbfda254a923$export$ccce65a22a26f2bc);
                                                    return [
                                                        2,
                                                        {
                                                            pages: addTo(data.pages, page, maxPages),
                                                            pageParams: addTo(data.pageParams, param, maxPages)
                                                        }
                                                    ];
                                            }
                                        });
                                    });
                                    return function fetchPage(data, param, previous) {
                                        return _ref.apply(this, arguments);
                                    };
                                }();
                                if (!(direction && oldPages.length)) return [
                                    3,
                                    2
                                ];
                                previous = direction === "backward";
                                pageParamFn = previous ? $d3fabe530440115c$var$getPreviousPageParam : $d3fabe530440115c$var$getNextPageParam;
                                oldData = {
                                    pages: oldPages,
                                    pageParams: oldPageParams
                                };
                                param = pageParamFn(options, oldData);
                                return [
                                    4,
                                    fetchPage(oldData, param, previous)
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 2:
                                return [
                                    4,
                                    fetchPage(empty, (_oldPageParams_ = oldPageParams[0]) !== null && _oldPageParams_ !== void 0 ? _oldPageParams_ : options.initialPageParam)
                                ];
                            case 3:
                                result = _state.sent();
                                remainingPages = pages !== null && pages !== void 0 ? pages : oldPages.length;
                                i = 1;
                                _state.label = 4;
                            case 4:
                                if (!(i < remainingPages)) return [
                                    3,
                                    7
                                ];
                                param1 = $d3fabe530440115c$var$getNextPageParam(options, result);
                                if (param1 == null) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    fetchPage(result, param1)
                                ];
                            case 5:
                                result = _state.sent();
                                _state.label = 6;
                            case 6:
                                i++;
                                return [
                                    3,
                                    4
                                ];
                            case 7:
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                });
                return function fetchFn() {
                    return _ref.apply(this, arguments);
                };
            }();
            if (context.options.persister) context.fetchFn = function() {
                var _context_options_persister, _context_options;
                return (_context_options_persister = (_context_options = context.options).persister) === null || _context_options_persister === void 0 ? void 0 : _context_options_persister.call(_context_options, fetchFn, {
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $d3fabe530440115c$var$getNextPageParam(options, param) {
    var pages = param.pages, pageParams = param.pageParams;
    var lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
function $d3fabe530440115c$var$getPreviousPageParam(options, param) {
    var pages = param.pages, pageParams = param.pageParams;
    var _options_getPreviousPageParam;
    return pages.length > 0 ? (_options_getPreviousPageParam = options.getPreviousPageParam) === null || _options_getPreviousPageParam === void 0 ? void 0 : _options_getPreviousPageParam.call(options, pages[0], pages, pageParams[0], pageParams) : void 0;
}
function $d3fabe530440115c$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $d3fabe530440115c$var$getNextPageParam(options, data) != null;
}
function $d3fabe530440115c$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $d3fabe530440115c$var$getPreviousPageParam(options, data) != null;
}


var $5faee5685a3d0f57$var$_queryCache, $5faee5685a3d0f57$var$_mutationCache, $5faee5685a3d0f57$var$_defaultOptions, $5faee5685a3d0f57$var$_queryDefaults, $5faee5685a3d0f57$var$_mutationDefaults, $5faee5685a3d0f57$var$_mountCount, $5faee5685a3d0f57$var$_unsubscribeFocus, $5faee5685a3d0f57$var$_unsubscribeOnline;
var $5faee5685a3d0f57$export$405d0624ed55a03f = ($5faee5685a3d0f57$var$_queryCache = /*#__PURE__*/ new WeakMap(), $5faee5685a3d0f57$var$_mutationCache = /*#__PURE__*/ new WeakMap(), $5faee5685a3d0f57$var$_defaultOptions = /*#__PURE__*/ new WeakMap(), $5faee5685a3d0f57$var$_queryDefaults = /*#__PURE__*/ new WeakMap(), $5faee5685a3d0f57$var$_mutationDefaults = /*#__PURE__*/ new WeakMap(), $5faee5685a3d0f57$var$_mountCount = /*#__PURE__*/ new WeakMap(), $5faee5685a3d0f57$var$_unsubscribeFocus = /*#__PURE__*/ new WeakMap(), $5faee5685a3d0f57$var$_unsubscribeOnline = /*#__PURE__*/ new WeakMap(), /*#__PURE__*/ function() {
    "use strict";
    function _class() {
        var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $4GJKx._)(this, _class);
        (0, $d4584ce6f6a30a88$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_queryCache, {
            writable: true,
            value: void 0
        });
        (0, $d4584ce6f6a30a88$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_mutationCache, {
            writable: true,
            value: void 0
        });
        (0, $d4584ce6f6a30a88$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_defaultOptions, {
            writable: true,
            value: void 0
        });
        (0, $d4584ce6f6a30a88$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_queryDefaults, {
            writable: true,
            value: void 0
        });
        (0, $d4584ce6f6a30a88$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_mutationDefaults, {
            writable: true,
            value: void 0
        });
        (0, $d4584ce6f6a30a88$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_mountCount, {
            writable: true,
            value: void 0
        });
        (0, $d4584ce6f6a30a88$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_unsubscribeFocus, {
            writable: true,
            value: void 0
        });
        (0, $d4584ce6f6a30a88$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_unsubscribeOnline, {
            writable: true,
            value: void 0
        });
        (0, $124143cbdcf95d51$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_queryCache, config.queryCache || new (0, $63358a1719517b9f$export$5dde0cd941da8468)());
        (0, $124143cbdcf95d51$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_mutationCache, config.mutationCache || new (0, $800448895f2fb61b$export$1fcfd9a244434844)());
        (0, $124143cbdcf95d51$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_defaultOptions, config.defaultOptions || {});
        (0, $124143cbdcf95d51$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_queryDefaults, /* @__PURE__ */ new Map());
        (0, $124143cbdcf95d51$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_mutationDefaults, /* @__PURE__ */ new Map());
        (0, $124143cbdcf95d51$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_mountCount, 0);
    }
    (0, $1wc17._)(_class, [
        {
            key: "mount",
            value: function mount() {
                (0, $e6af5fa487922a1e$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_mountCount).value++;
                if ((0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_mountCount) !== 1) return;
                var _this = this;
                (0, $124143cbdcf95d51$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_unsubscribeFocus, (0, $29eddb9c4fc3b76a$export$6bf54661be5b02cf).subscribe(function() {
                    var _ref = (0, $kSuI9._)(function(focused) {
                        return (0, $eha6O.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!focused) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        _this.resumePausedMutations()
                                    ];
                                case 1:
                                    _state.sent();
                                    (0, $8c2a5b50554ee522$export$71511d61b312f219)(_this, $5faee5685a3d0f57$var$_queryCache).onFocus();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(focused) {
                        return _ref.apply(this, arguments);
                    };
                }()));
                var _this1 = this;
                (0, $124143cbdcf95d51$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_unsubscribeOnline, (0, $1b5cdad49385d0dd$export$b113e788b2dd3fdc).subscribe(function() {
                    var _ref = (0, $kSuI9._)(function(online) {
                        return (0, $eha6O.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!online) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        _this1.resumePausedMutations()
                                    ];
                                case 1:
                                    _state.sent();
                                    (0, $8c2a5b50554ee522$export$71511d61b312f219)(_this1, $5faee5685a3d0f57$var$_queryCache).onOnline();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(online) {
                        return _ref.apply(this, arguments);
                    };
                }()));
            }
        },
        {
            key: "unmount",
            value: function unmount() {
                var _this, _this1, _ref, _this2, _this3, _ref1;
                (0, $e6af5fa487922a1e$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_mountCount).value--;
                if ((0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_mountCount) !== 0) return;
                (_this = (0, $8c2a5b50554ee522$export$71511d61b312f219)(_ref = _this1 = this, $5faee5685a3d0f57$var$_unsubscribeFocus)) === null || _this === void 0 ? void 0 : _this.call(_this1);
                (0, $124143cbdcf95d51$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_unsubscribeFocus, void 0);
                (_this2 = (0, $8c2a5b50554ee522$export$71511d61b312f219)(_ref1 = _this3 = this, $5faee5685a3d0f57$var$_unsubscribeOnline)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3);
                (0, $124143cbdcf95d51$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_unsubscribeOnline, void 0);
            }
        },
        {
            key: "isFetching",
            value: function isFetching(filters) {
                return (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_queryCache).findAll((0, $cxjpp._)((0, $do9pw._)({}, filters), {
                    fetchStatus: "fetching"
                })).length;
            }
        },
        {
            key: "isMutating",
            value: function isMutating(filters) {
                return (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_mutationCache).findAll((0, $cxjpp._)((0, $do9pw._)({}, filters), {
                    status: "pending"
                })).length;
            }
        },
        {
            key: "getQueryData",
            value: function getQueryData(queryKey) {
                var _class_private_field_get_get;
                var options = this.defaultQueryOptions({
                    queryKey: queryKey
                });
                return (_class_private_field_get_get = (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_queryCache).get(options.queryHash)) === null || _class_private_field_get_get === void 0 ? void 0 : _class_private_field_get_get.state.data;
            }
        },
        {
            key: "ensureQueryData",
            value: function ensureQueryData(options) {
                var cachedData = this.getQueryData(options.queryKey);
                if (cachedData === void 0) return this.fetchQuery(options);
                else {
                    var defaultedOptions = this.defaultQueryOptions(options);
                    var query = (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_queryCache).build(this, defaultedOptions);
                    if (options.revalidateIfStale && query.isStaleByTime((0, $af19fbfda254a923$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
                    return Promise.resolve(cachedData);
                }
            }
        },
        {
            key: "getQueriesData",
            value: function getQueriesData(filters) {
                return (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_queryCache).findAll(filters).map(function(param) {
                    var queryKey = param.queryKey, state = param.state;
                    var data = state.data;
                    return [
                        queryKey,
                        data
                    ];
                });
            }
        },
        {
            key: "setQueryData",
            value: function setQueryData(queryKey, updater, options) {
                var defaultedOptions = this.defaultQueryOptions({
                    queryKey: queryKey
                });
                var query = (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_queryCache).get(defaultedOptions.queryHash);
                var prevData = query === null || query === void 0 ? void 0 : query.state.data;
                var data = (0, $af19fbfda254a923$export$7f095f455ad5af3f)(updater, prevData);
                if (data === void 0) return void 0;
                return (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_queryCache).build(this, defaultedOptions).setData(data, (0, $cxjpp._)((0, $do9pw._)({}, options), {
                    manual: true
                }));
            }
        },
        {
            key: "setQueriesData",
            value: function setQueriesData(filters, updater, options) {
                var _this = this;
                return (0, $13a3a02e43f53625$export$520687f44db6e1ab).batch(function() {
                    return (0, $8c2a5b50554ee522$export$71511d61b312f219)(_this, $5faee5685a3d0f57$var$_queryCache).findAll(filters).map(function(param) {
                        var queryKey = param.queryKey;
                        return [
                            queryKey,
                            _this.setQueryData(queryKey, updater, options)
                        ];
                    });
                });
            }
        },
        {
            key: "getQueryState",
            value: function getQueryState(queryKey) {
                var _class_private_field_get_get;
                var options = this.defaultQueryOptions({
                    queryKey: queryKey
                });
                return (_class_private_field_get_get = (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_queryCache).get(options.queryHash)) === null || _class_private_field_get_get === void 0 ? void 0 : _class_private_field_get_get.state;
            }
        },
        {
            key: "removeQueries",
            value: function removeQueries(filters) {
                var queryCache = (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_queryCache);
                (0, $13a3a02e43f53625$export$520687f44db6e1ab).batch(function() {
                    queryCache.findAll(filters).forEach(function(query) {
                        queryCache.remove(query);
                    });
                });
            }
        },
        {
            key: "resetQueries",
            value: function resetQueries(filters, options) {
                var _this = this;
                var queryCache = (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_queryCache);
                var refetchFilters = (0, $do9pw._)({
                    type: "active"
                }, filters);
                return (0, $13a3a02e43f53625$export$520687f44db6e1ab).batch(function() {
                    queryCache.findAll(filters).forEach(function(query) {
                        query.reset();
                    });
                    return _this.refetchQueries(refetchFilters, options);
                });
            }
        },
        {
            key: "cancelQueries",
            value: function cancelQueries() {
                var _this = this;
                var filters = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, cancelOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var defaultedCancelOptions = (0, $do9pw._)({
                    revert: true
                }, cancelOptions);
                var promises = (0, $13a3a02e43f53625$export$520687f44db6e1ab).batch(function() {
                    return (0, $8c2a5b50554ee522$export$71511d61b312f219)(_this, $5faee5685a3d0f57$var$_queryCache).findAll(filters).map(function(query) {
                        return query.cancel(defaultedCancelOptions);
                    });
                });
                return Promise.all(promises).then((0, $af19fbfda254a923$export$8793edee2d425525)).catch((0, $af19fbfda254a923$export$8793edee2d425525));
            }
        },
        {
            key: "invalidateQueries",
            value: function invalidateQueries() {
                var _this = this;
                var filters = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return (0, $13a3a02e43f53625$export$520687f44db6e1ab).batch(function() {
                    (0, $8c2a5b50554ee522$export$71511d61b312f219)(_this, $5faee5685a3d0f57$var$_queryCache).findAll(filters).forEach(function(query) {
                        query.invalidate();
                    });
                    if (filters.refetchType === "none") return Promise.resolve();
                    var _filters_refetchType, _ref;
                    var refetchFilters = (0, $cxjpp._)((0, $do9pw._)({}, filters), {
                        type: (_ref = (_filters_refetchType = filters.refetchType) !== null && _filters_refetchType !== void 0 ? _filters_refetchType : filters.type) !== null && _ref !== void 0 ? _ref : "active"
                    });
                    return _this.refetchQueries(refetchFilters, options);
                });
            }
        },
        {
            key: "refetchQueries",
            value: function refetchQueries() {
                var _this = this;
                var filters = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, options = arguments.length > 1 ? arguments[1] : void 0;
                var _options_cancelRefetch;
                var fetchOptions = (0, $cxjpp._)((0, $do9pw._)({}, options), {
                    cancelRefetch: (_options_cancelRefetch = options === null || options === void 0 ? void 0 : options.cancelRefetch) !== null && _options_cancelRefetch !== void 0 ? _options_cancelRefetch : true
                });
                var promises = (0, $13a3a02e43f53625$export$520687f44db6e1ab).batch(function() {
                    return (0, $8c2a5b50554ee522$export$71511d61b312f219)(_this, $5faee5685a3d0f57$var$_queryCache).findAll(filters).filter(function(query) {
                        return !query.isDisabled();
                    }).map(function(query) {
                        var promise = query.fetch(void 0, fetchOptions);
                        if (!fetchOptions.throwOnError) promise = promise.catch((0, $af19fbfda254a923$export$8793edee2d425525));
                        return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
                    });
                });
                return Promise.all(promises).then((0, $af19fbfda254a923$export$8793edee2d425525));
            }
        },
        {
            key: "fetchQuery",
            value: function fetchQuery(options) {
                var defaultedOptions = this.defaultQueryOptions(options);
                if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
                var query = (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_queryCache).build(this, defaultedOptions);
                return query.isStaleByTime((0, $af19fbfda254a923$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
            }
        },
        {
            key: "prefetchQuery",
            value: function prefetchQuery(options) {
                return this.fetchQuery(options).then((0, $af19fbfda254a923$export$8793edee2d425525)).catch((0, $af19fbfda254a923$export$8793edee2d425525));
            }
        },
        {
            key: "fetchInfiniteQuery",
            value: function fetchInfiniteQuery(options) {
                options.behavior = (0, $d3fabe530440115c$export$84470d1367601e8d)(options.pages);
                return this.fetchQuery(options);
            }
        },
        {
            key: "prefetchInfiniteQuery",
            value: function prefetchInfiniteQuery(options) {
                return this.fetchInfiniteQuery(options).then((0, $af19fbfda254a923$export$8793edee2d425525)).catch((0, $af19fbfda254a923$export$8793edee2d425525));
            }
        },
        {
            key: "resumePausedMutations",
            value: function resumePausedMutations() {
                if ((0, $1b5cdad49385d0dd$export$b113e788b2dd3fdc).isOnline()) return (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_mutationCache).resumePausedMutations();
                return Promise.resolve();
            }
        },
        {
            key: "getQueryCache",
            value: function getQueryCache() {
                return (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_queryCache);
            }
        },
        {
            key: "getMutationCache",
            value: function getMutationCache() {
                return (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_mutationCache);
            }
        },
        {
            key: "getDefaultOptions",
            value: function getDefaultOptions() {
                return (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_defaultOptions);
            }
        },
        {
            key: "setDefaultOptions",
            value: function setDefaultOptions(options) {
                (0, $124143cbdcf95d51$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_defaultOptions, options);
            }
        },
        {
            key: "setQueryDefaults",
            value: function setQueryDefaults(queryKey, options) {
                (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_queryDefaults).set((0, $af19fbfda254a923$export$1e87d19d4aab5805)(queryKey), {
                    queryKey: queryKey,
                    defaultOptions: options
                });
            }
        },
        {
            key: "getQueryDefaults",
            value: function getQueryDefaults(queryKey) {
                var defaults = (0, $c6Xmf._)((0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_queryDefaults).values());
                var result = {};
                defaults.forEach(function(queryDefault) {
                    if ((0, $af19fbfda254a923$export$2f07189bb9fa26a7)(queryKey, queryDefault.queryKey)) result = (0, $do9pw._)({}, result, queryDefault.defaultOptions);
                });
                return result;
            }
        },
        {
            key: "setMutationDefaults",
            value: function setMutationDefaults(mutationKey, options) {
                (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_mutationDefaults).set((0, $af19fbfda254a923$export$1e87d19d4aab5805)(mutationKey), {
                    mutationKey: mutationKey,
                    defaultOptions: options
                });
            }
        },
        {
            key: "getMutationDefaults",
            value: function getMutationDefaults(mutationKey) {
                var defaults = (0, $c6Xmf._)((0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_mutationDefaults).values());
                var result = {};
                defaults.forEach(function(queryDefault) {
                    if ((0, $af19fbfda254a923$export$2f07189bb9fa26a7)(mutationKey, queryDefault.mutationKey)) result = (0, $do9pw._)({}, result, queryDefault.defaultOptions);
                });
                return result;
            }
        },
        {
            key: "defaultQueryOptions",
            value: function defaultQueryOptions(options) {
                if (options._defaulted) return options;
                var defaultedOptions = (0, $cxjpp._)((0, $do9pw._)({}, (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_defaultOptions).queries, this.getQueryDefaults(options.queryKey), options), {
                    _defaulted: true
                });
                if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $af19fbfda254a923$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
                if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
                if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
                if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
                if (defaultedOptions.enabled !== true && defaultedOptions.queryFn === (0, $af19fbfda254a923$export$1aa5a89531b7670d)) defaultedOptions.enabled = false;
                return defaultedOptions;
            }
        },
        {
            key: "defaultMutationOptions",
            value: function defaultMutationOptions(options) {
                if (options === null || options === void 0 ? void 0 : options._defaulted) return options;
                return (0, $cxjpp._)((0, $do9pw._)({}, (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_defaultOptions).mutations, (options === null || options === void 0 ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey), options), {
                    _defaulted: true
                });
            }
        },
        {
            key: "clear",
            value: function clear() {
                (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_queryCache).clear();
                (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $5faee5685a3d0f57$var$_mutationCache).clear();
            }
        }
    ]);
    return _class;
}());


var $1Mpn7 = parcelRequire("1Mpn7");

"use client";
var $953e85a5ab939cf5$export$da112d31b0149f31 = $1Mpn7.createContext(void 0);
var $953e85a5ab939cf5$export$22e77b9572c4fded = function(queryClient) {
    var client = $1Mpn7.useContext($953e85a5ab939cf5$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $953e85a5ab939cf5$export$45604f0cc8ae667b = function(param) {
    var client = param.client, children = param.children;
    $1Mpn7.useEffect(function() {
        client.mount();
        return function() {
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $78b37e1ff5a5ba28$exports.jsx)($953e85a5ab939cf5$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};


var $49f782a21a858f73$exports = {};

$49f782a21a858f73$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "BTCLogo.5558c6c7.svg";


var $cf198cc02a1cf978$exports = {};

$cf198cc02a1cf978$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "EthLogo.13b90052.svg";


var $c3af053f7c3c5163$exports = {};

$c3af053f7c3c5163$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "BNBLogo.3dada3dc.svg";


var $03620a9412aa34f7$exports = {};

$03620a9412aa34f7$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "DogeLogo.58faeab6.svg";


var $23b34a954fa05838$exports = {};

$23b34a954fa05838$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "Solana.f2db1e5a.png";


var $039bd4d684cbfd0a$exports = {};

$039bd4d684cbfd0a$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "LitecoinLogo.f8fad246.svg";


var $1e58ce75afa1adfc$exports = {};

$1e58ce75afa1adfc$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "DashLogo.ac107e85.svg";


var $d2f450ec95425176$exports = {};

$d2f450ec95425176$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "CardanoLogo.c8e54c54.svg";


var $37d27b0943e83c4c$exports = {};

$37d27b0943e83c4c$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "XMRLogo.26608d9e.svg";


var $5d39efd1acbcc2ad$exports = {};

$5d39efd1acbcc2ad$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "TetherLogo.6d30f474.svg";


var $a345f3b3ee09feaa$exports = {};

$a345f3b3ee09feaa$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "USDCLogo.08b3a902.svg";


var $2954bf38f4aed119$exports = {};

$2954bf38f4aed119$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "PolygonLogo.dda6f433.svg";


var $3e04e3845a939979$exports = {};

$3e04e3845a939979$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "Doge.9d700487.png";


var $db5e1d58939009e6$exports = {};

$db5e1d58939009e6$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "ZcashLogo.5ee68c2f.svg";


var $5d22a9b53f75b97e$exports = {};

$5d22a9b53f75b97e$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "BAT.1212afba.svg";


var $c7c23fe39b1ec5b3$exports = {};

$c7c23fe39b1ec5b3$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "BUSDLogo.a70524b3.svg";


var $cca768d861163912$exports = {};

$cca768d861163912$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "DOT.8f378c19.svg";


var $239aa09aa7299eeb$exports = {};

$239aa09aa7299eeb$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "TronLogo.a023c6a9.svg";


var $fe6907d6cba7b37a$exports = {};

$fe6907d6cba7b37a$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "VerseLogo.e24b56c2.png";


var $953030a151110bf7$exports = {};

$953030a151110bf7$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "ArbitrumLogo.4a7518b6.svg";


var $cdac8429c845843c$exports = {};

$cdac8429c845843c$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "AvalancheLogo.ad53a0d0.svg";


var $4fbedd456c072db4$exports = {};

$4fbedd456c072db4$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "BaseLogo.e87313d9.svg";



var $do9pw = parcelRequire("do9pw");
function $3bff8aebc4e60342$export$b6380ff64616a4fb(chain) {
    return (0, $do9pw._)({
        formatters: undefined,
        fees: undefined,
        serializers: undefined
    }, chain);
}


var $f2095a368764cd16$export$536d3e0d2c7baf54 = /*#__PURE__*/ (0, $3bff8aebc4e60342$export$b6380ff64616a4fb)({
    id: 1,
    name: "Ethereum",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://cloudflare-eth.com"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "Etherscan",
            url: "https://etherscan.io",
            apiUrl: "https://api.etherscan.io/api"
        }
    },
    contracts: {
        ensRegistry: {
            address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
        },
        ensUniversalResolver: {
            address: "0xce01f8eee7E479C928F8919abD53E553a36CeF67",
            blockCreated: 19258213
        },
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 14353601
        }
    }
});


var $225f0d2cf29ca890$export$ca1d15c01fde7266 = /*#__PURE__*/ (0, $3bff8aebc4e60342$export$b6380ff64616a4fb)({
    id: 43114,
    name: "Avalanche",
    nativeCurrency: {
        decimals: 18,
        name: "Avalanche",
        symbol: "AVAX"
    },
    rpcUrls: {
        default: {
            http: [
                "https://api.avax.network/ext/bc/C/rpc"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "SnowTrace",
            url: "https://snowtrace.io",
            apiUrl: "https://api.snowtrace.io"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 11907934
        }
    }
});


var $3sHb8 = parcelRequire("3sHb8");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");
/**
 * Predeploy contracts for OP Stack.
 * @see https://github.com/ethereum-optimism/optimism/blob/develop/specs/predeploys.md
 */ var $efa78c0455d124f3$export$ea30b8ddade7b2c1 = {
    gasPriceOracle: {
        address: "0x420000000000000000000000000000000000000F"
    },
    l1Block: {
        address: "0x4200000000000000000000000000000000000015"
    },
    l2CrossDomainMessenger: {
        address: "0x4200000000000000000000000000000000000007"
    },
    l2Erc721Bridge: {
        address: "0x4200000000000000000000000000000000000014"
    },
    l2StandardBridge: {
        address: "0x4200000000000000000000000000000000000010"
    },
    l2ToL1MessagePasser: {
        address: "0x4200000000000000000000000000000000000016"
    }
};



var $itrhm = parcelRequire("itrhm");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $2eyrN = parcelRequire("2eyrN");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $l0HdX = parcelRequire("l0HdX");

var $itrhm = parcelRequire("itrhm");

var $2eyrN = parcelRequire("2eyrN");
var $362945b46c90d2fd$export$cd5f936b62a5e91 = {
    "0x0": "legacy",
    "0x1": "eip2930",
    "0x2": "eip1559",
    "0x3": "eip4844",
    "0x4": "eip7702"
};
function $362945b46c90d2fd$export$b02b16590d26dadc(transaction) {
    var transaction_ = (0, $cxjpp._)((0, $do9pw._)({}, transaction), {
        blockHash: transaction.blockHash ? transaction.blockHash : null,
        blockNumber: transaction.blockNumber ? BigInt(transaction.blockNumber) : null,
        chainId: transaction.chainId ? (0, $itrhm.hexToNumber)(transaction.chainId) : undefined,
        gas: transaction.gas ? BigInt(transaction.gas) : undefined,
        gasPrice: transaction.gasPrice ? BigInt(transaction.gasPrice) : undefined,
        maxFeePerBlobGas: transaction.maxFeePerBlobGas ? BigInt(transaction.maxFeePerBlobGas) : undefined,
        maxFeePerGas: transaction.maxFeePerGas ? BigInt(transaction.maxFeePerGas) : undefined,
        maxPriorityFeePerGas: transaction.maxPriorityFeePerGas ? BigInt(transaction.maxPriorityFeePerGas) : undefined,
        nonce: transaction.nonce ? (0, $itrhm.hexToNumber)(transaction.nonce) : undefined,
        to: transaction.to ? transaction.to : null,
        transactionIndex: transaction.transactionIndex ? Number(transaction.transactionIndex) : null,
        type: transaction.type ? $362945b46c90d2fd$export$cd5f936b62a5e91[transaction.type] : undefined,
        typeHex: transaction.type ? transaction.type : undefined,
        value: transaction.value ? BigInt(transaction.value) : undefined,
        v: transaction.v ? BigInt(transaction.v) : undefined
    });
    if (transaction.authorizationList) transaction_.authorizationList = $362945b46c90d2fd$var$formatAuthorizationList(transaction.authorizationList);
    transaction_.yParity = function() {
        // If `yParity` is provided, we will use it.
        if (transaction.yParity) return Number(transaction.yParity);
        // If no `yParity` provided, try derive from `v`.
        if ((0, $l0HdX._)(transaction_.v) === "bigint") {
            if (transaction_.v === 0n || transaction_.v === 27n) return 0;
            if (transaction_.v === 1n || transaction_.v === 28n) return 1;
            if (transaction_.v >= 35n) return transaction_.v % 2n === 0n ? 1 : 0;
        }
        return undefined;
    }();
    if (transaction_.type === "legacy") {
        delete transaction_.accessList;
        delete transaction_.maxFeePerBlobGas;
        delete transaction_.maxFeePerGas;
        delete transaction_.maxPriorityFeePerGas;
        delete transaction_.yParity;
    }
    if (transaction_.type === "eip2930") {
        delete transaction_.maxFeePerBlobGas;
        delete transaction_.maxFeePerGas;
        delete transaction_.maxPriorityFeePerGas;
    }
    if (transaction_.type === "eip1559") delete transaction_.maxFeePerBlobGas;
    return transaction_;
}
var $362945b46c90d2fd$export$c19bdc7dbe69198d = /*#__PURE__*/ (0, $2eyrN.defineFormatter)("transaction", $362945b46c90d2fd$export$b02b16590d26dadc);
//////////////////////////////////////////////////////////////////////////////
function $362945b46c90d2fd$var$formatAuthorizationList(authorizationList) {
    return authorizationList.map(function(authorization) {
        return (0, $do9pw._)({
            contractAddress: authorization.address,
            r: authorization.r,
            s: authorization.s,
            chainId: Number(authorization.chainId),
            nonce: Number(authorization.nonce)
        }, typeof authorization.yParity !== "undefined" ? {
            yParity: Number(authorization.yParity)
        } : {}, typeof authorization.v !== "undefined" && typeof authorization.yParity === "undefined" ? {
            v: Number(authorization.v)
        } : {});
    });
}


function $f6087e0399f0c94f$export$ba1152bc4017d62a(block) {
    var _block_transactions;
    var transactions = (_block_transactions = block.transactions) === null || _block_transactions === void 0 ? void 0 : _block_transactions.map(function(transaction) {
        if (typeof transaction === "string") return transaction;
        return (0, $362945b46c90d2fd$export$b02b16590d26dadc)(transaction);
    });
    return (0, $cxjpp._)((0, $do9pw._)({}, block), {
        baseFeePerGas: block.baseFeePerGas ? BigInt(block.baseFeePerGas) : null,
        blobGasUsed: block.blobGasUsed ? BigInt(block.blobGasUsed) : undefined,
        difficulty: block.difficulty ? BigInt(block.difficulty) : undefined,
        excessBlobGas: block.excessBlobGas ? BigInt(block.excessBlobGas) : undefined,
        gasLimit: block.gasLimit ? BigInt(block.gasLimit) : undefined,
        gasUsed: block.gasUsed ? BigInt(block.gasUsed) : undefined,
        hash: block.hash ? block.hash : null,
        logsBloom: block.logsBloom ? block.logsBloom : null,
        nonce: block.nonce ? block.nonce : null,
        number: block.number ? BigInt(block.number) : null,
        size: block.size ? BigInt(block.size) : undefined,
        timestamp: block.timestamp ? BigInt(block.timestamp) : undefined,
        transactions: transactions,
        totalDifficulty: block.totalDifficulty ? BigInt(block.totalDifficulty) : null
    });
}
var $f6087e0399f0c94f$export$9f35cb3327f1a5c5 = /*#__PURE__*/ (0, $2eyrN.defineFormatter)("block", $f6087e0399f0c94f$export$ba1152bc4017d62a);




var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $itrhm = parcelRequire("itrhm");

var $2eyrN = parcelRequire("2eyrN");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");
function $55e0178b1429ebe9$export$fccdbdc2b9d7893(log) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, args = _ref.args, eventName = _ref.eventName;
    return (0, $do9pw._)((0, $cxjpp._)((0, $do9pw._)({}, log), {
        blockHash: log.blockHash ? log.blockHash : null,
        blockNumber: log.blockNumber ? BigInt(log.blockNumber) : null,
        logIndex: log.logIndex ? Number(log.logIndex) : null,
        transactionHash: log.transactionHash ? log.transactionHash : null,
        transactionIndex: log.transactionIndex ? Number(log.transactionIndex) : null
    }), eventName ? {
        args: args,
        eventName: eventName
    } : {});
}



var $8cb58e272a45980a$export$3f17d120ae0df04 = {
    "0x0": "reverted",
    "0x1": "success"
};
function $8cb58e272a45980a$export$30da670e49d6fc31(transactionReceipt) {
    var receipt = (0, $cxjpp._)((0, $do9pw._)({}, transactionReceipt), {
        blockNumber: transactionReceipt.blockNumber ? BigInt(transactionReceipt.blockNumber) : null,
        contractAddress: transactionReceipt.contractAddress ? transactionReceipt.contractAddress : null,
        cumulativeGasUsed: transactionReceipt.cumulativeGasUsed ? BigInt(transactionReceipt.cumulativeGasUsed) : null,
        effectiveGasPrice: transactionReceipt.effectiveGasPrice ? BigInt(transactionReceipt.effectiveGasPrice) : null,
        gasUsed: transactionReceipt.gasUsed ? BigInt(transactionReceipt.gasUsed) : null,
        logs: transactionReceipt.logs ? transactionReceipt.logs.map(function(log) {
            return (0, $55e0178b1429ebe9$export$fccdbdc2b9d7893)(log);
        }) : null,
        to: transactionReceipt.to ? transactionReceipt.to : null,
        transactionIndex: transactionReceipt.transactionIndex ? (0, $itrhm.hexToNumber)(transactionReceipt.transactionIndex) : null,
        status: transactionReceipt.status ? $8cb58e272a45980a$export$3f17d120ae0df04[transactionReceipt.status] : null,
        type: transactionReceipt.type ? (0, $362945b46c90d2fd$export$cd5f936b62a5e91)[transactionReceipt.type] || transactionReceipt.type : null
    });
    if (transactionReceipt.blobGasPrice) receipt.blobGasPrice = BigInt(transactionReceipt.blobGasPrice);
    if (transactionReceipt.blobGasUsed) receipt.blobGasUsed = BigInt(transactionReceipt.blobGasUsed);
    return receipt;
}
var $8cb58e272a45980a$export$8d3f90420000ba71 = /*#__PURE__*/ (0, $2eyrN.defineFormatter)("transactionReceipt", $8cb58e272a45980a$export$30da670e49d6fc31);


var $8c36d5665146b2eb$export$fe98a034cfb96d55 = {
    block: /*#__PURE__*/ (0, $f6087e0399f0c94f$export$9f35cb3327f1a5c5)({
        format: function(args) {
            var _args_transactions;
            var transactions = (_args_transactions = args.transactions) === null || _args_transactions === void 0 ? void 0 : _args_transactions.map(function(transaction) {
                if (typeof transaction === "string") return transaction;
                var formatted = (0, $362945b46c90d2fd$export$b02b16590d26dadc)(transaction);
                if (formatted.typeHex === "0x7e") {
                    formatted.isSystemTx = transaction.isSystemTx;
                    formatted.mint = transaction.mint ? (0, $itrhm.hexToBigInt)(transaction.mint) : undefined;
                    formatted.sourceHash = transaction.sourceHash;
                    formatted.type = "deposit";
                }
                return formatted;
            });
            return {
                transactions: transactions,
                stateRoot: args.stateRoot
            };
        }
    }),
    transaction: /*#__PURE__*/ (0, $362945b46c90d2fd$export$c19bdc7dbe69198d)({
        format: function(args) {
            var transaction = {};
            if (args.type === "0x7e") {
                transaction.isSystemTx = args.isSystemTx;
                transaction.mint = args.mint ? (0, $itrhm.hexToBigInt)(args.mint) : undefined;
                transaction.sourceHash = args.sourceHash;
                transaction.type = "deposit";
            }
            return transaction;
        }
    }),
    transactionReceipt: /*#__PURE__*/ (0, $8cb58e272a45980a$export$8d3f90420000ba71)({
        format: function(args) {
            return {
                l1GasPrice: args.l1GasPrice ? (0, $itrhm.hexToBigInt)(args.l1GasPrice) : null,
                l1GasUsed: args.l1GasUsed ? (0, $itrhm.hexToBigInt)(args.l1GasUsed) : null,
                l1Fee: args.l1Fee ? (0, $itrhm.hexToBigInt)(args.l1Fee) : null,
                l1FeeScalar: args.l1FeeScalar ? Number(args.l1FeeScalar) : null
            };
        }
    })
};



var $5YJl8 = parcelRequire("5YJl8");

var $7deC8 = parcelRequire("7deC8");

var $ewLmX = parcelRequire("ewLmX");

var $f3VZN = parcelRequire("f3VZN");

var $7ihh7 = parcelRequire("7ihh7");

var $89FXB = parcelRequire("89FXB");

var $g8Qfu = parcelRequire("g8Qfu");

var $f3VZN = parcelRequire("f3VZN");
function $386e2dc3c188940d$export$140c78e750979cda(bytes) {
    var to = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "hex";
    var encodable = $386e2dc3c188940d$var$getEncodable(bytes);
    var cursor = (0, $89FXB.createCursor)(new Uint8Array(encodable.length));
    encodable.encode(cursor);
    if (to === "hex") return (0, $f3VZN.bytesToHex)(cursor.bytes);
    return cursor.bytes;
}
function $386e2dc3c188940d$export$643d3163062ff0f3(bytes) {
    var to = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "bytes";
    return $386e2dc3c188940d$export$140c78e750979cda(bytes, to);
}
function $386e2dc3c188940d$export$e01da38311234e95(hex) {
    var to = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "hex";
    return $386e2dc3c188940d$export$140c78e750979cda(hex, to);
}
function $386e2dc3c188940d$var$getEncodable(bytes) {
    if (Array.isArray(bytes)) return $386e2dc3c188940d$var$getEncodableList(bytes.map(function(x) {
        return $386e2dc3c188940d$var$getEncodable(x);
    }));
    return $386e2dc3c188940d$var$getEncodableBytes(bytes);
}
function $386e2dc3c188940d$var$getEncodableList(list) {
    var bodyLength = list.reduce(function(acc, x) {
        return acc + x.length;
    }, 0);
    var sizeOfBodyLength = $386e2dc3c188940d$var$getSizeOfLength(bodyLength);
    var length = function() {
        if (bodyLength <= 55) return 1 + bodyLength;
        return 1 + sizeOfBodyLength + bodyLength;
    }();
    return {
        length: length,
        encode: function(cursor) {
            if (bodyLength <= 55) cursor.pushByte(0xc0 + bodyLength);
            else {
                cursor.pushByte(247 + sizeOfBodyLength);
                if (sizeOfBodyLength === 1) cursor.pushUint8(bodyLength);
                else if (sizeOfBodyLength === 2) cursor.pushUint16(bodyLength);
                else if (sizeOfBodyLength === 3) cursor.pushUint24(bodyLength);
                else cursor.pushUint32(bodyLength);
            }
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var encode = _step.value.encode;
                    encode(cursor);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    };
}
function $386e2dc3c188940d$var$getEncodableBytes(bytesOrHex) {
    var bytes = typeof bytesOrHex === "string" ? (0, $g8Qfu.hexToBytes)(bytesOrHex) : bytesOrHex;
    var sizeOfBytesLength = $386e2dc3c188940d$var$getSizeOfLength(bytes.length);
    var length = function() {
        if (bytes.length === 1 && bytes[0] < 0x80) return 1;
        if (bytes.length <= 55) return 1 + bytes.length;
        return 1 + sizeOfBytesLength + bytes.length;
    }();
    return {
        length: length,
        encode: function(cursor) {
            if (bytes.length === 1 && bytes[0] < 0x80) cursor.pushBytes(bytes);
            else if (bytes.length <= 55) {
                cursor.pushByte(0x80 + bytes.length);
                cursor.pushBytes(bytes);
            } else {
                cursor.pushByte(183 + sizeOfBytesLength);
                if (sizeOfBytesLength === 1) cursor.pushUint8(bytes.length);
                else if (sizeOfBytesLength === 2) cursor.pushUint16(bytes.length);
                else if (sizeOfBytesLength === 3) cursor.pushUint24(bytes.length);
                else cursor.pushUint32(bytes.length);
                cursor.pushBytes(bytes);
            }
        }
    };
}
function $386e2dc3c188940d$var$getSizeOfLength(length) {
    if (length < 256) return 1;
    if (length < Math.pow(2, 16)) return 2;
    if (length < Math.pow(2, 24)) return 3;
    if (length < Math.pow(2, 32)) return 4;
    throw new (0, $7ihh7.BaseError)("Length is too large.");
}



var $c6Xmf = parcelRequire("c6Xmf");

var $hgawa = parcelRequire("hgawa");

var $g8Qfu = parcelRequire("g8Qfu");

var $f3VZN = parcelRequire("f3VZN");
function $239f76bf65899618$export$b67626aab22a659b(parameters) {
    var kzg = parameters.kzg;
    var _parameters_to;
    var to = (_parameters_to = parameters.to) !== null && _parameters_to !== void 0 ? _parameters_to : typeof parameters.blobs[0] === "string" ? "hex" : "bytes";
    var blobs = typeof parameters.blobs[0] === "string" ? parameters.blobs.map(function(x) {
        return (0, $g8Qfu.hexToBytes)(x);
    }) : parameters.blobs;
    var commitments = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = blobs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var blob = _step.value;
            commitments.push(Uint8Array.from(kzg.blobToKzgCommitment(blob)));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return to === "bytes" ? commitments : commitments.map(function(x) {
        return (0, $f3VZN.bytesToHex)(x);
    });
}



var $g8Qfu = parcelRequire("g8Qfu");

var $f3VZN = parcelRequire("f3VZN");
function $cdb99e133ee02170$export$78a225f8922765eb(parameters) {
    var kzg = parameters.kzg;
    var _parameters_to;
    var to = (_parameters_to = parameters.to) !== null && _parameters_to !== void 0 ? _parameters_to : typeof parameters.blobs[0] === "string" ? "hex" : "bytes";
    var blobs = typeof parameters.blobs[0] === "string" ? parameters.blobs.map(function(x) {
        return (0, $g8Qfu.hexToBytes)(x);
    }) : parameters.blobs;
    var commitments = typeof parameters.commitments[0] === "string" ? parameters.commitments.map(function(x) {
        return (0, $g8Qfu.hexToBytes)(x);
    }) : parameters.commitments;
    var proofs = [];
    for(var i = 0; i < blobs.length; i++){
        var blob = blobs[i];
        var commitment = commitments[i];
        proofs.push(Uint8Array.from(kzg.computeBlobKzgProof(blob, commitment)));
    }
    return to === "bytes" ? proofs : proofs.map(function(x) {
        return (0, $f3VZN.bytesToHex)(x);
    });
}



var $f3VZN = parcelRequire("f3VZN");

var $fjRrf = parcelRequire("fjRrf");

var $aP7UT = parcelRequire("aP7UT");

var $g8Qfu = parcelRequire("g8Qfu");

var $f3VZN = parcelRequire("f3VZN");
function $578bb9c1e6b988a5$export$bced8d2aada2d1c9(value, to_) {
    var to = to_ || "hex";
    var bytes = (0, $fjRrf.sha256)((0, $aP7UT.isHex)(value, {
        strict: false
    }) ? (0, $g8Qfu.toBytes)(value) : value);
    if (to === "bytes") return bytes;
    return (0, $f3VZN.toHex)(bytes);
}


function $744d7c4fe18d29b1$export$7b2f762c7eb1ecea(parameters) {
    var commitment = parameters.commitment, _parameters_version = parameters.version, version = _parameters_version === void 0 ? 1 : _parameters_version;
    var _parameters_to;
    var to = (_parameters_to = parameters.to) !== null && _parameters_to !== void 0 ? _parameters_to : typeof commitment === "string" ? "hex" : "bytes";
    var versionedHash = (0, $578bb9c1e6b988a5$export$bced8d2aada2d1c9)(commitment, "bytes");
    versionedHash.set([
        version
    ], 0);
    return to === "bytes" ? versionedHash : (0, $f3VZN.bytesToHex)(versionedHash);
}


function $ec1abdeba20dbf2b$export$e31b3e59dda37b17(parameters) {
    var commitments = parameters.commitments, version = parameters.version;
    var _parameters_to;
    var to = (_parameters_to = parameters.to) !== null && _parameters_to !== void 0 ? _parameters_to : typeof commitments[0] === "string" ? "hex" : "bytes";
    var hashes = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = commitments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var commitment = _step.value;
            hashes.push((0, $744d7c4fe18d29b1$export$7b2f762c7eb1ecea)({
                commitment: commitment,
                to: to,
                version: version
            }));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return hashes;
}




// https://github.com/ethereum/EIPs/blob/master/EIPS/eip-4844.md#parameters
/** Blob limit per transaction. */ var $cd1d1b22dd498287$var$blobsPerTransaction = 6;
var $cd1d1b22dd498287$export$a5d2a246d959344 = 32;
var $cd1d1b22dd498287$export$57577a1a84b7e334 = 4096;
var $cd1d1b22dd498287$export$6f30828563a6c6ef = $cd1d1b22dd498287$export$a5d2a246d959344 * $cd1d1b22dd498287$export$57577a1a84b7e334;
var $cd1d1b22dd498287$export$b8db4e3f07d08e09 = $cd1d1b22dd498287$export$6f30828563a6c6ef * $cd1d1b22dd498287$var$blobsPerTransaction - // terminator byte (0x80).
1 - // zero byte (0x00) appended to each field element.
1 * $cd1d1b22dd498287$export$57577a1a84b7e334 * $cd1d1b22dd498287$var$blobsPerTransaction;



var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");
// https://github.com/ethereum/EIPs/blob/master/EIPS/eip-4844.md#parameters
var $b5da64e270fc872e$export$de38d5f871f0b1cd = 1;



var $7ihh7 = parcelRequire("7ihh7");
var $de1c8f11abf2043a$export$4000e90bfe41caa1 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(BlobSizeTooLargeError, BaseError);
    var _super = (0, $ohfOJ._)(BlobSizeTooLargeError);
    function BlobSizeTooLargeError(param) {
        var maxSize = param.maxSize, size = param.size;
        (0, $4GJKx._)(this, BlobSizeTooLargeError);
        return _super.call(this, "Blob size is too large.", {
            metaMessages: [
                "Max: ".concat(maxSize, " bytes"),
                "Given: ".concat(size, " bytes")
            ],
            name: "BlobSizeTooLargeError"
        });
    }
    return BlobSizeTooLargeError;
}((0, $7ihh7.BaseError));
var $de1c8f11abf2043a$export$d145394ceab4d1c3 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(EmptyBlobError, BaseError);
    var _super = (0, $ohfOJ._)(EmptyBlobError);
    function EmptyBlobError() {
        (0, $4GJKx._)(this, EmptyBlobError);
        return _super.call(this, "Blob data must not be empty.", {
            name: "EmptyBlobError"
        });
    }
    return EmptyBlobError;
}((0, $7ihh7.BaseError));
var $de1c8f11abf2043a$export$ebd5b15dd92c680 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(InvalidVersionedHashSizeError, BaseError);
    var _super = (0, $ohfOJ._)(InvalidVersionedHashSizeError);
    function InvalidVersionedHashSizeError(param) {
        var hash = param.hash, size = param.size;
        (0, $4GJKx._)(this, InvalidVersionedHashSizeError);
        return _super.call(this, 'Versioned hash "'.concat(hash, '" size is invalid.'), {
            metaMessages: [
                "Expected: 32",
                "Received: ".concat(size)
            ],
            name: "InvalidVersionedHashSizeError"
        });
    }
    return InvalidVersionedHashSizeError;
}((0, $7ihh7.BaseError));
var $de1c8f11abf2043a$export$509ed1d312c500 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(InvalidVersionedHashVersionError, BaseError);
    var _super = (0, $ohfOJ._)(InvalidVersionedHashVersionError);
    function InvalidVersionedHashVersionError(param) {
        var hash = param.hash, version = param.version;
        (0, $4GJKx._)(this, InvalidVersionedHashVersionError);
        return _super.call(this, 'Versioned hash "'.concat(hash, '" version is invalid.'), {
            metaMessages: [
                "Expected: ".concat((0, $b5da64e270fc872e$export$de38d5f871f0b1cd)),
                "Received: ".concat(version)
            ],
            name: "InvalidVersionedHashVersionError"
        });
    }
    return InvalidVersionedHashVersionError;
}((0, $7ihh7.BaseError));



var $89FXB = parcelRequire("89FXB");

var $dfJGH = parcelRequire("dfJGH");

var $g8Qfu = parcelRequire("g8Qfu");

var $f3VZN = parcelRequire("f3VZN");
function $9d3813f24560413f$export$7ec339bd77d6ed92(parameters) {
    var _parameters_to;
    var to = (_parameters_to = parameters.to) !== null && _parameters_to !== void 0 ? _parameters_to : typeof parameters.data === "string" ? "hex" : "bytes";
    var data = typeof parameters.data === "string" ? (0, $g8Qfu.hexToBytes)(parameters.data) : parameters.data;
    var size_ = (0, $dfJGH.size)(data);
    if (!size_) throw new (0, $de1c8f11abf2043a$export$d145394ceab4d1c3)();
    if (size_ > (0, $cd1d1b22dd498287$export$b8db4e3f07d08e09)) throw new (0, $de1c8f11abf2043a$export$4000e90bfe41caa1)({
        maxSize: (0, $cd1d1b22dd498287$export$b8db4e3f07d08e09),
        size: size_
    });
    var blobs = [];
    var active = true;
    var position = 0;
    while(active){
        var blob = (0, $89FXB.createCursor)(new Uint8Array((0, $cd1d1b22dd498287$export$6f30828563a6c6ef)));
        var _$size = 0;
        while(_$size < (0, $cd1d1b22dd498287$export$57577a1a84b7e334)){
            var bytes = data.slice(position, position + ((0, $cd1d1b22dd498287$export$a5d2a246d959344) - 1));
            // Push a zero byte so the field element doesn't overflow the BLS modulus.
            blob.pushByte(0x00);
            // Push the current segment of data bytes.
            blob.pushBytes(bytes);
            // If we detect that the current segment of data bytes is less than 31 bytes,
            // we can stop processing and push a terminator byte to indicate the end of the blob.
            if (bytes.length < 31) {
                blob.pushByte(0x80);
                active = false;
                break;
            }
            _$size++;
            position += 31;
        }
        blobs.push(blob);
    }
    return to === "bytes" ? blobs.map(function(x) {
        return x.bytes;
    }) : blobs.map(function(x) {
        return (0, $f3VZN.bytesToHex)(x.bytes);
    });
}


function $613e19a94297935c$export$44960962e1c9641b(parameters) {
    var data = parameters.data, kzg = parameters.kzg, to = parameters.to;
    var _parameters_blobs;
    var blobs = (_parameters_blobs = parameters.blobs) !== null && _parameters_blobs !== void 0 ? _parameters_blobs : (0, $9d3813f24560413f$export$7ec339bd77d6ed92)({
        data: data,
        to: to
    });
    var _parameters_commitments;
    var commitments = (_parameters_commitments = parameters.commitments) !== null && _parameters_commitments !== void 0 ? _parameters_commitments : (0, $239f76bf65899618$export$b67626aab22a659b)({
        blobs: blobs,
        kzg: kzg,
        to: to
    });
    var _parameters_proofs;
    var proofs = (_parameters_proofs = parameters.proofs) !== null && _parameters_proofs !== void 0 ? _parameters_proofs : (0, $cdb99e133ee02170$export$78a225f8922765eb)({
        blobs: blobs,
        commitments: commitments,
        kzg: kzg,
        to: to
    });
    var sidecars = [];
    for(var i = 0; i < blobs.length; i++)sidecars.push({
        blob: blobs[i],
        commitment: commitments[i],
        proof: proofs[i]
    });
    return sidecars;
}



var $ewLmX = parcelRequire("ewLmX");

var $bi3OS = parcelRequire("bi3OS");

var $f3VZN = parcelRequire("f3VZN");


var $dRLPW = parcelRequire("dRLPW");

var $c6Xmf = parcelRequire("c6Xmf");

var $f3VZN = parcelRequire("f3VZN");

function $a2e514b152a64049$export$a695669f1a41df5b(authorizationList) {
    if (!authorizationList || authorizationList.length === 0) return [];
    var serializedAuthorizationList = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = authorizationList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ref = _step.value;
            var authorization = _ref;
            var contractAddress = authorization.contractAddress, chainId = authorization.chainId, nonce = authorization.nonce, signature = (0, $dRLPW._)(authorization, [
                "contractAddress",
                "chainId",
                "nonce"
            ]);
            serializedAuthorizationList.push([
                (0, $f3VZN.toHex)(chainId),
                contractAddress,
                (0, $f3VZN.toHex)(nonce)
            ].concat((0, $c6Xmf._)((0, $adb7449d769485d0$export$13ef8e144f96fd76)({}, signature))));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serializedAuthorizationList;
}




var $5YJl8 = parcelRequire("5YJl8");

var $7ihh7 = parcelRequire("7ihh7");


var $7yD9U = parcelRequire("7yD9U");

var $btxjr = parcelRequire("btxjr");

var $7deC8 = parcelRequire("7deC8");

var $dfJGH = parcelRequire("dfJGH");

var $8SGIa = parcelRequire("8SGIa");

var $itrhm = parcelRequire("itrhm");
function $c7d2e574c5f0661d$export$c066ee77932a0249(transaction) {
    var authorizationList = transaction.authorizationList;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (authorizationList) try {
        for(var _iterator = authorizationList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var authorization = _step.value;
            var contractAddress = authorization.contractAddress, chainId = authorization.chainId;
            if (!(0, $7deC8.isAddress)(contractAddress)) throw new (0, $5YJl8.InvalidAddressError)({
                address: contractAddress
            });
            if (chainId <= 0) throw new (0, $7yD9U.InvalidChainIdError)({
                chainId: chainId
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    $c7d2e574c5f0661d$export$9ce52ad2ebd4d8fd(transaction);
}
function $c7d2e574c5f0661d$export$7a7b1c9cbdcde679(transaction) {
    var blobVersionedHashes = transaction.blobVersionedHashes;
    if (blobVersionedHashes) {
        if (blobVersionedHashes.length === 0) throw new (0, $de1c8f11abf2043a$export$d145394ceab4d1c3)();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = blobVersionedHashes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var hash = _step.value;
                var size_ = (0, $dfJGH.size)(hash);
                var version = (0, $itrhm.hexToNumber)((0, $8SGIa.slice)(hash, 0, 1));
                if (size_ !== 32) throw new (0, $de1c8f11abf2043a$export$ebd5b15dd92c680)({
                    hash: hash,
                    size: size_
                });
                if (version !== (0, $b5da64e270fc872e$export$de38d5f871f0b1cd)) throw new (0, $de1c8f11abf2043a$export$509ed1d312c500)({
                    hash: hash,
                    version: version
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    $c7d2e574c5f0661d$export$9ce52ad2ebd4d8fd(transaction);
}
function $c7d2e574c5f0661d$export$9ce52ad2ebd4d8fd(transaction) {
    var chainId = transaction.chainId, maxPriorityFeePerGas = transaction.maxPriorityFeePerGas, maxFeePerGas = transaction.maxFeePerGas, to = transaction.to;
    if (chainId <= 0) throw new (0, $7yD9U.InvalidChainIdError)({
        chainId: chainId
    });
    if (to && !(0, $7deC8.isAddress)(to)) throw new (0, $5YJl8.InvalidAddressError)({
        address: to
    });
    if (maxFeePerGas && maxFeePerGas > Math.pow(2n, 256n) - 1n) throw new (0, $btxjr.FeeCapTooHighError)({
        maxFeePerGas: maxFeePerGas
    });
    if (maxPriorityFeePerGas && maxFeePerGas && maxPriorityFeePerGas > maxFeePerGas) throw new (0, $btxjr.TipAboveFeeCapError)({
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas
    });
}
function $c7d2e574c5f0661d$export$18dc5e03b8985881(transaction) {
    var chainId = transaction.chainId, maxPriorityFeePerGas = transaction.maxPriorityFeePerGas, gasPrice = transaction.gasPrice, maxFeePerGas = transaction.maxFeePerGas, to = transaction.to;
    if (chainId <= 0) throw new (0, $7yD9U.InvalidChainIdError)({
        chainId: chainId
    });
    if (to && !(0, $7deC8.isAddress)(to)) throw new (0, $5YJl8.InvalidAddressError)({
        address: to
    });
    if (maxPriorityFeePerGas || maxFeePerGas) throw new (0, $7ihh7.BaseError)("`maxFeePerGas`/`maxPriorityFeePerGas` is not a valid EIP-2930 Transaction attribute.");
    if (gasPrice && gasPrice > Math.pow(2n, 256n) - 1n) throw new (0, $btxjr.FeeCapTooHighError)({
        maxFeePerGas: gasPrice
    });
}
function $c7d2e574c5f0661d$export$f9ff7fa58fadd108(transaction) {
    var chainId = transaction.chainId, maxPriorityFeePerGas = transaction.maxPriorityFeePerGas, gasPrice = transaction.gasPrice, maxFeePerGas = transaction.maxFeePerGas, to = transaction.to;
    if (to && !(0, $7deC8.isAddress)(to)) throw new (0, $5YJl8.InvalidAddressError)({
        address: to
    });
    if (typeof chainId !== "undefined" && chainId <= 0) throw new (0, $7yD9U.InvalidChainIdError)({
        chainId: chainId
    });
    if (maxPriorityFeePerGas || maxFeePerGas) throw new (0, $7ihh7.BaseError)("`maxFeePerGas`/`maxPriorityFeePerGas` is not a valid Legacy Transaction attribute.");
    if (gasPrice && gasPrice > Math.pow(2n, 256n) - 1n) throw new (0, $btxjr.FeeCapTooHighError)({
        maxFeePerGas: gasPrice
    });
}



var $hgawa = parcelRequire("hgawa");
function $83ee023353cbed31$export$944c6678cd5a1ea8(transaction) {
    if (transaction.type) return transaction.type;
    if (typeof transaction.authorizationList !== "undefined") return "eip7702";
    if (typeof transaction.blobs !== "undefined" || typeof transaction.blobVersionedHashes !== "undefined" || typeof transaction.maxFeePerBlobGas !== "undefined" || typeof transaction.sidecars !== "undefined") return "eip4844";
    if (typeof transaction.maxFeePerGas !== "undefined" || typeof transaction.maxPriorityFeePerGas !== "undefined") return "eip1559";
    if (typeof transaction.gasPrice !== "undefined") {
        if (typeof transaction.accessList !== "undefined") return "eip2930";
        return "legacy";
    }
    throw new (0, $hgawa.InvalidSerializableTransactionError)({
        transaction: transaction
    });
}



var $5YJl8 = parcelRequire("5YJl8");

var $hgawa = parcelRequire("hgawa");

var $7deC8 = parcelRequire("7deC8");
function $90ee9c93e2878df0$export$736ebd57ab43df1(accessList) {
    if (!accessList || accessList.length === 0) return [];
    var serializedAccessList = [];
    for(var i = 0; i < accessList.length; i++){
        var _accessList_i = accessList[i], address = _accessList_i.address, storageKeys = _accessList_i.storageKeys;
        for(var j = 0; j < storageKeys.length; j++){
            if (storageKeys[j].length - 2 !== 64) throw new (0, $hgawa.InvalidStorageKeySizeError)({
                storageKey: storageKeys[j]
            });
        }
        if (!(0, $7deC8.isAddress)(address, {
            strict: false
        })) throw new (0, $5YJl8.InvalidAddressError)({
            address: address
        });
        serializedAccessList.push([
            address,
            storageKeys
        ]);
    }
    return serializedAccessList;
}


function $adb7449d769485d0$export$7cb44e9a321cd996(transaction, signature) {
    var type = (0, $83ee023353cbed31$export$944c6678cd5a1ea8)(transaction);
    if (type === "eip1559") return $adb7449d769485d0$var$serializeTransactionEIP1559(transaction, signature);
    if (type === "eip2930") return $adb7449d769485d0$var$serializeTransactionEIP2930(transaction, signature);
    if (type === "eip4844") return $adb7449d769485d0$var$serializeTransactionEIP4844(transaction, signature);
    if (type === "eip7702") return $adb7449d769485d0$var$serializeTransactionEIP7702(transaction, signature);
    return $adb7449d769485d0$var$serializeTransactionLegacy(transaction, signature);
}
function $adb7449d769485d0$var$serializeTransactionEIP7702(transaction, signature) {
    var authorizationList = transaction.authorizationList, chainId = transaction.chainId, gas = transaction.gas, nonce = transaction.nonce, to = transaction.to, value = transaction.value, maxFeePerGas = transaction.maxFeePerGas, maxPriorityFeePerGas = transaction.maxPriorityFeePerGas, accessList = transaction.accessList, data = transaction.data;
    (0, $c7d2e574c5f0661d$export$c066ee77932a0249)(transaction);
    var serializedAccessList = (0, $90ee9c93e2878df0$export$736ebd57ab43df1)(accessList);
    var serializedAuthorizationList = (0, $a2e514b152a64049$export$a695669f1a41df5b)(authorizationList);
    return (0, $ewLmX.concatHex)([
        "0x04",
        (0, $386e2dc3c188940d$export$140c78e750979cda)([
            (0, $f3VZN.toHex)(chainId),
            nonce ? (0, $f3VZN.toHex)(nonce) : "0x",
            maxPriorityFeePerGas ? (0, $f3VZN.toHex)(maxPriorityFeePerGas) : "0x",
            maxFeePerGas ? (0, $f3VZN.toHex)(maxFeePerGas) : "0x",
            gas ? (0, $f3VZN.toHex)(gas) : "0x",
            to !== null && to !== void 0 ? to : "0x",
            value ? (0, $f3VZN.toHex)(value) : "0x",
            data !== null && data !== void 0 ? data : "0x",
            serializedAccessList,
            serializedAuthorizationList
        ].concat((0, $c6Xmf._)($adb7449d769485d0$export$13ef8e144f96fd76(transaction, signature))))
    ]);
}
function $adb7449d769485d0$var$serializeTransactionEIP4844(transaction, signature) {
    var chainId = transaction.chainId, gas = transaction.gas, nonce = transaction.nonce, to = transaction.to, value = transaction.value, maxFeePerBlobGas = transaction.maxFeePerBlobGas, maxFeePerGas = transaction.maxFeePerGas, maxPriorityFeePerGas = transaction.maxPriorityFeePerGas, accessList = transaction.accessList, data = transaction.data;
    (0, $c7d2e574c5f0661d$export$7a7b1c9cbdcde679)(transaction);
    var blobVersionedHashes = transaction.blobVersionedHashes;
    var sidecars = transaction.sidecars;
    // If `blobs` are passed, we will need to compute the KZG commitments & proofs.
    if (transaction.blobs && (typeof blobVersionedHashes === "undefined" || typeof sidecars === "undefined")) {
        var blobs = typeof transaction.blobs[0] === "string" ? transaction.blobs : transaction.blobs.map(function(x) {
            return (0, $f3VZN.bytesToHex)(x);
        });
        var kzg = transaction.kzg;
        var commitments = (0, $239f76bf65899618$export$b67626aab22a659b)({
            blobs: blobs,
            kzg: kzg
        });
        if (typeof blobVersionedHashes === "undefined") blobVersionedHashes = (0, $ec1abdeba20dbf2b$export$e31b3e59dda37b17)({
            commitments: commitments
        });
        if (typeof sidecars === "undefined") {
            var proofs = (0, $cdb99e133ee02170$export$78a225f8922765eb)({
                blobs: blobs,
                commitments: commitments,
                kzg: kzg
            });
            sidecars = (0, $613e19a94297935c$export$44960962e1c9641b)({
                blobs: blobs,
                commitments: commitments,
                proofs: proofs
            });
        }
    }
    var serializedAccessList = (0, $90ee9c93e2878df0$export$736ebd57ab43df1)(accessList);
    var serializedTransaction = [
        (0, $f3VZN.toHex)(chainId),
        nonce ? (0, $f3VZN.toHex)(nonce) : "0x",
        maxPriorityFeePerGas ? (0, $f3VZN.toHex)(maxPriorityFeePerGas) : "0x",
        maxFeePerGas ? (0, $f3VZN.toHex)(maxFeePerGas) : "0x",
        gas ? (0, $f3VZN.toHex)(gas) : "0x",
        to !== null && to !== void 0 ? to : "0x",
        value ? (0, $f3VZN.toHex)(value) : "0x",
        data !== null && data !== void 0 ? data : "0x",
        serializedAccessList,
        maxFeePerBlobGas ? (0, $f3VZN.toHex)(maxFeePerBlobGas) : "0x",
        blobVersionedHashes !== null && blobVersionedHashes !== void 0 ? blobVersionedHashes : []
    ].concat((0, $c6Xmf._)($adb7449d769485d0$export$13ef8e144f96fd76(transaction, signature)));
    var blobs1 = [];
    var commitments1 = [];
    var proofs1 = [];
    if (sidecars) for(var i = 0; i < sidecars.length; i++){
        var _sidecars_i = sidecars[i], blob = _sidecars_i.blob, commitment = _sidecars_i.commitment, proof = _sidecars_i.proof;
        blobs1.push(blob);
        commitments1.push(commitment);
        proofs1.push(proof);
    }
    return (0, $ewLmX.concatHex)([
        "0x03",
        sidecars ? (0, $386e2dc3c188940d$export$140c78e750979cda)([
            serializedTransaction,
            blobs1,
            commitments1,
            proofs1
        ]) : (0, $386e2dc3c188940d$export$140c78e750979cda)(serializedTransaction)
    ]);
}
function $adb7449d769485d0$var$serializeTransactionEIP1559(transaction, signature) {
    var chainId = transaction.chainId, gas = transaction.gas, nonce = transaction.nonce, to = transaction.to, value = transaction.value, maxFeePerGas = transaction.maxFeePerGas, maxPriorityFeePerGas = transaction.maxPriorityFeePerGas, accessList = transaction.accessList, data = transaction.data;
    (0, $c7d2e574c5f0661d$export$9ce52ad2ebd4d8fd)(transaction);
    var serializedAccessList = (0, $90ee9c93e2878df0$export$736ebd57ab43df1)(accessList);
    var serializedTransaction = [
        (0, $f3VZN.toHex)(chainId),
        nonce ? (0, $f3VZN.toHex)(nonce) : "0x",
        maxPriorityFeePerGas ? (0, $f3VZN.toHex)(maxPriorityFeePerGas) : "0x",
        maxFeePerGas ? (0, $f3VZN.toHex)(maxFeePerGas) : "0x",
        gas ? (0, $f3VZN.toHex)(gas) : "0x",
        to !== null && to !== void 0 ? to : "0x",
        value ? (0, $f3VZN.toHex)(value) : "0x",
        data !== null && data !== void 0 ? data : "0x",
        serializedAccessList
    ].concat((0, $c6Xmf._)($adb7449d769485d0$export$13ef8e144f96fd76(transaction, signature)));
    return (0, $ewLmX.concatHex)([
        "0x02",
        (0, $386e2dc3c188940d$export$140c78e750979cda)(serializedTransaction)
    ]);
}
function $adb7449d769485d0$var$serializeTransactionEIP2930(transaction, signature) {
    var chainId = transaction.chainId, gas = transaction.gas, data = transaction.data, nonce = transaction.nonce, to = transaction.to, value = transaction.value, accessList = transaction.accessList, gasPrice = transaction.gasPrice;
    (0, $c7d2e574c5f0661d$export$18dc5e03b8985881)(transaction);
    var serializedAccessList = (0, $90ee9c93e2878df0$export$736ebd57ab43df1)(accessList);
    var serializedTransaction = [
        (0, $f3VZN.toHex)(chainId),
        nonce ? (0, $f3VZN.toHex)(nonce) : "0x",
        gasPrice ? (0, $f3VZN.toHex)(gasPrice) : "0x",
        gas ? (0, $f3VZN.toHex)(gas) : "0x",
        to !== null && to !== void 0 ? to : "0x",
        value ? (0, $f3VZN.toHex)(value) : "0x",
        data !== null && data !== void 0 ? data : "0x",
        serializedAccessList
    ].concat((0, $c6Xmf._)($adb7449d769485d0$export$13ef8e144f96fd76(transaction, signature)));
    return (0, $ewLmX.concatHex)([
        "0x01",
        (0, $386e2dc3c188940d$export$140c78e750979cda)(serializedTransaction)
    ]);
}
function $adb7449d769485d0$var$serializeTransactionLegacy(transaction, signature) {
    var _transaction_chainId = transaction.chainId, chainId = _transaction_chainId === void 0 ? 0 : _transaction_chainId, gas = transaction.gas, data = transaction.data, nonce = transaction.nonce, to = transaction.to, value = transaction.value, gasPrice = transaction.gasPrice;
    (0, $c7d2e574c5f0661d$export$f9ff7fa58fadd108)(transaction);
    var serializedTransaction = [
        nonce ? (0, $f3VZN.toHex)(nonce) : "0x",
        gasPrice ? (0, $f3VZN.toHex)(gasPrice) : "0x",
        gas ? (0, $f3VZN.toHex)(gas) : "0x",
        to !== null && to !== void 0 ? to : "0x",
        value ? (0, $f3VZN.toHex)(value) : "0x",
        data !== null && data !== void 0 ? data : "0x"
    ];
    if (signature) {
        var v = function() {
            // EIP-155 (inferred chainId)
            if (signature.v >= 35n) {
                var inferredChainId = (signature.v - 35n) / 2n;
                if (inferredChainId > 0) return signature.v;
                return 27n + (signature.v === 35n ? 0n : 1n);
            }
            // EIP-155 (explicit chainId)
            if (chainId > 0) return BigInt(chainId * 2) + BigInt(35n + signature.v - 27n);
            // Pre-EIP-155 (no chainId)
            var v = 27n + (signature.v === 27n ? 0n : 1n);
            if (signature.v !== v) throw new (0, $hgawa.InvalidLegacyVError)({
                v: signature.v
            });
            return v;
        }();
        var r = (0, $bi3OS.trim)(signature.r);
        var s = (0, $bi3OS.trim)(signature.s);
        serializedTransaction = (0, $c6Xmf._)(serializedTransaction).concat([
            (0, $f3VZN.toHex)(v),
            r === "0x00" ? "0x" : r,
            s === "0x00" ? "0x" : s
        ]);
    } else if (chainId > 0) serializedTransaction = (0, $c6Xmf._)(serializedTransaction).concat([
        (0, $f3VZN.toHex)(chainId),
        "0x",
        "0x"
    ]);
    return (0, $386e2dc3c188940d$export$140c78e750979cda)(serializedTransaction);
}
function $adb7449d769485d0$export$13ef8e144f96fd76(transaction, signature_) {
    var signature = signature_ !== null && signature_ !== void 0 ? signature_ : transaction;
    var v = signature.v, yParity = signature.yParity;
    if (typeof signature.r === "undefined") return [];
    if (typeof signature.s === "undefined") return [];
    if (typeof v === "undefined" && typeof yParity === "undefined") return [];
    var r = (0, $bi3OS.trim)(signature.r);
    var s = (0, $bi3OS.trim)(signature.s);
    var yParity_ = function() {
        if (typeof yParity === "number") return yParity ? (0, $f3VZN.toHex)(1) : "0x";
        if (v === 0n) return "0x";
        if (v === 1n) return (0, $f3VZN.toHex)(1);
        return v === 27n ? "0x" : (0, $f3VZN.toHex)(1);
    }();
    return [
        yParity_,
        r === "0x00" ? "0x" : r,
        s === "0x00" ? "0x" : s
    ];
}


function $466762898570065a$export$7cb44e9a321cd996(transaction, signature) {
    if ($466762898570065a$var$isDeposit(transaction)) return $466762898570065a$var$serializeTransactionDeposit(transaction);
    return (0, $adb7449d769485d0$export$7cb44e9a321cd996)(transaction, signature);
}
var $466762898570065a$export$7824249990c72c71 = {
    transaction: $466762898570065a$export$7cb44e9a321cd996
};
function $466762898570065a$var$serializeTransactionDeposit(transaction) {
    $466762898570065a$export$91db50bb3f58e144(transaction);
    var sourceHash = transaction.sourceHash, data = transaction.data, from = transaction.from, gas = transaction.gas, isSystemTx = transaction.isSystemTx, mint = transaction.mint, to = transaction.to, value = transaction.value;
    var serializedTransaction = [
        sourceHash,
        from,
        to !== null && to !== void 0 ? to : "0x",
        mint ? (0, $f3VZN.toHex)(mint) : "0x",
        value ? (0, $f3VZN.toHex)(value) : "0x",
        gas ? (0, $f3VZN.toHex)(gas) : "0x",
        isSystemTx ? "0x1" : "0x",
        data !== null && data !== void 0 ? data : "0x"
    ];
    return (0, $ewLmX.concatHex)([
        "0x7e",
        (0, $386e2dc3c188940d$export$140c78e750979cda)(serializedTransaction)
    ]);
}
function $466762898570065a$var$isDeposit(transaction) {
    if (transaction.type === "deposit") return true;
    if (typeof transaction.sourceHash !== "undefined") return true;
    return false;
}
function $466762898570065a$export$91db50bb3f58e144(transaction) {
    var from = transaction.from, to = transaction.to;
    if (from && !(0, $7deC8.isAddress)(from)) throw new (0, $5YJl8.InvalidAddressError)({
        address: from
    });
    if (to && !(0, $7deC8.isAddress)(to)) throw new (0, $5YJl8.InvalidAddressError)({
        address: to
    });
}


var $61b28a805983de07$export$ca9ff151299322fa = {
    contracts: (0, $efa78c0455d124f3$export$ea30b8ddade7b2c1),
    formatters: (0, $8c36d5665146b2eb$export$fe98a034cfb96d55),
    serializers: (0, $466762898570065a$export$7824249990c72c71)
};



var $23f2e6978ca8d764$var$sourceId = 1; // mainnet
var $23f2e6978ca8d764$export$e2253033e6e1df16 = /*#__PURE__*/ (0, $3bff8aebc4e60342$export$b6380ff64616a4fb)((0, $cxjpp._)((0, $do9pw._)({}, (0, $61b28a805983de07$export$ca9ff151299322fa)), {
    id: 8453,
    name: "Base",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://mainnet.base.org"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "Basescan",
            url: "https://basescan.org",
            apiUrl: "https://api.basescan.org/api"
        }
    },
    contracts: (0, $cxjpp._)((0, $do9pw._)({}, (0, $61b28a805983de07$export$ca9ff151299322fa).contracts), {
        l2OutputOracle: (0, $3sHb8._)({}, $23f2e6978ca8d764$var$sourceId, {
            address: "0x56315b90c40730925ec5485cf004d835058518A0"
        }),
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 5022
        },
        portal: (0, $3sHb8._)({}, $23f2e6978ca8d764$var$sourceId, {
            address: "0x49048044D57e1C92A77f79988d21Fa8fAF74E97e",
            blockCreated: 17482143
        }),
        l1StandardBridge: (0, $3sHb8._)({}, $23f2e6978ca8d764$var$sourceId, {
            address: "0x3154Cf16ccdb4C6d922629664174b904d80F2C35",
            blockCreated: 17482143
        })
    }),
    sourceId: $23f2e6978ca8d764$var$sourceId
}));


var $609903e81fb48f89$export$b7b19aa0ee06c73 = /*#__PURE__*/ (0, $3bff8aebc4e60342$export$b6380ff64616a4fb)({
    id: 137,
    name: "Polygon",
    nativeCurrency: {
        name: "MATIC",
        symbol: "MATIC",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://polygon-rpc.com"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "PolygonScan",
            url: "https://polygonscan.com",
            apiUrl: "https://api.polygonscan.com/api"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 25770160
        }
    }
});


var $af443f471a88909e$export$34b6ef3a78067459 = /*#__PURE__*/ (0, $3bff8aebc4e60342$export$b6380ff64616a4fb)({
    id: 80001,
    name: "Polygon Mumbai",
    nativeCurrency: {
        name: "MATIC",
        symbol: "MATIC",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc.ankr.com/polygon_mumbai"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "PolygonScan",
            url: "https://mumbai.polygonscan.com",
            apiUrl: "https://api-testnet.polygonscan.com/api"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 25770160
        }
    },
    testnet: true
});


var $7c74330b745834e8$export$170e8cdd0c4e59c8 = /*#__PURE__*/ (0, $3bff8aebc4e60342$export$b6380ff64616a4fb)({
    id: 56,
    name: "BNB Smart Chain",
    nativeCurrency: {
        decimals: 18,
        name: "BNB",
        symbol: "BNB"
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc.ankr.com/bsc"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "BscScan",
            url: "https://bscscan.com",
            apiUrl: "https://api.bscscan.com/api"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 15921452
        }
    }
});


var $362fc72842b76a67$export$1c182ebff3ea4eef = /*#__PURE__*/ (0, $3bff8aebc4e60342$export$b6380ff64616a4fb)({
    id: 97,
    name: "Binance Smart Chain Testnet",
    nativeCurrency: {
        decimals: 18,
        name: "BNB",
        symbol: "tBNB"
    },
    rpcUrls: {
        default: {
            http: [
                "https://data-seed-prebsc-1-s1.bnbchain.org:8545"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "BscScan",
            url: "https://testnet.bscscan.com",
            apiUrl: "https://testnet.bscscan.com/api"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 17422483
        }
    },
    testnet: true
});


var $4f58ad3687968cfa$export$625cf84d855940d4 = /*#__PURE__*/ (0, $3bff8aebc4e60342$export$b6380ff64616a4fb)({
    id: 42161,
    name: "Arbitrum One",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://arb1.arbitrum.io/rpc"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "Arbiscan",
            url: "https://arbiscan.io",
            apiUrl: "https://api.arbiscan.io/api"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 7654707
        }
    }
});


var $8d6f5e1ed5250aac$export$857f1b5f596fb425 = /*#__PURE__*/ (0, $3bff8aebc4e60342$export$b6380ff64616a4fb)({
    id: 421613,
    name: "Arbitrum Goerli",
    nativeCurrency: {
        name: "Arbitrum Goerli Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://goerli-rollup.arbitrum.io/rpc"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "Arbiscan",
            url: "https://goerli.arbiscan.io"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 88114
        }
    },
    testnet: true
});



var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");
var $24f38d6e95bf0035$export$aafe1f751f1bc52a = {
    WALLET_CONNECT_CONNECTOR_ID: "walletConnect",
    INJECTED_CONNECTOR_ID: "injected",
    WALLET_STANDARD_CONNECTOR_ID: "announced",
    COINBASE_CONNECTOR_ID: "coinbaseWallet",
    COINBASE_SDK_CONNECTOR_ID: "coinbaseWalletSDK",
    SAFE_CONNECTOR_ID: "safe",
    LEDGER_CONNECTOR_ID: "ledger",
    EIP6963_CONNECTOR_ID: "eip6963",
    AUTH_CONNECTOR_ID: "w3mAuth",
    EIP155: "eip155",
    ADD_CHAIN_METHOD: "wallet_addEthereumChain",
    EIP6963_ANNOUNCE_EVENT: "eip6963:announceProvider",
    EIP6963_REQUEST_EVENT: "eip6963:requestProvider",
    CONNECTOR_RDNS_MAP: {
        coinbaseWallet: "com.coinbase.wallet",
        coinbaseWalletSDK: "com.coinbase.wallet"
    },
    VERSION: "5.1.4"
};



var $3sHb8 = parcelRequire("3sHb8");

var $f0772dbd8906c097$var$_obj, $f0772dbd8906c097$var$_obj1, $f0772dbd8906c097$var$_obj2, $f0772dbd8906c097$var$_obj3;
var $f0772dbd8906c097$export$fd35d6514357600 = {
    ConnectorExplorerIds: ($f0772dbd8906c097$var$_obj = {}, (0, $3sHb8._)($f0772dbd8906c097$var$_obj, (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).COINBASE_CONNECTOR_ID, "fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa"), (0, $3sHb8._)($f0772dbd8906c097$var$_obj, (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).COINBASE_SDK_CONNECTOR_ID, "fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa"), (0, $3sHb8._)($f0772dbd8906c097$var$_obj, (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).SAFE_CONNECTOR_ID, "225affb176778569276e484e1b92637ad061b01e13a048b35a9d280c3b58970f"), (0, $3sHb8._)($f0772dbd8906c097$var$_obj, (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).LEDGER_CONNECTOR_ID, "19177a98252e07ddfc9af2083ba8e07ef627cb6103467ffebb3f8f4205fd7927"), $f0772dbd8906c097$var$_obj),
    EIP155NetworkImageIds: {
        1: "ba0ba0cd-17c6-4806-ad93-f9d174f17900",
        42161: "3bff954d-5cb0-47a0-9a23-d20192e74600",
        43114: "30c46e53-e989-45fb-4549-be3bd4eb3b00",
        56: "93564157-2e8e-4ce7-81df-b264dbee9b00",
        250: "06b26297-fe0c-4733-5d6b-ffa5498aac00",
        10: "ab9c186a-c52f-464b-2906-ca59d760a400",
        137: "41d04d42-da3b-4453-8506-668cc0727900",
        100: "02b53f6a-e3d4-479e-1cb4-21178987d100",
        9001: "f926ff41-260d-4028-635e-91913fc28e00",
        324: "b310f07f-4ef7-49f3-7073-2a0a39685800",
        314: "5a73b3dd-af74-424e-cae0-0de859ee9400",
        4689: "34e68754-e536-40da-c153-6ef2e7188a00",
        1088: "3897a66d-40b9-4833-162f-a2c90531c900",
        1284: "161038da-44ae-4ec7-1208-0ea569454b00",
        1285: "f1d73bb6-5450-4e18-38f7-fb6484264a00",
        7777777: "845c60df-d429-4991-e687-91ae45791600",
        42220: "ab781bbc-ccc6-418d-d32d-789b15da1f00",
        8453: "7289c336-3981-4081-c5f4-efc26ac64a00",
        1313161554: "3ff73439-a619-4894-9262-4470c773a100",
        2020: "b8101fc0-9c19-4b6f-ec65-f6dfff106e00",
        2021: "b8101fc0-9c19-4b6f-ec65-f6dfff106e00",
        "5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp": "a1b58899-f671-4276-6a5e-56ca5bd59700",
        "4uhcVJyU9pJkvQyS88uRDiswHXSCkY3z": "a1b58899-f671-4276-6a5e-56ca5bd59700",
        EtWTRABZaYq6iMfeYKouRu166VU2xqa1: "a1b58899-f671-4276-6a5e-56ca5bd59700"
    },
    ConnectorImageIds: ($f0772dbd8906c097$var$_obj1 = {}, (0, $3sHb8._)($f0772dbd8906c097$var$_obj1, (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).COINBASE_CONNECTOR_ID, "0c2840c3-5b04-4c44-9661-fbd4b49e1800"), (0, $3sHb8._)($f0772dbd8906c097$var$_obj1, (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).COINBASE_SDK_CONNECTOR_ID, "0c2840c3-5b04-4c44-9661-fbd4b49e1800"), (0, $3sHb8._)($f0772dbd8906c097$var$_obj1, (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).SAFE_CONNECTOR_ID, "461db637-8616-43ce-035a-d89b8a1d5800"), (0, $3sHb8._)($f0772dbd8906c097$var$_obj1, (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).LEDGER_CONNECTOR_ID, "54a1aa77-d202-4f8d-0fb2-5d2bb6db0300"), (0, $3sHb8._)($f0772dbd8906c097$var$_obj1, (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).WALLET_CONNECT_CONNECTOR_ID, "ef1a1fcf-7fe8-4d69-bd6d-fda1345b4400"), (0, $3sHb8._)($f0772dbd8906c097$var$_obj1, (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).INJECTED_CONNECTOR_ID, "07ba87ed-43aa-4adf-4540-9e6a2b9cae00"), $f0772dbd8906c097$var$_obj1),
    ConnectorNamesMap: ($f0772dbd8906c097$var$_obj2 = {}, (0, $3sHb8._)($f0772dbd8906c097$var$_obj2, (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).INJECTED_CONNECTOR_ID, "Browser Wallet"), (0, $3sHb8._)($f0772dbd8906c097$var$_obj2, (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).WALLET_CONNECT_CONNECTOR_ID, "WalletConnect"), (0, $3sHb8._)($f0772dbd8906c097$var$_obj2, (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).COINBASE_CONNECTOR_ID, "Coinbase"), (0, $3sHb8._)($f0772dbd8906c097$var$_obj2, (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).COINBASE_SDK_CONNECTOR_ID, "Coinbase"), (0, $3sHb8._)($f0772dbd8906c097$var$_obj2, (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).LEDGER_CONNECTOR_ID, "Ledger"), (0, $3sHb8._)($f0772dbd8906c097$var$_obj2, (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).SAFE_CONNECTOR_ID, "Safe"), $f0772dbd8906c097$var$_obj2),
    ConnectorTypesMap: ($f0772dbd8906c097$var$_obj3 = {}, (0, $3sHb8._)($f0772dbd8906c097$var$_obj3, (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).INJECTED_CONNECTOR_ID, "INJECTED"), (0, $3sHb8._)($f0772dbd8906c097$var$_obj3, (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).WALLET_CONNECT_CONNECTOR_ID, "WALLET_CONNECT"), (0, $3sHb8._)($f0772dbd8906c097$var$_obj3, (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).EIP6963_CONNECTOR_ID, "ANNOUNCED"), (0, $3sHb8._)($f0772dbd8906c097$var$_obj3, (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).AUTH_CONNECTOR_ID, "AUTH"), $f0772dbd8906c097$var$_obj3),
    WalletConnectRpcChainIds: [
        1,
        5,
        11155111,
        10,
        420,
        42161,
        421613,
        137,
        80001,
        42220,
        1313161554,
        1313161555,
        56,
        97,
        43114,
        43113,
        100,
        8453,
        84531,
        7777777,
        999,
        324,
        280
    ]
};



var $cv9Rk = parcelRequire("cv9Rk");

var $c4fae76388afc96e$export$518f198897991e39 = {
    getCaipTokens: function(tokens) {
        if (!tokens) return undefined;
        var caipTokens = {};
        Object.entries(tokens).forEach(function(param) {
            var _param = (0, $cv9Rk._)(param, 2), id = _param[0], token = _param[1];
            caipTokens["".concat((0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).EIP155, ":").concat(id)] = token;
        });
        return caipTokens;
    }
};


var $9395b52ba8ad701f$export$d69f2df2005140cd;
(function(SocialProviderEnum) {
    SocialProviderEnum["Google"] = "google";
    SocialProviderEnum["Github"] = "github";
    SocialProviderEnum["Apple"] = "apple";
    SocialProviderEnum["Facebook"] = "facebook";
    SocialProviderEnum["X"] = "x";
    SocialProviderEnum["Discord"] = "discord";
    SocialProviderEnum["Farcaster"] = "farcaster";
})($9395b52ba8ad701f$export$d69f2df2005140cd || ($9395b52ba8ad701f$export$d69f2df2005140cd = {}));





var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $do9pw = parcelRequire("do9pw");

var $eha6O = parcelRequire("eha6O");
parcelRequire("cwWZ7");
var $dMLJP = parcelRequire("dMLJP");
var $faNff = parcelRequire("faNff");
var $fPqxb = parcelRequire("fPqxb");
var $2qlRb = parcelRequire("2qlRb");
var $3cYIS = parcelRequire("3cYIS");
var $jrvVk = parcelRequire("jrvVk");
var $kOW8v = parcelRequire("kOW8v");
var $khm6W = parcelRequire("khm6W");
var $5Lhe6 = parcelRequire("5Lhe6");
var $dJ6Ea = parcelRequire("dJ6Ea");
var $4HJlA = parcelRequire("4HJlA");
var $8FcCV = parcelRequire("8FcCV");
var $1QDT9 = parcelRequire("1QDT9");
var $iptjJ = parcelRequire("iptjJ");
var $9zDWP = parcelRequire("9zDWP");
var $hZBJb = parcelRequire("hZBJb");
parcelRequire("grHtr");
var $kYNxm = parcelRequire("kYNxm");
parcelRequire("dSKxG");
var $3QZC1 = parcelRequire("3QZC1");
var $01027d2cdef453cb$var$isInitialized = false;



var $01027d2cdef453cb$export$fc94c40ea502fa4c = /*#__PURE__*/ function() {
    "use strict";
    function AppKit(options) {
        (0, $4GJKx._)(this, AppKit);
        this.initPromise = undefined;
        this.setIsConnected = function(isConnected, chain) {
            (0, $dMLJP.AccountController).setIsConnected(isConnected, chain);
        };
        this.getIsConnectedState = function() {
            return (0, $dMLJP.AccountController).state.isConnected;
        };
        this.setAllAccounts = function(addresses, chain) {
            (0, $dMLJP.AccountController).setAllAccounts(addresses, chain);
            (0, $faNff.OptionsController).setHasMultipleAddresses((addresses === null || addresses === void 0 ? void 0 : addresses.length) > 1);
        };
        this.addAddressLabel = function(address, label, chain) {
            (0, $dMLJP.AccountController).addAddressLabel(address, label, chain);
        };
        this.removeAddressLabel = function(address, chain) {
            (0, $dMLJP.AccountController).removeAddressLabel(address, chain);
        };
        this.getCaipAddress = function() {
            return (0, $dMLJP.AccountController).state.caipAddress;
        };
        this.setCaipAddress = function(caipAddress, chain) {
            (0, $dMLJP.AccountController).setCaipAddress(caipAddress, chain);
        };
        this.setBalance = function(balance, balanceSymbol, chain) {
            (0, $dMLJP.AccountController).setBalance(balance, balanceSymbol, chain);
        };
        this.setProfileName = function(profileName, chain) {
            (0, $dMLJP.AccountController).setProfileName(profileName, chain);
        };
        this.setProfileImage = function(profileImage, chain) {
            (0, $dMLJP.AccountController).setProfileImage(profileImage, chain);
        };
        this.resetAccount = function(chain) {
            (0, $dMLJP.AccountController).resetAccount(chain);
        };
        this.setCaipNetwork = function(caipNetwork) {
            (0, $fPqxb.NetworkController).setCaipNetwork(caipNetwork);
        };
        this.getCaipNetwork = function() {
            return (0, $fPqxb.NetworkController).state.caipNetwork;
        };
        this.setRequestedCaipNetworks = function(requestedCaipNetworks, chain) {
            (0, $fPqxb.NetworkController).setRequestedCaipNetworks(requestedCaipNetworks, chain);
        };
        this.getApprovedCaipNetworkIds = function() {
            return (0, $fPqxb.NetworkController).getApprovedCaipNetworkIds();
        };
        this.setApprovedCaipNetworksData = function(chain) {
            return (0, $fPqxb.NetworkController).setApprovedCaipNetworksData(chain);
        };
        this.resetNetwork = function() {
            (0, $fPqxb.NetworkController).resetNetwork();
        };
        this.setConnectors = function(connectors) {
            (0, $2qlRb.ConnectorController).setConnectors(connectors);
        };
        this.addConnector = function(connector) {
            (0, $2qlRb.ConnectorController).addConnector(connector);
        };
        this.getConnectors = function() {
            return (0, $2qlRb.ConnectorController).getConnectors();
        };
        this.resetWcConnection = function() {
            (0, $3cYIS.ConnectionController).resetWcConnection();
        };
        this.fetchIdentity = function(request) {
            return (0, $jrvVk.BlockchainApiController).fetchIdentity(request);
        };
        this.setAddressExplorerUrl = function(addressExplorerUrl, chain) {
            (0, $dMLJP.AccountController).setAddressExplorerUrl(addressExplorerUrl, chain);
        };
        this.setSmartAccountDeployed = function(isDeployed, chain) {
            (0, $dMLJP.AccountController).setSmartAccountDeployed(isDeployed, chain);
        };
        this.setConnectedWalletInfo = function(connectedWalletInfo, chain) {
            (0, $dMLJP.AccountController).setConnectedWalletInfo(connectedWalletInfo, chain);
        };
        this.setSmartAccountEnabledNetworks = function(smartAccountEnabledNetworks, chain) {
            (0, $fPqxb.NetworkController).setSmartAccountEnabledNetworks(smartAccountEnabledNetworks, chain);
        };
        this.setPreferredAccountType = function(preferredAccountType, chain) {
            (0, $dMLJP.AccountController).setPreferredAccountType(preferredAccountType, chain);
        };
        this.getWalletConnectName = function(address) {
            return (0, $kOW8v.EnsController).getNamesForAddress(address);
        };
        this.resolveWalletConnectName = function() {
            var _ref = (0, $kSuI9._)(function(name) {
                var _networkNameAddresses_, trimmedName, wcNameAddress, networkNameAddresses;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            trimmedName = name.replace((0, $3QZC1.ConstantsUtil).WC_NAME_SUFFIX, "");
                            return [
                                4,
                                (0, $kOW8v.EnsController).resolveName(trimmedName)
                            ];
                        case 1:
                            wcNameAddress = _state.sent();
                            networkNameAddresses = Object.values(wcNameAddress === null || wcNameAddress === void 0 ? void 0 : wcNameAddress.addresses) || [];
                            return [
                                2,
                                ((_networkNameAddresses_ = networkNameAddresses[0]) === null || _networkNameAddresses_ === void 0 ? void 0 : _networkNameAddresses_.address) || false
                            ];
                    }
                });
            });
            return function(name) {
                return _ref.apply(this, arguments);
            };
        }();
        this.setEIP6963Enabled = function(enabled) {
            (0, $faNff.OptionsController).setEIP6963Enabled(enabled);
        };
        this.setClientId = function(clientId) {
            (0, $jrvVk.BlockchainApiController).setClientId(clientId);
        };
        this.getConnectorImage = function(connector) {
            return (0, $khm6W.AssetUtil).getConnectorImage(connector);
        };
        this.initControllers(options);
        this.initOrContinue();
    }
    (0, $1wc17._)(AppKit, [
        {
            key: "open",
            value: function open(options) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.initOrContinue()
                                ];
                            case 1:
                                _state.sent();
                                (0, $5Lhe6.ModalController).open(options);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "close",
            value: function close() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.initOrContinue()
                                ];
                            case 1:
                                _state.sent();
                                (0, $5Lhe6.ModalController).close();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setLoading",
            value: function setLoading(loading) {
                (0, $5Lhe6.ModalController).setLoading(loading);
            }
        },
        {
            key: "getThemeMode",
            value: function getThemeMode() {
                return (0, $dJ6Ea.ThemeController).state.themeMode;
            }
        },
        {
            key: "getThemeVariables",
            value: function getThemeVariables() {
                return (0, $dJ6Ea.ThemeController).state.themeVariables;
            }
        },
        {
            key: "setThemeMode",
            value: function setThemeMode(themeMode) {
                (0, $dJ6Ea.ThemeController).setThemeMode(themeMode);
                (0, $kYNxm.setColorTheme)((0, $dJ6Ea.ThemeController).state.themeMode);
            }
        },
        {
            key: "setThemeVariables",
            value: function setThemeVariables1(themeVariables) {
                (0, $dJ6Ea.ThemeController).setThemeVariables(themeVariables);
                (0, $kYNxm.setThemeVariables)((0, $dJ6Ea.ThemeController).state.themeVariables);
            }
        },
        {
            key: "subscribeTheme",
            value: function subscribeTheme(callback) {
                return (0, $dJ6Ea.ThemeController).subscribe(callback);
            }
        },
        {
            key: "getWalletInfo",
            value: function getWalletInfo() {
                return (0, $dMLJP.AccountController).state.connectedWalletInfo;
            }
        },
        {
            key: "subscribeWalletInfo",
            value: function subscribeWalletInfo(callback) {
                return (0, $dMLJP.AccountController).subscribeKey("connectedWalletInfo", callback);
            }
        },
        {
            key: "subscribeShouldUpdateToAddress",
            value: function subscribeShouldUpdateToAddress(callback) {
                (0, $dMLJP.AccountController).subscribeKey("shouldUpdateToAddress", callback);
            }
        },
        {
            key: "subscribeCaipNetworkChange",
            value: function subscribeCaipNetworkChange(callback) {
                (0, $fPqxb.NetworkController).subscribeKey("caipNetwork", callback);
            }
        },
        {
            key: "getState",
            value: function getState() {
                return (0, $4HJlA.PublicStateController).state;
            }
        },
        {
            key: "subscribeState",
            value: function subscribeState(callback) {
                return (0, $4HJlA.PublicStateController).subscribe(callback);
            }
        },
        {
            key: "showErrorMessage",
            value: function showErrorMessage(message) {
                (0, $8FcCV.SnackController).showError(message);
            }
        },
        {
            key: "showSuccessMessage",
            value: function showSuccessMessage(message) {
                (0, $8FcCV.SnackController).showSuccess(message);
            }
        },
        {
            key: "getEvent",
            value: function getEvent() {
                return (0, $do9pw._)({}, (0, $1QDT9.EventsController).state);
            }
        },
        {
            key: "subscribeEvents",
            value: function subscribeEvents(callback) {
                return (0, $1QDT9.EventsController).subscribe(callback);
            }
        },
        {
            key: "replace",
            value: function replace(route) {
                (0, $iptjJ.RouterController).replace(route);
            }
        },
        {
            key: "redirect",
            value: function redirect(route) {
                (0, $iptjJ.RouterController).push(route);
            }
        },
        {
            key: "popTransactionStack",
            value: function popTransactionStack(cancel) {
                (0, $iptjJ.RouterController).popTransactionStack(cancel);
            }
        },
        {
            key: "isOpen",
            value: function isOpen() {
                return (0, $5Lhe6.ModalController).state.open;
            }
        },
        {
            key: "isTransactionStackEmpty",
            value: function isTransactionStackEmpty() {
                return (0, $iptjJ.RouterController).state.transactionStack.length === 0;
            }
        },
        {
            key: "isTransactionShouldReplaceView",
            value: function isTransactionShouldReplaceView() {
                var _RouterController_state_transactionStack_;
                return (_RouterController_state_transactionStack_ = (0, $iptjJ.RouterController).state.transactionStack[(0, $iptjJ.RouterController).state.transactionStack.length - 1]) === null || _RouterController_state_transactionStack_ === void 0 ? void 0 : _RouterController_state_transactionStack_.replace;
            }
        },
        {
            key: "initControllers",
            value: function initControllers(options) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _options_adapters, _options_adapters1, evmAdapter, SIWEController;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $faNff.OptionsController).setProjectId(options.projectId);
                                (0, $faNff.OptionsController).setSdkVersion(options.sdkVersion);
                                (0, $9zDWP.ChainController).initialize(options.adapters || []);
                                (_options_adapters = options.adapters) === null || _options_adapters === void 0 ? void 0 : _options_adapters.forEach(function(adapter) {
                                    var _adapter_construct;
                                    (_adapter_construct = adapter.construct) === null || _adapter_construct === void 0 ? void 0 : _adapter_construct.call(adapter, _this, options);
                                    (0, $fPqxb.NetworkController).setAllowUnsupportedChain(options.allowUnsupportedChain, adapter.chain);
                                    (0, $fPqxb.NetworkController).setDefaultCaipNetwork(options.defaultChain);
                                });
                                (0, $faNff.OptionsController).setAllWallets(options.allWallets);
                                (0, $faNff.OptionsController).setIncludeWalletIds(options.includeWalletIds);
                                (0, $faNff.OptionsController).setExcludeWalletIds(options.excludeWalletIds);
                                (0, $faNff.OptionsController).setFeaturedWalletIds(options.featuredWalletIds);
                                (0, $faNff.OptionsController).setTokens(options.tokens);
                                (0, $faNff.OptionsController).setTermsConditionsUrl(options.termsConditionsUrl);
                                (0, $faNff.OptionsController).setPrivacyPolicyUrl(options.privacyPolicyUrl);
                                (0, $faNff.OptionsController).setCustomWallets(options.customWallets);
                                (0, $faNff.OptionsController).setEnableAnalytics(options.enableAnalytics);
                                (0, $faNff.OptionsController).setOnrampEnabled(options.enableOnramp !== false);
                                (0, $faNff.OptionsController).setEnableSwaps(options.enableSwaps !== false);
                                if (options.metadata) (0, $faNff.OptionsController).setMetadata(options.metadata);
                                if (options.themeMode) (0, $dJ6Ea.ThemeController).setThemeMode(options.themeMode);
                                if (options.themeVariables) (0, $dJ6Ea.ThemeController).setThemeVariables(options.themeVariables);
                                if (options.disableAppend) (0, $faNff.OptionsController).setDisableAppend(Boolean(options.disableAppend));
                                evmAdapter = (_options_adapters1 = options.adapters) === null || _options_adapters1 === void 0 ? void 0 : _options_adapters1.find(function(adapter) {
                                    return adapter.chain === (0, $3QZC1.ConstantsUtil).CHAIN.EVM;
                                });
                                if (!evmAdapter) return [
                                    3,
                                    2
                                ];
                                if (!options.siweConfig) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (parcelRequire("jCIHD"))
                                ];
                            case 1:
                                SIWEController = _state.sent().SIWEController;
                                SIWEController.setSIWEClient(options.siweConfig);
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "initOrContinue",
            value: function initOrContinue() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        if (!_this.initPromise && !$01027d2cdef453cb$var$isInitialized && (0, $hZBJb.CoreHelperUtil).isClient()) {
                            $01027d2cdef453cb$var$isInitialized = true;
                            _this.initPromise = new Promise(function() {
                                var _ref = (0, $kSuI9._)(function(resolve) {
                                    var modal;
                                    return (0, $eha6O.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    Promise.all([
                                                        Promise.resolve((parcelRequire("grHtr"))),
                                                        (parcelRequire("gtcRQ"))
                                                    ])
                                                ];
                                            case 1:
                                                _state.sent();
                                                modal = document.createElement("w3m-modal");
                                                if (!(0, $faNff.OptionsController).state.disableAppend) document.body.insertAdjacentElement("beforeend", modal);
                                                resolve();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(resolve) {
                                    return _ref.apply(this, arguments);
                                };
                            }());
                        }
                        return [
                            2,
                            _this.initPromise
                        ];
                    });
                })();
            }
        }
    ], [
        {
            key: "getInstance",
            value: function getInstance() {
                return this.instance;
            }
        }
    ]);
    return AppKit;
}();



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $dMLJP = parcelRequire("dMLJP");
var $fPqxb = parcelRequire("fPqxb");
var $khm6W = parcelRequire("khm6W");
var $hZBJb = parcelRequire("hZBJb");
var $5Lhe6 = parcelRequire("5Lhe6");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $04kNM = parcelRequire("04kNM");
var $334Pv = parcelRequire("334Pv");

var $hxyOZ = parcelRequire("hxyOZ");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $696d14fc702af3d6$export$f68dd208b5df064d = function(t) {
    return t !== null && t !== void 0 ? t : (0, $hxyOZ.nothing);
};




function $b938b22fc530788b$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      <wui-account-button\n        .disabled=",
        "\n        .isUnsupportedChain=",
        "\n        address=",
        "\n        profileName=",
        "\n        networkSrc=",
        "\n        avatarSrc=",
        "\n        balance=",
        "\n        @click=",
        '\n        data-testid="account-button"\n        .charsStart=',
        "\n        .charsEnd=",
        "\n      >\n      </wui-account-button>\n    "
    ]);
    $b938b22fc530788b$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $b938b22fc530788b$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $b938b22fc530788b$export$f039a2838669d98e = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mAccountButton, LitElement);
    var _super = (0, $ohfOJ._)(W3mAccountButton);
    function W3mAccountButton() {
        var _this_unsubscribe;
        (0, $4GJKx._)(this, W3mAccountButton);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.disabled = false;
        _this.balance = "show";
        _this.charsStart = 4;
        _this.charsEnd = 6;
        _this.address = (0, $dMLJP.AccountController).state.address;
        _this.balanceVal = (0, $dMLJP.AccountController).state.balance;
        _this.balanceSymbol = (0, $dMLJP.AccountController).state.balanceSymbol;
        _this.profileName = (0, $dMLJP.AccountController).state.profileName;
        _this.profileImage = (0, $dMLJP.AccountController).state.profileImage;
        _this.network = (0, $fPqxb.NetworkController).state.caipNetwork;
        _this.isUnsupportedChain = (0, $fPqxb.NetworkController).state.isUnsupportedChain;
        (_this_unsubscribe = _this.unsubscribe).push.apply(_this_unsubscribe, [
            (0, $dMLJP.AccountController).subscribe(function(val) {
                if (val.isConnected) {
                    _this.address = val.address;
                    _this.balanceVal = val.balance;
                    _this.profileName = val.profileName;
                    _this.profileImage = val.profileImage;
                    _this.balanceSymbol = val.balanceSymbol;
                } else {
                    _this.address = "";
                    _this.balanceVal = "";
                    _this.profileName = "";
                    _this.profileImage = "";
                    _this.balanceSymbol = "";
                }
            }),
            (0, $fPqxb.NetworkController).subscribeKey("caipNetwork", function(val) {
                _this.network = val;
            }),
            (0, $fPqxb.NetworkController).subscribeKey("isUnsupportedChain", function(val) {
                _this.isUnsupportedChain = val;
            })
        ]);
        return _this;
    }
    (0, $1wc17._)(W3mAccountButton, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var networkImage = (0, $khm6W.AssetUtil).getNetworkImage(this.network);
                var showBalance = this.balance === "show";
                return (0, $hxyOZ.html)($b938b22fc530788b$var$_templateObject(), Boolean(this.disabled), this.isUnsupportedChain, (0, $696d14fc702af3d6$export$f68dd208b5df064d)(this.address), (0, $696d14fc702af3d6$export$f68dd208b5df064d)(this.profileName), (0, $696d14fc702af3d6$export$f68dd208b5df064d)(networkImage), (0, $696d14fc702af3d6$export$f68dd208b5df064d)(this.profileImage), showBalance ? (0, $hZBJb.CoreHelperUtil).formatBalance(this.balanceVal, this.balanceSymbol) : "", this.onClick.bind(this), this.charsStart, this.charsEnd);
            }
        },
        {
            key: "onClick",
            value: function onClick() {
                if (this.isUnsupportedChain) (0, $5Lhe6.ModalController).open({
                    view: "UnsupportedChain"
                });
                else (0, $5Lhe6.ModalController).open();
            }
        }
    ]);
    return W3mAccountButton;
}((0, $2yD3e.LitElement));
$b938b22fc530788b$var$__decorate([
    (0, $04kNM.property)({
        type: Boolean
    })
], $b938b22fc530788b$export$f039a2838669d98e.prototype, "disabled", void 0);
$b938b22fc530788b$var$__decorate([
    (0, $04kNM.property)()
], $b938b22fc530788b$export$f039a2838669d98e.prototype, "balance", void 0);
$b938b22fc530788b$var$__decorate([
    (0, $04kNM.property)()
], $b938b22fc530788b$export$f039a2838669d98e.prototype, "charsStart", void 0);
$b938b22fc530788b$var$__decorate([
    (0, $04kNM.property)()
], $b938b22fc530788b$export$f039a2838669d98e.prototype, "charsEnd", void 0);
$b938b22fc530788b$var$__decorate([
    (0, $334Pv.state)()
], $b938b22fc530788b$export$f039a2838669d98e.prototype, "address", void 0);
$b938b22fc530788b$var$__decorate([
    (0, $334Pv.state)()
], $b938b22fc530788b$export$f039a2838669d98e.prototype, "balanceVal", void 0);
$b938b22fc530788b$var$__decorate([
    (0, $334Pv.state)()
], $b938b22fc530788b$export$f039a2838669d98e.prototype, "balanceSymbol", void 0);
$b938b22fc530788b$var$__decorate([
    (0, $334Pv.state)()
], $b938b22fc530788b$export$f039a2838669d98e.prototype, "profileName", void 0);
$b938b22fc530788b$var$__decorate([
    (0, $334Pv.state)()
], $b938b22fc530788b$export$f039a2838669d98e.prototype, "profileImage", void 0);
$b938b22fc530788b$var$__decorate([
    (0, $334Pv.state)()
], $b938b22fc530788b$export$f039a2838669d98e.prototype, "network", void 0);
$b938b22fc530788b$var$__decorate([
    (0, $334Pv.state)()
], $b938b22fc530788b$export$f039a2838669d98e.prototype, "isUnsupportedChain", void 0);
$b938b22fc530788b$export$f039a2838669d98e = $b938b22fc530788b$var$__decorate([
    (0, $hdxb6.customElement)("w3m-account-button")
], $b938b22fc530788b$export$f039a2838669d98e);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $dMLJP = parcelRequire("dMLJP");
var $5Lhe6 = parcelRequire("5Lhe6");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $04kNM = parcelRequire("04kNM");
var $334Pv = parcelRequire("334Pv");


var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $2f50f729f87a7176$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: block;\n    width: max-content;\n  }\n"
    ]);
    $2f50f729f87a7176$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $2f50f729f87a7176$export$2e2bcd8739ae039 = (0, $2D5eP.css)($2f50f729f87a7176$var$_templateObject());


function $f0530612dafb8587$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n          <w3m-account-button\n            .disabled=",
        "\n            balance=",
        "\n            .charsStart=",
        "\n            .charsEnd=",
        "\n          >\n          </w3m-account-button>\n        "
    ]);
    $f0530612dafb8587$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $f0530612dafb8587$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "\n          <w3m-connect-button\n            size=",
        "\n            label=",
        "\n            loadingLabel=",
        "\n          ></w3m-connect-button>\n        "
    ]);
    $f0530612dafb8587$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $f0530612dafb8587$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f0530612dafb8587$export$857f19a8cabe3497 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mButton, LitElement);
    var _super = (0, $ohfOJ._)(W3mButton);
    function W3mButton() {
        (0, $4GJKx._)(this, W3mButton);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.unsubscribe = [];
        _this.disabled = false;
        _this.balance = undefined;
        _this.size = undefined;
        _this.label = undefined;
        _this.loadingLabel = undefined;
        _this.charsStart = 4;
        _this.charsEnd = 6;
        _this.isAccount = (0, $dMLJP.AccountController).state.isConnected;
        _this.isLoading = (0, $5Lhe6.ModalController).state.loading;
        return _this;
    }
    (0, $1wc17._)(W3mButton, [
        {
            key: "firstUpdated",
            value: function firstUpdated() {
                var _this = this;
                this.unsubscribe.push((0, $dMLJP.AccountController).subscribe(function(val) {
                    _this.isAccount = val.isConnected;
                }), (0, $5Lhe6.ModalController).subscribeKey("loading", function(val) {
                    _this.isLoading = val;
                }));
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return this.isAccount && !this.isLoading ? (0, $hxyOZ.html)($f0530612dafb8587$var$_templateObject(), Boolean(this.disabled), (0, $696d14fc702af3d6$export$f68dd208b5df064d)(this.balance), (0, $696d14fc702af3d6$export$f68dd208b5df064d)(this.charsStart), (0, $696d14fc702af3d6$export$f68dd208b5df064d)(this.charsEnd)) : (0, $hxyOZ.html)($f0530612dafb8587$var$_templateObject1(), (0, $696d14fc702af3d6$export$f68dd208b5df064d)(this.size), (0, $696d14fc702af3d6$export$f68dd208b5df064d)(this.label), (0, $696d14fc702af3d6$export$f68dd208b5df064d)(this.loadingLabel));
            }
        }
    ]);
    return W3mButton;
}((0, $2yD3e.LitElement));
$f0530612dafb8587$export$857f19a8cabe3497.styles = (0, $2f50f729f87a7176$export$2e2bcd8739ae039);
$f0530612dafb8587$var$__decorate([
    (0, $04kNM.property)({
        type: Boolean
    })
], $f0530612dafb8587$export$857f19a8cabe3497.prototype, "disabled", void 0);
$f0530612dafb8587$var$__decorate([
    (0, $04kNM.property)()
], $f0530612dafb8587$export$857f19a8cabe3497.prototype, "balance", void 0);
$f0530612dafb8587$var$__decorate([
    (0, $04kNM.property)()
], $f0530612dafb8587$export$857f19a8cabe3497.prototype, "size", void 0);
$f0530612dafb8587$var$__decorate([
    (0, $04kNM.property)()
], $f0530612dafb8587$export$857f19a8cabe3497.prototype, "label", void 0);
$f0530612dafb8587$var$__decorate([
    (0, $04kNM.property)()
], $f0530612dafb8587$export$857f19a8cabe3497.prototype, "loadingLabel", void 0);
$f0530612dafb8587$var$__decorate([
    (0, $04kNM.property)()
], $f0530612dafb8587$export$857f19a8cabe3497.prototype, "charsStart", void 0);
$f0530612dafb8587$var$__decorate([
    (0, $04kNM.property)()
], $f0530612dafb8587$export$857f19a8cabe3497.prototype, "charsEnd", void 0);
$f0530612dafb8587$var$__decorate([
    (0, $334Pv.state)()
], $f0530612dafb8587$export$857f19a8cabe3497.prototype, "isAccount", void 0);
$f0530612dafb8587$var$__decorate([
    (0, $334Pv.state)()
], $f0530612dafb8587$export$857f19a8cabe3497.prototype, "isLoading", void 0);
$f0530612dafb8587$export$857f19a8cabe3497 = $f0530612dafb8587$var$__decorate([
    (0, $hdxb6.customElement)("w3m-button")
], $f0530612dafb8587$export$857f19a8cabe3497);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $5Lhe6 = parcelRequire("5Lhe6");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $04kNM = parcelRequire("04kNM");
var $334Pv = parcelRequire("334Pv");

function $c57d27414a0e1760$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      <wui-connect-button\n        size=",
        "\n        .loading=",
        "\n        @click=",
        '\n        data-testid="connect-button"\n      >\n        ',
        "\n      </wui-connect-button>\n    "
    ]);
    $c57d27414a0e1760$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $c57d27414a0e1760$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c57d27414a0e1760$export$277240c185e0322e = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mConnectButton, LitElement);
    var _super = (0, $ohfOJ._)(W3mConnectButton);
    function W3mConnectButton() {
        (0, $4GJKx._)(this, W3mConnectButton);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.size = "md";
        _this.label = "Connect Wallet";
        _this.loadingLabel = "Connecting...";
        _this.open = (0, $5Lhe6.ModalController).state.open;
        _this.loading = (0, $5Lhe6.ModalController).state.loading;
        _this.unsubscribe.push((0, $5Lhe6.ModalController).subscribe(function(val) {
            _this.open = val.open;
            _this.loading = val.loading;
        }));
        return _this;
    }
    (0, $1wc17._)(W3mConnectButton, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var isLoading = this.loading || this.open;
                return (0, $hxyOZ.html)($c57d27414a0e1760$var$_templateObject(), (0, $696d14fc702af3d6$export$f68dd208b5df064d)(this.size), isLoading, this.onClick.bind(this), isLoading ? this.loadingLabel : this.label);
            }
        },
        {
            key: "onClick",
            value: function onClick() {
                if (this.open) (0, $5Lhe6.ModalController).close();
                else if (!this.loading) (0, $5Lhe6.ModalController).open();
            }
        }
    ]);
    return W3mConnectButton;
}((0, $2yD3e.LitElement));
$c57d27414a0e1760$var$__decorate([
    (0, $04kNM.property)()
], $c57d27414a0e1760$export$277240c185e0322e.prototype, "size", void 0);
$c57d27414a0e1760$var$__decorate([
    (0, $04kNM.property)()
], $c57d27414a0e1760$export$277240c185e0322e.prototype, "label", void 0);
$c57d27414a0e1760$var$__decorate([
    (0, $04kNM.property)()
], $c57d27414a0e1760$export$277240c185e0322e.prototype, "loadingLabel", void 0);
$c57d27414a0e1760$var$__decorate([
    (0, $334Pv.state)()
], $c57d27414a0e1760$export$277240c185e0322e.prototype, "open", void 0);
$c57d27414a0e1760$var$__decorate([
    (0, $334Pv.state)()
], $c57d27414a0e1760$export$277240c185e0322e.prototype, "loading", void 0);
$c57d27414a0e1760$export$277240c185e0322e = $c57d27414a0e1760$var$__decorate([
    (0, $hdxb6.customElement)("w3m-connect-button")
], $c57d27414a0e1760$export$277240c185e0322e);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $fPqxb = parcelRequire("fPqxb");
var $dMLJP = parcelRequire("dMLJP");
var $5Lhe6 = parcelRequire("5Lhe6");
var $khm6W = parcelRequire("khm6W");
var $1QDT9 = parcelRequire("1QDT9");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $04kNM = parcelRequire("04kNM");
var $334Pv = parcelRequire("334Pv");


var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $2e0acf55bd7da6fa$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: block;\n    width: max-content;\n  }\n"
    ]);
    $2e0acf55bd7da6fa$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $2e0acf55bd7da6fa$export$2e2bcd8739ae039 = (0, $2D5eP.css)($2e0acf55bd7da6fa$var$_templateObject());


function $a6b82d85511aa547$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-network-button\n        data-testid="wui-network-button"\n        .disabled=',
        "\n        .isUnsupportedChain=",
        "\n        imageSrc=",
        "\n        @click=",
        "\n      >\n        ",
        "\n        <slot></slot>\n      </wui-network-button>\n    "
    ]);
    $a6b82d85511aa547$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $a6b82d85511aa547$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a6b82d85511aa547$export$28375bf34267491c = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mNetworkButton, LitElement);
    var _super = (0, $ohfOJ._)(W3mNetworkButton);
    function W3mNetworkButton() {
        (0, $4GJKx._)(this, W3mNetworkButton);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.unsubscribe = [];
        _this.disabled = false;
        _this.network = (0, $fPqxb.NetworkController).state.caipNetwork;
        _this.connected = (0, $dMLJP.AccountController).state.isConnected;
        _this.loading = (0, $5Lhe6.ModalController).state.loading;
        _this.isUnsupportedChain = (0, $fPqxb.NetworkController).state.isUnsupportedChain;
        return _this;
    }
    (0, $1wc17._)(W3mNetworkButton, [
        {
            key: "firstUpdated",
            value: function firstUpdated() {
                var _this = this;
                var _this_unsubscribe;
                (_this_unsubscribe = this.unsubscribe).push.apply(_this_unsubscribe, [
                    (0, $fPqxb.NetworkController).subscribeKey("caipNetwork", function(val) {
                        return _this.network = val;
                    }),
                    (0, $dMLJP.AccountController).subscribeKey("isConnected", function(val) {
                        return _this.connected = val;
                    }),
                    (0, $5Lhe6.ModalController).subscribeKey("loading", function(val) {
                        return _this.loading = val;
                    }),
                    (0, $fPqxb.NetworkController).subscribeKey("isUnsupportedChain", function(val) {
                        return _this.isUnsupportedChain = val;
                    })
                ]);
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($a6b82d85511aa547$var$_templateObject(), Boolean(this.disabled || this.loading), this.isUnsupportedChain, (0, $696d14fc702af3d6$export$f68dd208b5df064d)((0, $khm6W.AssetUtil).getNetworkImage(this.network)), this.onClick.bind(this), this.getLabel());
            }
        },
        {
            key: "getLabel",
            value: function getLabel() {
                if (this.label) return this.label;
                if (this.isUnsupportedChain) return "Switch Network";
                if (this.network) return this.network.name;
                if (this.connected) return "Unknown Network";
                return "Select Network";
            }
        },
        {
            key: "onClick",
            value: function onClick() {
                if (!this.loading) {
                    (0, $1QDT9.EventsController).sendEvent({
                        type: "track",
                        event: "CLICK_NETWORKS"
                    });
                    (0, $5Lhe6.ModalController).open({
                        view: "Networks"
                    });
                }
            }
        }
    ]);
    return W3mNetworkButton;
}((0, $2yD3e.LitElement));
$a6b82d85511aa547$export$28375bf34267491c.styles = (0, $2e0acf55bd7da6fa$export$2e2bcd8739ae039);
$a6b82d85511aa547$var$__decorate([
    (0, $04kNM.property)({
        type: Boolean
    })
], $a6b82d85511aa547$export$28375bf34267491c.prototype, "disabled", void 0);
$a6b82d85511aa547$var$__decorate([
    (0, $04kNM.property)({
        type: String
    })
], $a6b82d85511aa547$export$28375bf34267491c.prototype, "label", void 0);
$a6b82d85511aa547$var$__decorate([
    (0, $334Pv.state)()
], $a6b82d85511aa547$export$28375bf34267491c.prototype, "network", void 0);
$a6b82d85511aa547$var$__decorate([
    (0, $334Pv.state)()
], $a6b82d85511aa547$export$28375bf34267491c.prototype, "connected", void 0);
$a6b82d85511aa547$var$__decorate([
    (0, $334Pv.state)()
], $a6b82d85511aa547$export$28375bf34267491c.prototype, "loading", void 0);
$a6b82d85511aa547$var$__decorate([
    (0, $334Pv.state)()
], $a6b82d85511aa547$export$28375bf34267491c.prototype, "isUnsupportedChain", void 0);
$a6b82d85511aa547$export$28375bf34267491c = $a6b82d85511aa547$var$__decorate([
    (0, $hdxb6.customElement)("w3m-network-button")
], $a6b82d85511aa547$export$28375bf34267491c);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $cv9Rk = parcelRequire("cv9Rk");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $iptjJ = parcelRequire("iptjJ");
var $5R7lI = parcelRequire("5R7lI");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $d0c413183cbe659c$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    --prev-height: 0px;\n    --new-height: 0px;\n    display: block;\n  }\n\n  div.w3m-router-container {\n    transform: translateY(0);\n    opacity: 1;\n  }\n\n  div.w3m-router-container[view-direction='prev'] {\n    animation:\n      slide-left-out 150ms forwards ease,\n      slide-left-in 150ms forwards ease;\n    animation-delay: 0ms, 200ms;\n  }\n\n  div.w3m-router-container[view-direction='next'] {\n    animation:\n      slide-right-out 150ms forwards ease,\n      slide-right-in 150ms forwards ease;\n    animation-delay: 0ms, 200ms;\n  }\n\n  @keyframes slide-left-out {\n    from {\n      transform: translateX(0px);\n      opacity: 1;\n    }\n    to {\n      transform: translateX(10px);\n      opacity: 0;\n    }\n  }\n\n  @keyframes slide-left-in {\n    from {\n      transform: translateX(-10px);\n      opacity: 0;\n    }\n    to {\n      transform: translateX(0);\n      opacity: 1;\n    }\n  }\n\n  @keyframes slide-right-out {\n    from {\n      transform: translateX(0px);\n      opacity: 1;\n    }\n    to {\n      transform: translateX(-10px);\n      opacity: 0;\n    }\n  }\n\n  @keyframes slide-right-in {\n    from {\n      transform: translateX(10px);\n      opacity: 0;\n    }\n    to {\n      transform: translateX(0);\n      opacity: 1;\n    }\n  }\n"
    ]);
    $d0c413183cbe659c$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $d0c413183cbe659c$export$2e2bcd8739ae039 = (0, $2D5eP.css)($d0c413183cbe659c$var$_templateObject());


var $560364d27174f3fd$export$aafe1f751f1bc52a = {
    ACCOUNT_TABS: [
        {
            label: "Tokens"
        },
        {
            label: "NFTs"
        },
        {
            label: "Activity"
        }
    ],
    SECURE_SITE_ORIGIN: "https://secure.walletconnect.org",
    VIEW_DIRECTION: {
        Next: "next",
        Prev: "prev"
    },
    ANIMATION_DURATIONS: {
        HeaderText: 120,
        ModalHeight: 150,
        ViewTransition: 150
    }
};


function $6fbf4ed9a4c90bb2$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<div class="w3m-router-container" view-direction="',
        '">\n      ',
        "\n    </div>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "<w3m-account-settings-view></w3m-account-settings-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "<w3m-account-view></w3m-account-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject3() {
    var data = (0, $j06k0._)([
        "<w3m-all-wallets-view></w3m-all-wallets-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject4() {
    var data = (0, $j06k0._)([
        "<w3m-approve-transaction-view></w3m-approve-transaction-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject5() {
    var data = (0, $j06k0._)([
        "<w3m-buy-in-progress-view></w3m-buy-in-progress-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject6() {
    var data = (0, $j06k0._)([
        "<w3m-choose-account-name-view></w3m-choose-account-name-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject7() {
    var data = (0, $j06k0._)([
        "<w3m-connect-view></w3m-connect-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject8() {
    var data = (0, $j06k0._)([
        "<w3m-connecting-wc-view></w3m-connecting-wc-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject9() {
    var data = (0, $j06k0._)([
        "<w3m-connecting-external-view></w3m-connecting-external-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject10() {
    var data = (0, $j06k0._)([
        "<w3m-connecting-siwe-view></w3m-connecting-siwe-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject11() {
    var data = (0, $j06k0._)([
        "<w3m-connect-wallets-view></w3m-connect-wallets-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject12() {
    var data = (0, $j06k0._)([
        "<w3m-connect-socials-view></w3m-connect-socials-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject13() {
    var data = (0, $j06k0._)([
        "<w3m-connecting-social-view></w3m-connecting-social-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject14() {
    var data = (0, $j06k0._)([
        "<w3m-downloads-view></w3m-downloads-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject15() {
    var data = (0, $j06k0._)([
        "<w3m-email-verify-otp-view></w3m-email-verify-otp-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject16() {
    var data = (0, $j06k0._)([
        "<w3m-email-verify-device-view></w3m-email-verify-device-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject17() {
    var data = (0, $j06k0._)([
        "<w3m-get-wallet-view></w3m-get-wallet-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject18() {
    var data = (0, $j06k0._)([
        "<w3m-networks-view></w3m-networks-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject19() {
    var data = (0, $j06k0._)([
        "<w3m-network-switch-view></w3m-network-switch-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject20() {
    var data = (0, $j06k0._)([
        "<w3m-profile-view></w3m-profile-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject21() {
    var data = (0, $j06k0._)([
        "<w3m-select-addresses-view></w3m-select-addresses-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject22() {
    var data = (0, $j06k0._)([
        "<w3m-switch-address-view></w3m-switch-address-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject23() {
    var data = (0, $j06k0._)([
        "<w3m-transactions-view></w3m-transactions-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject24() {
    var data = (0, $j06k0._)([
        "<w3m-onramp-providers-view></w3m-onramp-providers-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject25() {
    var data = (0, $j06k0._)([
        "<w3m-onramp-activity-view></w3m-onramp-activity-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject26() {
    var data = (0, $j06k0._)([
        "<w3m-onramp-token-select-view></w3m-onramp-token-select-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject26 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject27() {
    var data = (0, $j06k0._)([
        "<w3m-onramp-fiat-select-view></w3m-onramp-fiat-select-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject27 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject28() {
    var data = (0, $j06k0._)([
        "<w3m-upgrade-wallet-view></w3m-upgrade-wallet-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject28 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject29() {
    var data = (0, $j06k0._)([
        "<w3m-upgrade-to-smart-account-view></w3m-upgrade-to-smart-account-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject29 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject30() {
    var data = (0, $j06k0._)([
        "<w3m-update-email-wallet-view></w3m-update-email-wallet-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject30 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject31() {
    var data = (0, $j06k0._)([
        "<w3m-update-email-primary-otp-view></w3m-update-email-primary-otp-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject31 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject32() {
    var data = (0, $j06k0._)([
        "<w3m-update-email-secondary-otp-view></w3m-update-email-secondary-otp-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject32 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject33() {
    var data = (0, $j06k0._)([
        "<w3m-unsupported-chain-view></w3m-unsupported-chain-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject33 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject34() {
    var data = (0, $j06k0._)([
        "<w3m-swap-view></w3m-swap-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject34 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject35() {
    var data = (0, $j06k0._)([
        "<w3m-swap-select-token-view></w3m-swap-select-token-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject35 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject36() {
    var data = (0, $j06k0._)([
        "<w3m-swap-preview-view></w3m-swap-preview-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject36 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject37() {
    var data = (0, $j06k0._)([
        "<w3m-wallet-send-view></w3m-wallet-send-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject37 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject38() {
    var data = (0, $j06k0._)([
        "<w3m-wallet-send-select-token-view></w3m-wallet-send-select-token-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject38 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject39() {
    var data = (0, $j06k0._)([
        "<w3m-wallet-send-preview-view></w3m-wallet-send-preview-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject39 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject40() {
    var data = (0, $j06k0._)([
        "<w3m-what-is-a-buy-view></w3m-what-is-a-buy-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject40 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject41() {
    var data = (0, $j06k0._)([
        "<w3m-wallet-receive-view></w3m-wallet-receive-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject41 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject42() {
    var data = (0, $j06k0._)([
        "<w3m-wallet-compatible-networks-view></w3m-wallet-compatible-networks-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject42 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject43() {
    var data = (0, $j06k0._)([
        "<w3m-what-is-a-wallet-view></w3m-what-is-a-wallet-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject43 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject44() {
    var data = (0, $j06k0._)([
        "<w3m-connecting-multi-chain-view></w3m-connecting-multi-chain-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject44 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject45() {
    var data = (0, $j06k0._)([
        "<w3m-what-is-a-network-view></w3m-what-is-a-network-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject45 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject46() {
    var data = (0, $j06k0._)([
        "<w3m-connecting-farcaster-view></w3m-connecting-farcaster-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject46 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject47() {
    var data = (0, $j06k0._)([
        "<w3m-switch-active-chain-view></w3m-switch-active-chain-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject47 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject48() {
    var data = (0, $j06k0._)([
        "<w3m-register-account-name-view></w3m-register-account-name-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject48 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject49() {
    var data = (0, $j06k0._)([
        "<w3m-register-account-name-success-view></w3m-register-account-name-success-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject49 = function _templateObject() {
        return data;
    };
    return data;
}
function $6fbf4ed9a4c90bb2$var$_templateObject50() {
    var data = (0, $j06k0._)([
        "<w3m-connect-view></w3m-connect-view>"
    ]);
    $6fbf4ed9a4c90bb2$var$_templateObject50 = function _templateObject() {
        return data;
    };
    return data;
}
var $6fbf4ed9a4c90bb2$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $6fbf4ed9a4c90bb2$export$ccc15c9e32141a55 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mRouter, LitElement);
    var _super = (0, $ohfOJ._)(W3mRouter);
    function W3mRouter() {
        (0, $4GJKx._)(this, W3mRouter);
        var _this;
        _this = _super.call(this);
        _this.resizeObserver = undefined;
        _this.prevHeight = "0px";
        _this.prevHistoryLength = 1;
        _this.unsubscribe = [];
        _this.view = (0, $iptjJ.RouterController).state.view;
        _this.viewDirection = "";
        _this.unsubscribe.push((0, $iptjJ.RouterController).subscribeKey("view", function(val) {
            return _this.onViewChange(val);
        }));
        return _this;
    }
    (0, $1wc17._)(W3mRouter, [
        {
            key: "firstUpdated",
            value: function firstUpdated() {
                var _this = this;
                this.resizeObserver = new ResizeObserver(function(param) {
                    var _param = (0, $cv9Rk._)(param, 1), content = _param[0];
                    var height = "".concat(content === null || content === void 0 ? void 0 : content.contentRect.height, "px");
                    if (_this.prevHeight !== "0px") {
                        _this.style.setProperty("--prev-height", _this.prevHeight);
                        _this.style.setProperty("--new-height", height);
                        _this.style.animation = "w3m-view-height 150ms forwards ease";
                        _this.style.height = "auto";
                    }
                    setTimeout(function() {
                        _this.prevHeight = height;
                        _this.style.animation = "unset";
                    }, (0, $560364d27174f3fd$export$aafe1f751f1bc52a).ANIMATION_DURATIONS.ModalHeight);
                });
                this.resizeObserver.observe(this.getWrapper());
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                var _this_resizeObserver;
                (_this_resizeObserver = this.resizeObserver) === null || _this_resizeObserver === void 0 ? void 0 : _this_resizeObserver.unobserve(this.getWrapper());
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject(), this.viewDirection, this.viewTemplate());
            }
        },
        {
            key: "viewTemplate",
            value: function viewTemplate() {
                switch(this.view){
                    case "AccountSettings":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject1());
                    case "Account":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject2());
                    case "AllWallets":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject3());
                    case "ApproveTransaction":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject4());
                    case "BuyInProgress":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject5());
                    case "ChooseAccountName":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject6());
                    case "Connect":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject7());
                    case "ConnectingWalletConnect":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject8());
                    case "ConnectingExternal":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject9());
                    case "ConnectingSiwe":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject10());
                    case "ConnectWallets":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject11());
                    case "ConnectSocials":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject12());
                    case "ConnectingSocial":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject13());
                    case "Downloads":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject14());
                    case "EmailVerifyOtp":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject15());
                    case "EmailVerifyDevice":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject16());
                    case "GetWallet":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject17());
                    case "Networks":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject18());
                    case "SwitchNetwork":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject19());
                    case "Profile":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject20());
                    case "SelectAddresses":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject21());
                    case "SwitchAddress":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject22());
                    case "Transactions":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject23());
                    case "OnRampProviders":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject24());
                    case "OnRampActivity":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject25());
                    case "OnRampTokenSelect":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject26());
                    case "OnRampFiatSelect":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject27());
                    case "UpgradeEmailWallet":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject28());
                    case "UpgradeToSmartAccount":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject29());
                    case "UpdateEmailWallet":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject30());
                    case "UpdateEmailPrimaryOtp":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject31());
                    case "UpdateEmailSecondaryOtp":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject32());
                    case "UnsupportedChain":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject33());
                    case "Swap":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject34());
                    case "SwapSelectToken":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject35());
                    case "SwapPreview":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject36());
                    case "WalletSend":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject37());
                    case "WalletSendSelectToken":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject38());
                    case "WalletSendPreview":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject39());
                    case "WhatIsABuy":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject40());
                    case "WalletReceive":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject41());
                    case "WalletCompatibleNetworks":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject42());
                    case "WhatIsAWallet":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject43());
                    case "ConnectingMultiChain":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject44());
                    case "WhatIsANetwork":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject45());
                    case "ConnectingFarcaster":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject46());
                    case "SwitchActiveChain":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject47());
                    case "RegisterAccountName":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject48());
                    case "RegisterAccountNameSuccess":
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject49());
                    default:
                        return (0, $hxyOZ.html)($6fbf4ed9a4c90bb2$var$_templateObject50());
                }
            }
        },
        {
            key: "onViewChange",
            value: function onViewChange(newView) {
                var _this = this;
                (0, $5R7lI.TooltipController).hide();
                var direction = (0, $560364d27174f3fd$export$aafe1f751f1bc52a).VIEW_DIRECTION.Next;
                var history = (0, $iptjJ.RouterController).state.history;
                if (history.length < this.prevHistoryLength) direction = (0, $560364d27174f3fd$export$aafe1f751f1bc52a).VIEW_DIRECTION.Prev;
                this.prevHistoryLength = history.length;
                this.viewDirection = direction;
                setTimeout(function() {
                    _this.view = newView;
                }, (0, $560364d27174f3fd$export$aafe1f751f1bc52a).ANIMATION_DURATIONS.ViewTransition);
            }
        },
        {
            key: "getWrapper",
            value: function getWrapper() {
                var _this_shadowRoot;
                return (_this_shadowRoot = this.shadowRoot) === null || _this_shadowRoot === void 0 ? void 0 : _this_shadowRoot.querySelector("div");
            }
        }
    ]);
    return W3mRouter;
}((0, $2yD3e.LitElement));
$6fbf4ed9a4c90bb2$export$ccc15c9e32141a55.styles = (0, $d0c413183cbe659c$export$2e2bcd8739ae039);
$6fbf4ed9a4c90bb2$var$__decorate([
    (0, $334Pv.state)()
], $6fbf4ed9a4c90bb2$export$ccc15c9e32141a55.prototype, "view", void 0);
$6fbf4ed9a4c90bb2$var$__decorate([
    (0, $334Pv.state)()
], $6fbf4ed9a4c90bb2$export$ccc15c9e32141a55.prototype, "viewDirection", void 0);
$6fbf4ed9a4c90bb2$export$ccc15c9e32141a55 = $6fbf4ed9a4c90bb2$var$__decorate([
    (0, $hdxb6.customElement)("w3m-router")
], $6fbf4ed9a4c90bb2$export$ccc15c9e32141a55);



var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("cwWZ7");
var $dMLJP = parcelRequire("dMLJP");
var $5Lhe6 = parcelRequire("5Lhe6");
var $69mn1 = parcelRequire("69mn1");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $04kNM = parcelRequire("04kNM");
var $334Pv = parcelRequire("334Pv");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $495bf0425877dd9a$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host > wui-flex {\n    width: 100%;\n    max-width: 360px;\n  }\n\n  :host > wui-flex > wui-flex {\n    border-radius: var(--wui-border-radius-l);\n    width: 100%;\n  }\n\n  .amounts-container {\n    width: 100%;\n  }\n"
    ]);
    $495bf0425877dd9a$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $495bf0425877dd9a$export$2e2bcd8739ae039 = (0, $2D5eP.css)($495bf0425877dd9a$var$_templateObject());


function $b2a9282e59a740d5$var$_templateObject() {
    var data = (0, $j06k0._)([
        "<wui-button\n                  variant=",
        '\n                  size="md"\n                  textVariant="paragraph-600"\n                  fullWidth\n                  @click=',
        "\n                  >",
        "</wui-button\n                >"
    ]);
    $b2a9282e59a740d5$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $b2a9282e59a740d5$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column" justifyContent="center" alignItems="center">\n        <wui-flex flexDirection="column" alignItems="center" gap="xs">\n          <w3m-onramp-input\n            type="Fiat"\n            @inputChange=',
        "\n            .value=",
        '\n          ></w3m-onramp-input>\n          <w3m-onramp-input\n            type="Token"\n            .value=',
        "\n            .loading=",
        '\n          ></w3m-onramp-input>\n          <wui-flex justifyContent="space-evenly" class="amounts-container" gap="xs">\n            ',
        "\n          </wui-flex>\n          ",
        "\n        </wui-flex>\n      </wui-flex>\n    "
    ]);
    $b2a9282e59a740d5$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $b2a9282e59a740d5$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "<wui-button\n          @click=",
        '\n          variant="main"\n          fullWidth\n          size="lg"\n          borderRadius="xs"\n        >\n          Get quotes\n        </wui-button>'
    ]);
    $b2a9282e59a740d5$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $b2a9282e59a740d5$var$_templateObject3() {
    var data = (0, $j06k0._)([
        "<wui-button\n          @click=",
        '\n          variant="accent"\n          fullWidth\n          size="lg"\n          borderRadius="xs"\n        >\n          Connect wallet\n        </wui-button>'
    ]);
    $b2a9282e59a740d5$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var $b2a9282e59a740d5$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $b2a9282e59a740d5$var$PAYMENT_CURRENCY_SYMBOLS = {
    USD: "$",
    EUR: "\u20AC",
    GBP: "\xa3"
};
var $b2a9282e59a740d5$var$BUY_PRESET_AMOUNTS = [
    100,
    250,
    500,
    1000
];
var $b2a9282e59a740d5$export$33bc4f3e369ccb5f = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mOnrampWidget, LitElement);
    var _super = (0, $ohfOJ._)(W3mOnrampWidget);
    function W3mOnrampWidget() {
        var _this_unsubscribe;
        (0, $4GJKx._)(this, W3mOnrampWidget);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.disabled = false;
        _this.connected = (0, $dMLJP.AccountController).state.isConnected;
        _this.loading = (0, $5Lhe6.ModalController).state.loading;
        _this.paymentCurrency = (0, $69mn1.OnRampController).state.paymentCurrency;
        _this.paymentAmount = (0, $69mn1.OnRampController).state.paymentAmount;
        _this.purchaseAmount = (0, $69mn1.OnRampController).state.purchaseAmount;
        _this.quoteLoading = (0, $69mn1.OnRampController).state.quotesLoading;
        (_this_unsubscribe = _this.unsubscribe).push.apply(_this_unsubscribe, [
            (0, $dMLJP.AccountController).subscribeKey("isConnected", function(val) {
                _this.connected = val;
            }),
            (0, $5Lhe6.ModalController).subscribeKey("loading", function(val) {
                _this.loading = val;
            }),
            (0, $69mn1.OnRampController).subscribe(function(val) {
                _this.paymentCurrency = val.paymentCurrency;
                _this.paymentAmount = val.paymentAmount;
                _this.purchaseAmount = val.purchaseAmount;
                _this.quoteLoading = val.quotesLoading;
            })
        ]);
        return _this;
    }
    (0, $1wc17._)(W3mOnrampWidget, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                return (0, $hxyOZ.html)($b2a9282e59a740d5$var$_templateObject1(), this.onPaymentAmountChange.bind(this), this.paymentAmount || 0, this.purchaseAmount || 0, this.quoteLoading, $b2a9282e59a740d5$var$BUY_PRESET_AMOUNTS.map(function(amount) {
                    var _this_paymentCurrency;
                    return (0, $hxyOZ.html)($b2a9282e59a740d5$var$_templateObject(), _this.paymentAmount === amount ? "accent" : "neutral", function() {
                        return _this.selectPresetAmount(amount);
                    }, "".concat($b2a9282e59a740d5$var$PAYMENT_CURRENCY_SYMBOLS[((_this_paymentCurrency = _this.paymentCurrency) === null || _this_paymentCurrency === void 0 ? void 0 : _this_paymentCurrency.id) || "USD"], " ").concat(amount));
                }), this.templateButton());
            }
        },
        {
            key: "templateButton",
            value: function templateButton() {
                return this.connected ? (0, $hxyOZ.html)($b2a9282e59a740d5$var$_templateObject2(), this.getQuotes.bind(this)) : (0, $hxyOZ.html)($b2a9282e59a740d5$var$_templateObject3(), this.openModal.bind(this));
            }
        },
        {
            key: "getQuotes",
            value: function getQuotes() {
                if (!this.loading) (0, $5Lhe6.ModalController).open({
                    view: "OnRampProviders"
                });
            }
        },
        {
            key: "openModal",
            value: function openModal() {
                (0, $5Lhe6.ModalController).open({
                    view: "Connect"
                });
            }
        },
        {
            key: "onPaymentAmountChange",
            value: function onPaymentAmountChange(event) {
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $69mn1.OnRampController).setPaymentAmount(Number(event.detail));
                                return [
                                    4,
                                    (0, $69mn1.OnRampController).getQuote()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "selectPresetAmount",
            value: function selectPresetAmount(amount) {
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $69mn1.OnRampController).setPaymentAmount(amount);
                                return [
                                    4,
                                    (0, $69mn1.OnRampController).getQuote()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return W3mOnrampWidget;
}((0, $2yD3e.LitElement));
$b2a9282e59a740d5$export$33bc4f3e369ccb5f.styles = (0, $495bf0425877dd9a$export$2e2bcd8739ae039);
$b2a9282e59a740d5$var$__decorate([
    (0, $04kNM.property)({
        type: Boolean
    })
], $b2a9282e59a740d5$export$33bc4f3e369ccb5f.prototype, "disabled", void 0);
$b2a9282e59a740d5$var$__decorate([
    (0, $334Pv.state)()
], $b2a9282e59a740d5$export$33bc4f3e369ccb5f.prototype, "connected", void 0);
$b2a9282e59a740d5$var$__decorate([
    (0, $334Pv.state)()
], $b2a9282e59a740d5$export$33bc4f3e369ccb5f.prototype, "loading", void 0);
$b2a9282e59a740d5$var$__decorate([
    (0, $334Pv.state)()
], $b2a9282e59a740d5$export$33bc4f3e369ccb5f.prototype, "paymentCurrency", void 0);
$b2a9282e59a740d5$var$__decorate([
    (0, $334Pv.state)()
], $b2a9282e59a740d5$export$33bc4f3e369ccb5f.prototype, "paymentAmount", void 0);
$b2a9282e59a740d5$var$__decorate([
    (0, $334Pv.state)()
], $b2a9282e59a740d5$export$33bc4f3e369ccb5f.prototype, "purchaseAmount", void 0);
$b2a9282e59a740d5$var$__decorate([
    (0, $334Pv.state)()
], $b2a9282e59a740d5$export$33bc4f3e369ccb5f.prototype, "quoteLoading", void 0);
$b2a9282e59a740d5$export$33bc4f3e369ccb5f = $b2a9282e59a740d5$var$__decorate([
    (0, $hdxb6.customElement)("w3m-onramp-widget")
], $b2a9282e59a740d5$export$33bc4f3e369ccb5f);



var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("cwWZ7");
var $datXT = parcelRequire("datXT");
var $dMLJP = parcelRequire("dMLJP");
var $fPqxb = parcelRequire("fPqxb");
var $5Lhe6 = parcelRequire("5Lhe6");
var $i7zcD = parcelRequire("i7zcD");
var $2qlRb = parcelRequire("2qlRb");
var $2sXdV = parcelRequire("2sXdV");
var $hZBJb = parcelRequire("hZBJb");
var $8FcCV = parcelRequire("8FcCV");
var $iptjJ = parcelRequire("iptjJ");
var $3cYIS = parcelRequire("3cYIS");
var $iSNyw = parcelRequire("iSNyw");
var $1QDT9 = parcelRequire("1QDT9");
parcelRequire("grHtr");
var $dI7zX = parcelRequire("dI7zX");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");

parcelRequire("hsyMZ");
var $cSJ4o = parcelRequire("cSJ4o");
function $6877365b8e2f8918$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex\n        flexDirection="column"\n        alignItems="center"\n        gap="l"\n        .padding=',
        "\n      >\n        <wui-avatar\n          alt=",
        "\n          address=",
        "\n          imageSrc=",
        '\n          size="2lg"\n        ></wui-avatar>\n        <wui-flex flexDirection="column" alignItems="center">\n          <wui-flex gap="3xs" alignItems="center" justifyContent="center">\n            <wui-text variant="title-6-600" color="fg-100" data-testid="account-settings-address">\n              ',
        '\n            </wui-text>\n            <wui-icon-link\n              size="md"\n              icon="copy"\n              iconColor="fg-200"\n              @click=',
        '\n            ></wui-icon-link>\n          </wui-flex>\n        </wui-flex>\n      </wui-flex>\n      <wui-flex flexDirection="column" gap="m">\n        <wui-flex flexDirection="column" gap="xs" .padding=',
        ">\n          ",
        "\n          <w3m-account-auth-button></w3m-account-auth-button>\n          <wui-list-item\n            .variant=",
        '\n            iconVariant="overlay"\n            icon="networkPlaceholder"\n            imageSrc=',
        "\n            ?chevron=",
        "\n            @click=",
        '\n            data-testid="account-switch-network-button"\n          >\n            <wui-text variant="paragraph-500" color="fg-100">\n              ',
        "\n            </wui-text>\n          </wui-list-item>\n          ",
        " ",
        '\n          <wui-list-item\n            variant="icon"\n            iconVariant="overlay"\n            icon="disconnect"\n            ?chevron=',
        "\n            .loading=",
        "\n            @click=",
        '\n            data-testid="disconnect-button"\n          >\n            <wui-text variant="paragraph-500" color="fg-200">Disconnect</wui-text>\n          </wui-list-item>\n        </wui-flex>\n      </wui-flex>\n    '
    ]);
    $6877365b8e2f8918$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $6877365b8e2f8918$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '\n      <wui-list-item\n        variant="icon"\n        iconVariant="overlay"\n        icon="id"\n        iconSize="sm"\n        ?chevron=',
        "\n        @click=",
        '\n        data-testid="account-choose-name-button"\n      >\n        <wui-text variant="paragraph-500" color="fg-100">Choose account name </wui-text>\n      </wui-list-item>\n    '
    ]);
    $6877365b8e2f8918$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $6877365b8e2f8918$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "\n      <wui-notice-card\n        @click=",
        '\n        label="Upgrade your wallet"\n        description="Transition to a self-custodial wallet"\n        icon="wallet"\n        data-testid="w3m-wallet-upgrade-card"\n      ></wui-notice-card>\n    '
    ]);
    $6877365b8e2f8918$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $6877365b8e2f8918$var$_templateObject3() {
    var data = (0, $j06k0._)([
        '\n      <wui-list-item\n        variant="icon"\n        iconVariant="overlay"\n        icon="swapHorizontalBold"\n        iconSize="sm"\n        ?chevron=',
        "\n        ?loading=",
        "\n        @click=",
        '\n        data-testid="account-toggle-preferred-account-type"\n      >\n        <wui-text variant="paragraph-500" color="fg-100">',
        "</wui-text>\n      </wui-list-item>\n    "
    ]);
    $6877365b8e2f8918$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var $6877365b8e2f8918$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $6877365b8e2f8918$export$b2168ecfa4cbc2f8 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mAccountSettingsView, LitElement);
    var _super = (0, $ohfOJ._)(W3mAccountSettingsView);
    function W3mAccountSettingsView() {
        var _this_usubscribe;
        (0, $4GJKx._)(this, W3mAccountSettingsView);
        var _this;
        _this = _super.call(this);
        _this.usubscribe = [];
        _this.networkImages = (0, $datXT.AssetController).state.networkImages;
        _this.address = (0, $dMLJP.AccountController).state.address;
        _this.profileImage = (0, $dMLJP.AccountController).state.profileImage;
        _this.profileName = (0, $dMLJP.AccountController).state.profileName;
        _this.network = (0, $fPqxb.NetworkController).state.caipNetwork;
        _this.preferredAccountType = (0, $dMLJP.AccountController).state.preferredAccountType;
        _this.disconnecting = false;
        _this.loading = false;
        _this.switched = false;
        _this.text = "";
        (_this_usubscribe = _this.usubscribe).push.apply(_this_usubscribe, [
            (0, $dMLJP.AccountController).subscribe(function(val) {
                if (val.address) {
                    _this.address = val.address;
                    _this.profileImage = val.profileImage;
                    _this.profileName = val.profileName;
                    _this.preferredAccountType = val.preferredAccountType;
                } else (0, $5Lhe6.ModalController).close();
            }),
            (0, $dMLJP.AccountController).subscribeKey("preferredAccountType", function(val) {
                return _this.preferredAccountType = val;
            }),
            (0, $fPqxb.NetworkController).subscribeKey("caipNetwork", function(val) {
                if (val === null || val === void 0 ? void 0 : val.id) _this.network = val;
            })
        ]);
        return _this;
    }
    (0, $1wc17._)(W3mAccountSettingsView, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.usubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_network, _this_profileName, _this_network1;
                if (!this.address) throw new Error("w3m-account-settings-view: No account provided");
                var _this_network_imageId;
                var networkImage = this.networkImages[(_this_network_imageId = (_this_network = this.network) === null || _this_network === void 0 ? void 0 : _this_network.imageId) !== null && _this_network_imageId !== void 0 ? _this_network_imageId : ""];
                var name = (_this_profileName = this.profileName) === null || _this_profileName === void 0 ? void 0 : _this_profileName.split(".")[0];
                var _this_network_name;
                return (0, $hxyOZ.html)($6877365b8e2f8918$var$_templateObject(), [
                    "0",
                    "xl",
                    "m",
                    "xl"
                ], this.address, this.address, (0, $696d14fc702af3d6$export$f68dd208b5df064d)(this.profileImage), name ? (0, $dI7zX.UiHelperUtil).getTruncateString({
                    string: name,
                    charsStart: 20,
                    charsEnd: 0,
                    truncate: "end"
                }) : (0, $dI7zX.UiHelperUtil).getTruncateString({
                    string: this.address,
                    charsStart: 4,
                    charsEnd: 6,
                    truncate: "middle"
                }), this.onCopyAddress, [
                    "0",
                    "l",
                    "m",
                    "l"
                ], this.authCardTemplate(), networkImage ? "image" : "icon", (0, $696d14fc702af3d6$export$f68dd208b5df064d)(networkImage), this.isAllowedNetworkSwitch(), this.onNetworks.bind(this), (_this_network_name = (_this_network1 = this.network) === null || _this_network1 === void 0 ? void 0 : _this_network1.name) !== null && _this_network_name !== void 0 ? _this_network_name : "Unknown", this.togglePreferredAccountBtnTemplate(), this.chooseNameButtonTemplate(), false, this.disconnecting, this.onDisconnect.bind(this));
            }
        },
        {
            key: "chooseNameButtonTemplate",
            value: function chooseNameButtonTemplate() {
                var type = (0, $i7zcD.StorageUtil).getConnectedConnector();
                var authConnector = (0, $2qlRb.ConnectorController).getAuthConnector();
                if (!authConnector || type !== "AUTH" || this.profileName) return null;
                return (0, $hxyOZ.html)($6877365b8e2f8918$var$_templateObject1(), true, this.onChooseName.bind(this));
            }
        },
        {
            key: "authCardTemplate",
            value: function authCardTemplate() {
                var type = (0, $i7zcD.StorageUtil).getConnectedConnector();
                var authConnector = (0, $2qlRb.ConnectorController).getAuthConnector();
                var origin = location.origin;
                if (!authConnector || type !== "AUTH" || origin.includes((0, $2sXdV.ConstantsUtil).SECURE_SITE)) return null;
                return (0, $hxyOZ.html)($6877365b8e2f8918$var$_templateObject2(), this.onGoToUpgradeView.bind(this));
            }
        },
        {
            key: "isAllowedNetworkSwitch",
            value: function isAllowedNetworkSwitch() {
                var _this = this;
                var requestedCaipNetworks = (0, $fPqxb.NetworkController).getRequestedCaipNetworks();
                var isMultiNetwork = requestedCaipNetworks ? requestedCaipNetworks.length > 1 : false;
                var isValidNetwork = requestedCaipNetworks === null || requestedCaipNetworks === void 0 ? void 0 : requestedCaipNetworks.find(function(param) {
                    var id = param.id;
                    var _this_network;
                    return id === ((_this_network = _this.network) === null || _this_network === void 0 ? void 0 : _this_network.id);
                });
                return isMultiNetwork || !isValidNetwork;
            }
        },
        {
            key: "onCopyAddress",
            value: function onCopyAddress() {
                try {
                    if (this.profileName) {
                        (0, $hZBJb.CoreHelperUtil).copyToClopboard(this.profileName);
                        (0, $8FcCV.SnackController).showSuccess("Name copied");
                    } else if (this.address) {
                        (0, $hZBJb.CoreHelperUtil).copyToClopboard(this.address);
                        (0, $8FcCV.SnackController).showSuccess("Address copied");
                    }
                } catch (e) {
                    (0, $8FcCV.SnackController).showError("Failed to copy");
                }
            }
        },
        {
            key: "togglePreferredAccountBtnTemplate",
            value: function togglePreferredAccountBtnTemplate() {
                var networkEnabled = (0, $fPqxb.NetworkController).checkIfSmartAccountEnabled();
                var type = (0, $i7zcD.StorageUtil).getConnectedConnector();
                var authConnector = (0, $2qlRb.ConnectorController).getAuthConnector();
                if (!authConnector || type !== "AUTH" || !networkEnabled) return null;
                if (!this.switched) this.text = this.preferredAccountType === (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT ? "Switch to your EOA" : "Switch to your smart account";
                return (0, $hxyOZ.html)($6877365b8e2f8918$var$_templateObject3(), true, this.loading, this.changePreferredAccountType.bind(this), this.text);
            }
        },
        {
            key: "onChooseName",
            value: function onChooseName() {
                (0, $iptjJ.RouterController).push("ChooseAccountName");
            }
        },
        {
            key: "changePreferredAccountType",
            value: function changePreferredAccountType() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var smartAccountEnabled, accountTypeTarget, authConnector;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                smartAccountEnabled = (0, $fPqxb.NetworkController).checkIfSmartAccountEnabled();
                                accountTypeTarget = _this.preferredAccountType === (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT || !smartAccountEnabled ? (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.EOA : (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT;
                                authConnector = (0, $2qlRb.ConnectorController).getAuthConnector();
                                if (!authConnector) return [
                                    2
                                ];
                                _this.loading = true;
                                return [
                                    4,
                                    (0, $3cYIS.ConnectionController).setPreferredAccountType(accountTypeTarget)
                                ];
                            case 1:
                                _state.sent();
                                _this.text = accountTypeTarget === (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT ? "Switch to your EOA" : "Switch to your smart account";
                                _this.switched = true;
                                (0, $iSNyw.SendController).resetSend();
                                _this.loading = false;
                                _this.requestUpdate();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onNetworks",
            value: function onNetworks() {
                if (this.isAllowedNetworkSwitch()) (0, $iptjJ.RouterController).push("Networks");
            }
        },
        {
            key: "onDisconnect",
            value: function onDisconnect() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    3,
                                    4
                                ]);
                                _this.disconnecting = true;
                                return [
                                    4,
                                    (0, $3cYIS.ConnectionController).disconnect()
                                ];
                            case 1:
                                _state.sent();
                                (0, $1QDT9.EventsController).sendEvent({
                                    type: "track",
                                    event: "DISCONNECT_SUCCESS"
                                });
                                (0, $5Lhe6.ModalController).close();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                e = _state.sent();
                                (0, $1QDT9.EventsController).sendEvent({
                                    type: "track",
                                    event: "DISCONNECT_ERROR"
                                });
                                (0, $8FcCV.SnackController).showError("Failed to disconnect");
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                _this.disconnecting = false;
                                return [
                                    7
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onGoToUpgradeView",
            value: function onGoToUpgradeView() {
                (0, $1QDT9.EventsController).sendEvent({
                    type: "track",
                    event: "EMAIL_UPGRADE_FROM_MODAL"
                });
                (0, $iptjJ.RouterController).push("UpgradeEmailWallet");
            }
        }
    ]);
    return W3mAccountSettingsView;
}((0, $2yD3e.LitElement));
$6877365b8e2f8918$var$__decorate([
    (0, $334Pv.state)()
], $6877365b8e2f8918$export$b2168ecfa4cbc2f8.prototype, "address", void 0);
$6877365b8e2f8918$var$__decorate([
    (0, $334Pv.state)()
], $6877365b8e2f8918$export$b2168ecfa4cbc2f8.prototype, "profileImage", void 0);
$6877365b8e2f8918$var$__decorate([
    (0, $334Pv.state)()
], $6877365b8e2f8918$export$b2168ecfa4cbc2f8.prototype, "profileName", void 0);
$6877365b8e2f8918$var$__decorate([
    (0, $334Pv.state)()
], $6877365b8e2f8918$export$b2168ecfa4cbc2f8.prototype, "network", void 0);
$6877365b8e2f8918$var$__decorate([
    (0, $334Pv.state)()
], $6877365b8e2f8918$export$b2168ecfa4cbc2f8.prototype, "preferredAccountType", void 0);
$6877365b8e2f8918$var$__decorate([
    (0, $334Pv.state)()
], $6877365b8e2f8918$export$b2168ecfa4cbc2f8.prototype, "disconnecting", void 0);
$6877365b8e2f8918$var$__decorate([
    (0, $334Pv.state)()
], $6877365b8e2f8918$export$b2168ecfa4cbc2f8.prototype, "loading", void 0);
$6877365b8e2f8918$var$__decorate([
    (0, $334Pv.state)()
], $6877365b8e2f8918$export$b2168ecfa4cbc2f8.prototype, "switched", void 0);
$6877365b8e2f8918$var$__decorate([
    (0, $334Pv.state)()
], $6877365b8e2f8918$export$b2168ecfa4cbc2f8.prototype, "text", void 0);
$6877365b8e2f8918$export$b2168ecfa4cbc2f8 = $6877365b8e2f8918$var$__decorate([
    (0, $hdxb6.customElement)("w3m-account-settings-view")
], $6877365b8e2f8918$export$b2168ecfa4cbc2f8);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $i7zcD = parcelRequire("i7zcD");
var $2qlRb = parcelRequire("2qlRb");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
function $9d07b1df825f4f25$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      ",
        "\n    "
    ]);
    $9d07b1df825f4f25$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $9d07b1df825f4f25$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "<w3m-account-wallet-features-widget></w3m-account-wallet-features-widget>"
    ]);
    $9d07b1df825f4f25$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $9d07b1df825f4f25$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "<w3m-account-default-widget></w3m-account-default-widget>"
    ]);
    $9d07b1df825f4f25$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $9d07b1df825f4f25$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9d07b1df825f4f25$export$fb2cfdfbb483d2ac = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mAccountView, LitElement);
    var _super = (0, $ohfOJ._)(W3mAccountView);
    function W3mAccountView() {
        (0, $4GJKx._)(this, W3mAccountView);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(W3mAccountView, [
        {
            key: "render",
            value: function render() {
                var type = (0, $i7zcD.StorageUtil).getConnectedConnector();
                var authConnector = (0, $2qlRb.ConnectorController).getAuthConnector();
                return (0, $hxyOZ.html)($9d07b1df825f4f25$var$_templateObject(), (authConnector === null || authConnector === void 0 ? void 0 : authConnector.walletFeatures) && type === "AUTH" ? this.walletFeaturesTemplate() : this.defaultTemplate());
            }
        },
        {
            key: "walletFeaturesTemplate",
            value: function walletFeaturesTemplate() {
                return (0, $hxyOZ.html)($9d07b1df825f4f25$var$_templateObject1());
            }
        },
        {
            key: "defaultTemplate",
            value: function defaultTemplate() {
                return (0, $hxyOZ.html)($9d07b1df825f4f25$var$_templateObject2());
            }
        }
    ]);
    return W3mAccountView;
}((0, $2yD3e.LitElement));
$9d07b1df825f4f25$export$fb2cfdfbb483d2ac = $9d07b1df825f4f25$var$__decorate([
    (0, $hdxb6.customElement)("w3m-account-view")
], $9d07b1df825f4f25$export$fb2cfdfbb483d2ac);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $hZBJb = parcelRequire("hZBJb");
var $iptjJ = parcelRequire("iptjJ");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");
function $307ea72612706b61$var$_templateObject() {
    var data = (0, $j06k0._)([
        "<w3m-all-wallets-search query=",
        "></w3m-all-wallets-search>"
    ]);
    $307ea72612706b61$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $307ea72612706b61$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "<w3m-all-wallets-list></w3m-all-wallets-list>"
    ]);
    $307ea72612706b61$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $307ea72612706b61$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "\n      <wui-flex .padding=",
        ' gap="s">\n        <wui-search-bar @inputChange=',
        "></wui-search-bar>\n        ",
        "\n      </wui-flex>\n      ",
        "\n    "
    ]);
    $307ea72612706b61$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $307ea72612706b61$var$_templateObject3() {
    var data = (0, $j06k0._)([
        '\n        <wui-icon-box\n          size="lg"\n          iconSize="xl"\n          iconColor="accent-100"\n          backgroundColor="accent-100"\n          icon="qrCode"\n          background="transparent"\n          border\n          borderColor="wui-accent-glass-010"\n          @click=',
        "\n        ></wui-icon-box>\n      "
    ]);
    $307ea72612706b61$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var $307ea72612706b61$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $307ea72612706b61$export$88f35657f4e64778 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mAllWalletsView, LitElement);
    var _super = (0, $ohfOJ._)(W3mAllWalletsView);
    function W3mAllWalletsView() {
        (0, $4GJKx._)(this, W3mAllWalletsView);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.search = "";
        _this.onDebouncedSearch = (0, $hZBJb.CoreHelperUtil).debounce(function(value) {
            _this.search = value;
        });
        return _this;
    }
    (0, $1wc17._)(W3mAllWalletsView, [
        {
            key: "render",
            value: function render() {
                var isSearch = this.search.length >= 2;
                return (0, $hxyOZ.html)($307ea72612706b61$var$_templateObject2(), [
                    "0",
                    "s",
                    "s",
                    "s"
                ], this.onInputChange.bind(this), this.qrButtonTemplate(), isSearch ? (0, $hxyOZ.html)($307ea72612706b61$var$_templateObject(), this.search) : (0, $hxyOZ.html)($307ea72612706b61$var$_templateObject1()));
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(event) {
                this.onDebouncedSearch(event.detail);
            }
        },
        {
            key: "qrButtonTemplate",
            value: function qrButtonTemplate() {
                if ((0, $hZBJb.CoreHelperUtil).isMobile()) return (0, $hxyOZ.html)($307ea72612706b61$var$_templateObject3(), this.onWalletConnectQr.bind(this));
                return null;
            }
        },
        {
            key: "onWalletConnectQr",
            value: function onWalletConnectQr() {
                (0, $iptjJ.RouterController).push("ConnectingWalletConnect");
            }
        }
    ]);
    return W3mAllWalletsView;
}((0, $2yD3e.LitElement));
$307ea72612706b61$var$__decorate([
    (0, $334Pv.state)()
], $307ea72612706b61$export$88f35657f4e64778.prototype, "search", void 0);
$307ea72612706b61$export$88f35657f4e64778 = $307ea72612706b61$var$__decorate([
    (0, $hdxb6.customElement)("w3m-all-wallets-view")
], $307ea72612706b61$export$88f35657f4e64778);



var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("cwWZ7");
var $69mn1 = parcelRequire("69mn1");
var $3cYIS = parcelRequire("3cYIS");
var $dMLJP = parcelRequire("dMLJP");
var $faNff = parcelRequire("faNff");
var $jrvVk = parcelRequire("jrvVk");
var $iptjJ = parcelRequire("iptjJ");
var $8FcCV = parcelRequire("8FcCV");
var $hZBJb = parcelRequire("hZBJb");
var $dJ6Ea = parcelRequire("dJ6Ea");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");
var $04kNM = parcelRequire("04kNM");


var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $7cfc25e42bba5031$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  @keyframes shake {\n    0% {\n      transform: translateX(0);\n    }\n    25% {\n      transform: translateX(3px);\n    }\n    50% {\n      transform: translateX(-3px);\n    }\n    75% {\n      transform: translateX(3px);\n    }\n    100% {\n      transform: translateX(0);\n    }\n  }\n\n  wui-flex:first-child:not(:only-child) {\n    position: relative;\n  }\n\n  wui-loading-thumbnail {\n    position: absolute;\n  }\n\n  wui-visual {\n    width: var(--wui-wallet-image-size-lg);\n    height: var(--wui-wallet-image-size-lg);\n    border-radius: calc(var(--wui-border-radius-5xs) * 9 - var(--wui-border-radius-xxs));\n    position: relative;\n    overflow: hidden;\n  }\n\n  wui-visual::after {\n    content: '';\n    display: block;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    inset: 0;\n    border-radius: calc(var(--wui-border-radius-5xs) * 9 - var(--wui-border-radius-xxs));\n    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-005);\n  }\n\n  wui-icon-box {\n    position: absolute;\n    right: calc(var(--wui-spacing-3xs) * -1);\n    bottom: calc(var(--wui-spacing-3xs) * -1);\n    opacity: 0;\n    transform: scale(0.5);\n    transition:\n      opacity var(--wui-ease-out-power-2) var(--wui-duration-lg),\n      transform var(--wui-ease-out-power-2) var(--wui-duration-lg);\n    will-change: opacity, transform;\n  }\n\n  wui-text[align='center'] {\n    width: 100%;\n    padding: 0px var(--wui-spacing-l);\n  }\n\n  [data-error='true'] wui-icon-box {\n    opacity: 1;\n    transform: scale(1);\n  }\n\n  [data-error='true'] > wui-flex:first-child {\n    animation: shake 250ms cubic-bezier(0.36, 0.07, 0.19, 0.97) both;\n  }\n\n  [data-retry='false'] wui-link {\n    display: none;\n  }\n\n  [data-retry='true'] wui-link {\n    display: block;\n    opacity: 1;\n  }\n\n  wui-link {\n    padding: var(--wui-spacing-4xs) var(--wui-spacing-xxs);\n  }\n"
    ]);
    $7cfc25e42bba5031$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $7cfc25e42bba5031$export$2e2bcd8739ae039 = (0, $2D5eP.css)($7cfc25e42bba5031$var$_templateObject());


function $6f9905c56accfaf2$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      <wui-flex\n        data-error=",
        "\n        data-retry=",
        '\n        flexDirection="column"\n        alignItems="center"\n        .padding=',
        '\n        gap="xl"\n      >\n        <wui-flex justifyContent="center" alignItems="center">\n          <wui-visual\n            name=',
        '\n            size="lg"\n            class="provider-image"\n          >\n          </wui-visual>\n\n          ',
        '\n\n          <wui-icon-box\n            backgroundColor="error-100"\n            background="opaque"\n            iconColor="error-100"\n            icon="close"\n            size="sm"\n            border\n            borderColor="wui-color-bg-125"\n          ></wui-icon-box>\n        </wui-flex>\n\n        <wui-flex flexDirection="column" alignItems="center" gap="xs">\n          <wui-text variant="paragraph-500" color=',
        ">\n            ",
        '\n          </wui-text>\n          <wui-text align="center" variant="small-500" color="fg-200">',
        "</wui-text>\n        </wui-flex>\n\n        ",
        "\n      </wui-flex>\n\n      <wui-flex .padding=",
        ' justifyContent="center">\n        <wui-link @click=',
        ' color="fg-200">\n          <wui-icon size="xs" color="fg-200" slot="iconLeft" name="copy"></wui-icon>\n          Copy link\n        </wui-link>\n      </wui-flex>\n    '
    ]);
    $6f9905c56accfaf2$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $6f9905c56accfaf2$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '<wui-button size="md" variant="accent" @click=',
        '>\n      <wui-icon color="inherit" slot="iconLeft" name="refresh"></wui-icon>\n      Try again\n    </wui-button>'
    ]);
    $6f9905c56accfaf2$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $6f9905c56accfaf2$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "<wui-loading-thumbnail radius=",
        "></wui-loading-thumbnail>"
    ]);
    $6f9905c56accfaf2$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $6f9905c56accfaf2$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $6f9905c56accfaf2$export$e0ca4e8f314f5325 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mBuyInProgressView, LitElement);
    var _super = (0, $ohfOJ._)(W3mBuyInProgressView);
    function W3mBuyInProgressView() {
        var _this_unsubscribe;
        (0, $4GJKx._)(this, W3mBuyInProgressView);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.selectedOnRampProvider = (0, $69mn1.OnRampController).state.selectedProvider;
        _this.uri = (0, $3cYIS.ConnectionController).state.wcUri;
        _this.ready = false;
        _this.showRetry = false;
        _this.buffering = false;
        _this.error = false;
        _this.startTime = null;
        _this.isMobile = false;
        _this.onRetry = undefined;
        (_this_unsubscribe = _this.unsubscribe).push.apply(_this_unsubscribe, [
            (0, $69mn1.OnRampController).subscribeKey("selectedProvider", function(val) {
                _this.selectedOnRampProvider = val;
            })
        ]);
        _this.watchTransactions();
        return _this;
    }
    (0, $1wc17._)(W3mBuyInProgressView, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                if (this.intervalId) clearInterval(this.intervalId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_selectedOnRampProvider, _this_selectedOnRampProvider1;
                var label = "Continue in external window";
                if (this.error) label = "Buy failed";
                else if (this.selectedOnRampProvider) label = "Buy in ".concat((_this_selectedOnRampProvider = this.selectedOnRampProvider) === null || _this_selectedOnRampProvider === void 0 ? void 0 : _this_selectedOnRampProvider.label);
                var subLabel = this.error ? "Buy can be declined from your side or due to and error on the provider app" : "We\u2019ll notify you once your Buy is processed";
                return (0, $hxyOZ.html)($6f9905c56accfaf2$var$_templateObject(), (0, $696d14fc702af3d6$export$f68dd208b5df064d)(this.error), this.showRetry, [
                    "3xl",
                    "xl",
                    "xl",
                    "xl"
                ], (0, $696d14fc702af3d6$export$f68dd208b5df064d)((_this_selectedOnRampProvider1 = this.selectedOnRampProvider) === null || _this_selectedOnRampProvider1 === void 0 ? void 0 : _this_selectedOnRampProvider1.name), this.error ? null : this.loaderTemplate(), this.error ? "error-100" : "fg-100", label, subLabel, this.error ? this.tryAgainTemplate() : null, [
                    "0",
                    "xl",
                    "xl",
                    "xl"
                ], this.onCopyUri);
            }
        },
        {
            key: "watchTransactions",
            value: function watchTransactions() {
                if (!this.selectedOnRampProvider) return;
                switch(this.selectedOnRampProvider.name){
                    case "coinbase":
                        this.startTime = Date.now();
                        this.initializeCoinbaseTransactions();
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "initializeCoinbaseTransactions",
            value: function initializeCoinbaseTransactions() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.watchCoinbaseTransactions()
                                ];
                            case 1:
                                _state.sent();
                                _this.intervalId = setInterval(function() {
                                    return _this.watchCoinbaseTransactions();
                                }, 4000);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "watchCoinbaseTransactions",
            value: function watchCoinbaseTransactions() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var address, projectId, coinbaseResponse, newTransactions, error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                address = (0, $dMLJP.AccountController).state.address;
                                projectId = (0, $faNff.OptionsController).state.projectId;
                                if (!address) throw new Error("No address found");
                                return [
                                    4,
                                    (0, $jrvVk.BlockchainApiController).fetchTransactions({
                                        account: address,
                                        onramp: "coinbase",
                                        projectId: projectId
                                    })
                                ];
                            case 1:
                                coinbaseResponse = _state.sent();
                                newTransactions = coinbaseResponse.data.filter(function(tx) {
                                    return new Date(tx.metadata.minedAt) > new Date(_this.startTime) || tx.metadata.status === "ONRAMP_TRANSACTION_STATUS_IN_PROGRESS";
                                });
                                if (newTransactions.length) {
                                    clearInterval(_this.intervalId);
                                    (0, $iptjJ.RouterController).replace("OnRampActivity");
                                } else if (_this.startTime && Date.now() - _this.startTime >= 180000) {
                                    clearInterval(_this.intervalId);
                                    _this.error = true;
                                }
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                error = _state.sent();
                                (0, $8FcCV.SnackController).showError(error);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onTryAgain",
            value: function onTryAgain() {
                if (!this.selectedOnRampProvider) return;
                this.error = false;
                (0, $hZBJb.CoreHelperUtil).openHref(this.selectedOnRampProvider.url, "popupWindow", "width=600,height=800,scrollbars=yes");
            }
        },
        {
            key: "tryAgainTemplate",
            value: function tryAgainTemplate() {
                var _this_selectedOnRampProvider;
                if (!((_this_selectedOnRampProvider = this.selectedOnRampProvider) === null || _this_selectedOnRampProvider === void 0 ? void 0 : _this_selectedOnRampProvider.url)) return null;
                return (0, $hxyOZ.html)($6f9905c56accfaf2$var$_templateObject1(), this.onTryAgain.bind(this));
            }
        },
        {
            key: "loaderTemplate",
            value: function loaderTemplate() {
                var borderRadiusMaster = (0, $dJ6Ea.ThemeController).state.themeVariables["--w3m-border-radius-master"];
                var radius = borderRadiusMaster ? parseInt(borderRadiusMaster.replace("px", ""), 10) : 4;
                return (0, $hxyOZ.html)($6f9905c56accfaf2$var$_templateObject2(), radius * 9);
            }
        },
        {
            key: "onCopyUri",
            value: function onCopyUri() {
                var _this_selectedOnRampProvider;
                if (!((_this_selectedOnRampProvider = this.selectedOnRampProvider) === null || _this_selectedOnRampProvider === void 0 ? void 0 : _this_selectedOnRampProvider.url)) {
                    (0, $8FcCV.SnackController).showError("No link found");
                    (0, $iptjJ.RouterController).goBack();
                    return;
                }
                try {
                    (0, $hZBJb.CoreHelperUtil).copyToClopboard(this.selectedOnRampProvider.url);
                    (0, $8FcCV.SnackController).showSuccess("Link copied");
                } catch (e) {
                    (0, $8FcCV.SnackController).showError("Failed to copy");
                }
            }
        }
    ]);
    return W3mBuyInProgressView;
}((0, $2yD3e.LitElement));
$6f9905c56accfaf2$export$e0ca4e8f314f5325.styles = (0, $7cfc25e42bba5031$export$2e2bcd8739ae039);
$6f9905c56accfaf2$var$__decorate([
    (0, $334Pv.state)()
], $6f9905c56accfaf2$export$e0ca4e8f314f5325.prototype, "intervalId", void 0);
$6f9905c56accfaf2$var$__decorate([
    (0, $334Pv.state)()
], $6f9905c56accfaf2$export$e0ca4e8f314f5325.prototype, "selectedOnRampProvider", void 0);
$6f9905c56accfaf2$var$__decorate([
    (0, $334Pv.state)()
], $6f9905c56accfaf2$export$e0ca4e8f314f5325.prototype, "uri", void 0);
$6f9905c56accfaf2$var$__decorate([
    (0, $334Pv.state)()
], $6f9905c56accfaf2$export$e0ca4e8f314f5325.prototype, "ready", void 0);
$6f9905c56accfaf2$var$__decorate([
    (0, $334Pv.state)()
], $6f9905c56accfaf2$export$e0ca4e8f314f5325.prototype, "showRetry", void 0);
$6f9905c56accfaf2$var$__decorate([
    (0, $334Pv.state)()
], $6f9905c56accfaf2$export$e0ca4e8f314f5325.prototype, "buffering", void 0);
$6f9905c56accfaf2$var$__decorate([
    (0, $334Pv.state)()
], $6f9905c56accfaf2$export$e0ca4e8f314f5325.prototype, "error", void 0);
$6f9905c56accfaf2$var$__decorate([
    (0, $334Pv.state)()
], $6f9905c56accfaf2$export$e0ca4e8f314f5325.prototype, "startTime", void 0);
$6f9905c56accfaf2$var$__decorate([
    (0, $04kNM.property)({
        type: Boolean
    })
], $6f9905c56accfaf2$export$e0ca4e8f314f5325.prototype, "isMobile", void 0);
$6f9905c56accfaf2$var$__decorate([
    (0, $04kNM.property)()
], $6f9905c56accfaf2$export$e0ca4e8f314f5325.prototype, "onRetry", void 0);
$6f9905c56accfaf2$export$e0ca4e8f314f5325 = $6f9905c56accfaf2$var$__decorate([
    (0, $hdxb6.customElement)("w3m-buy-in-progress-view")
], $6f9905c56accfaf2$export$e0ca4e8f314f5325);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $73330e37ead9f6d3$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host > wui-flex {\n    max-height: clamp(360px, 540px, 80vh);\n    scrollbar-width: none;\n    overflow-y: scroll;\n    overflow-x: hidden;\n  }\n\n  :host > wui-flex::-webkit-scrollbar {\n    display: none;\n  }\n\n  .all-wallets {\n    flex-flow: column;\n  }\n"
    ]);
    $73330e37ead9f6d3$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $73330e37ead9f6d3$export$2e2bcd8739ae039 = (0, $2D5eP.css)($73330e37ead9f6d3$var$_templateObject());


parcelRequire("cwWZ7");
var $2qlRb = parcelRequire("2qlRb");
var $iptjJ = parcelRequire("iptjJ");
parcelRequire("334Pv");


var $334Pv = parcelRequire("334Pv");
function $78eef96247f534a4$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column" .padding=',
        ">\n        <w3m-email-login-widget></w3m-email-login-widget>\n        <w3m-social-login-widget></w3m-social-login-widget>\n        ",
        "\n      </wui-flex>\n      <w3m-legal-footer></w3m-legal-footer>\n    "
    ]);
    $78eef96247f534a4$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $78eef96247f534a4$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '\n          <wui-flex flexDirection="column" gap="xs" .margin=',
        '>\n            <w3m-connector-list></w3m-connector-list>\n            <wui-flex class="all-wallets">\n              <w3m-all-wallets-widget></w3m-all-wallets-widget>\n            </wui-flex>\n          </wui-flex>\n        '
    ]);
    $78eef96247f534a4$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $78eef96247f534a4$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "<wui-list-button\n        @click=",
        '\n        text="Continue with a wallet"\n      ></wui-list-button>'
    ]);
    $78eef96247f534a4$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $78eef96247f534a4$var$_templateObject3() {
    var data = (0, $j06k0._)([
        "<w3m-wallet-login-list></w3m-wallet-login-list>"
    ]);
    $78eef96247f534a4$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var $78eef96247f534a4$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $78eef96247f534a4$export$b7220f3d0ae9dbca = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mConnectView, LitElement);
    var _super = (0, $ohfOJ._)(W3mConnectView);
    function W3mConnectView() {
        (0, $4GJKx._)(this, W3mConnectView);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.connectors = (0, $2qlRb.ConnectorController).state.connectors;
        _this.unsubscribe.push((0, $2qlRb.ConnectorController).subscribeKey("connectors", function(val) {
            return _this.connectors = val;
        }));
        return _this;
    }
    (0, $1wc17._)(W3mConnectView, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($78eef96247f534a4$var$_templateObject(), [
                    "3xs",
                    "s",
                    "s",
                    "s"
                ], this.walletListTemplate());
            }
        },
        {
            key: "walletListTemplate",
            value: function walletListTemplate() {
                var authConnector = this.connectors.find(function(c) {
                    return c.type === "AUTH";
                });
                if (authConnector === null || authConnector === void 0 ? void 0 : authConnector.socials) {
                    if (authConnector === null || authConnector === void 0 ? void 0 : authConnector.showWallets) return (0, $hxyOZ.html)($78eef96247f534a4$var$_templateObject1(), [
                        "xs",
                        "0",
                        "0",
                        "0"
                    ]);
                    return (0, $hxyOZ.html)($78eef96247f534a4$var$_templateObject2(), this.onContinueWalletClick.bind(this));
                }
                return (0, $hxyOZ.html)($78eef96247f534a4$var$_templateObject3());
            }
        },
        {
            key: "onContinueWalletClick",
            value: function onContinueWalletClick() {
                (0, $iptjJ.RouterController).push("ConnectWallets");
            }
        }
    ]);
    return W3mConnectView;
}((0, $2yD3e.LitElement));
$78eef96247f534a4$export$b7220f3d0ae9dbca.styles = (0, $73330e37ead9f6d3$export$2e2bcd8739ae039);
$78eef96247f534a4$var$__decorate([
    (0, $334Pv.state)()
], $78eef96247f534a4$export$b7220f3d0ae9dbca.prototype, "connectors", void 0);
$78eef96247f534a4$export$b7220f3d0ae9dbca = $78eef96247f534a4$var$__decorate([
    (0, $hdxb6.customElement)("w3m-connect-view")
], $78eef96247f534a4$export$b7220f3d0ae9dbca);



var $d3H5E = parcelRequire("d3H5E");

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("cwWZ7");
var $1QDT9 = parcelRequire("1QDT9");
var $3cYIS = parcelRequire("3cYIS");
var $faNff = parcelRequire("faNff");
var $iptjJ = parcelRequire("iptjJ");
var $5Lhe6 = parcelRequire("5Lhe6");

parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $iptjJ = parcelRequire("iptjJ");
var $khm6W = parcelRequire("khm6W");
var $3cYIS = parcelRequire("3cYIS");
var $dJ6Ea = parcelRequire("dJ6Ea");
var $hZBJb = parcelRequire("hZBJb");
var $8FcCV = parcelRequire("8FcCV");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");
var $04kNM = parcelRequire("04kNM");


var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $36bd94e94765bd5f$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  @keyframes shake {\n    0% {\n      transform: translateX(0);\n    }\n    25% {\n      transform: translateX(3px);\n    }\n    50% {\n      transform: translateX(-3px);\n    }\n    75% {\n      transform: translateX(3px);\n    }\n    100% {\n      transform: translateX(0);\n    }\n  }\n\n  wui-flex:first-child:not(:only-child) {\n    position: relative;\n  }\n\n  wui-loading-thumbnail {\n    position: absolute;\n  }\n\n  wui-icon-box {\n    position: absolute;\n    right: calc(var(--wui-spacing-3xs) * -1);\n    bottom: calc(var(--wui-spacing-3xs) * -1);\n    opacity: 0;\n    transform: scale(0.5);\n    transition-property: opacity, transform;\n    transition-duration: var(--wui-duration-lg);\n    transition-timing-function: var(--wui-ease-out-power-2);\n    will-change: opacity, transform;\n  }\n\n  wui-text[align='center'] {\n    width: 100%;\n    padding: 0px var(--wui-spacing-l);\n  }\n\n  [data-error='true'] wui-icon-box {\n    opacity: 1;\n    transform: scale(1);\n  }\n\n  [data-error='true'] > wui-flex:first-child {\n    animation: shake 250ms cubic-bezier(0.36, 0.07, 0.19, 0.97) both;\n  }\n\n  [data-retry='false'] wui-link {\n    display: none;\n  }\n\n  [data-retry='true'] wui-link {\n    display: block;\n    opacity: 1;\n  }\n"
    ]);
    $36bd94e94765bd5f$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $36bd94e94765bd5f$export$2e2bcd8739ae039 = (0, $2D5eP.css)($36bd94e94765bd5f$var$_templateObject());


function $eab46a9771ccbf53$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n            <wui-flex .padding=",
        ' justifyContent="center">\n              <wui-link @click=',
        ' color="fg-200">\n                <wui-icon size="xs" color="fg-200" slot="iconLeft" name="copy"></wui-icon>\n                Copy link\n              </wui-link>\n            </wui-flex>\n          '
    ]);
    $eab46a9771ccbf53$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $eab46a9771ccbf53$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "\n      <wui-flex\n        data-error=",
        "\n        data-retry=",
        '\n        flexDirection="column"\n        alignItems="center"\n        .padding=',
        '\n        gap="xl"\n      >\n        <wui-flex justifyContent="center" alignItems="center">\n          <wui-wallet-image size="lg" imageSrc=',
        "></wui-wallet-image>\n\n          ",
        '\n\n          <wui-icon-box\n            backgroundColor="error-100"\n            background="opaque"\n            iconColor="error-100"\n            icon="close"\n            size="sm"\n            border\n            borderColor="wui-color-bg-125"\n          ></wui-icon-box>\n        </wui-flex>\n\n        <wui-flex flexDirection="column" alignItems="center" gap="xs">\n          <wui-text variant="paragraph-500" color=',
        ">\n            ",
        '\n          </wui-text>\n          <wui-text align="center" variant="small-500" color="fg-200">',
        '</wui-text>\n        </wui-flex>\n\n        <wui-button\n          variant="accent"\n          size="md"\n          ?disabled=',
        "\n          @click=",
        '\n        >\n          <wui-icon color="inherit" slot="iconLeft" name=',
        "></wui-icon>\n          ",
        "\n        </wui-button>\n      </wui-flex>\n\n      ",
        "\n\n      <w3m-mobile-download-links .wallet=",
        "></w3m-mobile-download-links>\n    "
    ]);
    $eab46a9771ccbf53$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $eab46a9771ccbf53$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "<wui-loading-thumbnail radius=",
        "></wui-loading-thumbnail>"
    ]);
    $eab46a9771ccbf53$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $eab46a9771ccbf53$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $eab46a9771ccbf53$export$902e3cfa9f67689d = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mConnectingWidget, LitElement);
    var _super = (0, $ohfOJ._)(W3mConnectingWidget);
    function W3mConnectingWidget() {
        var _this_unsubscribe;
        (0, $4GJKx._)(this, W3mConnectingWidget);
        var _this;
        var _RouterController_state_data, _RouterController_state_data1, _this_wallet, _this_connector;
        _this = _super.call(this);
        _this.wallet = (_RouterController_state_data = (0, $iptjJ.RouterController).state.data) === null || _RouterController_state_data === void 0 ? void 0 : _RouterController_state_data.wallet;
        _this.connector = (_RouterController_state_data1 = (0, $iptjJ.RouterController).state.data) === null || _RouterController_state_data1 === void 0 ? void 0 : _RouterController_state_data1.connector;
        _this.timeout = undefined;
        _this.secondaryBtnLabel = "Try again";
        _this.secondaryBtnIcon = "refresh";
        _this.secondaryLabel = "Accept connection request in the wallet";
        _this.onConnect = undefined;
        _this.onRender = undefined;
        _this.onAutoConnect = undefined;
        _this.isWalletConnect = true;
        _this.unsubscribe = [];
        var _AssetUtil_getWalletImage;
        _this.imageSrc = (_AssetUtil_getWalletImage = (0, $khm6W.AssetUtil).getWalletImage(_this.wallet)) !== null && _AssetUtil_getWalletImage !== void 0 ? _AssetUtil_getWalletImage : (0, $khm6W.AssetUtil).getConnectorImage(_this.connector);
        var _this_wallet_name, _ref;
        _this.name = (_ref = (_this_wallet_name = (_this_wallet = _this.wallet) === null || _this_wallet === void 0 ? void 0 : _this_wallet.name) !== null && _this_wallet_name !== void 0 ? _this_wallet_name : (_this_connector = _this.connector) === null || _this_connector === void 0 ? void 0 : _this_connector.name) !== null && _ref !== void 0 ? _ref : "Wallet";
        _this.isRetrying = false;
        _this.uri = (0, $3cYIS.ConnectionController).state.wcUri;
        _this.error = (0, $3cYIS.ConnectionController).state.wcError;
        _this.ready = false;
        _this.showRetry = false;
        _this.buffering = false;
        _this.isMobile = false;
        _this.onRetry = undefined;
        (_this_unsubscribe = _this.unsubscribe).push.apply(_this_unsubscribe, [
            (0, $3cYIS.ConnectionController).subscribeKey("wcUri", function(val) {
                _this.uri = val;
                if (_this.isRetrying && _this.onRetry) {
                    var _this_onConnect, _this1;
                    _this.isRetrying = false;
                    (_this_onConnect = (_this1 = _this).onConnect) === null || _this_onConnect === void 0 ? void 0 : _this_onConnect.call(_this1);
                }
            }),
            (0, $3cYIS.ConnectionController).subscribeKey("wcError", function(val) {
                return _this.error = val;
            }),
            (0, $3cYIS.ConnectionController).subscribeKey("buffering", function(val) {
                return _this.buffering = val;
            })
        ]);
        return _this;
    }
    (0, $1wc17._)(W3mConnectingWidget, [
        {
            key: "firstUpdated",
            value: function firstUpdated() {
                var _this_onAutoConnect, _this;
                (_this_onAutoConnect = (_this = this).onAutoConnect) === null || _this_onAutoConnect === void 0 ? void 0 : _this_onAutoConnect.call(_this);
                this.showRetry = !this.onAutoConnect;
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
                clearTimeout(this.timeout);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_onRender, _this;
                (_this_onRender = (_this = this).onRender) === null || _this_onRender === void 0 ? void 0 : _this_onRender.call(_this);
                this.onShowRetry();
                var subLabel = this.error ? "Connection can be declined if a previous request is still active" : this.secondaryLabel;
                var label = "Continue in ".concat(this.name);
                if (this.buffering) label = "Connecting...";
                if (this.error) label = "Connection declined";
                return (0, $hxyOZ.html)($eab46a9771ccbf53$var$_templateObject1(), (0, $696d14fc702af3d6$export$f68dd208b5df064d)(this.error), this.showRetry, [
                    "3xl",
                    "xl",
                    "xl",
                    "xl"
                ], (0, $696d14fc702af3d6$export$f68dd208b5df064d)(this.imageSrc), this.error ? null : this.loaderTemplate(), this.error ? "error-100" : "fg-100", label, subLabel, !this.error && this.buffering, this.onTryAgain.bind(this), this.secondaryBtnIcon, this.secondaryBtnLabel, this.isWalletConnect ? (0, $hxyOZ.html)($eab46a9771ccbf53$var$_templateObject(), [
                    "0",
                    "xl",
                    "xl",
                    "xl"
                ], this.onCopyUri) : null, this.wallet);
            }
        },
        {
            key: "onShowRetry",
            value: function onShowRetry() {
                if (this.error && !this.showRetry) {
                    var _this_shadowRoot;
                    this.showRetry = true;
                    var retryButton = (_this_shadowRoot = this.shadowRoot) === null || _this_shadowRoot === void 0 ? void 0 : _this_shadowRoot.querySelector("wui-button");
                    retryButton === null || retryButton === void 0 ? void 0 : retryButton.animate([
                        {
                            opacity: 0
                        },
                        {
                            opacity: 1
                        }
                    ], {
                        fill: "forwards",
                        easing: "ease"
                    });
                }
            }
        },
        {
            key: "onTryAgain",
            value: function onTryAgain() {
                if (!this.buffering) {
                    var _this_onConnect, _this;
                    (0, $3cYIS.ConnectionController).setWcError(false);
                    if (this.onRetry) {
                        var _this_onRetry, _this1;
                        this.isRetrying = true;
                        (_this_onRetry = (_this1 = this).onRetry) === null || _this_onRetry === void 0 ? void 0 : _this_onRetry.call(_this1);
                    } else (_this_onConnect = (_this = this).onConnect) === null || _this_onConnect === void 0 ? void 0 : _this_onConnect.call(_this);
                }
            }
        },
        {
            key: "loaderTemplate",
            value: function loaderTemplate() {
                var borderRadiusMaster = (0, $dJ6Ea.ThemeController).state.themeVariables["--w3m-border-radius-master"];
                var radius = borderRadiusMaster ? parseInt(borderRadiusMaster.replace("px", ""), 10) : 4;
                return (0, $hxyOZ.html)($eab46a9771ccbf53$var$_templateObject2(), radius * 9);
            }
        },
        {
            key: "onCopyUri",
            value: function onCopyUri() {
                try {
                    if (this.uri) {
                        (0, $hZBJb.CoreHelperUtil).copyToClopboard(this.uri);
                        (0, $8FcCV.SnackController).showSuccess("Link copied");
                    }
                } catch (e) {
                    (0, $8FcCV.SnackController).showError("Failed to copy");
                }
            }
        }
    ]);
    return W3mConnectingWidget;
}((0, $2yD3e.LitElement));
$eab46a9771ccbf53$export$902e3cfa9f67689d.styles = (0, $36bd94e94765bd5f$export$2e2bcd8739ae039);
$eab46a9771ccbf53$var$__decorate([
    (0, $334Pv.state)()
], $eab46a9771ccbf53$export$902e3cfa9f67689d.prototype, "uri", void 0);
$eab46a9771ccbf53$var$__decorate([
    (0, $334Pv.state)()
], $eab46a9771ccbf53$export$902e3cfa9f67689d.prototype, "error", void 0);
$eab46a9771ccbf53$var$__decorate([
    (0, $334Pv.state)()
], $eab46a9771ccbf53$export$902e3cfa9f67689d.prototype, "ready", void 0);
$eab46a9771ccbf53$var$__decorate([
    (0, $334Pv.state)()
], $eab46a9771ccbf53$export$902e3cfa9f67689d.prototype, "showRetry", void 0);
$eab46a9771ccbf53$var$__decorate([
    (0, $334Pv.state)()
], $eab46a9771ccbf53$export$902e3cfa9f67689d.prototype, "buffering", void 0);
$eab46a9771ccbf53$var$__decorate([
    (0, $04kNM.property)({
        type: Boolean
    })
], $eab46a9771ccbf53$export$902e3cfa9f67689d.prototype, "isMobile", void 0);
$eab46a9771ccbf53$var$__decorate([
    (0, $04kNM.property)()
], $eab46a9771ccbf53$export$902e3cfa9f67689d.prototype, "onRetry", void 0);


var $706d2132481fdf9e$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $706d2132481fdf9e$export$1d20b0281d81b1fd = /*#__PURE__*/ function(W3mConnectingWidget) {
    "use strict";
    (0, $dcsZi._)(W3mConnectingExternalView, W3mConnectingWidget);
    var _super = (0, $ohfOJ._)(W3mConnectingExternalView);
    function W3mConnectingExternalView() {
        (0, $4GJKx._)(this, W3mConnectingExternalView);
        var _this;
        _this = _super.call(this);
        if (!_this.connector) throw new Error("w3m-connecting-view: No connector provided");
        var _this_connector_name;
        (0, $1QDT9.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: (_this_connector_name = _this.connector.name) !== null && _this_connector_name !== void 0 ? _this_connector_name : "Unknown",
                platform: "browser"
            }
        });
        _this.onConnect = _this.onConnectProxy.bind((0, $d3H5E._)(_this));
        _this.onAutoConnect = _this.onConnectProxy.bind((0, $d3H5E._)(_this));
        _this.isWalletConnect = false;
        return _this;
    }
    (0, $1wc17._)(W3mConnectingExternalView, [
        {
            key: "onConnectProxy",
            value: function onConnectProxy() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var error, _error_message;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    3,
                                    ,
                                    4
                                ]);
                                _this.error = false;
                                if (!_this.connector) return [
                                    3,
                                    2
                                ];
                                if (!(_this.connector.id !== (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).COINBASE_SDK_CONNECTOR_ID || !_this.error)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (0, $3cYIS.ConnectionController).connectExternal(_this.connector, _this.connector.chain)
                                ];
                            case 1:
                                _state.sent();
                                if ((0, $faNff.OptionsController).state.isSiweEnabled) (0, $iptjJ.RouterController).push("ConnectingSiwe");
                                else (0, $5Lhe6.ModalController).close();
                                (0, $1QDT9.EventsController).sendEvent({
                                    type: "track",
                                    event: "CONNECT_SUCCESS",
                                    properties: {
                                        method: "browser",
                                        name: _this.connector.name || "Unknown"
                                    }
                                });
                                _state.label = 2;
                            case 2:
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                (0, $1QDT9.EventsController).sendEvent({
                                    type: "track",
                                    event: "CONNECT_ERROR",
                                    properties: {
                                        message: (_error_message = error === null || error === void 0 ? void 0 : error.message) !== null && _error_message !== void 0 ? _error_message : "Unknown"
                                    }
                                });
                                _this.error = true;
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return W3mConnectingExternalView;
}((0, $eab46a9771ccbf53$export$902e3cfa9f67689d));
$706d2132481fdf9e$export$1d20b0281d81b1fd = $706d2132481fdf9e$var$__decorate([
    (0, $hdxb6.customElement)("w3m-connecting-external-view")
], $706d2132481fdf9e$export$1d20b0281d81b1fd);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $9zDWP = parcelRequire("9zDWP");
var $khm6W = parcelRequire("khm6W");
var $8FcCV = parcelRequire("8FcCV");
var $hZBJb = parcelRequire("hZBJb");
var $iptjJ = parcelRequire("iptjJ");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");


var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $00421c786e45c11f$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  wui-flex,\n  wui-list-wallet {\n    width: 100%;\n  }\n"
    ]);
    $00421c786e45c11f$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $00421c786e45c11f$export$2e2bcd8739ae039 = (0, $2D5eP.css)($00421c786e45c11f$var$_templateObject());


function $774c26b53ac9b40a$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex\n        flexDirection="column"\n        alignItems="center"\n        .padding=',
        '\n        gap="xl"\n      >\n        <wui-flex justifyContent="center" alignItems="center">\n          <wui-wallet-image\n            size="lg"\n            imageSrc=',
        '\n          ></wui-wallet-image>\n        </wui-flex>\n        <wui-flex\n          flexDirection="column"\n          alignItems="center"\n          gap="xs"\n          .padding=',
        '\n        >\n          <wui-text variant="paragraph-500" color="fg-100">\n            Select Chain for ',
        '\n          </wui-text>\n          <wui-text align="center" variant="small-500" color="fg-200"\n            >Select which chain to connect to your multi chain wallet</wui-text\n          >\n        </wui-flex>\n        <wui-flex\n          flexGrow="1"\n          flexDirection="column"\n          alignItems="center"\n          gap="xs"\n          .padding=',
        "\n        >\n          ",
        "\n        </wui-flex>\n      </wui-flex>\n    "
    ]);
    $774c26b53ac9b40a$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $774c26b53ac9b40a$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "\n        <wui-list-wallet\n          imageSrc=",
        "\n          name=",
        "\n          @click=",
        "\n        ></wui-list-wallet>\n      "
    ]);
    $774c26b53ac9b40a$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $774c26b53ac9b40a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $774c26b53ac9b40a$export$4df72daec743eb3c = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mConnectingMultiChainView, LitElement);
    var _super = (0, $ohfOJ._)(W3mConnectingMultiChainView);
    function W3mConnectingMultiChainView() {
        var _this_unsubscribe;
        (0, $4GJKx._)(this, W3mConnectingMultiChainView);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.activeConnector = (0, $9zDWP.ChainController).state.activeConnector;
        (_this_unsubscribe = _this.unsubscribe).push.apply(_this_unsubscribe, [
            (0, $9zDWP.ChainController).subscribeKey("activeConnector", function(val) {
                return _this.activeConnector = val;
            })
        ]);
        return _this;
    }
    (0, $1wc17._)(W3mConnectingMultiChainView, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_activeConnector;
                return (0, $hxyOZ.html)($774c26b53ac9b40a$var$_templateObject(), [
                    "m",
                    "xl",
                    "xl",
                    "xl"
                ], (0, $696d14fc702af3d6$export$f68dd208b5df064d)((0, $khm6W.AssetUtil).getConnectorImage(this.activeConnector)), [
                    "0",
                    "s",
                    "0",
                    "s"
                ], (_this_activeConnector = this.activeConnector) === null || _this_activeConnector === void 0 ? void 0 : _this_activeConnector.name, [
                    "xs",
                    "0",
                    "xs",
                    "0"
                ], this.networksTemplate());
            }
        },
        {
            key: "networksTemplate",
            value: function networksTemplate() {
                var _this = this;
                var _this_activeConnector_providers, _this_activeConnector;
                return (_this_activeConnector = this.activeConnector) === null || _this_activeConnector === void 0 ? void 0 : (_this_activeConnector_providers = _this_activeConnector.providers) === null || _this_activeConnector_providers === void 0 ? void 0 : _this_activeConnector_providers.map(function(provider) {
                    return (0, $hxyOZ.html)($774c26b53ac9b40a$var$_templateObject1(), (0, $696d14fc702af3d6$export$f68dd208b5df064d)((0, $khm6W.AssetUtil).getChainImage(provider.chain)), provider.name, function() {
                        return _this.onConnector(provider);
                    });
                });
            }
        },
        {
            key: "onConnector",
            value: function onConnector(provider) {
                var _this_activeConnector_providers, _this_activeConnector;
                (0, $9zDWP.ChainController).setActiveChain(provider.chain);
                var connector = (_this_activeConnector = this.activeConnector) === null || _this_activeConnector === void 0 ? void 0 : (_this_activeConnector_providers = _this_activeConnector.providers) === null || _this_activeConnector_providers === void 0 ? void 0 : _this_activeConnector_providers.find(function(p) {
                    return p.chain === provider.chain;
                });
                if (!connector) {
                    (0, $8FcCV.SnackController).showError("Failed to find connector");
                    return;
                }
                if (connector.type === "WALLET_CONNECT") {
                    if ((0, $hZBJb.CoreHelperUtil).isMobile()) (0, $iptjJ.RouterController).push("AllWallets");
                    else (0, $iptjJ.RouterController).push("ConnectingWalletConnect");
                } else (0, $iptjJ.RouterController).push("ConnectingExternal", {
                    connector: connector
                });
            }
        }
    ]);
    return W3mConnectingMultiChainView;
}((0, $2yD3e.LitElement));
$774c26b53ac9b40a$export$4df72daec743eb3c.styles = (0, $00421c786e45c11f$export$2e2bcd8739ae039);
$774c26b53ac9b40a$var$__decorate([
    (0, $334Pv.state)()
], $774c26b53ac9b40a$export$4df72daec743eb3c.prototype, "activeConnector", void 0);
$774c26b53ac9b40a$export$4df72daec743eb3c = $774c26b53ac9b40a$var$__decorate([
    (0, $hdxb6.customElement)("w3m-connecting-multi-chain-view")
], $774c26b53ac9b40a$export$4df72daec743eb3c);



var $d3H5E = parcelRequire("d3H5E");

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("cwWZ7");
var $iptjJ = parcelRequire("iptjJ");
var $2sXdV = parcelRequire("2sXdV");
var $3cYIS = parcelRequire("3cYIS");
var $hZBJb = parcelRequire("hZBJb");
var $i7zcD = parcelRequire("i7zcD");
var $faNff = parcelRequire("faNff");
var $5Lhe6 = parcelRequire("5Lhe6");
var $1QDT9 = parcelRequire("1QDT9");
var $8FcCV = parcelRequire("8FcCV");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");
function $ea9350c0f2c11fbd$var$_templateObject() {
    var data = (0, $j06k0._)([
        "<w3m-connecting-wc-qrcode></w3m-connecting-wc-qrcode>"
    ]);
    $ea9350c0f2c11fbd$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $ea9350c0f2c11fbd$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "\n      ",
        "\n      <div>",
        "</div>\n    "
    ]);
    $ea9350c0f2c11fbd$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $ea9350c0f2c11fbd$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "<w3m-connecting-wc-browser></w3m-connecting-wc-browser>"
    ]);
    $ea9350c0f2c11fbd$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $ea9350c0f2c11fbd$var$_templateObject3() {
    var data = (0, $j06k0._)([
        "\n          <w3m-connecting-wc-desktop .onRetry=",
        ">\n          </w3m-connecting-wc-desktop>\n        "
    ]);
    $ea9350c0f2c11fbd$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $ea9350c0f2c11fbd$var$_templateObject4() {
    var data = (0, $j06k0._)([
        "\n          <w3m-connecting-wc-web .onRetry=",
        ">\n          </w3m-connecting-wc-web>\n        "
    ]);
    $ea9350c0f2c11fbd$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $ea9350c0f2c11fbd$var$_templateObject5() {
    var data = (0, $j06k0._)([
        "\n          <w3m-connecting-wc-mobile isMobile .onRetry=",
        ">\n          </w3m-connecting-wc-mobile>\n        "
    ]);
    $ea9350c0f2c11fbd$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $ea9350c0f2c11fbd$var$_templateObject6() {
    var data = (0, $j06k0._)([
        "<w3m-connecting-wc-qrcode></w3m-connecting-wc-qrcode>"
    ]);
    $ea9350c0f2c11fbd$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $ea9350c0f2c11fbd$var$_templateObject7() {
    var data = (0, $j06k0._)([
        "<w3m-connecting-wc-unsupported></w3m-connecting-wc-unsupported>"
    ]);
    $ea9350c0f2c11fbd$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $ea9350c0f2c11fbd$var$_templateObject8() {
    var data = (0, $j06k0._)([
        "\n      <w3m-connecting-header\n        .platforms=",
        "\n        .onSelectPlatfrom=",
        "\n      >\n      </w3m-connecting-header>\n    "
    ]);
    $ea9350c0f2c11fbd$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
var $ea9350c0f2c11fbd$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var $ea9350c0f2c11fbd$export$749260f2a44cfead = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mConnectingWcView, LitElement);
    var _super = (0, $ohfOJ._)(W3mConnectingWcView);
    function W3mConnectingWcView() {
        (0, $4GJKx._)(this, W3mConnectingWcView);
        var _this;
        var _RouterController_state_data;
        _this = _super.call(this);
        _this.interval = undefined;
        _this.lastRetry = Date.now();
        _this.wallet = (_RouterController_state_data = (0, $iptjJ.RouterController).state.data) === null || _RouterController_state_data === void 0 ? void 0 : _RouterController_state_data.wallet;
        _this.platform = undefined;
        _this.platforms = [];
        _this.initializeConnection();
        _this.interval = setInterval(_this.initializeConnection.bind((0, $d3H5E._)(_this)), (0, $2sXdV.ConstantsUtil).TEN_SEC_MS);
        return _this;
    }
    (0, $1wc17._)(W3mConnectingWcView, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                clearTimeout(this.interval);
            }
        },
        {
            key: "render",
            value: function render() {
                if (!this.wallet) return (0, $hxyOZ.html)($ea9350c0f2c11fbd$var$_templateObject());
                this.determinePlatforms();
                return (0, $hxyOZ.html)($ea9350c0f2c11fbd$var$_templateObject1(), this.headerTemplate(), this.platformTemplate());
            }
        },
        {
            key: "initializeConnection",
            value: function initializeConnection() {
                var retry = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var wcPairingExpiry, SIWEController, error, _error_message;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    6,
                                    ,
                                    7
                                ]);
                                wcPairingExpiry = (0, $3cYIS.ConnectionController).state.wcPairingExpiry;
                                if (!(retry || (0, $hZBJb.CoreHelperUtil).isPairingExpired(wcPairingExpiry))) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    (0, $3cYIS.ConnectionController).connectWalletConnect()
                                ];
                            case 1:
                                _state.sent();
                                _this.finalizeConnection();
                                if (!((0, $i7zcD.StorageUtil).getConnectedConnector() === "AUTH" && (0, $faNff.OptionsController).state.hasMultipleAddresses)) return [
                                    3,
                                    2
                                ];
                                (0, $iptjJ.RouterController).push("SelectAddresses");
                                return [
                                    3,
                                    5
                                ];
                            case 2:
                                if (!(0, $faNff.OptionsController).state.isSiweEnabled) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    (parcelRequire("jCIHD"))
                                ];
                            case 3:
                                SIWEController = _state.sent().SIWEController;
                                if (SIWEController.state.status === "success") (0, $5Lhe6.ModalController).close();
                                else (0, $iptjJ.RouterController).push("ConnectingSiwe");
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                (0, $5Lhe6.ModalController).close();
                                _state.label = 5;
                            case 5:
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                error = _state.sent();
                                (0, $1QDT9.EventsController).sendEvent({
                                    type: "track",
                                    event: "CONNECT_ERROR",
                                    properties: {
                                        message: (_error_message = error === null || error === void 0 ? void 0 : error.message) !== null && _error_message !== void 0 ? _error_message : "Unknown"
                                    }
                                });
                                (0, $3cYIS.ConnectionController).setWcError(true);
                                if ((0, $hZBJb.CoreHelperUtil).isAllowedRetry(_this.lastRetry)) {
                                    (0, $8FcCV.SnackController).showError("Declined");
                                    _this.lastRetry = Date.now();
                                    _this.initializeConnection(true);
                                }
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "finalizeConnection",
            value: function finalizeConnection() {
                var _this_wallet;
                var _ConnectionController_state = (0, $3cYIS.ConnectionController).state, wcLinking = _ConnectionController_state.wcLinking, recentWallet = _ConnectionController_state.recentWallet;
                if (wcLinking) (0, $i7zcD.StorageUtil).setWalletConnectDeepLink(wcLinking);
                if (recentWallet) (0, $i7zcD.StorageUtil).setWeb3ModalRecent(recentWallet);
                (0, $1QDT9.EventsController).sendEvent({
                    type: "track",
                    event: "CONNECT_SUCCESS",
                    properties: {
                        method: wcLinking ? "mobile" : "qrcode",
                        name: ((_this_wallet = this.wallet) === null || _this_wallet === void 0 ? void 0 : _this_wallet.name) || "Unknown"
                    }
                });
            }
        },
        {
            key: "determinePlatforms",
            value: function determinePlatforms() {
                if (!this.wallet) throw new Error("w3m-connecting-wc-view:determinePlatforms No wallet");
                if (this.platform) return;
                var _this_wallet = this.wallet, mobile_link = _this_wallet.mobile_link, desktop_link = _this_wallet.desktop_link, webapp_link = _this_wallet.webapp_link, injected = _this_wallet.injected, rdns = _this_wallet.rdns;
                var injectedIds = injected === null || injected === void 0 ? void 0 : injected.map(function(param) {
                    var injected_id = param.injected_id;
                    return injected_id;
                }).filter(Boolean);
                var browserIds = rdns ? [
                    rdns
                ] : injectedIds !== null && injectedIds !== void 0 ? injectedIds : [];
                var isBrowser = (0, $faNff.OptionsController).state.isUniversalProvider ? false : browserIds.length;
                var isMobileWc = mobile_link;
                var isWebWc = webapp_link;
                var isBrowserInstalled = (0, $3cYIS.ConnectionController).checkInstalled(browserIds);
                var isBrowserWc = isBrowser && isBrowserInstalled;
                var isDesktopWc = desktop_link && !(0, $hZBJb.CoreHelperUtil).isMobile();
                if (isBrowserWc) this.platforms.push("browser");
                if (isMobileWc) this.platforms.push((0, $hZBJb.CoreHelperUtil).isMobile() ? "mobile" : "qrcode");
                if (isWebWc) this.platforms.push("web");
                if (isDesktopWc) this.platforms.push("desktop");
                if (!isBrowserWc && isBrowser) this.platforms.push("unsupported");
                this.platform = this.platforms[0];
            }
        },
        {
            key: "platformTemplate",
            value: function platformTemplate() {
                var _this = this;
                switch(this.platform){
                    case "browser":
                        return (0, $hxyOZ.html)($ea9350c0f2c11fbd$var$_templateObject2());
                    case "desktop":
                        return (0, $hxyOZ.html)($ea9350c0f2c11fbd$var$_templateObject3(), function() {
                            return _this.initializeConnection(true);
                        });
                    case "web":
                        return (0, $hxyOZ.html)($ea9350c0f2c11fbd$var$_templateObject4(), function() {
                            return _this.initializeConnection(true);
                        });
                    case "mobile":
                        return (0, $hxyOZ.html)($ea9350c0f2c11fbd$var$_templateObject5(), function() {
                            return _this.initializeConnection(true);
                        });
                    case "qrcode":
                        return (0, $hxyOZ.html)($ea9350c0f2c11fbd$var$_templateObject6());
                    default:
                        return (0, $hxyOZ.html)($ea9350c0f2c11fbd$var$_templateObject7());
                }
            }
        },
        {
            key: "headerTemplate",
            value: function headerTemplate() {
                var multiPlatform = this.platforms.length > 1;
                if (!multiPlatform) return null;
                return (0, $hxyOZ.html)($ea9350c0f2c11fbd$var$_templateObject8(), this.platforms, this.onSelectPlatform.bind(this));
            }
        },
        {
            key: "onSelectPlatform",
            value: function onSelectPlatform(platform) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _this_shadowRoot, container;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                container = (_this_shadowRoot = _this.shadowRoot) === null || _this_shadowRoot === void 0 ? void 0 : _this_shadowRoot.querySelector("div");
                                if (!container) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    container.animate([
                                        {
                                            opacity: 1
                                        },
                                        {
                                            opacity: 0
                                        }
                                    ], {
                                        duration: 200,
                                        fill: "forwards",
                                        easing: "ease"
                                    }).finished
                                ];
                            case 1:
                                _state.sent();
                                _this.platform = platform;
                                container.animate([
                                    {
                                        opacity: 0
                                    },
                                    {
                                        opacity: 1
                                    }
                                ], {
                                    duration: 200,
                                    fill: "forwards",
                                    easing: "ease"
                                });
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return W3mConnectingWcView;
}((0, $2yD3e.LitElement));
$ea9350c0f2c11fbd$var$__decorate([
    (0, $334Pv.state)()
], $ea9350c0f2c11fbd$export$749260f2a44cfead.prototype, "platform", void 0);
$ea9350c0f2c11fbd$var$__decorate([
    (0, $334Pv.state)()
], $ea9350c0f2c11fbd$export$749260f2a44cfead.prototype, "platforms", void 0);
$ea9350c0f2c11fbd$export$749260f2a44cfead = $ea9350c0f2c11fbd$var$__decorate([
    (0, $hdxb6.customElement)("w3m-connecting-wc-view")
], $ea9350c0f2c11fbd$export$749260f2a44cfead);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("cwWZ7");
var $hZBJb = parcelRequire("hZBJb");
var $iptjJ = parcelRequire("iptjJ");
var $1QDT9 = parcelRequire("1QDT9");
var $dMLJP = parcelRequire("dMLJP");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $38a9b8c98ab342df$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  .continue-button-container {\n    width: 100%;\n  }\n"
    ]);
    $38a9b8c98ab342df$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $38a9b8c98ab342df$export$2e2bcd8739ae039 = (0, $2D5eP.css)($38a9b8c98ab342df$var$_templateObject());


parcelRequire("dSKxG");
var $ejaSv = parcelRequire("ejaSv");
parcelRequire("hsyMZ");
var $cSJ4o = parcelRequire("cSJ4o");
function $0fe56e47ad7154a2$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex\n        flexDirection="column"\n        alignItems="center"\n        gap="xxl"\n        .padding=',
        "\n      >\n        ",
        " ",
        "\n        <wui-link\n          @click=",
        '\n        >\n          Learn more about names\n          <wui-icon color="inherit" slot="iconRight" name="externalLink"></wui-icon>\n        </wui-link>\n      </wui-flex>\n    '
    ]);
    $0fe56e47ad7154a2$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $0fe56e47ad7154a2$var$_templateObject1() {
    var data = (0, $j06k0._)([
        ' <wui-flex\n      flexDirection="column"\n      gap="xxl"\n      alignItems="center"\n      .padding=',
        '\n    >\n      <wui-flex gap="s" alignItems="center" justifyContent="center">\n        <wui-icon-box\n          icon="id"\n          size="xl"\n          iconSize="xxl"\n          iconColor="fg-200"\n          backgroundColor="fg-200"\n        ></wui-icon-box>\n      </wui-flex>\n      <wui-flex flexDirection="column" alignItems="center" gap="s">\n        <wui-text align="center" variant="medium-600" color="fg-100">\n          Choose your account name\n        </wui-text>\n        <wui-text align="center" variant="paragraph-400" color="fg-100">\n          Finally say goodbye to 0x addresses, name your account to make it easier to exchange\n          assets\n        </wui-text>\n      </wui-flex>\n    </wui-flex>'
    ]);
    $0fe56e47ad7154a2$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $0fe56e47ad7154a2$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "<wui-flex\n      .padding=",
        '\n      gap="s"\n      class="continue-button-container"\n    >\n      <wui-button\n        fullWidth\n        .loading=',
        '\n        size="lg"\n        borderRadius="xs"\n        @click=',
        "\n        >Choose name\n      </wui-button>\n    </wui-flex>"
    ]);
    $0fe56e47ad7154a2$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $0fe56e47ad7154a2$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $0fe56e47ad7154a2$export$8697ba8a32799bc3 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mChooseAccountNameView, LitElement);
    var _super = (0, $ohfOJ._)(W3mChooseAccountNameView);
    function W3mChooseAccountNameView() {
        (0, $4GJKx._)(this, W3mChooseAccountNameView);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.loading = false;
        return _this;
    }
    (0, $1wc17._)(W3mChooseAccountNameView, [
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($0fe56e47ad7154a2$var$_templateObject(), [
                    "0",
                    "0",
                    "l",
                    "0"
                ], this.onboardingTemplate(), this.buttonsTemplate(), function() {
                    (0, $hZBJb.CoreHelperUtil).openHref((0, $ejaSv.NavigationUtil).URLS.FAQ, "_blank");
                });
            }
        },
        {
            key: "onboardingTemplate",
            value: function onboardingTemplate() {
                return (0, $hxyOZ.html)($0fe56e47ad7154a2$var$_templateObject1(), [
                    "0",
                    "xxl",
                    "0",
                    "xxl"
                ]);
            }
        },
        {
            key: "buttonsTemplate",
            value: function buttonsTemplate() {
                return (0, $hxyOZ.html)($0fe56e47ad7154a2$var$_templateObject2(), [
                    "0",
                    "2l",
                    "0",
                    "2l"
                ], this.loading, this.handleContinue.bind(this));
            }
        },
        {
            key: "handleContinue",
            value: function handleContinue() {
                (0, $iptjJ.RouterController).push("RegisterAccountName");
                (0, $1QDT9.EventsController).sendEvent({
                    type: "track",
                    event: "OPEN_ENS_FLOW",
                    properties: {
                        isSmartAccount: (0, $dMLJP.AccountController).state.preferredAccountType === (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT
                    }
                });
            }
        }
    ]);
    return W3mChooseAccountNameView;
}((0, $2yD3e.LitElement));
$0fe56e47ad7154a2$export$8697ba8a32799bc3.styles = (0, $38a9b8c98ab342df$export$2e2bcd8739ae039);
$0fe56e47ad7154a2$var$__decorate([
    (0, $334Pv.state)()
], $0fe56e47ad7154a2$export$8697ba8a32799bc3.prototype, "loading", void 0);
$0fe56e47ad7154a2$export$8697ba8a32799bc3 = $0fe56e47ad7154a2$var$__decorate([
    (0, $hdxb6.customElement)("w3m-choose-account-name-view")
], $0fe56e47ad7154a2$export$8697ba8a32799bc3);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $iptjJ = parcelRequire("iptjJ");
var $hZBJb = parcelRequire("hZBJb");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
function $a56df302bdca065a$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex gap="xs" flexDirection="column" .padding=',
        ">\n        ",
        " ",
        " ",
        "\n        ",
        "\n      </wui-flex>\n    "
    ]);
    $a56df302bdca065a$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $a56df302bdca065a$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '<wui-list-item\n      variant="icon"\n      icon="chromeStore"\n      iconVariant="square"\n      @click=',
        '\n      chevron\n    >\n      <wui-text variant="paragraph-500" color="fg-100">Chrome Extension</wui-text>\n    </wui-list-item>'
    ]);
    $a56df302bdca065a$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $a56df302bdca065a$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '<wui-list-item\n      variant="icon"\n      icon="appStore"\n      iconVariant="square"\n      @click=',
        '\n      chevron\n    >\n      <wui-text variant="paragraph-500" color="fg-100">iOS App</wui-text>\n    </wui-list-item>'
    ]);
    $a56df302bdca065a$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $a56df302bdca065a$var$_templateObject3() {
    var data = (0, $j06k0._)([
        '<wui-list-item\n      variant="icon"\n      icon="playStore"\n      iconVariant="square"\n      @click=',
        '\n      chevron\n    >\n      <wui-text variant="paragraph-500" color="fg-100">Android App</wui-text>\n    </wui-list-item>'
    ]);
    $a56df302bdca065a$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $a56df302bdca065a$var$_templateObject4() {
    var data = (0, $j06k0._)([
        '\n      <wui-list-item\n        variant="icon"\n        icon="browser"\n        iconVariant="square-blue"\n        @click=',
        '\n        chevron\n      >\n        <wui-text variant="paragraph-500" color="fg-100">Website</wui-text>\n      </wui-list-item>\n    '
    ]);
    $a56df302bdca065a$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
var $a56df302bdca065a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a56df302bdca065a$export$72485cd62e8c17e7 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mDownloadsView, LitElement);
    var _super = (0, $ohfOJ._)(W3mDownloadsView);
    function W3mDownloadsView() {
        (0, $4GJKx._)(this, W3mDownloadsView);
        var _this;
        var _RouterController_state_data;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.wallet = (_RouterController_state_data = (0, $iptjJ.RouterController).state.data) === null || _RouterController_state_data === void 0 ? void 0 : _RouterController_state_data.wallet;
        return _this;
    }
    (0, $1wc17._)(W3mDownloadsView, [
        {
            key: "render",
            value: function render() {
                if (!this.wallet) throw new Error("w3m-downloads-view");
                return (0, $hxyOZ.html)($a56df302bdca065a$var$_templateObject(), [
                    "s",
                    "s",
                    "l",
                    "s"
                ], this.chromeTemplate(), this.iosTemplate(), this.androidTemplate(), this.homepageTemplate());
            }
        },
        {
            key: "chromeTemplate",
            value: function chromeTemplate() {
                var _this_wallet;
                if (!((_this_wallet = this.wallet) === null || _this_wallet === void 0 ? void 0 : _this_wallet.chrome_store)) return null;
                return (0, $hxyOZ.html)($a56df302bdca065a$var$_templateObject1(), this.onChromeStore.bind(this));
            }
        },
        {
            key: "iosTemplate",
            value: function iosTemplate() {
                var _this_wallet;
                if (!((_this_wallet = this.wallet) === null || _this_wallet === void 0 ? void 0 : _this_wallet.app_store)) return null;
                return (0, $hxyOZ.html)($a56df302bdca065a$var$_templateObject2(), this.onAppStore.bind(this));
            }
        },
        {
            key: "androidTemplate",
            value: function androidTemplate() {
                var _this_wallet;
                if (!((_this_wallet = this.wallet) === null || _this_wallet === void 0 ? void 0 : _this_wallet.play_store)) return null;
                return (0, $hxyOZ.html)($a56df302bdca065a$var$_templateObject3(), this.onPlayStore.bind(this));
            }
        },
        {
            key: "homepageTemplate",
            value: function homepageTemplate() {
                var _this_wallet;
                if (!((_this_wallet = this.wallet) === null || _this_wallet === void 0 ? void 0 : _this_wallet.homepage)) return null;
                return (0, $hxyOZ.html)($a56df302bdca065a$var$_templateObject4(), this.onHomePage.bind(this));
            }
        },
        {
            key: "onChromeStore",
            value: function onChromeStore() {
                var _this_wallet;
                if ((_this_wallet = this.wallet) === null || _this_wallet === void 0 ? void 0 : _this_wallet.chrome_store) (0, $hZBJb.CoreHelperUtil).openHref(this.wallet.chrome_store, "_blank");
            }
        },
        {
            key: "onAppStore",
            value: function onAppStore() {
                var _this_wallet;
                if ((_this_wallet = this.wallet) === null || _this_wallet === void 0 ? void 0 : _this_wallet.app_store) (0, $hZBJb.CoreHelperUtil).openHref(this.wallet.app_store, "_blank");
            }
        },
        {
            key: "onPlayStore",
            value: function onPlayStore() {
                var _this_wallet;
                if ((_this_wallet = this.wallet) === null || _this_wallet === void 0 ? void 0 : _this_wallet.play_store) (0, $hZBJb.CoreHelperUtil).openHref(this.wallet.play_store, "_blank");
            }
        },
        {
            key: "onHomePage",
            value: function onHomePage() {
                var _this_wallet;
                if ((_this_wallet = this.wallet) === null || _this_wallet === void 0 ? void 0 : _this_wallet.homepage) (0, $hZBJb.CoreHelperUtil).openHref(this.wallet.homepage, "_blank");
            }
        }
    ]);
    return W3mDownloadsView;
}((0, $2yD3e.LitElement));
$a56df302bdca065a$export$72485cd62e8c17e7 = $a56df302bdca065a$var$__decorate([
    (0, $hdxb6.customElement)("w3m-downloads-view")
], $a56df302bdca065a$export$72485cd62e8c17e7);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $c6Xmf = parcelRequire("c6Xmf");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $hZBJb = parcelRequire("hZBJb");
var $hMdcG = parcelRequire("hMdcG");
var $faNff = parcelRequire("faNff");
var $khm6W = parcelRequire("khm6W");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");

function $6879a44227f948dd$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column" .padding=',
        ' gap="xs">\n        ',
        '\n        <wui-list-wallet\n          name="Explore all"\n          showAllWallets\n          walletIcon="allWallets"\n          icon="externalLink"\n          @click=',
        "\n        ></wui-list-wallet>\n      </wui-flex>\n    "
    ]);
    $6879a44227f948dd$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $6879a44227f948dd$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "\n        <wui-list-wallet\n          name=",
        '\n          tagVariant="main"\n          imageSrc=',
        "\n          @click=",
        "\n        ></wui-list-wallet>\n      "
    ]);
    $6879a44227f948dd$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $6879a44227f948dd$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $6879a44227f948dd$var$EXPLORER = "https://walletconnect.com/explorer";
var $6879a44227f948dd$export$24ca15e036ec0442 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mGetWalletView, LitElement);
    var _super = (0, $ohfOJ._)(W3mGetWalletView);
    function W3mGetWalletView() {
        (0, $4GJKx._)(this, W3mGetWalletView);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(W3mGetWalletView, [
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($6879a44227f948dd$var$_templateObject(), [
                    "0",
                    "s",
                    "s",
                    "s"
                ], this.recommendedWalletsTemplate(), function() {
                    (0, $hZBJb.CoreHelperUtil).openHref("https://walletconnect.com/explorer?type=wallet", "_blank");
                });
            }
        },
        {
            key: "recommendedWalletsTemplate",
            value: function recommendedWalletsTemplate() {
                var _ApiController_state = (0, $hMdcG.ApiController).state, recommended = _ApiController_state.recommended, featured = _ApiController_state.featured;
                var customWallets = (0, $faNff.OptionsController).state.customWallets;
                var wallets = (0, $c6Xmf._)(featured).concat((0, $c6Xmf._)(customWallets !== null && customWallets !== void 0 ? customWallets : []), (0, $c6Xmf._)(recommended)).slice(0, 4);
                return wallets.map(function(wallet) {
                    var _wallet_name;
                    return (0, $hxyOZ.html)($6879a44227f948dd$var$_templateObject1(), (_wallet_name = wallet.name) !== null && _wallet_name !== void 0 ? _wallet_name : "Unknown", (0, $696d14fc702af3d6$export$f68dd208b5df064d)((0, $khm6W.AssetUtil).getWalletImage(wallet)), function() {
                        var _wallet_homepage;
                        (0, $hZBJb.CoreHelperUtil).openHref((_wallet_homepage = wallet.homepage) !== null && _wallet_homepage !== void 0 ? _wallet_homepage : $6879a44227f948dd$var$EXPLORER, "_blank");
                    });
                });
            }
        }
    ]);
    return W3mGetWalletView;
}((0, $2yD3e.LitElement));
$6879a44227f948dd$export$24ca15e036ec0442 = $6879a44227f948dd$var$__decorate([
    (0, $hdxb6.customElement)("w3m-get-wallet-view")
], $6879a44227f948dd$export$24ca15e036ec0442);



var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $04RAu = parcelRequire("04RAu");

var $b8Rim = parcelRequire("b8Rim");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $04kNM = parcelRequire("04kNM");
var $334Pv = parcelRequire("334Pv");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $017999b82bfd022c$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  wui-flex {\n    width: 100%;\n  }\n\n  .suggestion {\n    background: var(--wui-color-gray-glass-002);\n    border-radius: var(--wui-border-radius-xs);\n  }\n\n  .suggestion:hover {\n    background-color: var(--wui-color-gray-glass-005);\n    cursor: pointer;\n  }\n\n  .suggested-name {\n    max-width: 75%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  form {\n    width: 100%;\n  }\n\n  wui-icon-link {\n    position: absolute;\n    right: 20px;\n    transform: translateY(11px);\n  }\n"
    ]);
    $017999b82bfd022c$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $017999b82bfd022c$export$2e2bcd8739ae039 = (0, $2D5eP.css)($017999b82bfd022c$var$_templateObject());



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $cv9Rk = parcelRequire("cv9Rk");

var $ohfOJ = parcelRequire("ohfOJ");

var $hxyOZ = parcelRequire("hxyOZ");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $04RAu = parcelRequire("04RAu");

var $b8Rim = parcelRequire("b8Rim");

var $dcsZi = parcelRequire("dcsZi");

var $3U0IP = parcelRequire("3U0IP");

var $c6Xmf = parcelRequire("c6Xmf");

var $ohfOJ = parcelRequire("ohfOJ");

var $hxyOZ = parcelRequire("hxyOZ");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $4174d5e9064793ea$var$et = (0, $hxyOZ._$LH).I, $4174d5e9064793ea$export$c3825b437cbdea5c = function(o) {
    return null === o || "object" != typeof o && "function" != typeof o;
}, $4174d5e9064793ea$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2,
    MATHML: 3
}, $4174d5e9064793ea$export$6b6d145ec2a44ca9 = function(o, t) {
    return void 0 === t ? void 0 !== (o === null || o === void 0 ? void 0 : o._$litType$) : (o === null || o === void 0 ? void 0 : o._$litType$) === t;
}, $4174d5e9064793ea$export$6a0e8de894d2fcca = function(o) {
    var _o__$litType$;
    return null != (o === null || o === void 0 ? void 0 : (_o__$litType$ = o._$litType$) === null || _o__$litType$ === void 0 ? void 0 : _o__$litType$.h);
}, $4174d5e9064793ea$export$2f448fec17d50a3e = function(o) {
    return void 0 !== (o === null || o === void 0 ? void 0 : o._$litDirective$);
}, $4174d5e9064793ea$export$f28e31de6a6eaf32 = function(o) {
    return o === null || o === void 0 ? void 0 : o._$litDirective$;
}, $4174d5e9064793ea$export$7f431ad0fff82fd9 = function(o) {
    return void 0 === o.strings;
}, $4174d5e9064793ea$var$lt = function() {
    return document.createComment("");
}, $4174d5e9064793ea$export$291b2338ad9b0b30 = function(o, t, i) {
    var n = o._$AA.parentNode, e = void 0 === t ? o._$AB : t._$AA;
    if (void 0 === i) {
        var _$t = n.insertBefore($4174d5e9064793ea$var$lt(), e), l = n.insertBefore($4174d5e9064793ea$var$lt(), e);
        i = new $4174d5e9064793ea$var$et(_$t, l, o, o.options);
    } else {
        var _$t1 = i._$AB.nextSibling, l1 = i._$AM, c = l1 !== o;
        if (c) {
            var _i__$AQ;
            var _$t2;
            (_i__$AQ = i._$AQ) === null || _i__$AQ === void 0 ? void 0 : _i__$AQ.call(i, o), i._$AM = o, void 0 !== i._$AP && (_$t2 = o._$AU) !== l1._$AU && i._$AP(_$t2);
        }
        if (_$t1 !== e || c) {
            var _$o = i._$AA;
            for(; _$o !== _$t1;){
                var _$t3 = _$o.nextSibling;
                n.insertBefore(_$o, e), _$o = _$t3;
            }
        }
    }
    return i;
}, $4174d5e9064793ea$export$cb8bf9562088e9f4 = function(o, t) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : o;
    return o._$AI(t, i), o;
}, $4174d5e9064793ea$var$ht = {}, $4174d5e9064793ea$export$ea70d9dd5965b1c8 = function(o) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $4174d5e9064793ea$var$ht;
    return o._$AH = t;
}, $4174d5e9064793ea$export$59e9bce518cde500 = function(o) {
    return o._$AH;
}, $4174d5e9064793ea$export$3133b3144bbba267 = function(o) {
    var _o__$AP;
    (_o__$AP = o._$AP) === null || _o__$AP === void 0 ? void 0 : _o__$AP.call(o, !1, !0);
    var t = o._$AA;
    var i = o._$AB.nextSibling;
    for(; t !== i;){
        var _$o = t.nextSibling;
        t.remove(), t = _$o;
    }
}, $4174d5e9064793ea$export$7f600b8138c094dc = function(o) {
    o._$AR();
};


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ 
var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $c6Xmf = parcelRequire("c6Xmf");
var $b02bdafd45ff6d1e$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $b02bdafd45ff6d1e$export$99b43ad1ed32e735 = function(t) {
    return function() {
        for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
            e[_key] = arguments[_key];
        }
        return {
            _$litDirective$: t,
            values: e
        };
    };
};
var $b02bdafd45ff6d1e$export$befdefbdce210f91 = /*#__PURE__*/ function() {
    "use strict";
    function i(t) {
        (0, $4GJKx._)(this, i);
    }
    (0, $1wc17._)(i, [
        {
            key: "_$AU",
            get: function get() {
                return this._$AM._$AU;
            }
        },
        {
            key: "_$AT",
            value: function _$AT(t, e, i) {
                this.t = t, this._$AM = e, this.i = i;
            }
        },
        {
            key: "_$AS",
            value: function _$AS(t, e) {
                return this.update(t, e);
            }
        },
        {
            key: "update",
            value: function update(t, e) {
                return this.render.apply(this, (0, $c6Xmf._)(e));
            }
        }
    ]);
    return i;
}();


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $193ec853b9b64c9e$var$mt = function(i, t) {
    var _i__$AO;
    var e = i._$AN;
    if (void 0 === e) return !1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _$i = _step.value;
            (_i__$AO = _$i._$AO) === null || _i__$AO === void 0 ? void 0 : _i__$AO.call(_$i, t, !1), $193ec853b9b64c9e$var$mt(_$i, t);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return !0;
}, $193ec853b9b64c9e$var$_t = function(i) {
    var t, e;
    do {
        if (void 0 === (t = i._$AM)) break;
        e = t._$AN, e.delete(i), i = t;
    }while (0 === (e === null || e === void 0 ? void 0 : e.size));
}, $193ec853b9b64c9e$var$wt = function(i) {
    for(var t; t = i._$AM; i = t){
        var e = t._$AN;
        if (void 0 === e) t._$AN = e = new Set;
        else if (e.has(i)) break;
        e.add(i), $193ec853b9b64c9e$var$gt(t);
    }
};
function $193ec853b9b64c9e$var$bt(i) {
    void 0 !== this._$AN ? ($193ec853b9b64c9e$var$_t(this), this._$AM = i, $193ec853b9b64c9e$var$wt(this)) : this._$AM = i;
}
function $193ec853b9b64c9e$var$yt(i) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var s = this._$AH, o = this._$AN;
    if (void 0 !== o && 0 !== o.size) {
        if (t) {
            if (Array.isArray(s)) for(var _$i = e; _$i < s.length; _$i++)$193ec853b9b64c9e$var$mt(s[_$i], !1), $193ec853b9b64c9e$var$_t(s[_$i]);
            else null != s && ($193ec853b9b64c9e$var$mt(s, !1), $193ec853b9b64c9e$var$_t(s));
        } else $193ec853b9b64c9e$var$mt(this, i);
    }
}
var $193ec853b9b64c9e$var$gt = function(i) {
    var _i, _i1;
    var __$AP, __$AQ;
    i.type == (0, $b02bdafd45ff6d1e$export$9ba3b3f20a85bfa).CHILD && ((__$AP = (_i = i)._$AP) !== null && __$AP !== void 0 ? __$AP : _i._$AP = $193ec853b9b64c9e$var$yt, (__$AQ = (_i1 = i)._$AQ) !== null && __$AQ !== void 0 ? __$AQ : _i1._$AQ = $193ec853b9b64c9e$var$bt);
};
var $193ec853b9b64c9e$export$7d025501802325e = /*#__PURE__*/ function(i) {
    "use strict";
    (0, $dcsZi._)($t, i);
    var _super = (0, $ohfOJ._)($t);
    function $t() {
        (0, $4GJKx._)(this, $t);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments))), _this._$AN = void 0;
        return (0, $3U0IP._)(_this);
    }
    (0, $1wc17._)($t, [
        {
            key: "_$AT",
            value: function _$AT(i, t, e) {
                (0, $04RAu._)((0, $b8Rim._)($t.prototype), "_$AT", this).call(this, i, t, e), $193ec853b9b64c9e$var$wt(this), this.isConnected = i._$AU;
            }
        },
        {
            key: "_$AO",
            value: function _$AO(i) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
                var _this_reconnected, _this, _this_disconnected, _this1;
                i !== this.isConnected && (this.isConnected = i, i ? (_this_reconnected = (_this = this).reconnected) === null || _this_reconnected === void 0 ? void 0 : _this_reconnected.call(_this) : (_this_disconnected = (_this1 = this).disconnected) === null || _this_disconnected === void 0 ? void 0 : _this_disconnected.call(_this1)), t && ($193ec853b9b64c9e$var$mt(this, i), $193ec853b9b64c9e$var$_t(this));
            }
        },
        {
            key: "setValue",
            value: function setValue(i) {
                if ((0, $4174d5e9064793ea$export$7f431ad0fff82fd9)(this.t)) this.t._$AI(i, this);
                else {
                    var t = (0, $c6Xmf._)(this.t._$AH);
                    t[this.i] = i, this.t._$AI(t, this, 0);
                }
            }
        },
        {
            key: "disconnected",
            value: function disconnected() {}
        },
        {
            key: "reconnected",
            value: function reconnected() {}
        }
    ]);
    return $t;
}((0, $b02bdafd45ff6d1e$export$befdefbdce210f91));



/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $89642349f29deca8$export$7d1e3a5e95ceca43 = function() {
    return new $89642349f29deca8$var$Zt;
};
var $89642349f29deca8$var$Zt = function Zt() {
    "use strict";
    (0, $4GJKx._)(this, Zt);
};
var $89642349f29deca8$var$qt = new WeakMap, $89642349f29deca8$export$eff4d24c3ff7876e = (0, $b02bdafd45ff6d1e$export$99b43ad1ed32e735)(/*#__PURE__*/ function($t) {
    "use strict";
    (0, $dcsZi._)(_class, $t);
    var _super = (0, $ohfOJ._)(_class);
    function _class() {
        (0, $4GJKx._)(this, _class);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(_class, [
        {
            key: "render",
            value: function render(t) {
                return 0, $hxyOZ.nothing;
            }
        },
        {
            key: "update",
            value: function update(t, param) {
                var _param = (0, $cv9Rk._)(param, 1), i = _param[0];
                var _t_options;
                var s = i !== this.Y;
                return s && void 0 !== this.Y && this.rt(void 0), (s || this.lt !== this.ct) && (this.Y = i, this.ht = (_t_options = t.options) === null || _t_options === void 0 ? void 0 : _t_options.host, this.rt(this.ct = t.element)), $hxyOZ.nothing;
            }
        },
        {
            key: "rt",
            value: function rt(t) {
                if (this.isConnected || (t = void 0), "function" == typeof this.Y) {
                    var _this_ht;
                    var i = (_this_ht = this.ht) !== null && _this_ht !== void 0 ? _this_ht : globalThis;
                    var s = $89642349f29deca8$var$qt.get(i);
                    void 0 === s && (s = new WeakMap, $89642349f29deca8$var$qt.set(i, s)), void 0 !== s.get(this.Y) && this.Y.call(this.ht, void 0), s.set(this.Y, t), void 0 !== t && this.Y.call(this.ht, t);
                } else this.Y.value = t;
            }
        },
        {
            key: "lt",
            get: function get() {
                var _qt_get, _this_Y;
                var _this_ht;
                return "function" == typeof this.Y ? (_qt_get = $89642349f29deca8$var$qt.get((_this_ht = this.ht) !== null && _this_ht !== void 0 ? _this_ht : globalThis)) === null || _qt_get === void 0 ? void 0 : _qt_get.get(this.Y) : (_this_Y = this.Y) === null || _this_Y === void 0 ? void 0 : _this_Y.value;
            }
        },
        {
            key: "disconnected",
            value: function disconnected() {
                this.lt === this.ct && this.rt(void 0);
            }
        },
        {
            key: "reconnected",
            value: function reconnected() {
                this.rt(this.ct);
            }
        }
    ]);
    return _class;
}((0, $193ec853b9b64c9e$export$7d025501802325e)));




parcelRequire("cwWZ7");
var $kOW8v = parcelRequire("kOW8v");
var $dMLJP = parcelRequire("dMLJP");
var $hZBJb = parcelRequire("hZBJb");
var $1QDT9 = parcelRequire("1QDT9");
var $8FcCV = parcelRequire("8FcCV");
parcelRequire("hsyMZ");
var $cSJ4o = parcelRequire("cSJ4o");
function $dfd3f52ef5612117$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex\n        flexDirection="column"\n        alignItems="center"\n        gap="m"\n        .padding=',
        "\n      >\n        <form ",
        " @submit=",
        ">\n          <wui-ens-input\n            @inputChange=",
        "\n            .errorMessage=",
        "\n            .value=",
        "\n          >\n          </wui-ens-input>\n          ",
        '\n          <input type="submit" hidden />\n        </form>\n        ',
        "\n      </wui-flex>\n    "
    ]);
    $dfd3f52ef5612117$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $dfd3f52ef5612117$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '\n          <wui-icon-link\n            size="sm"\n            icon="chevronRight"\n            iconcolor="accent-100"\n            @click=',
        "\n          >\n          </wui-icon-link>\n        "
    ]);
    $dfd3f52ef5612117$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $dfd3f52ef5612117$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '<wui-loading-spinner size="lg" color="fg-100"></wui-loading-spinner>'
    ]);
    $dfd3f52ef5612117$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $dfd3f52ef5612117$var$_templateObject3() {
    var data = (0, $j06k0._)([
        '<wui-tag variant="shade" size="lg">Registered</wui-tag>'
    ]);
    $dfd3f52ef5612117$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $dfd3f52ef5612117$var$_templateObject4() {
    var data = (0, $j06k0._)([
        '<wui-tag variant="success" size="lg">Available</wui-tag>'
    ]);
    $dfd3f52ef5612117$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $dfd3f52ef5612117$var$_templateObject5() {
    var data = (0, $j06k0._)([
        '<wui-flex flexDirection="column" gap="xxs" alignItems="center">\n      <wui-flex\n        data-testid="account-name-suggestion"\n        .padding=',
        '\n        justifyContent="space-between"\n        class="suggestion"\n      >\n        <wui-text color="fg-100" variant="paragraph-400" class="suggested-name">\n          ',
        "</wui-text\n        >",
        "\n      </wui-flex>\n      ",
        "\n    </wui-flex>"
    ]);
    $dfd3f52ef5612117$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $dfd3f52ef5612117$var$_templateObject6() {
    var data = (0, $j06k0._)([
        ' <wui-flex\n      data-testid="account-name-suggestion"\n      .padding=',
        '\n      justifyContent="space-between"\n      class="suggestion"\n      @click=',
        '\n    >\n      <wui-text color="fg-100" variant="paragraph-400" class="suggested-name">\n        ',
        '\n      </wui-text>\n      <wui-tag variant="success" size="lg">Available</wui-tag>\n    </wui-flex>'
    ]);
    $dfd3f52ef5612117$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
var $dfd3f52ef5612117$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $dfd3f52ef5612117$export$4bdeb34003c74fa7 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mRegisterAccountNameView, LitElement);
    var _super = (0, $ohfOJ._)(W3mRegisterAccountNameView);
    function W3mRegisterAccountNameView() {
        var _this_usubscribe;
        (0, $4GJKx._)(this, W3mRegisterAccountNameView);
        var _this;
        _this = _super.call(this);
        _this.formRef = (0, $89642349f29deca8$export$7d1e3a5e95ceca43)();
        _this.usubscribe = [];
        _this.name = "";
        _this.error = "";
        _this.loading = (0, $kOW8v.EnsController).state.loading;
        _this.suggestions = (0, $kOW8v.EnsController).state.suggestions;
        _this.registered = false;
        _this.profileName = (0, $dMLJP.AccountController).state.profileName;
        _this.onDebouncedNameInputChange = (0, $hZBJb.CoreHelperUtil).debounce(function(value) {
            if ((0, $kOW8v.EnsController).validateName(value)) {
                _this.error = "";
                _this.name = value;
                (0, $kOW8v.EnsController).getSuggestions(value);
                (0, $kOW8v.EnsController).isNameRegistered(value).then(function(registered) {
                    _this.registered = registered;
                });
            } else if (value.length < 4) _this.error = "Name must be at least 4 characters long";
            else _this.error = "Can only contain letters, numbers and - characters";
        });
        (_this_usubscribe = _this.usubscribe).push.apply(_this_usubscribe, [
            (0, $kOW8v.EnsController).subscribe(function(val) {
                _this.suggestions = val.suggestions;
                _this.loading = val.loading;
            }),
            (0, $dMLJP.AccountController).subscribeKey("profileName", function(val) {
                _this.profileName = val;
                if (val) _this.error = "You already own a name";
            })
        ]);
        return _this;
    }
    (0, $1wc17._)(W3mRegisterAccountNameView, [
        {
            key: "firstUpdated",
            value: function firstUpdated() {
                var _this_formRef_value;
                (_this_formRef_value = this.formRef.value) === null || _this_formRef_value === void 0 ? void 0 : _this_formRef_value.addEventListener("keydown", this.onEnterKey.bind(this));
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                var _this_formRef_value;
                (0, $04RAu._)((0, $b8Rim._)(W3mRegisterAccountNameView.prototype), "disconnectedCallback", this).call(this);
                this.usubscribe.forEach(function(unsub) {
                    return unsub();
                });
                (_this_formRef_value = this.formRef.value) === null || _this_formRef_value === void 0 ? void 0 : _this_formRef_value.removeEventListener("keydown", this.onEnterKey.bind(this));
            }
        },
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($dfd3f52ef5612117$var$_templateObject(), [
                    "0",
                    "s",
                    "m",
                    "s"
                ], (0, $89642349f29deca8$export$eff4d24c3ff7876e)(this.formRef), this.onSubmitName.bind(this), this.onNameInputChange.bind(this), this.error, this.name, this.submitButtonTemplate(), this.templateSuggestions());
            }
        },
        {
            key: "submitButtonTemplate",
            value: function submitButtonTemplate() {
                var showSubmit = this.isAllowedToSubmit();
                return showSubmit ? (0, $hxyOZ.html)($dfd3f52ef5612117$var$_templateObject1(), this.onSubmitName.bind(this)) : null;
            }
        },
        {
            key: "onSelectSuggestion",
            value: function onSelectSuggestion(name) {
                var _this = this;
                return function() {
                    _this.name = name;
                    _this.registered = false;
                    _this.requestUpdate();
                };
            }
        },
        {
            key: "onNameInputChange",
            value: function onNameInputChange(event) {
                this.onDebouncedNameInputChange(event.detail);
            }
        },
        {
            key: "nameSuggestionTagTemplate",
            value: function nameSuggestionTagTemplate() {
                if (this.loading) return (0, $hxyOZ.html)($dfd3f52ef5612117$var$_templateObject2());
                return this.registered ? (0, $hxyOZ.html)($dfd3f52ef5612117$var$_templateObject3()) : (0, $hxyOZ.html)($dfd3f52ef5612117$var$_templateObject4());
            }
        },
        {
            key: "templateSuggestions",
            value: function templateSuggestions() {
                var _this = this;
                if (!this.name || this.name.length < 4 || this.error) return null;
                var suggestions = this.registered ? this.suggestions.filter(function(s) {
                    return s.name !== _this.name;
                }) : [];
                return (0, $hxyOZ.html)($dfd3f52ef5612117$var$_templateObject5(), [
                    "m",
                    "m",
                    "m",
                    "m"
                ], this.name, this.nameSuggestionTagTemplate(), suggestions.map(function(suggestion) {
                    return _this.availableNameTemplate(suggestion.name);
                }));
            }
        },
        {
            key: "availableNameTemplate",
            value: function availableNameTemplate(suggestion) {
                return (0, $hxyOZ.html)($dfd3f52ef5612117$var$_templateObject6(), [
                    "m",
                    "m",
                    "m",
                    "m"
                ], this.onSelectSuggestion(suggestion), suggestion);
            }
        },
        {
            key: "isAllowedToSubmit",
            value: function isAllowedToSubmit() {
                return !this.loading && !this.registered && !this.error && !this.profileName && (0, $kOW8v.EnsController).validateName(this.name);
            }
        },
        {
            key: "onSubmitName",
            value: function onSubmitName() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                if (!_this.isAllowedToSubmit()) return [
                                    2
                                ];
                                (0, $1QDT9.EventsController).sendEvent({
                                    type: "track",
                                    event: "REGISTER_NAME_INITIATED",
                                    properties: {
                                        isSmartAccount: (0, $dMLJP.AccountController).state.preferredAccountType === (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT,
                                        ensName: _this.name
                                    }
                                });
                                return [
                                    4,
                                    (0, $kOW8v.EnsController).registerName(_this.name)
                                ];
                            case 1:
                                _state.sent();
                                (0, $1QDT9.EventsController).sendEvent({
                                    type: "track",
                                    event: "REGISTER_NAME_SUCCESS",
                                    properties: {
                                        isSmartAccount: (0, $dMLJP.AccountController).state.preferredAccountType === (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT,
                                        ensName: _this.name
                                    }
                                });
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                error = _state.sent();
                                (0, $8FcCV.SnackController).showError(error.message);
                                (0, $1QDT9.EventsController).sendEvent({
                                    type: "track",
                                    event: "REGISTER_NAME_ERROR",
                                    properties: {
                                        isSmartAccount: (0, $dMLJP.AccountController).state.preferredAccountType === (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT,
                                        ensName: _this.name,
                                        error: (error === null || error === void 0 ? void 0 : error.message) || "Unknown error"
                                    }
                                });
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onEnterKey",
            value: function onEnterKey(event) {
                if (event.key === "Enter" && this.isAllowedToSubmit()) this.onSubmitName();
            }
        }
    ]);
    return W3mRegisterAccountNameView;
}((0, $2yD3e.LitElement));
$dfd3f52ef5612117$export$4bdeb34003c74fa7.styles = (0, $017999b82bfd022c$export$2e2bcd8739ae039);
$dfd3f52ef5612117$var$__decorate([
    (0, $04kNM.property)()
], $dfd3f52ef5612117$export$4bdeb34003c74fa7.prototype, "errorMessage", void 0);
$dfd3f52ef5612117$var$__decorate([
    (0, $334Pv.state)()
], $dfd3f52ef5612117$export$4bdeb34003c74fa7.prototype, "name", void 0);
$dfd3f52ef5612117$var$__decorate([
    (0, $334Pv.state)()
], $dfd3f52ef5612117$export$4bdeb34003c74fa7.prototype, "error", void 0);
$dfd3f52ef5612117$var$__decorate([
    (0, $334Pv.state)()
], $dfd3f52ef5612117$export$4bdeb34003c74fa7.prototype, "loading", void 0);
$dfd3f52ef5612117$var$__decorate([
    (0, $334Pv.state)()
], $dfd3f52ef5612117$export$4bdeb34003c74fa7.prototype, "suggestions", void 0);
$dfd3f52ef5612117$var$__decorate([
    (0, $334Pv.state)()
], $dfd3f52ef5612117$export$4bdeb34003c74fa7.prototype, "registered", void 0);
$dfd3f52ef5612117$var$__decorate([
    (0, $334Pv.state)()
], $dfd3f52ef5612117$export$4bdeb34003c74fa7.prototype, "profileName", void 0);
$dfd3f52ef5612117$export$4bdeb34003c74fa7 = $dfd3f52ef5612117$var$__decorate([
    (0, $hdxb6.customElement)("w3m-register-account-name-view")
], $dfd3f52ef5612117$export$4bdeb34003c74fa7);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("cwWZ7");
var $hZBJb = parcelRequire("hZBJb");
var $iptjJ = parcelRequire("iptjJ");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $3d110978612eab89$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  .continue-button-container {\n    width: 100%;\n  }\n"
    ]);
    $3d110978612eab89$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $3d110978612eab89$export$2e2bcd8739ae039 = (0, $2D5eP.css)($3d110978612eab89$var$_templateObject());


parcelRequire("dSKxG");
var $ejaSv = parcelRequire("ejaSv");
function $225cff03d788ea3c$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex\n        flexDirection="column"\n        alignItems="center"\n        gap="xxl"\n        .padding=',
        "\n      >\n        ",
        " ",
        "\n        <wui-link\n          @click=",
        '\n        >\n          Learn more\n          <wui-icon color="inherit" slot="iconRight" name="externalLink"></wui-icon>\n        </wui-link>\n      </wui-flex>\n    '
    ]);
    $225cff03d788ea3c$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $225cff03d788ea3c$var$_templateObject1() {
    var data = (0, $j06k0._)([
        ' <wui-flex\n      flexDirection="column"\n      gap="xxl"\n      alignItems="center"\n      .padding=',
        '\n    >\n      <wui-flex gap="s" alignItems="center" justifyContent="center">\n        <wui-icon-box\n          size="xl"\n          iconcolor="success-100"\n          backgroundcolor="success-100"\n          icon="checkmark"\n          background="opaque"\n        ></wui-icon-box>\n      </wui-flex>\n      <wui-flex flexDirection="column" alignItems="center" gap="s">\n        <wui-text align="center" variant="medium-600" color="fg-100">\n          Account name chosen successfully\n        </wui-text>\n        <wui-text align="center" variant="paragraph-400" color="fg-100">\n          You can now fund your account and trade crypto\n        </wui-text>\n      </wui-flex>\n    </wui-flex>'
    ]);
    $225cff03d788ea3c$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $225cff03d788ea3c$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "<wui-flex\n      .padding=",
        '\n      gap="s"\n      class="continue-button-container"\n    >\n      <wui-button fullWidth size="lg" borderRadius="xs" @click=',
        "\n        >Let's Go!\n      </wui-button>\n    </wui-flex>"
    ]);
    $225cff03d788ea3c$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $225cff03d788ea3c$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $225cff03d788ea3c$export$ee9fc061481b900a = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mRegisterAccountNameSuccess, LitElement);
    var _super = (0, $ohfOJ._)(W3mRegisterAccountNameSuccess);
    function W3mRegisterAccountNameSuccess() {
        (0, $4GJKx._)(this, W3mRegisterAccountNameSuccess);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(W3mRegisterAccountNameSuccess, [
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($225cff03d788ea3c$var$_templateObject(), [
                    "0",
                    "0",
                    "l",
                    "0"
                ], this.onboardingTemplate(), this.buttonsTemplate(), function() {
                    (0, $hZBJb.CoreHelperUtil).openHref((0, $ejaSv.NavigationUtil).URLS.FAQ, "_blank");
                });
            }
        },
        {
            key: "onboardingTemplate",
            value: function onboardingTemplate() {
                return (0, $hxyOZ.html)($225cff03d788ea3c$var$_templateObject1(), [
                    "0",
                    "xxl",
                    "0",
                    "xxl"
                ]);
            }
        },
        {
            key: "buttonsTemplate",
            value: function buttonsTemplate() {
                return (0, $hxyOZ.html)($225cff03d788ea3c$var$_templateObject2(), [
                    "0",
                    "2l",
                    "0",
                    "2l"
                ], this.redirectToAccount.bind(this));
            }
        },
        {
            key: "redirectToAccount",
            value: function redirectToAccount() {
                (0, $iptjJ.RouterController).replace("Account");
            }
        }
    ]);
    return W3mRegisterAccountNameSuccess;
}((0, $2yD3e.LitElement));
$225cff03d788ea3c$export$ee9fc061481b900a.styles = (0, $3d110978612eab89$export$2e2bcd8739ae039);
$225cff03d788ea3c$export$ee9fc061481b900a = $225cff03d788ea3c$var$__decorate([
    (0, $hdxb6.customElement)("w3m-register-account-name-success-view")
], $225cff03d788ea3c$export$ee9fc061481b900a);



var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("cwWZ7");
var $iptjJ = parcelRequire("iptjJ");
var $khm6W = parcelRequire("khm6W");
var $i7zcD = parcelRequire("i7zcD");
var $2qlRb = parcelRequire("2qlRb");
var $fPqxb = parcelRequire("fPqxb");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");


var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $b34b94ce146a38cc$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  @keyframes shake {\n    0% {\n      transform: translateX(0);\n    }\n    25% {\n      transform: translateX(3px);\n    }\n    50% {\n      transform: translateX(-3px);\n    }\n    75% {\n      transform: translateX(3px);\n    }\n    100% {\n      transform: translateX(0);\n    }\n  }\n\n  wui-flex:first-child:not(:only-child) {\n    position: relative;\n  }\n\n  wui-loading-hexagon {\n    position: absolute;\n  }\n\n  wui-icon-box {\n    position: absolute;\n    right: 4px;\n    bottom: 0;\n    opacity: 0;\n    transform: scale(0.5);\n    z-index: 1;\n  }\n\n  wui-button {\n    display: none;\n  }\n\n  [data-error='true'] wui-icon-box {\n    opacity: 1;\n    transform: scale(1);\n  }\n\n  [data-error='true'] > wui-flex:first-child {\n    animation: shake 250ms cubic-bezier(0.36, 0.07, 0.19, 0.97) both;\n  }\n\n  wui-button[data-retry='true'] {\n    display: block;\n    opacity: 1;\n  }\n"
    ]);
    $b34b94ce146a38cc$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $b34b94ce146a38cc$export$2e2bcd8739ae039 = (0, $2D5eP.css)($b34b94ce146a38cc$var$_templateObject());



var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");
parcelRequire("cwWZ7");
var $faNff = parcelRequire("faNff");
var $6a2RN = parcelRequire("6a2RN");

var $cfc345dac538f72b$export$79d00c05833eff69 = {
    onNetworkChange: /*#__PURE__*/ (0, $kSuI9._)(function() {
        var _SIWEController_state__client_options, _SIWEController_state__client, SIWEController;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(0, $faNff.OptionsController).state.isSiweEnabled) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (parcelRequire("jCIHD"))
                    ];
                case 1:
                    SIWEController = _state.sent().SIWEController;
                    if (!((_SIWEController_state__client = SIWEController.state._client) === null || _SIWEController_state__client === void 0 ? void 0 : (_SIWEController_state__client_options = _SIWEController_state__client.options) === null || _SIWEController_state__client_options === void 0 ? void 0 : _SIWEController_state__client_options.signOutOnNetworkChange)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        SIWEController.signOut()
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    (0, $6a2RN.RouterUtil).navigateAfterNetworkSwitch();
                    _state.label = 4;
                case 4:
                    return [
                        3,
                        6
                    ];
                case 5:
                    (0, $6a2RN.RouterUtil).navigateAfterNetworkSwitch();
                    _state.label = 6;
                case 6:
                    return [
                        2
                    ];
            }
        });
    })
};


function $d8c8f55ee47f47d0$var$_templateObject() {
    var data = (0, $j06k0._)([
        "<wui-loading-hexagon></wui-loading-hexagon>"
    ]);
    $d8c8f55ee47f47d0$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $d8c8f55ee47f47d0$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "\n      <wui-flex\n        data-error=",
        '\n        flexDirection="column"\n        alignItems="center"\n        .padding=',
        '\n        gap="xl"\n      >\n        <wui-flex justifyContent="center" alignItems="center">\n          <wui-network-image\n            size="lg"\n            imageSrc=',
        "\n          ></wui-network-image>\n\n          ",
        '\n\n          <wui-icon-box\n            backgroundColor="error-100"\n            background="opaque"\n            iconColor="error-100"\n            icon="close"\n            size="sm"\n            ?border=',
        '\n            borderColor="wui-color-bg-125"\n          ></wui-icon-box>\n        </wui-flex>\n\n        <wui-flex flexDirection="column" alignItems="center" gap="xs">\n          <wui-text align="center" variant="paragraph-500" color="fg-100">',
        '</wui-text>\n          <wui-text align="center" variant="small-500" color="fg-200">',
        "</wui-text>\n        </wui-flex>\n\n        <wui-button\n          data-retry=",
        '\n          variant="accent"\n          size="md"\n          .disabled=',
        "\n          @click=",
        '\n        >\n          <wui-icon color="inherit" slot="iconLeft" name="refresh"></wui-icon>\n          Try again\n        </wui-button>\n      </wui-flex>\n    '
    ]);
    $d8c8f55ee47f47d0$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $d8c8f55ee47f47d0$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d8c8f55ee47f47d0$export$d124f6a585588d61 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mNetworkSwitchView, LitElement);
    var _super = (0, $ohfOJ._)(W3mNetworkSwitchView);
    function W3mNetworkSwitchView() {
        (0, $4GJKx._)(this, W3mNetworkSwitchView);
        var _this;
        var _RouterController_state_data;
        _this = _super.call(this);
        _this.network = (_RouterController_state_data = (0, $iptjJ.RouterController).state.data) === null || _RouterController_state_data === void 0 ? void 0 : _RouterController_state_data.network;
        _this.unsubscribe = [];
        _this.showRetry = false;
        _this.error = false;
        return _this;
    }
    (0, $1wc17._)(W3mNetworkSwitchView, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "firstUpdated",
            value: function firstUpdated() {
                this.onSwitchNetwork();
            }
        },
        {
            key: "render",
            value: function render() {
                if (!this.network) throw new Error("w3m-network-switch-view: No network provided");
                this.onShowRetry();
                var label = this.getLabel();
                var subLabel = this.getSubLabel();
                return (0, $hxyOZ.html)($d8c8f55ee47f47d0$var$_templateObject1(), this.error, [
                    "3xl",
                    "xl",
                    "3xl",
                    "xl"
                ], (0, $696d14fc702af3d6$export$f68dd208b5df064d)((0, $khm6W.AssetUtil).getNetworkImage(this.network)), this.error ? null : (0, $hxyOZ.html)($d8c8f55ee47f47d0$var$_templateObject()), true, label, subLabel, this.showRetry, !this.error, this.onSwitchNetwork.bind(this));
            }
        },
        {
            key: "getSubLabel",
            value: function getSubLabel() {
                var type = (0, $i7zcD.StorageUtil).getConnectedConnector();
                var authConnector = (0, $2qlRb.ConnectorController).getAuthConnector();
                if (authConnector && type === "AUTH") return "";
                return this.error ? "Switch can be declined if chain is not supported by a wallet or previous request is still active" : "Accept connection request in your wallet";
            }
        },
        {
            key: "getLabel",
            value: function getLabel() {
                var _this_network;
                var type = (0, $i7zcD.StorageUtil).getConnectedConnector();
                var authConnector = (0, $2qlRb.ConnectorController).getAuthConnector();
                var _this_network_name;
                if (authConnector && type === "AUTH") return "Switching to ".concat((_this_network_name = (_this_network = this.network) === null || _this_network === void 0 ? void 0 : _this_network.name) !== null && _this_network_name !== void 0 ? _this_network_name : "Unknown", " network...");
                return this.error ? "Switch declined" : "Approve in wallet";
            }
        },
        {
            key: "onShowRetry",
            value: function onShowRetry() {
                if (this.error && !this.showRetry) {
                    var _this_shadowRoot;
                    this.showRetry = true;
                    var retryButton = (_this_shadowRoot = this.shadowRoot) === null || _this_shadowRoot === void 0 ? void 0 : _this_shadowRoot.querySelector("wui-button");
                    retryButton === null || retryButton === void 0 ? void 0 : retryButton.animate([
                        {
                            opacity: 0
                        },
                        {
                            opacity: 1
                        }
                    ], {
                        fill: "forwards",
                        easing: "ease"
                    });
                }
            }
        },
        {
            key: "onSwitchNetwork",
            value: function onSwitchNetwork() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    4,
                                    ,
                                    5
                                ]);
                                _this.error = false;
                                if (!_this.network) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    (0, $fPqxb.NetworkController).switchActiveNetwork(_this.network)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    (0, $cfc345dac538f72b$export$79d00c05833eff69).onNetworkChange()
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                e = _state.sent();
                                _this.error = true;
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return W3mNetworkSwitchView;
}((0, $2yD3e.LitElement));
$d8c8f55ee47f47d0$export$d124f6a585588d61.styles = (0, $b34b94ce146a38cc$export$2e2bcd8739ae039);
$d8c8f55ee47f47d0$var$__decorate([
    (0, $334Pv.state)()
], $d8c8f55ee47f47d0$export$d124f6a585588d61.prototype, "showRetry", void 0);
$d8c8f55ee47f47d0$var$__decorate([
    (0, $334Pv.state)()
], $d8c8f55ee47f47d0$export$d124f6a585588d61.prototype, "error", void 0);
$d8c8f55ee47f47d0$export$d124f6a585588d61 = $d8c8f55ee47f47d0$var$__decorate([
    (0, $hdxb6.customElement)("w3m-network-switch-view")
], $d8c8f55ee47f47d0$export$d124f6a585588d61);



var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("cwWZ7");
var $fPqxb = parcelRequire("fPqxb");
var $hZBJb = parcelRequire("hZBJb");
var $1QDT9 = parcelRequire("1QDT9");
var $iptjJ = parcelRequire("iptjJ");
var $khm6W = parcelRequire("khm6W");
var $9zDWP = parcelRequire("9zDWP");
var $dMLJP = parcelRequire("dMLJP");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");


var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $9ab7e2fc0d2216b8$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  .container {\n    max-height: 360px;\n    overflow: auto;\n  }\n\n  .container::-webkit-scrollbar {\n    display: none;\n  }\n"
    ]);
    $9ab7e2fc0d2216b8$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $9ab7e2fc0d2216b8$export$2e2bcd8739ae039 = (0, $2D5eP.css)($9ab7e2fc0d2216b8$var$_templateObject());



function $4e2ed48a2dc3f60e$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      ",
        '\n      <wui-flex\n        class="container"\n        .padding=',
        '\n        flexDirection="column"\n        gap="xs"\n      >\n        ',
        '\n      </wui-flex>\n\n      <wui-separator></wui-separator>\n\n      <wui-flex padding="s" flexDirection="column" gap="m" alignItems="center">\n        <wui-text variant="small-400" color="fg-300" align="center">\n          Your connected wallet may not support some of the networks available for this dApp\n        </wui-text>\n        <wui-link @click=',
        '>\n          <wui-icon size="xs" color="accent-100" slot="iconLeft" name="helpCircle"></wui-icon>\n          What is a network\n        </wui-link>\n      </wui-flex>\n    '
    ]);
    $4e2ed48a2dc3f60e$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $4e2ed48a2dc3f60e$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex gap="xs" .padding=',
        ">\n        <wui-input-text\n          @inputChange=",
        '\n          class="network-search-input"\n          size="md"\n          placeholder="Search network"\n          icon="search"\n        ></wui-input-text>\n      </wui-flex>\n    '
    ]);
    $4e2ed48a2dc3f60e$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $4e2ed48a2dc3f60e$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "\n        <wui-list-network\n          .selected=",
        "\n          imageSrc=",
        '\n          type="network"\n          name=',
        "\n          @click=",
        "\n          .disabled=",
        "\n          data-testid=",
        "\n        ></wui-list-network>\n      "
    ]);
    $4e2ed48a2dc3f60e$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $4e2ed48a2dc3f60e$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $4e2ed48a2dc3f60e$export$ff1f854e9d8d99b2 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mNetworksView, LitElement);
    var _super = (0, $ohfOJ._)(W3mNetworksView);
    function W3mNetworksView() {
        (0, $4GJKx._)(this, W3mNetworksView);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.network = (0, $fPqxb.NetworkController).state.caipNetwork;
        _this.requestedCaipNetworks = (0, $fPqxb.NetworkController).getRequestedCaipNetworks();
        _this.search = "";
        _this.onDebouncedSearch = (0, $hZBJb.CoreHelperUtil).debounce(function(value) {
            _this.search = value;
        }, 100);
        _this.unsubscribe.push((0, $fPqxb.NetworkController).subscribeKey("caipNetwork", function(val) {
            return _this.network = val;
        }));
        return _this;
    }
    (0, $1wc17._)(W3mNetworksView, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($4e2ed48a2dc3f60e$var$_templateObject(), this.templateSearchInput(), [
                    "0",
                    "s",
                    "s",
                    "s"
                ], this.networksTemplate(), this.onNetworkHelp.bind(this));
            }
        },
        {
            key: "templateSearchInput",
            value: function templateSearchInput() {
                return (0, $hxyOZ.html)($4e2ed48a2dc3f60e$var$_templateObject1(), [
                    "0",
                    "s",
                    "s",
                    "s"
                ], this.onInputChange.bind(this));
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(event) {
                this.onDebouncedSearch(event.detail);
            }
        },
        {
            key: "onNetworkHelp",
            value: function onNetworkHelp() {
                (0, $1QDT9.EventsController).sendEvent({
                    type: "track",
                    event: "CLICK_NETWORK_HELP"
                });
                (0, $iptjJ.RouterController).push("WhatIsANetwork");
            }
        },
        {
            key: "networksTemplate",
            value: function networksTemplate() {
                var _this = this;
                var _this_filteredNetworks;
                var requestedCaipNetworks = (0, $fPqxb.NetworkController).getRequestedCaipNetworks();
                var approvedCaipNetworkIds = (0, $fPqxb.NetworkController).state.approvedCaipNetworkIds;
                var supportsAllNetworks = (0, $fPqxb.NetworkController).state.supportsAllNetworks;
                var sortedNetworks = (0, $hZBJb.CoreHelperUtil).sortRequestedNetworks(approvedCaipNetworkIds, requestedCaipNetworks);
                if (this.search) this.filteredNetworks = sortedNetworks === null || sortedNetworks === void 0 ? void 0 : sortedNetworks.filter(function(network) {
                    var _network_name;
                    return network === null || network === void 0 ? void 0 : (_network_name = network.name) === null || _network_name === void 0 ? void 0 : _network_name.toLowerCase().includes(_this.search.toLowerCase());
                });
                else this.filteredNetworks = sortedNetworks;
                return (_this_filteredNetworks = this.filteredNetworks) === null || _this_filteredNetworks === void 0 ? void 0 : _this_filteredNetworks.map(function(network) {
                    var _this_network;
                    var _network_name, _network_name1;
                    return (0, $hxyOZ.html)($4e2ed48a2dc3f60e$var$_templateObject2(), ((_this_network = _this.network) === null || _this_network === void 0 ? void 0 : _this_network.id) === network.id, (0, $696d14fc702af3d6$export$f68dd208b5df064d)((0, $khm6W.AssetUtil).getNetworkImage(network)), (_network_name = network.name) !== null && _network_name !== void 0 ? _network_name : network.id, function() {
                        return _this.onSwitchNetwork(network);
                    }, !supportsAllNetworks && !(approvedCaipNetworkIds === null || approvedCaipNetworkIds === void 0 ? void 0 : approvedCaipNetworkIds.includes(network.id)) && network.chain === (0, $9zDWP.ChainController).state.activeChain, "w3m-network-switch-".concat((_network_name1 = network.name) !== null && _network_name1 !== void 0 ? _network_name1 : network.id));
                });
            }
        },
        {
            key: "onSwitchNetwork",
            value: function onSwitchNetwork(network) {
                return (0, $kSuI9._)(function() {
                    var isConnected, isNetworkChainConnected, approvedCaipNetworkIds, supportsAllNetworks, caipNetwork, routerData;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                isConnected = (0, $dMLJP.AccountController).state.isConnected;
                                isNetworkChainConnected = (0, $dMLJP.AccountController).getChainIsConnected(network.chain);
                                approvedCaipNetworkIds = (0, $fPqxb.NetworkController).state.approvedCaipNetworkIds;
                                supportsAllNetworks = (0, $fPqxb.NetworkController).state.supportsAllNetworks;
                                caipNetwork = (0, $fPqxb.NetworkController).state.caipNetwork;
                                routerData = (0, $iptjJ.RouterController).state.data;
                                if (!(isConnected && (caipNetwork === null || caipNetwork === void 0 ? void 0 : caipNetwork.id) !== network.id)) return [
                                    3,
                                    5
                                ];
                                if (!isNetworkChainConnected) {
                                    (0, $iptjJ.RouterController).push("SwitchActiveChain", {
                                        switchToChain: network.chain,
                                        navigateTo: "Connect",
                                        navigateWithReplace: true
                                    });
                                    return [
                                        2
                                    ];
                                }
                                if (!(approvedCaipNetworkIds === null || approvedCaipNetworkIds === void 0 ? void 0 : approvedCaipNetworkIds.includes(network.id))) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    (0, $fPqxb.NetworkController).switchActiveNetwork(network)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    (0, $cfc345dac538f72b$export$79d00c05833eff69).onNetworkChange()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                if (supportsAllNetworks) (0, $iptjJ.RouterController).push("SwitchNetwork", (0, $cxjpp._)((0, $do9pw._)({}, routerData), {
                                    network: network
                                }));
                                _state.label = 4;
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                if (!isConnected) {
                                    (0, $fPqxb.NetworkController).setActiveCaipNetwork(network);
                                    if (!isNetworkChainConnected) (0, $iptjJ.RouterController).push("Connect");
                                }
                                _state.label = 6;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return W3mNetworksView;
}((0, $2yD3e.LitElement));
$4e2ed48a2dc3f60e$export$ff1f854e9d8d99b2.styles = (0, $9ab7e2fc0d2216b8$export$2e2bcd8739ae039);
$4e2ed48a2dc3f60e$var$__decorate([
    (0, $334Pv.state)()
], $4e2ed48a2dc3f60e$export$ff1f854e9d8d99b2.prototype, "network", void 0);
$4e2ed48a2dc3f60e$var$__decorate([
    (0, $334Pv.state)()
], $4e2ed48a2dc3f60e$export$ff1f854e9d8d99b2.prototype, "requestedCaipNetworks", void 0);
$4e2ed48a2dc3f60e$var$__decorate([
    (0, $334Pv.state)()
], $4e2ed48a2dc3f60e$export$ff1f854e9d8d99b2.prototype, "filteredNetworks", void 0);
$4e2ed48a2dc3f60e$var$__decorate([
    (0, $334Pv.state)()
], $4e2ed48a2dc3f60e$export$ff1f854e9d8d99b2.prototype, "search", void 0);
$4e2ed48a2dc3f60e$export$ff1f854e9d8d99b2 = $4e2ed48a2dc3f60e$var$__decorate([
    (0, $hdxb6.customElement)("w3m-networks-view")
], $4e2ed48a2dc3f60e$export$ff1f854e9d8d99b2);



var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $do9pw = parcelRequire("do9pw");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("dSKxG");
var $6qlO7 = parcelRequire("6qlO7");
parcelRequire("cwWZ7");
var $69mn1 = parcelRequire("69mn1");
var $ktZEF = parcelRequire("ktZEF");
var $datXT = parcelRequire("datXT");
var $dMLJP = parcelRequire("dMLJP");
var $faNff = parcelRequire("faNff");
parcelRequire("grHtr");
var $3kwZm = parcelRequire("3kwZm");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $77c919e73ae138bd$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host > wui-flex {\n    height: 500px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    scrollbar-width: none;\n    padding: var(--wui-spacing-m);\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n  }\n\n  :host > wui-flex::-webkit-scrollbar {\n    display: none;\n  }\n\n  :host > wui-flex > wui-flex {\n    width: 100%;\n  }\n\n  wui-transaction-list-item-loader {\n    width: 100%;\n  }\n"
    ]);
    $77c919e73ae138bd$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $77c919e73ae138bd$export$2e2bcd8739ae039 = (0, $2D5eP.css)($77c919e73ae138bd$var$_templateObject());



function $da8bdd25ee4a48e3$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column" .padding=',
        ' gap="xs">\n        ',
        "\n      </wui-flex>\n    "
    ]);
    $da8bdd25ee4a48e3$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $da8bdd25ee4a48e3$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '\n        <w3m-onramp-activity-item\n          label="Bought"\n          .completed=',
        "\n          .inProgress=",
        "\n          .failed=",
        "\n          purchaseCurrency=",
        "\n          purchaseValue=",
        "\n          date=",
        "\n          icon=",
        "\n          symbol=",
        "\n        ></w3m-onramp-activity-item>\n      "
    ]);
    $da8bdd25ee4a48e3$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $da8bdd25ee4a48e3$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '\n          <wui-flex flexDirection="column">\n            <wui-flex\n              alignItems="center"\n              flexDirection="row"\n              .padding=',
        '\n            >\n              <wui-text variant="paragraph-500" color="fg-200">',
        '</wui-text>\n            </wui-flex>\n            <wui-flex flexDirection="column" gap="xs">\n              ',
        "\n            </wui-flex>\n          </wui-flex>\n        "
    ]);
    $da8bdd25ee4a48e3$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $da8bdd25ee4a48e3$var$_templateObject3() {
    var data = (0, $j06k0._)([
        " <wui-transaction-list-item-loader></wui-transaction-list-item-loader> "
    ]);
    $da8bdd25ee4a48e3$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var $da8bdd25ee4a48e3$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $da8bdd25ee4a48e3$var$LOADING_ITEM_COUNT = 7;
var $da8bdd25ee4a48e3$export$4a0b241548ecf9e5 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mOnRampActivityView, LitElement);
    var _super = (0, $ohfOJ._)(W3mOnRampActivityView);
    function W3mOnRampActivityView() {
        var _this_unsubscribe;
        (0, $4GJKx._)(this, W3mOnRampActivityView);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.selectedOnRampProvider = (0, $69mn1.OnRampController).state.selectedProvider;
        _this.loading = false;
        _this.coinbaseTransactions = (0, $ktZEF.TransactionsController).state.coinbaseTransactions;
        _this.tokenImages = (0, $datXT.AssetController).state.tokenImages;
        (_this_unsubscribe = _this.unsubscribe).push.apply(_this_unsubscribe, [
            (0, $69mn1.OnRampController).subscribeKey("selectedProvider", function(val) {
                _this.selectedOnRampProvider = val;
            }),
            (0, $datXT.AssetController).subscribeKey("tokenImages", function(val) {
                return _this.tokenImages = val;
            }),
            function() {
                clearTimeout(_this.refetchTimeout);
            },
            (0, $ktZEF.TransactionsController).subscribe(function(val) {
                _this.coinbaseTransactions = (0, $do9pw._)({}, val.coinbaseTransactions);
            })
        ]);
        (0, $ktZEF.TransactionsController).clearCursor();
        _this.fetchTransactions();
        return _this;
    }
    (0, $1wc17._)(W3mOnRampActivityView, [
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($da8bdd25ee4a48e3$var$_templateObject(), [
                    "0",
                    "s",
                    "s",
                    "s"
                ], this.loading ? this.templateLoading() : this.templateTransactionsByYear());
            }
        },
        {
            key: "templateTransactions",
            value: function templateTransactions(transactions) {
                var _this = this;
                return transactions === null || transactions === void 0 ? void 0 : transactions.map(function(transaction) {
                    var _transaction_metadata, _fungibleInfo_icon, _this_tokenImages;
                    var date = (0, $6qlO7.DateUtil).formatDate(transaction === null || transaction === void 0 ? void 0 : (_transaction_metadata = transaction.metadata) === null || _transaction_metadata === void 0 ? void 0 : _transaction_metadata.minedAt);
                    var transfer = transaction.transfers[0];
                    var fungibleInfo = transfer === null || transfer === void 0 ? void 0 : transfer.fungible_info;
                    if (!fungibleInfo) return null;
                    var icon = (fungibleInfo === null || fungibleInfo === void 0 ? void 0 : (_fungibleInfo_icon = fungibleInfo.icon) === null || _fungibleInfo_icon === void 0 ? void 0 : _fungibleInfo_icon.url) || ((_this_tokenImages = _this.tokenImages) === null || _this_tokenImages === void 0 ? void 0 : _this_tokenImages[fungibleInfo.symbol || ""]);
                    return (0, $hxyOZ.html)($da8bdd25ee4a48e3$var$_templateObject1(), transaction.metadata.status === "ONRAMP_TRANSACTION_STATUS_SUCCESS", transaction.metadata.status === "ONRAMP_TRANSACTION_STATUS_IN_PROGRESS", transaction.metadata.status === "ONRAMP_TRANSACTION_STATUS_FAILED", (0, $696d14fc702af3d6$export$f68dd208b5df064d)(fungibleInfo.symbol), transfer.quantity.numeric, date, (0, $696d14fc702af3d6$export$f68dd208b5df064d)(icon), (0, $696d14fc702af3d6$export$f68dd208b5df064d)(fungibleInfo.symbol));
                });
            }
        },
        {
            key: "templateTransactionsByYear",
            value: function templateTransactionsByYear() {
                var _this = this;
                var sortedYearKeys = Object.keys(this.coinbaseTransactions).sort().reverse();
                return sortedYearKeys.map(function(year) {
                    var yearInt = parseInt(year, 10);
                    var sortedMonthIndexes = new Array(12).fill(null).map(function(_, idx) {
                        return idx;
                    }).reverse();
                    return sortedMonthIndexes.map(function(month) {
                        var _this_coinbaseTransactions_yearInt;
                        var groupTitle = (0, $3kwZm.TransactionUtil).getTransactionGroupTitle(yearInt, month);
                        var transactions = (_this_coinbaseTransactions_yearInt = _this.coinbaseTransactions[yearInt]) === null || _this_coinbaseTransactions_yearInt === void 0 ? void 0 : _this_coinbaseTransactions_yearInt[month];
                        if (!transactions) return null;
                        return (0, $hxyOZ.html)($da8bdd25ee4a48e3$var$_templateObject2(), [
                            "xs",
                            "s",
                            "s",
                            "s"
                        ], groupTitle, _this.templateTransactions(transactions));
                    });
                });
            }
        },
        {
            key: "fetchTransactions",
            value: function fetchTransactions() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var provider;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                provider = "coinbase";
                                if (!(provider === "coinbase")) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.fetchCoinbaseTransactions()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fetchCoinbaseTransactions",
            value: function fetchCoinbaseTransactions() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var address, projectId;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                address = (0, $dMLJP.AccountController).state.address;
                                projectId = (0, $faNff.OptionsController).state.projectId;
                                if (!address) throw new Error("No address found");
                                if (!projectId) throw new Error("No projectId found");
                                _this.loading = true;
                                return [
                                    4,
                                    (0, $ktZEF.TransactionsController).fetchTransactions(address, "coinbase")
                                ];
                            case 1:
                                _state.sent();
                                _this.loading = false;
                                _this.refetchLoadingTransactions();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "refetchLoadingTransactions",
            value: function refetchLoadingTransactions() {
                var _this_coinbaseTransactions_today_getFullYear;
                var today = new Date();
                var currentMonthTxs = ((_this_coinbaseTransactions_today_getFullYear = this.coinbaseTransactions[today.getFullYear()]) === null || _this_coinbaseTransactions_today_getFullYear === void 0 ? void 0 : _this_coinbaseTransactions_today_getFullYear[today.getMonth()]) || [];
                var loadingTransactions = currentMonthTxs.filter(function(transaction) {
                    return transaction.metadata.status === "ONRAMP_TRANSACTION_STATUS_IN_PROGRESS";
                });
                if (loadingTransactions.length === 0) {
                    clearTimeout(this.refetchTimeout);
                    return;
                }
                var _this = this;
                this.refetchTimeout = setTimeout(/*#__PURE__*/ (0, $kSuI9._)(function() {
                    var address;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                address = (0, $dMLJP.AccountController).state.address;
                                return [
                                    4,
                                    (0, $ktZEF.TransactionsController).fetchTransactions(address, "coinbase")
                                ];
                            case 1:
                                _state.sent();
                                _this.refetchLoadingTransactions();
                                return [
                                    2
                                ];
                        }
                    });
                }), 3000);
            }
        },
        {
            key: "templateLoading",
            value: function templateLoading() {
                return Array($da8bdd25ee4a48e3$var$LOADING_ITEM_COUNT).fill((0, $hxyOZ.html)($da8bdd25ee4a48e3$var$_templateObject3())).map(function(item) {
                    return item;
                });
            }
        }
    ]);
    return W3mOnRampActivityView;
}((0, $2yD3e.LitElement));
$da8bdd25ee4a48e3$export$4a0b241548ecf9e5.styles = (0, $77c919e73ae138bd$export$2e2bcd8739ae039);
$da8bdd25ee4a48e3$var$__decorate([
    (0, $334Pv.state)()
], $da8bdd25ee4a48e3$export$4a0b241548ecf9e5.prototype, "selectedOnRampProvider", void 0);
$da8bdd25ee4a48e3$var$__decorate([
    (0, $334Pv.state)()
], $da8bdd25ee4a48e3$export$4a0b241548ecf9e5.prototype, "loading", void 0);
$da8bdd25ee4a48e3$var$__decorate([
    (0, $334Pv.state)()
], $da8bdd25ee4a48e3$export$4a0b241548ecf9e5.prototype, "coinbaseTransactions", void 0);
$da8bdd25ee4a48e3$var$__decorate([
    (0, $334Pv.state)()
], $da8bdd25ee4a48e3$export$4a0b241548ecf9e5.prototype, "tokenImages", void 0);
$da8bdd25ee4a48e3$export$4a0b241548ecf9e5 = $da8bdd25ee4a48e3$var$__decorate([
    (0, $hdxb6.customElement)("w3m-onramp-activity-view")
], $da8bdd25ee4a48e3$export$4a0b241548ecf9e5);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $69mn1 = parcelRequire("69mn1");
var $datXT = parcelRequire("datXT");
var $5Lhe6 = parcelRequire("5Lhe6");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $8afc9445111d3df8$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host > wui-grid {\n    max-height: 360px;\n    overflow: auto;\n  }\n\n  wui-grid::-webkit-scrollbar {\n    display: none;\n  }\n"
    ]);
    $8afc9445111d3df8$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $8afc9445111d3df8$export$2e2bcd8739ae039 = (0, $2D5eP.css)($8afc9445111d3df8$var$_templateObject());



function $1acc2aa8ab5fe81f$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column" .padding=',
        ' gap="xs">\n        ',
        "\n      </wui-flex>\n      <w3m-legal-footer></w3m-legal-footer>\n    "
    ]);
    $1acc2aa8ab5fe81f$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $1acc2aa8ab5fe81f$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "\n        <wui-list-item\n          imageSrc=",
        "\n          @click=",
        '\n          variant="image"\n        >\n          <wui-text variant="paragraph-500" color="fg-100">',
        "</wui-text>\n        </wui-list-item>\n      "
    ]);
    $1acc2aa8ab5fe81f$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $1acc2aa8ab5fe81f$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $1acc2aa8ab5fe81f$export$d8e2d72354b51198 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mOnrampFiatSelectView, LitElement);
    var _super = (0, $ohfOJ._)(W3mOnrampFiatSelectView);
    function W3mOnrampFiatSelectView() {
        var _this_unsubscribe;
        (0, $4GJKx._)(this, W3mOnrampFiatSelectView);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.selectedCurrency = (0, $69mn1.OnRampController).state.paymentCurrency;
        _this.currencies = (0, $69mn1.OnRampController).state.paymentCurrencies;
        _this.currencyImages = (0, $datXT.AssetController).state.currencyImages;
        (_this_unsubscribe = _this.unsubscribe).push.apply(_this_unsubscribe, [
            (0, $69mn1.OnRampController).subscribe(function(val) {
                _this.selectedCurrency = val.paymentCurrency;
                _this.currencies = val.paymentCurrencies;
            }),
            (0, $datXT.AssetController).subscribeKey("currencyImages", function(val) {
                return _this.currencyImages = val;
            })
        ]);
        return _this;
    }
    (0, $1wc17._)(W3mOnrampFiatSelectView, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($1acc2aa8ab5fe81f$var$_templateObject(), [
                    "0",
                    "s",
                    "s",
                    "s"
                ], this.currenciesTemplate());
            }
        },
        {
            key: "currenciesTemplate",
            value: function currenciesTemplate() {
                var _this = this;
                return this.currencies.map(function(currency) {
                    var _this_currencyImages;
                    return (0, $hxyOZ.html)($1acc2aa8ab5fe81f$var$_templateObject1(), (0, $696d14fc702af3d6$export$f68dd208b5df064d)((_this_currencyImages = _this.currencyImages) === null || _this_currencyImages === void 0 ? void 0 : _this_currencyImages[currency.id]), function() {
                        return _this.selectCurrency(currency);
                    }, currency.id);
                });
            }
        },
        {
            key: "selectCurrency",
            value: function selectCurrency(currency) {
                if (!currency) return;
                (0, $69mn1.OnRampController).setPaymentCurrency(currency);
                (0, $5Lhe6.ModalController).close();
            }
        }
    ]);
    return W3mOnrampFiatSelectView;
}((0, $2yD3e.LitElement));
$1acc2aa8ab5fe81f$export$d8e2d72354b51198.styles = (0, $8afc9445111d3df8$export$2e2bcd8739ae039);
$1acc2aa8ab5fe81f$var$__decorate([
    (0, $334Pv.state)()
], $1acc2aa8ab5fe81f$export$d8e2d72354b51198.prototype, "selectedCurrency", void 0);
$1acc2aa8ab5fe81f$var$__decorate([
    (0, $334Pv.state)()
], $1acc2aa8ab5fe81f$export$d8e2d72354b51198.prototype, "currencies", void 0);
$1acc2aa8ab5fe81f$var$__decorate([
    (0, $334Pv.state)()
], $1acc2aa8ab5fe81f$export$d8e2d72354b51198.prototype, "currencyImages", void 0);
$1acc2aa8ab5fe81f$export$d8e2d72354b51198 = $1acc2aa8ab5fe81f$var$__decorate([
    (0, $hdxb6.customElement)("w3m-onramp-fiat-select-view")
], $1acc2aa8ab5fe81f$export$d8e2d72354b51198);



var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("cwWZ7");
var $69mn1 = parcelRequire("69mn1");
var $iptjJ = parcelRequire("iptjJ");
var $hZBJb = parcelRequire("hZBJb");
var $1QDT9 = parcelRequire("1QDT9");
var $dMLJP = parcelRequire("dMLJP");
var $fPqxb = parcelRequire("fPqxb");
var $2sXdV = parcelRequire("2sXdV");
var $jrvVk = parcelRequire("jrvVk");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");
parcelRequire("hsyMZ");
var $cSJ4o = parcelRequire("cSJ4o");
function $0ab0ea4c0750b3ff$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column" .padding=',
        ' gap="xs">\n        ',
        "\n      </wui-flex>\n      <w3m-onramp-providers-footer></w3m-onramp-providers-footer>\n    "
    ]);
    $0ab0ea4c0750b3ff$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $0ab0ea4c0750b3ff$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "\n        <w3m-onramp-provider-item\n          label=",
        "\n          name=",
        "\n          feeRange=",
        "\n          @click=",
        "\n          ?disabled=",
        "\n        ></w3m-onramp-provider-item>\n      "
    ]);
    $0ab0ea4c0750b3ff$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $0ab0ea4c0750b3ff$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $0ab0ea4c0750b3ff$export$59a62e1add0f780c = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mOnRampProvidersView, LitElement);
    var _super = (0, $ohfOJ._)(W3mOnRampProvidersView);
    function W3mOnRampProvidersView() {
        var _this_unsubscribe;
        (0, $4GJKx._)(this, W3mOnRampProvidersView);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.providers = (0, $69mn1.OnRampController).state.providers;
        (_this_unsubscribe = _this.unsubscribe).push.apply(_this_unsubscribe, [
            (0, $69mn1.OnRampController).subscribeKey("providers", function(val) {
                _this.providers = val;
            })
        ]);
        return _this;
    }
    (0, $1wc17._)(W3mOnRampProvidersView, [
        {
            key: "firstUpdated",
            value: function firstUpdated() {
                var _this = this;
                var _this1 = this;
                var urlPromises = this.providers.map(function() {
                    var _ref = (0, $kSuI9._)(function(provider) {
                        return (0, $eha6O.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!(provider.name === "coinbase")) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        _this1.getCoinbaseOnRampURL()
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _state.sent()
                                    ];
                                case 2:
                                    return [
                                        2,
                                        Promise.resolve(provider === null || provider === void 0 ? void 0 : provider.url)
                                    ];
                            }
                        });
                    });
                    return function(provider) {
                        return _ref.apply(this, arguments);
                    };
                }());
                Promise.all(urlPromises).then(function(urls) {
                    _this.providers = _this.providers.map(function(provider, index) {
                        return (0, $cxjpp._)((0, $do9pw._)({}, provider), {
                            url: urls[index] || ""
                        });
                    });
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($0ab0ea4c0750b3ff$var$_templateObject(), [
                    "0",
                    "s",
                    "s",
                    "s"
                ], this.onRampProvidersTemplate());
            }
        },
        {
            key: "onRampProvidersTemplate",
            value: function onRampProvidersTemplate() {
                var _this = this;
                return this.providers.map(function(provider) {
                    return (0, $hxyOZ.html)($0ab0ea4c0750b3ff$var$_templateObject1(), provider.label, provider.name, provider.feeRange, function() {
                        _this.onClickProvider(provider);
                    }, !provider.url);
                });
            }
        },
        {
            key: "onClickProvider",
            value: function onClickProvider(provider) {
                (0, $69mn1.OnRampController).setSelectedProvider(provider);
                (0, $iptjJ.RouterController).push("BuyInProgress");
                (0, $hZBJb.CoreHelperUtil).openHref(provider.url, "popupWindow", "width=600,height=800,scrollbars=yes");
                (0, $1QDT9.EventsController).sendEvent({
                    type: "track",
                    event: "SELECT_BUY_PROVIDER",
                    properties: {
                        provider: provider.name,
                        isSmartAccount: (0, $dMLJP.AccountController).state.preferredAccountType === (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT
                    }
                });
            }
        },
        {
            key: "getCoinbaseOnRampURL",
            value: function getCoinbaseOnRampURL() {
                return (0, $kSuI9._)(function() {
                    var address, network, _ConstantsUtil_WC_COINBASE_PAY_SDK_CHAIN_NAME_MAP_network_name, defaultNetwork, purchaseCurrency, assets;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                address = (0, $dMLJP.AccountController).state.address;
                                network = (0, $fPqxb.NetworkController).state.caipNetwork;
                                if (!address) throw new Error("No address found");
                                if (!(network === null || network === void 0 ? void 0 : network.name)) throw new Error("No network found");
                                defaultNetwork = (_ConstantsUtil_WC_COINBASE_PAY_SDK_CHAIN_NAME_MAP_network_name = (0, $2sXdV.ConstantsUtil).WC_COINBASE_PAY_SDK_CHAIN_NAME_MAP[network.name]) !== null && _ConstantsUtil_WC_COINBASE_PAY_SDK_CHAIN_NAME_MAP_network_name !== void 0 ? _ConstantsUtil_WC_COINBASE_PAY_SDK_CHAIN_NAME_MAP_network_name : (0, $2sXdV.ConstantsUtil).WC_COINBASE_PAY_SDK_FALLBACK_CHAIN;
                                purchaseCurrency = (0, $69mn1.OnRampController).state.purchaseCurrency;
                                assets = purchaseCurrency ? [
                                    purchaseCurrency.symbol
                                ] : (0, $69mn1.OnRampController).state.purchaseCurrencies.map(function(currency) {
                                    return currency.symbol;
                                });
                                return [
                                    4,
                                    (0, $jrvVk.BlockchainApiController).generateOnRampURL({
                                        defaultNetwork: defaultNetwork,
                                        destinationWallets: [
                                            {
                                                address: address,
                                                blockchains: (0, $2sXdV.ConstantsUtil).WC_COINBASE_PAY_SDK_CHAINS,
                                                assets: assets
                                            }
                                        ],
                                        partnerUserId: address,
                                        purchaseAmount: (0, $69mn1.OnRampController).state.purchaseAmount
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return W3mOnRampProvidersView;
}((0, $2yD3e.LitElement));
$0ab0ea4c0750b3ff$var$__decorate([
    (0, $334Pv.state)()
], $0ab0ea4c0750b3ff$export$59a62e1add0f780c.prototype, "providers", void 0);
$0ab0ea4c0750b3ff$export$59a62e1add0f780c = $0ab0ea4c0750b3ff$var$__decorate([
    (0, $hdxb6.customElement)("w3m-onramp-providers-view")
], $0ab0ea4c0750b3ff$export$59a62e1add0f780c);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $69mn1 = parcelRequire("69mn1");
var $datXT = parcelRequire("datXT");
var $5Lhe6 = parcelRequire("5Lhe6");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $109643e8f6d8c5d1$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host > wui-grid {\n    max-height: 360px;\n    overflow: auto;\n  }\n\n  wui-grid::-webkit-scrollbar {\n    display: none;\n  }\n"
    ]);
    $109643e8f6d8c5d1$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $109643e8f6d8c5d1$export$2e2bcd8739ae039 = (0, $2D5eP.css)($109643e8f6d8c5d1$var$_templateObject());



function $db33ca8c02d6bee3$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column" .padding=',
        ' gap="xs">\n        ',
        "\n      </wui-flex>\n      <w3m-legal-footer></w3m-legal-footer>\n    "
    ]);
    $db33ca8c02d6bee3$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $db33ca8c02d6bee3$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "\n        <wui-list-item\n          imageSrc=",
        "\n          @click=",
        '\n          variant="image"\n        >\n          <wui-flex gap="3xs" alignItems="center">\n            <wui-text variant="paragraph-500" color="fg-100">',
        '</wui-text>\n            <wui-text variant="small-400" color="fg-200">',
        "</wui-text>\n          </wui-flex>\n        </wui-list-item>\n      "
    ]);
    $db33ca8c02d6bee3$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $db33ca8c02d6bee3$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $db33ca8c02d6bee3$export$97f0fa712fa488a5 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mOnrampTokensView, LitElement);
    var _super = (0, $ohfOJ._)(W3mOnrampTokensView);
    function W3mOnrampTokensView() {
        var _this_unsubscribe;
        (0, $4GJKx._)(this, W3mOnrampTokensView);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.selectedCurrency = (0, $69mn1.OnRampController).state.purchaseCurrencies;
        _this.tokens = (0, $69mn1.OnRampController).state.purchaseCurrencies;
        _this.tokenImages = (0, $datXT.AssetController).state.tokenImages;
        (_this_unsubscribe = _this.unsubscribe).push.apply(_this_unsubscribe, [
            (0, $69mn1.OnRampController).subscribe(function(val) {
                _this.selectedCurrency = val.purchaseCurrencies;
                _this.tokens = val.purchaseCurrencies;
            }),
            (0, $datXT.AssetController).subscribeKey("tokenImages", function(val) {
                return _this.tokenImages = val;
            })
        ]);
        return _this;
    }
    (0, $1wc17._)(W3mOnrampTokensView, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($db33ca8c02d6bee3$var$_templateObject(), [
                    "0",
                    "s",
                    "s",
                    "s"
                ], this.currenciesTemplate());
            }
        },
        {
            key: "currenciesTemplate",
            value: function currenciesTemplate() {
                var _this = this;
                return this.tokens.map(function(token) {
                    var _this_tokenImages;
                    return (0, $hxyOZ.html)($db33ca8c02d6bee3$var$_templateObject1(), (0, $696d14fc702af3d6$export$f68dd208b5df064d)((_this_tokenImages = _this.tokenImages) === null || _this_tokenImages === void 0 ? void 0 : _this_tokenImages[token.symbol]), function() {
                        return _this.selectToken(token);
                    }, token.name, token.symbol);
                });
            }
        },
        {
            key: "selectToken",
            value: function selectToken(currency) {
                if (!currency) return;
                (0, $69mn1.OnRampController).setPurchaseCurrency(currency);
                (0, $5Lhe6.ModalController).close();
            }
        }
    ]);
    return W3mOnrampTokensView;
}((0, $2yD3e.LitElement));
$db33ca8c02d6bee3$export$97f0fa712fa488a5.styles = (0, $109643e8f6d8c5d1$export$2e2bcd8739ae039);
$db33ca8c02d6bee3$var$__decorate([
    (0, $334Pv.state)()
], $db33ca8c02d6bee3$export$97f0fa712fa488a5.prototype, "selectedCurrency", void 0);
$db33ca8c02d6bee3$var$__decorate([
    (0, $334Pv.state)()
], $db33ca8c02d6bee3$export$97f0fa712fa488a5.prototype, "tokens", void 0);
$db33ca8c02d6bee3$var$__decorate([
    (0, $334Pv.state)()
], $db33ca8c02d6bee3$export$97f0fa712fa488a5.prototype, "tokenImages", void 0);
$db33ca8c02d6bee3$export$97f0fa712fa488a5 = $db33ca8c02d6bee3$var$__decorate([
    (0, $hdxb6.customElement)("w3m-onramp-token-select-view")
], $db33ca8c02d6bee3$export$97f0fa712fa488a5);



var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $42a0aa987cfc6b54$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host > wui-flex:first-child {\n    overflow-y: auto;\n    overflow-x: hidden;\n    scrollbar-width: none;\n  }\n\n  :host > wui-flex:first-child::-webkit-scrollbar {\n    display: none;\n  }\n\n  wui-loading-hexagon {\n    position: absolute;\n  }\n\n  .action-button {\n    width: 100%;\n    border-radius: var(--wui-border-radius-xs);\n  }\n\n  .action-button:disabled {\n    border-color: 1px solid var(--wui-color-gray-glass-005);\n  }\n\n  .swap-inputs-container {\n    position: relative;\n  }\n\n  .replace-tokens-button-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    gap: var(--wui-spacing-1xs);\n    border-radius: var(--wui-border-radius-xs);\n    background-color: var(--wui-color-modal-bg-base);\n    padding: var(--wui-spacing-xxs);\n  }\n\n  .replace-tokens-button-container > button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 40px;\n    width: 40px;\n    padding: var(--wui-spacing-xs);\n    border: none;\n    border-radius: var(--wui-border-radius-xxs);\n    background: var(--wui-color-gray-glass-002);\n    transition: background-color var(--wui-duration-md) var(--wui-ease-out-power-1);\n    will-change: background-color;\n    z-index: 20;\n  }\n\n  .replace-tokens-button-container > button:hover {\n    background: var(--wui-color-gray-glass-005);\n  }\n\n  .details-container > wui-flex {\n    background: var(--wui-color-gray-glass-002);\n    border-radius: var(--wui-border-radius-xxs);\n    width: 100%;\n  }\n\n  .details-container > wui-flex > button {\n    border: none;\n    background: none;\n    padding: var(--wui-spacing-s);\n    border-radius: var(--wui-border-radius-xxs);\n    transition: background 0.2s linear;\n  }\n\n  .details-container > wui-flex > button:hover {\n    background: var(--wui-color-gray-glass-002);\n  }\n\n  .details-content-container {\n    padding: var(--wui-spacing-1xs);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .details-content-container > wui-flex {\n    width: 100%;\n  }\n\n  .details-row {\n    width: 100%;\n    padding: var(--wui-spacing-s) var(--wui-spacing-xl);\n    border-radius: var(--wui-border-radius-xxs);\n    background: var(--wui-color-gray-glass-002);\n  }\n"
    ]);
    $42a0aa987cfc6b54$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $42a0aa987cfc6b54$export$2e2bcd8739ae039 = (0, $2D5eP.css)($42a0aa987cfc6b54$var$_templateObject());


parcelRequire("cwWZ7");
var $fPqxb = parcelRequire("fPqxb");
var $8DzeN = parcelRequire("8DzeN");
var $hZBJb = parcelRequire("hZBJb");
var $5Lhe6 = parcelRequire("5Lhe6");
var $iptjJ = parcelRequire("iptjJ");
var $2sXdV = parcelRequire("2sXdV");
var $1QDT9 = parcelRequire("1QDT9");
var $dMLJP = parcelRequire("dMLJP");
parcelRequire("dSKxG");
var $eMPGH = parcelRequire("eMPGH");
parcelRequire("hsyMZ");
var $cSJ4o = parcelRequire("cSJ4o");
function $effb8af77e38bfa6$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column" .padding=',
        ' gap="s">\n        ',
        "\n      </wui-flex>\n    "
    ]);
    $effb8af77e38bfa6$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $effb8af77e38bfa6$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column" gap="s">\n        <wui-flex flexDirection="column" alignItems="center" gap="xs" class="swap-inputs-container">\n          ',
        "\n          ",
        " ",
        "\n        </wui-flex>\n        ",
        " ",
        "\n      </wui-flex>\n    "
    ]);
    $effb8af77e38bfa6$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $effb8af77e38bfa6$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex class="replace-tokens-button-container">\n        <button @click=',
        '>\n          <wui-icon name="recycleHorizontal" color="fg-250" size="lg"></wui-icon>\n        </button>\n      </wui-flex>\n    '
    ]);
    $effb8af77e38bfa6$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $effb8af77e38bfa6$var$_templateObject3() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column" gap="l">\n        <wui-flex flexDirection="column" alignItems="center" gap="xs" class="swap-inputs-container">\n          <w3m-swap-input-skeleton target="sourceToken"></w3m-swap-input-skeleton>\n          <w3m-swap-input-skeleton target="toToken"></w3m-swap-input-skeleton>\n          ',
        "\n        </wui-flex>\n        ",
        "\n      </wui-flex>\n    "
    ]);
    $effb8af77e38bfa6$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $effb8af77e38bfa6$var$_templateObject4() {
    var data = (0, $j06k0._)([
        "<w3m-swap-input\n      .value=",
        "\n      ?disabled=",
        "\n      .onSetAmount=",
        "\n      target=",
        "\n      .token=",
        "\n      .balance=",
        "\n      .price=",
        "\n      .marketValue=",
        "\n      .onSetMaxValue=",
        "\n    ></w3m-swap-input>"
    ]);
    $effb8af77e38bfa6$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $effb8af77e38bfa6$var$_templateObject5() {
    var data = (0, $j06k0._)([
        "<w3m-swap-details .detailsOpen=",
        "></w3m-swap-details>"
    ]);
    $effb8af77e38bfa6$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $effb8af77e38bfa6$var$_templateObject6() {
    var data = (0, $j06k0._)([
        ' <wui-flex gap="xs">\n      <wui-button\n        data-testid="swap-action-button"\n        class="action-button"\n        fullWidth\n        size="lg"\n        borderRadius="xs"\n        variant=',
        "\n        .loading=",
        "\n        .disabled=",
        "\n        @click=",
        "\n      >\n        ",
        "\n      </wui-button>\n    </wui-flex>"
    ]);
    $effb8af77e38bfa6$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
var $effb8af77e38bfa6$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $effb8af77e38bfa6$export$9cc2509453f936aa = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mSwapView, LitElement);
    var _super = (0, $ohfOJ._)(W3mSwapView);
    function W3mSwapView() {
        var _this_unsubscribe;
        (0, $4GJKx._)(this, W3mSwapView);
        var _this;
        var _NetworkController_state_caipNetwork;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.detailsOpen = false;
        _this.caipNetworkId = (_NetworkController_state_caipNetwork = (0, $fPqxb.NetworkController).state.caipNetwork) === null || _NetworkController_state_caipNetwork === void 0 ? void 0 : _NetworkController_state_caipNetwork.id;
        _this.initialized = (0, $8DzeN.SwapController).state.initialized;
        _this.loadingQuote = (0, $8DzeN.SwapController).state.loadingQuote;
        _this.loadingPrices = (0, $8DzeN.SwapController).state.loadingPrices;
        _this.loadingTransaction = (0, $8DzeN.SwapController).state.loadingTransaction;
        _this.sourceToken = (0, $8DzeN.SwapController).state.sourceToken;
        _this.sourceTokenAmount = (0, $8DzeN.SwapController).state.sourceTokenAmount;
        _this.sourceTokenPriceInUSD = (0, $8DzeN.SwapController).state.sourceTokenPriceInUSD;
        _this.toToken = (0, $8DzeN.SwapController).state.toToken;
        _this.toTokenAmount = (0, $8DzeN.SwapController).state.toTokenAmount;
        _this.toTokenPriceInUSD = (0, $8DzeN.SwapController).state.toTokenPriceInUSD;
        _this.inputError = (0, $8DzeN.SwapController).state.inputError;
        _this.gasPriceInUSD = (0, $8DzeN.SwapController).state.gasPriceInUSD;
        _this.fetchError = (0, $8DzeN.SwapController).state.fetchError;
        _this.onDebouncedGetSwapCalldata = (0, $hZBJb.CoreHelperUtil).debounce(/*#__PURE__*/ (0, $kSuI9._)(function() {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, $8DzeN.SwapController).swapTokens()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        }), 200);
        (0, $fPqxb.NetworkController).subscribeKey("caipNetwork", function(newCaipNetwork) {
            if (_this.caipNetworkId !== (newCaipNetwork === null || newCaipNetwork === void 0 ? void 0 : newCaipNetwork.id)) {
                _this.caipNetworkId = newCaipNetwork === null || newCaipNetwork === void 0 ? void 0 : newCaipNetwork.id;
                (0, $8DzeN.SwapController).resetState();
                (0, $8DzeN.SwapController).initializeState();
            }
        });
        (_this_unsubscribe = _this.unsubscribe).push.apply(_this_unsubscribe, [
            (0, $5Lhe6.ModalController).subscribeKey("open", function(isOpen) {
                if (!isOpen) (0, $8DzeN.SwapController).resetState();
            }),
            (0, $iptjJ.RouterController).subscribeKey("view", function(newRoute) {
                if (!newRoute.includes("Swap")) (0, $8DzeN.SwapController).resetValues();
            }),
            (0, $8DzeN.SwapController).subscribe(function(newState) {
                _this.initialized = newState.initialized;
                _this.loadingQuote = newState.loadingQuote;
                _this.loadingPrices = newState.loadingPrices;
                _this.loadingTransaction = newState.loadingTransaction;
                _this.sourceToken = newState.sourceToken;
                _this.sourceTokenAmount = newState.sourceTokenAmount;
                _this.sourceTokenPriceInUSD = newState.sourceTokenPriceInUSD;
                _this.toToken = newState.toToken;
                _this.toTokenAmount = newState.toTokenAmount;
                _this.toTokenPriceInUSD = newState.toTokenPriceInUSD;
                _this.inputError = newState.inputError;
                _this.gasPriceInUSD = newState.gasPriceInUSD;
                _this.fetchError = newState.fetchError;
            })
        ]);
        return _this;
    }
    (0, $1wc17._)(W3mSwapView, [
        {
            key: "firstUpdated",
            value: function firstUpdated() {
                (0, $8DzeN.SwapController).initializeState();
                this.watchTokensAndValues();
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe === null || unsubscribe === void 0 ? void 0 : unsubscribe();
                });
                clearInterval(this.interval);
            }
        },
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($effb8af77e38bfa6$var$_templateObject(), [
                    "0",
                    "l",
                    "l",
                    "l"
                ], this.initialized ? this.templateSwap() : this.templateLoading());
            }
        },
        {
            key: "watchTokensAndValues",
            value: function watchTokensAndValues() {
                this.interval = setInterval(function() {
                    (0, $8DzeN.SwapController).getNetworkTokenPrice();
                    (0, $8DzeN.SwapController).getMyTokensWithBalance();
                    (0, $8DzeN.SwapController).swapTokens();
                }, 10000);
            }
        },
        {
            key: "templateSwap",
            value: function templateSwap() {
                return (0, $hxyOZ.html)($effb8af77e38bfa6$var$_templateObject1(), this.templateTokenInput("sourceToken", this.sourceToken), this.templateTokenInput("toToken", this.toToken), this.templateReplaceTokensButton(), this.templateDetails(), this.templateActionButton());
            }
        },
        {
            key: "actionButtonLabel",
            value: function actionButtonLabel() {
                if (this.fetchError) return "Swap";
                if (!this.sourceToken || !this.toToken) return "Select token";
                if (!this.sourceTokenAmount) return "Enter amount";
                if (this.inputError) return this.inputError;
                return "Review swap";
            }
        },
        {
            key: "templateReplaceTokensButton",
            value: function templateReplaceTokensButton() {
                return (0, $hxyOZ.html)($effb8af77e38bfa6$var$_templateObject2(), this.onSwitchTokens.bind(this));
            }
        },
        {
            key: "templateLoading",
            value: function templateLoading() {
                return (0, $hxyOZ.html)($effb8af77e38bfa6$var$_templateObject3(), this.templateReplaceTokensButton(), this.templateActionButton());
            }
        },
        {
            key: "templateTokenInput",
            value: function templateTokenInput(target, token) {
                var _SwapController_state_myTokensWithBalance, _myToken_quantity;
                var myToken = (_SwapController_state_myTokensWithBalance = (0, $8DzeN.SwapController).state.myTokensWithBalance) === null || _SwapController_state_myTokensWithBalance === void 0 ? void 0 : _SwapController_state_myTokensWithBalance.find(function(ct) {
                    return (ct === null || ct === void 0 ? void 0 : ct.address) === (token === null || token === void 0 ? void 0 : token.address);
                });
                var amount = target === "toToken" ? this.toTokenAmount : this.sourceTokenAmount;
                var price = target === "toToken" ? this.toTokenPriceInUSD : this.sourceTokenPriceInUSD;
                var value = parseFloat(amount) * price;
                if (target === "toToken") value -= this.gasPriceInUSD || 0;
                return (0, $hxyOZ.html)($effb8af77e38bfa6$var$_templateObject4(), target === "toToken" ? this.toTokenAmount : this.sourceTokenAmount, this.loadingQuote && target === "toToken", this.handleChangeAmount.bind(this), target, token, myToken === null || myToken === void 0 ? void 0 : (_myToken_quantity = myToken.quantity) === null || _myToken_quantity === void 0 ? void 0 : _myToken_quantity.numeric, myToken === null || myToken === void 0 ? void 0 : myToken.price, value, this.onSetMaxValue.bind(this));
            }
        },
        {
            key: "onSetMaxValue",
            value: function onSetMaxValue(target, balance) {
                var token = target === "sourceToken" ? this.sourceToken : this.toToken;
                var isNetworkToken = (token === null || token === void 0 ? void 0 : token.address) === (0, $2sXdV.ConstantsUtil).NATIVE_TOKEN_ADDRESS;
                var value = "0";
                if (!balance) {
                    value = "0";
                    this.handleChangeAmount(target, value);
                    return;
                }
                if (!this.gasPriceInUSD) {
                    value = balance;
                    this.handleChangeAmount(target, value);
                    return;
                }
                var amountOfTokenGasRequires = (0, $eMPGH.NumberUtil).bigNumber(this.gasPriceInUSD.toFixed(5)).dividedBy(this.sourceTokenPriceInUSD);
                var maxValue = isNetworkToken ? (0, $eMPGH.NumberUtil).bigNumber(balance).minus(amountOfTokenGasRequires) : (0, $eMPGH.NumberUtil).bigNumber(balance);
                this.handleChangeAmount(target, maxValue.isGreaterThan(0) ? maxValue.toFixed(20) : "0");
            }
        },
        {
            key: "templateDetails",
            value: function templateDetails() {
                if (!this.sourceToken || !this.toToken || this.inputError) return null;
                return (0, $hxyOZ.html)($effb8af77e38bfa6$var$_templateObject5(), this.detailsOpen);
            }
        },
        {
            key: "handleChangeAmount",
            value: function handleChangeAmount(target, value) {
                (0, $8DzeN.SwapController).clearError();
                if (target === "sourceToken") (0, $8DzeN.SwapController).setSourceTokenAmount(value);
                else (0, $8DzeN.SwapController).setToTokenAmount(value);
                this.onDebouncedGetSwapCalldata();
            }
        },
        {
            key: "templateActionButton",
            value: function templateActionButton() {
                var haveNoTokenSelected = !this.toToken || !this.sourceToken;
                var haveNoAmount = !this.sourceTokenAmount;
                var loading = this.loadingQuote || this.loadingPrices || this.loadingTransaction;
                var disabled = loading || haveNoTokenSelected || haveNoAmount || this.inputError;
                return (0, $hxyOZ.html)($effb8af77e38bfa6$var$_templateObject6(), haveNoTokenSelected ? "neutral" : "main", loading, disabled, this.onSwapPreview.bind(this), this.actionButtonLabel());
            }
        },
        {
            key: "onSwitchTokens",
            value: function onSwitchTokens() {
                (0, $8DzeN.SwapController).switchTokens();
            }
        },
        {
            key: "onSwapPreview",
            value: function onSwapPreview() {
                var _this_sourceToken, _this_toToken;
                if (this.fetchError) {
                    (0, $8DzeN.SwapController).swapTokens();
                    return;
                }
                (0, $1QDT9.EventsController).sendEvent({
                    type: "track",
                    event: "INITIATE_SWAP",
                    properties: {
                        network: this.caipNetworkId || "",
                        swapFromToken: ((_this_sourceToken = this.sourceToken) === null || _this_sourceToken === void 0 ? void 0 : _this_sourceToken.symbol) || "",
                        swapToToken: ((_this_toToken = this.toToken) === null || _this_toToken === void 0 ? void 0 : _this_toToken.symbol) || "",
                        swapFromAmount: this.sourceTokenAmount || "",
                        swapToAmount: this.toTokenAmount || "",
                        isSmartAccount: (0, $dMLJP.AccountController).state.preferredAccountType === (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT
                    }
                });
                (0, $iptjJ.RouterController).push("SwapPreview");
            }
        }
    ]);
    return W3mSwapView;
}((0, $2yD3e.LitElement));
$effb8af77e38bfa6$export$9cc2509453f936aa.styles = (0, $42a0aa987cfc6b54$export$2e2bcd8739ae039);
$effb8af77e38bfa6$var$__decorate([
    (0, $334Pv.state)()
], $effb8af77e38bfa6$export$9cc2509453f936aa.prototype, "interval", void 0);
$effb8af77e38bfa6$var$__decorate([
    (0, $334Pv.state)()
], $effb8af77e38bfa6$export$9cc2509453f936aa.prototype, "detailsOpen", void 0);
$effb8af77e38bfa6$var$__decorate([
    (0, $334Pv.state)()
], $effb8af77e38bfa6$export$9cc2509453f936aa.prototype, "caipNetworkId", void 0);
$effb8af77e38bfa6$var$__decorate([
    (0, $334Pv.state)()
], $effb8af77e38bfa6$export$9cc2509453f936aa.prototype, "initialized", void 0);
$effb8af77e38bfa6$var$__decorate([
    (0, $334Pv.state)()
], $effb8af77e38bfa6$export$9cc2509453f936aa.prototype, "loadingQuote", void 0);
$effb8af77e38bfa6$var$__decorate([
    (0, $334Pv.state)()
], $effb8af77e38bfa6$export$9cc2509453f936aa.prototype, "loadingPrices", void 0);
$effb8af77e38bfa6$var$__decorate([
    (0, $334Pv.state)()
], $effb8af77e38bfa6$export$9cc2509453f936aa.prototype, "loadingTransaction", void 0);
$effb8af77e38bfa6$var$__decorate([
    (0, $334Pv.state)()
], $effb8af77e38bfa6$export$9cc2509453f936aa.prototype, "sourceToken", void 0);
$effb8af77e38bfa6$var$__decorate([
    (0, $334Pv.state)()
], $effb8af77e38bfa6$export$9cc2509453f936aa.prototype, "sourceTokenAmount", void 0);
$effb8af77e38bfa6$var$__decorate([
    (0, $334Pv.state)()
], $effb8af77e38bfa6$export$9cc2509453f936aa.prototype, "sourceTokenPriceInUSD", void 0);
$effb8af77e38bfa6$var$__decorate([
    (0, $334Pv.state)()
], $effb8af77e38bfa6$export$9cc2509453f936aa.prototype, "toToken", void 0);
$effb8af77e38bfa6$var$__decorate([
    (0, $334Pv.state)()
], $effb8af77e38bfa6$export$9cc2509453f936aa.prototype, "toTokenAmount", void 0);
$effb8af77e38bfa6$var$__decorate([
    (0, $334Pv.state)()
], $effb8af77e38bfa6$export$9cc2509453f936aa.prototype, "toTokenPriceInUSD", void 0);
$effb8af77e38bfa6$var$__decorate([
    (0, $334Pv.state)()
], $effb8af77e38bfa6$export$9cc2509453f936aa.prototype, "inputError", void 0);
$effb8af77e38bfa6$var$__decorate([
    (0, $334Pv.state)()
], $effb8af77e38bfa6$export$9cc2509453f936aa.prototype, "gasPriceInUSD", void 0);
$effb8af77e38bfa6$var$__decorate([
    (0, $334Pv.state)()
], $effb8af77e38bfa6$export$9cc2509453f936aa.prototype, "fetchError", void 0);
$effb8af77e38bfa6$export$9cc2509453f936aa = $effb8af77e38bfa6$var$__decorate([
    (0, $hdxb6.customElement)("w3m-swap-view")
], $effb8af77e38bfa6$export$9cc2509453f936aa);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $iptjJ = parcelRequire("iptjJ");
var $9zDWP = parcelRequire("9zDWP");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $1ad247a0d1b0657b$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  @keyframes shake {\n    0% {\n      transform: translateX(0);\n    }\n    25% {\n      transform: translateX(3px);\n    }\n    50% {\n      transform: translateX(-3px);\n    }\n    75% {\n      transform: translateX(3px);\n    }\n    100% {\n      transform: translateX(0);\n    }\n  }\n\n  wui-flex:first-child:not(:only-child) {\n    position: relative;\n  }\n\n  wui-loading-thumbnail {\n    position: absolute;\n  }\n\n  wui-visual {\n    width: var(--wui-wallet-image-size-lg);\n    height: var(--wui-wallet-image-size-lg);\n    border-radius: calc(var(--wui-border-radius-5xs) * 9 - var(--wui-border-radius-xxs));\n    position: relative;\n    overflow: hidden;\n  }\n\n  wui-visual::after {\n    content: '';\n    display: block;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    inset: 0;\n    border-radius: calc(var(--wui-border-radius-5xs) * 9 - var(--wui-border-radius-xxs));\n    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-005);\n  }\n\n  wui-icon-box {\n    position: absolute;\n    right: calc(var(--wui-spacing-3xs) * -1);\n    bottom: calc(var(--wui-spacing-3xs) * -1);\n    opacity: 0;\n    transform: scale(0.5);\n    transition:\n      opacity var(--wui-ease-out-power-2) var(--wui-duration-lg),\n      transform var(--wui-ease-out-power-2) var(--wui-duration-lg);\n    will-change: opacity, transform;\n  }\n\n  wui-text[align='center'] {\n    width: 100%;\n    padding: 0px var(--wui-spacing-l);\n  }\n\n  [data-error='true'] wui-icon-box {\n    opacity: 1;\n    transform: scale(1);\n  }\n\n  [data-error='true'] > wui-flex:first-child {\n    animation: shake 250ms cubic-bezier(0.36, 0.07, 0.19, 0.97) both;\n  }\n\n  [data-retry='false'] wui-link {\n    display: none;\n  }\n\n  [data-retry='true'] wui-link {\n    display: block;\n    opacity: 1;\n  }\n\n  wui-link {\n    padding: var(--wui-spacing-4xs) var(--wui-spacing-xxs);\n  }\n"
    ]);
    $1ad247a0d1b0657b$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $1ad247a0d1b0657b$export$2e2bcd8739ae039 = (0, $2D5eP.css)($1ad247a0d1b0657b$var$_templateObject());


parcelRequire("dSKxG");
var $3QZC1 = parcelRequire("3QZC1");
parcelRequire("kAqXG");
var $04kNM = parcelRequire("04kNM");
function $8abf680811fc5ed0$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex\n        flexDirection="column"\n        alignItems="center"\n        .padding=',
        '\n        gap="xl"\n      >\n        <wui-flex justifyContent="center" flexDirection="column" alignItems="center" gap="xl">\n          <wui-visual name="eth"></wui-visual>\n          <wui-text variant="paragraph-500" color="fg-100" align="center">Switch to EVM</wui-text>\n          <wui-text variant="small-400" color="fg-200" align="center">\n            This feature is not supported on the ',
        " chain. Switch to\n            ",
        ' chain to proceed using it.\n          </wui-text>\n          <wui-button size="md" @click=',
        ">Switch</wui-button>\n        </wui-flex>\n      </wui-flex>\n    "
    ]);
    $8abf680811fc5ed0$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $8abf680811fc5ed0$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $8abf680811fc5ed0$export$4ce390738fa2ca0d = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mSwitchActiveChainView, LitElement);
    var _super = (0, $ohfOJ._)(W3mSwitchActiveChainView);
    function W3mSwitchActiveChainView() {
        (0, $4GJKx._)(this, W3mSwitchActiveChainView);
        var _this;
        var _RouterController_state_data, _RouterController_state_data1, _RouterController_state_data2;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.unsubscribe = [];
        _this.switchToChain = (_RouterController_state_data = (0, $iptjJ.RouterController).state.data) === null || _RouterController_state_data === void 0 ? void 0 : _RouterController_state_data.switchToChain;
        _this.navigateTo = (_RouterController_state_data1 = (0, $iptjJ.RouterController).state.data) === null || _RouterController_state_data1 === void 0 ? void 0 : _RouterController_state_data1.navigateTo;
        _this.navigateWithReplace = (_RouterController_state_data2 = (0, $iptjJ.RouterController).state.data) === null || _RouterController_state_data2 === void 0 ? void 0 : _RouterController_state_data2.navigateWithReplace;
        _this.activeChain = (0, $9zDWP.ChainController).state.activeChain;
        return _this;
    }
    (0, $1wc17._)(W3mSwitchActiveChainView, [
        {
            key: "firstUpdated",
            value: function firstUpdated() {
                var _this = this;
                this.unsubscribe.push((0, $9zDWP.ChainController).subscribeKey("activeChain", function(val) {
                    return _this.activeChain = val;
                }));
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var chainNameString = this.activeChain ? (0, $3QZC1.ConstantsUtil).CHAIN_NAME_MAP[this.activeChain] : "current";
                var switchedChainNameString = this.switchToChain ? (0, $3QZC1.ConstantsUtil).CHAIN_NAME_MAP[this.switchToChain] : "supported";
                return (0, $hxyOZ.html)($8abf680811fc5ed0$var$_templateObject(), [
                    "3xl",
                    "xl",
                    "xl",
                    "xl"
                ], chainNameString, switchedChainNameString, this.switchActiveChain.bind(this));
            }
        },
        {
            key: "switchActiveChain",
            value: function switchActiveChain() {
                if (!this.switchToChain) return;
                (0, $9zDWP.ChainController).setActiveChain(this.switchToChain);
                if (this.navigateTo) {
                    if (this.navigateWithReplace) (0, $iptjJ.RouterController).replace(this.navigateTo);
                    else (0, $iptjJ.RouterController).push(this.navigateTo);
                } else (0, $iptjJ.RouterController).goBack();
            }
        }
    ]);
    return W3mSwitchActiveChainView;
}((0, $2yD3e.LitElement));
$8abf680811fc5ed0$export$4ce390738fa2ca0d.styles = (0, $1ad247a0d1b0657b$export$2e2bcd8739ae039);
$8abf680811fc5ed0$var$__decorate([
    (0, $04kNM.property)()
], $8abf680811fc5ed0$export$4ce390738fa2ca0d.prototype, "activeChain", void 0);
$8abf680811fc5ed0$export$4ce390738fa2ca0d = $8abf680811fc5ed0$var$__decorate([
    (0, $hdxb6.customElement)("w3m-switch-active-chain-view")
], $8abf680811fc5ed0$export$4ce390738fa2ca0d);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("grHtr");
var $dI7zX = parcelRequire("dI7zX");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $80f6784bf97758d6$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host > wui-flex:first-child {\n    overflow-y: auto;\n    overflow-x: hidden;\n    scrollbar-width: none;\n  }\n\n  :host > wui-flex:first-child::-webkit-scrollbar {\n    display: none;\n  }\n\n  .preview-container,\n  .details-container {\n    width: 100%;\n  }\n\n  .token-image {\n    width: 24px;\n    height: 24px;\n    box-shadow: 0 0 0 2px var(--wui-color-gray-glass-005);\n    border-radius: 12px;\n  }\n\n  wui-loading-hexagon {\n    position: absolute;\n  }\n\n  .token-item {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: var(--wui-spacing-xxs);\n    padding: var(--wui-spacing-xs);\n    height: 40px;\n    border: none;\n    border-radius: 80px;\n    background: var(--wui-color-gray-glass-002);\n    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-002);\n    cursor: pointer;\n    transition: background 0.2s linear;\n  }\n\n  .token-item:hover {\n    background: var(--wui-color-gray-glass-005);\n  }\n\n  .preview-token-details-container {\n    width: 100%;\n  }\n\n  .details-row {\n    width: 100%;\n    padding: var(--wui-spacing-s) var(--wui-spacing-xl);\n    border-radius: var(--wui-border-radius-xxs);\n    background: var(--wui-color-gray-glass-002);\n  }\n\n  .action-buttons-container {\n    width: 100%;\n    gap: var(--wui-spacing-xs);\n  }\n\n  .action-buttons-container > button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: transparent;\n    height: 48px;\n    border-radius: var(--wui-border-radius-xs);\n    border: none;\n    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-010);\n  }\n\n  .action-buttons-container > button:disabled {\n    opacity: 0.8;\n    cursor: not-allowed;\n  }\n\n  .action-button > wui-loading-spinner {\n    display: inline-block;\n  }\n\n  .cancel-button:hover,\n  .action-button:hover {\n    cursor: pointer;\n  }\n\n  .action-buttons-container > wui-button.cancel-button {\n    flex: 2;\n  }\n\n  .action-buttons-container > wui-button.action-button {\n    flex: 4;\n  }\n\n  .action-buttons-container > button.action-button > wui-text {\n    color: white;\n  }\n\n  .details-container > wui-flex {\n    background: var(--wui-color-gray-glass-002);\n    border-radius: var(--wui-border-radius-xxs);\n    width: 100%;\n  }\n\n  .details-container > wui-flex > button {\n    border: none;\n    background: none;\n    padding: var(--wui-spacing-s);\n    border-radius: var(--wui-border-radius-xxs);\n    transition: background 0.2s linear;\n  }\n\n  .details-container > wui-flex > button:hover {\n    background: var(--wui-color-gray-glass-002);\n  }\n\n  .details-content-container {\n    padding: var(--wui-spacing-1xs);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .details-content-container > wui-flex {\n    width: 100%;\n  }\n\n  .details-row {\n    width: 100%;\n    padding: var(--wui-spacing-s) var(--wui-spacing-xl);\n    border-radius: var(--wui-border-radius-xxs);\n    background: var(--wui-color-gray-glass-002);\n  }\n"
    ]);
    $80f6784bf97758d6$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $80f6784bf97758d6$export$2e2bcd8739ae039 = (0, $2D5eP.css)($80f6784bf97758d6$var$_templateObject());


parcelRequire("cwWZ7");
var $8DzeN = parcelRequire("8DzeN");
var $fPqxb = parcelRequire("fPqxb");
var $dMLJP = parcelRequire("dMLJP");
var $iptjJ = parcelRequire("iptjJ");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");
function $3480111b0a2726c5$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column" .padding=',
        ' gap="s">\n        ',
        "\n      </wui-flex>\n    "
    ]);
    $3480111b0a2726c5$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $3480111b0a2726c5$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column" alignItems="center" gap="l">\n        <wui-flex class="preview-container" flexDirection="column" alignItems="flex-start" gap="l">\n          <wui-flex\n            class="preview-token-details-container"\n            alignItems="center"\n            justifyContent="space-between"\n            gap="l"\n          >\n            <wui-flex flexDirection="column" alignItems="flex-start" gap="4xs">\n              <wui-text variant="small-400" color="fg-150">Send</wui-text>\n              <wui-text variant="paragraph-400" color="fg-100">$',
        '</wui-text>\n            </wui-flex>\n            <wui-token-button\n              flexDirection="row-reverse"\n              text=',
        "\n              imageSrc=",
        '\n            >\n            </wui-token-button>\n          </wui-flex>\n          <wui-icon name="recycleHorizontal" color="fg-200" size="md"></wui-icon>\n          <wui-flex\n            class="preview-token-details-container"\n            alignItems="center"\n            justifyContent="space-between"\n            gap="l"\n          >\n            <wui-flex flexDirection="column" alignItems="flex-start" gap="4xs">\n              <wui-text variant="small-400" color="fg-150">Receive</wui-text>\n              <wui-text variant="paragraph-400" color="fg-100">$',
        '</wui-text>\n            </wui-flex>\n            <wui-token-button\n              flexDirection="row-reverse"\n              text=',
        "\n              imageSrc=",
        "\n            >\n            </wui-token-button>\n          </wui-flex>\n        </wui-flex>\n\n        ",
        '\n\n        <wui-flex flexDirection="row" alignItems="center" justifyContent="center" gap="xs">\n          <wui-icon size="sm" color="fg-200" name="infoCircle"></wui-icon>\n          <wui-text variant="small-400" color="fg-200">Review transaction carefully</wui-text>\n        </wui-flex>\n\n        <wui-flex\n          class="action-buttons-container"\n          flexDirection="row"\n          alignItems="center"\n          justifyContent="space-between"\n          gap="xs"\n        >\n          <wui-button\n            class="cancel-button"\n            fullWidth\n            size="lg"\n            borderRadius="xs"\n            variant="neutral"\n            @click=',
        '\n          >\n            <wui-text variant="paragraph-600" color="fg-200">Cancel</wui-text>\n          </wui-button>\n          <wui-button\n            class="action-button"\n            fullWidth\n            size="lg"\n            borderRadius="xs"\n            variant="main"\n            ?loading=',
        "\n            ?disabled=",
        "\n            @click=",
        '\n          >\n            <wui-text variant="paragraph-600" color="inverse-100">\n              ',
        "\n            </wui-text>\n          </wui-button>\n        </wui-flex>\n      </wui-flex>\n    "
    ]);
    $3480111b0a2726c5$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $3480111b0a2726c5$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "<w3m-swap-details .detailsOpen=",
        "></w3m-swap-details>"
    ]);
    $3480111b0a2726c5$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $3480111b0a2726c5$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $3480111b0a2726c5$export$2b6fdf515f2cfc8d = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mSwapPreviewView, LitElement);
    var _super = (0, $ohfOJ._)(W3mSwapPreviewView);
    function W3mSwapPreviewView() {
        var _this_unsubscribe;
        (0, $4GJKx._)(this, W3mSwapPreviewView);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.detailsOpen = true;
        _this.approvalTransaction = (0, $8DzeN.SwapController).state.approvalTransaction;
        _this.swapTransaction = (0, $8DzeN.SwapController).state.swapTransaction;
        _this.sourceToken = (0, $8DzeN.SwapController).state.sourceToken;
        var _SwapController_state_sourceTokenAmount;
        _this.sourceTokenAmount = (_SwapController_state_sourceTokenAmount = (0, $8DzeN.SwapController).state.sourceTokenAmount) !== null && _SwapController_state_sourceTokenAmount !== void 0 ? _SwapController_state_sourceTokenAmount : "";
        _this.sourceTokenPriceInUSD = (0, $8DzeN.SwapController).state.sourceTokenPriceInUSD;
        _this.toToken = (0, $8DzeN.SwapController).state.toToken;
        var _SwapController_state_toTokenAmount;
        _this.toTokenAmount = (_SwapController_state_toTokenAmount = (0, $8DzeN.SwapController).state.toTokenAmount) !== null && _SwapController_state_toTokenAmount !== void 0 ? _SwapController_state_toTokenAmount : "";
        _this.toTokenPriceInUSD = (0, $8DzeN.SwapController).state.toTokenPriceInUSD;
        _this.caipNetwork = (0, $fPqxb.NetworkController).state.caipNetwork;
        _this.balanceSymbol = (0, $dMLJP.AccountController).state.balanceSymbol;
        _this.gasPriceInUSD = (0, $8DzeN.SwapController).state.gasPriceInUSD;
        _this.inputError = (0, $8DzeN.SwapController).state.inputError;
        _this.loadingQuote = (0, $8DzeN.SwapController).state.loadingQuote;
        _this.loadingApprovalTransaction = (0, $8DzeN.SwapController).state.loadingApprovalTransaction;
        _this.loadingBuildTransaction = (0, $8DzeN.SwapController).state.loadingBuildTransaction;
        _this.loadingTransaction = (0, $8DzeN.SwapController).state.loadingTransaction;
        (_this_unsubscribe = _this.unsubscribe).push.apply(_this_unsubscribe, [
            (0, $dMLJP.AccountController).subscribeKey("balanceSymbol", function(newBalanceSymbol) {
                if (_this.balanceSymbol !== newBalanceSymbol) (0, $iptjJ.RouterController).goBack();
            }),
            (0, $fPqxb.NetworkController).subscribeKey("caipNetwork", function(newCaipNetwork) {
                if (_this.caipNetwork !== newCaipNetwork) _this.caipNetwork = newCaipNetwork;
            }),
            (0, $8DzeN.SwapController).subscribe(function(newState) {
                _this.approvalTransaction = newState.approvalTransaction;
                _this.swapTransaction = newState.swapTransaction;
                _this.sourceToken = newState.sourceToken;
                _this.gasPriceInUSD = newState.gasPriceInUSD;
                _this.toToken = newState.toToken;
                _this.gasPriceInUSD = newState.gasPriceInUSD;
                _this.toTokenPriceInUSD = newState.toTokenPriceInUSD;
                var _newState_sourceTokenAmount;
                _this.sourceTokenAmount = (_newState_sourceTokenAmount = newState.sourceTokenAmount) !== null && _newState_sourceTokenAmount !== void 0 ? _newState_sourceTokenAmount : "";
                var _newState_toTokenAmount;
                _this.toTokenAmount = (_newState_toTokenAmount = newState.toTokenAmount) !== null && _newState_toTokenAmount !== void 0 ? _newState_toTokenAmount : "";
                _this.inputError = newState.inputError;
                if (newState.inputError) (0, $iptjJ.RouterController).goBack();
                _this.loadingQuote = newState.loadingQuote;
                _this.loadingApprovalTransaction = newState.loadingApprovalTransaction;
                _this.loadingBuildTransaction = newState.loadingBuildTransaction;
                _this.loadingTransaction = newState.loadingTransaction;
            })
        ]);
        return _this;
    }
    (0, $1wc17._)(W3mSwapPreviewView, [
        {
            key: "firstUpdated",
            value: function firstUpdated() {
                (0, $8DzeN.SwapController).getTransaction();
                this.refreshTransaction();
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe === null || unsubscribe === void 0 ? void 0 : unsubscribe();
                });
                clearInterval(this.interval);
            }
        },
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($3480111b0a2726c5$var$_templateObject(), [
                    "0",
                    "l",
                    "l",
                    "l"
                ], this.templateSwap());
            }
        },
        {
            key: "refreshTransaction",
            value: function refreshTransaction() {
                this.interval = setInterval(function() {
                    if (!(0, $8DzeN.SwapController).getApprovalLoadingState()) (0, $8DzeN.SwapController).getTransaction();
                }, 10000);
            }
        },
        {
            key: "templateSwap",
            value: function templateSwap() {
                var _this_sourceToken, _this_toToken, _this_sourceToken1, _this_toToken1;
                var sourceTokenText = "".concat((0, $dI7zX.UiHelperUtil).formatNumberToLocalString(parseFloat(this.sourceTokenAmount)), " ").concat((_this_sourceToken = this.sourceToken) === null || _this_sourceToken === void 0 ? void 0 : _this_sourceToken.symbol);
                var toTokenText = "".concat((0, $dI7zX.UiHelperUtil).formatNumberToLocalString(parseFloat(this.toTokenAmount)), " ").concat((_this_toToken = this.toToken) === null || _this_toToken === void 0 ? void 0 : _this_toToken.symbol);
                var sourceTokenValue = parseFloat(this.sourceTokenAmount) * this.sourceTokenPriceInUSD;
                var toTokenValue = parseFloat(this.toTokenAmount) * this.toTokenPriceInUSD - (this.gasPriceInUSD || 0);
                var sentPrice = (0, $dI7zX.UiHelperUtil).formatNumberToLocalString(sourceTokenValue);
                var receivePrice = (0, $dI7zX.UiHelperUtil).formatNumberToLocalString(toTokenValue);
                var loading = this.loadingQuote || this.loadingBuildTransaction || this.loadingTransaction || this.loadingApprovalTransaction;
                return (0, $hxyOZ.html)($3480111b0a2726c5$var$_templateObject1(), sentPrice, sourceTokenText, (_this_sourceToken1 = this.sourceToken) === null || _this_sourceToken1 === void 0 ? void 0 : _this_sourceToken1.logoUri, receivePrice, toTokenText, (_this_toToken1 = this.toToken) === null || _this_toToken1 === void 0 ? void 0 : _this_toToken1.logoUri, this.templateDetails(), this.onCancelTransaction.bind(this), loading, loading, this.onSendTransaction.bind(this), this.actionButtonLabel());
            }
        },
        {
            key: "templateDetails",
            value: function templateDetails() {
                if (!this.sourceToken || !this.toToken || this.inputError) return null;
                return (0, $hxyOZ.html)($3480111b0a2726c5$var$_templateObject2(), this.detailsOpen);
            }
        },
        {
            key: "actionButtonLabel",
            value: function actionButtonLabel() {
                if (this.loadingApprovalTransaction) return "Approving...";
                if (this.approvalTransaction) return "Approve";
                return "Swap";
            }
        },
        {
            key: "onCancelTransaction",
            value: function onCancelTransaction() {
                (0, $iptjJ.RouterController).goBack();
            }
        },
        {
            key: "onSendTransaction",
            value: function onSendTransaction() {
                if (this.approvalTransaction) (0, $8DzeN.SwapController).sendTransactionForApproval(this.approvalTransaction);
                else (0, $8DzeN.SwapController).sendTransactionForSwap(this.swapTransaction);
            }
        }
    ]);
    return W3mSwapPreviewView;
}((0, $2yD3e.LitElement));
$3480111b0a2726c5$export$2b6fdf515f2cfc8d.styles = (0, $80f6784bf97758d6$export$2e2bcd8739ae039);
$3480111b0a2726c5$var$__decorate([
    (0, $334Pv.state)()
], $3480111b0a2726c5$export$2b6fdf515f2cfc8d.prototype, "interval", void 0);
$3480111b0a2726c5$var$__decorate([
    (0, $334Pv.state)()
], $3480111b0a2726c5$export$2b6fdf515f2cfc8d.prototype, "detailsOpen", void 0);
$3480111b0a2726c5$var$__decorate([
    (0, $334Pv.state)()
], $3480111b0a2726c5$export$2b6fdf515f2cfc8d.prototype, "approvalTransaction", void 0);
$3480111b0a2726c5$var$__decorate([
    (0, $334Pv.state)()
], $3480111b0a2726c5$export$2b6fdf515f2cfc8d.prototype, "swapTransaction", void 0);
$3480111b0a2726c5$var$__decorate([
    (0, $334Pv.state)()
], $3480111b0a2726c5$export$2b6fdf515f2cfc8d.prototype, "sourceToken", void 0);
$3480111b0a2726c5$var$__decorate([
    (0, $334Pv.state)()
], $3480111b0a2726c5$export$2b6fdf515f2cfc8d.prototype, "sourceTokenAmount", void 0);
$3480111b0a2726c5$var$__decorate([
    (0, $334Pv.state)()
], $3480111b0a2726c5$export$2b6fdf515f2cfc8d.prototype, "sourceTokenPriceInUSD", void 0);
$3480111b0a2726c5$var$__decorate([
    (0, $334Pv.state)()
], $3480111b0a2726c5$export$2b6fdf515f2cfc8d.prototype, "toToken", void 0);
$3480111b0a2726c5$var$__decorate([
    (0, $334Pv.state)()
], $3480111b0a2726c5$export$2b6fdf515f2cfc8d.prototype, "toTokenAmount", void 0);
$3480111b0a2726c5$var$__decorate([
    (0, $334Pv.state)()
], $3480111b0a2726c5$export$2b6fdf515f2cfc8d.prototype, "toTokenPriceInUSD", void 0);
$3480111b0a2726c5$var$__decorate([
    (0, $334Pv.state)()
], $3480111b0a2726c5$export$2b6fdf515f2cfc8d.prototype, "caipNetwork", void 0);
$3480111b0a2726c5$var$__decorate([
    (0, $334Pv.state)()
], $3480111b0a2726c5$export$2b6fdf515f2cfc8d.prototype, "balanceSymbol", void 0);
$3480111b0a2726c5$var$__decorate([
    (0, $334Pv.state)()
], $3480111b0a2726c5$export$2b6fdf515f2cfc8d.prototype, "gasPriceInUSD", void 0);
$3480111b0a2726c5$var$__decorate([
    (0, $334Pv.state)()
], $3480111b0a2726c5$export$2b6fdf515f2cfc8d.prototype, "inputError", void 0);
$3480111b0a2726c5$var$__decorate([
    (0, $334Pv.state)()
], $3480111b0a2726c5$export$2b6fdf515f2cfc8d.prototype, "loadingQuote", void 0);
$3480111b0a2726c5$var$__decorate([
    (0, $334Pv.state)()
], $3480111b0a2726c5$export$2b6fdf515f2cfc8d.prototype, "loadingApprovalTransaction", void 0);
$3480111b0a2726c5$var$__decorate([
    (0, $334Pv.state)()
], $3480111b0a2726c5$export$2b6fdf515f2cfc8d.prototype, "loadingBuildTransaction", void 0);
$3480111b0a2726c5$var$__decorate([
    (0, $334Pv.state)()
], $3480111b0a2726c5$export$2b6fdf515f2cfc8d.prototype, "loadingTransaction", void 0);
$3480111b0a2726c5$export$2b6fdf515f2cfc8d = $3480111b0a2726c5$var$__decorate([
    (0, $hdxb6.customElement)("w3m-swap-preview-view")
], $3480111b0a2726c5$export$2b6fdf515f2cfc8d);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $04RAu = parcelRequire("04RAu");

var $b8Rim = parcelRequire("b8Rim");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("grHtr");
var $giGFz = parcelRequire("giGFz");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $f867456bdceb6b6c$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    --tokens-scroll--top-opacity: 0;\n    --tokens-scroll--bottom-opacity: 1;\n    --suggested-tokens-scroll--left-opacity: 0;\n    --suggested-tokens-scroll--right-opacity: 1;\n  }\n\n  :host > wui-flex:first-child {\n    overflow-y: hidden;\n    overflow-x: hidden;\n    scrollbar-width: none;\n    scrollbar-height: none;\n  }\n\n  :host > wui-flex:first-child::-webkit-scrollbar {\n    display: none;\n  }\n\n  wui-loading-hexagon {\n    position: absolute;\n  }\n\n  .suggested-tokens-container {\n    overflow-x: auto;\n    mask-image: linear-gradient(\n      to right,\n      rgba(0, 0, 0, calc(1 - var(--suggested-tokens-scroll--left-opacity))) 0px,\n      rgba(200, 200, 200, calc(1 - var(--suggested-tokens-scroll--left-opacity))) 1px,\n      black 50px,\n      black 90px,\n      black calc(100% - 90px),\n      black calc(100% - 50px),\n      rgba(155, 155, 155, calc(1 - var(--suggested-tokens-scroll--right-opacity))) calc(100% - 1px),\n      rgba(0, 0, 0, calc(1 - var(--suggested-tokens-scroll--right-opacity))) 100%\n    );\n  }\n\n  .suggested-tokens-container::-webkit-scrollbar {\n    display: none;\n  }\n\n  .tokens-container {\n    border-top: 1px solid var(--wui-color-gray-glass-005);\n    height: 100%;\n    max-height: 390px;\n  }\n\n  .tokens {\n    width: 100%;\n    overflow-y: auto;\n    mask-image: linear-gradient(\n      to bottom,\n      rgba(0, 0, 0, calc(1 - var(--tokens-scroll--top-opacity))) 0px,\n      rgba(200, 200, 200, calc(1 - var(--tokens-scroll--top-opacity))) 1px,\n      black 50px,\n      black 90px,\n      black calc(100% - 90px),\n      black calc(100% - 50px),\n      rgba(155, 155, 155, calc(1 - var(--tokens-scroll--bottom-opacity))) calc(100% - 1px),\n      rgba(0, 0, 0, calc(1 - var(--tokens-scroll--bottom-opacity))) 100%\n    );\n  }\n\n  .network-search-input,\n  .select-network-button {\n    height: 40px;\n  }\n\n  .select-network-button {\n    border: none;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    gap: var(--wui-spacing-xs);\n    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-005);\n    background-color: transparent;\n    border-radius: var(--wui-border-radius-xxs);\n    padding: var(--wui-spacing-xs);\n    align-items: center;\n    transition: background-color 0.2s linear;\n  }\n\n  .select-network-button:hover {\n    background-color: var(--wui-color-gray-glass-002);\n  }\n\n  .select-network-button > wui-image {\n    width: 26px;\n    height: 26px;\n    border-radius: var(--wui-border-radius-xs);\n    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-010);\n  }\n"
    ]);
    $f867456bdceb6b6c$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $f867456bdceb6b6c$export$2e2bcd8739ae039 = (0, $2D5eP.css)($f867456bdceb6b6c$var$_templateObject());


parcelRequire("cwWZ7");
var $iptjJ = parcelRequire("iptjJ");
var $8DzeN = parcelRequire("8DzeN");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");
function $b7f2850fe0fb12d8$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column" gap="s">\n        ',
        " ",
        " ",
        "\n      </wui-flex>\n    "
    ]);
    $b7f2850fe0fb12d8$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $b7f2850fe0fb12d8$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "\n      <wui-flex .padding=",
        ' gap="xs">\n        <wui-input-text\n          data-testid="swap-select-token-search-input"\n          class="network-search-input"\n          size="sm"\n          placeholder="Search token"\n          icon="search"\n          .value=',
        "\n          @inputChange=",
        "\n        ></wui-input-text>\n      </wui-flex>\n    "
    ]);
    $b7f2850fe0fb12d8$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $b7f2850fe0fb12d8$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '\n                    <wui-token-list-item\n                      data-testid="swap-select-token-item-',
        '"\n                      name=',
        "\n                      ?disabled=",
        "\n                      symbol=",
        "\n                      price=",
        "\n                      amount=",
        "\n                      imageSrc=",
        "\n                      @click=",
        "\n                    >\n                    </wui-token-list-item>\n                  "
    ]);
    $b7f2850fe0fb12d8$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $b7f2850fe0fb12d8$var$_templateObject3() {
    var data = (0, $j06k0._)([
        '\n                <wui-flex justifyContent="flex-start" padding="s">\n                  <wui-text variant="paragraph-500" color="fg-200">Your tokens</wui-text>\n                </wui-flex>\n                ',
        "\n              "
    ]);
    $b7f2850fe0fb12d8$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $b7f2850fe0fb12d8$var$_templateObject4() {
    var data = (0, $j06k0._)([
        '\n                  <wui-token-list-item\n                    data-testid="swap-select-token-item-',
        '"\n                    name=',
        "\n                    symbol=",
        "\n                    imageSrc=",
        "\n                    @click=",
        "\n                  >\n                  </wui-token-list-item>\n                "
    ]);
    $b7f2850fe0fb12d8$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $b7f2850fe0fb12d8$var$_templateObject5() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex class="tokens-container">\n        <wui-flex class="tokens" .padding=',
        ' flexDirection="column">\n          ',
        '\n\n          <wui-flex justifyContent="flex-start" padding="s">\n            <wui-text variant="paragraph-500" color="fg-200">Tokens</wui-text>\n          </wui-flex>\n          ',
        "\n        </wui-flex>\n      </wui-flex>\n    "
    ]);
    $b7f2850fe0fb12d8$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $b7f2850fe0fb12d8$var$_templateObject6() {
    var data = (0, $j06k0._)([
        "\n            <wui-token-button\n              text=",
        "\n              imageSrc=",
        "\n              @click=",
        "\n            >\n            </wui-token-button>\n          "
    ]);
    $b7f2850fe0fb12d8$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $b7f2850fe0fb12d8$var$_templateObject7() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex class="suggested-tokens-container" .padding=',
        ' gap="xs">\n        ',
        "\n      </wui-flex>\n    "
    ]);
    $b7f2850fe0fb12d8$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
var $b7f2850fe0fb12d8$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $b7f2850fe0fb12d8$export$f787d9978790b696 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mSwapSelectTokenView, LitElement);
    var _super = (0, $ohfOJ._)(W3mSwapSelectTokenView);
    function W3mSwapSelectTokenView() {
        var _this_unsubscribe;
        (0, $4GJKx._)(this, W3mSwapSelectTokenView);
        var _this;
        var _RouterController_state_data;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.targetToken = (_RouterController_state_data = (0, $iptjJ.RouterController).state.data) === null || _RouterController_state_data === void 0 ? void 0 : _RouterController_state_data.target;
        _this.sourceToken = (0, $8DzeN.SwapController).state.sourceToken;
        _this.sourceTokenAmount = (0, $8DzeN.SwapController).state.sourceTokenAmount;
        _this.toToken = (0, $8DzeN.SwapController).state.toToken;
        _this.myTokensWithBalance = (0, $8DzeN.SwapController).state.myTokensWithBalance;
        _this.popularTokens = (0, $8DzeN.SwapController).state.popularTokens;
        _this.searchValue = "";
        (_this_unsubscribe = _this.unsubscribe).push.apply(_this_unsubscribe, [
            (0, $8DzeN.SwapController).subscribe(function(newState) {
                _this.sourceToken = newState.sourceToken;
                _this.toToken = newState.toToken;
                _this.myTokensWithBalance = newState.myTokensWithBalance;
            })
        ]);
        return _this;
    }
    (0, $1wc17._)(W3mSwapSelectTokenView, [
        {
            key: "updated",
            value: function updated() {
                var _this_renderRoot, _this_renderRoot1;
                var suggestedTokensContainer = (_this_renderRoot = this.renderRoot) === null || _this_renderRoot === void 0 ? void 0 : _this_renderRoot.querySelector(".suggested-tokens-container");
                suggestedTokensContainer === null || suggestedTokensContainer === void 0 ? void 0 : suggestedTokensContainer.addEventListener("scroll", this.handleSuggestedTokensScroll.bind(this));
                var tokensList = (_this_renderRoot1 = this.renderRoot) === null || _this_renderRoot1 === void 0 ? void 0 : _this_renderRoot1.querySelector(".tokens");
                tokensList === null || tokensList === void 0 ? void 0 : tokensList.addEventListener("scroll", this.handleTokenListScroll.bind(this));
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                var _this_renderRoot, _this_renderRoot1;
                (0, $04RAu._)((0, $b8Rim._)(W3mSwapSelectTokenView.prototype), "disconnectedCallback", this).call(this);
                var suggestedTokensContainer = (_this_renderRoot = this.renderRoot) === null || _this_renderRoot === void 0 ? void 0 : _this_renderRoot.querySelector(".suggested-tokens-container");
                var tokensList = (_this_renderRoot1 = this.renderRoot) === null || _this_renderRoot1 === void 0 ? void 0 : _this_renderRoot1.querySelector(".tokens");
                suggestedTokensContainer === null || suggestedTokensContainer === void 0 ? void 0 : suggestedTokensContainer.removeEventListener("scroll", this.handleSuggestedTokensScroll.bind(this));
                tokensList === null || tokensList === void 0 ? void 0 : tokensList.removeEventListener("scroll", this.handleTokenListScroll.bind(this));
                clearInterval(this.interval);
            }
        },
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($b7f2850fe0fb12d8$var$_templateObject(), this.templateSearchInput(), this.templateSuggestedTokens(), this.templateTokens());
            }
        },
        {
            key: "onSelectToken",
            value: function onSelectToken(token) {
                if (this.targetToken === "sourceToken") (0, $8DzeN.SwapController).setSourceToken(token);
                else {
                    (0, $8DzeN.SwapController).setToToken(token);
                    if (this.sourceToken && this.sourceTokenAmount) (0, $8DzeN.SwapController).swapTokens();
                }
                (0, $iptjJ.RouterController).goBack();
            }
        },
        {
            key: "templateSearchInput",
            value: function templateSearchInput() {
                return (0, $hxyOZ.html)($b7f2850fe0fb12d8$var$_templateObject1(), [
                    "3xs",
                    "s",
                    "0",
                    "s"
                ], this.searchValue, this.onSearchInputChange.bind(this));
            }
        },
        {
            key: "templateTokens",
            value: function templateTokens() {
                var _this = this;
                var yourTokens = this.myTokensWithBalance ? Object.values(this.myTokensWithBalance) : [];
                var tokens = this.popularTokens ? this.popularTokens : [];
                var filteredYourTokens = this.filterTokensWithText(yourTokens, this.searchValue);
                var filteredTokens = this.filterTokensWithText(tokens, this.searchValue);
                return (0, $hxyOZ.html)($b7f2850fe0fb12d8$var$_templateObject5(), [
                    "0",
                    "s",
                    "s",
                    "s"
                ], (filteredYourTokens === null || filteredYourTokens === void 0 ? void 0 : filteredYourTokens.length) > 0 ? (0, $hxyOZ.html)($b7f2850fe0fb12d8$var$_templateObject3(), filteredYourTokens.map(function(token) {
                    var _this_sourceToken, _this_toToken, _token_quantity;
                    var selected = token.symbol === ((_this_sourceToken = _this.sourceToken) === null || _this_sourceToken === void 0 ? void 0 : _this_sourceToken.symbol) || token.symbol === ((_this_toToken = _this.toToken) === null || _this_toToken === void 0 ? void 0 : _this_toToken.symbol);
                    return (0, $hxyOZ.html)($b7f2850fe0fb12d8$var$_templateObject2(), token.symbol, token.name, selected, token.symbol, token === null || token === void 0 ? void 0 : token.price, token === null || token === void 0 ? void 0 : (_token_quantity = token.quantity) === null || _token_quantity === void 0 ? void 0 : _token_quantity.numeric, token.logoUri, function() {
                        if (!selected) _this.onSelectToken(token);
                    });
                })) : null, (filteredTokens === null || filteredTokens === void 0 ? void 0 : filteredTokens.length) > 0 ? filteredTokens.map(function(token) {
                    return (0, $hxyOZ.html)($b7f2850fe0fb12d8$var$_templateObject4(), token.symbol, token.name, token.symbol, token.logoUri, function() {
                        return _this.onSelectToken(token);
                    });
                }) : null);
            }
        },
        {
            key: "templateSuggestedTokens",
            value: function templateSuggestedTokens() {
                var _this = this;
                var tokens = (0, $8DzeN.SwapController).state.suggestedTokens ? (0, $8DzeN.SwapController).state.suggestedTokens.slice(0, 8) : null;
                if (!tokens) return null;
                return (0, $hxyOZ.html)($b7f2850fe0fb12d8$var$_templateObject7(), [
                    "0",
                    "s",
                    "0",
                    "s"
                ], tokens.map(function(token) {
                    return (0, $hxyOZ.html)($b7f2850fe0fb12d8$var$_templateObject6(), token.symbol, token.logoUri, function() {
                        return _this.onSelectToken(token);
                    });
                }));
            }
        },
        {
            key: "onSearchInputChange",
            value: function onSearchInputChange(event) {
                this.searchValue = event.detail;
            }
        },
        {
            key: "handleSuggestedTokensScroll",
            value: function handleSuggestedTokensScroll() {
                var _this_renderRoot;
                var container = (_this_renderRoot = this.renderRoot) === null || _this_renderRoot === void 0 ? void 0 : _this_renderRoot.querySelector(".suggested-tokens-container");
                if (!container) return;
                container.style.setProperty("--suggested-tokens-scroll--left-opacity", (0, $giGFz.MathUtil).interpolate([
                    0,
                    100
                ], [
                    0,
                    1
                ], container.scrollLeft).toString());
                container.style.setProperty("--suggested-tokens-scroll--right-opacity", (0, $giGFz.MathUtil).interpolate([
                    0,
                    100
                ], [
                    0,
                    1
                ], container.scrollWidth - container.scrollLeft - container.offsetWidth).toString());
            }
        },
        {
            key: "handleTokenListScroll",
            value: function handleTokenListScroll() {
                var _this_renderRoot;
                var container = (_this_renderRoot = this.renderRoot) === null || _this_renderRoot === void 0 ? void 0 : _this_renderRoot.querySelector(".tokens");
                if (!container) return;
                container.style.setProperty("--tokens-scroll--top-opacity", (0, $giGFz.MathUtil).interpolate([
                    0,
                    100
                ], [
                    0,
                    1
                ], container.scrollTop).toString());
                container.style.setProperty("--tokens-scroll--bottom-opacity", (0, $giGFz.MathUtil).interpolate([
                    0,
                    100
                ], [
                    0,
                    1
                ], container.scrollHeight - container.scrollTop - container.offsetHeight).toString());
            }
        },
        {
            key: "filterTokensWithText",
            value: function filterTokensWithText(tokens, text) {
                return tokens.filter(function(token) {
                    return "".concat(token.symbol, " ").concat(token.name, " ").concat(token.address).toLowerCase().includes(text.toLowerCase());
                });
            }
        }
    ]);
    return W3mSwapSelectTokenView;
}((0, $2yD3e.LitElement));
$b7f2850fe0fb12d8$export$f787d9978790b696.styles = (0, $f867456bdceb6b6c$export$2e2bcd8739ae039);
$b7f2850fe0fb12d8$var$__decorate([
    (0, $334Pv.state)()
], $b7f2850fe0fb12d8$export$f787d9978790b696.prototype, "interval", void 0);
$b7f2850fe0fb12d8$var$__decorate([
    (0, $334Pv.state)()
], $b7f2850fe0fb12d8$export$f787d9978790b696.prototype, "targetToken", void 0);
$b7f2850fe0fb12d8$var$__decorate([
    (0, $334Pv.state)()
], $b7f2850fe0fb12d8$export$f787d9978790b696.prototype, "sourceToken", void 0);
$b7f2850fe0fb12d8$var$__decorate([
    (0, $334Pv.state)()
], $b7f2850fe0fb12d8$export$f787d9978790b696.prototype, "sourceTokenAmount", void 0);
$b7f2850fe0fb12d8$var$__decorate([
    (0, $334Pv.state)()
], $b7f2850fe0fb12d8$export$f787d9978790b696.prototype, "toToken", void 0);
$b7f2850fe0fb12d8$var$__decorate([
    (0, $334Pv.state)()
], $b7f2850fe0fb12d8$export$f787d9978790b696.prototype, "myTokensWithBalance", void 0);
$b7f2850fe0fb12d8$var$__decorate([
    (0, $334Pv.state)()
], $b7f2850fe0fb12d8$export$f787d9978790b696.prototype, "popularTokens", void 0);
$b7f2850fe0fb12d8$var$__decorate([
    (0, $334Pv.state)()
], $b7f2850fe0fb12d8$export$f787d9978790b696.prototype, "searchValue", void 0);
$b7f2850fe0fb12d8$export$f787d9978790b696 = $b7f2850fe0fb12d8$var$__decorate([
    (0, $hdxb6.customElement)("w3m-swap-select-token-view")
], $b7f2850fe0fb12d8$export$f787d9978790b696);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $70525f91dd794487$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host > wui-flex:first-child {\n    height: 500px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    scrollbar-width: none;\n  }\n\n  :host > wui-flex:first-child::-webkit-scrollbar {\n    display: none;\n  }\n"
    ]);
    $70525f91dd794487$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $70525f91dd794487$export$2e2bcd8739ae039 = (0, $2D5eP.css)($70525f91dd794487$var$_templateObject());


function $9fe2d001293cca50$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column" .padding=',
        ' gap="s">\n        <w3m-activity-list page="activity"></w3m-activity-list>\n      </wui-flex>\n    '
    ]);
    $9fe2d001293cca50$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $9fe2d001293cca50$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9fe2d001293cca50$export$5b9982998ebc2231 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mTransactionsView, LitElement);
    var _super = (0, $ohfOJ._)(W3mTransactionsView);
    function W3mTransactionsView() {
        (0, $4GJKx._)(this, W3mTransactionsView);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(W3mTransactionsView, [
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($9fe2d001293cca50$var$_templateObject(), [
                    "0",
                    "m",
                    "m",
                    "m"
                ]);
            }
        }
    ]);
    return W3mTransactionsView;
}((0, $2yD3e.LitElement));
$9fe2d001293cca50$export$5b9982998ebc2231.styles = (0, $70525f91dd794487$export$2e2bcd8739ae039);
$9fe2d001293cca50$export$5b9982998ebc2231 = $9fe2d001293cca50$var$__decorate([
    (0, $hdxb6.customElement)("w3m-transactions-view")
], $9fe2d001293cca50$export$5b9982998ebc2231);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $hZBJb = parcelRequire("hZBJb");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
function $dc085ddf115f6d2c$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex\n        flexDirection="column"\n        .padding=',
        '\n        alignItems="center"\n        gap="xl"\n      >\n        <w3m-help-widget .data=',
        '></w3m-help-widget>\n        <wui-button\n          variant="main"\n          size="md"\n          @click=',
        '\n        >\n          Learn more\n          <wui-icon color="inherit" slot="iconRight" name="externalLink"></wui-icon>\n        </wui-button>\n      </wui-flex>\n    '
    ]);
    $dc085ddf115f6d2c$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $dc085ddf115f6d2c$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $dc085ddf115f6d2c$var$data = [
    {
        images: [
            "network",
            "layers",
            "system"
        ],
        title: "The system\u2019s nuts and bolts",
        text: "A network is what brings the blockchain to life, as this technical infrastructure allows apps to access the ledger and smart contract services."
    },
    {
        images: [
            "noun",
            "defiAlt",
            "dao"
        ],
        title: "Designed for different uses",
        text: "Each network is designed differently, and may therefore suit certain apps and experiences."
    }
];
var $dc085ddf115f6d2c$export$e747cd062ecb4580 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mWhatIsANetworkView, LitElement);
    var _super = (0, $ohfOJ._)(W3mWhatIsANetworkView);
    function W3mWhatIsANetworkView() {
        (0, $4GJKx._)(this, W3mWhatIsANetworkView);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(W3mWhatIsANetworkView, [
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($dc085ddf115f6d2c$var$_templateObject(), [
                    "xxl",
                    "xl",
                    "xl",
                    "xl"
                ], $dc085ddf115f6d2c$var$data, function() {
                    (0, $hZBJb.CoreHelperUtil).openHref("https://ethereum.org/en/developers/docs/networks/", "_blank");
                });
            }
        }
    ]);
    return W3mWhatIsANetworkView;
}((0, $2yD3e.LitElement));
$dc085ddf115f6d2c$export$e747cd062ecb4580 = $dc085ddf115f6d2c$var$__decorate([
    (0, $hdxb6.customElement)("w3m-what-is-a-network-view")
], $dc085ddf115f6d2c$export$e747cd062ecb4580);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $1QDT9 = parcelRequire("1QDT9");
var $iptjJ = parcelRequire("iptjJ");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
function $c26b150dbb7ae71b$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex\n        flexDirection="column"\n        .padding=',
        '\n        alignItems="center"\n        gap="xl"\n      >\n        <w3m-help-widget .data=',
        '></w3m-help-widget>\n        <wui-button variant="main" size="md" @click=',
        '>\n          <wui-icon color="inherit" slot="iconLeft" name="wallet"></wui-icon>\n          Get a wallet\n        </wui-button>\n      </wui-flex>\n    '
    ]);
    $c26b150dbb7ae71b$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $c26b150dbb7ae71b$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c26b150dbb7ae71b$var$data = [
    {
        images: [
            "login",
            "profile",
            "lock"
        ],
        title: "One login for all of web3",
        text: "Log in to any app by connecting your wallet. Say goodbye to countless passwords!"
    },
    {
        images: [
            "defi",
            "nft",
            "eth"
        ],
        title: "A home for your digital assets",
        text: "A wallet lets you store, send and receive digital assets like cryptocurrencies and NFTs."
    },
    {
        images: [
            "browser",
            "noun",
            "dao"
        ],
        title: "Your gateway to a new web",
        text: "With your wallet, you can explore and interact with DeFi, NFTs, DAOs, and much more."
    }
];
var $c26b150dbb7ae71b$export$16ac3b6705a4e652 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mWhatIsAWalletView, LitElement);
    var _super = (0, $ohfOJ._)(W3mWhatIsAWalletView);
    function W3mWhatIsAWalletView() {
        (0, $4GJKx._)(this, W3mWhatIsAWalletView);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(W3mWhatIsAWalletView, [
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($c26b150dbb7ae71b$var$_templateObject(), [
                    "xxl",
                    "xl",
                    "xl",
                    "xl"
                ], $c26b150dbb7ae71b$var$data, this.onGetWallet.bind(this));
            }
        },
        {
            key: "onGetWallet",
            value: function onGetWallet() {
                (0, $1QDT9.EventsController).sendEvent({
                    type: "track",
                    event: "CLICK_GET_WALLET"
                });
                (0, $iptjJ.RouterController).push("GetWallet");
            }
        }
    ]);
    return W3mWhatIsAWalletView;
}((0, $2yD3e.LitElement));
$c26b150dbb7ae71b$export$16ac3b6705a4e652 = $c26b150dbb7ae71b$var$__decorate([
    (0, $hdxb6.customElement)("w3m-what-is-a-wallet-view")
], $c26b150dbb7ae71b$export$16ac3b6705a4e652);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("cwWZ7");
var $iptjJ = parcelRequire("iptjJ");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
function $5933376da8c54a9a$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex\n        flexDirection="column"\n        .padding=',
        '\n        alignItems="center"\n        gap="xl"\n      >\n        <wui-visual name="onrampCard"></wui-visual>\n        <wui-flex flexDirection="column" gap="xs" alignItems="center">\n          <wui-text align="center" variant="paragraph-500" color="fg-100">\n            Quickly and easily buy digital assets!\n          </wui-text>\n          <wui-text align="center" variant="small-400" color="fg-200">\n            Simply select your preferred onramp provider and add digital assets to your account\n            using your credit card or bank transfer\n          </wui-text>\n        </wui-flex>\n        <wui-button @click=',
        '>\n          <wui-icon size="sm" color="inherit" name="add" slot="iconLeft"></wui-icon>\n          Buy\n        </wui-button>\n      </wui-flex>\n    '
    ]);
    $5933376da8c54a9a$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $5933376da8c54a9a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $5933376da8c54a9a$export$c63d73b9361e157e = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mWhatIsABuyView, LitElement);
    var _super = (0, $ohfOJ._)(W3mWhatIsABuyView);
    function W3mWhatIsABuyView() {
        (0, $4GJKx._)(this, W3mWhatIsABuyView);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(W3mWhatIsABuyView, [
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($5933376da8c54a9a$var$_templateObject(), [
                    "xxl",
                    "3xl",
                    "xl",
                    "3xl"
                ], (0, $iptjJ.RouterController).goBack);
            }
        }
    ]);
    return W3mWhatIsABuyView;
}((0, $2yD3e.LitElement));
$5933376da8c54a9a$export$c63d73b9361e157e = $5933376da8c54a9a$var$__decorate([
    (0, $hdxb6.customElement)("w3m-what-is-a-buy-view")
], $5933376da8c54a9a$export$c63d73b9361e157e);



var $d3H5E = parcelRequire("d3H5E");

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("cwWZ7");
var $iptjJ = parcelRequire("iptjJ");
var $2qlRb = parcelRequire("2qlRb");
var $hZBJb = parcelRequire("hZBJb");
var $8FcCV = parcelRequire("8FcCV");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $c06436792636ec0b$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  wui-loading-spinner {\n    margin: 9px auto;\n  }\n\n  .email-display,\n  .email-display wui-text {\n    max-width: 100%;\n  }\n"
    ]);
    $c06436792636ec0b$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $c06436792636ec0b$export$2e2bcd8739ae039 = (0, $2D5eP.css)($c06436792636ec0b$var$_templateObject());


parcelRequire("hsyMZ");
var $2ZXsZ = parcelRequire("2ZXsZ");
function $c873eaad6f63047d$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<wui-loading-spinner size="xl" color="accent-100"></wui-loading-spinner>'
    ]);
    $c873eaad6f63047d$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $c873eaad6f63047d$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '\n                    <wui-text variant="small-400" align="center" color="error-100">\n                      ',
        ". Try Again\n                    </wui-text>\n                  "
    ]);
    $c873eaad6f63047d$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $c873eaad6f63047d$var$_templateObject2() {
    var data = (0, $j06k0._)([
        ' <wui-flex flexDirection="column" alignItems="center" gap="xs">\n              <wui-otp\n                dissabled\n                length="6"\n                @inputChange=',
        "\n                .otp=",
        "\n              ></wui-otp>\n              ",
        "\n            </wui-flex>"
    ]);
    $c873eaad6f63047d$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $c873eaad6f63047d$var$_templateObject3() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex\n        flexDirection="column"\n        alignItems="center"\n        .padding=',
        '\n        gap="l"\n      >\n        <wui-flex\n          class="email-display"\n          flexDirection="column"\n          alignItems="center"\n          .padding=',
        '\n        >\n          <wui-text variant="paragraph-400" color="fg-100" align="center">\n            Enter the code we sent to\n          </wui-text>\n          <wui-text variant="paragraph-500" color="fg-100" lineClamp="1" align="center">\n            ',
        '\n          </wui-text>\n        </wui-flex>\n\n        <wui-text variant="small-400" color="fg-200">The code expires in 20 minutes</wui-text>\n\n        ',
        '\n\n        <wui-flex alignItems="center" gap="xs">\n          <wui-text variant="small-400" color="fg-200">',
        "</wui-text>\n          <wui-link @click=",
        " .disabled=",
        ">\n            ",
        "\n          </wui-link>\n        </wui-flex>\n      </wui-flex>\n    "
    ]);
    $c873eaad6f63047d$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var $c873eaad6f63047d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c873eaad6f63047d$var$OTP_LENGTH = 6;
var $c873eaad6f63047d$export$84443566fe241bc9 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mEmailOtpWidget, LitElement);
    var _super = (0, $ohfOJ._)(W3mEmailOtpWidget);
    function W3mEmailOtpWidget() {
        (0, $4GJKx._)(this, W3mEmailOtpWidget);
        var _this;
        var _RouterController_state_data;
        _this = _super.call(this);
        _this.loading = false;
        _this.timeoutTimeLeft = (0, $2ZXsZ.W3mFrameHelpers).getTimeToNextEmailLogin();
        _this.error = "";
        _this.otp = "";
        _this.email = (_RouterController_state_data = (0, $iptjJ.RouterController).state.data) === null || _RouterController_state_data === void 0 ? void 0 : _RouterController_state_data.email;
        _this.authConnector = (0, $2qlRb.ConnectorController).getAuthConnector();
        return _this;
    }
    (0, $1wc17._)(W3mEmailOtpWidget, [
        {
            key: "firstUpdated",
            value: function firstUpdated() {
                this.startOTPTimeout();
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                clearTimeout(this.OTPTimeout);
            }
        },
        {
            key: "render",
            value: function render() {
                if (!this.email) throw new Error("w3m-email-otp-widget: No email provided");
                var isResendDisabled = Boolean(this.timeoutTimeLeft);
                var footerLabels = this.getFooterLabels(isResendDisabled);
                return (0, $hxyOZ.html)($c873eaad6f63047d$var$_templateObject3(), [
                    "l",
                    "0",
                    "l",
                    "0"
                ], [
                    "0",
                    "xl",
                    "0",
                    "xl"
                ], this.email, this.loading ? (0, $hxyOZ.html)($c873eaad6f63047d$var$_templateObject()) : (0, $hxyOZ.html)($c873eaad6f63047d$var$_templateObject2(), this.onOtpInputChange.bind(this), this.otp, this.error ? (0, $hxyOZ.html)($c873eaad6f63047d$var$_templateObject1(), this.error) : null), footerLabels.title, this.onResendCode.bind(this), isResendDisabled, footerLabels.action);
            }
        },
        {
            key: "startOTPTimeout",
            value: function startOTPTimeout() {
                var _this = this;
                this.timeoutTimeLeft = (0, $2ZXsZ.W3mFrameHelpers).getTimeToNextEmailLogin();
                this.OTPTimeout = setInterval(function() {
                    if (_this.timeoutTimeLeft > 0) _this.timeoutTimeLeft = (0, $2ZXsZ.W3mFrameHelpers).getTimeToNextEmailLogin();
                    else clearInterval(_this.OTPTimeout);
                }, 1000);
            }
        },
        {
            key: "onOtpInputChange",
            value: function onOtpInputChange(event) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _this_onOtpSubmit, _this1, error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    3,
                                    ,
                                    4
                                ]);
                                if (!!_this.loading) return [
                                    3,
                                    2
                                ];
                                _this.otp = event.detail;
                                if (!(_this.authConnector && _this.otp.length === $c873eaad6f63047d$var$OTP_LENGTH)) return [
                                    3,
                                    2
                                ];
                                _this.loading = true;
                                return [
                                    4,
                                    (_this_onOtpSubmit = (_this1 = _this).onOtpSubmit) === null || _this_onOtpSubmit === void 0 ? void 0 : _this_onOtpSubmit.call(_this1, _this.otp)
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                _this.error = (0, $hZBJb.CoreHelperUtil).parseError(error);
                                _this.loading = false;
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onResendCode",
            value: function onResendCode() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var authConnector, error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    5,
                                    6,
                                    7
                                ]);
                                if (!_this.onOtpResend) return [
                                    3,
                                    3
                                ];
                                if (!(!_this.loading && !_this.timeoutTimeLeft)) return [
                                    3,
                                    2
                                ];
                                _this.error = "";
                                _this.otp = "";
                                authConnector = (0, $2qlRb.ConnectorController).getAuthConnector();
                                if (!authConnector || !_this.email) throw new Error("w3m-email-otp-widget: Unable to resend email");
                                _this.loading = true;
                                return [
                                    4,
                                    _this.onOtpResend(_this.email)
                                ];
                            case 1:
                                _state.sent();
                                _this.startOTPTimeout();
                                (0, $8FcCV.SnackController).showSuccess("Code email resent");
                                _state.label = 2;
                            case 2:
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                if (_this.onStartOver) _this.onStartOver();
                                _state.label = 4;
                            case 4:
                                return [
                                    3,
                                    7
                                ];
                            case 5:
                                error = _state.sent();
                                (0, $8FcCV.SnackController).showError(error);
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                _this.loading = false;
                                return [
                                    7
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getFooterLabels",
            value: function getFooterLabels(isResendDisabled) {
                if (this.onStartOver) return {
                    title: "Something wrong?",
                    action: "Try again ".concat(isResendDisabled ? "in ".concat(this.timeoutTimeLeft, "s") : "")
                };
                return {
                    title: "Didn't receive it?",
                    action: "Resend ".concat(isResendDisabled ? "in ".concat(this.timeoutTimeLeft, "s") : "Code")
                };
            }
        }
    ]);
    return W3mEmailOtpWidget;
}((0, $2yD3e.LitElement));
$c873eaad6f63047d$export$84443566fe241bc9.styles = (0, $c06436792636ec0b$export$2e2bcd8739ae039);
$c873eaad6f63047d$var$__decorate([
    (0, $334Pv.state)()
], $c873eaad6f63047d$export$84443566fe241bc9.prototype, "loading", void 0);
$c873eaad6f63047d$var$__decorate([
    (0, $334Pv.state)()
], $c873eaad6f63047d$export$84443566fe241bc9.prototype, "timeoutTimeLeft", void 0);
$c873eaad6f63047d$var$__decorate([
    (0, $334Pv.state)()
], $c873eaad6f63047d$export$84443566fe241bc9.prototype, "error", void 0);
$c873eaad6f63047d$export$84443566fe241bc9 = $c873eaad6f63047d$var$__decorate([
    (0, $hdxb6.customElement)("w3m-email-otp-widget")
], $c873eaad6f63047d$export$84443566fe241bc9);


parcelRequire("cwWZ7");
var $dMLJP = parcelRequire("dMLJP");
var $fPqxb = parcelRequire("fPqxb");
var $1QDT9 = parcelRequire("1QDT9");
var $3cYIS = parcelRequire("3cYIS");
var $iptjJ = parcelRequire("iptjJ");
var $5Lhe6 = parcelRequire("5Lhe6");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");
var $0399692562b59c85$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $0399692562b59c85$export$cf0da95883710edd = /*#__PURE__*/ function(W3mEmailOtpWidget) {
    "use strict";
    (0, $dcsZi._)(W3mEmailVerifyOtpView, W3mEmailOtpWidget);
    var _super = (0, $ohfOJ._)(W3mEmailVerifyOtpView);
    function W3mEmailVerifyOtpView() {
        (0, $4GJKx._)(this, W3mEmailVerifyOtpView);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.smartAccountDeployed = (0, $dMLJP.AccountController).state.smartAccountDeployed;
        var _this1 = (0, $d3H5E._)(_this);
        _this.onOtpSubmit = function() {
            var _ref = (0, $kSuI9._)(function(otp) {
                var smartAccountEnabled, error;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                4,
                                ,
                                5
                            ]);
                            if (!_this1.authConnector) return [
                                3,
                                3
                            ];
                            smartAccountEnabled = (0, $fPqxb.NetworkController).checkIfSmartAccountEnabled();
                            return [
                                4,
                                _this1.authConnector.provider.connectOtp({
                                    otp: otp
                                })
                            ];
                        case 1:
                            _state.sent();
                            (0, $1QDT9.EventsController).sendEvent({
                                type: "track",
                                event: "EMAIL_VERIFICATION_CODE_PASS"
                            });
                            return [
                                4,
                                (0, $3cYIS.ConnectionController).connectExternal(_this1.authConnector, _this1.authConnector.chain)
                            ];
                        case 2:
                            _state.sent();
                            (0, $1QDT9.EventsController).sendEvent({
                                type: "track",
                                event: "CONNECT_SUCCESS",
                                properties: {
                                    method: "email",
                                    name: _this1.authConnector.name || "Unknown"
                                }
                            });
                            if ((0, $dMLJP.AccountController).state.allAccounts.length > 1) (0, $iptjJ.RouterController).push("SelectAddresses");
                            else if (smartAccountEnabled && !_this1.smartAccountDeployed) (0, $iptjJ.RouterController).push("UpgradeToSmartAccount");
                            else (0, $5Lhe6.ModalController).close();
                            _state.label = 3;
                        case 3:
                            return [
                                3,
                                5
                            ];
                        case 4:
                            error = _state.sent();
                            (0, $1QDT9.EventsController).sendEvent({
                                type: "track",
                                event: "EMAIL_VERIFICATION_CODE_FAIL"
                            });
                            throw error;
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(otp) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this2 = (0, $d3H5E._)(_this);
        _this.onOtpResend = function() {
            var _ref = (0, $kSuI9._)(function(email) {
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!_this2.authConnector) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _this2.authConnector.provider.connectEmail({
                                    email: email
                                })
                            ];
                        case 1:
                            _state.sent();
                            (0, $1QDT9.EventsController).sendEvent({
                                type: "track",
                                event: "EMAIL_VERIFICATION_CODE_SENT"
                            });
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(email) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.unsubscribe.push((0, $dMLJP.AccountController).subscribeKey("smartAccountDeployed", function(val) {
            _this.smartAccountDeployed = val;
        }));
        return _this;
    }
    return W3mEmailVerifyOtpView;
}((0, $c873eaad6f63047d$export$84443566fe241bc9));
$0399692562b59c85$var$__decorate([
    (0, $334Pv.state)()
], $0399692562b59c85$export$cf0da95883710edd.prototype, "smartAccountDeployed", void 0);
$0399692562b59c85$export$cf0da95883710edd = $0399692562b59c85$var$__decorate([
    (0, $hdxb6.customElement)("w3m-email-verify-otp-view")
], $0399692562b59c85$export$cf0da95883710edd);



var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $49d1b58f9d28cd83$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  wui-icon-box {\n    height: var(--wui-icon-box-size-xl);\n    width: var(--wui-icon-box-size-xl);\n  }\n"
    ]);
    $49d1b58f9d28cd83$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $49d1b58f9d28cd83$export$2e2bcd8739ae039 = (0, $2D5eP.css)($49d1b58f9d28cd83$var$_templateObject());


parcelRequire("cwWZ7");
var $iptjJ = parcelRequire("iptjJ");
var $2qlRb = parcelRequire("2qlRb");
var $1QDT9 = parcelRequire("1QDT9");
var $8FcCV = parcelRequire("8FcCV");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");
function $fbec1151121207f3$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex\n        flexDirection="column"\n        alignItems="center"\n        .padding=',
        '\n        gap="l"\n      >\n        <wui-icon-box\n          size="xl"\n          iconcolor="accent-100"\n          backgroundcolor="accent-100"\n          icon="verify"\n          background="opaque"\n        ></wui-icon-box>\n\n        <wui-flex flexDirection="column" alignItems="center" gap="s">\n          <wui-flex flexDirection="column" alignItems="center">\n            <wui-text variant="paragraph-400" color="fg-100">\n              Approve the login link we sent to\n            </wui-text>\n            <wui-text variant="paragraph-400" color="fg-100"><b>',
        '</b></wui-text>\n          </wui-flex>\n\n          <wui-text variant="small-400" color="fg-200" align="center">\n            The code expires in 20 minutes\n          </wui-text>\n\n          <wui-flex alignItems="center" id="w3m-resend-section" gap="xs">\n            <wui-text variant="small-400" color="fg-100" align="center">\n              Didn\'t receive it?\n            </wui-text>\n            <wui-link @click=',
        " .disabled=",
        ">\n              Resend email\n            </wui-link>\n          </wui-flex>\n        </wui-flex>\n      </wui-flex>\n    "
    ]);
    $fbec1151121207f3$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $fbec1151121207f3$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $fbec1151121207f3$export$442e575aa1acbb10 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mEmailVerifyDeviceView, LitElement);
    var _super = (0, $ohfOJ._)(W3mEmailVerifyDeviceView);
    function W3mEmailVerifyDeviceView() {
        (0, $4GJKx._)(this, W3mEmailVerifyDeviceView);
        var _this;
        var _RouterController_state_data;
        _this = _super.call(this);
        _this.email = (_RouterController_state_data = (0, $iptjJ.RouterController).state.data) === null || _RouterController_state_data === void 0 ? void 0 : _RouterController_state_data.email;
        _this.authConnector = (0, $2qlRb.ConnectorController).getAuthConnector();
        _this.loading = false;
        _this.listenForDeviceApproval();
        return _this;
    }
    (0, $1wc17._)(W3mEmailVerifyDeviceView, [
        {
            key: "render",
            value: function render() {
                if (!this.email) throw new Error("w3m-email-verify-device-view: No email provided");
                if (!this.authConnector) throw new Error("w3m-email-verify-device-view: No auth connector provided");
                return (0, $hxyOZ.html)($fbec1151121207f3$var$_templateObject(), [
                    "xxl",
                    "s",
                    "xxl",
                    "s"
                ], this.email, this.onResendCode.bind(this), this.loading);
            }
        },
        {
            key: "listenForDeviceApproval",
            value: function listenForDeviceApproval() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.authConnector) return [
                                    3,
                                    4
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.authConnector.provider.connectDevice()
                                ];
                            case 2:
                                _state.sent();
                                (0, $1QDT9.EventsController).sendEvent({
                                    type: "track",
                                    event: "DEVICE_REGISTERED_FOR_EMAIL"
                                });
                                (0, $1QDT9.EventsController).sendEvent({
                                    type: "track",
                                    event: "EMAIL_VERIFICATION_CODE_SENT"
                                });
                                (0, $iptjJ.RouterController).replace("EmailVerifyOtp", {
                                    email: _this.email
                                });
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                (0, $iptjJ.RouterController).goBack();
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onResendCode",
            value: function onResendCode() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    3,
                                    4,
                                    5
                                ]);
                                if (!!_this.loading) return [
                                    3,
                                    2
                                ];
                                if (!_this.authConnector || !_this.email) throw new Error("w3m-email-login-widget: Unable to resend email");
                                _this.loading = true;
                                return [
                                    4,
                                    _this.authConnector.provider.connectEmail({
                                        email: _this.email
                                    })
                                ];
                            case 1:
                                _state.sent();
                                _this.listenForDeviceApproval();
                                (0, $8FcCV.SnackController).showSuccess("Code email resent");
                                _state.label = 2;
                            case 2:
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                error = _state.sent();
                                (0, $8FcCV.SnackController).showError(error);
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                _this.loading = false;
                                return [
                                    7
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return W3mEmailVerifyDeviceView;
}((0, $2yD3e.LitElement));
$fbec1151121207f3$export$442e575aa1acbb10.styles = (0, $49d1b58f9d28cd83$export$2e2bcd8739ae039);
$fbec1151121207f3$var$__decorate([
    (0, $334Pv.state)()
], $fbec1151121207f3$export$442e575aa1acbb10.prototype, "loading", void 0);
$fbec1151121207f3$export$442e575aa1acbb10 = $fbec1151121207f3$var$__decorate([
    (0, $hdxb6.customElement)("w3m-email-verify-device-view")
], $fbec1151121207f3$export$442e575aa1acbb10);



var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $482130ca486eaa17$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  div {\n    width: 100%;\n    height: 400px;\n  }\n\n  [data-ready='false'] {\n    transform: scale(1.05);\n  }\n\n  @media (max-width: 430px) {\n    [data-ready='false'] {\n      transform: translateY(-50px);\n    }\n  }\n"
    ]);
    $482130ca486eaa17$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $482130ca486eaa17$export$2e2bcd8739ae039 = (0, $2D5eP.css)($482130ca486eaa17$var$_templateObject());


parcelRequire("cwWZ7");
var $5Lhe6 = parcelRequire("5Lhe6");
var $iptjJ = parcelRequire("iptjJ");
var $2qlRb = parcelRequire("2qlRb");
var $dJ6Ea = parcelRequire("dJ6Ea");
parcelRequire("dSKxG");
var $cnADL = parcelRequire("cnADL");
function $c11f23d88dba68a5$var$_templateObject() {
    var data = (0, $j06k0._)([
        "<div data-ready=",
        "></div>"
    ]);
    $c11f23d88dba68a5$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $c11f23d88dba68a5$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c11f23d88dba68a5$var$PAGE_HEIGHT = 400;
var $c11f23d88dba68a5$var$PAGE_WIDTH = 360;
var $c11f23d88dba68a5$var$HEADER_HEIGHT = 64;
var $c11f23d88dba68a5$export$ab9ab0bd09f8f225 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mApproveTransactionView, LitElement);
    var _super = (0, $ohfOJ._)(W3mApproveTransactionView);
    function W3mApproveTransactionView() {
        var _this_unsubscribe;
        (0, $4GJKx._)(this, W3mApproveTransactionView);
        var _this;
        _this = _super.call(this);
        _this.bodyObserver = undefined;
        _this.unsubscribe = [];
        _this.iframe = document.getElementById("w3m-iframe");
        _this.ready = false;
        (_this_unsubscribe = _this.unsubscribe).push.apply(_this_unsubscribe, [
            (0, $5Lhe6.ModalController).subscribeKey("open", function(isOpen) {
                if (!isOpen) {
                    _this.onHideIframe();
                    (0, $iptjJ.RouterController).popTransactionStack();
                }
            }),
            (0, $5Lhe6.ModalController).subscribeKey("shake", function(val) {
                if (val) _this.iframe.style.animation = "w3m-shake 500ms var(--wui-ease-out-power-2)";
                else _this.iframe.style.animation = "none";
            })
        ]);
        return _this;
    }
    (0, $1wc17._)(W3mApproveTransactionView, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                var _this_bodyObserver;
                this.onHideIframe();
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
                (_this_bodyObserver = this.bodyObserver) === null || _this_bodyObserver === void 0 ? void 0 : _this_bodyObserver.unobserve(window.document.body);
            }
        },
        {
            key: "firstUpdated",
            value: function firstUpdated() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.syncTheme()
                                ];
                            case 1:
                                _state.sent();
                                _this.iframe.style.display = "block";
                                _this.bodyObserver = new ResizeObserver(function(entries) {
                                    var _entries_, _contentBoxSize_;
                                    var contentBoxSize = entries === null || entries === void 0 ? void 0 : (_entries_ = entries[0]) === null || _entries_ === void 0 ? void 0 : _entries_.contentBoxSize;
                                    var width = contentBoxSize === null || contentBoxSize === void 0 ? void 0 : (_contentBoxSize_ = contentBoxSize[0]) === null || _contentBoxSize_ === void 0 ? void 0 : _contentBoxSize_.inlineSize;
                                    _this.iframe.style.height = "".concat($c11f23d88dba68a5$var$PAGE_HEIGHT, "px");
                                    if (width && width <= 430) {
                                        _this.iframe.style.width = "100%";
                                        _this.iframe.style.left = "0px";
                                        _this.iframe.style.bottom = "0px";
                                        _this.iframe.style.top = "unset";
                                    } else {
                                        _this.iframe.style.width = "".concat($c11f23d88dba68a5$var$PAGE_WIDTH, "px");
                                        _this.iframe.style.left = "calc(50% - ".concat($c11f23d88dba68a5$var$PAGE_WIDTH / 2, "px)");
                                        _this.iframe.style.top = "calc(50% - ".concat($c11f23d88dba68a5$var$PAGE_HEIGHT / 2, "px + ").concat($c11f23d88dba68a5$var$HEADER_HEIGHT / 2, "px)");
                                        _this.iframe.style.bottom = "unset";
                                    }
                                    _this.ready = true;
                                    _this.onShowIframe();
                                });
                                _this.bodyObserver.observe(window.document.body);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($c11f23d88dba68a5$var$_templateObject(), this.ready);
            }
        },
        {
            key: "onShowIframe",
            value: function onShowIframe() {
                var isMobile = window.innerWidth <= 430;
                this.iframe.style.animation = isMobile ? "w3m-iframe-zoom-in-mobile 200ms var(--wui-ease-out-power-2)" : "w3m-iframe-zoom-in 200ms var(--wui-ease-out-power-2)";
            }
        },
        {
            key: "onHideIframe",
            value: function onHideIframe() {
                this.iframe.style.display = "none";
                this.iframe.style.animation = "w3m-iframe-fade-out 200ms var(--wui-ease-out-power-2)";
            }
        },
        {
            key: "syncTheme",
            value: function syncTheme() {
                return (0, $kSuI9._)(function() {
                    var authConnector, themeMode, themeVariables;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                authConnector = (0, $2qlRb.ConnectorController).getAuthConnector();
                                if (!authConnector) return [
                                    3,
                                    2
                                ];
                                themeMode = (0, $dJ6Ea.ThemeController).getSnapshot().themeMode;
                                themeVariables = (0, $dJ6Ea.ThemeController).getSnapshot().themeVariables;
                                return [
                                    4,
                                    authConnector.provider.syncTheme({
                                        themeVariables: themeVariables,
                                        w3mThemeVariables: (0, $cnADL.getW3mThemeVariables)(themeVariables, themeMode)
                                    })
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return W3mApproveTransactionView;
}((0, $2yD3e.LitElement));
$c11f23d88dba68a5$export$ab9ab0bd09f8f225.styles = (0, $482130ca486eaa17$export$2e2bcd8739ae039);
$c11f23d88dba68a5$var$__decorate([
    (0, $334Pv.state)()
], $c11f23d88dba68a5$export$ab9ab0bd09f8f225.prototype, "ready", void 0);
$c11f23d88dba68a5$export$ab9ab0bd09f8f225 = $c11f23d88dba68a5$var$__decorate([
    (0, $hdxb6.customElement)("w3m-approve-transaction-view")
], $c11f23d88dba68a5$export$ab9ab0bd09f8f225);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("cwWZ7");
var $2sXdV = parcelRequire("2sXdV");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
function $4340e9a2726125ab$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column" alignItems="center" gap="xl" padding="xl">\n        <wui-text variant="paragraph-400" color="fg-100">Follow the instructions on</wui-text>\n        <wui-chip\n          icon="externalLink"\n          variant="fill"\n          href=',
        "\n          imageSrc=",
        '\n          data-testid="w3m-secure-website-button"\n        >\n        </wui-chip>\n        <wui-text variant="small-400" color="fg-200">\n          You will have to reconnect for security reasons\n        </wui-text>\n      </wui-flex>\n    '
    ]);
    $4340e9a2726125ab$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $4340e9a2726125ab$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $4340e9a2726125ab$export$a1f0d947f01e8672 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mUpgradeWalletView, LitElement);
    var _super = (0, $ohfOJ._)(W3mUpgradeWalletView);
    function W3mUpgradeWalletView() {
        (0, $4GJKx._)(this, W3mUpgradeWalletView);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(W3mUpgradeWalletView, [
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($4340e9a2726125ab$var$_templateObject(), (0, $2sXdV.ConstantsUtil).SECURE_SITE_DASHBOARD, (0, $2sXdV.ConstantsUtil).SECURE_SITE_FAVICON);
            }
        }
    ]);
    return W3mUpgradeWalletView;
}((0, $2yD3e.LitElement));
$4340e9a2726125ab$export$a1f0d947f01e8672 = $4340e9a2726125ab$var$__decorate([
    (0, $hdxb6.customElement)("w3m-upgrade-wallet-view")
], $4340e9a2726125ab$export$a1f0d947f01e8672);



var $d3H5E = parcelRequire("d3H5E");

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("cwWZ7");
var $2qlRb = parcelRequire("2qlRb");
var $3cYIS = parcelRequire("3cYIS");
var $6a2RN = parcelRequire("6a2RN");
var $8FcCV = parcelRequire("8FcCV");
var $hZBJb = parcelRequire("hZBJb");
var $iptjJ = parcelRequire("iptjJ");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");
parcelRequire("hsyMZ");
var $cSJ4o = parcelRequire("cSJ4o");
parcelRequire("dSKxG");
var $ejaSv = parcelRequire("ejaSv");
function $8305ab6e84fc47de$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex\n        flexDirection="column"\n        alignItems="center"\n        gap="xxl"\n        .padding=',
        "\n      >\n        ",
        " ",
        "\n        <wui-link\n          @click=",
        '\n        >\n          Learn more\n          <wui-icon color="inherit" slot="iconRight" name="externalLink"></wui-icon>\n        </wui-link>\n      </wui-flex>\n    '
    ]);
    $8305ab6e84fc47de$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $8305ab6e84fc47de$var$_templateObject1() {
    var data = (0, $j06k0._)([
        ' <wui-flex\n      flexDirection="column"\n      gap="xxl"\n      alignItems="center"\n      .padding=',
        '\n    >\n      <wui-flex gap="s" alignItems="center" justifyContent="center">\n        <wui-visual name="google"></wui-visual>\n        <wui-visual name="pencil"></wui-visual>\n        <wui-visual name="lightbulb"></wui-visual>\n      </wui-flex>\n      <wui-flex flexDirection="column" alignItems="center" gap="s">\n        <wui-text align="center" variant="medium-600" color="fg-100">\n          Discover Smart Accounts\n        </wui-text>\n        <wui-text align="center" variant="paragraph-400" color="fg-100">\n          Access advanced features such as username, social login, improved security and a smoother\n          user experience!\n        </wui-text>\n      </wui-flex>\n    </wui-flex>'
    ]);
    $8305ab6e84fc47de$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $8305ab6e84fc47de$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "<wui-flex .padding=",
        ' gap="s">\n      <wui-button\n        variant="accent"\n        @click=',
        '\n        size="lg"\n        borderRadius="xs"\n      >\n        Do it later\n      </wui-button>\n      <wui-button\n        .loading=',
        '\n        size="lg"\n        borderRadius="xs"\n        @click=',
        "\n        >Continue\n      </wui-button>\n    </wui-flex>"
    ]);
    $8305ab6e84fc47de$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $8305ab6e84fc47de$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $8305ab6e84fc47de$export$5ea49ea5c855ab18 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mUpgradeToSmartAccountView, LitElement);
    var _super = (0, $ohfOJ._)(W3mUpgradeToSmartAccountView);
    function W3mUpgradeToSmartAccountView() {
        (0, $4GJKx._)(this, W3mUpgradeToSmartAccountView);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.authConnector = (0, $2qlRb.ConnectorController).getAuthConnector();
        _this.loading = false;
        var _this1 = (0, $d3H5E._)(_this);
        _this.setPreferSmartAccount = /*#__PURE__*/ (0, $kSuI9._)(function() {
            var e;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!_this1.authConnector) return [
                            3,
                            4
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        _this1.loading = true;
                        return [
                            4,
                            (0, $3cYIS.ConnectionController).setPreferredAccountType((0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT)
                        ];
                    case 2:
                        _state.sent();
                        _this1.loading = false;
                        (0, $6a2RN.RouterUtil).navigateAfterPreferredAccountTypeSelect();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        (0, $8FcCV.SnackController).showError("Error upgrading to smart account");
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _this;
    }
    (0, $1wc17._)(W3mUpgradeToSmartAccountView, [
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($8305ab6e84fc47de$var$_templateObject(), [
                    "0",
                    "0",
                    "l",
                    "0"
                ], this.onboardingTemplate(), this.buttonsTemplate(), function() {
                    (0, $hZBJb.CoreHelperUtil).openHref((0, $ejaSv.NavigationUtil).URLS.FAQ, "_blank");
                });
            }
        },
        {
            key: "onboardingTemplate",
            value: function onboardingTemplate() {
                return (0, $hxyOZ.html)($8305ab6e84fc47de$var$_templateObject1(), [
                    "0",
                    "xxl",
                    "0",
                    "xxl"
                ]);
            }
        },
        {
            key: "buttonsTemplate",
            value: function buttonsTemplate() {
                return (0, $hxyOZ.html)($8305ab6e84fc47de$var$_templateObject2(), [
                    "0",
                    "2l",
                    "0",
                    "2l"
                ], this.redirectToAccount.bind(this), this.loading, this.setPreferSmartAccount.bind(this));
            }
        },
        {
            key: "redirectToAccount",
            value: function redirectToAccount() {
                (0, $iptjJ.RouterController).push("Account");
            }
        }
    ]);
    return W3mUpgradeToSmartAccountView;
}((0, $2yD3e.LitElement));
$8305ab6e84fc47de$var$__decorate([
    (0, $334Pv.state)()
], $8305ab6e84fc47de$export$5ea49ea5c855ab18.prototype, "authConnector", void 0);
$8305ab6e84fc47de$var$__decorate([
    (0, $334Pv.state)()
], $8305ab6e84fc47de$export$5ea49ea5c855ab18.prototype, "loading", void 0);
$8305ab6e84fc47de$export$5ea49ea5c855ab18 = $8305ab6e84fc47de$var$__decorate([
    (0, $hdxb6.customElement)("w3m-upgrade-to-smart-account-view")
], $8305ab6e84fc47de$export$5ea49ea5c855ab18);



var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("cwWZ7");
var $iptjJ = parcelRequire("iptjJ");
var $2qlRb = parcelRequire("2qlRb");
var $1QDT9 = parcelRequire("1QDT9");
var $8FcCV = parcelRequire("8FcCV");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");


var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $705be0390738a93b$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  wui-email-input {\n    width: 100%;\n  }\n\n  form {\n    width: 100%;\n    display: block;\n    position: relative;\n  }\n"
    ]);
    $705be0390738a93b$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $705be0390738a93b$export$2e2bcd8739ae039 = (0, $2D5eP.css)($705be0390738a93b$var$_templateObject());


function $2a08514fa52d0c97$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column" padding="m" gap="m">\n        <form ',
        " @submit=",
        ">\n          <wui-email-input\n            value=",
        "\n            .disabled=",
        "\n            @inputChange=",
        '\n          >\n          </wui-email-input>\n          <input type="submit" hidden />\n        </form>\n\n        <wui-flex gap="s">\n          <wui-button size="md" variant="neutral" fullWidth @click=',
        '>\n            Cancel\n          </wui-button>\n\n          <wui-button\n            size="md"\n            variant="main"\n            fullWidth\n            @click=',
        "\n            .disabled=",
        "\n            .loading=",
        "\n          >\n            Save\n          </wui-button>\n        </wui-flex>\n      </wui-flex>\n    "
    ]);
    $2a08514fa52d0c97$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $2a08514fa52d0c97$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $2a08514fa52d0c97$export$6814d6aff4948a0 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mUpdateEmailWalletView, LitElement);
    var _super = (0, $ohfOJ._)(W3mUpdateEmailWalletView);
    function W3mUpdateEmailWalletView() {
        (0, $4GJKx._)(this, W3mUpdateEmailWalletView);
        var _this;
        var _RouterController_state_data;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.formRef = (0, $89642349f29deca8$export$7d1e3a5e95ceca43)();
        var _RouterController_state_data_email;
        _this.initialEmail = (_RouterController_state_data_email = (_RouterController_state_data = (0, $iptjJ.RouterController).state.data) === null || _RouterController_state_data === void 0 ? void 0 : _RouterController_state_data.email) !== null && _RouterController_state_data_email !== void 0 ? _RouterController_state_data_email : "";
        _this.email = "";
        _this.loading = false;
        return _this;
    }
    (0, $1wc17._)(W3mUpdateEmailWalletView, [
        {
            key: "firstUpdated",
            value: function firstUpdated() {
                var _this = this;
                var _this_formRef_value;
                (_this_formRef_value = this.formRef.value) === null || _this_formRef_value === void 0 ? void 0 : _this_formRef_value.addEventListener("keydown", function(event) {
                    if (event.key === "Enter") _this.onSubmitEmail(event);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var showSubmit = !this.loading && this.email.length > 3 && this.email !== this.initialEmail;
                return (0, $hxyOZ.html)($2a08514fa52d0c97$var$_templateObject(), (0, $89642349f29deca8$export$eff4d24c3ff7876e)(this.formRef), this.onSubmitEmail.bind(this), this.initialEmail, this.loading, this.onEmailInputChange.bind(this), (0, $iptjJ.RouterController).goBack, this.onSubmitEmail.bind(this), !showSubmit, this.loading);
            }
        },
        {
            key: "onEmailInputChange",
            value: function onEmailInputChange(event) {
                this.email = event.detail;
            }
        },
        {
            key: "onSubmitEmail",
            value: function onSubmitEmail(event) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var authConnector, response, error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                if (_this.loading) return [
                                    2
                                ];
                                _this.loading = true;
                                event.preventDefault();
                                authConnector = (0, $2qlRb.ConnectorController).getAuthConnector();
                                if (!authConnector) throw new Error("w3m-update-email-wallet: Auth connector not found");
                                return [
                                    4,
                                    authConnector.provider.updateEmail({
                                        email: _this.email
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                (0, $1QDT9.EventsController).sendEvent({
                                    type: "track",
                                    event: "EMAIL_EDIT"
                                });
                                if (response.action === "VERIFY_SECONDARY_OTP") (0, $iptjJ.RouterController).push("UpdateEmailSecondaryOtp", {
                                    email: _this.initialEmail,
                                    newEmail: _this.email
                                });
                                else (0, $iptjJ.RouterController).push("UpdateEmailPrimaryOtp", {
                                    email: _this.initialEmail,
                                    newEmail: _this.email
                                });
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                error = _state.sent();
                                (0, $8FcCV.SnackController).showError(error);
                                _this.loading = false;
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return W3mUpdateEmailWalletView;
}((0, $2yD3e.LitElement));
$2a08514fa52d0c97$export$6814d6aff4948a0.styles = (0, $705be0390738a93b$export$2e2bcd8739ae039);
$2a08514fa52d0c97$var$__decorate([
    (0, $334Pv.state)()
], $2a08514fa52d0c97$export$6814d6aff4948a0.prototype, "email", void 0);
$2a08514fa52d0c97$var$__decorate([
    (0, $334Pv.state)()
], $2a08514fa52d0c97$export$6814d6aff4948a0.prototype, "loading", void 0);
$2a08514fa52d0c97$export$6814d6aff4948a0 = $2a08514fa52d0c97$var$__decorate([
    (0, $hdxb6.customElement)("w3m-update-email-wallet-view")
], $2a08514fa52d0c97$export$6814d6aff4948a0);



var $d3H5E = parcelRequire("d3H5E");

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");

parcelRequire("cwWZ7");
var $iptjJ = parcelRequire("iptjJ");
var $1QDT9 = parcelRequire("1QDT9");
var $1a5bfe168b78b438$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $1a5bfe168b78b438$export$f089084b6501bc5 = /*#__PURE__*/ function(W3mEmailOtpWidget) {
    "use strict";
    (0, $dcsZi._)(W3mUpdateEmailPrimaryOtpView, W3mEmailOtpWidget);
    var _super = (0, $ohfOJ._)(W3mUpdateEmailPrimaryOtpView);
    function W3mUpdateEmailPrimaryOtpView() {
        (0, $4GJKx._)(this, W3mUpdateEmailPrimaryOtpView);
        var _this;
        var _RouterController_state_data;
        _this = _super.call(this);
        _this.email = (_RouterController_state_data = (0, $iptjJ.RouterController).state.data) === null || _RouterController_state_data === void 0 ? void 0 : _RouterController_state_data.email;
        var _this1 = (0, $d3H5E._)(_this);
        _this.onOtpSubmit = function() {
            var _ref = (0, $kSuI9._)(function(otp) {
                var error;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            if (!_this1.authConnector) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _this1.authConnector.provider.updateEmailPrimaryOtp({
                                    otp: otp
                                })
                            ];
                        case 1:
                            _state.sent();
                            (0, $1QDT9.EventsController).sendEvent({
                                type: "track",
                                event: "EMAIL_VERIFICATION_CODE_PASS"
                            });
                            (0, $iptjJ.RouterController).replace("UpdateEmailSecondaryOtp", (0, $iptjJ.RouterController).state.data);
                            _state.label = 2;
                        case 2:
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            (0, $1QDT9.EventsController).sendEvent({
                                type: "track",
                                event: "EMAIL_VERIFICATION_CODE_FAIL"
                            });
                            throw error;
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(otp) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.onStartOver = function() {
            (0, $iptjJ.RouterController).replace("UpdateEmailWallet", (0, $iptjJ.RouterController).state.data);
        };
        return _this;
    }
    return W3mUpdateEmailPrimaryOtpView;
}((0, $c873eaad6f63047d$export$84443566fe241bc9));
$1a5bfe168b78b438$export$f089084b6501bc5 = $1a5bfe168b78b438$var$__decorate([
    (0, $hdxb6.customElement)("w3m-update-email-primary-otp-view")
], $1a5bfe168b78b438$export$f089084b6501bc5);



var $d3H5E = parcelRequire("d3H5E");

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");

parcelRequire("cwWZ7");
var $iptjJ = parcelRequire("iptjJ");
var $1QDT9 = parcelRequire("1QDT9");
var $9a8a07aa60ed8645$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9a8a07aa60ed8645$export$627b68ac942cb0d6 = /*#__PURE__*/ function(W3mEmailOtpWidget) {
    "use strict";
    (0, $dcsZi._)(W3mUpdateEmailSecondaryOtpView, W3mEmailOtpWidget);
    var _super = (0, $ohfOJ._)(W3mUpdateEmailSecondaryOtpView);
    function W3mUpdateEmailSecondaryOtpView() {
        (0, $4GJKx._)(this, W3mUpdateEmailSecondaryOtpView);
        var _this;
        var _RouterController_state_data;
        _this = _super.call(this);
        _this.email = (_RouterController_state_data = (0, $iptjJ.RouterController).state.data) === null || _RouterController_state_data === void 0 ? void 0 : _RouterController_state_data.newEmail;
        var _this1 = (0, $d3H5E._)(_this);
        _this.onOtpSubmit = function() {
            var _ref = (0, $kSuI9._)(function(otp) {
                var error;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            if (!_this1.authConnector) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _this1.authConnector.provider.updateEmailSecondaryOtp({
                                    otp: otp
                                })
                            ];
                        case 1:
                            _state.sent();
                            (0, $1QDT9.EventsController).sendEvent({
                                type: "track",
                                event: "EMAIL_VERIFICATION_CODE_PASS"
                            });
                            (0, $iptjJ.RouterController).reset("Account");
                            _state.label = 2;
                        case 2:
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            (0, $1QDT9.EventsController).sendEvent({
                                type: "track",
                                event: "EMAIL_VERIFICATION_CODE_FAIL"
                            });
                            throw error;
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(otp) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.onStartOver = function() {
            (0, $iptjJ.RouterController).replace("UpdateEmailWallet", (0, $iptjJ.RouterController).state.data);
        };
        return _this;
    }
    return W3mUpdateEmailSecondaryOtpView;
}((0, $c873eaad6f63047d$export$84443566fe241bc9));
$9a8a07aa60ed8645$export$627b68ac942cb0d6 = $9a8a07aa60ed8645$var$__decorate([
    (0, $hdxb6.customElement)("w3m-update-email-secondary-otp-view")
], $9a8a07aa60ed8645$export$627b68ac942cb0d6);



var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("cwWZ7");
var $iptjJ = parcelRequire("iptjJ");
var $fPqxb = parcelRequire("fPqxb");
var $hZBJb = parcelRequire("hZBJb");
var $2sXdV = parcelRequire("2sXdV");
var $khm6W = parcelRequire("khm6W");
var $3cYIS = parcelRequire("3cYIS");
var $1QDT9 = parcelRequire("1QDT9");
var $5Lhe6 = parcelRequire("5Lhe6");
var $8FcCV = parcelRequire("8FcCV");
var $dMLJP = parcelRequire("dMLJP");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");


var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $795ca25345ebcb4e$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host > wui-flex {\n    max-height: clamp(360px, 540px, 80vh);\n    overflow: scroll;\n    scrollbar-width: none;\n  }\n\n  :host > wui-flex::-webkit-scrollbar {\n    display: none;\n  }\n"
    ]);
    $795ca25345ebcb4e$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $795ca25345ebcb4e$export$2e2bcd8739ae039 = (0, $2D5eP.css)($795ca25345ebcb4e$var$_templateObject());



function $d7b1da07f46e37fc$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex class="container" flexDirection="column" gap="0">\n        <wui-flex\n          class="container"\n          flexDirection="column"\n          .padding=',
        '\n          alignItems="center"\n          gap="xl"\n        >\n          ',
        '\n        </wui-flex>\n\n        <wui-flex flexDirection="column" padding="s" gap="xs">\n          ',
        '\n        </wui-flex>\n\n        <wui-separator text="or"></wui-separator>\n        <wui-flex flexDirection="column" padding="s" gap="xs">\n          <wui-list-item\n            variant="icon"\n            iconVariant="overlay"\n            icon="disconnect"\n            ?chevron=',
        "\n            .loading=",
        "\n            @click=",
        '\n            data-testid="disconnect-button"\n          >\n            <wui-text variant="paragraph-500" color="fg-200">Disconnect</wui-text>\n          </wui-list-item>\n        </wui-flex>\n      </wui-flex>\n    '
    ]);
    $d7b1da07f46e37fc$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $d7b1da07f46e37fc$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '\n        <wui-text variant="small-400" color="fg-200" align="center">\n          The swap feature doesn\u2019t support your current network. Switch to an available option to\n          continue.\n        </wui-text>\n      '
    ]);
    $d7b1da07f46e37fc$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $d7b1da07f46e37fc$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '\n      <wui-text variant="small-400" color="fg-200" align="center">\n        This app doesn\u2019t support your current network. Switch to an available option to continue.\n      </wui-text>\n    '
    ]);
    $d7b1da07f46e37fc$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $d7b1da07f46e37fc$var$_templateObject3() {
    var data = (0, $j06k0._)([
        "\n        <wui-list-network\n          imageSrc=",
        "\n          name=",
        "\n          @click=",
        "\n        >\n        </wui-list-network>\n      "
    ]);
    $d7b1da07f46e37fc$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var $d7b1da07f46e37fc$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d7b1da07f46e37fc$export$db1b0c4a50057bc8 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mUnsupportedChainView, LitElement);
    var _super = (0, $ohfOJ._)(W3mUnsupportedChainView);
    function W3mUnsupportedChainView() {
        (0, $4GJKx._)(this, W3mUnsupportedChainView);
        var _this;
        var _RouterController_state_data;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.swapUnsupportedChain = (_RouterController_state_data = (0, $iptjJ.RouterController).state.data) === null || _RouterController_state_data === void 0 ? void 0 : _RouterController_state_data.swapUnsupportedChain;
        _this.disconecting = false;
        return _this;
    }
    (0, $1wc17._)(W3mUnsupportedChainView, [
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($d7b1da07f46e37fc$var$_templateObject(), [
                    "m",
                    "xl",
                    "xs",
                    "xl"
                ], this.descriptionTemplate(), this.networksTemplate(), false, this.disconecting, this.onDisconnect.bind(this));
            }
        },
        {
            key: "descriptionTemplate",
            value: function descriptionTemplate() {
                if (this.swapUnsupportedChain) return (0, $hxyOZ.html)($d7b1da07f46e37fc$var$_templateObject1());
                return (0, $hxyOZ.html)($d7b1da07f46e37fc$var$_templateObject2());
            }
        },
        {
            key: "networksTemplate",
            value: function networksTemplate() {
                var _this = this;
                var requestedCaipNetworks = (0, $fPqxb.NetworkController).getRequestedCaipNetworks();
                var approvedCaipNetworkIds = (0, $fPqxb.NetworkController).state.approvedCaipNetworkIds;
                var sortedNetworks = (0, $hZBJb.CoreHelperUtil).sortRequestedNetworks(approvedCaipNetworkIds, requestedCaipNetworks);
                var filteredNetworks = this.swapUnsupportedChain ? sortedNetworks.filter(function(network) {
                    return (0, $2sXdV.ConstantsUtil).SWAP_SUPPORTED_NETWORKS.includes(network.id);
                }) : sortedNetworks;
                return filteredNetworks.map(function(network) {
                    var _network_name;
                    return (0, $hxyOZ.html)($d7b1da07f46e37fc$var$_templateObject3(), (0, $696d14fc702af3d6$export$f68dd208b5df064d)((0, $khm6W.AssetUtil).getNetworkImage(network)), (_network_name = network.name) !== null && _network_name !== void 0 ? _network_name : "Unknown", function() {
                        return _this.onSwitchNetwork(network);
                    });
                });
            }
        },
        {
            key: "onDisconnect",
            value: function onDisconnect() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    3,
                                    4
                                ]);
                                _this.disconecting = true;
                                return [
                                    4,
                                    (0, $3cYIS.ConnectionController).disconnect()
                                ];
                            case 1:
                                _state.sent();
                                (0, $1QDT9.EventsController).sendEvent({
                                    type: "track",
                                    event: "DISCONNECT_SUCCESS"
                                });
                                (0, $5Lhe6.ModalController).close();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                e = _state.sent();
                                (0, $1QDT9.EventsController).sendEvent({
                                    type: "track",
                                    event: "DISCONNECT_ERROR"
                                });
                                (0, $8FcCV.SnackController).showError("Failed to disconnect");
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                _this.disconecting = false;
                                return [
                                    7
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onSwitchNetwork",
            value: function onSwitchNetwork(network) {
                return (0, $kSuI9._)(function() {
                    var isConnected, approvedCaipNetworkIds, supportsAllNetworks, caipNetwork, routerData;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                isConnected = (0, $dMLJP.AccountController).state.isConnected;
                                approvedCaipNetworkIds = (0, $fPqxb.NetworkController).state.approvedCaipNetworkIds;
                                supportsAllNetworks = (0, $fPqxb.NetworkController).state.supportsAllNetworks;
                                caipNetwork = (0, $fPqxb.NetworkController).state.caipNetwork;
                                routerData = (0, $iptjJ.RouterController).state.data;
                                if (!(isConnected && (caipNetwork === null || caipNetwork === void 0 ? void 0 : caipNetwork.id) !== network.id)) return [
                                    3,
                                    5
                                ];
                                if (!(approvedCaipNetworkIds === null || approvedCaipNetworkIds === void 0 ? void 0 : approvedCaipNetworkIds.includes(network.id))) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    (0, $fPqxb.NetworkController).switchActiveNetwork(network)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    (0, $cfc345dac538f72b$export$79d00c05833eff69).onNetworkChange()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                if (supportsAllNetworks) (0, $iptjJ.RouterController).push("SwitchNetwork", (0, $cxjpp._)((0, $do9pw._)({}, routerData), {
                                    network: network
                                }));
                                _state.label = 4;
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                if (!isConnected) {
                                    (0, $fPqxb.NetworkController).setActiveCaipNetwork(network);
                                    (0, $iptjJ.RouterController).push("Connect");
                                }
                                _state.label = 6;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return W3mUnsupportedChainView;
}((0, $2yD3e.LitElement));
$d7b1da07f46e37fc$export$db1b0c4a50057bc8.styles = (0, $795ca25345ebcb4e$export$2e2bcd8739ae039);
$d7b1da07f46e37fc$var$__decorate([
    (0, $334Pv.state)()
], $d7b1da07f46e37fc$export$db1b0c4a50057bc8.prototype, "disconecting", void 0);
$d7b1da07f46e37fc$export$db1b0c4a50057bc8 = $d7b1da07f46e37fc$var$__decorate([
    (0, $hdxb6.customElement)("w3m-unsupported-chain-view")
], $d7b1da07f46e37fc$export$db1b0c4a50057bc8);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $dMLJP = parcelRequire("dMLJP");
var $fPqxb = parcelRequire("fPqxb");
var $8FcCV = parcelRequire("8FcCV");
var $khm6W = parcelRequire("khm6W");
var $dJ6Ea = parcelRequire("dJ6Ea");
var $iptjJ = parcelRequire("iptjJ");
var $hZBJb = parcelRequire("hZBJb");
parcelRequire("grHtr");
var $dI7zX = parcelRequire("dI7zX");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $dde02261c67f533d$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  wui-compatible-network {\n    margin-top: var(--wui-spacing-l);\n  }\n"
    ]);
    $dde02261c67f533d$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $dde02261c67f533d$export$2e2bcd8739ae039 = (0, $2D5eP.css)($dde02261c67f533d$var$_templateObject());


parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");
parcelRequire("hsyMZ");
var $cSJ4o = parcelRequire("cSJ4o");
function $f58371a2049b342c$var$_templateObject() {
    var data = (0, $j06k0._)([
        ' <wui-flex\n      flexDirection="column"\n      .padding=',
        '\n      alignItems="center"\n    >\n      <wui-chip-button\n        data-testid="receive-address-copy-button"\n        @click=',
        "\n        text=",
        '\n        icon="copy"\n        size="sm"\n        imageSrc=',
        '\n        variant="gray"\n      ></wui-chip-button>\n      <wui-flex\n        flexDirection="column"\n        .padding=',
        '\n        alignItems="center"\n        gap="s"\n      >\n        <wui-qr-code\n          size=',
        "\n          theme=",
        "\n          uri=",
        "\n          ?arenaClear=",
        '\n          data-testid="wui-qr-code"\n        ></wui-qr-code>\n        <wui-text variant="paragraph-500" color="fg-100" align="center">\n          Copy your address or scan this QR code\n        </wui-text>\n      </wui-flex>\n      ',
        "\n    </wui-flex>"
    ]);
    $f58371a2049b342c$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $f58371a2049b342c$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "<wui-compatible-network\n        @click=",
        '\n        text="Only receive assets on this network"\n        .networkImages=',
        "\n      ></wui-compatible-network>"
    ]);
    $f58371a2049b342c$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $f58371a2049b342c$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "<wui-compatible-network\n      @click=",
        '\n      text="Only receive assets on these networks"\n      .networkImages=',
        "\n    ></wui-compatible-network>"
    ]);
    $f58371a2049b342c$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $f58371a2049b342c$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f58371a2049b342c$export$98052df59169e23d = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mWalletReceiveView, LitElement);
    var _super = (0, $ohfOJ._)(W3mWalletReceiveView);
    function W3mWalletReceiveView() {
        var _this_unsubscribe;
        (0, $4GJKx._)(this, W3mWalletReceiveView);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.address = (0, $dMLJP.AccountController).state.address;
        _this.profileName = (0, $dMLJP.AccountController).state.profileName;
        _this.network = (0, $fPqxb.NetworkController).state.caipNetwork;
        _this.preferredAccountType = (0, $dMLJP.AccountController).state.preferredAccountType;
        (_this_unsubscribe = _this.unsubscribe).push.apply(_this_unsubscribe, [
            (0, $dMLJP.AccountController).subscribe(function(val) {
                if (val.address) {
                    _this.address = val.address;
                    _this.profileName = val.profileName;
                    _this.preferredAccountType = val.preferredAccountType;
                } else (0, $8FcCV.SnackController).showError("Account not found");
            }),
            (0, $fPqxb.NetworkController).subscribeKey("caipNetwork", function(val) {
                if (val === null || val === void 0 ? void 0 : val.id) _this.network = val;
            })
        ]);
        return _this;
    }
    (0, $1wc17._)(W3mWalletReceiveView, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                if (!this.address) throw new Error("w3m-wallet-receive-view: No account provided");
                var networkImage = (0, $khm6W.AssetUtil).getNetworkImage(this.network);
                return (0, $hxyOZ.html)($f58371a2049b342c$var$_templateObject(), [
                    "0",
                    "l",
                    "l",
                    "l"
                ], this.onCopyClick.bind(this), (0, $dI7zX.UiHelperUtil).getTruncateString({
                    string: this.profileName || this.address || "",
                    charsStart: this.profileName ? 18 : 4,
                    charsEnd: this.profileName ? 0 : 4,
                    truncate: this.profileName ? "end" : "middle"
                }), networkImage ? networkImage : "", [
                    "l",
                    "0",
                    "0",
                    "0"
                ], 232, (0, $dJ6Ea.ThemeController).state.themeMode, this.address, true, this.networkTemplate());
            }
        },
        {
            key: "networkTemplate",
            value: function networkTemplate() {
                var _requestedCaipNetworks_filter;
                var requestedCaipNetworks = (0, $fPqxb.NetworkController).getRequestedCaipNetworks();
                var isNetworkEnabledForSmartAccounts = (0, $fPqxb.NetworkController).checkIfSmartAccountEnabled();
                var caipNetwork = (0, $fPqxb.NetworkController).state.caipNetwork;
                if (this.preferredAccountType === (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT && isNetworkEnabledForSmartAccounts) {
                    if (!caipNetwork) return null;
                    var _AssetUtil_getNetworkImage;
                    return (0, $hxyOZ.html)($f58371a2049b342c$var$_templateObject1(), this.onReceiveClick.bind(this), [
                        (_AssetUtil_getNetworkImage = (0, $khm6W.AssetUtil).getNetworkImage(caipNetwork)) !== null && _AssetUtil_getNetworkImage !== void 0 ? _AssetUtil_getNetworkImage : ""
                    ]);
                }
                var slicedNetworks = requestedCaipNetworks === null || requestedCaipNetworks === void 0 ? void 0 : (_requestedCaipNetworks_filter = requestedCaipNetworks.filter(function(network) {
                    return network === null || network === void 0 ? void 0 : network.imageId;
                })) === null || _requestedCaipNetworks_filter === void 0 ? void 0 : _requestedCaipNetworks_filter.slice(0, 5);
                var imagesArray = slicedNetworks.map((0, $khm6W.AssetUtil).getNetworkImage).filter(Boolean);
                return (0, $hxyOZ.html)($f58371a2049b342c$var$_templateObject2(), this.onReceiveClick.bind(this), imagesArray);
            }
        },
        {
            key: "onReceiveClick",
            value: function onReceiveClick() {
                (0, $iptjJ.RouterController).push("WalletCompatibleNetworks");
            }
        },
        {
            key: "onCopyClick",
            value: function onCopyClick() {
                try {
                    if (this.address) {
                        (0, $hZBJb.CoreHelperUtil).copyToClopboard(this.address);
                        (0, $8FcCV.SnackController).showSuccess("Address copied");
                    }
                } catch (e) {
                    (0, $8FcCV.SnackController).showError("Failed to copy");
                }
            }
        }
    ]);
    return W3mWalletReceiveView;
}((0, $2yD3e.LitElement));
$f58371a2049b342c$export$98052df59169e23d.styles = (0, $dde02261c67f533d$export$2e2bcd8739ae039);
$f58371a2049b342c$var$__decorate([
    (0, $334Pv.state)()
], $f58371a2049b342c$export$98052df59169e23d.prototype, "address", void 0);
$f58371a2049b342c$var$__decorate([
    (0, $334Pv.state)()
], $f58371a2049b342c$export$98052df59169e23d.prototype, "profileName", void 0);
$f58371a2049b342c$var$__decorate([
    (0, $334Pv.state)()
], $f58371a2049b342c$export$98052df59169e23d.prototype, "network", void 0);
$f58371a2049b342c$var$__decorate([
    (0, $334Pv.state)()
], $f58371a2049b342c$export$98052df59169e23d.prototype, "preferredAccountType", void 0);
$f58371a2049b342c$export$98052df59169e23d = $f58371a2049b342c$var$__decorate([
    (0, $hdxb6.customElement)("w3m-wallet-receive-view")
], $f58371a2049b342c$export$98052df59169e23d);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $dMLJP = parcelRequire("dMLJP");
var $fPqxb = parcelRequire("fPqxb");
var $hZBJb = parcelRequire("hZBJb");
var $khm6W = parcelRequire("khm6W");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");


var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $3d704729f4d5f1b7$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host > wui-flex {\n    max-height: clamp(360px, 540px, 80vh);\n    overflow: scroll;\n    scrollbar-width: none;\n  }\n\n  :host > wui-flex::-webkit-scrollbar {\n    display: none;\n  }\n"
    ]);
    $3d704729f4d5f1b7$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $3d704729f4d5f1b7$export$2e2bcd8739ae039 = (0, $2D5eP.css)($3d704729f4d5f1b7$var$_templateObject());


parcelRequire("hsyMZ");
var $cSJ4o = parcelRequire("cSJ4o");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");
function $615187b385bd24ff$var$_templateObject() {
    var data = (0, $j06k0._)([
        ' <wui-flex\n      flexDirection="column"\n      .padding=',
        '\n      gap="xs"\n    >\n      <wui-banner\n        icon="warningCircle"\n        text="You can only receive assets on these networks"\n      ></wui-banner>\n      ',
        "\n    </wui-flex>"
    ]);
    $615187b385bd24ff$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $615187b385bd24ff$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "\n        <wui-list-network\n          imageSrc=",
        "\n          name=",
        "\n          ?transparent=",
        "\n        >\n        </wui-list-network>\n      "
    ]);
    $615187b385bd24ff$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $615187b385bd24ff$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $615187b385bd24ff$export$b80248a7d70a36d4 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mWalletCompatibleNetworksView, LitElement);
    var _super = (0, $ohfOJ._)(W3mWalletCompatibleNetworksView);
    function W3mWalletCompatibleNetworksView() {
        (0, $4GJKx._)(this, W3mWalletCompatibleNetworksView);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.preferredAccountType = (0, $dMLJP.AccountController).state.preferredAccountType;
        _this.unsubscribe.push((0, $dMLJP.AccountController).subscribeKey("preferredAccountType", function(val) {
            _this.preferredAccountType = val;
        }));
        return _this;
    }
    (0, $1wc17._)(W3mWalletCompatibleNetworksView, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($615187b385bd24ff$var$_templateObject(), [
                    "xs",
                    "s",
                    "m",
                    "s"
                ], this.networkTemplate());
            }
        },
        {
            key: "networkTemplate",
            value: function networkTemplate() {
                var requestedCaipNetworks = (0, $fPqxb.NetworkController).getRequestedCaipNetworks();
                var approvedCaipNetworkIds = (0, $fPqxb.NetworkController).state.approvedCaipNetworkIds;
                var caipNetwork = (0, $fPqxb.NetworkController).state.caipNetwork;
                var isNetworkEnabledForSmartAccounts = (0, $fPqxb.NetworkController).checkIfSmartAccountEnabled();
                var sortedNetworks = (0, $hZBJb.CoreHelperUtil).sortRequestedNetworks(approvedCaipNetworkIds, requestedCaipNetworks);
                if (isNetworkEnabledForSmartAccounts && this.preferredAccountType === (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT) {
                    if (!caipNetwork) return null;
                    sortedNetworks = [
                        caipNetwork
                    ];
                }
                return sortedNetworks.map(function(network) {
                    var _network_name;
                    return (0, $hxyOZ.html)($615187b385bd24ff$var$_templateObject1(), (0, $696d14fc702af3d6$export$f68dd208b5df064d)((0, $khm6W.AssetUtil).getNetworkImage(network)), (_network_name = network.name) !== null && _network_name !== void 0 ? _network_name : "Unknown", true);
                });
            }
        }
    ]);
    return W3mWalletCompatibleNetworksView;
}((0, $2yD3e.LitElement));
$615187b385bd24ff$export$b80248a7d70a36d4.styles = (0, $3d704729f4d5f1b7$export$2e2bcd8739ae039);
$615187b385bd24ff$var$__decorate([
    (0, $334Pv.state)()
], $615187b385bd24ff$export$b80248a7d70a36d4.prototype, "preferredAccountType", void 0);
$615187b385bd24ff$export$b80248a7d70a36d4 = $615187b385bd24ff$var$__decorate([
    (0, $hdxb6.customElement)("w3m-wallet-compatible-networks-view")
], $615187b385bd24ff$export$b80248a7d70a36d4);



var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $a19a99a528450e90$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: block;\n  }\n\n  wui-flex {\n    position: relative;\n  }\n\n  wui-icon-box {\n    width: 40px;\n    height: 40px;\n    border-radius: var(--wui-border-radius-xs) !important;\n    border: 5px solid var(--wui-color-bg-125);\n    background: var(--wui-color-bg-175);\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 1;\n  }\n\n  wui-button {\n    --local-border-radius: var(--wui-border-radius-xs) !important;\n  }\n\n  .inputContainer {\n    height: fit-content;\n  }\n"
    ]);
    $a19a99a528450e90$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $a19a99a528450e90$export$2e2bcd8739ae039 = (0, $2D5eP.css)($a19a99a528450e90$var$_templateObject());


parcelRequire("cwWZ7");
var $iSNyw = parcelRequire("iSNyw");
var $8DzeN = parcelRequire("8DzeN");
var $iptjJ = parcelRequire("iptjJ");
var $hZBJb = parcelRequire("hZBJb");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");
function $dec8df0fd00ee8ae$var$_templateObject() {
    var data = (0, $j06k0._)([
        ' <wui-flex flexDirection="column" .padding=',
        '>\n      <wui-flex class="inputContainer" gap="xs" flexDirection="column">\n        <w3m-input-token\n          .token=',
        "\n          .sendTokenAmount=",
        "\n          .gasPriceInUSD=",
        '\n        ></w3m-input-token>\n        <wui-icon-box\n          size="inherit"\n          backgroundColor="fg-300"\n          iconSize="lg"\n          iconColor="fg-250"\n          background="opaque"\n          icon="arrowBottom"\n        ></wui-icon-box>\n        <w3m-input-address\n          .value=',
        "\n        ></w3m-input-address>\n      </wui-flex>\n      <wui-flex .margin=",
        ">\n        <wui-button\n          @click=",
        "\n          ?disabled=",
        '\n          size="lg"\n          variant="main"\n          ?loading=',
        "\n          fullWidth\n        >\n          ",
        "\n        </wui-button>\n      </wui-flex>\n    </wui-flex>"
    ]);
    $dec8df0fd00ee8ae$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $dec8df0fd00ee8ae$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $dec8df0fd00ee8ae$export$d2da0955648ac29b = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mWalletSendView, LitElement);
    var _super = (0, $ohfOJ._)(W3mWalletSendView);
    function W3mWalletSendView() {
        var _this_unsubscribe;
        (0, $4GJKx._)(this, W3mWalletSendView);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.token = (0, $iSNyw.SendController).state.token;
        _this.sendTokenAmount = (0, $iSNyw.SendController).state.sendTokenAmount;
        _this.receiverAddress = (0, $iSNyw.SendController).state.receiverAddress;
        _this.receiverProfileName = (0, $iSNyw.SendController).state.receiverProfileName;
        _this.loading = (0, $iSNyw.SendController).state.loading;
        _this.gasPriceInUSD = (0, $iSNyw.SendController).state.gasPriceInUSD;
        _this.message = "Preview Send";
        _this.fetchNetworkPrice();
        (_this_unsubscribe = _this.unsubscribe).push.apply(_this_unsubscribe, [
            (0, $iSNyw.SendController).subscribe(function(val) {
                _this.token = val.token;
                _this.sendTokenAmount = val.sendTokenAmount;
                _this.receiverAddress = val.receiverAddress;
                _this.gasPriceInUSD = val.gasPriceInUSD;
                _this.receiverProfileName = val.receiverProfileName;
                _this.loading = val.loading;
            })
        ]);
        return _this;
    }
    (0, $1wc17._)(W3mWalletSendView, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                this.getMessage();
                return (0, $hxyOZ.html)($dec8df0fd00ee8ae$var$_templateObject(), [
                    "0",
                    "l",
                    "l",
                    "l"
                ], this.token, this.sendTokenAmount, this.gasPriceInUSD, this.receiverProfileName ? this.receiverProfileName : this.receiverAddress, [
                    "l",
                    "0",
                    "0",
                    "0"
                ], this.onButtonClick.bind(this), !this.message.startsWith("Preview Send"), this.loading, this.message);
            }
        },
        {
            key: "fetchNetworkPrice",
            value: function fetchNetworkPrice() {
                return (0, $kSuI9._)(function() {
                    var gas;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $8DzeN.SwapController).getNetworkTokenPrice()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    (0, $8DzeN.SwapController).getInitialGasPrice()
                                ];
                            case 2:
                                gas = _state.sent();
                                if ((gas === null || gas === void 0 ? void 0 : gas.gasPrice) && (gas === null || gas === void 0 ? void 0 : gas.gasPriceInUSD)) {
                                    (0, $iSNyw.SendController).setGasPrice(gas.gasPrice);
                                    (0, $iSNyw.SendController).setGasPriceInUsd(gas.gasPriceInUSD);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onButtonClick",
            value: function onButtonClick() {
                (0, $iptjJ.RouterController).push("WalletSendPreview");
            }
        },
        {
            key: "getMessage",
            value: function getMessage() {
                var _this_token;
                this.message = "Preview Send";
                if (this.receiverAddress && !(0, $hZBJb.CoreHelperUtil).isAddress(this.receiverAddress)) this.message = "Invalid Address";
                if (!this.receiverAddress) this.message = "Add Address";
                if (this.sendTokenAmount && this.token && this.sendTokenAmount > Number(this.token.quantity.numeric)) this.message = "Insufficient Funds";
                if (!this.sendTokenAmount) this.message = "Add Amount";
                if (this.sendTokenAmount && ((_this_token = this.token) === null || _this_token === void 0 ? void 0 : _this_token.price)) {
                    var value = this.sendTokenAmount * this.token.price;
                    if (!value) this.message = "Incorrect Value";
                }
                if (!this.token) this.message = "Select Token";
            }
        }
    ]);
    return W3mWalletSendView;
}((0, $2yD3e.LitElement));
$dec8df0fd00ee8ae$export$d2da0955648ac29b.styles = (0, $a19a99a528450e90$export$2e2bcd8739ae039);
$dec8df0fd00ee8ae$var$__decorate([
    (0, $334Pv.state)()
], $dec8df0fd00ee8ae$export$d2da0955648ac29b.prototype, "token", void 0);
$dec8df0fd00ee8ae$var$__decorate([
    (0, $334Pv.state)()
], $dec8df0fd00ee8ae$export$d2da0955648ac29b.prototype, "sendTokenAmount", void 0);
$dec8df0fd00ee8ae$var$__decorate([
    (0, $334Pv.state)()
], $dec8df0fd00ee8ae$export$d2da0955648ac29b.prototype, "receiverAddress", void 0);
$dec8df0fd00ee8ae$var$__decorate([
    (0, $334Pv.state)()
], $dec8df0fd00ee8ae$export$d2da0955648ac29b.prototype, "receiverProfileName", void 0);
$dec8df0fd00ee8ae$var$__decorate([
    (0, $334Pv.state)()
], $dec8df0fd00ee8ae$export$d2da0955648ac29b.prototype, "loading", void 0);
$dec8df0fd00ee8ae$var$__decorate([
    (0, $334Pv.state)()
], $dec8df0fd00ee8ae$export$d2da0955648ac29b.prototype, "gasPriceInUSD", void 0);
$dec8df0fd00ee8ae$var$__decorate([
    (0, $334Pv.state)()
], $dec8df0fd00ee8ae$export$d2da0955648ac29b.prototype, "message", void 0);
$dec8df0fd00ee8ae$export$d2da0955648ac29b = $dec8df0fd00ee8ae$var$__decorate([
    (0, $hdxb6.customElement)("w3m-wallet-send-view")
], $dec8df0fd00ee8ae$export$d2da0955648ac29b);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $284638ec3c866cfa$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  .contentContainer {\n    height: 440px;\n    overflow: scroll;\n    scrollbar-width: none;\n  }\n\n  .contentContainer::-webkit-scrollbar {\n    display: none;\n  }\n\n  wui-icon-box {\n    width: 40px;\n    height: 40px;\n    border-radius: var(--wui-border-radius-xxs);\n  }\n"
    ]);
    $284638ec3c866cfa$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $284638ec3c866cfa$export$2e2bcd8739ae039 = (0, $2D5eP.css)($284638ec3c866cfa$var$_templateObject());


parcelRequire("cwWZ7");
var $dMLJP = parcelRequire("dMLJP");
var $hZBJb = parcelRequire("hZBJb");
var $fPqxb = parcelRequire("fPqxb");
var $iptjJ = parcelRequire("iptjJ");
var $iSNyw = parcelRequire("iSNyw");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");
function $b8b8883e0328b513$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column">\n        ',
        " <wui-separator></wui-separator> ",
        "\n      </wui-flex>\n    "
    ]);
    $b8b8883e0328b513$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $b8b8883e0328b513$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex gap="xs" padding="s">\n        <wui-input-text\n          @inputChange=',
        '\n          class="network-search-input"\n          size="sm"\n          placeholder="Search token"\n          icon="search"\n        ></wui-input-text>\n      </wui-flex>\n    '
    ]);
    $b8b8883e0328b513$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $b8b8883e0328b513$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "<wui-list-token\n                    @click=",
        "\n                    ?clickable=",
        "\n                    tokenName=",
        "\n                    tokenImageUrl=",
        "\n                    tokenAmount=",
        "\n                    tokenValue=",
        "\n                    tokenCurrency=",
        "\n                  ></wui-list-token>"
    ]);
    $b8b8883e0328b513$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $b8b8883e0328b513$var$_templateObject3() {
    var data = (0, $j06k0._)([
        "<wui-flex\n                .padding=",
        '\n                alignItems="center"\n                flexDirection="column"\n                gap="l"\n              >\n                <wui-icon-box\n                  icon="coinPlaceholder"\n                  size="inherit"\n                  iconColor="fg-200"\n                  backgroundColor="fg-200"\n                  iconSize="lg"\n                ></wui-icon-box>\n                <wui-flex\n                  class="textContent"\n                  gap="xs"\n                  flexDirection="column"\n                  justifyContent="center"\n                  flexDirection="column"\n                >\n                  <wui-text variant="paragraph-500" align="center" color="fg-100"\n                    >No tokens found</wui-text\n                  >\n                  <wui-text variant="small-400" align="center" color="fg-200"\n                    >Your tokens will appear here</wui-text\n                  >\n                </wui-flex>\n                <wui-link @click=',
        ">Buy</wui-link>\n              </wui-flex>"
    ]);
    $b8b8883e0328b513$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $b8b8883e0328b513$var$_templateObject4() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex\n        class="contentContainer"\n        flexDirection="column"\n        .padding=',
        '\n      >\n        <wui-flex justifyContent="flex-start" .padding=',
        '>\n          <wui-text variant="paragraph-500" color="fg-200">Your tokens</wui-text>\n        </wui-flex>\n        <wui-flex flexDirection="column" gap="xs">\n          ',
        "\n        </wui-flex>\n      </wui-flex>\n    "
    ]);
    $b8b8883e0328b513$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
var $b8b8883e0328b513$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $b8b8883e0328b513$export$90e27946f1ab834e = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mSendSelectTokenView, LitElement);
    var _super = (0, $ohfOJ._)(W3mSendSelectTokenView);
    function W3mSendSelectTokenView() {
        var _this_unsubscribe;
        (0, $4GJKx._)(this, W3mSendSelectTokenView);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.tokenBalance = (0, $dMLJP.AccountController).state.tokenBalance;
        _this.search = "";
        _this.onDebouncedSearch = (0, $hZBJb.CoreHelperUtil).debounce(function(value) {
            _this.search = value;
        });
        (_this_unsubscribe = _this.unsubscribe).push.apply(_this_unsubscribe, [
            (0, $dMLJP.AccountController).subscribe(function(val) {
                _this.tokenBalance = val.tokenBalance;
            })
        ]);
        return _this;
    }
    (0, $1wc17._)(W3mSendSelectTokenView, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($b8b8883e0328b513$var$_templateObject(), this.templateSearchInput(), this.templateTokens());
            }
        },
        {
            key: "templateSearchInput",
            value: function templateSearchInput() {
                return (0, $hxyOZ.html)($b8b8883e0328b513$var$_templateObject1(), this.onInputChange.bind(this));
            }
        },
        {
            key: "templateTokens",
            value: function templateTokens() {
                var _this = this;
                var _this_tokenBalance, _this_tokenBalance1;
                this.tokens = (_this_tokenBalance = this.tokenBalance) === null || _this_tokenBalance === void 0 ? void 0 : _this_tokenBalance.filter(function(token) {
                    var _NetworkController_state_caipNetwork;
                    return token.chainId === ((_NetworkController_state_caipNetwork = (0, $fPqxb.NetworkController).state.caipNetwork) === null || _NetworkController_state_caipNetwork === void 0 ? void 0 : _NetworkController_state_caipNetwork.id);
                });
                if (this.search) this.filteredTokens = (_this_tokenBalance1 = this.tokenBalance) === null || _this_tokenBalance1 === void 0 ? void 0 : _this_tokenBalance1.filter(function(token) {
                    return token.name.toLowerCase().includes(_this.search.toLowerCase());
                });
                else this.filteredTokens = this.tokens;
                return (0, $hxyOZ.html)($b8b8883e0328b513$var$_templateObject4(), [
                    "0",
                    "s",
                    "0",
                    "s"
                ], [
                    "m",
                    "s",
                    "s",
                    "s"
                ], this.filteredTokens && this.filteredTokens.length > 0 ? this.filteredTokens.map(function(token) {
                    return (0, $hxyOZ.html)($b8b8883e0328b513$var$_templateObject2(), _this.handleTokenClick.bind(_this, token), true, token.name, token.iconUrl, token.quantity.numeric, token.value, token.symbol);
                }) : (0, $hxyOZ.html)($b8b8883e0328b513$var$_templateObject3(), [
                    "4xl",
                    "0",
                    "0",
                    "0"
                ], this.onBuyClick.bind(this)));
            }
        },
        {
            key: "onBuyClick",
            value: function onBuyClick() {
                (0, $iptjJ.RouterController).push("OnRampProviders");
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(event) {
                this.onDebouncedSearch(event.detail);
            }
        },
        {
            key: "handleTokenClick",
            value: function handleTokenClick(token) {
                (0, $iSNyw.SendController).setToken(token);
                (0, $iSNyw.SendController).setTokenAmount(undefined);
                (0, $iptjJ.RouterController).goBack();
            }
        }
    ]);
    return W3mSendSelectTokenView;
}((0, $2yD3e.LitElement));
$b8b8883e0328b513$export$90e27946f1ab834e.styles = (0, $284638ec3c866cfa$export$2e2bcd8739ae039);
$b8b8883e0328b513$var$__decorate([
    (0, $334Pv.state)()
], $b8b8883e0328b513$export$90e27946f1ab834e.prototype, "tokenBalance", void 0);
$b8b8883e0328b513$var$__decorate([
    (0, $334Pv.state)()
], $b8b8883e0328b513$export$90e27946f1ab834e.prototype, "tokens", void 0);
$b8b8883e0328b513$var$__decorate([
    (0, $334Pv.state)()
], $b8b8883e0328b513$export$90e27946f1ab834e.prototype, "filteredTokens", void 0);
$b8b8883e0328b513$var$__decorate([
    (0, $334Pv.state)()
], $b8b8883e0328b513$export$90e27946f1ab834e.prototype, "search", void 0);
$b8b8883e0328b513$export$90e27946f1ab834e = $b8b8883e0328b513$var$__decorate([
    (0, $hdxb6.customElement)("w3m-wallet-send-select-token-view")
], $b8b8883e0328b513$export$90e27946f1ab834e);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("grHtr");
var $dI7zX = parcelRequire("dI7zX");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $8dfa4083338c557b$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  wui-avatar,\n  wui-image {\n    display: ruby;\n    width: 32px;\n    height: 32px;\n    border-radius: var(--wui-border-radius-3xl);\n  }\n\n  .sendButton {\n    width: 70%;\n    --local-width: 100% !important;\n    --local-border-radius: var(--wui-border-radius-xs) !important;\n  }\n\n  .cancelButton {\n    width: 30%;\n    --local-width: 100% !important;\n    --local-border-radius: var(--wui-border-radius-xs) !important;\n  }\n"
    ]);
    $8dfa4083338c557b$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $8dfa4083338c557b$export$2e2bcd8739ae039 = (0, $2D5eP.css)($8dfa4083338c557b$var$_templateObject());


parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");
parcelRequire("cwWZ7");
var $iSNyw = parcelRequire("iSNyw");
var $fPqxb = parcelRequire("fPqxb");
var $iptjJ = parcelRequire("iptjJ");
function $21e67e040cacab4e$var$_templateObject() {
    var data = (0, $j06k0._)([
        ' <wui-flex flexDirection="column" .padding=',
        '>\n      <wui-flex gap="xs" flexDirection="column" .padding=',
        '>\n        <wui-flex alignItems="center" justifyContent="space-between">\n          <wui-flex flexDirection="column" gap="4xs">\n            <wui-text variant="small-400" color="fg-150">Send</wui-text>\n            ',
        '\n          </wui-flex>\n          <wui-preview-item\n            text="',
        " ",
        '"\n            .imageSrc=',
        '\n          ></wui-preview-item>\n        </wui-flex>\n        <wui-flex>\n          <wui-icon color="fg-200" size="md" name="arrowBottom"></wui-icon>\n        </wui-flex>\n        <wui-flex alignItems="center" justifyContent="space-between">\n          <wui-text variant="small-400" color="fg-150">To</wui-text>\n          <wui-preview-item\n            text="',
        '"\n            address=',
        "\n            .imageSrc=",
        "\n            .isAddress=",
        '\n          ></wui-preview-item>\n        </wui-flex>\n      </wui-flex>\n      <wui-flex flexDirection="column" .padding=',
        ">\n        <w3m-wallet-send-details\n          .caipNetwork=",
        "\n          .receiverAddress=",
        "\n          .networkFee=",
        '\n        ></w3m-wallet-send-details>\n        <wui-flex justifyContent="center" gap="xxs" .padding=',
        '>\n          <wui-icon size="sm" color="fg-200" name="warningCircle"></wui-icon>\n          <wui-text variant="small-400" color="fg-200">Review transaction carefully</wui-text>\n        </wui-flex>\n        <wui-flex justifyContent="center" gap="s" .padding=',
        '>\n          <wui-button\n            class="cancelButton"\n            @click=',
        '\n            size="lg"\n            variant="neutral"\n          >\n            Cancel\n          </wui-button>\n          <wui-button\n            class="sendButton"\n            @click=',
        '\n            size="lg"\n            variant="main"\n          >\n            Send\n          </wui-button>\n        </wui-flex>\n      </wui-flex></wui-flex\n    >'
    ]);
    $21e67e040cacab4e$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $21e67e040cacab4e$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '<wui-text variant="paragraph-400" color="fg-100"\n        >$',
        "</wui-text\n      >"
    ]);
    $21e67e040cacab4e$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $21e67e040cacab4e$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $21e67e040cacab4e$export$3308935d6e923da1 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mWalletSendPreviewView, LitElement);
    var _super = (0, $ohfOJ._)(W3mWalletSendPreviewView);
    function W3mWalletSendPreviewView() {
        var _this_unsubscribe;
        (0, $4GJKx._)(this, W3mWalletSendPreviewView);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.token = (0, $iSNyw.SendController).state.token;
        _this.sendTokenAmount = (0, $iSNyw.SendController).state.sendTokenAmount;
        _this.receiverAddress = (0, $iSNyw.SendController).state.receiverAddress;
        _this.receiverProfileName = (0, $iSNyw.SendController).state.receiverProfileName;
        _this.receiverProfileImageUrl = (0, $iSNyw.SendController).state.receiverProfileImageUrl;
        _this.gasPriceInUSD = (0, $iSNyw.SendController).state.gasPriceInUSD;
        _this.caipNetwork = (0, $fPqxb.NetworkController).state.caipNetwork;
        (_this_unsubscribe = _this.unsubscribe).push.apply(_this_unsubscribe, [
            (0, $iSNyw.SendController).subscribe(function(val) {
                _this.token = val.token;
                _this.sendTokenAmount = val.sendTokenAmount;
                _this.receiverAddress = val.receiverAddress;
                _this.gasPriceInUSD = val.gasPriceInUSD;
                _this.receiverProfileName = val.receiverProfileName;
                _this.receiverProfileImageUrl = val.receiverProfileImageUrl;
            }),
            (0, $fPqxb.NetworkController).subscribeKey("caipNetwork", function(val) {
                return _this.caipNetwork = val;
            })
        ]);
        return _this;
    }
    (0, $1wc17._)(W3mWalletSendPreviewView, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_token, _this_token1;
                var _this_receiverAddress, _this_receiverProfileImageUrl;
                return (0, $hxyOZ.html)($21e67e040cacab4e$var$_templateObject(), [
                    "0",
                    "l",
                    "l",
                    "l"
                ], [
                    "0",
                    "xs",
                    "0",
                    "xs"
                ], this.sendValueTemplate(), this.sendTokenAmount ? (0, $dI7zX.UiHelperUtil).roundNumber(this.sendTokenAmount, 6, 5) : "unknown", (_this_token = this.token) === null || _this_token === void 0 ? void 0 : _this_token.symbol, (_this_token1 = this.token) === null || _this_token1 === void 0 ? void 0 : _this_token1.iconUrl, this.receiverProfileName ? (0, $dI7zX.UiHelperUtil).getTruncateString({
                    string: this.receiverProfileName,
                    charsStart: 20,
                    charsEnd: 0,
                    truncate: "end"
                }) : (0, $dI7zX.UiHelperUtil).getTruncateString({
                    string: this.receiverAddress ? this.receiverAddress : "",
                    charsStart: 4,
                    charsEnd: 4,
                    truncate: "middle"
                }), (_this_receiverAddress = this.receiverAddress) !== null && _this_receiverAddress !== void 0 ? _this_receiverAddress : "", (_this_receiverProfileImageUrl = this.receiverProfileImageUrl) !== null && _this_receiverProfileImageUrl !== void 0 ? _this_receiverProfileImageUrl : undefined, true, [
                    "xxl",
                    "0",
                    "0",
                    "0"
                ], this.caipNetwork, this.receiverAddress, this.gasPriceInUSD, [
                    "s",
                    "0",
                    "0",
                    "0"
                ], [
                    "l",
                    "0",
                    "0",
                    "0"
                ], this.onCancelClick.bind(this), this.onSendClick.bind(this));
            }
        },
        {
            key: "sendValueTemplate",
            value: function sendValueTemplate() {
                if (this.token && this.sendTokenAmount) {
                    var price = this.token.price;
                    var totalValue = price * this.sendTokenAmount;
                    return (0, $hxyOZ.html)($21e67e040cacab4e$var$_templateObject1(), totalValue.toFixed(2));
                }
                return null;
            }
        },
        {
            key: "onSendClick",
            value: function onSendClick() {
                (0, $iSNyw.SendController).sendToken();
            }
        },
        {
            key: "onCancelClick",
            value: function onCancelClick() {
                (0, $iptjJ.RouterController).goBack();
            }
        }
    ]);
    return W3mWalletSendPreviewView;
}((0, $2yD3e.LitElement));
$21e67e040cacab4e$export$3308935d6e923da1.styles = (0, $8dfa4083338c557b$export$2e2bcd8739ae039);
$21e67e040cacab4e$var$__decorate([
    (0, $334Pv.state)()
], $21e67e040cacab4e$export$3308935d6e923da1.prototype, "token", void 0);
$21e67e040cacab4e$var$__decorate([
    (0, $334Pv.state)()
], $21e67e040cacab4e$export$3308935d6e923da1.prototype, "sendTokenAmount", void 0);
$21e67e040cacab4e$var$__decorate([
    (0, $334Pv.state)()
], $21e67e040cacab4e$export$3308935d6e923da1.prototype, "receiverAddress", void 0);
$21e67e040cacab4e$var$__decorate([
    (0, $334Pv.state)()
], $21e67e040cacab4e$export$3308935d6e923da1.prototype, "receiverProfileName", void 0);
$21e67e040cacab4e$var$__decorate([
    (0, $334Pv.state)()
], $21e67e040cacab4e$export$3308935d6e923da1.prototype, "receiverProfileImageUrl", void 0);
$21e67e040cacab4e$var$__decorate([
    (0, $334Pv.state)()
], $21e67e040cacab4e$export$3308935d6e923da1.prototype, "gasPriceInUSD", void 0);
$21e67e040cacab4e$var$__decorate([
    (0, $334Pv.state)()
], $21e67e040cacab4e$export$3308935d6e923da1.prototype, "caipNetwork", void 0);
$21e67e040cacab4e$export$3308935d6e923da1 = $21e67e040cacab4e$var$__decorate([
    (0, $hdxb6.customElement)("w3m-wallet-send-preview-view")
], $21e67e040cacab4e$export$3308935d6e923da1);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $69fac336ef8c7806$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  wui-flex {\n    max-height: clamp(360px, 540px, 80vh);\n    overflow: scroll;\n    scrollbar-width: none;\n  }\n  wui-flex::-webkit-scrollbar {\n    display: none;\n  }\n"
    ]);
    $69fac336ef8c7806$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $69fac336ef8c7806$export$2e2bcd8739ae039 = (0, $2D5eP.css)($69fac336ef8c7806$var$_templateObject());


function $9a3634743a495ccf$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column" padding="s" gap="xs">\n        <w3m-wallet-login-list></w3m-wallet-login-list>\n      </wui-flex>\n      <w3m-legal-footer></w3m-legal-footer>\n    '
    ]);
    $9a3634743a495ccf$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $9a3634743a495ccf$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9a3634743a495ccf$export$68b068a6fe91a465 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mConnectWalletsView, LitElement);
    var _super = (0, $ohfOJ._)(W3mConnectWalletsView);
    function W3mConnectWalletsView() {
        (0, $4GJKx._)(this, W3mConnectWalletsView);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(W3mConnectWalletsView, [
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($9a3634743a495ccf$var$_templateObject());
            }
        }
    ]);
    return W3mConnectWalletsView;
}((0, $2yD3e.LitElement));
$9a3634743a495ccf$export$68b068a6fe91a465.styles = (0, $69fac336ef8c7806$export$2e2bcd8739ae039);
$9a3634743a495ccf$export$68b068a6fe91a465 = $9a3634743a495ccf$var$__decorate([
    (0, $hdxb6.customElement)("w3m-connect-wallets-view")
], $9a3634743a495ccf$export$68b068a6fe91a465);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $077e99f5dfe254a3$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  wui-flex {\n    max-height: clamp(360px, 540px, 80vh);\n    overflow: scroll;\n    scrollbar-width: none;\n  }\n  wui-flex::-webkit-scrollbar {\n    display: none;\n  }\n"
    ]);
    $077e99f5dfe254a3$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $077e99f5dfe254a3$export$2e2bcd8739ae039 = (0, $2D5eP.css)($077e99f5dfe254a3$var$_templateObject());


function $284224b4769b3d3d$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column" padding="s" gap="xs">\n        <w3m-social-login-list></w3m-social-login-list>\n      </wui-flex>\n      <w3m-legal-footer></w3m-legal-footer>\n    '
    ]);
    $284224b4769b3d3d$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $284224b4769b3d3d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $284224b4769b3d3d$export$fc46f8619085b31 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mConnectSocialsView, LitElement);
    var _super = (0, $ohfOJ._)(W3mConnectSocialsView);
    function W3mConnectSocialsView() {
        (0, $4GJKx._)(this, W3mConnectSocialsView);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(W3mConnectSocialsView, [
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($284224b4769b3d3d$var$_templateObject());
            }
        }
    ]);
    return W3mConnectSocialsView;
}((0, $2yD3e.LitElement));
$284224b4769b3d3d$export$fc46f8619085b31.styles = (0, $077e99f5dfe254a3$export$2e2bcd8739ae039);
$284224b4769b3d3d$export$fc46f8619085b31 = $284224b4769b3d3d$var$__decorate([
    (0, $hdxb6.customElement)("w3m-connect-socials-view")
], $284224b4769b3d3d$export$fc46f8619085b31);



var $d3H5E = parcelRequire("d3H5E");

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("cwWZ7");
var $dMLJP = parcelRequire("dMLJP");
var $2qlRb = parcelRequire("2qlRb");
var $9zDWP = parcelRequire("9zDWP");
var $i7zcD = parcelRequire("i7zcD");
var $3cYIS = parcelRequire("3cYIS");
var $1QDT9 = parcelRequire("1QDT9");
var $iptjJ = parcelRequire("iptjJ");
var $8FcCV = parcelRequire("8FcCV");
var $5Lhe6 = parcelRequire("5Lhe6");
var $dJ6Ea = parcelRequire("dJ6Ea");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");


var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $30ac212c93a1d161$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  wui-logo {\n    width: 80px;\n    height: 80px;\n    border-radius: var(--wui-border-radius-m);\n  }\n  @keyframes shake {\n    0% {\n      transform: translateX(0);\n    }\n    25% {\n      transform: translateX(3px);\n    }\n    50% {\n      transform: translateX(-3px);\n    }\n    75% {\n      transform: translateX(3px);\n    }\n    100% {\n      transform: translateX(0);\n    }\n  }\n  wui-flex:first-child:not(:only-child) {\n    position: relative;\n  }\n  wui-loading-thumbnail {\n    position: absolute;\n  }\n  wui-icon-box {\n    position: absolute;\n    right: calc(var(--wui-spacing-3xs) * -1);\n    bottom: calc(var(--wui-spacing-3xs) * -1);\n    opacity: 0;\n    transform: scale(0.5);\n    transition: all var(--wui-ease-out-power-2) var(--wui-duration-lg);\n  }\n  wui-text[align='center'] {\n    width: 100%;\n    padding: 0px var(--wui-spacing-l);\n  }\n  [data-error='true'] wui-icon-box {\n    opacity: 1;\n    transform: scale(1);\n  }\n  [data-error='true'] > wui-flex:first-child {\n    animation: shake 250ms cubic-bezier(0.36, 0.07, 0.19, 0.97) both;\n  }\n  .capitalize {\n    text-transform: capitalize;\n  }\n"
    ]);
    $30ac212c93a1d161$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $30ac212c93a1d161$export$2e2bcd8739ae039 = (0, $2D5eP.css)($30ac212c93a1d161$var$_templateObject());



function $782d936b1b30b6cb$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      <wui-flex\n        data-error=",
        '\n        flexDirection="column"\n        alignItems="center"\n        .padding=',
        '\n        gap="xl"\n      >\n        <wui-flex justifyContent="center" alignItems="center">\n          <wui-logo logo=',
        "></wui-logo>\n          ",
        '\n          <wui-icon-box\n            backgroundColor="error-100"\n            background="opaque"\n            iconColor="error-100"\n            icon="close"\n            size="sm"\n            border\n            borderColor="wui-color-bg-125"\n          ></wui-icon-box>\n        </wui-flex>\n        <wui-flex flexDirection="column" alignItems="center" gap="xs">\n          <wui-text align="center" variant="paragraph-500" color="fg-100"\n            >Log in with\n            <span class="capitalize">',
        '</span></wui-text\n          >\n          <wui-text align="center" variant="small-400" color=',
        "\n            >",
        "</wui-text\n          ></wui-flex\n        >\n      </wui-flex>\n    "
    ]);
    $782d936b1b30b6cb$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $782d936b1b30b6cb$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "<wui-loading-thumbnail radius=",
        "></wui-loading-thumbnail>"
    ]);
    $782d936b1b30b6cb$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $782d936b1b30b6cb$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $782d936b1b30b6cb$export$d35a2e38563913c4 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mConnectingSocialView, LitElement);
    var _super = (0, $ohfOJ._)(W3mConnectingSocialView);
    function W3mConnectingSocialView() {
        var _this_unsubscribe;
        (0, $4GJKx._)(this, W3mConnectingSocialView);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.socialProvider = (0, $dMLJP.AccountController).state.socialProvider;
        _this.socialWindow = (0, $dMLJP.AccountController).state.socialWindow;
        _this.error = false;
        _this.connecting = false;
        _this.message = "Connect in the provider window";
        _this.authConnector = (0, $2qlRb.ConnectorController).getAuthConnector();
        var _this1 = (0, $d3H5E._)(_this);
        _this.handleSocialConnection = function() {
            var _ref = (0, $kSuI9._)(function(event) {
                var _event_data, uri, error;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!((_event_data = event.data) === null || _event_data === void 0 ? void 0 : _event_data.resultUri)) return [
                                3,
                                8
                            ];
                            if (!(event.origin === (0, $560364d27174f3fd$export$aafe1f751f1bc52a).SECURE_SITE_ORIGIN)) return [
                                3,
                                7
                            ];
                            window.removeEventListener("message", _this1.handleSocialConnection, false);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                5,
                                ,
                                6
                            ]);
                            if (!(_this1.authConnector && !_this1.connecting)) return [
                                3,
                                4
                            ];
                            if (_this1.socialWindow) {
                                _this1.socialWindow.close();
                                (0, $dMLJP.AccountController).setSocialWindow(undefined, (0, $9zDWP.ChainController).state.activeChain);
                            }
                            _this1.connecting = true;
                            _this1.updateMessage();
                            uri = event.data.resultUri;
                            return [
                                4,
                                _this1.authConnector.provider.connectSocial(uri)
                            ];
                        case 2:
                            _state.sent();
                            if (!_this1.socialProvider) return [
                                3,
                                4
                            ];
                            (0, $i7zcD.StorageUtil).setConnectedSocialProvider(_this1.socialProvider);
                            return [
                                4,
                                (0, $3cYIS.ConnectionController).connectExternal(_this1.authConnector, _this1.authConnector.chain)
                            ];
                        case 3:
                            _state.sent();
                            (0, $1QDT9.EventsController).sendEvent({
                                type: "track",
                                event: "SOCIAL_LOGIN_SUCCESS",
                                properties: {
                                    provider: _this1.socialProvider
                                }
                            });
                            _state.label = 4;
                        case 4:
                            return [
                                3,
                                6
                            ];
                        case 5:
                            error = _state.sent();
                            _this1.error = true;
                            _this1.updateMessage();
                            if (_this1.socialProvider) (0, $1QDT9.EventsController).sendEvent({
                                type: "track",
                                event: "SOCIAL_LOGIN_ERROR",
                                properties: {
                                    provider: _this1.socialProvider
                                }
                            });
                            return [
                                3,
                                6
                            ];
                        case 6:
                            return [
                                3,
                                8
                            ];
                        case 7:
                            (0, $iptjJ.RouterController).goBack();
                            (0, $8FcCV.SnackController).showError("Untrusted Origin");
                            if (_this1.socialProvider) (0, $1QDT9.EventsController).sendEvent({
                                type: "track",
                                event: "SOCIAL_LOGIN_ERROR",
                                properties: {
                                    provider: _this1.socialProvider
                                }
                            });
                            _state.label = 8;
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(event) {
                return _ref.apply(this, arguments);
            };
        }();
        (_this_unsubscribe = _this.unsubscribe).push.apply(_this_unsubscribe, [
            (0, $dMLJP.AccountController).subscribe(function(val) {
                if (val.socialProvider) _this.socialProvider = val.socialProvider;
                if (val.socialWindow) _this.socialWindow = val.socialWindow;
                if (val.address) {
                    if ((0, $5Lhe6.ModalController).state.open) (0, $5Lhe6.ModalController).close();
                }
            })
        ]);
        if (_this.authConnector) _this.connectSocial();
        return _this;
    }
    (0, $1wc17._)(W3mConnectingSocialView, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
                window.removeEventListener("message", this.handleSocialConnection, false);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_socialProvider;
                return (0, $hxyOZ.html)($782d936b1b30b6cb$var$_templateObject(), (0, $696d14fc702af3d6$export$f68dd208b5df064d)(this.error), [
                    "3xl",
                    "xl",
                    "xl",
                    "xl"
                ], (0, $696d14fc702af3d6$export$f68dd208b5df064d)(this.socialProvider), this.error ? null : this.loaderTemplate(), (_this_socialProvider = this.socialProvider) !== null && _this_socialProvider !== void 0 ? _this_socialProvider : "Social", this.error ? "error-100" : "fg-200", this.message);
            }
        },
        {
            key: "loaderTemplate",
            value: function loaderTemplate() {
                var borderRadiusMaster = (0, $dJ6Ea.ThemeController).state.themeVariables["--w3m-border-radius-master"];
                var radius = borderRadiusMaster ? parseInt(borderRadiusMaster.replace("px", ""), 10) : 4;
                return (0, $hxyOZ.html)($782d936b1b30b6cb$var$_templateObject1(), radius * 9);
            }
        },
        {
            key: "connectSocial",
            value: function connectSocial() {
                var _this = this;
                var interval = setInterval(function() {
                    var _this_socialWindow;
                    if ((_this_socialWindow = _this.socialWindow) === null || _this_socialWindow === void 0 ? void 0 : _this_socialWindow.closed) {
                        if (!_this.connecting && (0, $iptjJ.RouterController).state.view === "ConnectingSocial") (0, $iptjJ.RouterController).goBack();
                        clearInterval(interval);
                    }
                }, 1000);
                window.addEventListener("message", this.handleSocialConnection, false);
            }
        },
        {
            key: "updateMessage",
            value: function updateMessage() {
                if (this.error) this.message = "Something went wrong";
                else if (this.connecting) this.message = "Retrieving user data";
                else this.message = "Connect in the provider window";
            }
        }
    ]);
    return W3mConnectingSocialView;
}((0, $2yD3e.LitElement));
$782d936b1b30b6cb$export$d35a2e38563913c4.styles = (0, $30ac212c93a1d161$export$2e2bcd8739ae039);
$782d936b1b30b6cb$var$__decorate([
    (0, $334Pv.state)()
], $782d936b1b30b6cb$export$d35a2e38563913c4.prototype, "socialProvider", void 0);
$782d936b1b30b6cb$var$__decorate([
    (0, $334Pv.state)()
], $782d936b1b30b6cb$export$d35a2e38563913c4.prototype, "socialWindow", void 0);
$782d936b1b30b6cb$var$__decorate([
    (0, $334Pv.state)()
], $782d936b1b30b6cb$export$d35a2e38563913c4.prototype, "error", void 0);
$782d936b1b30b6cb$var$__decorate([
    (0, $334Pv.state)()
], $782d936b1b30b6cb$export$d35a2e38563913c4.prototype, "connecting", void 0);
$782d936b1b30b6cb$var$__decorate([
    (0, $334Pv.state)()
], $782d936b1b30b6cb$export$d35a2e38563913c4.prototype, "message", void 0);
$782d936b1b30b6cb$export$d35a2e38563913c4 = $782d936b1b30b6cb$var$__decorate([
    (0, $hdxb6.customElement)("w3m-connecting-social-view")
], $782d936b1b30b6cb$export$d35a2e38563913c4);



var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("cwWZ7");
var $dMLJP = parcelRequire("dMLJP");
var $5Lhe6 = parcelRequire("5Lhe6");
var $iptjJ = parcelRequire("iptjJ");
var $9zDWP = parcelRequire("9zDWP");
var $2qlRb = parcelRequire("2qlRb");
var $hZBJb = parcelRequire("hZBJb");
var $8FcCV = parcelRequire("8FcCV");
parcelRequire("grHtr");
var $dI7zX = parcelRequire("dI7zX");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");


var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $400933f5d0629393$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  wui-flex {\n    width: 100%;\n  }\n\n  wui-icon-link {\n    margin-right: calc(var(--wui-icon-box-size-md) * -1);\n  }\n\n  .account-links {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .account-links wui-flex {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex: 1;\n    background: red;\n    align-items: center;\n    justify-content: center;\n    height: 48px;\n    padding: 10px;\n    flex: 1 0 0;\n\n    border-radius: var(--XS, 16px);\n    border: 1px solid var(--dark-accent-glass-010, rgba(71, 161, 255, 0.1));\n    background: var(--dark-accent-glass-010, rgba(71, 161, 255, 0.1));\n    transition: background-color var(--wui-ease-out-power-1) var(--wui-duration-md);\n    will-change: background-color;\n  }\n\n  .account-links wui-flex:hover {\n    background: var(--dark-accent-glass-015, rgba(71, 161, 255, 0.15));\n  }\n\n  .account-links wui-flex wui-icon {\n    width: var(--S, 20px);\n    height: var(--S, 20px);\n  }\n\n  .account-links wui-flex wui-icon svg path {\n    stroke: #47a1ff;\n  }\n\n  .account-settings-button {\n    padding: calc(var(--wui-spacing-m) - 1px) var(--wui-spacing-2l);\n    height: 40px;\n    border-radius: var(--wui-border-radius-xxs);\n    border: 1px solid var(--wui-color-gray-glass-002);\n    background: var(--wui-color-gray-glass-002);\n    cursor: pointer;\n  }\n\n  .account-settings-button:hover {\n    background: var(--wui-color-gray-glass-005);\n  }\n"
    ]);
    $400933f5d0629393$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $400933f5d0629393$export$2e2bcd8739ae039 = (0, $2D5eP.css)($400933f5d0629393$var$_templateObject());


function $54da3209a9564746$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column" gap="l" .padding=',
        '>\n        <wui-flex flexDirection="column" alignItems="center" gap="l">\n          <wui-avatar\n            alt=',
        "\n            address=",
        "\n            imageSrc=",
        '\n            size="2lg"\n          ></wui-avatar>\n          <wui-flex flexDirection="column" alignItems="center">\n            <wui-flex gap="3xs" alignItems="center" justifyContent="center">\n              <wui-text variant="title-6-600" color="fg-100" data-testid="account-settings-address">\n                ',
        '\n              </wui-text>\n              <wui-icon-link\n                size="md"\n                icon="copy"\n                iconColor="fg-200"\n                @click=',
        '\n              ></wui-icon-link>\n            </wui-flex>\n          </wui-flex>\n        </wui-flex>\n        <wui-flex\n          data-testid="account-settings-button"\n          justifyContent="center"\n          alignItems="center"\n          class="account-settings-button"\n          @click=',
        '\n        >\n          <wui-text variant="paragraph-500" color="fg-100">Account Settings</wui-text>\n        </wui-flex>\n        ',
        "\n      </wui-flex>\n    "
    ]);
    $54da3209a9564746$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $54da3209a9564746$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '<wui-flex flexDirection="column">\n      <wui-flex .padding=',
        '>\n        <wui-text color="fg-200" variant="paragraph-400">Your accounts</wui-text>\n      </wui-flex>\n      <wui-flex flexDirection="column" gap="xxs">\n        ',
        "\n      </wui-flex>\n    </wui-flex>"
    ]);
    $54da3209a9564746$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $54da3209a9564746$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '<wui-button\n            slot="action"\n            textVariant="small-600"\n            size="sm"\n            variant="accent"\n            @click=',
        "\n            >Switch</wui-button\n          >"
    ]);
    $54da3209a9564746$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $54da3209a9564746$var$_templateObject3() {
    var data = (0, $j06k0._)([
        "<wui-list-account accountAddress=",
        " accountType=",
        ">\n      ",
        "\n    </wui-list-account>"
    ]);
    $54da3209a9564746$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var $54da3209a9564746$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $54da3209a9564746$export$dd89179375aa519e = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mProfileView, LitElement);
    var _super = (0, $ohfOJ._)(W3mProfileView);
    function W3mProfileView() {
        (0, $4GJKx._)(this, W3mProfileView);
        var _this;
        _this = _super.call(this);
        _this.usubscribe = [];
        _this.address = (0, $dMLJP.AccountController).state.address;
        _this.profileImage = (0, $dMLJP.AccountController).state.profileImage;
        _this.profileName = (0, $dMLJP.AccountController).state.profileName;
        _this.accounts = (0, $dMLJP.AccountController).state.allAccounts;
        _this.usubscribe.push((0, $dMLJP.AccountController).subscribeKey("address", function(address) {
            if (address) _this.address = address;
            else (0, $5Lhe6.ModalController).close();
        }));
        _this.usubscribe.push((0, $dMLJP.AccountController).subscribeKey("profileImage", function(profileImage) {
            _this.profileImage = profileImage;
        }));
        _this.usubscribe.push((0, $dMLJP.AccountController).subscribeKey("profileName", function(profileName) {
            _this.profileName = profileName;
        }));
        return _this;
    }
    (0, $1wc17._)(W3mProfileView, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.usubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_profileName;
                if (!this.address) throw new Error("w3m-profile-view: No account provided");
                var name = (_this_profileName = this.profileName) === null || _this_profileName === void 0 ? void 0 : _this_profileName.split(".")[0];
                return (0, $hxyOZ.html)($54da3209a9564746$var$_templateObject(), [
                    "0",
                    "xl",
                    "m",
                    "xl"
                ], this.address, this.address, (0, $696d14fc702af3d6$export$f68dd208b5df064d)(this.profileImage), name ? (0, $dI7zX.UiHelperUtil).getTruncateString({
                    string: name,
                    charsStart: 20,
                    charsEnd: 0,
                    truncate: "end"
                }) : (0, $dI7zX.UiHelperUtil).getTruncateString({
                    string: this.address,
                    charsStart: 4,
                    charsEnd: 6,
                    truncate: "middle"
                }), this.onCopyAddress, function() {
                    return (0, $iptjJ.RouterController).push("AccountSettings");
                }, this.accountsTemplate());
            }
        },
        {
            key: "accountsTemplate",
            value: function accountsTemplate() {
                var _this = this;
                return (0, $hxyOZ.html)($54da3209a9564746$var$_templateObject1(), [
                    "3xs",
                    "m",
                    "s",
                    "s"
                ], this.accounts.map(function(account) {
                    return _this.accountTemplate(account);
                }));
            }
        },
        {
            key: "onSwitchAccount",
            value: function onSwitchAccount(account) {
                return (0, $kSuI9._)(function() {
                    var emailConnector;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $dMLJP.AccountController).setShouldUpdateToAddress(account.address, (0, $9zDWP.ChainController).state.activeChain);
                                emailConnector = (0, $2qlRb.ConnectorController).getAuthConnector();
                                if (!emailConnector) return [
                                    2
                                ];
                                return [
                                    4,
                                    emailConnector.provider.setPreferredAccount(account.type)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    emailConnector.provider.connect()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "accountTemplate",
            value: function accountTemplate(account) {
                var _this = this;
                return (0, $hxyOZ.html)($54da3209a9564746$var$_templateObject3(), account.address, account.type, account.address === this.address ? "" : (0, $hxyOZ.html)($54da3209a9564746$var$_templateObject2(), function() {
                    return _this.onSwitchAccount(account);
                }));
            }
        },
        {
            key: "onCopyAddress",
            value: function onCopyAddress() {
                try {
                    if (this.profileName) {
                        (0, $hZBJb.CoreHelperUtil).copyToClopboard(this.profileName);
                        (0, $8FcCV.SnackController).showSuccess("Name copied");
                    } else if (this.address) {
                        (0, $hZBJb.CoreHelperUtil).copyToClopboard(this.address);
                        (0, $8FcCV.SnackController).showSuccess("Address copied");
                    }
                } catch (e) {
                    (0, $8FcCV.SnackController).showError("Failed to copy");
                }
            }
        }
    ]);
    return W3mProfileView;
}((0, $2yD3e.LitElement));
$54da3209a9564746$export$dd89179375aa519e.styles = (0, $400933f5d0629393$export$2e2bcd8739ae039);
$54da3209a9564746$var$__decorate([
    (0, $334Pv.state)()
], $54da3209a9564746$export$dd89179375aa519e.prototype, "address", void 0);
$54da3209a9564746$var$__decorate([
    (0, $334Pv.state)()
], $54da3209a9564746$export$dd89179375aa519e.prototype, "profileImage", void 0);
$54da3209a9564746$var$__decorate([
    (0, $334Pv.state)()
], $54da3209a9564746$export$dd89179375aa519e.prototype, "profileName", void 0);
$54da3209a9564746$var$__decorate([
    (0, $334Pv.state)()
], $54da3209a9564746$export$dd89179375aa519e.prototype, "accounts", void 0);
$54da3209a9564746$export$dd89179375aa519e = $54da3209a9564746$var$__decorate([
    (0, $hdxb6.customElement)("w3m-profile-view")
], $54da3209a9564746$export$dd89179375aa519e);



var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $04RAu = parcelRequire("04RAu");

var $b8Rim = parcelRequire("b8Rim");

var $dcsZi = parcelRequire("dcsZi");

var $do9pw = parcelRequire("do9pw");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("cwWZ7");
var $faNff = parcelRequire("faNff");
var $dMLJP = parcelRequire("dMLJP");
var $9zDWP = parcelRequire("9zDWP");
var $5Lhe6 = parcelRequire("5Lhe6");
var $3cYIS = parcelRequire("3cYIS");
var $iptjJ = parcelRequire("iptjJ");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");


var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $fa52de8aa032c5f4$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  input[type='checkbox'] {\n    all: revert;\n    width: var(--wui-spacing-xl);\n    height: var(--wui-spacing-xl);\n    accent-color: var(--wui-color-accent-100);\n  }\n"
    ]);
    $fa52de8aa032c5f4$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $fa52de8aa032c5f4$export$2e2bcd8739ae039 = (0, $2D5eP.css)($fa52de8aa032c5f4$var$_templateObject());


function $187fdbb4e1ed9c48$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n    <wui-flex justifyContent="center" .padding=',
        '>\n      <wui-banner-img imageSrc="',
        '" text="',
        '" size="sm"></wui-banner>\n    </wui-flex>\n    <wui-flex .padding=',
        ' flexDirection="row" justifyContent="space-between">\n        <wui-text variant="paragraph-400" color="fg-200">Select all</wui-text>\n        <input type="checkbox" .checked=',
        "  @click=",
        ' />\n    </wui-flex>\n      <wui-flex flexDirection="column" .padding=',
        ">\n        ",
        "\n      </wui-flex>\n      <wui-flex .padding=",
        ' gap="s" justifyContent="space-between">\n        <wui-button\n          size="md"\n          ?fullwidth=',
        '\n          variant="neutral"\n          @click=',
        '\n          data-testid="w3m-connecting-siwe-cancel"\n        >\n          Cancel\n        </wui-button>\n        <wui-button\n          size="md"\n          ?fullwidth=',
        '\n          variant="main"\n          .disabled=',
        "\n          @click=",
        "\n          ?loading=",
        "\n        >\n          ",
        "\n        </wui-button>\n      </wui-flex>\n    "
    ]);
    $187fdbb4e1ed9c48$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $187fdbb4e1ed9c48$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '<wui-list-account accountAddress="',
        '" accountType="',
        '">\n      <input\n        id="',
        '"\n        slot="action"\n        type="checkbox"\n        .checked="',
        '"\n        @change="',
        '"\n      />\n    </wui-list-account>'
    ]);
    $187fdbb4e1ed9c48$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $187fdbb4e1ed9c48$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $187fdbb4e1ed9c48$export$61dfe1ba29fc5d9d = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mSelectAddressesView, LitElement);
    var _super = (0, $ohfOJ._)(W3mSelectAddressesView);
    function W3mSelectAddressesView() {
        (0, $4GJKx._)(this, W3mSelectAddressesView);
        var _this;
        _this = _super.call(this);
        _this.metadata = (0, $faNff.OptionsController).state.metadata;
        _this.allAccounts = (0, $dMLJP.AccountController).state.allAccounts;
        _this.selectedAccounts = (0, $dMLJP.AccountController).state.allAccounts;
        _this.selectAll = true;
        _this.approved = false;
        _this.isApproving = false;
        _this.getAddressTemplate = function(account) {
            var checked = _this.selectedAccounts.some(function(_account) {
                return _account.address === account.address;
            });
            return (0, $hxyOZ.html)($187fdbb4e1ed9c48$var$_templateObject1(), account.address, account.type, account.address, checked, _this.handleClick(account));
        };
        _this.onSelectAll = function(event) {
            var checked = event.target.checked;
            _this.selectAll = _this.selectedAccounts.length === _this.allAccounts.length;
            _this.allAccounts.forEach(function(account) {
                _this.onSelect(account, checked);
            });
        };
        _this.onSelect = function(account, add) {
            if (add) _this.selectedAccounts.push(account);
            else _this.selectedAccounts = _this.selectedAccounts.filter(function(a) {
                return a.address !== account.address;
            });
            if (_this.selectedAccounts.length > 0) _this.selectAll = _this.selectedAccounts.length === _this.allAccounts.length;
        };
        (0, $dMLJP.AccountController).subscribeKey("allAccounts", function(allAccounts) {
            _this.allAccounts = allAccounts;
        });
        return _this;
    }
    (0, $1wc17._)(W3mSelectAddressesView, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_metadata, _this_metadata1;
                return (0, $hxyOZ.html)($187fdbb4e1ed9c48$var$_templateObject(), [
                    "xl",
                    "0",
                    "xl",
                    "0"
                ], (0, $696d14fc702af3d6$export$f68dd208b5df064d)((_this_metadata = this.metadata) === null || _this_metadata === void 0 ? void 0 : _this_metadata.icons[0]), (0, $696d14fc702af3d6$export$f68dd208b5df064d)((_this_metadata1 = this.metadata) === null || _this_metadata1 === void 0 ? void 0 : _this_metadata1.url), [
                    "0",
                    "xl",
                    "0",
                    "xl"
                ], this.selectAll, this.onSelectAll.bind(this), [
                    "l",
                    "xl",
                    "xl",
                    "xl"
                ], this.allAccounts.map(function(account) {
                    return _this.getAddressTemplate(account);
                }), [
                    "l",
                    "xl",
                    "xl",
                    "xl"
                ], true, this.onCancel.bind(this), true, this.selectedAccounts.length === 0, this.onContinue.bind(this), this.isApproving, this.isApproving ? "Signing..." : "Continue");
            }
        },
        {
            key: "handleClick",
            value: function handleClick(account) {
                var _this = this;
                return function(event) {
                    var _this_onSelect, _this1;
                    var target = event.target;
                    (_this_onSelect = (_this1 = _this).onSelect) === null || _this_onSelect === void 0 ? void 0 : _this_onSelect.call(_this1, (0, $do9pw._)({}, account), target === null || target === void 0 ? void 0 : target.checked);
                };
            }
        },
        {
            key: "onContinue",
            value: function onContinue() {
                if (this.selectedAccounts.length > 0) {
                    var _this_selectedAccounts_;
                    this.isApproving = true;
                    (0, $dMLJP.AccountController).setAllAccounts(this.selectedAccounts, (0, $9zDWP.ChainController).state.activeChain);
                    var _this_selectedAccounts__address;
                    (0, $dMLJP.AccountController).setShouldUpdateToAddress((_this_selectedAccounts__address = (_this_selectedAccounts_ = this.selectedAccounts[0]) === null || _this_selectedAccounts_ === void 0 ? void 0 : _this_selectedAccounts_.address) !== null && _this_selectedAccounts__address !== void 0 ? _this_selectedAccounts__address : "", (0, $9zDWP.ChainController).state.activeChain);
                    this.approved = true;
                    this.isApproving = false;
                    (0, $5Lhe6.ModalController).close();
                } else this.onCancel();
            }
        },
        {
            key: "onCancel",
            value: function onCancel() {
                return (0, $kSuI9._)(function() {
                    var isConnected;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                isConnected = (0, $dMLJP.AccountController).state.isConnected;
                                if (!isConnected) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (0, $3cYIS.ConnectionController).disconnect()
                                ];
                            case 1:
                                _state.sent();
                                (0, $5Lhe6.ModalController).close();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                (0, $iptjJ.RouterController).push("Connect");
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                (0, $04RAu._)((0, $b8Rim._)(W3mSelectAddressesView.prototype), "disconnectedCallback", this).call(this);
                if (!this.approved) this.onCancel();
            }
        }
    ]);
    return W3mSelectAddressesView;
}((0, $2yD3e.LitElement));
$187fdbb4e1ed9c48$export$61dfe1ba29fc5d9d.styles = (0, $fa52de8aa032c5f4$export$2e2bcd8739ae039);
$187fdbb4e1ed9c48$var$__decorate([
    (0, $334Pv.state)()
], $187fdbb4e1ed9c48$export$61dfe1ba29fc5d9d.prototype, "allAccounts", void 0);
$187fdbb4e1ed9c48$var$__decorate([
    (0, $334Pv.state)()
], $187fdbb4e1ed9c48$export$61dfe1ba29fc5d9d.prototype, "selectedAccounts", void 0);
$187fdbb4e1ed9c48$var$__decorate([
    (0, $334Pv.state)()
], $187fdbb4e1ed9c48$export$61dfe1ba29fc5d9d.prototype, "selectAll", void 0);
$187fdbb4e1ed9c48$var$__decorate([
    (0, $334Pv.state)()
], $187fdbb4e1ed9c48$export$61dfe1ba29fc5d9d.prototype, "approved", void 0);
$187fdbb4e1ed9c48$var$__decorate([
    (0, $334Pv.state)()
], $187fdbb4e1ed9c48$export$61dfe1ba29fc5d9d.prototype, "isApproving", void 0);
$187fdbb4e1ed9c48$export$61dfe1ba29fc5d9d = $187fdbb4e1ed9c48$var$__decorate([
    (0, $hdxb6.customElement)("w3m-select-addresses-view")
], $187fdbb4e1ed9c48$export$61dfe1ba29fc5d9d);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $04RAu = parcelRequire("04RAu");

var $b8Rim = parcelRequire("b8Rim");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $faNff = parcelRequire("faNff");
var $dMLJP = parcelRequire("dMLJP");
var $i7zcD = parcelRequire("i7zcD");
var $fPqxb = parcelRequire("fPqxb");
var $jrvVk = parcelRequire("jrvVk");
var $9zDWP = parcelRequire("9zDWP");
var $5Lhe6 = parcelRequire("5Lhe6");
parcelRequire("grHtr");
var $dI7zX = parcelRequire("dI7zX");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $18e28b40aa793574$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  wui-avatar {\n    width: var(--wui-spacing-3xl);\n    height: var(--wui-spacing-3xl);\n    box-shadow: 0 0 0 0;\n  }\n\n  wui-icon-box {\n    position: relative;\n    right: 15px;\n    top: 15px;\n    border: 2px solid var(--wui-color-bg-150);\n    background-color: var(--wui-color-bg-125);\n  }\n"
    ]);
    $18e28b40aa793574$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $18e28b40aa793574$export$2e2bcd8739ae039 = (0, $2D5eP.css)($18e28b40aa793574$var$_templateObject());



function $0823607eef4d1dc9$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex justifyContent="center" .padding=',
        ">\n        <wui-banner-img\n          imageSrc=",
        "\n          text=",
        '\n          size="sm"\n        ></wui-banner-img>\n      </wui-flex>\n      <wui-flex flexDirection="column" gap="xxl" .padding=',
        ">\n        ",
        "\n      </wui-flex>\n    "
    ]);
    $0823607eef4d1dc9$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $0823607eef4d1dc9$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '<wui-icon-box\n                size="sm"\n                iconcolor="fg-200"\n                backgroundcolor="glass-002"\n                background="gray"\n                icon="',
        '"\n                ?border=',
        "\n              ></wui-icon-box>"
    ]);
    $0823607eef4d1dc9$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $0823607eef4d1dc9$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '<wui-flex .padding="',
        '"></wui-flex>'
    ]);
    $0823607eef4d1dc9$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $0823607eef4d1dc9$var$_templateObject3() {
    var data = (0, $j06k0._)([
        '<wui-loading-spinner size="sm" color="accent-100"></wui-loading-spinner>'
    ]);
    $0823607eef4d1dc9$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $0823607eef4d1dc9$var$_templateObject4() {
    var data = (0, $j06k0._)([
        "\n                <wui-button\n                  data-testid=",
        '\n                  textVariant="small-600"\n                  size="md"\n                  variant="accent"\n                  @click=',
        "\n                  >Switch to</wui-button\n                >\n              "
    ]);
    $0823607eef4d1dc9$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $0823607eef4d1dc9$var$_templateObject5() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex\n        flexDirection="row"\n        justifyContent="space-between"\n        data-testid="switch-address-item"\n      >\n        <wui-flex alignItems="center">\n          <wui-avatar address=',
        "></wui-avatar>\n          ",
        '\n          <wui-flex flexDirection="column">\n            <wui-text class="address" variant="paragraph-500" color="fg-100"\n              >',
        '</wui-text\n            >\n            <wui-text class="address-description" variant="small-400">\n              ',
        '\n            </wui-text>\n          </wui-flex>\n        </wui-flex>\n        <wui-flex gap="s" alignItems="center">\n          ',
        "\n        </wui-flex>\n      </wui-flex>\n    "
    ]);
    $0823607eef4d1dc9$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
var $0823607eef4d1dc9$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $0823607eef4d1dc9$export$7ff6a3b4aced362e = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mSwitchAddressView, LitElement);
    var _super = (0, $ohfOJ._)(W3mSwitchAddressView);
    function W3mSwitchAddressView() {
        (0, $4GJKx._)(this, W3mSwitchAddressView);
        var _this;
        _this = _super.call(this);
        _this.metadata = (0, $faNff.OptionsController).state.metadata;
        _this.allAccounts = (0, $dMLJP.AccountController).state.allAccounts || [];
        _this.balances = {};
        _this.labels = (0, $dMLJP.AccountController).state.addressLabels;
        _this.currentAddress = (0, $dMLJP.AccountController).state.address || "";
        _this.connectedConnector = (0, $i7zcD.StorageUtil).getConnectedConnector();
        _this.shouldShowIcon = _this.connectedConnector === "AUTH";
        _this.caipNetwork = (0, $fPqxb.NetworkController).state.caipNetwork;
        (0, $dMLJP.AccountController).subscribeKey("allAccounts", function(allAccounts) {
            _this.allAccounts = allAccounts;
        });
        return _this;
    }
    (0, $1wc17._)(W3mSwitchAddressView, [
        {
            key: "connectedCallback",
            value: function connectedCallback() {
                var _this = this;
                (0, $04RAu._)((0, $b8Rim._)(W3mSwitchAddressView.prototype), "connectedCallback", this).call(this);
                this.allAccounts.forEach(function(account) {
                    var _this_caipNetwork;
                    (0, $jrvVk.BlockchainApiController).getBalance(account.address, (_this_caipNetwork = _this.caipNetwork) === null || _this_caipNetwork === void 0 ? void 0 : _this_caipNetwork.id).then(function(response) {
                        var total = _this.balances[account.address] || 0;
                        if (response.balances.length > 0) total = response.balances.reduce(function(acc, balance) {
                            return acc + ((balance === null || balance === void 0 ? void 0 : balance.value) || 0);
                        }, 0);
                        _this.balances[account.address] = total;
                        _this.requestUpdate();
                    });
                });
            }
        },
        {
            key: "getAddressIcon",
            value: function getAddressIcon(type) {
                if (type === "smartAccount") return "lightbulb";
                return "mail";
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_metadata, _this_metadata1;
                return (0, $hxyOZ.html)($0823607eef4d1dc9$var$_templateObject(), [
                    "xl",
                    "0",
                    "xl",
                    "0"
                ], (0, $696d14fc702af3d6$export$f68dd208b5df064d)((_this_metadata = this.metadata) === null || _this_metadata === void 0 ? void 0 : _this_metadata.icons[0]), (0, $696d14fc702af3d6$export$f68dd208b5df064d)((_this_metadata1 = this.metadata) === null || _this_metadata1 === void 0 ? void 0 : _this_metadata1.url), [
                    "l",
                    "xl",
                    "xl",
                    "xl"
                ], this.allAccounts.map(function(account, index) {
                    return _this.getAddressTemplate(account, index);
                }));
            }
        },
        {
            key: "getAddressTemplate",
            value: function getAddressTemplate(account, index) {
                var _this = this;
                var _this_labels, _this_balances_account_address, _account_address, _this_currentAddress;
                var label = (_this_labels = this.labels) === null || _this_labels === void 0 ? void 0 : _this_labels.get(account.address);
                return (0, $hxyOZ.html)($0823607eef4d1dc9$var$_templateObject5(), account.address, this.shouldShowIcon ? (0, $hxyOZ.html)($0823607eef4d1dc9$var$_templateObject1(), this.getAddressIcon(account.type), true) : (0, $hxyOZ.html)($0823607eef4d1dc9$var$_templateObject2(), [
                    "0",
                    "0",
                    "0",
                    "s"
                ]), label ? label : (0, $dI7zX.UiHelperUtil).getTruncateString({
                    string: account.address,
                    charsStart: 4,
                    charsEnd: 6,
                    truncate: "middle"
                }), typeof this.balances[account.address] === "number" ? "$".concat((_this_balances_account_address = this.balances[account.address]) === null || _this_balances_account_address === void 0 ? void 0 : _this_balances_account_address.toFixed(2)) : (0, $hxyOZ.html)($0823607eef4d1dc9$var$_templateObject3()), ((_account_address = account.address) === null || _account_address === void 0 ? void 0 : _account_address.toLowerCase()) === ((_this_currentAddress = this.currentAddress) === null || _this_currentAddress === void 0 ? void 0 : _this_currentAddress.toLowerCase()) ? "" : (0, $hxyOZ.html)($0823607eef4d1dc9$var$_templateObject4(), "w3m-switch-address-button-".concat(index), function() {
                    return _this.onSwitchAddress(account.address);
                }));
            }
        },
        {
            key: "onSwitchAddress",
            value: function onSwitchAddress(address) {
                (0, $dMLJP.AccountController).setShouldUpdateToAddress(address, (0, $9zDWP.ChainController).state.activeChain);
                (0, $5Lhe6.ModalController).close();
            }
        }
    ]);
    return W3mSwitchAddressView;
}((0, $2yD3e.LitElement));
$0823607eef4d1dc9$export$7ff6a3b4aced362e.styles = (0, $18e28b40aa793574$export$2e2bcd8739ae039);
$0823607eef4d1dc9$var$__decorate([
    (0, $334Pv.state)()
], $0823607eef4d1dc9$export$7ff6a3b4aced362e.prototype, "allAccounts", void 0);
$0823607eef4d1dc9$var$__decorate([
    (0, $334Pv.state)()
], $0823607eef4d1dc9$export$7ff6a3b4aced362e.prototype, "balances", void 0);
$0823607eef4d1dc9$export$7ff6a3b4aced362e = $0823607eef4d1dc9$var$__decorate([
    (0, $hdxb6.customElement)("w3m-switch-address-view")
], $0823607eef4d1dc9$export$7ff6a3b4aced362e);



var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $04RAu = parcelRequire("04RAu");

var $b8Rim = parcelRequire("b8Rim");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("cwWZ7");
var $dMLJP = parcelRequire("dMLJP");
var $2qlRb = parcelRequire("2qlRb");
var $hZBJb = parcelRequire("hZBJb");
var $dJ6Ea = parcelRequire("dJ6Ea");
var $i7zcD = parcelRequire("i7zcD");
var $3cYIS = parcelRequire("3cYIS");
var $5Lhe6 = parcelRequire("5Lhe6");
var $iptjJ = parcelRequire("iptjJ");
var $8FcCV = parcelRequire("8FcCV");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $f7b47e6cbc3d345b$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  @keyframes fadein {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  wui-shimmer {\n    width: 100%;\n    aspect-ratio: 1 / 1;\n    border-radius: clamp(0px, var(--wui-border-radius-l), 40px) !important;\n  }\n\n  wui-qr-code {\n    opacity: 0;\n    animation-duration: 200ms;\n    animation-timing-function: ease;\n    animation-name: fadein;\n    animation-fill-mode: forwards;\n  }\n\n  wui-logo {\n    width: 80px;\n    height: 80px;\n    border-radius: var(--wui-border-radius-m);\n  }\n\n  wui-flex:first-child:not(:only-child) {\n    position: relative;\n  }\n  wui-loading-thumbnail {\n    position: absolute;\n  }\n  wui-icon-box {\n    position: absolute;\n    right: calc(var(--wui-spacing-3xs) * -1);\n    bottom: calc(var(--wui-spacing-3xs) * -1);\n    opacity: 0;\n    transform: scale(0.5);\n    transition: all var(--wui-ease-out-power-2) var(--wui-duration-lg);\n  }\n"
    ]);
    $f7b47e6cbc3d345b$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $f7b47e6cbc3d345b$export$2e2bcd8739ae039 = (0, $2D5eP.css)($f7b47e6cbc3d345b$var$_templateObject());


function $23f5cb99964ac9f5$var$_templateObject() {
    var data = (0, $j06k0._)([
        "",
        ""
    ]);
    $23f5cb99964ac9f5$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $23f5cb99964ac9f5$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "",
        ""
    ]);
    $23f5cb99964ac9f5$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $23f5cb99964ac9f5$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "",
        ""
    ]);
    $23f5cb99964ac9f5$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $23f5cb99964ac9f5$var$_templateObject3() {
    var data = (0, $j06k0._)([
        "",
        ""
    ]);
    $23f5cb99964ac9f5$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $23f5cb99964ac9f5$var$_templateObject4() {
    var data = (0, $j06k0._)([
        "",
        ""
    ]);
    $23f5cb99964ac9f5$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $23f5cb99964ac9f5$var$_templateObject5() {
    var data = (0, $j06k0._)([
        ' <wui-flex\n      flexDirection="column"\n      alignItems="center"\n      .padding=',
        '\n      gap="xl"\n    >\n      <wui-shimmer borderRadius="l" width="100%"> ',
        ' </wui-shimmer>\n\n      <wui-text variant="paragraph-500" color="fg-100">\n        Scan this QR Code with your phone\n      </wui-text>\n      ',
        "\n    </wui-flex>"
    ]);
    $23f5cb99964ac9f5$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $23f5cb99964ac9f5$var$_templateObject6() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex\n        flexDirection="column"\n        alignItems="center"\n        .padding=',
        '\n        gap="xl"\n      >\n        <wui-flex justifyContent="center" alignItems="center">\n          <wui-logo logo="farcaster"></wui-logo>\n          ',
        '\n          <wui-icon-box\n            backgroundColor="error-100"\n            background="opaque"\n            iconColor="error-100"\n            icon="close"\n            size="sm"\n            border\n            borderColor="wui-color-bg-125"\n          ></wui-icon-box>\n        </wui-flex>\n        <wui-flex flexDirection="column" alignItems="center" gap="xs">\n          <wui-text align="center" variant="paragraph-500" color="fg-100">\n            Loading user data\n          </wui-text>\n          <wui-text align="center" variant="small-400" color="fg-200">\n            Please wait a moment while we load your data.\n          </wui-text>\n        </wui-flex>\n      </wui-flex>\n    '
    ]);
    $23f5cb99964ac9f5$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $23f5cb99964ac9f5$var$_templateObject7() {
    var data = (0, $j06k0._)([
        ' <wui-flex\n      flexDirection="column"\n      alignItems="center"\n      .padding=',
        '\n      gap="xl"\n    >\n      <wui-flex justifyContent="center" alignItems="center">\n        <wui-logo logo="farcaster"></wui-logo>\n        ',
        '\n        <wui-icon-box\n          backgroundColor="error-100"\n          background="opaque"\n          iconColor="error-100"\n          icon="close"\n          size="sm"\n          border\n          borderColor="wui-color-bg-125"\n        ></wui-icon-box>\n      </wui-flex>\n      <wui-flex flexDirection="column" alignItems="center" gap="xs">\n        <wui-text align="center" variant="paragraph-500" color="fg-100"\n          >Continue in Farcaster</span></wui-text\n        >\n        <wui-text align="center" variant="small-400" color="fg-200"\n          >Accept connection request in the app</wui-text\n        ></wui-flex\n      >\n      ',
        "\n    </wui-flex>"
    ]);
    $23f5cb99964ac9f5$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $23f5cb99964ac9f5$var$_templateObject8() {
    var data = (0, $j06k0._)([
        "<wui-loading-thumbnail radius=",
        "></wui-loading-thumbnail>"
    ]);
    $23f5cb99964ac9f5$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function $23f5cb99964ac9f5$var$_templateObject9() {
    var data = (0, $j06k0._)([
        '<wui-button\n      size="md"\n      ?loading=',
        "\n      ?disabled=",
        "\n      @click=",
        "\n    >\n      Open farcaster</wui-button\n    >"
    ]);
    $23f5cb99964ac9f5$var$_templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function $23f5cb99964ac9f5$var$_templateObject10() {
    var data = (0, $j06k0._)([
        " <wui-qr-code\n      size=",
        "\n      theme=",
        "\n      uri=",
        "\n      ?farcaster=",
        '\n      data-testid="wui-qr-code"\n    ></wui-qr-code>'
    ]);
    $23f5cb99964ac9f5$var$_templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function $23f5cb99964ac9f5$var$_templateObject11() {
    var data = (0, $j06k0._)([
        "<wui-link\n      .disabled=",
        "\n      @click=",
        '\n      color="fg-200"\n      data-testid="copy-wc2-uri"\n    >\n      <wui-icon size="xs" color="fg-200" slot="iconLeft" name="copy"></wui-icon>\n      Copy link\n    </wui-link>'
    ]);
    $23f5cb99964ac9f5$var$_templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
var $23f5cb99964ac9f5$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $23f5cb99964ac9f5$export$cf5e35f91724cbaf = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mConnectingFarcasterView, LitElement);
    var _super = (0, $ohfOJ._)(W3mConnectingFarcasterView);
    function W3mConnectingFarcasterView() {
        var _this_unsubscribe;
        (0, $4GJKx._)(this, W3mConnectingFarcasterView);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.timeout = undefined;
        _this.socialProvider = (0, $dMLJP.AccountController).state.socialProvider;
        _this.uri = (0, $dMLJP.AccountController).state.farcasterUrl;
        _this.ready = false;
        _this.loading = false;
        _this.authConnector = (0, $2qlRb.ConnectorController).getAuthConnector();
        _this.forceUpdate = function() {
            _this.requestUpdate();
        };
        (_this_unsubscribe = _this.unsubscribe).push.apply(_this_unsubscribe, [
            (0, $dMLJP.AccountController).subscribeKey("farcasterUrl", function(val) {
                if (val) {
                    _this.uri = val;
                    _this.connectFarcaster();
                }
            }),
            (0, $dMLJP.AccountController).subscribeKey("socialProvider", function(val) {
                if (val) _this.socialProvider = val;
            })
        ]);
        window.addEventListener("resize", _this.forceUpdate);
        return _this;
    }
    (0, $1wc17._)(W3mConnectingFarcasterView, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                (0, $04RAu._)((0, $b8Rim._)(W3mConnectingFarcasterView.prototype), "disconnectedCallback", this).call(this);
                clearTimeout(this.timeout);
                window.removeEventListener("resize", this.forceUpdate);
            }
        },
        {
            key: "render",
            value: function render() {
                this.onRenderProxy();
                return (0, $hxyOZ.html)($23f5cb99964ac9f5$var$_templateObject(), this.platformTemplate());
            }
        },
        {
            key: "platformTemplate",
            value: function platformTemplate() {
                if ((0, $hZBJb.CoreHelperUtil).isMobile()) return (0, $hxyOZ.html)($23f5cb99964ac9f5$var$_templateObject1(), this.mobileTemplate());
                return (0, $hxyOZ.html)($23f5cb99964ac9f5$var$_templateObject2(), this.desktopTemplate());
            }
        },
        {
            key: "desktopTemplate",
            value: function desktopTemplate() {
                if (this.loading) return (0, $hxyOZ.html)($23f5cb99964ac9f5$var$_templateObject3(), this.loadingTemplate());
                return (0, $hxyOZ.html)($23f5cb99964ac9f5$var$_templateObject4(), this.qrTemplate());
            }
        },
        {
            key: "qrTemplate",
            value: function qrTemplate() {
                return (0, $hxyOZ.html)($23f5cb99964ac9f5$var$_templateObject5(), [
                    "0",
                    "xl",
                    "xl",
                    "xl"
                ], this.qrCodeTemplate(), this.copyTemplate());
            }
        },
        {
            key: "loadingTemplate",
            value: function loadingTemplate() {
                return (0, $hxyOZ.html)($23f5cb99964ac9f5$var$_templateObject6(), [
                    "xl",
                    "xl",
                    "xl",
                    "xl"
                ], this.loaderTemplate());
            }
        },
        {
            key: "mobileTemplate",
            value: function mobileTemplate() {
                return (0, $hxyOZ.html)($23f5cb99964ac9f5$var$_templateObject7(), [
                    "3xl",
                    "xl",
                    "xl",
                    "xl"
                ], this.loaderTemplate(), this.mobileLinkTemplate());
            }
        },
        {
            key: "loaderTemplate",
            value: function loaderTemplate() {
                var borderRadiusMaster = (0, $dJ6Ea.ThemeController).state.themeVariables["--w3m-border-radius-master"];
                var radius = borderRadiusMaster ? parseInt(borderRadiusMaster.replace("px", ""), 10) : 4;
                return (0, $hxyOZ.html)($23f5cb99964ac9f5$var$_templateObject8(), radius * 9);
            }
        },
        {
            key: "connectFarcaster",
            value: function connectFarcaster() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _this_authConnector, error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.authConnector) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    (_this_authConnector = _this.authConnector) === null || _this_authConnector === void 0 ? void 0 : _this_authConnector.provider.connectFarcaster()
                                ];
                            case 2:
                                _state.sent();
                                if (_this.socialProvider) (0, $i7zcD.StorageUtil).setConnectedSocialProvider(_this.socialProvider);
                                _this.loading = true;
                                return [
                                    4,
                                    (0, $3cYIS.ConnectionController).connectExternal(_this.authConnector, _this.authConnector.chain)
                                ];
                            case 3:
                                _state.sent();
                                _this.loading = false;
                                (0, $5Lhe6.ModalController).close();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                error = _state.sent();
                                (0, $iptjJ.RouterController).goBack();
                                (0, $8FcCV.SnackController).showError(error);
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "mobileLinkTemplate",
            value: function mobileLinkTemplate() {
                var _this = this;
                return (0, $hxyOZ.html)($23f5cb99964ac9f5$var$_templateObject9(), this.loading, !this.uri || this.loading, function() {
                    if (_this.uri) (0, $hZBJb.CoreHelperUtil).openHref(_this.uri, "_blank");
                });
            }
        },
        {
            key: "onRenderProxy",
            value: function onRenderProxy() {
                var _this = this;
                if (!this.ready && this.uri) this.timeout = setTimeout(function() {
                    _this.ready = true;
                }, 0);
            }
        },
        {
            key: "qrCodeTemplate",
            value: function qrCodeTemplate() {
                if (!this.uri || !this.ready) return null;
                var size = this.getBoundingClientRect().width - 40;
                return (0, $hxyOZ.html)($23f5cb99964ac9f5$var$_templateObject10(), size, (0, $dJ6Ea.ThemeController).state.themeMode, this.uri, true);
            }
        },
        {
            key: "copyTemplate",
            value: function copyTemplate() {
                var inactive = !this.uri || !this.ready;
                return (0, $hxyOZ.html)($23f5cb99964ac9f5$var$_templateObject11(), inactive, this.onCopyUri);
            }
        },
        {
            key: "onCopyUri",
            value: function onCopyUri() {
                try {
                    if (this.uri) {
                        (0, $hZBJb.CoreHelperUtil).copyToClopboard(this.uri);
                        (0, $8FcCV.SnackController).showSuccess("Link copied");
                    }
                } catch (e) {
                    (0, $8FcCV.SnackController).showError("Failed to copy");
                }
            }
        }
    ]);
    return W3mConnectingFarcasterView;
}((0, $2yD3e.LitElement));
$23f5cb99964ac9f5$export$cf5e35f91724cbaf.styles = (0, $f7b47e6cbc3d345b$export$2e2bcd8739ae039);
$23f5cb99964ac9f5$var$__decorate([
    (0, $334Pv.state)()
], $23f5cb99964ac9f5$export$cf5e35f91724cbaf.prototype, "socialProvider", void 0);
$23f5cb99964ac9f5$var$__decorate([
    (0, $334Pv.state)()
], $23f5cb99964ac9f5$export$cf5e35f91724cbaf.prototype, "uri", void 0);
$23f5cb99964ac9f5$var$__decorate([
    (0, $334Pv.state)()
], $23f5cb99964ac9f5$export$cf5e35f91724cbaf.prototype, "ready", void 0);
$23f5cb99964ac9f5$var$__decorate([
    (0, $334Pv.state)()
], $23f5cb99964ac9f5$export$cf5e35f91724cbaf.prototype, "loading", void 0);
$23f5cb99964ac9f5$export$cf5e35f91724cbaf = $23f5cb99964ac9f5$var$__decorate([
    (0, $hdxb6.customElement)("w3m-connecting-farcaster-view")
], $23f5cb99964ac9f5$export$cf5e35f91724cbaf);



var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $cv9Rk = parcelRequire("cv9Rk");

var $j06k0 = parcelRequire("j06k0");

var $c6Xmf = parcelRequire("c6Xmf");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("cwWZ7");
var $hMdcG = parcelRequire("hMdcG");
var $2qlRb = parcelRequire("2qlRb");
var $iptjJ = parcelRequire("iptjJ");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");


var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $02b512d39fd408f9$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  wui-grid {\n    max-height: clamp(360px, 400px, 80vh);\n    overflow: scroll;\n    scrollbar-width: none;\n    grid-auto-rows: min-content;\n    grid-template-columns: repeat(auto-fill, 76px);\n  }\n\n  @media (max-width: 435px) {\n    wui-grid {\n      grid-template-columns: repeat(auto-fill, 77px);\n    }\n  }\n\n  wui-grid[data-scroll='false'] {\n    overflow: hidden;\n  }\n\n  wui-grid::-webkit-scrollbar {\n    display: none;\n  }\n\n  wui-loading-spinner {\n    padding-top: var(--wui-spacing-l);\n    padding-bottom: var(--wui-spacing-l);\n    justify-content: center;\n    grid-column: 1 / span 4;\n  }\n"
    ]);
    $02b512d39fd408f9$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $02b512d39fd408f9$export$2e2bcd8739ae039 = (0, $2D5eP.css)($02b512d39fd408f9$var$_templateObject());



var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");
parcelRequire("cwWZ7");
var $2qlRb = parcelRequire("2qlRb");
function $c597bb466e6ae7c9$export$cffc81df24a1f1f1(wallets) {
    var connectors = (0, $2qlRb.ConnectorController).state.connectors;
    var installedConnectors = connectors.filter(function(c) {
        return c.type === "ANNOUNCED";
    }).reduce(function(acum, val) {
        var _val_info;
        if (!((_val_info = val.info) === null || _val_info === void 0 ? void 0 : _val_info.rdns)) return acum;
        acum[val.info.rdns] = true;
        return acum;
    }, {});
    var walletsWithInstalled = wallets.map(function(wallet) {
        var _wallet_rdns;
        return (0, $cxjpp._)((0, $do9pw._)({}, wallet), {
            installed: Boolean(wallet.rdns) && Boolean(installedConnectors[(_wallet_rdns = wallet.rdns) !== null && _wallet_rdns !== void 0 ? _wallet_rdns : ""])
        });
    });
    var sortedWallets = walletsWithInstalled.sort(function(a, b) {
        return Number(b.installed) - Number(a.installed);
    });
    return sortedWallets;
}


function $d1e74532862a1b5f$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      <wui-grid\n        data-scroll=",
        "\n        .padding=",
        '\n        columnGap="xxs"\n        rowGap="l"\n        justifyContent="space-between"\n      >\n        ',
        "\n        ",
        "\n      </wui-grid>\n    "
    ]);
    $d1e74532862a1b5f$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $d1e74532862a1b5f$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '\n        <wui-card-select-loader type="wallet" id=',
        "></wui-card-select-loader>\n      "
    ]);
    $d1e74532862a1b5f$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $d1e74532862a1b5f$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "\n        <w3m-all-wallets-list-item\n          @click=",
        "\n          .wallet=",
        "\n        ></w3m-all-wallets-list-item>\n      "
    ]);
    $d1e74532862a1b5f$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $d1e74532862a1b5f$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d1e74532862a1b5f$var$PAGINATOR_ID = "local-paginator";
var $d1e74532862a1b5f$export$f39175f9037ce7d2 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mAllWalletsList, LitElement);
    var _super = (0, $ohfOJ._)(W3mAllWalletsList);
    function W3mAllWalletsList() {
        var _this_unsubscribe;
        (0, $4GJKx._)(this, W3mAllWalletsList);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.paginationObserver = undefined;
        _this.initial = !(0, $hMdcG.ApiController).state.wallets.length;
        _this.wallets = (0, $hMdcG.ApiController).state.wallets;
        _this.recommended = (0, $hMdcG.ApiController).state.recommended;
        _this.featured = (0, $hMdcG.ApiController).state.featured;
        (_this_unsubscribe = _this.unsubscribe).push.apply(_this_unsubscribe, [
            (0, $hMdcG.ApiController).subscribeKey("wallets", function(val) {
                return _this.wallets = val;
            }),
            (0, $hMdcG.ApiController).subscribeKey("recommended", function(val) {
                return _this.recommended = val;
            }),
            (0, $hMdcG.ApiController).subscribeKey("featured", function(val) {
                return _this.featured = val;
            })
        ]);
        return _this;
    }
    (0, $1wc17._)(W3mAllWalletsList, [
        {
            key: "firstUpdated",
            value: function firstUpdated() {
                this.initialFetch();
                this.createPaginationObserver();
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                var _this_paginationObserver;
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
                (_this_paginationObserver = this.paginationObserver) === null || _this_paginationObserver === void 0 ? void 0 : _this_paginationObserver.disconnect();
            }
        },
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($d1e74532862a1b5f$var$_templateObject(), !this.initial, [
                    "0",
                    "s",
                    "s",
                    "s"
                ], this.initial ? this.shimmerTemplate(16) : this.walletsTemplate(), this.paginationLoaderTemplate());
            }
        },
        {
            key: "initialFetch",
            value: function initialFetch() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _this_shadowRoot, gridEl;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                gridEl = (_this_shadowRoot = _this.shadowRoot) === null || _this_shadowRoot === void 0 ? void 0 : _this_shadowRoot.querySelector("wui-grid");
                                if (!(_this.initial && gridEl)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    (0, $hMdcG.ApiController).fetchWallets({
                                        page: 1
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    gridEl.animate([
                                        {
                                            opacity: 1
                                        },
                                        {
                                            opacity: 0
                                        }
                                    ], {
                                        duration: 200,
                                        fill: "forwards",
                                        easing: "ease"
                                    }).finished
                                ];
                            case 2:
                                _state.sent();
                                _this.initial = false;
                                gridEl.animate([
                                    {
                                        opacity: 0
                                    },
                                    {
                                        opacity: 1
                                    }
                                ], {
                                    duration: 200,
                                    fill: "forwards",
                                    easing: "ease"
                                });
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "shimmerTemplate",
            value: function shimmerTemplate(items, id) {
                return (0, $c6Xmf._)(Array(items)).map(function() {
                    return (0, $hxyOZ.html)($d1e74532862a1b5f$var$_templateObject1(), (0, $696d14fc702af3d6$export$f68dd208b5df064d)(id));
                });
            }
        },
        {
            key: "walletsTemplate",
            value: function walletsTemplate() {
                var _this = this;
                var wallets = (0, $c6Xmf._)(this.featured).concat((0, $c6Xmf._)(this.recommended), (0, $c6Xmf._)(this.wallets));
                var walletsWithInstalled = (0, $c597bb466e6ae7c9$export$cffc81df24a1f1f1)(wallets);
                return walletsWithInstalled.map(function(wallet) {
                    return (0, $hxyOZ.html)($d1e74532862a1b5f$var$_templateObject2(), function() {
                        return _this.onConnectWallet(wallet);
                    }, wallet);
                });
            }
        },
        {
            key: "paginationLoaderTemplate",
            value: function paginationLoaderTemplate() {
                var _ApiController_state = (0, $hMdcG.ApiController).state, wallets = _ApiController_state.wallets, recommended = _ApiController_state.recommended, featured = _ApiController_state.featured, count = _ApiController_state.count;
                var columns = window.innerWidth < 352 ? 3 : 4;
                var currentWallets = wallets.length + recommended.length;
                var minimumRows = Math.ceil(currentWallets / columns);
                var shimmerCount = minimumRows * columns - currentWallets + columns;
                shimmerCount -= wallets.length ? featured.length % columns : 0;
                if (count === 0 && featured.length > 0) return null;
                if (count === 0 || (0, $c6Xmf._)(featured).concat((0, $c6Xmf._)(wallets), (0, $c6Xmf._)(recommended)).length < count) return this.shimmerTemplate(shimmerCount, $d1e74532862a1b5f$var$PAGINATOR_ID);
                return null;
            }
        },
        {
            key: "createPaginationObserver",
            value: function createPaginationObserver() {
                var _this = this;
                var _this_shadowRoot;
                var loaderEl = (_this_shadowRoot = this.shadowRoot) === null || _this_shadowRoot === void 0 ? void 0 : _this_shadowRoot.querySelector("#".concat($d1e74532862a1b5f$var$PAGINATOR_ID));
                if (loaderEl) {
                    this.paginationObserver = new IntersectionObserver(function(param) {
                        var _param = (0, $cv9Rk._)(param, 1), element = _param[0];
                        if ((element === null || element === void 0 ? void 0 : element.isIntersecting) && !_this.initial) {
                            var _ApiController_state = (0, $hMdcG.ApiController).state, page = _ApiController_state.page, count = _ApiController_state.count, wallets = _ApiController_state.wallets;
                            if (wallets.length < count) (0, $hMdcG.ApiController).fetchWallets({
                                page: page + 1
                            });
                        }
                    });
                    this.paginationObserver.observe(loaderEl);
                }
            }
        },
        {
            key: "onConnectWallet",
            value: function onConnectWallet(wallet) {
                var connector = (0, $2qlRb.ConnectorController).getConnector(wallet.id, wallet.rdns);
                if (connector) (0, $iptjJ.RouterController).push("ConnectingExternal", {
                    connector: connector
                });
                else (0, $iptjJ.RouterController).push("ConnectingWalletConnect", {
                    wallet: wallet
                });
            }
        }
    ]);
    return W3mAllWalletsList;
}((0, $2yD3e.LitElement));
$d1e74532862a1b5f$export$f39175f9037ce7d2.styles = (0, $02b512d39fd408f9$export$2e2bcd8739ae039);
$d1e74532862a1b5f$var$__decorate([
    (0, $334Pv.state)()
], $d1e74532862a1b5f$export$f39175f9037ce7d2.prototype, "initial", void 0);
$d1e74532862a1b5f$var$__decorate([
    (0, $334Pv.state)()
], $d1e74532862a1b5f$export$f39175f9037ce7d2.prototype, "wallets", void 0);
$d1e74532862a1b5f$var$__decorate([
    (0, $334Pv.state)()
], $d1e74532862a1b5f$export$f39175f9037ce7d2.prototype, "recommended", void 0);
$d1e74532862a1b5f$var$__decorate([
    (0, $334Pv.state)()
], $d1e74532862a1b5f$export$f39175f9037ce7d2.prototype, "featured", void 0);
$d1e74532862a1b5f$export$f39175f9037ce7d2 = $d1e74532862a1b5f$var$__decorate([
    (0, $hdxb6.customElement)("w3m-all-wallets-list")
], $d1e74532862a1b5f$export$f39175f9037ce7d2);



var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");
var $04kNM = parcelRequire("04kNM");

parcelRequire("cwWZ7");
var $khm6W = parcelRequire("khm6W");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $062c2bcc016211ab$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  button {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 76px;\n    row-gap: var(--wui-spacing-xs);\n    padding: var(--wui-spacing-xs) var(--wui-spacing-0);\n    background-color: var(--wui-color-gray-glass-002);\n    border-radius: clamp(0px, var(--wui-border-radius-xs), 20px);\n    will-change: background-color, color;\n    outline: none;\n    border: none;\n  }\n\n  button > wui-text {\n    color: var(--wui-color-fg-100);\n    max-width: var(--wui-icon-box-size-xl);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    justify-content: center;\n  }\n\n  button:hover:enabled {\n    background-color: var(--wui-color-gray-glass-005);\n  }\n\n  button:disabled > wui-text {\n    color: var(--wui-color-gray-glass-015);\n  }\n\n  [data-selected='true'] {\n    background-color: var(--wui-color-accent-glass-020);\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    [data-selected='true']:hover:enabled {\n      background-color: var(--wui-color-accent-glass-015);\n    }\n  }\n\n  [data-selected='true']:active:enabled {\n    background-color: var(--wui-color-accent-glass-010);\n  }\n"
    ]);
    $062c2bcc016211ab$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $062c2bcc016211ab$export$2e2bcd8739ae039 = (0, $2D5eP.css)($062c2bcc016211ab$var$_templateObject());


function $613f5040d59d72da$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      <button ontouchstart>\n        ",
        '\n        <wui-text variant="tiny-500" color="inherit">',
        "</wui-text>\n      </button>\n    "
    ]);
    $613f5040d59d72da$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $613f5040d59d72da$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '\n      <wui-wallet-image\n        size="md"\n        imageSrc=',
        "\n        name=",
        "\n        .installed=",
        '\n        badgeSize="sm"\n      >\n      </wui-wallet-image>\n    '
    ]);
    $613f5040d59d72da$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $613f5040d59d72da$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '<wui-shimmer width="56px" height="56px" borderRadius="xs"></wui-shimmer>'
    ]);
    $613f5040d59d72da$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $613f5040d59d72da$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $613f5040d59d72da$export$77cea17ccfc04f35 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mAllWalletsListItem, LitElement);
    var _super = (0, $ohfOJ._)(W3mAllWalletsListItem);
    function W3mAllWalletsListItem() {
        (0, $4GJKx._)(this, W3mAllWalletsListItem);
        var _this;
        _this = _super.call(this);
        _this.observer = new IntersectionObserver(function() {
            return undefined;
        });
        _this.visible = false;
        _this.imageSrc = undefined;
        _this.imageLoading = false;
        _this.wallet = undefined;
        _this.observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    _this.visible = true;
                    _this.fetchImageSrc();
                } else _this.visible = false;
            });
        }, {
            threshold: 0.01
        });
        return _this;
    }
    (0, $1wc17._)(W3mAllWalletsListItem, [
        {
            key: "firstUpdated",
            value: function firstUpdated() {
                this.observer.observe(this);
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.observer.disconnect();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_wallet;
                return (0, $hxyOZ.html)($613f5040d59d72da$var$_templateObject(), this.imageTemplate(), (_this_wallet = this.wallet) === null || _this_wallet === void 0 ? void 0 : _this_wallet.name);
            }
        },
        {
            key: "imageTemplate",
            value: function imageTemplate() {
                var _this_wallet, _this_wallet1;
                if (!this.visible && !this.imageSrc || this.imageLoading) return this.shimmerTemplate();
                return (0, $hxyOZ.html)($613f5040d59d72da$var$_templateObject1(), (0, $696d14fc702af3d6$export$f68dd208b5df064d)(this.imageSrc), (_this_wallet = this.wallet) === null || _this_wallet === void 0 ? void 0 : _this_wallet.name, (_this_wallet1 = this.wallet) === null || _this_wallet1 === void 0 ? void 0 : _this_wallet1.installed);
            }
        },
        {
            key: "shimmerTemplate",
            value: function shimmerTemplate() {
                return (0, $hxyOZ.html)($613f5040d59d72da$var$_templateObject2());
            }
        },
        {
            key: "fetchImageSrc",
            value: function fetchImageSrc() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.wallet) return [
                                    2
                                ];
                                _this.imageSrc = (0, $khm6W.AssetUtil).getWalletImage(_this.wallet);
                                if (_this.imageSrc) return [
                                    2
                                ];
                                _this.imageLoading = true;
                                return [
                                    4,
                                    (0, $khm6W.AssetUtil).fetchWalletImage(_this.wallet.image_id)
                                ];
                            case 1:
                                _this.imageSrc = _state.sent();
                                _this.imageLoading = false;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return W3mAllWalletsListItem;
}((0, $2yD3e.LitElement));
$613f5040d59d72da$export$77cea17ccfc04f35.styles = (0, $062c2bcc016211ab$export$2e2bcd8739ae039);
$613f5040d59d72da$var$__decorate([
    (0, $334Pv.state)()
], $613f5040d59d72da$export$77cea17ccfc04f35.prototype, "visible", void 0);
$613f5040d59d72da$var$__decorate([
    (0, $334Pv.state)()
], $613f5040d59d72da$export$77cea17ccfc04f35.prototype, "imageSrc", void 0);
$613f5040d59d72da$var$__decorate([
    (0, $334Pv.state)()
], $613f5040d59d72da$export$77cea17ccfc04f35.prototype, "imageLoading", void 0);
$613f5040d59d72da$var$__decorate([
    (0, $04kNM.property)()
], $613f5040d59d72da$export$77cea17ccfc04f35.prototype, "wallet", void 0);
$613f5040d59d72da$export$77cea17ccfc04f35 = $613f5040d59d72da$var$__decorate([
    (0, $hdxb6.customElement)("w3m-all-wallets-list-item")
], $613f5040d59d72da$export$77cea17ccfc04f35);



var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("cwWZ7");
var $hMdcG = parcelRequire("hMdcG");
var $2qlRb = parcelRequire("2qlRb");
var $iptjJ = parcelRequire("iptjJ");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");
var $04kNM = parcelRequire("04kNM");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $c11f84c62aaa75f7$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  wui-grid,\n  wui-loading-spinner,\n  wui-flex {\n    height: 360px;\n  }\n\n  wui-grid {\n    overflow: scroll;\n    scrollbar-width: none;\n    grid-auto-rows: min-content;\n  }\n\n  wui-grid[data-scroll='false'] {\n    overflow: hidden;\n  }\n\n  wui-grid::-webkit-scrollbar {\n    display: none;\n  }\n\n  wui-loading-spinner {\n    justify-content: center;\n    align-items: center;\n  }\n"
    ]);
    $c11f84c62aaa75f7$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $c11f84c62aaa75f7$export$2e2bcd8739ae039 = (0, $2D5eP.css)($c11f84c62aaa75f7$var$_templateObject());



function $3f01d1da8ec08122$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<wui-loading-spinner color="accent-100"></wui-loading-spinner>'
    ]);
    $3f01d1da8ec08122$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $3f01d1da8ec08122$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '\n        <wui-flex justifyContent="center" alignItems="center" gap="s" flexDirection="column">\n          <wui-icon-box\n            size="lg"\n            iconColor="fg-200"\n            backgroundColor="fg-300"\n            icon="wallet"\n            background="transparent"\n          ></wui-icon-box>\n          <wui-text color="fg-200" variant="paragraph-500">No Wallet found</wui-text>\n        </wui-flex>\n      '
    ]);
    $3f01d1da8ec08122$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $3f01d1da8ec08122$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "\n            <w3m-all-wallets-list-item\n              @click=",
        "\n              .wallet=",
        "\n            ></w3m-all-wallets-list-item>\n          "
    ]);
    $3f01d1da8ec08122$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $3f01d1da8ec08122$var$_templateObject3() {
    var data = (0, $j06k0._)([
        "\n      <wui-grid\n        .padding=",
        '\n        gridTemplateColumns="repeat(4, 1fr)"\n        rowGap="l"\n        columnGap="xs"\n      >\n        ',
        "\n      </wui-grid>\n    "
    ]);
    $3f01d1da8ec08122$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var $3f01d1da8ec08122$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $3f01d1da8ec08122$export$65a744e48142d5af = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mAllWalletsSearch, LitElement);
    var _super = (0, $ohfOJ._)(W3mAllWalletsSearch);
    function W3mAllWalletsSearch() {
        (0, $4GJKx._)(this, W3mAllWalletsSearch);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.prevQuery = "";
        _this.loading = true;
        _this.query = "";
        return _this;
    }
    (0, $1wc17._)(W3mAllWalletsSearch, [
        {
            key: "render",
            value: function render() {
                this.onSearch();
                return this.loading ? (0, $hxyOZ.html)($3f01d1da8ec08122$var$_templateObject()) : this.walletsTemplate();
            }
        },
        {
            key: "onSearch",
            value: function onSearch() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(_this.query.trim() !== _this.prevQuery.trim())) return [
                                    3,
                                    2
                                ];
                                _this.prevQuery = _this.query;
                                _this.loading = true;
                                return [
                                    4,
                                    (0, $hMdcG.ApiController).searchWallet({
                                        search: _this.query
                                    })
                                ];
                            case 1:
                                _state.sent();
                                _this.loading = false;
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "walletsTemplate",
            value: function walletsTemplate() {
                var _this = this;
                var search = (0, $hMdcG.ApiController).state.search;
                var wallets = (0, $c597bb466e6ae7c9$export$cffc81df24a1f1f1)(search);
                if (!search.length) return (0, $hxyOZ.html)($3f01d1da8ec08122$var$_templateObject1());
                return (0, $hxyOZ.html)($3f01d1da8ec08122$var$_templateObject3(), [
                    "0",
                    "s",
                    "s",
                    "s"
                ], wallets.map(function(wallet) {
                    return (0, $hxyOZ.html)($3f01d1da8ec08122$var$_templateObject2(), function() {
                        return _this.onConnectWallet(wallet);
                    }, wallet);
                }));
            }
        },
        {
            key: "onConnectWallet",
            value: function onConnectWallet(wallet) {
                var connector = (0, $2qlRb.ConnectorController).getConnector(wallet.id, wallet.rdns);
                if (connector) (0, $iptjJ.RouterController).push("ConnectingExternal", {
                    connector: connector
                });
                else (0, $iptjJ.RouterController).push("ConnectingWalletConnect", {
                    wallet: wallet
                });
            }
        }
    ]);
    return W3mAllWalletsSearch;
}((0, $2yD3e.LitElement));
$3f01d1da8ec08122$export$65a744e48142d5af.styles = (0, $c11f84c62aaa75f7$export$2e2bcd8739ae039);
$3f01d1da8ec08122$var$__decorate([
    (0, $334Pv.state)()
], $3f01d1da8ec08122$export$65a744e48142d5af.prototype, "loading", void 0);
$3f01d1da8ec08122$var$__decorate([
    (0, $04kNM.property)()
], $3f01d1da8ec08122$export$65a744e48142d5af.prototype, "query", void 0);
$3f01d1da8ec08122$export$65a744e48142d5af = $3f01d1da8ec08122$var$__decorate([
    (0, $hdxb6.customElement)("w3m-all-wallets-search")
], $3f01d1da8ec08122$export$65a744e48142d5af);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $3cYIS = parcelRequire("3cYIS");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $04kNM = parcelRequire("04kNM");
var $334Pv = parcelRequire("334Pv");
function $ac088e52203cdc47$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex justifyContent="center" .padding=',
        ">\n        <wui-tabs\n          ?disabled=",
        "\n          .tabs=",
        "\n          .onTabChange=",
        "\n        ></wui-tabs>\n      </wui-flex>\n    "
    ]);
    $ac088e52203cdc47$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $ac088e52203cdc47$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $ac088e52203cdc47$export$994bb77f05fbbbde = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mConnectingHeader, LitElement);
    var _super = (0, $ohfOJ._)(W3mConnectingHeader);
    function W3mConnectingHeader() {
        (0, $4GJKx._)(this, W3mConnectingHeader);
        var _this;
        _this = _super.call(this);
        _this.platformTabs = [];
        _this.unsubscribe = [];
        _this.platforms = [];
        _this.onSelectPlatfrom = undefined;
        _this.buffering = false;
        _this.unsubscribe.push((0, $3cYIS.ConnectionController).subscribeKey("buffering", function(val) {
            return _this.buffering = val;
        }));
        return _this;
    }
    (0, $1wc17._)(W3mConnectingHeader, [
        {
            key: "disconnectCallback",
            value: function disconnectCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var tabs = this.generateTabs();
                return (0, $hxyOZ.html)($ac088e52203cdc47$var$_templateObject(), [
                    "0",
                    "0",
                    "l",
                    "0"
                ], this.buffering, tabs, this.onTabChange.bind(this));
            }
        },
        {
            key: "generateTabs",
            value: function generateTabs() {
                var tabs = this.platforms.map(function(platform) {
                    if (platform === "browser") return {
                        label: "Browser",
                        icon: "extension",
                        platform: "browser"
                    };
                    else if (platform === "mobile") return {
                        label: "Mobile",
                        icon: "mobile",
                        platform: "mobile"
                    };
                    else if (platform === "qrcode") return {
                        label: "Mobile",
                        icon: "mobile",
                        platform: "qrcode"
                    };
                    else if (platform === "web") return {
                        label: "Webapp",
                        icon: "browser",
                        platform: "web"
                    };
                    else if (platform === "desktop") return {
                        label: "Desktop",
                        icon: "desktop",
                        platform: "desktop"
                    };
                    return {
                        label: "Browser",
                        icon: "extension",
                        platform: "unsupported"
                    };
                });
                this.platformTabs = tabs.map(function(param) {
                    var platform = param.platform;
                    return platform;
                });
                return tabs;
            }
        },
        {
            key: "onTabChange",
            value: function onTabChange(index) {
                var _this_onSelectPlatfrom, _this;
                var tab = this.platformTabs[index];
                if (tab) (_this_onSelectPlatfrom = (_this = this).onSelectPlatfrom) === null || _this_onSelectPlatfrom === void 0 ? void 0 : _this_onSelectPlatfrom.call(_this, tab);
            }
        }
    ]);
    return W3mConnectingHeader;
}((0, $2yD3e.LitElement));
$ac088e52203cdc47$var$__decorate([
    (0, $04kNM.property)({
        type: Array
    })
], $ac088e52203cdc47$export$994bb77f05fbbbde.prototype, "platforms", void 0);
$ac088e52203cdc47$var$__decorate([
    (0, $04kNM.property)()
], $ac088e52203cdc47$export$994bb77f05fbbbde.prototype, "onSelectPlatfrom", void 0);
$ac088e52203cdc47$var$__decorate([
    (0, $334Pv.state)()
], $ac088e52203cdc47$export$994bb77f05fbbbde.prototype, "buffering", void 0);
$ac088e52203cdc47$export$994bb77f05fbbbde = $ac088e52203cdc47$var$__decorate([
    (0, $hdxb6.customElement)("w3m-connecting-header")
], $ac088e52203cdc47$export$994bb77f05fbbbde);



var $d3H5E = parcelRequire("d3H5E");

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("cwWZ7");
var $1QDT9 = parcelRequire("1QDT9");
var $2qlRb = parcelRequire("2qlRb");
var $3cYIS = parcelRequire("3cYIS");
var $5Lhe6 = parcelRequire("5Lhe6");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");

var $38eed7aa7ea5a1f1$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $38eed7aa7ea5a1f1$export$f6b6073753ecd240 = /*#__PURE__*/ function(W3mConnectingWidget) {
    "use strict";
    (0, $dcsZi._)(W3mConnectingWcBrowser, W3mConnectingWidget);
    var _super = (0, $ohfOJ._)(W3mConnectingWcBrowser);
    function W3mConnectingWcBrowser() {
        (0, $4GJKx._)(this, W3mConnectingWcBrowser);
        var _this;
        _this = _super.call(this);
        if (!_this.wallet) throw new Error("w3m-connecting-wc-browser: No wallet provided");
        _this.onConnect = _this.onConnectProxy.bind((0, $d3H5E._)(_this));
        _this.onAutoConnect = _this.onConnectProxy.bind((0, $d3H5E._)(_this));
        (0, $1QDT9.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: _this.wallet.name,
                platform: "browser"
            }
        });
        return _this;
    }
    (0, $1wc17._)(W3mConnectingWcBrowser, [
        {
            key: "onConnectProxy",
            value: function onConnectProxy() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _this_wallet, connectors, announcedConnector, injectedConnector, error, _error_message;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    5,
                                    ,
                                    6
                                ]);
                                _this.error = false;
                                connectors = (0, $2qlRb.ConnectorController).state.connectors;
                                announcedConnector = connectors.find(function(c) {
                                    var _c_info, _this_wallet;
                                    return c.type === "ANNOUNCED" && ((_c_info = c.info) === null || _c_info === void 0 ? void 0 : _c_info.rdns) === ((_this_wallet = _this.wallet) === null || _this_wallet === void 0 ? void 0 : _this_wallet.rdns);
                                });
                                injectedConnector = connectors.find(function(c) {
                                    return c.type === "INJECTED";
                                });
                                if (!announcedConnector) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (0, $3cYIS.ConnectionController).connectExternal(announcedConnector, announcedConnector.chain)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                if (!injectedConnector) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    (0, $3cYIS.ConnectionController).connectExternal(injectedConnector, injectedConnector.chain)
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                (0, $5Lhe6.ModalController).close();
                                (0, $1QDT9.EventsController).sendEvent({
                                    type: "track",
                                    event: "CONNECT_SUCCESS",
                                    properties: {
                                        method: "browser",
                                        name: ((_this_wallet = _this.wallet) === null || _this_wallet === void 0 ? void 0 : _this_wallet.name) || "Unknown"
                                    }
                                });
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                error = _state.sent();
                                (0, $1QDT9.EventsController).sendEvent({
                                    type: "track",
                                    event: "CONNECT_ERROR",
                                    properties: {
                                        message: (_error_message = error === null || error === void 0 ? void 0 : error.message) !== null && _error_message !== void 0 ? _error_message : "Unknown"
                                    }
                                });
                                _this.error = true;
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return W3mConnectingWcBrowser;
}((0, $eab46a9771ccbf53$export$902e3cfa9f67689d));
$38eed7aa7ea5a1f1$export$f6b6073753ecd240 = $38eed7aa7ea5a1f1$var$__decorate([
    (0, $hdxb6.customElement)("w3m-connecting-wc-browser")
], $38eed7aa7ea5a1f1$export$f6b6073753ecd240);



var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $1QDT9 = parcelRequire("1QDT9");
var $hZBJb = parcelRequire("hZBJb");
var $3cYIS = parcelRequire("3cYIS");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");

var $b56f0e110fe75648$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $b56f0e110fe75648$export$99d24518d9937f53 = /*#__PURE__*/ function(W3mConnectingWidget) {
    "use strict";
    (0, $dcsZi._)(W3mConnectingWcDesktop, W3mConnectingWidget);
    var _super = (0, $ohfOJ._)(W3mConnectingWcDesktop);
    function W3mConnectingWcDesktop() {
        (0, $4GJKx._)(this, W3mConnectingWcDesktop);
        var _this;
        _this = _super.call(this);
        if (!_this.wallet) throw new Error("w3m-connecting-wc-desktop: No wallet provided");
        _this.onConnect = _this.onConnectProxy.bind((0, $d3H5E._)(_this));
        _this.onRender = _this.onRenderProxy.bind((0, $d3H5E._)(_this));
        (0, $1QDT9.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: _this.wallet.name,
                platform: "desktop"
            }
        });
        return _this;
    }
    (0, $1wc17._)(W3mConnectingWcDesktop, [
        {
            key: "onRenderProxy",
            value: function onRenderProxy() {
                if (!this.ready && this.uri) {
                    var _this_onConnect, _this;
                    this.ready = true;
                    (_this_onConnect = (_this = this).onConnect) === null || _this_onConnect === void 0 ? void 0 : _this_onConnect.call(_this);
                }
            }
        },
        {
            key: "onConnectProxy",
            value: function onConnectProxy() {
                var _this_wallet;
                if (((_this_wallet = this.wallet) === null || _this_wallet === void 0 ? void 0 : _this_wallet.desktop_link) && this.uri) try {
                    this.error = false;
                    var _this_wallet1 = this.wallet, desktop_link = _this_wallet1.desktop_link, name = _this_wallet1.name;
                    var _CoreHelperUtil_formatNativeUrl = (0, $hZBJb.CoreHelperUtil).formatNativeUrl(desktop_link, this.uri), redirect = _CoreHelperUtil_formatNativeUrl.redirect, href = _CoreHelperUtil_formatNativeUrl.href;
                    (0, $3cYIS.ConnectionController).setWcLinking({
                        name: name,
                        href: href
                    });
                    (0, $3cYIS.ConnectionController).setRecentWallet(this.wallet);
                    (0, $hZBJb.CoreHelperUtil).openHref(redirect, "_blank");
                } catch (e) {
                    this.error = true;
                }
            }
        }
    ]);
    return W3mConnectingWcDesktop;
}((0, $eab46a9771ccbf53$export$902e3cfa9f67689d));
$b56f0e110fe75648$export$99d24518d9937f53 = $b56f0e110fe75648$var$__decorate([
    (0, $hdxb6.customElement)("w3m-connecting-wc-desktop")
], $b56f0e110fe75648$export$99d24518d9937f53);



var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $04RAu = parcelRequire("04RAu");

var $b8Rim = parcelRequire("b8Rim");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $1QDT9 = parcelRequire("1QDT9");
var $hZBJb = parcelRequire("hZBJb");
var $3cYIS = parcelRequire("3cYIS");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");

var $4b051a0fa2cf2b1a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $4b051a0fa2cf2b1a$export$bde153011a6b26 = /*#__PURE__*/ function(W3mConnectingWidget) {
    "use strict";
    (0, $dcsZi._)(W3mConnectingWcMobile, W3mConnectingWidget);
    var _super = (0, $ohfOJ._)(W3mConnectingWcMobile);
    function W3mConnectingWcMobile() {
        (0, $4GJKx._)(this, W3mConnectingWcMobile);
        var _this;
        _this = _super.call(this);
        if (!_this.wallet) throw new Error("w3m-connecting-wc-mobile: No wallet provided");
        _this.onConnect = _this.onConnectProxy.bind((0, $d3H5E._)(_this));
        _this.onRender = _this.onRenderProxy.bind((0, $d3H5E._)(_this));
        document.addEventListener("visibilitychange", _this.onBuffering.bind((0, $d3H5E._)(_this)));
        (0, $1QDT9.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: _this.wallet.name,
                platform: "mobile"
            }
        });
        return _this;
    }
    (0, $1wc17._)(W3mConnectingWcMobile, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                (0, $04RAu._)((0, $b8Rim._)(W3mConnectingWcMobile.prototype), "disconnectedCallback", this).call(this);
                document.removeEventListener("visibilitychange", this.onBuffering.bind(this));
            }
        },
        {
            key: "onRenderProxy",
            value: function onRenderProxy() {
                if (!this.ready && this.uri) {
                    var _this_onConnect, _this;
                    this.ready = true;
                    (_this_onConnect = (_this = this).onConnect) === null || _this_onConnect === void 0 ? void 0 : _this_onConnect.call(_this);
                }
            }
        },
        {
            key: "onConnectProxy",
            value: function onConnectProxy() {
                var _this_wallet;
                if (((_this_wallet = this.wallet) === null || _this_wallet === void 0 ? void 0 : _this_wallet.mobile_link) && this.uri) try {
                    this.error = false;
                    var _this_wallet1 = this.wallet, mobile_link = _this_wallet1.mobile_link, name = _this_wallet1.name;
                    var _CoreHelperUtil_formatNativeUrl = (0, $hZBJb.CoreHelperUtil).formatNativeUrl(mobile_link, this.uri), redirect = _CoreHelperUtil_formatNativeUrl.redirect, href = _CoreHelperUtil_formatNativeUrl.href;
                    (0, $3cYIS.ConnectionController).setWcLinking({
                        name: name,
                        href: href
                    });
                    (0, $3cYIS.ConnectionController).setRecentWallet(this.wallet);
                    (0, $hZBJb.CoreHelperUtil).openHref(redirect, "_self");
                } catch (e) {
                    this.error = true;
                }
            }
        },
        {
            key: "onBuffering",
            value: function onBuffering() {
                var _document;
                var isIos = (0, $hZBJb.CoreHelperUtil).isIos();
                if (((_document = document) === null || _document === void 0 ? void 0 : _document.visibilityState) === "visible" && !this.error && isIos) {
                    (0, $3cYIS.ConnectionController).setBuffering(true);
                    setTimeout(function() {
                        (0, $3cYIS.ConnectionController).setBuffering(false);
                    }, 5000);
                }
            }
        }
    ]);
    return W3mConnectingWcMobile;
}((0, $eab46a9771ccbf53$export$902e3cfa9f67689d));
$4b051a0fa2cf2b1a$export$bde153011a6b26 = $4b051a0fa2cf2b1a$var$__decorate([
    (0, $hdxb6.customElement)("w3m-connecting-wc-mobile")
], $4b051a0fa2cf2b1a$export$bde153011a6b26);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $04RAu = parcelRequire("04RAu");

var $b8Rim = parcelRequire("b8Rim");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $1QDT9 = parcelRequire("1QDT9");
var $3cYIS = parcelRequire("3cYIS");
var $dJ6Ea = parcelRequire("dJ6Ea");
var $khm6W = parcelRequire("khm6W");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");



var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $6140d41635ccd1c0$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  @keyframes fadein {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  wui-shimmer {\n    width: 100%;\n    aspect-ratio: 1 / 1;\n    border-radius: clamp(0px, var(--wui-border-radius-l), 40px) !important;\n  }\n\n  wui-qr-code {\n    opacity: 0;\n    animation-duration: 200ms;\n    animation-timing-function: ease;\n    animation-name: fadein;\n    animation-fill-mode: forwards;\n  }\n"
    ]);
    $6140d41635ccd1c0$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $6140d41635ccd1c0$export$2e2bcd8739ae039 = (0, $2D5eP.css)($6140d41635ccd1c0$var$_templateObject());


function $be75d392949ee96c$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex\n        flexDirection="column"\n        alignItems="center"\n        .padding=',
        '\n        gap="xl"\n      >\n        <wui-shimmer borderRadius="l" width="100%"> ',
        ' </wui-shimmer>\n\n        <wui-text variant="paragraph-500" color="fg-100">\n          Scan this QR Code with your phone\n        </wui-text>\n        ',
        "\n      </wui-flex>\n\n      <w3m-mobile-download-links .wallet=",
        "></w3m-mobile-download-links>\n    "
    ]);
    $be75d392949ee96c$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $be75d392949ee96c$var$_templateObject1() {
    var data = (0, $j06k0._)([
        " <wui-qr-code\n      size=",
        "\n      theme=",
        "\n      uri=",
        "\n      imageSrc=",
        "\n      alt=",
        '\n      data-testid="wui-qr-code"\n    ></wui-qr-code>'
    ]);
    $be75d392949ee96c$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $be75d392949ee96c$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "<wui-link\n      .disabled=",
        "\n      @click=",
        '\n      color="fg-200"\n      data-testid="copy-wc2-uri"\n    >\n      <wui-icon size="xs" color="fg-200" slot="iconLeft" name="copy"></wui-icon>\n      Copy link\n    </wui-link>'
    ]);
    $be75d392949ee96c$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $be75d392949ee96c$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $be75d392949ee96c$export$d4369b1b68d9b78a = /*#__PURE__*/ function(W3mConnectingWidget) {
    "use strict";
    (0, $dcsZi._)(W3mConnectingWcQrcode, W3mConnectingWidget);
    var _super = (0, $ohfOJ._)(W3mConnectingWcQrcode);
    function W3mConnectingWcQrcode() {
        (0, $4GJKx._)(this, W3mConnectingWcQrcode);
        var _this;
        var _this_wallet;
        _this = _super.call(this);
        _this.forceUpdate = function() {
            _this.requestUpdate();
        };
        window.addEventListener("resize", _this.forceUpdate);
        var _this_wallet_name;
        (0, $1QDT9.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: (_this_wallet_name = (_this_wallet = _this.wallet) === null || _this_wallet === void 0 ? void 0 : _this_wallet.name) !== null && _this_wallet_name !== void 0 ? _this_wallet_name : "WalletConnect",
                platform: "qrcode"
            }
        });
        return _this;
    }
    (0, $1wc17._)(W3mConnectingWcQrcode, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                (0, $04RAu._)((0, $b8Rim._)(W3mConnectingWcQrcode.prototype), "disconnectedCallback", this).call(this);
                window.removeEventListener("resize", this.forceUpdate);
            }
        },
        {
            key: "render",
            value: function render() {
                this.onRenderProxy();
                return (0, $hxyOZ.html)($be75d392949ee96c$var$_templateObject(), [
                    "0",
                    "xl",
                    "xl",
                    "xl"
                ], this.qrCodeTemplate(), this.copyTemplate(), this.wallet);
            }
        },
        {
            key: "onRenderProxy",
            value: function onRenderProxy() {
                var _this = this;
                if (!this.ready && this.uri) this.timeout = setTimeout(function() {
                    _this.ready = true;
                }, 0);
            }
        },
        {
            key: "qrCodeTemplate",
            value: function qrCodeTemplate() {
                if (!this.uri || !this.ready) return null;
                var size = this.getBoundingClientRect().width - 40;
                var alt = this.wallet ? this.wallet.name : undefined;
                (0, $3cYIS.ConnectionController).setWcLinking(undefined);
                (0, $3cYIS.ConnectionController).setRecentWallet(this.wallet);
                return (0, $hxyOZ.html)($be75d392949ee96c$var$_templateObject1(), size, (0, $dJ6Ea.ThemeController).state.themeMode, this.uri, (0, $696d14fc702af3d6$export$f68dd208b5df064d)((0, $khm6W.AssetUtil).getWalletImage(this.wallet)), (0, $696d14fc702af3d6$export$f68dd208b5df064d)(alt));
            }
        },
        {
            key: "copyTemplate",
            value: function copyTemplate() {
                var inactive = !this.uri || !this.ready;
                return (0, $hxyOZ.html)($be75d392949ee96c$var$_templateObject2(), inactive, this.onCopyUri);
            }
        }
    ]);
    return W3mConnectingWcQrcode;
}((0, $eab46a9771ccbf53$export$902e3cfa9f67689d));
$be75d392949ee96c$export$d4369b1b68d9b78a.styles = (0, $6140d41635ccd1c0$export$2e2bcd8739ae039);
$be75d392949ee96c$export$d4369b1b68d9b78a = $be75d392949ee96c$var$__decorate([
    (0, $hdxb6.customElement)("w3m-connecting-wc-qrcode")
], $be75d392949ee96c$export$d4369b1b68d9b78a);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $iptjJ = parcelRequire("iptjJ");
var $1QDT9 = parcelRequire("1QDT9");
var $khm6W = parcelRequire("khm6W");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");

function $8a96bc22ed6dc261$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex\n        flexDirection="column"\n        alignItems="center"\n        .padding=',
        '\n        gap="xl"\n      >\n        <wui-wallet-image\n          size="lg"\n          imageSrc=',
        '\n        ></wui-wallet-image>\n\n        <wui-text variant="paragraph-500" color="fg-100">Not Detected</wui-text>\n      </wui-flex>\n\n      <w3m-mobile-download-links .wallet=',
        "></w3m-mobile-download-links>\n    "
    ]);
    $8a96bc22ed6dc261$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $8a96bc22ed6dc261$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $8a96bc22ed6dc261$export$8ced6ff0971fe41b = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mConnectingWcUnsupported, LitElement);
    var _super = (0, $ohfOJ._)(W3mConnectingWcUnsupported);
    function W3mConnectingWcUnsupported() {
        (0, $4GJKx._)(this, W3mConnectingWcUnsupported);
        var _this;
        var _RouterController_state_data;
        _this = _super.call(this);
        _this.wallet = (_RouterController_state_data = (0, $iptjJ.RouterController).state.data) === null || _RouterController_state_data === void 0 ? void 0 : _RouterController_state_data.wallet;
        if (!_this.wallet) throw new Error("w3m-connecting-wc-unsupported: No wallet provided");
        (0, $1QDT9.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: _this.wallet.name,
                platform: "browser"
            }
        });
        return _this;
    }
    (0, $1wc17._)(W3mConnectingWcUnsupported, [
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($8a96bc22ed6dc261$var$_templateObject(), [
                    "3xl",
                    "xl",
                    "xl",
                    "xl"
                ], (0, $696d14fc702af3d6$export$f68dd208b5df064d)((0, $khm6W.AssetUtil).getWalletImage(this.wallet)), this.wallet);
            }
        }
    ]);
    return W3mConnectingWcUnsupported;
}((0, $2yD3e.LitElement));
$8a96bc22ed6dc261$export$8ced6ff0971fe41b = $8a96bc22ed6dc261$var$__decorate([
    (0, $hdxb6.customElement)("w3m-connecting-wc-unsupported")
], $8a96bc22ed6dc261$export$8ced6ff0971fe41b);



var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $1QDT9 = parcelRequire("1QDT9");
var $hZBJb = parcelRequire("hZBJb");
var $3cYIS = parcelRequire("3cYIS");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");

var $32572265b3469676$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $32572265b3469676$export$bdfe677b483cfd66 = /*#__PURE__*/ function(W3mConnectingWidget) {
    "use strict";
    (0, $dcsZi._)(W3mConnectingWcWeb, W3mConnectingWidget);
    var _super = (0, $ohfOJ._)(W3mConnectingWcWeb);
    function W3mConnectingWcWeb() {
        (0, $4GJKx._)(this, W3mConnectingWcWeb);
        var _this;
        _this = _super.call(this);
        if (!_this.wallet) throw new Error("w3m-connecting-wc-web: No wallet provided");
        _this.onConnect = _this.onConnectProxy.bind((0, $d3H5E._)(_this));
        _this.secondaryBtnLabel = "Open";
        _this.secondaryLabel = "Open and continue in a new browser tab";
        _this.secondaryBtnIcon = "externalLink";
        (0, $1QDT9.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: _this.wallet.name,
                platform: "web"
            }
        });
        return _this;
    }
    (0, $1wc17._)(W3mConnectingWcWeb, [
        {
            key: "onConnectProxy",
            value: function onConnectProxy() {
                var _this_wallet;
                if (((_this_wallet = this.wallet) === null || _this_wallet === void 0 ? void 0 : _this_wallet.webapp_link) && this.uri) try {
                    this.error = false;
                    var _this_wallet1 = this.wallet, webapp_link = _this_wallet1.webapp_link, name = _this_wallet1.name;
                    var _CoreHelperUtil_formatUniversalUrl = (0, $hZBJb.CoreHelperUtil).formatUniversalUrl(webapp_link, this.uri), redirect = _CoreHelperUtil_formatUniversalUrl.redirect, href = _CoreHelperUtil_formatUniversalUrl.href;
                    (0, $3cYIS.ConnectionController).setWcLinking({
                        name: name,
                        href: href
                    });
                    (0, $3cYIS.ConnectionController).setRecentWallet(this.wallet);
                    (0, $hZBJb.CoreHelperUtil).openHref(redirect, "_blank");
                } catch (e) {
                    this.error = true;
                }
            }
        }
    ]);
    return W3mConnectingWcWeb;
}((0, $eab46a9771ccbf53$export$902e3cfa9f67689d));
$32572265b3469676$export$bdfe677b483cfd66 = $32572265b3469676$var$__decorate([
    (0, $hdxb6.customElement)("w3m-connecting-wc-web")
], $32572265b3469676$export$bdfe677b483cfd66);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");
var $04kNM = parcelRequire("04kNM");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $9062f8bc9302b804$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    width: 100%;\n  }\n\n  .details-container > wui-flex {\n    background: var(--wui-color-gray-glass-002);\n    border-radius: var(--wui-border-radius-xxs);\n    width: 100%;\n  }\n\n  .details-container > wui-flex > button {\n    border: none;\n    background: none;\n    padding: var(--wui-spacing-s);\n    border-radius: var(--wui-border-radius-xxs);\n    cursor: pointer;\n  }\n\n  .details-content-container {\n    padding: var(--wui-spacing-1xs);\n    padding-top: 0px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .details-content-container > wui-flex {\n    width: 100%;\n  }\n\n  .details-row {\n    width: 100%;\n    padding: var(--wui-spacing-s);\n    padding-left: var(--wui-spacing-s);\n    padding-right: var(--wui-spacing-1xs);\n    border-radius: calc(var(--wui-border-radius-5xs) + var(--wui-border-radius-4xs));\n    background: var(--wui-color-gray-glass-002);\n  }\n\n  .details-row-title {\n    white-space: nowrap;\n  }\n\n  .details-row.provider-free-row {\n    padding-right: var(--wui-spacing-xs);\n  }\n"
    ]);
    $9062f8bc9302b804$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $9062f8bc9302b804$export$2e2bcd8739ae039 = (0, $2D5eP.css)($9062f8bc9302b804$var$_templateObject());


parcelRequire("grHtr");
var $dI7zX = parcelRequire("dI7zX");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("dSKxG");
var $eMPGH = parcelRequire("eMPGH");
parcelRequire("cwWZ7");
var $2sXdV = parcelRequire("2sXdV");
var $fPqxb = parcelRequire("fPqxb");
var $8DzeN = parcelRequire("8DzeN");
function $8db372aedf80193a$var$_templateObject() {
    var data = (0, $j06k0._)([
        ' <wui-flex flexDirection="column" gap="xs">\n                        <wui-flex\n                          justifyContent="space-between"\n                          alignItems="center"\n                          class="details-row"\n                        >\n                          <wui-flex alignItems="center" gap="xs">\n                            <wui-text class="details-row-title" variant="small-400" color="fg-150">\n                              Price impact\n                            </wui-text>\n                            <w3m-tooltip-trigger\n                              text="Price impact reflects the change in market price due to your trade"\n                            >\n                              <wui-icon size="xs" color="fg-250" name="infoCircle"></wui-icon>\n                            </w3m-tooltip-trigger>\n                          </wui-flex>\n                          <wui-flex>\n                            <wui-text variant="small-400" color="fg-200">\n                              ',
        "%\n                            </wui-text>\n                          </wui-flex>\n                        </wui-flex>\n                      </wui-flex>"
    ]);
    $8db372aedf80193a$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $8db372aedf80193a$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '<wui-flex flexDirection="column" gap="xs">\n                        <wui-flex\n                          justifyContent="space-between"\n                          alignItems="center"\n                          class="details-row"\n                        >\n                          <wui-flex alignItems="center" gap="xs">\n                            <wui-text class="details-row-title" variant="small-400" color="fg-150">\n                              Max. slippage\n                            </wui-text>\n                            <w3m-tooltip-trigger\n                              text=',
        '\n                            >\n                              <wui-icon size="xs" color="fg-250" name="infoCircle"></wui-icon>\n                            </w3m-tooltip-trigger>\n                          </wui-flex>\n                          <wui-flex>\n                            <wui-text variant="small-400" color="fg-200">\n                              ',
        "\n                              ",
        " ",
        "%\n                            </wui-text>\n                          </wui-flex>\n                        </wui-flex>\n                      </wui-flex>"
    ]);
    $8db372aedf80193a$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $8db372aedf80193a$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '\n                <wui-flex flexDirection="column" gap="xs" class="details-content-container">\n                  <wui-flex flexDirection="column" gap="xs">\n                    <wui-flex\n                      justifyContent="space-between"\n                      alignItems="center"\n                      class="details-row"\n                    >\n                      <wui-flex alignItems="center" gap="xs">\n                        <wui-text class="details-row-title" variant="small-400" color="fg-150">\n                          Network cost\n                        </wui-text>\n                        <w3m-tooltip-trigger\n                          text=',
        '\n                        >\n                          <wui-icon size="xs" color="fg-250" name="infoCircle"></wui-icon>\n                        </w3m-tooltip-trigger>\n                      </wui-flex>\n                      <wui-text variant="small-400" color="fg-100">\n                        $',
        "\n                      </wui-text>\n                    </wui-flex>\n                  </wui-flex>\n                  ",
        "\n                  ",
        '\n                  <wui-flex flexDirection="column" gap="xs">\n                    <wui-flex\n                      justifyContent="space-between"\n                      alignItems="center"\n                      class="details-row provider-free-row"\n                    >\n                      <wui-flex alignItems="center" gap="xs">\n                        <wui-text class="details-row-title" variant="small-400" color="fg-150">\n                          Provider fee\n                        </wui-text>\n                      </wui-flex>\n                      <wui-flex>\n                        <wui-text variant="small-400" color="fg-200">0.85%</wui-text>\n                      </wui-flex>\n                    </wui-flex>\n                  </wui-flex>\n                </wui-flex>\n              '
    ]);
    $8db372aedf80193a$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $8db372aedf80193a$var$_templateObject3() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column" alignItems="center" gap="1xs" class="details-container">\n        <wui-flex flexDirection="column">\n          <button @click=',
        '>\n            <wui-flex justifyContent="space-between" .padding=',
        '>\n              <wui-flex justifyContent="flex-start" flexGrow="1" gap="xs">\n                <wui-text variant="small-400" color="fg-100">\n                  1 ',
        " =\n                  ",
        "\n                  ",
        '\n                </wui-text>\n                <wui-text variant="small-400" color="fg-200">\n                  $',
        '\n                </wui-text>\n              </wui-flex>\n              <wui-icon name="chevronBottom"></wui-icon>\n            </wui-flex>\n          </button>\n          ',
        "\n        </wui-flex>\n      </wui-flex>\n    "
    ]);
    $8db372aedf80193a$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var $8db372aedf80193a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $8db372aedf80193a$var$slippageRate = (0, $2sXdV.ConstantsUtil).CONVERT_SLIPPAGE_TOLERANCE;
var $8db372aedf80193a$export$a5d884fb6b8316b8 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiSwapDetails, LitElement);
    var _super = (0, $ohfOJ._)(WuiSwapDetails);
    function WuiSwapDetails() {
        var _this_unsubscribe;
        (0, $4GJKx._)(this, WuiSwapDetails);
        var _this;
        var _NetworkController_state_caipNetwork;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.networkName = (_NetworkController_state_caipNetwork = (0, $fPqxb.NetworkController).state.caipNetwork) === null || _NetworkController_state_caipNetwork === void 0 ? void 0 : _NetworkController_state_caipNetwork.name;
        _this.detailsOpen = false;
        _this.sourceToken = (0, $8DzeN.SwapController).state.sourceToken;
        _this.toToken = (0, $8DzeN.SwapController).state.toToken;
        _this.toTokenAmount = (0, $8DzeN.SwapController).state.toTokenAmount;
        _this.sourceTokenPriceInUSD = (0, $8DzeN.SwapController).state.sourceTokenPriceInUSD;
        _this.toTokenPriceInUSD = (0, $8DzeN.SwapController).state.toTokenPriceInUSD;
        _this.gasPriceInUSD = (0, $8DzeN.SwapController).state.gasPriceInUSD;
        _this.priceImpact = (0, $8DzeN.SwapController).state.priceImpact;
        _this.maxSlippage = (0, $8DzeN.SwapController).state.maxSlippage;
        _this.networkTokenSymbol = (0, $8DzeN.SwapController).state.networkTokenSymbol;
        _this.inputError = (0, $8DzeN.SwapController).state.inputError;
        (_this_unsubscribe = _this.unsubscribe).push.apply(_this_unsubscribe, [
            (0, $8DzeN.SwapController).subscribe(function(newState) {
                _this.sourceToken = newState.sourceToken;
                _this.toToken = newState.toToken;
                _this.toTokenAmount = newState.toTokenAmount;
                _this.gasPriceInUSD = newState.gasPriceInUSD;
                _this.priceImpact = newState.priceImpact;
                _this.maxSlippage = newState.maxSlippage;
                _this.sourceTokenPriceInUSD = newState.sourceTokenPriceInUSD;
                _this.toTokenPriceInUSD = newState.toTokenPriceInUSD;
                _this.inputError = newState.inputError;
            })
        ]);
        return _this;
    }
    (0, $1wc17._)(WuiSwapDetails, [
        {
            key: "render",
            value: function render() {
                var minReceivedAmount = this.toTokenAmount && this.maxSlippage ? (0, $eMPGH.NumberUtil).bigNumber(this.toTokenAmount).minus(this.maxSlippage).toString() : null;
                if (!this.sourceToken || !this.toToken || this.inputError) return null;
                var toTokenSwappedAmount = this.sourceTokenPriceInUSD && this.toTokenPriceInUSD ? 1 / this.toTokenPriceInUSD * this.sourceTokenPriceInUSD : 0;
                return (0, $hxyOZ.html)($8db372aedf80193a$var$_templateObject3(), this.toggleDetails.bind(this), [
                    "0",
                    "xs",
                    "0",
                    "xs"
                ], this.sourceToken.symbol, (0, $dI7zX.UiHelperUtil).formatNumberToLocalString(toTokenSwappedAmount, 3), this.toToken.symbol, (0, $dI7zX.UiHelperUtil).formatNumberToLocalString(this.sourceTokenPriceInUSD), this.detailsOpen ? (0, $hxyOZ.html)($8db372aedf80193a$var$_templateObject2(), "Network cost is paid in ".concat(this.networkTokenSymbol, " on the ").concat(this.networkName, " network in order to execute transaction."), (0, $dI7zX.UiHelperUtil).formatNumberToLocalString(this.gasPriceInUSD, 3), this.priceImpact ? (0, $hxyOZ.html)($8db372aedf80193a$var$_templateObject(), (0, $dI7zX.UiHelperUtil).formatNumberToLocalString(this.priceImpact, 3)) : null, this.maxSlippage && this.sourceToken.symbol ? (0, $hxyOZ.html)($8db372aedf80193a$var$_templateObject1(), "Max slippage sets the minimum amount you must receive for the transaction to proceed. ".concat(minReceivedAmount ? "Transaction will be reversed if you receive less than ".concat((0, $dI7zX.UiHelperUtil).formatNumberToLocalString(minReceivedAmount, 6), " ").concat(this.toToken.symbol, " due to price changes.") : ""), (0, $dI7zX.UiHelperUtil).formatNumberToLocalString(this.maxSlippage, 6), this.toToken.symbol, $8db372aedf80193a$var$slippageRate) : null) : null);
            }
        },
        {
            key: "toggleDetails",
            value: function toggleDetails() {
                this.detailsOpen = !this.detailsOpen;
            }
        }
    ]);
    return WuiSwapDetails;
}((0, $2yD3e.LitElement));
$8db372aedf80193a$export$a5d884fb6b8316b8.styles = [
    (0, $9062f8bc9302b804$export$2e2bcd8739ae039)
];
$8db372aedf80193a$var$__decorate([
    (0, $334Pv.state)()
], $8db372aedf80193a$export$a5d884fb6b8316b8.prototype, "networkName", void 0);
$8db372aedf80193a$var$__decorate([
    (0, $04kNM.property)()
], $8db372aedf80193a$export$a5d884fb6b8316b8.prototype, "detailsOpen", void 0);
$8db372aedf80193a$var$__decorate([
    (0, $334Pv.state)()
], $8db372aedf80193a$export$a5d884fb6b8316b8.prototype, "sourceToken", void 0);
$8db372aedf80193a$var$__decorate([
    (0, $334Pv.state)()
], $8db372aedf80193a$export$a5d884fb6b8316b8.prototype, "toToken", void 0);
$8db372aedf80193a$var$__decorate([
    (0, $334Pv.state)()
], $8db372aedf80193a$export$a5d884fb6b8316b8.prototype, "toTokenAmount", void 0);
$8db372aedf80193a$var$__decorate([
    (0, $334Pv.state)()
], $8db372aedf80193a$export$a5d884fb6b8316b8.prototype, "sourceTokenPriceInUSD", void 0);
$8db372aedf80193a$var$__decorate([
    (0, $334Pv.state)()
], $8db372aedf80193a$export$a5d884fb6b8316b8.prototype, "toTokenPriceInUSD", void 0);
$8db372aedf80193a$var$__decorate([
    (0, $334Pv.state)()
], $8db372aedf80193a$export$a5d884fb6b8316b8.prototype, "gasPriceInUSD", void 0);
$8db372aedf80193a$var$__decorate([
    (0, $334Pv.state)()
], $8db372aedf80193a$export$a5d884fb6b8316b8.prototype, "priceImpact", void 0);
$8db372aedf80193a$var$__decorate([
    (0, $334Pv.state)()
], $8db372aedf80193a$export$a5d884fb6b8316b8.prototype, "maxSlippage", void 0);
$8db372aedf80193a$var$__decorate([
    (0, $334Pv.state)()
], $8db372aedf80193a$export$a5d884fb6b8316b8.prototype, "networkTokenSymbol", void 0);
$8db372aedf80193a$var$__decorate([
    (0, $334Pv.state)()
], $8db372aedf80193a$export$a5d884fb6b8316b8.prototype, "inputError", void 0);
$8db372aedf80193a$export$a5d884fb6b8316b8 = $8db372aedf80193a$var$__decorate([
    (0, $hdxb6.customElement)("w3m-swap-details")
], $8db372aedf80193a$export$a5d884fb6b8316b8);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $04kNM = parcelRequire("04kNM");
parcelRequire("cwWZ7");
var $1QDT9 = parcelRequire("1QDT9");
var $iptjJ = parcelRequire("iptjJ");
parcelRequire("dSKxG");
var $eMPGH = parcelRequire("eMPGH");
var $c3zzE = parcelRequire("c3zzE");
parcelRequire("grHtr");
var $dI7zX = parcelRequire("dI7zX");
var $hdxb6 = parcelRequire("hdxb6");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $18eeeb7d473dc1ff$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host > wui-flex {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    border-radius: var(--wui-border-radius-s);\n    background-color: var(--wui-color-gray-glass-002);\n    padding: var(--wui-spacing-xl);\n    padding-right: var(--wui-spacing-s);\n    width: 100%;\n    height: 100px;\n    box-sizing: border-box;\n    box-shadow: inset 0px 0px 0px 1px var(--wui-color-gray-glass-002);\n    position: relative;\n    transition: box-shadow var(--wui-ease-out-power-1) var(--wui-duration-lg);\n    will-change: background-color;\n  }\n\n  :host wui-flex.focus {\n    box-shadow: inset 0px 0px 0px 1px var(--wui-color-gray-glass-005);\n  }\n\n  :host > wui-flex .swap-input,\n  :host > wui-flex .swap-token-button {\n    z-index: 10;\n  }\n\n  :host > wui-flex .swap-input {\n    -webkit-mask-image: linear-gradient(\n      270deg,\n      transparent 0px,\n      transparent 8px,\n      black 24px,\n      black 25px,\n      black 32px,\n      black 100%\n    );\n    mask-image: linear-gradient(\n      270deg,\n      transparent 0px,\n      transparent 8px,\n      black 24px,\n      black 25px,\n      black 32px,\n      black 100%\n    );\n  }\n\n  :host > wui-flex .swap-input input {\n    background: none;\n    border: none;\n    height: 42px;\n    width: 100%;\n    font-size: 32px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 130%;\n    letter-spacing: -1.28px;\n    outline: none;\n    caret-color: var(--wui-color-accent-100);\n    color: var(--wui-color-fg-100);\n    padding: 0px;\n  }\n\n  :host > wui-flex .swap-input input:focus-visible {\n    outline: none;\n  }\n\n  :host > wui-flex .swap-input input::-webkit-outer-spin-button,\n  :host > wui-flex .swap-input input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  .max-value-button {\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n    color: var(--wui-color-gray-glass-020);\n    padding-left: 0px;\n  }\n\n  .market-value {\n    min-height: 18px;\n  }\n"
    ]);
    $18eeeb7d473dc1ff$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $18eeeb7d473dc1ff$export$2e2bcd8739ae039 = (0, $2D5eP.css)($18eeeb7d473dc1ff$var$_templateObject());


function $e9fdb5cfe7b1b068$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex class="',
        '" justifyContent="space-between">\n        <wui-flex\n          flex="1"\n          flexDirection="column"\n          alignItems="flex-start"\n          justifyContent="center"\n          class="swap-input"\n        >\n          <input\n            data-testid="swap-input-',
        '"\n            @focusin=',
        "\n            @focusout=",
        "\n            ?disabled=",
        "\n            .value=",
        "\n            @input=",
        "\n            @keydown=",
        '\n            placeholder="0"\n            type="text"\n            inputmode="decimal"\n          />\n          <wui-text class="market-value" variant="small-400" color="fg-200">\n            ',
        "\n          </wui-text>\n        </wui-flex>\n        ",
        "\n      </wui-flex>\n    "
    ]);
    $e9fdb5cfe7b1b068$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $e9fdb5cfe7b1b068$var$_templateObject1() {
    var data = (0, $j06k0._)([
        ' <wui-button\n        data-testid="swap-select-token-button-',
        '"\n        class="swap-token-button"\n        size="md"\n        variant="accent"\n        @click=',
        "\n      >\n        Select token\n      </wui-button>"
    ]);
    $e9fdb5cfe7b1b068$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $e9fdb5cfe7b1b068$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex\n        class="swap-token-button"\n        flexDirection="column"\n        alignItems="flex-end"\n        justifyContent="center"\n        gap="xxs"\n      >\n        <wui-token-button\n          data-testid="swap-input-token-',
        '"\n          text=',
        "\n          imageSrc=",
        "\n          @click=",
        '\n        >\n        </wui-token-button>\n        <wui-flex alignItems="center" gap="xxs"> ',
        " </wui-flex>\n      </wui-flex>\n    "
    ]);
    $e9fdb5cfe7b1b068$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $e9fdb5cfe7b1b068$var$_templateObject3() {
    var data = (0, $j06k0._)([
        '<wui-text variant="small-400" color="fg-200">\n            ',
        "\n          </wui-text>"
    ]);
    $e9fdb5cfe7b1b068$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $e9fdb5cfe7b1b068$var$_templateObject4() {
    var data = (0, $j06k0._)([
        "\n      ",
        "\n      ",
        "\n    "
    ]);
    $e9fdb5cfe7b1b068$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $e9fdb5cfe7b1b068$var$_templateObject5() {
    var data = (0, $j06k0._)([
        ' <button class="max-value-button" @click=',
        '>\n        <wui-text color="accent-100" variant="small-600">Max</wui-text>\n      </button>'
    ]);
    $e9fdb5cfe7b1b068$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $e9fdb5cfe7b1b068$var$_templateObject6() {
    var data = (0, $j06k0._)([
        ' <button class="max-value-button" @click=',
        '>\n      <wui-text color="accent-100" variant="small-600">Buy</wui-text>\n    </button>'
    ]);
    $e9fdb5cfe7b1b068$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
var $e9fdb5cfe7b1b068$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $e9fdb5cfe7b1b068$var$MINIMUM_USD_VALUE_TO_CONVERT = 0.00005;
var $e9fdb5cfe7b1b068$export$9ede572f30521f7c = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mSwapInput, LitElement);
    var _super = (0, $ohfOJ._)(W3mSwapInput);
    function W3mSwapInput() {
        (0, $4GJKx._)(this, W3mSwapInput);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.focused = false;
        _this.price = 0;
        _this.target = "sourceToken";
        _this.onSetAmount = null;
        _this.onSetMaxValue = null;
        return _this;
    }
    (0, $1wc17._)(W3mSwapInput, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var marketValue = this.marketValue || "0";
                var isMarketValueGreaterThanZero = (0, $eMPGH.NumberUtil).bigNumber(marketValue).isGreaterThan("0");
                return (0, $hxyOZ.html)($e9fdb5cfe7b1b068$var$_templateObject(), this.focused ? "focus" : "", this.target, function() {
                    return _this.onFocusChange(true);
                }, function() {
                    return _this.onFocusChange(false);
                }, this.disabled, this.value, this.dispatchInputChangeEvent, this.handleKeydown, isMarketValueGreaterThanZero ? "$".concat((0, $dI7zX.UiHelperUtil).formatNumberToLocalString(this.marketValue, 3)) : null, this.templateTokenSelectButton());
            }
        },
        {
            key: "handleKeydown",
            value: function handleKeydown(event) {
                var _this = this;
                return (0, $c3zzE.InputUtil).numericInputKeyDown(event, this.value, function(value) {
                    var _this_onSetAmount, _this1;
                    return (_this_onSetAmount = (_this1 = _this).onSetAmount) === null || _this_onSetAmount === void 0 ? void 0 : _this_onSetAmount.call(_this1, _this.target, value);
                });
            }
        },
        {
            key: "dispatchInputChangeEvent",
            value: function dispatchInputChangeEvent(event) {
                if (!this.onSetAmount) return;
                var value = event.target.value.replace(RegExp("[^0-9.]", "gu"), "");
                if (value === "," || value === ".") this.onSetAmount(this.target, "0.");
                else if (value.endsWith(",")) this.onSetAmount(this.target, value.replace(",", "."));
                else this.onSetAmount(this.target, value);
            }
        },
        {
            key: "setMaxValueToInput",
            value: function setMaxValueToInput() {
                var _this_onSetMaxValue, _this;
                (_this_onSetMaxValue = (_this = this).onSetMaxValue) === null || _this_onSetMaxValue === void 0 ? void 0 : _this_onSetMaxValue.call(_this, this.target, this.balance);
            }
        },
        {
            key: "templateTokenSelectButton",
            value: function templateTokenSelectButton() {
                if (!this.token) return (0, $hxyOZ.html)($e9fdb5cfe7b1b068$var$_templateObject1(), this.target, this.onSelectToken.bind(this));
                return (0, $hxyOZ.html)($e9fdb5cfe7b1b068$var$_templateObject2(), this.target, this.token.symbol, this.token.logoUri, this.onSelectToken.bind(this), this.tokenBalanceTemplate());
            }
        },
        {
            key: "tokenBalanceTemplate",
            value: function tokenBalanceTemplate() {
                var balanceValueInUSD = (0, $eMPGH.NumberUtil).multiply(this.balance, this.price);
                var haveBalance = balanceValueInUSD ? balanceValueInUSD === null || balanceValueInUSD === void 0 ? void 0 : balanceValueInUSD.isGreaterThan($e9fdb5cfe7b1b068$var$MINIMUM_USD_VALUE_TO_CONVERT) : false;
                return (0, $hxyOZ.html)($e9fdb5cfe7b1b068$var$_templateObject4(), haveBalance ? (0, $hxyOZ.html)($e9fdb5cfe7b1b068$var$_templateObject3(), (0, $dI7zX.UiHelperUtil).formatNumberToLocalString(this.balance, 3)) : null, this.target === "sourceToken" ? this.tokenActionButtonTemplate(haveBalance) : null);
            }
        },
        {
            key: "tokenActionButtonTemplate",
            value: function tokenActionButtonTemplate(haveBalance) {
                if (haveBalance) return (0, $hxyOZ.html)($e9fdb5cfe7b1b068$var$_templateObject5(), this.setMaxValueToInput.bind(this));
                return (0, $hxyOZ.html)($e9fdb5cfe7b1b068$var$_templateObject6(), this.onBuyToken.bind(this));
            }
        },
        {
            key: "onFocusChange",
            value: function onFocusChange(state) {
                this.focused = state;
            }
        },
        {
            key: "onSelectToken",
            value: function onSelectToken() {
                (0, $1QDT9.EventsController).sendEvent({
                    type: "track",
                    event: "CLICK_SELECT_TOKEN_TO_SWAP"
                });
                (0, $iptjJ.RouterController).push("SwapSelectToken", {
                    target: this.target
                });
            }
        },
        {
            key: "onBuyToken",
            value: function onBuyToken() {
                (0, $iptjJ.RouterController).push("OnRampProviders");
            }
        }
    ]);
    return W3mSwapInput;
}((0, $2yD3e.LitElement));
$e9fdb5cfe7b1b068$export$9ede572f30521f7c.styles = [
    (0, $18eeeb7d473dc1ff$export$2e2bcd8739ae039)
];
$e9fdb5cfe7b1b068$var$__decorate([
    (0, $04kNM.property)()
], $e9fdb5cfe7b1b068$export$9ede572f30521f7c.prototype, "focused", void 0);
$e9fdb5cfe7b1b068$var$__decorate([
    (0, $04kNM.property)()
], $e9fdb5cfe7b1b068$export$9ede572f30521f7c.prototype, "balance", void 0);
$e9fdb5cfe7b1b068$var$__decorate([
    (0, $04kNM.property)()
], $e9fdb5cfe7b1b068$export$9ede572f30521f7c.prototype, "value", void 0);
$e9fdb5cfe7b1b068$var$__decorate([
    (0, $04kNM.property)()
], $e9fdb5cfe7b1b068$export$9ede572f30521f7c.prototype, "price", void 0);
$e9fdb5cfe7b1b068$var$__decorate([
    (0, $04kNM.property)()
], $e9fdb5cfe7b1b068$export$9ede572f30521f7c.prototype, "marketValue", void 0);
$e9fdb5cfe7b1b068$var$__decorate([
    (0, $04kNM.property)()
], $e9fdb5cfe7b1b068$export$9ede572f30521f7c.prototype, "disabled", void 0);
$e9fdb5cfe7b1b068$var$__decorate([
    (0, $04kNM.property)()
], $e9fdb5cfe7b1b068$export$9ede572f30521f7c.prototype, "target", void 0);
$e9fdb5cfe7b1b068$var$__decorate([
    (0, $04kNM.property)()
], $e9fdb5cfe7b1b068$export$9ede572f30521f7c.prototype, "token", void 0);
$e9fdb5cfe7b1b068$var$__decorate([
    (0, $04kNM.property)()
], $e9fdb5cfe7b1b068$export$9ede572f30521f7c.prototype, "onSetAmount", void 0);
$e9fdb5cfe7b1b068$var$__decorate([
    (0, $04kNM.property)()
], $e9fdb5cfe7b1b068$export$9ede572f30521f7c.prototype, "onSetMaxValue", void 0);
$e9fdb5cfe7b1b068$export$9ede572f30521f7c = $e9fdb5cfe7b1b068$var$__decorate([
    (0, $hdxb6.customElement)("w3m-swap-input")
], $e9fdb5cfe7b1b068$export$9ede572f30521f7c);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $04kNM = parcelRequire("04kNM");
parcelRequire("cwWZ7");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $846c79fac7429995$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    width: 100%;\n  }\n\n  :host > wui-flex {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    border-radius: var(--wui-border-radius-s);\n    padding: var(--wui-spacing-xl);\n    padding-right: var(--wui-spacing-s);\n    background-color: var(--wui-color-gray-glass-002);\n    box-shadow: inset 0px 0px 0px 1px var(--wui-color-gray-glass-002);\n    width: 100%;\n    height: 100px;\n    box-sizing: border-box;\n    position: relative;\n  }\n\n  wui-shimmer.market-value {\n    opacity: 0;\n  }\n\n  :host > wui-flex > svg.input_mask {\n    position: absolute;\n    inset: 0;\n    z-index: 5;\n  }\n\n  :host wui-flex .input_mask__border,\n  :host wui-flex .input_mask__background {\n    transition: fill var(--wui-duration-md) var(--wui-ease-out-power-1);\n    will-change: fill;\n  }\n\n  :host wui-flex .input_mask__border {\n    fill: var(--wui-color-gray-glass-020);\n  }\n\n  :host wui-flex .input_mask__background {\n    fill: var(--wui-color-gray-glass-002);\n  }\n"
    ]);
    $846c79fac7429995$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $846c79fac7429995$export$2e2bcd8739ae039 = (0, $2D5eP.css)($846c79fac7429995$var$_templateObject());


function $461a7951dad401c0$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex class justifyContent="space-between">\n        <wui-flex\n          flex="1"\n          flexDirection="column"\n          alignItems="flex-start"\n          justifyContent="center"\n          class="swap-input"\n          gap="xxs"\n        >\n          <wui-shimmer width="80px" height="40px" borderRadius="xxs" variant="light"></wui-shimmer>\n        </wui-flex>\n        ',
        "\n      </wui-flex>\n    "
    ]);
    $461a7951dad401c0$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $461a7951dad401c0$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex\n        class="swap-token-button"\n        flexDirection="column"\n        alignItems="flex-end"\n        justifyContent="center"\n        gap="xxs"\n      >\n        <wui-shimmer width="80px" height="40px" borderRadius="3xl" variant="light"></wui-shimmer>\n      </wui-flex>\n    '
    ]);
    $461a7951dad401c0$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $461a7951dad401c0$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $461a7951dad401c0$export$3b3c1d28340eee2c = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mSwapInputSkeleton, LitElement);
    var _super = (0, $ohfOJ._)(W3mSwapInputSkeleton);
    function W3mSwapInputSkeleton() {
        (0, $4GJKx._)(this, W3mSwapInputSkeleton);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.target = "sourceToken";
        return _this;
    }
    (0, $1wc17._)(W3mSwapInputSkeleton, [
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($461a7951dad401c0$var$_templateObject(), this.templateTokenSelectButton());
            }
        },
        {
            key: "templateTokenSelectButton",
            value: function templateTokenSelectButton() {
                return (0, $hxyOZ.html)($461a7951dad401c0$var$_templateObject1());
            }
        }
    ]);
    return W3mSwapInputSkeleton;
}((0, $2yD3e.LitElement));
$461a7951dad401c0$export$3b3c1d28340eee2c.styles = [
    (0, $846c79fac7429995$export$2e2bcd8739ae039)
];
$461a7951dad401c0$var$__decorate([
    (0, $04kNM.property)()
], $461a7951dad401c0$export$3b3c1d28340eee2c.prototype, "target", void 0);
$461a7951dad401c0$export$3b3c1d28340eee2c = $461a7951dad401c0$var$__decorate([
    (0, $hdxb6.customElement)("w3m-swap-input-skeleton")
], $461a7951dad401c0$export$3b3c1d28340eee2c);



var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("cwWZ7");
var $iptjJ = parcelRequire("iptjJ");
var $2qlRb = parcelRequire("2qlRb");
var $dMLJP = parcelRequire("dMLJP");
var $fPqxb = parcelRequire("fPqxb");
var $faNff = parcelRequire("faNff");
var $3cYIS = parcelRequire("3cYIS");
var $1QDT9 = parcelRequire("1QDT9");
var $5Lhe6 = parcelRequire("5Lhe6");
var $khm6W = parcelRequire("khm6W");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $bd89f2361e92b063$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    height: 64px;\n  }\n\n  wui-text {\n    text-transform: capitalize;\n  }\n\n  wui-flex.w3m-header-title {\n    transform: translateY(0);\n    opacity: 1;\n  }\n\n  wui-flex.w3m-header-title[view-direction='prev'] {\n    animation:\n      slide-down-out 120ms forwards var(--wui-ease-out-power-2),\n      slide-down-in 120ms forwards var(--wui-ease-out-power-2);\n    animation-delay: 0ms, 200ms;\n  }\n\n  wui-flex.w3m-header-title[view-direction='next'] {\n    animation:\n      slide-up-out 120ms forwards var(--wui-ease-out-power-2),\n      slide-up-in 120ms forwards var(--wui-ease-out-power-2);\n    animation-delay: 0ms, 200ms;\n  }\n\n  wui-icon-link[data-hidden='true'] {\n    opacity: 0 !important;\n    pointer-events: none;\n  }\n\n  @keyframes slide-up-out {\n    from {\n      transform: translateY(0px);\n      opacity: 1;\n    }\n    to {\n      transform: translateY(3px);\n      opacity: 0;\n    }\n  }\n\n  @keyframes slide-up-in {\n    from {\n      transform: translateY(-3px);\n      opacity: 0;\n    }\n    to {\n      transform: translateY(0);\n      opacity: 1;\n    }\n  }\n\n  @keyframes slide-down-out {\n    from {\n      transform: translateY(0px);\n      opacity: 1;\n    }\n    to {\n      transform: translateY(-3px);\n      opacity: 0;\n    }\n  }\n\n  @keyframes slide-down-in {\n    from {\n      transform: translateY(3px);\n      opacity: 0;\n    }\n    to {\n      transform: translateY(0);\n      opacity: 1;\n    }\n  }\n"
    ]);
    $bd89f2361e92b063$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $bd89f2361e92b063$export$2e2bcd8739ae039 = (0, $2D5eP.css)($bd89f2361e92b063$var$_templateObject());




function $7dcf7e8b74fc8423$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      <wui-flex .padding=",
        ' justifyContent="space-between" alignItems="center">\n        ',
        " ",
        " ",
        "\n      </wui-flex>\n    "
    ]);
    $7dcf7e8b74fc8423$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $7dcf7e8b74fc8423$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '<div style="width:40px" />'
    ]);
    $7dcf7e8b74fc8423$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $7dcf7e8b74fc8423$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "\n      <wui-icon-link\n        ?disabled=",
        '\n        icon="close"\n        @click=',
        '\n        data-testid="w3m-header-close"\n      ></wui-icon-link>\n    '
    ]);
    $7dcf7e8b74fc8423$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $7dcf7e8b74fc8423$var$_templateObject3() {
    var data = (0, $j06k0._)([
        '<wui-tag variant="main">Beta</wui-tag>'
    ]);
    $7dcf7e8b74fc8423$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $7dcf7e8b74fc8423$var$_templateObject4() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex\n        view-direction="',
        '"\n        class="w3m-header-title"\n        alignItems="center"\n        gap="xs"\n      >\n        <wui-text variant="paragraph-700" color="fg-100">',
        "</wui-text>\n        ",
        "\n      </wui-flex>\n    "
    ]);
    $7dcf7e8b74fc8423$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $7dcf7e8b74fc8423$var$_templateObject5() {
    var data = (0, $j06k0._)([
        '<wui-select\n        id="dynamic"\n        data-testid="w3m-account-select-network"\n        active-network=',
        "\n        @click=",
        "\n        imageSrc=",
        "\n      ></wui-select>"
    ]);
    $7dcf7e8b74fc8423$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $7dcf7e8b74fc8423$var$_templateObject6() {
    var data = (0, $j06k0._)([
        '<wui-icon-link\n        id="dynamic"\n        icon="chevronLeft"\n        ?disabled=',
        "\n        @click=",
        "\n      ></wui-icon-link>"
    ]);
    $7dcf7e8b74fc8423$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $7dcf7e8b74fc8423$var$_templateObject7() {
    var data = (0, $j06k0._)([
        "<wui-icon-link\n      data-hidden=",
        '\n      id="dynamic"\n      icon="helpCircle"\n      @click=',
        "\n    ></wui-icon-link>"
    ]);
    $7dcf7e8b74fc8423$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
var $7dcf7e8b74fc8423$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $7dcf7e8b74fc8423$var$BETA_SCREENS = [
    "Swap",
    "SwapSelectToken",
    "SwapPreview"
];
function $7dcf7e8b74fc8423$var$headings() {
    var _RouterController_state_data_connector, _RouterController_state_data, _RouterController_state_data_wallet, _RouterController_state_data1, _RouterController_state_data_network, _RouterController_state_data2, _connectors_;
    var connectorName = (_RouterController_state_data = (0, $iptjJ.RouterController).state.data) === null || _RouterController_state_data === void 0 ? void 0 : (_RouterController_state_data_connector = _RouterController_state_data.connector) === null || _RouterController_state_data_connector === void 0 ? void 0 : _RouterController_state_data_connector.name;
    var walletName = (_RouterController_state_data1 = (0, $iptjJ.RouterController).state.data) === null || _RouterController_state_data1 === void 0 ? void 0 : (_RouterController_state_data_wallet = _RouterController_state_data1.wallet) === null || _RouterController_state_data_wallet === void 0 ? void 0 : _RouterController_state_data_wallet.name;
    var networkName = (_RouterController_state_data2 = (0, $iptjJ.RouterController).state.data) === null || _RouterController_state_data2 === void 0 ? void 0 : (_RouterController_state_data_network = _RouterController_state_data2.network) === null || _RouterController_state_data_network === void 0 ? void 0 : _RouterController_state_data_network.name;
    var name = walletName !== null && walletName !== void 0 ? walletName : connectorName;
    var connectors = (0, $2qlRb.ConnectorController).getConnectors();
    var isEmail = connectors.length === 1 && ((_connectors_ = connectors[0]) === null || _connectors_ === void 0 ? void 0 : _connectors_.id) === "w3m-email";
    return {
        Connect: "Connect ".concat(isEmail ? "Email" : "", " Wallet"),
        ChooseAccountName: undefined,
        Account: undefined,
        AccountSettings: undefined,
        AllWallets: "All Wallets",
        ApproveTransaction: "Approve Transaction",
        BuyInProgress: "Buy",
        ConnectingExternal: name !== null && name !== void 0 ? name : "Connect Wallet",
        ConnectingWalletConnect: name !== null && name !== void 0 ? name : "WalletConnect",
        ConnectingSiwe: "Sign In",
        Convert: "Convert",
        ConvertSelectToken: "Select token",
        ConvertPreview: "Preview convert",
        Downloads: name ? "Get ".concat(name) : "Downloads",
        EmailVerifyOtp: "Confirm Email",
        EmailVerifyDevice: "Register Device",
        GetWallet: "Get a wallet",
        Networks: "Choose Network",
        OnRampProviders: "Choose Provider",
        OnRampActivity: "Activity",
        OnRampTokenSelect: "Select Token",
        OnRampFiatSelect: "Select Currency",
        Profile: undefined,
        SelectAddresses: "Select accounts",
        SwitchNetwork: networkName !== null && networkName !== void 0 ? networkName : "Switch Network",
        SwitchAddress: "Switch Address",
        Transactions: "Activity",
        UnsupportedChain: "Switch Network",
        UpgradeEmailWallet: "Upgrade your Wallet",
        UpgradeToSmartAccount: undefined,
        UpdateEmailWallet: "Edit Email",
        UpdateEmailPrimaryOtp: "Confirm Current Email",
        UpdateEmailSecondaryOtp: "Confirm New Email",
        WhatIsABuy: "What is Buy?",
        RegisterAccountName: "Choose name",
        RegisterAccountNameSuccess: "",
        WalletReceive: "Receive",
        WalletCompatibleNetworks: "Compatible Networks",
        Swap: "Swap",
        SwapSelectToken: "Select token",
        SwapPreview: "Preview swap",
        WalletSend: "Send",
        WalletSendPreview: "Review send",
        WalletSendSelectToken: "Select Token",
        WhatIsANetwork: "What is a network?",
        WhatIsAWallet: "What is a wallet?",
        ConnectWallets: "Connect wallet",
        ConnectSocials: "All socials",
        ConnectingSocial: (0, $dMLJP.AccountController).state.socialProvider ? (0, $dMLJP.AccountController).state.socialProvider : "Connect Social",
        ConnectingMultiChain: "Select chain",
        ConnectingFarcaster: "Farcaster",
        SwitchActiveChain: "Switch chain"
    };
}

var $7dcf7e8b74fc8423$export$c6714271d9f13670 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mHeader, LitElement);
    var _super = (0, $ohfOJ._)(W3mHeader);
    function W3mHeader() {
        (0, $4GJKx._)(this, W3mHeader);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.heading = $7dcf7e8b74fc8423$var$headings()[(0, $iptjJ.RouterController).state.view];
        _this.network = (0, $fPqxb.NetworkController).state.caipNetwork;
        _this.buffering = false;
        _this.showBack = false;
        _this.isSiweEnabled = (0, $faNff.OptionsController).state.isSiweEnabled;
        _this.prevHistoryLength = 1;
        _this.view = (0, $iptjJ.RouterController).state.view;
        _this.viewDirection = "";
        _this.headerText = $7dcf7e8b74fc8423$var$headings()[(0, $iptjJ.RouterController).state.view];
        _this.unsubscribe.push((0, $iptjJ.RouterController).subscribeKey("view", function(val) {
            setTimeout(function() {
                _this.view = val;
                _this.headerText = $7dcf7e8b74fc8423$var$headings()[val];
            }, (0, $560364d27174f3fd$export$aafe1f751f1bc52a).ANIMATION_DURATIONS.HeaderText);
            _this.onViewChange();
            _this.onHistoryChange();
        }), (0, $3cYIS.ConnectionController).subscribeKey("buffering", function(val) {
            return _this.buffering = val;
        }), (0, $fPqxb.NetworkController).subscribeKey("caipNetwork", function(val) {
            return _this.network = val;
        }));
        return _this;
    }
    (0, $1wc17._)(W3mHeader, [
        {
            key: "disconnectCallback",
            value: function disconnectCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($7dcf7e8b74fc8423$var$_templateObject(), this.getPadding(), this.dynamicButtonTemplate(), this.titleTemplate(), this.closeButtonTemplate());
            }
        },
        {
            key: "onWalletHelp",
            value: function onWalletHelp() {
                (0, $1QDT9.EventsController).sendEvent({
                    type: "track",
                    event: "CLICK_WALLET_HELP"
                });
                (0, $iptjJ.RouterController).push("WhatIsAWallet");
            }
        },
        {
            key: "onClose",
            value: function onClose() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var SIWEController, isApproveSignScreen, isUnauthenticated;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.isSiweEnabled) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (parcelRequire("jCIHD"))
                                ];
                            case 1:
                                SIWEController = _state.sent().SIWEController;
                                isApproveSignScreen = (0, $iptjJ.RouterController).state.view === "ApproveTransaction";
                                isUnauthenticated = SIWEController.state.status !== "success";
                                if (isUnauthenticated && isApproveSignScreen) (0, $iptjJ.RouterController).popTransactionStack(true);
                                else (0, $5Lhe6.ModalController).close();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                (0, $5Lhe6.ModalController).close();
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "closeButtonTemplate",
            value: function closeButtonTemplate() {
                var isSiweSignScreen = (0, $iptjJ.RouterController).state.view === "ConnectingSiwe";
                if (this.isSiweEnabled && isSiweSignScreen) return (0, $hxyOZ.html)($7dcf7e8b74fc8423$var$_templateObject1());
                return (0, $hxyOZ.html)($7dcf7e8b74fc8423$var$_templateObject2(), this.buffering, this.onClose.bind(this));
            }
        },
        {
            key: "titleTemplate",
            value: function titleTemplate() {
                var isBeta = $7dcf7e8b74fc8423$var$BETA_SCREENS.includes(this.view);
                return (0, $hxyOZ.html)($7dcf7e8b74fc8423$var$_templateObject4(), this.viewDirection, this.headerText, isBeta ? (0, $hxyOZ.html)($7dcf7e8b74fc8423$var$_templateObject3()) : null);
            }
        },
        {
            key: "dynamicButtonTemplate",
            value: function dynamicButtonTemplate() {
                var _this_network;
                var view = (0, $iptjJ.RouterController).state.view;
                var isConnectHelp = view === "Connect";
                var isApproveTransaction = view === "ApproveTransaction";
                var isUpgradeToSmartAccounts = view === "UpgradeToSmartAccount";
                var isConnectingSIWEView = view === "ConnectingSiwe";
                var isAccountView = view === "Account";
                var shouldHideBack = isApproveTransaction || isUpgradeToSmartAccounts || isConnectingSIWEView;
                if (isAccountView) return (0, $hxyOZ.html)($7dcf7e8b74fc8423$var$_templateObject5(), (_this_network = this.network) === null || _this_network === void 0 ? void 0 : _this_network.name, this.onNetworks.bind(this), (0, $696d14fc702af3d6$export$f68dd208b5df064d)((0, $khm6W.AssetUtil).getNetworkImage(this.network)));
                if (this.showBack && !shouldHideBack) return (0, $hxyOZ.html)($7dcf7e8b74fc8423$var$_templateObject6(), this.buffering, this.onGoBack.bind(this));
                return (0, $hxyOZ.html)($7dcf7e8b74fc8423$var$_templateObject7(), !isConnectHelp, this.onWalletHelp.bind(this));
            }
        },
        {
            key: "onNetworks",
            value: function onNetworks() {
                if (this.isAllowedNetworkSwitch()) {
                    (0, $1QDT9.EventsController).sendEvent({
                        type: "track",
                        event: "CLICK_NETWORKS"
                    });
                    (0, $iptjJ.RouterController).push("Networks");
                }
            }
        },
        {
            key: "isAllowedNetworkSwitch",
            value: function isAllowedNetworkSwitch() {
                var _this = this;
                var requestedCaipNetworks = (0, $fPqxb.NetworkController).getRequestedCaipNetworks();
                var isMultiNetwork = requestedCaipNetworks ? requestedCaipNetworks.length > 1 : false;
                var isValidNetwork = requestedCaipNetworks === null || requestedCaipNetworks === void 0 ? void 0 : requestedCaipNetworks.find(function(param) {
                    var id = param.id;
                    var _this_network;
                    return id === ((_this_network = _this.network) === null || _this_network === void 0 ? void 0 : _this_network.id);
                });
                return isMultiNetwork || !isValidNetwork;
            }
        },
        {
            key: "getPadding",
            value: function getPadding() {
                if (this.heading) return [
                    "l",
                    "2l",
                    "l",
                    "2l"
                ];
                return [
                    "0",
                    "2l",
                    "0",
                    "2l"
                ];
            }
        },
        {
            key: "onViewChange",
            value: function onViewChange() {
                var history = (0, $iptjJ.RouterController).state.history;
                var direction = (0, $560364d27174f3fd$export$aafe1f751f1bc52a).VIEW_DIRECTION.Next;
                if (history.length < this.prevHistoryLength) direction = (0, $560364d27174f3fd$export$aafe1f751f1bc52a).VIEW_DIRECTION.Prev;
                this.prevHistoryLength = history.length;
                this.viewDirection = direction;
            }
        },
        {
            key: "onHistoryChange",
            value: function onHistoryChange() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _this_shadowRoot, history, buttonEl;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                history = (0, $iptjJ.RouterController).state.history;
                                buttonEl = (_this_shadowRoot = _this.shadowRoot) === null || _this_shadowRoot === void 0 ? void 0 : _this_shadowRoot.querySelector("#dynamic");
                                if (!(history.length > 1 && !_this.showBack && buttonEl)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    buttonEl.animate([
                                        {
                                            opacity: 1
                                        },
                                        {
                                            opacity: 0
                                        }
                                    ], {
                                        duration: 200,
                                        fill: "forwards",
                                        easing: "ease"
                                    }).finished
                                ];
                            case 1:
                                _state.sent();
                                _this.showBack = true;
                                buttonEl.animate([
                                    {
                                        opacity: 0
                                    },
                                    {
                                        opacity: 1
                                    }
                                ], {
                                    duration: 200,
                                    fill: "forwards",
                                    easing: "ease"
                                });
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                if (!(history.length <= 1 && _this.showBack && buttonEl)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    buttonEl.animate([
                                        {
                                            opacity: 1
                                        },
                                        {
                                            opacity: 0
                                        }
                                    ], {
                                        duration: 200,
                                        fill: "forwards",
                                        easing: "ease"
                                    }).finished
                                ];
                            case 3:
                                _state.sent();
                                _this.showBack = false;
                                buttonEl.animate([
                                    {
                                        opacity: 0
                                    },
                                    {
                                        opacity: 1
                                    }
                                ], {
                                    duration: 200,
                                    fill: "forwards",
                                    easing: "ease"
                                });
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onGoBack",
            value: function onGoBack() {
                (0, $iptjJ.RouterController).goBack();
            }
        }
    ]);
    return W3mHeader;
}((0, $2yD3e.LitElement));
$7dcf7e8b74fc8423$export$c6714271d9f13670.styles = (0, $bd89f2361e92b063$export$2e2bcd8739ae039);
$7dcf7e8b74fc8423$var$__decorate([
    (0, $334Pv.state)()
], $7dcf7e8b74fc8423$export$c6714271d9f13670.prototype, "heading", void 0);
$7dcf7e8b74fc8423$var$__decorate([
    (0, $334Pv.state)()
], $7dcf7e8b74fc8423$export$c6714271d9f13670.prototype, "network", void 0);
$7dcf7e8b74fc8423$var$__decorate([
    (0, $334Pv.state)()
], $7dcf7e8b74fc8423$export$c6714271d9f13670.prototype, "buffering", void 0);
$7dcf7e8b74fc8423$var$__decorate([
    (0, $334Pv.state)()
], $7dcf7e8b74fc8423$export$c6714271d9f13670.prototype, "showBack", void 0);
$7dcf7e8b74fc8423$var$__decorate([
    (0, $334Pv.state)()
], $7dcf7e8b74fc8423$export$c6714271d9f13670.prototype, "isSiweEnabled", void 0);
$7dcf7e8b74fc8423$var$__decorate([
    (0, $334Pv.state)()
], $7dcf7e8b74fc8423$export$c6714271d9f13670.prototype, "prevHistoryLength", void 0);
$7dcf7e8b74fc8423$var$__decorate([
    (0, $334Pv.state)()
], $7dcf7e8b74fc8423$export$c6714271d9f13670.prototype, "view", void 0);
$7dcf7e8b74fc8423$var$__decorate([
    (0, $334Pv.state)()
], $7dcf7e8b74fc8423$export$c6714271d9f13670.prototype, "viewDirection", void 0);
$7dcf7e8b74fc8423$var$__decorate([
    (0, $334Pv.state)()
], $7dcf7e8b74fc8423$export$c6714271d9f13670.prototype, "headerText", void 0);
$7dcf7e8b74fc8423$export$c6714271d9f13670 = $7dcf7e8b74fc8423$var$__decorate([
    (0, $hdxb6.customElement)("w3m-header")
], $7dcf7e8b74fc8423$export$c6714271d9f13670);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $04kNM = parcelRequire("04kNM");
function $c5d0755616e128e0$var$_templateObject() {
    var data = (0, $j06k0._)([
        "<wui-visual name=",
        "></wui-visual>"
    ]);
    $c5d0755616e128e0$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $c5d0755616e128e0$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '\n            <wui-flex flexDirection="column" alignItems="center" gap="xl">\n              <wui-flex flexDirection="row" justifyContent="center" gap="1xs">\n                ',
        '\n              </wui-flex>\n            </wui-flex>\n            <wui-flex flexDirection="column" alignItems="center" gap="xxs">\n              <wui-text variant="paragraph-500" color="fg-100" align="center">\n                ',
        '\n              </wui-text>\n              <wui-text variant="small-500" color="fg-200" align="center">',
        "</wui-text>\n            </wui-flex>\n          "
    ]);
    $c5d0755616e128e0$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $c5d0755616e128e0$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column" alignItems="center" gap="l">\n        ',
        "\n      </wui-flex>\n    "
    ]);
    $c5d0755616e128e0$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $c5d0755616e128e0$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c5d0755616e128e0$export$c95abd0ceed44b88 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mHelpWidget, LitElement);
    var _super = (0, $ohfOJ._)(W3mHelpWidget);
    function W3mHelpWidget() {
        (0, $4GJKx._)(this, W3mHelpWidget);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.data = [];
        return _this;
    }
    (0, $1wc17._)(W3mHelpWidget, [
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($c5d0755616e128e0$var$_templateObject2(), this.data.map(function(item) {
                    return (0, $hxyOZ.html)($c5d0755616e128e0$var$_templateObject1(), item.images.map(function(image) {
                        return (0, $hxyOZ.html)($c5d0755616e128e0$var$_templateObject(), image);
                    }), item.title, item.text);
                }));
            }
        }
    ]);
    return W3mHelpWidget;
}((0, $2yD3e.LitElement));
$c5d0755616e128e0$var$__decorate([
    (0, $04kNM.property)({
        type: Array
    })
], $c5d0755616e128e0$export$c95abd0ceed44b88.prototype, "data", void 0);
$c5d0755616e128e0$export$c95abd0ceed44b88 = $c5d0755616e128e0$var$__decorate([
    (0, $hdxb6.customElement)("w3m-help-widget")
], $c5d0755616e128e0$export$c95abd0ceed44b88);



var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $04kNM = parcelRequire("04kNM");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("cwWZ7");
var $hMdcG = parcelRequire("hMdcG");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $ac72c89b8f9dbd9d$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    width: 100%;\n  }\n\n  :host > wui-flex {\n    width: 100%;\n    padding: var(--wui-spacing-s);\n    border-radius: var(--wui-border-radius-xs);\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: var(--wui-spacing-s);\n  }\n\n  :host > wui-flex:hover {\n    background-color: var(--wui-color-gray-glass-002);\n  }\n\n  .purchase-image-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    width: var(--wui-icon-box-size-lg);\n    height: var(--wui-icon-box-size-lg);\n  }\n\n  .purchase-image-container wui-image {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    border-radius: calc(var(--wui-icon-box-size-lg) / 2);\n  }\n\n  .purchase-image-container wui-image::after {\n    content: '';\n    display: block;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    inset: 0;\n    border-radius: calc(var(--wui-icon-box-size-lg) / 2);\n    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-005);\n  }\n\n  .purchase-image-container wui-icon-box {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    transform: translate(20%, 20%);\n  }\n"
    ]);
    $ac72c89b8f9dbd9d$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $ac72c89b8f9dbd9d$export$2e2bcd8739ae039 = (0, $2D5eP.css)($ac72c89b8f9dbd9d$var$_templateObject());


function $cfcc6c96e908a936$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<wui-loading-spinner color="fg-200" size="md"></wui-loading-spinner>'
    ]);
    $cfcc6c96e908a936$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $cfcc6c96e908a936$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '<wui-text variant="micro-700" color="fg-300"><span>',
        "</span></wui-text>"
    ]);
    $cfcc6c96e908a936$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $cfcc6c96e908a936$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "\n      <wui-flex>\n        ",
        '\n        <wui-flex flexDirection="column" gap="4xs" flexGrow="1">\n          <wui-flex gap="xxs" alignItems="center" justifyContent="flex-start">\n            ',
        '\n            <wui-text variant="paragraph-500" color="fg-100"> ',
        '</wui-text>\n          </wui-flex>\n          <wui-text variant="small-400" color="fg-200">\n            + ',
        " ",
        "\n          </wui-text>\n        </wui-flex>\n        ",
        "\n      </wui-flex>\n    "
    ]);
    $cfcc6c96e908a936$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $cfcc6c96e908a936$var$_templateObject3() {
    var data = (0, $j06k0._)([
        '<wui-icon-box\n      size="xxs"\n      iconColor="error-100"\n      backgroundColor="error-100"\n      background="opaque"\n      icon="close"\n      borderColor="wui-color-bg-125"\n    ></wui-icon-box>'
    ]);
    $cfcc6c96e908a936$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $cfcc6c96e908a936$var$_templateObject4() {
    var data = (0, $j06k0._)([
        '<wui-flex class="purchase-image-container">\n      <wui-image src=',
        "></wui-image>\n    </wui-flex>"
    ]);
    $cfcc6c96e908a936$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $cfcc6c96e908a936$var$_templateObject5() {
    var data = (0, $j06k0._)([
        '<wui-icon-box\n      size="xxs"\n      iconColor="success-100"\n      backgroundColor="success-100"\n      background="opaque"\n      icon="arrowBottom"\n      borderColor="wui-color-bg-125"\n    ></wui-icon-box>'
    ]);
    $cfcc6c96e908a936$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
var $cfcc6c96e908a936$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $cfcc6c96e908a936$export$73a3d63470374c46 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mOnRampActivityItem, LitElement);
    var _super = (0, $ohfOJ._)(W3mOnRampActivityItem);
    function W3mOnRampActivityItem() {
        (0, $4GJKx._)(this, W3mOnRampActivityItem);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.disabled = false;
        _this.color = "inherit";
        _this.label = "Bought";
        _this.purchaseValue = "";
        _this.purchaseCurrency = "";
        _this.date = "";
        _this.completed = false;
        _this.inProgress = false;
        _this.failed = false;
        _this.onClick = null;
        _this.symbol = "";
        return _this;
    }
    (0, $1wc17._)(W3mOnRampActivityItem, [
        {
            key: "firstUpdated",
            value: function firstUpdated() {
                if (!this.icon) this.fetchTokenImage();
            }
        },
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($cfcc6c96e908a936$var$_templateObject2(), this.imageTemplate(), this.statusIconTemplate(), this.label, this.purchaseValue, this.purchaseCurrency, this.inProgress ? (0, $hxyOZ.html)($cfcc6c96e908a936$var$_templateObject()) : (0, $hxyOZ.html)($cfcc6c96e908a936$var$_templateObject1(), this.date));
            }
        },
        {
            key: "fetchTokenImage",
            value: function fetchTokenImage() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $hMdcG.ApiController)._fetchTokenImage(_this.purchaseCurrency)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "statusIconTemplate",
            value: function statusIconTemplate() {
                if (this.inProgress) return null;
                return this.completed ? this.boughtIconTemplate() : this.errorIconTemplate();
            }
        },
        {
            key: "errorIconTemplate",
            value: function errorIconTemplate() {
                return (0, $hxyOZ.html)($cfcc6c96e908a936$var$_templateObject3());
            }
        },
        {
            key: "imageTemplate",
            value: function imageTemplate() {
                var icon = this.icon || "https://avatar.vercel.sh/andrew.svg?size=50&text=".concat(this.symbol);
                return (0, $hxyOZ.html)($cfcc6c96e908a936$var$_templateObject4(), icon);
            }
        },
        {
            key: "boughtIconTemplate",
            value: function boughtIconTemplate() {
                return (0, $hxyOZ.html)($cfcc6c96e908a936$var$_templateObject5());
            }
        }
    ]);
    return W3mOnRampActivityItem;
}((0, $2yD3e.LitElement));
$cfcc6c96e908a936$export$73a3d63470374c46.styles = [
    (0, $ac72c89b8f9dbd9d$export$2e2bcd8739ae039)
];
$cfcc6c96e908a936$var$__decorate([
    (0, $04kNM.property)({
        type: Boolean
    })
], $cfcc6c96e908a936$export$73a3d63470374c46.prototype, "disabled", void 0);
$cfcc6c96e908a936$var$__decorate([
    (0, $04kNM.property)()
], $cfcc6c96e908a936$export$73a3d63470374c46.prototype, "color", void 0);
$cfcc6c96e908a936$var$__decorate([
    (0, $04kNM.property)()
], $cfcc6c96e908a936$export$73a3d63470374c46.prototype, "label", void 0);
$cfcc6c96e908a936$var$__decorate([
    (0, $04kNM.property)()
], $cfcc6c96e908a936$export$73a3d63470374c46.prototype, "purchaseValue", void 0);
$cfcc6c96e908a936$var$__decorate([
    (0, $04kNM.property)()
], $cfcc6c96e908a936$export$73a3d63470374c46.prototype, "purchaseCurrency", void 0);
$cfcc6c96e908a936$var$__decorate([
    (0, $04kNM.property)()
], $cfcc6c96e908a936$export$73a3d63470374c46.prototype, "date", void 0);
$cfcc6c96e908a936$var$__decorate([
    (0, $04kNM.property)({
        type: Boolean
    })
], $cfcc6c96e908a936$export$73a3d63470374c46.prototype, "completed", void 0);
$cfcc6c96e908a936$var$__decorate([
    (0, $04kNM.property)({
        type: Boolean
    })
], $cfcc6c96e908a936$export$73a3d63470374c46.prototype, "inProgress", void 0);
$cfcc6c96e908a936$var$__decorate([
    (0, $04kNM.property)({
        type: Boolean
    })
], $cfcc6c96e908a936$export$73a3d63470374c46.prototype, "failed", void 0);
$cfcc6c96e908a936$var$__decorate([
    (0, $04kNM.property)()
], $cfcc6c96e908a936$export$73a3d63470374c46.prototype, "onClick", void 0);
$cfcc6c96e908a936$var$__decorate([
    (0, $04kNM.property)()
], $cfcc6c96e908a936$export$73a3d63470374c46.prototype, "symbol", void 0);
$cfcc6c96e908a936$var$__decorate([
    (0, $04kNM.property)()
], $cfcc6c96e908a936$export$73a3d63470374c46.prototype, "icon", void 0);
$cfcc6c96e908a936$export$73a3d63470374c46 = $cfcc6c96e908a936$var$__decorate([
    (0, $hdxb6.customElement)("w3m-onramp-activity-item")
], $cfcc6c96e908a936$export$73a3d63470374c46);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $do9pw = parcelRequire("do9pw");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $04kNM = parcelRequire("04kNM");
var $334Pv = parcelRequire("334Pv");

parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $a3fc6644f1000058$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    width: 100%;\n  }\n\n  wui-loading-spinner {\n    position: absolute;\n    top: 50%;\n    right: 20px;\n    transform: translateY(-50%);\n  }\n\n  .currency-container {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    right: var(--wui-spacing-1xs);\n    height: 40px;\n    padding: var(--wui-spacing-xs) var(--wui-spacing-1xs) var(--wui-spacing-xs)\n      var(--wui-spacing-xs);\n    min-width: 95px;\n    border-radius: var(--FULL, 1000px);\n    border: 1px solid var(--wui-color-gray-glass-002);\n    background: var(--wui-color-gray-glass-002);\n    cursor: pointer;\n  }\n\n  .currency-container > wui-image {\n    height: 24px;\n    width: 24px;\n    border-radius: 50%;\n  }\n"
    ]);
    $a3fc6644f1000058$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $a3fc6644f1000058$export$2e2bcd8739ae039 = (0, $2D5eP.css)($a3fc6644f1000058$var$_templateObject());


parcelRequire("cwWZ7");
var $datXT = parcelRequire("datXT");
var $69mn1 = parcelRequire("69mn1");
var $5Lhe6 = parcelRequire("5Lhe6");
function $872a3da3a6f0cdb9$var$_templateObject() {
    var data = (0, $j06k0._)([
        ' <wui-flex\n            class="currency-container"\n            justifyContent="space-between"\n            alignItems="center"\n            gap="xxs"\n            @click=',
        "\n          >\n            <wui-image src=",
        '></wui-image>\n            <wui-text color="fg-100">',
        "</wui-text>\n          </wui-flex>"
    ]);
    $872a3da3a6f0cdb9$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $872a3da3a6f0cdb9$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "<wui-loading-spinner></wui-loading-spinner>"
    ]);
    $872a3da3a6f0cdb9$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $872a3da3a6f0cdb9$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '<wui-input-text type="number" size="lg" value=',
        ">\n      ",
        "\n    </wui-input-text>"
    ]);
    $872a3da3a6f0cdb9$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $872a3da3a6f0cdb9$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $872a3da3a6f0cdb9$export$8c7f6376138a05de = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mInputCurrency, LitElement);
    var _super = (0, $ohfOJ._)(W3mInputCurrency);
    function W3mInputCurrency() {
        (0, $4GJKx._)(this, W3mInputCurrency);
        var _this;
        var _this_currencies;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.type = "Token";
        _this.value = 0;
        _this.currencies = [];
        _this.selectedCurrency = (_this_currencies = _this.currencies) === null || _this_currencies === void 0 ? void 0 : _this_currencies[0];
        _this.currencyImages = (0, $datXT.AssetController).state.currencyImages;
        _this.tokenImages = (0, $datXT.AssetController).state.tokenImages;
        _this.unsubscribe.push((0, $69mn1.OnRampController).subscribeKey("purchaseCurrency", function(val) {
            if (!val || _this.type === "Fiat") return;
            _this.selectedCurrency = _this.formatPurchaseCurrency(val);
        }), (0, $69mn1.OnRampController).subscribeKey("paymentCurrency", function(val) {
            if (!val || _this.type === "Token") return;
            _this.selectedCurrency = _this.formatPaymentCurrency(val);
        }), (0, $69mn1.OnRampController).subscribe(function(val) {
            if (_this.type === "Fiat") _this.currencies = val.purchaseCurrencies.map(_this.formatPurchaseCurrency);
            else _this.currencies = val.paymentCurrencies.map(_this.formatPaymentCurrency);
        }), (0, $datXT.AssetController).subscribe(function(val) {
            _this.currencyImages = (0, $do9pw._)({}, val.currencyImages);
            _this.tokenImages = (0, $do9pw._)({}, val.tokenImages);
        }));
        return _this;
    }
    (0, $1wc17._)(W3mInputCurrency, [
        {
            key: "firstUpdated",
            value: function firstUpdated() {
                (0, $69mn1.OnRampController).getAvailableCurrencies();
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_selectedCurrency;
                var symbol = ((_this_selectedCurrency = this.selectedCurrency) === null || _this_selectedCurrency === void 0 ? void 0 : _this_selectedCurrency.symbol) || "";
                var image = this.currencyImages[symbol] || this.tokenImages[symbol];
                return (0, $hxyOZ.html)($872a3da3a6f0cdb9$var$_templateObject2(), this.value, this.selectedCurrency ? (0, $hxyOZ.html)($872a3da3a6f0cdb9$var$_templateObject(), function() {
                    return (0, $5Lhe6.ModalController).open({
                        view: "OnRamp".concat(_this.type, "Select")
                    });
                }, (0, $696d14fc702af3d6$export$f68dd208b5df064d)(image), this.selectedCurrency.symbol) : (0, $hxyOZ.html)($872a3da3a6f0cdb9$var$_templateObject1()));
            }
        },
        {
            key: "formatPaymentCurrency",
            value: function formatPaymentCurrency(currency) {
                return {
                    name: currency.id,
                    symbol: currency.id
                };
            }
        },
        {
            key: "formatPurchaseCurrency",
            value: function formatPurchaseCurrency(currency) {
                return {
                    name: currency.name,
                    symbol: currency.symbol
                };
            }
        }
    ]);
    return W3mInputCurrency;
}((0, $2yD3e.LitElement));
$872a3da3a6f0cdb9$export$8c7f6376138a05de.styles = (0, $a3fc6644f1000058$export$2e2bcd8739ae039);
$872a3da3a6f0cdb9$var$__decorate([
    (0, $04kNM.property)({
        type: String
    })
], $872a3da3a6f0cdb9$export$8c7f6376138a05de.prototype, "type", void 0);
$872a3da3a6f0cdb9$var$__decorate([
    (0, $04kNM.property)({
        type: Number
    })
], $872a3da3a6f0cdb9$export$8c7f6376138a05de.prototype, "value", void 0);
$872a3da3a6f0cdb9$var$__decorate([
    (0, $334Pv.state)()
], $872a3da3a6f0cdb9$export$8c7f6376138a05de.prototype, "currencies", void 0);
$872a3da3a6f0cdb9$var$__decorate([
    (0, $334Pv.state)()
], $872a3da3a6f0cdb9$export$8c7f6376138a05de.prototype, "selectedCurrency", void 0);
$872a3da3a6f0cdb9$var$__decorate([
    (0, $334Pv.state)()
], $872a3da3a6f0cdb9$export$8c7f6376138a05de.prototype, "currencyImages", void 0);
$872a3da3a6f0cdb9$var$__decorate([
    (0, $334Pv.state)()
], $872a3da3a6f0cdb9$export$8c7f6376138a05de.prototype, "tokenImages", void 0);
$872a3da3a6f0cdb9$export$8c7f6376138a05de = $872a3da3a6f0cdb9$var$__decorate([
    (0, $hdxb6.customElement)("w3m-onramp-input")
], $872a3da3a6f0cdb9$export$8c7f6376138a05de);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $04kNM = parcelRequire("04kNM");

parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("cwWZ7");
var $fPqxb = parcelRequire("fPqxb");
var $khm6W = parcelRequire("khm6W");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $21d3e156fb6f8815$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  button {\n    padding: var(--wui-spacing-s);\n    border-radius: var(--wui-border-radius-xs);\n    border: none;\n    outline: none;\n    background-color: var(--wui-color-gray-glass-002);\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: var(--wui-spacing-s);\n    transition: background-color var(--wui-ease-out-power-1) var(--wui-duration-md);\n    will-change: background-color;\n  }\n\n  button:hover {\n    background-color: var(--wui-color-gray-glass-005);\n  }\n\n  .provider-image {\n    width: var(--wui-spacing-3xl);\n    min-width: var(--wui-spacing-3xl);\n    height: var(--wui-spacing-3xl);\n    border-radius: calc(var(--wui-border-radius-xs) - calc(var(--wui-spacing-s) / 2));\n    position: relative;\n    overflow: hidden;\n  }\n\n  .provider-image::after {\n    content: '';\n    display: block;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    inset: 0;\n    border-radius: calc(var(--wui-border-radius-xs) - calc(var(--wui-spacing-s) / 2));\n    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-005);\n  }\n\n  .network-icon {\n    width: var(--wui-spacing-m);\n    height: var(--wui-spacing-m);\n    border-radius: calc(var(--wui-spacing-m) / 2);\n    overflow: hidden;\n    box-shadow:\n      0 0 0 3px var(--wui-color-gray-glass-002),\n      0 0 0 3px var(--wui-color-modal-bg);\n    transition: box-shadow var(--wui-ease-out-power-1) var(--wui-duration-md);\n    will-change: box-shadow;\n  }\n\n  button:hover .network-icon {\n    box-shadow:\n      0 0 0 3px var(--wui-color-gray-glass-005),\n      0 0 0 3px var(--wui-color-modal-bg);\n  }\n"
    ]);
    $21d3e156fb6f8815$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $21d3e156fb6f8815$export$2e2bcd8739ae039 = (0, $2D5eP.css)($21d3e156fb6f8815$var$_templateObject());


function $c3a8950a8be16bc4$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<wui-loading-spinner color="fg-200" size="md"></wui-loading-spinner>'
    ]);
    $c3a8950a8be16bc4$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $c3a8950a8be16bc4$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '<wui-icon name="chevronRight" color="fg-200" size="sm"></wui-icon>'
    ]);
    $c3a8950a8be16bc4$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $c3a8950a8be16bc4$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "\n      <button ?disabled=",
        " ontouchstart>\n        <wui-visual name=",
        ' class="provider-image"></wui-visual>\n        <wui-flex flexDirection="column" gap="4xs">\n          <wui-text variant="paragraph-500" color="fg-100">',
        '</wui-text>\n          <wui-flex alignItems="center" justifyContent="flex-start" gap="l">\n            <wui-text variant="tiny-500" color="fg-100">\n              <wui-text variant="tiny-400" color="fg-200">Fees</wui-text>\n              ',
        '\n            </wui-text>\n            <wui-flex gap="xxs">\n              <wui-icon name="bank" size="xs" color="fg-150"></wui-icon>\n              <wui-icon name="card" size="xs" color="fg-150"></wui-icon>\n            </wui-flex>\n            ',
        "\n          </wui-flex>\n        </wui-flex>\n        ",
        "\n      </button>\n    "
    ]);
    $c3a8950a8be16bc4$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $c3a8950a8be16bc4$var$_templateObject3() {
    var data = (0, $j06k0._)([
        '\n            <wui-flex class="network-icon">\n              <wui-image src=',
        "></wui-image>\n            </wui-flex>\n          "
    ]);
    $c3a8950a8be16bc4$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $c3a8950a8be16bc4$var$_templateObject4() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex class="networks">\n        ',
        "\n      </wui-flex>\n    "
    ]);
    $c3a8950a8be16bc4$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
var $c3a8950a8be16bc4$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c3a8950a8be16bc4$export$b88f5e2e0c9c5425 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mOnRampProviderItem, LitElement);
    var _super = (0, $ohfOJ._)(W3mOnRampProviderItem);
    function W3mOnRampProviderItem() {
        (0, $4GJKx._)(this, W3mOnRampProviderItem);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.disabled = false;
        _this.color = "inherit";
        _this.label = "";
        _this.feeRange = "";
        _this.loading = false;
        _this.onClick = null;
        return _this;
    }
    (0, $1wc17._)(W3mOnRampProviderItem, [
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($c3a8950a8be16bc4$var$_templateObject2(), this.disabled, (0, $696d14fc702af3d6$export$f68dd208b5df064d)(this.name), this.label, this.feeRange, this.networksTemplate(), this.loading ? (0, $hxyOZ.html)($c3a8950a8be16bc4$var$_templateObject()) : (0, $hxyOZ.html)($c3a8950a8be16bc4$var$_templateObject1()));
            }
        },
        {
            key: "networksTemplate",
            value: function networksTemplate() {
                var _requestedCaipNetworks_filter;
                var requestedCaipNetworks = (0, $fPqxb.NetworkController).getRequestedCaipNetworks();
                var slicedNetworks = requestedCaipNetworks === null || requestedCaipNetworks === void 0 ? void 0 : (_requestedCaipNetworks_filter = requestedCaipNetworks.filter(function(network) {
                    return network === null || network === void 0 ? void 0 : network.imageId;
                })) === null || _requestedCaipNetworks_filter === void 0 ? void 0 : _requestedCaipNetworks_filter.slice(0, 5);
                return (0, $hxyOZ.html)($c3a8950a8be16bc4$var$_templateObject4(), slicedNetworks === null || slicedNetworks === void 0 ? void 0 : slicedNetworks.map(function(network) {
                    return (0, $hxyOZ.html)($c3a8950a8be16bc4$var$_templateObject3(), (0, $696d14fc702af3d6$export$f68dd208b5df064d)((0, $khm6W.AssetUtil).getNetworkImage(network)));
                }));
            }
        }
    ]);
    return W3mOnRampProviderItem;
}((0, $2yD3e.LitElement));
$c3a8950a8be16bc4$export$b88f5e2e0c9c5425.styles = [
    (0, $21d3e156fb6f8815$export$2e2bcd8739ae039)
];
$c3a8950a8be16bc4$var$__decorate([
    (0, $04kNM.property)({
        type: Boolean
    })
], $c3a8950a8be16bc4$export$b88f5e2e0c9c5425.prototype, "disabled", void 0);
$c3a8950a8be16bc4$var$__decorate([
    (0, $04kNM.property)()
], $c3a8950a8be16bc4$export$b88f5e2e0c9c5425.prototype, "color", void 0);
$c3a8950a8be16bc4$var$__decorate([
    (0, $04kNM.property)()
], $c3a8950a8be16bc4$export$b88f5e2e0c9c5425.prototype, "name", void 0);
$c3a8950a8be16bc4$var$__decorate([
    (0, $04kNM.property)()
], $c3a8950a8be16bc4$export$b88f5e2e0c9c5425.prototype, "label", void 0);
$c3a8950a8be16bc4$var$__decorate([
    (0, $04kNM.property)()
], $c3a8950a8be16bc4$export$b88f5e2e0c9c5425.prototype, "feeRange", void 0);
$c3a8950a8be16bc4$var$__decorate([
    (0, $04kNM.property)({
        type: Boolean
    })
], $c3a8950a8be16bc4$export$b88f5e2e0c9c5425.prototype, "loading", void 0);
$c3a8950a8be16bc4$var$__decorate([
    (0, $04kNM.property)()
], $c3a8950a8be16bc4$export$b88f5e2e0c9c5425.prototype, "onClick", void 0);
$c3a8950a8be16bc4$export$b88f5e2e0c9c5425 = $c3a8950a8be16bc4$var$__decorate([
    (0, $hdxb6.customElement)("w3m-onramp-provider-item")
], $c3a8950a8be16bc4$export$b88f5e2e0c9c5425);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $faNff = parcelRequire("faNff");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $6771390cff1131d6$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  wui-flex {\n    background-color: var(--wui-color-gray-glass-005);\n  }\n\n  a {\n    text-decoration: none;\n    color: var(--wui-color-fg-175);\n    font-weight: 500;\n  }\n"
    ]);
    $6771390cff1131d6$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $6771390cff1131d6$export$2e2bcd8739ae039 = (0, $2D5eP.css)($6771390cff1131d6$var$_templateObject());


function $f5919d81024a594b$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      <wui-flex .padding=",
        ' justifyContent="center">\n        <wui-text color="fg-250" variant="small-400" align="center">\n          By connecting your wallet, you agree to our <br />\n          ',
        " ",
        " ",
        "\n        </wui-text>\n      </wui-flex>\n    "
    ]);
    $f5919d81024a594b$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $f5919d81024a594b$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "<a href=",
        ">Terms of Service</a>"
    ]);
    $f5919d81024a594b$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $f5919d81024a594b$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "<a href=",
        ">Privacy Policy</a>"
    ]);
    $f5919d81024a594b$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $f5919d81024a594b$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f5919d81024a594b$export$c463b51fb31743f5 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mLegalFooter, LitElement);
    var _super = (0, $ohfOJ._)(W3mLegalFooter);
    function W3mLegalFooter() {
        (0, $4GJKx._)(this, W3mLegalFooter);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(W3mLegalFooter, [
        {
            key: "render",
            value: function render() {
                var _OptionsController_state = (0, $faNff.OptionsController).state, termsConditionsUrl = _OptionsController_state.termsConditionsUrl, privacyPolicyUrl = _OptionsController_state.privacyPolicyUrl;
                if (!termsConditionsUrl && !privacyPolicyUrl) return null;
                return (0, $hxyOZ.html)($f5919d81024a594b$var$_templateObject(), [
                    "m",
                    "s",
                    "s",
                    "s"
                ], this.termsTemplate(), this.andTemplate(), this.privacyTemplate());
            }
        },
        {
            key: "andTemplate",
            value: function andTemplate() {
                var _OptionsController_state = (0, $faNff.OptionsController).state, termsConditionsUrl = _OptionsController_state.termsConditionsUrl, privacyPolicyUrl = _OptionsController_state.privacyPolicyUrl;
                return termsConditionsUrl && privacyPolicyUrl ? "and" : "";
            }
        },
        {
            key: "termsTemplate",
            value: function termsTemplate() {
                var termsConditionsUrl = (0, $faNff.OptionsController).state.termsConditionsUrl;
                if (!termsConditionsUrl) return null;
                return (0, $hxyOZ.html)($f5919d81024a594b$var$_templateObject1(), termsConditionsUrl);
            }
        },
        {
            key: "privacyTemplate",
            value: function privacyTemplate() {
                var privacyPolicyUrl = (0, $faNff.OptionsController).state.privacyPolicyUrl;
                if (!privacyPolicyUrl) return null;
                return (0, $hxyOZ.html)($f5919d81024a594b$var$_templateObject2(), privacyPolicyUrl);
            }
        }
    ]);
    return W3mLegalFooter;
}((0, $2yD3e.LitElement));
$f5919d81024a594b$export$c463b51fb31743f5.styles = [
    (0, $6771390cff1131d6$export$2e2bcd8739ae039)
];
$f5919d81024a594b$export$c463b51fb31743f5 = $f5919d81024a594b$var$__decorate([
    (0, $hdxb6.customElement)("w3m-legal-footer")
], $f5919d81024a594b$export$c463b51fb31743f5);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $hZBJb = parcelRequire("hZBJb");
var $iptjJ = parcelRequire("iptjJ");
parcelRequire("grHtr");
var $dI7zX = parcelRequire("dI7zX");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $04kNM = parcelRequire("04kNM");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $dc05d884306564cf$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: block;\n    padding: 0 var(--wui-spacing-xl) var(--wui-spacing-xl);\n  }\n"
    ]);
    $dc05d884306564cf$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $dc05d884306564cf$export$2e2bcd8739ae039 = (0, $2D5eP.css)($dc05d884306564cf$var$_templateObject());


function $40cde58b26659b71$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n        <wui-cta-button\n          label=",
        '\n          buttonLabel="Get"\n          @click=',
        "\n        ></wui-cta-button>\n      "
    ]);
    $40cde58b26659b71$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $40cde58b26659b71$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "\n        <wui-cta-button\n          label=",
        '\n          buttonLabel="Get"\n          @click=',
        "\n        ></wui-cta-button>\n      "
    ]);
    $40cde58b26659b71$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $40cde58b26659b71$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "\n        <wui-cta-button\n          label=",
        '\n          buttonLabel="Get"\n          @click=',
        "\n        ></wui-cta-button>\n      "
    ]);
    $40cde58b26659b71$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $40cde58b26659b71$var$_templateObject3() {
    var data = (0, $j06k0._)([
        "\n        <wui-cta-button\n          label=",
        '\n          buttonLabel="Get"\n          @click=',
        "\n        ></wui-cta-button>\n      "
    ]);
    $40cde58b26659b71$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var $40cde58b26659b71$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $40cde58b26659b71$export$eabbdf5c2372470b = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mMobileDownloadLinks, LitElement);
    var _super = (0, $ohfOJ._)(W3mMobileDownloadLinks);
    function W3mMobileDownloadLinks() {
        (0, $4GJKx._)(this, W3mMobileDownloadLinks);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.wallet = undefined;
        return _this;
    }
    (0, $1wc17._)(W3mMobileDownloadLinks, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                if (!this.wallet) {
                    this.style.display = "none";
                    return null;
                }
                var _this_wallet = this.wallet, name = _this_wallet.name, app_store = _this_wallet.app_store, play_store = _this_wallet.play_store, chrome_store = _this_wallet.chrome_store, homepage = _this_wallet.homepage;
                var isMobile = (0, $hZBJb.CoreHelperUtil).isMobile();
                var isIos = (0, $hZBJb.CoreHelperUtil).isIos();
                var isAndroid = (0, $hZBJb.CoreHelperUtil).isAndroid();
                var isMultiple = [
                    app_store,
                    play_store,
                    homepage,
                    chrome_store
                ].filter(Boolean).length > 1;
                var shortName = (0, $dI7zX.UiHelperUtil).getTruncateString({
                    string: name,
                    charsStart: 12,
                    charsEnd: 0,
                    truncate: "end"
                });
                if (isMultiple && !isMobile) return (0, $hxyOZ.html)($40cde58b26659b71$var$_templateObject(), "Don't have ".concat(shortName, "?"), function() {
                    return (0, $iptjJ.RouterController).push("Downloads", {
                        wallet: _this.wallet
                    });
                });
                if (!isMultiple && homepage) return (0, $hxyOZ.html)($40cde58b26659b71$var$_templateObject1(), "Don't have ".concat(shortName, "?"), this.onHomePage.bind(this));
                if (app_store && isIos) return (0, $hxyOZ.html)($40cde58b26659b71$var$_templateObject2(), "Don't have ".concat(shortName, "?"), this.onAppStore.bind(this));
                if (play_store && isAndroid) return (0, $hxyOZ.html)($40cde58b26659b71$var$_templateObject3(), "Don't have ".concat(shortName, "?"), this.onPlayStore.bind(this));
                this.style.display = "none";
                return null;
            }
        },
        {
            key: "onAppStore",
            value: function onAppStore() {
                var _this_wallet;
                if ((_this_wallet = this.wallet) === null || _this_wallet === void 0 ? void 0 : _this_wallet.app_store) (0, $hZBJb.CoreHelperUtil).openHref(this.wallet.app_store, "_blank");
            }
        },
        {
            key: "onPlayStore",
            value: function onPlayStore() {
                var _this_wallet;
                if ((_this_wallet = this.wallet) === null || _this_wallet === void 0 ? void 0 : _this_wallet.play_store) (0, $hZBJb.CoreHelperUtil).openHref(this.wallet.play_store, "_blank");
            }
        },
        {
            key: "onHomePage",
            value: function onHomePage() {
                var _this_wallet;
                if ((_this_wallet = this.wallet) === null || _this_wallet === void 0 ? void 0 : _this_wallet.homepage) (0, $hZBJb.CoreHelperUtil).openHref(this.wallet.homepage, "_blank");
            }
        }
    ]);
    return W3mMobileDownloadLinks;
}((0, $2yD3e.LitElement));
$40cde58b26659b71$export$eabbdf5c2372470b.styles = [
    (0, $dc05d884306564cf$export$2e2bcd8739ae039)
];
$40cde58b26659b71$var$__decorate([
    (0, $04kNM.property)({
        type: Object
    })
], $40cde58b26659b71$export$eabbdf5c2372470b.prototype, "wallet", void 0);
$40cde58b26659b71$export$eabbdf5c2372470b = $40cde58b26659b71$var$__decorate([
    (0, $hdxb6.customElement)("w3m-mobile-download-links")
], $40cde58b26659b71$export$eabbdf5c2372470b);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $faNff = parcelRequire("faNff");
var $1QDT9 = parcelRequire("1QDT9");
var $dMLJP = parcelRequire("dMLJP");
var $iptjJ = parcelRequire("iptjJ");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $88f032c56bf3520a$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  wui-flex {\n    border-top: 1px solid var(--wui-color-gray-glass-005);\n  }\n\n  a {\n    text-decoration: none;\n    color: var(--wui-color-fg-175);\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: var(--wui-spacing-3xs);\n  }\n"
    ]);
    $88f032c56bf3520a$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $88f032c56bf3520a$export$2e2bcd8739ae039 = (0, $2D5eP.css)($88f032c56bf3520a$var$_templateObject());


parcelRequire("hsyMZ");
var $cSJ4o = parcelRequire("cSJ4o");
function $8ed9c148736bdd98$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      <wui-flex\n        .padding=",
        '\n        flexDirection="column"\n        alignItems="center"\n        justifyContent="center"\n        gap="s"\n      >\n        <wui-text color="fg-250" variant="small-400" align="center">\n          We work with the best providers to give you the lowest fees and best support. More options\n          coming soon!\n        </wui-text>\n\n        ',
        "\n      </wui-flex>\n    "
    ]);
    $8ed9c148736bdd98$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $8ed9c148736bdd98$var$_templateObject1() {
    var data = (0, $j06k0._)([
        " <wui-link @click=",
        '>\n      <wui-icon size="xs" color="accent-100" slot="iconLeft" name="helpCircle"></wui-icon>\n      How does it work?\n    </wui-link>'
    ]);
    $8ed9c148736bdd98$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $8ed9c148736bdd98$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $8ed9c148736bdd98$export$1877b66553939a5b = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mOnRampProvidersFooter, LitElement);
    var _super = (0, $ohfOJ._)(W3mOnRampProvidersFooter);
    function W3mOnRampProvidersFooter() {
        (0, $4GJKx._)(this, W3mOnRampProvidersFooter);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(W3mOnRampProvidersFooter, [
        {
            key: "render",
            value: function render() {
                var _OptionsController_state = (0, $faNff.OptionsController).state, termsConditionsUrl = _OptionsController_state.termsConditionsUrl, privacyPolicyUrl = _OptionsController_state.privacyPolicyUrl;
                if (!termsConditionsUrl && !privacyPolicyUrl) return null;
                return (0, $hxyOZ.html)($8ed9c148736bdd98$var$_templateObject(), [
                    "m",
                    "s",
                    "s",
                    "s"
                ], this.howDoesItWorkTemplate());
            }
        },
        {
            key: "howDoesItWorkTemplate",
            value: function howDoesItWorkTemplate() {
                return (0, $hxyOZ.html)($8ed9c148736bdd98$var$_templateObject1(), this.onWhatIsBuy.bind(this));
            }
        },
        {
            key: "onWhatIsBuy",
            value: function onWhatIsBuy() {
                (0, $1QDT9.EventsController).sendEvent({
                    type: "track",
                    event: "SELECT_WHAT_IS_A_BUY",
                    properties: {
                        isSmartAccount: (0, $dMLJP.AccountController).state.preferredAccountType === (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT
                    }
                });
                (0, $iptjJ.RouterController).push("WhatIsABuy");
            }
        }
    ]);
    return W3mOnRampProvidersFooter;
}((0, $2yD3e.LitElement));
$8ed9c148736bdd98$export$1877b66553939a5b.styles = [
    (0, $88f032c56bf3520a$export$2e2bcd8739ae039)
];
$8ed9c148736bdd98$export$1877b66553939a5b = $8ed9c148736bdd98$var$__decorate([
    (0, $hdxb6.customElement)("w3m-onramp-providers-footer")
], $8ed9c148736bdd98$export$1877b66553939a5b);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $8FcCV = parcelRequire("8FcCV");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $e87e9c6797a34367$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: block;\n    position: absolute;\n    opacity: 0;\n    pointer-events: none;\n    top: 11px;\n    left: 50%;\n    width: max-content;\n  }\n"
    ]);
    $e87e9c6797a34367$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $e87e9c6797a34367$export$2e2bcd8739ae039 = (0, $2D5eP.css)($e87e9c6797a34367$var$_templateObject());


function $23ae8823d545f1d6$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      <wui-snackbar\n        message=",
        "\n        backgroundColor=",
        "\n        iconColor=",
        "\n        icon=",
        "\n        .loading=",
        "\n      ></wui-snackbar>\n    "
    ]);
    $23ae8823d545f1d6$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $23ae8823d545f1d6$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $23ae8823d545f1d6$var$presets = {
    loading: undefined,
    success: {
        backgroundColor: "success-100",
        iconColor: "success-100",
        icon: "checkmark"
    },
    error: {
        backgroundColor: "error-100",
        iconColor: "error-100",
        icon: "close"
    }
};
var $23ae8823d545f1d6$export$a84538312ac1ab9d = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mSnackBar, LitElement);
    var _super = (0, $ohfOJ._)(W3mSnackBar);
    function W3mSnackBar() {
        (0, $4GJKx._)(this, W3mSnackBar);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.timeout = undefined;
        _this.open = (0, $8FcCV.SnackController).state.open;
        _this.unsubscribe.push((0, $8FcCV.SnackController).subscribeKey("open", function(val) {
            _this.open = val;
            _this.onOpen();
        }));
        return _this;
    }
    (0, $1wc17._)(W3mSnackBar, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                clearTimeout(this.timeout);
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _SnackController_state = (0, $8FcCV.SnackController).state, message = _SnackController_state.message, variant = _SnackController_state.variant;
                var preset = $23ae8823d545f1d6$var$presets[variant];
                return (0, $hxyOZ.html)($23ae8823d545f1d6$var$_templateObject(), message, preset === null || preset === void 0 ? void 0 : preset.backgroundColor, preset === null || preset === void 0 ? void 0 : preset.iconColor, preset === null || preset === void 0 ? void 0 : preset.icon, variant === "loading");
            }
        },
        {
            key: "onOpen",
            value: function onOpen() {
                clearTimeout(this.timeout);
                if (this.open) {
                    this.animate([
                        {
                            opacity: 0,
                            transform: "translateX(-50%) scale(0.85)"
                        },
                        {
                            opacity: 1,
                            transform: "translateX(-50%) scale(1)"
                        }
                    ], {
                        duration: 150,
                        fill: "forwards",
                        easing: "ease"
                    });
                    this.timeout = setTimeout(function() {
                        return (0, $8FcCV.SnackController).hide();
                    }, 2500);
                } else this.animate([
                    {
                        opacity: 1,
                        transform: "translateX(-50%) scale(1)"
                    },
                    {
                        opacity: 0,
                        transform: "translateX(-50%) scale(0.85)"
                    }
                ], {
                    duration: 150,
                    fill: "forwards",
                    easing: "ease"
                });
            }
        }
    ]);
    return W3mSnackBar;
}((0, $2yD3e.LitElement));
$23ae8823d545f1d6$export$a84538312ac1ab9d.styles = (0, $e87e9c6797a34367$export$2e2bcd8739ae039);
$23ae8823d545f1d6$var$__decorate([
    (0, $334Pv.state)()
], $23ae8823d545f1d6$export$a84538312ac1ab9d.prototype, "open", void 0);
$23ae8823d545f1d6$export$a84538312ac1ab9d = $23ae8823d545f1d6$var$__decorate([
    (0, $hdxb6.customElement)("w3m-snackbar")
], $23ae8823d545f1d6$export$a84538312ac1ab9d);



var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("cwWZ7");
var $2qlRb = parcelRequire("2qlRb");
var $9zDWP = parcelRequire("9zDWP");
var $iptjJ = parcelRequire("iptjJ");
var $1QDT9 = parcelRequire("1QDT9");
var $hZBJb = parcelRequire("hZBJb");
var $8FcCV = parcelRequire("8FcCV");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");


var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $1cd230faadadc1e9$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  wui-separator {\n    margin: var(--wui-spacing-s) calc(var(--wui-spacing-s) * -1);\n    width: calc(100% + var(--wui-spacing-s) * 2);\n  }\n\n  wui-email-input {\n    width: 100%;\n  }\n\n  form {\n    width: 100%;\n    display: block;\n    position: relative;\n  }\n\n  wui-icon-link,\n  wui-loading-spinner {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  wui-icon-link {\n    right: var(--wui-spacing-xs);\n  }\n\n  wui-loading-spinner {\n    right: var(--wui-spacing-m);\n  }\n"
    ]);
    $1cd230faadadc1e9$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $1cd230faadadc1e9$export$2e2bcd8739ae039 = (0, $2D5eP.css)($1cd230faadadc1e9$var$_templateObject());


parcelRequire("dSKxG");
var $3QZC1 = parcelRequire("3QZC1");
function $08a7f7810d7a6d28$var$_templateObject() {
    var data = (0, $j06k0._)([
        "<wui-flex .padding=",
        '>\n            <wui-separator text="or"></wui-separator>\n          </wui-flex>'
    ]);
    $08a7f7810d7a6d28$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $08a7f7810d7a6d28$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "\n      <form ",
        " @submit=",
        ">\n        <wui-email-input\n          @focus=",
        "\n          .disabled=",
        "\n          @inputChange=",
        "\n          .errorMessage=",
        "\n        >\n        </wui-email-input>\n\n        ",
        "",
        '\n        <input type="submit" hidden />\n      </form>\n\n      ',
        "\n    "
    ]);
    $08a7f7810d7a6d28$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $08a7f7810d7a6d28$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '\n          <wui-icon-link\n            size="sm"\n            icon="chevronRight"\n            iconcolor="accent-100"\n            @click=',
        "\n          >\n          </wui-icon-link>\n        "
    ]);
    $08a7f7810d7a6d28$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $08a7f7810d7a6d28$var$_templateObject3() {
    var data = (0, $j06k0._)([
        '<wui-loading-spinner size="md" color="accent-100"></wui-loading-spinner>'
    ]);
    $08a7f7810d7a6d28$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var $08a7f7810d7a6d28$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $08a7f7810d7a6d28$export$73f53e8345d3576d = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mEmailLoginWidget, LitElement);
    var _super = (0, $ohfOJ._)(W3mEmailLoginWidget);
    function W3mEmailLoginWidget() {
        (0, $4GJKx._)(this, W3mEmailLoginWidget);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.formRef = (0, $89642349f29deca8$export$7d1e3a5e95ceca43)();
        _this.connectors = (0, $2qlRb.ConnectorController).state.connectors;
        _this.email = "";
        _this.loading = false;
        _this.error = "";
        _this.unsubscribe.push((0, $2qlRb.ConnectorController).subscribeKey("connectors", function(val) {
            return _this.connectors = val;
        }));
        return _this;
    }
    (0, $1wc17._)(W3mEmailLoginWidget, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "firstUpdated",
            value: function firstUpdated() {
                var _this = this;
                var _this_formRef_value;
                (_this_formRef_value = this.formRef.value) === null || _this_formRef_value === void 0 ? void 0 : _this_formRef_value.addEventListener("keydown", function(event) {
                    if (event.key === "Enter") _this.onSubmitEmail(event);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var connector = this.connectors.find(function(c) {
                    return c.type === "AUTH";
                });
                var multipleConnectors = this.connectors.length > 1;
                if (!(connector === null || connector === void 0 ? void 0 : connector.email)) return null;
                return (0, $hxyOZ.html)($08a7f7810d7a6d28$var$_templateObject1(), (0, $89642349f29deca8$export$eff4d24c3ff7876e)(this.formRef), this.onSubmitEmail.bind(this), this.onFocusEvent.bind(this), this.loading, this.onEmailInputChange.bind(this), this.error, this.submitButtonTemplate(), this.loadingTemplate(), connector.socials || !multipleConnectors ? null : (0, $hxyOZ.html)($08a7f7810d7a6d28$var$_templateObject(), [
                    "xxs",
                    "0",
                    "0",
                    "0"
                ]));
            }
        },
        {
            key: "submitButtonTemplate",
            value: function submitButtonTemplate() {
                var showSubmit = !this.loading && this.email.length > 3;
                return showSubmit ? (0, $hxyOZ.html)($08a7f7810d7a6d28$var$_templateObject2(), this.onSubmitEmail.bind(this)) : null;
            }
        },
        {
            key: "loadingTemplate",
            value: function loadingTemplate() {
                return this.loading ? (0, $hxyOZ.html)($08a7f7810d7a6d28$var$_templateObject3()) : null;
            }
        },
        {
            key: "onEmailInputChange",
            value: function onEmailInputChange(event) {
                this.email = event.detail.trim();
                this.error = "";
            }
        },
        {
            key: "onSubmitEmail",
            value: function onSubmitEmail(event) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var availableChains, isAvailableChain, authConnector, action, error, parsedError;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                availableChains = [
                                    (0, $3QZC1.ConstantsUtil).CHAIN.EVM,
                                    (0, $3QZC1.ConstantsUtil).CHAIN.SOLANA
                                ];
                                isAvailableChain = availableChains.find(function(chain) {
                                    return chain === (0, $9zDWP.ChainController).state.activeChain;
                                });
                                if (!isAvailableChain) {
                                    (0, $iptjJ.RouterController).push("SwitchActiveChain", {
                                        switchToChain: (0, $3QZC1.ConstantsUtil).CHAIN.EVM
                                    });
                                    return [
                                        2
                                    ];
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    4,
                                    5
                                ]);
                                if (_this.loading) return [
                                    2
                                ];
                                _this.loading = true;
                                event.preventDefault();
                                authConnector = (0, $2qlRb.ConnectorController).getAuthConnector();
                                if (!authConnector) throw new Error("w3m-email-login-widget: Auth connector not found");
                                return [
                                    4,
                                    authConnector.provider.connectEmail({
                                        email: _this.email
                                    })
                                ];
                            case 2:
                                action = _state.sent().action;
                                (0, $1QDT9.EventsController).sendEvent({
                                    type: "track",
                                    event: "EMAIL_SUBMITTED"
                                });
                                if (action === "VERIFY_OTP") {
                                    (0, $1QDT9.EventsController).sendEvent({
                                        type: "track",
                                        event: "EMAIL_VERIFICATION_CODE_SENT"
                                    });
                                    (0, $iptjJ.RouterController).push("EmailVerifyOtp", {
                                        email: _this.email
                                    });
                                } else if (action === "VERIFY_DEVICE") (0, $iptjJ.RouterController).push("EmailVerifyDevice", {
                                    email: _this.email
                                });
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                error = _state.sent();
                                parsedError = (0, $hZBJb.CoreHelperUtil).parseError(error);
                                if (parsedError === null || parsedError === void 0 ? void 0 : parsedError.includes("Invalid email")) _this.error = "Invalid email. Try again.";
                                else (0, $8FcCV.SnackController).showError(error);
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                _this.loading = false;
                                return [
                                    7
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onFocusEvent",
            value: function onFocusEvent() {
                (0, $1QDT9.EventsController).sendEvent({
                    type: "track",
                    event: "EMAIL_LOGIN_SELECTED"
                });
            }
        }
    ]);
    return W3mEmailLoginWidget;
}((0, $2yD3e.LitElement));
$08a7f7810d7a6d28$export$73f53e8345d3576d.styles = (0, $1cd230faadadc1e9$export$2e2bcd8739ae039);
$08a7f7810d7a6d28$var$__decorate([
    (0, $334Pv.state)()
], $08a7f7810d7a6d28$export$73f53e8345d3576d.prototype, "connectors", void 0);
$08a7f7810d7a6d28$var$__decorate([
    (0, $334Pv.state)()
], $08a7f7810d7a6d28$export$73f53e8345d3576d.prototype, "email", void 0);
$08a7f7810d7a6d28$var$__decorate([
    (0, $334Pv.state)()
], $08a7f7810d7a6d28$export$73f53e8345d3576d.prototype, "loading", void 0);
$08a7f7810d7a6d28$var$__decorate([
    (0, $334Pv.state)()
], $08a7f7810d7a6d28$export$73f53e8345d3576d.prototype, "error", void 0);
$08a7f7810d7a6d28$export$73f53e8345d3576d = $08a7f7810d7a6d28$var$__decorate([
    (0, $hdxb6.customElement)("w3m-email-login-widget")
], $08a7f7810d7a6d28$export$73f53e8345d3576d);



var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("cwWZ7");
var $dMLJP = parcelRequire("dMLJP");
var $8FcCV = parcelRequire("8FcCV");
var $9zDWP = parcelRequire("9zDWP");
var $hZBJb = parcelRequire("hZBJb");
var $faNff = parcelRequire("faNff");
var $i7zcD = parcelRequire("i7zcD");
var $2qlRb = parcelRequire("2qlRb");
var $2sXdV = parcelRequire("2sXdV");
var $iptjJ = parcelRequire("iptjJ");
var $1QDT9 = parcelRequire("1QDT9");
var $3cYIS = parcelRequire("3cYIS");
var $5Lhe6 = parcelRequire("5Lhe6");
parcelRequire("grHtr");
var $dI7zX = parcelRequire("dI7zX");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");

parcelRequire("dSKxG");
var $3QZC1 = parcelRequire("3QZC1");
parcelRequire("hsyMZ");
var $cSJ4o = parcelRequire("cSJ4o");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $f3e312db9731d2b3$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  wui-flex {\n    width: 100%;\n  }\n\n  :host > wui-flex:first-child {\n    transform: translateY(calc(var(--wui-spacing-xxs) * -1));\n  }\n\n  wui-icon-link {\n    margin-right: calc(var(--wui-icon-box-size-md) * -1);\n  }\n\n  wui-notice-card {\n    margin-bottom: var(--wui-spacing-3xs);\n  }\n\n  wui-list-item > wui-text {\n    flex: 1;\n  }\n\n  w3m-transactions-view {\n    max-height: 200px;\n  }\n\n  .tab-content-container {\n    height: 300px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    scrollbar-width: none;\n  }\n\n  .tab-content-container::-webkit-scrollbar {\n    display: none;\n  }\n\n  .account-button {\n    width: auto;\n    border: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: var(--wui-spacing-s);\n    height: 48px;\n    padding: var(--wui-spacing-xs);\n    padding-right: var(--wui-spacing-s);\n    box-shadow: inset 0 0 0 1px var(--wui-color-gray-glass-002);\n    background-color: var(--wui-color-gray-glass-002);\n    border-radius: 24px;\n    transition: background-color 0.2s linear;\n  }\n\n  .account-button:hover {\n    background-color: var(--wui-color-gray-glass-005);\n  }\n\n  .avatar-container {\n    position: relative;\n  }\n\n  wui-avatar.avatar {\n    width: 32px;\n    height: 32px;\n    box-shadow: 0 0 0 2px var(--wui-color-gray-glass-005);\n  }\n\n  wui-avatar.network-avatar {\n    width: 16px;\n    height: 16px;\n    position: absolute;\n    left: 100%;\n    top: 100%;\n    transform: translate(-75%, -75%);\n    box-shadow: 0 0 0 2px var(--wui-color-gray-glass-005);\n  }\n\n  .account-links {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .account-links wui-flex {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex: 1;\n    background: red;\n    align-items: center;\n    justify-content: center;\n    height: 48px;\n    padding: 10px;\n    flex: 1 0 0;\n    border-radius: var(--XS, 16px);\n    border: 1px solid var(--dark-accent-glass-010, rgba(71, 161, 255, 0.1));\n    background: var(--dark-accent-glass-010, rgba(71, 161, 255, 0.1));\n    transition:\n      background-color var(--wui-ease-out-power-1) var(--wui-duration-md),\n      opacity var(--wui-ease-out-power-1) var(--wui-duration-md);\n    will-change: background-color, opacity;\n  }\n\n  .account-links wui-flex:hover {\n    background: var(--dark-accent-glass-015, rgba(71, 161, 255, 0.15));\n  }\n\n  .account-links wui-flex wui-icon {\n    width: var(--S, 20px);\n    height: var(--S, 20px);\n  }\n\n  .account-links wui-flex wui-icon svg path {\n    stroke: #667dff;\n  }\n"
    ]);
    $f3e312db9731d2b3$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $f3e312db9731d2b3$export$2e2bcd8739ae039 = (0, $2D5eP.css)($f3e312db9731d2b3$var$_templateObject());


function $81f1b652a7ff9edb$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<wui-flex\n        flexDirection="column"\n        .padding=',
        '\n        alignItems="center"\n        gap="l"\n      >\n        ',
        '\n        <wui-flex flexDirection="column" alignItems="center">\n          <wui-text variant="paragraph-500" color="fg-200">\n            ',
        "\n          </wui-text>\n        </wui-flex>\n        ",
        '\n      </wui-flex>\n\n      <wui-flex flexDirection="column" gap="xs" .padding=',
        ">\n        ",
        " <w3m-account-auth-button></w3m-account-auth-button>\n        ",
        " ",
        " ",
        '\n        <wui-list-item\n          variant="icon"\n          iconVariant="overlay"\n          icon="disconnect"\n          ?chevron=',
        "\n          .loading=",
        "\n          @click=",
        '\n          data-testid="disconnect-button"\n        >\n          <wui-text variant="paragraph-500" color="fg-200">Disconnect</wui-text>\n        </wui-list-item>\n      </wui-flex>'
    ]);
    $81f1b652a7ff9edb$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $81f1b652a7ff9edb$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '\n      <wui-list-item\n        data-testid="w3m-account-default-onramp-button"\n        iconVariant="blue"\n        icon="card"\n        ?chevron=',
        "\n        @click=",
        '\n      >\n        <wui-text variant="paragraph-500" color="fg-100">Buy crypto</wui-text>\n      </wui-list-item>\n    '
    ]);
    $81f1b652a7ff9edb$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $81f1b652a7ff9edb$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '<wui-tag variant="main">Coming soon</wui-tag>'
    ]);
    $81f1b652a7ff9edb$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $81f1b652a7ff9edb$var$_templateObject3() {
    var data = (0, $j06k0._)([
        ' <wui-list-item\n      iconVariant="blue"\n      icon="clock"\n      iconSize="sm"\n      ?chevron=',
        "\n      ?disabled=",
        "\n      @click=",
        '\n    >\n      <wui-text variant="paragraph-500" color="fg-100" ?disabled=',
        "> Activity </wui-text>\n      ",
        "\n    </wui-list-item>"
    ]);
    $81f1b652a7ff9edb$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $81f1b652a7ff9edb$var$_templateObject4() {
    var data = (0, $j06k0._)([
        '\n      <wui-list-item\n        iconVariant="blue"\n        icon="recycleHorizontal"\n        ?chevron=',
        "\n        @click=",
        '\n      >\n        <wui-text variant="paragraph-500" color="fg-100">Swap</wui-text>\n      </wui-list-item>\n    '
    ]);
    $81f1b652a7ff9edb$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $81f1b652a7ff9edb$var$_templateObject5() {
    var data = (0, $j06k0._)([
        "\n      <wui-notice-card\n        @click=",
        '\n        label="Upgrade your wallet"\n        description="Transition to a self-custodial wallet"\n        icon="wallet"\n        data-testid="w3m-wallet-upgrade-card"\n      ></wui-notice-card>\n    '
    ]);
    $81f1b652a7ff9edb$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $81f1b652a7ff9edb$var$_templateObject6() {
    var data = (0, $j06k0._)([
        '\n      <wui-button size="md" variant="neutral" @click=',
        '>\n        <wui-icon size="sm" color="inherit" slot="iconLeft" name="compass"></wui-icon>\n        Block Explorer\n        <wui-icon size="sm" color="inherit" slot="iconRight" name="externalLink"></wui-icon>\n      </wui-button>\n    '
    ]);
    $81f1b652a7ff9edb$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $81f1b652a7ff9edb$var$_templateObject7() {
    var data = (0, $j06k0._)([
        "\n      <wui-avatar\n        alt=",
        "\n        address=",
        "\n        imageSrc=",
        '\n      ></wui-avatar>\n      <wui-flex flexDirection="column" alignItems="center">\n        <wui-flex gap="3xs" alignItems="center" justifyContent="center">\n          <wui-text variant="large-600" color="fg-100">\n            ',
        '\n          </wui-text>\n          <wui-icon-link\n            size="md"\n            icon="copy"\n            iconColor="fg-200"\n            @click=',
        "\n          ></wui-icon-link> </wui-flex\n      ></wui-flex>\n    "
    ]);
    $81f1b652a7ff9edb$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $81f1b652a7ff9edb$var$_templateObject8() {
    var data = (0, $j06k0._)([
        "\n      <wui-profile-button-v2\n        .onProfileClick=",
        "\n        address=",
        '\n        icon="',
        '"\n        avatarSrc=',
        "\n        profileName=",
        "\n        .onCopyClick=",
        "\n      ></wui-profile-button-v2>\n    "
    ]);
    $81f1b652a7ff9edb$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
var $81f1b652a7ff9edb$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $81f1b652a7ff9edb$export$6c58fb2c5893d9b3 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mAccountDefaultWidget, LitElement);
    var _super = (0, $ohfOJ._)(W3mAccountDefaultWidget);
    function W3mAccountDefaultWidget() {
        var _this_unsubscribe;
        (0, $4GJKx._)(this, W3mAccountDefaultWidget);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.address = (0, $dMLJP.AccountController).state.address;
        _this.profileImage = (0, $dMLJP.AccountController).state.profileImage;
        _this.profileName = (0, $dMLJP.AccountController).state.profileName;
        _this.disconnecting = false;
        _this.balance = (0, $dMLJP.AccountController).state.balance;
        _this.balanceSymbol = (0, $dMLJP.AccountController).state.balanceSymbol;
        (_this_unsubscribe = _this.unsubscribe).push.apply(_this_unsubscribe, [
            (0, $dMLJP.AccountController).subscribe(function(val) {
                if (val.address) {
                    _this.address = val.address;
                    _this.profileImage = val.profileImage;
                    _this.profileName = val.profileName;
                    _this.balance = val.balance;
                    _this.balanceSymbol = val.balanceSymbol;
                } else if (!_this.disconnecting) (0, $8FcCV.SnackController).showError("Account not found");
            })
        ]);
        return _this;
    }
    (0, $1wc17._)(W3mAccountDefaultWidget, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                if (!this.address) throw new Error("w3m-account-view: No account provided");
                return (0, $hxyOZ.html)($81f1b652a7ff9edb$var$_templateObject(), [
                    "0",
                    "xl",
                    "m",
                    "xl"
                ], (0, $9zDWP.ChainController).state.activeChain === (0, $3QZC1.ConstantsUtil).CHAIN.EVM ? this.multiAccountTemplate() : this.singleAccountTemplate(), (0, $hZBJb.CoreHelperUtil).formatBalance(this.balance, this.balanceSymbol), this.explorerBtnTemplate(), [
                    "0",
                    "s",
                    "s",
                    "s"
                ], this.authCardTemplate(), this.onrampTemplate(), this.swapsTemplate(), this.activityTemplate(), false, this.disconnecting, this.onDisconnect.bind(this));
            }
        },
        {
            key: "onrampTemplate",
            value: function onrampTemplate() {
                var enableOnramp = (0, $faNff.OptionsController).state.enableOnramp;
                var isSolana = (0, $9zDWP.ChainController).state.activeChain === (0, $3QZC1.ConstantsUtil).CHAIN.SOLANA;
                if (!enableOnramp || isSolana) return null;
                return (0, $hxyOZ.html)($81f1b652a7ff9edb$var$_templateObject1(), true, this.handleClickPay.bind(this));
            }
        },
        {
            key: "activityTemplate",
            value: function activityTemplate() {
                var isSolana = (0, $9zDWP.ChainController).state.activeChain === (0, $3QZC1.ConstantsUtil).CHAIN.SOLANA;
                return (0, $hxyOZ.html)($81f1b652a7ff9edb$var$_templateObject3(), !isSolana, isSolana, this.onTransactions.bind(this), isSolana, isSolana ? (0, $hxyOZ.html)($81f1b652a7ff9edb$var$_templateObject2()) : "");
            }
        },
        {
            key: "swapsTemplate",
            value: function swapsTemplate() {
                var enableSwaps = (0, $faNff.OptionsController).state.enableSwaps;
                if (!enableSwaps || (0, $9zDWP.ChainController).state.activeChain === (0, $3QZC1.ConstantsUtil).CHAIN.SOLANA) return null;
                return (0, $hxyOZ.html)($81f1b652a7ff9edb$var$_templateObject4(), true, this.handleClickSwap.bind(this));
            }
        },
        {
            key: "authCardTemplate",
            value: function authCardTemplate() {
                var type = (0, $i7zcD.StorageUtil).getConnectedConnector();
                var authConnector = (0, $2qlRb.ConnectorController).getAuthConnector();
                var origin = location.origin;
                if (!authConnector || type !== "AUTH" || origin.includes((0, $2sXdV.ConstantsUtil).SECURE_SITE)) return null;
                return (0, $hxyOZ.html)($81f1b652a7ff9edb$var$_templateObject5(), this.onGoToUpgradeView.bind(this));
            }
        },
        {
            key: "handleSwitchAccountsView",
            value: function handleSwitchAccountsView() {
                (0, $iptjJ.RouterController).push("SwitchAddress");
            }
        },
        {
            key: "handleClickPay",
            value: function handleClickPay() {
                (0, $iptjJ.RouterController).push("OnRampProviders");
            }
        },
        {
            key: "handleClickSwap",
            value: function handleClickSwap() {
                (0, $iptjJ.RouterController).push("Swap");
            }
        },
        {
            key: "explorerBtnTemplate",
            value: function explorerBtnTemplate() {
                var addressExplorerUrl = (0, $dMLJP.AccountController).state.addressExplorerUrl;
                if (!addressExplorerUrl) return null;
                return (0, $hxyOZ.html)($81f1b652a7ff9edb$var$_templateObject6(), this.onExplorer.bind(this));
            }
        },
        {
            key: "singleAccountTemplate",
            value: function singleAccountTemplate() {
                return (0, $hxyOZ.html)($81f1b652a7ff9edb$var$_templateObject7(), (0, $696d14fc702af3d6$export$f68dd208b5df064d)(this.address), (0, $696d14fc702af3d6$export$f68dd208b5df064d)(this.address), (0, $696d14fc702af3d6$export$f68dd208b5df064d)(this.profileImage === null ? undefined : this.profileImage), this.profileName ? (0, $dI7zX.UiHelperUtil).getTruncateString({
                    string: this.profileName,
                    charsStart: 20,
                    charsEnd: 0,
                    truncate: "end"
                }) : (0, $dI7zX.UiHelperUtil).getTruncateString({
                    string: this.address ? this.address : "",
                    charsStart: 4,
                    charsEnd: 4,
                    truncate: "middle"
                }), this.onCopyAddress);
            }
        },
        {
            key: "multiAccountTemplate",
            value: function multiAccountTemplate() {
                var _this = this;
                var _AccountController_state_allAccounts;
                if (!this.address) throw new Error("w3m-account-view: No account provided");
                var account = (_AccountController_state_allAccounts = (0, $dMLJP.AccountController).state.allAccounts) === null || _AccountController_state_allAccounts === void 0 ? void 0 : _AccountController_state_allAccounts.find(function(acc) {
                    return acc.address === _this.address;
                });
                var label = (0, $dMLJP.AccountController).state.addressLabels.get(this.address);
                return (0, $hxyOZ.html)($81f1b652a7ff9edb$var$_templateObject8(), this.handleSwitchAccountsView.bind(this), (0, $696d14fc702af3d6$export$f68dd208b5df064d)(this.address), (account === null || account === void 0 ? void 0 : account.type) === (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT && (0, $9zDWP.ChainController).state.activeChain === (0, $3QZC1.ConstantsUtil).CHAIN.EVM ? "lightbulb" : "mail", (0, $696d14fc702af3d6$export$f68dd208b5df064d)(this.profileImage ? this.profileImage : undefined), (0, $696d14fc702af3d6$export$f68dd208b5df064d)(label ? label : this.profileName), this.onCopyAddress.bind(this));
            }
        },
        {
            key: "onCopyAddress",
            value: function onCopyAddress() {
                try {
                    if (this.address) {
                        (0, $hZBJb.CoreHelperUtil).copyToClopboard(this.address);
                        (0, $8FcCV.SnackController).showSuccess("Address copied");
                    }
                } catch (e) {
                    (0, $8FcCV.SnackController).showError("Failed to copy");
                }
            }
        },
        {
            key: "onTransactions",
            value: function onTransactions() {
                (0, $1QDT9.EventsController).sendEvent({
                    type: "track",
                    event: "CLICK_TRANSACTIONS",
                    properties: {
                        isSmartAccount: (0, $dMLJP.AccountController).state.preferredAccountType === (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT
                    }
                });
                (0, $iptjJ.RouterController).push("Transactions");
            }
        },
        {
            key: "onDisconnect",
            value: function onDisconnect() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    3,
                                    4
                                ]);
                                _this.disconnecting = true;
                                return [
                                    4,
                                    (0, $3cYIS.ConnectionController).disconnect()
                                ];
                            case 1:
                                _state.sent();
                                (0, $1QDT9.EventsController).sendEvent({
                                    type: "track",
                                    event: "DISCONNECT_SUCCESS"
                                });
                                (0, $5Lhe6.ModalController).close();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                e = _state.sent();
                                (0, $1QDT9.EventsController).sendEvent({
                                    type: "track",
                                    event: "DISCONNECT_ERROR"
                                });
                                (0, $8FcCV.SnackController).showError("Failed to disconnect");
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                _this.disconnecting = false;
                                return [
                                    7
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onExplorer",
            value: function onExplorer() {
                var addressExplorerUrl = (0, $dMLJP.AccountController).state.addressExplorerUrl;
                if (addressExplorerUrl) (0, $hZBJb.CoreHelperUtil).openHref(addressExplorerUrl, "_blank");
            }
        },
        {
            key: "onGoToUpgradeView",
            value: function onGoToUpgradeView() {
                (0, $1QDT9.EventsController).sendEvent({
                    type: "track",
                    event: "EMAIL_UPGRADE_FROM_MODAL"
                });
                (0, $iptjJ.RouterController).push("UpgradeEmailWallet");
            }
        }
    ]);
    return W3mAccountDefaultWidget;
}((0, $2yD3e.LitElement));
$81f1b652a7ff9edb$export$6c58fb2c5893d9b3.styles = (0, $f3e312db9731d2b3$export$2e2bcd8739ae039);
$81f1b652a7ff9edb$var$__decorate([
    (0, $334Pv.state)()
], $81f1b652a7ff9edb$export$6c58fb2c5893d9b3.prototype, "address", void 0);
$81f1b652a7ff9edb$var$__decorate([
    (0, $334Pv.state)()
], $81f1b652a7ff9edb$export$6c58fb2c5893d9b3.prototype, "profileImage", void 0);
$81f1b652a7ff9edb$var$__decorate([
    (0, $334Pv.state)()
], $81f1b652a7ff9edb$export$6c58fb2c5893d9b3.prototype, "profileName", void 0);
$81f1b652a7ff9edb$var$__decorate([
    (0, $334Pv.state)()
], $81f1b652a7ff9edb$export$6c58fb2c5893d9b3.prototype, "disconnecting", void 0);
$81f1b652a7ff9edb$var$__decorate([
    (0, $334Pv.state)()
], $81f1b652a7ff9edb$export$6c58fb2c5893d9b3.prototype, "balance", void 0);
$81f1b652a7ff9edb$var$__decorate([
    (0, $334Pv.state)()
], $81f1b652a7ff9edb$export$6c58fb2c5893d9b3.prototype, "balanceSymbol", void 0);
$81f1b652a7ff9edb$export$6c58fb2c5893d9b3 = $81f1b652a7ff9edb$var$__decorate([
    (0, $hdxb6.customElement)("w3m-account-default-widget")
], $81f1b652a7ff9edb$export$6c58fb2c5893d9b3);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $dMLJP = parcelRequire("dMLJP");
var $fPqxb = parcelRequire("fPqxb");
var $5Lhe6 = parcelRequire("5Lhe6");
var $khm6W = parcelRequire("khm6W");
var $hZBJb = parcelRequire("hZBJb");
var $faNff = parcelRequire("faNff");
var $iptjJ = parcelRequire("iptjJ");
var $2sXdV = parcelRequire("2sXdV");
var $1QDT9 = parcelRequire("1QDT9");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");


var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $1a4f2a889d76ae66$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  wui-flex {\n    width: 100%;\n  }\n\n  wui-promo {\n    position: absolute;\n    top: -32px;\n  }\n\n  wui-profile-button {\n    margin-top: calc(-1 * var(--wui-spacing-2l));\n  }\n\n  wui-promo + wui-profile-button {\n    margin-top: var(--wui-spacing-2l);\n  }\n\n  wui-tabs {\n    width: 100%;\n  }\n\n  .contentContainer {\n    height: 280px;\n  }\n\n  .contentContainer > wui-icon-box {\n    width: 40px;\n    height: 40px;\n    border-radius: var(--wui-border-radius-xxs);\n  }\n\n  .contentContainer > .textContent {\n    width: 65%;\n  }\n"
    ]);
    $1a4f2a889d76ae66$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $1a4f2a889d76ae66$export$2e2bcd8739ae039 = (0, $2D5eP.css)($1a4f2a889d76ae66$var$_templateObject());



parcelRequire("hsyMZ");
var $cSJ4o = parcelRequire("cSJ4o");
function $7332acfb74187337$var$_templateObject() {
    var data = (0, $j06k0._)([
        "<wui-network-icon .network=",
        "></wui-network-icon>"
    ]);
    $7332acfb74187337$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $7332acfb74187337$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '<wui-flex\n      flexDirection="column"\n      .padding=',
        '\n      alignItems="center"\n      gap="m"\n    >\n      ',
        "\n      ",
        "\n      <wui-profile-button\n        @click=",
        "\n        address=",
        "\n        networkSrc=",
        '\n        icon="chevronBottom"\n        avatarSrc=',
        "\n        profileName=",
        '\n        data-testid="w3m-profile-button"\n      ></wui-profile-button>\n      ',
        '\n      <wui-flex gap="s">\n        <w3m-tooltip-trigger text="Buy">\n          <wui-icon-button\n            data-testid="wallet-features-onramp-button"\n            @click=',
        '\n            icon="card"\n          ></wui-icon-button>\n        </w3m-tooltip-trigger>\n        ',
        '\n        <w3m-tooltip-trigger text="Receive">\n          <wui-icon-button\n            data-testid="wallet-features-receive-button"\n            @click=',
        '\n            icon="arrowBottomCircle"\n          >\n          </wui-icon-button>\n        </w3m-tooltip-trigger>\n        <w3m-tooltip-trigger text="Send">\n          <wui-icon-button\n            data-testid="wallet-features-send-button"\n            @click=',
        '\n            icon="send"\n          ></wui-icon-button>\n        </w3m-tooltip-trigger>\n      </wui-flex>\n\n      <wui-tabs\n        .onTabChange=',
        "\n        .activeTab=",
        "\n        localTabWidth=",
        "\n        .tabs=",
        "\n      ></wui-tabs>\n      ",
        "\n    </wui-flex>"
    ]);
    $7332acfb74187337$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $7332acfb74187337$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '\n      <w3m-tooltip-trigger text="Swap">\n        <wui-icon-button\n          data-testid="wallet-features-swap-button"\n          @click=',
        '\n          icon="recycleHorizontal"\n        >\n        </wui-icon-button>\n      </w3m-tooltip-trigger>\n    '
    ]);
    $7332acfb74187337$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $7332acfb74187337$var$_templateObject3() {
    var data = (0, $j06k0._)([
        "<w3m-account-tokens-widget></w3m-account-tokens-widget>"
    ]);
    $7332acfb74187337$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $7332acfb74187337$var$_templateObject4() {
    var data = (0, $j06k0._)([
        "<w3m-account-nfts-widget></w3m-account-nfts-widget>"
    ]);
    $7332acfb74187337$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $7332acfb74187337$var$_templateObject5() {
    var data = (0, $j06k0._)([
        "<w3m-account-activity-widget></w3m-account-activity-widget>"
    ]);
    $7332acfb74187337$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $7332acfb74187337$var$_templateObject6() {
    var data = (0, $j06k0._)([
        "<w3m-account-tokens-widget></w3m-account-tokens-widget>"
    ]);
    $7332acfb74187337$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $7332acfb74187337$var$_templateObject7() {
    var data = (0, $j06k0._)([
        "<wui-balance dollars=",
        " pennies=",
        "></wui-balance>"
    ]);
    $7332acfb74187337$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $7332acfb74187337$var$_templateObject8() {
    var data = (0, $j06k0._)([
        '<wui-balance dollars="0" pennies="00"></wui-balance>'
    ]);
    $7332acfb74187337$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function $7332acfb74187337$var$_templateObject9() {
    var data = (0, $j06k0._)([
        " <wui-promo\n      text=",
        "\n      @click=",
        '\n      data-testid="activate-smart-account-promo"\n    ></wui-promo>'
    ]);
    $7332acfb74187337$var$_templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
var $7332acfb74187337$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $7332acfb74187337$var$TABS = 3;
var $7332acfb74187337$var$TABS_PADDING = 48;
var $7332acfb74187337$var$MODAL_MOBILE_VIEW_PX = 430;
var $7332acfb74187337$export$40fe2014a0a05eaf = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mAccountWalletFeaturesWidget, LitElement);
    var _super = (0, $ohfOJ._)(W3mAccountWalletFeaturesWidget);
    function W3mAccountWalletFeaturesWidget() {
        var _this_unsubscribe;
        (0, $4GJKx._)(this, W3mAccountWalletFeaturesWidget);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.address = (0, $dMLJP.AccountController).state.address;
        _this.profileImage = (0, $dMLJP.AccountController).state.profileImage;
        _this.profileName = (0, $dMLJP.AccountController).state.profileName;
        _this.smartAccountDeployed = (0, $dMLJP.AccountController).state.smartAccountDeployed;
        _this.network = (0, $fPqxb.NetworkController).state.caipNetwork;
        _this.currentTab = (0, $dMLJP.AccountController).state.currentTab;
        _this.tokenBalance = (0, $dMLJP.AccountController).state.tokenBalance;
        _this.preferredAccountType = (0, $dMLJP.AccountController).state.preferredAccountType;
        (_this_unsubscribe = _this.unsubscribe).push.apply(_this_unsubscribe, [
            (0, $dMLJP.AccountController).subscribe(function(val) {
                if (val.address) {
                    _this.address = val.address;
                    _this.profileImage = val.profileImage;
                    _this.profileName = val.profileName;
                    _this.currentTab = val.currentTab;
                    _this.tokenBalance = val.tokenBalance;
                    _this.smartAccountDeployed = val.smartAccountDeployed;
                    _this.preferredAccountType = val.preferredAccountType;
                } else (0, $5Lhe6.ModalController).close();
            }),
            (0, $fPqxb.NetworkController).subscribeKey("caipNetwork", function(val) {
                _this.network = val;
            })
        ]);
        _this.watchSwapValues();
        return _this;
    }
    (0, $1wc17._)(W3mAccountWalletFeaturesWidget, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
                clearInterval(this.watchTokenBalance);
            }
        },
        {
            key: "firstUpdated",
            value: function firstUpdated() {
                (0, $dMLJP.AccountController).fetchTokenBalance();
            }
        },
        {
            key: "render",
            value: function render() {
                if (!this.address) throw new Error("w3m-account-view: No account provided");
                var networkImage = (0, $khm6W.AssetUtil).getNetworkImage(this.network);
                return (0, $hxyOZ.html)($7332acfb74187337$var$_templateObject1(), [
                    "0",
                    "xl",
                    "m",
                    "xl"
                ], this.network && (0, $hxyOZ.html)($7332acfb74187337$var$_templateObject(), this.network), this.activateAccountTemplate(), this.onProfileButtonClick.bind(this), (0, $696d14fc702af3d6$export$f68dd208b5df064d)(this.address), (0, $696d14fc702af3d6$export$f68dd208b5df064d)(networkImage), (0, $696d14fc702af3d6$export$f68dd208b5df064d)(this.profileImage ? this.profileImage : undefined), this.profileName, this.tokenBalanceTemplate(), this.onBuyClick.bind(this), this.swapsTemplate(), this.onReceiveClick.bind(this), this.onSendClick.bind(this), this.onTabChange.bind(this), this.currentTab, (0, $hZBJb.CoreHelperUtil).isMobile() && window.innerWidth < $7332acfb74187337$var$MODAL_MOBILE_VIEW_PX ? "".concat((window.innerWidth - $7332acfb74187337$var$TABS_PADDING) / $7332acfb74187337$var$TABS, "px") : "104px", (0, $560364d27174f3fd$export$aafe1f751f1bc52a).ACCOUNT_TABS, this.listContentTemplate());
            }
        },
        {
            key: "swapsTemplate",
            value: function swapsTemplate() {
                var enableSwaps = (0, $faNff.OptionsController).state.enableSwaps;
                if (!enableSwaps) return null;
                return (0, $hxyOZ.html)($7332acfb74187337$var$_templateObject2(), this.onSwapClick.bind(this));
            }
        },
        {
            key: "watchSwapValues",
            value: function watchSwapValues() {
                this.watchTokenBalance = setInterval(function() {
                    return (0, $dMLJP.AccountController).fetchTokenBalance();
                }, 10000);
            }
        },
        {
            key: "listContentTemplate",
            value: function listContentTemplate() {
                if (this.currentTab === 0) return (0, $hxyOZ.html)($7332acfb74187337$var$_templateObject3());
                if (this.currentTab === 1) return (0, $hxyOZ.html)($7332acfb74187337$var$_templateObject4());
                if (this.currentTab === 2) return (0, $hxyOZ.html)($7332acfb74187337$var$_templateObject5());
                return (0, $hxyOZ.html)($7332acfb74187337$var$_templateObject6());
            }
        },
        {
            key: "tokenBalanceTemplate",
            value: function tokenBalanceTemplate() {
                var _this_tokenBalance;
                if (this.tokenBalance && ((_this_tokenBalance = this.tokenBalance) === null || _this_tokenBalance === void 0 ? void 0 : _this_tokenBalance.length) >= 0) {
                    var value = (0, $hZBJb.CoreHelperUtil).calculateBalance(this.tokenBalance);
                    var _CoreHelperUtil_formatTokenBalance = (0, $hZBJb.CoreHelperUtil).formatTokenBalance(value), _CoreHelperUtil_formatTokenBalance_dollars = _CoreHelperUtil_formatTokenBalance.dollars, dollars = _CoreHelperUtil_formatTokenBalance_dollars === void 0 ? "0" : _CoreHelperUtil_formatTokenBalance_dollars, _CoreHelperUtil_formatTokenBalance_pennies = _CoreHelperUtil_formatTokenBalance.pennies, pennies = _CoreHelperUtil_formatTokenBalance_pennies === void 0 ? "00" : _CoreHelperUtil_formatTokenBalance_pennies;
                    return (0, $hxyOZ.html)($7332acfb74187337$var$_templateObject7(), dollars, pennies);
                }
                return (0, $hxyOZ.html)($7332acfb74187337$var$_templateObject8());
            }
        },
        {
            key: "activateAccountTemplate",
            value: function activateAccountTemplate() {
                var smartAccountEnabled = (0, $fPqxb.NetworkController).checkIfSmartAccountEnabled();
                if (!smartAccountEnabled || this.preferredAccountType !== (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.EOA || this.smartAccountDeployed) return null;
                return (0, $hxyOZ.html)($7332acfb74187337$var$_templateObject9(), "Activate your account", this.onUpdateToSmartAccount.bind(this));
            }
        },
        {
            key: "onTabChange",
            value: function onTabChange(index) {
                (0, $dMLJP.AccountController).setCurrentTab(index);
            }
        },
        {
            key: "onProfileButtonClick",
            value: function onProfileButtonClick() {
                (0, $iptjJ.RouterController).push("Profile");
            }
        },
        {
            key: "onBuyClick",
            value: function onBuyClick() {
                (0, $iptjJ.RouterController).push("OnRampProviders");
            }
        },
        {
            key: "onSwapClick",
            value: function onSwapClick() {
                var _this_network, _this_network1;
                if (((_this_network = this.network) === null || _this_network === void 0 ? void 0 : _this_network.id) && !(0, $2sXdV.ConstantsUtil).SWAP_SUPPORTED_NETWORKS.includes((_this_network1 = this.network) === null || _this_network1 === void 0 ? void 0 : _this_network1.id)) (0, $iptjJ.RouterController).push("UnsupportedChain", {
                    swapUnsupportedChain: true
                });
                else {
                    var _this_network2;
                    (0, $1QDT9.EventsController).sendEvent({
                        type: "track",
                        event: "OPEN_SWAP",
                        properties: {
                            network: ((_this_network2 = this.network) === null || _this_network2 === void 0 ? void 0 : _this_network2.id) || "",
                            isSmartAccount: (0, $dMLJP.AccountController).state.preferredAccountType === (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT
                        }
                    });
                    (0, $iptjJ.RouterController).push("Swap");
                }
            }
        },
        {
            key: "onReceiveClick",
            value: function onReceiveClick() {
                (0, $iptjJ.RouterController).push("WalletReceive");
            }
        },
        {
            key: "onSendClick",
            value: function onSendClick() {
                var _this_network;
                (0, $1QDT9.EventsController).sendEvent({
                    type: "track",
                    event: "OPEN_SEND",
                    properties: {
                        network: ((_this_network = this.network) === null || _this_network === void 0 ? void 0 : _this_network.id) || "",
                        isSmartAccount: (0, $dMLJP.AccountController).state.preferredAccountType === (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT
                    }
                });
                (0, $iptjJ.RouterController).push("WalletSend");
            }
        },
        {
            key: "onUpdateToSmartAccount",
            value: function onUpdateToSmartAccount() {
                (0, $iptjJ.RouterController).push("UpgradeToSmartAccount");
            }
        }
    ]);
    return W3mAccountWalletFeaturesWidget;
}((0, $2yD3e.LitElement));
$7332acfb74187337$export$40fe2014a0a05eaf.styles = (0, $1a4f2a889d76ae66$export$2e2bcd8739ae039);
$7332acfb74187337$var$__decorate([
    (0, $334Pv.state)()
], $7332acfb74187337$export$40fe2014a0a05eaf.prototype, "watchTokenBalance", void 0);
$7332acfb74187337$var$__decorate([
    (0, $334Pv.state)()
], $7332acfb74187337$export$40fe2014a0a05eaf.prototype, "address", void 0);
$7332acfb74187337$var$__decorate([
    (0, $334Pv.state)()
], $7332acfb74187337$export$40fe2014a0a05eaf.prototype, "profileImage", void 0);
$7332acfb74187337$var$__decorate([
    (0, $334Pv.state)()
], $7332acfb74187337$export$40fe2014a0a05eaf.prototype, "profileName", void 0);
$7332acfb74187337$var$__decorate([
    (0, $334Pv.state)()
], $7332acfb74187337$export$40fe2014a0a05eaf.prototype, "smartAccountDeployed", void 0);
$7332acfb74187337$var$__decorate([
    (0, $334Pv.state)()
], $7332acfb74187337$export$40fe2014a0a05eaf.prototype, "network", void 0);
$7332acfb74187337$var$__decorate([
    (0, $334Pv.state)()
], $7332acfb74187337$export$40fe2014a0a05eaf.prototype, "currentTab", void 0);
$7332acfb74187337$var$__decorate([
    (0, $334Pv.state)()
], $7332acfb74187337$export$40fe2014a0a05eaf.prototype, "tokenBalance", void 0);
$7332acfb74187337$var$__decorate([
    (0, $334Pv.state)()
], $7332acfb74187337$export$40fe2014a0a05eaf.prototype, "preferredAccountType", void 0);
$7332acfb74187337$export$40fe2014a0a05eaf = $7332acfb74187337$var$__decorate([
    (0, $hdxb6.customElement)("w3m-account-wallet-features-widget")
], $7332acfb74187337$export$40fe2014a0a05eaf);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $5384950b3fb67760$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    width: 100%;\n    max-height: 280px;\n    overflow: scroll;\n    scrollbar-width: none;\n  }\n\n  :host::-webkit-scrollbar {\n    display: none;\n  }\n"
    ]);
    $5384950b3fb67760$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $5384950b3fb67760$export$2e2bcd8739ae039 = (0, $2D5eP.css)($5384950b3fb67760$var$_templateObject());


function $a56fcc2bfd1458b9$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<w3m-activity-list page="account"></w3m-activity-list>'
    ]);
    $a56fcc2bfd1458b9$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $a56fcc2bfd1458b9$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a56fcc2bfd1458b9$export$703a5b3cf022b6fa = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mAccountActivityWidget, LitElement);
    var _super = (0, $ohfOJ._)(W3mAccountActivityWidget);
    function W3mAccountActivityWidget() {
        (0, $4GJKx._)(this, W3mAccountActivityWidget);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(W3mAccountActivityWidget, [
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($a56fcc2bfd1458b9$var$_templateObject());
            }
        }
    ]);
    return W3mAccountActivityWidget;
}((0, $2yD3e.LitElement));
$a56fcc2bfd1458b9$export$703a5b3cf022b6fa.styles = (0, $5384950b3fb67760$export$2e2bcd8739ae039);
$a56fcc2bfd1458b9$export$703a5b3cf022b6fa = $a56fcc2bfd1458b9$var$__decorate([
    (0, $hdxb6.customElement)("w3m-account-activity-widget")
], $a56fcc2bfd1458b9$export$703a5b3cf022b6fa);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $iptjJ = parcelRequire("iptjJ");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $a0723171ee724239$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  .contentContainer {\n    height: 280px;\n  }\n\n  .contentContainer > wui-icon-box {\n    width: 40px;\n    height: 40px;\n    border-radius: var(--wui-border-radius-xxs);\n  }\n\n  .contentContainer > .textContent {\n    width: 65%;\n  }\n"
    ]);
    $a0723171ee724239$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $a0723171ee724239$export$2e2bcd8739ae039 = (0, $2D5eP.css)($a0723171ee724239$var$_templateObject());


function $d66853ae72534b4d$var$_templateObject() {
    var data = (0, $j06k0._)([
        "",
        ""
    ]);
    $d66853ae72534b4d$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $d66853ae72534b4d$var$_templateObject1() {
    var data = (0, $j06k0._)([
        ' <wui-flex\n      class="contentContainer"\n      alignItems="center"\n      justifyContent="center"\n      flexDirection="column"\n      gap="l"\n    >\n      <wui-icon-box\n        icon="wallet"\n        size="inherit"\n        iconColor="fg-200"\n        backgroundColor="fg-200"\n        iconSize="lg"\n      ></wui-icon-box>\n      <wui-flex\n        class="textContent"\n        gap="xs"\n        flexDirection="column"\n        justifyContent="center"\n        flexDirection="column"\n      >\n        <wui-text variant="paragraph-500" align="center" color="fg-100">Coming soon</wui-text>\n        <wui-text variant="small-400" align="center" color="fg-200"\n          >Stay tuned for our upcoming NFT feature</wui-text\n        >\n      </wui-flex>\n      <wui-link @click=',
        ">Receive funds</wui-link>\n    </wui-flex>"
    ]);
    $d66853ae72534b4d$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $d66853ae72534b4d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d66853ae72534b4d$export$f8df4d2d7652c9e = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mAccountNftsWidget, LitElement);
    var _super = (0, $ohfOJ._)(W3mAccountNftsWidget);
    function W3mAccountNftsWidget() {
        (0, $4GJKx._)(this, W3mAccountNftsWidget);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(W3mAccountNftsWidget, [
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($d66853ae72534b4d$var$_templateObject(), this.nftTemplate());
            }
        },
        {
            key: "nftTemplate",
            value: function nftTemplate() {
                return (0, $hxyOZ.html)($d66853ae72534b4d$var$_templateObject1(), this.onReceiveClick.bind(this));
            }
        },
        {
            key: "onReceiveClick",
            value: function onReceiveClick() {
                (0, $iptjJ.RouterController).push("WalletReceive");
            }
        }
    ]);
    return W3mAccountNftsWidget;
}((0, $2yD3e.LitElement));
$d66853ae72534b4d$export$f8df4d2d7652c9e.styles = (0, $a0723171ee724239$export$2e2bcd8739ae039);
$d66853ae72534b4d$export$f8df4d2d7652c9e = $d66853ae72534b4d$var$__decorate([
    (0, $hdxb6.customElement)("w3m-account-nfts-widget")
], $d66853ae72534b4d$export$f8df4d2d7652c9e);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $dMLJP = parcelRequire("dMLJP");
var $iptjJ = parcelRequire("iptjJ");
var $1QDT9 = parcelRequire("1QDT9");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $baf4f1f4acc72fcf$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    width: 100%;\n  }\n\n  wui-flex {\n    width: 100%;\n  }\n\n  .contentContainer {\n    max-height: 280px;\n    overflow: scroll;\n    scrollbar-width: none;\n  }\n\n  .contentContainer::-webkit-scrollbar {\n    display: none;\n  }\n"
    ]);
    $baf4f1f4acc72fcf$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $baf4f1f4acc72fcf$export$2e2bcd8739ae039 = (0, $2D5eP.css)($baf4f1f4acc72fcf$var$_templateObject());


parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");
parcelRequire("hsyMZ");
var $cSJ4o = parcelRequire("cSJ4o");
function $f7cd77d373e00f13$var$_templateObject() {
    var data = (0, $j06k0._)([
        "",
        ""
    ]);
    $f7cd77d373e00f13$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $f7cd77d373e00f13$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '<wui-flex class="contentContainer" flexDirection="column" gap="xs">\n        ',
        "\n      </wui-flex>"
    ]);
    $f7cd77d373e00f13$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $f7cd77d373e00f13$var$_templateObject2() {
    var data = (0, $j06k0._)([
        ' <wui-flex flexDirection="column" gap="xs"\n      ><wui-list-description\n        @click=',
        '\n        text="Buy Crypto"\n        description="Easy with card or bank account"\n        icon="card"\n        iconColor="success-100"\n        iconBackgroundColor="success-100"\n        tag="popular"\n      ></wui-list-description\n      ><wui-list-description\n        @click=',
        '\n        text="Receive funds"\n        description="Transfer tokens on your wallet"\n        icon="arrowBottomCircle"\n        iconColor="fg-200"\n        iconBackgroundColor="fg-200"\n      ></wui-list-description\n    ></wui-flex>'
    ]);
    $f7cd77d373e00f13$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $f7cd77d373e00f13$var$_templateObject3() {
    var data = (0, $j06k0._)([
        "<wui-list-token\n          tokenName=",
        "\n          tokenImageUrl=",
        "\n          tokenAmount=",
        "\n          tokenValue=",
        "\n          tokenCurrency=",
        "\n        ></wui-list-token>"
    ]);
    $f7cd77d373e00f13$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var $f7cd77d373e00f13$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f7cd77d373e00f13$export$e09eb41ed15591bb = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mAccountTokensWidget, LitElement);
    var _super = (0, $ohfOJ._)(W3mAccountTokensWidget);
    function W3mAccountTokensWidget() {
        var _this_unsubscribe;
        (0, $4GJKx._)(this, W3mAccountTokensWidget);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.tokenBalance = (0, $dMLJP.AccountController).state.tokenBalance;
        (_this_unsubscribe = _this.unsubscribe).push.apply(_this_unsubscribe, [
            (0, $dMLJP.AccountController).subscribe(function(val) {
                _this.tokenBalance = val.tokenBalance;
            })
        ]);
        return _this;
    }
    (0, $1wc17._)(W3mAccountTokensWidget, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($f7cd77d373e00f13$var$_templateObject(), this.tokenTemplate());
            }
        },
        {
            key: "tokenTemplate",
            value: function tokenTemplate() {
                var _this_tokenBalance;
                if (this.tokenBalance && ((_this_tokenBalance = this.tokenBalance) === null || _this_tokenBalance === void 0 ? void 0 : _this_tokenBalance.length) > 0) return (0, $hxyOZ.html)($f7cd77d373e00f13$var$_templateObject1(), this.tokenItemTemplate());
                return (0, $hxyOZ.html)($f7cd77d373e00f13$var$_templateObject2(), this.onBuyClick.bind(this), this.onReceiveClick.bind(this));
            }
        },
        {
            key: "tokenItemTemplate",
            value: function tokenItemTemplate() {
                var _this_tokenBalance;
                return (_this_tokenBalance = this.tokenBalance) === null || _this_tokenBalance === void 0 ? void 0 : _this_tokenBalance.map(function(token) {
                    return (0, $hxyOZ.html)($f7cd77d373e00f13$var$_templateObject3(), token.name, token.iconUrl, token.quantity.numeric, token.value, token.symbol);
                });
            }
        },
        {
            key: "onReceiveClick",
            value: function onReceiveClick() {
                (0, $iptjJ.RouterController).push("WalletReceive");
            }
        },
        {
            key: "onBuyClick",
            value: function onBuyClick() {
                (0, $1QDT9.EventsController).sendEvent({
                    type: "track",
                    event: "SELECT_BUY_CRYPTO",
                    properties: {
                        isSmartAccount: (0, $dMLJP.AccountController).state.preferredAccountType === (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT
                    }
                });
                (0, $iptjJ.RouterController).push("OnRampProviders");
            }
        }
    ]);
    return W3mAccountTokensWidget;
}((0, $2yD3e.LitElement));
$f7cd77d373e00f13$export$e09eb41ed15591bb.styles = (0, $baf4f1f4acc72fcf$export$2e2bcd8739ae039);
$f7cd77d373e00f13$var$__decorate([
    (0, $334Pv.state)()
], $f7cd77d373e00f13$export$e09eb41ed15591bb.prototype, "tokenBalance", void 0);
$f7cd77d373e00f13$export$e09eb41ed15591bb = $f7cd77d373e00f13$var$__decorate([
    (0, $hdxb6.customElement)("w3m-account-tokens-widget")
], $f7cd77d373e00f13$export$e09eb41ed15591bb);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $cv9Rk = parcelRequire("cv9Rk");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("dSKxG");
var $3QZC1 = parcelRequire("3QZC1");
var $6qlO7 = parcelRequire("6qlO7");
parcelRequire("cwWZ7");
var $9zDWP = parcelRequire("9zDWP");
var $dMLJP = parcelRequire("dMLJP");
var $ktZEF = parcelRequire("ktZEF");
var $fPqxb = parcelRequire("fPqxb");
var $iptjJ = parcelRequire("iptjJ");
var $faNff = parcelRequire("faNff");
var $1QDT9 = parcelRequire("1QDT9");
parcelRequire("grHtr");
var $3kwZm = parcelRequire("3kwZm");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $04kNM = parcelRequire("04kNM");
var $334Pv = parcelRequire("334Pv");
parcelRequire("hsyMZ");
var $cSJ4o = parcelRequire("cSJ4o");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $d43e2fa34f113e24$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    min-height: 100%;\n  }\n\n  .group-container[last-group='true'] {\n    padding-bottom: var(--wui-spacing-m);\n  }\n\n  .contentContainer {\n    height: 280px;\n  }\n\n  .contentContainer > wui-icon-box {\n    width: 40px;\n    height: 40px;\n    border-radius: var(--wui-border-radius-xxs);\n  }\n\n  .contentContainer > .textContent {\n    width: 65%;\n  }\n\n  .emptyContainer {\n    height: 100%;\n  }\n"
    ]);
    $d43e2fa34f113e24$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $d43e2fa34f113e24$export$2e2bcd8739ae039 = (0, $2D5eP.css)($d43e2fa34f113e24$var$_templateObject());


function $e50a235271798f5c$var$_templateObject() {
    var data = (0, $j06k0._)([
        " ",
        "\n    ",
        "\n    ",
        ""
    ]);
    $e50a235271798f5c$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $e50a235271798f5c$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '\n          <wui-flex\n            flexDirection="column"\n            class="group-container"\n            last-group="',
        '"\n          >\n            <wui-flex\n              alignItems="center"\n              flexDirection="row"\n              .padding=',
        '\n            >\n              <wui-text variant="paragraph-500" color="fg-200">',
        '</wui-text>\n            </wui-flex>\n            <wui-flex flexDirection="column" gap="xs">\n              ',
        "\n            </wui-flex>\n          </wui-flex>\n        "
    ]);
    $e50a235271798f5c$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $e50a235271798f5c$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "\n        <wui-transaction-list-item\n          date=",
        "\n          .direction=",
        "\n          id=",
        "\n          status=",
        "\n          type=",
        "\n          .images=",
        "\n          .descriptions=",
        "\n        ></wui-transaction-list-item>\n      "
    ]);
    $e50a235271798f5c$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $e50a235271798f5c$var$_templateObject3() {
    var data = (0, $j06k0._)([
        " <wui-transaction-list-item\n          date=",
        "\n          direction=",
        "\n          id=",
        "\n          status=",
        "\n          type=",
        "\n          .onlyDirectionIcon=",
        "\n          .images=",
        "\n          .descriptions=",
        "\n        ></wui-transaction-list-item>"
    ]);
    $e50a235271798f5c$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $e50a235271798f5c$var$_templateObject4() {
    var data = (0, $j06k0._)([
        "\n      <wui-transaction-list-item\n        date=",
        "\n        .direction=",
        "\n        id=",
        "\n        status=",
        "\n        type=",
        "\n        .images=",
        "\n        .descriptions=",
        "\n      ></wui-transaction-list-item>\n    "
    ]);
    $e50a235271798f5c$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $e50a235271798f5c$var$_templateObject5() {
    var data = (0, $j06k0._)([
        "",
        ""
    ]);
    $e50a235271798f5c$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $e50a235271798f5c$var$_templateObject6() {
    var data = (0, $j06k0._)([
        '\n      <wui-text align="center" variant="paragraph-500" color="fg-100"\n        >Transaction history is coming soon!</wui-text\n      >\n    '
    ]);
    $e50a235271798f5c$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $e50a235271798f5c$var$_templateObject7() {
    var data = (0, $j06k0._)([
        ' <wui-text align="center" variant="paragraph-500" color="fg-100"\n        >No Transactions yet</wui-text\n      >\n      <wui-text align="center" variant="small-500" color="fg-200"\n        >Start trading on dApps <br />\n        to grow your wallet!</wui-text\n      >'
    ]);
    $e50a235271798f5c$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $e50a235271798f5c$var$_templateObject8() {
    var data = (0, $j06k0._)([
        '<wui-flex\n      class="emptyContainer"\n      flexGrow="1"\n      flexDirection="column"\n      justifyContent="center"\n      alignItems="center"\n      .padding=',
        '\n      gap="xl"\n    >\n      <wui-icon-box\n        backgroundColor="gray-glass-005"\n        background="gray"\n        iconColor="fg-200"\n        icon="wallet"\n        size="lg"\n        ?border=',
        '\n        borderColor="wui-color-bg-125"\n      ></wui-icon-box>\n      <wui-flex flexDirection="column" alignItems="center" gap="xs">\n        ',
        "\n      </wui-flex>\n    </wui-flex>"
    ]);
    $e50a235271798f5c$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function $e50a235271798f5c$var$_templateObject9() {
    var data = (0, $j06k0._)([
        '\n      <wui-text variant="paragraph-500" align="center" color="fg-100"\n        >Transaction history is coming soon!</wui-text\n      >\n    '
    ]);
    $e50a235271798f5c$var$_templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function $e50a235271798f5c$var$_templateObject10() {
    var data = (0, $j06k0._)([
        ' <wui-text variant="paragraph-500" align="center" color="fg-100"\n        >No activity yet</wui-text\n      >\n      <wui-text variant="small-400" align="center" color="fg-200"\n        >Your next transactions will appear here</wui-text\n      >'
    ]);
    $e50a235271798f5c$var$_templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function $e50a235271798f5c$var$_templateObject11() {
    var data = (0, $j06k0._)([
        '<wui-flex\n      class="contentContainer"\n      alignItems="center"\n      justifyContent="center"\n      flexDirection="column"\n      gap="l"\n    >\n      <wui-icon-box\n        icon="swapHorizontal"\n        size="inherit"\n        iconColor="fg-200"\n        backgroundColor="fg-200"\n        iconSize="lg"\n      ></wui-icon-box>\n      <wui-flex\n        class="textContent"\n        gap="xs"\n        flexDirection="column"\n        justifyContent="center"\n        flexDirection="column"\n      >\n        ',
        "\n      </wui-flex>\n      <wui-link @click=",
        ">Trade</wui-link>\n    </wui-flex>"
    ]);
    $e50a235271798f5c$var$_templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function $e50a235271798f5c$var$_templateObject12() {
    var data = (0, $j06k0._)([
        "",
        ""
    ]);
    $e50a235271798f5c$var$_templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function $e50a235271798f5c$var$_templateObject13() {
    var data = (0, $j06k0._)([
        "",
        ""
    ]);
    $e50a235271798f5c$var$_templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function $e50a235271798f5c$var$_templateObject14() {
    var data = (0, $j06k0._)([
        " <wui-transaction-list-item-loader></wui-transaction-list-item-loader> "
    ]);
    $e50a235271798f5c$var$_templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
var $e50a235271798f5c$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $e50a235271798f5c$var$PAGINATOR_ID = "last-transaction";
var $e50a235271798f5c$var$LOADING_ITEM_COUNT = 7;
var $e50a235271798f5c$export$719cb0f98e6f6fef = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mActivityList, LitElement);
    var _super = (0, $ohfOJ._)(W3mActivityList);
    function W3mActivityList() {
        var _this_unsubscribe;
        (0, $4GJKx._)(this, W3mActivityList);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.paginationObserver = undefined;
        _this.page = "activity";
        _this.isSolana = (0, $9zDWP.ChainController).state.activeChain === (0, $3QZC1.ConstantsUtil).CHAIN.SOLANA;
        _this.address = (0, $dMLJP.AccountController).state.address;
        _this.transactionsByYear = (0, $ktZEF.TransactionsController).state.transactionsByYear;
        _this.loading = (0, $ktZEF.TransactionsController).state.loading;
        _this.empty = (0, $ktZEF.TransactionsController).state.empty;
        _this.next = (0, $ktZEF.TransactionsController).state.next;
        (0, $ktZEF.TransactionsController).clearCursor();
        (_this_unsubscribe = _this.unsubscribe).push.apply(_this_unsubscribe, [
            (0, $9zDWP.ChainController).subscribeKey("activeChain", function(activeChain) {
                _this.isSolana = activeChain === (0, $3QZC1.ConstantsUtil).CHAIN.SOLANA;
            }),
            (0, $dMLJP.AccountController).subscribe(function(val) {
                if (val.isConnected) {
                    if (_this.address !== val.address) {
                        _this.address = val.address;
                        (0, $ktZEF.TransactionsController).resetTransactions();
                        (0, $ktZEF.TransactionsController).fetchTransactions(val.address);
                    }
                }
            }),
            (0, $fPqxb.NetworkController).subscribeKey("caipNetwork", function() {
                _this.updateTransactionView();
            }),
            (0, $ktZEF.TransactionsController).subscribe(function(val) {
                _this.transactionsByYear = val.transactionsByYear;
                _this.loading = val.loading;
                _this.empty = val.empty;
                _this.next = val.next;
            })
        ]);
        return _this;
    }
    (0, $1wc17._)(W3mActivityList, [
        {
            key: "firstUpdated",
            value: function firstUpdated() {
                if (this.isSolana) {
                    this.loading = false;
                    this.empty = true;
                    return;
                }
                this.updateTransactionView();
                this.createPaginationObserver();
            }
        },
        {
            key: "updated",
            value: function updated() {
                this.setPaginationObserver();
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($e50a235271798f5c$var$_templateObject(), this.empty ? null : this.templateTransactionsByYear(), this.loading ? this.templateLoading() : null, !this.loading && this.empty ? this.templateEmpty() : null);
            }
        },
        {
            key: "updateTransactionView",
            value: function updateTransactionView() {
                var _NetworkController_state_caipNetwork;
                var currentNetwork = (_NetworkController_state_caipNetwork = (0, $fPqxb.NetworkController).state.caipNetwork) === null || _NetworkController_state_caipNetwork === void 0 ? void 0 : _NetworkController_state_caipNetwork.id;
                var lastNetworkInView = (0, $ktZEF.TransactionsController).state.lastNetworkInView;
                if (lastNetworkInView !== currentNetwork) {
                    (0, $ktZEF.TransactionsController).resetTransactions();
                    (0, $ktZEF.TransactionsController).fetchTransactions(this.address);
                }
                (0, $ktZEF.TransactionsController).setLastNetworkInView(currentNetwork);
            }
        },
        {
            key: "templateTransactionsByYear",
            value: function templateTransactionsByYear() {
                var _this = this;
                var sortedYearKeys = Object.keys(this.transactionsByYear).sort().reverse();
                return sortedYearKeys.map(function(year) {
                    var yearInt = parseInt(year, 10);
                    var sortedMonthIndexes = new Array(12).fill(null).map(function(_, idx) {
                        var _this_transactionsByYear_yearInt;
                        var groupTitle = (0, $3kwZm.TransactionUtil).getTransactionGroupTitle(yearInt, idx);
                        var transactions = (_this_transactionsByYear_yearInt = _this.transactionsByYear[yearInt]) === null || _this_transactionsByYear_yearInt === void 0 ? void 0 : _this_transactionsByYear_yearInt[idx];
                        return {
                            groupTitle: groupTitle,
                            transactions: transactions
                        };
                    }).filter(function(param) {
                        var transactions = param.transactions;
                        return transactions;
                    }).reverse();
                    return sortedMonthIndexes.map(function(param, index) {
                        var groupTitle = param.groupTitle, transactions = param.transactions;
                        var isLastGroup = index === sortedMonthIndexes.length - 1;
                        if (!transactions) return null;
                        return (0, $hxyOZ.html)($e50a235271798f5c$var$_templateObject1(), isLastGroup ? "true" : "false", [
                            "xs",
                            "s",
                            "s",
                            "s"
                        ], groupTitle, _this.templateTransactions(transactions, isLastGroup));
                    });
                });
            }
        },
        {
            key: "templateRenderTransaction",
            value: function templateRenderTransaction(transaction, isLastTransaction) {
                var _this = this;
                var _this_getTransactionListItemProps = this.getTransactionListItemProps(transaction), date = _this_getTransactionListItemProps.date, descriptions = _this_getTransactionListItemProps.descriptions, direction = _this_getTransactionListItemProps.direction, isAllNFT = _this_getTransactionListItemProps.isAllNFT, images = _this_getTransactionListItemProps.images, status = _this_getTransactionListItemProps.status, transfers = _this_getTransactionListItemProps.transfers, type = _this_getTransactionListItemProps.type;
                var haveMultipleTransfers = (transfers === null || transfers === void 0 ? void 0 : transfers.length) > 1;
                var haveTwoTransfers = (transfers === null || transfers === void 0 ? void 0 : transfers.length) === 2;
                if (haveTwoTransfers && !isAllNFT) return (0, $hxyOZ.html)($e50a235271798f5c$var$_templateObject2(), date, direction, isLastTransaction && this.next ? $e50a235271798f5c$var$PAGINATOR_ID : "", status, type, images, descriptions);
                if (haveMultipleTransfers) return transfers.map(function(transfer, index) {
                    var description = (0, $3kwZm.TransactionUtil).getTransferDescription(transfer);
                    var isLastTransfer = isLastTransaction && index === transfers.length - 1;
                    return (0, $hxyOZ.html)($e50a235271798f5c$var$_templateObject3(), date, transfer.direction, isLastTransfer && _this.next ? $e50a235271798f5c$var$PAGINATOR_ID : "", status, type, true, [
                        images[index]
                    ], [
                        description
                    ]);
                });
                return (0, $hxyOZ.html)($e50a235271798f5c$var$_templateObject4(), date, direction, isLastTransaction && this.next ? $e50a235271798f5c$var$PAGINATOR_ID : "", status, type, images, descriptions);
            }
        },
        {
            key: "templateTransactions",
            value: function templateTransactions(transactions, isLastGroup) {
                var _this = this;
                return transactions.map(function(transaction, index) {
                    var isLastTransaction = isLastGroup && index === transactions.length - 1;
                    return (0, $hxyOZ.html)($e50a235271798f5c$var$_templateObject5(), _this.templateRenderTransaction(transaction, isLastTransaction));
                });
            }
        },
        {
            key: "emptyStateActivity",
            value: function emptyStateActivity() {
                var comingSoon = (0, $hxyOZ.html)($e50a235271798f5c$var$_templateObject6());
                var empty = (0, $hxyOZ.html)($e50a235271798f5c$var$_templateObject7());
                return (0, $hxyOZ.html)($e50a235271798f5c$var$_templateObject8(), [
                    "3xl",
                    "xl",
                    "3xl",
                    "xl"
                ], true, this.isSolana ? comingSoon : empty);
            }
        },
        {
            key: "emptyStateAccount",
            value: function emptyStateAccount() {
                var comingSoon = (0, $hxyOZ.html)($e50a235271798f5c$var$_templateObject9());
                var empty = (0, $hxyOZ.html)($e50a235271798f5c$var$_templateObject10());
                return (0, $hxyOZ.html)($e50a235271798f5c$var$_templateObject11(), this.isSolana ? comingSoon : empty, this.onReceiveClick.bind(this));
            }
        },
        {
            key: "templateEmpty",
            value: function templateEmpty() {
                if (this.page === "account") return (0, $hxyOZ.html)($e50a235271798f5c$var$_templateObject12(), this.emptyStateAccount());
                return (0, $hxyOZ.html)($e50a235271798f5c$var$_templateObject13(), this.emptyStateActivity());
            }
        },
        {
            key: "templateLoading",
            value: function templateLoading() {
                if (this.page === "activity") return Array($e50a235271798f5c$var$LOADING_ITEM_COUNT).fill((0, $hxyOZ.html)($e50a235271798f5c$var$_templateObject14())).map(function(item) {
                    return item;
                });
                return null;
            }
        },
        {
            key: "onReceiveClick",
            value: function onReceiveClick() {
                (0, $iptjJ.RouterController).push("WalletReceive");
            }
        },
        {
            key: "createPaginationObserver",
            value: function createPaginationObserver() {
                var _this = this;
                var projectId = (0, $faNff.OptionsController).state.projectId;
                this.paginationObserver = new IntersectionObserver(function(param) {
                    var _param = (0, $cv9Rk._)(param, 1), element = _param[0];
                    if ((element === null || element === void 0 ? void 0 : element.isIntersecting) && !_this.loading) {
                        (0, $ktZEF.TransactionsController).fetchTransactions(_this.address);
                        (0, $1QDT9.EventsController).sendEvent({
                            type: "track",
                            event: "LOAD_MORE_TRANSACTIONS",
                            properties: {
                                address: _this.address,
                                projectId: projectId,
                                cursor: _this.next,
                                isSmartAccount: (0, $dMLJP.AccountController).state.preferredAccountType === (0, $cSJ4o.W3mFrameRpcConstants).ACCOUNT_TYPES.SMART_ACCOUNT
                            }
                        });
                    }
                }, {});
                this.setPaginationObserver();
            }
        },
        {
            key: "setPaginationObserver",
            value: function setPaginationObserver() {
                var _this_paginationObserver, _this_shadowRoot, _this_paginationObserver1;
                (_this_paginationObserver = this.paginationObserver) === null || _this_paginationObserver === void 0 ? void 0 : _this_paginationObserver.disconnect();
                var lastItem = (_this_shadowRoot = this.shadowRoot) === null || _this_shadowRoot === void 0 ? void 0 : _this_shadowRoot.querySelector("#".concat($e50a235271798f5c$var$PAGINATOR_ID));
                if (lastItem) (_this_paginationObserver1 = this.paginationObserver) === null || _this_paginationObserver1 === void 0 ? void 0 : _this_paginationObserver1.observe(lastItem);
            }
        },
        {
            key: "getTransactionListItemProps",
            value: function getTransactionListItemProps(transaction) {
                var _transaction_metadata, _transaction_transfers, _transaction_transfers1, _transaction_metadata1, _transaction_metadata2;
                var date = (0, $6qlO7.DateUtil).formatDate(transaction === null || transaction === void 0 ? void 0 : (_transaction_metadata = transaction.metadata) === null || _transaction_metadata === void 0 ? void 0 : _transaction_metadata.minedAt);
                var descriptions = (0, $3kwZm.TransactionUtil).getTransactionDescriptions(transaction);
                var transfers = transaction === null || transaction === void 0 ? void 0 : transaction.transfers;
                var transfer = transaction === null || transaction === void 0 ? void 0 : (_transaction_transfers = transaction.transfers) === null || _transaction_transfers === void 0 ? void 0 : _transaction_transfers[0];
                var isAllNFT = Boolean(transfer) && (transaction === null || transaction === void 0 ? void 0 : (_transaction_transfers1 = transaction.transfers) === null || _transaction_transfers1 === void 0 ? void 0 : _transaction_transfers1.every(function(item) {
                    return Boolean(item.nft_info);
                }));
                var images = (0, $3kwZm.TransactionUtil).getTransactionImages(transfers);
                return {
                    date: date,
                    direction: transfer === null || transfer === void 0 ? void 0 : transfer.direction,
                    descriptions: descriptions,
                    isAllNFT: isAllNFT,
                    images: images,
                    status: (_transaction_metadata1 = transaction.metadata) === null || _transaction_metadata1 === void 0 ? void 0 : _transaction_metadata1.status,
                    transfers: transfers,
                    type: (_transaction_metadata2 = transaction.metadata) === null || _transaction_metadata2 === void 0 ? void 0 : _transaction_metadata2.operationType
                };
            }
        }
    ]);
    return W3mActivityList;
}((0, $2yD3e.LitElement));
$e50a235271798f5c$export$719cb0f98e6f6fef.styles = (0, $d43e2fa34f113e24$export$2e2bcd8739ae039);
$e50a235271798f5c$var$__decorate([
    (0, $04kNM.property)()
], $e50a235271798f5c$export$719cb0f98e6f6fef.prototype, "page", void 0);
$e50a235271798f5c$var$__decorate([
    (0, $334Pv.state)()
], $e50a235271798f5c$export$719cb0f98e6f6fef.prototype, "isSolana", void 0);
$e50a235271798f5c$var$__decorate([
    (0, $334Pv.state)()
], $e50a235271798f5c$export$719cb0f98e6f6fef.prototype, "address", void 0);
$e50a235271798f5c$var$__decorate([
    (0, $334Pv.state)()
], $e50a235271798f5c$export$719cb0f98e6f6fef.prototype, "transactionsByYear", void 0);
$e50a235271798f5c$var$__decorate([
    (0, $334Pv.state)()
], $e50a235271798f5c$export$719cb0f98e6f6fef.prototype, "loading", void 0);
$e50a235271798f5c$var$__decorate([
    (0, $334Pv.state)()
], $e50a235271798f5c$export$719cb0f98e6f6fef.prototype, "empty", void 0);
$e50a235271798f5c$var$__decorate([
    (0, $334Pv.state)()
], $e50a235271798f5c$export$719cb0f98e6f6fef.prototype, "next", void 0);
$e50a235271798f5c$export$719cb0f98e6f6fef = $e50a235271798f5c$var$__decorate([
    (0, $hdxb6.customElement)("w3m-activity-list")
], $e50a235271798f5c$export$719cb0f98e6f6fef);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("grHtr");
var $dI7zX = parcelRequire("dI7zX");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $fa83e138823c4655$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    width: 100%;\n    height: 100px;\n    border-radius: var(--wui-border-radius-s);\n    border: 1px solid var(--wui-color-gray-glass-002);\n    background-color: var(--wui-color-gray-glass-002);\n    transition: background-color var(--wui-ease-out-power-1) var(--wui-duration-lg);\n    will-change: background-color;\n  }\n\n  :host(:hover) {\n    background-color: var(--wui-color-gray-glass-005);\n  }\n\n  wui-flex {\n    width: 100%;\n    height: fit-content;\n  }\n\n  wui-button {\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n  }\n\n  wui-input-amount {\n    mask-image: linear-gradient(\n      270deg,\n      transparent 0px,\n      transparent 8px,\n      black 24px,\n      black 25px,\n      black 32px,\n      black 100%\n    );\n  }\n\n  .totalValue {\n    width: 100%;\n  }\n"
    ]);
    $fa83e138823c4655$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $fa83e138823c4655$export$2e2bcd8739ae039 = (0, $2D5eP.css)($fa83e138823c4655$var$_templateObject());


parcelRequire("kAqXG");
var $04kNM = parcelRequire("04kNM");
parcelRequire("cwWZ7");
var $iptjJ = parcelRequire("iptjJ");
var $iSNyw = parcelRequire("iSNyw");
parcelRequire("dSKxG");
var $eMPGH = parcelRequire("eMPGH");
function $3b8eb7e44bf93d2a$var$_templateObject() {
    var data = (0, $j06k0._)([
        ' <wui-flex\n      flexDirection="column"\n      gap="4xs"\n      .padding=',
        '\n    >\n      <wui-flex alignItems="center">\n        <wui-input-amount\n          @inputChange=',
        "\n          ?disabled=",
        "\n          .value=",
        "\n        ></wui-input-amount>\n        ",
        '\n      </wui-flex>\n      <wui-flex alignItems="center" justifyContent="space-between">\n        ',
        '\n        <wui-flex alignItems="center" gap="4xs" justifyContent="flex-end">\n          ',
        " ",
        "\n        </wui-flex>\n      </wui-flex>\n    </wui-flex>"
    ]);
    $3b8eb7e44bf93d2a$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $3b8eb7e44bf93d2a$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "<wui-token-button\n        text=",
        "\n        imageSrc=",
        "\n        @click=",
        "\n      >\n      </wui-token-button>"
    ]);
    $3b8eb7e44bf93d2a$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $3b8eb7e44bf93d2a$var$_templateObject2() {
    var data = (0, $j06k0._)([
        '<wui-button\n      size="md"\n      variant="accent"\n      @click=',
        "\n      >Select token</wui-button\n    >"
    ]);
    $3b8eb7e44bf93d2a$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $3b8eb7e44bf93d2a$var$_templateObject3() {
    var data = (0, $j06k0._)([
        '<wui-text class="totalValue" variant="small-400" color="fg-200"\n        >',
        "</wui-text\n      >"
    ]);
    $3b8eb7e44bf93d2a$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $3b8eb7e44bf93d2a$var$_templateObject4() {
    var data = (0, $j06k0._)([
        ' <wui-text variant="small-400" color="error-100">\n          ',
        "\n        </wui-text>"
    ]);
    $3b8eb7e44bf93d2a$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $3b8eb7e44bf93d2a$var$_templateObject5() {
    var data = (0, $j06k0._)([
        ' <wui-text variant="small-400" color="fg-200">\n        ',
        "\n      </wui-text>"
    ]);
    $3b8eb7e44bf93d2a$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $3b8eb7e44bf93d2a$var$_templateObject6() {
    var data = (0, $j06k0._)([
        "<wui-link @click=",
        ">Buy</wui-link>"
    ]);
    $3b8eb7e44bf93d2a$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $3b8eb7e44bf93d2a$var$_templateObject7() {
    var data = (0, $j06k0._)([
        "<wui-link @click=",
        ">Max</wui-link>"
    ]);
    $3b8eb7e44bf93d2a$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
var $3b8eb7e44bf93d2a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $3b8eb7e44bf93d2a$export$fd578e03b00e8696 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mInputToken, LitElement);
    var _super = (0, $ohfOJ._)(W3mInputToken);
    function W3mInputToken() {
        (0, $4GJKx._)(this, W3mInputToken);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(W3mInputToken, [
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($3b8eb7e44bf93d2a$var$_templateObject(), [
                    "xl",
                    "s",
                    "l",
                    "l"
                ], this.onInputChange.bind(this), !this.token && true, this.sendTokenAmount ? String(this.sendTokenAmount) : "", this.buttonTemplate(), this.sendValueTemplate(), this.maxAmountTemplate(), this.actionTemplate());
            }
        },
        {
            key: "buttonTemplate",
            value: function buttonTemplate() {
                if (this.token) return (0, $hxyOZ.html)($3b8eb7e44bf93d2a$var$_templateObject1(), this.token.symbol, this.token.iconUrl, this.handleSelectButtonClick.bind(this));
                return (0, $hxyOZ.html)($3b8eb7e44bf93d2a$var$_templateObject2(), this.handleSelectButtonClick.bind(this));
            }
        },
        {
            key: "handleSelectButtonClick",
            value: function handleSelectButtonClick() {
                (0, $iptjJ.RouterController).push("WalletSendSelectToken");
            }
        },
        {
            key: "sendValueTemplate",
            value: function sendValueTemplate() {
                if (this.token && this.sendTokenAmount) {
                    var price = this.token.price;
                    var totalValue = price * this.sendTokenAmount;
                    return (0, $hxyOZ.html)($3b8eb7e44bf93d2a$var$_templateObject3(), totalValue ? "$".concat((0, $dI7zX.UiHelperUtil).formatNumberToLocalString(totalValue, 2)) : "Incorrect value");
                }
                return null;
            }
        },
        {
            key: "maxAmountTemplate",
            value: function maxAmountTemplate() {
                if (this.token) {
                    if (this.sendTokenAmount && this.sendTokenAmount > Number(this.token.quantity.numeric)) return (0, $hxyOZ.html)($3b8eb7e44bf93d2a$var$_templateObject4(), (0, $dI7zX.UiHelperUtil).roundNumber(Number(this.token.quantity.numeric), 6, 5));
                    return (0, $hxyOZ.html)($3b8eb7e44bf93d2a$var$_templateObject5(), (0, $dI7zX.UiHelperUtil).roundNumber(Number(this.token.quantity.numeric), 6, 5));
                }
                return null;
            }
        },
        {
            key: "actionTemplate",
            value: function actionTemplate() {
                if (this.token) {
                    if (this.sendTokenAmount && this.sendTokenAmount > Number(this.token.quantity.numeric)) return (0, $hxyOZ.html)($3b8eb7e44bf93d2a$var$_templateObject6(), this.onBuyClick.bind(this));
                    return (0, $hxyOZ.html)($3b8eb7e44bf93d2a$var$_templateObject7(), this.onMaxClick.bind(this));
                }
                return null;
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(event) {
                (0, $iSNyw.SendController).setTokenAmount(event.detail);
            }
        },
        {
            key: "onMaxClick",
            value: function onMaxClick() {
                if (this.token && this.gasPriceInUSD) {
                    var amountOfTokenGasRequires = (0, $eMPGH.NumberUtil).bigNumber(this.gasPriceInUSD.toFixed(5)).dividedBy(this.token.price);
                    var isNetworkToken = this.token.address === undefined;
                    var maxValue = isNetworkToken ? (0, $eMPGH.NumberUtil).bigNumber(this.token.quantity.numeric).minus(amountOfTokenGasRequires) : (0, $eMPGH.NumberUtil).bigNumber(this.token.quantity.numeric);
                    (0, $iSNyw.SendController).setTokenAmount(Number(maxValue.toFixed(20)));
                }
            }
        },
        {
            key: "onBuyClick",
            value: function onBuyClick() {
                (0, $iptjJ.RouterController).push("OnRampProviders");
            }
        }
    ]);
    return W3mInputToken;
}((0, $2yD3e.LitElement));
$3b8eb7e44bf93d2a$export$fd578e03b00e8696.styles = (0, $fa83e138823c4655$export$2e2bcd8739ae039);
$3b8eb7e44bf93d2a$var$__decorate([
    (0, $04kNM.property)({
        type: Object
    })
], $3b8eb7e44bf93d2a$export$fd578e03b00e8696.prototype, "token", void 0);
$3b8eb7e44bf93d2a$var$__decorate([
    (0, $04kNM.property)({
        type: Number
    })
], $3b8eb7e44bf93d2a$export$fd578e03b00e8696.prototype, "sendTokenAmount", void 0);
$3b8eb7e44bf93d2a$var$__decorate([
    (0, $04kNM.property)({
        type: Number
    })
], $3b8eb7e44bf93d2a$export$fd578e03b00e8696.prototype, "gasPriceInUSD", void 0);
$3b8eb7e44bf93d2a$export$fd578e03b00e8696 = $3b8eb7e44bf93d2a$var$__decorate([
    (0, $hdxb6.customElement)("w3m-input-token")
], $3b8eb7e44bf93d2a$export$fd578e03b00e8696);



var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $fe68049e5a305a6b$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    width: 100%;\n    height: 100px;\n    border-radius: var(--wui-border-radius-s);\n    border: 1px solid var(--wui-color-gray-glass-002);\n    background-color: var(--wui-color-gray-glass-002);\n    transition: background-color var(--wui-ease-out-power-1) var(--wui-duration-lg);\n    will-change: background-color;\n    position: relative;\n  }\n\n  :host(:hover) {\n    background-color: var(--wui-color-gray-glass-005);\n  }\n\n  wui-flex {\n    width: 100%;\n    height: fit-content;\n  }\n\n  wui-button {\n    display: ruby;\n    color: var(--wui-color-fg-100);\n    margin: 0 var(--wui-spacing-xs);\n  }\n\n  .instruction {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  .paste {\n    display: inline-flex;\n  }\n\n  textarea {\n    background: transparent;\n    width: 100%;\n    font-family: var(--w3m-font-family);\n    font-size: var(--wui-font-size-medium);\n    font-style: normal;\n    font-weight: var(--wui-font-weight-light);\n    line-height: 130%;\n    letter-spacing: var(--wui-letter-spacing-medium);\n    color: var(--wui-color-fg-100);\n    caret-color: var(--wui-color-accent-100);\n    box-sizing: border-box;\n    -webkit-appearance: none;\n    -moz-appearance: textfield;\n    padding: 0px;\n    border: none;\n    outline: none;\n    appearance: none;\n    resize: none;\n    overflow: hidden;\n  }\n"
    ]);
    $fe68049e5a305a6b$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $fe68049e5a305a6b$export$2e2bcd8739ae039 = (0, $2D5eP.css)($fe68049e5a305a6b$var$_templateObject());


parcelRequire("kAqXG");
var $04kNM = parcelRequire("04kNM");
var $334Pv = parcelRequire("334Pv");
parcelRequire("cwWZ7");
var $hZBJb = parcelRequire("hZBJb");
var $3cYIS = parcelRequire("3cYIS");
var $iSNyw = parcelRequire("iSNyw");

function $e4be859866f88fd1$var$_templateObject() {
    var data = (0, $j06k0._)([
        " <wui-flex\n      @click=",
        '\n      flexDirection="column"\n      justifyContent="center"\n      gap="4xs"\n      .padding=',
        "\n    >\n      <wui-text\n        ",
        '\n        class="instruction"\n        color="fg-300"\n        variant="medium-400"\n      >\n        Type or\n        <wui-button\n          class="paste"\n          size="md"\n          variant="neutral"\n          iconLeft="copy"\n          @click=',
        '\n        >\n          <wui-icon size="sm" color="inherit" slot="iconLeft" name="copy"></wui-icon>\n          Paste\n        </wui-button>\n        address\n      </wui-text>\n      <textarea\n        spellcheck="false"\n        ?disabled=',
        "\n        ",
        "\n        @input=",
        "\n        @blur=",
        "\n        .value=",
        '\n        autocomplete="off"\n      >\n',
        "</textarea\n      >\n    </wui-flex>"
    ]);
    $e4be859866f88fd1$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $e4be859866f88fd1$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $e4be859866f88fd1$export$a34d851a88071b13 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mInputAddress, LitElement);
    var _super = (0, $ohfOJ._)(W3mInputAddress);
    function W3mInputAddress() {
        (0, $4GJKx._)(this, W3mInputAddress);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.inputElementRef = (0, $89642349f29deca8$export$7d1e3a5e95ceca43)();
        _this.instructionElementRef = (0, $89642349f29deca8$export$7d1e3a5e95ceca43)();
        _this.instructionHidden = Boolean(_this.value);
        _this.pasting = false;
        _this.onDebouncedSearch = (0, $hZBJb.CoreHelperUtil).debounce(function() {
            var _ref = (0, $kSuI9._)(function(value) {
                var address, avatar;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0, $3cYIS.ConnectionController).getEnsAddress(value)
                            ];
                        case 1:
                            address = _state.sent();
                            (0, $iSNyw.SendController).setLoading(false);
                            if (!address) return [
                                3,
                                3
                            ];
                            (0, $iSNyw.SendController).setReceiverProfileName(value);
                            (0, $iSNyw.SendController).setReceiverAddress(address);
                            return [
                                4,
                                (0, $3cYIS.ConnectionController).getEnsAvatar(value)
                            ];
                        case 2:
                            avatar = _state.sent();
                            if (avatar) (0, $iSNyw.SendController).setReceiverProfileImageUrl(avatar);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            (0, $iSNyw.SendController).setReceiverAddress(value);
                            (0, $iSNyw.SendController).setReceiverProfileName(undefined);
                            (0, $iSNyw.SendController).setReceiverProfileImageUrl(undefined);
                            _state.label = 4;
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(value) {
                return _ref.apply(this, arguments);
            };
        }());
        return _this;
    }
    (0, $1wc17._)(W3mInputAddress, [
        {
            key: "firstUpdated",
            value: function firstUpdated() {
                if (this.value) this.instructionHidden = true;
                this.checkHidden();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_value, _this_value1;
                return (0, $hxyOZ.html)($e4be859866f88fd1$var$_templateObject(), this.onBoxClick.bind(this), [
                    "2xl",
                    "l",
                    "xl",
                    "l"
                ], (0, $89642349f29deca8$export$eff4d24c3ff7876e)(this.instructionElementRef), this.onPasteClick.bind(this), !this.instructionHidden, (0, $89642349f29deca8$export$eff4d24c3ff7876e)(this.inputElementRef), this.onInputChange.bind(this), this.onBlur.bind(this), (_this_value = this.value) !== null && _this_value !== void 0 ? _this_value : "", (_this_value1 = this.value) !== null && _this_value1 !== void 0 ? _this_value1 : "");
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _this_inputElementRef_value;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.instructionElementRef.value) return [
                                    3,
                                    2
                                ];
                                _this.instructionHidden = true;
                                return [
                                    4,
                                    _this.toggleInstructionFocus(false)
                                ];
                            case 1:
                                _state.sent();
                                _this.instructionElementRef.value.style.pointerEvents = "none";
                                (_this_inputElementRef_value = _this.inputElementRef.value) === null || _this_inputElementRef_value === void 0 ? void 0 : _this_inputElementRef_value.focus();
                                if (_this.inputElementRef.value) _this.inputElementRef.value.selectionStart = _this.inputElementRef.value.selectionEnd = _this.inputElementRef.value.value.length;
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "focusInstruction",
            value: function focusInstruction() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _this_inputElementRef_value;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.instructionElementRef.value) return [
                                    3,
                                    2
                                ];
                                _this.instructionHidden = false;
                                return [
                                    4,
                                    _this.toggleInstructionFocus(true)
                                ];
                            case 1:
                                _state.sent();
                                _this.instructionElementRef.value.style.pointerEvents = "auto";
                                (_this_inputElementRef_value = _this.inputElementRef.value) === null || _this_inputElementRef_value === void 0 ? void 0 : _this_inputElementRef_value.blur();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "toggleInstructionFocus",
            value: function toggleInstructionFocus(focus) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.instructionElementRef.value) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.instructionElementRef.value.animate([
                                        {
                                            opacity: focus ? 0 : 1
                                        },
                                        {
                                            opacity: focus ? 1 : 0
                                        }
                                    ], {
                                        duration: 100,
                                        easing: "ease",
                                        fill: "forwards"
                                    }).finished
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onBoxClick",
            value: function onBoxClick() {
                if (!this.value && !this.instructionHidden) this.focusInput();
            }
        },
        {
            key: "onBlur",
            value: function onBlur() {
                if (!this.value && this.instructionHidden && !this.pasting) this.focusInstruction();
            }
        },
        {
            key: "checkHidden",
            value: function checkHidden() {
                if (this.instructionHidden) this.focusInput();
            }
        },
        {
            key: "onPasteClick",
            value: function onPasteClick() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var text;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.pasting = true;
                                return [
                                    4,
                                    navigator.clipboard.readText()
                                ];
                            case 1:
                                text = _state.sent();
                                (0, $iSNyw.SendController).setReceiverAddress(text);
                                _this.focusInput();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(e) {
                this.pasting = false;
                var element = e.target;
                if (element.value && !this.instructionHidden) this.focusInput();
                (0, $iSNyw.SendController).setLoading(true);
                this.onDebouncedSearch(element.value);
            }
        }
    ]);
    return W3mInputAddress;
}((0, $2yD3e.LitElement));
$e4be859866f88fd1$export$a34d851a88071b13.styles = (0, $fe68049e5a305a6b$export$2e2bcd8739ae039);
$e4be859866f88fd1$var$__decorate([
    (0, $04kNM.property)()
], $e4be859866f88fd1$export$a34d851a88071b13.prototype, "value", void 0);
$e4be859866f88fd1$var$__decorate([
    (0, $334Pv.state)()
], $e4be859866f88fd1$export$a34d851a88071b13.prototype, "instructionHidden", void 0);
$e4be859866f88fd1$var$__decorate([
    (0, $334Pv.state)()
], $e4be859866f88fd1$export$a34d851a88071b13.prototype, "pasting", void 0);
$e4be859866f88fd1$export$a34d851a88071b13 = $e4be859866f88fd1$var$__decorate([
    (0, $hdxb6.customElement)("w3m-input-address")
], $e4be859866f88fd1$export$a34d851a88071b13);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("grHtr");
var $dI7zX = parcelRequire("dI7zX");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $a5bf9d727580abc5$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    display: flex;\n    width: auto;\n    flex-direction: column;\n    gap: var(--wui-border-radius-1xs);\n    border-radius: var(--wui-border-radius-s);\n    background: var(--wui-color-gray-glass-002);\n    padding: var(--wui-spacing-s) var(--wui-spacing-1xs) var(--wui-spacing-1xs)\n      var(--wui-spacing-1xs);\n  }\n\n  wui-text {\n    padding: 0 var(--wui-spacing-1xs);\n  }\n\n  wui-flex {\n    margin-top: var(--wui-spacing-1xs);\n  }\n\n  .network {\n    cursor: pointer;\n    transition: background-color var(--wui-ease-out-power-1) var(--wui-duration-lg);\n    will-change: background-color;\n  }\n\n  .network:focus-visible {\n    border: 1px solid var(--wui-color-accent-100);\n    background-color: var(--wui-color-gray-glass-005);\n    -webkit-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);\n    -moz-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);\n    box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);\n  }\n\n  .network:hover {\n    background-color: var(--wui-color-gray-glass-005);\n  }\n\n  .network:active {\n    background-color: var(--wui-color-gray-glass-010);\n  }\n"
    ]);
    $a5bf9d727580abc5$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $a5bf9d727580abc5$export$2e2bcd8739ae039 = (0, $2D5eP.css)($a5bf9d727580abc5$var$_templateObject());


parcelRequire("kAqXG");
var $04kNM = parcelRequire("04kNM");
parcelRequire("cwWZ7");
var $khm6W = parcelRequire("khm6W");
var $iptjJ = parcelRequire("iptjJ");

function $9a6795bb64c6dd55$var$_templateObject() {
    var data = (0, $j06k0._)([
        ' <wui-text variant="small-400" color="fg-200">Details</wui-text>\n      <wui-flex flexDirection="column" gap="xxs">\n        <wui-list-content textTitle="Network cost" textValue="$',
        '"></wui-list-content></wui-list-content>\n        <wui-list-content\n          textTitle="Address"\n          textValue=',
        "\n        >\n        </wui-list-content>\n        ",
        "\n      </wui-flex>"
    ]);
    $9a6795bb64c6dd55$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $9a6795bb64c6dd55$var$_templateObject1() {
    var data = (0, $j06k0._)([
        " <wui-list-content\n        @click=",
        '\n        class="network"\n        textTitle="Network"\n        imageSrc=',
        "\n      ></wui-list-content>"
    ]);
    $9a6795bb64c6dd55$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $9a6795bb64c6dd55$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9a6795bb64c6dd55$export$bfe01ba2d6f78539 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mWalletSendDetails, LitElement);
    var _super = (0, $ohfOJ._)(W3mWalletSendDetails);
    function W3mWalletSendDetails() {
        (0, $4GJKx._)(this, W3mWalletSendDetails);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(W3mWalletSendDetails, [
        {
            key: "render",
            value: function render() {
                var _this_receiverAddress;
                return (0, $hxyOZ.html)($9a6795bb64c6dd55$var$_templateObject(), (0, $696d14fc702af3d6$export$f68dd208b5df064d)((0, $dI7zX.UiHelperUtil).formatNumberToLocalString(this.networkFee, 2)), (0, $dI7zX.UiHelperUtil).getTruncateString({
                    string: (_this_receiverAddress = this.receiverAddress) !== null && _this_receiverAddress !== void 0 ? _this_receiverAddress : "",
                    charsStart: 4,
                    charsEnd: 4,
                    truncate: "middle"
                }), this.networkTemplate());
            }
        },
        {
            key: "networkTemplate",
            value: function networkTemplate() {
                var _this = this;
                var _this_caipNetwork;
                if ((_this_caipNetwork = this.caipNetwork) === null || _this_caipNetwork === void 0 ? void 0 : _this_caipNetwork.name) return (0, $hxyOZ.html)($9a6795bb64c6dd55$var$_templateObject1(), function() {
                    return _this.onNetworkClick(_this.caipNetwork);
                }, (0, $696d14fc702af3d6$export$f68dd208b5df064d)((0, $khm6W.AssetUtil).getNetworkImage(this.caipNetwork)));
                return null;
            }
        },
        {
            key: "onNetworkClick",
            value: function onNetworkClick(network) {
                if (network) (0, $iptjJ.RouterController).push("Networks", {
                    network: network
                });
            }
        }
    ]);
    return W3mWalletSendDetails;
}((0, $2yD3e.LitElement));
$9a6795bb64c6dd55$export$bfe01ba2d6f78539.styles = (0, $a5bf9d727580abc5$export$2e2bcd8739ae039);
$9a6795bb64c6dd55$var$__decorate([
    (0, $04kNM.property)()
], $9a6795bb64c6dd55$export$bfe01ba2d6f78539.prototype, "receiverAddress", void 0);
$9a6795bb64c6dd55$var$__decorate([
    (0, $04kNM.property)({
        type: Object
    })
], $9a6795bb64c6dd55$export$bfe01ba2d6f78539.prototype, "caipNetwork", void 0);
$9a6795bb64c6dd55$var$__decorate([
    (0, $04kNM.property)({
        type: Number
    })
], $9a6795bb64c6dd55$export$bfe01ba2d6f78539.prototype, "networkFee", void 0);
$9a6795bb64c6dd55$export$bfe01ba2d6f78539 = $9a6795bb64c6dd55$var$__decorate([
    (0, $hdxb6.customElement)("w3m-wallet-send-details")
], $9a6795bb64c6dd55$export$bfe01ba2d6f78539);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("cwWZ7");
var $5R7lI = parcelRequire("5R7lI");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $ffeb511e08bcc68c$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    pointer-events: none;\n  }\n\n  :host > wui-flex {\n    display: var(--w3m-tooltip-display);\n    opacity: var(--w3m-tooltip-opacity);\n    padding: 9px var(--wui-spacing-s) 10px var(--wui-spacing-s);\n    border-radius: var(--wui-border-radius-xxs);\n    color: var(--wui-color-bg-100);\n    position: fixed;\n    top: var(--w3m-tooltip-top);\n    left: var(--w3m-tooltip-left);\n    transform: translate(calc(-50% + var(--w3m-tooltip-parent-width)), calc(-100% - 8px));\n    max-width: calc(var(--w3m-modal-width) - var(--wui-spacing-xl));\n    transition: opacity 0.2s var(--wui-ease-out-power-2);\n    will-change: opacity;\n  }\n\n  :host([data-variant='shade']) > wui-flex {\n    background-color: var(--wui-color-bg-150);\n    border: 1px solid var(--wui-color-gray-glass-005);\n  }\n\n  :host([data-variant='shade']) > wui-flex > wui-text {\n    color: var(--wui-color-fg-150);\n  }\n\n  :host([data-variant='fill']) > wui-flex {\n    background-color: var(--wui-color-fg-100);\n    border: none;\n  }\n\n  wui-icon {\n    position: absolute;\n    width: 12px !important;\n    height: 4px !important;\n    color: var(--wui-color-bg-150);\n  }\n\n  wui-icon[data-placement='top'] {\n    bottom: 0px;\n    left: 50%;\n    transform: translate(-50%, 95%);\n  }\n\n  wui-icon[data-placement='bottom'] {\n    top: 0;\n    left: 50%;\n    transform: translate(-50%, -95%) rotate(180deg);\n  }\n\n  wui-icon[data-placement='right'] {\n    top: 50%;\n    left: 0;\n    transform: translate(-65%, -50%) rotate(90deg);\n  }\n\n  wui-icon[data-placement='left'] {\n    top: 50%;\n    right: 0%;\n    transform: translate(65%, -50%) rotate(270deg);\n  }\n"
    ]);
    $ffeb511e08bcc68c$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $ffeb511e08bcc68c$export$2e2bcd8739ae039 = (0, $2D5eP.css)($ffeb511e08bcc68c$var$_templateObject());


function $abd272bd2fe60c6f$var$_templateObject() {
    var data = (0, $j06k0._)([
        '<wui-flex>\n      <wui-icon data-placement="top" color="fg-100" size="inherit" name="cursor"></wui-icon>\n      <wui-text color="inherit" variant="small-500">',
        "</wui-text>\n    </wui-flex>"
    ]);
    $abd272bd2fe60c6f$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $abd272bd2fe60c6f$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $abd272bd2fe60c6f$export$690e052e08bb9d48 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mTooltip, LitElement);
    var _super = (0, $ohfOJ._)(W3mTooltip);
    function W3mTooltip() {
        var _this_unsubscribe;
        (0, $4GJKx._)(this, W3mTooltip);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.open = (0, $5R7lI.TooltipController).state.open;
        _this.message = (0, $5R7lI.TooltipController).state.message;
        _this.triggerRect = (0, $5R7lI.TooltipController).state.triggerRect;
        _this.variant = (0, $5R7lI.TooltipController).state.variant;
        (_this_unsubscribe = _this.unsubscribe).push.apply(_this_unsubscribe, [
            (0, $5R7lI.TooltipController).subscribe(function(newState) {
                _this.open = newState.open;
                _this.message = newState.message;
                _this.triggerRect = newState.triggerRect;
                _this.variant = newState.variant;
            })
        ]);
        return _this;
    }
    (0, $1wc17._)(W3mTooltip, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                this.dataset["variant"] = this.variant;
                var topValue = this.triggerRect.top;
                var leftValue = this.triggerRect.left;
                this.style.cssText = "\n    --w3m-tooltip-top: ".concat(topValue, "px;\n    --w3m-tooltip-left: ").concat(leftValue, "px;\n    --w3m-tooltip-parent-width: ").concat(this.triggerRect.width / 2, "px;\n    --w3m-tooltip-display: ").concat(this.open ? "flex" : "none", ";\n    --w3m-tooltip-opacity: ").concat(this.open ? 1 : 0, ";\n    ");
                return (0, $hxyOZ.html)($abd272bd2fe60c6f$var$_templateObject(), this.message);
            }
        }
    ]);
    return W3mTooltip;
}((0, $2yD3e.LitElement));
$abd272bd2fe60c6f$export$690e052e08bb9d48.styles = [
    (0, $ffeb511e08bcc68c$export$2e2bcd8739ae039)
];
$abd272bd2fe60c6f$var$__decorate([
    (0, $334Pv.state)()
], $abd272bd2fe60c6f$export$690e052e08bb9d48.prototype, "open", void 0);
$abd272bd2fe60c6f$var$__decorate([
    (0, $334Pv.state)()
], $abd272bd2fe60c6f$export$690e052e08bb9d48.prototype, "message", void 0);
$abd272bd2fe60c6f$var$__decorate([
    (0, $334Pv.state)()
], $abd272bd2fe60c6f$export$690e052e08bb9d48.prototype, "triggerRect", void 0);
$abd272bd2fe60c6f$var$__decorate([
    (0, $334Pv.state)()
], $abd272bd2fe60c6f$export$690e052e08bb9d48.prototype, "variant", void 0);
$abd272bd2fe60c6f$export$690e052e08bb9d48 = $abd272bd2fe60c6f$var$__decorate([
    (0, $hdxb6.customElement)("w3m-tooltip")
], $abd272bd2fe60c6f$export$690e052e08bb9d48);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $04kNM = parcelRequire("04kNM");
var $334Pv = parcelRequire("334Pv");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $457a0c71439b0e64$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    width: 100%;\n    display: block;\n  }\n"
    ]);
    $457a0c71439b0e64$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $457a0c71439b0e64$export$2e2bcd8739ae039 = (0, $2D5eP.css)($457a0c71439b0e64$var$_templateObject());


parcelRequire("cwWZ7");
var $5R7lI = parcelRequire("5R7lI");
var $iptjJ = parcelRequire("iptjJ");
var $5Lhe6 = parcelRequire("5Lhe6");
function $f6ce423c1f5d9b79$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      <div\n        @pointermove=",
        "\n        @pointerleave=",
        "\n      >\n        ",
        "\n      </div>\n    "
    ]);
    $f6ce423c1f5d9b79$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $f6ce423c1f5d9b79$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "<slot></slot> "
    ]);
    $f6ce423c1f5d9b79$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $f6ce423c1f5d9b79$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f6ce423c1f5d9b79$export$24079ca0bc8e6c8d = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(WuiTooltipTrigger, LitElement);
    var _super = (0, $ohfOJ._)(WuiTooltipTrigger);
    function WuiTooltipTrigger() {
        (0, $4GJKx._)(this, WuiTooltipTrigger);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.text = "";
        _this.open = (0, $5R7lI.TooltipController).state.open;
        _this.unsubscribe.push((0, $iptjJ.RouterController).subscribeKey("view", function() {
            (0, $5R7lI.TooltipController).hide();
        }), (0, $5Lhe6.ModalController).subscribeKey("open", function(modalOpen) {
            if (!modalOpen) (0, $5R7lI.TooltipController).hide();
        }), (0, $5R7lI.TooltipController).subscribeKey("open", function(tooltipOpen) {
            _this.open = tooltipOpen;
        }));
        return _this;
    }
    (0, $1wc17._)(WuiTooltipTrigger, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
                (0, $5R7lI.TooltipController).hide();
            }
        },
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($f6ce423c1f5d9b79$var$_templateObject(), this.onMouseEnter.bind(this), this.onMouseLeave.bind(this), this.renderChildren());
            }
        },
        {
            key: "renderChildren",
            value: function renderChildren() {
                return (0, $hxyOZ.html)($f6ce423c1f5d9b79$var$_templateObject1());
            }
        },
        {
            key: "onMouseEnter",
            value: function onMouseEnter() {
                var rect = this.getBoundingClientRect();
                if (!this.open) (0, $5R7lI.TooltipController).showTooltip({
                    message: this.text,
                    triggerRect: {
                        width: rect.width,
                        height: rect.height,
                        left: rect.left,
                        top: rect.top
                    },
                    variant: "shade"
                });
            }
        },
        {
            key: "onMouseLeave",
            value: function onMouseLeave(event) {
                if (!this.contains(event.relatedTarget)) (0, $5R7lI.TooltipController).hide();
            }
        }
    ]);
    return WuiTooltipTrigger;
}((0, $2yD3e.LitElement));
$f6ce423c1f5d9b79$export$24079ca0bc8e6c8d.styles = [
    (0, $457a0c71439b0e64$export$2e2bcd8739ae039)
];
$f6ce423c1f5d9b79$var$__decorate([
    (0, $04kNM.property)()
], $f6ce423c1f5d9b79$export$24079ca0bc8e6c8d.prototype, "text", void 0);
$f6ce423c1f5d9b79$var$__decorate([
    (0, $334Pv.state)()
], $f6ce423c1f5d9b79$export$24079ca0bc8e6c8d.prototype, "open", void 0);
$f6ce423c1f5d9b79$export$24079ca0bc8e6c8d = $f6ce423c1f5d9b79$var$__decorate([
    (0, $hdxb6.customElement)("w3m-tooltip-trigger")
], $f6ce423c1f5d9b79$export$24079ca0bc8e6c8d);



var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("cwWZ7");
var $2qlRb = parcelRequire("2qlRb");
var $iptjJ = parcelRequire("iptjJ");
var $dMLJP = parcelRequire("dMLJP");
var $9zDWP = parcelRequire("9zDWP");
var $1QDT9 = parcelRequire("1QDT9");
var $8FcCV = parcelRequire("8FcCV");
var $hZBJb = parcelRequire("hZBJb");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $6174a0dfea8afd20$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host > wui-flex:first-child {\n    margin-top: var(--wui-spacing-s);\n  }\n  wui-separator {\n    margin: var(--wui-spacing-m) calc(var(--wui-spacing-m) * -1) var(--wui-spacing-m)\n      calc(var(--wui-spacing-m) * -1);\n    width: calc(100% + var(--wui-spacing-s) * 2);\n  }\n"
    ]);
    $6174a0dfea8afd20$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $6174a0dfea8afd20$export$2e2bcd8739ae039 = (0, $2D5eP.css)($6174a0dfea8afd20$var$_templateObject());




function $16a6e25aee8d6878$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex\n        class="container"\n        flexDirection="column"\n        gap="xs"\n        .padding=',
        '\n        data-testid="w3m-social-login-widget"\n      >\n        ',
        "",
        "\n      </wui-flex>\n      ",
        "\n    "
    ]);
    $16a6e25aee8d6878$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $16a6e25aee8d6878$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "<wui-logo-select\n              data-testid=",
        "\n              @click=",
        "\n              logo=",
        "\n            ></wui-logo-select>"
    ]);
    $16a6e25aee8d6878$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $16a6e25aee8d6878$var$_templateObject2() {
    var data = (0, $j06k0._)([
        ' <wui-flex gap="xs">\n        ',
        "\n      </wui-flex>"
    ]);
    $16a6e25aee8d6878$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $16a6e25aee8d6878$var$_templateObject3() {
    var data = (0, $j06k0._)([
        " <wui-list-social\n      data-testid=",
        "\n      @click=",
        "\n      logo=",
        '\n      align="center"\n      name=',
        "\n    ></wui-list-social>"
    ]);
    $16a6e25aee8d6878$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $16a6e25aee8d6878$var$_templateObject4() {
    var data = (0, $j06k0._)([
        "<wui-logo-select\n              data-testid=",
        "\n              @click=",
        "\n              logo=",
        "\n            ></wui-logo-select>"
    ]);
    $16a6e25aee8d6878$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $16a6e25aee8d6878$var$_templateObject5() {
    var data = (0, $j06k0._)([
        '<wui-flex gap="xs">\n        ',
        '\n        <wui-logo-select logo="more" @click=',
        "></wui-logo-select>\n      </wui-flex>"
    ]);
    $16a6e25aee8d6878$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $16a6e25aee8d6878$var$_templateObject6() {
    var data = (0, $j06k0._)([
        "<wui-logo-select\n            data-testid=",
        "\n            @click=",
        "\n            logo=",
        "\n          ></wui-logo-select>"
    ]);
    $16a6e25aee8d6878$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $16a6e25aee8d6878$var$_templateObject7() {
    var data = (0, $j06k0._)([
        '<wui-flex gap="xs">\n      ',
        "\n    </wui-flex>"
    ]);
    $16a6e25aee8d6878$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $16a6e25aee8d6878$var$_templateObject8() {
    var data = (0, $j06k0._)([
        '<wui-separator text="or"></wui-separator>'
    ]);
    $16a6e25aee8d6878$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
var $16a6e25aee8d6878$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $16a6e25aee8d6878$var$MAX_TOP_VIEW = 2;
var $16a6e25aee8d6878$var$MAXIMUM_LENGTH = 6;
var $16a6e25aee8d6878$export$eedc45ff45b02ce3 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mSocialLoginWidget, LitElement);
    var _super = (0, $ohfOJ._)(W3mSocialLoginWidget);
    function W3mSocialLoginWidget() {
        (0, $4GJKx._)(this, W3mSocialLoginWidget);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.connectors = (0, $2qlRb.ConnectorController).state.connectors;
        _this.connector = _this.connectors.find(function(c) {
            return c.type === "AUTH";
        });
        _this.unsubscribe.push((0, $2qlRb.ConnectorController).subscribeKey("connectors", function(val) {
            _this.connectors = val;
            _this.connector = _this.connectors.find(function(c) {
                return c.type === "AUTH";
            });
        }));
        return _this;
    }
    (0, $1wc17._)(W3mSocialLoginWidget, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_connector;
                if (!((_this_connector = this.connector) === null || _this_connector === void 0 ? void 0 : _this_connector.socials)) return null;
                return (0, $hxyOZ.html)($16a6e25aee8d6878$var$_templateObject(), [
                    "0",
                    "0",
                    "xs",
                    "0"
                ], this.topViewTemplate(), this.bottomViewTemplate(), this.separatorTemplate());
            }
        },
        {
            key: "topViewTemplate",
            value: function topViewTemplate() {
                var _this = this;
                var _this_connector, _this_connector_socials, _this_connector1;
                if (!((_this_connector = this.connector) === null || _this_connector === void 0 ? void 0 : _this_connector.socials)) return null;
                if (this.connector.socials.length === 2) return (0, $hxyOZ.html)($16a6e25aee8d6878$var$_templateObject2(), this.connector.socials.slice(0, $16a6e25aee8d6878$var$MAX_TOP_VIEW).map(function(social) {
                    return (0, $hxyOZ.html)($16a6e25aee8d6878$var$_templateObject1(), "social-selector-".concat(social), function() {
                        _this.onSocialClick(social);
                    }, social);
                }));
                return (0, $hxyOZ.html)($16a6e25aee8d6878$var$_templateObject3(), "social-selector-".concat((_this_connector1 = this.connector) === null || _this_connector1 === void 0 ? void 0 : (_this_connector_socials = _this_connector1.socials) === null || _this_connector_socials === void 0 ? void 0 : _this_connector_socials[0]), function() {
                    var _this_connector_socials, _this_connector;
                    _this.onSocialClick((_this_connector = _this.connector) === null || _this_connector === void 0 ? void 0 : (_this_connector_socials = _this_connector.socials) === null || _this_connector_socials === void 0 ? void 0 : _this_connector_socials[0]);
                }, (0, $696d14fc702af3d6$export$f68dd208b5df064d)(this.connector.socials[0]), "Continue with ".concat(this.connector.socials[0]));
            }
        },
        {
            key: "bottomViewTemplate",
            value: function bottomViewTemplate() {
                var _this = this;
                var _this_connector, _this_connector1, _this_connector2;
                if (!((_this_connector = this.connector) === null || _this_connector === void 0 ? void 0 : _this_connector.socials)) return null;
                if (((_this_connector1 = this.connector) === null || _this_connector1 === void 0 ? void 0 : _this_connector1.socials.length) <= $16a6e25aee8d6878$var$MAX_TOP_VIEW) return null;
                if (((_this_connector2 = this.connector) === null || _this_connector2 === void 0 ? void 0 : _this_connector2.socials.length) > $16a6e25aee8d6878$var$MAXIMUM_LENGTH) return (0, $hxyOZ.html)($16a6e25aee8d6878$var$_templateObject5(), this.connector.socials.slice(1, $16a6e25aee8d6878$var$MAXIMUM_LENGTH - 1).map(function(social) {
                    return (0, $hxyOZ.html)($16a6e25aee8d6878$var$_templateObject4(), "social-selector-".concat(social), function() {
                        _this.onSocialClick(social);
                    }, social);
                }), this.onMoreSocialsClick.bind(this));
                return (0, $hxyOZ.html)($16a6e25aee8d6878$var$_templateObject7(), this.connector.socials.slice(1, this.connector.socials.length).map(function(social) {
                    return (0, $hxyOZ.html)($16a6e25aee8d6878$var$_templateObject6(), "social-selector-".concat(social), function() {
                        _this.onSocialClick(social);
                    }, social);
                }));
            }
        },
        {
            key: "separatorTemplate",
            value: function separatorTemplate() {
                var walletConnectConnector = this.connectors.find(function(c) {
                    return c.type === "WALLET_CONNECT";
                });
                if (walletConnectConnector) return (0, $hxyOZ.html)($16a6e25aee8d6878$var$_templateObject8());
                return null;
            }
        },
        {
            key: "onMoreSocialsClick",
            value: function onMoreSocialsClick() {
                (0, $iptjJ.RouterController).push("ConnectSocials");
            }
        },
        {
            key: "onSocialClick",
            value: function onSocialClick(socialProvider) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var authConnector, url, error, authConnector1, uri, _this_popupWindow, error1, _this_popupWindow1;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (socialProvider) {
                                    (0, $dMLJP.AccountController).setSocialProvider(socialProvider, (0, $9zDWP.ChainController).state.activeChain);
                                    (0, $1QDT9.EventsController).sendEvent({
                                        type: "track",
                                        event: "SOCIAL_LOGIN_STARTED",
                                        properties: {
                                            provider: socialProvider
                                        }
                                    });
                                }
                                if (!(socialProvider === (0, $9395b52ba8ad701f$export$d69f2df2005140cd).Farcaster)) return [
                                    3,
                                    5
                                ];
                                (0, $iptjJ.RouterController).push("ConnectingFarcaster");
                                authConnector = (0, $2qlRb.ConnectorController).getAuthConnector();
                                if (!authConnector) return [
                                    3,
                                    4
                                ];
                                if (!!(0, $dMLJP.AccountController).state.farcasterUrl) return [
                                    3,
                                    4
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    authConnector.provider.getFarcasterUri()
                                ];
                            case 2:
                                url = _state.sent().url;
                                (0, $dMLJP.AccountController).setFarcasterUrl(url, (0, $9zDWP.ChainController).state.activeChain);
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                (0, $iptjJ.RouterController).goBack();
                                (0, $8FcCV.SnackController).showError(error);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    3,
                                    10
                                ];
                            case 5:
                                (0, $iptjJ.RouterController).push("ConnectingSocial");
                                authConnector1 = (0, $2qlRb.ConnectorController).getAuthConnector();
                                _this.popupWindow = (0, $hZBJb.CoreHelperUtil).returnOpenHref("", "popupWindow", "width=600,height=800,scrollbars=yes");
                                _state.label = 6;
                            case 6:
                                _state.trys.push([
                                    6,
                                    9,
                                    ,
                                    10
                                ]);
                                if (!(authConnector1 && socialProvider)) return [
                                    3,
                                    8
                                ];
                                return [
                                    4,
                                    authConnector1.provider.getSocialRedirectUri({
                                        provider: socialProvider
                                    })
                                ];
                            case 7:
                                uri = _state.sent().uri;
                                if (_this.popupWindow && uri) {
                                    (0, $dMLJP.AccountController).setSocialWindow(_this.popupWindow, (0, $9zDWP.ChainController).state.activeChain);
                                    _this.popupWindow.location.href = uri;
                                } else {
                                    ;
                                    (_this_popupWindow = _this.popupWindow) === null || _this_popupWindow === void 0 ? void 0 : _this_popupWindow.close();
                                    throw new Error("Something went wrong");
                                }
                                _state.label = 8;
                            case 8:
                                return [
                                    3,
                                    10
                                ];
                            case 9:
                                error1 = _state.sent();
                                (_this_popupWindow1 = _this.popupWindow) === null || _this_popupWindow1 === void 0 ? void 0 : _this_popupWindow1.close();
                                (0, $8FcCV.SnackController).showError("Something went wrong");
                                return [
                                    3,
                                    10
                                ];
                            case 10:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return W3mSocialLoginWidget;
}((0, $2yD3e.LitElement));
$16a6e25aee8d6878$export$eedc45ff45b02ce3.styles = (0, $6174a0dfea8afd20$export$2e2bcd8739ae039);
$16a6e25aee8d6878$var$__decorate([
    (0, $334Pv.state)()
], $16a6e25aee8d6878$export$eedc45ff45b02ce3.prototype, "connectors", void 0);
$16a6e25aee8d6878$export$eedc45ff45b02ce3 = $16a6e25aee8d6878$var$__decorate([
    (0, $hdxb6.customElement)("w3m-social-login-widget")
], $16a6e25aee8d6878$export$eedc45ff45b02ce3);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
function $547b4e309340c8a2$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column" gap="xs">\n        <w3m-connector-list></w3m-connector-list>\n        <w3m-all-wallets-widget></w3m-all-wallets-widget>\n      </wui-flex>\n    '
    ]);
    $547b4e309340c8a2$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $547b4e309340c8a2$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $547b4e309340c8a2$export$f3f7a152cb46e6bf = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mWalletLoginList, LitElement);
    var _super = (0, $ohfOJ._)(W3mWalletLoginList);
    function W3mWalletLoginList() {
        (0, $4GJKx._)(this, W3mWalletLoginList);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(W3mWalletLoginList, [
        {
            key: "render",
            value: function render() {
                return (0, $hxyOZ.html)($547b4e309340c8a2$var$_templateObject());
            }
        }
    ]);
    return W3mWalletLoginList;
}((0, $2yD3e.LitElement));
$547b4e309340c8a2$export$f3f7a152cb46e6bf = $547b4e309340c8a2$var$__decorate([
    (0, $hdxb6.customElement)("w3m-wallet-login-list")
], $547b4e309340c8a2$export$f3f7a152cb46e6bf);



var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("cwWZ7");
var $2qlRb = parcelRequire("2qlRb");
var $dMLJP = parcelRequire("dMLJP");
var $9zDWP = parcelRequire("9zDWP");
var $1QDT9 = parcelRequire("1QDT9");
var $iptjJ = parcelRequire("iptjJ");
var $8FcCV = parcelRequire("8FcCV");
var $hZBJb = parcelRequire("hZBJb");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $f9d01786a9b94c75$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    margin-top: var(--wui-spacing-3xs);\n  }\n  wui-separator {\n    margin: var(--wui-spacing-m) calc(var(--wui-spacing-m) * -1) var(--wui-spacing-xs)\n      calc(var(--wui-spacing-m) * -1);\n    width: calc(100% + var(--wui-spacing-s) * 2);\n  }\n"
    ]);
    $f9d01786a9b94c75$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $f9d01786a9b94c75$export$2e2bcd8739ae039 = (0, $2D5eP.css)($f9d01786a9b94c75$var$_templateObject());



function $0799a545aef374b8$var$_templateObject() {
    var data = (0, $j06k0._)([
        "<wui-list-social\n            @click=",
        "\n            name=",
        "\n            logo=",
        "\n          ></wui-list-social>"
    ]);
    $0799a545aef374b8$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $0799a545aef374b8$var$_templateObject1() {
    var data = (0, $j06k0._)([
        ' <wui-flex flexDirection="column" gap="xs">\n      ',
        "\n    </wui-flex>"
    ]);
    $0799a545aef374b8$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $0799a545aef374b8$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $0799a545aef374b8$export$ce5dbfa5d115479d = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mSocialLoginList, LitElement);
    var _super = (0, $ohfOJ._)(W3mSocialLoginList);
    function W3mSocialLoginList() {
        (0, $4GJKx._)(this, W3mSocialLoginList);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.connectors = (0, $2qlRb.ConnectorController).state.connectors;
        _this.connector = _this.connectors.find(function(c) {
            return c.type === "AUTH";
        });
        _this.unsubscribe.push((0, $2qlRb.ConnectorController).subscribeKey("connectors", function(val) {
            _this.connectors = val;
            _this.connector = _this.connectors.find(function(c) {
                return c.type === "AUTH";
            });
        }));
        return _this;
    }
    (0, $1wc17._)(W3mSocialLoginList, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_connector;
                if (!((_this_connector = this.connector) === null || _this_connector === void 0 ? void 0 : _this_connector.socials)) return null;
                return (0, $hxyOZ.html)($0799a545aef374b8$var$_templateObject1(), this.connector.socials.map(function(social) {
                    return (0, $hxyOZ.html)($0799a545aef374b8$var$_templateObject(), function() {
                        _this.onSocialClick(social);
                    }, social, social);
                }));
            }
        },
        {
            key: "onSocialClick",
            value: function onSocialClick(socialProvider) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var authConnector, url, error, authConnector1, uri, _this_popupWindow, error1, _this_popupWindow1;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (socialProvider) {
                                    (0, $dMLJP.AccountController).setSocialProvider(socialProvider, (0, $9zDWP.ChainController).state.activeChain);
                                    (0, $1QDT9.EventsController).sendEvent({
                                        type: "track",
                                        event: "SOCIAL_LOGIN_STARTED",
                                        properties: {
                                            provider: socialProvider
                                        }
                                    });
                                }
                                if (!(socialProvider === (0, $9395b52ba8ad701f$export$d69f2df2005140cd).Farcaster)) return [
                                    3,
                                    5
                                ];
                                (0, $iptjJ.RouterController).push("ConnectingFarcaster");
                                authConnector = (0, $2qlRb.ConnectorController).getAuthConnector();
                                if (!authConnector) return [
                                    3,
                                    4
                                ];
                                if (!!(0, $dMLJP.AccountController).state.farcasterUrl) return [
                                    3,
                                    4
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    authConnector.provider.getFarcasterUri()
                                ];
                            case 2:
                                url = _state.sent().url;
                                (0, $dMLJP.AccountController).setFarcasterUrl(url, (0, $9zDWP.ChainController).state.activeChain);
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                (0, $iptjJ.RouterController).goBack();
                                (0, $8FcCV.SnackController).showError(error);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    3,
                                    10
                                ];
                            case 5:
                                (0, $iptjJ.RouterController).push("ConnectingSocial");
                                authConnector1 = (0, $2qlRb.ConnectorController).getAuthConnector();
                                _this.popupWindow = (0, $hZBJb.CoreHelperUtil).returnOpenHref("", "popupWindow", "width=600,height=800,scrollbars=yes");
                                _state.label = 6;
                            case 6:
                                _state.trys.push([
                                    6,
                                    9,
                                    ,
                                    10
                                ]);
                                if (!(authConnector1 && socialProvider)) return [
                                    3,
                                    8
                                ];
                                return [
                                    4,
                                    authConnector1.provider.getSocialRedirectUri({
                                        provider: socialProvider
                                    })
                                ];
                            case 7:
                                uri = _state.sent().uri;
                                if (_this.popupWindow && uri) {
                                    (0, $dMLJP.AccountController).setSocialWindow(_this.popupWindow, (0, $9zDWP.ChainController).state.activeChain);
                                    _this.popupWindow.location.href = uri;
                                } else {
                                    ;
                                    (_this_popupWindow = _this.popupWindow) === null || _this_popupWindow === void 0 ? void 0 : _this_popupWindow.close();
                                    throw new Error("Something went wrong");
                                }
                                _state.label = 8;
                            case 8:
                                return [
                                    3,
                                    10
                                ];
                            case 9:
                                error1 = _state.sent();
                                (_this_popupWindow1 = _this.popupWindow) === null || _this_popupWindow1 === void 0 ? void 0 : _this_popupWindow1.close();
                                (0, $8FcCV.SnackController).showError("Something went wrong");
                                return [
                                    3,
                                    10
                                ];
                            case 10:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return W3mSocialLoginList;
}((0, $2yD3e.LitElement));
$0799a545aef374b8$export$ce5dbfa5d115479d.styles = (0, $f9d01786a9b94c75$export$2e2bcd8739ae039);
$0799a545aef374b8$var$__decorate([
    (0, $334Pv.state)()
], $0799a545aef374b8$export$ce5dbfa5d115479d.prototype, "connectors", void 0);
$0799a545aef374b8$export$ce5dbfa5d115479d = $0799a545aef374b8$var$__decorate([
    (0, $hdxb6.customElement)("w3m-social-login-list")
], $0799a545aef374b8$export$ce5dbfa5d115479d);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $2qlRb = parcelRequire("2qlRb");
var $hMdcG = parcelRequire("hMdcG");
var $khm6W = parcelRequire("khm6W");
var $hZBJb = parcelRequire("hZBJb");
var $iptjJ = parcelRequire("iptjJ");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");

function $0f080bf4af524743$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n            <wui-list-wallet\n              imageSrc=",
        "\n              name=",
        "\n              @click=",
        '\n              tagVariant="success"\n              tagLabel="installed"\n              data-testid=',
        "\n              .installed=",
        "\n            >\n            </wui-list-wallet>\n          "
    ]);
    $0f080bf4af524743$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $0f080bf4af524743$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column" gap="xs">\n        ',
        "\n      </wui-flex>\n    "
    ]);
    $0f080bf4af524743$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $0f080bf4af524743$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $0f080bf4af524743$export$c9a28c988ae309b = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mConnectAnnouncedWidget, LitElement);
    var _super = (0, $ohfOJ._)(W3mConnectAnnouncedWidget);
    function W3mConnectAnnouncedWidget() {
        (0, $4GJKx._)(this, W3mConnectAnnouncedWidget);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.connectors = (0, $2qlRb.ConnectorController).state.connectors;
        _this.unsubscribe.push((0, $2qlRb.ConnectorController).subscribeKey("connectors", function(val) {
            return _this.connectors = val;
        }));
        return _this;
    }
    (0, $1wc17._)(W3mConnectAnnouncedWidget, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var announcedConnectors = this.connectors.filter(function(connector) {
                    return connector.type === "ANNOUNCED";
                });
                if (!(announcedConnectors === null || announcedConnectors === void 0 ? void 0 : announcedConnectors.length)) {
                    this.style.cssText = "display: none";
                    return null;
                }
                return (0, $hxyOZ.html)($0f080bf4af524743$var$_templateObject1(), announcedConnectors.map(function(connector) {
                    var _connector_info;
                    if (((_connector_info = connector.info) === null || _connector_info === void 0 ? void 0 : _connector_info.rdns) && (0, $hMdcG.ApiController).state.excludedRDNS) {
                        var _connector_info1;
                        if ((0, $hMdcG.ApiController).state.excludedRDNS.includes(connector === null || connector === void 0 ? void 0 : (_connector_info1 = connector.info) === null || _connector_info1 === void 0 ? void 0 : _connector_info1.rdns)) return null;
                    }
                    var _connector_name;
                    return (0, $hxyOZ.html)($0f080bf4af524743$var$_templateObject(), (0, $696d14fc702af3d6$export$f68dd208b5df064d)((0, $khm6W.AssetUtil).getConnectorImage(connector)), (_connector_name = connector.name) !== null && _connector_name !== void 0 ? _connector_name : "Unknown", function() {
                        return _this.onConnector(connector);
                    }, "wallet-selector-".concat(connector.id), true);
                }));
            }
        },
        {
            key: "onConnector",
            value: function onConnector(connector) {
                if (connector.type === "WALLET_CONNECT") {
                    if ((0, $hZBJb.CoreHelperUtil).isMobile()) (0, $iptjJ.RouterController).push("AllWallets");
                    else (0, $iptjJ.RouterController).push("ConnectingWalletConnect");
                } else (0, $iptjJ.RouterController).push("ConnectingExternal", {
                    connector: connector
                });
            }
        }
    ]);
    return W3mConnectAnnouncedWidget;
}((0, $2yD3e.LitElement));
$0f080bf4af524743$var$__decorate([
    (0, $334Pv.state)()
], $0f080bf4af524743$export$c9a28c988ae309b.prototype, "connectors", void 0);
$0f080bf4af524743$export$c9a28c988ae309b = $0f080bf4af524743$var$__decorate([
    (0, $hdxb6.customElement)("w3m-connect-announced-widget")
], $0f080bf4af524743$export$c9a28c988ae309b);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $2qlRb = parcelRequire("2qlRb");
var $faNff = parcelRequire("faNff");
var $khm6W = parcelRequire("khm6W");
var $i7zcD = parcelRequire("i7zcD");
var $hZBJb = parcelRequire("hZBJb");
var $iptjJ = parcelRequire("iptjJ");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");

function $562ab6d4c7c3b5ef$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n          <wui-list-wallet\n            imageSrc=",
        "\n            name=",
        "\n            @click=",
        "\n            data-testid=",
        "\n          >\n          </wui-list-wallet>\n        "
    ]);
    $562ab6d4c7c3b5ef$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $562ab6d4c7c3b5ef$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '<wui-flex flexDirection="column" gap="xs">\n      ',
        "\n    </wui-flex>"
    ]);
    $562ab6d4c7c3b5ef$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $562ab6d4c7c3b5ef$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $562ab6d4c7c3b5ef$export$4b0f736048e205f0 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mConnectCustomWidget, LitElement);
    var _super = (0, $ohfOJ._)(W3mConnectCustomWidget);
    function W3mConnectCustomWidget() {
        (0, $4GJKx._)(this, W3mConnectCustomWidget);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.connectors = (0, $2qlRb.ConnectorController).state.connectors;
        _this.unsubscribe.push((0, $2qlRb.ConnectorController).subscribeKey("connectors", function(val) {
            return _this.connectors = val;
        }));
        return _this;
    }
    (0, $1wc17._)(W3mConnectCustomWidget, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var customWallets = (0, $faNff.OptionsController).state.customWallets;
                if (!(customWallets === null || customWallets === void 0 ? void 0 : customWallets.length)) {
                    this.style.cssText = "display: none";
                    return null;
                }
                var wallets = this.filterOutDuplicateWallets(customWallets);
                return (0, $hxyOZ.html)($562ab6d4c7c3b5ef$var$_templateObject1(), wallets.map(function(wallet) {
                    var _wallet_name;
                    return (0, $hxyOZ.html)($562ab6d4c7c3b5ef$var$_templateObject(), (0, $696d14fc702af3d6$export$f68dd208b5df064d)((0, $khm6W.AssetUtil).getWalletImage(wallet)), (_wallet_name = wallet.name) !== null && _wallet_name !== void 0 ? _wallet_name : "Unknown", function() {
                        return _this.onConnectWallet(wallet);
                    }, "wallet-selector-".concat(wallet.id));
                }));
            }
        },
        {
            key: "filterOutDuplicateWallets",
            value: function filterOutDuplicateWallets(wallets) {
                var recent = (0, $i7zcD.StorageUtil).getRecentWallets();
                var connectorRDNSs = this.connectors.map(function(connector) {
                    var _connector_info;
                    return (_connector_info = connector.info) === null || _connector_info === void 0 ? void 0 : _connector_info.rdns;
                }).filter(Boolean);
                var recentRDNSs = recent.map(function(wallet) {
                    return wallet.rdns;
                }).filter(Boolean);
                var allRDNSs = connectorRDNSs.concat(recentRDNSs);
                if (allRDNSs.includes("io.metamask.mobile") && (0, $hZBJb.CoreHelperUtil).isMobile()) {
                    var index = allRDNSs.indexOf("io.metamask.mobile");
                    allRDNSs[index] = "io.metamask";
                }
                var filtered = wallets.filter(function(wallet) {
                    return !allRDNSs.includes(String(wallet === null || wallet === void 0 ? void 0 : wallet.rdns));
                });
                return filtered;
            }
        },
        {
            key: "onConnectWallet",
            value: function onConnectWallet(wallet) {
                (0, $iptjJ.RouterController).push("ConnectingWalletConnect", {
                    wallet: wallet
                });
            }
        }
    ]);
    return W3mConnectCustomWidget;
}((0, $2yD3e.LitElement));
$562ab6d4c7c3b5ef$var$__decorate([
    (0, $334Pv.state)()
], $562ab6d4c7c3b5ef$export$4b0f736048e205f0.prototype, "connectors", void 0);
$562ab6d4c7c3b5ef$export$4b0f736048e205f0 = $562ab6d4c7c3b5ef$var$__decorate([
    (0, $hdxb6.customElement)("w3m-connect-custom-widget")
], $562ab6d4c7c3b5ef$export$4b0f736048e205f0);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $hMdcG = parcelRequire("hMdcG");
var $khm6W = parcelRequire("khm6W");
var $2qlRb = parcelRequire("2qlRb");
var $iptjJ = parcelRequire("iptjJ");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");

parcelRequire("cwWZ7");
var $faNff = parcelRequire("faNff");
var $2qlRb = parcelRequire("2qlRb");
var $i7zcD = parcelRequire("i7zcD");
var $hZBJb = parcelRequire("hZBJb");
var $a3c133667f61d45d$export$74541ed5542a8fa7 = {
    filterOutDuplicatesByRDNS: function(wallets) {
        var connectors = (0, $faNff.OptionsController).state.enableEIP6963 ? (0, $2qlRb.ConnectorController).state.connectors : [];
        var recent = (0, $i7zcD.StorageUtil).getRecentWallets();
        var connectorRDNSs = connectors.map(function(connector) {
            var _connector_info;
            return (_connector_info = connector.info) === null || _connector_info === void 0 ? void 0 : _connector_info.rdns;
        }).filter(Boolean);
        var recentRDNSs = recent.map(function(wallet) {
            return wallet.rdns;
        }).filter(Boolean);
        var allRDNSs = connectorRDNSs.concat(recentRDNSs);
        if (allRDNSs.includes("io.metamask.mobile") && (0, $hZBJb.CoreHelperUtil).isMobile()) {
            var index = allRDNSs.indexOf("io.metamask.mobile");
            allRDNSs[index] = "io.metamask";
        }
        var filtered = wallets.filter(function(wallet) {
            return !allRDNSs.includes(String(wallet === null || wallet === void 0 ? void 0 : wallet.rdns));
        });
        return filtered;
    },
    filterOutDuplicatesByIds: function(wallets) {
        var connectors = (0, $2qlRb.ConnectorController).state.connectors;
        var recent = (0, $i7zcD.StorageUtil).getRecentWallets();
        var connectorIds = connectors.map(function(connector) {
            return connector.explorerId;
        });
        var recentIds = recent.map(function(wallet) {
            return wallet.id;
        });
        var allIds = connectorIds.concat(recentIds);
        var filtered = wallets.filter(function(wallet) {
            return !allIds.includes(wallet === null || wallet === void 0 ? void 0 : wallet.id);
        });
        return filtered;
    },
    filterOutDuplicateWallets: function(wallets) {
        var uniqueByRDNS = this.filterOutDuplicatesByRDNS(wallets);
        var uniqueWallets = this.filterOutDuplicatesByIds(uniqueByRDNS);
        return uniqueWallets;
    }
};


function $dfce0350d2b82f92$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n            <wui-list-wallet\n              imageSrc=",
        "\n              name=",
        "\n              @click=",
        "\n            >\n            </wui-list-wallet>\n          "
    ]);
    $dfce0350d2b82f92$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $dfce0350d2b82f92$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column" gap="xs">\n        ',
        "\n      </wui-flex>\n    "
    ]);
    $dfce0350d2b82f92$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $dfce0350d2b82f92$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $dfce0350d2b82f92$export$988c4a1271f336d6 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mConnectFeaturedWidget, LitElement);
    var _super = (0, $ohfOJ._)(W3mConnectFeaturedWidget);
    function W3mConnectFeaturedWidget() {
        (0, $4GJKx._)(this, W3mConnectFeaturedWidget);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.unsubscribe = [];
        return _this;
    }
    (0, $1wc17._)(W3mConnectFeaturedWidget, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var featured = (0, $hMdcG.ApiController).state.featured;
                if (!featured.length) {
                    this.style.cssText = "display: none";
                    return null;
                }
                var wallets = (0, $a3c133667f61d45d$export$74541ed5542a8fa7).filterOutDuplicateWallets(featured);
                return (0, $hxyOZ.html)($dfce0350d2b82f92$var$_templateObject1(), wallets.map(function(wallet) {
                    var _wallet_name;
                    return (0, $hxyOZ.html)($dfce0350d2b82f92$var$_templateObject(), (0, $696d14fc702af3d6$export$f68dd208b5df064d)((0, $khm6W.AssetUtil).getWalletImage(wallet)), (_wallet_name = wallet.name) !== null && _wallet_name !== void 0 ? _wallet_name : "Unknown", function() {
                        return _this.onConnectWallet(wallet);
                    });
                }));
            }
        },
        {
            key: "onConnectWallet",
            value: function onConnectWallet(wallet) {
                var connector = (0, $2qlRb.ConnectorController).getConnector(wallet.id, wallet.rdns);
                if (connector) (0, $iptjJ.RouterController).push("ConnectingExternal", {
                    connector: connector
                });
                else (0, $iptjJ.RouterController).push("ConnectingWalletConnect", {
                    wallet: wallet
                });
            }
        }
    ]);
    return W3mConnectFeaturedWidget;
}((0, $2yD3e.LitElement));
$dfce0350d2b82f92$export$988c4a1271f336d6 = $dfce0350d2b82f92$var$__decorate([
    (0, $hdxb6.customElement)("w3m-connect-featured-widget")
], $dfce0350d2b82f92$export$988c4a1271f336d6);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $2qlRb = parcelRequire("2qlRb");
var $hZBJb = parcelRequire("hZBJb");
var $3cYIS = parcelRequire("3cYIS");
var $hMdcG = parcelRequire("hMdcG");
var $khm6W = parcelRequire("khm6W");
var $9zDWP = parcelRequire("9zDWP");
var $iptjJ = parcelRequire("iptjJ");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");

function $b906f32fe4b67cb8$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n            <wui-list-wallet\n              imageSrc=",
        "\n              .installed=",
        "\n              name=",
        '\n              tagVariant="success"\n              tagLabel="installed"\n              data-testid=',
        "\n              @click=",
        "\n            >\n            </wui-list-wallet>\n          "
    ]);
    $b906f32fe4b67cb8$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $b906f32fe4b67cb8$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column" gap="xs">\n        ',
        "\n      </wui-flex>\n    "
    ]);
    $b906f32fe4b67cb8$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $b906f32fe4b67cb8$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $b906f32fe4b67cb8$export$b09ba0c7d63a0bb9 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mConnectInjectedWidget, LitElement);
    var _super = (0, $ohfOJ._)(W3mConnectInjectedWidget);
    function W3mConnectInjectedWidget() {
        (0, $4GJKx._)(this, W3mConnectInjectedWidget);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.connectors = (0, $2qlRb.ConnectorController).state.connectors;
        _this.unsubscribe.push((0, $2qlRb.ConnectorController).subscribeKey("connectors", function(val) {
            return _this.connectors = val;
        }));
        return _this;
    }
    (0, $1wc17._)(W3mConnectInjectedWidget, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _injectedConnectors_;
                var injectedConnectors = this.connectors.filter(function(connector) {
                    return connector.type === "INJECTED";
                });
                if (!(injectedConnectors === null || injectedConnectors === void 0 ? void 0 : injectedConnectors.length) || injectedConnectors.length === 1 && ((_injectedConnectors_ = injectedConnectors[0]) === null || _injectedConnectors_ === void 0 ? void 0 : _injectedConnectors_.name) === "Browser Wallet" && !(0, $hZBJb.CoreHelperUtil).isMobile()) {
                    this.style.cssText = "display: none";
                    return null;
                }
                return (0, $hxyOZ.html)($b906f32fe4b67cb8$var$_templateObject1(), injectedConnectors.map(function(connector) {
                    var _connector_info;
                    if (!(0, $hZBJb.CoreHelperUtil).isMobile() && connector.name === "Browser Wallet") return null;
                    if (!(0, $3cYIS.ConnectionController).checkInstalled(undefined, connector.chain)) {
                        _this.style.cssText = "display: none";
                        return null;
                    }
                    if (((_connector_info = connector.info) === null || _connector_info === void 0 ? void 0 : _connector_info.rdns) && (0, $hMdcG.ApiController).state.excludedRDNS) {
                        var _connector_info1;
                        if ((0, $hMdcG.ApiController).state.excludedRDNS.includes(connector === null || connector === void 0 ? void 0 : (_connector_info1 = connector.info) === null || _connector_info1 === void 0 ? void 0 : _connector_info1.rdns)) return null;
                    }
                    var _connector_name;
                    return (0, $hxyOZ.html)($b906f32fe4b67cb8$var$_templateObject(), (0, $696d14fc702af3d6$export$f68dd208b5df064d)((0, $khm6W.AssetUtil).getConnectorImage(connector)), true, (_connector_name = connector.name) !== null && _connector_name !== void 0 ? _connector_name : "Unknown", "wallet-selector-".concat(connector.id), function() {
                        return _this.onConnector(connector);
                    });
                }));
            }
        },
        {
            key: "onConnector",
            value: function onConnector(connector) {
                (0, $9zDWP.ChainController).setActiveConnector(connector);
                (0, $iptjJ.RouterController).push("ConnectingExternal", {
                    connector: connector
                });
            }
        }
    ]);
    return W3mConnectInjectedWidget;
}((0, $2yD3e.LitElement));
$b906f32fe4b67cb8$var$__decorate([
    (0, $334Pv.state)()
], $b906f32fe4b67cb8$export$b09ba0c7d63a0bb9.prototype, "connectors", void 0);
$b906f32fe4b67cb8$export$b09ba0c7d63a0bb9 = $b906f32fe4b67cb8$var$__decorate([
    (0, $hdxb6.customElement)("w3m-connect-injected-widget")
], $b906f32fe4b67cb8$export$b09ba0c7d63a0bb9);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $2qlRb = parcelRequire("2qlRb");
var $khm6W = parcelRequire("khm6W");
var $9zDWP = parcelRequire("9zDWP");
var $iptjJ = parcelRequire("iptjJ");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");

function $019781022178b63f$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n            <wui-list-wallet\n              imageSrc=",
        "\n              .installed=",
        "\n              name=",
        '\n              tagVariant="shade"\n              tagLabel="multichain"\n              data-testid=',
        "\n              @click=",
        "\n            >\n            </wui-list-wallet>\n          "
    ]);
    $019781022178b63f$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $019781022178b63f$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column" gap="xs">\n        ',
        "\n      </wui-flex>\n    "
    ]);
    $019781022178b63f$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $019781022178b63f$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $019781022178b63f$export$6b9b4f1550111d67 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mConnectMultiChainWidget, LitElement);
    var _super = (0, $ohfOJ._)(W3mConnectMultiChainWidget);
    function W3mConnectMultiChainWidget() {
        (0, $4GJKx._)(this, W3mConnectMultiChainWidget);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.connectors = (0, $2qlRb.ConnectorController).state.connectors;
        _this.unsubscribe.push((0, $2qlRb.ConnectorController).subscribeKey("connectors", function(val) {
            return _this.connectors = val;
        }));
        return _this;
    }
    (0, $1wc17._)(W3mConnectMultiChainWidget, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var multiChainConnectors = this.connectors.filter(function(connector) {
                    return connector.type === "MULTI_CHAIN" && connector.name !== "WalletConnect";
                });
                if (!(multiChainConnectors === null || multiChainConnectors === void 0 ? void 0 : multiChainConnectors.length)) {
                    this.style.cssText = "display: none";
                    return null;
                }
                return (0, $hxyOZ.html)($019781022178b63f$var$_templateObject1(), multiChainConnectors.map(function(connector) {
                    var _connector_name;
                    return (0, $hxyOZ.html)($019781022178b63f$var$_templateObject(), (0, $696d14fc702af3d6$export$f68dd208b5df064d)((0, $khm6W.AssetUtil).getConnectorImage(connector)), true, (_connector_name = connector.name) !== null && _connector_name !== void 0 ? _connector_name : "Unknown", "wallet-selector-".concat(connector.id), function() {
                        return _this.onConnector(connector);
                    });
                }));
            }
        },
        {
            key: "onConnector",
            value: function onConnector(connector) {
                (0, $9zDWP.ChainController).setActiveConnector(connector);
                (0, $iptjJ.RouterController).push("ConnectingMultiChain");
            }
        }
    ]);
    return W3mConnectMultiChainWidget;
}((0, $2yD3e.LitElement));
$019781022178b63f$var$__decorate([
    (0, $334Pv.state)()
], $019781022178b63f$export$6b9b4f1550111d67.prototype, "connectors", void 0);
$019781022178b63f$export$6b9b4f1550111d67 = $019781022178b63f$var$__decorate([
    (0, $hdxb6.customElement)("w3m-connect-multi-chain-widget")
], $019781022178b63f$export$6b9b4f1550111d67);



var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
parcelRequire("cwWZ7");
var $2qlRb = parcelRequire("2qlRb");
var $khm6W = parcelRequire("khm6W");
var $3cYIS = parcelRequire("3cYIS");
var $faNff = parcelRequire("faNff");
var $iptjJ = parcelRequire("iptjJ");
var $5Lhe6 = parcelRequire("5Lhe6");
var $1QDT9 = parcelRequire("1QDT9");

parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");

function $ec56f5ae0888157d$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column" gap="xs">\n        <wui-list-wallet\n          imageSrc=',
        "\n          .installed=",
        "\n          name=",
        "\n          data-testid=",
        "\n          @click=",
        "\n        >\n        </wui-list-wallet>\n      </wui-flex>\n    "
    ]);
    $ec56f5ae0888157d$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $ec56f5ae0888157d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $ec56f5ae0888157d$export$25d176a7269bd954 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mConnectCoinbaseWidget, LitElement);
    var _super = (0, $ohfOJ._)(W3mConnectCoinbaseWidget);
    function W3mConnectCoinbaseWidget() {
        (0, $4GJKx._)(this, W3mConnectCoinbaseWidget);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.connectors = (0, $2qlRb.ConnectorController).state.connectors;
        _this.unsubscribe.push((0, $2qlRb.ConnectorController).subscribeKey("connectors", function(val) {
            return _this.connectors = val;
        }));
        return _this;
    }
    (0, $1wc17._)(W3mConnectCoinbaseWidget, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var coinbaseConnector = this.connectors.find(function(connector) {
                    return connector.id === "coinbaseWalletSDK";
                });
                if (!coinbaseConnector) {
                    this.style.cssText = "display: none";
                    return null;
                }
                return (0, $hxyOZ.html)($ec56f5ae0888157d$var$_templateObject(), (0, $696d14fc702af3d6$export$f68dd208b5df064d)((0, $khm6W.AssetUtil).getConnectorImage(coinbaseConnector)), true, (0, $696d14fc702af3d6$export$f68dd208b5df064d)(coinbaseConnector.name), "wallet-selector-".concat(coinbaseConnector.id), function() {
                    return _this.onConnector(coinbaseConnector);
                });
            }
        },
        {
            key: "onCoinbaseConnector",
            value: function onCoinbaseConnector(connector) {
                return (0, $kSuI9._)(function() {
                    var error, _error_message;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                (0, $3cYIS.ConnectionController).setWcError(false);
                                return [
                                    4,
                                    (0, $3cYIS.ConnectionController).connectExternal(connector, connector.chain)
                                ];
                            case 1:
                                _state.sent();
                                if ((0, $faNff.OptionsController).state.isSiweEnabled) (0, $iptjJ.RouterController).push("ConnectingSiwe");
                                else (0, $5Lhe6.ModalController).close();
                                (0, $1QDT9.EventsController).sendEvent({
                                    type: "track",
                                    event: "CONNECT_SUCCESS",
                                    properties: {
                                        method: "browser",
                                        name: connector.name || "Unknown"
                                    }
                                });
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                error = _state.sent();
                                (0, $1QDT9.EventsController).sendEvent({
                                    type: "track",
                                    event: "CONNECT_ERROR",
                                    properties: {
                                        message: (_error_message = error === null || error === void 0 ? void 0 : error.message) !== null && _error_message !== void 0 ? _error_message : "Unknown"
                                    }
                                });
                                (0, $3cYIS.ConnectionController).setWcError(true);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onConnector",
            value: function onConnector(connector) {
                (0, $iptjJ.RouterController).push("ConnectingExternal", {
                    connector: connector
                });
                if (connector.id === (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).COINBASE_SDK_CONNECTOR_ID) this.onCoinbaseConnector(connector);
            }
        }
    ]);
    return W3mConnectCoinbaseWidget;
}((0, $2yD3e.LitElement));
$ec56f5ae0888157d$var$__decorate([
    (0, $334Pv.state)()
], $ec56f5ae0888157d$export$25d176a7269bd954.prototype, "connectors", void 0);
$ec56f5ae0888157d$export$25d176a7269bd954 = $ec56f5ae0888157d$var$__decorate([
    (0, $hdxb6.customElement)("w3m-connect-coinbase-widget")
], $ec56f5ae0888157d$export$25d176a7269bd954);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $2qlRb = parcelRequire("2qlRb");
var $khm6W = parcelRequire("khm6W");
var $iptjJ = parcelRequire("iptjJ");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");

function $c6b04c9b369f1229$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n            <wui-list-wallet\n              imageSrc=",
        "\n              .installed=",
        "\n              name=",
        "\n              data-testid=",
        "\n              @click=",
        "\n            >\n            </wui-list-wallet>\n          "
    ]);
    $c6b04c9b369f1229$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $c6b04c9b369f1229$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column" gap="xs">\n        ',
        "\n      </wui-flex>\n    "
    ]);
    $c6b04c9b369f1229$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $c6b04c9b369f1229$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c6b04c9b369f1229$export$e85be7cb330fbdd7 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mConnectExternalWidget, LitElement);
    var _super = (0, $ohfOJ._)(W3mConnectExternalWidget);
    function W3mConnectExternalWidget() {
        (0, $4GJKx._)(this, W3mConnectExternalWidget);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.connectors = (0, $2qlRb.ConnectorController).state.connectors;
        _this.unsubscribe.push((0, $2qlRb.ConnectorController).subscribeKey("connectors", function(val) {
            return _this.connectors = val;
        }));
        return _this;
    }
    (0, $1wc17._)(W3mConnectExternalWidget, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var externalConnectors = this.connectors.filter(function(connector) {
                    return connector.type === "EXTERNAL";
                });
                var filteredOutCoinbaseConnectors = externalConnectors.filter(function(connector) {
                    return connector.id !== "coinbaseWalletSDK";
                });
                if (!(filteredOutCoinbaseConnectors === null || filteredOutCoinbaseConnectors === void 0 ? void 0 : filteredOutCoinbaseConnectors.length)) {
                    this.style.cssText = "display: none";
                    return null;
                }
                return (0, $hxyOZ.html)($c6b04c9b369f1229$var$_templateObject1(), filteredOutCoinbaseConnectors.map(function(connector) {
                    var _connector_name;
                    return (0, $hxyOZ.html)($c6b04c9b369f1229$var$_templateObject(), (0, $696d14fc702af3d6$export$f68dd208b5df064d)((0, $khm6W.AssetUtil).getConnectorImage(connector)), true, (_connector_name = connector.name) !== null && _connector_name !== void 0 ? _connector_name : "Unknown", "wallet-selector-external-".concat(connector.id), function() {
                        return _this.onConnector(connector);
                    });
                }));
            }
        },
        {
            key: "onConnector",
            value: function onConnector(connector) {
                (0, $iptjJ.RouterController).push("ConnectingExternal", {
                    connector: connector
                });
            }
        }
    ]);
    return W3mConnectExternalWidget;
}((0, $2yD3e.LitElement));
$c6b04c9b369f1229$var$__decorate([
    (0, $334Pv.state)()
], $c6b04c9b369f1229$export$e85be7cb330fbdd7.prototype, "connectors", void 0);
$c6b04c9b369f1229$export$e85be7cb330fbdd7 = $c6b04c9b369f1229$var$__decorate([
    (0, $hdxb6.customElement)("w3m-connect-external-widget")
], $c6b04c9b369f1229$export$e85be7cb330fbdd7);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $i7zcD = parcelRequire("i7zcD");
var $khm6W = parcelRequire("khm6W");
var $iptjJ = parcelRequire("iptjJ");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");

function $5242a4bd404c3bfe$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n            <wui-list-wallet\n              imageSrc=",
        "\n              name=",
        "\n              @click=",
        '\n              tagLabel="recent"\n              tagVariant="shade"\n            >\n            </wui-list-wallet>\n          '
    ]);
    $5242a4bd404c3bfe$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $5242a4bd404c3bfe$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column" gap="xs">\n        ',
        "\n      </wui-flex>\n    "
    ]);
    $5242a4bd404c3bfe$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $5242a4bd404c3bfe$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $5242a4bd404c3bfe$export$e1e21695d8881ac0 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mConnectRecentWidget, LitElement);
    var _super = (0, $ohfOJ._)(W3mConnectRecentWidget);
    function W3mConnectRecentWidget() {
        (0, $4GJKx._)(this, W3mConnectRecentWidget);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(W3mConnectRecentWidget, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var recent = (0, $i7zcD.StorageUtil).getRecentWallets();
                if (!(recent === null || recent === void 0 ? void 0 : recent.length)) {
                    this.style.cssText = "display: none";
                    return null;
                }
                return (0, $hxyOZ.html)($5242a4bd404c3bfe$var$_templateObject1(), recent.map(function(wallet) {
                    var _wallet_name;
                    return (0, $hxyOZ.html)($5242a4bd404c3bfe$var$_templateObject(), (0, $696d14fc702af3d6$export$f68dd208b5df064d)((0, $khm6W.AssetUtil).getWalletImage(wallet)), (_wallet_name = wallet.name) !== null && _wallet_name !== void 0 ? _wallet_name : "Unknown", function() {
                        return _this.onConnectWallet(wallet);
                    });
                }));
            }
        },
        {
            key: "onConnectWallet",
            value: function onConnectWallet(wallet) {
                (0, $iptjJ.RouterController).push("ConnectingWalletConnect", {
                    wallet: wallet
                });
            }
        }
    ]);
    return W3mConnectRecentWidget;
}((0, $2yD3e.LitElement));
$5242a4bd404c3bfe$export$e1e21695d8881ac0 = $5242a4bd404c3bfe$var$__decorate([
    (0, $hdxb6.customElement)("w3m-connect-recent-widget")
], $5242a4bd404c3bfe$export$e1e21695d8881ac0);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $2qlRb = parcelRequire("2qlRb");
var $hMdcG = parcelRequire("hMdcG");
var $faNff = parcelRequire("faNff");
var $i7zcD = parcelRequire("i7zcD");
var $khm6W = parcelRequire("khm6W");
var $iptjJ = parcelRequire("iptjJ");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");


function $1a29877ed3da300c$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n            <wui-list-wallet\n              imageSrc=",
        "\n              name=",
        "\n              @click=",
        "\n            >\n            </wui-list-wallet>\n          "
    ]);
    $1a29877ed3da300c$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $1a29877ed3da300c$var$_templateObject1() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column" gap="xs">\n        ',
        "\n      </wui-flex>\n    "
    ]);
    $1a29877ed3da300c$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $1a29877ed3da300c$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $1a29877ed3da300c$export$f5714d84d1c8cd45 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mConnectRecommendedWidget, LitElement);
    var _super = (0, $ohfOJ._)(W3mConnectRecommendedWidget);
    function W3mConnectRecommendedWidget() {
        (0, $4GJKx._)(this, W3mConnectRecommendedWidget);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.connectors = (0, $2qlRb.ConnectorController).state.connectors;
        _this.unsubscribe.push((0, $2qlRb.ConnectorController).subscribeKey("connectors", function(val) {
            return _this.connectors = val;
        }));
        return _this;
    }
    (0, $1wc17._)(W3mConnectRecommendedWidget, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var connector = this.connectors.find(function(c) {
                    return c.type === "WALLET_CONNECT";
                });
                if (!connector) return null;
                var recommended = (0, $hMdcG.ApiController).state.recommended;
                var _OptionsController_state = (0, $faNff.OptionsController).state, customWallets = _OptionsController_state.customWallets, featuredWalletIds = _OptionsController_state.featuredWalletIds;
                var connectors = (0, $2qlRb.ConnectorController).state.connectors;
                var recent = (0, $i7zcD.StorageUtil).getRecentWallets();
                var injected = connectors.filter(function(c) {
                    return c.type === "INJECTED" || c.type === "ANNOUNCED";
                });
                var injectedWallets = injected.filter(function(i) {
                    return i.name !== "Browser Wallet";
                });
                if (featuredWalletIds || customWallets || !recommended.length) {
                    this.style.cssText = "display: none";
                    return null;
                }
                var overrideLength = injectedWallets.length + recent.length;
                var maxRecommended = Math.max(0, 2 - overrideLength);
                var wallets = (0, $a3c133667f61d45d$export$74541ed5542a8fa7).filterOutDuplicateWallets(recommended).slice(0, maxRecommended);
                if (!wallets.length) {
                    this.style.cssText = "display: none";
                    return null;
                }
                return (0, $hxyOZ.html)($1a29877ed3da300c$var$_templateObject1(), wallets.map(function(wallet) {
                    var _wallet_name;
                    return (0, $hxyOZ.html)($1a29877ed3da300c$var$_templateObject(), (0, $696d14fc702af3d6$export$f68dd208b5df064d)((0, $khm6W.AssetUtil).getWalletImage(wallet)), (_wallet_name = wallet === null || wallet === void 0 ? void 0 : wallet.name) !== null && _wallet_name !== void 0 ? _wallet_name : "Unknown", function() {
                        return _this.onConnectWallet(wallet);
                    });
                }));
            }
        },
        {
            key: "onConnectWallet",
            value: function onConnectWallet(wallet) {
                var connector = (0, $2qlRb.ConnectorController).getConnector(wallet.id, wallet.rdns);
                if (connector) (0, $iptjJ.RouterController).push("ConnectingExternal", {
                    connector: connector
                });
                else (0, $iptjJ.RouterController).push("ConnectingWalletConnect", {
                    wallet: wallet
                });
            }
        }
    ]);
    return W3mConnectRecommendedWidget;
}((0, $2yD3e.LitElement));
$1a29877ed3da300c$var$__decorate([
    (0, $334Pv.state)()
], $1a29877ed3da300c$export$f5714d84d1c8cd45.prototype, "connectors", void 0);
$1a29877ed3da300c$export$f5714d84d1c8cd45 = $1a29877ed3da300c$var$__decorate([
    (0, $hdxb6.customElement)("w3m-connect-recommended-widget")
], $1a29877ed3da300c$export$f5714d84d1c8cd45);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $2qlRb = parcelRequire("2qlRb");
var $hZBJb = parcelRequire("hZBJb");
var $khm6W = parcelRequire("khm6W");
var $iptjJ = parcelRequire("iptjJ");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");

function $6934dcb32149daf7$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n      <wui-list-wallet\n        imageSrc=",
        "\n        name=",
        "\n        @click=",
        '\n        tagLabel="qr code"\n        tagVariant="main"\n        data-testid="wallet-selector-walletconnect"\n      >\n      </wui-list-wallet>\n    '
    ]);
    $6934dcb32149daf7$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $6934dcb32149daf7$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $6934dcb32149daf7$export$9691df2d71151e4c = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mConnectWalletConnectWidget, LitElement);
    var _super = (0, $ohfOJ._)(W3mConnectWalletConnectWidget);
    function W3mConnectWalletConnectWidget() {
        (0, $4GJKx._)(this, W3mConnectWalletConnectWidget);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.connectors = (0, $2qlRb.ConnectorController).state.connectors;
        _this.unsubscribe.push((0, $2qlRb.ConnectorController).subscribeKey("connectors", function(val) {
            return _this.connectors = val;
        }));
        return _this;
    }
    (0, $1wc17._)(W3mConnectWalletConnectWidget, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                if ((0, $hZBJb.CoreHelperUtil).isMobile()) {
                    this.style.cssText = "display: none";
                    return null;
                }
                var connector = this.connectors.find(function(c) {
                    return c.type === "WALLET_CONNECT";
                });
                if (!connector) {
                    this.style.cssText = "display: none";
                    return null;
                }
                var _connector_name;
                return (0, $hxyOZ.html)($6934dcb32149daf7$var$_templateObject(), (0, $696d14fc702af3d6$export$f68dd208b5df064d)((0, $khm6W.AssetUtil).getConnectorImage(connector)), (_connector_name = connector.name) !== null && _connector_name !== void 0 ? _connector_name : "Unknown", function() {
                    return _this.onConnector(connector);
                });
            }
        },
        {
            key: "onConnector",
            value: function onConnector(connector) {
                if (connector.type === "WALLET_CONNECT") {
                    if ((0, $hZBJb.CoreHelperUtil).isMobile()) (0, $iptjJ.RouterController).push("AllWallets");
                    else (0, $iptjJ.RouterController).push("ConnectingWalletConnect");
                } else (0, $iptjJ.RouterController).push("ConnectingExternal", {
                    connector: connector
                });
            }
        }
    ]);
    return W3mConnectWalletConnectWidget;
}((0, $2yD3e.LitElement));
$6934dcb32149daf7$var$__decorate([
    (0, $334Pv.state)()
], $6934dcb32149daf7$export$9691df2d71151e4c.prototype, "connectors", void 0);
$6934dcb32149daf7$export$9691df2d71151e4c = $6934dcb32149daf7$var$__decorate([
    (0, $hdxb6.customElement)("w3m-connect-walletconnect-widget")
], $6934dcb32149daf7$export$9691df2d71151e4c);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");

var $j06k0 = parcelRequire("j06k0");
parcelRequire("4A6TP");
var $2D5eP = parcelRequire("2D5eP");
function $2ebb4659a3fda09e$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    margin-top: var(--wui-spacing-3xs);\n  }\n  wui-separator {\n    margin: var(--wui-spacing-m) calc(var(--wui-spacing-m) * -1) var(--wui-spacing-xs)\n      calc(var(--wui-spacing-m) * -1);\n    width: calc(100% + var(--wui-spacing-s) * 2);\n  }\n"
    ]);
    $2ebb4659a3fda09e$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $2ebb4659a3fda09e$export$2e2bcd8739ae039 = (0, $2D5eP.css)($2ebb4659a3fda09e$var$_templateObject());


parcelRequire("cwWZ7");
var $2qlRb = parcelRequire("2qlRb");
var $hMdcG = parcelRequire("hMdcG");
var $faNff = parcelRequire("faNff");
var $i7zcD = parcelRequire("i7zcD");
var $9zDWP = parcelRequire("9zDWP");
parcelRequire("dSKxG");
var $3QZC1 = parcelRequire("3QZC1");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");


function $e9971886f0180318$var$_templateObject() {
    var data = (0, $j06k0._)([
        "<w3m-connect-recent-widget></w3m-connect-recent-widget>"
    ]);
    $e9971886f0180318$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $e9971886f0180318$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "<w3m-connect-multi-chain-widget></w3m-connect-multi-chain-widget>"
    ]);
    $e9971886f0180318$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $e9971886f0180318$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "<w3m-connect-announced-widget></w3m-connect-announced-widget>"
    ]);
    $e9971886f0180318$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $e9971886f0180318$var$_templateObject3() {
    var data = (0, $j06k0._)([
        "<w3m-connect-injected-widget></w3m-connect-injected-widget>"
    ]);
    $e9971886f0180318$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $e9971886f0180318$var$_templateObject4() {
    var data = (0, $j06k0._)([
        "<w3m-connect-featured-widget></w3m-connect-featured-widget>"
    ]);
    $e9971886f0180318$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $e9971886f0180318$var$_templateObject5() {
    var data = (0, $j06k0._)([
        "<w3m-connect-custom-widget></w3m-connect-custom-widget>"
    ]);
    $e9971886f0180318$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $e9971886f0180318$var$_templateObject6() {
    var data = (0, $j06k0._)([
        "<w3m-connect-coinbase-widget></w3m-connect-coinbase-widget>"
    ]);
    $e9971886f0180318$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $e9971886f0180318$var$_templateObject7() {
    var data = (0, $j06k0._)([
        "<w3m-connect-external-widget></w3m-connect-external-widget>"
    ]);
    $e9971886f0180318$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $e9971886f0180318$var$_templateObject8() {
    var data = (0, $j06k0._)([
        "<w3m-connect-recommended-widget></w3m-connect-recommended-widget>"
    ]);
    $e9971886f0180318$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function $e9971886f0180318$var$_templateObject9() {
    var data = (0, $j06k0._)([
        '\n      <wui-flex flexDirection="column" gap="xs">\n        <w3m-connect-walletconnect-widget></w3m-connect-walletconnect-widget>\n        ',
        "\n        ",
        "\n        ",
        "\n        ",
        "\n        ",
        "\n        ",
        "\n        ",
        "\n        ",
        "\n        ",
        "\n      </wui-flex>\n    "
    ]);
    $e9971886f0180318$var$_templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
var $e9971886f0180318$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $e9971886f0180318$export$6446820b0ee4da6c = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mConnectorList, LitElement);
    var _super = (0, $ohfOJ._)(W3mConnectorList);
    function W3mConnectorList() {
        (0, $4GJKx._)(this, W3mConnectorList);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.connectors = (0, $2qlRb.ConnectorController).state.connectors;
        _this.unsubscribe.push((0, $2qlRb.ConnectorController).subscribeKey("connectors", function(val) {
            return _this.connectors = val;
        }));
        return _this;
    }
    (0, $1wc17._)(W3mConnectorList, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_getConnectorsByType = this.getConnectorsByType(), custom = _this_getConnectorsByType.custom, recent = _this_getConnectorsByType.recent, announced = _this_getConnectorsByType.announced, coinbase = _this_getConnectorsByType.coinbase, injected = _this_getConnectorsByType.injected, multiChain = _this_getConnectorsByType.multiChain, recommended = _this_getConnectorsByType.recommended, featured = _this_getConnectorsByType.featured, external = _this_getConnectorsByType.external;
                return (0, $hxyOZ.html)($e9971886f0180318$var$_templateObject9(), recent.length ? (0, $hxyOZ.html)($e9971886f0180318$var$_templateObject()) : null, multiChain.length ? (0, $hxyOZ.html)($e9971886f0180318$var$_templateObject1()) : null, announced.length ? (0, $hxyOZ.html)($e9971886f0180318$var$_templateObject2()) : null, injected.length ? (0, $hxyOZ.html)($e9971886f0180318$var$_templateObject3()) : null, featured.length ? (0, $hxyOZ.html)($e9971886f0180318$var$_templateObject4()) : null, (custom === null || custom === void 0 ? void 0 : custom.length) ? (0, $hxyOZ.html)($e9971886f0180318$var$_templateObject5()) : null, coinbase ? (0, $hxyOZ.html)($e9971886f0180318$var$_templateObject6()) : null, external.length ? (0, $hxyOZ.html)($e9971886f0180318$var$_templateObject7()) : null, recommended.length ? (0, $hxyOZ.html)($e9971886f0180318$var$_templateObject8()) : null);
            }
        },
        {
            key: "getConnectorsByType",
            value: function getConnectorsByType() {
                var _ApiController_state = (0, $hMdcG.ApiController).state, featured = _ApiController_state.featured, recommended = _ApiController_state.recommended;
                var _OptionsController_state = (0, $faNff.OptionsController).state, custom = _OptionsController_state.customWallets;
                var recent = (0, $i7zcD.StorageUtil).getRecentWallets();
                var filteredRecommended = (0, $a3c133667f61d45d$export$74541ed5542a8fa7).filterOutDuplicateWallets(recommended);
                var filteredFeatured = (0, $a3c133667f61d45d$export$74541ed5542a8fa7).filterOutDuplicateWallets(featured);
                var multiChain = this.connectors.filter(function(connector) {
                    return connector.type === "MULTI_CHAIN";
                });
                var announced = this.connectors.filter(function(connector) {
                    return connector.type === "ANNOUNCED";
                });
                var injected = this.connectors.filter(function(connector) {
                    return connector.type === "INJECTED";
                });
                var external = this.connectors.filter(function(connector) {
                    return connector.type === "EXTERNAL";
                });
                var coinbase = this.connectors.find(function(connector) {
                    return connector.id === (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).COINBASE_SDK_CONNECTOR_ID;
                });
                var isEVM = (0, $9zDWP.ChainController).state.activeChain === (0, $3QZC1.ConstantsUtil).CHAIN.EVM;
                var includeAnnouncedAndInjected = isEVM ? (0, $faNff.OptionsController).state.enableEIP6963 : true;
                return {
                    custom: custom,
                    recent: recent,
                    coinbase: coinbase,
                    external: external,
                    multiChain: multiChain,
                    announced: includeAnnouncedAndInjected ? announced : [],
                    injected: includeAnnouncedAndInjected ? injected : [],
                    recommended: filteredRecommended,
                    featured: filteredFeatured
                };
            }
        }
    ]);
    return W3mConnectorList;
}((0, $2yD3e.LitElement));
$e9971886f0180318$export$6446820b0ee4da6c.styles = (0, $2ebb4659a3fda09e$export$2e2bcd8739ae039);
$e9971886f0180318$var$__decorate([
    (0, $334Pv.state)()
], $e9971886f0180318$export$6446820b0ee4da6c.prototype, "connectors", void 0);
$e9971886f0180318$export$6446820b0ee4da6c = $e9971886f0180318$var$__decorate([
    (0, $hdxb6.customElement)("w3m-connector-list")
], $e9971886f0180318$export$6446820b0ee4da6c);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("cwWZ7");
var $2qlRb = parcelRequire("2qlRb");
var $hMdcG = parcelRequire("hMdcG");
var $faNff = parcelRequire("faNff");
var $hZBJb = parcelRequire("hZBJb");
var $1QDT9 = parcelRequire("1QDT9");
var $iptjJ = parcelRequire("iptjJ");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("kAqXG");
var $334Pv = parcelRequire("334Pv");
function $2ff177f705fa9242$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-list-wallet\n        name="All Wallets"\n        walletIcon="allWallets"\n        showAllWallets\n        @click=',
        "\n        tagLabel=",
        '\n        tagVariant="shade"\n        data-testid="all-wallets"\n      ></wui-list-wallet>\n    '
    ]);
    $2ff177f705fa9242$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $2ff177f705fa9242$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $2ff177f705fa9242$export$49d950fc703ce1d8 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mAllWalletsWidget, LitElement);
    var _super = (0, $ohfOJ._)(W3mAllWalletsWidget);
    function W3mAllWalletsWidget() {
        (0, $4GJKx._)(this, W3mAllWalletsWidget);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.connectors = (0, $2qlRb.ConnectorController).state.connectors;
        _this.count = (0, $hMdcG.ApiController).state.count;
        _this.unsubscribe.push((0, $2qlRb.ConnectorController).subscribeKey("connectors", function(val) {
            return _this.connectors = val;
        }), (0, $hMdcG.ApiController).subscribeKey("count", function(val) {
            return _this.count = val;
        }));
        return _this;
    }
    (0, $1wc17._)(W3mAllWalletsWidget, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var wcConnector = this.connectors.find(function(c) {
                    return c.type === "WALLET_CONNECT";
                });
                var allWallets = (0, $faNff.OptionsController).state.allWallets;
                if (!wcConnector || allWallets === "HIDE") return null;
                if (allWallets === "ONLY_MOBILE" && !(0, $hZBJb.CoreHelperUtil).isMobile()) return null;
                var featuredCount = (0, $hMdcG.ApiController).state.featured.length;
                var rawCount = this.count + featuredCount;
                var roundedCount = rawCount < 10 ? rawCount : Math.floor(rawCount / 10) * 10;
                var tagLabel = roundedCount < rawCount ? "".concat(roundedCount, "+") : "".concat(roundedCount);
                return (0, $hxyOZ.html)($2ff177f705fa9242$var$_templateObject(), this.onAllWallets.bind(this), tagLabel);
            }
        },
        {
            key: "onAllWallets",
            value: function onAllWallets() {
                (0, $1QDT9.EventsController).sendEvent({
                    type: "track",
                    event: "CLICK_ALL_WALLETS"
                });
                (0, $iptjJ.RouterController).push("AllWallets");
            }
        }
    ]);
    return W3mAllWalletsWidget;
}((0, $2yD3e.LitElement));
$2ff177f705fa9242$var$__decorate([
    (0, $334Pv.state)()
], $2ff177f705fa9242$export$49d950fc703ce1d8.prototype, "connectors", void 0);
$2ff177f705fa9242$var$__decorate([
    (0, $334Pv.state)()
], $2ff177f705fa9242$export$49d950fc703ce1d8.prototype, "count", void 0);
$2ff177f705fa9242$export$49d950fc703ce1d8 = $2ff177f705fa9242$var$__decorate([
    (0, $hdxb6.customElement)("w3m-all-wallets-widget")
], $2ff177f705fa9242$export$49d950fc703ce1d8);



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("grHtr");
var $hdxb6 = parcelRequire("hdxb6");
parcelRequire("4A6TP");
var $hxyOZ = parcelRequire("hxyOZ");
var $2yD3e = parcelRequire("2yD3e");
parcelRequire("cwWZ7");
var $i7zcD = parcelRequire("i7zcD");
var $2qlRb = parcelRequire("2qlRb");
var $iptjJ = parcelRequire("iptjJ");
function $33adde3664c224b2$var$_templateObject() {
    var data = (0, $j06k0._)([
        '\n      <wui-list-item\n        variant="icon"\n        iconVariant="overlay"\n        icon=',
        "\n        iconSize=",
        '\n        data-testid="w3m-account-email-update"\n        ?chevron=',
        "\n        @click=",
        '\n      >\n        <wui-text variant="paragraph-500" color="fg-100">',
        "</wui-text>\n      </wui-list-item>\n    "
    ]);
    $33adde3664c224b2$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $33adde3664c224b2$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $33adde3664c224b2$export$ce67733292087122 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mAccountAuthButton, LitElement);
    var _super = (0, $ohfOJ._)(W3mAccountAuthButton);
    function W3mAccountAuthButton() {
        (0, $4GJKx._)(this, W3mAccountAuthButton);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.socialProvider = (0, $i7zcD.StorageUtil).getConnectedSocialProvider();
        _this.socialUsername = (0, $i7zcD.StorageUtil).getConnectedSocialUsername();
        return _this;
    }
    (0, $1wc17._)(W3mAccountAuthButton, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var type = (0, $i7zcD.StorageUtil).getConnectedConnector();
                var authConnector = (0, $2qlRb.ConnectorController).getAuthConnector();
                if (!authConnector || type !== "AUTH") {
                    this.style.cssText = "display: none";
                    return null;
                }
                var _authConnector_provider_getEmail;
                var email = (_authConnector_provider_getEmail = authConnector.provider.getEmail()) !== null && _authConnector_provider_getEmail !== void 0 ? _authConnector_provider_getEmail : "";
                var _this_socialProvider;
                return (0, $hxyOZ.html)($33adde3664c224b2$var$_templateObject(), (_this_socialProvider = this.socialProvider) !== null && _this_socialProvider !== void 0 ? _this_socialProvider : "mail", this.socialProvider ? "xxl" : "sm", !this.socialProvider, function() {
                    _this.onGoToUpdateEmail(email, _this.socialProvider);
                }, this.getAuthName(email));
            }
        },
        {
            key: "onGoToUpdateEmail",
            value: function onGoToUpdateEmail(email, socialProvider) {
                if (!socialProvider) (0, $iptjJ.RouterController).push("UpdateEmailWallet", {
                    email: email
                });
            }
        },
        {
            key: "getAuthName",
            value: function getAuthName(email) {
                if (this.socialUsername) {
                    if (this.socialProvider === "discord" && this.socialUsername.endsWith("0")) return this.socialUsername.slice(0, -1);
                    return this.socialUsername;
                }
                return email.length > 30 ? "".concat(email.slice(0, -3), "...") : email;
            }
        }
    ]);
    return W3mAccountAuthButton;
}((0, $2yD3e.LitElement));
$33adde3664c224b2$export$ce67733292087122 = $33adde3664c224b2$var$__decorate([
    (0, $hdxb6.customElement)("w3m-account-auth-button")
], $33adde3664c224b2$export$ce67733292087122);




parcelRequire("cwWZ7");
var $hZBJb = parcelRequire("hZBJb");
function $059208c4a444786a$export$14650d4efb17e382(options) {
    return new (0, $01027d2cdef453cb$export$fc94c40ea502fa4c)((0, $cxjpp._)((0, $do9pw._)({}, options), {
        sdkType: "w3m",
        sdkVersion: "html-multichain-".concat((0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).VERSION)
    }));
}


parcelRequire("8if8T");

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $c6Xmf = parcelRequire("c6Xmf");

var $eha6O = parcelRequire("eha6O");

var $cTdql = parcelRequire("cTdql");

var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $eha6O = parcelRequire("eha6O");

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $c6Xmf = parcelRequire("c6Xmf");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");
var $4441ec449835927d$export$83d89fbfd8236492 = "2.13.4";


var $66844b130223db0e$export$c506eb22e615ba4a = function() {
    return "@wagmi/core@".concat((0, $4441ec449835927d$export$83d89fbfd8236492));
};


var $5fe8c9a1072e57c7$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $5fe8c9a1072e57c7$var$_BaseError_instances, $5fe8c9a1072e57c7$var$_BaseError_walk;
var $5fe8c9a1072e57c7$export$a490eb03cb7a0a5e = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $dcsZi._)(BaseError, Error1);
    var _super = (0, $ohfOJ._)(BaseError);
    function BaseError(shortMessage) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $4GJKx._)(this, BaseError);
        var _this;
        var _options_cause;
        _this = _super.call(this);
        $5fe8c9a1072e57c7$var$_BaseError_instances.add((0, $d3H5E._)(_this));
        Object.defineProperty((0, $d3H5E._)(_this), "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty((0, $d3H5E._)(_this), "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty((0, $d3H5E._)(_this), "metaMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty((0, $d3H5E._)(_this), "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty((0, $d3H5E._)(_this), "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "WagmiCoreError"
        });
        var details = options.cause instanceof BaseError ? options.cause.details : ((_options_cause = options.cause) === null || _options_cause === void 0 ? void 0 : _options_cause.message) ? options.cause.message : options.details;
        var docsPath = options.cause instanceof BaseError ? options.cause.docsPath || options.docsPath : options.docsPath;
        _this.message = [
            shortMessage || "An error occurred.",
            ""
        ].concat((0, $c6Xmf._)(options.metaMessages ? (0, $c6Xmf._)(options.metaMessages).concat([
            ""
        ]) : []), (0, $c6Xmf._)(docsPath ? [
            "Docs: ".concat(_this.docsBaseUrl).concat(docsPath, ".html").concat(options.docsSlug ? "#".concat(options.docsSlug) : "")
        ] : []), (0, $c6Xmf._)(details ? [
            "Details: ".concat(details)
        ] : []), [
            "Version: ".concat(_this.version)
        ]).join("\n");
        if (options.cause) _this.cause = options.cause;
        _this.details = details;
        _this.docsPath = docsPath;
        _this.metaMessages = options.metaMessages;
        _this.shortMessage = shortMessage;
        return _this;
    }
    (0, $1wc17._)(BaseError, [
        {
            key: "docsBaseUrl",
            get: function get() {
                return "https://wagmi.sh/core";
            }
        },
        {
            key: "version",
            get: function get() {
                return (0, $66844b130223db0e$export$c506eb22e615ba4a)();
            }
        },
        {
            key: "walk",
            value: function walk(fn) {
                return $5fe8c9a1072e57c7$var$__classPrivateFieldGet(this, $5fe8c9a1072e57c7$var$_BaseError_instances, "m", $5fe8c9a1072e57c7$var$_BaseError_walk).call(this, this, fn);
            }
        }
    ]);
    return BaseError;
}((0, $FuVm8._)(Error));
$5fe8c9a1072e57c7$var$_BaseError_instances = new WeakSet(), $5fe8c9a1072e57c7$var$_BaseError_walk = function _BaseError_walk(err, fn) {
    if (fn === null || fn === void 0 ? void 0 : fn(err)) return err;
    if (err.cause) return $5fe8c9a1072e57c7$var$__classPrivateFieldGet(this, $5fe8c9a1072e57c7$var$_BaseError_instances, "m", _BaseError_walk).call(this, err.cause, fn);
    return err;
};


var $ad7a5f8bd0b5662c$export$688e5fda4b4631ed = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(ChainNotConfiguredError, BaseError);
    var _super = (0, $ohfOJ._)(ChainNotConfiguredError);
    function ChainNotConfiguredError() {
        (0, $4GJKx._)(this, ChainNotConfiguredError);
        var _this;
        _this = _super.call(this, "Chain not configured.");
        Object.defineProperty((0, $d3H5E._)(_this), "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ChainNotConfiguredError"
        });
        return _this;
    }
    return ChainNotConfiguredError;
}((0, $5fe8c9a1072e57c7$export$a490eb03cb7a0a5e));
var $ad7a5f8bd0b5662c$export$ee7f4e50316bc4b2 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(ConnectorAlreadyConnectedError, BaseError);
    var _super = (0, $ohfOJ._)(ConnectorAlreadyConnectedError);
    function ConnectorAlreadyConnectedError() {
        (0, $4GJKx._)(this, ConnectorAlreadyConnectedError);
        var _this;
        _this = _super.call(this, "Connector already connected.");
        Object.defineProperty((0, $d3H5E._)(_this), "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ConnectorAlreadyConnectedError"
        });
        return _this;
    }
    return ConnectorAlreadyConnectedError;
}((0, $5fe8c9a1072e57c7$export$a490eb03cb7a0a5e));
var $ad7a5f8bd0b5662c$export$d9a3828eace037a6 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(ConnectorNotConnectedError, BaseError);
    var _super = (0, $ohfOJ._)(ConnectorNotConnectedError);
    function ConnectorNotConnectedError() {
        (0, $4GJKx._)(this, ConnectorNotConnectedError);
        var _this;
        _this = _super.call(this, "Connector not connected.");
        Object.defineProperty((0, $d3H5E._)(_this), "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ConnectorNotConnectedError"
        });
        return _this;
    }
    return ConnectorNotConnectedError;
}((0, $5fe8c9a1072e57c7$export$a490eb03cb7a0a5e));
var $ad7a5f8bd0b5662c$export$9f8a797207d6544e = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(ConnectorNotFoundError, BaseError);
    var _super = (0, $ohfOJ._)(ConnectorNotFoundError);
    function ConnectorNotFoundError() {
        (0, $4GJKx._)(this, ConnectorNotFoundError);
        var _this;
        _this = _super.call(this, "Connector not found.");
        Object.defineProperty((0, $d3H5E._)(_this), "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ConnectorNotFoundError"
        });
        return _this;
    }
    return ConnectorNotFoundError;
}((0, $5fe8c9a1072e57c7$export$a490eb03cb7a0a5e));
var $ad7a5f8bd0b5662c$export$65c369a969e2c62e = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(ConnectorAccountNotFoundError, BaseError);
    var _super = (0, $ohfOJ._)(ConnectorAccountNotFoundError);
    function ConnectorAccountNotFoundError(param) {
        var address = param.address, connector = param.connector;
        (0, $4GJKx._)(this, ConnectorAccountNotFoundError);
        var _this;
        _this = _super.call(this, 'Account "'.concat(address, '" not found for connector "').concat(connector.name, '".'));
        Object.defineProperty((0, $d3H5E._)(_this), "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ConnectorAccountNotFoundError"
        });
        return _this;
    }
    return ConnectorAccountNotFoundError;
}((0, $5fe8c9a1072e57c7$export$a490eb03cb7a0a5e));
var $ad7a5f8bd0b5662c$export$6f9c2f3137249d9c = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(ConnectorChainMismatchError, BaseError);
    var _super = (0, $ohfOJ._)(ConnectorChainMismatchError);
    function ConnectorChainMismatchError(param) {
        var connectionChainId = param.connectionChainId, connectorChainId = param.connectorChainId;
        (0, $4GJKx._)(this, ConnectorChainMismatchError);
        var _this;
        _this = _super.call(this, "The current chain of the connector (id: ".concat(connectorChainId, ") does not match the connection's chain (id: ").concat(connectionChainId, ")."), {
            metaMessages: [
                "Current Chain ID:  ".concat(connectorChainId),
                "Expected Chain ID: ".concat(connectionChainId)
            ]
        });
        Object.defineProperty((0, $d3H5E._)(_this), "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ConnectorChainMismatchError"
        });
        return _this;
    }
    return ConnectorChainMismatchError;
}((0, $5fe8c9a1072e57c7$export$a490eb03cb7a0a5e));



var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $280108186d4a00cc$export$43839b3ff6336f15 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(ProviderNotFoundError, BaseError);
    var _super = (0, $ohfOJ._)(ProviderNotFoundError);
    function ProviderNotFoundError() {
        (0, $4GJKx._)(this, ProviderNotFoundError);
        var _this;
        _this = _super.call(this, "Provider not found.");
        Object.defineProperty((0, $d3H5E._)(_this), "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ProviderNotFoundError"
        });
        return _this;
    }
    return ProviderNotFoundError;
}((0, $5fe8c9a1072e57c7$export$a490eb03cb7a0a5e));
var $280108186d4a00cc$export$a4296a4b7763e5d8 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(SwitchChainNotSupportedError, BaseError);
    var _super = (0, $ohfOJ._)(SwitchChainNotSupportedError);
    function SwitchChainNotSupportedError(param) {
        var connector = param.connector;
        (0, $4GJKx._)(this, SwitchChainNotSupportedError);
        var _this;
        _this = _super.call(this, '"'.concat(connector.name, '" does not support programmatic chain switching.'));
        Object.defineProperty((0, $d3H5E._)(_this), "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "SwitchChainNotSupportedError"
        });
        return _this;
    }
    return SwitchChainNotSupportedError;
}((0, $5fe8c9a1072e57c7$export$a490eb03cb7a0a5e));


function $f077f6357baad451$export$15599da40e72d2f(config, parameters) {
    return $f077f6357baad451$var$_switchChain.apply(this, arguments);
}
function $f077f6357baad451$var$_switchChain() {
    $f077f6357baad451$var$_switchChain = (0, $kSuI9._)(function(config, parameters) {
        var _parameters_connector, addEthereumChainParameter, chainId, _parameters_connector_uid, connection, connector, chain, chain1;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    addEthereumChainParameter = parameters.addEthereumChainParameter, chainId = parameters.chainId;
                    connection = config.state.connections.get((_parameters_connector_uid = (_parameters_connector = parameters.connector) === null || _parameters_connector === void 0 ? void 0 : _parameters_connector.uid) !== null && _parameters_connector_uid !== void 0 ? _parameters_connector_uid : config.state.current);
                    if (!connection) return [
                        3,
                        2
                    ];
                    connector = connection.connector;
                    if (!connector.switchChain) throw new (0, $280108186d4a00cc$export$a4296a4b7763e5d8)({
                        connector: connector
                    });
                    return [
                        4,
                        connector.switchChain({
                            addEthereumChainParameter: addEthereumChainParameter,
                            chainId: chainId
                        })
                    ];
                case 1:
                    chain = _state.sent();
                    return [
                        2,
                        chain
                    ];
                case 2:
                    chain1 = config.chains.find(function(x) {
                        return x.id === chainId;
                    });
                    if (!chain1) throw new (0, $ad7a5f8bd0b5662c$export$688e5fda4b4631ed)();
                    config.setState(function(x) {
                        return (0, $cxjpp._)((0, $do9pw._)({}, x), {
                            chainId: chainId
                        });
                    });
                    return [
                        2,
                        chain1
                    ];
            }
        });
    });
    return $f077f6357baad451$var$_switchChain.apply(this, arguments);
}


var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $eha6O = parcelRequire("eha6O");

function $122e140114974ba5$export$64605811ab45167f(config, parameters) {
    return $122e140114974ba5$var$_connect.apply(this, arguments);
}
function $122e140114974ba5$var$_connect() {
    $122e140114974ba5$var$_connect = (0, $kSuI9._)(function(config, parameters) {
        var connector, _config_storage, data, accounts, error;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof parameters.connector === "function") connector = config._internal.connectors.setup(parameters.connector);
                    else connector = parameters.connector;
                    // Check if connector is already connected
                    if (connector.uid === config.state.current) throw new (0, $ad7a5f8bd0b5662c$export$ee7f4e50316bc4b2)();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    config.setState(function(x) {
                        return (0, $cxjpp._)((0, $do9pw._)({}, x), {
                            status: "connecting"
                        });
                    });
                    connector.emitter.emit("message", {
                        type: "connecting"
                    });
                    return [
                        4,
                        connector.connect({
                            chainId: parameters.chainId
                        })
                    ];
                case 2:
                    data = _state.sent();
                    accounts = data.accounts;
                    connector.emitter.off("connect", config._internal.events.connect);
                    connector.emitter.on("change", config._internal.events.change);
                    connector.emitter.on("disconnect", config._internal.events.disconnect);
                    return [
                        4,
                        (_config_storage = config.storage) === null || _config_storage === void 0 ? void 0 : _config_storage.setItem("recentConnectorId", connector.id)
                    ];
                case 3:
                    _state.sent();
                    config.setState(function(x) {
                        return (0, $cxjpp._)((0, $do9pw._)({}, x), {
                            connections: new Map(x.connections).set(connector.uid, {
                                accounts: accounts,
                                chainId: data.chainId,
                                connector: connector
                            }),
                            current: connector.uid,
                            status: "connected"
                        });
                    });
                    return [
                        2,
                        {
                            accounts: accounts,
                            chainId: data.chainId
                        }
                    ];
                case 4:
                    error = _state.sent();
                    config.setState(function(x) {
                        return (0, $cxjpp._)((0, $do9pw._)({}, x), {
                            // Keep existing connector connected in case of error
                            status: x.current ? "connected" : "disconnected"
                        });
                    });
                    throw error;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return $122e140114974ba5$var$_connect.apply(this, arguments);
}

/** https://wagmi.sh/core/api/actions/disconnect */ 
var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $eha6O = parcelRequire("eha6O");
function $91ceee46be7e0ba4$export$37dfea93db2e14ed(config) {
    return $91ceee46be7e0ba4$var$_disconnect.apply(this, arguments);
}
function $91ceee46be7e0ba4$var$_disconnect() {
    $91ceee46be7e0ba4$var$_disconnect = (0, $kSuI9._)(function(config) {
        var parameters, connector, _config_state, connections, current, connection, connections1, _config_state_connections_get, _config_storage, current1, connector1;
        var _arguments = arguments;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    parameters = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    if (parameters.connector) connector = parameters.connector;
                    else {
                        _config_state = config.state, connections = _config_state.connections, current = _config_state.current;
                        connection = connections.get(current);
                        connector = connection === null || connection === void 0 ? void 0 : connection.connector;
                    }
                    connections1 = config.state.connections;
                    if (!connector) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        connector.disconnect()
                    ];
                case 1:
                    _state.sent();
                    connector.emitter.off("change", config._internal.events.change);
                    connector.emitter.off("disconnect", config._internal.events.disconnect);
                    connector.emitter.on("connect", config._internal.events.connect);
                    connections1.delete(connector.uid);
                    _state.label = 2;
                case 2:
                    config.setState(function(x) {
                        // if no connections exist, move to disconnected state
                        if (connections1.size === 0) return (0, $cxjpp._)((0, $do9pw._)({}, x), {
                            connections: new Map(),
                            current: null,
                            status: "disconnected"
                        });
                        // switch over to another connection
                        var nextConnection = connections1.values().next().value;
                        return (0, $cxjpp._)((0, $do9pw._)({}, x), {
                            connections: new Map(connections1),
                            current: nextConnection.connector.uid
                        });
                    });
                    current1 = config.state.current;
                    if (!current1) return [
                        2
                    ];
                    connector1 = (_config_state_connections_get = config.state.connections.get(current1)) === null || _config_state_connections_get === void 0 ? void 0 : _config_state_connections_get.connector;
                    if (!connector1) return [
                        2
                    ];
                    return [
                        4,
                        (_config_storage = config.storage) === null || _config_storage === void 0 ? void 0 : _config_storage.setItem("recentConnectorId", connector1.id)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $91ceee46be7e0ba4$var$_disconnect.apply(this, arguments);
}


var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $dRLPW = parcelRequire("dRLPW");

var $eha6O = parcelRequire("eha6O");

var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $l2YyF = parcelRequire("l2YyF");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $7ihh7 = parcelRequire("7ihh7");
var $58c5ed114b2c2f06$export$62ee6b05f0767f28 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(AccountNotFoundError, BaseError);
    var _super = (0, $ohfOJ._)(AccountNotFoundError);
    function AccountNotFoundError() {
        var docsPath = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).docsPath;
        (0, $4GJKx._)(this, AccountNotFoundError);
        return _super.call(this, [
            "Could not find an Account to execute with this Action.",
            "Please provide an Account with the `account` argument on the Action, or by supplying an `account` to the Client."
        ].join("\n"), {
            docsPath: docsPath,
            docsSlug: "account",
            name: "AccountNotFoundError"
        });
    }
    return AccountNotFoundError;
}((0, $7ihh7.BaseError));
var $58c5ed114b2c2f06$export$22c1d840ef5fbc66 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(AccountTypeNotSupportedError, BaseError);
    var _super = (0, $ohfOJ._)(AccountTypeNotSupportedError);
    function AccountTypeNotSupportedError(param) {
        var docsPath = param.docsPath, metaMessages = param.metaMessages, type = param.type;
        (0, $4GJKx._)(this, AccountTypeNotSupportedError);
        return _super.call(this, 'Account type "'.concat(type, '" is not supported.'), {
            docsPath: docsPath,
            metaMessages: metaMessages,
            name: "AccountTypeNotSupportedError"
        });
    }
    return AccountTypeNotSupportedError;
}((0, $7ihh7.BaseError));



var $f3VZN = parcelRequire("f3VZN");
function $de0a1e3b33b8ce79$export$1d9a7a8a40780de(client, _) {
    return $de0a1e3b33b8ce79$var$_signMessage.apply(this, arguments);
}
function $de0a1e3b33b8ce79$var$_signMessage() {
    $de0a1e3b33b8ce79$var$_signMessage = (0, $kSuI9._)(function(client, param) {
        var tmp, account_, message, account, message_;
        return (0, $eha6O.__generator)(this, function(_state) {
            tmp = param.account, account_ = tmp === void 0 ? client.account : tmp, message = param.message;
            if (!account_) throw new (0, $58c5ed114b2c2f06$export$62ee6b05f0767f28)({
                docsPath: "/docs/actions/wallet/signMessage"
            });
            account = (0, $l2YyF.parseAccount)(account_);
            if (account.signMessage) return [
                2,
                account.signMessage({
                    message: message
                })
            ];
            message_ = function() {
                if (typeof message === "string") return (0, $f3VZN.stringToHex)(message);
                if (message.raw instanceof Uint8Array) return (0, $f3VZN.toHex)(message.raw);
                return message.raw;
            }();
            return [
                2,
                client.request({
                    method: "personal_sign",
                    params: [
                        message_,
                        account.address
                    ]
                }, {
                    retryCount: 0
                })
            ];
        });
    });
    return $de0a1e3b33b8ce79$var$_signMessage.apply(this, arguments);
}


/**
 * Retrieves and returns an action from the client (if exists), and falls
 * back to the tree-shakable action.
 *
 * Useful for extracting overridden actions from a client (ie. if a consumer
 * wants to override the `sendTransaction` implementation).
 */ function $79c54d690e762313$export$6ca3170acb89054(client, actionFn, // Some minifiers drop `Function.prototype.name`, or replace it with short letters,
// meaning that `actionFn.name` will not always work. For that case, the consumer
// needs to pass the name explicitly.
name) {
    var action_implicit = client[actionFn.name];
    if (typeof action_implicit === "function") return action_implicit;
    var action_explicit = client[name];
    if (typeof action_explicit === "function") return action_explicit;
    return function(params) {
        return actionFn(client, params);
    };
}



var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $cv9Rk = parcelRequire("cv9Rk");

var $eha6O = parcelRequire("eha6O");

var $do9pw = parcelRequire("do9pw");

var $l2YyF = parcelRequire("l2YyF");
var $045accc3b414c820$var$size = 256;
var $045accc3b414c820$var$index = $045accc3b414c820$var$size;
var $045accc3b414c820$var$buffer;
function $045accc3b414c820$export$e2a22331486dcca0() {
    var length = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 11;
    if (!$045accc3b414c820$var$buffer || $045accc3b414c820$var$index + length > $045accc3b414c820$var$size * 2) {
        $045accc3b414c820$var$buffer = "";
        $045accc3b414c820$var$index = 0;
        for(var i = 0; i < $045accc3b414c820$var$size; i++)$045accc3b414c820$var$buffer += (256 + Math.random() * 256 | 0).toString(16).substring(1);
    }
    return $045accc3b414c820$var$buffer.substring($045accc3b414c820$var$index, $045accc3b414c820$var$index++ + length);
}


function $3b636b6bfcd71602$export$5d730b7aed1a3eb0(parameters) {
    var _parameters_pollingInterval;
    var batch = parameters.batch, _parameters_cacheTime = parameters.cacheTime, cacheTime = _parameters_cacheTime === void 0 ? (_parameters_pollingInterval = parameters.pollingInterval) !== null && _parameters_pollingInterval !== void 0 ? _parameters_pollingInterval : 4000 : _parameters_cacheTime, ccipRead = parameters.ccipRead, _parameters_key = parameters.key, key = _parameters_key === void 0 ? "base" : _parameters_key, _parameters_name = parameters.name, name = _parameters_name === void 0 ? "Base Client" : _parameters_name, _parameters_pollingInterval1 = parameters.pollingInterval, pollingInterval = _parameters_pollingInterval1 === void 0 ? 4000 : _parameters_pollingInterval1, _parameters_type = parameters.type, type = _parameters_type === void 0 ? "base" : _parameters_type;
    var chain = parameters.chain;
    var account = parameters.account ? (0, $l2YyF.parseAccount)(parameters.account) : undefined;
    var _parameters_transport = parameters.transport({
        chain: chain,
        pollingInterval: pollingInterval
    }), config = _parameters_transport.config, request = _parameters_transport.request, value = _parameters_transport.value;
    var transport = (0, $do9pw._)({}, config, value);
    var client = {
        account: account,
        batch: batch,
        cacheTime: cacheTime,
        ccipRead: ccipRead,
        chain: chain,
        key: key,
        name: name,
        pollingInterval: pollingInterval,
        request: request,
        transport: transport,
        type: type,
        uid: (0, $045accc3b414c820$export$e2a22331486dcca0)()
    };
    function extend(base) {
        return function(extendFn) {
            var extended = extendFn(base);
            for(var key in client)delete extended[key];
            var combined = (0, $do9pw._)({}, base, extended);
            return Object.assign(combined, {
                extend: extend(combined)
            });
        };
    }
    return Object.assign(client, {
        extend: extend(client)
    });
}
function $3b636b6bfcd71602$export$3db60a9e016ddd81() {
    return null;
}


var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $eha6O = parcelRequire("eha6O");

var $7ihh7 = parcelRequire("7ihh7");

var $5yelF = parcelRequire("5yelF");

var $aqVrP = parcelRequire("aqVrP");

var $f3VZN = parcelRequire("f3VZN");

var $h0UKT = parcelRequire("h0UKT");

var $8Ampo = parcelRequire("8Ampo");
var $202b25b385d4a5dd$export$e89e805418f4d2c = /*#__PURE__*/ new (0, $8Ampo.LruMap)(8192);
function $202b25b385d4a5dd$export$387c3b0c09132fc3(fn, param) {
    var _param_enabled = param.enabled, enabled = _param_enabled === void 0 ? true : _param_enabled, id = param.id;
    if (!enabled || !id) return fn();
    if ($202b25b385d4a5dd$export$e89e805418f4d2c.get(id)) return $202b25b385d4a5dd$export$e89e805418f4d2c.get(id);
    var promise = fn().finally(function() {
        return $202b25b385d4a5dd$export$e89e805418f4d2c.delete(id);
    });
    $202b25b385d4a5dd$export$e89e805418f4d2c.set(id, promise);
    return promise;
}



var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");
function $a77c4d3ea39fd77e$export$5c069c93d2b7493f(time) {
    return $a77c4d3ea39fd77e$var$_wait.apply(this, arguments);
}
function $a77c4d3ea39fd77e$var$_wait() {
    $a77c4d3ea39fd77e$var$_wait = (0, $kSuI9._)(function(time) {
        return (0, $eha6O.__generator)(this, function(_state) {
            return [
                2,
                new Promise(function(res) {
                    return setTimeout(res, time);
                })
            ];
        });
    });
    return $a77c4d3ea39fd77e$var$_wait.apply(this, arguments);
}


function $26064d0812f4a37c$export$188df5ecf8e7961a(fn) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tmp = _ref.delay, delay_ = tmp === void 0 ? 100 : tmp, _ref_retryCount = _ref.retryCount, retryCount = _ref_retryCount === void 0 ? 2 : _ref_retryCount, _ref_shouldRetry = _ref.shouldRetry, shouldRetry = _ref_shouldRetry === void 0 ? function() {
        return true;
    } : _ref_shouldRetry;
    return new Promise(function(resolve, reject) {
        var attemptRetry = function() {
            var _ref = (0, $kSuI9._)(function() {
                var _ref, _ref_count, count, retry, data, err, _tmp;
                var _arguments = arguments;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _ref_count = _ref.count, count = _ref_count === void 0 ? 0 : _ref_count;
                            retry = function() {
                                var _ref = (0, $kSuI9._)(function(param) {
                                    var error, delay;
                                    return (0, $eha6O.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                error = param.error;
                                                delay = typeof delay_ === "function" ? delay_({
                                                    count: count,
                                                    error: error
                                                }) : delay_;
                                                if (!delay) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    (0, $a77c4d3ea39fd77e$export$5c069c93d2b7493f)(delay)
                                                ];
                                            case 1:
                                                _state.sent();
                                                _state.label = 2;
                                            case 2:
                                                attemptRetry({
                                                    count: count + 1
                                                });
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function retry(_) {
                                    return _ref.apply(this, arguments);
                                };
                            }();
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                6
                            ]);
                            return [
                                4,
                                fn()
                            ];
                        case 2:
                            data = _state.sent();
                            resolve(data);
                            return [
                                3,
                                6
                            ];
                        case 3:
                            err = _state.sent();
                            _tmp = count < retryCount;
                            if (!_tmp) return [
                                3,
                                5
                            ];
                            return [
                                4,
                                shouldRetry({
                                    count: count,
                                    error: err
                                })
                            ];
                        case 4:
                            _tmp = _state.sent();
                            _state.label = 5;
                        case 5:
                            if (_tmp) return [
                                2,
                                retry({
                                    error: err
                                })
                            ];
                            reject(err);
                            return [
                                3,
                                6
                            ];
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            });
            return function attemptRetry() {
                return _ref.apply(this, arguments);
            };
        }();
        attemptRetry();
    });
}



var $lUgMT = parcelRequire("lUgMT");
function $56520a7ad0cb2b42$export$6c5295ef7e82f2b2(request) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return function() {
        var _ref = (0, $kSuI9._)(function(args) {
            var overrideOptions, _$_object_spread, _object_spread_dedupe, dedupe, _object_spread_retryDelay, retryDelay, _object_spread_retryCount, retryCount, uid, requestId;
            var _arguments = arguments;
            return (0, $eha6O.__generator)(this, function(_state) {
                overrideOptions = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                _$_object_spread = (0, $do9pw._)({}, options, overrideOptions), _object_spread_dedupe = _$_object_spread.dedupe, dedupe = _object_spread_dedupe === void 0 ? false : _object_spread_dedupe, _object_spread_retryDelay = _$_object_spread.retryDelay, retryDelay = _object_spread_retryDelay === void 0 ? 150 : _object_spread_retryDelay, _object_spread_retryCount = _$_object_spread.retryCount, retryCount = _object_spread_retryCount === void 0 ? 3 : _object_spread_retryCount, uid = _$_object_spread.uid;
                requestId = dedupe ? (0, $h0UKT.keccak256)((0, $f3VZN.stringToHex)("".concat(uid, ".").concat((0, $lUgMT.stringify)(args)))) : undefined;
                return [
                    2,
                    (0, $202b25b385d4a5dd$export$387c3b0c09132fc3)(function() {
                        return (0, $26064d0812f4a37c$export$188df5ecf8e7961a)(/*#__PURE__*/ (0, $kSuI9._)(function() {
                            var err_, err;
                            return (0, $eha6O.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            request(args)
                                        ];
                                    case 1:
                                        return [
                                            2,
                                            _state.sent()
                                        ];
                                    case 2:
                                        err_ = _state.sent();
                                        err = err_;
                                        switch(err.code){
                                            // -32700
                                            case (0, $aqVrP.ParseRpcError).code:
                                                throw new (0, $aqVrP.ParseRpcError)(err);
                                            // -32600
                                            case (0, $aqVrP.InvalidRequestRpcError).code:
                                                throw new (0, $aqVrP.InvalidRequestRpcError)(err);
                                            // -32601
                                            case (0, $aqVrP.MethodNotFoundRpcError).code:
                                                throw new (0, $aqVrP.MethodNotFoundRpcError)(err, {
                                                    method: args.method
                                                });
                                            // -32602
                                            case (0, $aqVrP.InvalidParamsRpcError).code:
                                                throw new (0, $aqVrP.InvalidParamsRpcError)(err);
                                            // -32603
                                            case (0, $aqVrP.InternalRpcError).code:
                                                throw new (0, $aqVrP.InternalRpcError)(err);
                                            // -32000
                                            case (0, $aqVrP.InvalidInputRpcError).code:
                                                throw new (0, $aqVrP.InvalidInputRpcError)(err);
                                            // -32001
                                            case (0, $aqVrP.ResourceNotFoundRpcError).code:
                                                throw new (0, $aqVrP.ResourceNotFoundRpcError)(err);
                                            // -32002
                                            case (0, $aqVrP.ResourceUnavailableRpcError).code:
                                                throw new (0, $aqVrP.ResourceUnavailableRpcError)(err);
                                            // -32003
                                            case (0, $aqVrP.TransactionRejectedRpcError).code:
                                                throw new (0, $aqVrP.TransactionRejectedRpcError)(err);
                                            // -32004
                                            case (0, $aqVrP.MethodNotSupportedRpcError).code:
                                                throw new (0, $aqVrP.MethodNotSupportedRpcError)(err, {
                                                    method: args.method
                                                });
                                            // -32005
                                            case (0, $aqVrP.LimitExceededRpcError).code:
                                                throw new (0, $aqVrP.LimitExceededRpcError)(err);
                                            // -32006
                                            case (0, $aqVrP.JsonRpcVersionUnsupportedError).code:
                                                throw new (0, $aqVrP.JsonRpcVersionUnsupportedError)(err);
                                            // 4001
                                            case (0, $aqVrP.UserRejectedRequestError).code:
                                                throw new (0, $aqVrP.UserRejectedRequestError)(err);
                                            // 4100
                                            case (0, $aqVrP.UnauthorizedProviderError).code:
                                                throw new (0, $aqVrP.UnauthorizedProviderError)(err);
                                            // 4200
                                            case (0, $aqVrP.UnsupportedProviderMethodError).code:
                                                throw new (0, $aqVrP.UnsupportedProviderMethodError)(err);
                                            // 4900
                                            case (0, $aqVrP.ProviderDisconnectedError).code:
                                                throw new (0, $aqVrP.ProviderDisconnectedError)(err);
                                            // 4901
                                            case (0, $aqVrP.ChainDisconnectedError).code:
                                                throw new (0, $aqVrP.ChainDisconnectedError)(err);
                                            // 4902
                                            case (0, $aqVrP.SwitchChainError).code:
                                                throw new (0, $aqVrP.SwitchChainError)(err);
                                            // CAIP-25: User Rejected Error
                                            // https://docs.walletconnect.com/2.0/specs/clients/sign/error-codes#rejected-caip-25
                                            case 5000:
                                                throw new (0, $aqVrP.UserRejectedRequestError)(err);
                                            default:
                                                if (err_ instanceof (0, $7ihh7.BaseError)) throw err_;
                                                throw new (0, $aqVrP.UnknownRpcError)(err);
                                        }
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        }), {
                            delay: function(param) {
                                var count = param.count, error = param.error;
                                // If we find a Retry-After header, let's retry after the given time.
                                if (error && error instanceof (0, $5yelF.HttpRequestError)) {
                                    var _error_headers;
                                    var retryAfter = error === null || error === void 0 ? void 0 : (_error_headers = error.headers) === null || _error_headers === void 0 ? void 0 : _error_headers.get("Retry-After");
                                    if (retryAfter === null || retryAfter === void 0 ? void 0 : retryAfter.match(/\d/)) return Number.parseInt(retryAfter) * 1000;
                                }
                                // Otherwise, let's retry with an exponential backoff.
                                return ~~(1 << count) * retryDelay;
                            },
                            retryCount: retryCount,
                            shouldRetry: function(param) {
                                var error = param.error;
                                return $56520a7ad0cb2b42$export$7bfea3c3d460ecd8(error);
                            }
                        });
                    }, {
                        enabled: dedupe,
                        id: requestId
                    })
                ];
            });
        });
        return function(args) {
            return _ref.apply(this, arguments);
        };
    }();
}
function $56520a7ad0cb2b42$export$7bfea3c3d460ecd8(error) {
    if ("code" in error && typeof error.code === "number") {
        if (error.code === -1) return true; // Unknown error
        if (error.code === (0, $aqVrP.LimitExceededRpcError).code) return true;
        if (error.code === (0, $aqVrP.InternalRpcError).code) return true;
        return false;
    }
    if (error instanceof (0, $5yelF.HttpRequestError) && error.status) {
        // Forbidden
        if (error.status === 403) return true;
        // Request Timeout
        if (error.status === 408) return true;
        // Request Entity Too Large
        if (error.status === 413) return true;
        // Too Many Requests
        if (error.status === 429) return true;
        // Internal Server Error
        if (error.status === 500) return true;
        // Bad Gateway
        if (error.status === 502) return true;
        // Service Unavailable
        if (error.status === 503) return true;
        // Gateway Timeout
        if (error.status === 504) return true;
        return false;
    }
    return true;
}



function $7a1b698487ed0e09$export$d09f50d9ab7f7b69(param, value) {
    var key = param.key, name = param.name, request = param.request, _param_retryCount = param.retryCount, retryCount = _param_retryCount === void 0 ? 3 : _param_retryCount, _param_retryDelay = param.retryDelay, retryDelay = _param_retryDelay === void 0 ? 150 : _param_retryDelay, timeout = param.timeout, type = param.type;
    var uid = (0, $045accc3b414c820$export$e2a22331486dcca0)();
    return {
        config: {
            key: key,
            name: name,
            request: request,
            retryCount: retryCount,
            retryDelay: retryDelay,
            timeout: timeout,
            type: type
        },
        request: (0, $56520a7ad0cb2b42$export$6c5295ef7e82f2b2)(request, {
            retryCount: retryCount,
            retryDelay: retryDelay,
            uid: uid
        }),
        value: value
    };
}


function $ee1926b8332bb274$export$4c00f665f0d4b443(provider) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _config_key = config.key, key = _config_key === void 0 ? "custom" : _config_key, _config_name = config.name, name = _config_name === void 0 ? "Custom Provider" : _config_name, retryDelay = config.retryDelay;
    return function(param) {
        var defaultRetryCount = param.retryCount;
        var _config_retryCount;
        return (0, $7a1b698487ed0e09$export$d09f50d9ab7f7b69)({
            key: key,
            name: name,
            request: provider.request.bind(provider),
            retryCount: (_config_retryCount = config.retryCount) !== null && _config_retryCount !== void 0 ? _config_retryCount : defaultRetryCount,
            retryDelay: retryDelay,
            type: "custom"
        });
    };
}



var $l2YyF = parcelRequire("l2YyF");
var $8zfHX = parcelRequire("8zfHX");

function $c7c82ca8fcf669fd$export$d784801ca17b4aec(config) {
    return $c7c82ca8fcf669fd$var$_getConnectorClient.apply(this, arguments);
}
function $c7c82ca8fcf669fd$var$_getConnectorClient() {
    $c7c82ca8fcf669fd$var$_getConnectorClient = (0, $kSuI9._)(function(config) {
        var parameters, connection, connector, _ref, accounts, chainId, _parameters_chainId, chainId1, connectorChainId, connector1, _parameters_account, account, chain, provider;
        var _arguments = arguments;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    parameters = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    if (!parameters.connector) return [
                        3,
                        2
                    ];
                    connector = parameters.connector;
                    return [
                        4,
                        Promise.all([
                            connector.getAccounts(),
                            connector.getChainId()
                        ])
                    ];
                case 1:
                    _ref = (0, $cv9Rk._).apply(void 0, [
                        _state.sent(),
                        2
                    ]), accounts = _ref[0], chainId = _ref[1];
                    connection = {
                        accounts: accounts,
                        chainId: chainId,
                        connector: connector
                    };
                    return [
                        3,
                        3
                    ];
                case 2:
                    connection = config.state.connections.get(config.state.current);
                    _state.label = 3;
                case 3:
                    if (!connection) throw new (0, $ad7a5f8bd0b5662c$export$d9a3828eace037a6)();
                    chainId1 = (_parameters_chainId = parameters.chainId) !== null && _parameters_chainId !== void 0 ? _parameters_chainId : connection.chainId;
                    return [
                        4,
                        connection.connector.getChainId()
                    ];
                case 4:
                    connectorChainId = _state.sent();
                    if (connectorChainId !== connection.chainId) throw new (0, $ad7a5f8bd0b5662c$export$6f9c2f3137249d9c)({
                        connectionChainId: connection.chainId,
                        connectorChainId: connectorChainId
                    });
                    connector1 = connection.connector;
                    if (connector1.getClient) return [
                        2,
                        connector1.getClient({
                            chainId: chainId1
                        })
                    ];
                    // Default using `custom` transport
                    account = (0, $l2YyF.parseAccount)((_parameters_account = parameters.account) !== null && _parameters_account !== void 0 ? _parameters_account : connection.accounts[0]);
                    account.address = (0, $8zfHX.getAddress)(account.address); // TODO: Checksum address as part of `parseAccount`?
                    chain = config.chains.find(function(chain) {
                        return chain.id === chainId1;
                    });
                    return [
                        4,
                        connection.connector.getProvider({
                            chainId: chainId1
                        })
                    ];
                case 5:
                    provider = _state.sent();
                    // If account was provided, check that it exists on the connector
                    if (parameters.account && !connection.accounts.some(function(x) {
                        return x.toLowerCase() === account.address.toLowerCase();
                    })) throw new (0, $ad7a5f8bd0b5662c$export$65c369a969e2c62e)({
                        address: account.address,
                        connector: connector1
                    });
                    return [
                        2,
                        (0, $3b636b6bfcd71602$export$5d730b7aed1a3eb0)({
                            account: account,
                            chain: chain,
                            name: "Connector Client",
                            transport: function(opts) {
                                return (0, $ee1926b8332bb274$export$4c00f665f0d4b443)(provider)((0, $cxjpp._)((0, $do9pw._)({}, opts), {
                                    retryCount: 0
                                }));
                            }
                        })
                    ];
            }
        });
    });
    return $c7c82ca8fcf669fd$var$_getConnectorClient.apply(this, arguments);
}


function $3a5afdbe326ed31c$export$1d9a7a8a40780de(config, parameters) {
    return $3a5afdbe326ed31c$var$_signMessage.apply(this, arguments);
}
function $3a5afdbe326ed31c$var$_signMessage() {
    $3a5afdbe326ed31c$var$_signMessage = (0, $kSuI9._)(function(config, parameters) {
        var account, connector, rest, client, action;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    account = parameters.account, connector = parameters.connector, rest = (0, $dRLPW._)(parameters, [
                        "account",
                        "connector"
                    ]);
                    if (!(typeof account === "object" && account.type === "local")) return [
                        3,
                        1
                    ];
                    client = config.getClient();
                    return [
                        3,
                        3
                    ];
                case 1:
                    return [
                        4,
                        (0, $c7c82ca8fcf669fd$export$d784801ca17b4aec)(config, {
                            account: account,
                            connector: connector
                        })
                    ];
                case 2:
                    client = _state.sent();
                    _state.label = 3;
                case 3:
                    action = (0, $79c54d690e762313$export$6ca3170acb89054)(client, (0, $de0a1e3b33b8ce79$export$1d9a7a8a40780de), "signMessage");
                    return [
                        2,
                        action((0, $do9pw._)({}, rest, account ? {
                            account: account
                        } : {}))
                    ];
            }
        });
    });
    return $3a5afdbe326ed31c$var$_signMessage.apply(this, arguments);
}


var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");

var $eha6O = parcelRequire("eha6O");

var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");

var $eha6O = parcelRequire("eha6O");

var $l2YyF = parcelRequire("l2YyF");

var $7ihh7 = parcelRequire("7ihh7");

var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $8zfHX = parcelRequire("8zfHX");

var $h0UKT = parcelRequire("h0UKT");
function $95dd5953b065b5f4$export$462669520a9d12d1(publicKey) {
    var address = (0, $h0UKT.keccak256)("0x".concat(publicKey.substring(4))).substring(26);
    return (0, $8zfHX.checksumAddress)("0x".concat(address));
}



var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $aP7UT = parcelRequire("aP7UT");

var $itrhm = parcelRequire("itrhm");

var $f3VZN = parcelRequire("f3VZN");
function $5858b984ccdf29b3$export$952dd09fbe0232b7(_) {
    return $5858b984ccdf29b3$var$_recoverPublicKey.apply(this, arguments);
}

function $5858b984ccdf29b3$var$_recoverPublicKey() {
    $5858b984ccdf29b3$var$_recoverPublicKey = (0, $kSuI9._)(function(param) {
        var hash, signature, hashHex, secp256k1, signature_, publicKey;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    hash = param.hash, signature = param.signature;
                    hashHex = (0, $aP7UT.isHex)(hash) ? hash : (0, $f3VZN.toHex)(hash);
                    return [
                        4,
                        Promise.resolve((parcelRequire("9i2gq")))
                    ];
                case 1:
                    secp256k1 = _state.sent().secp256k1;
                    signature_ = function() {
                        // typeof signature: `Signature`
                        if (typeof signature === "object" && "r" in signature && "s" in signature) {
                            var r = signature.r, s = signature.s, v = signature.v, yParity = signature.yParity;
                            var yParityOrV = Number(yParity !== null && yParity !== void 0 ? yParity : v);
                            var recoveryBit = $5858b984ccdf29b3$var$toRecoveryBit(yParityOrV);
                            return new secp256k1.Signature((0, $itrhm.hexToBigInt)(r), (0, $itrhm.hexToBigInt)(s)).addRecoveryBit(recoveryBit);
                        }
                        // typeof signature: `Hex | ByteArray`
                        var signatureHex = (0, $aP7UT.isHex)(signature) ? signature : (0, $f3VZN.toHex)(signature);
                        var yParityOrV1 = (0, $itrhm.hexToNumber)("0x".concat(signatureHex.slice(130)));
                        var recoveryBit1 = $5858b984ccdf29b3$var$toRecoveryBit(yParityOrV1);
                        return secp256k1.Signature.fromCompact(signatureHex.substring(2, 130)).addRecoveryBit(recoveryBit1);
                    }();
                    publicKey = signature_.recoverPublicKey(hashHex.substring(2)).toHex(false);
                    return [
                        2,
                        "0x".concat(publicKey)
                    ];
            }
        });
    });
    return $5858b984ccdf29b3$var$_recoverPublicKey.apply(this, arguments);
}
function $5858b984ccdf29b3$var$toRecoveryBit(yParityOrV) {
    if (yParityOrV === 0 || yParityOrV === 1) return yParityOrV;
    if (yParityOrV === 27) return 0;
    if (yParityOrV === 28) return 1;
    throw new Error("Invalid yParityOrV value");
}


function $d70d5b44ce3174ec$export$23cc18f96d8510e2(_) {
    return $d70d5b44ce3174ec$var$_recoverAddress.apply(this, arguments);
}
function $d70d5b44ce3174ec$var$_recoverAddress() {
    $d70d5b44ce3174ec$var$_recoverAddress = (0, $kSuI9._)(function(param) {
        var hash, signature;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    hash = param.hash, signature = param.signature;
                    return [
                        4,
                        (0, $5858b984ccdf29b3$export$952dd09fbe0232b7)({
                            hash: hash,
                            signature: signature
                        })
                    ];
                case 1:
                    return [
                        2,
                        (0, $95dd5953b065b5f4$export$462669520a9d12d1).apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return $d70d5b44ce3174ec$var$_recoverAddress.apply(this, arguments);
}



var $ewLmX = parcelRequire("ewLmX");

var $g8Qfu = parcelRequire("g8Qfu");

var $f3VZN = parcelRequire("f3VZN");


var $h0UKT = parcelRequire("h0UKT");
function $62c154f1d726852a$export$52e574e057b290dc(parameters) {
    var chainId = parameters.chainId, contractAddress = parameters.contractAddress, nonce = parameters.nonce, to = parameters.to;
    var hash = (0, $h0UKT.keccak256)((0, $ewLmX.concatHex)([
        "0x05",
        (0, $386e2dc3c188940d$export$140c78e750979cda)([
            (0, $f3VZN.numberToHex)(chainId),
            contractAddress,
            (0, $f3VZN.numberToHex)(nonce)
        ])
    ]));
    if (to === "bytes") return (0, $g8Qfu.hexToBytes)(hash);
    return hash;
}


function $15a1aceb58378c31$export$415d0315604a8515(parameters) {
    return $15a1aceb58378c31$var$_recoverAuthorizationAddress.apply(this, arguments);
}
function $15a1aceb58378c31$var$_recoverAuthorizationAddress() {
    $15a1aceb58378c31$var$_recoverAuthorizationAddress = (0, $kSuI9._)(function(parameters) {
        var authorization, signature;
        return (0, $eha6O.__generator)(this, function(_state) {
            authorization = parameters.authorization, signature = parameters.signature;
            return [
                2,
                (0, $d70d5b44ce3174ec$export$23cc18f96d8510e2)({
                    hash: (0, $62c154f1d726852a$export$52e574e057b290dc)(authorization),
                    signature: signature !== null && signature !== void 0 ? signature : authorization
                })
            ];
        });
    });
    return $15a1aceb58378c31$var$_recoverAuthorizationAddress.apply(this, arguments);
}



var $f3VZN = parcelRequire("f3VZN");

var $do9pw = parcelRequire("do9pw");

var $dRLPW = parcelRequire("dRLPW");

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $c6Xmf = parcelRequire("c6Xmf");

var $ohfOJ = parcelRequire("ohfOJ");

var $2LEmF = parcelRequire("2LEmF");

var $PaOKy = parcelRequire("PaOKy");

var $7ihh7 = parcelRequire("7ihh7");

var $hgawa = parcelRequire("hgawa");
var $71d16e9c5d8e9c0c$export$9e393e362ab0c102 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(EstimateGasExecutionError, BaseError);
    var _super = (0, $ohfOJ._)(EstimateGasExecutionError);
    function EstimateGasExecutionError(cause, param) {
        var account = param.account, docsPath = param.docsPath, chain = param.chain, data = param.data, gas = param.gas, gasPrice = param.gasPrice, maxFeePerGas = param.maxFeePerGas, maxPriorityFeePerGas = param.maxPriorityFeePerGas, nonce = param.nonce, to = param.to, value = param.value;
        (0, $4GJKx._)(this, EstimateGasExecutionError);
        var _this;
        var _chain_nativeCurrency;
        var prettyArgs = (0, $hgawa.prettyPrint)({
            from: account === null || account === void 0 ? void 0 : account.address,
            to: to,
            value: typeof value !== "undefined" && "".concat((0, $2LEmF.formatEther)(value), " ").concat((chain === null || chain === void 0 ? void 0 : (_chain_nativeCurrency = chain.nativeCurrency) === null || _chain_nativeCurrency === void 0 ? void 0 : _chain_nativeCurrency.symbol) || "ETH"),
            data: data,
            gas: gas,
            gasPrice: typeof gasPrice !== "undefined" && "".concat((0, $PaOKy.formatGwei)(gasPrice), " gwei"),
            maxFeePerGas: typeof maxFeePerGas !== "undefined" && "".concat((0, $PaOKy.formatGwei)(maxFeePerGas), " gwei"),
            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== "undefined" && "".concat((0, $PaOKy.formatGwei)(maxPriorityFeePerGas), " gwei"),
            nonce: nonce
        });
        _this = _super.call(this, cause.shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: (0, $c6Xmf._)(cause.metaMessages ? (0, $c6Xmf._)(cause.metaMessages).concat([
                " "
            ]) : []).concat([
                "Estimate Gas Arguments:",
                prettyArgs
            ]).filter(Boolean),
            name: "EstimateGasExecutionError"
        });
        Object.defineProperty((0, $d3H5E._)(_this), "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this.cause = cause;
        return _this;
    }
    return EstimateGasExecutionError;
}((0, $7ihh7.BaseError));



var $btxjr = parcelRequire("btxjr");

var $lVJzh = parcelRequire("lVJzh");
function $5d6fb596d874d36d$export$f201b805dbcd7c48(err, _param) {
    var docsPath = _param.docsPath, args = (0, $dRLPW._)(_param, [
        "docsPath"
    ]);
    var cause = function() {
        var cause = (0, $lVJzh.getNodeError)(err, args);
        if (cause instanceof (0, $btxjr.UnknownNodeError)) return err;
        return cause;
    }();
    return new (0, $71d16e9c5d8e9c0c$export$9e393e362ab0c102)(cause, (0, $do9pw._)({
        docsPath: docsPath
    }, args));
}



var $6N8Zo = parcelRequire("6N8Zo");

var $17do3 = parcelRequire("17do3");

var $7h9bY = parcelRequire("7h9bY");

var $p2XJW = parcelRequire("p2XJW");

var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $l0HdX = parcelRequire("l0HdX");

var $eha6O = parcelRequire("eha6O");

var $l2YyF = parcelRequire("l2YyF");

var $kSuI9 = parcelRequire("kSuI9");

var $l0HdX = parcelRequire("l0HdX");

var $eha6O = parcelRequire("eha6O");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $PaOKy = parcelRequire("PaOKy");

var $7ihh7 = parcelRequire("7ihh7");
var $27e9eb63dd13bf29$export$200c092bedf29ac0 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(BaseFeeScalarError, BaseError);
    var _super = (0, $ohfOJ._)(BaseFeeScalarError);
    function BaseFeeScalarError() {
        (0, $4GJKx._)(this, BaseFeeScalarError);
        return _super.call(this, "`baseFeeMultiplier` must be greater than 1.", {
            name: "BaseFeeScalarError"
        });
    }
    return BaseFeeScalarError;
}((0, $7ihh7.BaseError));
var $27e9eb63dd13bf29$export$dcf53c0ae183fb46 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(Eip1559FeesNotSupportedError, BaseError);
    var _super = (0, $ohfOJ._)(Eip1559FeesNotSupportedError);
    function Eip1559FeesNotSupportedError() {
        (0, $4GJKx._)(this, Eip1559FeesNotSupportedError);
        return _super.call(this, "Chain does not support EIP-1559 fees.", {
            name: "Eip1559FeesNotSupportedError"
        });
    }
    return Eip1559FeesNotSupportedError;
}((0, $7ihh7.BaseError));
var $27e9eb63dd13bf29$export$bcf9730904a1086f = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(MaxFeePerGasTooLowError, BaseError);
    var _super = (0, $ohfOJ._)(MaxFeePerGasTooLowError);
    function MaxFeePerGasTooLowError(param) {
        var maxPriorityFeePerGas = param.maxPriorityFeePerGas;
        (0, $4GJKx._)(this, MaxFeePerGasTooLowError);
        return _super.call(this, "`maxFeePerGas` cannot be less than the `maxPriorityFeePerGas` (".concat((0, $PaOKy.formatGwei)(maxPriorityFeePerGas), " gwei)."), {
            name: "MaxFeePerGasTooLowError"
        });
    }
    return MaxFeePerGasTooLowError;
}((0, $7ihh7.BaseError));


/**
 * Retrieves and returns an action from the client (if exists), and falls
 * back to the tree-shakable action.
 *
 * Useful for extracting overridden actions from a client (ie. if a consumer
 * wants to override the `sendTransaction` implementation).
 */ function $b75d685676ab0a62$export$6ca3170acb89054(client, actionFn, // Some minifiers drop `Function.prototype.name`, or replace it with short letters,
// meaning that `actionFn.name` will not always work. For that case, the consumer
// needs to pass the name explicitly.
name) {
    var action_implicit = client[actionFn.name];
    if (typeof action_implicit === "function") return action_implicit;
    var action_explicit = client[name];
    if (typeof action_explicit === "function") return action_explicit;
    return function(params) {
        return actionFn(client, params);
    };
}



var $kSuI9 = parcelRequire("kSuI9");

var $cv9Rk = parcelRequire("cv9Rk");

var $l0HdX = parcelRequire("l0HdX");

var $eha6O = parcelRequire("eha6O");


var $itrhm = parcelRequire("itrhm");


var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $7ihh7 = parcelRequire("7ihh7");
var $16bcd5f9a78aa912$export$f5a00468af285e38 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(BlockNotFoundError, BaseError);
    var _super = (0, $ohfOJ._)(BlockNotFoundError);
    function BlockNotFoundError(param) {
        var blockHash = param.blockHash, blockNumber = param.blockNumber;
        (0, $4GJKx._)(this, BlockNotFoundError);
        var identifier = "Block";
        if (blockHash) identifier = 'Block at hash "'.concat(blockHash, '"');
        if (blockNumber) identifier = 'Block at number "'.concat(blockNumber, '"');
        return _super.call(this, "".concat(identifier, " could not be found."), {
            name: "BlockNotFoundError"
        });
    }
    return BlockNotFoundError;
}((0, $7ihh7.BaseError));



var $f3VZN = parcelRequire("f3VZN");

function $985463a4c6a1d2e4$export$ea0af84ed2e77902(client) {
    return $985463a4c6a1d2e4$var$_getBlock.apply(this, arguments);
}
function $985463a4c6a1d2e4$var$_getBlock() {
    $985463a4c6a1d2e4$var$_getBlock = (0, $kSuI9._)(function(client) {
        var _ref, blockHash, blockNumber, blockTag_, includeTransactions_, _client_chain_formatters_block, _client_chain_formatters, _client_chain, blockTag, includeTransactions, blockNumberHex, block, format;
        var _arguments = arguments;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ref = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, blockHash = _ref.blockHash, blockNumber = _ref.blockNumber, blockTag_ = _ref.blockTag, includeTransactions_ = _ref.includeTransactions;
                    blockTag = blockTag_ !== null && blockTag_ !== void 0 ? blockTag_ : "latest";
                    includeTransactions = includeTransactions_ !== null && includeTransactions_ !== void 0 ? includeTransactions_ : false;
                    blockNumberHex = blockNumber !== undefined ? (0, $f3VZN.numberToHex)(blockNumber) : undefined;
                    block = null;
                    if (!blockHash) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        client.request({
                            method: "eth_getBlockByHash",
                            params: [
                                blockHash,
                                includeTransactions
                            ]
                        }, {
                            dedupe: true
                        })
                    ];
                case 1:
                    block = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        client.request({
                            method: "eth_getBlockByNumber",
                            params: [
                                blockNumberHex || blockTag,
                                includeTransactions
                            ]
                        }, {
                            dedupe: Boolean(blockNumberHex)
                        })
                    ];
                case 3:
                    block = _state.sent();
                    _state.label = 4;
                case 4:
                    if (!block) throw new (0, $16bcd5f9a78aa912$export$f5a00468af285e38)({
                        blockHash: blockHash,
                        blockNumber: blockNumber
                    });
                    format = ((_client_chain = client.chain) === null || _client_chain === void 0 ? void 0 : (_client_chain_formatters = _client_chain.formatters) === null || _client_chain_formatters === void 0 ? void 0 : (_client_chain_formatters_block = _client_chain_formatters.block) === null || _client_chain_formatters_block === void 0 ? void 0 : _client_chain_formatters_block.format) || (0, $f6087e0399f0c94f$export$ba1152bc4017d62a);
                    return [
                        2,
                        format(block)
                    ];
            }
        });
    });
    return $985463a4c6a1d2e4$var$_getBlock.apply(this, arguments);
}


/**
 * Returns the current price of gas (in wei).
 *
 * - Docs: https://viem.sh/docs/actions/public/getGasPrice
 * - JSON-RPC Methods: [`eth_gasPrice`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_gasprice)
 *
 * @param client - Client to use
 * @returns The gas price (in wei). {@link GetGasPriceReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getGasPrice } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const gasPrice = await getGasPrice(client)
 */ 
var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");
function $d938e21ef1904b42$export$89c15b50d46d3f8c(client) {
    return $d938e21ef1904b42$var$_getGasPrice.apply(this, arguments);
}
function $d938e21ef1904b42$var$_getGasPrice() {
    $d938e21ef1904b42$var$_getGasPrice = (0, $kSuI9._)(function(client) {
        var gasPrice;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        client.request({
                            method: "eth_gasPrice"
                        })
                    ];
                case 1:
                    gasPrice = _state.sent();
                    return [
                        2,
                        BigInt(gasPrice)
                    ];
            }
        });
    });
    return $d938e21ef1904b42$var$_getGasPrice.apply(this, arguments);
}


function $0a0dd3d64a962158$export$fd79a693887f886c(client, args) {
    return $0a0dd3d64a962158$var$_estimateMaxPriorityFeePerGas.apply(this, arguments);
}
function $0a0dd3d64a962158$var$_estimateMaxPriorityFeePerGas() {
    $0a0dd3d64a962158$var$_estimateMaxPriorityFeePerGas = (0, $kSuI9._)(function(client, args) {
        return (0, $eha6O.__generator)(this, function(_state) {
            return [
                2,
                $0a0dd3d64a962158$export$59275bafd388148(client, args)
            ];
        });
    });
    return $0a0dd3d64a962158$var$_estimateMaxPriorityFeePerGas.apply(this, arguments);
}
function $0a0dd3d64a962158$export$59275bafd388148(client, args) {
    return $0a0dd3d64a962158$var$_internal_estimateMaxPriorityFeePerGas.apply(this, arguments);
}
function $0a0dd3d64a962158$var$_internal_estimateMaxPriorityFeePerGas() {
    $0a0dd3d64a962158$var$_internal_estimateMaxPriorityFeePerGas = (0, $kSuI9._)(function(client, args) {
        var _ref, block_, _ref_chain, chain, request, _chain_fees, _chain_fees1, _chain_fees_maxPriorityFeePerGas, maxPriorityFeePerGas, block, _tmp, maxPriorityFeePerGas_, maxPriorityFeePerGasHex, e, _ref1, block1, gasPrice, maxPriorityFeePerGas1;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ref = args || {}, block_ = _ref.block, _ref_chain = _ref.chain, chain = _ref_chain === void 0 ? client.chain : _ref_chain, request = _ref.request;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        ,
                        9
                    ]);
                    maxPriorityFeePerGas = (_chain_fees_maxPriorityFeePerGas = chain === null || chain === void 0 ? void 0 : (_chain_fees = chain.fees) === null || _chain_fees === void 0 ? void 0 : _chain_fees.maxPriorityFeePerGas) !== null && _chain_fees_maxPriorityFeePerGas !== void 0 ? _chain_fees_maxPriorityFeePerGas : chain === null || chain === void 0 ? void 0 : (_chain_fees1 = chain.fees) === null || _chain_fees1 === void 0 ? void 0 : _chain_fees1.defaultPriorityFee;
                    if (!(typeof maxPriorityFeePerGas === "function")) return [
                        3,
                        5
                    ];
                    _tmp = block_;
                    if (_tmp) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $985463a4c6a1d2e4$export$ea0af84ed2e77902), "getBlock")({})
                    ];
                case 2:
                    _tmp = _state.sent();
                    _state.label = 3;
                case 3:
                    block = _tmp;
                    return [
                        4,
                        maxPriorityFeePerGas({
                            block: block,
                            client: client,
                            request: request
                        })
                    ];
                case 4:
                    maxPriorityFeePerGas_ = _state.sent();
                    if (maxPriorityFeePerGas_ === null) throw new Error();
                    return [
                        2,
                        maxPriorityFeePerGas_
                    ];
                case 5:
                    if (typeof maxPriorityFeePerGas !== "undefined") return [
                        2,
                        maxPriorityFeePerGas
                    ];
                    return [
                        4,
                        client.request({
                            method: "eth_maxPriorityFeePerGas"
                        })
                    ];
                case 6:
                    maxPriorityFeePerGasHex = _state.sent();
                    return [
                        2,
                        (0, $itrhm.hexToBigInt)(maxPriorityFeePerGasHex)
                    ];
                case 7:
                    e = _state.sent();
                    return [
                        4,
                        Promise.all([
                            block_ ? Promise.resolve(block_) : (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $985463a4c6a1d2e4$export$ea0af84ed2e77902), "getBlock")({}),
                            (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $d938e21ef1904b42$export$89c15b50d46d3f8c), "getGasPrice")({})
                        ])
                    ];
                case 8:
                    _ref1 = (0, $cv9Rk._).apply(void 0, [
                        _state.sent(),
                        2
                    ]), block1 = _ref1[0], gasPrice = _ref1[1];
                    if ((0, $l0HdX._)(block1.baseFeePerGas) !== "bigint") throw new (0, $27e9eb63dd13bf29$export$dcf53c0ae183fb46)();
                    maxPriorityFeePerGas1 = gasPrice - block1.baseFeePerGas;
                    if (maxPriorityFeePerGas1 < 0n) return [
                        2,
                        0n
                    ];
                    return [
                        2,
                        maxPriorityFeePerGas1
                    ];
                case 9:
                    return [
                        2
                    ];
            }
        });
    });
    return $0a0dd3d64a962158$var$_internal_estimateMaxPriorityFeePerGas.apply(this, arguments);
}




function $c6a8e460e4f994e2$export$8193bed8c46d2831(client, args) {
    return $c6a8e460e4f994e2$var$_estimateFeesPerGas.apply(this, arguments);
}
function $c6a8e460e4f994e2$var$_estimateFeesPerGas() {
    $c6a8e460e4f994e2$var$_estimateFeesPerGas = (0, $kSuI9._)(function(client, args) {
        return (0, $eha6O.__generator)(this, function(_state) {
            return [
                2,
                $c6a8e460e4f994e2$export$67115e8707c5a9e(client, args)
            ];
        });
    });
    return $c6a8e460e4f994e2$var$_estimateFeesPerGas.apply(this, arguments);
}
function $c6a8e460e4f994e2$export$67115e8707c5a9e(client, args) {
    return $c6a8e460e4f994e2$var$_internal_estimateFeesPerGas.apply(this, arguments);
}
function $c6a8e460e4f994e2$var$_internal_estimateFeesPerGas() {
    $c6a8e460e4f994e2$var$_internal_estimateFeesPerGas = (0, $kSuI9._)(function(client, args) {
        var _baseFeeMultiplier_toString_split_, _chain_fees, _ref, block_, _ref_chain, chain, request, _ref_type, type, baseFeeMultiplier, _baseFeeMultiplier_toString_split__length, decimals, denominator, multiply, block, _tmp, fees, maxPriorityFeePerGas, _tmp1, baseFeePerGas, _request_maxFeePerGas, maxFeePerGas, _request_gasPrice, gasPrice, _tmp2;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ref = args || {}, block_ = _ref.block, _ref_chain = _ref.chain, chain = _ref_chain === void 0 ? client.chain : _ref_chain, request = _ref.request, _ref_type = _ref.type, type = _ref_type === void 0 ? "eip1559" : _ref_type;
                    return [
                        4,
                        (0, $kSuI9._)(function() {
                            var _chain_fees, _chain_fees1, _chain_fees_baseFeeMultiplier;
                            return (0, $eha6O.__generator)(this, function(_state) {
                                if (typeof (chain === null || chain === void 0 ? void 0 : (_chain_fees = chain.fees) === null || _chain_fees === void 0 ? void 0 : _chain_fees.baseFeeMultiplier) === "function") return [
                                    2,
                                    chain.fees.baseFeeMultiplier({
                                        block: block_,
                                        client: client,
                                        request: request
                                    })
                                ];
                                return [
                                    2,
                                    (_chain_fees_baseFeeMultiplier = chain === null || chain === void 0 ? void 0 : (_chain_fees1 = chain.fees) === null || _chain_fees1 === void 0 ? void 0 : _chain_fees1.baseFeeMultiplier) !== null && _chain_fees_baseFeeMultiplier !== void 0 ? _chain_fees_baseFeeMultiplier : 1.2
                                ];
                            });
                        })()
                    ];
                case 1:
                    baseFeeMultiplier = _state.sent();
                    if (baseFeeMultiplier < 1) throw new (0, $27e9eb63dd13bf29$export$200c092bedf29ac0)();
                    decimals = (_baseFeeMultiplier_toString_split__length = (_baseFeeMultiplier_toString_split_ = baseFeeMultiplier.toString().split(".")[1]) === null || _baseFeeMultiplier_toString_split_ === void 0 ? void 0 : _baseFeeMultiplier_toString_split_.length) !== null && _baseFeeMultiplier_toString_split__length !== void 0 ? _baseFeeMultiplier_toString_split__length : 0;
                    denominator = Math.pow(10, decimals);
                    multiply = function(base) {
                        return base * BigInt(Math.ceil(baseFeeMultiplier * denominator)) / BigInt(denominator);
                    };
                    if (!block_) return [
                        3,
                        2
                    ];
                    _tmp = block_;
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $985463a4c6a1d2e4$export$ea0af84ed2e77902), "getBlock")({})
                    ];
                case 3:
                    _tmp = _state.sent();
                    _state.label = 4;
                case 4:
                    block = _tmp;
                    if (!(typeof (chain === null || chain === void 0 ? void 0 : (_chain_fees = chain.fees) === null || _chain_fees === void 0 ? void 0 : _chain_fees.estimateFeesPerGas) === "function")) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        chain.fees.estimateFeesPerGas({
                            block: block_,
                            client: client,
                            multiply: multiply,
                            request: request,
                            type: type
                        })
                    ];
                case 5:
                    fees = _state.sent();
                    if (fees !== null) return [
                        2,
                        fees
                    ];
                    _state.label = 6;
                case 6:
                    if (!(type === "eip1559")) return [
                        3,
                        10
                    ];
                    if ((0, $l0HdX._)(block.baseFeePerGas) !== "bigint") throw new (0, $27e9eb63dd13bf29$export$dcf53c0ae183fb46)();
                    if (!((0, $l0HdX._)(request === null || request === void 0 ? void 0 : request.maxPriorityFeePerGas) === "bigint")) return [
                        3,
                        7
                    ];
                    _tmp1 = request.maxPriorityFeePerGas;
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        (0, $0a0dd3d64a962158$export$59275bafd388148)(client, {
                            block: block,
                            chain: chain,
                            request: request
                        })
                    ];
                case 8:
                    _tmp1 = _state.sent();
                    _state.label = 9;
                case 9:
                    maxPriorityFeePerGas = _tmp1;
                    baseFeePerGas = multiply(block.baseFeePerGas);
                    maxFeePerGas = (_request_maxFeePerGas = request === null || request === void 0 ? void 0 : request.maxFeePerGas) !== null && _request_maxFeePerGas !== void 0 ? _request_maxFeePerGas : baseFeePerGas + maxPriorityFeePerGas;
                    return [
                        2,
                        {
                            maxFeePerGas: maxFeePerGas,
                            maxPriorityFeePerGas: maxPriorityFeePerGas
                        }
                    ];
                case 10:
                    if (!((_request_gasPrice = request === null || request === void 0 ? void 0 : request.gasPrice) !== null && _request_gasPrice !== void 0)) return [
                        3,
                        11
                    ];
                    _tmp2 = _request_gasPrice;
                    return [
                        3,
                        13
                    ];
                case 11:
                    return [
                        4,
                        (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $d938e21ef1904b42$export$89c15b50d46d3f8c), "getGasPrice")({})
                    ];
                case 12:
                    _tmp2 = multiply.apply(void 0, [
                        _state.sent()
                    ]);
                    _state.label = 13;
                case 13:
                    gasPrice = _tmp2;
                    return [
                        2,
                        {
                            gasPrice: gasPrice
                        }
                    ];
            }
        });
    });
    return $c6a8e460e4f994e2$var$_internal_estimateFeesPerGas.apply(this, arguments);
}





var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $itrhm = parcelRequire("itrhm");

var $f3VZN = parcelRequire("f3VZN");
function $920033f9ccbbdb05$export$b18e66333ec1361e(client, _) {
    return $920033f9ccbbdb05$var$_getTransactionCount.apply(this, arguments);
}
function $920033f9ccbbdb05$var$_getTransactionCount() {
    $920033f9ccbbdb05$var$_getTransactionCount = (0, $kSuI9._)(function(client, param) {
        var address, _param_blockTag, blockTag, blockNumber, count;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    address = param.address, _param_blockTag = param.blockTag, blockTag = _param_blockTag === void 0 ? "latest" : _param_blockTag, blockNumber = param.blockNumber;
                    return [
                        4,
                        client.request({
                            method: "eth_getTransactionCount",
                            params: [
                                address,
                                blockNumber ? (0, $f3VZN.numberToHex)(blockNumber) : blockTag
                            ]
                        }, {
                            dedupe: Boolean(blockNumber)
                        })
                    ];
                case 1:
                    count = _state.sent();
                    return [
                        2,
                        (0, $itrhm.hexToNumber)(count)
                    ];
            }
        });
    });
    return $920033f9ccbbdb05$var$_getTransactionCount.apply(this, arguments);
}









var $p2XJW = parcelRequire("p2XJW");


var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $itrhm = parcelRequire("itrhm");
function $3f6367ac0fc6b0ac$export$850fa7b3891187c(client) {
    return $3f6367ac0fc6b0ac$var$_getChainId.apply(this, arguments);
}
function $3f6367ac0fc6b0ac$var$_getChainId() {
    $3f6367ac0fc6b0ac$var$_getChainId = (0, $kSuI9._)(function(client) {
        var chainIdHex;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        client.request({
                            method: "eth_chainId"
                        }, {
                            dedupe: true
                        })
                    ];
                case 1:
                    chainIdHex = _state.sent();
                    return [
                        2,
                        (0, $itrhm.hexToNumber)(chainIdHex)
                    ];
            }
        });
    });
    return $3f6367ac0fc6b0ac$var$_getChainId.apply(this, arguments);
}


var $4869f53cd4aaa39a$export$4f3e0c2bc77eca55 = [
    "blobVersionedHashes",
    "chainId",
    "fees",
    "gas",
    "nonce",
    "type"
];
function $4869f53cd4aaa39a$export$2e8a9232fb815d77(client, args) {
    return $4869f53cd4aaa39a$var$_prepareTransactionRequest.apply(this, arguments);
}
function $4869f53cd4aaa39a$var$_prepareTransactionRequest() {
    $4869f53cd4aaa39a$var$_prepareTransactionRequest = (0, $kSuI9._)(function(client, args) {
        var tmp, account_, blobs, chain, gas, kzg, nonce, nonceManager, _args_parameters, parameters, type, account, request, block, chainId, commitments, versionedHashes, proofs, sidecars, chainId1, e, block1, block2, _ref, maxFeePerGas, maxPriorityFeePerGas, block3, _ref1, gasPrice_;
        function getBlock() {
            return _getBlock.apply(this, arguments);
        }
        function _getBlock() {
            _getBlock = (0, $kSuI9._)(function() {
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (block) return [
                                2,
                                block
                            ];
                            return [
                                4,
                                (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $985463a4c6a1d2e4$export$ea0af84ed2e77902), "getBlock")({
                                    blockTag: "latest"
                                })
                            ];
                        case 1:
                            block = _state.sent();
                            return [
                                2,
                                block
                            ];
                    }
                });
            });
            return _getBlock.apply(this, arguments);
        }
        function getChainId() {
            return _getChainId.apply(this, arguments);
        }
        function _getChainId() {
            _getChainId = (0, $kSuI9._)(function() {
                var chainId_;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (chainId) return [
                                2,
                                chainId
                            ];
                            if (chain) return [
                                2,
                                chain.id
                            ];
                            if (typeof args.chainId !== "undefined") return [
                                2,
                                args.chainId
                            ];
                            return [
                                4,
                                (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $3f6367ac0fc6b0ac$export$850fa7b3891187c), "getChainId")({})
                            ];
                        case 1:
                            chainId_ = _state.sent();
                            chainId = chainId_;
                            return [
                                2,
                                chainId
                            ];
                    }
                });
            });
            return _getChainId.apply(this, arguments);
        }
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    tmp = args.account, account_ = tmp === void 0 ? client.account : tmp, blobs = args.blobs, chain = args.chain, gas = args.gas, kzg = args.kzg, nonce = args.nonce, nonceManager = args.nonceManager, _args_parameters = args.parameters, parameters = _args_parameters === void 0 ? $4869f53cd4aaa39a$export$4f3e0c2bc77eca55 : _args_parameters, type = args.type;
                    account = account_ ? (0, $l2YyF.parseAccount)(account_) : undefined;
                    request = (0, $do9pw._)({}, args, account ? {
                        from: account === null || account === void 0 ? void 0 : account.address
                    } : {});
                    if ((parameters.includes("blobVersionedHashes") || parameters.includes("sidecars")) && blobs && kzg) {
                        commitments = (0, $239f76bf65899618$export$b67626aab22a659b)({
                            blobs: blobs,
                            kzg: kzg
                        });
                        if (parameters.includes("blobVersionedHashes")) {
                            versionedHashes = (0, $ec1abdeba20dbf2b$export$e31b3e59dda37b17)({
                                commitments: commitments,
                                to: "hex"
                            });
                            request.blobVersionedHashes = versionedHashes;
                        }
                        if (parameters.includes("sidecars")) {
                            proofs = (0, $cdb99e133ee02170$export$78a225f8922765eb)({
                                blobs: blobs,
                                commitments: commitments,
                                kzg: kzg
                            });
                            sidecars = (0, $613e19a94297935c$export$44960962e1c9641b)({
                                blobs: blobs,
                                commitments: commitments,
                                proofs: proofs,
                                to: "hex"
                            });
                            request.sidecars = sidecars;
                        }
                    }
                    if (!parameters.includes("chainId")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        getChainId()
                    ];
                case 1:
                    request.chainId = _state.sent();
                    _state.label = 2;
                case 2:
                    if (!(parameters.includes("nonce") && typeof nonce === "undefined" && account)) return [
                        3,
                        7
                    ];
                    if (!nonceManager) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        getChainId()
                    ];
                case 3:
                    chainId1 = _state.sent();
                    return [
                        4,
                        nonceManager.consume({
                            address: account.address,
                            chainId: chainId1,
                            client: client
                        })
                    ];
                case 4:
                    request.nonce = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 5:
                    return [
                        4,
                        (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $920033f9ccbbdb05$export$b18e66333ec1361e), "getTransactionCount")({
                            address: account.address,
                            blockTag: "pending"
                        })
                    ];
                case 6:
                    request.nonce = _state.sent();
                    _state.label = 7;
                case 7:
                    if (!((parameters.includes("fees") || parameters.includes("type")) && typeof type === "undefined")) return [
                        3,
                        11
                    ];
                    _state.label = 8;
                case 8:
                    _state.trys.push([
                        8,
                        9,
                        ,
                        11
                    ]);
                    request.type = (0, $83ee023353cbed31$export$944c6678cd5a1ea8)(request);
                    return [
                        3,
                        11
                    ];
                case 9:
                    e = _state.sent();
                    return [
                        4,
                        getBlock()
                    ];
                case 10:
                    block1 = _state.sent();
                    request.type = (0, $l0HdX._)(block1 === null || block1 === void 0 ? void 0 : block1.baseFeePerGas) === "bigint" ? "eip1559" : "legacy";
                    return [
                        3,
                        11
                    ];
                case 11:
                    if (!parameters.includes("fees")) return [
                        3,
                        18
                    ];
                    if (!(request.type !== "legacy" && request.type !== "eip2930")) return [
                        3,
                        15
                    ];
                    if (!(typeof request.maxFeePerGas === "undefined" || typeof request.maxPriorityFeePerGas === "undefined")) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        getBlock()
                    ];
                case 12:
                    block2 = _state.sent();
                    return [
                        4,
                        (0, $c6a8e460e4f994e2$export$67115e8707c5a9e)(client, {
                            block: block2,
                            chain: chain,
                            request: request
                        })
                    ];
                case 13:
                    _ref = _state.sent(), maxFeePerGas = _ref.maxFeePerGas, maxPriorityFeePerGas = _ref.maxPriorityFeePerGas;
                    if (typeof args.maxPriorityFeePerGas === "undefined" && args.maxFeePerGas && args.maxFeePerGas < maxPriorityFeePerGas) throw new (0, $27e9eb63dd13bf29$export$bcf9730904a1086f)({
                        maxPriorityFeePerGas: maxPriorityFeePerGas
                    });
                    request.maxPriorityFeePerGas = maxPriorityFeePerGas;
                    request.maxFeePerGas = maxFeePerGas;
                    _state.label = 14;
                case 14:
                    return [
                        3,
                        18
                    ];
                case 15:
                    // Legacy fees
                    if (typeof args.maxFeePerGas !== "undefined" || typeof args.maxPriorityFeePerGas !== "undefined") throw new (0, $27e9eb63dd13bf29$export$dcf53c0ae183fb46)();
                    return [
                        4,
                        getBlock()
                    ];
                case 16:
                    block3 = _state.sent();
                    return [
                        4,
                        (0, $c6a8e460e4f994e2$export$67115e8707c5a9e)(client, {
                            block: block3,
                            chain: chain,
                            request: request,
                            type: "legacy"
                        })
                    ];
                case 17:
                    _ref1 = _state.sent(), gasPrice_ = _ref1.gasPrice;
                    request.gasPrice = gasPrice_;
                    _state.label = 18;
                case 18:
                    if (!(parameters.includes("gas") && typeof gas === "undefined")) return [
                        3,
                        20
                    ];
                    return [
                        4,
                        (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $decf603c2fa0d1c4$export$e0580ae1f48db848), "estimateGas")((0, $cxjpp._)((0, $do9pw._)({}, request), {
                            account: account ? {
                                address: account.address,
                                type: "json-rpc"
                            } : undefined
                        }))
                    ];
                case 19:
                    request.gas = _state.sent();
                    _state.label = 20;
                case 20:
                    (0, $p2XJW.assertRequest)(request);
                    delete request.parameters;
                    return [
                        2,
                        request
                    ];
            }
        });
    });
    return $4869f53cd4aaa39a$var$_prepareTransactionRequest.apply(this, arguments);
}



var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $f3VZN = parcelRequire("f3VZN");
function $179cf38efbf30cf7$export$df96cd8d56be0ab1(client, _) {
    return $179cf38efbf30cf7$var$_getBalance.apply(this, arguments);
}
function $179cf38efbf30cf7$var$_getBalance() {
    $179cf38efbf30cf7$var$_getBalance = (0, $kSuI9._)(function(client, param) {
        var address, blockNumber, _param_blockTag, blockTag, blockNumberHex, balance;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    address = param.address, blockNumber = param.blockNumber, _param_blockTag = param.blockTag, blockTag = _param_blockTag === void 0 ? "latest" : _param_blockTag;
                    blockNumberHex = blockNumber ? (0, $f3VZN.numberToHex)(blockNumber) : undefined;
                    return [
                        4,
                        client.request({
                            method: "eth_getBalance",
                            params: [
                                address,
                                blockNumberHex || blockTag
                            ]
                        })
                    ];
                case 1:
                    balance = _state.sent();
                    return [
                        2,
                        BigInt(balance)
                    ];
            }
        });
    });
    return $179cf38efbf30cf7$var$_getBalance.apply(this, arguments);
}


function $decf603c2fa0d1c4$export$e0580ae1f48db848(client, args) {
    return $decf603c2fa0d1c4$var$_estimateGas.apply(this, arguments);
}
function $decf603c2fa0d1c4$var$_estimateGas() {
    $decf603c2fa0d1c4$var$_estimateGas = (0, $kSuI9._)(function(client, args) {
        var _args_account, account_, account, _client_chain_formatters_transactionRequest, _client_chain_formatters, _client_chain, _ref, accessList, authorizationList, blobs, blobVersionedHashes, blockNumber, blockTag, data, gas, gasPrice, maxFeePerBlobGas, maxFeePerGas, maxPriorityFeePerGas, nonce, value, stateOverride, rest, blockNumberHex, block, rpcStateOverride, to, chainFormat, format, request, estimate, value1, estimates, err;
        function estimateGas_rpc(parameters) {
            var block = parameters.block, request = parameters.request, rpcStateOverride = parameters.rpcStateOverride;
            return client.request({
                method: "eth_estimateGas",
                params: rpcStateOverride ? [
                    request,
                    block !== null && block !== void 0 ? block : "latest",
                    rpcStateOverride
                ] : block ? [
                    request,
                    block
                ] : [
                    request
                ]
            });
        }
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    account_ = (_args_account = args.account) !== null && _args_account !== void 0 ? _args_account : client.account;
                    account = account_ ? (0, $l2YyF.parseAccount)(account_) : undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        ,
                        9
                    ]);
                    return [
                        4,
                        (0, $4869f53cd4aaa39a$export$2e8a9232fb815d77)(client, (0, $cxjpp._)((0, $do9pw._)({}, args), {
                            parameters: // Some RPC Providers do not compute versioned hashes from blobs. We will need
                            // to compute them.
                            (account === null || account === void 0 ? void 0 : account.type) === "local" ? undefined : [
                                "blobVersionedHashes"
                            ]
                        }))
                    ];
                case 2:
                    _ref = _state.sent(), accessList = _ref.accessList, authorizationList = _ref.authorizationList, blobs = _ref.blobs, blobVersionedHashes = _ref.blobVersionedHashes, blockNumber = _ref.blockNumber, blockTag = _ref.blockTag, data = _ref.data, gas = _ref.gas, gasPrice = _ref.gasPrice, maxFeePerBlobGas = _ref.maxFeePerBlobGas, maxFeePerGas = _ref.maxFeePerGas, maxPriorityFeePerGas = _ref.maxPriorityFeePerGas, nonce = _ref.nonce, value = _ref.value, stateOverride = _ref.stateOverride, rest = (0, $dRLPW._)(_ref, [
                        "accessList",
                        "authorizationList",
                        "blobs",
                        "blobVersionedHashes",
                        "blockNumber",
                        "blockTag",
                        "data",
                        "gas",
                        "gasPrice",
                        "maxFeePerBlobGas",
                        "maxFeePerGas",
                        "maxPriorityFeePerGas",
                        "nonce",
                        "value",
                        "stateOverride"
                    ]);
                    blockNumberHex = blockNumber ? (0, $f3VZN.numberToHex)(blockNumber) : undefined;
                    block = blockNumberHex || blockTag;
                    rpcStateOverride = (0, $7h9bY.serializeStateOverride)(stateOverride);
                    return [
                        4,
                        (0, $kSuI9._)(function() {
                            return (0, $eha6O.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        // If `to` exists on the parameters, use that.
                                        if (rest.to) return [
                                            2,
                                            rest.to
                                        ];
                                        if (!(authorizationList && authorizationList.length > 0)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            (0, $15a1aceb58378c31$export$415d0315604a8515)({
                                                authorization: authorizationList[0]
                                            }).catch(function() {
                                                throw new (0, $7ihh7.BaseError)("`to` is required. Could not infer from `authorizationList`");
                                            })
                                        ];
                                    case 1:
                                        return [
                                            2,
                                            _state.sent()
                                        ];
                                    case 2:
                                        // Otherwise, we are sending a deployment transaction.
                                        return [
                                            2,
                                            undefined
                                        ];
                                }
                            });
                        })()
                    ];
                case 3:
                    to = _state.sent();
                    (0, $p2XJW.assertRequest)(args);
                    chainFormat = (_client_chain = client.chain) === null || _client_chain === void 0 ? void 0 : (_client_chain_formatters = _client_chain.formatters) === null || _client_chain_formatters === void 0 ? void 0 : (_client_chain_formatters_transactionRequest = _client_chain_formatters.transactionRequest) === null || _client_chain_formatters_transactionRequest === void 0 ? void 0 : _client_chain_formatters_transactionRequest.format;
                    format = chainFormat || (0, $17do3.formatTransactionRequest);
                    request = format((0, $cxjpp._)((0, $do9pw._)({}, (0, $6N8Zo.extract)(rest, {
                        format: chainFormat
                    })), {
                        from: account === null || account === void 0 ? void 0 : account.address,
                        accessList: accessList,
                        authorizationList: authorizationList,
                        blobs: blobs,
                        blobVersionedHashes: blobVersionedHashes,
                        data: data,
                        gas: gas,
                        gasPrice: gasPrice,
                        maxFeePerBlobGas: maxFeePerBlobGas,
                        maxFeePerGas: maxFeePerGas,
                        maxPriorityFeePerGas: maxPriorityFeePerGas,
                        nonce: nonce,
                        to: to,
                        value: value
                    }));
                    return [
                        4,
                        estimateGas_rpc({
                            block: block,
                            request: request,
                            rpcStateOverride: rpcStateOverride
                        })
                    ];
                case 4:
                    estimate = BigInt.apply(void 0, [
                        _state.sent()
                    ]);
                    if (!authorizationList) return [
                        3,
                        7
                    ];
                    return [
                        4,
                        (0, $179cf38efbf30cf7$export$df96cd8d56be0ab1)(client, {
                            address: request.from
                        })
                    ];
                case 5:
                    value1 = _state.sent();
                    return [
                        4,
                        Promise.all(authorizationList.map(function() {
                            var _ref = (0, $kSuI9._)(function(authorization) {
                                var contractAddress, estimate;
                                return (0, $eha6O.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            contractAddress = authorization.contractAddress;
                                            return [
                                                4,
                                                estimateGas_rpc({
                                                    block: block,
                                                    request: {
                                                        authorizationList: undefined,
                                                        data: data,
                                                        from: account === null || account === void 0 ? void 0 : account.address,
                                                        to: contractAddress,
                                                        value: (0, $f3VZN.numberToHex)(value1)
                                                    },
                                                    rpcStateOverride: rpcStateOverride
                                                }).catch(function() {
                                                    return 100000n;
                                                })
                                            ];
                                        case 1:
                                            estimate = _state.sent();
                                            return [
                                                2,
                                                2n * BigInt(estimate)
                                            ];
                                    }
                                });
                            });
                            return function(authorization) {
                                return _ref.apply(this, arguments);
                            };
                        }()))
                    ];
                case 6:
                    estimates = _state.sent();
                    estimate += estimates.reduce(function(acc, curr) {
                        return acc + curr;
                    }, 0n);
                    _state.label = 7;
                case 7:
                    return [
                        2,
                        estimate
                    ];
                case 8:
                    err = _state.sent();
                    throw (0, $5d6fb596d874d36d$export$f201b805dbcd7c48)(err, (0, $cxjpp._)((0, $do9pw._)({}, args), {
                        account: account,
                        chain: client.chain
                    }));
                case 9:
                    return [
                        2
                    ];
            }
        });
    });
    return $decf603c2fa0d1c4$var$_estimateGas.apply(this, arguments);
}




function $711af0904a0a3a79$export$e0580ae1f48db848(config, parameters) {
    return $711af0904a0a3a79$var$_estimateGas.apply(this, arguments);
}
function $711af0904a0a3a79$var$_estimateGas() {
    $711af0904a0a3a79$var$_estimateGas = (0, $kSuI9._)(function(config, parameters) {
        var chainId, connector, rest, account, connectorClient, client, action;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    chainId = parameters.chainId, connector = parameters.connector, rest = (0, $dRLPW._)(parameters, [
                        "chainId",
                        "connector"
                    ]);
                    if (!parameters.account) return [
                        3,
                        1
                    ];
                    account = parameters.account;
                    return [
                        3,
                        3
                    ];
                case 1:
                    return [
                        4,
                        (0, $c7c82ca8fcf669fd$export$d784801ca17b4aec)(config, {
                            account: parameters.account,
                            chainId: chainId,
                            connector: connector
                        })
                    ];
                case 2:
                    connectorClient = _state.sent();
                    account = connectorClient.account;
                    _state.label = 3;
                case 3:
                    client = config.getClient({
                        chainId: chainId
                    });
                    action = (0, $79c54d690e762313$export$6ca3170acb89054)(client, (0, $decf603c2fa0d1c4$export$e0580ae1f48db848), "estimateGas");
                    return [
                        2,
                        action((0, $cxjpp._)((0, $do9pw._)({}, rest), {
                            account: account
                        }))
                    ];
            }
        });
    });
    return $711af0904a0a3a79$var$_estimateGas.apply(this, arguments);
}

/** https://wagmi.sh/core/api/actions/getAccount */ function $03c83a18d36f49ac$export$4f9234baf34abd0(config) {
    var uid = config.state.current;
    var connection = config.state.connections.get(uid);
    var addresses = connection === null || connection === void 0 ? void 0 : connection.accounts;
    var address = addresses === null || addresses === void 0 ? void 0 : addresses[0];
    var chain = config.chains.find(function(chain) {
        return chain.id === (connection === null || connection === void 0 ? void 0 : connection.chainId);
    });
    var status = config.state.status;
    switch(status){
        case "connected":
            return {
                address: address,
                addresses: addresses,
                chain: chain,
                chainId: connection === null || connection === void 0 ? void 0 : connection.chainId,
                connector: connection === null || connection === void 0 ? void 0 : connection.connector,
                isConnected: true,
                isConnecting: false,
                isDisconnected: false,
                isReconnecting: false,
                status: status
            };
        case "reconnecting":
            return {
                address: address,
                addresses: addresses,
                chain: chain,
                chainId: connection === null || connection === void 0 ? void 0 : connection.chainId,
                connector: connection === null || connection === void 0 ? void 0 : connection.connector,
                isConnected: !!address,
                isConnecting: false,
                isDisconnected: false,
                isReconnecting: true,
                status: status
            };
        case "connecting":
            return {
                address: address,
                addresses: addresses,
                chain: chain,
                chainId: connection === null || connection === void 0 ? void 0 : connection.chainId,
                connector: connection === null || connection === void 0 ? void 0 : connection.connector,
                isConnected: false,
                isConnecting: true,
                isDisconnected: false,
                isReconnecting: false,
                status: status
            };
        case "disconnected":
            return {
                address: undefined,
                addresses: undefined,
                chain: undefined,
                chainId: undefined,
                connector: undefined,
                isConnected: false,
                isConnecting: false,
                isDisconnected: true,
                isReconnecting: false,
                status: status
            };
    }
}


var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $dRLPW = parcelRequire("dRLPW");

var $eha6O = parcelRequire("eha6O");



function $fdfac1d482c19b90$export$2e8a9232fb815d77(config, parameters) {
    return $fdfac1d482c19b90$var$_prepareTransactionRequest.apply(this, arguments);
}
function $fdfac1d482c19b90$var$_prepareTransactionRequest() {
    $fdfac1d482c19b90$var$_prepareTransactionRequest = (0, $kSuI9._)(function(config, parameters) {
        var account_, chainId, rest, account, client, action;
        return (0, $eha6O.__generator)(this, function(_state) {
            account_ = parameters.account, chainId = parameters.chainId, rest = (0, $dRLPW._)(parameters, [
                "account",
                "chainId"
            ]);
            account = account_ !== null && account_ !== void 0 ? account_ : (0, $03c83a18d36f49ac$export$4f9234baf34abd0)(config).address;
            client = config.getClient({
                chainId: chainId
            });
            action = (0, $79c54d690e762313$export$6ca3170acb89054)(client, (0, $4869f53cd4aaa39a$export$2e8a9232fb815d77), "prepareTransactionRequest");
            return [
                2,
                action((0, $do9pw._)({}, rest, account ? {
                    account: account
                } : {}))
            ];
        });
    });
    return $fdfac1d482c19b90$var$_prepareTransactionRequest.apply(this, arguments);
}


var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");

var $eha6O = parcelRequire("eha6O");

var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");

var $c6Xmf = parcelRequire("c6Xmf");

var $eha6O = parcelRequire("eha6O");

var $l2YyF = parcelRequire("l2YyF");


var $7ihh7 = parcelRequire("7ihh7");


var $7yD9U = parcelRequire("7yD9U");
function $365b5cac335d0771$export$390d312ab46d0597(param) {
    var chain = param.chain, currentChainId = param.currentChainId;
    if (!chain) throw new (0, $7yD9U.ChainNotFoundError)();
    if (currentChainId !== chain.id) throw new (0, $7yD9U.ChainMismatchError)({
        chain: chain,
        currentChainId: currentChainId
    });
}



var $do9pw = parcelRequire("do9pw");

var $dRLPW = parcelRequire("dRLPW");

var $btxjr = parcelRequire("btxjr");

var $hgawa = parcelRequire("hgawa");

var $lVJzh = parcelRequire("lVJzh");
function $e79665f80153b9fc$export$da1758db1985646e(err, _param) {
    var docsPath = _param.docsPath, args = (0, $dRLPW._)(_param, [
        "docsPath"
    ]);
    var cause = function() {
        var cause = (0, $lVJzh.getNodeError)(err, args);
        if (cause instanceof (0, $btxjr.UnknownNodeError)) return err;
        return cause;
    }();
    return new (0, $hgawa.TransactionExecutionError)(cause, (0, $do9pw._)({
        docsPath: docsPath
    }, args));
}



var $6N8Zo = parcelRequire("6N8Zo");

var $17do3 = parcelRequire("17do3");


var $p2XJW = parcelRequire("p2XJW");


/**
 * Sends a **signed** transaction to the network
 *
 * - Docs: https://viem.sh/docs/actions/wallet/sendRawTransaction
 * - JSON-RPC Method: [`eth_sendRawTransaction`](https://ethereum.github.io/execution-apis/api-documentation/)
 *
 * @param client - Client to use
 * @param parameters - {@link SendRawTransactionParameters}
 * @returns The transaction hash. {@link SendRawTransactionReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { sendRawTransaction } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 *
 * const hash = await sendRawTransaction(client, {
 *   serializedTransaction: '0x02f850018203118080825208808080c080a04012522854168b27e5dc3d5839bab5e6b39e1a0ffd343901ce1622e3d64b48f1a04e00902ae0502c4728cbf12156290df99c3ed7de85b1dbfe20b5c36931733a33'
 * })
 */ 
var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");
function $da458af31d30456f$export$4e309754b4830e29(client, _) {
    return $da458af31d30456f$var$_sendRawTransaction.apply(this, arguments);
}
function $da458af31d30456f$var$_sendRawTransaction() {
    $da458af31d30456f$var$_sendRawTransaction = (0, $kSuI9._)(function(client, param) {
        var serializedTransaction;
        return (0, $eha6O.__generator)(this, function(_state) {
            serializedTransaction = param.serializedTransaction;
            return [
                2,
                client.request({
                    method: "eth_sendRawTransaction",
                    params: [
                        serializedTransaction
                    ]
                }, {
                    retryCount: 0
                })
            ];
        });
    });
    return $da458af31d30456f$var$_sendRawTransaction.apply(this, arguments);
}


function $49da3b39ba760adb$export$8e0e7ffc78696d30(client, parameters) {
    return $49da3b39ba760adb$var$_sendTransaction.apply(this, arguments);
}
function $49da3b39ba760adb$var$_sendTransaction() {
    $49da3b39ba760adb$var$_sendTransaction = (0, $kSuI9._)(function(client, parameters) {
        var tmp, account_, _parameters_chain, chain, accessList, authorizationList, blobs, data, gas, gasPrice, maxFeePerBlobGas, maxFeePerGas, maxPriorityFeePerGas, nonce, value, rest, account, to, _client_chain_formatters_transactionRequest, _client_chain_formatters, _client_chain, chainId, chainFormat, format, request, _chain_serializers, request1, serializer, serializedTransaction, err;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    tmp = parameters.account, account_ = tmp === void 0 ? client.account : tmp, _parameters_chain = parameters.chain, chain = _parameters_chain === void 0 ? client.chain : _parameters_chain, accessList = parameters.accessList, authorizationList = parameters.authorizationList, blobs = parameters.blobs, data = parameters.data, gas = parameters.gas, gasPrice = parameters.gasPrice, maxFeePerBlobGas = parameters.maxFeePerBlobGas, maxFeePerGas = parameters.maxFeePerGas, maxPriorityFeePerGas = parameters.maxPriorityFeePerGas, nonce = parameters.nonce, value = parameters.value, rest = (0, $dRLPW._)(parameters, [
                        "account",
                        "chain",
                        "accessList",
                        "authorizationList",
                        "blobs",
                        "data",
                        "gas",
                        "gasPrice",
                        "maxFeePerBlobGas",
                        "maxFeePerGas",
                        "maxPriorityFeePerGas",
                        "nonce",
                        "value"
                    ]);
                    if (!account_) throw new (0, $58c5ed114b2c2f06$export$62ee6b05f0767f28)({
                        docsPath: "/docs/actions/wallet/sendTransaction"
                    });
                    account = (0, $l2YyF.parseAccount)(account_);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        11,
                        ,
                        12
                    ]);
                    (0, $p2XJW.assertRequest)(parameters);
                    return [
                        4,
                        (0, $kSuI9._)(function() {
                            return (0, $eha6O.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        // If `to` exists on the parameters, use that.
                                        if (parameters.to) return [
                                            2,
                                            parameters.to
                                        ];
                                        if (!(authorizationList && authorizationList.length > 0)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            (0, $15a1aceb58378c31$export$415d0315604a8515)({
                                                authorization: authorizationList[0]
                                            }).catch(function() {
                                                throw new (0, $7ihh7.BaseError)("`to` is required. Could not infer from `authorizationList`.");
                                            })
                                        ];
                                    case 1:
                                        return [
                                            2,
                                            _state.sent()
                                        ];
                                    case 2:
                                        // Otherwise, we are sending a deployment transaction.
                                        return [
                                            2,
                                            undefined
                                        ];
                                }
                            });
                        })()
                    ];
                case 2:
                    to = _state.sent();
                    if (!(account.type === "json-rpc")) return [
                        3,
                        6
                    ];
                    if (!(chain !== null)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $3f6367ac0fc6b0ac$export$850fa7b3891187c), "getChainId")({})
                    ];
                case 3:
                    chainId = _state.sent();
                    (0, $365b5cac335d0771$export$390d312ab46d0597)({
                        currentChainId: chainId,
                        chain: chain
                    });
                    _state.label = 4;
                case 4:
                    chainFormat = (_client_chain = client.chain) === null || _client_chain === void 0 ? void 0 : (_client_chain_formatters = _client_chain.formatters) === null || _client_chain_formatters === void 0 ? void 0 : (_client_chain_formatters_transactionRequest = _client_chain_formatters.transactionRequest) === null || _client_chain_formatters_transactionRequest === void 0 ? void 0 : _client_chain_formatters_transactionRequest.format;
                    format = chainFormat || (0, $17do3.formatTransactionRequest);
                    request = format((0, $cxjpp._)((0, $do9pw._)({}, (0, $6N8Zo.extract)(rest, {
                        format: chainFormat
                    })), {
                        accessList: accessList,
                        authorizationList: authorizationList,
                        blobs: blobs,
                        chainId: chainId,
                        data: data,
                        from: account.address,
                        gas: gas,
                        gasPrice: gasPrice,
                        maxFeePerBlobGas: maxFeePerBlobGas,
                        maxFeePerGas: maxFeePerGas,
                        maxPriorityFeePerGas: maxPriorityFeePerGas,
                        nonce: nonce,
                        to: to,
                        value: value
                    }));
                    return [
                        4,
                        client.request({
                            method: "eth_sendTransaction",
                            params: [
                                request
                            ]
                        }, {
                            retryCount: 0
                        })
                    ];
                case 5:
                    return [
                        2,
                        _state.sent()
                    ];
                case 6:
                    if (!(account.type === "local")) return [
                        3,
                        10
                    ];
                    return [
                        4,
                        (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $4869f53cd4aaa39a$export$2e8a9232fb815d77), "prepareTransactionRequest")((0, $cxjpp._)((0, $do9pw._)({
                            account: account,
                            accessList: accessList,
                            authorizationList: authorizationList,
                            blobs: blobs,
                            chain: chain,
                            data: data,
                            gas: gas,
                            gasPrice: gasPrice,
                            maxFeePerBlobGas: maxFeePerBlobGas,
                            maxFeePerGas: maxFeePerGas,
                            maxPriorityFeePerGas: maxPriorityFeePerGas,
                            nonce: nonce,
                            nonceManager: account.nonceManager,
                            parameters: (0, $c6Xmf._)((0, $4869f53cd4aaa39a$export$4f3e0c2bc77eca55)).concat([
                                "sidecars"
                            ]),
                            value: value
                        }, rest), {
                            to: to
                        }))
                    ];
                case 7:
                    request1 = _state.sent();
                    serializer = chain === null || chain === void 0 ? void 0 : (_chain_serializers = chain.serializers) === null || _chain_serializers === void 0 ? void 0 : _chain_serializers.transaction;
                    return [
                        4,
                        account.signTransaction(request1, {
                            serializer: serializer
                        })
                    ];
                case 8:
                    serializedTransaction = _state.sent();
                    return [
                        4,
                        (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $da458af31d30456f$export$4e309754b4830e29), "sendRawTransaction")({
                            serializedTransaction: serializedTransaction
                        })
                    ];
                case 9:
                    return [
                        2,
                        _state.sent()
                    ];
                case 10:
                    if (account.type === "smart") throw new (0, $58c5ed114b2c2f06$export$22c1d840ef5fbc66)({
                        metaMessages: [
                            "Consider using the `sendUserOperation` Action instead."
                        ],
                        docsPath: "/docs/actions/bundler/sendUserOperation",
                        type: "smart"
                    });
                    throw new (0, $58c5ed114b2c2f06$export$22c1d840ef5fbc66)({
                        docsPath: "/docs/actions/wallet/sendTransaction",
                        type: account.type
                    });
                case 11:
                    err = _state.sent();
                    if (err instanceof (0, $58c5ed114b2c2f06$export$22c1d840ef5fbc66)) throw err;
                    throw (0, $e79665f80153b9fc$export$da1758db1985646e)(err, (0, $cxjpp._)((0, $do9pw._)({}, parameters), {
                        account: account,
                        chain: parameters.chain || undefined
                    }));
                case 12:
                    return [
                        2
                    ];
            }
        });
    });
    return $49da3b39ba760adb$var$_sendTransaction.apply(this, arguments);
}





function $7b090043ca07fcb8$export$8e0e7ffc78696d30(config, parameters) {
    return $7b090043ca07fcb8$var$_sendTransaction.apply(this, arguments);
}
function $7b090043ca07fcb8$var$_sendTransaction() {
    $7b090043ca07fcb8$var$_sendTransaction = (0, $kSuI9._)(function(config, parameters) {
        var account, chainId, connector, gas_, rest, client, _getAccount, activeConnector, gas, action, hash;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    account = parameters.account, chainId = parameters.chainId, connector = parameters.connector, gas_ = parameters.gas, rest = (0, $dRLPW._)(parameters, [
                        "account",
                        "chainId",
                        "connector",
                        "gas"
                    ]);
                    if (!(typeof account === "object" && account.type === "local")) return [
                        3,
                        1
                    ];
                    client = config.getClient({
                        chainId: chainId
                    });
                    return [
                        3,
                        3
                    ];
                case 1:
                    return [
                        4,
                        (0, $c7c82ca8fcf669fd$export$d784801ca17b4aec)(config, {
                            account: account,
                            chainId: chainId,
                            connector: connector
                        })
                    ];
                case 2:
                    client = _state.sent();
                    _state.label = 3;
                case 3:
                    _getAccount = (0, $03c83a18d36f49ac$export$4f9234baf34abd0)(config), activeConnector = _getAccount.connector;
                    return [
                        4,
                        (0, $kSuI9._)(function() {
                            var _this, action;
                            return (0, $eha6O.__generator)(this, function(_state) {
                                // Skip gas estimation if `data` doesn't exist (not a contract interaction).
                                if (!("data" in parameters) || !parameters.data) return [
                                    2,
                                    undefined
                                ];
                                // Skip gas estimation if connector supports simulation.
                                if ((_this = connector !== null && connector !== void 0 ? connector : activeConnector) === null || _this === void 0 ? void 0 : _this.supportsSimulation) return [
                                    2,
                                    undefined
                                ];
                                // Skip gas estimation if `null` is provided.
                                if (gas_ === null) return [
                                    2,
                                    undefined
                                ];
                                // Run gas estimation if no value is provided.
                                if (gas_ === undefined) {
                                    action = (0, $79c54d690e762313$export$6ca3170acb89054)(client, (0, $decf603c2fa0d1c4$export$e0580ae1f48db848), "estimateGas");
                                    return [
                                        2,
                                        action((0, $cxjpp._)((0, $do9pw._)({}, rest), {
                                            account: account,
                                            chain: chainId ? {
                                                id: chainId
                                            } : null
                                        }))
                                    ];
                                }
                                // Use provided gas value.
                                return [
                                    2,
                                    gas_
                                ];
                            });
                        })()
                    ];
                case 4:
                    gas = _state.sent();
                    action = (0, $79c54d690e762313$export$6ca3170acb89054)(client, (0, $49da3b39ba760adb$export$8e0e7ffc78696d30), "sendTransaction");
                    return [
                        4,
                        action((0, $cxjpp._)((0, $do9pw._)({}, rest, account ? {
                            account: account
                        } : {}), {
                            gas: gas,
                            chain: chainId ? {
                                id: chainId
                            } : null
                        }))
                    ];
                case 5:
                    hash = _state.sent();
                    return [
                        2,
                        hash
                    ];
            }
        });
    });
    return $7b090043ca07fcb8$var$_sendTransaction.apply(this, arguments);
}


var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");

var $eha6O = parcelRequire("eha6O");

var $itrhm = parcelRequire("itrhm");

var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");


var $hgawa = parcelRequire("hgawa");

/** @internal */ 
var $c6Xmf = parcelRequire("c6Xmf");
var $4ae5ed700072ba74$export$94ab3a05cb07971d = /*#__PURE__*/ new Map();
var $4ae5ed700072ba74$export$b4a4aba7c5f97c17 = /*#__PURE__*/ new Map();
var $4ae5ed700072ba74$var$callbackCount = 0;
function $4ae5ed700072ba74$export$d1203567a167490e(observerId, callbacks, fn) {
    var _loop = function(key) {
        emit[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _listener_fns_key;
            var _listener_fns_key1, _listener_fns;
            var listeners = getListeners();
            if (listeners.length === 0) return;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var listener = _step.value;
                    (_listener_fns_key1 = (_listener_fns = listener.fns)[key]) === null || _listener_fns_key1 === void 0 ? void 0 : (_listener_fns_key = _listener_fns_key1).call.apply(_listener_fns_key, [
                        _listener_fns
                    ].concat((0, $c6Xmf._)(args)));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
    };
    var callbackId = ++$4ae5ed700072ba74$var$callbackCount;
    var getListeners = function() {
        return $4ae5ed700072ba74$export$94ab3a05cb07971d.get(observerId) || [];
    };
    var unsubscribe = function() {
        var listeners = getListeners();
        $4ae5ed700072ba74$export$94ab3a05cb07971d.set(observerId, listeners.filter(function(cb) {
            return cb.id !== callbackId;
        }));
    };
    var unwatch = function() {
        var cleanup = $4ae5ed700072ba74$export$b4a4aba7c5f97c17.get(observerId);
        if (getListeners().length === 1 && cleanup) cleanup();
        unsubscribe();
    };
    var listeners = getListeners();
    $4ae5ed700072ba74$export$94ab3a05cb07971d.set(observerId, (0, $c6Xmf._)(listeners).concat([
        {
            id: callbackId,
            fns: callbacks
        }
    ]));
    if (listeners && listeners.length > 0) return unwatch;
    var emit = {};
    for(var key in callbacks)_loop(key);
    var cleanup = fn(emit);
    if (typeof cleanup === "function") $4ae5ed700072ba74$export$b4a4aba7c5f97c17.set(observerId, cleanup);
    return unwatch;
}




var $lUgMT = parcelRequire("lUgMT");


var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $hgawa = parcelRequire("hgawa");

var $f3VZN = parcelRequire("f3VZN");

function $55ff11d9c8fdfd6e$export$ec0c6556a09b65b8(client, _) {
    return $55ff11d9c8fdfd6e$var$_getTransaction.apply(this, arguments);
}
function $55ff11d9c8fdfd6e$var$_getTransaction() {
    $55ff11d9c8fdfd6e$var$_getTransaction = (0, $kSuI9._)(function(client, param) {
        var blockHash, blockNumber, blockTag_, hash, index, _client_chain_formatters_transaction, _client_chain_formatters, _client_chain, blockTag, blockNumberHex, transaction, format;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    blockHash = param.blockHash, blockNumber = param.blockNumber, blockTag_ = param.blockTag, hash = param.hash, index = param.index;
                    blockTag = blockTag_ || "latest";
                    blockNumberHex = blockNumber !== undefined ? (0, $f3VZN.numberToHex)(blockNumber) : undefined;
                    transaction = null;
                    if (!hash) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        client.request({
                            method: "eth_getTransactionByHash",
                            params: [
                                hash
                            ]
                        }, {
                            dedupe: true
                        })
                    ];
                case 1:
                    transaction = _state.sent();
                    return [
                        3,
                        6
                    ];
                case 2:
                    if (!blockHash) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        client.request({
                            method: "eth_getTransactionByBlockHashAndIndex",
                            params: [
                                blockHash,
                                (0, $f3VZN.numberToHex)(index)
                            ]
                        }, {
                            dedupe: true
                        })
                    ];
                case 3:
                    transaction = _state.sent();
                    return [
                        3,
                        6
                    ];
                case 4:
                    if (!(blockNumberHex || blockTag)) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        client.request({
                            method: "eth_getTransactionByBlockNumberAndIndex",
                            params: [
                                blockNumberHex || blockTag,
                                (0, $f3VZN.numberToHex)(index)
                            ]
                        }, {
                            dedupe: Boolean(blockNumberHex)
                        })
                    ];
                case 5:
                    transaction = _state.sent();
                    _state.label = 6;
                case 6:
                    if (!transaction) throw new (0, $hgawa.TransactionNotFoundError)({
                        blockHash: blockHash,
                        blockNumber: blockNumber,
                        blockTag: blockTag,
                        hash: hash,
                        index: index
                    });
                    format = ((_client_chain = client.chain) === null || _client_chain === void 0 ? void 0 : (_client_chain_formatters = _client_chain.formatters) === null || _client_chain_formatters === void 0 ? void 0 : (_client_chain_formatters_transaction = _client_chain_formatters.transaction) === null || _client_chain_formatters_transaction === void 0 ? void 0 : _client_chain_formatters_transaction.format) || (0, $362945b46c90d2fd$export$b02b16590d26dadc);
                    return [
                        2,
                        format(transaction)
                    ];
            }
        });
    });
    return $55ff11d9c8fdfd6e$var$_getTransaction.apply(this, arguments);
}



var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $hgawa = parcelRequire("hgawa");

function $f0ad3251ac056bba$export$6b1ceb3cd5f8b21f(client, _) {
    return $f0ad3251ac056bba$var$_getTransactionReceipt.apply(this, arguments);
}
function $f0ad3251ac056bba$var$_getTransactionReceipt() {
    $f0ad3251ac056bba$var$_getTransactionReceipt = (0, $kSuI9._)(function(client, param) {
        var hash, _client_chain_formatters_transactionReceipt, _client_chain_formatters, _client_chain, receipt, format;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    hash = param.hash;
                    return [
                        4,
                        client.request({
                            method: "eth_getTransactionReceipt",
                            params: [
                                hash
                            ]
                        }, {
                            dedupe: true
                        })
                    ];
                case 1:
                    receipt = _state.sent();
                    if (!receipt) throw new (0, $hgawa.TransactionReceiptNotFoundError)({
                        hash: hash
                    });
                    format = ((_client_chain = client.chain) === null || _client_chain === void 0 ? void 0 : (_client_chain_formatters = _client_chain.formatters) === null || _client_chain_formatters === void 0 ? void 0 : (_client_chain_formatters_transactionReceipt = _client_chain_formatters.transactionReceipt) === null || _client_chain_formatters_transactionReceipt === void 0 ? void 0 : _client_chain_formatters_transactionReceipt.format) || (0, $8cb58e272a45980a$export$30da670e49d6fc31);
                    return [
                        2,
                        format(receipt)
                    ];
            }
        });
    });
    return $f0ad3251ac056bba$var$_getTransactionReceipt.apply(this, arguments);
}



var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $itrhm = parcelRequire("itrhm");



var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

function $656bd20abacea8de$export$e0c10349b2c5e1d4(fn, param) {
    var emitOnBegin = param.emitOnBegin, initialWaitTime = param.initialWaitTime, interval = param.interval;
    var active = true;
    var unwatch = function() {
        return active = false;
    };
    var watch = function() {
        var _ref = (0, $kSuI9._)(function() {
            var data, _ref, initialWait, poll;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        data = undefined;
                        if (!emitOnBegin) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            fn({
                                unpoll: unwatch
                            })
                        ];
                    case 1:
                        data = _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            initialWaitTime === null || initialWaitTime === void 0 ? void 0 : initialWaitTime(data)
                        ];
                    case 3:
                        initialWait = (_ref = _state.sent()) !== null && _ref !== void 0 ? _ref : interval;
                        return [
                            4,
                            (0, $a77c4d3ea39fd77e$export$5c069c93d2b7493f)(initialWait)
                        ];
                    case 4:
                        _state.sent();
                        poll = function() {
                            var _ref = (0, $kSuI9._)(function() {
                                return (0, $eha6O.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!active) return [
                                                2
                                            ];
                                            return [
                                                4,
                                                fn({
                                                    unpoll: unwatch
                                                })
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                4,
                                                (0, $a77c4d3ea39fd77e$export$5c069c93d2b7493f)(interval)
                                            ];
                                        case 2:
                                            _state.sent();
                                            poll();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function poll() {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        poll();
                        return [
                            2
                        ];
                }
            });
        });
        return function watch() {
            return _ref.apply(this, arguments);
        };
    }();
    watch();
    return unwatch;
}



var $lUgMT = parcelRequire("lUgMT");

var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");
/** @internal */ 
var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");
var $a4cbe70cacf8b808$export$e89e805418f4d2c = /*#__PURE__*/ new Map();
var $a4cbe70cacf8b808$export$b4c67320c85a8b9d = /*#__PURE__*/ new Map();
function $a4cbe70cacf8b808$export$e2575ed62a2f107b(cacheKey) {
    var buildCache = function(cacheKey, cache) {
        return {
            clear: function() {
                return cache.delete(cacheKey);
            },
            get: function() {
                return cache.get(cacheKey);
            },
            set: function(data) {
                return cache.set(cacheKey, data);
            }
        };
    };
    var promise = buildCache(cacheKey, $a4cbe70cacf8b808$export$e89e805418f4d2c);
    var response = buildCache(cacheKey, $a4cbe70cacf8b808$export$b4c67320c85a8b9d);
    return {
        clear: function() {
            promise.clear();
            response.clear();
        },
        promise: promise,
        response: response
    };
}
function $a4cbe70cacf8b808$export$33b32b3abf8170f0(fn, _) {
    return $a4cbe70cacf8b808$var$_withCache.apply(this, arguments);
}
function $a4cbe70cacf8b808$var$_withCache() {
    $a4cbe70cacf8b808$var$_withCache = (0, $kSuI9._)(function(fn, param) {
        var cacheKey, _param_cacheTime, cacheTime, cache, response, age, promise, data;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    cacheKey = param.cacheKey, _param_cacheTime = param.cacheTime, cacheTime = _param_cacheTime === void 0 ? Number.POSITIVE_INFINITY : _param_cacheTime;
                    cache = $a4cbe70cacf8b808$export$e2575ed62a2f107b(cacheKey);
                    // If a response exists in the cache, and it's not expired, return it
                    // and do not invoke the promise.
                    // If the max age is 0, the cache is disabled.
                    response = cache.response.get();
                    if (response && cacheTime > 0) {
                        age = new Date().getTime() - response.created.getTime();
                        if (age < cacheTime) return [
                            2,
                            response.data
                        ];
                    }
                    promise = cache.promise.get();
                    if (!promise) {
                        promise = fn();
                        // Store the promise in the cache so that subsequent invocations
                        // will wait for the same promise to resolve (deduping).
                        cache.promise.set(promise);
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        3,
                        4
                    ]);
                    return [
                        4,
                        promise
                    ];
                case 2:
                    data = _state.sent();
                    // Store the response in the cache so that subsequent invocations
                    // will return the same response.
                    cache.response.set({
                        created: new Date(),
                        data: data
                    });
                    return [
                        2,
                        data
                    ];
                case 3:
                    // Clear the promise cache so that subsequent invocations will
                    // invoke the promise again.
                    cache.promise.clear();
                    return [
                        7
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $a4cbe70cacf8b808$var$_withCache.apply(this, arguments);
}


var $1b10c774854a89ed$var$cacheKey = function(id) {
    return "blockNumber.".concat(id);
};
function $1b10c774854a89ed$export$bc78c57a2d1b4a2b(id) {
    return (0, $a4cbe70cacf8b808$export$e2575ed62a2f107b)($1b10c774854a89ed$var$cacheKey(id));
}
function $1b10c774854a89ed$export$9328b5c92c53a20e(client) {
    return $1b10c774854a89ed$var$_getBlockNumber.apply(this, arguments);
}
function $1b10c774854a89ed$var$_getBlockNumber() {
    $1b10c774854a89ed$var$_getBlockNumber = (0, $kSuI9._)(function(client) {
        var _ref, _ref_cacheTime, cacheTime, blockNumberHex;
        var _arguments = arguments;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ref = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, _ref_cacheTime = _ref.cacheTime, cacheTime = _ref_cacheTime === void 0 ? client.cacheTime : _ref_cacheTime;
                    return [
                        4,
                        (0, $a4cbe70cacf8b808$export$33b32b3abf8170f0)(function() {
                            return client.request({
                                method: "eth_blockNumber"
                            });
                        }, {
                            cacheKey: $1b10c774854a89ed$var$cacheKey(client.uid),
                            cacheTime: cacheTime
                        })
                    ];
                case 1:
                    blockNumberHex = _state.sent();
                    return [
                        2,
                        BigInt(blockNumberHex)
                    ];
            }
        });
    });
    return $1b10c774854a89ed$var$_getBlockNumber.apply(this, arguments);
}


function $60a9ddfed54c508b$export$fc5f622dd0d82466(client, param) {
    var _param_emitOnBegin = param.emitOnBegin, emitOnBegin = _param_emitOnBegin === void 0 ? false : _param_emitOnBegin, _param_emitMissed = param.emitMissed, emitMissed = _param_emitMissed === void 0 ? false : _param_emitMissed, onBlockNumber = param.onBlockNumber, onError = param.onError, poll_ = param.poll, _param_pollingInterval = param.pollingInterval, pollingInterval = _param_pollingInterval === void 0 ? client.pollingInterval : _param_pollingInterval;
    var enablePolling = function() {
        if (typeof poll_ !== "undefined") return poll_;
        if (client.transport.type === "webSocket") return false;
        if (client.transport.type === "fallback" && client.transport.transports[0].config.type === "webSocket") return false;
        return true;
    }();
    var prevBlockNumber;
    var pollBlockNumber = function() {
        var observerId = (0, $lUgMT.stringify)([
            "watchBlockNumber",
            client.uid,
            emitOnBegin,
            emitMissed,
            pollingInterval
        ]);
        return (0, $4ae5ed700072ba74$export$d1203567a167490e)(observerId, {
            onBlockNumber: onBlockNumber,
            onError: onError
        }, function(emit) {
            return (0, $656bd20abacea8de$export$e0c10349b2c5e1d4)(/*#__PURE__*/ (0, $kSuI9._)(function() {
                var blockNumber, i, err, _emit_onError;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $1b10c774854a89ed$export$9328b5c92c53a20e), "getBlockNumber")({
                                    cacheTime: 0
                                })
                            ];
                        case 1:
                            blockNumber = _state.sent();
                            if (prevBlockNumber) {
                                // If the current block number is the same as the previous,
                                // we can skip.
                                if (blockNumber === prevBlockNumber) return [
                                    2
                                ];
                                // If we have missed out on some previous blocks, and the
                                // `emitMissed` flag is truthy, let's emit those blocks.
                                if (blockNumber - prevBlockNumber > 1 && emitMissed) for(i = prevBlockNumber + 1n; i < blockNumber; i++){
                                    emit.onBlockNumber(i, prevBlockNumber);
                                    prevBlockNumber = i;
                                }
                            }
                            // If the next block number is greater than the previous,
                            // it is not in the past, and we can emit the new block number.
                            if (!prevBlockNumber || blockNumber > prevBlockNumber) {
                                emit.onBlockNumber(blockNumber, prevBlockNumber);
                                prevBlockNumber = blockNumber;
                            }
                            return [
                                3,
                                3
                            ];
                        case 2:
                            err = _state.sent();
                            (_emit_onError = emit.onError) === null || _emit_onError === void 0 ? void 0 : _emit_onError.call(emit, err);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            }), {
                emitOnBegin: emitOnBegin,
                interval: pollingInterval
            });
        });
    };
    var subscribeBlockNumber = function() {
        var observerId = (0, $lUgMT.stringify)([
            "watchBlockNumber",
            client.uid,
            emitOnBegin,
            emitMissed
        ]);
        return (0, $4ae5ed700072ba74$export$d1203567a167490e)(observerId, {
            onBlockNumber: onBlockNumber,
            onError: onError
        }, function(emit) {
            var active = true;
            var unsubscribe = function() {
                return active = false;
            };
            (0, $kSuI9._)(function() {
                var transport, _ref, unsubscribe_, err;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            transport = function() {
                                if (client.transport.type === "fallback") {
                                    var transport = client.transport.transports.find(function(transport) {
                                        return transport.config.type === "webSocket";
                                    });
                                    if (!transport) return client.transport;
                                    return transport.value;
                                }
                                return client.transport;
                            }();
                            return [
                                4,
                                transport.subscribe({
                                    params: [
                                        "newHeads"
                                    ],
                                    onData: function(data) {
                                        var _data_result;
                                        if (!active) return;
                                        var blockNumber = (0, $itrhm.hexToBigInt)((_data_result = data.result) === null || _data_result === void 0 ? void 0 : _data_result.number);
                                        emit.onBlockNumber(blockNumber, prevBlockNumber);
                                        prevBlockNumber = blockNumber;
                                    },
                                    onError: function(error) {
                                        var _emit_onError;
                                        (_emit_onError = emit.onError) === null || _emit_onError === void 0 ? void 0 : _emit_onError.call(emit, error);
                                    }
                                })
                            ];
                        case 1:
                            _ref = _state.sent(), unsubscribe_ = _ref.unsubscribe;
                            unsubscribe = unsubscribe_;
                            if (!active) unsubscribe();
                            return [
                                3,
                                3
                            ];
                        case 2:
                            err = _state.sent();
                            onError === null || onError === void 0 ? void 0 : onError(err);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
            return function() {
                return unsubscribe();
            };
        });
    };
    return enablePolling ? pollBlockNumber() : subscribeBlockNumber();
}


function $209a49fa49253b0e$export$694ec9bdf0bb55cf(client, _) {
    return $209a49fa49253b0e$var$_waitForTransactionReceipt.apply(this, arguments);
}
function $209a49fa49253b0e$var$_waitForTransactionReceipt() {
    $209a49fa49253b0e$var$_waitForTransactionReceipt = (0, $kSuI9._)(function(client, param) {
        var _param_confirmations, confirmations, hash, onReplaced, _param_pollingInterval, pollingInterval, _param_retryCount, retryCount, _param_retryDelay, retryDelay, timeout, observerId, count, transaction, replacedTransaction, receipt, retrying;
        return (0, $eha6O.__generator)(this, function(_state) {
            _param_confirmations = param.confirmations, confirmations = _param_confirmations === void 0 ? 1 : _param_confirmations, hash = param.hash, onReplaced = param.onReplaced, _param_pollingInterval = param.pollingInterval, pollingInterval = _param_pollingInterval === void 0 ? client.pollingInterval : _param_pollingInterval, _param_retryCount = param.retryCount, retryCount = _param_retryCount === void 0 ? 6 : _param_retryCount, _param_retryDelay = param.retryDelay, retryDelay = _param_retryDelay === void 0 ? function(param) {
                var count = param.count;
                return ~~(1 << count) * 200;
            } : _param_retryDelay, timeout = param.timeout;
            observerId = (0, $lUgMT.stringify)([
                "waitForTransactionReceipt",
                client.uid,
                hash
            ]);
            count = 0;
            retrying = false;
            return [
                2,
                new Promise(function(resolve, reject) {
                    if (timeout) setTimeout(function() {
                        return reject(new (0, $hgawa.WaitForTransactionReceiptTimeoutError)({
                            hash: hash
                        }));
                    }, timeout);
                    var _unobserve = (0, $4ae5ed700072ba74$export$d1203567a167490e)(observerId, {
                        onReplaced: onReplaced,
                        resolve: resolve,
                        reject: reject
                    }, function(emit) {
                        var _unwatch = (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $60a9ddfed54c508b$export$fc5f622dd0d82466), "watchBlockNumber")({
                            emitMissed: true,
                            emitOnBegin: true,
                            poll: true,
                            pollingInterval: pollingInterval,
                            onBlockNumber: function(blockNumber_) {
                                return (0, $kSuI9._)(function() {
                                    var done, blockNumber, err, block, replacementTransaction, reason, err_;
                                    return (0, $eha6O.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                done = function(fn) {
                                                    _unwatch();
                                                    fn();
                                                    _unobserve();
                                                };
                                                blockNumber = blockNumber_;
                                                if (retrying) return [
                                                    2
                                                ];
                                                if (count > retryCount) done(function() {
                                                    return emit.reject(new (0, $hgawa.WaitForTransactionReceiptTimeoutError)({
                                                        hash: hash
                                                    }));
                                                });
                                                _state.label = 1;
                                            case 1:
                                                _state.trys.push([
                                                    1,
                                                    5,
                                                    13,
                                                    14
                                                ]);
                                                // If we already have a valid receipt, let's check if we have enough
                                                // confirmations. If we do, then we can resolve.
                                                if (receipt) {
                                                    if (confirmations > 1 && (!receipt.blockNumber || blockNumber - receipt.blockNumber + 1n < confirmations)) return [
                                                        2
                                                    ];
                                                    done(function() {
                                                        return emit.resolve(receipt);
                                                    });
                                                    return [
                                                        2
                                                    ];
                                                }
                                                if (!!transaction) return [
                                                    3,
                                                    3
                                                ];
                                                retrying = true;
                                                return [
                                                    4,
                                                    (0, $26064d0812f4a37c$export$188df5ecf8e7961a)(/*#__PURE__*/ (0, $kSuI9._)(function() {
                                                        return (0, $eha6O.__generator)(this, function(_state) {
                                                            switch(_state.label){
                                                                case 0:
                                                                    return [
                                                                        4,
                                                                        (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $55ff11d9c8fdfd6e$export$ec0c6556a09b65b8), "getTransaction")({
                                                                            hash: hash
                                                                        })
                                                                    ];
                                                                case 1:
                                                                    transaction = _state.sent();
                                                                    if (transaction.blockNumber) blockNumber = transaction.blockNumber;
                                                                    return [
                                                                        2
                                                                    ];
                                                            }
                                                        });
                                                    }), {
                                                        delay: retryDelay,
                                                        retryCount: retryCount
                                                    })
                                                ];
                                            case 2:
                                                _state.sent();
                                                retrying = false;
                                                _state.label = 3;
                                            case 3:
                                                return [
                                                    4,
                                                    (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $f0ad3251ac056bba$export$6b1ceb3cd5f8b21f), "getTransactionReceipt")({
                                                        hash: hash
                                                    })
                                                ];
                                            case 4:
                                                // Get the receipt to check if it's been processed.
                                                receipt = _state.sent();
                                                // Check if we have enough confirmations. If not, continue polling.
                                                if (confirmations > 1 && (!receipt.blockNumber || blockNumber - receipt.blockNumber + 1n < confirmations)) return [
                                                    2
                                                ];
                                                done(function() {
                                                    return emit.resolve(receipt);
                                                });
                                                return [
                                                    3,
                                                    14
                                                ];
                                            case 5:
                                                err = _state.sent();
                                                if (!(err instanceof (0, $hgawa.TransactionNotFoundError) || err instanceof (0, $hgawa.TransactionReceiptNotFoundError))) return [
                                                    3,
                                                    11
                                                ];
                                                if (!transaction) {
                                                    retrying = false;
                                                    return [
                                                        2
                                                    ];
                                                }
                                                _state.label = 6;
                                            case 6:
                                                _state.trys.push([
                                                    6,
                                                    9,
                                                    ,
                                                    10
                                                ]);
                                                replacedTransaction = transaction;
                                                // Let's retrieve the transactions from the current block.
                                                // We need to retry as some RPC Providers may be slow to sync
                                                // up mined blocks.
                                                retrying = true;
                                                return [
                                                    4,
                                                    (0, $26064d0812f4a37c$export$188df5ecf8e7961a)(function() {
                                                        return (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $985463a4c6a1d2e4$export$ea0af84ed2e77902), "getBlock")({
                                                            blockNumber: blockNumber,
                                                            includeTransactions: true
                                                        });
                                                    }, {
                                                        delay: retryDelay,
                                                        retryCount: retryCount,
                                                        shouldRetry: function(param) {
                                                            var error = param.error;
                                                            return error instanceof (0, $16bcd5f9a78aa912$export$f5a00468af285e38);
                                                        }
                                                    })
                                                ];
                                            case 7:
                                                block = _state.sent();
                                                retrying = false;
                                                replacementTransaction = block.transactions.find(function(param) {
                                                    var from = param.from, nonce = param.nonce;
                                                    return from === replacedTransaction.from && nonce === replacedTransaction.nonce;
                                                });
                                                // If we couldn't find a replacement transaction, continue polling.
                                                if (!replacementTransaction) return [
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $f0ad3251ac056bba$export$6b1ceb3cd5f8b21f), "getTransactionReceipt")({
                                                        hash: replacementTransaction.hash
                                                    })
                                                ];
                                            case 8:
                                                // If we found a replacement transaction, return it's receipt.
                                                receipt = _state.sent();
                                                // Check if we have enough confirmations. If not, continue polling.
                                                if (confirmations > 1 && (!receipt.blockNumber || blockNumber - receipt.blockNumber + 1n < confirmations)) return [
                                                    2
                                                ];
                                                reason = "replaced";
                                                if (replacementTransaction.to === replacedTransaction.to && replacementTransaction.value === replacedTransaction.value) reason = "repriced";
                                                else if (replacementTransaction.from === replacementTransaction.to && replacementTransaction.value === 0n) reason = "cancelled";
                                                done(function() {
                                                    var _emit_onReplaced;
                                                    (_emit_onReplaced = emit.onReplaced) === null || _emit_onReplaced === void 0 ? void 0 : _emit_onReplaced.call(emit, {
                                                        reason: reason,
                                                        replacedTransaction: replacedTransaction,
                                                        transaction: replacementTransaction,
                                                        transactionReceipt: receipt
                                                    });
                                                    emit.resolve(receipt);
                                                });
                                                return [
                                                    3,
                                                    10
                                                ];
                                            case 9:
                                                err_ = _state.sent();
                                                done(function() {
                                                    return emit.reject(err_);
                                                });
                                                return [
                                                    3,
                                                    10
                                                ];
                                            case 10:
                                                return [
                                                    3,
                                                    12
                                                ];
                                            case 11:
                                                done(function() {
                                                    return emit.reject(err);
                                                });
                                                _state.label = 12;
                                            case 12:
                                                return [
                                                    3,
                                                    14
                                                ];
                                            case 13:
                                                count++;
                                                return [
                                                    7
                                                ];
                                            case 14:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            }
                        });
                    });
                })
            ];
        });
    });
    return $209a49fa49253b0e$var$_waitForTransactionReceipt.apply(this, arguments);
}


var $hy7Ff = parcelRequire("hy7Ff");

function $98c83597d2cecc81$export$694ec9bdf0bb55cf(config, parameters) {
    return $98c83597d2cecc81$var$_waitForTransactionReceipt.apply(this, arguments);
}
function $98c83597d2cecc81$var$_waitForTransactionReceipt() {
    $98c83597d2cecc81$var$_waitForTransactionReceipt = (0, $kSuI9._)(function(config, parameters) {
        var chainId, _parameters_timeout, timeout, rest, client, action, receipt, action_getTransaction, txn, action_call, code, reason;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    chainId = parameters.chainId, _parameters_timeout = parameters.timeout, timeout = _parameters_timeout === void 0 ? 0 : _parameters_timeout, rest = (0, $dRLPW._)(parameters, [
                        "chainId",
                        "timeout"
                    ]);
                    client = config.getClient({
                        chainId: chainId
                    });
                    action = (0, $79c54d690e762313$export$6ca3170acb89054)(client, (0, $209a49fa49253b0e$export$694ec9bdf0bb55cf), "waitForTransactionReceipt");
                    return [
                        4,
                        action((0, $cxjpp._)((0, $do9pw._)({}, rest), {
                            timeout: timeout
                        }))
                    ];
                case 1:
                    receipt = _state.sent();
                    if (!(receipt.status === "reverted")) return [
                        3,
                        4
                    ];
                    action_getTransaction = (0, $79c54d690e762313$export$6ca3170acb89054)(client, (0, $55ff11d9c8fdfd6e$export$ec0c6556a09b65b8), "getTransaction");
                    return [
                        4,
                        action_getTransaction({
                            hash: receipt.transactionHash
                        })
                    ];
                case 2:
                    txn = _state.sent();
                    action_call = (0, $79c54d690e762313$export$6ca3170acb89054)(client, (0, $hy7Ff.call), "call");
                    return [
                        4,
                        action_call((0, $cxjpp._)((0, $do9pw._)({}, txn), {
                            gasPrice: txn.type !== "eip1559" ? txn.gasPrice : undefined,
                            maxFeePerGas: txn.type === "eip1559" ? txn.maxFeePerGas : undefined,
                            maxPriorityFeePerGas: txn.type === "eip1559" ? txn.maxPriorityFeePerGas : undefined
                        }))
                    ];
                case 3:
                    code = _state.sent();
                    reason = (code === null || code === void 0 ? void 0 : code.data) ? (0, $itrhm.hexToString)("0x".concat(code.data.substring(138))) : "unknown reason";
                    throw new Error(reason);
                case 4:
                    return [
                        2,
                        (0, $cxjpp._)((0, $do9pw._)({}, receipt), {
                            chainId: client.chain.id
                        })
                    ];
            }
        });
    });
    return $98c83597d2cecc81$var$_waitForTransactionReceipt.apply(this, arguments);
}


var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");

var $eha6O = parcelRequire("eha6O");

var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $dRLPW = parcelRequire("dRLPW");

var $eha6O = parcelRequire("eha6O");

var $l2YyF = parcelRequire("l2YyF");


var $cdvyV = parcelRequire("cdvyV");

var $fLalY = parcelRequire("fLalY");

var $7ihh7 = parcelRequire("7ihh7");

var $fZz5Q = parcelRequire("fZz5Q");

var $aqVrP = parcelRequire("aqVrP");
var $2cf930bd18c2e947$var$EXECUTION_REVERTED_ERROR_CODE = 3;
function $2cf930bd18c2e947$export$4414444aba6ddd8a(err, param) {
    var abi = param.abi, address = param.address, args = param.args, docsPath = param.docsPath, functionName = param.functionName, sender = param.sender;
    var _ref = err instanceof (0, $fZz5Q.RawContractError) ? err : err instanceof (0, $7ihh7.BaseError) ? err.walk(function(err) {
        return "data" in err;
    }) || err.walk() : {}, code = _ref.code, data = _ref.data, message = _ref.message, shortMessage = _ref.shortMessage;
    var cause = function() {
        if (err instanceof (0, $fLalY.AbiDecodingZeroDataError)) return new (0, $fZz5Q.ContractFunctionZeroDataError)({
            functionName: functionName
        });
        if ([
            $2cf930bd18c2e947$var$EXECUTION_REVERTED_ERROR_CODE,
            (0, $aqVrP.InternalRpcError).code
        ].includes(code) && (data || message || shortMessage)) return new (0, $fZz5Q.ContractFunctionRevertedError)({
            abi: abi,
            data: typeof data === "object" ? data.data : data,
            functionName: functionName,
            message: shortMessage !== null && shortMessage !== void 0 ? shortMessage : message
        });
        return err;
    }();
    return new (0, $fZz5Q.ContractFunctionExecutionError)(cause, {
        abi: abi,
        args: args,
        contractAddress: address,
        docsPath: docsPath,
        functionName: functionName,
        sender: sender
    });
}




function $c2786d6d73bd4474$export$4c0f201bc17cbf23(client, parameters) {
    return $c2786d6d73bd4474$var$_writeContract.apply(this, arguments);
}
function $c2786d6d73bd4474$var$_writeContract() {
    $c2786d6d73bd4474$var$_writeContract = (0, $kSuI9._)(function(client, parameters) {
        var abi, tmp, account_, address, args, dataSuffix, functionName, request, account, data, error;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    abi = parameters.abi, tmp = parameters.account, account_ = tmp === void 0 ? client.account : tmp, address = parameters.address, args = parameters.args, dataSuffix = parameters.dataSuffix, functionName = parameters.functionName, request = (0, $dRLPW._)(parameters, [
                        "abi",
                        "account",
                        "address",
                        "args",
                        "dataSuffix",
                        "functionName"
                    ]);
                    if (!account_) throw new (0, $58c5ed114b2c2f06$export$62ee6b05f0767f28)({
                        docsPath: "/docs/contract/writeContract"
                    });
                    account = (0, $l2YyF.parseAccount)(account_);
                    data = (0, $cdvyV.encodeFunctionData)({
                        abi: abi,
                        args: args,
                        functionName: functionName
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $49da3b39ba760adb$export$8e0e7ffc78696d30), "sendTransaction")((0, $do9pw._)({
                            data: "".concat(data).concat(dataSuffix ? dataSuffix.replace("0x", "") : ""),
                            to: address,
                            account: account
                        }, request))
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    error = _state.sent();
                    throw (0, $2cf930bd18c2e947$export$4414444aba6ddd8a)(error, {
                        abi: abi,
                        address: address,
                        args: args,
                        docsPath: "/docs/contract/writeContract",
                        functionName: functionName,
                        sender: account.address
                    });
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $c2786d6d73bd4474$var$_writeContract.apply(this, arguments);
}






var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");

var $eha6O = parcelRequire("eha6O");

var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");

var $eha6O = parcelRequire("eha6O");

var $l2YyF = parcelRequire("l2YyF");

var $itJ66 = parcelRequire("itJ66");

var $cdvyV = parcelRequire("cdvyV");



var $hy7Ff = parcelRequire("hy7Ff");
function $a35082122e3eb786$export$e8798d551e27a374(client, parameters) {
    return $a35082122e3eb786$var$_simulateContract.apply(this, arguments);
}
function $a35082122e3eb786$var$_simulateContract() {
    $a35082122e3eb786$var$_simulateContract = (0, $kSuI9._)(function(client, parameters) {
        var abi, address, args, dataSuffix, functionName, callRequest, account, calldata, data, result, minimizedAbi, error;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    abi = parameters.abi, address = parameters.address, args = parameters.args, dataSuffix = parameters.dataSuffix, functionName = parameters.functionName, callRequest = (0, $dRLPW._)(parameters, [
                        "abi",
                        "address",
                        "args",
                        "dataSuffix",
                        "functionName"
                    ]);
                    account = callRequest.account ? (0, $l2YyF.parseAccount)(callRequest.account) : client.account;
                    calldata = (0, $cdvyV.encodeFunctionData)({
                        abi: abi,
                        args: args,
                        functionName: functionName
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $hy7Ff.call), "call")((0, $cxjpp._)((0, $do9pw._)({
                            batch: false,
                            data: "".concat(calldata).concat(dataSuffix ? dataSuffix.replace("0x", "") : ""),
                            to: address
                        }, callRequest), {
                            account: account
                        }))
                    ];
                case 2:
                    data = _state.sent().data;
                    result = (0, $itJ66.decodeFunctionResult)({
                        abi: abi,
                        args: args,
                        functionName: functionName,
                        data: data || "0x"
                    });
                    minimizedAbi = abi.filter(function(abiItem) {
                        return "name" in abiItem && abiItem.name === parameters.functionName;
                    });
                    return [
                        2,
                        {
                            result: result,
                            request: (0, $cxjpp._)((0, $do9pw._)({
                                abi: minimizedAbi,
                                address: address,
                                args: args,
                                dataSuffix: dataSuffix,
                                functionName: functionName
                            }, callRequest), {
                                account: account
                            })
                        }
                    ];
                case 3:
                    error = _state.sent();
                    throw (0, $2cf930bd18c2e947$export$4414444aba6ddd8a)(error, {
                        abi: abi,
                        address: address,
                        args: args,
                        docsPath: "/docs/contract/simulateContract",
                        functionName: functionName,
                        sender: account === null || account === void 0 ? void 0 : account.address
                    });
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $a35082122e3eb786$var$_simulateContract.apply(this, arguments);
}




function $05674fa37ec6bb65$export$e8798d551e27a374(config, parameters) {
    return $05674fa37ec6bb65$var$_simulateContract.apply(this, arguments);
}
function $05674fa37ec6bb65$var$_simulateContract() {
    $05674fa37ec6bb65$var$_simulateContract = (0, $kSuI9._)(function(config, parameters) {
        var abi, chainId, connector, rest, account, connectorClient, client, action, _ref, result, request;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    abi = parameters.abi, chainId = parameters.chainId, connector = parameters.connector, rest = (0, $dRLPW._)(parameters, [
                        "abi",
                        "chainId",
                        "connector"
                    ]);
                    if (!parameters.account) return [
                        3,
                        1
                    ];
                    account = parameters.account;
                    return [
                        3,
                        3
                    ];
                case 1:
                    return [
                        4,
                        (0, $c7c82ca8fcf669fd$export$d784801ca17b4aec)(config, {
                            chainId: chainId,
                            connector: connector
                        })
                    ];
                case 2:
                    connectorClient = _state.sent();
                    account = connectorClient.account;
                    _state.label = 3;
                case 3:
                    client = config.getClient({
                        chainId: chainId
                    });
                    action = (0, $79c54d690e762313$export$6ca3170acb89054)(client, (0, $a35082122e3eb786$export$e8798d551e27a374), "simulateContract");
                    return [
                        4,
                        action((0, $cxjpp._)((0, $do9pw._)({}, rest), {
                            abi: abi,
                            account: account
                        }))
                    ];
                case 4:
                    _ref = _state.sent(), result = _ref.result, request = _ref.request;
                    return [
                        2,
                        {
                            chainId: client.chain.id,
                            result: result,
                            request: (0, $cxjpp._)((0, $do9pw._)({
                                __mode: "prepared"
                            }, request), {
                                chainId: chainId
                            })
                        }
                    ];
            }
        });
    });
    return $05674fa37ec6bb65$var$_simulateContract.apply(this, arguments);
}


function $f3af23078fd1eb56$export$4c0f201bc17cbf23(config, parameters) {
    return $f3af23078fd1eb56$var$_writeContract.apply(this, arguments);
}
function $f3af23078fd1eb56$var$_writeContract() {
    $f3af23078fd1eb56$var$_writeContract = (0, $kSuI9._)(function(config, parameters) {
        var account, chainId, connector, __mode, rest, client, _getAccount, activeConnector, request, _ref, simulateRequest, action, hash;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    account = parameters.account, chainId = parameters.chainId, connector = parameters.connector, __mode = parameters.__mode, rest = (0, $dRLPW._)(parameters, [
                        "account",
                        "chainId",
                        "connector",
                        "__mode"
                    ]);
                    if (!(typeof account === "object" && account.type === "local")) return [
                        3,
                        1
                    ];
                    client = config.getClient({
                        chainId: chainId
                    });
                    return [
                        3,
                        3
                    ];
                case 1:
                    return [
                        4,
                        (0, $c7c82ca8fcf669fd$export$d784801ca17b4aec)(config, {
                            account: account,
                            chainId: chainId,
                            connector: connector
                        })
                    ];
                case 2:
                    client = _state.sent();
                    _state.label = 3;
                case 3:
                    _getAccount = (0, $03c83a18d36f49ac$export$4f9234baf34abd0)(config), activeConnector = _getAccount.connector;
                    if (!(__mode === "prepared" || (activeConnector === null || activeConnector === void 0 ? void 0 : activeConnector.supportsSimulation))) return [
                        3,
                        4
                    ];
                    request = rest;
                    return [
                        3,
                        6
                    ];
                case 4:
                    return [
                        4,
                        (0, $05674fa37ec6bb65$export$e8798d551e27a374)(config, (0, $cxjpp._)((0, $do9pw._)({}, rest), {
                            account: account,
                            chainId: chainId
                        }))
                    ];
                case 5:
                    _ref = _state.sent(), simulateRequest = _ref.request;
                    request = simulateRequest;
                    _state.label = 6;
                case 6:
                    action = (0, $79c54d690e762313$export$6ca3170acb89054)(client, (0, $c2786d6d73bd4474$export$4c0f201bc17cbf23), "writeContract");
                    return [
                        4,
                        action((0, $cxjpp._)((0, $do9pw._)({}, request, account ? {
                            account: account
                        } : {}), {
                            chain: chainId ? {
                                id: chainId
                            } : null
                        }))
                    ];
                case 7:
                    hash = _state.sent();
                    return [
                        2,
                        hash
                    ];
            }
        });
    });
    return $f3af23078fd1eb56$var$_writeContract.apply(this, arguments);
}


var $dRLPW = parcelRequire("dRLPW");

var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $c6Xmf = parcelRequire("c6Xmf");

var $eha6O = parcelRequire("eha6O");

var $9ClpR = parcelRequire("9ClpR");

var $itJ66 = parcelRequire("itJ66");

var $cdvyV = parcelRequire("cdvyV");

var $hpqb7 = parcelRequire("hpqb7");

var $bi3OS = parcelRequire("bi3OS");

var $f3VZN = parcelRequire("f3VZN");

var $7B10z = parcelRequire("7B10z");

var $7ihh7 = parcelRequire("7ihh7");

var $fZz5Q = parcelRequire("fZz5Q");
function $1517027e0fd72fcc$export$78f90e26b9356cd7(err, callType) {
    var _cause_data, _cause_data1, _cause_data2, _cause_data3, _cause_data4, _cause_reason;
    if (!(err instanceof (0, $7ihh7.BaseError))) return false;
    var cause = err.walk(function(e) {
        return e instanceof (0, $fZz5Q.ContractFunctionRevertedError);
    });
    if (!(cause instanceof (0, $fZz5Q.ContractFunctionRevertedError))) return false;
    if (((_cause_data = cause.data) === null || _cause_data === void 0 ? void 0 : _cause_data.errorName) === "ResolverNotFound") return true;
    if (((_cause_data1 = cause.data) === null || _cause_data1 === void 0 ? void 0 : _cause_data1.errorName) === "ResolverWildcardNotSupported") return true;
    if (((_cause_data2 = cause.data) === null || _cause_data2 === void 0 ? void 0 : _cause_data2.errorName) === "ResolverNotContract") return true;
    if (((_cause_data3 = cause.data) === null || _cause_data3 === void 0 ? void 0 : _cause_data3.errorName) === "ResolverError") return true;
    if (((_cause_data4 = cause.data) === null || _cause_data4 === void 0 ? void 0 : _cause_data4.errorName) === "HttpError") return true;
    // Backwards compatibility for older UniversalResolver contracts
    if ((_cause_reason = cause.reason) === null || _cause_reason === void 0 ? void 0 : _cause_reason.includes("Wildcard on non-extended resolvers is not supported")) return true;
    // No primary name set for address.
    if (callType === "reverse" && cause.reason === (0, $7B10z.panicReasons)[50]) return true;
    return false;
}



var $ewLmX = parcelRequire("ewLmX");

var $g8Qfu = parcelRequire("g8Qfu");

var $f3VZN = parcelRequire("f3VZN");

var $h0UKT = parcelRequire("h0UKT");

var $aP7UT = parcelRequire("aP7UT");
function $2a8696783fd4e45a$export$cbf748cac2e87c52(label) {
    if (label.length !== 66) return null;
    if (label.indexOf("[") !== 0) return null;
    if (label.indexOf("]") !== 65) return null;
    var hash = "0x".concat(label.slice(1, 65));
    if (!(0, $aP7UT.isHex)(hash)) return null;
    return hash;
}


function $bf3fd72d115e0f83$export$91d651ee363e1209(name) {
    var result = new Uint8Array(32).fill(0);
    if (!name) return (0, $f3VZN.bytesToHex)(result);
    var labels = name.split(".");
    // Iterate in reverse order building up hash
    for(var i = labels.length - 1; i >= 0; i -= 1){
        var hashFromEncodedLabel = (0, $2a8696783fd4e45a$export$cbf748cac2e87c52)(labels[i]);
        var hashed = hashFromEncodedLabel ? (0, $g8Qfu.toBytes)(hashFromEncodedLabel) : (0, $h0UKT.keccak256)((0, $g8Qfu.stringToBytes)(labels[i]), "bytes");
        result = (0, $h0UKT.keccak256)((0, $ewLmX.concat)([
            result,
            hashed
        ]), "bytes");
    }
    return (0, $f3VZN.bytesToHex)(result);
}



var $g8Qfu = parcelRequire("g8Qfu");
function $c2fcfd1ca5e16fb4$export$c23ac52da6ff5062(hash) {
    return "[".concat(hash.slice(2), "]");
}



var $g8Qfu = parcelRequire("g8Qfu");

var $f3VZN = parcelRequire("f3VZN");

var $h0UKT = parcelRequire("h0UKT");

function $4af8b7b55c14c84e$export$83615f6c30436a69(label) {
    var result = new Uint8Array(32).fill(0);
    if (!label) return (0, $f3VZN.bytesToHex)(result);
    return (0, $2a8696783fd4e45a$export$cbf748cac2e87c52)(label) || (0, $h0UKT.keccak256)((0, $g8Qfu.stringToBytes)(label));
}


function $96800cc462682856$export$8a0899f9ded0844(packet) {
    // strip leading and trailing `.`
    var value = packet.replace(/^\.|\.$/gm, "");
    if (value.length === 0) return new Uint8Array(1);
    var bytes = new Uint8Array((0, $g8Qfu.stringToBytes)(value).byteLength + 2);
    var offset = 0;
    var list = value.split(".");
    for(var i = 0; i < list.length; i++){
        var encoded = (0, $g8Qfu.stringToBytes)(list[i]);
        // if the length is > 255, make the encoded label value a labelhash
        // this is compatible with the universal resolver
        if (encoded.byteLength > 255) encoded = (0, $g8Qfu.stringToBytes)((0, $c2fcfd1ca5e16fb4$export$c23ac52da6ff5062)((0, $4af8b7b55c14c84e$export$83615f6c30436a69)(list[i])));
        bytes[offset] = encoded.length;
        bytes.set(encoded, offset + 1);
        offset += encoded.length + 1;
    }
    if (bytes.byteLength !== offset + 1) return bytes.slice(0, offset + 1);
    return bytes;
}




var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");

var $eha6O = parcelRequire("eha6O");

var $itJ66 = parcelRequire("itJ66");

var $cdvyV = parcelRequire("cdvyV");



var $hy7Ff = parcelRequire("hy7Ff");
function $1500f99f7733ae7a$export$43af7de392176737(client, parameters) {
    return $1500f99f7733ae7a$var$_readContract.apply(this, arguments);
}
function $1500f99f7733ae7a$var$_readContract() {
    $1500f99f7733ae7a$var$_readContract = (0, $kSuI9._)(function(client, parameters) {
        var abi, address, args, functionName, rest, calldata, data, error;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    abi = parameters.abi, address = parameters.address, args = parameters.args, functionName = parameters.functionName, rest = (0, $dRLPW._)(parameters, [
                        "abi",
                        "address",
                        "args",
                        "functionName"
                    ]);
                    calldata = (0, $cdvyV.encodeFunctionData)({
                        abi: abi,
                        args: args,
                        functionName: functionName
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $hy7Ff.call), "call")((0, $cxjpp._)((0, $do9pw._)({}, rest), {
                            data: calldata,
                            to: address
                        }))
                    ];
                case 2:
                    data = _state.sent().data;
                    return [
                        2,
                        (0, $itJ66.decodeFunctionResult)({
                            abi: abi,
                            args: args,
                            functionName: functionName,
                            data: data || "0x"
                        })
                    ];
                case 3:
                    error = _state.sent();
                    throw (0, $2cf930bd18c2e947$export$4414444aba6ddd8a)(error, {
                        abi: abi,
                        address: address,
                        args: args,
                        docsPath: "/docs/contract/readContract",
                        functionName: functionName
                    });
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $1500f99f7733ae7a$var$_readContract.apply(this, arguments);
}


function $1cba6a8167532c80$export$24b77c7e87f05b8d(client, _) {
    return $1cba6a8167532c80$var$_getEnsAddress.apply(this, arguments);
}
function $1cba6a8167532c80$var$_getEnsAddress() {
    $1cba6a8167532c80$var$_getEnsAddress = (0, $kSuI9._)(function(client, param) {
        var blockNumber, blockTag, coinType, name, gatewayUrls, strict, universalResolverAddress_, universalResolverAddress, functionData, readContractParameters, readContractAction, res, _tmp, address, err;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    blockNumber = param.blockNumber, blockTag = param.blockTag, coinType = param.coinType, name = param.name, gatewayUrls = param.gatewayUrls, strict = param.strict, universalResolverAddress_ = param.universalResolverAddress;
                    universalResolverAddress = universalResolverAddress_;
                    if (!universalResolverAddress) {
                        if (!client.chain) throw new Error("client chain not configured. universalResolverAddress is required.");
                        universalResolverAddress = (0, $hpqb7.getChainContractAddress)({
                            blockNumber: blockNumber,
                            chain: client.chain,
                            contract: "ensUniversalResolver"
                        });
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        ,
                        7
                    ]);
                    functionData = (0, $cdvyV.encodeFunctionData)((0, $do9pw._)({
                        abi: (0, $9ClpR.addressResolverAbi),
                        functionName: "addr"
                    }, coinType != null ? {
                        args: [
                            (0, $bf3fd72d115e0f83$export$91d651ee363e1209)(name),
                            BigInt(coinType)
                        ]
                    } : {
                        args: [
                            (0, $bf3fd72d115e0f83$export$91d651ee363e1209)(name)
                        ]
                    }));
                    readContractParameters = {
                        address: universalResolverAddress,
                        abi: (0, $9ClpR.universalResolverResolveAbi),
                        functionName: "resolve",
                        args: [
                            (0, $f3VZN.toHex)((0, $96800cc462682856$export$8a0899f9ded0844)(name)),
                            functionData
                        ],
                        blockNumber: blockNumber,
                        blockTag: blockTag
                    };
                    readContractAction = (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $1500f99f7733ae7a$export$43af7de392176737), "readContract");
                    if (!gatewayUrls) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        readContractAction((0, $cxjpp._)((0, $do9pw._)({}, readContractParameters), {
                            args: (0, $c6Xmf._)(readContractParameters.args).concat([
                                gatewayUrls
                            ])
                        }))
                    ];
                case 2:
                    _tmp = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 3:
                    return [
                        4,
                        readContractAction(readContractParameters)
                    ];
                case 4:
                    _tmp = _state.sent();
                    _state.label = 5;
                case 5:
                    res = _tmp;
                    if (res[0] === "0x") return [
                        2,
                        null
                    ];
                    address = (0, $itJ66.decodeFunctionResult)({
                        abi: (0, $9ClpR.addressResolverAbi),
                        args: coinType != null ? [
                            (0, $bf3fd72d115e0f83$export$91d651ee363e1209)(name),
                            BigInt(coinType)
                        ] : undefined,
                        functionName: "addr",
                        data: res[0]
                    });
                    if (address === "0x") return [
                        2,
                        null
                    ];
                    if ((0, $bi3OS.trim)(address) === "0x00") return [
                        2,
                        null
                    ];
                    return [
                        2,
                        address
                    ];
                case 6:
                    err = _state.sent();
                    if (strict) throw err;
                    if ((0, $1517027e0fd72fcc$export$78f90e26b9356cd7)(err, "resolve")) return [
                        2,
                        null
                    ];
                    throw err;
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    return $1cba6a8167532c80$var$_getEnsAddress.apply(this, arguments);
}



function $007bb2fc1fe756f5$export$24b77c7e87f05b8d(config, parameters) {
    var chainId = parameters.chainId, rest = (0, $dRLPW._)(parameters, [
        "chainId"
    ]);
    var client = config.getClient({
        chainId: chainId
    });
    var action = (0, $79c54d690e762313$export$6ca3170acb89054)(client, (0, $1cba6a8167532c80$export$24b77c7e87f05b8d), "getEnsAddress");
    return action(rest);
}


var $dRLPW = parcelRequire("dRLPW");

var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $kSuI9 = parcelRequire("kSuI9");

var $cv9Rk = parcelRequire("cv9Rk");

var $eha6O = parcelRequire("eha6O");


var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $7ihh7 = parcelRequire("7ihh7");
var $5e8a460894238e86$export$3d9377558041f9cf = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(EnsAvatarInvalidMetadataError, BaseError);
    var _super = (0, $ohfOJ._)(EnsAvatarInvalidMetadataError);
    function EnsAvatarInvalidMetadataError(param) {
        var data = param.data;
        (0, $4GJKx._)(this, EnsAvatarInvalidMetadataError);
        return _super.call(this, "Unable to extract image from metadata. The metadata may be malformed or invalid.", {
            metaMessages: [
                "- Metadata must be a JSON object with at least an `image`, `image_url` or `image_data` property.",
                "",
                "Provided data: ".concat(JSON.stringify(data))
            ],
            name: "EnsAvatarInvalidMetadataError"
        });
    }
    return EnsAvatarInvalidMetadataError;
}((0, $7ihh7.BaseError));
var $5e8a460894238e86$export$74a8ea52cecec305 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(EnsAvatarInvalidNftUriError, BaseError);
    var _super = (0, $ohfOJ._)(EnsAvatarInvalidNftUriError);
    function EnsAvatarInvalidNftUriError(param) {
        var reason = param.reason;
        (0, $4GJKx._)(this, EnsAvatarInvalidNftUriError);
        return _super.call(this, "ENS NFT avatar URI is invalid. ".concat(reason), {
            name: "EnsAvatarInvalidNftUriError"
        });
    }
    return EnsAvatarInvalidNftUriError;
}((0, $7ihh7.BaseError));
var $5e8a460894238e86$export$f202ff3d50da14eb = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(EnsAvatarUriResolutionError, BaseError);
    var _super = (0, $ohfOJ._)(EnsAvatarUriResolutionError);
    function EnsAvatarUriResolutionError(param) {
        var uri = param.uri;
        (0, $4GJKx._)(this, EnsAvatarUriResolutionError);
        return _super.call(this, 'Unable to resolve ENS avatar URI "'.concat(uri, '". The URI may be malformed, invalid, or does not respond with a valid image.'), {
            name: "EnsAvatarUriResolutionError"
        });
    }
    return EnsAvatarUriResolutionError;
}((0, $7ihh7.BaseError));
var $5e8a460894238e86$export$45137f20297c5e74 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(EnsAvatarUnsupportedNamespaceError, BaseError);
    var _super = (0, $ohfOJ._)(EnsAvatarUnsupportedNamespaceError);
    function EnsAvatarUnsupportedNamespaceError(param) {
        var namespace = param.namespace;
        (0, $4GJKx._)(this, EnsAvatarUnsupportedNamespaceError);
        return _super.call(this, 'ENS NFT avatar namespace "'.concat(namespace, '" is not supported. Must be "erc721" or "erc1155".'), {
            name: "EnsAvatarUnsupportedNamespaceError"
        });
    }
    return EnsAvatarUnsupportedNamespaceError;
}((0, $7ihh7.BaseError));


var $035d6f689e34d7ad$var$networkRegex = RegExp("(?<protocol>https?:\\/\\/[^\\/]*|ipfs:\\/|ipns:\\/|ar:\\/)?(?<root>\\/)?(?<subpath>ipfs\\/|ipns\\/)?(?<target>[\\w\\-.]+)(?<subtarget>\\/.*)?");
var $035d6f689e34d7ad$var$ipfsHashRegex = RegExp("^(Qm[1-9A-HJ-NP-Za-km-z]{44,}|b[A-Za-z2-7]{58,}|B[A-Z2-7]{58,}|z[1-9A-HJ-NP-Za-km-z]{48,}|F[0-9A-F]{50,})(\\/(?<target>[\\w\\-.]+))?(?<subtarget>\\/.*)?$");
var $035d6f689e34d7ad$var$base64Regex = /^data:([a-zA-Z\-/+]*);base64,([^"].*)/;
var $035d6f689e34d7ad$var$dataURIRegex = /^data:([a-zA-Z\-/+]*)?(;[a-zA-Z0-9].*?)?(,)/;
function $035d6f689e34d7ad$export$db9c123edba6463(uri) {
    return $035d6f689e34d7ad$var$_isImageUri.apply(this, arguments);
}
function $035d6f689e34d7ad$var$_isImageUri() {
    $035d6f689e34d7ad$var$_isImageUri = (0, $kSuI9._)(function(uri) {
        var res, contentType, error;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        fetch(uri, {
                            method: "HEAD"
                        })
                    ];
                case 1:
                    res = _state.sent();
                    // retrieve content type header to check if content is image
                    if (res.status === 200) {
                        contentType = res.headers.get("content-type");
                        return [
                            2,
                            contentType === null || contentType === void 0 ? void 0 : contentType.startsWith("image/")
                        ];
                    }
                    return [
                        2,
                        false
                    ];
                case 2:
                    error = _state.sent();
                    // if error is not cors related then fail
                    if (typeof error === "object" && typeof error.response !== "undefined") return [
                        2,
                        false
                    ];
                    // fail in NodeJS, since the error is not cors but any other network issue
                    // biome-ignore lint/suspicious/noPrototypeBuiltins:
                    if (!globalThis.hasOwnProperty("Image")) return [
                        2,
                        false
                    ];
                    // in case of cors, use image api to validate if given url is an actual image
                    return [
                        2,
                        new Promise(function(resolve) {
                            var img = new Image();
                            img.onload = function() {
                                resolve(true);
                            };
                            img.onerror = function() {
                                resolve(false);
                            };
                            img.src = uri;
                        })
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $035d6f689e34d7ad$var$_isImageUri.apply(this, arguments);
}
function $035d6f689e34d7ad$export$90df7f536ca3f624(custom, defaultGateway) {
    if (!custom) return defaultGateway;
    if (custom.endsWith("/")) return custom.slice(0, -1);
    return custom;
}
function $035d6f689e34d7ad$export$9c878106a0d8edac(param) {
    var uri = param.uri, gatewayUrls = param.gatewayUrls;
    var isEncoded = $035d6f689e34d7ad$var$base64Regex.test(uri);
    if (isEncoded) return {
        uri: uri,
        isOnChain: true,
        isEncoded: isEncoded
    };
    var ipfsGateway = $035d6f689e34d7ad$export$90df7f536ca3f624(gatewayUrls === null || gatewayUrls === void 0 ? void 0 : gatewayUrls.ipfs, "https://ipfs.io");
    var arweaveGateway = $035d6f689e34d7ad$export$90df7f536ca3f624(gatewayUrls === null || gatewayUrls === void 0 ? void 0 : gatewayUrls.arweave, "https://arweave.net");
    var networkRegexMatch = uri.match($035d6f689e34d7ad$var$networkRegex);
    var _ref = (networkRegexMatch === null || networkRegexMatch === void 0 ? void 0 : networkRegexMatch.groups) || {}, protocol = _ref.protocol, subpath = _ref.subpath, target = _ref.target, _ref_subtarget = _ref.subtarget, subtarget = _ref_subtarget === void 0 ? "" : _ref_subtarget;
    var isIPNS = protocol === "ipns:/" || subpath === "ipns/";
    var isIPFS = protocol === "ipfs:/" || subpath === "ipfs/" || $035d6f689e34d7ad$var$ipfsHashRegex.test(uri);
    if (uri.startsWith("http") && !isIPNS && !isIPFS) {
        var replacedUri = uri;
        if (gatewayUrls === null || gatewayUrls === void 0 ? void 0 : gatewayUrls.arweave) replacedUri = uri.replace(/https:\/\/arweave.net/g, gatewayUrls === null || gatewayUrls === void 0 ? void 0 : gatewayUrls.arweave);
        return {
            uri: replacedUri,
            isOnChain: false,
            isEncoded: false
        };
    }
    if ((isIPNS || isIPFS) && target) return {
        uri: "".concat(ipfsGateway, "/").concat(isIPNS ? "ipns" : "ipfs", "/").concat(target).concat(subtarget),
        isOnChain: false,
        isEncoded: false
    };
    if (protocol === "ar:/" && target) return {
        uri: "".concat(arweaveGateway, "/").concat(target).concat(subtarget || ""),
        isOnChain: false,
        isEncoded: false
    };
    var parsedUri = uri.replace($035d6f689e34d7ad$var$dataURIRegex, "");
    if (parsedUri.startsWith("<svg")) // if svg, base64 encode
    parsedUri = "data:image/svg+xml;base64,".concat(btoa(parsedUri));
    if (parsedUri.startsWith("data:") || parsedUri.startsWith("{")) return {
        uri: parsedUri,
        isOnChain: true,
        isEncoded: false
    };
    throw new (0, $5e8a460894238e86$export$f202ff3d50da14eb)({
        uri: uri
    });
}
function $035d6f689e34d7ad$export$9be3fe34a3333ecb(data) {
    // validation check for json data, must include one of theses properties
    if (typeof data !== "object" || !("image" in data) && !("image_url" in data) && !("image_data" in data)) throw new (0, $5e8a460894238e86$export$3d9377558041f9cf)({
        data: data
    });
    return data.image || data.image_url || data.image_data;
}
function $035d6f689e34d7ad$export$b9759ed161b5e3c5(_) {
    return $035d6f689e34d7ad$var$_getMetadataAvatarUri.apply(this, arguments);
}
function $035d6f689e34d7ad$var$_getMetadataAvatarUri() {
    $035d6f689e34d7ad$var$_getMetadataAvatarUri = (0, $kSuI9._)(function(param) {
        var gatewayUrls, uri, res, image, e;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    gatewayUrls = param.gatewayUrls, uri = param.uri;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        fetch(uri).then(function(res) {
                            return res.json();
                        })
                    ];
                case 2:
                    res = _state.sent();
                    return [
                        4,
                        $035d6f689e34d7ad$export$1f4e569649d3a793({
                            gatewayUrls: gatewayUrls,
                            uri: $035d6f689e34d7ad$export$9be3fe34a3333ecb(res)
                        })
                    ];
                case 3:
                    image = _state.sent();
                    return [
                        2,
                        image
                    ];
                case 4:
                    e = _state.sent();
                    throw new (0, $5e8a460894238e86$export$f202ff3d50da14eb)({
                        uri: uri
                    });
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return $035d6f689e34d7ad$var$_getMetadataAvatarUri.apply(this, arguments);
}
function $035d6f689e34d7ad$export$1f4e569649d3a793(_) {
    return $035d6f689e34d7ad$var$_parseAvatarUri.apply(this, arguments);
}
function $035d6f689e34d7ad$var$_parseAvatarUri() {
    $035d6f689e34d7ad$var$_parseAvatarUri = (0, $kSuI9._)(function(param) {
        var gatewayUrls, uri, _resolveAvatarUri, resolvedURI, isOnChain, isImage;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    gatewayUrls = param.gatewayUrls, uri = param.uri;
                    _resolveAvatarUri = $035d6f689e34d7ad$export$9c878106a0d8edac({
                        uri: uri,
                        gatewayUrls: gatewayUrls
                    }), resolvedURI = _resolveAvatarUri.uri, isOnChain = _resolveAvatarUri.isOnChain;
                    if (isOnChain) return [
                        2,
                        resolvedURI
                    ];
                    return [
                        4,
                        $035d6f689e34d7ad$export$db9c123edba6463(resolvedURI)
                    ];
                case 1:
                    isImage = _state.sent();
                    if (isImage) return [
                        2,
                        resolvedURI
                    ];
                    throw new (0, $5e8a460894238e86$export$f202ff3d50da14eb)({
                        uri: uri
                    });
            }
        });
    });
    return $035d6f689e34d7ad$var$_parseAvatarUri.apply(this, arguments);
}
function $035d6f689e34d7ad$export$e78cf22c9d52ca8a(uri_) {
    var uri = uri_;
    // parse valid nft spec (CAIP-22/CAIP-29)
    // @see: https://github.com/ChainAgnostic/CAIPs/tree/master/CAIPs
    if (uri.startsWith("did:nft:")) // convert DID to CAIP
    uri = uri.replace("did:nft:", "").replace(/_/g, "/");
    var _uri_split = (0, $cv9Rk._)(uri.split("/"), 3), reference = _uri_split[0], asset_namespace = _uri_split[1], tokenID = _uri_split[2];
    var _reference_split = (0, $cv9Rk._)(reference.split(":"), 2), eip_namespace = _reference_split[0], chainID = _reference_split[1];
    var _asset_namespace_split = (0, $cv9Rk._)(asset_namespace.split(":"), 2), erc_namespace = _asset_namespace_split[0], contractAddress = _asset_namespace_split[1];
    if (!eip_namespace || eip_namespace.toLowerCase() !== "eip155") throw new (0, $5e8a460894238e86$export$74a8ea52cecec305)({
        reason: "Only EIP-155 supported"
    });
    if (!chainID) throw new (0, $5e8a460894238e86$export$74a8ea52cecec305)({
        reason: "Chain ID not found"
    });
    if (!contractAddress) throw new (0, $5e8a460894238e86$export$74a8ea52cecec305)({
        reason: "Contract address not found"
    });
    if (!tokenID) throw new (0, $5e8a460894238e86$export$74a8ea52cecec305)({
        reason: "Token ID not found"
    });
    if (!erc_namespace) throw new (0, $5e8a460894238e86$export$74a8ea52cecec305)({
        reason: "ERC namespace not found"
    });
    return {
        chainID: Number.parseInt(chainID),
        namespace: erc_namespace.toLowerCase(),
        contractAddress: contractAddress,
        tokenID: tokenID
    };
}
function $035d6f689e34d7ad$export$29b8ee2b96a1ed4f(client, _) {
    return $035d6f689e34d7ad$var$_getNftTokenUri.apply(this, arguments);
}
function $035d6f689e34d7ad$var$_getNftTokenUri() {
    $035d6f689e34d7ad$var$_getNftTokenUri = (0, $kSuI9._)(function(client, param) {
        var nft;
        return (0, $eha6O.__generator)(this, function(_state) {
            nft = param.nft;
            if (nft.namespace === "erc721") return [
                2,
                (0, $1500f99f7733ae7a$export$43af7de392176737)(client, {
                    address: nft.contractAddress,
                    abi: [
                        {
                            name: "tokenURI",
                            type: "function",
                            stateMutability: "view",
                            inputs: [
                                {
                                    name: "tokenId",
                                    type: "uint256"
                                }
                            ],
                            outputs: [
                                {
                                    name: "",
                                    type: "string"
                                }
                            ]
                        }
                    ],
                    functionName: "tokenURI",
                    args: [
                        BigInt(nft.tokenID)
                    ]
                })
            ];
            if (nft.namespace === "erc1155") return [
                2,
                (0, $1500f99f7733ae7a$export$43af7de392176737)(client, {
                    address: nft.contractAddress,
                    abi: [
                        {
                            name: "uri",
                            type: "function",
                            stateMutability: "view",
                            inputs: [
                                {
                                    name: "_id",
                                    type: "uint256"
                                }
                            ],
                            outputs: [
                                {
                                    name: "",
                                    type: "string"
                                }
                            ]
                        }
                    ],
                    functionName: "uri",
                    args: [
                        BigInt(nft.tokenID)
                    ]
                })
            ];
            throw new (0, $5e8a460894238e86$export$45137f20297c5e74)({
                namespace: nft.namespace
            });
        });
    });
    return $035d6f689e34d7ad$var$_getNftTokenUri.apply(this, arguments);
}


function $fba2c2ace8e72196$export$3713446b2fba5(client, _) {
    return $fba2c2ace8e72196$var$_parseAvatarRecord.apply(this, arguments);
}
function $fba2c2ace8e72196$var$_parseAvatarRecord() {
    $fba2c2ace8e72196$var$_parseAvatarRecord = (0, $kSuI9._)(function(client, param) {
        var gatewayUrls, record;
        return (0, $eha6O.__generator)(this, function(_state) {
            gatewayUrls = param.gatewayUrls, record = param.record;
            if (/eip155:/i.test(record)) return [
                2,
                $fba2c2ace8e72196$var$parseNftAvatarUri(client, {
                    gatewayUrls: gatewayUrls,
                    record: record
                })
            ];
            return [
                2,
                (0, $035d6f689e34d7ad$export$1f4e569649d3a793)({
                    uri: record,
                    gatewayUrls: gatewayUrls
                })
            ];
        });
    });
    return $fba2c2ace8e72196$var$_parseAvatarRecord.apply(this, arguments);
}
function $fba2c2ace8e72196$var$parseNftAvatarUri(client, _) {
    return $fba2c2ace8e72196$var$_parseNftAvatarUri.apply(this, arguments);
}
function $fba2c2ace8e72196$var$_parseNftAvatarUri() {
    $fba2c2ace8e72196$var$_parseNftAvatarUri = (0, $kSuI9._)(function(client, param) {
        var gatewayUrls, record, nft, nftUri, _resolveAvatarUri, resolvedNftUri, isOnChain, isEncoded, encodedJson, decoded, uriTokenId;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    gatewayUrls = param.gatewayUrls, record = param.record;
                    // parse NFT URI into properties
                    nft = (0, $035d6f689e34d7ad$export$e78cf22c9d52ca8a)(record);
                    return [
                        4,
                        (0, $035d6f689e34d7ad$export$29b8ee2b96a1ed4f)(client, {
                            nft: nft
                        })
                    ];
                case 1:
                    nftUri = _state.sent();
                    // resolve the URI from the fetched tokenURI
                    _resolveAvatarUri = (0, $035d6f689e34d7ad$export$9c878106a0d8edac)({
                        uri: nftUri,
                        gatewayUrls: gatewayUrls
                    }), resolvedNftUri = _resolveAvatarUri.uri, isOnChain = _resolveAvatarUri.isOnChain, isEncoded = _resolveAvatarUri.isEncoded;
                    // if the resolved URI is on chain, return the data
                    if (isOnChain && (resolvedNftUri.includes("data:application/json;base64,") || resolvedNftUri.startsWith("{"))) {
                        encodedJson = isEncoded ? atob(resolvedNftUri.replace("data:application/json;base64,", "")) : resolvedNftUri;
                        decoded = JSON.parse(encodedJson);
                        return [
                            2,
                            (0, $035d6f689e34d7ad$export$1f4e569649d3a793)({
                                uri: (0, $035d6f689e34d7ad$export$9be3fe34a3333ecb)(decoded),
                                gatewayUrls: gatewayUrls
                            })
                        ];
                    }
                    uriTokenId = nft.tokenID;
                    if (nft.namespace === "erc1155") uriTokenId = uriTokenId.replace("0x", "").padStart(64, "0");
                    return [
                        2,
                        (0, $035d6f689e34d7ad$export$b9759ed161b5e3c5)({
                            gatewayUrls: gatewayUrls,
                            uri: resolvedNftUri.replace(/(?:0x)?{id}/, uriTokenId)
                        })
                    ];
            }
        });
    });
    return $fba2c2ace8e72196$var$_parseNftAvatarUri.apply(this, arguments);
}




var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $c6Xmf = parcelRequire("c6Xmf");

var $eha6O = parcelRequire("eha6O");

var $9ClpR = parcelRequire("9ClpR");

var $itJ66 = parcelRequire("itJ66");

var $cdvyV = parcelRequire("cdvyV");

var $hpqb7 = parcelRequire("hpqb7");

var $f3VZN = parcelRequire("f3VZN");





function $f16202edb526a59f$export$2b2c96dabd62b431(client, _) {
    return $f16202edb526a59f$var$_getEnsText.apply(this, arguments);
}
function $f16202edb526a59f$var$_getEnsText() {
    $f16202edb526a59f$var$_getEnsText = (0, $kSuI9._)(function(client, param) {
        var blockNumber, blockTag, name, key, gatewayUrls, strict, universalResolverAddress_, universalResolverAddress, readContractParameters, readContractAction, res, _tmp, record, err;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    blockNumber = param.blockNumber, blockTag = param.blockTag, name = param.name, key = param.key, gatewayUrls = param.gatewayUrls, strict = param.strict, universalResolverAddress_ = param.universalResolverAddress;
                    universalResolverAddress = universalResolverAddress_;
                    if (!universalResolverAddress) {
                        if (!client.chain) throw new Error("client chain not configured. universalResolverAddress is required.");
                        universalResolverAddress = (0, $hpqb7.getChainContractAddress)({
                            blockNumber: blockNumber,
                            chain: client.chain,
                            contract: "ensUniversalResolver"
                        });
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        ,
                        7
                    ]);
                    readContractParameters = {
                        address: universalResolverAddress,
                        abi: (0, $9ClpR.universalResolverResolveAbi),
                        functionName: "resolve",
                        args: [
                            (0, $f3VZN.toHex)((0, $96800cc462682856$export$8a0899f9ded0844)(name)),
                            (0, $cdvyV.encodeFunctionData)({
                                abi: (0, $9ClpR.textResolverAbi),
                                functionName: "text",
                                args: [
                                    (0, $bf3fd72d115e0f83$export$91d651ee363e1209)(name),
                                    key
                                ]
                            })
                        ],
                        blockNumber: blockNumber,
                        blockTag: blockTag
                    };
                    readContractAction = (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $1500f99f7733ae7a$export$43af7de392176737), "readContract");
                    if (!gatewayUrls) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        readContractAction((0, $cxjpp._)((0, $do9pw._)({}, readContractParameters), {
                            args: (0, $c6Xmf._)(readContractParameters.args).concat([
                                gatewayUrls
                            ])
                        }))
                    ];
                case 2:
                    _tmp = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 3:
                    return [
                        4,
                        readContractAction(readContractParameters)
                    ];
                case 4:
                    _tmp = _state.sent();
                    _state.label = 5;
                case 5:
                    res = _tmp;
                    if (res[0] === "0x") return [
                        2,
                        null
                    ];
                    record = (0, $itJ66.decodeFunctionResult)({
                        abi: (0, $9ClpR.textResolverAbi),
                        functionName: "text",
                        data: res[0]
                    });
                    return [
                        2,
                        record === "" ? null : record
                    ];
                case 6:
                    err = _state.sent();
                    if (strict) throw err;
                    if ((0, $1517027e0fd72fcc$export$78f90e26b9356cd7)(err, "resolve")) return [
                        2,
                        null
                    ];
                    throw err;
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    return $f16202edb526a59f$var$_getEnsText.apply(this, arguments);
}


function $2fb6ebea52500c21$export$65f1d2b9649a54e5(client, _) {
    return $2fb6ebea52500c21$var$_getEnsAvatar.apply(this, arguments);
}
function $2fb6ebea52500c21$var$_getEnsAvatar() {
    $2fb6ebea52500c21$var$_getEnsAvatar = (0, $kSuI9._)(function(client, param) {
        var blockNumber, blockTag, assetGatewayUrls, name, gatewayUrls, strict, universalResolverAddress, record, e;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    blockNumber = param.blockNumber, blockTag = param.blockTag, assetGatewayUrls = param.assetGatewayUrls, name = param.name, gatewayUrls = param.gatewayUrls, strict = param.strict, universalResolverAddress = param.universalResolverAddress;
                    return [
                        4,
                        (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $f16202edb526a59f$export$2b2c96dabd62b431), "getEnsText")({
                            blockNumber: blockNumber,
                            blockTag: blockTag,
                            key: "avatar",
                            name: name,
                            universalResolverAddress: universalResolverAddress,
                            gatewayUrls: gatewayUrls,
                            strict: strict
                        })
                    ];
                case 1:
                    record = _state.sent();
                    if (!record) return [
                        2,
                        null
                    ];
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        (0, $fba2c2ace8e72196$export$3713446b2fba5)(client, {
                            record: record,
                            gatewayUrls: assetGatewayUrls
                        })
                    ];
                case 3:
                    return [
                        2,
                        _state.sent()
                    ];
                case 4:
                    e = _state.sent();
                    return [
                        2,
                        null
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return $2fb6ebea52500c21$var$_getEnsAvatar.apply(this, arguments);
}



function $5ddc98a781ca279f$export$65f1d2b9649a54e5(config, parameters) {
    var chainId = parameters.chainId, rest = (0, $dRLPW._)(parameters, [
        "chainId"
    ]);
    var client = config.getClient({
        chainId: chainId
    });
    var action = (0, $79c54d690e762313$export$6ca3170acb89054)(client, (0, $2fb6ebea52500c21$export$65f1d2b9649a54e5), "getEnsAvatar");
    return action(rest);
}

/** https://wagmi.sh/core/api/actions/watchConnectors */ function $790c49935f6737ac$export$9c8eec0a0da048a0(config, parameters) {
    var onChange = parameters.onChange;
    return config._internal.connectors.subscribe(function(connectors, prevConnectors) {
        onChange(Object.values(connectors), prevConnectors);
    });
}


var $dRLPW = parcelRequire("dRLPW");
/** Forked from https://github.com/epoberezkin/fast-deep-equal */ function $131791f4a2d73743$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    if (a && b && typeof a === "object" && typeof b === "object") {
        if (a.constructor !== b.constructor) return false;
        var length;
        var i;
        if (Array.isArray(a) && Array.isArray(b)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;)if (!$131791f4a2d73743$export$9cb4719e2e525b7a(a[i], b[i])) return false;
            return true;
        }
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        var keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (key && !$131791f4a2d73743$export$9cb4719e2e525b7a(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    // biome-ignore lint/suspicious/noSelfCompare: <explanation>
    return a !== a && b !== b;
}



function $c9f803c524f80d4c$export$30c94aeff2da2ac6(config, parameters) {
    var onChange = parameters.onChange;
    return config.subscribe(function() {
        return (0, $03c83a18d36f49ac$export$4f9234baf34abd0)(config);
    }, onChange, {
        equalityFn: function(a, b) {
            var aConnector = a.connector, aRest = (0, $dRLPW._)(a, [
                "connector"
            ]);
            var bConnector = b.connector, bRest = (0, $dRLPW._)(b, [
                "connector"
            ]);
            return (0, $131791f4a2d73743$export$9cb4719e2e525b7a)(aRest, bRest) && // check connector separately
            (aConnector === null || aConnector === void 0 ? void 0 : aConnector.id) === (bConnector === null || bConnector === void 0 ? void 0 : bConnector.id) && (aConnector === null || aConnector === void 0 ? void 0 : aConnector.uid) === (bConnector === null || bConnector === void 0 ? void 0 : bConnector.uid);
        }
    });
}


var $c6Xmf = parcelRequire("c6Xmf");

var $2e03580ec1c529ae$var$previousConnections = [];
function $2e03580ec1c529ae$export$82b9f8f75cc709b4(config) {
    var connections = (0, $c6Xmf._)(config.state.connections.values());
    if (config.state.status === "reconnecting") return $2e03580ec1c529ae$var$previousConnections;
    if ((0, $131791f4a2d73743$export$9cb4719e2e525b7a)($2e03580ec1c529ae$var$previousConnections, connections)) return $2e03580ec1c529ae$var$previousConnections;
    $2e03580ec1c529ae$var$previousConnections = connections;
    return connections;
}


var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $eha6O = parcelRequire("eha6O");

function $01b64e08bb036827$export$9ccfa7718cb7f8b1(config, parameters) {
    return $01b64e08bb036827$var$_switchAccount.apply(this, arguments);
}
function $01b64e08bb036827$var$_switchAccount() {
    $01b64e08bb036827$var$_switchAccount = (0, $kSuI9._)(function(config, parameters) {
        var _config_storage, connector, connection;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    connector = parameters.connector;
                    connection = config.state.connections.get(connector.uid);
                    if (!connection) throw new (0, $ad7a5f8bd0b5662c$export$d9a3828eace037a6)();
                    return [
                        4,
                        (_config_storage = config.storage) === null || _config_storage === void 0 ? void 0 : _config_storage.setItem("recentConnectorId", connector.id)
                    ];
                case 1:
                    _state.sent();
                    config.setState(function(x) {
                        return (0, $cxjpp._)((0, $do9pw._)({}, x), {
                            current: connector.uid
                        });
                    });
                    return [
                        2,
                        {
                            accounts: connection.accounts,
                            chainId: connection.chainId
                        }
                    ];
            }
        });
    });
    return $01b64e08bb036827$var$_switchAccount.apply(this, arguments);
}


var $dRLPW = parcelRequire("dRLPW");

var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $eha6O = parcelRequire("eha6O");

var $9ClpR = parcelRequire("9ClpR");

var $hpqb7 = parcelRequire("hpqb7");

var $f3VZN = parcelRequire("f3VZN");




function $e151f531924cea99$export$e1b98d9bc05a9fc2(client, _) {
    return $e151f531924cea99$var$_getEnsName.apply(this, arguments);
}
function $e151f531924cea99$var$_getEnsName() {
    $e151f531924cea99$var$_getEnsName = (0, $kSuI9._)(function(client, param) {
        var address, blockNumber, blockTag, gatewayUrls, strict, universalResolverAddress_, universalResolverAddress, reverseNode, readContractParameters, readContractAction, _ref, name, resolvedAddress, _tmp, err;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    address = param.address, blockNumber = param.blockNumber, blockTag = param.blockTag, gatewayUrls = param.gatewayUrls, strict = param.strict, universalResolverAddress_ = param.universalResolverAddress;
                    universalResolverAddress = universalResolverAddress_;
                    if (!universalResolverAddress) {
                        if (!client.chain) throw new Error("client chain not configured. universalResolverAddress is required.");
                        universalResolverAddress = (0, $hpqb7.getChainContractAddress)({
                            blockNumber: blockNumber,
                            chain: client.chain,
                            contract: "ensUniversalResolver"
                        });
                    }
                    reverseNode = "".concat(address.toLowerCase().substring(2), ".addr.reverse");
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        ,
                        7
                    ]);
                    readContractParameters = {
                        address: universalResolverAddress,
                        abi: (0, $9ClpR.universalResolverReverseAbi),
                        functionName: "reverse",
                        args: [
                            (0, $f3VZN.toHex)((0, $96800cc462682856$export$8a0899f9ded0844)(reverseNode))
                        ],
                        blockNumber: blockNumber,
                        blockTag: blockTag
                    };
                    readContractAction = (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $1500f99f7733ae7a$export$43af7de392176737), "readContract");
                    if (!gatewayUrls) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        readContractAction((0, $cxjpp._)((0, $do9pw._)({}, readContractParameters), {
                            args: (0, $c6Xmf._)(readContractParameters.args).concat([
                                gatewayUrls
                            ])
                        }))
                    ];
                case 2:
                    _tmp = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 3:
                    return [
                        4,
                        readContractAction(readContractParameters)
                    ];
                case 4:
                    _tmp = _state.sent();
                    _state.label = 5;
                case 5:
                    _ref = (0, $cv9Rk._).apply(void 0, [
                        _tmp,
                        2
                    ]), name = _ref[0], resolvedAddress = _ref[1];
                    if (address.toLowerCase() !== resolvedAddress.toLowerCase()) return [
                        2,
                        null
                    ];
                    return [
                        2,
                        name
                    ];
                case 6:
                    err = _state.sent();
                    if (strict) throw err;
                    if ((0, $1517027e0fd72fcc$export$78f90e26b9356cd7)(err, "reverse")) return [
                        2,
                        null
                    ];
                    throw err;
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    return $e151f531924cea99$var$_getEnsName.apply(this, arguments);
}



function $8f72e8ecbeb44f2c$export$e1b98d9bc05a9fc2(config, parameters) {
    var chainId = parameters.chainId, rest = (0, $dRLPW._)(parameters, [
        "chainId"
    ]);
    var client = config.getClient({
        chainId: chainId
    });
    var action = (0, $79c54d690e762313$export$6ca3170acb89054)(client, (0, $e151f531924cea99$export$e1b98d9bc05a9fc2), "getEnsName");
    return action(rest);
}


var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $cv9Rk = parcelRequire("cv9Rk");

var $eha6O = parcelRequire("eha6O");

var $fZz5Q = parcelRequire("fZz5Q");
var $itrhm = parcelRequire("itrhm");
var $bi3OS = parcelRequire("bi3OS");
var $4fKM9 = parcelRequire("4fKM9");



var $bRSDw = parcelRequire("bRSDw");
function $1a53554e002748ee$export$65f2564e9a9b9222(unit) {
    if (typeof unit === "number") return unit;
    if (unit === "wei") return 0;
    return Math.abs((0, $bRSDw.weiUnits)[unit]);
}



var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");

var $cv9Rk = parcelRequire("cv9Rk");

var $eha6O = parcelRequire("eha6O");

var $fZz5Q = parcelRequire("fZz5Q");

var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $dRLPW = parcelRequire("dRLPW");

var $eha6O = parcelRequire("eha6O");

var $kSuI9 = parcelRequire("kSuI9");

var $c6Xmf = parcelRequire("c6Xmf");

var $eha6O = parcelRequire("eha6O");

var $9ClpR = parcelRequire("9ClpR");

var $fLalY = parcelRequire("fLalY");

var $7ihh7 = parcelRequire("7ihh7");

var $fZz5Q = parcelRequire("fZz5Q");

var $itJ66 = parcelRequire("itJ66");

var $cdvyV = parcelRequire("cdvyV");

var $hpqb7 = parcelRequire("hpqb7");



function $47b9a12e2fcb3d2a$export$60ef70589ee4f7ad(client, parameters) {
    return $47b9a12e2fcb3d2a$var$_multicall.apply(this, arguments);
}
function $47b9a12e2fcb3d2a$var$_multicall() {
    $47b9a12e2fcb3d2a$var$_multicall = (0, $kSuI9._)(function(client, parameters) {
        var _client_batch, _parameters_allowFailure, allowFailure, batchSize_, blockNumber, blockTag, multicallAddress_, stateOverride, contracts, batchSize, multicallAddress, chunkedCalls, currentChunk, currentChunkSize, i, _contracts_i, abi, address, args, functionName, callData, error, aggregate3Results, results, i1, result, j, aggregate3Result, j1, _aggregate3Result_j, returnData, success, callData1, _contracts_results_length, abi1, address1, functionName1, args1, result1, error1;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _parameters_allowFailure = parameters.allowFailure, allowFailure = _parameters_allowFailure === void 0 ? true : _parameters_allowFailure, batchSize_ = parameters.batchSize, blockNumber = parameters.blockNumber, blockTag = parameters.blockTag, multicallAddress_ = parameters.multicallAddress, stateOverride = parameters.stateOverride;
                    contracts = parameters.contracts;
                    batchSize = batchSize_ !== null && batchSize_ !== void 0 ? batchSize_ : typeof ((_client_batch = client.batch) === null || _client_batch === void 0 ? void 0 : _client_batch.multicall) === "object" && client.batch.multicall.batchSize || 1024;
                    multicallAddress = multicallAddress_;
                    if (!multicallAddress) {
                        if (!client.chain) throw new Error("client chain not configured. multicallAddress is required.");
                        multicallAddress = (0, $hpqb7.getChainContractAddress)({
                            blockNumber: blockNumber,
                            chain: client.chain,
                            contract: "multicall3"
                        });
                    }
                    chunkedCalls = [
                        []
                    ];
                    currentChunk = 0;
                    currentChunkSize = 0;
                    for(i = 0; i < contracts.length; i++){
                        _contracts_i = contracts[i], abi = _contracts_i.abi, address = _contracts_i.address, args = _contracts_i.args, functionName = _contracts_i.functionName;
                        try {
                            callData = (0, $cdvyV.encodeFunctionData)({
                                abi: abi,
                                args: args,
                                functionName: functionName
                            });
                            currentChunkSize += (callData.length - 2) / 2;
                            // Check to see if we need to create a new chunk.
                            if (// Check if batching is enabled.
                            batchSize > 0 && // Check if the current size of the batch exceeds the size limit.
                            currentChunkSize > batchSize && // Check if the current chunk is not already empty.
                            chunkedCalls[currentChunk].length > 0) {
                                currentChunk++;
                                currentChunkSize = (callData.length - 2) / 2;
                                chunkedCalls[currentChunk] = [];
                            }
                            chunkedCalls[currentChunk] = (0, $c6Xmf._)(chunkedCalls[currentChunk]).concat([
                                {
                                    allowFailure: true,
                                    callData: callData,
                                    target: address
                                }
                            ]);
                        } catch (err) {
                            error = (0, $2cf930bd18c2e947$export$4414444aba6ddd8a)(err, {
                                abi: abi,
                                address: address,
                                args: args,
                                docsPath: "/docs/contract/multicall",
                                functionName: functionName
                            });
                            if (!allowFailure) throw error;
                            chunkedCalls[currentChunk] = (0, $c6Xmf._)(chunkedCalls[currentChunk]).concat([
                                {
                                    allowFailure: true,
                                    callData: "0x",
                                    target: address
                                }
                            ]);
                        }
                    }
                    return [
                        4,
                        Promise.allSettled(chunkedCalls.map(function(calls) {
                            return (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $1500f99f7733ae7a$export$43af7de392176737), "readContract")({
                                abi: (0, $9ClpR.multicall3Abi),
                                address: multicallAddress,
                                args: [
                                    calls
                                ],
                                blockNumber: blockNumber,
                                blockTag: blockTag,
                                functionName: "aggregate3",
                                stateOverride: stateOverride
                            });
                        }))
                    ];
                case 1:
                    aggregate3Results = _state.sent();
                    results = [];
                    for(i1 = 0; i1 < aggregate3Results.length; i1++){
                        result = aggregate3Results[i1];
                        // If an error occurred in a `readContract` invocation (ie. network error),
                        // then append the failure reason to each contract result.
                        if (result.status === "rejected") {
                            if (!allowFailure) throw result.reason;
                            for(j = 0; j < chunkedCalls[i1].length; j++)results.push({
                                status: "failure",
                                error: result.reason,
                                result: undefined
                            });
                            continue;
                        }
                        // If the `readContract` call was successful, then decode the results.
                        aggregate3Result = result.value;
                        for(j1 = 0; j1 < aggregate3Result.length; j1++){
                            // Extract the response from `readContract`
                            _aggregate3Result_j = aggregate3Result[j1], returnData = _aggregate3Result_j.returnData, success = _aggregate3Result_j.success;
                            // Extract the request call data from the original call.
                            callData1 = chunkedCalls[i1][j1].callData;
                            // Extract the contract config for this call from the `contracts` argument
                            // for decoding.
                            _contracts_results_length = contracts[results.length], abi1 = _contracts_results_length.abi, address1 = _contracts_results_length.address, functionName1 = _contracts_results_length.functionName, args1 = _contracts_results_length.args;
                            try {
                                if (callData1 === "0x") throw new (0, $fLalY.AbiDecodingZeroDataError)();
                                if (!success) throw new (0, $fZz5Q.RawContractError)({
                                    data: returnData
                                });
                                result1 = (0, $itJ66.decodeFunctionResult)({
                                    abi: abi1,
                                    args: args1,
                                    data: returnData,
                                    functionName: functionName1
                                });
                                results.push(allowFailure ? {
                                    result: result1,
                                    status: "success"
                                } : result1);
                            } catch (err) {
                                error1 = (0, $2cf930bd18c2e947$export$4414444aba6ddd8a)(err, {
                                    abi: abi1,
                                    address: address1,
                                    args: args1,
                                    docsPath: "/docs/contract/multicall",
                                    functionName: functionName1
                                });
                                if (!allowFailure) throw error1;
                                results.push({
                                    error: error1,
                                    result: undefined,
                                    status: "failure"
                                });
                            }
                        }
                    }
                    if (results.length !== contracts.length) throw new (0, $7ihh7.BaseError)("multicall results mismatch");
                    return [
                        2,
                        results
                    ];
            }
        });
    });
    return $47b9a12e2fcb3d2a$var$_multicall.apply(this, arguments);
}



function $f6984a5c5658617f$export$60ef70589ee4f7ad(config, parameters) {
    return $f6984a5c5658617f$var$_multicall.apply(this, arguments);
}
function $f6984a5c5658617f$var$_multicall() {
    $f6984a5c5658617f$var$_multicall = (0, $kSuI9._)(function(config, parameters) {
        var _parameters_allowFailure, allowFailure, chainId, contracts, rest, client, action;
        return (0, $eha6O.__generator)(this, function(_state) {
            _parameters_allowFailure = parameters.allowFailure, allowFailure = _parameters_allowFailure === void 0 ? true : _parameters_allowFailure, chainId = parameters.chainId, contracts = parameters.contracts, rest = (0, $dRLPW._)(parameters, [
                "allowFailure",
                "chainId",
                "contracts"
            ]);
            client = config.getClient({
                chainId: chainId
            });
            action = (0, $79c54d690e762313$export$6ca3170acb89054)(client, (0, $47b9a12e2fcb3d2a$export$60ef70589ee4f7ad), "multicall");
            return [
                2,
                action((0, $do9pw._)({
                    allowFailure: allowFailure,
                    contracts: contracts
                }, rest))
            ];
        });
    });
    return $f6984a5c5658617f$var$_multicall.apply(this, arguments);
}



var $dRLPW = parcelRequire("dRLPW");


function $1a18d167e4c9d292$export$43af7de392176737(config, parameters) {
    var chainId = parameters.chainId, rest = (0, $dRLPW._)(parameters, [
        "chainId"
    ]);
    var client = config.getClient({
        chainId: chainId
    });
    var action = (0, $79c54d690e762313$export$6ca3170acb89054)(client, (0, $1500f99f7733ae7a$export$43af7de392176737), "readContract");
    return action(rest);
}


function $9468f7391927b5cf$export$aa7cd72d27ce4a5(config, parameters) {
    return $9468f7391927b5cf$var$_readContracts.apply(this, arguments);
}
function $9468f7391927b5cf$var$_readContracts() {
    $9468f7391927b5cf$var$_readContracts = (0, $kSuI9._)(function(config, parameters) {
        var _parameters_allowFailure, allowFailure, blockNumber, blockTag, rest, contracts, contractsByChainId, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, index, contract, _contractsByChainId_chainId, _contract_chainId, chainId, promises, multicallResults, resultIndexes, error, promises1;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _parameters_allowFailure = parameters.allowFailure, allowFailure = _parameters_allowFailure === void 0 ? true : _parameters_allowFailure, blockNumber = parameters.blockNumber, blockTag = parameters.blockTag, rest = (0, $dRLPW._)(parameters, [
                        "allowFailure",
                        "blockNumber",
                        "blockTag"
                    ]);
                    contracts = parameters.contracts;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        7
                    ]);
                    contractsByChainId = {};
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = contracts.entries()[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            _step_value = (0, $cv9Rk._)(_step.value, 2), index = _step_value[0], contract = _step_value[1];
                            ;
                            ;
                            chainId = (_contract_chainId = contract.chainId) !== null && _contract_chainId !== void 0 ? _contract_chainId : config.state.chainId;
                            if (!contractsByChainId[chainId]) contractsByChainId[chainId] = [];
                            (_contractsByChainId_chainId = contractsByChainId[chainId]) === null || _contractsByChainId_chainId === void 0 ? void 0 : _contractsByChainId_chainId.push({
                                contract: contract,
                                index: index
                            });
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    promises = function() {
                        return Object.entries(contractsByChainId).map(function(param) {
                            var _param = (0, $cv9Rk._)(param, 2), chainId = _param[0], contracts = _param[1];
                            return (0, $f6984a5c5658617f$export$60ef70589ee4f7ad)(config, (0, $cxjpp._)((0, $do9pw._)({}, rest), {
                                allowFailure: allowFailure,
                                blockNumber: blockNumber,
                                blockTag: blockTag,
                                chainId: Number.parseInt(chainId),
                                contracts: contracts.map(function(param) {
                                    var contract = param.contract;
                                    return contract;
                                })
                            }));
                        });
                    };
                    return [
                        4,
                        Promise.all(promises())
                    ];
                case 2:
                    multicallResults = _state.sent().flat();
                    // Reorder the contract results back to the order they were
                    // provided in.
                    resultIndexes = Object.values(contractsByChainId).flatMap(function(contracts) {
                        return contracts.map(function(param) {
                            var index = param.index;
                            return index;
                        });
                    });
                    return [
                        2,
                        multicallResults.reduce(function(results, result, index) {
                            if (results) results[resultIndexes[index]] = result;
                            return results;
                        }, [])
                    ];
                case 3:
                    error = _state.sent();
                    if (error instanceof (0, $fZz5Q.ContractFunctionExecutionError)) throw error;
                    promises1 = function() {
                        return contracts.map(function(contract) {
                            return (0, $1a18d167e4c9d292$export$43af7de392176737)(config, (0, $cxjpp._)((0, $do9pw._)({}, contract), {
                                blockNumber: blockNumber,
                                blockTag: blockTag
                            }));
                        });
                    };
                    if (!allowFailure) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        Promise.allSettled(promises1())
                    ];
                case 4:
                    return [
                        2,
                        _state.sent().map(function(result) {
                            if (result.status === "fulfilled") return {
                                result: result.value,
                                status: "success"
                            };
                            return {
                                error: result.reason,
                                result: undefined,
                                status: "failure"
                            };
                        })
                    ];
                case 5:
                    return [
                        4,
                        Promise.all(promises1())
                    ];
                case 6:
                    return [
                        2,
                        _state.sent()
                    ];
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    return $9468f7391927b5cf$var$_readContracts.apply(this, arguments);
}


function $97cc5aab3d18b888$export$df96cd8d56be0ab1(config, parameters) {
    return $97cc5aab3d18b888$var$_getBalance.apply(this, arguments);
}
function $97cc5aab3d18b888$var$_getBalance() {
    $97cc5aab3d18b888$var$_getBalance = (0, $kSuI9._)(function(config, parameters) {
        var address, blockNumber, blockTag, chainId, tokenAddress, _parameters_unit, unit, error, balance, symbol, client, action, value, _config_chains_find, chain;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    address = parameters.address, blockNumber = parameters.blockNumber, blockTag = parameters.blockTag, chainId = parameters.chainId, tokenAddress = parameters.token, _parameters_unit = parameters.unit, unit = _parameters_unit === void 0 ? "ether" : _parameters_unit;
                    if (!tokenAddress) return [
                        3,
                        5
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        2,
                        ,
                        5
                    ]);
                    return [
                        2,
                        $97cc5aab3d18b888$var$getTokenBalance(config, {
                            balanceAddress: address,
                            chainId: chainId,
                            symbolType: "string",
                            tokenAddress: tokenAddress
                        })
                    ];
                case 2:
                    error = _state.sent();
                    if (!(error instanceof (0, $fZz5Q.ContractFunctionExecutionError))) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        $97cc5aab3d18b888$var$getTokenBalance(config, {
                            balanceAddress: address,
                            chainId: chainId,
                            symbolType: "bytes32",
                            tokenAddress: tokenAddress
                        })
                    ];
                case 3:
                    balance = _state.sent();
                    symbol = (0, $itrhm.hexToString)((0, $bi3OS.trim)(balance.symbol, {
                        dir: "right"
                    }));
                    return [
                        2,
                        (0, $cxjpp._)((0, $do9pw._)({}, balance), {
                            symbol: symbol
                        })
                    ];
                case 4:
                    throw error;
                case 5:
                    client = config.getClient({
                        chainId: chainId
                    });
                    action = (0, $79c54d690e762313$export$6ca3170acb89054)(client, (0, $179cf38efbf30cf7$export$df96cd8d56be0ab1), "getBalance");
                    return [
                        4,
                        action(blockNumber ? {
                            address: address,
                            blockNumber: blockNumber
                        } : {
                            address: address,
                            blockTag: blockTag
                        })
                    ];
                case 6:
                    value = _state.sent();
                    chain = (_config_chains_find = config.chains.find(function(x) {
                        return x.id === chainId;
                    })) !== null && _config_chains_find !== void 0 ? _config_chains_find : client.chain;
                    return [
                        2,
                        {
                            decimals: chain.nativeCurrency.decimals,
                            formatted: (0, $4fKM9.formatUnits)(value, (0, $1a53554e002748ee$export$65f2564e9a9b9222)(unit)),
                            symbol: chain.nativeCurrency.symbol,
                            value: value
                        }
                    ];
            }
        });
    });
    return $97cc5aab3d18b888$var$_getBalance.apply(this, arguments);
}
function $97cc5aab3d18b888$var$getTokenBalance(config, parameters) {
    return $97cc5aab3d18b888$var$_getTokenBalance.apply(this, arguments);
}
function $97cc5aab3d18b888$var$_getTokenBalance() {
    $97cc5aab3d18b888$var$_getTokenBalance = (0, $kSuI9._)(function(config, parameters) {
        var balanceAddress, chainId, symbolType, tokenAddress, unit, contract, _ref, value, decimals, symbol, formatted;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    balanceAddress = parameters.balanceAddress, chainId = parameters.chainId, symbolType = parameters.symbolType, tokenAddress = parameters.tokenAddress, unit = parameters.unit;
                    contract = {
                        abi: [
                            {
                                type: "function",
                                name: "balanceOf",
                                stateMutability: "view",
                                inputs: [
                                    {
                                        type: "address"
                                    }
                                ],
                                outputs: [
                                    {
                                        type: "uint256"
                                    }
                                ]
                            },
                            {
                                type: "function",
                                name: "decimals",
                                stateMutability: "view",
                                inputs: [],
                                outputs: [
                                    {
                                        type: "uint8"
                                    }
                                ]
                            },
                            {
                                type: "function",
                                name: "symbol",
                                stateMutability: "view",
                                inputs: [],
                                outputs: [
                                    {
                                        type: symbolType
                                    }
                                ]
                            }
                        ],
                        address: tokenAddress
                    };
                    return [
                        4,
                        (0, $9468f7391927b5cf$export$aa7cd72d27ce4a5)(config, {
                            allowFailure: false,
                            contracts: [
                                (0, $cxjpp._)((0, $do9pw._)({}, contract), {
                                    functionName: "balanceOf",
                                    args: [
                                        balanceAddress
                                    ],
                                    chainId: chainId
                                }),
                                (0, $cxjpp._)((0, $do9pw._)({}, contract), {
                                    functionName: "decimals",
                                    chainId: chainId
                                }),
                                (0, $cxjpp._)((0, $do9pw._)({}, contract), {
                                    functionName: "symbol",
                                    chainId: chainId
                                })
                            ]
                        })
                    ];
                case 1:
                    _ref = (0, $cv9Rk._).apply(void 0, [
                        _state.sent(),
                        3
                    ]), value = _ref[0], decimals = _ref[1], symbol = _ref[2];
                    formatted = (0, $4fKM9.formatUnits)(value !== null && value !== void 0 ? value : "0", (0, $1a53554e002748ee$export$65f2564e9a9b9222)(unit !== null && unit !== void 0 ? unit : decimals));
                    return [
                        2,
                        {
                            decimals: decimals,
                            formatted: formatted,
                            symbol: symbol,
                            value: value
                        }
                    ];
            }
        });
    });
    return $97cc5aab3d18b888$var$_getTokenBalance.apply(this, arguments);
}



/**
 * Multiplies a string representation of a number by a given exponent of base 10 (10exponent).
 *
 * - Docs: https://viem.sh/docs/utilities/parseUnits
 *
 * @example
 * import { parseUnits } from 'viem'
 *
 * parseUnits('420', 9)
 * // 420000000000n
 */ 
var $cv9Rk = parcelRequire("cv9Rk");
function $5e268930465d8d42$export$203ae30b4f6490b3(value, decimals) {
    var _value_split = (0, $cv9Rk._)(value.split("."), 2), integer = _value_split[0], tmp = _value_split[1], fraction = tmp === void 0 ? "0" : tmp;
    var negative = integer.startsWith("-");
    if (negative) integer = integer.slice(1);
    // trim trailing zeros.
    fraction = fraction.replace(/(0+)$/, "");
    // round off if the fraction is larger than the number of decimals.
    if (decimals === 0) {
        if (Math.round(Number(".".concat(fraction))) === 1) integer = "".concat(BigInt(integer) + 1n);
        fraction = "";
    } else if (fraction.length > decimals) {
        var _ref = [
            fraction.slice(0, decimals - 1),
            fraction.slice(decimals - 1, decimals),
            fraction.slice(decimals)
        ], left = _ref[0], unit = _ref[1], right = _ref[2];
        var rounded = Math.round(Number("".concat(unit, ".").concat(right)));
        if (rounded > 9) fraction = "".concat(BigInt(left) + BigInt(1), "0").padStart(left.length + 1, "0");
        else fraction = "".concat(left).concat(rounded);
        if (fraction.length > decimals) {
            fraction = fraction.slice(1);
            integer = "".concat(BigInt(integer) + 1n);
        }
        fraction = fraction.slice(0, decimals);
    } else fraction = fraction.padEnd(decimals, "0");
    return BigInt("".concat(negative ? "-" : "").concat(integer).concat(fraction));
}


var $4fKM9 = parcelRequire("4fKM9");

parcelRequire("dSKxG");
var $3QZC1 = parcelRequire("3QZC1");
var $fcokf = parcelRequire("fcokf");

var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");
parcelRequire("dSKxG");
var $3QZC1 = parcelRequire("3QZC1");



var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $3sHb8 = parcelRequire("3sHb8");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $l0HdX = parcelRequire("l0HdX");

var $eha6O = parcelRequire("eha6O");

var $3ngRt = parcelRequire("3ngRt");

var $4BEBs = parcelRequire("4BEBs");
var $80dd9d4bfedfabd3$exports = {};
"use strict";
Object.defineProperty($80dd9d4bfedfabd3$exports, "__esModule", {
    value: true
});
$80dd9d4bfedfabd3$exports.getLocalStorage = $80dd9d4bfedfabd3$exports.getLocalStorageOrThrow = $80dd9d4bfedfabd3$exports.getCrypto = $80dd9d4bfedfabd3$exports.getCryptoOrThrow = $80dd9d4bfedfabd3$exports.getLocation = $80dd9d4bfedfabd3$exports.getLocationOrThrow = $80dd9d4bfedfabd3$exports.getNavigator = $80dd9d4bfedfabd3$exports.getNavigatorOrThrow = $80dd9d4bfedfabd3$exports.getDocument = $80dd9d4bfedfabd3$exports.getDocumentOrThrow = $80dd9d4bfedfabd3$exports.getFromWindowOrThrow = $80dd9d4bfedfabd3$exports.getFromWindow = void 0;
function $80dd9d4bfedfabd3$var$getFromWindow(name) {
    var res = undefined;
    if (typeof window !== "undefined" && typeof window[name] !== "undefined") res = window[name];
    return res;
}
$80dd9d4bfedfabd3$exports.getFromWindow = $80dd9d4bfedfabd3$var$getFromWindow;
function $80dd9d4bfedfabd3$var$getFromWindowOrThrow(name) {
    var res = $80dd9d4bfedfabd3$var$getFromWindow(name);
    if (!res) throw new Error("".concat(name, " is not defined in Window"));
    return res;
}
$80dd9d4bfedfabd3$exports.getFromWindowOrThrow = $80dd9d4bfedfabd3$var$getFromWindowOrThrow;
function $80dd9d4bfedfabd3$var$getDocumentOrThrow() {
    return $80dd9d4bfedfabd3$var$getFromWindowOrThrow("document");
}
$80dd9d4bfedfabd3$exports.getDocumentOrThrow = $80dd9d4bfedfabd3$var$getDocumentOrThrow;
function $80dd9d4bfedfabd3$var$getDocument() {
    return $80dd9d4bfedfabd3$var$getFromWindow("document");
}
$80dd9d4bfedfabd3$exports.getDocument = $80dd9d4bfedfabd3$var$getDocument;
function $80dd9d4bfedfabd3$var$getNavigatorOrThrow() {
    return $80dd9d4bfedfabd3$var$getFromWindowOrThrow("navigator");
}
$80dd9d4bfedfabd3$exports.getNavigatorOrThrow = $80dd9d4bfedfabd3$var$getNavigatorOrThrow;
function $80dd9d4bfedfabd3$var$getNavigator() {
    return $80dd9d4bfedfabd3$var$getFromWindow("navigator");
}
$80dd9d4bfedfabd3$exports.getNavigator = $80dd9d4bfedfabd3$var$getNavigator;
function $80dd9d4bfedfabd3$var$getLocationOrThrow() {
    return $80dd9d4bfedfabd3$var$getFromWindowOrThrow("location");
}
$80dd9d4bfedfabd3$exports.getLocationOrThrow = $80dd9d4bfedfabd3$var$getLocationOrThrow;
function $80dd9d4bfedfabd3$var$getLocation() {
    return $80dd9d4bfedfabd3$var$getFromWindow("location");
}
$80dd9d4bfedfabd3$exports.getLocation = $80dd9d4bfedfabd3$var$getLocation;
function $80dd9d4bfedfabd3$var$getCryptoOrThrow() {
    return $80dd9d4bfedfabd3$var$getFromWindowOrThrow("crypto");
}
$80dd9d4bfedfabd3$exports.getCryptoOrThrow = $80dd9d4bfedfabd3$var$getCryptoOrThrow;
function $80dd9d4bfedfabd3$var$getCrypto() {
    return $80dd9d4bfedfabd3$var$getFromWindow("crypto");
}
$80dd9d4bfedfabd3$exports.getCrypto = $80dd9d4bfedfabd3$var$getCrypto;
function $80dd9d4bfedfabd3$var$getLocalStorageOrThrow() {
    return $80dd9d4bfedfabd3$var$getFromWindowOrThrow("localStorage");
}
$80dd9d4bfedfabd3$exports.getLocalStorageOrThrow = $80dd9d4bfedfabd3$var$getLocalStorageOrThrow;
function $80dd9d4bfedfabd3$var$getLocalStorage() {
    return $80dd9d4bfedfabd3$var$getFromWindow("localStorage");
}
$80dd9d4bfedfabd3$exports.getLocalStorage = $80dd9d4bfedfabd3$var$getLocalStorage;


var $662e373d3cd182b8$exports = {};

var $l0HdX = parcelRequire("l0HdX");
"use strict";
Object.defineProperty($662e373d3cd182b8$exports, "__esModule", {
    value: true
});
$662e373d3cd182b8$exports.getWindowMetadata = void 0;

function $662e373d3cd182b8$var$getWindowMetadata() {
    var doc;
    var loc;
    try {
        doc = $80dd9d4bfedfabd3$exports.getDocumentOrThrow();
        loc = $80dd9d4bfedfabd3$exports.getLocationOrThrow();
    } catch (e) {
        return null;
    }
    function getIcons() {
        var links = doc.getElementsByTagName("link");
        var icons = [];
        for(var i = 0; i < links.length; i++){
            var link = links[i];
            var rel = link.getAttribute("rel");
            if (rel) {
                if (rel.toLowerCase().indexOf("icon") > -1) {
                    var href = link.getAttribute("href");
                    if (href) {
                        if (href.toLowerCase().indexOf("https:") === -1 && href.toLowerCase().indexOf("http:") === -1 && href.indexOf("//") !== 0) {
                            var absoluteHref = loc.protocol + "//" + loc.host;
                            if (href.indexOf("/") === 0) absoluteHref += href;
                            else {
                                var path = loc.pathname.split("/");
                                path.pop();
                                var finalPath = path.join("/");
                                absoluteHref += finalPath + "/" + href;
                            }
                            icons.push(absoluteHref);
                        } else if (href.indexOf("//") === 0) {
                            var absoluteUrl = loc.protocol + href;
                            icons.push(absoluteUrl);
                        } else icons.push(href);
                    }
                }
            }
        }
        return icons;
    }
    function getWindowMetadataOfAny() {
        var _loop = function(i) {
            var tag = metaTags[i];
            var attributes = [
                "itemprop",
                "property",
                "name"
            ].map(function(target) {
                return tag.getAttribute(target);
            }).filter(function(attr) {
                if (attr) return args.includes(attr);
                return false;
            });
            if (attributes.length && attributes) {
                var content = tag.getAttribute("content");
                if (content) return {
                    v: content
                };
            }
        };
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var metaTags = doc.getElementsByTagName("meta");
        for(var i = 0; i < metaTags.length; i++){
            var _ret = _loop(i);
            if ((0, $l0HdX._)(_ret) === "object") return _ret.v;
        }
        return "";
    }
    function getName() {
        var name = getWindowMetadataOfAny("name", "og:site_name", "og:title", "twitter:title");
        if (!name) name = doc.title;
        return name;
    }
    function getDescription() {
        var description = getWindowMetadataOfAny("description", "og:description", "twitter:description", "keywords");
        return description;
    }
    var name = getName();
    var description = getDescription();
    var url = loc.origin;
    var icons = getIcons();
    var meta = {
        description: description,
        url: url,
        icons: icons,
        name: name
    };
    return meta;
}
$662e373d3cd182b8$exports.getWindowMetadata = $662e373d3cd182b8$var$getWindowMetadata;



var $hDCWT = parcelRequire("hDCWT");

var $1MbOp = parcelRequire("1MbOp");

var $atJCh = parcelRequire("atJCh");

var $5A0yG = parcelRequire("5A0yG");

var $27vAG = parcelRequire("27vAG");

var $1fnK2 = parcelRequire("1fnK2");
parcelRequire("7Ft2D");
var $ewlTP = parcelRequire("ewlTP");
var $l7Yp4 = parcelRequire("l7Yp4");
var $lQfAa = parcelRequire("lQfAa");

var $l0HdX = parcelRequire("l0HdX");
function $4b5f6a83d1361b5a$var$e(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "string";
    if (!s[r] || (0, $l0HdX._)(s[r]) !== i) throw new Error('Missing or invalid "'.concat(r, '" param'));
}
function $4b5f6a83d1361b5a$var$l(s, r) {
    var i = !0;
    return r.forEach(function(t) {
        t in s || (i = !1);
    }), i;
}
function $4b5f6a83d1361b5a$var$f(s, r) {
    return Array.isArray(s) ? s.length === r : Object.keys(s).length === r;
}
function $4b5f6a83d1361b5a$var$w(s, r) {
    return Array.isArray(s) ? s.length >= r : Object.keys(s).length >= r;
}
function $4b5f6a83d1361b5a$var$u(s, r, i) {
    return (i.length ? $4b5f6a83d1361b5a$var$w(s, r.length) : $4b5f6a83d1361b5a$var$f(s, r.length)) ? $4b5f6a83d1361b5a$var$l(s, r) : !1;
}
function $4b5f6a83d1361b5a$var$n(s, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "_";
    var t = s.split(i);
    return t[t.length - 1].trim().toLowerCase() === r.trim().toLowerCase();
}
function $4b5f6a83d1361b5a$export$c75580565fa025bd(s) {
    return $4b5f6a83d1361b5a$export$f576347163de0984(s.method) && $4b5f6a83d1361b5a$export$dae2311546d43680(s.params);
}
function $4b5f6a83d1361b5a$export$f576347163de0984(s) {
    return $4b5f6a83d1361b5a$var$n(s, "subscribe");
}
function $4b5f6a83d1361b5a$export$dae2311546d43680(s) {
    return $4b5f6a83d1361b5a$var$u(s, [
        "topic"
    ], []);
}
function $4b5f6a83d1361b5a$export$8fa7cf76b41caee0(s) {
    return $4b5f6a83d1361b5a$export$71d4d33ac7f7a269(s.method) && $4b5f6a83d1361b5a$export$71e8d1aa48c3e86f(s.params);
}
function $4b5f6a83d1361b5a$export$71d4d33ac7f7a269(s) {
    return $4b5f6a83d1361b5a$var$n(s, "publish");
}
function $4b5f6a83d1361b5a$export$71e8d1aa48c3e86f(s) {
    return $4b5f6a83d1361b5a$var$u(s, [
        "message",
        "topic",
        "ttl"
    ], [
        "prompt",
        "tag"
    ]);
}
function $4b5f6a83d1361b5a$export$83e292763180b41b(s) {
    return $4b5f6a83d1361b5a$export$568d956f39536025(s.method) && $4b5f6a83d1361b5a$export$cbc597c53c3b4f80(s.params);
}
function $4b5f6a83d1361b5a$export$568d956f39536025(s) {
    return $4b5f6a83d1361b5a$var$n(s, "unsubscribe");
}
function $4b5f6a83d1361b5a$export$cbc597c53c3b4f80(s) {
    return $4b5f6a83d1361b5a$var$u(s, [
        "id",
        "topic"
    ], []);
}
function $4b5f6a83d1361b5a$export$43cf4100d6287b8e(s) {
    return $4b5f6a83d1361b5a$export$3cb4ad320e3a46a4(s.method) && $4b5f6a83d1361b5a$export$6366ff9a39f2da4c(s.params);
}
function $4b5f6a83d1361b5a$export$3cb4ad320e3a46a4(s) {
    return $4b5f6a83d1361b5a$var$n(s, "subscription");
}
function $4b5f6a83d1361b5a$export$6366ff9a39f2da4c(s) {
    return $4b5f6a83d1361b5a$var$u(s, [
        "id",
        "data"
    ], []);
}
function $4b5f6a83d1361b5a$export$abdf96c288cb375(s) {
    if (!$4b5f6a83d1361b5a$export$f576347163de0984(s.method)) throw new Error("JSON-RPC Request has invalid subscribe method");
    if (!$4b5f6a83d1361b5a$export$dae2311546d43680(s.params)) throw new Error("JSON-RPC Request has invalid subscribe params");
    var r = s.params;
    return $4b5f6a83d1361b5a$var$e(r, "topic"), r;
}
function $4b5f6a83d1361b5a$export$eac3e45ac5c5c9fa(s) {
    if (!$4b5f6a83d1361b5a$export$71d4d33ac7f7a269(s.method)) throw new Error("JSON-RPC Request has invalid publish method");
    if (!$4b5f6a83d1361b5a$export$71e8d1aa48c3e86f(s.params)) throw new Error("JSON-RPC Request has invalid publish params");
    var r = s.params;
    return $4b5f6a83d1361b5a$var$e(r, "topic"), $4b5f6a83d1361b5a$var$e(r, "message"), $4b5f6a83d1361b5a$var$e(r, "ttl", "number"), r;
}
function $4b5f6a83d1361b5a$export$78baa72f78156594(s) {
    if (!$4b5f6a83d1361b5a$export$568d956f39536025(s.method)) throw new Error("JSON-RPC Request has invalid unsubscribe method");
    if (!$4b5f6a83d1361b5a$export$cbc597c53c3b4f80(s.params)) throw new Error("JSON-RPC Request has invalid unsubscribe params");
    var r = s.params;
    return $4b5f6a83d1361b5a$var$e(r, "id"), r;
}
function $4b5f6a83d1361b5a$export$4d5822edd41f3b48(s) {
    if (!$4b5f6a83d1361b5a$export$3cb4ad320e3a46a4(s.method)) throw new Error("JSON-RPC Request has invalid subscription method");
    if (!$4b5f6a83d1361b5a$export$6366ff9a39f2da4c(s.params)) throw new Error("JSON-RPC Request has invalid subscription params");
    var r = s.params;
    return $4b5f6a83d1361b5a$var$e(r, "id"), $4b5f6a83d1361b5a$var$e(r, "data"), r;
}
var $4b5f6a83d1361b5a$export$af490b3b9a6de00f = {
    waku: {
        publish: "waku_publish",
        batchPublish: "waku_batchPublish",
        subscribe: "waku_subscribe",
        batchSubscribe: "waku_batchSubscribe",
        subscription: "waku_subscription",
        unsubscribe: "waku_unsubscribe",
        batchUnsubscribe: "waku_batchUnsubscribe",
        batchFetchMessages: "waku_batchFetchMessages"
    },
    irn: {
        publish: "irn_publish",
        batchPublish: "irn_batchPublish",
        subscribe: "irn_subscribe",
        batchSubscribe: "irn_batchSubscribe",
        subscription: "irn_subscription",
        unsubscribe: "irn_unsubscribe",
        batchUnsubscribe: "irn_batchUnsubscribe",
        batchFetchMessages: "irn_batchFetchMessages"
    },
    iridium: {
        publish: "iridium_publish",
        batchPublish: "iridium_batchPublish",
        subscribe: "iridium_subscribe",
        batchSubscribe: "iridium_batchSubscribe",
        subscription: "iridium_subscription",
        unsubscribe: "iridium_unsubscribe",
        batchUnsubscribe: "iridium_batchUnsubscribe",
        batchFetchMessages: "iridium_batchFetchMessages"
    }
};



var $3qWgZ = parcelRequire("3qWgZ");

var $8dlmd = parcelRequire("8dlmd");
var $4e7e1af11ea066d2$require$Buffer = $8dlmd.Buffer;
var $4e7e1af11ea066d2$var$Ir = ":";
function $4e7e1af11ea066d2$export$4764229d78de4437(e) {
    var _e_split = (0, $cv9Rk._)(e.split($4e7e1af11ea066d2$var$Ir), 2), t = _e_split[0], r = _e_split[1];
    return {
        namespace: t,
        reference: r
    };
}
function $4e7e1af11ea066d2$export$a5999672e4930644(e) {
    var t = e.namespace, r = e.reference;
    return [
        t,
        r
    ].join($4e7e1af11ea066d2$var$Ir);
}
function $4e7e1af11ea066d2$export$276ab0158c66e3d(e) {
    var _e_split = (0, $cv9Rk._)(e.split($4e7e1af11ea066d2$var$Ir), 3), t = _e_split[0], r = _e_split[1], i = _e_split[2];
    return {
        namespace: t,
        reference: r,
        address: i
    };
}
function $4e7e1af11ea066d2$export$566a25328fb93a18(e) {
    var t = e.namespace, r = e.reference, i = e.address;
    return [
        t,
        r,
        i
    ].join($4e7e1af11ea066d2$var$Ir);
}
function $4e7e1af11ea066d2$export$d579bc26e95946b5(e, t) {
    var r = [];
    return e.forEach(function(i) {
        var n = t(i);
        r.includes(n) || r.push(n);
    }), r;
}
function $4e7e1af11ea066d2$export$2806d446053abd1d(e) {
    var _ci = $4e7e1af11ea066d2$export$276ab0158c66e3d(e), t = _ci.address;
    return t;
}
function $4e7e1af11ea066d2$export$93512919ec2ab555(e) {
    var _ci = $4e7e1af11ea066d2$export$276ab0158c66e3d(e), t = _ci.namespace, r = _ci.reference;
    return $4e7e1af11ea066d2$export$a5999672e4930644({
        namespace: t,
        reference: r
    });
}
function $4e7e1af11ea066d2$export$40283ddc77f27f6e(e, t) {
    var _dn = $4e7e1af11ea066d2$export$4764229d78de4437(t), r = _dn.namespace, i = _dn.reference;
    return $4e7e1af11ea066d2$export$566a25328fb93a18({
        namespace: r,
        reference: i,
        address: e
    });
}
function $4e7e1af11ea066d2$export$aa4a6b630dfcfa83(e) {
    return $4e7e1af11ea066d2$export$d579bc26e95946b5(e, $4e7e1af11ea066d2$export$2806d446053abd1d);
}
function $4e7e1af11ea066d2$export$d5ee58c6b13696e9(e) {
    return $4e7e1af11ea066d2$export$d579bc26e95946b5(e, $4e7e1af11ea066d2$export$93512919ec2ab555);
}
function $4e7e1af11ea066d2$export$23329703ad972840(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var r = [];
    return Object.keys(e).forEach(function(i) {
        var _r;
        if (t.length && !t.includes(i)) return;
        var n = e[i];
        (_r = r).push.apply(_r, (0, $c6Xmf._)(n.accounts));
    }), r;
}
function $4e7e1af11ea066d2$export$6281ff29da5f85fe(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var r = [];
    return Object.keys(e).forEach(function(i) {
        var _r;
        if (t.length && !t.includes(i)) return;
        var n = e[i];
        (_r = r).push.apply(_r, (0, $c6Xmf._)($4e7e1af11ea066d2$export$d5ee58c6b13696e9(n.accounts)));
    }), r;
}
function $4e7e1af11ea066d2$export$d1109eeb751412cf(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var r = [];
    return Object.keys(e).forEach(function(i) {
        var _$_r;
        if (t.length && !t.includes(i)) return;
        var n = e[i];
        (_$_r = r).push.apply(_$_r, (0, $c6Xmf._)($4e7e1af11ea066d2$export$376384387cd15b27(i, n)));
    }), r;
}
function $4e7e1af11ea066d2$export$376384387cd15b27(e, t) {
    return e.includes(":") ? [
        e
    ] : t.chains || [];
}
var $4e7e1af11ea066d2$var$Qo = Object.defineProperty, $4e7e1af11ea066d2$var$bn = Object.getOwnPropertySymbols, $4e7e1af11ea066d2$var$Jo = Object.prototype.hasOwnProperty, $4e7e1af11ea066d2$var$Go = Object.prototype.propertyIsEnumerable, $4e7e1af11ea066d2$var$yn = function(e, t, r) {
    return t in e ? $4e7e1af11ea066d2$var$Qo(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r;
}, $4e7e1af11ea066d2$var$wn = function(e, t) {
    for(var r in t || (t = {}))$4e7e1af11ea066d2$var$Jo.call(t, r) && $4e7e1af11ea066d2$var$yn(e, r, t[r]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($4e7e1af11ea066d2$var$bn) try {
        for(var _iterator = $4e7e1af11ea066d2$var$bn(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var r = _step.value;
            $4e7e1af11ea066d2$var$Go.call(t, r) && $4e7e1af11ea066d2$var$yn(e, r, t[r]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return e;
};
var $4e7e1af11ea066d2$export$f12873d77424d47b = "ReactNative", $4e7e1af11ea066d2$export$86b1301a63b15dd9 = {
    reactNative: "react-native",
    node: "node",
    browser: "browser",
    unknown: "unknown"
}, $4e7e1af11ea066d2$export$657dee6d5648750a = " ", $4e7e1af11ea066d2$export$96c3628b3b9d2079 = ":", $4e7e1af11ea066d2$export$98238152dfccf046 = "/", $4e7e1af11ea066d2$export$7f882bb969de14a3 = 2, $4e7e1af11ea066d2$export$77baccb4c6bd5852 = 1e3, $4e7e1af11ea066d2$export$e08b61c98317d88c = "js";
function $4e7e1af11ea066d2$export$8ee0fc9ee280b4ee() {
    return (typeof $3qWgZ === "undefined" ? "undefined" : (0, $l0HdX._)($3qWgZ)) < "u" && (0, $l0HdX._)($3qWgZ.versions) < "u" && (0, $l0HdX._)($3qWgZ.versions.node) < "u";
}
function $4e7e1af11ea066d2$export$f7a1e23e542d38e3() {
    return !(0, $80dd9d4bfedfabd3$exports.getDocument)() && !!(0, $80dd9d4bfedfabd3$exports.getNavigator)() && navigator.product === $4e7e1af11ea066d2$export$f12873d77424d47b;
}
function $4e7e1af11ea066d2$export$4e09c449d6c407f7() {
    return !$4e7e1af11ea066d2$export$8ee0fc9ee280b4ee() && !!(0, $80dd9d4bfedfabd3$exports.getNavigator)() && !!(0, $80dd9d4bfedfabd3$exports.getDocument)();
}
function $4e7e1af11ea066d2$export$57570b1603cf6adb() {
    return $4e7e1af11ea066d2$export$f7a1e23e542d38e3() ? $4e7e1af11ea066d2$export$86b1301a63b15dd9.reactNative : $4e7e1af11ea066d2$export$8ee0fc9ee280b4ee() ? $4e7e1af11ea066d2$export$86b1301a63b15dd9.node : $4e7e1af11ea066d2$export$4e09c449d6c407f7() ? $4e7e1af11ea066d2$export$86b1301a63b15dd9.browser : $4e7e1af11ea066d2$export$86b1301a63b15dd9.unknown;
}
function $4e7e1af11ea066d2$export$40a40f90174d197c() {
    var e;
    try {
        return $4e7e1af11ea066d2$export$f7a1e23e542d38e3() && (typeof $parcel$global === "undefined" ? "undefined" : (0, $l0HdX._)($parcel$global)) < "u" && (0, $l0HdX._)($parcel$global == null ? void 0 : $parcel$global.Application) < "u" ? (e = $parcel$global.Application) == null ? void 0 : e.applicationId : void 0;
    } catch (e) {
        return;
    }
}
function $4e7e1af11ea066d2$export$c4147c69f6845da(e, t) {
    var r = $hDCWT.parse(e);
    return r = $4e7e1af11ea066d2$var$wn($4e7e1af11ea066d2$var$wn({}, r), t), e = $hDCWT.stringify(r), e;
}
function $4e7e1af11ea066d2$export$ba31e015127122bb() {
    return (0, $662e373d3cd182b8$exports.getWindowMetadata)() || {
        name: "",
        description: "",
        url: "",
        icons: [
            ""
        ]
    };
}
function $4e7e1af11ea066d2$export$6b05aa0115b6fc2d(e, t) {
    var r;
    var i = $4e7e1af11ea066d2$export$57570b1603cf6adb(), n = {
        protocol: e,
        version: t,
        env: i
    };
    return i === "browser" && (n.host = ((r = (0, $80dd9d4bfedfabd3$exports.getLocation)()) == null ? void 0 : r.host) || "unknown"), n;
}
function $4e7e1af11ea066d2$export$20d4a3cb5829b8b6() {
    if ($4e7e1af11ea066d2$export$57570b1603cf6adb() === $4e7e1af11ea066d2$export$86b1301a63b15dd9.reactNative && (typeof $parcel$global === "undefined" ? "undefined" : (0, $l0HdX._)($parcel$global)) < "u" && (0, $l0HdX._)($parcel$global == null ? void 0 : $parcel$global.Platform) < "u") {
        var _global_Platform = $parcel$global.Platform, r = _global_Platform.OS, i = _global_Platform.Version;
        return [
            r,
            i
        ].join("-");
    }
    var e = (0, $3ngRt.detect)();
    if (e === null) return "unknown";
    var t = e.os ? e.os.replace(" ", "").toLowerCase() : "unknown";
    return e.type === "browser" ? [
        t,
        e.name,
        e.version
    ].join("-") : [
        t,
        e.version
    ].join("-");
}
function $4e7e1af11ea066d2$export$4389b0987726d52d() {
    var e;
    var t = $4e7e1af11ea066d2$export$57570b1603cf6adb();
    return t === $4e7e1af11ea066d2$export$86b1301a63b15dd9.browser ? [
        t,
        ((e = (0, $80dd9d4bfedfabd3$exports.getLocation)()) == null ? void 0 : e.host) || "unknown"
    ].join(":") : t;
}
function $4e7e1af11ea066d2$export$b55a4c6e272b719f(e, t, r) {
    var i = $4e7e1af11ea066d2$export$20d4a3cb5829b8b6(), n = $4e7e1af11ea066d2$export$4389b0987726d52d();
    return [
        [
            e,
            t
        ].join("-"),
        [
            $4e7e1af11ea066d2$export$e08b61c98317d88c,
            r
        ].join("-"),
        i,
        n
    ].join("/");
}
function $4e7e1af11ea066d2$export$d875b3963ef774f5(param) {
    var e = param.protocol, t = param.version, r = param.relayUrl, i = param.sdkVersion, n = param.auth, o = param.projectId, h = param.useOnCloseEvent, p = param.bundleId;
    var b = r.split("?"), m = $4e7e1af11ea066d2$export$b55a4c6e272b719f(e, t, i), w = {
        auth: n,
        ua: m,
        projectId: o,
        useOnCloseEvent: h || void 0,
        origin: p || void 0
    }, y = $4e7e1af11ea066d2$export$c4147c69f6845da(b[1] || "", w);
    return b[0] + "?" + y;
}
function $4e7e1af11ea066d2$export$ed08891a8a54eb(e) {
    var t = (e.match(/^[^:]+(?=:\/\/)/gi) || [])[0];
    var r = (typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t)) < "u" ? e.split("://")[1] : e;
    return t = t === "wss" ? "https" : "http", [
        t,
        r
    ].join("://");
}
function $4e7e1af11ea066d2$export$804de46662e4ac95(e, t, r) {
    if (!e[t] || (0, $l0HdX._)(e[t]) !== r) throw new Error('Missing or invalid "'.concat(t, '" param'));
}
function $4e7e1af11ea066d2$export$1e21530e896c0b0b(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $4e7e1af11ea066d2$export$7f882bb969de14a3;
    return $4e7e1af11ea066d2$export$7f00885504704576(e.split($4e7e1af11ea066d2$export$98238152dfccf046), t);
}
function $4e7e1af11ea066d2$export$80bffd46c37a96f6(e) {
    return $4e7e1af11ea066d2$export$1e21530e896c0b0b(e).join($4e7e1af11ea066d2$export$657dee6d5648750a);
}
function $4e7e1af11ea066d2$export$1468a49de573f7f9(e, t) {
    return e.filter(function(r) {
        return t.includes(r);
    }).length === e.length;
}
function $4e7e1af11ea066d2$export$7f00885504704576(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $4e7e1af11ea066d2$export$7f882bb969de14a3;
    return e.slice(Math.max(e.length - t, 0));
}
function $4e7e1af11ea066d2$export$c4b8dfeb6e237eb9(e) {
    return Object.fromEntries(e.entries());
}
function $4e7e1af11ea066d2$export$ac31b37c726bc3ba(e) {
    return new Map(Object.entries(e));
}
function $4e7e1af11ea066d2$export$592ef47eabb05614(e, t) {
    var r = {};
    return Object.keys(e).forEach(function(i) {
        r[i] = t(e[i]);
    }), r;
}
var $4e7e1af11ea066d2$export$85c927578394b28b = function(e) {
    return e;
};
function $4e7e1af11ea066d2$export$e9f8fcacef3bca4b(e) {
    return e.trim().replace(/^\w/, function(t) {
        return t.toUpperCase();
    });
}
function $4e7e1af11ea066d2$export$9a00dee1beb8f576(e) {
    return e.split($4e7e1af11ea066d2$export$657dee6d5648750a).map(function(t) {
        return $4e7e1af11ea066d2$export$e9f8fcacef3bca4b(t);
    }).join($4e7e1af11ea066d2$export$657dee6d5648750a);
}
function $4e7e1af11ea066d2$export$cbf9e3cc9ffc85cb() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $4BEBs.FIVE_MINUTES), t = arguments.length > 1 ? arguments[1] : void 0;
    var r = (0, $4BEBs.toMiliseconds)(e || (0, $4BEBs.FIVE_MINUTES));
    var i, n, o;
    return {
        resolve: function(h) {
            o && i && (clearTimeout(o), i(h));
        },
        reject: function(h) {
            o && n && (clearTimeout(o), n(h));
        },
        done: function() {
            return new Promise(function(h, p) {
                o = setTimeout(function() {
                    p(new Error(t));
                }, r), i = h, n = p;
            });
        }
    };
}
function $4e7e1af11ea066d2$export$3da2293b007ed708(e, t, r) {
    return new Promise(function() {
        var _ref = (0, $kSuI9._)(function(i, n) {
            var o, _$h, h;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        o = setTimeout(function() {
                            return n(new Error(r));
                        }, t);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            e
                        ];
                    case 2:
                        _$h = _state.sent();
                        i(_$h);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        h = _state.sent();
                        n(h);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        clearTimeout(o);
                        return [
                            2
                        ];
                }
            });
        });
        return function(i, n) {
            return _ref.apply(this, arguments);
        };
    }());
}
function $4e7e1af11ea066d2$export$187ab6574b2ae23f(e, t) {
    if (typeof t == "string" && t.startsWith("".concat(e, ":"))) return t;
    if (e.toLowerCase() === "topic") {
        if (typeof t != "string") throw new Error('Value must be "string" for expirer target type: topic');
        return "topic:".concat(t);
    } else if (e.toLowerCase() === "id") {
        if (typeof t != "number") throw new Error('Value must be "number" for expirer target type: id');
        return "id:".concat(t);
    }
    throw new Error("Unknown expirer target type: ".concat(e));
}
function $4e7e1af11ea066d2$export$43ab92477f8713b9(e) {
    return $4e7e1af11ea066d2$export$187ab6574b2ae23f("topic", e);
}
function $4e7e1af11ea066d2$export$bd13103c2e5cc0c3(e) {
    return $4e7e1af11ea066d2$export$187ab6574b2ae23f("id", e);
}
function $4e7e1af11ea066d2$export$93adeb0f16e8e51d(e) {
    var _e_split = (0, $cv9Rk._)(e.split(":"), 2), t = _e_split[0], r = _e_split[1], i = {
        id: void 0,
        topic: void 0
    };
    if (t === "topic" && typeof r == "string") i.topic = r;
    else if (t === "id" && Number.isInteger(Number(r))) i.id = Number(r);
    else throw new Error("Invalid target, expected id:number or topic:string, got ".concat(t, ":").concat(r));
    return i;
}
function $4e7e1af11ea066d2$export$b136d03015bfc12(e, t) {
    return (0, $4BEBs.fromMiliseconds)((t || Date.now()) + (0, $4BEBs.toMiliseconds)(e));
}
function $4e7e1af11ea066d2$export$57947cfd429801a2(e) {
    return Date.now() >= (0, $4BEBs.toMiliseconds)(e);
}
function $4e7e1af11ea066d2$export$e3eb27ce66c0f6d9(e, t) {
    return "".concat(e).concat(t ? ":".concat(t) : "");
}
function $4e7e1af11ea066d2$export$9826fe7ad3921016() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return (0, $c6Xmf._)(new Set((0, $c6Xmf._)(e).concat((0, $c6Xmf._)(t))));
}
function $4e7e1af11ea066d2$export$694a208c8abca99a(_) {
    return $4e7e1af11ea066d2$var$_m0.apply(this, arguments);
}
function $4e7e1af11ea066d2$var$_m0() {
    $4e7e1af11ea066d2$var$_m0 = (0, $kSuI9._)(function(param) {
        var e, t, r, _$i, n, o, h, _tmp, _tmp1, i;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    e = param.id, t = param.topic, r = param.wcDeepLink;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        ,
                        7
                    ]);
                    if (!r) return [
                        2
                    ];
                    _$i = typeof r == "string" ? JSON.parse(r) : r;
                    n = _$i === null || _$i === void 0 ? void 0 : _$i.href;
                    if (typeof n != "string") return [
                        2
                    ];
                    n.endsWith("/") && (n = n.slice(0, -1));
                    o = "".concat(n, "/wc?requestId=").concat(e, "&sessionTopic=").concat(t), h = $4e7e1af11ea066d2$export$57570b1603cf6adb();
                    if (!(h === $4e7e1af11ea066d2$export$86b1301a63b15dd9.browser)) return [
                        3,
                        2
                    ];
                    _tmp = o.startsWith("https://") || o.startsWith("http://") ? window.open(o, "_blank", "noreferrer noopener") : window.open(o, "_self", "noreferrer noopener");
                    return [
                        3,
                        5
                    ];
                case 2:
                    _tmp1 = h === $4e7e1af11ea066d2$export$86b1301a63b15dd9.reactNative && (0, $l0HdX._)($parcel$global == null ? void 0 : $parcel$global.Linking) < "u";
                    if (!_tmp1) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        $parcel$global.Linking.openURL(o)
                    ];
                case 3:
                    _tmp1 = _state.sent();
                    _state.label = 4;
                case 4:
                    _tmp = _tmp1;
                    _state.label = 5;
                case 5:
                    _tmp;
                    return [
                        3,
                        7
                    ];
                case 6:
                    i = _state.sent();
                    console.error(i);
                    return [
                        3,
                        7
                    ];
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    return $4e7e1af11ea066d2$var$_m0.apply(this, arguments);
}
function $4e7e1af11ea066d2$export$e55bfdac47149a32(e, t) {
    return $4e7e1af11ea066d2$var$_g0.apply(this, arguments);
}
function $4e7e1af11ea066d2$var$_g0() {
    $4e7e1af11ea066d2$var$_g0 = (0, $kSuI9._)(function(e, t) {
        var r;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        e.getItem(t)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent() || ($4e7e1af11ea066d2$export$4e09c449d6c407f7() ? localStorage.getItem(t) : void 0)
                    ];
                case 2:
                    r = _state.sent();
                    console.error(r);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $4e7e1af11ea066d2$var$_g0.apply(this, arguments);
}
function $4e7e1af11ea066d2$export$f8aaf09178dd8b96(e, t) {
    return e.filter(function(r) {
        return t.includes(r);
    });
}
var $4e7e1af11ea066d2$var$On = (typeof globalThis === "undefined" ? "undefined" : (0, $l0HdX._)(globalThis)) < "u" ? globalThis : (typeof window === "undefined" ? "undefined" : (0, $l0HdX._)(window)) < "u" ? window : (typeof $parcel$global === "undefined" ? "undefined" : (0, $l0HdX._)($parcel$global)) < "u" ? $parcel$global : (typeof self === "undefined" ? "undefined" : (0, $l0HdX._)(self)) < "u" ? self : {};
function $4e7e1af11ea066d2$var$A0(e) {
    var t = e.default;
    if (typeof t == "function") {
        var r = function r() {
            return t.apply(this, arguments);
        };
        r.prototype = t.prototype;
    } else r = {};
    return Object.defineProperty(r, "__esModule", {
        value: !0
    }), Object.keys(e).forEach(function(i) {
        var n = Object.getOwnPropertyDescriptor(e, i);
        Object.defineProperty(r, i, n.get ? n : {
            enumerable: !0,
            get: function get() {
                return e[i];
            }
        });
    }), r;
}
var $4e7e1af11ea066d2$var$Pn = {
    exports: {}
}; /**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */ 
(function(e) {
    (function() {
        var t = "input is invalid type", r = "finalize already called", i = typeof window == "object", n = i ? window : {};
        n.JS_SHA3_NO_WINDOW && (i = !1);
        var o = !i && typeof self == "object", h = !n.JS_SHA3_NO_NODE_JS && typeof $3qWgZ == "object" && $3qWgZ.versions && $3qWgZ.versions.node;
        h ? n = $4e7e1af11ea066d2$var$On : o && (n = self);
        var p = !n.JS_SHA3_NO_COMMON_JS && !0 && e.exports, b = !n.JS_SHA3_NO_ARRAY_BUFFER && (typeof ArrayBuffer === "undefined" ? "undefined" : (0, $l0HdX._)(ArrayBuffer)) < "u", m = "0123456789abcdef".split(""), w = [
            31,
            7936,
            2031616,
            520093696
        ], y = [
            4,
            1024,
            262144,
            67108864
        ], S = [
            1,
            256,
            65536,
            16777216
        ], I = [
            6,
            1536,
            393216,
            100663296
        ], N = [
            0,
            8,
            16,
            24
        ], C = [
            1,
            0,
            32898,
            0,
            32906,
            2147483648,
            2147516416,
            2147483648,
            32907,
            0,
            2147483649,
            0,
            2147516545,
            2147483648,
            32777,
            2147483648,
            138,
            0,
            136,
            0,
            2147516425,
            0,
            2147483658,
            0,
            2147516555,
            0,
            139,
            2147483648,
            32905,
            2147483648,
            32771,
            2147483648,
            32770,
            2147483648,
            128,
            2147483648,
            32778,
            0,
            2147483658,
            2147483648,
            2147516545,
            2147483648,
            32896,
            2147483648,
            2147483649,
            0,
            2147516424,
            2147483648
        ], F = [
            224,
            256,
            384,
            512
        ], U = [
            128,
            256
        ], J = [
            "hex",
            "buffer",
            "arrayBuffer",
            "array",
            "digest"
        ], Bt = {
            128: 168,
            256: 136
        };
        (n.JS_SHA3_NO_NODE_JS || !Array.isArray) && (Array.isArray = function(u) {
            return Object.prototype.toString.call(u) === "[object Array]";
        }), b && (n.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView) && (ArrayBuffer.isView = function(u) {
            return typeof u == "object" && u.buffer && u.buffer.constructor === ArrayBuffer;
        });
        for(var G = function G(u, E, _) {
            return function(B) {
                return new s(u, E, u).update(B)[_]();
            };
        }, H = function H(u, E, _) {
            return function(B, R) {
                return new s(u, E, R).update(B)[_]();
            };
        }, z = function z(u, E, _) {
            return function(B, R, T, P) {
                return f["cshake" + u].update(B, R, T, P)[_]();
            };
        }, Pt = function Pt(u, E, _) {
            return function(B, R, T, P) {
                return f["kmac" + u].update(B, R, T, P)[_]();
            };
        }, W = function W(u, E, _, B) {
            for(var R = 0; R < J.length; ++R){
                var T = J[R];
                u[T] = E(_, B, T);
            }
            return u;
        }, Rt = function Rt(u, E) {
            var _ = G(u, E, "hex");
            return _.create = function() {
                return new s(u, E, u);
            }, _.update = function(B) {
                return _.create().update(B);
            }, W(_, G, u, E);
        }, Yt = function Yt(u, E) {
            var _ = H(u, E, "hex");
            return _.create = function(B) {
                return new s(u, E, B);
            }, _.update = function(B, R) {
                return _.create(R).update(B);
            }, W(_, H, u, E);
        }, Y = function Y(u, E) {
            var _ = Bt[u], B = z(u, E, "hex");
            return B.create = function(R, T, P) {
                return !T && !P ? f["shake" + u].create(R) : new s(u, E, R).bytepad([
                    T,
                    P
                ], _);
            }, B.update = function(R, T, P, O) {
                return B.create(T, P, O).update(R);
            }, W(B, z, u, E);
        }, Vt = function Vt(u, E) {
            var _ = Bt[u], B = Pt(u, E, "hex");
            return B.create = function(R, T, P) {
                return new v(u, E, T).bytepad([
                    "KMAC",
                    P
                ], _).bytepad([
                    R
                ], _);
            }, B.update = function(R, T, P, O) {
                return B.create(R, P, O).update(T);
            }, W(B, Pt, u, E);
        }, A = [
            {
                name: "keccak",
                padding: S,
                bits: F,
                createMethod: Rt
            },
            {
                name: "sha3",
                padding: I,
                bits: F,
                createMethod: Rt
            },
            {
                name: "shake",
                padding: w,
                bits: U,
                createMethod: Yt
            },
            {
                name: "cshake",
                padding: y,
                bits: U,
                createMethod: Y
            },
            {
                name: "kmac",
                padding: y,
                bits: U,
                createMethod: Vt
            }
        ], f = {}, a = [], c = 0; c < A.length; ++c)for(var d = A[c], g = d.bits, x = 0; x < g.length; ++x){
            var M = d.name + "_" + g[x];
            if (a.push(M), f[M] = d.createMethod(g[x], d.padding), d.name !== "sha3") {
                var l = d.name + g[x];
                a.push(l), f[l] = f[M];
            }
        }
        function s(u, E, _) {
            this.blocks = [], this.s = [], this.padding = E, this.outputBits = _, this.reset = !0, this.finalized = !1, this.block = 0, this.start = 0, this.blockCount = 1600 - (u << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = _ >> 5, this.extraBytes = (_ & 31) >> 3;
            for(var B = 0; B < 50; ++B)this.s[B] = 0;
        }
        s.prototype.update = function(u) {
            if (this.finalized) throw new Error(r);
            var E, _ = typeof u === "undefined" ? "undefined" : (0, $l0HdX._)(u);
            if (_ !== "string") {
                if (_ === "object") {
                    if (u === null) throw new Error(t);
                    if (b && u.constructor === ArrayBuffer) u = new Uint8Array(u);
                    else if (!Array.isArray(u) && (!b || !ArrayBuffer.isView(u))) throw new Error(t);
                } else throw new Error(t);
                E = !0;
            }
            for(var B = this.blocks, R = this.byteCount, T = u.length, P = this.blockCount, O = 0, Ct = this.s, D, q; O < T;){
                if (this.reset) for(this.reset = !1, B[0] = this.block, D = 1; D < P + 1; ++D)B[D] = 0;
                if (E) for(D = this.start; O < T && D < R; ++O)B[D >> 2] |= u[O] << N[D++ & 3];
                else for(D = this.start; O < T && D < R; ++O)q = u.charCodeAt(O), q < 128 ? B[D >> 2] |= q << N[D++ & 3] : q < 2048 ? (B[D >> 2] |= (192 | q >> 6) << N[D++ & 3], B[D >> 2] |= (128 | q & 63) << N[D++ & 3]) : q < 55296 || q >= 57344 ? (B[D >> 2] |= (224 | q >> 12) << N[D++ & 3], B[D >> 2] |= (128 | q >> 6 & 63) << N[D++ & 3], B[D >> 2] |= (128 | q & 63) << N[D++ & 3]) : (q = 65536 + ((q & 1023) << 10 | u.charCodeAt(++O) & 1023), B[D >> 2] |= (240 | q >> 18) << N[D++ & 3], B[D >> 2] |= (128 | q >> 12 & 63) << N[D++ & 3], B[D >> 2] |= (128 | q >> 6 & 63) << N[D++ & 3], B[D >> 2] |= (128 | q & 63) << N[D++ & 3]);
                if (this.lastByteIndex = D, D >= R) {
                    for(this.start = D - R, this.block = B[P], D = 0; D < P; ++D)Ct[D] ^= B[D];
                    k(Ct), this.reset = !0;
                } else this.start = D;
            }
            return this;
        }, s.prototype.encode = function(u, E) {
            var _ = u & 255, B = 1, R = [
                _
            ];
            for(u = u >> 8, _ = u & 255; _ > 0;)R.unshift(_), u = u >> 8, _ = u & 255, ++B;
            return E ? R.push(B) : R.unshift(B), this.update(R), R.length;
        }, s.prototype.encodeString = function(u) {
            var E, _ = typeof u === "undefined" ? "undefined" : (0, $l0HdX._)(u);
            if (_ !== "string") {
                if (_ === "object") {
                    if (u === null) throw new Error(t);
                    if (b && u.constructor === ArrayBuffer) u = new Uint8Array(u);
                    else if (!Array.isArray(u) && (!b || !ArrayBuffer.isView(u))) throw new Error(t);
                } else throw new Error(t);
                E = !0;
            }
            var B = 0, R = u.length;
            if (E) B = R;
            else for(var T = 0; T < u.length; ++T){
                var P = u.charCodeAt(T);
                P < 128 ? B += 1 : P < 2048 ? B += 2 : P < 55296 || P >= 57344 ? B += 3 : (P = 65536 + ((P & 1023) << 10 | u.charCodeAt(++T) & 1023), B += 4);
            }
            return B += this.encode(B * 8), this.update(u), B;
        }, s.prototype.bytepad = function(u, E) {
            for(var _ = this.encode(E), B = 0; B < u.length; ++B)_ += this.encodeString(u[B]);
            var R = E - _ % E, T = [];
            return T.length = R, this.update(T), this;
        }, s.prototype.finalize = function() {
            if (!this.finalized) {
                this.finalized = !0;
                var u = this.blocks, E = this.lastByteIndex, _ = this.blockCount, B = this.s;
                if (u[E >> 2] |= this.padding[E & 3], this.lastByteIndex === this.byteCount) for(u[0] = u[_], E = 1; E < _ + 1; ++E)u[E] = 0;
                for(u[_ - 1] |= 2147483648, E = 0; E < _; ++E)B[E] ^= u[E];
                k(B);
            }
        }, s.prototype.toString = s.prototype.hex = function() {
            this.finalize();
            for(var u = this.blockCount, E = this.s, _ = this.outputBlocks, B = this.extraBytes, R = 0, T = 0, P = "", O; T < _;){
                for(R = 0; R < u && T < _; ++R, ++T)O = E[R], P += m[O >> 4 & 15] + m[O & 15] + m[O >> 12 & 15] + m[O >> 8 & 15] + m[O >> 20 & 15] + m[O >> 16 & 15] + m[O >> 28 & 15] + m[O >> 24 & 15];
                T % u === 0 && (k(E), R = 0);
            }
            return B && (O = E[R], P += m[O >> 4 & 15] + m[O & 15], B > 1 && (P += m[O >> 12 & 15] + m[O >> 8 & 15]), B > 2 && (P += m[O >> 20 & 15] + m[O >> 16 & 15])), P;
        }, s.prototype.arrayBuffer = function() {
            this.finalize();
            var u = this.blockCount, E = this.s, _ = this.outputBlocks, B = this.extraBytes, R = 0, T = 0, P = this.outputBits >> 3, O;
            B ? O = new ArrayBuffer(_ + 1 << 2) : O = new ArrayBuffer(P);
            for(var Ct = new Uint32Array(O); T < _;){
                for(R = 0; R < u && T < _; ++R, ++T)Ct[T] = E[R];
                T % u === 0 && k(E);
            }
            return B && (Ct[R] = E[R], O = O.slice(0, P)), O;
        }, s.prototype.buffer = s.prototype.arrayBuffer, s.prototype.digest = s.prototype.array = function() {
            this.finalize();
            for(var u = this.blockCount, E = this.s, _ = this.outputBlocks, B = this.extraBytes, R = 0, T = 0, P = [], O, Ct; T < _;){
                for(R = 0; R < u && T < _; ++R, ++T)O = T << 2, Ct = E[R], P[O] = Ct & 255, P[O + 1] = Ct >> 8 & 255, P[O + 2] = Ct >> 16 & 255, P[O + 3] = Ct >> 24 & 255;
                T % u === 0 && k(E);
            }
            return B && (O = T << 2, Ct = E[R], P[O] = Ct & 255, B > 1 && (P[O + 1] = Ct >> 8 & 255), B > 2 && (P[O + 2] = Ct >> 16 & 255)), P;
        };
        function v(u, E, _) {
            s.call(this, u, E, _);
        }
        v.prototype = new s, v.prototype.finalize = function() {
            return this.encode(this.outputBits, !0), s.prototype.finalize.call(this);
        };
        var k = function k(u) {
            var E, _, B, R, T, P, O, Ct, D, q, De, X, Z, Fe, $, tt, Te, et, rt, Ue, it, nt, ke, ft, ot, qe, st, at, Ke, ut, ht, He, ct, lt, ze, dt, pt, Le, vt, mt, je, gt, At, Qe, bt, yt, Je, wt, xt, Ge, Mt, Et, Ye, St, Nt, Ve, It, _t, Me, Ee, Se, Ne, Ie;
            for(B = 0; B < 48; B += 2)R = u[0] ^ u[10] ^ u[20] ^ u[30] ^ u[40], T = u[1] ^ u[11] ^ u[21] ^ u[31] ^ u[41], P = u[2] ^ u[12] ^ u[22] ^ u[32] ^ u[42], O = u[3] ^ u[13] ^ u[23] ^ u[33] ^ u[43], Ct = u[4] ^ u[14] ^ u[24] ^ u[34] ^ u[44], D = u[5] ^ u[15] ^ u[25] ^ u[35] ^ u[45], q = u[6] ^ u[16] ^ u[26] ^ u[36] ^ u[46], De = u[7] ^ u[17] ^ u[27] ^ u[37] ^ u[47], X = u[8] ^ u[18] ^ u[28] ^ u[38] ^ u[48], Z = u[9] ^ u[19] ^ u[29] ^ u[39] ^ u[49], E = X ^ (P << 1 | O >>> 31), _ = Z ^ (O << 1 | P >>> 31), u[0] ^= E, u[1] ^= _, u[10] ^= E, u[11] ^= _, u[20] ^= E, u[21] ^= _, u[30] ^= E, u[31] ^= _, u[40] ^= E, u[41] ^= _, E = R ^ (Ct << 1 | D >>> 31), _ = T ^ (D << 1 | Ct >>> 31), u[2] ^= E, u[3] ^= _, u[12] ^= E, u[13] ^= _, u[22] ^= E, u[23] ^= _, u[32] ^= E, u[33] ^= _, u[42] ^= E, u[43] ^= _, E = P ^ (q << 1 | De >>> 31), _ = O ^ (De << 1 | q >>> 31), u[4] ^= E, u[5] ^= _, u[14] ^= E, u[15] ^= _, u[24] ^= E, u[25] ^= _, u[34] ^= E, u[35] ^= _, u[44] ^= E, u[45] ^= _, E = Ct ^ (X << 1 | Z >>> 31), _ = D ^ (Z << 1 | X >>> 31), u[6] ^= E, u[7] ^= _, u[16] ^= E, u[17] ^= _, u[26] ^= E, u[27] ^= _, u[36] ^= E, u[37] ^= _, u[46] ^= E, u[47] ^= _, E = q ^ (R << 1 | T >>> 31), _ = De ^ (T << 1 | R >>> 31), u[8] ^= E, u[9] ^= _, u[18] ^= E, u[19] ^= _, u[28] ^= E, u[29] ^= _, u[38] ^= E, u[39] ^= _, u[48] ^= E, u[49] ^= _, Fe = u[0], $ = u[1], yt = u[11] << 4 | u[10] >>> 28, Je = u[10] << 4 | u[11] >>> 28, at = u[20] << 3 | u[21] >>> 29, Ke = u[21] << 3 | u[20] >>> 29, Ee = u[31] << 9 | u[30] >>> 23, Se = u[30] << 9 | u[31] >>> 23, gt = u[40] << 18 | u[41] >>> 14, At = u[41] << 18 | u[40] >>> 14, lt = u[2] << 1 | u[3] >>> 31, ze = u[3] << 1 | u[2] >>> 31, tt = u[13] << 12 | u[12] >>> 20, Te = u[12] << 12 | u[13] >>> 20, wt = u[22] << 10 | u[23] >>> 22, xt = u[23] << 10 | u[22] >>> 22, ut = u[33] << 13 | u[32] >>> 19, ht = u[32] << 13 | u[33] >>> 19, Ne = u[42] << 2 | u[43] >>> 30, Ie = u[43] << 2 | u[42] >>> 30, St = u[5] << 30 | u[4] >>> 2, Nt = u[4] << 30 | u[5] >>> 2, dt = u[14] << 6 | u[15] >>> 26, pt = u[15] << 6 | u[14] >>> 26, et = u[25] << 11 | u[24] >>> 21, rt = u[24] << 11 | u[25] >>> 21, Ge = u[34] << 15 | u[35] >>> 17, Mt = u[35] << 15 | u[34] >>> 17, He = u[45] << 29 | u[44] >>> 3, ct = u[44] << 29 | u[45] >>> 3, ft = u[6] << 28 | u[7] >>> 4, ot = u[7] << 28 | u[6] >>> 4, Ve = u[17] << 23 | u[16] >>> 9, It = u[16] << 23 | u[17] >>> 9, Le = u[26] << 25 | u[27] >>> 7, vt = u[27] << 25 | u[26] >>> 7, Ue = u[36] << 21 | u[37] >>> 11, it = u[37] << 21 | u[36] >>> 11, Et = u[47] << 24 | u[46] >>> 8, Ye = u[46] << 24 | u[47] >>> 8, Qe = u[8] << 27 | u[9] >>> 5, bt = u[9] << 27 | u[8] >>> 5, qe = u[18] << 20 | u[19] >>> 12, st = u[19] << 20 | u[18] >>> 12, _t = u[29] << 7 | u[28] >>> 25, Me = u[28] << 7 | u[29] >>> 25, mt = u[38] << 8 | u[39] >>> 24, je = u[39] << 8 | u[38] >>> 24, nt = u[48] << 14 | u[49] >>> 18, ke = u[49] << 14 | u[48] >>> 18, u[0] = Fe ^ ~tt & et, u[1] = $ ^ ~Te & rt, u[10] = ft ^ ~qe & at, u[11] = ot ^ ~st & Ke, u[20] = lt ^ ~dt & Le, u[21] = ze ^ ~pt & vt, u[30] = Qe ^ ~yt & wt, u[31] = bt ^ ~Je & xt, u[40] = St ^ ~Ve & _t, u[41] = Nt ^ ~It & Me, u[2] = tt ^ ~et & Ue, u[3] = Te ^ ~rt & it, u[12] = qe ^ ~at & ut, u[13] = st ^ ~Ke & ht, u[22] = dt ^ ~Le & mt, u[23] = pt ^ ~vt & je, u[32] = yt ^ ~wt & Ge, u[33] = Je ^ ~xt & Mt, u[42] = Ve ^ ~_t & Ee, u[43] = It ^ ~Me & Se, u[4] = et ^ ~Ue & nt, u[5] = rt ^ ~it & ke, u[14] = at ^ ~ut & He, u[15] = Ke ^ ~ht & ct, u[24] = Le ^ ~mt & gt, u[25] = vt ^ ~je & At, u[34] = wt ^ ~Ge & Et, u[35] = xt ^ ~Mt & Ye, u[44] = _t ^ ~Ee & Ne, u[45] = Me ^ ~Se & Ie, u[6] = Ue ^ ~nt & Fe, u[7] = it ^ ~ke & $, u[16] = ut ^ ~He & ft, u[17] = ht ^ ~ct & ot, u[26] = mt ^ ~gt & lt, u[27] = je ^ ~At & ze, u[36] = Ge ^ ~Et & Qe, u[37] = Mt ^ ~Ye & bt, u[46] = Ee ^ ~Ne & St, u[47] = Se ^ ~Ie & Nt, u[8] = nt ^ ~Fe & tt, u[9] = ke ^ ~$ & Te, u[18] = He ^ ~ft & qe, u[19] = ct ^ ~ot & st, u[28] = gt ^ ~lt & dt, u[29] = At ^ ~ze & pt, u[38] = Et ^ ~Qe & yt, u[39] = Ye ^ ~bt & Je, u[48] = Ne ^ ~St & Ve, u[49] = Ie ^ ~Nt & It, u[0] ^= C[B], u[1] ^= C[B + 1];
        };
        if (p) e.exports = f;
        else for(c = 0; c < a.length; ++c)n[a[c]] = f[a[c]];
    })();
})($4e7e1af11ea066d2$var$Pn);
var $4e7e1af11ea066d2$var$b0 = $4e7e1af11ea066d2$var$Pn.exports;
var $4e7e1af11ea066d2$var$y0 = "logger/5.7.0";
var $4e7e1af11ea066d2$var$Dn = !1, $4e7e1af11ea066d2$var$Fn = !1;
var $4e7e1af11ea066d2$var$Cr = {
    debug: 1,
    default: 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
var $4e7e1af11ea066d2$var$Tn = $4e7e1af11ea066d2$var$Cr.default, $4e7e1af11ea066d2$var$gi = null;
function $4e7e1af11ea066d2$var$w0() {
    try {
        var _$e = [];
        if ([
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach(function(t) {
            try {
                if ("test".normalize(t) !== "test") throw new Error("bad normalize");
            } catch (e) {
                _$e.push(t);
            }
        }), _$e.length) throw new Error("missing " + _$e.join(", "));
        if (String.fromCharCode(233).normalize("NFD") !== String.fromCharCode(101, 769)) throw new Error("broken implementation");
    } catch (e) {
        return e.message;
    }
    return null;
}
var $4e7e1af11ea066d2$var$Un = $4e7e1af11ea066d2$var$w0();
var $4e7e1af11ea066d2$var$Ai;
(function(e) {
    e.DEBUG = "DEBUG", e.INFO = "INFO", e.WARNING = "WARNING", e.ERROR = "ERROR", e.OFF = "OFF";
})($4e7e1af11ea066d2$var$Ai || ($4e7e1af11ea066d2$var$Ai = {}));
var $4e7e1af11ea066d2$var$re;
(function(e) {
    e.UNKNOWN_ERROR = "UNKNOWN_ERROR", e.NOT_IMPLEMENTED = "NOT_IMPLEMENTED", e.UNSUPPORTED_OPERATION = "UNSUPPORTED_OPERATION", e.NETWORK_ERROR = "NETWORK_ERROR", e.SERVER_ERROR = "SERVER_ERROR", e.TIMEOUT = "TIMEOUT", e.BUFFER_OVERRUN = "BUFFER_OVERRUN", e.NUMERIC_FAULT = "NUMERIC_FAULT", e.MISSING_NEW = "MISSING_NEW", e.INVALID_ARGUMENT = "INVALID_ARGUMENT", e.MISSING_ARGUMENT = "MISSING_ARGUMENT", e.UNEXPECTED_ARGUMENT = "UNEXPECTED_ARGUMENT", e.CALL_EXCEPTION = "CALL_EXCEPTION", e.INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS", e.NONCE_EXPIRED = "NONCE_EXPIRED", e.REPLACEMENT_UNDERPRICED = "REPLACEMENT_UNDERPRICED", e.UNPREDICTABLE_GAS_LIMIT = "UNPREDICTABLE_GAS_LIMIT", e.TRANSACTION_REPLACED = "TRANSACTION_REPLACED", e.ACTION_REJECTED = "ACTION_REJECTED";
})($4e7e1af11ea066d2$var$re || ($4e7e1af11ea066d2$var$re = {}));
var $4e7e1af11ea066d2$var$kn = "0123456789abcdef";
var $4e7e1af11ea066d2$var$L = /*#__PURE__*/ function() {
    "use strict";
    function L(t) {
        (0, $4GJKx._)(this, L);
        Object.defineProperty(this, "version", {
            enumerable: !0,
            value: t,
            writable: !1
        });
    }
    (0, $1wc17._)(L, [
        {
            key: "_log",
            value: function _log(t, r) {
                var i = t.toLowerCase();
                $4e7e1af11ea066d2$var$Cr[i] == null && this.throwArgumentError("invalid log level name", "logLevel", t), !($4e7e1af11ea066d2$var$Tn > $4e7e1af11ea066d2$var$Cr[i]) && console.log.apply(console, r);
            }
        },
        {
            key: "debug",
            value: function debug() {
                for(var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++){
                    t[_key] = arguments[_key];
                }
                this._log(L.levels.DEBUG, t);
            }
        },
        {
            key: "info",
            value: function info() {
                for(var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++){
                    t[_key] = arguments[_key];
                }
                this._log(L.levels.INFO, t);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++){
                    t[_key] = arguments[_key];
                }
                this._log(L.levels.WARNING, t);
            }
        },
        {
            key: "makeError",
            value: function makeError(t, r, i) {
                if ($4e7e1af11ea066d2$var$Fn) return this.makeError("censored error", r, {});
                r || (r = L.errors.UNKNOWN_ERROR), i || (i = {});
                var n = [];
                Object.keys(i).forEach(function(b) {
                    var m = i[b];
                    try {
                        if (m instanceof Uint8Array) {
                            var w = "";
                            for(var y = 0; y < m.length; y++)w += $4e7e1af11ea066d2$var$kn[m[y] >> 4], w += $4e7e1af11ea066d2$var$kn[m[y] & 15];
                            n.push(b + "=Uint8Array(0x" + w + ")");
                        } else n.push(b + "=" + JSON.stringify(m));
                    } catch (e) {
                        n.push(b + "=" + JSON.stringify(i[b].toString()));
                    }
                }), n.push("code=".concat(r)), n.push("version=".concat(this.version));
                var o = t;
                var h = "";
                switch(r){
                    case $4e7e1af11ea066d2$var$re.NUMERIC_FAULT:
                        {
                            h = "NUMERIC_FAULT";
                            var b = t;
                            switch(b){
                                case "overflow":
                                case "underflow":
                                case "division-by-zero":
                                    h += "-" + b;
                                    break;
                                case "negative-power":
                                case "negative-width":
                                    h += "-unsupported";
                                    break;
                                case "unbound-bitwise-result":
                                    h += "-unbound-result";
                                    break;
                            }
                            break;
                        }
                    case $4e7e1af11ea066d2$var$re.CALL_EXCEPTION:
                    case $4e7e1af11ea066d2$var$re.INSUFFICIENT_FUNDS:
                    case $4e7e1af11ea066d2$var$re.MISSING_NEW:
                    case $4e7e1af11ea066d2$var$re.NONCE_EXPIRED:
                    case $4e7e1af11ea066d2$var$re.REPLACEMENT_UNDERPRICED:
                    case $4e7e1af11ea066d2$var$re.TRANSACTION_REPLACED:
                    case $4e7e1af11ea066d2$var$re.UNPREDICTABLE_GAS_LIMIT:
                        h = r;
                        break;
                }
                h && (t += " [ See: https://links.ethers.org/v5-errors-" + h + " ]"), n.length && (t += " (" + n.join(", ") + ")");
                var p = new Error(t);
                return p.reason = o, p.code = r, Object.keys(i).forEach(function(b) {
                    p[b] = i[b];
                }), p;
            }
        },
        {
            key: "throwError",
            value: function throwError(t, r, i) {
                throw this.makeError(t, r, i);
            }
        },
        {
            key: "throwArgumentError",
            value: function throwArgumentError(t, r, i) {
                return this.throwError(t, L.errors.INVALID_ARGUMENT, {
                    argument: r,
                    value: i
                });
            }
        },
        {
            key: "assert",
            value: function assert(t, r, i, n) {
                t || this.throwError(r, i, n);
            }
        },
        {
            key: "assertArgument",
            value: function assertArgument(t, r, i, n) {
                t || this.throwArgumentError(r, i, n);
            }
        },
        {
            key: "checkNormalize",
            value: function checkNormalize(t) {
                $4e7e1af11ea066d2$var$Un && this.throwError("platform missing String.prototype.normalize", L.errors.UNSUPPORTED_OPERATION, {
                    operation: "String.prototype.normalize",
                    form: $4e7e1af11ea066d2$var$Un
                });
            }
        },
        {
            key: "checkSafeUint53",
            value: function checkSafeUint53(t, r) {
                typeof t == "number" && (r == null && (r = "value not safe"), (t < 0 || t >= 9007199254740991) && this.throwError(r, L.errors.NUMERIC_FAULT, {
                    operation: "checkSafeInteger",
                    fault: "out-of-safe-range",
                    value: t
                }), t % 1 && this.throwError(r, L.errors.NUMERIC_FAULT, {
                    operation: "checkSafeInteger",
                    fault: "non-integer",
                    value: t
                }));
            }
        },
        {
            key: "checkArgumentCount",
            value: function checkArgumentCount(t, r, i) {
                i ? i = ": " + i : i = "", t < r && this.throwError("missing argument" + i, L.errors.MISSING_ARGUMENT, {
                    count: t,
                    expectedCount: r
                }), t > r && this.throwError("too many arguments" + i, L.errors.UNEXPECTED_ARGUMENT, {
                    count: t,
                    expectedCount: r
                });
            }
        },
        {
            key: "checkNew",
            value: function checkNew(t, r) {
                (t === Object || t == null) && this.throwError("missing new", L.errors.MISSING_NEW, {
                    name: r.name
                });
            }
        },
        {
            key: "checkAbstract",
            value: function checkAbstract(t, r) {
                t === r ? this.throwError("cannot instantiate abstract class " + JSON.stringify(r.name) + " directly; use a sub-class", L.errors.UNSUPPORTED_OPERATION, {
                    name: t.name,
                    operation: "new"
                }) : (t === Object || t == null) && this.throwError("missing new", L.errors.MISSING_NEW, {
                    name: r.name
                });
            }
        }
    ], [
        {
            key: "globalLogger",
            value: function globalLogger() {
                return $4e7e1af11ea066d2$var$gi || ($4e7e1af11ea066d2$var$gi = new L($4e7e1af11ea066d2$var$y0)), $4e7e1af11ea066d2$var$gi;
            }
        },
        {
            key: "setCensorship",
            value: function setCensorship(t, r) {
                if (!t && r && this.globalLogger().throwError("cannot permanently disable censorship", L.errors.UNSUPPORTED_OPERATION, {
                    operation: "setCensorship"
                }), $4e7e1af11ea066d2$var$Dn) {
                    if (!t) return;
                    this.globalLogger().throwError("error censorship permanent", L.errors.UNSUPPORTED_OPERATION, {
                        operation: "setCensorship"
                    });
                }
                $4e7e1af11ea066d2$var$Fn = !!t, $4e7e1af11ea066d2$var$Dn = !!r;
            }
        },
        {
            key: "setLogLevel",
            value: function setLogLevel(t) {
                var r = $4e7e1af11ea066d2$var$Cr[t.toLowerCase()];
                if (r == null) {
                    L.globalLogger().warn("invalid log level - " + t);
                    return;
                }
                $4e7e1af11ea066d2$var$Tn = r;
            }
        },
        {
            key: "from",
            value: function from(t) {
                return new L(t);
            }
        }
    ]);
    return L;
}();
$4e7e1af11ea066d2$var$L.errors = $4e7e1af11ea066d2$var$re, $4e7e1af11ea066d2$var$L.levels = $4e7e1af11ea066d2$var$Ai;
var $4e7e1af11ea066d2$var$x0 = "bytes/5.7.0", $4e7e1af11ea066d2$var$Dt = new $4e7e1af11ea066d2$var$L($4e7e1af11ea066d2$var$x0);
function $4e7e1af11ea066d2$var$qn(e) {
    return !!e.toHexString;
}
function $4e7e1af11ea066d2$var$rr(e) {
    return e.slice || (e.slice = function() {
        var t = Array.prototype.slice.call(arguments);
        return $4e7e1af11ea066d2$var$rr(new Uint8Array(Array.prototype.slice.apply(e, t)));
    }), e;
}
function $4e7e1af11ea066d2$var$M0(e) {
    return $4e7e1af11ea066d2$var$Qt(e) && !(e.length % 2) || $4e7e1af11ea066d2$var$ir(e);
}
function $4e7e1af11ea066d2$var$Kn(e) {
    return typeof e == "number" && e == e && e % 1 === 0;
}
function $4e7e1af11ea066d2$var$ir(e) {
    if (e == null) return !1;
    if (e.constructor === Uint8Array) return !0;
    if (typeof e == "string" || !$4e7e1af11ea066d2$var$Kn(e.length) || e.length < 0) return !1;
    for(var t = 0; t < e.length; t++){
        var r = e[t];
        if (!$4e7e1af11ea066d2$var$Kn(r) || r < 0 || r >= 256) return !1;
    }
    return !0;
}
function $4e7e1af11ea066d2$var$Ot(e, t) {
    if (t || (t = {}), typeof e == "number") {
        $4e7e1af11ea066d2$var$Dt.checkSafeUint53(e, "invalid arrayify value");
        var r = [];
        for(; e;)r.unshift(e & 255), e = parseInt(String(e / 256));
        return r.length === 0 && r.push(0), $4e7e1af11ea066d2$var$rr(new Uint8Array(r));
    }
    if (t.allowMissingPrefix && typeof e == "string" && e.substring(0, 2) !== "0x" && (e = "0x" + e), $4e7e1af11ea066d2$var$qn(e) && (e = e.toHexString()), $4e7e1af11ea066d2$var$Qt(e)) {
        var r1 = e.substring(2);
        r1.length % 2 && (t.hexPad === "left" ? r1 = "0" + r1 : t.hexPad === "right" ? r1 += "0" : $4e7e1af11ea066d2$var$Dt.throwArgumentError("hex data is odd-length", "value", e));
        var i = [];
        for(var n = 0; n < r1.length; n += 2)i.push(parseInt(r1.substring(n, n + 2), 16));
        return $4e7e1af11ea066d2$var$rr(new Uint8Array(i));
    }
    return $4e7e1af11ea066d2$var$ir(e) ? $4e7e1af11ea066d2$var$rr(new Uint8Array(e)) : $4e7e1af11ea066d2$var$Dt.throwArgumentError("invalid arrayify value", "value", e);
}
function $4e7e1af11ea066d2$var$E0(e) {
    var t = e.map(function(n) {
        return $4e7e1af11ea066d2$var$Ot(n);
    }), r = t.reduce(function(n, o) {
        return n + o.length;
    }, 0), i = new Uint8Array(r);
    return t.reduce(function(n, o) {
        return i.set(o, n), n + o.length;
    }, 0), $4e7e1af11ea066d2$var$rr(i);
}
function $4e7e1af11ea066d2$var$S0(e, t) {
    e = $4e7e1af11ea066d2$var$Ot(e), e.length > t && $4e7e1af11ea066d2$var$Dt.throwArgumentError("value out of range", "value", arguments[0]);
    var r = new Uint8Array(t);
    return r.set(e, t - e.length), $4e7e1af11ea066d2$var$rr(r);
}
function $4e7e1af11ea066d2$var$Qt(e, t) {
    return !(typeof e != "string" || !e.match(/^0x[0-9A-Fa-f]*$/) || t && e.length !== 2 + 2 * t);
}
var $4e7e1af11ea066d2$var$bi = "0123456789abcdef";
function $4e7e1af11ea066d2$var$Kt(e, t) {
    if (t || (t = {}), typeof e == "number") {
        $4e7e1af11ea066d2$var$Dt.checkSafeUint53(e, "invalid hexlify value");
        var r = "";
        for(; e;)r = $4e7e1af11ea066d2$var$bi[e & 15] + r, e = Math.floor(e / 16);
        return r.length ? (r.length % 2 && (r = "0" + r), "0x" + r) : "0x00";
    }
    if ((typeof e === "undefined" ? "undefined" : (0, $l0HdX._)(e)) == "bigint") return e = e.toString(16), e.length % 2 ? "0x0" + e : "0x" + e;
    if (t.allowMissingPrefix && typeof e == "string" && e.substring(0, 2) !== "0x" && (e = "0x" + e), $4e7e1af11ea066d2$var$qn(e)) return e.toHexString();
    if ($4e7e1af11ea066d2$var$Qt(e)) return e.length % 2 && (t.hexPad === "left" ? e = "0x0" + e.substring(2) : t.hexPad === "right" ? e += "0" : $4e7e1af11ea066d2$var$Dt.throwArgumentError("hex data is odd-length", "value", e)), e.toLowerCase();
    if ($4e7e1af11ea066d2$var$ir(e)) {
        var r1 = "0x";
        for(var i = 0; i < e.length; i++){
            var n = e[i];
            r1 += $4e7e1af11ea066d2$var$bi[(n & 240) >> 4] + $4e7e1af11ea066d2$var$bi[n & 15];
        }
        return r1;
    }
    return $4e7e1af11ea066d2$var$Dt.throwArgumentError("invalid hexlify value", "value", e);
}
function $4e7e1af11ea066d2$var$N0(e) {
    if (typeof e != "string") e = $4e7e1af11ea066d2$var$Kt(e);
    else if (!$4e7e1af11ea066d2$var$Qt(e) || e.length % 2) return null;
    return (e.length - 2) / 2;
}
function $4e7e1af11ea066d2$var$Hn(e, t, r) {
    return typeof e != "string" ? e = $4e7e1af11ea066d2$var$Kt(e) : (!$4e7e1af11ea066d2$var$Qt(e) || e.length % 2) && $4e7e1af11ea066d2$var$Dt.throwArgumentError("invalid hexData", "value", e), t = 2 + 2 * t, r != null ? "0x" + e.substring(t, 2 + 2 * r) : "0x" + e.substring(t);
}
function $4e7e1af11ea066d2$var$oe(e, t) {
    for(typeof e != "string" ? e = $4e7e1af11ea066d2$var$Kt(e) : $4e7e1af11ea066d2$var$Qt(e) || $4e7e1af11ea066d2$var$Dt.throwArgumentError("invalid hex string", "value", e), e.length > 2 * t + 2 && $4e7e1af11ea066d2$var$Dt.throwArgumentError("value out of range", "value", arguments[1]); e.length < 2 * t + 2;)e = "0x0" + e.substring(2);
    return e;
}
function $4e7e1af11ea066d2$var$zn(e) {
    var t = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if ($4e7e1af11ea066d2$var$M0(e)) {
        var r = $4e7e1af11ea066d2$var$Ot(e);
        r.length === 64 ? (t.v = 27 + (r[32] >> 7), r[32] &= 127, t.r = $4e7e1af11ea066d2$var$Kt(r.slice(0, 32)), t.s = $4e7e1af11ea066d2$var$Kt(r.slice(32, 64))) : r.length === 65 ? (t.r = $4e7e1af11ea066d2$var$Kt(r.slice(0, 32)), t.s = $4e7e1af11ea066d2$var$Kt(r.slice(32, 64)), t.v = r[64]) : $4e7e1af11ea066d2$var$Dt.throwArgumentError("invalid signature string", "signature", e), t.v < 27 && (t.v === 0 || t.v === 1 ? t.v += 27 : $4e7e1af11ea066d2$var$Dt.throwArgumentError("signature invalid v byte", "signature", e)), t.recoveryParam = 1 - t.v % 2, t.recoveryParam && (r[32] |= 128), t._vs = $4e7e1af11ea066d2$var$Kt(r.slice(32, 64));
    } else {
        if (t.r = e.r, t.s = e.s, t.v = e.v, t.recoveryParam = e.recoveryParam, t._vs = e._vs, t._vs != null) {
            var n = $4e7e1af11ea066d2$var$S0($4e7e1af11ea066d2$var$Ot(t._vs), 32);
            t._vs = $4e7e1af11ea066d2$var$Kt(n);
            var o = n[0] >= 128 ? 1 : 0;
            t.recoveryParam == null ? t.recoveryParam = o : t.recoveryParam !== o && $4e7e1af11ea066d2$var$Dt.throwArgumentError("signature recoveryParam mismatch _vs", "signature", e), n[0] &= 127;
            var h = $4e7e1af11ea066d2$var$Kt(n);
            t.s == null ? t.s = h : t.s !== h && $4e7e1af11ea066d2$var$Dt.throwArgumentError("signature v mismatch _vs", "signature", e);
        }
        if (t.recoveryParam == null) t.v == null ? $4e7e1af11ea066d2$var$Dt.throwArgumentError("signature missing v and recoveryParam", "signature", e) : t.v === 0 || t.v === 1 ? t.recoveryParam = t.v : t.recoveryParam = 1 - t.v % 2;
        else if (t.v == null) t.v = 27 + t.recoveryParam;
        else {
            var n1 = t.v === 0 || t.v === 1 ? t.v : 1 - t.v % 2;
            t.recoveryParam !== n1 && $4e7e1af11ea066d2$var$Dt.throwArgumentError("signature recoveryParam mismatch v", "signature", e);
        }
        t.r == null || !$4e7e1af11ea066d2$var$Qt(t.r) ? $4e7e1af11ea066d2$var$Dt.throwArgumentError("signature missing or invalid r", "signature", e) : t.r = $4e7e1af11ea066d2$var$oe(t.r, 32), t.s == null || !$4e7e1af11ea066d2$var$Qt(t.s) ? $4e7e1af11ea066d2$var$Dt.throwArgumentError("signature missing or invalid s", "signature", e) : t.s = $4e7e1af11ea066d2$var$oe(t.s, 32);
        var r1 = $4e7e1af11ea066d2$var$Ot(t.s);
        r1[0] >= 128 && $4e7e1af11ea066d2$var$Dt.throwArgumentError("signature s out of range", "signature", e), t.recoveryParam && (r1[0] |= 128);
        var i = $4e7e1af11ea066d2$var$Kt(r1);
        t._vs && ($4e7e1af11ea066d2$var$Qt(t._vs) || $4e7e1af11ea066d2$var$Dt.throwArgumentError("signature invalid _vs", "signature", e), t._vs = $4e7e1af11ea066d2$var$oe(t._vs, 32)), t._vs == null ? t._vs = i : t._vs !== i && $4e7e1af11ea066d2$var$Dt.throwArgumentError("signature _vs mismatch v and s", "signature", e);
    }
    return t.yParityAndS = t._vs, t.compact = t.r + t.yParityAndS.substring(2), t;
}
function $4e7e1af11ea066d2$var$yi(e) {
    return "0x" + $4e7e1af11ea066d2$var$b0.keccak_256($4e7e1af11ea066d2$var$Ot(e));
}
var $4e7e1af11ea066d2$var$Ln = {
    exports: {}
}, $4e7e1af11ea066d2$var$I0 = {}, $4e7e1af11ea066d2$var$_0 = Object.freeze({
    __proto__: null,
    default: $4e7e1af11ea066d2$var$I0
}), $4e7e1af11ea066d2$var$B0 = $4e7e1af11ea066d2$var$A0($4e7e1af11ea066d2$var$_0);
(function(e) {
    (function(t, r) {
        function i(A, f) {
            if (!A) throw new Error(f || "Assertion failed");
        }
        function n(A, f) {
            A.super_ = f;
            var a = function a() {};
            a.prototype = f.prototype, A.prototype = new a, A.prototype.constructor = A;
        }
        function o(A, f, a) {
            if (o.isBN(A)) return A;
            this.negative = 0, this.words = null, this.length = 0, this.red = null, A !== null && ((f === "le" || f === "be") && (a = f, f = 10), this._init(A || 0, f || 10, a || "be"));
        }
        typeof t == "object" ? t.exports = o : r.BN = o, o.BN = o, o.wordSize = 26;
        var h;
        try {
            (typeof window === "undefined" ? "undefined" : (0, $l0HdX._)(window)) < "u" && (0, $l0HdX._)(window.Buffer) < "u" ? h = window.Buffer : h = $4e7e1af11ea066d2$var$B0.Buffer;
        } catch (e) {}
        o.isBN = function(f) {
            return f instanceof o ? !0 : f !== null && typeof f == "object" && f.constructor.wordSize === o.wordSize && Array.isArray(f.words);
        }, o.max = function(f, a) {
            return f.cmp(a) > 0 ? f : a;
        }, o.min = function(f, a) {
            return f.cmp(a) < 0 ? f : a;
        }, o.prototype._init = function(f, a, c) {
            if (typeof f == "number") return this._initNumber(f, a, c);
            if (typeof f == "object") return this._initArray(f, a, c);
            a === "hex" && (a = 16), i(a === (a | 0) && a >= 2 && a <= 36), f = f.toString().replace(/\s+/g, "");
            var d = 0;
            f[0] === "-" && (d++, this.negative = 1), d < f.length && (a === 16 ? this._parseHex(f, d, c) : (this._parseBase(f, a, d), c === "le" && this._initArray(this.toArray(), a, c)));
        }, o.prototype._initNumber = function(f, a, c) {
            f < 0 && (this.negative = 1, f = -f), f < 67108864 ? (this.words = [
                f & 67108863
            ], this.length = 1) : f < 4503599627370496 ? (this.words = [
                f & 67108863,
                f / 67108864 & 67108863
            ], this.length = 2) : (i(f < 9007199254740992), this.words = [
                f & 67108863,
                f / 67108864 & 67108863,
                1
            ], this.length = 3), c === "le" && this._initArray(this.toArray(), a, c);
        }, o.prototype._initArray = function(f, a, c) {
            if (i(typeof f.length == "number"), f.length <= 0) return this.words = [
                0
            ], this.length = 1, this;
            this.length = Math.ceil(f.length / 3), this.words = new Array(this.length);
            for(var d = 0; d < this.length; d++)this.words[d] = 0;
            var g, x, M = 0;
            if (c === "be") for(d = f.length - 1, g = 0; d >= 0; d -= 3)x = f[d] | f[d - 1] << 8 | f[d - 2] << 16, this.words[g] |= x << M & 67108863, this.words[g + 1] = x >>> 26 - M & 67108863, M += 24, M >= 26 && (M -= 26, g++);
            else if (c === "le") for(d = 0, g = 0; d < f.length; d += 3)x = f[d] | f[d + 1] << 8 | f[d + 2] << 16, this.words[g] |= x << M & 67108863, this.words[g + 1] = x >>> 26 - M & 67108863, M += 24, M >= 26 && (M -= 26, g++);
            return this._strip();
        };
        function p(A, f) {
            var a = A.charCodeAt(f);
            if (a >= 48 && a <= 57) return a - 48;
            if (a >= 65 && a <= 70) return a - 55;
            if (a >= 97 && a <= 102) return a - 87;
            i(!1, "Invalid character in " + A);
        }
        function b(A, f, a) {
            var c = p(A, a);
            return a - 1 >= f && (c |= p(A, a - 1) << 4), c;
        }
        o.prototype._parseHex = function(f, a, c) {
            this.length = Math.ceil((f.length - a) / 6), this.words = new Array(this.length);
            for(var d = 0; d < this.length; d++)this.words[d] = 0;
            var g = 0, x = 0, M;
            if (c === "be") for(d = f.length - 1; d >= a; d -= 2)M = b(f, a, d) << g, this.words[x] |= M & 67108863, g >= 18 ? (g -= 18, x += 1, this.words[x] |= M >>> 26) : g += 8;
            else {
                var l = f.length - a;
                for(d = l % 2 === 0 ? a + 1 : a; d < f.length; d += 2)M = b(f, a, d) << g, this.words[x] |= M & 67108863, g >= 18 ? (g -= 18, x += 1, this.words[x] |= M >>> 26) : g += 8;
            }
            this._strip();
        };
        function m(A, f, a, c) {
            for(var d = 0, g = 0, x = Math.min(A.length, a), M = f; M < x; M++){
                var l = A.charCodeAt(M) - 48;
                d *= c, l >= 49 ? g = l - 49 + 10 : l >= 17 ? g = l - 17 + 10 : g = l, i(l >= 0 && g < c, "Invalid character"), d += g;
            }
            return d;
        }
        o.prototype._parseBase = function(f, a, c) {
            this.words = [
                0
            ], this.length = 1;
            for(var d = 0, g = 1; g <= 67108863; g *= a)d++;
            d--, g = g / a | 0;
            for(var x = f.length - c, M = x % d, l = Math.min(x, x - M) + c, s = 0, v = c; v < l; v += d)s = m(f, v, v + d, a), this.imuln(g), this.words[0] + s < 67108864 ? this.words[0] += s : this._iaddn(s);
            if (M !== 0) {
                var k = 1;
                for(s = m(f, v, f.length, a), v = 0; v < M; v++)k *= a;
                this.imuln(k), this.words[0] + s < 67108864 ? this.words[0] += s : this._iaddn(s);
            }
            this._strip();
        }, o.prototype.copy = function(f) {
            f.words = new Array(this.length);
            for(var a = 0; a < this.length; a++)f.words[a] = this.words[a];
            f.length = this.length, f.negative = this.negative, f.red = this.red;
        };
        function w(A, f) {
            A.words = f.words, A.length = f.length, A.negative = f.negative, A.red = f.red;
        }
        if (o.prototype._move = function(f) {
            w(f, this);
        }, o.prototype.clone = function() {
            var f = new o(null);
            return this.copy(f), f;
        }, o.prototype._expand = function(f) {
            for(; this.length < f;)this.words[this.length++] = 0;
            return this;
        }, o.prototype._strip = function() {
            for(; this.length > 1 && this.words[this.length - 1] === 0;)this.length--;
            return this._normSign();
        }, o.prototype._normSign = function() {
            return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
        }, (typeof Symbol === "undefined" ? "undefined" : (0, $l0HdX._)(Symbol)) < "u" && typeof Symbol.for == "function") try {
            o.prototype[Symbol.for("nodejs.util.inspect.custom")] = y;
        } catch (e) {
            o.prototype.inspect = y;
        }
        else o.prototype.inspect = y;
        function y() {
            return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
        }
        var S = [
            "",
            "0",
            "00",
            "000",
            "0000",
            "00000",
            "000000",
            "0000000",
            "00000000",
            "000000000",
            "0000000000",
            "00000000000",
            "000000000000",
            "0000000000000",
            "00000000000000",
            "000000000000000",
            "0000000000000000",
            "00000000000000000",
            "000000000000000000",
            "0000000000000000000",
            "00000000000000000000",
            "000000000000000000000",
            "0000000000000000000000",
            "00000000000000000000000",
            "000000000000000000000000",
            "0000000000000000000000000"
        ], I = [
            0,
            0,
            25,
            16,
            12,
            11,
            10,
            9,
            8,
            8,
            7,
            7,
            7,
            7,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5
        ], N = [
            0,
            0,
            33554432,
            43046721,
            16777216,
            48828125,
            60466176,
            40353607,
            16777216,
            43046721,
            1e7,
            19487171,
            35831808,
            62748517,
            7529536,
            11390625,
            16777216,
            24137569,
            34012224,
            47045881,
            64e6,
            4084101,
            5153632,
            6436343,
            7962624,
            9765625,
            11881376,
            14348907,
            17210368,
            20511149,
            243e5,
            28629151,
            33554432,
            39135393,
            45435424,
            52521875,
            60466176
        ];
        o.prototype.toString = function(f, a) {
            f = f || 10, a = a | 0 || 1;
            var c;
            if (f === 16 || f === "hex") {
                c = "";
                for(var d = 0, g = 0, x = 0; x < this.length; x++){
                    var M = this.words[x], l = ((M << d | g) & 16777215).toString(16);
                    g = M >>> 24 - d & 16777215, d += 2, d >= 26 && (d -= 26, x--), g !== 0 || x !== this.length - 1 ? c = S[6 - l.length] + l + c : c = l + c;
                }
                for(g !== 0 && (c = g.toString(16) + c); c.length % a !== 0;)c = "0" + c;
                return this.negative !== 0 && (c = "-" + c), c;
            }
            if (f === (f | 0) && f >= 2 && f <= 36) {
                var s = I[f], v = N[f];
                c = "";
                var k = this.clone();
                for(k.negative = 0; !k.isZero();){
                    var u = k.modrn(v).toString(f);
                    k = k.idivn(v), k.isZero() ? c = u + c : c = S[s - u.length] + u + c;
                }
                for(this.isZero() && (c = "0" + c); c.length % a !== 0;)c = "0" + c;
                return this.negative !== 0 && (c = "-" + c), c;
            }
            i(!1, "Base should be between 2 and 36");
        }, o.prototype.toNumber = function() {
            var f = this.words[0];
            return this.length === 2 ? f += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? f += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -f : f;
        }, o.prototype.toJSON = function() {
            return this.toString(16, 2);
        }, h && (o.prototype.toBuffer = function(f, a) {
            return this.toArrayLike(h, f, a);
        }), o.prototype.toArray = function(f, a) {
            return this.toArrayLike(Array, f, a);
        };
        var C = function C(f, a) {
            return f.allocUnsafe ? f.allocUnsafe(a) : new f(a);
        };
        o.prototype.toArrayLike = function(f, a, c) {
            this._strip();
            var d = this.byteLength(), g = c || Math.max(1, d);
            i(d <= g, "byte array longer than desired length"), i(g > 0, "Requested array length <= 0");
            var x = C(f, g), M = a === "le" ? "LE" : "BE";
            return this["_toArrayLike" + M](x, d), x;
        }, o.prototype._toArrayLikeLE = function(f, a) {
            for(var c = 0, d = 0, g = 0, x = 0; g < this.length; g++){
                var M = this.words[g] << x | d;
                f[c++] = M & 255, c < f.length && (f[c++] = M >> 8 & 255), c < f.length && (f[c++] = M >> 16 & 255), x === 6 ? (c < f.length && (f[c++] = M >> 24 & 255), d = 0, x = 0) : (d = M >>> 24, x += 2);
            }
            if (c < f.length) for(f[c++] = d; c < f.length;)f[c++] = 0;
        }, o.prototype._toArrayLikeBE = function(f, a) {
            for(var c = f.length - 1, d = 0, g = 0, x = 0; g < this.length; g++){
                var M = this.words[g] << x | d;
                f[c--] = M & 255, c >= 0 && (f[c--] = M >> 8 & 255), c >= 0 && (f[c--] = M >> 16 & 255), x === 6 ? (c >= 0 && (f[c--] = M >> 24 & 255), d = 0, x = 0) : (d = M >>> 24, x += 2);
            }
            if (c >= 0) for(f[c--] = d; c >= 0;)f[c--] = 0;
        }, Math.clz32 ? o.prototype._countBits = function(f) {
            return 32 - Math.clz32(f);
        } : o.prototype._countBits = function(f) {
            var a = f, c = 0;
            return a >= 4096 && (c += 13, a >>>= 13), a >= 64 && (c += 7, a >>>= 7), a >= 8 && (c += 4, a >>>= 4), a >= 2 && (c += 2, a >>>= 2), c + a;
        }, o.prototype._zeroBits = function(f) {
            if (f === 0) return 26;
            var a = f, c = 0;
            return a & 8191 || (c += 13, a >>>= 13), a & 127 || (c += 7, a >>>= 7), a & 15 || (c += 4, a >>>= 4), a & 3 || (c += 2, a >>>= 2), a & 1 || c++, c;
        }, o.prototype.bitLength = function() {
            var f = this.words[this.length - 1], a = this._countBits(f);
            return (this.length - 1) * 26 + a;
        };
        function F(A) {
            for(var f = new Array(A.bitLength()), a = 0; a < f.length; a++){
                var c = a / 26 | 0, d = a % 26;
                f[a] = A.words[c] >>> d & 1;
            }
            return f;
        }
        o.prototype.zeroBits = function() {
            if (this.isZero()) return 0;
            for(var f = 0, a = 0; a < this.length; a++){
                var c = this._zeroBits(this.words[a]);
                if (f += c, c !== 26) break;
            }
            return f;
        }, o.prototype.byteLength = function() {
            return Math.ceil(this.bitLength() / 8);
        }, o.prototype.toTwos = function(f) {
            return this.negative !== 0 ? this.abs().inotn(f).iaddn(1) : this.clone();
        }, o.prototype.fromTwos = function(f) {
            return this.testn(f - 1) ? this.notn(f).iaddn(1).ineg() : this.clone();
        }, o.prototype.isNeg = function() {
            return this.negative !== 0;
        }, o.prototype.neg = function() {
            return this.clone().ineg();
        }, o.prototype.ineg = function() {
            return this.isZero() || (this.negative ^= 1), this;
        }, o.prototype.iuor = function(f) {
            for(; this.length < f.length;)this.words[this.length++] = 0;
            for(var a = 0; a < f.length; a++)this.words[a] = this.words[a] | f.words[a];
            return this._strip();
        }, o.prototype.ior = function(f) {
            return i((this.negative | f.negative) === 0), this.iuor(f);
        }, o.prototype.or = function(f) {
            return this.length > f.length ? this.clone().ior(f) : f.clone().ior(this);
        }, o.prototype.uor = function(f) {
            return this.length > f.length ? this.clone().iuor(f) : f.clone().iuor(this);
        }, o.prototype.iuand = function(f) {
            var a;
            this.length > f.length ? a = f : a = this;
            for(var c = 0; c < a.length; c++)this.words[c] = this.words[c] & f.words[c];
            return this.length = a.length, this._strip();
        }, o.prototype.iand = function(f) {
            return i((this.negative | f.negative) === 0), this.iuand(f);
        }, o.prototype.and = function(f) {
            return this.length > f.length ? this.clone().iand(f) : f.clone().iand(this);
        }, o.prototype.uand = function(f) {
            return this.length > f.length ? this.clone().iuand(f) : f.clone().iuand(this);
        }, o.prototype.iuxor = function(f) {
            var a, c;
            this.length > f.length ? (a = this, c = f) : (a = f, c = this);
            for(var d = 0; d < c.length; d++)this.words[d] = a.words[d] ^ c.words[d];
            if (this !== a) for(; d < a.length; d++)this.words[d] = a.words[d];
            return this.length = a.length, this._strip();
        }, o.prototype.ixor = function(f) {
            return i((this.negative | f.negative) === 0), this.iuxor(f);
        }, o.prototype.xor = function(f) {
            return this.length > f.length ? this.clone().ixor(f) : f.clone().ixor(this);
        }, o.prototype.uxor = function(f) {
            return this.length > f.length ? this.clone().iuxor(f) : f.clone().iuxor(this);
        }, o.prototype.inotn = function(f) {
            i(typeof f == "number" && f >= 0);
            var a = Math.ceil(f / 26) | 0, c = f % 26;
            this._expand(a), c > 0 && a--;
            for(var d = 0; d < a; d++)this.words[d] = ~this.words[d] & 67108863;
            return c > 0 && (this.words[d] = ~this.words[d] & 67108863 >> 26 - c), this._strip();
        }, o.prototype.notn = function(f) {
            return this.clone().inotn(f);
        }, o.prototype.setn = function(f, a) {
            i(typeof f == "number" && f >= 0);
            var c = f / 26 | 0, d = f % 26;
            return this._expand(c + 1), a ? this.words[c] = this.words[c] | 1 << d : this.words[c] = this.words[c] & ~(1 << d), this._strip();
        }, o.prototype.iadd = function(f) {
            var a;
            if (this.negative !== 0 && f.negative === 0) return this.negative = 0, a = this.isub(f), this.negative ^= 1, this._normSign();
            if (this.negative === 0 && f.negative !== 0) return f.negative = 0, a = this.isub(f), f.negative = 1, a._normSign();
            var c, d;
            this.length > f.length ? (c = this, d = f) : (c = f, d = this);
            for(var g = 0, x = 0; x < d.length; x++)a = (c.words[x] | 0) + (d.words[x] | 0) + g, this.words[x] = a & 67108863, g = a >>> 26;
            for(; g !== 0 && x < c.length; x++)a = (c.words[x] | 0) + g, this.words[x] = a & 67108863, g = a >>> 26;
            if (this.length = c.length, g !== 0) this.words[this.length] = g, this.length++;
            else if (c !== this) for(; x < c.length; x++)this.words[x] = c.words[x];
            return this;
        }, o.prototype.add = function(f) {
            var a;
            return f.negative !== 0 && this.negative === 0 ? (f.negative = 0, a = this.sub(f), f.negative ^= 1, a) : f.negative === 0 && this.negative !== 0 ? (this.negative = 0, a = f.sub(this), this.negative = 1, a) : this.length > f.length ? this.clone().iadd(f) : f.clone().iadd(this);
        }, o.prototype.isub = function(f) {
            if (f.negative !== 0) {
                f.negative = 0;
                var a = this.iadd(f);
                return f.negative = 1, a._normSign();
            } else if (this.negative !== 0) return this.negative = 0, this.iadd(f), this.negative = 1, this._normSign();
            var c = this.cmp(f);
            if (c === 0) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
            var d, g;
            c > 0 ? (d = this, g = f) : (d = f, g = this);
            for(var x = 0, M = 0; M < g.length; M++)a = (d.words[M] | 0) - (g.words[M] | 0) + x, x = a >> 26, this.words[M] = a & 67108863;
            for(; x !== 0 && M < d.length; M++)a = (d.words[M] | 0) + x, x = a >> 26, this.words[M] = a & 67108863;
            if (x === 0 && M < d.length && d !== this) for(; M < d.length; M++)this.words[M] = d.words[M];
            return this.length = Math.max(this.length, M), d !== this && (this.negative = 1), this._strip();
        }, o.prototype.sub = function(f) {
            return this.clone().isub(f);
        };
        function U(A, f, a) {
            a.negative = f.negative ^ A.negative;
            var c = A.length + f.length | 0;
            a.length = c, c = c - 1 | 0;
            var d = A.words[0] | 0, g = f.words[0] | 0, x = d * g, M = x & 67108863, l = x / 67108864 | 0;
            a.words[0] = M;
            for(var s = 1; s < c; s++){
                for(var v = l >>> 26, k = l & 67108863, u = Math.min(s, f.length - 1), E = Math.max(0, s - A.length + 1); E <= u; E++){
                    var _ = s - E | 0;
                    d = A.words[_] | 0, g = f.words[E] | 0, x = d * g + k, v += x / 67108864 | 0, k = x & 67108863;
                }
                a.words[s] = k | 0, l = v | 0;
            }
            return l !== 0 ? a.words[s] = l | 0 : a.length--, a._strip();
        }
        var J = function J(f, a, c) {
            var d = f.words, g = a.words, x = c.words, M = 0, l, s, v, k = d[0] | 0, u = k & 8191, E = k >>> 13, _ = d[1] | 0, B = _ & 8191, R = _ >>> 13, T = d[2] | 0, P = T & 8191, O = T >>> 13, Ct = d[3] | 0, D = Ct & 8191, q = Ct >>> 13, De = d[4] | 0, X = De & 8191, Z = De >>> 13, Fe = d[5] | 0, $ = Fe & 8191, tt = Fe >>> 13, Te = d[6] | 0, et = Te & 8191, rt = Te >>> 13, Ue = d[7] | 0, it = Ue & 8191, nt = Ue >>> 13, ke = d[8] | 0, ft = ke & 8191, ot = ke >>> 13, qe = d[9] | 0, st = qe & 8191, at = qe >>> 13, Ke = g[0] | 0, ut = Ke & 8191, ht = Ke >>> 13, He = g[1] | 0, ct = He & 8191, lt = He >>> 13, ze = g[2] | 0, dt = ze & 8191, pt = ze >>> 13, Le = g[3] | 0, vt = Le & 8191, mt = Le >>> 13, je = g[4] | 0, gt = je & 8191, At = je >>> 13, Qe = g[5] | 0, bt = Qe & 8191, yt = Qe >>> 13, Je = g[6] | 0, wt = Je & 8191, xt = Je >>> 13, Ge = g[7] | 0, Mt = Ge & 8191, Et = Ge >>> 13, Ye = g[8] | 0, St = Ye & 8191, Nt = Ye >>> 13, Ve = g[9] | 0, It = Ve & 8191, _t = Ve >>> 13;
            c.negative = f.negative ^ a.negative, c.length = 19, l = Math.imul(u, ut), s = Math.imul(u, ht), s = s + Math.imul(E, ut) | 0, v = Math.imul(E, ht);
            var Me = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, l = Math.imul(B, ut), s = Math.imul(B, ht), s = s + Math.imul(R, ut) | 0, v = Math.imul(R, ht), l = l + Math.imul(u, ct) | 0, s = s + Math.imul(u, lt) | 0, s = s + Math.imul(E, ct) | 0, v = v + Math.imul(E, lt) | 0;
            var Ee = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, l = Math.imul(P, ut), s = Math.imul(P, ht), s = s + Math.imul(O, ut) | 0, v = Math.imul(O, ht), l = l + Math.imul(B, ct) | 0, s = s + Math.imul(B, lt) | 0, s = s + Math.imul(R, ct) | 0, v = v + Math.imul(R, lt) | 0, l = l + Math.imul(u, dt) | 0, s = s + Math.imul(u, pt) | 0, s = s + Math.imul(E, dt) | 0, v = v + Math.imul(E, pt) | 0;
            var Se = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, l = Math.imul(D, ut), s = Math.imul(D, ht), s = s + Math.imul(q, ut) | 0, v = Math.imul(q, ht), l = l + Math.imul(P, ct) | 0, s = s + Math.imul(P, lt) | 0, s = s + Math.imul(O, ct) | 0, v = v + Math.imul(O, lt) | 0, l = l + Math.imul(B, dt) | 0, s = s + Math.imul(B, pt) | 0, s = s + Math.imul(R, dt) | 0, v = v + Math.imul(R, pt) | 0, l = l + Math.imul(u, vt) | 0, s = s + Math.imul(u, mt) | 0, s = s + Math.imul(E, vt) | 0, v = v + Math.imul(E, mt) | 0;
            var Ne = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Ne >>> 26) | 0, Ne &= 67108863, l = Math.imul(X, ut), s = Math.imul(X, ht), s = s + Math.imul(Z, ut) | 0, v = Math.imul(Z, ht), l = l + Math.imul(D, ct) | 0, s = s + Math.imul(D, lt) | 0, s = s + Math.imul(q, ct) | 0, v = v + Math.imul(q, lt) | 0, l = l + Math.imul(P, dt) | 0, s = s + Math.imul(P, pt) | 0, s = s + Math.imul(O, dt) | 0, v = v + Math.imul(O, pt) | 0, l = l + Math.imul(B, vt) | 0, s = s + Math.imul(B, mt) | 0, s = s + Math.imul(R, vt) | 0, v = v + Math.imul(R, mt) | 0, l = l + Math.imul(u, gt) | 0, s = s + Math.imul(u, At) | 0, s = s + Math.imul(E, gt) | 0, v = v + Math.imul(E, At) | 0;
            var Ie = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863, l = Math.imul($, ut), s = Math.imul($, ht), s = s + Math.imul(tt, ut) | 0, v = Math.imul(tt, ht), l = l + Math.imul(X, ct) | 0, s = s + Math.imul(X, lt) | 0, s = s + Math.imul(Z, ct) | 0, v = v + Math.imul(Z, lt) | 0, l = l + Math.imul(D, dt) | 0, s = s + Math.imul(D, pt) | 0, s = s + Math.imul(q, dt) | 0, v = v + Math.imul(q, pt) | 0, l = l + Math.imul(P, vt) | 0, s = s + Math.imul(P, mt) | 0, s = s + Math.imul(O, vt) | 0, v = v + Math.imul(O, mt) | 0, l = l + Math.imul(B, gt) | 0, s = s + Math.imul(B, At) | 0, s = s + Math.imul(R, gt) | 0, v = v + Math.imul(R, At) | 0, l = l + Math.imul(u, bt) | 0, s = s + Math.imul(u, yt) | 0, s = s + Math.imul(E, bt) | 0, v = v + Math.imul(E, yt) | 0;
            var Wr = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Wr >>> 26) | 0, Wr &= 67108863, l = Math.imul(et, ut), s = Math.imul(et, ht), s = s + Math.imul(rt, ut) | 0, v = Math.imul(rt, ht), l = l + Math.imul($, ct) | 0, s = s + Math.imul($, lt) | 0, s = s + Math.imul(tt, ct) | 0, v = v + Math.imul(tt, lt) | 0, l = l + Math.imul(X, dt) | 0, s = s + Math.imul(X, pt) | 0, s = s + Math.imul(Z, dt) | 0, v = v + Math.imul(Z, pt) | 0, l = l + Math.imul(D, vt) | 0, s = s + Math.imul(D, mt) | 0, s = s + Math.imul(q, vt) | 0, v = v + Math.imul(q, mt) | 0, l = l + Math.imul(P, gt) | 0, s = s + Math.imul(P, At) | 0, s = s + Math.imul(O, gt) | 0, v = v + Math.imul(O, At) | 0, l = l + Math.imul(B, bt) | 0, s = s + Math.imul(B, yt) | 0, s = s + Math.imul(R, bt) | 0, v = v + Math.imul(R, yt) | 0, l = l + Math.imul(u, wt) | 0, s = s + Math.imul(u, xt) | 0, s = s + Math.imul(E, wt) | 0, v = v + Math.imul(E, xt) | 0;
            var Xr = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Xr >>> 26) | 0, Xr &= 67108863, l = Math.imul(it, ut), s = Math.imul(it, ht), s = s + Math.imul(nt, ut) | 0, v = Math.imul(nt, ht), l = l + Math.imul(et, ct) | 0, s = s + Math.imul(et, lt) | 0, s = s + Math.imul(rt, ct) | 0, v = v + Math.imul(rt, lt) | 0, l = l + Math.imul($, dt) | 0, s = s + Math.imul($, pt) | 0, s = s + Math.imul(tt, dt) | 0, v = v + Math.imul(tt, pt) | 0, l = l + Math.imul(X, vt) | 0, s = s + Math.imul(X, mt) | 0, s = s + Math.imul(Z, vt) | 0, v = v + Math.imul(Z, mt) | 0, l = l + Math.imul(D, gt) | 0, s = s + Math.imul(D, At) | 0, s = s + Math.imul(q, gt) | 0, v = v + Math.imul(q, At) | 0, l = l + Math.imul(P, bt) | 0, s = s + Math.imul(P, yt) | 0, s = s + Math.imul(O, bt) | 0, v = v + Math.imul(O, yt) | 0, l = l + Math.imul(B, wt) | 0, s = s + Math.imul(B, xt) | 0, s = s + Math.imul(R, wt) | 0, v = v + Math.imul(R, xt) | 0, l = l + Math.imul(u, Mt) | 0, s = s + Math.imul(u, Et) | 0, s = s + Math.imul(E, Mt) | 0, v = v + Math.imul(E, Et) | 0;
            var Zr = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (Zr >>> 26) | 0, Zr &= 67108863, l = Math.imul(ft, ut), s = Math.imul(ft, ht), s = s + Math.imul(ot, ut) | 0, v = Math.imul(ot, ht), l = l + Math.imul(it, ct) | 0, s = s + Math.imul(it, lt) | 0, s = s + Math.imul(nt, ct) | 0, v = v + Math.imul(nt, lt) | 0, l = l + Math.imul(et, dt) | 0, s = s + Math.imul(et, pt) | 0, s = s + Math.imul(rt, dt) | 0, v = v + Math.imul(rt, pt) | 0, l = l + Math.imul($, vt) | 0, s = s + Math.imul($, mt) | 0, s = s + Math.imul(tt, vt) | 0, v = v + Math.imul(tt, mt) | 0, l = l + Math.imul(X, gt) | 0, s = s + Math.imul(X, At) | 0, s = s + Math.imul(Z, gt) | 0, v = v + Math.imul(Z, At) | 0, l = l + Math.imul(D, bt) | 0, s = s + Math.imul(D, yt) | 0, s = s + Math.imul(q, bt) | 0, v = v + Math.imul(q, yt) | 0, l = l + Math.imul(P, wt) | 0, s = s + Math.imul(P, xt) | 0, s = s + Math.imul(O, wt) | 0, v = v + Math.imul(O, xt) | 0, l = l + Math.imul(B, Mt) | 0, s = s + Math.imul(B, Et) | 0, s = s + Math.imul(R, Mt) | 0, v = v + Math.imul(R, Et) | 0, l = l + Math.imul(u, St) | 0, s = s + Math.imul(u, Nt) | 0, s = s + Math.imul(E, St) | 0, v = v + Math.imul(E, Nt) | 0;
            var $r = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + ($r >>> 26) | 0, $r &= 67108863, l = Math.imul(st, ut), s = Math.imul(st, ht), s = s + Math.imul(at, ut) | 0, v = Math.imul(at, ht), l = l + Math.imul(ft, ct) | 0, s = s + Math.imul(ft, lt) | 0, s = s + Math.imul(ot, ct) | 0, v = v + Math.imul(ot, lt) | 0, l = l + Math.imul(it, dt) | 0, s = s + Math.imul(it, pt) | 0, s = s + Math.imul(nt, dt) | 0, v = v + Math.imul(nt, pt) | 0, l = l + Math.imul(et, vt) | 0, s = s + Math.imul(et, mt) | 0, s = s + Math.imul(rt, vt) | 0, v = v + Math.imul(rt, mt) | 0, l = l + Math.imul($, gt) | 0, s = s + Math.imul($, At) | 0, s = s + Math.imul(tt, gt) | 0, v = v + Math.imul(tt, At) | 0, l = l + Math.imul(X, bt) | 0, s = s + Math.imul(X, yt) | 0, s = s + Math.imul(Z, bt) | 0, v = v + Math.imul(Z, yt) | 0, l = l + Math.imul(D, wt) | 0, s = s + Math.imul(D, xt) | 0, s = s + Math.imul(q, wt) | 0, v = v + Math.imul(q, xt) | 0, l = l + Math.imul(P, Mt) | 0, s = s + Math.imul(P, Et) | 0, s = s + Math.imul(O, Mt) | 0, v = v + Math.imul(O, Et) | 0, l = l + Math.imul(B, St) | 0, s = s + Math.imul(B, Nt) | 0, s = s + Math.imul(R, St) | 0, v = v + Math.imul(R, Nt) | 0, l = l + Math.imul(u, It) | 0, s = s + Math.imul(u, _t) | 0, s = s + Math.imul(E, It) | 0, v = v + Math.imul(E, _t) | 0;
            var ti = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (ti >>> 26) | 0, ti &= 67108863, l = Math.imul(st, ct), s = Math.imul(st, lt), s = s + Math.imul(at, ct) | 0, v = Math.imul(at, lt), l = l + Math.imul(ft, dt) | 0, s = s + Math.imul(ft, pt) | 0, s = s + Math.imul(ot, dt) | 0, v = v + Math.imul(ot, pt) | 0, l = l + Math.imul(it, vt) | 0, s = s + Math.imul(it, mt) | 0, s = s + Math.imul(nt, vt) | 0, v = v + Math.imul(nt, mt) | 0, l = l + Math.imul(et, gt) | 0, s = s + Math.imul(et, At) | 0, s = s + Math.imul(rt, gt) | 0, v = v + Math.imul(rt, At) | 0, l = l + Math.imul($, bt) | 0, s = s + Math.imul($, yt) | 0, s = s + Math.imul(tt, bt) | 0, v = v + Math.imul(tt, yt) | 0, l = l + Math.imul(X, wt) | 0, s = s + Math.imul(X, xt) | 0, s = s + Math.imul(Z, wt) | 0, v = v + Math.imul(Z, xt) | 0, l = l + Math.imul(D, Mt) | 0, s = s + Math.imul(D, Et) | 0, s = s + Math.imul(q, Mt) | 0, v = v + Math.imul(q, Et) | 0, l = l + Math.imul(P, St) | 0, s = s + Math.imul(P, Nt) | 0, s = s + Math.imul(O, St) | 0, v = v + Math.imul(O, Nt) | 0, l = l + Math.imul(B, It) | 0, s = s + Math.imul(B, _t) | 0, s = s + Math.imul(R, It) | 0, v = v + Math.imul(R, _t) | 0;
            var ei = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (ei >>> 26) | 0, ei &= 67108863, l = Math.imul(st, dt), s = Math.imul(st, pt), s = s + Math.imul(at, dt) | 0, v = Math.imul(at, pt), l = l + Math.imul(ft, vt) | 0, s = s + Math.imul(ft, mt) | 0, s = s + Math.imul(ot, vt) | 0, v = v + Math.imul(ot, mt) | 0, l = l + Math.imul(it, gt) | 0, s = s + Math.imul(it, At) | 0, s = s + Math.imul(nt, gt) | 0, v = v + Math.imul(nt, At) | 0, l = l + Math.imul(et, bt) | 0, s = s + Math.imul(et, yt) | 0, s = s + Math.imul(rt, bt) | 0, v = v + Math.imul(rt, yt) | 0, l = l + Math.imul($, wt) | 0, s = s + Math.imul($, xt) | 0, s = s + Math.imul(tt, wt) | 0, v = v + Math.imul(tt, xt) | 0, l = l + Math.imul(X, Mt) | 0, s = s + Math.imul(X, Et) | 0, s = s + Math.imul(Z, Mt) | 0, v = v + Math.imul(Z, Et) | 0, l = l + Math.imul(D, St) | 0, s = s + Math.imul(D, Nt) | 0, s = s + Math.imul(q, St) | 0, v = v + Math.imul(q, Nt) | 0, l = l + Math.imul(P, It) | 0, s = s + Math.imul(P, _t) | 0, s = s + Math.imul(O, It) | 0, v = v + Math.imul(O, _t) | 0;
            var ri = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (ri >>> 26) | 0, ri &= 67108863, l = Math.imul(st, vt), s = Math.imul(st, mt), s = s + Math.imul(at, vt) | 0, v = Math.imul(at, mt), l = l + Math.imul(ft, gt) | 0, s = s + Math.imul(ft, At) | 0, s = s + Math.imul(ot, gt) | 0, v = v + Math.imul(ot, At) | 0, l = l + Math.imul(it, bt) | 0, s = s + Math.imul(it, yt) | 0, s = s + Math.imul(nt, bt) | 0, v = v + Math.imul(nt, yt) | 0, l = l + Math.imul(et, wt) | 0, s = s + Math.imul(et, xt) | 0, s = s + Math.imul(rt, wt) | 0, v = v + Math.imul(rt, xt) | 0, l = l + Math.imul($, Mt) | 0, s = s + Math.imul($, Et) | 0, s = s + Math.imul(tt, Mt) | 0, v = v + Math.imul(tt, Et) | 0, l = l + Math.imul(X, St) | 0, s = s + Math.imul(X, Nt) | 0, s = s + Math.imul(Z, St) | 0, v = v + Math.imul(Z, Nt) | 0, l = l + Math.imul(D, It) | 0, s = s + Math.imul(D, _t) | 0, s = s + Math.imul(q, It) | 0, v = v + Math.imul(q, _t) | 0;
            var ii = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (ii >>> 26) | 0, ii &= 67108863, l = Math.imul(st, gt), s = Math.imul(st, At), s = s + Math.imul(at, gt) | 0, v = Math.imul(at, At), l = l + Math.imul(ft, bt) | 0, s = s + Math.imul(ft, yt) | 0, s = s + Math.imul(ot, bt) | 0, v = v + Math.imul(ot, yt) | 0, l = l + Math.imul(it, wt) | 0, s = s + Math.imul(it, xt) | 0, s = s + Math.imul(nt, wt) | 0, v = v + Math.imul(nt, xt) | 0, l = l + Math.imul(et, Mt) | 0, s = s + Math.imul(et, Et) | 0, s = s + Math.imul(rt, Mt) | 0, v = v + Math.imul(rt, Et) | 0, l = l + Math.imul($, St) | 0, s = s + Math.imul($, Nt) | 0, s = s + Math.imul(tt, St) | 0, v = v + Math.imul(tt, Nt) | 0, l = l + Math.imul(X, It) | 0, s = s + Math.imul(X, _t) | 0, s = s + Math.imul(Z, It) | 0, v = v + Math.imul(Z, _t) | 0;
            var ni = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (ni >>> 26) | 0, ni &= 67108863, l = Math.imul(st, bt), s = Math.imul(st, yt), s = s + Math.imul(at, bt) | 0, v = Math.imul(at, yt), l = l + Math.imul(ft, wt) | 0, s = s + Math.imul(ft, xt) | 0, s = s + Math.imul(ot, wt) | 0, v = v + Math.imul(ot, xt) | 0, l = l + Math.imul(it, Mt) | 0, s = s + Math.imul(it, Et) | 0, s = s + Math.imul(nt, Mt) | 0, v = v + Math.imul(nt, Et) | 0, l = l + Math.imul(et, St) | 0, s = s + Math.imul(et, Nt) | 0, s = s + Math.imul(rt, St) | 0, v = v + Math.imul(rt, Nt) | 0, l = l + Math.imul($, It) | 0, s = s + Math.imul($, _t) | 0, s = s + Math.imul(tt, It) | 0, v = v + Math.imul(tt, _t) | 0;
            var fi = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (fi >>> 26) | 0, fi &= 67108863, l = Math.imul(st, wt), s = Math.imul(st, xt), s = s + Math.imul(at, wt) | 0, v = Math.imul(at, xt), l = l + Math.imul(ft, Mt) | 0, s = s + Math.imul(ft, Et) | 0, s = s + Math.imul(ot, Mt) | 0, v = v + Math.imul(ot, Et) | 0, l = l + Math.imul(it, St) | 0, s = s + Math.imul(it, Nt) | 0, s = s + Math.imul(nt, St) | 0, v = v + Math.imul(nt, Nt) | 0, l = l + Math.imul(et, It) | 0, s = s + Math.imul(et, _t) | 0, s = s + Math.imul(rt, It) | 0, v = v + Math.imul(rt, _t) | 0;
            var oi = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (oi >>> 26) | 0, oi &= 67108863, l = Math.imul(st, Mt), s = Math.imul(st, Et), s = s + Math.imul(at, Mt) | 0, v = Math.imul(at, Et), l = l + Math.imul(ft, St) | 0, s = s + Math.imul(ft, Nt) | 0, s = s + Math.imul(ot, St) | 0, v = v + Math.imul(ot, Nt) | 0, l = l + Math.imul(it, It) | 0, s = s + Math.imul(it, _t) | 0, s = s + Math.imul(nt, It) | 0, v = v + Math.imul(nt, _t) | 0;
            var si = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (si >>> 26) | 0, si &= 67108863, l = Math.imul(st, St), s = Math.imul(st, Nt), s = s + Math.imul(at, St) | 0, v = Math.imul(at, Nt), l = l + Math.imul(ft, It) | 0, s = s + Math.imul(ft, _t) | 0, s = s + Math.imul(ot, It) | 0, v = v + Math.imul(ot, _t) | 0;
            var ai = (M + l | 0) + ((s & 8191) << 13) | 0;
            M = (v + (s >>> 13) | 0) + (ai >>> 26) | 0, ai &= 67108863, l = Math.imul(st, It), s = Math.imul(st, _t), s = s + Math.imul(at, It) | 0, v = Math.imul(at, _t);
            var ui = (M + l | 0) + ((s & 8191) << 13) | 0;
            return M = (v + (s >>> 13) | 0) + (ui >>> 26) | 0, ui &= 67108863, x[0] = Me, x[1] = Ee, x[2] = Se, x[3] = Ne, x[4] = Ie, x[5] = Wr, x[6] = Xr, x[7] = Zr, x[8] = $r, x[9] = ti, x[10] = ei, x[11] = ri, x[12] = ii, x[13] = ni, x[14] = fi, x[15] = oi, x[16] = si, x[17] = ai, x[18] = ui, M !== 0 && (x[19] = M, c.length++), c;
        };
        Math.imul || (J = U);
        function Bt(A, f, a) {
            a.negative = f.negative ^ A.negative, a.length = A.length + f.length;
            for(var c = 0, d = 0, g = 0; g < a.length - 1; g++){
                var x = d;
                d = 0;
                for(var M = c & 67108863, l = Math.min(g, f.length - 1), s = Math.max(0, g - A.length + 1); s <= l; s++){
                    var v = g - s, k = A.words[v] | 0, u = f.words[s] | 0, E = k * u, _ = E & 67108863;
                    x = x + (E / 67108864 | 0) | 0, _ = _ + M | 0, M = _ & 67108863, x = x + (_ >>> 26) | 0, d += x >>> 26, x &= 67108863;
                }
                a.words[g] = M, c = x, x = d;
            }
            return c !== 0 ? a.words[g] = c : a.length--, a._strip();
        }
        function G(A, f, a) {
            return Bt(A, f, a);
        }
        o.prototype.mulTo = function(f, a) {
            var c, d = this.length + f.length;
            return this.length === 10 && f.length === 10 ? c = J(this, f, a) : d < 63 ? c = U(this, f, a) : d < 1024 ? c = Bt(this, f, a) : c = G(this, f, a), c;
        }, o.prototype.mul = function(f) {
            var a = new o(null);
            return a.words = new Array(this.length + f.length), this.mulTo(f, a);
        }, o.prototype.mulf = function(f) {
            var a = new o(null);
            return a.words = new Array(this.length + f.length), G(this, f, a);
        }, o.prototype.imul = function(f) {
            return this.clone().mulTo(f, this);
        }, o.prototype.imuln = function(f) {
            var a = f < 0;
            a && (f = -f), i(typeof f == "number"), i(f < 67108864);
            for(var c = 0, d = 0; d < this.length; d++){
                var g = (this.words[d] | 0) * f, x = (g & 67108863) + (c & 67108863);
                c >>= 26, c += g / 67108864 | 0, c += x >>> 26, this.words[d] = x & 67108863;
            }
            return c !== 0 && (this.words[d] = c, this.length++), a ? this.ineg() : this;
        }, o.prototype.muln = function(f) {
            return this.clone().imuln(f);
        }, o.prototype.sqr = function() {
            return this.mul(this);
        }, o.prototype.isqr = function() {
            return this.imul(this.clone());
        }, o.prototype.pow = function(f) {
            var a = F(f);
            if (a.length === 0) return new o(1);
            for(var c = this, d = 0; d < a.length && a[d] === 0; d++, c = c.sqr());
            if (++d < a.length) for(var g = c.sqr(); d < a.length; d++, g = g.sqr())a[d] !== 0 && (c = c.mul(g));
            return c;
        }, o.prototype.iushln = function(f) {
            i(typeof f == "number" && f >= 0);
            var a = f % 26, c = (f - a) / 26, d = 67108863 >>> 26 - a << 26 - a, g;
            if (a !== 0) {
                var x = 0;
                for(g = 0; g < this.length; g++){
                    var M = this.words[g] & d, l = (this.words[g] | 0) - M << a;
                    this.words[g] = l | x, x = M >>> 26 - a;
                }
                x && (this.words[g] = x, this.length++);
            }
            if (c !== 0) {
                for(g = this.length - 1; g >= 0; g--)this.words[g + c] = this.words[g];
                for(g = 0; g < c; g++)this.words[g] = 0;
                this.length += c;
            }
            return this._strip();
        }, o.prototype.ishln = function(f) {
            return i(this.negative === 0), this.iushln(f);
        }, o.prototype.iushrn = function(f, a, c) {
            i(typeof f == "number" && f >= 0);
            var d;
            a ? d = (a - a % 26) / 26 : d = 0;
            var g = f % 26, x = Math.min((f - g) / 26, this.length), M = 67108863 ^ 67108863 >>> g << g, l = c;
            if (d -= x, d = Math.max(0, d), l) {
                for(var s = 0; s < x; s++)l.words[s] = this.words[s];
                l.length = x;
            }
            if (x !== 0) {
                if (this.length > x) for(this.length -= x, s = 0; s < this.length; s++)this.words[s] = this.words[s + x];
                else this.words[0] = 0, this.length = 1;
            }
            var v = 0;
            for(s = this.length - 1; s >= 0 && (v !== 0 || s >= d); s--){
                var k = this.words[s] | 0;
                this.words[s] = v << 26 - g | k >>> g, v = k & M;
            }
            return l && v !== 0 && (l.words[l.length++] = v), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
        }, o.prototype.ishrn = function(f, a, c) {
            return i(this.negative === 0), this.iushrn(f, a, c);
        }, o.prototype.shln = function(f) {
            return this.clone().ishln(f);
        }, o.prototype.ushln = function(f) {
            return this.clone().iushln(f);
        }, o.prototype.shrn = function(f) {
            return this.clone().ishrn(f);
        }, o.prototype.ushrn = function(f) {
            return this.clone().iushrn(f);
        }, o.prototype.testn = function(f) {
            i(typeof f == "number" && f >= 0);
            var a = f % 26, c = (f - a) / 26, d = 1 << a;
            if (this.length <= c) return !1;
            var g = this.words[c];
            return !!(g & d);
        }, o.prototype.imaskn = function(f) {
            i(typeof f == "number" && f >= 0);
            var a = f % 26, c = (f - a) / 26;
            if (i(this.negative === 0, "imaskn works only with positive numbers"), this.length <= c) return this;
            if (a !== 0 && c++, this.length = Math.min(c, this.length), a !== 0) {
                var d = 67108863 ^ 67108863 >>> a << a;
                this.words[this.length - 1] &= d;
            }
            return this._strip();
        }, o.prototype.maskn = function(f) {
            return this.clone().imaskn(f);
        }, o.prototype.iaddn = function(f) {
            return i(typeof f == "number"), i(f < 67108864), f < 0 ? this.isubn(-f) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= f ? (this.words[0] = f - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(f), this.negative = 1, this) : this._iaddn(f);
        }, o.prototype._iaddn = function(f) {
            this.words[0] += f;
            for(var a = 0; a < this.length && this.words[a] >= 67108864; a++)this.words[a] -= 67108864, a === this.length - 1 ? this.words[a + 1] = 1 : this.words[a + 1]++;
            return this.length = Math.max(this.length, a + 1), this;
        }, o.prototype.isubn = function(f) {
            if (i(typeof f == "number"), i(f < 67108864), f < 0) return this.iaddn(-f);
            if (this.negative !== 0) return this.negative = 0, this.iaddn(f), this.negative = 1, this;
            if (this.words[0] -= f, this.length === 1 && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;
            else for(var a = 0; a < this.length && this.words[a] < 0; a++)this.words[a] += 67108864, this.words[a + 1] -= 1;
            return this._strip();
        }, o.prototype.addn = function(f) {
            return this.clone().iaddn(f);
        }, o.prototype.subn = function(f) {
            return this.clone().isubn(f);
        }, o.prototype.iabs = function() {
            return this.negative = 0, this;
        }, o.prototype.abs = function() {
            return this.clone().iabs();
        }, o.prototype._ishlnsubmul = function(f, a, c) {
            var d = f.length + c, g;
            this._expand(d);
            var x, M = 0;
            for(g = 0; g < f.length; g++){
                x = (this.words[g + c] | 0) + M;
                var l = (f.words[g] | 0) * a;
                x -= l & 67108863, M = (x >> 26) - (l / 67108864 | 0), this.words[g + c] = x & 67108863;
            }
            for(; g < this.length - c; g++)x = (this.words[g + c] | 0) + M, M = x >> 26, this.words[g + c] = x & 67108863;
            if (M === 0) return this._strip();
            for(i(M === -1), M = 0, g = 0; g < this.length; g++)x = -(this.words[g] | 0) + M, M = x >> 26, this.words[g] = x & 67108863;
            return this.negative = 1, this._strip();
        }, o.prototype._wordDiv = function(f, a) {
            var c = this.length - f.length, d = this.clone(), g = f, x = g.words[g.length - 1] | 0, M = this._countBits(x);
            c = 26 - M, c !== 0 && (g = g.ushln(c), d.iushln(c), x = g.words[g.length - 1] | 0);
            var l = d.length - g.length, s;
            if (a !== "mod") {
                s = new o(null), s.length = l + 1, s.words = new Array(s.length);
                for(var v = 0; v < s.length; v++)s.words[v] = 0;
            }
            var k = d.clone()._ishlnsubmul(g, 1, l);
            k.negative === 0 && (d = k, s && (s.words[l] = 1));
            for(var u = l - 1; u >= 0; u--){
                var E = (d.words[g.length + u] | 0) * 67108864 + (d.words[g.length + u - 1] | 0);
                for(E = Math.min(E / x | 0, 67108863), d._ishlnsubmul(g, E, u); d.negative !== 0;)E--, d.negative = 0, d._ishlnsubmul(g, 1, u), d.isZero() || (d.negative ^= 1);
                s && (s.words[u] = E);
            }
            return s && s._strip(), d._strip(), a !== "div" && c !== 0 && d.iushrn(c), {
                div: s || null,
                mod: d
            };
        }, o.prototype.divmod = function(f, a, c) {
            if (i(!f.isZero()), this.isZero()) return {
                div: new o(0),
                mod: new o(0)
            };
            var d, g, x;
            return this.negative !== 0 && f.negative === 0 ? (x = this.neg().divmod(f, a), a !== "mod" && (d = x.div.neg()), a !== "div" && (g = x.mod.neg(), c && g.negative !== 0 && g.iadd(f)), {
                div: d,
                mod: g
            }) : this.negative === 0 && f.negative !== 0 ? (x = this.divmod(f.neg(), a), a !== "mod" && (d = x.div.neg()), {
                div: d,
                mod: x.mod
            }) : this.negative & f.negative ? (x = this.neg().divmod(f.neg(), a), a !== "div" && (g = x.mod.neg(), c && g.negative !== 0 && g.isub(f)), {
                div: x.div,
                mod: g
            }) : f.length > this.length || this.cmp(f) < 0 ? {
                div: new o(0),
                mod: this
            } : f.length === 1 ? a === "div" ? {
                div: this.divn(f.words[0]),
                mod: null
            } : a === "mod" ? {
                div: null,
                mod: new o(this.modrn(f.words[0]))
            } : {
                div: this.divn(f.words[0]),
                mod: new o(this.modrn(f.words[0]))
            } : this._wordDiv(f, a);
        }, o.prototype.div = function(f) {
            return this.divmod(f, "div", !1).div;
        }, o.prototype.mod = function(f) {
            return this.divmod(f, "mod", !1).mod;
        }, o.prototype.umod = function(f) {
            return this.divmod(f, "mod", !0).mod;
        }, o.prototype.divRound = function(f) {
            var a = this.divmod(f);
            if (a.mod.isZero()) return a.div;
            var c = a.div.negative !== 0 ? a.mod.isub(f) : a.mod, d = f.ushrn(1), g = f.andln(1), x = c.cmp(d);
            return x < 0 || g === 1 && x === 0 ? a.div : a.div.negative !== 0 ? a.div.isubn(1) : a.div.iaddn(1);
        }, o.prototype.modrn = function(f) {
            var a = f < 0;
            a && (f = -f), i(f <= 67108863);
            for(var c = 67108864 % f, d = 0, g = this.length - 1; g >= 0; g--)d = (c * d + (this.words[g] | 0)) % f;
            return a ? -d : d;
        }, o.prototype.modn = function(f) {
            return this.modrn(f);
        }, o.prototype.idivn = function(f) {
            var a = f < 0;
            a && (f = -f), i(f <= 67108863);
            for(var c = 0, d = this.length - 1; d >= 0; d--){
                var g = (this.words[d] | 0) + c * 67108864;
                this.words[d] = g / f | 0, c = g % f;
            }
            return this._strip(), a ? this.ineg() : this;
        }, o.prototype.divn = function(f) {
            return this.clone().idivn(f);
        }, o.prototype.egcd = function(f) {
            i(f.negative === 0), i(!f.isZero());
            var a = this, c = f.clone();
            a.negative !== 0 ? a = a.umod(f) : a = a.clone();
            for(var d = new o(1), g = new o(0), x = new o(0), M = new o(1), l = 0; a.isEven() && c.isEven();)a.iushrn(1), c.iushrn(1), ++l;
            for(var s = c.clone(), v = a.clone(); !a.isZero();){
                for(var k = 0, u = 1; !(a.words[0] & u) && k < 26; ++k, u <<= 1);
                if (k > 0) for(a.iushrn(k); k-- > 0;)(d.isOdd() || g.isOdd()) && (d.iadd(s), g.isub(v)), d.iushrn(1), g.iushrn(1);
                for(var E = 0, _ = 1; !(c.words[0] & _) && E < 26; ++E, _ <<= 1);
                if (E > 0) for(c.iushrn(E); E-- > 0;)(x.isOdd() || M.isOdd()) && (x.iadd(s), M.isub(v)), x.iushrn(1), M.iushrn(1);
                a.cmp(c) >= 0 ? (a.isub(c), d.isub(x), g.isub(M)) : (c.isub(a), x.isub(d), M.isub(g));
            }
            return {
                a: x,
                b: M,
                gcd: c.iushln(l)
            };
        }, o.prototype._invmp = function(f) {
            i(f.negative === 0), i(!f.isZero());
            var a = this, c = f.clone();
            a.negative !== 0 ? a = a.umod(f) : a = a.clone();
            for(var d = new o(1), g = new o(0), x = c.clone(); a.cmpn(1) > 0 && c.cmpn(1) > 0;){
                for(var M = 0, l = 1; !(a.words[0] & l) && M < 26; ++M, l <<= 1);
                if (M > 0) for(a.iushrn(M); M-- > 0;)d.isOdd() && d.iadd(x), d.iushrn(1);
                for(var s = 0, v = 1; !(c.words[0] & v) && s < 26; ++s, v <<= 1);
                if (s > 0) for(c.iushrn(s); s-- > 0;)g.isOdd() && g.iadd(x), g.iushrn(1);
                a.cmp(c) >= 0 ? (a.isub(c), d.isub(g)) : (c.isub(a), g.isub(d));
            }
            var k;
            return a.cmpn(1) === 0 ? k = d : k = g, k.cmpn(0) < 0 && k.iadd(f), k;
        }, o.prototype.gcd = function(f) {
            if (this.isZero()) return f.abs();
            if (f.isZero()) return this.abs();
            var a = this.clone(), c = f.clone();
            a.negative = 0, c.negative = 0;
            for(var d = 0; a.isEven() && c.isEven(); d++)a.iushrn(1), c.iushrn(1);
            do {
                for(; a.isEven();)a.iushrn(1);
                for(; c.isEven();)c.iushrn(1);
                var g = a.cmp(c);
                if (g < 0) {
                    var x = a;
                    a = c, c = x;
                } else if (g === 0 || c.cmpn(1) === 0) break;
                a.isub(c);
            }while (!0);
            return c.iushln(d);
        }, o.prototype.invm = function(f) {
            return this.egcd(f).a.umod(f);
        }, o.prototype.isEven = function() {
            return (this.words[0] & 1) === 0;
        }, o.prototype.isOdd = function() {
            return (this.words[0] & 1) === 1;
        }, o.prototype.andln = function(f) {
            return this.words[0] & f;
        }, o.prototype.bincn = function(f) {
            i(typeof f == "number");
            var a = f % 26, c = (f - a) / 26, d = 1 << a;
            if (this.length <= c) return this._expand(c + 1), this.words[c] |= d, this;
            for(var g = d, x = c; g !== 0 && x < this.length; x++){
                var M = this.words[x] | 0;
                M += g, g = M >>> 26, M &= 67108863, this.words[x] = M;
            }
            return g !== 0 && (this.words[x] = g, this.length++), this;
        }, o.prototype.isZero = function() {
            return this.length === 1 && this.words[0] === 0;
        }, o.prototype.cmpn = function(f) {
            var a = f < 0;
            if (this.negative !== 0 && !a) return -1;
            if (this.negative === 0 && a) return 1;
            this._strip();
            var c;
            if (this.length > 1) c = 1;
            else {
                a && (f = -f), i(f <= 67108863, "Number is too big");
                var d = this.words[0] | 0;
                c = d === f ? 0 : d < f ? -1 : 1;
            }
            return this.negative !== 0 ? -c | 0 : c;
        }, o.prototype.cmp = function(f) {
            if (this.negative !== 0 && f.negative === 0) return -1;
            if (this.negative === 0 && f.negative !== 0) return 1;
            var a = this.ucmp(f);
            return this.negative !== 0 ? -a | 0 : a;
        }, o.prototype.ucmp = function(f) {
            if (this.length > f.length) return 1;
            if (this.length < f.length) return -1;
            for(var a = 0, c = this.length - 1; c >= 0; c--){
                var d = this.words[c] | 0, g = f.words[c] | 0;
                if (d !== g) {
                    d < g ? a = -1 : d > g && (a = 1);
                    break;
                }
            }
            return a;
        }, o.prototype.gtn = function(f) {
            return this.cmpn(f) === 1;
        }, o.prototype.gt = function(f) {
            return this.cmp(f) === 1;
        }, o.prototype.gten = function(f) {
            return this.cmpn(f) >= 0;
        }, o.prototype.gte = function(f) {
            return this.cmp(f) >= 0;
        }, o.prototype.ltn = function(f) {
            return this.cmpn(f) === -1;
        }, o.prototype.lt = function(f) {
            return this.cmp(f) === -1;
        }, o.prototype.lten = function(f) {
            return this.cmpn(f) <= 0;
        }, o.prototype.lte = function(f) {
            return this.cmp(f) <= 0;
        }, o.prototype.eqn = function(f) {
            return this.cmpn(f) === 0;
        }, o.prototype.eq = function(f) {
            return this.cmp(f) === 0;
        }, o.red = function(f) {
            return new Y(f);
        }, o.prototype.toRed = function(f) {
            return i(!this.red, "Already a number in reduction context"), i(this.negative === 0, "red works only with positives"), f.convertTo(this)._forceRed(f);
        }, o.prototype.fromRed = function() {
            return i(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
        }, o.prototype._forceRed = function(f) {
            return this.red = f, this;
        }, o.prototype.forceRed = function(f) {
            return i(!this.red, "Already a number in reduction context"), this._forceRed(f);
        }, o.prototype.redAdd = function(f) {
            return i(this.red, "redAdd works only with red numbers"), this.red.add(this, f);
        }, o.prototype.redIAdd = function(f) {
            return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, f);
        }, o.prototype.redSub = function(f) {
            return i(this.red, "redSub works only with red numbers"), this.red.sub(this, f);
        }, o.prototype.redISub = function(f) {
            return i(this.red, "redISub works only with red numbers"), this.red.isub(this, f);
        }, o.prototype.redShl = function(f) {
            return i(this.red, "redShl works only with red numbers"), this.red.shl(this, f);
        }, o.prototype.redMul = function(f) {
            return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, f), this.red.mul(this, f);
        }, o.prototype.redIMul = function(f) {
            return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, f), this.red.imul(this, f);
        }, o.prototype.redSqr = function() {
            return i(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
        }, o.prototype.redISqr = function() {
            return i(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
        }, o.prototype.redSqrt = function() {
            return i(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
        }, o.prototype.redInvm = function() {
            return i(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
        }, o.prototype.redNeg = function() {
            return i(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
        }, o.prototype.redPow = function(f) {
            return i(this.red && !f.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, f);
        };
        var H = {
            k256: null,
            p224: null,
            p192: null,
            p25519: null
        };
        function z(A, f) {
            this.name = A, this.p = new o(f, 16), this.n = this.p.bitLength(), this.k = new o(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
        }
        z.prototype._tmp = function() {
            var f = new o(null);
            return f.words = new Array(Math.ceil(this.n / 13)), f;
        }, z.prototype.ireduce = function(f) {
            var a = f, c;
            do this.split(a, this.tmp), a = this.imulK(a), a = a.iadd(this.tmp), c = a.bitLength();
            while (c > this.n);
            var d = c < this.n ? -1 : a.ucmp(this.p);
            return d === 0 ? (a.words[0] = 0, a.length = 1) : d > 0 ? a.isub(this.p) : a.strip !== void 0 ? a.strip() : a._strip(), a;
        }, z.prototype.split = function(f, a) {
            f.iushrn(this.n, 0, a);
        }, z.prototype.imulK = function(f) {
            return f.imul(this.k);
        };
        function Pt() {
            z.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
        }
        n(Pt, z), Pt.prototype.split = function(f, a) {
            for(var c = 4194303, d = Math.min(f.length, 9), g = 0; g < d; g++)a.words[g] = f.words[g];
            if (a.length = d, f.length <= 9) {
                f.words[0] = 0, f.length = 1;
                return;
            }
            var x = f.words[9];
            for(a.words[a.length++] = x & c, g = 10; g < f.length; g++){
                var M = f.words[g] | 0;
                f.words[g - 10] = (M & c) << 4 | x >>> 22, x = M;
            }
            x >>>= 22, f.words[g - 10] = x, x === 0 && f.length > 10 ? f.length -= 10 : f.length -= 9;
        }, Pt.prototype.imulK = function(f) {
            f.words[f.length] = 0, f.words[f.length + 1] = 0, f.length += 2;
            for(var a = 0, c = 0; c < f.length; c++){
                var d = f.words[c] | 0;
                a += d * 977, f.words[c] = a & 67108863, a = d * 64 + (a / 67108864 | 0);
            }
            return f.words[f.length - 1] === 0 && (f.length--, f.words[f.length - 1] === 0 && f.length--), f;
        };
        function W() {
            z.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
        }
        n(W, z);
        function Rt() {
            z.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
        }
        n(Rt, z);
        function Yt() {
            z.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
        }
        n(Yt, z), Yt.prototype.imulK = function(f) {
            for(var a = 0, c = 0; c < f.length; c++){
                var d = (f.words[c] | 0) * 19 + a, g = d & 67108863;
                d >>>= 26, f.words[c] = g, a = d;
            }
            return a !== 0 && (f.words[f.length++] = a), f;
        }, o._prime = function(f) {
            if (H[f]) return H[f];
            var a;
            if (f === "k256") a = new Pt;
            else if (f === "p224") a = new W;
            else if (f === "p192") a = new Rt;
            else if (f === "p25519") a = new Yt;
            else throw new Error("Unknown prime " + f);
            return H[f] = a, a;
        };
        function Y(A) {
            if (typeof A == "string") {
                var f = o._prime(A);
                this.m = f.p, this.prime = f;
            } else i(A.gtn(1), "modulus must be greater than 1"), this.m = A, this.prime = null;
        }
        Y.prototype._verify1 = function(f) {
            i(f.negative === 0, "red works only with positives"), i(f.red, "red works only with red numbers");
        }, Y.prototype._verify2 = function(f, a) {
            i((f.negative | a.negative) === 0, "red works only with positives"), i(f.red && f.red === a.red, "red works only with red numbers");
        }, Y.prototype.imod = function(f) {
            return this.prime ? this.prime.ireduce(f)._forceRed(this) : (w(f, f.umod(this.m)._forceRed(this)), f);
        }, Y.prototype.neg = function(f) {
            return f.isZero() ? f.clone() : this.m.sub(f)._forceRed(this);
        }, Y.prototype.add = function(f, a) {
            this._verify2(f, a);
            var c = f.add(a);
            return c.cmp(this.m) >= 0 && c.isub(this.m), c._forceRed(this);
        }, Y.prototype.iadd = function(f, a) {
            this._verify2(f, a);
            var c = f.iadd(a);
            return c.cmp(this.m) >= 0 && c.isub(this.m), c;
        }, Y.prototype.sub = function(f, a) {
            this._verify2(f, a);
            var c = f.sub(a);
            return c.cmpn(0) < 0 && c.iadd(this.m), c._forceRed(this);
        }, Y.prototype.isub = function(f, a) {
            this._verify2(f, a);
            var c = f.isub(a);
            return c.cmpn(0) < 0 && c.iadd(this.m), c;
        }, Y.prototype.shl = function(f, a) {
            return this._verify1(f), this.imod(f.ushln(a));
        }, Y.prototype.imul = function(f, a) {
            return this._verify2(f, a), this.imod(f.imul(a));
        }, Y.prototype.mul = function(f, a) {
            return this._verify2(f, a), this.imod(f.mul(a));
        }, Y.prototype.isqr = function(f) {
            return this.imul(f, f.clone());
        }, Y.prototype.sqr = function(f) {
            return this.mul(f, f);
        }, Y.prototype.sqrt = function(f) {
            if (f.isZero()) return f.clone();
            var a = this.m.andln(3);
            if (i(a % 2 === 1), a === 3) {
                var c = this.m.add(new o(1)).iushrn(2);
                return this.pow(f, c);
            }
            for(var d = this.m.subn(1), g = 0; !d.isZero() && d.andln(1) === 0;)g++, d.iushrn(1);
            i(!d.isZero());
            var x = new o(1).toRed(this), M = x.redNeg(), l = this.m.subn(1).iushrn(1), s = this.m.bitLength();
            for(s = new o(2 * s * s).toRed(this); this.pow(s, l).cmp(M) !== 0;)s.redIAdd(M);
            for(var v = this.pow(s, d), k = this.pow(f, d.addn(1).iushrn(1)), u = this.pow(f, d), E = g; u.cmp(x) !== 0;){
                for(var _ = u, B = 0; _.cmp(x) !== 0; B++)_ = _.redSqr();
                i(B < E);
                var R = this.pow(v, new o(1).iushln(E - B - 1));
                k = k.redMul(R), v = R.redSqr(), u = u.redMul(v), E = B;
            }
            return k;
        }, Y.prototype.invm = function(f) {
            var a = f._invmp(this.m);
            return a.negative !== 0 ? (a.negative = 0, this.imod(a).redNeg()) : this.imod(a);
        }, Y.prototype.pow = function(f, a) {
            if (a.isZero()) return new o(1).toRed(this);
            if (a.cmpn(1) === 0) return f.clone();
            var c = 4, d = new Array(1 << c);
            d[0] = new o(1).toRed(this), d[1] = f;
            for(var g = 2; g < d.length; g++)d[g] = this.mul(d[g - 1], f);
            var x = d[0], M = 0, l = 0, s = a.bitLength() % 26;
            for(s === 0 && (s = 26), g = a.length - 1; g >= 0; g--){
                for(var v = a.words[g], k = s - 1; k >= 0; k--){
                    var u = v >> k & 1;
                    if (x !== d[0] && (x = this.sqr(x)), u === 0 && M === 0) {
                        l = 0;
                        continue;
                    }
                    M <<= 1, M |= u, l++, !(l !== c && (g !== 0 || k !== 0)) && (x = this.mul(x, d[M]), l = 0, M = 0);
                }
                s = 26;
            }
            return x;
        }, Y.prototype.convertTo = function(f) {
            var a = f.umod(this.m);
            return a === f ? a.clone() : a;
        }, Y.prototype.convertFrom = function(f) {
            var a = f.clone();
            return a.red = null, a;
        }, o.mont = function(f) {
            return new Vt(f);
        };
        function Vt(A) {
            Y.call(this, A), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new o(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
        }
        n(Vt, Y), Vt.prototype.convertTo = function(f) {
            return this.imod(f.ushln(this.shift));
        }, Vt.prototype.convertFrom = function(f) {
            var a = this.imod(f.mul(this.rinv));
            return a.red = null, a;
        }, Vt.prototype.imul = function(f, a) {
            if (f.isZero() || a.isZero()) return f.words[0] = 0, f.length = 1, f;
            var c = f.imul(a), d = c.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), g = c.isub(d).iushrn(this.shift), x = g;
            return g.cmp(this.m) >= 0 ? x = g.isub(this.m) : g.cmpn(0) < 0 && (x = g.iadd(this.m)), x._forceRed(this);
        }, Vt.prototype.mul = function(f, a) {
            if (f.isZero() || a.isZero()) return new o(0)._forceRed(this);
            var c = f.mul(a), d = c.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), g = c.isub(d).iushrn(this.shift), x = g;
            return g.cmp(this.m) >= 0 ? x = g.isub(this.m) : g.cmpn(0) < 0 && (x = g.iadd(this.m)), x._forceRed(this);
        }, Vt.prototype.invm = function(f) {
            var a = this.imod(f._invmp(this.m).mul(this.r2));
            return a._forceRed(this);
        };
    })(e, $4e7e1af11ea066d2$var$On);
})($4e7e1af11ea066d2$var$Ln);
var $4e7e1af11ea066d2$var$K = $4e7e1af11ea066d2$var$Ln.exports;
var $4e7e1af11ea066d2$var$jn = "bignumber/5.7.0";
var $4e7e1af11ea066d2$var$Rr = $4e7e1af11ea066d2$var$K.BN;
var $4e7e1af11ea066d2$var$Ae = new $4e7e1af11ea066d2$var$L($4e7e1af11ea066d2$var$jn), $4e7e1af11ea066d2$var$wi = {}, $4e7e1af11ea066d2$var$Qn = 9007199254740991;
function $4e7e1af11ea066d2$var$C0(e) {
    return e != null && ($4e7e1af11ea066d2$var$V.isBigNumber(e) || typeof e == "number" && e % 1 === 0 || typeof e == "string" && !!e.match(/^-?[0-9]+$/) || $4e7e1af11ea066d2$var$Qt(e) || (typeof e === "undefined" ? "undefined" : (0, $l0HdX._)(e)) == "bigint" || $4e7e1af11ea066d2$var$ir(e));
}
var $4e7e1af11ea066d2$var$Jn = !1;
var $4e7e1af11ea066d2$var$V = /*#__PURE__*/ function() {
    "use strict";
    function V(t, r) {
        (0, $4GJKx._)(this, V);
        t !== $4e7e1af11ea066d2$var$wi && $4e7e1af11ea066d2$var$Ae.throwError("cannot call constructor directly; use BigNumber.from", $4e7e1af11ea066d2$var$L.errors.UNSUPPORTED_OPERATION, {
            operation: "new (BigNumber)"
        }), this._hex = r, this._isBigNumber = !0, Object.freeze(this);
    }
    (0, $1wc17._)(V, [
        {
            key: "fromTwos",
            value: function fromTwos(t) {
                return $4e7e1af11ea066d2$var$Lt($4e7e1af11ea066d2$var$j(this).fromTwos(t));
            }
        },
        {
            key: "toTwos",
            value: function toTwos(t) {
                return $4e7e1af11ea066d2$var$Lt($4e7e1af11ea066d2$var$j(this).toTwos(t));
            }
        },
        {
            key: "abs",
            value: function abs() {
                return this._hex[0] === "-" ? V.from(this._hex.substring(1)) : this;
            }
        },
        {
            key: "add",
            value: function add(t) {
                return $4e7e1af11ea066d2$var$Lt($4e7e1af11ea066d2$var$j(this).add($4e7e1af11ea066d2$var$j(t)));
            }
        },
        {
            key: "sub",
            value: function sub(t) {
                return $4e7e1af11ea066d2$var$Lt($4e7e1af11ea066d2$var$j(this).sub($4e7e1af11ea066d2$var$j(t)));
            }
        },
        {
            key: "div",
            value: function div(t) {
                return V.from(t).isZero() && $4e7e1af11ea066d2$var$Wt("division-by-zero", "div"), $4e7e1af11ea066d2$var$Lt($4e7e1af11ea066d2$var$j(this).div($4e7e1af11ea066d2$var$j(t)));
            }
        },
        {
            key: "mul",
            value: function mul(t) {
                return $4e7e1af11ea066d2$var$Lt($4e7e1af11ea066d2$var$j(this).mul($4e7e1af11ea066d2$var$j(t)));
            }
        },
        {
            key: "mod",
            value: function mod(t) {
                var r = $4e7e1af11ea066d2$var$j(t);
                return r.isNeg() && $4e7e1af11ea066d2$var$Wt("division-by-zero", "mod"), $4e7e1af11ea066d2$var$Lt($4e7e1af11ea066d2$var$j(this).umod(r));
            }
        },
        {
            key: "pow",
            value: function pow(t) {
                var r = $4e7e1af11ea066d2$var$j(t);
                return r.isNeg() && $4e7e1af11ea066d2$var$Wt("negative-power", "pow"), $4e7e1af11ea066d2$var$Lt($4e7e1af11ea066d2$var$j(this).pow(r));
            }
        },
        {
            key: "and",
            value: function and(t) {
                var r = $4e7e1af11ea066d2$var$j(t);
                return (this.isNegative() || r.isNeg()) && $4e7e1af11ea066d2$var$Wt("unbound-bitwise-result", "and"), $4e7e1af11ea066d2$var$Lt($4e7e1af11ea066d2$var$j(this).and(r));
            }
        },
        {
            key: "or",
            value: function or(t) {
                var r = $4e7e1af11ea066d2$var$j(t);
                return (this.isNegative() || r.isNeg()) && $4e7e1af11ea066d2$var$Wt("unbound-bitwise-result", "or"), $4e7e1af11ea066d2$var$Lt($4e7e1af11ea066d2$var$j(this).or(r));
            }
        },
        {
            key: "xor",
            value: function xor(t) {
                var r = $4e7e1af11ea066d2$var$j(t);
                return (this.isNegative() || r.isNeg()) && $4e7e1af11ea066d2$var$Wt("unbound-bitwise-result", "xor"), $4e7e1af11ea066d2$var$Lt($4e7e1af11ea066d2$var$j(this).xor(r));
            }
        },
        {
            key: "mask",
            value: function mask(t) {
                return (this.isNegative() || t < 0) && $4e7e1af11ea066d2$var$Wt("negative-width", "mask"), $4e7e1af11ea066d2$var$Lt($4e7e1af11ea066d2$var$j(this).maskn(t));
            }
        },
        {
            key: "shl",
            value: function shl(t) {
                return (this.isNegative() || t < 0) && $4e7e1af11ea066d2$var$Wt("negative-width", "shl"), $4e7e1af11ea066d2$var$Lt($4e7e1af11ea066d2$var$j(this).shln(t));
            }
        },
        {
            key: "shr",
            value: function shr(t) {
                return (this.isNegative() || t < 0) && $4e7e1af11ea066d2$var$Wt("negative-width", "shr"), $4e7e1af11ea066d2$var$Lt($4e7e1af11ea066d2$var$j(this).shrn(t));
            }
        },
        {
            key: "eq",
            value: function eq(t) {
                return $4e7e1af11ea066d2$var$j(this).eq($4e7e1af11ea066d2$var$j(t));
            }
        },
        {
            key: "lt",
            value: function lt(t) {
                return $4e7e1af11ea066d2$var$j(this).lt($4e7e1af11ea066d2$var$j(t));
            }
        },
        {
            key: "lte",
            value: function lte(t) {
                return $4e7e1af11ea066d2$var$j(this).lte($4e7e1af11ea066d2$var$j(t));
            }
        },
        {
            key: "gt",
            value: function gt(t) {
                return $4e7e1af11ea066d2$var$j(this).gt($4e7e1af11ea066d2$var$j(t));
            }
        },
        {
            key: "gte",
            value: function gte(t) {
                return $4e7e1af11ea066d2$var$j(this).gte($4e7e1af11ea066d2$var$j(t));
            }
        },
        {
            key: "isNegative",
            value: function isNegative() {
                return this._hex[0] === "-";
            }
        },
        {
            key: "isZero",
            value: function isZero() {
                return $4e7e1af11ea066d2$var$j(this).isZero();
            }
        },
        {
            key: "toNumber",
            value: function toNumber() {
                try {
                    return $4e7e1af11ea066d2$var$j(this).toNumber();
                } catch (e) {
                    $4e7e1af11ea066d2$var$Wt("overflow", "toNumber", this.toString());
                }
                return null;
            }
        },
        {
            key: "toBigInt",
            value: function toBigInt() {
                try {
                    return BigInt(this.toString());
                } catch (e) {}
                return $4e7e1af11ea066d2$var$Ae.throwError("this platform does not support BigInt", $4e7e1af11ea066d2$var$L.errors.UNSUPPORTED_OPERATION, {
                    value: this.toString()
                });
            }
        },
        {
            key: "toString",
            value: function toString() {
                return arguments.length > 0 && (arguments[0] === 10 ? $4e7e1af11ea066d2$var$Jn || ($4e7e1af11ea066d2$var$Jn = !0, $4e7e1af11ea066d2$var$Ae.warn("BigNumber.toString does not accept any parameters; base-10 is assumed")) : arguments[0] === 16 ? $4e7e1af11ea066d2$var$Ae.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", $4e7e1af11ea066d2$var$L.errors.UNEXPECTED_ARGUMENT, {}) : $4e7e1af11ea066d2$var$Ae.throwError("BigNumber.toString does not accept parameters", $4e7e1af11ea066d2$var$L.errors.UNEXPECTED_ARGUMENT, {})), $4e7e1af11ea066d2$var$j(this).toString(10);
            }
        },
        {
            key: "toHexString",
            value: function toHexString() {
                return this._hex;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(t) {
                return {
                    type: "BigNumber",
                    hex: this.toHexString()
                };
            }
        }
    ], [
        {
            key: "from",
            value: function from(t) {
                if (t instanceof V) return t;
                if (typeof t == "string") return t.match(/^-?0x[0-9a-f]+$/i) ? new V($4e7e1af11ea066d2$var$wi, $4e7e1af11ea066d2$var$vr(t)) : t.match(/^-?[0-9]+$/) ? new V($4e7e1af11ea066d2$var$wi, $4e7e1af11ea066d2$var$vr(new $4e7e1af11ea066d2$var$Rr(t))) : $4e7e1af11ea066d2$var$Ae.throwArgumentError("invalid BigNumber string", "value", t);
                if (typeof t == "number") return t % 1 && $4e7e1af11ea066d2$var$Wt("underflow", "BigNumber.from", t), (t >= $4e7e1af11ea066d2$var$Qn || t <= -$4e7e1af11ea066d2$var$Qn) && $4e7e1af11ea066d2$var$Wt("overflow", "BigNumber.from", t), V.from(String(t));
                var r = t;
                if ((typeof r === "undefined" ? "undefined" : (0, $l0HdX._)(r)) == "bigint") return V.from(r.toString());
                if ($4e7e1af11ea066d2$var$ir(r)) return V.from($4e7e1af11ea066d2$var$Kt(r));
                if (r) {
                    if (r.toHexString) {
                        var i = r.toHexString();
                        if (typeof i == "string") return V.from(i);
                    } else {
                        var i1 = r._hex;
                        if (i1 == null && r.type === "BigNumber" && (i1 = r.hex), typeof i1 == "string" && ($4e7e1af11ea066d2$var$Qt(i1) || i1[0] === "-" && $4e7e1af11ea066d2$var$Qt(i1.substring(1)))) return V.from(i1);
                    }
                }
                return $4e7e1af11ea066d2$var$Ae.throwArgumentError("invalid BigNumber value", "value", t);
            }
        },
        {
            key: "isBigNumber",
            value: function isBigNumber(t) {
                return !!(t && t._isBigNumber);
            }
        }
    ]);
    return V;
}();
function $4e7e1af11ea066d2$var$vr(e) {
    if (typeof e != "string") return $4e7e1af11ea066d2$var$vr(e.toString(16));
    if (e[0] === "-") return e = e.substring(1), e[0] === "-" && $4e7e1af11ea066d2$var$Ae.throwArgumentError("invalid hex", "value", e), e = $4e7e1af11ea066d2$var$vr(e), e === "0x00" ? e : "-" + e;
    if (e.substring(0, 2) !== "0x" && (e = "0x" + e), e === "0x") return "0x00";
    for(e.length % 2 && (e = "0x0" + e.substring(2)); e.length > 4 && e.substring(0, 4) === "0x00";)e = "0x" + e.substring(4);
    return e;
}
function $4e7e1af11ea066d2$var$Lt(e) {
    return $4e7e1af11ea066d2$var$V.from($4e7e1af11ea066d2$var$vr(e));
}
function $4e7e1af11ea066d2$var$j(e) {
    var t = $4e7e1af11ea066d2$var$V.from(e).toHexString();
    return t[0] === "-" ? new $4e7e1af11ea066d2$var$Rr("-" + t.substring(3), 16) : new $4e7e1af11ea066d2$var$Rr(t.substring(2), 16);
}
function $4e7e1af11ea066d2$var$Wt(e, t, r) {
    var i = {
        fault: e,
        operation: t
    };
    return r != null && (i.value = r), $4e7e1af11ea066d2$var$Ae.throwError(e, $4e7e1af11ea066d2$var$L.errors.NUMERIC_FAULT, i);
}
function $4e7e1af11ea066d2$var$R0(e) {
    return new $4e7e1af11ea066d2$var$Rr(e, 36).toString(16);
}
var $4e7e1af11ea066d2$var$Ht = new $4e7e1af11ea066d2$var$L($4e7e1af11ea066d2$var$jn), $4e7e1af11ea066d2$var$mr = {}, $4e7e1af11ea066d2$var$Gn = $4e7e1af11ea066d2$var$V.from(0), $4e7e1af11ea066d2$var$Yn = $4e7e1af11ea066d2$var$V.from(-1);
function $4e7e1af11ea066d2$var$Vn(e, t, r, i) {
    var n = {
        fault: t,
        operation: r
    };
    return i !== void 0 && (n.value = i), $4e7e1af11ea066d2$var$Ht.throwError(e, $4e7e1af11ea066d2$var$L.errors.NUMERIC_FAULT, n);
}
var $4e7e1af11ea066d2$var$gr = "0";
for(; $4e7e1af11ea066d2$var$gr.length < 256;)$4e7e1af11ea066d2$var$gr += $4e7e1af11ea066d2$var$gr;
function $4e7e1af11ea066d2$var$xi(e) {
    if (typeof e != "number") try {
        e = $4e7e1af11ea066d2$var$V.from(e).toNumber();
    } catch (e) {}
    return typeof e == "number" && e >= 0 && e <= 256 && !(e % 1) ? "1" + $4e7e1af11ea066d2$var$gr.substring(0, e) : $4e7e1af11ea066d2$var$Ht.throwArgumentError("invalid decimal size", "decimals", e);
}
function $4e7e1af11ea066d2$var$Mi(e, t) {
    t == null && (t = 0);
    var r = $4e7e1af11ea066d2$var$xi(t);
    e = $4e7e1af11ea066d2$var$V.from(e);
    var i = e.lt($4e7e1af11ea066d2$var$Gn);
    i && (e = e.mul($4e7e1af11ea066d2$var$Yn));
    var n = e.mod(r).toString();
    for(; n.length < r.length - 1;)n = "0" + n;
    n = n.match(/^([0-9]*[1-9]|0)(0*)/)[1];
    var o = e.div(r).toString();
    return r.length === 1 ? e = o : e = o + "." + n, i && (e = "-" + e), e;
}
function $4e7e1af11ea066d2$var$be(e, t) {
    t == null && (t = 0);
    var r = $4e7e1af11ea066d2$var$xi(t);
    (typeof e != "string" || !e.match(/^-?[0-9.]+$/)) && $4e7e1af11ea066d2$var$Ht.throwArgumentError("invalid decimal value", "value", e);
    var i = e.substring(0, 1) === "-";
    i && (e = e.substring(1)), e === "." && $4e7e1af11ea066d2$var$Ht.throwArgumentError("missing value", "value", e);
    var n = e.split(".");
    n.length > 2 && $4e7e1af11ea066d2$var$Ht.throwArgumentError("too many decimal points", "value", e);
    var o = n[0], h = n[1];
    for(o || (o = "0"), h || (h = "0"); h[h.length - 1] === "0";)h = h.substring(0, h.length - 1);
    for(h.length > r.length - 1 && $4e7e1af11ea066d2$var$Vn("fractional component exceeds decimals", "underflow", "parseFixed"), h === "" && (h = "0"); h.length < r.length - 1;)h += "0";
    var p = $4e7e1af11ea066d2$var$V.from(o), b = $4e7e1af11ea066d2$var$V.from(h);
    var m = p.mul(r).add(b);
    return i && (m = m.mul($4e7e1af11ea066d2$var$Yn)), m;
}
var $4e7e1af11ea066d2$var$dr = /*#__PURE__*/ function() {
    "use strict";
    function dr(t, r, i, n) {
        (0, $4GJKx._)(this, dr);
        t !== $4e7e1af11ea066d2$var$mr && $4e7e1af11ea066d2$var$Ht.throwError("cannot use FixedFormat constructor; use FixedFormat.from", $4e7e1af11ea066d2$var$L.errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        }), this.signed = r, this.width = i, this.decimals = n, this.name = (r ? "" : "u") + "fixed" + String(i) + "x" + String(n), this._multiplier = $4e7e1af11ea066d2$var$xi(n), Object.freeze(this);
    }
    (0, $1wc17._)(dr, null, [
        {
            key: "from",
            value: function from(t) {
                if (t instanceof dr) return t;
                typeof t == "number" && (t = "fixed128x".concat(t));
                var r = !0, i = 128, n = 18;
                if (typeof t == "string") {
                    if (t !== "fixed") {
                        if (t === "ufixed") r = !1;
                        else {
                            var o = t.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
                            o || $4e7e1af11ea066d2$var$Ht.throwArgumentError("invalid fixed format", "format", t), r = o[1] !== "u", i = parseInt(o[2]), n = parseInt(o[3]);
                        }
                    }
                } else if (t) {
                    var o1 = function(h, p, b) {
                        return t[h] == null ? b : ((0, $l0HdX._)(t[h]) !== p && $4e7e1af11ea066d2$var$Ht.throwArgumentError("invalid fixed format (" + h + " not " + p + ")", "format." + h, t[h]), t[h]);
                    };
                    r = o1("signed", "boolean", r), i = o1("width", "number", i), n = o1("decimals", "number", n);
                }
                return i % 8 && $4e7e1af11ea066d2$var$Ht.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", i), n > 80 && $4e7e1af11ea066d2$var$Ht.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", n), new dr($4e7e1af11ea066d2$var$mr, r, i, n);
            }
        }
    ]);
    return dr;
}();
var $4e7e1af11ea066d2$var$Ut = /*#__PURE__*/ function() {
    "use strict";
    function Ut(t, r, i, n) {
        (0, $4GJKx._)(this, Ut);
        t !== $4e7e1af11ea066d2$var$mr && $4e7e1af11ea066d2$var$Ht.throwError("cannot use FixedNumber constructor; use FixedNumber.from", $4e7e1af11ea066d2$var$L.errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        }), this.format = n, this._hex = r, this._value = i, this._isFixedNumber = !0, Object.freeze(this);
    }
    (0, $1wc17._)(Ut, [
        {
            key: "_checkFormat",
            value: function _checkFormat(t) {
                this.format.name !== t.format.name && $4e7e1af11ea066d2$var$Ht.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", t);
            }
        },
        {
            key: "addUnsafe",
            value: function addUnsafe(t) {
                this._checkFormat(t);
                var r = $4e7e1af11ea066d2$var$be(this._value, this.format.decimals), i = $4e7e1af11ea066d2$var$be(t._value, t.format.decimals);
                return Ut.fromValue(r.add(i), this.format.decimals, this.format);
            }
        },
        {
            key: "subUnsafe",
            value: function subUnsafe(t) {
                this._checkFormat(t);
                var r = $4e7e1af11ea066d2$var$be(this._value, this.format.decimals), i = $4e7e1af11ea066d2$var$be(t._value, t.format.decimals);
                return Ut.fromValue(r.sub(i), this.format.decimals, this.format);
            }
        },
        {
            key: "mulUnsafe",
            value: function mulUnsafe(t) {
                this._checkFormat(t);
                var r = $4e7e1af11ea066d2$var$be(this._value, this.format.decimals), i = $4e7e1af11ea066d2$var$be(t._value, t.format.decimals);
                return Ut.fromValue(r.mul(i).div(this.format._multiplier), this.format.decimals, this.format);
            }
        },
        {
            key: "divUnsafe",
            value: function divUnsafe(t) {
                this._checkFormat(t);
                var r = $4e7e1af11ea066d2$var$be(this._value, this.format.decimals), i = $4e7e1af11ea066d2$var$be(t._value, t.format.decimals);
                return Ut.fromValue(r.mul(this.format._multiplier).div(i), this.format.decimals, this.format);
            }
        },
        {
            key: "floor",
            value: function floor() {
                var t = this.toString().split(".");
                t.length === 1 && t.push("0");
                var r = Ut.from(t[0], this.format);
                var i = !t[1].match(/^(0*)$/);
                return this.isNegative() && i && (r = r.subUnsafe($4e7e1af11ea066d2$var$Wn.toFormat(r.format))), r;
            }
        },
        {
            key: "ceiling",
            value: function ceiling() {
                var t = this.toString().split(".");
                t.length === 1 && t.push("0");
                var r = Ut.from(t[0], this.format);
                var i = !t[1].match(/^(0*)$/);
                return !this.isNegative() && i && (r = r.addUnsafe($4e7e1af11ea066d2$var$Wn.toFormat(r.format))), r;
            }
        },
        {
            key: "round",
            value: function round(t) {
                t == null && (t = 0);
                var r = this.toString().split(".");
                if (r.length === 1 && r.push("0"), (t < 0 || t > 80 || t % 1) && $4e7e1af11ea066d2$var$Ht.throwArgumentError("invalid decimal count", "decimals", t), r[1].length <= t) return this;
                var i = Ut.from("1" + $4e7e1af11ea066d2$var$gr.substring(0, t), this.format), n = $4e7e1af11ea066d2$var$O0.toFormat(this.format);
                return this.mulUnsafe(i).addUnsafe(n).floor().divUnsafe(i);
            }
        },
        {
            key: "isZero",
            value: function isZero() {
                return this._value === "0.0" || this._value === "0";
            }
        },
        {
            key: "isNegative",
            value: function isNegative() {
                return this._value[0] === "-";
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this._value;
            }
        },
        {
            key: "toHexString",
            value: function toHexString(t) {
                if (t == null) return this._hex;
                t % 8 && $4e7e1af11ea066d2$var$Ht.throwArgumentError("invalid byte width", "width", t);
                var r = $4e7e1af11ea066d2$var$V.from(this._hex).fromTwos(this.format.width).toTwos(t).toHexString();
                return $4e7e1af11ea066d2$var$oe(r, t / 8);
            }
        },
        {
            key: "toUnsafeFloat",
            value: function toUnsafeFloat() {
                return parseFloat(this.toString());
            }
        },
        {
            key: "toFormat",
            value: function toFormat(t) {
                return Ut.fromString(this._value, t);
            }
        }
    ], [
        {
            key: "fromValue",
            value: function fromValue(t, r, i) {
                return i == null && r != null && !$4e7e1af11ea066d2$var$C0(r) && (i = r, r = null), r == null && (r = 0), i == null && (i = "fixed"), Ut.fromString($4e7e1af11ea066d2$var$Mi(t, r), $4e7e1af11ea066d2$var$dr.from(i));
            }
        },
        {
            key: "fromString",
            value: function fromString(t, r) {
                r == null && (r = "fixed");
                var i = $4e7e1af11ea066d2$var$dr.from(r), n = $4e7e1af11ea066d2$var$be(t, i.decimals);
                !i.signed && n.lt($4e7e1af11ea066d2$var$Gn) && $4e7e1af11ea066d2$var$Vn("unsigned value cannot be negative", "overflow", "value", t);
                var o = null;
                i.signed ? o = n.toTwos(i.width).toHexString() : (o = n.toHexString(), o = $4e7e1af11ea066d2$var$oe(o, i.width / 8));
                var h = $4e7e1af11ea066d2$var$Mi(n, i.decimals);
                return new Ut($4e7e1af11ea066d2$var$mr, o, h, i);
            }
        },
        {
            key: "fromBytes",
            value: function fromBytes(t, r) {
                r == null && (r = "fixed");
                var i = $4e7e1af11ea066d2$var$dr.from(r);
                if ($4e7e1af11ea066d2$var$Ot(t).length > i.width / 8) throw new Error("overflow");
                var n = $4e7e1af11ea066d2$var$V.from(t);
                i.signed && (n = n.fromTwos(i.width));
                var o = n.toTwos((i.signed ? 0 : 1) + i.width).toHexString(), h = $4e7e1af11ea066d2$var$Mi(n, i.decimals);
                return new Ut($4e7e1af11ea066d2$var$mr, o, h, i);
            }
        },
        {
            key: "from",
            value: function from(t, r) {
                if (typeof t == "string") return Ut.fromString(t, r);
                if ($4e7e1af11ea066d2$var$ir(t)) return Ut.fromBytes(t, r);
                try {
                    return Ut.fromValue(t, 0, r);
                } catch (i) {
                    if (i.code !== $4e7e1af11ea066d2$var$L.errors.INVALID_ARGUMENT) throw i;
                }
                return $4e7e1af11ea066d2$var$Ht.throwArgumentError("invalid FixedNumber value", "value", t);
            }
        },
        {
            key: "isFixedNumber",
            value: function isFixedNumber(t) {
                return !!(t && t._isFixedNumber);
            }
        }
    ]);
    return Ut;
}();
var $4e7e1af11ea066d2$var$Wn = $4e7e1af11ea066d2$var$Ut.from(1), $4e7e1af11ea066d2$var$O0 = $4e7e1af11ea066d2$var$Ut.from("0.5"), $4e7e1af11ea066d2$var$P0 = "strings/5.7.0", $4e7e1af11ea066d2$var$Xn = new $4e7e1af11ea066d2$var$L($4e7e1af11ea066d2$var$P0);
var $4e7e1af11ea066d2$var$Or;
(function(e) {
    e.current = "", e.NFC = "NFC", e.NFD = "NFD", e.NFKC = "NFKC", e.NFKD = "NFKD";
})($4e7e1af11ea066d2$var$Or || ($4e7e1af11ea066d2$var$Or = {}));
var $4e7e1af11ea066d2$var$nr;
(function(e) {
    e.UNEXPECTED_CONTINUE = "unexpected continuation byte", e.BAD_PREFIX = "bad codepoint prefix", e.OVERRUN = "string overrun", e.MISSING_CONTINUE = "missing continuation byte", e.OUT_OF_RANGE = "out of UTF-8 range", e.UTF16_SURROGATE = "UTF-16 surrogate", e.OVERLONG = "overlong representation";
})($4e7e1af11ea066d2$var$nr || ($4e7e1af11ea066d2$var$nr = {}));
function $4e7e1af11ea066d2$var$D0(e, t, r, i, n) {
    return $4e7e1af11ea066d2$var$Xn.throwArgumentError("invalid codepoint at offset ".concat(t, "; ").concat(e), "bytes", r);
}
function $4e7e1af11ea066d2$var$Zn(e, t, r, i, n) {
    if (e === $4e7e1af11ea066d2$var$nr.BAD_PREFIX || e === $4e7e1af11ea066d2$var$nr.UNEXPECTED_CONTINUE) {
        var o = 0;
        for(var h = t + 1; h < r.length && r[h] >> 6 === 2; h++)o++;
        return o;
    }
    return e === $4e7e1af11ea066d2$var$nr.OVERRUN ? r.length - t - 1 : 0;
}
function $4e7e1af11ea066d2$var$F0(e, t, r, i, n) {
    return e === $4e7e1af11ea066d2$var$nr.OVERLONG ? (i.push(n), 0) : (i.push(65533), $4e7e1af11ea066d2$var$Zn(e, t, r));
}
Object.freeze({
    error: $4e7e1af11ea066d2$var$D0,
    ignore: $4e7e1af11ea066d2$var$Zn,
    replace: $4e7e1af11ea066d2$var$F0
});
function $4e7e1af11ea066d2$var$Ei(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $4e7e1af11ea066d2$var$Or.current;
    t != $4e7e1af11ea066d2$var$Or.current && ($4e7e1af11ea066d2$var$Xn.checkNormalize(), e = e.normalize(t));
    var r = [];
    for(var i = 0; i < e.length; i++){
        var n = e.charCodeAt(i);
        if (n < 128) r.push(n);
        else if (n < 2048) r.push(n >> 6 | 192), r.push(n & 63 | 128);
        else if ((n & 64512) == 55296) {
            i++;
            var o = e.charCodeAt(i);
            if (i >= e.length || (o & 64512) !== 56320) throw new Error("invalid utf-8 string");
            var h = 65536 + ((n & 1023) << 10) + (o & 1023);
            r.push(h >> 18 | 240), r.push(h >> 12 & 63 | 128), r.push(h >> 6 & 63 | 128), r.push(h & 63 | 128);
        } else r.push(n >> 12 | 224), r.push(n >> 6 & 63 | 128), r.push(n & 63 | 128);
    }
    return $4e7e1af11ea066d2$var$Ot(r);
}
function $4e7e1af11ea066d2$var$T0(e) {
    if (e.length % 4 !== 0) throw new Error("bad data");
    var t = [];
    for(var r = 0; r < e.length; r += 4)t.push(parseInt(e.substring(r, r + 4), 16));
    return t;
}
function $4e7e1af11ea066d2$var$Si(e, t) {
    t || (t = function t(n) {
        return [
            parseInt(n, 16)
        ];
    });
    var r = 0, i = {};
    return e.split(",").forEach(function(n) {
        var o = n.split(":");
        r += parseInt(o[0], 16), i[r] = t(o[1]);
    }), i;
}
function $4e7e1af11ea066d2$var$$n(e) {
    var t = 0;
    return e.split(",").map(function(r) {
        var i = r.split("-");
        i.length === 1 ? i[1] = "0" : i[1] === "" && (i[1] = "1");
        var n = t + parseInt(i[0], 16);
        return t = parseInt(i[1], 16), {
            l: n,
            h: t
        };
    });
}
$4e7e1af11ea066d2$var$$n("221,13-1b,5f-,40-10,51-f,11-3,3-3,2-2,2-4,8,2,15,2d,28-8,88,48,27-,3-5,11-20,27-,8,28,3-5,12,18,b-a,1c-4,6-16,2-d,2-2,2,1b-4,17-9,8f-,10,f,1f-2,1c-34,33-14e,4,36-,13-,6-2,1a-f,4,9-,3-,17,8,2-2,5-,2,8-,3-,4-8,2-3,3,6-,16-6,2-,7-3,3-,17,8,3,3,3-,2,6-3,3-,4-a,5,2-6,10-b,4,8,2,4,17,8,3,6-,b,4,4-,2-e,2-4,b-10,4,9-,3-,17,8,3-,5-,9-2,3-,4-7,3-3,3,4-3,c-10,3,7-2,4,5-2,3,2,3-2,3-2,4-2,9,4-3,6-2,4,5-8,2-e,d-d,4,9,4,18,b,6-3,8,4,5-6,3-8,3-3,b-11,3,9,4,18,b,6-3,8,4,5-6,3-6,2,3-3,b-11,3,9,4,18,11-3,7-,4,5-8,2-7,3-3,b-11,3,13-2,19,a,2-,8-2,2-3,7,2,9-11,4-b,3b-3,1e-24,3,2-,3,2-,2-5,5,8,4,2,2-,3,e,4-,6,2,7-,b-,3-21,49,23-5,1c-3,9,25,10-,2-2f,23,6,3,8-2,5-5,1b-45,27-9,2a-,2-3,5b-4,45-4,53-5,8,40,2,5-,8,2,5-,28,2,5-,20,2,5-,8,2,5-,8,8,18,20,2,5-,8,28,14-5,1d-22,56-b,277-8,1e-2,52-e,e,8-a,18-8,15-b,e,4,3-b,5e-2,b-15,10,b-5,59-7,2b-555,9d-3,5b-5,17-,7-,27-,7-,9,2,2,2,20-,36,10,f-,7,14-,4,a,54-3,2-6,6-5,9-,1c-10,13-1d,1c-14,3c-,10-6,32-b,240-30,28-18,c-14,a0,115-,3,66-,b-76,5,5-,1d,24,2,5-2,2,8-,35-2,19,f-10,1d-3,311-37f,1b,5a-b,d7-19,d-3,41,57-,68-4,29-3,5f,29-37,2e-2,25-c,2c-2,4e-3,30,78-3,64-,20,19b7-49,51a7-59,48e-2,38-738,2ba5-5b,222f-,3c-94,8-b,6-4,1b,6,2,3,3,6d-20,16e-f,41-,37-7,2e-2,11-f,5-b,18-,b,14,5-3,6,88-,2,bf-2,7-,7-,7-,4-2,8,8-9,8-2ff,20,5-b,1c-b4,27-,27-cbb1,f7-9,28-2,b5-221,56,48,3-,2-,3-,5,d,2,5,3,42,5-,9,8,1d,5,6,2-2,8,153-3,123-3,33-27fd,a6da-5128,21f-5df,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3,2-1d,61-ff7d"), "ad,34f,1806,180b,180c,180d,200b,200c,200d,2060,feff".split(",").map(function(e) {
    return parseInt(e, 16);
}), $4e7e1af11ea066d2$var$Si("b5:3bc,c3:ff,7:73,2:253,5:254,3:256,1:257,5:259,1:25b,3:260,1:263,2:269,1:268,5:26f,1:272,2:275,7:280,3:283,5:288,3:28a,1:28b,5:292,3f:195,1:1bf,29:19e,125:3b9,8b:3b2,1:3b8,1:3c5,3:3c6,1:3c0,1a:3ba,1:3c1,1:3c3,2:3b8,1:3b5,1bc9:3b9,1c:1f76,1:1f77,f:1f7a,1:1f7b,d:1f78,1:1f79,1:1f7c,1:1f7d,107:63,5:25b,4:68,1:68,1:68,3:69,1:69,1:6c,3:6e,4:70,1:71,1:72,1:72,1:72,7:7a,2:3c9,2:7a,2:6b,1:e5,1:62,1:63,3:65,1:66,2:6d,b:3b3,1:3c0,6:64,1b574:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3"), $4e7e1af11ea066d2$var$Si("179:1,2:1,2:1,5:1,2:1,a:4f,a:1,8:1,2:1,2:1,3:1,5:1,3:1,4:1,2:1,3:1,4:1,8:2,1:1,2:2,1:1,2:2,27:2,195:26,2:25,1:25,1:25,2:40,2:3f,1:3f,33:1,11:-6,1:-9,1ac7:-3a,6d:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,b:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,c:-8,2:-8,2:-8,2:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,49:-8,1:-8,1:-4a,1:-4a,d:-56,1:-56,1:-56,1:-56,d:-8,1:-8,f:-8,1:-8,3:-7"), $4e7e1af11ea066d2$var$Si("df:00730073,51:00690307,19:02BC006E,a7:006A030C,18a:002003B9,16:03B903080301,20:03C503080301,1d7:05650582,190f:00680331,1:00740308,1:0077030A,1:0079030A,1:006102BE,b6:03C50313,2:03C503130300,2:03C503130301,2:03C503130342,2a:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,3:1F7003B9,1:03B103B9,1:03AC03B9,2:03B10342,1:03B1034203B9,5:03B103B9,6:1F7403B9,1:03B703B9,1:03AE03B9,2:03B70342,1:03B7034203B9,5:03B703B9,6:03B903080300,1:03B903080301,3:03B90342,1:03B903080342,b:03C503080300,1:03C503080301,1:03C10313,2:03C50342,1:03C503080342,b:1F7C03B9,1:03C903B9,1:03CE03B9,2:03C90342,1:03C9034203B9,5:03C903B9,ac:00720073,5b:00B00063,6:00B00066,d:006E006F,a:0073006D,1:00740065006C,1:0074006D,124f:006800700061,2:00610075,2:006F0076,b:00700061,1:006E0061,1:03BC0061,1:006D0061,1:006B0061,1:006B0062,1:006D0062,1:00670062,3:00700066,1:006E0066,1:03BC0066,4:0068007A,1:006B0068007A,1:006D0068007A,1:00670068007A,1:00740068007A,15:00700061,1:006B00700061,1:006D00700061,1:006700700061,8:00700076,1:006E0076,1:03BC0076,1:006D0076,1:006B0076,1:006D0076,1:00700077,1:006E0077,1:03BC0077,1:006D0077,1:006B0077,1:006D0077,1:006B03C9,1:006D03C9,2:00620071,3:00632215006B0067,1:0063006F002E,1:00640062,1:00670079,2:00680070,2:006B006B,1:006B006D,9:00700068,2:00700070006D,1:00700072,2:00730076,1:00770062,c723:00660066,1:00660069,1:0066006C,1:006600660069,1:00660066006C,1:00730074,1:00730074,d:05740576,1:05740565,1:0574056B,1:057E0576,1:0574056D", $4e7e1af11ea066d2$var$T0), $4e7e1af11ea066d2$var$$n("80-20,2a0-,39c,32,f71,18e,7f2-f,19-7,30-4,7-5,f81-b,5,a800-20ff,4d1-1f,110,fa-6,d174-7,2e84-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,2,1f-5f,ff7f-20001");
var $4e7e1af11ea066d2$var$tf = "hash/5.7.0";
function $4e7e1af11ea066d2$var$U0(e) {
    e = atob(e);
    var t = [];
    for(var r = 0; r < e.length; r++)t.push(e.charCodeAt(r));
    return $4e7e1af11ea066d2$var$Ot(t);
}
function $4e7e1af11ea066d2$var$ef(e, t) {
    t == null && (t = 1);
    var r = [], i = r.forEach, n = function n1(o, h) {
        i.call(o, function(p) {
            h > 0 && Array.isArray(p) ? n(p, h - 1) : r.push(p);
        });
    };
    return n(e, t), r;
}
function $4e7e1af11ea066d2$var$k0(e) {
    var t = {};
    for(var r = 0; r < e.length; r++){
        var i = e[r];
        t[i[0]] = i[1];
    }
    return t;
}
function $4e7e1af11ea066d2$var$q0(e) {
    var t = 0;
    function r() {
        return e[t++] << 8 | e[t++];
    }
    var i = r(), n = 1, o = [
        0,
        1
    ];
    for(var H = 1; H < i; H++)o.push(n += r());
    var h = r(), p = t;
    t += h;
    var b = 0, m = 0;
    function w() {
        return b == 0 && (m = m << 8 | e[t++], b = 8), m >> --b & 1;
    }
    var y = 31, S = Math.pow(2, y), I = S >>> 1, N = I >> 1, C = S - 1;
    var F = 0;
    for(var H1 = 0; H1 < y; H1++)F = F << 1 | w();
    var U = [], J = 0, Bt = S;
    for(;;){
        var H2 = Math.floor(((F - J + 1) * n - 1) / Bt), z = 0, Pt = i;
        for(; Pt - z > 1;){
            var Yt = z + Pt >>> 1;
            H2 < o[Yt] ? Pt = Yt : z = Yt;
        }
        if (z == 0) break;
        U.push(z);
        var W = J + Math.floor(Bt * o[z] / n), Rt = J + Math.floor(Bt * o[z + 1] / n) - 1;
        for(; !((W ^ Rt) & I);)F = F << 1 & C | w(), W = W << 1 & C, Rt = Rt << 1 & C | 1;
        for(; W & ~Rt & N;)F = F & I | F << 1 & C >>> 1 | w(), W = W << 1 ^ I, Rt = (Rt ^ I) << 1 | I | 1;
        J = W, Bt = 1 + Rt - W;
    }
    var G = i - 4;
    return U.map(function(H) {
        switch(H - G){
            case 3:
                return G + 65792 + (e[p++] << 16 | e[p++] << 8 | e[p++]);
            case 2:
                return G + 256 + (e[p++] << 8 | e[p++]);
            case 1:
                return G + e[p++];
            default:
                return H - 1;
        }
    });
}
function $4e7e1af11ea066d2$var$K0(e) {
    var t = 0;
    return function() {
        return e[t++];
    };
}
function $4e7e1af11ea066d2$var$H0(e) {
    return $4e7e1af11ea066d2$var$K0($4e7e1af11ea066d2$var$q0(e));
}
function $4e7e1af11ea066d2$var$z0(e) {
    return e & 1 ? ~e >> 1 : e >> 1;
}
function $4e7e1af11ea066d2$var$L0(e, t) {
    var r = Array(e);
    for(var i = 0; i < e; i++)r[i] = 1 + t();
    return r;
}
function $4e7e1af11ea066d2$var$rf(e, t) {
    var r = Array(e);
    for(var i = 0, n = -1; i < e; i++)r[i] = n += 1 + t();
    return r;
}
function $4e7e1af11ea066d2$var$j0(e, t) {
    var r = Array(e);
    for(var i = 0, n = 0; i < e; i++)r[i] = n += $4e7e1af11ea066d2$var$z0(t());
    return r;
}
function $4e7e1af11ea066d2$var$Pr(e, t) {
    var r = $4e7e1af11ea066d2$var$rf(e(), e), i = e(), n = $4e7e1af11ea066d2$var$rf(i, e), o = $4e7e1af11ea066d2$var$L0(i, e);
    for(var h = 0; h < i; h++)for(var p = 0; p < o[h]; p++)r.push(n[h] + p);
    return t ? r.map(function(h) {
        return t[h];
    }) : r;
}
function $4e7e1af11ea066d2$var$Q0(e) {
    var t = [];
    for(;;){
        var r = e();
        if (r == 0) break;
        t.push($4e7e1af11ea066d2$var$G0(r, e));
    }
    for(;;){
        var r1 = e() - 1;
        if (r1 < 0) break;
        t.push($4e7e1af11ea066d2$var$Y0(r1, e));
    }
    return $4e7e1af11ea066d2$var$k0($4e7e1af11ea066d2$var$ef(t));
}
function $4e7e1af11ea066d2$var$J0(e) {
    var t = [];
    for(;;){
        var r = e();
        if (r == 0) break;
        t.push(r);
    }
    return t;
}
function $4e7e1af11ea066d2$var$nf(e, t, r) {
    var i = Array(e).fill(void 0).map(function() {
        return [];
    });
    for(var n = 0; n < t; n++)$4e7e1af11ea066d2$var$j0(e, r).forEach(function(o, h) {
        return i[h].push(o);
    });
    return i;
}
function $4e7e1af11ea066d2$var$G0(e, t) {
    var r = 1 + t(), i = t(), n = $4e7e1af11ea066d2$var$J0(t), o = $4e7e1af11ea066d2$var$nf(n.length, 1 + e, t);
    return $4e7e1af11ea066d2$var$ef(o.map(function(h, p) {
        var b = h[0], m = h.slice(1);
        return Array(n[p]).fill(void 0).map(function(w, y) {
            var S = y * i;
            return [
                b + y * r,
                m.map(function(I) {
                    return I + S;
                })
            ];
        });
    }));
}
function $4e7e1af11ea066d2$var$Y0(e, t) {
    var r = 1 + t();
    return $4e7e1af11ea066d2$var$nf(r, 1 + e, t).map(function(n) {
        return [
            n[0],
            n.slice(1)
        ];
    });
}
function $4e7e1af11ea066d2$var$V0(e) {
    var t = $4e7e1af11ea066d2$var$Pr(e).sort(function(i, n) {
        return i - n;
    });
    return r();
    function r() {
        var i = [];
        for(;;){
            var m = $4e7e1af11ea066d2$var$Pr(e, t);
            if (m.length == 0) break;
            i.push({
                set: new Set(m),
                node: r()
            });
        }
        i.sort(function(m, w) {
            return w.set.size - m.set.size;
        });
        var n = e(), o = n % 3;
        n = n / 3 | 0;
        var h = !!(n & 1);
        n >>= 1;
        var p = n == 1, b = n == 2;
        return {
            branches: i,
            valid: o,
            fe0f: h,
            save: p,
            check: b
        };
    }
}
function $4e7e1af11ea066d2$var$W0() {
    return $4e7e1af11ea066d2$var$H0($4e7e1af11ea066d2$var$U0("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"));
}
var $4e7e1af11ea066d2$var$Dr = $4e7e1af11ea066d2$var$W0();
new Set($4e7e1af11ea066d2$var$Pr($4e7e1af11ea066d2$var$Dr)), new Set($4e7e1af11ea066d2$var$Pr($4e7e1af11ea066d2$var$Dr)), $4e7e1af11ea066d2$var$Q0($4e7e1af11ea066d2$var$Dr), $4e7e1af11ea066d2$var$V0($4e7e1af11ea066d2$var$Dr), new $4e7e1af11ea066d2$var$L($4e7e1af11ea066d2$var$tf);
var $4e7e1af11ea066d2$var$X0 = new Uint8Array(32);
$4e7e1af11ea066d2$var$X0.fill(0);
var $4e7e1af11ea066d2$var$Z0 = "\x19Ethereum Signed Message:\n";
function $4e7e1af11ea066d2$var$ff(e) {
    return typeof e == "string" && (e = $4e7e1af11ea066d2$var$Ei(e)), $4e7e1af11ea066d2$var$yi($4e7e1af11ea066d2$var$E0([
        $4e7e1af11ea066d2$var$Ei($4e7e1af11ea066d2$var$Z0),
        $4e7e1af11ea066d2$var$Ei(String(e.length)),
        e
    ]));
}
var $4e7e1af11ea066d2$var$$0 = "rlp/5.7.0";
new $4e7e1af11ea066d2$var$L($4e7e1af11ea066d2$var$$0);
var $4e7e1af11ea066d2$var$ts = "address/5.7.0", $4e7e1af11ea066d2$var$Ar = new $4e7e1af11ea066d2$var$L($4e7e1af11ea066d2$var$ts);
function $4e7e1af11ea066d2$var$of(e) {
    $4e7e1af11ea066d2$var$Qt(e, 20) || $4e7e1af11ea066d2$var$Ar.throwArgumentError("invalid address", "address", e), e = e.toLowerCase();
    var t = e.substring(2).split(""), r = new Uint8Array(40);
    for(var n = 0; n < 40; n++)r[n] = t[n].charCodeAt(0);
    var i = $4e7e1af11ea066d2$var$Ot($4e7e1af11ea066d2$var$yi(r));
    for(var n1 = 0; n1 < 40; n1 += 2)i[n1 >> 1] >> 4 >= 8 && (t[n1] = t[n1].toUpperCase()), (i[n1 >> 1] & 15) >= 8 && (t[n1 + 1] = t[n1 + 1].toUpperCase());
    return "0x" + t.join("");
}
var $4e7e1af11ea066d2$var$es = 9007199254740991;
function $4e7e1af11ea066d2$var$rs(e) {
    return Math.log10 ? Math.log10(e) : Math.log(e) / Math.LN10;
}
var $4e7e1af11ea066d2$var$Ni = {};
for(var $4e7e1af11ea066d2$var$e = 0; $4e7e1af11ea066d2$var$e < 10; $4e7e1af11ea066d2$var$e++)$4e7e1af11ea066d2$var$Ni[String($4e7e1af11ea066d2$var$e)] = String($4e7e1af11ea066d2$var$e);
for(var $4e7e1af11ea066d2$var$e1 = 0; $4e7e1af11ea066d2$var$e1 < 26; $4e7e1af11ea066d2$var$e1++)$4e7e1af11ea066d2$var$Ni[String.fromCharCode(65 + $4e7e1af11ea066d2$var$e1)] = String(10 + $4e7e1af11ea066d2$var$e1);
var $4e7e1af11ea066d2$var$sf = Math.floor($4e7e1af11ea066d2$var$rs($4e7e1af11ea066d2$var$es));
function $4e7e1af11ea066d2$var$is(e) {
    e = e.toUpperCase(), e = e.substring(4) + e.substring(0, 2) + "00";
    var t = e.split("").map(function(i) {
        return $4e7e1af11ea066d2$var$Ni[i];
    }).join("");
    for(; t.length >= $4e7e1af11ea066d2$var$sf;){
        var i = t.substring(0, $4e7e1af11ea066d2$var$sf);
        t = parseInt(i, 10) % 97 + t.substring(i.length);
    }
    var r = String(98 - parseInt(t, 10) % 97);
    for(; r.length < 2;)r = "0" + r;
    return r;
}
function $4e7e1af11ea066d2$var$ns(e) {
    var t = null;
    if (typeof e != "string" && $4e7e1af11ea066d2$var$Ar.throwArgumentError("invalid address", "address", e), e.match(/^(0x)?[0-9a-fA-F]{40}$/)) e.substring(0, 2) !== "0x" && (e = "0x" + e), t = $4e7e1af11ea066d2$var$of(e), e.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && t !== e && $4e7e1af11ea066d2$var$Ar.throwArgumentError("bad address checksum", "address", e);
    else if (e.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        for(e.substring(2, 4) !== $4e7e1af11ea066d2$var$is(e) && $4e7e1af11ea066d2$var$Ar.throwArgumentError("bad icap checksum", "address", e), t = $4e7e1af11ea066d2$var$R0(e.substring(4)); t.length < 40;)t = "0" + t;
        t = $4e7e1af11ea066d2$var$of("0x" + t);
    } else $4e7e1af11ea066d2$var$Ar.throwArgumentError("invalid address", "address", e);
    return t;
}
var $4e7e1af11ea066d2$var$fs = "properties/5.7.0";
new $4e7e1af11ea066d2$var$L($4e7e1af11ea066d2$var$fs);
function $4e7e1af11ea066d2$var$br(e, t, r) {
    Object.defineProperty(e, t, {
        enumerable: !0,
        value: r,
        writable: !1
    });
}
new $4e7e1af11ea066d2$var$L($4e7e1af11ea066d2$var$tf);
var $4e7e1af11ea066d2$var$os = new Uint8Array(32);
$4e7e1af11ea066d2$var$os.fill(0), $4e7e1af11ea066d2$var$V.from(-1);
var $4e7e1af11ea066d2$var$ss = $4e7e1af11ea066d2$var$V.from(0), $4e7e1af11ea066d2$var$as = $4e7e1af11ea066d2$var$V.from(1);
$4e7e1af11ea066d2$var$V.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), $4e7e1af11ea066d2$var$oe($4e7e1af11ea066d2$var$as.toHexString(), 32), $4e7e1af11ea066d2$var$oe($4e7e1af11ea066d2$var$ss.toHexString(), 32);
var $4e7e1af11ea066d2$var$se = {}, $4e7e1af11ea066d2$var$Q = {}, $4e7e1af11ea066d2$var$yr = $4e7e1af11ea066d2$var$af;
function $4e7e1af11ea066d2$var$af(e, t) {
    if (!e) throw new Error(t || "Assertion failed");
}
$4e7e1af11ea066d2$var$af.equal = function(t, r, i) {
    if (t != r) throw new Error(i || "Assertion failed: " + t + " != " + r);
};
var $4e7e1af11ea066d2$var$Ii = {
    exports: {}
};
typeof Object.create == "function" ? $4e7e1af11ea066d2$var$Ii.exports = function(t, r) {
    r && (t.super_ = r, t.prototype = Object.create(r.prototype, {
        constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0
        }
    }));
} : $4e7e1af11ea066d2$var$Ii.exports = function(t, r) {
    if (r) {
        t.super_ = r;
        var i = function i() {};
        i.prototype = r.prototype, t.prototype = new i, t.prototype.constructor = t;
    }
};
var $4e7e1af11ea066d2$var$us = $4e7e1af11ea066d2$var$yr, $4e7e1af11ea066d2$var$hs = $4e7e1af11ea066d2$var$Ii.exports;
$4e7e1af11ea066d2$var$Q.inherits = $4e7e1af11ea066d2$var$hs;
function $4e7e1af11ea066d2$var$cs(e, t) {
    return (e.charCodeAt(t) & 64512) !== 55296 || t < 0 || t + 1 >= e.length ? !1 : (e.charCodeAt(t + 1) & 64512) === 56320;
}
function $4e7e1af11ea066d2$var$ls(e, t) {
    if (Array.isArray(e)) return e.slice();
    if (!e) return [];
    var r = [];
    if (typeof e == "string") {
        if (t) {
            if (t === "hex") for(e = e.replace(/[^a-z0-9]+/ig, ""), e.length % 2 !== 0 && (e = "0" + e), n = 0; n < e.length; n += 2)r.push(parseInt(e[n] + e[n + 1], 16));
        } else for(var i = 0, n = 0; n < e.length; n++){
            var o = e.charCodeAt(n);
            o < 128 ? r[i++] = o : o < 2048 ? (r[i++] = o >> 6 | 192, r[i++] = o & 63 | 128) : $4e7e1af11ea066d2$var$cs(e, n) ? (o = 65536 + ((o & 1023) << 10) + (e.charCodeAt(++n) & 1023), r[i++] = o >> 18 | 240, r[i++] = o >> 12 & 63 | 128, r[i++] = o >> 6 & 63 | 128, r[i++] = o & 63 | 128) : (r[i++] = o >> 12 | 224, r[i++] = o >> 6 & 63 | 128, r[i++] = o & 63 | 128);
        }
    } else for(n = 0; n < e.length; n++)r[n] = e[n] | 0;
    return r;
}
$4e7e1af11ea066d2$var$Q.toArray = $4e7e1af11ea066d2$var$ls;
function $4e7e1af11ea066d2$var$ds(e) {
    for(var t = "", r = 0; r < e.length; r++)t += $4e7e1af11ea066d2$var$hf(e[r].toString(16));
    return t;
}
$4e7e1af11ea066d2$var$Q.toHex = $4e7e1af11ea066d2$var$ds;
function $4e7e1af11ea066d2$var$uf(e) {
    var t = e >>> 24 | e >>> 8 & 65280 | e << 8 & 16711680 | (e & 255) << 24;
    return t >>> 0;
}
$4e7e1af11ea066d2$var$Q.htonl = $4e7e1af11ea066d2$var$uf;
function $4e7e1af11ea066d2$var$ps(e, t) {
    for(var r = "", i = 0; i < e.length; i++){
        var n = e[i];
        t === "little" && (n = $4e7e1af11ea066d2$var$uf(n)), r += $4e7e1af11ea066d2$var$cf(n.toString(16));
    }
    return r;
}
$4e7e1af11ea066d2$var$Q.toHex32 = $4e7e1af11ea066d2$var$ps;
function $4e7e1af11ea066d2$var$hf(e) {
    return e.length === 1 ? "0" + e : e;
}
$4e7e1af11ea066d2$var$Q.zero2 = $4e7e1af11ea066d2$var$hf;
function $4e7e1af11ea066d2$var$cf(e) {
    return e.length === 7 ? "0" + e : e.length === 6 ? "00" + e : e.length === 5 ? "000" + e : e.length === 4 ? "0000" + e : e.length === 3 ? "00000" + e : e.length === 2 ? "000000" + e : e.length === 1 ? "0000000" + e : e;
}
$4e7e1af11ea066d2$var$Q.zero8 = $4e7e1af11ea066d2$var$cf;
function $4e7e1af11ea066d2$var$vs(e, t, r, i) {
    var n = r - t;
    $4e7e1af11ea066d2$var$us(n % 4 === 0);
    for(var o = new Array(n / 4), h = 0, p = t; h < o.length; h++, p += 4){
        var b;
        i === "big" ? b = e[p] << 24 | e[p + 1] << 16 | e[p + 2] << 8 | e[p + 3] : b = e[p + 3] << 24 | e[p + 2] << 16 | e[p + 1] << 8 | e[p], o[h] = b >>> 0;
    }
    return o;
}
$4e7e1af11ea066d2$var$Q.join32 = $4e7e1af11ea066d2$var$vs;
function $4e7e1af11ea066d2$var$ms(e, t) {
    for(var r = new Array(e.length * 4), i = 0, n = 0; i < e.length; i++, n += 4){
        var o = e[i];
        t === "big" ? (r[n] = o >>> 24, r[n + 1] = o >>> 16 & 255, r[n + 2] = o >>> 8 & 255, r[n + 3] = o & 255) : (r[n + 3] = o >>> 24, r[n + 2] = o >>> 16 & 255, r[n + 1] = o >>> 8 & 255, r[n] = o & 255);
    }
    return r;
}
$4e7e1af11ea066d2$var$Q.split32 = $4e7e1af11ea066d2$var$ms;
function $4e7e1af11ea066d2$var$gs(e, t) {
    return e >>> t | e << 32 - t;
}
$4e7e1af11ea066d2$var$Q.rotr32 = $4e7e1af11ea066d2$var$gs;
function $4e7e1af11ea066d2$var$As(e, t) {
    return e << t | e >>> 32 - t;
}
$4e7e1af11ea066d2$var$Q.rotl32 = $4e7e1af11ea066d2$var$As;
function $4e7e1af11ea066d2$var$bs(e, t) {
    return e + t >>> 0;
}
$4e7e1af11ea066d2$var$Q.sum32 = $4e7e1af11ea066d2$var$bs;
function $4e7e1af11ea066d2$var$ys(e, t, r) {
    return e + t + r >>> 0;
}
$4e7e1af11ea066d2$var$Q.sum32_3 = $4e7e1af11ea066d2$var$ys;
function $4e7e1af11ea066d2$var$ws(e, t, r, i) {
    return e + t + r + i >>> 0;
}
$4e7e1af11ea066d2$var$Q.sum32_4 = $4e7e1af11ea066d2$var$ws;
function $4e7e1af11ea066d2$var$xs(e, t, r, i, n) {
    return e + t + r + i + n >>> 0;
}
$4e7e1af11ea066d2$var$Q.sum32_5 = $4e7e1af11ea066d2$var$xs;
function $4e7e1af11ea066d2$var$Ms(e, t, r, i) {
    var n = e[t], o = e[t + 1], h = i + o >>> 0, p = (h < i ? 1 : 0) + r + n;
    e[t] = p >>> 0, e[t + 1] = h;
}
$4e7e1af11ea066d2$var$Q.sum64 = $4e7e1af11ea066d2$var$Ms;
function $4e7e1af11ea066d2$var$Es(e, t, r, i) {
    var n = t + i >>> 0, o = (n < t ? 1 : 0) + e + r;
    return o >>> 0;
}
$4e7e1af11ea066d2$var$Q.sum64_hi = $4e7e1af11ea066d2$var$Es;
function $4e7e1af11ea066d2$var$Ss(e, t, r, i) {
    var n = t + i;
    return n >>> 0;
}
$4e7e1af11ea066d2$var$Q.sum64_lo = $4e7e1af11ea066d2$var$Ss;
function $4e7e1af11ea066d2$var$Ns(e, t, r, i, n, o, h, p) {
    var b = 0, m = t;
    m = m + i >>> 0, b += m < t ? 1 : 0, m = m + o >>> 0, b += m < o ? 1 : 0, m = m + p >>> 0, b += m < p ? 1 : 0;
    var w = e + r + n + h + b;
    return w >>> 0;
}
$4e7e1af11ea066d2$var$Q.sum64_4_hi = $4e7e1af11ea066d2$var$Ns;
function $4e7e1af11ea066d2$var$Is(e, t, r, i, n, o, h, p) {
    var b = t + i + o + p;
    return b >>> 0;
}
$4e7e1af11ea066d2$var$Q.sum64_4_lo = $4e7e1af11ea066d2$var$Is;
function $4e7e1af11ea066d2$var$_s(e, t, r, i, n, o, h, p, b, m) {
    var w = 0, y = t;
    y = y + i >>> 0, w += y < t ? 1 : 0, y = y + o >>> 0, w += y < o ? 1 : 0, y = y + p >>> 0, w += y < p ? 1 : 0, y = y + m >>> 0, w += y < m ? 1 : 0;
    var S = e + r + n + h + b + w;
    return S >>> 0;
}
$4e7e1af11ea066d2$var$Q.sum64_5_hi = $4e7e1af11ea066d2$var$_s;
function $4e7e1af11ea066d2$var$Bs(e, t, r, i, n, o, h, p, b, m) {
    var w = t + i + o + p + m;
    return w >>> 0;
}
$4e7e1af11ea066d2$var$Q.sum64_5_lo = $4e7e1af11ea066d2$var$Bs;
function $4e7e1af11ea066d2$var$Cs(e, t, r) {
    var i = t << 32 - r | e >>> r;
    return i >>> 0;
}
$4e7e1af11ea066d2$var$Q.rotr64_hi = $4e7e1af11ea066d2$var$Cs;
function $4e7e1af11ea066d2$var$Rs(e, t, r) {
    var i = e << 32 - r | t >>> r;
    return i >>> 0;
}
$4e7e1af11ea066d2$var$Q.rotr64_lo = $4e7e1af11ea066d2$var$Rs;
function $4e7e1af11ea066d2$var$Os(e, t, r) {
    return e >>> r;
}
$4e7e1af11ea066d2$var$Q.shr64_hi = $4e7e1af11ea066d2$var$Os;
function $4e7e1af11ea066d2$var$Ps(e, t, r) {
    var i = e << 32 - r | t >>> r;
    return i >>> 0;
}
$4e7e1af11ea066d2$var$Q.shr64_lo = $4e7e1af11ea066d2$var$Ps;
var $4e7e1af11ea066d2$var$fr = {}, $4e7e1af11ea066d2$var$lf = $4e7e1af11ea066d2$var$Q, $4e7e1af11ea066d2$var$Ds = $4e7e1af11ea066d2$var$yr;
function $4e7e1af11ea066d2$var$Fr() {
    this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
}
$4e7e1af11ea066d2$var$fr.BlockHash = $4e7e1af11ea066d2$var$Fr, $4e7e1af11ea066d2$var$Fr.prototype.update = function(t, r) {
    if (t = $4e7e1af11ea066d2$var$lf.toArray(t, r), this.pending ? this.pending = this.pending.concat(t) : this.pending = t, this.pendingTotal += t.length, this.pending.length >= this._delta8) {
        t = this.pending;
        var i = t.length % this._delta8;
        this.pending = t.slice(t.length - i, t.length), this.pending.length === 0 && (this.pending = null), t = $4e7e1af11ea066d2$var$lf.join32(t, 0, t.length - i, this.endian);
        for(var n = 0; n < t.length; n += this._delta32)this._update(t, n, n + this._delta32);
    }
    return this;
}, $4e7e1af11ea066d2$var$Fr.prototype.digest = function(t) {
    return this.update(this._pad()), $4e7e1af11ea066d2$var$Ds(this.pending === null), this._digest(t);
}, $4e7e1af11ea066d2$var$Fr.prototype._pad = function() {
    var t = this.pendingTotal, r = this._delta8, i = r - (t + this.padLength) % r, n = new Array(i + this.padLength);
    n[0] = 128;
    for(var o = 1; o < i; o++)n[o] = 0;
    if (t <<= 3, this.endian === "big") {
        for(var h = 8; h < this.padLength; h++)n[o++] = 0;
        n[o++] = 0, n[o++] = 0, n[o++] = 0, n[o++] = 0, n[o++] = t >>> 24 & 255, n[o++] = t >>> 16 & 255, n[o++] = t >>> 8 & 255, n[o++] = t & 255;
    } else for(n[o++] = t & 255, n[o++] = t >>> 8 & 255, n[o++] = t >>> 16 & 255, n[o++] = t >>> 24 & 255, n[o++] = 0, n[o++] = 0, n[o++] = 0, n[o++] = 0, h = 8; h < this.padLength; h++)n[o++] = 0;
    return n;
};
var $4e7e1af11ea066d2$var$or = {}, $4e7e1af11ea066d2$var$ae = {}, $4e7e1af11ea066d2$var$Fs = $4e7e1af11ea066d2$var$Q, $4e7e1af11ea066d2$var$ue = $4e7e1af11ea066d2$var$Fs.rotr32;
function $4e7e1af11ea066d2$var$Ts(e, t, r, i) {
    if (e === 0) return $4e7e1af11ea066d2$var$df(t, r, i);
    if (e === 1 || e === 3) return $4e7e1af11ea066d2$var$vf(t, r, i);
    if (e === 2) return $4e7e1af11ea066d2$var$pf(t, r, i);
}
$4e7e1af11ea066d2$var$ae.ft_1 = $4e7e1af11ea066d2$var$Ts;
function $4e7e1af11ea066d2$var$df(e, t, r) {
    return e & t ^ ~e & r;
}
$4e7e1af11ea066d2$var$ae.ch32 = $4e7e1af11ea066d2$var$df;
function $4e7e1af11ea066d2$var$pf(e, t, r) {
    return e & t ^ e & r ^ t & r;
}
$4e7e1af11ea066d2$var$ae.maj32 = $4e7e1af11ea066d2$var$pf;
function $4e7e1af11ea066d2$var$vf(e, t, r) {
    return e ^ t ^ r;
}
$4e7e1af11ea066d2$var$ae.p32 = $4e7e1af11ea066d2$var$vf;
function $4e7e1af11ea066d2$var$Us(e) {
    return $4e7e1af11ea066d2$var$ue(e, 2) ^ $4e7e1af11ea066d2$var$ue(e, 13) ^ $4e7e1af11ea066d2$var$ue(e, 22);
}
$4e7e1af11ea066d2$var$ae.s0_256 = $4e7e1af11ea066d2$var$Us;
function $4e7e1af11ea066d2$var$ks(e) {
    return $4e7e1af11ea066d2$var$ue(e, 6) ^ $4e7e1af11ea066d2$var$ue(e, 11) ^ $4e7e1af11ea066d2$var$ue(e, 25);
}
$4e7e1af11ea066d2$var$ae.s1_256 = $4e7e1af11ea066d2$var$ks;
function $4e7e1af11ea066d2$var$qs(e) {
    return $4e7e1af11ea066d2$var$ue(e, 7) ^ $4e7e1af11ea066d2$var$ue(e, 18) ^ e >>> 3;
}
$4e7e1af11ea066d2$var$ae.g0_256 = $4e7e1af11ea066d2$var$qs;
function $4e7e1af11ea066d2$var$Ks(e) {
    return $4e7e1af11ea066d2$var$ue(e, 17) ^ $4e7e1af11ea066d2$var$ue(e, 19) ^ e >>> 10;
}
$4e7e1af11ea066d2$var$ae.g1_256 = $4e7e1af11ea066d2$var$Ks;
var $4e7e1af11ea066d2$var$sr = $4e7e1af11ea066d2$var$Q, $4e7e1af11ea066d2$var$Hs = $4e7e1af11ea066d2$var$fr, $4e7e1af11ea066d2$var$zs = $4e7e1af11ea066d2$var$ae, $4e7e1af11ea066d2$var$_i = $4e7e1af11ea066d2$var$sr.rotl32, $4e7e1af11ea066d2$var$wr = $4e7e1af11ea066d2$var$sr.sum32, $4e7e1af11ea066d2$var$Ls = $4e7e1af11ea066d2$var$sr.sum32_5, $4e7e1af11ea066d2$var$js = $4e7e1af11ea066d2$var$zs.ft_1, $4e7e1af11ea066d2$var$mf = $4e7e1af11ea066d2$var$Hs.BlockHash, $4e7e1af11ea066d2$var$Qs = [
    1518500249,
    1859775393,
    2400959708,
    3395469782
];
function $4e7e1af11ea066d2$var$he() {
    if (!(this instanceof $4e7e1af11ea066d2$var$he)) return new $4e7e1af11ea066d2$var$he;
    $4e7e1af11ea066d2$var$mf.call(this), this.h = [
        1732584193,
        4023233417,
        2562383102,
        271733878,
        3285377520
    ], this.W = new Array(80);
}
$4e7e1af11ea066d2$var$sr.inherits($4e7e1af11ea066d2$var$he, $4e7e1af11ea066d2$var$mf);
var $4e7e1af11ea066d2$var$Js = $4e7e1af11ea066d2$var$he;
$4e7e1af11ea066d2$var$he.blockSize = 512, $4e7e1af11ea066d2$var$he.outSize = 160, $4e7e1af11ea066d2$var$he.hmacStrength = 80, $4e7e1af11ea066d2$var$he.padLength = 64, $4e7e1af11ea066d2$var$he.prototype._update = function(t, r) {
    for(var i = this.W, n = 0; n < 16; n++)i[n] = t[r + n];
    for(; n < i.length; n++)i[n] = $4e7e1af11ea066d2$var$_i(i[n - 3] ^ i[n - 8] ^ i[n - 14] ^ i[n - 16], 1);
    var o = this.h[0], h = this.h[1], p = this.h[2], b = this.h[3], m = this.h[4];
    for(n = 0; n < i.length; n++){
        var w = ~~(n / 20), y = $4e7e1af11ea066d2$var$Ls($4e7e1af11ea066d2$var$_i(o, 5), $4e7e1af11ea066d2$var$js(w, h, p, b), m, i[n], $4e7e1af11ea066d2$var$Qs[w]);
        m = b, b = p, p = $4e7e1af11ea066d2$var$_i(h, 30), h = o, o = y;
    }
    this.h[0] = $4e7e1af11ea066d2$var$wr(this.h[0], o), this.h[1] = $4e7e1af11ea066d2$var$wr(this.h[1], h), this.h[2] = $4e7e1af11ea066d2$var$wr(this.h[2], p), this.h[3] = $4e7e1af11ea066d2$var$wr(this.h[3], b), this.h[4] = $4e7e1af11ea066d2$var$wr(this.h[4], m);
}, $4e7e1af11ea066d2$var$he.prototype._digest = function(t) {
    return t === "hex" ? $4e7e1af11ea066d2$var$sr.toHex32(this.h, "big") : $4e7e1af11ea066d2$var$sr.split32(this.h, "big");
};
var $4e7e1af11ea066d2$var$ar = $4e7e1af11ea066d2$var$Q, $4e7e1af11ea066d2$var$Gs = $4e7e1af11ea066d2$var$fr, $4e7e1af11ea066d2$var$ur = $4e7e1af11ea066d2$var$ae, $4e7e1af11ea066d2$var$Ys = $4e7e1af11ea066d2$var$yr, $4e7e1af11ea066d2$var$ie = $4e7e1af11ea066d2$var$ar.sum32, $4e7e1af11ea066d2$var$Vs = $4e7e1af11ea066d2$var$ar.sum32_4, $4e7e1af11ea066d2$var$Ws = $4e7e1af11ea066d2$var$ar.sum32_5, $4e7e1af11ea066d2$var$Xs = $4e7e1af11ea066d2$var$ur.ch32, $4e7e1af11ea066d2$var$Zs = $4e7e1af11ea066d2$var$ur.maj32, $4e7e1af11ea066d2$var$$s = $4e7e1af11ea066d2$var$ur.s0_256, $4e7e1af11ea066d2$var$ta = $4e7e1af11ea066d2$var$ur.s1_256, $4e7e1af11ea066d2$var$ea = $4e7e1af11ea066d2$var$ur.g0_256, $4e7e1af11ea066d2$var$ra = $4e7e1af11ea066d2$var$ur.g1_256, $4e7e1af11ea066d2$var$gf = $4e7e1af11ea066d2$var$Gs.BlockHash, $4e7e1af11ea066d2$var$ia = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
];
function $4e7e1af11ea066d2$var$ce() {
    if (!(this instanceof $4e7e1af11ea066d2$var$ce)) return new $4e7e1af11ea066d2$var$ce;
    $4e7e1af11ea066d2$var$gf.call(this), this.h = [
        1779033703,
        3144134277,
        1013904242,
        2773480762,
        1359893119,
        2600822924,
        528734635,
        1541459225
    ], this.k = $4e7e1af11ea066d2$var$ia, this.W = new Array(64);
}
$4e7e1af11ea066d2$var$ar.inherits($4e7e1af11ea066d2$var$ce, $4e7e1af11ea066d2$var$gf);
var $4e7e1af11ea066d2$var$Af = $4e7e1af11ea066d2$var$ce;
$4e7e1af11ea066d2$var$ce.blockSize = 512, $4e7e1af11ea066d2$var$ce.outSize = 256, $4e7e1af11ea066d2$var$ce.hmacStrength = 192, $4e7e1af11ea066d2$var$ce.padLength = 64, $4e7e1af11ea066d2$var$ce.prototype._update = function(t, r) {
    for(var i = this.W, n = 0; n < 16; n++)i[n] = t[r + n];
    for(; n < i.length; n++)i[n] = $4e7e1af11ea066d2$var$Vs($4e7e1af11ea066d2$var$ra(i[n - 2]), i[n - 7], $4e7e1af11ea066d2$var$ea(i[n - 15]), i[n - 16]);
    var o = this.h[0], h = this.h[1], p = this.h[2], b = this.h[3], m = this.h[4], w = this.h[5], y = this.h[6], S = this.h[7];
    for($4e7e1af11ea066d2$var$Ys(this.k.length === i.length), n = 0; n < i.length; n++){
        var I = $4e7e1af11ea066d2$var$Ws(S, $4e7e1af11ea066d2$var$ta(m), $4e7e1af11ea066d2$var$Xs(m, w, y), this.k[n], i[n]), N = $4e7e1af11ea066d2$var$ie($4e7e1af11ea066d2$var$$s(o), $4e7e1af11ea066d2$var$Zs(o, h, p));
        S = y, y = w, w = m, m = $4e7e1af11ea066d2$var$ie(b, I), b = p, p = h, h = o, o = $4e7e1af11ea066d2$var$ie(I, N);
    }
    this.h[0] = $4e7e1af11ea066d2$var$ie(this.h[0], o), this.h[1] = $4e7e1af11ea066d2$var$ie(this.h[1], h), this.h[2] = $4e7e1af11ea066d2$var$ie(this.h[2], p), this.h[3] = $4e7e1af11ea066d2$var$ie(this.h[3], b), this.h[4] = $4e7e1af11ea066d2$var$ie(this.h[4], m), this.h[5] = $4e7e1af11ea066d2$var$ie(this.h[5], w), this.h[6] = $4e7e1af11ea066d2$var$ie(this.h[6], y), this.h[7] = $4e7e1af11ea066d2$var$ie(this.h[7], S);
}, $4e7e1af11ea066d2$var$ce.prototype._digest = function(t) {
    return t === "hex" ? $4e7e1af11ea066d2$var$ar.toHex32(this.h, "big") : $4e7e1af11ea066d2$var$ar.split32(this.h, "big");
};
var $4e7e1af11ea066d2$var$Bi = $4e7e1af11ea066d2$var$Q, $4e7e1af11ea066d2$var$bf = $4e7e1af11ea066d2$var$Af;
function $4e7e1af11ea066d2$var$ye() {
    if (!(this instanceof $4e7e1af11ea066d2$var$ye)) return new $4e7e1af11ea066d2$var$ye;
    $4e7e1af11ea066d2$var$bf.call(this), this.h = [
        3238371032,
        914150663,
        812702999,
        4144912697,
        4290775857,
        1750603025,
        1694076839,
        3204075428
    ];
}
$4e7e1af11ea066d2$var$Bi.inherits($4e7e1af11ea066d2$var$ye, $4e7e1af11ea066d2$var$bf);
var $4e7e1af11ea066d2$var$na = $4e7e1af11ea066d2$var$ye;
$4e7e1af11ea066d2$var$ye.blockSize = 512, $4e7e1af11ea066d2$var$ye.outSize = 224, $4e7e1af11ea066d2$var$ye.hmacStrength = 192, $4e7e1af11ea066d2$var$ye.padLength = 64, $4e7e1af11ea066d2$var$ye.prototype._digest = function(t) {
    return t === "hex" ? $4e7e1af11ea066d2$var$Bi.toHex32(this.h.slice(0, 7), "big") : $4e7e1af11ea066d2$var$Bi.split32(this.h.slice(0, 7), "big");
};
var $4e7e1af11ea066d2$var$jt = $4e7e1af11ea066d2$var$Q, $4e7e1af11ea066d2$var$fa = $4e7e1af11ea066d2$var$fr, $4e7e1af11ea066d2$var$oa = $4e7e1af11ea066d2$var$yr, $4e7e1af11ea066d2$var$le = $4e7e1af11ea066d2$var$jt.rotr64_hi, $4e7e1af11ea066d2$var$de = $4e7e1af11ea066d2$var$jt.rotr64_lo, $4e7e1af11ea066d2$var$yf = $4e7e1af11ea066d2$var$jt.shr64_hi, $4e7e1af11ea066d2$var$wf = $4e7e1af11ea066d2$var$jt.shr64_lo, $4e7e1af11ea066d2$var$Be = $4e7e1af11ea066d2$var$jt.sum64, $4e7e1af11ea066d2$var$Ci = $4e7e1af11ea066d2$var$jt.sum64_hi, $4e7e1af11ea066d2$var$Ri = $4e7e1af11ea066d2$var$jt.sum64_lo, $4e7e1af11ea066d2$var$sa = $4e7e1af11ea066d2$var$jt.sum64_4_hi, $4e7e1af11ea066d2$var$aa = $4e7e1af11ea066d2$var$jt.sum64_4_lo, $4e7e1af11ea066d2$var$ua = $4e7e1af11ea066d2$var$jt.sum64_5_hi, $4e7e1af11ea066d2$var$ha = $4e7e1af11ea066d2$var$jt.sum64_5_lo, $4e7e1af11ea066d2$var$xf = $4e7e1af11ea066d2$var$fa.BlockHash, $4e7e1af11ea066d2$var$ca = [
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
];
function $4e7e1af11ea066d2$var$ne() {
    if (!(this instanceof $4e7e1af11ea066d2$var$ne)) return new $4e7e1af11ea066d2$var$ne;
    $4e7e1af11ea066d2$var$xf.call(this), this.h = [
        1779033703,
        4089235720,
        3144134277,
        2227873595,
        1013904242,
        4271175723,
        2773480762,
        1595750129,
        1359893119,
        2917565137,
        2600822924,
        725511199,
        528734635,
        4215389547,
        1541459225,
        327033209
    ], this.k = $4e7e1af11ea066d2$var$ca, this.W = new Array(160);
}
$4e7e1af11ea066d2$var$jt.inherits($4e7e1af11ea066d2$var$ne, $4e7e1af11ea066d2$var$xf);
var $4e7e1af11ea066d2$var$Mf = $4e7e1af11ea066d2$var$ne;
$4e7e1af11ea066d2$var$ne.blockSize = 1024, $4e7e1af11ea066d2$var$ne.outSize = 512, $4e7e1af11ea066d2$var$ne.hmacStrength = 192, $4e7e1af11ea066d2$var$ne.padLength = 128, $4e7e1af11ea066d2$var$ne.prototype._prepareBlock = function(t, r) {
    for(var i = this.W, n = 0; n < 32; n++)i[n] = t[r + n];
    for(; n < i.length; n += 2){
        var o = $4e7e1af11ea066d2$var$xa(i[n - 4], i[n - 3]), h = $4e7e1af11ea066d2$var$Ma(i[n - 4], i[n - 3]), p = i[n - 14], b = i[n - 13], m = $4e7e1af11ea066d2$var$ya(i[n - 30], i[n - 29]), w = $4e7e1af11ea066d2$var$wa(i[n - 30], i[n - 29]), y = i[n - 32], S = i[n - 31];
        i[n] = $4e7e1af11ea066d2$var$sa(o, h, p, b, m, w, y, S), i[n + 1] = $4e7e1af11ea066d2$var$aa(o, h, p, b, m, w, y, S);
    }
}, $4e7e1af11ea066d2$var$ne.prototype._update = function(t, r) {
    this._prepareBlock(t, r);
    var i = this.W, n = this.h[0], o = this.h[1], h = this.h[2], p = this.h[3], b = this.h[4], m = this.h[5], w = this.h[6], y = this.h[7], S = this.h[8], I = this.h[9], N = this.h[10], C = this.h[11], F = this.h[12], U = this.h[13], J = this.h[14], Bt = this.h[15];
    $4e7e1af11ea066d2$var$oa(this.k.length === i.length);
    for(var G = 0; G < i.length; G += 2){
        var H = J, z = Bt, Pt = $4e7e1af11ea066d2$var$Aa(S, I), W = $4e7e1af11ea066d2$var$ba(S, I), Rt = $4e7e1af11ea066d2$var$la(S, I, N, C, F), Yt = $4e7e1af11ea066d2$var$da(S, I, N, C, F, U), Y = this.k[G], Vt = this.k[G + 1], A = i[G], f = i[G + 1], a = $4e7e1af11ea066d2$var$ua(H, z, Pt, W, Rt, Yt, Y, Vt, A, f), c = $4e7e1af11ea066d2$var$ha(H, z, Pt, W, Rt, Yt, Y, Vt, A, f);
        H = $4e7e1af11ea066d2$var$ma(n, o), z = $4e7e1af11ea066d2$var$ga(n, o), Pt = $4e7e1af11ea066d2$var$pa(n, o, h, p, b), W = $4e7e1af11ea066d2$var$va(n, o, h, p, b, m);
        var d = $4e7e1af11ea066d2$var$Ci(H, z, Pt, W), g = $4e7e1af11ea066d2$var$Ri(H, z, Pt, W);
        J = F, Bt = U, F = N, U = C, N = S, C = I, S = $4e7e1af11ea066d2$var$Ci(w, y, a, c), I = $4e7e1af11ea066d2$var$Ri(y, y, a, c), w = b, y = m, b = h, m = p, h = n, p = o, n = $4e7e1af11ea066d2$var$Ci(a, c, d, g), o = $4e7e1af11ea066d2$var$Ri(a, c, d, g);
    }
    $4e7e1af11ea066d2$var$Be(this.h, 0, n, o), $4e7e1af11ea066d2$var$Be(this.h, 2, h, p), $4e7e1af11ea066d2$var$Be(this.h, 4, b, m), $4e7e1af11ea066d2$var$Be(this.h, 6, w, y), $4e7e1af11ea066d2$var$Be(this.h, 8, S, I), $4e7e1af11ea066d2$var$Be(this.h, 10, N, C), $4e7e1af11ea066d2$var$Be(this.h, 12, F, U), $4e7e1af11ea066d2$var$Be(this.h, 14, J, Bt);
}, $4e7e1af11ea066d2$var$ne.prototype._digest = function(t) {
    return t === "hex" ? $4e7e1af11ea066d2$var$jt.toHex32(this.h, "big") : $4e7e1af11ea066d2$var$jt.split32(this.h, "big");
};
function $4e7e1af11ea066d2$var$la(e, t, r, i, n) {
    var o = e & r ^ ~e & n;
    return o < 0 && (o += 4294967296), o;
}
function $4e7e1af11ea066d2$var$da(e, t, r, i, n, o) {
    var h = t & i ^ ~t & o;
    return h < 0 && (h += 4294967296), h;
}
function $4e7e1af11ea066d2$var$pa(e, t, r, i, n) {
    var o = e & r ^ e & n ^ r & n;
    return o < 0 && (o += 4294967296), o;
}
function $4e7e1af11ea066d2$var$va(e, t, r, i, n, o) {
    var h = t & i ^ t & o ^ i & o;
    return h < 0 && (h += 4294967296), h;
}
function $4e7e1af11ea066d2$var$ma(e, t) {
    var r = $4e7e1af11ea066d2$var$le(e, t, 28), i = $4e7e1af11ea066d2$var$le(t, e, 2), n = $4e7e1af11ea066d2$var$le(t, e, 7), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $4e7e1af11ea066d2$var$ga(e, t) {
    var r = $4e7e1af11ea066d2$var$de(e, t, 28), i = $4e7e1af11ea066d2$var$de(t, e, 2), n = $4e7e1af11ea066d2$var$de(t, e, 7), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $4e7e1af11ea066d2$var$Aa(e, t) {
    var r = $4e7e1af11ea066d2$var$le(e, t, 14), i = $4e7e1af11ea066d2$var$le(e, t, 18), n = $4e7e1af11ea066d2$var$le(t, e, 9), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $4e7e1af11ea066d2$var$ba(e, t) {
    var r = $4e7e1af11ea066d2$var$de(e, t, 14), i = $4e7e1af11ea066d2$var$de(e, t, 18), n = $4e7e1af11ea066d2$var$de(t, e, 9), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $4e7e1af11ea066d2$var$ya(e, t) {
    var r = $4e7e1af11ea066d2$var$le(e, t, 1), i = $4e7e1af11ea066d2$var$le(e, t, 8), n = $4e7e1af11ea066d2$var$yf(e, t, 7), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $4e7e1af11ea066d2$var$wa(e, t) {
    var r = $4e7e1af11ea066d2$var$de(e, t, 1), i = $4e7e1af11ea066d2$var$de(e, t, 8), n = $4e7e1af11ea066d2$var$wf(e, t, 7), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $4e7e1af11ea066d2$var$xa(e, t) {
    var r = $4e7e1af11ea066d2$var$le(e, t, 19), i = $4e7e1af11ea066d2$var$le(t, e, 29), n = $4e7e1af11ea066d2$var$yf(e, t, 6), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
function $4e7e1af11ea066d2$var$Ma(e, t) {
    var r = $4e7e1af11ea066d2$var$de(e, t, 19), i = $4e7e1af11ea066d2$var$de(t, e, 29), n = $4e7e1af11ea066d2$var$wf(e, t, 6), o = r ^ i ^ n;
    return o < 0 && (o += 4294967296), o;
}
var $4e7e1af11ea066d2$var$Oi = $4e7e1af11ea066d2$var$Q, $4e7e1af11ea066d2$var$Ef = $4e7e1af11ea066d2$var$Mf;
function $4e7e1af11ea066d2$var$we() {
    if (!(this instanceof $4e7e1af11ea066d2$var$we)) return new $4e7e1af11ea066d2$var$we;
    $4e7e1af11ea066d2$var$Ef.call(this), this.h = [
        3418070365,
        3238371032,
        1654270250,
        914150663,
        2438529370,
        812702999,
        355462360,
        4144912697,
        1731405415,
        4290775857,
        2394180231,
        1750603025,
        3675008525,
        1694076839,
        1203062813,
        3204075428
    ];
}
$4e7e1af11ea066d2$var$Oi.inherits($4e7e1af11ea066d2$var$we, $4e7e1af11ea066d2$var$Ef);
var $4e7e1af11ea066d2$var$Ea = $4e7e1af11ea066d2$var$we;
$4e7e1af11ea066d2$var$we.blockSize = 1024, $4e7e1af11ea066d2$var$we.outSize = 384, $4e7e1af11ea066d2$var$we.hmacStrength = 192, $4e7e1af11ea066d2$var$we.padLength = 128, $4e7e1af11ea066d2$var$we.prototype._digest = function(t) {
    return t === "hex" ? $4e7e1af11ea066d2$var$Oi.toHex32(this.h.slice(0, 12), "big") : $4e7e1af11ea066d2$var$Oi.split32(this.h.slice(0, 12), "big");
}, $4e7e1af11ea066d2$var$or.sha1 = $4e7e1af11ea066d2$var$Js, $4e7e1af11ea066d2$var$or.sha224 = $4e7e1af11ea066d2$var$na, $4e7e1af11ea066d2$var$or.sha256 = $4e7e1af11ea066d2$var$Af, $4e7e1af11ea066d2$var$or.sha384 = $4e7e1af11ea066d2$var$Ea, $4e7e1af11ea066d2$var$or.sha512 = $4e7e1af11ea066d2$var$Mf;
var $4e7e1af11ea066d2$var$Sf = {}, $4e7e1af11ea066d2$var$Xe = $4e7e1af11ea066d2$var$Q, $4e7e1af11ea066d2$var$Sa = $4e7e1af11ea066d2$var$fr, $4e7e1af11ea066d2$var$Tr = $4e7e1af11ea066d2$var$Xe.rotl32, $4e7e1af11ea066d2$var$Nf = $4e7e1af11ea066d2$var$Xe.sum32, $4e7e1af11ea066d2$var$xr = $4e7e1af11ea066d2$var$Xe.sum32_3, $4e7e1af11ea066d2$var$If = $4e7e1af11ea066d2$var$Xe.sum32_4, $4e7e1af11ea066d2$var$_f = $4e7e1af11ea066d2$var$Sa.BlockHash;
function $4e7e1af11ea066d2$var$pe() {
    if (!(this instanceof $4e7e1af11ea066d2$var$pe)) return new $4e7e1af11ea066d2$var$pe;
    $4e7e1af11ea066d2$var$_f.call(this), this.h = [
        1732584193,
        4023233417,
        2562383102,
        271733878,
        3285377520
    ], this.endian = "little";
}
$4e7e1af11ea066d2$var$Xe.inherits($4e7e1af11ea066d2$var$pe, $4e7e1af11ea066d2$var$_f), $4e7e1af11ea066d2$var$Sf.ripemd160 = $4e7e1af11ea066d2$var$pe, $4e7e1af11ea066d2$var$pe.blockSize = 512, $4e7e1af11ea066d2$var$pe.outSize = 160, $4e7e1af11ea066d2$var$pe.hmacStrength = 192, $4e7e1af11ea066d2$var$pe.padLength = 64, $4e7e1af11ea066d2$var$pe.prototype._update = function(t, r) {
    for(var i = this.h[0], n = this.h[1], o = this.h[2], h = this.h[3], p = this.h[4], b = i, m = n, w = o, y = h, S = p, I = 0; I < 80; I++){
        var N = $4e7e1af11ea066d2$var$Nf($4e7e1af11ea066d2$var$Tr($4e7e1af11ea066d2$var$If(i, $4e7e1af11ea066d2$var$Bf(I, n, o, h), t[$4e7e1af11ea066d2$var$_a[I] + r], $4e7e1af11ea066d2$var$Na(I)), $4e7e1af11ea066d2$var$Ca[I]), p);
        i = p, p = h, h = $4e7e1af11ea066d2$var$Tr(o, 10), o = n, n = N, N = $4e7e1af11ea066d2$var$Nf($4e7e1af11ea066d2$var$Tr($4e7e1af11ea066d2$var$If(b, $4e7e1af11ea066d2$var$Bf(79 - I, m, w, y), t[$4e7e1af11ea066d2$var$Ba[I] + r], $4e7e1af11ea066d2$var$Ia(I)), $4e7e1af11ea066d2$var$Ra[I]), S), b = S, S = y, y = $4e7e1af11ea066d2$var$Tr(w, 10), w = m, m = N;
    }
    N = $4e7e1af11ea066d2$var$xr(this.h[1], o, y), this.h[1] = $4e7e1af11ea066d2$var$xr(this.h[2], h, S), this.h[2] = $4e7e1af11ea066d2$var$xr(this.h[3], p, b), this.h[3] = $4e7e1af11ea066d2$var$xr(this.h[4], i, m), this.h[4] = $4e7e1af11ea066d2$var$xr(this.h[0], n, w), this.h[0] = N;
}, $4e7e1af11ea066d2$var$pe.prototype._digest = function(t) {
    return t === "hex" ? $4e7e1af11ea066d2$var$Xe.toHex32(this.h, "little") : $4e7e1af11ea066d2$var$Xe.split32(this.h, "little");
};
function $4e7e1af11ea066d2$var$Bf(e, t, r, i) {
    return e <= 15 ? t ^ r ^ i : e <= 31 ? t & r | ~t & i : e <= 47 ? (t | ~r) ^ i : e <= 63 ? t & i | r & ~i : t ^ (r | ~i);
}
function $4e7e1af11ea066d2$var$Na(e) {
    return e <= 15 ? 0 : e <= 31 ? 1518500249 : e <= 47 ? 1859775393 : e <= 63 ? 2400959708 : 2840853838;
}
function $4e7e1af11ea066d2$var$Ia(e) {
    return e <= 15 ? 1352829926 : e <= 31 ? 1548603684 : e <= 47 ? 1836072691 : e <= 63 ? 2053994217 : 0;
}
var $4e7e1af11ea066d2$var$_a = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
], $4e7e1af11ea066d2$var$Ba = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
], $4e7e1af11ea066d2$var$Ca = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
], $4e7e1af11ea066d2$var$Ra = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
], $4e7e1af11ea066d2$var$Oa = $4e7e1af11ea066d2$var$Q, $4e7e1af11ea066d2$var$Pa = $4e7e1af11ea066d2$var$yr;
function $4e7e1af11ea066d2$var$hr(e, t, r) {
    if (!(this instanceof $4e7e1af11ea066d2$var$hr)) return new $4e7e1af11ea066d2$var$hr(e, t, r);
    this.Hash = e, this.blockSize = e.blockSize / 8, this.outSize = e.outSize / 8, this.inner = null, this.outer = null, this._init($4e7e1af11ea066d2$var$Oa.toArray(t, r));
}
var $4e7e1af11ea066d2$var$Da = $4e7e1af11ea066d2$var$hr;
$4e7e1af11ea066d2$var$hr.prototype._init = function(t) {
    t.length > this.blockSize && (t = new this.Hash().update(t).digest()), $4e7e1af11ea066d2$var$Pa(t.length <= this.blockSize);
    for(var r = t.length; r < this.blockSize; r++)t.push(0);
    for(r = 0; r < t.length; r++)t[r] ^= 54;
    for(this.inner = new this.Hash().update(t), r = 0; r < t.length; r++)t[r] ^= 106;
    this.outer = new this.Hash().update(t);
}, $4e7e1af11ea066d2$var$hr.prototype.update = function(t, r) {
    return this.inner.update(t, r), this;
}, $4e7e1af11ea066d2$var$hr.prototype.digest = function(t) {
    return this.outer.update(this.inner.digest()), this.outer.digest(t);
}, function(e) {
    var t = e;
    t.utils = $4e7e1af11ea066d2$var$Q, t.common = $4e7e1af11ea066d2$var$fr, t.sha = $4e7e1af11ea066d2$var$or, t.ripemd = $4e7e1af11ea066d2$var$Sf, t.hmac = $4e7e1af11ea066d2$var$Da, t.sha1 = t.sha.sha1, t.sha256 = t.sha.sha256, t.sha224 = t.sha.sha224, t.sha384 = t.sha.sha384, t.sha512 = t.sha.sha512, t.ripemd160 = t.ripemd.ripemd160;
}($4e7e1af11ea066d2$var$se);
function $4e7e1af11ea066d2$var$cr(e, t, r) {
    return r = {
        path: t,
        exports: {},
        require: function require1(i, n) {
            return $4e7e1af11ea066d2$var$Fa(i, n !== null && n !== void 0 ? n : r.path);
        }
    }, e(r, r.exports), r.exports;
}
function $4e7e1af11ea066d2$var$Fa() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var $4e7e1af11ea066d2$var$Pi = $4e7e1af11ea066d2$var$Cf;
function $4e7e1af11ea066d2$var$Cf(e, t) {
    if (!e) throw new Error(t || "Assertion failed");
}
$4e7e1af11ea066d2$var$Cf.equal = function(t, r, i) {
    if (t != r) throw new Error(i || "Assertion failed: " + t + " != " + r);
};
var $4e7e1af11ea066d2$var$fe = $4e7e1af11ea066d2$var$cr(function(e, t) {
    var r = t;
    function i(h, p) {
        if (Array.isArray(h)) return h.slice();
        if (!h) return [];
        var b = [];
        if (typeof h != "string") {
            for(var m = 0; m < h.length; m++)b[m] = h[m] | 0;
            return b;
        }
        if (p === "hex") {
            h = h.replace(/[^a-z0-9]+/ig, ""), h.length % 2 !== 0 && (h = "0" + h);
            for(var m = 0; m < h.length; m += 2)b.push(parseInt(h[m] + h[m + 1], 16));
        } else for(var m = 0; m < h.length; m++){
            var w = h.charCodeAt(m), y = w >> 8, S = w & 255;
            y ? b.push(y, S) : b.push(S);
        }
        return b;
    }
    r.toArray = i;
    function n(h) {
        return h.length === 1 ? "0" + h : h;
    }
    r.zero2 = n;
    function o(h) {
        for(var p = "", b = 0; b < h.length; b++)p += n(h[b].toString(16));
        return p;
    }
    r.toHex = o, r.encode = function(p, b) {
        return b === "hex" ? o(p) : p;
    };
}), $4e7e1af11ea066d2$var$Jt = $4e7e1af11ea066d2$var$cr(function(e, t) {
    var r = t;
    r.assert = $4e7e1af11ea066d2$var$Pi, r.toArray = $4e7e1af11ea066d2$var$fe.toArray, r.zero2 = $4e7e1af11ea066d2$var$fe.zero2, r.toHex = $4e7e1af11ea066d2$var$fe.toHex, r.encode = $4e7e1af11ea066d2$var$fe.encode;
    function i(b, m, w) {
        var y = new Array(Math.max(b.bitLength(), w) + 1);
        y.fill(0);
        for(var S = 1 << m + 1, I = b.clone(), N = 0; N < y.length; N++){
            var C, F = I.andln(S - 1);
            I.isOdd() ? (F > (S >> 1) - 1 ? C = (S >> 1) - F : C = F, I.isubn(C)) : C = 0, y[N] = C, I.iushrn(1);
        }
        return y;
    }
    r.getNAF = i;
    function n(b, m) {
        var w = [
            [],
            []
        ];
        b = b.clone(), m = m.clone();
        for(var y = 0, S = 0, I; b.cmpn(-y) > 0 || m.cmpn(-S) > 0;){
            var N = b.andln(3) + y & 3, C = m.andln(3) + S & 3;
            N === 3 && (N = -1), C === 3 && (C = -1);
            var F;
            N & 1 ? (I = b.andln(7) + y & 7, (I === 3 || I === 5) && C === 2 ? F = -N : F = N) : F = 0, w[0].push(F);
            var U;
            C & 1 ? (I = m.andln(7) + S & 7, (I === 3 || I === 5) && N === 2 ? U = -C : U = C) : U = 0, w[1].push(U), 2 * y === F + 1 && (y = 1 - y), 2 * S === U + 1 && (S = 1 - S), b.iushrn(1), m.iushrn(1);
        }
        return w;
    }
    r.getJSF = n;
    function o(b, m, w) {
        var y = "_" + m;
        b.prototype[m] = function() {
            return this[y] !== void 0 ? this[y] : this[y] = w.call(this);
        };
    }
    r.cachedProperty = o;
    function h(b) {
        return typeof b == "string" ? r.toArray(b, "hex") : b;
    }
    r.parseBytes = h;
    function p(b) {
        return new $4e7e1af11ea066d2$var$K(b, "hex", "le");
    }
    r.intFromLE = p;
}), $4e7e1af11ea066d2$var$Ur = $4e7e1af11ea066d2$var$Jt.getNAF, $4e7e1af11ea066d2$var$Ta = $4e7e1af11ea066d2$var$Jt.getJSF, $4e7e1af11ea066d2$var$kr = $4e7e1af11ea066d2$var$Jt.assert;
function $4e7e1af11ea066d2$var$Ce(e, t) {
    this.type = e, this.p = new $4e7e1af11ea066d2$var$K(t.p, 16), this.red = t.prime ? $4e7e1af11ea066d2$var$K.red(t.prime) : $4e7e1af11ea066d2$var$K.mont(this.p), this.zero = new $4e7e1af11ea066d2$var$K(0).toRed(this.red), this.one = new $4e7e1af11ea066d2$var$K(1).toRed(this.red), this.two = new $4e7e1af11ea066d2$var$K(2).toRed(this.red), this.n = t.n && new $4e7e1af11ea066d2$var$K(t.n, 16), this.g = t.g && this.pointFromJSON(t.g, t.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
    var r = this.n && this.p.div(this.n);
    !r || r.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
}
var $4e7e1af11ea066d2$var$Ze = $4e7e1af11ea066d2$var$Ce;
$4e7e1af11ea066d2$var$Ce.prototype.point = function() {
    throw new Error("Not implemented");
}, $4e7e1af11ea066d2$var$Ce.prototype.validate = function() {
    throw new Error("Not implemented");
}, $4e7e1af11ea066d2$var$Ce.prototype._fixedNafMul = function(t, r) {
    $4e7e1af11ea066d2$var$kr(t.precomputed);
    var i = t._getDoubles(), n = $4e7e1af11ea066d2$var$Ur(r, 1, this._bitLength), o = (1 << i.step + 1) - (i.step % 2 === 0 ? 2 : 1);
    o /= 3;
    var h = [], p, b;
    for(p = 0; p < n.length; p += i.step){
        b = 0;
        for(var m = p + i.step - 1; m >= p; m--)b = (b << 1) + n[m];
        h.push(b);
    }
    for(var w = this.jpoint(null, null, null), y = this.jpoint(null, null, null), S = o; S > 0; S--){
        for(p = 0; p < h.length; p++)b = h[p], b === S ? y = y.mixedAdd(i.points[p]) : b === -S && (y = y.mixedAdd(i.points[p].neg()));
        w = w.add(y);
    }
    return w.toP();
}, $4e7e1af11ea066d2$var$Ce.prototype._wnafMul = function(t, r) {
    var i = 4, n = t._getNAFPoints(i);
    i = n.wnd;
    for(var o = n.points, h = $4e7e1af11ea066d2$var$Ur(r, i, this._bitLength), p = this.jpoint(null, null, null), b = h.length - 1; b >= 0; b--){
        for(var m = 0; b >= 0 && h[b] === 0; b--)m++;
        if (b >= 0 && m++, p = p.dblp(m), b < 0) break;
        var w = h[b];
        $4e7e1af11ea066d2$var$kr(w !== 0), t.type === "affine" ? w > 0 ? p = p.mixedAdd(o[w - 1 >> 1]) : p = p.mixedAdd(o[-w - 1 >> 1].neg()) : w > 0 ? p = p.add(o[w - 1 >> 1]) : p = p.add(o[-w - 1 >> 1].neg());
    }
    return t.type === "affine" ? p.toP() : p;
}, $4e7e1af11ea066d2$var$Ce.prototype._wnafMulAdd = function(t, r, i, n, o) {
    var h = this._wnafT1, p = this._wnafT2, b = this._wnafT3, m = 0, w, y, S;
    for(w = 0; w < n; w++){
        S = r[w];
        var I = S._getNAFPoints(t);
        h[w] = I.wnd, p[w] = I.points;
    }
    for(w = n - 1; w >= 1; w -= 2){
        var N = w - 1, C = w;
        if (h[N] !== 1 || h[C] !== 1) {
            b[N] = $4e7e1af11ea066d2$var$Ur(i[N], h[N], this._bitLength), b[C] = $4e7e1af11ea066d2$var$Ur(i[C], h[C], this._bitLength), m = Math.max(b[N].length, m), m = Math.max(b[C].length, m);
            continue;
        }
        var F = [
            r[N],
            null,
            null,
            r[C]
        ];
        r[N].y.cmp(r[C].y) === 0 ? (F[1] = r[N].add(r[C]), F[2] = r[N].toJ().mixedAdd(r[C].neg())) : r[N].y.cmp(r[C].y.redNeg()) === 0 ? (F[1] = r[N].toJ().mixedAdd(r[C]), F[2] = r[N].add(r[C].neg())) : (F[1] = r[N].toJ().mixedAdd(r[C]), F[2] = r[N].toJ().mixedAdd(r[C].neg()));
        var U = [
            -3,
            -1,
            -5,
            -7,
            0,
            7,
            5,
            1,
            3
        ], J = $4e7e1af11ea066d2$var$Ta(i[N], i[C]);
        for(m = Math.max(J[0].length, m), b[N] = new Array(m), b[C] = new Array(m), y = 0; y < m; y++){
            var Bt = J[0][y] | 0, G = J[1][y] | 0;
            b[N][y] = U[(Bt + 1) * 3 + (G + 1)], b[C][y] = 0, p[N] = F;
        }
    }
    var H = this.jpoint(null, null, null), z = this._wnafT4;
    for(w = m; w >= 0; w--){
        for(var Pt = 0; w >= 0;){
            var W = !0;
            for(y = 0; y < n; y++)z[y] = b[y][w] | 0, z[y] !== 0 && (W = !1);
            if (!W) break;
            Pt++, w--;
        }
        if (w >= 0 && Pt++, H = H.dblp(Pt), w < 0) break;
        for(y = 0; y < n; y++){
            var Rt = z[y];
            Rt !== 0 && (Rt > 0 ? S = p[y][Rt - 1 >> 1] : Rt < 0 && (S = p[y][-Rt - 1 >> 1].neg()), S.type === "affine" ? H = H.mixedAdd(S) : H = H.add(S));
        }
    }
    for(w = 0; w < n; w++)p[w] = null;
    return o ? H : H.toP();
};
function $4e7e1af11ea066d2$var$Xt(e, t) {
    this.curve = e, this.type = t, this.precomputed = null;
}
$4e7e1af11ea066d2$var$Ce.BasePoint = $4e7e1af11ea066d2$var$Xt, $4e7e1af11ea066d2$var$Xt.prototype.eq = function() {
    throw new Error("Not implemented");
}, $4e7e1af11ea066d2$var$Xt.prototype.validate = function() {
    return this.curve.validate(this);
}, $4e7e1af11ea066d2$var$Ce.prototype.decodePoint = function(t, r) {
    t = $4e7e1af11ea066d2$var$Jt.toArray(t, r);
    var i = this.p.byteLength();
    if ((t[0] === 4 || t[0] === 6 || t[0] === 7) && t.length - 1 === 2 * i) {
        t[0] === 6 ? $4e7e1af11ea066d2$var$kr(t[t.length - 1] % 2 === 0) : t[0] === 7 && $4e7e1af11ea066d2$var$kr(t[t.length - 1] % 2 === 1);
        var n = this.point(t.slice(1, 1 + i), t.slice(1 + i, 1 + 2 * i));
        return n;
    } else if ((t[0] === 2 || t[0] === 3) && t.length - 1 === i) return this.pointFromX(t.slice(1, 1 + i), t[0] === 3);
    throw new Error("Unknown point format");
}, $4e7e1af11ea066d2$var$Xt.prototype.encodeCompressed = function(t) {
    return this.encode(t, !0);
}, $4e7e1af11ea066d2$var$Xt.prototype._encode = function(t) {
    var r = this.curve.p.byteLength(), i = this.getX().toArray("be", r);
    return t ? [
        this.getY().isEven() ? 2 : 3
    ].concat(i) : [
        4
    ].concat(i, this.getY().toArray("be", r));
}, $4e7e1af11ea066d2$var$Xt.prototype.encode = function(t, r) {
    return $4e7e1af11ea066d2$var$Jt.encode(this._encode(r), t);
}, $4e7e1af11ea066d2$var$Xt.prototype.precompute = function(t) {
    if (this.precomputed) return this;
    var r = {
        doubles: null,
        naf: null,
        beta: null
    };
    return r.naf = this._getNAFPoints(8), r.doubles = this._getDoubles(4, t), r.beta = this._getBeta(), this.precomputed = r, this;
}, $4e7e1af11ea066d2$var$Xt.prototype._hasDoubles = function(t) {
    if (!this.precomputed) return !1;
    var r = this.precomputed.doubles;
    return r ? r.points.length >= Math.ceil((t.bitLength() + 1) / r.step) : !1;
}, $4e7e1af11ea066d2$var$Xt.prototype._getDoubles = function(t, r) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    for(var i = [
        this
    ], n = this, o = 0; o < r; o += t){
        for(var h = 0; h < t; h++)n = n.dbl();
        i.push(n);
    }
    return {
        step: t,
        points: i
    };
}, $4e7e1af11ea066d2$var$Xt.prototype._getNAFPoints = function(t) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    for(var r = [
        this
    ], i = (1 << t) - 1, n = i === 1 ? null : this.dbl(), o = 1; o < i; o++)r[o] = r[o - 1].add(n);
    return {
        wnd: t,
        points: r
    };
}, $4e7e1af11ea066d2$var$Xt.prototype._getBeta = function() {
    return null;
}, $4e7e1af11ea066d2$var$Xt.prototype.dblp = function(t) {
    for(var r = this, i = 0; i < t; i++)r = r.dbl();
    return r;
};
var $4e7e1af11ea066d2$var$Di = $4e7e1af11ea066d2$var$cr(function(e) {
    typeof Object.create == "function" ? e.exports = function(r, i) {
        i && (r.super_ = i, r.prototype = Object.create(i.prototype, {
            constructor: {
                value: r,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }));
    } : e.exports = function(r, i) {
        if (i) {
            r.super_ = i;
            var n = function n() {};
            n.prototype = i.prototype, r.prototype = new n, r.prototype.constructor = r;
        }
    };
}), $4e7e1af11ea066d2$var$Ua = $4e7e1af11ea066d2$var$Jt.assert;
function $4e7e1af11ea066d2$var$Zt(e) {
    $4e7e1af11ea066d2$var$Ze.call(this, "short", e), this.a = new $4e7e1af11ea066d2$var$K(e.a, 16).toRed(this.red), this.b = new $4e7e1af11ea066d2$var$K(e.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(e), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
}
$4e7e1af11ea066d2$var$Di($4e7e1af11ea066d2$var$Zt, $4e7e1af11ea066d2$var$Ze);
var $4e7e1af11ea066d2$var$ka = $4e7e1af11ea066d2$var$Zt;
$4e7e1af11ea066d2$var$Zt.prototype._getEndomorphism = function(t) {
    if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
        var r, i;
        if (t.beta) r = new $4e7e1af11ea066d2$var$K(t.beta, 16).toRed(this.red);
        else {
            var n = this._getEndoRoots(this.p);
            r = n[0].cmp(n[1]) < 0 ? n[0] : n[1], r = r.toRed(this.red);
        }
        if (t.lambda) i = new $4e7e1af11ea066d2$var$K(t.lambda, 16);
        else {
            var o = this._getEndoRoots(this.n);
            this.g.mul(o[0]).x.cmp(this.g.x.redMul(r)) === 0 ? i = o[0] : (i = o[1], $4e7e1af11ea066d2$var$Ua(this.g.mul(i).x.cmp(this.g.x.redMul(r)) === 0));
        }
        var h;
        return t.basis ? h = t.basis.map(function(p) {
            return {
                a: new $4e7e1af11ea066d2$var$K(p.a, 16),
                b: new $4e7e1af11ea066d2$var$K(p.b, 16)
            };
        }) : h = this._getEndoBasis(i), {
            beta: r,
            lambda: i,
            basis: h
        };
    }
}, $4e7e1af11ea066d2$var$Zt.prototype._getEndoRoots = function(t) {
    var r = t === this.p ? this.red : $4e7e1af11ea066d2$var$K.mont(t), i = new $4e7e1af11ea066d2$var$K(2).toRed(r).redInvm(), n = i.redNeg(), o = new $4e7e1af11ea066d2$var$K(3).toRed(r).redNeg().redSqrt().redMul(i), h = n.redAdd(o).fromRed(), p = n.redSub(o).fromRed();
    return [
        h,
        p
    ];
}, $4e7e1af11ea066d2$var$Zt.prototype._getEndoBasis = function(t) {
    for(var r = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), i = t, n = this.n.clone(), o = new $4e7e1af11ea066d2$var$K(1), h = new $4e7e1af11ea066d2$var$K(0), p = new $4e7e1af11ea066d2$var$K(0), b = new $4e7e1af11ea066d2$var$K(1), m, w, y, S, I, N, C, F = 0, U, J; i.cmpn(0) !== 0;){
        var Bt = n.div(i);
        U = n.sub(Bt.mul(i)), J = p.sub(Bt.mul(o));
        var G = b.sub(Bt.mul(h));
        if (!y && U.cmp(r) < 0) m = C.neg(), w = o, y = U.neg(), S = J;
        else if (y && ++F === 2) break;
        C = U, n = i, i = U, p = o, o = J, b = h, h = G;
    }
    I = U.neg(), N = J;
    var H = y.sqr().add(S.sqr()), z = I.sqr().add(N.sqr());
    return z.cmp(H) >= 0 && (I = m, N = w), y.negative && (y = y.neg(), S = S.neg()), I.negative && (I = I.neg(), N = N.neg()), [
        {
            a: y,
            b: S
        },
        {
            a: I,
            b: N
        }
    ];
}, $4e7e1af11ea066d2$var$Zt.prototype._endoSplit = function(t) {
    var r = this.endo.basis, i = r[0], n = r[1], o = n.b.mul(t).divRound(this.n), h = i.b.neg().mul(t).divRound(this.n), p = o.mul(i.a), b = h.mul(n.a), m = o.mul(i.b), w = h.mul(n.b), y = t.sub(p).sub(b), S = m.add(w).neg();
    return {
        k1: y,
        k2: S
    };
}, $4e7e1af11ea066d2$var$Zt.prototype.pointFromX = function(t, r) {
    t = new $4e7e1af11ea066d2$var$K(t, 16), t.red || (t = t.toRed(this.red));
    var i = t.redSqr().redMul(t).redIAdd(t.redMul(this.a)).redIAdd(this.b), n = i.redSqrt();
    if (n.redSqr().redSub(i).cmp(this.zero) !== 0) throw new Error("invalid point");
    var o = n.fromRed().isOdd();
    return (r && !o || !r && o) && (n = n.redNeg()), this.point(t, n);
}, $4e7e1af11ea066d2$var$Zt.prototype.validate = function(t) {
    if (t.inf) return !0;
    var r = t.x, i = t.y, n = this.a.redMul(r), o = r.redSqr().redMul(r).redIAdd(n).redIAdd(this.b);
    return i.redSqr().redISub(o).cmpn(0) === 0;
}, $4e7e1af11ea066d2$var$Zt.prototype._endoWnafMulAdd = function(t, r, i) {
    for(var n = this._endoWnafT1, o = this._endoWnafT2, h = 0; h < t.length; h++){
        var p = this._endoSplit(r[h]), b = t[h], m = b._getBeta();
        p.k1.negative && (p.k1.ineg(), b = b.neg(!0)), p.k2.negative && (p.k2.ineg(), m = m.neg(!0)), n[h * 2] = b, n[h * 2 + 1] = m, o[h * 2] = p.k1, o[h * 2 + 1] = p.k2;
    }
    for(var w = this._wnafMulAdd(1, n, o, h * 2, i), y = 0; y < h * 2; y++)n[y] = null, o[y] = null;
    return w;
};
function $4e7e1af11ea066d2$var$Ft(e, t, r, i) {
    $4e7e1af11ea066d2$var$Ze.BasePoint.call(this, e, "affine"), t === null && r === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new $4e7e1af11ea066d2$var$K(t, 16), this.y = new $4e7e1af11ea066d2$var$K(r, 16), i && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
}
$4e7e1af11ea066d2$var$Di($4e7e1af11ea066d2$var$Ft, $4e7e1af11ea066d2$var$Ze.BasePoint), $4e7e1af11ea066d2$var$Zt.prototype.point = function(t, r, i) {
    return new $4e7e1af11ea066d2$var$Ft(this, t, r, i);
}, $4e7e1af11ea066d2$var$Zt.prototype.pointFromJSON = function(t, r) {
    return $4e7e1af11ea066d2$var$Ft.fromJSON(this, t, r);
}, $4e7e1af11ea066d2$var$Ft.prototype._getBeta = function() {
    if (this.curve.endo) {
        var t = this.precomputed;
        if (t && t.beta) return t.beta;
        var r = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
        if (t) {
            var i = this.curve, n = function n(o) {
                return i.point(o.x.redMul(i.endo.beta), o.y);
            };
            t.beta = r, r.precomputed = {
                beta: null,
                naf: t.naf && {
                    wnd: t.naf.wnd,
                    points: t.naf.points.map(n)
                },
                doubles: t.doubles && {
                    step: t.doubles.step,
                    points: t.doubles.points.map(n)
                }
            };
        }
        return r;
    }
}, $4e7e1af11ea066d2$var$Ft.prototype.toJSON = function() {
    return this.precomputed ? [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ] : [
        this.x,
        this.y
    ];
}, $4e7e1af11ea066d2$var$Ft.fromJSON = function(t, r, i) {
    typeof r == "string" && (r = JSON.parse(r));
    var n = t.point(r[0], r[1], i);
    if (!r[2]) return n;
    function o(p) {
        return t.point(p[0], p[1], i);
    }
    var h = r[2];
    return n.precomputed = {
        beta: null,
        doubles: h.doubles && {
            step: h.doubles.step,
            points: [
                n
            ].concat(h.doubles.points.map(o))
        },
        naf: h.naf && {
            wnd: h.naf.wnd,
            points: [
                n
            ].concat(h.naf.points.map(o))
        }
    }, n;
}, $4e7e1af11ea066d2$var$Ft.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
}, $4e7e1af11ea066d2$var$Ft.prototype.isInfinity = function() {
    return this.inf;
}, $4e7e1af11ea066d2$var$Ft.prototype.add = function(t) {
    if (this.inf) return t;
    if (t.inf) return this;
    if (this.eq(t)) return this.dbl();
    if (this.neg().eq(t)) return this.curve.point(null, null);
    if (this.x.cmp(t.x) === 0) return this.curve.point(null, null);
    var r = this.y.redSub(t.y);
    r.cmpn(0) !== 0 && (r = r.redMul(this.x.redSub(t.x).redInvm()));
    var i = r.redSqr().redISub(this.x).redISub(t.x), n = r.redMul(this.x.redSub(i)).redISub(this.y);
    return this.curve.point(i, n);
}, $4e7e1af11ea066d2$var$Ft.prototype.dbl = function() {
    if (this.inf) return this;
    var t = this.y.redAdd(this.y);
    if (t.cmpn(0) === 0) return this.curve.point(null, null);
    var r = this.curve.a, i = this.x.redSqr(), n = t.redInvm(), o = i.redAdd(i).redIAdd(i).redIAdd(r).redMul(n), h = o.redSqr().redISub(this.x.redAdd(this.x)), p = o.redMul(this.x.redSub(h)).redISub(this.y);
    return this.curve.point(h, p);
}, $4e7e1af11ea066d2$var$Ft.prototype.getX = function() {
    return this.x.fromRed();
}, $4e7e1af11ea066d2$var$Ft.prototype.getY = function() {
    return this.y.fromRed();
}, $4e7e1af11ea066d2$var$Ft.prototype.mul = function(t) {
    return t = new $4e7e1af11ea066d2$var$K(t, 16), this.isInfinity() ? this : this._hasDoubles(t) ? this.curve._fixedNafMul(this, t) : this.curve.endo ? this.curve._endoWnafMulAdd([
        this
    ], [
        t
    ]) : this.curve._wnafMul(this, t);
}, $4e7e1af11ea066d2$var$Ft.prototype.mulAdd = function(t, r, i) {
    var n = [
        this,
        r
    ], o = [
        t,
        i
    ];
    return this.curve.endo ? this.curve._endoWnafMulAdd(n, o) : this.curve._wnafMulAdd(1, n, o, 2);
}, $4e7e1af11ea066d2$var$Ft.prototype.jmulAdd = function(t, r, i) {
    var n = [
        this,
        r
    ], o = [
        t,
        i
    ];
    return this.curve.endo ? this.curve._endoWnafMulAdd(n, o, !0) : this.curve._wnafMulAdd(1, n, o, 2, !0);
}, $4e7e1af11ea066d2$var$Ft.prototype.eq = function(t) {
    return this === t || this.inf === t.inf && (this.inf || this.x.cmp(t.x) === 0 && this.y.cmp(t.y) === 0);
}, $4e7e1af11ea066d2$var$Ft.prototype.neg = function(t) {
    if (this.inf) return this;
    var r = this.curve.point(this.x, this.y.redNeg());
    if (t && this.precomputed) {
        var i = this.precomputed, n = function n(o) {
            return o.neg();
        };
        r.precomputed = {
            naf: i.naf && {
                wnd: i.naf.wnd,
                points: i.naf.points.map(n)
            },
            doubles: i.doubles && {
                step: i.doubles.step,
                points: i.doubles.points.map(n)
            }
        };
    }
    return r;
}, $4e7e1af11ea066d2$var$Ft.prototype.toJ = function() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var t = this.curve.jpoint(this.x, this.y, this.curve.one);
    return t;
};
function $4e7e1af11ea066d2$var$Tt(e, t, r, i) {
    $4e7e1af11ea066d2$var$Ze.BasePoint.call(this, e, "jacobian"), t === null && r === null && i === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new $4e7e1af11ea066d2$var$K(0)) : (this.x = new $4e7e1af11ea066d2$var$K(t, 16), this.y = new $4e7e1af11ea066d2$var$K(r, 16), this.z = new $4e7e1af11ea066d2$var$K(i, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
}
$4e7e1af11ea066d2$var$Di($4e7e1af11ea066d2$var$Tt, $4e7e1af11ea066d2$var$Ze.BasePoint), $4e7e1af11ea066d2$var$Zt.prototype.jpoint = function(t, r, i) {
    return new $4e7e1af11ea066d2$var$Tt(this, t, r, i);
}, $4e7e1af11ea066d2$var$Tt.prototype.toP = function() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var t = this.z.redInvm(), r = t.redSqr(), i = this.x.redMul(r), n = this.y.redMul(r).redMul(t);
    return this.curve.point(i, n);
}, $4e7e1af11ea066d2$var$Tt.prototype.neg = function() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
}, $4e7e1af11ea066d2$var$Tt.prototype.add = function(t) {
    if (this.isInfinity()) return t;
    if (t.isInfinity()) return this;
    var r = t.z.redSqr(), i = this.z.redSqr(), n = this.x.redMul(r), o = t.x.redMul(i), h = this.y.redMul(r.redMul(t.z)), p = t.y.redMul(i.redMul(this.z)), b = n.redSub(o), m = h.redSub(p);
    if (b.cmpn(0) === 0) return m.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var w = b.redSqr(), y = w.redMul(b), S = n.redMul(w), I = m.redSqr().redIAdd(y).redISub(S).redISub(S), N = m.redMul(S.redISub(I)).redISub(h.redMul(y)), C = this.z.redMul(t.z).redMul(b);
    return this.curve.jpoint(I, N, C);
}, $4e7e1af11ea066d2$var$Tt.prototype.mixedAdd = function(t) {
    if (this.isInfinity()) return t.toJ();
    if (t.isInfinity()) return this;
    var r = this.z.redSqr(), i = this.x, n = t.x.redMul(r), o = this.y, h = t.y.redMul(r).redMul(this.z), p = i.redSub(n), b = o.redSub(h);
    if (p.cmpn(0) === 0) return b.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var m = p.redSqr(), w = m.redMul(p), y = i.redMul(m), S = b.redSqr().redIAdd(w).redISub(y).redISub(y), I = b.redMul(y.redISub(S)).redISub(o.redMul(w)), N = this.z.redMul(p);
    return this.curve.jpoint(S, I, N);
}, $4e7e1af11ea066d2$var$Tt.prototype.dblp = function(t) {
    if (t === 0) return this;
    if (this.isInfinity()) return this;
    if (!t) return this.dbl();
    var r;
    if (this.curve.zeroA || this.curve.threeA) {
        var i = this;
        for(r = 0; r < t; r++)i = i.dbl();
        return i;
    }
    var n = this.curve.a, o = this.curve.tinv, h = this.x, p = this.y, b = this.z, m = b.redSqr().redSqr(), w = p.redAdd(p);
    for(r = 0; r < t; r++){
        var y = h.redSqr(), S = w.redSqr(), I = S.redSqr(), N = y.redAdd(y).redIAdd(y).redIAdd(n.redMul(m)), C = h.redMul(S), F = N.redSqr().redISub(C.redAdd(C)), U = C.redISub(F), J = N.redMul(U);
        J = J.redIAdd(J).redISub(I);
        var Bt = w.redMul(b);
        r + 1 < t && (m = m.redMul(I)), h = F, b = Bt, w = J;
    }
    return this.curve.jpoint(h, w.redMul(o), b);
}, $4e7e1af11ea066d2$var$Tt.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
}, $4e7e1af11ea066d2$var$Tt.prototype._zeroDbl = function() {
    var t, r, i;
    if (this.zOne) {
        var n = this.x.redSqr(), o = this.y.redSqr(), h = o.redSqr(), p = this.x.redAdd(o).redSqr().redISub(n).redISub(h);
        p = p.redIAdd(p);
        var b = n.redAdd(n).redIAdd(n), m = b.redSqr().redISub(p).redISub(p), w = h.redIAdd(h);
        w = w.redIAdd(w), w = w.redIAdd(w), t = m, r = b.redMul(p.redISub(m)).redISub(w), i = this.y.redAdd(this.y);
    } else {
        var y = this.x.redSqr(), S = this.y.redSqr(), I = S.redSqr(), N = this.x.redAdd(S).redSqr().redISub(y).redISub(I);
        N = N.redIAdd(N);
        var C = y.redAdd(y).redIAdd(y), F = C.redSqr(), U = I.redIAdd(I);
        U = U.redIAdd(U), U = U.redIAdd(U), t = F.redISub(N).redISub(N), r = C.redMul(N.redISub(t)).redISub(U), i = this.y.redMul(this.z), i = i.redIAdd(i);
    }
    return this.curve.jpoint(t, r, i);
}, $4e7e1af11ea066d2$var$Tt.prototype._threeDbl = function() {
    var t, r, i;
    if (this.zOne) {
        var n = this.x.redSqr(), o = this.y.redSqr(), h = o.redSqr(), p = this.x.redAdd(o).redSqr().redISub(n).redISub(h);
        p = p.redIAdd(p);
        var b = n.redAdd(n).redIAdd(n).redIAdd(this.curve.a), m = b.redSqr().redISub(p).redISub(p);
        t = m;
        var w = h.redIAdd(h);
        w = w.redIAdd(w), w = w.redIAdd(w), r = b.redMul(p.redISub(m)).redISub(w), i = this.y.redAdd(this.y);
    } else {
        var y = this.z.redSqr(), S = this.y.redSqr(), I = this.x.redMul(S), N = this.x.redSub(y).redMul(this.x.redAdd(y));
        N = N.redAdd(N).redIAdd(N);
        var C = I.redIAdd(I);
        C = C.redIAdd(C);
        var F = C.redAdd(C);
        t = N.redSqr().redISub(F), i = this.y.redAdd(this.z).redSqr().redISub(S).redISub(y);
        var U = S.redSqr();
        U = U.redIAdd(U), U = U.redIAdd(U), U = U.redIAdd(U), r = N.redMul(C.redISub(t)).redISub(U);
    }
    return this.curve.jpoint(t, r, i);
}, $4e7e1af11ea066d2$var$Tt.prototype._dbl = function() {
    var t = this.curve.a, r = this.x, i = this.y, n = this.z, o = n.redSqr().redSqr(), h = r.redSqr(), p = i.redSqr(), b = h.redAdd(h).redIAdd(h).redIAdd(t.redMul(o)), m = r.redAdd(r);
    m = m.redIAdd(m);
    var w = m.redMul(p), y = b.redSqr().redISub(w.redAdd(w)), S = w.redISub(y), I = p.redSqr();
    I = I.redIAdd(I), I = I.redIAdd(I), I = I.redIAdd(I);
    var N = b.redMul(S).redISub(I), C = i.redAdd(i).redMul(n);
    return this.curve.jpoint(y, N, C);
}, $4e7e1af11ea066d2$var$Tt.prototype.trpl = function() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    var t = this.x.redSqr(), r = this.y.redSqr(), i = this.z.redSqr(), n = r.redSqr(), o = t.redAdd(t).redIAdd(t), h = o.redSqr(), p = this.x.redAdd(r).redSqr().redISub(t).redISub(n);
    p = p.redIAdd(p), p = p.redAdd(p).redIAdd(p), p = p.redISub(h);
    var b = p.redSqr(), m = n.redIAdd(n);
    m = m.redIAdd(m), m = m.redIAdd(m), m = m.redIAdd(m);
    var w = o.redIAdd(p).redSqr().redISub(h).redISub(b).redISub(m), y = r.redMul(w);
    y = y.redIAdd(y), y = y.redIAdd(y);
    var S = this.x.redMul(b).redISub(y);
    S = S.redIAdd(S), S = S.redIAdd(S);
    var I = this.y.redMul(w.redMul(m.redISub(w)).redISub(p.redMul(b)));
    I = I.redIAdd(I), I = I.redIAdd(I), I = I.redIAdd(I);
    var N = this.z.redAdd(p).redSqr().redISub(i).redISub(b);
    return this.curve.jpoint(S, I, N);
}, $4e7e1af11ea066d2$var$Tt.prototype.mul = function(t, r) {
    return t = new $4e7e1af11ea066d2$var$K(t, r), this.curve._wnafMul(this, t);
}, $4e7e1af11ea066d2$var$Tt.prototype.eq = function(t) {
    if (t.type === "affine") return this.eq(t.toJ());
    if (this === t) return !0;
    var r = this.z.redSqr(), i = t.z.redSqr();
    if (this.x.redMul(i).redISub(t.x.redMul(r)).cmpn(0) !== 0) return !1;
    var n = r.redMul(this.z), o = i.redMul(t.z);
    return this.y.redMul(o).redISub(t.y.redMul(n)).cmpn(0) === 0;
}, $4e7e1af11ea066d2$var$Tt.prototype.eqXToP = function(t) {
    var r = this.z.redSqr(), i = t.toRed(this.curve.red).redMul(r);
    if (this.x.cmp(i) === 0) return !0;
    for(var n = t.clone(), o = this.curve.redN.redMul(r);;){
        if (n.iadd(this.curve.n), n.cmp(this.curve.p) >= 0) return !1;
        if (i.redIAdd(o), this.x.cmp(i) === 0) return !0;
    }
}, $4e7e1af11ea066d2$var$Tt.prototype.inspect = function() {
    return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
}, $4e7e1af11ea066d2$var$Tt.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
};
var $4e7e1af11ea066d2$var$qr = $4e7e1af11ea066d2$var$cr(function(e, t) {
    var r = t;
    r.base = $4e7e1af11ea066d2$var$Ze, r.short = $4e7e1af11ea066d2$var$ka, r.mont = null, r.edwards = null;
}), $4e7e1af11ea066d2$var$Kr = $4e7e1af11ea066d2$var$cr(function(e, t) {
    var r = t, i = $4e7e1af11ea066d2$var$Jt.assert;
    function n(p) {
        p.type === "short" ? this.curve = new $4e7e1af11ea066d2$var$qr.short(p) : p.type === "edwards" ? this.curve = new $4e7e1af11ea066d2$var$qr.edwards(p) : this.curve = new $4e7e1af11ea066d2$var$qr.mont(p), this.g = this.curve.g, this.n = this.curve.n, this.hash = p.hash, i(this.g.validate(), "Invalid curve"), i(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    r.PresetCurve = n;
    function o(p, b) {
        Object.defineProperty(r, p, {
            configurable: !0,
            enumerable: !0,
            get: function get() {
                var m = new n(b);
                return Object.defineProperty(r, p, {
                    configurable: !0,
                    enumerable: !0,
                    value: m
                }), m;
            }
        });
    }
    o("p192", {
        type: "short",
        prime: "p192",
        p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
        b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
        n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
        hash: $4e7e1af11ea066d2$var$se.sha256,
        gRed: !1,
        g: [
            "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
            "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
        ]
    }), o("p224", {
        type: "short",
        prime: "p224",
        p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
        b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
        n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
        hash: $4e7e1af11ea066d2$var$se.sha256,
        gRed: !1,
        g: [
            "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
            "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
        ]
    }), o("p256", {
        type: "short",
        prime: null,
        p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
        a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
        b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
        n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
        hash: $4e7e1af11ea066d2$var$se.sha256,
        gRed: !1,
        g: [
            "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
            "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
        ]
    }), o("p384", {
        type: "short",
        prime: null,
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
        a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
        b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
        n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
        hash: $4e7e1af11ea066d2$var$se.sha384,
        gRed: !1,
        g: [
            "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
            "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
        ]
    }), o("p521", {
        type: "short",
        prime: null,
        p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
        a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
        b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
        n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
        hash: $4e7e1af11ea066d2$var$se.sha512,
        gRed: !1,
        g: [
            "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
            "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
        ]
    }), o("curve25519", {
        type: "mont",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "76d06",
        b: "1",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: $4e7e1af11ea066d2$var$se.sha256,
        gRed: !1,
        g: [
            "9"
        ]
    }), o("ed25519", {
        type: "edwards",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "-1",
        c: "1",
        d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: $4e7e1af11ea066d2$var$se.sha256,
        gRed: !1,
        g: [
            "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
            "6666666666666666666666666666666666666666666666666666666666666658"
        ]
    });
    var h;
    try {
        h = null.crash();
    } catch (e) {
        h = void 0;
    }
    o("secp256k1", {
        type: "short",
        prime: "k256",
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
        a: "0",
        b: "7",
        n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
        h: "1",
        hash: $4e7e1af11ea066d2$var$se.sha256,
        beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
        lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
        basis: [
            {
                a: "3086d221a7d46bcde86c90e49284eb15",
                b: "-e4437ed6010e88286f547fa90abfe4c3"
            },
            {
                a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                b: "3086d221a7d46bcde86c90e49284eb15"
            }
        ],
        gRed: !1,
        g: [
            "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
            "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
            h
        ]
    });
});
function $4e7e1af11ea066d2$var$Re(e) {
    if (!(this instanceof $4e7e1af11ea066d2$var$Re)) return new $4e7e1af11ea066d2$var$Re(e);
    this.hash = e.hash, this.predResist = !!e.predResist, this.outLen = this.hash.outSize, this.minEntropy = e.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
    var t = $4e7e1af11ea066d2$var$fe.toArray(e.entropy, e.entropyEnc || "hex"), r = $4e7e1af11ea066d2$var$fe.toArray(e.nonce, e.nonceEnc || "hex"), i = $4e7e1af11ea066d2$var$fe.toArray(e.pers, e.persEnc || "hex");
    $4e7e1af11ea066d2$var$Pi(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._init(t, r, i);
}
var $4e7e1af11ea066d2$var$Rf = $4e7e1af11ea066d2$var$Re;
$4e7e1af11ea066d2$var$Re.prototype._init = function(t, r, i) {
    var n = t.concat(r).concat(i);
    this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
    for(var o = 0; o < this.V.length; o++)this.K[o] = 0, this.V[o] = 1;
    this._update(n), this._reseed = 1, this.reseedInterval = 281474976710656;
}, $4e7e1af11ea066d2$var$Re.prototype._hmac = function() {
    return new $4e7e1af11ea066d2$var$se.hmac(this.hash, this.K);
}, $4e7e1af11ea066d2$var$Re.prototype._update = function(t) {
    var r = this._hmac().update(this.V).update([
        0
    ]);
    t && (r = r.update(t)), this.K = r.digest(), this.V = this._hmac().update(this.V).digest(), t && (this.K = this._hmac().update(this.V).update([
        1
    ]).update(t).digest(), this.V = this._hmac().update(this.V).digest());
}, $4e7e1af11ea066d2$var$Re.prototype.reseed = function(t, r, i, n) {
    typeof r != "string" && (n = i, i = r, r = null), t = $4e7e1af11ea066d2$var$fe.toArray(t, r), i = $4e7e1af11ea066d2$var$fe.toArray(i, n), $4e7e1af11ea066d2$var$Pi(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._update(t.concat(i || [])), this._reseed = 1;
}, $4e7e1af11ea066d2$var$Re.prototype.generate = function(t, r, i, n) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    typeof r != "string" && (n = i, i = r, r = null), i && (i = $4e7e1af11ea066d2$var$fe.toArray(i, n || "hex"), this._update(i));
    for(var o = []; o.length < t;)this.V = this._hmac().update(this.V).digest(), o = o.concat(this.V);
    var h = o.slice(0, t);
    return this._update(i), this._reseed++, $4e7e1af11ea066d2$var$fe.encode(h, r);
};
var $4e7e1af11ea066d2$var$Fi = $4e7e1af11ea066d2$var$Jt.assert;
function $4e7e1af11ea066d2$var$kt(e, t) {
    this.ec = e, this.priv = null, this.pub = null, t.priv && this._importPrivate(t.priv, t.privEnc), t.pub && this._importPublic(t.pub, t.pubEnc);
}
var $4e7e1af11ea066d2$var$Ti = $4e7e1af11ea066d2$var$kt;
$4e7e1af11ea066d2$var$kt.fromPublic = function(t, r, i) {
    return r instanceof $4e7e1af11ea066d2$var$kt ? r : new $4e7e1af11ea066d2$var$kt(t, {
        pub: r,
        pubEnc: i
    });
}, $4e7e1af11ea066d2$var$kt.fromPrivate = function(t, r, i) {
    return r instanceof $4e7e1af11ea066d2$var$kt ? r : new $4e7e1af11ea066d2$var$kt(t, {
        priv: r,
        privEnc: i
    });
}, $4e7e1af11ea066d2$var$kt.prototype.validate = function() {
    var t = this.getPublic();
    return t.isInfinity() ? {
        result: !1,
        reason: "Invalid public key"
    } : t.validate() ? t.mul(this.ec.curve.n).isInfinity() ? {
        result: !0,
        reason: null
    } : {
        result: !1,
        reason: "Public key * N != O"
    } : {
        result: !1,
        reason: "Public key is not a point"
    };
}, $4e7e1af11ea066d2$var$kt.prototype.getPublic = function(t, r) {
    return typeof t == "string" && (r = t, t = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), r ? this.pub.encode(r, t) : this.pub;
}, $4e7e1af11ea066d2$var$kt.prototype.getPrivate = function(t) {
    return t === "hex" ? this.priv.toString(16, 2) : this.priv;
}, $4e7e1af11ea066d2$var$kt.prototype._importPrivate = function(t, r) {
    this.priv = new $4e7e1af11ea066d2$var$K(t, r || 16), this.priv = this.priv.umod(this.ec.curve.n);
}, $4e7e1af11ea066d2$var$kt.prototype._importPublic = function(t, r) {
    if (t.x || t.y) {
        this.ec.curve.type === "mont" ? $4e7e1af11ea066d2$var$Fi(t.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && $4e7e1af11ea066d2$var$Fi(t.x && t.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(t.x, t.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(t, r);
}, $4e7e1af11ea066d2$var$kt.prototype.derive = function(t) {
    return t.validate() || $4e7e1af11ea066d2$var$Fi(t.validate(), "public point not validated"), t.mul(this.priv).getX();
}, $4e7e1af11ea066d2$var$kt.prototype.sign = function(t, r, i) {
    return this.ec.sign(t, this, r, i);
}, $4e7e1af11ea066d2$var$kt.prototype.verify = function(t, r) {
    return this.ec.verify(t, r, this);
}, $4e7e1af11ea066d2$var$kt.prototype.inspect = function() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
var $4e7e1af11ea066d2$var$qa = $4e7e1af11ea066d2$var$Jt.assert;
function $4e7e1af11ea066d2$var$Hr(e, t) {
    if (e instanceof $4e7e1af11ea066d2$var$Hr) return e;
    this._importDER(e, t) || ($4e7e1af11ea066d2$var$qa(e.r && e.s, "Signature without r or s"), this.r = new $4e7e1af11ea066d2$var$K(e.r, 16), this.s = new $4e7e1af11ea066d2$var$K(e.s, 16), e.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = e.recoveryParam);
}
var $4e7e1af11ea066d2$var$zr = $4e7e1af11ea066d2$var$Hr;
function $4e7e1af11ea066d2$var$Ka() {
    this.place = 0;
}
function $4e7e1af11ea066d2$var$Ui(e, t) {
    var r = e[t.place++];
    if (!(r & 128)) return r;
    var i = r & 15;
    if (i === 0 || i > 4) return !1;
    for(var n = 0, o = 0, h = t.place; o < i; o++, h++)n <<= 8, n |= e[h], n >>>= 0;
    return n <= 127 ? !1 : (t.place = h, n);
}
function $4e7e1af11ea066d2$var$Of(e) {
    for(var t = 0, r = e.length - 1; !e[t] && !(e[t + 1] & 128) && t < r;)t++;
    return t === 0 ? e : e.slice(t);
}
$4e7e1af11ea066d2$var$Hr.prototype._importDER = function(t, r) {
    t = $4e7e1af11ea066d2$var$Jt.toArray(t, r);
    var i = new $4e7e1af11ea066d2$var$Ka;
    if (t[i.place++] !== 48) return !1;
    var n = $4e7e1af11ea066d2$var$Ui(t, i);
    if (n === !1 || n + i.place !== t.length || t[i.place++] !== 2) return !1;
    var o = $4e7e1af11ea066d2$var$Ui(t, i);
    if (o === !1) return !1;
    var h = t.slice(i.place, o + i.place);
    if (i.place += o, t[i.place++] !== 2) return !1;
    var p = $4e7e1af11ea066d2$var$Ui(t, i);
    if (p === !1 || t.length !== p + i.place) return !1;
    var b = t.slice(i.place, p + i.place);
    if (h[0] === 0) {
        if (h[1] & 128) h = h.slice(1);
        else return !1;
    }
    if (b[0] === 0) {
        if (b[1] & 128) b = b.slice(1);
        else return !1;
    }
    return this.r = new $4e7e1af11ea066d2$var$K(h), this.s = new $4e7e1af11ea066d2$var$K(b), this.recoveryParam = null, !0;
};
function $4e7e1af11ea066d2$var$ki(e, t) {
    if (t < 128) {
        e.push(t);
        return;
    }
    var r = 1 + (Math.log(t) / Math.LN2 >>> 3);
    for(e.push(r | 128); --r;)e.push(t >>> (r << 3) & 255);
    e.push(t);
}
$4e7e1af11ea066d2$var$Hr.prototype.toDER = function(t) {
    var r = this.r.toArray(), i = this.s.toArray();
    for(r[0] & 128 && (r = [
        0
    ].concat(r)), i[0] & 128 && (i = [
        0
    ].concat(i)), r = $4e7e1af11ea066d2$var$Of(r), i = $4e7e1af11ea066d2$var$Of(i); !i[0] && !(i[1] & 128);)i = i.slice(1);
    var n = [
        2
    ];
    $4e7e1af11ea066d2$var$ki(n, r.length), n = n.concat(r), n.push(2), $4e7e1af11ea066d2$var$ki(n, i.length);
    var o = n.concat(i), h = [
        48
    ];
    return $4e7e1af11ea066d2$var$ki(h, o.length), h = h.concat(o), $4e7e1af11ea066d2$var$Jt.encode(h, t);
};
var $4e7e1af11ea066d2$var$Ha = function Ha() {
    throw new Error("unsupported");
}, $4e7e1af11ea066d2$var$Pf = $4e7e1af11ea066d2$var$Jt.assert;
function $4e7e1af11ea066d2$var$$t(e) {
    if (!(this instanceof $4e7e1af11ea066d2$var$$t)) return new $4e7e1af11ea066d2$var$$t(e);
    typeof e == "string" && ($4e7e1af11ea066d2$var$Pf(Object.prototype.hasOwnProperty.call($4e7e1af11ea066d2$var$Kr, e), "Unknown curve " + e), e = $4e7e1af11ea066d2$var$Kr[e]), e instanceof $4e7e1af11ea066d2$var$Kr.PresetCurve && (e = {
        curve: e
    }), this.curve = e.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = e.curve.g, this.g.precompute(e.curve.n.bitLength() + 1), this.hash = e.hash || e.curve.hash;
}
var $4e7e1af11ea066d2$var$za = $4e7e1af11ea066d2$var$$t;
$4e7e1af11ea066d2$var$$t.prototype.keyPair = function(t) {
    return new $4e7e1af11ea066d2$var$Ti(this, t);
}, $4e7e1af11ea066d2$var$$t.prototype.keyFromPrivate = function(t, r) {
    return $4e7e1af11ea066d2$var$Ti.fromPrivate(this, t, r);
}, $4e7e1af11ea066d2$var$$t.prototype.keyFromPublic = function(t, r) {
    return $4e7e1af11ea066d2$var$Ti.fromPublic(this, t, r);
}, $4e7e1af11ea066d2$var$$t.prototype.genKeyPair = function(t) {
    t || (t = {});
    for(var r = new $4e7e1af11ea066d2$var$Rf({
        hash: this.hash,
        pers: t.pers,
        persEnc: t.persEnc || "utf8",
        entropy: t.entropy || $4e7e1af11ea066d2$var$Ha(this.hash.hmacStrength),
        entropyEnc: t.entropy && t.entropyEnc || "utf8",
        nonce: this.n.toArray()
    }), i = this.n.byteLength(), n = this.n.sub(new $4e7e1af11ea066d2$var$K(2));;){
        var o = new $4e7e1af11ea066d2$var$K(r.generate(i));
        if (!(o.cmp(n) > 0)) return o.iaddn(1), this.keyFromPrivate(o);
    }
}, $4e7e1af11ea066d2$var$$t.prototype._truncateToN = function(t, r) {
    var i = t.byteLength() * 8 - this.n.bitLength();
    return i > 0 && (t = t.ushrn(i)), !r && t.cmp(this.n) >= 0 ? t.sub(this.n) : t;
}, $4e7e1af11ea066d2$var$$t.prototype.sign = function(t, r, i, n) {
    typeof i == "object" && (n = i, i = null), n || (n = {}), r = this.keyFromPrivate(r, i), t = this._truncateToN(new $4e7e1af11ea066d2$var$K(t, 16));
    for(var o = this.n.byteLength(), h = r.getPrivate().toArray("be", o), p = t.toArray("be", o), b = new $4e7e1af11ea066d2$var$Rf({
        hash: this.hash,
        entropy: h,
        nonce: p,
        pers: n.pers,
        persEnc: n.persEnc || "utf8"
    }), m = this.n.sub(new $4e7e1af11ea066d2$var$K(1)), w = 0;; w++){
        var y = n.k ? n.k(w) : new $4e7e1af11ea066d2$var$K(b.generate(this.n.byteLength()));
        if (y = this._truncateToN(y, !0), !(y.cmpn(1) <= 0 || y.cmp(m) >= 0)) {
            var S = this.g.mul(y);
            if (!S.isInfinity()) {
                var I = S.getX(), N = I.umod(this.n);
                if (N.cmpn(0) !== 0) {
                    var C = y.invm(this.n).mul(N.mul(r.getPrivate()).iadd(t));
                    if (C = C.umod(this.n), C.cmpn(0) !== 0) {
                        var F = (S.getY().isOdd() ? 1 : 0) | (I.cmp(N) !== 0 ? 2 : 0);
                        return n.canonical && C.cmp(this.nh) > 0 && (C = this.n.sub(C), F ^= 1), new $4e7e1af11ea066d2$var$zr({
                            r: N,
                            s: C,
                            recoveryParam: F
                        });
                    }
                }
            }
        }
    }
}, $4e7e1af11ea066d2$var$$t.prototype.verify = function(t, r, i, n) {
    t = this._truncateToN(new $4e7e1af11ea066d2$var$K(t, 16)), i = this.keyFromPublic(i, n), r = new $4e7e1af11ea066d2$var$zr(r, "hex");
    var o = r.r, h = r.s;
    if (o.cmpn(1) < 0 || o.cmp(this.n) >= 0 || h.cmpn(1) < 0 || h.cmp(this.n) >= 0) return !1;
    var p = h.invm(this.n), b = p.mul(t).umod(this.n), m = p.mul(o).umod(this.n), w;
    return this.curve._maxwellTrick ? (w = this.g.jmulAdd(b, i.getPublic(), m), w.isInfinity() ? !1 : w.eqXToP(o)) : (w = this.g.mulAdd(b, i.getPublic(), m), w.isInfinity() ? !1 : w.getX().umod(this.n).cmp(o) === 0);
}, $4e7e1af11ea066d2$var$$t.prototype.recoverPubKey = function(e, t, r, i) {
    $4e7e1af11ea066d2$var$Pf((3 & r) === r, "The recovery param is more than two bits"), t = new $4e7e1af11ea066d2$var$zr(t, i);
    var n = this.n, o = new $4e7e1af11ea066d2$var$K(e), h = t.r, p = t.s, b = r & 1, m = r >> 1;
    if (h.cmp(this.curve.p.umod(this.curve.n)) >= 0 && m) throw new Error("Unable to find sencond key candinate");
    m ? h = this.curve.pointFromX(h.add(this.curve.n), b) : h = this.curve.pointFromX(h, b);
    var w = t.r.invm(n), y = n.sub(o).mul(w).umod(n), S = p.mul(w).umod(n);
    return this.g.mulAdd(y, h, S);
}, $4e7e1af11ea066d2$var$$t.prototype.getKeyRecoveryParam = function(e, t, r, i) {
    if (t = new $4e7e1af11ea066d2$var$zr(t, i), t.recoveryParam !== null) return t.recoveryParam;
    for(var n = 0; n < 4; n++){
        var o;
        try {
            o = this.recoverPubKey(e, t, n);
        } catch (e) {
            continue;
        }
        if (o.eq(r)) return n;
    }
    throw new Error("Unable to find valid recovery factor");
};
var $4e7e1af11ea066d2$var$La = $4e7e1af11ea066d2$var$cr(function(e, t) {
    var r = t;
    r.version = "6.5.4", r.utils = $4e7e1af11ea066d2$var$Jt, r.rand = function() {
        throw new Error("unsupported");
    }, r.curve = $4e7e1af11ea066d2$var$qr, r.curves = $4e7e1af11ea066d2$var$Kr, r.ec = $4e7e1af11ea066d2$var$za, r.eddsa = null;
}), $4e7e1af11ea066d2$var$ja = $4e7e1af11ea066d2$var$La.ec;
var $4e7e1af11ea066d2$var$Qa = "signing-key/5.7.0", $4e7e1af11ea066d2$var$qi = new $4e7e1af11ea066d2$var$L($4e7e1af11ea066d2$var$Qa);
var $4e7e1af11ea066d2$var$Ki = null;
function $4e7e1af11ea066d2$var$ve() {
    return $4e7e1af11ea066d2$var$Ki || ($4e7e1af11ea066d2$var$Ki = new $4e7e1af11ea066d2$var$ja("secp256k1")), $4e7e1af11ea066d2$var$Ki;
}
var $4e7e1af11ea066d2$var$Ja = /*#__PURE__*/ function() {
    "use strict";
    function Ja(t) {
        (0, $4GJKx._)(this, Ja);
        $4e7e1af11ea066d2$var$br(this, "curve", "secp256k1"), $4e7e1af11ea066d2$var$br(this, "privateKey", $4e7e1af11ea066d2$var$Kt(t)), $4e7e1af11ea066d2$var$N0(this.privateKey) !== 32 && $4e7e1af11ea066d2$var$qi.throwArgumentError("invalid private key", "privateKey", "[[ REDACTED ]]");
        var r = $4e7e1af11ea066d2$var$ve().keyFromPrivate($4e7e1af11ea066d2$var$Ot(this.privateKey));
        $4e7e1af11ea066d2$var$br(this, "publicKey", "0x" + r.getPublic(!1, "hex")), $4e7e1af11ea066d2$var$br(this, "compressedPublicKey", "0x" + r.getPublic(!0, "hex")), $4e7e1af11ea066d2$var$br(this, "_isSigningKey", !0);
    }
    (0, $1wc17._)(Ja, [
        {
            key: "_addPoint",
            value: function _addPoint(t) {
                var r = $4e7e1af11ea066d2$var$ve().keyFromPublic($4e7e1af11ea066d2$var$Ot(this.publicKey)), i = $4e7e1af11ea066d2$var$ve().keyFromPublic($4e7e1af11ea066d2$var$Ot(t));
                return "0x" + r.pub.add(i.pub).encodeCompressed("hex");
            }
        },
        {
            key: "signDigest",
            value: function signDigest(t) {
                var r = $4e7e1af11ea066d2$var$ve().keyFromPrivate($4e7e1af11ea066d2$var$Ot(this.privateKey)), i = $4e7e1af11ea066d2$var$Ot(t);
                i.length !== 32 && $4e7e1af11ea066d2$var$qi.throwArgumentError("bad digest length", "digest", t);
                var n = r.sign(i, {
                    canonical: !0
                });
                return $4e7e1af11ea066d2$var$zn({
                    recoveryParam: n.recoveryParam,
                    r: $4e7e1af11ea066d2$var$oe("0x" + n.r.toString(16), 32),
                    s: $4e7e1af11ea066d2$var$oe("0x" + n.s.toString(16), 32)
                });
            }
        },
        {
            key: "computeSharedSecret",
            value: function computeSharedSecret(t) {
                var r = $4e7e1af11ea066d2$var$ve().keyFromPrivate($4e7e1af11ea066d2$var$Ot(this.privateKey)), i = $4e7e1af11ea066d2$var$ve().keyFromPublic($4e7e1af11ea066d2$var$Ot($4e7e1af11ea066d2$var$Df(t)));
                return $4e7e1af11ea066d2$var$oe("0x" + r.derive(i.getPublic()).toString(16), 32);
            }
        }
    ], [
        {
            key: "isSigningKey",
            value: function isSigningKey(t) {
                return !!(t && t._isSigningKey);
            }
        }
    ]);
    return Ja;
}();
function $4e7e1af11ea066d2$var$Ga(e, t) {
    var r = $4e7e1af11ea066d2$var$zn(t), i = {
        r: $4e7e1af11ea066d2$var$Ot(r.r),
        s: $4e7e1af11ea066d2$var$Ot(r.s)
    };
    return "0x" + $4e7e1af11ea066d2$var$ve().recoverPubKey($4e7e1af11ea066d2$var$Ot(e), i, r.recoveryParam).encode("hex", !1);
}
function $4e7e1af11ea066d2$var$Df(e, t) {
    var r = $4e7e1af11ea066d2$var$Ot(e);
    if (r.length === 32) {
        var i = new $4e7e1af11ea066d2$var$Ja(r);
        return t ? "0x" + $4e7e1af11ea066d2$var$ve().keyFromPrivate(r).getPublic(!0, "hex") : i.publicKey;
    } else {
        if (r.length === 33) return t ? $4e7e1af11ea066d2$var$Kt(r) : "0x" + $4e7e1af11ea066d2$var$ve().keyFromPublic(r).getPublic(!1, "hex");
        if (r.length === 65) return t ? "0x" + $4e7e1af11ea066d2$var$ve().keyFromPublic(r).getPublic(!0, "hex") : $4e7e1af11ea066d2$var$Kt(r);
    }
    return $4e7e1af11ea066d2$var$qi.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}
var $4e7e1af11ea066d2$var$Ya = "transactions/5.7.0";
new $4e7e1af11ea066d2$var$L($4e7e1af11ea066d2$var$Ya);
var $4e7e1af11ea066d2$var$Ff;
(function(e) {
    e[e.legacy = 0] = "legacy", e[e.eip2930 = 1] = "eip2930", e[e.eip1559 = 2] = "eip1559";
})($4e7e1af11ea066d2$var$Ff || ($4e7e1af11ea066d2$var$Ff = {}));
function $4e7e1af11ea066d2$var$Va(e) {
    var t = $4e7e1af11ea066d2$var$Df(e);
    return $4e7e1af11ea066d2$var$ns($4e7e1af11ea066d2$var$Hn($4e7e1af11ea066d2$var$yi($4e7e1af11ea066d2$var$Hn(t, 1)), 12));
}
function $4e7e1af11ea066d2$var$Wa(e, t) {
    return $4e7e1af11ea066d2$var$Va($4e7e1af11ea066d2$var$Ga($4e7e1af11ea066d2$var$Ot(e), t));
}
var $4e7e1af11ea066d2$var$Xa = "https://rpc.walletconnect.com/v1";
function $4e7e1af11ea066d2$export$ab54e47fdf2903bb(e, t, r, i, n, o) {
    return $4e7e1af11ea066d2$var$_Tf.apply(this, arguments);
}
function $4e7e1af11ea066d2$var$_Tf() {
    $4e7e1af11ea066d2$var$_Tf = (0, $kSuI9._)(function(e, t, r, i, n, o) {
        var _;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = r.t;
                    switch(_){
                        case "eip191":
                            return [
                                3,
                                1
                            ];
                        case "eip1271":
                            return [
                                3,
                                2
                            ];
                    }
                    return [
                        3,
                        4
                    ];
                case 1:
                    return [
                        2,
                        $4e7e1af11ea066d2$export$b5da105d64914e5a(e, t, r.s)
                    ];
                case 2:
                    return [
                        4,
                        $4e7e1af11ea066d2$export$9bffe3330373b76b(e, t, r.s, i, n, o)
                    ];
                case 3:
                    return [
                        2,
                        _state.sent()
                    ];
                case 4:
                    throw new Error("verifySignature failed: Attempted to verify CacaoSignature with unknown type: ".concat(r.t));
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return $4e7e1af11ea066d2$var$_Tf.apply(this, arguments);
}
function $4e7e1af11ea066d2$export$b5da105d64914e5a(e, t, r) {
    return $4e7e1af11ea066d2$var$Wa($4e7e1af11ea066d2$var$ff(t), r).toLowerCase() === e.toLowerCase();
}
function $4e7e1af11ea066d2$export$9bffe3330373b76b(e, t, r, i, n, o) {
    return $4e7e1af11ea066d2$var$_kf.apply(this, arguments);
}
function $4e7e1af11ea066d2$var$_kf() {
    $4e7e1af11ea066d2$var$_kf = (0, $kSuI9._)(function(e, t, r, i, n, o) {
        var _$h, p, b, m, w, y, S, _ref, I, h;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    _$h = "0x1626ba7e", p = "0000000000000000000000000000000000000000000000000000000000000040", b = "0000000000000000000000000000000000000000000000000000000000000041", m = r.substring(2), w = $4e7e1af11ea066d2$var$ff(t).substring(2), y = _$h + w + p + b + m;
                    return [
                        4,
                        fetch("".concat(o || $4e7e1af11ea066d2$var$Xa, "/?chainId=").concat(i, "&projectId=").concat(n), {
                            method: "POST",
                            body: JSON.stringify({
                                id: $4e7e1af11ea066d2$var$Za(),
                                jsonrpc: "2.0",
                                method: "eth_call",
                                params: [
                                    {
                                        to: e,
                                        data: y
                                    },
                                    "latest"
                                ]
                            })
                        })
                    ];
                case 1:
                    S = _state.sent();
                    return [
                        4,
                        S.json()
                    ];
                case 2:
                    _ref = _state.sent(), I = _ref.result;
                    return [
                        2,
                        I ? I.slice(0, _$h.length).toLowerCase() === _$h.toLowerCase() : !1
                    ];
                case 3:
                    h = _state.sent();
                    return [
                        2,
                        (console.error("isValidEip1271Signature: ", h), !1)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $4e7e1af11ea066d2$var$_kf.apply(this, arguments);
}
function $4e7e1af11ea066d2$var$Za() {
    return Date.now() + Math.floor(Math.random() * 1e3);
}
var $4e7e1af11ea066d2$var$$a = Object.defineProperty, $4e7e1af11ea066d2$var$tu = Object.defineProperties, $4e7e1af11ea066d2$var$eu = Object.getOwnPropertyDescriptors, $4e7e1af11ea066d2$var$qf = Object.getOwnPropertySymbols, $4e7e1af11ea066d2$var$ru = Object.prototype.hasOwnProperty, $4e7e1af11ea066d2$var$iu = Object.prototype.propertyIsEnumerable, $4e7e1af11ea066d2$var$Kf = function(e, t, r) {
    return t in e ? $4e7e1af11ea066d2$var$$a(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r;
}, $4e7e1af11ea066d2$var$Hi = function(e, t) {
    for(var r in t || (t = {}))$4e7e1af11ea066d2$var$ru.call(t, r) && $4e7e1af11ea066d2$var$Kf(e, r, t[r]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($4e7e1af11ea066d2$var$qf) try {
        for(var _iterator = $4e7e1af11ea066d2$var$qf(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var r = _step.value;
            $4e7e1af11ea066d2$var$iu.call(t, r) && $4e7e1af11ea066d2$var$Kf(e, r, t[r]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return e;
}, $4e7e1af11ea066d2$var$Hf = function(e, t) {
    return $4e7e1af11ea066d2$var$tu(e, $4e7e1af11ea066d2$var$eu(t));
};
var $4e7e1af11ea066d2$var$nu = "did:pkh:", $4e7e1af11ea066d2$export$a524ae552db7912 = function(e) {
    return e === null || e === void 0 ? void 0 : e.split(":");
}, $4e7e1af11ea066d2$export$85f23c05c80b194 = function(e) {
    var t = e && $4e7e1af11ea066d2$export$a524ae552db7912(e);
    if (t) return e.includes($4e7e1af11ea066d2$var$nu) ? t[3] : t[1];
}, $4e7e1af11ea066d2$export$a8b149927aef7051 = function(e) {
    var t = e && $4e7e1af11ea066d2$export$a524ae552db7912(e);
    if (t) return t[2] + ":" + t[3];
}, $4e7e1af11ea066d2$export$bf43cfbb4bd95de9 = function(e) {
    var t = e && $4e7e1af11ea066d2$export$a524ae552db7912(e);
    if (t) return t.pop();
};
function $4e7e1af11ea066d2$export$b7d566fce8e2b970(e) {
    return $4e7e1af11ea066d2$var$_ou.apply(this, arguments);
}
function $4e7e1af11ea066d2$var$_ou() {
    $4e7e1af11ea066d2$var$_ou = (0, $kSuI9._)(function(e) {
        var t, r, i, n, o, h;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    t = e.cacao, r = e.projectId, i = t.s, n = t.p, o = $4e7e1af11ea066d2$export$25868d1e8e76735f(n, n.iss), h = $4e7e1af11ea066d2$export$bf43cfbb4bd95de9(n.iss);
                    return [
                        4,
                        $4e7e1af11ea066d2$export$ab54e47fdf2903bb(h, o, i, $4e7e1af11ea066d2$export$85f23c05c80b194(n.iss), r)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return $4e7e1af11ea066d2$var$_ou.apply(this, arguments);
}
var $4e7e1af11ea066d2$export$25868d1e8e76735f = function(e, t) {
    var r = "".concat(e.domain, " wants you to sign in with your Ethereum account:"), i = $4e7e1af11ea066d2$export$bf43cfbb4bd95de9(t);
    if (!e.aud && !e.uri) throw new Error("Either `aud` or `uri` is required to construct the message");
    var n = e.statement || void 0;
    var o = "URI: ".concat(e.aud || e.uri), h = "Version: ".concat(e.version), p = "Chain ID: ".concat($4e7e1af11ea066d2$export$85f23c05c80b194(t)), b = "Nonce: ".concat(e.nonce), m = "Issued At: ".concat(e.iat), w = e.exp ? "Expiration Time: ".concat(e.exp) : void 0, y = e.nbf ? "Not Before: ".concat(e.nbf) : void 0, S = e.requestId ? "Request ID: ".concat(e.requestId) : void 0, I = e.resources ? "Resources:".concat(e.resources.map(function(C) {
        return "\n- ".concat(C);
    }).join("")) : void 0, N = $4e7e1af11ea066d2$export$3bb18ae0fb9a9fa9(e.resources);
    if (N) {
        var C = $4e7e1af11ea066d2$export$d34522c9e5a1aed1(N);
        n = $4e7e1af11ea066d2$export$51673931d3a8308d(n, C);
    }
    return [
        r,
        i,
        "",
        n,
        "",
        o,
        h,
        p,
        b,
        m,
        w,
        y,
        S,
        I
    ].filter(function(C) {
        return C != null;
    }).join("\n");
};
function $4e7e1af11ea066d2$export$905974078a05d5f9(e, t, r) {
    return r.includes("did:pkh:") || (r = "did:pkh:".concat(r)), {
        h: {
            t: "caip122"
        },
        p: {
            iss: r,
            domain: e.domain,
            aud: e.aud,
            version: e.version,
            nonce: e.nonce,
            iat: e.iat,
            statement: e.statement,
            requestId: e.requestId,
            resources: e.resources,
            nbf: e.nbf,
            exp: e.exp
        },
        s: t
    };
}
function $4e7e1af11ea066d2$export$2bfa2ac7d9bc193c(e) {
    var t;
    var r = e.authPayload, i = e.chains, n = e.methods, o = r.statement || "";
    if (!(i != null && i.length)) return r;
    var h = r.chains, p = $4e7e1af11ea066d2$export$f8aaf09178dd8b96(h, i);
    if (!(p != null && p.length)) throw new Error("No supported chains");
    var b = $4e7e1af11ea066d2$export$8db308c294c84efd(r.resources);
    if (!b) return r;
    $4e7e1af11ea066d2$export$ae8075c482503f32(b);
    var m = $4e7e1af11ea066d2$export$9595a56724061288(b, "eip155");
    var w = (r === null || r === void 0 ? void 0 : r.resources) || [];
    if (m != null && m.length) {
        var y = $4e7e1af11ea066d2$export$e1a9af3d61db3b68(m), S = $4e7e1af11ea066d2$export$f8aaf09178dd8b96(y, n);
        if (!(S != null && S.length)) throw new Error("Supported methods don't satisfy the requested: ".concat(JSON.stringify(y), ", supported: ").concat(JSON.stringify(n)));
        var I = $4e7e1af11ea066d2$export$987cafd76db78dd1("request", S, {
            chains: p
        }), N = $4e7e1af11ea066d2$export$317cb0007b0867c1(b, "eip155", I);
        w = ((t = r === null || r === void 0 ? void 0 : r.resources) == null ? void 0 : t.slice(0, -1)) || [], w.push($4e7e1af11ea066d2$export$79a538532b4f11f7(N));
    }
    return $4e7e1af11ea066d2$var$Hf($4e7e1af11ea066d2$var$Hi({}, r), {
        statement: $4e7e1af11ea066d2$export$fb351782bc6f001e(o, $4e7e1af11ea066d2$export$3bb18ae0fb9a9fa9(w)),
        chains: p,
        resources: r != null && r.resources || w.length > 0 ? w : void 0
    });
}
function $4e7e1af11ea066d2$export$8db308c294c84efd(e) {
    var t = $4e7e1af11ea066d2$export$3bb18ae0fb9a9fa9(e);
    if (t && $4e7e1af11ea066d2$export$d9f11bd9fec5a64(t)) return $4e7e1af11ea066d2$export$d34522c9e5a1aed1(t);
}
function $4e7e1af11ea066d2$export$771534f1eaa353c(e, t) {
    var r;
    return (r = e === null || e === void 0 ? void 0 : e.att) == null ? void 0 : r.hasOwnProperty(t);
}
function $4e7e1af11ea066d2$export$9595a56724061288(e, t) {
    var r, i;
    return (r = e === null || e === void 0 ? void 0 : e.att) != null && r[t] ? Object.keys((i = e === null || e === void 0 ? void 0 : e.att) == null ? void 0 : i[t]) : [];
}
function $4e7e1af11ea066d2$export$d4548b739f9dafe(e) {
    return (e === null || e === void 0 ? void 0 : e.map(function(t) {
        return Object.keys(t);
    })) || [];
}
function $4e7e1af11ea066d2$export$e1a9af3d61db3b68(e) {
    return (e === null || e === void 0 ? void 0 : e.map(function(t) {
        var r;
        return (r = t.split("/")) == null ? void 0 : r[1];
    })) || [];
}
function $4e7e1af11ea066d2$export$e510a73ee562749(e) {
    return $4e7e1af11ea066d2$require$Buffer.from(JSON.stringify(e)).toString("base64");
}
function $4e7e1af11ea066d2$export$c62426fdd000a97e(e) {
    return JSON.parse($4e7e1af11ea066d2$require$Buffer.from(e, "base64").toString("utf-8"));
}
function $4e7e1af11ea066d2$export$ae8075c482503f32(e) {
    if (!e) throw new Error("No recap provided, value is undefined");
    if (!e.att) throw new Error("No `att` property found");
    var t = Object.keys(e.att);
    if (!(t != null && t.length)) throw new Error("No resources found in `att` property");
    t.forEach(function(r) {
        var i = e.att[r];
        if (Array.isArray(i)) throw new Error("Resource must be an object: ".concat(r));
        if (typeof i != "object") throw new Error("Resource must be an object: ".concat(r));
        if (!Object.keys(i).length) throw new Error("Resource object is empty: ".concat(r));
        Object.keys(i).forEach(function(n) {
            var o = i[n];
            if (!Array.isArray(o)) throw new Error("Ability limits ".concat(n, " must be an array of objects, found: ").concat(o));
            if (!o.length) throw new Error("Value of ".concat(n, " is empty array, must be an array with objects"));
            o.forEach(function(h) {
                if (typeof h != "object") throw new Error("Ability limits (".concat(n, ") must be an array of objects, found: ").concat(h));
            });
        });
    });
}
function $4e7e1af11ea066d2$export$eea18a04b33506ed(e, t, r) {
    var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return r === null || r === void 0 ? void 0 : r.sort(function(n, o) {
        return n.localeCompare(o);
    }), {
        att: (0, $3sHb8._)({}, e, $4e7e1af11ea066d2$export$987cafd76db78dd1(t, r, i))
    };
}
function $4e7e1af11ea066d2$export$317cb0007b0867c1(e, t, r) {
    var i;
    return e.att[t] = $4e7e1af11ea066d2$var$Hi({}, r), ((i = Object.keys(e.att)) == null ? void 0 : i.sort(function(n, o) {
        return n.localeCompare(o);
    })).reduce(function(n, o) {
        return n.att[o] = e.att[o], n;
    }, {
        att: {}
    });
}
function $4e7e1af11ea066d2$export$987cafd76db78dd1(e, t) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _Object;
    t = t === null || t === void 0 ? void 0 : t.sort(function(n, o) {
        return n.localeCompare(o);
    });
    var i = t.map(function(n) {
        return (0, $3sHb8._)({}, "".concat(e, "/").concat(n), [
            r
        ]);
    });
    return (_Object = Object).assign.apply(_Object, [
        {}
    ].concat((0, $c6Xmf._)(i)));
}
function $4e7e1af11ea066d2$export$79a538532b4f11f7(e) {
    return $4e7e1af11ea066d2$export$ae8075c482503f32(e), "urn:recap:".concat($4e7e1af11ea066d2$export$e510a73ee562749(e).replace(/=/g, ""));
}
function $4e7e1af11ea066d2$export$d34522c9e5a1aed1(e) {
    var t = $4e7e1af11ea066d2$export$c62426fdd000a97e(e.replace("urn:recap:", ""));
    return $4e7e1af11ea066d2$export$ae8075c482503f32(t), t;
}
function $4e7e1af11ea066d2$export$2bc35d2a08a09ad5(e, t, r) {
    var i = $4e7e1af11ea066d2$export$eea18a04b33506ed(e, t, r);
    return $4e7e1af11ea066d2$export$79a538532b4f11f7(i);
}
function $4e7e1af11ea066d2$export$d9f11bd9fec5a64(e) {
    return e && e.includes("urn:recap:");
}
function $4e7e1af11ea066d2$export$c7a40c552af428b5(e, t) {
    var r = $4e7e1af11ea066d2$export$d34522c9e5a1aed1(e), i = $4e7e1af11ea066d2$export$d34522c9e5a1aed1(t), n = $4e7e1af11ea066d2$export$2445df2492ef2cbd(r, i);
    return $4e7e1af11ea066d2$export$79a538532b4f11f7(n);
}
function $4e7e1af11ea066d2$export$2445df2492ef2cbd(e, t) {
    $4e7e1af11ea066d2$export$ae8075c482503f32(e), $4e7e1af11ea066d2$export$ae8075c482503f32(t);
    var r = Object.keys(e.att).concat(Object.keys(t.att)).sort(function(n, o) {
        return n.localeCompare(o);
    }), i = {
        att: {}
    };
    return r.forEach(function(n) {
        var o, h;
        Object.keys(((o = e.att) == null ? void 0 : o[n]) || {}).concat(Object.keys(((h = t.att) == null ? void 0 : h[n]) || {})).sort(function(p, b) {
            return p.localeCompare(b);
        }).forEach(function(p) {
            var b, m;
            i.att[n] = $4e7e1af11ea066d2$var$Hf($4e7e1af11ea066d2$var$Hi({}, i.att[n]), (0, $3sHb8._)({}, p, ((b = e.att[n]) == null ? void 0 : b[p]) || ((m = t.att[n]) == null ? void 0 : m[p])));
        });
    }), i;
}
function $4e7e1af11ea066d2$export$51673931d3a8308d() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 ? arguments[1] : void 0;
    $4e7e1af11ea066d2$export$ae8075c482503f32(t);
    var r = "I further authorize the stated URI to perform the following actions on my behalf: ";
    if (e.includes(r)) return e;
    var i = [];
    var n = 0;
    Object.keys(t.att).forEach(function(p) {
        var b = Object.keys(t.att[p]).map(function(y) {
            return {
                ability: y.split("/")[0],
                action: y.split("/")[1]
            };
        });
        b.sort(function(y, S) {
            return y.action.localeCompare(S.action);
        });
        var m = {};
        b.forEach(function(y) {
            m[y.ability] || (m[y.ability] = []), m[y.ability].push(y.action);
        });
        var w = Object.keys(m).map(function(y) {
            return n++, "(".concat(n, ") '").concat(y, "': '").concat(m[y].join("', '"), "' for '").concat(p, "'.");
        });
        i.push(w.join(", ").replace(".,", "."));
    });
    var o = i.join(" "), h = "".concat(r).concat(o);
    return "".concat(e ? e + " " : "").concat(h);
}
function $4e7e1af11ea066d2$export$d6c6a43d36418efe(e) {
    var t;
    var r = $4e7e1af11ea066d2$export$d34522c9e5a1aed1(e);
    $4e7e1af11ea066d2$export$ae8075c482503f32(r);
    var i = (t = r.att) == null ? void 0 : t.eip155;
    return i ? Object.keys(i).map(function(n) {
        return n.split("/")[1];
    }) : [];
}
function $4e7e1af11ea066d2$export$372f88051a611988(e) {
    var t = $4e7e1af11ea066d2$export$d34522c9e5a1aed1(e);
    $4e7e1af11ea066d2$export$ae8075c482503f32(t);
    var r = [];
    return Object.values(t.att).forEach(function(i) {
        Object.values(i).forEach(function(n) {
            var o;
            (o = n === null || n === void 0 ? void 0 : n[0]) != null && o.chains && r.push(n[0].chains);
        });
    }), (0, $c6Xmf._)(new Set(r.flat()));
}
function $4e7e1af11ea066d2$export$fb351782bc6f001e(e, t) {
    if (!t) return e;
    var r = $4e7e1af11ea066d2$export$d34522c9e5a1aed1(t);
    return $4e7e1af11ea066d2$export$ae8075c482503f32(r), $4e7e1af11ea066d2$export$51673931d3a8308d(e, r);
}
function $4e7e1af11ea066d2$export$3bb18ae0fb9a9fa9(e) {
    if (!e) return;
    var t = e === null || e === void 0 ? void 0 : e[e.length - 1];
    return $4e7e1af11ea066d2$export$d9f11bd9fec5a64(t) ? t : void 0;
}
var $4e7e1af11ea066d2$export$f7403969428298bd = "base10", $4e7e1af11ea066d2$export$49eb910ab2518105 = "base16", $4e7e1af11ea066d2$export$9bff723d552e6bcf = "base64pad", $4e7e1af11ea066d2$export$9560dad2a83e4f04 = "utf8", $4e7e1af11ea066d2$export$3425bd336a9673d8 = 0, $4e7e1af11ea066d2$export$406e97c329f0f3d4 = 1, $4e7e1af11ea066d2$var$vu = 0, $4e7e1af11ea066d2$var$Zf = 1, $4e7e1af11ea066d2$var$Vi = 12, $4e7e1af11ea066d2$var$Wi = 32;
function $4e7e1af11ea066d2$export$a949d36eab55b41f() {
    var e = $1fnK2.generateKeyPair();
    return {
        privateKey: (0, $ewlTP.toString)(e.secretKey, $4e7e1af11ea066d2$export$49eb910ab2518105),
        publicKey: (0, $ewlTP.toString)(e.publicKey, $4e7e1af11ea066d2$export$49eb910ab2518105)
    };
}
function $4e7e1af11ea066d2$export$d15a28e4f1821243() {
    var e = (0, $5A0yG.randomBytes)($4e7e1af11ea066d2$var$Wi);
    return (0, $ewlTP.toString)(e, $4e7e1af11ea066d2$export$49eb910ab2518105);
}
function $4e7e1af11ea066d2$export$f8378f68e053f5c6(e, t) {
    var r = $1fnK2.sharedKey((0, $l7Yp4.fromString)(e, $4e7e1af11ea066d2$export$49eb910ab2518105), (0, $l7Yp4.fromString)(t, $4e7e1af11ea066d2$export$49eb910ab2518105), !0), i = new (0, $atJCh.HKDF)((0, $27vAG.SHA256), r).expand($4e7e1af11ea066d2$var$Wi);
    return (0, $ewlTP.toString)(i, $4e7e1af11ea066d2$export$49eb910ab2518105);
}
function $4e7e1af11ea066d2$export$1e87d19d4aab5805(e) {
    var t = (0, $27vAG.hash)((0, $l7Yp4.fromString)(e, $4e7e1af11ea066d2$export$49eb910ab2518105));
    return (0, $ewlTP.toString)(t, $4e7e1af11ea066d2$export$49eb910ab2518105);
}
function $4e7e1af11ea066d2$export$d4c241cec96564c1(e) {
    var t = (0, $27vAG.hash)((0, $l7Yp4.fromString)(e, $4e7e1af11ea066d2$export$9560dad2a83e4f04));
    return (0, $ewlTP.toString)(t, $4e7e1af11ea066d2$export$49eb910ab2518105);
}
function $4e7e1af11ea066d2$export$e9d2f9ba70428fb6(e) {
    return (0, $l7Yp4.fromString)("".concat(e), $4e7e1af11ea066d2$export$f7403969428298bd);
}
function $4e7e1af11ea066d2$export$7547a514ee29b9d4(e) {
    return Number((0, $ewlTP.toString)(e, $4e7e1af11ea066d2$export$f7403969428298bd));
}
function $4e7e1af11ea066d2$export$5b0f6292f11d1d18(e) {
    var t = $4e7e1af11ea066d2$export$e9d2f9ba70428fb6((0, $l0HdX._)(e.type) < "u" ? e.type : $4e7e1af11ea066d2$export$3425bd336a9673d8);
    if ($4e7e1af11ea066d2$export$7547a514ee29b9d4(t) === $4e7e1af11ea066d2$export$406e97c329f0f3d4 && (0, $l0HdX._)(e.senderPublicKey) > "u") throw new Error("Missing sender public key for type 1 envelope");
    var r = (0, $l0HdX._)(e.senderPublicKey) < "u" ? (0, $l7Yp4.fromString)(e.senderPublicKey, $4e7e1af11ea066d2$export$49eb910ab2518105) : void 0, i = (0, $l0HdX._)(e.iv) < "u" ? (0, $l7Yp4.fromString)(e.iv, $4e7e1af11ea066d2$export$49eb910ab2518105) : (0, $5A0yG.randomBytes)($4e7e1af11ea066d2$var$Vi), n = new (0, $1MbOp.ChaCha20Poly1305)((0, $l7Yp4.fromString)(e.symKey, $4e7e1af11ea066d2$export$49eb910ab2518105)).seal(i, (0, $l7Yp4.fromString)(e.message, $4e7e1af11ea066d2$export$9560dad2a83e4f04));
    return $4e7e1af11ea066d2$export$dfdc1655ccc5b9cb({
        type: t,
        sealed: n,
        iv: i,
        senderPublicKey: r
    });
}
function $4e7e1af11ea066d2$export$e85a0c9a1067c5d3(e) {
    var t = new (0, $1MbOp.ChaCha20Poly1305)((0, $l7Yp4.fromString)(e.symKey, $4e7e1af11ea066d2$export$49eb910ab2518105)), _Xi = $4e7e1af11ea066d2$export$efcd34ab6248d3cd(e.encoded), r = _Xi.sealed, i = _Xi.iv, n = t.open(i, r);
    if (n === null) throw new Error("Failed to decrypt");
    return (0, $ewlTP.toString)(n, $4e7e1af11ea066d2$export$9560dad2a83e4f04);
}
function $4e7e1af11ea066d2$export$dfdc1655ccc5b9cb(e) {
    if ($4e7e1af11ea066d2$export$7547a514ee29b9d4(e.type) === $4e7e1af11ea066d2$export$406e97c329f0f3d4) {
        if ((0, $l0HdX._)(e.senderPublicKey) > "u") throw new Error("Missing sender public key for type 1 envelope");
        return (0, $ewlTP.toString)((0, $lQfAa.concat)([
            e.type,
            e.senderPublicKey,
            e.iv,
            e.sealed
        ]), $4e7e1af11ea066d2$export$9bff723d552e6bcf);
    }
    return (0, $ewlTP.toString)((0, $lQfAa.concat)([
        e.type,
        e.iv,
        e.sealed
    ]), $4e7e1af11ea066d2$export$9bff723d552e6bcf);
}
function $4e7e1af11ea066d2$export$efcd34ab6248d3cd(e) {
    var t = (0, $l7Yp4.fromString)(e, $4e7e1af11ea066d2$export$9bff723d552e6bcf), r = t.slice($4e7e1af11ea066d2$var$vu, $4e7e1af11ea066d2$var$Zf), i = $4e7e1af11ea066d2$var$Zf;
    if ($4e7e1af11ea066d2$export$7547a514ee29b9d4(r) === $4e7e1af11ea066d2$export$406e97c329f0f3d4) {
        var p = i + $4e7e1af11ea066d2$var$Wi, b = p + $4e7e1af11ea066d2$var$Vi, m = t.slice(i, p), w = t.slice(p, b), y = t.slice(b);
        return {
            type: r,
            sealed: y,
            iv: w,
            senderPublicKey: m
        };
    }
    var n = i + $4e7e1af11ea066d2$var$Vi, o = t.slice(i, n), h = t.slice(n);
    return {
        type: r,
        sealed: h,
        iv: o
    };
}
function $4e7e1af11ea066d2$export$177f3e316562333d(e, t) {
    var r = $4e7e1af11ea066d2$export$efcd34ab6248d3cd(e);
    return $4e7e1af11ea066d2$export$7949f60f2444aef2({
        type: $4e7e1af11ea066d2$export$7547a514ee29b9d4(r.type),
        senderPublicKey: (0, $l0HdX._)(r.senderPublicKey) < "u" ? (0, $ewlTP.toString)(r.senderPublicKey, $4e7e1af11ea066d2$export$49eb910ab2518105) : void 0,
        receiverPublicKey: t === null || t === void 0 ? void 0 : t.receiverPublicKey
    });
}
function $4e7e1af11ea066d2$export$7949f60f2444aef2(e) {
    var t = (e === null || e === void 0 ? void 0 : e.type) || $4e7e1af11ea066d2$export$3425bd336a9673d8;
    if (t === $4e7e1af11ea066d2$export$406e97c329f0f3d4) {
        if ((0, $l0HdX._)(e === null || e === void 0 ? void 0 : e.senderPublicKey) > "u") throw new Error("missing sender public key");
        if ((0, $l0HdX._)(e === null || e === void 0 ? void 0 : e.receiverPublicKey) > "u") throw new Error("missing receiver public key");
    }
    return {
        type: t,
        senderPublicKey: e === null || e === void 0 ? void 0 : e.senderPublicKey,
        receiverPublicKey: e === null || e === void 0 ? void 0 : e.receiverPublicKey
    };
}
function $4e7e1af11ea066d2$export$8c165704db2d5c15(e) {
    return e.type === $4e7e1af11ea066d2$export$406e97c329f0f3d4 && typeof e.senderPublicKey == "string" && typeof e.receiverPublicKey == "string";
}
var $4e7e1af11ea066d2$export$822d0bd1635d5360 = "irn";
function $4e7e1af11ea066d2$export$cf77af25151525db(e) {
    return (e === null || e === void 0 ? void 0 : e.relay) || {
        protocol: $4e7e1af11ea066d2$export$822d0bd1635d5360
    };
}
function $4e7e1af11ea066d2$export$604e3deb95e1b734(e) {
    var t = (0, $4b5f6a83d1361b5a$export$af490b3b9a6de00f)[e];
    if ((typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t)) > "u") throw new Error("Relay Protocol not supported: ".concat(e));
    return t;
}
var $4e7e1af11ea066d2$var$Iu = Object.defineProperty, $4e7e1af11ea066d2$var$_u = Object.defineProperties, $4e7e1af11ea066d2$var$Bu = Object.getOwnPropertyDescriptors, $4e7e1af11ea066d2$var$io = Object.getOwnPropertySymbols, $4e7e1af11ea066d2$var$Cu = Object.prototype.hasOwnProperty, $4e7e1af11ea066d2$var$Ru = Object.prototype.propertyIsEnumerable, $4e7e1af11ea066d2$var$no = function(e, t, r) {
    return t in e ? $4e7e1af11ea066d2$var$Iu(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r;
}, $4e7e1af11ea066d2$var$fo = function(e, t) {
    for(var r in t || (t = {}))$4e7e1af11ea066d2$var$Cu.call(t, r) && $4e7e1af11ea066d2$var$no(e, r, t[r]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($4e7e1af11ea066d2$var$io) try {
        for(var _iterator = $4e7e1af11ea066d2$var$io(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var r = _step.value;
            $4e7e1af11ea066d2$var$Ru.call(t, r) && $4e7e1af11ea066d2$var$no(e, r, t[r]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return e;
}, $4e7e1af11ea066d2$var$Ou = function(e, t) {
    return $4e7e1af11ea066d2$var$_u(e, $4e7e1af11ea066d2$var$Bu(t));
};
function $4e7e1af11ea066d2$export$3d24f408c2ac468a(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "-";
    var r = {}, i = "relay" + t;
    return Object.keys(e).forEach(function(n) {
        if (n.startsWith(i)) {
            var o = n.replace(i, ""), h = e[n];
            r[o] = h;
        }
    }), r;
}
function $4e7e1af11ea066d2$export$59f58847421cfb28(e) {
    e = e.includes("wc://") ? e.replace("wc://", "") : e, e = e.includes("wc:") ? e.replace("wc:", "") : e;
    var t = e.indexOf(":"), r = e.indexOf("?") !== -1 ? e.indexOf("?") : void 0, i = e.substring(0, t), n = e.substring(t + 1, r).split("@"), o = (typeof r === "undefined" ? "undefined" : (0, $l0HdX._)(r)) < "u" ? e.substring(r) : "", h = $hDCWT.parse(o), p = typeof h.methods == "string" ? h.methods.split(",") : void 0;
    return {
        protocol: i,
        topic: $4e7e1af11ea066d2$export$5ddc9ebef1d00f28(n[0]),
        version: parseInt(n[1], 10),
        symKey: h.symKey,
        relay: $4e7e1af11ea066d2$export$3d24f408c2ac468a(h),
        methods: p,
        expiryTimestamp: h.expiryTimestamp ? parseInt(h.expiryTimestamp, 10) : void 0
    };
}
function $4e7e1af11ea066d2$export$5ddc9ebef1d00f28(e) {
    return e.startsWith("//") ? e.substring(2) : e;
}
function $4e7e1af11ea066d2$export$65c55c7ccd19bb8f(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "-";
    var r = "relay", i = {};
    return Object.keys(e).forEach(function(n) {
        var o = r + t + n;
        e[n] && (i[o] = e[n]);
    }), i;
}
function $4e7e1af11ea066d2$export$b2786ede34fb2350(e) {
    return "".concat(e.protocol, ":").concat(e.topic, "@").concat(e.version, "?") + $hDCWT.stringify($4e7e1af11ea066d2$var$fo($4e7e1af11ea066d2$var$Ou($4e7e1af11ea066d2$var$fo({
        symKey: e.symKey
    }, $4e7e1af11ea066d2$export$65c55c7ccd19bb8f(e.relay)), {
        expiryTimestamp: e.expiryTimestamp
    }), e.methods ? {
        methods: e.methods.join(",")
    } : {}));
}
var $4e7e1af11ea066d2$var$Fu = Object.defineProperty, $4e7e1af11ea066d2$var$Tu = Object.defineProperties, $4e7e1af11ea066d2$var$Uu = Object.getOwnPropertyDescriptors, $4e7e1af11ea066d2$var$uo = Object.getOwnPropertySymbols, $4e7e1af11ea066d2$var$ku = Object.prototype.hasOwnProperty, $4e7e1af11ea066d2$var$qu = Object.prototype.propertyIsEnumerable, $4e7e1af11ea066d2$var$ho = function(e, t, r) {
    return t in e ? $4e7e1af11ea066d2$var$Fu(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r;
}, $4e7e1af11ea066d2$var$Ku = function(e, t) {
    for(var r in t || (t = {}))$4e7e1af11ea066d2$var$ku.call(t, r) && $4e7e1af11ea066d2$var$ho(e, r, t[r]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($4e7e1af11ea066d2$var$uo) try {
        for(var _iterator = $4e7e1af11ea066d2$var$uo(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var r = _step.value;
            $4e7e1af11ea066d2$var$qu.call(t, r) && $4e7e1af11ea066d2$var$ho(e, r, t[r]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return e;
}, $4e7e1af11ea066d2$var$Hu = function(e, t) {
    return $4e7e1af11ea066d2$var$Tu(e, $4e7e1af11ea066d2$var$Uu(t));
};
function $4e7e1af11ea066d2$export$d46695d9c3664fe9(e) {
    var t = [];
    return e.forEach(function(r) {
        var _r_split = (0, $cv9Rk._)(r.split(":"), 2), i = _r_split[0], n = _r_split[1];
        t.push("".concat(i, ":").concat(n));
    }), t;
}
function $4e7e1af11ea066d2$export$fb6db6038e742b14(e) {
    var t = [];
    return Object.values(e).forEach(function(r) {
        var _t;
        (_t = t).push.apply(_t, (0, $c6Xmf._)($4e7e1af11ea066d2$export$d46695d9c3664fe9(r.accounts)));
    }), t;
}
function $4e7e1af11ea066d2$export$7dcf4808e17b15ac(e, t) {
    var r = [];
    return Object.values(e).forEach(function(i) {
        var _r;
        $4e7e1af11ea066d2$export$d46695d9c3664fe9(i.accounts).includes(t) && (_r = r).push.apply(_r, (0, $c6Xmf._)(i.methods));
    }), r;
}
function $4e7e1af11ea066d2$export$94ee6d00e384a22(e, t) {
    var r = [];
    return Object.values(e).forEach(function(i) {
        var _r;
        $4e7e1af11ea066d2$export$d46695d9c3664fe9(i.accounts).includes(t) && (_r = r).push.apply(_r, (0, $c6Xmf._)(i.events));
    }), r;
}
function $4e7e1af11ea066d2$export$a8daa26a7c60ef90(e, t) {
    var r = $4e7e1af11ea066d2$export$93f7b81dc815a714(e, t);
    if (r) throw new Error(r.message);
    var i = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $cv9Rk._)(_step.value, 2), n = _step_value[0], o = _step_value[1];
            i[n] = {
                methods: o.methods,
                events: o.events,
                chains: o.accounts.map(function(h) {
                    return "".concat(h.split(":")[0], ":").concat(h.split(":")[1]);
                })
            };
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return i;
}
function $4e7e1af11ea066d2$export$c0b86bc9b7d9f338(e) {
    var _e_proposal = e.proposal, t = _e_proposal.requiredNamespaces, tmp = _e_proposal.optionalNamespaces, r = tmp === void 0 ? {} : tmp, i = e.supportedNamespaces, n = $4e7e1af11ea066d2$export$2994550cda701c96(t), o = $4e7e1af11ea066d2$export$2994550cda701c96(r), h = {};
    Object.keys(i).forEach(function(m) {
        var w = i[m].chains, y = i[m].methods, S = i[m].events, I = i[m].accounts;
        w.forEach(function(N) {
            if (!I.some(function(C) {
                return C.includes(N);
            })) throw new Error("No accounts provided for chain ".concat(N, " in namespace ").concat(m));
        }), h[m] = {
            chains: w,
            methods: y,
            events: S,
            accounts: I
        };
    });
    var p = $4e7e1af11ea066d2$export$ba5b0a4b585cd1b4(t, h, "approve()");
    if (p) throw new Error(p.message);
    var b = {};
    return !Object.keys(t).length && !Object.keys(r).length ? h : (Object.keys(n).forEach(function(m) {
        var w = i[m].chains.filter(function(N) {
            var C, F;
            return (F = (C = n[m]) == null ? void 0 : C.chains) == null ? void 0 : F.includes(N);
        }), y = i[m].methods.filter(function(N) {
            var C, F;
            return (F = (C = n[m]) == null ? void 0 : C.methods) == null ? void 0 : F.includes(N);
        }), S = i[m].events.filter(function(N) {
            var C, F;
            return (F = (C = n[m]) == null ? void 0 : C.events) == null ? void 0 : F.includes(N);
        }), I = w.map(function(N) {
            return i[m].accounts.filter(function(C) {
                return C.includes("".concat(N, ":"));
            });
        }).flat();
        b[m] = {
            chains: w,
            methods: y,
            events: S,
            accounts: I
        };
    }), Object.keys(o).forEach(function(m) {
        var w, y, S, I, N, C;
        if (!i[m]) return;
        var F = (y = (w = o[m]) == null ? void 0 : w.chains) == null ? void 0 : y.filter(function(G) {
            return i[m].chains.includes(G);
        }), U = i[m].methods.filter(function(G) {
            var H, z;
            return (z = (H = o[m]) == null ? void 0 : H.methods) == null ? void 0 : z.includes(G);
        }), J = i[m].events.filter(function(G) {
            var H, z;
            return (z = (H = o[m]) == null ? void 0 : H.events) == null ? void 0 : z.includes(G);
        }), Bt = F === null || F === void 0 ? void 0 : F.map(function(G) {
            return i[m].accounts.filter(function(H) {
                return H.includes("".concat(G, ":"));
            });
        }).flat();
        b[m] = {
            chains: $4e7e1af11ea066d2$export$9826fe7ad3921016((S = b[m]) == null ? void 0 : S.chains, F),
            methods: $4e7e1af11ea066d2$export$9826fe7ad3921016((I = b[m]) == null ? void 0 : I.methods, U),
            events: $4e7e1af11ea066d2$export$9826fe7ad3921016((N = b[m]) == null ? void 0 : N.events, J),
            accounts: $4e7e1af11ea066d2$export$9826fe7ad3921016((C = b[m]) == null ? void 0 : C.accounts, Bt)
        };
    }), b);
}
function $4e7e1af11ea066d2$export$e03e993df4723bde(e) {
    return e.includes(":");
}
function $4e7e1af11ea066d2$export$dd404c96fbbb1ff8(e) {
    return $4e7e1af11ea066d2$export$e03e993df4723bde(e) ? e.split(":")[0] : e;
}
function $4e7e1af11ea066d2$export$2994550cda701c96(e) {
    var t, r, i;
    var n = {};
    if (!$4e7e1af11ea066d2$export$16a0268bc22b47b0(e)) return n;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $cv9Rk._)(_step.value, 2), o = _step_value[0], h = _step_value[1];
            var p = $4e7e1af11ea066d2$export$e03e993df4723bde(o) ? [
                o
            ] : h.chains, b = h.methods || [], m = h.events || [], w = $4e7e1af11ea066d2$export$dd404c96fbbb1ff8(o);
            n[w] = $4e7e1af11ea066d2$var$Hu($4e7e1af11ea066d2$var$Ku({}, n[w]), {
                chains: $4e7e1af11ea066d2$export$9826fe7ad3921016(p, (t = n[w]) == null ? void 0 : t.chains),
                methods: $4e7e1af11ea066d2$export$9826fe7ad3921016(b, (r = n[w]) == null ? void 0 : r.methods),
                events: $4e7e1af11ea066d2$export$9826fe7ad3921016(m, (i = n[w]) == null ? void 0 : i.events)
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return n;
}
function $4e7e1af11ea066d2$export$293459f1cc8d700(e) {
    var t = {};
    return e === null || e === void 0 ? void 0 : e.forEach(function(r) {
        var _r_split = (0, $cv9Rk._)(r.split(":"), 2), i = _r_split[0], n = _r_split[1];
        t[i] || (t[i] = {
            accounts: [],
            chains: [],
            events: []
        }), t[i].accounts.push(r), t[i].chains.push("".concat(i, ":").concat(n));
    }), t;
}
function $4e7e1af11ea066d2$export$b5744b1c39447540(e, t) {
    t = t.map(function(i) {
        return i.replace("did:pkh:", "");
    });
    var r = $4e7e1af11ea066d2$export$293459f1cc8d700(t);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(r)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $cv9Rk._)(_step.value, 2), i = _step_value[0], n = _step_value[1];
            n.methods ? n.methods = $4e7e1af11ea066d2$export$9826fe7ad3921016(n.methods, e) : n.methods = e, n.events = [
                "chainChanged",
                "accountsChanged"
            ];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return r;
}
var $4e7e1af11ea066d2$export$990de0b632caca05 = {
    INVALID_METHOD: {
        message: "Invalid method.",
        code: 1001
    },
    INVALID_EVENT: {
        message: "Invalid event.",
        code: 1002
    },
    INVALID_UPDATE_REQUEST: {
        message: "Invalid update request.",
        code: 1003
    },
    INVALID_EXTEND_REQUEST: {
        message: "Invalid extend request.",
        code: 1004
    },
    INVALID_SESSION_SETTLE_REQUEST: {
        message: "Invalid session settle request.",
        code: 1005
    },
    UNAUTHORIZED_METHOD: {
        message: "Unauthorized method.",
        code: 3001
    },
    UNAUTHORIZED_EVENT: {
        message: "Unauthorized event.",
        code: 3002
    },
    UNAUTHORIZED_UPDATE_REQUEST: {
        message: "Unauthorized update request.",
        code: 3003
    },
    UNAUTHORIZED_EXTEND_REQUEST: {
        message: "Unauthorized extend request.",
        code: 3004
    },
    USER_REJECTED: {
        message: "User rejected.",
        code: 5e3
    },
    USER_REJECTED_CHAINS: {
        message: "User rejected chains.",
        code: 5001
    },
    USER_REJECTED_METHODS: {
        message: "User rejected methods.",
        code: 5002
    },
    USER_REJECTED_EVENTS: {
        message: "User rejected events.",
        code: 5003
    },
    UNSUPPORTED_CHAINS: {
        message: "Unsupported chains.",
        code: 5100
    },
    UNSUPPORTED_METHODS: {
        message: "Unsupported methods.",
        code: 5101
    },
    UNSUPPORTED_EVENTS: {
        message: "Unsupported events.",
        code: 5102
    },
    UNSUPPORTED_ACCOUNTS: {
        message: "Unsupported accounts.",
        code: 5103
    },
    UNSUPPORTED_NAMESPACE_KEY: {
        message: "Unsupported namespace key.",
        code: 5104
    },
    USER_DISCONNECTED: {
        message: "User disconnected.",
        code: 6e3
    },
    SESSION_SETTLEMENT_FAILED: {
        message: "Session settlement failed.",
        code: 7e3
    },
    WC_METHOD_UNSUPPORTED: {
        message: "Unsupported wc_ method.",
        code: 10001
    }
}, $4e7e1af11ea066d2$export$77b3faa414a0ce61 = {
    NOT_INITIALIZED: {
        message: "Not initialized.",
        code: 1
    },
    NO_MATCHING_KEY: {
        message: "No matching key.",
        code: 2
    },
    RESTORE_WILL_OVERRIDE: {
        message: "Restore will override.",
        code: 3
    },
    RESUBSCRIBED: {
        message: "Resubscribed.",
        code: 4
    },
    MISSING_OR_INVALID: {
        message: "Missing or invalid.",
        code: 5
    },
    EXPIRED: {
        message: "Expired.",
        code: 6
    },
    UNKNOWN_TYPE: {
        message: "Unknown type.",
        code: 7
    },
    MISMATCHED_TOPIC: {
        message: "Mismatched topic.",
        code: 8
    },
    NON_CONFORMING_NAMESPACES: {
        message: "Non conforming namespaces.",
        code: 9
    }
};
function $4e7e1af11ea066d2$export$500d4c4a8fafe35(e, t) {
    var _Ao_e = $4e7e1af11ea066d2$export$77b3faa414a0ce61[e], r = _Ao_e.message, i = _Ao_e.code;
    return {
        message: t ? "".concat(r, " ").concat(t) : r,
        code: i
    };
}
function $4e7e1af11ea066d2$export$8203ef1531c8b5b5(e, t) {
    var _go_e = $4e7e1af11ea066d2$export$990de0b632caca05[e], r = _go_e.message, i = _go_e.code;
    return {
        message: t ? "".concat(r, " ").concat(t) : r,
        code: i
    };
}
function $4e7e1af11ea066d2$export$41dd3d480aac4a71(e, t) {
    return Array.isArray(e) ? (typeof t === "undefined" ? "undefined" : (0, $l0HdX._)(t)) < "u" && e.length ? e.every(t) : !0 : !1;
}
function $4e7e1af11ea066d2$export$16a0268bc22b47b0(e) {
    return Object.getPrototypeOf(e) === Object.prototype && Object.keys(e).length;
}
function $4e7e1af11ea066d2$export$fce6876652108ab(e) {
    return (typeof e === "undefined" ? "undefined" : (0, $l0HdX._)(e)) > "u";
}
function $4e7e1af11ea066d2$export$ee898ca48ab56c74(e, t) {
    return t && $4e7e1af11ea066d2$export$fce6876652108ab(e) ? !0 : typeof e == "string" && !!e.trim().length;
}
function $4e7e1af11ea066d2$export$d6781b696a0576d1(e, t) {
    return t && $4e7e1af11ea066d2$export$fce6876652108ab(e) ? !0 : typeof e == "number" && !isNaN(e);
}
function $4e7e1af11ea066d2$export$6fc4971bf8f326a(e, t) {
    var r = t.requiredNamespaces, i = Object.keys(e.namespaces), n = Object.keys(r);
    var o = !0;
    return $4e7e1af11ea066d2$export$1468a49de573f7f9(n, i) ? (i.forEach(function(h) {
        var _e_namespaces_h = e.namespaces[h], p = _e_namespaces_h.accounts, b = _e_namespaces_h.methods, m = _e_namespaces_h.events, w = $4e7e1af11ea066d2$export$d46695d9c3664fe9(p), y = r[h];
        (!$4e7e1af11ea066d2$export$1468a49de573f7f9($4e7e1af11ea066d2$export$376384387cd15b27(h, y), w) || !$4e7e1af11ea066d2$export$1468a49de573f7f9(y.methods, b) || !$4e7e1af11ea066d2$export$1468a49de573f7f9(y.events, m)) && (o = !1);
    }), o) : !1;
}
function $4e7e1af11ea066d2$export$e544b39f0a22e47a(e) {
    return $4e7e1af11ea066d2$export$ee898ca48ab56c74(e, !1) && e.includes(":") ? e.split(":").length === 2 : !1;
}
function $4e7e1af11ea066d2$export$49e4a5b6862e3c71(e) {
    if ($4e7e1af11ea066d2$export$ee898ca48ab56c74(e, !1) && e.includes(":")) {
        var t = e.split(":");
        if (t.length === 3) {
            var r = t[0] + ":" + t[1];
            return !!t[2] && $4e7e1af11ea066d2$export$e544b39f0a22e47a(r);
        }
    }
    return !1;
}
function $4e7e1af11ea066d2$export$bef94a5618bf18bf(e) {
    if ($4e7e1af11ea066d2$export$ee898ca48ab56c74(e, !1)) try {
        return (0, $l0HdX._)(new URL(e)) < "u";
    } catch (e) {
        return !1;
    }
    return !1;
}
function $4e7e1af11ea066d2$export$f657f7976bb2769d(e) {
    var t;
    return (t = e === null || e === void 0 ? void 0 : e.proposer) == null ? void 0 : t.publicKey;
}
function $4e7e1af11ea066d2$export$c96d5113768aaf5e(e) {
    return e === null || e === void 0 ? void 0 : e.topic;
}
function $4e7e1af11ea066d2$export$5e1c5c89613c213f(e, t) {
    var r = null;
    return $4e7e1af11ea066d2$export$ee898ca48ab56c74(e === null || e === void 0 ? void 0 : e.publicKey, !1) || (r = $4e7e1af11ea066d2$export$500d4c4a8fafe35("MISSING_OR_INVALID", "".concat(t, " controller public key should be a string"))), r;
}
function $4e7e1af11ea066d2$export$c12fced8176774f3(e) {
    var t = !0;
    return $4e7e1af11ea066d2$export$41dd3d480aac4a71(e) ? e.length && (t = e.every(function(r) {
        return $4e7e1af11ea066d2$export$ee898ca48ab56c74(r, !1);
    })) : t = !1, t;
}
function $4e7e1af11ea066d2$export$df46c123d7e298ce(e, t, r) {
    var i = null;
    return $4e7e1af11ea066d2$export$41dd3d480aac4a71(t) && t.length ? t.forEach(function(n) {
        i || $4e7e1af11ea066d2$export$e544b39f0a22e47a(n) || (i = $4e7e1af11ea066d2$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", "".concat(r, ", chain ").concat(n, ' should be a string and conform to "namespace:chainId" format')));
    }) : $4e7e1af11ea066d2$export$e544b39f0a22e47a(e) || (i = $4e7e1af11ea066d2$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", "".concat(r, ', chains must be defined as "namespace:chainId" e.g. "eip155:1": {...} in the namespace key OR as an array of CAIP-2 chainIds e.g. eip155: { chains: ["eip155:1", "eip155:5"] }'))), i;
}
function $4e7e1af11ea066d2$export$94ae96fb66f29e08(e, t, r) {
    var i = null;
    return Object.entries(e).forEach(function(param) {
        var _param = (0, $cv9Rk._)(param, 2), n = _param[0], o = _param[1];
        if (i) return;
        var h = $4e7e1af11ea066d2$export$df46c123d7e298ce(n, $4e7e1af11ea066d2$export$376384387cd15b27(n, o), "".concat(t, " ").concat(r));
        h && (i = h);
    }), i;
}
function $4e7e1af11ea066d2$export$d5644026aaffb9e7(e, t) {
    var r = null;
    return $4e7e1af11ea066d2$export$41dd3d480aac4a71(e) ? e.forEach(function(i) {
        r || $4e7e1af11ea066d2$export$49e4a5b6862e3c71(i) || (r = $4e7e1af11ea066d2$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", "".concat(t, ", account ").concat(i, ' should be a string and conform to "namespace:chainId:address" format')));
    }) : r = $4e7e1af11ea066d2$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", "".concat(t, ', accounts should be an array of strings conforming to "namespace:chainId:address" format')), r;
}
function $4e7e1af11ea066d2$export$2a2012e7bfa1cfb4(e, t) {
    var r = null;
    return Object.values(e).forEach(function(i) {
        if (r) return;
        var n = $4e7e1af11ea066d2$export$d5644026aaffb9e7(i === null || i === void 0 ? void 0 : i.accounts, "".concat(t, " namespace"));
        n && (r = n);
    }), r;
}
function $4e7e1af11ea066d2$export$b32541d63753af56(e, t) {
    var r = null;
    return $4e7e1af11ea066d2$export$c12fced8176774f3(e === null || e === void 0 ? void 0 : e.methods) ? $4e7e1af11ea066d2$export$c12fced8176774f3(e === null || e === void 0 ? void 0 : e.events) || (r = $4e7e1af11ea066d2$export$8203ef1531c8b5b5("UNSUPPORTED_EVENTS", "".concat(t, ", events should be an array of strings or empty array for no events"))) : r = $4e7e1af11ea066d2$export$8203ef1531c8b5b5("UNSUPPORTED_METHODS", "".concat(t, ", methods should be an array of strings or empty array for no methods")), r;
}
function $4e7e1af11ea066d2$export$27682c78deeca9d7(e, t) {
    var r = null;
    return Object.values(e).forEach(function(i) {
        if (r) return;
        var n = $4e7e1af11ea066d2$export$b32541d63753af56(i, "".concat(t, ", namespace"));
        n && (r = n);
    }), r;
}
function $4e7e1af11ea066d2$export$9e2b2cae22c6a8b3(e, t, r) {
    var i = null;
    if (e && $4e7e1af11ea066d2$export$16a0268bc22b47b0(e)) {
        var n = $4e7e1af11ea066d2$export$27682c78deeca9d7(e, t);
        n && (i = n);
        var o = $4e7e1af11ea066d2$export$94ae96fb66f29e08(e, t, r);
        o && (i = o);
    } else i = $4e7e1af11ea066d2$export$500d4c4a8fafe35("MISSING_OR_INVALID", "".concat(t, ", ").concat(r, " should be an object with data"));
    return i;
}
function $4e7e1af11ea066d2$export$93f7b81dc815a714(e, t) {
    var r = null;
    if (e && $4e7e1af11ea066d2$export$16a0268bc22b47b0(e)) {
        var i = $4e7e1af11ea066d2$export$27682c78deeca9d7(e, t);
        i && (r = i);
        var n = $4e7e1af11ea066d2$export$2a2012e7bfa1cfb4(e, t);
        n && (r = n);
    } else r = $4e7e1af11ea066d2$export$500d4c4a8fafe35("MISSING_OR_INVALID", "".concat(t, ", namespaces should be an object with data"));
    return r;
}
function $4e7e1af11ea066d2$export$1b3fc298be8c9a7b(e) {
    return $4e7e1af11ea066d2$export$ee898ca48ab56c74(e.protocol, !0);
}
function $4e7e1af11ea066d2$export$6294c30b976bd21e(e, t) {
    var r = !1;
    return t && !e ? r = !0 : e && $4e7e1af11ea066d2$export$41dd3d480aac4a71(e) && e.length && e.forEach(function(i) {
        r = $4e7e1af11ea066d2$export$1b3fc298be8c9a7b(i);
    }), r;
}
function $4e7e1af11ea066d2$export$53551be28ad5e34d(e) {
    return typeof e == "number";
}
function $4e7e1af11ea066d2$export$b3f5fcca1d210454(e) {
    return (typeof e === "undefined" ? "undefined" : (0, $l0HdX._)(e)) < "u" && true;
}
function $4e7e1af11ea066d2$export$766fe78377d96f2a(e) {
    return !(!e || typeof e != "object" || !e.code || !$4e7e1af11ea066d2$export$d6781b696a0576d1(e.code, !1) || !e.message || !$4e7e1af11ea066d2$export$ee898ca48ab56c74(e.message, !1));
}
function $4e7e1af11ea066d2$export$1a2af3c017fb6d42(e) {
    return !($4e7e1af11ea066d2$export$fce6876652108ab(e) || !$4e7e1af11ea066d2$export$ee898ca48ab56c74(e.method, !1));
}
function $4e7e1af11ea066d2$export$1ae38cf0a848f651(e) {
    return !($4e7e1af11ea066d2$export$fce6876652108ab(e) || $4e7e1af11ea066d2$export$fce6876652108ab(e.result) && $4e7e1af11ea066d2$export$fce6876652108ab(e.error) || !$4e7e1af11ea066d2$export$d6781b696a0576d1(e.id, !1) || !$4e7e1af11ea066d2$export$ee898ca48ab56c74(e.jsonrpc, !1));
}
function $4e7e1af11ea066d2$export$cbe4cdc5960cfa11(e) {
    return !($4e7e1af11ea066d2$export$fce6876652108ab(e) || !$4e7e1af11ea066d2$export$ee898ca48ab56c74(e.name, !1));
}
function $4e7e1af11ea066d2$export$144fc36610eb6522(e, t) {
    return !(!$4e7e1af11ea066d2$export$e544b39f0a22e47a(t) || !$4e7e1af11ea066d2$export$fb6db6038e742b14(e).includes(t));
}
function $4e7e1af11ea066d2$export$8db4804e3a6de711(e, t, r) {
    return $4e7e1af11ea066d2$export$ee898ca48ab56c74(r, !1) ? $4e7e1af11ea066d2$export$7dcf4808e17b15ac(e, t).includes(r) : !1;
}
function $4e7e1af11ea066d2$export$df2c67ef8baad16b(e, t, r) {
    return $4e7e1af11ea066d2$export$ee898ca48ab56c74(r, !1) ? $4e7e1af11ea066d2$export$94ee6d00e384a22(e, t).includes(r) : !1;
}
function $4e7e1af11ea066d2$export$ba5b0a4b585cd1b4(e, t, r) {
    var i = null;
    var n = $4e7e1af11ea066d2$var$sh(e), o = $4e7e1af11ea066d2$var$ah(t), h = Object.keys(n), p = Object.keys(o), b = $4e7e1af11ea066d2$var$_o(Object.keys(e)), m = $4e7e1af11ea066d2$var$_o(Object.keys(t)), w = b.filter(function(y) {
        return !m.includes(y);
    });
    return w.length && (i = $4e7e1af11ea066d2$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", "".concat(r, " namespaces keys don't satisfy requiredNamespaces.\n      Required: ").concat(w.toString(), "\n      Received: ").concat(Object.keys(t).toString()))), $4e7e1af11ea066d2$export$1468a49de573f7f9(h, p) || (i = $4e7e1af11ea066d2$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", "".concat(r, " namespaces chains don't satisfy required namespaces.\n      Required: ").concat(h.toString(), "\n      Approved: ").concat(p.toString()))), Object.keys(t).forEach(function(y) {
        if (!y.includes(":") || i) return;
        var S = $4e7e1af11ea066d2$export$d46695d9c3664fe9(t[y].accounts);
        S.includes(y) || (i = $4e7e1af11ea066d2$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", "".concat(r, " namespaces accounts don't satisfy namespace accounts for ").concat(y, "\n        Required: ").concat(y, "\n        Approved: ").concat(S.toString())));
    }), h.forEach(function(y) {
        i || ($4e7e1af11ea066d2$export$1468a49de573f7f9(n[y].methods, o[y].methods) ? $4e7e1af11ea066d2$export$1468a49de573f7f9(n[y].events, o[y].events) || (i = $4e7e1af11ea066d2$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", "".concat(r, " namespaces events don't satisfy namespace events for ").concat(y))) : i = $4e7e1af11ea066d2$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", "".concat(r, " namespaces methods don't satisfy namespace methods for ").concat(y)));
    }), i;
}
function $4e7e1af11ea066d2$var$sh(e) {
    var t = {};
    return Object.keys(e).forEach(function(r) {
        var i;
        r.includes(":") ? t[r] = e[r] : (i = e[r].chains) == null || i.forEach(function(n) {
            t[n] = {
                methods: e[r].methods,
                events: e[r].events
            };
        });
    }), t;
}
function $4e7e1af11ea066d2$var$_o(e) {
    return (0, $c6Xmf._)(new Set(e.map(function(t) {
        return t.includes(":") ? t.split(":")[0] : t;
    })));
}
function $4e7e1af11ea066d2$var$ah(e) {
    var t = {};
    return Object.keys(e).forEach(function(r) {
        if (r.includes(":")) t[r] = e[r];
        else {
            var i = $4e7e1af11ea066d2$export$d46695d9c3664fe9(e[r].accounts);
            i === null || i === void 0 ? void 0 : i.forEach(function(n) {
                t[n] = {
                    accounts: e[r].accounts.filter(function(o) {
                        return o.includes("".concat(n, ":"));
                    }),
                    methods: e[r].methods,
                    events: e[r].events
                };
            });
        }
    }), t;
}
function $4e7e1af11ea066d2$export$59fba2af1ac782b(e, t) {
    return $4e7e1af11ea066d2$export$d6781b696a0576d1(e, !1) && e <= t.max && e >= t.min;
}
function $4e7e1af11ea066d2$export$53c2fd0173ad2b80() {
    var e = $4e7e1af11ea066d2$export$57570b1603cf6adb();
    return new Promise(function(t) {
        switch(e){
            case $4e7e1af11ea066d2$export$86b1301a63b15dd9.browser:
                t($4e7e1af11ea066d2$export$2f147c609a999e49());
                break;
            case $4e7e1af11ea066d2$export$86b1301a63b15dd9.reactNative:
                t($4e7e1af11ea066d2$export$1444c95b1570bd12());
                break;
            case $4e7e1af11ea066d2$export$86b1301a63b15dd9.node:
                t($4e7e1af11ea066d2$export$aec5b2d627eec500());
                break;
            default:
                t(!0);
        }
    });
}
function $4e7e1af11ea066d2$export$2f147c609a999e49() {
    var _navigator;
    return $4e7e1af11ea066d2$export$4e09c449d6c407f7() && ((_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.onLine);
}
function $4e7e1af11ea066d2$export$1444c95b1570bd12() {
    return $4e7e1af11ea066d2$var$_Co.apply(this, arguments);
}
function $4e7e1af11ea066d2$var$_Co() {
    $4e7e1af11ea066d2$var$_Co = (0, $kSuI9._)(function() {
        var e;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!($4e7e1af11ea066d2$export$f7a1e23e542d38e3() && (typeof $parcel$global === "undefined" ? "undefined" : (0, $l0HdX._)($parcel$global)) < "u" && $parcel$global != null && $parcel$global.NetInfo)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        $parcel$global == null ? void 0 : $parcel$global.NetInfo.fetch()
                    ];
                case 1:
                    e = _state.sent();
                    return [
                        2,
                        e === null || e === void 0 ? void 0 : e.isConnected
                    ];
                case 2:
                    return [
                        2,
                        !0
                    ];
            }
        });
    });
    return $4e7e1af11ea066d2$var$_Co.apply(this, arguments);
}
function $4e7e1af11ea066d2$export$aec5b2d627eec500() {
    return !0;
}
function $4e7e1af11ea066d2$export$600a1ee4bc680996(e) {
    switch($4e7e1af11ea066d2$export$57570b1603cf6adb()){
        case $4e7e1af11ea066d2$export$86b1301a63b15dd9.browser:
            $4e7e1af11ea066d2$export$d32b24f18d96c5f2(e);
            break;
        case $4e7e1af11ea066d2$export$86b1301a63b15dd9.reactNative:
            $4e7e1af11ea066d2$export$904edb1c18ec91c7(e);
            break;
        case $4e7e1af11ea066d2$export$86b1301a63b15dd9.node:
            break;
    }
}
function $4e7e1af11ea066d2$export$d32b24f18d96c5f2(e) {
    !$4e7e1af11ea066d2$export$f7a1e23e542d38e3() && $4e7e1af11ea066d2$export$4e09c449d6c407f7() && (window.addEventListener("online", function() {
        return e(!0);
    }), window.addEventListener("offline", function() {
        return e(!1);
    }));
}
function $4e7e1af11ea066d2$export$904edb1c18ec91c7(e) {
    var _global;
    $4e7e1af11ea066d2$export$f7a1e23e542d38e3() && (typeof $parcel$global === "undefined" ? "undefined" : (0, $l0HdX._)($parcel$global)) < "u" && $parcel$global != null && $parcel$global.NetInfo && ((_global = $parcel$global) === null || _global === void 0 ? void 0 : _global.NetInfo.addEventListener(function(t) {
        return e(t === null || t === void 0 ? void 0 : t.isConnected);
    }));
}
var $4e7e1af11ea066d2$var$rn = {};
var $4e7e1af11ea066d2$export$b72d712fed4d036d = /*#__PURE__*/ function() {
    "use strict";
    function lh() {
        (0, $4GJKx._)(this, lh);
    }
    (0, $1wc17._)(lh, null, [
        {
            key: "get",
            value: function get(t) {
                return $4e7e1af11ea066d2$var$rn[t];
            }
        },
        {
            key: "set",
            value: function set(t, r) {
                $4e7e1af11ea066d2$var$rn[t] = r;
            }
        },
        {
            key: "delete",
            value: function _delete(t) {
                delete $4e7e1af11ea066d2$var$rn[t];
            }
        }
    ]);
    return lh;
}();



var $kSuI9 = parcelRequire("kSuI9");

var $cv9Rk = parcelRequire("cv9Rk");

var $eha6O = parcelRequire("eha6O");

var $5yelF = parcelRequire("5yelF");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $7ihh7 = parcelRequire("7ihh7");
var $b7763775c86b6ce3$export$d0a48bf953f3c239 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(UrlRequiredError, BaseError);
    var _super = (0, $ohfOJ._)(UrlRequiredError);
    function UrlRequiredError() {
        (0, $4GJKx._)(this, UrlRequiredError);
        return _super.call(this, "No URL was provided to the Transport. Please provide a valid RPC URL to the Transport.", {
            docsPath: "/docs/clients/intro",
            name: "UrlRequiredError"
        });
    }
    return UrlRequiredError;
}((0, $7ihh7.BaseError));



var $esvdW = parcelRequire("esvdW");

var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $eha6O = parcelRequire("eha6O");

var $5yelF = parcelRequire("5yelF");

var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");
function $ff2899ef378151ae$export$e86e19342bc4850e(fn, param) {
    var _param_errorInstance = param.errorInstance, errorInstance = _param_errorInstance === void 0 ? new Error("timed out") : _param_errorInstance, timeout = param.timeout, signal = param.signal;
    return new Promise(function(resolve, reject) {
        (0, $kSuI9._)(function() {
            var timeoutId, controller, err;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        controller = new AbortController();
                        if (timeout > 0) timeoutId = setTimeout(function() {
                            if (signal) controller.abort();
                            else reject(errorInstance);
                        }, timeout); // need to cast because bun globals.d.ts overrides @types/node
                        return [
                            4,
                            fn({
                                signal: (controller === null || controller === void 0 ? void 0 : controller.signal) || null
                            })
                        ];
                    case 1:
                        resolve.apply(void 0, [
                            _state.sent()
                        ]);
                        return [
                            3,
                            4
                        ];
                    case 2:
                        err = _state.sent();
                        if ((err === null || err === void 0 ? void 0 : err.name) === "AbortError") reject(errorInstance);
                        reject(err);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        clearTimeout(timeoutId);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    });
}



var $lUgMT = parcelRequire("lUgMT");
function $15020756ab1e1edd$var$createIdStore() {
    return {
        current: 0,
        take: function() {
            return this.current++;
        },
        reset: function() {
            this.current = 0;
        }
    };
}
var $15020756ab1e1edd$export$94f79fd1fae0679e = /*#__PURE__*/ $15020756ab1e1edd$var$createIdStore();


function $63b7c102ea9f3631$export$290dc69d3612792(url) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return {
        request: function(params) {
            return (0, $kSuI9._)(function() {
                var _options_timeout, body, _params_onRequest, onRequest, _params_onResponse, onResponse, _params_timeout, timeout, _options_fetchOptions, _params_fetchOptions, fetchOptions, headers, method, signal_, _response_headers_get, response, data, err;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            body = params.body, _params_onRequest = params.onRequest, onRequest = _params_onRequest === void 0 ? options.onRequest : _params_onRequest, _params_onResponse = params.onResponse, onResponse = _params_onResponse === void 0 ? options.onResponse : _params_onResponse, _params_timeout = params.timeout, timeout = _params_timeout === void 0 ? (_options_timeout = options.timeout) !== null && _options_timeout !== void 0 ? _options_timeout : 10000 : _params_timeout;
                            fetchOptions = (0, $do9pw._)({}, (_options_fetchOptions = options.fetchOptions) !== null && _options_fetchOptions !== void 0 ? _options_fetchOptions : {}, (_params_fetchOptions = params.fetchOptions) !== null && _params_fetchOptions !== void 0 ? _params_fetchOptions : {});
                            headers = fetchOptions.headers, method = fetchOptions.method, signal_ = fetchOptions.signal;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                9,
                                ,
                                10
                            ]);
                            return [
                                4,
                                (0, $ff2899ef378151ae$export$e86e19342bc4850e)(function() {
                                    var _ref = (0, $kSuI9._)(function(param) {
                                        var signal, _body_id, init, request, response;
                                        return (0, $eha6O.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    signal = param.signal;
                                                    init = (0, $cxjpp._)((0, $do9pw._)({}, fetchOptions), {
                                                        body: Array.isArray(body) ? (0, $lUgMT.stringify)(body.map(function(body) {
                                                            var _body_id;
                                                            return (0, $do9pw._)({
                                                                jsonrpc: "2.0",
                                                                id: (_body_id = body.id) !== null && _body_id !== void 0 ? _body_id : (0, $15020756ab1e1edd$export$94f79fd1fae0679e).take()
                                                            }, body);
                                                        })) : (0, $lUgMT.stringify)((0, $do9pw._)({
                                                            jsonrpc: "2.0",
                                                            id: (_body_id = body.id) !== null && _body_id !== void 0 ? _body_id : (0, $15020756ab1e1edd$export$94f79fd1fae0679e).take()
                                                        }, body)),
                                                        headers: (0, $do9pw._)({
                                                            "Content-Type": "application/json"
                                                        }, headers),
                                                        method: method || "POST",
                                                        signal: signal_ || (timeout > 0 ? signal : null)
                                                    });
                                                    request = new Request(url, init);
                                                    if (!onRequest) return [
                                                        3,
                                                        2
                                                    ];
                                                    return [
                                                        4,
                                                        onRequest(request)
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    _state.label = 2;
                                                case 2:
                                                    return [
                                                        4,
                                                        fetch(url, init)
                                                    ];
                                                case 3:
                                                    response = _state.sent();
                                                    return [
                                                        2,
                                                        response
                                                    ];
                                            }
                                        });
                                    });
                                    return function(_) {
                                        return _ref.apply(this, arguments);
                                    };
                                }(), {
                                    errorInstance: new (0, $5yelF.TimeoutError)({
                                        body: body,
                                        url: url
                                    }),
                                    timeout: timeout,
                                    signal: true
                                })
                            ];
                        case 2:
                            response = _state.sent();
                            if (!onResponse) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                onResponse(response)
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            if (!((_response_headers_get = response.headers.get("Content-Type")) === null || _response_headers_get === void 0 ? void 0 : _response_headers_get.startsWith("application/json"))) return [
                                3,
                                6
                            ];
                            return [
                                4,
                                response.json()
                            ];
                        case 5:
                            data = _state.sent();
                            return [
                                3,
                                8
                            ];
                        case 6:
                            return [
                                4,
                                response.text()
                            ];
                        case 7:
                            data = _state.sent();
                            data = JSON.parse(data || "{}");
                            _state.label = 8;
                        case 8:
                            if (!response.ok) throw new (0, $5yelF.HttpRequestError)({
                                body: body,
                                details: (0, $lUgMT.stringify)(data.error) || response.statusText,
                                headers: response.headers,
                                status: response.status,
                                url: url
                            });
                            return [
                                2,
                                data
                            ];
                        case 9:
                            err = _state.sent();
                            if (err instanceof (0, $5yelF.HttpRequestError)) throw err;
                            if (err instanceof (0, $5yelF.TimeoutError)) throw err;
                            throw new (0, $5yelF.HttpRequestError)({
                                body: body,
                                cause: err,
                                url: url
                            });
                        case 10:
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    };
}



function $8b7fc1077ff96d68$export$7d6f1c8842f9f527(/** URL of the JSON-RPC API. Defaults to the chain's public RPC URL. */ url) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var batch = config.batch, fetchOptions = config.fetchOptions, _config_key = config.key, key = _config_key === void 0 ? "http" : _config_key, _config_name = config.name, name = _config_name === void 0 ? "HTTP JSON-RPC" : _config_name, onFetchRequest = config.onFetchRequest, onFetchResponse = config.onFetchResponse, retryDelay = config.retryDelay;
    return function(param) {
        var chain = param.chain, retryCount_ = param.retryCount, timeout_ = param.timeout;
        var _ref = typeof batch === "object" ? batch : {}, _ref_batchSize = _ref.batchSize, batchSize = _ref_batchSize === void 0 ? 1000 : _ref_batchSize, _ref_wait = _ref.wait, wait = _ref_wait === void 0 ? 0 : _ref_wait;
        var _config_retryCount;
        var retryCount = (_config_retryCount = config.retryCount) !== null && _config_retryCount !== void 0 ? _config_retryCount : retryCount_;
        var _ref1;
        var timeout = (_ref1 = timeout_ !== null && timeout_ !== void 0 ? timeout_ : config.timeout) !== null && _ref1 !== void 0 ? _ref1 : 10000;
        var url_ = url || (chain === null || chain === void 0 ? void 0 : chain.rpcUrls.default.http[0]);
        if (!url_) throw new (0, $b7763775c86b6ce3$export$d0a48bf953f3c239)();
        var rpcClient = (0, $63b7c102ea9f3631$export$290dc69d3612792)(url_, {
            fetchOptions: fetchOptions,
            onRequest: onFetchRequest,
            onResponse: onFetchResponse,
            timeout: timeout
        });
        return (0, $7a1b698487ed0e09$export$d09f50d9ab7f7b69)({
            key: key,
            name: name,
            request: function(param) {
                var method = param.method, params = param.params;
                return (0, $kSuI9._)(function() {
                    var body, schedule, fn, _ref, _ref_, error, result;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                body = {
                                    method: method,
                                    params: params
                                };
                                schedule = (0, $esvdW.createBatchScheduler)({
                                    id: url_,
                                    wait: wait,
                                    shouldSplitBatch: function(requests) {
                                        return requests.length > batchSize;
                                    },
                                    fn: function(body) {
                                        return rpcClient.request({
                                            body: body
                                        });
                                    },
                                    sort: function(a, b) {
                                        return a.id - b.id;
                                    }
                                }).schedule;
                                fn = function() {
                                    var _ref = (0, $kSuI9._)(function(body) {
                                        var _tmp;
                                        return (0, $eha6O.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (!batch) return [
                                                        3,
                                                        1
                                                    ];
                                                    _tmp = schedule(body);
                                                    return [
                                                        3,
                                                        3
                                                    ];
                                                case 1:
                                                    return [
                                                        4,
                                                        rpcClient.request({
                                                            body: body
                                                        })
                                                    ];
                                                case 2:
                                                    _tmp = [
                                                        _state.sent()
                                                    ];
                                                    _state.label = 3;
                                                case 3:
                                                    return [
                                                        2,
                                                        _tmp
                                                    ];
                                            }
                                        });
                                    });
                                    return function fn(body) {
                                        return _ref.apply(this, arguments);
                                    };
                                }();
                                return [
                                    4,
                                    fn(body)
                                ];
                            case 1:
                                _ref = (0, $cv9Rk._).apply(void 0, [
                                    _state.sent(),
                                    1
                                ]), _ref_ = _ref[0], error = _ref_.error, result = _ref_.result;
                                if (error) throw new (0, $5yelF.RpcRequestError)({
                                    body: body,
                                    error: error,
                                    url: url_
                                });
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            },
            retryCount: retryCount,
            retryDelay: retryDelay,
            timeout: timeout,
            type: "http"
        }, {
            fetchOptions: fetchOptions,
            url: url_
        });
    };
}


var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $eha6O = parcelRequire("eha6O");

var $aqVrP = parcelRequire("aqVrP");


function $c2abfd15d99a3bf6$export$bcd1dd1f397bba12(transports_) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _config_key = config.key, key = _config_key === void 0 ? "fallback" : _config_key, _config_name = config.name, name = _config_name === void 0 ? "Fallback" : _config_name, _config_rank = config.rank, rank = _config_rank === void 0 ? false : _config_rank, retryCount = config.retryCount, retryDelay = config.retryDelay;
    return function(_param) {
        var chain = _param.chain, _param_pollingInterval = _param.pollingInterval, pollingInterval = _param_pollingInterval === void 0 ? 4000 : _param_pollingInterval, timeout = _param.timeout, rest = (0, $dRLPW._)(_param, [
            "chain",
            "pollingInterval",
            "timeout"
        ]);
        var transports = transports_;
        var onResponse = function() {};
        var transport = (0, $7a1b698487ed0e09$export$d09f50d9ab7f7b69)({
            key: key,
            name: name,
            request: function(param) {
                var method = param.method, params = param.params;
                return (0, $kSuI9._)(function() {
                    var fetch;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        fetch = function() {
                            var _ref = (0, $kSuI9._)(function() {
                                var i, transport, response, err;
                                var _arguments = arguments;
                                return (0, $eha6O.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            i = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 0;
                                            transport = transports[i]((0, $cxjpp._)((0, $do9pw._)({}, rest), {
                                                chain: chain,
                                                retryCount: 0,
                                                timeout: timeout
                                            }));
                                            _state.label = 1;
                                        case 1:
                                            _state.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4,
                                                transport.request({
                                                    method: method,
                                                    params: params
                                                })
                                            ];
                                        case 2:
                                            response = _state.sent();
                                            onResponse({
                                                method: method,
                                                params: params,
                                                response: response,
                                                transport: transport,
                                                status: "success"
                                            });
                                            return [
                                                2,
                                                response
                                            ];
                                        case 3:
                                            err = _state.sent();
                                            onResponse({
                                                error: err,
                                                method: method,
                                                params: params,
                                                transport: transport,
                                                status: "error"
                                            });
                                            if ($c2abfd15d99a3bf6$var$shouldThrow(err)) throw err;
                                            // If we've reached the end of the fallbacks, throw the error.
                                            if (i === transports.length - 1) throw err;
                                            // Otherwise, try the next fallback.
                                            return [
                                                2,
                                                fetch(i + 1)
                                            ];
                                        case 4:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function fetch() {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        return [
                            2,
                            fetch()
                        ];
                    });
                })();
            },
            retryCount: retryCount,
            retryDelay: retryDelay,
            type: "fallback"
        }, {
            onResponse: function(fn) {
                return onResponse = fn;
            },
            transports: transports.map(function(fn) {
                return fn({
                    chain: chain,
                    retryCount: 0
                });
            })
        });
        if (rank) {
            var rankOptions = typeof rank === "object" ? rank : {};
            var _rankOptions_interval;
            $c2abfd15d99a3bf6$export$f2bce5ae3fda4e76({
                chain: chain,
                interval: (_rankOptions_interval = rankOptions.interval) !== null && _rankOptions_interval !== void 0 ? _rankOptions_interval : pollingInterval,
                onTransports: function(transports_) {
                    return transports = transports_;
                },
                sampleCount: rankOptions.sampleCount,
                timeout: rankOptions.timeout,
                transports: transports,
                weights: rankOptions.weights
            });
        }
        return transport;
    };
}
function $c2abfd15d99a3bf6$var$shouldThrow(error) {
    if ("code" in error && typeof error.code === "number") {
        if (error.code === (0, $aqVrP.TransactionRejectedRpcError).code || error.code === (0, $aqVrP.UserRejectedRequestError).code || error.code === 5000 // CAIP UserRejectedRequestError
        ) return true;
    }
    return false;
}
function $c2abfd15d99a3bf6$export$f2bce5ae3fda4e76(param) {
    var chain = param.chain, _param_interval = param.interval, interval = _param_interval === void 0 ? 4000 : _param_interval, onTransports = param.onTransports, _param_sampleCount = param.sampleCount, sampleCount = _param_sampleCount === void 0 ? 10 : _param_sampleCount, _param_timeout = param.timeout, timeout = _param_timeout === void 0 ? 1000 : _param_timeout, transports = param.transports, _param_weights = param.weights, weights = _param_weights === void 0 ? {} : _param_weights;
    var tmp = weights.stability, stabilityWeight = tmp === void 0 ? 0.7 : tmp, tmp1 = weights.latency, latencyWeight = tmp1 === void 0 ? 0.3 : tmp1;
    var samples = [];
    var rankTransports_ = function() {
        var _ref = (0, $kSuI9._)(function() {
            var _Math, _Math1, sample, maxLatency, scores;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Promise.all(transports.map(function() {
                                var _ref = (0, $kSuI9._)(function(transport) {
                                    var transport_, start, end, success, e, latency;
                                    return (0, $eha6O.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                transport_ = transport({
                                                    chain: chain,
                                                    retryCount: 0,
                                                    timeout: timeout
                                                });
                                                start = Date.now();
                                                _state.label = 1;
                                            case 1:
                                                _state.trys.push([
                                                    1,
                                                    3,
                                                    4,
                                                    5
                                                ]);
                                                return [
                                                    4,
                                                    transport_.request({
                                                        method: "net_listening"
                                                    })
                                                ];
                                            case 2:
                                                _state.sent();
                                                success = 1;
                                                return [
                                                    3,
                                                    5
                                                ];
                                            case 3:
                                                e = _state.sent();
                                                success = 0;
                                                return [
                                                    3,
                                                    5
                                                ];
                                            case 4:
                                                end = Date.now();
                                                return [
                                                    7
                                                ];
                                            case 5:
                                                latency = end - start;
                                                return [
                                                    2,
                                                    {
                                                        latency: latency,
                                                        success: success
                                                    }
                                                ];
                                        }
                                    });
                                });
                                return function(transport) {
                                    return _ref.apply(this, arguments);
                                };
                            }()))
                        ];
                    case 1:
                        sample = _state.sent();
                        // 2. Store the sample. If we have more than `sampleCount` samples, remove
                        // the oldest sample.
                        samples.push(sample);
                        if (samples.length > sampleCount) samples.shift();
                        // 3. Calculate the max latency from samples.
                        maxLatency = (_Math1 = Math).max.apply(_Math1, (0, $c6Xmf._)(samples.map(function(sample) {
                            return (_Math = Math).max.apply(_Math, (0, $c6Xmf._)(sample.map(function(param) {
                                var latency = param.latency;
                                return latency;
                            })));
                        })));
                        // 4. Calculate the score for each Transport.
                        scores = transports.map(function(_, i) {
                            var latencies = samples.map(function(sample) {
                                return sample[i].latency;
                            });
                            var meanLatency = latencies.reduce(function(acc, latency) {
                                return acc + latency;
                            }, 0) / latencies.length;
                            var latencyScore = 1 - meanLatency / maxLatency;
                            var successes = samples.map(function(sample) {
                                return sample[i].success;
                            });
                            var stabilityScore = successes.reduce(function(acc, success) {
                                return acc + success;
                            }, 0) / successes.length;
                            if (stabilityScore === 0) return [
                                0,
                                i
                            ];
                            return [
                                latencyWeight * latencyScore + stabilityWeight * stabilityScore,
                                i
                            ];
                        }).sort(function(a, b) {
                            return b[0] - a[0];
                        });
                        // 5. Sort the Transports by score.
                        onTransports(scores.map(function(param) {
                            var _param = (0, $cv9Rk._)(param, 2), i = _param[1];
                            return transports[i];
                        }));
                        // 6. Wait, and then rank again.
                        return [
                            4,
                            (0, $a77c4d3ea39fd77e$export$5c069c93d2b7493f)(interval)
                        ];
                    case 2:
                        _state.sent();
                        rankTransports_();
                        return [
                            2
                        ];
                }
            });
        });
        return function rankTransports_() {
            return _ref.apply(this, arguments);
        };
    }();
    rankTransports_();
}


parcelRequire("cwWZ7");
var $hZBJb = parcelRequire("hZBJb");
function $e82e1b76ecf9a723$export$1ee567fcdafbf4d8(chain) {
    if (!chain) return undefined;
    return {
        id: "".concat((0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).EIP155, ":").concat(chain.id),
        name: chain.name,
        imageId: (0, $f0772dbd8906c097$export$fd35d6514357600).EIP155NetworkImageIds[chain.id],
        chain: (0, $3QZC1.ConstantsUtil).CHAIN.EVM
    };
}
function $e82e1b76ecf9a723$export$24a8d1cae47a6f(connector) {
    return $e82e1b76ecf9a723$var$_getWalletConnectCaipNetworks.apply(this, arguments);
}
function $e82e1b76ecf9a723$var$_getWalletConnectCaipNetworks() {
    $e82e1b76ecf9a723$var$_getWalletConnectCaipNetworks = (0, $kSuI9._)(function(connector) {
        var _provider_signer_session, _provider_signer, _ns_ConstantsUtil_EIP155, _ns_ConstantsUtil_EIP1551, provider, ns, nsMethods, nsChains;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!connector) throw new Error("networkControllerClient:getApprovedCaipNetworks - connector is undefined");
                    return [
                        4,
                        connector === null || connector === void 0 ? void 0 : connector.getProvider()
                    ];
                case 1:
                    provider = _state.sent();
                    ns = provider === null || provider === void 0 ? void 0 : (_provider_signer = provider.signer) === null || _provider_signer === void 0 ? void 0 : (_provider_signer_session = _provider_signer.session) === null || _provider_signer_session === void 0 ? void 0 : _provider_signer_session.namespaces;
                    nsMethods = ns === null || ns === void 0 ? void 0 : (_ns_ConstantsUtil_EIP155 = ns[(0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).EIP155]) === null || _ns_ConstantsUtil_EIP155 === void 0 ? void 0 : _ns_ConstantsUtil_EIP155.methods;
                    nsChains = (0, $4e7e1af11ea066d2$export$d5ee58c6b13696e9)((ns === null || ns === void 0 ? void 0 : (_ns_ConstantsUtil_EIP1551 = ns[(0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).EIP155]) === null || _ns_ConstantsUtil_EIP1551 === void 0 ? void 0 : _ns_ConstantsUtil_EIP1551.accounts) || []);
                    return [
                        2,
                        {
                            supportsAllNetworks: Boolean(nsMethods === null || nsMethods === void 0 ? void 0 : nsMethods.includes((0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).ADD_CHAIN_METHOD)),
                            approvedCaipNetworkIds: nsChains
                        }
                    ];
            }
        });
    });
    return $e82e1b76ecf9a723$var$_getWalletConnectCaipNetworks.apply(this, arguments);
}
function $e82e1b76ecf9a723$export$94f91666d3e5b28f() {
    return {
        supportsAllNetworks: false,
        approvedCaipNetworkIds: (0, $f0772dbd8906c097$export$fd35d6514357600).WalletConnectRpcChainIds.map(function(id) {
            return "".concat((0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).EIP155, ":").concat(id);
        })
    };
}
function $e82e1b76ecf9a723$export$867d8b939ab7f43e(param) {
    var chain = param.chain, projectId = param.projectId;
    var _chain_rpcUrls__http, _chain_rpcUrls_;
    var RPC_URL = (0, $hZBJb.CoreHelperUtil).getBlockchainApiUrl();
    var chainDefaultUrl = (_chain_rpcUrls_ = chain.rpcUrls[0]) === null || _chain_rpcUrls_ === void 0 ? void 0 : (_chain_rpcUrls__http = _chain_rpcUrls_.http) === null || _chain_rpcUrls__http === void 0 ? void 0 : _chain_rpcUrls__http[0];
    if (!(0, $f0772dbd8906c097$export$fd35d6514357600).WalletConnectRpcChainIds.includes(chain.id)) return (0, $8b7fc1077ff96d68$export$7d6f1c8842f9f527)(chainDefaultUrl);
    return (0, $c2abfd15d99a3bf6$export$bcd1dd1f397bba12)([
        (0, $8b7fc1077ff96d68$export$7d6f1c8842f9f527)("".concat(RPC_URL, "/v1/?chainId=").concat((0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).EIP155, ":").concat(chain.id, "&projectId=").concat(projectId), {
            fetchOptions: {
                headers: {
                    "Content-Type": "text/plain"
                }
            }
        }),
        (0, $8b7fc1077ff96d68$export$7d6f1c8842f9f527)(chainDefaultUrl)
    ]);
}
function $e82e1b76ecf9a723$export$c1398e40f52e8b4a(caipAddress) {
    if (!caipAddress) throw new Error("No CAIP address provided");
    var account = caipAddress.split(":")[2];
    if (!account) throw new Error("Invalid CAIP address");
    return account;
}


parcelRequire("hsyMZ");
var $2ZXsZ = parcelRequire("2ZXsZ");
var $cSJ4o = parcelRequire("cSJ4o");
// created 2023-09-12T22:05:14.211Z
// compressed base64-encoded blob for include-ens data
// source: https://github.com/adraffy/ens-normalize.js/blob/main/src/make.js
// see: https://github.com/adraffy/ens-normalize.js#security
// SHA-256: 0565ed049b9cf1614bb9e11ba7d8ac6a6fb96c893253d890f7e2b2884b9ded32

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $cv9Rk = parcelRequire("cv9Rk");

var $gdHfP = parcelRequire("gdHfP");

var $c6Xmf = parcelRequire("c6Xmf");

var $l0HdX = parcelRequire("l0HdX");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");
var $ed66406a997fd44d$var$COMPRESSED$1 = "AEEUdwmgDS8BxQKKAP4BOgDjATAAngDUAIMAoABoAOAAagCOAEQAhABMAHIAOwA9ACsANgAmAGIAHgAuACgAJwAXAC0AGgAjAB8ALwAUACkAEgAeAAkAGwARABkAFgA5ACgALQArADcAFQApABAAHgAiABAAGgAeABMAGAUhBe8BFxREN8sF2wC5AK5HAW8ArQkDzQCuhzc3NzcBP68NEfMABQdHBuw5BV8FYAA9MzkI9r4ZBg7QyQAWA9CeOwLNCjcCjqkChuA/lm+RAsXTAoP6ASfnEQDytQFJAjWVCkeXAOsA6godAB/cwdAUE0WlBCN/AQUCQRjFD/MRBjHxDQSJbw0jBzUAswBxme+tnIcAYwabAysG8QAjAEMMmxcDqgPKQyDXCMMxA7kUQwD3NXOrAKmFIAAfBC0D3x4BJQDBGdUFAhEgVD8JnwmQJiNWYUzrg0oAGwAUAB0AFnNcACkAFgBP9h3gPfsDOWDKneY2ChglX1UDYD30ABsAFAAdABZzIGRAnwDD8wAjAEEMzRbDqgMB2sAFYwXqAtCnAsS4AwpUJKRtFHsadUz9AMMVbwLpABM1NJEX0ZkCgYMBEyMAxRVvAukAEzUBUFAtmUwSAy4DBTER33EftQHfSwB5MxJ/AjkWKQLzL8E/cwBB6QH9LQDPDtO9ASNriQC5DQANAwCK21EFI91zHwCoL9kBqQcHBwcHKzUDowBvAQohPvU3fAQgHwCyAc8CKQMA5zMSezr7ULgFmDp/LzVQBgEGAi8FYQVgt8AFcTtlQhpCWEmfe5tmZ6IAExsDzQ8t+X8rBKtTAltbAn0jsy8Bl6utPWMDTR8Ei2kRANkDBrNHNysDBzECQWUAcwFpJ3kAiyUhAJ0BUb8AL3EfAbfNAz81KUsFWwF3YQZtAm0A+VEfAzEJDQBRSQCzAQBlAHsAM70GD/v3IZWHBwARKQAxALsjTwHZAeMPEzmXgIHwABIAGQA8AEUAQDt3gdvIEGcQZAkGTRFMdEIVEwK0D64L7REdDNkq09PgADSxB/MDWwfzA1sDWwfzB/MDWwfzA1sDWwNbA1scEvAi28gQZw9QBHUFlgWTBN4IiyZREYkHMAjaVBV0JhxPA00BBCMtSSQ7mzMTJUpMFE0LCAQ2SmyvfUADTzGzVP2QqgPTMlc5dAkGHnkSqAAyD3skNb1OhnpPcagKU0+2tYdJak5vAsY6sEAACikJm2/Dd1YGRRAfJ6kQ+ww3AbkBPw3xS9wE9QY/BM0fgRkdD9GVoAipLeEM8SbnLqWAXiP5KocF8Uv4POELUVFsD10LaQnnOmeBUgMlAREijwrhDT0IcRD3Cs1vDekRSQc9A9lJngCpBwULFR05FbkmFGKwCw05ewb/GvoLkyazEy17AAXXGiUGUQEtGwMA0y7rhbRaNVwgT2MGBwspI8sUrFAkDSlAu3hMGh8HGSWtApVDdEqLUToelyH6PEENai4XUYAH+TwJGVMLhTyiRq9FEhHWPpE9TCJNTDAEOYMsMyePCdMPiQy9fHYBXQklCbUMdRM1ERs3yQg9Bx0xlygnGQglRplgngT7owP3E9UDDwVDCUUHFwO5HDETMhUtBRGBKNsC9zbZLrcCk1aEARsFzw8pH+MQVEfkDu0InwJpA4cl7wAxFSUAGyKfCEdnAGOP3FMJLs8Iy2pwI3gDaxTrZRF3B5UOWwerHDcVwxzlcMxeD4YMKKezCV8BeQmdAWME5wgNNV+MpCBFZ1eLXBifIGVBQ14AAjUMaRWjRMGHfAKPD28SHwE5AXcHPQ0FAnsR8RFvEJkI74YINbkz/DopBFMhhyAVCisDU2zSCysm/Qz8bQGnEmYDEDRBd/Jnr2C6KBgBBx0yyUFkIfULlk/RDKAaxRhGVDIZ6AfDA/ca9yfuQVsGAwOnBxc6UTPyBMELbQiPCUMATQ6nGwfbGG4KdYzUATWPAbudA1uVhwJzkwY7Bw8Aaw+LBX3pACECqwinAAkA0wNbAD0CsQehAB0AiUUBQQMrMwEl6QKTA5cINc8BmTMB9y0EH8cMGQD7O25OAsO1AoBuZqYF4VwCkgJNOQFRKQQJUktVA7N15QDfAE8GF+NLARmvTs8e50cB43MvAMsA/wAJOQcJRQHRAfdxALsBYws1Caa3uQFR7S0AhwAZbwHbAo0A4QA5AIP1AVcAUQVd/QXXAlNNARU1HC9bZQG/AyMBNwERAH0Gz5GpzQsjBHEH1wIQHxXlAu8yB7kFAyLjE9FCyQK94lkAMhoKPAqrCqpgX2Q3CjV2PVQAEh+sPss/UgVVO1c7XDtXO1w7VztcO1c7XDtXO1wDm8Pmw+YKcF9JYe8Mqg3YRMw6TRPfYFVgNhPMLbsUxRXSJVoZQRrAJwkl6FUNDwgt12Y0CDA0eRfAAEMpbINFY4oeNApPHOtTlVT8LR8AtUumM7MNsBsZREQFS3XxYi4WEgomAmSFAmJGX1GzAV83JAKh+wJonAJmDQKfiDgfDwJmPwJmKgRyBIMDfxcDfpY5Cjl7GzmGOicnAmwhAjI6OA4CbcsCbbLzjgM3a0kvAWsA4gDlAE4JB5wMkQECD8YAEbkCdzMCdqZDAnlPRwJ4viFg30WyRvcCfEMCeswCfQ0CfPRIBEiBZygALxlJXEpfGRtK0ALRBQLQ0EsrA4hTA4fqRMmRNgLypV0HAwOyS9JMMSkH001QTbMCi0MCitzFHwshR2sJuwKOOwKOYESbhQKO3QKOYHxRuFM5AQ5S2FSJApP/ApMQAO0AIFUiVbNV1AosHymZijLleGpFPz0Cl6MC77ZYJawAXSkClpMCloCgAK1ZsFoNhVEAPwKWuQKWUlxIXNUCmc8CmWhczl0LHQKcnznGOqECnBoCn58CnryOACETNS4TAp31Ap6WALlBYThh8wKe1wKgcgGtAp6jIwKeUqljzGQrKS8CJ7MCJoICoP8CoFDbAqYzAqXSAqgDAIECp/ZogGi1AAdNaiBq1QKs5wKssgKtawKtBgJXIQJV4AKx5dsDH1JsmwKywRECsuwbbORtZ21MYwMl0QK2YD9DbpQDKUkCuGICuUsZArkue3A6cOUCvR0DLbYDMhUCvoxyBgMzdQK+HnMmc1MCw88CwwhzhnRPOUl05AM8qwEDPJ4DPcMCxYACxksCxhSNAshtVQLISALJUwLJMgJkoQLd1nh9ZXiyeSlL1AMYp2cGAmH4GfeVKHsPXpZevxUCz28Cz3AzT1fW9xejAMqxAs93AS3uA04Wfk8JAtwrAtuOAtJTA1JgA1NjAQUDVZCAjUMEzxrxZEl5A4LSg5EC2ssC2eKEFIRNp0ADhqkAMwNkEoZ1Xf0AWQLfaQLevHd7AuIz7RgB8zQrAfSfAfLWiwLr9wLpdH0DAur9AuroAP1LAb0C7o0C66CWrpcHAu5DA4XkmH1w5HGlAvMHAG0DjhqZlwL3FwORcgOSiwL3nAL53QL4apogmq+/O5siA52HAv7+AR8APZ8gAZ+3AwWRA6ZuA6bdANXJAwZuoYyiCQ0DDE0BEwEjB3EGZb1rCQC/BG/DFY8etxEAG3k9ACcDNxJRA42DAWcrJQCM8wAlAOanC6OVCLsGI6fJBgCvBRnDBvElRUYFFoAFcD9GSDNCKUK8X3kZX8QAls0FOgCQVCGbwTsuYDoZutcONxjOGJHJ/gVfBWAFXwVgBWsFYAVfBWAFXwVgBV8FYAVfBWBOHQjfjW8KCgoKbF7xMwTRA7kGN8PDAMMEr8MA70gxFroFTj5xPnhCR0K+X30/X/AAWBkzswCNBsxzzASm70aCRS4rDDMeLz49fnXfcsH5GcoscQFz13Y4HwVnBXLJycnACNdRYwgICAqEXoWTxgA7P4kACxbZBu21Kw0AjMsTAwkVAOVtJUUsJ1JCuULESUArXy9gPi9AKwnJRQYKTD9LPoA+iT54PnkCkULEUUpDX9NWV3JVEjQAc1w3A3IBE3YnX+g7QiMJb6MKaiszRCUuQrNCxDPMCcwEX9EWJzYREBEEBwIHKn6l33JCNVIfybPJtAltydPUCmhBZw/tEKsZAJOVJU1CLRuxbUHOQAo7P0s+eEJHHA8SJVRPdGM0NVrpvBoKhfUlM0JHHGUQUhEWO1xLSj8MO0ucNAqJIzVCRxv9EFsqKyA4OQgNj2nwZgp5ZNFgE2A1K3YHS2AhQQojJmC7DgpzGG1WYFUZCQYHZO9gHWCdYIVgu2BTYJlwFh8GvRbcXbG8YgtDHrMBwzPVyQonHQgkCyYBgQJ0Ajc4nVqIAwGSCsBPIgDsK3SWEtIVBa5N8gGjAo+kVwVIZwD/AEUSCDweX4ITrRQsJ8K3TwBXFDwEAB0TvzVcAtoTS20RIwDgVgZ9BBImYgA5AL4Coi8LFnezOkCnIQFjAY4KBAPh9RcGsgZSBsEAJctdsWIRu2kTkQstRw7DAcMBKgpPBGIGMDAwKCYnKTQaLg4AKRSVAFwCdl+YUZ0JdicFD3lPAdt1F9ZZKCGxuE3yBxkFVGcA/wBFEgiCBwAOLHQSjxOtQDg1z7deFRMAZ8QTAGtKb1ApIiPHADkAvgKiLy1DFtYCmBiDAlDDWNB0eo7fpaMO/aEVRRv0ATEQZBIODyMEAc8JQhCbDRgzFD4TAEMAu9YBCgCsAOkAm5I3ABwAYxvONnR+MhXJAxgKQyxL2+kkJhMbhQKDBMkSsvF0AD9BNQ6uQC7WqSQHwxEAEEIu1hkhAH2z4iQPwyJPHNWpdyYBRSpnJALzoBAEVPPsH20MxA0CCEQKRgAFyAtFAlMNwwjEDUQJRArELtapMg7DDZgJIw+TGukEIwvDFkMAqAtDEMMMBhioe+QAO3MMRAACrgnEBSPY9Q0FDnbSBoMAB8MSYxkSxAEJAPIJAAB8FWMOFtMc/HcXwxhDAC7DAvOowwAewwJdKDKHAAHDAALrFUQVwwAbwyvzpWMWv8wA/ABpAy++bcYDUKPD0KhDCwKmJ1MAAmMA5+UZwxAagwipBRL/eADfw6fDGOMCGsOjk3l6BwOpo4sAEsMOGxMAA5sAbcMOAAvDp0MJGkMDwgipnNIPAwfIqUMGAOGDAAPzABXDAAcDAAnDAGmTABrDAA7DChjDjnEWAwABYwAOcwAuUyYABsMAF8MIKQANUgC6wy4AA8MADqMq8wCyYgAcIwAB8wqpAAXOCx0V4wAHowBCwwEKAGnDAAuDAB3DAAjDCakABdIAbqcZ3QCZCCkABdIAAAFDAAfjAB2jCCkABqIACYMAGzMAbSMA5sOIAAhjAAhDABTDBAkpAAbSAOOTAAlDC6kOzPtnAAdDAG6kQFAATwAKwwwAA0MACbUDPwAHIwAZgwACE6cDAAojAApDAAoDp/MGwwAJIwADEwAQQwgAFEMAEXMAD5MADfMADcMAGRMOFiMAFUMAbqMWuwHDAMIAE0MLAGkzEgDhUwACQwAEWgAXgwUjAAbYABjDBSYBgzBaAEFNALcQBxUMegAwMngBrA0IZgJ0KxQHBREPd1N0ZzKRJwaIHAZqNT4DqQq8BwngAB4DAwt2AX56T1ocKQNXAh1GATQGC3tOxYNagkgAMQA5CQADAQEAWxLjAIOYNAEzAH7tFRk6TglSAF8NAAlYAQ+S1ACAQwQorQBiAN4dAJ1wPyeTANVzuQDX3AIeEMp9eyMgXiUAEdkBkJizKltbVVAaRMqRAAEAhyQ/SDEz6BmfVwB6ATEsOClKIRcDOF0E/832AFNt5AByAnkCRxGCOs94NjXdAwINGBonDBwPALW2AwICAgAAAAAAAAYDBQMDARrUAwAtAAAAAgEGBgYGBgYFBQUFBQUEBQYHCAkEBQUFBQQAAAICAAAAIgCNAJAAlT0A6gC7ANwApEQAwgCyAK0AqADuAKYA2gCjAOcBCAEDAMcAgQBiANIA1AEDAN4A8gCQAKkBMQDqAN8A3AsBCQ8yO9ra2tq8xuLT1tRJOB0BUgFcNU0BWgFpAWgBWwFMUUlLbhMBUxsNEAs6PhMOACcUKy0vMj5AQENDQ0RFFEYGJFdXV1dZWVhZL1pbXVxcI2NnZ2ZoZypsbnZ1eHh4eHh4enp6enp6enp6enp8fH18e2IARPIASQCaAHgAMgBm+ACOAFcAVwA3AnbvAIsABfj4AGQAk/IAnwBPAGIAZP//sACFAIUAaQBWALEAJAC2AIMCQAJDAPwA5wD+AP4A6AD/AOkA6QDoAOYALwJ7AVEBQAE+AVQBPgE+AT4BOQE4ATgBOAEcAVgXADEQCAEAUx8SHgsdHhYAjgCWAKYAUQBqIAIxAHYAbwCXAxUDJzIDIUlGTzEAkQJPAMcCVwKkAMAClgKWApYClgKWApYCiwKWApYClgKWApYClgKVApUCmAKgApcClgKWApQClAKUApQCkgKVAnUB1AKXAp8ClgKWApUeAIETBQD+DQOfAmECOh8BVBg9AuIZEjMbAU4/G1WZAXusRAFpYQEFA0FPAQYAmTEeIJdyADFoAHEANgCRA5zMk/C2jGINwjMWygIZCaXdfDILBCs5dAE7YnQBugDlhoiHhoiGiYqKhouOjIaNkI6Ij4qQipGGkoaThpSSlYaWhpeKmIaZhpqGm4aci52QnoqfhuIC4XTpAt90AIp0LHSoAIsAdHQEQwRABEIERQRDBEkERgRBBEcESQRIBEQERgRJAJ5udACrA490ALxuAQ10ANFZdHQA13QCFHQA/mJ0AP4BIQD+APwA/AD9APwDhGZ03ASMK23HAP4A/AD8AP0A/CR0dACRYnQA/gCRASEA/gCRAvQA/gCRA4RmdNwEjCttxyR0AP9idAEhAP4A/gD8APwA/QD8AP8A/AD8AP0A/AOEZnTcBIwrbcckdHQAkWJ0ASEA/gCRAP4AkQL0AP4AkQOEZnTcBIwrbcckdAJLAT50AlIBQXQCU8l0dAJfdHQDpgL0A6YDpgOnA6cDpwOnA4RmdNwEjCttxyR0dACRYnQBIQOmAJEDpgCRAvQDpgCRA4RmdNwEjCttxyR0BDh0AJEEOQCRDpU5dSgCADR03gV2CwArdAEFAM5iCnR0AF1iAAYcOgp0dACRCnQAXAEIwWZ0CnRmdHQAkWZ0CnRmdEXgAFF03gp0dEY0tlT2u3SOAQTwscwhjZZKrhYcBSfFp9XNbKiVDOD2b+cpe4/Z17mQnbtzzhaeQtE2GGj0IDNTjRUSyTxxw/RPHW/+vS7d1NfRt9z9QPZg4X7QFfhCnkvgNPIItOsC2eV6hPannZNHlZ9xrwZXIMOlu3jSoQSq78WEjwLjw1ELSlF1aBvfzwk5ZX7AUvQzjPQKbDuQ+sm4wNOp4A6AdVuRS0t1y/DZpg4R6m7FNjM9HgvW7Bi88zaMjOo6lM8wtBBdj8LP4ylv3zCXPhebMKJc066o9sF71oFW/8JXu86HJbwDID5lzw5GWLR/LhT0Qqnp2JQxNZNfcbLIzPy+YypqRm/lBmGmex+82+PisxUumSeJkALIT6rJezxMH+CTJmQtt5uwTVbL3ptmjDUQzlSIvWi8Tl7ng1NpuRn1Ng4n14Qc+3Iil7OwkvNWogLSPkn3pihIFytyIGmMhOe3n1tWsuMy9BdKyqF4Z3v2SgggTL9KVvMXPnCbRe+oOuFFP3HejBG/w9gvmfNYvg6JuWia2lcSSN1uIjBktzoIazOHPJZ7kKHPz8mRWVdW3lA8WGF9dQF6Bm673boov3BUWDU2JNcahR23GtfHKLOz/viZ+rYnZFaIznXO67CYEJ1fXuTRpZhYZkKe54xeoagkNGLs+NTZHE0rX45/XvQ2RGADX6vcAvdxIUBV27wxGm2zjZo4X3ILgAlrOFheuZ6wtsvaIj4yLY7qqawlliaIcrz2G+c3vscAnCkCuMzMmZvMfu9lLwTvfX+3cVSyPdN9ZwgDZhfjRgNJcLiJ67b9xx8JHswprbiE3v9UphotAPIgnXVIN5KmMc0piXhc6cChPnN+MRhG9adtdttQTTwSIpl8I4/j//d3sz1326qTBTpPRM/Hgh3kzqEXs8ZAk4ErQhNO8hzrQ0DLkWMA/N+91tn2MdOJnWC2FCZehkQrwzwbKOjhvZsbM95QoeL9skYyMf4srVPVJSgg7pOLUtr/n9eT99oe9nLtFRpjA9okV2Kj8h9k5HaC0oivRD8VyXkJ81tcd4fHNXPCfloIQasxsuO18/46dR2jgul/UIet2G0kRvnyONMKhHs6J26FEoqSqd+rfYjeEGwHWVDpX1fh1jBBcKGMqRepju9Y00mDVHC+Xdij/j44rKfvfjGinNs1jO/0F3jB83XCDINN/HB84axlP+3E/klktRo+vl3U/aiyMJbIodE1XSsDn6UAzIoMtUObY2+k/4gY/l+AkZJ5Sj2vQrkyLm3FoxjhDX+31UXBFf9XrAH31fFqoBmDEZvhvvpnZ87N+oZEu7U9O/nnk+QWj3x8uyoRbEnf+O5UMr9i0nHP38IF5AvzrBW8YWBUR0mIAzIvndQq9N3v/Jto3aPjPXUPl8ASdPPyAp7jENf8bk7VMM9ol9XGmlBmeDMuGqt+WzuL6CXAxXjIhCPM5vACchgMJ/8XBGLO/D1isVvGhwwHHr1DLaI5mn2Jr/b1pUD90uciDaS8cXNDzCWvNmT/PhQe5e8nTnnnkt8Ds/SIjibcum/fqDhKopxAY8AkSrPn+IGDEKOO+U3XOP6djFs2H5N9+orhOahiQk5KnEUWa+CzkVzhp8bMHRbg81qhjjXuIKbHjSLSIBKWqockGtKinY+z4/RdBUF6pcc3JmnlxVcNgrI4SEzKUZSwcD2QCyxzKve+gAmg6ZuSRkpPFa6mfThu7LJNu3H5K42uCpNvPAsoedolKV/LHe/eJ+BbaG5MG0NaSGVPRUmNFMFFSSpXEcXwbVh7UETOZZtoVNRGOIbbkig3McEtR68cG0RZAoJevWYo7Dg/lZ1CQzblWeUvVHmr8fY4Nqd9JJiH/zEX24mJviH60fAyFr0A3c4bC1j3yZU60VgJxXn8JgJXLUIsiBnmKmMYz+7yBQFBvqb2eYnuW59joZBf56/wXvWIR4R8wTmV80i1mZy+S4+BUES+hzjk0uXpC///z/IlqHZ1monzlXp8aCfhGKMti73FI1KbL1q6IKO4fuBuZ59gagjn5xU79muMpHXg6S+e+gDM/U9BKLHbl9l6o8czQKl4RUkJJiqftQG2i3BMg/TQlUYFkJDYBOOvAugYuzYSDnZbDDd/aSd9x0Oe6F+bJcHfl9+gp6L5/TgA+BdFFovbfCrQ40s5vMPw8866pNX8zyFGeFWdxIpPVp9Rg1UPOVFbFZrvaFq/YAzHQgqMWpahMYfqHpmwXfHL1/kpYmGuHFwT55mQu0dylfNuq2Oq0hTMCPwqfxnuBIPLXfci4Y1ANy+1CUipQxld/izVh16WyG2Q0CQQ9NqtAnx1HCHwDj7sYxOSB0wopZSnOzxQOcExmxrVTF2BkOthVpGfuhaGECfCJpJKpjnihY+xOT2QJxN61+9K6QSqtv2Shr82I3jgJrqBg0wELFZPjvHpvzTtaJnLK6Vb97Yn933koO/saN7fsjwNKzp4l2lJVx2orjCGzC/4ZL4zCver6aQYtC5sdoychuFE6ufOiog+VWi5UDkbmvmtah/3aArEBIi39s5ILUnlFLgilcGuz9CQshEY7fw2ouoILAYPVT/gyAIq3TFAIwVsl+ktkRz/qGfnCDGrm5gsl/l9QdvCWGsjPz3dU7XuqKfdUrr/6XIgjp4rey6AJBmCmUJMjITHVdFb5m1p+dLMCL8t55zD42cmftmLEJC0Da04YiRCVUBLLa8D071/N5UBNBXDh0LFsmhV/5B5ExOB4j3WVG/S3lfK5o+V6ELHvy6RR9n4ac+VsK4VE4yphPvV+kG9FegTBH4ZRXL2HytUHCduJazB/KykjfetYxOXTLws267aGOd+I+JhKP//+VnXmS90OD/jvLcVu0asyqcuYN1mSb6XTlCkqv1vigZPIYwNF/zpWcT1GR/6aEIRjkh0yhg4LXJfaGobYJTY4JI58KiAKgmmgAKWdl5nYCeLqavRJGQNuYuZtZFGx+IkI4w4NS2xwbetNMunOjBu/hmKCI/w7tfiiyUd//4rbTeWt4izBY8YvGIN6vyKYmP/8X8wHKCeN+WRcKM70+tXKNGyevU9H2Dg5BsljnTf8YbsJ1TmMs74Ce2XlHisleguhyeg44rQOHZuw/6HTkhnnurK2d62q6yS7210SsAIaR+jXMQA+svkrLpsUY+F30Uw89uOdGAR6vo4FIME0EfVVeHTu6eKicfhSqOeXJhbftcd08sWEnNUL1C9fnprTgd83IMut8onVUF0hvqzZfHduPjbjwEXIcoYmy+P6tcJZHmeOv6VrvEdkHDJecjHuHeWANe79VG662qTjA/HCvumVv3qL+LrOcpqGps2ZGwQdFJ7PU4iuyRlBrwfO+xnPyr47s2cXVbWzAyznDiBGjCM3ksxjjqM62GE9C8f5U38kB3VjtabKp/nRdvMESPGDG90bWRLAt1Qk5DyLuazRR1YzdC1c+hZXvAWV8xA72S4A8B67vjVhbba3MMop293FeEXpe7zItMWrJG/LOH9ByOXmYnNJfjmfuX9KbrpgLOba4nZ+fl8Gbdv/ihv+6wFGKHCYrVwmhFC0J3V2bn2tIB1wCc1CST3d3X2OyxhguXcs4sm679UngzofuSeBewMFJboIQHbUh/m2JhW2hG9DIvG2t7yZIzKBTz9wBtnNC+2pCRYhSIuQ1j8xsz5VvqnyUIthvuoyyu7fNIrg/KQUVmGQaqkqZk/Vx5b33/gsEs8yX7SC1J+NV4icz6bvIE7C5G6McBaI8rVg56q5QBJWxn/87Q1sPK4+sQa8fLU5gXo4paaq4cOcQ4wR0VBHPGjKh+UlPCbA1nLXyEUX45qZ8J7/Ln4FPJE2TdzD0Z8MLSNQiykMMmSyOCiFfy84Rq60emYB2vD09KjYwsoIpeDcBDTElBbXxND72yhd9pC/1CMid/5HUMvAL27OtcIJDzNKpRPNqPOpyt2aPGz9QWIs9hQ9LiX5s8m9hjTUu/f7MyIatjjd+tSfQ3ufZxPpmJhTaBtZtKLUcfOCUqADuO+QoH8B9v6U+P0HV1GLQmtoNFTb3s74ivZgjES0qfK+8RdGgBbcCMSy8eBvh98+et1KIFqSe1KQPyXULBMTsIYnysIwiZBJYdI20vseV+wuJkcqGemehKjaAb9L57xZm3g2zX0bZ2xk/fU+bCo7TlnbW7JuF1YdURo/2Gw7VclDG1W7LOtas2LX4upifZ/23rzpsnY/ALfRgrcWP5hYmV9VxVOQA1fZvp9F2UNU+7d7xRyVm5wiLp3/0dlV7vdw1PMiZrbDAYzIVqEjRY2YU03sJhPnlwIPcZUG5ltL6S8XCxU1eYS5cjr34veBmXAvy7yN4ZjArIG0dfD/5UpBNlX1ZPoxJOwyqRi3wQWtOzd4oNKh0LkoTm8cwqgIfKhqqGOhwo71I+zXnMemTv2B2AUzABWyFztGgGULjDDzWYwJUVBTjKCn5K2QGMK1CQT7SzziOjo+BhAmqBjzuc3xYym2eedGeOIRJVyTwDw37iCMe4g5Vbnsb5ZBdxOAnMT7HU4DHpxWGuQ7GeiY30Cpbvzss55+5Km1YsbD5ea3NI9QNYIXol5apgSu9dZ8f8xS5dtHpido5BclDuLWY4lhik0tbJa07yJhH0BOyEut/GRbYTS6RfiTYWGMCkNpfSHi7HvdiTglEVHKZXaVhezH4kkXiIvKopYAlPusftpE4a5IZwvw1x/eLvoDIh/zpo9FiQInsTb2SAkKHV42XYBjpJDg4374XiVb3ws4qM0s9eSQ5HzsMU4OZJKuopFjBM+dAZEl8RUMx5uU2N486Kr141tVsGQfGjORYMCJAMsxELeNT4RmWjRcpdTGBwcx6XN9drWqPmJzcrGrH4+DRc7+n1w3kPZwu0BkNr6hQrqgo7JTB9A5kdJ/H7P4cWBMwsmuixAzJB3yrQpnGIq90lxAXLzDCdn1LPibsRt7rHNjgQBklRgPZ8vTbjXdgXrTWQsK5MdrXXQVPp0Rinq3frzZKJ0qD6Qhc40VzAraUXlob1gvkhK3vpmHgI6FRlQZNx6eRqkp0zy4AQlX813fAPtL3jMRaitGFFjo0zmErloC+h+YYdVQ6k4F/epxAoF0BmqEoKNTt6j4vQZNQ2BoqF9Vj53TOIoNmDiu9Xp15RkIgQIGcoLpfoIbenzpGUAtqFJp5W+LLnx38jHeECTJ/navKY1NWfN0sY1T8/pB8kIH3DU3DX+u6W3YwpypBMYOhbSxGjq84RZ84fWJow8pyHqn4S/9J15EcCMsXqrfwyd9mhiu3+rEo9pPpoJkdZqHjra4NvzFwuThNKy6hao/SlLw3ZADUcUp3w3SRVfW2rhl80zOgTYnKE0Hs2qp1J6H3xqPqIkvUDRMFDYyRbsFI3M9MEyovPk8rlw7/0a81cDVLmBsR2ze2pBuKb23fbeZC0uXoIvDppfTwIDxk1Oq2dGesGc+oJXWJLGkOha3CX+DUnzgAp9HGH9RsPZN63Hn4RMA5eSVhPHO+9RcRb/IOgtW31V1Q5IPGtoxPjC+MEJbVlIMYADd9aHYWUIQKopuPOHmoqSkubnAKnzgKHqgIOfW5RdAgotN6BN+O2ZYHkuemLnvQ8U9THVrS1RtLmKbcC7PeeDsYznvqzeg6VCNwmr0Yyx1wnLjyT84BZz3EJyCptD3yeueAyDWIs0L2qs/VQ3HUyqfrja0V1LdDzqAikeWuV4sc7RLIB69jEIBjCkyZedoUHqCrOvShVzyd73OdrJW0hPOuQv2qOoHDc9xVb6Yu6uq3Xqp2ZaH46A7lzevbxQEmfrzvAYSJuZ4WDk1Hz3QX1LVdiUK0EvlAGAYlG3Md30r7dcPN63yqBCIj25prpvZP0nI4+EgWoFG95V596CurXpKRBGRjQlHCvy5Ib/iW8nZJWwrET3mgd6mEhfP4KCuaLjopWs7h+MdXFdIv8dHQJgg1xi1eYqB0uDYjxwVmri0Sv5XKut/onqapC+FQiC2C1lvYJ9MVco6yDYsS3AANUfMtvtbYI2hfwZatiSsnoUeMZd34GVjkMMKA+XnjJpXgRW2SHTZplVowPmJsvXy6w3cfO1AK2dvtZEKTkC/TY9LFiKHCG0DnrMQdGm2lzlBHM9iEYynH2UcVMhUEjsc0oDBTgo2ZSQ1gzkAHeWeBXYFjYLuuf8yzTCy7/RFR81WDjXMbq2BOH5dURnxo6oivmxL3cKzKInlZkD31nvpHB9Kk7GfcfE1t+1V64b9LtgeJGlpRFxQCAqWJ5DoY77ski8gsOEOr2uywZaoO/NGa0X0y1pNQHBi3b2SUGNpcZxDT7rLbBf1FSnQ8guxGW3W+36BW0gBje4DOz6Ba6SVk0xiKgt+q2JOFyr4SYfnu+Ic1QZYIuwHBrgzr6UvOcSCzPTOo7D6IC4ISeS7zkl4h+2VoeHpnG/uWR3+ysNgPcOIXQbv0n4mr3BwQcdKJxgPSeyuP/z1Jjg4e9nUvoXegqQVIE30EHx5GHv+FAVUNTowYDJgyFhf5IvlYmEqRif6+WN1MkEJmDcQITx9FX23a4mxy1AQRsOHO/+eImX9l8EMJI3oPWzVXxSOeHU1dUWYr2uAA7AMb+vAEZSbU3qob9ibCyXeypEMpZ6863o6QPqlqGHZkuWABSTVNd4cOh9hv3qEpSx2Zy/DJMP6cItEmiBJ5PFqQnDEIt3NrA3COlOSgz43D7gpNFNJ5MBh4oFzhDPiglC2ypsNU4ISywY2erkyb1NC3Qh/IfWj0eDgZI4/ln8WPfBsT3meTjq1Uqt1E7Zl/qftqkx6aM9KueMCekSnMrcHj1CqTWWzEzPsZGcDe3Ue4Ws+XFYVxNbOFF8ezkvQGR6ZOtOLU2lQEnMBStx47vE6Pb7AYMBRj2OOfZXfisjJnpTfSNjo6sZ6qSvNxZNmDeS7Gk3yYyCk1HtKN2UnhMIjOXUzAqDv90lx9O/q/AT1ZMnit5XQe9wmQxnE/WSH0CqZ9/2Hy+Sfmpeg8RwsHI5Z8kC8H293m/LHVVM/BA7HaTJYg5Enk7M/xWpq0192ACfBai2LA/qrCjCr6Dh1BIMzMXINBmX96MJ5Hn2nxln/RXPFhwHxUmSV0EV2V0jm86/dxxuYSU1W7sVkEbN9EzkG0QFwPhyHKyb3t+Fj5WoUUTErcazE/N6EW6Lvp0d//SDPj7EV9UdJN+Amnf3Wwk3A0SlJ9Z00yvXZ7n3z70G47Hfsow8Wq1JXcfwnA+Yxa5mFsgV464KKP4T31wqIgzFPd3eCe3j5ory5fBF2hgCFyVFrLzI9eetNXvM7oQqyFgDo4CTp/hDV9NMX9JDHQ/nyHTLvZLNLF6ftn2OxjGm8+PqOwhxnPHWipkE/8wbtyri80Sr7pMNkQGMfo4ZYK9OcCC4ESVFFbLMIvlxSoRqWie0wxqnLfcLSXMSpMMQEJYDVObYsXIQNv4TGNwjq1kvT1UOkicTrG3IaBZ3XdScS3u8sgeZPVpOLkbiF940FjbCeNRINNvDbd01EPBrTCPpm12m43ze1bBB59Ia6Ovhnur/Nvx3IxwSWol+3H2qfCJR8df6aQf4v6WiONxkK+IqT4pKQrZK/LplgDI/PJZbOep8dtbV7oCr6CgfpWa8NczOkPx81iSHbsNhVSJBOtrLIMrL31LK9TqHqAbAHe0RLmmV806kRLDLNEhUEJfm9u0sxpkL93Zgd6rw+tqBfTMi59xqXHLXSHwSbSBl0EK0+loECOPtrl+/nsaFe197di4yUgoe4jKoAJDXc6DGDjrQOoFDWZJ9HXwt8xDrQP+7aRwWKWI1GF8s8O4KzxWBBcwnl3vnl1Oez3oh6Ea1vjR7/z7DDTrFtqU2W/KAEzAuXDNZ7MY73MF216dzdSbWmUp4lcm7keJfWaMHgut9x5C9mj66Z0lJ+yhsjVvyiWrfk1lzPOTdhG15Y7gQlXtacvI7qv/XNSscDwqkgwHT/gUsD5yB7LdRRvJxQGYINn9hTpodKFVSTPrtGvyQw+HlRFXIkodErAGu9Iy1YpfSPc3jkFh5CX3lPxv7aqjE/JAfTIpEjGb/H7MO0e2vsViSW1qa/Lmi4/n4DEI3g7lYrcanspDfEpKkdV1OjSLOy0BCUqVoECaB55vs06rXl4jqmLsPsFM/7vYJ0vrBhDCm/00A/H81l1uekJ/6Lml3Hb9+NKiLqATJmDpyzfYZFHumEjC662L0Bwkxi7E9U4cQA0XMVDuMYAIeLMPgQaMVOd8fmt5SflFIfuBoszeAw7ow5gXPE2Y/yBc/7jExARUf/BxIHQBF5Sn3i61w4z5xJdCyO1F1X3+3ax+JSvMeZ7S6QSKp1Fp/sjYz6Z+VgCZzibGeEoujryfMulH7Rai5kAft9ebcW50DyJr2uo2z97mTWIu45YsSnNSMrrNUuG1XsYBtD9TDYzQffKB87vWbkM4EbPAFgoBV4GQS+vtFDUqOFAoi1nTtmIOvg38N4hT2Sn8r8clmBCXspBlMBYTnrqFJGBT3wZOzAyJDre9dHH7+x7qaaKDOB4UQALD5ecS0DE4obubQEiuJZ0EpBVpLuYcce8Aa4PYd/V4DLDAJBYKQPCWTcrEaZ5HYbJi11Gd6hjGom1ii18VHYnG28NKpkz2UKVPxlhYSp8uZr367iOmoy7zsxehW9wzcy2zG0a80PBMCRQMb32hnaHeOR8fnNDzZhaNYhkOdDsBUZ3loDMa1YP0uS0cjUP3b/6DBlqmZOeNABDsLl5BI5QJups8uxAuWJdkUB/pO6Zax6tsg7fN5mjjDgMGngO+DPcKqiHIDbFIGudxtPTIyDi9SFMKBDcfdGQRv41q1AqmxgkVfJMnP8w/Bc7N9/TR6C7mGObFqFkIEom8sKi2xYqJLTCHK7cxzaZvqODo22c3wisBCP4HeAgcRbNPAsBkNRhSmD48dHupdBRw4mIvtS5oeF6zeT1KMCyhMnmhpkFAGWnGscoNkwvQ8ZM5lE/vgTHFYL99OuNxdFBxTEDd5v2qLR8y9WkXsWgG6kZNndFG+pO/UAkOCipqIhL3hq7cRSdrCq7YhUsTocEcnaFa6nVkhnSeRYUA1YO0z5itF9Sly3VlxYDw239TJJH6f3EUfYO5lb7bcFcz8Bp7Oo8QmnsUHOz/fagVUBtKEw1iT88j+aKkv8cscKNkMxjYr8344D1kFoZ7/td1W6LCNYN594301tUGRmFjAzeRg5vyoM1F6+bJZ/Q54jN/k8SFd3DxPTYaAUsivsBfgTn7Mx8H2SpPt4GOdYRnEJOH6jHM2p6SgB0gzIRq6fHxGMmSmqaPCmlfwxiuloaVIitLGN8wie2CDWhkzLoCJcODh7KIOAqbHEvXdUxaS4TTTs07Clzj/6GmVs9kiZDerMxEnhUB6QQPlcfqkG9882RqHoLiHGBoHfQuXIsAG8GTAtao2KVwRnvvam8jo1e312GQAKWEa4sUVEAMG4G6ckcONDwRcg1e2D3+ohXgY4UAWF8wHKQMrSnzCgfFpsxh+aHXMGtPQroQasRY4U6UdG0rz1Vjbka0MekOGRZQEvqQFlxseFor8zWFgHek3v29+WqN6gaK5gZOTOMZzpQIC1201LkMCXild3vWXSc5UX9xcFYfbRPzGFa1FDcPfPB/jUEq/FeGt419CI3YmBlVoHsa4KdcwQP5ZSwHHhFJ7/Ph/Rap/4vmG91eDwPP0lDfCDRCLszTqfzM71xpmiKi2HwS4WlqvGNwtvwF5Dqpn6KTq8ax00UMPkxDcZrEEEsIvHiUXXEphdb4GB4FymlPwBz4Gperqq5pW7TQ6/yNRhW8VT5NhuP0udlxo4gILq5ZxAZk8ZGh3g4CqxJlPKY7AQxupfUcVpWT5VItp1+30UqoyP4wWsRo3olRRgkWZZ2ZN6VC3OZFeXB8NbnUrSdikNptD1QiGuKkr8EmSR/AK9Rw+FF3s5uwuPbvHGiPeFOViltMK7AUaOsq9+x9cndk3iJEE5LKZRlWJbKOZweROzmPNVPkjE3K/TyA57Rs68TkZ3MR8akKpm7cFjnjPd/DdkWjgYoKHSr5Wu5ssoBYU4acRs5g2DHxUmdq8VXOXRbunD8QN0LhgkssgahcdoYsNvuXGUK/KXD/7oFb+VGdhqIn02veuM5bLudJOc2Ky0GMaG4W/xWBxIJcL7yliJOXOpx0AkBqUgzlDczmLT4iILXDxxtRR1oZa2JWFgiAb43obrJnG/TZC2KSK2wqOzRZTXavZZFMb1f3bXvVaNaK828w9TO610gk8JNf3gMfETzXXsbcvRGCG9JWQZ6+cDPqc4466Yo2RcKH+PILeKOqtnlbInR3MmBeGG3FH10yzkybuqEC2HSQwpA0An7d9+73BkDUTm30bZmoP/RGbgFN+GrCOfADgqr0WbI1a1okpFms8iHYw9hm0zUvlEMivBRxModrbJJ+9/p3jUdQQ9BCtQdxnOGrT5dzRUmw0593/mbRSdBg0nRvRZM5/E16m7ZHmDEtWhwvfdZCZ8J8M12W0yRMszXamWfQTwIZ4ayYktrnscQuWr8idp3PjT2eF/jmtdhIfcpMnb+IfZY2FebW6UY/AK3jP4u3Tu4zE4qlnQgLFbM19EBIsNf7KhjdbqQ/D6yiDb+NlEi2SKD+ivXVUK8ib0oBo366gXkR8ZxGjpJIDcEgZPa9TcYe0TIbiPl/rPUQDu3XBJ9X/GNq3FAUsKsll57DzaGMrjcT+gctp+9MLYXCq+sqP81eVQ0r9lt+gcQfZbACRbEjvlMskztZG8gbC8Qn9tt26Q7y7nDrbZq/LEz7kR6Jc6pg3N9rVX8Y5MJrGlML9p9lU4jbTkKqCveeZUJjHB03m2KRKR2TytoFkTXOLg7keU1s1lrPMQJpoOKLuAAC+y1HlJucU6ysB5hsXhvSPPLq5J7JtnqHKZ4vYjC4Vy8153QY+6780xDuGARsGbOs1WqzH0QS765rnSKEbbKlkO8oI/VDwUd0is13tKpqILu1mDJFNy/iJAWcvDgjxvusIT+PGz3ST/J9r9Mtfd0jpaGeiLYIqXc7DiHSS8TcjFVksi66PEkxW1z6ujbLLUGNNYnzOWpH8BZGK4bCK7iR+MbIv8ncDAz1u4StN3vTTzewr9IQjk9wxFxn+6N1ddKs0vffJiS08N3a4G1SVrlZ97Q/M+8G9fe5AP6d9/Qq4WRnORVhofPIKEdCr3llspUfE0oKIIYoByBRPh+bX1HLS3JWGJRhIvE1aW4NTd8ePi4Z+kXb+Z8snYfSNcqijhAgVsx4RCM54cXUiYkjeBmmC4ajOHrChoELscJJC7+9jjMjw5BagZKlgRMiSNYz7h7vvZIoQqbtQmspc0cUk1G/73iXtSpROl5wtLgQi0mW2Ex8i3WULhcggx6E1LMVHUsdc9GHI1PH3U2Ko0PyGdn9KdVOLm7FPBui0i9a0HpA60MsewVE4z8CAt5d401Gv6zXlIT5Ybit1VIA0FCs7wtvYreru1fUyW3oLAZ/+aTnZrOcYRNVA8spoRtlRoWflsRClFcgzkqiHOrf0/SVw+EpVaFlJ0g4Kxq1MMOmiQdpMNpte8lMMQqm6cIFXlnGbfJllysKDi+0JJMotkqgIxOSQgU9dn/lWkeVf8nUm3iwX2Nl3WDw9i6AUK3vBAbZZrcJpDQ/N64AVwjT07Jef30GSSmtNu2WlW7YoyW2FlWfZFQUwk867EdLYKk9VG6JgEnBiBxkY7LMo4YLQJJlAo9l/oTvJkSARDF/XtyAzM8O2t3eT/iXa6wDN3WewNmQHdPfsxChU/KtLG2Mn8i4ZqKdSlIaBZadxJmRzVS/o4yA65RTSViq60oa395Lqw0pzY4SipwE0SXXsKV+GZraGSkr/RW08wPRvqvSUkYBMA9lPx4m24az+IHmCbXA+0faxTRE9wuGeO06DIXa6QlKJ3puIyiuAVfPr736vzo2pBirS+Vxel3TMm3JKhz9o2ZoRvaFVpIkykb0Hcm4oHFBMcNSNj7/4GJt43ogonY2Vg4nsDQIWxAcorpXACzgBqQPjYsE/VUpXpwNManEru4NwMCFPkXvMoqvoeLN3qyu/N1eWEHttMD65v19l/0kH2mR35iv/FI+yjoHJ9gPMz67af3Mq/BoWXqu3rphiWMXVkmnPSEkpGpUI2h1MThideGFEOK6YZHPwYzMBvpNC7+ZHxPb7epfefGyIB4JzO9DTNEYnDLVVHdQyvOEVefrk6Uv5kTQYVYWWdqrdcIl7yljwwIWdfQ/y+2QB3eR/qxYObuYyB4gTbo2in4PzarU1sO9nETkmj9/AoxDA+JM3GMqQtJR4jtduHtnoCLxd1gQUscHRB/MoRYIEsP2pDZ9KvHgtlk1iTbWWbHhohwFEYX7y51fUV2nuUmnoUcqnWIQAAgl9LTVX+Bc0QGNEhChxHR4YjfE51PUdGfsSFE6ck7BL3/hTf9jLq4G1IafINxOLKeAtO7quulYvH5YOBc+zX7CrMgWnW47/jfRsWnJjYYoE7xMfWV2HN2iyIqLI";
var $ed66406a997fd44d$var$FENCED = new Map([
    [
        8217,
        "apostrophe"
    ],
    [
        8260,
        "fraction slash"
    ],
    [
        12539,
        "middle dot"
    ]
]);
var $ed66406a997fd44d$var$NSM_MAX = 4;
function $ed66406a997fd44d$var$decode_arithmetic(bytes) {
    var pos = 0;
    function u16() {
        return bytes[pos++] << 8 | bytes[pos++];
    }
    // decode the frequency table
    var symbol_count = u16();
    var total = 1;
    var acc = [
        0,
        1
    ]; // first symbol has frequency 1
    for(var i = 1; i < symbol_count; i++)acc.push(total += u16());
    // skip the sized-payload that the last 3 symbols index into
    var skip = u16();
    var pos_payload = pos;
    pos += skip;
    var read_width = 0;
    var read_buffer = 0;
    function read_bit() {
        if (read_width == 0) {
            // this will read beyond end of buffer
            // but (undefined|0) => zero pad
            read_buffer = read_buffer << 8 | bytes[pos++];
            read_width = 8;
        }
        return read_buffer >> --read_width & 1;
    }
    var N = 31;
    var FULL = Math.pow(2, N);
    var HALF = FULL >>> 1;
    var QRTR = HALF >> 1;
    var MASK = FULL - 1;
    // fill register
    var register = 0;
    for(var i1 = 0; i1 < N; i1++)register = register << 1 | read_bit();
    var symbols = [];
    var low = 0;
    var range = FULL; // treat like a float
    while(true){
        var value = Math.floor(((register - low + 1) * total - 1) / range);
        var start = 0;
        var end = symbol_count;
        while(end - start > 1){
            var mid = start + end >>> 1;
            if (value < acc[mid]) end = mid;
            else start = mid;
        }
        if (start == 0) break; // first symbol is end mark
        symbols.push(start);
        var a = low + Math.floor(range * acc[start] / total);
        var b = low + Math.floor(range * acc[start + 1] / total) - 1;
        while(((a ^ b) & HALF) == 0){
            register = register << 1 & MASK | read_bit();
            a = a << 1 & MASK;
            b = b << 1 & MASK | 1;
        }
        while(a & ~b & QRTR){
            register = register & HALF | register << 1 & MASK >>> 1 | read_bit();
            a = a << 1 ^ HALF;
            b = (b ^ HALF) << 1 | HALF | 1;
        }
        low = a;
        range = 1 + b - a;
    }
    var offset = symbol_count - 4;
    return symbols.map(function(x) {
        switch(x - offset){
            case 3:
                return offset + 0x10100 + (bytes[pos_payload++] << 16 | bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 2:
                return offset + 0x100 + (bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 1:
                return offset + bytes[pos_payload++];
            default:
                return x - 1;
        }
    });
}
// returns an iterator which returns the next symbol
function $ed66406a997fd44d$var$read_payload(v) {
    var pos = 0;
    return function() {
        return v[pos++];
    };
}
function $ed66406a997fd44d$var$read_compressed_payload(s) {
    return $ed66406a997fd44d$var$read_payload($ed66406a997fd44d$var$decode_arithmetic($ed66406a997fd44d$var$unsafe_atob(s)));
}
// unsafe in the sense:
// expected well-formed Base64 w/o padding 
// 20220922: added for https://github.com/adraffy/ens-normalize.js/issues/4
function $ed66406a997fd44d$var$unsafe_atob(s) {
    var lookup = [];
    Array.from("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/").forEach(function(c, i) {
        return lookup[c.charCodeAt(0)] = i;
    });
    var n = s.length;
    var ret = new Uint8Array(6 * n >> 3);
    for(var i = 0, pos = 0, width = 0, carry = 0; i < n; i++){
        carry = carry << 6 | lookup[s.charCodeAt(i)];
        width += 6;
        if (width >= 8) ret[pos++] = carry >> (width -= 8);
    }
    return ret;
}
// eg. [0,1,2,3...] => [0,-1,1,-2,...]
function $ed66406a997fd44d$var$signed(i) {
    return i & 1 ? ~i >> 1 : i >> 1;
}
function $ed66406a997fd44d$var$read_deltas(n, next) {
    var v = Array(n);
    for(var i = 0, x = 0; i < n; i++)v[i] = x += $ed66406a997fd44d$var$signed(next());
    return v;
}
// [123][5] => [0 3] [1 1] [0 0]
function $ed66406a997fd44d$var$read_sorted(next) {
    var prev = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var ret = [];
    while(true){
        var x = next();
        var n = next();
        if (!n) break;
        prev += x;
        for(var i = 0; i < n; i++)ret.push(prev + i);
        prev += n + 1;
    }
    return ret;
}
function $ed66406a997fd44d$var$read_sorted_arrays(next) {
    return $ed66406a997fd44d$var$read_array_while(function() {
        var v = $ed66406a997fd44d$var$read_sorted(next);
        if (v.length) return v;
    });
}
// returns map of x => ys
function $ed66406a997fd44d$var$read_mapped(next) {
    var ret = [];
    while(true){
        var w = next();
        if (w == 0) break;
        ret.push($ed66406a997fd44d$var$read_linear_table(w, next));
    }
    while(true){
        var w1 = next() - 1;
        if (w1 < 0) break;
        ret.push($ed66406a997fd44d$var$read_replacement_table(w1, next));
    }
    return ret.flat();
}
// read until next is falsy
// return array of read values
function $ed66406a997fd44d$var$read_array_while(next) {
    var v = [];
    while(true){
        var x = next(v.length);
        if (!x) break;
        v.push(x);
    }
    return v;
}
// read w columns of length n
// return as n rows of length w
function $ed66406a997fd44d$var$read_transposed(n, w, next) {
    var m = Array(n).fill().map(function() {
        return [];
    });
    for(var i = 0; i < w; i++)$ed66406a997fd44d$var$read_deltas(n, next).forEach(function(x, j) {
        return m[j].push(x);
    });
    return m;
}
// returns [[x, ys], [x+dx, ys+dy], [x+2*dx, ys+2*dy], ...]
// where dx/dy = steps, n = run size, w = length of y
function $ed66406a997fd44d$var$read_linear_table(w, next) {
    var dx = 1 + next();
    var dy = next();
    var vN = $ed66406a997fd44d$var$read_array_while(next);
    var m = $ed66406a997fd44d$var$read_transposed(vN.length, 1 + w, next);
    return m.flatMap(function(v, i) {
        var _v = (0, $gdHfP._)(v), x = _v[0], ys = _v.slice(1);
        return Array(vN[i]).fill().map(function(_, j) {
            var j_dy = j * dy;
            return [
                x + j * dx,
                ys.map(function(y) {
                    return y + j_dy;
                })
            ];
        });
    });
}
// return [[x, ys...], ...]
// where w = length of y
function $ed66406a997fd44d$var$read_replacement_table(w, next) {
    var n = 1 + next();
    var m = $ed66406a997fd44d$var$read_transposed(n, 1 + w, next);
    return m.map(function(v) {
        return [
            v[0],
            v.slice(1)
        ];
    });
}
function $ed66406a997fd44d$var$read_trie(next) {
    var ret = [];
    var sorted = $ed66406a997fd44d$var$read_sorted(next);
    expand(decode([]), []);
    return ret; // not sorted
    function decode(Q) {
        var S = next(); // state: valid, save, check
        var B = $ed66406a997fd44d$var$read_array_while(function() {
            var cps = $ed66406a997fd44d$var$read_sorted(next).map(function(i) {
                return sorted[i];
            });
            if (cps.length) return decode(cps);
        });
        return {
            S: S,
            B: B,
            Q: Q
        };
    }
    function expand(param, cps, saved) {
        var S = param.S, B = param.B;
        if (S & 4 && saved === cps[cps.length - 1]) return;
        if (S & 2) saved = cps[cps.length - 1];
        if (S & 1) ret.push(cps);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator = B[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                var br = _step.value;
                try {
                    for(var _iterator1 = br.Q[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                        var cp = _step1.value;
                        expand(br, (0, $c6Xmf._)(cps).concat([
                            cp
                        ]), saved);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
}
function $ed66406a997fd44d$var$hex_cp(cp) {
    return cp.toString(16).toUpperCase().padStart(2, "0");
}
function $ed66406a997fd44d$var$quote_cp(cp) {
    return "{".concat($ed66406a997fd44d$var$hex_cp(cp), "}"); // raffy convention: like "\u{X}" w/o the "\u"
}
/*
export function explode_cp(s) {
	return [...s].map(c => c.codePointAt(0));
}
*/ function $ed66406a997fd44d$var$explode_cp(s) {
    var cps = [];
    for(var pos = 0, len = s.length; pos < len;){
        var cp = s.codePointAt(pos);
        pos += cp < 0x10000 ? 1 : 2;
        cps.push(cp);
    }
    return cps;
}
function $ed66406a997fd44d$var$str_from_cps(cps) {
    var _String, _String1;
    var chunk = 4096;
    var len = cps.length;
    if (len < chunk) return (_String = String).fromCodePoint.apply(_String, (0, $c6Xmf._)(cps));
    var buf = [];
    for(var i = 0; i < len;)buf.push((_String1 = String).fromCodePoint.apply(_String1, (0, $c6Xmf._)(cps.slice(i, i += chunk))));
    return buf.join("");
}
function $ed66406a997fd44d$var$compare_arrays(a, b) {
    var n = a.length;
    var c = n - b.length;
    for(var i = 0; c == 0 && i < n; i++)c = a[i] - b[i];
    return c;
}
// created 2023-09-12T22:05:14.211Z
// compressed base64-encoded blob for include-nf data
// source: https://github.com/adraffy/ens-normalize.js/blob/main/src/make.js
// see: https://github.com/adraffy/ens-normalize.js#security
// SHA-256: a974b6f8541fc29d919bc85118af0a44015851fab5343f8679cb31be2bdb209e
var $ed66406a997fd44d$var$COMPRESSED = "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";
// https://unicode.org/reports/tr15/
// for reference implementation
// see: /derive/nf.js
// algorithmic hangul
// https://www.unicode.org/versions/Unicode15.0.0/ch03.pdf (page 144)
var $ed66406a997fd44d$var$S0 = 0xAC00;
var $ed66406a997fd44d$var$L0 = 0x1100;
var $ed66406a997fd44d$var$V0 = 0x1161;
var $ed66406a997fd44d$var$T0 = 0x11A7;
var $ed66406a997fd44d$var$L_COUNT = 19;
var $ed66406a997fd44d$var$V_COUNT = 21;
var $ed66406a997fd44d$var$T_COUNT = 28;
var $ed66406a997fd44d$var$N_COUNT = $ed66406a997fd44d$var$V_COUNT * $ed66406a997fd44d$var$T_COUNT;
var $ed66406a997fd44d$var$S_COUNT = $ed66406a997fd44d$var$L_COUNT * $ed66406a997fd44d$var$N_COUNT;
var $ed66406a997fd44d$var$S1 = $ed66406a997fd44d$var$S0 + $ed66406a997fd44d$var$S_COUNT;
var $ed66406a997fd44d$var$L1 = $ed66406a997fd44d$var$L0 + $ed66406a997fd44d$var$L_COUNT;
var $ed66406a997fd44d$var$V1 = $ed66406a997fd44d$var$V0 + $ed66406a997fd44d$var$V_COUNT;
var $ed66406a997fd44d$var$T1 = $ed66406a997fd44d$var$T0 + $ed66406a997fd44d$var$T_COUNT;
function $ed66406a997fd44d$var$unpack_cc(packed) {
    return packed >> 24 & 0xFF;
}
function $ed66406a997fd44d$var$unpack_cp(packed) {
    return packed & 0xFFFFFF;
}
var $ed66406a997fd44d$var$SHIFTED_RANK, $ed66406a997fd44d$var$EXCLUSIONS, $ed66406a997fd44d$var$DECOMP, $ed66406a997fd44d$var$RECOMP;
function $ed66406a997fd44d$var$init$1() {
    //console.time('nf');
    var r = $ed66406a997fd44d$var$read_compressed_payload($ed66406a997fd44d$var$COMPRESSED);
    $ed66406a997fd44d$var$SHIFTED_RANK = new Map($ed66406a997fd44d$var$read_sorted_arrays(r).flatMap(function(v, i) {
        return v.map(function(x) {
            return [
                x,
                i + 1 << 24
            ];
        });
    })); // pre-shifted
    $ed66406a997fd44d$var$EXCLUSIONS = new Set($ed66406a997fd44d$var$read_sorted(r));
    $ed66406a997fd44d$var$DECOMP = new Map();
    $ed66406a997fd44d$var$RECOMP = new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $ed66406a997fd44d$var$read_mapped(r)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $cv9Rk._)(_step.value, 2), cp = _step_value[0], cps = _step_value[1];
            if (!$ed66406a997fd44d$var$EXCLUSIONS.has(cp) && cps.length == 2) {
                var _cps = (0, $cv9Rk._)(cps, 2), a = _cps[0], b = _cps[1];
                var bucket = $ed66406a997fd44d$var$RECOMP.get(a);
                if (!bucket) {
                    bucket = new Map();
                    $ed66406a997fd44d$var$RECOMP.set(a, bucket);
                }
                bucket.set(b, cp);
            }
            $ed66406a997fd44d$var$DECOMP.set(cp, cps.reverse()); // stored reversed
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
//console.timeEnd('nf');
// 20230905: 11ms
}
function $ed66406a997fd44d$var$is_hangul(cp) {
    return cp >= $ed66406a997fd44d$var$S0 && cp < $ed66406a997fd44d$var$S1;
}
function $ed66406a997fd44d$var$compose_pair(a, b) {
    if (a >= $ed66406a997fd44d$var$L0 && a < $ed66406a997fd44d$var$L1 && b >= $ed66406a997fd44d$var$V0 && b < $ed66406a997fd44d$var$V1) return $ed66406a997fd44d$var$S0 + (a - $ed66406a997fd44d$var$L0) * $ed66406a997fd44d$var$N_COUNT + (b - $ed66406a997fd44d$var$V0) * $ed66406a997fd44d$var$T_COUNT;
    else if ($ed66406a997fd44d$var$is_hangul(a) && b > $ed66406a997fd44d$var$T0 && b < $ed66406a997fd44d$var$T1 && (a - $ed66406a997fd44d$var$S0) % $ed66406a997fd44d$var$T_COUNT == 0) return a + (b - $ed66406a997fd44d$var$T0);
    else {
        var recomp = $ed66406a997fd44d$var$RECOMP.get(a);
        if (recomp) {
            recomp = recomp.get(b);
            if (recomp) return recomp;
        }
        return -1;
    }
}
function $ed66406a997fd44d$var$decomposed(cps) {
    if (!$ed66406a997fd44d$var$SHIFTED_RANK) $ed66406a997fd44d$var$init$1();
    var ret = [];
    var buf = [];
    var check_order = false;
    function add(cp) {
        var cc = $ed66406a997fd44d$var$SHIFTED_RANK.get(cp);
        if (cc) {
            check_order = true;
            cp |= cc;
        }
        ret.push(cp);
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = cps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var cp = _step.value;
            while(true){
                if (cp < 0x80) ret.push(cp);
                else if ($ed66406a997fd44d$var$is_hangul(cp)) {
                    var s_index = cp - $ed66406a997fd44d$var$S0;
                    var l_index = s_index / $ed66406a997fd44d$var$N_COUNT | 0;
                    var v_index = s_index % $ed66406a997fd44d$var$N_COUNT / $ed66406a997fd44d$var$T_COUNT | 0;
                    var t_index = s_index % $ed66406a997fd44d$var$T_COUNT;
                    add($ed66406a997fd44d$var$L0 + l_index);
                    add($ed66406a997fd44d$var$V0 + v_index);
                    if (t_index > 0) add($ed66406a997fd44d$var$T0 + t_index);
                } else {
                    var _buf;
                    var mapped = $ed66406a997fd44d$var$DECOMP.get(cp);
                    if (mapped) (_buf = buf).push.apply(_buf, (0, $c6Xmf._)(mapped));
                    else add(cp);
                }
                if (!buf.length) break;
                cp = buf.pop();
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (check_order && ret.length > 1) {
        var prev_cc = $ed66406a997fd44d$var$unpack_cc(ret[0]);
        for(var i = 1; i < ret.length; i++){
            var cc = $ed66406a997fd44d$var$unpack_cc(ret[i]);
            if (cc == 0 || prev_cc <= cc) {
                prev_cc = cc;
                continue;
            }
            var j = i - 1;
            while(true){
                var tmp = ret[j + 1];
                ret[j + 1] = ret[j];
                ret[j] = tmp;
                if (!j) break;
                prev_cc = $ed66406a997fd44d$var$unpack_cc(ret[--j]);
                if (prev_cc <= cc) break;
            }
            prev_cc = $ed66406a997fd44d$var$unpack_cc(ret[i]);
        }
    }
    return ret;
}
function $ed66406a997fd44d$var$composed_from_decomposed(v) {
    var _ret;
    var ret = [];
    var stack = [];
    var prev_cp = -1;
    var prev_cc = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = v[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var packed = _step.value;
            var cc = $ed66406a997fd44d$var$unpack_cc(packed);
            var cp = $ed66406a997fd44d$var$unpack_cp(packed);
            if (prev_cp == -1) {
                if (cc == 0) prev_cp = cp;
                else ret.push(cp);
            } else if (prev_cc > 0 && prev_cc >= cc) {
                if (cc == 0) {
                    var _ret1;
                    (_ret1 = ret).push.apply(_ret1, [
                        prev_cp
                    ].concat((0, $c6Xmf._)(stack)));
                    stack.length = 0;
                    prev_cp = cp;
                } else stack.push(cp);
                prev_cc = cc;
            } else {
                var composed = $ed66406a997fd44d$var$compose_pair(prev_cp, cp);
                if (composed >= 0) prev_cp = composed;
                else if (prev_cc == 0 && cc == 0) {
                    ret.push(prev_cp);
                    prev_cp = cp;
                } else {
                    stack.push(cp);
                    prev_cc = cc;
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (prev_cp >= 0) (_ret = ret).push.apply(_ret, [
        prev_cp
    ].concat((0, $c6Xmf._)(stack)));
    return ret;
}
// note: cps can be iterable
function $ed66406a997fd44d$export$9d0d896b286a3dba(cps) {
    return $ed66406a997fd44d$var$decomposed(cps).map($ed66406a997fd44d$var$unpack_cp);
}
function $ed66406a997fd44d$export$f42252642e08449(cps) {
    return $ed66406a997fd44d$var$composed_from_decomposed($ed66406a997fd44d$var$decomposed(cps));
}
var $ed66406a997fd44d$var$HYPHEN = 0x2D;
var $ed66406a997fd44d$var$STOP = 0x2E;
var $ed66406a997fd44d$var$STOP_CH = ".";
var $ed66406a997fd44d$var$FE0F = 0xFE0F;
var $ed66406a997fd44d$var$UNIQUE_PH = 1;
// 20230913: replace [...v] with Array_from(v) to avoid large spreads
var $ed66406a997fd44d$var$Array_from = function(x) {
    return Array.from(x);
}; // Array.from.bind(Array);
function $ed66406a997fd44d$var$group_has_cp(g, cp) {
    // 20230913: keep primary and secondary distinct instead of creating valid union
    return g.P.has(cp) || g.Q.has(cp);
}
var $ed66406a997fd44d$var$Emoji = /*#__PURE__*/ function(Array1) {
    "use strict";
    (0, $dcsZi._)(Emoji, Array1);
    var _super = (0, $ohfOJ._)(Emoji);
    function Emoji() {
        (0, $4GJKx._)(this, Emoji);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(Emoji, [
        {
            key: "is_emoji",
            get: function get() {
                return true;
            } // free tagging system
        }
    ]);
    return Emoji;
}((0, $FuVm8._)(Array));
var $ed66406a997fd44d$var$MAPPED, $ed66406a997fd44d$var$IGNORED, $ed66406a997fd44d$var$CM, $ed66406a997fd44d$var$NSM, $ed66406a997fd44d$var$ESCAPE, $ed66406a997fd44d$var$NFC_CHECK, $ed66406a997fd44d$var$GROUPS, $ed66406a997fd44d$var$WHOLE_VALID, $ed66406a997fd44d$var$WHOLE_MAP, $ed66406a997fd44d$var$VALID, $ed66406a997fd44d$var$EMOJI_LIST, $ed66406a997fd44d$var$EMOJI_ROOT;
function $ed66406a997fd44d$var$init() {
    if ($ed66406a997fd44d$var$MAPPED) return;
    var r = $ed66406a997fd44d$var$read_compressed_payload($ed66406a997fd44d$var$COMPRESSED$1);
    var read_sorted_array = function() {
        return $ed66406a997fd44d$var$read_sorted(r);
    };
    var read_sorted_set = function() {
        return new Set(read_sorted_array());
    };
    $ed66406a997fd44d$var$MAPPED = new Map($ed66406a997fd44d$var$read_mapped(r));
    $ed66406a997fd44d$var$IGNORED = read_sorted_set(); // ignored characters are not valid, so just read raw codepoints
    /*
	// direct include from payload is smaller than the decompression code
	const FENCED = new Map(read_array_while(() => {
		let cp = r();
		if (cp) return [cp, read_str(r())];
	}));
	*/ // 20230217: we still need all CM for proper error formatting
    // but norm only needs NSM subset that are potentially-valid
    $ed66406a997fd44d$var$CM = read_sorted_array();
    $ed66406a997fd44d$var$NSM = new Set(read_sorted_array().map(function(i) {
        return $ed66406a997fd44d$var$CM[i];
    }));
    $ed66406a997fd44d$var$CM = new Set($ed66406a997fd44d$var$CM);
    $ed66406a997fd44d$var$ESCAPE = read_sorted_set(); // characters that should not be printed
    $ed66406a997fd44d$var$NFC_CHECK = read_sorted_set(); // only needed to illustrate ens_tokenize() transformations
    var chunks = $ed66406a997fd44d$var$read_sorted_arrays(r);
    var unrestricted = r();
    var read_chunked = function() {
        return new Set(read_sorted_array().flatMap(function(i) {
            return chunks[i];
        }).concat(read_sorted_array()));
    };
    $ed66406a997fd44d$var$GROUPS = $ed66406a997fd44d$var$read_array_while(function(i) {
        // minifier property mangling seems unsafe
        // so these are manually renamed to single chars
        var N = $ed66406a997fd44d$var$read_array_while(r).map(function(x) {
            return x + 0x60;
        });
        if (N.length) {
            var R = i >= unrestricted; // first arent restricted
            N[0] -= 32; // capitalize
            N = $ed66406a997fd44d$var$str_from_cps(N);
            if (R) N = "Restricted[".concat(N, "]");
            var P = read_chunked(); // primary
            var Q = read_chunked(); // secondary
            var M = !r(); // not-whitelisted, check for NSM
            // *** this code currently isn't needed ***
            /*
			let V = [...P, ...Q].sort((a, b) => a-b); // derive: sorted valid
			let M = r()-1; // number of combining mark
			if (M < 0) { // whitelisted
				M = new Map(read_array_while(() => {
					let i = r();
					if (i) return [V[i-1], read_array_while(() => {
						let v = read_array_while(r);
						if (v.length) return v.map(x => x-1);
					})];
				}));
			}*/ return {
                N: N,
                P: P,
                Q: Q,
                M: M,
                R: R
            };
        }
    });
    // decode compressed wholes
    $ed66406a997fd44d$var$WHOLE_VALID = read_sorted_set();
    $ed66406a997fd44d$var$WHOLE_MAP = new Map();
    var wholes = read_sorted_array().concat($ed66406a997fd44d$var$Array_from($ed66406a997fd44d$var$WHOLE_VALID)).sort(function(a, b) {
        return a - b;
    }); // must be sorted
    wholes.forEach(function(cp, i) {
        var d = r();
        var w = wholes[i] = d ? wholes[i - d] : {
            V: [],
            M: new Map()
        };
        w.V.push(cp); // add to member set
        if (!$ed66406a997fd44d$var$WHOLE_VALID.has(cp)) $ed66406a997fd44d$var$WHOLE_MAP.set(cp, w); // register with whole map
    });
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = _step.value, V = _step_value.V, M = _step_value.M;
            // connect all groups that have each whole character
            var recs = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                var _loop = function() {
                    var cp = _step1.value;
                    var gs = $ed66406a997fd44d$var$GROUPS.filter(function(g) {
                        return $ed66406a997fd44d$var$group_has_cp(g, cp);
                    });
                    var rec = recs.find(function(param) {
                        var G = param.G;
                        return gs.some(function(g) {
                            return G.has(g);
                        });
                    });
                    if (!rec) {
                        rec = {
                            G: new Set(),
                            V: []
                        };
                        recs.push(rec);
                    }
                    rec.V.push(cp);
                    gs.forEach(function(g) {
                        return rec.G.add(g);
                    });
                };
                for(var _iterator = V[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            // per character cache groups which are not a member of the extent
            var union = recs.flatMap(function(x) {
                return $ed66406a997fd44d$var$Array_from(x.G);
            });
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                var _loop1 = function() {
                    var _step_value = _step2.value, G = _step_value.G, V = _step_value.V;
                    var complement = new Set(union.filter(function(g) {
                        return !G.has(g);
                    }));
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = V[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var cp = _step.value;
                            M.set(cp, complement);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                };
                for(var _iterator1 = recs[Symbol.iterator](), _step2; !(_iteratorNormalCompletion1 = (_step2 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop1();
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        };
        // compute confusable-extent complements
        for(var _iterator = new Set($ed66406a997fd44d$var$WHOLE_MAP.values())[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // compute valid set
    var union = new Set(); // exists in 1+ groups
    var multi = new Set(); // exists in 2+ groups
    var add_to_union = function(cp) {
        return union.has(cp) ? multi.add(cp) : union.add(cp);
    };
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = $ed66406a997fd44d$var$GROUPS[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var g = _step1.value;
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            try {
                for(var _iterator2 = g.P[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var cp = _step2.value;
                    add_to_union(cp);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
            var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
            try {
                for(var _iterator3 = g.Q[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                    var cp1 = _step3.value;
                    add_to_union(cp1);
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                        _iterator3.return();
                    }
                } finally{
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    var _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
    try {
        // dual purpose WHOLE_MAP: return placeholder if unique non-confusable
        for(var _iterator4 = union[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
            var cp2 = _step4.value;
            if (!$ed66406a997fd44d$var$WHOLE_MAP.has(cp2) && !multi.has(cp2)) $ed66406a997fd44d$var$WHOLE_MAP.set(cp2, $ed66406a997fd44d$var$UNIQUE_PH);
        }
    } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                _iterator4.return();
            }
        } finally{
            if (_didIteratorError4) {
                throw _iteratorError4;
            }
        }
    }
    $ed66406a997fd44d$var$VALID = new Set($ed66406a997fd44d$var$Array_from(union).concat($ed66406a997fd44d$var$Array_from($ed66406a997fd44d$export$9d0d896b286a3dba(union)))); // possibly valid
    // decode emoji
    // 20230719: emoji are now fully-expanded to avoid quirk logic 
    $ed66406a997fd44d$var$EMOJI_LIST = $ed66406a997fd44d$var$read_trie(r).map(function(v) {
        return $ed66406a997fd44d$var$Emoji.from(v);
    }).sort($ed66406a997fd44d$var$compare_arrays);
    $ed66406a997fd44d$var$EMOJI_ROOT = new Map(); // this has approx 7K nodes (2+ per emoji)
    var _iteratorNormalCompletion5 = true, _didIteratorError5 = false, _iteratorError5 = undefined;
    try {
        var _loop1 = function() {
            var cps = _step5.value;
            // 20230719: change to *slightly* stricter algorithm which disallows 
            // insertion of misplaced FE0F in emoji sequences (matching ENSIP-15)
            // example: beautified [A B] (eg. flag emoji) 
            //  before: allow: [A FE0F B], error: [A FE0F FE0F B] 
            //   after: error: both
            // note: this code now matches ENSNormalize.{cs,java} logic
            var prev = [
                $ed66406a997fd44d$var$EMOJI_ROOT
            ];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                var _loop = function() {
                    var cp = _step.value;
                    var _prev;
                    var next = prev.map(function(node) {
                        var child = node.get(cp);
                        if (!child) {
                            // should this be object? 
                            // (most have 1-2 items, few have many)
                            // 20230719: no, v8 default map is 4?
                            child = new Map();
                            node.set(cp, child);
                        }
                        return child;
                    });
                    if (cp === $ed66406a997fd44d$var$FE0F) (_prev = prev).push.apply(_prev, (0, $c6Xmf._)(next)); // less than 20 elements
                    else prev = next;
                };
                for(var _iterator = cps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = prev[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var x = _step1.value;
                    x.V = cps;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        };
        for(var _iterator5 = $ed66406a997fd44d$var$EMOJI_LIST[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true)_loop1();
    } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                _iterator5.return();
            }
        } finally{
            if (_didIteratorError5) {
                throw _iteratorError5;
            }
        }
    }
}
// if escaped: {HEX}
//       else: "x" {HEX}
function $ed66406a997fd44d$var$quoted_cp(cp) {
    return ($ed66406a997fd44d$export$4b1c9c18c687e5e9(cp) ? "" : "".concat($ed66406a997fd44d$var$bidi_qq($ed66406a997fd44d$export$6ec6f9a7f89f00db([
        cp
    ])), " ")) + $ed66406a997fd44d$var$quote_cp(cp);
}
// 20230211: some messages can be mixed-directional and result in spillover
// use 200E after a quoted string to force the remainder of a string from 
// acquring the direction of the quote
// https://www.w3.org/International/questions/qa-bidi-unicode-controls#exceptions
function $ed66406a997fd44d$var$bidi_qq(s) {
    return '"'.concat(s, '"\u200E'); // strong LTR
}
function $ed66406a997fd44d$var$check_label_extension(cps) {
    if (cps.length >= 4 && cps[2] == $ed66406a997fd44d$var$HYPHEN && cps[3] == $ed66406a997fd44d$var$HYPHEN) throw new Error('invalid label extension: "'.concat($ed66406a997fd44d$var$str_from_cps(cps.slice(0, 4)), '"'));
}
function $ed66406a997fd44d$var$check_leading_underscore(cps) {
    var UNDERSCORE = 0x5F;
    for(var i = cps.lastIndexOf(UNDERSCORE); i > 0;){
        if (cps[--i] !== UNDERSCORE) throw new Error("underscore allowed only at start");
    }
}
// check that a fenced cp is not leading, trailing, or touching another fenced cp
function $ed66406a997fd44d$var$check_fenced(cps) {
    var cp = cps[0];
    var prev = $ed66406a997fd44d$var$FENCED.get(cp);
    if (prev) throw $ed66406a997fd44d$var$error_placement("leading ".concat(prev));
    var n = cps.length;
    var last = -1; // prevents trailing from throwing
    for(var i = 1; i < n; i++){
        cp = cps[i];
        var match = $ed66406a997fd44d$var$FENCED.get(cp);
        if (match) {
            // since cps[0] isn't fenced, cps[1] cannot throw
            if (last == i) throw $ed66406a997fd44d$var$error_placement("".concat(prev, " + ").concat(match));
            last = i + 1;
            prev = match;
        }
    }
    if (last == n) throw $ed66406a997fd44d$var$error_placement("trailing ".concat(prev));
}
// create a safe to print string 
// invisibles are escaped
// leading cm uses placeholder
// quoter(cp) => string, eg. 3000 => "{3000}"
// note: in html, you'd call this function then replace [<>&] with entities
function $ed66406a997fd44d$export$6ec6f9a7f89f00db(cps) {
    var quoter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $ed66406a997fd44d$var$quote_cp;
    //if (Number.isInteger(cps)) cps = [cps];
    //if (!Array.isArray(cps)) throw new TypeError(`expected codepoints`);
    var buf = [];
    if ($ed66406a997fd44d$export$e29a9e4d2573411c(cps[0])) buf.push("\u25CC");
    var prev = 0;
    var n = cps.length;
    for(var i = 0; i < n; i++){
        var cp = cps[i];
        if ($ed66406a997fd44d$export$4b1c9c18c687e5e9(cp)) {
            buf.push($ed66406a997fd44d$var$str_from_cps(cps.slice(prev, i)));
            buf.push(quoter(cp));
            prev = i + 1;
        }
    }
    buf.push($ed66406a997fd44d$var$str_from_cps(cps.slice(prev, n)));
    return buf.join("");
}
// note: set(s) cannot be exposed because they can be modified
// note: Object.freeze() doesn't work
function $ed66406a997fd44d$export$e29a9e4d2573411c(cp) {
    $ed66406a997fd44d$var$init();
    return $ed66406a997fd44d$var$CM.has(cp);
}
function $ed66406a997fd44d$export$4b1c9c18c687e5e9(cp) {
    $ed66406a997fd44d$var$init();
    return $ed66406a997fd44d$var$ESCAPE.has(cp);
}
// return all supported emoji as fully-qualified emoji 
// ordered by length then lexicographic 
function $ed66406a997fd44d$export$95d5ea4de7964366() {
    $ed66406a997fd44d$var$init();
    return $ed66406a997fd44d$var$EMOJI_LIST.map(function(x) {
        return x.slice();
    }); // emoji are exposed so copy
}
function $ed66406a997fd44d$export$f4e6b2721065fb3d(frag, decompose) {
    $ed66406a997fd44d$var$init();
    var nf = decompose ? $ed66406a997fd44d$export$9d0d896b286a3dba : $ed66406a997fd44d$export$f42252642e08449;
    return frag.split($ed66406a997fd44d$var$STOP_CH).map(function(label) {
        return $ed66406a997fd44d$var$str_from_cps($ed66406a997fd44d$var$tokens_from_str($ed66406a997fd44d$var$explode_cp(label), nf, $ed66406a997fd44d$var$filter_fe0f).flat());
    }).join($ed66406a997fd44d$var$STOP_CH);
}
function $ed66406a997fd44d$export$499f715881831a51(name) {
    return $ed66406a997fd44d$var$flatten($ed66406a997fd44d$var$split(name, $ed66406a997fd44d$export$f42252642e08449, $ed66406a997fd44d$var$filter_fe0f));
}
function $ed66406a997fd44d$export$d2ee080f6ab2341d(name) {
    var labels = $ed66406a997fd44d$var$split(name, $ed66406a997fd44d$export$f42252642e08449, function(x) {
        return x;
    }); // emoji not exposed
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = labels[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, type = _step_value.type, output = _step_value.output, error = _step_value.error;
            if (error) break; // flatten will throw
            // replace leading/trailing hyphen
            // 20230121: consider beautifing all or leading/trailing hyphen to unicode variant
            // not exactly the same in every font, but very similar: "-" vs "‐"
            /*
		const UNICODE_HYPHEN = 0x2010;
		// maybe this should replace all for visual consistancy?
		// `node tools/reg-count.js regex ^-\{2,\}` => 592
		//for (let i = 0; i < output.length; i++) if (output[i] == 0x2D) output[i] = 0x2010;
		if (output[0] == HYPHEN) output[0] = UNICODE_HYPHEN;
		let end = output.length-1;
		if (output[end] == HYPHEN) output[end] = UNICODE_HYPHEN;
		*/ // 20230123: WHATWG URL uses "CheckHyphens" false
            // https://url.spec.whatwg.org/#idna
            // update ethereum symbol
            // ξ => Ξ if not greek
            if (type !== "Greek") {
                var prev = 0;
                while(true){
                    var next = output.indexOf(0x3BE, prev);
                    if (next < 0) break;
                    output[next] = 0x39E;
                    prev = next + 1;
                }
            }
        // 20221213: fixes bidi subdomain issue, but breaks invariant (200E is disallowed)
        // could be fixed with special case for: 2D (.) + 200E (LTR)
        // https://discuss.ens.domains/t/bidi-label-ordering-spoof/15824
        //output.splice(0, 0, 0x200E);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return $ed66406a997fd44d$var$flatten(labels);
}
function $ed66406a997fd44d$export$d2ba335951b08421(name, preserve_emoji) {
    return $ed66406a997fd44d$var$split(name, $ed66406a997fd44d$export$f42252642e08449, preserve_emoji ? function(x) {
        return x.slice();
    } : $ed66406a997fd44d$var$filter_fe0f); // emoji are exposed so copy
}
function $ed66406a997fd44d$var$split(name, nf, ef) {
    if (!name) return []; // 20230719: empty name allowance
    $ed66406a997fd44d$var$init();
    var offset = 0;
    // https://unicode.org/reports/tr46/#Validity_Criteria
    // 4.) "The label must not contain a U+002E ( . ) FULL STOP."
    return name.split($ed66406a997fd44d$var$STOP_CH).map(function(label) {
        var input = $ed66406a997fd44d$var$explode_cp(label);
        var info = {
            input: input,
            offset: offset
        };
        offset += input.length + 1; // + stop
        try {
            // 1.) "The label must be in Unicode Normalization Form NFC"
            var tokens = info.tokens = $ed66406a997fd44d$var$tokens_from_str(input, nf, ef);
            var token_count = tokens.length;
            var type;
            if (!token_count) //norm = [];
            //type = 'None'; // use this instead of next match, "ASCII"
            // 20230120: change to strict
            // https://discuss.ens.domains/t/ens-name-normalization-2nd/14564/59
            throw new Error("empty label");
            var norm = info.output = tokens.flat();
            $ed66406a997fd44d$var$check_leading_underscore(norm);
            var emoji = info.emoji = token_count > 1 || tokens[0].is_emoji; // same as: tokens.some(x => x.is_emoji);
            if (!emoji && norm.every(function(cp) {
                return cp < 0x80;
            })) {
                // 20230123: matches matches WHATWG, see note 3.3
                $ed66406a997fd44d$var$check_label_extension(norm); // only needed for ascii
                // cant have fenced
                // cant have cm
                // cant have wholes
                // see derive: "Fastpath ASCII"
                type = "ASCII";
            } else {
                var chars = tokens.flatMap(function(x) {
                    return x.is_emoji ? [] : x;
                }); // all of the nfc tokens concat together
                if (!chars.length) type = "Emoji";
                else {
                    // 5.) "The label must not begin with a combining mark, that is: General_Category=Mark."
                    if ($ed66406a997fd44d$var$CM.has(norm[0])) throw $ed66406a997fd44d$var$error_placement("leading combining mark");
                    for(var i = 1; i < token_count; i++){
                        var cps = tokens[i];
                        if (!cps.is_emoji && $ed66406a997fd44d$var$CM.has(cps[0])) // bidi_qq() not needed since emoji is LTR and cps is a CM
                        throw $ed66406a997fd44d$var$error_placement('emoji + combining mark: "'.concat($ed66406a997fd44d$var$str_from_cps(tokens[i - 1]), " + ").concat($ed66406a997fd44d$export$6ec6f9a7f89f00db([
                            cps[0]
                        ]), '"'));
                    }
                    $ed66406a997fd44d$var$check_fenced(norm);
                    var unique = $ed66406a997fd44d$var$Array_from(new Set(chars));
                    var _determine_group = (0, $cv9Rk._)($ed66406a997fd44d$var$determine_group(unique), 1), g = _determine_group[0]; // take the first match
                    // see derive: "Matching Groups have Same CM Style"
                    // alternative: could form a hybrid type: Latin/Japanese/...	
                    $ed66406a997fd44d$var$check_group(g, chars); // need text in order
                    $ed66406a997fd44d$var$check_whole(g, unique); // only need unique text (order would be required for multiple-char confusables)
                    type = g.N;
                // 20230121: consider exposing restricted flag
                // it's simpler to just check for 'Restricted'
                // or even better: type.endsWith(']')
                //if (g.R) info.restricted = true;
                }
            }
            info.type = type;
        } catch (err) {
            info.error = err; // use full error object
        }
        return info;
    });
}
function $ed66406a997fd44d$var$check_whole(group, unique) {
    var maker;
    var shared = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var cp = _step.value;
            var whole = $ed66406a997fd44d$var$WHOLE_MAP.get(cp);
            if (whole === $ed66406a997fd44d$var$UNIQUE_PH) return {
                v: void void 0
            } // unique, non-confusable
            ;
            if (whole) {
                var set = whole.M.get(cp); // groups which have a character that look-like this character
                maker = maker ? maker.filter(function(g) {
                    return set.has(g);
                }) : $ed66406a997fd44d$var$Array_from(set);
                if (!maker.length) return {
                    v: void void 0
                } // confusable intersection is empty
                ;
            } else shared.push(cp);
        };
        for(var _iterator = unique[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop();
            if ((0, $l0HdX._)(_ret) === "object") return _ret.v;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    if (maker) try {
        var _loop1 = function() {
            var g = _step1.value;
            if (shared.every(function(cp) {
                return $ed66406a997fd44d$var$group_has_cp(g, cp);
            })) throw new Error("whole-script confusable: ".concat(group.N, "/").concat(g.N));
        };
        // we have 1+ confusable
        // check if any of the remaining groups
        // contain the shared characters too
        for(var _iterator1 = maker[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop1();
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
}
// assumption: unique.size > 0
// returns list of matching groups
function $ed66406a997fd44d$var$determine_group(unique) {
    var groups = $ed66406a997fd44d$var$GROUPS;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var cp = _step.value;
            // note: we need to dodge CM that are whitelisted
            // but that code isn't currently necessary
            var gs = groups.filter(function(g) {
                return $ed66406a997fd44d$var$group_has_cp(g, cp);
            });
            if (!gs.length) {
                if (!$ed66406a997fd44d$var$GROUPS.some(function(g) {
                    return $ed66406a997fd44d$var$group_has_cp(g, cp);
                })) // the character was composed of valid parts
                // but it's NFC form is invalid
                // 20230716: change to more exact statement, see: ENSNormalize.{cs,java}
                // note: this doesn't have to be a composition
                // 20230720: change to full check
                throw $ed66406a997fd44d$var$error_disallowed(cp); // this should be rare
                else // there is no group that contains all these characters
                // throw using the highest priority group that matched
                // https://www.unicode.org/reports/tr39/#mixed_script_confusables
                throw $ed66406a997fd44d$var$error_group_member(groups[0], cp);
            }
            groups = gs;
            if (gs.length == 1) return "break" // there is only one group left
            ;
        };
        for(var _iterator = unique[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop();
            if (_ret === "break") break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // there are at least 1 group(s) with all of these characters
    return groups;
}
// throw on first error
function $ed66406a997fd44d$var$flatten(split) {
    return split.map(function(param) {
        var input = param.input, error = param.error, output = param.output;
        if (error) {
            // don't print label again if just a single label
            var msg = error.message;
            // bidi_qq() only necessary if msg is digits
            throw new Error(split.length == 1 ? msg : "Invalid label ".concat($ed66406a997fd44d$var$bidi_qq($ed66406a997fd44d$export$6ec6f9a7f89f00db(input)), ": ").concat(msg));
        }
        return $ed66406a997fd44d$var$str_from_cps(output);
    }).join($ed66406a997fd44d$var$STOP_CH);
}
function $ed66406a997fd44d$var$error_disallowed(cp) {
    // TODO: add cp to error?
    return new Error("disallowed character: ".concat($ed66406a997fd44d$var$quoted_cp(cp)));
}
function $ed66406a997fd44d$var$error_group_member(g, cp) {
    var quoted = $ed66406a997fd44d$var$quoted_cp(cp);
    var gg = $ed66406a997fd44d$var$GROUPS.find(function(g) {
        return g.P.has(cp);
    }); // only check primary
    if (gg) quoted = "".concat(gg.N, " ").concat(quoted);
    return new Error("illegal mixture: ".concat(g.N, " + ").concat(quoted));
}
function $ed66406a997fd44d$var$error_placement(where) {
    return new Error("illegal placement: ".concat(where));
}
// assumption: cps.length > 0
// assumption: cps[0] isn't a CM
// assumption: the previous character isn't an emoji
function $ed66406a997fd44d$var$check_group(g, cps) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = cps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var cp = _step.value;
            if (!$ed66406a997fd44d$var$group_has_cp(g, cp)) // for whitelisted scripts, this will throw illegal mixture on invalid cm, eg. "e{300}{300}"
            // at the moment, it's unnecessary to introduce an extra error type
            // until there exists a whitelisted multi-character
            //   eg. if (M < 0 && is_combining_mark(cp)) { ... }
            // there are 3 cases:
            //   1. illegal cm for wrong group => mixture error
            //   2. illegal cm for same group => cm error
            //       requires set of whitelist cm per group: 
            //        eg. new Set([...g.P, ...g.Q].flatMap(nfc).filter(cp => CM.has(cp)))
            //   3. wrong group => mixture error
            throw $ed66406a997fd44d$var$error_group_member(g, cp);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    //if (M >= 0) { // we have a known fixed cm count
    if (g.M) {
        var decomposed = $ed66406a997fd44d$export$9d0d896b286a3dba(cps);
        for(var i = 1, e = decomposed.length; i < e; i++)// 20230210: bugfix: using cps instead of decomposed h/t Carbon225
        /*
			if (CM.has(decomposed[i])) {
				let j = i + 1;
				while (j < e && CM.has(decomposed[j])) j++;
				if (j - i > M) {
					throw new Error(`too many combining marks: ${g.N} ${bidi_qq(str_from_cps(decomposed.slice(i-1, j)))} (${j-i}/${M})`);
				}
				i = j;
			}
			*/ // 20230217: switch to NSM counting
        // https://www.unicode.org/reports/tr39/#Optional_Detection
        if ($ed66406a997fd44d$var$NSM.has(decomposed[i])) {
            var j = i + 1;
            for(var cp1 = void 0; j < e && $ed66406a997fd44d$var$NSM.has(cp1 = decomposed[j]); j++)// a. Forbid sequences of the same nonspacing mark.
            for(var k = i; k < j; k++){
                if (decomposed[k] == cp1) throw new Error("duplicate non-spacing marks: ".concat($ed66406a997fd44d$var$quoted_cp(cp1)));
            }
            // parse to end so we have full nsm count
            // b. Forbid sequences of more than 4 nonspacing marks (gc=Mn or gc=Me).
            if (j - i > $ed66406a997fd44d$var$NSM_MAX) // note: this slice starts with a base char or spacing-mark cm
            throw new Error("excessive non-spacing marks: ".concat($ed66406a997fd44d$var$bidi_qq($ed66406a997fd44d$export$6ec6f9a7f89f00db(decomposed.slice(i - 1, j))), " (").concat(j - i, "/").concat($ed66406a997fd44d$var$NSM_MAX, ")"));
            i = j;
        }
    }
// *** this code currently isn't needed ***
/*
	let cm_whitelist = M instanceof Map;
	for (let i = 0, e = cps.length; i < e; ) {
		let cp = cps[i++];
		let seqs = cm_whitelist && M.get(cp);
		if (seqs) { 
			// list of codepoints that can follow
			// if this exists, this will always be 1+
			let j = i;
			while (j < e && CM.has(cps[j])) j++;
			let cms = cps.slice(i, j);
			let match = seqs.find(seq => !compare_arrays(seq, cms));
			if (!match) throw new Error(`disallowed combining mark sequence: "${safe_str_from_cps([cp, ...cms])}"`);
			i = j;
		} else if (!V.has(cp)) {
			// https://www.unicode.org/reports/tr39/#mixed_script_confusables
			let quoted = quoted_cp(cp);
			for (let cp of cps) {
				let u = UNIQUE.get(cp);
				if (u && u !== g) {
					// if both scripts are restricted this error is confusing
					// because we don't differentiate RestrictedA from RestrictedB 
					if (!u.R) quoted = `${quoted} is ${u.N}`;
					break;
				}
			}
			throw new Error(`disallowed ${g.N} character: ${quoted}`);
			//throw new Error(`disallowed character: ${quoted} (expected ${g.N})`);
			//throw new Error(`${g.N} does not allow: ${quoted}`);
		}
	}
	if (!cm_whitelist) {
		let decomposed = nfd(cps);
		for (let i = 1, e = decomposed.length; i < e; i++) { // we know it can't be cm leading
			if (CM.has(decomposed[i])) {
				let j = i + 1;
				while (j < e && CM.has(decomposed[j])) j++;
				if (j - i > M) {
					throw new Error(`too many combining marks: "${str_from_cps(decomposed.slice(i-1, j))}" (${j-i}/${M})`);
				}
				i = j;
			}
		}
	}
	*/ }
// given a list of codepoints
// returns a list of lists, where emoji are a fully-qualified (as Array subclass)
// eg. explode_cp("abc💩d") => [[61, 62, 63], Emoji[1F4A9, FE0F], [64]]
// 20230818: rename for 'process' name collision h/t Javarome
// https://github.com/adraffy/ens-normalize.js/issues/23
function $ed66406a997fd44d$var$tokens_from_str(input, nf, ef) {
    var ret = [];
    var chars = [];
    input = input.slice().reverse(); // flip so we can pop
    while(input.length){
        var emoji = $ed66406a997fd44d$var$consume_emoji_reversed(input);
        if (emoji) {
            if (chars.length) {
                ret.push(nf(chars));
                chars = [];
            }
            ret.push(ef(emoji));
        } else {
            var cp = input.pop();
            if ($ed66406a997fd44d$var$VALID.has(cp)) chars.push(cp);
            else {
                var _chars;
                var cps = $ed66406a997fd44d$var$MAPPED.get(cp);
                if (cps) (_chars = chars).push.apply(_chars, (0, $c6Xmf._)(cps)); // less than 10 elements
                else if (!$ed66406a997fd44d$var$IGNORED.has(cp)) // 20230912: unicode 15.1 changed the order of processing such that
                // disallowed parts are only rejected after NFC
                // https://unicode.org/reports/tr46/#Validity_Criteria
                // this doesn't impact normalization as of today
                // technically, this error can be removed as the group logic will apply similar logic
                // however the error type might be less clear
                throw $ed66406a997fd44d$var$error_disallowed(cp);
            }
        }
    }
    if (chars.length) ret.push(nf(chars));
    return ret;
}
function $ed66406a997fd44d$var$filter_fe0f(cps) {
    return cps.filter(function(cp) {
        return cp != $ed66406a997fd44d$var$FE0F;
    });
}
// given array of codepoints
// returns the longest valid emoji sequence (or undefined if no match)
// *MUTATES* the supplied array
// disallows interleaved ignored characters
// fills (optional) eaten array with matched codepoints
function $ed66406a997fd44d$var$consume_emoji_reversed(cps, eaten) {
    var node = $ed66406a997fd44d$var$EMOJI_ROOT;
    var emoji;
    var pos = cps.length;
    while(pos){
        node = node.get(cps[--pos]);
        if (!node) break;
        var V = node.V;
        if (V) {
            var _eaten;
            emoji = V;
            if (eaten) (_eaten = eaten).push.apply(_eaten, (0, $c6Xmf._)(cps.slice(pos).reverse())); // (optional) copy input, used for ens_tokenize()
            cps.length = pos; // truncate
        }
    }
    return emoji;
}
// ************************************************************
// tokenizer 
var $ed66406a997fd44d$var$TY_VALID = "valid";
var $ed66406a997fd44d$var$TY_MAPPED = "mapped";
var $ed66406a997fd44d$var$TY_IGNORED = "ignored";
var $ed66406a997fd44d$var$TY_DISALLOWED = "disallowed";
var $ed66406a997fd44d$var$TY_EMOJI = "emoji";
var $ed66406a997fd44d$var$TY_NFC = "nfc";
var $ed66406a997fd44d$var$TY_STOP = "stop";
function $ed66406a997fd44d$export$bac129d8210aa825(name) {
    var _loop = function(i1, start1) {
        var token = tokens[i1];
        if ($ed66406a997fd44d$var$is_valid_or_mapped(token.type)) {
            if ($ed66406a997fd44d$var$requires_check(token.cps)) {
                var end = i1 + 1;
                for(var pos = end; pos < tokens.length; pos++){
                    var _tokens_pos = tokens[pos], type = _tokens_pos.type, cps = _tokens_pos.cps;
                    if ($ed66406a997fd44d$var$is_valid_or_mapped(type)) {
                        if (!$ed66406a997fd44d$var$requires_check(cps)) break;
                        end = pos + 1;
                    } else if (type !== $ed66406a997fd44d$var$TY_IGNORED) break;
                }
                if (start1 < 0) start1 = i1;
                var slice = tokens.slice(start1, end);
                var cps0 = slice.flatMap(function(x) {
                    return $ed66406a997fd44d$var$is_valid_or_mapped(x.type) ? x.cps : [];
                }); // strip junk tokens
                var cps1 = $ed66406a997fd44d$export$f42252642e08449(cps0);
                if ($ed66406a997fd44d$var$compare_arrays(cps1, cps0)) {
                    tokens.splice(start1, end - start1, {
                        type: $ed66406a997fd44d$var$TY_NFC,
                        input: cps0,
                        cps: cps1,
                        tokens0: $ed66406a997fd44d$var$collapse_valid_tokens(slice),
                        tokens: $ed66406a997fd44d$export$bac129d8210aa825($ed66406a997fd44d$var$str_from_cps(cps1), {
                            nf: false
                        })
                    });
                    i1 = start1;
                } else i1 = end - 1; // skip to end of slice
                start1 = -1; // reset
            } else start1 = i1; // remember last
        } else if (token.type !== $ed66406a997fd44d$var$TY_IGNORED) start1 = -1; // reset
        start = start1, i = i1, void 0;
    };
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_nf = _ref.nf, nf = _ref_nf === void 0 ? true : _ref_nf;
    $ed66406a997fd44d$var$init();
    var input = $ed66406a997fd44d$var$explode_cp(name).reverse();
    var eaten = [];
    var tokens = [];
    while(input.length){
        var emoji = $ed66406a997fd44d$var$consume_emoji_reversed(input, eaten);
        if (emoji) {
            tokens.push({
                type: $ed66406a997fd44d$var$TY_EMOJI,
                emoji: emoji.slice(),
                input: eaten,
                cps: $ed66406a997fd44d$var$filter_fe0f(emoji)
            });
            eaten = []; // reset buffer
        } else {
            var cp = input.pop();
            if (cp == $ed66406a997fd44d$var$STOP) tokens.push({
                type: $ed66406a997fd44d$var$TY_STOP,
                cp: cp
            });
            else if ($ed66406a997fd44d$var$VALID.has(cp)) tokens.push({
                type: $ed66406a997fd44d$var$TY_VALID,
                cps: [
                    cp
                ]
            });
            else if ($ed66406a997fd44d$var$IGNORED.has(cp)) tokens.push({
                type: $ed66406a997fd44d$var$TY_IGNORED,
                cp: cp
            });
            else {
                var cps = $ed66406a997fd44d$var$MAPPED.get(cp);
                if (cps) tokens.push({
                    type: $ed66406a997fd44d$var$TY_MAPPED,
                    cp: cp,
                    cps: cps.slice()
                });
                else tokens.push({
                    type: $ed66406a997fd44d$var$TY_DISALLOWED,
                    cp: cp
                });
            }
        }
    }
    if (nf) for(var i = 0, start = -1; i < tokens.length; i++)_loop(i, start);
    return $ed66406a997fd44d$var$collapse_valid_tokens(tokens);
}
function $ed66406a997fd44d$var$is_valid_or_mapped(type) {
    return type == $ed66406a997fd44d$var$TY_VALID || type == $ed66406a997fd44d$var$TY_MAPPED;
}
function $ed66406a997fd44d$var$requires_check(cps) {
    return cps.some(function(cp) {
        return $ed66406a997fd44d$var$NFC_CHECK.has(cp);
    });
}
function $ed66406a997fd44d$var$collapse_valid_tokens(tokens) {
    var _loop = function(i) {
        if (tokens[i].type == $ed66406a997fd44d$var$TY_VALID) {
            var j = i + 1;
            while(j < tokens.length && tokens[j].type == $ed66406a997fd44d$var$TY_VALID)j++;
            tokens.splice(i, j - i, {
                type: $ed66406a997fd44d$var$TY_VALID,
                cps: tokens.slice(i, j).flatMap(function(x) {
                    return x.cps;
                })
            });
        }
    };
    for(var i = 0; i < tokens.length; i++)_loop(i);
    return tokens;
}


function $d7d43328081de087$export$a3295358bff77e(name) {
    return (0, $ed66406a997fd44d$export$499f715881831a51)(name);
}




var $2eb794d81ea38b94$export$ba6a4843bec5d2a8 = /*#__PURE__*/ function() {
    "use strict";
    function EVMWagmiClient(options) {
        var _this = this;
        (0, $4GJKx._)(this, EVMWagmiClient);
        var _this_options, _this_options1, _this_options2;
        this.appKit = undefined;
        this.options = undefined;
        this.chain = (0, $3QZC1.ConstantsUtil).CHAIN.EVM;
        this.defaultChain = undefined;
        this.tokens = (0, $c4fae76388afc96e$export$518f198897991e39).getCaipTokens((_this_options = this.options) === null || _this_options === void 0 ? void 0 : _this_options.tokens);
        this.getCaipDefaultChain = (_this_options1 = this.options) === null || _this_options1 === void 0 ? void 0 : _this_options1.defaultChain;
        this.siweControllerClient = (_this_options2 = this.options) === null || _this_options2 === void 0 ? void 0 : _this_options2.siweConfig;
        var wagmiConfig = options.wagmiConfig, defaultChain = options.defaultChain;
        if (!wagmiConfig) throw new Error("wagmiConfig is undefined");
        this.wagmiConfig = wagmiConfig;
        this.defaultChain = (0, $e82e1b76ecf9a723$export$1ee567fcdafbf4d8)(defaultChain);
        this.siweControllerClient = options.siweConfig;
        var _this1 = this;
        var _this2 = this;
        this.networkControllerClient = {
            switchCaipNetwork: function() {
                var _ref = (0, $kSuI9._)(function(caipNetwork) {
                    var chainId;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                chainId = (0, $fcokf.NetworkUtil).caipNetworkIdToNumber(caipNetwork === null || caipNetwork === void 0 ? void 0 : caipNetwork.id);
                                if (!chainId) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (0, $f077f6357baad451$export$15599da40e72d2f)(_this1.wagmiConfig, {
                                        chainId: chainId
                                    })
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(caipNetwork) {
                    return _ref.apply(this, arguments);
                };
            }(),
            getApprovedCaipNetworksData: /*#__PURE__*/ (0, $kSuI9._)(function() {
                return (0, $eha6O.__generator)(this, function(_state) {
                    return [
                        2,
                        new Promise(function(resolve) {
                            var _connection_connector, _connection_connector1;
                            var connections = new Map(_this2.wagmiConfig.state.connections);
                            var connection = connections.get(_this2.wagmiConfig.state.current || "");
                            if ((connection === null || connection === void 0 ? void 0 : (_connection_connector = connection.connector) === null || _connection_connector === void 0 ? void 0 : _connection_connector.id) === (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).AUTH_CONNECTOR_ID) resolve((0, $e82e1b76ecf9a723$export$94f91666d3e5b28f)());
                            else if ((connection === null || connection === void 0 ? void 0 : (_connection_connector1 = connection.connector) === null || _connection_connector1 === void 0 ? void 0 : _connection_connector1.id) === (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).WALLET_CONNECT_CONNECTOR_ID) {
                                var connector = _this2.wagmiConfig.connectors.find(function(c) {
                                    return c.id === (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).WALLET_CONNECT_CONNECTOR_ID;
                                });
                                resolve((0, $e82e1b76ecf9a723$export$24a8d1cae47a6f)(connector));
                            }
                            resolve({
                                approvedCaipNetworkIds: undefined,
                                supportsAllNetworks: true
                            });
                        })
                    ];
                });
            })
        };
        var _this3 = this;
        var _this4 = this;
        var _this5 = this;
        var _this6 = this;
        var _this7 = this;
        var _this8 = this;
        var _this9 = this;
        var _this10 = this;
        var _this11 = this;
        var _this12 = this;
        this.connectionControllerClient = {
            connectWalletConnect: function() {
                var _ref = (0, $kSuI9._)(function(onUri) {
                    var _this_options, _provider_signer_client_core_crypto, _provider_signer_client_core, _provider_signer_client, _provider_signer, _this_appKit, _this_appKit_getCaipNetwork, _this_appKit1, _siweConfig_getMessageParams, _siweConfig_options, siweConfig, connector, provider, clientId, chainId, siweParams, _result_auths, _ref, SIWEController, getDidChainId, getDidAddress, reorderedChains, result, _, _tmp, signedCacao, p, s, cacaoChainId, address, message, error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                siweConfig = (_this_options = _this3.options) === null || _this_options === void 0 ? void 0 : _this_options.siweConfig;
                                connector = _this3.wagmiConfig.connectors.find(function(c) {
                                    return c.id === (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).WALLET_CONNECT_CONNECTOR_ID;
                                });
                                if (!connector) throw new Error("connectionControllerClient:getWalletConnectUri - connector is undefined");
                                return [
                                    4,
                                    connector.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                provider.on("display_uri", function(data) {
                                    onUri(data);
                                });
                                return [
                                    4,
                                    (_provider_signer = provider.signer) === null || _provider_signer === void 0 ? void 0 : (_provider_signer_client = _provider_signer.client) === null || _provider_signer_client === void 0 ? void 0 : (_provider_signer_client_core = _provider_signer_client.core) === null || _provider_signer_client_core === void 0 ? void 0 : (_provider_signer_client_core_crypto = _provider_signer_client_core.crypto) === null || _provider_signer_client_core_crypto === void 0 ? void 0 : _provider_signer_client_core_crypto.getClientId()
                                ];
                            case 2:
                                clientId = _state.sent();
                                if (clientId) (_this_appKit = _this3.appKit) === null || _this_appKit === void 0 ? void 0 : _this_appKit.setClientId(clientId);
                                chainId = (0, $fcokf.NetworkUtil).caipNetworkIdToNumber((_this_appKit1 = _this3.appKit) === null || _this_appKit1 === void 0 ? void 0 : (_this_appKit_getCaipNetwork = _this_appKit1.getCaipNetwork()) === null || _this_appKit_getCaipNetwork === void 0 ? void 0 : _this_appKit_getCaipNetwork.id);
                                return [
                                    4,
                                    siweConfig === null || siweConfig === void 0 ? void 0 : (_siweConfig_getMessageParams = siweConfig.getMessageParams) === null || _siweConfig_getMessageParams === void 0 ? void 0 : _siweConfig_getMessageParams.call(siweConfig)
                                ];
                            case 3:
                                siweParams = _state.sent();
                                if (!((siweConfig === null || siweConfig === void 0 ? void 0 : (_siweConfig_options = siweConfig.options) === null || _siweConfig_options === void 0 ? void 0 : _siweConfig_options.enabled) && typeof (provider === null || provider === void 0 ? void 0 : provider.authenticate) === "function" && siweParams && Object.keys(siweParams || {}).length > 0)) return [
                                    3,
                                    14
                                ];
                                return [
                                    4,
                                    (parcelRequire("jCIHD"))
                                ];
                            case 4:
                                _ref = _state.sent(), SIWEController = _ref.SIWEController, getDidChainId = _ref.getDidChainId, getDidAddress = _ref.getDidAddress;
                                return [
                                    4,
                                    connector.setRequestedChainsIds(siweParams.chains)
                                ];
                            case 5:
                                _state.sent();
                                reorderedChains = siweParams.chains;
                                if (chainId) reorderedChains = [
                                    chainId
                                ].concat((0, $c6Xmf._)(siweParams.chains.filter(function(c) {
                                    return c !== chainId;
                                })));
                                _ = provider.authenticate;
                                _tmp = {};
                                return [
                                    4,
                                    siweConfig.getNonce()
                                ];
                            case 6:
                                return [
                                    4,
                                    _.apply(provider, [
                                        (0, $cxjpp._).apply(void 0, [
                                            (0, $do9pw._).apply(void 0, [
                                                (_tmp.nonce = _state.sent(), _tmp.methods = (0, $c6Xmf._)((0, $cTdql.OPTIONAL_METHODS)), _tmp),
                                                siweParams
                                            ]),
                                            {
                                                chains: reorderedChains
                                            }
                                        ])
                                    ])
                                ];
                            case 7:
                                result = _state.sent();
                                signedCacao = result === null || result === void 0 ? void 0 : (_result_auths = result.auths) === null || _result_auths === void 0 ? void 0 : _result_auths[0];
                                if (!signedCacao) return [
                                    3,
                                    13
                                ];
                                p = signedCacao.p, s = signedCacao.s;
                                cacaoChainId = getDidChainId(p.iss) || "";
                                address = getDidAddress(p.iss);
                                if (address && cacaoChainId) SIWEController.setSession({
                                    address: address,
                                    chainId: parseInt(cacaoChainId, 10)
                                });
                                _state.label = 8;
                            case 8:
                                _state.trys.push([
                                    8,
                                    10,
                                    ,
                                    13
                                ]);
                                message = provider.signer.client.formatAuthMessage({
                                    request: p,
                                    iss: p.iss
                                });
                                return [
                                    4,
                                    SIWEController.verifyMessage({
                                        message: message,
                                        signature: s.s,
                                        cacao: signedCacao
                                    })
                                ];
                            case 9:
                                _state.sent();
                                return [
                                    3,
                                    13
                                ];
                            case 10:
                                error = _state.sent();
                                console.error("Error verifying message", error);
                                return [
                                    4,
                                    provider.disconnect().catch(console.error)
                                ];
                            case 11:
                                _state.sent();
                                return [
                                    4,
                                    SIWEController.signOut().catch(console.error)
                                ];
                            case 12:
                                _state.sent();
                                throw error;
                            case 13:
                                _this3.wagmiConfig.state.current = "";
                                _state.label = 14;
                            case 14:
                                return [
                                    4,
                                    (0, $122e140114974ba5$export$64605811ab45167f)(_this3.wagmiConfig, {
                                        connector: connector,
                                        chainId: chainId
                                    })
                                ];
                            case 15:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(onUri) {
                    return _ref.apply(this, arguments);
                };
            }(),
            connectExternal: function() {
                var _ref = (0, $kSuI9._)(function(param) {
                    var id, provider, info, _this_appKit, _connector_setEip6963Wallet, _this_appKit_getCaipNetwork, _this_appKit1, connector, chainId;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                id = param.id, provider = param.provider, info = param.info;
                                connector = _this4.wagmiConfig.connectors.find(function(c) {
                                    return c.id === id;
                                });
                                if (!connector) throw new Error("connectionControllerClient:connectExternal - connector is undefined");
                                (_this_appKit = _this4.appKit) === null || _this_appKit === void 0 ? void 0 : _this_appKit.setClientId(null);
                                if (provider && info && connector.id === (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).EIP6963_CONNECTOR_ID) (_connector_setEip6963Wallet = connector.setEip6963Wallet) === null || _connector_setEip6963Wallet === void 0 ? void 0 : _connector_setEip6963Wallet.call(connector, {
                                    provider: provider,
                                    info: info
                                });
                                chainId = (0, $fcokf.NetworkUtil).caipNetworkIdToNumber((_this_appKit1 = _this4.appKit) === null || _this_appKit1 === void 0 ? void 0 : (_this_appKit_getCaipNetwork = _this_appKit1.getCaipNetwork()) === null || _this_appKit_getCaipNetwork === void 0 ? void 0 : _this_appKit_getCaipNetwork.id);
                                return [
                                    4,
                                    (0, $122e140114974ba5$export$64605811ab45167f)(_this4.wagmiConfig, {
                                        connector: connector,
                                        chainId: chainId
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(_) {
                    return _ref.apply(this, arguments);
                };
            }(),
            reconnectExternal: function() {
                var _ref = (0, $kSuI9._)(function(param) {
                    var id, connector;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                id = param.id;
                                connector = _this5.wagmiConfig.connectors.find(function(c) {
                                    return c.id === id;
                                });
                                if (!connector) throw new Error("connectionControllerClient:connectExternal - connector is undefined");
                                return [
                                    4,
                                    (0, $f8aa10d203403d99$export$f0e7018a430fa792)(_this5.wagmiConfig, {
                                        connectors: [
                                            connector
                                        ]
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(_) {
                    return _ref.apply(this, arguments);
                };
            }(),
            checkInstalled: function(ids) {
                var _this_appKit;
                var injectedConnector = (_this_appKit = _this.appKit) === null || _this_appKit === void 0 ? void 0 : _this_appKit.getConnectors().find(function(c) {
                    return c.type === "INJECTED";
                });
                if (!ids) return Boolean(window.ethereum);
                if (injectedConnector) {
                    var _window;
                    if (!((_window = window) === null || _window === void 0 ? void 0 : _window.ethereum)) return false;
                    return ids.some(function(id) {
                        var _window_ethereum;
                        return Boolean((_window_ethereum = window.ethereum) === null || _window_ethereum === void 0 ? void 0 : _window_ethereum[String(id)]);
                    });
                }
                return false;
            },
            disconnect: /*#__PURE__*/ (0, $kSuI9._)(function() {
                var _this_appKit, _this_options_siweConfig_options, _this_options_siweConfig, _this_options, SIWEController;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0, $91ceee46be7e0ba4$export$37dfea93db2e14ed)(_this6.wagmiConfig)
                            ];
                        case 1:
                            _state.sent();
                            (_this_appKit = _this6.appKit) === null || _this_appKit === void 0 ? void 0 : _this_appKit.setClientId(null);
                            if (!((_this_options = _this6.options) === null || _this_options === void 0 ? void 0 : (_this_options_siweConfig = _this_options.siweConfig) === null || _this_options_siweConfig === void 0 ? void 0 : (_this_options_siweConfig_options = _this_options_siweConfig.options) === null || _this_options_siweConfig_options === void 0 ? void 0 : _this_options_siweConfig_options.signOutOnDisconnect)) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                (parcelRequire("jCIHD"))
                            ];
                        case 2:
                            SIWEController = _state.sent().SIWEController;
                            return [
                                4,
                                SIWEController.signOut()
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }),
            signMessage: function() {
                var _ref = (0, $kSuI9._)(function(message) {
                    var _this_appKit, caipAddress, account;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        caipAddress = ((_this_appKit = _this7.appKit) === null || _this_appKit === void 0 ? void 0 : _this_appKit.getCaipAddress()) || "";
                        account = (0, $e82e1b76ecf9a723$export$c1398e40f52e8b4a)(caipAddress);
                        return [
                            2,
                            (0, $3a5afdbe326ed31c$export$1d9a7a8a40780de)(_this7.wagmiConfig, {
                                message: message,
                                account: account
                            })
                        ];
                    });
                });
                return function(message) {
                    return _ref.apply(this, arguments);
                };
            }(),
            estimateGas: function() {
                var _ref = (0, $kSuI9._)(function(args) {
                    var error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    (0, $711af0904a0a3a79$export$e0580ae1f48db848)(_this8.wagmiConfig, {
                                        account: args.address,
                                        to: args.to,
                                        data: args.data,
                                        type: "legacy"
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                error = _state.sent();
                                return [
                                    2,
                                    0n
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(args) {
                    return _ref.apply(this, arguments);
                };
            }(),
            sendTransaction: function() {
                var _ref = (0, $kSuI9._)(function(data) {
                    var chainId, txParams, tx;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                chainId = (0, $03c83a18d36f49ac$export$4f9234baf34abd0)(_this9.wagmiConfig).chainId;
                                txParams = {
                                    account: data.address,
                                    to: data.to,
                                    value: data.value,
                                    gas: data.gas,
                                    gasPrice: data.gasPrice,
                                    data: data.data,
                                    chainId: chainId,
                                    type: "legacy"
                                };
                                return [
                                    4,
                                    (0, $fdfac1d482c19b90$export$2e8a9232fb815d77)(_this9.wagmiConfig, txParams)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    (0, $7b090043ca07fcb8$export$8e0e7ffc78696d30)(_this9.wagmiConfig, txParams)
                                ];
                            case 2:
                                tx = _state.sent();
                                return [
                                    4,
                                    (0, $98c83597d2cecc81$export$694ec9bdf0bb55cf)(_this9.wagmiConfig, {
                                        hash: tx,
                                        timeout: 25000
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2,
                                    tx
                                ];
                        }
                    });
                });
                return function(data) {
                    return _ref.apply(this, arguments);
                };
            }(),
            writeContract: function() {
                var _ref = (0, $kSuI9._)(function(data) {
                    var _this_appKit, _this_appKit_getCaipNetwork, _this_appKit1, caipAddress, account, chainId, tx;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                caipAddress = ((_this_appKit = _this10.appKit) === null || _this_appKit === void 0 ? void 0 : _this_appKit.getCaipAddress()) || "";
                                account = (0, $e82e1b76ecf9a723$export$c1398e40f52e8b4a)(caipAddress);
                                chainId = (0, $fcokf.NetworkUtil).caipNetworkIdToNumber((_this_appKit1 = _this10.appKit) === null || _this_appKit1 === void 0 ? void 0 : (_this_appKit_getCaipNetwork = _this_appKit1.getCaipNetwork()) === null || _this_appKit_getCaipNetwork === void 0 ? void 0 : _this_appKit_getCaipNetwork.id);
                                return [
                                    4,
                                    (0, $f3af23078fd1eb56$export$4c0f201bc17cbf23)(_this10.wagmiConfig, {
                                        chainId: chainId,
                                        address: data.tokenAddress,
                                        account: account,
                                        abi: data.abi,
                                        functionName: data.method,
                                        args: [
                                            data.receiverAddress,
                                            data.tokenAmount
                                        ]
                                    })
                                ];
                            case 1:
                                tx = _state.sent();
                                return [
                                    2,
                                    tx
                                ];
                        }
                    });
                });
                return function(data) {
                    return _ref.apply(this, arguments);
                };
            }(),
            getEnsAddress: function() {
                var _ref = (0, $kSuI9._)(function(value) {
                    var _this_appKit_getCaipNetwork, _this_appKit, _this_appKit1, chainId, ensName, wcName, e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    5,
                                    ,
                                    6
                                ]);
                                chainId = (0, $fcokf.NetworkUtil).caipNetworkIdToNumber((_this_appKit = _this11.appKit) === null || _this_appKit === void 0 ? void 0 : (_this_appKit_getCaipNetwork = _this_appKit.getCaipNetwork()) === null || _this_appKit_getCaipNetwork === void 0 ? void 0 : _this_appKit_getCaipNetwork.id);
                                ensName = false;
                                wcName = false;
                                if (!(value === null || value === void 0 ? void 0 : value.endsWith((0, $3QZC1.ConstantsUtil).WC_NAME_SUFFIX))) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (_this_appKit1 = _this11.appKit) === null || _this_appKit1 === void 0 ? void 0 : _this_appKit1.resolveWalletConnectName(value)
                                ];
                            case 1:
                                wcName = _state.sent() || false;
                                _state.label = 2;
                            case 2:
                                if (!(chainId === (0, $f2095a368764cd16$export$536d3e0d2c7baf54).id)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    (0, $007bb2fc1fe756f5$export$24b77c7e87f05b8d)(_this11.wagmiConfig, {
                                        name: (0, $d7d43328081de087$export$a3295358bff77e)(value),
                                        chainId: chainId
                                    })
                                ];
                            case 3:
                                ensName = _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    2,
                                    ensName || wcName || false
                                ];
                            case 5:
                                e = _state.sent();
                                return [
                                    2,
                                    false
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(value) {
                    return _ref.apply(this, arguments);
                };
            }(),
            getEnsAvatar: function() {
                var _ref = (0, $kSuI9._)(function(value) {
                    var _this_appKit_getCaipNetwork, _this_appKit, chainId, avatar;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                chainId = (0, $fcokf.NetworkUtil).caipNetworkIdToNumber((_this_appKit = _this12.appKit) === null || _this_appKit === void 0 ? void 0 : (_this_appKit_getCaipNetwork = _this_appKit.getCaipNetwork()) === null || _this_appKit_getCaipNetwork === void 0 ? void 0 : _this_appKit_getCaipNetwork.id);
                                if (chainId !== (0, $f2095a368764cd16$export$536d3e0d2c7baf54).id) return [
                                    2,
                                    false
                                ];
                                return [
                                    4,
                                    (0, $5ddc98a781ca279f$export$65f1d2b9649a54e5)(_this12.wagmiConfig, {
                                        name: (0, $d7d43328081de087$export$a3295358bff77e)(value),
                                        chainId: chainId
                                    })
                                ];
                            case 1:
                                avatar = _state.sent();
                                return [
                                    2,
                                    avatar || false
                                ];
                        }
                    });
                });
                return function(value) {
                    return _ref.apply(this, arguments);
                };
            }(),
            parseUnits: (0, $5e268930465d8d42$export$203ae30b4f6490b3),
            formatUnits: (0, $4fKM9.formatUnits)
        };
    }
    (0, $1wc17._)(EVMWagmiClient, [
        {
            key: "construct",
            value: function construct(appKit, options) {
                var _this = this;
                var _this_appKit, _this_appKit1;
                if (!options.projectId) throw new Error("projectId is undefined");
                this.appKit = appKit;
                this.options = options;
                this.tokens = (0, $c4fae76388afc96e$export$518f198897991e39).getCaipTokens(options.tokens);
                this.syncRequestedNetworks((0, $c6Xmf._)(this.wagmiConfig.chains));
                this.syncConnectors(this.wagmiConfig.connectors);
                this.initAuthConnectorListeners((0, $c6Xmf._)(this.wagmiConfig.connectors));
                (0, $790c49935f6737ac$export$9c8eec0a0da048a0)(this.wagmiConfig, {
                    onChange: function(connectors) {
                        return _this.syncConnectors(connectors);
                    }
                });
                (0, $c9f803c524f80d4c$export$30c94aeff2da2ac6)(this.wagmiConfig, {
                    onChange: function(accountData) {
                        return _this.syncAccount((0, $do9pw._)({}, accountData));
                    }
                });
                (_this_appKit = this.appKit) === null || _this_appKit === void 0 ? void 0 : _this_appKit.setEIP6963Enabled(options.enableEIP6963 !== false);
                (_this_appKit1 = this.appKit) === null || _this_appKit1 === void 0 ? void 0 : _this_appKit1.subscribeShouldUpdateToAddress(function(newAddress) {
                    if (newAddress) {
                        var _connections_;
                        var connections = (0, $2e03580ec1c529ae$export$82b9f8f75cc709b4)(_this.wagmiConfig);
                        var connector = (_connections_ = connections[0]) === null || _connections_ === void 0 ? void 0 : _connections_.connector;
                        if (connector) (0, $01b64e08bb036827$export$9ccfa7718cb7f8b1)(_this.wagmiConfig, {
                            connector: connector
                        }).then(function(response) {
                            return _this.syncAccount({
                                address: newAddress,
                                isConnected: true,
                                addresses: response.accounts,
                                connector: connector,
                                chainId: response.chainId
                            });
                        });
                    }
                });
            }
        },
        {
            key: "subscribeState",
            value: function subscribeState(callback) {
                var _this_appKit;
                return (_this_appKit = this.appKit) === null || _this_appKit === void 0 ? void 0 : _this_appKit.subscribeState(function(state) {
                    return callback((0, $cxjpp._)((0, $do9pw._)({}, state), {
                        selectedNetworkId: (0, $fcokf.NetworkUtil).caipNetworkIdToNumber(state.selectedNetworkId)
                    }));
                });
            }
        },
        {
            key: "syncRequestedNetworks",
            value: function syncRequestedNetworks(chains) {
                var _this = this;
                var _this_appKit;
                var requestedCaipNetworks = chains === null || chains === void 0 ? void 0 : chains.map(function(chain) {
                    var _this_options_chainImages, _this_options;
                    return {
                        id: "".concat((0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).EIP155, ":").concat(chain.id),
                        name: chain.name,
                        imageId: (0, $f0772dbd8906c097$export$fd35d6514357600).EIP155NetworkImageIds[chain.id],
                        imageUrl: (_this_options = _this.options) === null || _this_options === void 0 ? void 0 : (_this_options_chainImages = _this_options.chainImages) === null || _this_options_chainImages === void 0 ? void 0 : _this_options_chainImages[chain.id],
                        chain: _this.chain
                    };
                });
                (_this_appKit = this.appKit) === null || _this_appKit === void 0 ? void 0 : _this_appKit.setRequestedCaipNetworks(requestedCaipNetworks !== null && requestedCaipNetworks !== void 0 ? requestedCaipNetworks : [], this.chain);
            }
        },
        {
            key: "syncAccount",
            value: function syncAccount(param) {
                var address = param.address, chainId = param.chainId, connector = param.connector, addresses = param.addresses, status = param.status;
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _this_appKit, caipAddress, _this_appKit1, _this_appKit2, _this_appKit3, _this_appKit4, isAuthConnector, _this_appKit5, _this_appKit6, _this_appKit7, _this_appKit8, _this_appKit9;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                caipAddress = "".concat((0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).EIP155, ":").concat(chainId, ":").concat(address);
                                if (((_this_appKit = _this.appKit) === null || _this_appKit === void 0 ? void 0 : _this_appKit.getCaipAddress()) === caipAddress) return [
                                    2
                                ];
                                if (!(status === "connected" && address && chainId)) return [
                                    3,
                                    2
                                ];
                                _this.syncNetwork(address, chainId, true);
                                (_this_appKit1 = _this.appKit) === null || _this_appKit1 === void 0 ? void 0 : _this_appKit1.setIsConnected(true, _this.chain);
                                (_this_appKit2 = _this.appKit) === null || _this_appKit2 === void 0 ? void 0 : _this_appKit2.setCaipAddress(caipAddress, _this.chain);
                                return [
                                    4,
                                    Promise.all([
                                        _this.syncProfile(address, chainId),
                                        _this.syncBalance(address, chainId),
                                        _this.syncConnectedWalletInfo(connector),
                                        (_this_appKit3 = _this.appKit) === null || _this_appKit3 === void 0 ? void 0 : _this_appKit3.setApprovedCaipNetworksData(_this.chain)
                                    ])
                                ];
                            case 1:
                                _state.sent();
                                if (connector) _this.syncConnectedWalletInfo(connector);
                                isAuthConnector = (connector === null || connector === void 0 ? void 0 : connector.id) === (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).AUTH_CONNECTOR_ID;
                                if (!isAuthConnector && (addresses === null || addresses === void 0 ? void 0 : addresses.length)) (_this_appKit4 = _this.appKit) === null || _this_appKit4 === void 0 ? void 0 : _this_appKit4.setAllAccounts(addresses.map(function(addr) {
                                    return {
                                        address: addr,
                                        type: "eoa"
                                    };
                                }), _this.chain);
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                if (status === "disconnected") {
                                    ;
                                    (_this_appKit5 = _this.appKit) === null || _this_appKit5 === void 0 ? void 0 : _this_appKit5.resetAccount(_this.chain);
                                    (_this_appKit6 = _this.appKit) === null || _this_appKit6 === void 0 ? void 0 : _this_appKit6.resetWcConnection();
                                    (_this_appKit7 = _this.appKit) === null || _this_appKit7 === void 0 ? void 0 : _this_appKit7.resetNetwork();
                                    (_this_appKit8 = _this.appKit) === null || _this_appKit8 === void 0 ? void 0 : _this_appKit8.setAllAccounts([], _this.chain);
                                    (_this_appKit9 = _this.appKit) === null || _this_appKit9 === void 0 ? void 0 : _this_appKit9.setIsConnected(false, _this.chain);
                                }
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "syncNetwork",
            value: function syncNetwork(address, chainId, isConnected) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var chain, _this_options_chainImages, _this_options, _this_appKit, _chain_name, name, _chain_id, id, caipChainId, _this_appKit1, _chain_blockExplorers_default, _chain_blockExplorers, _this_appKit2, caipAddress, _this_appKit3, url;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                chain = _this.wagmiConfig.chains.find(function(c) {
                                    return c.id === chainId;
                                });
                                if (!(chain || chainId)) return [
                                    3,
                                    2
                                ];
                                name = (_chain_name = chain === null || chain === void 0 ? void 0 : chain.name) !== null && _chain_name !== void 0 ? _chain_name : chainId === null || chainId === void 0 ? void 0 : chainId.toString();
                                id = Number((_chain_id = chain === null || chain === void 0 ? void 0 : chain.id) !== null && _chain_id !== void 0 ? _chain_id : chainId);
                                caipChainId = "".concat((0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).EIP155, ":").concat(id);
                                (_this_appKit = _this.appKit) === null || _this_appKit === void 0 ? void 0 : _this_appKit.setCaipNetwork({
                                    id: caipChainId,
                                    name: name,
                                    imageId: (0, $f0772dbd8906c097$export$fd35d6514357600).EIP155NetworkImageIds[id],
                                    imageUrl: (_this_options = _this.options) === null || _this_options === void 0 ? void 0 : (_this_options_chainImages = _this_options.chainImages) === null || _this_options_chainImages === void 0 ? void 0 : _this_options_chainImages[id],
                                    chain: _this.chain
                                });
                                if (!(isConnected && address && chainId)) return [
                                    3,
                                    2
                                ];
                                caipAddress = "".concat((0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).EIP155, ":").concat(id, ":").concat(address);
                                (_this_appKit1 = _this.appKit) === null || _this_appKit1 === void 0 ? void 0 : _this_appKit1.setCaipAddress(caipAddress, _this.chain);
                                if (chain === null || chain === void 0 ? void 0 : (_chain_blockExplorers = chain.blockExplorers) === null || _chain_blockExplorers === void 0 ? void 0 : (_chain_blockExplorers_default = _chain_blockExplorers.default) === null || _chain_blockExplorers_default === void 0 ? void 0 : _chain_blockExplorers_default.url) {
                                    ;
                                    url = "".concat(chain.blockExplorers.default.url, "/address/").concat(address);
                                    (_this_appKit3 = _this.appKit) === null || _this_appKit3 === void 0 ? void 0 : _this_appKit3.setAddressExplorerUrl(url, _this.chain);
                                } else (_this_appKit2 = _this.appKit) === null || _this_appKit2 === void 0 ? void 0 : _this_appKit2.setAddressExplorerUrl(undefined, _this.chain);
                                return [
                                    4,
                                    _this.syncBalance(address, chainId)
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "syncWalletConnectName",
            value: function syncWalletConnectName(address) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _this_appKit, registeredWcNames, _this_appKit1, wcName, e, _this_appKit2;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.appKit) throw new Error("syncWalletConnectName - appKit is undefined");
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.appKit.getWalletConnectName(address)
                                ];
                            case 2:
                                registeredWcNames = _state.sent();
                                if (registeredWcNames[0]) {
                                    ;
                                    wcName = registeredWcNames[0];
                                    (_this_appKit1 = _this.appKit) === null || _this_appKit1 === void 0 ? void 0 : _this_appKit1.setProfileName(wcName.name, _this.chain);
                                } else (_this_appKit = _this.appKit) === null || _this_appKit === void 0 ? void 0 : _this_appKit.setProfileName(null, _this.chain);
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                (_this_appKit2 = _this.appKit) === null || _this_appKit2 === void 0 ? void 0 : _this_appKit2.setProfileName(null, _this.chain);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "syncProfile",
            value: function syncProfile(address, chainId) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _this_appKit, _this_appKit1, _ref, name, avatar, e, profileName, _this_appKit2, _this_appKit3, profileImage, _this_appKit4, _this_appKit5;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.appKit) throw new Error("syncProfile - appKit is undefined");
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    5,
                                    ,
                                    14
                                ]);
                                return [
                                    4,
                                    _this.appKit.fetchIdentity({
                                        address: address
                                    })
                                ];
                            case 2:
                                _ref = _state.sent(), name = _ref.name, avatar = _ref.avatar;
                                (_this_appKit = _this.appKit) === null || _this_appKit === void 0 ? void 0 : _this_appKit.setProfileName(name, _this.chain);
                                (_this_appKit1 = _this.appKit) === null || _this_appKit1 === void 0 ? void 0 : _this_appKit1.setProfileImage(avatar, _this.chain);
                                if (!!name) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this.syncWalletConnectName(address)
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    3,
                                    14
                                ];
                            case 5:
                                e = _state.sent();
                                if (!(chainId === (0, $f2095a368764cd16$export$536d3e0d2c7baf54).id)) return [
                                    3,
                                    11
                                ];
                                return [
                                    4,
                                    (0, $8f72e8ecbeb44f2c$export$e1b98d9bc05a9fc2)(_this.wagmiConfig, {
                                        address: address,
                                        chainId: chainId
                                    })
                                ];
                            case 6:
                                profileName = _state.sent();
                                if (!profileName) return [
                                    3,
                                    8
                                ];
                                (_this_appKit2 = _this.appKit) === null || _this_appKit2 === void 0 ? void 0 : _this_appKit2.setProfileName(profileName, _this.chain);
                                return [
                                    4,
                                    (0, $5ddc98a781ca279f$export$65f1d2b9649a54e5)(_this.wagmiConfig, {
                                        name: profileName,
                                        chainId: chainId
                                    })
                                ];
                            case 7:
                                profileImage = _state.sent();
                                if (profileImage) (_this_appKit3 = _this.appKit) === null || _this_appKit3 === void 0 ? void 0 : _this_appKit3.setProfileImage(profileImage, _this.chain);
                                return [
                                    3,
                                    10
                                ];
                            case 8:
                                return [
                                    4,
                                    _this.syncWalletConnectName(address)
                                ];
                            case 9:
                                _state.sent();
                                (_this_appKit4 = _this.appKit) === null || _this_appKit4 === void 0 ? void 0 : _this_appKit4.setProfileImage(null, _this.chain);
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    13
                                ];
                            case 11:
                                return [
                                    4,
                                    _this.syncWalletConnectName(address)
                                ];
                            case 12:
                                _state.sent();
                                (_this_appKit5 = _this.appKit) === null || _this_appKit5 === void 0 ? void 0 : _this_appKit5.setProfileImage(null, _this.chain);
                                _state.label = 13;
                            case 13:
                                return [
                                    3,
                                    14
                                ];
                            case 14:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "syncBalance",
            value: function syncBalance(address, chainId) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _this_appKit, chain, _this_options_tokens_chain_id, _this_options_tokens, _this_options, _this_appKit1, balance;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                chain = _this.wagmiConfig.chains.find(function(c) {
                                    return c.id === chainId;
                                });
                                if (!chain) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (0, $97cc5aab3d18b888$export$df96cd8d56be0ab1)(_this.wagmiConfig, {
                                        address: address,
                                        chainId: chain.id,
                                        token: (_this_options = _this.options) === null || _this_options === void 0 ? void 0 : (_this_options_tokens = _this_options.tokens) === null || _this_options_tokens === void 0 ? void 0 : (_this_options_tokens_chain_id = _this_options_tokens[chain.id]) === null || _this_options_tokens_chain_id === void 0 ? void 0 : _this_options_tokens_chain_id.address
                                    })
                                ];
                            case 1:
                                balance = _state.sent();
                                (_this_appKit1 = _this.appKit) === null || _this_appKit1 === void 0 ? void 0 : _this_appKit1.setBalance(balance.formatted, balance.symbol, _this.chain);
                                return [
                                    2
                                ];
                            case 2:
                                (_this_appKit = _this.appKit) === null || _this_appKit === void 0 ? void 0 : _this_appKit.setBalance(undefined, undefined, _this.chain);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "syncConnectedWalletInfo",
            value: function syncConnectedWalletInfo(connector) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _walletConnectProvider_session_peer_metadata_icons, _this_appKit, walletConnectProvider, _this_appKit1, _this_appKit2, wagmiConnector;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!connector) throw Error("syncConnectedWalletInfo - connector is undefined");
                                if (!(connector.id === (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).WALLET_CONNECT_CONNECTOR_ID && connector.getProvider)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    connector.getProvider()
                                ];
                            case 1:
                                walletConnectProvider = _state.sent();
                                if (walletConnectProvider.session) (_this_appKit = _this.appKit) === null || _this_appKit === void 0 ? void 0 : _this_appKit.setConnectedWalletInfo((0, $cxjpp._)((0, $do9pw._)({}, walletConnectProvider.session.peer.metadata), {
                                    name: walletConnectProvider.session.peer.metadata.name,
                                    icon: (_walletConnectProvider_session_peer_metadata_icons = walletConnectProvider.session.peer.metadata.icons) === null || _walletConnectProvider_session_peer_metadata_icons === void 0 ? void 0 : _walletConnectProvider_session_peer_metadata_icons[0]
                                }), _this.chain);
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                wagmiConnector = (_this_appKit1 = _this.appKit) === null || _this_appKit1 === void 0 ? void 0 : _this_appKit1.getConnectors().find(function(c) {
                                    return c.id === connector.id;
                                });
                                (_this_appKit2 = _this.appKit) === null || _this_appKit2 === void 0 ? void 0 : _this_appKit2.setConnectedWalletInfo({
                                    name: connector.name,
                                    icon: connector.icon || _this.appKit.getConnectorImage(wagmiConnector)
                                }, _this.chain);
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "syncConnectors",
            value: function syncConnectors(connectors) {
                var _this = this;
                var _this_appKit;
                var uniqueIds = new Set();
                var filteredConnectors = connectors.filter(function(item) {
                    return !uniqueIds.has(item.id) && uniqueIds.add(item.id);
                });
                var w3mConnectors = [];
                var coinbaseSDKId = (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).COINBASE_SDK_CONNECTOR_ID;
                var coinbaseConnector = filteredConnectors.find(function(c) {
                    return c.id === coinbaseSDKId;
                });
                filteredConnectors.forEach(function(param) {
                    var id = param.id, name = param.name, type = param.type, icon = param.icon;
                    var _this_options_connectorImages, _this_options;
                    var isCoinbaseRepeated = coinbaseConnector && id === (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).CONNECTOR_RDNS_MAP[(0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).COINBASE_CONNECTOR_ID];
                    var shouldSkip = isCoinbaseRepeated || (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).AUTH_CONNECTOR_ID === id;
                    var _this_options_connectorImages_id, _PresetsUtil_ConnectorNamesMap_id, _PresetsUtil_ConnectorTypesMap_type;
                    if (!shouldSkip) w3mConnectors.push({
                        id: id,
                        explorerId: (0, $f0772dbd8906c097$export$fd35d6514357600).ConnectorExplorerIds[id],
                        imageUrl: (_this_options_connectorImages_id = (_this_options = _this.options) === null || _this_options === void 0 ? void 0 : (_this_options_connectorImages = _this_options.connectorImages) === null || _this_options_connectorImages === void 0 ? void 0 : _this_options_connectorImages[id]) !== null && _this_options_connectorImages_id !== void 0 ? _this_options_connectorImages_id : icon,
                        name: (_PresetsUtil_ConnectorNamesMap_id = (0, $f0772dbd8906c097$export$fd35d6514357600).ConnectorNamesMap[id]) !== null && _PresetsUtil_ConnectorNamesMap_id !== void 0 ? _PresetsUtil_ConnectorNamesMap_id : name,
                        imageId: (0, $f0772dbd8906c097$export$fd35d6514357600).ConnectorImageIds[id],
                        type: (_PresetsUtil_ConnectorTypesMap_type = (0, $f0772dbd8906c097$export$fd35d6514357600).ConnectorTypesMap[type]) !== null && _PresetsUtil_ConnectorTypesMap_type !== void 0 ? _PresetsUtil_ConnectorTypesMap_type : "EXTERNAL",
                        info: {
                            rdns: id
                        },
                        chain: _this.chain
                    });
                });
                (_this_appKit = this.appKit) === null || _this_appKit === void 0 ? void 0 : _this_appKit.setConnectors(w3mConnectors);
                this.syncAuthConnector(filteredConnectors);
            }
        },
        {
            key: "syncAuthConnector",
            value: function syncAuthConnector(connectors) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var authConnector, _this_appKit, provider;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                authConnector = connectors.find(function(param) {
                                    var id = param.id;
                                    return id === (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).AUTH_CONNECTOR_ID;
                                });
                                if (!authConnector) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    authConnector.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                (_this_appKit = _this.appKit) === null || _this_appKit === void 0 ? void 0 : _this_appKit.addConnector({
                                    id: (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).AUTH_CONNECTOR_ID,
                                    type: "AUTH",
                                    name: "Auth",
                                    provider: provider,
                                    email: authConnector.email,
                                    socials: authConnector.socials,
                                    showWallets: authConnector.showWallets,
                                    chain: _this.chain,
                                    walletFeatures: authConnector.walletFeatures
                                });
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "initAuthConnectorListeners",
            value: function initAuthConnectorListeners(connectors) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var authConnector;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                authConnector = connectors.find(function(param) {
                                    var id = param.id;
                                    return id === (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).AUTH_CONNECTOR_ID;
                                });
                                if (!authConnector) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.listenAuthConnector(authConnector)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this.listenModal(authConnector)
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "listenAuthConnector",
            value: function listenAuthConnector(connector) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _this_appKit, _this_appKit1, _this_appKit2, provider, isLoginEmailUsed;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(typeof window !== "undefined" && connector)) return [
                                    3,
                                    2
                                ];
                                (_this_appKit = _this.appKit) === null || _this_appKit === void 0 ? void 0 : _this_appKit.setLoading(true);
                                return [
                                    4,
                                    connector.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                isLoginEmailUsed = provider.getLoginEmailUsed();
                                (_this_appKit1 = _this.appKit) === null || _this_appKit1 === void 0 ? void 0 : _this_appKit1.setLoading(isLoginEmailUsed);
                                if (isLoginEmailUsed) (_this_appKit2 = _this.appKit) === null || _this_appKit2 === void 0 ? void 0 : _this_appKit2.setIsConnected(false, _this.chain);
                                provider.onRpcRequest(function(request) {
                                    if ((0, $2ZXsZ.W3mFrameHelpers).checkIfRequestExists(request)) {
                                        if (!(0, $2ZXsZ.W3mFrameHelpers).checkIfRequestIsAllowed(request)) {
                                            var _this_appKit, _this_appKit1;
                                            if ((_this_appKit = _this.appKit) === null || _this_appKit === void 0 ? void 0 : _this_appKit.isOpen()) {
                                                var _this_appKit2, _this_appKit3, _this_appKit4, _this_appKit5;
                                                if ((_this_appKit2 = _this.appKit) === null || _this_appKit2 === void 0 ? void 0 : _this_appKit2.isTransactionStackEmpty()) return;
                                                if ((_this_appKit3 = _this.appKit) === null || _this_appKit3 === void 0 ? void 0 : _this_appKit3.isTransactionShouldReplaceView()) (_this_appKit4 = _this.appKit) === null || _this_appKit4 === void 0 ? void 0 : _this_appKit4.replace("ApproveTransaction");
                                                else (_this_appKit5 = _this.appKit) === null || _this_appKit5 === void 0 ? void 0 : _this_appKit5.redirect("ApproveTransaction");
                                            } else (_this_appKit1 = _this.appKit) === null || _this_appKit1 === void 0 ? void 0 : _this_appKit1.open({
                                                view: "ApproveTransaction"
                                            });
                                        }
                                    } else {
                                        var _this_appKit6;
                                        (_this_appKit6 = _this.appKit) === null || _this_appKit6 === void 0 ? void 0 : _this_appKit6.open();
                                        console.error((0, $cSJ4o.W3mFrameRpcConstants).RPC_METHOD_NOT_ALLOWED_MESSAGE, {
                                            method: request.method
                                        });
                                        setTimeout(function() {
                                            var _this_appKit;
                                            (_this_appKit = _this.appKit) === null || _this_appKit === void 0 ? void 0 : _this_appKit.showErrorMessage((0, $cSJ4o.W3mFrameRpcConstants).RPC_METHOD_NOT_ALLOWED_UI_MESSAGE);
                                        }, 300);
                                        provider.rejectRpcRequests();
                                    }
                                });
                                provider.onRpcError(function() {
                                    var _this_appKit;
                                    var isModalOpen = (_this_appKit = _this.appKit) === null || _this_appKit === void 0 ? void 0 : _this_appKit.isOpen();
                                    if (isModalOpen) {
                                        var _this_appKit1, _this_appKit2, _this_appKit3;
                                        if ((_this_appKit1 = _this.appKit) === null || _this_appKit1 === void 0 ? void 0 : _this_appKit1.isTransactionStackEmpty()) (_this_appKit2 = _this.appKit) === null || _this_appKit2 === void 0 ? void 0 : _this_appKit2.close();
                                        else (_this_appKit3 = _this.appKit) === null || _this_appKit3 === void 0 ? void 0 : _this_appKit3.popTransactionStack(true);
                                    }
                                });
                                provider.onRpcSuccess(function() {
                                    var _this_appKit, _this_appKit1, _this_appKit2;
                                    if ((_this_appKit = _this.appKit) === null || _this_appKit === void 0 ? void 0 : _this_appKit.isTransactionStackEmpty()) (_this_appKit1 = _this.appKit) === null || _this_appKit1 === void 0 ? void 0 : _this_appKit1.close();
                                    else (_this_appKit2 = _this.appKit) === null || _this_appKit2 === void 0 ? void 0 : _this_appKit2.popTransactionStack();
                                });
                                provider.onNotConnected(function() {
                                    var _this_appKit;
                                    var isConnected = (_this_appKit = _this.appKit) === null || _this_appKit === void 0 ? void 0 : _this_appKit.getIsConnectedState();
                                    if (!isConnected) {
                                        var _this_appKit1, _this_appKit2;
                                        (_this_appKit1 = _this.appKit) === null || _this_appKit1 === void 0 ? void 0 : _this_appKit1.setIsConnected(false, _this.chain);
                                        (_this_appKit2 = _this.appKit) === null || _this_appKit2 === void 0 ? void 0 : _this_appKit2.setLoading(false);
                                    }
                                });
                                provider.onIsConnected(function(req) {
                                    var _this_appKit, _this_appKit1, _this_appKit2, _this_appKit3, _this_appKit4;
                                    (_this_appKit = _this.appKit) === null || _this_appKit === void 0 ? void 0 : _this_appKit.setIsConnected(true, _this.chain);
                                    (_this_appKit1 = _this.appKit) === null || _this_appKit1 === void 0 ? void 0 : _this_appKit1.setSmartAccountDeployed(Boolean(req.smartAccountDeployed), _this.chain);
                                    (_this_appKit2 = _this.appKit) === null || _this_appKit2 === void 0 ? void 0 : _this_appKit2.setPreferredAccountType(req.preferredAccountType, _this.chain);
                                    (_this_appKit3 = _this.appKit) === null || _this_appKit3 === void 0 ? void 0 : _this_appKit3.setLoading(false);
                                    (_this_appKit4 = _this.appKit) === null || _this_appKit4 === void 0 ? void 0 : _this_appKit4.setAllAccounts(req.accounts || [
                                        {
                                            address: req.address,
                                            type: req.preferredAccountType || "eoa"
                                        }
                                    ], _this.chain);
                                });
                                provider.onGetSmartAccountEnabledNetworks(function(networks) {
                                    var _this_appKit;
                                    (_this_appKit = _this.appKit) === null || _this_appKit === void 0 ? void 0 : _this_appKit.setSmartAccountEnabledNetworks(networks, _this.chain);
                                });
                                provider.onSetPreferredAccount(function(param) {
                                    var address = param.address, type = param.type;
                                    var _this_appKit, _this_appKit_getCaipNetwork, _this_appKit1;
                                    if (!address) return;
                                    (_this_appKit = _this.appKit) === null || _this_appKit === void 0 ? void 0 : _this_appKit.setPreferredAccountType(type, _this.chain);
                                    _this.syncAccount({
                                        address: address,
                                        isConnected: true,
                                        chainId: (0, $fcokf.NetworkUtil).caipNetworkIdToNumber((_this_appKit1 = _this.appKit) === null || _this_appKit1 === void 0 ? void 0 : (_this_appKit_getCaipNetwork = _this_appKit1.getCaipNetwork()) === null || _this_appKit_getCaipNetwork === void 0 ? void 0 : _this_appKit_getCaipNetwork.id),
                                        connector: connector
                                    });
                                });
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "listenModal",
            value: function listenModal(connector) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var provider;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    connector.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                _this.subscribeState(function(val) {
                                    if (!val.open) provider.rejectRpcRequests();
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return EVMWagmiClient;
}();



var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");

var $c6Xmf = parcelRequire("c6Xmf");
parcelRequire("8if8T");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $c6Xmf = parcelRequire("c6Xmf");
/**
 * Announces an EIP-1193 Provider.
 */ function $64514dc476deed4a$export$60dbeacb3287962a(detail) {
    var event = new CustomEvent("eip6963:announceProvider", {
        detail: Object.freeze(detail)
    });
    window.dispatchEvent(event);
    var handler = function() {
        return window.dispatchEvent(event);
    };
    window.addEventListener("eip6963:requestProvider", handler);
    return function() {
        return window.removeEventListener("eip6963:requestProvider", handler);
    };
}
function $64514dc476deed4a$export$f262fc9233ecbc18(listener) {
    if (typeof window === "undefined") return;
    var handler = function(event) {
        return listener(event.detail);
    };
    window.addEventListener("eip6963:announceProvider", handler);
    window.dispatchEvent(new CustomEvent("eip6963:requestProvider"));
    return function() {
        return window.removeEventListener("eip6963:announceProvider", handler);
    };
}


function $ff2d63981562eb5a$export$f51a9068ac82ea43() {
    var listeners = new Set();
    var providerDetails = [];
    var request = function() {
        return (0, $64514dc476deed4a$export$f262fc9233ecbc18)(function(providerDetail) {
            if (providerDetails.some(function(param) {
                var info = param.info;
                return info.uuid === providerDetail.info.uuid;
            })) return;
            providerDetails = (0, $c6Xmf._)(providerDetails).concat([
                providerDetail
            ]);
            listeners.forEach(function(listener) {
                return listener(providerDetails, {
                    added: [
                        providerDetail
                    ]
                });
            });
        });
    };
    var unwatch = request();
    return {
        _listeners: function() {
            return listeners;
        },
        clear: function() {
            listeners.forEach(function(listener) {
                return listener([], {
                    removed: (0, $c6Xmf._)(providerDetails)
                });
            });
            providerDetails = [];
        },
        destroy: function() {
            this.clear();
            listeners.clear();
            unwatch === null || unwatch === void 0 ? void 0 : unwatch();
        },
        findProvider: function(param) {
            var rdns = param.rdns;
            return providerDetails.find(function(providerDetail) {
                return providerDetail.info.rdns === rdns;
            });
        },
        getProviders: function() {
            return providerDetails;
        },
        reset: function() {
            this.clear();
            unwatch === null || unwatch === void 0 ? void 0 : unwatch();
            unwatch = request();
        },
        subscribe: function(listener) {
            var emitImmediately = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).emitImmediately;
            listeners.add(listener);
            if (emitImmediately) listener(providerDetails, {
                added: providerDetails
            });
            return function() {
                return listeners.delete(listener);
            };
        }
    };
}




var $3sHb8 = parcelRequire("3sHb8");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");
var $69f3bd0e82bb1626$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/middleware.mjs"
});
var $69f3bd0e82bb1626$var$reduxImpl = function(reducer, initial) {
    return function(set, _get, api) {
        var _api;
        api.dispatch = function(action) {
            set(function(state) {
                return reducer(state, action);
            }, false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return (0, $do9pw._)({
            dispatch: function() {
                for(var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++){
                    a[_key] = arguments[_key];
                }
                return (_api = api).dispatch.apply(_api, (0, $c6Xmf._)(a));
            }
        }, initial);
    };
};
var $69f3bd0e82bb1626$export$4feba8a1bc8e9afd = $69f3bd0e82bb1626$var$reduxImpl;
var $69f3bd0e82bb1626$var$trackedConnections = /* @__PURE__ */ new Map();
var $69f3bd0e82bb1626$var$getTrackedConnectionState = function(name) {
    var api = $69f3bd0e82bb1626$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(function(param) {
        var _param = (0, $cv9Rk._)(param, 2), key = _param[0], api2 = _param[1];
        return [
            key,
            api2.getState()
        ];
    }));
};
var $69f3bd0e82bb1626$var$extractConnectionInformation = function(store, extensionConnector, options) {
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    var existingConnection = $69f3bd0e82bb1626$var$trackedConnections.get(options.name);
    if (existingConnection) return (0, $do9pw._)({
        type: "tracked",
        store: store
    }, existingConnection);
    var newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $69f3bd0e82bb1626$var$trackedConnections.set(options.name, newConnection);
    return (0, $do9pw._)({
        type: "tracked",
        store: store
    }, newConnection);
};
var $69f3bd0e82bb1626$var$devtoolsImpl = function(fn) {
    var devtoolsOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return function(set, get, api) {
        var enabled = devtoolsOptions.enabled, anonymousActionType = devtoolsOptions.anonymousActionType, store = devtoolsOptions.store, options = (0, $dRLPW._)(devtoolsOptions, [
            "enabled",
            "anonymousActionType",
            "store"
        ]);
        var extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : ($69f3bd0e82bb1626$import_meta.env ? $69f3bd0e82bb1626$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (e) {}
        if (!extensionConnector) {
            if (($69f3bd0e82bb1626$import_meta.env ? $69f3bd0e82bb1626$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[zustand devtools middleware] Please install/enable Redux devtools extension");
            return fn(set, get, api);
        }
        var _extractConnectionInformation = $69f3bd0e82bb1626$var$extractConnectionInformation(store, extensionConnector, options), connection = _extractConnectionInformation.connection, connectionInformation = (0, $dRLPW._)(_extractConnectionInformation, [
            "connection"
        ]);
        var isRecording = true;
        api.setState = function(state, replace, nameOrAction) {
            var r = set(state, replace);
            if (!isRecording) return r;
            var action = nameOrAction === void 0 ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send((0, $cxjpp._)((0, $do9pw._)({}, action), {
                type: "".concat(store, "/").concat(action.type)
            }), (0, $cxjpp._)((0, $do9pw._)({}, $69f3bd0e82bb1626$var$getTrackedConnectionState(options.name)), (0, $3sHb8._)({}, store, api.getState())));
            return r;
        };
        var setStateFromDevtools = function() {
            for(var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++){
                a[_key] = arguments[_key];
            }
            var originalIsRecording = isRecording;
            isRecording = false;
            set.apply(void 0, (0, $c6Xmf._)(a));
            isRecording = originalIsRecording;
        };
        var initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(function(param) {
                var _param = (0, $cv9Rk._)(param, 2), key = _param[0], store2 = _param[1];
                return [
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ];
            })));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            var didWarnAboutReservedActionType = false;
            var originalDispatch = api.dispatch;
            api.dispatch = function() {
                for(var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++){
                    a[_key] = arguments[_key];
                }
                if (($69f3bd0e82bb1626$import_meta.env ? $69f3bd0e82bb1626$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch.apply(void 0, (0, $c6Xmf._)(a));
            };
        }
        connection.subscribe(function(message) {
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $69f3bd0e82bb1626$var$parseJsonThen(message.payload, function(action) {
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error('\n                    [zustand devtools middleware] Unsupported __setState action format. \n                    When using \'store\' option in devtools(), the \'state\' should have only one key, which is a value of \'store\' that was passed in devtools(),\n                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }\n                    ');
                            var stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($69f3bd0e82bb1626$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($69f3bd0e82bb1626$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $69f3bd0e82bb1626$var$parseJsonThen(message.state, function(state) {
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($69f3bd0e82bb1626$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $69f3bd0e82bb1626$var$parseJsonThen(message.state, function(state) {
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                var nextLiftedState = message.payload.nextLiftedState;
                                var lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
};
var $69f3bd0e82bb1626$export$6922d3b3a607469e = $69f3bd0e82bb1626$var$devtoolsImpl;
var $69f3bd0e82bb1626$var$parseJsonThen = function(stringified, f) {
    var parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) f(parsed);
};
var $69f3bd0e82bb1626$var$subscribeWithSelectorImpl = function(fn) {
    return function(set, get, api) {
        var origSubscribe = api.subscribe;
        api.subscribe = function(selector, optListener, options) {
            var listener = selector;
            if (optListener) {
                var equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                var currentSlice = selector(api.getState());
                listener = function(state) {
                    var nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        var previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        var initialState = fn(set, get, api);
        return initialState;
    };
};
var $69f3bd0e82bb1626$export$5c593627aef9f076 = $69f3bd0e82bb1626$var$subscribeWithSelectorImpl;
var $69f3bd0e82bb1626$export$1be1fc439b849fdf = function(initialState, create) {
    return function() {
        for(var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++){
            a[_key] = arguments[_key];
        }
        return Object.assign({}, initialState, create.apply(void 0, (0, $c6Xmf._)(a)));
    };
};
function $69f3bd0e82bb1626$export$95a3b7b12ab518f9(getStorage, options) {
    var storage;
    try {
        storage = getStorage();
    } catch (e) {
        return;
    }
    var persistStorage = {
        getItem: function(name) {
            var _a;
            var parse = function(str2) {
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            var str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: function(name, newValue) {
            return storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer));
        },
        removeItem: function(name) {
            return storage.removeItem(name);
        }
    };
    return persistStorage;
}
var $69f3bd0e82bb1626$var$toThenable = function(fn) {
    return function(input) {
        try {
            var result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then: function(onFulfilled) {
                    return $69f3bd0e82bb1626$var$toThenable(onFulfilled)(result);
                },
                catch: function(_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then: function(_onFulfilled) {
                    return this;
                },
                catch: function(onRejected) {
                    return $69f3bd0e82bb1626$var$toThenable(onRejected)(e);
                }
            };
        }
    };
};
var $69f3bd0e82bb1626$var$oldImpl = function(config, baseOptions) {
    return function(set, get, api) {
        var options = (0, $do9pw._)({
            getStorage: function() {
                return localStorage;
            },
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: function(state) {
                return state;
            },
            version: 0,
            merge: function(persistedState, currentState) {
                return (0, $do9pw._)({}, currentState, persistedState);
            }
        }, baseOptions);
        var hasHydrated = false;
        var hydrationListeners = /* @__PURE__ */ new Set();
        var finishHydrationListeners = /* @__PURE__ */ new Set();
        var storage;
        try {
            storage = options.getStorage();
        } catch (e) {}
        if (!storage) return config(function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            console.warn("[zustand persist middleware] Unable to update item '".concat(options.name, "', the given storage is currently unavailable."));
            set.apply(void 0, (0, $c6Xmf._)(args));
        }, get, api);
        var thenableSerialize = $69f3bd0e82bb1626$var$toThenable(options.serialize);
        var setItem = function() {
            var state = options.partialize((0, $do9pw._)({}, get()));
            var errorInSync;
            var thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then(function(serializedValue) {
                return storage.setItem(options.name, serializedValue);
            }).catch(function(e) {
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        var savedSetState = api.setState;
        api.setState = function(state, replace) {
            savedSetState(state, replace);
            setItem();
        };
        var configResult = config(function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            set.apply(void 0, (0, $c6Xmf._)(args));
            setItem();
        }, get, api);
        var stateFromStorage;
        var hydrate = function() {
            var _a;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach(function(cb) {
                return cb(get());
            });
            var postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
            return $69f3bd0e82bb1626$var$toThenable(storage.getItem.bind(storage))(options.name).then(function(storageValue) {
                if (storageValue) return options.deserialize(storageValue);
            }).then(function(deserializedStorageValue) {
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error("State loaded from storage couldn't be migrated since no migrate function was provided");
                    } else return deserializedStorageValue.state;
                }
            }).then(function(migratedState) {
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(function() {
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                hasHydrated = true;
                finishHydrationListeners.forEach(function(cb) {
                    return cb(stateFromStorage);
                });
            }).catch(function(e) {
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: function(newOptions) {
                options = (0, $do9pw._)({}, options, newOptions);
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: function() {
                storage == null || storage.removeItem(options.name);
            },
            getOptions: function() {
                return options;
            },
            rehydrate: function() {
                return hydrate();
            },
            hasHydrated: function() {
                return hasHydrated;
            },
            onHydrate: function(cb) {
                hydrationListeners.add(cb);
                return function() {
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: function(cb) {
                finishHydrationListeners.add(cb);
                return function() {
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
};
var $69f3bd0e82bb1626$var$newImpl = function(config, baseOptions) {
    return function(set, get, api) {
        var options = (0, $do9pw._)({
            storage: $69f3bd0e82bb1626$export$95a3b7b12ab518f9(function() {
                return localStorage;
            }),
            partialize: function(state) {
                return state;
            },
            version: 0,
            merge: function(persistedState, currentState) {
                return (0, $do9pw._)({}, currentState, persistedState);
            }
        }, baseOptions);
        var hasHydrated = false;
        var hydrationListeners = /* @__PURE__ */ new Set();
        var finishHydrationListeners = /* @__PURE__ */ new Set();
        var storage = options.storage;
        if (!storage) return config(function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            console.warn("[zustand persist middleware] Unable to update item '".concat(options.name, "', the given storage is currently unavailable."));
            set.apply(void 0, (0, $c6Xmf._)(args));
        }, get, api);
        var setItem = function() {
            var state = options.partialize((0, $do9pw._)({}, get()));
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        var savedSetState = api.setState;
        api.setState = function(state, replace) {
            savedSetState(state, replace);
            setItem();
        };
        var configResult = config(function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            set.apply(void 0, (0, $c6Xmf._)(args));
            setItem();
        }, get, api);
        var stateFromStorage;
        var hydrate = function() {
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach(function(cb) {
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            var postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return $69f3bd0e82bb1626$var$toThenable(storage.getItem.bind(storage))(options.name).then(function(deserializedStorageValue) {
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error("State loaded from storage couldn't be migrated since no migrate function was provided");
                    } else return deserializedStorageValue.state;
                }
            }).then(function(migratedState) {
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(function() {
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach(function(cb) {
                    return cb(stateFromStorage);
                });
            }).catch(function(e) {
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: function(newOptions) {
                options = (0, $do9pw._)({}, options, newOptions);
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: function() {
                storage == null || storage.removeItem(options.name);
            },
            getOptions: function() {
                return options;
            },
            rehydrate: function() {
                return hydrate();
            },
            hasHydrated: function() {
                return hasHydrated;
            },
            onHydrate: function(cb) {
                hydrationListeners.add(cb);
                return function() {
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: function(cb) {
                finishHydrationListeners.add(cb);
                return function() {
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
};
var $69f3bd0e82bb1626$var$persistImpl = function(config, baseOptions) {
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
        if (($69f3bd0e82bb1626$import_meta.env ? $69f3bd0e82bb1626$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead.");
        return $69f3bd0e82bb1626$var$oldImpl(config, baseOptions);
    }
    return $69f3bd0e82bb1626$var$newImpl(config, baseOptions);
};
var $69f3bd0e82bb1626$export$9a6132153fba2e0 = $69f3bd0e82bb1626$var$persistImpl;


var $16360e4fdff57925$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/vanilla.mjs"
});
var $16360e4fdff57925$var$createStoreImpl = function(createState) {
    var state;
    var listeners = /* @__PURE__ */ new Set();
    var setState = function(partial, replace) {
        var nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object") ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, previousState);
            });
        }
    };
    var getState = function() {
        return state;
    };
    var subscribe = function(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function() {
        if (($16360e4fdff57925$import_meta.env ? $16360e4fdff57925$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        subscribe: subscribe,
        destroy: destroy
    };
    state = createState(setState, getState, api);
    return api;
};
var $16360e4fdff57925$export$f51a9068ac82ea43 = function(createState) {
    return createState ? $16360e4fdff57925$var$createStoreImpl(createState) : $16360e4fdff57925$var$createStoreImpl;
};
var $16360e4fdff57925$export$2e2bcd8739ae039 = function(createState) {
    if (($16360e4fdff57925$import_meta.env ? $16360e4fdff57925$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
    return $16360e4fdff57925$export$f51a9068ac82ea43(createState);
};



var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $dRLPW = parcelRequire("dRLPW");

var $c6Xmf = parcelRequire("c6Xmf");

var $eha6O = parcelRequire("eha6O");

var $8zfHX = parcelRequire("8zfHX");
var $aqVrP = parcelRequire("aqVrP");
var $f3VZN = parcelRequire("f3VZN");


function $b10dbf4ad6df2f47$export$36e7227504c841ea(createConnectorFn) {
    return createConnectorFn;
}


// Regex of wallets/providers that can accurately simulate contract calls & display contract revert reasons.
var $618bc8d87e24d77b$var$supportsSimulationIdRegex = /(rabby|trustwallet)/;
var $618bc8d87e24d77b$var$targetMap = {
    coinbaseWallet: {
        id: "coinbaseWallet",
        name: "Coinbase Wallet",
        provider: function(window1) {
            if (window1 === null || window1 === void 0 ? void 0 : window1.coinbaseWalletExtension) return window1.coinbaseWalletExtension;
            return $618bc8d87e24d77b$var$findProvider(window1, "isCoinbaseWallet");
        }
    },
    metaMask: {
        id: "metaMask",
        name: "MetaMask",
        provider: function(window1) {
            return $618bc8d87e24d77b$var$findProvider(window1, function(provider) {
                if (!provider.isMetaMask) return false;
                // Brave tries to make itself look like MetaMask
                // Could also try RPC `web3_clientVersion` if following is unreliable
                if (provider.isBraveWallet && !provider._events && !provider._state) return false;
                // Other wallets that try to look like MetaMask
                var flags = [
                    "isApexWallet",
                    "isAvalanche",
                    "isBitKeep",
                    "isBlockWallet",
                    "isKuCoinWallet",
                    "isMathWallet",
                    "isOkxWallet",
                    "isOKExWallet",
                    "isOneInchIOSWallet",
                    "isOneInchAndroidWallet",
                    "isOpera",
                    "isPortal",
                    "isRabby",
                    "isTokenPocket",
                    "isTokenary",
                    "isZerion"
                ];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = flags[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var flag = _step.value;
                        if (provider[flag]) return false;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return true;
            });
        }
    },
    phantom: {
        id: "phantom",
        name: "Phantom",
        provider: function(window1) {
            var _window_phantom, _window_phantom1;
            if (window1 === null || window1 === void 0 ? void 0 : (_window_phantom = window1.phantom) === null || _window_phantom === void 0 ? void 0 : _window_phantom.ethereum) return (_window_phantom1 = window1.phantom) === null || _window_phantom1 === void 0 ? void 0 : _window_phantom1.ethereum;
            return $618bc8d87e24d77b$var$findProvider(window1, "isPhantom");
        }
    }
};
$618bc8d87e24d77b$export$a7a34dad4983656f.type = "injected";
function $618bc8d87e24d77b$export$a7a34dad4983656f() {
    var parameters = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _parameters_shimDisconnect = parameters.shimDisconnect, shimDisconnect = _parameters_shimDisconnect === void 0 ? true : _parameters_shimDisconnect, unstable_shimAsyncInject = parameters.unstable_shimAsyncInject;
    function getTarget() {
        var target = parameters.target;
        if (typeof target === "function") {
            var result = target();
            if (result) return result;
        }
        if (typeof target === "object") return target;
        var _targetMap_target;
        if (typeof target === "string") return (0, $do9pw._)({}, (_targetMap_target = $618bc8d87e24d77b$var$targetMap[target]) !== null && _targetMap_target !== void 0 ? _targetMap_target : {
            id: target,
            name: "".concat(target[0].toUpperCase()).concat(target.slice(1)),
            provider: "is".concat(target[0].toUpperCase()).concat(target.slice(1))
        });
        return {
            id: "injected",
            name: "Injected",
            provider: function(window1) {
                return window1 === null || window1 === void 0 ? void 0 : window1.ethereum;
            }
        };
    }
    var accountsChanged;
    var chainChanged;
    var connect;
    var disconnect;
    return (0, $b10dbf4ad6df2f47$export$36e7227504c841ea)(function(config) {
        return {
            get icon () {
                return getTarget().icon;
            },
            get id () {
                return getTarget().id;
            },
            get name () {
                return getTarget().name;
            },
            get supportsSimulation () {
                return $618bc8d87e24d77b$var$supportsSimulationIdRegex.test(this.id.toLowerCase());
            },
            type: $618bc8d87e24d77b$export$a7a34dad4983656f.type,
            setup: function() {
                return (0, $kSuI9._)(function() {
                    var provider;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                // Only start listening for events if `target` is set, otherwise `injected()` will also receive events
                                if (provider && parameters.target) {
                                    if (!connect) {
                                        connect = this.onConnect.bind(this);
                                        provider.on("connect", connect);
                                    }
                                    // We shouldn't need to listen for `'accountsChanged'` here since the `'connect'` event should suffice (and wallet shouldn't be connected yet).
                                    // Some wallets, like MetaMask, do not implement the `'connect'` event and overload `'accountsChanged'` instead.
                                    if (!accountsChanged) {
                                        accountsChanged = this.onAccountsChanged.bind(this);
                                        provider.on("accountsChanged", accountsChanged);
                                    }
                                }
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this);
            },
            connect: function() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, chainId = _ref.chainId, isReconnecting = _ref.isReconnecting;
                return (0, $kSuI9._)(function() {
                    var provider, accounts, _permissions__caveats__value, _permissions__caveats_, _permissions__caveats, _permissions_, permissions, sortedAccounts, err, error, _config_storage, _config_storage1, requestedAccounts, currentChainId, chain, _chain_id, err1, error1;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                if (!provider) throw new (0, $280108186d4a00cc$export$43839b3ff6336f15)();
                                accounts = [];
                                if (!isReconnecting) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this.getAccounts().catch(function() {
                                        return [];
                                    })
                                ];
                            case 2:
                                accounts = _state.sent();
                                return [
                                    3,
                                    9
                                ];
                            case 3:
                                if (!shimDisconnect) return [
                                    3,
                                    9
                                ];
                                _state.label = 4;
                            case 4:
                                _state.trys.push([
                                    4,
                                    8,
                                    ,
                                    9
                                ]);
                                return [
                                    4,
                                    provider.request({
                                        method: "wallet_requestPermissions",
                                        params: [
                                            {
                                                eth_accounts: {}
                                            }
                                        ]
                                    })
                                ];
                            case 5:
                                permissions = _state.sent();
                                accounts = (_permissions_ = permissions[0]) === null || _permissions_ === void 0 ? void 0 : (_permissions__caveats = _permissions_.caveats) === null || _permissions__caveats === void 0 ? void 0 : (_permissions__caveats_ = _permissions__caveats[0]) === null || _permissions__caveats_ === void 0 ? void 0 : (_permissions__caveats__value = _permissions__caveats_.value) === null || _permissions__caveats__value === void 0 ? void 0 : _permissions__caveats__value.map(function(x) {
                                    return (0, $8zfHX.getAddress)(x);
                                });
                                if (!(accounts.length > 0)) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    this.getAccounts()
                                ];
                            case 6:
                                sortedAccounts = _state.sent();
                                accounts = sortedAccounts;
                                _state.label = 7;
                            case 7:
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                err = _state.sent();
                                error = err;
                                // Not all injected providers support `wallet_requestPermissions` (e.g. MetaMask iOS).
                                // Only bubble up error if user rejects request
                                if (error.code === (0, $aqVrP.UserRejectedRequestError).code) throw new (0, $aqVrP.UserRejectedRequestError)(error);
                                // Or prompt is already open
                                if (error.code === (0, $aqVrP.ResourceUnavailableRpcError).code) throw error;
                                return [
                                    3,
                                    9
                                ];
                            case 9:
                                _state.trys.push([
                                    9,
                                    19,
                                    ,
                                    20
                                ]);
                                if (!(!(accounts === null || accounts === void 0 ? void 0 : accounts.length) && !isReconnecting)) return [
                                    3,
                                    11
                                ];
                                return [
                                    4,
                                    provider.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 10:
                                requestedAccounts = _state.sent();
                                accounts = requestedAccounts.map(function(x) {
                                    return (0, $8zfHX.getAddress)(x);
                                });
                                _state.label = 11;
                            case 11:
                                // Manage EIP-1193 event listeners
                                // https://eips.ethereum.org/EIPS/eip-1193#events
                                if (connect) {
                                    provider.removeListener("connect", connect);
                                    connect = undefined;
                                }
                                if (!accountsChanged) {
                                    accountsChanged = this.onAccountsChanged.bind(this);
                                    provider.on("accountsChanged", accountsChanged);
                                }
                                if (!chainChanged) {
                                    chainChanged = this.onChainChanged.bind(this);
                                    provider.on("chainChanged", chainChanged);
                                }
                                if (!disconnect) {
                                    disconnect = this.onDisconnect.bind(this);
                                    provider.on("disconnect", disconnect);
                                }
                                return [
                                    4,
                                    this.getChainId()
                                ];
                            case 12:
                                currentChainId = _state.sent();
                                if (!(chainId && currentChainId !== chainId)) return [
                                    3,
                                    14
                                ];
                                return [
                                    4,
                                    this.switchChain({
                                        chainId: chainId
                                    }).catch(function(error) {
                                        if (error.code === (0, $aqVrP.UserRejectedRequestError).code) throw error;
                                        return {
                                            id: currentChainId
                                        };
                                    })
                                ];
                            case 13:
                                chain = _state.sent();
                                currentChainId = (_chain_id = chain === null || chain === void 0 ? void 0 : chain.id) !== null && _chain_id !== void 0 ? _chain_id : currentChainId;
                                _state.label = 14;
                            case 14:
                                if (!shimDisconnect) return [
                                    3,
                                    16
                                ];
                                return [
                                    4,
                                    (_config_storage = config.storage) === null || _config_storage === void 0 ? void 0 : _config_storage.removeItem("".concat(this.id, ".disconnected"))
                                ];
                            case 15:
                                _state.sent();
                                _state.label = 16;
                            case 16:
                                if (!!parameters.target) return [
                                    3,
                                    18
                                ];
                                return [
                                    4,
                                    (_config_storage1 = config.storage) === null || _config_storage1 === void 0 ? void 0 : _config_storage1.setItem("injected.connected", true)
                                ];
                            case 17:
                                _state.sent();
                                _state.label = 18;
                            case 18:
                                return [
                                    2,
                                    {
                                        accounts: accounts,
                                        chainId: currentChainId
                                    }
                                ];
                            case 19:
                                err1 = _state.sent();
                                error1 = err1;
                                if (error1.code === (0, $aqVrP.UserRejectedRequestError).code) throw new (0, $aqVrP.UserRejectedRequestError)(error1);
                                if (error1.code === (0, $aqVrP.ResourceUnavailableRpcError).code) throw new (0, $aqVrP.ResourceUnavailableRpcError)(error1);
                                throw error1;
                            case 20:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this);
            },
            disconnect: function() {
                return (0, $kSuI9._)(function() {
                    var _config_storage, _config_storage1, provider, e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                if (!provider) throw new (0, $280108186d4a00cc$export$43839b3ff6336f15)();
                                // Manage EIP-1193 event listeners
                                if (chainChanged) {
                                    provider.removeListener("chainChanged", chainChanged);
                                    chainChanged = undefined;
                                }
                                if (disconnect) {
                                    provider.removeListener("disconnect", disconnect);
                                    disconnect = undefined;
                                }
                                if (!connect) {
                                    connect = this.onConnect.bind(this);
                                    provider.on("connect", connect);
                                }
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                // Adding timeout as not all wallets support this method and can hang
                                // https://github.com/wevm/wagmi/issues/4064
                                return [
                                    4,
                                    (0, $ff2899ef378151ae$export$e86e19342bc4850e)(function() {
                                        return(// TODO: Remove explicit type for viem@3
                                        provider.request({
                                            // `'wallet_revokePermissions'` added in `viem@2.10.3`
                                            method: "wallet_revokePermissions",
                                            params: [
                                                {
                                                    eth_accounts: {}
                                                }
                                            ]
                                        }));
                                    }, {
                                        timeout: 100
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                e = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                if (!shimDisconnect) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    (_config_storage = config.storage) === null || _config_storage === void 0 ? void 0 : _config_storage.setItem("".concat(this.id, ".disconnected"), true)
                                ];
                            case 6:
                                _state.sent();
                                _state.label = 7;
                            case 7:
                                if (!!parameters.target) return [
                                    3,
                                    9
                                ];
                                return [
                                    4,
                                    (_config_storage1 = config.storage) === null || _config_storage1 === void 0 ? void 0 : _config_storage1.removeItem("injected.connected")
                                ];
                            case 8:
                                _state.sent();
                                _state.label = 9;
                            case 9:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this);
            },
            getAccounts: function() {
                return (0, $kSuI9._)(function() {
                    var provider, accounts;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                if (!provider) throw new (0, $280108186d4a00cc$export$43839b3ff6336f15)();
                                return [
                                    4,
                                    provider.request({
                                        method: "eth_accounts"
                                    })
                                ];
                            case 2:
                                accounts = _state.sent();
                                return [
                                    2,
                                    accounts.map(function(x) {
                                        return (0, $8zfHX.getAddress)(x);
                                    })
                                ];
                        }
                    });
                }).apply(this);
            },
            getChainId: function() {
                return (0, $kSuI9._)(function() {
                    var provider, hexChainId;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                if (!provider) throw new (0, $280108186d4a00cc$export$43839b3ff6336f15)();
                                return [
                                    4,
                                    provider.request({
                                        method: "eth_chainId"
                                    })
                                ];
                            case 2:
                                hexChainId = _state.sent();
                                return [
                                    2,
                                    Number(hexChainId)
                                ];
                        }
                    });
                }).apply(this);
            },
            getProvider: function() {
                return (0, $kSuI9._)(function() {
                    var provider, target;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        if (typeof window === "undefined") return [
                            2,
                            undefined
                        ];
                        target = getTarget();
                        if (typeof target.provider === "function") provider = target.provider(window);
                        else if (typeof target.provider === "string") provider = $618bc8d87e24d77b$var$findProvider(window, target.provider);
                        else provider = target.provider;
                        // Some wallets do not conform to EIP-1193 (e.g. Trust Wallet)
                        // https://github.com/wevm/wagmi/issues/3526#issuecomment-1912683002
                        if (provider && !provider.removeListener) {
                            // Try using `off` handler if it exists, otherwise noop
                            if ("off" in provider && typeof provider.off === "function") provider.removeListener = provider.off;
                            else provider.removeListener = function() {};
                        }
                        return [
                            2,
                            provider
                        ];
                    });
                })();
            },
            isAuthorized: function() {
                return (0, $kSuI9._)(function() {
                    var _this, _config_storage, isDisconnected, _tmp, _config_storage1, connected, provider, _this1, handleEthereum, timeout, res, accounts, e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    11,
                                    ,
                                    12
                                ]);
                                _tmp = shimDisconnect;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                // If shim exists in storage, connector is disconnected
                                return [
                                    4,
                                    (_config_storage = config.storage) === null || _config_storage === void 0 ? void 0 : _config_storage.getItem("".concat(this.id, ".disconnected"))
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                isDisconnected = _tmp;
                                if (isDisconnected) return [
                                    2,
                                    false
                                ];
                                if (!!parameters.target) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    (_config_storage1 = config.storage) === null || _config_storage1 === void 0 ? void 0 : _config_storage1.getItem("injected.connected")
                                ];
                            case 4:
                                connected = _state.sent();
                                if (!connected) return [
                                    2,
                                    false
                                ];
                                _state.label = 5;
                            case 5:
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 6:
                                provider = _state.sent();
                                if (!!provider) return [
                                    3,
                                    9
                                ];
                                if (!(unstable_shimAsyncInject !== undefined && unstable_shimAsyncInject !== false)) return [
                                    3,
                                    8
                                ];
                                _this1 = this;
                                // If no provider is found, check for async injection
                                // https://github.com/wevm/references/issues/167
                                // https://github.com/MetaMask/detect-provider
                                handleEthereum = function() {
                                    var _ref = (0, $kSuI9._)(function() {
                                        var provider;
                                        return (0, $eha6O.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (typeof window !== "undefined") window.removeEventListener("ethereum#initialized", handleEthereum);
                                                    return [
                                                        4,
                                                        _this1.getProvider()
                                                    ];
                                                case 1:
                                                    provider = _state.sent();
                                                    return [
                                                        2,
                                                        !!provider
                                                    ];
                                            }
                                        });
                                    });
                                    return function handleEthereum() {
                                        return _ref.apply(this, arguments);
                                    };
                                }();
                                timeout = typeof unstable_shimAsyncInject === "number" ? unstable_shimAsyncInject : 1000;
                                return [
                                    4,
                                    Promise.race((0, $c6Xmf._)(typeof window !== "undefined" ? [
                                        new Promise(function(resolve) {
                                            return window.addEventListener("ethereum#initialized", function() {
                                                return resolve(handleEthereum());
                                            }, {
                                                once: true
                                            });
                                        })
                                    ] : []).concat([
                                        new Promise(function(resolve) {
                                            return setTimeout(function() {
                                                return resolve(handleEthereum());
                                            }, timeout);
                                        })
                                    ]))
                                ];
                            case 7:
                                res = _state.sent();
                                if (res) return [
                                    2,
                                    true
                                ];
                                _state.label = 8;
                            case 8:
                                throw new (0, $280108186d4a00cc$export$43839b3ff6336f15)();
                            case 9:
                                return [
                                    4,
                                    (0, $26064d0812f4a37c$export$188df5ecf8e7961a)(function() {
                                        return _this.getAccounts();
                                    })
                                ];
                            case 10:
                                accounts = _state.sent();
                                return [
                                    2,
                                    !!accounts.length
                                ];
                            case 11:
                                e = _state.sent();
                                return [
                                    2,
                                    false
                                ];
                            case 12:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this);
            },
            switchChain: function(param) {
                var addEthereumChainParameter = param.addEthereumChainParameter, chainId = param.chainId;
                return (0, $kSuI9._)(function() {
                    var provider, chain, _this, err, // Unwrapping for MetaMask Mobile
                    // https://github.com/MetaMask/metamask-mobile/issues/2944#issuecomment-976988719
                    _error_data_originalError, _error_data, _$error, _addEthereumChainParameter_rpcUrls, _chain_rpcUrls_default, _chain_blockExplorers, _ref, blockExplorer, blockExplorers, blockExplorerUrls, rpcUrls, _chain_rpcUrls_default_http_, _addEthereumChainParameter_chainName, _addEthereumChainParameter_nativeCurrency, addEthereumChain, currentChainId, error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                if (!provider) throw new (0, $280108186d4a00cc$export$43839b3ff6336f15)();
                                chain = config.chains.find(function(x) {
                                    return x.id === chainId;
                                });
                                if (!chain) throw new (0, $aqVrP.SwitchChainError)(new (0, $ad7a5f8bd0b5662c$export$688e5fda4b4631ed)());
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    10
                                ]);
                                _this = this;
                                return [
                                    4,
                                    Promise.all([
                                        provider.request({
                                            method: "wallet_switchEthereumChain",
                                            params: [
                                                {
                                                    chainId: (0, $f3VZN.numberToHex)(chainId)
                                                }
                                            ]
                                        })// During `'wallet_switchEthereumChain'`, MetaMask makes a `'net_version'` RPC call to the target chain.
                                        // If this request fails, MetaMask does not emit the `'chainChanged'` event, but will still switch the chain.
                                        // To counter this behavior, we request and emit the current chain ID to confirm the chain switch either via
                                        // this callback or an externally emitted `'chainChanged'` event.
                                        // https://github.com/MetaMask/metamask-extension/issues/24247
                                        .then(/*#__PURE__*/ (0, $kSuI9._)(function() {
                                            var currentChainId;
                                            return (0, $eha6O.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            _this.getChainId()
                                                        ];
                                                    case 1:
                                                        currentChainId = _state.sent();
                                                        if (currentChainId === chainId) config.emitter.emit("change", {
                                                            chainId: chainId
                                                        });
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        })),
                                        new Promise(function(resolve) {
                                            return config.emitter.once("change", function(param) {
                                                var currentChainId = param.chainId;
                                                if (currentChainId === chainId) resolve();
                                            });
                                        })
                                    ])
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2,
                                    chain
                                ];
                            case 4:
                                err = _state.sent();
                                _$error = err;
                                if (!(_$error.code === 4902 || (_$error === null || _$error === void 0 ? void 0 : (_error_data = _$error.data) === null || _error_data === void 0 ? void 0 : (_error_data_originalError = _error_data.originalError) === null || _error_data_originalError === void 0 ? void 0 : _error_data_originalError.code) === 4902)) return [
                                    3,
                                    9
                                ];
                                _state.label = 5;
                            case 5:
                                _state.trys.push([
                                    5,
                                    8,
                                    ,
                                    9
                                ]);
                                _ref = (_chain_blockExplorers = chain.blockExplorers) !== null && _chain_blockExplorers !== void 0 ? _chain_blockExplorers : {}, blockExplorer = _ref.default, blockExplorers = (0, $dRLPW._)(_ref, [
                                    "default"
                                ]);
                                if (addEthereumChainParameter === null || addEthereumChainParameter === void 0 ? void 0 : addEthereumChainParameter.blockExplorerUrls) blockExplorerUrls = addEthereumChainParameter.blockExplorerUrls;
                                else if (blockExplorer) blockExplorerUrls = [
                                    blockExplorer.url
                                ].concat((0, $c6Xmf._)(Object.values(blockExplorers).map(function(x) {
                                    return x.url;
                                })));
                                if (addEthereumChainParameter === null || addEthereumChainParameter === void 0 ? void 0 : (_addEthereumChainParameter_rpcUrls = addEthereumChainParameter.rpcUrls) === null || _addEthereumChainParameter_rpcUrls === void 0 ? void 0 : _addEthereumChainParameter_rpcUrls.length) rpcUrls = addEthereumChainParameter.rpcUrls;
                                else rpcUrls = [
                                    (_chain_rpcUrls_default_http_ = (_chain_rpcUrls_default = chain.rpcUrls.default) === null || _chain_rpcUrls_default === void 0 ? void 0 : _chain_rpcUrls_default.http[0]) !== null && _chain_rpcUrls_default_http_ !== void 0 ? _chain_rpcUrls_default_http_ : ""
                                ];
                                addEthereumChain = {
                                    blockExplorerUrls: blockExplorerUrls,
                                    chainId: (0, $f3VZN.numberToHex)(chainId),
                                    chainName: (_addEthereumChainParameter_chainName = addEthereumChainParameter === null || addEthereumChainParameter === void 0 ? void 0 : addEthereumChainParameter.chainName) !== null && _addEthereumChainParameter_chainName !== void 0 ? _addEthereumChainParameter_chainName : chain.name,
                                    iconUrls: addEthereumChainParameter === null || addEthereumChainParameter === void 0 ? void 0 : addEthereumChainParameter.iconUrls,
                                    nativeCurrency: (_addEthereumChainParameter_nativeCurrency = addEthereumChainParameter === null || addEthereumChainParameter === void 0 ? void 0 : addEthereumChainParameter.nativeCurrency) !== null && _addEthereumChainParameter_nativeCurrency !== void 0 ? _addEthereumChainParameter_nativeCurrency : chain.nativeCurrency,
                                    rpcUrls: rpcUrls
                                };
                                return [
                                    4,
                                    provider.request({
                                        method: "wallet_addEthereumChain",
                                        params: [
                                            addEthereumChain
                                        ]
                                    })
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    4,
                                    this.getChainId()
                                ];
                            case 7:
                                currentChainId = _state.sent();
                                if (currentChainId !== chainId) throw new (0, $aqVrP.UserRejectedRequestError)(new Error("User rejected switch after adding network."));
                                return [
                                    2,
                                    chain
                                ];
                            case 8:
                                error = _state.sent();
                                throw new (0, $aqVrP.UserRejectedRequestError)(error);
                            case 9:
                                if (_$error.code === (0, $aqVrP.UserRejectedRequestError).code) throw new (0, $aqVrP.UserRejectedRequestError)(_$error);
                                throw new (0, $aqVrP.SwitchChainError)(_$error);
                            case 10:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this);
            },
            onAccountsChanged: function(accounts) {
                return (0, $kSuI9._)(function() {
                    var _config_storage, chainId;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(accounts.length === 0)) return [
                                    3,
                                    1
                                ];
                                this.onDisconnect();
                                return [
                                    3,
                                    6
                                ];
                            case 1:
                                if (!config.emitter.listenerCount("connect")) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    this.getChainId()
                                ];
                            case 2:
                                chainId = _state.sent().toString();
                                this.onConnect({
                                    chainId: chainId
                                });
                                if (!shimDisconnect) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    (_config_storage = config.storage) === null || _config_storage === void 0 ? void 0 : _config_storage.removeItem("".concat(this.id, ".disconnected"))
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                config.emitter.emit("change", {
                                    accounts: accounts.map(function(x) {
                                        return (0, $8zfHX.getAddress)(x);
                                    })
                                });
                                _state.label = 6;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this);
            },
            onChainChanged: function(chain) {
                var chainId = Number(chain);
                config.emitter.emit("change", {
                    chainId: chainId
                });
            },
            onConnect: function(connectInfo) {
                return (0, $kSuI9._)(function() {
                    var accounts, chainId, provider;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getAccounts()
                                ];
                            case 1:
                                accounts = _state.sent();
                                if (accounts.length === 0) return [
                                    2
                                ];
                                chainId = Number(connectInfo.chainId);
                                config.emitter.emit("connect", {
                                    accounts: accounts,
                                    chainId: chainId
                                });
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 2:
                                provider = _state.sent();
                                if (provider) {
                                    if (connect) {
                                        provider.removeListener("connect", connect);
                                        connect = undefined;
                                    }
                                    if (!accountsChanged) {
                                        accountsChanged = this.onAccountsChanged.bind(this);
                                        provider.on("accountsChanged", accountsChanged);
                                    }
                                    if (!chainChanged) {
                                        chainChanged = this.onChainChanged.bind(this);
                                        provider.on("chainChanged", chainChanged);
                                    }
                                    if (!disconnect) {
                                        disconnect = this.onDisconnect.bind(this);
                                        provider.on("disconnect", disconnect);
                                    }
                                }
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this);
            },
            onDisconnect: function(error) {
                return (0, $kSuI9._)(function() {
                    var provider, _tmp;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                if (!(error && error.code === 1013)) return [
                                    3,
                                    4
                                ];
                                _tmp = provider;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this.getAccounts()
                                ];
                            case 2:
                                _tmp = !!_state.sent().length;
                                _state.label = 3;
                            case 3:
                                if (_tmp) return [
                                    2
                                ];
                                _state.label = 4;
                            case 4:
                                // No need to remove `${this.id}.disconnected` from storage because `onDisconnect` is typically
                                // only called when the wallet is disconnected through the wallet's interface, meaning the wallet
                                // actually disconnected and we don't need to simulate it.
                                config.emitter.emit("disconnect");
                                // Manage EIP-1193 event listeners
                                if (provider) {
                                    if (chainChanged) {
                                        provider.removeListener("chainChanged", chainChanged);
                                        chainChanged = undefined;
                                    }
                                    if (disconnect) {
                                        provider.removeListener("disconnect", disconnect);
                                        disconnect = undefined;
                                    }
                                    if (!connect) {
                                        connect = this.onConnect.bind(this);
                                        provider.on("connect", connect);
                                    }
                                }
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this);
            }
        };
    });
}
function $618bc8d87e24d77b$var$findProvider(window1, select) {
    function isProvider(provider) {
        if (typeof select === "function") return select(provider);
        if (typeof select === "string") return provider[select];
        return true;
    }
    var ethereum = window1.ethereum;
    if (ethereum === null || ethereum === void 0 ? void 0 : ethereum.providers) return ethereum.providers.find(function(provider) {
        return isProvider(provider);
    });
    if (ethereum && isProvider(ethereum)) return ethereum;
    return undefined;
}



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $do9pw = parcelRequire("do9pw");
var $113ab3d9ed3b6666$exports = {};
"use strict";
var $113ab3d9ed3b6666$var$has = Object.prototype.hasOwnProperty, $113ab3d9ed3b6666$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $113ab3d9ed3b6666$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $113ab3d9ed3b6666$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $113ab3d9ed3b6666$var$Events().__proto__) $113ab3d9ed3b6666$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $113ab3d9ed3b6666$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $113ab3d9ed3b6666$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $113ab3d9ed3b6666$var$EE(fn, context || emitter, once), evt = $113ab3d9ed3b6666$var$prefix ? $113ab3d9ed3b6666$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $113ab3d9ed3b6666$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $113ab3d9ed3b6666$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $113ab3d9ed3b6666$var$EventEmitter() {
    this._events = new $113ab3d9ed3b6666$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $113ab3d9ed3b6666$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($113ab3d9ed3b6666$var$has.call(events, name)) names.push($113ab3d9ed3b6666$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $113ab3d9ed3b6666$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $113ab3d9ed3b6666$var$prefix ? $113ab3d9ed3b6666$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $113ab3d9ed3b6666$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $113ab3d9ed3b6666$var$prefix ? $113ab3d9ed3b6666$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $113ab3d9ed3b6666$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $113ab3d9ed3b6666$var$prefix ? $113ab3d9ed3b6666$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $113ab3d9ed3b6666$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $113ab3d9ed3b6666$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $113ab3d9ed3b6666$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $113ab3d9ed3b6666$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $113ab3d9ed3b6666$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $113ab3d9ed3b6666$var$prefix ? $113ab3d9ed3b6666$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $113ab3d9ed3b6666$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $113ab3d9ed3b6666$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $113ab3d9ed3b6666$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $113ab3d9ed3b6666$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $113ab3d9ed3b6666$var$prefix ? $113ab3d9ed3b6666$var$prefix + event : event;
        if (this._events[evt]) $113ab3d9ed3b6666$var$clearEvent(this, evt);
    } else {
        this._events = new $113ab3d9ed3b6666$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$113ab3d9ed3b6666$var$EventEmitter.prototype.off = $113ab3d9ed3b6666$var$EventEmitter.prototype.removeListener;
$113ab3d9ed3b6666$var$EventEmitter.prototype.addListener = $113ab3d9ed3b6666$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$113ab3d9ed3b6666$var$EventEmitter.prefixed = $113ab3d9ed3b6666$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$113ab3d9ed3b6666$var$EventEmitter.EventEmitter = $113ab3d9ed3b6666$var$EventEmitter;
$113ab3d9ed3b6666$exports = $113ab3d9ed3b6666$var$EventEmitter;


var $feb93b13dbd69bb3$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($113ab3d9ed3b6666$exports)));


var $6b4978379027cbc0$export$4293555f241ae35a = /*#__PURE__*/ function() {
    "use strict";
    function Emitter(uid) {
        (0, $4GJKx._)(this, Emitter);
        Object.defineProperty(this, "uid", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: uid
        });
        Object.defineProperty(this, "_emitter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new (0, (/*@__PURE__*/$parcel$interopDefault($113ab3d9ed3b6666$exports)))()
        });
    }
    (0, $1wc17._)(Emitter, [
        {
            key: "on",
            value: function on(eventName, fn) {
                this._emitter.on(eventName, fn);
            }
        },
        {
            key: "once",
            value: function once(eventName, fn) {
                this._emitter.once(eventName, fn);
            }
        },
        {
            key: "off",
            value: function off(eventName, fn) {
                this._emitter.off(eventName, fn);
            }
        },
        {
            key: "emit",
            value: function emit(eventName) {
                for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    params[_key - 1] = arguments[_key];
                }
                var data = params[0];
                this._emitter.emit(eventName, (0, $do9pw._)({
                    uid: this.uid
                }, data));
            }
        },
        {
            key: "listenerCount",
            value: function listenerCount(eventName) {
                return this._emitter.listenerCount(eventName);
            }
        }
    ]);
    return Emitter;
}();
function $6b4978379027cbc0$export$6f5e8f34570e3ad1(uid) {
    return new $6b4978379027cbc0$export$4293555f241ae35a(uid);
}



var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $eha6O = parcelRequire("eha6O");
function $61df247699c48a42$export$efcd34ab6248d3cd(value, reviver) {
    return JSON.parse(value, function(key, value_) {
        var _$value = value_;
        if ((_$value === null || _$value === void 0 ? void 0 : _$value.__type) === "bigint") _$value = BigInt(_$value.value);
        if ((_$value === null || _$value === void 0 ? void 0 : _$value.__type) === "Map") _$value = new Map(_$value.value);
        var _reviver;
        return (_reviver = reviver === null || reviver === void 0 ? void 0 : reviver(key, _$value)) !== null && _reviver !== void 0 ? _reviver : _$value;
    });
}


/**
 * Get the reference key for the circular value
 *
 * @param keys the keys to build the reference key from
 * @param cutoff the maximum number of keys to include
 * @returns the reference key
 */ 
var $l0HdX = parcelRequire("l0HdX");
function $91b079192540124d$var$getReferenceKey(keys, cutoff) {
    return keys.slice(0, cutoff).join(".") || ".";
}
/**
 * Faster `Array.prototype.indexOf` implementation build for slicing / splicing
 *
 * @param array the array to match the value in
 * @param value the value to match
 * @returns the matching index, or -1
 */ function $91b079192540124d$var$getCutoff(array, value) {
    var length = array.length;
    for(var index = 0; index < length; ++index){
        if (array[index] === value) return index + 1;
    }
    return 0;
}
/**
 * Create a replacer method that handles circular values
 *
 * @param [replacer] a custom replacer to use for non-circular values
 * @param [circularReplacer] a custom replacer to use for circular methods
 * @returns the value to stringify
 */ function $91b079192540124d$var$createReplacer(replacer, circularReplacer) {
    var hasReplacer = typeof replacer === "function";
    var hasCircularReplacer = typeof circularReplacer === "function";
    var cache = [];
    var keys = [];
    return function replace(key, value) {
        if (typeof value === "object") {
            if (cache.length) {
                var thisCutoff = $91b079192540124d$var$getCutoff(cache, this);
                if (thisCutoff === 0) cache[cache.length] = this;
                else {
                    cache.splice(thisCutoff);
                    keys.splice(thisCutoff);
                }
                keys[keys.length] = key;
                var valueCutoff = $91b079192540124d$var$getCutoff(cache, value);
                if (valueCutoff !== 0) return hasCircularReplacer ? circularReplacer.call(this, key, value, $91b079192540124d$var$getReferenceKey(keys, valueCutoff)) : "[ref=".concat($91b079192540124d$var$getReferenceKey(keys, valueCutoff), "]");
            } else {
                cache[0] = value;
                keys[0] = key;
            }
        }
        return hasReplacer ? replacer.call(this, key, value) : value;
    };
}
function $91b079192540124d$export$dfdc1655ccc5b9cb(value, replacer, indent, circularReplacer) {
    return JSON.stringify(value, $91b079192540124d$var$createReplacer(function(key, value_) {
        var _$value = value_;
        if ((typeof _$value === "undefined" ? "undefined" : (0, $l0HdX._)(_$value)) === "bigint") _$value = {
            __type: "bigint",
            value: value_.toString()
        };
        if (_$value instanceof Map) _$value = {
            __type: "Map",
            value: Array.from(value_.entries())
        };
        var _replacer;
        return (_replacer = replacer === null || replacer === void 0 ? void 0 : replacer(key, _$value)) !== null && _replacer !== void 0 ? _replacer : _$value;
    }, circularReplacer), indent !== null && indent !== void 0 ? indent : undefined);
}


function $ce02504bd055b819$export$d184a47a971dd4b9(parameters) {
    var _parameters_deserialize = parameters.deserialize, deserialize = _parameters_deserialize === void 0 ? (0, $61df247699c48a42$export$efcd34ab6248d3cd) : _parameters_deserialize, tmp = parameters.key, prefix = tmp === void 0 ? "wagmi" : tmp, _parameters_serialize = parameters.serialize, serialize = _parameters_serialize === void 0 ? (0, $91b079192540124d$export$dfdc1655ccc5b9cb) : _parameters_serialize, _parameters_storage = parameters.storage, storage = _parameters_storage === void 0 ? $ce02504bd055b819$export$e2ef6c4b988c05b : _parameters_storage;
    function unwrap(value) {
        if (value instanceof Promise) return value.then(function(x) {
            return x;
        }).catch(function() {
            return null;
        });
        return value;
    }
    return (0, $cxjpp._)((0, $do9pw._)({}, storage), {
        key: prefix,
        getItem: function(key, defaultValue) {
            return (0, $kSuI9._)(function() {
                var value, unwrapped, _deserialize;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            value = storage.getItem("".concat(prefix, ".").concat(key));
                            return [
                                4,
                                unwrap(value)
                            ];
                        case 1:
                            unwrapped = _state.sent();
                            if (unwrapped) return [
                                2,
                                (_deserialize = deserialize(unwrapped)) !== null && _deserialize !== void 0 ? _deserialize : null
                            ];
                            return [
                                2,
                                defaultValue !== null && defaultValue !== void 0 ? defaultValue : null
                            ];
                    }
                });
            })();
        },
        setItem: function(key, value) {
            return (0, $kSuI9._)(function() {
                var storageKey;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            storageKey = "".concat(prefix, ".").concat(key);
                            if (!(value === null)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                unwrap(storage.removeItem(storageKey))
                            ];
                        case 1:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                unwrap(storage.setItem(storageKey, serialize(value)))
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        removeItem: function(key) {
            return (0, $kSuI9._)(function() {
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                unwrap(storage.removeItem("".concat(prefix, ".").concat(key)))
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    });
}
var $ce02504bd055b819$export$e2ef6c4b988c05b = {
    getItem: function() {
        return null;
    },
    setItem: function() {},
    removeItem: function() {}
};



var $182501e71ada3481$var$size = 256;
var $182501e71ada3481$var$index = $182501e71ada3481$var$size;
var $182501e71ada3481$var$buffer;
function $182501e71ada3481$export$e2a22331486dcca0() {
    var length = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 11;
    if (!$182501e71ada3481$var$buffer || $182501e71ada3481$var$index + length > $182501e71ada3481$var$size * 2) {
        $182501e71ada3481$var$buffer = "";
        $182501e71ada3481$var$index = 0;
        for(var i = 0; i < $182501e71ada3481$var$size; i++)$182501e71ada3481$var$buffer += (256 + Math.random() * 256 | 0).toString(16).substring(1);
    }
    return $182501e71ada3481$var$buffer.substring($182501e71ada3481$var$index, $182501e71ada3481$var$index++ + length);
}



function $93f05fdf2144e397$export$45a69314cf48a3eb(parameters) {
    var _parameters_multiInjectedProviderDiscovery = parameters.multiInjectedProviderDiscovery, multiInjectedProviderDiscovery = _parameters_multiInjectedProviderDiscovery === void 0 ? true : _parameters_multiInjectedProviderDiscovery, _parameters_storage = parameters.storage, storage = _parameters_storage === void 0 ? (0, $ce02504bd055b819$export$d184a47a971dd4b9)({
        storage: typeof window !== "undefined" && window.localStorage ? window.localStorage : (0, $ce02504bd055b819$export$e2ef6c4b988c05b)
    }) : _parameters_storage, _parameters_syncConnectedChain = parameters.syncConnectedChain, syncConnectedChain = _parameters_syncConnectedChain === void 0 ? true : _parameters_syncConnectedChain, _parameters_ssr = parameters.ssr, ssr = _parameters_ssr === void 0 ? false : _parameters_ssr, rest = (0, $dRLPW._)(parameters, [
        "multiInjectedProviderDiscovery",
        "storage",
        "syncConnectedChain",
        "ssr"
    ]);
    /////////////////////////////////////////////////////////////////////////////////////////////////
    // Set up connectors, clients, etc.
    /////////////////////////////////////////////////////////////////////////////////////////////////
    var mipd = typeof window !== "undefined" && multiInjectedProviderDiscovery ? (0, $ff2d63981562eb5a$export$f51a9068ac82ea43)() : undefined;
    var chains = (0, $16360e4fdff57925$export$f51a9068ac82ea43)(function() {
        return rest.chains;
    });
    var connectors = (0, $16360e4fdff57925$export$f51a9068ac82ea43)(function() {
        var _rest_connectors, _mipd_getProviders_map;
        return (0, $c6Xmf._)((_rest_connectors = rest.connectors) !== null && _rest_connectors !== void 0 ? _rest_connectors : []).concat((0, $c6Xmf._)(!ssr ? (_mipd_getProviders_map = mipd === null || mipd === void 0 ? void 0 : mipd.getProviders().map(providerDetailToConnector)) !== null && _mipd_getProviders_map !== void 0 ? _mipd_getProviders_map : [] : [])).map(setup);
    });
    function setup(connectorFn) {
        var _connector_setup;
        // Set up emitter with uid and add to connector so they are "linked" together.
        var emitter = (0, $6b4978379027cbc0$export$6f5e8f34570e3ad1)((0, $182501e71ada3481$export$e2a22331486dcca0)());
        var connector = (0, $cxjpp._)((0, $do9pw._)({}, connectorFn({
            emitter: emitter,
            chains: chains.getState(),
            storage: storage,
            transports: rest.transports
        })), {
            emitter: emitter,
            uid: emitter.uid
        });
        // Start listening for `connect` events on connector setup
        // This allows connectors to "connect" themselves without user interaction (e.g. MetaMask's "Manually connect to current site")
        emitter.on("connect", connect);
        (_connector_setup = connector.setup) === null || _connector_setup === void 0 ? void 0 : _connector_setup.call(connector);
        return connector;
    }
    function providerDetailToConnector(providerDetail) {
        var info = providerDetail.info;
        var provider = providerDetail.provider;
        return (0, $618bc8d87e24d77b$export$a7a34dad4983656f)({
            target: (0, $cxjpp._)((0, $do9pw._)({}, info), {
                id: info.rdns,
                provider: provider
            })
        });
    }
    var clients = new Map();
    function getClient() {
        var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var _config_chainId;
        var chainId = (_config_chainId = config.chainId) !== null && _config_chainId !== void 0 ? _config_chainId : store.getState().chainId;
        var chain = chains.getState().find(function(x) {
            return x.id === chainId;
        });
        // chainId specified and not configured
        if (config.chainId && !chain) throw new (0, $ad7a5f8bd0b5662c$export$688e5fda4b4631ed)();
        {
            var client = clients.get(store.getState().chainId);
            if (client && !chain) return client;
            if (!chain) throw new (0, $ad7a5f8bd0b5662c$export$688e5fda4b4631ed)();
        }
        // If a memoized client exists for a chain id, use that.
        {
            var client1 = clients.get(chainId);
            if (client1) return client1;
        }
        var client2;
        if (rest.client) client2 = rest.client({
            chain: chain
        });
        else {
            var chainId1 = chain.id;
            var chainIds = chains.getState().map(function(x) {
                return x.id;
            });
            // Grab all properties off `rest` and resolve for use in `createClient`
            var properties = {};
            var entries = Object.entries(rest);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                var _loop = function() {
                    var _step_value = (0, $cv9Rk._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                    if (key === "chains" || key === "client" || key === "connectors" || key === "transports") return "continue";
                    if (typeof value === "object") {
                        // check if value is chainId-specific since some values can be objects
                        // e.g. { batch: { multicall: { batchSize: 1024 } } }
                        if (chainId1 in value) properties[key] = value[chainId1];
                        else {
                            // check if value is chainId-specific, but does not have value for current chainId
                            var hasChainSpecificValue = chainIds.some(function(x) {
                                return x in value;
                            });
                            if (hasChainSpecificValue) return "continue";
                            properties[key] = value;
                        }
                    } else properties[key] = value;
                };
                for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var _properties_batch;
            client2 = (0, $3b636b6bfcd71602$export$5d730b7aed1a3eb0)((0, $cxjpp._)((0, $do9pw._)({}, properties), {
                chain: chain,
                batch: (_properties_batch = properties.batch) !== null && _properties_batch !== void 0 ? _properties_batch : {
                    multicall: true
                },
                transport: function(parameters) {
                    return rest.transports[chainId1]((0, $cxjpp._)((0, $do9pw._)({}, parameters), {
                        connectors: connectors
                    }));
                }
            }));
        }
        clients.set(chainId, client2);
        return client2;
    }
    /////////////////////////////////////////////////////////////////////////////////////////////////
    // Create store
    /////////////////////////////////////////////////////////////////////////////////////////////////
    function getInitialState() {
        return {
            chainId: chains.getState()[0].id,
            connections: new Map(),
            current: null,
            status: "disconnected"
        };
    }
    var currentVersion;
    var prefix = "0.0.0-canary-";
    var _version_split_;
    if ((0, $4441ec449835927d$export$83d89fbfd8236492).startsWith(prefix)) currentVersion = Number.parseInt((0, $4441ec449835927d$export$83d89fbfd8236492).replace(prefix, ""));
    else currentVersion = Number.parseInt((_version_split_ = (0, $4441ec449835927d$export$83d89fbfd8236492).split(".")[0]) !== null && _version_split_ !== void 0 ? _version_split_ : "0");
    var store = (0, $16360e4fdff57925$export$f51a9068ac82ea43)((0, $69f3bd0e82bb1626$export$5c593627aef9f076)(// only use persist middleware if storage exists
    storage ? (0, $69f3bd0e82bb1626$export$9a6132153fba2e0)(getInitialState, {
        migrate: function(persistedState, version) {
            if (version === currentVersion) return persistedState;
            var initialState = getInitialState();
            var chainId = validatePersistedChainId(persistedState, initialState.chainId);
            return (0, $cxjpp._)((0, $do9pw._)({}, initialState), {
                chainId: chainId
            });
        },
        name: "store",
        partialize: function(state) {
            // Only persist "critical" store properties to preserve storage size.
            return {
                connections: {
                    __type: "Map",
                    value: Array.from(state.connections.entries()).map(function(param) {
                        var _param = (0, $cv9Rk._)(param, 2), key = _param[0], connection = _param[1];
                        var _connection_connector = connection.connector, id = _connection_connector.id, name = _connection_connector.name, type = _connection_connector.type, uid = _connection_connector.uid;
                        var connector = {
                            id: id,
                            name: name,
                            type: type,
                            uid: uid
                        };
                        return [
                            key,
                            (0, $cxjpp._)((0, $do9pw._)({}, connection), {
                                connector: connector
                            })
                        ];
                    })
                },
                chainId: state.chainId,
                current: state.current
            };
        },
        merge: function(persistedState, currentState) {
            // `status` should not be persisted as it messes with reconnection
            if (typeof persistedState === "object" && persistedState && "status" in persistedState) delete persistedState.status;
            // Make sure persisted `chainId` is valid
            var chainId = validatePersistedChainId(persistedState, currentState.chainId);
            return (0, $cxjpp._)((0, $do9pw._)({}, currentState, persistedState), {
                chainId: chainId
            });
        },
        skipHydration: ssr,
        storage: storage,
        version: currentVersion
    }) : getInitialState));
    function validatePersistedChainId(persistedState, defaultChainId) {
        return persistedState && typeof persistedState === "object" && "chainId" in persistedState && typeof persistedState.chainId === "number" && chains.getState().some(function(x) {
            return x.id === persistedState.chainId;
        }) ? persistedState.chainId : defaultChainId;
    }
    /////////////////////////////////////////////////////////////////////////////////////////////////
    // Subscribe to changes
    /////////////////////////////////////////////////////////////////////////////////////////////////
    // Update default chain when connector chain changes
    if (syncConnectedChain) store.subscribe(function(param) {
        var connections = param.connections, current = param.current;
        var _connections_get;
        return current ? (_connections_get = connections.get(current)) === null || _connections_get === void 0 ? void 0 : _connections_get.chainId : undefined;
    }, function(chainId) {
        // If chain is not configured, then don't switch over to it.
        var isChainConfigured = chains.getState().some(function(x) {
            return x.id === chainId;
        });
        if (!isChainConfigured) return;
        return store.setState(function(x) {
            return (0, $cxjpp._)((0, $do9pw._)({}, x), {
                chainId: chainId !== null && chainId !== void 0 ? chainId : x.chainId
            });
        });
    });
    // EIP-6963 subscribe for new wallet providers
    mipd === null || mipd === void 0 ? void 0 : mipd.subscribe(function(providerDetails) {
        var currentConnectorIds = new Map();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = connectors.getState()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var connector = _step.value;
                currentConnectorIds.set(connector.id, true);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var newConnectors = [];
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = providerDetails[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var providerDetail = _step1.value;
                var connector1 = setup(providerDetailToConnector(providerDetail));
                if (currentConnectorIds.has(connector1.id)) continue;
                newConnectors.push(connector1);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        if (storage && !store.persist.hasHydrated()) return;
        connectors.setState(function(x) {
            return (0, $c6Xmf._)(x).concat((0, $c6Xmf._)(newConnectors));
        }, true);
    });
    /////////////////////////////////////////////////////////////////////////////////////////////////
    // Emitter listeners
    /////////////////////////////////////////////////////////////////////////////////////////////////
    function change(data) {
        store.setState(function(x) {
            var connection = x.connections.get(data.uid);
            if (!connection) return x;
            var _data_accounts, _data_chainId;
            return (0, $cxjpp._)((0, $do9pw._)({}, x), {
                connections: new Map(x.connections).set(data.uid, {
                    accounts: (_data_accounts = data.accounts) !== null && _data_accounts !== void 0 ? _data_accounts : connection.accounts,
                    chainId: (_data_chainId = data.chainId) !== null && _data_chainId !== void 0 ? _data_chainId : connection.chainId,
                    connector: connection.connector
                })
            });
        });
    }
    function connect(data) {
        // Disable handling if reconnecting/connecting
        if (store.getState().status === "connecting" || store.getState().status === "reconnecting") return;
        store.setState(function(x) {
            var connector = connectors.getState().find(function(x) {
                return x.uid === data.uid;
            });
            if (!connector) return x;
            if (connector.emitter.listenerCount("connect")) connector.emitter.off("connect", change);
            if (!connector.emitter.listenerCount("change")) connector.emitter.on("change", change);
            if (!connector.emitter.listenerCount("disconnect")) connector.emitter.on("disconnect", disconnect);
            return (0, $cxjpp._)((0, $do9pw._)({}, x), {
                connections: new Map(x.connections).set(data.uid, {
                    accounts: data.accounts,
                    chainId: data.chainId,
                    connector: connector
                }),
                current: data.uid,
                status: "connected"
            });
        });
    }
    function disconnect(data) {
        store.setState(function(x) {
            var connection = x.connections.get(data.uid);
            if (connection) {
                var connector = connection.connector;
                if (connector.emitter.listenerCount("change")) connection.connector.emitter.off("change", change);
                if (connector.emitter.listenerCount("disconnect")) connection.connector.emitter.off("disconnect", disconnect);
                if (!connector.emitter.listenerCount("connect")) connection.connector.emitter.on("connect", connect);
            }
            x.connections.delete(data.uid);
            if (x.connections.size === 0) return (0, $cxjpp._)((0, $do9pw._)({}, x), {
                connections: new Map(),
                current: null,
                status: "disconnected"
            });
            var nextConnection = x.connections.values().next().value;
            return (0, $cxjpp._)((0, $do9pw._)({}, x), {
                connections: new Map(x.connections),
                current: nextConnection.connector.uid
            });
        });
    }
    return {
        get chains () {
            return chains.getState();
        },
        get connectors () {
            return connectors.getState();
        },
        storage: storage,
        getClient: getClient,
        get state () {
            return store.getState();
        },
        setState: function(value) {
            var newState;
            if (typeof value === "function") newState = value(store.getState());
            else newState = value;
            // Reset state if it got set to something not matching the base state
            var initialState = getInitialState();
            if (typeof newState !== "object") newState = initialState;
            var isCorrupt = Object.keys(initialState).some(function(x) {
                return !(x in newState);
            });
            if (isCorrupt) newState = initialState;
            store.setState(newState, true);
        },
        subscribe: function(selector, listener, options) {
            return store.subscribe(selector, listener, options ? (0, $cxjpp._)((0, $do9pw._)({}, options), {
                fireImmediately: options.emitImmediately
            }) : undefined);
        },
        _internal: {
            mipd: mipd,
            store: store,
            ssr: Boolean(ssr),
            syncConnectedChain: syncConnectedChain,
            transports: rest.transports,
            chains: {
                setState: function(value) {
                    var nextChains = typeof value === "function" ? value(chains.getState()) : value;
                    if (nextChains.length === 0) return;
                    return chains.setState(nextChains, true);
                },
                subscribe: function(listener) {
                    return chains.subscribe(listener);
                }
            },
            connectors: {
                providerDetailToConnector: providerDetailToConnector,
                setup: setup,
                setState: function(value) {
                    return connectors.setState(typeof value === "function" ? value(connectors.getState()) : value, true);
                },
                subscribe: function(listener) {
                    return connectors.subscribe(listener);
                }
            },
            events: {
                change: change,
                connect: connect,
                disconnect: disconnect
            }
        }
    };
}



var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $eha6O = parcelRequire("eha6O");
function $aa5d274cf8fbe9a1$export$c04fcecb1d6d70c7(parameters) {
    var _parameters_transports_chain_id, _parameters_transports, _transport_value;
    var chain = parameters.chain;
    var fallbackUrl = chain.rpcUrls.default.http[0];
    if (!parameters.transports) return [
        fallbackUrl
    ];
    var transport = (_parameters_transports = parameters.transports) === null || _parameters_transports === void 0 ? void 0 : (_parameters_transports_chain_id = _parameters_transports[chain.id]) === null || _parameters_transports_chain_id === void 0 ? void 0 : _parameters_transports_chain_id.call(_parameters_transports, {
        chain: chain
    });
    var transports = (transport === null || transport === void 0 ? void 0 : (_transport_value = transport.value) === null || _transport_value === void 0 ? void 0 : _transport_value.transports) || [
        transport
    ];
    return transports.map(function(param) {
        var value = param.value;
        return (value === null || value === void 0 ? void 0 : value.url) || fallbackUrl;
    });
}



var $8zfHX = parcelRequire("8zfHX");
var $aqVrP = parcelRequire("aqVrP");
var $f3VZN = parcelRequire("f3VZN");
$bb0235625fedf18a$export$340cc50ae9d9f255.type = "walletConnect";

function $bb0235625fedf18a$export$340cc50ae9d9f255(parameters) {
    var _parameters_isNewChainsStale;
    var isNewChainsStale = (_parameters_isNewChainsStale = parameters.isNewChainsStale) !== null && _parameters_isNewChainsStale !== void 0 ? _parameters_isNewChainsStale : true;
    var provider_;
    var providerPromise;
    var NAMESPACE = "eip155";
    var accountsChanged;
    var chainChanged;
    var connect;
    var displayUri;
    var sessionDelete;
    var disconnect;
    return (0, $b10dbf4ad6df2f47$export$36e7227504c841ea)(function(config) {
        return {
            id: "walletConnect",
            name: "WalletConnect",
            type: $bb0235625fedf18a$export$340cc50ae9d9f255.type,
            setup: function() {
                return (0, $kSuI9._)(function() {
                    var provider;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getProvider().catch(function() {
                                        return null;
                                    })
                                ];
                            case 1:
                                provider = _state.sent();
                                if (!provider) return [
                                    2
                                ];
                                if (!connect) {
                                    connect = this.onConnect.bind(this);
                                    provider.on("connect", connect);
                                }
                                if (!sessionDelete) {
                                    sessionDelete = this.onSessionDelete.bind(this);
                                    provider.on("session_delete", sessionDelete);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this);
            },
            connect: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                return (0, $kSuI9._)(function() {
                    var chainId, rest, provider, targetChainId, _config_storage, _config_chains_, _ref, state, isChainSupported, isChainsStale, optionalChains, accounts, currentChainId, error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                chainId = _param.chainId, rest = (0, $dRLPW._)(_param, [
                                    "chainId"
                                ]);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    12,
                                    ,
                                    13
                                ]);
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 2:
                                provider = _state.sent();
                                if (!provider) throw new (0, $280108186d4a00cc$export$43839b3ff6336f15)();
                                if (!displayUri) {
                                    displayUri = this.onDisplayUri;
                                    provider.on("display_uri", displayUri);
                                }
                                targetChainId = chainId;
                                if (!!targetChainId) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    (_config_storage = config.storage) === null || _config_storage === void 0 ? void 0 : _config_storage.getItem("state")
                                ];
                            case 3:
                                state = (_ref = _state.sent()) !== null && _ref !== void 0 ? _ref : {};
                                isChainSupported = config.chains.some(function(x) {
                                    return x.id === state.chainId;
                                });
                                if (isChainSupported) targetChainId = state.chainId;
                                else targetChainId = (_config_chains_ = config.chains[0]) === null || _config_chains_ === void 0 ? void 0 : _config_chains_.id;
                                _state.label = 4;
                            case 4:
                                if (!targetChainId) throw new Error("No chains found on connector.");
                                return [
                                    4,
                                    this.isChainsStale()
                                ];
                            case 5:
                                isChainsStale = _state.sent();
                                if (!(provider.session && isChainsStale)) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    provider.disconnect()
                                ];
                            case 6:
                                _state.sent();
                                _state.label = 7;
                            case 7:
                                if (!(!provider.session || isChainsStale)) return [
                                    3,
                                    9
                                ];
                                optionalChains = config.chains.filter(function(chain) {
                                    return chain.id !== targetChainId;
                                }).map(function(optionalChain) {
                                    return optionalChain.id;
                                });
                                return [
                                    4,
                                    provider.connect((0, $do9pw._)({
                                        optionalChains: [
                                            targetChainId
                                        ].concat((0, $c6Xmf._)(optionalChains))
                                    }, "pairingTopic" in rest ? {
                                        pairingTopic: rest.pairingTopic
                                    } : {}))
                                ];
                            case 8:
                                _state.sent();
                                this.setRequestedChainsIds(config.chains.map(function(x) {
                                    return x.id;
                                }));
                                _state.label = 9;
                            case 9:
                                return [
                                    4,
                                    provider.enable()
                                ];
                            case 10:
                                accounts = _state.sent().map(function(x) {
                                    return (0, $8zfHX.getAddress)(x);
                                });
                                return [
                                    4,
                                    this.getChainId()
                                ];
                            case 11:
                                currentChainId = _state.sent();
                                if (displayUri) {
                                    provider.removeListener("display_uri", displayUri);
                                    displayUri = undefined;
                                }
                                if (connect) {
                                    provider.removeListener("connect", connect);
                                    connect = undefined;
                                }
                                if (!accountsChanged) {
                                    accountsChanged = this.onAccountsChanged.bind(this);
                                    provider.on("accountsChanged", accountsChanged);
                                }
                                if (!chainChanged) {
                                    chainChanged = this.onChainChanged.bind(this);
                                    provider.on("chainChanged", chainChanged);
                                }
                                if (!disconnect) {
                                    disconnect = this.onDisconnect.bind(this);
                                    provider.on("disconnect", disconnect);
                                }
                                if (!sessionDelete) {
                                    sessionDelete = this.onSessionDelete.bind(this);
                                    provider.on("session_delete", sessionDelete);
                                }
                                return [
                                    2,
                                    {
                                        accounts: accounts,
                                        chainId: currentChainId
                                    }
                                ];
                            case 12:
                                error = _state.sent();
                                if (/(user rejected|connection request reset)/i.test(error === null || error === void 0 ? void 0 : error.message)) throw new (0, $aqVrP.UserRejectedRequestError)(error);
                                throw error;
                            case 13:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this);
            },
            disconnect: function() {
                return (0, $kSuI9._)(function() {
                    var provider, error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    5,
                                    6
                                ]);
                                return [
                                    4,
                                    provider === null || provider === void 0 ? void 0 : provider.disconnect()
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                error = _state.sent();
                                if (!/No matching key/i.test(error.message)) throw error;
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                if (chainChanged) {
                                    provider === null || provider === void 0 ? void 0 : provider.removeListener("chainChanged", chainChanged);
                                    chainChanged = undefined;
                                }
                                if (disconnect) {
                                    provider === null || provider === void 0 ? void 0 : provider.removeListener("disconnect", disconnect);
                                    disconnect = undefined;
                                }
                                if (!connect) {
                                    connect = this.onConnect.bind(this);
                                    provider === null || provider === void 0 ? void 0 : provider.on("connect", connect);
                                }
                                if (accountsChanged) {
                                    provider === null || provider === void 0 ? void 0 : provider.removeListener("accountsChanged", accountsChanged);
                                    accountsChanged = undefined;
                                }
                                if (sessionDelete) {
                                    provider === null || provider === void 0 ? void 0 : provider.removeListener("session_delete", sessionDelete);
                                    sessionDelete = undefined;
                                }
                                this.setRequestedChainsIds([]);
                                return [
                                    7
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this);
            },
            getAccounts: function() {
                return (0, $kSuI9._)(function() {
                    var provider;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                return [
                                    2,
                                    provider.accounts.map(function(x) {
                                        return (0, $8zfHX.getAddress)(x);
                                    })
                                ];
                        }
                    });
                }).apply(this);
            },
            getProvider: function() {
                var chainId = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).chainId;
                return (0, $kSuI9._)(function() {
                    var _this_switchChain, _this;
                    function initProvider() {
                        return _initProvider.apply(this, arguments);
                    }
                    function _initProvider() {
                        _initProvider = (0, $kSuI9._)(function() {
                            var optionalChains, EthereumProvider, _parameters_showQrModal;
                            return (0, $eha6O.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        optionalChains = config.chains.map(function(x) {
                                            return x.id;
                                        });
                                        if (!optionalChains.length) return [
                                            2
                                        ];
                                        return [
                                            4,
                                            Promise.resolve((parcelRequire("cTdql")))
                                        ];
                                    case 1:
                                        EthereumProvider = _state.sent().EthereumProvider;
                                        return [
                                            4,
                                            EthereumProvider.init((0, $cxjpp._)((0, $do9pw._)({}, parameters), {
                                                disableProviderPing: true,
                                                optionalChains: optionalChains,
                                                projectId: parameters.projectId,
                                                rpcMap: Object.fromEntries(config.chains.map(function(chain) {
                                                    var _extractRpcUrls = (0, $cv9Rk._)((0, $aa5d274cf8fbe9a1$export$c04fcecb1d6d70c7)({
                                                        chain: chain,
                                                        transports: config.transports
                                                    }), 1), url = _extractRpcUrls[0];
                                                    return [
                                                        chain.id,
                                                        url
                                                    ];
                                                })),
                                                showQrModal: (_parameters_showQrModal = parameters.showQrModal) !== null && _parameters_showQrModal !== void 0 ? _parameters_showQrModal : true
                                            }))
                                        ];
                                    case 2:
                                        return [
                                            2,
                                            _state.sent()
                                        ];
                                }
                            });
                        });
                        return _initProvider.apply(this, arguments);
                    }
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!provider_) return [
                                    3,
                                    2
                                ];
                                if (!providerPromise) providerPromise = initProvider();
                                return [
                                    4,
                                    providerPromise
                                ];
                            case 1:
                                provider_ = _state.sent();
                                provider_ === null || provider_ === void 0 ? void 0 : provider_.events.setMaxListeners(Number.POSITIVE_INFINITY);
                                _state.label = 2;
                            case 2:
                                if (!chainId) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    (_this_switchChain = (_this = this).switchChain) === null || _this_switchChain === void 0 ? void 0 : _this_switchChain.call(_this, {
                                        chainId: chainId
                                    })
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    2,
                                    provider_
                                ];
                        }
                    });
                }).apply(this);
            },
            getChainId: function() {
                return (0, $kSuI9._)(function() {
                    var provider;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                return [
                                    2,
                                    provider.chainId
                                ];
                        }
                    });
                }).apply(this);
            },
            isAuthorized: function() {
                return (0, $kSuI9._)(function() {
                    var _ref, accounts, provider, isChainsStale, e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    Promise.all([
                                        this.getAccounts(),
                                        this.getProvider()
                                    ])
                                ];
                            case 1:
                                _ref = (0, $cv9Rk._).apply(void 0, [
                                    _state.sent(),
                                    2
                                ]), accounts = _ref[0], provider = _ref[1];
                                // If an account does not exist on the session, then the connector is unauthorized.
                                if (!accounts.length) return [
                                    2,
                                    false
                                ];
                                return [
                                    4,
                                    this.isChainsStale()
                                ];
                            case 2:
                                isChainsStale = _state.sent();
                                if (!(isChainsStale && provider.session)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    provider.disconnect().catch(function() {})
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2,
                                    false
                                ];
                            case 4:
                                return [
                                    2,
                                    true
                                ];
                            case 5:
                                e = _state.sent();
                                return [
                                    2,
                                    false
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this);
            },
            switchChain: function(param) {
                var addEthereumChainParameter = param.addEthereumChainParameter, chainId = param.chainId;
                return (0, $kSuI9._)(function() {
                    var provider, chain, requestedChains, err, _$error, _chain_blockExplorers, _chain_blockExplorers1, _addEthereumChainParameter_rpcUrls, blockExplorerUrls, rpcUrls, _addEthereumChainParameter_chainName, _addEthereumChainParameter_nativeCurrency, addEthereumChain, requestedChains1, error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                if (!provider) throw new (0, $280108186d4a00cc$export$43839b3ff6336f15)();
                                chain = config.chains.find(function(x) {
                                    return x.id === chainId;
                                });
                                if (!chain) throw new (0, $aqVrP.SwitchChainError)(new (0, $ad7a5f8bd0b5662c$export$688e5fda4b4631ed)());
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    5,
                                    ,
                                    11
                                ]);
                                return [
                                    4,
                                    Promise.all([
                                        new Promise(function(resolve) {
                                            var listener = function(param) {
                                                var currentChainId = param.chainId;
                                                if (currentChainId === chainId) {
                                                    config.emitter.off("change", listener);
                                                    resolve();
                                                }
                                            };
                                            config.emitter.on("change", listener);
                                        }),
                                        provider.request({
                                            method: "wallet_switchEthereumChain",
                                            params: [
                                                {
                                                    chainId: (0, $f3VZN.numberToHex)(chainId)
                                                }
                                            ]
                                        })
                                    ])
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    4,
                                    this.getRequestedChainsIds()
                                ];
                            case 4:
                                requestedChains = _state.sent();
                                this.setRequestedChainsIds((0, $c6Xmf._)(requestedChains).concat([
                                    chainId
                                ]));
                                return [
                                    2,
                                    chain
                                ];
                            case 5:
                                err = _state.sent();
                                _$error = err;
                                if (/(user rejected)/i.test(_$error.message)) throw new (0, $aqVrP.UserRejectedRequestError)(_$error);
                                _state.label = 6;
                            case 6:
                                _state.trys.push([
                                    6,
                                    9,
                                    ,
                                    10
                                ]);
                                if (addEthereumChainParameter === null || addEthereumChainParameter === void 0 ? void 0 : addEthereumChainParameter.blockExplorerUrls) blockExplorerUrls = addEthereumChainParameter.blockExplorerUrls;
                                else blockExplorerUrls = ((_chain_blockExplorers = chain.blockExplorers) === null || _chain_blockExplorers === void 0 ? void 0 : _chain_blockExplorers.default.url) ? [
                                    (_chain_blockExplorers1 = chain.blockExplorers) === null || _chain_blockExplorers1 === void 0 ? void 0 : _chain_blockExplorers1.default.url
                                ] : [];
                                if (addEthereumChainParameter === null || addEthereumChainParameter === void 0 ? void 0 : (_addEthereumChainParameter_rpcUrls = addEthereumChainParameter.rpcUrls) === null || _addEthereumChainParameter_rpcUrls === void 0 ? void 0 : _addEthereumChainParameter_rpcUrls.length) rpcUrls = addEthereumChainParameter.rpcUrls;
                                else rpcUrls = (0, $c6Xmf._)(chain.rpcUrls.default.http);
                                addEthereumChain = {
                                    blockExplorerUrls: blockExplorerUrls,
                                    chainId: (0, $f3VZN.numberToHex)(chainId),
                                    chainName: (_addEthereumChainParameter_chainName = addEthereumChainParameter === null || addEthereumChainParameter === void 0 ? void 0 : addEthereumChainParameter.chainName) !== null && _addEthereumChainParameter_chainName !== void 0 ? _addEthereumChainParameter_chainName : chain.name,
                                    iconUrls: addEthereumChainParameter === null || addEthereumChainParameter === void 0 ? void 0 : addEthereumChainParameter.iconUrls,
                                    nativeCurrency: (_addEthereumChainParameter_nativeCurrency = addEthereumChainParameter === null || addEthereumChainParameter === void 0 ? void 0 : addEthereumChainParameter.nativeCurrency) !== null && _addEthereumChainParameter_nativeCurrency !== void 0 ? _addEthereumChainParameter_nativeCurrency : chain.nativeCurrency,
                                    rpcUrls: rpcUrls
                                };
                                return [
                                    4,
                                    provider.request({
                                        method: "wallet_addEthereumChain",
                                        params: [
                                            addEthereumChain
                                        ]
                                    })
                                ];
                            case 7:
                                _state.sent();
                                return [
                                    4,
                                    this.getRequestedChainsIds()
                                ];
                            case 8:
                                requestedChains1 = _state.sent();
                                this.setRequestedChainsIds((0, $c6Xmf._)(requestedChains1).concat([
                                    chainId
                                ]));
                                return [
                                    2,
                                    chain
                                ];
                            case 9:
                                error = _state.sent();
                                throw new (0, $aqVrP.UserRejectedRequestError)(error);
                            case 10:
                                return [
                                    3,
                                    11
                                ];
                            case 11:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this);
            },
            onAccountsChanged: function(accounts) {
                if (accounts.length === 0) this.onDisconnect();
                else config.emitter.emit("change", {
                    accounts: accounts.map(function(x) {
                        return (0, $8zfHX.getAddress)(x);
                    })
                });
            },
            onChainChanged: function(chain) {
                var chainId = Number(chain);
                config.emitter.emit("change", {
                    chainId: chainId
                });
            },
            onConnect: function(connectInfo) {
                return (0, $kSuI9._)(function() {
                    var chainId, accounts;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                chainId = Number(connectInfo.chainId);
                                return [
                                    4,
                                    this.getAccounts()
                                ];
                            case 1:
                                accounts = _state.sent();
                                config.emitter.emit("connect", {
                                    accounts: accounts,
                                    chainId: chainId
                                });
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this);
            },
            onDisconnect: function(_error) {
                return (0, $kSuI9._)(function() {
                    var provider;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this.setRequestedChainsIds([]);
                                config.emitter.emit("disconnect");
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                if (accountsChanged) {
                                    provider.removeListener("accountsChanged", accountsChanged);
                                    accountsChanged = undefined;
                                }
                                if (chainChanged) {
                                    provider.removeListener("chainChanged", chainChanged);
                                    chainChanged = undefined;
                                }
                                if (disconnect) {
                                    provider.removeListener("disconnect", disconnect);
                                    disconnect = undefined;
                                }
                                if (sessionDelete) {
                                    provider.removeListener("session_delete", sessionDelete);
                                    sessionDelete = undefined;
                                }
                                if (!connect) {
                                    connect = this.onConnect.bind(this);
                                    provider.on("connect", connect);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this);
            },
            onDisplayUri: function(uri) {
                config.emitter.emit("message", {
                    type: "display_uri",
                    data: uri
                });
            },
            onSessionDelete: function() {
                this.onDisconnect();
            },
            getNamespaceChainsIds: function() {
                var _provider__session_namespaces_NAMESPACE_accounts, _provider__session_namespaces_NAMESPACE, _provider__session;
                if (!provider_) return [];
                var chainIds = (_provider__session = provider_.session) === null || _provider__session === void 0 ? void 0 : (_provider__session_namespaces_NAMESPACE = _provider__session.namespaces[NAMESPACE]) === null || _provider__session_namespaces_NAMESPACE === void 0 ? void 0 : (_provider__session_namespaces_NAMESPACE_accounts = _provider__session_namespaces_NAMESPACE.accounts) === null || _provider__session_namespaces_NAMESPACE_accounts === void 0 ? void 0 : _provider__session_namespaces_NAMESPACE_accounts.map(function(account) {
                    return Number.parseInt(account.split(":")[1] || "");
                });
                return chainIds !== null && chainIds !== void 0 ? chainIds : [];
            },
            getRequestedChainsIds: function() {
                return (0, $kSuI9._)(function() {
                    var _config_storage, _ref;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (_config_storage = config.storage) === null || _config_storage === void 0 ? void 0 : _config_storage.getItem(this.requestedChainsStorageKey)
                                ];
                            case 1:
                                return [
                                    2,
                                    (_ref = _state.sent()) !== null && _ref !== void 0 ? _ref : []
                                ];
                        }
                    });
                }).apply(this);
            },
            isChainsStale: /**
         * Checks if the target chains match the chains that were
         * initially requested by the connector for the WalletConnect session.
         * If there is a mismatch, this means that the chains on the connector
         * are considered stale, and need to be revalidated at a later point (via
         * connection).
         *
         * There may be a scenario where a dapp adds a chain to the
         * connector later on, however, this chain will not have been approved or rejected
         * by the wallet. In this case, the chain is considered stale.
         */ function() {
                return (0, $kSuI9._)(function() {
                    var connectorChains, namespaceChains, requestedChains;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!isNewChainsStale) return [
                                    2,
                                    false
                                ];
                                connectorChains = config.chains.map(function(x) {
                                    return x.id;
                                });
                                namespaceChains = this.getNamespaceChainsIds();
                                if (namespaceChains.length && !namespaceChains.some(function(id) {
                                    return connectorChains.includes(id);
                                })) return [
                                    2,
                                    false
                                ];
                                return [
                                    4,
                                    this.getRequestedChainsIds()
                                ];
                            case 1:
                                requestedChains = _state.sent();
                                return [
                                    2,
                                    !connectorChains.every(function(id) {
                                        return requestedChains.includes(id);
                                    })
                                ];
                        }
                    });
                }).apply(this);
            },
            setRequestedChainsIds: function(chains) {
                return (0, $kSuI9._)(function() {
                    var _config_storage;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (_config_storage = config.storage) === null || _config_storage === void 0 ? void 0 : _config_storage.setItem(this.requestedChainsStorageKey, chains)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this);
            },
            get requestedChainsStorageKey () {
                return "".concat(this.id, ".requestedChains");
            }
        };
    });
}


var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $eha6O = parcelRequire("eha6O");


var $8zfHX = parcelRequire("8zfHX");
var $aqVrP = parcelRequire("aqVrP");
var $f3VZN = parcelRequire("f3VZN");
$f7a111e0ecc086fc$export$40dfb463b44d19b.type = "coinbaseWallet";
function $f7a111e0ecc086fc$export$40dfb463b44d19b() {
    var parameters = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (parameters.version === "3" || parameters.headlessMode) return $f7a111e0ecc086fc$var$version3(parameters);
    return $f7a111e0ecc086fc$var$version4(parameters);
}

function $f7a111e0ecc086fc$var$version4(parameters) {
    var sdk;
    var walletProvider;
    var accountsChanged;
    var chainChanged;
    var disconnect;
    return (0, $b10dbf4ad6df2f47$export$36e7227504c841ea)(function(config) {
        return {
            id: "coinbaseWalletSDK",
            name: "Coinbase Wallet",
            supportsSimulation: true,
            type: $f7a111e0ecc086fc$export$40dfb463b44d19b.type,
            connect: function() {
                var chainId = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).chainId;
                return (0, $kSuI9._)(function() {
                    var provider, accounts, currentChainId, chain, _chain_id, error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                return [
                                    4,
                                    provider.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 2:
                                accounts = _state.sent().map(function(x) {
                                    return (0, $8zfHX.getAddress)(x);
                                });
                                if (!accountsChanged) {
                                    accountsChanged = this.onAccountsChanged.bind(this);
                                    provider.on("accountsChanged", accountsChanged);
                                }
                                if (!chainChanged) {
                                    chainChanged = this.onChainChanged.bind(this);
                                    provider.on("chainChanged", chainChanged);
                                }
                                if (!disconnect) {
                                    disconnect = this.onDisconnect.bind(this);
                                    provider.on("disconnect", disconnect);
                                }
                                return [
                                    4,
                                    this.getChainId()
                                ];
                            case 3:
                                currentChainId = _state.sent();
                                if (!(chainId && currentChainId !== chainId)) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    this.switchChain({
                                        chainId: chainId
                                    }).catch(function(error) {
                                        if (error.code === (0, $aqVrP.UserRejectedRequestError).code) throw error;
                                        return {
                                            id: currentChainId
                                        };
                                    })
                                ];
                            case 4:
                                chain = _state.sent();
                                currentChainId = (_chain_id = chain === null || chain === void 0 ? void 0 : chain.id) !== null && _chain_id !== void 0 ? _chain_id : currentChainId;
                                _state.label = 5;
                            case 5:
                                return [
                                    2,
                                    {
                                        accounts: accounts,
                                        chainId: currentChainId
                                    }
                                ];
                            case 6:
                                error = _state.sent();
                                if (/(user closed modal|accounts received is empty|user denied account|request rejected)/i.test(error.message)) throw new (0, $aqVrP.UserRejectedRequestError)(error);
                                throw error;
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this);
            },
            disconnect: function() {
                return (0, $kSuI9._)(function() {
                    var _provider_close, provider;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                if (accountsChanged) {
                                    provider.removeListener("accountsChanged", accountsChanged);
                                    accountsChanged = undefined;
                                }
                                if (chainChanged) {
                                    provider.removeListener("chainChanged", chainChanged);
                                    chainChanged = undefined;
                                }
                                if (disconnect) {
                                    provider.removeListener("disconnect", disconnect);
                                    disconnect = undefined;
                                }
                                provider.disconnect();
                                (_provider_close = provider.close) === null || _provider_close === void 0 ? void 0 : _provider_close.call(provider);
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this);
            },
            getAccounts: function() {
                return (0, $kSuI9._)(function() {
                    var provider;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                return [
                                    4,
                                    provider.request({
                                        method: "eth_accounts"
                                    })
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent().map(function(x) {
                                        return (0, $8zfHX.getAddress)(x);
                                    })
                                ];
                        }
                    });
                }).apply(this);
            },
            getChainId: function() {
                return (0, $kSuI9._)(function() {
                    var provider, chainId;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                return [
                                    4,
                                    provider.request({
                                        method: "eth_chainId"
                                    })
                                ];
                            case 2:
                                chainId = _state.sent();
                                return [
                                    2,
                                    Number(chainId)
                                ];
                        }
                    });
                }).apply(this);
            },
            getProvider: function() {
                return (0, $kSuI9._)(function() {
                    var CoinbaseWalletSDK, _parameters_preference;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!walletProvider) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (0, $kSuI9._)(function() {
                                        var _ref, SDK;
                                        return (0, $eha6O.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        (parcelRequire("2ULQQ"))
                                                    ];
                                                case 1:
                                                    _ref = _state.sent(), SDK = _ref.default;
                                                    if (typeof SDK !== "function" && typeof SDK.default === "function") return [
                                                        2,
                                                        SDK.default
                                                    ];
                                                    return [
                                                        2,
                                                        SDK
                                                    ];
                                            }
                                        });
                                    })()
                                ];
                            case 1:
                                CoinbaseWalletSDK = _state.sent();
                                sdk = new CoinbaseWalletSDK((0, $cxjpp._)((0, $do9pw._)({}, parameters), {
                                    appChainIds: config.chains.map(function(x) {
                                        return x.id;
                                    })
                                }));
                                walletProvider = sdk.makeWeb3Provider((0, $cxjpp._)((0, $do9pw._)({}, parameters), {
                                    options: (_parameters_preference = parameters.preference) !== null && _parameters_preference !== void 0 ? _parameters_preference : "all"
                                }));
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    walletProvider
                                ];
                        }
                    });
                })();
            },
            isAuthorized: function() {
                return (0, $kSuI9._)(function() {
                    var accounts, e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    this.getAccounts()
                                ];
                            case 1:
                                accounts = _state.sent();
                                return [
                                    2,
                                    !!accounts.length
                                ];
                            case 2:
                                e = _state.sent();
                                return [
                                    2,
                                    false
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this);
            },
            switchChain: function(param) {
                var addEthereumChainParameter = param.addEthereumChainParameter, chainId = param.chainId;
                return (0, $kSuI9._)(function() {
                    var chain, provider, error, _chain_blockExplorers, _chain_blockExplorers1, _addEthereumChainParameter_rpcUrls, _chain_rpcUrls_default, blockExplorerUrls, rpcUrls, _chain_rpcUrls_default_http_, _addEthereumChainParameter_chainName, _addEthereumChainParameter_nativeCurrency, addEthereumChain, error1;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                chain = config.chains.find(function(chain) {
                                    return chain.id === chainId;
                                });
                                if (!chain) throw new (0, $aqVrP.SwitchChainError)(new (0, $ad7a5f8bd0b5662c$export$688e5fda4b4631ed)());
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    9
                                ]);
                                return [
                                    4,
                                    provider.request({
                                        method: "wallet_switchEthereumChain",
                                        params: [
                                            {
                                                chainId: (0, $f3VZN.numberToHex)(chain.id)
                                            }
                                        ]
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2,
                                    chain
                                ];
                            case 4:
                                error = _state.sent();
                                if (!(error.code === 4902)) return [
                                    3,
                                    8
                                ];
                                _state.label = 5;
                            case 5:
                                _state.trys.push([
                                    5,
                                    7,
                                    ,
                                    8
                                ]);
                                if (addEthereumChainParameter === null || addEthereumChainParameter === void 0 ? void 0 : addEthereumChainParameter.blockExplorerUrls) blockExplorerUrls = addEthereumChainParameter.blockExplorerUrls;
                                else blockExplorerUrls = ((_chain_blockExplorers = chain.blockExplorers) === null || _chain_blockExplorers === void 0 ? void 0 : _chain_blockExplorers.default.url) ? [
                                    (_chain_blockExplorers1 = chain.blockExplorers) === null || _chain_blockExplorers1 === void 0 ? void 0 : _chain_blockExplorers1.default.url
                                ] : [];
                                if (addEthereumChainParameter === null || addEthereumChainParameter === void 0 ? void 0 : (_addEthereumChainParameter_rpcUrls = addEthereumChainParameter.rpcUrls) === null || _addEthereumChainParameter_rpcUrls === void 0 ? void 0 : _addEthereumChainParameter_rpcUrls.length) rpcUrls = addEthereumChainParameter.rpcUrls;
                                else rpcUrls = [
                                    (_chain_rpcUrls_default_http_ = (_chain_rpcUrls_default = chain.rpcUrls.default) === null || _chain_rpcUrls_default === void 0 ? void 0 : _chain_rpcUrls_default.http[0]) !== null && _chain_rpcUrls_default_http_ !== void 0 ? _chain_rpcUrls_default_http_ : ""
                                ];
                                addEthereumChain = {
                                    blockExplorerUrls: blockExplorerUrls,
                                    chainId: (0, $f3VZN.numberToHex)(chainId),
                                    chainName: (_addEthereumChainParameter_chainName = addEthereumChainParameter === null || addEthereumChainParameter === void 0 ? void 0 : addEthereumChainParameter.chainName) !== null && _addEthereumChainParameter_chainName !== void 0 ? _addEthereumChainParameter_chainName : chain.name,
                                    iconUrls: addEthereumChainParameter === null || addEthereumChainParameter === void 0 ? void 0 : addEthereumChainParameter.iconUrls,
                                    nativeCurrency: (_addEthereumChainParameter_nativeCurrency = addEthereumChainParameter === null || addEthereumChainParameter === void 0 ? void 0 : addEthereumChainParameter.nativeCurrency) !== null && _addEthereumChainParameter_nativeCurrency !== void 0 ? _addEthereumChainParameter_nativeCurrency : chain.nativeCurrency,
                                    rpcUrls: rpcUrls
                                };
                                return [
                                    4,
                                    provider.request({
                                        method: "wallet_addEthereumChain",
                                        params: [
                                            addEthereumChain
                                        ]
                                    })
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    2,
                                    chain
                                ];
                            case 7:
                                error1 = _state.sent();
                                throw new (0, $aqVrP.UserRejectedRequestError)(error1);
                            case 8:
                                throw new (0, $aqVrP.SwitchChainError)(error);
                            case 9:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this);
            },
            onAccountsChanged: function(accounts) {
                if (accounts.length === 0) this.onDisconnect();
                else config.emitter.emit("change", {
                    accounts: accounts.map(function(x) {
                        return (0, $8zfHX.getAddress)(x);
                    })
                });
            },
            onChainChanged: function(chain) {
                var chainId = Number(chain);
                config.emitter.emit("change", {
                    chainId: chainId
                });
            },
            onDisconnect: function(_error) {
                return (0, $kSuI9._)(function() {
                    var provider;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                config.emitter.emit("disconnect");
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                if (accountsChanged) {
                                    provider.removeListener("accountsChanged", accountsChanged);
                                    accountsChanged = undefined;
                                }
                                if (chainChanged) {
                                    provider.removeListener("chainChanged", chainChanged);
                                    chainChanged = undefined;
                                }
                                if (disconnect) {
                                    provider.removeListener("disconnect", disconnect);
                                    disconnect = undefined;
                                }
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this);
            }
        };
    });
}

function $f7a111e0ecc086fc$var$version3(parameters) {
    var reloadOnDisconnect = false;
    var sdk;
    var walletProvider;
    var accountsChanged;
    var chainChanged;
    var disconnect;
    return (0, $b10dbf4ad6df2f47$export$36e7227504c841ea)(function(config) {
        return {
            id: "coinbaseWalletSDK",
            name: "Coinbase Wallet",
            supportsSimulation: true,
            type: $f7a111e0ecc086fc$export$40dfb463b44d19b.type,
            connect: function() {
                var chainId = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).chainId;
                return (0, $kSuI9._)(function() {
                    var provider, accounts, currentChainId, chain, _chain_id, error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                return [
                                    4,
                                    provider.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 2:
                                accounts = _state.sent().map(function(x) {
                                    return (0, $8zfHX.getAddress)(x);
                                });
                                if (!accountsChanged) {
                                    accountsChanged = this.onAccountsChanged.bind(this);
                                    provider.on("accountsChanged", accountsChanged);
                                }
                                if (!chainChanged) {
                                    chainChanged = this.onChainChanged.bind(this);
                                    provider.on("chainChanged", chainChanged);
                                }
                                if (!disconnect) {
                                    disconnect = this.onDisconnect.bind(this);
                                    provider.on("disconnect", disconnect);
                                }
                                return [
                                    4,
                                    this.getChainId()
                                ];
                            case 3:
                                currentChainId = _state.sent();
                                if (!(chainId && currentChainId !== chainId)) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    this.switchChain({
                                        chainId: chainId
                                    }).catch(function(error) {
                                        if (error.code === (0, $aqVrP.UserRejectedRequestError).code) throw error;
                                        return {
                                            id: currentChainId
                                        };
                                    })
                                ];
                            case 4:
                                chain = _state.sent();
                                currentChainId = (_chain_id = chain === null || chain === void 0 ? void 0 : chain.id) !== null && _chain_id !== void 0 ? _chain_id : currentChainId;
                                _state.label = 5;
                            case 5:
                                return [
                                    2,
                                    {
                                        accounts: accounts,
                                        chainId: currentChainId
                                    }
                                ];
                            case 6:
                                error = _state.sent();
                                if (/(user closed modal|accounts received is empty|user denied account)/i.test(error.message)) throw new (0, $aqVrP.UserRejectedRequestError)(error);
                                throw error;
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this);
            },
            disconnect: function() {
                return (0, $kSuI9._)(function() {
                    var provider;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                if (accountsChanged) {
                                    provider.removeListener("accountsChanged", accountsChanged);
                                    accountsChanged = undefined;
                                }
                                if (chainChanged) {
                                    provider.removeListener("chainChanged", chainChanged);
                                    chainChanged = undefined;
                                }
                                if (disconnect) {
                                    provider.removeListener("disconnect", disconnect);
                                    disconnect = undefined;
                                }
                                provider.disconnect();
                                provider.close();
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this);
            },
            getAccounts: function() {
                return (0, $kSuI9._)(function() {
                    var provider;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                return [
                                    4,
                                    provider.request({
                                        method: "eth_accounts"
                                    })
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent().map(function(x) {
                                        return (0, $8zfHX.getAddress)(x);
                                    })
                                ];
                        }
                    });
                }).apply(this);
            },
            getChainId: function() {
                return (0, $kSuI9._)(function() {
                    var provider, chainId;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                return [
                                    4,
                                    provider.request({
                                        method: "eth_chainId"
                                    })
                                ];
                            case 2:
                                chainId = _state.sent();
                                return [
                                    2,
                                    Number(chainId)
                                ];
                        }
                    });
                }).apply(this);
            },
            getProvider: function() {
                return (0, $kSuI9._)(function() {
                    var _sdk_walletExtension, CoinbaseWalletSDK, walletExtensionChainId, chain, chainId, jsonRpcUrl;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!walletProvider) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (0, $kSuI9._)(function() {
                                        var _ref, SDK;
                                        return (0, $eha6O.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        (parcelRequire("iMVEh"))
                                                    ];
                                                case 1:
                                                    _ref = _state.sent(), SDK = _ref.default;
                                                    if (typeof SDK !== "function" && typeof SDK.default === "function") return [
                                                        2,
                                                        SDK.default
                                                    ];
                                                    return [
                                                        2,
                                                        SDK
                                                    ];
                                            }
                                        });
                                    })()
                                ];
                            case 1:
                                CoinbaseWalletSDK = _state.sent();
                                sdk = new CoinbaseWalletSDK((0, $cxjpp._)((0, $do9pw._)({}, parameters), {
                                    reloadOnDisconnect: reloadOnDisconnect
                                }));
                                // Force types to retrieve private `walletExtension` method from the Coinbase Wallet SDK.
                                walletExtensionChainId = (_sdk_walletExtension = sdk.walletExtension) === null || _sdk_walletExtension === void 0 ? void 0 : _sdk_walletExtension.getChainId();
                                chain = config.chains.find(function(chain) {
                                    return parameters.chainId ? chain.id === parameters.chainId : chain.id === walletExtensionChainId;
                                }) || config.chains[0];
                                chainId = parameters.chainId || (chain === null || chain === void 0 ? void 0 : chain.id);
                                jsonRpcUrl = parameters.jsonRpcUrl || (chain === null || chain === void 0 ? void 0 : chain.rpcUrls.default.http[0]);
                                walletProvider = sdk.makeWeb3Provider(jsonRpcUrl, chainId);
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    walletProvider
                                ];
                        }
                    });
                })();
            },
            isAuthorized: function() {
                return (0, $kSuI9._)(function() {
                    var accounts, e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    this.getAccounts()
                                ];
                            case 1:
                                accounts = _state.sent();
                                return [
                                    2,
                                    !!accounts.length
                                ];
                            case 2:
                                e = _state.sent();
                                return [
                                    2,
                                    false
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this);
            },
            switchChain: function(param) {
                var addEthereumChainParameter = param.addEthereumChainParameter, chainId = param.chainId;
                return (0, $kSuI9._)(function() {
                    var chain, provider, error, _chain_blockExplorers, _chain_blockExplorers1, _addEthereumChainParameter_rpcUrls, _chain_rpcUrls_default, blockExplorerUrls, rpcUrls, _chain_rpcUrls_default_http_, _addEthereumChainParameter_chainName, _addEthereumChainParameter_nativeCurrency, addEthereumChain, error1;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                chain = config.chains.find(function(chain) {
                                    return chain.id === chainId;
                                });
                                if (!chain) throw new (0, $aqVrP.SwitchChainError)(new (0, $ad7a5f8bd0b5662c$export$688e5fda4b4631ed)());
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    9
                                ]);
                                return [
                                    4,
                                    provider.request({
                                        method: "wallet_switchEthereumChain",
                                        params: [
                                            {
                                                chainId: (0, $f3VZN.numberToHex)(chain.id)
                                            }
                                        ]
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2,
                                    chain
                                ];
                            case 4:
                                error = _state.sent();
                                if (!(error.code === 4902)) return [
                                    3,
                                    8
                                ];
                                _state.label = 5;
                            case 5:
                                _state.trys.push([
                                    5,
                                    7,
                                    ,
                                    8
                                ]);
                                if (addEthereumChainParameter === null || addEthereumChainParameter === void 0 ? void 0 : addEthereumChainParameter.blockExplorerUrls) blockExplorerUrls = addEthereumChainParameter.blockExplorerUrls;
                                else blockExplorerUrls = ((_chain_blockExplorers = chain.blockExplorers) === null || _chain_blockExplorers === void 0 ? void 0 : _chain_blockExplorers.default.url) ? [
                                    (_chain_blockExplorers1 = chain.blockExplorers) === null || _chain_blockExplorers1 === void 0 ? void 0 : _chain_blockExplorers1.default.url
                                ] : [];
                                if (addEthereumChainParameter === null || addEthereumChainParameter === void 0 ? void 0 : (_addEthereumChainParameter_rpcUrls = addEthereumChainParameter.rpcUrls) === null || _addEthereumChainParameter_rpcUrls === void 0 ? void 0 : _addEthereumChainParameter_rpcUrls.length) rpcUrls = addEthereumChainParameter.rpcUrls;
                                else rpcUrls = [
                                    (_chain_rpcUrls_default_http_ = (_chain_rpcUrls_default = chain.rpcUrls.default) === null || _chain_rpcUrls_default === void 0 ? void 0 : _chain_rpcUrls_default.http[0]) !== null && _chain_rpcUrls_default_http_ !== void 0 ? _chain_rpcUrls_default_http_ : ""
                                ];
                                addEthereumChain = {
                                    blockExplorerUrls: blockExplorerUrls,
                                    chainId: (0, $f3VZN.numberToHex)(chainId),
                                    chainName: (_addEthereumChainParameter_chainName = addEthereumChainParameter === null || addEthereumChainParameter === void 0 ? void 0 : addEthereumChainParameter.chainName) !== null && _addEthereumChainParameter_chainName !== void 0 ? _addEthereumChainParameter_chainName : chain.name,
                                    iconUrls: addEthereumChainParameter === null || addEthereumChainParameter === void 0 ? void 0 : addEthereumChainParameter.iconUrls,
                                    nativeCurrency: (_addEthereumChainParameter_nativeCurrency = addEthereumChainParameter === null || addEthereumChainParameter === void 0 ? void 0 : addEthereumChainParameter.nativeCurrency) !== null && _addEthereumChainParameter_nativeCurrency !== void 0 ? _addEthereumChainParameter_nativeCurrency : chain.nativeCurrency,
                                    rpcUrls: rpcUrls
                                };
                                return [
                                    4,
                                    provider.request({
                                        method: "wallet_addEthereumChain",
                                        params: [
                                            addEthereumChain
                                        ]
                                    })
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    2,
                                    chain
                                ];
                            case 7:
                                error1 = _state.sent();
                                throw new (0, $aqVrP.UserRejectedRequestError)(error1);
                            case 8:
                                throw new (0, $aqVrP.SwitchChainError)(error);
                            case 9:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this);
            },
            onAccountsChanged: function(accounts) {
                if (accounts.length === 0) this.onDisconnect();
                else config.emitter.emit("change", {
                    accounts: accounts.map(function(x) {
                        return (0, $8zfHX.getAddress)(x);
                    })
                });
            },
            onChainChanged: function(chain) {
                var chainId = Number(chain);
                config.emitter.emit("change", {
                    chainId: chainId
                });
            },
            onDisconnect: function(_error) {
                return (0, $kSuI9._)(function() {
                    var provider;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                config.emitter.emit("disconnect");
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                if (accountsChanged) {
                                    provider.removeListener("accountsChanged", accountsChanged);
                                    accountsChanged = undefined;
                                }
                                if (chainChanged) {
                                    provider.removeListener("chainChanged", chainChanged);
                                    chainChanged = undefined;
                                }
                                if (disconnect) {
                                    provider.removeListener("disconnect", disconnect);
                                    disconnect = undefined;
                                }
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this);
            }
        };
    });
}



var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

parcelRequire("hsyMZ");
var $31229 = parcelRequire("31229");
parcelRequire("dSKxG");
var $fcokf = parcelRequire("fcokf");
var $3QZC1 = parcelRequire("3QZC1");

var $aqVrP = parcelRequire("aqVrP");
var $8zfHX = parcelRequire("8zfHX");

function $8cdbe1219d15231a$export$f3a67f9bdc78b494(parameters) {
    function parseChainId(chainId) {
        return (0, $fcokf.NetworkUtil).parseEvmChainId(chainId) || 1;
    }
    return (0, $b10dbf4ad6df2f47$export$36e7227504c841ea)(function(config) {
        return {
            id: (0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).AUTH_CONNECTOR_ID,
            name: "Web3Modal Auth",
            type: "w3mAuth",
            socials: parameters.socials,
            email: parameters.email,
            showWallets: parameters.showWallets,
            walletFeatures: parameters.walletFeatures,
            chain: (0, $3QZC1.ConstantsUtil).CHAIN.EVM,
            connect: function() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                return (0, $kSuI9._)(function() {
                    var provider, _ref, address, chainId, parsedChainId;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                return [
                                    4,
                                    provider.connect({
                                        chainId: options.chainId
                                    })
                                ];
                            case 2:
                                _ref = _state.sent(), address = _ref.address, chainId = _ref.chainId;
                                return [
                                    4,
                                    provider.getSmartAccountEnabledNetworks()
                                ];
                            case 3:
                                _state.sent();
                                parsedChainId = parseChainId(chainId);
                                return [
                                    2,
                                    {
                                        accounts: [
                                            address
                                        ],
                                        account: address,
                                        chainId: parsedChainId,
                                        chain: {
                                            id: parsedChainId,
                                            unsuported: false
                                        }
                                    }
                                ];
                        }
                    });
                }).apply(this);
            },
            disconnect: function() {
                return (0, $kSuI9._)(function() {
                    var provider;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                return [
                                    4,
                                    provider.disconnect()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this);
            },
            getAccounts: function() {
                return (0, $kSuI9._)(function() {
                    var provider, address;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                return [
                                    4,
                                    provider.connect()
                                ];
                            case 2:
                                address = _state.sent().address;
                                config.emitter.emit("change", {
                                    accounts: [
                                        address
                                    ]
                                });
                                return [
                                    2,
                                    [
                                        address
                                    ]
                                ];
                        }
                    });
                }).apply(this);
            },
            getProvider: function() {
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        if (!this.provider) this.provider = new (0, $31229.W3mFrameProvider)(parameters.options.projectId);
                        return [
                            2,
                            Promise.resolve(this.provider)
                        ];
                    });
                }).apply(this);
            },
            getChainId: function() {
                return (0, $kSuI9._)(function() {
                    var provider, chainId;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                return [
                                    4,
                                    provider.getChainId()
                                ];
                            case 2:
                                chainId = _state.sent().chainId;
                                return [
                                    2,
                                    parseChainId(chainId)
                                ];
                        }
                    });
                }).apply(this);
            },
            isAuthorized: function() {
                return (0, $kSuI9._)(function() {
                    var provider, isConnected;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                return [
                                    4,
                                    provider.isConnected()
                                ];
                            case 2:
                                isConnected = _state.sent().isConnected;
                                return [
                                    2,
                                    isConnected
                                ];
                        }
                    });
                }).apply(this);
            },
            switchChain: function(param) {
                var chainId = param.chainId;
                return (0, $kSuI9._)(function() {
                    var chain, provider, error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    3,
                                    ,
                                    4
                                ]);
                                chain = config.chains.find(function(c) {
                                    return c.id === chainId;
                                });
                                if (!chain) throw new (0, $aqVrP.SwitchChainError)(new Error("chain not found on connector."));
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                return [
                                    4,
                                    provider.switchNetwork(chainId)
                                ];
                            case 2:
                                _state.sent();
                                config.emitter.emit("change", {
                                    chainId: Number(chainId)
                                });
                                return [
                                    2,
                                    chain
                                ];
                            case 3:
                                error = _state.sent();
                                if (error instanceof Error) throw new (0, $aqVrP.SwitchChainError)(error);
                                throw error;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this);
            },
            onAccountsChanged: function(accounts) {
                if (accounts.length === 0) this.onDisconnect();
                else config.emitter.emit("change", {
                    accounts: accounts.map((0, $8zfHX.getAddress))
                });
            },
            onChainChanged: function(chain) {
                var chainId = Number(chain);
                config.emitter.emit("change", {
                    chainId: chainId
                });
            },
            onConnect: function(connectInfo) {
                return (0, $kSuI9._)(function() {
                    var chainId, accounts;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                chainId = Number(connectInfo.chainId);
                                return [
                                    4,
                                    this.getAccounts()
                                ];
                            case 1:
                                accounts = _state.sent();
                                config.emitter.emit("connect", {
                                    accounts: accounts,
                                    chainId: chainId
                                });
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this);
            },
            onDisconnect: function(_error) {
                return (0, $kSuI9._)(function() {
                    var provider;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                return [
                                    4,
                                    provider.disconnect()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this);
            }
        };
    });
}



function $8012589831b73495$export$f84bd70098573c5c(_param) {
    var projectId = _param.projectId, chains = _param.chains, metadata = _param.metadata, enableCoinbase = _param.enableCoinbase, enableInjected = _param.enableInjected, _param_auth = _param.auth, auth = _param_auth === void 0 ? {} : _param_auth, enableWalletConnect = _param.enableWalletConnect, enableEIP6963 = _param.enableEIP6963, wagmiConfig = (0, $dRLPW._)(_param, [
        "projectId",
        "chains",
        "metadata",
        "enableCoinbase",
        "enableInjected",
        "auth",
        "enableWalletConnect",
        "enableEIP6963"
    ]);
    var _mergedAuth_socials;
    var _wagmiConfig_connectors;
    var connectors = (_wagmiConfig_connectors = wagmiConfig === null || wagmiConfig === void 0 ? void 0 : wagmiConfig.connectors) !== null && _wagmiConfig_connectors !== void 0 ? _wagmiConfig_connectors : [];
    var transportsArr = chains.map(function(chain) {
        return [
            chain.id,
            (0, $e82e1b76ecf9a723$export$867d8b939ab7f43e)({
                chain: chain,
                projectId: projectId
            })
        ];
    });
    var transports = Object.fromEntries(transportsArr);
    var defaultAuth = {
        email: true,
        showWallets: true,
        walletFeatures: true,
        socials: [
            "google",
            "x",
            "discord",
            "farcaster",
            "github",
            "apple",
            "facebook"
        ]
    };
    if (enableWalletConnect !== false) connectors.push((0, $bb0235625fedf18a$export$340cc50ae9d9f255)({
        projectId: projectId,
        metadata: metadata,
        showQrModal: false
    }));
    if (enableInjected !== false) connectors.push((0, $618bc8d87e24d77b$export$a7a34dad4983656f)({
        shimDisconnect: true
    }));
    var _metadata_name, _metadata_icons_;
    if (enableCoinbase !== false) connectors.push((0, $f7a111e0ecc086fc$export$40dfb463b44d19b)({
        version: "4",
        appName: (_metadata_name = metadata === null || metadata === void 0 ? void 0 : metadata.name) !== null && _metadata_name !== void 0 ? _metadata_name : "Unknown",
        appLogoUrl: (_metadata_icons_ = metadata === null || metadata === void 0 ? void 0 : metadata.icons[0]) !== null && _metadata_icons_ !== void 0 ? _metadata_icons_ : "Unknown",
        preference: wagmiConfig.coinbasePreference || "all"
    }));
    var mergedAuth = (0, $do9pw._)({}, defaultAuth, auth);
    if (mergedAuth.email || ((_mergedAuth_socials = mergedAuth.socials) === null || _mergedAuth_socials === void 0 ? void 0 : _mergedAuth_socials.length)) connectors.push((0, $8cdbe1219d15231a$export$f3a67f9bdc78b494)({
        chains: (0, $c6Xmf._)(chains),
        options: {
            projectId: projectId
        },
        socials: mergedAuth.socials,
        email: mergedAuth.email,
        showWallets: mergedAuth.showWallets,
        walletFeatures: mergedAuth.walletFeatures
    }));
    return (0, $93f05fdf2144e397$export$45a69314cf48a3eb)((0, $cxjpp._)((0, $do9pw._)({
        chains: chains,
        multiInjectedProviderDiscovery: enableEIP6963 !== false,
        transports: transports
    }, wagmiConfig), {
        connectors: connectors
    }));
}






function $daff7a27f229ef6a$export$14650d4efb17e382(options) {
    var wagmiAdapter = new (0, $2eb794d81ea38b94$export$ba6a4843bec5d2a8)({
        wagmiConfig: options.wagmiConfig,
        siweConfig: options.siweConfig,
        defaultChain: options.defaultChain
    });
    return new (0, $01027d2cdef453cb$export$fc94c40ea502fa4c)((0, $cxjpp._)((0, $do9pw._)({}, options), {
        defaultChain: wagmiAdapter.defaultChain,
        adapters: [
            wagmiAdapter
        ],
        sdkType: "w3m",
        sdkVersion: "html-wagmi-".concat((0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).VERSION)
    }));
}


var $7228c3dac31e12e0$export$cc4208a8ebc9f985 = {
    Ethereum: (0, $f2095a368764cd16$export$536d3e0d2c7baf54),
    Avalanche: (0, $225f0d2cf29ca890$export$ca1d15c01fde7266),
    Base: (0, $23f2e6978ca8d764$export$e2253033e6e1df16),
    SepoliaTestnet: {
        id: 11155111,
        network: "sepolia",
        name: "Sepolia",
        nativeCurrency: {
            name: "Sepolia Ether",
            symbol: "SEP",
            decimals: 18
        },
        rpcUrls: {
            alchemy: {
                http: [
                    "https://eth-sepolia.g.alchemy.com/v2"
                ],
                webSocket: [
                    "wss://eth-sepolia.g.alchemy.com/v2"
                ]
            },
            infura: {
                http: [
                    "https://sepolia.infura.io/v3"
                ],
                webSocket: [
                    "wss://sepolia.infura.io/ws/v3"
                ]
            },
            default: {
                http: [
                    "https://rpc2.sepolia.org"
                ]
            },
            public: {
                http: [
                    "https://rpc2.sepolia.org"
                ]
            }
        },
        blockExplorers: {
            etherscan: {
                name: "Etherscan",
                url: "https://sepolia.etherscan.io"
            },
            default: {
                name: "Etherscan",
                url: "https://sepolia.etherscan.io"
            }
        },
        contracts: {
            multicall3: {
                address: "0xca11bde05977b3631167028862be2a173976ca11",
                blockCreated: 6507670
            }
        },
        testnet: true
    },
    Polygon: (0, $609903e81fb48f89$export$b7b19aa0ee06c73),
    PolygonTestnet: (0, $af443f471a88909e$export$34b6ef3a78067459),
    BNB: (0, $7c74330b745834e8$export$170e8cdd0c4e59c8),
    BNBTestnet: (0, $362fc72842b76a67$export$1c182ebff3ea4eef),
    Arbitrum: (0, $4f58ad3687968cfa$export$625cf84d855940d4),
    ArbitrumTestnet: (0, $8d6f5e1ed5250aac$export$857f1b5f596fb425)
};
var $7228c3dac31e12e0$var$chains = Object.values($7228c3dac31e12e0$export$cc4208a8ebc9f985);
var $7228c3dac31e12e0$export$e4bb003b4e7478a = "e13bb5b25a3121bba8a056c8dadd0c1c";
var $7228c3dac31e12e0$export$dbb5e893e736e4ee = {
    name: "Radom",
    description: "Decentralized payments",
    url: "https://radom.com",
    icons: []
};
var $7228c3dac31e12e0$export$382a3cc012b91987 = (0, $8012589831b73495$export$f84bd70098573c5c)({
    chains: $7228c3dac31e12e0$var$chains,
    projectId: $7228c3dac31e12e0$export$e4bb003b4e7478a,
    metadata: $7228c3dac31e12e0$export$dbb5e893e736e4ee
});
var $7228c3dac31e12e0$export$ba33f6d94de735b7 = function() {
    return [
        {
            name: "Bitcoin",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($49f782a21a858f73$exports))),
            ticker: "BTC"
        },
        {
            name: "BitcoinTestnet",
            currencyName: "Bitcoin",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($49f782a21a858f73$exports))),
            ticker: "BTC",
            isTestnet: true
        },
        {
            name: "Ethereum",
            currencyName: "Ether",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($cf198cc02a1cf978$exports))),
            ticker: "ETH"
        },
        {
            name: "SepoliaTestnet",
            currencyName: "Ether",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($cf198cc02a1cf978$exports))),
            ticker: "ETH",
            isTestnet: true
        },
        {
            name: "Polygon",
            currencyName: "Matic",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($2954bf38f4aed119$exports))),
            ticker: "MATIC"
        },
        {
            name: "Avalanche",
            currencyName: "Avalanche",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($cdac8429c845843c$exports))),
            ticker: "AVAX"
        },
        {
            name: "PolygonTestnet",
            currencyName: "Matic",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($2954bf38f4aed119$exports))),
            ticker: "MATIC",
            isTestnet: true
        },
        {
            name: "BNB",
            currencyName: "BNB",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($c3af053f7c3c5163$exports))),
            ticker: "BNB"
        },
        {
            name: "BNBTestnet",
            currencyName: "BNB",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($c3af053f7c3c5163$exports))),
            ticker: "BNB",
            isTestnet: true
        },
        {
            name: "Arbitrum",
            currencyName: "ETH",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($953030a151110bf7$exports))),
            ticker: "ETH"
        },
        {
            name: "Base",
            currencyName: "ETH",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($4fbedd456c072db4$exports))),
            ticker: "ETH"
        },
        {
            name: "Sepolia USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($a345f3b3ee09feaa$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 11155111,
                tokenAddress: "0xa4fCE8264370437e718aE207805b4e6233638b9E",
                networkName: "SepoliaTestnet",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($cf198cc02a1cf978$exports))),
                decimals: 6,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isTestnet: true
        },
        {
            name: "Devnet USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($a345f3b3ee09feaa$exports))),
            tokenInfo: {
                tokenType: "solana",
                tokenAddress: "4zMMC9srt5Ri5X14GAgXhaHii3GnPAEERYPJgZJDncDU",
                networkName: "SolanaDevnet",
                cluster: "SolanaDevnet",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($23b34a954fa05838$exports))),
                decimals: 6
            },
            isTestnet: true,
            isSolana: true
        },
        {
            name: "Sepolia Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($5d39efd1acbcc2ad$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 11155111,
                tokenAddress: "0xE50d86c6dE38F9754f6777d2925377564Bf79482",
                networkName: "SepoliaTestnet",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($cf198cc02a1cf978$exports))),
                decimals: 6,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isTestnet: true
        },
        {
            name: "Basic Attention Token",
            ticker: "BAT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($5d22a9b53f75b97e$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 11155111,
                tokenAddress: "0x5D684d37922dAf7Aa2013E65A22880a11C475e25",
                networkName: "SepoliaTestnet",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($cf198cc02a1cf978$exports))),
                decimals: 18,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isTestnet: true
        },
        {
            name: "Polygon Testnet USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($a345f3b3ee09feaa$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 80001,
                tokenAddress: "0x8f8b1972eea072C3C228EbE8f9FEADe03927D70F",
                networkName: "PolygonTestnet",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($2954bf38f4aed119$exports))),
                decimals: 6,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isTestnet: true
        },
        {
            name: "Polygon Testnet Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($5d39efd1acbcc2ad$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 80001,
                tokenAddress: "0x70BE8802e2F3C6652B7e0814B478f66Ec52d9d88",
                networkName: "PolygonTestnet",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($2954bf38f4aed119$exports))),
                decimals: 6,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isTestnet: true
        },
        {
            name: "Polygon Testnet BAT",
            ticker: "BAT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($5d22a9b53f75b97e$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 80001,
                tokenAddress: "0xd445cAAbb9eA6685D3A512439256866563a16E93",
                networkName: "PolygonTestnet",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($2954bf38f4aed119$exports))),
                decimals: 18,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isTestnet: true
        },
        {
            name: "Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($5d39efd1acbcc2ad$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 1,
                tokenAddress: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
                networkName: "Ethereum",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($cf198cc02a1cf978$exports))),
                decimals: 6,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            }
        },
        {
            name: "Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($5d39efd1acbcc2ad$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 137,
                tokenAddress: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
                networkName: "Polygon",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($2954bf38f4aed119$exports))),
                decimals: 6,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            }
        },
        {
            name: "Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($5d39efd1acbcc2ad$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 56,
                tokenAddress: "0x55d398326f99059ff775485246999027b3197955",
                networkName: "BNB",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($c3af053f7c3c5163$exports))),
                decimals: 18,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            }
        },
        {
            name: "USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($a345f3b3ee09feaa$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 56,
                tokenAddress: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
                networkName: "BNB",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($c3af053f7c3c5163$exports))),
                decimals: 18,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            }
        },
        {
            name: "USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($a345f3b3ee09feaa$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 8453,
                tokenAddress: "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913",
                networkName: "Base",
                subscriptionContract: "0x61dD58140201Af4E77B67a36BaA25e1e560d87E9",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($4fbedd456c072db4$exports))),
                decimals: 6
            }
        },
        {
            name: "USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($a345f3b3ee09feaa$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 42161,
                tokenAddress: "0xaf88d065e77c8cc2239327c5edb3a432268e5831",
                networkName: "Arbitrum",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($953030a151110bf7$exports))),
                decimals: 6
            }
        },
        {
            name: "Bridged USD Coin",
            ticker: "USDC.e",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($a345f3b3ee09feaa$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 42161,
                tokenAddress: "0xff970a61a04b1ca14834a43f5de4533ebddb5cc8",
                networkName: "Arbitrum",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($953030a151110bf7$exports))),
                decimals: 6
            }
        },
        {
            name: "Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($5d39efd1acbcc2ad$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 42161,
                tokenAddress: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
                networkName: "Arbitrum",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($953030a151110bf7$exports))),
                decimals: 6
            }
        },
        {
            name: "Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($5d39efd1acbcc2ad$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 43114,
                tokenAddress: "0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7",
                networkName: "Avalanche",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($cdac8429c845843c$exports))),
                decimals: 6
            }
        },
        {
            name: "Binance USD",
            ticker: "BUSD",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($c7c23fe39b1ec5b3$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 56,
                tokenAddress: "0xe9e7cea3dedca5984780bafc599bd69add087d56",
                networkName: "BNB",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($c3af053f7c3c5163$exports))),
                decimals: 18,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            }
        },
        {
            name: "Basic Attention Token",
            ticker: "BAT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($5d22a9b53f75b97e$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 56,
                tokenAddress: "0x101d82428437127bf1608f699cd651e6abf9766e",
                networkName: "BNB",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($c3af053f7c3c5163$exports))),
                decimals: 18,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            }
        },
        {
            name: "USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($a345f3b3ee09feaa$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 1,
                tokenAddress: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
                networkName: "Ethereum",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($cf198cc02a1cf978$exports))),
                decimals: 6,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            }
        },
        {
            name: "Basic Attention Token",
            ticker: "BAT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($5d22a9b53f75b97e$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 1,
                tokenAddress: "0x0d8775f648430679a709e98d2b0cb6250d2887ef",
                networkName: "Ethereum",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($cf198cc02a1cf978$exports))),
                decimals: 18,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            }
        },
        {
            name: "Verse",
            ticker: "VERSE",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($fe6907d6cba7b37a$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 1,
                tokenAddress: "0x249ca82617ec3dfb2589c4c17ab7ec9765350a18",
                networkName: "Ethereum",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($cf198cc02a1cf978$exports))),
                decimals: 18,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            }
        },
        {
            name: "Bridged USD Coin",
            ticker: "USDC.e",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($a345f3b3ee09feaa$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 137,
                tokenAddress: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
                networkName: "Polygon",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($2954bf38f4aed119$exports))),
                decimals: 6,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            }
        },
        {
            name: "USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($a345f3b3ee09feaa$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 137,
                tokenAddress: "0x3c499c542cef5e3811e1192ce70d8cc03d5c3359",
                networkName: "Polygon",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($2954bf38f4aed119$exports))),
                decimals: 6,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            }
        },
        {
            name: "USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($a345f3b3ee09feaa$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 137,
                tokenAddress: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
                networkName: "Polygon",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($2954bf38f4aed119$exports))),
                decimals: 6,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            }
        },
        {
            name: "Basic Attention Token",
            ticker: "BAT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($5d22a9b53f75b97e$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 137,
                tokenAddress: "0x3cef98bb43d732e2f285ee605a8158cde967d219",
                networkName: "Polygon",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($2954bf38f4aed119$exports))),
                decimals: 18,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            }
        },
        {
            name: "Solana",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($23b34a954fa05838$exports))),
            ticker: "SOL",
            isSolana: true
        },
        {
            name: "SolanaTestnet",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($23b34a954fa05838$exports))),
            ticker: "SOL",
            isTestnet: true,
            isSolana: true
        },
        {
            name: "SolanaDevnet",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($23b34a954fa05838$exports))),
            ticker: "SOL",
            isTestnet: true,
            isSolana: true
        },
        {
            name: "Polkadot",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($cca768d861163912$exports))),
            ticker: "DOT"
        },
        {
            name: "PolkadotTestnet",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($cca768d861163912$exports))),
            ticker: "WND",
            isTestnet: true
        },
        {
            name: "Solana Testnet USD Coin",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($a345f3b3ee09feaa$exports))),
            ticker: "USDC",
            isTestnet: true,
            tokenInfo: {
                tokenType: "solana",
                cluster: "testnet",
                tokenAddress: "CpMah17kQEL2wqyMKt3mZBdTnZbkbfx4nqmQMFDP5vwp",
                networkName: "SolanaTestnet",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($a345f3b3ee09feaa$exports))),
                decimals: 6
            },
            isSolana: true
        },
        {
            name: "Solana Devnet USD Coin",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($a345f3b3ee09feaa$exports))),
            ticker: "USDC",
            isTestnet: true,
            tokenInfo: {
                tokenType: "solana",
                cluster: "devnet",
                tokenAddress: "4zMMC9srt5Ri5X14GAgXhaHii3GnPAEERYPJgZJDncDU",
                networkName: "SolanaDevnet",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($a345f3b3ee09feaa$exports))),
                decimals: 6
            },
            isSolana: true
        },
        {
            name: "Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($5d39efd1acbcc2ad$exports))),
            tokenInfo: {
                tokenType: "solana",
                cluster: "mainnet",
                tokenAddress: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
                networkName: "Solana",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($23b34a954fa05838$exports))),
                decimals: 6
            },
            isSolana: true
        },
        {
            name: "USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($a345f3b3ee09feaa$exports))),
            tokenInfo: {
                tokenType: "solana",
                cluster: "mainnet",
                tokenAddress: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
                networkName: "Solana",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($23b34a954fa05838$exports))),
                decimals: 6
            },
            isSolana: true
        },
        {
            name: "Basic Attention Token",
            ticker: "BAT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($5d22a9b53f75b97e$exports))),
            tokenInfo: {
                tokenType: "solana",
                cluster: "mainnet",
                tokenAddress: "EPeUFDgHRxs9xxEPVaL6kfGQvCon7jmAWKVUHuux1Tpz",
                networkName: "Solana",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($23b34a954fa05838$exports))),
                decimals: 8
            },
            isSolana: true
        },
        {
            name: "Cardano",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($d2f450ec95425176$exports))),
            ticker: "ADA"
        },
        {
            name: "Monero",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($37d27b0943e83c4c$exports))),
            ticker: "XMR"
        },
        {
            name: "Dogecoin",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($03620a9412aa34f7$exports))),
            ticker: "DOGE",
            qrCodeImage: (0, (/*@__PURE__*/$parcel$interopDefault($3e04e3845a939979$exports)))
        },
        {
            name: "Litecoin",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($039bd4d684cbfd0a$exports))),
            ticker: "LTC"
        },
        {
            name: "Dash",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($1e58ce75afa1adfc$exports))),
            ticker: "DASH"
        },
        {
            name: "Zcash",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($db5e1d58939009e6$exports))),
            ticker: "ZEC"
        },
        {
            name: "ZcashTestnet",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($db5e1d58939009e6$exports))),
            ticker: "ZEC",
            isTestnet: true
        },
        {
            name: "Tron",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($239aa09aa7299eeb$exports))),
            ticker: "TRX"
        },
        {
            name: "Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($5d39efd1acbcc2ad$exports))),
            tokenInfo: {
                tokenType: "tron",
                networkName: "Tron",
                tokenAddress: "TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($239aa09aa7299eeb$exports))),
                decimals: 6
            }
        },
        {
            name: "TronTestnet",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($239aa09aa7299eeb$exports))),
            ticker: "TRX",
            isTestnet: true
        },
        {
            name: "Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($5d39efd1acbcc2ad$exports))),
            tokenInfo: {
                tokenType: "tron",
                networkName: "TronTestnet",
                tokenAddress: "TSrUgwP9NPHKMcWPtHRRWcoxFV4JU6R9qk",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($239aa09aa7299eeb$exports))),
                decimals: 6
            },
            isTestnet: true
        }
    ];
};
var $7228c3dac31e12e0$export$8793fab959da70d1 = function(network, token) {
    var method = $7228c3dac31e12e0$export$ba33f6d94de735b7().find(function(m) {
        var _m_tokenInfo, _m_tokenInfo1;
        if (token) return ((_m_tokenInfo = m.tokenInfo) === null || _m_tokenInfo === void 0 ? void 0 : _m_tokenInfo.tokenAddress.toLowerCase()) === token.toLowerCase() && network.toLowerCase() === ((_m_tokenInfo1 = m.tokenInfo) === null || _m_tokenInfo1 === void 0 ? void 0 : _m_tokenInfo1.networkName.toLowerCase());
        else return m.name.toLowerCase() === network.toLowerCase();
    });
    if (!method) {
        var method1 = $7228c3dac31e12e0$export$ba33f6d94de735b7().find(function(m) {
            return m.name.toLowerCase() === network.toLowerCase();
        });
        if (method1) return method1;
    }
    if (!method) return {
        name: "Unknown",
        logo: null,
        ticker: "Unknown"
    };
    return method;
};
var $7228c3dac31e12e0$export$aab47327b38c6232 = function(m) {
    if (!m) return false;
    if (m.tokenInfo) {
        if (m.tokenInfo.tokenType === "evm" && m.tokenInfo.subscriptionContract) return true;
    }
    return false;
};



var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $eha6O = parcelRequire("eha6O");


var $1Mpn7 = parcelRequire("1Mpn7");

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $eha6O = parcelRequire("eha6O");

var $cv9Rk = parcelRequire("cv9Rk");

var $l0HdX = parcelRequire("l0HdX");
"use strict";
function $67c4890188190b79$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}



var $3qWgZ = parcelRequire("3qWgZ");
"use strict";
// utils is a library of generic helper functions non-specific to axios
var $8978bc38b4fd9d45$var$toString = Object.prototype.toString;
var $8978bc38b4fd9d45$var$getPrototypeOf = Object.getPrototypeOf;
var $8978bc38b4fd9d45$var$kindOf = function(cache) {
    return function(thing) {
        var str = $8978bc38b4fd9d45$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    };
}(Object.create(null));
var $8978bc38b4fd9d45$var$kindOfTest = function(type) {
    type = type.toLowerCase();
    return function(thing) {
        return $8978bc38b4fd9d45$var$kindOf(thing) === type;
    };
};
var $8978bc38b4fd9d45$var$typeOfTest = function(type) {
    return function(thing) {
        return (typeof thing === "undefined" ? "undefined" : (0, $l0HdX._)(thing)) === type;
    };
};
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ var $8978bc38b4fd9d45$var$isArray = Array.isArray;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ var $8978bc38b4fd9d45$var$isUndefined = $8978bc38b4fd9d45$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $8978bc38b4fd9d45$var$isBuffer(val) {
    return val !== null && !$8978bc38b4fd9d45$var$isUndefined(val) && val.constructor !== null && !$8978bc38b4fd9d45$var$isUndefined(val.constructor) && $8978bc38b4fd9d45$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ var $8978bc38b4fd9d45$var$isArrayBuffer = $8978bc38b4fd9d45$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $8978bc38b4fd9d45$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $8978bc38b4fd9d45$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ var $8978bc38b4fd9d45$var$isString = $8978bc38b4fd9d45$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ var $8978bc38b4fd9d45$var$isFunction = $8978bc38b4fd9d45$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ var $8978bc38b4fd9d45$var$isNumber = $8978bc38b4fd9d45$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ var $8978bc38b4fd9d45$var$isObject = function(thing) {
    return thing !== null && typeof thing === "object";
};
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ var $8978bc38b4fd9d45$var$isBoolean = function(thing) {
    return thing === true || thing === false;
};
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ var $8978bc38b4fd9d45$var$isPlainObject = function(val) {
    if ($8978bc38b4fd9d45$var$kindOf(val) !== "object") return false;
    var prototype = $8978bc38b4fd9d45$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ var $8978bc38b4fd9d45$var$isDate = $8978bc38b4fd9d45$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ var $8978bc38b4fd9d45$var$isFile = $8978bc38b4fd9d45$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ var $8978bc38b4fd9d45$var$isBlob = $8978bc38b4fd9d45$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ var $8978bc38b4fd9d45$var$isFileList = $8978bc38b4fd9d45$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ var $8978bc38b4fd9d45$var$isStream = function(val) {
    return $8978bc38b4fd9d45$var$isObject(val) && $8978bc38b4fd9d45$var$isFunction(val.pipe);
};
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ var $8978bc38b4fd9d45$var$isFormData = function(thing) {
    var kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $8978bc38b4fd9d45$var$isFunction(thing.append) && ((kind = $8978bc38b4fd9d45$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $8978bc38b4fd9d45$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ var $8978bc38b4fd9d45$var$isURLSearchParams = $8978bc38b4fd9d45$var$kindOfTest("URLSearchParams");
var $8978bc38b4fd9d45$var$_map = (0, $cv9Rk._)([
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($8978bc38b4fd9d45$var$kindOfTest), 4), $8978bc38b4fd9d45$var$isReadableStream = $8978bc38b4fd9d45$var$_map[0], $8978bc38b4fd9d45$var$isRequest = $8978bc38b4fd9d45$var$_map[1], $8978bc38b4fd9d45$var$isResponse = $8978bc38b4fd9d45$var$_map[2], $8978bc38b4fd9d45$var$isHeaders = $8978bc38b4fd9d45$var$_map[3];
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ var $8978bc38b4fd9d45$var$trim = function(str) {
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $8978bc38b4fd9d45$var$forEach(obj, fn) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_allOwnKeys = _ref.allOwnKeys, allOwnKeys = _ref_allOwnKeys === void 0 ? false : _ref_allOwnKeys;
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    var i;
    var l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($8978bc38b4fd9d45$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        var keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        var len = keys.length;
        var key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $8978bc38b4fd9d45$var$findKey(obj, key) {
    key = key.toLowerCase();
    var keys = Object.keys(obj);
    var i = keys.length;
    var _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
var $8978bc38b4fd9d45$var$_global = function() {
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
}();
var $8978bc38b4fd9d45$var$isContextDefined = function(context) {
    return !$8978bc38b4fd9d45$var$isUndefined(context) && context !== $8978bc38b4fd9d45$var$_global;
};
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $8978bc38b4fd9d45$var$merge() {
    var caseless = ($8978bc38b4fd9d45$var$isContextDefined(this) && this || {}).caseless;
    var result = {};
    var assignValue = function(val, key) {
        var targetKey = caseless && $8978bc38b4fd9d45$var$findKey(result, key) || key;
        if ($8978bc38b4fd9d45$var$isPlainObject(result[targetKey]) && $8978bc38b4fd9d45$var$isPlainObject(val)) result[targetKey] = $8978bc38b4fd9d45$var$merge(result[targetKey], val);
        else if ($8978bc38b4fd9d45$var$isPlainObject(val)) result[targetKey] = $8978bc38b4fd9d45$var$merge({}, val);
        else if ($8978bc38b4fd9d45$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(var i = 0, l = arguments.length; i < l; i++)arguments[i] && $8978bc38b4fd9d45$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ var $8978bc38b4fd9d45$var$extend = function(a, b, thisArg) {
    var allOwnKeys = (arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}).allOwnKeys;
    $8978bc38b4fd9d45$var$forEach(b, function(val, key) {
        if (thisArg && $8978bc38b4fd9d45$var$isFunction(val)) a[key] = (0, $67c4890188190b79$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ var $8978bc38b4fd9d45$var$stripBOM = function(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ var $8978bc38b4fd9d45$var$inherits = function(constructor, superConstructor, props, descriptors) {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ var $8978bc38b4fd9d45$var$toFlatObject = function(sourceObj, destObj, filter, propFilter) {
    var props;
    var i;
    var prop;
    var merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $8978bc38b4fd9d45$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ var $8978bc38b4fd9d45$var$endsWith = function(str, searchString, position) {
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    var lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ var $8978bc38b4fd9d45$var$toArray = function(thing) {
    if (!thing) return null;
    if ($8978bc38b4fd9d45$var$isArray(thing)) return thing;
    var i = thing.length;
    if (!$8978bc38b4fd9d45$var$isNumber(i)) return null;
    var arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
var $8978bc38b4fd9d45$var$isTypedArray = function(TypedArray) {
    // eslint-disable-next-line func-names
    return function(thing) {
        return TypedArray && thing instanceof TypedArray;
    };
}(typeof Uint8Array !== "undefined" && $8978bc38b4fd9d45$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ var $8978bc38b4fd9d45$var$forEachEntry = function(obj, fn) {
    var generator = obj && obj[Symbol.iterator];
    var iterator = generator.call(obj);
    var result;
    while((result = iterator.next()) && !result.done){
        var pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ var $8978bc38b4fd9d45$var$matchAll = function(regExp, str) {
    var matches;
    var arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ var $8978bc38b4fd9d45$var$isHTMLForm = $8978bc38b4fd9d45$var$kindOfTest("HTMLFormElement");
var $8978bc38b4fd9d45$var$toCamelCase = function(str) {
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ var $8978bc38b4fd9d45$var$hasOwnProperty = function(param) {
    var hasOwnProperty = param.hasOwnProperty;
    return function(obj, prop) {
        return hasOwnProperty.call(obj, prop);
    };
}(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ var $8978bc38b4fd9d45$var$isRegExp = $8978bc38b4fd9d45$var$kindOfTest("RegExp");
var $8978bc38b4fd9d45$var$reduceDescriptors = function(obj, reducer) {
    var descriptors = Object.getOwnPropertyDescriptors(obj);
    var reducedDescriptors = {};
    $8978bc38b4fd9d45$var$forEach(descriptors, function(descriptor, name) {
        var ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ var $8978bc38b4fd9d45$var$freezeMethods = function(obj) {
    $8978bc38b4fd9d45$var$reduceDescriptors(obj, function(descriptor, name) {
        // skip restricted props in strict mode
        if ($8978bc38b4fd9d45$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        var value = obj[name];
        if (!$8978bc38b4fd9d45$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = function() {
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
var $8978bc38b4fd9d45$var$toObjectSet = function(arrayOrString, delimiter) {
    var obj = {};
    var define = function(arr) {
        arr.forEach(function(value) {
            obj[value] = true;
        });
    };
    $8978bc38b4fd9d45$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
var $8978bc38b4fd9d45$var$noop = function() {};
var $8978bc38b4fd9d45$var$toFiniteNumber = function(value, defaultValue) {
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
var $8978bc38b4fd9d45$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
var $8978bc38b4fd9d45$var$DIGIT = "0123456789";
var $8978bc38b4fd9d45$var$ALPHABET = {
    DIGIT: $8978bc38b4fd9d45$var$DIGIT,
    ALPHA: $8978bc38b4fd9d45$var$ALPHA,
    ALPHA_DIGIT: $8978bc38b4fd9d45$var$ALPHA + $8978bc38b4fd9d45$var$ALPHA.toUpperCase() + $8978bc38b4fd9d45$var$DIGIT
};
var $8978bc38b4fd9d45$var$generateString = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 16, alphabet = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $8978bc38b4fd9d45$var$ALPHABET.ALPHA_DIGIT;
    var str = "";
    var length = alphabet.length;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $8978bc38b4fd9d45$var$isSpecCompliantForm(thing) {
    return !!(thing && $8978bc38b4fd9d45$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
var $8978bc38b4fd9d45$var$toJSONObject = function(obj) {
    var stack = new Array(10);
    var visit = function(source, i) {
        if ($8978bc38b4fd9d45$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                var target = $8978bc38b4fd9d45$var$isArray(source) ? [] : {};
                $8978bc38b4fd9d45$var$forEach(source, function(value, key) {
                    var reducedValue = visit(value, i + 1);
                    !$8978bc38b4fd9d45$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
var $8978bc38b4fd9d45$var$isAsyncFn = $8978bc38b4fd9d45$var$kindOfTest("AsyncFunction");
var $8978bc38b4fd9d45$var$isThenable = function(thing) {
    return thing && ($8978bc38b4fd9d45$var$isObject(thing) || $8978bc38b4fd9d45$var$isFunction(thing)) && $8978bc38b4fd9d45$var$isFunction(thing.then) && $8978bc38b4fd9d45$var$isFunction(thing.catch);
};
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
var $8978bc38b4fd9d45$var$_setImmediate = function(setImmediateSupported, postMessageSupported) {
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? function(token, callbacks) {
        $8978bc38b4fd9d45$var$_global.addEventListener("message", function(param) {
            var source = param.source, data = param.data;
            if (source === $8978bc38b4fd9d45$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return function(cb) {
            callbacks.push(cb);
            $8978bc38b4fd9d45$var$_global.postMessage(token, "*");
        };
    }("axios@".concat(Math.random()), []) : function(cb) {
        return setTimeout(cb);
    };
}(typeof setImmediate === "function", $8978bc38b4fd9d45$var$isFunction($8978bc38b4fd9d45$var$_global.postMessage));
var $8978bc38b4fd9d45$var$asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind($8978bc38b4fd9d45$var$_global) : typeof $3qWgZ !== "undefined" && $3qWgZ.nextTick || $8978bc38b4fd9d45$var$_setImmediate;
var // *********************
$8978bc38b4fd9d45$export$2e2bcd8739ae039 = {
    isArray: $8978bc38b4fd9d45$var$isArray,
    isArrayBuffer: $8978bc38b4fd9d45$var$isArrayBuffer,
    isBuffer: $8978bc38b4fd9d45$var$isBuffer,
    isFormData: $8978bc38b4fd9d45$var$isFormData,
    isArrayBufferView: $8978bc38b4fd9d45$var$isArrayBufferView,
    isString: $8978bc38b4fd9d45$var$isString,
    isNumber: $8978bc38b4fd9d45$var$isNumber,
    isBoolean: $8978bc38b4fd9d45$var$isBoolean,
    isObject: $8978bc38b4fd9d45$var$isObject,
    isPlainObject: $8978bc38b4fd9d45$var$isPlainObject,
    isReadableStream: $8978bc38b4fd9d45$var$isReadableStream,
    isRequest: $8978bc38b4fd9d45$var$isRequest,
    isResponse: $8978bc38b4fd9d45$var$isResponse,
    isHeaders: $8978bc38b4fd9d45$var$isHeaders,
    isUndefined: $8978bc38b4fd9d45$var$isUndefined,
    isDate: $8978bc38b4fd9d45$var$isDate,
    isFile: $8978bc38b4fd9d45$var$isFile,
    isBlob: $8978bc38b4fd9d45$var$isBlob,
    isRegExp: $8978bc38b4fd9d45$var$isRegExp,
    isFunction: $8978bc38b4fd9d45$var$isFunction,
    isStream: $8978bc38b4fd9d45$var$isStream,
    isURLSearchParams: $8978bc38b4fd9d45$var$isURLSearchParams,
    isTypedArray: $8978bc38b4fd9d45$var$isTypedArray,
    isFileList: $8978bc38b4fd9d45$var$isFileList,
    forEach: $8978bc38b4fd9d45$var$forEach,
    merge: $8978bc38b4fd9d45$var$merge,
    extend: $8978bc38b4fd9d45$var$extend,
    trim: $8978bc38b4fd9d45$var$trim,
    stripBOM: $8978bc38b4fd9d45$var$stripBOM,
    inherits: $8978bc38b4fd9d45$var$inherits,
    toFlatObject: $8978bc38b4fd9d45$var$toFlatObject,
    kindOf: $8978bc38b4fd9d45$var$kindOf,
    kindOfTest: $8978bc38b4fd9d45$var$kindOfTest,
    endsWith: $8978bc38b4fd9d45$var$endsWith,
    toArray: $8978bc38b4fd9d45$var$toArray,
    forEachEntry: $8978bc38b4fd9d45$var$forEachEntry,
    matchAll: $8978bc38b4fd9d45$var$matchAll,
    isHTMLForm: $8978bc38b4fd9d45$var$isHTMLForm,
    hasOwnProperty: $8978bc38b4fd9d45$var$hasOwnProperty,
    hasOwnProp: $8978bc38b4fd9d45$var$hasOwnProperty,
    reduceDescriptors: $8978bc38b4fd9d45$var$reduceDescriptors,
    freezeMethods: $8978bc38b4fd9d45$var$freezeMethods,
    toObjectSet: $8978bc38b4fd9d45$var$toObjectSet,
    toCamelCase: $8978bc38b4fd9d45$var$toCamelCase,
    noop: $8978bc38b4fd9d45$var$noop,
    toFiniteNumber: $8978bc38b4fd9d45$var$toFiniteNumber,
    findKey: $8978bc38b4fd9d45$var$findKey,
    global: $8978bc38b4fd9d45$var$_global,
    isContextDefined: $8978bc38b4fd9d45$var$isContextDefined,
    ALPHABET: $8978bc38b4fd9d45$var$ALPHABET,
    generateString: $8978bc38b4fd9d45$var$generateString,
    isSpecCompliantForm: $8978bc38b4fd9d45$var$isSpecCompliantForm,
    toJSONObject: $8978bc38b4fd9d45$var$toJSONObject,
    isAsyncFn: $8978bc38b4fd9d45$var$isAsyncFn,
    isThenable: $8978bc38b4fd9d45$var$isThenable,
    setImmediate: $8978bc38b4fd9d45$var$_setImmediate,
    asap: $8978bc38b4fd9d45$var$asap
};




var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $eha6O = parcelRequire("eha6O");




"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $23f55eba377f5456$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).inherits($23f55eba377f5456$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
var $23f55eba377f5456$var$prototype = $23f55eba377f5456$var$AxiosError.prototype;
var $23f55eba377f5456$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach(function(code) {
    $23f55eba377f5456$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($23f55eba377f5456$var$AxiosError, $23f55eba377f5456$var$descriptors);
Object.defineProperty($23f55eba377f5456$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$23f55eba377f5456$var$AxiosError.from = function(error, code, config, request, response, customProps) {
    var axiosError = Object.create($23f55eba377f5456$var$prototype);
    (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, function(prop) {
        return prop !== "isAxiosError";
    });
    $23f55eba377f5456$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $23f55eba377f5456$export$2e2bcd8739ae039 = $23f55eba377f5456$var$AxiosError;


// eslint-disable-next-line strict
var $4d25f865c46a0982$export$2e2bcd8739ae039 = null;



var $8dlmd = parcelRequire("8dlmd");
var $8f2473769c2fa420$require$Buffer = $8dlmd.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $8f2473769c2fa420$var$isVisitable(thing) {
    return (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $8f2473769c2fa420$var$removeBrackets(key) {
    return (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $8f2473769c2fa420$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $8f2473769c2fa420$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $8f2473769c2fa420$var$isFlatArray(arr) {
    return (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isArray(arr) && !arr.some($8f2473769c2fa420$var$isVisitable);
}
var $8f2473769c2fa420$var$predicates = (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).toFlatObject((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $8f2473769c2fa420$var$toFormData(obj, formData, options) {
    if (!(0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $4d25f865c46a0982$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    var metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    var visitor = options.visitor || defaultVisitor;
    var dots = options.dots;
    var indexes = options.indexes;
    var _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    var useBlob = _Blob && (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $23f55eba377f5456$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $8f2473769c2fa420$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        var arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isArray(value) && $8f2473769c2fa420$var$isFlatArray(value) || ((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isFileList(value) || (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $8f2473769c2fa420$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $8f2473769c2fa420$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($8f2473769c2fa420$var$isVisitable(value)) return true;
        formData.append($8f2473769c2fa420$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    var stack = [];
    var exposedHelpers = Object.assign($8f2473769c2fa420$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $8f2473769c2fa420$var$isVisitable
    });
    function build(value, path) {
        if ((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            var result = !((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $8f2473769c2fa420$export$2e2bcd8739ae039 = $8f2473769c2fa420$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $aceeb2fa81b27c75$var$encode(str) {
    var charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $aceeb2fa81b27c75$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $8f2473769c2fa420$export$2e2bcd8739ae039)(params, this, options);
}
var $aceeb2fa81b27c75$var$prototype = $aceeb2fa81b27c75$var$AxiosURLSearchParams.prototype;
$aceeb2fa81b27c75$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$aceeb2fa81b27c75$var$prototype.toString = function toString(encoder) {
    var _encode = encoder ? function _encode(value) {
        return encoder.call(this, value, $aceeb2fa81b27c75$var$encode);
    } : $aceeb2fa81b27c75$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $aceeb2fa81b27c75$export$2e2bcd8739ae039 = $aceeb2fa81b27c75$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $139d54524bb33fbe$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $139d54524bb33fbe$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var _encode = options && options.encode || $139d54524bb33fbe$var$encode;
    var serializeFn = options && options.serialize;
    var serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $aceeb2fa81b27c75$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

"use strict";
var $588268bc2bc9eb74$var$InterceptorManager = /*#__PURE__*/ function() {
    function InterceptorManager() {
        (0, $4GJKx._)(this, InterceptorManager);
        this.handlers = [];
    }
    (0, $1wc17._)(InterceptorManager, [
        {
            /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ key: "use",
            value: function use(fulfilled, rejected, options) {
                this.handlers.push({
                    fulfilled: fulfilled,
                    rejected: rejected,
                    synchronous: options ? options.synchronous : false,
                    runWhen: options ? options.runWhen : null
                });
                return this.handlers.length - 1;
            }
        },
        {
            /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ key: "eject",
            value: function eject(id) {
                if (this.handlers[id]) this.handlers[id] = null;
            }
        },
        {
            /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ key: "clear",
            value: function clear() {
                if (this.handlers) this.handlers = [];
            }
        },
        {
            /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ key: "forEach",
            value: function forEach(fn) {
                (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
                    if (h !== null) fn(h);
                });
            }
        }
    ]);
    return InterceptorManager;
}();
var $588268bc2bc9eb74$export$2e2bcd8739ae039 = $588268bc2bc9eb74$var$InterceptorManager;





"use strict";
var $7201287a7b743550$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






var $do9pw = parcelRequire("do9pw");

"use strict";
var $a3804c41b01e4396$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $aceeb2fa81b27c75$export$2e2bcd8739ae039);


"use strict";
var $903ff5d7426cf622$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $b4b153b1faba033b$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $1726160cd5d9c2ef$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: (0, $a3804c41b01e4396$export$2e2bcd8739ae039),
        FormData: (0, $903ff5d7426cf622$export$2e2bcd8739ae039),
        Blob: (0, $b4b153b1faba033b$export$2e2bcd8739ae039)
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $68eea29ce1a374ea$exports = {};

$parcel$export($68eea29ce1a374ea$exports, "hasBrowserEnv", function () { return $68eea29ce1a374ea$export$c4996c4b7b93b0bf; });
$parcel$export($68eea29ce1a374ea$exports, "navigator", function () { return $68eea29ce1a374ea$export$ec7c8efa7f5790ae; });
$parcel$export($68eea29ce1a374ea$exports, "hasStandardBrowserEnv", function () { return $68eea29ce1a374ea$export$c0bcc9250309d66; });
$parcel$export($68eea29ce1a374ea$exports, "hasStandardBrowserWebWorkerEnv", function () { return $68eea29ce1a374ea$export$c81692cf5af97dac; });
$parcel$export($68eea29ce1a374ea$exports, "origin", function () { return $68eea29ce1a374ea$export$f710a83a91838a36; });
var $68eea29ce1a374ea$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
var $68eea29ce1a374ea$export$ec7c8efa7f5790ae = typeof navigator === "object" && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ var $68eea29ce1a374ea$export$c0bcc9250309d66 = $68eea29ce1a374ea$export$c4996c4b7b93b0bf && (!$68eea29ce1a374ea$export$ec7c8efa7f5790ae || [
    "ReactNative",
    "NativeScript",
    "NS"
].indexOf($68eea29ce1a374ea$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ var $68eea29ce1a374ea$export$c81692cf5af97dac = function() {
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
}();
var $68eea29ce1a374ea$export$f710a83a91838a36 = $68eea29ce1a374ea$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";


var $6316f3d4cabce5cc$export$2e2bcd8739ae039 = (0, $do9pw._)({}, $68eea29ce1a374ea$exports, (0, $1726160cd5d9c2ef$export$2e2bcd8739ae039));


"use strict";
function $9b1ea81c66df6b9e$export$2e2bcd8739ae039(data, options) {
    return (0, $8f2473769c2fa420$export$2e2bcd8739ae039)(data, new (0, $6316f3d4cabce5cc$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function visitor(value, key, path, helpers) {
            if ((0, $6316f3d4cabce5cc$export$2e2bcd8739ae039).isNode && (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $1797e45e79d81ad9$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map(function(match) {
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $1797e45e79d81ad9$var$arrayToObject(arr) {
    var obj = {};
    var keys = Object.keys(arr);
    var i;
    var len = keys.length;
    var key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $1797e45e79d81ad9$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        var name = path[index++];
        if (name === "__proto__") return true;
        var isNumericKey = Number.isFinite(+name);
        var isLast = index >= path.length;
        name = !name && (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        var result = buildPath(path, value, target[name], index);
        if (result && (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $1797e45e79d81ad9$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isFormData(formData) && (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        var obj = {};
        (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).forEachEntry(formData, function(name, value) {
            buildPath($1797e45e79d81ad9$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $1797e45e79d81ad9$export$2e2bcd8739ae039 = $1797e45e79d81ad9$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $d5f67f5251d190d5$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $d5f67f5251d190d5$var$defaults = {
    transitional: (0, $7201287a7b743550$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            var contentType = headers.getContentType() || "";
            var hasJSONContentType = contentType.indexOf("application/json") > -1;
            var isObjectPayload = (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            var isFormData = (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $1797e45e79d81ad9$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isBuffer(data) || (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isStream(data) || (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isFile(data) || (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isBlob(data) || (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            var isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $9b1ea81c66df6b9e$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    var _FormData = this.env && this.env.FormData;
                    return (0, $8f2473769c2fa420$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $d5f67f5251d190d5$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $d5f67f5251d190d5$var$defaults.transitional;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var JSONRequested = this.responseType === "json";
            if ((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isResponse(data) || (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                var silentJSONParsing = transitional && transitional.silentJSONParsing;
                var strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $23f55eba377f5456$export$2e2bcd8739ae039).from(e, (0, $23f55eba377f5456$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $6316f3d4cabce5cc$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $6316f3d4cabce5cc$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], function(method) {
    $d5f67f5251d190d5$var$defaults.headers[method] = {};
});
var $d5f67f5251d190d5$export$2e2bcd8739ae039 = $d5f67f5251d190d5$var$defaults;



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");


"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $56a20c8304ed9fc0$var$ignoreDuplicateOf = (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $56a20c8304ed9fc0$export$2e2bcd8739ae039 = function(rawHeaders) {
    var parsed = {};
    var key;
    var val;
    var i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $56a20c8304ed9fc0$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
var $a07841e7e23ec317$var$$internals = Symbol("internals");
function $a07841e7e23ec317$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $a07841e7e23ec317$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isArray(value) ? value.map($a07841e7e23ec317$var$normalizeValue) : String(value);
}
function $a07841e7e23ec317$var$parseTokens(str) {
    var tokens = Object.create(null);
    var tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    var match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
var $a07841e7e23ec317$var$isValidHeaderName = function(str) {
    return /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
};
function $a07841e7e23ec317$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $a07841e7e23ec317$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, function(w, char, str) {
        return char.toUpperCase() + str;
    });
}
function $a07841e7e23ec317$var$buildAccessors(obj, header) {
    var accessorName = (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach(function(methodName) {
        Object.defineProperty(obj, methodName + accessorName, {
            value: function value(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
var $a07841e7e23ec317$var$AxiosHeaders = /*#__PURE__*/ function() {
    function AxiosHeaders(headers) {
        (0, $4GJKx._)(this, AxiosHeaders);
        headers && this.set(headers);
    }
    (0, $1wc17._)(AxiosHeaders, [
        {
            key: "set",
            value: function set(header, valueOrRewrite, rewrite) {
                var self = this;
                function setHeader(_value, _header, _rewrite) {
                    var lHeader = $a07841e7e23ec317$var$normalizeHeader(_header);
                    if (!lHeader) throw new Error("header name must be a non-empty string");
                    var key = (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).findKey(self, lHeader);
                    if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $a07841e7e23ec317$var$normalizeValue(_value);
                }
                var setHeaders = function(headers, _rewrite) {
                    return (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).forEach(headers, function(_value, _header) {
                        return setHeader(_value, _header, _rewrite);
                    });
                };
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if ((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
                else if ((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$a07841e7e23ec317$var$isValidHeaderName(header)) setHeaders((0, $56a20c8304ed9fc0$export$2e2bcd8739ae039)(header), valueOrRewrite);
                else if ((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isHeaders(header)) try {
                    for(var _iterator = header.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $cv9Rk._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                        setHeader(value, key, rewrite);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                else header != null && setHeader(valueOrRewrite, header, rewrite);
                return this;
            }
        },
        {
            key: "get",
            value: function get(header, parser) {
                header = $a07841e7e23ec317$var$normalizeHeader(header);
                if (header) {
                    var key = (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).findKey(this, header);
                    if (key) {
                        var value = this[key];
                        if (!parser) return value;
                        if (parser === true) return $a07841e7e23ec317$var$parseTokens(value);
                        if ((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                        if ((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                        throw new TypeError("parser must be boolean|regexp|function");
                    }
                }
            }
        },
        {
            key: "has",
            value: function has(header, matcher) {
                header = $a07841e7e23ec317$var$normalizeHeader(header);
                if (header) {
                    var key = (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).findKey(this, header);
                    return !!(key && this[key] !== undefined && (!matcher || $a07841e7e23ec317$var$matchHeaderValue(this, this[key], key, matcher)));
                }
                return false;
            }
        },
        {
            key: "delete",
            value: function _delete(header, matcher) {
                var self = this;
                var deleted = false;
                function deleteHeader(_header) {
                    _header = $a07841e7e23ec317$var$normalizeHeader(_header);
                    if (_header) {
                        var key = (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).findKey(self, _header);
                        if (key && (!matcher || $a07841e7e23ec317$var$matchHeaderValue(self, self[key], key, matcher))) {
                            delete self[key];
                            deleted = true;
                        }
                    }
                }
                if ((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
                else deleteHeader(header);
                return deleted;
            }
        },
        {
            key: "clear",
            value: function clear(matcher) {
                var keys = Object.keys(this);
                var i = keys.length;
                var deleted = false;
                while(i--){
                    var key = keys[i];
                    if (!matcher || $a07841e7e23ec317$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                        delete this[key];
                        deleted = true;
                    }
                }
                return deleted;
            }
        },
        {
            key: "normalize",
            value: function normalize(format) {
                var self = this;
                var headers = {};
                (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).forEach(this, function(value, header) {
                    var key = (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).findKey(headers, header);
                    if (key) {
                        self[key] = $a07841e7e23ec317$var$normalizeValue(value);
                        delete self[header];
                        return;
                    }
                    var normalized = format ? $a07841e7e23ec317$var$formatHeader(header) : String(header).trim();
                    if (normalized !== header) delete self[header];
                    self[normalized] = $a07841e7e23ec317$var$normalizeValue(value);
                    headers[normalized] = true;
                });
                return this;
            }
        },
        {
            key: "concat",
            value: function concat() {
                for(var _len = arguments.length, targets = new Array(_len), _key = 0; _key < _len; _key++){
                    targets[_key] = arguments[_key];
                }
                var _this_constructor;
                return (_this_constructor = this.constructor).concat.apply(_this_constructor, [
                    this
                ].concat((0, $c6Xmf._)(targets)));
            }
        },
        {
            key: "toJSON",
            value: function toJSON(asStrings) {
                var obj = Object.create(null);
                (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).forEach(this, function(value, header) {
                    value != null && value !== false && (obj[header] = asStrings && (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
                });
                return obj;
            }
        },
        {
            key: Symbol.iterator,
            value: function value() {
                return Object.entries(this.toJSON())[Symbol.iterator]();
            }
        },
        {
            key: "toString",
            value: function toString() {
                return Object.entries(this.toJSON()).map(function(param) {
                    var _param = (0, $cv9Rk._)(param, 2), header = _param[0], value = _param[1];
                    return header + ": " + value;
                }).join("\n");
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "AxiosHeaders";
            }
        }
    ], [
        {
            key: "from",
            value: function from(thing) {
                return thing instanceof this ? thing : new this(thing);
            }
        },
        {
            key: "concat",
            value: function concat(first) {
                for(var _len = arguments.length, targets = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    targets[_key - 1] = arguments[_key];
                }
                var computed = new this(first);
                targets.forEach(function(target) {
                    return computed.set(target);
                });
                return computed;
            }
        },
        {
            key: "accessor",
            value: function accessor(header) {
                var internals = this[$a07841e7e23ec317$var$$internals] = this[$a07841e7e23ec317$var$$internals] = {
                    accessors: {}
                };
                var accessors = internals.accessors;
                var prototype = this.prototype;
                function defineAccessor(_header) {
                    var lHeader = $a07841e7e23ec317$var$normalizeHeader(_header);
                    if (!accessors[lHeader]) {
                        $a07841e7e23ec317$var$buildAccessors(prototype, _header);
                        accessors[lHeader] = true;
                    }
                }
                (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
                return this;
            }
        }
    ]);
    return AxiosHeaders;
}();
$a07841e7e23ec317$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).reduceDescriptors($a07841e7e23ec317$var$AxiosHeaders.prototype, function(param, key) {
    var value = param.value;
    var mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: function() {
            return value;
        },
        set: function(headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).freezeMethods($a07841e7e23ec317$var$AxiosHeaders);
var $a07841e7e23ec317$export$2e2bcd8739ae039 = $a07841e7e23ec317$var$AxiosHeaders;


"use strict";
function $72c6a3e7f725c92e$export$2e2bcd8739ae039(fns, response) {
    var config = this || (0, $d5f67f5251d190d5$export$2e2bcd8739ae039);
    var context = response || config;
    var headers = (0, $a07841e7e23ec317$export$2e2bcd8739ae039).from(context.headers);
    var data = context.data;
    (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $bf3d392823176dec$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $362efa0bfd268d89$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $23f55eba377f5456$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $23f55eba377f5456$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).inherits($362efa0bfd268d89$var$CanceledError, (0, $23f55eba377f5456$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $362efa0bfd268d89$export$2e2bcd8739ae039 = $362efa0bfd268d89$var$CanceledError;




var $cv9Rk = parcelRequire("cv9Rk");



var $cv9Rk = parcelRequire("cv9Rk");


"use strict";
function $c52485f5ecc194bf$export$2e2bcd8739ae039(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $23f55eba377f5456$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $23f55eba377f5456$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $23f55eba377f5456$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





"use strict";
function $40bb9a1d7f194b0d$export$2e2bcd8739ae039(url) {
    var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}





var $3sHb8 = parcelRequire("3sHb8");

var $c6Xmf = parcelRequire("c6Xmf");
"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $e09c3146f27a9c50$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    var bytes = new Array(samplesCount);
    var timestamps = new Array(samplesCount);
    var head = 0;
    var tail = 0;
    var firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        var now = Date.now();
        var startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        var i = tail;
        var bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        var passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $e09c3146f27a9c50$export$2e2bcd8739ae039 = $e09c3146f27a9c50$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $c671e0a3a1a1b2af$var$throttle(fn, freq) {
    var timestamp = 0;
    var threshold = 1000 / freq;
    var lastArgs;
    var timer;
    var invoke = function(args) {
        var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    var throttled = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var now = Date.now();
        var passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(function() {
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    var flush = function() {
        return lastArgs && invoke(lastArgs);
    };
    return [
        throttled,
        flush
    ];
}
var $c671e0a3a1a1b2af$export$2e2bcd8739ae039 = $c671e0a3a1a1b2af$var$throttle;



var $f325318ccb5e605c$export$c1b28109d46c3592 = function(listener, isDownloadStream) {
    var freq = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3;
    var bytesNotified = 0;
    var _speedometer = (0, $e09c3146f27a9c50$export$2e2bcd8739ae039)(50, 250);
    return (0, $c671e0a3a1a1b2af$export$2e2bcd8739ae039)(function(e) {
        var loaded = e.loaded;
        var total = e.lengthComputable ? e.total : undefined;
        var progressBytes = loaded - bytesNotified;
        var rate = _speedometer(progressBytes);
        var inRange = loaded <= total;
        bytesNotified = loaded;
        var data = (0, $3sHb8._)({
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null
        }, isDownloadStream ? "download" : "upload", true);
        listener(data);
    }, freq);
};
var $f325318ccb5e605c$export$d9fadd12586c18d6 = function(total, throttled) {
    var lengthComputable = total != null;
    return [
        function(loaded) {
            return throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            });
        },
        throttled[1]
    ];
};
var $f325318ccb5e605c$export$5d35863c355a22a9 = function(fn) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).asap(function() {
            return fn.apply(void 0, (0, $c6Xmf._)(args));
        });
    };
};



var $gdHfP = parcelRequire("gdHfP");

var $c6Xmf = parcelRequire("c6Xmf");




"use strict";
var $a9969ca74c845630$export$2e2bcd8739ae039 = (0, $6316f3d4cabce5cc$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = (0, $6316f3d4cabce5cc$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $6316f3d4cabce5cc$export$2e2bcd8739ae039).navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();




var $796d4763ce0f83a8$export$2e2bcd8739ae039 = (0, $6316f3d4cabce5cc$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write: function(name, value, expires, path, domain, secure) {
        var cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isString(path) && cookie.push("path=" + path);
        (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read: function(name) {
        var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove: function(name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write: function() {},
    read: function() {
        return null;
    },
    remove: function() {}
};


"use strict";
function $57d68b8910dc5aed$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $d1b1396a7c007310$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $151097c3bcaa8131$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $57d68b8910dc5aed$export$2e2bcd8739ae039)(requestedURL)) return (0, $d1b1396a7c007310$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}



var $do9pw = parcelRequire("do9pw");


"use strict";
var $8c2f0de1517b3b7f$var$headersToObject = function(thing) {
    return thing instanceof (0, $a07841e7e23ec317$export$2e2bcd8739ae039) ? (0, $do9pw._)({}, thing) : thing;
};
function $8c2f0de1517b3b7f$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isPlainObject(target) && (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    var mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: function(a, b) {
            return mergeDeepProperties($8c2f0de1517b3b7f$var$headersToObject(a), $8c2f0de1517b3b7f$var$headersToObject(b), true);
        }
    };
    (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(config1[prop], config2[prop], prop);
        (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $b7ad20900308004e$export$2e2bcd8739ae039 = function(config) {
    var newConfig = (0, $8c2f0de1517b3b7f$export$2e2bcd8739ae039)({}, config);
    var data = newConfig.data, withXSRFToken = newConfig.withXSRFToken, xsrfHeaderName = newConfig.xsrfHeaderName, xsrfCookieName = newConfig.xsrfCookieName, headers = newConfig.headers, auth = newConfig.auth;
    newConfig.headers = headers = (0, $a07841e7e23ec317$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $139d54524bb33fbe$export$2e2bcd8739ae039)((0, $151097c3bcaa8131$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set("Authorization", "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : "")));
    var contentType;
    if ((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $6316f3d4cabce5cc$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $6316f3d4cabce5cc$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            var _ref = (0, $gdHfP._)(contentType ? contentType.split(";").map(function(token) {
                return token.trim();
            }).filter(Boolean) : []), type = _ref[0], tokens = _ref.slice(1);
            headers.setContentType([
                type || "multipart/form-data"
            ].concat((0, $c6Xmf._)(tokens)).join("; "));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $6316f3d4cabce5cc$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $a9969ca74c845630$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            var xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $796d4763ce0f83a8$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


var $84e90eb6e38b873a$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $84e90eb6e38b873a$export$2e2bcd8739ae039 = $84e90eb6e38b873a$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var _config = (0, $b7ad20900308004e$export$2e2bcd8739ae039)(config);
        var requestData = _config.data;
        var requestHeaders = (0, $a07841e7e23ec317$export$2e2bcd8739ae039).from(_config.headers).normalize();
        var responseType = _config.responseType, onUploadProgress = _config.onUploadProgress, onDownloadProgress = _config.onDownloadProgress;
        var onCanceled;
        var uploadThrottled, downloadThrottled;
        var flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener("abort", onCanceled);
        }
        var request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = (0, $a07841e7e23ec317$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $c52485f5ecc194bf$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $23f55eba377f5456$export$2e2bcd8739ae039)("Request aborted", (0, $23f55eba377f5456$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $23f55eba377f5456$export$2e2bcd8739ae039)("Network Error", (0, $23f55eba377f5456$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            var transitional = _config.transitional || (0, $7201287a7b743550$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $23f55eba377f5456$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $23f55eba377f5456$export$2e2bcd8739ae039).ETIMEDOUT : (0, $23f55eba377f5456$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            var ref;
            ref = (0, $cv9Rk._)((0, $f325318ccb5e605c$export$c1b28109d46c3592)(onDownloadProgress, true), 2), downloadThrottled = ref[0], flushDownload = ref[1], ref;
            request.addEventListener("progress", downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            var ref1;
            ref1 = (0, $cv9Rk._)((0, $f325318ccb5e605c$export$c1b28109d46c3592)(onUploadProgress), 2), uploadThrottled = ref1[0], flushUpload = ref1[1], ref1;
            request.upload.addEventListener("progress", uploadThrottled);
            request.upload.addEventListener("loadend", flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $362efa0bfd268d89$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        var protocol = (0, $40bb9a1d7f194b0d$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $6316f3d4cabce5cc$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $23f55eba377f5456$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $23f55eba377f5456$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};



var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $eha6O = parcelRequire("eha6O");






var $ab7fc8bfb59ffa15$var$composeSignals = function(signals, timeout) {
    var length = (signals = signals ? signals.filter(Boolean) : []).length;
    if (timeout || length) {
        var controller = new AbortController();
        var aborted;
        var onabort = function onabort(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                var err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $23f55eba377f5456$export$2e2bcd8739ae039) ? err : new (0, $362efa0bfd268d89$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        var timer = timeout && setTimeout(function() {
            timer = null;
            onabort(new (0, $23f55eba377f5456$export$2e2bcd8739ae039)("timeout ".concat(timeout, " of ms exceeded"), (0, $23f55eba377f5456$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        var unsubscribe = function() {
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach(function(signal) {
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener("abort", onabort);
                });
                signals = null;
            }
        };
        signals.forEach(function(signal) {
            return signal.addEventListener("abort", onabort);
        });
        var signal = controller.signal;
        signal.unsubscribe = function() {
            return (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).asap(unsubscribe);
        };
        return signal;
    }
};
var $ab7fc8bfb59ffa15$export$2e2bcd8739ae039 = $ab7fc8bfb59ffa15$var$composeSignals;


function $68cf7c021fefc6fc$export$71511d61b312f219(inner, awaitWrap) {
    var iter = {}, waiting = false;
    function pump(key, value) {
        waiting = true;
        value = new Promise(function(resolve) {
            resolve(inner[key](value));
        });
        return {
            done: false,
            value: awaitWrap(value)
        };
    }
    if (typeof Symbol === "function" && Symbol.iterator) iter[Symbol.iterator] = function() {
        return this;
    };
    iter.next = function(value) {
        if (waiting) {
            waiting = false;
            return value;
        }
        return pump("next", value);
    };
    if (typeof inner.throw === "function") iter.throw = function(value) {
        if (waiting) {
            waiting = false;
            throw value;
        }
        return pump("throw", value);
    };
    if (typeof inner.return === "function") iter.return = function(value) {
        return pump("return", value);
    };
    return iter;
}


function $c8615161abeda9f1$export$71511d61b312f219(iterable) {
    var method, async, sync, retry = 2;
    for("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;){
        if (async && null != (method = iterable[async])) return method.call(iterable);
        if (sync && null != (method = iterable[sync])) return new $c8615161abeda9f1$var$AsyncFromSyncIterator(method.call(iterable));
        async = "@@asyncIterator", sync = "@@iterator";
    }
    throw new TypeError("Object is not async iterable");
}
function $c8615161abeda9f1$var$AsyncFromSyncIterator(s) {
    function AsyncFromSyncIteratorContinuation(r) {
        if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object."));
        var done = r.done;
        return Promise.resolve(r.value).then(function(value) {
            return {
                value: value,
                done: done
            };
        });
    }
    return $c8615161abeda9f1$var$AsyncFromSyncIterator = function(s) {
        this.s = s, this.n = s.next;
    }, $c8615161abeda9f1$var$AsyncFromSyncIterator.prototype = {
        s: null,
        n: null,
        next: function() {
            return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
        },
        return: function(value) {
            var ret = this.s.return;
            return void 0 === ret ? Promise.resolve({
                value: value,
                done: !0
            }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments));
        },
        throw: function(value) {
            var thr = this.s.return;
            return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments));
        }
    }, new $c8615161abeda9f1$var$AsyncFromSyncIterator(s);
}



var $kSuI9 = parcelRequire("kSuI9");
function $cc1aeed869364e4c$export$71511d61b312f219(value) {
    this.wrapped = value;
}


function $85d928f5abad2213$export$71511d61b312f219(value) {
    return new (0, $cc1aeed869364e4c$export$71511d61b312f219)(value);
}



function $dcca5116e589d888$export$71511d61b312f219(gen) {
    var front, back;
    function send(key, arg) {
        return new Promise(function(resolve, reject) {
            var request = {
                key: key,
                arg: arg,
                resolve: resolve,
                reject: reject,
                next: null
            };
            if (back) back = back.next = request;
            else {
                front = back = request;
                resume(key, arg);
            }
        });
    }
    function resume(key, arg) {
        try {
            var result = gen[key](arg);
            var value = result.value;
            var wrappedAwait = value instanceof (0, $cc1aeed869364e4c$export$71511d61b312f219);
            Promise.resolve(wrappedAwait ? value.wrapped : value).then(function(arg) {
                if (wrappedAwait) {
                    resume("next", arg);
                    return;
                }
                settle(result.done ? "return" : "normal", arg);
            }, function(err) {
                resume("throw", err);
            });
        } catch (err) {
            settle("throw", err);
        }
    }
    function settle(type, value) {
        switch(type){
            case "return":
                front.resolve({
                    value: value,
                    done: true
                });
                break;
            case "throw":
                front.reject(value);
                break;
            default:
                front.resolve({
                    value: value,
                    done: false
                });
                break;
        }
        front = front.next;
        if (front) resume(front.key, front.arg);
        else back = null;
    }
    this._invoke = send;
    if (typeof gen.return !== "function") this.return = undefined;
}
if (typeof Symbol === "function" && Symbol.asyncIterator) $dcca5116e589d888$export$71511d61b312f219.prototype[Symbol.asyncIterator] = function() {
    return this;
};
$dcca5116e589d888$export$71511d61b312f219.prototype.next = function(arg) {
    return this._invoke("next", arg);
};
$dcca5116e589d888$export$71511d61b312f219.prototype.throw = function(arg) {
    return this._invoke("throw", arg);
};
$dcca5116e589d888$export$71511d61b312f219.prototype.return = function(arg) {
    return this._invoke("return", arg);
};


function $8eba423faf80607e$export$71511d61b312f219(fn) {
    return function() {
        return new (0, $dcca5116e589d888$export$71511d61b312f219)(fn.apply(this, arguments));
    };
}



var $eha6O = parcelRequire("eha6O");

var $eha6O = parcelRequire("eha6O");
var $9788b673e96bd682$export$71b051935044bd5d = function streamChunk(chunk, chunkSize) {
    var len, pos, end;
    return (0, $eha6O.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                len = chunk.byteLength;
                if (!(!chunkSize || len < chunkSize)) return [
                    3,
                    2
                ];
                return [
                    4,
                    chunk
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
            case 2:
                pos = 0;
                _state.label = 3;
            case 3:
                if (!(pos < len)) return [
                    3,
                    5
                ];
                end = pos + chunkSize;
                return [
                    4,
                    chunk.slice(pos, end)
                ];
            case 4:
                _state.sent();
                pos = end;
                return [
                    3,
                    3
                ];
            case 5:
                return [
                    2
                ];
        }
    });
};
var $9788b673e96bd682$export$f9f241124ee3198e = function() {
    var _ref = (0, $8eba423faf80607e$export$71511d61b312f219)(function(iterable, chunkSize, encode) {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, _tmp, err;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $c8615161abeda9f1$export$71511d61b312f219)(iterable);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        (0, $85d928f5abad2213$export$71511d61b312f219)(_iterator.next())
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    chunk = _value;
                    if (!ArrayBuffer.isView(chunk)) return [
                        3,
                        4
                    ];
                    _tmp = chunk;
                    return [
                        3,
                        6
                    ];
                case 4:
                    return [
                        4,
                        (0, $85d928f5abad2213$export$71511d61b312f219)(encode(String(chunk)))
                    ];
                case 5:
                    _tmp = _state.sent();
                    _state.label = 6;
                case 6:
                    return [
                        5,
                        (0, $eha6O.__values)((0, $68cf7c021fefc6fc$export$71511d61b312f219).apply(void 0, [
                            (0, $c8615161abeda9f1$export$71511d61b312f219).apply(void 0, [
                                $9788b673e96bd682$export$71b051935044bd5d.apply(void 0, [
                                    _tmp,
                                    chunkSize
                                ])
                            ]),
                            (0, $85d928f5abad2213$export$71511d61b312f219)
                        ]))
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        _iterator.return()
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    return [
                        2
                    ];
            }
        });
    });
    return function readBytes(iterable, chunkSize, encode) {
        return _ref.apply(this, arguments);
    };
}();
var $9788b673e96bd682$export$b0119225647bd83 = function(stream, chunkSize, onProgress, onFinish, encode) {
    var iterator = $9788b673e96bd682$export$f9f241124ee3198e(stream, chunkSize, encode);
    var bytes = 0;
    var done;
    var _onFinish = function(e) {
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        pull: function(controller) {
            return (0, $kSuI9._)(function() {
                var _ref, done, value, len, loadedBytes, err;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                iterator.next()
                            ];
                        case 1:
                            _ref = _state.sent(), done = _ref.done, value = _ref.value;
                            if (done) {
                                _onFinish();
                                controller.close();
                                return [
                                    2
                                ];
                            }
                            len = value.byteLength;
                            if (onProgress) {
                                loadedBytes = bytes += len;
                                onProgress(loadedBytes);
                            }
                            controller.enqueue(new Uint8Array(value));
                            return [
                                3,
                                3
                            ];
                        case 2:
                            err = _state.sent();
                            _onFinish(err);
                            throw err;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        cancel: function(reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






var $664917e882f824aa$var$isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
var $664917e882f824aa$var$isReadableStreamSupported = $664917e882f824aa$var$isFetchSupported && typeof ReadableStream === "function";
// used only inside the fetch adapter
var $664917e882f824aa$var$encodeText = $664917e882f824aa$var$isFetchSupported && (typeof TextEncoder === "function" ? function(encoder) {
    return function(str) {
        return encoder.encode(str);
    };
}(new TextEncoder()) : function() {
    var _ref = (0, $kSuI9._)(function(str) {
        var _;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = Uint8Array.bind;
                    return [
                        4,
                        new Response(str).arrayBuffer()
                    ];
                case 1:
                    return [
                        2,
                        new (_.apply(Uint8Array, [
                            void 0,
                            _state.sent()
                        ]))
                    ];
            }
        });
    });
    return function(str) {
        return _ref.apply(this, arguments);
    };
}());
var $664917e882f824aa$var$test = function(fn) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    try {
        return !!fn.apply(void 0, (0, $c6Xmf._)(args));
    } catch (e) {
        return false;
    }
};
var $664917e882f824aa$var$supportsRequestStream = $664917e882f824aa$var$isReadableStreamSupported && $664917e882f824aa$var$test(function() {
    var duplexAccessed = false;
    var hasContentType = new Request((0, $6316f3d4cabce5cc$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: "POST",
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
});
var $664917e882f824aa$var$DEFAULT_CHUNK_SIZE = 65536;
var $664917e882f824aa$var$supportsResponseStream = $664917e882f824aa$var$isReadableStreamSupported && $664917e882f824aa$var$test(function() {
    return (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isReadableStream(new Response("").body);
});
var $664917e882f824aa$var$resolvers = {
    stream: $664917e882f824aa$var$supportsResponseStream && function(res) {
        return res.body;
    }
};
$664917e882f824aa$var$isFetchSupported && function(res) {
    [
        "text",
        "arrayBuffer",
        "blob",
        "formData",
        "stream"
    ].forEach(function(type) {
        !$664917e882f824aa$var$resolvers[type] && ($664917e882f824aa$var$resolvers[type] = (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isFunction(res[type]) ? function(res) {
            return res[type]();
        } : function(_, config) {
            throw new (0, $23f55eba377f5456$export$2e2bcd8739ae039)("Response type '".concat(type, "' is not supported"), (0, $23f55eba377f5456$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
}(new Response);
var $664917e882f824aa$var$getBodyLength = function() {
    var _ref = (0, $kSuI9._)(function(body) {
        var _request;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (body == null) return [
                        2,
                        0
                    ];
                    if ((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isBlob(body)) return [
                        2,
                        body.size
                    ];
                    if (!(0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isSpecCompliantForm(body)) return [
                        3,
                        2
                    ];
                    _request = new Request((0, $6316f3d4cabce5cc$export$2e2bcd8739ae039).origin, {
                        method: "POST",
                        body: body
                    });
                    return [
                        4,
                        _request.arrayBuffer()
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().byteLength
                    ];
                case 2:
                    if ((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isArrayBuffer(body)) return [
                        2,
                        body.byteLength
                    ];
                    if ((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + "";
                    if (!(0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isString(body)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        $664917e882f824aa$var$encodeText(body)
                    ];
                case 3:
                    return [
                        2,
                        _state.sent().byteLength
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getBodyLength(body) {
        return _ref.apply(this, arguments);
    };
}();
var $664917e882f824aa$var$resolveBodyLength = function() {
    var _ref = (0, $kSuI9._)(function(headers, body) {
        var length;
        return (0, $eha6O.__generator)(this, function(_state) {
            length = (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
            return [
                2,
                length == null ? $664917e882f824aa$var$getBodyLength(body) : length
            ];
        });
    });
    return function resolveBodyLength(headers, body) {
        return _ref.apply(this, arguments);
    };
}();
var $664917e882f824aa$export$2e2bcd8739ae039 = $664917e882f824aa$var$isFetchSupported && function() {
    var _ref = (0, $kSuI9._)(function(config) {
        var _resolveConfig, url, method, data, signal, cancelToken, timeout, onDownloadProgress, onUploadProgress, responseType, headers, _resolveConfig_withCredentials, withCredentials, fetchOptions, composedSignal, request, unsubscribe, requestContentLength, _tmp, _request, contentTypeHeader, _progressEventDecorator, onProgress, flush, isCredentialsSupported, response, isStreamResponse, options, responseContentLength, _ref, onProgress1, flush1, responseData, err;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _resolveConfig = (0, $b7ad20900308004e$export$2e2bcd8739ae039)(config), url = _resolveConfig.url, method = _resolveConfig.method, data = _resolveConfig.data, signal = _resolveConfig.signal, cancelToken = _resolveConfig.cancelToken, timeout = _resolveConfig.timeout, onDownloadProgress = _resolveConfig.onDownloadProgress, onUploadProgress = _resolveConfig.onUploadProgress, responseType = _resolveConfig.responseType, headers = _resolveConfig.headers, _resolveConfig_withCredentials = _resolveConfig.withCredentials, withCredentials = _resolveConfig_withCredentials === void 0 ? "same-origin" : _resolveConfig_withCredentials, fetchOptions = _resolveConfig.fetchOptions;
                    responseType = responseType ? (responseType + "").toLowerCase() : "text";
                    composedSignal = (0, $ab7fc8bfb59ffa15$export$2e2bcd8739ae039)([
                        signal,
                        cancelToken && cancelToken.toAbortSignal()
                    ], timeout);
                    unsubscribe = composedSignal && composedSignal.unsubscribe && function() {
                        composedSignal.unsubscribe();
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        ,
                        8
                    ]);
                    _tmp = onUploadProgress && $664917e882f824aa$var$supportsRequestStream && method !== "get" && method !== "head";
                    if (!_tmp) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        $664917e882f824aa$var$resolveBodyLength(headers, data)
                    ];
                case 2:
                    _tmp = (requestContentLength = _state.sent()) !== 0;
                    _state.label = 3;
                case 3:
                    if (_tmp) {
                        _request = new Request(url, {
                            method: "POST",
                            body: data,
                            duplex: "half"
                        });
                        ;
                        if ((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
                        if (_request.body) {
                            _progressEventDecorator = (0, $cv9Rk._)((0, $f325318ccb5e605c$export$d9fadd12586c18d6)(requestContentLength, (0, $f325318ccb5e605c$export$c1b28109d46c3592)((0, $f325318ccb5e605c$export$5d35863c355a22a9)(onUploadProgress))), 2), onProgress = _progressEventDecorator[0], flush = _progressEventDecorator[1];
                            data = (0, $9788b673e96bd682$export$b0119225647bd83)(_request.body, $664917e882f824aa$var$DEFAULT_CHUNK_SIZE, onProgress, flush, $664917e882f824aa$var$encodeText);
                        }
                    }
                    if (!(0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? "include" : "omit";
                    // Cloudflare Workers throws when credentials are defined
                    // see https://github.com/cloudflare/workerd/issues/902
                    isCredentialsSupported = "credentials" in Request.prototype;
                    request = new Request(url, (0, $cxjpp._)((0, $do9pw._)({}, fetchOptions), {
                        signal: composedSignal,
                        method: method.toUpperCase(),
                        headers: headers.normalize().toJSON(),
                        body: data,
                        duplex: "half",
                        credentials: isCredentialsSupported ? withCredentials : undefined
                    }));
                    return [
                        4,
                        fetch(request)
                    ];
                case 4:
                    response = _state.sent();
                    isStreamResponse = $664917e882f824aa$var$supportsResponseStream && (responseType === "stream" || responseType === "response");
                    if ($664917e882f824aa$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                        options = {};
                        [
                            "status",
                            "statusText",
                            "headers"
                        ].forEach(function(prop) {
                            options[prop] = response[prop];
                        });
                        responseContentLength = (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get("content-length"));
                        _ref = (0, $cv9Rk._)(onDownloadProgress && (0, $f325318ccb5e605c$export$d9fadd12586c18d6)(responseContentLength, (0, $f325318ccb5e605c$export$c1b28109d46c3592)((0, $f325318ccb5e605c$export$5d35863c355a22a9)(onDownloadProgress), true)) || [], 2), onProgress1 = _ref[0], flush1 = _ref[1];
                        response = new Response((0, $9788b673e96bd682$export$b0119225647bd83)(response.body, $664917e882f824aa$var$DEFAULT_CHUNK_SIZE, onProgress1, function() {
                            flush1 && flush1();
                            unsubscribe && unsubscribe();
                        }, $664917e882f824aa$var$encodeText), options);
                    }
                    responseType = responseType || "text";
                    return [
                        4,
                        $664917e882f824aa$var$resolvers[(0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).findKey($664917e882f824aa$var$resolvers, responseType) || "text"](response, config)
                    ];
                case 5:
                    responseData = _state.sent();
                    !isStreamResponse && unsubscribe && unsubscribe();
                    return [
                        4,
                        new Promise(function(resolve, reject) {
                            (0, $c52485f5ecc194bf$export$2e2bcd8739ae039)(resolve, reject, {
                                data: responseData,
                                headers: (0, $a07841e7e23ec317$export$2e2bcd8739ae039).from(response.headers),
                                status: response.status,
                                statusText: response.statusText,
                                config: config,
                                request: request
                            });
                        })
                    ];
                case 6:
                    return [
                        2,
                        _state.sent()
                    ];
                case 7:
                    err = _state.sent();
                    unsubscribe && unsubscribe();
                    if (err && err.name === "TypeError" && /fetch/i.test(err.message)) throw Object.assign(new (0, $23f55eba377f5456$export$2e2bcd8739ae039)("Network Error", (0, $23f55eba377f5456$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
                        cause: err.cause || err
                    });
                    throw (0, $23f55eba377f5456$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return function(config) {
        return _ref.apply(this, arguments);
    };
}();



var $7a979858a81d7907$var$knownAdapters = {
    http: (0, $4d25f865c46a0982$export$2e2bcd8739ae039),
    xhr: (0, $84e90eb6e38b873a$export$2e2bcd8739ae039),
    fetch: (0, $664917e882f824aa$export$2e2bcd8739ae039)
};
(0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).forEach($7a979858a81d7907$var$knownAdapters, function(fn, value) {
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
var $7a979858a81d7907$var$renderReason = function(reason) {
    return "- ".concat(reason);
};
var $7a979858a81d7907$var$isResolvedHandle = function(adapter) {
    return (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
};
var $7a979858a81d7907$export$2e2bcd8739ae039 = {
    getAdapter: function(adapters) {
        adapters = (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        var length = adapters.length;
        var nameOrAdapter;
        var adapter;
        var rejectedReasons = {};
        for(var i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            var id = void 0;
            adapter = nameOrAdapter;
            if (!$7a979858a81d7907$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $7a979858a81d7907$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $23f55eba377f5456$export$2e2bcd8739ae039)("Unknown adapter '".concat(id, "'"));
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            var reasons = Object.entries(rejectedReasons).map(function(param) {
                var _param = (0, $cv9Rk._)(param, 2), id = _param[0], state = _param[1];
                return "adapter ".concat(id, " ") + (state === false ? "is not supported by the environment" : "is not available in the build");
            });
            var s = length ? reasons.length > 1 ? "since :\n" + reasons.map($7a979858a81d7907$var$renderReason).join("\n") : " " + $7a979858a81d7907$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $23f55eba377f5456$export$2e2bcd8739ae039)("There is no suitable adapter to dispatch the request " + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $7a979858a81d7907$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $2a6aba29c8e2c703$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $362efa0bfd268d89$export$2e2bcd8739ae039)(null, config);
}
function $2a6aba29c8e2c703$export$2e2bcd8739ae039(config) {
    $2a6aba29c8e2c703$var$throwIfCancellationRequested(config);
    config.headers = (0, $a07841e7e23ec317$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $72c6a3e7f725c92e$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    var adapter = (0, $7a979858a81d7907$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $d5f67f5251d190d5$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $2a6aba29c8e2c703$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $72c6a3e7f725c92e$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $a07841e7e23ec317$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $bf3d392823176dec$export$2e2bcd8739ae039)(reason)) {
            $2a6aba29c8e2c703$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $72c6a3e7f725c92e$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $a07841e7e23ec317$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}





var $l0HdX = parcelRequire("l0HdX");
var $cd6d39256165d39e$export$a4ad2735b021c132 = "1.7.6";



"use strict";
var $e642d405cabe65bf$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $e642d405cabe65bf$var$validators[type] = function validator(thing) {
        return (typeof thing === "undefined" ? "undefined" : (0, $l0HdX._)(thing)) === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $e642d405cabe65bf$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $e642d405cabe65bf$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $cd6d39256165d39e$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new (0, $23f55eba377f5456$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $23f55eba377f5456$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$e642d405cabe65bf$var$deprecatedWarnings[opt]) {
            $e642d405cabe65bf$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $e642d405cabe65bf$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $23f55eba377f5456$export$2e2bcd8739ae039)("options must be an object", (0, $23f55eba377f5456$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $23f55eba377f5456$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $23f55eba377f5456$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $23f55eba377f5456$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $23f55eba377f5456$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $e642d405cabe65bf$export$2e2bcd8739ae039 = {
    assertOptions: $e642d405cabe65bf$var$assertOptions,
    validators: $e642d405cabe65bf$var$validators
};



"use strict";
var $050cde3b00cdbe3a$var$validators = (0, $e642d405cabe65bf$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ var $050cde3b00cdbe3a$var$Axios = /*#__PURE__*/ function() {
    function Axios(instanceConfig) {
        (0, $4GJKx._)(this, Axios);
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $588268bc2bc9eb74$export$2e2bcd8739ae039)(),
            response: new (0, $588268bc2bc9eb74$export$2e2bcd8739ae039)()
        };
    }
    (0, $1wc17._)(Axios, [
        {
            key: "request",
            value: /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ function request(configOrUrl, config) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var err, dummy, stack;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this._request(configOrUrl, config)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                err = _state.sent();
                                if (err instanceof Error) {
                                    ;
                                    Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                                    // slice off the Error: ... line
                                    stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                                    try {
                                        if (!err.stack) err.stack = stack;
                                        else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
                                    } catch (e) {
                                    // ignore the case where "stack" is an un-writable property
                                    }
                                }
                                throw err;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_request",
            value: function _request(configOrUrl, config) {
                /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
                if (typeof configOrUrl === "string") {
                    config = config || {};
                    config.url = configOrUrl;
                } else config = configOrUrl || {};
                config = (0, $8c2f0de1517b3b7f$export$2e2bcd8739ae039)(this.defaults, config);
                var transitional = config.transitional, paramsSerializer = config.paramsSerializer, headers = config.headers;
                if (transitional !== undefined) (0, $e642d405cabe65bf$export$2e2bcd8739ae039).assertOptions(transitional, {
                    silentJSONParsing: $050cde3b00cdbe3a$var$validators.transitional($050cde3b00cdbe3a$var$validators.boolean),
                    forcedJSONParsing: $050cde3b00cdbe3a$var$validators.transitional($050cde3b00cdbe3a$var$validators.boolean),
                    clarifyTimeoutError: $050cde3b00cdbe3a$var$validators.transitional($050cde3b00cdbe3a$var$validators.boolean)
                }, false);
                if (paramsSerializer != null) {
                    if ((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                        serialize: paramsSerializer
                    };
                    else (0, $e642d405cabe65bf$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                        encode: $050cde3b00cdbe3a$var$validators.function,
                        serialize: $050cde3b00cdbe3a$var$validators.function
                    }, true);
                }
                // Set config.method
                config.method = (config.method || this.defaults.method || "get").toLowerCase();
                // Flatten headers
                var contextHeaders = headers && (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
                headers && (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).forEach([
                    "delete",
                    "get",
                    "head",
                    "post",
                    "put",
                    "patch",
                    "common"
                ], function(method) {
                    delete headers[method];
                });
                config.headers = (0, $a07841e7e23ec317$export$2e2bcd8739ae039).concat(contextHeaders, headers);
                // filter out skipped interceptors
                var requestInterceptorChain = [];
                var synchronousRequestInterceptors = true;
                this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
                    if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
                    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
                    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
                });
                var responseInterceptorChain = [];
                this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
                    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
                });
                var promise;
                var i = 0;
                var len;
                if (!synchronousRequestInterceptors) {
                    var chain = [
                        (0, $2a6aba29c8e2c703$export$2e2bcd8739ae039).bind(this),
                        undefined
                    ];
                    chain.unshift.apply(chain, requestInterceptorChain);
                    chain.push.apply(chain, responseInterceptorChain);
                    len = chain.length;
                    promise = Promise.resolve(config);
                    while(i < len)promise = promise.then(chain[i++], chain[i++]);
                    return promise;
                }
                len = requestInterceptorChain.length;
                var newConfig = config;
                i = 0;
                while(i < len){
                    var onFulfilled = requestInterceptorChain[i++];
                    var onRejected = requestInterceptorChain[i++];
                    try {
                        newConfig = onFulfilled(newConfig);
                    } catch (error) {
                        onRejected.call(this, error);
                        break;
                    }
                }
                try {
                    promise = (0, $2a6aba29c8e2c703$export$2e2bcd8739ae039).call(this, newConfig);
                } catch (error) {
                    return Promise.reject(error);
                }
                i = 0;
                len = responseInterceptorChain.length;
                while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
                return promise;
            }
        },
        {
            key: "getUri",
            value: function getUri(config) {
                config = (0, $8c2f0de1517b3b7f$export$2e2bcd8739ae039)(this.defaults, config);
                var fullPath = (0, $151097c3bcaa8131$export$2e2bcd8739ae039)(config.baseURL, config.url);
                return (0, $139d54524bb33fbe$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
            }
        }
    ]);
    return Axios;
}();
// Provide aliases for supported request methods
(0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $050cde3b00cdbe3a$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $8c2f0de1517b3b7f$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $8c2f0de1517b3b7f$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $050cde3b00cdbe3a$var$Axios.prototype[method] = generateHTTPMethod();
    $050cde3b00cdbe3a$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $050cde3b00cdbe3a$export$2e2bcd8739ae039 = $050cde3b00cdbe3a$var$Axios;







var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ var $f3e8c6a15ab6edfb$var$CancelToken = /*#__PURE__*/ function() {
    function CancelToken(executor) {
        (0, $4GJKx._)(this, CancelToken);
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        var resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        var token = this;
        // eslint-disable-next-line func-names
        this.promise.then(function(cancel) {
            if (!token._listeners) return;
            var i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = function(onfulfilled) {
            var _resolve;
            // eslint-disable-next-line func-names
            var promise = new Promise(function(resolve) {
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $362efa0bfd268d89$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    (0, $1wc17._)(CancelToken, [
        {
            /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ key: "throwIfRequested",
            value: function throwIfRequested() {
                if (this.reason) throw this.reason;
            }
        },
        {
            /**
   * Subscribe to the cancel signal
   */ key: "subscribe",
            value: function subscribe(listener) {
                if (this.reason) {
                    listener(this.reason);
                    return;
                }
                if (this._listeners) this._listeners.push(listener);
                else this._listeners = [
                    listener
                ];
            }
        },
        {
            /**
   * Unsubscribe from the cancel signal
   */ key: "unsubscribe",
            value: function unsubscribe(listener) {
                if (!this._listeners) return;
                var index = this._listeners.indexOf(listener);
                if (index !== -1) this._listeners.splice(index, 1);
            }
        },
        {
            key: "toAbortSignal",
            value: function toAbortSignal() {
                var _this = this;
                var controller = new AbortController();
                var abort = function(err) {
                    controller.abort(err);
                };
                this.subscribe(abort);
                controller.signal.unsubscribe = function() {
                    return _this.unsubscribe(abort);
                };
                return controller.signal;
            }
        }
    ], [
        {
            key: "source",
            value: /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ function source() {
                var cancel;
                var token = new CancelToken(function executor(c) {
                    cancel = c;
                });
                return {
                    token: token,
                    cancel: cancel
                };
            }
        }
    ]);
    return CancelToken;
}();
var $f3e8c6a15ab6edfb$export$2e2bcd8739ae039 = $f3e8c6a15ab6edfb$var$CancelToken;






"use strict";
function $b997afe1d1a4f540$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $62b73003bb2cd727$export$2e2bcd8739ae039(payload) {
    return (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}





var $cv9Rk = parcelRequire("cv9Rk");
var $e84c229f09c879c4$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($e84c229f09c879c4$var$HttpStatusCode).forEach(function(param) {
    var _param = (0, $cv9Rk._)(param, 2), key = _param[0], value = _param[1];
    $e84c229f09c879c4$var$HttpStatusCode[value] = key;
});
var $e84c229f09c879c4$export$2e2bcd8739ae039 = $e84c229f09c879c4$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $3e1a051896abba78$var$createInstance(defaultConfig) {
    var context = new (0, $050cde3b00cdbe3a$export$2e2bcd8739ae039)(defaultConfig);
    var instance = (0, $67c4890188190b79$export$2e2bcd8739ae039)((0, $050cde3b00cdbe3a$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).extend(instance, (0, $050cde3b00cdbe3a$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $3e1a051896abba78$var$createInstance((0, $8c2f0de1517b3b7f$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $3e1a051896abba78$var$axios = $3e1a051896abba78$var$createInstance((0, $d5f67f5251d190d5$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$3e1a051896abba78$var$axios.Axios = (0, $050cde3b00cdbe3a$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$3e1a051896abba78$var$axios.CanceledError = (0, $362efa0bfd268d89$export$2e2bcd8739ae039);
$3e1a051896abba78$var$axios.CancelToken = (0, $f3e8c6a15ab6edfb$export$2e2bcd8739ae039);
$3e1a051896abba78$var$axios.isCancel = (0, $bf3d392823176dec$export$2e2bcd8739ae039);
$3e1a051896abba78$var$axios.VERSION = (0, $cd6d39256165d39e$export$a4ad2735b021c132);
$3e1a051896abba78$var$axios.toFormData = (0, $8f2473769c2fa420$export$2e2bcd8739ae039);
// Expose AxiosError class
$3e1a051896abba78$var$axios.AxiosError = (0, $23f55eba377f5456$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$3e1a051896abba78$var$axios.Cancel = $3e1a051896abba78$var$axios.CanceledError;
// Expose all/spread
$3e1a051896abba78$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$3e1a051896abba78$var$axios.spread = (0, $b997afe1d1a4f540$export$2e2bcd8739ae039);
// Expose isAxiosError
$3e1a051896abba78$var$axios.isAxiosError = (0, $62b73003bb2cd727$export$2e2bcd8739ae039);
// Expose mergeConfig
$3e1a051896abba78$var$axios.mergeConfig = (0, $8c2f0de1517b3b7f$export$2e2bcd8739ae039);
$3e1a051896abba78$var$axios.AxiosHeaders = (0, $a07841e7e23ec317$export$2e2bcd8739ae039);
$3e1a051896abba78$var$axios.formToJSON = function(thing) {
    return (0, $1797e45e79d81ad9$export$2e2bcd8739ae039)((0, $8978bc38b4fd9d45$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
};
$3e1a051896abba78$var$axios.getAdapter = (0, $7a979858a81d7907$export$2e2bcd8739ae039).getAdapter;
$3e1a051896abba78$var$axios.HttpStatusCode = (0, $e84c229f09c879c4$export$2e2bcd8739ae039);
$3e1a051896abba78$var$axios.default = $3e1a051896abba78$var$axios;
var // this module should only have a default export
$3e1a051896abba78$export$2e2bcd8739ae039 = $3e1a051896abba78$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
var $e7c734877012dc3c$export$1c00760e9e5a4e95 = (0, $3e1a051896abba78$export$2e2bcd8739ae039).Axios, $e7c734877012dc3c$export$c1fbed17c2f6a328 = (0, $3e1a051896abba78$export$2e2bcd8739ae039).AxiosError, $e7c734877012dc3c$export$1ab0c6b20d94fa14 = (0, $3e1a051896abba78$export$2e2bcd8739ae039).CanceledError, $e7c734877012dc3c$export$3b22524397b493c6 = (0, $3e1a051896abba78$export$2e2bcd8739ae039).isCancel, $e7c734877012dc3c$export$fd08e3cb425f0d61 = (0, $3e1a051896abba78$export$2e2bcd8739ae039).CancelToken, $e7c734877012dc3c$export$a4ad2735b021c132 = (0, $3e1a051896abba78$export$2e2bcd8739ae039).VERSION, $e7c734877012dc3c$export$84bf76cd7afc7469 = (0, $3e1a051896abba78$export$2e2bcd8739ae039).all, $e7c734877012dc3c$export$848c9b7ead0df967 = (0, $3e1a051896abba78$export$2e2bcd8739ae039).Cancel, $e7c734877012dc3c$export$fbafdbe06a5b5a9a = (0, $3e1a051896abba78$export$2e2bcd8739ae039).isAxiosError, $e7c734877012dc3c$export$3ae0fd4797ed47c8 = (0, $3e1a051896abba78$export$2e2bcd8739ae039).spread, $e7c734877012dc3c$export$10ae0d317ea97f8b = (0, $3e1a051896abba78$export$2e2bcd8739ae039).toFormData, $e7c734877012dc3c$export$4e7d6ff0f3e6520 = (0, $3e1a051896abba78$export$2e2bcd8739ae039).AxiosHeaders, $e7c734877012dc3c$export$a972f69c851492b3 = (0, $3e1a051896abba78$export$2e2bcd8739ae039).HttpStatusCode, $e7c734877012dc3c$export$86d7c59254d6a2c9 = (0, $3e1a051896abba78$export$2e2bcd8739ae039).formToJSON, $e7c734877012dc3c$export$17ddc20a97d669e2 = (0, $3e1a051896abba78$export$2e2bcd8739ae039).getAdapter, $e7c734877012dc3c$export$7ec1ebcfa9d8bd6a = (0, $3e1a051896abba78$export$2e2bcd8739ae039).mergeConfig;



var $3sHb8 = parcelRequire("3sHb8");
var $651851c7f7a4dfb5$var$_prod;
var $651851c7f7a4dfb5$export$f9865a0a7f208c15 = ($651851c7f7a4dfb5$var$_prod = "prod") !== null && $651851c7f7a4dfb5$var$_prod !== void 0 ? $651851c7f7a4dfb5$var$_prod : "local";
var $651851c7f7a4dfb5$export$1345fde192f5a83e = $651851c7f7a4dfb5$export$f9865a0a7f208c15 === "prod";
var $651851c7f7a4dfb5$var$API_BASE_URLS = {
    local: "http://0.0.0.0:3000",
    // local: 'https://api.radom.network',
    dev: "https://api.dev.radom.network",
    test: "https://api.test.radom.network",
    prod: "https://api.radom.com"
};
var $651851c7f7a4dfb5$export$c3ee1e672e1e24e7 = $651851c7f7a4dfb5$var$API_BASE_URLS[$651851c7f7a4dfb5$export$f9865a0a7f208c15];
var $651851c7f7a4dfb5$export$8fe7e62e076ddbb5;
(function(RADOM_COLORS) {
    RADOM_COLORS["BLACK"] = "#282828";
    RADOM_COLORS["BLUE"] = "#070728";
    RADOM_COLORS["BLUE_ALT"] = "#0E259C";
    RADOM_COLORS["BLUE_MED"] = "#0F1D4B";
    RADOM_COLORS["PURPLE"] = "#9F76EA";
    RADOM_COLORS["ORANGE"] = "#FF6648";
    RADOM_COLORS["ORANGE_MED"] = "#FF8972";
    RADOM_COLORS["ORANGE_LIGHT"] = "#FFDBD4";
    RADOM_COLORS["ORANGE_LIGHTEST"] = "#FFF2EF";
    RADOM_COLORS["SUCCESS"] = "#36AF67";
    RADOM_COLORS["SUCCESS_LIGHT"] = "#d8f3e3";
    RADOM_COLORS["WARNING"] = "#F79009";
    RADOM_COLORS["WARNING_LIGHT"] = "#FEF0C7";
    RADOM_COLORS["INFO"] = "#5490EC";
    RADOM_COLORS["INFO_LIGHT"] = "#d1e1fa";
    RADOM_COLORS["ERROR"] = "#FF5252";
    RADOM_COLORS["ERROR_LIGHT"] = "#ffcccc";
    RADOM_COLORS["GRAY_DARKEST"] = "#636576";
    RADOM_COLORS["GRAY_DARKER"] = "#9B9EB1";
    RADOM_COLORS["GRAY_DARK"] = "#E2E4EF";
    RADOM_COLORS["GRAY_MED"] = "#EFF0F8";
    RADOM_COLORS["GRAY_LIGHTEST"] = "#F8F8FB";
    RADOM_COLORS["INPUT_PLACEHOLDER"] = "#9ba3af";
    RADOM_COLORS["NICE_GREEN"] = "#4bb69c";
    RADOM_COLORS["NEW_BLUE"] = "#3464E6";
    RADOM_COLORS["DARK_BLUE"] = "#07053f";
})($651851c7f7a4dfb5$export$8fe7e62e076ddbb5 || ($651851c7f7a4dfb5$export$8fe7e62e076ddbb5 = {}));
var $651851c7f7a4dfb5$export$a794f8af63328e6b;
(function(WINDOW_SIZE) {
    WINDOW_SIZE["MOBILE_SMALL"] = "320px";
    WINDOW_SIZE["MOBILE_MEDIUM"] = "375px";
    WINDOW_SIZE["MOBILE_LARGE"] = "425px";
    WINDOW_SIZE["TABLET"] = "768px";
    WINDOW_SIZE["LAPTOP"] = "1024px";
    WINDOW_SIZE["LAPTOP_LARGE"] = "1440px";
    WINDOW_SIZE["DESKTOP"] = "2560px";
})($651851c7f7a4dfb5$export$a794f8af63328e6b || ($651851c7f7a4dfb5$export$a794f8af63328e6b = {}));
var $651851c7f7a4dfb5$var$_obj;
var $651851c7f7a4dfb5$var$SecondsToPaymentPeriod = ($651851c7f7a4dfb5$var$_obj = {
    1: "Second",
    60: "Minute"
}, (0, $3sHb8._)($651851c7f7a4dfb5$var$_obj, 3600, "Hour"), (0, $3sHb8._)($651851c7f7a4dfb5$var$_obj, 86400, "Day"), (0, $3sHb8._)($651851c7f7a4dfb5$var$_obj, 604800, "Week"), (0, $3sHb8._)($651851c7f7a4dfb5$var$_obj, 2592000, "Month"), (0, $3sHb8._)($651851c7f7a4dfb5$var$_obj, 7776000, "Quarter"), (0, $3sHb8._)($651851c7f7a4dfb5$var$_obj, 31536000, "Year"), $651851c7f7a4dfb5$var$_obj);
var $651851c7f7a4dfb5$export$d82eb24974fa9fd = function(numSeconds) {
    if ($651851c7f7a4dfb5$var$SecondsToPaymentPeriod[numSeconds]) return $651851c7f7a4dfb5$var$SecondsToPaymentPeriod[numSeconds];
    return "".concat(numSeconds, " seconds");
};
var $651851c7f7a4dfb5$var$RADOM_CONTRACT_ADDRESSES = {
    31337: "0x749a0F73869eb0b0389F37B2Cee2b8DE5B358baB",
    5: "0x9D4B6432c290D4c393Bbe8fa30b72e240c008F17",
    80001: "0x987296974b23c050d6Eb2BE0CB2A60a1e9CeBa4e",
    4002: "0x819b60B377f99f1c1e8d40B53538b5Dbe1B4a37B",
    11155111: "0x8BBAaaE8225455ce62FCA83FF761fF4895bdD27B",
    1313161555: "0xc17C78B13f9594D974AF55921751B0919E4f377D",
    43113: "0xCc8401Fbca27934D4bFC762FEbb667ACdb976F88",
    534353: "0x3a909d378A6504287C03E0B19FdfB12f84c229e7",
    137: "0x63d76ee7B8b31F8D8CD1D96953C21Adb6fc5E028",
    56: "0x63d76ee7B8b31F8D8CD1D96953C21Adb6fc5E028",
    1: "0x63d76ee7B8b31F8D8CD1D96953C21Adb6fc5E028",
    1313161554: "0x63d76ee7B8b31F8D8CD1D96953C21Adb6fc5E028",
    250: "0x63d76ee7B8b31F8D8CD1D96953C21Adb6fc5E028",
    43114: "0x63d76ee7B8b31F8D8CD1D96953C21Adb6fc5E028",
    66: "0x63d76ee7B8b31F8D8CD1D96953C21Adb6fc5E028"
};
var $651851c7f7a4dfb5$export$ce84370551d92e53 = function(chainId) {
    if ($651851c7f7a4dfb5$var$RADOM_CONTRACT_ADDRESSES[chainId]) return $651851c7f7a4dfb5$var$RADOM_CONTRACT_ADDRESSES[chainId];
    return $651851c7f7a4dfb5$var$RADOM_CONTRACT_ADDRESSES[31337];
};
var $651851c7f7a4dfb5$export$cb8c5ae35c7906d6 = {
    RadomDevNet: "http://localhost:9545",
    GoerliTestnet: "https://goerli.etherscan.io",
    PolygonTestnet: "https://mumbai.polygonscan.com",
    FantomTestnet: "https://testnet.ftmscan.com",
    SepoliaTestnet: "https://sepolia.etherscan.io",
    BitcoinTestnet: "https://mempool.space/testnet",
    Bitcoin: "https://mempool.space",
    AuroraTestnet: "https://explorer.testnet.aurora.dev",
    Aurora: "https://explorer.aurora.dev",
    Arbitrum: "https://arbiscan.io",
    Ethereum: "https://etherscan.io",
    Fantom: "https://ftmscan.com",
    AvalancheTestnet: "https://testnet.snowtrace.io",
    Avalanche: "https://snowtrace.io",
    ScrollTestnet: "https://blockscout.scroll.io",
    Polygon: "https://polygonscan.com",
    BNB: "https://bscscan.com",
    BNBTestnet: "https://testnet.bscscan.com",
    PolkadotTestnet: "https://westend.subscan.io",
    Polkadot: "https://polkadot.subscan.io",
    TronTestnet: "https://nile.tronscan.org/#",
    Tron: "https://tronscan.org/#"
};
var $651851c7f7a4dfb5$export$4d78c43b7fa734a7 = [
    "United Kingdom",
    "United States",
    "Canada",
    "Australia",
    "New Zealand",
    "South Africa",
    "Anguilla",
    "Bermuda",
    "British Virgin Islands",
    "Cayman Islands",
    "Falkland Islands",
    "Gibraltar",
    "Montserrat",
    "Pitcairn Islands",
    "Saint Helena",
    "South Georgia and the South Sandwich Islands",
    "Turks and Caicos Islands",
    "Albania",
    "Andorra",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belgium",
    "Belize",
    "Bhutan",
    "Bolivia",
    "Bosnia and Herzegovina",
    "Botswana",
    "Brazil",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cabo Verde",
    "Cambodia",
    "Cameroon",
    "Chile",
    "Colombia",
    "Comoros",
    "Costa Rica",
    "Croatia",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "East Timor (Timor-Leste)",
    "Ecuador",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini",
    "Faroe Islands",
    "Fiji",
    "Finland",
    "France",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Greece",
    "Greenland",
    "Grenada",
    "Guatemala",
    "Guernsey",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Honduras",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Ireland",
    "Isle of Man",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jersey",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Kosovo",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Malta",
    "Marshall Islands",
    "Mauritania",
    "Mauritius",
    "Mexico",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Morocco",
    "Mozambique",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "North Macedonia",
    "Norway",
    "Oman",
    "Palau",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Qatar",
    "Romania",
    "Rwanda",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Spain",
    "Sri Lanka",
    "Suriname",
    "Sweden",
    "Switzerland",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Togo",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Vatican City",
    "Vietnam",
    "Zambia",
    "Zimbabwe"
];


var $49995c6694fcc6fd$export$8d291ecd86a6c444;
(function(InputFieldDataType) {
    InputFieldDataType["String"] = "String";
    InputFieldDataType["Number"] = "Number";
    InputFieldDataType["Email"] = "Email";
    InputFieldDataType["Address"] = "Address";
})($49995c6694fcc6fd$export$8d291ecd86a6c444 || ($49995c6694fcc6fd$export$8d291ecd86a6c444 = {}));
var $49995c6694fcc6fd$var$Radom = function Radom() {
    "use strict";
    (0, $4GJKx._)(this, Radom);
    this.getPaymentLink = function() {
        var _ref = (0, $kSuI9._)(function(id) {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, $3e1a051896abba78$export$2e2bcd8739ae039).get("".concat((0, $651851c7f7a4dfb5$export$c3ee1e672e1e24e7), "/payment_link/").concat(id)).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }();
    this.getDonationLink = function() {
        var _ref = (0, $kSuI9._)(function(id) {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, $3e1a051896abba78$export$2e2bcd8739ae039).get("".concat((0, $651851c7f7a4dfb5$export$c3ee1e672e1e24e7), "/donation_link/").concat(id)).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }();
    this.getInvoice = function() {
        var _ref = (0, $kSuI9._)(function(id) {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, $3e1a051896abba78$export$2e2bcd8739ae039).get("".concat((0, $651851c7f7a4dfb5$export$c3ee1e672e1e24e7), "/invoice/").concat(id)).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }();
    this.redeemDiscountCode = function() {
        var _ref = (0, $kSuI9._)(function(req) {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, $3e1a051896abba78$export$2e2bcd8739ae039).post("".concat((0, $651851c7f7a4dfb5$export$c3ee1e672e1e24e7), "/discount_code/verify"), req).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(req) {
            return _ref.apply(this, arguments);
        };
    }();
    this.getPriceQuotes = function() {
        var _ref = (0, $kSuI9._)(function(from, to) {
            var fromCurrencies, toCurrencies;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        fromCurrencies = from.map(function(f, i) {
                            return "from[".concat(i, "]=").concat(f);
                        }).join("&");
                        toCurrencies = to.map(function(f, i) {
                            return "to[".concat(i, "]=").concat(f);
                        }).join("&");
                        return [
                            4,
                            (0, $3e1a051896abba78$export$2e2bcd8739ae039).get("".concat((0, $651851c7f7a4dfb5$export$c3ee1e672e1e24e7), "/price_quotes?").concat(fromCurrencies, "&").concat(toCurrencies)).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(from, to) {
            return _ref.apply(this, arguments);
        };
    }();
    this.getCheckoutSession = function() {
        var _ref = (0, $kSuI9._)(function(id) {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, $3e1a051896abba78$export$2e2bcd8739ae039).get("".concat((0, $651851c7f7a4dfb5$export$c3ee1e672e1e24e7), "/checkout_session/").concat(id)).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }();
    this.getSellerProfile = function() {
        var _ref = (0, $kSuI9._)(function(address) {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, $3e1a051896abba78$export$2e2bcd8739ae039).get("".concat((0, $651851c7f7a4dfb5$export$c3ee1e672e1e24e7), "/sellers/").concat(address)).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(address) {
            return _ref.apply(this, arguments);
        };
    }();
    this.createPaymentLinkOrder = function() {
        var _ref = (0, $kSuI9._)(function(data) {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, $3e1a051896abba78$export$2e2bcd8739ae039).post("".concat((0, $651851c7f7a4dfb5$export$c3ee1e672e1e24e7), "/payment_link_order/pending"), data).then(function(res) {
                                return res.data;
                            }).catch(function(err) {
                                throw new Error(err.response.data.error);
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }();
    this.createDonationLinkOrder = function() {
        var _ref = (0, $kSuI9._)(function(data) {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, $3e1a051896abba78$export$2e2bcd8739ae039).post("".concat((0, $651851c7f7a4dfb5$export$c3ee1e672e1e24e7), "/donation_link_order/pending"), data).then(function(res) {
                                return res.data;
                            }).catch(function(err) {
                                throw new Error(err.response.data.error);
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }();
    this.createCheckoutSessionOrder = function() {
        var _ref = (0, $kSuI9._)(function(data) {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, $3e1a051896abba78$export$2e2bcd8739ae039).post("".concat((0, $651851c7f7a4dfb5$export$c3ee1e672e1e24e7), "/checkout/pending"), data).then(function(res) {
                                return res.data;
                            }).catch(function(err) {
                                throw new Error(err.response.data.error);
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }();
    this.createInvoicePayment = function() {
        var _ref = (0, $kSuI9._)(function(data) {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, $3e1a051896abba78$export$2e2bcd8739ae039).post("".concat((0, $651851c7f7a4dfb5$export$c3ee1e672e1e24e7), "/invoices/pending"), data).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }();
    this.getManagedPaymentStatus = function() {
        var _ref = (0, $kSuI9._)(function(paymentId) {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, $3e1a051896abba78$export$2e2bcd8739ae039).get("".concat((0, $651851c7f7a4dfb5$export$c3ee1e672e1e24e7), "/managed_payment_status/").concat(paymentId)).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(paymentId) {
            return _ref.apply(this, arguments);
        };
    }();
    this.completeTokenDelegatePayment = function() {
        var _ref = (0, $kSuI9._)(function(paymentId, signature) {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, $3e1a051896abba78$export$2e2bcd8739ae039).post("".concat((0, $651851c7f7a4dfb5$export$c3ee1e672e1e24e7), "/token_delegate_payment"), {
                                paymentId: paymentId,
                                signature: signature
                            }).then(function(res) {
                                return res.data;
                            }).catch(function(err) {
                                throw new Error(err.response.data.error);
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(paymentId, signature) {
            return _ref.apply(this, arguments);
        };
    }();
    this.getSubscription = function() {
        var _ref = (0, $kSuI9._)(function(id) {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, $3e1a051896abba78$export$2e2bcd8739ae039).get("".concat((0, $651851c7f7a4dfb5$export$c3ee1e672e1e24e7), "/subscription/").concat(id)).then(function(res) {
                                return res.data;
                            }).catch(function(err) {
                                throw new Error(err.response.data.error);
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }();
    this.estimateTokenTranferGas = function() {
        var _ref = (0, $kSuI9._)(function(network, token) {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, $3e1a051896abba78$export$2e2bcd8739ae039).get("".concat((0, $651851c7f7a4dfb5$export$c3ee1e672e1e24e7), "/estimate_token_transfer_gas?network=").concat(network, "&token=").concat(token)).then(function(res) {
                                return res.data;
                            }).catch(function(err) {
                                throw new Error(err.response.data.error);
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(network, token) {
            return _ref.apply(this, arguments);
        };
    }();
    this.createSubscriptionPayment = function() {
        var _ref = (0, $kSuI9._)(function(subscriptionId) {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, $3e1a051896abba78$export$2e2bcd8739ae039).post("".concat((0, $651851c7f7a4dfb5$export$c3ee1e672e1e24e7), "/subscription/").concat(subscriptionId, "/pay")).then(function(res) {
                                return res.data;
                            }).catch(function(err) {
                                throw new Error(err.response.data.error);
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(subscriptionId) {
            return _ref.apply(this, arguments);
        };
    }();
    this.cancelSubscription = function() {
        var _ref = (0, $kSuI9._)(function(id) {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, $3e1a051896abba78$export$2e2bcd8739ae039).post("".concat((0, $651851c7f7a4dfb5$export$c3ee1e672e1e24e7), "/subscription/").concat(id, "/cancel")).then(function(res) {
                                return res.data;
                            }).catch(function(err) {
                                throw new Error(err.response.data.error);
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }();
};
var $49995c6694fcc6fd$export$2e2bcd8739ae039 = new $49995c6694fcc6fd$var$Radom();



var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cv9Rk = parcelRequire("cv9Rk");

var $j06k0 = parcelRequire("j06k0");

var $c6Xmf = parcelRequire("c6Xmf");

var $eha6O = parcelRequire("eha6O");


var $1Mpn7 = parcelRequire("1Mpn7");


var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");

parcelRequire("1Mpn7");
function $3eae42650b1c19fb$var$RadomLogo(_param) {
    var logoProps = _param.logoProps, props = (0, $dRLPW._)(_param, [
        "logoProps"
    ]);
    return /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("svg", (0, $cxjpp._)((0, $do9pw._)({
        width: "120",
        height: "32",
        viewBox: "0 0 120 32",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "black"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("g", {
                clipPath: "url(#clip0_526_40)",
                children: [
                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("path", {
                        d: "M0.499695 2.35787C0.688149 2.35787 0.863681 2.35787 1.03921 2.35787C4.26879 2.35787 7.49836 2.35571 10.7279 2.35894C12.7277 2.3611 14.7102 2.49248 16.5808 3.29583C19.6715 4.62255 21.2555 7.28461 21.2189 10.9019C21.1888 13.9117 19.1782 16.184 16.5808 17.2146C15.8367 17.5096 15.0322 17.6496 14.2666 17.8962C14.0641 17.9619 13.9047 18.1601 13.726 18.2979C13.9295 18.4056 14.1233 18.5671 14.3398 18.6113C15.1432 18.775 15.9767 18.8277 16.7596 19.056C18.2317 19.4857 19.1169 20.5637 19.6219 21.9679C20.5373 24.5126 21.4354 27.0637 22.3378 29.6116C22.3787 29.7279 22.3981 29.8518 22.439 30.0187C22.2754 30.037 22.1429 30.0628 22.0104 30.0639C20.6826 30.0672 19.3548 30.0542 18.0271 30.0736C17.662 30.079 17.4983 29.9821 17.4046 29.5998C16.9179 27.6172 16.4031 25.6422 15.883 23.6672C15.2627 21.311 13.8024 20.0349 11.2804 19.8486C9.19122 19.6946 7.08915 19.7162 4.99353 19.6462C4.56385 19.6322 4.55201 19.8723 4.55201 20.1943C4.55847 23.244 4.55631 26.2948 4.55631 29.3446C4.55631 29.8256 4.31007 30.0661 3.81757 30.0661C2.72561 30.0661 1.63365 30.0661 0.499695 30.0661V2.35787H0.499695ZM4.55631 16.1958C4.79108 16.1958 4.98276 16.1958 5.17552 16.1958C6.82639 16.1958 8.47725 16.1743 10.1281 16.2023C11.387 16.2238 12.5823 15.9675 13.7443 15.5142C16.5754 14.4093 17.8687 11.478 16.724 8.68994C15.9993 6.92385 14.5401 6.06127 12.7342 5.95466C10.2121 5.80605 7.67928 5.85558 5.15183 5.79528C4.67693 5.78451 4.54232 5.92881 4.54555 6.40372C4.56493 9.54391 4.55524 12.6841 4.55524 15.8243C4.55524 15.9266 4.55524 16.03 4.55524 16.1958H4.55631Z"
                    }),
                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("path", {
                        d: "M119.786 30.0476H116.058V29.4618C116.058 25.5678 116.063 21.6738 116.052 17.7798C116.051 17.2079 116.009 16.6307 115.929 16.0643C115.659 14.183 114.493 13.1104 112.585 12.951C110.393 12.7679 108.503 14.1151 107.891 16.3927C107.67 17.2122 107.557 18.0845 107.548 18.9342C107.511 22.433 107.532 25.9318 107.532 29.4316C107.532 29.6233 107.532 29.8161 107.532 30.0369H103.777C103.777 29.7999 103.777 29.591 103.777 29.3821C103.777 25.6496 103.797 21.9171 103.762 18.1847C103.753 17.2596 103.651 16.3174 103.442 15.4171C102.89 13.0286 100.663 12.6118 99.0872 13.0985C97.1456 13.6994 96.1193 15.1737 95.6239 17.027C95.3827 17.9316 95.2912 18.8976 95.2793 19.8377C95.2384 23.0317 95.2643 26.2258 95.2643 29.4198C95.2643 29.6126 95.2643 29.8053 95.2643 30.0638C94.0538 30.0638 92.893 30.0702 91.7332 30.0519C91.6449 30.0509 91.5199 29.8947 91.4822 29.7859C91.437 29.6578 91.4672 29.5027 91.4672 29.3584C91.4672 23.1136 91.4672 16.8687 91.4672 10.6249C91.4672 10.1526 91.6994 9.91672 92.1639 9.91743C93.1676 9.91743 94.1712 9.91743 95.2223 9.91743C95.331 11.004 95.2449 12.0454 95.0112 13.077C94.9563 13.3215 94.8583 13.5605 94.8324 13.8071C94.8109 14.0117 94.868 14.225 94.8906 14.4339C95.0618 14.2853 95.2836 14.1668 95.3924 13.9816C95.6832 13.4895 95.891 12.9489 96.1915 12.4632C97.5602 10.2523 100.258 9.15608 102.766 9.80651C104.532 10.2642 105.669 11.4326 106.307 13.1147C106.39 13.3322 106.416 13.5767 106.53 13.7748C106.616 13.9256 106.793 14.1087 106.94 14.1162C107.086 14.1248 107.3 13.9676 107.387 13.8244C107.674 13.3505 107.882 12.8272 108.184 12.3641C109.533 10.2943 111.419 9.34453 113.905 9.67298C115.165 9.83882 116.329 10.177 117.358 11.0019C118.694 12.0734 119.32 13.4959 119.582 15.1059C119.735 16.0384 119.792 16.9958 119.798 17.9424C119.822 21.8181 119.809 25.6938 119.808 29.5706C119.808 29.7106 119.792 29.8506 119.782 30.0476H119.786Z"
                    }),
                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("path", {
                        d: "M65.5957 30.0652C64.4273 30.0652 63.3159 30.076 62.2057 30.049C62.0904 30.0458 61.888 29.8304 61.8815 29.7066C61.8223 28.5199 61.8632 27.3428 62.2713 26.2024C62.3413 26.0064 62.2563 25.7544 62.2433 25.5283C62.0646 25.6844 61.7943 25.805 61.72 26.001C60.9748 27.9545 59.6233 29.3114 57.6515 29.937C54.5533 30.9192 51.7179 30.3452 49.3089 28.1322C47.2596 26.2498 46.3905 23.7837 46.1687 21.0797C45.949 18.4036 46.4562 15.8697 47.881 13.5544C49.5824 10.7911 52.5719 9.35995 55.782 9.6464C57.6881 9.81655 59.3271 10.5478 60.5731 12.0069C61.0297 12.5411 61.3162 13.2206 61.6758 13.8366C61.748 13.9593 61.7695 14.1252 61.8664 14.2178C61.9774 14.3233 62.1464 14.3685 62.2897 14.4396C62.3263 14.2964 62.4243 14.137 62.3909 14.0121C61.3194 9.99747 62.0786 5.91069 61.9009 1.86269C61.9009 1.84761 61.916 1.83254 61.9472 1.77438H65.5968V30.0652H65.5957ZM49.8592 19.9673C49.9626 20.7286 50.0078 21.5029 50.1833 22.247C50.5193 23.675 51.1687 24.9801 52.3748 25.846C54.9625 27.7025 58.4473 27.0919 60.2651 24.7034C62.1863 22.1781 62.3963 19.3664 61.0695 16.5417C59.8193 13.8796 57.2401 12.428 54.073 13.2809C53.2804 13.4941 52.5848 13.8409 51.9946 14.4364C50.4709 15.9731 49.9141 17.8576 49.8581 19.9683L49.8592 19.9673Z"
                    }),
                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("path", {
                        d: "M28.6953 16.1755H25.0554C25.1749 15.0663 25.526 14.0713 26.0838 13.1473C26.9486 11.7161 28.2344 10.7911 29.7862 10.2645C32.4654 9.3556 35.1738 9.33191 37.8671 10.2203C40.4904 11.0861 41.9743 12.9427 42.39 15.6435C42.5397 16.6149 42.6258 17.6045 42.6334 18.5866C42.6614 22.2653 42.6452 25.9439 42.6441 29.6236C42.6441 29.7475 42.6301 29.8713 42.6215 30.0296H38.8847C38.8471 28.691 38.7954 27.3719 39.2067 26.0828C39.2832 25.8448 39.3521 25.6004 39.378 25.3538C39.3898 25.2407 39.2864 25.1147 39.2358 24.9952C39.113 25.0695 38.9364 25.1147 38.8761 25.2235C38.5908 25.7393 38.3851 26.3057 38.0642 26.7957C36.2453 29.5709 33.5929 30.609 30.3838 30.3085C28.2311 30.1071 26.3972 29.1993 25.2223 27.3126C23.1536 23.9883 24.825 19.8315 28.6468 18.6599C30.456 18.1053 32.3276 18.1193 34.1863 18.0008C35.1695 17.9384 36.1548 17.8641 37.1327 17.7434C39.253 17.4818 39.1378 15.9634 38.4152 14.6269C37.9392 13.7461 37.0616 13.3648 36.1301 13.1613C34.5148 12.8081 32.8897 12.779 31.283 13.2087C29.9315 13.5705 29.1077 14.4643 28.8062 15.8341C28.7836 15.9386 28.7405 16.0387 28.6953 16.1744V16.1755ZM38.8104 19.2694C38.1665 19.9715 37.4094 20.286 36.5888 20.4357C35.3913 20.6532 34.1809 20.7986 32.9867 21.029C31.8861 21.2422 30.7414 21.3898 29.7183 21.813C27.9285 22.5517 27.6238 24.9909 29.0786 26.2164C29.7732 26.8022 30.61 26.9573 31.4876 26.9756C36.2033 27.0789 38.9967 23.5252 38.8115 19.2694H38.8104Z"
                    }),
                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("path", {
                        d: "M88.2782 19.9631C88.3051 22.5035 87.688 24.8565 86.0953 26.8864C84.5597 28.8442 82.5201 29.9512 80.0723 30.2722C78.0456 30.5371 76.0674 30.3271 74.2011 29.4225C71.8848 28.2993 70.3427 26.4708 69.5102 24.0704C68.512 21.1908 68.527 18.2875 69.6922 15.4542C71.2516 11.6625 74.563 9.53676 78.6831 9.6046C81.8287 9.65629 84.438 10.8172 86.3268 13.392C87.5114 15.0073 88.0962 16.8542 88.2728 18.8357C88.3062 19.2083 88.2771 19.5873 88.2771 19.9631H88.2782ZM84.5446 19.7025C84.5554 18.6493 84.3174 17.3905 83.7057 16.221C82.6741 14.2481 81.0706 13.1379 78.8167 13.0646C76.5401 12.9903 74.7288 13.8766 73.6401 15.8979C72.1206 18.7172 72.1475 21.5925 73.8005 24.3482C75.8186 27.7135 80.4589 27.4798 82.4694 25.4413C83.9706 23.9196 84.5554 22.0534 84.5446 19.7025Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("clipPath", {
                    id: "clip0_526_40",
                    children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("rect", {
                        width: "119.315",
                        height: "28.6268",
                        transform: "translate(0.498489 1.77344)"
                    })
                })
            })
        ]
    }));
}
var $3eae42650b1c19fb$export$2e2bcd8739ae039 = $3eae42650b1c19fb$var$RadomLogo;


/**
 * @module color-parse
 */ var $fb3428360ff534a0$exports = {};
"use strict";
$fb3428360ff534a0$exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};


var $2d2a080f9d10c083$export$2e2bcd8739ae039 = $2d2a080f9d10c083$var$parse;
/**
 * Base hues
 * http://dev.w3.org/csswg/css-color/#typedef-named-hue
 */ //FIXME: use external hue detector
var $2d2a080f9d10c083$var$baseHues = {
    red: 0,
    orange: 60,
    yellow: 120,
    green: 180,
    blue: 240,
    purple: 300
};
/**
 * Parse color from the string passed
 *
 * @return {Object} A space indicator `space`, an array `values` and `alpha`
 */ function $2d2a080f9d10c083$var$parse(cstr) {
    var m, parts = [], alpha = 1, space;
    if (typeof cstr === "string") {
        cstr = cstr.toLowerCase();
        //keyword
        if ((0, (/*@__PURE__*/$parcel$interopDefault($fb3428360ff534a0$exports)))[cstr]) {
            parts = (0, (/*@__PURE__*/$parcel$interopDefault($fb3428360ff534a0$exports)))[cstr].slice();
            space = "rgb";
        } else if (cstr === "transparent") {
            alpha = 0;
            space = "rgb";
            parts = [
                0,
                0,
                0
            ];
        } else if (/^#[A-Fa-f0-9]+$/.test(cstr)) {
            var base = cstr.slice(1);
            var size = base.length;
            var isShort = size <= 4;
            alpha = 1;
            if (isShort) {
                parts = [
                    parseInt(base[0] + base[0], 16),
                    parseInt(base[1] + base[1], 16),
                    parseInt(base[2] + base[2], 16)
                ];
                if (size === 4) alpha = parseInt(base[3] + base[3], 16) / 255;
            } else {
                parts = [
                    parseInt(base[0] + base[1], 16),
                    parseInt(base[2] + base[3], 16),
                    parseInt(base[4] + base[5], 16)
                ];
                if (size === 8) alpha = parseInt(base[6] + base[7], 16) / 255;
            }
            if (!parts[0]) parts[0] = 0;
            if (!parts[1]) parts[1] = 0;
            if (!parts[2]) parts[2] = 0;
            space = "rgb";
        } else if (m = /^((?:rgb|hs[lvb]|hwb|cmyk?|xy[zy]|gray|lab|lchu?v?|[ly]uv|lms)a?)\s*\(([^\)]*)\)/.exec(cstr)) {
            var name = m[1];
            var isRGB = name === "rgb";
            var base = name.replace(/a$/, "");
            space = base;
            var size = base === "cmyk" ? 4 : base === "gray" ? 1 : 3;
            parts = m[2].trim().split(/\s*[,\/]\s*|\s+/).map(function(x, i) {
                //<percentage>
                if (/%$/.test(x)) {
                    //alpha
                    if (i === size) return parseFloat(x) / 100;
                    //rgb
                    if (base === "rgb") return parseFloat(x) * 255 / 100;
                    return parseFloat(x);
                } else if (base[i] === "h") {
                    //<deg>
                    if (/deg$/.test(x)) return parseFloat(x);
                    else if ($2d2a080f9d10c083$var$baseHues[x] !== undefined) return $2d2a080f9d10c083$var$baseHues[x];
                }
                return parseFloat(x);
            });
            if (name === base) parts.push(1);
            alpha = isRGB ? 1 : parts[size] === undefined ? 1 : parts[size];
            parts = parts.slice(0, size);
        } else if (cstr.length > 10 && /[0-9](?:\s|\/)/.test(cstr)) {
            parts = cstr.match(/([0-9]+)/g).map(function(value) {
                return parseFloat(value);
            });
            space = cstr.match(/([a-z])/ig).join("").toLowerCase();
        }
    } else if (!isNaN(cstr)) {
        space = "rgb";
        parts = [
            cstr >>> 16,
            (cstr & 0x00ff00) >>> 8,
            cstr & 0x0000ff
        ];
    } else if (Array.isArray(cstr) || cstr.length) {
        parts = [
            cstr[0],
            cstr[1],
            cstr[2]
        ];
        space = "rgb";
        alpha = cstr.length === 4 ? cstr[3] : 1;
    } else if (cstr instanceof Object) {
        if (cstr.r != null || cstr.red != null || cstr.R != null) {
            space = "rgb";
            parts = [
                cstr.r || cstr.red || cstr.R || 0,
                cstr.g || cstr.green || cstr.G || 0,
                cstr.b || cstr.blue || cstr.B || 0
            ];
        } else {
            space = "hsl";
            parts = [
                cstr.h || cstr.hue || cstr.H || 0,
                cstr.s || cstr.saturation || cstr.S || 0,
                cstr.l || cstr.lightness || cstr.L || cstr.b || cstr.brightness
            ];
        }
        alpha = cstr.a || cstr.alpha || cstr.opacity || 1;
        if (cstr.opacity != null) alpha /= 100;
    }
    return {
        space: space,
        values: parts,
        alpha: alpha
    };
}


var $1d6feab37e2cd829$exports = {};

$parcel$export($1d6feab37e2cd829$exports, "parse", function () { return $1d6feab37e2cd829$export$98e6a39c04603d36; }, function (v) { return $1d6feab37e2cd829$export$98e6a39c04603d36 = v; });
$parcel$export($1d6feab37e2cd829$exports, "stringify", function () { return $1d6feab37e2cd829$export$fac44ee5b035f737; }, function (v) { return $1d6feab37e2cd829$export$fac44ee5b035f737 = v; });
// Copyright (c) 2014 Rafael Caricio. All rights reserved.
// Use of this source code is governed by a BSD-style license that can be
// found in the LICENSE file.
var $1d6feab37e2cd829$export$98e6a39c04603d36;
var $1d6feab37e2cd829$export$fac44ee5b035f737;
var $1d6feab37e2cd829$var$GradientParser = $1d6feab37e2cd829$var$GradientParser || {};
$1d6feab37e2cd829$var$GradientParser.stringify = function() {
    var visitor = {
        "visit_linear-gradient": function(node) {
            return visitor.visit_gradient(node);
        },
        "visit_repeating-linear-gradient": function(node) {
            return visitor.visit_gradient(node);
        },
        "visit_radial-gradient": function(node) {
            return visitor.visit_gradient(node);
        },
        "visit_repeating-radial-gradient": function(node) {
            return visitor.visit_gradient(node);
        },
        "visit_gradient": function(node) {
            var orientation = visitor.visit(node.orientation);
            if (orientation) orientation += ", ";
            return node.type + "(" + orientation + visitor.visit(node.colorStops) + ")";
        },
        "visit_shape": function(node) {
            var result = node.value, at = visitor.visit(node.at), style = visitor.visit(node.style);
            if (style) result += " " + style;
            if (at) result += " at " + at;
            return result;
        },
        "visit_default-radial": function(node) {
            var result = "", at = visitor.visit(node.at);
            if (at) result += at;
            return result;
        },
        "visit_extent-keyword": function(node) {
            var result = node.value, at = visitor.visit(node.at);
            if (at) result += " at " + at;
            return result;
        },
        "visit_position-keyword": function(node) {
            return node.value;
        },
        "visit_position": function(node) {
            return visitor.visit(node.value.x) + " " + visitor.visit(node.value.y);
        },
        "visit_%": function(node) {
            return node.value + "%";
        },
        "visit_em": function(node) {
            return node.value + "em";
        },
        "visit_px": function(node) {
            return node.value + "px";
        },
        "visit_literal": function(node) {
            return visitor.visit_color(node.value, node);
        },
        "visit_hex": function(node) {
            return visitor.visit_color("#" + node.value, node);
        },
        "visit_rgb": function(node) {
            return visitor.visit_color("rgb(" + node.value.join(", ") + ")", node);
        },
        "visit_rgba": function(node) {
            return visitor.visit_color("rgba(" + node.value.join(", ") + ")", node);
        },
        "visit_color": function(resultColor, node) {
            var result = resultColor, length = visitor.visit(node.length);
            if (length) result += " " + length;
            return result;
        },
        "visit_angular": function(node) {
            return node.value + "deg";
        },
        "visit_directional": function(node) {
            return "to " + node.value;
        },
        "visit_array": function(elements) {
            var result = "", size = elements.length;
            elements.forEach(function(element, i) {
                result += visitor.visit(element);
                if (i < size - 1) result += ", ";
            });
            return result;
        },
        "visit": function(element) {
            if (!element) return "";
            var result = "";
            if (element instanceof Array) return visitor.visit_array(element, result);
            else if (element.type) {
                var nodeVisitor = visitor["visit_" + element.type];
                if (nodeVisitor) return nodeVisitor(element);
                else throw Error("Missing visitor visit_" + element.type);
            } else throw Error("Invalid node.");
        }
    };
    return function(root) {
        return visitor.visit(root);
    };
}();
// Copyright (c) 2014 Rafael Caricio. All rights reserved.
// Use of this source code is governed by a BSD-style license that can be
// found in the LICENSE file.
var $1d6feab37e2cd829$var$GradientParser = $1d6feab37e2cd829$var$GradientParser || {};
$1d6feab37e2cd829$var$GradientParser.parse = function() {
    var tokens = {
        linearGradient: /^(\-(webkit|o|ms|moz)\-)?(linear\-gradient)/i,
        repeatingLinearGradient: /^(\-(webkit|o|ms|moz)\-)?(repeating\-linear\-gradient)/i,
        radialGradient: /^(\-(webkit|o|ms|moz)\-)?(radial\-gradient)/i,
        repeatingRadialGradient: /^(\-(webkit|o|ms|moz)\-)?(repeating\-radial\-gradient)/i,
        sideOrCorner: /^to (left (top|bottom)|right (top|bottom)|left|right|top|bottom)/i,
        extentKeywords: /^(closest\-side|closest\-corner|farthest\-side|farthest\-corner|contain|cover)/,
        positionKeywords: /^(left|center|right|top|bottom)/i,
        pixelValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))px/,
        percentageValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))\%/,
        emValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))em/,
        angleValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))deg/,
        startCall: /^\(/,
        endCall: /^\)/,
        comma: /^,/,
        hexColor: /^\#([0-9a-fA-F]+)/,
        literalColor: /^([a-zA-Z]+)/,
        rgbColor: /^rgb/i,
        rgbaColor: /^rgba/i,
        number: /^(([0-9]*\.[0-9]+)|([0-9]+\.?))/
    };
    var input = "";
    function error(msg) {
        var err = new Error(input + ": " + msg);
        err.source = input;
        throw err;
    }
    function getAST() {
        var ast = matchListDefinitions();
        if (input.length > 0) error("Invalid input not EOF");
        return ast;
    }
    function matchListDefinitions() {
        return matchListing(matchDefinition);
    }
    function matchDefinition() {
        return matchGradient("linear-gradient", tokens.linearGradient, matchLinearOrientation) || matchGradient("repeating-linear-gradient", tokens.repeatingLinearGradient, matchLinearOrientation) || matchGradient("radial-gradient", tokens.radialGradient, matchListRadialOrientations) || matchGradient("repeating-radial-gradient", tokens.repeatingRadialGradient, matchListRadialOrientations);
    }
    function matchGradient(gradientType, pattern, orientationMatcher) {
        return matchCall(pattern, function(captures) {
            var orientation = orientationMatcher();
            if (orientation) {
                if (!scan(tokens.comma)) error("Missing comma before color stops");
            }
            return {
                type: gradientType,
                orientation: orientation,
                colorStops: matchListing(matchColorStop)
            };
        });
    }
    function matchCall(pattern, callback) {
        var captures = scan(pattern);
        if (captures) {
            if (!scan(tokens.startCall)) error("Missing (");
            var result = callback(captures);
            if (!scan(tokens.endCall)) error("Missing )");
            return result;
        }
    }
    function matchLinearOrientation() {
        return matchSideOrCorner() || matchAngle();
    }
    function matchSideOrCorner() {
        return match("directional", tokens.sideOrCorner, 1);
    }
    function matchAngle() {
        return match("angular", tokens.angleValue, 1);
    }
    function matchListRadialOrientations() {
        var radialOrientations, radialOrientation = matchRadialOrientation(), lookaheadCache;
        if (radialOrientation) {
            radialOrientations = [];
            radialOrientations.push(radialOrientation);
            lookaheadCache = input;
            if (scan(tokens.comma)) {
                radialOrientation = matchRadialOrientation();
                if (radialOrientation) radialOrientations.push(radialOrientation);
                else input = lookaheadCache;
            }
        }
        return radialOrientations;
    }
    function matchRadialOrientation() {
        var radialType = matchCircle() || matchEllipse();
        if (radialType) radialType.at = matchAtPosition();
        else {
            var extent = matchExtentKeyword();
            if (extent) {
                radialType = extent;
                var positionAt = matchAtPosition();
                if (positionAt) radialType.at = positionAt;
            } else {
                var defaultPosition = matchPositioning();
                if (defaultPosition) radialType = {
                    type: "default-radial",
                    at: defaultPosition
                };
            }
        }
        return radialType;
    }
    function matchCircle() {
        var circle = match("shape", /^(circle)/i, 0);
        if (circle) circle.style = matchLength() || matchExtentKeyword();
        return circle;
    }
    function matchEllipse() {
        var ellipse = match("shape", /^(ellipse)/i, 0);
        if (ellipse) ellipse.style = matchDistance() || matchExtentKeyword();
        return ellipse;
    }
    function matchExtentKeyword() {
        return match("extent-keyword", tokens.extentKeywords, 1);
    }
    function matchAtPosition() {
        if (match("position", /^at/, 0)) {
            var positioning = matchPositioning();
            if (!positioning) error("Missing positioning value");
            return positioning;
        }
    }
    function matchPositioning() {
        var location = matchCoordinates();
        if (location.x || location.y) return {
            type: "position",
            value: location
        };
    }
    function matchCoordinates() {
        return {
            x: matchDistance(),
            y: matchDistance()
        };
    }
    function matchListing(matcher) {
        var captures = matcher(), result = [];
        if (captures) {
            result.push(captures);
            while(scan(tokens.comma)){
                captures = matcher();
                if (captures) result.push(captures);
                else error("One extra comma");
            }
        }
        return result;
    }
    function matchColorStop() {
        var color = matchColor();
        if (!color) error("Expected color definition");
        color.length = matchDistance();
        return color;
    }
    function matchColor() {
        return matchHexColor() || matchRGBAColor() || matchRGBColor() || matchLiteralColor();
    }
    function matchLiteralColor() {
        return match("literal", tokens.literalColor, 0);
    }
    function matchHexColor() {
        return match("hex", tokens.hexColor, 1);
    }
    function matchRGBColor() {
        return matchCall(tokens.rgbColor, function() {
            return {
                type: "rgb",
                value: matchListing(matchNumber)
            };
        });
    }
    function matchRGBAColor() {
        return matchCall(tokens.rgbaColor, function() {
            return {
                type: "rgba",
                value: matchListing(matchNumber)
            };
        });
    }
    function matchNumber() {
        return scan(tokens.number)[1];
    }
    function matchDistance() {
        return match("%", tokens.percentageValue, 1) || matchPositionKeyword() || matchLength();
    }
    function matchPositionKeyword() {
        return match("position-keyword", tokens.positionKeywords, 1);
    }
    function matchLength() {
        return match("px", tokens.pixelValue, 1) || match("em", tokens.emValue, 1);
    }
    function match(type, pattern, captureIndex) {
        var captures = scan(pattern);
        if (captures) return {
            type: type,
            value: captures[captureIndex]
        };
    }
    function scan(regexp) {
        var captures, blankCaptures;
        blankCaptures = /^[\n\r\t\s]+/.exec(input);
        if (blankCaptures) consume(blankCaptures[0].length);
        captures = regexp.exec(input);
        if (captures) consume(captures[0].length);
        return captures;
    }
    function consume(size) {
        input = input.substr(size);
    }
    return function(code) {
        input = code.toString();
        return getAST();
    };
}();
$1d6feab37e2cd829$export$98e6a39c04603d36 = $1d6feab37e2cd829$var$GradientParser.parse;
$1d6feab37e2cd829$export$fac44ee5b035f737 = $1d6feab37e2cd829$var$GradientParser.stringify;


var $923ed4f38e3f62e1$export$193698062786be9a = function(address) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 4;
    if (!address) return "";
    return address.substring(0, decimals) + "..." + address.slice(address.length - decimals);
};
function $923ed4f38e3f62e1$export$8121a4101142837f(bgColor, lightColor, darkColor) {
    var color = (0, $2d2a080f9d10c083$export$2e2bcd8739ae039)(bgColor);
    try {
        var gradientColor = (0, (/*@__PURE__*/$parcel$interopDefault($1d6feab37e2cd829$exports))).parse(bgColor);
        color = (0, $2d2a080f9d10c083$export$2e2bcd8739ae039)(gradientColor[0].colorStops[0].value);
    } catch (e) {}
    var r = color.values[0];
    var g = color.values[1];
    var b = color.values[2];
    var uicolors = [
        r / 255,
        g / 255,
        b / 255
    ];
    var c = uicolors.map(function(col) {
        if (col <= 0.03928) return col / 12.92;
        return Math.pow((col + 0.055) / 1.055, 2.4);
    });
    var L = 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
    return L > 0.179 ? darkColor : lightColor;
}
function $923ed4f38e3f62e1$export$f5dd818bff069720(val, options) {
    return Intl.NumberFormat("en-US", options).format(val);
}
function $923ed4f38e3f62e1$export$1e21512880529eb2(address) {
    var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(address);
}



var $j06k0 = parcelRequire("j06k0");

parcelRequire("1Mpn7");
var $37a542d4961dbff1$exports = {};
"use strict";

$37a542d4961dbff1$exports = (parcelRequire("dqToa"));



var $1Mpn7 = parcelRequire("1Mpn7");
var $7bad41d4868ffbaf$exports = {};
//
$7bad41d4868ffbaf$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


function $fe350731a2c76af8$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, _$B = e.length, J = _$B - 1, y, f = "", p = "", F = "", G = "", C; l < _$B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, _$B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, "")), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < _$B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, "").trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ""));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(""), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ""));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + "{" + k + "}";
                                        break;
                                    case 107:
                                        f = f.replace(fa, "$1 $2");
                                        k = f + "{" + k + "}";
                                        k = 1 === w || 2 === w && L("@" + k, 3) ? "@-webkit-" + k + "@" + k : "@" + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ""));
                                }
                                else k = "";
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, "") : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(" ", ":")).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = "\0\0"), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += "\0");
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = "";
                                    break;
                                default:
                                    32 !== g && (y = " ");
                            }
                            break;
                        case 0:
                            y = "\\0";
                            break;
                        case 12:
                            y = "\\f";
                            break;
                        case 11:
                            y = "\\v";
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = "\f" + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += "\r");
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = "", b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(",") + "{" + p + "}";
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ":-moz-$1") + p;
                        break;
                    case 112:
                        p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? "" : d[0] + " "; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + " ", h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, "$1" + d.trim());
            case 58:
                return d.trim() + c.replace(F, "$1" + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf("\f")) return c.replace(F, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ";", m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(":", 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ";";
            return 1 === w || 2 === w && L(b, 1) ? "-webkit-" + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return "-webkit-" + a + a;
            case 978:
                return "-webkit-" + a + "-moz-" + a + a;
            case 1019:
            case 983:
                return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
                if (0 < a.indexOf("image-set(", 11)) return a.replace(ja, "$1-webkit-$2") + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
                    case 115:
                        return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
                    case 98:
                        return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
                }
                return "-webkit-" + a + "-ms-" + a + a;
            case 964:
                return "-webkit-" + a + "-ms-flex-" + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
                return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf("-") + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, "tb");
                        break;
                    case 232:
                        b = a.replace(G, "tb-rl");
                        break;
                    case 220:
                        b = a.replace(G, "lr");
                        break;
                    default:
                        return a;
                }
                return "-webkit-" + a + "-ms-" + b + a;
            case 1017:
                if (-1 === a.indexOf("sticky", 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, "-webkit-" + b) + ";" + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, "-webkit-" + (102 < m ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
                }
                return a + ";";
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
                    case 115:
                        return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
                    default:
                        return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P(d.replace("stretch", "fill-available"), c, e, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
                break;
            case 962:
                if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ":" : "{"), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, "$1"), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ("function" === typeof d) S[A++] = d;
                else if ("object" === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? "function" !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && "string" === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = "";
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = "";
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $fe350731a2c76af8$export$2e2bcd8739ae039 = $fe350731a2c76af8$var$stylis_min;


var $a661ec6db99b52aa$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $a661ec6db99b52aa$export$2e2bcd8739ae039 = $a661ec6db99b52aa$var$unitlessKeys;


function $1423aa965bc622c7$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


// eslint-disable-next-line no-undef
var $23a78f4023c8eae7$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $23a78f4023c8eae7$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $1423aa965bc622c7$export$2e2bcd8739ae039)(function(prop) {
    return $23a78f4023c8eae7$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});


var $03d46e509d407e42$exports = {};
"use strict";
var $54af28472747c1b7$exports = {};
"use strict";

$54af28472747c1b7$exports = (parcelRequire("hwp41"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $03d46e509d407e42$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $03d46e509d407e42$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $03d46e509d407e42$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $03d46e509d407e42$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $03d46e509d407e42$var$TYPE_STATICS = {};
$03d46e509d407e42$var$TYPE_STATICS[$54af28472747c1b7$exports.ForwardRef] = $03d46e509d407e42$var$FORWARD_REF_STATICS;
$03d46e509d407e42$var$TYPE_STATICS[$54af28472747c1b7$exports.Memo] = $03d46e509d407e42$var$MEMO_STATICS;
function $03d46e509d407e42$var$getStatics(component) {
    // React v16.11 and below
    if ($54af28472747c1b7$exports.isMemo(component)) return $03d46e509d407e42$var$MEMO_STATICS;
     // React v16.12 and above
    return $03d46e509d407e42$var$TYPE_STATICS[component["$$typeof"]] || $03d46e509d407e42$var$REACT_STATICS;
}
var $03d46e509d407e42$var$defineProperty = Object.defineProperty;
var $03d46e509d407e42$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $03d46e509d407e42$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $03d46e509d407e42$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $03d46e509d407e42$var$getPrototypeOf = Object.getPrototypeOf;
var $03d46e509d407e42$var$objectPrototype = Object.prototype;
function $03d46e509d407e42$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($03d46e509d407e42$var$objectPrototype) {
            var inheritedComponent = $03d46e509d407e42$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $03d46e509d407e42$var$objectPrototype) $03d46e509d407e42$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $03d46e509d407e42$var$getOwnPropertyNames(sourceComponent);
        if ($03d46e509d407e42$var$getOwnPropertySymbols) keys = keys.concat($03d46e509d407e42$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $03d46e509d407e42$var$getStatics(targetComponent);
        var sourceStatics = $03d46e509d407e42$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$03d46e509d407e42$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $03d46e509d407e42$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $03d46e509d407e42$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$03d46e509d407e42$exports = $03d46e509d407e42$var$hoistNonReactStatics;



var $3qWgZ = parcelRequire("3qWgZ");
function $f2ce4b3babf40f7e$var$y() {
    return ($f2ce4b3babf40f7e$var$y = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var _$r in n)Object.prototype.hasOwnProperty.call(n, _$r) && (e[_$r] = n[_$r]);
        }
        return e;
    }).apply(this, arguments);
}
var $f2ce4b3babf40f7e$var$v = function v(e, t) {
    for(var n = [
        e[0]
    ], _$r = 0, o = t.length; _$r < o; _$r += 1)n.push(t[_$r], e[_$r + 1]);
    return n;
}, $f2ce4b3babf40f7e$var$g = function g(t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, $37a542d4961dbff1$exports.typeOf)(t);
}, $f2ce4b3babf40f7e$var$S = Object.freeze([]), $f2ce4b3babf40f7e$var$w = Object.freeze({});
function $f2ce4b3babf40f7e$var$E(e) {
    return "function" == typeof e;
}
function $f2ce4b3babf40f7e$var$b(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $f2ce4b3babf40f7e$export$7ba318d8d2f06c76(e) {
    return e && "string" == typeof e.styledComponentId;
}
var $f2ce4b3babf40f7e$var$N = ("undefined" != typeof $3qWgZ && void 0 !== $3qWgZ.env && undefined, "data-styled"), $f2ce4b3babf40f7e$export$83d89fbfd8236492 = "5.3.11", $f2ce4b3babf40f7e$var$C = "undefined" != typeof window && "HTMLElement" in window, $f2ce4b3babf40f7e$var$I = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : "undefined" != typeof $3qWgZ && void 0 !== $3qWgZ.env && false), $f2ce4b3babf40f7e$var$P = {}, $f2ce4b3babf40f7e$var$O = {};
function $f2ce4b3babf40f7e$var$R() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, _$r = arguments.length; n < _$r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function $f2ce4b3babf40f7e$var$D(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), _$r = 1; _$r < t; _$r++)n[_$r - 1] = arguments[_$r];
    throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var $f2ce4b3babf40f7e$var$j = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, _$r = n.length, o = _$r; e >= o;)(o <<= 1) < 0 && $f2ce4b3babf40f7e$var$D(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = _$r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), _$r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < _$r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], _$r = this.indexOfGroup(e), o = _$r + n, s = _$r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), $f2ce4b3babf40f7e$var$T = new Map, $f2ce4b3babf40f7e$var$x = new Map, $f2ce4b3babf40f7e$var$k = 1, $f2ce4b3babf40f7e$var$V = function V(e) {
    if ($f2ce4b3babf40f7e$var$T.has(e)) return $f2ce4b3babf40f7e$var$T.get(e);
    for(; $f2ce4b3babf40f7e$var$x.has($f2ce4b3babf40f7e$var$k);)$f2ce4b3babf40f7e$var$k++;
    var t = $f2ce4b3babf40f7e$var$k++;
    return $f2ce4b3babf40f7e$var$T.set(e, t), $f2ce4b3babf40f7e$var$x.set(t, e), t;
}, $f2ce4b3babf40f7e$var$B = function B(e) {
    return $f2ce4b3babf40f7e$var$x.get(e);
}, $f2ce4b3babf40f7e$var$z = function z(e, t) {
    t >= $f2ce4b3babf40f7e$var$k && ($f2ce4b3babf40f7e$var$k = t + 1), $f2ce4b3babf40f7e$var$T.set(e, t), $f2ce4b3babf40f7e$var$x.set(t, e);
}, $f2ce4b3babf40f7e$var$M = "style[" + $f2ce4b3babf40f7e$var$N + '][data-styled-version="5.3.11"]', $f2ce4b3babf40f7e$var$G = new RegExp("^" + $f2ce4b3babf40f7e$var$N + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $f2ce4b3babf40f7e$var$L = function L(e, t, n) {
    for(var _$r, o = n.split(","), s = 0, i = o.length; s < i; s++)(_$r = o[s]) && e.registerName(t, _$r);
}, $f2ce4b3babf40f7e$var$F = function F(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), _$r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match($f2ce4b3babf40f7e$var$G);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && ($f2ce4b3babf40f7e$var$z(u, c), $f2ce4b3babf40f7e$var$L(e, u, a[3]), e.getTag().insertRules(c, _$r)), _$r.length = 0;
            } else _$r.push(i);
        }
    }
}, $f2ce4b3babf40f7e$var$Y = function Y() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}, $f2ce4b3babf40f7e$var$q = function q(e) {
    var t = document.head, n = e || t, _$r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var _$r = t[n];
            if (_$r && 1 === _$r.nodeType && _$r.hasAttribute($f2ce4b3babf40f7e$var$N)) return _$r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    _$r.setAttribute($f2ce4b3babf40f7e$var$N, "active"), _$r.setAttribute("data-styled-version", "5.3.11");
    var i = $f2ce4b3babf40f7e$var$Y();
    return i && _$r.setAttribute("nonce", i), n.insertBefore(_$r, s), _$r;
}, $f2ce4b3babf40f7e$var$H = function() {
    function e(e) {
        var t = this.element = $f2ce4b3babf40f7e$var$q(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, _$r = t.length; n < _$r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            $f2ce4b3babf40f7e$var$D(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $f2ce4b3babf40f7e$var$$ = function() {
    function e(e) {
        var t = this.element = $f2ce4b3babf40f7e$var$q(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), _$r = this.nodes[e];
            return this.element.insertBefore(n, _$r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $f2ce4b3babf40f7e$var$W = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $f2ce4b3babf40f7e$var$U = $f2ce4b3babf40f7e$var$C, $f2ce4b3babf40f7e$var$J = {
    isServer: !$f2ce4b3babf40f7e$var$C,
    useCSSOMInjection: !$f2ce4b3babf40f7e$var$I
}, $f2ce4b3babf40f7e$var$X = function() {
    function e(e, t, n) {
        void 0 === e && (e = $f2ce4b3babf40f7e$var$w), void 0 === t && (t = {}), this.options = $f2ce4b3babf40f7e$var$y({}, $f2ce4b3babf40f7e$var$J, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $f2ce4b3babf40f7e$var$C && $f2ce4b3babf40f7e$var$U && ($f2ce4b3babf40f7e$var$U = !1, function(e) {
            for(var _$t = document.querySelectorAll($f2ce4b3babf40f7e$var$M), _$n = 0, _$r = _$t.length; _$n < _$r; _$n++){
                var o = _$t[_$n];
                o && "active" !== o.getAttribute($f2ce4b3babf40f7e$var$N) && ($f2ce4b3babf40f7e$var$F(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return $f2ce4b3babf40f7e$var$V(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($f2ce4b3babf40f7e$var$y({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var _$e, t, n, _$r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, _$r = t.useCSSOMInjection, o = t.target, _$e = n ? new $f2ce4b3babf40f7e$var$W(o) : _$r ? new $f2ce4b3babf40f7e$var$H(o) : new $f2ce4b3babf40f7e$var$$(o), new $f2ce4b3babf40f7e$var$j(_$e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if ($f2ce4b3babf40f7e$var$V(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($f2ce4b3babf40f7e$var$V(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup($f2ce4b3babf40f7e$var$V(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, _$r = "", o = 0; o < n; o++){
                var s = $f2ce4b3babf40f7e$var$B(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = $f2ce4b3babf40f7e$var$N + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), _$r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return _$r;
        }(this);
    }, e;
}(), $f2ce4b3babf40f7e$var$Z = /(a)(d)/gi, $f2ce4b3babf40f7e$var$K = function K(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $f2ce4b3babf40f7e$var$Q(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $f2ce4b3babf40f7e$var$K(t % 52) + n;
    return ($f2ce4b3babf40f7e$var$K(t % 52) + n).replace($f2ce4b3babf40f7e$var$Z, "$1-$2");
}
var $f2ce4b3babf40f7e$var$ee = function ee(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $f2ce4b3babf40f7e$var$te = function te(e) {
    return $f2ce4b3babf40f7e$var$ee(5381, e);
};
function $f2ce4b3babf40f7e$var$ne(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($f2ce4b3babf40f7e$var$E(n) && !$f2ce4b3babf40f7e$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $f2ce4b3babf40f7e$var$re = $f2ce4b3babf40f7e$var$te("5.3.11"), $f2ce4b3babf40f7e$var$oe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $f2ce4b3babf40f7e$var$ne(e), this.componentId = t, this.baseHash = $f2ce4b3babf40f7e$var$ee($f2ce4b3babf40f7e$var$re, t), this.baseStyle = n, $f2ce4b3babf40f7e$var$X.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var _$r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(_$r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = $f2ce4b3babf40f7e$var$_e(this.rules, e, t, n).join(""), i = $f2ce4b3babf40f7e$var$Q($f2ce4b3babf40f7e$var$ee(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(_$r, i)) {
                    var a = n(s, "." + i, void 0, _$r);
                    t.insertRules(_$r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = $f2ce4b3babf40f7e$var$ee(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h;
                else if (h) {
                    var p = $f2ce4b3babf40f7e$var$_e(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = $f2ce4b3babf40f7e$var$ee(u, f + d), l += f;
                }
            }
            if (l) {
                var m = $f2ce4b3babf40f7e$var$Q(u >>> 0);
                if (!t.hasNameForId(_$r, m)) {
                    var y = n(l, "." + m, void 0, _$r);
                    t.insertRules(_$r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), $f2ce4b3babf40f7e$var$se = /^\s*\/\/.*$/gm, $f2ce4b3babf40f7e$var$ie = [
    ":",
    "[",
    ".",
    "#"
];
function $f2ce4b3babf40f7e$var$ae(e) {
    var t, n, _$r, o, s = void 0 === e ? $f2ce4b3babf40f7e$var$w : e, i = s.options, a = void 0 === i ? $f2ce4b3babf40f7e$var$w : i, c = s.plugins, u = void 0 === c ? $f2ce4b3babf40f7e$var$S : c, l = new (0, $fe350731a2c76af8$export$2e2bcd8739ae039)(a), d = [], p = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function f(e, r, s) {
        return 0 === r && -1 !== $f2ce4b3babf40f7e$var$ie.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace($f2ce4b3babf40f7e$var$se, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, _$r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(_$r, f));
        },
        p,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $f2ce4b3babf40f7e$var$D(15), $f2ce4b3babf40f7e$var$ee(e, t.name);
    }, 5381).toString() : "", m;
}
var $f2ce4b3babf40f7e$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createContext(), $f2ce4b3babf40f7e$export$91317688fc694efa = $f2ce4b3babf40f7e$export$8c190ef828af4c86.Consumer, $f2ce4b3babf40f7e$var$le = (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createContext(), $f2ce4b3babf40f7e$var$de = ($f2ce4b3babf40f7e$var$le.Consumer, new $f2ce4b3babf40f7e$var$X), $f2ce4b3babf40f7e$var$he = $f2ce4b3babf40f7e$var$ae();
function $f2ce4b3babf40f7e$var$pe() {
    return (0, $1Mpn7.useContext)($f2ce4b3babf40f7e$export$8c190ef828af4c86) || $f2ce4b3babf40f7e$var$de;
}
function $f2ce4b3babf40f7e$var$fe() {
    return (0, $1Mpn7.useContext)($f2ce4b3babf40f7e$var$le) || $f2ce4b3babf40f7e$var$he;
}
function $f2ce4b3babf40f7e$export$a473771da2f0ff7c(e) {
    var t = (0, $1Mpn7.useState)(e.stylisPlugins), n = t[0], s = t[1], c = $f2ce4b3babf40f7e$var$pe(), u = (0, $1Mpn7.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, $1Mpn7.useMemo)(function() {
        return $f2ce4b3babf40f7e$var$ae({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, $1Mpn7.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($7bad41d4868ffbaf$exports)))(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement($f2ce4b3babf40f7e$export$8c190ef828af4c86.Provider, {
        value: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement($f2ce4b3babf40f7e$var$le.Provider, {
        value: l
    }, (0, e.children)));
}
var $f2ce4b3babf40f7e$var$ye = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $f2ce4b3babf40f7e$var$he);
            var _$r = n.name + t.hash;
            e.hasNameForId(n.id, _$r) || e.insertRules(n.id, _$r, t(n.rules, _$r, "@keyframes"));
        }, this.toString = function() {
            return $f2ce4b3babf40f7e$var$D(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $f2ce4b3babf40f7e$var$he), this.name + e.hash;
    }, e;
}(), $f2ce4b3babf40f7e$var$ve = /([A-Z])/, $f2ce4b3babf40f7e$var$ge = /([A-Z])/g, $f2ce4b3babf40f7e$var$Se = /^ms-/, $f2ce4b3babf40f7e$var$we = function we(e) {
    return "-" + e.toLowerCase();
};
function $f2ce4b3babf40f7e$var$Ee(e) {
    return $f2ce4b3babf40f7e$var$ve.test(e) ? e.replace($f2ce4b3babf40f7e$var$ge, $f2ce4b3babf40f7e$var$we).replace($f2ce4b3babf40f7e$var$Se, "-ms-") : e;
}
var $f2ce4b3babf40f7e$var$be = function be(e) {
    return null == e || !1 === e || "" === e;
};
function $f2ce4b3babf40f7e$var$_e(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = $f2ce4b3babf40f7e$var$_e(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if ($f2ce4b3babf40f7e$var$be(e)) return "";
    if ($f2ce4b3babf40f7e$export$7ba318d8d2f06c76(e)) return "." + e.styledComponentId;
    if ($f2ce4b3babf40f7e$var$E(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return $f2ce4b3babf40f7e$var$_e(u, n, r, o);
    }
    var l;
    return e instanceof $f2ce4b3babf40f7e$var$ye ? r ? (e.inject(r, o), e.getName(o)) : e : $f2ce4b3babf40f7e$var$g(e) ? function e(t, n) {
        var _$r, _$o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !$f2ce4b3babf40f7e$var$be(t[i]) && (Array.isArray(t[i]) && t[i].isCss || $f2ce4b3babf40f7e$var$E(t[i]) ? s.push($f2ce4b3babf40f7e$var$Ee(i) + ":", t[i], ";") : $f2ce4b3babf40f7e$var$g(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push($f2ce4b3babf40f7e$var$Ee(i) + ": " + (_$r = i, null == (_$o = t[i]) || "boolean" == typeof _$o || "" === _$o ? "" : "number" != typeof _$o || 0 === _$o || _$r in (0, $a661ec6db99b52aa$export$2e2bcd8739ae039) || _$r.startsWith("--") ? String(_$o).trim() : _$o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var $f2ce4b3babf40f7e$var$Ne = function Ne(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function $f2ce4b3babf40f7e$export$dbf350e5966cf602(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), _$r = 1; _$r < t; _$r++)n[_$r - 1] = arguments[_$r];
    return $f2ce4b3babf40f7e$var$E(e) || $f2ce4b3babf40f7e$var$g(e) ? $f2ce4b3babf40f7e$var$Ne($f2ce4b3babf40f7e$var$_e($f2ce4b3babf40f7e$var$v($f2ce4b3babf40f7e$var$S, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : $f2ce4b3babf40f7e$var$Ne($f2ce4b3babf40f7e$var$_e($f2ce4b3babf40f7e$var$v(e, n)));
}
var $f2ce4b3babf40f7e$var$Ce = /invalid hook call/i, $f2ce4b3babf40f7e$var$Ie = new Set, $f2ce4b3babf40f7e$var$Pe = function Pe(e, t) {
    var n, _$r, o, e1;
}, $f2ce4b3babf40f7e$var$Oe = function Oe(e, t, n) {
    return void 0 === n && (n = $f2ce4b3babf40f7e$var$w), e.theme !== n.theme && e.theme || t || n.theme;
}, $f2ce4b3babf40f7e$var$Re = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $f2ce4b3babf40f7e$var$De = /(^-|-$)/g;
function $f2ce4b3babf40f7e$var$je(e) {
    return e.replace($f2ce4b3babf40f7e$var$Re, "-").replace($f2ce4b3babf40f7e$var$De, "");
}
var $f2ce4b3babf40f7e$var$Te = function Te(e) {
    return $f2ce4b3babf40f7e$var$Q($f2ce4b3babf40f7e$var$te(e) >>> 0);
};
function $f2ce4b3babf40f7e$var$xe(e) {
    return "string" == typeof e && true;
}
var $f2ce4b3babf40f7e$var$ke = function ke(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, $f2ce4b3babf40f7e$var$Ve = function Ve(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function $f2ce4b3babf40f7e$var$Be(e, t, n) {
    var _$r = e[n];
    $f2ce4b3babf40f7e$var$ke(t) && $f2ce4b3babf40f7e$var$ke(_$r) ? $f2ce4b3babf40f7e$var$ze(_$r, t) : e[n] = t;
}
function $f2ce4b3babf40f7e$var$ze(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), _$r = 1; _$r < t; _$r++)n[_$r - 1] = arguments[_$r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if ($f2ce4b3babf40f7e$var$ke(i)) for(var a in i)$f2ce4b3babf40f7e$var$Ve(a) && $f2ce4b3babf40f7e$var$Be(e, i[a], a);
    }
    return e;
}
var $f2ce4b3babf40f7e$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createContext(), $f2ce4b3babf40f7e$export$b631efc24e9d5e2f = $f2ce4b3babf40f7e$export$2c657da244d00bd6.Consumer;
function $f2ce4b3babf40f7e$export$d8964aec282183a3(e) {
    var t = (0, $1Mpn7.useContext)($f2ce4b3babf40f7e$export$2c657da244d00bd6), n = (0, $1Mpn7.useMemo)(function() {
        return function(e, t) {
            if (!e) return $f2ce4b3babf40f7e$var$D(14);
            if ($f2ce4b3babf40f7e$var$E(e)) {
                var n = e(t);
                return n;
            }
            return Array.isArray(e) || "object" != typeof e ? $f2ce4b3babf40f7e$var$D(8) : t ? $f2ce4b3babf40f7e$var$y({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement($f2ce4b3babf40f7e$export$2c657da244d00bd6.Provider, {
        value: n
    }, e.children) : null;
}
var $f2ce4b3babf40f7e$var$Fe = {};
function $f2ce4b3babf40f7e$var$Ye(e, t, n) {
    var o = $f2ce4b3babf40f7e$export$7ba318d8d2f06c76(e), i = !$f2ce4b3babf40f7e$var$xe(e), a = t.attrs, c = void 0 === a ? $f2ce4b3babf40f7e$var$S : a, l = t.componentId, d = void 0 === l ? function(e, t) {
        var _$n = "string" != typeof e ? "sc" : $f2ce4b3babf40f7e$var$je(e);
        $f2ce4b3babf40f7e$var$Fe[_$n] = ($f2ce4b3babf40f7e$var$Fe[_$n] || 0) + 1;
        var _$r = _$n + "-" + $f2ce4b3babf40f7e$var$Te("5.3.11" + _$n + $f2ce4b3babf40f7e$var$Fe[_$n]);
        return t ? t + "-" + _$r : _$r;
    }(t.displayName, t.parentComponentId) : l, h = t.displayName, p = void 0 === h ? function(e) {
        return $f2ce4b3babf40f7e$var$xe(e) ? "styled." + e : "Styled(" + $f2ce4b3babf40f7e$var$b(e) + ")";
    }(e) : h, v = t.displayName && t.componentId ? $f2ce4b3babf40f7e$var$je(t.displayName) + "-" + t.componentId : t.componentId || d, g = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, N = t.shouldForwardProp;
    o && e.shouldForwardProp && (N = t.shouldForwardProp ? function N(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var A, C = new $f2ce4b3babf40f7e$var$oe(n, v, o ? e.componentStyle : void 0), I = C.isStatic && 0 === c.length, P = function P(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, l = e.shouldForwardProp, d = e.styledComponentId, h = e.target, p = function(e, t, n) {
                void 0 === e && (e = $f2ce4b3babf40f7e$var$w);
                var _$r = $f2ce4b3babf40f7e$var$y({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var _$t, _$n, _$s, i = e;
                    for(_$t in $f2ce4b3babf40f7e$var$E(i) && (i = i(_$r)), i)_$r[_$t] = o[_$t] = "className" === _$t ? (_$n = o[_$t], _$s = i[_$t], _$n && _$s ? _$n + " " + _$s : _$n || _$s) : i[_$t];
                }), [
                    _$r,
                    o
                ];
            }($f2ce4b3babf40f7e$var$Oe(t, (0, $1Mpn7.useContext)($f2ce4b3babf40f7e$export$2c657da244d00bd6), a) || $f2ce4b3babf40f7e$var$w, t, o), _$m = p[0], v = p[1], g = function(e, t, n, r) {
                var o = $f2ce4b3babf40f7e$var$pe(), _$s = $f2ce4b3babf40f7e$var$fe(), i = t ? e.generateAndInjectStyles($f2ce4b3babf40f7e$var$w, o, _$s) : e.generateAndInjectStyles(n, o, _$s);
                return i;
            }(i, r, _$m, void 0), S = n, b = v.$as || t.$as || v.as || t.as || h, _$_ = $f2ce4b3babf40f7e$var$xe(b), N = v !== t ? $f2ce4b3babf40f7e$var$y({}, t, {}, v) : t, A = {};
            for(var C in N)"$" !== C[0] && "as" !== C && ("forwardedAs" === C ? A.as = N[C] : (l ? l(C, (0, $23a78f4023c8eae7$export$2e2bcd8739ae039), b) : !_$_ || (0, $23a78f4023c8eae7$export$2e2bcd8739ae039)(C)) && (A[C] = N[C]));
            return t.style && v.style !== t.style && (A.style = $f2ce4b3babf40f7e$var$y({}, t.style, {}, v.style)), A.className = Array.prototype.concat(c, d, g !== d ? g : null, t.className, v.className).filter(Boolean).join(" "), A.ref = S, (0, $1Mpn7.createElement)(b, A);
        }(A, e, t, I);
    };
    return P.displayName = p, (A = (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).forwardRef(P)).attrs = g, A.componentStyle = C, A.displayName = p, A.shouldForwardProp = N, A.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $f2ce4b3babf40f7e$var$S, A.styledComponentId = v, A.target = o ? e.target : e, A.withComponent = function(e) {
        var _$r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var _$n, _$r, o = {}, s = Object.keys(e);
            for(_$r = 0; _$r < s.length; _$r++)_$n = s[_$r], t.indexOf(_$n) >= 0 || (o[_$n] = e[_$n]);
            return o;
        }(t, [
            "componentId"
        ]), s = _$r && _$r + "-" + ($f2ce4b3babf40f7e$var$xe(e) ? e : $f2ce4b3babf40f7e$var$je($f2ce4b3babf40f7e$var$b(e)));
        return $f2ce4b3babf40f7e$var$Ye(e, $f2ce4b3babf40f7e$var$y({}, o, {
            attrs: g,
            componentId: s
        }), n);
    }, Object.defineProperty(A, "defaultProps", {
        get: function get() {
            return this._foldedDefaultProps;
        },
        set: function set(t) {
            this._foldedDefaultProps = o ? $f2ce4b3babf40f7e$var$ze({}, e.defaultProps, t) : t;
        }
    }), Object.defineProperty(A, "toString", {
        value: function value() {
            return "." + A.styledComponentId;
        }
    }), i && (0, (/*@__PURE__*/$parcel$interopDefault($03d46e509d407e42$exports)))(A, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), A;
}
var $f2ce4b3babf40f7e$var$qe = function qe(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = $f2ce4b3babf40f7e$var$w), !(0, $37a542d4961dbff1$exports.isValidElementType)(r)) return $f2ce4b3babf40f7e$var$D(1, String(r));
        var s = function s() {
            return t(r, o, $f2ce4b3babf40f7e$export$dbf350e5966cf602.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, $f2ce4b3babf40f7e$var$y({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, $f2ce4b3babf40f7e$var$y({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }($f2ce4b3babf40f7e$var$Ye, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    $f2ce4b3babf40f7e$var$qe[e] = $f2ce4b3babf40f7e$var$qe(e);
});
var $f2ce4b3babf40f7e$var$He = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $f2ce4b3babf40f7e$var$ne(e), $f2ce4b3babf40f7e$var$X.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r($f2ce4b3babf40f7e$var$_e(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && $f2ce4b3babf40f7e$var$X.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $f2ce4b3babf40f7e$export$f0f03736edb61697(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = $f2ce4b3babf40f7e$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + $f2ce4b3babf40f7e$var$Te(JSON.stringify(i)), u = new $f2ce4b3babf40f7e$var$He(i, a);
    function d(e) {
        var t = $f2ce4b3babf40f7e$var$pe(), n = $f2ce4b3babf40f7e$var$fe(), o = (0, $1Mpn7.useContext)($f2ce4b3babf40f7e$export$2c657da244d00bd6), _$d = (0, $1Mpn7.useRef)(t.allocateGSInstance(a)).current;
        return t.server && h(_$d, e, t, o, n), (0, $1Mpn7.useLayoutEffect)(function() {
            if (!t.server) return h(_$d, e, t, o, n), function() {
                return u.removeStyles(_$d, t);
            };
        }, [
            _$d,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, $f2ce4b3babf40f7e$var$P, n, o);
        else {
            var s = $f2ce4b3babf40f7e$var$y({}, t, {
                theme: $f2ce4b3babf40f7e$var$Oe(t, r, d.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).memo(d);
}
function $f2ce4b3babf40f7e$export$d25ddfdf17c3ad3e(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), _$r = 1; _$r < t; _$r++)n[_$r - 1] = arguments[_$r];
    var o = $f2ce4b3babf40f7e$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)).join(""), s = $f2ce4b3babf40f7e$var$Te(o);
    return new $f2ce4b3babf40f7e$var$ye(s, o);
}
var $f2ce4b3babf40f7e$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var _$e = this;
        this._emitSheetCSS = function() {
            var t = _$e.instance.toString();
            if (!t) return "";
            var n = $f2ce4b3babf40f7e$var$Y();
            return "<style " + [
                n && 'nonce="' + n + '"',
                $f2ce4b3babf40f7e$var$N + '="true"',
                'data-styled-version="5.3.11"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return _$e.sealed ? $f2ce4b3babf40f7e$var$D(2) : _$e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (_$e.sealed) return $f2ce4b3babf40f7e$var$D(2);
            var n = ((t = {})[$f2ce4b3babf40f7e$var$N] = "", t["data-styled-version"] = "5.3.11", t.dangerouslySetInnerHTML = {
                __html: _$e.instance.toString()
            }, t), o = $f2ce4b3babf40f7e$var$Y();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("style", $f2ce4b3babf40f7e$var$y({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            _$e.sealed = !0;
        }, this.instance = new $f2ce4b3babf40f7e$var$X({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? $f2ce4b3babf40f7e$var$D(2) : (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement($f2ce4b3babf40f7e$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return $f2ce4b3babf40f7e$var$D(3);
    }, e;
}(), $f2ce4b3babf40f7e$export$e8748c6a27b910dc = function Je(e) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).forwardRef(function(t, n) {
        var o = (0, $1Mpn7.useContext)($f2ce4b3babf40f7e$export$2c657da244d00bd6), i = e.defaultProps, a = $f2ce4b3babf40f7e$var$Oe(t, o, i);
        return (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement(e, $f2ce4b3babf40f7e$var$y({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($03d46e509d407e42$exports)))(t, e), t.displayName = "WithTheme(" + $f2ce4b3babf40f7e$var$b(e) + ")", t;
}, $f2ce4b3babf40f7e$export$93d4e7f90805808f = function Xe() {
    return (0, $1Mpn7.useContext)($f2ce4b3babf40f7e$export$2c657da244d00bd6);
}, $f2ce4b3babf40f7e$export$5c87cfe6c475f500 = {
    StyleSheet: $f2ce4b3babf40f7e$var$X,
    masterSheet: $f2ce4b3babf40f7e$var$de
};
var $f2ce4b3babf40f7e$export$2e2bcd8739ae039 = $f2ce4b3babf40f7e$var$qe;



function $920900f9cf33bdcc$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  display: flex;\n  gap: 8px;\n  font-size: 12px;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    $920900f9cf33bdcc$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $920900f9cf33bdcc$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "\n  font-weight: 400;\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n  align-items: center;\n  font-size: 14px;\n  color: ",
        ";\n"
    ]);
    $920900f9cf33bdcc$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $920900f9cf33bdcc$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "\n  ",
        "\n\n  ::placeholder {\n    ",
        "\n  }\n"
    ]);
    $920900f9cf33bdcc$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $920900f9cf33bdcc$var$_templateObject3() {
    var data = (0, $j06k0._)([
        "\n  max-width: min-content;\n  background-color: ",
        ";\n  border-radius: 5px;\n  padding: 3px 5px;\n  color: ",
        ";\n  font-size: 12px;\n  user-select: none;\n"
    ]);
    $920900f9cf33bdcc$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var $920900f9cf33bdcc$export$e6d6b58188820b8a = (0, $f2ce4b3babf40f7e$export$2e2bcd8739ae039).div($920900f9cf33bdcc$var$_templateObject());
var $920900f9cf33bdcc$export$1e8407dccf0d27b6 = "\n  border: 1px solid ".concat((0, $651851c7f7a4dfb5$export$8fe7e62e076ddbb5).GRAY_DARK, ";\n  border-radius: 5px;\n  padding: 8px 6px;\n  transition: 0.2s ease border, box-shadow;\n  width: 100%;\n  outline: none;\n  box-shadow: 0 1px 1px rgb(226 228 239 / 50%);\n  font-size: 14px;\n\n  :hover {\n    border-color: ").concat((0, $651851c7f7a4dfb5$export$8fe7e62e076ddbb5).GRAY_DARK, ";\n  }\n\n  :focus {\n    border-color: ").concat((0, $651851c7f7a4dfb5$export$8fe7e62e076ddbb5).GRAY_DARKER, ";\n    box-shadow: 0 0 5px ").concat((0, $651851c7f7a4dfb5$export$8fe7e62e076ddbb5).GRAY_DARK, ";\n  }\n\n  ::placeholder {\n    color: ").concat((0, $651851c7f7a4dfb5$export$8fe7e62e076ddbb5).GRAY_DARKER, ";\n  }\n");
var $920900f9cf33bdcc$export$30c69c51aadaa8e4 = function(param) {
    var label = param.label, _param_type = param.type, type = _param_type === void 0 ? "text" : _param_type, value = param.value, onChange = param.onChange, placeholder = param.placeholder, pattern = param.pattern, onKeyDown = param.onKeyDown, required = param.required;
    return /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            gap: 10
        },
        children: [
            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)($920900f9cf33bdcc$export$76d3231fec538b73, {
                children: label
            }),
            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)($920900f9cf33bdcc$export$c86715117507e8e5, {
                type: type,
                value: value,
                onChange: onChange,
                placeholder: placeholder,
                pattern: pattern,
                onKeyDown: onKeyDown,
                required: required
            })
        ]
    });
};
var $920900f9cf33bdcc$export$76d3231fec538b73 = (0, $f2ce4b3babf40f7e$export$2e2bcd8739ae039).span($920900f9cf33bdcc$var$_templateObject1(), (0, $651851c7f7a4dfb5$export$8fe7e62e076ddbb5).GRAY_DARKER);
var $920900f9cf33bdcc$export$c86715117507e8e5 = (0, $f2ce4b3babf40f7e$export$2e2bcd8739ae039).input($920900f9cf33bdcc$var$_templateObject2(), $920900f9cf33bdcc$export$1e8407dccf0d27b6, function(props) {
    return props.placeholderColor && "color: ".concat(props.placeholderColor, " !important;");
});
var $920900f9cf33bdcc$export$bd0cf18531183c14 = (0, $f2ce4b3babf40f7e$export$2e2bcd8739ae039).div($920900f9cf33bdcc$var$_templateObject3(), (0, $651851c7f7a4dfb5$export$8fe7e62e076ddbb5).GRAY_MED, (0, $651851c7f7a4dfb5$export$8fe7e62e076ddbb5).GRAY_DARKEST);



var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");

var $j06k0 = parcelRequire("j06k0");

parcelRequire("1Mpn7");



var $j06k0 = parcelRequire("j06k0");


function $175084bd47e05638$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  from {\n      transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"
    ]);
    $175084bd47e05638$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $175084bd47e05638$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "\n  width: 20px;\n  height: 20px;\n  margin: 0;\n  background: transparent;\n  border-top: 2px solid ",
        ";\n  border-right: 2px solid transparent;\n  border-radius: 50%;\n  animation: .5s ",
        " linear infinite;\n"
    ]);
    $175084bd47e05638$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $175084bd47e05638$var$Spin = (0, $f2ce4b3babf40f7e$export$d25ddfdf17c3ad3e)($175084bd47e05638$var$_templateObject());
var $175084bd47e05638$var$Spinner = (0, $f2ce4b3babf40f7e$export$2e2bcd8739ae039).div($175084bd47e05638$var$_templateObject1(), (0, $651851c7f7a4dfb5$export$8fe7e62e076ddbb5).ORANGE, $175084bd47e05638$var$Spin);
var $175084bd47e05638$export$2e2bcd8739ae039 = $175084bd47e05638$var$Spinner;


function $913546acae8c9187$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  background-color: ",
        ";\n  border-radius: 25px;\n  padding: 14px 30px;\n  outline: 0;\n  border: 0;\n  color: #FFF;\n  cursor: pointer;\n  transition: 0.2s ease all;\n  font-size: 16px;\n  height: fit-content;\n  user-select: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n  transform: scale(1);\n\n  :hover {\n    transform: scale(1.005);\n    opacity: 0.75;\n  }\n  \n  :active {\n    transform: scale(0.995);\n  }\n\n  :disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n\n    :active {\n      color: #FFF;\n    }\n  }\n"
    ]);
    $913546acae8c9187$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $913546acae8c9187$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "\n  border: 1px solid;\n  border-color: ",
        ";\n  border-radius: 5px;\n  padding: 10px 30px;\n  outline: 0;\n  background: none;\n  color: ",
        ";\n  cursor: pointer;\n  transition: 0.2s ease all;\n  font-size: 14px;\n  height: fit-content;\n  user-select: none;\n  \n  :hover {\n    opacity: 0.75;\n  }\n\n  :disabled {\n    cursor: default;\n    border-color: ",
        ";\n    color: ",
        ";\n    :hover {\n      opacity: 1;\n    }\n  }\n  \n  :active {\n    opacity: 0.5;\n  }\n"
    ]);
    $913546acae8c9187$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $913546acae8c9187$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "\n  border: 1px solid;\n  border-color: ",
        ";\n  border-radius: 5px;\n  padding: 5px 20px;\n  outline: 0;\n  background: none;\n  color: ",
        ";\n  cursor: pointer;\n  transition: 0.2s ease all;\n  font-size: 12px;\n  height: fit-content;\n  user-select: none;\n  text-decoration: none;\n  \n  :hover {\n    opacity: 0.75;\n  }\n  \n  :active {\n    opacity: 0.5;\n  }\n"
    ]);
    $913546acae8c9187$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $913546acae8c9187$var$_templateObject3() {
    var data = (0, $j06k0._)([
        "\n  background-color: ",
        ";\n  border-radius: 5px;\n  padding: 10px 30px;\n  outline: 0;\n  border: 0;\n  color: #FFF;\n  cursor: pointer;\n  transition: 0.2s ease all;\n  text-decoration: none;\n  font-size: 14px;\n  height: fit-content;\n  user-select: none;\n  \n  :hover {\n      opacity: 0.75;\n  }\n  \n  :active {\n      background-color: #ffd6ce;\n      color: ",
        ";\n  }\n"
    ]);
    $913546acae8c9187$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $913546acae8c9187$var$_templateObject4() {
    var data = (0, $j06k0._)([
        "\n  border: 0;\n  border-radius: 5px;\n  padding: 5px 20px;\n  outline: 0;\n  background: none;\n  color: ",
        ";\n  cursor: pointer;\n  transition: 0.2s ease all;\n  font-size: 12px;\n  height: fit-content;\n  user-select: none;\n  display: flex;\n  align-items: center;\n  \n  :hover {\n    opacity: 0.75;\n  }\n  \n  :active {\n    opacity: 0.5;\n  }\n"
    ]);
    $913546acae8c9187$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
var $913546acae8c9187$var$PrimaryButtonInner = (0, $f2ce4b3babf40f7e$export$2e2bcd8739ae039).button($913546acae8c9187$var$_templateObject(), (0, $651851c7f7a4dfb5$export$8fe7e62e076ddbb5).BLACK);
var $913546acae8c9187$export$ac16a6a04d9b7c84 = function(_param) // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
/*#__PURE__*/ {
    var disabled = _param.disabled, props = (0, $dRLPW._)(_param, [
        "disabled"
    ]);
    var _props_spinnerColor;
    return (0, $78b37e1ff5a5ba28$exports.jsx)($913546acae8c9187$var$PrimaryButtonInner, (0, $cxjpp._)((0, $do9pw._)({
        style: props.style,
        disabled: props.isLoading || disabled
    }, props), {
        children: props.isLoading ? /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $175084bd47e05638$export$2e2bcd8739ae039), {
            style: {
                borderColor: (_props_spinnerColor = props.spinnerColor) !== null && _props_spinnerColor !== void 0 ? _props_spinnerColor : "white"
            }
        }) : props.children
    }));
};
var $913546acae8c9187$export$f861551692d63a2e = (0, $f2ce4b3babf40f7e$export$2e2bcd8739ae039).button($913546acae8c9187$var$_templateObject1(), (0, $651851c7f7a4dfb5$export$8fe7e62e076ddbb5).ORANGE, (0, $651851c7f7a4dfb5$export$8fe7e62e076ddbb5).ORANGE, (0, $651851c7f7a4dfb5$export$8fe7e62e076ddbb5).ORANGE_LIGHT, (0, $651851c7f7a4dfb5$export$8fe7e62e076ddbb5).ORANGE_LIGHT);
var $913546acae8c9187$export$eeafbfd890eadf04 = (0, $f2ce4b3babf40f7e$export$2e2bcd8739ae039).a($913546acae8c9187$var$_templateObject2(), (0, $651851c7f7a4dfb5$export$8fe7e62e076ddbb5).ORANGE, (0, $651851c7f7a4dfb5$export$8fe7e62e076ddbb5).ORANGE);
var $913546acae8c9187$export$eeb919efb9beb575 = (0, $f2ce4b3babf40f7e$export$2e2bcd8739ae039).a($913546acae8c9187$var$_templateObject3(), (0, $651851c7f7a4dfb5$export$8fe7e62e076ddbb5).ORANGE, (0, $651851c7f7a4dfb5$export$8fe7e62e076ddbb5).ORANGE);
var $913546acae8c9187$export$c25acd513dcc8062 = (0, $f2ce4b3babf40f7e$export$2e2bcd8739ae039).button($913546acae8c9187$var$_templateObject4(), (0, $651851c7f7a4dfb5$export$8fe7e62e076ddbb5).ORANGE);



parcelRequire("1Mpn7");


var $cv9Rk = parcelRequire("cv9Rk");


var $ab54c6528fd33ab0$exports = {};

$ab54c6528fd33ab0$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "EUROCLogo.e814427f.svg";


var $0f4e15bfd5ca546d$exports = {};

$0f4e15bfd5ca546d$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "FRAXLogo.493412e4.svg";


var $314c79ce397264a1$exports = {};

$314c79ce397264a1$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "DaiLogo.5b7d885d.svg";


var $24fa3a5fa31088bf$exports = {};

$24fa3a5fa31088bf$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "WETH.6226dbd9.svg";


var $1ca0b7eeaa1ce6da$exports = {};

$1ca0b7eeaa1ce6da$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "GeminiLogo.5cbba47e.png";



var $ad61c475a87f4dd1$exports = {};

$ad61c475a87f4dd1$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "TORLogo.bd732ad4.svg";


var $45f726d027cb8b97$exports = {};

$45f726d027cb8b97$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "TUSDLogo.df934baa.svg";


var $f4151107e463ef7b$exports = {};

$f4151107e463ef7b$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "USDPLogo.d2d050af.svg";


var $d8d8a427155ecfef$exports = {};

$d8d8a427155ecfef$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "TetherGoldLogo.5d02ace7.svg";


var $766dcfcaaeac16db$exports = {};

$766dcfcaaeac16db$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "PRQLogo.ef7c079b.svg";


var $124f41021434efbc$exports = {};

$124f41021434efbc$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "PAXGLogo.814ce36e.svg";


var $20c62d8ae4848285$exports = {};

$20c62d8ae4848285$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "MIMLogo.ea9454b3.svg";



var $30953b4efe489e63$exports = {};

$30953b4efe489e63$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "FantomLogo.59ea410b.svg";


var $0d36aa53ad1b24f2$exports = {};

$0d36aa53ad1b24f2$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "WrappedBitcoin.a9abc558.svg";





var $7b54e9cb5bb08ffa$exports = {};

$7b54e9cb5bb08ffa$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "DAIKLogo.7aa105ad.png";


var $69707e5e0c88fb19$exports = {};

$69707e5e0c88fb19$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "ETHKLogo.b79115fc.png";


var $e2d064fef7267dbc$exports = {};

$e2d064fef7267dbc$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "BTCKLogo.9770427e.png";


var $700a611de8a97cda$exports = {};

$700a611de8a97cda$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "WOKTLogo.2376971f.png";


var $30861f511cf373b9$exports = {};

$30861f511cf373b9$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "OKBLogo.8b0e77b3.png";


var $3e5bdbdfebaf62ee$export$8e1e81ac145e31be = {
    USDC: {
        name: "USD Coin",
        ticker: "USDC",
        addresses: {
            1: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
            31337: "0x6d4cc59Ca95Ab85e333a17bAF97a225CA10F292c",
            5: "0x12437ca9aCb41Cc73D1c59E29C7496A054FC8A78",
            80001: "0x8f8b1972eea072C3C228EbE8f9FEADe03927D70F",
            4002: "0x31720c00bD9EDEF0dbcBFcBa20B572c6b950C6Dc",
            11155111: "0xa4fCE8264370437e718aE207805b4e6233638b9E",
            1313161555: "0x0C6013dfdaBF883F3fc2d7D9911f30f54D10E4a6",
            43113: "0x2e9B1F01068B96D7c85913f70Cf29464FA98b567",
            534353: "0x87cba17033bAA29324708dC12503a14C179a00D7",
            137: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
            56: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
            250: "0x04068DA6C83AFCFA0e13ba15A6696662335D5B75",
            43114: "0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E",
            66: "0xc946DAf81b08146B1C7A8Da2A851Ddf2B3EAaf85"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($a345f3b3ee09feaa$exports))),
        decimals: {
            default: 6,
            56: 18,
            66: 18
        }
    },
    PAXG: {
        name: "Paxos Gold",
        ticker: "PAXG",
        addresses: {
            1: "0x45804880de22913dafe09f4980848ece6ecbaf78"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($124f41021434efbc$exports))),
        decimals: {
            default: 18
        }
    },
    DAIK: {
        name: "DAI",
        ticker: "DAIK",
        pricefeedTicker: "DAI",
        addresses: {
            66: "0x21cDE7E32a6CAF4742d00d44B07279e7596d26B9"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($7b54e9cb5bb08ffa$exports))),
        decimals: {
            default: 18
        }
    },
    ETHK: {
        name: "ETHK",
        ticker: "ETHK",
        pricefeedTicker: "ETH",
        addresses: {
            66: "0xEF71CA2EE68F45B9Ad6F72fbdb33d707b872315C"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($69707e5e0c88fb19$exports))),
        decimals: {
            default: 18
        }
    },
    WOKT: {
        name: "Wrapped OKT",
        ticker: "WOKT",
        pricefeedTicker: "OKT",
        addresses: {
            66: "0x8F8526dbfd6E38E3D8307702cA8469Bae6C56C15"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($700a611de8a97cda$exports))),
        decimals: {
            default: 18
        }
    },
    XAUT: {
        name: "Tether Gold",
        ticker: "XAUT",
        addresses: {
            1: "0x68749665FF8D2d112Fa859AA293F07A622782F38"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($d8d8a427155ecfef$exports))),
        decimals: {
            default: 6
        }
    },
    WBTC: {
        name: "Wrapped Bitcoin",
        ticker: "WBTC",
        addresses: {
            1: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
            250: "0x321162Cd933E2Be498Cd2267a90534A804051b11",
            137: "0x1bfd67037b42cf73acf2047067bd4f2c47d9bfd6",
            56: "0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c",
            43114: "0x50b7545627a5162f82a992c33b87adc75187b218"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($0d36aa53ad1b24f2$exports))),
        decimals: {
            default: 8,
            56: 18
        }
    },
    USDCe: {
        name: "Bridged USDC Coin",
        ticker: "USDC.e",
        pricefeedTicker: "USDC",
        addresses: {
            1313161554: "0xb12bfca5a55806aaf64e99521918a4bf0fc40802",
            43114: "0xa7d7079b0fead91f3e65f86e8915cb59c1a4c664"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($a345f3b3ee09feaa$exports))),
        decimals: {
            default: 6
        }
    },
    EURT: {
        name: "Euro Tether",
        ticker: "EURT",
        addresses: {
            1: "0xC581b735A1688071A1746c968e0798D642EDE491"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($5d39efd1acbcc2ad$exports))),
        decimals: {
            default: 6
        }
    },
    BTCK: {
        name: "BTCK",
        ticker: "BTCK",
        pricefeedTicker: "BTC",
        addresses: {
            66: "0x54e4622DC504176b3BB432dCCAf504569699a7fF"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($e2d064fef7267dbc$exports))),
        decimals: {
            default: 18
        }
    },
    OKB: {
        name: "OKB",
        ticker: "OKB",
        addresses: {
            66: "0xdF54B6c6195EA4d948D03bfD818D365cf175cFC2"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($30861f511cf373b9$exports))),
        decimals: {
            default: 18
        }
    },
    EUROC: {
        name: "Euro Coin",
        ticker: "EUROC",
        addresses: {
            1: "0x1abaea1f7c830bd89acc67ec4af516284b1bc33c"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($ab54c6528fd33ab0$exports))),
        decimals: {
            default: 6
        }
    },
    USDT: {
        name: "Tether USD",
        ticker: "USDT",
        addresses: {
            1: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
            31337: "0x7e05775C8CD424Fc80a0a6B31c7596fdF20B8076",
            5: "0x1AAaF0f10C26E33DBe04d06531E533345CbA755e",
            80001: "0x70BE8802e2F3C6652B7e0814B478f66Ec52d9d88",
            4002: "0xCc8401Fbca27934D4bFC762FEbb667ACdb976F88",
            11155111: "0xE50d86c6dE38F9754f6777d2925377564Bf79482",
            1313161555: "0x7696c118ea37866c38918CAE97C4A9383e8129F6",
            43113: "0x31720c00bD9EDEF0dbcBFcBa20B572c6b950C6Dc",
            534353: "0xA0CA2CdC4291826AAFb0C2DF77f303EdfeA34ef3",
            137: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
            56: "0x55d398326f99059ff775485246999027b3197955",
            43114: "0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7",
            66: "0x382bB369d343125BfB2117af9c149795C6C65C50"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($5d39efd1acbcc2ad$exports))),
        decimals: {
            default: 6,
            56: 18,
            66: 18
        }
    },
    USDTe: {
        name: "Tether USD",
        ticker: "USDT.e",
        pricefeedTicker: "USDT",
        addresses: {
            1313161554: "0x4988a896b1227218e4A686fdE5EabdcAbd91571f",
            43114: "0xc7198437980c041c805a1edcba50c1ce5db95118"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($5d39efd1acbcc2ad$exports))),
        decimals: {
            default: 6
        }
    },
    FUSDT: {
        name: "Frapped USDT",
        ticker: "fUSDT",
        pricefeedTicker: "USDT",
        addresses: {
            250: "0x049d68029688eAbF473097a2fC38ef61633A3C7A"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($5d39efd1acbcc2ad$exports))),
        decimals: {
            default: 6
        }
    },
    FRAX: {
        name: "FRAX",
        ticker: "FRAX",
        addresses: {
            1: "0x853d955acef822db058eb8505911ed77f175b99e",
            250: "0xdc301622e621166bd8e82f2ca0a26c13ad0be355",
            43114: "0xD24C2Ad096400B6FBcd2ad8B24E7acBc21A1da64"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($0f4e15bfd5ca546d$exports))),
        decimals: {
            default: 18
        }
    },
    WAVAX: {
        name: "Wrapped AVAX",
        ticker: "WAVAX",
        pricefeedTicker: "AVAX",
        addresses: {
            43114: "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($cdac8429c845843c$exports))),
        decimals: {
            default: 18
        }
    },
    USDP: {
        name: "Pax Dollar",
        ticker: "USDP",
        addresses: {
            1: "0x8e870d67f660d95d5be530380d0ec0bd388289e1"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($f4151107e463ef7b$exports))),
        decimals: {
            default: 18
        }
    },
    TUSD: {
        name: "TrueUSD",
        ticker: "TUSD",
        addresses: {
            1: "0x0000000000085d4780B73119b644AE5ecd22b376"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($45f726d027cb8b97$exports))),
        decimals: {
            default: 18
        }
    },
    MIM: {
        name: "Magic Internet Money",
        ticker: "MIM",
        addresses: {
            250: "0x82f0B8B456c1A451378467398982d4834b6829c1",
            43114: "0x130966628846bfd36ff31a822705796e8cb8c18d"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($20c62d8ae4848285$exports))),
        decimals: {
            default: 18
        }
    },
    WFTM: {
        name: "Wrapped Fantom",
        ticker: "WFTM",
        pricefeedTicker: "FTM",
        addresses: {
            250: "0x21be370d5312f44cb42ce377bc9b8a0cef1a4c83"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($30953b4efe489e63$exports))),
        decimals: {
            default: 18
        }
    },
    DAI: {
        name: "DAI Stablecoin",
        ticker: "DAI",
        addresses: {
            1: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
            31337: "0x3a2F7b4b41706C6A0A60cDf02835321175c919e4",
            5: "0x16246c650be7C4EE01fDE5DAEd829D4C65c09450",
            80001: "0x3C10B58B766F2E9BEE0895cd5654EF8E02Fb6b8B",
            4002: "0x2e9B1F01068B96D7c85913f70Cf29464FA98b567",
            11155111: "0xE76FbC3C71499e0C522F21ad1520825BB7Be6714",
            1313161555: "0xACdC5B8b4cD24D99737116afA55F98D05D853c55",
            43113: "0x04C15309Edf4ff9fcDa1F542CddBd63684bd50f0",
            534353: "0x56F8853aE261FFD95D65131e8525DBd317103664",
            137: "0x8f3cf7ad23cd3cadbd9735aff958023239c6a063",
            56: "0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3",
            1313161554: "0xe3520349F477A5F6EB06107066048508498A291b",
            250: "0x8d11ec38a3eb5e956b052f67da8bdc9bef8abf3e"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($314c79ce397264a1$exports))),
        decimals: {
            default: 18
        }
    },
    DAIe: {
        name: "DAI Stablecoin",
        ticker: "DAI.e",
        pricefeedTicker: "DAI",
        addresses: {
            43114: "0xd586e7f844cea2f87f50152665bcbc2c279d8d70"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($314c79ce397264a1$exports))),
        decimals: {
            default: 18
        }
    },
    BUSD: {
        name: "Binance USD",
        ticker: "BUSD",
        addresses: {
            56: "0xe9e7cea3dedca5984780bafc599bd69add087d56"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($c7c23fe39b1ec5b3$exports))),
        decimals: {
            default: 18
        }
    },
    BUSDe: {
        name: "Binance USD",
        ticker: "BUSD.e",
        pricefeedTicker: "BUSD",
        addresses: {
            43114: "0x19860ccb0a68fd4213ab9d8266f7bbf05a8dde98"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($c7c23fe39b1ec5b3$exports))),
        decimals: {
            default: 18
        }
    },
    TOR: {
        name: "TOR",
        ticker: "TOR",
        addresses: {
            250: "0x74e23df9110aa9ea0b6ff2faee01e740ca1c642e"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($ad61c475a87f4dd1$exports))),
        decimals: {
            default: 18
        }
    },
    GUSD: {
        name: "Gemini Dollar",
        ticker: "GUSD",
        addresses: {
            1: "0x056Fd409E1d7A124BD7017459dFEa2F387b6d5Cd",
            31337: "0xc9777dd0eCe801171dFedAE50d3FE8f9D03C80F1",
            5: "0xd72301a9aB0583d5294bb4BcAfb3781B14855001",
            80001: "0x1Df991976eFA97dCE09023B702f138F30E3fC8B4",
            4002: "0x04C15309Edf4ff9fcDa1F542CddBd63684bd50f0",
            11155111: "0xB081F0D0f1eb825D0A42134ef1121dAF5321D917",
            1313161555: "0x705210d03E8585FC8FFb41D008C6b4962001E346",
            43113: "0x692d1A26B49B8417d09b9CCD510096B933c8Bc4B",
            534353: "0xEc11bA12B74E0c6215FA66334c756780C2AB3fbb",
            137: "0xc8a94a3d3d2dabc3c1caffffdca6a7543c3e3e65"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($1ca0b7eeaa1ce6da$exports))),
        decimals: {
            default: 2
        }
    },
    WETH: {
        name: "Wrapped Ether",
        ticker: "WETH",
        addresses: {
            1: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
            31337: "0xC89366f3e4C59DDBf17fb116ba9DF8bbD806338c",
            5: "0x0DAa76b8ebdAe1c170bc350c9E0eFb2C595de621",
            80001: "0x9aE88Fb19F76d07996b7d5Bc5d45E9747e6E0b31",
            4002: "0x692d1A26B49B8417d09b9CCD510096B933c8Bc4B",
            11155111: "0xa5Da2a6f19D79A88bd280d758393793d348FcD3D",
            1313161555: "0x54a2D690d06DFa62d911355F5d2f79ceA1f81C8c",
            43113: "0xa550DDe4f887Bd3B49137BAbE38BBD6bFa4e0BDA",
            534353: "0x7FDbC336F0d85BC31511fE20d582c7dCA46233e3",
            137: "0x7ceb23fd6bc0add59e62ac25578270cff1b9f619",
            56: "0x2170ed0880ac9a755fd29b2688956bd959f933f8",
            250: "0x74b23882a30290451A17c44f4F05243b6b58C76d",
            43114: "0x49D5c2BdFfac6CE2BFdB6640F4F80f226bc10bAB"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($24fa3a5fa31088bf$exports))),
        decimals: {
            default: 18
        }
    },
    WBNB: {
        name: "Wrapped BNB",
        ticker: "WBNB",
        addresses: {
            56: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($c3af053f7c3c5163$exports))),
        decimals: {
            default: 18
        }
    },
    WMATIC: {
        name: "Wrapped Polygon",
        ticker: "WMATIC",
        pricefeedTicker: "MATIC",
        addresses: {
            137: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($2954bf38f4aed119$exports))),
        decimals: {
            default: 18
        }
    },
    BAT: {
        name: "Basic Attention Token",
        ticker: "BAT",
        addresses: {
            1: "0x0d8775f648430679a709e98d2b0cb6250d2887ef",
            137: "0x3cef98bb43d732e2f285ee605a8158cde967d219",
            56: "0x101d82428437127bf1608f699cd651e6abf9766e",
            80001: "0xd445cAAbb9eA6685D3A512439256866563a16E93",
            4002: "0x5720755857EF377D59cb8758B5E3eDBC483b4467",
            11155111: "0x5D684d37922dAf7Aa2013E65A22880a11C475e25",
            1313161555: "0x8dEf8ef4ea453c4dd988c1596DD6FaDD6A291e53",
            43113: "0xABB6a5C05a70098585D095D5446b6845b57E2873"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($5d22a9b53f75b97e$exports))),
        decimals: {
            default: 18
        }
    },
    PRQ: {
        name: "Parsiq Token",
        ticker: "PRQ",
        addresses: {
            1: "0x362bc847A3a9637d3af6624EeC853618a43ed7D2"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($766dcfcaaeac16db$exports))),
        decimals: {
            default: 18
        }
    }
};
function $3e5bdbdfebaf62ee$export$257b2d10b709d8ef(address, chainId) {
    var token = Object.values($3e5bdbdfebaf62ee$export$8e1e81ac145e31be).find(function(t) {
        return Object.entries(t.addresses).find(function(param) {
            var _param = (0, $cv9Rk._)(param, 2), chain = _param[0], addr = _param[1];
            return chain.toString() === chainId.toString() && addr.toLowerCase() === address.toLowerCase();
        });
    });
    if (!token) return {
        name: "Unknown",
        ticker: "UNKNOWN",
        addresses: {},
        logo: "",
        decimals: {
            default: 18
        }
    };
    return token;
}


var $256101bd45fddc91$export$330f51eee3728a4c = [
    {
        icon: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
            style: {
                width: "inherit",
                opacity: 0.4
            },
            children: "$"
        }),
        ticker: "USD"
    },
    {
        icon: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
            style: {
                width: "inherit",
                opacity: 0.4
            },
            children: "$"
        }),
        ticker: "CAD"
    },
    {
        icon: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
            style: {
                width: "inherit",
                opacity: 0.4
            },
            children: "\xa3"
        }),
        ticker: "GBP"
    },
    {
        icon: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
            style: {
                width: "inherit",
                opacity: 0.4
            },
            children: "\u20AC"
        }),
        ticker: "EUR"
    },
    {
        icon: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("img", {
            src: (0, $3e5bdbdfebaf62ee$export$8e1e81ac145e31be).USDC.logo,
            style: {
                width: "inherit"
            }
        }),
        ticker: "USDC"
    },
    {
        icon: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("img", {
            src: (0, $3e5bdbdfebaf62ee$export$8e1e81ac145e31be).USDT.logo,
            style: {
                width: "inherit"
            }
        }),
        ticker: "USDT"
    }
];
var $256101bd45fddc91$export$413b0d1e3ece6964 = [
    "USDT",
    "USDC"
];
var $256101bd45fddc91$export$3dc27271f5d5c629 = function(currency, amount) {
    var decimals = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
    var effectiveDecimals = decimals !== undefined ? decimals : 2;
    var numericAmount = typeof amount === "number" ? amount : Number(amount);
    if (!$256101bd45fddc91$export$413b0d1e3ece6964.includes(currency)) try {
        var options = {
            style: "currency",
            currency: currency,
            minimumFractionDigits: effectiveDecimals,
            maximumFractionDigits: effectiveDecimals
        };
        var formattedAmount = Intl.NumberFormat("en-US", options).format(numericAmount).replace(/(\.\d*[1-9])0+$|\.0*$/, "$1");
        return /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
            children: formattedAmount
        });
    } catch (err) {
        return /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
            children: Intl.NumberFormat("en-US", {
                minimumFractionDigits: effectiveDecimals,
                maximumFractionDigits: effectiveDecimals
            }).format(amount)
        });
    }
    var tokenFormattedAmount = numericAmount.toFixed(effectiveDecimals).replace(/(\.\d*[1-9])0+$|\.0*$/, "$1");
    return /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
        style: {
            display: "inline-flex",
            gap: "4px"
        },
        children: [
            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                children: tokenFormattedAmount
            }),
            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                style: {
                    color: (0, $651851c7f7a4dfb5$export$8fe7e62e076ddbb5).GRAY_DARKER
                },
                children: currency
            })
        ]
    });
};
var $256101bd45fddc91$export$bc56dd87ebd6aae2 = function(currency, amount) {
    if (!$256101bd45fddc91$export$413b0d1e3ece6964.includes(currency)) try {
        return Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currency
        }).format(amount);
    } catch (err) {
        return Intl.NumberFormat("en-US").format(amount);
    }
    return "".concat(Intl.NumberFormat("en-US").format(amount), " ").concat(currency);
};



var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");
var $0807aac856fc3647$exports = {};

$parcel$export($0807aac856fc3647$exports, "create", function () { return $0807aac856fc3647$export$185802fd694ee1f5; }, function (v) { return $0807aac856fc3647$export$185802fd694ee1f5 = v; });
$parcel$export($0807aac856fc3647$exports, "toCanvas", function () { return $0807aac856fc3647$export$f87f6982d1fd4f81; }, function (v) { return $0807aac856fc3647$export$f87f6982d1fd4f81 = v; });
$parcel$export($0807aac856fc3647$exports, "toDataURL", function () { return $0807aac856fc3647$export$723e4939e5a27c8; }, function (v) { return $0807aac856fc3647$export$723e4939e5a27c8 = v; });
$parcel$export($0807aac856fc3647$exports, "toString", function () { return $0807aac856fc3647$export$f84e8e69fd4488a5; }, function (v) { return $0807aac856fc3647$export$f84e8e69fd4488a5 = v; });
var $0807aac856fc3647$export$185802fd694ee1f5;
var $0807aac856fc3647$export$f87f6982d1fd4f81;
var $0807aac856fc3647$export$723e4939e5a27c8;
// only svg for now.
var $0807aac856fc3647$export$f84e8e69fd4488a5;
var $e26c61e3366333d2$exports = {};
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
$e26c61e3366333d2$exports = function() {
    return typeof Promise === "function" && Promise.prototype && Promise.prototype.then;
};


/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $1217456071d3dc5a$export$185802fd694ee1f5;
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $4388121972c2f33e$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $4388121972c2f33e$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $4388121972c2f33e$export$ed1d66da50968976;
var $4388121972c2f33e$export$6733b14783f975c2;
var $4388121972c2f33e$export$ce5b1274f8597fa0;
var $4388121972c2f33e$export$43dd553ecded716d;
var $4388121972c2f33e$var$toSJISFunction;
var $4388121972c2f33e$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$4388121972c2f33e$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$4388121972c2f33e$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $4388121972c2f33e$var$CODEWORDS_COUNT[version];
};
$4388121972c2f33e$export$ed1d66da50968976 = function(data) {
    var digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$4388121972c2f33e$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== "function") throw new Error('"toSJISFunc" is not a valid function.');
    $4388121972c2f33e$var$toSJISFunction = f;
};
$4388121972c2f33e$export$ce5b1274f8597fa0 = function() {
    return typeof $4388121972c2f33e$var$toSJISFunction !== "undefined";
};
$4388121972c2f33e$export$43dd553ecded716d = function toSJIS(kanji) {
    return $4388121972c2f33e$var$toSJISFunction(kanji);
};


var $e9fae99c9441edbd$export$61196ced6d74a310;
var $e9fae99c9441edbd$export$3a1a48c8f6ef640e;
var $e9fae99c9441edbd$export$3722cfe417b6ed86;
var $e9fae99c9441edbd$export$7f8ddf7c7c20b3cd;
var $e9fae99c9441edbd$export$1ea939691cdc45b8;
var $e9fae99c9441edbd$export$6788812c4e6611e6;
$e9fae99c9441edbd$export$61196ced6d74a310 = {
    bit: 1
};
$e9fae99c9441edbd$export$3a1a48c8f6ef640e = {
    bit: 0
};
$e9fae99c9441edbd$export$3722cfe417b6ed86 = {
    bit: 3
};
$e9fae99c9441edbd$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $e9fae99c9441edbd$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    var lcStr = string.toLowerCase();
    switch(lcStr){
        case "l":
        case "low":
            return $e9fae99c9441edbd$export$61196ced6d74a310;
        case "m":
        case "medium":
            return $e9fae99c9441edbd$export$3a1a48c8f6ef640e;
        case "q":
        case "quartile":
            return $e9fae99c9441edbd$export$3722cfe417b6ed86;
        case "h":
        case "high":
            return $e9fae99c9441edbd$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error("Unknown EC Level: " + string);
    }
}
$e9fae99c9441edbd$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== "undefined" && level.bit >= 0 && level.bit < 4;
};
$e9fae99c9441edbd$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($e9fae99c9441edbd$export$1ea939691cdc45b8(value)) return value;
    try {
        return $e9fae99c9441edbd$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};


var $7377cb53a1712415$exports = {};
function $7377cb53a1712415$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$7377cb53a1712415$var$BitBuffer.prototype = {
    get: function get(index) {
        var bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function put(num, length) {
        for(var i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function getLengthInBits() {
        return this.length;
    },
    putBit: function putBit(bit) {
        var bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
$7377cb53a1712415$exports = $7377cb53a1712415$var$BitBuffer;


var $710c4b003760de0e$exports = {};
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $710c4b003760de0e$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $710c4b003760de0e$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    var index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $710c4b003760de0e$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $710c4b003760de0e$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $710c4b003760de0e$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
$710c4b003760de0e$exports = $710c4b003760de0e$var$BitMatrix;


/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $830d5c31c4757718$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $830d5c31c4757718$export$c39457c570f2b189;

var $830d5c31c4757718$require$getSymbolSize = $4388121972c2f33e$export$8d4a06d3facd414b;
$830d5c31c4757718$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    var posCount = Math.floor(version / 7) + 2;
    var size = $830d5c31c4757718$require$getSymbolSize(version);
    var intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    var positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(var i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$830d5c31c4757718$export$c39457c570f2b189 = function getPositions(version) {
    var coords = [];
    var pos = $830d5c31c4757718$export$cb05537eb8e57a83(version);
    var posLength = pos.length;
    for(var i = 0; i < posLength; i++)for(var j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};


/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $6284c3ff2b9856aa$export$c39457c570f2b189;

var $6284c3ff2b9856aa$require$getSymbolSize = $4388121972c2f33e$export$8d4a06d3facd414b;
var $6284c3ff2b9856aa$var$FINDER_PATTERN_SIZE = 7;
$6284c3ff2b9856aa$export$c39457c570f2b189 = function getPositions(version) {
    var size = $6284c3ff2b9856aa$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $6284c3ff2b9856aa$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $6284c3ff2b9856aa$var$FINDER_PATTERN_SIZE
        ]
    ];
};


/**
 * Data mask pattern reference
 * @type {Object}
 */ var $e54ce71b50c172e9$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $e54ce71b50c172e9$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $e54ce71b50c172e9$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $e54ce71b50c172e9$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $e54ce71b50c172e9$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $e54ce71b50c172e9$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $e54ce71b50c172e9$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $e54ce71b50c172e9$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $e54ce71b50c172e9$export$fe9625aaceb0e563;
$e54ce71b50c172e9$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ var $e54ce71b50c172e9$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$e54ce71b50c172e9$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== "" && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$e54ce71b50c172e9$export$6788812c4e6611e6 = function from(value) {
    return $e54ce71b50c172e9$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$e54ce71b50c172e9$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    var size = data.size;
    var points = 0;
    var sameCountCol = 0;
    var sameCountRow = 0;
    var lastCol = null;
    var lastRow = null;
    for(var row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(var col = 0; col < size; col++){
            var module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $e54ce71b50c172e9$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $e54ce71b50c172e9$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $e54ce71b50c172e9$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $e54ce71b50c172e9$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$e54ce71b50c172e9$export$9a9385107a518e46 = function getPenaltyN2(data) {
    var size = data.size;
    var points = 0;
    for(var row = 0; row < size - 1; row++)for(var col = 0; col < size - 1; col++){
        var last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $e54ce71b50c172e9$var$PenaltyScores.N2;
};
$e54ce71b50c172e9$export$ade754353f0dc75e = function getPenaltyN3(data) {
    var size = data.size;
    var points = 0;
    var bitsCol = 0;
    var bitsRow = 0;
    for(var row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(var col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $e54ce71b50c172e9$var$PenaltyScores.N3;
};
$e54ce71b50c172e9$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    var darkCount = 0;
    var modulesCount = data.data.length;
    for(var i = 0; i < modulesCount; i++)darkCount += data.data[i];
    var k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $e54ce71b50c172e9$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $e54ce71b50c172e9$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $e54ce71b50c172e9$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $e54ce71b50c172e9$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $e54ce71b50c172e9$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $e54ce71b50c172e9$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $e54ce71b50c172e9$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $e54ce71b50c172e9$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $e54ce71b50c172e9$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $e54ce71b50c172e9$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error("bad maskPattern:" + maskPattern);
    }
}
$e54ce71b50c172e9$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    var size = data.size;
    for(var col = 0; col < size; col++)for(var row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $e54ce71b50c172e9$var$getMaskAt(pattern, row, col));
    }
};
$e54ce71b50c172e9$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    var numPatterns = Object.keys($e54ce71b50c172e9$export$7ed115685df827af).length;
    var bestPattern = 0;
    var lowerPenalty = Infinity;
    for(var p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $e54ce71b50c172e9$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        var penalty = $e54ce71b50c172e9$export$a5fd3a02c14d0b3e(data) + $e54ce71b50c172e9$export$9a9385107a518e46(data) + $e54ce71b50c172e9$export$ade754353f0dc75e(data) + $e54ce71b50c172e9$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $e54ce71b50c172e9$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};


/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $6a48667e7ef78660$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $6a48667e7ef78660$export$683d1b3e8a1a8438;

var $6a48667e7ef78660$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
var $6a48667e7ef78660$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$6a48667e7ef78660$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $e9fae99c9441edbd$export$61196ced6d74a310:
            return $6a48667e7ef78660$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $e9fae99c9441edbd$export$3a1a48c8f6ef640e:
            return $6a48667e7ef78660$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $e9fae99c9441edbd$export$3722cfe417b6ed86:
            return $6a48667e7ef78660$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $e9fae99c9441edbd$export$7f8ddf7c7c20b3cd:
            return $6a48667e7ef78660$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$6a48667e7ef78660$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $e9fae99c9441edbd$export$61196ced6d74a310:
            return $6a48667e7ef78660$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $e9fae99c9441edbd$export$3a1a48c8f6ef640e:
            return $6a48667e7ef78660$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $e9fae99c9441edbd$export$3722cfe417b6ed86:
            return $6a48667e7ef78660$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $e9fae99c9441edbd$export$7f8ddf7c7c20b3cd:
            return $6a48667e7ef78660$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};


var $76233d0da5b0b0b7$exports = {};
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $91dbd677774fadc2$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $91dbd677774fadc2$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $91dbd677774fadc2$export$7b8be06a973a9d05;
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $458c5686b6754c1f$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $458c5686b6754c1f$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $458c5686b6754c1f$export$6e3a27864ab166fe;
var $458c5686b6754c1f$var$EXP_TABLE = new Uint8Array(512);
var $458c5686b6754c1f$var$LOG_TABLE = new Uint8Array(256) /**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */ ;
(function initTables() {
    var x = 1;
    for(var i = 0; i < 255; i++){
        $458c5686b6754c1f$var$EXP_TABLE[i] = x;
        $458c5686b6754c1f$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(var i1 = 255; i1 < 512; i1++)$458c5686b6754c1f$var$EXP_TABLE[i1] = $458c5686b6754c1f$var$EXP_TABLE[i1 - 255];
})();
$458c5686b6754c1f$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error("log(" + n + ")");
    return $458c5686b6754c1f$var$LOG_TABLE[n];
};
$458c5686b6754c1f$export$b310ec824aaee37f = function exp(n) {
    return $458c5686b6754c1f$var$EXP_TABLE[n];
};
$458c5686b6754c1f$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $458c5686b6754c1f$var$EXP_TABLE[$458c5686b6754c1f$var$LOG_TABLE[x] + $458c5686b6754c1f$var$LOG_TABLE[y]];
};


$91dbd677774fadc2$export$6e3a27864ab166fe = function mul(p1, p2) {
    var coeff = new Uint8Array(p1.length + p2.length - 1);
    for(var i = 0; i < p1.length; i++)for(var j = 0; j < p2.length; j++)coeff[i + j] ^= $458c5686b6754c1f$export$6e3a27864ab166fe(p1[i], p2[j]);
    return coeff;
};
$91dbd677774fadc2$export$842a2cf37af977e1 = function mod(divident, divisor) {
    var result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        var coeff = result[0];
        for(var i = 0; i < divisor.length; i++)result[i] ^= $458c5686b6754c1f$export$6e3a27864ab166fe(divisor[i], coeff);
        // remove all zeros from buffer head
        var offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$91dbd677774fadc2$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    var poly = new Uint8Array([
        1
    ]);
    for(var i = 0; i < degree; i++)poly = $91dbd677774fadc2$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $458c5686b6754c1f$export$b310ec824aaee37f(i)
    ]));
    return poly;
};


function $76233d0da5b0b0b7$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $76233d0da5b0b0b7$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $91dbd677774fadc2$export$7b8be06a973a9d05(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $76233d0da5b0b0b7$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error("Encoder not initialized");
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    var paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    var remainder = $91dbd677774fadc2$export$842a2cf37af977e1(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    var start = this.degree - remainder.length;
    if (start > 0) {
        var buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
$76233d0da5b0b0b7$exports = $76233d0da5b0b0b7$var$ReedSolomonEncoder;


/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $ea5bd07762a4cdd6$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $ea5bd07762a4cdd6$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $ea5bd07762a4cdd6$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $ea5bd07762a4cdd6$export$eee5438974ef6f0e;



/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $4111658940cc6571$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $4111658940cc6571$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $4111658940cc6571$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $4111658940cc6571$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $4111658940cc6571$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $4111658940cc6571$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $4111658940cc6571$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $4111658940cc6571$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $4111658940cc6571$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $4111658940cc6571$export$6788812c4e6611e6;
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $2e942a47c03f3fbe$export$1ea939691cdc45b8;
$2e942a47c03f3fbe$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};


var $2abab5f61f43837e$export$a4d452c2363c8e12;
var $2abab5f61f43837e$export$9df7c29d562bab83;
var $2abab5f61f43837e$export$8f4bf8f7eb581284;
var $2abab5f61f43837e$export$4d318981b5a83836;
var $2abab5f61f43837e$export$376a9ed239d6c1c8;
var $2abab5f61f43837e$export$175f16aef75a4569;
var $2abab5f61f43837e$export$50b7f9bf92c74274;
var $2abab5f61f43837e$export$4ba5f52893b4ac97;
var $2abab5f61f43837e$var$numeric = "[0-9]+";
var $2abab5f61f43837e$var$alphanumeric = "[A-Z $%*+\\-./:]+";
var $2abab5f61f43837e$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$2abab5f61f43837e$var$kanji = $2abab5f61f43837e$var$kanji.replace(/u/g, "\\u");
var $2abab5f61f43837e$var$byte = "(?:(?![A-Z0-9 $%*+\\-./:]|" + $2abab5f61f43837e$var$kanji + ")(?:.|[\r\n]))+";
$2abab5f61f43837e$export$a4d452c2363c8e12 = new RegExp($2abab5f61f43837e$var$kanji, "g");
$2abab5f61f43837e$export$9df7c29d562bab83 = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
$2abab5f61f43837e$export$8f4bf8f7eb581284 = new RegExp($2abab5f61f43837e$var$byte, "g");
$2abab5f61f43837e$export$4d318981b5a83836 = new RegExp($2abab5f61f43837e$var$numeric, "g");
$2abab5f61f43837e$export$376a9ed239d6c1c8 = new RegExp($2abab5f61f43837e$var$alphanumeric, "g");
var $2abab5f61f43837e$var$TEST_KANJI = new RegExp("^" + $2abab5f61f43837e$var$kanji + "$");
var $2abab5f61f43837e$var$TEST_NUMERIC = new RegExp("^" + $2abab5f61f43837e$var$numeric + "$");
var $2abab5f61f43837e$var$TEST_ALPHANUMERIC = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
$2abab5f61f43837e$export$175f16aef75a4569 = function testKanji(str) {
    return $2abab5f61f43837e$var$TEST_KANJI.test(str);
};
$2abab5f61f43837e$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $2abab5f61f43837e$var$TEST_NUMERIC.test(str);
};
$2abab5f61f43837e$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $2abab5f61f43837e$var$TEST_ALPHANUMERIC.test(str);
};


$4111658940cc6571$export$4d318981b5a83836 = {
    id: "Numeric",
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$4111658940cc6571$export$376a9ed239d6c1c8 = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$4111658940cc6571$export$8f4bf8f7eb581284 = {
    id: "Byte",
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$4111658940cc6571$export$a4d452c2363c8e12 = {
    id: "Kanji",
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$4111658940cc6571$export$bb410559a65d3418 = {
    bit: -1
};
$4111658940cc6571$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error("Invalid mode: " + mode);
    if (!$2e942a47c03f3fbe$export$1ea939691cdc45b8(version)) throw new Error("Invalid version: " + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$4111658940cc6571$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($2abab5f61f43837e$export$50b7f9bf92c74274(dataStr)) return $4111658940cc6571$export$4d318981b5a83836;
    else if ($2abab5f61f43837e$export$4ba5f52893b4ac97(dataStr)) return $4111658940cc6571$export$376a9ed239d6c1c8;
    else if ($2abab5f61f43837e$export$175f16aef75a4569(dataStr)) return $4111658940cc6571$export$a4d452c2363c8e12;
    else return $4111658940cc6571$export$8f4bf8f7eb581284;
};
$4111658940cc6571$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error("Invalid mode");
};
$4111658940cc6571$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $4111658940cc6571$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    var lcStr = string.toLowerCase();
    switch(lcStr){
        case "numeric":
            return $4111658940cc6571$export$4d318981b5a83836;
        case "alphanumeric":
            return $4111658940cc6571$export$376a9ed239d6c1c8;
        case "kanji":
            return $4111658940cc6571$export$a4d452c2363c8e12;
        case "byte":
            return $4111658940cc6571$export$8f4bf8f7eb581284;
        default:
            throw new Error("Unknown mode: " + string);
    }
}
$4111658940cc6571$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($4111658940cc6571$export$1ea939691cdc45b8(value)) return value;
    try {
        return $4111658940cc6571$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};



// Generator polynomial used to encode version information
var $ea5bd07762a4cdd6$var$G18 = 7973;
var $ea5bd07762a4cdd6$var$G18_BCH = $4388121972c2f33e$export$ed1d66da50968976($ea5bd07762a4cdd6$var$G18);
function $ea5bd07762a4cdd6$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(var currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $ea5bd07762a4cdd6$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $ea5bd07762a4cdd6$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $4111658940cc6571$export$e79764af6ffaeb8d(mode, version) + 4;
}
function $ea5bd07762a4cdd6$var$getTotalBitsFromDataArray(segments, version) {
    var totalBits = 0;
    segments.forEach(function(data) {
        var reservedBits = $ea5bd07762a4cdd6$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $ea5bd07762a4cdd6$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(var currentVersion = 1; currentVersion <= 40; currentVersion++){
        var length = $ea5bd07762a4cdd6$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $ea5bd07762a4cdd6$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $4111658940cc6571$export$bb410559a65d3418)) return currentVersion;
    }
    return undefined;
}
$ea5bd07762a4cdd6$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($2e942a47c03f3fbe$export$1ea939691cdc45b8(value)) return parseInt(value, 10);
    return defaultValue;
};
$ea5bd07762a4cdd6$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$2e942a47c03f3fbe$export$1ea939691cdc45b8(version)) throw new Error("Invalid QR Code version");
    // Use Byte mode as default
    if (typeof mode === "undefined") mode = $4111658940cc6571$export$8f4bf8f7eb581284;
    // Total codewords for this QR code version (Data + Error correction)
    var totalCodewords = $4388121972c2f33e$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    var ecTotalCodewords = $6a48667e7ef78660$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    var dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $4111658940cc6571$export$bb410559a65d3418) return dataTotalCodewordsBits;
    var usableBits = dataTotalCodewordsBits - $ea5bd07762a4cdd6$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $4111658940cc6571$export$4d318981b5a83836:
            return Math.floor(usableBits / 10 * 3);
        case $4111658940cc6571$export$376a9ed239d6c1c8:
            return Math.floor(usableBits / 11 * 2);
        case $4111658940cc6571$export$a4d452c2363c8e12:
            return Math.floor(usableBits / 13);
        case $4111658940cc6571$export$8f4bf8f7eb581284:
        default:
            return Math.floor(usableBits / 8);
    }
};
$ea5bd07762a4cdd6$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    var seg;
    var ecl = $e9fae99c9441edbd$export$6788812c4e6611e6(errorCorrectionLevel, $e9fae99c9441edbd$export$3a1a48c8f6ef640e);
    if (Array.isArray(data)) {
        if (data.length > 1) return $ea5bd07762a4cdd6$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $ea5bd07762a4cdd6$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$ea5bd07762a4cdd6$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$2e942a47c03f3fbe$export$1ea939691cdc45b8(version) || version < 7) throw new Error("Invalid QR Code version");
    var d = version << 12;
    while($4388121972c2f33e$export$ed1d66da50968976(d) - $ea5bd07762a4cdd6$var$G18_BCH >= 0)d ^= $ea5bd07762a4cdd6$var$G18 << $4388121972c2f33e$export$ed1d66da50968976(d) - $ea5bd07762a4cdd6$var$G18_BCH;
    return version << 12 | d;
};


/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $957eed2f85623c28$export$eee5438974ef6f0e;

var $957eed2f85623c28$var$G15 = 1335;
var $957eed2f85623c28$var$G15_MASK = 21522;
var $957eed2f85623c28$var$G15_BCH = $4388121972c2f33e$export$ed1d66da50968976($957eed2f85623c28$var$G15);
$957eed2f85623c28$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    var data = errorCorrectionLevel.bit << 3 | mask;
    var d = data << 10;
    while($4388121972c2f33e$export$ed1d66da50968976(d) - $957eed2f85623c28$var$G15_BCH >= 0)d ^= $957eed2f85623c28$var$G15 << $4388121972c2f33e$export$ed1d66da50968976(d) - $957eed2f85623c28$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $957eed2f85623c28$var$G15_MASK;
};



/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $840e9e003feee659$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $840e9e003feee659$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $840e9e003feee659$export$89ab1afb9839589b;

var $ecd6058578fa158a$exports = {};

function $ecd6058578fa158a$var$NumericData(data) {
    this.mode = $4111658940cc6571$export$4d318981b5a83836;
    this.data = data.toString();
}
$ecd6058578fa158a$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$ecd6058578fa158a$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$ecd6058578fa158a$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $ecd6058578fa158a$var$NumericData.getBitsLength(this.data.length);
};
$ecd6058578fa158a$var$NumericData.prototype.write = function write(bitBuffer) {
    var i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    var remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
$ecd6058578fa158a$exports = $ecd6058578fa158a$var$NumericData;


var $7660532943ce9a47$exports = {};

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ var $7660532943ce9a47$var$ALPHA_NUM_CHARS = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
];
function $7660532943ce9a47$var$AlphanumericData(data) {
    this.mode = $4111658940cc6571$export$376a9ed239d6c1c8;
    this.data = data;
}
$7660532943ce9a47$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$7660532943ce9a47$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$7660532943ce9a47$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $7660532943ce9a47$var$AlphanumericData.getBitsLength(this.data.length);
};
$7660532943ce9a47$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    var i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        var value = $7660532943ce9a47$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $7660532943ce9a47$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($7660532943ce9a47$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
$7660532943ce9a47$exports = $7660532943ce9a47$var$AlphanumericData;


var $b2130011200482ef$exports = {};

function $b2130011200482ef$var$ByteData(data) {
    this.mode = $4111658940cc6571$export$8f4bf8f7eb581284;
    if (typeof data === "string") this.data = new TextEncoder().encode(data);
    else this.data = new Uint8Array(data);
}
$b2130011200482ef$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$b2130011200482ef$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$b2130011200482ef$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $b2130011200482ef$var$ByteData.getBitsLength(this.data.length);
};
$b2130011200482ef$var$ByteData.prototype.write = function(bitBuffer) {
    for(var i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
$b2130011200482ef$exports = $b2130011200482ef$var$ByteData;


var $b0aefd2ce6ee87e3$exports = {};


function $b0aefd2ce6ee87e3$var$KanjiData(data) {
    this.mode = $4111658940cc6571$export$a4d452c2363c8e12;
    this.data = data;
}
$b0aefd2ce6ee87e3$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$b0aefd2ce6ee87e3$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$b0aefd2ce6ee87e3$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $b0aefd2ce6ee87e3$var$KanjiData.getBitsLength(this.data.length);
};
$b0aefd2ce6ee87e3$var$KanjiData.prototype.write = function(bitBuffer) {
    var i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        var value = $4388121972c2f33e$export$43dd553ecded716d(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error("Invalid SJIS character: " + this.data[i] + "\n" + "Make sure your charset is UTF-8");
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
$b0aefd2ce6ee87e3$exports = $b0aefd2ce6ee87e3$var$KanjiData;





var $67vLd = parcelRequire("67vLd");
/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $840e9e003feee659$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $840e9e003feee659$var$getSegments(regex, mode, str) {
    var segments = [];
    var result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $840e9e003feee659$var$getSegmentsFromString(dataStr) {
    var numSegs = $840e9e003feee659$var$getSegments($2abab5f61f43837e$export$4d318981b5a83836, $4111658940cc6571$export$4d318981b5a83836, dataStr);
    var alphaNumSegs = $840e9e003feee659$var$getSegments($2abab5f61f43837e$export$376a9ed239d6c1c8, $4111658940cc6571$export$376a9ed239d6c1c8, dataStr);
    var byteSegs;
    var kanjiSegs;
    if ($4388121972c2f33e$export$ce5b1274f8597fa0()) {
        byteSegs = $840e9e003feee659$var$getSegments($2abab5f61f43837e$export$8f4bf8f7eb581284, $4111658940cc6571$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = $840e9e003feee659$var$getSegments($2abab5f61f43837e$export$a4d452c2363c8e12, $4111658940cc6571$export$a4d452c2363c8e12, dataStr);
    } else {
        byteSegs = $840e9e003feee659$var$getSegments($2abab5f61f43837e$export$9df7c29d562bab83, $4111658940cc6571$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = [];
    }
    var segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $840e9e003feee659$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $4111658940cc6571$export$4d318981b5a83836:
            return $ecd6058578fa158a$exports.getBitsLength(length);
        case $4111658940cc6571$export$376a9ed239d6c1c8:
            return $7660532943ce9a47$exports.getBitsLength(length);
        case $4111658940cc6571$export$a4d452c2363c8e12:
            return $b0aefd2ce6ee87e3$exports.getBitsLength(length);
        case $4111658940cc6571$export$8f4bf8f7eb581284:
            return $b2130011200482ef$exports.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $840e9e003feee659$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        var prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $840e9e003feee659$var$buildNodes(segs) {
    var nodes = [];
    for(var i = 0; i < segs.length; i++){
        var seg = segs[i];
        switch(seg.mode){
            case $4111658940cc6571$export$4d318981b5a83836:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $4111658940cc6571$export$376a9ed239d6c1c8,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $4111658940cc6571$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $4111658940cc6571$export$376a9ed239d6c1c8:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $4111658940cc6571$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $4111658940cc6571$export$a4d452c2363c8e12:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $4111658940cc6571$export$8f4bf8f7eb581284,
                        length: $840e9e003feee659$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $4111658940cc6571$export$8f4bf8f7eb581284:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $4111658940cc6571$export$8f4bf8f7eb581284,
                        length: $840e9e003feee659$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $840e9e003feee659$var$buildGraph(nodes, version) {
    var table = {};
    var graph = {
        start: {}
    };
    var prevNodeIds = [
        "start"
    ];
    for(var i = 0; i < nodes.length; i++){
        var nodeGroup = nodes[i];
        var currentNodeIds = [];
        for(var j = 0; j < nodeGroup.length; j++){
            var node = nodeGroup[j];
            var key = "" + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(var n = 0; n < prevNodeIds.length; n++){
                var prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $840e9e003feee659$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $840e9e003feee659$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $840e9e003feee659$var$getSegmentBitsLength(node.length, node.mode) + 4 + $4111658940cc6571$export$e79764af6ffaeb8d(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(var n1 = 0; n1 < prevNodeIds.length; n1++)graph[prevNodeIds[n1]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $840e9e003feee659$var$buildSingleSegment(data, modesHint) {
    var mode;
    var bestMode = $4111658940cc6571$export$1bd4c93ffb42e55e(data);
    mode = $4111658940cc6571$export$6788812c4e6611e6(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $4111658940cc6571$export$8f4bf8f7eb581284 && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + " cannot be encoded with mode " + $4111658940cc6571$export$f84e8e69fd4488a5(mode) + ".\n Suggested mode is: " + $4111658940cc6571$export$f84e8e69fd4488a5(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $4111658940cc6571$export$a4d452c2363c8e12 && !$4388121972c2f33e$export$ce5b1274f8597fa0()) mode = $4111658940cc6571$export$8f4bf8f7eb581284;
    switch(mode){
        case $4111658940cc6571$export$4d318981b5a83836:
            return new $ecd6058578fa158a$exports(data);
        case $4111658940cc6571$export$376a9ed239d6c1c8:
            return new $7660532943ce9a47$exports(data);
        case $4111658940cc6571$export$a4d452c2363c8e12:
            return new $b0aefd2ce6ee87e3$exports(data);
        case $4111658940cc6571$export$8f4bf8f7eb581284:
            return new $b2130011200482ef$exports(data);
    }
}
$840e9e003feee659$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === "string") acc.push($840e9e003feee659$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($840e9e003feee659$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$840e9e003feee659$export$3004f64547af360e = function fromString(data, version) {
    var segs = $840e9e003feee659$var$getSegmentsFromString(data, $4388121972c2f33e$export$ce5b1274f8597fa0());
    var nodes = $840e9e003feee659$var$buildNodes(segs);
    var graph = $840e9e003feee659$var$buildGraph(nodes, version);
    var path = $67vLd.find_path(graph.map, "start", "end");
    var optimizedSegs = [];
    for(var i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $840e9e003feee659$export$571d59b505e6bb4e($840e9e003feee659$var$mergeSegments(optimizedSegs));
};
$840e9e003feee659$export$89ab1afb9839589b = function rawSplit(data) {
    return $840e9e003feee659$export$571d59b505e6bb4e($840e9e003feee659$var$getSegmentsFromString(data, $4388121972c2f33e$export$ce5b1274f8597fa0()));
};


/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $1217456071d3dc5a$var$setupFinderPattern(matrix, version) {
    var size = matrix.size;
    var pos = $6284c3ff2b9856aa$export$c39457c570f2b189(version);
    for(var i = 0; i < pos.length; i++){
        var row = pos[i][0];
        var col = pos[i][1];
        for(var r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(var c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $1217456071d3dc5a$var$setupTimingPattern(matrix) {
    var size = matrix.size;
    for(var r = 8; r < size - 8; r++){
        var value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $1217456071d3dc5a$var$setupAlignmentPattern(matrix, version) {
    var pos = $830d5c31c4757718$export$c39457c570f2b189(version);
    for(var i = 0; i < pos.length; i++){
        var row = pos[i][0];
        var col = pos[i][1];
        for(var r = -2; r <= 2; r++){
            for(var c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $1217456071d3dc5a$var$setupVersionInfo(matrix, version) {
    var size = matrix.size;
    var bits = $ea5bd07762a4cdd6$export$eee5438974ef6f0e(version);
    var row, col, mod;
    for(var i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $1217456071d3dc5a$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    var size = matrix.size;
    var bits = $957eed2f85623c28$export$eee5438974ef6f0e(errorCorrectionLevel, maskPattern);
    var i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $1217456071d3dc5a$var$setupData(matrix, data) {
    var size = matrix.size;
    var inc = -1;
    var row = size - 1;
    var bitIndex = 7;
    var byteIndex = 0;
    for(var col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(var c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                var dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $1217456071d3dc5a$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    var buffer = new $7377cb53a1712415$exports();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $4111658940cc6571$export$e79764af6ffaeb8d(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    var totalCodewords = $4388121972c2f33e$export$b05dac13c7a35c32(version);
    var ecTotalCodewords = $6a48667e7ef78660$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    var dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    var remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(var i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $1217456071d3dc5a$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $1217456071d3dc5a$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    var totalCodewords = $4388121972c2f33e$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    var ecTotalCodewords = $6a48667e7ef78660$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    var dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    var ecTotalBlocks = $6a48667e7ef78660$export$41a1fc627aca72b9(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    var blocksInGroup2 = totalCodewords % ecTotalBlocks;
    var blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    var totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    var dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    var dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    var ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    var rs = new $76233d0da5b0b0b7$exports(ecCount);
    var offset = 0;
    var dcData = new Array(ecTotalBlocks);
    var ecData = new Array(ecTotalBlocks);
    var maxDataSize = 0;
    var buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(var b = 0; b < ecTotalBlocks; b++){
        var dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    var data = new Uint8Array(totalCodewords);
    var index = 0;
    var i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $1217456071d3dc5a$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    var segments;
    if (Array.isArray(data)) segments = $840e9e003feee659$export$571d59b505e6bb4e(data);
    else if (typeof data === "string") {
        var estimatedVersion = version;
        if (!estimatedVersion) {
            var rawSegments = $840e9e003feee659$export$89ab1afb9839589b(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $ea5bd07762a4cdd6$export$264e969aa7a8ff7e(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $840e9e003feee659$export$3004f64547af360e(data, estimatedVersion || 40);
    } else throw new Error("Invalid data");
    // Get the min version that can contain data
    var bestVersion = $ea5bd07762a4cdd6$export$264e969aa7a8ff7e(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error("The amount of data is too big to be stored in a QR Code");
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + ".\n");
    var dataBits = $1217456071d3dc5a$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    var moduleCount = $4388121972c2f33e$export$8d4a06d3facd414b(version);
    var modules = new $710c4b003760de0e$exports(moduleCount);
    // Add function modules
    $1217456071d3dc5a$var$setupFinderPattern(modules, version);
    $1217456071d3dc5a$var$setupTimingPattern(modules);
    $1217456071d3dc5a$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $1217456071d3dc5a$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $1217456071d3dc5a$var$setupVersionInfo(modules, version);
    // Add data codewords
    $1217456071d3dc5a$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $e54ce71b50c172e9$export$fe9625aaceb0e563(modules, $1217456071d3dc5a$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $e54ce71b50c172e9$export$a1c9aa9c0e8ba394(maskPattern, modules);
    // Replace format info bits with correct values
    $1217456071d3dc5a$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$1217456071d3dc5a$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === "undefined" || data === "") throw new Error("No input text");
    var errorCorrectionLevel = $e9fae99c9441edbd$export$3a1a48c8f6ef640e;
    var version;
    var mask;
    if (typeof options !== "undefined") {
        // Use higher error correction level as default
        errorCorrectionLevel = $e9fae99c9441edbd$export$6788812c4e6611e6(options.errorCorrectionLevel, $e9fae99c9441edbd$export$3a1a48c8f6ef640e);
        version = $ea5bd07762a4cdd6$export$6788812c4e6611e6(options.version);
        mask = $e54ce71b50c172e9$export$6788812c4e6611e6(options.maskPattern);
        if (options.toSJISFunc) $4388121972c2f33e$export$6733b14783f975c2(options.toSJISFunc);
    }
    return $1217456071d3dc5a$var$createSymbol(data, version, errorCorrectionLevel, mask);
};


var $27310ad3139cc503$export$b3890eb0ae9dca99;
var $27310ad3139cc503$export$c3e5526bbaf70a25;
var $b15d4f7aafe3a8fa$export$d2312e68e1f5ad00;
var $b15d4f7aafe3a8fa$export$5cdac61cf538712e;
var $b15d4f7aafe3a8fa$export$c3a1a1f268a8142b;
var $b15d4f7aafe3a8fa$export$83136f57c739c5f3;
function $b15d4f7aafe3a8fa$var$hex2rgba(hex) {
    if (typeof hex === "number") hex = hex.toString();
    if (typeof hex !== "string") throw new Error("Color should be defined as hex string");
    var hexCode = hex.slice().replace("#", "").split("");
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error("Invalid hex color: " + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push("F", "F");
    var hexValue = parseInt(hexCode.join(""), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: "#" + hexCode.slice(0, 6).join("")
    };
}
$b15d4f7aafe3a8fa$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    var margin = typeof options.margin === "undefined" || options.margin === null || options.margin < 0 ? 4 : options.margin;
    var width = options.width && options.width >= 21 ? options.width : undefined;
    var scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $b15d4f7aafe3a8fa$var$hex2rgba(options.color.dark || "#000000ff"),
            light: $b15d4f7aafe3a8fa$var$hex2rgba(options.color.light || "#ffffffff")
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$b15d4f7aafe3a8fa$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$b15d4f7aafe3a8fa$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    var scale = $b15d4f7aafe3a8fa$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$b15d4f7aafe3a8fa$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    var size = qr.modules.size;
    var data = qr.modules.data;
    var scale = $b15d4f7aafe3a8fa$export$5cdac61cf538712e(size, opts);
    var symbolSize = Math.floor((size + opts.margin * 2) * scale);
    var scaledMargin = opts.margin * scale;
    var palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(var i = 0; i < symbolSize; i++)for(var j = 0; j < symbolSize; j++){
        var posDst = (i * symbolSize + j) * 4;
        var pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            var iSrc = Math.floor((i - scaledMargin) / scale);
            var jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};


function $27310ad3139cc503$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + "px";
    canvas.style.width = size + "px";
}
function $27310ad3139cc503$var$getCanvasElement() {
    try {
        return document.createElement("canvas");
    } catch (e) {
        throw new Error("You need to specify a canvas element");
    }
}
$27310ad3139cc503$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    var opts = options;
    var canvasEl = canvas;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $27310ad3139cc503$var$getCanvasElement();
    opts = $b15d4f7aafe3a8fa$export$d2312e68e1f5ad00(opts);
    var size = $b15d4f7aafe3a8fa$export$c3a1a1f268a8142b(qrData.modules.size, opts);
    var ctx = canvasEl.getContext("2d");
    var image = ctx.createImageData(size, size);
    $b15d4f7aafe3a8fa$export$83136f57c739c5f3(image.data, qrData, opts);
    $27310ad3139cc503$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$27310ad3139cc503$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    var opts = options;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    var canvasEl = $27310ad3139cc503$export$b3890eb0ae9dca99(qrData, canvas, opts);
    var type = opts.type || "image/png";
    var rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};


var $990e140f762b1e2f$export$b3890eb0ae9dca99;

function $990e140f762b1e2f$var$getColorAttrib(color, attrib) {
    var alpha = color.a / 255;
    var str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + " " + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $990e140f762b1e2f$var$svgCmd(cmd, x, y) {
    var str = cmd + x;
    if (typeof y !== "undefined") str += " " + y;
    return str;
}
function $990e140f762b1e2f$var$qrToPath(data, size, margin) {
    var path = "";
    var moveBy = 0;
    var newRow = false;
    var lineLength = 0;
    for(var i = 0; i < data.length; i++){
        var col = Math.floor(i % size);
        var row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $990e140f762b1e2f$var$svgCmd("M", col + margin, 0.5 + row + margin) : $990e140f762b1e2f$var$svgCmd("m", moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $990e140f762b1e2f$var$svgCmd("h", lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$990e140f762b1e2f$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    var opts = $b15d4f7aafe3a8fa$export$d2312e68e1f5ad00(options);
    var size = qrData.modules.size;
    var data = qrData.modules.data;
    var qrcodesize = size + opts.margin * 2;
    var bg = !opts.color.light.a ? "" : "<path " + $990e140f762b1e2f$var$getColorAttrib(opts.color.light, "fill") + ' d="M0 0h' + qrcodesize + "v" + qrcodesize + 'H0z"/>';
    var path = "<path " + $990e140f762b1e2f$var$getColorAttrib(opts.color.dark, "stroke") + ' d="' + $990e140f762b1e2f$var$qrToPath(data, size, opts.margin) + '"/>';
    var viewBox = 'viewBox="0 0 ' + qrcodesize + " " + qrcodesize + '"';
    var width = !opts.width ? "" : 'width="' + opts.width + '" height="' + opts.width + '" ';
    var svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + "</svg>\n";
    if (typeof cb === "function") cb(null, svgTag);
    return svgTag;
};


function $0807aac856fc3647$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    var args = [].slice.call(arguments, 1);
    var argsNum = args.length;
    var isLastArgCb = typeof args[argsNum - 1] === "function";
    if (!isLastArgCb && !$e26c61e3366333d2$exports()) throw new Error("Callback required as last argument");
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error("Too few arguments provided");
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === "undefined") {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error("Too few arguments provided");
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                var data = $1217456071d3dc5a$export$185802fd694ee1f5(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        var data = $1217456071d3dc5a$export$185802fd694ee1f5(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$0807aac856fc3647$export$185802fd694ee1f5 = $1217456071d3dc5a$export$185802fd694ee1f5;
$0807aac856fc3647$export$f87f6982d1fd4f81 = $0807aac856fc3647$var$renderCanvas.bind(null, $27310ad3139cc503$export$b3890eb0ae9dca99);
$0807aac856fc3647$export$723e4939e5a27c8 = $0807aac856fc3647$var$renderCanvas.bind(null, $27310ad3139cc503$export$c3e5526bbaf70a25);
$0807aac856fc3647$export$f84e8e69fd4488a5 = $0807aac856fc3647$var$renderCanvas.bind(null, function(data, _, opts) {
    return $990e140f762b1e2f$export$b3890eb0ae9dca99(data, opts);
});




var $bRSDw = parcelRequire("bRSDw");

function $b1e23f0d09f654a9$export$642c4e67bbdc0bc7(ether) {
    var unit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "wei";
    return (0, $5e268930465d8d42$export$203ae30b4f6490b3)(ether, (0, $bRSDw.etherUnits)[unit]);
}


function $c52b579c7e92ba59$var$loadImage(src) {
    return $c52b579c7e92ba59$var$_loadImage.apply(this, arguments);
}
function $c52b579c7e92ba59$var$_loadImage() {
    $c52b579c7e92ba59$var$_loadImage = (0, $kSuI9._)(function(src) {
        var image;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    image = new Image();
                    image.crossOrigin = "anonymous";
                    return [
                        4,
                        new Promise(function(resolve) {
                            image.onload = function() {
                                resolve(image);
                            };
                            image.src = src;
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return $c52b579c7e92ba59$var$_loadImage.apply(this, arguments);
}
function $c52b579c7e92ba59$export$45312203e6f4f22c(paymentMethodDetails) {
    return $c52b579c7e92ba59$var$_generateQRCode.apply(this, arguments);
}
function $c52b579c7e92ba59$var$_generateQRCode() {
    $c52b579c7e92ba59$var$_generateQRCode = (0, $kSuI9._)(function(paymentMethodDetails) {
        var darkColor, lightColor, drawRadius, _paymentMethod_tokenInfo, dataUrl, network, token, paymentAddress, amount, paymentMethod, _paymentMethod_tokenInfo1, tokenAddress, chainId, decimals, _paymentMethod_tokenInfo2, tokenAddress1, decimals1, cluster, _paymentMethod_tokenInfo3, tokenAddress2, decimals2, width, height, canvas, ctx, img, maxLogoSize, outlineSize, imgMax, imgWidth, imgHeight, centerX, centerY, chainImage, chainImgMax, chainImgWidth, chainImgHeight, imgMax1, imgWidth1, imgHeight1, centerX1, centerY1, newImg;
        var _arguments = arguments;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    darkColor = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "#000000", lightColor = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "#ffffff", drawRadius = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : true;
                    dataUrl = "";
                    network = paymentMethodDetails.network, token = paymentMethodDetails.token, paymentAddress = paymentMethodDetails.paymentAddress, amount = paymentMethodDetails.amount;
                    paymentMethod = (0, $7228c3dac31e12e0$export$8793fab959da70d1)(network, token);
                    switch(paymentMethod.name){
                        case "Bitcoin":
                        case "BitcoinTestnet":
                            dataUrl = "bitcoin:".concat(paymentAddress, "?value=").concat(amount);
                            break;
                        case "Litecoin":
                            dataUrl = "litecoin:".concat(paymentAddress, "}?amount=").concat(amount);
                            break;
                        case "Ethereum":
                        case "SepoliaTestnet":
                        case "Polygon":
                        case "PolygonTestnet":
                        case "BNB":
                        case "BNBTestnet":
                        case "Arbitrum":
                        case "Avalanche":
                        case "Base":
                        case "ArbitrumTestnet":
                            dataUrl = "ethereum:".concat(paymentAddress, "?value=").concat((0, $b1e23f0d09f654a9$export$642c4e67bbdc0bc7)(amount));
                            break;
                        case "SolanaDevnet":
                        case "SolanaTestnet":
                        case "Solana":
                            dataUrl = "solana:".concat(paymentAddress, "?value=").concat(amount);
                            break;
                        case "Zcash":
                        case "ZcashTestnet":
                            dataUrl = "zcash:".concat(paymentAddress, "?value=").concat(amount);
                            break;
                        case "Dogecoin":
                            dataUrl = "dogecoin:".concat(paymentAddress, "?value=").concat(amount);
                            break;
                        case "Tron":
                        case "TronTestnet":
                            dataUrl = "tron:".concat(paymentAddress, "?value=").concat((0, $5e268930465d8d42$export$203ae30b4f6490b3)(amount, 6));
                            break;
                        case "PolkadotTestnet":
                        case "Polkadot":
                            dataUrl = paymentAddress;
                            break;
                    }
                    switch((_paymentMethod_tokenInfo = paymentMethod.tokenInfo) === null || _paymentMethod_tokenInfo === void 0 ? void 0 : _paymentMethod_tokenInfo.networkName){
                        case "Ethereum":
                        case "SepoliaTestnet":
                        case "Polygon":
                        case "PolygonTestnet":
                        case "BNB":
                        case "BNBTestnet":
                        case "Arbitrum":
                        case "Avalanche":
                        case "Base":
                        case "ArbitrumTestnet":
                            {
                                _paymentMethod_tokenInfo1 = paymentMethod.tokenInfo, tokenAddress = _paymentMethod_tokenInfo1.tokenAddress, chainId = _paymentMethod_tokenInfo1.chainId, decimals = _paymentMethod_tokenInfo1.decimals;
                                dataUrl = "ethereum:".concat(tokenAddress, "@").concat(chainId, "/transfer?address=").concat(paymentAddress, "&uint256=").concat((0, $5e268930465d8d42$export$203ae30b4f6490b3)(amount, decimals));
                                break;
                            }
                        case "Solana":
                        case "SolanaDevnet":
                        case "SolanaTestnet":
                            {
                                _paymentMethod_tokenInfo2 = paymentMethod.tokenInfo, tokenAddress1 = _paymentMethod_tokenInfo2.tokenAddress, decimals1 = _paymentMethod_tokenInfo2.decimals, cluster = _paymentMethod_tokenInfo2.cluster;
                                dataUrl = "solana:".concat(tokenAddress1, "@").concat(cluster, "/transfer?address=").concat(paymentAddress, "&uint256=").concat((0, $5e268930465d8d42$export$203ae30b4f6490b3)(amount, decimals1));
                                break;
                            }
                        case "Tron":
                        case "TronTestnet":
                            {
                                _paymentMethod_tokenInfo3 = paymentMethod.tokenInfo, tokenAddress2 = _paymentMethod_tokenInfo3.tokenAddress, decimals2 = _paymentMethod_tokenInfo3.decimals;
                                dataUrl = "tron:".concat(tokenAddress2, "/transfer?address=").concat(paymentAddress, "&uint256=").concat((0, $5e268930465d8d42$export$203ae30b4f6490b3)(amount, decimals2));
                            }
                    }
                    width = 500;
                    height = 500;
                    canvas = document.createElement("canvas");
                    canvas.width = width;
                    canvas.height = height;
                    (0, (/*@__PURE__*/$parcel$interopDefault($0807aac856fc3647$exports))).toCanvas(canvas, dataUrl, {
                        errorCorrectionLevel: "H",
                        margin: 1,
                        color: {
                            dark: darkColor,
                            light: lightColor
                        },
                        width: 500
                    });
                    ctx = canvas.getContext("2d");
                    if (!!ctx) return [
                        3,
                        2
                    ];
                    console.error("Failed to get canvas");
                    return [
                        4,
                        Promise.reject(new Error("Failed to get canvas context"))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    return [
                        4,
                        $c52b579c7e92ba59$var$loadImage(paymentMethod.qrCodeImage || paymentMethod.logo)
                    ];
                case 3:
                    img = _state.sent();
                    maxLogoSize = 100;
                    ctx.beginPath();
                    ctx.fillStyle = "#ffffff";
                    outlineSize = 20;
                    if (!paymentMethod.tokenInfo) return [
                        3,
                        5
                    ];
                    imgMax = Math.max(img.width, img.height);
                    imgWidth = img.width / imgMax * maxLogoSize;
                    imgHeight = img.height / imgMax * maxLogoSize;
                    centerX = (500 - imgWidth) / 2;
                    centerY = (500 - imgHeight) / 2;
                    if (drawRadius && ctx.roundRect) {
                        ctx.roundRect(200 - outlineSize / 2, 200 - outlineSize / 2, maxLogoSize + outlineSize, maxLogoSize + outlineSize, 90);
                        ctx.fill();
                    }
                    return [
                        4,
                        $c52b579c7e92ba59$var$loadImage(paymentMethod.tokenInfo.logo)
                    ];
                case 4:
                    chainImage = _state.sent();
                    chainImgMax = Math.max(chainImage.width, chainImage.height);
                    chainImgWidth = chainImage.width / chainImgMax * maxLogoSize / 2;
                    chainImgHeight = chainImage.height / chainImgMax * maxLogoSize / 2;
                    if (drawRadius && ctx.roundRect) {
                        ctx.roundRect(centerX + maxLogoSize / 2 + outlineSize - 14, centerX + maxLogoSize / 2 + outlineSize - 14, 70, 70, 90);
                        ctx.fill();
                    }
                    ctx.drawImage(img, centerX, centerY, imgWidth, imgHeight);
                    ctx.drawImage(chainImage, centerX + maxLogoSize / 2 + outlineSize + (Math.max(chainImgWidth, chainImgHeight) - chainImgWidth) / 2, centerY + maxLogoSize / 2 + outlineSize + (Math.max(chainImgWidth, chainImgHeight) - chainImgHeight) / 2, chainImgWidth, chainImgHeight);
                    return [
                        3,
                        6
                    ];
                case 5:
                    imgMax1 = Math.max(img.width, img.height);
                    imgWidth1 = img.width / imgMax1 * maxLogoSize;
                    imgHeight1 = img.height / imgMax1 * maxLogoSize;
                    centerX1 = (500 - imgWidth1) / 2;
                    centerY1 = (500 - imgHeight1) / 2;
                    if (drawRadius && ctx.roundRect) {
                        ctx.roundRect(200 - outlineSize / 2, 200 - outlineSize / 2, maxLogoSize + outlineSize, maxLogoSize + outlineSize, 90);
                        ctx.fill();
                    }
                    ctx.drawImage(img, centerX1, centerY1, imgWidth1, imgHeight1);
                    _state.label = 6;
                case 6:
                    newImg = canvas.toDataURL("image/png");
                    return [
                        2,
                        [
                            newImg,
                            dataUrl
                        ]
                    ];
            }
        });
    });
    return $c52b579c7e92ba59$var$_generateQRCode.apply(this, arguments);
}




var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");



var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $f3VZN = parcelRequire("f3VZN");
function $2800daeb2928d97c$export$e648161d6b1bb565(client, _) {
    return $2800daeb2928d97c$var$_addChain.apply(this, arguments);
}
function $2800daeb2928d97c$var$_addChain() {
    $2800daeb2928d97c$var$_addChain = (0, $kSuI9._)(function(client, param) {
        var chain, id, name, nativeCurrency, rpcUrls, blockExplorers;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    chain = param.chain;
                    id = chain.id, name = chain.name, nativeCurrency = chain.nativeCurrency, rpcUrls = chain.rpcUrls, blockExplorers = chain.blockExplorers;
                    return [
                        4,
                        client.request({
                            method: "wallet_addEthereumChain",
                            params: [
                                {
                                    chainId: (0, $f3VZN.numberToHex)(id),
                                    chainName: name,
                                    nativeCurrency: nativeCurrency,
                                    rpcUrls: rpcUrls.default.http,
                                    blockExplorerUrls: blockExplorers ? Object.values(blockExplorers).map(function(param) {
                                        var url = param.url;
                                        return url;
                                    }) : undefined
                                }
                            ]
                        }, {
                            dedupe: true,
                            retryCount: 0
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $2800daeb2928d97c$var$_addChain.apply(this, arguments);
}



var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");

var $af8cf = parcelRequire("af8cf");

function $21a15c5231ebcaa1$export$46c7a79747abe6a9(walletClient, parameters) {
    var abi = parameters.abi, args = parameters.args, bytecode = parameters.bytecode, request = (0, $dRLPW._)(parameters, [
        "abi",
        "args",
        "bytecode"
    ]);
    var calldata = (0, $af8cf.encodeDeployData)({
        abi: abi,
        args: args,
        bytecode: bytecode
    });
    return (0, $49da3b39ba760adb$export$8e0e7ffc78696d30)(walletClient, (0, $cxjpp._)((0, $do9pw._)({}, request), {
        data: calldata
    }));
}



var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $8zfHX = parcelRequire("8zfHX");
function $6a141c5cc87e7c06$export$17d5f00cfd692b8a(client) {
    return $6a141c5cc87e7c06$var$_getAddresses.apply(this, arguments);
}
function $6a141c5cc87e7c06$var$_getAddresses() {
    $6a141c5cc87e7c06$var$_getAddresses = (0, $kSuI9._)(function(client) {
        var _client_account, addresses;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (((_client_account = client.account) === null || _client_account === void 0 ? void 0 : _client_account.type) === "local") return [
                        2,
                        [
                            client.account.address
                        ]
                    ];
                    return [
                        4,
                        client.request({
                            method: "eth_accounts"
                        }, {
                            dedupe: true
                        })
                    ];
                case 1:
                    addresses = _state.sent();
                    return [
                        2,
                        addresses.map(function(address) {
                            return (0, $8zfHX.checksumAddress)(address);
                        })
                    ];
            }
        });
    });
    return $6a141c5cc87e7c06$var$_getAddresses.apply(this, arguments);
}


/**
 * Gets the wallets current permissions.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/getPermissions
 * - JSON-RPC Methods: [`wallet_getPermissions`](https://eips.ethereum.org/EIPS/eip-2255)
 *
 * @param client - Client to use
 * @returns The wallet permissions. {@link GetPermissionsReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getPermissions } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const permissions = await getPermissions(client)
 */ 
var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");
function $0ab8697b6a32921a$export$e10fd44ca431fa8e(client) {
    return $0ab8697b6a32921a$var$_getPermissions.apply(this, arguments);
}
function $0ab8697b6a32921a$var$_getPermissions() {
    $0ab8697b6a32921a$var$_getPermissions = (0, $kSuI9._)(function(client) {
        var permissions;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        client.request({
                            method: "wallet_getPermissions"
                        }, {
                            dedupe: true
                        })
                    ];
                case 1:
                    permissions = _state.sent();
                    return [
                        2,
                        permissions
                    ];
            }
        });
    });
    return $0ab8697b6a32921a$var$_getPermissions.apply(this, arguments);
}




var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $8zfHX = parcelRequire("8zfHX");
function $d73b9b549067a28c$export$87c5bcc1dede6f06(client) {
    return $d73b9b549067a28c$var$_requestAddresses.apply(this, arguments);
}
function $d73b9b549067a28c$var$_requestAddresses() {
    $d73b9b549067a28c$var$_requestAddresses = (0, $kSuI9._)(function(client) {
        var addresses;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        client.request({
                            method: "eth_requestAccounts"
                        }, {
                            dedupe: true,
                            retryCount: 0
                        })
                    ];
                case 1:
                    addresses = _state.sent();
                    return [
                        2,
                        addresses.map(function(address) {
                            return (0, $8zfHX.getAddress)(address);
                        })
                    ];
            }
        });
    });
    return $d73b9b549067a28c$var$_requestAddresses.apply(this, arguments);
}


/**
 * Requests permissions for a wallet.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/requestPermissions
 * - JSON-RPC Methods: [`wallet_requestPermissions`](https://eips.ethereum.org/EIPS/eip-2255)
 *
 * @param client - Client to use
 * @param parameters - {@link RequestPermissionsParameters}
 * @returns The wallet permissions. {@link RequestPermissionsReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { requestPermissions } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const permissions = await requestPermissions(client, {
 *   eth_accounts: {}
 * })
 */ 
var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");
function $d178e5b64ddffbc6$export$8cec5d3683c6896e(client, permissions) {
    return $d178e5b64ddffbc6$var$_requestPermissions.apply(this, arguments);
}
function $d178e5b64ddffbc6$var$_requestPermissions() {
    $d178e5b64ddffbc6$var$_requestPermissions = (0, $kSuI9._)(function(client, permissions) {
        return (0, $eha6O.__generator)(this, function(_state) {
            return [
                2,
                client.request({
                    method: "wallet_requestPermissions",
                    params: [
                        permissions
                    ]
                }, {
                    retryCount: 0
                })
            ];
        });
    });
    return $d178e5b64ddffbc6$var$_requestPermissions.apply(this, arguments);
}






var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");

var $eha6O = parcelRequire("eha6O");

var $l2YyF = parcelRequire("l2YyF");



var $f3VZN = parcelRequire("f3VZN");

var $17do3 = parcelRequire("17do3");


var $p2XJW = parcelRequire("p2XJW");

function $8d80aa1ba7facbfa$export$6ad02cc4966b42ab(client, parameters) {
    return $8d80aa1ba7facbfa$var$_signTransaction.apply(this, arguments);
}
function $8d80aa1ba7facbfa$var$_signTransaction() {
    $8d80aa1ba7facbfa$var$_signTransaction = (0, $kSuI9._)(function(client, parameters) {
        var _client_chain, _formatters_transactionRequest, _client_chain_serializers, _client_chain1, tmp, account_, _parameters_chain, chain, transaction, account, chainId, formatters, format;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    tmp = parameters.account, account_ = tmp === void 0 ? client.account : tmp, _parameters_chain = parameters.chain, chain = _parameters_chain === void 0 ? client.chain : _parameters_chain, transaction = (0, $dRLPW._)(parameters, [
                        "account",
                        "chain"
                    ]);
                    if (!account_) throw new (0, $58c5ed114b2c2f06$export$62ee6b05f0767f28)({
                        docsPath: "/docs/actions/wallet/signTransaction"
                    });
                    account = (0, $l2YyF.parseAccount)(account_);
                    (0, $p2XJW.assertRequest)((0, $do9pw._)({
                        account: account
                    }, parameters));
                    return [
                        4,
                        (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $3f6367ac0fc6b0ac$export$850fa7b3891187c), "getChainId")({})
                    ];
                case 1:
                    chainId = _state.sent();
                    if (chain !== null) (0, $365b5cac335d0771$export$390d312ab46d0597)({
                        currentChainId: chainId,
                        chain: chain
                    });
                    formatters = (chain === null || chain === void 0 ? void 0 : chain.formatters) || ((_client_chain = client.chain) === null || _client_chain === void 0 ? void 0 : _client_chain.formatters);
                    format = (formatters === null || formatters === void 0 ? void 0 : (_formatters_transactionRequest = formatters.transactionRequest) === null || _formatters_transactionRequest === void 0 ? void 0 : _formatters_transactionRequest.format) || (0, $17do3.formatTransactionRequest);
                    if (account.signTransaction) return [
                        2,
                        account.signTransaction((0, $cxjpp._)((0, $do9pw._)({}, transaction), {
                            chainId: chainId
                        }), {
                            serializer: (_client_chain1 = client.chain) === null || _client_chain1 === void 0 ? void 0 : (_client_chain_serializers = _client_chain1.serializers) === null || _client_chain_serializers === void 0 ? void 0 : _client_chain_serializers.transaction
                        })
                    ];
                    return [
                        4,
                        client.request({
                            method: "eth_signTransaction",
                            params: [
                                (0, $cxjpp._)((0, $do9pw._)({}, format(transaction)), {
                                    chainId: (0, $f3VZN.numberToHex)(chainId),
                                    from: account.address
                                })
                            ]
                        }, {
                            retryCount: 0
                        })
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return $8d80aa1ba7facbfa$var$_signTransaction.apply(this, arguments);
}



var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $eha6O = parcelRequire("eha6O");

var $l2YyF = parcelRequire("l2YyF");


var $do9pw = parcelRequire("do9pw");

var $cv9Rk = parcelRequire("cv9Rk");

var $l0HdX = parcelRequire("l0HdX");

var $fLalY = parcelRequire("fLalY");

var $5YJl8 = parcelRequire("5YJl8");

var $7deC8 = parcelRequire("7deC8");

var $dfJGH = parcelRequire("dfJGH");

var $f3VZN = parcelRequire("f3VZN");
var $50a07fe8038a9f99$export$6cd562aaf6380f0e = /^(.*)\[([0-9]*)\]$/;
var $50a07fe8038a9f99$export$94d7303c0d9f263a = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/;
var $50a07fe8038a9f99$export$45902cc189596eef = /^(u?int)(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;


// Implementation forked and adapted from https://github.com/MetaMask/eth-sig-util/blob/main/src/sign-typed-data.ts

var $do9pw = parcelRequire("do9pw");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $iL62l = parcelRequire("iL62l");

var $ewLmX = parcelRequire("ewLmX");

var $f3VZN = parcelRequire("f3VZN");

var $h0UKT = parcelRequire("h0UKT");

function $e3ab2e296963b97e$export$9e2bd399d9aaab56(parameters) {
    var _parameters_domain = parameters.domain, domain = _parameters_domain === void 0 ? {} : _parameters_domain, message = parameters.message, primaryType = parameters.primaryType;
    var types = (0, $do9pw._)({
        EIP712Domain: (0, $7c3a5ba88e091414$export$6a292159484ee032)({
            domain: domain
        })
    }, parameters.types);
    // Need to do a runtime validation check on addresses, byte ranges, integer ranges, etc
    // as we can't statically check this with TypeScript.
    (0, $7c3a5ba88e091414$export$fac174f558903e26)({
        domain: domain,
        message: message,
        primaryType: primaryType,
        types: types
    });
    var parts = [
        "0x1901"
    ];
    if (domain) parts.push($e3ab2e296963b97e$export$d4e887b08c47faea({
        domain: domain,
        types: types
    }));
    if (primaryType !== "EIP712Domain") parts.push($e3ab2e296963b97e$export$4b8f67c208624fdf({
        data: message,
        primaryType: primaryType,
        types: types
    }));
    return (0, $h0UKT.keccak256)((0, $ewLmX.concat)(parts));
}
function $e3ab2e296963b97e$export$d4e887b08c47faea(param) {
    var domain = param.domain, types = param.types;
    return $e3ab2e296963b97e$export$4b8f67c208624fdf({
        data: domain,
        primaryType: "EIP712Domain",
        types: types
    });
}
function $e3ab2e296963b97e$export$4b8f67c208624fdf(param) {
    var data = param.data, primaryType = param.primaryType, types = param.types;
    var encoded = $e3ab2e296963b97e$var$encodeData({
        data: data,
        primaryType: primaryType,
        types: types
    });
    return (0, $h0UKT.keccak256)(encoded);
}
function $e3ab2e296963b97e$var$encodeData(param) {
    var data = param.data, primaryType = param.primaryType, types = param.types;
    var encodedTypes = [
        {
            type: "bytes32"
        }
    ];
    var encodedValues = [
        $e3ab2e296963b97e$var$hashType({
            primaryType: primaryType,
            types: types
        })
    ];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = types[primaryType][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var field = _step.value;
            var _encodeField = (0, $cv9Rk._)($e3ab2e296963b97e$var$encodeField({
                types: types,
                name: field.name,
                type: field.type,
                value: data[field.name]
            }), 2), type = _encodeField[0], value = _encodeField[1];
            encodedTypes.push(type);
            encodedValues.push(value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return (0, $iL62l.encodeAbiParameters)(encodedTypes, encodedValues);
}
function $e3ab2e296963b97e$var$hashType(param) {
    var primaryType = param.primaryType, types = param.types;
    var encodedHashType = (0, $f3VZN.toHex)($e3ab2e296963b97e$export$432cbecf661dce2b({
        primaryType: primaryType,
        types: types
    }));
    return (0, $h0UKT.keccak256)(encodedHashType);
}
function $e3ab2e296963b97e$export$432cbecf661dce2b(param) {
    var primaryType = param.primaryType, types = param.types;
    var result = "";
    var unsortedDeps = $e3ab2e296963b97e$var$findTypeDependencies({
        primaryType: primaryType,
        types: types
    });
    unsortedDeps.delete(primaryType);
    var deps = [
        primaryType
    ].concat((0, $c6Xmf._)(Array.from(unsortedDeps).sort()));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = deps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var type = _step.value;
            result += "".concat(type, "(").concat(types[type].map(function(param) {
                var name = param.name, t = param.type;
                return "".concat(t, " ").concat(name);
            }).join(","), ")");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
}
function $e3ab2e296963b97e$var$findTypeDependencies(param) {
    var primaryType_ = param.primaryType, types = param.types, results = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Set();
    var match = primaryType_.match(RegExp("^\\w*", "u"));
    var primaryType = match === null || match === void 0 ? void 0 : match[0];
    if (results.has(primaryType) || types[primaryType] === undefined) return results;
    results.add(primaryType);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = types[primaryType][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var field = _step.value;
            $e3ab2e296963b97e$var$findTypeDependencies({
                primaryType: field.type,
                types: types
            }, results);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return results;
}
function $e3ab2e296963b97e$var$encodeField(param) {
    var types = param.types, name = param.name, type = param.type, value = param.value;
    if (types[type] !== undefined) return [
        {
            type: "bytes32"
        },
        (0, $h0UKT.keccak256)($e3ab2e296963b97e$var$encodeData({
            data: value,
            primaryType: type,
            types: types
        }))
    ];
    if (type === "bytes") {
        var prepend = value.length % 2 ? "0" : "";
        value = "0x".concat(prepend + value.slice(2));
        return [
            {
                type: "bytes32"
            },
            (0, $h0UKT.keccak256)(value)
        ];
    }
    if (type === "string") return [
        {
            type: "bytes32"
        },
        (0, $h0UKT.keccak256)((0, $f3VZN.toHex)(value))
    ];
    if (type.lastIndexOf("]") === type.length - 1) {
        var parsedType = type.slice(0, type.lastIndexOf("["));
        var typeValuePairs = value.map(function(item) {
            return $e3ab2e296963b97e$var$encodeField({
                name: name,
                type: parsedType,
                types: types,
                value: item
            });
        });
        return [
            {
                type: "bytes32"
            },
            (0, $h0UKT.keccak256)((0, $iL62l.encodeAbiParameters)(typeValuePairs.map(function(param) {
                var _param = (0, $cv9Rk._)(param, 1), t = _param[0];
                return t;
            }), typeValuePairs.map(function(param) {
                var _param = (0, $cv9Rk._)(param, 2), v = _param[1];
                return v;
            })))
        ];
    }
    return [
        {
            type: type
        },
        value
    ];
}



var $lUgMT = parcelRequire("lUgMT");
function $7c3a5ba88e091414$export$ce8e1cf733064451(parameters) {
    var domain_ = parameters.domain, message_ = parameters.message, primaryType = parameters.primaryType, types = parameters.types;
    var normalizeData = function(struct, data_) {
        var data = (0, $do9pw._)({}, data_);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = struct[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var param = _step.value;
                var name = param.name, type = param.type;
                if (type === "address") data[name] = data[name].toLowerCase();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return data;
    };
    var domain = function() {
        if (!types.EIP712Domain) return {};
        if (!domain_) return {};
        return normalizeData(types.EIP712Domain, domain_);
    }();
    var message = function() {
        if (primaryType === "EIP712Domain") return undefined;
        return normalizeData(types[primaryType], message_);
    }();
    return (0, $lUgMT.stringify)({
        domain: domain,
        message: message,
        primaryType: primaryType,
        types: types
    });
}
function $7c3a5ba88e091414$export$fac174f558903e26(parameters) {
    var domain = parameters.domain, message = parameters.message, primaryType = parameters.primaryType, types = parameters.types;
    var validateData = function(struct, data) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = struct[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var param = _step.value;
                var name = param.name, type = param.type;
                var value = data[name];
                var integerMatch = type.match((0, $50a07fe8038a9f99$export$45902cc189596eef));
                if (integerMatch && (typeof value === "number" || (typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value)) === "bigint")) {
                    var _integerMatch = (0, $cv9Rk._)(integerMatch, 3), _type = _integerMatch[0], base = _integerMatch[1], size_ = _integerMatch[2];
                    // If number cannot be cast to a sized hex value, it is out of range
                    // and will throw.
                    (0, $f3VZN.numberToHex)(value, {
                        signed: base === "int",
                        size: Number.parseInt(size_) / 8
                    });
                }
                if (type === "address" && typeof value === "string" && !(0, $7deC8.isAddress)(value)) throw new (0, $5YJl8.InvalidAddressError)({
                    address: value
                });
                var bytesMatch = type.match((0, $50a07fe8038a9f99$export$94d7303c0d9f263a));
                if (bytesMatch) {
                    var _bytesMatch = (0, $cv9Rk._)(bytesMatch, 2), _type1 = _bytesMatch[0], size_1 = _bytesMatch[1];
                    if (size_1 && (0, $dfJGH.size)(value) !== Number.parseInt(size_1)) throw new (0, $fLalY.BytesSizeMismatchError)({
                        expectedSize: Number.parseInt(size_1),
                        givenSize: (0, $dfJGH.size)(value)
                    });
                }
                var _$struct = types[type];
                if (_$struct) validateData(_$struct, value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    // Validate domain types.
    if (types.EIP712Domain && domain) validateData(types.EIP712Domain, domain);
    // Validate message types.
    if (primaryType !== "EIP712Domain") validateData(types[primaryType], message);
}
function $7c3a5ba88e091414$export$6a292159484ee032(param) {
    var domain = param.domain;
    return [
        typeof (domain === null || domain === void 0 ? void 0 : domain.name) === "string" && {
            name: "name",
            type: "string"
        },
        (domain === null || domain === void 0 ? void 0 : domain.version) && {
            name: "version",
            type: "string"
        },
        typeof (domain === null || domain === void 0 ? void 0 : domain.chainId) === "number" && {
            name: "chainId",
            type: "uint256"
        },
        (domain === null || domain === void 0 ? void 0 : domain.verifyingContract) && {
            name: "verifyingContract",
            type: "address"
        },
        (domain === null || domain === void 0 ? void 0 : domain.salt) && {
            name: "salt",
            type: "bytes32"
        }
    ].filter(Boolean);
}
function $7c3a5ba88e091414$export$a1ffff851efcaaba(param) {
    var domain = param.domain;
    return (0, $e3ab2e296963b97e$export$d4e887b08c47faea)({
        domain: domain,
        types: {
            EIP712Domain: $7c3a5ba88e091414$export$6a292159484ee032({
                domain: domain
            })
        }
    });
}


function $53c73aade9624920$export$9f05de2db4d31153(client, parameters) {
    return $53c73aade9624920$var$_signTypedData.apply(this, arguments);
}
function $53c73aade9624920$var$_signTypedData() {
    $53c73aade9624920$var$_signTypedData = (0, $kSuI9._)(function(client, parameters) {
        var tmp, account_, domain, message, primaryType, account, types, typedData;
        return (0, $eha6O.__generator)(this, function(_state) {
            tmp = parameters.account, account_ = tmp === void 0 ? client.account : tmp, domain = parameters.domain, message = parameters.message, primaryType = parameters.primaryType;
            if (!account_) throw new (0, $58c5ed114b2c2f06$export$62ee6b05f0767f28)({
                docsPath: "/docs/actions/wallet/signTypedData"
            });
            account = (0, $l2YyF.parseAccount)(account_);
            types = (0, $do9pw._)({
                EIP712Domain: (0, $7c3a5ba88e091414$export$6a292159484ee032)({
                    domain: domain
                })
            }, parameters.types);
            // Need to do a runtime validation check on addresses, byte ranges, integer ranges, etc
            // as we can't statically check this with TypeScript.
            (0, $7c3a5ba88e091414$export$fac174f558903e26)({
                domain: domain,
                message: message,
                primaryType: primaryType,
                types: types
            });
            if (account.signTypedData) return [
                2,
                account.signTypedData({
                    domain: domain,
                    message: message,
                    primaryType: primaryType,
                    types: types
                })
            ];
            typedData = (0, $7c3a5ba88e091414$export$ce8e1cf733064451)({
                domain: domain,
                message: message,
                primaryType: primaryType,
                types: types
            });
            return [
                2,
                client.request({
                    method: "eth_signTypedData_v4",
                    params: [
                        account.address,
                        typedData
                    ]
                }, {
                    retryCount: 0
                })
            ];
        });
    });
    return $53c73aade9624920$var$_signTypedData.apply(this, arguments);
}



var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $f3VZN = parcelRequire("f3VZN");
function $757cc05ccd0d1413$export$15599da40e72d2f(client, _) {
    return $757cc05ccd0d1413$var$_switchChain.apply(this, arguments);
}
function $757cc05ccd0d1413$var$_switchChain() {
    $757cc05ccd0d1413$var$_switchChain = (0, $kSuI9._)(function(client, param) {
        var id;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    id = param.id;
                    return [
                        4,
                        client.request({
                            method: "wallet_switchEthereumChain",
                            params: [
                                {
                                    chainId: (0, $f3VZN.numberToHex)(id)
                                }
                            ]
                        }, {
                            retryCount: 0
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $757cc05ccd0d1413$var$_switchChain.apply(this, arguments);
}


/**
 * Adds an EVM chain to the wallet.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/watchAsset
 * - JSON-RPC Methods: [`eth_switchEthereumChain`](https://eips.ethereum.org/EIPS/eip-747)
 *
 * @param client - Client to use
 * @param parameters - {@link WatchAssetParameters}
 * @returns Boolean indicating if the token was successfully added. {@link WatchAssetReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { watchAsset } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const success = await watchAsset(client, {
 *   type: 'ERC20',
 *   options: {
 *     address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
 *     decimals: 18,
 *     symbol: 'WETH',
 *   },
 * })
 */ 
var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");
function $3135b06170976960$export$7eea68d1a70548bd(client, params) {
    return $3135b06170976960$var$_watchAsset.apply(this, arguments);
}
function $3135b06170976960$var$_watchAsset() {
    $3135b06170976960$var$_watchAsset = (0, $kSuI9._)(function(client, params) {
        var added;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        client.request({
                            method: "wallet_watchAsset",
                            params: params
                        }, {
                            retryCount: 0
                        })
                    ];
                case 1:
                    added = _state.sent();
                    return [
                        2,
                        added
                    ];
            }
        });
    });
    return $3135b06170976960$var$_watchAsset.apply(this, arguments);
}



function $21078de348ee146f$export$d07041b4ed194fbc(client) {
    return {
        addChain: function(args) {
            return (0, $2800daeb2928d97c$export$e648161d6b1bb565)(client, args);
        },
        deployContract: function(args) {
            return (0, $21a15c5231ebcaa1$export$46c7a79747abe6a9)(client, args);
        },
        getAddresses: function() {
            return (0, $6a141c5cc87e7c06$export$17d5f00cfd692b8a)(client);
        },
        getChainId: function() {
            return (0, $3f6367ac0fc6b0ac$export$850fa7b3891187c)(client);
        },
        getPermissions: function() {
            return (0, $0ab8697b6a32921a$export$e10fd44ca431fa8e)(client);
        },
        prepareTransactionRequest: function(args) {
            return (0, $4869f53cd4aaa39a$export$2e8a9232fb815d77)(client, args);
        },
        requestAddresses: function() {
            return (0, $d73b9b549067a28c$export$87c5bcc1dede6f06)(client);
        },
        requestPermissions: function(args) {
            return (0, $d178e5b64ddffbc6$export$8cec5d3683c6896e)(client, args);
        },
        sendRawTransaction: function(args) {
            return (0, $da458af31d30456f$export$4e309754b4830e29)(client, args);
        },
        sendTransaction: function(args) {
            return (0, $49da3b39ba760adb$export$8e0e7ffc78696d30)(client, args);
        },
        signMessage: function(args) {
            return (0, $de0a1e3b33b8ce79$export$1d9a7a8a40780de)(client, args);
        },
        signTransaction: function(args) {
            return (0, $8d80aa1ba7facbfa$export$6ad02cc4966b42ab)(client, args);
        },
        signTypedData: function(args) {
            return (0, $53c73aade9624920$export$9f05de2db4d31153)(client, args);
        },
        switchChain: function(args) {
            return (0, $757cc05ccd0d1413$export$15599da40e72d2f)(client, args);
        },
        watchAsset: function(args) {
            return (0, $3135b06170976960$export$7eea68d1a70548bd)(client, args);
        },
        writeContract: function(args) {
            return (0, $c2786d6d73bd4474$export$4c0f201bc17cbf23)(client, args);
        }
    };
}


function $d3530e20f4bd5211$export$362b8ea2edbd9090(parameters) {
    var _parameters_key = parameters.key, key = _parameters_key === void 0 ? "wallet" : _parameters_key, _parameters_name = parameters.name, name = _parameters_name === void 0 ? "Wallet Client" : _parameters_name, transport = parameters.transport;
    var client = (0, $3b636b6bfcd71602$export$5d730b7aed1a3eb0)((0, $cxjpp._)((0, $do9pw._)({}, parameters), {
        key: key,
        name: name,
        transport: transport,
        type: "walletClient"
    }));
    return client.extend((0, $21078de348ee146f$export$d07041b4ed194fbc));
}


var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");





var $kSuI9 = parcelRequire("kSuI9");

var $cv9Rk = parcelRequire("cv9Rk");

var $eha6O = parcelRequire("eha6O");

var $hpqb7 = parcelRequire("hpqb7");

var $f3VZN = parcelRequire("f3VZN");



function $96c1b7ca5662843b$export$ba1240cd558e6b31(client, _) {
    return $96c1b7ca5662843b$var$_getEnsResolver.apply(this, arguments);
}
function $96c1b7ca5662843b$var$_getEnsResolver() {
    $96c1b7ca5662843b$var$_getEnsResolver = (0, $kSuI9._)(function(client, param) {
        var blockNumber, blockTag, name, universalResolverAddress_, universalResolverAddress, _ref, resolverAddress;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    blockNumber = param.blockNumber, blockTag = param.blockTag, name = param.name, universalResolverAddress_ = param.universalResolverAddress;
                    universalResolverAddress = universalResolverAddress_;
                    if (!universalResolverAddress) {
                        if (!client.chain) throw new Error("client chain not configured. universalResolverAddress is required.");
                        universalResolverAddress = (0, $hpqb7.getChainContractAddress)({
                            blockNumber: blockNumber,
                            chain: client.chain,
                            contract: "ensUniversalResolver"
                        });
                    }
                    return [
                        4,
                        (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $1500f99f7733ae7a$export$43af7de392176737), "readContract")({
                            address: universalResolverAddress,
                            abi: [
                                {
                                    inputs: [
                                        {
                                            type: "bytes"
                                        }
                                    ],
                                    name: "findResolver",
                                    outputs: [
                                        {
                                            type: "address"
                                        },
                                        {
                                            type: "bytes32"
                                        }
                                    ],
                                    stateMutability: "view",
                                    type: "function"
                                }
                            ],
                            functionName: "findResolver",
                            args: [
                                (0, $f3VZN.toHex)((0, $96800cc462682856$export$8a0899f9ded0844)(name))
                            ],
                            blockNumber: blockNumber,
                            blockTag: blockTag
                        })
                    ];
                case 1:
                    _ref = (0, $cv9Rk._).apply(void 0, [
                        _state.sent(),
                        1
                    ]), resolverAddress = _ref[0];
                    return [
                        2,
                        resolverAddress
                    ];
            }
        });
    });
    return $96c1b7ca5662843b$var$_getEnsResolver.apply(this, arguments);
}




var $hy7Ff = parcelRequire("hy7Ff");

var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");
/**
 * Scopes `request` to the filter ID. If the client is a fallback, it will
 * listen for responses and scope the child transport `request` function
 * to the successful filter ID.
 */ function $fcd41e6beeaa5b59$export$b7aadf80a875f555(client, param) {
    var method = param.method;
    var _client_transport_onResponse, _client_transport;
    var requestMap = {};
    if (client.transport.type === "fallback") (_client_transport_onResponse = (_client_transport = client.transport).onResponse) === null || _client_transport_onResponse === void 0 ? void 0 : _client_transport_onResponse.call(_client_transport, function(param) {
        var method_ = param.method, id = param.response, status = param.status, transport = param.transport;
        if (status === "success" && method === method_) requestMap[id] = transport.request;
    });
    return function(id) {
        return requestMap[id] || client.request;
    };
}


function $9f3183c77e2d2785$export$651edd5ecf84bf98(client) {
    return $9f3183c77e2d2785$var$_createBlockFilter.apply(this, arguments);
}
function $9f3183c77e2d2785$var$_createBlockFilter() {
    $9f3183c77e2d2785$var$_createBlockFilter = (0, $kSuI9._)(function(client) {
        var getRequest, id;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    getRequest = (0, $fcd41e6beeaa5b59$export$b7aadf80a875f555)(client, {
                        method: "eth_newBlockFilter"
                    });
                    return [
                        4,
                        client.request({
                            method: "eth_newBlockFilter"
                        })
                    ];
                case 1:
                    id = _state.sent();
                    return [
                        2,
                        {
                            id: id,
                            request: getRequest(id),
                            type: "block"
                        }
                    ];
            }
        });
    });
    return $9f3183c77e2d2785$var$_createBlockFilter.apply(this, arguments);
}



var $kSuI9 = parcelRequire("kSuI9");

var $l0HdX = parcelRequire("l0HdX");

var $eha6O = parcelRequire("eha6O");

var $c6Xmf = parcelRequire("c6Xmf");

var $fLalY = parcelRequire("fLalY");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $7ihh7 = parcelRequire("7ihh7");
var $ddd8ebfcb965f243$export$f71f080d25382681 = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(FilterTypeNotSupportedError, BaseError);
    var _super = (0, $ohfOJ._)(FilterTypeNotSupportedError);
    function FilterTypeNotSupportedError(type) {
        (0, $4GJKx._)(this, FilterTypeNotSupportedError);
        return _super.call(this, 'Filter type "'.concat(type, '" is not supported.'), {
            name: "FilterTypeNotSupportedError"
        });
    }
    return FilterTypeNotSupportedError;
}((0, $7ihh7.BaseError));



var $g8Qfu = parcelRequire("g8Qfu");

var $h0UKT = parcelRequire("h0UKT");

var $040Im = parcelRequire("040Im");

var $iL62l = parcelRequire("iL62l");

var $5FHHs = parcelRequire("5FHHs");

var $lW5gB = parcelRequire("lW5gB");
var $608dffba10df3e8b$var$docsPath = "/docs/contract/encodeEventTopics";
function $608dffba10df3e8b$export$64e9f7ca5ce29acd(parameters) {
    var abi = parameters.abi, eventName = parameters.eventName, args = parameters.args;
    var abiItem = abi[0];
    if (eventName) {
        var item = (0, $lW5gB.getAbiItem)({
            abi: abi,
            name: eventName
        });
        if (!item) throw new (0, $fLalY.AbiEventNotFoundError)(eventName, {
            docsPath: $608dffba10df3e8b$var$docsPath
        });
        abiItem = item;
    }
    if (abiItem.type !== "event") throw new (0, $fLalY.AbiEventNotFoundError)(undefined, {
        docsPath: $608dffba10df3e8b$var$docsPath
    });
    var definition = (0, $5FHHs.formatAbiItem)(abiItem);
    var signature = (0, $040Im.toEventSelector)(definition);
    var topics = [];
    if (args && "inputs" in abiItem) {
        var _abiItem_inputs;
        var indexedInputs = (_abiItem_inputs = abiItem.inputs) === null || _abiItem_inputs === void 0 ? void 0 : _abiItem_inputs.filter(function(param) {
            return "indexed" in param && param.indexed;
        });
        var _indexedInputs_map;
        var args_ = Array.isArray(args) ? args : Object.values(args).length > 0 ? (_indexedInputs_map = indexedInputs === null || indexedInputs === void 0 ? void 0 : indexedInputs.map(function(x) {
            return args[x.name];
        })) !== null && _indexedInputs_map !== void 0 ? _indexedInputs_map : [] : [];
        var _indexedInputs_map1;
        if (args_.length > 0) topics = (_indexedInputs_map1 = indexedInputs === null || indexedInputs === void 0 ? void 0 : indexedInputs.map(function(param, i) {
            if (Array.isArray(args_[i])) return args_[i].map(function(_, j) {
                return $608dffba10df3e8b$var$encodeArg({
                    param: param,
                    value: args_[i][j]
                });
            });
            return args_[i] ? $608dffba10df3e8b$var$encodeArg({
                param: param,
                value: args_[i]
            }) : null;
        })) !== null && _indexedInputs_map1 !== void 0 ? _indexedInputs_map1 : [];
    }
    return [
        signature
    ].concat((0, $c6Xmf._)(topics));
}
function $608dffba10df3e8b$var$encodeArg(param) {
    var _$param = param.param, value = param.value;
    if (_$param.type === "string" || _$param.type === "bytes") return (0, $h0UKT.keccak256)((0, $g8Qfu.toBytes)(value));
    if (_$param.type === "tuple" || _$param.type.match(/^(.*)\[(\d+)?\]$/)) throw new (0, $ddd8ebfcb965f243$export$f71f080d25382681)(_$param.type);
    return (0, $iL62l.encodeAbiParameters)([
        _$param
    ], [
        value
    ]);
}



var $f3VZN = parcelRequire("f3VZN");

function $a4ada780449c7224$export$36f99fdb90149e8b(client, parameters) {
    return $a4ada780449c7224$var$_createContractEventFilter.apply(this, arguments);
}
function $a4ada780449c7224$var$_createContractEventFilter() {
    $a4ada780449c7224$var$_createContractEventFilter = (0, $kSuI9._)(function(client, parameters) {
        var address, abi, args, eventName, fromBlock, strict, toBlock, getRequest, topics, id;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    address = parameters.address, abi = parameters.abi, args = parameters.args, eventName = parameters.eventName, fromBlock = parameters.fromBlock, strict = parameters.strict, toBlock = parameters.toBlock;
                    getRequest = (0, $fcd41e6beeaa5b59$export$b7aadf80a875f555)(client, {
                        method: "eth_newFilter"
                    });
                    topics = eventName ? (0, $608dffba10df3e8b$export$64e9f7ca5ce29acd)({
                        abi: abi,
                        args: args,
                        eventName: eventName
                    }) : undefined;
                    return [
                        4,
                        client.request({
                            method: "eth_newFilter",
                            params: [
                                {
                                    address: address,
                                    fromBlock: (typeof fromBlock === "undefined" ? "undefined" : (0, $l0HdX._)(fromBlock)) === "bigint" ? (0, $f3VZN.numberToHex)(fromBlock) : fromBlock,
                                    toBlock: (typeof toBlock === "undefined" ? "undefined" : (0, $l0HdX._)(toBlock)) === "bigint" ? (0, $f3VZN.numberToHex)(toBlock) : toBlock,
                                    topics: topics
                                }
                            ]
                        })
                    ];
                case 1:
                    id = _state.sent();
                    return [
                        2,
                        {
                            abi: abi,
                            args: args,
                            eventName: eventName,
                            id: id,
                            request: getRequest(id),
                            strict: Boolean(strict),
                            type: "event"
                        }
                    ];
            }
        });
    });
    return $a4ada780449c7224$var$_createContractEventFilter.apply(this, arguments);
}



var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $l0HdX = parcelRequire("l0HdX");

var $eha6O = parcelRequire("eha6O");


var $f3VZN = parcelRequire("f3VZN");

function $a1db1fb484e19edd$export$977ab14bbccde633(client) {
    return $a1db1fb484e19edd$var$_createEventFilter.apply(this, arguments);
}
function $a1db1fb484e19edd$var$_createEventFilter() {
    $a1db1fb484e19edd$var$_createEventFilter = (0, $kSuI9._)(function(client) {
        var _ref, address, args, event, events_, fromBlock, strict, toBlock, events, getRequest, topics, encoded, id;
        var _arguments = arguments;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ref = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, address = _ref.address, args = _ref.args, event = _ref.event, events_ = _ref.events, fromBlock = _ref.fromBlock, strict = _ref.strict, toBlock = _ref.toBlock;
                    events = events_ !== null && events_ !== void 0 ? events_ : event ? [
                        event
                    ] : undefined;
                    getRequest = (0, $fcd41e6beeaa5b59$export$b7aadf80a875f555)(client, {
                        method: "eth_newFilter"
                    });
                    topics = [];
                    if (events) {
                        encoded = events.flatMap(function(event) {
                            return (0, $608dffba10df3e8b$export$64e9f7ca5ce29acd)({
                                abi: [
                                    event
                                ],
                                eventName: event.name,
                                args: args
                            });
                        });
                        // TODO: Clean up type casting
                        topics = [
                            encoded
                        ];
                        if (event) topics = topics[0];
                    }
                    return [
                        4,
                        client.request({
                            method: "eth_newFilter",
                            params: [
                                (0, $do9pw._)({
                                    address: address,
                                    fromBlock: (typeof fromBlock === "undefined" ? "undefined" : (0, $l0HdX._)(fromBlock)) === "bigint" ? (0, $f3VZN.numberToHex)(fromBlock) : fromBlock,
                                    toBlock: (typeof toBlock === "undefined" ? "undefined" : (0, $l0HdX._)(toBlock)) === "bigint" ? (0, $f3VZN.numberToHex)(toBlock) : toBlock
                                }, topics.length ? {
                                    topics: topics
                                } : {})
                            ]
                        })
                    ];
                case 1:
                    id = _state.sent();
                    return [
                        2,
                        {
                            abi: events,
                            args: args,
                            eventName: event ? event.name : undefined,
                            fromBlock: fromBlock,
                            id: id,
                            request: getRequest(id),
                            strict: Boolean(strict),
                            toBlock: toBlock,
                            type: "event"
                        }
                    ];
            }
        });
    });
    return $a1db1fb484e19edd$var$_createEventFilter.apply(this, arguments);
}



var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

function $705745bab512e2e7$export$d455ed04c3e85241(client) {
    return $705745bab512e2e7$var$_createPendingTransactionFilter.apply(this, arguments);
}
function $705745bab512e2e7$var$_createPendingTransactionFilter() {
    $705745bab512e2e7$var$_createPendingTransactionFilter = (0, $kSuI9._)(function(client) {
        var getRequest, id;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    getRequest = (0, $fcd41e6beeaa5b59$export$b7aadf80a875f555)(client, {
                        method: "eth_newPendingTransactionFilter"
                    });
                    return [
                        4,
                        client.request({
                            method: "eth_newPendingTransactionFilter"
                        })
                    ];
                case 1:
                    id = _state.sent();
                    return [
                        2,
                        {
                            id: id,
                            request: getRequest(id),
                            type: "transaction"
                        }
                    ];
            }
        });
    });
    return $705745bab512e2e7$var$_createPendingTransactionFilter.apply(this, arguments);
}



var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $dRLPW = parcelRequire("dRLPW");

var $eha6O = parcelRequire("eha6O");

var $l2YyF = parcelRequire("l2YyF");

var $cdvyV = parcelRequire("cdvyV");



function $26658049de670cf6$export$7b896b3a3695de87(client, parameters) {
    return $26658049de670cf6$var$_estimateContractGas.apply(this, arguments);
}
function $26658049de670cf6$var$_estimateContractGas() {
    $26658049de670cf6$var$_estimateContractGas = (0, $kSuI9._)(function(client, parameters) {
        var abi, address, args, functionName, request, data, gas, error, account;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    abi = parameters.abi, address = parameters.address, args = parameters.args, functionName = parameters.functionName, request = (0, $dRLPW._)(parameters, [
                        "abi",
                        "address",
                        "args",
                        "functionName"
                    ]);
                    data = (0, $cdvyV.encodeFunctionData)({
                        abi: abi,
                        args: args,
                        functionName: functionName
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $decf603c2fa0d1c4$export$e0580ae1f48db848), "estimateGas")((0, $do9pw._)({
                            data: data,
                            to: address
                        }, request))
                    ];
                case 2:
                    gas = _state.sent();
                    return [
                        2,
                        gas
                    ];
                case 3:
                    error = _state.sent();
                    account = request.account ? (0, $l2YyF.parseAccount)(request.account) : undefined;
                    throw (0, $2cf930bd18c2e947$export$4414444aba6ddd8a)(error, {
                        abi: abi,
                        address: address,
                        args: args,
                        docsPath: "/docs/contract/estimateContractGas",
                        functionName: functionName,
                        sender: account === null || account === void 0 ? void 0 : account.address
                    });
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $26658049de670cf6$var$_estimateContractGas.apply(this, arguments);
}






/**
 * Returns the base fee per blob gas in wei.
 *
 * - Docs: https://viem.sh/docs/actions/public/getBlobBaseFee
 * - JSON-RPC Methods: [`eth_blobBaseFee`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_blobBaseFee)
 *
 * @param client - Client to use
 * @returns The blob base fee (in wei). {@link GetBlobBaseFeeReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getBlobBaseFee } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const blobBaseFee = await getBlobBaseFee(client)
 */ 
var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");
function $b52281f217393855$export$9682cd49f77b48b(client) {
    return $b52281f217393855$var$_getBlobBaseFee.apply(this, arguments);
}
function $b52281f217393855$var$_getBlobBaseFee() {
    $b52281f217393855$var$_getBlobBaseFee = (0, $kSuI9._)(function(client) {
        var baseFee;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        client.request({
                            method: "eth_blobBaseFee"
                        })
                    ];
                case 1:
                    baseFee = _state.sent();
                    return [
                        2,
                        BigInt(baseFee)
                    ];
            }
        });
    });
    return $b52281f217393855$var$_getBlobBaseFee.apply(this, arguments);
}





var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $itrhm = parcelRequire("itrhm");

var $f3VZN = parcelRequire("f3VZN");
function $c5decdc35e85b209$export$8c2de5be7f4dfc0(client) {
    return $c5decdc35e85b209$var$_getBlockTransactionCount.apply(this, arguments);
}
function $c5decdc35e85b209$var$_getBlockTransactionCount() {
    $c5decdc35e85b209$var$_getBlockTransactionCount = (0, $kSuI9._)(function(client) {
        var _ref, blockHash, blockNumber, _ref_blockTag, blockTag, blockNumberHex, count;
        var _arguments = arguments;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ref = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, blockHash = _ref.blockHash, blockNumber = _ref.blockNumber, _ref_blockTag = _ref.blockTag, blockTag = _ref_blockTag === void 0 ? "latest" : _ref_blockTag;
                    blockNumberHex = blockNumber !== undefined ? (0, $f3VZN.numberToHex)(blockNumber) : undefined;
                    if (!blockHash) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        client.request({
                            method: "eth_getBlockTransactionCountByHash",
                            params: [
                                blockHash
                            ]
                        }, {
                            dedupe: true
                        })
                    ];
                case 1:
                    count = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        client.request({
                            method: "eth_getBlockTransactionCountByNumber",
                            params: [
                                blockNumberHex || blockTag
                            ]
                        }, {
                            dedupe: Boolean(blockNumberHex)
                        })
                    ];
                case 3:
                    count = _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2,
                        (0, $itrhm.hexToNumber)(count)
                    ];
            }
        });
    });
    return $c5decdc35e85b209$var$_getBlockTransactionCount.apply(this, arguments);
}




var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $f3VZN = parcelRequire("f3VZN");
function $37d2500dd5b8229d$export$9a0a9c75ccef13fb(client, _) {
    return $37d2500dd5b8229d$var$_getCode.apply(this, arguments);
}
function $37d2500dd5b8229d$var$_getCode() {
    $37d2500dd5b8229d$var$_getCode = (0, $kSuI9._)(function(client, param) {
        var address, blockNumber, _param_blockTag, blockTag, blockNumberHex, hex;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    address = param.address, blockNumber = param.blockNumber, _param_blockTag = param.blockTag, blockTag = _param_blockTag === void 0 ? "latest" : _param_blockTag;
                    blockNumberHex = blockNumber !== undefined ? (0, $f3VZN.numberToHex)(blockNumber) : undefined;
                    return [
                        4,
                        client.request({
                            method: "eth_getCode",
                            params: [
                                address,
                                blockNumberHex || blockTag
                            ]
                        }, {
                            dedupe: Boolean(blockNumberHex)
                        })
                    ];
                case 1:
                    hex = _state.sent();
                    if (hex === "0x") return [
                        2,
                        undefined
                    ];
                    return [
                        2,
                        hex
                    ];
            }
        });
    });
    return $37d2500dd5b8229d$var$_getCode.apply(this, arguments);
}



var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $lW5gB = parcelRequire("lW5gB");


var $kSuI9 = parcelRequire("kSuI9");

var $l0HdX = parcelRequire("l0HdX");

var $eha6O = parcelRequire("eha6O");

// TODO(v3): checksum address.

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $cv9Rk = parcelRequire("cv9Rk");

var $fLalY = parcelRequire("fLalY");

var $7YhYp = parcelRequire("7YhYp");

var $g8Qfu = parcelRequire("g8Qfu");

var $h0UKT = parcelRequire("h0UKT");

var $gdHfP = parcelRequire("gdHfP");

var $c6Xmf = parcelRequire("c6Xmf");

var $fLalY = parcelRequire("fLalY");

var $dfJGH = parcelRequire("dfJGH");

var $040Im = parcelRequire("040Im");

var $1kC4N = parcelRequire("1kC4N");

var $iYiQt = parcelRequire("iYiQt");

var $5FHHs = parcelRequire("5FHHs");
var $08263f7f1338aacd$var$docsPath = "/docs/contract/decodeEventLog";
function $08263f7f1338aacd$export$ec0597e81db3d947(parameters) {
    var abi = parameters.abi, data = parameters.data, strict_ = parameters.strict, topics = parameters.topics;
    var strict = strict_ !== null && strict_ !== void 0 ? strict_ : true;
    var _topics = (0, $gdHfP._)(topics), signature = _topics[0], argTopics = _topics.slice(1);
    if (!signature) throw new (0, $fLalY.AbiEventSignatureEmptyTopicsError)({
        docsPath: $08263f7f1338aacd$var$docsPath
    });
    var abiItem = abi.find(function(x) {
        return x.type === "event" && signature === (0, $040Im.toEventSelector)((0, $5FHHs.formatAbiItem)(x));
    });
    if (!(abiItem && "name" in abiItem) || abiItem.type !== "event") throw new (0, $fLalY.AbiEventSignatureNotFoundError)(signature, {
        docsPath: $08263f7f1338aacd$var$docsPath
    });
    var name = abiItem.name, inputs = abiItem.inputs;
    var isUnnamed = inputs === null || inputs === void 0 ? void 0 : inputs.some(function(x) {
        return !("name" in x && x.name);
    });
    var args = isUnnamed ? [] : {};
    // Decode topics (indexed args).
    var indexedInputs = inputs.filter(function(x) {
        return "indexed" in x && x.indexed;
    });
    for(var i = 0; i < indexedInputs.length; i++){
        var param = indexedInputs[i];
        var topic = argTopics[i];
        if (!topic) throw new (0, $fLalY.DecodeLogTopicsMismatch)({
            abiItem: abiItem,
            param: param
        });
        args[isUnnamed ? i : param.name || i] = $08263f7f1338aacd$var$decodeTopic({
            param: param,
            value: topic
        });
    }
    // Decode data (non-indexed args).
    var nonIndexedInputs = inputs.filter(function(x) {
        return !("indexed" in x && x.indexed);
    });
    if (nonIndexedInputs.length > 0) {
        if (data && data !== "0x") try {
            var decodedData = (0, $iYiQt.decodeAbiParameters)(nonIndexedInputs, data);
            if (decodedData) {
                if (isUnnamed) args = (0, $c6Xmf._)(args).concat((0, $c6Xmf._)(decodedData));
                else for(var i1 = 0; i1 < nonIndexedInputs.length; i1++)args[nonIndexedInputs[i1].name] = decodedData[i1];
            }
        } catch (err) {
            if (strict) {
                if (err instanceof (0, $fLalY.AbiDecodingDataSizeTooSmallError) || err instanceof (0, $1kC4N.PositionOutOfBoundsError)) throw new (0, $fLalY.DecodeLogDataMismatch)({
                    abiItem: abiItem,
                    data: data,
                    params: nonIndexedInputs,
                    size: (0, $dfJGH.size)(data)
                });
                throw err;
            }
        }
        else if (strict) throw new (0, $fLalY.DecodeLogDataMismatch)({
            abiItem: abiItem,
            data: "0x",
            params: nonIndexedInputs,
            size: 0
        });
    }
    return {
        eventName: name,
        args: Object.values(args).length > 0 ? args : undefined
    };
}
function $08263f7f1338aacd$var$decodeTopic(param) {
    var _$param = param.param, value = param.value;
    if (_$param.type === "string" || _$param.type === "bytes" || _$param.type === "tuple" || _$param.type.match(/^(.*)\[(\d+)?\]$/)) return value;
    var decodedArg = (0, $iYiQt.decodeAbiParameters)([
        _$param
    ], value) || [];
    return decodedArg[0];
}



var $lW5gB = parcelRequire("lW5gB");
function $630b61ec9fc6f493$export$7d811a19971cdf46(parameters) {
    var abi = parameters.abi, args = parameters.args, logs = parameters.logs, _parameters_strict = parameters.strict, strict = _parameters_strict === void 0 ? true : _parameters_strict;
    var eventName = function() {
        if (!parameters.eventName) return undefined;
        if (Array.isArray(parameters.eventName)) return parameters.eventName;
        return [
            parameters.eventName
        ];
    }();
    return logs.map(function(log) {
        try {
            var abiItem = (0, $lW5gB.getAbiItem)({
                abi: abi,
                name: log.topics[0]
            });
            if (!abiItem) return null;
            var event = (0, $08263f7f1338aacd$export$ec0597e81db3d947)((0, $cxjpp._)((0, $do9pw._)({}, log), {
                abi: [
                    abiItem
                ],
                strict: strict
            }));
            // Check that the decoded event name matches the provided event name.
            if (eventName && !eventName.includes(event.eventName)) return null;
            // Check that the decoded event args match the provided args.
            if (!$630b61ec9fc6f493$var$includesArgs({
                args: event.args,
                inputs: abiItem.inputs,
                matchArgs: args
            })) return null;
            return (0, $do9pw._)({}, event, log);
        } catch (err) {
            var eventName1;
            var isUnnamed;
            if (err instanceof (0, $fLalY.AbiEventSignatureNotFoundError)) return null;
            if (err instanceof (0, $fLalY.DecodeLogDataMismatch) || err instanceof (0, $fLalY.DecodeLogTopicsMismatch)) {
                var _err_abiItem_inputs;
                // If strict mode is on, and log data/topics do not match event definition, skip.
                if (strict) return null;
                eventName1 = err.abiItem.name;
                isUnnamed = (_err_abiItem_inputs = err.abiItem.inputs) === null || _err_abiItem_inputs === void 0 ? void 0 : _err_abiItem_inputs.some(function(x) {
                    return !("name" in x && x.name);
                });
            }
            // Set args to empty if there is an error decoding (e.g. indexed/non-indexed params mismatch).
            return (0, $cxjpp._)((0, $do9pw._)({}, log), {
                args: isUnnamed ? [] : {},
                eventName: eventName1
            });
        }
    }).filter(Boolean);
}
function $630b61ec9fc6f493$var$includesArgs(parameters) {
    var args = parameters.args, inputs = parameters.inputs, matchArgs = parameters.matchArgs;
    if (!matchArgs) return true;
    if (!args) return false;
    function isEqual(input, value, arg) {
        try {
            if (input.type === "address") return (0, $7YhYp.isAddressEqual)(value, arg);
            if (input.type === "string" || input.type === "bytes") return (0, $h0UKT.keccak256)((0, $g8Qfu.toBytes)(value)) === arg;
            return value === arg;
        } catch (e) {
            return false;
        }
    }
    if (Array.isArray(args) && Array.isArray(matchArgs)) return matchArgs.every(function(value, index) {
        if (!value) return true;
        var input = inputs[index];
        if (!input) return false;
        var value_ = Array.isArray(value) ? value : [
            value
        ];
        return value_.some(function(value) {
            return isEqual(input, value, args[index]);
        });
    });
    if (typeof args === "object" && !Array.isArray(args) && typeof matchArgs === "object" && !Array.isArray(matchArgs)) return Object.entries(matchArgs).every(function(param) {
        var _param = (0, $cv9Rk._)(param, 2), key = _param[0], value = _param[1];
        if (!value) return true;
        var input = inputs.find(function(input) {
            return input.name === key;
        });
        if (!input) return false;
        var value_ = Array.isArray(value) ? value : [
            value
        ];
        return value_.some(function(value) {
            return isEqual(input, value, args[key]);
        });
    });
    return false;
}



var $f3VZN = parcelRequire("f3VZN");

function $6ff42dbea0cf781e$export$cb5260c832aab30a(client) {
    return $6ff42dbea0cf781e$var$_getLogs.apply(this, arguments);
}
function $6ff42dbea0cf781e$var$_getLogs() {
    $6ff42dbea0cf781e$var$_getLogs = (0, $kSuI9._)(function(client) {
        var _ref, address, blockHash, fromBlock, toBlock, event, events_, args, strict_, strict, events, topics, encoded, logs, formattedLogs;
        var _arguments = arguments;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ref = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, address = _ref.address, blockHash = _ref.blockHash, fromBlock = _ref.fromBlock, toBlock = _ref.toBlock, event = _ref.event, events_ = _ref.events, args = _ref.args, strict_ = _ref.strict;
                    strict = strict_ !== null && strict_ !== void 0 ? strict_ : false;
                    events = events_ !== null && events_ !== void 0 ? events_ : event ? [
                        event
                    ] : undefined;
                    topics = [];
                    if (events) {
                        encoded = events.flatMap(function(event) {
                            return (0, $608dffba10df3e8b$export$64e9f7ca5ce29acd)({
                                abi: [
                                    event
                                ],
                                eventName: event.name,
                                args: events_ ? undefined : args
                            });
                        });
                        // TODO: Clean up type casting
                        topics = [
                            encoded
                        ];
                        if (event) topics = topics[0];
                    }
                    if (!blockHash) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        client.request({
                            method: "eth_getLogs",
                            params: [
                                {
                                    address: address,
                                    topics: topics,
                                    blockHash: blockHash
                                }
                            ]
                        })
                    ];
                case 1:
                    logs = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        client.request({
                            method: "eth_getLogs",
                            params: [
                                {
                                    address: address,
                                    topics: topics,
                                    fromBlock: (typeof fromBlock === "undefined" ? "undefined" : (0, $l0HdX._)(fromBlock)) === "bigint" ? (0, $f3VZN.numberToHex)(fromBlock) : fromBlock,
                                    toBlock: (typeof toBlock === "undefined" ? "undefined" : (0, $l0HdX._)(toBlock)) === "bigint" ? (0, $f3VZN.numberToHex)(toBlock) : toBlock
                                }
                            ]
                        })
                    ];
                case 3:
                    logs = _state.sent();
                    _state.label = 4;
                case 4:
                    formattedLogs = logs.map(function(log) {
                        return (0, $55e0178b1429ebe9$export$fccdbdc2b9d7893)(log);
                    });
                    if (!events) return [
                        2,
                        formattedLogs
                    ];
                    return [
                        2,
                        (0, $630b61ec9fc6f493$export$7d811a19971cdf46)({
                            abi: events,
                            args: args,
                            logs: formattedLogs,
                            strict: strict
                        })
                    ];
            }
        });
    });
    return $6ff42dbea0cf781e$var$_getLogs.apply(this, arguments);
}


function $c7cf0e41c9b19a2b$export$1e175955db02d8d(client, parameters) {
    return $c7cf0e41c9b19a2b$var$_getContractEvents.apply(this, arguments);
}
function $c7cf0e41c9b19a2b$var$_getContractEvents() {
    $c7cf0e41c9b19a2b$var$_getContractEvents = (0, $kSuI9._)(function(client, parameters) {
        var abi, address, args, blockHash, eventName, fromBlock, toBlock, strict, event, events;
        return (0, $eha6O.__generator)(this, function(_state) {
            abi = parameters.abi, address = parameters.address, args = parameters.args, blockHash = parameters.blockHash, eventName = parameters.eventName, fromBlock = parameters.fromBlock, toBlock = parameters.toBlock, strict = parameters.strict;
            event = eventName ? (0, $lW5gB.getAbiItem)({
                abi: abi,
                name: eventName
            }) : undefined;
            events = !event ? abi.filter(function(x) {
                return x.type === "event";
            }) : undefined;
            return [
                2,
                (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $6ff42dbea0cf781e$export$cb5260c832aab30a), "getLogs")({
                    address: address,
                    args: args,
                    blockHash: blockHash,
                    event: event,
                    events: events,
                    fromBlock: fromBlock,
                    toBlock: toBlock,
                    strict: strict
                })
            ];
        });
    });
    return $c7cf0e41c9b19a2b$var$_getContractEvents.apply(this, arguments);
}



var $kSuI9 = parcelRequire("kSuI9");

var $cv9Rk = parcelRequire("cv9Rk");

var $eha6O = parcelRequire("eha6O");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $7ihh7 = parcelRequire("7ihh7");
var $ab3c2a855f14e909$export$3738cbd1470ec0c = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(Eip712DomainNotFoundError, BaseError);
    var _super = (0, $ohfOJ._)(Eip712DomainNotFoundError);
    function Eip712DomainNotFoundError(param) {
        var address = param.address;
        (0, $4GJKx._)(this, Eip712DomainNotFoundError);
        return _super.call(this, 'No EIP-712 domain found on contract "'.concat(address, '".'), {
            metaMessages: [
                "Ensure that:",
                '- The contract is deployed at the address "'.concat(address, '".'),
                "- `eip712Domain()` function exists on the contract.",
                "- `eip712Domain()` function matches signature to ERC-5267 specification."
            ],
            name: "Eip712DomainNotFoundError"
        });
    }
    return Eip712DomainNotFoundError;
}((0, $7ihh7.BaseError));




function $dd2762f9c6af6f48$export$78097141abc77755(client, parameters) {
    return $dd2762f9c6af6f48$var$_getEip712Domain.apply(this, arguments);
}
function $dd2762f9c6af6f48$var$_getEip712Domain() {
    $dd2762f9c6af6f48$var$_getEip712Domain = (0, $kSuI9._)(function(client, parameters) {
        var address, factory, factoryData, _ref, fields, name, version, chainId, verifyingContract, salt, extensions, e, error;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    address = parameters.address, factory = parameters.factory, factoryData = parameters.factoryData;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $1500f99f7733ae7a$export$43af7de392176737), "readContract")({
                            abi: $dd2762f9c6af6f48$var$abi,
                            address: address,
                            functionName: "eip712Domain",
                            factory: factory,
                            factoryData: factoryData
                        })
                    ];
                case 2:
                    _ref = (0, $cv9Rk._).apply(void 0, [
                        _state.sent(),
                        7
                    ]), fields = _ref[0], name = _ref[1], version = _ref[2], chainId = _ref[3], verifyingContract = _ref[4], salt = _ref[5], extensions = _ref[6];
                    return [
                        2,
                        {
                            domain: {
                                name: name,
                                version: version,
                                chainId: Number(chainId),
                                verifyingContract: verifyingContract,
                                salt: salt
                            },
                            extensions: extensions,
                            fields: fields
                        }
                    ];
                case 3:
                    e = _state.sent();
                    error = e;
                    if (error.name === "ContractFunctionExecutionError" && error.cause.name === "ContractFunctionZeroDataError") throw new (0, $ab3c2a855f14e909$export$3738cbd1470ec0c)({
                        address: address
                    });
                    throw error;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $dd2762f9c6af6f48$var$_getEip712Domain.apply(this, arguments);
}
var $dd2762f9c6af6f48$var$abi = [
    {
        inputs: [],
        name: "eip712Domain",
        outputs: [
            {
                name: "fields",
                type: "bytes1"
            },
            {
                name: "name",
                type: "string"
            },
            {
                name: "version",
                type: "string"
            },
            {
                name: "chainId",
                type: "uint256"
            },
            {
                name: "verifyingContract",
                type: "address"
            },
            {
                name: "salt",
                type: "bytes32"
            },
            {
                name: "extensions",
                type: "uint256[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];



var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $f3VZN = parcelRequire("f3VZN");
function $04565a3d84e86d5f$export$6c26435bc7761d23(feeHistory) {
    var _feeHistory_reward;
    return {
        baseFeePerGas: feeHistory.baseFeePerGas.map(function(value) {
            return BigInt(value);
        }),
        gasUsedRatio: feeHistory.gasUsedRatio,
        oldestBlock: BigInt(feeHistory.oldestBlock),
        reward: (_feeHistory_reward = feeHistory.reward) === null || _feeHistory_reward === void 0 ? void 0 : _feeHistory_reward.map(function(reward) {
            return reward.map(function(value) {
                return BigInt(value);
            });
        })
    };
}


function $531e1d56a4ecf199$export$66598bc0c00a958e(client, _) {
    return $531e1d56a4ecf199$var$_getFeeHistory.apply(this, arguments);
}
function $531e1d56a4ecf199$var$_getFeeHistory() {
    $531e1d56a4ecf199$var$_getFeeHistory = (0, $kSuI9._)(function(client, param) {
        var blockCount, blockNumber, _param_blockTag, blockTag, rewardPercentiles, blockNumberHex, feeHistory;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    blockCount = param.blockCount, blockNumber = param.blockNumber, _param_blockTag = param.blockTag, blockTag = _param_blockTag === void 0 ? "latest" : _param_blockTag, rewardPercentiles = param.rewardPercentiles;
                    blockNumberHex = blockNumber ? (0, $f3VZN.numberToHex)(blockNumber) : undefined;
                    return [
                        4,
                        client.request({
                            method: "eth_feeHistory",
                            params: [
                                (0, $f3VZN.numberToHex)(blockCount),
                                blockNumberHex || blockTag,
                                rewardPercentiles
                            ]
                        }, {
                            dedupe: Boolean(blockNumberHex)
                        })
                    ];
                case 1:
                    feeHistory = _state.sent();
                    return [
                        2,
                        (0, $04565a3d84e86d5f$export$6c26435bc7761d23)(feeHistory)
                    ];
            }
        });
    });
    return $531e1d56a4ecf199$var$_getFeeHistory.apply(this, arguments);
}



var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");


function $745e63ecde4cca0f$export$e69fa84ce52a94fd(_client, _) {
    return $745e63ecde4cca0f$var$_getFilterChanges.apply(this, arguments);
}
function $745e63ecde4cca0f$var$_getFilterChanges() {
    $745e63ecde4cca0f$var$_getFilterChanges = (0, $kSuI9._)(function(_client, param) {
        var filter, strict, logs, formattedLogs;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    filter = param.filter;
                    strict = "strict" in filter && filter.strict;
                    return [
                        4,
                        filter.request({
                            method: "eth_getFilterChanges",
                            params: [
                                filter.id
                            ]
                        })
                    ];
                case 1:
                    logs = _state.sent();
                    if (typeof logs[0] === "string") return [
                        2,
                        logs
                    ];
                    formattedLogs = logs.map(function(log) {
                        return (0, $55e0178b1429ebe9$export$fccdbdc2b9d7893)(log);
                    });
                    if (!("abi" in filter) || !filter.abi) return [
                        2,
                        formattedLogs
                    ];
                    return [
                        2,
                        (0, $630b61ec9fc6f493$export$7d811a19971cdf46)({
                            abi: filter.abi,
                            logs: formattedLogs,
                            strict: strict
                        })
                    ];
            }
        });
    });
    return $745e63ecde4cca0f$var$_getFilterChanges.apply(this, arguments);
}



var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");


function $03463eb6f48aa255$export$776d3b8c33a8b58(_client, _) {
    return $03463eb6f48aa255$var$_getFilterLogs.apply(this, arguments);
}
function $03463eb6f48aa255$var$_getFilterLogs() {
    $03463eb6f48aa255$var$_getFilterLogs = (0, $kSuI9._)(function(_client, param) {
        var filter, _filter_strict, strict, logs, formattedLogs;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    filter = param.filter;
                    strict = (_filter_strict = filter.strict) !== null && _filter_strict !== void 0 ? _filter_strict : false;
                    return [
                        4,
                        filter.request({
                            method: "eth_getFilterLogs",
                            params: [
                                filter.id
                            ]
                        })
                    ];
                case 1:
                    logs = _state.sent();
                    formattedLogs = logs.map(function(log) {
                        return (0, $55e0178b1429ebe9$export$fccdbdc2b9d7893)(log);
                    });
                    if (!filter.abi) return [
                        2,
                        formattedLogs
                    ];
                    return [
                        2,
                        (0, $630b61ec9fc6f493$export$7d811a19971cdf46)({
                            abi: filter.abi,
                            logs: formattedLogs,
                            strict: strict
                        })
                    ];
            }
        });
    });
    return $03463eb6f48aa255$var$_getFilterLogs.apply(this, arguments);
}





var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $f3VZN = parcelRequire("f3VZN");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $itrhm = parcelRequire("itrhm");
function $1958bbd4b0d5caa7$var$formatStorageProof(storageProof) {
    return storageProof.map(function(proof) {
        return (0, $cxjpp._)((0, $do9pw._)({}, proof), {
            value: BigInt(proof.value)
        });
    });
}
function $1958bbd4b0d5caa7$export$f37c234f0c7125e3(proof) {
    return (0, $cxjpp._)((0, $do9pw._)({}, proof), {
        balance: proof.balance ? BigInt(proof.balance) : undefined,
        nonce: proof.nonce ? (0, $itrhm.hexToNumber)(proof.nonce) : undefined,
        storageProof: proof.storageProof ? $1958bbd4b0d5caa7$var$formatStorageProof(proof.storageProof) : undefined
    });
}


function $2b7cd1f962a94eab$export$4a314c097411dc17(client, _) {
    return $2b7cd1f962a94eab$var$_getProof.apply(this, arguments);
}
function $2b7cd1f962a94eab$var$_getProof() {
    $2b7cd1f962a94eab$var$_getProof = (0, $kSuI9._)(function(client, param) {
        var address, blockNumber, blockTag_, storageKeys, blockTag, blockNumberHex, proof;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    address = param.address, blockNumber = param.blockNumber, blockTag_ = param.blockTag, storageKeys = param.storageKeys;
                    blockTag = blockTag_ !== null && blockTag_ !== void 0 ? blockTag_ : "latest";
                    blockNumberHex = blockNumber !== undefined ? (0, $f3VZN.numberToHex)(blockNumber) : undefined;
                    return [
                        4,
                        client.request({
                            method: "eth_getProof",
                            params: [
                                address,
                                storageKeys,
                                blockNumberHex || blockTag
                            ]
                        })
                    ];
                case 1:
                    proof = _state.sent();
                    return [
                        2,
                        (0, $1958bbd4b0d5caa7$export$f37c234f0c7125e3)(proof)
                    ];
            }
        });
    });
    return $2b7cd1f962a94eab$var$_getProof.apply(this, arguments);
}



var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $f3VZN = parcelRequire("f3VZN");
function $d4d64bfbd07c3570$export$14e244c1a3c8527e(client, _) {
    return $d4d64bfbd07c3570$var$_getStorageAt.apply(this, arguments);
}
function $d4d64bfbd07c3570$var$_getStorageAt() {
    $d4d64bfbd07c3570$var$_getStorageAt = (0, $kSuI9._)(function(client, param) {
        var address, blockNumber, _param_blockTag, blockTag, slot, blockNumberHex, data;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    address = param.address, blockNumber = param.blockNumber, _param_blockTag = param.blockTag, blockTag = _param_blockTag === void 0 ? "latest" : _param_blockTag, slot = param.slot;
                    blockNumberHex = blockNumber !== undefined ? (0, $f3VZN.numberToHex)(blockNumber) : undefined;
                    return [
                        4,
                        client.request({
                            method: "eth_getStorageAt",
                            params: [
                                address,
                                slot,
                                blockNumberHex || blockTag
                            ]
                        })
                    ];
                case 1:
                    data = _state.sent();
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return $d4d64bfbd07c3570$var$_getStorageAt.apply(this, arguments);
}




var $kSuI9 = parcelRequire("kSuI9");

var $cv9Rk = parcelRequire("cv9Rk");

var $eha6O = parcelRequire("eha6O");



function $f166e01feb50786f$export$e2ccc904d713b66d(client, _) {
    return $f166e01feb50786f$var$_getTransactionConfirmations.apply(this, arguments);
}
function $f166e01feb50786f$var$_getTransactionConfirmations() {
    $f166e01feb50786f$var$_getTransactionConfirmations = (0, $kSuI9._)(function(client, param) {
        var hash, transactionReceipt, _ref, blockNumber, transaction, transactionBlockNumber;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    hash = param.hash, transactionReceipt = param.transactionReceipt;
                    return [
                        4,
                        Promise.all([
                            (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $1b10c774854a89ed$export$9328b5c92c53a20e), "getBlockNumber")({}),
                            hash ? (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $55ff11d9c8fdfd6e$export$ec0c6556a09b65b8), "getTransaction")({
                                hash: hash
                            }) : undefined
                        ])
                    ];
                case 1:
                    _ref = (0, $cv9Rk._).apply(void 0, [
                        _state.sent(),
                        2
                    ]), blockNumber = _ref[0], transaction = _ref[1];
                    transactionBlockNumber = (transactionReceipt === null || transactionReceipt === void 0 ? void 0 : transactionReceipt.blockNumber) || (transaction === null || transaction === void 0 ? void 0 : transaction.blockNumber);
                    if (!transactionBlockNumber) return [
                        2,
                        0n
                    ];
                    return [
                        2,
                        blockNumber - transactionBlockNumber + 1n
                    ];
            }
        });
    });
    return $f166e01feb50786f$var$_getTransactionConfirmations.apply(this, arguments);
}







/**
 * Destroys a [`Filter`](https://viem.sh/docs/glossary/types#filter).
 *
 * - Docs: https://viem.sh/docs/actions/public/uninstallFilter
 * - JSON-RPC Methods: [`eth_uninstallFilter`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_uninstallFilter)
 *
 * Destroys a Filter that was created from one of the following Actions:
 * - [`createBlockFilter`](https://viem.sh/docs/actions/public/createBlockFilter)
 * - [`createEventFilter`](https://viem.sh/docs/actions/public/createEventFilter)
 * - [`createPendingTransactionFilter`](https://viem.sh/docs/actions/public/createPendingTransactionFilter)
 *
 * @param client - Client to use
 * @param parameters - {@link UninstallFilterParameters}
 * @returns A boolean indicating if the Filter was successfully uninstalled. {@link UninstallFilterReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { createPendingTransactionFilter, uninstallFilter } from 'viem/public'
 *
 * const filter = await createPendingTransactionFilter(client)
 * const uninstalled = await uninstallFilter(client, { filter })
 * // true
 */ 
var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");
function $4a210018ba954c91$export$54eb7d691768f7f3(_client, _) {
    return $4a210018ba954c91$var$_uninstallFilter.apply(this, arguments);
}
function $4a210018ba954c91$var$_uninstallFilter() {
    $4a210018ba954c91$var$_uninstallFilter = (0, $kSuI9._)(function(_client, param) {
        var filter;
        return (0, $eha6O.__generator)(this, function(_state) {
            filter = param.filter;
            return [
                2,
                filter.request({
                    method: "eth_uninstallFilter",
                    params: [
                        filter.id
                    ]
                })
            ];
        });
    });
    return $4a210018ba954c91$var$_uninstallFilter.apply(this, arguments);
}



var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $dRLPW = parcelRequire("dRLPW");

var $eha6O = parcelRequire("eha6O");

var $h0UKT = parcelRequire("h0UKT");
var $a8b41fe3d2f597b3$export$39d5d904b514ff63 = "\x19Ethereum Signed Message:\n";



var $ewLmX = parcelRequire("ewLmX");

var $dfJGH = parcelRequire("dfJGH");

var $f3VZN = parcelRequire("f3VZN");
function $5599f2ec43478f86$export$6c55de89b570d8ea(message_) {
    var message = function() {
        if (typeof message_ === "string") return (0, $f3VZN.stringToHex)(message_);
        if (typeof message_.raw === "string") return message_.raw;
        return (0, $f3VZN.bytesToHex)(message_.raw);
    }();
    var prefix = (0, $f3VZN.stringToHex)("".concat((0, $a8b41fe3d2f597b3$export$39d5d904b514ff63)).concat((0, $dfJGH.size)(message)));
    return (0, $ewLmX.concat)([
        prefix,
        message
    ]);
}


function $842cfd32f95cd358$export$d4c241cec96564c1(message, to_) {
    return (0, $h0UKT.keccak256)((0, $5599f2ec43478f86$export$6c55de89b570d8ea)(message), to_);
}



var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $dRLPW = parcelRequire("dRLPW");

var $eha6O = parcelRequire("eha6O");

var $9ClpR = parcelRequire("9ClpR");

var $iakMX = parcelRequire("iakMX");

var $fZz5Q = parcelRequire("fZz5Q");

var $af8cf = parcelRequire("af8cf");

var $8zfHX = parcelRequire("8zfHX");

var $7YhYp = parcelRequire("7YhYp");

var $fLMRX = parcelRequire("fLMRX");

var $g8Qfu = parcelRequire("g8Qfu");

var $aP7UT = parcelRequire("aP7UT");
function $0f488b00e21c6255$export$88282e62826c5bec(a_, b_) {
    var a = (0, $aP7UT.isHex)(a_) ? (0, $g8Qfu.toBytes)(a_) : a_;
    var b = (0, $aP7UT.isHex)(b_) ? (0, $g8Qfu.toBytes)(b_) : b_;
    return (0, $fLMRX.equalBytes)(a, b);
}



var $aP7UT = parcelRequire("aP7UT");

var $f3VZN = parcelRequire("f3VZN");

var $0031753df3e0aaef$export$8511286dc8754b90 = "0x6492649264926492649264926492649264926492649264926492649264926492";
var $0031753df3e0aaef$export$2f840586fca04b0e = "0x0000000000000000000000000000000000000000000000000000000000000000";



var $8SGIa = parcelRequire("8SGIa");
function $7b13e91e44fd20f9$export$3d72f97f1f04bf61(signature) {
    return (0, $8SGIa.sliceHex)(signature, -32) === (0, $0031753df3e0aaef$export$8511286dc8754b90);
}





var $iL62l = parcelRequire("iL62l");

var $ewLmX = parcelRequire("ewLmX");

var $g8Qfu = parcelRequire("g8Qfu");
function $4e9b449c61855d35$export$950b6c77371336fb(parameters) {
    var address = parameters.address, data = parameters.data, signature = parameters.signature, _parameters_to = parameters.to, to = _parameters_to === void 0 ? "hex" : _parameters_to;
    var signature_ = (0, $ewLmX.concatHex)([
        (0, $iL62l.encodeAbiParameters)([
            {
                type: "address"
            },
            {
                type: "bytes"
            },
            {
                type: "bytes"
            }
        ], [
            address,
            data,
            signature
        ]),
        (0, $0031753df3e0aaef$export$8511286dc8754b90)
    ]);
    if (to === "hex") return signature_;
    return (0, $g8Qfu.hexToBytes)(signature_);
}



var $9i2gq = parcelRequire("9i2gq");

var $itrhm = parcelRequire("itrhm");

var $g8Qfu = parcelRequire("g8Qfu");
function $833d23bda47a5376$export$97951e8415c34ee5(param) {
    var r = param.r, s = param.s, _param_to = param.to, to = _param_to === void 0 ? "hex" : _param_to, v = param.v, yParity = param.yParity;
    var yParity_ = function() {
        if (yParity === 0 || yParity === 1) return yParity;
        if (v && (v === 27n || v === 28n || v >= 35n)) return v % 2n === 0n ? 1 : 0;
        throw new Error("Invalid `v` or `yParity` value");
    }();
    var signature = "0x".concat(new (0, $9i2gq.secp256k1).Signature((0, $itrhm.hexToBigInt)(r), (0, $itrhm.hexToBigInt)(s)).toCompactHex()).concat(yParity_ === 0 ? "1b" : "1c");
    if (to === "hex") return signature;
    return (0, $g8Qfu.hexToBytes)(signature);
}



var $hy7Ff = parcelRequire("hy7Ff");
function $1af9dce28d0263e8$export$434ee6408013d7f2(client, parameters) {
    return $1af9dce28d0263e8$var$_verifyHash.apply(this, arguments);
}
function $1af9dce28d0263e8$var$_verifyHash() {
    $1af9dce28d0263e8$var$_verifyHash = (0, $kSuI9._)(function(client, parameters) {
        var address, factory, factoryData, hash, signature, rest, signatureHex, wrappedSignature, data, error, verified, _tmp, e;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    address = parameters.address, factory = parameters.factory, factoryData = parameters.factoryData, hash = parameters.hash, signature = parameters.signature, rest = (0, $dRLPW._)(parameters, [
                        "address",
                        "factory",
                        "factoryData",
                        "hash",
                        "signature"
                    ]);
                    signatureHex = function() {
                        if ((0, $aP7UT.isHex)(signature)) return signature;
                        if (typeof signature === "object" && "r" in signature && "s" in signature) return (0, $833d23bda47a5376$export$97951e8415c34ee5)(signature);
                        return (0, $f3VZN.bytesToHex)(signature);
                    }();
                    return [
                        4,
                        (0, $kSuI9._)(function() {
                            return (0, $eha6O.__generator)(this, function(_state) {
                                // If no `factory` or `factoryData` is provided, it is assumed that the
                                // address is not a Smart Account, or the Smart Account is already deployed.
                                if (!factory && !factoryData) return [
                                    2,
                                    signatureHex
                                ];
                                // If the signature is already wrapped, return the signature.
                                if ((0, $7b13e91e44fd20f9$export$3d72f97f1f04bf61)(signatureHex)) return [
                                    2,
                                    signatureHex
                                ];
                                // If the Smart Account is not deployed, wrap the signature with a 6492 wrapper
                                // to perform counterfactual validation.
                                return [
                                    2,
                                    (0, $4e9b449c61855d35$export$950b6c77371336fb)({
                                        address: factory,
                                        data: factoryData,
                                        signature: signatureHex
                                    })
                                ];
                            });
                        })()
                    ];
                case 1:
                    wrappedSignature = _state.sent();
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        9
                    ]);
                    return [
                        4,
                        (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $hy7Ff.call), "call")((0, $do9pw._)({
                            data: (0, $af8cf.encodeDeployData)({
                                abi: (0, $9ClpR.universalSignatureValidatorAbi),
                                args: [
                                    address,
                                    hash,
                                    wrappedSignature
                                ],
                                bytecode: (0, $iakMX.universalSignatureValidatorByteCode)
                            })
                        }, rest))
                    ];
                case 3:
                    data = _state.sent().data;
                    return [
                        2,
                        (0, $0f488b00e21c6255$export$88282e62826c5bec)(data !== null && data !== void 0 ? data : "0x0", "0x1")
                    ];
                case 4:
                    error = _state.sent();
                    _state.label = 5;
                case 5:
                    _state.trys.push([
                        5,
                        7,
                        ,
                        8
                    ]);
                    _tmp = [
                        (0, $8zfHX.getAddress)(address)
                    ];
                    return [
                        4,
                        (0, $d70d5b44ce3174ec$export$23cc18f96d8510e2)({
                            hash: hash,
                            signature: signature
                        })
                    ];
                case 6:
                    verified = (0, $7YhYp.isAddressEqual).apply(void 0, _tmp.concat([
                        _state.sent()
                    ]));
                    if (verified) return [
                        2,
                        true
                    ];
                    return [
                        3,
                        8
                    ];
                case 7:
                    e = _state.sent();
                    return [
                        3,
                        8
                    ];
                case 8:
                    if (error instanceof (0, $fZz5Q.CallExecutionError)) // if the execution fails, the signature was not valid and an internal method inside of the validator reverted
                    // this can happen for many reasons, for example if signer can not be recovered from the signature
                    // or if the signature has no valid format
                    return [
                        2,
                        false
                    ];
                    throw error;
                case 9:
                    return [
                        2
                    ];
            }
        });
    });
    return $1af9dce28d0263e8$var$_verifyHash.apply(this, arguments);
}


function $555b92a84cbdc145$export$228d0e772cc158cb(client, _param) {
    return $555b92a84cbdc145$var$_verifyMessage.apply(this, arguments);
}
function $555b92a84cbdc145$var$_verifyMessage() {
    $555b92a84cbdc145$var$_verifyMessage = (0, $kSuI9._)(function(client, _param) {
        var address, message, factory, factoryData, signature, callRequest, hash;
        return (0, $eha6O.__generator)(this, function(_state) {
            address = _param.address, message = _param.message, factory = _param.factory, factoryData = _param.factoryData, signature = _param.signature, callRequest = (0, $dRLPW._)(_param, [
                "address",
                "message",
                "factory",
                "factoryData",
                "signature"
            ]);
            hash = (0, $842cfd32f95cd358$export$d4c241cec96564c1)(message);
            return [
                2,
                (0, $1af9dce28d0263e8$export$434ee6408013d7f2)(client, (0, $do9pw._)({
                    address: address,
                    factory: factory,
                    factoryData: factoryData,
                    hash: hash,
                    signature: signature
                }, callRequest))
            ];
        });
    });
    return $555b92a84cbdc145$var$_verifyMessage.apply(this, arguments);
}



var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $dRLPW = parcelRequire("dRLPW");

var $eha6O = parcelRequire("eha6O");


function $c8012710d51df460$export$3603b1c1bcd76798(client, parameters) {
    return $c8012710d51df460$var$_verifyTypedData.apply(this, arguments);
}
function $c8012710d51df460$var$_verifyTypedData() {
    $c8012710d51df460$var$_verifyTypedData = (0, $kSuI9._)(function(client, parameters) {
        var address, factory, factoryData, signature, message, primaryType, types, domain, callRequest, hash;
        return (0, $eha6O.__generator)(this, function(_state) {
            address = parameters.address, factory = parameters.factory, factoryData = parameters.factoryData, signature = parameters.signature, message = parameters.message, primaryType = parameters.primaryType, types = parameters.types, domain = parameters.domain, callRequest = (0, $dRLPW._)(parameters, [
                "address",
                "factory",
                "factoryData",
                "signature",
                "message",
                "primaryType",
                "types",
                "domain"
            ]);
            hash = (0, $e3ab2e296963b97e$export$9e2bd399d9aaab56)({
                message: message,
                primaryType: primaryType,
                types: types,
                domain: domain
            });
            return [
                2,
                (0, $1af9dce28d0263e8$export$434ee6408013d7f2)(client, (0, $do9pw._)({
                    address: address,
                    factory: factory,
                    factoryData: factoryData,
                    hash: hash,
                    signature: signature
                }, callRequest))
            ];
        });
    });
    return $c8012710d51df460$var$_verifyTypedData.apply(this, arguments);
}





var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");





var $lUgMT = parcelRequire("lUgMT");

function $c65b7a252afeae23$export$f04bd2888af8db20(client, param) {
    var _param_blockTag = param.blockTag, blockTag = _param_blockTag === void 0 ? "latest" : _param_blockTag, _param_emitMissed = param.emitMissed, emitMissed = _param_emitMissed === void 0 ? false : _param_emitMissed, _param_emitOnBegin = param.emitOnBegin, emitOnBegin = _param_emitOnBegin === void 0 ? false : _param_emitOnBegin, onBlock = param.onBlock, onError = param.onError, includeTransactions_ = param.includeTransactions, poll_ = param.poll, _param_pollingInterval = param.pollingInterval, pollingInterval = _param_pollingInterval === void 0 ? client.pollingInterval : _param_pollingInterval;
    var enablePolling = function() {
        if (typeof poll_ !== "undefined") return poll_;
        if (client.transport.type === "webSocket") return false;
        if (client.transport.type === "fallback" && client.transport.transports[0].config.type === "webSocket") return false;
        return true;
    }();
    var includeTransactions = includeTransactions_ !== null && includeTransactions_ !== void 0 ? includeTransactions_ : false;
    var prevBlock;
    var pollBlocks = function() {
        var observerId = (0, $lUgMT.stringify)([
            "watchBlocks",
            client.uid,
            blockTag,
            emitMissed,
            emitOnBegin,
            includeTransactions,
            pollingInterval
        ]);
        return (0, $4ae5ed700072ba74$export$d1203567a167490e)(observerId, {
            onBlock: onBlock,
            onError: onError
        }, function(emit) {
            return (0, $656bd20abacea8de$export$e0c10349b2c5e1d4)(/*#__PURE__*/ (0, $kSuI9._)(function() {
                var block, i, block1, err, _emit_onError;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                6,
                                ,
                                7
                            ]);
                            return [
                                4,
                                (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $985463a4c6a1d2e4$export$ea0af84ed2e77902), "getBlock")({
                                    blockTag: blockTag,
                                    includeTransactions: includeTransactions
                                })
                            ];
                        case 1:
                            block = _state.sent();
                            if (!(block.number && (prevBlock === null || prevBlock === void 0 ? void 0 : prevBlock.number))) return [
                                3,
                                5
                            ];
                            // If the current block number is the same as the previous,
                            // we can skip.
                            if (block.number === prevBlock.number) return [
                                2
                            ];
                            if (!(block.number - prevBlock.number > 1 && emitMissed)) return [
                                3,
                                5
                            ];
                            i = (prevBlock === null || prevBlock === void 0 ? void 0 : prevBlock.number) + 1n;
                            _state.label = 2;
                        case 2:
                            if (!(i < block.number)) return [
                                3,
                                5
                            ];
                            return [
                                4,
                                (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $985463a4c6a1d2e4$export$ea0af84ed2e77902), "getBlock")({
                                    blockNumber: i,
                                    includeTransactions: includeTransactions
                                })
                            ];
                        case 3:
                            block1 = _state.sent();
                            emit.onBlock(block1, prevBlock);
                            prevBlock = block1;
                            _state.label = 4;
                        case 4:
                            i++;
                            return [
                                3,
                                2
                            ];
                        case 5:
                            if (// If no previous block exists, emit.
                            !(prevBlock === null || prevBlock === void 0 ? void 0 : prevBlock.number) || // If the block tag is "pending" with no block number, emit.
                            blockTag === "pending" && !(block === null || block === void 0 ? void 0 : block.number) || // If the next block number is greater than the previous block number, emit.
                            // We don't want to emit blocks in the past.
                            block.number && block.number > prevBlock.number) {
                                emit.onBlock(block, prevBlock);
                                prevBlock = block;
                            }
                            return [
                                3,
                                7
                            ];
                        case 6:
                            err = _state.sent();
                            (_emit_onError = emit.onError) === null || _emit_onError === void 0 ? void 0 : _emit_onError.call(emit, err);
                            return [
                                3,
                                7
                            ];
                        case 7:
                            return [
                                2
                            ];
                    }
                });
            }), {
                emitOnBegin: emitOnBegin,
                interval: pollingInterval
            });
        });
    };
    var subscribeBlocks = function() {
        var active = true;
        var unsubscribe = function() {
            return active = false;
        };
        (0, $kSuI9._)(function() {
            var transport, _ref, unsubscribe_, err;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        transport = function() {
                            if (client.transport.type === "fallback") {
                                var transport = client.transport.transports.find(function(transport) {
                                    return transport.config.type === "webSocket";
                                });
                                if (!transport) return client.transport;
                                return transport.value;
                            }
                            return client.transport;
                        }();
                        return [
                            4,
                            transport.subscribe({
                                params: [
                                    "newHeads"
                                ],
                                onData: function(data) {
                                    var _client_chain_formatters_block, _client_chain_formatters, _client_chain;
                                    if (!active) return;
                                    var format = ((_client_chain = client.chain) === null || _client_chain === void 0 ? void 0 : (_client_chain_formatters = _client_chain.formatters) === null || _client_chain_formatters === void 0 ? void 0 : (_client_chain_formatters_block = _client_chain_formatters.block) === null || _client_chain_formatters_block === void 0 ? void 0 : _client_chain_formatters_block.format) || (0, $f6087e0399f0c94f$export$ba1152bc4017d62a);
                                    var block = format(data.result);
                                    onBlock(block, prevBlock);
                                    prevBlock = block;
                                },
                                onError: function(error) {
                                    onError === null || onError === void 0 ? void 0 : onError(error);
                                }
                            })
                        ];
                    case 1:
                        _ref = _state.sent(), unsubscribe_ = _ref.unsubscribe;
                        unsubscribe = unsubscribe_;
                        if (!active) unsubscribe();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        onError === null || onError === void 0 ? void 0 : onError(err);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
        return function() {
            return unsubscribe();
        };
    };
    return enablePolling ? pollBlocks() : subscribeBlocks();
}



var $kSuI9 = parcelRequire("kSuI9");

var $l0HdX = parcelRequire("l0HdX");

var $eha6O = parcelRequire("eha6O");

var $fLalY = parcelRequire("fLalY");

var $aqVrP = parcelRequire("aqVrP");







var $lUgMT = parcelRequire("lUgMT");





function $c6161c0f9cfa9763$export$2a02a63daa2df376(client, parameters) {
    var abi = parameters.abi, address = parameters.address, args = parameters.args, _parameters_batch = parameters.batch, batch = _parameters_batch === void 0 ? true : _parameters_batch, eventName = parameters.eventName, fromBlock = parameters.fromBlock, onError = parameters.onError, onLogs = parameters.onLogs, poll_ = parameters.poll, _parameters_pollingInterval = parameters.pollingInterval, pollingInterval = _parameters_pollingInterval === void 0 ? client.pollingInterval : _parameters_pollingInterval, strict_ = parameters.strict;
    var enablePolling = function() {
        if (typeof poll_ !== "undefined") return poll_;
        if ((typeof fromBlock === "undefined" ? "undefined" : (0, $l0HdX._)(fromBlock)) === "bigint") return true;
        if (client.transport.type === "webSocket") return false;
        if (client.transport.type === "fallback" && client.transport.transports[0].config.type === "webSocket") return false;
        return true;
    }();
    var pollContractEvent = function() {
        var strict = strict_ !== null && strict_ !== void 0 ? strict_ : false;
        var observerId = (0, $lUgMT.stringify)([
            "watchContractEvent",
            address,
            args,
            batch,
            client.uid,
            eventName,
            pollingInterval,
            strict,
            fromBlock
        ]);
        return (0, $4ae5ed700072ba74$export$d1203567a167490e)(observerId, {
            onLogs: onLogs,
            onError: onError
        }, function(emit) {
            var previousBlockNumber;
            if (fromBlock !== undefined) previousBlockNumber = fromBlock - 1n;
            var filter;
            var initialized = false;
            var unwatch = (0, $656bd20abacea8de$export$e0c10349b2c5e1d4)(/*#__PURE__*/ (0, $kSuI9._)(function() {
                var e, logs, blockNumber, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, log, err, _emit_onError;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!!initialized) return [
                                3,
                                5
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $a4ada780449c7224$export$36f99fdb90149e8b), "createContractEventFilter")({
                                    abi: abi,
                                    address: address,
                                    args: args,
                                    eventName: eventName,
                                    strict: strict,
                                    fromBlock: fromBlock
                                })
                            ];
                        case 2:
                            filter = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            initialized = true;
                            return [
                                2
                            ];
                        case 5:
                            _state.trys.push([
                                5,
                                13,
                                ,
                                14
                            ]);
                            if (!filter) return [
                                3,
                                7
                            ];
                            return [
                                4,
                                (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $745e63ecde4cca0f$export$e69fa84ce52a94fd), "getFilterChanges")({
                                    filter: filter
                                })
                            ];
                        case 6:
                            logs = _state.sent();
                            return [
                                3,
                                12
                            ];
                        case 7:
                            return [
                                4,
                                (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $1b10c774854a89ed$export$9328b5c92c53a20e), "getBlockNumber")({})
                            ];
                        case 8:
                            blockNumber = _state.sent();
                            if (!(previousBlockNumber && previousBlockNumber < blockNumber)) return [
                                3,
                                10
                            ];
                            return [
                                4,
                                (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $c7cf0e41c9b19a2b$export$1e175955db02d8d), "getContractEvents")({
                                    abi: abi,
                                    address: address,
                                    args: args,
                                    eventName: eventName,
                                    fromBlock: previousBlockNumber + 1n,
                                    toBlock: blockNumber,
                                    strict: strict
                                })
                            ];
                        case 9:
                            logs = _state.sent();
                            return [
                                3,
                                11
                            ];
                        case 10:
                            logs = [];
                            _state.label = 11;
                        case 11:
                            previousBlockNumber = blockNumber;
                            _state.label = 12;
                        case 12:
                            if (logs.length === 0) return [
                                2
                            ];
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            if (batch) emit.onLogs(logs);
                            else try {
                                for(_iterator = logs[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    log = _step.value;
                                    emit.onLogs([
                                        log
                                    ]);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            return [
                                3,
                                14
                            ];
                        case 13:
                            err = _state.sent();
                            // If a filter has been set and gets uninstalled, providers will throw an InvalidInput error.
                            // Reinitialize the filter when this occurs
                            if (filter && err instanceof (0, $aqVrP.InvalidInputRpcError)) initialized = false;
                            (_emit_onError = emit.onError) === null || _emit_onError === void 0 ? void 0 : _emit_onError.call(emit, err);
                            return [
                                3,
                                14
                            ];
                        case 14:
                            return [
                                2
                            ];
                    }
                });
            }), {
                emitOnBegin: true,
                interval: pollingInterval
            });
            return /*#__PURE__*/ (0, $kSuI9._)(function() {
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!filter) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $4a210018ba954c91$export$54eb7d691768f7f3), "uninstallFilter")({
                                    filter: filter
                                })
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            unwatch();
                            return [
                                2
                            ];
                    }
                });
            });
        });
    };
    var subscribeContractEvent = function() {
        var strict = strict_ !== null && strict_ !== void 0 ? strict_ : false;
        var observerId = (0, $lUgMT.stringify)([
            "watchContractEvent",
            address,
            args,
            batch,
            client.uid,
            eventName,
            pollingInterval,
            strict
        ]);
        var active = true;
        var unsubscribe = function() {
            return active = false;
        };
        return (0, $4ae5ed700072ba74$export$d1203567a167490e)(observerId, {
            onLogs: onLogs,
            onError: onError
        }, function(emit) {
            (0, $kSuI9._)(function() {
                var transport, topics, _ref, unsubscribe_, err;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            transport = function() {
                                if (client.transport.type === "fallback") {
                                    var transport = client.transport.transports.find(function(transport) {
                                        return transport.config.type === "webSocket";
                                    });
                                    if (!transport) return client.transport;
                                    return transport.value;
                                }
                                return client.transport;
                            }();
                            topics = eventName ? (0, $608dffba10df3e8b$export$64e9f7ca5ce29acd)({
                                abi: abi,
                                eventName: eventName,
                                args: args
                            }) : [];
                            return [
                                4,
                                transport.subscribe({
                                    params: [
                                        "logs",
                                        {
                                            address: address,
                                            topics: topics
                                        }
                                    ],
                                    onData: function(data) {
                                        if (!active) return;
                                        var log = data.result;
                                        try {
                                            var _decodeEventLog = (0, $08263f7f1338aacd$export$ec0597e81db3d947)({
                                                abi: abi,
                                                data: log.data,
                                                topics: log.topics,
                                                strict: strict_
                                            }), eventName = _decodeEventLog.eventName, args = _decodeEventLog.args;
                                            var formatted = (0, $55e0178b1429ebe9$export$fccdbdc2b9d7893)(log, {
                                                args: args,
                                                eventName: eventName
                                            });
                                            emit.onLogs([
                                                formatted
                                            ]);
                                        } catch (err) {
                                            var eventName1;
                                            var isUnnamed;
                                            if (err instanceof (0, $fLalY.DecodeLogDataMismatch) || err instanceof (0, $fLalY.DecodeLogTopicsMismatch)) {
                                                var _err_abiItem_inputs;
                                                // If strict mode is on, and log data/topics do not match event definition, skip.
                                                if (strict_) return;
                                                eventName1 = err.abiItem.name;
                                                isUnnamed = (_err_abiItem_inputs = err.abiItem.inputs) === null || _err_abiItem_inputs === void 0 ? void 0 : _err_abiItem_inputs.some(function(x) {
                                                    return !("name" in x && x.name);
                                                });
                                            }
                                            // Set args to empty if there is an error decoding (e.g. indexed/non-indexed params mismatch).
                                            var formatted1 = (0, $55e0178b1429ebe9$export$fccdbdc2b9d7893)(log, {
                                                args: isUnnamed ? [] : {},
                                                eventName: eventName1
                                            });
                                            emit.onLogs([
                                                formatted1
                                            ]);
                                        }
                                    },
                                    onError: function(error) {
                                        var _emit_onError;
                                        (_emit_onError = emit.onError) === null || _emit_onError === void 0 ? void 0 : _emit_onError.call(emit, error);
                                    }
                                })
                            ];
                        case 1:
                            _ref = _state.sent(), unsubscribe_ = _ref.unsubscribe;
                            unsubscribe = unsubscribe_;
                            if (!active) unsubscribe();
                            return [
                                3,
                                3
                            ];
                        case 2:
                            err = _state.sent();
                            onError === null || onError === void 0 ? void 0 : onError(err);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
            return function() {
                return unsubscribe();
            };
        });
    };
    return enablePolling ? pollContractEvent() : subscribeContractEvent();
}



var $kSuI9 = parcelRequire("kSuI9");

var $l0HdX = parcelRequire("l0HdX");

var $eha6O = parcelRequire("eha6O");




var $lUgMT = parcelRequire("lUgMT");

var $fLalY = parcelRequire("fLalY");

var $aqVrP = parcelRequire("aqVrP");








function $dce898742824ae8e$export$f6260ad5441916b4(client, param) {
    var address = param.address, args = param.args, _param_batch = param.batch, batch = _param_batch === void 0 ? true : _param_batch, event = param.event, events = param.events, fromBlock = param.fromBlock, onError = param.onError, onLogs = param.onLogs, poll_ = param.poll, _param_pollingInterval = param.pollingInterval, pollingInterval = _param_pollingInterval === void 0 ? client.pollingInterval : _param_pollingInterval, strict_ = param.strict;
    var enablePolling = function() {
        if (typeof poll_ !== "undefined") return poll_;
        if ((typeof fromBlock === "undefined" ? "undefined" : (0, $l0HdX._)(fromBlock)) === "bigint") return true;
        if (client.transport.type === "webSocket") return false;
        if (client.transport.type === "fallback" && client.transport.transports[0].config.type === "webSocket") return false;
        return true;
    }();
    var strict = strict_ !== null && strict_ !== void 0 ? strict_ : false;
    var pollEvent = function() {
        var observerId = (0, $lUgMT.stringify)([
            "watchEvent",
            address,
            args,
            batch,
            client.uid,
            event,
            pollingInterval,
            fromBlock
        ]);
        return (0, $4ae5ed700072ba74$export$d1203567a167490e)(observerId, {
            onLogs: onLogs,
            onError: onError
        }, function(emit) {
            var previousBlockNumber;
            if (fromBlock !== undefined) previousBlockNumber = fromBlock - 1n;
            var filter;
            var initialized = false;
            var unwatch = (0, $656bd20abacea8de$export$e0c10349b2c5e1d4)(/*#__PURE__*/ (0, $kSuI9._)(function() {
                var e, logs, blockNumber, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, log, err, _emit_onError;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!!initialized) return [
                                3,
                                5
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $a1db1fb484e19edd$export$977ab14bbccde633), "createEventFilter")({
                                    address: address,
                                    args: args,
                                    event: event,
                                    events: events,
                                    strict: strict,
                                    fromBlock: fromBlock
                                })
                            ];
                        case 2:
                            filter = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            initialized = true;
                            return [
                                2
                            ];
                        case 5:
                            _state.trys.push([
                                5,
                                13,
                                ,
                                14
                            ]);
                            if (!filter) return [
                                3,
                                7
                            ];
                            return [
                                4,
                                (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $745e63ecde4cca0f$export$e69fa84ce52a94fd), "getFilterChanges")({
                                    filter: filter
                                })
                            ];
                        case 6:
                            logs = _state.sent();
                            return [
                                3,
                                12
                            ];
                        case 7:
                            return [
                                4,
                                (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $1b10c774854a89ed$export$9328b5c92c53a20e), "getBlockNumber")({})
                            ];
                        case 8:
                            blockNumber = _state.sent();
                            if (!(previousBlockNumber && previousBlockNumber !== blockNumber)) return [
                                3,
                                10
                            ];
                            return [
                                4,
                                (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $6ff42dbea0cf781e$export$cb5260c832aab30a), "getLogs")({
                                    address: address,
                                    args: args,
                                    event: event,
                                    events: events,
                                    fromBlock: previousBlockNumber + 1n,
                                    toBlock: blockNumber
                                })
                            ];
                        case 9:
                            logs = _state.sent();
                            return [
                                3,
                                11
                            ];
                        case 10:
                            logs = [];
                            _state.label = 11;
                        case 11:
                            previousBlockNumber = blockNumber;
                            _state.label = 12;
                        case 12:
                            if (logs.length === 0) return [
                                2
                            ];
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            if (batch) emit.onLogs(logs);
                            else try {
                                for(_iterator = logs[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    log = _step.value;
                                    emit.onLogs([
                                        log
                                    ]);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            return [
                                3,
                                14
                            ];
                        case 13:
                            err = _state.sent();
                            // If a filter has been set and gets uninstalled, providers will throw an InvalidInput error.
                            // Reinitialize the filter when this occurs
                            if (filter && err instanceof (0, $aqVrP.InvalidInputRpcError)) initialized = false;
                            (_emit_onError = emit.onError) === null || _emit_onError === void 0 ? void 0 : _emit_onError.call(emit, err);
                            return [
                                3,
                                14
                            ];
                        case 14:
                            return [
                                2
                            ];
                    }
                });
            }), {
                emitOnBegin: true,
                interval: pollingInterval
            });
            return /*#__PURE__*/ (0, $kSuI9._)(function() {
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!filter) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $4a210018ba954c91$export$54eb7d691768f7f3), "uninstallFilter")({
                                    filter: filter
                                })
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            unwatch();
                            return [
                                2
                            ];
                    }
                });
            });
        });
    };
    var subscribeEvent = function() {
        var active = true;
        var unsubscribe = function() {
            return active = false;
        };
        (0, $kSuI9._)(function() {
            var transport, events_, topics, encoded, _ref, unsubscribe_, err;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        transport = function() {
                            if (client.transport.type === "fallback") {
                                var transport = client.transport.transports.find(function(transport) {
                                    return transport.config.type === "webSocket";
                                });
                                if (!transport) return client.transport;
                                return transport.value;
                            }
                            return client.transport;
                        }();
                        events_ = events !== null && events !== void 0 ? events : event ? [
                            event
                        ] : undefined;
                        topics = [];
                        if (events_) {
                            encoded = events_.flatMap(function(event) {
                                return (0, $608dffba10df3e8b$export$64e9f7ca5ce29acd)({
                                    abi: [
                                        event
                                    ],
                                    eventName: event.name,
                                    args: args
                                });
                            });
                            // TODO: Clean up type casting
                            topics = [
                                encoded
                            ];
                            if (event) topics = topics[0];
                        }
                        return [
                            4,
                            transport.subscribe({
                                params: [
                                    "logs",
                                    {
                                        address: address,
                                        topics: topics
                                    }
                                ],
                                onData: function(data) {
                                    if (!active) return;
                                    var log = data.result;
                                    try {
                                        var _decodeEventLog = (0, $08263f7f1338aacd$export$ec0597e81db3d947)({
                                            abi: events_ !== null && events_ !== void 0 ? events_ : [],
                                            data: log.data,
                                            topics: log.topics,
                                            strict: strict
                                        }), eventName = _decodeEventLog.eventName, args = _decodeEventLog.args;
                                        var formatted = (0, $55e0178b1429ebe9$export$fccdbdc2b9d7893)(log, {
                                            args: args,
                                            eventName: eventName
                                        });
                                        onLogs([
                                            formatted
                                        ]);
                                    } catch (err) {
                                        var eventName1;
                                        var isUnnamed;
                                        if (err instanceof (0, $fLalY.DecodeLogDataMismatch) || err instanceof (0, $fLalY.DecodeLogTopicsMismatch)) {
                                            var _err_abiItem_inputs;
                                            // If strict mode is on, and log data/topics do not match event definition, skip.
                                            if (strict_) return;
                                            eventName1 = err.abiItem.name;
                                            isUnnamed = (_err_abiItem_inputs = err.abiItem.inputs) === null || _err_abiItem_inputs === void 0 ? void 0 : _err_abiItem_inputs.some(function(x) {
                                                return !("name" in x && x.name);
                                            });
                                        }
                                        // Set args to empty if there is an error decoding (e.g. indexed/non-indexed params mismatch).
                                        var formatted1 = (0, $55e0178b1429ebe9$export$fccdbdc2b9d7893)(log, {
                                            args: isUnnamed ? [] : {},
                                            eventName: eventName1
                                        });
                                        onLogs([
                                            formatted1
                                        ]);
                                    }
                                },
                                onError: function(error) {
                                    onError === null || onError === void 0 ? void 0 : onError(error);
                                }
                            })
                        ];
                    case 1:
                        _ref = _state.sent(), unsubscribe_ = _ref.unsubscribe;
                        unsubscribe = unsubscribe_;
                        if (!active) unsubscribe();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        onError === null || onError === void 0 ? void 0 : onError(err);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
        return function() {
            return unsubscribe();
        };
    };
    return enablePolling ? pollEvent() : subscribeEvent();
}



var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");




var $lUgMT = parcelRequire("lUgMT");



function $48ff1528b107fecb$export$223080172c87e789(client, param) {
    var _param_batch = param.batch, batch = _param_batch === void 0 ? true : _param_batch, onError = param.onError, onTransactions = param.onTransactions, poll_ = param.poll, _param_pollingInterval = param.pollingInterval, pollingInterval = _param_pollingInterval === void 0 ? client.pollingInterval : _param_pollingInterval;
    var enablePolling = typeof poll_ !== "undefined" ? poll_ : client.transport.type !== "webSocket";
    var pollPendingTransactions = function() {
        var observerId = (0, $lUgMT.stringify)([
            "watchPendingTransactions",
            client.uid,
            batch,
            pollingInterval
        ]);
        return (0, $4ae5ed700072ba74$export$d1203567a167490e)(observerId, {
            onTransactions: onTransactions,
            onError: onError
        }, function(emit) {
            var filter;
            var unwatch = (0, $656bd20abacea8de$export$e0c10349b2c5e1d4)(/*#__PURE__*/ (0, $kSuI9._)(function() {
                var err, hashes, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, hash, err1, _emit_onError;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                6,
                                ,
                                7
                            ]);
                            if (!!filter) return [
                                3,
                                4
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $705745bab512e2e7$export$d455ed04c3e85241), "createPendingTransactionFilter")({})
                            ];
                        case 2:
                            filter = _state.sent();
                            return [
                                2
                            ];
                        case 3:
                            err = _state.sent();
                            unwatch();
                            throw err;
                        case 4:
                            return [
                                4,
                                (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $745e63ecde4cca0f$export$e69fa84ce52a94fd), "getFilterChanges")({
                                    filter: filter
                                })
                            ];
                        case 5:
                            hashes = _state.sent();
                            if (hashes.length === 0) return [
                                2
                            ];
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            if (batch) emit.onTransactions(hashes);
                            else try {
                                for(_iterator = hashes[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    hash = _step.value;
                                    emit.onTransactions([
                                        hash
                                    ]);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            return [
                                3,
                                7
                            ];
                        case 6:
                            err1 = _state.sent();
                            (_emit_onError = emit.onError) === null || _emit_onError === void 0 ? void 0 : _emit_onError.call(emit, err1);
                            return [
                                3,
                                7
                            ];
                        case 7:
                            return [
                                2
                            ];
                    }
                });
            }), {
                emitOnBegin: true,
                interval: pollingInterval
            });
            return /*#__PURE__*/ (0, $kSuI9._)(function() {
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!filter) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $4a210018ba954c91$export$54eb7d691768f7f3), "uninstallFilter")({
                                    filter: filter
                                })
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            unwatch();
                            return [
                                2
                            ];
                    }
                });
            });
        });
    };
    var subscribePendingTransactions = function() {
        var active = true;
        var unsubscribe = function() {
            return active = false;
        };
        (0, $kSuI9._)(function() {
            var _ref, unsubscribe_, err;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            client.transport.subscribe({
                                params: [
                                    "newPendingTransactions"
                                ],
                                onData: function(data) {
                                    if (!active) return;
                                    var transaction = data.result;
                                    onTransactions([
                                        transaction
                                    ]);
                                },
                                onError: function(error) {
                                    onError === null || onError === void 0 ? void 0 : onError(error);
                                }
                            })
                        ];
                    case 1:
                        _ref = _state.sent(), unsubscribe_ = _ref.unsubscribe;
                        unsubscribe = unsubscribe_;
                        if (!active) unsubscribe();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        onError === null || onError === void 0 ? void 0 : onError(err);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
        return function() {
            return unsubscribe();
        };
    };
    return enablePolling ? pollPendingTransactions() : subscribePendingTransactions();
}



var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $dRLPW = parcelRequire("dRLPW");

var $eha6O = parcelRequire("eha6O");

/**
 * @description Parses EIP-4361 formatted message into message fields object.
 *
 * @see https://eips.ethereum.org/EIPS/eip-4361
 *
 * @returns EIP-4361 fields object
 */ 
var $do9pw = parcelRequire("do9pw");

var $dRLPW = parcelRequire("dRLPW");
function $0452b423bc60318b$export$ebbfe406e131b6f6(message) {
    var _message_match, _message_match1, _message_split_;
    var _message_match_groups;
    var _ref = (_message_match_groups = (_message_match = message.match($0452b423bc60318b$var$prefixRegex)) === null || _message_match === void 0 ? void 0 : _message_match.groups) !== null && _message_match_groups !== void 0 ? _message_match_groups : {}, scheme = _ref.scheme, statement = _ref.statement, prefix = (0, $dRLPW._)(_ref, [
        "scheme",
        "statement"
    ]);
    var _message_match_groups1;
    var _ref1 = (_message_match_groups1 = (_message_match1 = message.match($0452b423bc60318b$var$suffixRegex)) === null || _message_match1 === void 0 ? void 0 : _message_match1.groups) !== null && _message_match_groups1 !== void 0 ? _message_match_groups1 : {}, chainId = _ref1.chainId, expirationTime = _ref1.expirationTime, issuedAt = _ref1.issuedAt, notBefore = _ref1.notBefore, requestId = _ref1.requestId, suffix = (0, $dRLPW._)(_ref1, [
        "chainId",
        "expirationTime",
        "issuedAt",
        "notBefore",
        "requestId"
    ]);
    var resources = (_message_split_ = message.split("Resources:")[1]) === null || _message_split_ === void 0 ? void 0 : _message_split_.split("\n- ").slice(1);
    return (0, $do9pw._)({}, prefix, suffix, chainId ? {
        chainId: Number(chainId)
    } : {}, expirationTime ? {
        expirationTime: new Date(expirationTime)
    } : {}, issuedAt ? {
        issuedAt: new Date(issuedAt)
    } : {}, notBefore ? {
        notBefore: new Date(notBefore)
    } : {}, requestId ? {
        requestId: requestId
    } : {}, resources ? {
        resources: resources
    } : {}, scheme ? {
        scheme: scheme
    } : {}, statement ? {
        statement: statement
    } : {});
}
// https://regexr.com/80gdj
var $0452b423bc60318b$var$prefixRegex = RegExp("^(?:(?<scheme>[a-zA-Z][a-zA-Z0-9+-.]*):\\/\\/)?(?<domain>[a-zA-Z0-9+-.]*(?::[0-9]{1,5})?) (?:wants you to sign in with your Ethereum account:\\n)(?<address>0x[a-fA-F0-9]{40})\\n\\n(?:(?<statement>.*)\\n\\n)?");
// https://regexr.com/80gf9
var $0452b423bc60318b$var$suffixRegex = RegExp("(?:URI: (?<uri>.+))\\n(?:Version: (?<version>.+))\\n(?:Chain ID: (?<chainId>\\d+))\\n(?:Nonce: (?<nonce>[a-zA-Z0-9]+))\\n(?:Issued At: (?<issuedAt>.+))(?:\\nExpiration Time: (?<expirationTime>.+))?(?:\\nNot Before: (?<notBefore>.+))?(?:\\nRequest ID: (?<requestId>.+))?");



var $7YhYp = parcelRequire("7YhYp");
function $91d7dd126b950a5e$export$d3bfd63549572667(parameters) {
    var address = parameters.address, domain = parameters.domain, message = parameters.message, nonce = parameters.nonce, scheme = parameters.scheme, _parameters_time = parameters.time, time = _parameters_time === void 0 ? new Date() : _parameters_time;
    if (domain && message.domain !== domain) return false;
    if (nonce && message.nonce !== nonce) return false;
    if (scheme && message.scheme !== scheme) return false;
    if (message.expirationTime && time >= message.expirationTime) return false;
    if (message.notBefore && time < message.notBefore) return false;
    try {
        if (!message.address) return false;
        if (address && !(0, $7YhYp.isAddressEqual)(message.address, address)) return false;
    } catch (e) {
        return false;
    }
    return true;
}



function $7ffe67b15bf271b0$export$10c59ebee3bc23e3(client, parameters) {
    return $7ffe67b15bf271b0$var$_verifySiweMessage.apply(this, arguments);
}
function $7ffe67b15bf271b0$var$_verifySiweMessage() {
    $7ffe67b15bf271b0$var$_verifySiweMessage = (0, $kSuI9._)(function(client, parameters) {
        var address, domain, message, nonce, scheme, signature, _parameters_time, time, callRequest, parsed, isValid, hash;
        return (0, $eha6O.__generator)(this, function(_state) {
            address = parameters.address, domain = parameters.domain, message = parameters.message, nonce = parameters.nonce, scheme = parameters.scheme, signature = parameters.signature, _parameters_time = parameters.time, time = _parameters_time === void 0 ? new Date() : _parameters_time, callRequest = (0, $dRLPW._)(parameters, [
                "address",
                "domain",
                "message",
                "nonce",
                "scheme",
                "signature",
                "time"
            ]);
            parsed = (0, $0452b423bc60318b$export$ebbfe406e131b6f6)(message);
            if (!parsed.address) return [
                2,
                false
            ];
            isValid = (0, $91d7dd126b950a5e$export$d3bfd63549572667)({
                address: address,
                domain: domain,
                message: parsed,
                nonce: nonce,
                scheme: scheme,
                time: time
            });
            if (!isValid) return [
                2,
                false
            ];
            hash = (0, $842cfd32f95cd358$export$d4c241cec96564c1)(message);
            return [
                2,
                (0, $1af9dce28d0263e8$export$434ee6408013d7f2)(client, (0, $do9pw._)({
                    address: parsed.address,
                    hash: hash,
                    signature: signature
                }, callRequest))
            ];
        });
    });
    return $7ffe67b15bf271b0$var$_verifySiweMessage.apply(this, arguments);
}




function $0a016c258b7265e5$export$8705b583fa097d24(client) {
    return {
        call: function(args) {
            return (0, $hy7Ff.call)(client, args);
        },
        createBlockFilter: function() {
            return (0, $9f3183c77e2d2785$export$651edd5ecf84bf98)(client);
        },
        createContractEventFilter: function(args) {
            return (0, $a4ada780449c7224$export$36f99fdb90149e8b)(client, args);
        },
        createEventFilter: function(args) {
            return (0, $a1db1fb484e19edd$export$977ab14bbccde633)(client, args);
        },
        createPendingTransactionFilter: function() {
            return (0, $705745bab512e2e7$export$d455ed04c3e85241)(client);
        },
        estimateContractGas: function(args) {
            return (0, $26658049de670cf6$export$7b896b3a3695de87)(client, args);
        },
        estimateGas: function(args) {
            return (0, $decf603c2fa0d1c4$export$e0580ae1f48db848)(client, args);
        },
        getBalance: function(args) {
            return (0, $179cf38efbf30cf7$export$df96cd8d56be0ab1)(client, args);
        },
        getBlobBaseFee: function() {
            return (0, $b52281f217393855$export$9682cd49f77b48b)(client);
        },
        getBlock: function(args) {
            return (0, $985463a4c6a1d2e4$export$ea0af84ed2e77902)(client, args);
        },
        getBlockNumber: function(args) {
            return (0, $1b10c774854a89ed$export$9328b5c92c53a20e)(client, args);
        },
        getBlockTransactionCount: function(args) {
            return (0, $c5decdc35e85b209$export$8c2de5be7f4dfc0)(client, args);
        },
        getBytecode: function(args) {
            return (0, $37d2500dd5b8229d$export$9a0a9c75ccef13fb)(client, args);
        },
        getChainId: function() {
            return (0, $3f6367ac0fc6b0ac$export$850fa7b3891187c)(client);
        },
        getCode: function(args) {
            return (0, $37d2500dd5b8229d$export$9a0a9c75ccef13fb)(client, args);
        },
        getContractEvents: function(args) {
            return (0, $c7cf0e41c9b19a2b$export$1e175955db02d8d)(client, args);
        },
        getEip712Domain: function(args) {
            return (0, $dd2762f9c6af6f48$export$78097141abc77755)(client, args);
        },
        getEnsAddress: function(args) {
            return (0, $1cba6a8167532c80$export$24b77c7e87f05b8d)(client, args);
        },
        getEnsAvatar: function(args) {
            return (0, $2fb6ebea52500c21$export$65f1d2b9649a54e5)(client, args);
        },
        getEnsName: function(args) {
            return (0, $e151f531924cea99$export$e1b98d9bc05a9fc2)(client, args);
        },
        getEnsResolver: function(args) {
            return (0, $96c1b7ca5662843b$export$ba1240cd558e6b31)(client, args);
        },
        getEnsText: function(args) {
            return (0, $f16202edb526a59f$export$2b2c96dabd62b431)(client, args);
        },
        getFeeHistory: function(args) {
            return (0, $531e1d56a4ecf199$export$66598bc0c00a958e)(client, args);
        },
        estimateFeesPerGas: function(args) {
            return (0, $c6a8e460e4f994e2$export$8193bed8c46d2831)(client, args);
        },
        getFilterChanges: function(args) {
            return (0, $745e63ecde4cca0f$export$e69fa84ce52a94fd)(client, args);
        },
        getFilterLogs: function(args) {
            return (0, $03463eb6f48aa255$export$776d3b8c33a8b58)(client, args);
        },
        getGasPrice: function() {
            return (0, $d938e21ef1904b42$export$89c15b50d46d3f8c)(client);
        },
        getLogs: function(args) {
            return (0, $6ff42dbea0cf781e$export$cb5260c832aab30a)(client, args);
        },
        getProof: function(args) {
            return (0, $2b7cd1f962a94eab$export$4a314c097411dc17)(client, args);
        },
        estimateMaxPriorityFeePerGas: function(args) {
            return (0, $0a0dd3d64a962158$export$fd79a693887f886c)(client, args);
        },
        getStorageAt: function(args) {
            return (0, $d4d64bfbd07c3570$export$14e244c1a3c8527e)(client, args);
        },
        getTransaction: function(args) {
            return (0, $55ff11d9c8fdfd6e$export$ec0c6556a09b65b8)(client, args);
        },
        getTransactionConfirmations: function(args) {
            return (0, $f166e01feb50786f$export$e2ccc904d713b66d)(client, args);
        },
        getTransactionCount: function(args) {
            return (0, $920033f9ccbbdb05$export$b18e66333ec1361e)(client, args);
        },
        getTransactionReceipt: function(args) {
            return (0, $f0ad3251ac056bba$export$6b1ceb3cd5f8b21f)(client, args);
        },
        multicall: function(args) {
            return (0, $47b9a12e2fcb3d2a$export$60ef70589ee4f7ad)(client, args);
        },
        prepareTransactionRequest: function(args) {
            return (0, $4869f53cd4aaa39a$export$2e8a9232fb815d77)(client, args);
        },
        readContract: function(args) {
            return (0, $1500f99f7733ae7a$export$43af7de392176737)(client, args);
        },
        sendRawTransaction: function(args) {
            return (0, $da458af31d30456f$export$4e309754b4830e29)(client, args);
        },
        simulateContract: function(args) {
            return (0, $a35082122e3eb786$export$e8798d551e27a374)(client, args);
        },
        verifyMessage: function(args) {
            return (0, $555b92a84cbdc145$export$228d0e772cc158cb)(client, args);
        },
        verifySiweMessage: function(args) {
            return (0, $7ffe67b15bf271b0$export$10c59ebee3bc23e3)(client, args);
        },
        verifyTypedData: function(args) {
            return (0, $c8012710d51df460$export$3603b1c1bcd76798)(client, args);
        },
        uninstallFilter: function(args) {
            return (0, $4a210018ba954c91$export$54eb7d691768f7f3)(client, args);
        },
        waitForTransactionReceipt: function(args) {
            return (0, $209a49fa49253b0e$export$694ec9bdf0bb55cf)(client, args);
        },
        watchBlocks: function(args) {
            return (0, $c65b7a252afeae23$export$f04bd2888af8db20)(client, args);
        },
        watchBlockNumber: function(args) {
            return (0, $60a9ddfed54c508b$export$fc5f622dd0d82466)(client, args);
        },
        watchContractEvent: function(args) {
            return (0, $c6161c0f9cfa9763$export$2a02a63daa2df376)(client, args);
        },
        watchEvent: function(args) {
            return (0, $dce898742824ae8e$export$f6260ad5441916b4)(client, args);
        },
        watchPendingTransactions: function(args) {
            return (0, $48ff1528b107fecb$export$223080172c87e789)(client, args);
        }
    };
}


function $a598c2a734c32a1f$export$d8e090d8c6a7a6ad(parameters) {
    var _parameters_key = parameters.key, key = _parameters_key === void 0 ? "public" : _parameters_key, _parameters_name = parameters.name, name = _parameters_name === void 0 ? "Public Client" : _parameters_name;
    var client = (0, $3b636b6bfcd71602$export$5d730b7aed1a3eb0)((0, $cxjpp._)((0, $do9pw._)({}, parameters), {
        key: key,
        name: name,
        type: "publicClient"
    }));
    return client.extend((0, $0a016c258b7265e5$export$8705b583fa097d24));
}


var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $cv9Rk = parcelRequire("cv9Rk");








function $67aa6ee4e548d91c$export$f518c38144e1f9d(param) {
    var abi = param.abi, address = param.address, client_ = param.client;
    var client = client_;
    var _ref = (0, $cv9Rk._)(function() {
        if (!client) return [
            undefined,
            undefined
        ];
        if ("public" in client && "wallet" in client) return [
            client.public,
            client.wallet
        ];
        if ("public" in client) return [
            client.public,
            undefined
        ];
        if ("wallet" in client) return [
            undefined,
            client.wallet
        ];
        return [
            client,
            client
        ];
    }(), 2), publicClient = _ref[0], walletClient = _ref[1];
    var hasPublicClient = publicClient !== undefined && publicClient !== null;
    var hasWalletClient = walletClient !== undefined && walletClient !== null;
    var contract = {};
    var hasReadFunction = false;
    var hasWriteFunction = false;
    var hasEvent = false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = abi[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            if (item.type === "function") {
                if (item.stateMutability === "view" || item.stateMutability === "pure") hasReadFunction = true;
                else hasWriteFunction = true;
            } else if (item.type === "event") hasEvent = true;
            // Exit early if all flags are `true`
            if (hasReadFunction && hasWriteFunction && hasEvent) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (hasPublicClient) {
        if (hasReadFunction) contract.read = new Proxy({}, {
            get: function(_, functionName) {
                return function() {
                    for(var _len = arguments.length, parameters = new Array(_len), _key = 0; _key < _len; _key++){
                        parameters[_key] = arguments[_key];
                    }
                    var _getFunctionParameters = $67aa6ee4e548d91c$export$b1d653474fdb0f41(parameters), args = _getFunctionParameters.args, options = _getFunctionParameters.options;
                    return (0, $b75d685676ab0a62$export$6ca3170acb89054)(publicClient, (0, $1500f99f7733ae7a$export$43af7de392176737), "readContract")((0, $do9pw._)({
                        abi: abi,
                        address: address,
                        functionName: functionName,
                        args: args
                    }, options));
                };
            }
        });
        if (hasWriteFunction) contract.simulate = new Proxy({}, {
            get: function(_, functionName) {
                return function() {
                    for(var _len = arguments.length, parameters = new Array(_len), _key = 0; _key < _len; _key++){
                        parameters[_key] = arguments[_key];
                    }
                    var _getFunctionParameters = $67aa6ee4e548d91c$export$b1d653474fdb0f41(parameters), args = _getFunctionParameters.args, options = _getFunctionParameters.options;
                    return (0, $b75d685676ab0a62$export$6ca3170acb89054)(publicClient, (0, $a35082122e3eb786$export$e8798d551e27a374), "simulateContract")((0, $do9pw._)({
                        abi: abi,
                        address: address,
                        functionName: functionName,
                        args: args
                    }, options));
                };
            }
        });
        if (hasEvent) {
            contract.createEventFilter = new Proxy({}, {
                get: function(_, eventName) {
                    return function() {
                        for(var _len = arguments.length, parameters = new Array(_len), _key = 0; _key < _len; _key++){
                            parameters[_key] = arguments[_key];
                        }
                        var abiEvent = abi.find(function(x) {
                            return x.type === "event" && x.name === eventName;
                        });
                        var _getEventParameters = $67aa6ee4e548d91c$export$5d0aafa8249eb606(parameters, abiEvent), args = _getEventParameters.args, options = _getEventParameters.options;
                        return (0, $b75d685676ab0a62$export$6ca3170acb89054)(publicClient, (0, $a4ada780449c7224$export$36f99fdb90149e8b), "createContractEventFilter")((0, $do9pw._)({
                            abi: abi,
                            address: address,
                            eventName: eventName,
                            args: args
                        }, options));
                    };
                }
            });
            contract.getEvents = new Proxy({}, {
                get: function(_, eventName) {
                    return function() {
                        for(var _len = arguments.length, parameters = new Array(_len), _key = 0; _key < _len; _key++){
                            parameters[_key] = arguments[_key];
                        }
                        var abiEvent = abi.find(function(x) {
                            return x.type === "event" && x.name === eventName;
                        });
                        var _getEventParameters = $67aa6ee4e548d91c$export$5d0aafa8249eb606(parameters, abiEvent), args = _getEventParameters.args, options = _getEventParameters.options;
                        return (0, $b75d685676ab0a62$export$6ca3170acb89054)(publicClient, (0, $c7cf0e41c9b19a2b$export$1e175955db02d8d), "getContractEvents")((0, $do9pw._)({
                            abi: abi,
                            address: address,
                            eventName: eventName,
                            args: args
                        }, options));
                    };
                }
            });
            contract.watchEvent = new Proxy({}, {
                get: function(_, eventName) {
                    return function() {
                        for(var _len = arguments.length, parameters = new Array(_len), _key = 0; _key < _len; _key++){
                            parameters[_key] = arguments[_key];
                        }
                        var abiEvent = abi.find(function(x) {
                            return x.type === "event" && x.name === eventName;
                        });
                        var _getEventParameters = $67aa6ee4e548d91c$export$5d0aafa8249eb606(parameters, abiEvent), args = _getEventParameters.args, options = _getEventParameters.options;
                        return (0, $b75d685676ab0a62$export$6ca3170acb89054)(publicClient, (0, $c6161c0f9cfa9763$export$2a02a63daa2df376), "watchContractEvent")((0, $do9pw._)({
                            abi: abi,
                            address: address,
                            eventName: eventName,
                            args: args
                        }, options));
                    };
                }
            });
        }
    }
    if (hasWalletClient) {
        if (hasWriteFunction) contract.write = new Proxy({}, {
            get: function(_, functionName) {
                return function() {
                    for(var _len = arguments.length, parameters = new Array(_len), _key = 0; _key < _len; _key++){
                        parameters[_key] = arguments[_key];
                    }
                    var _getFunctionParameters = $67aa6ee4e548d91c$export$b1d653474fdb0f41(parameters), args = _getFunctionParameters.args, options = _getFunctionParameters.options;
                    return (0, $b75d685676ab0a62$export$6ca3170acb89054)(walletClient, (0, $c2786d6d73bd4474$export$4c0f201bc17cbf23), "writeContract")((0, $do9pw._)({
                        abi: abi,
                        address: address,
                        functionName: functionName,
                        args: args
                    }, options));
                };
            }
        });
    }
    if (hasPublicClient || hasWalletClient) {
        if (hasWriteFunction) contract.estimateGas = new Proxy({}, {
            get: function(_, functionName) {
                return function() {
                    for(var _len = arguments.length, parameters = new Array(_len), _key = 0; _key < _len; _key++){
                        parameters[_key] = arguments[_key];
                    }
                    var _getFunctionParameters = $67aa6ee4e548d91c$export$b1d653474fdb0f41(parameters), args = _getFunctionParameters.args, options = _getFunctionParameters.options;
                    var client = publicClient !== null && publicClient !== void 0 ? publicClient : walletClient;
                    var _options_account;
                    return (0, $b75d685676ab0a62$export$6ca3170acb89054)(client, (0, $26658049de670cf6$export$7b896b3a3695de87), "estimateContractGas")((0, $cxjpp._)((0, $do9pw._)({
                        abi: abi,
                        address: address,
                        functionName: functionName,
                        args: args
                    }, options), {
                        account: (_options_account = options.account) !== null && _options_account !== void 0 ? _options_account : walletClient.account
                    }));
                };
            }
        });
    }
    contract.address = address;
    contract.abi = abi;
    return contract;
}
function $67aa6ee4e548d91c$export$b1d653474fdb0f41(values) {
    var hasArgs = values.length && Array.isArray(values[0]);
    var args = hasArgs ? values[0] : [];
    var _ref;
    var options = (_ref = hasArgs ? values[1] : values[0]) !== null && _ref !== void 0 ? _ref : {};
    return {
        args: args,
        options: options
    };
}
function $67aa6ee4e548d91c$export$5d0aafa8249eb606(values, abiEvent) {
    var hasArgs = false;
    // If first item is array, must be `args`
    if (Array.isArray(values[0])) hasArgs = true;
    else if (values.length === 1) // if event has indexed inputs, must have `args`
    hasArgs = abiEvent.inputs.some(function(x) {
        return x.indexed;
    });
    else if (values.length === 2) hasArgs = true;
    var args = hasArgs ? values[0] : undefined;
    var _ref;
    var options = (_ref = hasArgs ? values[1] : values[0]) !== null && _ref !== void 0 ? _ref : {};
    return {
        args: args,
        options: options
    };
}


var $9ClpR = parcelRequire("9ClpR");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $cv9Rk = parcelRequire("cv9Rk");

var $1Mpn7 = parcelRequire("1Mpn7");
// src/mutationObserver.ts

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");






var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $ohfOJ = parcelRequire("ohfOJ");




var $67988eaa9f0418c1$var$_client, $67988eaa9f0418c1$var$_currentResult, $67988eaa9f0418c1$var$_currentMutation, $67988eaa9f0418c1$var$_mutateOptions, $67988eaa9f0418c1$var$_updateResult, $67988eaa9f0418c1$var$_notify, $67988eaa9f0418c1$var$_class;
var $67988eaa9f0418c1$export$d3c1860ee66f291a = ($67988eaa9f0418c1$var$_client = /*#__PURE__*/ new WeakMap(), $67988eaa9f0418c1$var$_currentResult = /*#__PURE__*/ new WeakMap(), $67988eaa9f0418c1$var$_currentMutation = /*#__PURE__*/ new WeakMap(), $67988eaa9f0418c1$var$_mutateOptions = /*#__PURE__*/ new WeakMap(), $67988eaa9f0418c1$var$_updateResult = /*#__PURE__*/ new WeakSet(), $67988eaa9f0418c1$var$_notify = /*#__PURE__*/ new WeakSet(), $67988eaa9f0418c1$var$_class = /*#__PURE__*/ function(Subscribable) {
    "use strict";
    (0, $dcsZi._)(_class, Subscribable);
    var _super = (0, $ohfOJ._)(_class);
    function _class(client, options) {
        (0, $4GJKx._)(this, _class);
        var _this;
        _this = _super.call(this);
        (0, $4ba5d20095745f8e$export$71511d61b312f219)((0, $d3H5E._)(_this), $67988eaa9f0418c1$var$_updateResult);
        (0, $4ba5d20095745f8e$export$71511d61b312f219)((0, $d3H5E._)(_this), $67988eaa9f0418c1$var$_notify);
        (0, $d4584ce6f6a30a88$export$71511d61b312f219)((0, $d3H5E._)(_this), $67988eaa9f0418c1$var$_client, {
            writable: true,
            value: void 0
        });
        (0, $d4584ce6f6a30a88$export$71511d61b312f219)((0, $d3H5E._)(_this), $67988eaa9f0418c1$var$_currentResult, {
            writable: true,
            value: void 0
        });
        (0, $d4584ce6f6a30a88$export$71511d61b312f219)((0, $d3H5E._)(_this), $67988eaa9f0418c1$var$_currentMutation, {
            writable: true,
            value: void 0
        });
        (0, $d4584ce6f6a30a88$export$71511d61b312f219)((0, $d3H5E._)(_this), $67988eaa9f0418c1$var$_mutateOptions, {
            writable: true,
            value: void 0
        });
        (0, $124143cbdcf95d51$export$71511d61b312f219)((0, $d3H5E._)(_this), $67988eaa9f0418c1$var$_client, client);
        _this.setOptions(options);
        _this.bindMethods();
        (0, $a66360d689e7ada3$export$71511d61b312f219)(_this, $67988eaa9f0418c1$var$_updateResult, $67988eaa9f0418c1$var$updateResult).call((0, $d3H5E._)(_this));
        return _this;
    }
    (0, $1wc17._)(_class, [
        {
            key: "bindMethods",
            value: function bindMethods() {
                this.mutate = this.mutate.bind(this);
                this.reset = this.reset.bind(this);
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                var _$_class_private_field_get;
                var prevOptions = this.options;
                this.options = (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $67988eaa9f0418c1$var$_client).defaultMutationOptions(options);
                if (!(0, $af19fbfda254a923$export$3e67810a3f0e9f1c)(this.options, prevOptions)) (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $67988eaa9f0418c1$var$_client).getMutationCache().notify({
                    type: "observerOptionsUpdated",
                    mutation: (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $67988eaa9f0418c1$var$_currentMutation),
                    observer: this
                });
                if ((prevOptions === null || prevOptions === void 0 ? void 0 : prevOptions.mutationKey) && this.options.mutationKey && (0, $af19fbfda254a923$export$1e87d19d4aab5805)(prevOptions.mutationKey) !== (0, $af19fbfda254a923$export$1e87d19d4aab5805)(this.options.mutationKey)) this.reset();
                else if (((_$_class_private_field_get = (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $67988eaa9f0418c1$var$_currentMutation)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.state.status) === "pending") (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $67988eaa9f0418c1$var$_currentMutation).setOptions(this.options);
            }
        },
        {
            key: "onUnsubscribe",
            value: function onUnsubscribe() {
                var _$_class_private_field_get;
                if (!this.hasListeners()) (_$_class_private_field_get = (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $67988eaa9f0418c1$var$_currentMutation)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.removeObserver(this);
            }
        },
        {
            key: "onMutationUpdate",
            value: function onMutationUpdate(action) {
                (0, $a66360d689e7ada3$export$71511d61b312f219)(this, $67988eaa9f0418c1$var$_updateResult, $67988eaa9f0418c1$var$updateResult).call(this);
                (0, $a66360d689e7ada3$export$71511d61b312f219)(this, $67988eaa9f0418c1$var$_notify, $67988eaa9f0418c1$var$notify).call(this, action);
            }
        },
        {
            key: "getCurrentResult",
            value: function getCurrentResult() {
                return (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $67988eaa9f0418c1$var$_currentResult);
            }
        },
        {
            key: "reset",
            value: function reset() {
                var _$_class_private_field_get;
                (_$_class_private_field_get = (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $67988eaa9f0418c1$var$_currentMutation)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.removeObserver(this);
                (0, $124143cbdcf95d51$export$71511d61b312f219)(this, $67988eaa9f0418c1$var$_currentMutation, void 0);
                (0, $a66360d689e7ada3$export$71511d61b312f219)(this, $67988eaa9f0418c1$var$_updateResult, $67988eaa9f0418c1$var$updateResult).call(this);
                (0, $a66360d689e7ada3$export$71511d61b312f219)(this, $67988eaa9f0418c1$var$_notify, $67988eaa9f0418c1$var$notify).call(this);
            }
        },
        {
            key: "mutate",
            value: function mutate(variables, options) {
                var _$_class_private_field_get;
                (0, $124143cbdcf95d51$export$71511d61b312f219)(this, $67988eaa9f0418c1$var$_mutateOptions, options);
                (_$_class_private_field_get = (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $67988eaa9f0418c1$var$_currentMutation)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.removeObserver(this);
                (0, $124143cbdcf95d51$export$71511d61b312f219)(this, $67988eaa9f0418c1$var$_currentMutation, (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $67988eaa9f0418c1$var$_client).getMutationCache().build((0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $67988eaa9f0418c1$var$_client), this.options));
                (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $67988eaa9f0418c1$var$_currentMutation).addObserver(this);
                return (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $67988eaa9f0418c1$var$_currentMutation).execute(variables);
            }
        }
    ]);
    return _class;
}((0, $d7555b70074d2039$export$d26086b469ecdbcc)), $67988eaa9f0418c1$var$_class);
function $67988eaa9f0418c1$var$updateResult() {
    var _$_class_private_field_get;
    var _class_private_field_get_state;
    var state = (_class_private_field_get_state = (_$_class_private_field_get = (0, $8c2a5b50554ee522$export$71511d61b312f219)(this, $67988eaa9f0418c1$var$_currentMutation)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.state) !== null && _class_private_field_get_state !== void 0 ? _class_private_field_get_state : (0, $0d96312ae51216f8$export$a1659b54bac3252a)();
    (0, $124143cbdcf95d51$export$71511d61b312f219)(this, $67988eaa9f0418c1$var$_currentResult, (0, $cxjpp._)((0, $do9pw._)({}, state), {
        isPending: state.status === "pending",
        isSuccess: state.status === "success",
        isError: state.status === "error",
        isIdle: state.status === "idle",
        mutate: this.mutate,
        reset: this.reset
    }));
}
function $67988eaa9f0418c1$var$notify(action) {
    var _this = this;
    (0, $13a3a02e43f53625$export$520687f44db6e1ab).batch(function() {
        if ((0, $8c2a5b50554ee522$export$71511d61b312f219)(_this, $67988eaa9f0418c1$var$_mutateOptions) && _this.hasListeners()) {
            var variables = (0, $8c2a5b50554ee522$export$71511d61b312f219)(_this, $67988eaa9f0418c1$var$_currentResult).variables;
            var context = (0, $8c2a5b50554ee522$export$71511d61b312f219)(_this, $67988eaa9f0418c1$var$_currentResult).context;
            if ((action === null || action === void 0 ? void 0 : action.type) === "success") {
                var _class_private_field_get_onSuccess, _$_class_private_field_get, _class_private_field_get_onSettled, _$_class_private_field_get1;
                (_class_private_field_get_onSuccess = (_$_class_private_field_get = (0, $8c2a5b50554ee522$export$71511d61b312f219)(_this, $67988eaa9f0418c1$var$_mutateOptions)).onSuccess) === null || _class_private_field_get_onSuccess === void 0 ? void 0 : _class_private_field_get_onSuccess.call(_$_class_private_field_get, action.data, variables, context);
                (_class_private_field_get_onSettled = (_$_class_private_field_get1 = (0, $8c2a5b50554ee522$export$71511d61b312f219)(_this, $67988eaa9f0418c1$var$_mutateOptions)).onSettled) === null || _class_private_field_get_onSettled === void 0 ? void 0 : _class_private_field_get_onSettled.call(_$_class_private_field_get1, action.data, null, variables, context);
            } else if ((action === null || action === void 0 ? void 0 : action.type) === "error") {
                var _class_private_field_get_onError, _$_class_private_field_get2, _class_private_field_get_onSettled1, _$_class_private_field_get3;
                (_class_private_field_get_onError = (_$_class_private_field_get2 = (0, $8c2a5b50554ee522$export$71511d61b312f219)(_this, $67988eaa9f0418c1$var$_mutateOptions)).onError) === null || _class_private_field_get_onError === void 0 ? void 0 : _class_private_field_get_onError.call(_$_class_private_field_get2, action.error, variables, context);
                (_class_private_field_get_onSettled1 = (_$_class_private_field_get3 = (0, $8c2a5b50554ee522$export$71511d61b312f219)(_this, $67988eaa9f0418c1$var$_mutateOptions)).onSettled) === null || _class_private_field_get_onSettled1 === void 0 ? void 0 : _class_private_field_get_onSettled1.call(_$_class_private_field_get3, void 0, action.error, variables, context);
            }
        }
        _this.listeners.forEach(function(listener) {
            listener((0, $8c2a5b50554ee522$export$71511d61b312f219)(_this, $67988eaa9f0418c1$var$_currentResult));
        });
    });
}



// src/utils.ts

var $c6Xmf = parcelRequire("c6Xmf");
function $5a632a0fae98da38$export$2072f68e6c3507cf(throwError, params) {
    if (typeof throwError === "function") return throwError.apply(void 0, (0, $c6Xmf._)(params));
    return !!throwError;
}
function $5a632a0fae98da38$export$8793edee2d425525() {}


"use client";
function $85df49500ba48544$export$609860bf8b0084c(options, queryClient) {
    var client = (0, $953e85a5ab939cf5$export$22e77b9572c4fded)(queryClient);
    var _React_useState = (0, $cv9Rk._)($1Mpn7.useState(function() {
        return new (0, $67988eaa9f0418c1$export$d3c1860ee66f291a)(client, options);
    }), 1), observer = _React_useState[0];
    $1Mpn7.useEffect(function() {
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    var result = $1Mpn7.useSyncExternalStore($1Mpn7.useCallback(function(onStoreChange) {
        return observer.subscribe((0, $13a3a02e43f53625$export$520687f44db6e1ab).batchCalls(onStoreChange));
    }, [
        observer
    ]), function() {
        return observer.getCurrentResult();
    }, function() {
        return observer.getCurrentResult();
    });
    var mutate = $1Mpn7.useCallback(function(variables, mutateOptions) {
        observer.mutate(variables, mutateOptions).catch((0, $5a632a0fae98da38$export$8793edee2d425525));
    }, [
        observer
    ]);
    if (result.error && (0, $5a632a0fae98da38$export$2072f68e6c3507cf)(observer.options.throwOnError, [
        result.error
    ])) throw result.error;
    return (0, $cxjpp._)((0, $do9pw._)({}, result), {
        mutate: mutate,
        mutateAsync: result.mutate
    });
}



function $e474a6a5a53b2c60$export$81bca4b1e9392240(config) {
    return {
        mutationFn: function(variables) {
            return (0, $91ceee46be7e0ba4$export$37dfea93db2e14ed)(config, variables);
        },
        mutationKey: [
            "disconnect"
        ]
    };
}



var $1Mpn7 = parcelRequire("1Mpn7");


var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $8de28a548c224f16$export$83d89fbfd8236492 = "2.12.8";


var $e8c710af54dcbcc0$export$c506eb22e615ba4a = function() {
    return "wagmi@".concat((0, $8de28a548c224f16$export$83d89fbfd8236492));
};


var $20389df85ffa5b84$export$a490eb03cb7a0a5e = /*#__PURE__*/ function(CoreError) {
    "use strict";
    (0, $dcsZi._)(BaseError, CoreError);
    var _super = (0, $ohfOJ._)(BaseError);
    function BaseError() {
        (0, $4GJKx._)(this, BaseError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        Object.defineProperty((0, $d3H5E._)(_this), "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "WagmiError"
        });
        return _this;
    }
    (0, $1wc17._)(BaseError, [
        {
            key: "docsBaseUrl",
            get: function get() {
                return "https://wagmi.sh/react";
            }
        },
        {
            key: "version",
            get: function get() {
                return (0, $e8c710af54dcbcc0$export$c506eb22e615ba4a)();
            }
        }
    ]);
    return BaseError;
}((0, $5fe8c9a1072e57c7$export$a490eb03cb7a0a5e));


var $fd9bda5fcc558a25$export$83af591da49c2ea = /*#__PURE__*/ function(BaseError) {
    "use strict";
    (0, $dcsZi._)(WagmiProviderNotFoundError, BaseError);
    var _super = (0, $ohfOJ._)(WagmiProviderNotFoundError);
    function WagmiProviderNotFoundError() {
        (0, $4GJKx._)(this, WagmiProviderNotFoundError);
        var _this;
        _this = _super.call(this, "`useConfig` must be used within `WagmiProvider`.", {
            docsPath: "/api/WagmiProvider"
        });
        Object.defineProperty((0, $d3H5E._)(_this), "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "WagmiProviderNotFoundError"
        });
        return _this;
    }
    return WagmiProviderNotFoundError;
}((0, $20389df85ffa5b84$export$a490eb03cb7a0a5e));


"use client";
function $8d9f74c1353afa82$export$b3611e87cd5ba6ce() {
    var parameters = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _parameters_config;
    var config = (_parameters_config = parameters.config) !== null && _parameters_config !== void 0 ? _parameters_config : (0, $1Mpn7.useContext)((0, $6de5ee6f9b442f8a$export$da7c16611087c70c));
    if (!config) throw new (0, $fd9bda5fcc558a25$export$83af591da49c2ea)();
    return config;
}




function $1fe8d3ea02c33219$export$a7de891c4ee82d0d(config, parameters) {
    var onChange = parameters.onChange;
    return config.subscribe(function() {
        return (0, $2e03580ec1c529ae$export$82b9f8f75cc709b4)(config);
    }, onChange, {
        equalityFn: (0, $131791f4a2d73743$export$9cb4719e2e525b7a)
    });
}



var $1Mpn7 = parcelRequire("1Mpn7");

"use client";
function $273cee14047fbef3$export$e54e57ae932f0754() {
    var parameters = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var config = (0, $8d9f74c1353afa82$export$b3611e87cd5ba6ce)(parameters);
    return (0, $1Mpn7.useSyncExternalStore)(function(onChange) {
        return (0, $1fe8d3ea02c33219$export$a7de891c4ee82d0d)(config, {
            onChange: onChange
        });
    }, function() {
        return (0, $2e03580ec1c529ae$export$82b9f8f75cc709b4)(config);
    }, function() {
        return (0, $2e03580ec1c529ae$export$82b9f8f75cc709b4)(config);
    });
}


"use client";
function $d33bf83e1f82b118$export$83bebf2fe7fead4e() {
    var parameters = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var mutation = parameters.mutation;
    var config = (0, $8d9f74c1353afa82$export$b3611e87cd5ba6ce)(parameters);
    var mutationOptions = (0, $e474a6a5a53b2c60$export$81bca4b1e9392240)(config);
    var _useMutation = (0, $85df49500ba48544$export$609860bf8b0084c)((0, $do9pw._)({}, mutation, mutationOptions)), mutate = _useMutation.mutate, mutateAsync = _useMutation.mutateAsync, result = (0, $dRLPW._)(_useMutation, [
        "mutate",
        "mutateAsync"
    ]);
    return (0, $cxjpp._)((0, $do9pw._)({}, result), {
        connectors: (0, $273cee14047fbef3$export$e54e57ae932f0754)({
            config: config
        }).map(function(connection) {
            return connection.connector;
        }),
        disconnect: mutate,
        disconnectAsync: mutateAsync
    });
}




var $3sHb8 = parcelRequire("3sHb8");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $cv9Rk = parcelRequire("cv9Rk");


var $1Mpn7 = parcelRequire("1Mpn7");
var $1d24c09aab6e066e$exports = {};
"use strict";

$1d24c09aab6e066e$exports = (parcelRequire("bnbqr"));


"use client";
var $06f6beae84b93aef$var$isPlainObject = function(obj) {
    return typeof obj === "object" && !Array.isArray(obj);
};
function $06f6beae84b93aef$export$1a0284c6345ef780(subscribe, getSnapshot) {
    var getServerSnapshot = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : getSnapshot, isEqual = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : (0, $131791f4a2d73743$export$9cb4719e2e525b7a);
    var trackedKeys = (0, $1Mpn7.useRef)([]);
    var result = (0, $1d24c09aab6e066e$exports.useSyncExternalStoreWithSelector)(subscribe, getSnapshot, getServerSnapshot, function(x) {
        return x;
    }, function(a, b) {
        if ($06f6beae84b93aef$var$isPlainObject(a) && $06f6beae84b93aef$var$isPlainObject(b) && trackedKeys.current.length) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = trackedKeys.current[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var key = _step.value;
                    var equal = isEqual(a[key], b[key]);
                    if (!equal) return false;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return true;
        }
        return isEqual(a, b);
    });
    if ($06f6beae84b93aef$var$isPlainObject(result)) {
        var trackedResult = (0, $do9pw._)({}, result);
        var properties = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var _step_value = (0, $cv9Rk._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                properties = (0, $cxjpp._)((0, $do9pw._)({}, properties), (0, $3sHb8._)({}, key, {
                    configurable: false,
                    enumerable: true,
                    get: function() {
                        if (!trackedKeys.current.includes(key)) trackedKeys.current.push(key);
                        return value;
                    }
                }));
            };
            for(var _iterator = Object.entries(trackedResult)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        Object.defineProperties(trackedResult, properties);
        return trackedResult;
    }
    return result;
}


"use client";
function $11433db317972ee3$export$83a8e409853da004() {
    var parameters = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var config = (0, $8d9f74c1353afa82$export$b3611e87cd5ba6ce)(parameters);
    return (0, $06f6beae84b93aef$export$1a0284c6345ef780)(function(onChange) {
        return (0, $c9f803c524f80d4c$export$30c94aeff2da2ac6)(config, {
            onChange: onChange
        });
    }, function() {
        return (0, $03c83a18d36f49ac$export$4f9234baf34abd0)(config);
    });
}



var $j06k0 = parcelRequire("j06k0");



var $j06k0 = parcelRequire("j06k0");

function $c5e756178d2efe0f$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  from {\n    background-color: rgba(7, 7, 40, 0);\n  }\n  to {\n    background-color: rgba(7, 7, 40, 0.75);\n  }\n"
    ]);
    $c5e756178d2efe0f$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $c5e756178d2efe0f$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "    \n  from {\n    transform: scale(0);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n"
    ]);
    $c5e756178d2efe0f$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $c5e756178d2efe0f$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "\n  from {\n    /* transform: scaleY(0); */\n    height: 0;\n  }\n  to {\n    /* transform: scaleY(1) */\n    height: fit-content;\n  }\n"
    ]);
    $c5e756178d2efe0f$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $c5e756178d2efe0f$var$_templateObject3() {
    var data = (0, $j06k0._)([
        "\n  from {\n    /* transform: scaleY(1) */\n  }\n  to {\n    /* transform: scaleY(0) */\n  }\n"
    ]);
    $c5e756178d2efe0f$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $c5e756178d2efe0f$var$_templateObject4() {
    var data = (0, $j06k0._)([
        "\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"
    ]);
    $c5e756178d2efe0f$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $c5e756178d2efe0f$var$_templateObject5() {
    var data = (0, $j06k0._)([
        "\n  0% {\n    opacity: 1;\n  }\n 100% {\n    opacity: 0;\n  }\n"
    ]);
    $c5e756178d2efe0f$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
var $c5e756178d2efe0f$export$ac81a72f0c3b6512 = (0, $f2ce4b3babf40f7e$export$d25ddfdf17c3ad3e)($c5e756178d2efe0f$var$_templateObject());
var $c5e756178d2efe0f$export$f9ae25e7d5fbc8b9 = (0, $f2ce4b3babf40f7e$export$d25ddfdf17c3ad3e)($c5e756178d2efe0f$var$_templateObject1());
var $c5e756178d2efe0f$export$c4535d5c0dad4021 = (0, $f2ce4b3babf40f7e$export$d25ddfdf17c3ad3e)($c5e756178d2efe0f$var$_templateObject2());
var $c5e756178d2efe0f$export$b953c4562f8602be = (0, $f2ce4b3babf40f7e$export$d25ddfdf17c3ad3e)($c5e756178d2efe0f$var$_templateObject3());
var $c5e756178d2efe0f$export$bd7370ffb2917ab7 = (0, $f2ce4b3babf40f7e$export$d25ddfdf17c3ad3e)($c5e756178d2efe0f$var$_templateObject4());
var $c5e756178d2efe0f$export$21430ab519d0e9c = (0, $f2ce4b3babf40f7e$export$d25ddfdf17c3ad3e)($c5e756178d2efe0f$var$_templateObject5());


function $52cd8b1dce1374e7$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  0% {\n    opacity: 0;\n    transform: translateY(25%);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n"
    ]);
    $52cd8b1dce1374e7$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $52cd8b1dce1374e7$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "\n  background-color: white;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n  animation: ",
        " 0.5s ease;\n  box-shadow: rgb(0 0 0 / 15%) 0px 1px 5px;\n  padding: 40px;\n"
    ]);
    $52cd8b1dce1374e7$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $52cd8b1dce1374e7$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 25px;\n  height: 25px;\n  border-radius: 100%;\n  background-color: ",
        ";\n  animation: ",
        " 0.5s ease;\n"
    ]);
    $52cd8b1dce1374e7$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var $52cd8b1dce1374e7$var$ReceiptIn = (0, $f2ce4b3babf40f7e$export$d25ddfdf17c3ad3e)($52cd8b1dce1374e7$var$_templateObject());
var $52cd8b1dce1374e7$export$af661ccd4dd193f2 = (0, $f2ce4b3babf40f7e$export$2e2bcd8739ae039).div($52cd8b1dce1374e7$var$_templateObject1(), $52cd8b1dce1374e7$var$ReceiptIn);
var $52cd8b1dce1374e7$export$763817fece9a8c9d = (0, $f2ce4b3babf40f7e$export$2e2bcd8739ae039).div($52cd8b1dce1374e7$var$_templateObject2(), (0, $651851c7f7a4dfb5$export$8fe7e62e076ddbb5).NICE_GREEN, (0, $c5e756178d2efe0f$export$f9ae25e7d5fbc8b9));



var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");

var $j06k0 = parcelRequire("j06k0");

parcelRequire("1Mpn7");

function $1fba025245cbd847$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  to {\n    stroke-dashoffset: 0;\n  }\n"
    ]);
    $1fba025245cbd847$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $1fba025245cbd847$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "\n  animation: ",
        " ",
        " cubic-bezier(0.650, 0.000, 0.450, 1.000) forwards;\n  animation-delay: ",
        ";\n"
    ]);
    $1fba025245cbd847$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $1fba025245cbd847$var$Dash = (0, $f2ce4b3babf40f7e$export$d25ddfdf17c3ad3e)($1fba025245cbd847$var$_templateObject());
var $1fba025245cbd847$var$AnimatedPath = (0, $f2ce4b3babf40f7e$export$2e2bcd8739ae039).path($1fba025245cbd847$var$_templateObject1(), $1fba025245cbd847$var$Dash, function(param) {
    var animationSpeed = param.animationSpeed;
    return animationSpeed;
}, function(param) {
    var animationDelay = param.animationDelay;
    return animationDelay;
});
function $1fba025245cbd847$var$Checkmark(_param) {
    var _param_animationDelay = _param.animationDelay, animationDelay = _param_animationDelay === void 0 ? "0.3s" : _param_animationDelay, _param_animationSpeed = _param.animationSpeed, animationSpeed = _param_animationSpeed === void 0 ? "0.5s" : _param_animationSpeed, props = (0, $dRLPW._)(_param, [
        "animationDelay",
        "animationSpeed"
    ]);
    return /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("svg", (0, $cxjpp._)((0, $do9pw._)({
        width: "52",
        height: "52",
        viewBox: "0 0 52 52",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        strokeWidth: 4,
        stroke: "white"
    }, props), {
        children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)($1fba025245cbd847$var$AnimatedPath, {
            animationDelay: animationDelay,
            animationSpeed: animationSpeed,
            strokeDashoffset: 100,
            strokeDasharray: 100,
            d: "M14.1 27.2l7.1 7.2 16.7-16.8"
        })
    }));
}
var $1fba025245cbd847$export$2e2bcd8739ae039 = $1fba025245cbd847$var$Checkmark;



var $lFPa6 = parcelRequire("lFPa6");

var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cv9Rk = parcelRequire("cv9Rk");

var $j06k0 = parcelRequire("j06k0");

var $eha6O = parcelRequire("eha6O");


var $1Mpn7 = parcelRequire("1Mpn7");






var $1Mpn7 = parcelRequire("1Mpn7");
var $064a90e950b6662f$var$EMPTY_ARRAY = [];
var $064a90e950b6662f$var$DEFAULT_CONTEXT = {
    autoConnect: false,
    connecting: false,
    connected: false,
    disconnecting: false,
    select: function() {
        $064a90e950b6662f$var$logMissingProviderError("call", "select");
    },
    connect: function() {
        return Promise.reject($064a90e950b6662f$var$logMissingProviderError("call", "connect"));
    },
    disconnect: function() {
        return Promise.reject($064a90e950b6662f$var$logMissingProviderError("call", "disconnect"));
    },
    sendTransaction: function() {
        return Promise.reject($064a90e950b6662f$var$logMissingProviderError("call", "sendTransaction"));
    },
    signTransaction: function() {
        return Promise.reject($064a90e950b6662f$var$logMissingProviderError("call", "signTransaction"));
    },
    signAllTransactions: function() {
        return Promise.reject($064a90e950b6662f$var$logMissingProviderError("call", "signAllTransactions"));
    },
    signMessage: function() {
        return Promise.reject($064a90e950b6662f$var$logMissingProviderError("call", "signMessage"));
    },
    signIn: function() {
        return Promise.reject($064a90e950b6662f$var$logMissingProviderError("call", "signIn"));
    }
};
Object.defineProperty($064a90e950b6662f$var$DEFAULT_CONTEXT, "wallets", {
    get: function() {
        $064a90e950b6662f$var$logMissingProviderError("read", "wallets");
        return $064a90e950b6662f$var$EMPTY_ARRAY;
    }
});
Object.defineProperty($064a90e950b6662f$var$DEFAULT_CONTEXT, "wallet", {
    get: function() {
        $064a90e950b6662f$var$logMissingProviderError("read", "wallet");
        return null;
    }
});
Object.defineProperty($064a90e950b6662f$var$DEFAULT_CONTEXT, "publicKey", {
    get: function() {
        $064a90e950b6662f$var$logMissingProviderError("read", "publicKey");
        return null;
    }
});
function $064a90e950b6662f$var$logMissingProviderError(action, property) {
    var error = new Error("You have tried to ".concat(action, ' "').concat(property, '" on a WalletContext without providing one. ') + "Make sure to render a WalletProvider as an ancestor of the component that uses WalletContext.");
    console.error(error);
    return error;
}
var $064a90e950b6662f$export$19648c908dc8d0bf = (0, $1Mpn7.createContext)($064a90e950b6662f$var$DEFAULT_CONTEXT);
function $064a90e950b6662f$export$c34addee860b0acb() {
    return (0, $1Mpn7.useContext)($064a90e950b6662f$export$19648c908dc8d0bf);
}


var $1Mpn7 = parcelRequire("1Mpn7");
var $0557e2bf883213b5$export$af54d3055d90c64e = (0, $1Mpn7.createContext)({});
function $0557e2bf883213b5$export$985e8768c0e91dbc() {
    return (0, $1Mpn7.useContext)($0557e2bf883213b5$export$af54d3055d90c64e);
}


var $69N5M = parcelRequire("69N5M");

var $1Mpn7 = parcelRequire("1Mpn7");

var $ba284faa37c4b127$export$fd685cf7c99624bd = function(param) {
    var children = param.children, endpoint = param.endpoint, _param_config = param.config, config = _param_config === void 0 ? {
        commitment: "confirmed"
    } : _param_config;
    var connection = (0, $1Mpn7.useMemo)(function() {
        return new (0, $69N5M.Connection)(endpoint, config);
    }, [
        endpoint,
        config
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $0557e2bf883213b5$export$af54d3055d90c64e).Provider, {
        value: {
            connection: connection
        }
    }, children);
};


var $kSuI9 = parcelRequire("kSuI9");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $eha6O = parcelRequire("eha6O");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $cv9Rk = parcelRequire("cv9Rk");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");
var $14165c3844082bdc$exports = {};
"use strict";
var $14165c3844082bdc$var$has = Object.prototype.hasOwnProperty, $14165c3844082bdc$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $14165c3844082bdc$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $14165c3844082bdc$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $14165c3844082bdc$var$Events().__proto__) $14165c3844082bdc$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $14165c3844082bdc$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $14165c3844082bdc$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $14165c3844082bdc$var$EE(fn, context || emitter, once), evt = $14165c3844082bdc$var$prefix ? $14165c3844082bdc$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $14165c3844082bdc$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $14165c3844082bdc$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $14165c3844082bdc$var$EventEmitter() {
    this._events = new $14165c3844082bdc$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $14165c3844082bdc$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($14165c3844082bdc$var$has.call(events, name)) names.push($14165c3844082bdc$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $14165c3844082bdc$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $14165c3844082bdc$var$prefix ? $14165c3844082bdc$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $14165c3844082bdc$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $14165c3844082bdc$var$prefix ? $14165c3844082bdc$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $14165c3844082bdc$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $14165c3844082bdc$var$prefix ? $14165c3844082bdc$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $14165c3844082bdc$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $14165c3844082bdc$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $14165c3844082bdc$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $14165c3844082bdc$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $14165c3844082bdc$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $14165c3844082bdc$var$prefix ? $14165c3844082bdc$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $14165c3844082bdc$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $14165c3844082bdc$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $14165c3844082bdc$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $14165c3844082bdc$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $14165c3844082bdc$var$prefix ? $14165c3844082bdc$var$prefix + event : event;
        if (this._events[evt]) $14165c3844082bdc$var$clearEvent(this, evt);
    } else {
        this._events = new $14165c3844082bdc$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$14165c3844082bdc$var$EventEmitter.prototype.off = $14165c3844082bdc$var$EventEmitter.prototype.removeListener;
$14165c3844082bdc$var$EventEmitter.prototype.addListener = $14165c3844082bdc$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$14165c3844082bdc$var$EventEmitter.prefixed = $14165c3844082bdc$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$14165c3844082bdc$var$EventEmitter.EventEmitter = $14165c3844082bdc$var$EventEmitter;
$14165c3844082bdc$exports = $14165c3844082bdc$var$EventEmitter;



var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");
var $3f5d780e6d40bbac$export$f46ec6f9dba8711d = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $dcsZi._)(WalletError, Error1);
    var _super = (0, $ohfOJ._)(WalletError);
    function WalletError(message, error) {
        (0, $4GJKx._)(this, WalletError);
        var _this;
        _this = _super.call(this, message);
        _this.error = error;
        return _this;
    }
    return WalletError;
}((0, $FuVm8._)(Error));
var $3f5d780e6d40bbac$export$d65db264eda99cd7 = /*#__PURE__*/ function(WalletError) {
    "use strict";
    (0, $dcsZi._)(WalletNotReadyError, WalletError);
    var _super = (0, $ohfOJ._)(WalletNotReadyError);
    function WalletNotReadyError() {
        (0, $4GJKx._)(this, WalletNotReadyError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "WalletNotReadyError";
        return _this;
    }
    return WalletNotReadyError;
}($3f5d780e6d40bbac$export$f46ec6f9dba8711d);
var $3f5d780e6d40bbac$export$9a551f94af9b0bf8 = /*#__PURE__*/ function(WalletError) {
    "use strict";
    (0, $dcsZi._)(WalletLoadError, WalletError);
    var _super = (0, $ohfOJ._)(WalletLoadError);
    function WalletLoadError() {
        (0, $4GJKx._)(this, WalletLoadError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "WalletLoadError";
        return _this;
    }
    return WalletLoadError;
}($3f5d780e6d40bbac$export$f46ec6f9dba8711d);
var $3f5d780e6d40bbac$export$9525019988612a5e = /*#__PURE__*/ function(WalletError) {
    "use strict";
    (0, $dcsZi._)(WalletConfigError, WalletError);
    var _super = (0, $ohfOJ._)(WalletConfigError);
    function WalletConfigError() {
        (0, $4GJKx._)(this, WalletConfigError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "WalletConfigError";
        return _this;
    }
    return WalletConfigError;
}($3f5d780e6d40bbac$export$f46ec6f9dba8711d);
var $3f5d780e6d40bbac$export$38f21f1c810261c7 = /*#__PURE__*/ function(WalletError) {
    "use strict";
    (0, $dcsZi._)(WalletConnectionError, WalletError);
    var _super = (0, $ohfOJ._)(WalletConnectionError);
    function WalletConnectionError() {
        (0, $4GJKx._)(this, WalletConnectionError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "WalletConnectionError";
        return _this;
    }
    return WalletConnectionError;
}($3f5d780e6d40bbac$export$f46ec6f9dba8711d);
var $3f5d780e6d40bbac$export$bf7028c52ebda81e = /*#__PURE__*/ function(WalletError) {
    "use strict";
    (0, $dcsZi._)(WalletDisconnectedError, WalletError);
    var _super = (0, $ohfOJ._)(WalletDisconnectedError);
    function WalletDisconnectedError() {
        (0, $4GJKx._)(this, WalletDisconnectedError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "WalletDisconnectedError";
        return _this;
    }
    return WalletDisconnectedError;
}($3f5d780e6d40bbac$export$f46ec6f9dba8711d);
var $3f5d780e6d40bbac$export$92e2b26fad5723ee = /*#__PURE__*/ function(WalletError) {
    "use strict";
    (0, $dcsZi._)(WalletDisconnectionError, WalletError);
    var _super = (0, $ohfOJ._)(WalletDisconnectionError);
    function WalletDisconnectionError() {
        (0, $4GJKx._)(this, WalletDisconnectionError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "WalletDisconnectionError";
        return _this;
    }
    return WalletDisconnectionError;
}($3f5d780e6d40bbac$export$f46ec6f9dba8711d);
var $3f5d780e6d40bbac$export$cd6fa2f8e2a8a612 = /*#__PURE__*/ function(WalletError) {
    "use strict";
    (0, $dcsZi._)(WalletAccountError, WalletError);
    var _super = (0, $ohfOJ._)(WalletAccountError);
    function WalletAccountError() {
        (0, $4GJKx._)(this, WalletAccountError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "WalletAccountError";
        return _this;
    }
    return WalletAccountError;
}($3f5d780e6d40bbac$export$f46ec6f9dba8711d);
var $3f5d780e6d40bbac$export$735bef3bfb0f2c86 = /*#__PURE__*/ function(WalletError) {
    "use strict";
    (0, $dcsZi._)(WalletPublicKeyError, WalletError);
    var _super = (0, $ohfOJ._)(WalletPublicKeyError);
    function WalletPublicKeyError() {
        (0, $4GJKx._)(this, WalletPublicKeyError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "WalletPublicKeyError";
        return _this;
    }
    return WalletPublicKeyError;
}($3f5d780e6d40bbac$export$f46ec6f9dba8711d);
var $3f5d780e6d40bbac$export$c2957028686b1575 = /*#__PURE__*/ function(WalletError) {
    "use strict";
    (0, $dcsZi._)(WalletKeypairError, WalletError);
    var _super = (0, $ohfOJ._)(WalletKeypairError);
    function WalletKeypairError() {
        (0, $4GJKx._)(this, WalletKeypairError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "WalletKeypairError";
        return _this;
    }
    return WalletKeypairError;
}($3f5d780e6d40bbac$export$f46ec6f9dba8711d);
var $3f5d780e6d40bbac$export$313d299817c74896 = /*#__PURE__*/ function(WalletError) {
    "use strict";
    (0, $dcsZi._)(WalletNotConnectedError, WalletError);
    var _super = (0, $ohfOJ._)(WalletNotConnectedError);
    function WalletNotConnectedError() {
        (0, $4GJKx._)(this, WalletNotConnectedError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "WalletNotConnectedError";
        return _this;
    }
    return WalletNotConnectedError;
}($3f5d780e6d40bbac$export$f46ec6f9dba8711d);
var $3f5d780e6d40bbac$export$769332ac3f90f46c = /*#__PURE__*/ function(WalletError) {
    "use strict";
    (0, $dcsZi._)(WalletSendTransactionError, WalletError);
    var _super = (0, $ohfOJ._)(WalletSendTransactionError);
    function WalletSendTransactionError() {
        (0, $4GJKx._)(this, WalletSendTransactionError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "WalletSendTransactionError";
        return _this;
    }
    return WalletSendTransactionError;
}($3f5d780e6d40bbac$export$f46ec6f9dba8711d);
var $3f5d780e6d40bbac$export$96f177062fdd8180 = /*#__PURE__*/ function(WalletError) {
    "use strict";
    (0, $dcsZi._)(WalletSignTransactionError, WalletError);
    var _super = (0, $ohfOJ._)(WalletSignTransactionError);
    function WalletSignTransactionError() {
        (0, $4GJKx._)(this, WalletSignTransactionError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "WalletSignTransactionError";
        return _this;
    }
    return WalletSignTransactionError;
}($3f5d780e6d40bbac$export$f46ec6f9dba8711d);
var $3f5d780e6d40bbac$export$2622c1721bbd4b17 = /*#__PURE__*/ function(WalletError) {
    "use strict";
    (0, $dcsZi._)(WalletSignMessageError, WalletError);
    var _super = (0, $ohfOJ._)(WalletSignMessageError);
    function WalletSignMessageError() {
        (0, $4GJKx._)(this, WalletSignMessageError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "WalletSignMessageError";
        return _this;
    }
    return WalletSignMessageError;
}($3f5d780e6d40bbac$export$f46ec6f9dba8711d);
var $3f5d780e6d40bbac$export$a4c7d3c66e3cdd6c = /*#__PURE__*/ function(WalletError) {
    "use strict";
    (0, $dcsZi._)(WalletSignInError, WalletError);
    var _super = (0, $ohfOJ._)(WalletSignInError);
    function WalletSignInError() {
        (0, $4GJKx._)(this, WalletSignInError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "WalletSignInError";
        return _this;
    }
    return WalletSignInError;
}($3f5d780e6d40bbac$export$f46ec6f9dba8711d);
var $3f5d780e6d40bbac$export$ec3efbdc71ef5c8c = /*#__PURE__*/ function(WalletError) {
    "use strict";
    (0, $dcsZi._)(WalletTimeoutError, WalletError);
    var _super = (0, $ohfOJ._)(WalletTimeoutError);
    function WalletTimeoutError() {
        (0, $4GJKx._)(this, WalletTimeoutError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "WalletTimeoutError";
        return _this;
    }
    return WalletTimeoutError;
}($3f5d780e6d40bbac$export$f46ec6f9dba8711d);
var $3f5d780e6d40bbac$export$c87b9320dc154c95 = /*#__PURE__*/ function(WalletError) {
    "use strict";
    (0, $dcsZi._)(WalletWindowBlockedError, WalletError);
    var _super = (0, $ohfOJ._)(WalletWindowBlockedError);
    function WalletWindowBlockedError() {
        (0, $4GJKx._)(this, WalletWindowBlockedError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "WalletWindowBlockedError";
        return _this;
    }
    return WalletWindowBlockedError;
}($3f5d780e6d40bbac$export$f46ec6f9dba8711d);
var $3f5d780e6d40bbac$export$d02b2d00a97edcea = /*#__PURE__*/ function(WalletError) {
    "use strict";
    (0, $dcsZi._)(WalletWindowClosedError, WalletError);
    var _super = (0, $ohfOJ._)(WalletWindowClosedError);
    function WalletWindowClosedError() {
        (0, $4GJKx._)(this, WalletWindowClosedError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "WalletWindowClosedError";
        return _this;
    }
    return WalletWindowClosedError;
}($3f5d780e6d40bbac$export$f46ec6f9dba8711d);


var $8c7df08073723177$export$2a7b8071105d05b6;
(function(WalletReadyState) {
    /**
     * User-installable wallets can typically be detected by scanning for an API
     * that they've injected into the global context. If such an API is present,
     * we consider the wallet to have been installed.
     */ WalletReadyState["Installed"] = "Installed";
    WalletReadyState["NotDetected"] = "NotDetected";
    /**
     * Loadable wallets are always available to you. Since you can load them at
     * any time, it's meaningless to say that they have been detected.
     */ WalletReadyState["Loadable"] = "Loadable";
    /**
     * If a wallet is not supported on a given platform (eg. server-rendering, or
     * mobile) then it will stay in the `Unsupported` state.
     */ WalletReadyState["Unsupported"] = "Unsupported";
})($8c7df08073723177$export$2a7b8071105d05b6 || ($8c7df08073723177$export$2a7b8071105d05b6 = {}));
var $8c7df08073723177$export$2af1ea2892adc469 = /*#__PURE__*/ function(EventEmitter) {
    "use strict";
    (0, $dcsZi._)(BaseWalletAdapter, EventEmitter);
    var _super = (0, $ohfOJ._)(BaseWalletAdapter);
    function BaseWalletAdapter() {
        (0, $4GJKx._)(this, BaseWalletAdapter);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(BaseWalletAdapter, [
        {
            key: "connected",
            get: function get() {
                return !!this.publicKey;
            }
        },
        {
            key: "autoConnect",
            value: function autoConnect() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.connect()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "prepareTransaction",
            value: function prepareTransaction(transaction, connection) {
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var publicKey, _tmp;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                publicKey = _this.publicKey;
                                if (!publicKey) throw new (0, $3f5d780e6d40bbac$export$313d299817c74896)();
                                transaction.feePayer = transaction.feePayer || publicKey;
                                _tmp = transaction.recentBlockhash;
                                if (_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    connection.getLatestBlockhash({
                                        commitment: options.preflightCommitment,
                                        minContextSlot: options.minContextSlot
                                    })
                                ];
                            case 1:
                                _tmp = _state.sent().blockhash;
                                _state.label = 2;
                            case 2:
                                transaction.recentBlockhash = _tmp;
                                return [
                                    2,
                                    transaction
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return BaseWalletAdapter;
}((0, (/*@__PURE__*/$parcel$interopDefault($14165c3844082bdc$exports))));
function $8c7df08073723177$export$378bae4c88e0b46e(detect) {
    // Early return when server-side rendering
    if (typeof window === "undefined" || typeof document === "undefined") return;
    var disposers = [];
    function detectAndDispose() {
        var detected = detect();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (detected) try {
            for(var _iterator = disposers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var dispose = _step.value;
                dispose();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    // Strategy #1: Try detecting every second.
    var interval = // TODO: #334 Replace with idle callback strategy.
    setInterval(detectAndDispose, 1000);
    disposers.push(function() {
        return clearInterval(interval);
    });
    // Strategy #2: Detect as soon as the DOM becomes 'ready'/'interactive'.
    if (// Implies that `DOMContentLoaded` has not yet fired.
    document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", detectAndDispose, {
            once: true
        });
        disposers.push(function() {
            return document.removeEventListener("DOMContentLoaded", detectAndDispose);
        });
    }
    // Strategy #3: Detect after the `window` has fully loaded.
    if (// If the `complete` state has been reached, we're too late.
    document.readyState !== "complete") {
        window.addEventListener("load", detectAndDispose, {
            once: true
        });
        disposers.push(function() {
            return window.removeEventListener("load", detectAndDispose);
        });
    }
    // Strategy #4: Detect synchronously, now.
    detectAndDispose();
}
function $8c7df08073723177$export$bf89b558d1e273a2() {
    // SSR: return false
    if (!navigator) return false;
    var userAgent = navigator.userAgent.toLowerCase();
    // if on iOS the user agent will contain either iPhone or iPad
    // caveat: if requesting desktop site then this won't work
    var isIos = userAgent.includes("iphone") || userAgent.includes("ipad");
    // if in a webview then it will not include Safari
    // note that other iOS browsers also include Safari
    // so we will redirect only if Safari is also included
    var isSafari = userAgent.includes("safari");
    return isIos && isSafari;
}


var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $dRLPW = parcelRequire("dRLPW");

var $c6Xmf = parcelRequire("c6Xmf");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");


function $17326fb7ccd2d31f$export$37ce1cc82e255d8(transaction) {
    return "version" in transaction;
}


var $d1e3c3dc9d32b5d7$export$9a51bf5d1bea9e98 = /*#__PURE__*/ function(BaseWalletAdapter) {
    "use strict";
    (0, $dcsZi._)(BaseSignerWalletAdapter, BaseWalletAdapter);
    var _super = (0, $ohfOJ._)(BaseSignerWalletAdapter);
    function BaseSignerWalletAdapter() {
        (0, $4GJKx._)(this, BaseSignerWalletAdapter);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(BaseSignerWalletAdapter, [
        {
            key: "sendTransaction",
            value: function sendTransaction(transaction, connection) {
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var emit, rawTransaction, error, _transaction, signers, sendOptions, rawTransaction1, error1, error2;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                emit = true;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    13,
                                    ,
                                    14
                                ]);
                                if (!(0, $17326fb7ccd2d31f$export$37ce1cc82e255d8)(transaction)) return [
                                    3,
                                    7
                                ];
                                if (!_this.supportedTransactionVersions) throw new (0, $3f5d780e6d40bbac$export$769332ac3f90f46c)("Sending versioned transactions isn't supported by this wallet");
                                if (!_this.supportedTransactionVersions.has(transaction.version)) throw new (0, $3f5d780e6d40bbac$export$769332ac3f90f46c)("Sending transaction version ".concat(transaction.version, " isn't supported by this wallet"));
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    _this.signTransaction(transaction)
                                ];
                            case 3:
                                transaction = _state.sent();
                                rawTransaction = transaction.serialize();
                                return [
                                    4,
                                    connection.sendRawTransaction(rawTransaction, options)
                                ];
                            case 4:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 5:
                                error = _state.sent();
                                // If the error was thrown by `signTransaction`, rethrow it and don't emit a duplicate event
                                if (error instanceof (0, $3f5d780e6d40bbac$export$96f177062fdd8180)) {
                                    emit = false;
                                    throw error;
                                }
                                throw new (0, $3f5d780e6d40bbac$export$769332ac3f90f46c)(error === null || error === void 0 ? void 0 : error.message, error);
                            case 6:
                                return [
                                    3,
                                    12
                                ];
                            case 7:
                                _state.trys.push([
                                    7,
                                    11,
                                    ,
                                    12
                                ]);
                                signers = options.signers, sendOptions = (0, $dRLPW._)(options, [
                                    "signers"
                                ]);
                                return [
                                    4,
                                    _this.prepareTransaction(transaction, connection, sendOptions)
                                ];
                            case 8:
                                transaction = _state.sent();
                                (signers === null || signers === void 0 ? void 0 : signers.length) && (_transaction = transaction).partialSign.apply(_transaction, (0, $c6Xmf._)(signers));
                                return [
                                    4,
                                    _this.signTransaction(transaction)
                                ];
                            case 9:
                                transaction = _state.sent();
                                rawTransaction1 = transaction.serialize();
                                return [
                                    4,
                                    connection.sendRawTransaction(rawTransaction1, sendOptions)
                                ];
                            case 10:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 11:
                                error1 = _state.sent();
                                // If the error was thrown by `signTransaction`, rethrow it and don't emit a duplicate event
                                if (error1 instanceof (0, $3f5d780e6d40bbac$export$96f177062fdd8180)) {
                                    emit = false;
                                    throw error1;
                                }
                                throw new (0, $3f5d780e6d40bbac$export$769332ac3f90f46c)(error1 === null || error1 === void 0 ? void 0 : error1.message, error1);
                            case 12:
                                return [
                                    3,
                                    14
                                ];
                            case 13:
                                error2 = _state.sent();
                                if (emit) _this.emit("error", error2);
                                throw error2;
                            case 14:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signAllTransactions",
            value: function signAllTransactions(transactions) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, transaction, signedTransactions, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, transaction1, _, err;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = transactions[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        transaction = _step.value;
                                        if ((0, $17326fb7ccd2d31f$export$37ce1cc82e255d8)(transaction)) {
                                            if (!_this.supportedTransactionVersions) throw new (0, $3f5d780e6d40bbac$export$96f177062fdd8180)("Signing versioned transactions isn't supported by this wallet");
                                            if (!_this.supportedTransactionVersions.has(transaction.version)) throw new (0, $3f5d780e6d40bbac$export$96f177062fdd8180)("Signing transaction version ".concat(transaction.version, " isn't supported by this wallet"));
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                signedTransactions = [];
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    8
                                ]);
                                _iterator1 = transactions[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                                    3,
                                    5
                                ];
                                transaction1 = _step1.value;
                                _ = signedTransactions.push;
                                return [
                                    4,
                                    _this.signTransaction(transaction1)
                                ];
                            case 3:
                                _.apply(signedTransactions, [
                                    _state.sent()
                                ]);
                                _state.label = 4;
                            case 4:
                                _iteratorNormalCompletion1 = true;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 8:
                                return [
                                    2,
                                    signedTransactions
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return BaseSignerWalletAdapter;
}((0, $8c7df08073723177$export$2af1ea2892adc469));
var $d1e3c3dc9d32b5d7$export$9db08bcddd106c96 = /*#__PURE__*/ function(BaseSignerWalletAdapter) {
    "use strict";
    (0, $dcsZi._)(BaseMessageSignerWalletAdapter, BaseSignerWalletAdapter);
    var _super = (0, $ohfOJ._)(BaseMessageSignerWalletAdapter);
    function BaseMessageSignerWalletAdapter() {
        (0, $4GJKx._)(this, BaseMessageSignerWalletAdapter);
        return _super.apply(this, arguments);
    }
    return BaseMessageSignerWalletAdapter;
}($d1e3c3dc9d32b5d7$export$9a51bf5d1bea9e98);
var $d1e3c3dc9d32b5d7$export$9779f871ffdb3d87 = /*#__PURE__*/ function(BaseMessageSignerWalletAdapter) {
    "use strict";
    (0, $dcsZi._)(BaseSignInMessageSignerWalletAdapter, BaseMessageSignerWalletAdapter);
    var _super = (0, $ohfOJ._)(BaseSignInMessageSignerWalletAdapter);
    function BaseSignInMessageSignerWalletAdapter() {
        (0, $4GJKx._)(this, BaseSignInMessageSignerWalletAdapter);
        return _super.apply(this, arguments);
    }
    return BaseSignInMessageSignerWalletAdapter;
}($d1e3c3dc9d32b5d7$export$9db08bcddd106c96);



var $69N5M = parcelRequire("69N5M");

var $c6Xmf = parcelRequire("c6Xmf");

var $eha6O = parcelRequire("eha6O");

var $69N5M = parcelRequire("69N5M");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");

var $dVH57 = parcelRequire("dVH57");
/**
 * @internal
 *
 * Efficiently compare {@link Indexed} arrays (e.g. `Array` and `Uint8Array`).
 *
 * @param a An array.
 * @param b Another array.
 *
 * @return `true` if the arrays have the same length and elements, `false` otherwise.
 *
 * @group Internal
 */ function $269341822e973607$export$234180f8206db11b(a, b) {
    if (a === b) return true;
    var length = a.length;
    if (length !== b.length) return false;
    for(var i = 0; i < length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $269341822e973607$export$c663ab80cce302c5(a, b) {
    return $269341822e973607$export$234180f8206db11b(a, b);
}


function $f2605d438f0cc86c$export$54b8e79a8f938f52(param) {
    var message = param.message, signedMessage = param.signedMessage, signature = param.signature, publicKey = param.publicKey;
    // TODO: implement https://github.com/solana-labs/solana/blob/master/docs/src/proposals/off-chain-message-signing.md
    return (0, $269341822e973607$export$c663ab80cce302c5)(message, signedMessage) && (0, $dVH57.ed25519).verify(signature, signedMessage, publicKey);
}
function $f2605d438f0cc86c$export$a7a8e868ceb02186(input, output) {
    var message = input.message, publicKey = input.account.publicKey;
    var signedMessage = output.signedMessage, signature = output.signature;
    return $f2605d438f0cc86c$export$54b8e79a8f938f52({
        message: message,
        signedMessage: signedMessage,
        signature: signature,
        publicKey: publicKey
    });
}



function $a8c6d2bf5142fd7c$export$9828dc452d20db63(input, output) {
    var signedMessage = output.signedMessage, signature = output.signature, publicKey = output.account.publicKey;
    var message = $a8c6d2bf5142fd7c$export$5a98156f426eafe8(input, output);
    return !!message && (0, $f2605d438f0cc86c$export$54b8e79a8f938f52)({
        message: message,
        signedMessage: signedMessage,
        signature: signature,
        publicKey: publicKey
    });
}
function $a8c6d2bf5142fd7c$export$5a98156f426eafe8(input, output) {
    var text = $a8c6d2bf5142fd7c$export$14d5fbb279d179c2(input, output);
    if (!text) return null;
    return new TextEncoder().encode(text);
}
function $a8c6d2bf5142fd7c$export$14d5fbb279d179c2(input, output) {
    var parsed = $a8c6d2bf5142fd7c$export$ddde1a7f6f94bd0a(output.signedMessage);
    if (!parsed) return null;
    if (input.domain && input.domain !== parsed.domain) return null;
    if (input.address && input.address !== parsed.address) return null;
    if (input.statement !== parsed.statement) return null;
    if (input.uri !== parsed.uri) return null;
    if (input.version !== parsed.version) return null;
    if (input.chainId !== parsed.chainId) return null;
    if (input.nonce !== parsed.nonce) return null;
    if (input.issuedAt !== parsed.issuedAt) return null;
    if (input.expirationTime !== parsed.expirationTime) return null;
    if (input.notBefore !== parsed.notBefore) return null;
    if (input.requestId !== parsed.requestId) return null;
    if (input.resources) {
        if (!parsed.resources) return null;
        if (!(0, $269341822e973607$export$234180f8206db11b)(input.resources, parsed.resources)) return null;
    } else if (parsed.resources) return null;
    return $a8c6d2bf5142fd7c$export$88aceda9565b68d2(parsed);
}
function $a8c6d2bf5142fd7c$export$ddde1a7f6f94bd0a(message) {
    var text = new TextDecoder().decode(message);
    return $a8c6d2bf5142fd7c$export$4a112f3ad8ba8e50(text);
}
// TODO: implement https://github.com/solana-labs/solana/blob/master/docs/src/proposals/off-chain-message-signing.md
var $a8c6d2bf5142fd7c$var$DOMAIN = "(?<domain>[^\\n]+?) wants you to sign in with your Solana account:\\n";
var $a8c6d2bf5142fd7c$var$ADDRESS = "(?<address>[^\\n]+)(?:\\n|$)";
var $a8c6d2bf5142fd7c$var$STATEMENT = "(?:\\n(?<statement>[\\S\\s]*?)(?:\\n|$))??";
var $a8c6d2bf5142fd7c$var$URI = "(?:\\nURI: (?<uri>[^\\n]+))?";
var $a8c6d2bf5142fd7c$var$VERSION = "(?:\\nVersion: (?<version>[^\\n]+))?";
var $a8c6d2bf5142fd7c$var$CHAIN_ID = "(?:\\nChain ID: (?<chainId>[^\\n]+))?";
var $a8c6d2bf5142fd7c$var$NONCE = "(?:\\nNonce: (?<nonce>[^\\n]+))?";
var $a8c6d2bf5142fd7c$var$ISSUED_AT = "(?:\\nIssued At: (?<issuedAt>[^\\n]+))?";
var $a8c6d2bf5142fd7c$var$EXPIRATION_TIME = "(?:\\nExpiration Time: (?<expirationTime>[^\\n]+))?";
var $a8c6d2bf5142fd7c$var$NOT_BEFORE = "(?:\\nNot Before: (?<notBefore>[^\\n]+))?";
var $a8c6d2bf5142fd7c$var$REQUEST_ID = "(?:\\nRequest ID: (?<requestId>[^\\n]+))?";
var $a8c6d2bf5142fd7c$var$RESOURCES = "(?:\\nResources:(?<resources>(?:\\n- [^\\n]+)*))?";
var $a8c6d2bf5142fd7c$var$FIELDS = "".concat($a8c6d2bf5142fd7c$var$URI).concat($a8c6d2bf5142fd7c$var$VERSION).concat($a8c6d2bf5142fd7c$var$CHAIN_ID).concat($a8c6d2bf5142fd7c$var$NONCE).concat($a8c6d2bf5142fd7c$var$ISSUED_AT).concat($a8c6d2bf5142fd7c$var$EXPIRATION_TIME).concat($a8c6d2bf5142fd7c$var$NOT_BEFORE).concat($a8c6d2bf5142fd7c$var$REQUEST_ID).concat($a8c6d2bf5142fd7c$var$RESOURCES);
var $a8c6d2bf5142fd7c$var$MESSAGE = new RegExp("^".concat($a8c6d2bf5142fd7c$var$DOMAIN).concat($a8c6d2bf5142fd7c$var$ADDRESS).concat($a8c6d2bf5142fd7c$var$STATEMENT).concat($a8c6d2bf5142fd7c$var$FIELDS, "\\n*$"));
function $a8c6d2bf5142fd7c$export$4a112f3ad8ba8e50(text) {
    var _groups_resources;
    var match = $a8c6d2bf5142fd7c$var$MESSAGE.exec(text);
    if (!match) return null;
    var groups = match.groups;
    if (!groups) return null;
    return {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        domain: groups.domain,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        address: groups.address,
        statement: groups.statement,
        uri: groups.uri,
        version: groups.version,
        nonce: groups.nonce,
        chainId: groups.chainId,
        issuedAt: groups.issuedAt,
        expirationTime: groups.expirationTime,
        notBefore: groups.notBefore,
        requestId: groups.requestId,
        resources: (_groups_resources = groups.resources) === null || _groups_resources === void 0 ? void 0 : _groups_resources.split("\n- ").slice(1)
    };
}
function $a8c6d2bf5142fd7c$export$92ddcd466ce9e7c4(input) {
    var text = $a8c6d2bf5142fd7c$export$88aceda9565b68d2(input);
    return new TextEncoder().encode(text);
}
function $a8c6d2bf5142fd7c$export$88aceda9565b68d2(input) {
    // ${domain} wants you to sign in with your Solana account:
    // ${address}
    //
    // ${statement}
    //
    // URI: ${uri}
    // Version: ${version}
    // Chain ID: ${chain}
    // Nonce: ${nonce}
    // Issued At: ${issued-at}
    // Expiration Time: ${expiration-time}
    // Not Before: ${not-before}
    // Request ID: ${request-id}
    // Resources:
    // - ${resources[0]}
    // - ${resources[1]}
    // ...
    // - ${resources[n]}
    var message = "".concat(input.domain, " wants you to sign in with your Solana account:\n");
    message += "".concat(input.address);
    if (input.statement) message += "\n\n".concat(input.statement);
    var fields = [];
    if (input.uri) fields.push("URI: ".concat(input.uri));
    if (input.version) fields.push("Version: ".concat(input.version));
    if (input.chainId) fields.push("Chain ID: ".concat(input.chainId));
    if (input.nonce) fields.push("Nonce: ".concat(input.nonce));
    if (input.issuedAt) fields.push("Issued At: ".concat(input.issuedAt));
    if (input.expirationTime) fields.push("Expiration Time: ".concat(input.expirationTime));
    if (input.notBefore) fields.push("Not Before: ".concat(input.notBefore));
    if (input.requestId) fields.push("Request ID: ".concat(input.requestId));
    if (input.resources) {
        fields.push("Resources:");
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = input.resources[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var resource = _step.value;
                fields.push("- ".concat(resource));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    if (fields.length) message += "\n\n".concat(fields.join("\n"));
    return message;
}


// Typescript `enums` thwart tree-shaking. See https://bargsten.org/jsts/enums/
var $c08f788f39a3ce67$export$93083e877aec7a8a = {
    ERROR_ASSOCIATION_PORT_OUT_OF_RANGE: "ERROR_ASSOCIATION_PORT_OUT_OF_RANGE",
    ERROR_FORBIDDEN_WALLET_BASE_URL: "ERROR_FORBIDDEN_WALLET_BASE_URL",
    ERROR_SECURE_CONTEXT_REQUIRED: "ERROR_SECURE_CONTEXT_REQUIRED",
    ERROR_SESSION_CLOSED: "ERROR_SESSION_CLOSED",
    ERROR_SESSION_TIMEOUT: "ERROR_SESSION_TIMEOUT",
    ERROR_WALLET_NOT_FOUND: "ERROR_WALLET_NOT_FOUND",
    ERROR_INVALID_PROTOCOL_VERSION: "ERROR_INVALID_PROTOCOL_VERSION"
};
var $c08f788f39a3ce67$export$d77545679c409b63 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $dcsZi._)(SolanaMobileWalletAdapterError, Error1);
    var _super = (0, $ohfOJ._)(SolanaMobileWalletAdapterError);
    function SolanaMobileWalletAdapterError() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $4GJKx._)(this, SolanaMobileWalletAdapterError);
        var _this;
        var _args = (0, $cv9Rk._)(args, 3), code = _args[0], message = _args[1], data = _args[2];
        _this = _super.call(this, message);
        _this.code = code;
        _this.data = data;
        _this.name = "SolanaMobileWalletAdapterError";
        return _this;
    }
    return SolanaMobileWalletAdapterError;
}((0, $FuVm8._)(Error));
// Typescript `enums` thwart tree-shaking. See https://bargsten.org/jsts/enums/
var $c08f788f39a3ce67$export$23d27841621bc1e8 = {
    // Keep these in sync with `mobilewalletadapter/common/ProtocolContract.java`.
    ERROR_AUTHORIZATION_FAILED: -1,
    ERROR_INVALID_PAYLOADS: -2,
    ERROR_NOT_SIGNED: -3,
    ERROR_NOT_SUBMITTED: -4,
    ERROR_TOO_MANY_PAYLOADS: -5,
    ERROR_ATTEST_ORIGIN_ANDROID: -100
};
var $c08f788f39a3ce67$export$58b788f937123c66 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $dcsZi._)(SolanaMobileWalletAdapterProtocolError, Error1);
    var _super = (0, $ohfOJ._)(SolanaMobileWalletAdapterProtocolError);
    function SolanaMobileWalletAdapterProtocolError() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $4GJKx._)(this, SolanaMobileWalletAdapterProtocolError);
        var _this;
        var _args = (0, $cv9Rk._)(args, 4), jsonRpcMessageId = _args[0], code = _args[1], message = _args[2], data = _args[3];
        _this = _super.call(this, message);
        _this.code = code;
        _this.data = data;
        _this.jsonRpcMessageId = jsonRpcMessageId;
        _this.name = "SolanaMobileWalletAdapterProtocolError";
        return _this;
    }
    return SolanaMobileWalletAdapterProtocolError;
}((0, $FuVm8._)(Error));
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $c08f788f39a3ce67$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c08f788f39a3ce67$var$createHelloReq(ecdhPublicKey, associationKeypairPrivateKey) {
    return $c08f788f39a3ce67$var$__awaiter(this, void 0, void 0, function() {
        var publicKeyBuffer, signatureBuffer, response;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        crypto.subtle.exportKey("raw", ecdhPublicKey)
                    ];
                case 1:
                    publicKeyBuffer = _state.sent();
                    return [
                        4,
                        crypto.subtle.sign({
                            hash: "SHA-256",
                            name: "ECDSA"
                        }, associationKeypairPrivateKey, publicKeyBuffer)
                    ];
                case 2:
                    signatureBuffer = _state.sent();
                    response = new Uint8Array(publicKeyBuffer.byteLength + signatureBuffer.byteLength);
                    response.set(new Uint8Array(publicKeyBuffer), 0);
                    response.set(new Uint8Array(signatureBuffer), publicKeyBuffer.byteLength);
                    return [
                        2,
                        response
                    ];
            }
        });
    });
}
function $c08f788f39a3ce67$var$encode(input) {
    return window.btoa(input);
}
function $c08f788f39a3ce67$var$createSIWSMessage(payload) {
    return (0, $a8c6d2bf5142fd7c$export$88aceda9565b68d2)(payload);
}
function $c08f788f39a3ce67$var$createSIWSMessageBase64(payload) {
    return $c08f788f39a3ce67$var$encode($c08f788f39a3ce67$var$createSIWSMessage(payload));
}
// optional features
var $c08f788f39a3ce67$export$6d2aa8b15676f603 = "solana:signTransactions";
var $c08f788f39a3ce67$export$7b8713ece485d770 = "solana:cloneAuthorization";
var $c08f788f39a3ce67$export$fca2a421c519d7f8 = "solana:signInWithSolana";
/**
 * Creates a {@link MobileWallet} proxy that handles backwards compatibility and API to RPC conversion.
 *
 * @param protocolVersion the protocol version in use for this session/request
 * @param protocolRequestHandler callback function that handles sending the RPC request to the wallet endpoint.
 * @returns a {@link MobileWallet} proxy
 */ function $c08f788f39a3ce67$var$createMobileWalletProxy(protocolVersion, protocolRequestHandler) {
    return new Proxy({}, {
        get: function(target, p) {
            if (target[p] == null) target[p] = function(inputParams) {
                return $c08f788f39a3ce67$var$__awaiter(this, void 0, void 0, function() {
                    var _handleMobileWalletRequest, method, params, result, _;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _handleMobileWalletRequest = $c08f788f39a3ce67$var$handleMobileWalletRequest(p, inputParams, protocolVersion), method = _handleMobileWalletRequest.method, params = _handleMobileWalletRequest.params;
                                return [
                                    4,
                                    protocolRequestHandler(method, params)
                                ];
                            case 1:
                                result = _state.sent();
                                if (!(method === "authorize" && params.sign_in_payload && !result.sign_in_result)) return [
                                    3,
                                    3
                                ];
                                _ = "sign_in_result";
                                return [
                                    4,
                                    $c08f788f39a3ce67$var$signInFallback(params.sign_in_payload, result, protocolRequestHandler)
                                ];
                            case 2:
                                result[_] = _state.sent();
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    $c08f788f39a3ce67$var$handleMobileWalletResponse(p, result, protocolVersion)
                                ];
                        }
                    });
                });
            };
            return target[p];
        },
        defineProperty: function() {
            return false;
        },
        deleteProperty: function() {
            return false;
        }
    });
}
/**
 * Handles all {@link MobileWallet} API requests and determines the correct MWA RPC method and params to call.
 * This handles backwards compatibility, based on the provided @protocolVersion.
 *
 * @param methodName the name of {@link MobileWallet} method that was called
 * @param methodParams the parameters that were passed to the method
 * @param protocolVersion the protocol version in use for this session/request
 * @returns the RPC request method and params that should be sent to the wallet endpoint
 */ function $c08f788f39a3ce67$var$handleMobileWalletRequest(methodName, methodParams, protocolVersion) {
    var params = methodParams;
    var method = methodName.toString().replace(/[A-Z]/g, function(letter) {
        return "_".concat(letter.toLowerCase());
    }).toLowerCase();
    switch(methodName){
        case "authorize":
            {
                var chain = params.chain;
                if (protocolVersion === "legacy") {
                    switch(chain){
                        case "solana:testnet":
                            chain = "testnet";
                            break;
                        case "solana:devnet":
                            chain = "devnet";
                            break;
                        case "solana:mainnet":
                            chain = "mainnet-beta";
                            break;
                        default:
                            chain = params.cluster;
                    }
                    params.cluster = chain;
                } else {
                    switch(chain){
                        case "testnet":
                        case "devnet":
                            chain = "solana:".concat(chain);
                            break;
                        case "mainnet-beta":
                            chain = "solana:mainnet";
                            break;
                    }
                    params.chain = chain;
                }
            }
        case "reauthorize":
            {
                var auth_token = params.auth_token, identity = params.identity;
                if (auth_token) switch(protocolVersion){
                    case "legacy":
                        method = "reauthorize";
                        params = {
                            auth_token: auth_token,
                            identity: identity
                        };
                        break;
                    default:
                        method = "authorize";
                        break;
                }
                break;
            }
    }
    return {
        method: method,
        params: params
    };
}
/**
 * Handles all {@link MobileWallet} API responses and modifies the response for backwards compatibility, if needed
 *
 * @param method the {@link MobileWallet} method that was called
 * @param response the original response that was returned by the method call
 * @param protocolVersion the protocol version in use for this session/request
 * @returns the possibly modified response
 */ function $c08f788f39a3ce67$var$handleMobileWalletResponse(method, response, protocolVersion) {
    switch(method){
        case "getCapabilities":
            {
                var capabilities = response;
                switch(protocolVersion){
                    case "legacy":
                        {
                            var features = [
                                $c08f788f39a3ce67$export$6d2aa8b15676f603
                            ];
                            if (capabilities.supports_clone_authorization === true) features.push($c08f788f39a3ce67$export$7b8713ece485d770);
                            return Object.assign(Object.assign({}, capabilities), {
                                features: features
                            });
                        }
                    case "v1":
                        return Object.assign(Object.assign({}, capabilities), {
                            supports_sign_and_send_transactions: true,
                            supports_clone_authorization: capabilities.features.includes($c08f788f39a3ce67$export$7b8713ece485d770)
                        });
                }
            }
    }
    return response;
}
function $c08f788f39a3ce67$var$signInFallback(signInPayload, authorizationResult, protocolRequestHandler) {
    var _a;
    return $c08f788f39a3ce67$var$__awaiter(this, void 0, void 0, function() {
        var domain, address, siwsMessage, signMessageResult, signInResult;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    domain = (_a = signInPayload.domain) !== null && _a !== void 0 ? _a : window.location.host;
                    address = authorizationResult.accounts[0].address;
                    siwsMessage = $c08f788f39a3ce67$var$createSIWSMessageBase64(Object.assign(Object.assign({}, signInPayload), {
                        domain: domain,
                        address: address
                    }));
                    return [
                        4,
                        protocolRequestHandler("sign_messages", {
                            addresses: [
                                address
                            ],
                            payloads: [
                                siwsMessage
                            ]
                        })
                    ];
                case 1:
                    signMessageResult = _state.sent();
                    signInResult = {
                        address: address,
                        signed_message: siwsMessage,
                        signature: signMessageResult.signed_payloads[0].slice(siwsMessage.length)
                    };
                    return [
                        2,
                        signInResult
                    ];
            }
        });
    });
}
var $c08f788f39a3ce67$var$SEQUENCE_NUMBER_BYTES = 4;
function $c08f788f39a3ce67$var$createSequenceNumberVector(sequenceNumber) {
    if (sequenceNumber >= 4294967296) throw new Error("Outbound sequence number overflow. The maximum sequence number is 32-bytes.");
    var byteArray = new ArrayBuffer($c08f788f39a3ce67$var$SEQUENCE_NUMBER_BYTES);
    var view = new DataView(byteArray);
    view.setUint32(0, sequenceNumber, /* littleEndian */ false);
    return new Uint8Array(byteArray);
}
var $c08f788f39a3ce67$var$INITIALIZATION_VECTOR_BYTES = 12;
var $c08f788f39a3ce67$var$ENCODED_PUBLIC_KEY_LENGTH_BYTES = 65;
function $c08f788f39a3ce67$var$encryptMessage(plaintext, sequenceNumber, sharedSecret) {
    return $c08f788f39a3ce67$var$__awaiter(this, void 0, void 0, function() {
        var sequenceNumberVector, initializationVector, ciphertext, response;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    sequenceNumberVector = $c08f788f39a3ce67$var$createSequenceNumberVector(sequenceNumber);
                    initializationVector = new Uint8Array($c08f788f39a3ce67$var$INITIALIZATION_VECTOR_BYTES);
                    crypto.getRandomValues(initializationVector);
                    return [
                        4,
                        crypto.subtle.encrypt($c08f788f39a3ce67$var$getAlgorithmParams(sequenceNumberVector, initializationVector), sharedSecret, new TextEncoder().encode(plaintext))
                    ];
                case 1:
                    ciphertext = _state.sent();
                    response = new Uint8Array(sequenceNumberVector.byteLength + initializationVector.byteLength + ciphertext.byteLength);
                    response.set(new Uint8Array(sequenceNumberVector), 0);
                    response.set(new Uint8Array(initializationVector), sequenceNumberVector.byteLength);
                    response.set(new Uint8Array(ciphertext), sequenceNumberVector.byteLength + initializationVector.byteLength);
                    return [
                        2,
                        response
                    ];
            }
        });
    });
}
function $c08f788f39a3ce67$var$decryptMessage(message, sharedSecret) {
    return $c08f788f39a3ce67$var$__awaiter(this, void 0, void 0, function() {
        var sequenceNumberVector, initializationVector, ciphertext, plaintextBuffer, plaintext;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    sequenceNumberVector = message.slice(0, $c08f788f39a3ce67$var$SEQUENCE_NUMBER_BYTES);
                    initializationVector = message.slice($c08f788f39a3ce67$var$SEQUENCE_NUMBER_BYTES, $c08f788f39a3ce67$var$SEQUENCE_NUMBER_BYTES + $c08f788f39a3ce67$var$INITIALIZATION_VECTOR_BYTES);
                    ciphertext = message.slice($c08f788f39a3ce67$var$SEQUENCE_NUMBER_BYTES + $c08f788f39a3ce67$var$INITIALIZATION_VECTOR_BYTES);
                    return [
                        4,
                        crypto.subtle.decrypt($c08f788f39a3ce67$var$getAlgorithmParams(sequenceNumberVector, initializationVector), sharedSecret, ciphertext)
                    ];
                case 1:
                    plaintextBuffer = _state.sent();
                    plaintext = $c08f788f39a3ce67$var$getUtf8Decoder().decode(plaintextBuffer);
                    return [
                        2,
                        plaintext
                    ];
            }
        });
    });
}
function $c08f788f39a3ce67$var$getAlgorithmParams(sequenceNumber, initializationVector) {
    return {
        additionalData: sequenceNumber,
        iv: initializationVector,
        name: "AES-GCM",
        tagLength: 128
    };
}
var $c08f788f39a3ce67$var$_utf8Decoder;
function $c08f788f39a3ce67$var$getUtf8Decoder() {
    if ($c08f788f39a3ce67$var$_utf8Decoder === undefined) $c08f788f39a3ce67$var$_utf8Decoder = new TextDecoder("utf-8");
    return $c08f788f39a3ce67$var$_utf8Decoder;
}
function $c08f788f39a3ce67$var$generateAssociationKeypair() {
    return $c08f788f39a3ce67$var$__awaiter(this, void 0, void 0, function() {
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        crypto.subtle.generateKey({
                            name: "ECDSA",
                            namedCurve: "P-256"
                        }, false, [
                            "sign"
                        ])
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
}
function $c08f788f39a3ce67$var$generateECDHKeypair() {
    return $c08f788f39a3ce67$var$__awaiter(this, void 0, void 0, function() {
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        crypto.subtle.generateKey({
                            name: "ECDH",
                            namedCurve: "P-256"
                        }, false, [
                            "deriveKey",
                            "deriveBits"
                        ])
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
}
function $c08f788f39a3ce67$var$encryptJsonRpcMessage(jsonRpcMessage, sharedSecret) {
    return $c08f788f39a3ce67$var$__awaiter(this, void 0, void 0, function() {
        var plaintext, sequenceNumber;
        return (0, $eha6O.__generator)(this, function(_state) {
            plaintext = JSON.stringify(jsonRpcMessage);
            sequenceNumber = jsonRpcMessage.id;
            return [
                2,
                $c08f788f39a3ce67$var$encryptMessage(plaintext, sequenceNumber, sharedSecret)
            ];
        });
    });
}
function $c08f788f39a3ce67$var$decryptJsonRpcMessage(message, sharedSecret) {
    return $c08f788f39a3ce67$var$__awaiter(this, void 0, void 0, function() {
        var plaintext, jsonRpcMessage;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $c08f788f39a3ce67$var$decryptMessage(message, sharedSecret)
                    ];
                case 1:
                    plaintext = _state.sent();
                    jsonRpcMessage = JSON.parse(plaintext);
                    if (Object.hasOwnProperty.call(jsonRpcMessage, "error")) throw new $c08f788f39a3ce67$export$58b788f937123c66(jsonRpcMessage.id, jsonRpcMessage.error.code, jsonRpcMessage.error.message);
                    return [
                        2,
                        jsonRpcMessage
                    ];
            }
        });
    });
}
function $c08f788f39a3ce67$var$parseHelloRsp(payloadBuffer, associationPublicKey, ecdhPrivateKey) {
    return $c08f788f39a3ce67$var$__awaiter(this, void 0, void 0, function() {
        var _ref, associationPublicKeyBuffer, walletPublicKey, sharedSecret, ecdhSecretKey, aesKeyMaterialVal;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.all([
                            crypto.subtle.exportKey("raw", associationPublicKey),
                            crypto.subtle.importKey("raw", payloadBuffer.slice(0, $c08f788f39a3ce67$var$ENCODED_PUBLIC_KEY_LENGTH_BYTES), {
                                name: "ECDH",
                                namedCurve: "P-256"
                            }, false, [])
                        ])
                    ];
                case 1:
                    _ref = (0, $cv9Rk._).apply(void 0, [
                        _state.sent(),
                        2
                    ]), associationPublicKeyBuffer = _ref[0], walletPublicKey = _ref[1];
                    return [
                        4,
                        crypto.subtle.deriveBits({
                            name: "ECDH",
                            public: walletPublicKey
                        }, ecdhPrivateKey, 256)
                    ];
                case 2:
                    sharedSecret = _state.sent();
                    return [
                        4,
                        crypto.subtle.importKey("raw", sharedSecret, "HKDF", false, [
                            "deriveKey"
                        ])
                    ];
                case 3:
                    ecdhSecretKey = _state.sent();
                    return [
                        4,
                        crypto.subtle.deriveKey({
                            name: "HKDF",
                            hash: "SHA-256",
                            salt: new Uint8Array(associationPublicKeyBuffer),
                            info: new Uint8Array()
                        }, ecdhSecretKey, {
                            name: "AES-GCM",
                            length: 128
                        }, false, [
                            "encrypt",
                            "decrypt"
                        ])
                    ];
                case 4:
                    aesKeyMaterialVal = _state.sent();
                    return [
                        2,
                        aesKeyMaterialVal
                    ];
            }
        });
    });
}
function $c08f788f39a3ce67$var$parseSessionProps(message, sharedSecret) {
    return $c08f788f39a3ce67$var$__awaiter(this, void 0, void 0, function() {
        var plaintext, jsonProperties, protocolVersion;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $c08f788f39a3ce67$var$decryptMessage(message, sharedSecret)
                    ];
                case 1:
                    plaintext = _state.sent();
                    jsonProperties = JSON.parse(plaintext);
                    protocolVersion = "legacy";
                    if (Object.hasOwnProperty.call(jsonProperties, "v")) switch(jsonProperties.v){
                        case 1:
                        case "1":
                        case "v1":
                            protocolVersion = "v1";
                            break;
                        case "legacy":
                            protocolVersion = "legacy";
                            break;
                        default:
                            throw new $c08f788f39a3ce67$export$d77545679c409b63($c08f788f39a3ce67$export$93083e877aec7a8a.ERROR_INVALID_PROTOCOL_VERSION, "Unknown/unsupported protocol version: ".concat(jsonProperties.v));
                    }
                    return [
                        2,
                        {
                            protocol_version: protocolVersion
                        }
                    ];
            }
        });
    });
}
function $c08f788f39a3ce67$var$getRandomAssociationPort() {
    return $c08f788f39a3ce67$var$assertAssociationPort(49152 + Math.floor(Math.random() * 16384));
}
function $c08f788f39a3ce67$var$assertAssociationPort(port) {
    if (port < 49152 || port > 65535) throw new $c08f788f39a3ce67$export$d77545679c409b63($c08f788f39a3ce67$export$93083e877aec7a8a.ERROR_ASSOCIATION_PORT_OUT_OF_RANGE, "Association port number must be between 49152 and 65535. ".concat(port, " given."), {
        port: port
    });
    return port;
}
// https://stackoverflow.com/a/9458996/802047
function $c08f788f39a3ce67$var$arrayBufferToBase64String(buffer) {
    var binary = "";
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for(var ii = 0; ii < len; ii++)binary += String.fromCharCode(bytes[ii]);
    return window.btoa(binary);
}
function $c08f788f39a3ce67$var$getStringWithURLUnsafeCharactersReplaced(unsafeBase64EncodedString) {
    return unsafeBase64EncodedString.replace(/[/+=]/g, function(m) {
        return ({
            "/": "_",
            "+": "-",
            "=": "."
        })[m];
    });
}
var $c08f788f39a3ce67$var$INTENT_NAME = "solana-wallet";
function $c08f788f39a3ce67$var$getPathParts(pathString) {
    return pathString// Strip leading and trailing slashes
    .replace(/(^\/+|\/+$)/g, "")// Return an array of directories
    .split("/");
}
function $c08f788f39a3ce67$var$getIntentURL(methodPathname, intentUrlBase) {
    var baseUrl = null;
    if (intentUrlBase) {
        try {
            baseUrl = new URL(intentUrlBase);
        } catch (_a) {} // eslint-disable-line no-empty
        if ((baseUrl === null || baseUrl === void 0 ? void 0 : baseUrl.protocol) !== "https:") throw new $c08f788f39a3ce67$export$d77545679c409b63($c08f788f39a3ce67$export$93083e877aec7a8a.ERROR_FORBIDDEN_WALLET_BASE_URL, "Base URLs supplied by wallets must be valid `https` URLs");
    }
    baseUrl || (baseUrl = new URL("".concat($c08f788f39a3ce67$var$INTENT_NAME, ":/")));
    var pathname = methodPathname.startsWith("/") ? methodPathname : (0, $c6Xmf._)($c08f788f39a3ce67$var$getPathParts(baseUrl.pathname)).concat((0, $c6Xmf._)($c08f788f39a3ce67$var$getPathParts(methodPathname))).join("/");
    return new URL(pathname, baseUrl);
}
function $c08f788f39a3ce67$var$getAssociateAndroidIntentURL(associationPublicKey, putativePort, associationURLBase) {
    var protocolVersions = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [
        "v1"
    ];
    return $c08f788f39a3ce67$var$__awaiter(this, void 0, void 0, function() {
        var associationPort, exportedKey, encodedKey, url;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    associationPort = $c08f788f39a3ce67$var$assertAssociationPort(putativePort);
                    return [
                        4,
                        crypto.subtle.exportKey("raw", associationPublicKey)
                    ];
                case 1:
                    exportedKey = _state.sent();
                    encodedKey = $c08f788f39a3ce67$var$arrayBufferToBase64String(exportedKey);
                    url = $c08f788f39a3ce67$var$getIntentURL("v1/associate/local", associationURLBase);
                    url.searchParams.set("association", $c08f788f39a3ce67$var$getStringWithURLUnsafeCharactersReplaced(encodedKey));
                    url.searchParams.set("port", "".concat(associationPort));
                    protocolVersions.forEach(function(version) {
                        url.searchParams.set("v", version);
                    });
                    return [
                        2,
                        url
                    ];
            }
        });
    });
}
// Typescript `enums` thwart tree-shaking. See https://bargsten.org/jsts/enums/
var $c08f788f39a3ce67$var$Browser = {
    Firefox: 0,
    Other: 1
};
function $c08f788f39a3ce67$var$assertUnreachable(x) {
    return x;
}
function $c08f788f39a3ce67$var$getBrowser() {
    return navigator.userAgent.indexOf("Firefox/") !== -1 ? $c08f788f39a3ce67$var$Browser.Firefox : $c08f788f39a3ce67$var$Browser.Other;
}
function $c08f788f39a3ce67$var$getDetectionPromise() {
    // Chrome and others silently fail if a custom protocol is not supported.
    // For these, we wait to see if the browser is navigated away from in
    // a reasonable amount of time (ie. the native wallet opened).
    return new Promise(function(resolve, reject) {
        function cleanup() {
            clearTimeout(timeoutId);
            window.removeEventListener("blur", handleBlur);
        }
        function handleBlur() {
            cleanup();
            resolve();
        }
        window.addEventListener("blur", handleBlur);
        var timeoutId = setTimeout(function() {
            cleanup();
            reject();
        }, 2000);
    });
}
var $c08f788f39a3ce67$var$_frame = null;
function $c08f788f39a3ce67$var$launchUrlThroughHiddenFrame(url) {
    if ($c08f788f39a3ce67$var$_frame == null) {
        $c08f788f39a3ce67$var$_frame = document.createElement("iframe");
        $c08f788f39a3ce67$var$_frame.style.display = "none";
        document.body.appendChild($c08f788f39a3ce67$var$_frame);
    }
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $c08f788f39a3ce67$var$_frame.contentWindow.location.href = url.toString();
}
function $c08f788f39a3ce67$var$startSession(associationPublicKey, associationURLBase) {
    return $c08f788f39a3ce67$var$__awaiter(this, void 0, void 0, function() {
        var randomAssociationPort, associationUrl, browser, detectionPromise, e;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    randomAssociationPort = $c08f788f39a3ce67$var$getRandomAssociationPort();
                    return [
                        4,
                        $c08f788f39a3ce67$var$getAssociateAndroidIntentURL(associationPublicKey, randomAssociationPort, associationURLBase)
                    ];
                case 1:
                    associationUrl = _state.sent();
                    if (!(associationUrl.protocol === "https:")) return [
                        3,
                        2
                    ];
                    // The association URL is an Android 'App Link' or iOS 'Universal Link'.
                    // These are regular web URLs that are designed to launch an app if it
                    // is installed or load the actual target webpage if not.
                    window.location.assign(associationUrl);
                    return [
                        3,
                        9
                    ];
                case 2:
                    _state.trys.push([
                        2,
                        8,
                        ,
                        9
                    ]);
                    browser = $c08f788f39a3ce67$var$getBrowser();
                    switch(browser){
                        case $c08f788f39a3ce67$var$Browser.Firefox:
                            return [
                                3,
                                3
                            ];
                        case $c08f788f39a3ce67$var$Browser.Other:
                            return [
                                3,
                                4
                            ];
                    }
                    return [
                        3,
                        6
                    ];
                case 3:
                    // If a custom protocol is not supported in Firefox, it throws.
                    $c08f788f39a3ce67$var$launchUrlThroughHiddenFrame(associationUrl);
                    // If we reached this line, it's supported.
                    return [
                        3,
                        7
                    ];
                case 4:
                    detectionPromise = $c08f788f39a3ce67$var$getDetectionPromise();
                    window.location.assign(associationUrl);
                    return [
                        4,
                        detectionPromise
                    ];
                case 5:
                    _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    $c08f788f39a3ce67$var$assertUnreachable(browser);
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        9
                    ];
                case 8:
                    e = _state.sent();
                    throw new $c08f788f39a3ce67$export$d77545679c409b63($c08f788f39a3ce67$export$93083e877aec7a8a.ERROR_WALLET_NOT_FOUND, "Found no installed wallet that supports the mobile wallet protocol.");
                case 9:
                    return [
                        2,
                        randomAssociationPort
                    ];
            }
        });
    });
}
var $c08f788f39a3ce67$var$WEBSOCKET_CONNECTION_CONFIG = {
    /**
     * 300 milliseconds is a generally accepted threshold for what someone
     * would consider an acceptable response time for a user interface
     * after having performed a low-attention tapping task. We set the initial
     * interval at which we wait for the wallet to set up the websocket at
     * half this, as per the Nyquist frequency, with a progressive backoff
     * sequence from there. The total wait time is 30s, which allows for the
     * user to be presented with a disambiguation dialog, select a wallet, and
     * for the wallet app to subsequently start.
     */ retryDelayScheduleMs: [
        150,
        150,
        200,
        500,
        500,
        750,
        750,
        1000
    ],
    timeoutMs: 30000
};
var $c08f788f39a3ce67$var$WEBSOCKET_PROTOCOL = "com.solana.mobilewalletadapter.v1";
function $c08f788f39a3ce67$var$assertSecureContext() {
    if (typeof window === "undefined" || window.isSecureContext !== true) throw new $c08f788f39a3ce67$export$d77545679c409b63($c08f788f39a3ce67$export$93083e877aec7a8a.ERROR_SECURE_CONTEXT_REQUIRED, "The mobile wallet adapter protocol must be used in a secure context (`https`).");
}
function $c08f788f39a3ce67$var$assertSecureEndpointSpecificURI(walletUriBase) {
    var url;
    try {
        url = new URL(walletUriBase);
    } catch (_a) {
        throw new $c08f788f39a3ce67$export$d77545679c409b63($c08f788f39a3ce67$export$93083e877aec7a8a.ERROR_FORBIDDEN_WALLET_BASE_URL, "Invalid base URL supplied by wallet");
    }
    if (url.protocol !== "https:") throw new $c08f788f39a3ce67$export$d77545679c409b63($c08f788f39a3ce67$export$93083e877aec7a8a.ERROR_FORBIDDEN_WALLET_BASE_URL, "Base URLs supplied by wallets must be valid `https` URLs");
}
function $c08f788f39a3ce67$var$getSequenceNumberFromByteArray(byteArray) {
    var view = new DataView(byteArray);
    return view.getUint32(0, /* littleEndian */ false);
}
function $c08f788f39a3ce67$export$dac1bad6146b2469(callback, config) {
    return $c08f788f39a3ce67$var$__awaiter(this, void 0, void 0, function() {
        var _this, associationKeypair, sessionPort, websocketURL, connectionStartTime, getNextRetryDelayMs, nextJsonRpcMessageId, lastKnownInboundSequenceNumber, state;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _this = this;
                    $c08f788f39a3ce67$var$assertSecureContext();
                    return [
                        4,
                        $c08f788f39a3ce67$var$generateAssociationKeypair()
                    ];
                case 1:
                    associationKeypair = _state.sent();
                    return [
                        4,
                        $c08f788f39a3ce67$var$startSession(associationKeypair.publicKey, config === null || config === void 0 ? void 0 : config.baseUri)
                    ];
                case 2:
                    sessionPort = _state.sent();
                    websocketURL = "ws://localhost:".concat(sessionPort, "/solana-wallet");
                    getNextRetryDelayMs = function() {
                        var schedule = (0, $c6Xmf._)($c08f788f39a3ce67$var$WEBSOCKET_CONNECTION_CONFIG.retryDelayScheduleMs);
                        return function() {
                            return schedule.length > 1 ? schedule.shift() : schedule[0];
                        };
                    }();
                    nextJsonRpcMessageId = 1;
                    lastKnownInboundSequenceNumber = 0;
                    state = {
                        __type: "disconnected"
                    };
                    return [
                        2,
                        new Promise(function(resolve, reject) {
                            var socket;
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            var jsonRpcResponsePromises = {};
                            var handleOpen = function() {
                                return $c08f788f39a3ce67$var$__awaiter(_this, void 0, void 0, function() {
                                    var associationKeypair, ecdhKeypair, _;
                                    return (0, $eha6O.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (state.__type !== "connecting") {
                                                    console.warn("Expected adapter state to be `connecting` at the moment the websocket opens. " + "Got `".concat(state.__type, "`."));
                                                    return [
                                                        2
                                                    ];
                                                }
                                                associationKeypair = state.associationKeypair;
                                                socket.removeEventListener("open", handleOpen);
                                                return [
                                                    4,
                                                    $c08f788f39a3ce67$var$generateECDHKeypair()
                                                ];
                                            case 1:
                                                ecdhKeypair = _state.sent();
                                                _ = socket.send;
                                                return [
                                                    4,
                                                    $c08f788f39a3ce67$var$createHelloReq(ecdhKeypair.publicKey, associationKeypair.privateKey)
                                                ];
                                            case 2:
                                                _.apply(socket, [
                                                    _state.sent()
                                                ]);
                                                state = {
                                                    __type: "hello_req_sent",
                                                    associationPublicKey: associationKeypair.publicKey,
                                                    ecdhPrivateKey: ecdhKeypair.privateKey
                                                };
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            };
                            var handleClose = function(evt) {
                                if (evt.wasClean) state = {
                                    __type: "disconnected"
                                };
                                else reject(new $c08f788f39a3ce67$export$d77545679c409b63($c08f788f39a3ce67$export$93083e877aec7a8a.ERROR_SESSION_CLOSED, "The wallet session dropped unexpectedly (".concat(evt.code, ": ").concat(evt.reason, ")."), {
                                    closeEvent: evt
                                }));
                                disposeSocket();
                            };
                            var handleError = function(_evt) {
                                return $c08f788f39a3ce67$var$__awaiter(_this, void 0, void 0, function() {
                                    return (0, $eha6O.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                disposeSocket();
                                                if (!(Date.now() - connectionStartTime >= $c08f788f39a3ce67$var$WEBSOCKET_CONNECTION_CONFIG.timeoutMs)) return [
                                                    3,
                                                    1
                                                ];
                                                reject(new $c08f788f39a3ce67$export$d77545679c409b63($c08f788f39a3ce67$export$93083e877aec7a8a.ERROR_SESSION_TIMEOUT, "Failed to connect to the wallet websocket on port ".concat(sessionPort, ".")));
                                                return [
                                                    3,
                                                    3
                                                ];
                                            case 1:
                                                return [
                                                    4,
                                                    new Promise(function(resolve) {
                                                        var retryDelayMs = getNextRetryDelayMs();
                                                        retryWaitTimeoutId = window.setTimeout(resolve, retryDelayMs);
                                                    })
                                                ];
                                            case 2:
                                                _state.sent();
                                                attemptSocketConnection();
                                                _state.label = 3;
                                            case 3:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            };
                            var handleMessage = function(evt) {
                                return $c08f788f39a3ce67$var$__awaiter(_this, void 0, void 0, function() {
                                    var _this, responseBuffer, _, sequenceNumberVector, sequenceNumber, jsonRpcMessage, responsePromise, e, responsePromise1, sharedSecret, sessionPropertiesBuffer, sessionProperties, _tmp, wallet, e1;
                                    return (0, $eha6O.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _this = this;
                                                return [
                                                    4,
                                                    evt.data.arrayBuffer()
                                                ];
                                            case 1:
                                                responseBuffer = _state.sent();
                                                _ = state.__type;
                                                switch(_){
                                                    case "connected":
                                                        return [
                                                            3,
                                                            2
                                                        ];
                                                    case "hello_req_sent":
                                                        return [
                                                            3,
                                                            6
                                                        ];
                                                }
                                                return [
                                                    3,
                                                    16
                                                ];
                                            case 2:
                                                _state.trys.push([
                                                    2,
                                                    4,
                                                    ,
                                                    5
                                                ]);
                                                sequenceNumberVector = responseBuffer.slice(0, $c08f788f39a3ce67$var$SEQUENCE_NUMBER_BYTES);
                                                sequenceNumber = $c08f788f39a3ce67$var$getSequenceNumberFromByteArray(sequenceNumberVector);
                                                if (sequenceNumber !== lastKnownInboundSequenceNumber + 1) throw new Error("Encrypted message has invalid sequence number");
                                                lastKnownInboundSequenceNumber = sequenceNumber;
                                                return [
                                                    4,
                                                    $c08f788f39a3ce67$var$decryptJsonRpcMessage(responseBuffer, state.sharedSecret)
                                                ];
                                            case 3:
                                                jsonRpcMessage = _state.sent();
                                                responsePromise = jsonRpcResponsePromises[jsonRpcMessage.id];
                                                delete jsonRpcResponsePromises[jsonRpcMessage.id];
                                                responsePromise.resolve(jsonRpcMessage.result);
                                                return [
                                                    3,
                                                    5
                                                ];
                                            case 4:
                                                e = _state.sent();
                                                if (e instanceof $c08f788f39a3ce67$export$58b788f937123c66) {
                                                    responsePromise1 = jsonRpcResponsePromises[e.jsonRpcMessageId];
                                                    delete jsonRpcResponsePromises[e.jsonRpcMessageId];
                                                    responsePromise1.reject(e);
                                                } else throw e;
                                                return [
                                                    3,
                                                    5
                                                ];
                                            case 5:
                                                return [
                                                    3,
                                                    16
                                                ];
                                            case 6:
                                                return [
                                                    4,
                                                    $c08f788f39a3ce67$var$parseHelloRsp(responseBuffer, state.associationPublicKey, state.ecdhPrivateKey)
                                                ];
                                            case 7:
                                                sharedSecret = _state.sent();
                                                sessionPropertiesBuffer = responseBuffer.slice($c08f788f39a3ce67$var$ENCODED_PUBLIC_KEY_LENGTH_BYTES);
                                                if (!(sessionPropertiesBuffer.byteLength !== 0)) return [
                                                    3,
                                                    9
                                                ];
                                                return [
                                                    4,
                                                    function() {
                                                        return $c08f788f39a3ce67$var$__awaiter(_this, void 0, void 0, function() {
                                                            var sequenceNumberVector, sequenceNumber;
                                                            return (0, $eha6O.__generator)(this, function(_state) {
                                                                sequenceNumberVector = sessionPropertiesBuffer.slice(0, $c08f788f39a3ce67$var$SEQUENCE_NUMBER_BYTES);
                                                                sequenceNumber = $c08f788f39a3ce67$var$getSequenceNumberFromByteArray(sequenceNumberVector);
                                                                if (sequenceNumber !== lastKnownInboundSequenceNumber + 1) throw new Error("Encrypted message has invalid sequence number");
                                                                lastKnownInboundSequenceNumber = sequenceNumber;
                                                                return [
                                                                    2,
                                                                    $c08f788f39a3ce67$var$parseSessionProps(sessionPropertiesBuffer, sharedSecret)
                                                                ];
                                                            });
                                                        });
                                                    }()
                                                ];
                                            case 8:
                                                _tmp = _state.sent();
                                                return [
                                                    3,
                                                    10
                                                ];
                                            case 9:
                                                _tmp = {
                                                    protocol_version: "legacy"
                                                };
                                                _state.label = 10;
                                            case 10:
                                                sessionProperties = _tmp;
                                                state = {
                                                    __type: "connected",
                                                    sharedSecret: sharedSecret,
                                                    sessionProperties: sessionProperties
                                                };
                                                wallet = $c08f788f39a3ce67$var$createMobileWalletProxy(sessionProperties.protocol_version, function(method, params) {
                                                    return $c08f788f39a3ce67$var$__awaiter(_this, void 0, void 0, function() {
                                                        var id, _;
                                                        return (0, $eha6O.__generator)(this, function(_state) {
                                                            switch(_state.label){
                                                                case 0:
                                                                    id = nextJsonRpcMessageId++;
                                                                    _ = socket.send;
                                                                    return [
                                                                        4,
                                                                        $c08f788f39a3ce67$var$encryptJsonRpcMessage({
                                                                            id: id,
                                                                            jsonrpc: "2.0",
                                                                            method: method,
                                                                            params: params !== null && params !== void 0 ? params : {}
                                                                        }, sharedSecret)
                                                                    ];
                                                                case 1:
                                                                    _.apply(socket, [
                                                                        _state.sent()
                                                                    ]);
                                                                    return [
                                                                        2,
                                                                        new Promise(function(resolve, reject) {
                                                                            jsonRpcResponsePromises[id] = {
                                                                                resolve: function(result) {
                                                                                    switch(method){
                                                                                        case "authorize":
                                                                                        case "reauthorize":
                                                                                            {
                                                                                                var wallet_uri_base = result.wallet_uri_base;
                                                                                                if (wallet_uri_base != null) try {
                                                                                                    $c08f788f39a3ce67$var$assertSecureEndpointSpecificURI(wallet_uri_base);
                                                                                                } catch (e) {
                                                                                                    reject(e);
                                                                                                    return;
                                                                                                }
                                                                                                break;
                                                                                            }
                                                                                    }
                                                                                    resolve(result);
                                                                                },
                                                                                reject: reject
                                                                            };
                                                                        })
                                                                    ];
                                                            }
                                                        });
                                                    });
                                                });
                                                _state.label = 11;
                                            case 11:
                                                _state.trys.push([
                                                    11,
                                                    13,
                                                    14,
                                                    15
                                                ]);
                                                return [
                                                    4,
                                                    callback(wallet)
                                                ];
                                            case 12:
                                                resolve.apply(void 0, [
                                                    _state.sent()
                                                ]);
                                                return [
                                                    3,
                                                    15
                                                ];
                                            case 13:
                                                e1 = _state.sent();
                                                reject(e1);
                                                return [
                                                    3,
                                                    15
                                                ];
                                            case 14:
                                                disposeSocket();
                                                socket.close();
                                                return [
                                                    7
                                                ];
                                            case 15:
                                                return [
                                                    3,
                                                    16
                                                ];
                                            case 16:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            };
                            var disposeSocket;
                            var retryWaitTimeoutId;
                            var attemptSocketConnection = function() {
                                if (disposeSocket) disposeSocket();
                                state = {
                                    __type: "connecting",
                                    associationKeypair: associationKeypair
                                };
                                if (connectionStartTime === undefined) connectionStartTime = Date.now();
                                socket = new WebSocket(websocketURL, [
                                    $c08f788f39a3ce67$var$WEBSOCKET_PROTOCOL
                                ]);
                                socket.addEventListener("open", handleOpen);
                                socket.addEventListener("close", handleClose);
                                socket.addEventListener("error", handleError);
                                socket.addEventListener("message", handleMessage);
                                disposeSocket = function() {
                                    window.clearTimeout(retryWaitTimeoutId);
                                    socket.removeEventListener("open", handleOpen);
                                    socket.removeEventListener("close", handleClose);
                                    socket.removeEventListener("error", handleError);
                                    socket.removeEventListener("message", handleMessage);
                                };
                            };
                            attemptSocketConnection();
                        })
                    ];
            }
        });
    });
}



var $aC4HZ = parcelRequire("aC4HZ");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $290f2aa058aa6216$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $290f2aa058aa6216$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $290f2aa058aa6216$var$fromUint8Array(byteArray) {
    var _String_fromCharCode;
    return window.btoa((_String_fromCharCode = String.fromCharCode).call.apply(_String_fromCharCode, [
        null
    ].concat((0, $c6Xmf._)(byteArray))));
}
function $290f2aa058aa6216$var$toUint8Array(base64EncodedByteArray) {
    return new Uint8Array(window.atob(base64EncodedByteArray).split("").map(function(c) {
        return c.charCodeAt(0);
    }));
}
function $290f2aa058aa6216$var$getPayloadFromTransaction(transaction) {
    var serializedTransaction = "version" in transaction ? transaction.serialize() : transaction.serialize({
        requireAllSignatures: false,
        verifySignatures: false
    });
    var payload = $290f2aa058aa6216$var$fromUint8Array(serializedTransaction);
    return payload;
}
function $290f2aa058aa6216$var$getTransactionFromWireMessage(byteArray) {
    var numSignatures = byteArray[0];
    var messageOffset = numSignatures * (0, $69N5M.SIGNATURE_LENGTH_IN_BYTES) + 1;
    var version = (0, $69N5M.VersionedMessage).deserializeMessageVersion(byteArray.slice(messageOffset, byteArray.length));
    if (version === "legacy") return (0, $69N5M.Transaction).from(byteArray);
    else return (0, $69N5M.VersionedTransaction).deserialize(byteArray);
}
function $290f2aa058aa6216$export$dac1bad6146b2469(callback, config) {
    return $290f2aa058aa6216$var$__awaiter(this, void 0, void 0, function() {
        var augmentedCallback;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    augmentedCallback = function(wallet) {
                        var augmentedAPI = new Proxy({}, {
                            get: function(target, p) {
                                if (target[p] == null) switch(p){
                                    case "signAndSendTransactions":
                                        target[p] = function(_a) {
                                            var minContextSlot = _a.minContextSlot, commitment = _a.commitment, skipPreflight = _a.skipPreflight, maxRetries = _a.maxRetries, waitForCommitmentToSendNextTransaction = _a.waitForCommitmentToSendNextTransaction, transactions = _a.transactions, rest = $290f2aa058aa6216$var$__rest(_a, [
                                                "minContextSlot",
                                                "commitment",
                                                "skipPreflight",
                                                "maxRetries",
                                                "waitForCommitmentToSendNextTransaction",
                                                "transactions"
                                            ]);
                                            return $290f2aa058aa6216$var$__awaiter(this, void 0, void 0, function() {
                                                var payloads, options, _ref, base64EncodedSignatures, signatures;
                                                return (0, $eha6O.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            payloads = transactions.map($290f2aa058aa6216$var$getPayloadFromTransaction);
                                                            options = {
                                                                min_context_slot: minContextSlot,
                                                                commitment: commitment,
                                                                skip_preflight: skipPreflight,
                                                                max_retries: maxRetries,
                                                                wait_for_commitment_to_send_next_transaction: waitForCommitmentToSendNextTransaction
                                                            };
                                                            return [
                                                                4,
                                                                wallet.signAndSendTransactions(Object.assign(Object.assign(Object.assign({}, rest), Object.values(options).some(function(element) {
                                                                    return element != null;
                                                                }) ? {
                                                                    options: options
                                                                } : null), {
                                                                    payloads: payloads
                                                                }))
                                                            ];
                                                        case 1:
                                                            _ref = _state.sent(), base64EncodedSignatures = _ref.signatures;
                                                            signatures = base64EncodedSignatures.map($290f2aa058aa6216$var$toUint8Array).map((0, (/*@__PURE__*/$parcel$interopDefault($aC4HZ))).encode);
                                                            return [
                                                                2,
                                                                signatures
                                                            ];
                                                    }
                                                });
                                            });
                                        };
                                        break;
                                    case "signMessages":
                                        target[p] = function(_a) {
                                            var payloads = _a.payloads, rest = $290f2aa058aa6216$var$__rest(_a, [
                                                "payloads"
                                            ]);
                                            return $290f2aa058aa6216$var$__awaiter(this, void 0, void 0, function() {
                                                var base64EncodedPayloads, _ref, base64EncodedSignedMessages, signedMessages;
                                                return (0, $eha6O.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            base64EncodedPayloads = payloads.map($290f2aa058aa6216$var$fromUint8Array);
                                                            return [
                                                                4,
                                                                wallet.signMessages(Object.assign(Object.assign({}, rest), {
                                                                    payloads: base64EncodedPayloads
                                                                }))
                                                            ];
                                                        case 1:
                                                            _ref = _state.sent(), base64EncodedSignedMessages = _ref.signed_payloads;
                                                            signedMessages = base64EncodedSignedMessages.map($290f2aa058aa6216$var$toUint8Array);
                                                            return [
                                                                2,
                                                                signedMessages
                                                            ];
                                                    }
                                                });
                                            });
                                        };
                                        break;
                                    case "signTransactions":
                                        target[p] = function(_a) {
                                            var transactions = _a.transactions, rest = $290f2aa058aa6216$var$__rest(_a, [
                                                "transactions"
                                            ]);
                                            return $290f2aa058aa6216$var$__awaiter(this, void 0, void 0, function() {
                                                var payloads, _ref, base64EncodedCompiledTransactions, compiledTransactions, signedTransactions;
                                                return (0, $eha6O.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            payloads = transactions.map($290f2aa058aa6216$var$getPayloadFromTransaction);
                                                            return [
                                                                4,
                                                                wallet.signTransactions(Object.assign(Object.assign({}, rest), {
                                                                    payloads: payloads
                                                                }))
                                                            ];
                                                        case 1:
                                                            _ref = _state.sent(), base64EncodedCompiledTransactions = _ref.signed_payloads;
                                                            compiledTransactions = base64EncodedCompiledTransactions.map($290f2aa058aa6216$var$toUint8Array);
                                                            signedTransactions = compiledTransactions.map($290f2aa058aa6216$var$getTransactionFromWireMessage);
                                                            return [
                                                                2,
                                                                signedTransactions
                                                            ];
                                                    }
                                                });
                                            });
                                        };
                                        break;
                                    default:
                                        target[p] = wallet[p];
                                        break;
                                }
                                return target[p];
                            },
                            defineProperty: function() {
                                return false;
                            },
                            deleteProperty: function() {
                                return false;
                            }
                        });
                        return callback(augmentedAPI);
                    };
                    return [
                        4,
                        (0, $c08f788f39a3ce67$export$dac1bad6146b2469)(augmentedCallback, config)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $5f92ecfd71990f96$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5f92ecfd71990f96$var$toUint8Array(base64EncodedByteArray) {
    return new Uint8Array(window.atob(base64EncodedByteArray).split("").map(function(c) {
        return c.charCodeAt(0);
    }));
}
function $5f92ecfd71990f96$var$getIsSupported() {
    return typeof window !== "undefined" && window.isSecureContext && typeof document !== "undefined" && /android/i.test(navigator.userAgent);
}
var $5f92ecfd71990f96$export$f1265e9082f346f1 = "Mobile Wallet Adapter";
var $5f92ecfd71990f96$var$SIGNATURE_LENGTH_IN_BYTES = 64;
function $5f92ecfd71990f96$var$getPublicKeyFromAddress(address) {
    var publicKeyByteArray = $5f92ecfd71990f96$var$toUint8Array(address);
    return new (0, $69N5M.PublicKey)(publicKeyByteArray);
}
function $5f92ecfd71990f96$var$isVersionedTransaction(transaction) {
    return "version" in transaction;
}
var $5f92ecfd71990f96$export$dec251788b2f5a84 = /*#__PURE__*/ function(BaseSignInMessageSignerWalletAdapter) {
    "use strict";
    (0, $dcsZi._)(SolanaMobileWalletAdapter, BaseSignInMessageSignerWalletAdapter);
    var _super = (0, $ohfOJ._)(SolanaMobileWalletAdapter);
    function SolanaMobileWalletAdapter(config) {
        (0, $4GJKx._)(this, SolanaMobileWalletAdapter);
        var _this;
        var _a;
        _this = _super.call(this);
        _this.supportedTransactionVersions = new Set(// FIXME(#244): We can't actually know what versions are supported until we know which wallet we're talking to.
        [
            "legacy",
            0
        ]);
        _this.name = $5f92ecfd71990f96$export$f1265e9082f346f1;
        _this.url = "https://solanamobile.com/wallets";
        _this.icon = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjI4IiB3aWR0aD0iMjgiIHZpZXdCb3g9Ii0zIDAgMjggMjgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iI0RDQjhGRiI+PHBhdGggZD0iTTE3LjQgMTcuNEgxNXYyLjRoMi40di0yLjRabTEuMi05LjZoLTIuNHYyLjRoMi40VjcuOFoiLz48cGF0aCBkPSJNMjEuNiAzVjBoLTIuNHYzaC0zLjZWMGgtMi40djNoLTIuNHY2LjZINC41YTIuMSAyLjEgMCAxIDEgMC00LjJoMi43VjNINC41QTQuNSA0LjUgMCAwIDAgMCA3LjVWMjRoMjEuNnYtNi42aC0yLjR2NC4ySDIuNFYxMS41Yy41LjMgMS4yLjQgMS44LjVoNy41QTYuNiA2LjYgMCAwIDAgMjQgOVYzaC0yLjRabTAgNS43YTQuMiA0LjIgMCAxIDEtOC40IDBWNS40aDguNHYzLjNaIi8+PC9nPjwvc3ZnPg==";
        _this._connecting = false;
        /**
         * Every time the connection is recycled in some way (eg. `disconnect()` is called)
         * increment this and use it to make sure that `transact` calls from the previous
         * 'generation' don't continue to do work and throw exceptions.
         */ _this._connectionGeneration = 0;
        _this._readyState = $5f92ecfd71990f96$var$getIsSupported() ? (0, $8c7df08073723177$export$2a7b8071105d05b6).Loadable : (0, $8c7df08073723177$export$2a7b8071105d05b6).Unsupported;
        _this._authorizationResultCache = config.authorizationResultCache;
        _this._addressSelector = config.addressSelector;
        _this._appIdentity = config.appIdentity;
        _this._chain = (_a = config.chain) !== null && _a !== void 0 ? _a : config.cluster;
        _this._onWalletNotFound = config.onWalletNotFound;
        if (_this._readyState !== (0, $8c7df08073723177$export$2a7b8071105d05b6).Unsupported) _this._authorizationResultCache.get().then(function(authorizationResult) {
            if (authorizationResult) // Having a prior authorization result is, right now, the best
            // indication that a mobile wallet is installed. There is no API
            // we can use to test for whether the association URI is supported.
            _this.declareWalletAsInstalled();
        });
        return _this;
    }
    (0, $1wc17._)(SolanaMobileWalletAdapter, [
        {
            key: "publicKey",
            get: function get() {
                if (this._publicKey == null && this._selectedAddress != null) try {
                    this._publicKey = $5f92ecfd71990f96$var$getPublicKeyFromAddress(this._selectedAddress);
                } catch (e) {
                    throw new (0, $3f5d780e6d40bbac$export$735bef3bfb0f2c86)(e instanceof Error && (e === null || e === void 0 ? void 0 : e.message) || "Unknown error", e);
                }
                return this._publicKey ? this._publicKey : null;
            }
        },
        {
            key: "connected",
            get: function get() {
                return !!this._authorizationResult;
            }
        },
        {
            key: "connecting",
            get: function get() {
                return this._connecting;
            }
        },
        {
            key: "readyState",
            get: function get() {
                return this._readyState;
            }
        },
        {
            key: "declareWalletAsInstalled",
            value: function declareWalletAsInstalled() {
                if (this._readyState !== (0, $8c7df08073723177$export$2a7b8071105d05b6).Installed) this.emit("readyStateChange", this._readyState = (0, $8c7df08073723177$export$2a7b8071105d05b6).Installed);
            }
        },
        {
            key: "runWithGuard",
            value: function runWithGuard(callback) {
                return $5f92ecfd71990f96$var$__awaiter(this, void 0, void 0, function() {
                    var e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    callback()
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                e = _state.sent();
                                this.emit("error", e);
                                throw e;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            /** @deprecated Use `autoConnect()` instead. */ key: "autoConnect_DO_NOT_USE_OR_YOU_WILL_BE_FIRED",
            value: function autoConnect_DO_NOT_USE_OR_YOU_WILL_BE_FIRED() {
                return $5f92ecfd71990f96$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.autoConnect()
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "autoConnect",
            value: function autoConnect() {
                return $5f92ecfd71990f96$var$__awaiter(this, void 0, void 0, function() {
                    var _this;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                if (this.connecting || this.connected) return [
                                    2
                                ];
                                return [
                                    4,
                                    this.runWithGuard(function() {
                                        return $5f92ecfd71990f96$var$__awaiter(_this, void 0, void 0, function() {
                                            var cachedAuthorizationResult, e;
                                            return (0, $eha6O.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        if (this._readyState !== (0, $8c7df08073723177$export$2a7b8071105d05b6).Installed && this._readyState !== (0, $8c7df08073723177$export$2a7b8071105d05b6).Loadable) throw new (0, $3f5d780e6d40bbac$export$d65db264eda99cd7)();
                                                        this._connecting = true;
                                                        _state.label = 1;
                                                    case 1:
                                                        _state.trys.push([
                                                            1,
                                                            3,
                                                            4,
                                                            5
                                                        ]);
                                                        return [
                                                            4,
                                                            this._authorizationResultCache.get()
                                                        ];
                                                    case 2:
                                                        cachedAuthorizationResult = _state.sent();
                                                        if (cachedAuthorizationResult) // TODO: Evaluate whether there's any threat to not `awaiting` this expression
                                                        this.handleAuthorizationResult(cachedAuthorizationResult);
                                                        return [
                                                            3,
                                                            5
                                                        ];
                                                    case 3:
                                                        e = _state.sent();
                                                        throw new (0, $3f5d780e6d40bbac$export$38f21f1c810261c7)(e instanceof Error && e.message || "Unknown error", e);
                                                    case 4:
                                                        this._connecting = false;
                                                        return [
                                                            7
                                                        ];
                                                    case 5:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "connect",
            value: function connect() {
                return $5f92ecfd71990f96$var$__awaiter(this, void 0, void 0, function() {
                    var _this;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                if (this.connecting || this.connected) return [
                                    2
                                ];
                                return [
                                    4,
                                    this.runWithGuard(function() {
                                        return $5f92ecfd71990f96$var$__awaiter(_this, void 0, void 0, function() {
                                            var e;
                                            return (0, $eha6O.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        if (this._readyState !== (0, $8c7df08073723177$export$2a7b8071105d05b6).Installed && this._readyState !== (0, $8c7df08073723177$export$2a7b8071105d05b6).Loadable) throw new (0, $3f5d780e6d40bbac$export$d65db264eda99cd7)();
                                                        this._connecting = true;
                                                        _state.label = 1;
                                                    case 1:
                                                        _state.trys.push([
                                                            1,
                                                            3,
                                                            4,
                                                            5
                                                        ]);
                                                        return [
                                                            4,
                                                            this.performAuthorization()
                                                        ];
                                                    case 2:
                                                        _state.sent();
                                                        return [
                                                            3,
                                                            5
                                                        ];
                                                    case 3:
                                                        e = _state.sent();
                                                        throw new (0, $3f5d780e6d40bbac$export$38f21f1c810261c7)(e instanceof Error && e.message || "Unknown error", e);
                                                    case 4:
                                                        this._connecting = false;
                                                        return [
                                                            7
                                                        ];
                                                    case 5:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "performAuthorization",
            value: function performAuthorization(signInPayload) {
                return $5f92ecfd71990f96$var$__awaiter(this, void 0, void 0, function() {
                    var _this, cachedAuthorizationResult, e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    this._authorizationResultCache.get()
                                ];
                            case 2:
                                cachedAuthorizationResult = _state.sent();
                                if (cachedAuthorizationResult) {
                                    // TODO: Evaluate whether there's any threat to not `awaiting` this expression
                                    this.handleAuthorizationResult(cachedAuthorizationResult);
                                    return [
                                        2,
                                        cachedAuthorizationResult
                                    ];
                                }
                                return [
                                    4,
                                    this.transact(function(wallet) {
                                        return $5f92ecfd71990f96$var$__awaiter(_this, void 0, void 0, function() {
                                            var authorizationResult;
                                            return (0, $eha6O.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            wallet.authorize({
                                                                chain: this._chain,
                                                                identity: this._appIdentity,
                                                                sign_in_payload: signInPayload
                                                            })
                                                        ];
                                                    case 1:
                                                        authorizationResult = _state.sent();
                                                        // TODO: Evaluate whether there's any threat to not `awaiting` this expression
                                                        Promise.all([
                                                            this._authorizationResultCache.set(authorizationResult),
                                                            this.handleAuthorizationResult(authorizationResult)
                                                        ]);
                                                        return [
                                                            2,
                                                            authorizationResult
                                                        ];
                                                }
                                            });
                                        });
                                    })
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 4:
                                e = _state.sent();
                                throw new (0, $3f5d780e6d40bbac$export$38f21f1c810261c7)(e instanceof Error && e.message || "Unknown error", e);
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "handleAuthorizationResult",
            value: function handleAuthorizationResult(authorizationResult) {
                var _a;
                return $5f92ecfd71990f96$var$__awaiter(this, void 0, void 0, function() {
                    var didPublicKeysChange, nextSelectedAddress;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                didPublicKeysChange = // Case 1: We started from having no authorization.
                                this._authorizationResult == null || // Case 2: The number of authorized accounts changed.
                                ((_a = this._authorizationResult) === null || _a === void 0 ? void 0 : _a.accounts.length) !== authorizationResult.accounts.length || // Case 3: The new list of addresses isn't exactly the same as the old list, in the same order.
                                this._authorizationResult.accounts.some(function(account, ii) {
                                    return account.address !== authorizationResult.accounts[ii].address;
                                });
                                this._authorizationResult = authorizationResult;
                                this.declareWalletAsInstalled();
                                if (!didPublicKeysChange) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this._addressSelector.select(authorizationResult.accounts.map(function(param) {
                                        var address = param.address;
                                        return address;
                                    }))
                                ];
                            case 1:
                                nextSelectedAddress = _state.sent();
                                if (nextSelectedAddress !== this._selectedAddress) {
                                    this._selectedAddress = nextSelectedAddress;
                                    delete this._publicKey;
                                    this.emit("connect", // Having just set `this._selectedAddress`, `this.publicKey` is definitely non-null
                                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                    this.publicKey);
                                }
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "performReauthorization",
            value: function performReauthorization(wallet, authToken) {
                return $5f92ecfd71990f96$var$__awaiter(this, void 0, void 0, function() {
                    var authorizationResult, e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    wallet.authorize({
                                        auth_token: authToken,
                                        identity: this._appIdentity
                                    })
                                ];
                            case 1:
                                authorizationResult = _state.sent();
                                // TODO: Evaluate whether there's any threat to not `awaiting` this expression
                                Promise.all([
                                    this._authorizationResultCache.set(authorizationResult),
                                    this.handleAuthorizationResult(authorizationResult)
                                ]);
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                e = _state.sent();
                                this.disconnect();
                                throw new (0, $3f5d780e6d40bbac$export$bf7028c52ebda81e)(e instanceof Error && (e === null || e === void 0 ? void 0 : e.message) || "Unknown error", e);
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                return $5f92ecfd71990f96$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        this._authorizationResultCache.clear(); // TODO: Evaluate whether there's any threat to not `awaiting` this expression
                        this._connecting = false;
                        this._connectionGeneration++;
                        delete this._authorizationResult;
                        delete this._publicKey;
                        delete this._selectedAddress;
                        this.emit("disconnect");
                        return [
                            2
                        ];
                    });
                });
            }
        },
        {
            key: "transact",
            value: function transact1(callback) {
                var _a;
                return $5f92ecfd71990f96$var$__awaiter(this, void 0, void 0, function() {
                    var walletUriBase, config, currentConnectionGeneration, e;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                walletUriBase = (_a = this._authorizationResult) === null || _a === void 0 ? void 0 : _a.wallet_uri_base;
                                config = walletUriBase ? {
                                    baseUri: walletUriBase
                                } : undefined;
                                currentConnectionGeneration = this._connectionGeneration;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    8
                                ]);
                                return [
                                    4,
                                    (0, $290f2aa058aa6216$export$dac1bad6146b2469)(callback, config)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                e = _state.sent();
                                if (!(this._connectionGeneration !== currentConnectionGeneration)) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    new Promise(function() {})
                                ];
                            case 4:
                                _state.sent(); // Never resolve.
                                _state.label = 5;
                            case 5:
                                if (!(e instanceof Error && e.name === "SolanaMobileWalletAdapterError" && e.code === "ERROR_WALLET_NOT_FOUND")) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    this._onWalletNotFound(this)
                                ];
                            case 6:
                                _state.sent();
                                _state.label = 7;
                            case 7:
                                throw e;
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "assertIsAuthorized",
            value: function assertIsAuthorized() {
                if (!this._authorizationResult || !this._selectedAddress) throw new (0, $3f5d780e6d40bbac$export$313d299817c74896)();
                return {
                    authToken: this._authorizationResult.auth_token,
                    selectedAddress: this._selectedAddress
                };
            }
        },
        {
            key: "performSignTransactions",
            value: function performSignTransactions(transactions) {
                return $5f92ecfd71990f96$var$__awaiter(this, void 0, void 0, function() {
                    var _this, authToken, error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                authToken = this.assertIsAuthorized().authToken;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    this.transact(function(wallet) {
                                        return $5f92ecfd71990f96$var$__awaiter(_this, void 0, void 0, function() {
                                            var signedTransactions;
                                            return (0, $eha6O.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            this.performReauthorization(wallet, authToken)
                                                        ];
                                                    case 1:
                                                        _state.sent();
                                                        return [
                                                            4,
                                                            wallet.signTransactions({
                                                                transactions: transactions
                                                            })
                                                        ];
                                                    case 2:
                                                        signedTransactions = _state.sent();
                                                        return [
                                                            2,
                                                            signedTransactions
                                                        ];
                                                }
                                            });
                                        });
                                    })
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                error = _state.sent();
                                throw new (0, $3f5d780e6d40bbac$export$96f177062fdd8180)(error === null || error === void 0 ? void 0 : error.message, error);
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "sendTransaction",
            value: function sendTransaction(transaction, connection, options) {
                return $5f92ecfd71990f96$var$__awaiter(this, void 0, void 0, function() {
                    var _this;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this.runWithGuard(function() {
                                        return $5f92ecfd71990f96$var$__awaiter(_this, void 0, void 0, function() {
                                            var _this, authToken, minContextSlot, error;
                                            return (0, $eha6O.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        _this = this;
                                                        authToken = this.assertIsAuthorized().authToken;
                                                        minContextSlot = options === null || options === void 0 ? void 0 : options.minContextSlot;
                                                        _state.label = 1;
                                                    case 1:
                                                        _state.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4,
                                                            this.transact(function(wallet) {
                                                                return $5f92ecfd71990f96$var$__awaiter(_this, void 0, void 0, function() {
                                                                    var _this, _ref, capabilities, _1, _2, signatures, _ref1, signedTransaction, serializedTransaction;
                                                                    function getTargetCommitment() {
                                                                        var targetCommitment;
                                                                        switch(connection.commitment){
                                                                            case "confirmed":
                                                                            case "finalized":
                                                                            case "processed":
                                                                                targetCommitment = connection.commitment;
                                                                                break;
                                                                            default:
                                                                                targetCommitment = "finalized";
                                                                        }
                                                                        var targetPreflightCommitment;
                                                                        switch(options === null || options === void 0 ? void 0 : options.preflightCommitment){
                                                                            case "confirmed":
                                                                            case "finalized":
                                                                            case "processed":
                                                                                targetPreflightCommitment = options.preflightCommitment;
                                                                                break;
                                                                            case undefined:
                                                                                targetPreflightCommitment = targetCommitment;
                                                                                break;
                                                                            default:
                                                                                targetPreflightCommitment = "finalized";
                                                                        }
                                                                        var preflightCommitmentScore = targetPreflightCommitment === "finalized" ? 2 : targetPreflightCommitment === "confirmed" ? 1 : 0;
                                                                        var targetCommitmentScore = targetCommitment === "finalized" ? 2 : targetCommitment === "confirmed" ? 1 : 0;
                                                                        return preflightCommitmentScore < targetCommitmentScore ? targetPreflightCommitment : targetCommitment;
                                                                    }
                                                                    return (0, $eha6O.__generator)(this, function(_state) {
                                                                        switch(_state.label){
                                                                            case 0:
                                                                                _this = this;
                                                                                return [
                                                                                    4,
                                                                                    Promise.all([
                                                                                        wallet.getCapabilities(),
                                                                                        this.performReauthorization(wallet, authToken),
                                                                                        $5f92ecfd71990f96$var$isVersionedTransaction(transaction) ? null : /**
                                   * Unlike versioned transactions, legacy `Transaction` objects
                                   * may not have an associated `feePayer` or `recentBlockhash`.
                                   * This code exists to patch them up in case they are missing.
                                   */ function() {
                                                                                            return $5f92ecfd71990f96$var$__awaiter(_this, void 0, void 0, function() {
                                                                                                var _a, blockhash;
                                                                                                return (0, $eha6O.__generator)(this, function(_state) {
                                                                                                    switch(_state.label){
                                                                                                        case 0:
                                                                                                            transaction.feePayer || (transaction.feePayer = (_a = this.publicKey) !== null && _a !== void 0 ? _a : undefined);
                                                                                                            if (!(transaction.recentBlockhash == null)) return [
                                                                                                                3,
                                                                                                                2
                                                                                                            ];
                                                                                                            return [
                                                                                                                4,
                                                                                                                connection.getLatestBlockhash({
                                                                                                                    commitment: getTargetCommitment()
                                                                                                                })
                                                                                                            ];
                                                                                                        case 1:
                                                                                                            blockhash = _state.sent().blockhash;
                                                                                                            transaction.recentBlockhash = blockhash;
                                                                                                            _state.label = 2;
                                                                                                        case 2:
                                                                                                            return [
                                                                                                                2
                                                                                                            ];
                                                                                                    }
                                                                                                });
                                                                                            });
                                                                                        }()
                                                                                    ])
                                                                                ];
                                                                            case 1:
                                                                                _ref = (0, $cv9Rk._).apply(void 0, [
                                                                                    _state.sent(),
                                                                                    3
                                                                                ]), capabilities = _ref[0], _1 = _ref[1], _2 = _ref[2];
                                                                                if (!capabilities.supports_sign_and_send_transactions) return [
                                                                                    3,
                                                                                    3
                                                                                ];
                                                                                return [
                                                                                    4,
                                                                                    wallet.signAndSendTransactions({
                                                                                        minContextSlot: minContextSlot,
                                                                                        transactions: [
                                                                                            transaction
                                                                                        ]
                                                                                    })
                                                                                ];
                                                                            case 2:
                                                                                signatures = _state.sent();
                                                                                return [
                                                                                    2,
                                                                                    signatures[0]
                                                                                ];
                                                                            case 3:
                                                                                return [
                                                                                    4,
                                                                                    wallet.signTransactions({
                                                                                        transactions: [
                                                                                            transaction
                                                                                        ]
                                                                                    })
                                                                                ];
                                                                            case 4:
                                                                                _ref1 = (0, $cv9Rk._).apply(void 0, [
                                                                                    _state.sent(),
                                                                                    1
                                                                                ]), signedTransaction = _ref1[0];
                                                                                if (!$5f92ecfd71990f96$var$isVersionedTransaction(signedTransaction)) return [
                                                                                    3,
                                                                                    6
                                                                                ];
                                                                                return [
                                                                                    4,
                                                                                    connection.sendTransaction(signedTransaction)
                                                                                ];
                                                                            case 5:
                                                                                return [
                                                                                    2,
                                                                                    _state.sent()
                                                                                ];
                                                                            case 6:
                                                                                serializedTransaction = signedTransaction.serialize();
                                                                                return [
                                                                                    4,
                                                                                    connection.sendRawTransaction(serializedTransaction, Object.assign(Object.assign({}, options), {
                                                                                        preflightCommitment: getTargetCommitment()
                                                                                    }))
                                                                                ];
                                                                            case 7:
                                                                                return [
                                                                                    2,
                                                                                    _state.sent()
                                                                                ];
                                                                            case 8:
                                                                                return [
                                                                                    2
                                                                                ];
                                                                        }
                                                                    });
                                                                });
                                                            })
                                                        ];
                                                    case 2:
                                                        return [
                                                            2,
                                                            _state.sent()
                                                        ];
                                                    case 3:
                                                        error = _state.sent();
                                                        throw new (0, $3f5d780e6d40bbac$export$769332ac3f90f46c)(error === null || error === void 0 ? void 0 : error.message, error);
                                                    case 4:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "signTransaction",
            value: function signTransaction(transaction) {
                return $5f92ecfd71990f96$var$__awaiter(this, void 0, void 0, function() {
                    var _this;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this.runWithGuard(function() {
                                        return $5f92ecfd71990f96$var$__awaiter(_this, void 0, void 0, function() {
                                            var _ref, signedTransaction;
                                            return (0, $eha6O.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            this.performSignTransactions([
                                                                transaction
                                                            ])
                                                        ];
                                                    case 1:
                                                        _ref = (0, $cv9Rk._).apply(void 0, [
                                                            _state.sent(),
                                                            1
                                                        ]), signedTransaction = _ref[0];
                                                        return [
                                                            2,
                                                            signedTransaction
                                                        ];
                                                }
                                            });
                                        });
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "signAllTransactions",
            value: function signAllTransactions(transactions) {
                return $5f92ecfd71990f96$var$__awaiter(this, void 0, void 0, function() {
                    var _this;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this.runWithGuard(function() {
                                        return $5f92ecfd71990f96$var$__awaiter(_this, void 0, void 0, function() {
                                            var signedTransactions;
                                            return (0, $eha6O.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            this.performSignTransactions(transactions)
                                                        ];
                                                    case 1:
                                                        signedTransactions = _state.sent();
                                                        return [
                                                            2,
                                                            signedTransactions
                                                        ];
                                                }
                                            });
                                        });
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "signMessage",
            value: function signMessage(message) {
                return $5f92ecfd71990f96$var$__awaiter(this, void 0, void 0, function() {
                    var _this;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this.runWithGuard(function() {
                                        return $5f92ecfd71990f96$var$__awaiter(_this, void 0, void 0, function() {
                                            var _this, _this_assertIsAuthorized, authToken, selectedAddress, error;
                                            return (0, $eha6O.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        _this = this;
                                                        _this_assertIsAuthorized = this.assertIsAuthorized(), authToken = _this_assertIsAuthorized.authToken, selectedAddress = _this_assertIsAuthorized.selectedAddress;
                                                        _state.label = 1;
                                                    case 1:
                                                        _state.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4,
                                                            this.transact(function(wallet) {
                                                                return $5f92ecfd71990f96$var$__awaiter(_this, void 0, void 0, function() {
                                                                    var _ref, signedMessage, signature;
                                                                    return (0, $eha6O.__generator)(this, function(_state) {
                                                                        switch(_state.label){
                                                                            case 0:
                                                                                return [
                                                                                    4,
                                                                                    this.performReauthorization(wallet, authToken)
                                                                                ];
                                                                            case 1:
                                                                                _state.sent();
                                                                                return [
                                                                                    4,
                                                                                    wallet.signMessages({
                                                                                        addresses: [
                                                                                            selectedAddress
                                                                                        ],
                                                                                        payloads: [
                                                                                            message
                                                                                        ]
                                                                                    })
                                                                                ];
                                                                            case 2:
                                                                                _ref = (0, $cv9Rk._).apply(void 0, [
                                                                                    _state.sent(),
                                                                                    1
                                                                                ]), signedMessage = _ref[0];
                                                                                signature = signedMessage.slice(-$5f92ecfd71990f96$var$SIGNATURE_LENGTH_IN_BYTES);
                                                                                return [
                                                                                    2,
                                                                                    signature
                                                                                ];
                                                                        }
                                                                    });
                                                                });
                                                            })
                                                        ];
                                                    case 2:
                                                        return [
                                                            2,
                                                            _state.sent()
                                                        ];
                                                    case 3:
                                                        error = _state.sent();
                                                        throw new (0, $3f5d780e6d40bbac$export$2622c1721bbd4b17)(error === null || error === void 0 ? void 0 : error.message, error);
                                                    case 4:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "signIn",
            value: function signIn(input) {
                return $5f92ecfd71990f96$var$__awaiter(this, void 0, void 0, function() {
                    var _this;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this.runWithGuard(function() {
                                        return $5f92ecfd71990f96$var$__awaiter(_this, void 0, void 0, function() {
                                            var _a, _b, authorizationResult, signedInAddress, signedInAccount, e;
                                            return (0, $eha6O.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        if (this._readyState !== (0, $8c7df08073723177$export$2a7b8071105d05b6).Installed && this._readyState !== (0, $8c7df08073723177$export$2a7b8071105d05b6).Loadable) throw new (0, $3f5d780e6d40bbac$export$d65db264eda99cd7)();
                                                        this._connecting = true;
                                                        _state.label = 1;
                                                    case 1:
                                                        _state.trys.push([
                                                            1,
                                                            3,
                                                            4,
                                                            5
                                                        ]);
                                                        return [
                                                            4,
                                                            this.performAuthorization(Object.assign(Object.assign({}, input), {
                                                                domain: (_a = input === null || input === void 0 ? void 0 : input.domain) !== null && _a !== void 0 ? _a : window.location.host
                                                            }))
                                                        ];
                                                    case 2:
                                                        authorizationResult = _state.sent();
                                                        if (!authorizationResult.sign_in_result) throw new Error("Sign in failed, no sign in result returned by wallet");
                                                        signedInAddress = authorizationResult.sign_in_result.address;
                                                        signedInAccount = Object.assign(Object.assign({}, (_b = authorizationResult.accounts.find(function(acc) {
                                                            return acc.address == signedInAddress;
                                                        })) !== null && _b !== void 0 ? _b : {
                                                            address: signedInAddress
                                                        }), {
                                                            publicKey: $5f92ecfd71990f96$var$toUint8Array(signedInAddress)
                                                        });
                                                        return [
                                                            2,
                                                            {
                                                                account: signedInAccount,
                                                                signedMessage: $5f92ecfd71990f96$var$toUint8Array(authorizationResult.sign_in_result.signed_message),
                                                                signature: $5f92ecfd71990f96$var$toUint8Array(authorizationResult.sign_in_result.signature)
                                                            }
                                                        ];
                                                    case 3:
                                                        e = _state.sent();
                                                        throw new (0, $3f5d780e6d40bbac$export$38f21f1c810261c7)(e instanceof Error && e.message || "Unknown error", e);
                                                    case 4:
                                                        this._connecting = false;
                                                        return [
                                                            7
                                                        ];
                                                    case 5:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return SolanaMobileWalletAdapter;
}((0, $d1e3c3dc9d32b5d7$export$9779f871ffdb3d87));
function $5f92ecfd71990f96$export$a299fb0acc11345b() {
    return {
        select: function(addresses) {
            return $5f92ecfd71990f96$var$__awaiter(this, void 0, void 0, function() {
                return (0, $eha6O.__generator)(this, function(_state) {
                    return [
                        2,
                        addresses[0]
                    ];
                });
            });
        }
    };
}
var $5f92ecfd71990f96$var$CACHE_KEY = "SolanaMobileWalletAdapterDefaultAuthorizationCache";
function $5f92ecfd71990f96$export$4a0b597891770806() {
    var storage;
    try {
        storage = window.localStorage;
    // eslint-disable-next-line no-empty
    } catch (_a) {}
    return {
        clear: function() {
            return $5f92ecfd71990f96$var$__awaiter(this, void 0, void 0, function() {
                return (0, $eha6O.__generator)(this, function(_state) {
                    if (!storage) return [
                        2
                    ];
                    try {
                        storage.removeItem($5f92ecfd71990f96$var$CACHE_KEY);
                    // eslint-disable-next-line no-empty
                    } catch (_a) {}
                    return [
                        2
                    ];
                });
            });
        },
        get: function() {
            return $5f92ecfd71990f96$var$__awaiter(this, void 0, void 0, function() {
                return (0, $eha6O.__generator)(this, function(_state) {
                    if (!storage) return [
                        2
                    ];
                    try {
                        return [
                            2,
                            JSON.parse(storage.getItem($5f92ecfd71990f96$var$CACHE_KEY)) || undefined
                        ];
                    // eslint-disable-next-line no-empty
                    } catch (_a) {}
                    return [
                        2
                    ];
                });
            });
        },
        set: function(authorizationResult) {
            return $5f92ecfd71990f96$var$__awaiter(this, void 0, void 0, function() {
                return (0, $eha6O.__generator)(this, function(_state) {
                    if (!storage) return [
                        2
                    ];
                    try {
                        storage.setItem($5f92ecfd71990f96$var$CACHE_KEY, JSON.stringify(authorizationResult));
                    // eslint-disable-next-line no-empty
                    } catch (_a) {}
                    return [
                        2
                    ];
                });
            });
        }
    };
}
function $5f92ecfd71990f96$var$defaultWalletNotFoundHandler(mobileWalletAdapter) {
    return $5f92ecfd71990f96$var$__awaiter(this, void 0, void 0, function() {
        return (0, $eha6O.__generator)(this, function(_state) {
            if (typeof window !== "undefined") window.location.assign(mobileWalletAdapter.url);
            return [
                2
            ];
        });
    });
}
function $5f92ecfd71990f96$export$e8b9e70cdf783b70() {
    return $5f92ecfd71990f96$var$defaultWalletNotFoundHandler;
}



var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $l4Sju = parcelRequire("l4Sju");
var $e8TeL = parcelRequire("e8TeL");
/** Name of the feature. */ var $93de5c00a84b23a2$export$cc68487eeb93b1d4 = "standard:connect";
var $93de5c00a84b23a2$export$59e6910693f047c2 = $93de5c00a84b23a2$export$cc68487eeb93b1d4;

/** Name of the feature. */ var $5f118803022fbeb8$export$5296443ca9e9fa0f = "standard:events";
var $5f118803022fbeb8$export$ada873a34909da65 = $5f118803022fbeb8$export$5296443ca9e9fa0f;


function $70a95a73aa27a564$export$de6946e7c2c87e9a(wallet) {
    return (0, $93de5c00a84b23a2$export$cc68487eeb93b1d4) in wallet.features && (0, $5f118803022fbeb8$export$5296443ca9e9fa0f) in wallet.features && ((0, $l4Sju.SolanaSignAndSendTransaction) in wallet.features || (0, $e8TeL.SolanaSignTransaction) in wallet.features);
}


var $d0641ee2ad4332f1$export$c5439c91843266e6 = (0, $70a95a73aa27a564$export$de6946e7c2c87e9a);


var $d3H5E = parcelRequire("d3H5E");

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");


var $l4Sju = parcelRequire("l4Sju");
var $e8TeL = parcelRequire("e8TeL");
var $l0pK9 = parcelRequire("l0pK9");/** Name of the feature. */ var $43701ed1e668c6ce$export$8adeab75f48a3607 = "solana:signIn";


/** Solana Mainnet (beta) cluster, e.g. https://api.mainnet-beta.solana.com */ var $38375b70a91e6f68$export$bba9a228295b3963 = "solana:mainnet";
var $38375b70a91e6f68$export$654cc095bd2e650 = "solana:devnet";
var $38375b70a91e6f68$export$76575b7bf4de1f40 = "solana:testnet";
var $38375b70a91e6f68$export$483699a75281444c = "solana:localnet";
var $38375b70a91e6f68$export$d77e7f94b1f6bf7d = [
    $38375b70a91e6f68$export$bba9a228295b3963,
    $38375b70a91e6f68$export$654cc095bd2e650,
    $38375b70a91e6f68$export$76575b7bf4de1f40,
    $38375b70a91e6f68$export$483699a75281444c
];
function $38375b70a91e6f68$export$d8f86f4d3d9fc2b5(chain) {
    return $38375b70a91e6f68$export$d77e7f94b1f6bf7d.includes(chain);
}


var $45fe045c0021ae8d$export$9462d80112b287bf = "https://api.mainnet-beta.solana.com";
var $45fe045c0021ae8d$export$2416cc3545b31c3b = "https://api.devnet.solana.com";
var $45fe045c0021ae8d$export$fe3dc909dfa57ddb = "https://api.testnet.solana.com";
var $45fe045c0021ae8d$export$ec9ed1d68bb4713f = "http://localhost:8899";
function $45fe045c0021ae8d$export$43dcd8213c5a5741(endpoint) {
    if (endpoint.includes($45fe045c0021ae8d$export$9462d80112b287bf)) return 0, $38375b70a91e6f68$export$bba9a228295b3963;
    if (/\bdevnet\b/i.test(endpoint)) return 0, $38375b70a91e6f68$export$654cc095bd2e650;
    if (/\btestnet\b/i.test(endpoint)) return 0, $38375b70a91e6f68$export$76575b7bf4de1f40;
    if (/\blocalhost\b/i.test(endpoint) || /\b127\.0\.0\.1\b/.test(endpoint)) return 0, $38375b70a91e6f68$export$483699a75281444c;
    return 0, $38375b70a91e6f68$export$bba9a228295b3963;
}
function $45fe045c0021ae8d$export$c9b15526ee38efba(chain, endpoint) {
    if (endpoint) return endpoint;
    if (chain === (0, $38375b70a91e6f68$export$bba9a228295b3963)) return $45fe045c0021ae8d$export$9462d80112b287bf;
    if (chain === (0, $38375b70a91e6f68$export$654cc095bd2e650)) return $45fe045c0021ae8d$export$2416cc3545b31c3b;
    if (chain === (0, $38375b70a91e6f68$export$76575b7bf4de1f40)) return $45fe045c0021ae8d$export$fe3dc909dfa57ddb;
    if (chain === (0, $38375b70a91e6f68$export$483699a75281444c)) return $45fe045c0021ae8d$export$ec9ed1d68bb4713f;
    return $45fe045c0021ae8d$export$9462d80112b287bf;
}

/**
 * TODO: docs
 */ function $b5416591b49774f5$export$430b2bce150d42d4(commitment) {
    switch(commitment){
        case "processed":
        case "confirmed":
        case "finalized":
        case undefined:
            return commitment;
        case "recent":
            return "processed";
        case "single":
        case "singleGossip":
            return "confirmed";
        case "max":
        case "root":
            return "finalized";
        default:
            return undefined;
    }
}



var $69N5M = parcelRequire("69N5M");
/** Name of the feature. */ var $884440781fc19407$export$38dbd4bbb9b696e6 = "standard:disconnect";
var $884440781fc19407$export$9e282393ab352bcd = $884440781fc19407$export$38dbd4bbb9b696e6;



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");
var $4257e3421c96b900$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $4257e3421c96b900$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $4257e3421c96b900$var$_ReadonlyWalletAccount_address, $4257e3421c96b900$var$_ReadonlyWalletAccount_publicKey, $4257e3421c96b900$var$_ReadonlyWalletAccount_chains, $4257e3421c96b900$var$_ReadonlyWalletAccount_features, $4257e3421c96b900$var$_ReadonlyWalletAccount_label, $4257e3421c96b900$var$_ReadonlyWalletAccount_icon;
var $4257e3421c96b900$export$c0ac434c7ac96eb0 = /*#__PURE__*/ function _target() {
    "use strict";
    function ReadonlyWalletAccount(account) {
        (0, $4GJKx._)(this, ReadonlyWalletAccount);
        $4257e3421c96b900$var$_ReadonlyWalletAccount_address.set(this, void 0);
        $4257e3421c96b900$var$_ReadonlyWalletAccount_publicKey.set(this, void 0);
        $4257e3421c96b900$var$_ReadonlyWalletAccount_chains.set(this, void 0);
        $4257e3421c96b900$var$_ReadonlyWalletAccount_features.set(this, void 0);
        $4257e3421c96b900$var$_ReadonlyWalletAccount_label.set(this, void 0);
        $4257e3421c96b900$var$_ReadonlyWalletAccount_icon.set(this, void 0);
        if ((this instanceof ReadonlyWalletAccount ? this.constructor : void 0) === ReadonlyWalletAccount) Object.freeze(this);
        $4257e3421c96b900$var$__classPrivateFieldSet(this, $4257e3421c96b900$var$_ReadonlyWalletAccount_address, account.address, "f");
        $4257e3421c96b900$var$__classPrivateFieldSet(this, $4257e3421c96b900$var$_ReadonlyWalletAccount_publicKey, account.publicKey.slice(), "f");
        $4257e3421c96b900$var$__classPrivateFieldSet(this, $4257e3421c96b900$var$_ReadonlyWalletAccount_chains, account.chains.slice(), "f");
        $4257e3421c96b900$var$__classPrivateFieldSet(this, $4257e3421c96b900$var$_ReadonlyWalletAccount_features, account.features.slice(), "f");
        $4257e3421c96b900$var$__classPrivateFieldSet(this, $4257e3421c96b900$var$_ReadonlyWalletAccount_label, account.label, "f");
        $4257e3421c96b900$var$__classPrivateFieldSet(this, $4257e3421c96b900$var$_ReadonlyWalletAccount_icon, account.icon, "f");
    }
    (0, $1wc17._)(ReadonlyWalletAccount, [
        {
            key: "address",
            get: /** Implementation of {@link "@wallet-standard/base".WalletAccount.address | WalletAccount::address} */ function get() {
                return $4257e3421c96b900$var$__classPrivateFieldGet(this, $4257e3421c96b900$var$_ReadonlyWalletAccount_address, "f");
            }
        },
        {
            key: "publicKey",
            get: /** Implementation of {@link "@wallet-standard/base".WalletAccount.publicKey | WalletAccount::publicKey} */ function get() {
                return $4257e3421c96b900$var$__classPrivateFieldGet(this, $4257e3421c96b900$var$_ReadonlyWalletAccount_publicKey, "f").slice();
            }
        },
        {
            key: "chains",
            get: /** Implementation of {@link "@wallet-standard/base".WalletAccount.chains | WalletAccount::chains} */ function get() {
                return $4257e3421c96b900$var$__classPrivateFieldGet(this, $4257e3421c96b900$var$_ReadonlyWalletAccount_chains, "f").slice();
            }
        },
        {
            key: "features",
            get: /** Implementation of {@link "@wallet-standard/base".WalletAccount.features | WalletAccount::features} */ function get() {
                return $4257e3421c96b900$var$__classPrivateFieldGet(this, $4257e3421c96b900$var$_ReadonlyWalletAccount_features, "f").slice();
            }
        },
        {
            key: "label",
            get: /** Implementation of {@link "@wallet-standard/base".WalletAccount.label | WalletAccount::label} */ function get() {
                return $4257e3421c96b900$var$__classPrivateFieldGet(this, $4257e3421c96b900$var$_ReadonlyWalletAccount_label, "f");
            }
        },
        {
            key: "icon",
            get: /** Implementation of {@link "@wallet-standard/base".WalletAccount.icon | WalletAccount::icon} */ function get() {
                return $4257e3421c96b900$var$__classPrivateFieldGet(this, $4257e3421c96b900$var$_ReadonlyWalletAccount_icon, "f");
            }
        }
    ]);
    return ReadonlyWalletAccount;
}();
$4257e3421c96b900$var$_ReadonlyWalletAccount_address = new WeakMap(), $4257e3421c96b900$var$_ReadonlyWalletAccount_publicKey = new WeakMap(), $4257e3421c96b900$var$_ReadonlyWalletAccount_chains = new WeakMap(), $4257e3421c96b900$var$_ReadonlyWalletAccount_features = new WeakMap(), $4257e3421c96b900$var$_ReadonlyWalletAccount_label = new WeakMap(), $4257e3421c96b900$var$_ReadonlyWalletAccount_icon = new WeakMap();
function $4257e3421c96b900$export$234180f8206db11b(a, b) {
    if (a === b) return true;
    var length = a.length;
    if (length !== b.length) return false;
    for(var i = 0; i < length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $4257e3421c96b900$export$c663ab80cce302c5(a, b) {
    return $4257e3421c96b900$export$234180f8206db11b(a, b);
}
function $4257e3421c96b900$export$287dd7971339c972(first) {
    for(var _len = arguments.length, others = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        others[_key - 1] = arguments[_key];
    }
    var length = others.reduce(function(length, bytes) {
        return length + bytes.length;
    }, first.length);
    var bytes = new Uint8Array(length);
    bytes.set(first, 0);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = others[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var other = _step.value;
            bytes.set(other, bytes.length);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return bytes;
}
function $4257e3421c96b900$export$357523c63a2253b9(source) {
    for(var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        keys[_key - 1] = arguments[_key];
    }
    var picked = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            picked[key] = source[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return picked;
}
function $4257e3421c96b900$export$864d727b48066337(callback) {
    try {
        callback();
    } catch (error) {
        console.error(error);
    }
}


var $ca3b22a27c78c8c6$exports = {};

var $1ISpw = parcelRequire("1ISpw");
var $ca3b22a27c78c8c6$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
$ca3b22a27c78c8c6$exports = $1ISpw($ca3b22a27c78c8c6$var$ALPHABET);


var $cdd8644f451074dc$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $cdd8644f451074dc$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $cdd8644f451074dc$var$_StandardWalletAdapter_instances, $cdd8644f451074dc$var$_StandardWalletAdapter_account, $cdd8644f451074dc$var$_StandardWalletAdapter_publicKey, $cdd8644f451074dc$var$_StandardWalletAdapter_connecting, $cdd8644f451074dc$var$_StandardWalletAdapter_disconnecting, $cdd8644f451074dc$var$_StandardWalletAdapter_off, $cdd8644f451074dc$var$_StandardWalletAdapter_supportedTransactionVersions, $cdd8644f451074dc$var$_StandardWalletAdapter_wallet, $cdd8644f451074dc$var$_StandardWalletAdapter_readyState, $cdd8644f451074dc$var$_StandardWalletAdapter_connect, $cdd8644f451074dc$var$_StandardWalletAdapter_connected, $cdd8644f451074dc$var$_StandardWalletAdapter_disconnected, $cdd8644f451074dc$var$_StandardWalletAdapter_reset, $cdd8644f451074dc$var$_StandardWalletAdapter_changed, $cdd8644f451074dc$var$_StandardWalletAdapter_signTransaction, $cdd8644f451074dc$var$_StandardWalletAdapter_signAllTransactions, $cdd8644f451074dc$var$_StandardWalletAdapter_signMessage, $cdd8644f451074dc$var$_StandardWalletAdapter_signIn;
var $cdd8644f451074dc$export$e0949de9e32fe3b2 = /*#__PURE__*/ function(BaseWalletAdapter) {
    "use strict";
    (0, $dcsZi._)(StandardWalletAdapter, BaseWalletAdapter);
    var _super = (0, $ohfOJ._)(StandardWalletAdapter);
    function StandardWalletAdapter(param) {
        var wallet = param.wallet;
        (0, $4GJKx._)(this, StandardWalletAdapter);
        var _this;
        _this = _super.call(this);
        $cdd8644f451074dc$var$_StandardWalletAdapter_instances.add((0, $d3H5E._)(_this));
        $cdd8644f451074dc$var$_StandardWalletAdapter_account.set((0, $d3H5E._)(_this), void 0);
        $cdd8644f451074dc$var$_StandardWalletAdapter_publicKey.set((0, $d3H5E._)(_this), void 0);
        $cdd8644f451074dc$var$_StandardWalletAdapter_connecting.set((0, $d3H5E._)(_this), void 0);
        $cdd8644f451074dc$var$_StandardWalletAdapter_disconnecting.set((0, $d3H5E._)(_this), void 0);
        $cdd8644f451074dc$var$_StandardWalletAdapter_off.set((0, $d3H5E._)(_this), void 0);
        $cdd8644f451074dc$var$_StandardWalletAdapter_supportedTransactionVersions.set((0, $d3H5E._)(_this), void 0);
        $cdd8644f451074dc$var$_StandardWalletAdapter_wallet.set((0, $d3H5E._)(_this), void 0);
        $cdd8644f451074dc$var$_StandardWalletAdapter_readyState.set((0, $d3H5E._)(_this), typeof window === "undefined" || typeof document === "undefined" ? (0, $8c7df08073723177$export$2a7b8071105d05b6).Unsupported : (0, $8c7df08073723177$export$2a7b8071105d05b6).Installed);
        $cdd8644f451074dc$var$_StandardWalletAdapter_changed.set((0, $d3H5E._)(_this), function(properties) {
            // If accounts have changed on the wallet, reflect this on the adapter.
            if ("accounts" in properties) {
                var account = $cdd8644f451074dc$var$__classPrivateFieldGet(_this, $cdd8644f451074dc$var$_StandardWalletAdapter_wallet, "f").accounts[0];
                // If the adapter isn't connected, or is disconnecting, or the first account hasn't changed, do nothing.
                if ($cdd8644f451074dc$var$__classPrivateFieldGet((0, $d3H5E._)(_this), $cdd8644f451074dc$var$_StandardWalletAdapter_account, "f") && !$cdd8644f451074dc$var$__classPrivateFieldGet((0, $d3H5E._)(_this), $cdd8644f451074dc$var$_StandardWalletAdapter_disconnecting, "f") && account !== $cdd8644f451074dc$var$__classPrivateFieldGet((0, $d3H5E._)(_this), $cdd8644f451074dc$var$_StandardWalletAdapter_account, "f")) {
                    // If there's a connected account, connect the adapter. Otherwise, disconnect it.
                    if (account) // Connect the adapter.
                    $cdd8644f451074dc$var$__classPrivateFieldGet(_this, $cdd8644f451074dc$var$_StandardWalletAdapter_instances, "m", $cdd8644f451074dc$var$_StandardWalletAdapter_connected).call((0, $d3H5E._)(_this), account);
                    else {
                        // Emit an error because the wallet spontaneously disconnected.
                        _this.emit("error", new (0, $3f5d780e6d40bbac$export$bf7028c52ebda81e)());
                        // Disconnect the adapter.
                        $cdd8644f451074dc$var$__classPrivateFieldGet(_this, $cdd8644f451074dc$var$_StandardWalletAdapter_instances, "m", $cdd8644f451074dc$var$_StandardWalletAdapter_disconnected).call((0, $d3H5E._)(_this));
                    }
                }
            }
            // After reflecting account changes, if features have changed on the wallet, reflect this on the adapter.
            if ("features" in properties) $cdd8644f451074dc$var$__classPrivateFieldGet(_this, $cdd8644f451074dc$var$_StandardWalletAdapter_instances, "m", $cdd8644f451074dc$var$_StandardWalletAdapter_reset).call((0, $d3H5E._)(_this));
        });
        $cdd8644f451074dc$var$__classPrivateFieldSet((0, $d3H5E._)(_this), $cdd8644f451074dc$var$_StandardWalletAdapter_wallet, wallet, "f");
        $cdd8644f451074dc$var$__classPrivateFieldSet((0, $d3H5E._)(_this), $cdd8644f451074dc$var$_StandardWalletAdapter_account, null, "f");
        $cdd8644f451074dc$var$__classPrivateFieldSet((0, $d3H5E._)(_this), $cdd8644f451074dc$var$_StandardWalletAdapter_publicKey, null, "f");
        $cdd8644f451074dc$var$__classPrivateFieldSet((0, $d3H5E._)(_this), $cdd8644f451074dc$var$_StandardWalletAdapter_connecting, false, "f");
        $cdd8644f451074dc$var$__classPrivateFieldSet((0, $d3H5E._)(_this), $cdd8644f451074dc$var$_StandardWalletAdapter_disconnecting, false, "f");
        $cdd8644f451074dc$var$__classPrivateFieldSet((0, $d3H5E._)(_this), $cdd8644f451074dc$var$_StandardWalletAdapter_off, $cdd8644f451074dc$var$__classPrivateFieldGet(_this, $cdd8644f451074dc$var$_StandardWalletAdapter_wallet, "f").features[0, $5f118803022fbeb8$export$5296443ca9e9fa0f].on("change", $cdd8644f451074dc$var$__classPrivateFieldGet((0, $d3H5E._)(_this), $cdd8644f451074dc$var$_StandardWalletAdapter_changed, "f")), "f");
        $cdd8644f451074dc$var$__classPrivateFieldGet(_this, $cdd8644f451074dc$var$_StandardWalletAdapter_instances, "m", $cdd8644f451074dc$var$_StandardWalletAdapter_reset).call((0, $d3H5E._)(_this));
        return _this;
    }
    (0, $1wc17._)(StandardWalletAdapter, [
        {
            key: "name",
            get: function get() {
                return $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_wallet, "f").name;
            }
        },
        {
            key: "url",
            get: function get() {
                return "https://github.com/solana-labs/wallet-standard";
            }
        },
        {
            key: "icon",
            get: function get() {
                return $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_wallet, "f").icon;
            }
        },
        {
            key: "readyState",
            get: function get() {
                return $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_readyState, "f");
            }
        },
        {
            key: "publicKey",
            get: function get() {
                return $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_publicKey, "f");
            }
        },
        {
            key: "connecting",
            get: function get() {
                return $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_connecting, "f");
            }
        },
        {
            key: "supportedTransactionVersions",
            get: function get() {
                return $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_supportedTransactionVersions, "f");
            }
        },
        {
            key: "wallet",
            get: function get() {
                return $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_wallet, "f");
            }
        },
        {
            key: "standard",
            get: function get() {
                return true;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                $cdd8644f451074dc$var$__classPrivateFieldSet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_account, null, "f");
                $cdd8644f451074dc$var$__classPrivateFieldSet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_publicKey, null, "f");
                $cdd8644f451074dc$var$__classPrivateFieldSet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_connecting, false, "f");
                $cdd8644f451074dc$var$__classPrivateFieldSet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_disconnecting, false, "f");
                var off = $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_off, "f");
                if (off) {
                    $cdd8644f451074dc$var$__classPrivateFieldSet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_off, null, "f");
                    off();
                }
            }
        },
        {
            key: "autoConnect",
            value: function autoConnect() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        return [
                            2,
                            $cdd8644f451074dc$var$__classPrivateFieldGet(_this, $cdd8644f451074dc$var$_StandardWalletAdapter_instances, "m", $cdd8644f451074dc$var$_StandardWalletAdapter_connect).call(_this, {
                                silent: true
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "connect",
            value: function connect() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        return [
                            2,
                            $cdd8644f451074dc$var$__classPrivateFieldGet(_this, $cdd8644f451074dc$var$_StandardWalletAdapter_instances, "m", $cdd8644f451074dc$var$_StandardWalletAdapter_connect).call(_this)
                        ];
                    });
                })();
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!((0, $884440781fc19407$export$38dbd4bbb9b696e6) in $cdd8644f451074dc$var$__classPrivateFieldGet(_this, $cdd8644f451074dc$var$_StandardWalletAdapter_wallet, "f").features)) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    4,
                                    5
                                ]);
                                $cdd8644f451074dc$var$__classPrivateFieldSet(_this, $cdd8644f451074dc$var$_StandardWalletAdapter_disconnecting, true, "f");
                                return [
                                    4,
                                    $cdd8644f451074dc$var$__classPrivateFieldGet(_this, $cdd8644f451074dc$var$_StandardWalletAdapter_wallet, "f").features[0, $884440781fc19407$export$38dbd4bbb9b696e6].disconnect()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                error = _state.sent();
                                _this.emit("error", new (0, $3f5d780e6d40bbac$export$92e2b26fad5723ee)(error === null || error === void 0 ? void 0 : error.message, error));
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                $cdd8644f451074dc$var$__classPrivateFieldSet(_this, $cdd8644f451074dc$var$_StandardWalletAdapter_disconnecting, false, "f");
                                return [
                                    7
                                ];
                            case 5:
                                $cdd8644f451074dc$var$__classPrivateFieldGet(_this, $cdd8644f451074dc$var$_StandardWalletAdapter_instances, "m", $cdd8644f451074dc$var$_StandardWalletAdapter_disconnected).call(_this);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendTransaction",
            value: function sendTransaction(transaction, connection) {
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var account, feature, chain, signers, sendOptions, serializedTransaction, _transaction, _ref, output, _ref1, output1, error, error1;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    12,
                                    ,
                                    13
                                ]);
                                account = $cdd8644f451074dc$var$__classPrivateFieldGet(_this, $cdd8644f451074dc$var$_StandardWalletAdapter_account, "f");
                                if (!account) throw new (0, $3f5d780e6d40bbac$export$313d299817c74896)();
                                if ((0, $l4Sju.SolanaSignAndSendTransaction) in $cdd8644f451074dc$var$__classPrivateFieldGet(_this, $cdd8644f451074dc$var$_StandardWalletAdapter_wallet, "f").features) {
                                    if (account.features.includes((0, $l4Sju.SolanaSignAndSendTransaction))) feature = (0, $l4Sju.SolanaSignAndSendTransaction);
                                    else if ((0, $e8TeL.SolanaSignTransaction) in $cdd8644f451074dc$var$__classPrivateFieldGet(_this, $cdd8644f451074dc$var$_StandardWalletAdapter_wallet, "f").features && account.features.includes((0, $e8TeL.SolanaSignTransaction))) feature = (0, $e8TeL.SolanaSignTransaction);
                                    else throw new (0, $3f5d780e6d40bbac$export$cd6fa2f8e2a8a612)();
                                } else if ((0, $e8TeL.SolanaSignTransaction) in $cdd8644f451074dc$var$__classPrivateFieldGet(_this, $cdd8644f451074dc$var$_StandardWalletAdapter_wallet, "f").features) {
                                    if (!account.features.includes((0, $e8TeL.SolanaSignTransaction))) throw new (0, $3f5d780e6d40bbac$export$cd6fa2f8e2a8a612)();
                                    feature = (0, $e8TeL.SolanaSignTransaction);
                                } else throw new (0, $3f5d780e6d40bbac$export$9525019988612a5e)();
                                chain = (0, $45fe045c0021ae8d$export$43dcd8213c5a5741)(connection.rpcEndpoint);
                                if (!account.chains.includes(chain)) throw new (0, $3f5d780e6d40bbac$export$769332ac3f90f46c)();
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    10,
                                    ,
                                    11
                                ]);
                                signers = options.signers, sendOptions = (0, $dRLPW._)(options, [
                                    "signers"
                                ]);
                                if (!(0, $17326fb7ccd2d31f$export$37ce1cc82e255d8)(transaction)) return [
                                    3,
                                    2
                                ];
                                (signers === null || signers === void 0 ? void 0 : signers.length) && transaction.sign(signers);
                                serializedTransaction = transaction.serialize();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.prepareTransaction(transaction, connection, sendOptions)
                                ];
                            case 3:
                                transaction = _state.sent();
                                (signers === null || signers === void 0 ? void 0 : signers.length) && (_transaction = transaction).partialSign.apply(_transaction, (0, $c6Xmf._)(signers));
                                serializedTransaction = new Uint8Array(transaction.serialize({
                                    requireAllSignatures: false,
                                    verifySignatures: false
                                }));
                                _state.label = 4;
                            case 4:
                                if (!(feature === (0, $l4Sju.SolanaSignAndSendTransaction))) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    $cdd8644f451074dc$var$__classPrivateFieldGet(_this, $cdd8644f451074dc$var$_StandardWalletAdapter_wallet, "f").features[0, $l4Sju.SolanaSignAndSendTransaction].signAndSendTransaction({
                                        account: account,
                                        chain: chain,
                                        transaction: serializedTransaction,
                                        options: {
                                            preflightCommitment: (0, $b5416591b49774f5$export$430b2bce150d42d4)(sendOptions.preflightCommitment || connection.commitment),
                                            skipPreflight: sendOptions.skipPreflight,
                                            maxRetries: sendOptions.maxRetries,
                                            minContextSlot: sendOptions.minContextSlot
                                        }
                                    })
                                ];
                            case 5:
                                _ref = (0, $cv9Rk._).apply(void 0, [
                                    _state.sent(),
                                    1
                                ]), output = _ref[0];
                                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                return [
                                    2,
                                    (0, (/*@__PURE__*/$parcel$interopDefault($ca3b22a27c78c8c6$exports))).encode(output.signature)
                                ];
                            case 6:
                                return [
                                    4,
                                    $cdd8644f451074dc$var$__classPrivateFieldGet(_this, $cdd8644f451074dc$var$_StandardWalletAdapter_wallet, "f").features[0, $e8TeL.SolanaSignTransaction].signTransaction({
                                        account: account,
                                        chain: chain,
                                        transaction: serializedTransaction,
                                        options: {
                                            preflightCommitment: (0, $b5416591b49774f5$export$430b2bce150d42d4)(sendOptions.preflightCommitment || connection.commitment),
                                            minContextSlot: sendOptions.minContextSlot
                                        }
                                    })
                                ];
                            case 7:
                                _ref1 = (0, $cv9Rk._).apply(void 0, [
                                    _state.sent(),
                                    1
                                ]), output1 = _ref1[0];
                                return [
                                    4,
                                    connection.sendRawTransaction(output1.signedTransaction, (0, $cxjpp._)((0, $do9pw._)({}, sendOptions), {
                                        preflightCommitment: (0, $b5416591b49774f5$export$430b2bce150d42d4)(sendOptions.preflightCommitment || connection.commitment)
                                    }))
                                ];
                            case 8:
                                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 9:
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                error = _state.sent();
                                if (error instanceof (0, $3f5d780e6d40bbac$export$f46ec6f9dba8711d)) throw error;
                                throw new (0, $3f5d780e6d40bbac$export$769332ac3f90f46c)(error === null || error === void 0 ? void 0 : error.message, error);
                            case 11:
                                return [
                                    3,
                                    13
                                ];
                            case 12:
                                error1 = _state.sent();
                                _this.emit("error", error1);
                                throw error1;
                            case 13:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return StandardWalletAdapter;
}((0, $8c7df08073723177$export$2af1ea2892adc469));
$cdd8644f451074dc$var$_StandardWalletAdapter_account = new WeakMap(), $cdd8644f451074dc$var$_StandardWalletAdapter_publicKey = new WeakMap(), $cdd8644f451074dc$var$_StandardWalletAdapter_connecting = new WeakMap(), $cdd8644f451074dc$var$_StandardWalletAdapter_disconnecting = new WeakMap(), $cdd8644f451074dc$var$_StandardWalletAdapter_off = new WeakMap(), $cdd8644f451074dc$var$_StandardWalletAdapter_supportedTransactionVersions = new WeakMap(), $cdd8644f451074dc$var$_StandardWalletAdapter_wallet = new WeakMap(), $cdd8644f451074dc$var$_StandardWalletAdapter_readyState = new WeakMap(), $cdd8644f451074dc$var$_StandardWalletAdapter_changed = new WeakMap(), $cdd8644f451074dc$var$_StandardWalletAdapter_instances = new WeakSet(), $cdd8644f451074dc$var$_StandardWalletAdapter_connect = function() {
    var __StandardWalletAdapter_connect = (0, $kSuI9._)(function(input) {
        var error, account, error1;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        5,
                        6,
                        7
                    ]);
                    if (this.connected || this.connecting) return [
                        2
                    ];
                    if ($cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_readyState, "f") !== (0, $8c7df08073723177$export$2a7b8071105d05b6).Installed) throw new (0, $3f5d780e6d40bbac$export$d65db264eda99cd7)();
                    $cdd8644f451074dc$var$__classPrivateFieldSet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_connecting, true, "f");
                    if (!!$cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_wallet, "f").accounts.length) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_wallet, "f").features[0, $93de5c00a84b23a2$export$cc68487eeb93b1d4].connect(input)
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    throw new (0, $3f5d780e6d40bbac$export$38f21f1c810261c7)(error === null || error === void 0 ? void 0 : error.message, error);
                case 4:
                    account = $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_wallet, "f").accounts[0];
                    if (!account) throw new (0, $3f5d780e6d40bbac$export$cd6fa2f8e2a8a612)();
                    $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_instances, "m", $cdd8644f451074dc$var$_StandardWalletAdapter_connected).call(this, account);
                    return [
                        3,
                        7
                    ];
                case 5:
                    error1 = _state.sent();
                    this.emit("error", error1);
                    throw error1;
                case 6:
                    $cdd8644f451074dc$var$__classPrivateFieldSet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_connecting, false, "f");
                    return [
                        7
                    ];
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    function _StandardWalletAdapter_connect(input) {
        return __StandardWalletAdapter_connect.apply(this, arguments);
    }
    return _StandardWalletAdapter_connect;
}(), $cdd8644f451074dc$var$_StandardWalletAdapter_connected = function _StandardWalletAdapter_connected(account) {
    var publicKey;
    try {
        // Use account.address instead of account.publicKey since address could be a PDA
        publicKey = new (0, $69N5M.PublicKey)(account.address);
    } catch (error) {
        throw new (0, $3f5d780e6d40bbac$export$735bef3bfb0f2c86)(error === null || error === void 0 ? void 0 : error.message, error);
    }
    $cdd8644f451074dc$var$__classPrivateFieldSet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_account, account, "f");
    $cdd8644f451074dc$var$__classPrivateFieldSet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_publicKey, publicKey, "f");
    $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_instances, "m", $cdd8644f451074dc$var$_StandardWalletAdapter_reset).call(this);
    this.emit("connect", publicKey);
}, $cdd8644f451074dc$var$_StandardWalletAdapter_disconnected = function _StandardWalletAdapter_disconnected() {
    $cdd8644f451074dc$var$__classPrivateFieldSet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_account, null, "f");
    $cdd8644f451074dc$var$__classPrivateFieldSet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_publicKey, null, "f");
    $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_instances, "m", $cdd8644f451074dc$var$_StandardWalletAdapter_reset).call(this);
    this.emit("disconnect");
}, $cdd8644f451074dc$var$_StandardWalletAdapter_reset = function _StandardWalletAdapter_reset() {
    var __classPrivateFieldGet1, __classPrivateFieldGet2;
    var supportedTransactionVersions = (0, $l4Sju.SolanaSignAndSendTransaction) in $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_wallet, "f").features ? $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_wallet, "f").features[0, $l4Sju.SolanaSignAndSendTransaction].supportedTransactionVersions : $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_wallet, "f").features[0, $e8TeL.SolanaSignTransaction].supportedTransactionVersions;
    $cdd8644f451074dc$var$__classPrivateFieldSet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_supportedTransactionVersions, (0, $4257e3421c96b900$export$234180f8206db11b)(supportedTransactionVersions, [
        "legacy"
    ]) ? null : new Set(supportedTransactionVersions), "f");
    if ((0, $e8TeL.SolanaSignTransaction) in $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_wallet, "f").features && ((__classPrivateFieldGet1 = $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_account, "f")) === null || __classPrivateFieldGet1 === void 0 ? void 0 : __classPrivateFieldGet1.features.includes((0, $e8TeL.SolanaSignTransaction)))) {
        this.signTransaction = $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_instances, "m", $cdd8644f451074dc$var$_StandardWalletAdapter_signTransaction);
        this.signAllTransactions = $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_instances, "m", $cdd8644f451074dc$var$_StandardWalletAdapter_signAllTransactions);
    } else {
        delete this.signTransaction;
        delete this.signAllTransactions;
    }
    if ((0, $l0pK9.SolanaSignMessage) in $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_wallet, "f").features && ((__classPrivateFieldGet2 = $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_account, "f")) === null || __classPrivateFieldGet2 === void 0 ? void 0 : __classPrivateFieldGet2.features.includes((0, $l0pK9.SolanaSignMessage)))) this.signMessage = $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_instances, "m", $cdd8644f451074dc$var$_StandardWalletAdapter_signMessage);
    else delete this.signMessage;
    if ((0, $43701ed1e668c6ce$export$8adeab75f48a3607) in $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_wallet, "f").features) this.signIn = $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_instances, "m", $cdd8644f451074dc$var$_StandardWalletAdapter_signIn);
    else delete this.signIn;
}, $cdd8644f451074dc$var$_StandardWalletAdapter_signTransaction = function() {
    var __StandardWalletAdapter_signTransaction = (0, $kSuI9._)(function(transaction) {
        var account, signedTransactions, serializedTransaction, error, error1;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        5,
                        ,
                        6
                    ]);
                    account = $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_account, "f");
                    if (!account) throw new (0, $3f5d780e6d40bbac$export$313d299817c74896)();
                    if (!((0, $e8TeL.SolanaSignTransaction) in $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_wallet, "f").features)) throw new (0, $3f5d780e6d40bbac$export$9525019988612a5e)();
                    if (!account.features.includes((0, $e8TeL.SolanaSignTransaction))) throw new (0, $3f5d780e6d40bbac$export$cd6fa2f8e2a8a612)();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_wallet, "f").features[0, $e8TeL.SolanaSignTransaction].signTransaction({
                            account: account,
                            transaction: (0, $17326fb7ccd2d31f$export$37ce1cc82e255d8)(transaction) ? transaction.serialize() : new Uint8Array(transaction.serialize({
                                requireAllSignatures: false,
                                verifySignatures: false
                            }))
                        })
                    ];
                case 2:
                    signedTransactions = _state.sent();
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    serializedTransaction = signedTransactions[0].signedTransaction;
                    return [
                        2,
                        (0, $17326fb7ccd2d31f$export$37ce1cc82e255d8)(transaction) ? (0, $69N5M.VersionedTransaction).deserialize(serializedTransaction) : (0, $69N5M.Transaction).from(serializedTransaction)
                    ];
                case 3:
                    error = _state.sent();
                    if (error instanceof (0, $3f5d780e6d40bbac$export$f46ec6f9dba8711d)) throw error;
                    throw new (0, $3f5d780e6d40bbac$export$96f177062fdd8180)(error === null || error === void 0 ? void 0 : error.message, error);
                case 4:
                    return [
                        3,
                        6
                    ];
                case 5:
                    error1 = _state.sent();
                    this.emit("error", error1);
                    throw error1;
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    function _StandardWalletAdapter_signTransaction(transaction) {
        return __StandardWalletAdapter_signTransaction.apply(this, arguments);
    }
    return _StandardWalletAdapter_signTransaction;
}(), $cdd8644f451074dc$var$_StandardWalletAdapter_signAllTransactions = function() {
    var __StandardWalletAdapter_signAllTransactions = (0, $kSuI9._)(function(transactions) {
        var account, __classPrivateFieldGet_features_SolanaSignTransaction, signedTransactions, error, error1;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        5,
                        ,
                        6
                    ]);
                    account = $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_account, "f");
                    if (!account) throw new (0, $3f5d780e6d40bbac$export$313d299817c74896)();
                    if (!((0, $e8TeL.SolanaSignTransaction) in $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_wallet, "f").features)) throw new (0, $3f5d780e6d40bbac$export$9525019988612a5e)();
                    if (!account.features.includes((0, $e8TeL.SolanaSignTransaction))) throw new (0, $3f5d780e6d40bbac$export$cd6fa2f8e2a8a612)();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (__classPrivateFieldGet_features_SolanaSignTransaction = $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_wallet, "f").features[0, $e8TeL.SolanaSignTransaction]).signTransaction.apply(__classPrivateFieldGet_features_SolanaSignTransaction, (0, $c6Xmf._)(transactions.map(function(transaction) {
                            return {
                                account: account,
                                transaction: (0, $17326fb7ccd2d31f$export$37ce1cc82e255d8)(transaction) ? transaction.serialize() : new Uint8Array(transaction.serialize({
                                    requireAllSignatures: false,
                                    verifySignatures: false
                                }))
                            };
                        })))
                    ];
                case 2:
                    signedTransactions = _state.sent();
                    return [
                        2,
                        transactions.map(function(transaction, index) {
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            var signedTransaction = signedTransactions[index].signedTransaction;
                            return (0, $17326fb7ccd2d31f$export$37ce1cc82e255d8)(transaction) ? (0, $69N5M.VersionedTransaction).deserialize(signedTransaction) : (0, $69N5M.Transaction).from(signedTransaction);
                        })
                    ];
                case 3:
                    error = _state.sent();
                    throw new (0, $3f5d780e6d40bbac$export$96f177062fdd8180)(error === null || error === void 0 ? void 0 : error.message, error);
                case 4:
                    return [
                        3,
                        6
                    ];
                case 5:
                    error1 = _state.sent();
                    this.emit("error", error1);
                    throw error1;
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    function _StandardWalletAdapter_signAllTransactions(transactions) {
        return __StandardWalletAdapter_signAllTransactions.apply(this, arguments);
    }
    return _StandardWalletAdapter_signAllTransactions;
}(), $cdd8644f451074dc$var$_StandardWalletAdapter_signMessage = function() {
    var __StandardWalletAdapter_signMessage = (0, $kSuI9._)(function(message) {
        var account, signedMessages, error, error1;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        5,
                        ,
                        6
                    ]);
                    account = $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_account, "f");
                    if (!account) throw new (0, $3f5d780e6d40bbac$export$313d299817c74896)();
                    if (!((0, $l0pK9.SolanaSignMessage) in $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_wallet, "f").features)) throw new (0, $3f5d780e6d40bbac$export$9525019988612a5e)();
                    if (!account.features.includes((0, $l0pK9.SolanaSignMessage))) throw new (0, $3f5d780e6d40bbac$export$cd6fa2f8e2a8a612)();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_wallet, "f").features[0, $l0pK9.SolanaSignMessage].signMessage({
                            account: account,
                            message: message
                        })
                    ];
                case 2:
                    signedMessages = _state.sent();
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    return [
                        2,
                        signedMessages[0].signature
                    ];
                case 3:
                    error = _state.sent();
                    throw new (0, $3f5d780e6d40bbac$export$2622c1721bbd4b17)(error === null || error === void 0 ? void 0 : error.message, error);
                case 4:
                    return [
                        3,
                        6
                    ];
                case 5:
                    error1 = _state.sent();
                    this.emit("error", error1);
                    throw error1;
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    function _StandardWalletAdapter_signMessage(message) {
        return __StandardWalletAdapter_signMessage.apply(this, arguments);
    }
    return _StandardWalletAdapter_signMessage;
}(), $cdd8644f451074dc$var$_StandardWalletAdapter_signIn = function() {
    var __StandardWalletAdapter_signIn = (0, $kSuI9._)(function() {
        var input, output, ref, error, error1;
        var _arguments = arguments;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    input = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        ,
                        7
                    ]);
                    if (!((0, $43701ed1e668c6ce$export$8adeab75f48a3607) in $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_wallet, "f").features)) throw new (0, $3f5d780e6d40bbac$export$9525019988612a5e)();
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_wallet, "f").features[0, $43701ed1e668c6ce$export$8adeab75f48a3607].signIn(input)
                    ];
                case 3:
                    ref = (0, $cv9Rk._).apply(void 0, [
                        _state.sent(),
                        1
                    ]), output = ref[0], ref;
                    return [
                        3,
                        5
                    ];
                case 4:
                    error = _state.sent();
                    throw new (0, $3f5d780e6d40bbac$export$a4c7d3c66e3cdd6c)(error === null || error === void 0 ? void 0 : error.message, error);
                case 5:
                    if (!output) throw new (0, $3f5d780e6d40bbac$export$a4c7d3c66e3cdd6c)();
                    $cdd8644f451074dc$var$__classPrivateFieldGet(this, $cdd8644f451074dc$var$_StandardWalletAdapter_instances, "m", $cdd8644f451074dc$var$_StandardWalletAdapter_connected).call(this, output.account);
                    return [
                        2,
                        output
                    ];
                case 6:
                    error1 = _state.sent();
                    this.emit("error", error1);
                    throw error1;
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    function _StandardWalletAdapter_signIn() {
        return __StandardWalletAdapter_signIn.apply(this, arguments);
    }
    return _StandardWalletAdapter_signIn;
}();



var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $c6Xmf = parcelRequire("c6Xmf");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");
var $e6d4814926d5c97e$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $e6d4814926d5c97e$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $e6d4814926d5c97e$var$_AppReadyEvent_detail;
var $e6d4814926d5c97e$var$wallets = undefined;
var $e6d4814926d5c97e$var$registered = new Set();
var $e6d4814926d5c97e$var$listeners = {};
function $e6d4814926d5c97e$export$ac4d188b6eef3eb7() {
    if ($e6d4814926d5c97e$var$wallets) return $e6d4814926d5c97e$var$wallets;
    $e6d4814926d5c97e$var$wallets = Object.freeze({
        register: $e6d4814926d5c97e$var$register,
        get: $e6d4814926d5c97e$var$get,
        on: $e6d4814926d5c97e$var$on
    });
    if (typeof window === "undefined") return $e6d4814926d5c97e$var$wallets;
    var api = Object.freeze({
        register: $e6d4814926d5c97e$var$register
    });
    try {
        window.addEventListener("wallet-standard:register-wallet", function(param) {
            var callback = param.detail;
            return callback(api);
        });
    } catch (error) {
        console.error("wallet-standard:register-wallet event listener could not be added\n", error);
    }
    try {
        window.dispatchEvent(new $e6d4814926d5c97e$var$AppReadyEvent(api));
    } catch (error) {
        console.error("wallet-standard:app-ready event could not be dispatched\n", error);
    }
    return $e6d4814926d5c97e$var$wallets;
}
function $e6d4814926d5c97e$var$register() {
    for(var _len = arguments.length, wallets = new Array(_len), _key = 0; _key < _len; _key++){
        wallets[_key] = arguments[_key];
    }
    var _listeners_register;
    // Filter out wallets that have already been registered.
    // This prevents the same wallet from being registered twice, but it also prevents wallets from being
    // unregistered by reusing a reference to the wallet to obtain the unregister function for it.
    wallets = wallets.filter(function(wallet) {
        return !$e6d4814926d5c97e$var$registered.has(wallet);
    });
    // If there are no new wallets to register, just return a no-op unregister function.
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    if (!wallets.length) return function() {};
    wallets.forEach(function(wallet) {
        return $e6d4814926d5c97e$var$registered.add(wallet);
    });
    (_listeners_register = $e6d4814926d5c97e$var$listeners["register"]) === null || _listeners_register === void 0 ? void 0 : _listeners_register.forEach(function(listener) {
        return $e6d4814926d5c97e$var$guard(function() {
            return listener.apply(void 0, (0, $c6Xmf._)(wallets));
        });
    });
    // Return a function that unregisters the registered wallets.
    return function unregister() {
        var _listeners_unregister;
        wallets.forEach(function(wallet) {
            return $e6d4814926d5c97e$var$registered.delete(wallet);
        });
        (_listeners_unregister = $e6d4814926d5c97e$var$listeners["unregister"]) === null || _listeners_unregister === void 0 ? void 0 : _listeners_unregister.forEach(function(listener) {
            return $e6d4814926d5c97e$var$guard(function() {
                return listener.apply(void 0, (0, $c6Xmf._)(wallets));
            });
        });
    };
}
function $e6d4814926d5c97e$var$get() {
    return (0, $c6Xmf._)($e6d4814926d5c97e$var$registered);
}
function $e6d4814926d5c97e$var$on(event, listener) {
    var _listeners_event;
    ((_listeners_event = $e6d4814926d5c97e$var$listeners[event]) === null || _listeners_event === void 0 ? void 0 : _listeners_event.push(listener)) || ($e6d4814926d5c97e$var$listeners[event] = [
        listener
    ]);
    // Return a function that removes the event listener.
    return function off() {
        var _listeners_event;
        $e6d4814926d5c97e$var$listeners[event] = (_listeners_event = $e6d4814926d5c97e$var$listeners[event]) === null || _listeners_event === void 0 ? void 0 : _listeners_event.filter(function(existingListener) {
            return listener !== existingListener;
        });
    };
}
function $e6d4814926d5c97e$var$guard(callback) {
    try {
        callback();
    } catch (error) {
        console.error(error);
    }
}
var $e6d4814926d5c97e$var$AppReadyEvent = /*#__PURE__*/ function(Event1) {
    "use strict";
    (0, $dcsZi._)(AppReadyEvent, Event1);
    var _super = (0, $ohfOJ._)(AppReadyEvent);
    function AppReadyEvent(api) {
        (0, $4GJKx._)(this, AppReadyEvent);
        var _this;
        _this = _super.call(this, "wallet-standard:app-ready", {
            bubbles: false,
            cancelable: false,
            composed: false
        });
        $e6d4814926d5c97e$var$_AppReadyEvent_detail.set((0, $d3H5E._)(_this), void 0);
        $e6d4814926d5c97e$var$__classPrivateFieldSet((0, $d3H5E._)(_this), $e6d4814926d5c97e$var$_AppReadyEvent_detail, api, "f");
        return _this;
    }
    (0, $1wc17._)(AppReadyEvent, [
        {
            key: "detail",
            get: function get() {
                return $e6d4814926d5c97e$var$__classPrivateFieldGet(this, $e6d4814926d5c97e$var$_AppReadyEvent_detail, "f");
            }
        },
        {
            key: "type",
            get: function get() {
                return "wallet-standard:app-ready";
            }
        },
        {
            /** @deprecated */ key: "preventDefault",
            value: function preventDefault() {
                throw new Error("preventDefault cannot be called");
            }
        },
        {
            /** @deprecated */ key: "stopImmediatePropagation",
            value: function stopImmediatePropagation() {
                throw new Error("stopImmediatePropagation cannot be called");
            }
        },
        {
            /** @deprecated */ key: "stopPropagation",
            value: function stopPropagation() {
                throw new Error("stopPropagation cannot be called");
            }
        }
    ]);
    return AppReadyEvent;
}((0, $FuVm8._)(Event));
$e6d4814926d5c97e$var$_AppReadyEvent_detail = new WeakMap();
function $e6d4814926d5c97e$export$2194deb72a59836d() {
    if ($e6d4814926d5c97e$var$wallets) return $e6d4814926d5c97e$var$wallets;
    $e6d4814926d5c97e$var$wallets = $e6d4814926d5c97e$export$ac4d188b6eef3eb7();
    if (typeof window === "undefined") return $e6d4814926d5c97e$var$wallets;
    var callbacks = window.navigator.wallets || [];
    if (!Array.isArray(callbacks)) {
        console.error("window.navigator.wallets is not an array");
        return $e6d4814926d5c97e$var$wallets;
    }
    var register = $e6d4814926d5c97e$var$wallets.register;
    var push = function() {
        for(var _len = arguments.length, callbacks = new Array(_len), _key = 0; _key < _len; _key++){
            callbacks[_key] = arguments[_key];
        }
        return callbacks.forEach(function(callback) {
            return $e6d4814926d5c97e$var$guard(function() {
                return callback({
                    register: register
                });
            });
        });
    };
    try {
        Object.defineProperty(window.navigator, "wallets", {
            value: Object.freeze({
                push: push
            })
        });
    } catch (error) {
        console.error("window.navigator.wallets could not be set");
        return $e6d4814926d5c97e$var$wallets;
    }
    push.apply(void 0, (0, $c6Xmf._)(callbacks));
    return $e6d4814926d5c97e$var$wallets;
}



var $1Mpn7 = parcelRequire("1Mpn7");
function $71d945b1c781ed16$export$ca3bd81d254ceecf(adapters) {
    var warnings = $71d945b1c781ed16$var$useConstant(function() {
        return new Set();
    });
    var _useConstant = $71d945b1c781ed16$var$useConstant(function() {
        return (0, $e6d4814926d5c97e$export$2194deb72a59836d)();
    }), get = _useConstant.get, on = _useConstant.on;
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)(function() {
        return $71d945b1c781ed16$var$wrapWalletsWithAdapters(get());
    }), 2), standardAdapters = _useState[0], setStandardAdapters = _useState[1];
    (0, $1Mpn7.useEffect)(function() {
        var listeners = [
            on("register", function() {
                for(var _len = arguments.length, wallets = new Array(_len), _key = 0; _key < _len; _key++){
                    wallets[_key] = arguments[_key];
                }
                return setStandardAdapters(function(standardAdapters) {
                    return (0, $c6Xmf._)(standardAdapters).concat((0, $c6Xmf._)($71d945b1c781ed16$var$wrapWalletsWithAdapters(wallets)));
                });
            }),
            on("unregister", function() {
                for(var _len = arguments.length, wallets = new Array(_len), _key = 0; _key < _len; _key++){
                    wallets[_key] = arguments[_key];
                }
                return setStandardAdapters(function(standardAdapters) {
                    return standardAdapters.filter(function(standardAdapter) {
                        return wallets.some(function(wallet) {
                            return wallet === standardAdapter.wallet;
                        });
                    });
                });
            })
        ];
        return function() {
            return listeners.forEach(function(off) {
                return off();
            });
        };
    }, [
        on
    ]);
    var prevStandardAdapters = $71d945b1c781ed16$var$usePrevious(standardAdapters);
    (0, $1Mpn7.useEffect)(function() {
        if (!prevStandardAdapters) return;
        var currentAdapters = new Set(standardAdapters);
        var removedAdapters = new Set(prevStandardAdapters.filter(function(previousAdapter) {
            return !currentAdapters.has(previousAdapter);
        }));
        removedAdapters.forEach(function(adapter) {
            return adapter.destroy();
        });
    }, [
        prevStandardAdapters,
        standardAdapters
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $1Mpn7.useEffect)(function() {
        return function() {
            return standardAdapters.forEach(function(adapter) {
                return adapter.destroy();
            });
        };
    }, []);
    return (0, $1Mpn7.useMemo)(function() {
        return (0, $c6Xmf._)(standardAdapters).concat((0, $c6Xmf._)(adapters.filter(function(param) {
            var name = param.name;
            if (standardAdapters.some(function(standardAdapter) {
                return standardAdapter.name === name;
            })) {
                if (!warnings.has(name)) {
                    warnings.add(name);
                    console.warn("".concat(name, " was registered as a Standard Wallet. The Wallet Adapter for ").concat(name, " can be removed from your app."));
                }
                return false;
            }
            return true;
        })));
    }, [
        standardAdapters,
        adapters,
        warnings
    ]);
}
function $71d945b1c781ed16$var$useConstant(fn) {
    var ref = (0, $1Mpn7.useRef)();
    if (!ref.current) ref.current = {
        value: fn()
    };
    return ref.current.value;
}
function $71d945b1c781ed16$var$usePrevious(state) {
    var ref = (0, $1Mpn7.useRef)();
    (0, $1Mpn7.useEffect)(function() {
        ref.current = state;
    });
    return ref.current;
}
function $71d945b1c781ed16$var$wrapWalletsWithAdapters(wallets) {
    return wallets.filter((0, $d0641ee2ad4332f1$export$c5439c91843266e6)).map(function(wallet) {
        return new (0, $cdd8644f451074dc$export$e0949de9e32fe3b2)({
            wallet: wallet
        });
    });
}



var $1Mpn7 = parcelRequire("1Mpn7");


var $f94aa3d44de67c95$export$7dc6752a22ab011a;
(function(Environment) {
    Environment[Environment["DESKTOP_WEB"] = 0] = "DESKTOP_WEB";
    Environment[Environment["MOBILE_WEB"] = 1] = "MOBILE_WEB";
})($f94aa3d44de67c95$export$7dc6752a22ab011a || ($f94aa3d44de67c95$export$7dc6752a22ab011a = {}));
function $f94aa3d44de67c95$var$isWebView(userAgentString) {
    return /(WebView|Version\/.+(Chrome)\/(\d+)\.(\d+)\.(\d+)\.(\d+)|; wv\).+(Chrome)\/(\d+)\.(\d+)\.(\d+)\.(\d+))/i.test(userAgentString);
}
function $f94aa3d44de67c95$export$2e2bcd8739ae039(param) {
    var adapters = param.adapters, userAgentString = param.userAgentString;
    if (adapters.some(function(adapter) {
        return adapter.name !== (0, $5f92ecfd71990f96$export$f1265e9082f346f1) && adapter.readyState === (0, $8c7df08073723177$export$2a7b8071105d05b6).Installed;
    })) /**
         * There are only two ways a browser extension adapter should be able to reach `Installed` status:
         *
         *     1. Its browser extension is installed.
         *     2. The app is running on a mobile wallet's in-app browser.
         *
         * In either case, we consider the environment to be desktop-like.
         */ return $f94aa3d44de67c95$export$7dc6752a22ab011a.DESKTOP_WEB;
    if (userAgentString && // Step 1: Check whether we're on a platform that supports MWA at all.
    /android/i.test(userAgentString) && // Step 2: Determine that we are *not* running in a WebView.
    !$f94aa3d44de67c95$var$isWebView(userAgentString)) return $f94aa3d44de67c95$export$7dc6752a22ab011a.MOBILE_WEB;
    else return $f94aa3d44de67c95$export$7dc6752a22ab011a.DESKTOP_WEB;
}


function $cddf03067ffa8f5d$export$2e2bcd8739ae039(endpoint) {
    if (!endpoint) return "mainnet-beta";
    if (/devnet/i.test(endpoint)) return "devnet";
    else if (/testnet/i.test(endpoint)) return "testnet";
    else return "mainnet-beta";
}




var $1Mpn7 = parcelRequire("1Mpn7");
function $eb10463ce63f1315$export$86e2cef2561044ac(key, defaultState) {
    var state = (0, $1Mpn7.useState)(function() {
        try {
            var value = localStorage.getItem(key);
            if (value) return JSON.parse(value);
        } catch (error) {
            if (typeof window !== "undefined") console.error(error);
        }
        return defaultState;
    });
    var value = state[0];
    var isFirstRenderRef = (0, $1Mpn7.useRef)(true);
    (0, $1Mpn7.useEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        try {
            if (value === null) localStorage.removeItem(key);
            else localStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            if (typeof window !== "undefined") console.error(error);
        }
    }, [
        value,
        key
    ]);
    return state;
}



var $kSuI9 = parcelRequire("kSuI9");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $eha6O = parcelRequire("eha6O");


var $1Mpn7 = parcelRequire("1Mpn7");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $ea1ec2757109f53d$export$3f5ccdf96415785c = /*#__PURE__*/ function(WalletError) {
    "use strict";
    (0, $dcsZi._)(WalletNotSelectedError, WalletError);
    var _super = (0, $ohfOJ._)(WalletNotSelectedError);
    function WalletNotSelectedError() {
        (0, $4GJKx._)(this, WalletNotSelectedError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "WalletNotSelectedError";
        return _this;
    }
    return WalletNotSelectedError;
}((0, $3f5d780e6d40bbac$export$f46ec6f9dba8711d));



function $79143ab3e7d32e0e$export$a50b3c99d691184b(param) {
    var children = param.children, adapters = param.wallets, adapter = param.adapter, isUnloadingRef = param.isUnloadingRef, onAutoConnectRequest = param.onAutoConnectRequest, onConnectError = param.onConnectError, onError = param.onError, onSelectWallet = param.onSelectWallet;
    var isConnectingRef = (0, $1Mpn7.useRef)(false);
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)(false), 2), connecting = _useState[0], setConnecting = _useState[1];
    var isDisconnectingRef = (0, $1Mpn7.useRef)(false);
    var _useState1 = (0, $cv9Rk._)((0, $1Mpn7.useState)(false), 2), disconnecting = _useState1[0], setDisconnecting = _useState1[1];
    var _useState2 = (0, $cv9Rk._)((0, $1Mpn7.useState)(function() {
        var _adapter_publicKey;
        return (_adapter_publicKey = adapter === null || adapter === void 0 ? void 0 : adapter.publicKey) !== null && _adapter_publicKey !== void 0 ? _adapter_publicKey : null;
    }), 2), publicKey = _useState2[0], setPublicKey = _useState2[1];
    var _useState3 = (0, $cv9Rk._)((0, $1Mpn7.useState)(function() {
        var _adapter_connected;
        return (_adapter_connected = adapter === null || adapter === void 0 ? void 0 : adapter.connected) !== null && _adapter_connected !== void 0 ? _adapter_connected : false;
    }), 2), connected = _useState3[0], setConnected = _useState3[1];
    /**
     * Store the error handlers as refs so that a change in the
     * custom error handler does not recompute other dependencies.
     */ var onErrorRef = (0, $1Mpn7.useRef)(onError);
    (0, $1Mpn7.useEffect)(function() {
        onErrorRef.current = onError;
        return function() {
            onErrorRef.current = undefined;
        };
    }, [
        onError
    ]);
    var handleErrorRef = (0, $1Mpn7.useRef)(function(error, adapter) {
        if (!isUnloadingRef.current) {
            if (onErrorRef.current) onErrorRef.current(error, adapter);
            else {
                console.error(error, adapter);
                if (error instanceof (0, $3f5d780e6d40bbac$export$d65db264eda99cd7) && typeof window !== "undefined" && adapter) window.open(adapter.url, "_blank");
            }
        }
        return error;
    });
    // Wrap adapters to conform to the `Wallet` interface
    var _useState4 = (0, $cv9Rk._)((0, $1Mpn7.useState)(function() {
        return adapters.map(function(adapter) {
            return {
                adapter: adapter,
                readyState: adapter.readyState
            };
        }).filter(function(param) {
            var readyState = param.readyState;
            return readyState !== (0, $8c7df08073723177$export$2a7b8071105d05b6).Unsupported;
        });
    }), 2), wallets = _useState4[0], setWallets = _useState4[1];
    // When the adapters change, start to listen for changes to their `readyState`
    (0, $1Mpn7.useEffect)(function() {
        // When the adapters change, wrap them to conform to the `Wallet` interface
        setWallets(function(wallets) {
            return adapters.map(function(adapter, index) {
                var wallet = wallets[index];
                // If the wallet hasn't changed, return the same instance
                return wallet && wallet.adapter === adapter && wallet.readyState === adapter.readyState ? wallet : {
                    adapter: adapter,
                    readyState: adapter.readyState
                };
            }).filter(function(param) {
                var readyState = param.readyState;
                return readyState !== (0, $8c7df08073723177$export$2a7b8071105d05b6).Unsupported;
            });
        });
        function handleReadyStateChange(readyState) {
            var _this = this;
            setWallets(function(prevWallets) {
                var index = prevWallets.findIndex(function(param) {
                    var adapter = param.adapter;
                    return adapter === _this;
                });
                if (index === -1) return prevWallets;
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                var adapter = prevWallets[index].adapter;
                return (0, $c6Xmf._)(prevWallets.slice(0, index)).concat([
                    {
                        adapter: adapter,
                        readyState: readyState
                    }
                ], (0, $c6Xmf._)(prevWallets.slice(index + 1))).filter(function(param) {
                    var _$readyState = param.readyState;
                    return _$readyState !== (0, $8c7df08073723177$export$2a7b8071105d05b6).Unsupported;
                });
            });
        }
        adapters.forEach(function(adapter) {
            return adapter.on("readyStateChange", handleReadyStateChange, adapter);
        });
        return function() {
            adapters.forEach(function(adapter) {
                return adapter.off("readyStateChange", handleReadyStateChange, adapter);
            });
        };
    }, [
        adapter,
        adapters
    ]);
    var wallet = (0, $1Mpn7.useMemo)(function() {
        var _wallets_find;
        return (_wallets_find = wallets.find(function(wallet) {
            return wallet.adapter === adapter;
        })) !== null && _wallets_find !== void 0 ? _wallets_find : null;
    }, [
        adapter,
        wallets
    ]);
    // Setup and teardown event listeners when the adapter changes
    (0, $1Mpn7.useEffect)(function() {
        if (!adapter) return;
        var handleConnect = function(publicKey) {
            setPublicKey(publicKey);
            isConnectingRef.current = false;
            setConnecting(false);
            setConnected(true);
            isDisconnectingRef.current = false;
            setDisconnecting(false);
        };
        var handleDisconnect = function() {
            if (isUnloadingRef.current) return;
            setPublicKey(null);
            isConnectingRef.current = false;
            setConnecting(false);
            setConnected(false);
            isDisconnectingRef.current = false;
            setDisconnecting(false);
        };
        var handleError = function(error) {
            handleErrorRef.current(error, adapter);
        };
        adapter.on("connect", handleConnect);
        adapter.on("disconnect", handleDisconnect);
        adapter.on("error", handleError);
        return function() {
            adapter.off("connect", handleConnect);
            adapter.off("disconnect", handleDisconnect);
            adapter.off("error", handleError);
            handleDisconnect();
        };
    }, [
        adapter,
        isUnloadingRef
    ]);
    // When the adapter changes, clear the `autoConnect` tracking flag
    var didAttemptAutoConnectRef = (0, $1Mpn7.useRef)(false);
    (0, $1Mpn7.useEffect)(function() {
        return function() {
            didAttemptAutoConnectRef.current = false;
        };
    }, [
        adapter
    ]);
    // If auto-connect is enabled, request to connect when the adapter changes and is ready
    (0, $1Mpn7.useEffect)(function() {
        if (didAttemptAutoConnectRef.current || isConnectingRef.current || connected || !onAutoConnectRequest || !((wallet === null || wallet === void 0 ? void 0 : wallet.readyState) === (0, $8c7df08073723177$export$2a7b8071105d05b6).Installed || (wallet === null || wallet === void 0 ? void 0 : wallet.readyState) === (0, $8c7df08073723177$export$2a7b8071105d05b6).Loadable)) return;
        isConnectingRef.current = true;
        setConnecting(true);
        didAttemptAutoConnectRef.current = true;
        (0, $kSuI9._)(function() {
            var e;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        return [
                            4,
                            onAutoConnectRequest()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        e = _state.sent();
                        onConnectError();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setConnecting(false);
                        isConnectingRef.current = false;
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        connected,
        onAutoConnectRequest,
        onConnectError,
        wallet
    ]);
    // Send a transaction using the provided connection
    var sendTransaction = (0, $1Mpn7.useCallback)(function() {
        var _ref = (0, $kSuI9._)(function(transaction, connection, options) {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!adapter) throw handleErrorRef.current(new (0, $ea1ec2757109f53d$export$3f5ccdf96415785c)());
                        if (!connected) throw handleErrorRef.current(new (0, $3f5d780e6d40bbac$export$313d299817c74896)(), adapter);
                        return [
                            4,
                            adapter.sendTransaction(transaction, connection, options)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(transaction, connection, options) {
            return _ref.apply(this, arguments);
        };
    }(), [
        adapter,
        connected
    ]);
    // Sign a transaction if the wallet supports it
    var signTransaction = (0, $1Mpn7.useMemo)(function() {
        return adapter && "signTransaction" in adapter ? function() {
            var _ref = (0, $kSuI9._)(function(transaction) {
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!connected) throw handleErrorRef.current(new (0, $3f5d780e6d40bbac$export$313d299817c74896)(), adapter);
                            return [
                                4,
                                adapter.signTransaction(transaction)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(transaction) {
                return _ref.apply(this, arguments);
            };
        }() : undefined;
    }, [
        adapter,
        connected
    ]);
    // Sign multiple transactions if the wallet supports it
    var signAllTransactions = (0, $1Mpn7.useMemo)(function() {
        return adapter && "signAllTransactions" in adapter ? function() {
            var _ref = (0, $kSuI9._)(function(transactions) {
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!connected) throw handleErrorRef.current(new (0, $3f5d780e6d40bbac$export$313d299817c74896)(), adapter);
                            return [
                                4,
                                adapter.signAllTransactions(transactions)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(transactions) {
                return _ref.apply(this, arguments);
            };
        }() : undefined;
    }, [
        adapter,
        connected
    ]);
    // Sign an arbitrary message if the wallet supports it
    var signMessage = (0, $1Mpn7.useMemo)(function() {
        return adapter && "signMessage" in adapter ? function() {
            var _ref = (0, $kSuI9._)(function(message) {
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!connected) throw handleErrorRef.current(new (0, $3f5d780e6d40bbac$export$313d299817c74896)(), adapter);
                            return [
                                4,
                                adapter.signMessage(message)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(message) {
                return _ref.apply(this, arguments);
            };
        }() : undefined;
    }, [
        adapter,
        connected
    ]);
    // Sign in if the wallet supports it
    var signIn = (0, $1Mpn7.useMemo)(function() {
        return adapter && "signIn" in adapter ? function() {
            var _ref = (0, $kSuI9._)(function(input) {
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                adapter.signIn(input)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(input) {
                return _ref.apply(this, arguments);
            };
        }() : undefined;
    }, [
        adapter
    ]);
    var handleConnect = (0, $1Mpn7.useCallback)(/*#__PURE__*/ (0, $kSuI9._)(function() {
        var adapter, readyState, e;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (isConnectingRef.current || isDisconnectingRef.current || (wallet === null || wallet === void 0 ? void 0 : wallet.adapter.connected)) return [
                        2
                    ];
                    if (!wallet) throw handleErrorRef.current(new (0, $ea1ec2757109f53d$export$3f5ccdf96415785c)());
                    adapter = wallet.adapter, readyState = wallet.readyState;
                    if (!(readyState === (0, $8c7df08073723177$export$2a7b8071105d05b6).Installed || readyState === (0, $8c7df08073723177$export$2a7b8071105d05b6).Loadable)) throw handleErrorRef.current(new (0, $3f5d780e6d40bbac$export$d65db264eda99cd7)(), adapter);
                    isConnectingRef.current = true;
                    setConnecting(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4,
                        adapter.connect()
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 3:
                    e = _state.sent();
                    onConnectError();
                    throw e;
                case 4:
                    setConnecting(false);
                    isConnectingRef.current = false;
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    }), [
        onConnectError,
        wallet
    ]);
    var handleDisconnect = (0, $1Mpn7.useCallback)(/*#__PURE__*/ (0, $kSuI9._)(function() {
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (isDisconnectingRef.current) return [
                        2
                    ];
                    if (!adapter) return [
                        2
                    ];
                    isDisconnectingRef.current = true;
                    setDisconnecting(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        3,
                        4
                    ]);
                    return [
                        4,
                        adapter.disconnect()
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    setDisconnecting(false);
                    isDisconnectingRef.current = false;
                    return [
                        7
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        adapter
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $064a90e950b6662f$export$19648c908dc8d0bf).Provider, {
        value: {
            autoConnect: !!onAutoConnectRequest,
            wallets: wallets,
            wallet: wallet,
            publicKey: publicKey,
            connected: connected,
            connecting: connecting,
            disconnecting: disconnecting,
            select: onSelectWallet,
            connect: handleConnect,
            disconnect: handleDisconnect,
            sendTransaction: sendTransaction,
            signTransaction: signTransaction,
            signAllTransactions: signAllTransactions,
            signMessage: signMessage,
            signIn: signIn
        }
    }, children);
}


var $c470b3c18c20aeea$var$_userAgent;
function $c470b3c18c20aeea$var$getUserAgent() {
    var _globalThis_navigator;
    var _globalThis_navigator_userAgent;
    if ($c470b3c18c20aeea$var$_userAgent === undefined) $c470b3c18c20aeea$var$_userAgent = (_globalThis_navigator_userAgent = (_globalThis_navigator = globalThis.navigator) === null || _globalThis_navigator === void 0 ? void 0 : _globalThis_navigator.userAgent) !== null && _globalThis_navigator_userAgent !== void 0 ? _globalThis_navigator_userAgent : null;
    return $c470b3c18c20aeea$var$_userAgent;
}
function $c470b3c18c20aeea$var$getIsMobile(adapters) {
    var userAgentString = $c470b3c18c20aeea$var$getUserAgent();
    return (0, $f94aa3d44de67c95$export$2e2bcd8739ae039)({
        adapters: adapters,
        userAgentString: userAgentString
    }) === (0, $f94aa3d44de67c95$export$7dc6752a22ab011a).MOBILE_WEB;
}
function $c470b3c18c20aeea$var$getUriForAppIdentity() {
    var location = globalThis.location;
    if (!location) return;
    return "".concat(location.protocol, "//").concat(location.host);
}
function $c470b3c18c20aeea$export$717b22fc3a2082b3(param) {
    var children = param.children, adapters = param.wallets, autoConnect = param.autoConnect, _param_localStorageKey = param.localStorageKey, localStorageKey = _param_localStorageKey === void 0 ? "walletName" : _param_localStorageKey, onError = param.onError;
    var connection = (0, $0557e2bf883213b5$export$985e8768c0e91dbc)().connection;
    var adaptersWithStandardAdapters = (0, $71d945b1c781ed16$export$ca3bd81d254ceecf)(adapters);
    var mobileWalletAdapter = (0, $1Mpn7.useMemo)(function() {
        if (!$c470b3c18c20aeea$var$getIsMobile(adaptersWithStandardAdapters)) return null;
        var existingMobileWalletAdapter = adaptersWithStandardAdapters.find(function(adapter) {
            return adapter.name === (0, $5f92ecfd71990f96$export$f1265e9082f346f1);
        });
        if (existingMobileWalletAdapter) return existingMobileWalletAdapter;
        return new (0, $5f92ecfd71990f96$export$dec251788b2f5a84)({
            addressSelector: (0, $5f92ecfd71990f96$export$a299fb0acc11345b)(),
            appIdentity: {
                uri: $c470b3c18c20aeea$var$getUriForAppIdentity()
            },
            authorizationResultCache: (0, $5f92ecfd71990f96$export$4a0b597891770806)(),
            cluster: (0, $cddf03067ffa8f5d$export$2e2bcd8739ae039)(connection === null || connection === void 0 ? void 0 : connection.rpcEndpoint),
            onWalletNotFound: (0, $5f92ecfd71990f96$export$e8b9e70cdf783b70)()
        });
    }, [
        adaptersWithStandardAdapters,
        connection === null || connection === void 0 ? void 0 : connection.rpcEndpoint
    ]);
    var adaptersWithMobileWalletAdapter = (0, $1Mpn7.useMemo)(function() {
        if (mobileWalletAdapter == null || adaptersWithStandardAdapters.indexOf(mobileWalletAdapter) !== -1) return adaptersWithStandardAdapters;
        return [
            mobileWalletAdapter
        ].concat((0, $c6Xmf._)(adaptersWithStandardAdapters));
    }, [
        adaptersWithStandardAdapters,
        mobileWalletAdapter
    ]);
    var _useLocalStorage = (0, $cv9Rk._)((0, $eb10463ce63f1315$export$86e2cef2561044ac)(localStorageKey, $c470b3c18c20aeea$var$getIsMobile(adaptersWithStandardAdapters) ? (0, $5f92ecfd71990f96$export$f1265e9082f346f1) : null), 2), walletName = _useLocalStorage[0], setWalletName = _useLocalStorage[1];
    var adapter = (0, $1Mpn7.useMemo)(function() {
        var _adaptersWithMobileWalletAdapter_find;
        return (_adaptersWithMobileWalletAdapter_find = adaptersWithMobileWalletAdapter.find(function(a) {
            return a.name === walletName;
        })) !== null && _adaptersWithMobileWalletAdapter_find !== void 0 ? _adaptersWithMobileWalletAdapter_find : null;
    }, [
        adaptersWithMobileWalletAdapter,
        walletName
    ]);
    var changeWallet = (0, $1Mpn7.useCallback)(function(nextWalletName) {
        if (walletName === nextWalletName) return;
        if (adapter && // Selecting a wallet other than the mobile wallet adapter is not
        // sufficient reason to call `disconnect` on the mobile wallet adapter.
        // Calling `disconnect` on the mobile wallet adapter causes the entire
        // authorization store to be wiped.
        adapter.name !== (0, $5f92ecfd71990f96$export$f1265e9082f346f1)) adapter.disconnect();
        setWalletName(nextWalletName);
    }, [
        adapter,
        setWalletName,
        walletName
    ]);
    (0, $1Mpn7.useEffect)(function() {
        if (!adapter) return;
        function handleDisconnect() {
            if (isUnloadingRef.current) return;
            // Leave the adapter selected in the event of a disconnection.
            if (walletName === (0, $5f92ecfd71990f96$export$f1265e9082f346f1) && $c470b3c18c20aeea$var$getIsMobile(adaptersWithStandardAdapters)) return;
            setWalletName(null);
        }
        adapter.on("disconnect", handleDisconnect);
        return function() {
            adapter.off("disconnect", handleDisconnect);
        };
    }, [
        adapter,
        adaptersWithStandardAdapters,
        setWalletName,
        walletName
    ]);
    var hasUserSelectedAWallet = (0, $1Mpn7.useRef)(false);
    var handleAutoConnectRequest = (0, $1Mpn7.useMemo)(function() {
        if (!autoConnect || !adapter) return;
        return /*#__PURE__*/ (0, $kSuI9._)(function() {
            var _tmp;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = autoConnect === true;
                        if (_tmp) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            autoConnect(adapter)
                        ];
                    case 1:
                        _tmp = _state.sent();
                        _state.label = 2;
                    case 2:
                        if (!_tmp) return [
                            3,
                            6
                        ];
                        if (!hasUserSelectedAWallet.current) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            adapter.connect()
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 4:
                        return [
                            4,
                            adapter.autoConnect()
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
    }, [
        autoConnect,
        adapter
    ]);
    var isUnloadingRef = (0, $1Mpn7.useRef)(false);
    (0, $1Mpn7.useEffect)(function() {
        if (walletName === (0, $5f92ecfd71990f96$export$f1265e9082f346f1) && $c470b3c18c20aeea$var$getIsMobile(adaptersWithStandardAdapters)) {
            isUnloadingRef.current = false;
            return;
        }
        function handleBeforeUnload() {
            isUnloadingRef.current = true;
        }
        /**
         * Some wallets fire disconnection events when the window unloads. Since there's no way to
         * distinguish between a disconnection event received because a user initiated it, and one
         * that was received because they've closed the window, we have to track window unload
         * events themselves. Downstream components use this information to decide whether to act
         * upon or drop wallet events and errors.
         */ window.addEventListener("beforeunload", handleBeforeUnload);
        return function() {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [
        adaptersWithStandardAdapters,
        walletName
    ]);
    var handleConnectError = (0, $1Mpn7.useCallback)(function() {
        if (adapter && adapter.name !== (0, $5f92ecfd71990f96$export$f1265e9082f346f1)) // If any error happens while connecting, unset the adapter.
        changeWallet(null);
    }, [
        adapter,
        changeWallet
    ]);
    var selectWallet = (0, $1Mpn7.useCallback)(function(walletName) {
        hasUserSelectedAWallet.current = true;
        changeWallet(walletName);
    }, [
        changeWallet
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $79143ab3e7d32e0e$export$a50b3c99d691184b), {
        wallets: adaptersWithMobileWalletAdapter,
        adapter: adapter,
        isUnloadingRef: isUnloadingRef,
        onAutoConnectRequest: handleAutoConnectRequest,
        onConnectError: handleConnectError,
        onError: onError,
        onSelectWallet: selectWallet
    }, children);
}



var $69N5M = parcelRequire("69N5M");

var $kSuI9 = parcelRequire("kSuI9");

var $cv9Rk = parcelRequire("cv9Rk");

var $eha6O = parcelRequire("eha6O");

var $jt90m = parcelRequire("jt90m");
var $20e3aa0fe80fabea$export$15db02dbfcaf60e0 = function(layout) {
    var decode = layout.decode.bind(layout);
    var encode = layout.encode.bind(layout);
    return {
        decode: decode,
        encode: encode
    };
};



var $jt90m = parcelRequire("jt90m");

var $hgOwg = parcelRequire("hgOwg");


var $8dlmd = parcelRequire("8dlmd");
var $59bc11fd00a6333b$require$Buffer = $8dlmd.Buffer;
var $59bc11fd00a6333b$export$c97e695afb26d84 = function(length) {
    return function(property) {
        var layout = (0, $jt90m.blob)(length, property);
        var _encodeDecode = (0, $20e3aa0fe80fabea$export$15db02dbfcaf60e0)(layout), encode = _encodeDecode.encode, decode = _encodeDecode.decode;
        var bigIntLayout = layout;
        bigIntLayout.decode = function(buffer, offset) {
            var src = decode(buffer, offset);
            return (0, $hgOwg.toBigIntLE)($59bc11fd00a6333b$require$Buffer.from(src));
        };
        bigIntLayout.encode = function(bigInt, buffer, offset) {
            var src = (0, $hgOwg.toBufferLE)(bigInt, length);
            return encode(src, buffer, offset);
        };
        return bigIntLayout;
    };
};
var $59bc11fd00a6333b$export$8fa7afc0d3e063a4 = function(length) {
    return function(property) {
        var layout = (0, $jt90m.blob)(length, property);
        var _encodeDecode = (0, $20e3aa0fe80fabea$export$15db02dbfcaf60e0)(layout), encode = _encodeDecode.encode, decode = _encodeDecode.decode;
        var bigIntLayout = layout;
        bigIntLayout.decode = function(buffer, offset) {
            var src = decode(buffer, offset);
            return (0, $hgOwg.toBigIntBE)($59bc11fd00a6333b$require$Buffer.from(src));
        };
        bigIntLayout.encode = function(bigInt, buffer, offset) {
            var src = (0, $hgOwg.toBufferBE)(bigInt, length);
            return encode(src, buffer, offset);
        };
        return bigIntLayout;
    };
};
var $59bc11fd00a6333b$export$cd1442401e54cffa = $59bc11fd00a6333b$export$c97e695afb26d84(8);
var $59bc11fd00a6333b$export$7f18746cf5292838 = $59bc11fd00a6333b$export$8fa7afc0d3e063a4(8);
var $59bc11fd00a6333b$export$6cebf8c93d35ecb4 = $59bc11fd00a6333b$export$c97e695afb26d84(16);
var $59bc11fd00a6333b$export$327689723be22772 = $59bc11fd00a6333b$export$8fa7afc0d3e063a4(16);
var $59bc11fd00a6333b$export$8f928ec3e6d68946 = $59bc11fd00a6333b$export$c97e695afb26d84(24);
var $59bc11fd00a6333b$export$559ccecc3c5a7252 = $59bc11fd00a6333b$export$8fa7afc0d3e063a4(24);
var $59bc11fd00a6333b$export$c6d3c723c6dee16b = $59bc11fd00a6333b$export$c97e695afb26d84(32);
var $59bc11fd00a6333b$export$667f357a9402d24c = $59bc11fd00a6333b$export$8fa7afc0d3e063a4(32);



var $5ZD4w = parcelRequire("5ZD4w");


var $685eebe107e3c435$export$23054672248b2c43 = new (0, $5ZD4w.default)("1e+18");
var $685eebe107e3c435$export$78a48a3d1e5dbe89 = function(property) {
    var layout = (0, $59bc11fd00a6333b$export$6cebf8c93d35ecb4)(property);
    var _encodeDecode = (0, $20e3aa0fe80fabea$export$15db02dbfcaf60e0)(layout), encode = _encodeDecode.encode, decode = _encodeDecode.decode;
    var decimalLayout = layout;
    decimalLayout.decode = function(buffer, offset) {
        var src = decode(buffer, offset).toString();
        return new (0, $5ZD4w.default)(src).div($685eebe107e3c435$export$23054672248b2c43);
    };
    decimalLayout.encode = function(decimal, buffer, offset) {
        var src = BigInt(decimal.times($685eebe107e3c435$export$23054672248b2c43).integerValue().toString());
        return encode(src, buffer, offset);
    };
    return decimalLayout;
};



var $jt90m = parcelRequire("jt90m");

var $41e55d51244b5d43$export$87b259aa03e3d267 = function(property) {
    var layout = (0, $jt90m.u8)(property);
    var _encodeDecode = (0, $20e3aa0fe80fabea$export$15db02dbfcaf60e0)(layout), encode = _encodeDecode.encode, decode = _encodeDecode.decode;
    var boolLayout = layout;
    boolLayout.decode = function(buffer, offset) {
        var src = decode(buffer, offset);
        return !!src;
    };
    boolLayout.encode = function(bool, buffer, offset) {
        var src = Number(bool);
        return encode(src, buffer, offset);
    };
    return boolLayout;
};



var $jt90m = parcelRequire("jt90m");

var $69N5M = parcelRequire("69N5M");

var $3285baf77b253a0b$export$86f13247979de5d7 = function(property) {
    var layout = (0, $jt90m.blob)(32, property);
    var _encodeDecode = (0, $20e3aa0fe80fabea$export$15db02dbfcaf60e0)(layout), encode = _encodeDecode.encode, decode = _encodeDecode.decode;
    var publicKeyLayout = layout;
    publicKeyLayout.decode = function(buffer, offset) {
        var src = decode(buffer, offset);
        return new (0, $69N5M.PublicKey)(src);
    };
    publicKeyLayout.encode = function(publicKey, buffer, offset) {
        var src = publicKey.toBuffer();
        return encode(src, buffer, offset);
    };
    return publicKeyLayout;
};





var $69N5M = parcelRequire("69N5M");

var $69N5M = parcelRequire("69N5M");
var $a44c7142cfb07f27$export$79de3e3c2b1ca801 = new (0, $69N5M.PublicKey)("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA");
var $a44c7142cfb07f27$export$8183845dc9f5ce72 = new (0, $69N5M.PublicKey)("TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb");
var $a44c7142cfb07f27$export$57a4f33bcc1767fa = new (0, $69N5M.PublicKey)("ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL");
var $a44c7142cfb07f27$export$71f490c6a4aef7af = new (0, $69N5M.PublicKey)("So11111111111111111111111111111111111111112");
var $a44c7142cfb07f27$export$710fe796384b28ef = new (0, $69N5M.PublicKey)("9pan9bMn5HatX4EJdBwg9VgCa7Uz5HL8N1m5D3NdXejP");
function $a44c7142cfb07f27$export$839bb614a661d99b(programId) {
    if (programId.equals($a44c7142cfb07f27$export$79de3e3c2b1ca801)) return false;
    else return true;
}


/** Base class for errors */ 
var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");
var $0974668e835203eb$export$ed0b8b496332122d = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $dcsZi._)(TokenError, Error1);
    var _super = (0, $ohfOJ._)(TokenError);
    function TokenError(message) {
        (0, $4GJKx._)(this, TokenError);
        return _super.call(this, message);
    }
    return TokenError;
}((0, $FuVm8._)(Error));
var $0974668e835203eb$export$a09a5e48de2f3404 = /*#__PURE__*/ function(TokenError) {
    "use strict";
    (0, $dcsZi._)(TokenAccountNotFoundError, TokenError);
    var _super = (0, $ohfOJ._)(TokenAccountNotFoundError);
    function TokenAccountNotFoundError() {
        (0, $4GJKx._)(this, TokenAccountNotFoundError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "TokenAccountNotFoundError";
        return _this;
    }
    return TokenAccountNotFoundError;
}($0974668e835203eb$export$ed0b8b496332122d);
var $0974668e835203eb$export$f4938317c78e324f = /*#__PURE__*/ function(TokenError) {
    "use strict";
    (0, $dcsZi._)(TokenInvalidAccountError, TokenError);
    var _super = (0, $ohfOJ._)(TokenInvalidAccountError);
    function TokenInvalidAccountError() {
        (0, $4GJKx._)(this, TokenInvalidAccountError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "TokenInvalidAccountError";
        return _this;
    }
    return TokenInvalidAccountError;
}($0974668e835203eb$export$ed0b8b496332122d);
var $0974668e835203eb$export$8daa71fef5582c70 = /*#__PURE__*/ function(TokenError) {
    "use strict";
    (0, $dcsZi._)(TokenInvalidAccountDataError, TokenError);
    var _super = (0, $ohfOJ._)(TokenInvalidAccountDataError);
    function TokenInvalidAccountDataError() {
        (0, $4GJKx._)(this, TokenInvalidAccountDataError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "TokenInvalidAccountDataError";
        return _this;
    }
    return TokenInvalidAccountDataError;
}($0974668e835203eb$export$ed0b8b496332122d);
var $0974668e835203eb$export$abb470453474d51 = /*#__PURE__*/ function(TokenError) {
    "use strict";
    (0, $dcsZi._)(TokenInvalidAccountOwnerError, TokenError);
    var _super = (0, $ohfOJ._)(TokenInvalidAccountOwnerError);
    function TokenInvalidAccountOwnerError() {
        (0, $4GJKx._)(this, TokenInvalidAccountOwnerError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "TokenInvalidAccountOwnerError";
        return _this;
    }
    return TokenInvalidAccountOwnerError;
}($0974668e835203eb$export$ed0b8b496332122d);
var $0974668e835203eb$export$250d31de4ddb7ca5 = /*#__PURE__*/ function(TokenError) {
    "use strict";
    (0, $dcsZi._)(TokenInvalidAccountSizeError, TokenError);
    var _super = (0, $ohfOJ._)(TokenInvalidAccountSizeError);
    function TokenInvalidAccountSizeError() {
        (0, $4GJKx._)(this, TokenInvalidAccountSizeError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "TokenInvalidAccountSizeError";
        return _this;
    }
    return TokenInvalidAccountSizeError;
}($0974668e835203eb$export$ed0b8b496332122d);
var $0974668e835203eb$export$871debb212ec395 = /*#__PURE__*/ function(TokenError) {
    "use strict";
    (0, $dcsZi._)(TokenInvalidMintError, TokenError);
    var _super = (0, $ohfOJ._)(TokenInvalidMintError);
    function TokenInvalidMintError() {
        (0, $4GJKx._)(this, TokenInvalidMintError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "TokenInvalidMintError";
        return _this;
    }
    return TokenInvalidMintError;
}($0974668e835203eb$export$ed0b8b496332122d);
var $0974668e835203eb$export$9d3e0012e0e06993 = /*#__PURE__*/ function(TokenError) {
    "use strict";
    (0, $dcsZi._)(TokenInvalidOwnerError, TokenError);
    var _super = (0, $ohfOJ._)(TokenInvalidOwnerError);
    function TokenInvalidOwnerError() {
        (0, $4GJKx._)(this, TokenInvalidOwnerError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "TokenInvalidOwnerError";
        return _this;
    }
    return TokenInvalidOwnerError;
}($0974668e835203eb$export$ed0b8b496332122d);
var $0974668e835203eb$export$c431a85da6f99bf0 = /*#__PURE__*/ function(TokenError) {
    "use strict";
    (0, $dcsZi._)(TokenOwnerOffCurveError, TokenError);
    var _super = (0, $ohfOJ._)(TokenOwnerOffCurveError);
    function TokenOwnerOffCurveError() {
        (0, $4GJKx._)(this, TokenOwnerOffCurveError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "TokenOwnerOffCurveError";
        return _this;
    }
    return TokenOwnerOffCurveError;
}($0974668e835203eb$export$ed0b8b496332122d);
var $0974668e835203eb$export$a241007212c884f6 = /*#__PURE__*/ function(TokenError) {
    "use strict";
    (0, $dcsZi._)(TokenInvalidInstructionProgramError, TokenError);
    var _super = (0, $ohfOJ._)(TokenInvalidInstructionProgramError);
    function TokenInvalidInstructionProgramError() {
        (0, $4GJKx._)(this, TokenInvalidInstructionProgramError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "TokenInvalidInstructionProgramError";
        return _this;
    }
    return TokenInvalidInstructionProgramError;
}($0974668e835203eb$export$ed0b8b496332122d);
var $0974668e835203eb$export$3882cbbd44973a88 = /*#__PURE__*/ function(TokenError) {
    "use strict";
    (0, $dcsZi._)(TokenInvalidInstructionKeysError, TokenError);
    var _super = (0, $ohfOJ._)(TokenInvalidInstructionKeysError);
    function TokenInvalidInstructionKeysError() {
        (0, $4GJKx._)(this, TokenInvalidInstructionKeysError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "TokenInvalidInstructionKeysError";
        return _this;
    }
    return TokenInvalidInstructionKeysError;
}($0974668e835203eb$export$ed0b8b496332122d);
var $0974668e835203eb$export$f96a822f391c3cc4 = /*#__PURE__*/ function(TokenError) {
    "use strict";
    (0, $dcsZi._)(TokenInvalidInstructionDataError, TokenError);
    var _super = (0, $ohfOJ._)(TokenInvalidInstructionDataError);
    function TokenInvalidInstructionDataError() {
        (0, $4GJKx._)(this, TokenInvalidInstructionDataError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "TokenInvalidInstructionDataError";
        return _this;
    }
    return TokenInvalidInstructionDataError;
}($0974668e835203eb$export$ed0b8b496332122d);
var $0974668e835203eb$export$e1301365d704141e = /*#__PURE__*/ function(TokenError) {
    "use strict";
    (0, $dcsZi._)(TokenInvalidInstructionTypeError, TokenError);
    var _super = (0, $ohfOJ._)(TokenInvalidInstructionTypeError);
    function TokenInvalidInstructionTypeError() {
        (0, $4GJKx._)(this, TokenInvalidInstructionTypeError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "TokenInvalidInstructionTypeError";
        return _this;
    }
    return TokenInvalidInstructionTypeError;
}($0974668e835203eb$export$ed0b8b496332122d);
var $0974668e835203eb$export$ff48aa5f01687311 = /*#__PURE__*/ function(TokenError) {
    "use strict";
    (0, $dcsZi._)(TokenUnsupportedInstructionError, TokenError);
    var _super = (0, $ohfOJ._)(TokenUnsupportedInstructionError);
    function TokenUnsupportedInstructionError() {
        (0, $4GJKx._)(this, TokenUnsupportedInstructionError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "TokenUnsupportedInstructionError";
        return _this;
    }
    return TokenUnsupportedInstructionError;
}($0974668e835203eb$export$ed0b8b496332122d);
var $0974668e835203eb$export$f515f489e4a79004 = /*#__PURE__*/ function(TokenError) {
    "use strict";
    (0, $dcsZi._)(TokenTransferHookAccountNotFound, TokenError);
    var _super = (0, $ohfOJ._)(TokenTransferHookAccountNotFound);
    function TokenTransferHookAccountNotFound() {
        (0, $4GJKx._)(this, TokenTransferHookAccountNotFound);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "TokenTransferHookAccountNotFound";
        return _this;
    }
    return TokenTransferHookAccountNotFound;
}($0974668e835203eb$export$ed0b8b496332122d);
var $0974668e835203eb$export$9fe40fd85b8108b = /*#__PURE__*/ function(TokenError) {
    "use strict";
    (0, $dcsZi._)(TokenTransferHookInvalidSeed, TokenError);
    var _super = (0, $ohfOJ._)(TokenTransferHookInvalidSeed);
    function TokenTransferHookInvalidSeed() {
        (0, $4GJKx._)(this, TokenTransferHookInvalidSeed);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "TokenTransferHookInvalidSeed";
        return _this;
    }
    return TokenTransferHookInvalidSeed;
}($0974668e835203eb$export$ed0b8b496332122d);
var $0974668e835203eb$export$de66998ed6d15b14 = /*#__PURE__*/ function(TokenError) {
    "use strict";
    (0, $dcsZi._)(TokenTransferHookAccountDataNotFound, TokenError);
    var _super = (0, $ohfOJ._)(TokenTransferHookAccountDataNotFound);
    function TokenTransferHookAccountDataNotFound() {
        (0, $4GJKx._)(this, TokenTransferHookAccountDataNotFound);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "TokenTransferHookAccountDataNotFound";
        return _this;
    }
    return TokenTransferHookAccountDataNotFound;
}($0974668e835203eb$export$ed0b8b496332122d);


var $8fc768cdbaf2edc7$export$b8ca5fa4899cbfc7;
(function(AccountType) {
    AccountType[AccountType["Uninitialized"] = 0] = "Uninitialized";
    AccountType[AccountType["Mint"] = 1] = "Mint";
    AccountType[AccountType["Account"] = 2] = "Account";
})($8fc768cdbaf2edc7$export$b8ca5fa4899cbfc7 || ($8fc768cdbaf2edc7$export$b8ca5fa4899cbfc7 = {}));
var $8fc768cdbaf2edc7$export$9d3ac77dcbf22b3f = 1;



var $cv9Rk = parcelRequire("cv9Rk");

var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $jt90m = parcelRequire("jt90m");






var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $eha6O = parcelRequire("eha6O");

var $jt90m = parcelRequire("jt90m");



var $c6dd9d2caa8bf3a6$export$c23cd279ce124ca0 = (0, $jt90m.struct)([
    (0, $jt90m.u8)("m"),
    (0, $jt90m.u8)("n"),
    (0, $41e55d51244b5d43$export$87b259aa03e3d267)("isInitialized"),
    (0, $3285baf77b253a0b$export$86f13247979de5d7)("signer1"),
    (0, $3285baf77b253a0b$export$86f13247979de5d7)("signer2"),
    (0, $3285baf77b253a0b$export$86f13247979de5d7)("signer3"),
    (0, $3285baf77b253a0b$export$86f13247979de5d7)("signer4"),
    (0, $3285baf77b253a0b$export$86f13247979de5d7)("signer5"),
    (0, $3285baf77b253a0b$export$86f13247979de5d7)("signer6"),
    (0, $3285baf77b253a0b$export$86f13247979de5d7)("signer7"),
    (0, $3285baf77b253a0b$export$86f13247979de5d7)("signer8"),
    (0, $3285baf77b253a0b$export$86f13247979de5d7)("signer9"),
    (0, $3285baf77b253a0b$export$86f13247979de5d7)("signer10"),
    (0, $3285baf77b253a0b$export$86f13247979de5d7)("signer11")
]);
var $c6dd9d2caa8bf3a6$export$c2abf71f91a1605b = $c6dd9d2caa8bf3a6$export$c23cd279ce124ca0.span;
function $c6dd9d2caa8bf3a6$export$257dfa65916d8d24(connection, address, commitment) {
    return $c6dd9d2caa8bf3a6$var$_getMultisig.apply(this, arguments);
}
function $c6dd9d2caa8bf3a6$var$_getMultisig() {
    $c6dd9d2caa8bf3a6$var$_getMultisig = (0, $kSuI9._)(function(connection, address, commitment) {
        var programId, info;
        var _arguments = arguments;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    programId = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : (0, $a44c7142cfb07f27$export$79de3e3c2b1ca801);
                    return [
                        4,
                        connection.getAccountInfo(address, commitment)
                    ];
                case 1:
                    info = _state.sent();
                    return [
                        2,
                        $c6dd9d2caa8bf3a6$export$2620f4d387573ced(address, info, programId)
                    ];
            }
        });
    });
    return $c6dd9d2caa8bf3a6$var$_getMultisig.apply(this, arguments);
}
function $c6dd9d2caa8bf3a6$export$2620f4d387573ced(address, info) {
    var programId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $a44c7142cfb07f27$export$79de3e3c2b1ca801);
    if (!info) throw new (0, $0974668e835203eb$export$a09a5e48de2f3404)();
    if (!info.owner.equals(programId)) throw new (0, $0974668e835203eb$export$abb470453474d51)();
    if (info.data.length != $c6dd9d2caa8bf3a6$export$c2abf71f91a1605b) throw new (0, $0974668e835203eb$export$250d31de4ddb7ca5)();
    var multisig = $c6dd9d2caa8bf3a6$export$c23cd279ce124ca0.decode(info.data);
    return (0, $do9pw._)({
        address: address
    }, multisig);
}
function $c6dd9d2caa8bf3a6$export$cd6dc5245600da53(connection, commitment) {
    return $c6dd9d2caa8bf3a6$var$_getMinimumBalanceForRentExemptMultisig.apply(this, arguments);
}
function $c6dd9d2caa8bf3a6$var$_getMinimumBalanceForRentExemptMultisig() {
    $c6dd9d2caa8bf3a6$var$_getMinimumBalanceForRentExemptMultisig = (0, $kSuI9._)(function(connection, commitment) {
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        connection.getMinimumBalanceForRentExemption($c6dd9d2caa8bf3a6$export$c2abf71f91a1605b, commitment)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return $c6dd9d2caa8bf3a6$var$_getMinimumBalanceForRentExemptMultisig.apply(this, arguments);
}



var $8dlmd = parcelRequire("8dlmd");
var $1182e7f995928e51$require$Buffer = $8dlmd.Buffer;
var $1182e7f995928e51$export$70504fba2ce56d52;
(function(AccountState) {
    AccountState[AccountState["Uninitialized"] = 0] = "Uninitialized";
    AccountState[AccountState["Initialized"] = 1] = "Initialized";
    AccountState[AccountState["Frozen"] = 2] = "Frozen";
})($1182e7f995928e51$export$70504fba2ce56d52 || ($1182e7f995928e51$export$70504fba2ce56d52 = {}));
var $1182e7f995928e51$export$cab31ec27f6c5fa = (0, $jt90m.struct)([
    (0, $3285baf77b253a0b$export$86f13247979de5d7)("mint"),
    (0, $3285baf77b253a0b$export$86f13247979de5d7)("owner"),
    (0, $59bc11fd00a6333b$export$cd1442401e54cffa)("amount"),
    (0, $jt90m.u32)("delegateOption"),
    (0, $3285baf77b253a0b$export$86f13247979de5d7)("delegate"),
    (0, $jt90m.u8)("state"),
    (0, $jt90m.u32)("isNativeOption"),
    (0, $59bc11fd00a6333b$export$cd1442401e54cffa)("isNative"),
    (0, $59bc11fd00a6333b$export$cd1442401e54cffa)("delegatedAmount"),
    (0, $jt90m.u32)("closeAuthorityOption"),
    (0, $3285baf77b253a0b$export$86f13247979de5d7)("closeAuthority")
]);
var $1182e7f995928e51$export$66ab21ef808e9dc6 = $1182e7f995928e51$export$cab31ec27f6c5fa.span;
function $1182e7f995928e51$export$4f9234baf34abd0(connection, address, commitment) {
    return $1182e7f995928e51$var$_getAccount.apply(this, arguments);
}
function $1182e7f995928e51$var$_getAccount() {
    $1182e7f995928e51$var$_getAccount = (0, $kSuI9._)(function(connection, address, commitment) {
        var programId, info;
        var _arguments = arguments;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    programId = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : (0, $a44c7142cfb07f27$export$79de3e3c2b1ca801);
                    return [
                        4,
                        connection.getAccountInfo(address, commitment)
                    ];
                case 1:
                    info = _state.sent();
                    return [
                        2,
                        $1182e7f995928e51$export$776350edf20ed1cc(address, info, programId)
                    ];
            }
        });
    });
    return $1182e7f995928e51$var$_getAccount.apply(this, arguments);
}
function $1182e7f995928e51$export$7ecda0587e867ff2(connection, addresses, commitment) {
    return $1182e7f995928e51$var$_getMultipleAccounts.apply(this, arguments);
}
function $1182e7f995928e51$var$_getMultipleAccounts() {
    $1182e7f995928e51$var$_getMultipleAccounts = (0, $kSuI9._)(function(connection, addresses, commitment) {
        var programId, infos;
        var _arguments = arguments;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    programId = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : (0, $a44c7142cfb07f27$export$79de3e3c2b1ca801);
                    return [
                        4,
                        connection.getMultipleAccountsInfo(addresses, commitment)
                    ];
                case 1:
                    infos = _state.sent();
                    return [
                        2,
                        addresses.map(function(address, i) {
                            return $1182e7f995928e51$export$776350edf20ed1cc(address, infos[i], programId);
                        })
                    ];
            }
        });
    });
    return $1182e7f995928e51$var$_getMultipleAccounts.apply(this, arguments);
}
function $1182e7f995928e51$export$22f9b1d0cdd74bb0(connection, commitment) {
    return $1182e7f995928e51$var$_getMinimumBalanceForRentExemptAccount.apply(this, arguments);
}
function $1182e7f995928e51$var$_getMinimumBalanceForRentExemptAccount() {
    $1182e7f995928e51$var$_getMinimumBalanceForRentExemptAccount = (0, $kSuI9._)(function(connection, commitment) {
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $1182e7f995928e51$export$e650be7f0aa49cb4(connection, [], commitment)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return $1182e7f995928e51$var$_getMinimumBalanceForRentExemptAccount.apply(this, arguments);
}
function $1182e7f995928e51$export$e650be7f0aa49cb4(connection, extensions, commitment) {
    return $1182e7f995928e51$var$_getMinimumBalanceForRentExemptAccountWithExtensions.apply(this, arguments);
}
function $1182e7f995928e51$var$_getMinimumBalanceForRentExemptAccountWithExtensions() {
    $1182e7f995928e51$var$_getMinimumBalanceForRentExemptAccountWithExtensions = (0, $kSuI9._)(function(connection, extensions, commitment) {
        var accountLen;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    accountLen = (0, $8a9fbac74071e86b$export$37c8c863c6dd42a9)(extensions);
                    return [
                        4,
                        connection.getMinimumBalanceForRentExemption(accountLen, commitment)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return $1182e7f995928e51$var$_getMinimumBalanceForRentExemptAccountWithExtensions.apply(this, arguments);
}
function $1182e7f995928e51$export$776350edf20ed1cc(address, info) {
    var programId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $a44c7142cfb07f27$export$79de3e3c2b1ca801);
    if (!info) throw new (0, $0974668e835203eb$export$a09a5e48de2f3404)();
    if (!info.owner.equals(programId)) throw new (0, $0974668e835203eb$export$abb470453474d51)();
    if (info.data.length < $1182e7f995928e51$export$66ab21ef808e9dc6) throw new (0, $0974668e835203eb$export$250d31de4ddb7ca5)();
    var rawAccount = $1182e7f995928e51$export$cab31ec27f6c5fa.decode(info.data.slice(0, $1182e7f995928e51$export$66ab21ef808e9dc6));
    var tlvData = $1182e7f995928e51$require$Buffer.alloc(0);
    if (info.data.length > $1182e7f995928e51$export$66ab21ef808e9dc6) {
        if (info.data.length === (0, $c6dd9d2caa8bf3a6$export$c2abf71f91a1605b)) throw new (0, $0974668e835203eb$export$250d31de4ddb7ca5)();
        if (info.data[$1182e7f995928e51$export$66ab21ef808e9dc6] != (0, $8fc768cdbaf2edc7$export$b8ca5fa4899cbfc7).Account) throw new (0, $0974668e835203eb$export$f4938317c78e324f)();
        tlvData = info.data.slice($1182e7f995928e51$export$66ab21ef808e9dc6 + (0, $8fc768cdbaf2edc7$export$9d3ac77dcbf22b3f));
    }
    return {
        address: address,
        mint: rawAccount.mint,
        owner: rawAccount.owner,
        amount: rawAccount.amount,
        delegate: rawAccount.delegateOption ? rawAccount.delegate : null,
        delegatedAmount: rawAccount.delegatedAmount,
        isInitialized: rawAccount.state !== $1182e7f995928e51$export$70504fba2ce56d52.Uninitialized,
        isFrozen: rawAccount.state === $1182e7f995928e51$export$70504fba2ce56d52.Frozen,
        isNative: !!rawAccount.isNativeOption,
        rentExemptReserve: rawAccount.isNativeOption ? rawAccount.isNative : null,
        closeAuthority: rawAccount.closeAuthorityOption ? rawAccount.closeAuthority : null,
        tlvData: tlvData
    };
}






var $jt90m = parcelRequire("jt90m");


var $fa490ba71e0f66c6$export$f70216558c70b1a0 = (0, $jt90m.struct)([
    (0, $41e55d51244b5d43$export$87b259aa03e3d267)("lockCpi")
]);
var $fa490ba71e0f66c6$export$2ad51e83460d1d03 = $fa490ba71e0f66c6$export$f70216558c70b1a0.span;
function $fa490ba71e0f66c6$export$1f414ebe518a07c3(account) {
    var extensionData = (0, $8a9fbac74071e86b$export$4fff3ed4eba4f4ee)((0, $8a9fbac74071e86b$export$4f037c6ec2da4eeb).CpiGuard, account.tlvData);
    if (extensionData !== null) return $fa490ba71e0f66c6$export$f70216558c70b1a0.decode(extensionData);
    else return null;
}



var $jt90m = parcelRequire("jt90m");

var $206dc1d272be8f5d$export$e8ecc3a3060edae5 = (0, $jt90m.struct)([
    (0, $jt90m.u8)("state")
]);
var $206dc1d272be8f5d$export$2e3c876eadfda1ab = $206dc1d272be8f5d$export$e8ecc3a3060edae5.span;
function $206dc1d272be8f5d$export$d7b87bbf5a44c34c(mint) {
    var extensionData = (0, $8a9fbac74071e86b$export$4fff3ed4eba4f4ee)((0, $8a9fbac74071e86b$export$4f037c6ec2da4eeb).DefaultAccountState, mint.tlvData);
    if (extensionData !== null) return $206dc1d272be8f5d$export$e8ecc3a3060edae5.decode(extensionData);
    else return null;
}



var $69N5M = parcelRequire("69N5M");

var $3sHb8 = parcelRequire("3sHb8");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $cv9Rk = parcelRequire("cv9Rk");
// src/codes.ts

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $3sHb8 = parcelRequire("3sHb8");

var $dcsZi = parcelRequire("dcsZi");

var $do9pw = parcelRequire("do9pw");

var $dRLPW = parcelRequire("dRLPW");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $l0HdX = parcelRequire("l0HdX");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");
var $c88b1e140ef0fdf7$export$637a712014b81b9c = 1;
var $c88b1e140ef0fdf7$export$2b45309b0547a9c4 = 2;
var $c88b1e140ef0fdf7$export$7cf14cde1226b7cb = 3;
var $c88b1e140ef0fdf7$export$6ad19ea5e363a944 = 4;
var $c88b1e140ef0fdf7$export$c37fe345cc9b38e7 = 5;
var $c88b1e140ef0fdf7$export$cf7b28c4ea07497b = 6;
var $c88b1e140ef0fdf7$export$e8ff0c73a3d6800d = 7;
var $c88b1e140ef0fdf7$export$7dd7d17f1f93a166 = 8;
var $c88b1e140ef0fdf7$export$8b23617676679e2d = 9;
var $c88b1e140ef0fdf7$export$e09e3905081e44fe = -32700;
var $c88b1e140ef0fdf7$export$afa40fd3fc01204 = -32603;
var $c88b1e140ef0fdf7$export$2981978a530b1a7c = -32602;
var $c88b1e140ef0fdf7$export$5ec955cc8b7e8cf9 = -32601;
var $c88b1e140ef0fdf7$export$23cb4efd59427895 = -32600;
var $c88b1e140ef0fdf7$export$4f93db3d1b48599e = -32016;
var $c88b1e140ef0fdf7$export$f7685139153f9191 = -32015;
var $c88b1e140ef0fdf7$export$65235469ebe9845e = -32014;
var $c88b1e140ef0fdf7$export$bdeebdca616ef1f3 = -32013;
var $c88b1e140ef0fdf7$export$1b90c411626421b1 = -32012;
var $c88b1e140ef0fdf7$export$8e678bf9b4e5cb64 = -32011;
var $c88b1e140ef0fdf7$export$54dea2286c43ec1e = -32010;
var $c88b1e140ef0fdf7$export$e71fbee92648fc61 = -32009;
var $c88b1e140ef0fdf7$export$eb4f7515ff6aa19d = -32008;
var $c88b1e140ef0fdf7$export$d21075fd06730e = -32007;
var $c88b1e140ef0fdf7$export$d964b43bb02eacdf = -32006;
var $c88b1e140ef0fdf7$export$6bad0f4fb625ae6e = -32005;
var $c88b1e140ef0fdf7$export$bfbf8b75e865efa0 = -32004;
var $c88b1e140ef0fdf7$export$83dce8c0aef70463 = -32003;
var $c88b1e140ef0fdf7$export$426cc73f5ad00f38 = -32002;
var $c88b1e140ef0fdf7$export$6ae475e85fe02aad = -32001;
var $c88b1e140ef0fdf7$export$fe284a92110eab86 = 28e5;
var $c88b1e140ef0fdf7$export$8aae3518bf4ea38c = 2800001;
var $c88b1e140ef0fdf7$export$e31a90a3bf6aebaa = 2800002;
var $c88b1e140ef0fdf7$export$adaec66b544981e7 = 2800003;
var $c88b1e140ef0fdf7$export$523a769cce7318bf = 2800004;
var $c88b1e140ef0fdf7$export$68473acf744cabf5 = 2800005;
var $c88b1e140ef0fdf7$export$940d17d3b63dba7c = 2800006;
var $c88b1e140ef0fdf7$export$a1cf857da540ee2e = 2800007;
var $c88b1e140ef0fdf7$export$30501b98da9564bb = 2800008;
var $c88b1e140ef0fdf7$export$123d01dd469dc2ef = 2800009;
var $c88b1e140ef0fdf7$export$2a7684440f52314e = 2800010;
var $c88b1e140ef0fdf7$export$8f39956700e64760 = 323e4;
var $c88b1e140ef0fdf7$export$1239089c4564c858 = 32300001;
var $c88b1e140ef0fdf7$export$afc08ee11abbc257 = 3230002;
var $c88b1e140ef0fdf7$export$57836d13a84f54b0 = 3230003;
var $c88b1e140ef0fdf7$export$f080cd056a56cd54 = 3230004;
var $c88b1e140ef0fdf7$export$f2bbb3c14e29977e = 361e4;
var $c88b1e140ef0fdf7$export$f18173f573d8bb21 = 3610001;
var $c88b1e140ef0fdf7$export$7ad09900bd645a86 = 3610002;
var $c88b1e140ef0fdf7$export$69c08c51e1841f29 = 3610003;
var $c88b1e140ef0fdf7$export$325dad4e0a6bd514 = 3610004;
var $c88b1e140ef0fdf7$export$242c341c7c464bee = 3610005;
var $c88b1e140ef0fdf7$export$a73c064bb32a7c36 = 3610006;
var $c88b1e140ef0fdf7$export$bc2b26beee0f9a0b = 3611e3;
var $c88b1e140ef0fdf7$export$bc1242deaa4d848d = 3704e3;
var $c88b1e140ef0fdf7$export$44352af09ecae39f = 3704001;
var $c88b1e140ef0fdf7$export$d2a0e93e506be463 = 3704002;
var $c88b1e140ef0fdf7$export$bbe4ed5687bc7f55 = 3704003;
var $c88b1e140ef0fdf7$export$436df06ce5af77b3 = 3704004;
var $c88b1e140ef0fdf7$export$552eeff1216c4a1e = 4128e3;
var $c88b1e140ef0fdf7$export$b260fc8c8d3cde52 = 4128001;
var $c88b1e140ef0fdf7$export$b81e507604713b9b = 4128002;
var $c88b1e140ef0fdf7$export$d308cb6df5c28ff6 = 4615e3;
var $c88b1e140ef0fdf7$export$ab2273c84ffc5d61 = 4615001;
var $c88b1e140ef0fdf7$export$23cc359156888c7f = 4615002;
var $c88b1e140ef0fdf7$export$a4193356408e9ff0 = 4615003;
var $c88b1e140ef0fdf7$export$f9ae264f831e3bcf = 4615004;
var $c88b1e140ef0fdf7$export$e170b44d99a3d17c = 4615005;
var $c88b1e140ef0fdf7$export$84ec8e94b54ae7d2 = 4615006;
var $c88b1e140ef0fdf7$export$4063fe8d5aed84a5 = 4615007;
var $c88b1e140ef0fdf7$export$ecdd3388f6a493b1 = 4615008;
var $c88b1e140ef0fdf7$export$df0a6d6cbb0d96a1 = 4615009;
var $c88b1e140ef0fdf7$export$e45bdcd5a97f01d1 = 4615010;
var $c88b1e140ef0fdf7$export$c2bfe7e903a0febb = 4615011;
var $c88b1e140ef0fdf7$export$fa2d8ac69bd6117e = 4615012;
var $c88b1e140ef0fdf7$export$2b7e7e6bd3d5b8c4 = 4615013;
var $c88b1e140ef0fdf7$export$72e64aed285de589 = 4615014;
var $c88b1e140ef0fdf7$export$95d7c72146ee65c6 = 4615015;
var $c88b1e140ef0fdf7$export$aa03f185732dc00b = 4615016;
var $c88b1e140ef0fdf7$export$c390f45549d7336b = 4615017;
var $c88b1e140ef0fdf7$export$2ea2f2f9a9e26449 = 4615018;
var $c88b1e140ef0fdf7$export$c9ece88629d0d2d8 = 4615019;
var $c88b1e140ef0fdf7$export$2f331454431511bf = 4615020;
var $c88b1e140ef0fdf7$export$3c4b9377ed4116a0 = 4615021;
var $c88b1e140ef0fdf7$export$211b990ef3bd19ce = 4615022;
var $c88b1e140ef0fdf7$export$ef486e0fcc8262b = 4615023;
var $c88b1e140ef0fdf7$export$afcb9eeb4bf056b5 = 4615024;
var $c88b1e140ef0fdf7$export$4db39a3a67e51db2 = 4615025;
var $c88b1e140ef0fdf7$export$5abe2d1d040bf6cf = 4615026;
var $c88b1e140ef0fdf7$export$35a7a209cf9aaee8 = 4615027;
var $c88b1e140ef0fdf7$export$203fce7ce63eb278 = 4615028;
var $c88b1e140ef0fdf7$export$c65d87b69a4b86e5 = 4615029;
var $c88b1e140ef0fdf7$export$d13686e596713674 = 4615030;
var $c88b1e140ef0fdf7$export$a070310f29fe959b = 4615031;
var $c88b1e140ef0fdf7$export$8eb8ce58a8afa4d8 = 4615032;
var $c88b1e140ef0fdf7$export$1224afa7bd705d3d = 4615033;
var $c88b1e140ef0fdf7$export$547fdb4fff65c547 = 4615034;
var $c88b1e140ef0fdf7$export$cbeea52e947eb081 = 4615035;
var $c88b1e140ef0fdf7$export$fd7a98f0746b6c8a = 4615036;
var $c88b1e140ef0fdf7$export$8e6d399c8fb88eaa = 4615037;
var $c88b1e140ef0fdf7$export$2c001ce75e66180d = 4615038;
var $c88b1e140ef0fdf7$export$ec7d592dad68aa12 = 4615039;
var $c88b1e140ef0fdf7$export$8815da3ec592d05a = 4615040;
var $c88b1e140ef0fdf7$export$b1b9bf899899a525 = 4615041;
var $c88b1e140ef0fdf7$export$67715a67add5645f = 4615042;
var $c88b1e140ef0fdf7$export$e343a153899b82e9 = 4615043;
var $c88b1e140ef0fdf7$export$2199fb95c7d85b85 = 4615044;
var $c88b1e140ef0fdf7$export$57c1675a0c20931f = 4615045;
var $c88b1e140ef0fdf7$export$9e62f446da191370 = 4615046;
var $c88b1e140ef0fdf7$export$b5ccaf975fe486a0 = 4615047;
var $c88b1e140ef0fdf7$export$4d39d4c2f04b41a8 = 4615048;
var $c88b1e140ef0fdf7$export$1997554dc67e9c4e = 4615049;
var $c88b1e140ef0fdf7$export$8a65209e9cece2cd = 4615050;
var $c88b1e140ef0fdf7$export$6b675123aa59300c = 4615051;
var $c88b1e140ef0fdf7$export$70b4e2dd1496c5a3 = 4615052;
var $c88b1e140ef0fdf7$export$43d5111034db211a = 4615053;
var $c88b1e140ef0fdf7$export$8aebe3e76f515046 = 4615054;
var $c88b1e140ef0fdf7$export$ee84b29a9985e516 = 5508e3;
var $c88b1e140ef0fdf7$export$9998b265c986beaa = 5508001;
var $c88b1e140ef0fdf7$export$dd792e9d67cd031b = 5508002;
var $c88b1e140ef0fdf7$export$14d32fbdad2233cd = 5508003;
var $c88b1e140ef0fdf7$export$8c6fc1cfcec8440c = 5508004;
var $c88b1e140ef0fdf7$export$dcec7171cff295d1 = 5508005;
var $c88b1e140ef0fdf7$export$200acbfc722e322b = 5508006;
var $c88b1e140ef0fdf7$export$4c96d9a95880ae4b = 5508007;
var $c88b1e140ef0fdf7$export$bba76b21ada319a5 = 5508008;
var $c88b1e140ef0fdf7$export$3cb3b480d2bfdacc = 5508009;
var $c88b1e140ef0fdf7$export$1f5fbaa83776feec = 5508010;
var $c88b1e140ef0fdf7$export$1d51c4c8b2c49e09 = 5508011;
var $c88b1e140ef0fdf7$export$694fd435994bcca = 5663e3;
var $c88b1e140ef0fdf7$export$707576ec00ca24d6 = 5663001;
var $c88b1e140ef0fdf7$export$e33d07a7526bded0 = 5663002;
var $c88b1e140ef0fdf7$export$a20747f749dd4515 = 5663003;
var $c88b1e140ef0fdf7$export$3963d9bca4091810 = 5663004;
var $c88b1e140ef0fdf7$export$b34a16b8adbffdc1 = 5663005;
var $c88b1e140ef0fdf7$export$3764bbcfb0679211 = 5663006;
var $c88b1e140ef0fdf7$export$ed2bdee7953e467f = 5663007;
var $c88b1e140ef0fdf7$export$11bea4440904349c = 5663008;
var $c88b1e140ef0fdf7$export$6d61b980429516bd = 5663009;
var $c88b1e140ef0fdf7$export$819b1b0603d2a966 = 5663010;
var $c88b1e140ef0fdf7$export$592862d1b11e32ac = 5663011;
var $c88b1e140ef0fdf7$export$242af5597d94abaf = 5663012;
var $c88b1e140ef0fdf7$export$802b3ebe5297e360 = 5663013;
var $c88b1e140ef0fdf7$export$bed6f92dafea0623 = 5663014;
var $c88b1e140ef0fdf7$export$36c2547c3c4d823f = 5663015;
var $c88b1e140ef0fdf7$export$de92784c954d1b84 = 5663016;
var $c88b1e140ef0fdf7$export$b55a3eb3d894ad9f = 5663017;
var $c88b1e140ef0fdf7$export$4e4582c633fc423e = 5663018;
var $c88b1e140ef0fdf7$export$8c82dde5b12c9789 = 705e4;
var $c88b1e140ef0fdf7$export$a746609ecc2f6acf = 7050001;
var $c88b1e140ef0fdf7$export$c4d8217d3eb3eaf8 = 7050002;
var $c88b1e140ef0fdf7$export$5d0f06cd8bc8e3af = 7050003;
var $c88b1e140ef0fdf7$export$83c8fe2717d1b271 = 7050004;
var $c88b1e140ef0fdf7$export$39ead28cf48a604c = 7050005;
var $c88b1e140ef0fdf7$export$624f65633216eb57 = 7050006;
var $c88b1e140ef0fdf7$export$2bbd9403cb117ea7 = 7050007;
var $c88b1e140ef0fdf7$export$e108dd5343c4c11 = 7050008;
var $c88b1e140ef0fdf7$export$a504ed6cab09ce4a = 7050009;
var $c88b1e140ef0fdf7$export$8c1ae05eccc11ef9 = 7050010;
var $c88b1e140ef0fdf7$export$47df44101c6f04b0 = 7050011;
var $c88b1e140ef0fdf7$export$89ae0c424691fbcb = 7050012;
var $c88b1e140ef0fdf7$export$bea5f92951bc42e7 = 7050013;
var $c88b1e140ef0fdf7$export$91a668e132084ecf = 7050014;
var $c88b1e140ef0fdf7$export$211b9b84186690f0 = 7050015;
var $c88b1e140ef0fdf7$export$291ea8d5a7496fde = 7050016;
var $c88b1e140ef0fdf7$export$5f027a86397cba92 = 7050017;
var $c88b1e140ef0fdf7$export$58bf90c73afbc02e = 7050018;
var $c88b1e140ef0fdf7$export$b8b2610c9a910763 = 7050019;
var $c88b1e140ef0fdf7$export$fb693aebffa32676 = 7050020;
var $c88b1e140ef0fdf7$export$572954173bc64b66 = 7050021;
var $c88b1e140ef0fdf7$export$fa9a13f1b40ee2fb = 7050022;
var $c88b1e140ef0fdf7$export$95c94f6ea500f1ab = 7050023;
var $c88b1e140ef0fdf7$export$11d69fb6993b2cf5 = 7050024;
var $c88b1e140ef0fdf7$export$bd54a9a85614b3a7 = 7050025;
var $c88b1e140ef0fdf7$export$df4ef1824fd194a3 = 7050026;
var $c88b1e140ef0fdf7$export$2725d50dd432fb3a = 7050027;
var $c88b1e140ef0fdf7$export$41f13726b04d8d05 = 7050028;
var $c88b1e140ef0fdf7$export$7b4a7eebff68ca7b = 7050029;
var $c88b1e140ef0fdf7$export$e3a4007020a2e8f5 = 7050030;
var $c88b1e140ef0fdf7$export$2ecc275dffbc087c = 7050031;
var $c88b1e140ef0fdf7$export$e3289c5954208202 = 7050032;
var $c88b1e140ef0fdf7$export$3569c6c71e349538 = 7050033;
var $c88b1e140ef0fdf7$export$4f413e02d5e82221 = 7050034;
var $c88b1e140ef0fdf7$export$1cd0de5dfcdeb99d = 7050035;
var $c88b1e140ef0fdf7$export$87e01307d368f511 = 7050036;
var $c88b1e140ef0fdf7$export$9c9326ce1e3df40c = 8078e3;
var $c88b1e140ef0fdf7$export$18fbf24f19efc69b = 8078001;
var $c88b1e140ef0fdf7$export$93561b31b951410d = 8078002;
var $c88b1e140ef0fdf7$export$3417da5bc6bcb45 = 8078003;
var $c88b1e140ef0fdf7$export$c4c73ab3c0833591 = 8078004;
var $c88b1e140ef0fdf7$export$824d79ab1779d517 = 8078005;
var $c88b1e140ef0fdf7$export$c464f3b291f1f3d0 = 8078006;
var $c88b1e140ef0fdf7$export$c04710d31ef4d278 = 8078007;
var $c88b1e140ef0fdf7$export$1fa107ead8489cf2 = 8078008;
var $c88b1e140ef0fdf7$export$2bb0703affb8fe68 = 8078009;
var $c88b1e140ef0fdf7$export$f6bf8a7c1f3defe4 = 8078010;
var $c88b1e140ef0fdf7$export$8653c145864f47f4 = 8078011;
var $c88b1e140ef0fdf7$export$89b582b06852d433 = 8078012;
var $c88b1e140ef0fdf7$export$4c1fcb4bd20b2951 = 8078013;
var $c88b1e140ef0fdf7$export$a617dff403944ec6 = 8078014;
var $c88b1e140ef0fdf7$export$c89f43f0d783cd50 = 8078015;
var $c88b1e140ef0fdf7$export$f73fb8ecbd4b2395 = 8078016;
var $c88b1e140ef0fdf7$export$efbd199de191d2aa = 8078017;
var $c88b1e140ef0fdf7$export$cb77f5a0f0fa7f18 = 8078018;
var $c88b1e140ef0fdf7$export$47278510a511031b = 8078019;
var $c88b1e140ef0fdf7$export$a9282ed13660c9f6 = 8078020;
var $c88b1e140ef0fdf7$export$5bdfee6423bc35ce = 8078021;
var $c88b1e140ef0fdf7$export$a2e9526594022372 = 8078022;
var $c88b1e140ef0fdf7$export$ef742b7036fb9005 = 81e5;
var $c88b1e140ef0fdf7$export$2a2f0f75708d1697 = 8100001;
var $c88b1e140ef0fdf7$export$7f6822f75edb8f41 = 8100002;
var $c88b1e140ef0fdf7$export$c2b279d002edb7ec = 819e4;
var $c88b1e140ef0fdf7$export$e1a3658b043aad8e = 8190001;
var $c88b1e140ef0fdf7$export$70877b3524829eb0 = 8190002;
var $c88b1e140ef0fdf7$export$d017b741c4452673 = 8190003;
var $c88b1e140ef0fdf7$export$b1b380d4068eeb8f = 8190004;
var $c88b1e140ef0fdf7$export$ecb673640304655c = 99e5;
var $c88b1e140ef0fdf7$export$bd3f60d945c38448 = 9900001;
var $c88b1e140ef0fdf7$export$b57ffff6ec11f63 = 9900002;
var $c88b1e140ef0fdf7$export$6fe73388375373f = 9900003;
// src/context.ts
function $c88b1e140ef0fdf7$var$encodeValue(value) {
    if (Array.isArray(value)) {
        var commaSeparatedValues = value.map($c88b1e140ef0fdf7$var$encodeValue).join("%2C%20");
        return "%5B" + commaSeparatedValues + /* "]" */ "%5D";
    } else if ((typeof value === "undefined" ? "undefined" : (0, $l0HdX._)(value)) === "bigint") return "".concat(value, "n");
    else return encodeURIComponent(String(value != null && Object.getPrototypeOf(value) === null ? // Plain objects with no prototype don't have a `toString` method.
    // Convert them before stringifying them.
    (0, $do9pw._)({}, value) : value));
}
function $c88b1e140ef0fdf7$var$encodeObjectContextEntry(param) {
    var _param = (0, $cv9Rk._)(param, 2), key = _param[0], value = _param[1];
    return "".concat(key, "=").concat($c88b1e140ef0fdf7$var$encodeValue(value));
}
function $c88b1e140ef0fdf7$var$encodeContextObject(context) {
    var searchParamsString = Object.entries(context).map($c88b1e140ef0fdf7$var$encodeObjectContextEntry).join("&");
    return btoa(searchParamsString);
}
var $c88b1e140ef0fdf7$var$_obj;
// src/messages.ts
var $c88b1e140ef0fdf7$var$SolanaErrorMessages = ($c88b1e140ef0fdf7$var$_obj = {}, (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$8f39956700e64760, "Account not found at address: $address"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$f080cd056a56cd54, "Not all accounts were decoded. Encoded accounts found at addresses: $addresses."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$57836d13a84f54b0, "Expected decoded account at address: $address"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$afc08ee11abbc257, "Failed to decode account data at address: $address"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$1239089c4564c858, "Accounts not found at addresses: $addresses"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$123d01dd469dc2ef, "Unable to find a viable program address bump seed."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$e31a90a3bf6aebaa, "$putativeAddress is not a base58-encoded address."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$fe284a92110eab86, "Expected base58 encoded address to decode to a byte array of length 32. Actual length: $actualLength."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$adaec66b544981e7, "The `CryptoKey` must be an `Ed25519` public key."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$30501b98da9564bb, "Invalid seeds; point must fall off the Ed25519 curve."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$523a769cce7318bf, "Expected given program derived address to have the following format: [Address, ProgramDerivedAddressBump]."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$940d17d3b63dba7c, "A maximum of $maxSeeds seeds, including the bump seed, may be supplied when creating an address. Received: $actual."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$a1cf857da540ee2e, "The seed at index $index with length $actual exceeds the maximum length of $maxSeedLength bytes."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$68473acf744cabf5, "Expected program derived address bump to be in the range [0, 255], got: $bump."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$2a7684440f52314e, "Program address cannot end with PDA marker."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$8aae3518bf4ea38c, "Expected base58-encoded address string of length in the range [32, 44]. Actual length: $actualLength."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$6ad19ea5e363a944, "Expected base58-encoded blockash string of length in the range [32, 44]. Actual length: $actualLength."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$637a712014b81b9c, "The network has progressed past the last block for which this transaction could have been committed."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$9c9326ce1e3df40c, "Codec [$codecDescription] cannot decode empty byte arrays."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$a2e9526594022372, "Enum codec cannot use lexical values [$stringValues] as discriminators. Either remove all lexical values or set `useValuesAsDiscriminators` to `false`."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$a9282ed13660c9f6, "Sentinel [$hexSentinel] must not be present in encoded bytes [$hexEncodedBytes]."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$824d79ab1779d517, "Encoder and decoder must have the same fixed size, got [$encoderFixedSize] and [$decoderFixedSize]."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$c464f3b291f1f3d0, "Encoder and decoder must have the same max size, got [$encoderMaxSize] and [$decoderMaxSize]."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$c4c73ab3c0833591, "Encoder and decoder must either both be fixed-size or variable-size."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$1fa107ead8489cf2, "Enum discriminator out of range. Expected a number in [$formattedValidDiscriminators], got $discriminator."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$93561b31b951410d, "Expected a fixed-size codec, got a variable-size one."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$4c1fcb4bd20b2951, "Codec [$codecDescription] expected a positive byte length, got $bytesLength."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$3417da5bc6bcb45, "Expected a variable-size codec, got a fixed-size one."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$47278510a511031b, "Codec [$codecDescription] expected zero-value [$hexZeroValue] to have the same size as the provided fixed-size item [$expectedSize bytes]."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$18fbf24f19efc69b, "Codec [$codecDescription] expected $expected bytes, got $bytesLength."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$cb77f5a0f0fa7f18, "Expected byte array constant [$hexConstant] to be present in data [$hexData] at offset [$offset]."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$2bb0703affb8fe68, "Invalid discriminated union variant. Expected one of [$variants], got $value."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$f6bf8a7c1f3defe4, "Invalid enum variant. Expected one of [$stringValues] or a number in [$formattedNumericalValues], got $variant."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$c89f43f0d783cd50, "Invalid literal union variant. Expected one of [$variants], got $value."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$c04710d31ef4d278, "Expected [$codecDescription] to have $expected items, got $actual."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$89b582b06852d433, "Invalid value $value for base $base with alphabet $alphabet."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$f73fb8ecbd4b2395, "Literal union discriminator out of range. Expected a number between $minRange and $maxRange, got $discriminator."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$8653c145864f47f4, "Codec [$codecDescription] expected number to be in the range [$min, $max], got $value."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$a617dff403944ec6, "Codec [$codecDescription] expected offset to be in the range [0, $bytesLength], got $offset."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$5bdfee6423bc35ce, "Expected sentinel [$hexSentinel] to be present in decoded bytes [$hexDecodedBytes]."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$efbd199de191d2aa, "Union variant out of range. Expected an index between $minRange and $maxRange, got $variant."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$bc2b26beee0f9a0b, "No random values implementation could be found."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$df0a6d6cbb0d96a1, "instruction requires an uninitialized account"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$ef486e0fcc8262b, "instruction tries to borrow reference for an account which is already borrowed"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$afcb9eeb4bf056b5, "instruction left account with an outstanding borrowed reference"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$3c4b9377ed4116a0, "program other than the account's owner changed the size of the account data"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$e170b44d99a3d17c, "account data too small for instruction"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$211b990ef3bd19ce, "instruction expected an executable account"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$9e62f446da191370, "An account does not have enough lamports to be rent-exempt"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$4d39d4c2f04b41a8, "Program arithmetic overflowed"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$57c1675a0c20931f, "Failed to serialize or deserialize account data: $encodedData"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$8aebe3e76f515046, "Builtin programs must consume compute units"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$8eb8ce58a8afa4d8, "Cross-program invocation call depth too deep"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$2c001ce75e66180d, "Computational budget exceeded"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$5abe2d1d040bf6cf, "custom program error: #$code"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$c390f45549d7336b, "instruction contains duplicate accounts"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$4db39a3a67e51db2, "instruction modifications of multiply-passed account differ"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$d13686e596713674, "executable accounts must be rent exempt"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$203fce7ce63eb278, "instruction changed executable accounts data"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$c65d87b69a4b86e5, "instruction changed the balance of an executable account"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$2ea2f2f9a9e26449, "instruction changed executable bit of an account"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$72e64aed285de589, "instruction modified data of an account it does not own"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$2b7e7e6bd3d5b8c4, "instruction spent from the balance of an account it does not own"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$ab2273c84ffc5d61, "generic instruction error"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$8a65209e9cece2cd, "Provided owner is not allowed"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$e343a153899b82e9, "Account is immutable"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$2199fb95c7d85b85, "Incorrect authority provided"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$4063fe8d5aed84a5, "incorrect program id for instruction"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$84ec8e94b54ae7d2, "insufficient funds for instruction"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$f9ae264f831e3bcf, "invalid account data for instruction"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$b5ccaf975fe486a0, "Invalid account owner"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$23cc359156888c7f, "invalid program argument"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$35a7a209cf9aaee8, "program returned invalid error code"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$a4193356408e9ff0, "invalid instruction data"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$8e6d399c8fb88eaa, "Failed to reallocate account data"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$fd7a98f0746b6c8a, "Provided seeds do not result in a valid address"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$6b675123aa59300c, "Accounts data allocations exceeded the maximum allowed per transaction"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$70b4e2dd1496c5a3, "Max accounts exceeded"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$43d5111034db211a, "Max instruction trace length exceeded"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$cbeea52e947eb081, "Length of the seed is too long for address generation"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$1224afa7bd705d3d, "An account required by the instruction is missing"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$ecdd3388f6a493b1, "missing required signature for instruction"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$fa2d8ac69bd6117e, "instruction illegally modified the program id of an account"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$2f331454431511bf, "insufficient account keys for instruction"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$ec7d592dad68aa12, "Cross-program invocation with unauthorized signer or writable account"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$8815da3ec592d05a, "Failed to create program execution environment"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$67715a67add5645f, "Program failed to compile"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$b1b9bf899899a525, "Program failed to complete"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$aa03f185732dc00b, "instruction modified data of a read-only account"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$95d7c72146ee65c6, "instruction changed the balance of a read-only account"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$547fdb4fff65c547, "Cross-program invocation reentrancy not allowed for this instruction"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$c9ece88629d0d2d8, "instruction modified rent epoch of an account"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$c2bfe7e903a0febb, "sum of account balances before and after instruction do not match"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$e45bdcd5a97f01d1, "instruction requires an initialized account"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$d308cb6df5c28ff6, ""), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$a070310f29fe959b, "Unsupported program id"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$1997554dc67e9c4e, "Unsupported sysvar"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$552eeff1216c4a1e, "The instruction does not have any accounts."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$b260fc8c8d3cde52, "The instruction does not have any data."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$b81e507604713b9b, "Expected instruction to have progress address $expectedProgramAddress, got $actualProgramAddress."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$c37fe345cc9b38e7, "Expected base58 encoded blockhash to decode to a byte array of length 32. Actual length: $actualLength."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$2b45309b0547a9c4, "The nonce `$expectedNonceValue` is no longer valid. It has advanced to `$actualNonceValue`"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$b57ffff6ec11f63, "Invariant violation: Found no abortable iterable cache entry for key `$cacheKey`. It should be impossible to hit this error; please file an issue at https://sola.na/web3invariant"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$6fe73388375373f, "Invariant violation: Switch statement non-exhaustive. Received unexpected value `$unexpectedValue`. It should be impossible to hit this error; please file an issue at https://sola.na/web3invariant"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$bd3f60d945c38448, "Invariant violation: WebSocket message iterator state is corrupt; iterated without first resolving existing message promise. It should be impossible to hit this error; please file an issue at https://sola.na/web3invariant"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$ecb673640304655c, "Invariant violation: WebSocket message iterator is missing state storage. It should be impossible to hit this error; please file an issue at https://sola.na/web3invariant"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$afa40fd3fc01204, "JSON-RPC error: Internal JSON-RPC error ($__serverMessage)"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$2981978a530b1a7c, "JSON-RPC error: Invalid method parameter(s) ($__serverMessage)"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$23cb4efd59427895, "JSON-RPC error: The JSON sent is not a valid `Request` object ($__serverMessage)"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$5ec955cc8b7e8cf9, "JSON-RPC error: The method does not exist / is not available ($__serverMessage)"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$e09e3905081e44fe, "JSON-RPC error: An error occurred on the server while parsing the JSON text ($__serverMessage)"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$1b90c411626421b1, "$__serverMessage"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$6ae475e85fe02aad, "$__serverMessage"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$bfbf8b75e865efa0, "$__serverMessage"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$65235469ebe9845e, "$__serverMessage"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$54dea2286c43ec1e, "$__serverMessage"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$e71fbee92648fc61, "$__serverMessage"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$4f93db3d1b48599e, "Minimum context slot has not been reached"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$6bad0f4fb625ae6e, "Node is unhealthy; behind by $numSlotsBehind slots"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$eb4f7515ff6aa19d, "No snapshot"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$426cc73f5ad00f38, "Transaction simulation failed"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$d21075fd06730e, "$__serverMessage"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$8e678bf9b4e5cb64, "Transaction history is not available from this node"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$d964b43bb02eacdf, "$__serverMessage"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$bdeebdca616ef1f3, "Transaction signature length mismatch"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$83dce8c0aef70463, "Transaction signature verification failure"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$f7685139153f9191, "$__serverMessage"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$bc1242deaa4d848d, "Key pair bytes must be of length 64, got $byteLength."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$44352af09ecae39f, "Expected private key bytes with length 32. Actual length: $actualLength."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$d2a0e93e506be463, "Expected base58-encoded signature to decode to a byte array of length 64. Actual length: $actualLength."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$436df06ce5af77b3, "The provided private key does not match the provided public key."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$bbe4ed5687bc7f55, "Expected base58-encoded signature string of length in the range [64, 88]. Actual length: $actualLength."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$cf7b28c4ea07497b, "Lamports value must be in the range [0, 2e64-1]"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$e8ff0c73a3d6800d, "`$value` cannot be parsed as a `BigInt`"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$7dd7d17f1f93a166, "`$value` cannot be parsed as a `Number`"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$7cf14cde1226b7cb, "No nonce account could be found at address `$nonceAccountAddress`"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$c2b279d002edb7ec, "Either the notification name must end in 'Notifications' or the API must supply a subscription creator function for the notification '$notificationName' to map between the notification name and the subscribe/unsubscribe method names."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$e1a3658b043aad8e, "Failed to obtain a subscription id from the server"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$70877b3524829eb0, "WebSocket was closed before payload could be added to the send buffer"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$d017b741c4452673, "WebSocket connection closed"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$b1b380d4068eeb8f, "WebSocket failed to connect"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$ef742b7036fb9005, "The $argumentLabel argument to the `$methodName` RPC method$optionalPathLabel was `$value`. This number is unsafe for use with the Solana JSON-RPC because it exceeds `Number.MAX_SAFE_INTEGER`."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$7f6822f75edb8f41, "HTTP error ($statusCode): $message"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$2a2f0f75708d1697, "HTTP header(s) forbidden: $headers. Learn more at https://developer.mozilla.org/en-US/docs/Glossary/Forbidden_header_name."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$ee84b29a9985e516, "Multiple distinct signers were identified for address `$address`. Please ensure that you are using the same signer instance for each address."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$9998b265c986beaa, "The provided value does not implement the `KeyPairSigner` interface"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$14d32fbdad2233cd, "The provided value does not implement the `MessageModifyingSigner` interface"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$8c6fc1cfcec8440c, "The provided value does not implement the `MessagePartialSigner` interface"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$dd792e9d67cd031b, "The provided value does not implement any of the `MessageSigner` interfaces"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$200acbfc722e322b, "The provided value does not implement the `TransactionModifyingSigner` interface"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$4c96d9a95880ae4b, "The provided value does not implement the `TransactionPartialSigner` interface"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$bba76b21ada319a5, "The provided value does not implement the `TransactionSendingSigner` interface"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$dcec7171cff295d1, "The provided value does not implement any of the `TransactionSigner` interfaces"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$3cb3b480d2bfdacc, "More than one `TransactionSendingSigner` was identified."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$1f5fbaa83776feec, "No `TransactionSendingSigner` was identified. Please provide a valid `ITransactionWithSingleSendingSigner` transaction."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$1d51c4c8b2c49e09, "Wallet account signers do not support signing multiple messages/transactions in a single operation"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$f18173f573d8bb21, "No digest implementation could be found."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$f2bbb3c14e29977e, "Cryptographic operations are only allowed in secure browser contexts. Read more here: https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$7ad09900bd645a86, "This runtime does not support the generation of Ed25519 key pairs.\n\nInstall @solana/webcrypto-ed25519-polyfill and call its `install` function before generating keys in environments that do not support Ed25519.\n\nFor a list of runtimes that currently support Ed25519 operations, visit https://github.com/WICG/webcrypto-secure-curves/issues/20."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$69c08c51e1841f29, "No signature verification implementation could be found."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$325dad4e0a6bd514, "No key generation implementation could be found."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$242c341c7c464bee, "No signing implementation could be found."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$a73c064bb32a7c36, "No key export implementation could be found."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$8b23617676679e2d, "Timestamp value must be in the range [-8.64e15, 8.64e15]. `$value` given"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$291ea8d5a7496fde, "Transaction processing left an account with an outstanding borrowed reference"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$a746609ecc2f6acf, "Account in use"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$c4d8217d3eb3eaf8, "Account loaded twice"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$5d0f06cd8bc8e3af, "Attempt to debit an account but found no record of a prior credit."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$95c94f6ea500f1ab, "Transaction loads an address table account that doesn't exist"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$2bbd9403cb117ea7, "This transaction has already been processed"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$e108dd5343c4c11, "Blockhash not found"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$a504ed6cab09ce4a, "Loader call chain is too deep"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$211b9b84186690f0, "Transactions are currently disabled due to cluster maintenance"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$e3a4007020a2e8f5, "Transaction contains a duplicate instruction ($index) that is not allowed"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$39ead28cf48a604c, "Insufficient funds for fee"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$2ecc275dffbc087c, "Transaction results in an account ($accountIndex) with insufficient funds for rent"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$624f65633216eb57, "This account may not be used to pay transaction fees"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$47df44101c6f04b0, "Transaction contains an invalid account reference"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$bd54a9a85614b3a7, "Transaction loads an address table account with invalid data"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$df4ef1824fd194a3, "Transaction address table lookup uses an invalid index"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$11d69fb6993b2cf5, "Transaction loads an address table account with an invalid owner"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$3569c6c71e349538, "LoadedAccountsDataSizeLimit set for transaction must be greater than 0."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$bea5f92951bc42e7, "This program may not be used for executing instructions"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$2725d50dd432fb3a, "Transaction leaves an account with a lower balance than rent-exempt minimum"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$b8b2610c9a910763, "Transaction loads a writable account that cannot be written"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$e3289c5954208202, "Transaction exceeded max loaded accounts data size cap"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$8c1ae05eccc11ef9, "Transaction requires a fee but has no signature present"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$83c8fe2717d1b271, "Attempt to load a program that does not exist"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$1cd0de5dfcdeb99d, "Execution of the program referenced by account at index $accountIndex is temporarily restricted."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$4f413e02d5e82221, "ResanitizationNeeded"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$91a668e132084ecf, "Transaction failed to sanitize accounts offsets correctly"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$89ae0c424691fbcb, "Transaction did not pass signature verification"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$fa9a13f1b40ee2fb, "Transaction locked too many accounts"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$87e01307d368f511, "Sum of account balances before and after transaction do not match"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$8c82dde5b12c9789, "The transaction failed with the error `$errorName`"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$58bf90c73afbc02e, "Transaction version is unsupported"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$572954173bc64b66, "Transaction would exceed account data limit within the block"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$7b4a7eebff68ca7b, "Transaction would exceed total account data limit"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$fb693aebffa32676, "Transaction would exceed max account limit within the block"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$5f027a86397cba92, "Transaction would exceed max Block Cost Limit"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$41f13726b04d8d05, "Transaction would exceed max Vote Cost Limit"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$36c2547c3c4d823f, "Attempted to sign a transaction with an address that is not a signer for it"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$819b1b0603d2a966, "Transaction is missing an address at index: $index."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$de92784c954d1b84, "Transaction has no expected signers therefore it cannot be encoded"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$e33d07a7526bded0, "Transaction does not have a blockhash lifetime"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$a20747f749dd4515, "Transaction is not a durable nonce transaction"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$b34a16b8adbffdc1, "Contents of these address lookup tables unknown: $lookupTableAddresses"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$3764bbcfb0679211, "Lookup of address at index $highestRequestedIndex failed for lookup table `$lookupTableAddress`. Highest known index is $highestKnownIndex. The lookup table may have been extended since its contents were retrieved"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$11bea4440904349c, "No fee payer set in CompiledTransaction"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$ed2bdee7953e467f, "Could not find program address at index $index"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$4e4582c633fc423e, "Failed to estimate the compute unit consumption for this transaction message. This is likely because simulating the transaction failed. Inspect the `cause` property of this error to learn more"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$592862d1b11e32ac, "Transaction is missing a fee payer."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$242af5597d94abaf, "Could not determine this transaction's signature. Make sure that the transaction has been signed by its fee payer."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$bed6f92dafea0623, "Transaction first instruction is not advance nonce account instruction."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$802b3ebe5297e360, "Transaction with no instructions cannot be durable nonce transaction."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$694fd435994bcca, "This transaction includes an address (`$programAddress`) which is both invoked and set as the fee payer. Program addresses may not pay fees"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$707576ec00ca24d6, "This transaction includes an address (`$programAddress`) which is both invoked and marked writable. Program addresses may not be writable"), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$b55a3eb3d894ad9f, "The transaction message expected the transaction to have $signerAddressesLength signatures, got $signaturesLength."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$6d61b980429516bd, "Transaction is missing signatures for addresses: $addresses."), (0, $3sHb8._)($c88b1e140ef0fdf7$var$_obj, $c88b1e140ef0fdf7$export$3963d9bca4091810, "Transaction version must be in the range [0, 127]. `$actualVersion` given"), $c88b1e140ef0fdf7$var$_obj);
// src/message-formatter.ts
var $c88b1e140ef0fdf7$var$START_INDEX = "i";
var $c88b1e140ef0fdf7$var$TYPE = "t";
function $c88b1e140ef0fdf7$var$getHumanReadableErrorMessage(code) {
    var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var messageFormatString = $c88b1e140ef0fdf7$var$SolanaErrorMessages[code];
    if (messageFormatString.length === 0) return "";
    var state;
    function commitStateUpTo(endIndex) {
        if (state[$c88b1e140ef0fdf7$var$TYPE] === 2 /* Variable */ ) {
            var variableName = messageFormatString.slice(state[$c88b1e140ef0fdf7$var$START_INDEX] + 1, endIndex);
            fragments.push(variableName in context ? "".concat(context[variableName]) : "$".concat(variableName));
        } else if (state[$c88b1e140ef0fdf7$var$TYPE] === 1 /* Text */ ) fragments.push(messageFormatString.slice(state[$c88b1e140ef0fdf7$var$START_INDEX], endIndex));
    }
    var fragments = [];
    messageFormatString.split("").forEach(function(char, ii) {
        if (ii === 0) {
            var _obj;
            state = (_obj = {}, (0, $3sHb8._)(_obj, $c88b1e140ef0fdf7$var$START_INDEX, 0), (0, $3sHb8._)(_obj, $c88b1e140ef0fdf7$var$TYPE, messageFormatString[0] === "\\" ? 0 /* EscapeSequence */  : messageFormatString[0] === "$" ? 2 /* Variable */  : 1 /* Text */ ), _obj);
            return;
        }
        var nextState;
        switch(state[$c88b1e140ef0fdf7$var$TYPE]){
            case 0 /* EscapeSequence */ :
                var _obj1;
                nextState = (_obj1 = {}, (0, $3sHb8._)(_obj1, $c88b1e140ef0fdf7$var$START_INDEX, ii), (0, $3sHb8._)(_obj1, $c88b1e140ef0fdf7$var$TYPE, 1 /* Text */ ), _obj1);
                break;
            case 1 /* Text */ :
                var _obj2, _obj3;
                if (char === "\\") nextState = (_obj2 = {}, (0, $3sHb8._)(_obj2, $c88b1e140ef0fdf7$var$START_INDEX, ii), (0, $3sHb8._)(_obj2, $c88b1e140ef0fdf7$var$TYPE, 0 /* EscapeSequence */ ), _obj2);
                else if (char === "$") nextState = (_obj3 = {}, (0, $3sHb8._)(_obj3, $c88b1e140ef0fdf7$var$START_INDEX, ii), (0, $3sHb8._)(_obj3, $c88b1e140ef0fdf7$var$TYPE, 2 /* Variable */ ), _obj3);
                break;
            case 2 /* Variable */ :
                var _obj4, _obj5, _obj6;
                if (char === "\\") nextState = (_obj4 = {}, (0, $3sHb8._)(_obj4, $c88b1e140ef0fdf7$var$START_INDEX, ii), (0, $3sHb8._)(_obj4, $c88b1e140ef0fdf7$var$TYPE, 0 /* EscapeSequence */ ), _obj4);
                else if (char === "$") nextState = (_obj5 = {}, (0, $3sHb8._)(_obj5, $c88b1e140ef0fdf7$var$START_INDEX, ii), (0, $3sHb8._)(_obj5, $c88b1e140ef0fdf7$var$TYPE, 2 /* Variable */ ), _obj5);
                else if (!char.match(/\w/)) nextState = (_obj6 = {}, (0, $3sHb8._)(_obj6, $c88b1e140ef0fdf7$var$START_INDEX, ii), (0, $3sHb8._)(_obj6, $c88b1e140ef0fdf7$var$TYPE, 1 /* Text */ ), _obj6);
                break;
        }
        if (nextState) {
            if (state !== nextState) commitStateUpTo(ii);
            state = nextState;
        }
    });
    commitStateUpTo();
    return fragments.join("");
}
function $c88b1e140ef0fdf7$var$getErrorMessage(code) {
    var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    {
        var decodingAdviceMessage = "Solana error #".concat(code, "; Decode this error by running `npx @solana/errors decode -- ").concat(code);
        if (Object.keys(context).length) decodingAdviceMessage += " '".concat($c88b1e140ef0fdf7$var$encodeContextObject(context), "'");
        return "".concat(decodingAdviceMessage, "`");
    }
}
// src/error.ts
function $c88b1e140ef0fdf7$export$cfead212e52d9961(e, code) {
    var isSolanaError2 = e instanceof Error && e.name === "SolanaError";
    if (isSolanaError2) {
        if (code !== void 0) return e.context.__code === code;
        return true;
    }
    return false;
}
var $c88b1e140ef0fdf7$export$8349fd9adaaed269 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $dcsZi._)(SolanaError, Error1);
    var _super = (0, $ohfOJ._)(SolanaError);
    function SolanaError() {
        for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
            _tmp[_key] = arguments[_key];
        }
        var _tmp1 = (0, $cv9Rk._)(_tmp, 2), code = _tmp1[0], contextAndErrorOptions = _tmp1[1];
        (0, $4GJKx._)(this, SolanaError);
        var _this;
        var context;
        var errorOptions;
        if (contextAndErrorOptions) {
            var cause = contextAndErrorOptions.cause, contextRest = (0, $dRLPW._)(contextAndErrorOptions, [
                "cause"
            ]);
            if (cause) errorOptions = {
                cause: cause
            };
            if (Object.keys(contextRest).length > 0) context = contextRest;
        }
        var message = $c88b1e140ef0fdf7$var$getErrorMessage(code, context);
        _this = _super.call(this, message, errorOptions);
        (0, $3sHb8._)((0, $d3H5E._)(_this), "context", void 0);
        _this.context = (0, $do9pw._)({
            __code: code
        }, context);
        _this.name = "SolanaError";
        return _this;
    }
    return SolanaError;
}((0, $FuVm8._)(Error));
// src/stack-trace.ts
function $c88b1e140ef0fdf7$export$4608fd6508cb51() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _Error;
    if ("captureStackTrace" in Error && typeof Error.captureStackTrace === "function") (_Error = Error).captureStackTrace.apply(_Error, (0, $c6Xmf._)(args));
}
// src/rpc-enum-errors.ts
function $c88b1e140ef0fdf7$var$getSolanaErrorFromRpcError(param, constructorOpt) {
    var errorCodeBaseOffset = param.errorCodeBaseOffset, getErrorContext = param.getErrorContext, orderedErrorNames = param.orderedErrorNames, rpcEnumError = param.rpcEnumError;
    var rpcErrorName;
    var rpcErrorContext;
    if (typeof rpcEnumError === "string") rpcErrorName = rpcEnumError;
    else {
        rpcErrorName = Object.keys(rpcEnumError)[0];
        rpcErrorContext = rpcEnumError[rpcErrorName];
    }
    var codeOffset = orderedErrorNames.indexOf(rpcErrorName);
    var errorCode = errorCodeBaseOffset + codeOffset;
    var errorContext = getErrorContext(errorCode, rpcErrorName, rpcErrorContext);
    var err = new $c88b1e140ef0fdf7$export$8349fd9adaaed269(errorCode, errorContext);
    $c88b1e140ef0fdf7$export$4608fd6508cb51(err, constructorOpt);
    return err;
}
// src/instruction-error.ts
var $c88b1e140ef0fdf7$var$ORDERED_ERROR_NAMES = [
    // Keep synced with RPC source: https://github.com/anza-xyz/agave/blob/master/sdk/program/src/instruction.rs
    // If this list ever gets too large, consider implementing a compression strategy like this:
    // https://gist.github.com/steveluscher/aaa7cbbb5433b1197983908a40860c47
    "GenericError",
    "InvalidArgument",
    "InvalidInstructionData",
    "InvalidAccountData",
    "AccountDataTooSmall",
    "InsufficientFunds",
    "IncorrectProgramId",
    "MissingRequiredSignature",
    "AccountAlreadyInitialized",
    "UninitializedAccount",
    "UnbalancedInstruction",
    "ModifiedProgramId",
    "ExternalAccountLamportSpend",
    "ExternalAccountDataModified",
    "ReadonlyLamportChange",
    "ReadonlyDataModified",
    "DuplicateAccountIndex",
    "ExecutableModified",
    "RentEpochModified",
    "NotEnoughAccountKeys",
    "AccountDataSizeChanged",
    "AccountNotExecutable",
    "AccountBorrowFailed",
    "AccountBorrowOutstanding",
    "DuplicateAccountOutOfSync",
    "Custom",
    "InvalidError",
    "ExecutableDataModified",
    "ExecutableLamportChange",
    "ExecutableAccountNotRentExempt",
    "UnsupportedProgramId",
    "CallDepth",
    "MissingAccount",
    "ReentrancyNotAllowed",
    "MaxSeedLengthExceeded",
    "InvalidSeeds",
    "InvalidRealloc",
    "ComputationalBudgetExceeded",
    "PrivilegeEscalation",
    "ProgramEnvironmentSetupFailure",
    "ProgramFailedToComplete",
    "ProgramFailedToCompile",
    "Immutable",
    "IncorrectAuthority",
    "BorshIoError",
    "AccountNotRentExempt",
    "InvalidAccountOwner",
    "ArithmeticOverflow",
    "UnsupportedSysvar",
    "IllegalOwner",
    "MaxAccountsDataAllocationsExceeded",
    "MaxAccountsExceeded",
    "MaxInstructionTraceLengthExceeded",
    "BuiltinProgramsMustConsumeComputeUnits"
];
function $c88b1e140ef0fdf7$export$4e38d43e41953f9e(index, instructionError) {
    return $c88b1e140ef0fdf7$var$getSolanaErrorFromRpcError({
        errorCodeBaseOffset: 4615001,
        getErrorContext: function(errorCode, rpcErrorName, rpcErrorContext) {
            if (errorCode === $c88b1e140ef0fdf7$export$d308cb6df5c28ff6) return (0, $do9pw._)({
                errorName: rpcErrorName,
                index: index
            }, rpcErrorContext !== void 0 ? {
                instructionErrorContext: rpcErrorContext
            } : null);
            else if (errorCode === $c88b1e140ef0fdf7$export$5abe2d1d040bf6cf) return {
                code: rpcErrorContext,
                index: index
            };
            else if (errorCode === $c88b1e140ef0fdf7$export$57c1675a0c20931f) return {
                encodedData: rpcErrorContext,
                index: index
            };
            return {
                index: index
            };
        },
        orderedErrorNames: $c88b1e140ef0fdf7$var$ORDERED_ERROR_NAMES,
        rpcEnumError: instructionError
    }, $c88b1e140ef0fdf7$export$4e38d43e41953f9e);
}
// src/transaction-error.ts
var $c88b1e140ef0fdf7$var$ORDERED_ERROR_NAMES2 = [
    // Keep synced with RPC source: https://github.com/anza-xyz/agave/blob/master/sdk/src/transaction/error.rs
    // If this list ever gets too large, consider implementing a compression strategy like this:
    // https://gist.github.com/steveluscher/aaa7cbbb5433b1197983908a40860c47
    "AccountInUse",
    "AccountLoadedTwice",
    "AccountNotFound",
    "ProgramAccountNotFound",
    "InsufficientFundsForFee",
    "InvalidAccountForFee",
    "AlreadyProcessed",
    "BlockhashNotFound",
    // `InstructionError` intentionally omitted; delegated to `getSolanaErrorFromInstructionError`
    "CallChainTooDeep",
    "MissingSignatureForFee",
    "InvalidAccountIndex",
    "SignatureFailure",
    "InvalidProgramForExecution",
    "SanitizeFailure",
    "ClusterMaintenance",
    "AccountBorrowOutstanding",
    "WouldExceedMaxBlockCostLimit",
    "UnsupportedVersion",
    "InvalidWritableAccount",
    "WouldExceedMaxAccountCostLimit",
    "WouldExceedAccountDataBlockLimit",
    "TooManyAccountLocks",
    "AddressLookupTableNotFound",
    "InvalidAddressLookupTableOwner",
    "InvalidAddressLookupTableData",
    "InvalidAddressLookupTableIndex",
    "InvalidRentPayingAccount",
    "WouldExceedMaxVoteCostLimit",
    "WouldExceedAccountDataTotalLimit",
    "DuplicateInstruction",
    "InsufficientFundsForRent",
    "MaxLoadedAccountsDataSizeExceeded",
    "InvalidLoadedAccountsDataSizeLimit",
    "ResanitizationNeeded",
    "ProgramExecutionTemporarilyRestricted",
    "UnbalancedTransaction"
];
function $c88b1e140ef0fdf7$export$c10ce7a2fd9c66f0(transactionError) {
    if (typeof transactionError === "object" && "InstructionError" in transactionError) return $c88b1e140ef0fdf7$export$4e38d43e41953f9e.apply(void 0, (0, $c6Xmf._)(transactionError.InstructionError));
    return $c88b1e140ef0fdf7$var$getSolanaErrorFromRpcError({
        errorCodeBaseOffset: 7050001,
        getErrorContext: function(errorCode, rpcErrorName, rpcErrorContext) {
            if (errorCode === $c88b1e140ef0fdf7$export$8c82dde5b12c9789) return (0, $do9pw._)({
                errorName: rpcErrorName
            }, rpcErrorContext !== void 0 ? {
                transactionErrorContext: rpcErrorContext
            } : null);
            else if (errorCode === $c88b1e140ef0fdf7$export$e3a4007020a2e8f5) return {
                index: rpcErrorContext
            };
            else if (errorCode === $c88b1e140ef0fdf7$export$2ecc275dffbc087c || errorCode === $c88b1e140ef0fdf7$export$1cd0de5dfcdeb99d) return {
                accountIndex: rpcErrorContext.account_index
            };
        },
        orderedErrorNames: $c88b1e140ef0fdf7$var$ORDERED_ERROR_NAMES2,
        rpcEnumError: transactionError
    }, $c88b1e140ef0fdf7$export$c10ce7a2fd9c66f0);
}
// src/json-rpc-error.ts
function $c88b1e140ef0fdf7$export$1f67f8d128316a6d(param) {
    var code = param.code, data = param.data, message = param.message;
    var out;
    if (code === $c88b1e140ef0fdf7$export$426cc73f5ad00f38) {
        var err = data.err, preflightErrorContext = (0, $dRLPW._)(data, [
            "err"
        ]);
        var causeObject = err ? {
            cause: $c88b1e140ef0fdf7$export$c10ce7a2fd9c66f0(err)
        } : null;
        out = new $c88b1e140ef0fdf7$export$8349fd9adaaed269($c88b1e140ef0fdf7$export$426cc73f5ad00f38, (0, $do9pw._)({}, preflightErrorContext, causeObject));
    } else {
        var errorContext;
        switch(code){
            case $c88b1e140ef0fdf7$export$afa40fd3fc01204:
            case $c88b1e140ef0fdf7$export$2981978a530b1a7c:
            case $c88b1e140ef0fdf7$export$23cb4efd59427895:
            case $c88b1e140ef0fdf7$export$5ec955cc8b7e8cf9:
            case $c88b1e140ef0fdf7$export$e09e3905081e44fe:
            case $c88b1e140ef0fdf7$export$1b90c411626421b1:
            case $c88b1e140ef0fdf7$export$6ae475e85fe02aad:
            case $c88b1e140ef0fdf7$export$bfbf8b75e865efa0:
            case $c88b1e140ef0fdf7$export$65235469ebe9845e:
            case $c88b1e140ef0fdf7$export$54dea2286c43ec1e:
            case $c88b1e140ef0fdf7$export$e71fbee92648fc61:
            case $c88b1e140ef0fdf7$export$d21075fd06730e:
            case $c88b1e140ef0fdf7$export$d964b43bb02eacdf:
            case $c88b1e140ef0fdf7$export$f7685139153f9191:
                errorContext = {
                    __serverMessage: message
                };
                break;
            default:
                if (typeof data === "object" && !Array.isArray(data)) errorContext = data;
        }
        out = new $c88b1e140ef0fdf7$export$8349fd9adaaed269(code, errorContext);
    }
    $c88b1e140ef0fdf7$export$4608fd6508cb51(out, $c88b1e140ef0fdf7$export$1f67f8d128316a6d);
    return out;
}
 //# sourceMappingURL=out.js.map


// src/add-codec-sentinel.ts
// src/bytes.ts
var $76a25877bc5f4f43$export$6cf3317d55598fde = function(byteArrays) {
    var nonEmptyByteArrays = byteArrays.filter(function(arr) {
        return arr.length;
    });
    if (nonEmptyByteArrays.length === 0) return byteArrays.length ? byteArrays[0] : new Uint8Array();
    if (nonEmptyByteArrays.length === 1) return nonEmptyByteArrays[0];
    var totalLength = nonEmptyByteArrays.reduce(function(total, arr) {
        return total + arr.length;
    }, 0);
    var result = new Uint8Array(totalLength);
    var offset = 0;
    nonEmptyByteArrays.forEach(function(arr) {
        result.set(arr, offset);
        offset += arr.length;
    });
    return result;
};
var $76a25877bc5f4f43$export$4c6b868113605df3 = function(bytes, length) {
    if (bytes.length >= length) return bytes;
    var paddedBytes = new Uint8Array(length).fill(0);
    paddedBytes.set(bytes);
    return paddedBytes;
};
var $76a25877bc5f4f43$export$11b3146a4f4702ef = function(bytes, length) {
    return $76a25877bc5f4f43$export$4c6b868113605df3(bytes.length <= length ? bytes : bytes.slice(0, length), length);
};
function $76a25877bc5f4f43$export$1b62aef2a79e6b21(data, bytes, offset) {
    var slice = offset === 0 && data.length === bytes.length ? data : data.slice(offset, offset + bytes.length);
    if (slice.length !== bytes.length) return false;
    return bytes.every(function(b, i) {
        return b === slice[i];
    });
}
function $76a25877bc5f4f43$export$30f3257599397621(value, encoder) {
    return "fixedSize" in encoder ? encoder.fixedSize : encoder.getSizeFromValue(value);
}
function $76a25877bc5f4f43$export$4e76eeb6df88c889(encoder) {
    return Object.freeze((0, $cxjpp._)((0, $do9pw._)({}, encoder), {
        encode: function(value) {
            var bytes = new Uint8Array($76a25877bc5f4f43$export$30f3257599397621(value, encoder));
            encoder.write(value, bytes, 0);
            return bytes;
        }
    }));
}
function $76a25877bc5f4f43$export$f8c898e83b60faaa(decoder) {
    return Object.freeze((0, $cxjpp._)((0, $do9pw._)({}, decoder), {
        decode: function(bytes) {
            var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
            return decoder.read(bytes, offset)[0];
        }
    }));
}
function $76a25877bc5f4f43$export$a4cf2f585987cc8(codec) {
    return Object.freeze((0, $cxjpp._)((0, $do9pw._)({}, codec), {
        decode: function(bytes) {
            var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
            return codec.read(bytes, offset)[0];
        },
        encode: function(value) {
            var bytes = new Uint8Array($76a25877bc5f4f43$export$30f3257599397621(value, codec));
            codec.write(value, bytes, 0);
            return bytes;
        }
    }));
}
function $76a25877bc5f4f43$export$f9d60229c95384d4(codec) {
    return "fixedSize" in codec && typeof codec.fixedSize === "number";
}
function $76a25877bc5f4f43$export$4e85b7423fd6bc55(codec) {
    if (!$76a25877bc5f4f43$export$f9d60229c95384d4(codec)) throw new (0, $c88b1e140ef0fdf7$export$8349fd9adaaed269)((0, $c88b1e140ef0fdf7$export$93561b31b951410d));
}
function $76a25877bc5f4f43$export$d76fd0b6e42f051a(codec) {
    return !$76a25877bc5f4f43$export$f9d60229c95384d4(codec);
}
function $76a25877bc5f4f43$export$6bf5fc425e413c8a(codec) {
    if (!$76a25877bc5f4f43$export$d76fd0b6e42f051a(codec)) throw new (0, $c88b1e140ef0fdf7$export$8349fd9adaaed269)((0, $c88b1e140ef0fdf7$export$3417da5bc6bcb45));
}
function $76a25877bc5f4f43$export$b88681b853abde79(encoder, decoder) {
    if ($76a25877bc5f4f43$export$f9d60229c95384d4(encoder) !== $76a25877bc5f4f43$export$f9d60229c95384d4(decoder)) throw new (0, $c88b1e140ef0fdf7$export$8349fd9adaaed269)((0, $c88b1e140ef0fdf7$export$c4c73ab3c0833591));
    if ($76a25877bc5f4f43$export$f9d60229c95384d4(encoder) && $76a25877bc5f4f43$export$f9d60229c95384d4(decoder) && encoder.fixedSize !== decoder.fixedSize) throw new (0, $c88b1e140ef0fdf7$export$8349fd9adaaed269)((0, $c88b1e140ef0fdf7$export$824d79ab1779d517), {
        decoderFixedSize: decoder.fixedSize,
        encoderFixedSize: encoder.fixedSize
    });
    if (!$76a25877bc5f4f43$export$f9d60229c95384d4(encoder) && !$76a25877bc5f4f43$export$f9d60229c95384d4(decoder) && encoder.maxSize !== decoder.maxSize) throw new (0, $c88b1e140ef0fdf7$export$8349fd9adaaed269)((0, $c88b1e140ef0fdf7$export$c464f3b291f1f3d0), {
        decoderMaxSize: decoder.maxSize,
        encoderMaxSize: encoder.maxSize
    });
    return (0, $cxjpp._)((0, $do9pw._)({}, decoder, encoder), {
        decode: decoder.decode,
        encode: encoder.encode,
        read: decoder.read,
        write: encoder.write
    });
}
// src/add-codec-sentinel.ts
function $76a25877bc5f4f43$export$e98b1308839de22(encoder, sentinel) {
    var write = function(value, bytes, offset) {
        var encoderBytes = encoder.encode(value);
        if ($76a25877bc5f4f43$var$findSentinelIndex(encoderBytes, sentinel) >= 0) throw new (0, $c88b1e140ef0fdf7$export$8349fd9adaaed269)((0, $c88b1e140ef0fdf7$export$a9282ed13660c9f6), {
            encodedBytes: encoderBytes,
            hexEncodedBytes: $76a25877bc5f4f43$var$hexBytes(encoderBytes),
            hexSentinel: $76a25877bc5f4f43$var$hexBytes(sentinel),
            sentinel: sentinel
        });
        bytes.set(encoderBytes, offset);
        offset += encoderBytes.length;
        bytes.set(sentinel, offset);
        offset += sentinel.length;
        return offset;
    };
    if ($76a25877bc5f4f43$export$f9d60229c95384d4(encoder)) return $76a25877bc5f4f43$export$4e76eeb6df88c889((0, $cxjpp._)((0, $do9pw._)({}, encoder), {
        fixedSize: encoder.fixedSize + sentinel.length,
        write: write
    }));
    return $76a25877bc5f4f43$export$4e76eeb6df88c889((0, $cxjpp._)((0, $do9pw._)({}, encoder, encoder.maxSize != null ? {
        maxSize: encoder.maxSize + sentinel.length
    } : {}), {
        getSizeFromValue: function(value) {
            return encoder.getSizeFromValue(value) + sentinel.length;
        },
        write: write
    }));
}
function $76a25877bc5f4f43$export$cdbc1a8bfd8f69c8(decoder, sentinel) {
    var read = function(bytes, offset) {
        var candidateBytes = offset === 0 ? bytes : bytes.slice(offset);
        var sentinelIndex = $76a25877bc5f4f43$var$findSentinelIndex(candidateBytes, sentinel);
        if (sentinelIndex === -1) throw new (0, $c88b1e140ef0fdf7$export$8349fd9adaaed269)((0, $c88b1e140ef0fdf7$export$5bdfee6423bc35ce), {
            decodedBytes: candidateBytes,
            hexDecodedBytes: $76a25877bc5f4f43$var$hexBytes(candidateBytes),
            hexSentinel: $76a25877bc5f4f43$var$hexBytes(sentinel),
            sentinel: sentinel
        });
        var preSentinelBytes = candidateBytes.slice(0, sentinelIndex);
        return [
            decoder.decode(preSentinelBytes),
            offset + preSentinelBytes.length + sentinel.length
        ];
    };
    if ($76a25877bc5f4f43$export$f9d60229c95384d4(decoder)) return $76a25877bc5f4f43$export$f8c898e83b60faaa((0, $cxjpp._)((0, $do9pw._)({}, decoder), {
        fixedSize: decoder.fixedSize + sentinel.length,
        read: read
    }));
    return $76a25877bc5f4f43$export$f8c898e83b60faaa((0, $cxjpp._)((0, $do9pw._)({}, decoder, decoder.maxSize != null ? {
        maxSize: decoder.maxSize + sentinel.length
    } : {}), {
        read: read
    }));
}
function $76a25877bc5f4f43$export$56d7c5070d1e9d9b(codec, sentinel) {
    return $76a25877bc5f4f43$export$b88681b853abde79($76a25877bc5f4f43$export$e98b1308839de22(codec, sentinel), $76a25877bc5f4f43$export$cdbc1a8bfd8f69c8(codec, sentinel));
}
function $76a25877bc5f4f43$var$findSentinelIndex(bytes, sentinel) {
    return bytes.findIndex(function(byte, index, arr) {
        if (sentinel.length === 1) return byte === sentinel[0];
        return $76a25877bc5f4f43$export$1b62aef2a79e6b21(arr, sentinel, index);
    });
}
function $76a25877bc5f4f43$var$hexBytes(bytes) {
    return bytes.reduce(function(str, byte) {
        return str + byte.toString(16).padStart(2, "0");
    }, "");
}
function $76a25877bc5f4f43$export$bf929351331b7b89(codecDescription, bytes) {
    var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (bytes.length - offset <= 0) throw new (0, $c88b1e140ef0fdf7$export$8349fd9adaaed269)((0, $c88b1e140ef0fdf7$export$9c9326ce1e3df40c), {
        codecDescription: codecDescription
    });
}
function $76a25877bc5f4f43$export$4a981e7c9ed0b6bf(codecDescription, expected, bytes) {
    var offset = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    var bytesLength = bytes.length - offset;
    if (bytesLength < expected) throw new (0, $c88b1e140ef0fdf7$export$8349fd9adaaed269)((0, $c88b1e140ef0fdf7$export$18fbf24f19efc69b), {
        bytesLength: bytesLength,
        codecDescription: codecDescription,
        expected: expected
    });
}
function $76a25877bc5f4f43$export$9319e0aa6a4927d2(codecDescription, offset, bytesLength) {
    if (offset < 0 || offset > bytesLength) throw new (0, $c88b1e140ef0fdf7$export$8349fd9adaaed269)((0, $c88b1e140ef0fdf7$export$a617dff403944ec6), {
        bytesLength: bytesLength,
        codecDescription: codecDescription,
        offset: offset
    });
}
// src/add-codec-size-prefix.ts
function $76a25877bc5f4f43$export$37e5b12cb5a8d560(encoder, prefix) {
    var write = function(value, bytes, offset) {
        var encoderBytes = encoder.encode(value);
        offset = prefix.write(encoderBytes.length, bytes, offset);
        bytes.set(encoderBytes, offset);
        return offset + encoderBytes.length;
    };
    if ($76a25877bc5f4f43$export$f9d60229c95384d4(prefix) && $76a25877bc5f4f43$export$f9d60229c95384d4(encoder)) return $76a25877bc5f4f43$export$4e76eeb6df88c889((0, $cxjpp._)((0, $do9pw._)({}, encoder), {
        fixedSize: prefix.fixedSize + encoder.fixedSize,
        write: write
    }));
    var _prefix_maxSize;
    var prefixMaxSize = $76a25877bc5f4f43$export$f9d60229c95384d4(prefix) ? prefix.fixedSize : (_prefix_maxSize = prefix.maxSize) !== null && _prefix_maxSize !== void 0 ? _prefix_maxSize : null;
    var _encoder_maxSize;
    var encoderMaxSize = $76a25877bc5f4f43$export$f9d60229c95384d4(encoder) ? encoder.fixedSize : (_encoder_maxSize = encoder.maxSize) !== null && _encoder_maxSize !== void 0 ? _encoder_maxSize : null;
    var maxSize = prefixMaxSize !== null && encoderMaxSize !== null ? prefixMaxSize + encoderMaxSize : null;
    return $76a25877bc5f4f43$export$4e76eeb6df88c889((0, $cxjpp._)((0, $do9pw._)({}, encoder, maxSize !== null ? {
        maxSize: maxSize
    } : {}), {
        getSizeFromValue: function(value) {
            var encoderSize = $76a25877bc5f4f43$export$30f3257599397621(value, encoder);
            return $76a25877bc5f4f43$export$30f3257599397621(encoderSize, prefix) + encoderSize;
        },
        write: write
    }));
}
function $76a25877bc5f4f43$export$fe2b33c81523b294(decoder, prefix) {
    var read = function(bytes, offset) {
        var _prefix_read = (0, $cv9Rk._)(prefix.read(bytes, offset), 2), bigintSize = _prefix_read[0], decoderOffset = _prefix_read[1];
        var size = Number(bigintSize);
        offset = decoderOffset;
        if (offset > 0 || bytes.length > size) bytes = bytes.slice(offset, offset + size);
        $76a25877bc5f4f43$export$4a981e7c9ed0b6bf("addDecoderSizePrefix", size, bytes);
        return [
            decoder.decode(bytes),
            offset + size
        ];
    };
    if ($76a25877bc5f4f43$export$f9d60229c95384d4(prefix) && $76a25877bc5f4f43$export$f9d60229c95384d4(decoder)) return $76a25877bc5f4f43$export$f8c898e83b60faaa((0, $cxjpp._)((0, $do9pw._)({}, decoder), {
        fixedSize: prefix.fixedSize + decoder.fixedSize,
        read: read
    }));
    var _prefix_maxSize;
    var prefixMaxSize = $76a25877bc5f4f43$export$f9d60229c95384d4(prefix) ? prefix.fixedSize : (_prefix_maxSize = prefix.maxSize) !== null && _prefix_maxSize !== void 0 ? _prefix_maxSize : null;
    var _decoder_maxSize;
    var decoderMaxSize = $76a25877bc5f4f43$export$f9d60229c95384d4(decoder) ? decoder.fixedSize : (_decoder_maxSize = decoder.maxSize) !== null && _decoder_maxSize !== void 0 ? _decoder_maxSize : null;
    var maxSize = prefixMaxSize !== null && decoderMaxSize !== null ? prefixMaxSize + decoderMaxSize : null;
    return $76a25877bc5f4f43$export$f8c898e83b60faaa((0, $cxjpp._)((0, $do9pw._)({}, decoder, maxSize !== null ? {
        maxSize: maxSize
    } : {}), {
        read: read
    }));
}
function $76a25877bc5f4f43$export$ec85c1caba397ab2(codec, prefix) {
    return $76a25877bc5f4f43$export$b88681b853abde79($76a25877bc5f4f43$export$37e5b12cb5a8d560(codec, prefix), $76a25877bc5f4f43$export$fe2b33c81523b294(codec, prefix));
}
// src/fix-codec-size.ts
function $76a25877bc5f4f43$export$cbdfce031443a1(encoder, fixedBytes) {
    return $76a25877bc5f4f43$export$4e76eeb6df88c889({
        fixedSize: fixedBytes,
        write: function(value, bytes, offset) {
            var variableByteArray = encoder.encode(value);
            var fixedByteArray = variableByteArray.length > fixedBytes ? variableByteArray.slice(0, fixedBytes) : variableByteArray;
            bytes.set(fixedByteArray, offset);
            return offset + fixedBytes;
        }
    });
}
function $76a25877bc5f4f43$export$1f85f8b8d2788007(decoder, fixedBytes) {
    return $76a25877bc5f4f43$export$f8c898e83b60faaa({
        fixedSize: fixedBytes,
        read: function(bytes, offset) {
            $76a25877bc5f4f43$export$4a981e7c9ed0b6bf("fixCodecSize", fixedBytes, bytes, offset);
            if (offset > 0 || bytes.length > fixedBytes) bytes = bytes.slice(offset, offset + fixedBytes);
            if ($76a25877bc5f4f43$export$f9d60229c95384d4(decoder)) bytes = $76a25877bc5f4f43$export$11b3146a4f4702ef(bytes, decoder.fixedSize);
            var _decoder_read = (0, $cv9Rk._)(decoder.read(bytes, 0), 1), value = _decoder_read[0];
            return [
                value,
                offset + fixedBytes
            ];
        }
    });
}
function $76a25877bc5f4f43$export$ff7dc697d5cc308f(codec, fixedBytes) {
    return $76a25877bc5f4f43$export$b88681b853abde79($76a25877bc5f4f43$export$cbdfce031443a1(codec, fixedBytes), $76a25877bc5f4f43$export$1f85f8b8d2788007(codec, fixedBytes));
}
// src/offset-codec.ts
function $76a25877bc5f4f43$export$92407871fbff8926(encoder, config) {
    return $76a25877bc5f4f43$export$4e76eeb6df88c889((0, $cxjpp._)((0, $do9pw._)({}, encoder), {
        write: function(value, bytes, preOffset) {
            var wrapBytes = function(offset) {
                return $76a25877bc5f4f43$var$modulo(offset, bytes.length);
            };
            var newPreOffset = config.preOffset ? config.preOffset({
                bytes: bytes,
                preOffset: preOffset,
                wrapBytes: wrapBytes
            }) : preOffset;
            $76a25877bc5f4f43$export$9319e0aa6a4927d2("offsetEncoder", newPreOffset, bytes.length);
            var postOffset = encoder.write(value, bytes, newPreOffset);
            var newPostOffset = config.postOffset ? config.postOffset({
                bytes: bytes,
                newPreOffset: newPreOffset,
                postOffset: postOffset,
                preOffset: preOffset,
                wrapBytes: wrapBytes
            }) : postOffset;
            $76a25877bc5f4f43$export$9319e0aa6a4927d2("offsetEncoder", newPostOffset, bytes.length);
            return newPostOffset;
        }
    }));
}
function $76a25877bc5f4f43$export$24667feddece166a(decoder, config) {
    return $76a25877bc5f4f43$export$f8c898e83b60faaa((0, $cxjpp._)((0, $do9pw._)({}, decoder), {
        read: function(bytes, preOffset) {
            var wrapBytes = function(offset) {
                return $76a25877bc5f4f43$var$modulo(offset, bytes.length);
            };
            var newPreOffset = config.preOffset ? config.preOffset({
                bytes: bytes,
                preOffset: preOffset,
                wrapBytes: wrapBytes
            }) : preOffset;
            $76a25877bc5f4f43$export$9319e0aa6a4927d2("offsetDecoder", newPreOffset, bytes.length);
            var _decoder_read = (0, $cv9Rk._)(decoder.read(bytes, newPreOffset), 2), value = _decoder_read[0], postOffset = _decoder_read[1];
            var newPostOffset = config.postOffset ? config.postOffset({
                bytes: bytes,
                newPreOffset: newPreOffset,
                postOffset: postOffset,
                preOffset: preOffset,
                wrapBytes: wrapBytes
            }) : postOffset;
            $76a25877bc5f4f43$export$9319e0aa6a4927d2("offsetDecoder", newPostOffset, bytes.length);
            return [
                value,
                newPostOffset
            ];
        }
    }));
}
function $76a25877bc5f4f43$export$8170ddca0f3f53ea(codec, config) {
    return $76a25877bc5f4f43$export$b88681b853abde79($76a25877bc5f4f43$export$92407871fbff8926(codec, config), $76a25877bc5f4f43$export$24667feddece166a(codec, config));
}
function $76a25877bc5f4f43$var$modulo(dividend, divisor) {
    if (divisor === 0) return 0;
    return (dividend % divisor + divisor) % divisor;
}
function $76a25877bc5f4f43$export$d41c2ca858573bc6(encoder, resize) {
    if ($76a25877bc5f4f43$export$f9d60229c95384d4(encoder)) {
        var fixedSize = resize(encoder.fixedSize);
        if (fixedSize < 0) throw new (0, $c88b1e140ef0fdf7$export$8349fd9adaaed269)((0, $c88b1e140ef0fdf7$export$4c1fcb4bd20b2951), {
            bytesLength: fixedSize,
            codecDescription: "resizeEncoder"
        });
        return $76a25877bc5f4f43$export$4e76eeb6df88c889((0, $cxjpp._)((0, $do9pw._)({}, encoder), {
            fixedSize: fixedSize
        }));
    }
    return $76a25877bc5f4f43$export$4e76eeb6df88c889((0, $cxjpp._)((0, $do9pw._)({}, encoder), {
        getSizeFromValue: function(value) {
            var newSize = resize(encoder.getSizeFromValue(value));
            if (newSize < 0) throw new (0, $c88b1e140ef0fdf7$export$8349fd9adaaed269)((0, $c88b1e140ef0fdf7$export$4c1fcb4bd20b2951), {
                bytesLength: newSize,
                codecDescription: "resizeEncoder"
            });
            return newSize;
        }
    }));
}
function $76a25877bc5f4f43$export$7369e12a03366140(decoder, resize) {
    if ($76a25877bc5f4f43$export$f9d60229c95384d4(decoder)) {
        var fixedSize = resize(decoder.fixedSize);
        if (fixedSize < 0) throw new (0, $c88b1e140ef0fdf7$export$8349fd9adaaed269)((0, $c88b1e140ef0fdf7$export$4c1fcb4bd20b2951), {
            bytesLength: fixedSize,
            codecDescription: "resizeDecoder"
        });
        return $76a25877bc5f4f43$export$f8c898e83b60faaa((0, $cxjpp._)((0, $do9pw._)({}, decoder), {
            fixedSize: fixedSize
        }));
    }
    return decoder;
}
function $76a25877bc5f4f43$export$aff234b7657ae683(codec, resize) {
    return $76a25877bc5f4f43$export$b88681b853abde79($76a25877bc5f4f43$export$d41c2ca858573bc6(codec, resize), $76a25877bc5f4f43$export$7369e12a03366140(codec, resize));
}
// src/pad-codec.ts
function $76a25877bc5f4f43$export$66b1746799cd3030(encoder, offset) {
    return $76a25877bc5f4f43$export$92407871fbff8926($76a25877bc5f4f43$export$d41c2ca858573bc6(encoder, function(size) {
        return size + offset;
    }), {
        preOffset: function(param) {
            var preOffset = param.preOffset;
            return preOffset + offset;
        }
    });
}
function $76a25877bc5f4f43$export$770586d1e6f1e5b(encoder, offset) {
    return $76a25877bc5f4f43$export$92407871fbff8926($76a25877bc5f4f43$export$d41c2ca858573bc6(encoder, function(size) {
        return size + offset;
    }), {
        postOffset: function(param) {
            var postOffset = param.postOffset;
            return postOffset + offset;
        }
    });
}
function $76a25877bc5f4f43$export$d88f5bbaa5c2e177(decoder, offset) {
    return $76a25877bc5f4f43$export$24667feddece166a($76a25877bc5f4f43$export$7369e12a03366140(decoder, function(size) {
        return size + offset;
    }), {
        preOffset: function(param) {
            var preOffset = param.preOffset;
            return preOffset + offset;
        }
    });
}
function $76a25877bc5f4f43$export$57a7baba87e0aed9(decoder, offset) {
    return $76a25877bc5f4f43$export$24667feddece166a($76a25877bc5f4f43$export$7369e12a03366140(decoder, function(size) {
        return size + offset;
    }), {
        postOffset: function(param) {
            var postOffset = param.postOffset;
            return postOffset + offset;
        }
    });
}
function $76a25877bc5f4f43$export$d6ed5bbf596a5505(codec, offset) {
    return $76a25877bc5f4f43$export$b88681b853abde79($76a25877bc5f4f43$export$66b1746799cd3030(codec, offset), $76a25877bc5f4f43$export$d88f5bbaa5c2e177(codec, offset));
}
function $76a25877bc5f4f43$export$b11ce69168faaa31(codec, offset) {
    return $76a25877bc5f4f43$export$b88681b853abde79($76a25877bc5f4f43$export$770586d1e6f1e5b(codec, offset), $76a25877bc5f4f43$export$57a7baba87e0aed9(codec, offset));
}
// src/reverse-codec.ts
function $76a25877bc5f4f43$var$copySourceToTargetInReverse(source, target_WILL_MUTATE, sourceOffset, sourceLength) {
    var targetOffset = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
    while(sourceOffset < --sourceLength){
        var leftValue = source[sourceOffset];
        target_WILL_MUTATE[sourceOffset + targetOffset] = source[sourceLength];
        target_WILL_MUTATE[sourceLength + targetOffset] = leftValue;
        sourceOffset++;
    }
    if (sourceOffset === sourceLength) target_WILL_MUTATE[sourceOffset + targetOffset] = source[sourceOffset];
}
function $76a25877bc5f4f43$export$290b4b66fdcc682c(encoder) {
    $76a25877bc5f4f43$export$4e85b7423fd6bc55(encoder);
    return $76a25877bc5f4f43$export$4e76eeb6df88c889((0, $cxjpp._)((0, $do9pw._)({}, encoder), {
        write: function(value, bytes, offset) {
            var newOffset = encoder.write(value, bytes, offset);
            $76a25877bc5f4f43$var$copySourceToTargetInReverse(bytes, bytes, offset, offset + encoder.fixedSize);
            return newOffset;
        }
    }));
}
function $76a25877bc5f4f43$export$1dded7e9fb3087ff(decoder) {
    $76a25877bc5f4f43$export$4e85b7423fd6bc55(decoder);
    return $76a25877bc5f4f43$export$f8c898e83b60faaa((0, $cxjpp._)((0, $do9pw._)({}, decoder), {
        read: function(bytes, offset) {
            var reversedBytes = bytes.slice();
            $76a25877bc5f4f43$var$copySourceToTargetInReverse(bytes, reversedBytes, offset, offset + decoder.fixedSize);
            return decoder.read(reversedBytes, offset);
        }
    }));
}
function $76a25877bc5f4f43$export$e1ef688f83355e2e(codec) {
    return $76a25877bc5f4f43$export$b88681b853abde79($76a25877bc5f4f43$export$290b4b66fdcc682c(codec), $76a25877bc5f4f43$export$1dded7e9fb3087ff(codec));
}
// src/transform-codec.ts
function $76a25877bc5f4f43$export$30169aca64409a56(encoder, unmap) {
    return $76a25877bc5f4f43$export$4e76eeb6df88c889((0, $cxjpp._)((0, $do9pw._)({}, $76a25877bc5f4f43$export$d76fd0b6e42f051a(encoder) ? (0, $cxjpp._)((0, $do9pw._)({}, encoder), {
        getSizeFromValue: function(value) {
            return encoder.getSizeFromValue(unmap(value));
        }
    }) : encoder), {
        write: function(value, bytes, offset) {
            return encoder.write(unmap(value), bytes, offset);
        }
    }));
}
function $76a25877bc5f4f43$export$605b10ee38669daa(decoder, map) {
    return $76a25877bc5f4f43$export$f8c898e83b60faaa((0, $cxjpp._)((0, $do9pw._)({}, decoder), {
        read: function(bytes, offset) {
            var _decoder_read = (0, $cv9Rk._)(decoder.read(bytes, offset), 2), value = _decoder_read[0], newOffset = _decoder_read[1];
            return [
                map(value, bytes, offset),
                newOffset
            ];
        }
    }));
}
function $76a25877bc5f4f43$export$59b20038bbe52b5f(codec, unmap, map) {
    return $76a25877bc5f4f43$export$a4cf2f585987cc8((0, $cxjpp._)((0, $do9pw._)({}, $76a25877bc5f4f43$export$30169aca64409a56(codec, unmap)), {
        read: map ? $76a25877bc5f4f43$export$605b10ee38669daa(codec, map).read : codec.read
    }));
}
 //# sourceMappingURL=out.js.map




// src/assertions.ts
function $22828546edae48c4$export$50ab5941a148d055(codecDescription, min, max, value) {
    if (value < min || value > max) throw new (0, $c88b1e140ef0fdf7$export$8349fd9adaaed269)((0, $c88b1e140ef0fdf7$export$8653c145864f47f4), {
        codecDescription: codecDescription,
        max: max,
        min: min,
        value: value
    });
}
// src/common.ts
var $22828546edae48c4$export$54493dce0da47833 = /* @__PURE__ */ function(Endian2) {
    Endian2[Endian2["Little"] = 0] = "Little";
    Endian2[Endian2["Big"] = 1] = "Big";
    return Endian2;
}($22828546edae48c4$export$54493dce0da47833 || {});
function $22828546edae48c4$var$isLittleEndian(config) {
    return (config === null || config === void 0 ? void 0 : config.endian) === 1 /* Big */  ? false : true;
}
function $22828546edae48c4$var$numberEncoderFactory(input) {
    return (0, $76a25877bc5f4f43$export$4e76eeb6df88c889)({
        fixedSize: input.size,
        write: function(value, bytes, offset) {
            if (input.range) $22828546edae48c4$export$50ab5941a148d055(input.name, input.range[0], input.range[1], value);
            var arrayBuffer = new ArrayBuffer(input.size);
            input.set(new DataView(arrayBuffer), value, $22828546edae48c4$var$isLittleEndian(input.config));
            bytes.set(new Uint8Array(arrayBuffer), offset);
            return offset + input.size;
        }
    });
}
function $22828546edae48c4$var$numberDecoderFactory(input) {
    return (0, $76a25877bc5f4f43$export$f8c898e83b60faaa)({
        fixedSize: input.size,
        read: function(bytes) {
            var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
            (0, $76a25877bc5f4f43$export$bf929351331b7b89)(input.name, bytes, offset);
            (0, $76a25877bc5f4f43$export$4a981e7c9ed0b6bf)(input.name, input.size, bytes, offset);
            var view = new DataView($22828546edae48c4$var$toArrayBuffer(bytes, offset, input.size));
            return [
                input.get(view, $22828546edae48c4$var$isLittleEndian(input.config)),
                offset + input.size
            ];
        }
    });
}
function $22828546edae48c4$var$toArrayBuffer(bytes, offset, length) {
    var bytesOffset = bytes.byteOffset + (offset !== null && offset !== void 0 ? offset : 0);
    var bytesLength = length !== null && length !== void 0 ? length : bytes.byteLength;
    return bytes.buffer.slice(bytesOffset, bytesOffset + bytesLength);
}
// src/f32.ts
var $22828546edae48c4$export$d76ef1cfec201bc9 = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return $22828546edae48c4$var$numberEncoderFactory({
        config: config,
        name: "f32",
        set: function(view, value, le) {
            return view.setFloat32(0, value, le);
        },
        size: 4
    });
};
var $22828546edae48c4$export$314df11445cfa5d0 = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return $22828546edae48c4$var$numberDecoderFactory({
        config: config,
        get: function(view, le) {
            return view.getFloat32(0, le);
        },
        name: "f32",
        size: 4
    });
};
var $22828546edae48c4$export$97a035f0564c51de = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0, $76a25877bc5f4f43$export$b88681b853abde79)($22828546edae48c4$export$d76ef1cfec201bc9(config), $22828546edae48c4$export$314df11445cfa5d0(config));
};
var $22828546edae48c4$export$551368d522177b99 = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return $22828546edae48c4$var$numberEncoderFactory({
        config: config,
        name: "f64",
        set: function(view, value, le) {
            return view.setFloat64(0, value, le);
        },
        size: 8
    });
};
var $22828546edae48c4$export$9475ae45ddf86dec = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return $22828546edae48c4$var$numberDecoderFactory({
        config: config,
        get: function(view, le) {
            return view.getFloat64(0, le);
        },
        name: "f64",
        size: 8
    });
};
var $22828546edae48c4$export$9db82e6fbf3ec8ac = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0, $76a25877bc5f4f43$export$b88681b853abde79)($22828546edae48c4$export$551368d522177b99(config), $22828546edae48c4$export$9475ae45ddf86dec(config));
};
var $22828546edae48c4$export$cf7587f741407205 = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return $22828546edae48c4$var$numberEncoderFactory({
        config: config,
        name: "i128",
        range: [
            -BigInt("0x7fffffffffffffffffffffffffffffff") - 1n,
            BigInt("0x7fffffffffffffffffffffffffffffff")
        ],
        set: function(view, value, le) {
            var leftOffset = le ? 8 : 0;
            var rightOffset = le ? 0 : 8;
            var rightMask = 0xffffffffffffffffn;
            view.setBigInt64(leftOffset, BigInt(value) >> 64n, le);
            view.setBigUint64(rightOffset, BigInt(value) & rightMask, le);
        },
        size: 16
    });
};
var $22828546edae48c4$export$aacd18c97984700c = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return $22828546edae48c4$var$numberDecoderFactory({
        config: config,
        get: function(view, le) {
            var leftOffset = le ? 8 : 0;
            var rightOffset = le ? 0 : 8;
            var left = view.getBigInt64(leftOffset, le);
            var right = view.getBigUint64(rightOffset, le);
            return (left << 64n) + right;
        },
        name: "i128",
        size: 16
    });
};
var $22828546edae48c4$export$b2a180b15845f643 = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0, $76a25877bc5f4f43$export$b88681b853abde79)($22828546edae48c4$export$cf7587f741407205(config), $22828546edae48c4$export$aacd18c97984700c(config));
};
var $22828546edae48c4$export$45d575c12b2bb6a5 = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return $22828546edae48c4$var$numberEncoderFactory({
        config: config,
        name: "i16",
        range: [
            -Number("0x7fff") - 1,
            Number("0x7fff")
        ],
        set: function(view, value, le) {
            return view.setInt16(0, value, le);
        },
        size: 2
    });
};
var $22828546edae48c4$export$4617ff1e22909f4 = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return $22828546edae48c4$var$numberDecoderFactory({
        config: config,
        get: function(view, le) {
            return view.getInt16(0, le);
        },
        name: "i16",
        size: 2
    });
};
var $22828546edae48c4$export$c82cd783a714bca2 = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0, $76a25877bc5f4f43$export$b88681b853abde79)($22828546edae48c4$export$45d575c12b2bb6a5(config), $22828546edae48c4$export$4617ff1e22909f4(config));
};
var $22828546edae48c4$export$73a58a16e77bb58b = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return $22828546edae48c4$var$numberEncoderFactory({
        config: config,
        name: "i32",
        range: [
            -Number("0x7fffffff") - 1,
            Number("0x7fffffff")
        ],
        set: function(view, value, le) {
            return view.setInt32(0, value, le);
        },
        size: 4
    });
};
var $22828546edae48c4$export$a7167d44cb5c65b9 = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return $22828546edae48c4$var$numberDecoderFactory({
        config: config,
        get: function(view, le) {
            return view.getInt32(0, le);
        },
        name: "i32",
        size: 4
    });
};
var $22828546edae48c4$export$c31d2e083195a86f = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0, $76a25877bc5f4f43$export$b88681b853abde79)($22828546edae48c4$export$73a58a16e77bb58b(config), $22828546edae48c4$export$a7167d44cb5c65b9(config));
};
var $22828546edae48c4$export$42b58a304e7edd67 = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return $22828546edae48c4$var$numberEncoderFactory({
        config: config,
        name: "i64",
        range: [
            -BigInt("0x7fffffffffffffff") - 1n,
            BigInt("0x7fffffffffffffff")
        ],
        set: function(view, value, le) {
            return view.setBigInt64(0, BigInt(value), le);
        },
        size: 8
    });
};
var $22828546edae48c4$export$6f14c9b3a349f404 = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return $22828546edae48c4$var$numberDecoderFactory({
        config: config,
        get: function(view, le) {
            return view.getBigInt64(0, le);
        },
        name: "i64",
        size: 8
    });
};
var $22828546edae48c4$export$ebdc4dbdba726e6a = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0, $76a25877bc5f4f43$export$b88681b853abde79)($22828546edae48c4$export$42b58a304e7edd67(config), $22828546edae48c4$export$6f14c9b3a349f404(config));
};
var $22828546edae48c4$export$44792a8c35b3c0ce = function() {
    return $22828546edae48c4$var$numberEncoderFactory({
        name: "i8",
        range: [
            -Number("0x7f") - 1,
            Number("0x7f")
        ],
        set: function(view, value) {
            return view.setInt8(0, value);
        },
        size: 1
    });
};
var $22828546edae48c4$export$fdc22c4a59dfe6be = function() {
    return $22828546edae48c4$var$numberDecoderFactory({
        get: function(view) {
            return view.getInt8(0);
        },
        name: "i8",
        size: 1
    });
};
var $22828546edae48c4$export$f930a8952cfab173 = function() {
    return (0, $76a25877bc5f4f43$export$b88681b853abde79)($22828546edae48c4$export$44792a8c35b3c0ce(), $22828546edae48c4$export$fdc22c4a59dfe6be());
};
var $22828546edae48c4$export$6f025a6ce2a023fc = function() {
    return (0, $76a25877bc5f4f43$export$4e76eeb6df88c889)({
        getSizeFromValue: function(value) {
            if (value <= 127) return 1;
            if (value <= 16383) return 2;
            return 3;
        },
        maxSize: 3,
        write: function(value, bytes, offset) {
            $22828546edae48c4$export$50ab5941a148d055("shortU16", 0, 65535, value);
            var shortU16Bytes = [
                0
            ];
            for(var ii = 0;; ii += 1){
                var alignedValue = value >> ii * 7;
                if (alignedValue === 0) break;
                var nextSevenBits = 127 & alignedValue;
                shortU16Bytes[ii] = nextSevenBits;
                if (ii > 0) shortU16Bytes[ii - 1] |= 128;
            }
            bytes.set(shortU16Bytes, offset);
            return offset + shortU16Bytes.length;
        }
    });
};
var $22828546edae48c4$export$fa35aa457fb08b4a = function() {
    return (0, $76a25877bc5f4f43$export$f8c898e83b60faaa)({
        maxSize: 3,
        read: function(bytes, offset) {
            var value = 0;
            var byteCount = 0;
            while(++byteCount){
                var byteIndex = byteCount - 1;
                var currentByte = bytes[offset + byteIndex];
                var nextSevenBits = 127 & currentByte;
                value |= nextSevenBits << byteIndex * 7;
                if ((currentByte & 128) === 0) break;
            }
            return [
                value,
                offset + byteCount
            ];
        }
    });
};
var $22828546edae48c4$export$9f6b1d6c8cda8e31 = function() {
    return (0, $76a25877bc5f4f43$export$b88681b853abde79)($22828546edae48c4$export$6f025a6ce2a023fc(), $22828546edae48c4$export$fa35aa457fb08b4a());
};
var $22828546edae48c4$export$3333225663a8d6bb = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return $22828546edae48c4$var$numberEncoderFactory({
        config: config,
        name: "u128",
        range: [
            0n,
            BigInt("0xffffffffffffffffffffffffffffffff")
        ],
        set: function(view, value, le) {
            var leftOffset = le ? 8 : 0;
            var rightOffset = le ? 0 : 8;
            var rightMask = 0xffffffffffffffffn;
            view.setBigUint64(leftOffset, BigInt(value) >> 64n, le);
            view.setBigUint64(rightOffset, BigInt(value) & rightMask, le);
        },
        size: 16
    });
};
var $22828546edae48c4$export$523e33537e060693 = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return $22828546edae48c4$var$numberDecoderFactory({
        config: config,
        get: function(view, le) {
            var leftOffset = le ? 8 : 0;
            var rightOffset = le ? 0 : 8;
            var left = view.getBigUint64(leftOffset, le);
            var right = view.getBigUint64(rightOffset, le);
            return (left << 64n) + right;
        },
        name: "u128",
        size: 16
    });
};
var $22828546edae48c4$export$e775878beaafab29 = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0, $76a25877bc5f4f43$export$b88681b853abde79)($22828546edae48c4$export$3333225663a8d6bb(config), $22828546edae48c4$export$523e33537e060693(config));
};
var $22828546edae48c4$export$e156211d06496a2f = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return $22828546edae48c4$var$numberEncoderFactory({
        config: config,
        name: "u16",
        range: [
            0,
            Number("0xffff")
        ],
        set: function(view, value, le) {
            return view.setUint16(0, value, le);
        },
        size: 2
    });
};
var $22828546edae48c4$export$1a649eb0055ac058 = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return $22828546edae48c4$var$numberDecoderFactory({
        config: config,
        get: function(view, le) {
            return view.getUint16(0, le);
        },
        name: "u16",
        size: 2
    });
};
var $22828546edae48c4$export$dda1212c8afd5e5c = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0, $76a25877bc5f4f43$export$b88681b853abde79)($22828546edae48c4$export$e156211d06496a2f(config), $22828546edae48c4$export$1a649eb0055ac058(config));
};
var $22828546edae48c4$export$3e3136013a349951 = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return $22828546edae48c4$var$numberEncoderFactory({
        config: config,
        name: "u32",
        range: [
            0,
            Number("0xffffffff")
        ],
        set: function(view, value, le) {
            return view.setUint32(0, value, le);
        },
        size: 4
    });
};
var $22828546edae48c4$export$ddc26825031b1ac9 = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return $22828546edae48c4$var$numberDecoderFactory({
        config: config,
        get: function(view, le) {
            return view.getUint32(0, le);
        },
        name: "u32",
        size: 4
    });
};
var $22828546edae48c4$export$172bf721fe9bbfd1 = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0, $76a25877bc5f4f43$export$b88681b853abde79)($22828546edae48c4$export$3e3136013a349951(config), $22828546edae48c4$export$ddc26825031b1ac9(config));
};
var $22828546edae48c4$export$59d3bc8d559487ec = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return $22828546edae48c4$var$numberEncoderFactory({
        config: config,
        name: "u64",
        range: [
            0n,
            BigInt("0xffffffffffffffff")
        ],
        set: function(view, value, le) {
            return view.setBigUint64(0, BigInt(value), le);
        },
        size: 8
    });
};
var $22828546edae48c4$export$faa05ffebebd465d = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return $22828546edae48c4$var$numberDecoderFactory({
        config: config,
        get: function(view, le) {
            return view.getBigUint64(0, le);
        },
        name: "u64",
        size: 8
    });
};
var $22828546edae48c4$export$7e56ec13f6029ccc = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0, $76a25877bc5f4f43$export$b88681b853abde79)($22828546edae48c4$export$59d3bc8d559487ec(config), $22828546edae48c4$export$faa05ffebebd465d(config));
};
var $22828546edae48c4$export$dc9732115561fb4b = function() {
    return $22828546edae48c4$var$numberEncoderFactory({
        name: "u8",
        range: [
            0,
            Number("0xff")
        ],
        set: function(view, value) {
            return view.setUint8(0, value);
        },
        size: 1
    });
};
var $22828546edae48c4$export$edadf68f5f1a8bc6 = function() {
    return $22828546edae48c4$var$numberDecoderFactory({
        get: function(view) {
            return view.getUint8(0);
        },
        name: "u8",
        size: 1
    });
};
var $22828546edae48c4$export$5ae2d5c46a10d97 = function() {
    return (0, $76a25877bc5f4f43$export$b88681b853abde79)($22828546edae48c4$export$dc9732115561fb4b(), $22828546edae48c4$export$edadf68f5f1a8bc6());
};
 //# sourceMappingURL=out.js.map



// src/array.ts
function $c7eada7ab3195342$export$1e6cff54ac72b1a3(codecDescription, expected, actual) {
    if (expected !== actual) throw new (0, $c88b1e140ef0fdf7$export$8349fd9adaaed269)((0, $c88b1e140ef0fdf7$export$c04710d31ef4d278), {
        actual: actual,
        codecDescription: codecDescription,
        expected: expected
    });
}
function $c7eada7ab3195342$var$maxCodecSizes(sizes) {
    return sizes.reduce(function(all, size) {
        return all === null || size === null ? null : Math.max(all, size);
    }, 0);
}
function $c7eada7ab3195342$var$sumCodecSizes(sizes) {
    return sizes.reduce(function(all, size) {
        return all === null || size === null ? null : all + size;
    }, 0);
}
function $c7eada7ab3195342$var$getFixedSize(codec) {
    return (0, $76a25877bc5f4f43$export$f9d60229c95384d4)(codec) ? codec.fixedSize : null;
}
function $c7eada7ab3195342$var$getMaxSize(codec) {
    var _codec_maxSize;
    return (0, $76a25877bc5f4f43$export$f9d60229c95384d4)(codec) ? codec.fixedSize : (_codec_maxSize = codec.maxSize) !== null && _codec_maxSize !== void 0 ? _codec_maxSize : null;
}
// src/array.ts
function $c7eada7ab3195342$export$415199198053c0b(item) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _config_size;
    var size = (_config_size = config.size) !== null && _config_size !== void 0 ? _config_size : (0, $22828546edae48c4$export$3e3136013a349951)();
    var fixedSize = $c7eada7ab3195342$var$computeArrayLikeCodecSize(size, $c7eada7ab3195342$var$getFixedSize(item));
    var _computeArrayLikeCodecSize;
    var maxSize = (_computeArrayLikeCodecSize = $c7eada7ab3195342$var$computeArrayLikeCodecSize(size, $c7eada7ab3195342$var$getMaxSize(item))) !== null && _computeArrayLikeCodecSize !== void 0 ? _computeArrayLikeCodecSize : void 0;
    return (0, $76a25877bc5f4f43$export$4e76eeb6df88c889)((0, $cxjpp._)((0, $do9pw._)({}, fixedSize !== null ? {
        fixedSize: fixedSize
    } : {
        getSizeFromValue: function(array) {
            var prefixSize = typeof size === "object" ? (0, $76a25877bc5f4f43$export$30f3257599397621)(array.length, size) : 0;
            return prefixSize + (0, $c6Xmf._)(array).reduce(function(all, value) {
                return all + (0, $76a25877bc5f4f43$export$30f3257599397621)(value, item);
            }, 0);
        },
        maxSize: maxSize
    }), {
        write: function(array, bytes, offset) {
            if (typeof size === "number") $c7eada7ab3195342$export$1e6cff54ac72b1a3("array", size, array.length);
            if (typeof size === "object") offset = size.write(array.length, bytes, offset);
            array.forEach(function(value) {
                offset = item.write(value, bytes, offset);
            });
            return offset;
        }
    }));
}
function $c7eada7ab3195342$export$9016038b2e3b0c2f(item) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _config_size;
    var size = (_config_size = config.size) !== null && _config_size !== void 0 ? _config_size : (0, $22828546edae48c4$export$ddc26825031b1ac9)();
    var itemSize = $c7eada7ab3195342$var$getFixedSize(item);
    var fixedSize = $c7eada7ab3195342$var$computeArrayLikeCodecSize(size, itemSize);
    var _computeArrayLikeCodecSize;
    var maxSize = (_computeArrayLikeCodecSize = $c7eada7ab3195342$var$computeArrayLikeCodecSize(size, $c7eada7ab3195342$var$getMaxSize(item))) !== null && _computeArrayLikeCodecSize !== void 0 ? _computeArrayLikeCodecSize : void 0;
    return (0, $76a25877bc5f4f43$export$f8c898e83b60faaa)((0, $cxjpp._)((0, $do9pw._)({}, fixedSize !== null ? {
        fixedSize: fixedSize
    } : {
        maxSize: maxSize
    }), {
        read: function(bytes, offset) {
            var array = [];
            if (typeof size === "object" && bytes.slice(offset).length === 0) return [
                array,
                offset
            ];
            if (size === "remainder") {
                while(offset < bytes.length){
                    var _item_read = (0, $cv9Rk._)(item.read(bytes, offset), 2), value = _item_read[0], newOffset2 = _item_read[1];
                    offset = newOffset2;
                    array.push(value);
                }
                return [
                    array,
                    offset
                ];
            }
            var _ref = (0, $cv9Rk._)(typeof size === "number" ? [
                size,
                offset
            ] : size.read(bytes, offset), 2), resolvedSize = _ref[0], newOffset = _ref[1];
            offset = newOffset;
            for(var i = 0; i < resolvedSize; i += 1){
                var _item_read1 = (0, $cv9Rk._)(item.read(bytes, offset), 2), value1 = _item_read1[0], newOffset21 = _item_read1[1];
                offset = newOffset21;
                array.push(value1);
            }
            return [
                array,
                offset
            ];
        }
    }));
}
function $c7eada7ab3195342$export$8390591075c4b219(item) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return (0, $76a25877bc5f4f43$export$b88681b853abde79)($c7eada7ab3195342$export$415199198053c0b(item, config), $c7eada7ab3195342$export$9016038b2e3b0c2f(item, config));
}
function $c7eada7ab3195342$var$computeArrayLikeCodecSize(size, itemSize) {
    if (typeof size !== "number") return null;
    if (size === 0) return 0;
    return itemSize === null ? null : itemSize * size;
}
function $c7eada7ab3195342$export$f0392815667c42f2(size) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var parsedConfig = typeof config === "boolean" ? {
        backward: config
    } : config;
    var _parsedConfig_backward;
    var backward = (_parsedConfig_backward = parsedConfig.backward) !== null && _parsedConfig_backward !== void 0 ? _parsedConfig_backward : false;
    return (0, $76a25877bc5f4f43$export$4e76eeb6df88c889)({
        fixedSize: size,
        write: function(value, bytes, offset) {
            var bytesToAdd = [];
            for(var i = 0; i < size; i += 1){
                var byte = 0;
                for(var j = 0; j < 8; j += 1){
                    var _value_;
                    var feature = Number((_value_ = value[i * 8 + j]) !== null && _value_ !== void 0 ? _value_ : 0);
                    byte |= feature << (backward ? j : 7 - j);
                }
                if (backward) bytesToAdd.unshift(byte);
                else bytesToAdd.push(byte);
            }
            bytes.set(bytesToAdd, offset);
            return size;
        }
    });
}
function $c7eada7ab3195342$export$5b3f10dd092d835b(size) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var parsedConfig = typeof config === "boolean" ? {
        backward: config
    } : config;
    var _parsedConfig_backward;
    var backward = (_parsedConfig_backward = parsedConfig.backward) !== null && _parsedConfig_backward !== void 0 ? _parsedConfig_backward : false;
    return (0, $76a25877bc5f4f43$export$f8c898e83b60faaa)({
        fixedSize: size,
        read: function(bytes, offset) {
            (0, $76a25877bc5f4f43$export$4a981e7c9ed0b6bf)("bitArray", size, bytes, offset);
            var booleans = [];
            var slice = bytes.slice(offset, offset + size);
            slice = backward ? slice.reverse() : slice;
            slice.forEach(function(byte) {
                for(var i = 0; i < 8; i += 1)if (backward) {
                    booleans.push(Boolean(byte & 1));
                    byte >>= 1;
                } else {
                    booleans.push(Boolean(byte & 128));
                    byte <<= 1;
                }
            });
            return [
                booleans,
                offset + size
            ];
        }
    });
}
function $c7eada7ab3195342$export$eb1097a7c4c3befd(size) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return (0, $76a25877bc5f4f43$export$b88681b853abde79)($c7eada7ab3195342$export$f0392815667c42f2(size, config), $c7eada7ab3195342$export$5b3f10dd092d835b(size, config));
}
function $c7eada7ab3195342$export$4a518d3f98f842eb() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _config_size;
    return (0, $76a25877bc5f4f43$export$30169aca64409a56)((_config_size = config.size) !== null && _config_size !== void 0 ? _config_size : (0, $22828546edae48c4$export$dc9732115561fb4b)(), function(value) {
        return value ? 1 : 0;
    });
}
function $c7eada7ab3195342$export$43a73c742ad521e1() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _config_size;
    return (0, $76a25877bc5f4f43$export$605b10ee38669daa)((_config_size = config.size) !== null && _config_size !== void 0 ? _config_size : (0, $22828546edae48c4$export$edadf68f5f1a8bc6)(), function(value) {
        return Number(value) === 1;
    });
}
function $c7eada7ab3195342$export$3071f075392d1897() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0, $76a25877bc5f4f43$export$b88681b853abde79)($c7eada7ab3195342$export$4a518d3f98f842eb(config), $c7eada7ab3195342$export$43a73c742ad521e1(config));
}
function $c7eada7ab3195342$export$636c51ad84d0674a() {
    return (0, $76a25877bc5f4f43$export$4e76eeb6df88c889)({
        getSizeFromValue: function(value) {
            return value.length;
        },
        write: function(value, bytes, offset) {
            bytes.set(value, offset);
            return offset + value.length;
        }
    });
}
function $c7eada7ab3195342$export$b90e67818b1b3d45() {
    return (0, $76a25877bc5f4f43$export$f8c898e83b60faaa)({
        read: function(bytes, offset) {
            var slice = bytes.slice(offset);
            return [
                slice,
                offset + slice.length
            ];
        }
    });
}
function $c7eada7ab3195342$export$f3c2d67c19d09b74() {
    return (0, $76a25877bc5f4f43$export$b88681b853abde79)($c7eada7ab3195342$export$636c51ad84d0674a(), $c7eada7ab3195342$export$b90e67818b1b3d45());
}
var $c7eada7ab3195342$var$getBase16Decoder = function() {
    return (0, $76a25877bc5f4f43$export$f8c898e83b60faaa)({
        read: function(bytes, offset) {
            var value = bytes.slice(offset).reduce(function(str, byte) {
                return str + byte.toString(16).padStart(2, "0");
            }, "");
            return [
                value,
                bytes.length
            ];
        }
    });
};
function $c7eada7ab3195342$export$23a212060029ca97(constant) {
    return (0, $76a25877bc5f4f43$export$4e76eeb6df88c889)({
        fixedSize: constant.length,
        write: function(_, bytes, offset) {
            bytes.set(constant, offset);
            return offset + constant.length;
        }
    });
}
function $c7eada7ab3195342$export$13c771567a4019f7(constant) {
    return (0, $76a25877bc5f4f43$export$f8c898e83b60faaa)({
        fixedSize: constant.length,
        read: function(bytes, offset) {
            var base16 = $c7eada7ab3195342$var$getBase16Decoder();
            if (!(0, $76a25877bc5f4f43$export$1b62aef2a79e6b21)(bytes, constant, offset)) throw new (0, $c88b1e140ef0fdf7$export$8349fd9adaaed269)((0, $c88b1e140ef0fdf7$export$cb77f5a0f0fa7f18), {
                constant: constant,
                data: bytes,
                hexConstant: base16.decode(constant),
                hexData: base16.decode(bytes),
                offset: offset
            });
            return [
                void 0,
                offset + constant.length
            ];
        }
    });
}
function $c7eada7ab3195342$export$ad029b7073097608(constant) {
    return (0, $76a25877bc5f4f43$export$b88681b853abde79)($c7eada7ab3195342$export$23a212060029ca97(constant), $c7eada7ab3195342$export$13c771567a4019f7(constant));
}
function $c7eada7ab3195342$export$6b19a6a85541fd99(items) {
    var fixedSize = $c7eada7ab3195342$var$sumCodecSizes(items.map($c7eada7ab3195342$var$getFixedSize));
    var _sumCodecSizes;
    var maxSize = (_sumCodecSizes = $c7eada7ab3195342$var$sumCodecSizes(items.map($c7eada7ab3195342$var$getMaxSize))) !== null && _sumCodecSizes !== void 0 ? _sumCodecSizes : void 0;
    return (0, $76a25877bc5f4f43$export$4e76eeb6df88c889)((0, $cxjpp._)((0, $do9pw._)({}, fixedSize === null ? {
        getSizeFromValue: function(value) {
            return items.map(function(item, index) {
                return (0, $76a25877bc5f4f43$export$30f3257599397621)(value[index], item);
            }).reduce(function(all, one) {
                return all + one;
            }, 0);
        },
        maxSize: maxSize
    } : {
        fixedSize: fixedSize
    }), {
        write: function(value, bytes, offset) {
            $c7eada7ab3195342$export$1e6cff54ac72b1a3("tuple", items.length, value.length);
            items.forEach(function(item, index) {
                offset = item.write(value[index], bytes, offset);
            });
            return offset;
        }
    }));
}
function $c7eada7ab3195342$export$9800955a9fcaec5(items) {
    var fixedSize = $c7eada7ab3195342$var$sumCodecSizes(items.map($c7eada7ab3195342$var$getFixedSize));
    var _sumCodecSizes;
    var maxSize = (_sumCodecSizes = $c7eada7ab3195342$var$sumCodecSizes(items.map($c7eada7ab3195342$var$getMaxSize))) !== null && _sumCodecSizes !== void 0 ? _sumCodecSizes : void 0;
    return (0, $76a25877bc5f4f43$export$f8c898e83b60faaa)((0, $cxjpp._)((0, $do9pw._)({}, fixedSize === null ? {
        maxSize: maxSize
    } : {
        fixedSize: fixedSize
    }), {
        read: function(bytes, offset) {
            var values = [];
            items.forEach(function(item) {
                var _item_read = (0, $cv9Rk._)(item.read(bytes, offset), 2), newValue = _item_read[0], newOffset = _item_read[1];
                values.push(newValue);
                offset = newOffset;
            });
            return [
                values,
                offset
            ];
        }
    }));
}
function $c7eada7ab3195342$export$dc2491d24b0f7b51(items) {
    return (0, $76a25877bc5f4f43$export$b88681b853abde79)($c7eada7ab3195342$export$6b19a6a85541fd99(items), $c7eada7ab3195342$export$9800955a9fcaec5(items));
}
function $c7eada7ab3195342$export$a9351c88c0e29fc0(variants, getIndexFromValue) {
    var fixedSize = $c7eada7ab3195342$var$getUnionFixedSize(variants);
    var write = function(variant, bytes, offset) {
        var index = getIndexFromValue(variant);
        $c7eada7ab3195342$var$assertValidVariantIndex(variants, index);
        return variants[index].write(variant, bytes, offset);
    };
    if (fixedSize !== null) return (0, $76a25877bc5f4f43$export$4e76eeb6df88c889)({
        fixedSize: fixedSize,
        write: write
    });
    var maxSize = $c7eada7ab3195342$var$getUnionMaxSize(variants);
    return (0, $76a25877bc5f4f43$export$4e76eeb6df88c889)((0, $cxjpp._)((0, $do9pw._)({}, maxSize !== null ? {
        maxSize: maxSize
    } : {}), {
        getSizeFromValue: function(variant) {
            var index = getIndexFromValue(variant);
            $c7eada7ab3195342$var$assertValidVariantIndex(variants, index);
            return (0, $76a25877bc5f4f43$export$30f3257599397621)(variant, variants[index]);
        },
        write: write
    }));
}
function $c7eada7ab3195342$export$ba967eb6bc7384b7(variants, getIndexFromBytes) {
    var fixedSize = $c7eada7ab3195342$var$getUnionFixedSize(variants);
    var read = function(bytes, offset) {
        var index = getIndexFromBytes(bytes, offset);
        $c7eada7ab3195342$var$assertValidVariantIndex(variants, index);
        return variants[index].read(bytes, offset);
    };
    if (fixedSize !== null) return (0, $76a25877bc5f4f43$export$f8c898e83b60faaa)({
        fixedSize: fixedSize,
        read: read
    });
    var maxSize = $c7eada7ab3195342$var$getUnionMaxSize(variants);
    return (0, $76a25877bc5f4f43$export$f8c898e83b60faaa)((0, $cxjpp._)((0, $do9pw._)({}, maxSize !== null ? {
        maxSize: maxSize
    } : {}), {
        read: read
    }));
}
function $c7eada7ab3195342$export$8e8c799359f1b4d2(variants, getIndexFromValue, getIndexFromBytes) {
    return (0, $76a25877bc5f4f43$export$b88681b853abde79)($c7eada7ab3195342$export$a9351c88c0e29fc0(variants, getIndexFromValue), $c7eada7ab3195342$export$ba967eb6bc7384b7(variants, getIndexFromBytes));
}
function $c7eada7ab3195342$var$assertValidVariantIndex(variants, index) {
    if (typeof variants[index] === "undefined") throw new (0, $c88b1e140ef0fdf7$export$8349fd9adaaed269)((0, $c88b1e140ef0fdf7$export$efbd199de191d2aa), {
        maxRange: variants.length - 1,
        minRange: 0,
        variant: index
    });
}
function $c7eada7ab3195342$var$getUnionFixedSize(variants) {
    if (variants.length === 0) return 0;
    if (!(0, $76a25877bc5f4f43$export$f9d60229c95384d4)(variants[0])) return null;
    var variantSize = variants[0].fixedSize;
    var sameSizedVariants = variants.every(function(variant) {
        return (0, $76a25877bc5f4f43$export$f9d60229c95384d4)(variant) && variant.fixedSize === variantSize;
    });
    return sameSizedVariants ? variantSize : null;
}
function $c7eada7ab3195342$var$getUnionMaxSize(variants) {
    return $c7eada7ab3195342$var$maxCodecSizes(variants.map(function(variant) {
        return $c7eada7ab3195342$var$getMaxSize(variant);
    }));
}
// src/discriminated-union.ts
function $c7eada7ab3195342$export$927540af483f54a(variants) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _config_discriminator;
    var discriminatorProperty = (_config_discriminator = config.discriminator) !== null && _config_discriminator !== void 0 ? _config_discriminator : "__kind";
    var _config_size;
    var prefix = (_config_size = config.size) !== null && _config_size !== void 0 ? _config_size : (0, $22828546edae48c4$export$dc9732115561fb4b)();
    return $c7eada7ab3195342$export$a9351c88c0e29fc0(variants.map(function(param, index) {
        var _param = (0, $cv9Rk._)(param, 2), variant = _param[1];
        return (0, $76a25877bc5f4f43$export$30169aca64409a56)($c7eada7ab3195342$export$6b19a6a85541fd99([
            prefix,
            variant
        ]), function(value) {
            return [
                index,
                value
            ];
        });
    }), function(value) {
        return $c7eada7ab3195342$var$getVariantDiscriminator(variants, value[discriminatorProperty]);
    });
}
function $c7eada7ab3195342$export$46f8fe299eb88c54(variants) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _config_discriminator;
    var discriminatorProperty = (_config_discriminator = config.discriminator) !== null && _config_discriminator !== void 0 ? _config_discriminator : "__kind";
    var _config_size;
    var prefix = (_config_size = config.size) !== null && _config_size !== void 0 ? _config_size : (0, $22828546edae48c4$export$edadf68f5f1a8bc6)();
    return $c7eada7ab3195342$export$ba967eb6bc7384b7(variants.map(function(param) {
        var _param = (0, $cv9Rk._)(param, 2), discriminator = _param[0], variant = _param[1];
        return (0, $76a25877bc5f4f43$export$605b10ee38669daa)($c7eada7ab3195342$export$9800955a9fcaec5([
            prefix,
            variant
        ]), function(param) {
            var _param = (0, $cv9Rk._)(param, 2), value = _param[1];
            return (0, $do9pw._)((0, $3sHb8._)({}, discriminatorProperty, discriminator), value);
        });
    }), function(bytes, offset) {
        return Number(prefix.read(bytes, offset)[0]);
    });
}
function $c7eada7ab3195342$export$54ce790fc77f87b2(variants) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return (0, $76a25877bc5f4f43$export$b88681b853abde79)($c7eada7ab3195342$export$927540af483f54a(variants, config), $c7eada7ab3195342$export$46f8fe299eb88c54(variants, config));
}
function $c7eada7ab3195342$var$getVariantDiscriminator(variants, discriminatorValue) {
    var discriminator = variants.findIndex(function(param) {
        var _param = (0, $cv9Rk._)(param, 1), key = _param[0];
        return discriminatorValue === key;
    });
    if (discriminator < 0) throw new (0, $c88b1e140ef0fdf7$export$8349fd9adaaed269)((0, $c88b1e140ef0fdf7$export$2bb0703affb8fe68), {
        value: discriminatorValue,
        variants: variants.map(function(param) {
            var _param = (0, $cv9Rk._)(param, 1), key = _param[0];
            return key;
        })
    });
    return discriminator;
}
var $c7eada7ab3195342$export$b7bab0bb6c91fbe9 = $c7eada7ab3195342$export$927540af483f54a;
var $c7eada7ab3195342$export$9cf3b180fc535fb1 = $c7eada7ab3195342$export$46f8fe299eb88c54;
var $c7eada7ab3195342$export$e076362323986828 = $c7eada7ab3195342$export$54ce790fc77f87b2;
// src/enum-helpers.ts
function $c7eada7ab3195342$var$getEnumStats(constructor) {
    var numericalValues = (0, $c6Xmf._)(new Set(Object.values(constructor).filter(function(v) {
        return typeof v === "number";
    }))).sort();
    var enumRecord = Object.fromEntries(Object.entries(constructor).slice(numericalValues.length));
    var enumKeys = Object.keys(enumRecord);
    var enumValues = Object.values(enumRecord);
    var stringValues = (0, $c6Xmf._)(/* @__PURE__ */ new Set((0, $c6Xmf._)(enumKeys).concat((0, $c6Xmf._)(enumValues.filter(function(v) {
        return typeof v === "string";
    })))));
    return {
        enumKeys: enumKeys,
        enumRecord: enumRecord,
        enumValues: enumValues,
        numericalValues: numericalValues,
        stringValues: stringValues
    };
}
function $c7eada7ab3195342$var$getEnumIndexFromVariant(param) {
    var enumKeys = param.enumKeys, enumValues = param.enumValues, variant = param.variant;
    var valueIndex = $c7eada7ab3195342$var$findLastIndex(enumValues, function(value) {
        return value === variant;
    });
    if (valueIndex >= 0) return valueIndex;
    return enumKeys.findIndex(function(key) {
        return key === variant;
    });
}
function $c7eada7ab3195342$var$getEnumIndexFromDiscriminator(param) {
    var discriminator = param.discriminator, enumKeys = param.enumKeys, enumValues = param.enumValues, useValuesAsDiscriminators = param.useValuesAsDiscriminators;
    if (!useValuesAsDiscriminators) return discriminator >= 0 && discriminator < enumKeys.length ? discriminator : -1;
    return $c7eada7ab3195342$var$findLastIndex(enumValues, function(value) {
        return value === discriminator;
    });
}
function $c7eada7ab3195342$var$findLastIndex(array, predicate) {
    var l = array.length;
    while(l--){
        if (predicate(array[l], l, array)) return l;
    }
    return -1;
}
function $c7eada7ab3195342$var$formatNumericalValues(values) {
    if (values.length === 0) return "";
    var range = [
        values[0],
        values[0]
    ];
    var ranges = [];
    for(var index = 1; index < values.length; index++){
        var value = values[index];
        if (range[1] + 1 === value) range[1] = value;
        else {
            ranges.push(range[0] === range[1] ? "".concat(range[0]) : "".concat(range[0], "-").concat(range[1]));
            range = [
                value,
                value
            ];
        }
    }
    ranges.push(range[0] === range[1] ? "".concat(range[0]) : "".concat(range[0], "-").concat(range[1]));
    return ranges.join(", ");
}
// src/enum.ts
function $c7eada7ab3195342$export$d531177bc561a76e(constructor) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _config_size;
    var prefix = (_config_size = config.size) !== null && _config_size !== void 0 ? _config_size : (0, $22828546edae48c4$export$dc9732115561fb4b)();
    var _config_useValuesAsDiscriminators;
    var useValuesAsDiscriminators = (_config_useValuesAsDiscriminators = config.useValuesAsDiscriminators) !== null && _config_useValuesAsDiscriminators !== void 0 ? _config_useValuesAsDiscriminators : false;
    var _getEnumStats = $c7eada7ab3195342$var$getEnumStats(constructor), enumKeys = _getEnumStats.enumKeys, enumValues = _getEnumStats.enumValues, numericalValues = _getEnumStats.numericalValues, stringValues = _getEnumStats.stringValues;
    if (useValuesAsDiscriminators && enumValues.some(function(value) {
        return typeof value === "string";
    })) throw new (0, $c88b1e140ef0fdf7$export$8349fd9adaaed269)((0, $c88b1e140ef0fdf7$export$a2e9526594022372), {
        stringValues: enumValues.filter(function(v) {
            return typeof v === "string";
        })
    });
    return (0, $76a25877bc5f4f43$export$30169aca64409a56)(prefix, function(variant) {
        var index = $c7eada7ab3195342$var$getEnumIndexFromVariant({
            enumKeys: enumKeys,
            enumValues: enumValues,
            variant: variant
        });
        if (index < 0) throw new (0, $c88b1e140ef0fdf7$export$8349fd9adaaed269)((0, $c88b1e140ef0fdf7$export$f6bf8a7c1f3defe4), {
            formattedNumericalValues: $c7eada7ab3195342$var$formatNumericalValues(numericalValues),
            numericalValues: numericalValues,
            stringValues: stringValues,
            variant: variant
        });
        return useValuesAsDiscriminators ? enumValues[index] : index;
    });
}
function $c7eada7ab3195342$export$9999963707d133fe(constructor) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _config_size;
    var prefix = (_config_size = config.size) !== null && _config_size !== void 0 ? _config_size : (0, $22828546edae48c4$export$edadf68f5f1a8bc6)();
    var _config_useValuesAsDiscriminators;
    var useValuesAsDiscriminators = (_config_useValuesAsDiscriminators = config.useValuesAsDiscriminators) !== null && _config_useValuesAsDiscriminators !== void 0 ? _config_useValuesAsDiscriminators : false;
    var _getEnumStats = $c7eada7ab3195342$var$getEnumStats(constructor), enumKeys = _getEnumStats.enumKeys, enumValues = _getEnumStats.enumValues, numericalValues = _getEnumStats.numericalValues;
    if (useValuesAsDiscriminators && enumValues.some(function(value) {
        return typeof value === "string";
    })) throw new (0, $c88b1e140ef0fdf7$export$8349fd9adaaed269)((0, $c88b1e140ef0fdf7$export$a2e9526594022372), {
        stringValues: enumValues.filter(function(v) {
            return typeof v === "string";
        })
    });
    return (0, $76a25877bc5f4f43$export$605b10ee38669daa)(prefix, function(value) {
        var discriminator = Number(value);
        var index = $c7eada7ab3195342$var$getEnumIndexFromDiscriminator({
            discriminator: discriminator,
            enumKeys: enumKeys,
            enumValues: enumValues,
            useValuesAsDiscriminators: useValuesAsDiscriminators
        });
        if (index < 0) {
            var validDiscriminators = useValuesAsDiscriminators ? numericalValues : (0, $c6Xmf._)(Array(enumKeys.length).keys());
            throw new (0, $c88b1e140ef0fdf7$export$8349fd9adaaed269)((0, $c88b1e140ef0fdf7$export$1fa107ead8489cf2), {
                discriminator: discriminator,
                formattedValidDiscriminators: $c7eada7ab3195342$var$formatNumericalValues(validDiscriminators),
                validDiscriminators: validDiscriminators
            });
        }
        return enumValues[index];
    });
}
function $c7eada7ab3195342$export$32fbd6339c31df5a(constructor) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return (0, $76a25877bc5f4f43$export$b88681b853abde79)($c7eada7ab3195342$export$d531177bc561a76e(constructor, config), $c7eada7ab3195342$export$9999963707d133fe(constructor, config));
}
var $c7eada7ab3195342$export$b851c0039bae17a3 = $c7eada7ab3195342$export$d531177bc561a76e;
var $c7eada7ab3195342$export$8da56cb51c791874 = $c7eada7ab3195342$export$9999963707d133fe;
var $c7eada7ab3195342$export$5f12d67506fd387e = $c7eada7ab3195342$export$32fbd6339c31df5a;
function $c7eada7ab3195342$export$e68e10087ec64330(encoder, prefixedEncoders) {
    return (0, $76a25877bc5f4f43$export$30169aca64409a56)($c7eada7ab3195342$export$6b19a6a85541fd99((0, $c6Xmf._)(prefixedEncoders).concat([
        encoder
    ])), function(value) {
        return (0, $c6Xmf._)(prefixedEncoders.map(function() {
            return void 0;
        })).concat([
            value
        ]);
    });
}
function $c7eada7ab3195342$export$3e731190a51906e9(decoder, prefixedDecoders) {
    return (0, $76a25877bc5f4f43$export$605b10ee38669daa)($c7eada7ab3195342$export$9800955a9fcaec5((0, $c6Xmf._)(prefixedDecoders).concat([
        decoder
    ])), function(tuple) {
        return tuple[tuple.length - 1];
    });
}
function $c7eada7ab3195342$export$e34ca45edea62fa(codec, prefixedCodecs) {
    return (0, $76a25877bc5f4f43$export$b88681b853abde79)($c7eada7ab3195342$export$e68e10087ec64330(codec, prefixedCodecs), $c7eada7ab3195342$export$3e731190a51906e9(codec, prefixedCodecs));
}
function $c7eada7ab3195342$export$48adc3d128b1e47b(encoder, suffixedEncoders) {
    return (0, $76a25877bc5f4f43$export$30169aca64409a56)($c7eada7ab3195342$export$6b19a6a85541fd99([
        encoder
    ].concat((0, $c6Xmf._)(suffixedEncoders))), function(value) {
        return [
            value
        ].concat((0, $c6Xmf._)(suffixedEncoders.map(function() {
            return void 0;
        })));
    });
}
function $c7eada7ab3195342$export$27bbee57fb582997(decoder, suffixedDecoders) {
    return (0, $76a25877bc5f4f43$export$605b10ee38669daa)($c7eada7ab3195342$export$9800955a9fcaec5([
        decoder
    ].concat((0, $c6Xmf._)(suffixedDecoders))), function(tuple) {
        return tuple[0];
    });
}
function $c7eada7ab3195342$export$997dd3a140dcd82a(codec, suffixedCodecs) {
    return (0, $76a25877bc5f4f43$export$b88681b853abde79)($c7eada7ab3195342$export$48adc3d128b1e47b(codec, suffixedCodecs), $c7eada7ab3195342$export$27bbee57fb582997(codec, suffixedCodecs));
}
function $c7eada7ab3195342$export$75c3a7c49a778905(key, value) {
    var config = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return (0, $76a25877bc5f4f43$export$30169aca64409a56)($c7eada7ab3195342$export$415199198053c0b($c7eada7ab3195342$export$6b19a6a85541fd99([
        key,
        value
    ]), config), function(map) {
        return (0, $c6Xmf._)(map.entries());
    });
}
function $c7eada7ab3195342$export$e102943539f62962(key, value) {
    var config = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return (0, $76a25877bc5f4f43$export$605b10ee38669daa)($c7eada7ab3195342$export$9016038b2e3b0c2f($c7eada7ab3195342$export$9800955a9fcaec5([
        key,
        value
    ]), config), function(entries) {
        return new Map(entries);
    });
}
function $c7eada7ab3195342$export$191db844d92ad593(key, value) {
    var config = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return (0, $76a25877bc5f4f43$export$b88681b853abde79)($c7eada7ab3195342$export$75c3a7c49a778905(key, value, config), $c7eada7ab3195342$export$e102943539f62962(key, value, config));
}
function $c7eada7ab3195342$export$a222f4a6d9205421() {
    return (0, $76a25877bc5f4f43$export$4e76eeb6df88c889)({
        fixedSize: 0,
        write: function(_value, _bytes, offset) {
            return offset;
        }
    });
}
function $c7eada7ab3195342$export$46a76d99d5c61218() {
    return (0, $76a25877bc5f4f43$export$f8c898e83b60faaa)({
        fixedSize: 0,
        read: function(_bytes, offset) {
            return [
                void 0,
                offset
            ];
        }
    });
}
function $c7eada7ab3195342$export$68459b38e676038a() {
    return (0, $76a25877bc5f4f43$export$b88681b853abde79)($c7eada7ab3195342$export$a222f4a6d9205421(), $c7eada7ab3195342$export$46a76d99d5c61218());
}
// src/nullable.ts
function $c7eada7ab3195342$export$b0dc66f9f6de624b(item) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var prefix = function() {
        if (config.prefix === null) return (0, $76a25877bc5f4f43$export$30169aca64409a56)($c7eada7ab3195342$export$a222f4a6d9205421(), function(_boolean) {
            return void 0;
        });
        var _config_prefix;
        return $c7eada7ab3195342$export$4a518d3f98f842eb({
            size: (_config_prefix = config.prefix) !== null && _config_prefix !== void 0 ? _config_prefix : (0, $22828546edae48c4$export$dc9732115561fb4b)()
        });
    }();
    var noneValue = function() {
        if (config.noneValue === "zeroes") {
            (0, $76a25877bc5f4f43$export$4e85b7423fd6bc55)(item);
            return (0, $76a25877bc5f4f43$export$cbdfce031443a1)($c7eada7ab3195342$export$a222f4a6d9205421(), item.fixedSize);
        }
        if (!config.noneValue) return $c7eada7ab3195342$export$a222f4a6d9205421();
        return $c7eada7ab3195342$export$23a212060029ca97(config.noneValue);
    }();
    return $c7eada7ab3195342$export$a9351c88c0e29fc0([
        (0, $76a25877bc5f4f43$export$30169aca64409a56)($c7eada7ab3195342$export$6b19a6a85541fd99([
            prefix,
            noneValue
        ]), function(_value) {
            return [
                false,
                void 0
            ];
        }),
        (0, $76a25877bc5f4f43$export$30169aca64409a56)($c7eada7ab3195342$export$6b19a6a85541fd99([
            prefix,
            item
        ]), function(value) {
            return [
                true,
                value
            ];
        })
    ], function(variant) {
        return Number(variant !== null);
    });
}
function $c7eada7ab3195342$export$320bb1c6ae316289(item) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var prefix = function() {
        if (config.prefix === null) return (0, $76a25877bc5f4f43$export$605b10ee38669daa)($c7eada7ab3195342$export$46a76d99d5c61218(), function() {
            return false;
        });
        var _config_prefix;
        return $c7eada7ab3195342$export$43a73c742ad521e1({
            size: (_config_prefix = config.prefix) !== null && _config_prefix !== void 0 ? _config_prefix : (0, $22828546edae48c4$export$edadf68f5f1a8bc6)()
        });
    }();
    var noneValue = function() {
        if (config.noneValue === "zeroes") {
            (0, $76a25877bc5f4f43$export$4e85b7423fd6bc55)(item);
            return (0, $76a25877bc5f4f43$export$1f85f8b8d2788007)($c7eada7ab3195342$export$46a76d99d5c61218(), item.fixedSize);
        }
        if (!config.noneValue) return $c7eada7ab3195342$export$46a76d99d5c61218();
        return $c7eada7ab3195342$export$13c771567a4019f7(config.noneValue);
    }();
    return $c7eada7ab3195342$export$ba967eb6bc7384b7([
        (0, $76a25877bc5f4f43$export$605b10ee38669daa)($c7eada7ab3195342$export$9800955a9fcaec5([
            prefix,
            noneValue
        ]), function() {
            return null;
        }),
        (0, $76a25877bc5f4f43$export$605b10ee38669daa)($c7eada7ab3195342$export$9800955a9fcaec5([
            prefix,
            item
        ]), function(param) {
            var _param = (0, $cv9Rk._)(param, 2), value = _param[1];
            return value;
        })
    ], function(bytes, offset) {
        if (config.prefix === null && !config.noneValue) return Number(offset < bytes.length);
        if (config.prefix === null && config.noneValue != null) {
            var zeroValue = config.noneValue === "zeroes" ? new Uint8Array(noneValue.fixedSize).fill(0) : config.noneValue;
            return (0, $76a25877bc5f4f43$export$1b62aef2a79e6b21)(bytes, zeroValue, offset) ? 0 : 1;
        }
        return Number(prefix.read(bytes, offset)[0]);
    });
}
function $c7eada7ab3195342$export$ac13939aa9a57a06(item) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return (0, $76a25877bc5f4f43$export$b88681b853abde79)($c7eada7ab3195342$export$b0dc66f9f6de624b(item, config), $c7eada7ab3195342$export$320bb1c6ae316289(item, config));
}
function $c7eada7ab3195342$export$b5f13ff6baa9ba6c(item) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return (0, $76a25877bc5f4f43$export$30169aca64409a56)($c7eada7ab3195342$export$415199198053c0b(item, config), function(set) {
        return (0, $c6Xmf._)(set);
    });
}
function $c7eada7ab3195342$export$b5164526d93d52f2(item) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return (0, $76a25877bc5f4f43$export$605b10ee38669daa)($c7eada7ab3195342$export$9016038b2e3b0c2f(item, config), function(entries) {
        return new Set(entries);
    });
}
function $c7eada7ab3195342$export$a7c6e50519818c5d(item) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return (0, $76a25877bc5f4f43$export$b88681b853abde79)($c7eada7ab3195342$export$b5f13ff6baa9ba6c(item, config), $c7eada7ab3195342$export$b5164526d93d52f2(item, config));
}
function $c7eada7ab3195342$export$64024546a32014b8(fields) {
    var fieldCodecs = fields.map(function(param) {
        var _param = (0, $cv9Rk._)(param, 2), codec = _param[1];
        return codec;
    });
    var fixedSize = $c7eada7ab3195342$var$sumCodecSizes(fieldCodecs.map($c7eada7ab3195342$var$getFixedSize));
    var _sumCodecSizes;
    var maxSize = (_sumCodecSizes = $c7eada7ab3195342$var$sumCodecSizes(fieldCodecs.map($c7eada7ab3195342$var$getMaxSize))) !== null && _sumCodecSizes !== void 0 ? _sumCodecSizes : void 0;
    return (0, $76a25877bc5f4f43$export$4e76eeb6df88c889)((0, $cxjpp._)((0, $do9pw._)({}, fixedSize === null ? {
        getSizeFromValue: function(value) {
            return fields.map(function(param) {
                var _param = (0, $cv9Rk._)(param, 2), key = _param[0], codec = _param[1];
                return (0, $76a25877bc5f4f43$export$30f3257599397621)(value[key], codec);
            }).reduce(function(all, one) {
                return all + one;
            }, 0);
        },
        maxSize: maxSize
    } : {
        fixedSize: fixedSize
    }), {
        write: function(struct, bytes, offset) {
            fields.forEach(function(param) {
                var _param = (0, $cv9Rk._)(param, 2), key = _param[0], codec = _param[1];
                offset = codec.write(struct[key], bytes, offset);
            });
            return offset;
        }
    }));
}
function $c7eada7ab3195342$export$7070fbe048971470(fields) {
    var fieldCodecs = fields.map(function(param) {
        var _param = (0, $cv9Rk._)(param, 2), codec = _param[1];
        return codec;
    });
    var fixedSize = $c7eada7ab3195342$var$sumCodecSizes(fieldCodecs.map($c7eada7ab3195342$var$getFixedSize));
    var _sumCodecSizes;
    var maxSize = (_sumCodecSizes = $c7eada7ab3195342$var$sumCodecSizes(fieldCodecs.map($c7eada7ab3195342$var$getMaxSize))) !== null && _sumCodecSizes !== void 0 ? _sumCodecSizes : void 0;
    return (0, $76a25877bc5f4f43$export$f8c898e83b60faaa)((0, $cxjpp._)((0, $do9pw._)({}, fixedSize === null ? {
        maxSize: maxSize
    } : {
        fixedSize: fixedSize
    }), {
        read: function(bytes, offset) {
            var struct = {};
            fields.forEach(function(param) {
                var _param = (0, $cv9Rk._)(param, 2), key = _param[0], codec = _param[1];
                var _codec_read = (0, $cv9Rk._)(codec.read(bytes, offset), 2), value = _codec_read[0], newOffset = _codec_read[1];
                offset = newOffset;
                struct[key] = value;
            });
            return [
                struct,
                offset
            ];
        }
    }));
}
function $c7eada7ab3195342$export$e7bbe4696420bde8(fields) {
    return (0, $76a25877bc5f4f43$export$b88681b853abde79)($c7eada7ab3195342$export$64024546a32014b8(fields), $c7eada7ab3195342$export$7070fbe048971470(fields));
}
 //# sourceMappingURL=out.js.map


var $15bf6bcc226e68ec$var$tokenGroupCodec = (0, $c7eada7ab3195342$export$e7bbe4696420bde8)([
    [
        "updateAuthority",
        (0, $76a25877bc5f4f43$export$ff7dc697d5cc308f)((0, $c7eada7ab3195342$export$f3c2d67c19d09b74)(), 32)
    ],
    [
        "mint",
        (0, $76a25877bc5f4f43$export$ff7dc697d5cc308f)((0, $c7eada7ab3195342$export$f3c2d67c19d09b74)(), 32)
    ],
    [
        "size",
        (0, $22828546edae48c4$export$172bf721fe9bbfd1)()
    ],
    [
        "maxSize",
        (0, $22828546edae48c4$export$172bf721fe9bbfd1)()
    ]
]);
var $15bf6bcc226e68ec$export$83b408df29875efc = $15bf6bcc226e68ec$var$tokenGroupCodec.fixedSize;
// Checks if all elements in the array are 0
function $15bf6bcc226e68ec$var$isNonePubkey(buffer) {
    for(var i = 0; i < buffer.length; i++){
        if (buffer[i] !== 0) return false;
    }
    return true;
}
function $15bf6bcc226e68ec$export$861b848ad534e6d5(group) {
    var _group_updateAuthority;
    // If no updateAuthority given, set it to the None/Zero PublicKey for encoding
    var updateAuthority = (_group_updateAuthority = group.updateAuthority) !== null && _group_updateAuthority !== void 0 ? _group_updateAuthority : (0, $69N5M.PublicKey).default;
    return $15bf6bcc226e68ec$var$tokenGroupCodec.encode({
        updateAuthority: updateAuthority.toBuffer(),
        mint: group.mint.toBuffer(),
        size: group.size,
        maxSize: group.maxSize
    });
}
function $15bf6bcc226e68ec$export$28d9c2954cb7f24e(buffer) {
    var data = $15bf6bcc226e68ec$var$tokenGroupCodec.decode(buffer);
    return $15bf6bcc226e68ec$var$isNonePubkey(data.updateAuthority) ? {
        mint: new (0, $69N5M.PublicKey)(data.mint),
        size: data.size,
        maxSize: data.maxSize
    } : {
        updateAuthority: new (0, $69N5M.PublicKey)(data.updateAuthority),
        mint: new (0, $69N5M.PublicKey)(data.mint),
        size: data.size,
        maxSize: data.maxSize
    };
}


var $69N5M = parcelRequire("69N5M");

var $e95ef6829b67db47$var$tokenGroupMemberCodec = (0, $c7eada7ab3195342$export$e7bbe4696420bde8)([
    [
        "mint",
        (0, $76a25877bc5f4f43$export$ff7dc697d5cc308f)((0, $c7eada7ab3195342$export$f3c2d67c19d09b74)(), 32)
    ],
    [
        "group",
        (0, $76a25877bc5f4f43$export$ff7dc697d5cc308f)((0, $c7eada7ab3195342$export$f3c2d67c19d09b74)(), 32)
    ],
    [
        "memberNumber",
        (0, $22828546edae48c4$export$172bf721fe9bbfd1)()
    ]
]);
var $e95ef6829b67db47$export$922ab442b9cf73bd = $e95ef6829b67db47$var$tokenGroupMemberCodec.fixedSize;
function $e95ef6829b67db47$export$57f8603c3835e979(member) {
    return $e95ef6829b67db47$var$tokenGroupMemberCodec.encode({
        mint: member.mint.toBuffer(),
        group: member.group.toBuffer(),
        memberNumber: member.memberNumber
    });
}
function $e95ef6829b67db47$export$1724e5edf41d9e41(buffer) {
    var data = $e95ef6829b67db47$var$tokenGroupMemberCodec.decode(buffer);
    return {
        mint: new (0, $69N5M.PublicKey)(data.mint),
        group: new (0, $69N5M.PublicKey)(data.group),
        memberNumber: data.memberNumber
    };
}



var $jt90m = parcelRequire("jt90m");


var $69N5M = parcelRequire("69N5M");

var $1ce548d4184aa8a7$export$b9dda2426c86a44d = (0, $jt90m.struct)([
    (0, $3285baf77b253a0b$export$86f13247979de5d7)("authority"),
    (0, $3285baf77b253a0b$export$86f13247979de5d7)("memberAddress")
]);
var $1ce548d4184aa8a7$export$f4d582c48d8cc7e7 = $1ce548d4184aa8a7$export$b9dda2426c86a44d.span;
function $1ce548d4184aa8a7$export$5562dfc68f7b75f4(mint) {
    var extensionData = (0, $8a9fbac74071e86b$export$4fff3ed4eba4f4ee)((0, $8a9fbac74071e86b$export$4f037c6ec2da4eeb).GroupMemberPointer, mint.tlvData);
    if (extensionData !== null) {
        var _GroupMemberPointerLayout_decode = $1ce548d4184aa8a7$export$b9dda2426c86a44d.decode(extensionData), authority = _GroupMemberPointerLayout_decode.authority, memberAddress = _GroupMemberPointerLayout_decode.memberAddress;
        // Explicitly set None/Zero keys to null
        return {
            authority: authority.equals((0, $69N5M.PublicKey).default) ? null : authority,
            memberAddress: memberAddress.equals((0, $69N5M.PublicKey).default) ? null : memberAddress
        };
    } else return null;
}



var $jt90m = parcelRequire("jt90m");


var $69N5M = parcelRequire("69N5M");

var $ceb25c2497c4f62e$export$511631140e2874fe = (0, $jt90m.struct)([
    (0, $3285baf77b253a0b$export$86f13247979de5d7)("authority"),
    (0, $3285baf77b253a0b$export$86f13247979de5d7)("groupAddress")
]);
var $ceb25c2497c4f62e$export$3852a2b4ecb1c96c = $ceb25c2497c4f62e$export$511631140e2874fe.span;
function $ceb25c2497c4f62e$export$9dc2a030696ac8a7(mint) {
    var extensionData = (0, $8a9fbac74071e86b$export$4fff3ed4eba4f4ee)((0, $8a9fbac74071e86b$export$4f037c6ec2da4eeb).GroupPointer, mint.tlvData);
    if (extensionData !== null) {
        var _GroupPointerLayout_decode = $ceb25c2497c4f62e$export$511631140e2874fe.decode(extensionData), authority = _GroupPointerLayout_decode.authority, groupAddress = _GroupPointerLayout_decode.groupAddress;
        // Explicitly set None/Zero keys to null
        return {
            authority: authority.equals((0, $69N5M.PublicKey).default) ? null : authority,
            groupAddress: groupAddress.equals((0, $69N5M.PublicKey).default) ? null : groupAddress
        };
    } else return null;
}



var $jt90m = parcelRequire("jt90m");

var $609c32eafafea420$export$3b7e34eff13c869c = (0, $jt90m.struct)([]);
var $609c32eafafea420$export$4ba1dedcafaef535 = $609c32eafafea420$export$3b7e34eff13c869c.span;
function $609c32eafafea420$export$ff9fc6dae6f7d7a0(account) {
    var extensionData = (0, $8a9fbac74071e86b$export$4fff3ed4eba4f4ee)((0, $8a9fbac74071e86b$export$4f037c6ec2da4eeb).ImmutableOwner, account.tlvData);
    if (extensionData !== null) return $609c32eafafea420$export$3b7e34eff13c869c.decode(extensionData);
    else return null;
}



var $jt90m = parcelRequire("jt90m");


var $f3ca28dba318d0c6$export$dea2930f2b4b5995 = (0, $jt90m.struct)([
    (0, $3285baf77b253a0b$export$86f13247979de5d7)("rateAuthority"),
    (0, $jt90m.ns64)("initializationTimestamp"),
    (0, $jt90m.s16)("preUpdateAverageRate"),
    (0, $jt90m.ns64)("lastUpdateTimestamp"),
    (0, $jt90m.s16)("currentRate")
]);
var $f3ca28dba318d0c6$export$5deaa22b862a446f = $f3ca28dba318d0c6$export$dea2930f2b4b5995.span;
function $f3ca28dba318d0c6$export$c0f4cb585bb22702(mint) {
    var extensionData = (0, $8a9fbac74071e86b$export$4fff3ed4eba4f4ee)((0, $8a9fbac74071e86b$export$4f037c6ec2da4eeb).InterestBearingConfig, mint.tlvData);
    if (extensionData !== null) return $f3ca28dba318d0c6$export$dea2930f2b4b5995.decode(extensionData);
    return null;
}



var $jt90m = parcelRequire("jt90m");


var $5ac6a954cb55640b$export$5607c4289fc50398 = (0, $jt90m.struct)([
    (0, $41e55d51244b5d43$export$87b259aa03e3d267)("requireIncomingTransferMemos")
]);
var $5ac6a954cb55640b$export$f4b5375ad34477a1 = $5ac6a954cb55640b$export$5607c4289fc50398.span;
function $5ac6a954cb55640b$export$3f4bed2e631f122c(account) {
    var extensionData = (0, $8a9fbac74071e86b$export$4fff3ed4eba4f4ee)((0, $8a9fbac74071e86b$export$4f037c6ec2da4eeb).MemoTransfer, account.tlvData);
    if (extensionData !== null) return $5ac6a954cb55640b$export$5607c4289fc50398.decode(extensionData);
    else return null;
}



var $jt90m = parcelRequire("jt90m");


var $69N5M = parcelRequire("69N5M");

var $0573eafe34cdb568$export$4dfd642335bea3f4 = (0, $jt90m.struct)([
    (0, $3285baf77b253a0b$export$86f13247979de5d7)("authority"),
    (0, $3285baf77b253a0b$export$86f13247979de5d7)("metadataAddress")
]);
var $0573eafe34cdb568$export$46bfcd668f9095d0 = $0573eafe34cdb568$export$4dfd642335bea3f4.span;
function $0573eafe34cdb568$export$eef22d421b9622d(mint) {
    var extensionData = (0, $8a9fbac74071e86b$export$4fff3ed4eba4f4ee)((0, $8a9fbac74071e86b$export$4f037c6ec2da4eeb).MetadataPointer, mint.tlvData);
    if (extensionData !== null) {
        var _MetadataPointerLayout_decode = $0573eafe34cdb568$export$4dfd642335bea3f4.decode(extensionData), authority = _MetadataPointerLayout_decode.authority, metadataAddress = _MetadataPointerLayout_decode.metadataAddress;
        // Explicitly set None/Zero keys to null
        return {
            authority: authority.equals((0, $69N5M.PublicKey).default) ? null : authority,
            metadataAddress: metadataAddress.equals((0, $69N5M.PublicKey).default) ? null : metadataAddress
        };
    } else return null;
}



var $jt90m = parcelRequire("jt90m");


var $a4a54deb514b29ac$export$ece081d471f0fc95 = (0, $jt90m.struct)([
    (0, $3285baf77b253a0b$export$86f13247979de5d7)("closeAuthority")
]);
var $a4a54deb514b29ac$export$1e1aa83bde32eb68 = $a4a54deb514b29ac$export$ece081d471f0fc95.span;
function $a4a54deb514b29ac$export$bfd41dfeb5917197(mint) {
    var extensionData = (0, $8a9fbac74071e86b$export$4fff3ed4eba4f4ee)((0, $8a9fbac74071e86b$export$4f037c6ec2da4eeb).MintCloseAuthority, mint.tlvData);
    if (extensionData !== null) return $a4a54deb514b29ac$export$ece081d471f0fc95.decode(extensionData);
    else return null;
}



var $jt90m = parcelRequire("jt90m");

var $b02bb390329a1a0b$export$bae9d70f4fd33725 = (0, $jt90m.struct)([]);
var $b02bb390329a1a0b$export$31a113d46d052efb = $b02bb390329a1a0b$export$bae9d70f4fd33725.span;
var $b02bb390329a1a0b$export$91a6e2e8798d2502 = $b02bb390329a1a0b$export$bae9d70f4fd33725.span;
function $b02bb390329a1a0b$export$718a9bb289be2420(mint) {
    var extensionData = (0, $8a9fbac74071e86b$export$4fff3ed4eba4f4ee)((0, $8a9fbac74071e86b$export$4f037c6ec2da4eeb).NonTransferable, mint.tlvData);
    if (extensionData !== null) return $b02bb390329a1a0b$export$bae9d70f4fd33725.decode(extensionData);
    else return null;
}
function $b02bb390329a1a0b$export$a8f1f408ee730236(account) {
    var extensionData = (0, $8a9fbac74071e86b$export$4fff3ed4eba4f4ee)((0, $8a9fbac74071e86b$export$4f037c6ec2da4eeb).NonTransferableAccount, account.tlvData);
    if (extensionData !== null) return $b02bb390329a1a0b$export$bae9d70f4fd33725.decode(extensionData);
    else return null;
}



var $jt90m = parcelRequire("jt90m");


var $5f36f627a1468f95$export$1d6e8e6f44705001 = (0, $jt90m.struct)([
    (0, $3285baf77b253a0b$export$86f13247979de5d7)("delegate")
]);
var $5f36f627a1468f95$export$636ea2373b6c6b7d = $5f36f627a1468f95$export$1d6e8e6f44705001.span;
function $5f36f627a1468f95$export$3d161872832356b0(mint) {
    var extensionData = (0, $8a9fbac74071e86b$export$4fff3ed4eba4f4ee)((0, $8a9fbac74071e86b$export$4f037c6ec2da4eeb).PermanentDelegate, mint.tlvData);
    if (extensionData !== null) return $5f36f627a1468f95$export$1d6e8e6f44705001.decode(extensionData);
    else return null;
}



var $jt90m = parcelRequire("jt90m");


var $f6740f0676a0748b$export$7bf230db5a769018 = 10000;
var $f6740f0676a0748b$export$8a34ad2d496101b6 = BigInt($f6740f0676a0748b$export$7bf230db5a769018);
function $f6740f0676a0748b$export$35e5691ab3997dac(property) {
    return (0, $jt90m.struct)([
        (0, $59bc11fd00a6333b$export$cd1442401e54cffa)("epoch"),
        (0, $59bc11fd00a6333b$export$cd1442401e54cffa)("maximumFee"),
        (0, $jt90m.u16)("transferFeeBasisPoints")
    ], property);
}
function $f6740f0676a0748b$export$8c3f5e003a1e38c7(transferFee, preFeeAmount) {
    var transferFeeBasisPoints = transferFee.transferFeeBasisPoints;
    if (transferFeeBasisPoints === 0 || preFeeAmount === BigInt(0)) return BigInt(0);
    else {
        var numerator = preFeeAmount * BigInt(transferFeeBasisPoints);
        var rawFee = (numerator + $f6740f0676a0748b$export$8a34ad2d496101b6 - BigInt(1)) / $f6740f0676a0748b$export$8a34ad2d496101b6;
        var fee = rawFee > transferFee.maximumFee ? transferFee.maximumFee : rawFee;
        return BigInt(fee);
    }
}
var $f6740f0676a0748b$export$c849e8e6e4ae7e4b = (0, $jt90m.struct)([
    (0, $3285baf77b253a0b$export$86f13247979de5d7)("transferFeeConfigAuthority"),
    (0, $3285baf77b253a0b$export$86f13247979de5d7)("withdrawWithheldAuthority"),
    (0, $59bc11fd00a6333b$export$cd1442401e54cffa)("withheldAmount"),
    $f6740f0676a0748b$export$35e5691ab3997dac("olderTransferFee"),
    $f6740f0676a0748b$export$35e5691ab3997dac("newerTransferFee")
]);
var $f6740f0676a0748b$export$972cf5dcc13158da = $f6740f0676a0748b$export$c849e8e6e4ae7e4b.span;
function $f6740f0676a0748b$export$2e57a339fb6e8894(transferFeeConfig, epoch) {
    if (epoch >= transferFeeConfig.newerTransferFee.epoch) return transferFeeConfig.newerTransferFee;
    else return transferFeeConfig.olderTransferFee;
}
function $f6740f0676a0748b$export$c8f0c7e4622306bc(transferFeeConfig, epoch, preFeeAmount) {
    var transferFee = $f6740f0676a0748b$export$2e57a339fb6e8894(transferFeeConfig, epoch);
    return $f6740f0676a0748b$export$8c3f5e003a1e38c7(transferFee, preFeeAmount);
}
var $f6740f0676a0748b$export$a20fb363192b96a2 = (0, $jt90m.struct)([
    (0, $59bc11fd00a6333b$export$cd1442401e54cffa)("withheldAmount")
]);
var $f6740f0676a0748b$export$8657a852ae4f4019 = $f6740f0676a0748b$export$a20fb363192b96a2.span;
function $f6740f0676a0748b$export$451dabe4cdde5d9a(mint) {
    var extensionData = (0, $8a9fbac74071e86b$export$4fff3ed4eba4f4ee)((0, $8a9fbac74071e86b$export$4f037c6ec2da4eeb).TransferFeeConfig, mint.tlvData);
    if (extensionData !== null) return $f6740f0676a0748b$export$c849e8e6e4ae7e4b.decode(extensionData);
    else return null;
}
function $f6740f0676a0748b$export$857f13d8ce75ecd9(account) {
    var extensionData = (0, $8a9fbac74071e86b$export$4fff3ed4eba4f4ee)((0, $8a9fbac74071e86b$export$4f037c6ec2da4eeb).TransferFeeAmount, account.tlvData);
    if (extensionData !== null) return $f6740f0676a0748b$export$a20fb363192b96a2.decode(extensionData);
    else return null;
}



var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $jt90m = parcelRequire("jt90m");


var $69N5M = parcelRequire("69N5M");



var $kSuI9 = parcelRequire("kSuI9");

var $cv9Rk = parcelRequire("cv9Rk");

var $gdHfP = parcelRequire("gdHfP");

var $eha6O = parcelRequire("eha6O");


var $8dlmd = parcelRequire("8dlmd");
var $cfb1c2509438b6c4$require$Buffer = $8dlmd.Buffer;
var $cfb1c2509438b6c4$var$DISCRIMINATOR_SPAN = 1;
var $cfb1c2509438b6c4$var$LITERAL_LENGTH_SPAN = 1;
var $cfb1c2509438b6c4$var$INSTRUCTION_ARG_OFFSET_SPAN = 1;
var $cfb1c2509438b6c4$var$INSTRUCTION_ARG_LENGTH_SPAN = 1;
var $cfb1c2509438b6c4$var$ACCOUNT_KEY_INDEX_SPAN = 1;
var $cfb1c2509438b6c4$var$ACCOUNT_DATA_ACCOUNT_INDEX_SPAN = 1;
var $cfb1c2509438b6c4$var$ACCOUNT_DATA_OFFSET_SPAN = 1;
var $cfb1c2509438b6c4$var$ACCOUNT_DATA_LENGTH_SPAN = 1;
function $cfb1c2509438b6c4$var$unpackSeedLiteral(seeds) {
    if (seeds.length < 1) throw new (0, $0974668e835203eb$export$9fe40fd85b8108b)();
    var _seeds = (0, $gdHfP._)(seeds), length = _seeds[0], rest = _seeds.slice(1);
    if (rest.length < length) throw new (0, $0974668e835203eb$export$9fe40fd85b8108b)();
    return {
        data: $cfb1c2509438b6c4$require$Buffer.from(rest.slice(0, length)),
        packedLength: $cfb1c2509438b6c4$var$DISCRIMINATOR_SPAN + $cfb1c2509438b6c4$var$LITERAL_LENGTH_SPAN + length
    };
}
function $cfb1c2509438b6c4$var$unpackSeedInstructionArg(seeds, instructionData) {
    if (seeds.length < 2) throw new (0, $0974668e835203eb$export$9fe40fd85b8108b)();
    var _seeds = (0, $cv9Rk._)(seeds, 2), index = _seeds[0], length = _seeds[1];
    if (instructionData.length < length + index) throw new (0, $0974668e835203eb$export$9fe40fd85b8108b)();
    return {
        data: instructionData.subarray(index, index + length),
        packedLength: $cfb1c2509438b6c4$var$DISCRIMINATOR_SPAN + $cfb1c2509438b6c4$var$INSTRUCTION_ARG_OFFSET_SPAN + $cfb1c2509438b6c4$var$INSTRUCTION_ARG_LENGTH_SPAN
    };
}
function $cfb1c2509438b6c4$var$unpackSeedAccountKey(seeds, previousMetas) {
    if (seeds.length < 1) throw new (0, $0974668e835203eb$export$9fe40fd85b8108b)();
    var _seeds = (0, $cv9Rk._)(seeds, 1), index = _seeds[0];
    if (previousMetas.length <= index) throw new (0, $0974668e835203eb$export$9fe40fd85b8108b)();
    return {
        data: previousMetas[index].pubkey.toBuffer(),
        packedLength: $cfb1c2509438b6c4$var$DISCRIMINATOR_SPAN + $cfb1c2509438b6c4$var$ACCOUNT_KEY_INDEX_SPAN
    };
}
function $cfb1c2509438b6c4$var$unpackSeedAccountData(seeds, previousMetas, connection) {
    return $cfb1c2509438b6c4$var$_unpackSeedAccountData.apply(this, arguments);
}
function $cfb1c2509438b6c4$var$_unpackSeedAccountData() {
    $cfb1c2509438b6c4$var$_unpackSeedAccountData = (0, $kSuI9._)(function(seeds, previousMetas, connection) {
        var _seeds, accountIndex, dataIndex, length, accountInfo;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (seeds.length < 3) throw new (0, $0974668e835203eb$export$9fe40fd85b8108b)();
                    _seeds = (0, $cv9Rk._)(seeds, 3), accountIndex = _seeds[0], dataIndex = _seeds[1], length = _seeds[2];
                    if (previousMetas.length <= accountIndex) throw new (0, $0974668e835203eb$export$9fe40fd85b8108b)();
                    return [
                        4,
                        connection.getAccountInfo(previousMetas[accountIndex].pubkey)
                    ];
                case 1:
                    accountInfo = _state.sent();
                    if (accountInfo == null) throw new (0, $0974668e835203eb$export$de66998ed6d15b14)();
                    if (accountInfo.data.length < dataIndex + length) throw new (0, $0974668e835203eb$export$9fe40fd85b8108b)();
                    return [
                        2,
                        {
                            data: accountInfo.data.subarray(dataIndex, dataIndex + length),
                            packedLength: $cfb1c2509438b6c4$var$DISCRIMINATOR_SPAN + $cfb1c2509438b6c4$var$ACCOUNT_DATA_ACCOUNT_INDEX_SPAN + $cfb1c2509438b6c4$var$ACCOUNT_DATA_OFFSET_SPAN + $cfb1c2509438b6c4$var$ACCOUNT_DATA_LENGTH_SPAN
                        }
                    ];
            }
        });
    });
    return $cfb1c2509438b6c4$var$_unpackSeedAccountData.apply(this, arguments);
}
function $cfb1c2509438b6c4$var$unpackFirstSeed(seeds, previousMetas, instructionData, connection) {
    return $cfb1c2509438b6c4$var$_unpackFirstSeed.apply(this, arguments);
}
function $cfb1c2509438b6c4$var$_unpackFirstSeed() {
    $cfb1c2509438b6c4$var$_unpackFirstSeed = (0, $kSuI9._)(function(seeds, previousMetas, instructionData, connection) {
        var _seeds, discriminator, rest, remaining;
        return (0, $eha6O.__generator)(this, function(_state) {
            _seeds = (0, $gdHfP._)(seeds), discriminator = _seeds[0], rest = _seeds.slice(1);
            remaining = new Uint8Array(rest);
            switch(discriminator){
                case 0:
                    return [
                        2,
                        null
                    ];
                case 1:
                    return [
                        2,
                        $cfb1c2509438b6c4$var$unpackSeedLiteral(remaining)
                    ];
                case 2:
                    return [
                        2,
                        $cfb1c2509438b6c4$var$unpackSeedInstructionArg(remaining, instructionData)
                    ];
                case 3:
                    return [
                        2,
                        $cfb1c2509438b6c4$var$unpackSeedAccountKey(remaining, previousMetas)
                    ];
                case 4:
                    return [
                        2,
                        $cfb1c2509438b6c4$var$unpackSeedAccountData(remaining, previousMetas, connection)
                    ];
                default:
                    throw new (0, $0974668e835203eb$export$9fe40fd85b8108b)();
            }
            return [
                2
            ];
        });
    });
    return $cfb1c2509438b6c4$var$_unpackFirstSeed.apply(this, arguments);
}
function $cfb1c2509438b6c4$export$e3c2327a8649c7d4(seeds, previousMetas, instructionData, connection) {
    return $cfb1c2509438b6c4$var$_unpackSeeds.apply(this, arguments);
}
function $cfb1c2509438b6c4$var$_unpackSeeds() {
    $cfb1c2509438b6c4$var$_unpackSeeds = (0, $kSuI9._)(function(seeds, previousMetas, instructionData, connection) {
        var unpackedSeeds, i, seed;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    unpackedSeeds = [];
                    i = 0;
                    _state.label = 1;
                case 1:
                    if (!(i < 32)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        $cfb1c2509438b6c4$var$unpackFirstSeed(seeds.slice(i), previousMetas, instructionData, connection)
                    ];
                case 2:
                    seed = _state.sent();
                    if (seed == null) return [
                        3,
                        3
                    ];
                    unpackedSeeds.push(seed.data);
                    i += seed.packedLength;
                    return [
                        3,
                        1
                    ];
                case 3:
                    return [
                        2,
                        unpackedSeeds
                    ];
            }
        });
    });
    return $cfb1c2509438b6c4$var$_unpackSeeds.apply(this, arguments);
}



var $8dlmd = parcelRequire("8dlmd");
var $531c01471b5fe543$require$Buffer = $8dlmd.Buffer;
var $531c01471b5fe543$export$ce2e6042aff3c26e = (0, $jt90m.struct)([
    (0, $3285baf77b253a0b$export$86f13247979de5d7)("authority"),
    (0, $3285baf77b253a0b$export$86f13247979de5d7)("programId")
]);
var $531c01471b5fe543$export$5ade3cdfd72ee348 = $531c01471b5fe543$export$ce2e6042aff3c26e.span;
function $531c01471b5fe543$export$eb429b5bab502847(mint) {
    var extensionData = (0, $8a9fbac74071e86b$export$4fff3ed4eba4f4ee)((0, $8a9fbac74071e86b$export$4f037c6ec2da4eeb).TransferHook, mint.tlvData);
    if (extensionData !== null) return $531c01471b5fe543$export$ce2e6042aff3c26e.decode(extensionData);
    else return null;
}
var $531c01471b5fe543$export$28d4d57b6bd1f0ec = (0, $jt90m.struct)([
    (0, $41e55d51244b5d43$export$87b259aa03e3d267)("transferring")
]);
var $531c01471b5fe543$export$998fd74b23e70abd = $531c01471b5fe543$export$28d4d57b6bd1f0ec.span;
function $531c01471b5fe543$export$67421072ccffa447(account) {
    var extensionData = (0, $8a9fbac74071e86b$export$4fff3ed4eba4f4ee)((0, $8a9fbac74071e86b$export$4f037c6ec2da4eeb).TransferHookAccount, account.tlvData);
    if (extensionData !== null) return $531c01471b5fe543$export$28d4d57b6bd1f0ec.decode(extensionData);
    else return null;
}
function $531c01471b5fe543$export$92a7ba5e4a13b776(mint, programId) {
    var seeds = [
        $531c01471b5fe543$require$Buffer.from("extra-account-metas"),
        mint.toBuffer()
    ];
    return (0, $69N5M.PublicKey).findProgramAddressSync(seeds, programId)[0];
}
var $531c01471b5fe543$export$38015d717b952b07 = (0, $jt90m.struct)([
    (0, $jt90m.u8)("discriminator"),
    (0, $jt90m.blob)(32, "addressConfig"),
    (0, $41e55d51244b5d43$export$87b259aa03e3d267)("isSigner"),
    (0, $41e55d51244b5d43$export$87b259aa03e3d267)("isWritable")
]);
var $531c01471b5fe543$export$547d3e194f2ec408 = (0, $jt90m.struct)([
    (0, $jt90m.u32)("count"),
    (0, $jt90m.seq)($531c01471b5fe543$export$38015d717b952b07, (0, $jt90m.greedy)($531c01471b5fe543$export$38015d717b952b07.span), "extraAccounts")
]);
var $531c01471b5fe543$export$e8f817468b384f2f = (0, $jt90m.struct)([
    (0, $59bc11fd00a6333b$export$cd1442401e54cffa)("instructionDiscriminator"),
    (0, $jt90m.u32)("length"),
    $531c01471b5fe543$export$547d3e194f2ec408.replicate("extraAccountsList")
]);
function $531c01471b5fe543$export$b7fb7bf27b1d242(account) {
    var extraAccountsList = $531c01471b5fe543$export$e8f817468b384f2f.decode(account.data).extraAccountsList;
    return extraAccountsList.extraAccounts.slice(0, extraAccountsList.count);
}
function $531c01471b5fe543$export$a538050d412c5646(connection, extraMeta, previousMetas, instructionData, transferHookProgramId) {
    return $531c01471b5fe543$var$_resolveExtraAccountMeta.apply(this, arguments);
}
function $531c01471b5fe543$var$_resolveExtraAccountMeta() {
    $531c01471b5fe543$var$_resolveExtraAccountMeta = (0, $kSuI9._)(function(connection, extraMeta, previousMetas, instructionData, transferHookProgramId) {
        var programId, accountIndex, seeds, pubkey;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (extraMeta.discriminator === 0) return [
                        2,
                        {
                            pubkey: new (0, $69N5M.PublicKey)(extraMeta.addressConfig),
                            isSigner: extraMeta.isSigner,
                            isWritable: extraMeta.isWritable
                        }
                    ];
                    programId = (0, $69N5M.PublicKey).default;
                    if (extraMeta.discriminator === 1) programId = transferHookProgramId;
                    else {
                        accountIndex = extraMeta.discriminator - 128;
                        if (previousMetas.length <= accountIndex) throw new (0, $0974668e835203eb$export$f515f489e4a79004)();
                        programId = previousMetas[accountIndex].pubkey;
                    }
                    return [
                        4,
                        (0, $cfb1c2509438b6c4$export$e3c2327a8649c7d4)(extraMeta.addressConfig, previousMetas, instructionData, connection)
                    ];
                case 1:
                    seeds = _state.sent();
                    pubkey = (0, $69N5M.PublicKey).findProgramAddressSync(seeds, programId)[0];
                    return [
                        2,
                        {
                            pubkey: pubkey,
                            isSigner: extraMeta.isSigner,
                            isWritable: extraMeta.isWritable
                        }
                    ];
            }
        });
    });
    return $531c01471b5fe543$var$_resolveExtraAccountMeta.apply(this, arguments);
}



var $8a9fbac74071e86b$export$4f037c6ec2da4eeb;
(function(ExtensionType) {
    ExtensionType[ExtensionType["Uninitialized"] = 0] = "Uninitialized";
    ExtensionType[ExtensionType["TransferFeeConfig"] = 1] = "TransferFeeConfig";
    ExtensionType[ExtensionType["TransferFeeAmount"] = 2] = "TransferFeeAmount";
    ExtensionType[ExtensionType["MintCloseAuthority"] = 3] = "MintCloseAuthority";
    ExtensionType[ExtensionType["ConfidentialTransferMint"] = 4] = "ConfidentialTransferMint";
    ExtensionType[ExtensionType["ConfidentialTransferAccount"] = 5] = "ConfidentialTransferAccount";
    ExtensionType[ExtensionType["DefaultAccountState"] = 6] = "DefaultAccountState";
    ExtensionType[ExtensionType["ImmutableOwner"] = 7] = "ImmutableOwner";
    ExtensionType[ExtensionType["MemoTransfer"] = 8] = "MemoTransfer";
    ExtensionType[ExtensionType["NonTransferable"] = 9] = "NonTransferable";
    ExtensionType[ExtensionType["InterestBearingConfig"] = 10] = "InterestBearingConfig";
    ExtensionType[ExtensionType["CpiGuard"] = 11] = "CpiGuard";
    ExtensionType[ExtensionType["PermanentDelegate"] = 12] = "PermanentDelegate";
    ExtensionType[ExtensionType["NonTransferableAccount"] = 13] = "NonTransferableAccount";
    ExtensionType[ExtensionType["TransferHook"] = 14] = "TransferHook";
    ExtensionType[ExtensionType["TransferHookAccount"] = 15] = "TransferHookAccount";
    // ConfidentialTransferFee, // Not implemented yet
    // ConfidentialTransferFeeAmount, // Not implemented yet
    ExtensionType[ExtensionType["MetadataPointer"] = 18] = "MetadataPointer";
    ExtensionType[ExtensionType["TokenMetadata"] = 19] = "TokenMetadata";
    ExtensionType[ExtensionType["GroupPointer"] = 20] = "GroupPointer";
    ExtensionType[ExtensionType["TokenGroup"] = 21] = "TokenGroup";
    ExtensionType[ExtensionType["GroupMemberPointer"] = 22] = "GroupMemberPointer";
    ExtensionType[ExtensionType["TokenGroupMember"] = 23] = "TokenGroupMember";
})($8a9fbac74071e86b$export$4f037c6ec2da4eeb || ($8a9fbac74071e86b$export$4f037c6ec2da4eeb = {}));
var $8a9fbac74071e86b$export$b60591f8709c84d6 = 2;
var $8a9fbac74071e86b$export$7ae242f656e23fe = 2;
function $8a9fbac74071e86b$var$addTypeAndLengthToLen(len) {
    return len + $8a9fbac74071e86b$export$b60591f8709c84d6 + $8a9fbac74071e86b$export$7ae242f656e23fe;
}
function $8a9fbac74071e86b$var$isVariableLengthExtension(e) {
    switch(e){
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.TokenMetadata:
            return true;
        default:
            return false;
    }
}
function $8a9fbac74071e86b$export$a83377bb2e8914d8(e) {
    switch(e){
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.Uninitialized:
            return 0;
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.TransferFeeConfig:
            return 0, $f6740f0676a0748b$export$972cf5dcc13158da;
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.TransferFeeAmount:
            return 0, $f6740f0676a0748b$export$8657a852ae4f4019;
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.MintCloseAuthority:
            return 0, $a4a54deb514b29ac$export$1e1aa83bde32eb68;
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.ConfidentialTransferMint:
            return 65;
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.ConfidentialTransferAccount:
            return 295;
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.CpiGuard:
            return 0, $fa490ba71e0f66c6$export$2ad51e83460d1d03;
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.DefaultAccountState:
            return 0, $206dc1d272be8f5d$export$2e3c876eadfda1ab;
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.ImmutableOwner:
            return 0, $609c32eafafea420$export$4ba1dedcafaef535;
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.MemoTransfer:
            return 0, $5ac6a954cb55640b$export$f4b5375ad34477a1;
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.MetadataPointer:
            return 0, $0573eafe34cdb568$export$46bfcd668f9095d0;
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.NonTransferable:
            return 0, $b02bb390329a1a0b$export$31a113d46d052efb;
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.InterestBearingConfig:
            return 0, $f3ca28dba318d0c6$export$5deaa22b862a446f;
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.PermanentDelegate:
            return 0, $5f36f627a1468f95$export$636ea2373b6c6b7d;
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.NonTransferableAccount:
            return 0, $b02bb390329a1a0b$export$91a6e2e8798d2502;
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.TransferHook:
            return 0, $531c01471b5fe543$export$5ade3cdfd72ee348;
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.TransferHookAccount:
            return 0, $531c01471b5fe543$export$998fd74b23e70abd;
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.GroupPointer:
            return 0, $ceb25c2497c4f62e$export$3852a2b4ecb1c96c;
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.GroupMemberPointer:
            return 0, $1ce548d4184aa8a7$export$f4d582c48d8cc7e7;
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.TokenGroup:
            return 0, $15bf6bcc226e68ec$export$83b408df29875efc;
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.TokenGroupMember:
            return 0, $e95ef6829b67db47$export$922ab442b9cf73bd;
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.TokenMetadata:
            throw Error("Cannot get type length for variable extension type: ".concat(e));
        default:
            throw Error("Unknown extension type: ".concat(e));
    }
}
function $8a9fbac74071e86b$export$bb78b607a215e9f6(e) {
    switch(e){
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.TransferFeeConfig:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.MintCloseAuthority:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.ConfidentialTransferMint:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.DefaultAccountState:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.NonTransferable:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.InterestBearingConfig:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.PermanentDelegate:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.TransferHook:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.MetadataPointer:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.TokenMetadata:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.GroupPointer:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.GroupMemberPointer:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.TokenGroup:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.TokenGroupMember:
            return true;
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.Uninitialized:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.TransferFeeAmount:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.ConfidentialTransferAccount:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.ImmutableOwner:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.MemoTransfer:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.CpiGuard:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.NonTransferableAccount:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.TransferHookAccount:
            return false;
        default:
            throw Error("Unknown extension type: ".concat(e));
    }
}
function $8a9fbac74071e86b$export$da3491d66fdbe926(e) {
    switch(e){
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.TransferFeeAmount:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.ConfidentialTransferAccount:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.ImmutableOwner:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.MemoTransfer:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.CpiGuard:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.NonTransferableAccount:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.TransferHookAccount:
            return true;
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.Uninitialized:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.TransferFeeConfig:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.MintCloseAuthority:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.ConfidentialTransferMint:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.DefaultAccountState:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.NonTransferable:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.InterestBearingConfig:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.PermanentDelegate:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.TransferHook:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.MetadataPointer:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.TokenMetadata:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.GroupPointer:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.GroupMemberPointer:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.TokenGroup:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.TokenGroupMember:
            return false;
        default:
            throw Error("Unknown extension type: ".concat(e));
    }
}
function $8a9fbac74071e86b$export$cbf93c990104e9e6(e) {
    switch(e){
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.TransferFeeConfig:
            return $8a9fbac74071e86b$export$4f037c6ec2da4eeb.TransferFeeAmount;
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.ConfidentialTransferMint:
            return $8a9fbac74071e86b$export$4f037c6ec2da4eeb.ConfidentialTransferAccount;
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.NonTransferable:
            return $8a9fbac74071e86b$export$4f037c6ec2da4eeb.NonTransferableAccount;
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.TransferHook:
            return $8a9fbac74071e86b$export$4f037c6ec2da4eeb.TransferHookAccount;
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.TransferFeeAmount:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.ConfidentialTransferAccount:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.CpiGuard:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.DefaultAccountState:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.ImmutableOwner:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.MemoTransfer:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.MintCloseAuthority:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.MetadataPointer:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.TokenMetadata:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.Uninitialized:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.InterestBearingConfig:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.PermanentDelegate:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.NonTransferableAccount:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.TransferHookAccount:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.GroupPointer:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.GroupMemberPointer:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.TokenGroup:
        case $8a9fbac74071e86b$export$4f037c6ec2da4eeb.TokenGroupMember:
            return $8a9fbac74071e86b$export$4f037c6ec2da4eeb.Uninitialized;
    }
}
function $8a9fbac74071e86b$var$getLen(extensionTypes, baseSize) {
    var variableLengthExtensions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (extensionTypes.length === 0 && Object.keys(variableLengthExtensions).length === 0) return baseSize;
    else {
        var accountLength = (0, $1182e7f995928e51$export$66ab21ef808e9dc6) + (0, $8fc768cdbaf2edc7$export$9d3ac77dcbf22b3f) + extensionTypes.filter(function(element, i) {
            return i === extensionTypes.indexOf(element);
        }).map(function(element) {
            return $8a9fbac74071e86b$var$addTypeAndLengthToLen($8a9fbac74071e86b$export$a83377bb2e8914d8(element));
        }).reduce(function(a, b) {
            return a + b;
        }, 0) + Object.entries(variableLengthExtensions).map(function(param) {
            var _param = (0, $cv9Rk._)(param, 2), extension = _param[0], len = _param[1];
            if (!$8a9fbac74071e86b$var$isVariableLengthExtension(Number(extension))) throw Error("Extension ".concat(extension, " is not variable length"));
            return $8a9fbac74071e86b$var$addTypeAndLengthToLen(len);
        }).reduce(function(a, b) {
            return a + b;
        }, 0);
        if (accountLength === (0, $c6dd9d2caa8bf3a6$export$c2abf71f91a1605b)) return accountLength + $8a9fbac74071e86b$export$b60591f8709c84d6;
        else return accountLength;
    }
}
function $8a9fbac74071e86b$export$887e6fc33c7c42b5(extensionTypes) {
    var variableLengthExtensions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return $8a9fbac74071e86b$var$getLen(extensionTypes, (0, $4eb158b8dd6c521a$export$1e66c79f18e1c0c4), variableLengthExtensions);
}
function $8a9fbac74071e86b$export$37c8c863c6dd42a9(extensionTypes) {
    // There are currently no variable length extensions for accounts
    return $8a9fbac74071e86b$var$getLen(extensionTypes, (0, $1182e7f995928e51$export$66ab21ef808e9dc6));
}
function $8a9fbac74071e86b$export$4fff3ed4eba4f4ee(extension, tlvData) {
    var extensionTypeIndex = 0;
    while($8a9fbac74071e86b$var$addTypeAndLengthToLen(extensionTypeIndex) <= tlvData.length){
        var entryType = tlvData.readUInt16LE(extensionTypeIndex);
        var entryLength = tlvData.readUInt16LE(extensionTypeIndex + $8a9fbac74071e86b$export$b60591f8709c84d6);
        var typeIndex = $8a9fbac74071e86b$var$addTypeAndLengthToLen(extensionTypeIndex);
        if (entryType == extension) return tlvData.slice(typeIndex, typeIndex + entryLength);
        extensionTypeIndex = typeIndex + entryLength;
    }
    return null;
}
function $8a9fbac74071e86b$export$ddfd0a43fd10c049(tlvData) {
    var extensionTypes = [];
    var extensionTypeIndex = 0;
    while(extensionTypeIndex < tlvData.length){
        var entryType = tlvData.readUInt16LE(extensionTypeIndex);
        extensionTypes.push(entryType);
        var entryLength = tlvData.readUInt16LE(extensionTypeIndex + $8a9fbac74071e86b$export$b60591f8709c84d6);
        extensionTypeIndex += $8a9fbac74071e86b$var$addTypeAndLengthToLen(entryLength);
    }
    return extensionTypes;
}
function $8a9fbac74071e86b$export$8e188ecf75868f0c(mint) {
    var extensionTypes = $8a9fbac74071e86b$export$ddfd0a43fd10c049(mint.tlvData);
    var accountExtensions = extensionTypes.map($8a9fbac74071e86b$export$cbf93c990104e9e6);
    return $8a9fbac74071e86b$export$37c8c863c6dd42a9(accountExtensions);
}
function $8a9fbac74071e86b$export$59ff847e58b4aa16(info, address, extensionType, extensionLen) {
    var programId = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : (0, $a44c7142cfb07f27$export$8183845dc9f5ce72);
    var mint = (0, $4eb158b8dd6c521a$export$624621e2731540bb)(address, info, programId);
    var extensionData = $8a9fbac74071e86b$export$4fff3ed4eba4f4ee(extensionType, mint.tlvData);
    var currentExtensionLen = extensionData ? $8a9fbac74071e86b$var$addTypeAndLengthToLen(extensionData.length) : 0;
    var newExtensionLen = $8a9fbac74071e86b$var$addTypeAndLengthToLen(extensionLen);
    return info.data.length + newExtensionLen - currentExtensionLen;
}





var $8dlmd = parcelRequire("8dlmd");
var $4eb158b8dd6c521a$require$Buffer = $8dlmd.Buffer;
var $4eb158b8dd6c521a$export$1374e91decd2fbe5 = (0, $jt90m.struct)([
    (0, $jt90m.u32)("mintAuthorityOption"),
    (0, $3285baf77b253a0b$export$86f13247979de5d7)("mintAuthority"),
    (0, $59bc11fd00a6333b$export$cd1442401e54cffa)("supply"),
    (0, $jt90m.u8)("decimals"),
    (0, $41e55d51244b5d43$export$87b259aa03e3d267)("isInitialized"),
    (0, $jt90m.u32)("freezeAuthorityOption"),
    (0, $3285baf77b253a0b$export$86f13247979de5d7)("freezeAuthority")
]);
var $4eb158b8dd6c521a$export$1e66c79f18e1c0c4 = $4eb158b8dd6c521a$export$1374e91decd2fbe5.span;
function $4eb158b8dd6c521a$export$aa28710f9c948d46(connection, address, commitment) {
    return $4eb158b8dd6c521a$var$_getMint.apply(this, arguments);
}
function $4eb158b8dd6c521a$var$_getMint() {
    $4eb158b8dd6c521a$var$_getMint = (0, $kSuI9._)(function(connection, address, commitment) {
        var programId, info;
        var _arguments = arguments;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    programId = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : (0, $a44c7142cfb07f27$export$79de3e3c2b1ca801);
                    return [
                        4,
                        connection.getAccountInfo(address, commitment)
                    ];
                case 1:
                    info = _state.sent();
                    return [
                        2,
                        $4eb158b8dd6c521a$export$624621e2731540bb(address, info, programId)
                    ];
            }
        });
    });
    return $4eb158b8dd6c521a$var$_getMint.apply(this, arguments);
}
function $4eb158b8dd6c521a$export$624621e2731540bb(address, info) {
    var programId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $a44c7142cfb07f27$export$79de3e3c2b1ca801);
    if (!info) throw new (0, $0974668e835203eb$export$a09a5e48de2f3404)();
    if (!info.owner.equals(programId)) throw new (0, $0974668e835203eb$export$abb470453474d51)();
    if (info.data.length < $4eb158b8dd6c521a$export$1e66c79f18e1c0c4) throw new (0, $0974668e835203eb$export$250d31de4ddb7ca5)();
    var rawMint = $4eb158b8dd6c521a$export$1374e91decd2fbe5.decode(info.data.slice(0, $4eb158b8dd6c521a$export$1e66c79f18e1c0c4));
    var tlvData = $4eb158b8dd6c521a$require$Buffer.alloc(0);
    if (info.data.length > $4eb158b8dd6c521a$export$1e66c79f18e1c0c4) {
        if (info.data.length <= (0, $1182e7f995928e51$export$66ab21ef808e9dc6)) throw new (0, $0974668e835203eb$export$250d31de4ddb7ca5)();
        if (info.data.length === (0, $c6dd9d2caa8bf3a6$export$c2abf71f91a1605b)) throw new (0, $0974668e835203eb$export$250d31de4ddb7ca5)();
        if (info.data[0, $1182e7f995928e51$export$66ab21ef808e9dc6] != (0, $8fc768cdbaf2edc7$export$b8ca5fa4899cbfc7).Mint) throw new (0, $0974668e835203eb$export$871debb212ec395)();
        tlvData = info.data.slice((0, $1182e7f995928e51$export$66ab21ef808e9dc6) + (0, $8fc768cdbaf2edc7$export$9d3ac77dcbf22b3f));
    }
    return {
        address: address,
        mintAuthority: rawMint.mintAuthorityOption ? rawMint.mintAuthority : null,
        supply: rawMint.supply,
        decimals: rawMint.decimals,
        isInitialized: rawMint.isInitialized,
        freezeAuthority: rawMint.freezeAuthorityOption ? rawMint.freezeAuthority : null,
        tlvData: tlvData
    };
}
function $4eb158b8dd6c521a$export$ee29e619ed2e153c(connection, commitment) {
    return $4eb158b8dd6c521a$var$_getMinimumBalanceForRentExemptMint.apply(this, arguments);
}
function $4eb158b8dd6c521a$var$_getMinimumBalanceForRentExemptMint() {
    $4eb158b8dd6c521a$var$_getMinimumBalanceForRentExemptMint = (0, $kSuI9._)(function(connection, commitment) {
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $4eb158b8dd6c521a$export$42e75cb3f25fa0b8(connection, [], commitment)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return $4eb158b8dd6c521a$var$_getMinimumBalanceForRentExemptMint.apply(this, arguments);
}
function $4eb158b8dd6c521a$export$42e75cb3f25fa0b8(connection, extensions, commitment) {
    return $4eb158b8dd6c521a$var$_getMinimumBalanceForRentExemptMintWithExtensions.apply(this, arguments);
}
function $4eb158b8dd6c521a$var$_getMinimumBalanceForRentExemptMintWithExtensions() {
    $4eb158b8dd6c521a$var$_getMinimumBalanceForRentExemptMintWithExtensions = (0, $kSuI9._)(function(connection, extensions, commitment) {
        var mintLen;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    mintLen = (0, $8a9fbac74071e86b$export$887e6fc33c7c42b5)(extensions);
                    return [
                        4,
                        connection.getMinimumBalanceForRentExemption(mintLen, commitment)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return $4eb158b8dd6c521a$var$_getMinimumBalanceForRentExemptMintWithExtensions.apply(this, arguments);
}
function $4eb158b8dd6c521a$export$d776e5c4182d21cc(mint, owner) {
    return $4eb158b8dd6c521a$var$_getAssociatedTokenAddress.apply(this, arguments);
}
function $4eb158b8dd6c521a$var$_getAssociatedTokenAddress() {
    $4eb158b8dd6c521a$var$_getAssociatedTokenAddress = (0, $kSuI9._)(function(mint, owner) {
        var allowOwnerOffCurve, programId, associatedTokenProgramId, _ref, address;
        var _arguments = arguments;
        return (0, $eha6O.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    allowOwnerOffCurve = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false, programId = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : (0, $a44c7142cfb07f27$export$79de3e3c2b1ca801), associatedTokenProgramId = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : (0, $a44c7142cfb07f27$export$57a4f33bcc1767fa);
                    if (!allowOwnerOffCurve && !(0, $69N5M.PublicKey).isOnCurve(owner.toBuffer())) throw new (0, $0974668e835203eb$export$c431a85da6f99bf0)();
                    return [
                        4,
                        (0, $69N5M.PublicKey).findProgramAddress([
                            owner.toBuffer(),
                            programId.toBuffer(),
                            mint.toBuffer()
                        ], associatedTokenProgramId)
                    ];
                case 1:
                    _ref = (0, $cv9Rk._).apply(void 0, [
                        _state.sent(),
                        1
                    ]), address = _ref[0];
                    return [
                        2,
                        address
                    ];
            }
        });
    });
    return $4eb158b8dd6c521a$var$_getAssociatedTokenAddress.apply(this, arguments);
}
function $4eb158b8dd6c521a$export$226efbbb37d925bb(mint, owner) {
    var allowOwnerOffCurve = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, programId = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : (0, $a44c7142cfb07f27$export$79de3e3c2b1ca801), associatedTokenProgramId = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : (0, $a44c7142cfb07f27$export$57a4f33bcc1767fa);
    if (!allowOwnerOffCurve && !(0, $69N5M.PublicKey).isOnCurve(owner.toBuffer())) throw new (0, $0974668e835203eb$export$c431a85da6f99bf0)();
    var _PublicKey_findProgramAddressSync = (0, $cv9Rk._)((0, $69N5M.PublicKey).findProgramAddressSync([
        owner.toBuffer(),
        programId.toBuffer(),
        mint.toBuffer()
    ], associatedTokenProgramId), 1), address = _PublicKey_findProgramAddressSync[0];
    return address;
}


var $69N5M = parcelRequire("69N5M");


var $8dlmd = parcelRequire("8dlmd");
var $8347295515b93468$require$Buffer = $8dlmd.Buffer;
function $8347295515b93468$export$65d7d2fa066d6cc6(payer, associatedToken, owner, mint) {
    var programId = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : (0, $a44c7142cfb07f27$export$79de3e3c2b1ca801), associatedTokenProgramId = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : (0, $a44c7142cfb07f27$export$57a4f33bcc1767fa);
    return $8347295515b93468$var$buildAssociatedTokenAccountInstruction(payer, associatedToken, owner, mint, $8347295515b93468$require$Buffer.alloc(0), programId, associatedTokenProgramId);
}
function $8347295515b93468$export$b66dd1dc00a3bc28(payer, associatedToken, owner, mint) {
    var programId = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : (0, $a44c7142cfb07f27$export$79de3e3c2b1ca801), associatedTokenProgramId = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : (0, $a44c7142cfb07f27$export$57a4f33bcc1767fa);
    return $8347295515b93468$var$buildAssociatedTokenAccountInstruction(payer, associatedToken, owner, mint, $8347295515b93468$require$Buffer.from([
        1
    ]), programId, associatedTokenProgramId);
}
function $8347295515b93468$var$buildAssociatedTokenAccountInstruction(payer, associatedToken, owner, mint, instructionData) {
    var programId = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : (0, $a44c7142cfb07f27$export$79de3e3c2b1ca801), associatedTokenProgramId = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : (0, $a44c7142cfb07f27$export$57a4f33bcc1767fa);
    var keys = [
        {
            pubkey: payer,
            isSigner: true,
            isWritable: true
        },
        {
            pubkey: associatedToken,
            isSigner: false,
            isWritable: true
        },
        {
            pubkey: owner,
            isSigner: false,
            isWritable: false
        },
        {
            pubkey: mint,
            isSigner: false,
            isWritable: false
        },
        {
            pubkey: (0, $69N5M.SystemProgram).programId,
            isSigner: false,
            isWritable: false
        },
        {
            pubkey: programId,
            isSigner: false,
            isWritable: false
        }
    ];
    return new (0, $69N5M.TransactionInstruction)({
        keys: keys,
        programId: associatedTokenProgramId,
        data: instructionData
    });
}
function $8347295515b93468$export$2108cac48553e999(nestedAssociatedToken, nestedMint, destinationAssociatedToken, ownerAssociatedToken, ownerMint, owner) {
    var programId = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : (0, $a44c7142cfb07f27$export$79de3e3c2b1ca801), associatedTokenProgramId = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : (0, $a44c7142cfb07f27$export$57a4f33bcc1767fa);
    var keys = [
        {
            pubkey: nestedAssociatedToken,
            isSigner: false,
            isWritable: true
        },
        {
            pubkey: nestedMint,
            isSigner: false,
            isWritable: false
        },
        {
            pubkey: destinationAssociatedToken,
            isSigner: false,
            isWritable: true
        },
        {
            pubkey: ownerAssociatedToken,
            isSigner: false,
            isWritable: true
        },
        {
            pubkey: ownerMint,
            isSigner: false,
            isWritable: false
        },
        {
            pubkey: owner,
            isSigner: true,
            isWritable: true
        },
        {
            pubkey: programId,
            isSigner: false,
            isWritable: false
        }
    ];
    return new (0, $69N5M.TransactionInstruction)({
        keys: keys,
        programId: associatedTokenProgramId,
        data: $8347295515b93468$require$Buffer.from([
            2
        ])
    });
}


var $gdHfP = parcelRequire("gdHfP");

var $jt90m = parcelRequire("jt90m");


var $69N5M = parcelRequire("69N5M");



var $69N5M = parcelRequire("69N5M");
function $65efca3ca9d76b55$export$fde60050662f8c02(keys, ownerOrAuthority, multiSigners) {
    if (multiSigners.length) {
        keys.push({
            pubkey: ownerOrAuthority,
            isSigner: false,
            isWritable: false
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = multiSigners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var signer = _step.value;
                keys.push({
                    pubkey: signer instanceof (0, $69N5M.PublicKey) ? signer : signer.publicKey,
                    isSigner: true,
                    isWritable: false
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else keys.push({
        pubkey: ownerOrAuthority,
        isSigner: true,
        isWritable: false
    });
    return keys;
}


/** Instructions defined by the program */ var $96a493d29c9dbf3d$export$236c07be390a0994;
(function(TokenInstruction) {
    TokenInstruction[TokenInstruction["InitializeMint"] = 0] = "InitializeMint";
    TokenInstruction[TokenInstruction["InitializeAccount"] = 1] = "InitializeAccount";
    TokenInstruction[TokenInstruction["InitializeMultisig"] = 2] = "InitializeMultisig";
    TokenInstruction[TokenInstruction["Transfer"] = 3] = "Transfer";
    TokenInstruction[TokenInstruction["Approve"] = 4] = "Approve";
    TokenInstruction[TokenInstruction["Revoke"] = 5] = "Revoke";
    TokenInstruction[TokenInstruction["SetAuthority"] = 6] = "SetAuthority";
    TokenInstruction[TokenInstruction["MintTo"] = 7] = "MintTo";
    TokenInstruction[TokenInstruction["Burn"] = 8] = "Burn";
    TokenInstruction[TokenInstruction["CloseAccount"] = 9] = "CloseAccount";
    TokenInstruction[TokenInstruction["FreezeAccount"] = 10] = "FreezeAccount";
    TokenInstruction[TokenInstruction["ThawAccount"] = 11] = "ThawAccount";
    TokenInstruction[TokenInstruction["TransferChecked"] = 12] = "TransferChecked";
    TokenInstruction[TokenInstruction["ApproveChecked"] = 13] = "ApproveChecked";
    TokenInstruction[TokenInstruction["MintToChecked"] = 14] = "MintToChecked";
    TokenInstruction[TokenInstruction["BurnChecked"] = 15] = "BurnChecked";
    TokenInstruction[TokenInstruction["InitializeAccount2"] = 16] = "InitializeAccount2";
    TokenInstruction[TokenInstruction["SyncNative"] = 17] = "SyncNative";
    TokenInstruction[TokenInstruction["InitializeAccount3"] = 18] = "InitializeAccount3";
    TokenInstruction[TokenInstruction["InitializeMultisig2"] = 19] = "InitializeMultisig2";
    TokenInstruction[TokenInstruction["InitializeMint2"] = 20] = "InitializeMint2";
    TokenInstruction[TokenInstruction["GetAccountDataSize"] = 21] = "GetAccountDataSize";
    TokenInstruction[TokenInstruction["InitializeImmutableOwner"] = 22] = "InitializeImmutableOwner";
    TokenInstruction[TokenInstruction["AmountToUiAmount"] = 23] = "AmountToUiAmount";
    TokenInstruction[TokenInstruction["UiAmountToAmount"] = 24] = "UiAmountToAmount";
    TokenInstruction[TokenInstruction["InitializeMintCloseAuthority"] = 25] = "InitializeMintCloseAuthority";
    TokenInstruction[TokenInstruction["TransferFeeExtension"] = 26] = "TransferFeeExtension";
    TokenInstruction[TokenInstruction["ConfidentialTransferExtension"] = 27] = "ConfidentialTransferExtension";
    TokenInstruction[TokenInstruction["DefaultAccountStateExtension"] = 28] = "DefaultAccountStateExtension";
    TokenInstruction[TokenInstruction["Reallocate"] = 29] = "Reallocate";
    TokenInstruction[TokenInstruction["MemoTransferExtension"] = 30] = "MemoTransferExtension";
    TokenInstruction[TokenInstruction["CreateNativeMint"] = 31] = "CreateNativeMint";
    TokenInstruction[TokenInstruction["InitializeNonTransferableMint"] = 32] = "InitializeNonTransferableMint";
    TokenInstruction[TokenInstruction["InterestBearingMintExtension"] = 33] = "InterestBearingMintExtension";
    TokenInstruction[TokenInstruction["CpiGuardExtension"] = 34] = "CpiGuardExtension";
    TokenInstruction[TokenInstruction["InitializePermanentDelegate"] = 35] = "InitializePermanentDelegate";
    TokenInstruction[TokenInstruction["TransferHookExtension"] = 36] = "TransferHookExtension";
    // ConfidentialTransferFeeExtension = 37,
    // WithdrawalExcessLamports = 38,
    TokenInstruction[TokenInstruction["MetadataPointerExtension"] = 39] = "MetadataPointerExtension";
    TokenInstruction[TokenInstruction["GroupPointerExtension"] = 40] = "GroupPointerExtension";
    TokenInstruction[TokenInstruction["GroupMemberPointerExtension"] = 41] = "GroupMemberPointerExtension";
})($96a493d29c9dbf3d$export$236c07be390a0994 || ($96a493d29c9dbf3d$export$236c07be390a0994 = {}));



var $8dlmd = parcelRequire("8dlmd");
var $7c5c73bd37fea01a$require$Buffer = $8dlmd.Buffer;
var $7c5c73bd37fea01a$export$36b3d03efc16d305 = (0, $jt90m.struct)([
    (0, $jt90m.u8)("instruction"),
    (0, $59bc11fd00a6333b$export$cd1442401e54cffa)("amount")
]);
function $7c5c73bd37fea01a$export$b274d5cebe357db9(source, destination, owner, amount) {
    var multiSigners = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], programId = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : (0, $a44c7142cfb07f27$export$79de3e3c2b1ca801);
    var keys = (0, $65efca3ca9d76b55$export$fde60050662f8c02)([
        {
            pubkey: source,
            isSigner: false,
            isWritable: true
        },
        {
            pubkey: destination,
            isSigner: false,
            isWritable: true
        }
    ], owner, multiSigners);
    var data = $7c5c73bd37fea01a$require$Buffer.alloc($7c5c73bd37fea01a$export$36b3d03efc16d305.span);
    $7c5c73bd37fea01a$export$36b3d03efc16d305.encode({
        instruction: (0, $96a493d29c9dbf3d$export$236c07be390a0994).Transfer,
        amount: BigInt(amount)
    }, data);
    return new (0, $69N5M.TransactionInstruction)({
        keys: keys,
        programId: programId,
        data: data
    });
}
function $7c5c73bd37fea01a$export$d4ef34cde439b107(instruction) {
    var programId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $a44c7142cfb07f27$export$79de3e3c2b1ca801);
    if (!instruction.programId.equals(programId)) throw new (0, $0974668e835203eb$export$a241007212c884f6)();
    if (instruction.data.length !== $7c5c73bd37fea01a$export$36b3d03efc16d305.span) throw new (0, $0974668e835203eb$export$f96a822f391c3cc4)();
    var _decodeTransferInstructionUnchecked = $7c5c73bd37fea01a$export$f64172008a79e2e1(instruction), _decodeTransferInstructionUnchecked_keys = _decodeTransferInstructionUnchecked.keys, source = _decodeTransferInstructionUnchecked_keys.source, destination = _decodeTransferInstructionUnchecked_keys.destination, owner = _decodeTransferInstructionUnchecked_keys.owner, multiSigners = _decodeTransferInstructionUnchecked_keys.multiSigners, data = _decodeTransferInstructionUnchecked.data;
    if (data.instruction !== (0, $96a493d29c9dbf3d$export$236c07be390a0994).Transfer) throw new (0, $0974668e835203eb$export$e1301365d704141e)();
    if (!source || !destination || !owner) throw new (0, $0974668e835203eb$export$3882cbbd44973a88)();
    // TODO: key checks?
    return {
        programId: programId,
        keys: {
            source: source,
            destination: destination,
            owner: owner,
            multiSigners: multiSigners
        },
        data: data
    };
}
function $7c5c73bd37fea01a$export$f64172008a79e2e1(param) {
    var programId = param.programId, _param_keys = (0, $gdHfP._)(param.keys), source = _param_keys[0], destination = _param_keys[1], owner = _param_keys[2], multiSigners = _param_keys.slice(3), data = param.data;
    return {
        programId: programId,
        keys: {
            source: source,
            destination: destination,
            owner: owner,
            multiSigners: multiSigners
        },
        data: $7c5c73bd37fea01a$export$36b3d03efc16d305.decode(data)
    };
}



var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");


var $1Mpn7 = parcelRequire("1Mpn7");




var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

parcelRequire("1Mpn7");
function $94a17a33d2bce04d$var$S(props) {
    return /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("svg", (0, $cxjpp._)((0, $do9pw._)({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "6 6 12 12",
        stroke: "rgba(0,0,0, 0.25)",
        strokeWidth: "1"
    }, props), {
        children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("path", {
            d: "M7 7L17 17M7 17L17 7",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }));
}
var $94a17a33d2bce04d$export$2e2bcd8739ae039 = $94a17a33d2bce04d$var$S;


function $d1f05c17921c0ca1$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  background-color: rgba(7, 7, 40, 0.75);\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 101;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: ",
        " 0.2s;\n"
    ]);
    $d1f05c17921c0ca1$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $d1f05c17921c0ca1$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "\n  background-color: white;\n  box-shadow: 0 0 20px rgba(7, 7, 40, 0.5);\n  width: 500px;\n  max-width: 90%;\n  border-radius: 10px;\n  animation: ",
        " 0.1s cubic-bezier(0.18, 0.89, 0.32, 1.15);\n  max-height: 90%;\n  overflow: scroll;\n"
    ]);
    $d1f05c17921c0ca1$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $d1f05c17921c0ca1$var$ModalContainer = (0, $f2ce4b3babf40f7e$export$2e2bcd8739ae039).div($d1f05c17921c0ca1$var$_templateObject(), (0, $c5e756178d2efe0f$export$ac81a72f0c3b6512));
var $d1f05c17921c0ca1$var$ModalInner = (0, $f2ce4b3babf40f7e$export$2e2bcd8739ae039).div($d1f05c17921c0ca1$var$_templateObject1(), (0, $c5e756178d2efe0f$export$f9ae25e7d5fbc8b9));
var $d1f05c17921c0ca1$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $dcsZi._)(Modal, _React_Component);
    var _super = (0, $ohfOJ._)(Modal);
    function Modal() {
        (0, $4GJKx._)(this, Modal);
        return _super.apply(this, arguments);
    }
    (0, $1wc17._)(Modal, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                if (!this.props.visible) return /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $78b37e1ff5a5ba28$exports.Fragment), {});
                return /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)($d1f05c17921c0ca1$var$ModalContainer, {
                    onClick: function(e) {
                        var _this_inner;
                        if (!(e.target === _this.inner || ((_this_inner = _this.inner) === null || _this_inner === void 0 ? void 0 : _this_inner.contains(e.target)))) _this.props.onClose();
                    },
                    children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)($d1f05c17921c0ca1$var$ModalInner, {
                        ref: function(inner) {
                            return _this.inner = inner;
                        },
                        style: this.props.innerStyles,
                        children: [
                            this.props.title && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    justifyContent: "space-between",
                                    width: "100%",
                                    padding: 30,
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                        style: {
                                            fontSize: 16,
                                            fontWeight: 500
                                        },
                                        children: this.props.title
                                    }),
                                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $913546acae8c9187$export$c25acd513dcc8062), {
                                        type: "button",
                                        onClick: function() {
                                            return _this.props.onClose();
                                        },
                                        style: {
                                            padding: 0
                                        },
                                        children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $94a17a33d2bce04d$export$2e2bcd8739ae039), {
                                            style: {
                                                width: "14px"
                                            }
                                        })
                                    })
                                ]
                            }),
                            this.props.children
                        ]
                    })
                });
            }
        }
    ]);
    return Modal;
}((0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Component);



var $555753d492a5a777$exports = {};
"use strict";
Object.defineProperty($555753d492a5a777$exports, "__esModule", {
    value: true
});
function $555753d492a5a777$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $1Mpn7 = parcelRequire("1Mpn7");
var $555753d492a5a777$var$React__default = $555753d492a5a777$var$_interopDefault($1Mpn7);

var $3Jk4b = parcelRequire("3Jk4b");
var $555753d492a5a777$var$ClientUAInstance = new $3Jk4b();
var $555753d492a5a777$var$browser = $555753d492a5a777$var$ClientUAInstance.getBrowser();
var $555753d492a5a777$var$cpu = $555753d492a5a777$var$ClientUAInstance.getCPU();
var $555753d492a5a777$var$device = $555753d492a5a777$var$ClientUAInstance.getDevice();
var $555753d492a5a777$var$engine = $555753d492a5a777$var$ClientUAInstance.getEngine();
var $555753d492a5a777$var$os = $555753d492a5a777$var$ClientUAInstance.getOS();
var $555753d492a5a777$var$ua = $555753d492a5a777$var$ClientUAInstance.getUA();
var $555753d492a5a777$var$setUa = function setUa(userAgentString) {
    return $555753d492a5a777$var$ClientUAInstance.setUA(userAgentString);
};
var $555753d492a5a777$var$parseUserAgent = function parseUserAgent(userAgent) {
    if (!userAgent) {
        console.error("No userAgent string was provided");
        return;
    }
    var UserAgentInstance = new $3Jk4b(userAgent);
    return {
        UA: UserAgentInstance,
        browser: UserAgentInstance.getBrowser(),
        cpu: UserAgentInstance.getCPU(),
        device: UserAgentInstance.getDevice(),
        engine: UserAgentInstance.getEngine(),
        os: UserAgentInstance.getOS(),
        ua: UserAgentInstance.getUA(),
        setUserAgent: function setUserAgent(userAgentString) {
            return UserAgentInstance.setUA(userAgentString);
        }
    };
};
var $555753d492a5a777$var$UAHelper = /*#__PURE__*/ Object.freeze({
    ClientUAInstance: $555753d492a5a777$var$ClientUAInstance,
    browser: $555753d492a5a777$var$browser,
    cpu: $555753d492a5a777$var$cpu,
    device: $555753d492a5a777$var$device,
    engine: $555753d492a5a777$var$engine,
    os: $555753d492a5a777$var$os,
    ua: $555753d492a5a777$var$ua,
    setUa: $555753d492a5a777$var$setUa,
    parseUserAgent: $555753d492a5a777$var$parseUserAgent
});
function $555753d492a5a777$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $555753d492a5a777$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $555753d492a5a777$var$ownKeys(Object(source), true).forEach(function(key) {
            $555753d492a5a777$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $555753d492a5a777$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $555753d492a5a777$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $555753d492a5a777$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $555753d492a5a777$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $555753d492a5a777$var$_typeof(obj);
}
function $555753d492a5a777$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $555753d492a5a777$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $555753d492a5a777$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $555753d492a5a777$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $555753d492a5a777$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $555753d492a5a777$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $555753d492a5a777$var$_extends() {
    $555753d492a5a777$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $555753d492a5a777$var$_extends.apply(this, arguments);
}
function $555753d492a5a777$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $555753d492a5a777$var$_setPrototypeOf(subClass, superClass);
}
function $555753d492a5a777$var$_getPrototypeOf(o) {
    $555753d492a5a777$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $555753d492a5a777$var$_getPrototypeOf(o);
}
function $555753d492a5a777$var$_setPrototypeOf(o, p) {
    $555753d492a5a777$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $555753d492a5a777$var$_setPrototypeOf(o, p);
}
function $555753d492a5a777$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $555753d492a5a777$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $555753d492a5a777$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $555753d492a5a777$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $555753d492a5a777$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $555753d492a5a777$var$_assertThisInitialized(self);
}
function $555753d492a5a777$var$_slicedToArray(arr, i) {
    return $555753d492a5a777$var$_arrayWithHoles(arr) || $555753d492a5a777$var$_iterableToArrayLimit(arr, i) || $555753d492a5a777$var$_unsupportedIterableToArray(arr, i) || $555753d492a5a777$var$_nonIterableRest();
}
function $555753d492a5a777$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $555753d492a5a777$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $555753d492a5a777$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $555753d492a5a777$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $555753d492a5a777$var$_arrayLikeToArray(o, minLen);
}
function $555753d492a5a777$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $555753d492a5a777$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $555753d492a5a777$var$DeviceTypes = {
    Mobile: "mobile",
    Tablet: "tablet",
    SmartTv: "smarttv",
    Console: "console",
    Wearable: "wearable",
    Embedded: "embedded",
    Browser: undefined
};
var $555753d492a5a777$var$BrowserTypes = {
    Chrome: "Chrome",
    Firefox: "Firefox",
    Opera: "Opera",
    Yandex: "Yandex",
    Safari: "Safari",
    InternetExplorer: "Internet Explorer",
    Edge: "Edge",
    Chromium: "Chromium",
    Ie: "IE",
    MobileSafari: "Mobile Safari",
    EdgeChromium: "Edge Chromium",
    MIUI: "MIUI Browser",
    SamsungBrowser: "Samsung Browser"
};
var $555753d492a5a777$var$OsTypes = {
    IOS: "iOS",
    Android: "Android",
    WindowsPhone: "Windows Phone",
    Windows: "Windows",
    MAC_OS: "Mac OS"
};
var $555753d492a5a777$var$InitialDeviceTypes = {
    isMobile: false,
    isTablet: false,
    isBrowser: false,
    isSmartTV: false,
    isConsole: false,
    isWearable: false
};
var $555753d492a5a777$var$checkDeviceType = function checkDeviceType(type) {
    switch(type){
        case $555753d492a5a777$var$DeviceTypes.Mobile:
            return {
                isMobile: true
            };
        case $555753d492a5a777$var$DeviceTypes.Tablet:
            return {
                isTablet: true
            };
        case $555753d492a5a777$var$DeviceTypes.SmartTv:
            return {
                isSmartTV: true
            };
        case $555753d492a5a777$var$DeviceTypes.Console:
            return {
                isConsole: true
            };
        case $555753d492a5a777$var$DeviceTypes.Wearable:
            return {
                isWearable: true
            };
        case $555753d492a5a777$var$DeviceTypes.Browser:
            return {
                isBrowser: true
            };
        case $555753d492a5a777$var$DeviceTypes.Embedded:
            return {
                isEmbedded: true
            };
        default:
            return $555753d492a5a777$var$InitialDeviceTypes;
    }
};
var $555753d492a5a777$var$setUserAgent = function setUserAgent(userAgent) {
    return $555753d492a5a777$var$setUa(userAgent);
};
var $555753d492a5a777$var$setDefaults = function setDefaults(p) {
    var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "none";
    return p ? p : d;
};
var $555753d492a5a777$var$getNavigatorInstance = function getNavigatorInstance() {
    if (typeof window !== "undefined") {
        if (window.navigator || navigator) return window.navigator || navigator;
    }
    return false;
};
var $555753d492a5a777$var$isIOS13Check = function isIOS13Check(type) {
    var nav = $555753d492a5a777$var$getNavigatorInstance();
    return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === "MacIntel" && nav.maxTouchPoints > 1 && !window.MSStream);
};
var $555753d492a5a777$var$browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
    return {
        isBrowser: isBrowser,
        browserMajorVersion: $555753d492a5a777$var$setDefaults(browser.major),
        browserFullVersion: $555753d492a5a777$var$setDefaults(browser.version),
        browserName: $555753d492a5a777$var$setDefaults(browser.name),
        engineName: $555753d492a5a777$var$setDefaults(engine.name),
        engineVersion: $555753d492a5a777$var$setDefaults(engine.version),
        osName: $555753d492a5a777$var$setDefaults(os.name),
        osVersion: $555753d492a5a777$var$setDefaults(os.version),
        userAgent: $555753d492a5a777$var$setDefaults(ua)
    };
};
var $555753d492a5a777$var$mobilePayload = function mobilePayload(type, device, os, ua) {
    return $555753d492a5a777$var$_objectSpread2({}, type, {
        vendor: $555753d492a5a777$var$setDefaults(device.vendor),
        model: $555753d492a5a777$var$setDefaults(device.model),
        os: $555753d492a5a777$var$setDefaults(os.name),
        osVersion: $555753d492a5a777$var$setDefaults(os.version),
        ua: $555753d492a5a777$var$setDefaults(ua)
    });
};
var $555753d492a5a777$var$smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
    return {
        isSmartTV: isSmartTV,
        engineName: $555753d492a5a777$var$setDefaults(engine.name),
        engineVersion: $555753d492a5a777$var$setDefaults(engine.version),
        osName: $555753d492a5a777$var$setDefaults(os.name),
        osVersion: $555753d492a5a777$var$setDefaults(os.version),
        userAgent: $555753d492a5a777$var$setDefaults(ua)
    };
};
var $555753d492a5a777$var$consolePayload = function consolePayload(isConsole, engine, os, ua) {
    return {
        isConsole: isConsole,
        engineName: $555753d492a5a777$var$setDefaults(engine.name),
        engineVersion: $555753d492a5a777$var$setDefaults(engine.version),
        osName: $555753d492a5a777$var$setDefaults(os.name),
        osVersion: $555753d492a5a777$var$setDefaults(os.version),
        userAgent: $555753d492a5a777$var$setDefaults(ua)
    };
};
var $555753d492a5a777$var$wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
    return {
        isWearable: isWearable,
        engineName: $555753d492a5a777$var$setDefaults(engine.name),
        engineVersion: $555753d492a5a777$var$setDefaults(engine.version),
        osName: $555753d492a5a777$var$setDefaults(os.name),
        osVersion: $555753d492a5a777$var$setDefaults(os.version),
        userAgent: $555753d492a5a777$var$setDefaults(ua)
    };
};
var $555753d492a5a777$var$embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
    return {
        isEmbedded: isEmbedded,
        vendor: $555753d492a5a777$var$setDefaults(device.vendor),
        model: $555753d492a5a777$var$setDefaults(device.model),
        engineName: $555753d492a5a777$var$setDefaults(engine.name),
        engineVersion: $555753d492a5a777$var$setDefaults(engine.version),
        osName: $555753d492a5a777$var$setDefaults(os.name),
        osVersion: $555753d492a5a777$var$setDefaults(os.version),
        userAgent: $555753d492a5a777$var$setDefaults(ua)
    };
};
function $555753d492a5a777$var$deviceDetect(userAgent) {
    var _ref = userAgent ? $555753d492a5a777$var$parseUserAgent(userAgent) : $555753d492a5a777$var$UAHelper, device = _ref.device, browser = _ref.browser, engine = _ref.engine, os = _ref.os, ua = _ref.ua;
    var type = $555753d492a5a777$var$checkDeviceType(device.type);
    var isBrowser = type.isBrowser, isMobile = type.isMobile, isTablet = type.isTablet, isSmartTV = type.isSmartTV, isConsole = type.isConsole, isWearable = type.isWearable, isEmbedded = type.isEmbedded;
    if (isBrowser) return $555753d492a5a777$var$browserPayload(isBrowser, browser, engine, os, ua);
    if (isSmartTV) return $555753d492a5a777$var$smartTvPayload(isSmartTV, engine, os, ua);
    if (isConsole) return $555753d492a5a777$var$consolePayload(isConsole, engine, os, ua);
    if (isMobile) return $555753d492a5a777$var$mobilePayload(type, device, os, ua);
    if (isTablet) return $555753d492a5a777$var$mobilePayload(type, device, os, ua);
    if (isWearable) return $555753d492a5a777$var$wearablePayload(isWearable, engine, os, ua);
    if (isEmbedded) return $555753d492a5a777$var$embeddedPayload(isEmbedded, device, engine, os, ua);
}
var $555753d492a5a777$var$isMobileType = function isMobileType(_ref) {
    var type = _ref.type;
    return type === $555753d492a5a777$var$DeviceTypes.Mobile;
};
var $555753d492a5a777$var$isTabletType = function isTabletType(_ref2) {
    var type = _ref2.type;
    return type === $555753d492a5a777$var$DeviceTypes.Tablet;
};
var $555753d492a5a777$var$isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
    var type = _ref3.type;
    return type === $555753d492a5a777$var$DeviceTypes.Mobile || type === $555753d492a5a777$var$DeviceTypes.Tablet;
};
var $555753d492a5a777$var$isSmartTVType = function isSmartTVType(_ref4) {
    var type = _ref4.type;
    return type === $555753d492a5a777$var$DeviceTypes.SmartTv;
};
var $555753d492a5a777$var$isBrowserType = function isBrowserType(_ref5) {
    var type = _ref5.type;
    return type === $555753d492a5a777$var$DeviceTypes.Browser;
};
var $555753d492a5a777$var$isWearableType = function isWearableType(_ref6) {
    var type = _ref6.type;
    return type === $555753d492a5a777$var$DeviceTypes.Wearable;
};
var $555753d492a5a777$var$isConsoleType = function isConsoleType(_ref7) {
    var type = _ref7.type;
    return type === $555753d492a5a777$var$DeviceTypes.Console;
};
var $555753d492a5a777$var$isEmbeddedType = function isEmbeddedType(_ref8) {
    var type = _ref8.type;
    return type === $555753d492a5a777$var$DeviceTypes.Embedded;
};
var $555753d492a5a777$var$getMobileVendor = function getMobileVendor(_ref9) {
    var vendor = _ref9.vendor;
    return $555753d492a5a777$var$setDefaults(vendor);
};
var $555753d492a5a777$var$getMobileModel = function getMobileModel(_ref10) {
    var model = _ref10.model;
    return $555753d492a5a777$var$setDefaults(model);
};
var $555753d492a5a777$var$getDeviceType = function getDeviceType(_ref11) {
    var type = _ref11.type;
    return $555753d492a5a777$var$setDefaults(type, "browser");
}; // os types
var $555753d492a5a777$var$isAndroidType = function isAndroidType(_ref12) {
    var name = _ref12.name;
    return name === $555753d492a5a777$var$OsTypes.Android;
};
var $555753d492a5a777$var$isWindowsType = function isWindowsType(_ref13) {
    var name = _ref13.name;
    return name === $555753d492a5a777$var$OsTypes.Windows;
};
var $555753d492a5a777$var$isMacOsType = function isMacOsType(_ref14) {
    var name = _ref14.name;
    return name === $555753d492a5a777$var$OsTypes.MAC_OS;
};
var $555753d492a5a777$var$isWinPhoneType = function isWinPhoneType(_ref15) {
    var name = _ref15.name;
    return name === $555753d492a5a777$var$OsTypes.WindowsPhone;
};
var $555753d492a5a777$var$isIOSType = function isIOSType(_ref16) {
    var name = _ref16.name;
    return name === $555753d492a5a777$var$OsTypes.IOS;
};
var $555753d492a5a777$var$getOsVersion = function getOsVersion(_ref17) {
    var version = _ref17.version;
    return $555753d492a5a777$var$setDefaults(version);
};
var $555753d492a5a777$var$getOsName = function getOsName(_ref18) {
    var name = _ref18.name;
    return $555753d492a5a777$var$setDefaults(name);
}; // browser types
var $555753d492a5a777$var$isChromeType = function isChromeType(_ref19) {
    var name = _ref19.name;
    return name === $555753d492a5a777$var$BrowserTypes.Chrome;
};
var $555753d492a5a777$var$isFirefoxType = function isFirefoxType(_ref20) {
    var name = _ref20.name;
    return name === $555753d492a5a777$var$BrowserTypes.Firefox;
};
var $555753d492a5a777$var$isChromiumType = function isChromiumType(_ref21) {
    var name = _ref21.name;
    return name === $555753d492a5a777$var$BrowserTypes.Chromium;
};
var $555753d492a5a777$var$isEdgeType = function isEdgeType(_ref22) {
    var name = _ref22.name;
    return name === $555753d492a5a777$var$BrowserTypes.Edge;
};
var $555753d492a5a777$var$isYandexType = function isYandexType(_ref23) {
    var name = _ref23.name;
    return name === $555753d492a5a777$var$BrowserTypes.Yandex;
};
var $555753d492a5a777$var$isSafariType = function isSafariType(_ref24) {
    var name = _ref24.name;
    return name === $555753d492a5a777$var$BrowserTypes.Safari || name === $555753d492a5a777$var$BrowserTypes.MobileSafari;
};
var $555753d492a5a777$var$isMobileSafariType = function isMobileSafariType(_ref25) {
    var name = _ref25.name;
    return name === $555753d492a5a777$var$BrowserTypes.MobileSafari;
};
var $555753d492a5a777$var$isOperaType = function isOperaType(_ref26) {
    var name = _ref26.name;
    return name === $555753d492a5a777$var$BrowserTypes.Opera;
};
var $555753d492a5a777$var$isIEType = function isIEType(_ref27) {
    var name = _ref27.name;
    return name === $555753d492a5a777$var$BrowserTypes.InternetExplorer || name === $555753d492a5a777$var$BrowserTypes.Ie;
};
var $555753d492a5a777$var$isMIUIType = function isMIUIType(_ref28) {
    var name = _ref28.name;
    return name === $555753d492a5a777$var$BrowserTypes.MIUI;
};
var $555753d492a5a777$var$isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
    var name = _ref29.name;
    return name === $555753d492a5a777$var$BrowserTypes.SamsungBrowser;
};
var $555753d492a5a777$var$getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
    var version = _ref30.version;
    return $555753d492a5a777$var$setDefaults(version);
};
var $555753d492a5a777$var$getBrowserVersion = function getBrowserVersion(_ref31) {
    var major = _ref31.major;
    return $555753d492a5a777$var$setDefaults(major);
};
var $555753d492a5a777$var$getBrowserName = function getBrowserName(_ref32) {
    var name = _ref32.name;
    return $555753d492a5a777$var$setDefaults(name);
}; // engine types
var $555753d492a5a777$var$getEngineName = function getEngineName(_ref33) {
    var name = _ref33.name;
    return $555753d492a5a777$var$setDefaults(name);
};
var $555753d492a5a777$var$getEngineVersion = function getEngineVersion(_ref34) {
    var version = _ref34.version;
    return $555753d492a5a777$var$setDefaults(version);
};
var $555753d492a5a777$var$isElectronType = function isElectronType() {
    var nav = $555753d492a5a777$var$getNavigatorInstance();
    var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
    return typeof ua === "string" ? /electron/.test(ua) : false;
};
var $555753d492a5a777$var$isEdgeChromiumType = function isEdgeChromiumType(ua) {
    return typeof ua === "string" && ua.indexOf("Edg/") !== -1;
};
var $555753d492a5a777$var$getIOS13 = function getIOS13() {
    var nav = $555753d492a5a777$var$getNavigatorInstance();
    return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === "MacIntel" && nav.maxTouchPoints > 1) && !window.MSStream;
};
var $555753d492a5a777$var$getIPad13 = function getIPad13() {
    return $555753d492a5a777$var$isIOS13Check("iPad");
};
var $555753d492a5a777$var$getIphone13 = function getIphone13() {
    return $555753d492a5a777$var$isIOS13Check("iPhone");
};
var $555753d492a5a777$var$getIPod13 = function getIPod13() {
    return $555753d492a5a777$var$isIOS13Check("iPod");
};
var $555753d492a5a777$var$getUseragent = function getUseragent(userAg) {
    return $555753d492a5a777$var$setDefaults(userAg);
};
function $555753d492a5a777$var$buildSelectorsObject(options) {
    var _ref = options ? options : $555753d492a5a777$var$UAHelper, device = _ref.device, browser = _ref.browser, os = _ref.os, engine = _ref.engine, ua = _ref.ua;
    return {
        isSmartTV: $555753d492a5a777$var$isSmartTVType(device),
        isConsole: $555753d492a5a777$var$isConsoleType(device),
        isWearable: $555753d492a5a777$var$isWearableType(device),
        isEmbedded: $555753d492a5a777$var$isEmbeddedType(device),
        isMobileSafari: $555753d492a5a777$var$isMobileSafariType(browser) || $555753d492a5a777$var$getIPad13(),
        isChromium: $555753d492a5a777$var$isChromiumType(browser),
        isMobile: $555753d492a5a777$var$isMobileAndTabletType(device) || $555753d492a5a777$var$getIPad13(),
        isMobileOnly: $555753d492a5a777$var$isMobileType(device),
        isTablet: $555753d492a5a777$var$isTabletType(device) || $555753d492a5a777$var$getIPad13(),
        isBrowser: $555753d492a5a777$var$isBrowserType(device),
        isDesktop: $555753d492a5a777$var$isBrowserType(device),
        isAndroid: $555753d492a5a777$var$isAndroidType(os),
        isWinPhone: $555753d492a5a777$var$isWinPhoneType(os),
        isIOS: $555753d492a5a777$var$isIOSType(os) || $555753d492a5a777$var$getIPad13(),
        isChrome: $555753d492a5a777$var$isChromeType(browser),
        isFirefox: $555753d492a5a777$var$isFirefoxType(browser),
        isSafari: $555753d492a5a777$var$isSafariType(browser),
        isOpera: $555753d492a5a777$var$isOperaType(browser),
        isIE: $555753d492a5a777$var$isIEType(browser),
        osVersion: $555753d492a5a777$var$getOsVersion(os),
        osName: $555753d492a5a777$var$getOsName(os),
        fullBrowserVersion: $555753d492a5a777$var$getBrowserFullVersion(browser),
        browserVersion: $555753d492a5a777$var$getBrowserVersion(browser),
        browserName: $555753d492a5a777$var$getBrowserName(browser),
        mobileVendor: $555753d492a5a777$var$getMobileVendor(device),
        mobileModel: $555753d492a5a777$var$getMobileModel(device),
        engineName: $555753d492a5a777$var$getEngineName(engine),
        engineVersion: $555753d492a5a777$var$getEngineVersion(engine),
        getUA: $555753d492a5a777$var$getUseragent(ua),
        isEdge: $555753d492a5a777$var$isEdgeType(browser) || $555753d492a5a777$var$isEdgeChromiumType(ua),
        isYandex: $555753d492a5a777$var$isYandexType(browser),
        deviceType: $555753d492a5a777$var$getDeviceType(device),
        isIOS13: $555753d492a5a777$var$getIOS13(),
        isIPad13: $555753d492a5a777$var$getIPad13(),
        isIPhone13: $555753d492a5a777$var$getIphone13(),
        isIPod13: $555753d492a5a777$var$getIPod13(),
        isElectron: $555753d492a5a777$var$isElectronType(),
        isEdgeChromium: $555753d492a5a777$var$isEdgeChromiumType(ua),
        isLegacyEdge: $555753d492a5a777$var$isEdgeType(browser) && !$555753d492a5a777$var$isEdgeChromiumType(ua),
        isWindows: $555753d492a5a777$var$isWindowsType(os),
        isMacOs: $555753d492a5a777$var$isMacOsType(os),
        isMIUI: $555753d492a5a777$var$isMIUIType(browser),
        isSamsungBrowser: $555753d492a5a777$var$isSamsungBrowserType(browser)
    };
}
var $555753d492a5a777$var$isSmartTV = $555753d492a5a777$var$isSmartTVType($555753d492a5a777$var$device);
var $555753d492a5a777$var$isConsole = $555753d492a5a777$var$isConsoleType($555753d492a5a777$var$device);
var $555753d492a5a777$var$isWearable = $555753d492a5a777$var$isWearableType($555753d492a5a777$var$device);
var $555753d492a5a777$var$isEmbedded = $555753d492a5a777$var$isEmbeddedType($555753d492a5a777$var$device);
var $555753d492a5a777$var$isMobileSafari = $555753d492a5a777$var$isMobileSafariType($555753d492a5a777$var$browser) || $555753d492a5a777$var$getIPad13();
var $555753d492a5a777$var$isChromium = $555753d492a5a777$var$isChromiumType($555753d492a5a777$var$browser);
var $555753d492a5a777$var$isMobile = $555753d492a5a777$var$isMobileAndTabletType($555753d492a5a777$var$device) || $555753d492a5a777$var$getIPad13();
var $555753d492a5a777$var$isMobileOnly = $555753d492a5a777$var$isMobileType($555753d492a5a777$var$device);
var $555753d492a5a777$var$isTablet = $555753d492a5a777$var$isTabletType($555753d492a5a777$var$device) || $555753d492a5a777$var$getIPad13();
var $555753d492a5a777$var$isBrowser = $555753d492a5a777$var$isBrowserType($555753d492a5a777$var$device);
var $555753d492a5a777$var$isDesktop = $555753d492a5a777$var$isBrowserType($555753d492a5a777$var$device);
var $555753d492a5a777$var$isAndroid = $555753d492a5a777$var$isAndroidType($555753d492a5a777$var$os);
var $555753d492a5a777$var$isWinPhone = $555753d492a5a777$var$isWinPhoneType($555753d492a5a777$var$os);
var $555753d492a5a777$var$isIOS = $555753d492a5a777$var$isIOSType($555753d492a5a777$var$os) || $555753d492a5a777$var$getIPad13();
var $555753d492a5a777$var$isChrome = $555753d492a5a777$var$isChromeType($555753d492a5a777$var$browser);
var $555753d492a5a777$var$isFirefox = $555753d492a5a777$var$isFirefoxType($555753d492a5a777$var$browser);
var $555753d492a5a777$var$isSafari = $555753d492a5a777$var$isSafariType($555753d492a5a777$var$browser);
var $555753d492a5a777$var$isOpera = $555753d492a5a777$var$isOperaType($555753d492a5a777$var$browser);
var $555753d492a5a777$var$isIE = $555753d492a5a777$var$isIEType($555753d492a5a777$var$browser);
var $555753d492a5a777$var$osVersion = $555753d492a5a777$var$getOsVersion($555753d492a5a777$var$os);
var $555753d492a5a777$var$osName = $555753d492a5a777$var$getOsName($555753d492a5a777$var$os);
var $555753d492a5a777$var$fullBrowserVersion = $555753d492a5a777$var$getBrowserFullVersion($555753d492a5a777$var$browser);
var $555753d492a5a777$var$browserVersion = $555753d492a5a777$var$getBrowserVersion($555753d492a5a777$var$browser);
var $555753d492a5a777$var$browserName = $555753d492a5a777$var$getBrowserName($555753d492a5a777$var$browser);
var $555753d492a5a777$var$mobileVendor = $555753d492a5a777$var$getMobileVendor($555753d492a5a777$var$device);
var $555753d492a5a777$var$mobileModel = $555753d492a5a777$var$getMobileModel($555753d492a5a777$var$device);
var $555753d492a5a777$var$engineName = $555753d492a5a777$var$getEngineName($555753d492a5a777$var$engine);
var $555753d492a5a777$var$engineVersion = $555753d492a5a777$var$getEngineVersion($555753d492a5a777$var$engine);
var $555753d492a5a777$var$getUA = $555753d492a5a777$var$getUseragent($555753d492a5a777$var$ua);
var $555753d492a5a777$var$isEdge = $555753d492a5a777$var$isEdgeType($555753d492a5a777$var$browser) || $555753d492a5a777$var$isEdgeChromiumType($555753d492a5a777$var$ua);
var $555753d492a5a777$var$isYandex = $555753d492a5a777$var$isYandexType($555753d492a5a777$var$browser);
var $555753d492a5a777$var$deviceType = $555753d492a5a777$var$getDeviceType($555753d492a5a777$var$device);
var $555753d492a5a777$var$isIOS13 = $555753d492a5a777$var$getIOS13();
var $555753d492a5a777$var$isIPad13 = $555753d492a5a777$var$getIPad13();
var $555753d492a5a777$var$isIPhone13 = $555753d492a5a777$var$getIphone13();
var $555753d492a5a777$var$isIPod13 = $555753d492a5a777$var$getIPod13();
var $555753d492a5a777$var$isElectron = $555753d492a5a777$var$isElectronType();
var $555753d492a5a777$var$isEdgeChromium = $555753d492a5a777$var$isEdgeChromiumType($555753d492a5a777$var$ua);
var $555753d492a5a777$var$isLegacyEdge = $555753d492a5a777$var$isEdgeType($555753d492a5a777$var$browser) && !$555753d492a5a777$var$isEdgeChromiumType($555753d492a5a777$var$ua);
var $555753d492a5a777$var$isWindows = $555753d492a5a777$var$isWindowsType($555753d492a5a777$var$os);
var $555753d492a5a777$var$isMacOs = $555753d492a5a777$var$isMacOsType($555753d492a5a777$var$os);
var $555753d492a5a777$var$isMIUI = $555753d492a5a777$var$isMIUIType($555753d492a5a777$var$browser);
var $555753d492a5a777$var$isSamsungBrowser = $555753d492a5a777$var$isSamsungBrowserType($555753d492a5a777$var$browser);
var $555753d492a5a777$var$getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
    if (!userAgent || typeof userAgent !== "string") {
        console.error("No valid user agent string was provided");
        return;
    }
    var _UAHelper$parseUserAg = $555753d492a5a777$var$parseUserAgent(userAgent), device = _UAHelper$parseUserAg.device, browser = _UAHelper$parseUserAg.browser, os = _UAHelper$parseUserAg.os, engine = _UAHelper$parseUserAg.engine, ua = _UAHelper$parseUserAg.ua;
    return $555753d492a5a777$var$buildSelectorsObject({
        device: device,
        browser: browser,
        os: os,
        engine: engine,
        ua: ua
    });
};
var $555753d492a5a777$var$AndroidView = function AndroidView(_ref) {
    var renderWithFragment = _ref.renderWithFragment, children = _ref.children, props = $555753d492a5a777$var$_objectWithoutProperties(_ref, [
        "renderWithFragment",
        "children"
    ]);
    return $555753d492a5a777$var$isAndroid ? renderWithFragment ? $555753d492a5a777$var$React__default.createElement($1Mpn7.Fragment, null, children) : $555753d492a5a777$var$React__default.createElement("div", props, children) : null;
};
var $555753d492a5a777$var$BrowserView = function BrowserView(_ref2) {
    var renderWithFragment = _ref2.renderWithFragment, children = _ref2.children, props = $555753d492a5a777$var$_objectWithoutProperties(_ref2, [
        "renderWithFragment",
        "children"
    ]);
    return $555753d492a5a777$var$isBrowser ? renderWithFragment ? $555753d492a5a777$var$React__default.createElement($1Mpn7.Fragment, null, children) : $555753d492a5a777$var$React__default.createElement("div", props, children) : null;
};
var $555753d492a5a777$var$IEView = function IEView(_ref3) {
    var renderWithFragment = _ref3.renderWithFragment, children = _ref3.children, props = $555753d492a5a777$var$_objectWithoutProperties(_ref3, [
        "renderWithFragment",
        "children"
    ]);
    return $555753d492a5a777$var$isIE ? renderWithFragment ? $555753d492a5a777$var$React__default.createElement($1Mpn7.Fragment, null, children) : $555753d492a5a777$var$React__default.createElement("div", props, children) : null;
};
var $555753d492a5a777$var$IOSView = function IOSView(_ref4) {
    var renderWithFragment = _ref4.renderWithFragment, children = _ref4.children, props = $555753d492a5a777$var$_objectWithoutProperties(_ref4, [
        "renderWithFragment",
        "children"
    ]);
    return $555753d492a5a777$var$isIOS ? renderWithFragment ? $555753d492a5a777$var$React__default.createElement($1Mpn7.Fragment, null, children) : $555753d492a5a777$var$React__default.createElement("div", props, children) : null;
};
var $555753d492a5a777$var$MobileView = function MobileView(_ref5) {
    var renderWithFragment = _ref5.renderWithFragment, children = _ref5.children, props = $555753d492a5a777$var$_objectWithoutProperties(_ref5, [
        "renderWithFragment",
        "children"
    ]);
    return $555753d492a5a777$var$isMobile ? renderWithFragment ? $555753d492a5a777$var$React__default.createElement($1Mpn7.Fragment, null, children) : $555753d492a5a777$var$React__default.createElement("div", props, children) : null;
};
var $555753d492a5a777$var$TabletView = function TabletView(_ref6) {
    var renderWithFragment = _ref6.renderWithFragment, children = _ref6.children, props = $555753d492a5a777$var$_objectWithoutProperties(_ref6, [
        "renderWithFragment",
        "children"
    ]);
    return $555753d492a5a777$var$isTablet ? renderWithFragment ? $555753d492a5a777$var$React__default.createElement($1Mpn7.Fragment, null, children) : $555753d492a5a777$var$React__default.createElement("div", props, children) : null;
};
var $555753d492a5a777$var$WinPhoneView = function WinPhoneView(_ref7) {
    var renderWithFragment = _ref7.renderWithFragment, children = _ref7.children, props = $555753d492a5a777$var$_objectWithoutProperties(_ref7, [
        "renderWithFragment",
        "children"
    ]);
    return $555753d492a5a777$var$isWinPhone ? renderWithFragment ? $555753d492a5a777$var$React__default.createElement($1Mpn7.Fragment, null, children) : $555753d492a5a777$var$React__default.createElement("div", props, children) : null;
};
var $555753d492a5a777$var$MobileOnlyView = function MobileOnlyView(_ref8) {
    var renderWithFragment = _ref8.renderWithFragment, children = _ref8.children, viewClassName = _ref8.viewClassName, style = _ref8.style, props = $555753d492a5a777$var$_objectWithoutProperties(_ref8, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style"
    ]);
    return $555753d492a5a777$var$isMobileOnly ? renderWithFragment ? $555753d492a5a777$var$React__default.createElement($1Mpn7.Fragment, null, children) : $555753d492a5a777$var$React__default.createElement("div", props, children) : null;
};
var $555753d492a5a777$var$SmartTVView = function SmartTVView(_ref9) {
    var renderWithFragment = _ref9.renderWithFragment, children = _ref9.children, props = $555753d492a5a777$var$_objectWithoutProperties(_ref9, [
        "renderWithFragment",
        "children"
    ]);
    return $555753d492a5a777$var$isSmartTV ? renderWithFragment ? $555753d492a5a777$var$React__default.createElement($1Mpn7.Fragment, null, children) : $555753d492a5a777$var$React__default.createElement("div", props, children) : null;
};
var $555753d492a5a777$var$ConsoleView = function ConsoleView(_ref10) {
    var renderWithFragment = _ref10.renderWithFragment, children = _ref10.children, props = $555753d492a5a777$var$_objectWithoutProperties(_ref10, [
        "renderWithFragment",
        "children"
    ]);
    return $555753d492a5a777$var$isConsole ? renderWithFragment ? $555753d492a5a777$var$React__default.createElement($1Mpn7.Fragment, null, children) : $555753d492a5a777$var$React__default.createElement("div", props, children) : null;
};
var $555753d492a5a777$var$WearableView = function WearableView(_ref11) {
    var renderWithFragment = _ref11.renderWithFragment, children = _ref11.children, props = $555753d492a5a777$var$_objectWithoutProperties(_ref11, [
        "renderWithFragment",
        "children"
    ]);
    return $555753d492a5a777$var$isWearable ? renderWithFragment ? $555753d492a5a777$var$React__default.createElement($1Mpn7.Fragment, null, children) : $555753d492a5a777$var$React__default.createElement("div", props, children) : null;
};
var $555753d492a5a777$var$CustomView = function CustomView(_ref12) {
    var renderWithFragment = _ref12.renderWithFragment, children = _ref12.children, viewClassName = _ref12.viewClassName, style = _ref12.style, condition = _ref12.condition, props = $555753d492a5a777$var$_objectWithoutProperties(_ref12, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style",
        "condition"
    ]);
    return condition ? renderWithFragment ? $555753d492a5a777$var$React__default.createElement($1Mpn7.Fragment, null, children) : $555753d492a5a777$var$React__default.createElement("div", props, children) : null;
};
function $555753d492a5a777$var$withOrientationChange(WrappedComponent) {
    return /*#__PURE__*/ function(_React$Component) {
        $555753d492a5a777$var$_inherits(_class, _React$Component);
        function _class(props) {
            var _this;
            $555753d492a5a777$var$_classCallCheck(this, _class);
            _this = $555753d492a5a777$var$_possibleConstructorReturn(this, $555753d492a5a777$var$_getPrototypeOf(_class).call(this, props));
            _this.isEventListenerAdded = false;
            _this.handleOrientationChange = _this.handleOrientationChange.bind($555753d492a5a777$var$_assertThisInitialized(_this));
            _this.onOrientationChange = _this.onOrientationChange.bind($555753d492a5a777$var$_assertThisInitialized(_this));
            _this.onPageLoad = _this.onPageLoad.bind($555753d492a5a777$var$_assertThisInitialized(_this));
            _this.state = {
                isLandscape: false,
                isPortrait: false
            };
            return _this;
        }
        $555753d492a5a777$var$_createClass(_class, [
            {
                key: "handleOrientationChange",
                value: function handleOrientationChange() {
                    if (!this.isEventListenerAdded) this.isEventListenerAdded = true;
                    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
                    this.setState({
                        isPortrait: orientation === 0,
                        isLandscape: orientation === 90
                    });
                }
            },
            {
                key: "onOrientationChange",
                value: function onOrientationChange() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "onPageLoad",
                value: function onPageLoad() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if ((typeof window === "undefined" ? "undefined" : $555753d492a5a777$var$_typeof(window)) !== undefined && $555753d492a5a777$var$isMobile) {
                        if (!this.isEventListenerAdded) {
                            this.handleOrientationChange();
                            window.addEventListener("load", this.onPageLoad, false);
                        } else window.removeEventListener("load", this.onPageLoad, false);
                        window.addEventListener("resize", this.onOrientationChange, false);
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    window.removeEventListener("resize", this.onOrientationChange, false);
                }
            },
            {
                key: "render",
                value: function render() {
                    return $555753d492a5a777$var$React__default.createElement(WrappedComponent, $555753d492a5a777$var$_extends({}, this.props, {
                        isLandscape: this.state.isLandscape,
                        isPortrait: this.state.isPortrait
                    }));
                }
            }
        ]);
        return _class;
    }($555753d492a5a777$var$React__default.Component);
}
function $555753d492a5a777$var$useMobileOrientation() {
    var _useState = $1Mpn7.useState(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        return {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? "portrait" : "landscape"
        };
    }), _useState2 = $555753d492a5a777$var$_slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var handleOrientationChange = $1Mpn7.useCallback(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        var next = {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? "portrait" : "landscape"
        };
        state.orientation !== next.orientation && setState(next);
    }, [
        state.orientation
    ]);
    $1Mpn7.useEffect(function() {
        if ((typeof window === "undefined" ? "undefined" : $555753d492a5a777$var$_typeof(window)) !== undefined && $555753d492a5a777$var$isMobile) {
            handleOrientationChange();
            window.addEventListener("load", handleOrientationChange, false);
            window.addEventListener("resize", handleOrientationChange, false);
        }
        return function() {
            window.removeEventListener("resize", handleOrientationChange, false);
            window.removeEventListener("load", handleOrientationChange, false);
        };
    }, [
        handleOrientationChange
    ]);
    return state;
}
function $555753d492a5a777$var$useDeviceData(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    return $555753d492a5a777$var$parseUserAgent(hookUserAgent);
}
function $555753d492a5a777$var$useDeviceSelectors(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    var deviceData = $555753d492a5a777$var$useDeviceData(hookUserAgent);
    var selectors = $555753d492a5a777$var$buildSelectorsObject(deviceData);
    return [
        selectors,
        deviceData
    ];
}
$555753d492a5a777$exports.AndroidView = $555753d492a5a777$var$AndroidView;
$555753d492a5a777$exports.BrowserTypes = $555753d492a5a777$var$BrowserTypes;
$555753d492a5a777$exports.BrowserView = $555753d492a5a777$var$BrowserView;
$555753d492a5a777$exports.ConsoleView = $555753d492a5a777$var$ConsoleView;
$555753d492a5a777$exports.CustomView = $555753d492a5a777$var$CustomView;
$555753d492a5a777$exports.IEView = $555753d492a5a777$var$IEView;
$555753d492a5a777$exports.IOSView = $555753d492a5a777$var$IOSView;
$555753d492a5a777$exports.MobileOnlyView = $555753d492a5a777$var$MobileOnlyView;
$555753d492a5a777$exports.MobileView = $555753d492a5a777$var$MobileView;
$555753d492a5a777$exports.OsTypes = $555753d492a5a777$var$OsTypes;
$555753d492a5a777$exports.SmartTVView = $555753d492a5a777$var$SmartTVView;
$555753d492a5a777$exports.TabletView = $555753d492a5a777$var$TabletView;
$555753d492a5a777$exports.WearableView = $555753d492a5a777$var$WearableView;
$555753d492a5a777$exports.WinPhoneView = $555753d492a5a777$var$WinPhoneView;
$555753d492a5a777$exports.browserName = $555753d492a5a777$var$browserName;
$555753d492a5a777$exports.browserVersion = $555753d492a5a777$var$browserVersion;
$555753d492a5a777$exports.deviceDetect = $555753d492a5a777$var$deviceDetect;
$555753d492a5a777$exports.deviceType = $555753d492a5a777$var$deviceType;
$555753d492a5a777$exports.engineName = $555753d492a5a777$var$engineName;
$555753d492a5a777$exports.engineVersion = $555753d492a5a777$var$engineVersion;
$555753d492a5a777$exports.fullBrowserVersion = $555753d492a5a777$var$fullBrowserVersion;
$555753d492a5a777$exports.getSelectorsByUserAgent = $555753d492a5a777$var$getSelectorsByUserAgent;
$555753d492a5a777$exports.getUA = $555753d492a5a777$var$getUA;
$555753d492a5a777$exports.isAndroid = $555753d492a5a777$var$isAndroid;
$555753d492a5a777$exports.isBrowser = $555753d492a5a777$var$isBrowser;
$555753d492a5a777$exports.isChrome = $555753d492a5a777$var$isChrome;
$555753d492a5a777$exports.isChromium = $555753d492a5a777$var$isChromium;
$555753d492a5a777$exports.isConsole = $555753d492a5a777$var$isConsole;
$555753d492a5a777$exports.isDesktop = $555753d492a5a777$var$isDesktop;
$555753d492a5a777$exports.isEdge = $555753d492a5a777$var$isEdge;
$555753d492a5a777$exports.isEdgeChromium = $555753d492a5a777$var$isEdgeChromium;
$555753d492a5a777$exports.isElectron = $555753d492a5a777$var$isElectron;
$555753d492a5a777$exports.isEmbedded = $555753d492a5a777$var$isEmbedded;
$555753d492a5a777$exports.isFirefox = $555753d492a5a777$var$isFirefox;
$555753d492a5a777$exports.isIE = $555753d492a5a777$var$isIE;
$555753d492a5a777$exports.isIOS = $555753d492a5a777$var$isIOS;
$555753d492a5a777$exports.isIOS13 = $555753d492a5a777$var$isIOS13;
$555753d492a5a777$exports.isIPad13 = $555753d492a5a777$var$isIPad13;
$555753d492a5a777$exports.isIPhone13 = $555753d492a5a777$var$isIPhone13;
$555753d492a5a777$exports.isIPod13 = $555753d492a5a777$var$isIPod13;
$555753d492a5a777$exports.isLegacyEdge = $555753d492a5a777$var$isLegacyEdge;
$555753d492a5a777$exports.isMIUI = $555753d492a5a777$var$isMIUI;
$555753d492a5a777$exports.isMacOs = $555753d492a5a777$var$isMacOs;
$555753d492a5a777$exports.isMobile = $555753d492a5a777$var$isMobile;
$555753d492a5a777$exports.isMobileOnly = $555753d492a5a777$var$isMobileOnly;
$555753d492a5a777$exports.isMobileSafari = $555753d492a5a777$var$isMobileSafari;
$555753d492a5a777$exports.isOpera = $555753d492a5a777$var$isOpera;
$555753d492a5a777$exports.isSafari = $555753d492a5a777$var$isSafari;
$555753d492a5a777$exports.isSamsungBrowser = $555753d492a5a777$var$isSamsungBrowser;
$555753d492a5a777$exports.isSmartTV = $555753d492a5a777$var$isSmartTV;
$555753d492a5a777$exports.isTablet = $555753d492a5a777$var$isTablet;
$555753d492a5a777$exports.isWearable = $555753d492a5a777$var$isWearable;
$555753d492a5a777$exports.isWinPhone = $555753d492a5a777$var$isWinPhone;
$555753d492a5a777$exports.isWindows = $555753d492a5a777$var$isWindows;
$555753d492a5a777$exports.isYandex = $555753d492a5a777$var$isYandex;
$555753d492a5a777$exports.mobileModel = $555753d492a5a777$var$mobileModel;
$555753d492a5a777$exports.mobileVendor = $555753d492a5a777$var$mobileVendor;
$555753d492a5a777$exports.osName = $555753d492a5a777$var$osName;
$555753d492a5a777$exports.osVersion = $555753d492a5a777$var$osVersion;
$555753d492a5a777$exports.parseUserAgent = $555753d492a5a777$var$parseUserAgent;
$555753d492a5a777$exports.setUserAgent = $555753d492a5a777$var$setUserAgent;
$555753d492a5a777$exports.useDeviceData = $555753d492a5a777$var$useDeviceData;
$555753d492a5a777$exports.useDeviceSelectors = $555753d492a5a777$var$useDeviceSelectors;
$555753d492a5a777$exports.useMobileOrientation = $555753d492a5a777$var$useMobileOrientation;
$555753d492a5a777$exports.withOrientationChange = $555753d492a5a777$var$withOrientationChange;



var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $1Mpn7 = parcelRequire("1Mpn7");

var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");

var $cv9Rk = parcelRequire("cv9Rk");

var $eha6O = parcelRequire("eha6O");


var $1Mpn7 = parcelRequire("1Mpn7");
function $c9560fc6dd4c9941$export$629f18756d2627db(param) {
    var onSelectWallet = param.onSelectWallet;
    var _useWallet = (0, $064a90e950b6662f$export$c34addee860b0acb)(), connect = _useWallet.connect, connected = _useWallet.connected, connecting = _useWallet.connecting, disconnect = _useWallet.disconnect, disconnecting = _useWallet.disconnecting, publicKey = _useWallet.publicKey, select = _useWallet.select, wallet = _useWallet.wallet, wallets = _useWallet.wallets;
    var buttonState;
    if (connecting) buttonState = "connecting";
    else if (connected) buttonState = "connected";
    else if (disconnecting) buttonState = "disconnecting";
    else if (wallet) buttonState = "has-wallet";
    else buttonState = "no-wallet";
    var handleConnect = (0, $1Mpn7.useCallback)(function() {
        connect().catch(function() {
        // Silently catch because any errors are caught by the context `onError` handler
        });
    }, [
        connect
    ]);
    var handleDisconnect = (0, $1Mpn7.useCallback)(function() {
        disconnect().catch(function() {
        // Silently catch because any errors are caught by the context `onError` handler
        });
    }, [
        disconnect
    ]);
    var handleSelectWallet = (0, $1Mpn7.useCallback)(function() {
        onSelectWallet({
            onSelectWallet: select,
            wallets: wallets
        });
    }, [
        onSelectWallet,
        select,
        wallets
    ]);
    return {
        buttonState: buttonState,
        onConnect: buttonState === "has-wallet" ? handleConnect : undefined,
        onDisconnect: buttonState !== "disconnecting" && buttonState !== "no-wallet" ? handleDisconnect : undefined,
        onSelectWallet: handleSelectWallet,
        publicKey: publicKey !== null && publicKey !== void 0 ? publicKey : undefined,
        walletIcon: wallet === null || wallet === void 0 ? void 0 : wallet.adapter.icon,
        walletName: wallet === null || wallet === void 0 ? void 0 : wallet.adapter.name
    };
}



var $1Mpn7 = parcelRequire("1Mpn7");

var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

var $dRLPW = parcelRequire("dRLPW");

var $1Mpn7 = parcelRequire("1Mpn7");

var $1Mpn7 = parcelRequire("1Mpn7");
var $9026b6a4b6691806$export$353f5b6fc5456de1 = function(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("button", {
        className: "wallet-adapter-button ".concat(props.className || ""),
        disabled: props.disabled,
        style: props.style,
        onClick: props.onClick,
        tabIndex: props.tabIndex || 0,
        type: "button"
    }, props.startIcon && (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("i", {
        className: "wallet-adapter-button-start-icon"
    }, props.startIcon), props.children, props.endIcon && (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("i", {
        className: "wallet-adapter-button-end-icon"
    }, props.endIcon));
};



var $do9pw = parcelRequire("do9pw");

var $dRLPW = parcelRequire("dRLPW");

var $1Mpn7 = parcelRequire("1Mpn7");
var $bed038088ef80935$export$deff84e7338ee5a5 = function(_param) {
    var wallet = _param.wallet, props = (0, $dRLPW._)(_param, [
        "wallet"
    ]);
    return wallet && (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("img", (0, $do9pw._)({
        src: wallet.adapter.icon,
        alt: "".concat(wallet.adapter.name, " icon")
    }, props));
};


function $a48ecffd578d9df2$export$a0d4a8038508425f(_param) {
    var walletIcon = _param.walletIcon, walletName = _param.walletName, props = (0, $dRLPW._)(_param, [
        "walletIcon",
        "walletName"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $9026b6a4b6691806$export$353f5b6fc5456de1), (0, $cxjpp._)((0, $do9pw._)({}, props), {
        className: "wallet-adapter-button-trigger",
        startIcon: walletIcon && walletName ? (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $bed038088ef80935$export$deff84e7338ee5a5), {
            wallet: {
                adapter: {
                    icon: walletIcon,
                    name: walletName
                }
            }
        }) : undefined
    }));
}



var $1Mpn7 = parcelRequire("1Mpn7");
var $9b6750fc2685388d$var$DEFAULT_CONTEXT = {
    setVisible: function(_open) {
        console.error($9b6750fc2685388d$var$constructMissingProviderErrorMessage("call", "setVisible"));
    },
    visible: false
};
Object.defineProperty($9b6750fc2685388d$var$DEFAULT_CONTEXT, "visible", {
    get: function() {
        console.error($9b6750fc2685388d$var$constructMissingProviderErrorMessage("read", "visible"));
        return false;
    }
});
function $9b6750fc2685388d$var$constructMissingProviderErrorMessage(action, valueName) {
    return "You have tried to " + " ".concat(action, ' "').concat(valueName, '"') + " on a WalletModalContext without providing one." + " Make sure to render a WalletModalProvider" + " as an ancestor of the component that uses " + "WalletModalContext";
}
var $9b6750fc2685388d$export$8fa8c0fc3ea86e87 = (0, $1Mpn7.createContext)($9b6750fc2685388d$var$DEFAULT_CONTEXT);
function $9b6750fc2685388d$export$6fdf0454adae214b() {
    return (0, $1Mpn7.useContext)($9b6750fc2685388d$export$8fa8c0fc3ea86e87);
}


function $2d0629b643cd6437$export$50382f20865178f9(_param) {
    var children = _param.children, labels = _param.labels, props = (0, $dRLPW._)(_param, [
        "children",
        "labels"
    ]);
    var _useWalletModal = (0, $9b6750fc2685388d$export$6fdf0454adae214b)(), setModalVisible = _useWalletModal.setVisible;
    var _useWalletMultiButton = (0, $c9560fc6dd4c9941$export$629f18756d2627db)({
        onSelectWallet: function() {
            setModalVisible(true);
        }
    }), buttonState = _useWalletMultiButton.buttonState, onConnect = _useWalletMultiButton.onConnect, onDisconnect = _useWalletMultiButton.onDisconnect, publicKey = _useWalletMultiButton.publicKey, walletIcon = _useWalletMultiButton.walletIcon, walletName = _useWalletMultiButton.walletName;
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)(false), 2), copied = _useState[0], setCopied = _useState[1];
    var _useState1 = (0, $cv9Rk._)((0, $1Mpn7.useState)(false), 2), menuOpen = _useState1[0], setMenuOpen = _useState1[1];
    var ref = (0, $1Mpn7.useRef)(null);
    (0, $1Mpn7.useEffect)(function() {
        var listener = function(event) {
            var node = ref.current;
            // Do nothing if clicking dropdown or its descendants
            if (!node || node.contains(event.target)) return;
            setMenuOpen(false);
        };
        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener);
        return function() {
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, []);
    var content = (0, $1Mpn7.useMemo)(function() {
        if (children) return children;
        else if (publicKey) {
            var base58 = publicKey.toBase58();
            return base58.slice(0, 4) + ".." + base58.slice(-4);
        } else if (buttonState === "connecting" || buttonState === "has-wallet") return labels[buttonState];
        else return labels["no-wallet"];
    }, [
        buttonState,
        children,
        labels,
        publicKey
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("div", {
        className: "wallet-adapter-dropdown"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $a48ecffd578d9df2$export$a0d4a8038508425f), (0, $cxjpp._)((0, $do9pw._)({}, props), {
        "aria-expanded": menuOpen,
        style: (0, $do9pw._)({
            pointerEvents: menuOpen ? "none" : "auto"
        }, props.style),
        onClick: function() {
            switch(buttonState){
                case "no-wallet":
                    setModalVisible(true);
                    break;
                case "has-wallet":
                    if (onConnect) onConnect();
                    break;
                case "connected":
                    setMenuOpen(true);
                    break;
            }
        },
        walletIcon: walletIcon,
        walletName: walletName
    }), content), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("ul", {
        "aria-label": "dropdown-list",
        className: "wallet-adapter-dropdown-list ".concat(menuOpen && "wallet-adapter-dropdown-list-active"),
        ref: ref,
        role: "menu"
    }, publicKey ? (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("li", {
        className: "wallet-adapter-dropdown-list-item",
        onClick: /*#__PURE__*/ (0, $kSuI9._)(function() {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            navigator.clipboard.writeText(publicKey.toBase58())
                        ];
                    case 1:
                        _state.sent();
                        setCopied(true);
                        setTimeout(function() {
                            return setCopied(false);
                        }, 400);
                        return [
                            2
                        ];
                }
            });
        }),
        role: "menuitem"
    }, copied ? labels["copied"] : labels["copy-address"]) : null, (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("li", {
        className: "wallet-adapter-dropdown-list-item",
        onClick: function() {
            setModalVisible(true);
            setMenuOpen(false);
        },
        role: "menuitem"
    }, labels["change-wallet"]), onDisconnect ? (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("li", {
        className: "wallet-adapter-dropdown-list-item",
        onClick: function() {
            onDisconnect();
            setMenuOpen(false);
        },
        role: "menuitem"
    }, labels["disconnect"]) : null));
}


var $258f56c4f81ef851$var$LABELS = {
    "change-wallet": "Change wallet",
    connecting: "Connecting ...",
    "copy-address": "Copy address",
    copied: "Copied",
    disconnect: "Disconnect",
    "has-wallet": "Connect",
    "no-wallet": "Select Wallet"
};
function $258f56c4f81ef851$export$968d144f04194cbb(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $2d0629b643cd6437$export$50382f20865178f9), (0, $cxjpp._)((0, $do9pw._)({}, props), {
        labels: $258f56c4f81ef851$var$LABELS
    }));
}


var $do9pw = parcelRequire("do9pw");

var $dRLPW = parcelRequire("dRLPW");

var $cv9Rk = parcelRequire("cv9Rk");

var $1Mpn7 = parcelRequire("1Mpn7");


var $cv9Rk = parcelRequire("cv9Rk");



var $1Mpn7 = parcelRequire("1Mpn7");


var $1Mpn7 = parcelRequire("1Mpn7");
var $d58210e799bd6b7f$export$78768a9af065a7b = function(param) {
    var id = param.id, children = param.children, _param_expanded = param.expanded, expanded = _param_expanded === void 0 ? false : _param_expanded;
    var ref = (0, $1Mpn7.useRef)(null);
    var instant = (0, $1Mpn7.useRef)(true);
    var transition = "height 250ms ease-out";
    var openCollapse = function() {
        var node = ref.current;
        if (!node) return;
        requestAnimationFrame(function() {
            node.style.height = node.scrollHeight + "px";
        });
    };
    var closeCollapse = function() {
        var node = ref.current;
        if (!node) return;
        requestAnimationFrame(function() {
            node.style.height = node.offsetHeight + "px";
            node.style.overflow = "hidden";
            requestAnimationFrame(function() {
                node.style.height = "0";
            });
        });
    };
    (0, $1Mpn7.useLayoutEffect)(function() {
        if (expanded) openCollapse();
        else closeCollapse();
    }, [
        expanded
    ]);
    (0, $1Mpn7.useLayoutEffect)(function() {
        var node = ref.current;
        if (!node) return;
        function handleComplete() {
            if (!node) return;
            node.style.overflow = expanded ? "initial" : "hidden";
            if (expanded) node.style.height = "auto";
        }
        function handleTransitionEnd(event) {
            if (node && event.target === node && event.propertyName === "height") handleComplete();
        }
        if (instant.current) {
            handleComplete();
            instant.current = false;
        }
        node.addEventListener("transitionend", handleTransitionEnd);
        return function() {
            return node.removeEventListener("transitionend", handleTransitionEnd);
        };
    }, [
        expanded
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("div", {
        className: "wallet-adapter-collapse",
        id: id,
        ref: ref,
        role: "region",
        style: {
            height: 0,
            transition: instant.current ? undefined : transition
        }
    }, children);
};




var $1Mpn7 = parcelRequire("1Mpn7");


var $5a35e27217f573ae$export$b6b33106605f17bb = function(param) {
    var handleClick = param.handleClick, tabIndex = param.tabIndex, wallet = param.wallet;
    return (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("li", null, (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $9026b6a4b6691806$export$353f5b6fc5456de1), {
        onClick: handleClick,
        startIcon: (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $bed038088ef80935$export$deff84e7338ee5a5), {
            wallet: wallet
        }),
        tabIndex: tabIndex
    }, wallet.adapter.name, wallet.readyState === (0, $8c7df08073723177$export$2a7b8071105d05b6).Installed && (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("span", null, "Detected")));
};



var $1Mpn7 = parcelRequire("1Mpn7");
var $96f344aeb7aceb63$export$d822b842d2dccc19 = function() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("svg", {
        width: "97",
        height: "96",
        viewBox: "0 0 97 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("circle", {
        cx: "48.5",
        cy: "48",
        r: "48",
        fill: "url(#paint0_linear_880_5115)",
        fillOpacity: "0.1"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("circle", {
        cx: "48.5",
        cy: "48",
        r: "47",
        stroke: "url(#paint1_linear_880_5115)",
        strokeOpacity: "0.4",
        strokeWidth: "2"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("g", {
        clipPath: "url(#clip0_880_5115)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("path", {
        d: "M65.5769 28.1523H31.4231C27.6057 28.1523 24.5 31.258 24.5 35.0754V60.9215C24.5 64.7389 27.6057 67.8446 31.4231 67.8446H65.5769C69.3943 67.8446 72.5 64.7389 72.5 60.9215V35.0754C72.5 31.258 69.3943 28.1523 65.5769 28.1523ZM69.7308 52.1523H59.5769C57.2865 52.1523 55.4231 50.289 55.4231 47.9985C55.4231 45.708 57.2864 43.8446 59.5769 43.8446H69.7308V52.1523ZM69.7308 41.0754H59.5769C55.7595 41.0754 52.6539 44.1811 52.6539 47.9985C52.6539 51.8159 55.7595 54.9215 59.5769 54.9215H69.7308V60.9215C69.7308 63.2119 67.8674 65.0754 65.5769 65.0754H31.4231C29.1327 65.0754 27.2692 63.212 27.2692 60.9215V35.0754C27.2692 32.785 29.1326 30.9215 31.4231 30.9215H65.5769C67.8673 30.9215 69.7308 32.7849 69.7308 35.0754V41.0754Z",
        fill: "url(#paint2_linear_880_5115)"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("path", {
        d: "M61.4231 46.6172H59.577C58.8123 46.6172 58.1924 47.2371 58.1924 48.0018C58.1924 48.7665 58.8123 49.3863 59.577 49.3863H61.4231C62.1878 49.3863 62.8077 48.7664 62.8077 48.0018C62.8077 47.2371 62.1878 46.6172 61.4231 46.6172Z",
        fill: "url(#paint3_linear_880_5115)"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("defs", null, (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("linearGradient", {
        id: "paint0_linear_880_5115",
        x1: "3.41664",
        y1: "98.0933",
        x2: "103.05",
        y2: "8.42498",
        gradientUnits: "userSpaceOnUse"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("stop", {
        stopColor: "#9945FF"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("stop", {
        offset: "0.14",
        stopColor: "#8A53F4"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("stop", {
        offset: "0.42",
        stopColor: "#6377D6"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("stop", {
        offset: "0.79",
        stopColor: "#24B0A7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("stop", {
        offset: "0.99",
        stopColor: "#00D18C"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("stop", {
        offset: "1",
        stopColor: "#00D18C"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("linearGradient", {
        id: "paint1_linear_880_5115",
        x1: "3.41664",
        y1: "98.0933",
        x2: "103.05",
        y2: "8.42498",
        gradientUnits: "userSpaceOnUse"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("stop", {
        stopColor: "#9945FF"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("stop", {
        offset: "0.14",
        stopColor: "#8A53F4"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("stop", {
        offset: "0.42",
        stopColor: "#6377D6"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("stop", {
        offset: "0.79",
        stopColor: "#24B0A7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("stop", {
        offset: "0.99",
        stopColor: "#00D18C"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("stop", {
        offset: "1",
        stopColor: "#00D18C"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("linearGradient", {
        id: "paint2_linear_880_5115",
        x1: "25.9583",
        y1: "68.7101",
        x2: "67.2337",
        y2: "23.7879",
        gradientUnits: "userSpaceOnUse"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("stop", {
        stopColor: "#9945FF"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("stop", {
        offset: "0.14",
        stopColor: "#8A53F4"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("stop", {
        offset: "0.42",
        stopColor: "#6377D6"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("stop", {
        offset: "0.79",
        stopColor: "#24B0A7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("stop", {
        offset: "0.99",
        stopColor: "#00D18C"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("stop", {
        offset: "1",
        stopColor: "#00D18C"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("linearGradient", {
        id: "paint3_linear_880_5115",
        x1: "58.3326",
        y1: "49.4467",
        x2: "61.0002",
        y2: "45.4453",
        gradientUnits: "userSpaceOnUse"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("stop", {
        stopColor: "#9945FF"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("stop", {
        offset: "0.14",
        stopColor: "#8A53F4"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("stop", {
        offset: "0.42",
        stopColor: "#6377D6"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("stop", {
        offset: "0.79",
        stopColor: "#24B0A7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("stop", {
        offset: "0.99",
        stopColor: "#00D18C"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("stop", {
        offset: "1",
        stopColor: "#00D18C"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("clipPath", {
        id: "clip0_880_5115"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("rect", {
        width: "48",
        height: "48",
        fill: "white",
        transform: "translate(24.5 24)"
    }))));
};



var $60b5e2519e095a6d$export$851b8e4aa786e6a1 = function(param) {
    var _param_className = param.className, className = _param_className === void 0 ? "" : _param_className, _param_container = param.container, container = _param_container === void 0 ? "body" : _param_container;
    var ref = (0, $1Mpn7.useRef)(null);
    var _useWallet = (0, $064a90e950b6662f$export$c34addee860b0acb)(), wallets = _useWallet.wallets, select = _useWallet.select;
    var setVisible = (0, $9b6750fc2685388d$export$6fdf0454adae214b)().setVisible;
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)(false), 2), expanded = _useState[0], setExpanded = _useState[1];
    var _useState1 = (0, $cv9Rk._)((0, $1Mpn7.useState)(false), 2), fadeIn = _useState1[0], setFadeIn = _useState1[1];
    var _useState2 = (0, $cv9Rk._)((0, $1Mpn7.useState)(null), 2), portal = _useState2[0], setPortal = _useState2[1];
    var _useMemo = (0, $cv9Rk._)((0, $1Mpn7.useMemo)(function() {
        var installed = [];
        var notInstalled = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = wallets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var wallet = _step.value;
                if (wallet.readyState === (0, $8c7df08073723177$export$2a7b8071105d05b6).Installed) installed.push(wallet);
                else notInstalled.push(wallet);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return installed.length ? [
            installed,
            notInstalled
        ] : [
            notInstalled,
            []
        ];
    }, [
        wallets
    ]), 2), listedWallets = _useMemo[0], collapsedWallets = _useMemo[1];
    var hideModal = (0, $1Mpn7.useCallback)(function() {
        setFadeIn(false);
        setTimeout(function() {
            return setVisible(false);
        }, 150);
    }, [
        setVisible
    ]);
    var handleClose = (0, $1Mpn7.useCallback)(function(event) {
        event.preventDefault();
        hideModal();
    }, [
        hideModal
    ]);
    var handleWalletClick = (0, $1Mpn7.useCallback)(function(event, walletName) {
        select(walletName);
        handleClose(event);
    }, [
        select,
        handleClose
    ]);
    var handleCollapseClick = (0, $1Mpn7.useCallback)(function() {
        return setExpanded(!expanded);
    }, [
        expanded
    ]);
    var handleTabKey = (0, $1Mpn7.useCallback)(function(event) {
        var node = ref.current;
        if (!node) return;
        // here we query all focusable elements
        var focusableElements = node.querySelectorAll("button");
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var firstElement = focusableElements[0];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var lastElement = focusableElements[focusableElements.length - 1];
        if (event.shiftKey) // if going backward by pressing tab and firstElement is active, shift focus to last focusable element
        {
            if (document.activeElement === firstElement) {
                lastElement.focus();
                event.preventDefault();
            }
        } else // if going forward by pressing tab and lastElement is active, shift focus to first focusable element
        if (document.activeElement === lastElement) {
            firstElement.focus();
            event.preventDefault();
        }
    }, [
        ref
    ]);
    (0, $1Mpn7.useLayoutEffect)(function() {
        var handleKeyDown = function(event) {
            if (event.key === "Escape") hideModal();
            else if (event.key === "Tab") handleTabKey(event);
        };
        // Get original overflow
        var overflow = window.getComputedStyle(document.body).overflow;
        // Hack to enable fade in animation after mount
        setTimeout(function() {
            return setFadeIn(true);
        }, 0);
        // Prevent scrolling on mount
        document.body.style.overflow = "hidden";
        // Listen for keydown events
        window.addEventListener("keydown", handleKeyDown, false);
        return function() {
            // Re-enable scrolling when component unmounts
            document.body.style.overflow = overflow;
            window.removeEventListener("keydown", handleKeyDown, false);
        };
    }, [
        hideModal,
        handleTabKey
    ]);
    (0, $1Mpn7.useLayoutEffect)(function() {
        return setPortal(document.querySelector(container));
    }, [
        container
    ]);
    return portal && (0, $aca89270c978b9c1$exports.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("div", {
        "aria-labelledby": "wallet-adapter-modal-title",
        "aria-modal": "true",
        className: "wallet-adapter-modal ".concat(fadeIn && "wallet-adapter-modal-fade-in", " ").concat(className),
        ref: ref,
        role: "dialog"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("div", {
        className: "wallet-adapter-modal-container"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("div", {
        className: "wallet-adapter-modal-wrapper"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("button", {
        onClick: handleClose,
        className: "wallet-adapter-modal-button-close"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("svg", {
        width: "14",
        height: "14"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("path", {
        d: "M14 12.461 8.3 6.772l5.234-5.233L12.006 0 6.772 5.234 1.54 0 0 1.539l5.234 5.233L0 12.006l1.539 1.528L6.772 8.3l5.69 5.7L14 12.461z"
    }))), listedWallets.length ? (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("h1", {
        className: "wallet-adapter-modal-title"
    }, "Connect a wallet on Solana to continue"), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("ul", {
        className: "wallet-adapter-modal-list"
    }, listedWallets.map(function(wallet) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $5a35e27217f573ae$export$b6b33106605f17bb), {
            key: wallet.adapter.name,
            handleClick: function(event) {
                return handleWalletClick(event, wallet.adapter.name);
            },
            wallet: wallet
        });
    }), collapsedWallets.length ? (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $d58210e799bd6b7f$export$78768a9af065a7b), {
        expanded: expanded,
        id: "wallet-adapter-modal-collapse"
    }, collapsedWallets.map(function(wallet) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $5a35e27217f573ae$export$b6b33106605f17bb), {
            key: wallet.adapter.name,
            handleClick: function(event) {
                return handleWalletClick(event, wallet.adapter.name);
            },
            tabIndex: expanded ? 0 : -1,
            wallet: wallet
        });
    })) : null), collapsedWallets.length ? (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("button", {
        className: "wallet-adapter-modal-list-more",
        onClick: handleCollapseClick,
        tabIndex: 0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("span", null, expanded ? "Less " : "More ", "options"), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("svg", {
        width: "13",
        height: "7",
        viewBox: "0 0 13 7",
        xmlns: "http://www.w3.org/2000/svg",
        className: "".concat(expanded ? "wallet-adapter-modal-list-more-icon-rotate" : "")
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("path", {
        d: "M0.71418 1.626L5.83323 6.26188C5.91574 6.33657 6.0181 6.39652 6.13327 6.43762C6.24844 6.47872 6.37371 6.5 6.50048 6.5C6.62725 6.5 6.75252 6.47872 6.8677 6.43762C6.98287 6.39652 7.08523 6.33657 7.16774 6.26188L12.2868 1.626C12.7753 1.1835 12.3703 0.5 11.6195 0.5H1.37997C0.629216 0.5 0.224175 1.1835 0.71418 1.626Z"
    }))) : null) : (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("h1", {
        className: "wallet-adapter-modal-title"
    }, "You'll need a wallet on Solana to continue"), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("div", {
        className: "wallet-adapter-modal-middle"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $96f344aeb7aceb63$export$d822b842d2dccc19), null)), collapsedWallets.length ? (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("button", {
        className: "wallet-adapter-modal-list-more",
        onClick: handleCollapseClick,
        tabIndex: 0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("span", null, expanded ? "Hide " : "Already have a wallet? View ", "options"), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("svg", {
        width: "13",
        height: "7",
        viewBox: "0 0 13 7",
        xmlns: "http://www.w3.org/2000/svg",
        className: "".concat(expanded ? "wallet-adapter-modal-list-more-icon-rotate" : "")
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("path", {
        d: "M0.71418 1.626L5.83323 6.26188C5.91574 6.33657 6.0181 6.39652 6.13327 6.43762C6.24844 6.47872 6.37371 6.5 6.50048 6.5C6.62725 6.5 6.75252 6.47872 6.8677 6.43762C6.98287 6.39652 7.08523 6.33657 7.16774 6.26188L12.2868 1.626C12.7753 1.1835 12.3703 0.5 11.6195 0.5H1.37997C0.629216 0.5 0.224175 1.1835 0.71418 1.626Z"
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $d58210e799bd6b7f$export$78768a9af065a7b), {
        expanded: expanded,
        id: "wallet-adapter-modal-collapse"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("ul", {
        className: "wallet-adapter-modal-list"
    }, collapsedWallets.map(function(wallet) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $5a35e27217f573ae$export$b6b33106605f17bb), {
            key: wallet.adapter.name,
            handleClick: function(event) {
                return handleWalletClick(event, wallet.adapter.name);
            },
            tabIndex: expanded ? 0 : -1,
            wallet: wallet
        });
    })))) : null))), (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement("div", {
        className: "wallet-adapter-modal-overlay",
        onMouseDown: handleClose
    })), portal);
};


var $d54b5a01dc6498a0$export$43bb60413a8a3ee6 = function(_param) {
    var children = _param.children, props = (0, $dRLPW._)(_param, [
        "children"
    ]);
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)(false), 2), visible = _useState[0], setVisible = _useState[1];
    return (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $9b6750fc2685388d$export$8fa8c0fc3ea86e87).Provider, {
        value: {
            visible: visible,
            setVisible: setVisible
        }
    }, children, visible && (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createElement((0, $60b5e2519e095a6d$export$851b8e4aa786e6a1), (0, $do9pw._)({}, props)));
};




var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $dRLPW = parcelRequire("dRLPW");

var $c6Xmf = parcelRequire("c6Xmf");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");


var $69N5M = parcelRequire("69N5M");
var $c5d4ac6438cae45d$export$37766f30d842581a = "Phantom";
var $c5d4ac6438cae45d$export$a8fff984faa686f6 = /*#__PURE__*/ function(BaseMessageSignerWalletAdapter) {
    "use strict";
    (0, $dcsZi._)(PhantomWalletAdapter, BaseMessageSignerWalletAdapter);
    var _super = (0, $ohfOJ._)(PhantomWalletAdapter);
    function PhantomWalletAdapter() {
        var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $4GJKx._)(this, PhantomWalletAdapter);
        var _this;
        _this = _super.call(this);
        _this.name = $c5d4ac6438cae45d$export$37766f30d842581a;
        _this.url = "https://phantom.app";
        _this.icon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDgiIGhlaWdodD0iMTA4IiB2aWV3Qm94PSIwIDAgMTA4IDEwOCIgZmlsbD0ibm9uZSI+CjxyZWN0IHdpZHRoPSIxMDgiIGhlaWdodD0iMTA4IiByeD0iMjYiIGZpbGw9IiNBQjlGRjIiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00Ni41MjY3IDY5LjkyMjlDNDIuMDA1NCA3Ni44NTA5IDM0LjQyOTIgODUuNjE4MiAyNC4zNDggODUuNjE4MkMxOS41ODI0IDg1LjYxODIgMTUgODMuNjU2MyAxNSA3NS4xMzQyQzE1IDUzLjQzMDUgNDQuNjMyNiAxOS44MzI3IDcyLjEyNjggMTkuODMyN0M4Ny43NjggMTkuODMyNyA5NCAzMC42ODQ2IDk0IDQzLjAwNzlDOTQgNTguODI1OCA4My43MzU1IDc2LjkxMjIgNzMuNTMyMSA3Ni45MTIyQzcwLjI5MzkgNzYuOTEyMiA2OC43MDUzIDc1LjEzNDIgNjguNzA1MyA3Mi4zMTRDNjguNzA1MyA3MS41NzgzIDY4LjgyNzUgNzAuNzgxMiA2OS4wNzE5IDY5LjkyMjlDNjUuNTg5MyA3NS44Njk5IDU4Ljg2ODUgODEuMzg3OCA1Mi41NzU0IDgxLjM4NzhDNDcuOTkzIDgxLjM4NzggNDUuNjcxMyA3OC41MDYzIDQ1LjY3MTMgNzQuNDU5OEM0NS42NzEzIDcyLjk4ODQgNDUuOTc2OCA3MS40NTU2IDQ2LjUyNjcgNjkuOTIyOVpNODMuNjc2MSA0Mi41Nzk0QzgzLjY3NjEgNDYuMTcwNCA4MS41NTc1IDQ3Ljk2NTggNzkuMTg3NSA0Ny45NjU4Qzc2Ljc4MTYgNDcuOTY1OCA3NC42OTg5IDQ2LjE3MDQgNzQuNjk4OSA0Mi41Nzk0Qzc0LjY5ODkgMzguOTg4NSA3Ni43ODE2IDM3LjE5MzEgNzkuMTg3NSAzNy4xOTMxQzgxLjU1NzUgMzcuMTkzMSA4My42NzYxIDM4Ljk4ODUgODMuNjc2MSA0Mi41Nzk0Wk03MC4yMTAzIDQyLjU3OTVDNzAuMjEwMyA0Ni4xNzA0IDY4LjA5MTYgNDcuOTY1OCA2NS43MjE2IDQ3Ljk2NThDNjMuMzE1NyA0Ny45NjU4IDYxLjIzMyA0Ni4xNzA0IDYxLjIzMyA0Mi41Nzk1QzYxLjIzMyAzOC45ODg1IDYzLjMxNTcgMzcuMTkzMSA2NS43MjE2IDM3LjE5MzFDNjguMDkxNiAzNy4xOTMxIDcwLjIxMDMgMzguOTg4NSA3MC4yMTAzIDQyLjU3OTVaIiBmaWxsPSIjRkZGREY4Ii8+Cjwvc3ZnPg==";
        _this.supportedTransactionVersions = new Set([
            "legacy",
            0
        ]);
        _this._readyState = typeof window === "undefined" || typeof document === "undefined" ? (0, $8c7df08073723177$export$2a7b8071105d05b6).Unsupported : (0, $8c7df08073723177$export$2a7b8071105d05b6).NotDetected;
        _this._disconnected = function() {
            var wallet = _this._wallet;
            if (wallet) {
                wallet.off("disconnect", _this._disconnected);
                wallet.off("accountChanged", _this._accountChanged);
                _this._wallet = null;
                _this._publicKey = null;
                _this.emit("error", new (0, $3f5d780e6d40bbac$export$bf7028c52ebda81e)());
                _this.emit("disconnect");
            }
        };
        _this._accountChanged = function(newPublicKey) {
            var publicKey = _this._publicKey;
            if (!publicKey) return;
            try {
                newPublicKey = new (0, $69N5M.PublicKey)(newPublicKey.toBytes());
            } catch (error) {
                _this.emit("error", new (0, $3f5d780e6d40bbac$export$735bef3bfb0f2c86)(error === null || error === void 0 ? void 0 : error.message, error));
                return;
            }
            if (publicKey.equals(newPublicKey)) return;
            _this._publicKey = newPublicKey;
            _this.emit("connect", newPublicKey);
        };
        _this._connecting = false;
        _this._wallet = null;
        _this._publicKey = null;
        if (_this._readyState !== (0, $8c7df08073723177$export$2a7b8071105d05b6).Unsupported) {
            if ((0, $8c7df08073723177$export$bf89b558d1e273a2)()) {
                // when in iOS (not webview), set Phantom as loadable instead of checking for install
                _this._readyState = (0, $8c7df08073723177$export$2a7b8071105d05b6).Loadable;
                _this.emit("readyStateChange", _this._readyState);
            } else (0, $8c7df08073723177$export$378bae4c88e0b46e)(function() {
                var _window_phantom_solana, _window_phantom, _window_solana;
                if (((_window_phantom = window.phantom) === null || _window_phantom === void 0 ? void 0 : (_window_phantom_solana = _window_phantom.solana) === null || _window_phantom_solana === void 0 ? void 0 : _window_phantom_solana.isPhantom) || ((_window_solana = window.solana) === null || _window_solana === void 0 ? void 0 : _window_solana.isPhantom)) {
                    _this._readyState = (0, $8c7df08073723177$export$2a7b8071105d05b6).Installed;
                    _this.emit("readyStateChange", _this._readyState);
                    return true;
                }
                return false;
            });
        }
        return _this;
    }
    (0, $1wc17._)(PhantomWalletAdapter, [
        {
            key: "publicKey",
            get: function get() {
                return this._publicKey;
            }
        },
        {
            key: "connecting",
            get: function get() {
                return this._connecting;
            }
        },
        {
            key: "readyState",
            get: function get() {
                return this._readyState;
            }
        },
        {
            key: "autoConnect",
            value: function autoConnect() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(_this.readyState === (0, $8c7df08073723177$export$2a7b8071105d05b6).Installed)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.connect()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "connect",
            value: function connect() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _window_phantom, url, ref, wallet, error, publicKey, error1;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    5,
                                    6,
                                    7
                                ]);
                                if (_this.connected || _this.connecting) return [
                                    2
                                ];
                                if (_this.readyState === (0, $8c7df08073723177$export$2a7b8071105d05b6).Loadable) {
                                    // redirect to the Phantom /browse universal link
                                    // this will open the current URL in the Phantom in-wallet browser
                                    url = encodeURIComponent(window.location.href);
                                    ref = encodeURIComponent(window.location.origin);
                                    window.location.href = "https://phantom.app/ul/browse/".concat(url, "?ref=").concat(ref);
                                    return [
                                        2
                                    ];
                                }
                                if (_this.readyState !== (0, $8c7df08073723177$export$2a7b8071105d05b6).Installed) throw new (0, $3f5d780e6d40bbac$export$d65db264eda99cd7)();
                                _this._connecting = true;
                                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                wallet = ((_window_phantom = window.phantom) === null || _window_phantom === void 0 ? void 0 : _window_phantom.solana) || window.solana;
                                if (!!wallet.isConnected) return [
                                    3,
                                    4
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    wallet.connect()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                throw new (0, $3f5d780e6d40bbac$export$38f21f1c810261c7)(error === null || error === void 0 ? void 0 : error.message, error);
                            case 4:
                                if (!wallet.publicKey) throw new (0, $3f5d780e6d40bbac$export$cd6fa2f8e2a8a612)();
                                try {
                                    publicKey = new (0, $69N5M.PublicKey)(wallet.publicKey.toBytes());
                                } catch (error) {
                                    throw new (0, $3f5d780e6d40bbac$export$735bef3bfb0f2c86)(error === null || error === void 0 ? void 0 : error.message, error);
                                }
                                wallet.on("disconnect", _this._disconnected);
                                wallet.on("accountChanged", _this._accountChanged);
                                _this._wallet = wallet;
                                _this._publicKey = publicKey;
                                _this.emit("connect", publicKey);
                                return [
                                    3,
                                    7
                                ];
                            case 5:
                                error1 = _state.sent();
                                _this.emit("error", error1);
                                throw error1;
                            case 6:
                                _this._connecting = false;
                                return [
                                    7
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var wallet, error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                wallet = _this._wallet;
                                if (!wallet) return [
                                    3,
                                    4
                                ];
                                wallet.off("disconnect", _this._disconnected);
                                wallet.off("accountChanged", _this._accountChanged);
                                _this._wallet = null;
                                _this._publicKey = null;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    wallet.disconnect()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                _this.emit("error", new (0, $3f5d780e6d40bbac$export$92e2b26fad5723ee)(error === null || error === void 0 ? void 0 : error.message, error));
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                _this.emit("disconnect");
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendTransaction",
            value: function sendTransaction(transaction, connection) {
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var wallet, signers, sendOptions, _transaction, signature, error, error1;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    8,
                                    ,
                                    9
                                ]);
                                wallet = _this._wallet;
                                if (!wallet) throw new (0, $3f5d780e6d40bbac$export$313d299817c74896)();
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    ,
                                    7
                                ]);
                                signers = options.signers, sendOptions = (0, $dRLPW._)(options, [
                                    "signers"
                                ]);
                                if (!(0, $17326fb7ccd2d31f$export$37ce1cc82e255d8)(transaction)) return [
                                    3,
                                    2
                                ];
                                (signers === null || signers === void 0 ? void 0 : signers.length) && transaction.sign(signers);
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.prepareTransaction(transaction, connection, sendOptions)
                                ];
                            case 3:
                                transaction = _state.sent();
                                (signers === null || signers === void 0 ? void 0 : signers.length) && (_transaction = transaction).partialSign.apply(_transaction, (0, $c6Xmf._)(signers));
                                _state.label = 4;
                            case 4:
                                sendOptions.preflightCommitment = sendOptions.preflightCommitment || connection.commitment;
                                return [
                                    4,
                                    wallet.signAndSendTransaction(transaction, sendOptions)
                                ];
                            case 5:
                                signature = _state.sent().signature;
                                return [
                                    2,
                                    signature
                                ];
                            case 6:
                                error = _state.sent();
                                if (error instanceof (0, $3f5d780e6d40bbac$export$f46ec6f9dba8711d)) throw error;
                                throw new (0, $3f5d780e6d40bbac$export$769332ac3f90f46c)(error === null || error === void 0 ? void 0 : error.message, error);
                            case 7:
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                error1 = _state.sent();
                                _this.emit("error", error1);
                                throw error1;
                            case 9:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signTransaction",
            value: function signTransaction(transaction) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var wallet, error, error1;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    5,
                                    ,
                                    6
                                ]);
                                wallet = _this._wallet;
                                if (!wallet) throw new (0, $3f5d780e6d40bbac$export$313d299817c74896)();
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    wallet.signTransaction(transaction)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent() || transaction
                                ];
                            case 3:
                                error = _state.sent();
                                throw new (0, $3f5d780e6d40bbac$export$96f177062fdd8180)(error === null || error === void 0 ? void 0 : error.message, error);
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                error1 = _state.sent();
                                _this.emit("error", error1);
                                throw error1;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signAllTransactions",
            value: function signAllTransactions(transactions) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var wallet, error, error1;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    5,
                                    ,
                                    6
                                ]);
                                wallet = _this._wallet;
                                if (!wallet) throw new (0, $3f5d780e6d40bbac$export$313d299817c74896)();
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    wallet.signAllTransactions(transactions)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent() || transactions
                                ];
                            case 3:
                                error = _state.sent();
                                throw new (0, $3f5d780e6d40bbac$export$96f177062fdd8180)(error === null || error === void 0 ? void 0 : error.message, error);
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                error1 = _state.sent();
                                _this.emit("error", error1);
                                throw error1;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signMessage",
            value: function signMessage(message) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var wallet, signature, error, error1;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    5,
                                    ,
                                    6
                                ]);
                                wallet = _this._wallet;
                                if (!wallet) throw new (0, $3f5d780e6d40bbac$export$313d299817c74896)();
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    wallet.signMessage(message)
                                ];
                            case 2:
                                signature = _state.sent().signature;
                                return [
                                    2,
                                    signature
                                ];
                            case 3:
                                error = _state.sent();
                                throw new (0, $3f5d780e6d40bbac$export$2622c1721bbd4b17)(error === null || error === void 0 ? void 0 : error.message, error);
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                error1 = _state.sent();
                                _this.emit("error", error1);
                                throw error1;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return PhantomWalletAdapter;
}((0, $d1e3c3dc9d32b5d7$export$9db08bcddd106c96));


var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $dRLPW = parcelRequire("dRLPW");

var $c6Xmf = parcelRequire("c6Xmf");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");


var $69N5M = parcelRequire("69N5M");

var $kSuI9 = parcelRequire("kSuI9");

var $eha6O = parcelRequire("eha6O");

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");
var $b063a0548647c322$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $b063a0548647c322$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $b063a0548647c322$var$_RegisterWalletEvent_detail;
function $b063a0548647c322$export$ecffa18c0543eceb(wallet) {
    var callback = function(param) {
        var register = param.register;
        return register(wallet);
    };
    try {
        window.dispatchEvent(new $b063a0548647c322$var$RegisterWalletEvent(callback));
    } catch (error) {
        console.error("wallet-standard:register-wallet event could not be dispatched\n", error);
    }
    try {
        window.addEventListener("wallet-standard:app-ready", function(param) {
            var api = param.detail;
            return callback(api);
        });
    } catch (error) {
        console.error("wallet-standard:app-ready event listener could not be added\n", error);
    }
}
var $b063a0548647c322$var$RegisterWalletEvent = /*#__PURE__*/ function(Event1) {
    "use strict";
    (0, $dcsZi._)(RegisterWalletEvent, Event1);
    var _super = (0, $ohfOJ._)(RegisterWalletEvent);
    function RegisterWalletEvent(callback) {
        (0, $4GJKx._)(this, RegisterWalletEvent);
        var _this;
        _this = _super.call(this, "wallet-standard:register-wallet", {
            bubbles: false,
            cancelable: false,
            composed: false
        });
        $b063a0548647c322$var$_RegisterWalletEvent_detail.set((0, $d3H5E._)(_this), void 0);
        $b063a0548647c322$var$__classPrivateFieldSet((0, $d3H5E._)(_this), $b063a0548647c322$var$_RegisterWalletEvent_detail, callback, "f");
        return _this;
    }
    (0, $1wc17._)(RegisterWalletEvent, [
        {
            key: "detail",
            get: function get() {
                return $b063a0548647c322$var$__classPrivateFieldGet(this, $b063a0548647c322$var$_RegisterWalletEvent_detail, "f");
            }
        },
        {
            key: "type",
            get: function get() {
                return "wallet-standard:register-wallet";
            }
        },
        {
            /** @deprecated */ key: "preventDefault",
            value: function preventDefault() {
                throw new Error("preventDefault cannot be called");
            }
        },
        {
            /** @deprecated */ key: "stopImmediatePropagation",
            value: function stopImmediatePropagation() {
                throw new Error("stopImmediatePropagation cannot be called");
            }
        },
        {
            /** @deprecated */ key: "stopPropagation",
            value: function stopPropagation() {
                throw new Error("stopPropagation cannot be called");
            }
        }
    ]);
    return RegisterWalletEvent;
}((0, $FuVm8._)(Event));
$b063a0548647c322$var$_RegisterWalletEvent_detail = new WeakMap();
function $b063a0548647c322$export$2dd0e8edbdeb04ec(wallet) {
    var _a;
    $b063a0548647c322$export$ecffa18c0543eceb(wallet);
    try {
        ((_a = window.navigator).wallets || (_a.wallets = [])).push(function(param) {
            var register = param.register;
            return register(wallet);
        });
    } catch (error) {
        console.error("window.navigator.wallets could not be pushed\n", error);
    }
}



var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $3sHb8 = parcelRequire("3sHb8");

var $c6Xmf = parcelRequire("c6Xmf");

var $eha6O = parcelRequire("eha6O");



var $l4Sju = parcelRequire("l4Sju");
var $l0pK9 = parcelRequire("l0pK9");
var $e8TeL = parcelRequire("e8TeL");

/** @internal */ var $12d07ed8b2dffbfc$export$1ca1ec8b29a4ce27 = "data:image/svg+xml;base64,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";


var $138fcddc6cc2f2c5$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $138fcddc6cc2f2c5$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_instances, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_listeners, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_version, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_name, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_icon, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_solflareMetaMask, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_on, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_emit, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_off, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_connect, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_disconnect, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_signAndSendTransaction, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_signTransaction, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_signMessage;

var $138fcddc6cc2f2c5$export$b9711d1b27bbdcc = /*#__PURE__*/ function() {
    "use strict";
    function SolflareMetaMaskWallet() {
        var _this = this;
        (0, $4GJKx._)(this, SolflareMetaMaskWallet);
        $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_instances.add(this);
        $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_listeners.set(this, {});
        $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_version.set(this, "1.0.0");
        $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_name.set(this, "MetaMask");
        $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_icon.set(this, (0, $12d07ed8b2dffbfc$export$1ca1ec8b29a4ce27));
        $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_solflareMetaMask.set(this, null);
        $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_on.set(this, function(event, listener) {
            var __classPrivateFieldGet_event;
            ((__classPrivateFieldGet_event = $138fcddc6cc2f2c5$var$__classPrivateFieldGet(_this, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_listeners, "f")[event]) === null || __classPrivateFieldGet_event === void 0 ? void 0 : __classPrivateFieldGet_event.push(listener)) || ($138fcddc6cc2f2c5$var$__classPrivateFieldGet(_this, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_listeners, "f")[event] = [
                listener
            ]);
            return function() {
                return $138fcddc6cc2f2c5$var$__classPrivateFieldGet(_this, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_instances, "m", $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_off).call(_this, event, listener);
            };
        });
        var _this1 = this;
        $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_connect.set(this, /*#__PURE__*/ (0, $kSuI9._)(function() {
            var SolflareMetaMaskClass, error;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!$138fcddc6cc2f2c5$var$__classPrivateFieldGet(_this1, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_solflareMetaMask, "f")) return [
                            3,
                            5
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (parcelRequire("7GSQG"))
                        ];
                    case 2:
                        SolflareMetaMaskClass = _state.sent().default;
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        throw new Error("Unable to load Solflare MetaMask SDK");
                    case 4:
                        $138fcddc6cc2f2c5$var$__classPrivateFieldSet(_this1, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_solflareMetaMask, new SolflareMetaMaskClass(), "f");
                        $138fcddc6cc2f2c5$var$__classPrivateFieldGet(_this1, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_solflareMetaMask, "f").on("standard_change", function(properties) {
                            return $138fcddc6cc2f2c5$var$__classPrivateFieldGet(_this1, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_instances, "m", $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_emit).call(_this1, "change", properties);
                        });
                        _state.label = 5;
                    case 5:
                        if (!!_this1.accounts.length) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            $138fcddc6cc2f2c5$var$__classPrivateFieldGet(_this1, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_solflareMetaMask, "f").connect()
                        ];
                    case 6:
                        _state.sent();
                        _state.label = 7;
                    case 7:
                        return [
                            2,
                            {
                                accounts: _this1.accounts
                            }
                        ];
                }
            });
        }));
        var _this2 = this;
        $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_disconnect.set(this, /*#__PURE__*/ (0, $kSuI9._)(function() {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!$138fcddc6cc2f2c5$var$__classPrivateFieldGet(_this2, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_solflareMetaMask, "f")) return [
                            2
                        ];
                        return [
                            4,
                            $138fcddc6cc2f2c5$var$__classPrivateFieldGet(_this2, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_solflareMetaMask, "f").disconnect()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        }));
        var _this3 = this;
        $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_signAndSendTransaction.set(this, /*#__PURE__*/ (0, $kSuI9._)(function() {
            var _len, inputs, _key, __classPrivateFieldGet1;
            var _arguments = arguments;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        for(_len = _arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++){
                            inputs[_key] = _arguments[_key];
                        }
                        if (!$138fcddc6cc2f2c5$var$__classPrivateFieldGet(_this3, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_solflareMetaMask, "f")) throw new (0, $3f5d780e6d40bbac$export$313d299817c74896)();
                        return [
                            4,
                            (__classPrivateFieldGet1 = $138fcddc6cc2f2c5$var$__classPrivateFieldGet(_this3, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_solflareMetaMask, "f")).standardSignAndSendTransaction.apply(__classPrivateFieldGet1, (0, $c6Xmf._)(inputs))
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        }));
        var _this4 = this;
        $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_signTransaction.set(this, /*#__PURE__*/ (0, $kSuI9._)(function() {
            var _len, inputs, _key, __classPrivateFieldGet1;
            var _arguments = arguments;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        for(_len = _arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++){
                            inputs[_key] = _arguments[_key];
                        }
                        if (!$138fcddc6cc2f2c5$var$__classPrivateFieldGet(_this4, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_solflareMetaMask, "f")) throw new (0, $3f5d780e6d40bbac$export$313d299817c74896)();
                        return [
                            4,
                            (__classPrivateFieldGet1 = $138fcddc6cc2f2c5$var$__classPrivateFieldGet(_this4, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_solflareMetaMask, "f")).standardSignTransaction.apply(__classPrivateFieldGet1, (0, $c6Xmf._)(inputs))
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        }));
        var _this5 = this;
        $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_signMessage.set(this, /*#__PURE__*/ (0, $kSuI9._)(function() {
            var _len, inputs, _key, __classPrivateFieldGet1;
            var _arguments = arguments;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        for(_len = _arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++){
                            inputs[_key] = _arguments[_key];
                        }
                        if (!$138fcddc6cc2f2c5$var$__classPrivateFieldGet(_this5, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_solflareMetaMask, "f")) throw new (0, $3f5d780e6d40bbac$export$313d299817c74896)();
                        return [
                            4,
                            (__classPrivateFieldGet1 = $138fcddc6cc2f2c5$var$__classPrivateFieldGet(_this5, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_solflareMetaMask, "f")).standardSignMessage.apply(__classPrivateFieldGet1, (0, $c6Xmf._)(inputs))
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        }));
    }
    (0, $1wc17._)(SolflareMetaMaskWallet, [
        {
            key: "version",
            get: function get() {
                return $138fcddc6cc2f2c5$var$__classPrivateFieldGet(this, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_version, "f");
            }
        },
        {
            key: "name",
            get: function get() {
                return $138fcddc6cc2f2c5$var$__classPrivateFieldGet(this, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_name, "f");
            }
        },
        {
            key: "icon",
            get: function get() {
                return $138fcddc6cc2f2c5$var$__classPrivateFieldGet(this, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_icon, "f");
            }
        },
        {
            key: "chains",
            get: function get() {
                return [
                    (0, $38375b70a91e6f68$export$bba9a228295b3963),
                    (0, $38375b70a91e6f68$export$654cc095bd2e650),
                    (0, $38375b70a91e6f68$export$76575b7bf4de1f40)
                ];
            }
        },
        {
            key: "features",
            get: function get() {
                var _obj;
                return _obj = {}, (0, $3sHb8._)(_obj, (0, $93de5c00a84b23a2$export$cc68487eeb93b1d4), {
                    version: "1.0.0",
                    connect: $138fcddc6cc2f2c5$var$__classPrivateFieldGet(this, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_connect, "f")
                }), (0, $3sHb8._)(_obj, (0, $884440781fc19407$export$38dbd4bbb9b696e6), {
                    version: "1.0.0",
                    disconnect: $138fcddc6cc2f2c5$var$__classPrivateFieldGet(this, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_disconnect, "f")
                }), (0, $3sHb8._)(_obj, (0, $5f118803022fbeb8$export$5296443ca9e9fa0f), {
                    version: "1.0.0",
                    on: $138fcddc6cc2f2c5$var$__classPrivateFieldGet(this, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_on, "f")
                }), (0, $3sHb8._)(_obj, (0, $l4Sju.SolanaSignAndSendTransaction), {
                    version: "1.0.0",
                    supportedTransactionVersions: [
                        "legacy",
                        0
                    ],
                    signAndSendTransaction: $138fcddc6cc2f2c5$var$__classPrivateFieldGet(this, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_signAndSendTransaction, "f")
                }), (0, $3sHb8._)(_obj, (0, $e8TeL.SolanaSignTransaction), {
                    version: "1.0.0",
                    supportedTransactionVersions: [
                        "legacy",
                        0
                    ],
                    signTransaction: $138fcddc6cc2f2c5$var$__classPrivateFieldGet(this, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_signTransaction, "f")
                }), (0, $3sHb8._)(_obj, (0, $l0pK9.SolanaSignMessage), {
                    version: "1.0.0",
                    signMessage: $138fcddc6cc2f2c5$var$__classPrivateFieldGet(this, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_signMessage, "f")
                }), _obj;
            }
        },
        {
            key: "accounts",
            get: function get() {
                return $138fcddc6cc2f2c5$var$__classPrivateFieldGet(this, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_solflareMetaMask, "f") ? $138fcddc6cc2f2c5$var$__classPrivateFieldGet(this, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_solflareMetaMask, "f").standardAccounts : [];
            }
        }
    ]);
    return SolflareMetaMaskWallet;
}();
$138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_listeners = new WeakMap(), $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_version = new WeakMap(), $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_name = new WeakMap(), $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_icon = new WeakMap(), $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_solflareMetaMask = new WeakMap(), $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_on = new WeakMap(), $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_connect = new WeakMap(), $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_disconnect = new WeakMap(), $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_signAndSendTransaction = new WeakMap(), $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_signTransaction = new WeakMap(), $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_signMessage = new WeakMap(), $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_instances = new WeakSet(), $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_emit = function _SolflareMetaMaskWallet_emit(event) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var // eslint-disable-next-line prefer-spread
    __classPrivateFieldGet_event;
    (__classPrivateFieldGet_event = $138fcddc6cc2f2c5$var$__classPrivateFieldGet(this, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_listeners, "f")[event]) === null || __classPrivateFieldGet_event === void 0 ? void 0 : __classPrivateFieldGet_event.forEach(function(listener) {
        return listener.apply(null, args);
    });
}, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_off = function _SolflareMetaMaskWallet_off(event, listener) {
    var __classPrivateFieldGet_event;
    $138fcddc6cc2f2c5$var$__classPrivateFieldGet(this, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_listeners, "f")[event] = (__classPrivateFieldGet_event = $138fcddc6cc2f2c5$var$__classPrivateFieldGet(this, $138fcddc6cc2f2c5$var$_SolflareMetaMaskWallet_listeners, "f")[event]) === null || __classPrivateFieldGet_event === void 0 ? void 0 : __classPrivateFieldGet_event.filter(function(existingListener) {
        return listener !== existingListener;
    });
};


var $bb6ae5cab2867ce9$var$registered = false;
function $bb6ae5cab2867ce9$var$register() {
    if ($bb6ae5cab2867ce9$var$registered) return;
    (0, $b063a0548647c322$export$ecffa18c0543eceb)(new (0, $138fcddc6cc2f2c5$export$b9711d1b27bbdcc)());
    $bb6ae5cab2867ce9$var$registered = true;
}
function $bb6ae5cab2867ce9$export$2dd247ebd3228ce5() {
    return $bb6ae5cab2867ce9$var$_detectAndRegisterSolflareMetaMaskWallet.apply(this, arguments);
}
function $bb6ae5cab2867ce9$var$_detectAndRegisterSolflareMetaMaskWallet() {
    $bb6ae5cab2867ce9$var$_detectAndRegisterSolflareMetaMaskWallet = (0, $kSuI9._)(function() {
        var id;
        function postMessage() {
            window.postMessage({
                target: "metamask-contentscript",
                data: {
                    name: "metamask-provider",
                    data: {
                        id: id,
                        jsonrpc: "2.0",
                        method: "wallet_getSnaps"
                    }
                }
            }, window.location.origin);
        }
        function onMessage(event) {
            var _message_data;
            var message = event.data;
            if ((message === null || message === void 0 ? void 0 : message.target) === "metamask-inpage" && ((_message_data = message.data) === null || _message_data === void 0 ? void 0 : _message_data.name) === "metamask-provider") {
                var _message_data_data;
                if (((_message_data_data = message.data.data) === null || _message_data_data === void 0 ? void 0 : _message_data_data.id) === id) {
                    window.removeEventListener("message", onMessage);
                    if (!message.data.data.error) $bb6ae5cab2867ce9$var$register();
                } else postMessage();
            }
        }
        return (0, $eha6O.__generator)(this, function(_state) {
            id = "solflare-detect-metamask";
            window.addEventListener("message", onMessage);
            window.setTimeout(function() {
                return window.removeEventListener("message", onMessage);
            }, 5000);
            postMessage();
            return [
                2
            ];
        });
    });
    return $bb6ae5cab2867ce9$var$_detectAndRegisterSolflareMetaMaskWallet.apply(this, arguments);
}


var $b1e7d4a4656ea14e$export$588524c4690a874f = "Solflare";

var $b1e7d4a4656ea14e$export$9fd69c70c5f8b9b4 = /*#__PURE__*/ function(BaseMessageSignerWalletAdapter) {
    "use strict";
    (0, $dcsZi._)(SolflareWalletAdapter, BaseMessageSignerWalletAdapter);
    var _super = (0, $ohfOJ._)(SolflareWalletAdapter);
    function SolflareWalletAdapter() {
        var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $4GJKx._)(this, SolflareWalletAdapter);
        var _this;
        _this = _super.call(this);
        _this.name = $b1e7d4a4656ea14e$export$588524c4690a874f;
        _this.url = "https://solflare.com";
        _this.icon = "data:image/svg+xml;base64,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";
        _this.supportedTransactionVersions = new Set([
            "legacy",
            0
        ]);
        _this._readyState = typeof window === "undefined" || typeof document === "undefined" ? (0, $8c7df08073723177$export$2a7b8071105d05b6).Unsupported : (0, $8c7df08073723177$export$2a7b8071105d05b6).Loadable;
        _this._disconnected = function() {
            var wallet = _this._wallet;
            if (wallet) {
                wallet.off("disconnect", _this._disconnected);
                _this._wallet = null;
                _this._publicKey = null;
                _this.emit("error", new (0, $3f5d780e6d40bbac$export$bf7028c52ebda81e)());
                _this.emit("disconnect");
            }
        };
        _this._accountChanged = function(newPublicKey) {
            if (!newPublicKey) return;
            var publicKey = _this._publicKey;
            if (!publicKey) return;
            try {
                newPublicKey = new (0, $69N5M.PublicKey)(newPublicKey.toBytes());
            } catch (error) {
                _this.emit("error", new (0, $3f5d780e6d40bbac$export$735bef3bfb0f2c86)(error === null || error === void 0 ? void 0 : error.message, error));
                return;
            }
            if (publicKey.equals(newPublicKey)) return;
            _this._publicKey = newPublicKey;
            _this.emit("connect", newPublicKey);
        };
        _this._connecting = false;
        _this._publicKey = null;
        _this._wallet = null;
        _this._config = config;
        if (_this._readyState !== (0, $8c7df08073723177$export$2a7b8071105d05b6).Unsupported) {
            (0, $8c7df08073723177$export$378bae4c88e0b46e)(function() {
                var _window_solflare;
                if (((_window_solflare = window.solflare) === null || _window_solflare === void 0 ? void 0 : _window_solflare.isSolflare) || window.SolflareApp) {
                    _this._readyState = (0, $8c7df08073723177$export$2a7b8071105d05b6).Installed;
                    _this.emit("readyStateChange", _this._readyState);
                    return true;
                }
                return false;
            });
            (0, $bb6ae5cab2867ce9$export$2dd247ebd3228ce5)();
        }
        return _this;
    }
    (0, $1wc17._)(SolflareWalletAdapter, [
        {
            key: "publicKey",
            get: function get() {
                return this._publicKey;
            }
        },
        {
            key: "connecting",
            get: function get() {
                return this._connecting;
            }
        },
        {
            key: "connected",
            get: function get() {
                var _this__wallet;
                return !!((_this__wallet = this._wallet) === null || _this__wallet === void 0 ? void 0 : _this__wallet.connected);
            }
        },
        {
            key: "readyState",
            get: function get() {
                return this._readyState;
            }
        },
        {
            key: "autoConnect",
            value: function autoConnect() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!(_this.readyState === (0, $8c7df08073723177$export$2a7b8071105d05b6).Loadable && (0, $8c7df08073723177$export$bf89b558d1e273a2)())) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.connect()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "connect",
            value: function connect() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var url, ref, SolflareClass, error, wallet, error1, publicKey, error2;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    9,
                                    10,
                                    11
                                ]);
                                if (_this.connected || _this.connecting) return [
                                    2
                                ];
                                if (_this._readyState !== (0, $8c7df08073723177$export$2a7b8071105d05b6).Loadable && _this._readyState !== (0, $8c7df08073723177$export$2a7b8071105d05b6).Installed) throw new (0, $3f5d780e6d40bbac$export$d65db264eda99cd7)();
                                // redirect to the Solflare /browse universal link
                                // this will open the current URL in the Solflare in-wallet browser
                                if (_this.readyState === (0, $8c7df08073723177$export$2a7b8071105d05b6).Loadable && (0, $8c7df08073723177$export$bf89b558d1e273a2)()) {
                                    url = encodeURIComponent(window.location.href);
                                    ref = encodeURIComponent(window.location.origin);
                                    window.location.href = "https://solflare.com/ul/v1/browse/".concat(url, "?ref=").concat(ref);
                                    return [
                                        2
                                    ];
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    (parcelRequire("2iaeM"))
                                ];
                            case 2:
                                SolflareClass = _state.sent().default;
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                throw new (0, $3f5d780e6d40bbac$export$9a551f94af9b0bf8)(error === null || error === void 0 ? void 0 : error.message, error);
                            case 4:
                                try {
                                    wallet = new SolflareClass({
                                        network: _this._config.network
                                    });
                                } catch (error) {
                                    throw new (0, $3f5d780e6d40bbac$export$9525019988612a5e)(error === null || error === void 0 ? void 0 : error.message, error);
                                }
                                _this._connecting = true;
                                if (!!wallet.connected) return [
                                    3,
                                    8
                                ];
                                _state.label = 5;
                            case 5:
                                _state.trys.push([
                                    5,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4,
                                    wallet.connect()
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                error1 = _state.sent();
                                throw new (0, $3f5d780e6d40bbac$export$38f21f1c810261c7)(error1 === null || error1 === void 0 ? void 0 : error1.message, error1);
                            case 8:
                                if (!wallet.publicKey) throw new (0, $3f5d780e6d40bbac$export$38f21f1c810261c7)();
                                try {
                                    publicKey = new (0, $69N5M.PublicKey)(wallet.publicKey.toBytes());
                                } catch (error) {
                                    throw new (0, $3f5d780e6d40bbac$export$735bef3bfb0f2c86)(error === null || error === void 0 ? void 0 : error.message, error);
                                }
                                wallet.on("disconnect", _this._disconnected);
                                wallet.on("accountChanged", _this._accountChanged);
                                _this._wallet = wallet;
                                _this._publicKey = publicKey;
                                _this.emit("connect", publicKey);
                                return [
                                    3,
                                    11
                                ];
                            case 9:
                                error2 = _state.sent();
                                _this.emit("error", error2);
                                throw error2;
                            case 10:
                                _this._connecting = false;
                                return [
                                    7
                                ];
                            case 11:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var wallet, error;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                wallet = _this._wallet;
                                if (!wallet) return [
                                    3,
                                    4
                                ];
                                wallet.off("disconnect", _this._disconnected);
                                wallet.off("accountChanged", _this._accountChanged);
                                _this._wallet = null;
                                _this._publicKey = null;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    wallet.disconnect()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                _this.emit("error", new (0, $3f5d780e6d40bbac$export$92e2b26fad5723ee)(error === null || error === void 0 ? void 0 : error.message, error));
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                _this.emit("disconnect");
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendTransaction",
            value: function sendTransaction(transaction, connection) {
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var wallet, signers, sendOptions, _transaction, error, error1;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    8,
                                    ,
                                    9
                                ]);
                                wallet = _this._wallet;
                                if (!wallet) throw new (0, $3f5d780e6d40bbac$export$313d299817c74896)();
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    ,
                                    7
                                ]);
                                signers = options.signers, sendOptions = (0, $dRLPW._)(options, [
                                    "signers"
                                ]);
                                if (!(0, $17326fb7ccd2d31f$export$37ce1cc82e255d8)(transaction)) return [
                                    3,
                                    2
                                ];
                                (signers === null || signers === void 0 ? void 0 : signers.length) && transaction.sign(signers);
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.prepareTransaction(transaction, connection, sendOptions)
                                ];
                            case 3:
                                transaction = _state.sent();
                                (signers === null || signers === void 0 ? void 0 : signers.length) && (_transaction = transaction).partialSign.apply(_transaction, (0, $c6Xmf._)(signers));
                                _state.label = 4;
                            case 4:
                                sendOptions.preflightCommitment = sendOptions.preflightCommitment || connection.commitment;
                                return [
                                    4,
                                    wallet.signAndSendTransaction(transaction, sendOptions)
                                ];
                            case 5:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 6:
                                error = _state.sent();
                                if (error instanceof (0, $3f5d780e6d40bbac$export$f46ec6f9dba8711d)) throw error;
                                throw new (0, $3f5d780e6d40bbac$export$769332ac3f90f46c)(error === null || error === void 0 ? void 0 : error.message, error);
                            case 7:
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                error1 = _state.sent();
                                _this.emit("error", error1);
                                throw error1;
                            case 9:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signTransaction",
            value: function signTransaction(transaction) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var wallet, error, error1;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    5,
                                    ,
                                    6
                                ]);
                                wallet = _this._wallet;
                                if (!wallet) throw new (0, $3f5d780e6d40bbac$export$313d299817c74896)();
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    wallet.signTransaction(transaction)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent() || transaction
                                ];
                            case 3:
                                error = _state.sent();
                                throw new (0, $3f5d780e6d40bbac$export$96f177062fdd8180)(error === null || error === void 0 ? void 0 : error.message, error);
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                error1 = _state.sent();
                                _this.emit("error", error1);
                                throw error1;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signAllTransactions",
            value: function signAllTransactions(transactions) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var wallet, error, error1;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    5,
                                    ,
                                    6
                                ]);
                                wallet = _this._wallet;
                                if (!wallet) throw new (0, $3f5d780e6d40bbac$export$313d299817c74896)();
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    wallet.signAllTransactions(transactions)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent() || transactions
                                ];
                            case 3:
                                error = _state.sent();
                                throw new (0, $3f5d780e6d40bbac$export$96f177062fdd8180)(error === null || error === void 0 ? void 0 : error.message, error);
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                error1 = _state.sent();
                                _this.emit("error", error1);
                                throw error1;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signMessage",
            value: function signMessage(message) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var wallet, error, error1;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    5,
                                    ,
                                    6
                                ]);
                                wallet = _this._wallet;
                                if (!wallet) throw new (0, $3f5d780e6d40bbac$export$313d299817c74896)();
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    wallet.signMessage(message, "utf8")
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                error = _state.sent();
                                throw new (0, $3f5d780e6d40bbac$export$2622c1721bbd4b17)(error === null || error === void 0 ? void 0 : error.message, error);
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                error1 = _state.sent();
                                _this.emit("error", error1);
                                throw error1;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return SolflareWalletAdapter;
}((0, $d1e3c3dc9d32b5d7$export$9db08bcddd106c96));


function $e3dbb0794ed8bfa2$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  box-shadow: 0 0 3px ",
        ";\n  border-radius: 5px;\n"
    ]);
    $e3dbb0794ed8bfa2$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $e3dbb0794ed8bfa2$var$ConnectedWalletContainer = (0, $f2ce4b3babf40f7e$export$2e2bcd8739ae039).div($e3dbb0794ed8bfa2$var$_templateObject(), (0, $651851c7f7a4dfb5$export$8fe7e62e076ddbb5).GRAY_DARK);
function $e3dbb0794ed8bfa2$var$endpointUrl(cluster) {
    if (cluster === "devnet") return "https://api.devnet.solana.com";
    return "https://api.radom.com/solana";
}
function $e3dbb0794ed8bfa2$var$maxBigInt(a, b) {
    return a > b ? a : b;
}
var $e3dbb0794ed8bfa2$var$SolanaWalletInner = function(props) {
    var _props_presaleStyling, _props_presaleStyling1;
    var _useWallet = (0, $064a90e950b6662f$export$c34addee860b0acb)(), connect = _useWallet.connect, connected = _useWallet.connected, solanaDisconnect = _useWallet.disconnect, sendTransaction = _useWallet.sendTransaction, publicKey = _useWallet.publicKey, select = _useWallet.select, wallet = _useWallet.wallet, wallets = _useWallet.wallets;
    var connection = (0, $0557e2bf883213b5$export$985e8768c0e91dbc)().connection;
    (0, $1Mpn7.useEffect)(function() {
        if (wallet && !connected && !(0, $555753d492a5a777$exports.isMobile)) connect();
    }, []);
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)(false), 2), isSolanaWalletModalVisible = _useState[0], setIsSolanaWalletModalVisible = _useState[1];
    (0, $1Mpn7.useEffect)(function() {
        if (wallet && !(0, $555753d492a5a777$exports.isMobile)) connect();
    }, [
        wallet
    ]);
    var isLoading = props.isLoading, setIsLoading = props.setIsLoading, managedPaymentDetails = props.managedPaymentDetails;
    var onClick = function() {
        var _ref = (0, $kSuI9._)(function() {
            var transaction, _ref, _ref_value, blockhash, lastValidBlockHeight, _ref_context, minContextSlot, _method_tokenInfo, tokenAddress, fromTokenAddress, method, _method_tokenInfo_decimals, minimumAmount, signature, err;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!publicKey) return [
                            2
                        ];
                        setIsLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            10,
                            ,
                            11
                        ]);
                        return [
                            4,
                            connection.getLatestBlockhashAndContext()
                        ];
                    case 2:
                        _ref = _state.sent(), _ref_value = _ref.value, blockhash = _ref_value.blockhash, lastValidBlockHeight = _ref_value.lastValidBlockHeight, _ref_context = _ref.context, minContextSlot = _ref_context.slot;
                        if (!managedPaymentDetails.token) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            $4eb158b8dd6c521a$export$d776e5c4182d21cc(new (0, $69N5M.PublicKey)(managedPaymentDetails.token), new (0, $69N5M.PublicKey)(managedPaymentDetails.paymentAddress))
                        ];
                    case 3:
                        tokenAddress = _state.sent();
                        return [
                            4,
                            $4eb158b8dd6c521a$export$d776e5c4182d21cc(new (0, $69N5M.PublicKey)(managedPaymentDetails.token), publicKey)
                        ];
                    case 4:
                        fromTokenAddress = _state.sent();
                        method = (0, $7228c3dac31e12e0$export$8793fab959da70d1)(managedPaymentDetails.network, managedPaymentDetails.token);
                        transaction = new (0, $69N5M.Transaction)({
                            blockhash: blockhash,
                            lastValidBlockHeight: lastValidBlockHeight,
                            feePayer: publicKey
                        }).add($8347295515b93468$export$b66dd1dc00a3bc28(publicKey, new (0, $69N5M.PublicKey)(tokenAddress), new (0, $69N5M.PublicKey)(managedPaymentDetails.paymentAddress), new (0, $69N5M.PublicKey)(managedPaymentDetails.token))).add($7c5c73bd37fea01a$export$b274d5cebe357db9(fromTokenAddress, tokenAddress, publicKey, (0, $5e268930465d8d42$export$203ae30b4f6490b3)(managedPaymentDetails.amount, (_method_tokenInfo_decimals = (_method_tokenInfo = method.tokenInfo) === null || _method_tokenInfo === void 0 ? void 0 : _method_tokenInfo.decimals) !== null && _method_tokenInfo_decimals !== void 0 ? _method_tokenInfo_decimals : 9)));
                        return [
                            3,
                            7
                        ];
                    case 5:
                        return [
                            4,
                            connection.getMinimumBalanceForRentExemption(0)
                        ];
                    case 6:
                        minimumAmount = BigInt.apply(void 0, [
                            _state.sent()
                        ]);
                        transaction = new (0, $69N5M.Transaction)({
                            blockhash: blockhash,
                            lastValidBlockHeight: lastValidBlockHeight,
                            feePayer: publicKey
                        }).add((0, $69N5M.SystemProgram).transfer({
                            fromPubkey: publicKey,
                            toPubkey: new (0, $69N5M.PublicKey)(managedPaymentDetails.paymentAddress),
                            lamports: $e3dbb0794ed8bfa2$var$maxBigInt((0, $5e268930465d8d42$export$203ae30b4f6490b3)(managedPaymentDetails.amount, 9), minimumAmount)
                        }));
                        _state.label = 7;
                    case 7:
                        return [
                            4,
                            sendTransaction(transaction, connection, {
                                preflightCommitment: "processed",
                                minContextSlot: minContextSlot
                            })
                        ];
                    case 8:
                        signature = _state.sent();
                        return [
                            4,
                            connection.confirmTransaction({
                                blockhash: blockhash,
                                lastValidBlockHeight: lastValidBlockHeight,
                                signature: signature
                            })
                        ];
                    case 9:
                        _state.sent();
                        return [
                            3,
                            11
                        ];
                    case 10:
                        err = _state.sent();
                        console.error("Failed", err);
                        setIsLoading(false);
                        return [
                            3,
                            11
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        });
        return function onClick() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)((0, $78b37e1ff5a5ba28$exports.Fragment), {
        children: [
            (wallet === null || wallet === void 0 ? void 0 : wallet.adapter.publicKey) && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)((0, $78b37e1ff5a5ba28$exports.Fragment), {
                children: [
                    props.presaleStyling && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                style: {
                                    color: props.presaleStyling.darkTextColor,
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 5
                                },
                                children: [
                                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                        style: {
                                            textTransform: "uppercase",
                                            fontSize: 10
                                        },
                                        children: "Connected wallet"
                                    }),
                                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                        children: (0, $923ed4f38e3f62e1$export$193698062786be9a)(wallet.adapter.publicKey.toString(), 10)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $913546acae8c9187$export$f861551692d63a2e), {
                                disabled: isLoading,
                                onClick: /*#__PURE__*/ (0, $kSuI9._)(function() {
                                    return (0, $eha6O.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    solanaDisconnect()
                                                ];
                                            case 1:
                                                return [
                                                    2,
                                                    _state.sent()
                                                ];
                                        }
                                    });
                                }),
                                style: {
                                    padding: 0,
                                    border: 0,
                                    color: props.presaleStyling.titleTextColor,
                                    textTransform: "uppercase",
                                    fontSize: 10
                                },
                                children: "Disconnect"
                            })
                        ]
                    }),
                    !props.presaleStyling && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)($e3dbb0794ed8bfa2$var$ConnectedWalletContainer, {
                        children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "column",
                                border: "1px solid ".concat((0, $651851c7f7a4dfb5$export$8fe7e62e076ddbb5).GRAY_DARK),
                                borderRadius: 5
                            },
                            children: [
                                /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: 15,
                                        backgroundColor: (0, $651851c7f7a4dfb5$export$8fe7e62e076ddbb5).GRAY_MED
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                            style: {
                                                fontSize: 14
                                            },
                                            children: "Connected wallet"
                                        }),
                                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $913546acae8c9187$export$f861551692d63a2e), {
                                            style: {
                                                border: 0,
                                                padding: 0,
                                                color: (0, $651851c7f7a4dfb5$export$8fe7e62e076ddbb5).BLACK,
                                                fontSize: 10,
                                                textTransform: "uppercase"
                                            },
                                            onClick: /*#__PURE__*/ (0, $kSuI9._)(function() {
                                                return (0, $eha6O.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            return [
                                                                4,
                                                                solanaDisconnect()
                                                            ];
                                                        case 1:
                                                            return [
                                                                2,
                                                                _state.sent()
                                                            ];
                                                    }
                                                });
                                            }),
                                            children: "Disconnect"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                    style: {
                                        padding: 15
                                    },
                                    children: wallet.adapter.publicKey.toString()
                                })
                            ]
                        })
                    })
                ]
            }),
            (wallet === null || wallet === void 0 ? void 0 : wallet.adapter.publicKey) ? /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $913546acae8c9187$export$ac16a6a04d9b7c84), {
                isLoading: isLoading,
                onClick: function() {
                    onClick();
                },
                style: {
                    width: "100%",
                    background: props.primaryButtonColor,
                    color: (_props_presaleStyling = props.presaleStyling) === null || _props_presaleStyling === void 0 ? void 0 : _props_presaleStyling.buttonTextColor
                },
                children: "Open wallet"
            }) : /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $258f56c4f81ef851$export$968d144f04194cbb), {
                style: {
                    width: "100%",
                    backgroundColor: "black",
                    background: props.primaryButtonColor,
                    color: (_props_presaleStyling1 = props.presaleStyling) === null || _props_presaleStyling1 === void 0 ? void 0 : _props_presaleStyling1.buttonTextColor,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    fontWeight: 400,
                    borderRadius: 30
                }
            }),
            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $d1f05c17921c0ca1$export$2e2bcd8739ae039), {
                onClose: function() {
                    return setIsSolanaWalletModalVisible(!isSolanaWalletModalVisible);
                },
                visible: isSolanaWalletModalVisible,
                innerStyles: {
                    width: 350
                },
                children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        flexGrow: 1,
                        padding: 20,
                        gap: 10,
                        fontSize: 14
                    },
                    children: [
                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
                            style: {
                                marginBottom: 10
                            },
                            children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                style: {
                                    fontSize: 16,
                                    fontWeight: 500
                                },
                                children: "Select wallet"
                            })
                        }),
                        wallets.length <= 0 && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                padding: "30px 0",
                                gap: 3
                            },
                            children: [
                                /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                    style: {
                                        fontSize: 14
                                    },
                                    children: "No wallet found"
                                }),
                                /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                    style: {
                                        opacity: 0.5
                                    },
                                    children: "Please install a Solana compatible wallet."
                                })
                            ]
                        }),
                        wallets.map(function(w, i) {
                            return /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $913546acae8c9187$export$ac16a6a04d9b7c84), {
                                onClick: /*#__PURE__*/ (0, $kSuI9._)(function() {
                                    return (0, $eha6O.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!(0, $555753d492a5a777$exports.isMobile)) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    connect()
                                                ];
                                            case 1:
                                                _state.sent();
                                                setIsSolanaWalletModalVisible(false);
                                                return [
                                                    3,
                                                    3
                                                ];
                                            case 2:
                                                select(w.adapter.name);
                                                setIsSolanaWalletModalVisible(false);
                                                _state.label = 3;
                                            case 3:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }),
                                style: {
                                    backgroundColor: (0, $651851c7f7a4dfb5$export$8fe7e62e076ddbb5).GRAY_MED,
                                    color: (0, $651851c7f7a4dfb5$export$8fe7e62e076ddbb5).BLACK
                                },
                                children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 15,
                                        justifyContent: "flex-start",
                                        width: "100%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
                                            style: {
                                                width: 20,
                                                height: 20,
                                                backgroundImage: "url(".concat(w.adapter.icon, ")"),
                                                backgroundSize: "contain",
                                                backgroundRepeat: "no-repeat",
                                                backgroundPosition: "center center"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                            children: w.adapter.name
                                        })
                                    ]
                                })
                            }, i);
                        })
                    ]
                })
            })
        ]
    });
};
var $e3dbb0794ed8bfa2$var$SolanaWallet = function(props) {
    var endpoint = $e3dbb0794ed8bfa2$var$endpointUrl(props.managedPaymentDetails.network === "Solana" ? "mainnet" : "devnet");
    var wallets = (0, $1Mpn7.useMemo)(function() {
        return [
            new (0, $c5d4ac6438cae45d$export$a8fff984faa686f6)(),
            new (0, $b1e7d4a4656ea14e$export$9fd69c70c5f8b9b4)()
        ];
    }, []);
    return /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $ba284faa37c4b127$export$fd685cf7c99624bd), {
        endpoint: endpoint,
        children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $c470b3c18c20aeea$export$717b22fc3a2082b3), {
            wallets: wallets,
            autoConnect: true,
            children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $d54b5a01dc6498a0$export$43bb60413a8a3ee6), {
                children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)($e3dbb0794ed8bfa2$var$SolanaWalletInner, (0, $do9pw._)({}, props))
            })
        })
    });
};
var $e3dbb0794ed8bfa2$export$2e2bcd8739ae039 = $e3dbb0794ed8bfa2$var$SolanaWallet;


function $dc7c4573339dd2fe$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $dc7c4573339dd2fe$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $dc7c4573339dd2fe$export$2e2bcd8739ae039(o);
}


function $d938d8d82288cd31$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}


function $021ac0b28ca79ad3$export$2e2bcd8739ae039(argument) {
    (0, $d938d8d82288cd31$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $dc7c4573339dd2fe$export$2e2bcd8739ae039)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $c0900da9e17e3b46$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $d938d8d82288cd31$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $021ac0b28ca79ad3$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $021ac0b28ca79ad3$export$2e2bcd8739ae039)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}



function $88d0aeaafe800168$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}




function $2812676540363fe8$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $d938d8d82288cd31$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $021ac0b28ca79ad3$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $88d0aeaafe800168$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}





function $625319bdb8dfddfd$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $d938d8d82288cd31$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $021ac0b28ca79ad3$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $88d0aeaafe800168$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}





function $d4ccd26b3e6caa0f$export$2e2bcd8739ae039(dirtyDate, duration) {
    (0, $d938d8d82288cd31$export$2e2bcd8739ae039)(2, arguments);
    if (!duration || (0, $dc7c4573339dd2fe$export$2e2bcd8739ae039)(duration) !== "object") return new Date(NaN);
    var years = duration.years ? (0, $88d0aeaafe800168$export$2e2bcd8739ae039)(duration.years) : 0;
    var months = duration.months ? (0, $88d0aeaafe800168$export$2e2bcd8739ae039)(duration.months) : 0;
    var weeks = duration.weeks ? (0, $88d0aeaafe800168$export$2e2bcd8739ae039)(duration.weeks) : 0;
    var days = duration.days ? (0, $88d0aeaafe800168$export$2e2bcd8739ae039)(duration.days) : 0;
    var hours = duration.hours ? (0, $88d0aeaafe800168$export$2e2bcd8739ae039)(duration.hours) : 0;
    var minutes = duration.minutes ? (0, $88d0aeaafe800168$export$2e2bcd8739ae039)(duration.minutes) : 0;
    var seconds = duration.seconds ? (0, $88d0aeaafe800168$export$2e2bcd8739ae039)(duration.seconds) : 0;
    // Add years and months
    var date = (0, $021ac0b28ca79ad3$export$2e2bcd8739ae039)(dirtyDate);
    var dateWithMonths = months || years ? (0, $625319bdb8dfddfd$export$2e2bcd8739ae039)(date, months + years * 12) : date;
    // Add weeks and days
    var dateWithDays = days || weeks ? (0, $2812676540363fe8$export$2e2bcd8739ae039)(dateWithMonths, days + weeks * 7) : dateWithMonths;
    // Add days, hours, minutes and seconds
    var minutesToAdd = minutes + hours * 60;
    var secondsToAdd = seconds + minutesToAdd * 60;
    var msToAdd = secondsToAdd * 1000;
    var finalDate = new Date(dateWithDays.getTime() + msToAdd);
    return finalDate;
}



/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $3ecbd34b7d8761a1$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}




function $ff1ffd17d0ac1527$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d938d8d82288cd31$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $021ac0b28ca79ad3$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}



var $6d4ba368e8923989$var$MILLISECONDS_IN_DAY = 86400000;
function $6d4ba368e8923989$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $d938d8d82288cd31$export$2e2bcd8739ae039)(2, arguments);
    var startOfDayLeft = (0, $ff1ffd17d0ac1527$export$2e2bcd8739ae039)(dirtyDateLeft);
    var startOfDayRight = (0, $ff1ffd17d0ac1527$export$2e2bcd8739ae039)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $3ecbd34b7d8761a1$export$2e2bcd8739ae039)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $3ecbd34b7d8761a1$export$2e2bcd8739ae039)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $6d4ba368e8923989$var$MILLISECONDS_IN_DAY);
}



// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $49715a28c806a5c0$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $49715a28c806a5c0$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $d938d8d82288cd31$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $021ac0b28ca79ad3$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $021ac0b28ca79ad3$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = $49715a28c806a5c0$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $6d4ba368e8923989$export$2e2bcd8739ae039)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($49715a28c806a5c0$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $ca3fa3c9294670b7$export$dfd9b671c89acc8e = 7;
var $ca3fa3c9294670b7$export$3913210603d8e9ae = 365.2425;
var $ca3fa3c9294670b7$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $ca3fa3c9294670b7$export$91246f0b9bd9beff = 60000;
var $ca3fa3c9294670b7$export$7f72910d6dfd237a = 3600000;
var $ca3fa3c9294670b7$export$397c2d5776aa9055 = 1000;
var $ca3fa3c9294670b7$export$4dec998e48f9c246 = -$ca3fa3c9294670b7$export$81caae6e1cc7a622;
var $ca3fa3c9294670b7$export$f2f5ae5a8e2d8f9f = 60;
var $ca3fa3c9294670b7$export$3c58128db900d44e = 3;
var $ca3fa3c9294670b7$export$80d7e435f744f319 = 12;
var $ca3fa3c9294670b7$export$4db7641526e3241f = 4;
var $ca3fa3c9294670b7$export$698aec755e92c695 = 3600;
var $ca3fa3c9294670b7$export$a77c1a7ebebe2a5a = 60;
var $ca3fa3c9294670b7$export$815a9362476d2fe3 = $ca3fa3c9294670b7$export$698aec755e92c695 * 24;
var $ca3fa3c9294670b7$export$34804a017b31e2fe = $ca3fa3c9294670b7$export$815a9362476d2fe3 * 7;
var $ca3fa3c9294670b7$export$7271e9e3478110d1 = $ca3fa3c9294670b7$export$815a9362476d2fe3 * $ca3fa3c9294670b7$export$3913210603d8e9ae;
var $ca3fa3c9294670b7$export$8e6600bbdee7dabb = $ca3fa3c9294670b7$export$7271e9e3478110d1 / 12;
var $ca3fa3c9294670b7$export$be1dccf2de902d31 = $ca3fa3c9294670b7$export$8e6600bbdee7dabb * 3;




function $1dd3955868c65189$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $d938d8d82288cd31$export$2e2bcd8739ae039)(2, arguments);
    return (0, $021ac0b28ca79ad3$export$2e2bcd8739ae039)(dateLeft).getTime() - (0, $021ac0b28ca79ad3$export$2e2bcd8739ae039)(dateRight).getTime();
}



var $5c2dcb1503e394a4$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $5c2dcb1503e394a4$var$defaultRoundingMethod = "trunc";
function $5c2dcb1503e394a4$export$b6474a47258c1211(method) {
    return method ? $5c2dcb1503e394a4$var$roundingMap[method] : $5c2dcb1503e394a4$var$roundingMap[$5c2dcb1503e394a4$var$defaultRoundingMethod];
}


function $ba4aace4b9b44edc$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $d938d8d82288cd31$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $1dd3955868c65189$export$2e2bcd8739ae039)(dateLeft, dateRight) / (0, $ca3fa3c9294670b7$export$7f72910d6dfd237a);
    return (0, $5c2dcb1503e394a4$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}






function $eda957019432a92e$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $d938d8d82288cd31$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $1dd3955868c65189$export$2e2bcd8739ae039)(dateLeft, dateRight) / (0, $ca3fa3c9294670b7$export$91246f0b9bd9beff);
    return (0, $5c2dcb1503e394a4$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}





function $312bc2b4194c21b2$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $d938d8d82288cd31$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $021ac0b28ca79ad3$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $021ac0b28ca79ad3$export$2e2bcd8739ae039)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}







function $e76f0460e0e7be42$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d938d8d82288cd31$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $021ac0b28ca79ad3$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}




function $d9c09febcf1e2017$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d938d8d82288cd31$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $021ac0b28ca79ad3$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}



function $99d4bb184b43758f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d938d8d82288cd31$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $021ac0b28ca79ad3$export$2e2bcd8739ae039)(dirtyDate);
    return (0, $e76f0460e0e7be42$export$2e2bcd8739ae039)(date).getTime() === (0, $d9c09febcf1e2017$export$2e2bcd8739ae039)(date).getTime();
}


function $95b04bfa5725ae75$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $d938d8d82288cd31$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $021ac0b28ca79ad3$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $021ac0b28ca79ad3$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = (0, $c0900da9e17e3b46$export$2e2bcd8739ae039)(dateLeft, dateRight);
    var difference = Math.abs((0, $312bc2b4194c21b2$export$2e2bcd8739ae039)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, $c0900da9e17e3b46$export$2e2bcd8739ae039)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $99d4bb184b43758f$export$2e2bcd8739ae039)((0, $021ac0b28ca79ad3$export$2e2bcd8739ae039)(dirtyDateLeft)) && difference === 1 && (0, $c0900da9e17e3b46$export$2e2bcd8739ae039)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}





function $5cda7903ceaa9585$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $d938d8d82288cd31$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $1dd3955868c65189$export$2e2bcd8739ae039)(dateLeft, dateRight) / 1000;
    return (0, $5c2dcb1503e394a4$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}





function $78216b2c670ef3dd$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $d938d8d82288cd31$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $021ac0b28ca79ad3$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $021ac0b28ca79ad3$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}




function $6584c6c93fbb8f35$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $d938d8d82288cd31$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $021ac0b28ca79ad3$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $021ac0b28ca79ad3$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = (0, $c0900da9e17e3b46$export$2e2bcd8739ae039)(dateLeft, dateRight);
    var difference = Math.abs((0, $78216b2c670ef3dd$export$2e2bcd8739ae039)(dateLeft, dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    dateLeft.setFullYear(1584);
    dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastYearNotFull = (0, $c0900da9e17e3b46$export$2e2bcd8739ae039)(dateLeft, dateRight) === -sign;
    var result = sign * (difference - Number(isLastYearNotFull));
    // Prevent negative zero
    return result === 0 ? 0 : result;
}




function $9ec7c0f63fa73321$export$2e2bcd8739ae039(interval) {
    (0, $d938d8d82288cd31$export$2e2bcd8739ae039)(1, arguments);
    var start = (0, $021ac0b28ca79ad3$export$2e2bcd8739ae039)(interval.start);
    var end = (0, $021ac0b28ca79ad3$export$2e2bcd8739ae039)(interval.end);
    if (isNaN(start.getTime())) throw new RangeError("Start Date is invalid");
    if (isNaN(end.getTime())) throw new RangeError("End Date is invalid");
    var duration = {};
    duration.years = Math.abs((0, $6584c6c93fbb8f35$export$2e2bcd8739ae039)(end, start));
    var sign = (0, $c0900da9e17e3b46$export$2e2bcd8739ae039)(end, start);
    var remainingMonths = (0, $d4ccd26b3e6caa0f$export$2e2bcd8739ae039)(start, {
        years: sign * duration.years
    });
    duration.months = Math.abs((0, $95b04bfa5725ae75$export$2e2bcd8739ae039)(end, remainingMonths));
    var remainingDays = (0, $d4ccd26b3e6caa0f$export$2e2bcd8739ae039)(remainingMonths, {
        months: sign * duration.months
    });
    duration.days = Math.abs((0, $49715a28c806a5c0$export$2e2bcd8739ae039)(end, remainingDays));
    var remainingHours = (0, $d4ccd26b3e6caa0f$export$2e2bcd8739ae039)(remainingDays, {
        days: sign * duration.days
    });
    duration.hours = Math.abs((0, $ba4aace4b9b44edc$export$2e2bcd8739ae039)(end, remainingHours));
    var remainingMinutes = (0, $d4ccd26b3e6caa0f$export$2e2bcd8739ae039)(remainingHours, {
        hours: sign * duration.hours
    });
    duration.minutes = Math.abs((0, $eda957019432a92e$export$2e2bcd8739ae039)(end, remainingMinutes));
    var remainingSeconds = (0, $d4ccd26b3e6caa0f$export$2e2bcd8739ae039)(remainingMinutes, {
        minutes: sign * duration.minutes
    });
    duration.seconds = Math.abs((0, $5cda7903ceaa9585$export$2e2bcd8739ae039)(end, remainingSeconds));
    return duration;
}

var $0422a40f9303554b$var$defaultOptions = {};
function $0422a40f9303554b$export$430a3269e24b912e() {
    return $0422a40f9303554b$var$defaultOptions;
}
function $0422a40f9303554b$export$95365be1b0704abc(newOptions) {
    $0422a40f9303554b$var$defaultOptions = newOptions;
}





var $c52cea693f4bdb7b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $c52cea693f4bdb7b$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $c52cea693f4bdb7b$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $c52cea693f4bdb7b$export$2e2bcd8739ae039 = $c52cea693f4bdb7b$var$formatDistance;


function $d46d76cc0325c765$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $d7afd3e15aa55a30$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $d7afd3e15aa55a30$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $d7afd3e15aa55a30$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $d7afd3e15aa55a30$var$formatLong = {
    date: (0, $d46d76cc0325c765$export$2e2bcd8739ae039)({
        formats: $d7afd3e15aa55a30$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $d46d76cc0325c765$export$2e2bcd8739ae039)({
        formats: $d7afd3e15aa55a30$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $d46d76cc0325c765$export$2e2bcd8739ae039)({
        formats: $d7afd3e15aa55a30$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $d7afd3e15aa55a30$export$2e2bcd8739ae039 = $d7afd3e15aa55a30$var$formatLong;


var $b5168e4abfcd8be0$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $b5168e4abfcd8be0$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $b5168e4abfcd8be0$var$formatRelativeLocale[token];
};
var $b5168e4abfcd8be0$export$2e2bcd8739ae039 = $b5168e4abfcd8be0$var$formatRelative;


function $c4ae12f4d7d17056$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $27756db4b2fd4c53$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $27756db4b2fd4c53$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $27756db4b2fd4c53$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $27756db4b2fd4c53$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $27756db4b2fd4c53$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $27756db4b2fd4c53$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $27756db4b2fd4c53$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $27756db4b2fd4c53$var$localize = {
    ordinalNumber: $27756db4b2fd4c53$var$ordinalNumber,
    era: (0, $c4ae12f4d7d17056$export$2e2bcd8739ae039)({
        values: $27756db4b2fd4c53$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $c4ae12f4d7d17056$export$2e2bcd8739ae039)({
        values: $27756db4b2fd4c53$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $c4ae12f4d7d17056$export$2e2bcd8739ae039)({
        values: $27756db4b2fd4c53$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $c4ae12f4d7d17056$export$2e2bcd8739ae039)({
        values: $27756db4b2fd4c53$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $c4ae12f4d7d17056$export$2e2bcd8739ae039)({
        values: $27756db4b2fd4c53$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $27756db4b2fd4c53$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $27756db4b2fd4c53$export$2e2bcd8739ae039 = $27756db4b2fd4c53$var$localize;


function $b4e5b10051d2207f$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $b4e5b10051d2207f$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $b4e5b10051d2207f$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $b4e5b10051d2207f$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $b4e5b10051d2207f$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $6b82994706de6f65$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $2efadab605aac984$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $2efadab605aac984$var$parseOrdinalNumberPattern = /\d+/i;
var $2efadab605aac984$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $2efadab605aac984$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $2efadab605aac984$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $2efadab605aac984$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $2efadab605aac984$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $2efadab605aac984$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $2efadab605aac984$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $2efadab605aac984$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $2efadab605aac984$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $2efadab605aac984$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $2efadab605aac984$var$match = {
    ordinalNumber: (0, $6b82994706de6f65$export$2e2bcd8739ae039)({
        matchPattern: $2efadab605aac984$var$matchOrdinalNumberPattern,
        parsePattern: $2efadab605aac984$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $b4e5b10051d2207f$export$2e2bcd8739ae039)({
        matchPatterns: $2efadab605aac984$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2efadab605aac984$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $b4e5b10051d2207f$export$2e2bcd8739ae039)({
        matchPatterns: $2efadab605aac984$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2efadab605aac984$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $b4e5b10051d2207f$export$2e2bcd8739ae039)({
        matchPatterns: $2efadab605aac984$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2efadab605aac984$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $b4e5b10051d2207f$export$2e2bcd8739ae039)({
        matchPatterns: $2efadab605aac984$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2efadab605aac984$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $b4e5b10051d2207f$export$2e2bcd8739ae039)({
        matchPatterns: $2efadab605aac984$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $2efadab605aac984$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $2efadab605aac984$export$2e2bcd8739ae039 = $2efadab605aac984$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $42edf1c7634ff38c$var$locale = {
    code: "en-US",
    formatDistance: (0, $c52cea693f4bdb7b$export$2e2bcd8739ae039),
    formatLong: (0, $d7afd3e15aa55a30$export$2e2bcd8739ae039),
    formatRelative: (0, $b5168e4abfcd8be0$export$2e2bcd8739ae039),
    localize: (0, $27756db4b2fd4c53$export$2e2bcd8739ae039),
    match: (0, $2efadab605aac984$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $42edf1c7634ff38c$export$2e2bcd8739ae039 = $42edf1c7634ff38c$var$locale;


var $1211f704d3e5080d$export$2e2bcd8739ae039 = (0, $42edf1c7634ff38c$export$2e2bcd8739ae039);



function $77dfe7aa26a64193$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}


function $0c3d6b43b0e8f55a$export$2e2bcd8739ae039(object) {
    return (0, $77dfe7aa26a64193$export$2e2bcd8739ae039)({}, object);
}





var $ceea973bc1537f4d$var$MINUTES_IN_DAY = 1440;
var $ceea973bc1537f4d$var$MINUTES_IN_ALMOST_TWO_DAYS = 2520;
var $ceea973bc1537f4d$var$MINUTES_IN_MONTH = 43200;
var $ceea973bc1537f4d$var$MINUTES_IN_TWO_MONTHS = 86400;
function $ceea973bc1537f4d$export$2e2bcd8739ae039(dirtyDate, dirtyBaseDate, options) {
    var _ref, _options$locale;
    (0, $d938d8d82288cd31$export$2e2bcd8739ae039)(2, arguments);
    var defaultOptions = (0, $0422a40f9303554b$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $1211f704d3e5080d$export$2e2bcd8739ae039);
    if (!locale.formatDistance) throw new RangeError("locale must contain formatDistance property");
    var comparison = (0, $c0900da9e17e3b46$export$2e2bcd8739ae039)(dirtyDate, dirtyBaseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    var localizeOptions = (0, $77dfe7aa26a64193$export$2e2bcd8739ae039)((0, $0c3d6b43b0e8f55a$export$2e2bcd8739ae039)(options), {
        addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
        comparison: comparison
    });
    var dateLeft;
    var dateRight;
    if (comparison > 0) {
        dateLeft = (0, $021ac0b28ca79ad3$export$2e2bcd8739ae039)(dirtyBaseDate);
        dateRight = (0, $021ac0b28ca79ad3$export$2e2bcd8739ae039)(dirtyDate);
    } else {
        dateLeft = (0, $021ac0b28ca79ad3$export$2e2bcd8739ae039)(dirtyDate);
        dateRight = (0, $021ac0b28ca79ad3$export$2e2bcd8739ae039)(dirtyBaseDate);
    }
    var seconds = (0, $5cda7903ceaa9585$export$2e2bcd8739ae039)(dateRight, dateLeft);
    var offsetInSeconds = ((0, $3ecbd34b7d8761a1$export$2e2bcd8739ae039)(dateRight) - (0, $3ecbd34b7d8761a1$export$2e2bcd8739ae039)(dateLeft)) / 1000;
    var minutes = Math.round((seconds - offsetInSeconds) / 60);
    var months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options !== null && options !== void 0 && options.includeSeconds) {
            if (seconds < 5) return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance("halfAMinute", 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance("xMinutes", minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance("aboutXHours", 1, localizeOptions);
    else if (minutes < $ceea973bc1537f4d$var$MINUTES_IN_DAY) {
        var hours = Math.round(minutes / 60);
        return locale.formatDistance("aboutXHours", hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < $ceea973bc1537f4d$var$MINUTES_IN_ALMOST_TWO_DAYS) return locale.formatDistance("xDays", 1, localizeOptions);
    else if (minutes < $ceea973bc1537f4d$var$MINUTES_IN_MONTH) {
        var days = Math.round(minutes / $ceea973bc1537f4d$var$MINUTES_IN_DAY);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < $ceea973bc1537f4d$var$MINUTES_IN_TWO_MONTHS) {
        months = Math.round(minutes / $ceea973bc1537f4d$var$MINUTES_IN_MONTH);
        return locale.formatDistance("aboutXMonths", months, localizeOptions);
    }
    months = (0, $95b04bfa5725ae75$export$2e2bcd8739ae039)(dateRight, dateLeft);
    // 2 months up to 12 months
    if (months < 12) {
        var nearestMonth = Math.round(minutes / $ceea973bc1537f4d$var$MINUTES_IN_MONTH);
        return locale.formatDistance("xMonths", nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        var monthsSinceStartOfYear = months % 12;
        var years = Math.floor(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance("aboutXYears", years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance("overXYears", years, localizeOptions);
        else return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
}



function $ce7f80eccea34e5e$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $d938d8d82288cd31$export$2e2bcd8739ae039)(1, arguments);
    return (0, $ceea973bc1537f4d$export$2e2bcd8739ae039)(dirtyDate, Date.now(), options);
}



var $1d38928f289e87f2$var$defaultFormat = [
    "years",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds"
];
function $1d38928f289e87f2$export$2e2bcd8739ae039(duration, options) {
    var _ref, _options$locale, _options$format, _options$zero, _options$delimiter;
    if (arguments.length < 1) throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
    var defaultOptions = (0, $0422a40f9303554b$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $1211f704d3e5080d$export$2e2bcd8739ae039);
    var format = (_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : $1d38928f289e87f2$var$defaultFormat;
    var zero = (_options$zero = options === null || options === void 0 ? void 0 : options.zero) !== null && _options$zero !== void 0 ? _options$zero : false;
    var delimiter = (_options$delimiter = options === null || options === void 0 ? void 0 : options.delimiter) !== null && _options$delimiter !== void 0 ? _options$delimiter : " ";
    if (!locale.formatDistance) return "";
    var result = format.reduce(function(acc, unit) {
        var token = "x".concat(unit.replace(/(^.)/, function(m) {
            return m.toUpperCase();
        }));
        var value = duration[unit];
        if (typeof value === "number" && (zero || duration[unit])) return acc.concat(locale.formatDistance(token, value));
        return acc;
    }, []).join(delimiter);
    return result;
}




var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

parcelRequire("1Mpn7");
function $2f8224fb9ba3490a$export$65be7b63f510f362(props) {
    return /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("svg", (0, $cxjpp._)((0, $do9pw._)({
        width: "10",
        height: "6",
        viewBox: "0 0 10 6",
        fill: "black",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("path", {
            d: "M5.39802 5.94478L9.9767 1.36609L8.90021 0.288086L5.39802 3.79257L1.89658 0.288086L0.819336 1.36533L5.39802 5.94478Z"
        })
    }));
}



var $d38b2772f4ec6328$exports = {};

$d38b2772f4ec6328$exports = (parcelRequire("6Aq0R")).getBundleURL("jWbtw") + "Wave.2a680c9e.svg";



var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");

parcelRequire("1Mpn7");
function $789f803c07c0d813$var$Copy(props) {
    return /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("svg", (0, $cxjpp._)((0, $do9pw._)({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("g", {
                clipPath: "url(#clip0_3_1274)",
                children: [
                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("path", {
                        d: "M16 3H4V16",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("path", {
                        d: "M8 7H20V19C20 20.1046 19.1046 21 18 21H10C8.89543 21 8 20.1046 8 19V7Z",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("clipPath", {
                    id: "clip0_3_1274",
                    children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    }));
}
var $789f803c07c0d813$export$2e2bcd8739ae039 = $789f803c07c0d813$var$Copy;



var $do9pw = parcelRequire("do9pw");

var $cxjpp = parcelRequire("cxjpp");



var $kSuI9 = parcelRequire("kSuI9");

var $do9pw = parcelRequire("do9pw");

var $cv9Rk = parcelRequire("cv9Rk");

var $eha6O = parcelRequire("eha6O");

var $1Mpn7 = parcelRequire("1Mpn7");
var $45f90ff27c2fb8ce$var$modal = undefined;
function $45f90ff27c2fb8ce$export$db9d243f55cd9d82(appKit) {
    if (appKit) $45f90ff27c2fb8ce$var$modal = appKit;
}
function $45f90ff27c2fb8ce$export$7cb034a59823159f() {
    if (!$45f90ff27c2fb8ce$var$modal) throw new Error('Please call "createWeb3Modal" before using "useWeb3ModalTheme" hook');
    function setThemeMode(themeMode) {
        if (themeMode) $45f90ff27c2fb8ce$var$modal === null || $45f90ff27c2fb8ce$var$modal === void 0 ? void 0 : $45f90ff27c2fb8ce$var$modal.setThemeMode(themeMode);
    }
    function setThemeVariables(themeVariables) {
        if (themeVariables) $45f90ff27c2fb8ce$var$modal === null || $45f90ff27c2fb8ce$var$modal === void 0 ? void 0 : $45f90ff27c2fb8ce$var$modal.setThemeVariables(themeVariables);
    }
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)($45f90ff27c2fb8ce$var$modal.getThemeMode()), 2), themeMode = _useState[0], setInternalThemeMode = _useState[1];
    var _useState1 = (0, $cv9Rk._)((0, $1Mpn7.useState)($45f90ff27c2fb8ce$var$modal.getThemeVariables()), 2), themeVariables = _useState1[0], setInternalThemeVariables = _useState1[1];
    (0, $1Mpn7.useEffect)(function() {
        var unsubscribe = $45f90ff27c2fb8ce$var$modal === null || $45f90ff27c2fb8ce$var$modal === void 0 ? void 0 : $45f90ff27c2fb8ce$var$modal.subscribeTheme(function(state) {
            setInternalThemeMode(state.themeMode);
            setInternalThemeVariables(state.themeVariables);
        });
        return function() {
            unsubscribe === null || unsubscribe === void 0 ? void 0 : unsubscribe();
        };
    }, []);
    return {
        themeMode: themeMode,
        themeVariables: themeVariables,
        setThemeMode: setThemeMode,
        setThemeVariables: setThemeVariables
    };
}
function $45f90ff27c2fb8ce$export$69804ca079d47f29() {
    if (!$45f90ff27c2fb8ce$var$modal) throw new Error('Please call "createWeb3Modal" before using "useWeb3Modal" hook');
    function open(options) {
        return _open.apply(this, arguments);
    }
    function _open() {
        _open = (0, $kSuI9._)(function(options) {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            $45f90ff27c2fb8ce$var$modal === null || $45f90ff27c2fb8ce$var$modal === void 0 ? void 0 : $45f90ff27c2fb8ce$var$modal.open(options)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _open.apply(this, arguments);
    }
    function close() {
        return _close.apply(this, arguments);
    }
    function _close() {
        _close = (0, $kSuI9._)(function() {
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            $45f90ff27c2fb8ce$var$modal === null || $45f90ff27c2fb8ce$var$modal === void 0 ? void 0 : $45f90ff27c2fb8ce$var$modal.close()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _close.apply(this, arguments);
    }
    return {
        open: open,
        close: close
    };
}
function $45f90ff27c2fb8ce$export$eeb8ee10880c5bf1() {
    if (!$45f90ff27c2fb8ce$var$modal) throw new Error('Please call "createWeb3Modal" before using "useWalletInfo" hook');
    var walletInfo = (0, $1Mpn7.useSyncExternalStore)($45f90ff27c2fb8ce$var$modal.subscribeWalletInfo, $45f90ff27c2fb8ce$var$modal.getWalletInfo, $45f90ff27c2fb8ce$var$modal.getWalletInfo);
    return {
        walletInfo: walletInfo
    };
}
function $45f90ff27c2fb8ce$export$462a1af4ea315fad() {
    if (!$45f90ff27c2fb8ce$var$modal) throw new Error('Please call "createWeb3Modal" before using "useWeb3ModalState" hook');
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)($45f90ff27c2fb8ce$var$modal.getState()), 2), state = _useState[0], setState = _useState[1];
    (0, $1Mpn7.useEffect)(function() {
        var unsubscribe = $45f90ff27c2fb8ce$var$modal === null || $45f90ff27c2fb8ce$var$modal === void 0 ? void 0 : $45f90ff27c2fb8ce$var$modal.subscribeState(function(newState) {
            setState((0, $do9pw._)({}, newState));
        });
        return function() {
            unsubscribe === null || unsubscribe === void 0 ? void 0 : unsubscribe();
        };
    }, []);
    return state;
}
function $45f90ff27c2fb8ce$export$cd17534826f46144() {
    if (!$45f90ff27c2fb8ce$var$modal) throw new Error('Please call "createWeb3Modal" before using "useWeb3ModalEvents" hook');
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)($45f90ff27c2fb8ce$var$modal.getEvent()), 2), event = _useState[0], setEvents = _useState[1];
    (0, $1Mpn7.useEffect)(function() {
        var unsubscribe = $45f90ff27c2fb8ce$var$modal === null || $45f90ff27c2fb8ce$var$modal === void 0 ? void 0 : $45f90ff27c2fb8ce$var$modal.subscribeEvents(function(newEvent) {
            setEvents((0, $do9pw._)({}, newEvent));
        });
        return function() {
            unsubscribe === null || unsubscribe === void 0 ? void 0 : unsubscribe();
        };
    }, []);
    return event;
}



var $3471780867f88505$var$appkit = undefined;
var $3471780867f88505$var$wagmiAdapter = undefined;
function $3471780867f88505$export$14650d4efb17e382(options) {
    $3471780867f88505$var$wagmiAdapter = new (0, $2eb794d81ea38b94$export$ba6a4843bec5d2a8)({
        wagmiConfig: options.wagmiConfig,
        siweConfig: options.siweConfig,
        defaultChain: options.defaultChain
    });
    $3471780867f88505$var$appkit = new (0, $01027d2cdef453cb$export$fc94c40ea502fa4c)((0, $cxjpp._)((0, $do9pw._)({}, options), {
        defaultChain: $3471780867f88505$var$wagmiAdapter.defaultChain,
        adapters: [
            $3471780867f88505$var$wagmiAdapter
        ],
        sdkType: "w3m",
        sdkVersion: "react-wagmi-".concat((0, $24f38d6e95bf0035$export$aafe1f751f1bc52a).VERSION)
    }));
    (0, $45f90ff27c2fb8ce$export$db9d243f55cd9d82)($3471780867f88505$var$appkit);
    return $3471780867f88505$var$appkit;
}





function $fd3ee3fc842ae846$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  100% {\n    --angle: 440deg;\n  }\n"
    ]);
    $fd3ee3fc842ae846$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $fd3ee3fc842ae846$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  top: 0;\n  z-index: -1;\n  overflow: hidden;\n"
    ]);
    $fd3ee3fc842ae846$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $fd3ee3fc842ae846$var$_templateObject2() {
    var data = (0, $j06k0._)([
        "\n  0% {\n    margin-left: 0;\n  }\n  100% {\n    margin-left: -1600px;\n  }\n"
    ]);
    $fd3ee3fc842ae846$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $fd3ee3fc842ae846$var$_templateObject3() {
    var data = (0, $j06k0._)([
        "\n  background: url(",
        ") repeat-x;\n  position: absolute;\n  width: 6400px;\n  height: 50%;\n  top: calc(50% - 100px);\n  animation: ",
        " 18s cubic-bezier( 0.36, 0.45, 0.63, 0.53) infinite;\n"
    ]);
    $fd3ee3fc842ae846$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $fd3ee3fc842ae846$var$_templateObject4() {
    var data = (0, $j06k0._)([
        "\n  border-radius: 3px;\n  overflow: hidden;\n  width: fit-content;\n  box-shadow: 0 0 3px ",
        ";\n  transition: 0.2s ease all;\n  cursor: pointer;\n\n  &:active {\n    transform: scale(0.99);\n  }\n"
    ]);
    $fd3ee3fc842ae846$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $fd3ee3fc842ae846$var$_templateObject5() {
    var data = (0, $j06k0._)([
        "\n  width: fit-content;\n  border: 3px solid;\n  border-image: conic-gradient(from var(--angle), var(--c2), var(--c1) 0.1turn, var(--c1) 0.15turn, var(--c2) 0.25turn) 30;\n  animation: ",
        " var(--d) linear infinite forwards;\n  font-size: 0;\n"
    ]);
    $fd3ee3fc842ae846$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $fd3ee3fc842ae846$var$_templateObject6() {
    var data = (0, $j06k0._)([
        "\n  from {\n    transform: translateY(-25%);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n"
    ]);
    $fd3ee3fc842ae846$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $fd3ee3fc842ae846$var$_templateObject7() {
    var data = (0, $j06k0._)([
        "\n  flex-grow: 1;\n  animation: ",
        " 0.2s ease;\n"
    ]);
    $fd3ee3fc842ae846$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $fd3ee3fc842ae846$var$_templateObject8() {
    var data = (0, $j06k0._)([
        "\n  width: 20px;\n  height: 20px;\n  background-image: url(",
        ");\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n"
    ]);
    $fd3ee3fc842ae846$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function $fd3ee3fc842ae846$var$_templateObject9() {
    var data = (0, $j06k0._)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 5px;\n"
    ]);
    $fd3ee3fc842ae846$var$_templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
// 1. Get a project ID at https://cloud.walletconnect.com
var $fd3ee3fc842ae846$var$chains = [
    (0, $f2095a368764cd16$export$536d3e0d2c7baf54),
    (0, $4f58ad3687968cfa$export$625cf84d855940d4)
];
var $fd3ee3fc842ae846$export$e506a1d27d1eaa20 = (0, $8012589831b73495$export$f84bd70098573c5c)({
    chains: $fd3ee3fc842ae846$var$chains,
    projectId: (0, $7228c3dac31e12e0$export$e4bb003b4e7478a),
    metadata: (0, $7228c3dac31e12e0$export$dbb5e893e736e4ee)
});
(0, $f8aa10d203403d99$export$f0e7018a430fa792)($fd3ee3fc842ae846$export$e506a1d27d1eaa20);
(0, $3471780867f88505$export$14650d4efb17e382)({
    wagmiConfig: $fd3ee3fc842ae846$export$e506a1d27d1eaa20,
    projectId: (0, $7228c3dac31e12e0$export$e4bb003b4e7478a)
});
var $fd3ee3fc842ae846$var$borderRotate = (0, $f2ce4b3babf40f7e$export$d25ddfdf17c3ad3e)($fd3ee3fc842ae846$var$_templateObject());
var $fd3ee3fc842ae846$var$CopyButton = function(param) {
    var onClick = param.onClick, style = param.style, _param_iconColor = param.iconColor, iconColor = _param_iconColor === void 0 ? (0, $651851c7f7a4dfb5$export$8fe7e62e076ddbb5).GRAY_DARKEST : _param_iconColor;
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)(false), 2), copied = _useState[0], setCopied = _useState[1];
    (0, $1Mpn7.useEffect)(function() {
        if (copied) {
            var timeout = setTimeout(function() {
                return setCopied(false);
            }, 3000);
            return function() {
                return clearTimeout(timeout);
            };
        }
    }, [
        copied
    ]);
    return /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)((0, $913546acae8c9187$export$f861551692d63a2e), {
        onClick: function() {
            setCopied(true);
            onClick();
        },
        style: (0, $do9pw._)({
            padding: "2px 4px",
            fontSize: 10,
            textTransform: "uppercase",
            background: (0, $651851c7f7a4dfb5$export$8fe7e62e076ddbb5).GRAY_MED,
            color: (0, $651851c7f7a4dfb5$export$8fe7e62e076ddbb5).GRAY_DARKEST,
            cursor: "pointer",
            borderRadius: 5,
            display: "flex",
            alignItems: "center",
            gap: 2,
            border: "none"
        }, style),
        children: [
            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                children: copied ? "Copied" : "Copy"
            }),
            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $789f803c07c0d813$export$2e2bcd8739ae039), {
                style: {
                    height: 10
                },
                stroke: iconColor
            })
        ]
    });
};
var $fd3ee3fc842ae846$var$WaveContainer = (0, $f2ce4b3babf40f7e$export$2e2bcd8739ae039).div($fd3ee3fc842ae846$var$_templateObject1());
var $fd3ee3fc842ae846$var$WaveAnim = (0, $f2ce4b3babf40f7e$export$d25ddfdf17c3ad3e)($fd3ee3fc842ae846$var$_templateObject2());
var $fd3ee3fc842ae846$var$Wave = (0, $f2ce4b3babf40f7e$export$2e2bcd8739ae039).div($fd3ee3fc842ae846$var$_templateObject3(), (0, (/*@__PURE__*/$parcel$interopDefault($d38b2772f4ec6328$exports))), $fd3ee3fc842ae846$var$WaveAnim);
function $fd3ee3fc842ae846$var$formatSecondsToMinutesAndSecondsString(totalSeconds) {
    var duration = (0, $9ec7c0f63fa73321$export$2e2bcd8739ae039)({
        start: 0,
        end: totalSeconds * 1000
    });
    var zeroPad = function(num) {
        return String(num).padStart(2, "0");
    };
    var formatted = [
        duration.days,
        duration.hours,
        duration.minutes,
        duration.seconds
    ].filter(function(a, i) {
        return i <= 1 ? !!a : true;
    }).map(zeroPad).join(":");
    return formatted;
}
var $fd3ee3fc842ae846$var$QRCodeWrapper = (0, $f2ce4b3babf40f7e$export$2e2bcd8739ae039).div($fd3ee3fc842ae846$var$_templateObject4(), (0, $651851c7f7a4dfb5$export$8fe7e62e076ddbb5).GRAY_DARK);
var $fd3ee3fc842ae846$var$QRCodeWrapperInner = (0, $f2ce4b3babf40f7e$export$2e2bcd8739ae039).div($fd3ee3fc842ae846$var$_templateObject5(), $fd3ee3fc842ae846$var$borderRotate);
var $fd3ee3fc842ae846$var$WrapperIn = (0, $f2ce4b3babf40f7e$export$d25ddfdf17c3ad3e)($fd3ee3fc842ae846$var$_templateObject6());
var $fd3ee3fc842ae846$var$Wrapper = (0, $f2ce4b3babf40f7e$export$2e2bcd8739ae039).div($fd3ee3fc842ae846$var$_templateObject7(), $fd3ee3fc842ae846$var$WrapperIn);
var $fd3ee3fc842ae846$var$TokenIcon = (0, $f2ce4b3babf40f7e$export$2e2bcd8739ae039).div($fd3ee3fc842ae846$var$_templateObject8(), function(param) {
    var imageUrl = param.imageUrl;
    return imageUrl;
});
var $fd3ee3fc842ae846$var$TimeInnerContainer = (0, $f2ce4b3babf40f7e$export$2e2bcd8739ae039).div($fd3ee3fc842ae846$var$_templateObject9());
var $fd3ee3fc842ae846$var$State;
(function(State) {
    State[State["SettingAmount"] = 0] = "SettingAmount";
    State[State["SettingPaymentMethod"] = 1] = "SettingPaymentMethod";
    State[State["SettingInputFields"] = 2] = "SettingInputFields";
    State[State["MakingPayment"] = 3] = "MakingPayment";
})($fd3ee3fc842ae846$var$State || ($fd3ee3fc842ae846$var$State = {}));
function $fd3ee3fc842ae846$var$Presale(props) {
    var _props_checkoutData_gateway_managed, _props_checkoutData_gateway_managed1, _props_checkoutData_products, _presaleData_tokenPresaleData_customizations, _presaleData_tokenPresaleData, _presaleData_tokenPresaleData_customizations1, _presaleData_tokenPresaleData1, _token_product_productType_Presale_Token, _token_product_productType_Presale, _token_product_productType, _token_product_productType_Presale_Token1, _token_product_productType_Presale1, _token_product_productType1, _props_paymentStatus, _props_paymentStatus1, _props_paymentStatus2, _props_paymentStatus3, _props_checkoutData_customizations, _props_paymentStatus4, _props_paymentStatus5, _props_paymentStatus6, _props_order, _props_checkoutData_inputFields, _props_checkoutData_gateway_managed2, _presaleData_tokenPresaleData2, _presaleData_tokenPresaleData_customizations2, _presaleData_tokenPresaleData3, _presaleData_tokenPresaleData4, _presaleData_tokenPresaleData5, _getMethod_tokenInfo, _token_product_productType_Presale_Token2, _token_product_productType_Presale2, _token_product_productType2, _props_checkoutData_gateway_managed3, _presaleData_tokenPresaleData6, _props_checkoutData_inputFields1;
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)({
        leftPanelColor: "white",
        primaryButtonColor: "black"
    }), 2), customizations = _useState[0], setCustomizations = _useState[1];
    var _useState1 = (0, $cv9Rk._)((0, $1Mpn7.useState)(), 2), fiatAmount = _useState1[0], setFiatAmount = _useState1[1];
    var _useState2 = (0, $cv9Rk._)((0, $1Mpn7.useState)(), 2), tokenAmount = _useState2[0], setTokenAmount = _useState2[1];
    var _useState3 = (0, $cv9Rk._)((0, $1Mpn7.useState)((_props_checkoutData_gateway_managed = props.checkoutData.gateway.managed) === null || _props_checkoutData_gateway_managed === void 0 ? void 0 : _props_checkoutData_gateway_managed.methods[0]), 2), selectedMethod = _useState3[0], setSelectedPaymentMethod = _useState3[1];
    var _useState4 = (0, $cv9Rk._)((0, $1Mpn7.useState)(0), 2), state = _useState4[0], setState = _useState4[1];
    var _useState5 = (0, $cv9Rk._)((0, $1Mpn7.useState)(), 2), startsAt = _useState5[0], setStartsAt = _useState5[1];
    var _useState6 = (0, $cv9Rk._)((0, $1Mpn7.useState)(), 2), endsAt = _useState6[0], setEndsAt = _useState6[1];
    var _useState7 = (0, $cv9Rk._)((0, $1Mpn7.useState)(), 2), nextPriceIncreaseAt = _useState7[0], setNextPriceIncreaseAt = _useState7[1];
    (0, $1Mpn7.useEffect)(function() {
        var _props_checkoutData_gateway_managed;
        setSelectedPaymentMethod((_props_checkoutData_gateway_managed = props.checkoutData.gateway.managed) === null || _props_checkoutData_gateway_managed === void 0 ? void 0 : _props_checkoutData_gateway_managed.methods[0]);
    }, [
        (_props_checkoutData_gateway_managed1 = props.checkoutData.gateway.managed) === null || _props_checkoutData_gateway_managed1 === void 0 ? void 0 : _props_checkoutData_gateway_managed1.methods
    ]);
    if (!props.checkoutData.products || ((_props_checkoutData_products = props.checkoutData.products) === null || _props_checkoutData_products === void 0 ? void 0 : _props_checkoutData_products.length) <= 0) return /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $78b37e1ff5a5ba28$exports.Fragment), {});
    var presaleData = props.checkoutData.presaleData;
    var token = props.checkoutData.products[0];
    var titleTextColor = (0, $923ed4f38e3f62e1$export$8121a4101142837f)(customizations.leftPanelColor, "rgba(255, 255, 255, 1)", "rgba(0, 0, 0, 1)");
    var lightTextColor = (0, $923ed4f38e3f62e1$export$8121a4101142837f)(customizations.leftPanelColor, "rgba(255, 255, 255, 0.05)", "rgba(0, 0, 0, 0.05)");
    var mediumTextColor = (0, $923ed4f38e3f62e1$export$8121a4101142837f)(customizations.leftPanelColor, "rgba(255, 255, 255, 0.1)", "rgba(0, 0, 0, 0.1)");
    var textColor = (0, $923ed4f38e3f62e1$export$8121a4101142837f)(customizations.leftPanelColor, "rgba(255, 255, 255, 0.45)", "rgba(0, 0, 0, 0.45)");
    var darkTextColor = (0, $923ed4f38e3f62e1$export$8121a4101142837f)(customizations.leftPanelColor, "rgba(255, 255, 255, 0.65)", "rgba(0, 0, 0, 0.65)");
    var buttonTextColor = (0, $923ed4f38e3f62e1$export$8121a4101142837f)(customizations.primaryButtonColor, "rgba(255, 255, 255, 0.95)", "rgba(0, 0, 0, 0.95)");
    var _useState8 = (0, $cv9Rk._)((0, $1Mpn7.useState)(1), 2), priceMultiplier = _useState8[0], setPriceMultiplier = _useState8[1];
    var setTokenAmountFromFiatAmount = function(fiatAmount) {
        var _token_product_productType_Presale_Token, _token_product_productType_Presale, _token_product_productType;
        var price = token.product.price * priceMultiplier;
        setTokenAmount((0, $lFPa6.round)(Number(fiatAmount) / price, (_token_product_productType = token.product.productType) === null || _token_product_productType === void 0 ? void 0 : (_token_product_productType_Presale = _token_product_productType.Presale) === null || _token_product_productType_Presale === void 0 ? void 0 : (_token_product_productType_Presale_Token = _token_product_productType_Presale.Token) === null || _token_product_productType_Presale_Token === void 0 ? void 0 : _token_product_productType_Presale_Token.decimals).toString());
    };
    var setFiatAmountFromTokenAmount = function(tokenAmount) {
        var price = token.product.price * priceMultiplier;
        setFiatAmount((0, $lFPa6.round)(Number(tokenAmount) * price, 2).toString());
    };
    var updateIntervals = function() {
        var _presaleData_tokenPresaleData;
        var _ref = (_presaleData_tokenPresaleData = presaleData === null || presaleData === void 0 ? void 0 : presaleData.tokenPresaleData) !== null && _presaleData_tokenPresaleData !== void 0 ? _presaleData_tokenPresaleData : {}, startsAt = _ref.startsAt, endsAt = _ref.endsAt, pricingStrategies = _ref.pricingStrategies;
        setStartsAt(startsAt ? new Date(startsAt) : undefined);
        setEndsAt(endsAt ? new Date(endsAt) : undefined);
        setNextPriceIncreaseAt(undefined);
        setPriceMultiplier(1);
        if (pricingStrategies) {
            var timeBased = pricingStrategies.timeBased;
            if (timeBased) {
                var startsAt1 = timeBased.startsAt, roundDurationSeconds = timeBased.roundDurationSeconds, priceIncreasePercentage = timeBased.priceIncreasePercentage;
                var roundDuration = roundDurationSeconds * 1000 || 1000;
                var start = new Date(startsAt1).getTime();
                var now = new Date().getTime();
                var nextIncreaseAt;
                if (start > now) nextIncreaseAt = start + roundDuration;
                else {
                    nextIncreaseAt = start + Math.ceil((now - start) / roundDuration) * roundDuration;
                    var multipliers = Math.floor((now - start) / roundDuration);
                    var percentIncrease = 1 + multipliers * priceIncreasePercentage;
                    setPriceMultiplier(percentIncrease);
                }
                setNextPriceIncreaseAt((0, $9ec7c0f63fa73321$export$2e2bcd8739ae039)({
                    start: new Date(),
                    end: new Date(nextIncreaseAt)
                }));
            }
        }
    };
    (0, $1Mpn7.useEffect)(function() {
        var _props_checkoutData_customizations;
        setCustomizations((_props_checkoutData_customizations = props.checkoutData.customizations) !== null && _props_checkoutData_customizations !== void 0 ? _props_checkoutData_customizations : customizations);
        var interval = setInterval(function() {
            return updateIntervals();
        }, 1000);
        updateIntervals();
        return function() {
            return clearInterval(interval);
        };
    }, [
        props.checkoutData
    ]);
    (0, $1Mpn7.useEffect)(function() {
        setErrorMessage(props.errorMessage);
    }, [
        props.errorMessage
    ]);
    var _useState9 = (0, $cv9Rk._)((0, $1Mpn7.useState)(""), 2), managedPaymentQrCode = _useState9[0], setManagedPaymentQrCode = _useState9[1];
    var generateManagedPaymentQrCode = function() {
        var _ref = (0, $kSuI9._)(function() {
            var darkColor, lightColor, _ref, qrCodeData;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!props.managedPaymentDetails) return [
                            2
                        ];
                        darkColor = (0, $923ed4f38e3f62e1$export$8121a4101142837f)(customizations.leftPanelColor, "#00000000", "#ffffff00");
                        lightColor = (0, $923ed4f38e3f62e1$export$8121a4101142837f)(customizations.primaryButtonColor, "#000000", "#000000");
                        return [
                            4,
                            (0, $c52b579c7e92ba59$export$45312203e6f4f22c)(props.managedPaymentDetails, lightColor, darkColor, true)
                        ];
                    case 1:
                        _ref = (0, $cv9Rk._).apply(void 0, [
                            _state.sent(),
                            1
                        ]), qrCodeData = _ref[0];
                        setManagedPaymentQrCode(qrCodeData);
                        return [
                            2
                        ];
                }
            });
        });
        return function generateManagedPaymentQrCode() {
            return _ref.apply(this, arguments);
        };
    }();
    var _useState10 = (0, $cv9Rk._)((0, $1Mpn7.useState)(), 2), errorMessage = _useState10[0], setErrorMessage = _useState10[1];
    var disconnect = (0, $d33bf83e1f82b118$export$83bebf2fe7fead4e)().disconnect;
    var _useAccount = (0, $11433db317972ee3$export$83a8e409853da004)(), address = _useAccount.address, isConnected = _useAccount.isConnected, connector = _useAccount.connector;
    var open = (0, $45f90ff27c2fb8ce$export$69804ca079d47f29)().open;
    var _useState11 = (0, $cv9Rk._)((0, $1Mpn7.useState)(false), 2), isWalletLoading = _useState11[0], setIsWalletLoading = _useState11[1];
    var onClickOpenWallet = function() {
        var _ref = (0, $kSuI9._)(function() {
            var _, chain, provider, signer, chainId, publicClient, contract, balance, decimals, parsedAmount, publicClient1, balance1, err, err1;
            return (0, $eha6O.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!props.managedPaymentDetails) return [
                            2
                        ];
                        _ = props.managedPaymentDetails.network;
                        switch(_){
                            case "Bitcoin":
                                return [
                                    3,
                                    1
                                ];
                            case "Solana":
                                return [
                                    3,
                                    1
                                ];
                            case "Zcash":
                                return [
                                    3,
                                    1
                                ];
                            case "ZcashTestnet":
                                return [
                                    3,
                                    1
                                ];
                            case "Ethereum":
                                return [
                                    3,
                                    2
                                ];
                            case "SepoliaTestnet":
                                return [
                                    3,
                                    2
                                ];
                            case "Polygon":
                                return [
                                    3,
                                    2
                                ];
                            case "PolygonTestnet":
                                return [
                                    3,
                                    2
                                ];
                            case "BNB":
                                return [
                                    3,
                                    2
                                ];
                            case "BNBTestnet":
                                return [
                                    3,
                                    2
                                ];
                            case "Base":
                                return [
                                    3,
                                    2
                                ];
                            case "Arbitrum":
                                return [
                                    3,
                                    2
                                ];
                            case "Avalanche":
                                return [
                                    3,
                                    2
                                ];
                        }
                        return [
                            3,
                            21
                        ];
                    case 1:
                        return [
                            3,
                            22
                        ];
                    case 2:
                        _state.trys.push([
                            2,
                            19,
                            ,
                            20
                        ]);
                        setErrorMessage("");
                        if (!!address) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            open()
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                    case 4:
                        if (!selectedMethod) return [
                            2
                        ];
                        setIsWalletLoading(true);
                        chain = (0, $7228c3dac31e12e0$export$cc4208a8ebc9f985)[props.managedPaymentDetails.network];
                        return [
                            4,
                            connector === null || connector === void 0 ? void 0 : connector.getProvider()
                        ];
                    case 5:
                        provider = _state.sent();
                        signer = (0, $d3530e20f4bd5211$export$362b8ea2edbd9090)({
                            chain: chain,
                            transport: (0, $ee1926b8332bb274$export$4c00f665f0d4b443)(provider)
                        });
                        if (!(connector === null || connector === void 0 ? void 0 : connector.switchChain)) return [
                            3,
                            8
                        ];
                        return [
                            4,
                            connector.getChainId()
                        ];
                    case 6:
                        chainId = _state.sent();
                        if (!(chainId !== chain.id)) return [
                            3,
                            8
                        ];
                        return [
                            4,
                            connector === null || connector === void 0 ? void 0 : connector.switchChain({
                                chainId: chain.id
                            })
                        ];
                    case 7:
                        _state.sent();
                        _state.label = 8;
                    case 8:
                        if (!props.managedPaymentDetails.token) return [
                            3,
                            12
                        ];
                        publicClient = (0, $a598c2a734c32a1f$export$d8e090d8c6a7a6ad)({
                            chain: chain,
                            transport: (0, $8b7fc1077ff96d68$export$7d6f1c8842f9f527)()
                        });
                        contract = (0, $67aa6ee4e548d91c$export$f518c38144e1f9d)({
                            address: props.managedPaymentDetails.token,
                            abi: (0, $9ClpR.erc20Abi),
                            client: {
                                public: publicClient,
                                wallet: signer
                            }
                        });
                        return [
                            4,
                            contract.read.balanceOf([
                                address
                            ])
                        ];
                    case 9:
                        balance = _state.sent();
                        return [
                            4,
                            contract.read.decimals()
                        ];
                    case 10:
                        decimals = _state.sent();
                        parsedAmount = (0, $5e268930465d8d42$export$203ae30b4f6490b3)(props.managedPaymentDetails.amount.toString(), decimals);
                        if (balance < parsedAmount) {
                            setIsWalletLoading(false);
                            return [
                                2,
                                setErrorMessage("Your wallet does not have enough ".concat((0, $7228c3dac31e12e0$export$8793fab959da70d1)(selectedMethod.network, selectedMethod.token).name, " for payment."))
                            ];
                        }
                        return [
                            4,
                            contract.write.transfer([
                                props.managedPaymentDetails.paymentAddress,
                                (0, $5e268930465d8d42$export$203ae30b4f6490b3)(props.managedPaymentDetails.amount, decimals)
                            ], {
                                account: address,
                                chain: chain
                            })
                        ];
                    case 11:
                        _state.sent();
                        return [
                            3,
                            18
                        ];
                    case 12:
                        publicClient1 = (0, $a598c2a734c32a1f$export$d8e090d8c6a7a6ad)({
                            chain: chain,
                            transport: (0, $8b7fc1077ff96d68$export$7d6f1c8842f9f527)()
                        });
                        _state.label = 13;
                    case 13:
                        _state.trys.push([
                            13,
                            15,
                            ,
                            16
                        ]);
                        return [
                            4,
                            publicClient1.getBalance({
                                address: address
                            })
                        ];
                    case 14:
                        balance1 = _state.sent();
                        if (balance1 < (0, $b1e23f0d09f654a9$export$642c4e67bbdc0bc7)(props.managedPaymentDetails.amount)) {
                            setIsWalletLoading(false);
                            return [
                                2,
                                setErrorMessage("Your wallet does not have enough ether for payment.")
                            ];
                        }
                        return [
                            3,
                            16
                        ];
                    case 15:
                        err = _state.sent();
                        return [
                            3,
                            16
                        ];
                    case 16:
                        if (!signer) return [
                            2
                        ];
                        return [
                            4,
                            signer.sendTransaction({
                                account: address,
                                chain: chain,
                                to: props.managedPaymentDetails.paymentAddress,
                                value: (0, $b1e23f0d09f654a9$export$642c4e67bbdc0bc7)(props.managedPaymentDetails.amount)
                            })
                        ];
                    case 17:
                        _state.sent();
                        setIsWalletLoading(false);
                        _state.label = 18;
                    case 18:
                        return [
                            3,
                            20
                        ];
                    case 19:
                        err1 = _state.sent();
                        setIsWalletLoading(false);
                        // setErrorMessage('Failed to open wallet. Please ensure you have enough funds.')
                        console.error(err1);
                        return [
                            3,
                            20
                        ];
                    case 20:
                        return [
                            3,
                            22
                        ];
                    case 21:
                        console.error("No wallet");
                        _state.label = 22;
                    case 22:
                        return [
                            2
                        ];
                }
            });
        });
        return function onClickOpenWallet() {
            return _ref.apply(this, arguments);
        };
    }();
    (0, $1Mpn7.useEffect)(function() {
        if (props.managedPaymentDetails) generateManagedPaymentQrCode();
    }, [
        props.managedPaymentDetails
    ]);
    var _presaleData_tokenPresaleData_customizations_titleFontSize, _presaleData_tokenPresaleData_customizations_title, _presaleData_tokenPresaleData_totalAmountRaised, _presaleData_tokenPresaleData_totalAmountRaised1, _presaleData_tokenPresaleData_minimumPurchaseAmount, _presaleData_tokenPresaleData_minimumPurchaseAmount1;
    return /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
        style: {
            fontSize: 0
        },
        children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
            style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 14,
                fontFamily: "Roboto, sans-serif",
                minHeight: "100%"
            },
            children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                style: {
                    width: 450,
                    minHeight: 550,
                    maxWidth: "100%",
                    background: customizations.leftPanelColor,
                    padding: 30,
                    borderRadius: 25,
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",
                    overflow: "hidden"
                },
                children: [
                    (props.paymentStatus ? Number(props.paymentStatus.amountRemaining) > 0 : true) && props.managedPaymentDetails && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)($fd3ee3fc842ae846$var$WaveContainer, {
                        style: {
                            zIndex: 0,
                            pointerEvents: "none",
                            opacity: 0.15
                        },
                        children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)($fd3ee3fc842ae846$var$Wave, {
                            style: {
                                top: 150
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            marginBottom: 30,
                            textAlign: "center",
                            zIndex: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                style: {
                                    fontSize: Number((_presaleData_tokenPresaleData_customizations_titleFontSize = presaleData === null || presaleData === void 0 ? void 0 : (_presaleData_tokenPresaleData = presaleData.tokenPresaleData) === null || _presaleData_tokenPresaleData === void 0 ? void 0 : (_presaleData_tokenPresaleData_customizations = _presaleData_tokenPresaleData.customizations) === null || _presaleData_tokenPresaleData_customizations === void 0 ? void 0 : _presaleData_tokenPresaleData_customizations.titleFontSize) !== null && _presaleData_tokenPresaleData_customizations_titleFontSize !== void 0 ? _presaleData_tokenPresaleData_customizations_titleFontSize : 46),
                                    fontWeight: 800,
                                    color: titleTextColor
                                },
                                children: (_presaleData_tokenPresaleData_customizations_title = presaleData === null || presaleData === void 0 ? void 0 : (_presaleData_tokenPresaleData1 = presaleData.tokenPresaleData) === null || _presaleData_tokenPresaleData1 === void 0 ? void 0 : (_presaleData_tokenPresaleData_customizations1 = _presaleData_tokenPresaleData1.customizations) === null || _presaleData_tokenPresaleData_customizations1 === void 0 ? void 0 : _presaleData_tokenPresaleData_customizations1.title) !== null && _presaleData_tokenPresaleData_customizations_title !== void 0 ? _presaleData_tokenPresaleData_customizations_title : "BUY $".concat((_token_product_productType = token.product.productType) === null || _token_product_productType === void 0 ? void 0 : (_token_product_productType_Presale = _token_product_productType.Presale) === null || _token_product_productType_Presale === void 0 ? void 0 : (_token_product_productType_Presale_Token = _token_product_productType_Presale.Token) === null || _token_product_productType_Presale_Token === void 0 ? void 0 : _token_product_productType_Presale_Token.ticker)
                            }),
                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("span", {
                                style: {
                                    color: textColor
                                },
                                children: [
                                    "1 ",
                                    (_token_product_productType1 = token.product.productType) === null || _token_product_productType1 === void 0 ? void 0 : (_token_product_productType_Presale1 = _token_product_productType1.Presale) === null || _token_product_productType_Presale1 === void 0 ? void 0 : (_token_product_productType_Presale_Token1 = _token_product_productType_Presale1.Token) === null || _token_product_productType_Presale_Token1 === void 0 ? void 0 : _token_product_productType_Presale_Token1.ticker,
                                    " = ",
                                    (0, $256101bd45fddc91$export$3dc27271f5d5c629)(token.product.currency, token.product.price * priceMultiplier, 10)
                                ]
                            })
                        ]
                    }),
                    state === 0 && !nextPriceIncreaseAt && endsAt && endsAt.getTime() > new Date().getTime() && (!startsAt || startsAt && startsAt.getTime() < new Date().getTime()) && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "center",
                            width: "100%",
                            marginBottom: 30
                        },
                        children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
                            style: {
                                padding: "10px 20px",
                                color: darkTextColor,
                                backgroundColor: lightTextColor,
                                borderRadius: 10
                            },
                            children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("span", {
                                children: [
                                    "Presale ends in ",
                                    (0, $ce7f80eccea34e5e$export$2e2bcd8739ae039)(endsAt)
                                ]
                            })
                        })
                    }),
                    state === 0 && nextPriceIncreaseAt && (!endsAt || endsAt && endsAt.getTime() > new Date().getTime()) && (!startsAt || startsAt && startsAt.getTime() < new Date().getTime()) && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            marginBottom: 30,
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                                alignItems: "center",
                                borderRadius: 10,
                                gap: 10
                            },
                            children: [
                                /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                    style: {
                                        fontSize: 14,
                                        color: titleTextColor
                                    },
                                    children: "Next price increase in"
                                }),
                                /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        flexDirection: "column",
                                        width: "100%",
                                        alignItems: "center",
                                        border: "1px solid ".concat(mediumTextColor),
                                        borderRadius: 10,
                                        overflow: "hidden"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
                                            style: {
                                                alignItems: "center",
                                                display: "grid",
                                                gridTemplateColumns: "repeat(4, 1fr)",
                                                width: "100%",
                                                padding: 15
                                            },
                                            children: [
                                                "days",
                                                "hours",
                                                "minutes",
                                                "seconds"
                                            ].map(function(t) {
                                                return /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)($fd3ee3fc842ae846$var$TimeInnerContainer, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                                            style: {
                                                                textTransform: "uppercase",
                                                                color: darkTextColor,
                                                                fontSize: 10
                                                            },
                                                            children: (0, $lFPa6.startCase)(t)
                                                        }),
                                                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                                            style: {
                                                                color: titleTextColor,
                                                                fontSize: 18
                                                            },
                                                            children: nextPriceIncreaseAt[t]
                                                        })
                                                    ]
                                                }, t);
                                            })
                                        }),
                                        endsAt && endsAt.getTime() > new Date().getTime() && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                            style: {
                                                color: darkTextColor,
                                                fontSize: 12,
                                                textAlign: "center",
                                                backgroundColor: lightTextColor,
                                                width: "100%",
                                                padding: 3
                                            },
                                            children: [
                                                "Presale ends in ",
                                                (0, $ce7f80eccea34e5e$export$2e2bcd8739ae039)(endsAt)
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    (props.paymentStatus ? Number(props.paymentStatus.amountRemaining) > 0 : true) && props.managedPaymentDetails && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)($fd3ee3fc842ae846$var$Wrapper, {
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            flexGrow: 1,
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 30
                        },
                        children: [
                            ((_props_paymentStatus = props.paymentStatus) === null || _props_paymentStatus === void 0 ? void 0 : _props_paymentStatus.status) !== "expired" && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)($fd3ee3fc842ae846$var$QRCodeWrapper, {
                                style: {
                                    boxShadow: "initial"
                                },
                                children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)($fd3ee3fc842ae846$var$QRCodeWrapperInner, {
                                    style: {
                                        border: "1px solid",
                                        borderColor: textColor,
                                        background: "white",
                                        borderRadius: 10,
                                        width: 168,
                                        height: 168,
                                        position: "relative",
                                        overflow: "hidden",
                                        padding: 3
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
                                            style: {
                                                width: "100%",
                                                height: "100%",
                                                position: "absolute",
                                                opacity: 0.15,
                                                zIndex: 0,
                                                left: 0,
                                                top: 0
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("img", {
                                            src: managedPaymentQrCode,
                                            style: {
                                                width: 160,
                                                height: 160,
                                                position: "relative",
                                                zIndex: 1
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    rowGap: 20,
                                    columnGap: 30,
                                    flexWrap: "wrap",
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            fontSize: 12,
                                            gap: 3
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 5
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                                        style: {
                                                            opacity: 0.5,
                                                            textTransform: "uppercase",
                                                            color: darkTextColor
                                                        },
                                                        children: "Amount due"
                                                    }),
                                                    ((_props_paymentStatus1 = props.paymentStatus) === null || _props_paymentStatus1 === void 0 ? void 0 : _props_paymentStatus1.status) !== "expired" && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)($fd3ee3fc842ae846$var$CopyButton, {
                                                        style: {
                                                            background: lightTextColor,
                                                            color: textColor
                                                        },
                                                        iconColor: textColor,
                                                        onClick: /*#__PURE__*/ (0, $kSuI9._)(function() {
                                                            var _props_managedPaymentDetails;
                                                            return (0, $eha6O.__generator)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        return [
                                                                            4,
                                                                            navigator.clipboard.writeText((0, $923ed4f38e3f62e1$export$f5dd818bff069720)((_props_managedPaymentDetails = props.managedPaymentDetails) === null || _props_managedPaymentDetails === void 0 ? void 0 : _props_managedPaymentDetails.amount, {
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 18
                                                                            }))
                                                                        ];
                                                                    case 1:
                                                                        return [
                                                                            2,
                                                                            _state.sent()
                                                                        ];
                                                                }
                                                            });
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                                style: {
                                                    fontSize: 16,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 5,
                                                    fontWeight: 300,
                                                    color: titleTextColor
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("img", {
                                                        src: (0, $7228c3dac31e12e0$export$8793fab959da70d1)(props.managedPaymentDetails.network, props.managedPaymentDetails.token).logo,
                                                        style: {
                                                            height: 20,
                                                            width: "auto"
                                                        }
                                                    }),
                                                    (0, $923ed4f38e3f62e1$export$f5dd818bff069720)(props.managedPaymentDetails.amount, {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 18
                                                    }),
                                                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                                        style: {
                                                            opacity: 0.5,
                                                            fontWeight: 100
                                                        },
                                                        children: (0, $7228c3dac31e12e0$export$8793fab959da70d1)(props.managedPaymentDetails.network, props.managedPaymentDetails.token).ticker
                                                    }),
                                                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("span", {
                                                        children: [
                                                            "on ",
                                                            selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.network
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            fontSize: 12,
                                            gap: 3,
                                            alignItems: "start"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                                style: {
                                                    opacity: 0.5,
                                                    textTransform: "uppercase",
                                                    textAlign: "center",
                                                    color: darkTextColor
                                                },
                                                children: "Time remaining"
                                            }),
                                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                                style: {
                                                    fontSize: 16,
                                                    fontWeight: 100,
                                                    textAlign: "center",
                                                    color: titleTextColor
                                                },
                                                children: $fd3ee3fc842ae846$var$formatSecondsToMinutesAndSecondsString((new Date(props.managedPaymentDetails.expiresAt).getTime() - new Date().getTime()) / 1000)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            fontSize: 12,
                                            gap: 3
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 5
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                                        style: {
                                                            opacity: 0.5,
                                                            textTransform: "uppercase",
                                                            color: darkTextColor
                                                        },
                                                        children: "Payment address"
                                                    }),
                                                    ((_props_paymentStatus2 = props.paymentStatus) === null || _props_paymentStatus2 === void 0 ? void 0 : _props_paymentStatus2.status) !== "expired" && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)($fd3ee3fc842ae846$var$CopyButton, {
                                                        style: {
                                                            background: lightTextColor,
                                                            color: textColor
                                                        },
                                                        iconColor: textColor,
                                                        onClick: /*#__PURE__*/ (0, $kSuI9._)(function() {
                                                            var _props_managedPaymentDetails, _props_managedPaymentDetails_paymentAddress;
                                                            return (0, $eha6O.__generator)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        return [
                                                                            4,
                                                                            navigator.clipboard.writeText((_props_managedPaymentDetails_paymentAddress = (_props_managedPaymentDetails = props.managedPaymentDetails) === null || _props_managedPaymentDetails === void 0 ? void 0 : _props_managedPaymentDetails.paymentAddress) !== null && _props_managedPaymentDetails_paymentAddress !== void 0 ? _props_managedPaymentDetails_paymentAddress : "")
                                                                        ];
                                                                    case 1:
                                                                        return [
                                                                            2,
                                                                            _state.sent()
                                                                        ];
                                                                }
                                                            });
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                                style: {
                                                    fontSize: 16,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 2,
                                                    fontWeight: 100,
                                                    color: titleTextColor,
                                                    overflowWrap: "anywhere",
                                                    textAlign: "left"
                                                },
                                                children: ((_props_paymentStatus3 = props.paymentStatus) === null || _props_paymentStatus3 === void 0 ? void 0 : _props_paymentStatus3.status) === "expired" ? "Expired" : props.managedPaymentDetails.paymentAddress
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "column",
                                    width: "100%",
                                    backgroundColor: address ? lightTextColor : "initial",
                                    borderBottomLeftRadius: 25,
                                    borderBottomRightRadius: 25,
                                    borderTopLeftRadius: 5,
                                    borderTopRightRadius: 5
                                },
                                children: [
                                    selectedMethod && !(0, $7228c3dac31e12e0$export$8793fab959da70d1)(selectedMethod.network, selectedMethod.token).isSolana && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)((0, $78b37e1ff5a5ba28$exports.Fragment), {
                                        children: [
                                            address && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    padding: 10
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                                        style: {
                                                            color: darkTextColor,
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: 5
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                                                style: {
                                                                    textTransform: "uppercase",
                                                                    fontSize: 10
                                                                },
                                                                children: "Connected wallet"
                                                            }),
                                                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                                                children: (0, $923ed4f38e3f62e1$export$193698062786be9a)(address, 10)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $913546acae8c9187$export$f861551692d63a2e), {
                                                        disabled: isWalletLoading,
                                                        onClick: function() {
                                                            return disconnect();
                                                        },
                                                        style: {
                                                            padding: 0,
                                                            border: 0,
                                                            color: titleTextColor,
                                                            textTransform: "uppercase",
                                                            fontSize: 10
                                                        },
                                                        children: "Disconnect"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $913546acae8c9187$export$ac16a6a04d9b7c84), {
                                                onClick: onClickOpenWallet,
                                                isLoading: isWalletLoading,
                                                spinnerColor: buttonTextColor,
                                                style: {
                                                    background: customizations.primaryButtonColor,
                                                    color: buttonTextColor,
                                                    width: "100%"
                                                },
                                                children: isConnected ? "Open wallet" : "Connect wallet"
                                            })
                                        ]
                                    }),
                                    selectedMethod && (0, $7228c3dac31e12e0$export$8793fab959da70d1)(selectedMethod.network, selectedMethod.token).isSolana && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $e3dbb0794ed8bfa2$export$2e2bcd8739ae039), {
                                        managedPaymentDetails: props.managedPaymentDetails,
                                        isLoading: isWalletLoading,
                                        setIsLoading: setIsWalletLoading,
                                        primaryButtonColor: (_props_checkoutData_customizations = props.checkoutData.customizations) === null || _props_checkoutData_customizations === void 0 ? void 0 : _props_checkoutData_customizations.primaryButtonColor,
                                        presaleStyling: {
                                            titleTextColor: titleTextColor,
                                            darkTextColor: darkTextColor,
                                            buttonTextColor: buttonTextColor
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    ((_props_paymentStatus4 = props.paymentStatus) === null || _props_paymentStatus4 === void 0 ? void 0 : _props_paymentStatus4.status) === "expired" && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexGrow: 1,
                            flexDirection: "column",
                            gap: 5
                        },
                        children: [
                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                style: {
                                    fontSize: 18,
                                    color: titleTextColor
                                },
                                children: "Payment expired"
                            }),
                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                style: {
                                    color: darkTextColor,
                                    textAlign: "center",
                                    marginBottom: 20
                                },
                                children: "The payment timer has expired."
                            }),
                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $913546acae8c9187$export$ac16a6a04d9b7c84), {
                                onClick: function() {
                                    return window.location.reload();
                                },
                                isLoading: props.isPreProcessingPayment,
                                style: {
                                    background: customizations.primaryButtonColor,
                                    color: buttonTextColor,
                                    width: "100%"
                                },
                                children: "Refresh"
                            })
                        ]
                    }),
                    Number((_props_paymentStatus5 = props.paymentStatus) === null || _props_paymentStatus5 === void 0 ? void 0 : _props_paymentStatus5.amountRemaining) <= 0 && ((_props_paymentStatus6 = props.paymentStatus) === null || _props_paymentStatus6 === void 0 ? void 0 : _props_paymentStatus6.status) !== "expired" && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
                        style: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexGrow: 1
                        },
                        children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "column",
                                gap: 30,
                                width: "100%",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 10,
                                        flexDirection: "column"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $52cd8b1dce1374e7$export$763817fece9a8c9d), {
                                            style: {
                                                background: customizations.primaryButtonColor,
                                                width: 45,
                                                height: 45
                                            },
                                            children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $1fba025245cbd847$export$2e2bcd8739ae039), {
                                                animationDelay: "0.5s",
                                                animationSpeed: "0.75s",
                                                stroke: buttonTextColor
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                            style: {
                                                fontSize: 18,
                                                color: titleTextColor
                                            },
                                            children: "Payment successful"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                    style: {
                                        display: "grid",
                                        gridTemplateColumns: "repeat(2, auto)",
                                        rowGap: 10,
                                        columnGap: 20,
                                        width: "100%",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        border: "1px solid",
                                        borderColor: lightTextColor,
                                        borderRadius: 25,
                                        padding: 20
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                            style: {
                                                color: textColor
                                            },
                                            children: "Order ID"
                                        }),
                                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
                                            style: {
                                                display: "flex",
                                                gap: 5,
                                                alignItems: "center",
                                                color: titleTextColor
                                            },
                                            children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                                children: (_props_order = props.order) === null || _props_order === void 0 ? void 0 : _props_order.id
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
                                            style: {
                                                gridColumn: "span 2",
                                                borderBottom: "1px solid",
                                                margin: "5px 0",
                                                borderColor: textColor,
                                                opacity: 0.25
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                            style: {
                                                color: textColor
                                            },
                                            children: "Tokens purchased"
                                        }),
                                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                gap: 5,
                                                alignItems: "center",
                                                color: titleTextColor
                                            },
                                            children: [
                                                token.product.imageUrl && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)($fd3ee3fc842ae846$var$TokenIcon, {
                                                    imageUrl: token.product.imageUrl
                                                }),
                                                /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                                    children: tokenAmount
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
                                            style: {
                                                gridColumn: "span 2",
                                                borderBottom: "1px solid",
                                                margin: "5px 0",
                                                borderColor: textColor,
                                                opacity: 0.25
                                            }
                                        }),
                                        (_props_checkoutData_inputFields = props.checkoutData.inputFields) === null || _props_checkoutData_inputFields === void 0 ? void 0 : _props_checkoutData_inputFields.map(function(iF, i) {
                                            return /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)((0, $78b37e1ff5a5ba28$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                                        style: {
                                                            color: textColor
                                                        },
                                                        children: iF.inputLabel
                                                    }),
                                                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                                        style: {
                                                            color: titleTextColor,
                                                            textOverflow: "ellipsis",
                                                            overflow: "auto"
                                                        },
                                                        children: iF.value
                                                    }),
                                                    props.checkoutData.inputFields && i < props.checkoutData.inputFields.length - 1 && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
                                                        style: {
                                                            gridColumn: "span 2",
                                                            borderBottom: "1px solid",
                                                            borderColor: textColor,
                                                            opacity: 0.25
                                                        }
                                                    })
                                                ]
                                            });
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    !props.managedPaymentDetails && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)((0, $78b37e1ff5a5ba28$exports.Fragment), {
                        children: [
                            state === 1 && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)($fd3ee3fc842ae846$var$Wrapper, {
                                style: {
                                    display: "flex",
                                    flexGrow: 1,
                                    overflow: "scroll",
                                    border: "1px solid ".concat(lightTextColor),
                                    borderRadius: 15,
                                    maxHeight: 340
                                },
                                children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
                                    style: {
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 8,
                                        width: "100%",
                                        height: "fit-content",
                                        padding: 10
                                    },
                                    children: (_props_checkoutData_gateway_managed2 = props.checkoutData.gateway.managed) === null || _props_checkoutData_gateway_managed2 === void 0 ? void 0 : _props_checkoutData_gateway_managed2.methods.map(function(method, i) {
                                        var m = (0, $7228c3dac31e12e0$export$8793fab959da70d1)(method.network, method.token);
                                        return /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)((0, $913546acae8c9187$export$ac16a6a04d9b7c84), {
                                            onClick: function() {
                                                setSelectedPaymentMethod(method);
                                                setState(0);
                                            },
                                            style: {
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "left",
                                                gap: 5,
                                                background: lightTextColor,
                                                padding: 15,
                                                borderRadius: 15,
                                                fontSize: 14
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
                                                    style: {
                                                        width: 20,
                                                        height: 20,
                                                        backgroundImage: "url(".concat(m.logo, ")"),
                                                        backgroundSize: "contain",
                                                        backgroundPosition: "center",
                                                        backgroundRepeat: "no-repeat",
                                                        position: "relative"
                                                    },
                                                    children: m.tokenInfo && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
                                                        style: {
                                                            background: "rgba(255, 255, 255, 0.95)",
                                                            borderRadius: "100%",
                                                            width: 12,
                                                            height: 12,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            position: "absolute",
                                                            bottom: -1,
                                                            right: -5,
                                                            boxShadow: "0 0 1px"
                                                        },
                                                        children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
                                                            style: {
                                                                width: 8,
                                                                height: 8,
                                                                backgroundImage: "url(".concat(m.tokenInfo.logo, ")"),
                                                                backgroundSize: "contain",
                                                                backgroundPosition: "center",
                                                                backgroundRepeat: "no-repeat"
                                                            }
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                                    style: {
                                                        color: titleTextColor
                                                    },
                                                    children: m.tokenInfo ? "".concat(m.name, " on ").concat(m.tokenInfo.networkName) : m.name
                                                })
                                            ]
                                        }, i);
                                    })
                                })
                            }),
                            state === 0 && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $78b37e1ff5a5ba28$exports.Fragment), {
                                children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)($fd3ee3fc842ae846$var$Wrapper, {
                                    style: {
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 15,
                                        justifyContent: "center"
                                    },
                                    children: [
                                        (presaleData === null || presaleData === void 0 ? void 0 : (_presaleData_tokenPresaleData2 = presaleData.tokenPresaleData) === null || _presaleData_tokenPresaleData2 === void 0 ? void 0 : _presaleData_tokenPresaleData2.totalRaiseAmount) && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                gap: 10,
                                                flexDirection: "column",
                                                marginBottom: 10
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
                                                    style: {
                                                        width: "100%",
                                                        background: lightTextColor,
                                                        height: 15,
                                                        borderRadius: 25,
                                                        overflow: "hidden"
                                                    },
                                                    children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
                                                        style: {
                                                            width: "".concat(Number((_presaleData_tokenPresaleData_totalAmountRaised = presaleData === null || presaleData === void 0 ? void 0 : presaleData.tokenPresaleData.totalAmountRaised) !== null && _presaleData_tokenPresaleData_totalAmountRaised !== void 0 ? _presaleData_tokenPresaleData_totalAmountRaised : 0) / Number(presaleData === null || presaleData === void 0 ? void 0 : presaleData.tokenPresaleData.totalRaiseAmount) * 100, "%"),
                                                            height: "100%",
                                                            background: customizations.primaryButtonColor
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                                    style: {
                                                        textTransform: "uppercase",
                                                        fontSize: 12,
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        color: textColor,
                                                        fontWeight: 600
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("span", {
                                                            children: [
                                                                token.product.currency,
                                                                " raised"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("span", {
                                                            children: [
                                                                (0, $256101bd45fddc91$export$3dc27271f5d5c629)(token.product.currency, (_presaleData_tokenPresaleData_totalAmountRaised1 = presaleData === null || presaleData === void 0 ? void 0 : presaleData.tokenPresaleData.totalAmountRaised) !== null && _presaleData_tokenPresaleData_totalAmountRaised1 !== void 0 ? _presaleData_tokenPresaleData_totalAmountRaised1 : 0),
                                                                !(presaleData === null || presaleData === void 0 ? void 0 : (_presaleData_tokenPresaleData3 = presaleData.tokenPresaleData) === null || _presaleData_tokenPresaleData3 === void 0 ? void 0 : (_presaleData_tokenPresaleData_customizations2 = _presaleData_tokenPresaleData3.customizations) === null || _presaleData_tokenPresaleData_customizations2 === void 0 ? void 0 : _presaleData_tokenPresaleData_customizations2.hideTotalRaiseGoal) && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)((0, $78b37e1ff5a5ba28$exports.Fragment), {
                                                                    children: [
                                                                        "/ ",
                                                                        (0, $256101bd45fddc91$export$3dc27271f5d5c629)(token.product.currency, presaleData === null || presaleData === void 0 ? void 0 : presaleData.tokenPresaleData.totalRaiseAmount)
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                            style: {
                                                border: "1px solid ".concat(mediumTextColor),
                                                borderRadius: 15,
                                                padding: 15,
                                                color: textColor,
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                                    style: {
                                                        flexGrow: 1
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                                            style: {
                                                                display: "flex",
                                                                gap: 10,
                                                                alignItems: "center",
                                                                marginBottom: 10
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                                                    children: [
                                                                        "You pay (",
                                                                        token.product.currency,
                                                                        ")"
                                                                    ]
                                                                }),
                                                                fiatAmount && Number(fiatAmount) < Number((_presaleData_tokenPresaleData_minimumPurchaseAmount = presaleData === null || presaleData === void 0 ? void 0 : (_presaleData_tokenPresaleData4 = presaleData.tokenPresaleData) === null || _presaleData_tokenPresaleData4 === void 0 ? void 0 : _presaleData_tokenPresaleData4.minimumPurchaseAmount) !== null && _presaleData_tokenPresaleData_minimumPurchaseAmount !== void 0 ? _presaleData_tokenPresaleData_minimumPurchaseAmount : 0) && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                                                    style: {
                                                                        color: "red",
                                                                        textTransform: "uppercase",
                                                                        fontSize: 10
                                                                    },
                                                                    children: [
                                                                        "Min ",
                                                                        presaleData === null || presaleData === void 0 ? void 0 : (_presaleData_tokenPresaleData5 = presaleData.tokenPresaleData) === null || _presaleData_tokenPresaleData5 === void 0 ? void 0 : _presaleData_tokenPresaleData5.minimumPurchaseAmount
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $920900f9cf33bdcc$export$c86715117507e8e5), {
                                                            placeholder: (0, $256101bd45fddc91$export$bc56dd87ebd6aae2)(token.product.currency, fiatAmount ? Number(fiatAmount) : 0),
                                                            disabled: props.isPreProcessingPayment,
                                                            value: fiatAmount,
                                                            onChange: function(e) {
                                                                if (!isNaN(e.target.value)) {
                                                                    var amount = e.target.value;
                                                                    setFiatAmount(amount);
                                                                    setTokenAmountFromFiatAmount(amount);
                                                                }
                                                            },
                                                            placeholderColor: textColor,
                                                            style: {
                                                                border: 0,
                                                                boxShadow: "none",
                                                                padding: 0,
                                                                fontSize: 16,
                                                                background: "none",
                                                                color: titleTextColor
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $913546acae8c9187$export$ac16a6a04d9b7c84), {
                                                    onClick: function() {
                                                        return setState(1);
                                                    },
                                                    style: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 5,
                                                        background: lightTextColor,
                                                        padding: "5px 10px",
                                                        borderRadius: 15,
                                                        fontSize: 14
                                                    },
                                                    children: selectedMethod && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)((0, $78b37e1ff5a5ba28$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
                                                                style: {
                                                                    width: 20,
                                                                    height: 20,
                                                                    backgroundImage: "url(".concat((0, $7228c3dac31e12e0$export$8793fab959da70d1)(selectedMethod.network, selectedMethod.token).logo, ")"),
                                                                    backgroundSize: "contain",
                                                                    backgroundPosition: "center",
                                                                    backgroundRepeat: "no-repeat",
                                                                    position: "relative"
                                                                },
                                                                children: (0, $7228c3dac31e12e0$export$8793fab959da70d1)(selectedMethod.network, selectedMethod.token).tokenInfo && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
                                                                    style: {
                                                                        background: "rgba(255, 255, 255, 0.95)",
                                                                        borderRadius: "100%",
                                                                        width: 12,
                                                                        height: 12,
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        position: "absolute",
                                                                        bottom: -1,
                                                                        right: -5,
                                                                        boxShadow: "0 0 1px"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
                                                                        style: {
                                                                            width: 8,
                                                                            height: 8,
                                                                            backgroundImage: "url(".concat((_getMethod_tokenInfo = (0, $7228c3dac31e12e0$export$8793fab959da70d1)(selectedMethod.network, selectedMethod.token).tokenInfo) === null || _getMethod_tokenInfo === void 0 ? void 0 : _getMethod_tokenInfo.logo, ")"),
                                                                            backgroundSize: "contain",
                                                                            backgroundPosition: "center",
                                                                            backgroundRepeat: "no-repeat"
                                                                        }
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                                                style: {
                                                                    color: titleTextColor
                                                                },
                                                                children: (0, $7228c3dac31e12e0$export$8793fab959da70d1)(selectedMethod.network, selectedMethod.token).name
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                            style: {
                                                border: "1px solid ".concat(mediumTextColor),
                                                borderRadius: 15,
                                                padding: 15,
                                                color: textColor,
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                                    style: {
                                                        flexGrow: 1
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
                                                            style: {
                                                                marginBottom: 10
                                                            },
                                                            children: "You receive"
                                                        }),
                                                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $920900f9cf33bdcc$export$c86715117507e8e5), {
                                                            disabled: props.isPreProcessingPayment,
                                                            placeholder: "0",
                                                            value: tokenAmount,
                                                            onChange: function(e) {
                                                                if (!isNaN(e.target.value)) {
                                                                    var amount = e.target.value;
                                                                    setTokenAmount(amount);
                                                                    setFiatAmountFromTokenAmount(amount);
                                                                }
                                                            },
                                                            placeholderColor: textColor,
                                                            style: {
                                                                border: 0,
                                                                boxShadow: "none",
                                                                padding: 0,
                                                                fontSize: 16,
                                                                background: "none",
                                                                color: titleTextColor
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                                    style: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 5,
                                                        background: lightTextColor,
                                                        padding: "5px 10px",
                                                        borderRadius: 15
                                                    },
                                                    children: [
                                                        token.product.imageUrl && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)($fd3ee3fc842ae846$var$TokenIcon, {
                                                            imageUrl: token.product.imageUrl
                                                        }),
                                                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                                            style: {
                                                                color: titleTextColor
                                                            },
                                                            children: (_token_product_productType2 = token.product.productType) === null || _token_product_productType2 === void 0 ? void 0 : (_token_product_productType_Presale2 = _token_product_productType2.Presale) === null || _token_product_productType_Presale2 === void 0 ? void 0 : (_token_product_productType_Presale_Token2 = _token_product_productType_Presale2.Token) === null || _token_product_productType_Presale_Token2 === void 0 ? void 0 : _token_product_productType_Presale_Token2.ticker
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
                                            style: {
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                gap: 2
                                            },
                                            children: (0, $c6Xmf._)(new Set((_props_checkoutData_gateway_managed3 = props.checkoutData.gateway.managed) === null || _props_checkoutData_gateway_managed3 === void 0 ? void 0 : _props_checkoutData_gateway_managed3.methods.map(function(p) {
                                                return (0, $7228c3dac31e12e0$export$8793fab959da70d1)(p.network, p.token).logo;
                                            }))).map(function(p, i) {
                                                return /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("img", {
                                                    style: {
                                                        height: 20,
                                                        maxWidth: 20
                                                    },
                                                    src: p
                                                }, i);
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $913546acae8c9187$export$ac16a6a04d9b7c84), {
                                            disabled: Number(fiatAmount !== null && fiatAmount !== void 0 ? fiatAmount : 1) < Number((_presaleData_tokenPresaleData_minimumPurchaseAmount1 = presaleData === null || presaleData === void 0 ? void 0 : (_presaleData_tokenPresaleData6 = presaleData.tokenPresaleData) === null || _presaleData_tokenPresaleData6 === void 0 ? void 0 : _presaleData_tokenPresaleData6.minimumPurchaseAmount) !== null && _presaleData_tokenPresaleData_minimumPurchaseAmount1 !== void 0 ? _presaleData_tokenPresaleData_minimumPurchaseAmount1 : 0),
                                            onClick: function() {
                                                if (startsAt && startsAt.getTime() > new Date().getTime()) return;
                                                if (endsAt && endsAt.getTime() < new Date().getTime()) return;
                                                if (selectedMethod && tokenAmount) setState(2);
                                            },
                                            isLoading: props.isPreProcessingPayment,
                                            style: {
                                                background: customizations.primaryButtonColor,
                                                color: buttonTextColor
                                            },
                                            children: startsAt && startsAt.getTime() > new Date().getTime() ? /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    flexDirection: "column"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                                        children: "Presale starts in"
                                                    }),
                                                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                                        style: {
                                                            fontSize: 12,
                                                            opacity: 0.5
                                                        },
                                                        children: (0, $1d38928f289e87f2$export$2e2bcd8739ae039)((0, $9ec7c0f63fa73321$export$2e2bcd8739ae039)({
                                                            start: new Date(),
                                                            end: startsAt
                                                        }))
                                                    })
                                                ]
                                            }) : endsAt && endsAt.getTime() < new Date().getTime() ? "Presale has ended" : "Continue"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    !props.managedPaymentDetails && state === 2 && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)($fd3ee3fc842ae846$var$Wrapper, {
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            gap: 20
                        },
                        children: [
                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    columnGap: 40,
                                    rowGap: 20,
                                    flexWrap: "wrap"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                        style: {
                                            color: textColor,
                                            display: "flex",
                                            flexDirection: "column"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
                                                style: {
                                                    marginBottom: 10
                                                },
                                                children: "Token amount"
                                            }),
                                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    gap: 5,
                                                    alignItems: "center",
                                                    color: titleTextColor
                                                },
                                                children: [
                                                    token.product.imageUrl && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)($fd3ee3fc842ae846$var$TokenIcon, {
                                                        imageUrl: token.product.imageUrl
                                                    }),
                                                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                                        children: tokenAmount
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                        style: {
                                            color: textColor,
                                            display: "flex",
                                            flexDirection: "column"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
                                                style: {
                                                    marginBottom: 10
                                                },
                                                children: "Payment method"
                                            }),
                                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
                                                style: {
                                                    display: "flex",
                                                    gap: 5,
                                                    alignItems: "center",
                                                    color: titleTextColor
                                                },
                                                children: selectedMethod && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)((0, $78b37e1ff5a5ba28$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("img", {
                                                            style: {
                                                                height: 20,
                                                                maxWidth: 20
                                                            },
                                                            src: (0, $7228c3dac31e12e0$export$8793fab959da70d1)(selectedMethod.network, selectedMethod.token).logo
                                                        }),
                                                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                                            style: {
                                                                opacity: 0.75,
                                                                fontWeight: 100
                                                            },
                                                            children: (0, $7228c3dac31e12e0$export$8793fab959da70d1)(selectedMethod.network, selectedMethod.token).ticker
                                                        }),
                                                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("span", {
                                                            children: [
                                                                "on ",
                                                                selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.network
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (_props_checkoutData_inputFields1 = props.checkoutData.inputFields) === null || _props_checkoutData_inputFields1 === void 0 ? void 0 : _props_checkoutData_inputFields1.map(function(inputField, i) {
                                return /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
                                    style: {
                                        border: "1px solid ".concat(mediumTextColor),
                                        borderRadius: 15,
                                        padding: 15,
                                        color: textColor,
                                        display: "flex",
                                        alignItems: "center"
                                    },
                                    children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                        style: {
                                            flexGrow: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
                                                style: {
                                                    marginBottom: 10
                                                },
                                                children: inputField.inputLabel
                                            }),
                                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $920900f9cf33bdcc$export$c86715117507e8e5), {
                                                autoFocus: i === 0,
                                                disabled: props.isPreProcessingPayment,
                                                placeholder: "Enter ".concat(inputField.inputLabel.toLowerCase()),
                                                value: inputField.value,
                                                onChange: function(e) {
                                                    var _props_onInputFieldsChange;
                                                    if (!props.checkoutData.inputFields) return;
                                                    var target = e.target;
                                                    var val = target.value;
                                                    if (inputField.inputLabel === "Email address") val = val.toLowerCase();
                                                    var newInputs = props.checkoutData.inputFields.slice();
                                                    newInputs[i].value = val;
                                                    (_props_onInputFieldsChange = props.onInputFieldsChange) === null || _props_onInputFieldsChange === void 0 ? void 0 : _props_onInputFieldsChange.call(props, newInputs);
                                                },
                                                placeholderColor: textColor,
                                                style: {
                                                    border: 0,
                                                    boxShadow: "none",
                                                    padding: 0,
                                                    fontSize: 16,
                                                    background: "none",
                                                    color: titleTextColor
                                                }
                                            })
                                        ]
                                    })
                                }, i);
                            }),
                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
                                style: {
                                    display: "flex",
                                    flexGrow: 1
                                }
                            }),
                            errorMessage && /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    gap: 5,
                                    width: "100%",
                                    backgroundColor: "red",
                                    borderRadius: 5,
                                    padding: "10px 15px"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                        style: {
                                            color: "white",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 3,
                                            textTransform: "uppercase",
                                            opacity: 0.75,
                                            fontSize: 10
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $94a17a33d2bce04d$export$2e2bcd8739ae039), {
                                                style: {
                                                    height: 8,
                                                    width: 8
                                                },
                                                stroke: "white",
                                                strokeWidth: 2
                                            }),
                                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                                children: "Error"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
                                        style: {
                                            color: "white"
                                        },
                                        children: errorMessage
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    gap: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)((0, $913546acae8c9187$export$ac16a6a04d9b7c84), {
                                        onClick: function() {
                                            setErrorMessage(undefined);
                                            setState(0);
                                        },
                                        disabled: props.isPreProcessingPayment,
                                        spinnerColor: buttonTextColor,
                                        style: {
                                            background: lightTextColor,
                                            color: textColor,
                                            borderRadius: 25,
                                            borderTopRightRadius: 0,
                                            borderBottomRightRadius: 0,
                                            alignItems: "center",
                                            gap: 3
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $2f8224fb9ba3490a$export$65be7b63f510f362), {
                                                fill: textColor,
                                                style: {
                                                    transform: "rotate(90deg)",
                                                    height: 14,
                                                    width: 14,
                                                    marginTop: -2
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                                children: "Back"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $913546acae8c9187$export$ac16a6a04d9b7c84), {
                                        onClick: function() {
                                            if (selectedMethod && tokenAmount) props.onCheckout({
                                                selectedMethod: selectedMethod,
                                                tokenAmount: tokenAmount
                                            });
                                        },
                                        isLoading: props.isPreProcessingPayment,
                                        spinnerColor: buttonTextColor,
                                        style: {
                                            background: customizations.primaryButtonColor,
                                            color: buttonTextColor,
                                            flexGrow: 1,
                                            borderTopLeftRadius: 0,
                                            borderBottomLeftRadius: 0
                                        },
                                        children: "Continue"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "center",
                            width: "100%",
                            marginTop: 30
                        },
                        children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("a", {
                            href: "https://www.radom.com/crypto-presales",
                            target: "_blank",
                            title: "Crypto Presale Powered by Radom",
                            style: {
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: 2,
                                cursor: "pointer",
                                userSelect: "none",
                                textDecoration: "none",
                                color: textColor
                            },
                            rel: "noreferrer",
                            children: [
                                /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                    style: {
                                        fontSize: 8,
                                        fontWeight: 100,
                                        marginBottom: 2
                                    },
                                    children: "Crypto Presale"
                                }),
                                /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsxs)("span", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        fontSize: 14,
                                        fontWeight: 100
                                    },
                                    children: [
                                        "Powered by",
                                        /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $3eae42650b1c19fb$export$2e2bcd8739ae039), {
                                            width: 60,
                                            height: 14,
                                            fill: textColor
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("span", {
                                    style: {
                                        position: "absolute",
                                        width: "1px",
                                        height: "1px",
                                        margin: "-1px",
                                        padding: 0,
                                        overflow: "hidden",
                                        clip: "rect(0, 0, 0, 0)",
                                        border: 0
                                    },
                                    children: "Radom"
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}
var $fd3ee3fc842ae846$export$2e2bcd8739ae039 = $fd3ee3fc842ae846$var$Presale;



parcelRequire("1Mpn7");

var $j06k0 = parcelRequire("j06k0");

parcelRequire("1Mpn7");

function $0610e2f40b437f55$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0.5;\n  }\n"
    ]);
    $0610e2f40b437f55$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $0610e2f40b437f55$var$_templateObject1() {
    var data = (0, $j06k0._)([
        "\n  animation: ",
        " ",
        "s alternate infinite linear;\n  background-color: rgba(0, 0, 0, 0.1);\n  background: linear-gradient(-45deg, rgb(155 158 177 / 50%), rgb(155 158 177 / 30%));\n  border-radius: 5px;\n  width: 50px;\n  height: 20px;\n"
    ]);
    $0610e2f40b437f55$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var $0610e2f40b437f55$var$LoadingBarAnimation = (0, $f2ce4b3babf40f7e$export$d25ddfdf17c3ad3e)($0610e2f40b437f55$var$_templateObject());
var $0610e2f40b437f55$var$LoadingBarInner = (0, $f2ce4b3babf40f7e$export$2e2bcd8739ae039).div($0610e2f40b437f55$var$_templateObject1(), $0610e2f40b437f55$var$LoadingBarAnimation, function(param) {
    var animationSpeed = param.animationSpeed;
    return animationSpeed;
});
var $0610e2f40b437f55$var$LoadingBar = function(param) {
    var _param_animationSpeed = param.animationSpeed, animationSpeed = _param_animationSpeed === void 0 ? 0.5 : _param_animationSpeed, style = param.style;
    return /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)($0610e2f40b437f55$var$LoadingBarInner, {
        animationSpeed: animationSpeed,
        style: style
    });
};
var $0610e2f40b437f55$export$2e2bcd8739ae039 = $0610e2f40b437f55$var$LoadingBar;


function $b65f8652b851c11c$var$LoadingPresale() {
    return /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)("div", {
        style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 14,
            minHeight: "100%"
        },
        children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $0610e2f40b437f55$export$2e2bcd8739ae039), {
            style: {
                width: 450,
                minHeight: 550,
                maxWidth: "100%",
                padding: 30,
                borderRadius: 25,
                display: "flex",
                flexDirection: "column"
            }
        })
    });
}
var $b65f8652b851c11c$export$2e2bcd8739ae039 = $b65f8652b851c11c$var$LoadingPresale;


function $15bcfd03d6dd4dab$var$PresaleView(param) {
    var paymentLinkId = param.paymentLinkId;
    var _useState = (0, $cv9Rk._)((0, $1Mpn7.useState)(true), 2), isLoading = _useState[0], setIsLoading = _useState[1];
    var _useState1 = (0, $cv9Rk._)((0, $1Mpn7.useState)(), 2), paymentLinkData = _useState1[0], setPaymentLinkData = _useState1[1];
    var _useState2 = (0, $cv9Rk._)((0, $1Mpn7.useState)(false), 2), isPreProcessingPayment = _useState2[0], setIsPreProcessingPayment = _useState2[1];
    var _useState3 = (0, $cv9Rk._)((0, $1Mpn7.useState)(), 2), order = _useState3[0], setOrder = _useState3[1];
    var _useState4 = (0, $cv9Rk._)((0, $1Mpn7.useState)(), 2), managedPaymentDetails = _useState4[0], setManagedPaymentDetails = _useState4[1];
    var _useState5 = (0, $cv9Rk._)((0, $1Mpn7.useState)(), 2), paymentStatus = _useState5[0], setPaymentStatus = _useState5[1];
    var _useState6 = (0, $cv9Rk._)((0, $1Mpn7.useState)([]), 2), inputFields = _useState6[0], setInputFields = _useState6[1];
    var _useState7 = (0, $cv9Rk._)((0, $1Mpn7.useState)(), 2), errorMessage = _useState7[0], setErrorMessage = _useState7[1];
    console.log("hi");
    (0, $1Mpn7.useEffect)(function() {
        console.log("getting apyemnt link");
        (0, $49995c6694fcc6fd$export$2e2bcd8739ae039).getPaymentLink(paymentLinkId).then(function(data) {
            setPaymentLinkData(data);
            if (data.inputFields) {
                var inputFields = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = data.inputFields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var input = _step.value;
                        inputFields.push((0, $cxjpp._)((0, $do9pw._)({}, input), {
                            value: ""
                        }));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                setInputFields(inputFields);
            }
        }).finally(function() {
            setIsLoading(false);
        });
    }, []);
    if (!paymentLinkData || paymentLinkData.products.length <= 0 || isLoading) return /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $b65f8652b851c11c$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $fd3ee3fc842ae846$export$2e2bcd8739ae039), {
        checkoutData: (0, $cxjpp._)((0, $do9pw._)({}, paymentLinkData), {
            inputFields: inputFields,
            products: paymentLinkData.products.map(function(p) {
                return {
                    product: p,
                    quantity: 1
                };
            })
        }),
        onCheckout: function() {
            var _ref = (0, $kSuI9._)(function(param) {
                var selectedMethod, tokenAmount, orderRes, checkPaymentInterval, err;
                return (0, $eha6O.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            selectedMethod = param.selectedMethod, tokenAmount = param.tokenAmount;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            setErrorMessage(undefined);
                            setIsPreProcessingPayment(true);
                            return [
                                4,
                                (0, $49995c6694fcc6fd$export$2e2bcd8739ae039).createPaymentLinkOrder({
                                    paymentLinkId: paymentLinkId,
                                    paymentMethod: {
                                        managed: {
                                            method: selectedMethod
                                        }
                                    },
                                    orderData: (0, $c6Xmf._)(inputFields.map(function(c) {
                                        return {
                                            key: c.inputLabel,
                                            value: c.value.toString()
                                        };
                                    })).concat([
                                        {
                                            key: "Token amount",
                                            value: tokenAmount
                                        }
                                    ])
                                })
                            ];
                        case 2:
                            orderRes = _state.sent();
                            setOrder(orderRes);
                            setIsPreProcessingPayment(false);
                            if (orderRes.paymentMethodDetails.managed) setManagedPaymentDetails(orderRes.paymentMethodDetails.managed);
                            checkPaymentInterval = setInterval(function() {
                                var _orderRes_paymentMethodDetails_managed;
                                if (!orderRes.paymentMethodDetails.managed) return;
                                (0, $49995c6694fcc6fd$export$2e2bcd8739ae039).getManagedPaymentStatus((_orderRes_paymentMethodDetails_managed = orderRes.paymentMethodDetails.managed) === null || _orderRes_paymentMethodDetails_managed === void 0 ? void 0 : _orderRes_paymentMethodDetails_managed.paymentId).then(function(res) {
                                    setPaymentStatus(res);
                                    if (res.status === "paymentConfirmed") {
                                        var _window;
                                        if ((_window = window) === null || _window === void 0 ? void 0 : _window.parent) window.parent.postMessage({
                                            orderId: orderRes.id,
                                            status: res.status
                                        }, "*");
                                        clearInterval(checkPaymentInterval);
                                    }
                                }).catch(function() {});
                            }, 1000);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            err = _state.sent();
                            setErrorMessage(err.reason || err.message);
                            setIsPreProcessingPayment(false);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        order: order,
        managedPaymentDetails: managedPaymentDetails,
        errorMessage: errorMessage,
        isPreProcessingPayment: isPreProcessingPayment,
        paymentStatus: paymentStatus,
        onInputFieldsChange: setInputFields,
        isSuccess: false,
        successElement: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $78b37e1ff5a5ba28$exports.Fragment), {})
    });
}
var $15bcfd03d6dd4dab$export$2e2bcd8739ae039 = $15bcfd03d6dd4dab$var$PresaleView;


var $6872995eb3c86719$var$queryClient = new (0, $5faee5685a3d0f57$export$405d0624ed55a03f)();
function $6872995eb3c86719$var$App(param) {
    var presaleId = param.presaleId;
    return /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $6de5ee6f9b442f8a$export$a28463dc600bc9f8), {
        config: (0, $7228c3dac31e12e0$export$382a3cc012b91987),
        children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $953e85a5ab939cf5$export$45604f0cc8ae667b), {
            client: $6872995eb3c86719$var$queryClient,
            children: /*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $15bcfd03d6dd4dab$export$2e2bcd8739ae039), {
                paymentLinkId: presaleId
            })
        })
    });
}
var $6872995eb3c86719$export$2e2bcd8739ae039 = $6872995eb3c86719$var$App;


console.info("\n\u2588\u2588\u2588\u2588\u2588\u2588\u2557  \u2588\u2588\u2588\u2588\u2588\u2557 \u2588\u2588\u2588\u2588\u2588\u2588\u2557  \u2588\u2588\u2588\u2588\u2588\u2588\u2557 \u2588\u2588\u2588\u2557   \u2588\u2588\u2588\u2557\n\u2588\u2588\u2554\u2550\u2550\u2588\u2588\u2557\u2588\u2588\u2554\u2550\u2550\u2588\u2588\u2557\u2588\u2588\u2554\u2550\u2550\u2588\u2588\u2557\u2588\u2588\u2554\u2550\u2550\u2550\u2588\u2588\u2557\u2588\u2588\u2588\u2588\u2557 \u2588\u2588\u2588\u2588\u2551\n\u2588\u2588\u2588\u2588\u2588\u2588\u2554\u255D\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2551\u2588\u2588\u2551  \u2588\u2588\u2551\u2588\u2588\u2551   \u2588\u2588\u2551\u2588\u2588\u2554\u2588\u2588\u2588\u2588\u2554\u2588\u2588\u2551\n\u2588\u2588\u2554\u2550\u2550\u2588\u2588\u2557\u2588\u2588\u2554\u2550\u2550\u2588\u2588\u2551\u2588\u2588\u2551  \u2588\u2588\u2551\u2588\u2588\u2551   \u2588\u2588\u2551\u2588\u2588\u2551\u255A\u2588\u2588\u2554\u255D\u2588\u2588\u2551\n\u2588\u2588\u2551  \u2588\u2588\u2551\u2588\u2588\u2551  \u2588\u2588\u2551\u2588\u2588\u2588\u2588\u2588\u2588\u2554\u255D\u255A\u2588\u2588\u2588\u2588\u2588\u2588\u2554\u255D\u2588\u2588\u2551 \u255A\u2550\u255D \u2588\u2588\u2551\n\u255A\u2550\u255D  \u255A\u2550\u255D\u255A\u2550\u255D  \u255A\u2550\u255D\u255A\u2550\u2550\u2550\u2550\u2550\u255D  \u255A\u2550\u2550\u2550\u2550\u2550\u255D \u255A\u2550\u255D     \u255A\u2550\u255D\nWelcome to Radom!\nBuild: ".concat(undefined, "\n"));
window.LoadPresale = function(elementId, presaleId) {
    var root = (0, $26fa11aab20bccf7$export$882461b6382ed46c)(document.getElementById(elementId));
    root.render(/*#__PURE__*/ (0, $78b37e1ff5a5ba28$exports.jsx)((0, $6872995eb3c86719$export$2e2bcd8739ae039), {
        presaleId: presaleId
    }));
} // console.log('fuck')
;

})();
//# sourceMappingURL=index.js.map
